export const settlements =
    {
        "1": {
            "name": "НОРИЛЬСК",
            "population": 176251,
            "type": "city",
            "poly": [
                [
                    87.2750655,
                    69.2892733
                ],
                [
                    87.3276359,
                    69.3936557
                ],
                [
                    87.9565658,
                    69.4374634
                ],
                [
                    88.2778974,
                    69.5873382
                ],
                [
                    88.5461627,
                    69.558813
                ],
                [
                    88.4536808,
                    69.3416974
                ],
                [
                    88.1689009,
                    69.2238835
                ],
                [
                    87.5930163,
                    69.2660357
                ],
                [
                    87.2750655,
                    69.2892733
                ]
            ],
            "longitude": 88.200517,
            "latitude": 69.3498394
        },
        "2": {
            "name": "АЧИНСК",
            "population": 106029,
            "type": "city",
            "poly": [
                [
                    90.35995,
                    56.2232532
                ],
                [
                    90.3877712,
                    56.218836
                ],
                [
                    90.3886986,
                    56.2248978
                ],
                [
                    90.3901968,
                    56.2269089
                ],
                [
                    90.3962627,
                    56.2320073
                ],
                [
                    90.3861408,
                    56.2346882
                ],
                [
                    90.3843137,
                    56.2334493
                ],
                [
                    90.3826693,
                    56.2336118
                ],
                [
                    90.3805499,
                    56.2329212
                ],
                [
                    90.3796364,
                    56.2350741
                ],
                [
                    90.3774805,
                    56.2361098
                ],
                [
                    90.3785036,
                    56.2389529
                ],
                [
                    90.3798556,
                    56.2389732
                ],
                [
                    90.3795999,
                    56.2412476
                ],
                [
                    90.3841675,
                    56.2428314
                ],
                [
                    90.3826104,
                    56.2436645
                ],
                [
                    90.3812987,
                    56.2445212
                ],
                [
                    90.3811711,
                    56.2446912
                ],
                [
                    90.3745005,
                    56.2535786
                ],
                [
                    90.3875941,
                    56.2607807
                ],
                [
                    90.4052153,
                    56.2595185
                ],
                [
                    90.4106965,
                    56.2574279
                ],
                [
                    90.411135,
                    56.2575497
                ],
                [
                    90.4157757,
                    56.2558447
                ],
                [
                    90.4158488,
                    56.2538148
                ],
                [
                    90.4178951,
                    56.2497142
                ],
                [
                    90.418224,
                    56.2473185
                ],
                [
                    90.4231571,
                    56.2460395
                ],
                [
                    90.4262995,
                    56.2446385
                ],
                [
                    90.4334252,
                    56.2465267
                ],
                [
                    90.4366408,
                    56.2437654
                ],
                [
                    90.4395276,
                    56.2440497
                ],
                [
                    90.4449065,
                    56.2477045
                ],
                [
                    90.4449279,
                    56.2479284
                ],
                [
                    90.4450187,
                    56.2488791
                ],
                [
                    90.4373854,
                    56.2515504
                ],
                [
                    90.4426239,
                    56.255531
                ],
                [
                    90.4400047,
                    56.2571314
                ],
                [
                    90.4419179,
                    56.2579542
                ],
                [
                    90.4441396,
                    56.2665657
                ],
                [
                    90.459902,
                    56.2680462
                ],
                [
                    90.4600657,
                    56.269176
                ],
                [
                    90.4568618,
                    56.2692669
                ],
                [
                    90.4443968,
                    56.2713447
                ],
                [
                    90.442713,
                    56.2694487
                ],
                [
                    90.4429702,
                    56.2676306
                ],
                [
                    90.4366325,
                    56.259552
                ],
                [
                    90.4291021,
                    56.2616692
                ],
                [
                    90.4281431,
                    56.2623966
                ],
                [
                    90.4265062,
                    56.2617731
                ],
                [
                    90.4238168,
                    56.2615263
                ],
                [
                    90.4213378,
                    56.2620199
                ],
                [
                    90.4188121,
                    56.263072
                ],
                [
                    90.4181339,
                    56.2644617
                ],
                [
                    90.418087,
                    56.2655397
                ],
                [
                    90.4148364,
                    56.2664878
                ],
                [
                    90.4138308,
                    56.2664488
                ],
                [
                    90.413059,
                    56.2655267
                ],
                [
                    90.4113986,
                    56.2643058
                ],
                [
                    90.4092704,
                    56.2642409
                ],
                [
                    90.4069318,
                    56.2647734
                ],
                [
                    90.4049439,
                    56.2651241
                ],
                [
                    90.4036109,
                    56.2650462
                ],
                [
                    90.4024883,
                    56.2646565
                ],
                [
                    90.4013892,
                    56.2638383
                ],
                [
                    90.4008513,
                    56.2627343
                ],
                [
                    90.3729981,
                    56.2654358
                ],
                [
                    90.3713376,
                    56.2667605
                ],
                [
                    90.3712675,
                    56.2680722
                ],
                [
                    90.3713142,
                    56.2696046
                ],
                [
                    90.3704489,
                    56.270098
                ],
                [
                    90.3688353,
                    56.2703707
                ],
                [
                    90.3670579,
                    56.2700721
                ],
                [
                    90.365491,
                    56.269163
                ],
                [
                    90.364883,
                    56.2687734
                ],
                [
                    90.3639241,
                    56.2689552
                ],
                [
                    90.3640877,
                    56.2708902
                ],
                [
                    90.3635967,
                    56.2717342
                ],
                [
                    90.3637136,
                    56.2728769
                ],
                [
                    90.3621701,
                    56.2746429
                ],
                [
                    90.3612112,
                    56.2752012
                ],
                [
                    90.3617024,
                    56.2764606
                ],
                [
                    90.3615855,
                    56.2772656
                ],
                [
                    90.3629185,
                    56.2782394
                ],
                [
                    90.3628717,
                    56.2789145
                ],
                [
                    90.3658886,
                    56.28007
                ],
                [
                    90.3720392,
                    56.2818615
                ],
                [
                    90.3788213,
                    56.285678
                ],
                [
                    90.3845977,
                    56.28573
                ],
                [
                    90.3868662,
                    56.2849122
                ],
                [
                    90.3878017,
                    56.2834713
                ],
                [
                    90.3875444,
                    56.2812773
                ],
                [
                    90.4150757,
                    56.2802715
                ],
                [
                    90.4162743,
                    56.2789083
                ],
                [
                    90.4184667,
                    56.2791193
                ],
                [
                    90.4232025,
                    56.2787785
                ],
                [
                    90.4278505,
                    56.2767661
                ],
                [
                    90.4293706,
                    56.2754028
                ],
                [
                    90.4297799,
                    56.2737148
                ],
                [
                    90.4301307,
                    56.272887
                ],
                [
                    90.4307738,
                    56.2727409
                ],
                [
                    90.4345741,
                    56.2738446
                ],
                [
                    90.4362696,
                    56.2754028
                ],
                [
                    90.4395145,
                    56.2763766
                ],
                [
                    90.4418239,
                    56.2766038
                ],
                [
                    90.4434025,
                    56.2763928
                ],
                [
                    90.4475828,
                    56.2754515
                ],
                [
                    90.4493953,
                    56.2767661
                ],
                [
                    90.4474074,
                    56.2784377
                ],
                [
                    90.4474367,
                    56.2792816
                ],
                [
                    90.4479233,
                    56.2796727
                ],
                [
                    90.4497047,
                    56.2807123
                ],
                [
                    90.4513034,
                    56.2826901
                ],
                [
                    90.452628,
                    56.2831211
                ],
                [
                    90.4516687,
                    56.2861382
                ],
                [
                    90.4490652,
                    56.2888762
                ],
                [
                    90.4370066,
                    56.290676
                ],
                [
                    90.4328044,
                    56.2917407
                ],
                [
                    90.4339832,
                    56.2935303
                ],
                [
                    90.4336277,
                    56.2947866
                ],
                [
                    90.4541976,
                    56.2945325
                ],
                [
                    90.4615972,
                    56.2960786
                ],
                [
                    90.468129,
                    56.2978782
                ],
                [
                    90.4699561,
                    56.3004633
                ],
                [
                    90.4726053,
                    56.3018571
                ],
                [
                    90.4713121,
                    56.3021758
                ],
                [
                    90.4718032,
                    56.3027727
                ],
                [
                    90.4698154,
                    56.304654
                ],
                [
                    90.4714992,
                    56.3081958
                ],
                [
                    90.4748434,
                    56.3081698
                ],
                [
                    90.4794506,
                    56.3044983
                ],
                [
                    90.4831923,
                    56.3049264
                ],
                [
                    90.4813916,
                    56.3091168
                ],
                [
                    90.4739548,
                    56.3106735
                ],
                [
                    90.4744693,
                    56.3114519
                ],
                [
                    90.4713823,
                    56.3159788
                ],
                [
                    90.4660005,
                    56.3173817
                ],
                [
                    90.4647672,
                    56.3183443
                ],
                [
                    90.4613415,
                    56.3217132
                ],
                [
                    90.4567281,
                    56.3260949
                ],
                [
                    90.45787,
                    56.3298429
                ],
                [
                    90.4605193,
                    56.332046
                ],
                [
                    90.4637623,
                    56.333616
                ],
                [
                    90.4681016,
                    56.3284754
                ],
                [
                    90.4720755,
                    56.3283741
                ],
                [
                    90.4716186,
                    56.3243473
                ],
                [
                    90.4803886,
                    56.3223211
                ],
                [
                    90.4924929,
                    56.3208013
                ],
                [
                    90.4955989,
                    56.3141644
                ],
                [
                    90.4971519,
                    56.312467
                ],
                [
                    90.504917,
                    56.313379
                ],
                [
                    90.5071094,
                    56.3130243
                ],
                [
                    90.5047799,
                    56.309376
                ],
                [
                    90.5082513,
                    56.3100347
                ],
                [
                    90.5086168,
                    56.3095027
                ],
                [
                    90.5094389,
                    56.30968
                ],
                [
                    90.5111746,
                    56.307425
                ],
                [
                    90.5124079,
                    56.3058033
                ],
                [
                    90.5151485,
                    56.3057526
                ],
                [
                    90.5158793,
                    56.3062594
                ],
                [
                    90.517615,
                    56.3062087
                ],
                [
                    90.5186199,
                    56.3058286
                ],
                [
                    90.5191681,
                    56.306158
                ],
                [
                    90.5204806,
                    56.306227
                ],
                [
                    90.5201626,
                    56.3067356
                ],
                [
                    90.5210794,
                    56.3068186
                ],
                [
                    90.5213413,
                    56.3072234
                ],
                [
                    90.5223515,
                    56.3074413
                ],
                [
                    90.5219587,
                    56.3077838
                ],
                [
                    90.5221458,
                    56.3081575
                ],
                [
                    90.5225761,
                    56.3081056
                ],
                [
                    90.5230251,
                    56.3076697
                ],
                [
                    90.5237548,
                    56.3074828
                ],
                [
                    90.5242224,
                    56.307898
                ],
                [
                    90.5249896,
                    56.3080018
                ],
                [
                    90.5255509,
                    56.3084169
                ],
                [
                    90.526636,
                    56.3086141
                ],
                [
                    90.527534,
                    56.3092057
                ],
                [
                    90.5281514,
                    56.3089358
                ],
                [
                    90.528694,
                    56.3093925
                ],
                [
                    90.5294049,
                    56.3096831
                ],
                [
                    90.5293675,
                    56.3090707
                ],
                [
                    90.5306397,
                    56.3092576
                ],
                [
                    90.5313132,
                    56.3093198
                ],
                [
                    90.5319307,
                    56.3097868
                ],
                [
                    90.5329035,
                    56.3096831
                ],
                [
                    90.5335958,
                    56.3097246
                ],
                [
                    90.5351112,
                    56.3101708
                ],
                [
                    90.5362899,
                    56.3103057
                ],
                [
                    90.5365896,
                    56.3106012
                ],
                [
                    90.5370012,
                    56.3106064
                ],
                [
                    90.5372483,
                    56.3106095
                ],
                [
                    90.5381613,
                    56.3105265
                ],
                [
                    90.5385953,
                    56.3108419
                ],
                [
                    90.5391192,
                    56.3102691
                ],
                [
                    90.5403615,
                    56.3103438
                ],
                [
                    90.5412445,
                    56.3103272
                ],
                [
                    90.5417534,
                    56.3101196
                ],
                [
                    90.5420827,
                    56.3097128
                ],
                [
                    90.5447619,
                    56.3098706
                ],
                [
                    90.5453606,
                    56.3075375
                ],
                [
                    90.549282,
                    56.3074213
                ],
                [
                    90.549267,
                    56.3061094
                ],
                [
                    90.548384,
                    56.305852
                ],
                [
                    90.5458694,
                    56.3056278
                ],
                [
                    90.543306,
                    56.27599
                ],
                [
                    90.5535287,
                    56.2757158
                ],
                [
                    90.5634782,
                    56.273121
                ],
                [
                    90.5634921,
                    56.2724397
                ],
                [
                    90.5634969,
                    56.2722068
                ],
                [
                    90.5977479,
                    56.2711919
                ],
                [
                    90.5977479,
                    56.2694362
                ],
                [
                    90.589834,
                    56.2687713
                ],
                [
                    90.5897404,
                    56.2681999
                ],
                [
                    90.5886927,
                    56.2681999
                ],
                [
                    90.5883372,
                    56.2685324
                ],
                [
                    90.5747544,
                    56.2678986
                ],
                [
                    90.574586,
                    56.2676389
                ],
                [
                    90.5736319,
                    56.2676493
                ],
                [
                    90.5734073,
                    56.2679506
                ],
                [
                    90.5594129,
                    56.2678571
                ],
                [
                    90.55902,
                    56.2674103
                ],
                [
                    90.5558582,
                    56.2672856
                ],
                [
                    90.5552033,
                    56.2657064
                ],
                [
                    90.5549975,
                    56.2645323
                ],
                [
                    90.5551098,
                    56.2638777
                ],
                [
                    90.5590949,
                    56.2635972
                ],
                [
                    90.5602548,
                    56.2622048
                ],
                [
                    90.5592257,
                    56.260376
                ],
                [
                    90.5591323,
                    56.2591601
                ],
                [
                    90.5600677,
                    56.2582872
                ],
                [
                    90.5519292,
                    56.2563751
                ],
                [
                    90.5478319,
                    56.2577884
                ],
                [
                    90.5453998,
                    56.2582457
                ],
                [
                    90.5432481,
                    56.2577365
                ],
                [
                    90.5413399,
                    56.2543589
                ],
                [
                    90.5411715,
                    56.2529973
                ],
                [
                    90.5416954,
                    56.2515111
                ],
                [
                    90.5416204,
                    56.2501183
                ],
                [
                    90.5410592,
                    56.2478938
                ],
                [
                    90.5400677,
                    56.2477275
                ],
                [
                    90.5393506,
                    56.2453441
                ],
                [
                    90.5390199,
                    56.2442451
                ],
                [
                    90.5397495,
                    56.2424985
                ],
                [
                    90.5394357,
                    56.2396466
                ],
                [
                    90.538889,
                    56.2346797
                ],
                [
                    90.5289357,
                    56.2335879
                ],
                [
                    90.5287486,
                    56.232808
                ],
                [
                    90.5247449,
                    56.2333071
                ],
                [
                    90.5199795,
                    56.2327709
                ],
                [
                    90.5146736,
                    56.2321739
                ],
                [
                    90.5140245,
                    56.2321009
                ],
                [
                    90.5092724,
                    56.2275666
                ],
                [
                    90.5096653,
                    56.2207017
                ],
                [
                    90.5053248,
                    56.21859
                ],
                [
                    90.5030048,
                    56.2184756
                ],
                [
                    90.503061,
                    56.2177162
                ],
                [
                    90.501321,
                    56.2176122
                ],
                [
                    90.5014333,
                    56.2140349
                ],
                [
                    90.4958219,
                    56.2123077
                ],
                [
                    90.4972105,
                    56.2096861
                ],
                [
                    90.5041899,
                    56.2078774
                ],
                [
                    90.5027304,
                    56.2074009
                ],
                [
                    90.5022393,
                    56.207544
                ],
                [
                    90.4996434,
                    56.2064774
                ],
                [
                    90.4971644,
                    56.2040579
                ],
                [
                    90.4966967,
                    56.202627
                ],
                [
                    90.4781256,
                    56.2064728
                ],
                [
                    90.4772633,
                    56.2066423
                ],
                [
                    90.4744004,
                    56.2077865
                ],
                [
                    90.4733478,
                    56.2077418
                ],
                [
                    90.4730781,
                    56.2078068
                ],
                [
                    90.4694749,
                    56.2086756
                ],
                [
                    90.4678846,
                    56.2088577
                ],
                [
                    90.4631713,
                    56.2102427
                ],
                [
                    90.4619381,
                    56.2106051
                ],
                [
                    90.4611994,
                    56.2108222
                ],
                [
                    90.4607884,
                    56.2038612
                ],
                [
                    90.4578194,
                    56.2038104
                ],
                [
                    90.4569515,
                    56.2048013
                ],
                [
                    90.45348,
                    56.2048775
                ],
                [
                    90.4533887,
                    56.211254
                ],
                [
                    90.4499173,
                    56.2117621
                ],
                [
                    90.44841,
                    56.2117367
                ],
                [
                    90.446994,
                    56.2120923
                ],
                [
                    90.4461718,
                    56.2127527
                ],
                [
                    90.4444818,
                    56.2131083
                ],
                [
                    90.4427918,
                    56.2136417
                ],
                [
                    90.4386351,
                    56.2146324
                ],
                [
                    90.4350724,
                    56.214988
                ],
                [
                    90.4343873,
                    56.2156229
                ],
                [
                    90.4333824,
                    56.2159785
                ],
                [
                    90.4321948,
                    56.2166643
                ],
                [
                    90.430459,
                    56.2180612
                ],
                [
                    90.4274444,
                    56.2199406
                ],
                [
                    90.4263482,
                    56.2209564
                ],
                [
                    90.4236533,
                    56.2220992
                ],
                [
                    90.4219176,
                    56.2226833
                ],
                [
                    90.4203189,
                    56.2226579
                ],
                [
                    90.4202275,
                    56.2220738
                ],
                [
                    90.4197708,
                    56.2218199
                ],
                [
                    90.4192905,
                    56.2217986
                ],
                [
                    90.4189981,
                    56.221181
                ],
                [
                    90.4185012,
                    56.2208722
                ],
                [
                    90.4184135,
                    56.2199782
                ],
                [
                    90.4170395,
                    56.2199945
                ],
                [
                    90.4165718,
                    56.2197832
                ],
                [
                    90.4154901,
                    56.2194419
                ],
                [
                    90.4148178,
                    56.2185967
                ],
                [
                    90.4144962,
                    56.2182878
                ],
                [
                    90.4127715,
                    56.2180928
                ],
                [
                    90.4121868,
                    56.2176701
                ],
                [
                    90.4121868,
                    56.21728
                ],
                [
                    90.4113391,
                    56.217085
                ],
                [
                    90.4105206,
                    56.2166948
                ],
                [
                    90.4113391,
                    56.2164673
                ],
                [
                    90.4107252,
                    56.2160446
                ],
                [
                    90.410199,
                    56.215622
                ],
                [
                    90.4094974,
                    56.2152806
                ],
                [
                    90.4090297,
                    56.2138501
                ],
                [
                    90.4097313,
                    56.2124358
                ],
                [
                    90.4090004,
                    56.2121269
                ],
                [
                    90.4072451,
                    56.2110169
                ],
                [
                    90.4063316,
                    56.2106105
                ],
                [
                    90.4060027,
                    56.2101431
                ],
                [
                    90.4044314,
                    56.2090457
                ],
                [
                    90.4038833,
                    56.2079076
                ],
                [
                    90.4021293,
                    56.2071556
                ],
                [
                    90.4010696,
                    56.2067897
                ],
                [
                    90.4004849,
                    56.2066475
                ],
                [
                    90.3997246,
                    56.2058846
                ],
                [
                    90.3982046,
                    56.2056374
                ],
                [
                    90.397386,
                    56.2052992
                ],
                [
                    90.3967312,
                    56.204987
                ],
                [
                    90.3956788,
                    56.2048569
                ],
                [
                    90.395445,
                    56.2045057
                ],
                [
                    90.3949772,
                    56.2040894
                ],
                [
                    90.393387,
                    56.2030357
                ],
                [
                    90.3918668,
                    56.2026195
                ],
                [
                    90.391768,
                    56.2027359
                ],
                [
                    90.3893411,
                    56.2055984
                ],
                [
                    90.3900193,
                    56.2053252
                ],
                [
                    90.3920072,
                    56.2057545
                ],
                [
                    90.393691,
                    56.2061447
                ],
                [
                    90.3962869,
                    56.2072764
                ],
                [
                    90.3975965,
                    56.2080178
                ],
                [
                    90.3980641,
                    56.2095396
                ],
                [
                    90.399561,
                    56.2102809
                ],
                [
                    90.3997948,
                    56.2124529
                ],
                [
                    90.4018295,
                    56.2139485
                ],
                [
                    90.4015923,
                    56.2149595
                ],
                [
                    90.4015488,
                    56.215145
                ],
                [
                    90.3954216,
                    56.2170696
                ],
                [
                    90.3913523,
                    56.2176938
                ],
                [
                    90.3893411,
                    56.2178108
                ],
                [
                    90.3888032,
                    56.2173167
                ],
                [
                    90.3869791,
                    56.2176808
                ],
                [
                    90.3876678,
                    56.2184742
                ],
                [
                    90.3741627,
                    56.2200574
                ],
                [
                    90.35995,
                    56.2232532
                ]
            ],
            "longitude": 90.4953964,
            "latitude": 56.2694846
        },
        "3": {
            "name": "КРАСНОЯРСК",
            "population": 1052218,
            "type": "city",
            "poly": [
                [
                    92.627132,
                    55.969635
                ],
                [
                    92.62953,
                    55.971194
                ],
                [
                    92.628991,
                    55.971674
                ],
                [
                    92.631089,
                    55.971854
                ],
                [
                    92.62965,
                    55.972513
                ],
                [
                    92.631149,
                    55.973413
                ],
                [
                    92.640024,
                    55.974672
                ],
                [
                    92.643681,
                    55.974852
                ],
                [
                    92.64554,
                    55.974672
                ],
                [
                    92.653215,
                    55.976051
                ],
                [
                    92.655734,
                    55.979049
                ],
                [
                    92.660051,
                    55.979049
                ],
                [
                    92.659151,
                    55.979949
                ],
                [
                    92.659271,
                    55.981388
                ],
                [
                    92.654594,
                    55.982227
                ],
                [
                    92.652376,
                    55.984686
                ],
                [
                    92.652496,
                    55.987204
                ],
                [
                    92.655793,
                    55.999286
                ],
                [
                    92.654474,
                    56.000725
                ],
                [
                    92.654354,
                    56.002464
                ],
                [
                    92.655314,
                    56.004083
                ],
                [
                    92.656513,
                    56.004983
                ],
                [
                    92.656333,
                    56.006842
                ],
                [
                    92.657053,
                    56.00846
                ],
                [
                    92.657053,
                    56.012358
                ],
                [
                    92.657412,
                    56.013257
                ],
                [
                    92.655254,
                    56.017275
                ],
                [
                    92.652795,
                    56.019254
                ],
                [
                    92.654834,
                    56.019553
                ],
                [
                    92.656033,
                    56.018654
                ],
                [
                    92.656753,
                    56.021112
                ],
                [
                    92.657832,
                    56.021772
                ],
                [
                    92.655793,
                    56.022132
                ],
                [
                    92.655194,
                    56.021712
                ],
                [
                    92.651236,
                    56.021772
                ],
                [
                    92.650157,
                    56.024051
                ],
                [
                    92.648358,
                    56.024171
                ],
                [
                    92.648358,
                    56.02549
                ],
                [
                    92.655194,
                    56.02543
                ],
                [
                    92.659391,
                    56.030736
                ],
                [
                    92.653095,
                    56.034334
                ],
                [
                    92.652616,
                    56.036073
                ],
                [
                    92.655374,
                    56.036073
                ],
                [
                    92.658072,
                    56.037422
                ],
                [
                    92.66053,
                    56.039041
                ],
                [
                    92.662359,
                    56.039881
                ],
                [
                    92.668535,
                    56.04126
                ],
                [
                    92.671474,
                    56.043358
                ],
                [
                    92.674442,
                    56.044258
                ],
                [
                    92.678819,
                    56.045037
                ],
                [
                    92.682596,
                    56.047376
                ],
                [
                    92.684845,
                    56.048395
                ],
                [
                    92.697827,
                    56.051243
                ],
                [
                    92.698187,
                    56.052503
                ],
                [
                    92.695368,
                    56.05634
                ],
                [
                    92.697977,
                    56.057
                ],
                [
                    92.712517,
                    56.060477
                ],
                [
                    92.714916,
                    56.060417
                ],
                [
                    92.714916,
                    56.061077
                ],
                [
                    92.716835,
                    56.062096
                ],
                [
                    92.718394,
                    56.061497
                ],
                [
                    92.718214,
                    56.062036
                ],
                [
                    92.724,
                    56.063506
                ],
                [
                    92.7249,
                    56.063266
                ],
                [
                    92.727958,
                    56.063925
                ],
                [
                    92.729097,
                    56.063625
                ],
                [
                    92.732755,
                    56.067403
                ],
                [
                    92.731136,
                    56.068243
                ],
                [
                    92.728557,
                    56.068302
                ],
                [
                    92.731256,
                    56.068542
                ],
                [
                    92.735033,
                    56.069562
                ],
                [
                    92.735033,
                    56.070401
                ],
                [
                    92.736112,
                    56.070761
                ],
                [
                    92.737252,
                    56.067463
                ],
                [
                    92.738391,
                    56.066684
                ],
                [
                    92.738271,
                    56.064885
                ],
                [
                    92.735033,
                    56.062966
                ],
                [
                    92.733834,
                    56.062486
                ],
                [
                    92.732994,
                    56.061827
                ],
                [
                    92.733534,
                    56.060867
                ],
                [
                    92.733054,
                    56.058709
                ],
                [
                    92.734613,
                    56.058109
                ],
                [
                    92.738811,
                    56.059068
                ],
                [
                    92.750443,
                    56.055531
                ],
                [
                    92.749964,
                    56.054691
                ],
                [
                    92.750683,
                    56.054631
                ],
                [
                    92.761326,
                    56.067523
                ],
                [
                    92.761746,
                    56.068842
                ],
                [
                    92.761386,
                    56.069502
                ],
                [
                    92.77188,
                    56.069622
                ],
                [
                    92.772269,
                    56.069322
                ],
                [
                    92.780964,
                    56.069262
                ],
                [
                    92.780724,
                    56.070101
                ],
                [
                    92.780544,
                    56.071181
                ],
                [
                    92.779405,
                    56.073159
                ],
                [
                    92.782103,
                    56.073219
                ],
                [
                    92.7858056,
                    56.0713248
                ],
                [
                    92.794755,
                    56.059248
                ],
                [
                    92.797693,
                    56.057809
                ],
                [
                    92.797334,
                    56.054391
                ],
                [
                    92.8027958,
                    56.0482521
                ],
                [
                    92.8036849,
                    56.0472527
                ],
                [
                    92.804109,
                    56.046776
                ],
                [
                    92.808516,
                    56.047855
                ],
                [
                    92.8234155,
                    56.0502368
                ],
                [
                    92.832621,
                    56.050854
                ],
                [
                    92.83364,
                    56.049474
                ],
                [
                    92.833101,
                    56.048935
                ],
                [
                    92.83412,
                    56.048395
                ],
                [
                    92.835302,
                    56.0484524
                ],
                [
                    92.8354951,
                    56.0474044
                ],
                [
                    92.8357376,
                    56.0466404
                ],
                [
                    92.837915,
                    56.0423344
                ],
                [
                    92.8380379,
                    56.0420576
                ],
                [
                    92.8381055,
                    56.0416117
                ],
                [
                    92.8393736,
                    56.0423488
                ],
                [
                    92.8411926,
                    56.0427624
                ],
                [
                    92.8426239,
                    56.0438359
                ],
                [
                    92.8445218,
                    56.044692
                ],
                [
                    92.8464445,
                    56.0466749
                ],
                [
                    92.846562,
                    56.047496
                ],
                [
                    92.848121,
                    56.047915
                ],
                [
                    92.849081,
                    56.049534
                ],
                [
                    92.848001,
                    56.050014
                ],
                [
                    92.846023,
                    56.049834
                ],
                [
                    92.845603,
                    56.050674
                ],
                [
                    92.846203,
                    56.051213
                ],
                [
                    92.847881,
                    56.051213
                ],
                [
                    92.85013,
                    56.052293
                ],
                [
                    92.85019,
                    56.053012
                ],
                [
                    92.84941,
                    56.054032
                ],
                [
                    92.8499909,
                    56.0550892
                ],
                [
                    92.8523727,
                    56.0549855
                ],
                [
                    92.8552888,
                    56.0552851
                ],
                [
                    92.8581196,
                    56.0558075
                ],
                [
                    92.8630956,
                    56.0572947
                ],
                [
                    92.8713177,
                    56.0597642
                ],
                [
                    92.869498,
                    56.064825
                ],
                [
                    92.870996,
                    56.0652334
                ],
                [
                    92.8710433,
                    56.0665983
                ],
                [
                    92.869018,
                    56.070521
                ],
                [
                    92.8683123,
                    56.0766627
                ],
                [
                    92.868119,
                    56.078346
                ],
                [
                    92.869798,
                    56.079305
                ],
                [
                    92.869917,
                    56.080205
                ],
                [
                    92.869018,
                    56.082723
                ],
                [
                    92.870517,
                    56.083503
                ],
                [
                    92.870517,
                    56.084282
                ],
                [
                    92.871596,
                    56.084582
                ],
                [
                    92.877413,
                    56.084582
                ],
                [
                    92.894802,
                    56.090279
                ],
                [
                    92.89708,
                    56.090578
                ],
                [
                    92.896301,
                    56.091238
                ],
                [
                    92.894082,
                    56.096994
                ],
                [
                    92.889705,
                    56.102391
                ],
                [
                    92.889105,
                    56.108027
                ],
                [
                    92.892343,
                    56.114173
                ],
                [
                    92.895341,
                    56.116752
                ],
                [
                    92.896121,
                    56.11867
                ],
                [
                    92.899599,
                    56.11897
                ],
                [
                    92.903196,
                    56.120589
                ],
                [
                    92.902477,
                    56.117951
                ],
                [
                    92.908923,
                    56.114893
                ],
                [
                    92.908803,
                    56.114233
                ],
                [
                    92.912221,
                    56.117052
                ],
                [
                    92.910901,
                    56.120949
                ],
                [
                    92.917287,
                    56.122148
                ],
                [
                    92.918487,
                    56.121069
                ],
                [
                    92.919386,
                    56.121549
                ],
                [
                    92.918367,
                    56.122448
                ],
                [
                    92.924813,
                    56.122478
                ],
                [
                    92.925232,
                    56.122238
                ],
                [
                    92.926492,
                    56.122718
                ],
                [
                    92.927931,
                    56.121579
                ],
                [
                    92.930209,
                    56.122418
                ],
                [
                    92.933807,
                    56.122358
                ],
                [
                    92.948018,
                    56.1196
                ],
                [
                    92.94418,
                    56.115283
                ],
                [
                    92.941602,
                    56.113664
                ],
                [
                    92.934466,
                    56.110905
                ],
                [
                    92.92865,
                    56.108987
                ],
                [
                    92.926072,
                    56.107667
                ],
                [
                    92.925292,
                    56.10419
                ],
                [
                    92.92961,
                    56.102511
                ],
                [
                    92.9340614,
                    56.1017312
                ],
                [
                    92.937824,
                    56.101072
                ],
                [
                    92.946279,
                    56.10377
                ],
                [
                    92.947658,
                    56.099513
                ],
                [
                    92.950236,
                    56.098613
                ],
                [
                    92.951975,
                    56.097714
                ],
                [
                    92.952635,
                    56.096694
                ],
                [
                    92.955033,
                    56.095975
                ],
                [
                    92.956592,
                    56.093996
                ],
                [
                    92.961179,
                    56.093696
                ],
                [
                    92.961419,
                    56.094056
                ],
                [
                    92.968795,
                    56.094176
                ],
                [
                    92.969604,
                    56.093936
                ],
                [
                    92.966606,
                    56.091838
                ],
                [
                    92.965467,
                    56.092017
                ],
                [
                    92.962049,
                    56.090818
                ],
                [
                    92.953354,
                    56.08836
                ],
                [
                    92.952095,
                    56.08737
                ],
                [
                    92.952095,
                    56.085631
                ],
                [
                    92.968285,
                    56.090668
                ],
                [
                    92.968885,
                    56.091388
                ],
                [
                    92.97584,
                    56.094446
                ],
                [
                    92.97662,
                    56.094386
                ],
                [
                    92.989002,
                    56.100262
                ],
                [
                    92.988642,
                    56.101222
                ],
                [
                    92.990741,
                    56.102061
                ],
                [
                    92.99161,
                    56.102121
                ],
                [
                    92.99179,
                    56.10404
                ],
                [
                    92.992809,
                    56.10446
                ],
                [
                    92.993049,
                    56.105479
                ],
                [
                    92.994608,
                    56.107757
                ],
                [
                    92.994488,
                    56.115253
                ],
                [
                    92.99137,
                    56.117831
                ],
                [
                    92.989152,
                    56.118311
                ],
                [
                    92.985674,
                    56.12005
                ],
                [
                    92.980517,
                    56.121788
                ],
                [
                    92.976919,
                    56.121848
                ],
                [
                    92.970863,
                    56.120889
                ],
                [
                    92.967925,
                    56.124337
                ],
                [
                    92.964747,
                    56.129434
                ],
                [
                    92.963248,
                    56.134051
                ],
                [
                    92.985314,
                    56.132911
                ],
                [
                    92.985734,
                    56.132672
                ],
                [
                    92.991011,
                    56.132432
                ],
                [
                    92.992689,
                    56.130153
                ],
                [
                    92.99197,
                    56.128714
                ],
                [
                    92.996107,
                    56.126975
                ],
                [
                    92.996647,
                    56.126016
                ],
                [
                    92.996467,
                    56.122958
                ],
                [
                    93.000724,
                    56.12014
                ],
                [
                    93.000844,
                    56.118041
                ],
                [
                    92.999345,
                    56.117261
                ],
                [
                    92.999465,
                    56.116902
                ],
                [
                    93.002673,
                    56.116482
                ],
                [
                    93.004292,
                    56.115582
                ],
                [
                    93.004112,
                    56.114383
                ],
                [
                    93.003213,
                    56.113784
                ],
                [
                    93.006151,
                    56.113064
                ],
                [
                    93.00699,
                    56.112165
                ],
                [
                    93.011937,
                    56.114023
                ],
                [
                    93.014576,
                    56.113904
                ],
                [
                    93.017993,
                    56.116782
                ],
                [
                    93.027437,
                    56.115522
                ],
                [
                    93.027377,
                    56.114623
                ],
                [
                    93.071569,
                    56.109107
                ],
                [
                    93.073428,
                    56.110006
                ],
                [
                    93.080414,
                    56.112464
                ],
                [
                    93.083532,
                    56.114503
                ],
                [
                    93.085331,
                    56.116242
                ],
                [
                    93.089558,
                    56.114983
                ],
                [
                    93.094235,
                    56.118341
                ],
                [
                    93.097173,
                    56.116662
                ],
                [
                    93.113123,
                    56.121938
                ],
                [
                    93.119839,
                    56.114443
                ],
                [
                    93.119839,
                    56.112764
                ],
                [
                    93.11714,
                    56.105329
                ],
                [
                    93.11756,
                    56.10323
                ],
                [
                    93.148171,
                    56.106828
                ],
                [
                    93.150509,
                    56.107907
                ],
                [
                    93.153747,
                    56.108327
                ],
                [
                    93.14973,
                    56.11912
                ],
                [
                    93.154317,
                    56.117441
                ],
                [
                    93.166639,
                    56.109646
                ],
                [
                    93.169397,
                    56.105329
                ],
                [
                    93.171676,
                    56.100172
                ],
                [
                    93.170177,
                    56.096874
                ],
                [
                    93.154587,
                    56.106468
                ],
                [
                    93.11855,
                    56.101851
                ],
                [
                    93.132641,
                    56.094386
                ],
                [
                    93.137857,
                    56.092347
                ],
                [
                    93.156535,
                    56.080445
                ],
                [
                    93.154796,
                    56.079305
                ],
                [
                    93.114622,
                    56.100712
                ],
                [
                    93.113003,
                    56.099633
                ],
                [
                    93.108206,
                    56.097834
                ],
                [
                    93.104099,
                    56.096694
                ],
                [
                    93.098522,
                    56.095795
                ],
                [
                    93.093965,
                    56.095555
                ],
                [
                    93.092226,
                    56.095075
                ],
                [
                    93.091387,
                    56.092737
                ],
                [
                    93.093126,
                    56.088839
                ],
                [
                    93.091507,
                    56.086921
                ],
                [
                    93.085391,
                    56.085601
                ],
                [
                    93.089048,
                    56.084702
                ],
                [
                    93.092766,
                    56.079545
                ],
                [
                    93.096064,
                    56.078106
                ],
                [
                    93.090008,
                    56.074089
                ],
                [
                    93.08563,
                    56.075708
                ],
                [
                    93.078915,
                    56.078226
                ],
                [
                    93.07073,
                    56.079905
                ],
                [
                    93.058288,
                    56.080445
                ],
                [
                    93.0364362,
                    56.0728622
                ],
                [
                    93.032444,
                    56.074898
                ],
                [
                    93.030465,
                    56.074958
                ],
                [
                    93.026388,
                    56.073159
                ],
                [
                    93.02348,
                    56.07274
                ],
                [
                    93.020302,
                    56.070761
                ],
                [
                    93.018383,
                    56.069861
                ],
                [
                    93.018323,
                    56.068842
                ],
                [
                    93.020302,
                    56.068782
                ],
                [
                    93.021141,
                    56.068482
                ],
                [
                    93.018323,
                    56.066384
                ],
                [
                    93.016704,
                    56.066983
                ],
                [
                    93.014785,
                    56.066743
                ],
                [
                    93.017903,
                    56.065964
                ],
                [
                    93.021501,
                    56.065964
                ],
                [
                    93.022521,
                    56.066264
                ],
                [
                    93.022101,
                    56.065005
                ],
                [
                    93.02318,
                    56.063506
                ],
                [
                    93.025399,
                    56.062906
                ],
                [
                    93.027078,
                    56.062606
                ],
                [
                    93.027377,
                    56.061287
                ],
                [
                    93.026058,
                    56.060208
                ],
                [
                    93.02396,
                    56.060028
                ],
                [
                    93.02288,
                    56.059248
                ],
                [
                    93.038171,
                    56.058289
                ],
                [
                    93.041828,
                    56.060148
                ],
                [
                    93.042368,
                    56.064345
                ],
                [
                    93.047045,
                    56.064165
                ],
                [
                    93.048124,
                    56.063685
                ],
                [
                    93.058348,
                    56.063386
                ],
                [
                    93.057508,
                    56.059968
                ],
                [
                    93.064284,
                    56.053012
                ],
                [
                    93.073968,
                    56.051483
                ],
                [
                    93.078405,
                    56.053522
                ],
                [
                    93.081493,
                    56.052203
                ],
                [
                    93.08641,
                    56.049384
                ],
                [
                    93.085091,
                    56.046087
                ],
                [
                    93.078855,
                    56.043268
                ],
                [
                    93.072739,
                    56.037962
                ],
                [
                    93.063924,
                    56.034244
                ],
                [
                    93.065303,
                    56.033225
                ],
                [
                    93.064704,
                    56.032085
                ],
                [
                    93.066862,
                    56.030347
                ],
                [
                    93.074298,
                    56.036763
                ],
                [
                    93.077955,
                    56.038202
                ],
                [
                    93.079394,
                    56.037242
                ],
                [
                    93.084251,
                    56.038501
                ],
                [
                    93.094715,
                    56.037902
                ],
                [
                    93.094655,
                    56.034124
                ],
                [
                    93.092616,
                    56.034124
                ],
                [
                    93.092676,
                    56.029867
                ],
                [
                    93.090577,
                    56.027319
                ],
                [
                    93.0906232,
                    56.0258872
                ],
                [
                    93.090637,
                    56.02546
                ],
                [
                    93.088958,
                    56.026059
                ],
                [
                    93.08662,
                    56.02552
                ],
                [
                    93.083442,
                    56.026119
                ],
                [
                    93.083502,
                    56.023781
                ],
                [
                    93.0910987,
                    56.0238531
                ],
                [
                    93.096154,
                    56.023901
                ],
                [
                    93.112104,
                    56.021802
                ],
                [
                    93.113483,
                    56.020483
                ],
                [
                    93.1113422,
                    56.0193738
                ],
                [
                    93.1087359,
                    56.0143865
                ],
                [
                    93.1072637,
                    56.0144432
                ],
                [
                    93.094475,
                    56.014936
                ],
                [
                    93.090637,
                    56.016495
                ],
                [
                    93.08686,
                    56.017095
                ],
                [
                    93.08584,
                    56.018054
                ],
                [
                    93.081733,
                    56.019014
                ],
                [
                    93.069171,
                    56.018294
                ],
                [
                    93.065513,
                    56.017095
                ],
                [
                    93.064074,
                    56.008401
                ],
                [
                    93.066593,
                    56.008161
                ],
                [
                    93.065093,
                    56.000396
                ],
                [
                    93.061975,
                    56.000216
                ],
                [
                    93.061556,
                    55.996738
                ],
                [
                    93.060536,
                    55.995479
                ],
                [
                    93.059787,
                    55.991431
                ],
                [
                    93.057868,
                    55.987774
                ],
                [
                    93.056309,
                    55.982077
                ],
                [
                    93.05427,
                    55.978929
                ],
                [
                    93.052052,
                    55.97845
                ],
                [
                    93.051272,
                    55.97797
                ],
                [
                    93.046325,
                    55.97773
                ],
                [
                    93.046505,
                    55.979409
                ],
                [
                    93.0377847,
                    55.9818543
                ],
                [
                    93.034363,
                    55.972813
                ],
                [
                    93.020092,
                    55.974552
                ],
                [
                    93.016794,
                    55.975212
                ],
                [
                    93.012597,
                    55.976231
                ],
                [
                    93.00801,
                    55.971404
                ],
                [
                    93.006031,
                    55.969785
                ],
                [
                    93.005251,
                    55.969785
                ],
                [
                    93.000514,
                    55.965048
                ],
                [
                    92.999015,
                    55.963069
                ],
                [
                    92.999015,
                    55.96199
                ],
                [
                    92.997277,
                    55.961091
                ],
                [
                    92.996677,
                    55.959771
                ],
                [
                    92.992989,
                    55.958482
                ],
                [
                    92.99155,
                    55.957343
                ],
                [
                    92.988972,
                    55.956803
                ],
                [
                    92.987053,
                    55.952426
                ],
                [
                    92.978568,
                    55.9529996
                ],
                [
                    92.9708983,
                    55.953518
                ],
                [
                    92.9711581,
                    55.9498699
                ],
                [
                    92.971403,
                    55.947449
                ],
                [
                    92.966366,
                    55.94649
                ],
                [
                    92.9385247,
                    55.9475387
                ],
                [
                    92.920705,
                    55.948199
                ],
                [
                    92.91249,
                    55.952096
                ],
                [
                    92.9116121,
                    55.9516727
                ],
                [
                    92.910811,
                    55.951257
                ],
                [
                    92.909492,
                    55.951737
                ],
                [
                    92.900708,
                    55.951257
                ],
                [
                    92.89795,
                    55.950118
                ],
                [
                    92.89813,
                    55.948738
                ],
                [
                    92.887696,
                    55.913331
                ],
                [
                    92.8864937,
                    55.9123643
                ],
                [
                    92.8858422,
                    55.9118405
                ],
                [
                    92.8802569,
                    55.9122372
                ],
                [
                    92.8711921,
                    55.9170142
                ],
                [
                    92.8708475,
                    55.9177683
                ],
                [
                    92.8714182,
                    55.9194237
                ],
                [
                    92.8689159,
                    55.9198891
                ],
                [
                    92.8582763,
                    55.9153086
                ],
                [
                    92.8534421,
                    55.9187633
                ],
                [
                    92.8529312,
                    55.9220781
                ],
                [
                    92.8530826,
                    55.9226445
                ],
                [
                    92.8515473,
                    55.9238704
                ],
                [
                    92.8508019,
                    55.9250173
                ],
                [
                    92.8504336,
                    55.9262897
                ],
                [
                    92.8510777,
                    55.9276035
                ],
                [
                    92.8517223,
                    55.9290608
                ],
                [
                    92.8518013,
                    55.9302594
                ],
                [
                    92.8516718,
                    55.9306056
                ],
                [
                    92.8510777,
                    55.9310782
                ],
                [
                    92.8488677,
                    55.9323295
                ],
                [
                    92.8482261,
                    55.9330017
                ],
                [
                    92.8463963,
                    55.9337205
                ],
                [
                    92.8455647,
                    55.9344706
                ],
                [
                    92.844733,
                    55.936116
                ],
                [
                    92.843294,
                    55.938455
                ],
                [
                    92.842875,
                    55.939594
                ],
                [
                    92.841256,
                    55.939954
                ],
                [
                    92.840476,
                    55.940913
                ],
                [
                    92.8370396,
                    55.9415848
                ],
                [
                    92.8353434,
                    55.9417215
                ],
                [
                    92.8354305,
                    55.9421091
                ],
                [
                    92.8373058,
                    55.9421661
                ],
                [
                    92.83743,
                    55.9443657
                ],
                [
                    92.837002,
                    55.94479
                ],
                [
                    92.8265689,
                    55.9471353
                ],
                [
                    92.8123299,
                    55.9498953
                ],
                [
                    92.8069754,
                    55.9520425
                ],
                [
                    92.8026947,
                    55.9521371
                ],
                [
                    92.7968907,
                    55.9521346
                ],
                [
                    92.7931199,
                    55.952217
                ],
                [
                    92.7886678,
                    55.951962
                ],
                [
                    92.7878671,
                    55.9511805
                ],
                [
                    92.7864941,
                    55.9502711
                ],
                [
                    92.783565,
                    55.9489384
                ],
                [
                    92.7820694,
                    55.9481388
                ],
                [
                    92.781407,
                    55.9483921
                ],
                [
                    92.784712,
                    55.951677
                ],
                [
                    92.7637302,
                    55.9517735
                ],
                [
                    92.7538406,
                    55.9522752
                ],
                [
                    92.7460863,
                    55.952659
                ],
                [
                    92.7240388,
                    55.954231
                ],
                [
                    92.7071014,
                    55.9555051
                ],
                [
                    92.6905626,
                    55.9559983
                ],
                [
                    92.6828821,
                    55.9568054
                ],
                [
                    92.6771176,
                    55.9562016
                ],
                [
                    92.6752214,
                    55.9552615
                ],
                [
                    92.6749168,
                    55.9548033
                ],
                [
                    92.6743695,
                    55.9546061
                ],
                [
                    92.6739114,
                    55.9545805
                ],
                [
                    92.6734592,
                    55.9546787
                ],
                [
                    92.6730771,
                    55.9548806
                ],
                [
                    92.6729142,
                    55.9550905
                ],
                [
                    92.6731271,
                    55.956575
                ],
                [
                    92.6738592,
                    55.9589906
                ],
                [
                    92.6746134,
                    55.9601392
                ],
                [
                    92.680667,
                    55.9628496
                ],
                [
                    92.6791234,
                    55.9642113
                ],
                [
                    92.679059,
                    55.964478
                ],
                [
                    92.675821,
                    55.971104
                ],
                [
                    92.674861,
                    55.972873
                ],
                [
                    92.664608,
                    55.972513
                ],
                [
                    92.663708,
                    55.971734
                ],
                [
                    92.648358,
                    55.970175
                ],
                [
                    92.638285,
                    55.968676
                ],
                [
                    92.636306,
                    55.969095
                ],
                [
                    92.635766,
                    55.968316
                ],
                [
                    92.631389,
                    55.967776
                ],
                [
                    92.63031,
                    55.968076
                ],
                [
                    92.62923,
                    55.969275
                ],
                [
                    92.627132,
                    55.969635
                ]
            ],
            "longitude": 92.8725147,
            "latitude": 56.0090968
        },
        "4": {
            "name": "КАНСК",
            "population": 91658,
            "type": "city",
            "poly": [
                [
                    95.6057985,
                    56.257223
                ],
                [
                    95.6068586,
                    56.257673
                ],
                [
                    95.6077291,
                    56.2577784
                ],
                [
                    95.6086944,
                    56.2580273
                ],
                [
                    95.6104181,
                    56.2585778
                ],
                [
                    95.6110387,
                    56.2590757
                ],
                [
                    95.6110042,
                    56.2593677
                ],
                [
                    95.6110473,
                    56.2597315
                ],
                [
                    95.6115644,
                    56.2599613
                ],
                [
                    95.6120902,
                    56.2604592
                ],
                [
                    95.6128101,
                    56.2611048
                ],
                [
                    95.6129071,
                    56.2613801
                ],
                [
                    95.61239,
                    56.2616433
                ],
                [
                    95.6120129,
                    56.2618827
                ],
                [
                    95.6120129,
                    56.2622118
                ],
                [
                    95.6124546,
                    56.2625469
                ],
                [
                    95.6131022,
                    56.2630129
                ],
                [
                    95.6132732,
                    56.2631998
                ],
                [
                    95.6133615,
                    56.2634632
                ],
                [
                    95.6136593,
                    56.263549
                ],
                [
                    95.6141613,
                    56.2634203
                ],
                [
                    95.6145584,
                    56.2632917
                ],
                [
                    95.6156892,
                    56.2634111
                ],
                [
                    95.6159209,
                    56.2634571
                ],
                [
                    95.615772,
                    56.2635919
                ],
                [
                    95.6159154,
                    56.2637512
                ],
                [
                    95.6163952,
                    56.2640851
                ],
                [
                    95.6169965,
                    56.2641065
                ],
                [
                    95.617504,
                    56.2643669
                ],
                [
                    95.617992,
                    56.2643466
                ],
                [
                    95.6180868,
                    56.2645429
                ],
                [
                    95.6183023,
                    56.2645668
                ],
                [
                    95.618466,
                    56.2645094
                ],
                [
                    95.6182333,
                    56.2642892
                ],
                [
                    95.6182937,
                    56.2641169
                ],
                [
                    95.6186901,
                    56.2638967
                ],
                [
                    95.6193021,
                    56.2638727
                ],
                [
                    95.6197502,
                    56.2637292
                ],
                [
                    95.6199485,
                    56.2637674
                ],
                [
                    95.6200777,
                    56.2641121
                ],
                [
                    95.619914,
                    56.2643131
                ],
                [
                    95.6195434,
                    56.2646003
                ],
                [
                    95.6194313,
                    56.2648396
                ],
                [
                    95.6194572,
                    56.2651507
                ],
                [
                    95.6198536,
                    56.2652752
                ],
                [
                    95.6202846,
                    56.2652369
                ],
                [
                    95.6204311,
                    56.2650407
                ],
                [
                    95.6205173,
                    56.2648923
                ],
                [
                    95.6210172,
                    56.264763
                ],
                [
                    95.6216291,
                    56.2648061
                ],
                [
                    95.6220773,
                    56.2650598
                ],
                [
                    95.6223186,
                    56.2652848
                ],
                [
                    95.6222669,
                    56.2654236
                ],
                [
                    95.622017,
                    56.2655145
                ],
                [
                    95.6215602,
                    56.265639
                ],
                [
                    95.6213619,
                    56.2661415
                ],
                [
                    95.6214308,
                    56.2664383
                ],
                [
                    95.6216291,
                    56.2668403
                ],
                [
                    95.6217239,
                    56.2672136
                ],
                [
                    95.6213102,
                    56.2672424
                ],
                [
                    95.6212154,
                    56.2674194
                ],
                [
                    95.6212585,
                    56.2677928
                ],
                [
                    95.6216376,
                    56.2679842
                ],
                [
                    95.622379,
                    56.2679842
                ],
                [
                    95.6229737,
                    56.2680895
                ],
                [
                    95.6241974,
                    56.2669313
                ],
                [
                    95.6252404,
                    56.2662325
                ],
                [
                    95.6257058,
                    56.2664335
                ],
                [
                    95.6272141,
                    56.2661415
                ],
                [
                    95.6274985,
                    56.2658974
                ],
                [
                    95.6273951,
                    56.2657634
                ],
                [
                    95.6278086,
                    56.2654863
                ],
                [
                    95.6276403,
                    56.2651311
                ],
                [
                    95.6271353,
                    56.2649722
                ],
                [
                    95.6268996,
                    56.2646263
                ],
                [
                    95.6284315,
                    56.2644486
                ],
                [
                    95.6299633,
                    56.2641495
                ],
                [
                    95.6320844,
                    56.2632146
                ],
                [
                    95.6322527,
                    56.2628967
                ],
                [
                    95.632825,
                    56.2628126
                ],
                [
                    95.6335657,
                    56.2626536
                ],
                [
                    95.6337509,
                    56.2622049
                ],
                [
                    95.6340539,
                    56.2613167
                ],
                [
                    95.6573515,
                    56.2622423
                ],
                [
                    95.6584622,
                    56.2624852
                ],
                [
                    95.6595466,
                    56.2626314
                ],
                [
                    95.6821924,
                    56.26307
                ],
                [
                    95.6824977,
                    56.2625846
                ],
                [
                    95.6833398,
                    56.258509
                ],
                [
                    95.6841927,
                    56.2581289
                ],
                [
                    95.6844559,
                    56.2578189
                ],
                [
                    95.6843749,
                    56.2571768
                ],
                [
                    95.6910918,
                    56.2572879
                ],
                [
                    95.6921657,
                    56.2554808
                ],
                [
                    95.692092,
                    56.2553873
                ],
                [
                    95.6920393,
                    56.2547732
                ],
                [
                    95.6972191,
                    56.25482
                ],
                [
                    95.6972086,
                    56.2538491
                ],
                [
                    95.6985772,
                    56.2537906
                ],
                [
                    95.7003565,
                    56.2564926
                ],
                [
                    95.7007823,
                    56.2580665
                ],
                [
                    95.7008606,
                    56.2587823
                ],
                [
                    95.7002684,
                    56.264023
                ],
                [
                    95.7004921,
                    56.2668952
                ],
                [
                    95.7025783,
                    56.2750449
                ],
                [
                    95.7159474,
                    56.2750947
                ],
                [
                    95.7166346,
                    56.2742493
                ],
                [
                    95.7174836,
                    56.2736881
                ],
                [
                    95.7171063,
                    56.2735272
                ],
                [
                    95.7165201,
                    56.2733439
                ],
                [
                    95.7162034,
                    56.2730895
                ],
                [
                    95.7160753,
                    56.2727528
                ],
                [
                    95.7158598,
                    56.2724685
                ],
                [
                    95.7154891,
                    56.2721168
                ],
                [
                    95.7152399,
                    56.2717015
                ],
                [
                    95.7153207,
                    56.2710318
                ],
                [
                    95.7151253,
                    56.2700254
                ],
                [
                    95.7146267,
                    56.269236
                ],
                [
                    95.7143505,
                    56.2689591
                ],
                [
                    95.7143505,
                    56.268787
                ],
                [
                    95.7146806,
                    56.2687009
                ],
                [
                    95.7153814,
                    56.2685812
                ],
                [
                    95.7205537,
                    56.2671686
                ],
                [
                    95.7216179,
                    56.2669755
                ],
                [
                    95.7220595,
                    56.266792
                ],
                [
                    95.7220831,
                    56.2666759
                ],
                [
                    95.7216111,
                    56.266513
                ],
                [
                    95.7223359,
                    56.2665074
                ],
                [
                    95.7228315,
                    56.2663708
                ],
                [
                    95.7236204,
                    56.2662734
                ],
                [
                    95.7243452,
                    56.2660993
                ],
                [
                    95.7267144,
                    56.2655108
                ],
                [
                    95.7279101,
                    56.265306
                ],
                [
                    95.7291743,
                    56.2650691
                ],
                [
                    95.7304965,
                    56.2647063
                ],
                [
                    95.7321119,
                    56.2640975
                ],
                [
                    95.733154,
                    56.2637273
                ],
                [
                    95.7340322,
                    56.2635523
                ],
                [
                    95.7349243,
                    56.2635598
                ],
                [
                    95.7351778,
                    56.2635733
                ],
                [
                    95.7356039,
                    56.263422
                ],
                [
                    95.7362593,
                    56.2632648
                ],
                [
                    95.7373084,
                    56.2631734
                ],
                [
                    95.7376698,
                    56.263088
                ],
                [
                    95.7378047,
                    56.2629113
                ],
                [
                    95.7377804,
                    56.262721
                ],
                [
                    95.7380258,
                    56.2626641
                ],
                [
                    95.7384794,
                    56.2626533
                ],
                [
                    95.7387626,
                    56.2625656
                ],
                [
                    95.7388547,
                    56.2623864
                ],
                [
                    95.7387099,
                    56.2622182
                ],
                [
                    95.7382161,
                    56.2619622
                ],
                [
                    95.7458696,
                    56.2591771
                ],
                [
                    95.7462699,
                    56.2584428
                ],
                [
                    95.7470969,
                    56.2572695
                ],
                [
                    95.7482084,
                    56.2562659
                ],
                [
                    95.7499203,
                    56.2553032
                ],
                [
                    95.7527553,
                    56.2542129
                ],
                [
                    95.7560404,
                    56.2526971
                ],
                [
                    95.7590416,
                    56.2511303
                ],
                [
                    95.7594278,
                    56.2509181
                ],
                [
                    95.7596565,
                    56.2508126
                ],
                [
                    95.7599521,
                    56.250857
                ],
                [
                    95.7600276,
                    56.2509145
                ],
                [
                    95.7599521,
                    56.2509828
                ],
                [
                    95.7596414,
                    56.251195
                ],
                [
                    95.7595529,
                    56.2514515
                ],
                [
                    95.7594235,
                    56.2516625
                ],
                [
                    95.7593005,
                    56.2519561
                ],
                [
                    95.7593587,
                    56.2521455
                ],
                [
                    95.7595529,
                    56.2523804
                ],
                [
                    95.7597596,
                    56.2525785
                ],
                [
                    95.7600587,
                    56.2530204
                ],
                [
                    95.7604041,
                    56.2528339
                ],
                [
                    95.7607743,
                    56.2525932
                ],
                [
                    95.7611579,
                    56.2525922
                ],
                [
                    95.7616311,
                    56.2523653
                ],
                [
                    95.7620223,
                    56.2522773
                ],
                [
                    95.7626882,
                    56.2519137
                ],
                [
                    95.7629783,
                    56.2518829
                ],
                [
                    95.7632665,
                    56.2516942
                ],
                [
                    95.763589,
                    56.2516381
                ],
                [
                    95.7638065,
                    56.2515289
                ],
                [
                    95.764045,
                    56.2515511
                ],
                [
                    95.7643771,
                    56.2514706
                ],
                [
                    95.764858,
                    56.2514091
                ],
                [
                    95.7652472,
                    56.2511483
                ],
                [
                    95.7658998,
                    56.2510571
                ],
                [
                    95.7661899,
                    56.2509681
                ],
                [
                    95.766167,
                    56.2506723
                ],
                [
                    95.7661594,
                    56.2505239
                ],
                [
                    95.7662318,
                    56.2504465
                ],
                [
                    95.7664361,
                    56.2504454
                ],
                [
                    95.7667032,
                    56.25072
                ],
                [
                    95.7668864,
                    56.2507878
                ],
                [
                    95.7675161,
                    56.2507168
                ],
                [
                    95.7680066,
                    56.2506309
                ],
                [
                    95.7681497,
                    56.2505461
                ],
                [
                    95.7681993,
                    56.2504571
                ],
                [
                    95.7679589,
                    56.2503553
                ],
                [
                    95.7678921,
                    56.2502631
                ],
                [
                    95.7680295,
                    56.2501655
                ],
                [
                    95.7681363,
                    56.250121
                ],
                [
                    95.7682298,
                    56.2501316
                ],
                [
                    95.7685504,
                    56.2502259
                ],
                [
                    95.7688634,
                    56.2502959
                ],
                [
                    95.7692756,
                    56.2503108
                ],
                [
                    95.7694473,
                    56.2502418
                ],
                [
                    95.7696839,
                    56.250227
                ],
                [
                    95.7699282,
                    56.2501411
                ],
                [
                    95.7700503,
                    56.2501199
                ],
                [
                    95.7701915,
                    56.25021
                ],
                [
                    95.7705464,
                    56.2500786
                ],
                [
                    95.7706113,
                    56.2499026
                ],
                [
                    95.7707449,
                    56.2498422
                ],
                [
                    95.7707846,
                    56.2497674
                ],
                [
                    95.7708926,
                    56.2496366
                ],
                [
                    95.7709958,
                    56.2496106
                ],
                [
                    95.7710683,
                    56.2496142
                ],
                [
                    95.7711747,
                    56.2496805
                ],
                [
                    95.77131,
                    56.2496563
                ],
                [
                    95.7714486,
                    56.2496913
                ],
                [
                    95.7717099,
                    56.2496993
                ],
                [
                    95.771855,
                    56.2495883
                ],
                [
                    95.7718659,
                    56.2492983
                ],
                [
                    95.7722469,
                    56.2490814
                ],
                [
                    95.7726436,
                    56.2490709
                ],
                [
                    95.7728577,
                    56.2490201
                ],
                [
                    95.7731442,
                    56.2489152
                ],
                [
                    95.7732765,
                    56.2487875
                ],
                [
                    95.7732733,
                    56.2487018
                ],
                [
                    95.7730938,
                    56.2486563
                ],
                [
                    95.7730057,
                    56.2485198
                ],
                [
                    95.7731347,
                    56.248009
                ],
                [
                    95.7730781,
                    56.2478533
                ],
                [
                    95.7729364,
                    56.2477589
                ],
                [
                    95.7727443,
                    56.2477571
                ],
                [
                    95.7726153,
                    56.2478446
                ],
                [
                    95.7723854,
                    56.2482347
                ],
                [
                    95.7720202,
                    56.2484814
                ],
                [
                    95.771762,
                    56.2484901
                ],
                [
                    95.7716077,
                    56.2483886
                ],
                [
                    95.7715699,
                    56.2482784
                ],
                [
                    95.7716298,
                    56.2481892
                ],
                [
                    95.7718061,
                    56.24817
                ],
                [
                    95.7718155,
                    56.247988
                ],
                [
                    95.7719068,
                    56.2479233
                ],
                [
                    95.7719887,
                    56.2477064
                ],
                [
                    95.7721493,
                    56.2476329
                ],
                [
                    95.7721398,
                    56.247535
                ],
                [
                    95.7712456,
                    56.2469437
                ],
                [
                    95.7712456,
                    56.2466568
                ],
                [
                    95.7716109,
                    56.2465553
                ],
                [
                    95.7722626,
                    56.246781
                ],
                [
                    95.7725082,
                    56.246781
                ],
                [
                    95.7726782,
                    56.2467617
                ],
                [
                    95.7727412,
                    56.246683
                ],
                [
                    95.7727947,
                    56.2465483
                ],
                [
                    95.7726656,
                    56.2464363
                ],
                [
                    95.7725617,
                    56.2462946
                ],
                [
                    95.7718376,
                    56.2460585
                ],
                [
                    95.7717431,
                    56.2460602
                ],
                [
                    95.7716392,
                    56.2461075
                ],
                [
                    95.7715321,
                    56.2461249
                ],
                [
                    95.7714944,
                    56.2460777
                ],
                [
                    95.7715447,
                    56.245978
                ],
                [
                    95.7716361,
                    56.2459518
                ],
                [
                    95.7723476,
                    56.2456718
                ],
                [
                    95.7724673,
                    56.2454532
                ],
                [
                    95.7725271,
                    56.2453027
                ],
                [
                    95.7724515,
                    56.245224
                ],
                [
                    95.7723319,
                    56.2451732
                ],
                [
                    95.7721995,
                    56.2451418
                ],
                [
                    95.7718533,
                    56.2452765
                ],
                [
                    95.7717179,
                    56.2452607
                ],
                [
                    95.7716423,
                    56.2451907
                ],
                [
                    95.7715951,
                    56.2449248
                ],
                [
                    95.7717651,
                    56.2447814
                ],
                [
                    95.7717777,
                    56.2446537
                ],
                [
                    95.7723949,
                    56.2446327
                ],
                [
                    95.7728168,
                    56.2445697
                ],
                [
                    95.772886,
                    56.2445137
                ],
                [
                    95.7730403,
                    56.2444385
                ],
                [
                    95.7731379,
                    56.2444297
                ],
                [
                    95.773289,
                    56.2444752
                ],
                [
                    95.7735567,
                    56.2444612
                ],
                [
                    95.7740258,
                    56.2443457
                ],
                [
                    95.7744824,
                    56.2441585
                ],
                [
                    95.7738967,
                    56.2435532
                ],
                [
                    95.7738715,
                    56.24338
                ],
                [
                    95.7741108,
                    56.2427799
                ],
                [
                    95.7745596,
                    56.2418608
                ],
                [
                    95.7750696,
                    56.2414671
                ],
                [
                    95.7758977,
                    56.2403649
                ],
                [
                    95.7766124,
                    56.2396825
                ],
                [
                    95.7780682,
                    56.2366526
                ],
                [
                    95.7780209,
                    56.2364531
                ],
                [
                    95.7778163,
                    56.2361539
                ],
                [
                    95.7777596,
                    56.2360226
                ],
                [
                    95.7769158,
                    56.2358074
                ],
                [
                    95.778553,
                    56.2347119
                ],
                [
                    95.7795448,
                    56.2330214
                ],
                [
                    95.7796907,
                    56.2329154
                ],
                [
                    95.7799573,
                    56.2327554
                ],
                [
                    95.7799888,
                    56.2327782
                ],
                [
                    95.7800045,
                    56.2329707
                ],
                [
                    95.7813427,
                    56.2337354
                ],
                [
                    95.7866488,
                    56.2369981
                ],
                [
                    95.7883609,
                    56.2356529
                ],
                [
                    95.7890231,
                    56.2348135
                ],
                [
                    95.7911597,
                    56.2328968
                ],
                [
                    95.7919157,
                    56.2323071
                ],
                [
                    95.7922432,
                    56.2320936
                ],
                [
                    95.7927249,
                    56.2316893
                ],
                [
                    95.7994786,
                    56.2279195
                ],
                [
                    95.7985081,
                    56.2272135
                ],
                [
                    95.7927895,
                    56.2230567
                ],
                [
                    95.7925099,
                    56.222897
                ],
                [
                    95.7924904,
                    56.2227022
                ],
                [
                    95.7925415,
                    56.2226147
                ],
                [
                    95.792392,
                    56.2224002
                ],
                [
                    95.7925061,
                    56.2221814
                ],
                [
                    95.7924431,
                    56.2217766
                ],
                [
                    95.7924746,
                    56.2217044
                ],
                [
                    95.7925099,
                    56.2216016
                ],
                [
                    95.7924668,
                    56.2214506
                ],
                [
                    95.7923802,
                    56.221339
                ],
                [
                    95.7924589,
                    56.2209976
                ],
                [
                    95.7921007,
                    56.2205097
                ],
                [
                    95.7921125,
                    56.2202492
                ],
                [
                    95.7920889,
                    56.2199166
                ],
                [
                    95.7919275,
                    56.2196869
                ],
                [
                    95.791719,
                    56.2195709
                ],
                [
                    95.7909042,
                    56.2193893
                ],
                [
                    95.7899282,
                    56.2187087
                ],
                [
                    95.7893822,
                    56.2180481
                ],
                [
                    95.789237,
                    56.217997
                ],
                [
                    95.7890158,
                    56.2177857
                ],
                [
                    95.788815,
                    56.2177113
                ],
                [
                    95.7887481,
                    56.2176434
                ],
                [
                    95.7886261,
                    56.2175931
                ],
                [
                    95.788575,
                    56.2173896
                ],
                [
                    95.7881349,
                    56.216516
                ],
                [
                    95.7880569,
                    56.2164179
                ],
                [
                    95.7871324,
                    56.2160608
                ],
                [
                    95.7860594,
                    56.2155621
                ],
                [
                    95.7846916,
                    56.214692
                ],
                [
                    95.7849082,
                    56.2145505
                ],
                [
                    95.7851529,
                    56.2142909
                ],
                [
                    95.7861964,
                    56.2145282
                ],
                [
                    95.7868851,
                    56.2146034
                ],
                [
                    95.7876723,
                    56.2146491
                ],
                [
                    95.7888776,
                    56.2144529
                ],
                [
                    95.7890682,
                    56.2142409
                ],
                [
                    95.7891905,
                    56.2140192
                ],
                [
                    95.7894679,
                    56.2138545
                ],
                [
                    95.789757,
                    56.2137177
                ],
                [
                    95.7900767,
                    56.2132594
                ],
                [
                    95.7918109,
                    56.2123566
                ],
                [
                    95.7939817,
                    56.2110741
                ],
                [
                    95.7954601,
                    56.2103392
                ],
                [
                    95.7959324,
                    56.2080886
                ],
                [
                    95.7955393,
                    56.2078246
                ],
                [
                    95.797965,
                    56.2060287
                ],
                [
                    95.7954899,
                    56.2048489
                ],
                [
                    95.7944739,
                    56.2010966
                ],
                [
                    95.7937533,
                    56.2006695
                ],
                [
                    95.7932453,
                    56.2005775
                ],
                [
                    95.7927019,
                    56.2003015
                ],
                [
                    95.7924892,
                    56.1994668
                ],
                [
                    95.7921111,
                    56.1991645
                ],
                [
                    95.7908944,
                    56.1988162
                ],
                [
                    95.7905399,
                    56.1984482
                ],
                [
                    95.7905075,
                    56.1972229
                ],
                [
                    95.7910382,
                    56.1966581
                ],
                [
                    95.7910843,
                    56.1962344
                ],
                [
                    95.7901845,
                    56.1957081
                ],
                [
                    95.7896768,
                    56.1957466
                ],
                [
                    95.7890077,
                    56.1963243
                ],
                [
                    95.7874156,
                    56.1961959
                ],
                [
                    95.7863081,
                    56.1959007
                ],
                [
                    95.7854083,
                    56.195875
                ],
                [
                    95.7848776,
                    56.1961831
                ],
                [
                    95.7840238,
                    56.1961446
                ],
                [
                    95.783147,
                    56.1964655
                ],
                [
                    95.7787862,
                    56.1936798
                ],
                [
                    95.7775864,
                    56.1917926
                ],
                [
                    95.7752098,
                    56.1900722
                ],
                [
                    95.7764788,
                    56.1895458
                ],
                [
                    95.7754867,
                    56.1884673
                ],
                [
                    95.7736639,
                    56.1876199
                ],
                [
                    95.7730409,
                    56.1869522
                ],
                [
                    95.7720949,
                    56.1868367
                ],
                [
                    95.7714258,
                    56.1862845
                ],
                [
                    95.7700413,
                    56.1855912
                ],
                [
                    95.7663418,
                    56.1840929
                ],
                [
                    95.7659031,
                    56.1841636
                ],
                [
                    95.7645524,
                    56.1825252
                ],
                [
                    95.7610544,
                    56.1793382
                ],
                [
                    95.7601077,
                    56.1795182
                ],
                [
                    95.7594728,
                    56.1799358
                ],
                [
                    95.7586416,
                    56.1805784
                ],
                [
                    95.7575986,
                    56.1809142
                ],
                [
                    95.7562997,
                    56.1809945
                ],
                [
                    95.7550732,
                    56.1809142
                ],
                [
                    95.7542615,
                    56.1806431
                ],
                [
                    95.7541713,
                    56.1800407
                ],
                [
                    95.7549289,
                    56.1793279
                ],
                [
                    95.7561915,
                    56.1786652
                ],
                [
                    95.756859,
                    56.1778921
                ],
                [
                    95.7565343,
                    56.1774905
                ],
                [
                    95.7548929,
                    56.1769182
                ],
                [
                    95.7528726,
                    56.1767575
                ],
                [
                    95.7550913,
                    56.1742171
                ],
                [
                    95.7551454,
                    56.1733034
                ],
                [
                    95.7528365,
                    56.1722992
                ],
                [
                    95.7526922,
                    56.1716766
                ],
                [
                    95.7533234,
                    56.170813
                ],
                [
                    95.7555386,
                    56.1689491
                ],
                [
                    95.7550913,
                    56.1682019
                ],
                [
                    95.7546151,
                    56.1680091
                ],
                [
                    95.7545717,
                    56.1675591
                ],
                [
                    95.7503253,
                    56.164998
                ],
                [
                    95.740813,
                    56.1585828
                ],
                [
                    95.7403197,
                    56.1554827
                ],
                [
                    95.7346123,
                    56.1556789
                ],
                [
                    95.7358454,
                    56.1617023
                ],
                [
                    95.7301027,
                    56.1619181
                ],
                [
                    95.729567,
                    56.1577894
                ],
                [
                    95.7026223,
                    56.1579024
                ],
                [
                    95.6942796,
                    56.1582415
                ],
                [
                    95.6908974,
                    56.1585428
                ],
                [
                    95.6900406,
                    56.159246
                ],
                [
                    95.6884848,
                    56.1600245
                ],
                [
                    95.6883044,
                    56.1605896
                ],
                [
                    95.687876,
                    56.1605142
                ],
                [
                    95.687876,
                    56.1592711
                ],
                [
                    95.686929,
                    56.1585805
                ],
                [
                    95.6844261,
                    56.156496
                ],
                [
                    95.6747306,
                    56.1586056
                ],
                [
                    95.6718219,
                    56.1591205
                ],
                [
                    95.6708523,
                    56.157149
                ],
                [
                    95.6694544,
                    56.1572244
                ],
                [
                    95.6683946,
                    56.1569355
                ],
                [
                    95.6542343,
                    56.1595608
                ],
                [
                    95.6494308,
                    56.1604442
                ],
                [
                    95.6464121,
                    56.1613522
                ],
                [
                    95.630698,
                    56.1683015
                ],
                [
                    95.6306698,
                    56.168592
                ],
                [
                    95.6309942,
                    56.1685999
                ],
                [
                    95.6310075,
                    56.1763673
                ],
                [
                    95.6301254,
                    56.186039
                ],
                [
                    95.6296406,
                    56.1864069
                ],
                [
                    95.6295966,
                    56.1869341
                ],
                [
                    95.6297728,
                    56.1880009
                ],
                [
                    95.6294203,
                    56.1890921
                ],
                [
                    95.6293077,
                    56.1903055
                ],
                [
                    95.6291149,
                    56.191317
                ],
                [
                    95.6286743,
                    56.1917921
                ],
                [
                    95.6272399,
                    56.1963428
                ],
                [
                    95.6280579,
                    56.1963898
                ],
                [
                    95.6289322,
                    56.1967586
                ],
                [
                    95.6288219,
                    56.1978673
                ],
                [
                    95.6288078,
                    56.1980087
                ],
                [
                    95.6261341,
                    56.1979711
                ],
                [
                    95.6261341,
                    56.1984418
                ],
                [
                    95.6268335,
                    56.1985548
                ],
                [
                    95.626801,
                    56.1986779
                ],
                [
                    95.6267771,
                    56.1987682
                ],
                [
                    95.626412,
                    56.1990545
                ],
                [
                    95.6272494,
                    56.2000596
                ],
                [
                    95.6284316,
                    56.2032449
                ],
                [
                    95.6250613,
                    56.2037234
                ],
                [
                    95.6249406,
                    56.2047066
                ],
                [
                    95.6287137,
                    56.205755
                ],
                [
                    95.6287419,
                    56.2060922
                ],
                [
                    95.628897,
                    56.2064687
                ],
                [
                    95.6298982,
                    56.2073942
                ],
                [
                    95.6306457,
                    56.2078178
                ],
                [
                    95.6317738,
                    56.2081394
                ],
                [
                    95.6368928,
                    56.2090413
                ],
                [
                    95.6373775,
                    56.2092374
                ],
                [
                    95.6372717,
                    56.2134772
                ],
                [
                    95.6365314,
                    56.2137713
                ],
                [
                    95.6353503,
                    56.214781
                ],
                [
                    95.6347687,
                    56.2152319
                ],
                [
                    95.6350155,
                    56.2153789
                ],
                [
                    95.6356853,
                    56.2156044
                ],
                [
                    95.6361613,
                    56.2153201
                ],
                [
                    95.6369721,
                    56.2153299
                ],
                [
                    95.6382413,
                    56.2146633
                ],
                [
                    95.6401274,
                    56.2142418
                ],
                [
                    95.64048,
                    56.2141536
                ],
                [
                    95.6403566,
                    56.2147516
                ],
                [
                    95.6400393,
                    56.2151927
                ],
                [
                    95.6405505,
                    56.2158494
                ],
                [
                    95.64048,
                    56.2163493
                ],
                [
                    95.640514,
                    56.2167588
                ],
                [
                    95.6415331,
                    56.2172183
                ],
                [
                    95.642442,
                    56.2177084
                ],
                [
                    95.6427174,
                    56.2184282
                ],
                [
                    95.6411199,
                    56.2187651
                ],
                [
                    95.6416983,
                    56.2194083
                ],
                [
                    95.6397152,
                    56.219929
                ],
                [
                    95.6415054,
                    56.2222107
                ],
                [
                    95.642559,
                    56.2230917
                ],
                [
                    95.6422696,
                    56.2231837
                ],
                [
                    95.6411533,
                    56.2236433
                ],
                [
                    95.6390469,
                    56.2247734
                ],
                [
                    95.6379885,
                    56.2252342
                ],
                [
                    95.6378827,
                    56.2254304
                ],
                [
                    95.6379532,
                    56.2256902
                ],
                [
                    95.6388793,
                    56.2264649
                ],
                [
                    95.6400611,
                    56.2272641
                ],
                [
                    95.6421867,
                    56.2287055
                ],
                [
                    95.6428922,
                    56.2291859
                ],
                [
                    95.6433773,
                    56.2296321
                ],
                [
                    95.6440123,
                    56.2300341
                ],
                [
                    95.6437696,
                    56.2300966
                ],
                [
                    95.6433066,
                    56.2301763
                ],
                [
                    95.64259,
                    56.2302375
                ],
                [
                    95.6423806,
                    56.2303724
                ],
                [
                    95.6424687,
                    56.2305991
                ],
                [
                    95.6427223,
                    56.2306604
                ],
                [
                    95.6427664,
                    56.2307891
                ],
                [
                    95.6431412,
                    56.2308749
                ],
                [
                    95.643472,
                    56.2311567
                ],
                [
                    95.6438578,
                    56.2316163
                ],
                [
                    95.6459842,
                    56.232835
                ],
                [
                    95.6474622,
                    56.2317344
                ],
                [
                    95.6503804,
                    56.229826
                ],
                [
                    95.6545003,
                    56.2290626
                ],
                [
                    95.6589635,
                    56.229826
                ],
                [
                    95.66274,
                    56.2313527
                ],
                [
                    95.6639417,
                    56.2330702
                ],
                [
                    95.6641133,
                    56.2362186
                ],
                [
                    95.6619427,
                    56.2377302
                ],
                [
                    95.6595129,
                    56.2392555
                ],
                [
                    95.6580124,
                    56.2400531
                ],
                [
                    95.657099,
                    56.2412495
                ],
                [
                    95.6569358,
                    56.2440591
                ],
                [
                    95.6558268,
                    56.2455272
                ],
                [
                    95.6544568,
                    56.246941
                ],
                [
                    95.6542611,
                    56.247684
                ],
                [
                    95.6547358,
                    56.2480619
                ],
                [
                    95.654649,
                    56.2483505
                ],
                [
                    95.6542504,
                    56.2484881
                ],
                [
                    95.6542181,
                    56.2487694
                ],
                [
                    95.6540673,
                    56.2489251
                ],
                [
                    95.6530976,
                    56.2491226
                ],
                [
                    95.6521819,
                    56.2493381
                ],
                [
                    95.6520203,
                    56.2495715
                ],
                [
                    95.6521496,
                    56.2498708
                ],
                [
                    95.6523004,
                    56.2501461
                ],
                [
                    95.6522573,
                    56.2503197
                ],
                [
                    95.6518372,
                    56.2503017
                ],
                [
                    95.6402557,
                    56.248973
                ],
                [
                    95.6145792,
                    56.2489174
                ],
                [
                    95.6134484,
                    56.248948
                ],
                [
                    95.6125727,
                    56.2491089
                ],
                [
                    95.6118488,
                    56.2493886
                ],
                [
                    95.6112627,
                    56.2497908
                ],
                [
                    95.6100832,
                    56.2513422
                ],
                [
                    95.6057985,
                    56.257223
                ]
            ],
            "longitude": 95.706787,
            "latitude": 56.205997
        },
        "5": {
            "name": "КЫЗЫЛ",
            "population": 114181,
            "type": "city",
            "poly": [
                [
                    94.2714722,
                    51.6719038
                ],
                [
                    94.2821152,
                    51.6791423
                ],
                [
                    94.2953945,
                    51.6860788
                ],
                [
                    94.3111983,
                    51.6914666
                ],
                [
                    94.3208167,
                    51.6953768
                ],
                [
                    94.3270928,
                    51.6993888
                ],
                [
                    94.3286155,
                    51.7036131
                ],
                [
                    94.3279862,
                    51.7085432
                ],
                [
                    94.3411443,
                    51.7125644
                ],
                [
                    94.3454381,
                    51.7133607
                ],
                [
                    94.3534707,
                    51.7155867
                ],
                [
                    94.3562456,
                    51.7187717
                ],
                [
                    94.3743264,
                    51.7235307
                ],
                [
                    94.3824175,
                    51.7262267
                ],
                [
                    94.3954742,
                    51.7295738
                ],
                [
                    94.4094948,
                    51.7328301
                ],
                [
                    94.4119931,
                    51.7337145
                ],
                [
                    94.4121486,
                    51.7340109
                ],
                [
                    94.4163991,
                    51.7408267
                ],
                [
                    94.4245077,
                    51.7562488
                ],
                [
                    94.4243675,
                    51.7613835
                ],
                [
                    94.4204885,
                    51.764869
                ],
                [
                    94.4211356,
                    51.7678834
                ],
                [
                    94.4242949,
                    51.7672471
                ],
                [
                    94.4280524,
                    51.7682074
                ],
                [
                    94.4308191,
                    51.7709953
                ],
                [
                    94.433698,
                    51.7710185
                ],
                [
                    94.4372125,
                    51.7692948
                ],
                [
                    94.4388576,
                    51.7704979
                ],
                [
                    94.440914,
                    51.7731701
                ],
                [
                    94.4389698,
                    51.7775308
                ],
                [
                    94.4383529,
                    51.7808618
                ],
                [
                    94.4390446,
                    51.7838688
                ],
                [
                    94.4368947,
                    51.7932468
                ],
                [
                    94.4367826,
                    51.8056515
                ],
                [
                    94.4391241,
                    51.8089207
                ],
                [
                    94.4392083,
                    51.8099954
                ],
                [
                    94.4412375,
                    51.8117138
                ],
                [
                    94.4586291,
                    51.8113805
                ],
                [
                    94.4728905,
                    51.8109367
                ],
                [
                    94.4832155,
                    51.8081909
                ],
                [
                    94.485,
                    51.808
                ],
                [
                    94.4855,
                    51.80775
                ],
                [
                    94.48575,
                    51.8075
                ],
                [
                    94.4855,
                    51.807
                ],
                [
                    94.48475,
                    51.806
                ],
                [
                    94.485,
                    51.805
                ],
                [
                    94.484,
                    51.7995
                ],
                [
                    94.48375,
                    51.79925
                ],
                [
                    94.484,
                    51.7985
                ],
                [
                    94.48375,
                    51.79825
                ],
                [
                    94.483,
                    51.797
                ],
                [
                    94.483,
                    51.7965
                ],
                [
                    94.483,
                    51.795
                ],
                [
                    94.48275,
                    51.79475
                ],
                [
                    94.4825,
                    51.7945
                ],
                [
                    94.4815,
                    51.7905
                ],
                [
                    94.48175,
                    51.79
                ],
                [
                    94.482,
                    51.78975
                ],
                [
                    94.48175,
                    51.78375
                ],
                [
                    94.47875,
                    51.779
                ],
                [
                    94.47725,
                    51.7775
                ],
                [
                    94.47525,
                    51.77525
                ],
                [
                    94.475,
                    51.77425
                ],
                [
                    94.4745,
                    51.77425
                ],
                [
                    94.47425,
                    51.774
                ],
                [
                    94.474,
                    51.7735
                ],
                [
                    94.47225,
                    51.77125
                ],
                [
                    94.4695,
                    51.76875
                ],
                [
                    94.469,
                    51.7685
                ],
                [
                    94.46675,
                    51.76725
                ],
                [
                    94.46575,
                    51.76725
                ],
                [
                    94.4645,
                    51.7665
                ],
                [
                    94.46425,
                    51.76675
                ],
                [
                    94.4629152,
                    51.7661299
                ],
                [
                    94.4655,
                    51.7645
                ],
                [
                    94.461,
                    51.762
                ],
                [
                    94.4605,
                    51.76175
                ],
                [
                    94.4585,
                    51.76
                ],
                [
                    94.45775,
                    51.759
                ],
                [
                    94.457,
                    51.7575
                ],
                [
                    94.457,
                    51.7555
                ],
                [
                    94.45925,
                    51.751
                ],
                [
                    94.4595,
                    51.75075
                ],
                [
                    94.4585,
                    51.74925
                ],
                [
                    94.458,
                    51.7475
                ],
                [
                    94.45775,
                    51.74675
                ],
                [
                    94.4595,
                    51.74425
                ],
                [
                    94.46075,
                    51.74325
                ],
                [
                    94.461,
                    51.743
                ],
                [
                    94.46175,
                    51.74125
                ],
                [
                    94.462,
                    51.741
                ],
                [
                    94.4624674,
                    51.7406812
                ],
                [
                    94.4642141,
                    51.742651
                ],
                [
                    94.4644973,
                    51.7426025
                ],
                [
                    94.4642516,
                    51.7420318
                ],
                [
                    94.4635,
                    51.741
                ],
                [
                    94.4632538,
                    51.7401517
                ],
                [
                    94.463,
                    51.739
                ],
                [
                    94.4633096,
                    51.7380948
                ],
                [
                    94.4635,
                    51.737
                ],
                [
                    94.463683,
                    51.7366178
                ],
                [
                    94.4637752,
                    51.736192
                ],
                [
                    94.4638117,
                    51.7357873
                ],
                [
                    94.4637774,
                    51.7341362
                ],
                [
                    94.4638804,
                    51.7338272
                ],
                [
                    94.4645445,
                    51.7340717
                ],
                [
                    94.4660852,
                    51.7352737
                ],
                [
                    94.4683597,
                    51.7377228
                ],
                [
                    94.4686365,
                    51.7385944
                ],
                [
                    94.4689659,
                    51.7387718
                ],
                [
                    94.4688618,
                    51.7374317
                ],
                [
                    94.4685292,
                    51.7358378
                ],
                [
                    94.4677267,
                    51.7352784
                ],
                [
                    94.4669031,
                    51.734351
                ],
                [
                    94.4648283,
                    51.7327603
                ],
                [
                    94.4637656,
                    51.7318013
                ],
                [
                    94.4594376,
                    51.7301314
                ],
                [
                    94.4568403,
                    51.7289565
                ],
                [
                    94.4565537,
                    51.728702
                ],
                [
                    94.4566234,
                    51.7284448
                ],
                [
                    94.4571136,
                    51.728309
                ],
                [
                    94.45825,
                    51.72825
                ],
                [
                    94.4607529,
                    51.7281405
                ],
                [
                    94.4615,
                    51.72825
                ],
                [
                    94.4661742,
                    51.7278129
                ],
                [
                    94.46725,
                    51.7275
                ],
                [
                    94.468,
                    51.727
                ],
                [
                    94.46775,
                    51.72675
                ],
                [
                    94.4651341,
                    51.7273157
                ],
                [
                    94.465258,
                    51.7270732
                ],
                [
                    94.4667675,
                    51.7265303
                ],
                [
                    94.4679917,
                    51.7260438
                ],
                [
                    94.4685,
                    51.72575
                ],
                [
                    94.4732821,
                    51.7233031
                ],
                [
                    94.4753002,
                    51.7225986
                ],
                [
                    94.4781843,
                    51.7223732
                ],
                [
                    94.4827202,
                    51.7227049
                ],
                [
                    94.4914535,
                    51.7241943
                ],
                [
                    94.49225,
                    51.72425
                ],
                [
                    94.4945134,
                    51.7242873
                ],
                [
                    94.49675,
                    51.72425
                ],
                [
                    94.50275,
                    51.72425
                ],
                [
                    94.50325,
                    51.72375
                ],
                [
                    94.50475,
                    51.724
                ],
                [
                    94.507,
                    51.724
                ],
                [
                    94.515,
                    51.721
                ],
                [
                    94.535,
                    51.7155
                ],
                [
                    94.5355,
                    51.71525
                ],
                [
                    94.53375,
                    51.715
                ],
                [
                    94.5305,
                    51.716
                ],
                [
                    94.53,
                    51.716
                ],
                [
                    94.52975,
                    51.71575
                ],
                [
                    94.5315,
                    51.7145
                ],
                [
                    94.53075,
                    51.71425
                ],
                [
                    94.5295,
                    51.71475
                ],
                [
                    94.52925,
                    51.7155
                ],
                [
                    94.529,
                    51.71575
                ],
                [
                    94.52625,
                    51.7165
                ],
                [
                    94.5255,
                    51.71675
                ],
                [
                    94.52475,
                    51.71575
                ],
                [
                    94.5255,
                    51.71475
                ],
                [
                    94.5255,
                    51.714
                ],
                [
                    94.52775,
                    51.71175
                ],
                [
                    94.52925,
                    51.711
                ],
                [
                    94.536,
                    51.71
                ],
                [
                    94.5365,
                    51.70975
                ],
                [
                    94.53675,
                    51.7095
                ],
                [
                    94.542,
                    51.7095
                ],
                [
                    94.5425,
                    51.709
                ],
                [
                    94.54425,
                    51.70925
                ],
                [
                    94.5485,
                    51.7085
                ],
                [
                    94.55025,
                    51.70825
                ],
                [
                    94.55175,
                    51.70875
                ],
                [
                    94.5585,
                    51.70875
                ],
                [
                    94.559,
                    51.70875
                ],
                [
                    94.5605,
                    51.70925
                ],
                [
                    94.561,
                    51.7095
                ],
                [
                    94.5745,
                    51.70825
                ],
                [
                    94.5755,
                    51.7085
                ],
                [
                    94.57775,
                    51.70775
                ],
                [
                    94.57925,
                    51.708
                ],
                [
                    94.58575,
                    51.707
                ],
                [
                    94.58675,
                    51.707
                ],
                [
                    94.587,
                    51.70675
                ],
                [
                    94.6119489,
                    51.7059035
                ],
                [
                    94.6323779,
                    51.706664
                ],
                [
                    94.6405351,
                    51.6997297
                ],
                [
                    94.6401178,
                    51.6973189
                ],
                [
                    94.6372639,
                    51.6963713
                ],
                [
                    94.6274791,
                    51.6971926
                ],
                [
                    94.618102,
                    51.6985192
                ],
                [
                    94.6110549,
                    51.7006809
                ],
                [
                    94.6012701,
                    51.7006809
                ],
                [
                    94.5923569,
                    51.7011495
                ],
                [
                    94.5866581,
                    51.7014491
                ],
                [
                    94.5766692,
                    51.7027183
                ],
                [
                    94.5717012,
                    51.7044
                ],
                [
                    94.5680273,
                    51.7047105
                ],
                [
                    94.5615145,
                    51.7055901
                ],
                [
                    94.5556697,
                    51.7044518
                ],
                [
                    94.5509521,
                    51.7052538
                ],
                [
                    94.5431031,
                    51.6916638
                ],
                [
                    94.5426935,
                    51.6900636
                ],
                [
                    94.5434617,
                    51.688842
                ],
                [
                    94.546,
                    51.6878482
                ],
                [
                    94.546167,
                    51.6866887
                ],
                [
                    94.5443361,
                    51.6868866
                ],
                [
                    94.5362685,
                    51.6841078
                ],
                [
                    94.527404,
                    51.6781175
                ],
                [
                    94.5245156,
                    51.6758941
                ],
                [
                    94.5232208,
                    51.671694
                ],
                [
                    94.5250136,
                    51.6658255
                ],
                [
                    94.5245156,
                    51.6618716
                ],
                [
                    94.5174439,
                    51.655075
                ],
                [
                    94.5142567,
                    51.6540246
                ],
                [
                    94.5111691,
                    51.6559401
                ],
                [
                    94.5013086,
                    51.6561873
                ],
                [
                    94.4909501,
                    51.6568052
                ],
                [
                    94.4841574,
                    51.6608707
                ],
                [
                    94.4729224,
                    51.661711
                ],
                [
                    94.4549146,
                    51.6592396
                ],
                [
                    94.4473449,
                    51.6562243
                ],
                [
                    94.4441577,
                    51.6529123
                ],
                [
                    94.4375442,
                    51.6517752
                ],
                [
                    94.4294168,
                    51.6534066
                ],
                [
                    94.4225643,
                    51.6513797
                ],
                [
                    94.4258312,
                    51.6458424
                ],
                [
                    94.4224846,
                    51.639711
                ],
                [
                    94.4236798,
                    51.6346174
                ],
                [
                    94.4395362,
                    51.6308586
                ],
                [
                    94.4446358,
                    51.6211634
                ],
                [
                    94.4538788,
                    51.6170077
                ],
                [
                    94.4698149,
                    51.5998367
                ],
                [
                    94.4652731,
                    51.5981044
                ],
                [
                    94.4471856,
                    51.5993417
                ],
                [
                    94.4344367,
                    51.5947386
                ],
                [
                    94.4372255,
                    51.5843921
                ],
                [
                    94.4421657,
                    51.5737461
                ],
                [
                    94.4414486,
                    51.5639396
                ],
                [
                    94.4393769,
                    51.5555678
                ],
                [
                    94.4349945,
                    51.5509602
                ],
                [
                    94.4310901,
                    51.5504648
                ],
                [
                    94.4050345,
                    51.567803
                ],
                [
                    94.3841582,
                    51.5683974
                ],
                [
                    94.3800148,
                    51.5762221
                ],
                [
                    94.3685408,
                    51.5891943
                ],
                [
                    94.3607321,
                    51.5896399
                ],
                [
                    94.359776,
                    51.5935506
                ],
                [
                    94.3469474,
                    51.5991438
                ],
                [
                    94.3462303,
                    51.5954315
                ],
                [
                    94.3399355,
                    51.5938971
                ],
                [
                    94.3196966,
                    51.6010245
                ],
                [
                    94.3154736,
                    51.6045878
                ],
                [
                    94.3295556,
                    51.6131062
                ],
                [
                    94.3523159,
                    51.6203535
                ],
                [
                    94.3590014,
                    51.642317
                ],
                [
                    94.3597462,
                    51.6518827
                ],
                [
                    94.3515869,
                    51.6548251
                ],
                [
                    94.3338405,
                    51.6602348
                ],
                [
                    94.3313927,
                    51.6641572
                ],
                [
                    94.327874,
                    51.6658653
                ],
                [
                    94.3200716,
                    51.6646949
                ],
                [
                    94.315635,
                    51.6686486
                ],
                [
                    94.304824,
                    51.6604879
                ],
                [
                    94.2917691,
                    51.6571029
                ],
                [
                    94.286409,
                    51.6582874
                ],
                [
                    94.283172,
                    51.6640024
                ],
                [
                    94.2779429,
                    51.664543
                ],
                [
                    94.2714722,
                    51.6719038
                ]
            ],
            "longitude": 94.423325,
            "latitude": 51.706715
        },
        "6": {
            "name": "КЕМЕРОВО",
            "population": 553076,
            "type": "city",
            "poly": [
                [
                    [
                        85.9096282,
                        55.3155238
                    ],
                    [
                        85.9136,
                        55.327801
                    ],
                    [
                        85.9213657,
                        55.333601
                    ],
                    [
                        85.9296056,
                        55.3360623
                    ],
                    [
                        85.9342294,
                        55.3357926
                    ],
                    [
                        85.9366006,
                        55.3315778
                    ],
                    [
                        85.9434628,
                        55.3274811
                    ],
                    [
                        85.9523099,
                        55.3253054
                    ],
                    [
                        85.9510057,
                        55.3316115
                    ],
                    [
                        85.9469154,
                        55.3322859
                    ],
                    [
                        85.9479556,
                        55.3377892
                    ],
                    [
                        85.9553049,
                        55.341764
                    ],
                    [
                        85.9525733,
                        55.343037
                    ],
                    [
                        85.9534459,
                        55.3435332
                    ],
                    [
                        85.957771,
                        55.3432743
                    ],
                    [
                        85.9627055,
                        55.3485037
                    ],
                    [
                        85.9653992,
                        55.3546727
                    ],
                    [
                        85.9574501,
                        55.3626948
                    ],
                    [
                        85.9570796,
                        55.3649585
                    ],
                    [
                        85.9523558,
                        55.3681696
                    ],
                    [
                        85.954023,
                        55.369854
                    ],
                    [
                        85.960911,
                        55.3651712
                    ],
                    [
                        85.9731147,
                        55.3772712
                    ],
                    [
                        85.9818617,
                        55.3753757
                    ],
                    [
                        85.9797869,
                        55.3810003
                    ],
                    [
                        85.9738087,
                        55.3825539
                    ],
                    [
                        85.9648161,
                        55.3872766
                    ],
                    [
                        85.9512697,
                        55.3913539
                    ],
                    [
                        85.9386495,
                        55.3887892
                    ],
                    [
                        85.927766,
                        55.3937212
                    ],
                    [
                        85.9312612,
                        55.4127571
                    ],
                    [
                        85.9424688,
                        55.4169107
                    ],
                    [
                        85.9402602,
                        55.4185447
                    ],
                    [
                        85.9159512,
                        55.4336576
                    ],
                    [
                        85.9167616,
                        55.436088
                    ],
                    [
                        85.9681686,
                        55.448435
                    ],
                    [
                        85.997577,
                        55.4512585
                    ],
                    [
                        86.0347428,
                        55.4525717
                    ],
                    [
                        86.0395388,
                        55.4466763
                    ],
                    [
                        86.0406477,
                        55.4454143
                    ],
                    [
                        86.0441211,
                        55.4390438
                    ],
                    [
                        86.050026,
                        55.4305044
                    ],
                    [
                        86.0552362,
                        55.4280736
                    ],
                    [
                        86.0552362,
                        55.4221602
                    ],
                    [
                        86.0639198,
                        55.4206489
                    ],
                    [
                        86.0724241,
                        55.4184298
                    ],
                    [
                        86.0811077,
                        55.4211897
                    ],
                    [
                        86.0815709,
                        55.4266434
                    ],
                    [
                        86.0849285,
                        55.4282202
                    ],
                    [
                        86.0950015,
                        55.4301911
                    ],
                    [
                        86.0928016,
                        55.4361689
                    ],
                    [
                        86.0875915,
                        55.4360376
                    ],
                    [
                        86.0812234,
                        55.4301911
                    ],
                    [
                        86.0786763,
                        55.4309137
                    ],
                    [
                        86.0750871,
                        55.4349209
                    ],
                    [
                        86.0588777,
                        55.440504
                    ],
                    [
                        86.04811,
                        55.4414235
                    ],
                    [
                        86.0424368,
                        55.4456266
                    ],
                    [
                        86.0478785,
                        55.4489099
                    ],
                    [
                        86.0521624,
                        55.4475966
                    ],
                    [
                        86.0504257,
                        55.4503545
                    ],
                    [
                        86.0535517,
                        55.4542941
                    ],
                    [
                        86.059942,
                        55.4521993
                    ],
                    [
                        86.0671741,
                        55.4561996
                    ],
                    [
                        86.0676141,
                        55.4600926
                    ],
                    [
                        86.0746536,
                        55.4623193
                    ],
                    [
                        86.0833974,
                        55.4587061
                    ],
                    [
                        86.086065,
                        55.461311
                    ],
                    [
                        86.091993,
                        55.4611429
                    ],
                    [
                        86.1007368,
                        55.4588742
                    ],
                    [
                        86.0991066,
                        55.4556809
                    ],
                    [
                        86.1047382,
                        55.4539161
                    ],
                    [
                        86.1050346,
                        55.4503023
                    ],
                    [
                        86.1116296,
                        55.4513528
                    ],
                    [
                        86.1162238,
                        55.4505964
                    ],
                    [
                        86.1384537,
                        55.4388701
                    ],
                    [
                        86.1380092,
                        55.4495038
                    ],
                    [
                        86.1469752,
                        55.4574457
                    ],
                    [
                        86.1463084,
                        55.4589162
                    ],
                    [
                        86.1566823,
                        55.4568574
                    ],
                    [
                        86.1605958,
                        55.4648136
                    ],
                    [
                        86.1560507,
                        55.4671101
                    ],
                    [
                        86.1478135,
                        55.4712718
                    ],
                    [
                        86.1405888,
                        55.4679116
                    ],
                    [
                        86.1359575,
                        55.4631332
                    ],
                    [
                        86.1383034,
                        55.4689087
                    ],
                    [
                        86.1424413,
                        55.4790938
                    ],
                    [
                        86.1454052,
                        55.4849725
                    ],
                    [
                        86.1512407,
                        55.4891184
                    ],
                    [
                        86.1511784,
                        55.4967795
                    ],
                    [
                        86.1490481,
                        55.5009243
                    ],
                    [
                        86.1420086,
                        55.4975665
                    ],
                    [
                        86.1368216,
                        55.4911126
                    ],
                    [
                        86.1239467,
                        55.4936313
                    ],
                    [
                        86.1125538,
                        55.5022358
                    ],
                    [
                        86.1063479,
                        55.5021309
                    ],
                    [
                        86.0982895,
                        55.4975665
                    ],
                    [
                        86.0866188,
                        55.5032325
                    ],
                    [
                        86.0876375,
                        55.5093173
                    ],
                    [
                        86.0811539,
                        55.5099468
                    ],
                    [
                        86.0725396,
                        55.5054358
                    ],
                    [
                        86.0774488,
                        55.510786
                    ],
                    [
                        86.0786095,
                        55.5134152
                    ],
                    [
                        86.0779427,
                        55.5146319
                    ],
                    [
                        86.081899,
                        55.5178429
                    ],
                    [
                        86.0821266,
                        55.519282
                    ],
                    [
                        86.0838145,
                        55.5181536
                    ],
                    [
                        86.0867889,
                        55.517535
                    ],
                    [
                        86.0920701,
                        55.5170195
                    ],
                    [
                        86.0992027,
                        55.515576
                    ],
                    [
                        86.1011148,
                        55.5160743
                    ],
                    [
                        86.1065638,
                        55.5166796
                    ],
                    [
                        86.1083081,
                        55.5166414
                    ],
                    [
                        86.1097346,
                        55.516229
                    ],
                    [
                        86.1114039,
                        55.5161774
                    ],
                    [
                        86.1121931,
                        55.5159369
                    ],
                    [
                        86.1157442,
                        55.5158166
                    ],
                    [
                        86.1124662,
                        55.5147683
                    ],
                    [
                        86.1157745,
                        55.5130326
                    ],
                    [
                        86.1232105,
                        55.5129295
                    ],
                    [
                        86.1230892,
                        55.5137372
                    ],
                    [
                        86.1291898,
                        55.5146136
                    ],
                    [
                        86.1291898,
                        55.5157135
                    ],
                    [
                        86.1209039,
                        55.5156275
                    ],
                    [
                        86.1213288,
                        55.5162118
                    ],
                    [
                        86.1239087,
                        55.5168133
                    ],
                    [
                        86.1315364,
                        55.5205346
                    ],
                    [
                        86.13561,
                        55.5207116
                    ],
                    [
                        86.1361288,
                        55.5225153
                    ],
                    [
                        86.1415382,
                        55.5237318
                    ],
                    [
                        86.1378331,
                        55.5202082
                    ],
                    [
                        86.1393152,
                        55.5197467
                    ],
                    [
                        86.1453914,
                        55.5215086
                    ],
                    [
                        86.1456878,
                        55.5248643
                    ],
                    [
                        86.1489482,
                        55.5275906
                    ],
                    [
                        86.1552467,
                        55.5277164
                    ],
                    [
                        86.1591739,
                        55.5247384
                    ],
                    [
                        86.1634718,
                        55.5253257
                    ],
                    [
                        86.1627615,
                        55.5283258
                    ],
                    [
                        86.1583155,
                        55.5301712
                    ],
                    [
                        86.1509795,
                        55.5319745
                    ],
                    [
                        86.1525355,
                        55.5343648
                    ],
                    [
                        86.1567594,
                        55.5376775
                    ],
                    [
                        86.1563628,
                        55.5429029
                    ],
                    [
                        86.1584376,
                        55.5447895
                    ],
                    [
                        86.1627354,
                        55.5428191
                    ],
                    [
                        86.1604383,
                        55.54001
                    ],
                    [
                        86.1653289,
                        55.5258776
                    ],
                    [
                        86.1674037,
                        55.5284361
                    ],
                    [
                        86.1682188,
                        55.5259196
                    ],
                    [
                        86.1648102,
                        55.5232771
                    ],
                    [
                        86.1629577,
                        55.5163554
                    ],
                    [
                        86.1597714,
                        55.5114465
                    ],
                    [
                        86.1662922,
                        55.50532
                    ],
                    [
                        86.1693303,
                        55.5072924
                    ],
                    [
                        86.1811862,
                        55.5071245
                    ],
                    [
                        86.1900783,
                        55.5048165
                    ],
                    [
                        86.1943019,
                        55.5086771
                    ],
                    [
                        86.1928941,
                        55.510901
                    ],
                    [
                        86.1948948,
                        55.5125374
                    ],
                    [
                        86.2043056,
                        55.5125794
                    ],
                    [
                        86.2008969,
                        55.5098101
                    ],
                    [
                        86.2019343,
                        55.5059495
                    ],
                    [
                        86.1995631,
                        55.5039771
                    ],
                    [
                        86.1988666,
                        55.4969691
                    ],
                    [
                        86.200645,
                        55.4908572
                    ],
                    [
                        86.2044982,
                        55.48901
                    ],
                    [
                        86.2018899,
                        55.4883719
                    ],
                    [
                        86.204024,
                        55.4858192
                    ],
                    [
                        86.2019492,
                        55.4824602
                    ],
                    [
                        86.1977403,
                        55.4833
                    ],
                    [
                        86.1935314,
                        55.4832328
                    ],
                    [
                        86.1894411,
                        55.485349
                    ],
                    [
                        86.1849358,
                        55.4846436
                    ],
                    [
                        86.1831574,
                        55.4851138
                    ],
                    [
                        86.1764587,
                        55.4825274
                    ],
                    [
                        86.1745025,
                        55.4837367
                    ],
                    [
                        86.1694637,
                        55.4837031
                    ],
                    [
                        86.1685319,
                        55.4808474
                    ],
                    [
                        86.1635672,
                        55.4805114
                    ],
                    [
                        86.1555644,
                        55.4771939
                    ],
                    [
                        86.1544693,
                        55.4746713
                    ],
                    [
                        86.1595674,
                        55.4727225
                    ],
                    [
                        86.1643691,
                        55.4722521
                    ],
                    [
                        86.1622943,
                        55.4690264
                    ],
                    [
                        86.1721941,
                        55.4612969
                    ],
                    [
                        86.1832201,
                        55.4592467
                    ],
                    [
                        86.1883775,
                        55.4648258
                    ],
                    [
                        86.1925271,
                        55.4612633
                    ],
                    [
                        86.1921715,
                        55.4583391
                    ],
                    [
                        86.1975067,
                        55.4573308
                    ],
                    [
                        86.1950762,
                        55.4552131
                    ],
                    [
                        86.1894446,
                        55.4566921
                    ],
                    [
                        86.1861249,
                        55.4543727
                    ],
                    [
                        86.1807897,
                        55.4544399
                    ],
                    [
                        86.1694672,
                        55.4589778
                    ],
                    [
                        86.1637763,
                        55.4572635
                    ],
                    [
                        86.1571369,
                        55.4549105
                    ],
                    [
                        86.1541137,
                        55.4506076
                    ],
                    [
                        86.1658835,
                        55.4443319
                    ],
                    [
                        86.1676223,
                        55.441693
                    ],
                    [
                        86.1679915,
                        55.4401617
                    ],
                    [
                        86.1629129,
                        55.4395739
                    ],
                    [
                        86.1624024,
                        55.4399903
                    ],
                    [
                        86.1601753,
                        55.4394793
                    ],
                    [
                        86.1534947,
                        55.4417422
                    ],
                    [
                        86.147789,
                        55.4394724
                    ],
                    [
                        86.1465305,
                        55.4361985
                    ],
                    [
                        86.1416363,
                        55.4341322
                    ],
                    [
                        86.13875,
                        55.4304882
                    ],
                    [
                        86.1425306,
                        55.4272577
                    ],
                    [
                        86.1351552,
                        55.4176978
                    ],
                    [
                        86.1358257,
                        55.4135874
                    ],
                    [
                        86.1407162,
                        55.4061416
                    ],
                    [
                        86.1451623,
                        55.4018922
                    ],
                    [
                        86.1425688,
                        55.4000409
                    ],
                    [
                        86.144199,
                        55.3960854
                    ],
                    [
                        86.1392378,
                        55.3919826
                    ],
                    [
                        86.1392378,
                        55.3864606
                    ],
                    [
                        86.1331384,
                        55.3791513
                    ],
                    [
                        86.1391612,
                        55.3764838
                    ],
                    [
                        86.1503533,
                        55.3778041
                    ],
                    [
                        86.156803,
                        55.3811707
                    ],
                    [
                        86.1611701,
                        55.3867433
                    ],
                    [
                        86.1660641,
                        55.3850192
                    ],
                    [
                        86.1820367,
                        55.3841572
                    ],
                    [
                        86.1828334,
                        55.3808164
                    ],
                    [
                        86.1771447,
                        55.379737
                    ],
                    [
                        86.1755701,
                        55.3770005
                    ],
                    [
                        86.1510245,
                        55.3724743
                    ],
                    [
                        86.1514876,
                        55.3700004
                    ],
                    [
                        86.1631083,
                        55.3720955
                    ],
                    [
                        86.1639103,
                        55.3658487
                    ],
                    [
                        86.1742564,
                        55.368172
                    ],
                    [
                        86.1749007,
                        55.3643327
                    ],
                    [
                        86.1769851,
                        55.3624668
                    ],
                    [
                        86.1801315,
                        55.3590043
                    ],
                    [
                        86.1811482,
                        55.3592659
                    ],
                    [
                        86.1824273,
                        55.3593245
                    ],
                    [
                        86.1833971,
                        55.3594066
                    ],
                    [
                        86.1831288,
                        55.3591721
                    ],
                    [
                        86.1825718,
                        55.358873
                    ],
                    [
                        86.1824793,
                        55.3579686
                    ],
                    [
                        86.1830463,
                        55.3570317
                    ],
                    [
                        86.1835105,
                        55.3559174
                    ],
                    [
                        86.1828186,
                        55.3551555
                    ],
                    [
                        86.1740348,
                        55.3525425
                    ],
                    [
                        86.1803288,
                        55.3460448
                    ],
                    [
                        86.1796098,
                        55.3457955
                    ],
                    [
                        86.1805176,
                        55.3448194
                    ],
                    [
                        86.1889347,
                        55.347332
                    ],
                    [
                        86.1908577,
                        55.3452081
                    ],
                    [
                        86.1918249,
                        55.3453639
                    ],
                    [
                        86.1921956,
                        55.3449148
                    ],
                    [
                        86.192244,
                        55.3441815
                    ],
                    [
                        86.1929693,
                        55.3434299
                    ],
                    [
                        86.1927275,
                        55.3433382
                    ],
                    [
                        86.1937914,
                        55.3421833
                    ],
                    [
                        86.1966928,
                        55.3430174
                    ],
                    [
                        86.1972247,
                        55.3424858
                    ],
                    [
                        86.196934,
                        55.3417827
                    ],
                    [
                        86.194694,
                        55.3411383
                    ],
                    [
                        86.1951586,
                        55.3403595
                    ],
                    [
                        86.19512,
                        55.3385188
                    ],
                    [
                        86.1948105,
                        55.3384968
                    ],
                    [
                        86.1947228,
                        55.3375815
                    ],
                    [
                        86.1950813,
                        55.3375874
                    ],
                    [
                        86.1950798,
                        55.3359633
                    ],
                    [
                        86.1944337,
                        55.3359107
                    ],
                    [
                        86.1943357,
                        55.3345861
                    ],
                    [
                        86.186433,
                        55.3344154
                    ],
                    [
                        86.1775526,
                        55.3317344
                    ],
                    [
                        86.1829512,
                        55.3258362
                    ],
                    [
                        86.1778948,
                        55.3243861
                    ],
                    [
                        86.1792708,
                        55.3228779
                    ],
                    [
                        86.1800641,
                        55.3230481
                    ],
                    [
                        86.1804672,
                        55.3226189
                    ],
                    [
                        86.1797389,
                        55.3224339
                    ],
                    [
                        86.1811856,
                        55.3207716
                    ],
                    [
                        86.1732986,
                        55.3184164
                    ],
                    [
                        86.1786855,
                        55.312519
                    ],
                    [
                        86.1694993,
                        55.3105591
                    ],
                    [
                        86.1667633,
                        55.3103825
                    ],
                    [
                        86.1406672,
                        55.3050386
                    ],
                    [
                        86.1434463,
                        55.3001623
                    ],
                    [
                        86.1433795,
                        55.2989086
                    ],
                    [
                        86.1424144,
                        55.2962791
                    ],
                    [
                        86.1419156,
                        55.2963886
                    ],
                    [
                        86.1404325,
                        55.293169
                    ],
                    [
                        86.1393677,
                        55.2913327
                    ],
                    [
                        86.1397173,
                        55.2910483
                    ],
                    [
                        86.1454624,
                        55.2912464
                    ],
                    [
                        86.1479976,
                        55.2908092
                    ],
                    [
                        86.1507554,
                        55.2906119
                    ],
                    [
                        86.1513462,
                        55.2893726
                    ],
                    [
                        86.1415394,
                        55.2855165
                    ],
                    [
                        86.1417338,
                        55.2851908
                    ],
                    [
                        86.1408808,
                        55.2847858
                    ],
                    [
                        86.1423393,
                        55.283201
                    ],
                    [
                        86.1395318,
                        55.2821496
                    ],
                    [
                        86.1397583,
                        55.2817476
                    ],
                    [
                        86.1311813,
                        55.2781874
                    ],
                    [
                        86.1312312,
                        55.2777416
                    ],
                    [
                        86.1261521,
                        55.2751219
                    ],
                    [
                        86.1262822,
                        55.2743439
                    ],
                    [
                        86.1255532,
                        55.2739658
                    ],
                    [
                        86.1244086,
                        55.274689
                    ],
                    [
                        86.1205377,
                        55.2724246
                    ],
                    [
                        86.1112767,
                        55.2686424
                    ],
                    [
                        86.107943,
                        55.2676624
                    ],
                    [
                        86.1002637,
                        55.2644016
                    ],
                    [
                        86.0888174,
                        55.2595987
                    ],
                    [
                        86.0810699,
                        55.2573361
                    ],
                    [
                        86.078489,
                        55.2593306
                    ],
                    [
                        86.0855861,
                        55.2622698
                    ],
                    [
                        86.0834372,
                        55.2646343
                    ],
                    [
                        86.096627,
                        55.2702493
                    ],
                    [
                        86.0962427,
                        55.2711001
                    ],
                    [
                        86.0983405,
                        55.2722098
                    ],
                    [
                        86.0998874,
                        55.2748927
                    ],
                    [
                        86.0991968,
                        55.2790724
                    ],
                    [
                        86.1009453,
                        55.2798663
                    ],
                    [
                        86.1008707,
                        55.2807524
                    ],
                    [
                        86.1038645,
                        55.2823599
                    ],
                    [
                        86.1006211,
                        55.2839409
                    ],
                    [
                        86.1052135,
                        55.2884948
                    ],
                    [
                        86.1025232,
                        55.2893893
                    ],
                    [
                        86.1045289,
                        55.2918532
                    ],
                    [
                        86.0958531,
                        55.2945789
                    ],
                    [
                        86.0923619,
                        55.2905558
                    ],
                    [
                        86.0865434,
                        55.2937455
                    ],
                    [
                        86.0823386,
                        55.2916117
                    ],
                    [
                        86.0732922,
                        55.2964792
                    ],
                    [
                        86.0719705,
                        55.2993652
                    ],
                    [
                        86.0688195,
                        55.3024974
                    ],
                    [
                        86.0641767,
                        55.3009253
                    ],
                    [
                        86.0629328,
                        55.3015862
                    ],
                    [
                        86.0615832,
                        55.3037283
                    ],
                    [
                        86.0594032,
                        55.3071407
                    ],
                    [
                        86.0586758,
                        55.3087648
                    ],
                    [
                        86.0561988,
                        55.3081239
                    ],
                    [
                        86.0566854,
                        55.3071268
                    ],
                    [
                        86.0543172,
                        55.3051326
                    ],
                    [
                        86.0535062,
                        55.3051326
                    ],
                    [
                        86.0524032,
                        55.3044124
                    ],
                    [
                        86.0515922,
                        55.3048002
                    ],
                    [
                        86.0443515,
                        55.2997783
                    ],
                    [
                        86.0552807,
                        55.2948676
                    ],
                    [
                        86.0654903,
                        55.2890552
                    ],
                    [
                        86.0643788,
                        55.2865234
                    ],
                    [
                        86.0613743,
                        55.2879048
                    ],
                    [
                        86.0588829,
                        55.2875206
                    ],
                    [
                        86.0564716,
                        55.2863077
                    ],
                    [
                        86.053874,
                        55.2865156
                    ],
                    [
                        86.0506438,
                        55.2846831
                    ],
                    [
                        86.0484758,
                        55.2871954
                    ],
                    [
                        86.0453874,
                        55.2878753
                    ],
                    [
                        86.0415908,
                        55.2874344
                    ],
                    [
                        86.0413907,
                        55.28823
                    ],
                    [
                        86.0381985,
                        55.2885255
                    ],
                    [
                        86.0359925,
                        55.2889098
                    ],
                    [
                        86.0337901,
                        55.289121
                    ],
                    [
                        86.0296408,
                        55.2877196
                    ],
                    [
                        86.0238784,
                        55.2921783
                    ],
                    [
                        86.0210302,
                        55.294382
                    ],
                    [
                        86.01714,
                        55.292378
                    ],
                    [
                        86.0153801,
                        55.2904793
                    ],
                    [
                        86.0105636,
                        55.2927999
                    ],
                    [
                        86.0008313,
                        55.2761993
                    ],
                    [
                        86.0086118,
                        55.2739199
                    ],
                    [
                        86.007278,
                        55.2672077
                    ],
                    [
                        85.9882343,
                        55.2732867
                    ],
                    [
                        85.9802315,
                        55.2700363
                    ],
                    [
                        85.9749704,
                        55.270965
                    ],
                    [
                        85.9641517,
                        55.2670389
                    ],
                    [
                        85.9553338,
                        55.2685587
                    ],
                    [
                        85.9502209,
                        55.2707539
                    ],
                    [
                        85.9361419,
                        55.256525
                    ],
                    [
                        85.929547,
                        55.2588898
                    ],
                    [
                        85.934734,
                        55.2639146
                    ],
                    [
                        85.929547,
                        55.2657723
                    ],
                    [
                        85.928806,
                        55.2724003
                    ],
                    [
                        85.9348081,
                        55.2763259
                    ],
                    [
                        85.9402174,
                        55.2754395
                    ],
                    [
                        85.9403656,
                        55.2775499
                    ],
                    [
                        85.9430083,
                        55.2774359
                    ],
                    [
                        85.9466641,
                        55.2821503
                    ],
                    [
                        85.9500861,
                        55.2813304
                    ],
                    [
                        85.9519095,
                        55.2872762
                    ],
                    [
                        85.9540772,
                        55.2880607
                    ],
                    [
                        85.9514806,
                        55.2921088
                    ],
                    [
                        85.9434037,
                        55.2905899
                    ],
                    [
                        85.9360678,
                        55.2860749
                    ],
                    [
                        85.9285096,
                        55.2853997
                    ],
                    [
                        85.9296211,
                        55.2826145
                    ],
                    [
                        85.9208773,
                        55.2834163
                    ],
                    [
                        85.9247305,
                        55.288016
                    ],
                    [
                        85.9293988,
                        55.2872143
                    ],
                    [
                        85.9419217,
                        55.2918557
                    ],
                    [
                        85.9486648,
                        55.2927417
                    ],
                    [
                        85.9613047,
                        55.2999584
                    ],
                    [
                        85.9610083,
                        55.3026581
                    ],
                    [
                        85.9545616,
                        55.3015192
                    ],
                    [
                        85.9482631,
                        55.297343
                    ],
                    [
                        85.9300344,
                        55.2995366
                    ],
                    [
                        85.9237359,
                        55.3035017
                    ],
                    [
                        85.9292193,
                        55.3081412
                    ],
                    [
                        85.928835,
                        55.3119816
                    ],
                    [
                        85.9168011,
                        55.3126226
                    ],
                    [
                        85.9096282,
                        55.3155238
                    ]
                ],
                [
                    [
                        86.0831282,
                        55.5198529
                    ],
                    [
                        86.0837937,
                        55.5210727
                    ],
                    [
                        86.0855206,
                        55.5219158
                    ],
                    [
                        86.087257,
                        55.5223763
                    ],
                    [
                        86.0879897,
                        55.5228808
                    ],
                    [
                        86.0882472,
                        55.5237104
                    ],
                    [
                        86.0893288,
                        55.5244365
                    ],
                    [
                        86.0907071,
                        55.5272076
                    ],
                    [
                        86.0919271,
                        55.5286065
                    ],
                    [
                        86.0938677,
                        55.5299141
                    ],
                    [
                        86.0948024,
                        55.5315282
                    ],
                    [
                        86.0969413,
                        55.5333394
                    ],
                    [
                        86.097987,
                        55.5337877
                    ],
                    [
                        86.0978009,
                        55.5343207
                    ],
                    [
                        86.1001711,
                        55.5350738
                    ],
                    [
                        86.1020977,
                        55.5350738
                    ],
                    [
                        86.1076493,
                        55.5346722
                    ],
                    [
                        86.108283,
                        55.5339907
                    ],
                    [
                        86.1117052,
                        55.5338903
                    ],
                    [
                        86.1151781,
                        55.5333523
                    ],
                    [
                        86.1186337,
                        55.5335237
                    ],
                    [
                        86.1217706,
                        55.533584
                    ],
                    [
                        86.1277119,
                        55.5344246
                    ],
                    [
                        86.1288804,
                        55.5339651
                    ],
                    [
                        86.1304379,
                        55.532669
                    ],
                    [
                        86.1326084,
                        55.53214
                    ],
                    [
                        86.1357771,
                        55.5315841
                    ],
                    [
                        86.1388508,
                        55.530526
                    ],
                    [
                        86.1413409,
                        55.5285469
                    ],
                    [
                        86.1409765,
                        55.5278026
                    ],
                    [
                        86.1345696,
                        55.5257419
                    ],
                    [
                        86.123289,
                        55.529033
                    ],
                    [
                        86.1231939,
                        55.5285846
                    ],
                    [
                        86.1240019,
                        55.5274547
                    ],
                    [
                        86.1233682,
                        55.5238585
                    ],
                    [
                        86.1214511,
                        55.5232935
                    ],
                    [
                        86.1208613,
                        55.5221751
                    ],
                    [
                        86.1212772,
                        55.5185089
                    ],
                    [
                        86.1180632,
                        55.5166956
                    ],
                    [
                        86.1154966,
                        55.516274
                    ],
                    [
                        86.1150529,
                        55.5167135
                    ],
                    [
                        86.1118367,
                        55.516561
                    ],
                    [
                        86.1075431,
                        55.5169916
                    ],
                    [
                        86.1001442,
                        55.515969
                    ],
                    [
                        86.0968487,
                        55.5163457
                    ],
                    [
                        86.0933315,
                        55.5173145
                    ],
                    [
                        86.0894815,
                        55.5175298
                    ],
                    [
                        86.0841422,
                        55.5186869
                    ],
                    [
                        86.0831282,
                        55.5198529
                    ]
                ],
                [
                    [
                        86.0705012,
                        55.5261483
                    ],
                    [
                        86.0740985,
                        55.5257761
                    ],
                    [
                        86.0760951,
                        55.5264865
                    ],
                    [
                        86.0768061,
                        55.5267395
                    ],
                    [
                        86.0807515,
                        55.528272
                    ],
                    [
                        86.0834978,
                        55.528491
                    ],
                    [
                        86.0869404,
                        55.5283158
                    ],
                    [
                        86.0864375,
                        55.5261921
                    ],
                    [
                        86.0869404,
                        55.5259732
                    ],
                    [
                        86.0861668,
                        55.5250317
                    ],
                    [
                        86.0851611,
                        55.5249004
                    ],
                    [
                        86.084078,
                        55.5233239
                    ],
                    [
                        86.0842328,
                        55.5225356
                    ],
                    [
                        86.0833431,
                        55.5222072
                    ],
                    [
                        86.082028,
                        55.5194043
                    ],
                    [
                        86.0818197,
                        55.5178955
                    ],
                    [
                        86.0783674,
                        55.5151812
                    ],
                    [
                        86.0748588,
                        55.5149961
                    ],
                    [
                        86.0739874,
                        55.515467
                    ],
                    [
                        86.0731358,
                        55.5165098
                    ],
                    [
                        86.0727131,
                        55.5221054
                    ],
                    [
                        86.0717823,
                        55.5221166
                    ],
                    [
                        86.0713849,
                        55.5251036
                    ],
                    [
                        86.0705012,
                        55.5261483
                    ]
                ]
            ],
            "longitude": 86.087234,
            "latitude": 55.355125
        },
        "7": {
            "name": "ЛЕНИНСК-КУЗНЕЦКИЙ",
            "population": 97666,
            "type": "city",
            "poly": [
                [
                    86.1264815,
                    54.6460797
                ],
                [
                    86.129366,
                    54.6499292
                ],
                [
                    86.1315252,
                    54.6528109
                ],
                [
                    86.1323429,
                    54.6668351
                ],
                [
                    86.1349786,
                    54.6701213
                ],
                [
                    86.1388577,
                    54.6741803
                ],
                [
                    86.1401507,
                    54.6793068
                ],
                [
                    86.1407306,
                    54.6849878
                ],
                [
                    86.1408819,
                    54.688268
                ],
                [
                    86.1438327,
                    54.6901047
                ],
                [
                    86.15433,
                    54.7044334
                ],
                [
                    86.1664665,
                    54.7156199
                ],
                [
                    86.1822336,
                    54.7197695
                ],
                [
                    86.2011163,
                    54.7199281
                ],
                [
                    86.2036277,
                    54.7181146
                ],
                [
                    86.2171667,
                    54.7084502
                ],
                [
                    86.2245945,
                    54.7051171
                ],
                [
                    86.2408294,
                    54.7144901
                ],
                [
                    86.2479404,
                    54.7145409
                ],
                [
                    86.2522041,
                    54.7097103
                ],
                [
                    86.2470476,
                    54.7062052
                ],
                [
                    86.2482256,
                    54.7058113
                ],
                [
                    86.2466141,
                    54.6964513
                ],
                [
                    86.2464835,
                    54.6956924
                ],
                [
                    86.248779,
                    54.6903307
                ],
                [
                    86.239151,
                    54.6818503
                ],
                [
                    86.2379708,
                    54.6796731
                ],
                [
                    86.2345419,
                    54.6753818
                ],
                [
                    86.2302676,
                    54.6735865
                ],
                [
                    86.2288385,
                    54.6728693
                ],
                [
                    86.2261434,
                    54.6717377
                ],
                [
                    86.2237294,
                    54.6714039
                ],
                [
                    86.2310143,
                    54.6613048
                ],
                [
                    86.2328639,
                    54.6553172
                ],
                [
                    86.2348166,
                    54.6526036
                ],
                [
                    86.2352822,
                    54.6500512
                ],
                [
                    86.236722,
                    54.6479481
                ],
                [
                    86.2376962,
                    54.646236
                ],
                [
                    86.2396746,
                    54.644535
                ],
                [
                    86.2501824,
                    54.6401194
                ],
                [
                    86.2529998,
                    54.6298946
                ],
                [
                    86.2315689,
                    54.6263953
                ],
                [
                    86.2236339,
                    54.6245729
                ],
                [
                    86.2193199,
                    54.6217718
                ],
                [
                    86.2132741,
                    54.6200024
                ],
                [
                    86.2057275,
                    54.6185765
                ],
                [
                    86.1847157,
                    54.6149666
                ],
                [
                    86.1639348,
                    54.6229882
                ],
                [
                    86.1700173,
                    54.6269835
                ],
                [
                    86.1743237,
                    54.6289748
                ],
                [
                    86.1717377,
                    54.6312202
                ],
                [
                    86.1583292,
                    54.6311394
                ],
                [
                    86.1540045,
                    54.6311133
                ],
                [
                    86.1506114,
                    54.633923
                ],
                [
                    86.1407048,
                    54.6421249
                ],
                [
                    86.129437,
                    54.6427662
                ],
                [
                    86.1264815,
                    54.6460797
                ]
            ],
            "longitude": 86.166115,
            "latitude": 54.665443
        },
        "8": {
            "name": "КИСЕЛЁВСК",
            "population": 92210,
            "type": "city",
            "poly": [
                [
                    86.4755159,
                    54.0546225
                ],
                [
                    86.4864252,
                    54.0662438
                ],
                [
                    86.4981995,
                    54.0662438
                ],
                [
                    86.5135783,
                    54.0717431
                ],
                [
                    86.5181438,
                    54.0778055
                ],
                [
                    86.5316002,
                    54.0793562
                ],
                [
                    86.5553891,
                    54.072448
                ],
                [
                    86.5686053,
                    54.073576
                ],
                [
                    86.5911928,
                    54.0861222
                ],
                [
                    86.6394916,
                    54.0883774
                ],
                [
                    86.6515062,
                    54.0810478
                ],
                [
                    86.6402125,
                    54.0742809
                ],
                [
                    86.6438169,
                    54.0707561
                ],
                [
                    86.6375692,
                    54.0658208
                ],
                [
                    86.6582344,
                    54.0476256
                ],
                [
                    86.6805816,
                    54.0556663
                ],
                [
                    86.6951226,
                    54.0388358
                ],
                [
                    86.7050915,
                    54.0415587
                ],
                [
                    86.7091568,
                    54.0465327
                ],
                [
                    86.7117762,
                    54.046644
                ],
                [
                    86.7157883,
                    54.040637
                ],
                [
                    86.7233935,
                    54.0422728
                ],
                [
                    86.7223573,
                    54.0394833
                ],
                [
                    86.7277953,
                    54.0370413
                ],
                [
                    86.7316381,
                    54.0372453
                ],
                [
                    86.743499,
                    54.0424328
                ],
                [
                    86.7453583,
                    54.0401066
                ],
                [
                    86.7519485,
                    54.0342209
                ],
                [
                    86.7702108,
                    54.0439574
                ],
                [
                    86.7771792,
                    54.0452272
                ],
                [
                    86.7956818,
                    54.0528452
                ],
                [
                    86.8009682,
                    54.0486131
                ],
                [
                    86.7860701,
                    54.0425464
                ],
                [
                    86.7882327,
                    54.03662
                ],
                [
                    86.7740554,
                    54.028011
                ],
                [
                    86.7680481,
                    54.0292813
                ],
                [
                    86.7281596,
                    54.0097993
                ],
                [
                    86.7335061,
                    53.9892839
                ],
                [
                    86.7434181,
                    53.9903434
                ],
                [
                    86.7596379,
                    53.9733872
                ],
                [
                    86.757235,
                    53.968617
                ],
                [
                    86.7419163,
                    53.9698538
                ],
                [
                    86.7323046,
                    53.9675569
                ],
                [
                    86.7186829,
                    53.9626598
                ],
                [
                    86.7046709,
                    53.9574844
                ],
                [
                    86.7034695,
                    53.9495308
                ],
                [
                    86.6965611,
                    53.9419292
                ],
                [
                    86.6680262,
                    53.9422828
                ],
                [
                    86.6403927,
                    53.9357409
                ],
                [
                    86.6400923,
                    53.9449347
                ],
                [
                    86.6178652,
                    53.9569542
                ],
                [
                    86.6133355,
                    53.9478342
                ],
                [
                    86.6154623,
                    53.9438739
                ],
                [
                    86.6066739,
                    53.9390226
                ],
                [
                    86.6052568,
                    53.9389689
                ],
                [
                    86.5996635,
                    53.938757
                ],
                [
                    86.5963547,
                    53.9427265
                ],
                [
                    86.5821426,
                    53.9431531
                ],
                [
                    86.5696252,
                    53.9452319
                ],
                [
                    86.5681769,
                    53.9477631
                ],
                [
                    86.5689703,
                    53.9521107
                ],
                [
                    86.5755565,
                    53.9532048
                ],
                [
                    86.5788177,
                    53.9569542
                ],
                [
                    86.5962389,
                    53.9610189
                ],
                [
                    86.5932353,
                    53.9728572
                ],
                [
                    86.5580925,
                    53.9800999
                ],
                [
                    86.5496822,
                    53.9859284
                ],
                [
                    86.535565,
                    53.9841623
                ],
                [
                    86.5217482,
                    53.9755071
                ],
                [
                    86.4974186,
                    53.9737405
                ],
                [
                    86.4943428,
                    53.9784253
                ],
                [
                    86.5075589,
                    53.9929781
                ],
                [
                    86.4931414,
                    54.015433
                ],
                [
                    86.5025128,
                    54.017692
                ],
                [
                    86.503474,
                    54.0222095
                ],
                [
                    86.5118842,
                    54.0162802
                ],
                [
                    86.5123648,
                    54.0027242
                ],
                [
                    86.5178915,
                    54.0011706
                ],
                [
                    86.5299061,
                    54.0104912
                ],
                [
                    86.530627,
                    54.0264443
                ],
                [
                    86.5361537,
                    54.0207978
                ],
                [
                    86.5452849,
                    54.0303963
                ],
                [
                    86.5226133,
                    54.0463841
                ],
                [
                    86.5047355,
                    54.0463841
                ],
                [
                    86.5003141,
                    54.0420949
                ],
                [
                    86.483013,
                    54.0439009
                ],
                [
                    86.4755159,
                    54.0546225
                ]
            ],
            "longitude": 86.6354771,
            "latitude": 54.0049872
        },
        "9": {
            "name": "ПРОКОПЬЕВСК",
            "population": 198438,
            "type": "city",
            "poly": [
                [
                    86.5747941,
                    53.8671523
                ],
                [
                    86.5816847,
                    53.8751617
                ],
                [
                    86.5748925,
                    53.8819511
                ],
                [
                    86.5753847,
                    53.8845041
                ],
                [
                    86.5995019,
                    53.8893775
                ],
                [
                    86.6121019,
                    53.8979047
                ],
                [
                    86.6307066,
                    53.8998767
                ],
                [
                    86.6308205,
                    53.9003837
                ],
                [
                    86.6313454,
                    53.9027203
                ],
                [
                    86.6315926,
                    53.9038205
                ],
                [
                    86.6319474,
                    53.904056
                ],
                [
                    86.6323983,
                    53.9043553
                ],
                [
                    86.6325782,
                    53.9044746
                ],
                [
                    86.6393691,
                    53.9089816
                ],
                [
                    86.6277535,
                    53.9237656
                ],
                [
                    86.6279504,
                    53.9320539
                ],
                [
                    86.6201738,
                    53.9394714
                ],
                [
                    86.6195832,
                    53.9416732
                ],
                [
                    86.6245051,
                    53.9431797
                ],
                [
                    86.6226348,
                    53.9453234
                ],
                [
                    86.6154623,
                    53.9438739
                ],
                [
                    86.6133355,
                    53.9478342
                ],
                [
                    86.6178652,
                    53.9569542
                ],
                [
                    86.6400923,
                    53.9449347
                ],
                [
                    86.6403927,
                    53.9357409
                ],
                [
                    86.6680263,
                    53.9422828
                ],
                [
                    86.6965611,
                    53.9419292
                ],
                [
                    86.7034695,
                    53.9495308
                ],
                [
                    86.7046709,
                    53.9574844
                ],
                [
                    86.7186829,
                    53.9626598
                ],
                [
                    86.7323046,
                    53.9675569
                ],
                [
                    86.7419163,
                    53.9698538
                ],
                [
                    86.757235,
                    53.968617
                ],
                [
                    86.7601322,
                    53.9655601
                ],
                [
                    86.7595641,
                    53.9589771
                ],
                [
                    86.7654703,
                    53.9571671
                ],
                [
                    86.7609176,
                    53.9541262
                ],
                [
                    86.7604254,
                    53.9511575
                ],
                [
                    86.7542731,
                    53.9447125
                ],
                [
                    86.7636246,
                    53.9449298
                ],
                [
                    86.7695309,
                    53.9469575
                ],
                [
                    86.7711305,
                    53.9421777
                ],
                [
                    86.7810973,
                    53.9427571
                ],
                [
                    86.7755602,
                    53.9386287
                ],
                [
                    86.793279,
                    53.9333409
                ],
                [
                    86.7966012,
                    53.9344275
                ],
                [
                    86.8125973,
                    53.9300809
                ],
                [
                    86.8145661,
                    53.9100083
                ],
                [
                    86.8203493,
                    53.9103707
                ],
                [
                    86.8213337,
                    53.907254
                ],
                [
                    86.8300375,
                    53.9006624
                ],
                [
                    86.8331995,
                    53.9021174
                ],
                [
                    86.8395505,
                    53.8974329
                ],
                [
                    86.8381645,
                    53.8966905
                ],
                [
                    86.8501345,
                    53.8894881
                ],
                [
                    86.8501975,
                    53.8883371
                ],
                [
                    86.8379755,
                    53.8855523
                ],
                [
                    86.8383386,
                    53.8842682
                ],
                [
                    86.8383535,
                    53.8842155
                ],
                [
                    86.8432675,
                    53.8838813
                ],
                [
                    86.8432675,
                    53.8827302
                ],
                [
                    86.8384411,
                    53.8793659
                ],
                [
                    86.8415173,
                    53.8775525
                ],
                [
                    86.8422556,
                    53.8740705
                ],
                [
                    86.8326579,
                    53.8705157
                ],
                [
                    86.8288435,
                    53.8661625
                ],
                [
                    86.8341345,
                    53.8540436
                ],
                [
                    86.8307463,
                    53.839181
                ],
                [
                    86.8346523,
                    53.8342366
                ],
                [
                    86.8291713,
                    53.8322661
                ],
                [
                    86.8296123,
                    53.8302956
                ],
                [
                    86.8372983,
                    53.8317084
                ],
                [
                    86.8435353,
                    53.8361326
                ],
                [
                    86.8490163,
                    53.8360954
                ],
                [
                    86.8509063,
                    53.8333815
                ],
                [
                    86.8483105,
                    53.8238151
                ],
                [
                    86.8424515,
                    53.8147776
                ],
                [
                    86.8434861,
                    53.8052184
                ],
                [
                    86.8383673,
                    53.8032187
                ],
                [
                    86.8400255,
                    53.8002637
                ],
                [
                    86.8502402,
                    53.7988467
                ],
                [
                    86.8494806,
                    53.7956339
                ],
                [
                    86.8516328,
                    53.794696
                ],
                [
                    86.8524739,
                    53.7917059
                ],
                [
                    86.8542828,
                    53.7901418
                ],
                [
                    86.8639474,
                    53.7907324
                ],
                [
                    86.8664429,
                    53.7866418
                ],
                [
                    86.8710568,
                    53.7856965
                ],
                [
                    86.8710568,
                    53.7828676
                ],
                [
                    86.8653872,
                    53.7799693
                ],
                [
                    86.8519678,
                    53.77814
                ],
                [
                    86.8340403,
                    53.769735
                ],
                [
                    86.8340521,
                    53.7516861
                ],
                [
                    86.8323511,
                    53.7514254
                ],
                [
                    86.8307761,
                    53.7543309
                ],
                [
                    86.8290955,
                    53.7787511
                ],
                [
                    86.8176255,
                    53.7870188
                ],
                [
                    86.8175902,
                    53.7936878
                ],
                [
                    86.8167032,
                    53.7944023
                ],
                [
                    86.8105619,
                    53.7930283
                ],
                [
                    86.8044509,
                    53.7949634
                ],
                [
                    86.7850487,
                    53.7950531
                ],
                [
                    86.7748783,
                    53.7921123
                ],
                [
                    86.7717732,
                    53.7938988
                ],
                [
                    86.7686739,
                    53.7989383
                ],
                [
                    86.7669669,
                    53.7974094
                ],
                [
                    86.7637548,
                    53.7967474
                ],
                [
                    86.7626662,
                    53.7944849
                ],
                [
                    86.7592793,
                    53.7954852
                ],
                [
                    86.7543602,
                    53.7950803
                ],
                [
                    86.7532945,
                    53.7876862
                ],
                [
                    86.7499915,
                    53.7870276
                ],
                [
                    86.746643,
                    53.7896407
                ],
                [
                    86.7495057,
                    53.7909984
                ],
                [
                    86.7485861,
                    53.796535
                ],
                [
                    86.7407621,
                    53.798876
                ],
                [
                    86.7348786,
                    53.7989126
                ],
                [
                    86.7367365,
                    53.799827
                ],
                [
                    86.737048,
                    53.8037518
                ],
                [
                    86.7342256,
                    53.8072042
                ],
                [
                    86.7318063,
                    53.8076209
                ],
                [
                    86.7207829,
                    53.8036006
                ],
                [
                    86.7124608,
                    53.8016194
                ],
                [
                    86.7102996,
                    53.8048768
                ],
                [
                    86.715138,
                    53.8137143
                ],
                [
                    86.7223896,
                    53.818374
                ],
                [
                    86.7231456,
                    53.8205162
                ],
                [
                    86.7198192,
                    53.8227178
                ],
                [
                    86.7195672,
                    53.8250085
                ],
                [
                    86.7334776,
                    53.8280725
                ],
                [
                    86.7328728,
                    53.8313148
                ],
                [
                    86.7288408,
                    53.8361926
                ],
                [
                    86.7181302,
                    53.8339604
                ],
                [
                    86.7145175,
                    53.8336558
                ],
                [
                    86.702985,
                    53.8386053
                ],
                [
                    86.6964532,
                    53.8370588
                ],
                [
                    86.6969773,
                    53.8342036
                ],
                [
                    86.6937921,
                    53.8323477
                ],
                [
                    86.6924615,
                    53.8279692
                ],
                [
                    86.6862119,
                    53.8289925
                ],
                [
                    86.6839136,
                    53.8380343
                ],
                [
                    86.6740554,
                    53.8350186
                ],
                [
                    86.6596788,
                    53.835197
                ],
                [
                    86.6512998,
                    53.8371673
                ],
                [
                    86.644291,
                    53.8329849
                ],
                [
                    86.6362585,
                    53.8368421
                ],
                [
                    86.6342898,
                    53.8367491
                ],
                [
                    86.6323998,
                    53.8385614
                ],
                [
                    86.633581,
                    53.8406988
                ],
                [
                    86.628541,
                    53.8438119
                ],
                [
                    86.6216907,
                    53.8408171
                ],
                [
                    86.6154685,
                    53.8380967
                ],
                [
                    86.6078297,
                    53.8316372
                ],
                [
                    86.600191,
                    53.8351227
                ],
                [
                    86.6063335,
                    53.8386079
                ],
                [
                    86.6090897,
                    53.8362844
                ],
                [
                    86.6123185,
                    53.8376785
                ],
                [
                    86.6127122,
                    53.8395837
                ],
                [
                    86.6164923,
                    53.8429291
                ],
                [
                    86.6095622,
                    53.8553792
                ],
                [
                    86.6051522,
                    53.8578874
                ],
                [
                    86.605231,
                    53.8612778
                ],
                [
                    86.5876697,
                    53.8634141
                ],
                [
                    86.578105,
                    53.8634769
                ],
                [
                    86.5752863,
                    53.8634954
                ],
                [
                    86.5747941,
                    53.8671523
                ]
            ],
            "longitude": 86.737663,
            "latitude": 53.890972
        },
        "10": {
            "name": "НОВОКУЗНЕЦК",
            "population": 551253,
            "type": "city",
            "poly": [
                [
                    86.8592186,
                    53.6511245
                ],
                [
                    86.8614215,
                    53.6516233
                ],
                [
                    86.8628818,
                    53.6512565
                ],
                [
                    86.8655797,
                    53.652078
                ],
                [
                    86.8668668,
                    53.6529582
                ],
                [
                    86.8671885,
                    53.6540877
                ],
                [
                    86.8661737,
                    53.6551439
                ],
                [
                    86.8665697,
                    53.6570948
                ],
                [
                    86.8646639,
                    53.6576522
                ],
                [
                    86.866941,
                    53.6579602
                ],
                [
                    86.8679558,
                    53.6588109
                ],
                [
                    86.8668668,
                    53.659427
                ],
                [
                    86.8669658,
                    53.6605563
                ],
                [
                    86.8639461,
                    53.6608644
                ],
                [
                    86.8628592,
                    53.6618208
                ],
                [
                    86.8640946,
                    53.6625803
                ],
                [
                    86.8632531,
                    53.6638416
                ],
                [
                    86.8634263,
                    53.6649122
                ],
                [
                    86.8660252,
                    53.6682851
                ],
                [
                    86.8659209,
                    53.6688071
                ],
                [
                    86.8661271,
                    53.6694263
                ],
                [
                    86.8685512,
                    53.6711937
                ],
                [
                    86.8722181,
                    53.6722001
                ],
                [
                    86.8731504,
                    53.6737342
                ],
                [
                    86.873109,
                    53.6746301
                ],
                [
                    86.873399,
                    53.6754401
                ],
                [
                    86.8733783,
                    53.6778331
                ],
                [
                    86.876258,
                    53.6793056
                ],
                [
                    86.8760923,
                    53.6802259
                ],
                [
                    86.8766517,
                    53.6804468
                ],
                [
                    86.8780397,
                    53.68014
                ],
                [
                    86.8892271,
                    53.6856247
                ],
                [
                    86.8941993,
                    53.683588
                ],
                [
                    86.8968304,
                    53.6812935
                ],
                [
                    86.8977005,
                    53.6811462
                ],
                [
                    86.8991714,
                    53.6802996
                ],
                [
                    86.9008288,
                    53.680275
                ],
                [
                    86.9022376,
                    53.6799192
                ],
                [
                    86.904848,
                    53.6784712
                ],
                [
                    86.9097373,
                    53.6784957
                ],
                [
                    86.9121612,
                    53.6791215
                ],
                [
                    86.9243224,
                    53.6831094
                ],
                [
                    86.9237837,
                    53.6834162
                ],
                [
                    86.9247574,
                    53.6840051
                ],
                [
                    86.9254825,
                    53.6854161
                ],
                [
                    86.9271605,
                    53.6864467
                ],
                [
                    86.9279479,
                    53.6872442
                ],
                [
                    86.9283622,
                    53.6875018
                ],
                [
                    86.9283208,
                    53.6882379
                ],
                [
                    86.9293152,
                    53.6894893
                ],
                [
                    86.9325472,
                    53.692041
                ],
                [
                    86.9340388,
                    53.6909737
                ],
                [
                    86.9339351,
                    53.6907529
                ],
                [
                    86.9344117,
                    53.6907652
                ],
                [
                    86.9357169,
                    53.6896856
                ],
                [
                    86.9382859,
                    53.688422
                ],
                [
                    86.9377277,
                    53.6874467
                ],
                [
                    86.9366504,
                    53.6870295
                ],
                [
                    86.9387014,
                    53.6866369
                ],
                [
                    86.9387843,
                    53.686502
                ],
                [
                    86.9384321,
                    53.6863302
                ],
                [
                    86.940856,
                    53.68541
                ],
                [
                    86.9356974,
                    53.681226
                ],
                [
                    86.9374998,
                    53.6806984
                ],
                [
                    86.9463461,
                    53.6844162
                ],
                [
                    86.9464083,
                    53.6858148
                ],
                [
                    86.9486251,
                    53.6870541
                ],
                [
                    86.9508625,
                    53.6880233
                ],
                [
                    86.9539908,
                    53.6898022
                ],
                [
                    86.9552339,
                    53.6901211
                ],
                [
                    86.9584451,
                    53.6903542
                ],
                [
                    86.961677,
                    53.689888
                ],
                [
                    86.9652611,
                    53.6883055
                ],
                [
                    86.9682237,
                    53.6884527
                ],
                [
                    86.9700883,
                    53.6879619
                ],
                [
                    86.97187,
                    53.6864406
                ],
                [
                    86.9712277,
                    53.6860603
                ],
                [
                    86.9702954,
                    53.6860235
                ],
                [
                    86.9659448,
                    53.685091
                ],
                [
                    86.9668149,
                    53.6835572
                ],
                [
                    86.9665042,
                    53.6833242
                ],
                [
                    86.9664834,
                    53.6826984
                ],
                [
                    86.9663799,
                    53.6825635
                ],
                [
                    86.966442,
                    53.6819254
                ],
                [
                    86.9668978,
                    53.6817291
                ],
                [
                    86.9688452,
                    53.6817659
                ],
                [
                    86.9691786,
                    53.6816403
                ],
                [
                    86.9690175,
                    53.6811978
                ],
                [
                    86.969706,
                    53.6808941
                ],
                [
                    86.9719035,
                    53.6804131
                ],
                [
                    86.9771904,
                    53.6816077
                ],
                [
                    86.981579,
                    53.6835037
                ],
                [
                    86.9803199,
                    53.6852108
                ],
                [
                    86.9824642,
                    53.6858069
                ],
                [
                    86.9837826,
                    53.6857548
                ],
                [
                    86.9851597,
                    53.6866918
                ],
                [
                    86.9872132,
                    53.687335
                ],
                [
                    86.9891818,
                    53.6895941
                ],
                [
                    86.9921502,
                    53.6902837
                ],
                [
                    86.9940731,
                    53.691176
                ],
                [
                    86.9955064,
                    53.6935958
                ],
                [
                    86.9949688,
                    53.694258
                ],
                [
                    86.998052,
                    53.6962683
                ],
                [
                    86.9974358,
                    53.6971315
                ],
                [
                    86.9971043,
                    53.6970518
                ],
                [
                    86.9966795,
                    53.6975485
                ],
                [
                    86.9933545,
                    53.6993086
                ],
                [
                    86.9930851,
                    53.7007007
                ],
                [
                    86.9921839,
                    53.7007804
                ],
                [
                    86.9906094,
                    53.702289
                ],
                [
                    86.9896461,
                    53.7027918
                ],
                [
                    86.9877193,
                    53.704288
                ],
                [
                    86.9884755,
                    53.7064341
                ],
                [
                    86.9877297,
                    53.709512
                ],
                [
                    86.9910859,
                    53.7108057
                ],
                [
                    86.9933441,
                    53.7120747
                ],
                [
                    86.9946803,
                    53.713356
                ],
                [
                    86.9956852,
                    53.7160411
                ],
                [
                    86.9968143,
                    53.7171323
                ],
                [
                    86.9968143,
                    53.7179537
                ],
                [
                    86.9971561,
                    53.7187138
                ],
                [
                    86.999839,
                    53.7206691
                ],
                [
                    86.9993625,
                    53.721325
                ],
                [
                    87.0025634,
                    53.7228573
                ],
                [
                    87.0030191,
                    53.7238196
                ],
                [
                    87.0038375,
                    53.7245121
                ],
                [
                    87.0038582,
                    53.7250515
                ],
                [
                    87.007577,
                    53.7284002
                ],
                [
                    87.0086464,
                    53.7299689
                ],
                [
                    87.0093787,
                    53.7306795
                ],
                [
                    87.0096572,
                    53.7311475
                ],
                [
                    87.0124406,
                    53.7326034
                ],
                [
                    87.0137004,
                    53.7347352
                ],
                [
                    87.0157074,
                    53.7366242
                ],
                [
                    87.0163373,
                    53.7367888
                ],
                [
                    87.0177436,
                    53.7379413
                ],
                [
                    87.0177143,
                    53.7384785
                ],
                [
                    87.0184175,
                    53.7391023
                ],
                [
                    87.0199118,
                    53.7399255
                ],
                [
                    87.01685,
                    53.7401681
                ],
                [
                    87.016015,
                    53.7404193
                ],
                [
                    87.0155169,
                    53.7407399
                ],
                [
                    87.0137883,
                    53.7411645
                ],
                [
                    87.013173,
                    53.741407
                ],
                [
                    87.0117227,
                    53.7413724
                ],
                [
                    87.0091699,
                    53.7409664
                ],
                [
                    87.0074852,
                    53.7400393
                ],
                [
                    87.0065037,
                    53.7398573
                ],
                [
                    87.004819,
                    53.7390342
                ],
                [
                    87.0040426,
                    53.738341
                ],
                [
                    87.0025484,
                    53.7377952
                ],
                [
                    87.0018745,
                    53.7376738
                ],
                [
                    87.0004975,
                    53.7369806
                ],
                [
                    86.9999115,
                    53.737102
                ],
                [
                    86.9990911,
                    53.7370153
                ],
                [
                    86.9983311,
                    53.7364668
                ],
                [
                    86.9977141,
                    53.7362528
                ],
                [
                    86.9968205,
                    53.7351436
                ],
                [
                    86.9957218,
                    53.734537
                ],
                [
                    86.9916053,
                    53.7329426
                ],
                [
                    86.9897594,
                    53.7348057
                ],
                [
                    86.9921034,
                    53.7356202
                ],
                [
                    86.9916053,
                    53.7364867
                ],
                [
                    86.9897594,
                    53.7366774
                ],
                [
                    86.9891002,
                    53.7367034
                ],
                [
                    86.9886461,
                    53.7372319
                ],
                [
                    86.9886314,
                    53.7380811
                ],
                [
                    86.9883092,
                    53.7390949
                ],
                [
                    86.9887633,
                    53.7393461
                ],
                [
                    86.9889537,
                    53.7404205
                ],
                [
                    86.9871958,
                    53.7405938
                ],
                [
                    86.9883678,
                    53.7412176
                ],
                [
                    86.9889244,
                    53.7416855
                ],
                [
                    86.9889244,
                    53.742058
                ],
                [
                    86.9880748,
                    53.7423526
                ],
                [
                    86.9881627,
                    53.7425172
                ],
                [
                    86.9885289,
                    53.7426212
                ],
                [
                    86.9893639,
                    53.7427338
                ],
                [
                    86.990229,
                    53.7422974
                ],
                [
                    86.9904361,
                    53.7420095
                ],
                [
                    86.9918967,
                    53.7422729
                ],
                [
                    86.993233,
                    53.7419237
                ],
                [
                    86.993378,
                    53.7417399
                ],
                [
                    86.993927,
                    53.7416235
                ],
                [
                    86.9940824,
                    53.7419421
                ],
                [
                    86.9944864,
                    53.7420462
                ],
                [
                    86.9949422,
                    53.7419666
                ],
                [
                    86.9954705,
                    53.7416664
                ],
                [
                    86.995833,
                    53.741746
                ],
                [
                    86.9958434,
                    53.7420585
                ],
                [
                    86.9956258,
                    53.7423648
                ],
                [
                    86.9958019,
                    53.7428426
                ],
                [
                    86.9964753,
                    53.7430203
                ],
                [
                    86.9970036,
                    53.7429835
                ],
                [
                    86.9974283,
                    53.7428059
                ],
                [
                    86.9971693,
                    53.7420585
                ],
                [
                    86.9974386,
                    53.7419972
                ],
                [
                    86.9978426,
                    53.7420769
                ],
                [
                    86.9986195,
                    53.7424383
                ],
                [
                    86.999386,
                    53.7433144
                ],
                [
                    87.0001939,
                    53.7436452
                ],
                [
                    87.0008777,
                    53.7437309
                ],
                [
                    87.0018929,
                    53.7437432
                ],
                [
                    87.0022347,
                    53.7436513
                ],
                [
                    87.002908,
                    53.7437799
                ],
                [
                    87.0031463,
                    53.7437003
                ],
                [
                    87.0033534,
                    53.7434675
                ],
                [
                    87.0035088,
                    53.7431612
                ],
                [
                    87.0041096,
                    53.7426466
                ],
                [
                    87.0044722,
                    53.742763
                ],
                [
                    87.0046586,
                    53.7428978
                ],
                [
                    87.0047726,
                    53.7431857
                ],
                [
                    87.0055701,
                    53.7435655
                ],
                [
                    87.0062849,
                    53.7439821
                ],
                [
                    87.0064403,
                    53.744123
                ],
                [
                    87.0063988,
                    53.74427
                ],
                [
                    87.0065232,
                    53.74427
                ],
                [
                    87.00643,
                    53.7445457
                ],
                [
                    87.0062746,
                    53.7445457
                ],
                [
                    87.0059327,
                    53.7453421
                ],
                [
                    87.0068857,
                    53.7456851
                ],
                [
                    87.0063885,
                    53.7471124
                ],
                [
                    87.0065128,
                    53.7475657
                ],
                [
                    87.0069168,
                    53.7479945
                ],
                [
                    87.0074244,
                    53.7483191
                ],
                [
                    87.0081702,
                    53.7487234
                ],
                [
                    87.0084188,
                    53.7492073
                ],
                [
                    87.0081599,
                    53.7497157
                ],
                [
                    87.0073312,
                    53.7502609
                ],
                [
                    87.0069065,
                    53.7503344
                ],
                [
                    87.005912,
                    53.7501445
                ],
                [
                    87.0044618,
                    53.7496545
                ],
                [
                    87.0023694,
                    53.7496116
                ],
                [
                    87.0003119,
                    53.7499511
                ],
                [
                    86.9998432,
                    53.7503322
                ],
                [
                    87.0000483,
                    53.7510079
                ],
                [
                    87.0013081,
                    53.7513717
                ],
                [
                    87.0020113,
                    53.7514237
                ],
                [
                    87.0031833,
                    53.7507827
                ],
                [
                    87.0036814,
                    53.7508173
                ],
                [
                    87.0030075,
                    53.7518048
                ],
                [
                    87.0033591,
                    53.7536238
                ],
                [
                    87.0018648,
                    53.754282
                ],
                [
                    87.0006049,
                    53.7540569
                ],
                [
                    86.998056,
                    53.754438
                ],
                [
                    86.9969133,
                    53.7553387
                ],
                [
                    86.9968254,
                    53.7561356
                ],
                [
                    86.998349,
                    53.7566033
                ],
                [
                    86.9987006,
                    53.7571749
                ],
                [
                    86.9978216,
                    53.7577118
                ],
                [
                    86.9974759,
                    53.7590222
                ],
                [
                    86.99644,
                    53.7602714
                ],
                [
                    86.9946998,
                    53.7606633
                ],
                [
                    86.9940782,
                    53.7610307
                ],
                [
                    86.9941611,
                    53.7623044
                ],
                [
                    86.9936639,
                    53.7627821
                ],
                [
                    86.9922136,
                    53.7624147
                ],
                [
                    86.9905563,
                    53.7627821
                ],
                [
                    86.9905148,
                    53.7637373
                ],
                [
                    86.9909499,
                    53.7641537
                ],
                [
                    86.9924001,
                    53.7643618
                ],
                [
                    86.9949069,
                    53.7643496
                ],
                [
                    86.995197,
                    53.7654028
                ],
                [
                    86.9958185,
                    53.7655497
                ],
                [
                    86.9948862,
                    53.7672886
                ],
                [
                    86.9958185,
                    53.7675825
                ],
                [
                    86.9966679,
                    53.7666763
                ],
                [
                    86.996585,
                    53.7664926
                ],
                [
                    86.9972894,
                    53.7660763
                ],
                [
                    86.9977452,
                    53.7655987
                ],
                [
                    86.9996512,
                    53.7656232
                ],
                [
                    86.9992989,
                    53.7667253
                ],
                [
                    87.0002935,
                    53.7672886
                ],
                [
                    87.002303,
                    53.7646435
                ],
                [
                    87.0030074,
                    53.7588384
                ],
                [
                    87.0042919,
                    53.7570747
                ],
                [
                    87.010445,
                    53.7516484
                ],
                [
                    87.015935,
                    53.7512441
                ],
                [
                    87.0222539,
                    53.7529468
                ],
                [
                    87.0228133,
                    53.7540125
                ],
                [
                    87.0235176,
                    53.7554947
                ],
                [
                    87.0235384,
                    53.7570257
                ],
                [
                    87.0244498,
                    53.7591201
                ],
                [
                    87.0243049,
                    53.7612145
                ],
                [
                    87.0252579,
                    53.7621575
                ],
                [
                    87.0274747,
                    53.7629658
                ],
                [
                    87.0289042,
                    53.764766
                ],
                [
                    87.0307167,
                    53.7668154
                ],
                [
                    87.0319911,
                    53.768256
                ],
                [
                    87.0335034,
                    53.7702763
                ],
                [
                    87.034415,
                    53.7723579
                ],
                [
                    87.0354301,
                    53.7757615
                ],
                [
                    87.0364453,
                    53.7785528
                ],
                [
                    87.0356166,
                    53.7794832
                ],
                [
                    87.0355544,
                    53.7823232
                ],
                [
                    87.0362174,
                    53.7834493
                ],
                [
                    87.0390971,
                    53.7842082
                ],
                [
                    87.0388899,
                    53.7868399
                ],
                [
                    87.041086,
                    53.7933141
                ],
                [
                    87.0417904,
                    53.7936813
                ],
                [
                    87.0427019,
                    53.7935956
                ],
                [
                    87.0435721,
                    53.7976828
                ],
                [
                    87.04409,
                    53.7988575
                ],
                [
                    87.0431992,
                    53.8002646
                ],
                [
                    87.0453538,
                    53.8002034
                ],
                [
                    87.0488136,
                    53.8003502
                ],
                [
                    87.0502638,
                    53.799873
                ],
                [
                    87.0522527,
                    53.8000321
                ],
                [
                    87.0545937,
                    53.7999098
                ],
                [
                    87.0571212,
                    53.8002156
                ],
                [
                    87.0600424,
                    53.8001055
                ],
                [
                    87.0633157,
                    53.8005338
                ],
                [
                    87.0675214,
                    53.8005827
                ],
                [
                    87.0683915,
                    53.7994693
                ],
                [
                    87.0698624,
                    53.799457
                ],
                [
                    87.0720792,
                    53.7997752
                ],
                [
                    87.0739229,
                    53.7995182
                ],
                [
                    87.0797446,
                    53.8000076
                ],
                [
                    87.0827694,
                    53.8003135
                ],
                [
                    87.0884459,
                    53.8003869
                ],
                [
                    87.0958006,
                    53.80117
                ],
                [
                    87.0981624,
                    53.8012434
                ],
                [
                    87.1046262,
                    53.8019041
                ],
                [
                    87.1053927,
                    53.8034702
                ],
                [
                    87.1030931,
                    53.8039596
                ],
                [
                    87.1029067,
                    53.8059538
                ],
                [
                    87.1070916,
                    53.8085474
                ],
                [
                    87.1074645,
                    53.8107738
                ],
                [
                    87.108231,
                    53.8129511
                ],
                [
                    87.1086454,
                    53.8138074
                ],
                [
                    87.1092047,
                    53.8181127
                ],
                [
                    87.1103856,
                    53.8191278
                ],
                [
                    87.1109242,
                    53.8198372
                ],
                [
                    87.1108621,
                    53.8205098
                ],
                [
                    87.1128924,
                    53.8220141
                ],
                [
                    87.1141562,
                    53.8226989
                ],
                [
                    87.1155028,
                    53.824093
                ],
                [
                    87.1169116,
                    53.8245332
                ],
                [
                    87.1189005,
                    53.8244843
                ],
                [
                    87.1298599,
                    53.8216227
                ],
                [
                    87.1287205,
                    53.8234204
                ],
                [
                    87.1281819,
                    53.8245455
                ],
                [
                    87.1277468,
                    53.8275781
                ],
                [
                    87.1280192,
                    53.8291424
                ],
                [
                    87.1289695,
                    53.830953
                ],
                [
                    87.1297313,
                    53.831904
                ],
                [
                    87.1303171,
                    53.8335294
                ],
                [
                    87.1306535,
                    53.8352366
                ],
                [
                    87.1321631,
                    53.8404276
                ],
                [
                    87.1334521,
                    53.8418451
                ],
                [
                    87.1359133,
                    53.8476358
                ],
                [
                    87.1360305,
                    53.8491049
                ],
                [
                    87.1377134,
                    53.8514006
                ],
                [
                    87.1406304,
                    53.8553612
                ],
                [
                    87.1429743,
                    53.858057
                ],
                [
                    87.1476914,
                    53.8615474
                ],
                [
                    87.150592,
                    53.8623422
                ],
                [
                    87.1532582,
                    53.8638799
                ],
                [
                    87.1518226,
                    53.8655558
                ],
                [
                    87.1538118,
                    53.8684188
                ],
                [
                    87.1528773,
                    53.8711359
                ],
                [
                    87.1520569,
                    53.8762835
                ],
                [
                    87.15736,
                    53.8797896
                ],
                [
                    87.1496544,
                    53.8820866
                ],
                [
                    87.1493908,
                    53.8822593
                ],
                [
                    87.1484532,
                    53.8824148
                ],
                [
                    87.1477206,
                    53.8823112
                ],
                [
                    87.1447615,
                    53.8822766
                ],
                [
                    87.1425924,
                    53.8843258
                ],
                [
                    87.1423334,
                    53.8843075
                ],
                [
                    87.1422506,
                    53.8845212
                ],
                [
                    87.1420745,
                    53.8848631
                ],
                [
                    87.1385629,
                    53.8857789
                ],
                [
                    87.1373198,
                    53.8858583
                ],
                [
                    87.1342744,
                    53.8853088
                ],
                [
                    87.1325341,
                    53.8848203
                ],
                [
                    87.1315086,
                    53.8847898
                ],
                [
                    87.1287117,
                    53.8841609
                ],
                [
                    87.1272822,
                    53.8836847
                ],
                [
                    87.1203316,
                    53.8823597
                ],
                [
                    87.1184563,
                    53.8810456
                ],
                [
                    87.1151016,
                    53.879638
                ],
                [
                    87.1135927,
                    53.8788263
                ],
                [
                    87.1111169,
                    53.8778331
                ],
                [
                    87.1091246,
                    53.8764946
                ],
                [
                    87.1069565,
                    53.8759505
                ],
                [
                    87.101756,
                    53.8734459
                ],
                [
                    87.1002178,
                    53.8730572
                ],
                [
                    87.0980204,
                    53.8717962
                ],
                [
                    87.0962478,
                    53.871062
                ],
                [
                    87.0955446,
                    53.871252
                ],
                [
                    87.0923071,
                    53.8697577
                ],
                [
                    87.0850514,
                    53.8715412
                ],
                [
                    87.076288,
                    53.8739108
                ],
                [
                    87.0726624,
                    53.8752666
                ],
                [
                    87.0840105,
                    53.882111
                ],
                [
                    87.0732139,
                    53.8848741
                ],
                [
                    87.0717929,
                    53.8860916
                ],
                [
                    87.0710605,
                    53.8861002
                ],
                [
                    87.0705331,
                    53.8867219
                ],
                [
                    87.0716904,
                    53.8886041
                ],
                [
                    87.0759241,
                    53.889925
                ],
                [
                    87.0789565,
                    53.8915394
                ],
                [
                    87.0820329,
                    53.8928257
                ],
                [
                    87.085329,
                    53.893853
                ],
                [
                    87.0879073,
                    53.8938012
                ],
                [
                    87.0889327,
                    53.8941206
                ],
                [
                    87.0894894,
                    53.8955795
                ],
                [
                    87.0857685,
                    53.8973405
                ],
                [
                    87.0859589,
                    53.8983418
                ],
                [
                    87.0863691,
                    53.8983159
                ],
                [
                    87.0863398,
                    53.8988079
                ],
                [
                    87.0860614,
                    53.9005083
                ],
                [
                    87.0854315,
                    53.9007672
                ],
                [
                    87.0826921,
                    53.90428
                ],
                [
                    87.0832341,
                    53.9068345
                ],
                [
                    87.0845379,
                    53.907965
                ],
                [
                    87.0852118,
                    53.9109767
                ],
                [
                    87.0855487,
                    53.9128319
                ],
                [
                    87.0854755,
                    53.9136689
                ],
                [
                    87.0869258,
                    53.918328
                ],
                [
                    87.0865449,
                    53.920252
                ],
                [
                    87.0859443,
                    53.9208904
                ],
                [
                    87.0858124,
                    53.9224691
                ],
                [
                    87.0847869,
                    53.9248672
                ],
                [
                    87.0861963,
                    53.9262917
                ],
                [
                    87.0855814,
                    53.927653
                ],
                [
                    87.086537,
                    53.9284073
                ],
                [
                    87.0894681,
                    53.9311093
                ],
                [
                    87.0924307,
                    53.9321461
                ],
                [
                    87.0950618,
                    53.9327315
                ],
                [
                    87.0997025,
                    53.9334755
                ],
                [
                    87.1041153,
                    53.9350611
                ],
                [
                    87.1074715,
                    53.9349147
                ],
                [
                    87.1083209,
                    53.9350367
                ],
                [
                    87.1040739,
                    53.9384637
                ],
                [
                    87.1036388,
                    53.9395613
                ],
                [
                    87.1036388,
                    53.9405247
                ],
                [
                    87.1040531,
                    53.9414515
                ],
                [
                    87.1041153,
                    53.9427197
                ],
                [
                    87.1047161,
                    53.9438659
                ],
                [
                    87.1064149,
                    53.9458901
                ],
                [
                    87.1074094,
                    53.9479019
                ],
                [
                    87.1101855,
                    53.9482921
                ],
                [
                    87.1128166,
                    53.9475483
                ],
                [
                    87.1189282,
                    53.9461583
                ],
                [
                    87.1218908,
                    53.9452194
                ],
                [
                    87.1266558,
                    53.9431465
                ],
                [
                    87.1342798,
                    53.940415
                ],
                [
                    87.1356057,
                    53.9380857
                ],
                [
                    87.1313379,
                    53.9383662
                ],
                [
                    87.1271737,
                    53.9382442
                ],
                [
                    87.1246048,
                    53.9384394
                ],
                [
                    87.1220358,
                    53.9373418
                ],
                [
                    87.1227609,
                    53.9341342
                ],
                [
                    87.1128787,
                    53.9309019
                ],
                [
                    87.1127959,
                    53.929365
                ],
                [
                    87.1123401,
                    53.9275963
                ],
                [
                    87.1117807,
                    53.9273889
                ],
                [
                    87.1166907,
                    53.9220578
                ],
                [
                    87.117333,
                    53.9188246
                ],
                [
                    87.1205235,
                    53.9157132
                ],
                [
                    87.1214765,
                    53.9144564
                ],
                [
                    87.1238382,
                    53.9137608
                ],
                [
                    87.1301778,
                    53.9137486
                ],
                [
                    87.1340726,
                    53.9128578
                ],
                [
                    87.1398942,
                    53.9101243
                ],
                [
                    87.1403293,
                    53.9101243
                ],
                [
                    87.1404328,
                    53.9105392
                ],
                [
                    87.1407229,
                    53.9105148
                ],
                [
                    87.1406608,
                    53.9101853
                ],
                [
                    87.1411577,
                    53.9099045
                ],
                [
                    87.1411339,
                    53.9097375
                ],
                [
                    87.1414758,
                    53.9096033
                ],
                [
                    87.141683,
                    53.9092494
                ],
                [
                    87.1417762,
                    53.9076079
                ],
                [
                    87.1420559,
                    53.907431
                ],
                [
                    87.1419938,
                    53.9067658
                ],
                [
                    87.1431022,
                    53.9058199
                ],
                [
                    87.1440552,
                    53.905942
                ],
                [
                    87.1441898,
                    53.9058871
                ],
                [
                    87.1441277,
                    53.9056247
                ],
                [
                    87.1443763,
                    53.905405
                ],
                [
                    87.1443556,
                    53.9032507
                ],
                [
                    87.1436614,
                    53.9027503
                ],
                [
                    87.1422735,
                    53.9023048
                ],
                [
                    87.1421595,
                    53.901371
                ],
                [
                    87.1409476,
                    53.9007607
                ],
                [
                    87.1446701,
                    53.8923787
                ],
                [
                    87.145139,
                    53.8924304
                ],
                [
                    87.1472778,
                    53.8867669
                ],
                [
                    87.1472485,
                    53.8862833
                ],
                [
                    87.1458714,
                    53.8854717
                ],
                [
                    87.1461091,
                    53.8851223
                ],
                [
                    87.1478597,
                    53.8848781
                ],
                [
                    87.1486677,
                    53.8846095
                ],
                [
                    87.1502836,
                    53.8838951
                ],
                [
                    87.1521999,
                    53.8869723
                ],
                [
                    87.1531633,
                    53.8878941
                ],
                [
                    87.1542614,
                    53.888584
                ],
                [
                    87.1562709,
                    53.8905559
                ],
                [
                    87.157027,
                    53.8916303
                ],
                [
                    87.1604766,
                    53.8935654
                ],
                [
                    87.1622272,
                    53.8942124
                ],
                [
                    87.1632422,
                    53.8949632
                ],
                [
                    87.1655938,
                    53.8955187
                ],
                [
                    87.1672201,
                    53.8961596
                ],
                [
                    87.1697787,
                    53.8968615
                ],
                [
                    87.1732281,
                    53.897478
                ],
                [
                    87.1737461,
                    53.8974902
                ],
                [
                    87.175476,
                    53.8978442
                ],
                [
                    87.1757764,
                    53.8980273
                ],
                [
                    87.1763564,
                    53.8980456
                ],
                [
                    87.1770608,
                    53.8983203
                ],
                [
                    87.1778895,
                    53.8989062
                ],
                [
                    87.17877,
                    53.8992907
                ],
                [
                    87.1799302,
                    53.900017
                ],
                [
                    87.1807589,
                    53.9002978
                ],
                [
                    87.1823127,
                    53.9012377
                ],
                [
                    87.1846848,
                    53.9031113
                ],
                [
                    87.1849852,
                    53.903923
                ],
                [
                    87.1864872,
                    53.9047468
                ],
                [
                    87.1869533,
                    53.9053083
                ],
                [
                    87.1894913,
                    53.9054059
                ],
                [
                    87.1944634,
                    53.9073343
                ],
                [
                    87.1975503,
                    53.908152
                ],
                [
                    87.199332,
                    53.9087622
                ],
                [
                    87.199187,
                    53.9097995
                ],
                [
                    87.2007097,
                    53.9099642
                ],
                [
                    87.2023568,
                    53.910312
                ],
                [
                    87.2048118,
                    53.9118009
                ],
                [
                    87.2060859,
                    53.9114653
                ],
                [
                    87.2079194,
                    53.9126551
                ],
                [
                    87.2079919,
                    53.9138387
                ],
                [
                    87.2085144,
                    53.9138453
                ],
                [
                    87.2118452,
                    53.9138631
                ],
                [
                    87.2146215,
                    53.9153213
                ],
                [
                    87.214984,
                    53.916633
                ],
                [
                    87.2173561,
                    53.9170113
                ],
                [
                    87.2182056,
                    53.9170235
                ],
                [
                    87.2216032,
                    53.9185548
                ],
                [
                    87.2241825,
                    53.9201287
                ],
                [
                    87.224918,
                    53.922642
                ],
                [
                    87.2293619,
                    53.9224529
                ],
                [
                    87.2310711,
                    53.9227823
                ],
                [
                    87.2326249,
                    53.9235081
                ],
                [
                    87.2355197,
                    53.9237552
                ],
                [
                    87.24658,
                    53.9261101
                ],
                [
                    87.2483379,
                    53.9267226
                ],
                [
                    87.2487041,
                    53.9286461
                ],
                [
                    87.2511945,
                    53.9292757
                ],
                [
                    87.2603065,
                    53.9276369
                ],
                [
                    87.2602772,
                    53.9271539
                ],
                [
                    87.2672942,
                    53.9267916
                ],
                [
                    87.2675753,
                    53.9241933
                ],
                [
                    87.2715133,
                    53.9233584
                ],
                [
                    87.2788087,
                    53.9255063
                ],
                [
                    87.2816213,
                    53.9261188
                ],
                [
                    87.2829984,
                    53.9266277
                ],
                [
                    87.2846831,
                    53.9271021
                ],
                [
                    87.285606,
                    53.9275765
                ],
                [
                    87.2919638,
                    53.9297674
                ],
                [
                    87.2966223,
                    53.9309404
                ],
                [
                    87.298761,
                    53.9311043
                ],
                [
                    87.3051921,
                    53.9319495
                ],
                [
                    87.3085762,
                    53.9298795
                ],
                [
                    87.3122239,
                    53.9293793
                ],
                [
                    87.3170395,
                    53.9295569
                ],
                [
                    87.3215556,
                    53.9297674
                ],
                [
                    87.3286459,
                    53.9295
                ],
                [
                    87.3305943,
                    53.9287237
                ],
                [
                    87.328851,
                    53.9275938
                ],
                [
                    87.3273714,
                    53.9256788
                ],
                [
                    87.3286899,
                    53.9254977
                ],
                [
                    87.3280745,
                    53.9246868
                ],
                [
                    87.3287045,
                    53.9237293
                ],
                [
                    87.3301255,
                    53.9204856
                ],
                [
                    87.3309459,
                    53.9200715
                ],
                [
                    87.330814,
                    53.9198299
                ],
                [
                    87.3303892,
                    53.9198645
                ],
                [
                    87.3317663,
                    53.9183374
                ],
                [
                    87.3312975,
                    53.9146101
                ],
                [
                    87.3345936,
                    53.9117799
                ],
                [
                    87.3354286,
                    53.911849
                ],
                [
                    87.3364101,
                    53.9112449
                ],
                [
                    87.3360878,
                    53.9111241
                ],
                [
                    87.3354433,
                    53.9111327
                ],
                [
                    87.3354433,
                    53.9099851
                ],
                [
                    87.3339637,
                    53.9093206
                ],
                [
                    87.3343738,
                    53.9090703
                ],
                [
                    87.3363222,
                    53.9096313
                ],
                [
                    87.3387394,
                    53.909148
                ],
                [
                    87.3394425,
                    53.9085785
                ],
                [
                    87.3398088,
                    53.90775
                ],
                [
                    87.3352382,
                    53.9057737
                ],
                [
                    87.3347547,
                    53.9021489
                ],
                [
                    87.3353114,
                    53.9008197
                ],
                [
                    87.3350917,
                    53.899948
                ],
                [
                    87.3360439,
                    53.8979713
                ],
                [
                    87.3376407,
                    53.8959514
                ],
                [
                    87.3406145,
                    53.8930078
                ],
                [
                    87.3443793,
                    53.8921704
                ],
                [
                    87.3445112,
                    53.8906423
                ],
                [
                    87.3467526,
                    53.8903919
                ],
                [
                    87.3471774,
                    53.8898567
                ],
                [
                    87.3471481,
                    53.8896926
                ],
                [
                    87.3465914,
                    53.8896149
                ],
                [
                    87.3469577,
                    53.8891055
                ],
                [
                    87.3473386,
                    53.8891401
                ],
                [
                    87.3474411,
                    53.8884666
                ],
                [
                    87.3476316,
                    53.8882249
                ],
                [
                    87.3470456,
                    53.8877759
                ],
                [
                    87.346152,
                    53.8878795
                ],
                [
                    87.3456245,
                    53.887586
                ],
                [
                    87.3448042,
                    53.8880091
                ],
                [
                    87.3430463,
                    53.888199
                ],
                [
                    87.3418597,
                    53.8879486
                ],
                [
                    87.3408635,
                    53.8882594
                ],
                [
                    87.3097754,
                    53.8862345
                ],
                [
                    87.3095682,
                    53.885856
                ],
                [
                    87.3093196,
                    53.8824124
                ],
                [
                    87.3095889,
                    53.8800066
                ],
                [
                    87.3090109,
                    53.877193
                ],
                [
                    87.3079572,
                    53.8757813
                ],
                [
                    87.3058499,
                    53.8758519
                ],
                [
                    87.3047963,
                    53.8765436
                ],
                [
                    87.3053709,
                    53.8771224
                ],
                [
                    87.3029764,
                    53.8777012
                ],
                [
                    87.2864773,
                    53.8795645
                ],
                [
                    87.2846814,
                    53.8785764
                ],
                [
                    87.282167,
                    53.8778847
                ],
                [
                    87.2818796,
                    53.877433
                ],
                [
                    87.277258,
                    53.8761483
                ],
                [
                    87.2756057,
                    53.8752025
                ],
                [
                    87.2743126,
                    53.8746519
                ],
                [
                    87.2721095,
                    53.8741578
                ],
                [
                    87.2702657,
                    53.8725201
                ],
                [
                    87.2668653,
                    53.871207
                ],
                [
                    87.265644,
                    53.8716447
                ],
                [
                    87.2603278,
                    53.8692445
                ],
                [
                    87.2625789,
                    53.8621276
                ],
                [
                    87.2604476,
                    53.8620288
                ],
                [
                    87.25846,
                    53.8642741
                ],
                [
                    87.2547245,
                    53.8669853
                ],
                [
                    87.251372,
                    53.8658557
                ],
                [
                    87.2490013,
                    53.8637093
                ],
                [
                    87.244643,
                    53.8623253
                ],
                [
                    87.242416,
                    53.8622406
                ],
                [
                    87.2345856,
                    53.8549814
                ],
                [
                    87.2332925,
                    53.8526225
                ],
                [
                    87.2386565,
                    53.8528062
                ],
                [
                    87.2398776,
                    53.8523541
                ],
                [
                    87.2378423,
                    53.8501364
                ],
                [
                    87.2377225,
                    53.8489498
                ],
                [
                    87.2367407,
                    53.8483283
                ],
                [
                    87.237986,
                    53.8477208
                ],
                [
                    87.2394946,
                    53.8473394
                ],
                [
                    87.2395664,
                    53.8463223
                ],
                [
                    87.2414582,
                    53.8456724
                ],
                [
                    87.2412187,
                    53.8451073
                ],
                [
                    87.2441161,
                    53.8439771
                ],
                [
                    87.2427991,
                    53.8424512
                ],
                [
                    87.2419132,
                    53.8420132
                ],
                [
                    87.2404045,
                    53.8427479
                ],
                [
                    87.2386086,
                    53.8423241
                ],
                [
                    87.2382015,
                    53.8429881
                ],
                [
                    87.2367168,
                    53.8437934
                ],
                [
                    87.2364055,
                    53.8446411
                ],
                [
                    87.2353279,
                    53.8438358
                ],
                [
                    87.2336517,
                    53.8452344
                ],
                [
                    87.233484,
                    53.8458561
                ],
                [
                    87.2318796,
                    53.8443585
                ],
                [
                    87.2277848,
                    53.8436945
                ],
                [
                    87.2278566,
                    53.8434402
                ],
                [
                    87.2274496,
                    53.8432141
                ],
                [
                    87.2287427,
                    53.8422534
                ],
                [
                    87.2298681,
                    53.8360505
                ],
                [
                    87.2306823,
                    53.8360646
                ],
                [
                    87.2315444,
                    53.8358103
                ],
                [
                    87.2338192,
                    53.8358527
                ],
                [
                    87.2350166,
                    53.8356266
                ],
                [
                    87.2356632,
                    53.8351885
                ],
                [
                    87.2354394,
                    53.833961
                ],
                [
                    87.2368279,
                    53.8327619
                ],
                [
                    87.2381824,
                    53.8308033
                ],
                [
                    87.238555,
                    53.829824
                ],
                [
                    87.2377747,
                    53.8293059
                ],
                [
                    87.2374994,
                    53.8292282
                ],
                [
                    87.237224,
                    53.8291717
                ],
                [
                    87.2378226,
                    53.8285498
                ],
                [
                    87.2381338,
                    53.8277159
                ],
                [
                    87.2384762,
                    53.8274559
                ],
                [
                    87.2388883,
                    53.827193
                ],
                [
                    87.2432345,
                    53.8260835
                ],
                [
                    87.2446833,
                    53.8259775
                ],
                [
                    87.2458207,
                    53.8255181
                ],
                [
                    87.2465631,
                    53.8250446
                ],
                [
                    87.2477487,
                    53.8249913
                ],
                [
                    87.2503466,
                    53.8241259
                ],
                [
                    87.2524059,
                    53.8226417
                ],
                [
                    87.2527891,
                    53.8220763
                ],
                [
                    87.2482633,
                    53.8198146
                ],
                [
                    87.2474491,
                    53.8202528
                ],
                [
                    87.2427795,
                    53.8201821
                ],
                [
                    87.2409117,
                    53.8212282
                ],
                [
                    87.2395707,
                    53.8214402
                ],
                [
                    87.2351646,
                    53.8207476
                ],
                [
                    87.230002,
                    53.820279
                ],
                [
                    87.2295372,
                    53.8204507
                ],
                [
                    87.2284836,
                    53.8207334
                ],
                [
                    87.2280286,
                    53.8214119
                ],
                [
                    87.2282826,
                    53.8222727
                ],
                [
                    87.230519,
                    53.8244086
                ],
                [
                    87.232315,
                    53.824875
                ],
                [
                    87.2331531,
                    53.8263591
                ],
                [
                    87.2357154,
                    53.8277159
                ],
                [
                    87.2361464,
                    53.8286064
                ],
                [
                    87.2365056,
                    53.8294685
                ],
                [
                    87.237679,
                    53.8296522
                ],
                [
                    87.2375592,
                    53.830486
                ],
                [
                    87.2362182,
                    53.8325776
                ],
                [
                    87.2349491,
                    53.8339484
                ],
                [
                    87.2349491,
                    53.8350506
                ],
                [
                    87.2334165,
                    53.8355593
                ],
                [
                    87.2284595,
                    53.835743
                ],
                [
                    87.2261608,
                    53.8354887
                ],
                [
                    87.2229721,
                    53.8342855
                ],
                [
                    87.2191445,
                    53.8324787
                ],
                [
                    87.2139241,
                    53.832083
                ],
                [
                    87.2042696,
                    53.8283267
                ],
                [
                    87.2017974,
                    53.8275671
                ],
                [
                    87.2002057,
                    53.8276271
                ],
                [
                    87.1993506,
                    53.8267607
                ],
                [
                    87.192857,
                    53.8218302
                ],
                [
                    87.191604,
                    53.8216503
                ],
                [
                    87.1914685,
                    53.8204309
                ],
                [
                    87.1902494,
                    53.8196112
                ],
                [
                    87.19008,
                    53.8186516
                ],
                [
                    87.1912653,
                    53.8182518
                ],
                [
                    87.1942398,
                    53.8186412
                ],
                [
                    87.1967515,
                    53.8187915
                ],
                [
                    87.1984786,
                    53.8183717
                ],
                [
                    87.1994946,
                    53.8193113
                ],
                [
                    87.2020385,
                    53.8191124
                ],
                [
                    87.2025424,
                    53.8185916
                ],
                [
                    87.203152,
                    53.8188315
                ],
                [
                    87.2039648,
                    53.8184317
                ],
                [
                    87.2039648,
                    53.8170122
                ],
                [
                    87.2010185,
                    53.8152128
                ],
                [
                    87.1947196,
                    53.8124936
                ],
                [
                    87.1940084,
                    53.8114938
                ],
                [
                    87.1874385,
                    53.810614
                ],
                [
                    87.1808009,
                    53.8081344
                ],
                [
                    87.1787013,
                    53.8081744
                ],
                [
                    87.1765339,
                    53.8069546
                ],
                [
                    87.1735876,
                    53.8055947
                ],
                [
                    87.1709123,
                    53.8047548
                ],
                [
                    87.1702909,
                    53.8040293
                ],
                [
                    87.170472,
                    53.8026148
                ],
                [
                    87.1693206,
                    53.8015348
                ],
                [
                    87.168982,
                    53.8008348
                ],
                [
                    87.1699302,
                    53.8002748
                ],
                [
                    87.1710477,
                    53.8000348
                ],
                [
                    87.1720298,
                    53.8002748
                ],
                [
                    87.1746036,
                    53.8000548
                ],
                [
                    87.1759243,
                    53.7995348
                ],
                [
                    87.1780239,
                    53.7997148
                ],
                [
                    87.1794818,
                    53.7982699
                ],
                [
                    87.1830737,
                    53.7965161
                ],
                [
                    87.1895393,
                    53.7968273
                ],
                [
                    87.1937059,
                    53.7978456
                ],
                [
                    87.1949032,
                    53.7989205
                ],
                [
                    87.1974894,
                    53.7990619
                ],
                [
                    87.2044339,
                    53.8017208
                ],
                [
                    87.2050086,
                    53.8027673
                ],
                [
                    87.2075948,
                    53.8031915
                ],
                [
                    87.2114262,
                    53.8022582
                ],
                [
                    87.2125757,
                    53.8023713
                ],
                [
                    87.2139258,
                    53.8018914
                ],
                [
                    87.2152973,
                    53.8013014
                ],
                [
                    87.2171599,
                    53.8019914
                ],
                [
                    87.2212552,
                    53.8029663
                ],
                [
                    87.2255246,
                    53.8035113
                ],
                [
                    87.2344143,
                    53.796441
                ],
                [
                    87.2386135,
                    53.7988912
                ],
                [
                    87.2433829,
                    53.7954534
                ],
                [
                    87.2505907,
                    53.794831
                ],
                [
                    87.2574872,
                    53.8002198
                ],
                [
                    87.2610313,
                    53.7997389
                ],
                [
                    87.2623723,
                    53.8010683
                ],
                [
                    87.2678561,
                    53.8022845
                ],
                [
                    87.2715438,
                    53.8051129
                ],
                [
                    87.2701789,
                    53.8059189
                ],
                [
                    87.2708733,
                    53.8064704
                ],
                [
                    87.2732919,
                    53.8063714
                ],
                [
                    87.274513,
                    53.8076016
                ],
                [
                    87.2751118,
                    53.8079693
                ],
                [
                    87.275902,
                    53.8075875
                ],
                [
                    87.2765965,
                    53.8079976
                ],
                [
                    87.2792785,
                    53.8083793
                ],
                [
                    87.2856243,
                    53.8134553
                ],
                [
                    87.2891923,
                    53.8130312
                ],
                [
                    87.2922335,
                    53.8119283
                ],
                [
                    87.2961367,
                    53.8146429
                ],
                [
                    87.2929997,
                    53.8160001
                ],
                [
                    87.2908925,
                    53.8179793
                ],
                [
                    87.2917785,
                    53.8184741
                ],
                [
                    87.291108,
                    53.8192092
                ],
                [
                    87.2921856,
                    53.820015
                ],
                [
                    87.2892162,
                    53.8205521
                ],
                [
                    87.2868065,
                    53.8223606
                ],
                [
                    87.2859834,
                    53.8241566
                ],
                [
                    87.2860553,
                    53.8259235
                ],
                [
                    87.2871808,
                    53.8266443
                ],
                [
                    87.2863187,
                    53.8298384
                ],
                [
                    87.2872287,
                    53.8299797
                ],
                [
                    87.2896233,
                    53.8314495
                ],
                [
                    87.2913235,
                    53.8320572
                ],
                [
                    87.2905812,
                    53.8326649
                ],
                [
                    87.290629,
                    53.8346998
                ],
                [
                    87.2900783,
                    53.8372999
                ],
                [
                    87.2888331,
                    53.8395606
                ],
                [
                    87.287971,
                    53.8402671
                ],
                [
                    87.2872287,
                    53.8466248
                ],
                [
                    87.2905093,
                    53.8514278
                ],
                [
                    87.2921267,
                    53.8526952
                ],
                [
                    87.2948435,
                    53.854168
                ],
                [
                    87.2964241,
                    53.8558771
                ],
                [
                    87.2976693,
                    53.8552697
                ],
                [
                    87.2995371,
                    53.855072
                ],
                [
                    87.301333,
                    53.8538149
                ],
                [
                    87.3031051,
                    53.8535324
                ],
                [
                    87.3103369,
                    53.8535889
                ],
                [
                    87.3135697,
                    53.8519786
                ],
                [
                    87.3221425,
                    53.8516255
                ],
                [
                    87.3248723,
                    53.8502129
                ],
                [
                    87.3211606,
                    53.8467802
                ],
                [
                    87.3202986,
                    53.8456642
                ],
                [
                    87.3207057,
                    53.8440112
                ],
                [
                    87.3204423,
                    53.8391792
                ],
                [
                    87.330404,
                    53.8409736
                ],
                [
                    87.333493,
                    53.8400693
                ],
                [
                    87.3362229,
                    53.840578
                ],
                [
                    87.3407967,
                    53.8438982
                ],
                [
                    87.344652,
                    53.8442938
                ],
                [
                    87.3472861,
                    53.8441807
                ],
                [
                    87.3484116,
                    53.8432483
                ],
                [
                    87.3478608,
                    53.8466248
                ],
                [
                    87.3492976,
                    53.8481081
                ],
                [
                    87.3512427,
                    53.8518612
                ],
                [
                    87.35538,
                    53.853829
                ],
                [
                    87.3572238,
                    53.8548884
                ],
                [
                    87.3587564,
                    53.8569081
                ],
                [
                    87.3620131,
                    53.8582922
                ],
                [
                    87.3629231,
                    53.8591961
                ],
                [
                    87.3665976,
                    53.8610566
                ],
                [
                    87.370562,
                    53.8627408
                ],
                [
                    87.3711607,
                    53.8637151
                ],
                [
                    87.3728609,
                    53.8639411
                ],
                [
                    87.373244,
                    53.8652543
                ],
                [
                    87.3737229,
                    53.8665252
                ],
                [
                    87.3751597,
                    53.867909
                ],
                [
                    87.3783206,
                    53.8697586
                ],
                [
                    87.3832536,
                    53.8692927
                ],
                [
                    87.384403,
                    53.8703658
                ],
                [
                    87.3871808,
                    53.8712412
                ],
                [
                    87.3896233,
                    53.8722859
                ],
                [
                    87.3958494,
                    53.8712129
                ],
                [
                    87.4007105,
                    53.8677678
                ],
                [
                    87.4009978,
                    53.8664687
                ],
                [
                    87.4020036,
                    53.8659321
                ],
                [
                    87.4020754,
                    53.8646754
                ],
                [
                    87.4054996,
                    53.8609331
                ],
                [
                    87.4079662,
                    53.8598316
                ],
                [
                    87.4088283,
                    53.8584899
                ],
                [
                    87.409403,
                    53.8577273
                ],
                [
                    87.4106961,
                    53.8580945
                ],
                [
                    87.4160361,
                    53.8571482
                ],
                [
                    87.4162996,
                    53.8574872
                ],
                [
                    87.4174011,
                    53.8573318
                ],
                [
                    87.4181434,
                    53.856103
                ],
                [
                    87.4174011,
                    53.8558347
                ],
                [
                    87.4176884,
                    53.8551708
                ],
                [
                    87.4193647,
                    53.8544081
                ],
                [
                    87.4207536,
                    53.8535042
                ],
                [
                    87.4193168,
                    53.8528968
                ],
                [
                    87.4194605,
                    53.8511876
                ],
                [
                    87.4216634,
                    53.8498315
                ],
                [
                    87.4218072,
                    53.8492382
                ],
                [
                    87.421448,
                    53.8490264
                ],
                [
                    87.4231722,
                    53.8475148
                ],
                [
                    87.4240342,
                    53.8471616
                ],
                [
                    87.4265486,
                    53.8481223
                ],
                [
                    87.4323915,
                    53.8462716
                ],
                [
                    87.4346185,
                    53.8450708
                ],
                [
                    87.441491,
                    53.8466672
                ],
                [
                    87.4472861,
                    53.8465824
                ],
                [
                    87.4509499,
                    53.8415105
                ],
                [
                    87.4492257,
                    53.8366781
                ],
                [
                    87.4494892,
                    53.8352227
                ],
                [
                    87.4480524,
                    53.8344031
                ],
                [
                    87.4485074,
                    53.8334987
                ],
                [
                    87.4483637,
                    53.8326084
                ],
                [
                    87.4498483,
                    53.8320431
                ],
                [
                    87.4501118,
                    53.8299939
                ],
                [
                    87.4486511,
                    53.8296688
                ],
                [
                    87.4436942,
                    53.829584
                ],
                [
                    87.4441971,
                    53.8291459
                ],
                [
                    87.4431913,
                    53.8285099
                ],
                [
                    87.4425447,
                    53.8282979
                ],
                [
                    87.4385457,
                    53.8282131
                ],
                [
                    87.4379471,
                    53.8281848
                ],
                [
                    87.4401262,
                    53.8261355
                ],
                [
                    87.440174,
                    53.8248492
                ],
                [
                    87.4390247,
                    53.8250895
                ],
                [
                    87.4390006,
                    53.8238457
                ],
                [
                    87.4364384,
                    53.8209479
                ],
                [
                    87.4364624,
                    53.818771
                ],
                [
                    87.4353369,
                    53.8188417
                ],
                [
                    87.4321999,
                    53.8182621
                ],
                [
                    87.429494,
                    53.8171311
                ],
                [
                    87.4283925,
                    53.8161556
                ],
                [
                    87.4264768,
                    53.8153498
                ],
                [
                    87.4247766,
                    53.8152932
                ],
                [
                    87.42413,
                    53.8146429
                ],
                [
                    87.4231243,
                    53.8143884
                ],
                [
                    87.4219988,
                    53.8136391
                ],
                [
                    87.4141204,
                    53.8104437
                ],
                [
                    87.4054996,
                    53.8054805
                ],
                [
                    87.4037517,
                    53.8044624
                ],
                [
                    87.4013331,
                    53.8032886
                ],
                [
                    87.3946281,
                    53.8007572
                ],
                [
                    87.3918982,
                    53.8000783
                ],
                [
                    87.3906479,
                    53.7993175
                ],
                [
                    87.3893359,
                    53.798565
                ],
                [
                    87.3879231,
                    53.7966132
                ],
                [
                    87.3855285,
                    53.7940248
                ],
                [
                    87.384834,
                    53.7929073
                ],
                [
                    87.3854805,
                    53.7920303
                ],
                [
                    87.3844509,
                    53.7912664
                ],
                [
                    87.3837324,
                    53.7891728
                ],
                [
                    87.3844268,
                    53.7887342
                ],
                [
                    87.3818886,
                    53.7866263
                ],
                [
                    87.3814097,
                    53.7865415
                ],
                [
                    87.3795658,
                    53.7845608
                ],
                [
                    87.3797814,
                    53.783627
                ],
                [
                    87.3784643,
                    53.7822829
                ],
                [
                    87.3771951,
                    53.7816603
                ],
                [
                    87.3731482,
                    53.7781088
                ],
                [
                    87.3714001,
                    53.7760852
                ],
                [
                    87.3667785,
                    53.7743305
                ],
                [
                    87.3535122,
                    53.7705094
                ],
                [
                    87.3504613,
                    53.7700279
                ],
                [
                    87.347789,
                    53.7698017
                ],
                [
                    87.3408685,
                    53.7698159
                ],
                [
                    87.3322478,
                    53.771217
                ],
                [
                    87.3315293,
                    53.7700848
                ],
                [
                    87.3301645,
                    53.7702122
                ],
                [
                    87.3288714,
                    53.7683864
                ],
                [
                    87.3301405,
                    53.7676787
                ],
                [
                    87.3369413,
                    53.7667304
                ],
                [
                    87.3420658,
                    53.7661926
                ],
                [
                    87.3427124,
                    53.76431
                ],
                [
                    87.3431674,
                    53.7643242
                ],
                [
                    87.3432871,
                    53.7639844
                ],
                [
                    87.3444605,
                    53.7638287
                ],
                [
                    87.3455381,
                    53.7642675
                ],
                [
                    87.3492976,
                    53.7644232
                ],
                [
                    87.3509978,
                    53.764494
                ],
                [
                    87.3506386,
                    53.7635456
                ],
                [
                    87.3504471,
                    53.7610259
                ],
                [
                    87.3509499,
                    53.7602332
                ],
                [
                    87.356266,
                    53.7598227
                ],
                [
                    87.3596425,
                    53.7613232
                ],
                [
                    87.3693647,
                    53.7629653
                ],
                [
                    87.3708733,
                    53.7613232
                ],
                [
                    87.3703465,
                    53.7597377
                ],
                [
                    87.3704662,
                    53.7583645
                ],
                [
                    87.3618928,
                    53.7574614
                ],
                [
                    87.3397296,
                    53.7515707
                ],
                [
                    87.3421961,
                    53.7485122
                ],
                [
                    87.3353954,
                    53.7480308
                ],
                [
                    87.3330486,
                    53.7472803
                ],
                [
                    87.3283791,
                    53.7465298
                ],
                [
                    87.3255295,
                    53.7462749
                ],
                [
                    87.324859,
                    53.7457084
                ],
                [
                    87.3236137,
                    53.745935
                ],
                [
                    87.3240687,
                    53.7452411
                ],
                [
                    87.3231109,
                    53.7445472
                ],
                [
                    87.3197584,
                    53.744264
                ],
                [
                    87.3206923,
                    53.7426212
                ],
                [
                    87.3194709,
                    53.7400577
                ],
                [
                    87.3155438,
                    53.7384573
                ],
                [
                    87.3143705,
                    53.7371967
                ],
                [
                    87.3142028,
                    53.7348171
                ],
                [
                    87.3129097,
                    53.7319982
                ],
                [
                    87.311904,
                    53.7301141
                ],
                [
                    87.3091709,
                    53.7281184
                ],
                [
                    87.3069546,
                    53.728015
                ],
                [
                    87.3062279,
                    53.7285903
                ],
                [
                    87.3065639,
                    53.7317574
                ],
                [
                    87.3093417,
                    53.7326498
                ],
                [
                    87.3103954,
                    53.7369984
                ],
                [
                    87.3097249,
                    53.7396612
                ],
                [
                    87.3096769,
                    53.7402135
                ],
                [
                    87.3074977,
                    53.7401285
                ],
                [
                    87.3074977,
                    53.739647
                ],
                [
                    87.3048637,
                    53.7384714
                ],
                [
                    87.3014394,
                    53.7352279
                ],
                [
                    87.3011042,
                    53.7335422
                ],
                [
                    87.3003139,
                    53.7335281
                ],
                [
                    87.2992603,
                    53.734378
                ],
                [
                    87.2990207,
                    53.7352703
                ],
                [
                    87.2997871,
                    53.7371542
                ],
                [
                    87.2986137,
                    53.7379049
                ],
                [
                    87.2943992,
                    53.731729
                ],
                [
                    87.2924595,
                    53.7307799
                ],
                [
                    87.2865927,
                    53.7298874
                ],
                [
                    87.281995,
                    53.7286974
                ],
                [
                    87.278403,
                    53.731474
                ],
                [
                    87.2819471,
                    53.7341372
                ],
                [
                    87.280175,
                    53.7361061
                ],
                [
                    87.2743561,
                    53.7317857
                ],
                [
                    87.2733024,
                    53.7319273
                ],
                [
                    87.2658072,
                    53.7300291
                ],
                [
                    87.265903,
                    53.7289949
                ],
                [
                    87.2687047,
                    53.7282582
                ],
                [
                    87.2670045,
                    53.726289
                ],
                [
                    87.2719136,
                    53.7249997
                ],
                [
                    87.2720333,
                    53.7240929
                ],
                [
                    87.268154,
                    53.7214859
                ],
                [
                    87.2664777,
                    53.7210183
                ],
                [
                    87.2595093,
                    53.7210183
                ],
                [
                    87.2543609,
                    53.7203948
                ],
                [
                    87.2524452,
                    53.7225485
                ],
                [
                    87.249859,
                    53.7218684
                ],
                [
                    87.2457162,
                    53.7219534
                ],
                [
                    87.2457641,
                    53.7201397
                ],
                [
                    87.2407833,
                    53.7185527
                ],
                [
                    87.2401846,
                    53.7192045
                ],
                [
                    87.241789,
                    53.7198422
                ],
                [
                    87.2405199,
                    53.7209899
                ],
                [
                    87.2448014,
                    53.7232614
                ],
                [
                    87.2384586,
                    53.726151
                ],
                [
                    87.2345516,
                    53.7270113
                ],
                [
                    87.2325536,
                    53.729115
                ],
                [
                    87.2323842,
                    53.7319398
                ],
                [
                    87.2292348,
                    53.732661
                ],
                [
                    87.2287945,
                    53.7334223
                ],
                [
                    87.23191,
                    53.7340633
                ],
                [
                    87.2317353,
                    53.7354565
                ],
                [
                    87.2275076,
                    53.7366875
                ],
                [
                    87.2270674,
                    53.7374286
                ],
                [
                    87.2283543,
                    53.7397321
                ],
                [
                    87.227677,
                    53.7399925
                ],
                [
                    87.2288961,
                    53.7413545
                ],
                [
                    87.2267287,
                    53.7414346
                ],
                [
                    87.2198541,
                    53.7425963
                ],
                [
                    87.2151129,
                    53.7454603
                ],
                [
                    87.2120989,
                    53.7422959
                ],
                [
                    87.2120312,
                    53.7411742
                ],
                [
                    87.2133858,
                    53.7395318
                ],
                [
                    87.2127761,
                    53.7364872
                ],
                [
                    87.2109475,
                    53.7355257
                ],
                [
                    87.2084415,
                    53.7353654
                ],
                [
                    87.205292,
                    53.7308179
                ],
                [
                    87.2034633,
                    53.7272718
                ],
                [
                    87.2080351,
                    53.7256689
                ],
                [
                    87.2136906,
                    53.7216614
                ],
                [
                    87.2191429,
                    53.7198379
                ],
                [
                    87.2188381,
                    53.7182748
                ],
                [
                    87.2219876,
                    53.7147276
                ],
                [
                    87.222394,
                    53.7155092
                ],
                [
                    87.2253403,
                    53.7162507
                ],
                [
                    87.2268303,
                    53.7152086
                ],
                [
                    87.223647,
                    53.7140662
                ],
                [
                    87.2259498,
                    53.7114406
                ],
                [
                    87.228422,
                    53.7103783
                ],
                [
                    87.2321133,
                    53.7095364
                ],
                [
                    87.2385138,
                    53.7091556
                ],
                [
                    87.241968,
                    53.7077525
                ],
                [
                    87.2442032,
                    53.7054673
                ],
                [
                    87.245253,
                    53.7035629
                ],
                [
                    87.2447789,
                    53.7002951
                ],
                [
                    87.2431195,
                    53.6984305
                ],
                [
                    87.2377011,
                    53.6961047
                ],
                [
                    87.2336711,
                    53.6950621
                ],
                [
                    87.2254418,
                    53.6951022
                ],
                [
                    87.2267626,
                    53.6934179
                ],
                [
                    87.2281849,
                    53.6932976
                ],
                [
                    87.2280833,
                    53.6923551
                ],
                [
                    87.2276092,
                    53.6918538
                ],
                [
                    87.2293702,
                    53.6893873
                ],
                [
                    87.23042,
                    53.6863791
                ],
                [
                    87.229438,
                    53.6857574
                ],
                [
                    87.2298782,
                    53.6837317
                ],
                [
                    87.2315376,
                    53.6815255
                ],
                [
                    87.2181608,
                    53.6812647
                ],
                [
                    87.2158918,
                    53.6824481
                ],
                [
                    87.2156209,
                    53.6836113
                ],
                [
                    87.2165014,
                    53.6843535
                ],
                [
                    87.2158072,
                    53.6884848
                ],
                [
                    87.214097,
                    53.6886553
                ],
                [
                    87.2129117,
                    53.6903097
                ],
                [
                    87.2109342,
                    53.6922743
                ],
                [
                    87.2108771,
                    53.6932161
                ],
                [
                    87.211898,
                    53.6975173
                ],
                [
                    87.2180905,
                    53.7007092
                ],
                [
                    87.2185484,
                    53.7006726
                ],
                [
                    87.2178685,
                    53.7036225
                ],
                [
                    87.2130554,
                    53.7082016
                ],
                [
                    87.2029663,
                    53.7125145
                ],
                [
                    87.1957142,
                    53.7158104
                ],
                [
                    87.1903184,
                    53.7174216
                ],
                [
                    87.1850463,
                    53.7197504
                ],
                [
                    87.1828187,
                    53.7212736
                ],
                [
                    87.1698794,
                    53.7189308
                ],
                [
                    87.1686192,
                    53.7202151
                ],
                [
                    87.1647337,
                    53.7207329
                ],
                [
                    87.1517996,
                    53.7160005
                ],
                [
                    87.1314002,
                    53.7091116
                ],
                [
                    87.1321353,
                    53.7061695
                ],
                [
                    87.1377359,
                    53.7082414
                ],
                [
                    87.1391711,
                    53.7077441
                ],
                [
                    87.1365108,
                    53.7065631
                ],
                [
                    87.1290622,
                    53.7009123
                ],
                [
                    87.1269726,
                    53.7012714
                ],
                [
                    87.1226848,
                    53.7030575
                ],
                [
                    87.1211796,
                    53.702467
                ],
                [
                    87.120462,
                    53.7028814
                ],
                [
                    87.1190444,
                    53.7024048
                ],
                [
                    87.1172242,
                    53.7002186
                ],
                [
                    87.1088781,
                    53.6976202
                ],
                [
                    87.0979221,
                    53.6979006
                ],
                [
                    87.0915857,
                    53.6986773
                ],
                [
                    87.087873,
                    53.7001426
                ],
                [
                    87.081784,
                    53.6999961
                ],
                [
                    87.071636,
                    53.7002891
                ],
                [
                    87.0730385,
                    53.7079833
                ],
                [
                    87.0713933,
                    53.7086878
                ],
                [
                    87.0638325,
                    53.7086463
                ],
                [
                    87.0475689,
                    53.7106385
                ],
                [
                    87.0461205,
                    53.7136806
                ],
                [
                    87.0442653,
                    53.712852
                ],
                [
                    87.0391198,
                    53.7128313
                ],
                [
                    87.0363195,
                    53.705642
                ],
                [
                    87.0306138,
                    53.7018916
                ],
                [
                    87.0260633,
                    53.6993842
                ],
                [
                    87.0247682,
                    53.6999022
                ],
                [
                    87.0188525,
                    53.6969388
                ],
                [
                    87.0170323,
                    53.6959233
                ],
                [
                    87.014092,
                    53.6958404
                ],
                [
                    87.0123068,
                    53.6973947
                ],
                [
                    87.0073013,
                    53.6965657
                ],
                [
                    86.9989994,
                    53.6883901
                ],
                [
                    86.9951091,
                    53.6847012
                ],
                [
                    86.9839013,
                    53.6792263
                ],
                [
                    86.9833321,
                    53.678332
                ],
                [
                    86.976179,
                    53.67452
                ],
                [
                    86.9836306,
                    53.670959
                ],
                [
                    86.98425,
                    53.6671425
                ],
                [
                    86.9833816,
                    53.6667631
                ],
                [
                    86.981649,
                    53.6671004
                ],
                [
                    86.977268,
                    53.6659712
                ],
                [
                    86.9775403,
                    53.6647247
                ],
                [
                    86.9716742,
                    53.6627008
                ],
                [
                    86.972788,
                    53.660794
                ],
                [
                    86.9707832,
                    53.6596794
                ],
                [
                    86.9712782,
                    53.6581687
                ],
                [
                    86.9661299,
                    53.6564965
                ],
                [
                    86.9640657,
                    53.6550559
                ],
                [
                    86.9608975,
                    53.6543518
                ],
                [
                    86.9460962,
                    53.6585763
                ],
                [
                    86.9411392,
                    53.6605363
                ],
                [
                    86.9397103,
                    53.6607764
                ],
                [
                    86.9397103,
                    53.6632696
                ],
                [
                    86.9375322,
                    53.6634456
                ],
                [
                    86.9307998,
                    53.660483
                ],
                [
                    86.9282256,
                    53.6579896
                ],
                [
                    86.926295,
                    53.6575789
                ],
                [
                    86.9252059,
                    53.6554373
                ],
                [
                    86.917533,
                    53.6528555
                ],
                [
                    86.9126322,
                    53.6523567
                ],
                [
                    86.9104046,
                    53.6502736
                ],
                [
                    86.9079294,
                    53.6507137
                ],
                [
                    86.8987714,
                    53.6474568
                ],
                [
                    86.8949102,
                    53.6476035
                ],
                [
                    86.8919583,
                    53.6471739
                ],
                [
                    86.8897123,
                    53.6462537
                ],
                [
                    86.8882273,
                    53.6464297
                ],
                [
                    86.8827325,
                    53.6446984
                ],
                [
                    86.8793663,
                    53.6446984
                ],
                [
                    86.8724854,
                    53.6403258
                ],
                [
                    86.8705313,
                    53.64094
                ],
                [
                    86.8689211,
                    53.6429964
                ],
                [
                    86.8673058,
                    53.6440162
                ],
                [
                    86.8697132,
                    53.6460482
                ],
                [
                    86.8674856,
                    53.6485718
                ],
                [
                    86.8673371,
                    53.6502736
                ],
                [
                    86.8638224,
                    53.6498335
                ],
                [
                    86.8613967,
                    53.6485718
                ],
                [
                    86.8593918,
                    53.650479
                ],
                [
                    86.8592186,
                    53.6511245
                ]
            ],
            "longitude": 87.136101,
            "latitude": 53.757607
        },
        "11": {
            "name": "МЕЖДУРЕЧЕНСК",
            "population": 98734,
            "type": "city",
            "poly": [
                [
                    87.9808014,
                    53.7093253
                ],
                [
                    87.9862946,
                    53.7149639
                ],
                [
                    87.9871529,
                    53.7135416
                ],
                [
                    87.9906719,
                    53.7141004
                ],
                [
                    87.9968517,
                    53.7125257
                ],
                [
                    88.000285,
                    53.7120685
                ],
                [
                    88.0031174,
                    53.7112557
                ],
                [
                    88.0110996,
                    53.7077504
                ],
                [
                    88.0116146,
                    53.7068867
                ],
                [
                    88.0174511,
                    53.7061247
                ],
                [
                    88.0237168,
                    53.7056674
                ],
                [
                    88.0258625,
                    53.7063279
                ],
                [
                    88.0274933,
                    53.7062771
                ],
                [
                    88.0294674,
                    53.7059214
                ],
                [
                    88.0359905,
                    53.7050577
                ],
                [
                    88.0416554,
                    53.7083092
                ],
                [
                    88.0542707,
                    53.7017388
                ],
                [
                    88.06318,
                    53.6981658
                ],
                [
                    88.0718678,
                    53.7002816
                ],
                [
                    88.0745285,
                    53.703127
                ],
                [
                    88.085944,
                    53.7055658
                ],
                [
                    88.0902355,
                    53.7064803
                ],
                [
                    88.0953854,
                    53.7061247
                ],
                [
                    88.0994194,
                    53.7070391
                ],
                [
                    88.108775,
                    53.7039908
                ],
                [
                    88.1135815,
                    53.6982999
                ],
                [
                    88.1195896,
                    53.6981474
                ],
                [
                    88.1208771,
                    53.6957591
                ],
                [
                    88.113324,
                    53.6878307
                ],
                [
                    88.1110066,
                    53.6876782
                ],
                [
                    88.1083458,
                    53.680155
                ],
                [
                    88.1044834,
                    53.6762913
                ],
                [
                    88.0928105,
                    53.6754778
                ],
                [
                    88.0852012,
                    53.6736748
                ],
                [
                    88.0820816,
                    53.6729356
                ],
                [
                    88.0812233,
                    53.6706983
                ],
                [
                    88.0767601,
                    53.6725797
                ],
                [
                    88.0680912,
                    53.6745626
                ],
                [
                    88.0469769,
                    53.6754778
                ],
                [
                    88.0461186,
                    53.6762913
                ],
                [
                    88.0415695,
                    53.6764438
                ],
                [
                    88.0330723,
                    53.6783757
                ],
                [
                    88.0319565,
                    53.6791383
                ],
                [
                    88.030669,
                    53.6790874
                ],
                [
                    88.0289524,
                    53.6803584
                ],
                [
                    88.0262917,
                    53.6800025
                ],
                [
                    88.0217426,
                    53.6864075
                ],
                [
                    88.0150479,
                    53.6895588
                ],
                [
                    88.0011433,
                    53.6956066
                ],
                [
                    87.9943627,
                    53.7037875
                ],
                [
                    87.9941052,
                    53.7046005
                ],
                [
                    87.9808014,
                    53.7093253
                ]
            ],
            "longitude": 88.0703443,
            "latitude": 53.6863763
        },
        "12": {
            "name": "АБАКАН",
            "population": 176212,
            "type": "city",
            "poly": [
                [
                    91.2836879,
                    53.6489535
                ],
                [
                    91.3082377,
                    53.658111
                ],
                [
                    91.3236539,
                    53.6638664
                ],
                [
                    91.3410664,
                    53.6704275
                ],
                [
                    91.3334362,
                    53.6770317
                ],
                [
                    91.3360538,
                    53.6809108
                ],
                [
                    91.3305979,
                    53.6853774
                ],
                [
                    91.3296,
                    53.6860449
                ],
                [
                    91.3144274,
                    53.6814417
                ],
                [
                    91.3121013,
                    53.6808925
                ],
                [
                    91.3103933,
                    53.6904872
                ],
                [
                    91.3089298,
                    53.6953791
                ],
                [
                    91.2991928,
                    53.7335023
                ],
                [
                    91.3378397,
                    53.734346
                ],
                [
                    91.3434987,
                    53.734659
                ],
                [
                    91.3662037,
                    53.7317605
                ],
                [
                    91.3746844,
                    53.7317391
                ],
                [
                    91.3741791,
                    53.7310534
                ],
                [
                    91.3729333,
                    53.7313034
                ],
                [
                    91.3727054,
                    53.7307376
                ],
                [
                    91.3738121,
                    53.7305468
                ],
                [
                    91.3732393,
                    53.7297671
                ],
                [
                    91.373274,
                    53.7294038
                ],
                [
                    91.3733013,
                    53.7287892
                ],
                [
                    91.3733223,
                    53.7280086
                ],
                [
                    91.3733814,
                    53.7274228
                ],
                [
                    91.3733418,
                    53.7270779
                ],
                [
                    91.3733273,
                    53.7268567
                ],
                [
                    91.3731685,
                    53.7265523
                ],
                [
                    91.3730869,
                    53.7263891
                ],
                [
                    91.3730721,
                    53.7260333
                ],
                [
                    91.3725816,
                    53.7253817
                ],
                [
                    91.3711933,
                    53.7234893
                ],
                [
                    91.3721608,
                    53.7232658
                ],
                [
                    91.3724685,
                    53.7232958
                ],
                [
                    91.3725986,
                    53.7233242
                ],
                [
                    91.3727537,
                    53.7233823
                ],
                [
                    91.3728757,
                    53.7234591
                ],
                [
                    91.3730995,
                    53.7236351
                ],
                [
                    91.373486,
                    53.723826
                ],
                [
                    91.3745011,
                    53.7242976
                ],
                [
                    91.3749893,
                    53.7249709
                ],
                [
                    91.3754681,
                    53.7254124
                ],
                [
                    91.375916,
                    53.7258428
                ],
                [
                    91.3761748,
                    53.7260879
                ],
                [
                    91.3764227,
                    53.7263256
                ],
                [
                    91.3768089,
                    53.7266454
                ],
                [
                    91.3772752,
                    53.7270581
                ],
                [
                    91.3769058,
                    53.7274176
                ],
                [
                    91.37741,
                    53.7278129
                ],
                [
                    91.3781662,
                    53.7281814
                ],
                [
                    91.3786444,
                    53.7285104
                ],
                [
                    91.3808203,
                    53.7301844
                ],
                [
                    91.3828489,
                    53.7297839
                ],
                [
                    91.3834449,
                    53.7301779
                ],
                [
                    91.3842291,
                    53.7306419
                ],
                [
                    91.3847592,
                    53.7307673
                ],
                [
                    91.387198,
                    53.7319688
                ],
                [
                    91.3901387,
                    53.7327303
                ],
                [
                    91.3939838,
                    53.733962
                ],
                [
                    91.3954375,
                    53.7344727
                ],
                [
                    91.3960682,
                    53.734548
                ],
                [
                    91.396584,
                    53.7344333
                ],
                [
                    91.3971493,
                    53.7345668
                ],
                [
                    91.3980224,
                    53.7349274
                ],
                [
                    91.3999596,
                    53.7352946
                ],
                [
                    91.4016548,
                    53.7360406
                ],
                [
                    91.4025406,
                    53.7367287
                ],
                [
                    91.4028496,
                    53.7370007
                ],
                [
                    91.4032561,
                    53.7373978
                ],
                [
                    91.4081365,
                    53.7418347
                ],
                [
                    91.4098099,
                    53.7459672
                ],
                [
                    91.4107313,
                    53.7471615
                ],
                [
                    91.4060013,
                    53.7492284
                ],
                [
                    91.4056131,
                    53.7484346
                ],
                [
                    91.4054766,
                    53.7483023
                ],
                [
                    91.4051344,
                    53.7482556
                ],
                [
                    91.405085,
                    53.7480765
                ],
                [
                    91.4036504,
                    53.7470892
                ],
                [
                    91.4025033,
                    53.7466339
                ],
                [
                    91.4024666,
                    53.7466166
                ],
                [
                    91.3995316,
                    53.7454436
                ],
                [
                    91.3989191,
                    53.7450724
                ],
                [
                    91.3981945,
                    53.7448833
                ],
                [
                    91.3973721,
                    53.7447594
                ],
                [
                    91.3963494,
                    53.7444897
                ],
                [
                    91.3962226,
                    53.7443962
                ],
                [
                    91.3955558,
                    53.7434171
                ],
                [
                    91.3943498,
                    53.7435192
                ],
                [
                    91.3936325,
                    53.7434803
                ],
                [
                    91.3924282,
                    53.7436243
                ],
                [
                    91.3915792,
                    53.7434998
                ],
                [
                    91.3930731,
                    53.7453446
                ],
                [
                    91.394646,
                    53.7451266
                ],
                [
                    91.3965216,
                    53.74745
                ],
                [
                    91.3951264,
                    53.7478664
                ],
                [
                    91.3962715,
                    53.7492985
                ],
                [
                    91.3969954,
                    53.7490845
                ],
                [
                    91.4005162,
                    53.7496954
                ],
                [
                    91.4002004,
                    53.7504075
                ],
                [
                    91.4003187,
                    53.7505437
                ],
                [
                    91.3994304,
                    53.752466
                ],
                [
                    91.3998485,
                    53.7525989
                ],
                [
                    91.4016051,
                    53.7518033
                ],
                [
                    91.4045727,
                    53.7509738
                ],
                [
                    91.4057889,
                    53.7506157
                ],
                [
                    91.4067212,
                    53.7511387
                ],
                [
                    91.4133105,
                    53.7484971
                ],
                [
                    91.4161957,
                    53.7489099
                ],
                [
                    91.4567509,
                    53.7479959
                ],
                [
                    91.4572376,
                    53.7483777
                ],
                [
                    91.4576806,
                    53.747908
                ],
                [
                    91.4604939,
                    53.7473726
                ],
                [
                    91.4616795,
                    53.7469033
                ],
                [
                    91.4713258,
                    53.7411474
                ],
                [
                    91.4758442,
                    53.7402818
                ],
                [
                    91.4769247,
                    53.739788
                ],
                [
                    91.4800384,
                    53.7377256
                ],
                [
                    91.4808869,
                    53.7370916
                ],
                [
                    91.4863218,
                    53.730485
                ],
                [
                    91.5108232,
                    53.7298
                ],
                [
                    91.5119079,
                    53.7298836
                ],
                [
                    91.5128918,
                    53.7293851
                ],
                [
                    91.51437,
                    53.7285762
                ],
                [
                    91.5152379,
                    53.727018
                ],
                [
                    91.513583,
                    53.7260121
                ],
                [
                    91.5161007,
                    53.7245075
                ],
                [
                    91.5282062,
                    53.7176048
                ],
                [
                    91.5300735,
                    53.716822
                ],
                [
                    91.5338047,
                    53.715724
                ],
                [
                    91.5368907,
                    53.7149085
                ],
                [
                    91.5403575,
                    53.7131937
                ],
                [
                    91.5424723,
                    53.7121998
                ],
                [
                    91.5437059,
                    53.7115801
                ],
                [
                    91.5455771,
                    53.7125863
                ],
                [
                    91.5467744,
                    53.7128931
                ],
                [
                    91.5478059,
                    53.711758
                ],
                [
                    91.5461732,
                    53.7102855
                ],
                [
                    91.5471321,
                    53.7101045
                ],
                [
                    91.5487545,
                    53.7099235
                ],
                [
                    91.5501591,
                    53.7100002
                ],
                [
                    91.5513772,
                    53.7100523
                ],
                [
                    91.5543213,
                    53.7103223
                ],
                [
                    91.556944,
                    53.7099296
                ],
                [
                    91.5592091,
                    53.7094909
                ],
                [
                    91.5615779,
                    53.7094618
                ],
                [
                    91.5638585,
                    53.7091995
                ],
                [
                    91.565372,
                    53.7087884
                ],
                [
                    91.567124,
                    53.7081717
                ],
                [
                    91.5683138,
                    53.7074292
                ],
                [
                    91.5683365,
                    53.7070362
                ],
                [
                    91.5692121,
                    53.7065334
                ],
                [
                    91.5702421,
                    53.703993
                ],
                [
                    91.5704699,
                    53.7009777
                ],
                [
                    91.5701933,
                    53.6999225
                ],
                [
                    91.5693175,
                    53.6983165
                ],
                [
                    91.5680265,
                    53.6968013
                ],
                [
                    91.5680891,
                    53.6967339
                ],
                [
                    91.5677933,
                    53.6965622
                ],
                [
                    91.566963,
                    53.6957238
                ],
                [
                    91.5668379,
                    53.6954342
                ],
                [
                    91.5643257,
                    53.693773
                ],
                [
                    91.5513773,
                    53.691084
                ],
                [
                    91.5448567,
                    53.6893866
                ],
                [
                    91.5394412,
                    53.6889082
                ],
                [
                    91.53314,
                    53.6888157
                ],
                [
                    91.5275158,
                    53.6891288
                ],
                [
                    91.5258318,
                    53.6895394
                ],
                [
                    91.5257184,
                    53.6895671
                ],
                [
                    91.5255868,
                    53.6895991
                ],
                [
                    91.5226748,
                    53.6902709
                ],
                [
                    91.5218627,
                    53.6905622
                ],
                [
                    91.5213053,
                    53.6907621
                ],
                [
                    91.5201828,
                    53.6912369
                ],
                [
                    91.5192207,
                    53.691737
                ],
                [
                    91.5190042,
                    53.6918815
                ],
                [
                    91.514174,
                    53.6911165
                ],
                [
                    91.5140604,
                    53.6910985
                ],
                [
                    91.5153296,
                    53.6894689
                ],
                [
                    91.5156499,
                    53.689497
                ],
                [
                    91.5197415,
                    53.6840458
                ],
                [
                    91.5228486,
                    53.6848928
                ],
                [
                    91.5265414,
                    53.6801663
                ],
                [
                    91.5260203,
                    53.6800199
                ],
                [
                    91.5279282,
                    53.677537
                ],
                [
                    91.5282199,
                    53.6769569
                ],
                [
                    91.528504,
                    53.6754466
                ],
                [
                    91.5288041,
                    53.6751233
                ],
                [
                    91.5273626,
                    53.6748379
                ],
                [
                    91.5282675,
                    53.6736877
                ],
                [
                    91.5278583,
                    53.6735637
                ],
                [
                    91.5351293,
                    53.6639516
                ],
                [
                    91.5344426,
                    53.6637772
                ],
                [
                    91.5351667,
                    53.6623213
                ],
                [
                    91.5370013,
                    53.6583516
                ],
                [
                    91.5360783,
                    53.6581424
                ],
                [
                    91.5330921,
                    53.6542893
                ],
                [
                    91.5341101,
                    53.6531711
                ],
                [
                    91.534083,
                    53.6517311
                ],
                [
                    91.5367434,
                    53.652246
                ],
                [
                    91.5371777,
                    53.6525437
                ],
                [
                    91.5371352,
                    53.6548248
                ],
                [
                    91.537366,
                    53.6552672
                ],
                [
                    91.5382754,
                    53.6553799
                ],
                [
                    91.5407728,
                    53.6534251
                ],
                [
                    91.5425647,
                    53.6523229
                ],
                [
                    91.5429854,
                    53.6524677
                ],
                [
                    91.5433654,
                    53.6521218
                ],
                [
                    91.5435012,
                    53.6514541
                ],
                [
                    91.5423543,
                    53.6501065
                ],
                [
                    91.5397538,
                    53.6476151
                ],
                [
                    91.5341105,
                    53.6460924
                ],
                [
                    91.532224,
                    53.6462413
                ],
                [
                    91.528404,
                    53.646247
                ],
                [
                    91.5283944,
                    53.6476692
                ],
                [
                    91.5287975,
                    53.6480334
                ],
                [
                    91.5271467,
                    53.6487105
                ],
                [
                    91.523749,
                    53.6436469
                ],
                [
                    91.5267915,
                    53.643994
                ],
                [
                    91.5323918,
                    53.6457535
                ],
                [
                    91.534242,
                    53.6457208
                ],
                [
                    91.5355528,
                    53.6412538
                ],
                [
                    91.5369614,
                    53.6395387
                ],
                [
                    91.5394036,
                    53.6372062
                ],
                [
                    91.5455982,
                    53.6323911
                ],
                [
                    91.5531426,
                    53.6296567
                ],
                [
                    91.5580411,
                    53.6271194
                ],
                [
                    91.558283,
                    53.6252902
                ],
                [
                    91.5575271,
                    53.6233444
                ],
                [
                    91.5531124,
                    53.6197844
                ],
                [
                    91.5514644,
                    53.6149057
                ],
                [
                    91.5503909,
                    53.6151748
                ],
                [
                    91.5433606,
                    53.6157846
                ],
                [
                    91.5420807,
                    53.6122567
                ],
                [
                    91.5245295,
                    53.610165
                ],
                [
                    91.5244674,
                    53.6073359
                ],
                [
                    91.5201651,
                    53.6074557
                ],
                [
                    91.5221532,
                    53.6130583
                ],
                [
                    91.511933,
                    53.6129938
                ],
                [
                    91.5129427,
                    53.6176467
                ],
                [
                    91.5227434,
                    53.6175914
                ],
                [
                    91.5227153,
                    53.6204346
                ],
                [
                    91.5233443,
                    53.621729
                ],
                [
                    91.523134,
                    53.6232078
                ],
                [
                    91.523394,
                    53.6241779
                ],
                [
                    91.523645,
                    53.6293797
                ],
                [
                    91.5234306,
                    53.630597
                ],
                [
                    91.523308,
                    53.6372096
                ],
                [
                    91.5228829,
                    53.6411784
                ],
                [
                    91.5177817,
                    53.641217
                ],
                [
                    91.5161809,
                    53.6405904
                ],
                [
                    91.5154112,
                    53.6404927
                ],
                [
                    91.5135499,
                    53.6404678
                ],
                [
                    91.5097298,
                    53.640094
                ],
                [
                    91.5086357,
                    53.6400619
                ],
                [
                    91.5082675,
                    53.6391115
                ],
                [
                    91.5058411,
                    53.6369986
                ],
                [
                    91.5063805,
                    53.6309014
                ],
                [
                    91.5007781,
                    53.6313343
                ],
                [
                    91.4994731,
                    53.6293373
                ],
                [
                    91.4941422,
                    53.6273478
                ],
                [
                    91.4866052,
                    53.6260033
                ],
                [
                    91.4836334,
                    53.625758
                ],
                [
                    91.4719214,
                    53.6282039
                ],
                [
                    91.4649568,
                    53.6283715
                ],
                [
                    91.4599804,
                    53.6303951
                ],
                [
                    91.4564036,
                    53.6371429
                ],
                [
                    91.4777777,
                    53.6466179
                ],
                [
                    91.484346,
                    53.6492882
                ],
                [
                    91.510339,
                    53.6541927
                ],
                [
                    91.5194142,
                    53.6562802
                ],
                [
                    91.5178437,
                    53.6630729
                ],
                [
                    91.5166047,
                    53.6668022
                ],
                [
                    91.5136486,
                    53.6701495
                ],
                [
                    91.5105139,
                    53.6731589
                ],
                [
                    91.5055456,
                    53.6746341
                ],
                [
                    91.4946423,
                    53.6759479
                ],
                [
                    91.494791,
                    53.6779955
                ],
                [
                    91.492537,
                    53.6792007
                ],
                [
                    91.4900167,
                    53.680897
                ],
                [
                    91.4913344,
                    53.6830706
                ],
                [
                    91.4926279,
                    53.6855088
                ],
                [
                    91.492273,
                    53.6885433
                ],
                [
                    91.4955535,
                    53.6918299
                ],
                [
                    91.4954239,
                    53.6927934
                ],
                [
                    91.4943229,
                    53.6929374
                ],
                [
                    91.4923514,
                    53.6929111
                ],
                [
                    91.4915255,
                    53.693531
                ],
                [
                    91.4899776,
                    53.6944163
                ],
                [
                    91.4885265,
                    53.6947287
                ],
                [
                    91.4869499,
                    53.6954929
                ],
                [
                    91.4870222,
                    53.6964103
                ],
                [
                    91.4864665,
                    53.6976043
                ],
                [
                    91.4878385,
                    53.6997756
                ],
                [
                    91.4882089,
                    53.7017411
                ],
                [
                    91.485975,
                    53.7037351
                ],
                [
                    91.4844358,
                    53.7058176
                ],
                [
                    91.4846118,
                    53.708155
                ],
                [
                    91.4734991,
                    53.7067197
                ],
                [
                    91.4693697,
                    53.7050103
                ],
                [
                    91.4668104,
                    53.7025686
                ],
                [
                    91.4649929,
                    53.7000055
                ],
                [
                    91.4621851,
                    53.6985317
                ],
                [
                    91.4589689,
                    53.6947074
                ],
                [
                    91.4542658,
                    53.6937648
                ],
                [
                    91.449073,
                    53.6902693
                ],
                [
                    91.4443368,
                    53.6871729
                ],
                [
                    91.440022,
                    53.6817304
                ],
                [
                    91.4404756,
                    53.6752872
                ],
                [
                    91.442597,
                    53.673086
                ],
                [
                    91.4429235,
                    53.6711318
                ],
                [
                    91.4452102,
                    53.6700063
                ],
                [
                    91.444832,
                    53.6676798
                ],
                [
                    91.4410208,
                    53.6654268
                ],
                [
                    91.4367919,
                    53.6651947
                ],
                [
                    91.431321,
                    53.6634425
                ],
                [
                    91.4297504,
                    53.6630084
                ],
                [
                    91.423712,
                    53.66568
                ],
                [
                    91.415046,
                    53.6689436
                ],
                [
                    91.4017664,
                    53.6710285
                ],
                [
                    91.3941885,
                    53.6703506
                ],
                [
                    91.3593467,
                    53.6599062
                ],
                [
                    91.3578424,
                    53.6596803
                ],
                [
                    91.3558967,
                    53.6596447
                ],
                [
                    91.3320612,
                    53.6603515
                ],
                [
                    91.3294671,
                    53.6569475
                ],
                [
                    91.3209922,
                    53.6530438
                ],
                [
                    91.3193217,
                    53.6538532
                ],
                [
                    91.3166274,
                    53.654703
                ],
                [
                    91.3142482,
                    53.654787
                ],
                [
                    91.3111915,
                    53.6540212
                ],
                [
                    91.3072366,
                    53.6525832
                ],
                [
                    91.3063543,
                    53.6513879
                ],
                [
                    91.3090743,
                    53.649806
                ],
                [
                    91.3092184,
                    53.6490335
                ],
                [
                    91.3081404,
                    53.647083
                ],
                [
                    91.308566,
                    53.6462002
                ],
                [
                    91.3103389,
                    53.6455613
                ],
                [
                    91.30616,
                    53.6431524
                ],
                [
                    91.3047768,
                    53.6415102
                ],
                [
                    91.3005044,
                    53.6397027
                ],
                [
                    91.2984084,
                    53.639227
                ],
                [
                    91.2947017,
                    53.6373636
                ],
                [
                    91.293012,
                    53.6386809
                ],
                [
                    91.2940325,
                    53.6392109
                ],
                [
                    91.2934809,
                    53.6397669
                ],
                [
                    91.2925682,
                    53.639535
                ],
                [
                    91.2918912,
                    53.6410809
                ],
                [
                    91.2932953,
                    53.6416843
                ],
                [
                    91.2940776,
                    53.6427278
                ],
                [
                    91.294004,
                    53.6436042
                ],
                [
                    91.2853282,
                    53.6420454
                ],
                [
                    91.2837964,
                    53.6445257
                ],
                [
                    91.2836879,
                    53.6489535
                ]
            ],
            "longitude": 91.438873,
            "latitude": 53.71529
        },
        "13": {
            "name": "ЧИТА",
            "population": 339453,
            "type": "city",
            "poly": [
                [
                    113.4181091,
                    52.0550243
                ],
                [
                    113.422288,
                    52.0568184
                ],
                [
                    113.4228298,
                    52.061964
                ],
                [
                    113.4429624,
                    52.0705512
                ],
                [
                    113.4265929,
                    52.0851128
                ],
                [
                    113.4379537,
                    52.1010401
                ],
                [
                    113.4723219,
                    52.0856941
                ],
                [
                    113.4812483,
                    52.0828591
                ],
                [
                    113.4972987,
                    52.083874
                ],
                [
                    113.4946621,
                    52.0985638
                ],
                [
                    113.4846899,
                    52.098509
                ],
                [
                    113.4849585,
                    52.1059091
                ],
                [
                    113.4949114,
                    52.106062
                ],
                [
                    113.5230693,
                    52.0802482
                ],
                [
                    113.4913548,
                    52.078758
                ],
                [
                    113.4967944,
                    52.067544
                ],
                [
                    113.510656,
                    52.0663041
                ],
                [
                    113.5115787,
                    52.0582832
                ],
                [
                    113.5274359,
                    52.04745
                ],
                [
                    113.5412976,
                    52.0375647
                ],
                [
                    113.5547515,
                    52.0212206
                ],
                [
                    113.5478207,
                    52.015331
                ],
                [
                    113.5266927,
                    51.992243
                ],
                [
                    113.4998414,
                    51.9929278
                ],
                [
                    113.4580847,
                    51.9863474
                ],
                [
                    113.4563065,
                    51.9885512
                ],
                [
                    113.4340521,
                    52.0161234
                ],
                [
                    113.423495,
                    52.0200982
                ],
                [
                    113.4190103,
                    52.02806
                ],
                [
                    113.4200185,
                    52.0371504
                ],
                [
                    113.4210059,
                    52.0460512
                ],
                [
                    113.4181091,
                    52.0550243
                ]
            ],
            "longitude": 113.500893,
            "latitude": 52.033409
        },
        "14": {
            "name": "ОМСК",
            "population": 1173854,
            "type": "city",
            "poly": [
                [
                    [
                        73.0975262,
                        54.9464813
                    ],
                    [
                        73.0981653,
                        54.9518794
                    ],
                    [
                        73.1212504,
                        54.9506127
                    ],
                    [
                        73.1231553,
                        54.9617309
                    ],
                    [
                        73.1239198,
                        54.9624504
                    ],
                    [
                        73.1403877,
                        54.9615294
                    ],
                    [
                        73.139811,
                        54.956418
                    ],
                    [
                        73.1478326,
                        54.9555478
                    ],
                    [
                        73.1483225,
                        54.9571916
                    ],
                    [
                        73.1506953,
                        54.9580618
                    ],
                    [
                        73.1527161,
                        54.9585716
                    ],
                    [
                        73.154997,
                        54.9604437
                    ],
                    [
                        73.1579822,
                        54.9591781
                    ],
                    [
                        73.1589313,
                        54.9600394
                    ],
                    [
                        73.1600794,
                        54.9609183
                    ],
                    [
                        73.1621155,
                        54.9633441
                    ],
                    [
                        73.1636157,
                        54.962764
                    ],
                    [
                        73.1628962,
                        54.9617709
                    ],
                    [
                        73.1623604,
                        54.9585716
                    ],
                    [
                        73.1627125,
                        54.9582024
                    ],
                    [
                        73.163233,
                        54.9583079
                    ],
                    [
                        73.1642433,
                        54.9599252
                    ],
                    [
                        73.1761227,
                        54.9573146
                    ],
                    [
                        73.1762605,
                        54.9567081
                    ],
                    [
                        73.1801335,
                        54.9561807
                    ],
                    [
                        73.1776076,
                        54.9472313
                    ],
                    [
                        73.179414,
                        54.9470819
                    ],
                    [
                        73.1818481,
                        54.9471962
                    ],
                    [
                        73.1909413,
                        54.9466598
                    ],
                    [
                        73.2055303,
                        54.9458509
                    ],
                    [
                        73.2128018,
                        54.9456927
                    ],
                    [
                        73.2130621,
                        54.9461938
                    ],
                    [
                        73.215144,
                        54.9459301
                    ],
                    [
                        73.215144,
                        54.9453761
                    ],
                    [
                        73.2362232,
                        54.9440813
                    ],
                    [
                        73.2362522,
                        54.9442761
                    ],
                    [
                        73.2357554,
                        54.9448244
                    ],
                    [
                        73.2365488,
                        54.9468621
                    ],
                    [
                        73.2347325,
                        54.9470155
                    ],
                    [
                        73.2350148,
                        54.9479492
                    ],
                    [
                        73.2374258,
                        54.9477193
                    ],
                    [
                        73.2380951,
                        54.9473517
                    ],
                    [
                        73.2458125,
                        54.944852
                    ],
                    [
                        73.2471711,
                        54.9462572
                    ],
                    [
                        73.2466837,
                        54.946928
                    ],
                    [
                        73.2462452,
                        54.9480089
                    ],
                    [
                        73.2479704,
                        54.9499034
                    ],
                    [
                        73.2510595,
                        54.9513066
                    ],
                    [
                        73.2520563,
                        54.9510385
                    ],
                    [
                        73.2536016,
                        54.9525492
                    ],
                    [
                        73.2444069,
                        54.9556212
                    ],
                    [
                        73.2447912,
                        54.9567815
                    ],
                    [
                        73.2437757,
                        54.9584334
                    ],
                    [
                        73.244072,
                        54.958793
                    ],
                    [
                        73.2323898,
                        54.9629682
                    ],
                    [
                        73.2302029,
                        54.9638611
                    ],
                    [
                        73.227595,
                        54.9646802
                    ],
                    [
                        73.2255251,
                        54.965036
                    ],
                    [
                        73.2223676,
                        54.9658752
                    ],
                    [
                        73.2203561,
                        54.9667278
                    ],
                    [
                        73.219023,
                        54.9670433
                    ],
                    [
                        73.2035979,
                        54.9721517
                    ],
                    [
                        73.1920086,
                        54.9757897
                    ],
                    [
                        73.1823138,
                        54.9738029
                    ],
                    [
                        73.1793902,
                        54.9735613
                    ],
                    [
                        73.1627259,
                        54.9804558
                    ],
                    [
                        73.1614117,
                        54.9797081
                    ],
                    [
                        73.1550236,
                        54.9825083
                    ],
                    [
                        73.1570349,
                        54.9835051
                    ],
                    [
                        73.158052,
                        54.9848034
                    ],
                    [
                        73.159789,
                        54.9865542
                    ],
                    [
                        73.1515495,
                        54.9895309
                    ],
                    [
                        73.1536865,
                        54.990875
                    ],
                    [
                        73.1561549,
                        54.9912945
                    ],
                    [
                        73.1570349,
                        54.9924484
                    ],
                    [
                        73.1542808,
                        54.9967358
                    ],
                    [
                        73.1659029,
                        55.0064036
                    ],
                    [
                        73.1690227,
                        55.0103946
                    ],
                    [
                        73.170634,
                        55.0102505
                    ],
                    [
                        73.1713516,
                        55.0113841
                    ],
                    [
                        73.179593,
                        55.0143423
                    ],
                    [
                        73.1804306,
                        55.0142271
                    ],
                    [
                        73.1809108,
                        55.0156805
                    ],
                    [
                        73.1840264,
                        55.0148418
                    ],
                    [
                        73.1836244,
                        55.0228574
                    ],
                    [
                        73.181994,
                        55.0233887
                    ],
                    [
                        73.1815696,
                        55.023696
                    ],
                    [
                        73.1819046,
                        55.0239072
                    ],
                    [
                        73.1809443,
                        55.0244129
                    ],
                    [
                        73.1810224,
                        55.0245025
                    ],
                    [
                        73.1786142,
                        55.0257571
                    ],
                    [
                        73.180708,
                        55.0270823
                    ],
                    [
                        73.1883418,
                        55.0236191
                    ],
                    [
                        73.195016,
                        55.0209059
                    ],
                    [
                        73.1999671,
                        55.0200182
                    ],
                    [
                        73.2042202,
                        55.0198681
                    ],
                    [
                        73.2076009,
                        55.0203182
                    ],
                    [
                        73.208626,
                        55.0213686
                    ],
                    [
                        73.2085891,
                        55.0253497
                    ],
                    [
                        73.1954602,
                        55.0308784
                    ],
                    [
                        73.1793241,
                        55.041896
                    ],
                    [
                        73.1693677,
                        55.0485838
                    ],
                    [
                        73.1597547,
                        55.0529106
                    ],
                    [
                        73.1559781,
                        55.0584167
                    ],
                    [
                        73.1535216,
                        55.0661543
                    ],
                    [
                        73.1491117,
                        55.0800407
                    ],
                    [
                        73.1463651,
                        55.0912413
                    ],
                    [
                        73.138553,
                        55.1099792
                    ],
                    [
                        73.1374387,
                        55.1126512
                    ],
                    [
                        73.1449918,
                        55.126002
                    ],
                    [
                        73.1522016,
                        55.1309093
                    ],
                    [
                        73.1559781,
                        55.1354235
                    ],
                    [
                        73.1592583,
                        55.1412567
                    ],
                    [
                        73.168712,
                        55.1396626
                    ],
                    [
                        73.1699226,
                        55.1409685
                    ],
                    [
                        73.1732987,
                        55.140413
                    ],
                    [
                        73.1722074,
                        55.1390778
                    ],
                    [
                        73.1816195,
                        55.1374209
                    ],
                    [
                        73.1792835,
                        55.1331128
                    ],
                    [
                        73.1874339,
                        55.1319041
                    ],
                    [
                        73.1838761,
                        55.1241616
                    ],
                    [
                        73.1828764,
                        55.1242211
                    ],
                    [
                        73.1815017,
                        55.119612
                    ],
                    [
                        73.1804812,
                        55.1150381
                    ],
                    [
                        73.1797252,
                        55.10894
                    ],
                    [
                        73.1771651,
                        55.1028007
                    ],
                    [
                        73.1902947,
                        55.1038835
                    ],
                    [
                        73.1916448,
                        55.100245
                    ],
                    [
                        73.2177355,
                        55.1069145
                    ],
                    [
                        73.2414258,
                        55.1134571
                    ],
                    [
                        73.2631967,
                        55.1191017
                    ],
                    [
                        73.2793057,
                        55.0994819
                    ],
                    [
                        73.283164,
                        55.0950893
                    ],
                    [
                        73.297809,
                        55.0824926
                    ],
                    [
                        73.3061551,
                        55.0753937
                    ],
                    [
                        73.312337,
                        55.0692479
                    ],
                    [
                        73.3178347,
                        55.0631154
                    ],
                    [
                        73.3206209,
                        55.060266
                    ],
                    [
                        73.3223222,
                        55.0574911
                    ],
                    [
                        73.325034,
                        55.0569297
                    ],
                    [
                        73.3323151,
                        55.0535683
                    ],
                    [
                        73.3286745,
                        55.050688
                    ],
                    [
                        73.3297574,
                        55.0492299
                    ],
                    [
                        73.3289857,
                        55.0488627
                    ],
                    [
                        73.3329165,
                        55.0441116
                    ],
                    [
                        73.3346269,
                        55.0448357
                    ],
                    [
                        73.3351788,
                        55.044568
                    ],
                    [
                        73.3358051,
                        55.0442641
                    ],
                    [
                        73.3350698,
                        55.0437249
                    ],
                    [
                        73.3343549,
                        55.0432135
                    ],
                    [
                        73.3420384,
                        55.0345779
                    ],
                    [
                        73.3425325,
                        55.0338427
                    ],
                    [
                        73.3437678,
                        55.0324541
                    ],
                    [
                        73.3479962,
                        55.0277869
                    ],
                    [
                        73.3507042,
                        55.0270625
                    ],
                    [
                        73.3516734,
                        55.0269154
                    ],
                    [
                        73.3530322,
                        55.027215
                    ],
                    [
                        73.3557315,
                        55.0291751
                    ],
                    [
                        73.3592135,
                        55.0314262
                    ],
                    [
                        73.3682573,
                        55.0377638
                    ],
                    [
                        73.3863242,
                        55.0503232
                    ],
                    [
                        73.3926261,
                        55.0521468
                    ],
                    [
                        73.4178287,
                        55.0593022
                    ],
                    [
                        73.4187433,
                        55.0597221
                    ],
                    [
                        73.4090601,
                        55.0655211
                    ],
                    [
                        73.3845252,
                        55.0590819
                    ],
                    [
                        73.3836397,
                        55.059481
                    ],
                    [
                        73.3830952,
                        55.0596057
                    ],
                    [
                        73.3828194,
                        55.0600256
                    ],
                    [
                        73.3819048,
                        55.0604039
                    ],
                    [
                        73.3809103,
                        55.0612603
                    ],
                    [
                        73.3823548,
                        55.062154
                    ],
                    [
                        73.3855923,
                        55.063372
                    ],
                    [
                        73.3884305,
                        55.0646773
                    ],
                    [
                        73.3995953,
                        55.0721548
                    ],
                    [
                        73.4042583,
                        55.072105
                    ],
                    [
                        73.4095225,
                        55.0693863
                    ],
                    [
                        73.4119342,
                        55.0708535
                    ],
                    [
                        73.408157,
                        55.072945
                    ],
                    [
                        73.4114376,
                        55.0751024
                    ],
                    [
                        73.4171389,
                        55.0721429
                    ],
                    [
                        73.4176088,
                        55.0720668
                    ],
                    [
                        73.4205348,
                        55.0739857
                    ],
                    [
                        73.4252429,
                        55.0721429
                    ],
                    [
                        73.4237977,
                        55.0710819
                    ],
                    [
                        73.426564,
                        55.0696807
                    ],
                    [
                        73.4257217,
                        55.0668122
                    ],
                    [
                        73.4324613,
                        55.0632088
                    ],
                    [
                        73.4333923,
                        55.0637673
                    ],
                    [
                        73.4462245,
                        55.0560853
                    ],
                    [
                        73.4387454,
                        55.0518489
                    ],
                    [
                        73.4612621,
                        55.0386831
                    ],
                    [
                        73.4697186,
                        55.0387477
                    ],
                    [
                        73.473297,
                        55.0394279
                    ],
                    [
                        73.4766658,
                        55.0404618
                    ],
                    [
                        73.4861965,
                        55.0438604
                    ],
                    [
                        73.4857252,
                        55.0443497
                    ],
                    [
                        73.5030999,
                        55.0542429
                    ],
                    [
                        73.5052695,
                        55.0544369
                    ],
                    [
                        73.5094182,
                        55.0567162
                    ],
                    [
                        73.5080953,
                        55.0579225
                    ],
                    [
                        73.5049097,
                        55.059244
                    ],
                    [
                        73.5003376,
                        55.0621534
                    ],
                    [
                        73.4972472,
                        55.060238
                    ],
                    [
                        73.4953104,
                        55.0616564
                    ],
                    [
                        73.4975326,
                        55.0633322
                    ],
                    [
                        73.503798,
                        55.0664776
                    ],
                    [
                        73.5065392,
                        55.065611
                    ],
                    [
                        73.5074388,
                        55.0654352
                    ],
                    [
                        73.5095131,
                        55.0658292
                    ],
                    [
                        73.512159,
                        55.0669988
                    ],
                    [
                        73.5171967,
                        55.069138
                    ],
                    [
                        73.5184138,
                        55.0707136
                    ],
                    [
                        73.5290291,
                        55.0755672
                    ],
                    [
                        73.5310505,
                        55.0748158
                    ],
                    [
                        73.5350511,
                        55.0745614
                    ],
                    [
                        73.5375065,
                        55.0728102
                    ],
                    [
                        73.5400042,
                        55.0711923
                    ],
                    [
                        73.5242729,
                        55.0637795
                    ],
                    [
                        73.5151798,
                        55.0588778
                    ],
                    [
                        73.5220106,
                        55.0597383
                    ],
                    [
                        73.5249296,
                        55.0601023
                    ],
                    [
                        73.5248237,
                        55.0560762
                    ],
                    [
                        73.5276434,
                        55.054374
                    ],
                    [
                        73.5296622,
                        55.0527588
                    ],
                    [
                        73.5337317,
                        55.0490264
                    ],
                    [
                        73.5393811,
                        55.0436641
                    ],
                    [
                        73.5489605,
                        55.0346859
                    ],
                    [
                        73.5513133,
                        55.0324558
                    ],
                    [
                        73.5545598,
                        55.0293748
                    ],
                    [
                        73.5574021,
                        55.026665
                    ],
                    [
                        73.5572783,
                        55.0264221
                    ],
                    [
                        73.5569645,
                        55.0261239
                    ],
                    [
                        73.5566929,
                        55.0257692
                    ],
                    [
                        73.5554403,
                        55.025272
                    ],
                    [
                        73.5538328,
                        55.0251059
                    ],
                    [
                        73.5515982,
                        55.0254048
                    ],
                    [
                        73.5492205,
                        55.0262961
                    ],
                    [
                        73.5480276,
                        55.0265782
                    ],
                    [
                        73.5461472,
                        55.0266988
                    ],
                    [
                        73.5436224,
                        55.0263012
                    ],
                    [
                        73.5406917,
                        55.0257302
                    ],
                    [
                        73.5382151,
                        55.0255632
                    ],
                    [
                        73.5347819,
                        55.0252188
                    ],
                    [
                        73.5331894,
                        55.0248321
                    ],
                    [
                        73.5312628,
                        55.0241364
                    ],
                    [
                        73.5296911,
                        55.0229124
                    ],
                    [
                        73.5285753,
                        55.021791
                    ],
                    [
                        73.5269997,
                        55.0210342
                    ],
                    [
                        73.5260338,
                        55.0201105
                    ],
                    [
                        73.5249633,
                        55.0187765
                    ],
                    [
                        73.5232637,
                        55.0179038
                    ],
                    [
                        73.5209578,
                        55.0175036
                    ],
                    [
                        73.5197615,
                        55.0174446
                    ],
                    [
                        73.5171955,
                        55.017834
                    ],
                    [
                        73.5159728,
                        55.0177743
                    ],
                    [
                        73.5167986,
                        55.0166384
                    ],
                    [
                        73.5186849,
                        55.0135694
                    ],
                    [
                        73.5254696,
                        55.0101321
                    ],
                    [
                        73.525519,
                        55.0095488
                    ],
                    [
                        73.5222303,
                        55.0092996
                    ],
                    [
                        73.5222402,
                        55.0090731
                    ],
                    [
                        73.5192281,
                        55.0088296
                    ],
                    [
                        73.5188923,
                        55.0084331
                    ],
                    [
                        73.515337,
                        55.0081443
                    ],
                    [
                        73.5155444,
                        55.0076572
                    ],
                    [
                        73.5266106,
                        55.0033948
                    ],
                    [
                        73.5313018,
                        55.0042015
                    ],
                    [
                        73.5448656,
                        55.0063785
                    ],
                    [
                        73.552797,
                        55.0071926
                    ],
                    [
                        73.561176,
                        55.0077147
                    ],
                    [
                        73.5625716,
                        55.0017562
                    ],
                    [
                        73.5635786,
                        54.9943327
                    ],
                    [
                        73.5637745,
                        54.9944198
                    ],
                    [
                        73.5639957,
                        54.9942566
                    ],
                    [
                        73.5638188,
                        54.9941732
                    ],
                    [
                        73.5649501,
                        54.9933864
                    ],
                    [
                        73.5651966,
                        54.9934734
                    ],
                    [
                        73.5664165,
                        54.9935169
                    ],
                    [
                        73.566505,
                        54.9935858
                    ],
                    [
                        73.5672761,
                        54.9936003
                    ],
                    [
                        73.5678196,
                        54.9935097
                    ],
                    [
                        73.5775342,
                        54.9936481
                    ],
                    [
                        73.5777965,
                        54.9935419
                    ],
                    [
                        73.5692941,
                        54.990169
                    ],
                    [
                        73.5723957,
                        54.988062
                    ],
                    [
                        73.5936726,
                        54.9962319
                    ],
                    [
                        73.606699,
                        54.9881849
                    ],
                    [
                        73.5911857,
                        54.9823142
                    ],
                    [
                        73.5997348,
                        54.9754771
                    ],
                    [
                        73.6001535,
                        54.9748151
                    ],
                    [
                        73.6008961,
                        54.9741168
                    ],
                    [
                        73.6011884,
                        54.9741375
                    ],
                    [
                        73.6017674,
                        54.9733759
                    ],
                    [
                        73.602829,
                        54.9700662
                    ],
                    [
                        73.6031788,
                        54.9687159
                    ],
                    [
                        73.6032874,
                        54.9661745
                    ],
                    [
                        73.6046143,
                        54.9613614
                    ],
                    [
                        73.6069546,
                        54.9615761
                    ],
                    [
                        73.608185,
                        54.9610843
                    ],
                    [
                        73.6090536,
                        54.9600454
                    ],
                    [
                        73.6100138,
                        54.9596981
                    ],
                    [
                        73.6114123,
                        54.9553836
                    ],
                    [
                        73.612781,
                        54.95548
                    ],
                    [
                        73.6145985,
                        54.9495854
                    ],
                    [
                        73.6152633,
                        54.9474847
                    ],
                    [
                        73.5752218,
                        54.9434337
                    ],
                    [
                        73.5656562,
                        54.9423694
                    ],
                    [
                        73.5539035,
                        54.9413005
                    ],
                    [
                        73.5482336,
                        54.940598
                    ],
                    [
                        73.5485645,
                        54.9396805
                    ],
                    [
                        73.5333461,
                        54.9374974
                    ],
                    [
                        73.5330518,
                        54.9357507
                    ],
                    [
                        73.5292646,
                        54.9343811
                    ],
                    [
                        73.5230782,
                        54.9337613
                    ],
                    [
                        73.5249341,
                        54.9284859
                    ],
                    [
                        73.5236564,
                        54.9262718
                    ],
                    [
                        73.525117,
                        54.9249747
                    ],
                    [
                        73.5278237,
                        54.9193897
                    ],
                    [
                        73.519751,
                        54.9175084
                    ],
                    [
                        73.5189695,
                        54.9176016
                    ],
                    [
                        73.514347,
                        54.9172457
                    ],
                    [
                        73.5118625,
                        54.9166143
                    ],
                    [
                        73.5218244,
                        54.9042976
                    ],
                    [
                        73.519582,
                        54.9029669
                    ],
                    [
                        73.5154089,
                        54.9023831
                    ],
                    [
                        73.5027061,
                        54.9006058
                    ],
                    [
                        73.5010401,
                        54.9007404
                    ],
                    [
                        73.5003467,
                        54.9006524
                    ],
                    [
                        73.4996713,
                        54.9
                    ],
                    [
                        73.4978072,
                        54.8999637
                    ],
                    [
                        73.4935837,
                        54.8964994
                    ],
                    [
                        73.4930253,
                        54.8959401
                    ],
                    [
                        73.4980233,
                        54.894806
                    ],
                    [
                        73.5053716,
                        54.8926464
                    ],
                    [
                        73.511108,
                        54.8905799
                    ],
                    [
                        73.5226439,
                        54.8865951
                    ],
                    [
                        73.5277544,
                        54.8854231
                    ],
                    [
                        73.5331126,
                        54.8845231
                    ],
                    [
                        73.5370299,
                        54.884277
                    ],
                    [
                        73.5431648,
                        54.8843741
                    ],
                    [
                        73.5649464,
                        54.8825481
                    ],
                    [
                        73.5972192,
                        54.880599
                    ],
                    [
                        73.6009093,
                        54.8866602
                    ],
                    [
                        73.6031606,
                        54.8858003
                    ],
                    [
                        73.6081382,
                        54.8901908
                    ],
                    [
                        73.6125177,
                        54.8885014
                    ],
                    [
                        73.6599421,
                        54.8698453
                    ],
                    [
                        73.648552,
                        54.8600883
                    ],
                    [
                        73.6286835,
                        54.8682861
                    ],
                    [
                        73.6181567,
                        54.8592807
                    ],
                    [
                        73.6061355,
                        54.8489701
                    ],
                    [
                        73.5962231,
                        54.8406181
                    ],
                    [
                        73.5896548,
                        54.8350939
                    ],
                    [
                        73.5838881,
                        54.833652
                    ],
                    [
                        73.5814408,
                        54.8319913
                    ],
                    [
                        73.5690097,
                        54.8373771
                    ],
                    [
                        73.5593125,
                        54.8414743
                    ],
                    [
                        73.5467859,
                        54.8468207
                    ],
                    [
                        73.5417587,
                        54.8482758
                    ],
                    [
                        73.53349,
                        54.8512333
                    ],
                    [
                        73.5277211,
                        54.853052
                    ],
                    [
                        73.5211556,
                        54.8547599
                    ],
                    [
                        73.5176119,
                        54.8558827
                    ],
                    [
                        73.4826537,
                        54.8666399
                    ],
                    [
                        73.4768519,
                        54.8681676
                    ],
                    [
                        73.4713138,
                        54.8704035
                    ],
                    [
                        73.4677623,
                        54.86924
                    ],
                    [
                        73.4639648,
                        54.8730742
                    ],
                    [
                        73.4615737,
                        54.8747029
                    ],
                    [
                        73.4586904,
                        54.8761292
                    ],
                    [
                        73.4589365,
                        54.8763315
                    ],
                    [
                        73.4574597,
                        54.8772317
                    ],
                    [
                        73.451148,
                        54.8802863
                    ],
                    [
                        73.4438694,
                        54.8829969
                    ],
                    [
                        73.4413728,
                        54.8808527
                    ],
                    [
                        73.4385598,
                        54.879194
                    ],
                    [
                        73.4438166,
                        54.8766248
                    ],
                    [
                        73.4348644,
                        54.8724257
                    ],
                    [
                        73.4343963,
                        54.8726702
                    ],
                    [
                        73.4275825,
                        54.8693693
                    ],
                    [
                        73.4192938,
                        54.8663855
                    ],
                    [
                        73.4189265,
                        54.8654696
                    ],
                    [
                        73.42114,
                        54.863853
                    ],
                    [
                        73.4296877,
                        54.854
                    ],
                    [
                        73.4311308,
                        54.8532167
                    ],
                    [
                        73.4372938,
                        54.8553074
                    ],
                    [
                        73.4454931,
                        54.8465795
                    ],
                    [
                        73.4394982,
                        54.8473271
                    ],
                    [
                        73.4368161,
                        54.8476615
                    ],
                    [
                        73.4261731,
                        54.8450918
                    ],
                    [
                        73.41862,
                        54.8413356
                    ],
                    [
                        73.4088317,
                        54.8355441
                    ],
                    [
                        73.3862796,
                        54.8275726
                    ],
                    [
                        73.3757794,
                        54.8251882
                    ],
                    [
                        73.3637959,
                        54.8240406
                    ],
                    [
                        73.3533708,
                        54.8250837
                    ],
                    [
                        73.3453357,
                        54.8271701
                    ],
                    [
                        73.3399991,
                        54.8308562
                    ],
                    [
                        73.3303861,
                        54.83837
                    ],
                    [
                        73.3197431,
                        54.8433126
                    ],
                    [
                        73.3154431,
                        54.8474333
                    ],
                    [
                        73.3125165,
                        54.851899
                    ],
                    [
                        73.3114767,
                        54.8578513
                    ],
                    [
                        73.3116807,
                        54.860515
                    ],
                    [
                        73.3118466,
                        54.8626816
                    ],
                    [
                        73.3132199,
                        54.8765109
                    ],
                    [
                        73.3152665,
                        54.8794724
                    ],
                    [
                        73.3121467,
                        54.8807673
                    ],
                    [
                        73.3103543,
                        54.8814326
                    ],
                    [
                        73.3117779,
                        54.8845771
                    ],
                    [
                        73.3055164,
                        54.8846713
                    ],
                    [
                        73.3044822,
                        54.8821127
                    ],
                    [
                        73.3010926,
                        54.883514
                    ],
                    [
                        73.3032704,
                        54.891269
                    ],
                    [
                        73.3041129,
                        54.8942685
                    ],
                    [
                        73.3022368,
                        54.894015
                    ],
                    [
                        73.2871939,
                        54.8945129
                    ],
                    [
                        73.2650763,
                        54.8952708
                    ],
                    [
                        73.2616745,
                        54.8947878
                    ],
                    [
                        73.2543779,
                        54.9127155
                    ],
                    [
                        73.2486551,
                        54.927492
                    ],
                    [
                        73.2456865,
                        54.9350924
                    ],
                    [
                        73.2426912,
                        54.935006
                    ],
                    [
                        73.2380166,
                        54.9357692
                    ],
                    [
                        73.2289304,
                        54.9367556
                    ],
                    [
                        73.2292939,
                        54.9380443
                    ],
                    [
                        73.215671,
                        54.9403553
                    ],
                    [
                        73.2072365,
                        54.9408232
                    ],
                    [
                        73.1915081,
                        54.9416871
                    ],
                    [
                        73.1844397,
                        54.9421838
                    ],
                    [
                        73.1842392,
                        54.9402689
                    ],
                    [
                        73.1687113,
                        54.9411184
                    ],
                    [
                        73.1681599,
                        54.9386851
                    ],
                    [
                        73.1667562,
                        54.9387211
                    ],
                    [
                        73.1660669,
                        54.9413272
                    ],
                    [
                        73.1660168,
                        54.9425366
                    ],
                    [
                        73.1566675,
                        54.9429829
                    ],
                    [
                        73.1500378,
                        54.9433716
                    ],
                    [
                        73.1467166,
                        54.9440411
                    ],
                    [
                        73.1325798,
                        54.944437
                    ],
                    [
                        73.1173653,
                        54.9453584
                    ],
                    [
                        73.1031784,
                        54.9459414
                    ],
                    [
                        73.0975262,
                        54.9464813
                    ]
                ],
                [
                    [
                        73.1971984,
                        55.1708928
                    ],
                    [
                        73.1978236,
                        55.1717419
                    ],
                    [
                        73.1989049,
                        55.1722919
                    ],
                    [
                        73.2014224,
                        55.174627
                    ],
                    [
                        73.2048353,
                        55.1772514
                    ],
                    [
                        73.2062039,
                        55.1792293
                    ],
                    [
                        73.2072008,
                        55.1828181
                    ],
                    [
                        73.2074035,
                        55.1852297
                    ],
                    [
                        73.2070318,
                        55.1860689
                    ],
                    [
                        73.2067784,
                        55.1879402
                    ],
                    [
                        73.2067615,
                        55.1903226
                    ],
                    [
                        73.206981,
                        55.1951834
                    ],
                    [
                        73.2067445,
                        55.1965625
                    ],
                    [
                        73.2063222,
                        55.2008151
                    ],
                    [
                        73.2062039,
                        55.2025796
                    ],
                    [
                        73.206356,
                        55.2031196
                    ],
                    [
                        73.2085017,
                        55.2026953
                    ],
                    [
                        73.2091776,
                        55.2024543
                    ],
                    [
                        73.2092621,
                        55.2026278
                    ],
                    [
                        73.2110699,
                        55.2023289
                    ],
                    [
                        73.2104617,
                        55.2012104
                    ],
                    [
                        73.2113234,
                        55.2010851
                    ],
                    [
                        73.2123201,
                        55.2008054
                    ],
                    [
                        73.2132833,
                        55.2003329
                    ],
                    [
                        73.212202,
                        55.1981729
                    ],
                    [
                        73.2126244,
                        55.1949327
                    ],
                    [
                        73.2104109,
                        55.194817
                    ],
                    [
                        73.2105124,
                        55.1923963
                    ],
                    [
                        73.2106306,
                        55.1918755
                    ],
                    [
                        73.2105462,
                        55.1912678
                    ],
                    [
                        73.2107827,
                        55.1873133
                    ],
                    [
                        73.211391,
                        55.1868117
                    ],
                    [
                        73.2123709,
                        55.1865512
                    ],
                    [
                        73.2153784,
                        55.1859918
                    ],
                    [
                        73.2168483,
                        55.185548
                    ],
                    [
                        73.2179297,
                        55.1847667
                    ],
                    [
                        73.2192306,
                        55.1857699
                    ],
                    [
                        73.2206499,
                        55.1849017
                    ],
                    [
                        73.2192306,
                        55.1834355
                    ],
                    [
                        73.2200079,
                        55.1811491
                    ],
                    [
                        73.2244684,
                        55.1834933
                    ],
                    [
                        73.225347,
                        55.1837924
                    ],
                    [
                        73.2294864,
                        55.1873904
                    ],
                    [
                        73.2337104,
                        55.1872554
                    ],
                    [
                        73.2330683,
                        55.1858181
                    ],
                    [
                        73.234099,
                        55.1853648
                    ],
                    [
                        73.2349269,
                        55.1848728
                    ],
                    [
                        73.2363293,
                        55.1838599
                    ],
                    [
                        73.2330515,
                        55.1805221
                    ],
                    [
                        73.2325277,
                        55.1794029
                    ],
                    [
                        73.2320715,
                        55.1790749
                    ],
                    [
                        73.233288,
                        55.1785732
                    ],
                    [
                        73.2329163,
                        55.1779943
                    ],
                    [
                        73.2344369,
                        55.1775312
                    ],
                    [
                        73.2331697,
                        55.176248
                    ],
                    [
                        73.2348593,
                        55.1757752
                    ],
                    [
                        73.2333725,
                        55.1742411
                    ],
                    [
                        73.2324263,
                        55.1724946
                    ],
                    [
                        73.2331697,
                        55.1722341
                    ],
                    [
                        73.2326122,
                        55.1712594
                    ],
                    [
                        73.2352479,
                        55.1697637
                    ],
                    [
                        73.2301623,
                        55.1669748
                    ],
                    [
                        73.2288951,
                        55.1674863
                    ],
                    [
                        73.2261749,
                        55.1687794
                    ],
                    [
                        73.2247894,
                        55.1687987
                    ],
                    [
                        73.2239108,
                        55.1689145
                    ],
                    [
                        73.2233363,
                        55.1684127
                    ],
                    [
                        73.2224071,
                        55.1681907
                    ],
                    [
                        73.2234208,
                        55.1668686
                    ],
                    [
                        73.221275,
                        55.1666177
                    ],
                    [
                        73.2202613,
                        55.1669072
                    ],
                    [
                        73.2203458,
                        55.1665598
                    ],
                    [
                        73.2198896,
                        55.1657009
                    ],
                    [
                        73.2176255,
                        55.1659711
                    ],
                    [
                        73.2173214,
                        55.1657877
                    ],
                    [
                        73.2164963,
                        55.1643892
                    ],
                    [
                        73.2121335,
                        55.1645335
                    ],
                    [
                        73.210266,
                        55.1645719
                    ],
                    [
                        73.2100376,
                        55.1668282
                    ],
                    [
                        73.2096077,
                        55.1674421
                    ],
                    [
                        73.2082641,
                        55.1677951
                    ],
                    [
                        73.2080492,
                        55.1678027
                    ],
                    [
                        73.2075386,
                        55.1679562
                    ],
                    [
                        73.205174,
                        55.168409
                    ],
                    [
                        73.2038439,
                        55.1688157
                    ],
                    [
                        73.1985403,
                        55.1702877
                    ],
                    [
                        73.1982694,
                        55.1704811
                    ],
                    [
                        73.1971984,
                        55.1708928
                    ]
                ],
                [
                    [
                        73.2659731,
                        55.4142082
                    ],
                    [
                        73.2668817,
                        55.4147983
                    ],
                    [
                        73.2675652,
                        55.4146168
                    ],
                    [
                        73.2680522,
                        55.4148313
                    ],
                    [
                        73.2683504,
                        55.4151078
                    ],
                    [
                        73.2677032,
                        55.4153719
                    ],
                    [
                        73.2682704,
                        55.4157144
                    ],
                    [
                        73.2715927,
                        55.4183677
                    ],
                    [
                        73.2725451,
                        55.4189124
                    ],
                    [
                        73.2734902,
                        55.4196923
                    ],
                    [
                        73.2742245,
                        55.4200389
                    ],
                    [
                        73.2744352,
                        55.4205051
                    ],
                    [
                        73.2751987,
                        55.4206495
                    ],
                    [
                        73.2773215,
                        55.4220029
                    ],
                    [
                        73.2783029,
                        55.4231058
                    ],
                    [
                        73.2793935,
                        55.4240671
                    ],
                    [
                        73.2815236,
                        55.4256884
                    ],
                    [
                        73.2826306,
                        55.4265654
                    ],
                    [
                        73.284017,
                        55.4261128
                    ],
                    [
                        73.3083833,
                        55.4169416
                    ],
                    [
                        73.3047844,
                        55.4137859
                    ],
                    [
                        73.304301,
                        55.4135419
                    ],
                    [
                        73.304301,
                        55.4130998
                    ],
                    [
                        73.3021198,
                        55.4109825
                    ],
                    [
                        73.3010591,
                        55.4105403
                    ],
                    [
                        73.2982928,
                        55.4081618
                    ],
                    [
                        73.2973528,
                        55.4070487
                    ],
                    [
                        73.294949,
                        55.4048148
                    ],
                    [
                        73.2933242,
                        55.4035643
                    ],
                    [
                        73.2908667,
                        55.4044717
                    ],
                    [
                        73.290249,
                        55.4043497
                    ],
                    [
                        73.285925,
                        55.4059965
                    ],
                    [
                        73.2811981,
                        55.4078721
                    ],
                    [
                        73.2783647,
                        55.408825
                    ],
                    [
                        73.2762832,
                        55.409412
                    ],
                    [
                        73.2750344,
                        55.4100905
                    ],
                    [
                        73.2733558,
                        55.4105632
                    ],
                    [
                        73.2687632,
                        55.4124156
                    ],
                    [
                        73.2683603,
                        55.4127815
                    ],
                    [
                        73.2679978,
                        55.4127586
                    ],
                    [
                        73.266816,
                        55.4132694
                    ],
                    [
                        73.2663366,
                        55.4136387
                    ],
                    [
                        73.2660458,
                        55.4136841
                    ],
                    [
                        73.2659731,
                        55.4142082
                    ]
                ],
                [
                    [
                        73.2073642,
                        55.3649603
                    ],
                    [
                        73.2077344,
                        55.36572
                    ],
                    [
                        73.2079091,
                        55.3659011
                    ],
                    [
                        73.2078372,
                        55.3672509
                    ],
                    [
                        73.2126283,
                        55.3693134
                    ],
                    [
                        73.2140265,
                        55.3708617
                    ],
                    [
                        73.2158463,
                        55.3720828
                    ],
                    [
                        73.2176147,
                        55.373146
                    ],
                    [
                        73.2205963,
                        55.3754244
                    ],
                    [
                        73.2223441,
                        55.3749512
                    ],
                    [
                        73.2240303,
                        55.3750038
                    ],
                    [
                        73.2278138,
                        55.3736835
                    ],
                    [
                        73.2292738,
                        55.3730175
                    ],
                    [
                        73.2291812,
                        55.3729299
                    ],
                    [
                        73.2292635,
                        55.3728831
                    ],
                    [
                        73.228955,
                        55.3726787
                    ],
                    [
                        73.2288419,
                        55.3727196
                    ],
                    [
                        73.2278034,
                        55.3721003
                    ],
                    [
                        73.2273717,
                        55.3722347
                    ],
                    [
                        73.2272278,
                        55.3721295
                    ],
                    [
                        73.2267651,
                        55.3722814
                    ],
                    [
                        73.2264464,
                        55.3719484
                    ],
                    [
                        73.2265491,
                        55.3719075
                    ],
                    [
                        73.2263641,
                        55.3716563
                    ],
                    [
                        73.2278858,
                        55.3712122
                    ],
                    [
                        73.2277624,
                        55.3710779
                    ],
                    [
                        73.2279783,
                        55.3709669
                    ],
                    [
                        73.2281017,
                        55.3709961
                    ],
                    [
                        73.229428,
                        55.3704527
                    ],
                    [
                        73.2299112,
                        55.3704761
                    ],
                    [
                        73.2305589,
                        55.3710428
                    ],
                    [
                        73.2303019,
                        55.3711655
                    ],
                    [
                        73.2306206,
                        55.3714167
                    ],
                    [
                        73.2312375,
                        55.3711305
                    ],
                    [
                        73.2315871,
                        55.3713525
                    ],
                    [
                        73.2317721,
                        55.3712765
                    ],
                    [
                        73.2320908,
                        55.3715277
                    ],
                    [
                        73.2322245,
                        55.3714635
                    ],
                    [
                        73.2325638,
                        55.3717264
                    ],
                    [
                        73.2334891,
                        55.3713992
                    ],
                    [
                        73.2339004,
                        55.3717848
                    ],
                    [
                        73.234106,
                        55.3717906
                    ],
                    [
                        73.2342294,
                        55.3718666
                    ],
                    [
                        73.2347948,
                        55.3716446
                    ],
                    [
                        73.235679,
                        55.3700613
                    ],
                    [
                        73.2381774,
                        55.3690213
                    ],
                    [
                        73.2374166,
                        55.3677417
                    ],
                    [
                        73.2375297,
                        55.3674554
                    ],
                    [
                        73.2389485,
                        55.3673794
                    ],
                    [
                        73.237396,
                        55.3635754
                    ],
                    [
                        73.2376119,
                        55.3634177
                    ],
                    [
                        73.2378895,
                        55.3628976
                    ],
                    [
                        73.2379409,
                        55.3623892
                    ],
                    [
                        73.2376222,
                        55.3620152
                    ],
                    [
                        73.237468,
                        55.3615068
                    ],
                    [
                        73.2373754,
                        55.3611211
                    ],
                    [
                        73.2372314,
                        55.3606652
                    ],
                    [
                        73.2367687,
                        55.3598938
                    ],
                    [
                        73.2352882,
                        55.3574684
                    ],
                    [
                        73.2347331,
                        55.3564866
                    ],
                    [
                        73.2344966,
                        55.3560657
                    ],
                    [
                        73.2339415,
                        55.3555222
                    ],
                    [
                        73.23133,
                        55.3553819
                    ],
                    [
                        73.2289345,
                        55.3559021
                    ],
                    [
                        73.2276493,
                        55.3562937
                    ],
                    [
                        73.2258501,
                        55.3569366
                    ],
                    [
                        73.2232592,
                        55.3568197
                    ],
                    [
                        73.2221179,
                        55.3569366
                    ],
                    [
                        73.2197635,
                        55.3586315
                    ],
                    [
                        73.2186943,
                        55.3590698
                    ],
                    [
                        73.2175222,
                        55.3598821
                    ],
                    [
                        73.2166277,
                        55.3603438
                    ],
                    [
                        73.2164118,
                        55.3607646
                    ],
                    [
                        73.2148079,
                        55.3618925
                    ],
                    [
                        73.2124124,
                        55.3626288
                    ],
                    [
                        73.2113945,
                        55.3630904
                    ],
                    [
                        73.2104383,
                        55.3636339
                    ],
                    [
                        73.2073642,
                        55.3649603
                    ]
                ],
                [
                    [
                        73.2532095,
                        55.3601884
                    ],
                    [
                        73.2536824,
                        55.3626312
                    ],
                    [
                        73.2542788,
                        55.3647641
                    ],
                    [
                        73.2553377,
                        55.3683226
                    ],
                    [
                        73.2557901,
                        55.3699877
                    ],
                    [
                        73.2560986,
                        55.3705077
                    ],
                    [
                        73.2567566,
                        55.3713081
                    ],
                    [
                        73.2607457,
                        55.3757072
                    ],
                    [
                        73.2630179,
                        55.3782542
                    ],
                    [
                        73.2670438,
                        55.3818938
                    ],
                    [
                        73.2718856,
                        55.3802334
                    ],
                    [
                        73.2712895,
                        55.3794858
                    ],
                    [
                        73.2745319,
                        55.3779658
                    ],
                    [
                        73.2775643,
                        55.376236
                    ],
                    [
                        73.2760118,
                        55.3749859
                    ],
                    [
                        73.2769371,
                        55.3744776
                    ],
                    [
                        73.2752818,
                        55.3731048
                    ],
                    [
                        73.2749117,
                        55.3722226
                    ],
                    [
                        73.2657587,
                        55.3675505
                    ],
                    [
                        73.2609314,
                        55.3686743
                    ],
                    [
                        73.2532095,
                        55.3601884
                    ]
                ]
            ],
            "longitude": 73.371529,
            "latitude": 54.991375
        },
        "15": {
            "name": "СЕВЕРСК",
            "population": 108436,
            "type": "city",
            "poly": [
                [
                    84.7653641,
                    56.6389563
                ],
                [
                    84.7701043,
                    56.6469869
                ],
                [
                    84.7793926,
                    56.6467051
                ],
                [
                    84.7947022,
                    56.643007
                ],
                [
                    84.8637556,
                    56.6766641
                ],
                [
                    84.8645504,
                    56.6807028
                ],
                [
                    84.8639412,
                    56.6885647
                ],
                [
                    84.8680528,
                    56.6915752
                ],
                [
                    84.9004875,
                    56.699184
                ],
                [
                    84.9039898,
                    56.7108868
                ],
                [
                    84.908558,
                    56.7220847
                ],
                [
                    84.9186083,
                    56.7367038
                ],
                [
                    84.956525,
                    56.7288519
                ],
                [
                    84.9740367,
                    56.7189095
                ],
                [
                    84.9728185,
                    56.6986823
                ],
                [
                    84.9583523,
                    56.6884811
                ],
                [
                    84.9603319,
                    56.6647231
                ],
                [
                    84.9620069,
                    56.6559355
                ],
                [
                    84.9318563,
                    56.6280529
                ],
                [
                    84.9317764,
                    56.6053436
                ],
                [
                    84.9416915,
                    56.5965975
                ],
                [
                    84.9487542,
                    56.5987154
                ],
                [
                    84.9570226,
                    56.5935943
                ],
                [
                    84.9488116,
                    56.5910651
                ],
                [
                    84.9649249,
                    56.5761293
                ],
                [
                    84.9678859,
                    56.5712951
                ],
                [
                    84.9672937,
                    56.5688334
                ],
                [
                    84.9640097,
                    56.5662824
                ],
                [
                    84.9468894,
                    56.5602307
                ],
                [
                    84.9425824,
                    56.563138
                ],
                [
                    84.9423599,
                    56.5649529
                ],
                [
                    84.9365315,
                    56.5653049
                ],
                [
                    84.9360008,
                    56.5655216
                ],
                [
                    84.9346836,
                    56.5683267
                ],
                [
                    84.9303984,
                    56.5702923
                ],
                [
                    84.926457,
                    56.5700811
                ],
                [
                    84.9207466,
                    56.5701028
                ],
                [
                    84.9187807,
                    56.571229
                ],
                [
                    84.9153113,
                    56.5714944
                ],
                [
                    84.9124314,
                    56.5753981
                ],
                [
                    84.9078414,
                    56.5814235
                ],
                [
                    84.9017771,
                    56.5870041
                ],
                [
                    84.9008925,
                    56.5875345
                ],
                [
                    84.8959093,
                    56.5913337
                ],
                [
                    84.8942777,
                    56.5929031
                ],
                [
                    84.8886262,
                    56.5961607
                ],
                [
                    84.8834268,
                    56.5981357
                ],
                [
                    84.8788761,
                    56.5992287
                ],
                [
                    84.875721,
                    56.5996507
                ],
                [
                    84.8663641,
                    56.599299
                ],
                [
                    84.8650568,
                    56.5989419
                ],
                [
                    84.8605847,
                    56.59806
                ],
                [
                    84.8572036,
                    56.5974973
                ],
                [
                    84.8523896,
                    56.598308
                ],
                [
                    84.8423426,
                    56.597968
                ],
                [
                    84.8321259,
                    56.5947618
                ],
                [
                    84.8208643,
                    56.5938268
                ],
                [
                    84.8101837,
                    56.5941713
                ],
                [
                    84.7991664,
                    56.604049
                ],
                [
                    84.7976496,
                    56.6134749
                ],
                [
                    84.7789442,
                    56.6281756
                ],
                [
                    84.7653641,
                    56.6389563
                ]
            ],
            "longitude": 84.881012,
            "latitude": 56.603161
        },
        "16": {
            "name": "ТОМСК",
            "population": 564910,
            "type": "city",
            "poly": [
                [
                    84.880681,
                    56.5158273
                ],
                [
                    84.8829819,
                    56.5173275
                ],
                [
                    84.8885458,
                    56.5185738
                ],
                [
                    84.9042546,
                    56.5227277
                ],
                [
                    84.9180809,
                    56.5258428
                ],
                [
                    84.9264478,
                    56.5277579
                ],
                [
                    84.9289997,
                    56.5305497
                ],
                [
                    84.9316771,
                    56.5342294
                ],
                [
                    84.9326811,
                    56.5368015
                ],
                [
                    84.932702,
                    56.539408
                ],
                [
                    84.9320536,
                    56.5428332
                ],
                [
                    84.9296272,
                    56.5467999
                ],
                [
                    84.9277656,
                    56.5483104
                ],
                [
                    84.9260294,
                    56.5489792
                ],
                [
                    84.9242933,
                    56.5502705
                ],
                [
                    84.9224944,
                    56.5521844
                ],
                [
                    84.915378,
                    56.5574807
                ],
                [
                    84.9146532,
                    56.5580838
                ],
                [
                    84.9133664,
                    56.5598526
                ],
                [
                    84.9119465,
                    56.5628926
                ],
                [
                    84.9115915,
                    56.5646122
                ],
                [
                    84.9111922,
                    56.5665355
                ],
                [
                    84.9111182,
                    56.5670081
                ],
                [
                    84.9114822,
                    56.5700775
                ],
                [
                    84.9161263,
                    56.5697235
                ],
                [
                    84.9184249,
                    56.5694769
                ],
                [
                    84.9200097,
                    56.569157
                ],
                [
                    84.9218062,
                    56.5686271
                ],
                [
                    84.9218309,
                    56.5679755
                ],
                [
                    84.9215002,
                    56.5651838
                ],
                [
                    84.9228176,
                    56.5641092
                ],
                [
                    84.9245634,
                    56.5637046
                ],
                [
                    84.9266652,
                    56.5620739
                ],
                [
                    84.9290887,
                    56.5633206
                ],
                [
                    84.9461221,
                    56.557014
                ],
                [
                    84.9600536,
                    56.5528774
                ],
                [
                    84.96131,
                    56.5397813
                ],
                [
                    84.96557,
                    56.5397624
                ],
                [
                    84.9659122,
                    56.5423281
                ],
                [
                    84.9672638,
                    56.5438561
                ],
                [
                    84.9689062,
                    56.5454124
                ],
                [
                    84.9775973,
                    56.5445069
                ],
                [
                    84.9816351,
                    56.5476759
                ],
                [
                    84.9877429,
                    56.5499204
                ],
                [
                    84.999103,
                    56.5538998
                ],
                [
                    85.0322596,
                    56.5456765
                ],
                [
                    85.0384871,
                    56.54711
                ],
                [
                    85.0452306,
                    56.5391423
                ],
                [
                    85.0614504,
                    56.5438961
                ],
                [
                    85.0635,
                    56.5419089
                ],
                [
                    85.084137,
                    56.5255402
                ],
                [
                    85.0890248,
                    56.5255058
                ],
                [
                    85.090959,
                    56.5235532
                ],
                [
                    85.1033273,
                    56.5241974
                ],
                [
                    85.1080525,
                    56.5233633
                ],
                [
                    85.1089585,
                    56.5210113
                ],
                [
                    85.1103177,
                    56.5209819
                ],
                [
                    85.1098631,
                    56.519213
                ],
                [
                    85.1097604,
                    56.5171973
                ],
                [
                    85.110588,
                    56.5172567
                ],
                [
                    85.1110238,
                    56.51711
                ],
                [
                    85.1113441,
                    56.5132113
                ],
                [
                    85.1102415,
                    56.5123148
                ],
                [
                    85.1139661,
                    56.5117115
                ],
                [
                    85.1204926,
                    56.5112606
                ],
                [
                    85.1247409,
                    56.5114148
                ],
                [
                    85.1315045,
                    56.5105203
                ],
                [
                    85.1392744,
                    56.5104586
                ],
                [
                    85.1404063,
                    56.5092323
                ],
                [
                    85.1425785,
                    56.5073281
                ],
                [
                    85.138456,
                    56.506283
                ],
                [
                    85.1365929,
                    56.5051691
                ],
                [
                    85.1355076,
                    56.5042333
                ],
                [
                    85.1329784,
                    56.501552
                ],
                [
                    85.1327905,
                    56.4994133
                ],
                [
                    85.1325077,
                    56.4972329
                ],
                [
                    85.1326686,
                    56.4961641
                ],
                [
                    85.1323923,
                    56.4938635
                ],
                [
                    85.132349,
                    56.4923014
                ],
                [
                    85.1317878,
                    56.4894331
                ],
                [
                    85.1319228,
                    56.4883988
                ],
                [
                    85.1306143,
                    56.4875861
                ],
                [
                    85.1301603,
                    56.4865513
                ],
                [
                    85.1315757,
                    56.4845595
                ],
                [
                    85.1345749,
                    56.4828629
                ],
                [
                    85.1378365,
                    56.482423
                ],
                [
                    85.1393959,
                    56.4812423
                ],
                [
                    85.1435996,
                    56.4806155
                ],
                [
                    85.1387381,
                    56.479074
                ],
                [
                    85.147449,
                    56.4713899
                ],
                [
                    85.1497489,
                    56.4684198
                ],
                [
                    85.1449894,
                    56.4666849
                ],
                [
                    85.1474202,
                    56.4644686
                ],
                [
                    85.1477357,
                    56.4637356
                ],
                [
                    85.1268099,
                    56.4563061
                ],
                [
                    85.1250114,
                    56.4576383
                ],
                [
                    85.1185292,
                    56.4586976
                ],
                [
                    85.1047918,
                    56.4536311
                ],
                [
                    85.1007741,
                    56.4541904
                ],
                [
                    85.0997173,
                    56.4582025
                ],
                [
                    85.0902138,
                    56.4627612
                ],
                [
                    85.0896407,
                    56.4630014
                ],
                [
                    85.088534,
                    56.4630451
                ],
                [
                    85.0849289,
                    56.4620867
                ],
                [
                    85.0834763,
                    56.4619229
                ],
                [
                    85.0816284,
                    56.4619993
                ],
                [
                    85.0794348,
                    56.4620703
                ],
                [
                    85.0769839,
                    56.4595092
                ],
                [
                    85.0701617,
                    56.4605999
                ],
                [
                    85.0665309,
                    56.463277
                ],
                [
                    85.0648959,
                    56.4634005
                ],
                [
                    85.0650077,
                    56.4637209
                ],
                [
                    85.064791,
                    56.4641957
                ],
                [
                    85.0640714,
                    56.4643849
                ],
                [
                    85.0633657,
                    56.4642999
                ],
                [
                    85.0626809,
                    56.4639989
                ],
                [
                    85.0605917,
                    56.4625744
                ],
                [
                    85.0601096,
                    56.4621614
                ],
                [
                    85.0594458,
                    56.4619143
                ],
                [
                    85.0586982,
                    56.461868
                ],
                [
                    85.0572937,
                    56.4619568
                ],
                [
                    85.0570168,
                    56.4621405
                ],
                [
                    85.0568213,
                    56.4630515
                ],
                [
                    85.0586158,
                    56.4647795
                ],
                [
                    85.0443075,
                    56.4649469
                ],
                [
                    85.040967,
                    56.4593435
                ],
                [
                    85.041781,
                    56.45405
                ],
                [
                    85.042094,
                    56.451031
                ],
                [
                    85.0403644,
                    56.4486347
                ],
                [
                    85.0465239,
                    56.444378
                ],
                [
                    85.0384234,
                    56.4398094
                ],
                [
                    85.0298219,
                    56.44921
                ],
                [
                    85.0278418,
                    56.4470342
                ],
                [
                    85.0285335,
                    56.4424012
                ],
                [
                    85.0232981,
                    56.4407125
                ],
                [
                    85.011311,
                    56.4464453
                ],
                [
                    85.0111869,
                    56.4464464
                ],
                [
                    85.010341,
                    56.4456377
                ],
                [
                    85.0043366,
                    56.4324867
                ],
                [
                    85.0016856,
                    56.4290484
                ],
                [
                    84.9987529,
                    56.42323
                ],
                [
                    84.9978479,
                    56.4209491
                ],
                [
                    84.997356,
                    56.4196148
                ],
                [
                    84.9979225,
                    56.4188009
                ],
                [
                    84.9981188,
                    56.4185303
                ],
                [
                    84.9971789,
                    56.4177418
                ],
                [
                    84.9959046,
                    56.4128546
                ],
                [
                    84.9972085,
                    56.4075319
                ],
                [
                    84.9962593,
                    56.4062153
                ],
                [
                    84.9942179,
                    56.4049851
                ],
                [
                    84.9948099,
                    56.4030108
                ],
                [
                    84.9884256,
                    56.3992986
                ],
                [
                    84.9839785,
                    56.3999122
                ],
                [
                    84.980146,
                    56.3998745
                ],
                [
                    84.979673,
                    56.4000364
                ],
                [
                    84.9801021,
                    56.4007595
                ],
                [
                    84.9558505,
                    56.4060291
                ],
                [
                    84.9565331,
                    56.4161718
                ],
                [
                    84.9558505,
                    56.4213789
                ],
                [
                    84.9575733,
                    56.4225259
                ],
                [
                    84.9558505,
                    56.4235794
                ],
                [
                    84.9565656,
                    56.4251902
                ],
                [
                    84.9548167,
                    56.4310934
                ],
                [
                    84.9515336,
                    56.4357448
                ],
                [
                    84.943667,
                    56.4400255
                ],
                [
                    84.9426007,
                    56.440597
                ],
                [
                    84.9358719,
                    56.4394684
                ],
                [
                    84.9347276,
                    56.4400219
                ],
                [
                    84.934214,
                    56.4406868
                ],
                [
                    84.9307943,
                    56.4405898
                ],
                [
                    84.9282718,
                    56.439375
                ],
                [
                    84.9266595,
                    56.43926
                ],
                [
                    84.9265489,
                    56.4398063
                ],
                [
                    84.9260678,
                    56.4416823
                ],
                [
                    84.9224596,
                    56.4415853
                ],
                [
                    84.9221345,
                    56.4434181
                ],
                [
                    84.9253137,
                    56.4435618
                ],
                [
                    84.924943,
                    56.4454305
                ],
                [
                    84.9192089,
                    56.4494766
                ],
                [
                    84.9189814,
                    56.4503605
                ],
                [
                    84.9186953,
                    56.4508239
                ],
                [
                    84.9186108,
                    56.4515318
                ],
                [
                    84.9205352,
                    56.4545353
                ],
                [
                    84.9193455,
                    56.4556993
                ],
                [
                    84.9132732,
                    56.4623305
                ],
                [
                    84.9068499,
                    56.4693592
                ],
                [
                    84.9008556,
                    56.4756756
                ],
                [
                    84.8999065,
                    56.4763794
                ],
                [
                    84.8980471,
                    56.477277
                ],
                [
                    84.8965778,
                    56.4778048
                ],
                [
                    84.8945819,
                    56.4781926
                ],
                [
                    84.8944989,
                    56.4782049
                ],
                [
                    84.8937711,
                    56.4789215
                ],
                [
                    84.8932111,
                    56.4798056
                ],
                [
                    84.8929099,
                    56.4815492
                ],
                [
                    84.89318,
                    56.4825758
                ],
                [
                    84.8939841,
                    56.4838398
                ],
                [
                    84.8950347,
                    56.4849205
                ],
                [
                    84.896631,
                    56.4859554
                ],
                [
                    84.8999073,
                    56.4873645
                ],
                [
                    84.901951,
                    56.4880306
                ],
                [
                    84.9035958,
                    56.4887319
                ],
                [
                    84.9048348,
                    56.4891068
                ],
                [
                    84.9057958,
                    56.4892936
                ],
                [
                    84.9066342,
                    56.4894018
                ],
                [
                    84.9073942,
                    56.4893721
                ],
                [
                    84.9087572,
                    56.4892367
                ],
                [
                    84.9097062,
                    56.4891074
                ],
                [
                    84.9102402,
                    56.4889389
                ],
                [
                    84.9119078,
                    56.4890174
                ],
                [
                    84.9130103,
                    56.4895725
                ],
                [
                    84.9136898,
                    56.4901946
                ],
                [
                    84.9145323,
                    56.4909181
                ],
                [
                    84.9150626,
                    56.4917507
                ],
                [
                    84.915302,
                    56.4932321
                ],
                [
                    84.9151459,
                    56.4943019
                ],
                [
                    84.9146848,
                    56.4951957
                ],
                [
                    84.9136794,
                    56.4960607
                ],
                [
                    84.913194,
                    56.4966731
                ],
                [
                    84.9118157,
                    56.49809
                ],
                [
                    84.9106308,
                    56.4973297
                ],
                [
                    84.9092636,
                    56.4965919
                ],
                [
                    84.9085604,
                    56.4963907
                ],
                [
                    84.9083456,
                    56.4966496
                ],
                [
                    84.9080843,
                    56.4970432
                ],
                [
                    84.9079124,
                    56.4972725
                ],
                [
                    84.907762,
                    56.4977586
                ],
                [
                    84.9076117,
                    56.4979839
                ],
                [
                    84.9073324,
                    56.4982013
                ],
                [
                    84.90696,
                    56.4984385
                ],
                [
                    84.9065518,
                    56.4986005
                ],
                [
                    84.9062009,
                    56.4986243
                ],
                [
                    84.905979,
                    56.498561
                ],
                [
                    84.9057928,
                    56.4985729
                ],
                [
                    84.9056352,
                    56.4986124
                ],
                [
                    84.9054849,
                    56.4987033
                ],
                [
                    84.9053488,
                    56.4988417
                ],
                [
                    84.9052772,
                    56.4991025
                ],
                [
                    84.9051984,
                    56.499395
                ],
                [
                    84.9049335,
                    56.4994899
                ],
                [
                    84.9045611,
                    56.4994938
                ],
                [
                    84.9044179,
                    56.4995531
                ],
                [
                    84.9042388,
                    56.5000551
                ],
                [
                    84.9042532,
                    56.500308
                ],
                [
                    84.9043677,
                    56.50064
                ],
                [
                    84.9044322,
                    56.5009009
                ],
                [
                    84.9043606,
                    56.5010906
                ],
                [
                    84.9038235,
                    56.5014265
                ],
                [
                    84.9033538,
                    56.5017204
                ],
                [
                    84.9025876,
                    56.5020919
                ],
                [
                    84.9021221,
                    56.5022856
                ],
                [
                    84.9017426,
                    56.5024279
                ],
                [
                    84.9014204,
                    56.502499
                ],
                [
                    84.9010265,
                    56.5025306
                ],
                [
                    84.9004751,
                    56.5025227
                ],
                [
                    84.8999882,
                    56.5024792
                ],
                [
                    84.8995155,
                    56.50242
                ],
                [
                    84.8991932,
                    56.5023409
                ],
                [
                    84.8989642,
                    56.5022026
                ],
                [
                    84.8988567,
                    56.5020485
                ],
                [
                    84.8987708,
                    56.501839
                ],
                [
                    84.8986562,
                    56.5017086
                ],
                [
                    84.8982623,
                    56.5016374
                ],
                [
                    84.8977181,
                    56.5017125
                ],
                [
                    84.8973386,
                    56.5018746
                ],
                [
                    84.8969376,
                    56.5019496
                ],
                [
                    84.8965223,
                    56.5019615
                ],
                [
                    84.8961642,
                    56.5018943
                ],
                [
                    84.8958706,
                    56.5017797
                ],
                [
                    84.895663,
                    56.5016335
                ],
                [
                    84.8954983,
                    56.5014517
                ],
                [
                    84.895269,
                    56.5013094
                ],
                [
                    84.8950471,
                    56.5012422
                ],
                [
                    84.8947822,
                    56.501262
                ],
                [
                    84.8938656,
                    56.5013647
                ],
                [
                    84.8930134,
                    56.5013173
                ],
                [
                    84.8918462,
                    56.5014319
                ],
                [
                    84.8901184,
                    56.5018018
                ],
                [
                    84.8893379,
                    56.5018828
                ],
                [
                    84.8881504,
                    56.5019618
                ],
                [
                    84.886797,
                    56.5018947
                ],
                [
                    84.880681,
                    56.5158273
                ]
            ],
            "longitude": 84.952324,
            "latitude": 56.488712
        },
        "17": {
            "name": "НОВОСИБИРСК",
            "population": 1584138,
            "type": "city",
            "poly": [
                [
                    82.751713,
                    54.9908711
                ],
                [
                    82.7522001,
                    54.9921719
                ],
                [
                    82.7524563,
                    54.9928392
                ],
                [
                    82.756365,
                    54.9962336
                ],
                [
                    82.7769239,
                    55.0141153
                ],
                [
                    82.7835433,
                    55.0197365
                ],
                [
                    82.7873464,
                    55.0230139
                ],
                [
                    82.793015,
                    55.0278655
                ],
                [
                    82.7964162,
                    55.0308762
                ],
                [
                    82.797286,
                    55.031586
                ],
                [
                    82.8168976,
                    55.0409745
                ],
                [
                    82.8212968,
                    55.0431091
                ],
                [
                    82.8213555,
                    55.0432505
                ],
                [
                    82.8184135,
                    55.0445066
                ],
                [
                    82.8179981,
                    55.0449718
                ],
                [
                    82.8171862,
                    55.0454478
                ],
                [
                    82.8109142,
                    55.0475186
                ],
                [
                    82.8097389,
                    55.0472918
                ],
                [
                    82.8084221,
                    55.0485084
                ],
                [
                    82.8078893,
                    55.0492288
                ],
                [
                    82.8061404,
                    55.050284
                ],
                [
                    82.8044514,
                    55.0514799
                ],
                [
                    82.803467,
                    55.0520714
                ],
                [
                    82.8030424,
                    55.0525081
                ],
                [
                    82.8023766,
                    55.0528509
                ],
                [
                    82.801894,
                    55.0532157
                ],
                [
                    82.800315,
                    55.0542746
                ],
                [
                    82.7988808,
                    55.0552299
                ],
                [
                    82.7962292,
                    55.0568252
                ],
                [
                    82.7944414,
                    55.0576275
                ],
                [
                    82.7924383,
                    55.0586141
                ],
                [
                    82.7917346,
                    55.059058
                ],
                [
                    82.7888916,
                    55.0611659
                ],
                [
                    82.7877341,
                    55.0623029
                ],
                [
                    82.7861813,
                    55.0646874
                ],
                [
                    82.7845198,
                    55.0660197
                ],
                [
                    82.7837861,
                    55.0671984
                ],
                [
                    82.7820387,
                    55.0688916
                ],
                [
                    82.7807799,
                    55.0711269
                ],
                [
                    82.7801355,
                    55.0730045
                ],
                [
                    82.7798797,
                    55.0738656
                ],
                [
                    82.7794377,
                    55.0744536
                ],
                [
                    82.7799057,
                    55.0745206
                ],
                [
                    82.7788008,
                    55.0774259
                ],
                [
                    82.7783318,
                    55.0804644
                ],
                [
                    82.779284,
                    55.0847793
                ],
                [
                    82.7801326,
                    55.0864519
                ],
                [
                    82.7801813,
                    55.0877314
                ],
                [
                    82.7810601,
                    55.0878876
                ],
                [
                    82.7810396,
                    55.0891472
                ],
                [
                    82.7800554,
                    55.0908482
                ],
                [
                    82.7795059,
                    55.0930107
                ],
                [
                    82.7794763,
                    55.0951004
                ],
                [
                    82.7792818,
                    55.0970943
                ],
                [
                    82.7791592,
                    55.1009168
                ],
                [
                    82.7785507,
                    55.1018916
                ],
                [
                    82.7776988,
                    55.1025592
                ],
                [
                    82.7773909,
                    55.1039189
                ],
                [
                    82.77704,
                    55.1064909
                ],
                [
                    82.7768755,
                    55.107871
                ],
                [
                    82.7771189,
                    55.108993
                ],
                [
                    82.777441,
                    55.1099554
                ],
                [
                    82.777305,
                    55.111925
                ],
                [
                    82.7774124,
                    55.1131657
                ],
                [
                    82.7782428,
                    55.1145455
                ],
                [
                    82.7819161,
                    55.1182071
                ],
                [
                    82.7829439,
                    55.1184391
                ],
                [
                    82.7833413,
                    55.118769
                ],
                [
                    82.7905745,
                    55.1188471
                ],
                [
                    82.821185,
                    55.1208602
                ],
                [
                    82.845237,
                    55.1237772
                ],
                [
                    82.8695365,
                    55.1265995
                ],
                [
                    82.8846161,
                    55.1283513
                ],
                [
                    82.8873589,
                    55.1315445
                ],
                [
                    82.8881085,
                    55.1313595
                ],
                [
                    82.8971691,
                    55.1298944
                ],
                [
                    82.9225412,
                    55.1213765
                ],
                [
                    82.9246725,
                    55.1222297
                ],
                [
                    82.9301542,
                    55.1205961
                ],
                [
                    82.9666365,
                    55.1119661
                ],
                [
                    82.9734484,
                    55.1142991
                ],
                [
                    82.9781729,
                    55.1155683
                ],
                [
                    82.9827835,
                    55.1150132
                ],
                [
                    82.9917249,
                    55.1166366
                ],
                [
                    82.9975002,
                    55.1165197
                ],
                [
                    83.0041466,
                    55.113859
                ],
                [
                    83.0054361,
                    55.1133001
                ],
                [
                    83.0029298,
                    55.106909
                ],
                [
                    83.0014371,
                    55.104426
                ],
                [
                    82.9997738,
                    55.1007336
                ],
                [
                    83.0030713,
                    55.0999313
                ],
                [
                    83.0151259,
                    55.0942268
                ],
                [
                    83.0196358,
                    55.0921179
                ],
                [
                    83.0189684,
                    55.0916742
                ],
                [
                    83.0198111,
                    55.0910713
                ],
                [
                    83.02208,
                    55.0903016
                ],
                [
                    83.0229097,
                    55.0896149
                ],
                [
                    83.0240022,
                    55.0901018
                ],
                [
                    83.0376887,
                    55.0838601
                ],
                [
                    83.0329928,
                    55.0823653
                ],
                [
                    83.0361066,
                    55.0795854
                ],
                [
                    83.0371709,
                    55.0792311
                ],
                [
                    83.0388921,
                    55.0795231
                ],
                [
                    83.0419357,
                    55.0789912
                ],
                [
                    83.0463247,
                    55.0776478
                ],
                [
                    83.0486569,
                    55.0759081
                ],
                [
                    83.0502136,
                    55.0750711
                ],
                [
                    83.0549632,
                    55.0747618
                ],
                [
                    83.0604531,
                    55.0735471
                ],
                [
                    83.0612538,
                    55.0727761
                ],
                [
                    83.061443,
                    55.0716748
                ],
                [
                    83.062727,
                    55.0705329
                ],
                [
                    83.0685221,
                    55.0698844
                ],
                [
                    83.0723787,
                    55.0686274
                ],
                [
                    83.0733491,
                    55.0673921
                ],
                [
                    83.0789915,
                    55.0658392
                ],
                [
                    83.0856233,
                    55.0641626
                ],
                [
                    83.0861477,
                    55.0631675
                ],
                [
                    83.082611,
                    55.0564391
                ],
                [
                    83.0814352,
                    55.0539216
                ],
                [
                    83.0812458,
                    55.0527903
                ],
                [
                    83.0802711,
                    55.0465722
                ],
                [
                    83.079581,
                    55.0428517
                ],
                [
                    83.0772324,
                    55.0293328
                ],
                [
                    83.0760167,
                    55.021697
                ],
                [
                    83.0746275,
                    55.0214623
                ],
                [
                    83.073232,
                    55.013087
                ],
                [
                    83.0720343,
                    55.0061944
                ],
                [
                    83.071323,
                    55.0019072
                ],
                [
                    83.0708056,
                    54.9987335
                ],
                [
                    83.0720542,
                    54.9983941
                ],
                [
                    83.0722536,
                    54.9962281
                ],
                [
                    83.0746148,
                    54.9960335
                ],
                [
                    83.0766633,
                    54.9963798
                ],
                [
                    83.0781448,
                    54.9956034
                ],
                [
                    83.0802664,
                    54.995052
                ],
                [
                    83.0794983,
                    54.9943863
                ],
                [
                    83.0780221,
                    54.9936657
                ],
                [
                    83.0767729,
                    54.9926039
                ],
                [
                    83.0765426,
                    54.9919083
                ],
                [
                    83.0766073,
                    54.9911839
                ],
                [
                    83.0761265,
                    54.9907181
                ],
                [
                    83.0757165,
                    54.9898271
                ],
                [
                    83.0834571,
                    54.984325
                ],
                [
                    83.0870283,
                    54.9843429
                ],
                [
                    83.0894767,
                    54.9840774
                ],
                [
                    83.0928119,
                    54.9835851
                ],
                [
                    83.0953375,
                    54.9829269
                ],
                [
                    83.0972943,
                    54.9824014
                ],
                [
                    83.0978148,
                    54.9821249
                ],
                [
                    83.099521,
                    54.9797795
                ],
                [
                    83.1001156,
                    54.9784799
                ],
                [
                    83.1005614,
                    54.9770762
                ],
                [
                    83.1022724,
                    54.9759213
                ],
                [
                    83.1052124,
                    54.9743169
                ],
                [
                    83.1069958,
                    54.9733695
                ],
                [
                    83.1083814,
                    54.9720485
                ],
                [
                    83.1097189,
                    54.9708036
                ],
                [
                    83.1106949,
                    54.9691852
                ],
                [
                    83.1112492,
                    54.9682861
                ],
                [
                    83.1120565,
                    54.9678296
                ],
                [
                    83.1142856,
                    54.9672831
                ],
                [
                    83.1195752,
                    54.9668266
                ],
                [
                    83.1240454,
                    54.9670756
                ],
                [
                    83.1269494,
                    54.9674145
                ],
                [
                    83.130998,
                    54.9682791
                ],
                [
                    83.1334801,
                    54.9691022
                ],
                [
                    83.1363599,
                    54.9693581
                ],
                [
                    83.137854,
                    54.9691506
                ],
                [
                    83.1392638,
                    54.9687702
                ],
                [
                    83.1413845,
                    54.967622
                ],
                [
                    83.14371,
                    54.9666606
                ],
                [
                    83.1458307,
                    54.9644679
                ],
                [
                    83.1480719,
                    54.9608292
                ],
                [
                    83.1489394,
                    54.9596462
                ],
                [
                    83.1505179,
                    54.958823
                ],
                [
                    83.1527952,
                    54.9578267
                ],
                [
                    83.1609969,
                    54.9567948
                ],
                [
                    83.1607411,
                    54.9563036
                ],
                [
                    83.1602702,
                    54.9553995
                ],
                [
                    83.1567526,
                    54.951441
                ],
                [
                    83.1522864,
                    54.9493373
                ],
                [
                    83.1501213,
                    54.948984
                ],
                [
                    83.1489093,
                    54.9450567
                ],
                [
                    83.1458622,
                    54.9416053
                ],
                [
                    83.146748,
                    54.9361442
                ],
                [
                    83.147811,
                    54.9358069
                ],
                [
                    83.1452178,
                    54.9325804
                ],
                [
                    83.1452178,
                    54.9323899
                ],
                [
                    83.1452178,
                    54.9317787
                ],
                [
                    83.1452178,
                    54.9278354
                ],
                [
                    83.1537399,
                    54.9160501
                ],
                [
                    83.1318664,
                    54.9019791
                ],
                [
                    83.13418,
                    54.9010048
                ],
                [
                    83.1371549,
                    54.8835792
                ],
                [
                    83.1285609,
                    54.8804418
                ],
                [
                    83.123713,
                    54.8770506
                ],
                [
                    83.123778,
                    54.863364
                ],
                [
                    83.1257844,
                    54.8513219
                ],
                [
                    83.1259347,
                    54.8492949
                ],
                [
                    83.1264614,
                    54.8425565
                ],
                [
                    83.1269416,
                    54.8422098
                ],
                [
                    83.1356542,
                    54.8421763
                ],
                [
                    83.1395779,
                    54.8405531
                ],
                [
                    83.1414857,
                    54.8386021
                ],
                [
                    83.1392958,
                    54.8385552
                ],
                [
                    83.1391248,
                    54.8377349
                ],
                [
                    83.1423751,
                    54.8359899
                ],
                [
                    83.1408893,
                    54.8352331
                ],
                [
                    83.1390814,
                    54.8350524
                ],
                [
                    83.1364381,
                    54.8341882
                ],
                [
                    83.1277063,
                    54.8275358
                ],
                [
                    83.1278231,
                    54.8267077
                ],
                [
                    83.1287599,
                    54.8260227
                ],
                [
                    83.1307056,
                    54.8257529
                ],
                [
                    83.1330477,
                    54.8247566
                ],
                [
                    83.1364347,
                    54.8240923
                ],
                [
                    83.1396053,
                    54.8233243
                ],
                [
                    83.1431005,
                    54.8220165
                ],
                [
                    83.1438931,
                    54.8225147
                ],
                [
                    83.1450102,
                    54.8218712
                ],
                [
                    83.146019,
                    54.8189027
                ],
                [
                    83.1447579,
                    54.8174494
                ],
                [
                    83.137338,
                    54.8159723
                ],
                [
                    83.1391551,
                    54.8144664
                ],
                [
                    83.1381913,
                    54.8120656
                ],
                [
                    83.1363234,
                    54.8098065
                ],
                [
                    83.1348643,
                    54.8063694
                ],
                [
                    83.130469,
                    54.8044665
                ],
                [
                    83.1278567,
                    54.8020262
                ],
                [
                    83.1224453,
                    54.8014098
                ],
                [
                    83.1177746,
                    54.8009231
                ],
                [
                    83.1041891,
                    54.8014179
                ],
                [
                    83.1052787,
                    54.806974
                ],
                [
                    83.0986899,
                    54.8079455
                ],
                [
                    83.0984578,
                    54.8082707
                ],
                [
                    83.0983612,
                    54.8083186
                ],
                [
                    83.0957305,
                    54.8085139
                ],
                [
                    83.0954996,
                    54.8085568
                ],
                [
                    83.0953876,
                    54.8086524
                ],
                [
                    83.09474,
                    54.8087332
                ],
                [
                    83.0836341,
                    54.8094514
                ],
                [
                    83.0851129,
                    54.8146197
                ],
                [
                    83.0842705,
                    54.8176128
                ],
                [
                    83.0824679,
                    54.8214326
                ],
                [
                    83.081857,
                    54.8242899
                ],
                [
                    83.082133,
                    54.8257739
                ],
                [
                    83.0807865,
                    54.8283343
                ],
                [
                    83.0798481,
                    54.8292565
                ],
                [
                    83.0788175,
                    54.8302104
                ],
                [
                    83.0772351,
                    54.8315353
                ],
                [
                    83.075579,
                    54.8323195
                ],
                [
                    83.0744014,
                    54.8325209
                ],
                [
                    83.0729109,
                    54.8324573
                ],
                [
                    83.0684762,
                    54.8324997
                ],
                [
                    83.0655082,
                    54.8324261
                ],
                [
                    83.0630822,
                    54.8320121
                ],
                [
                    83.0611056,
                    54.8308477
                ],
                [
                    83.0579608,
                    54.8298126
                ],
                [
                    83.0565233,
                    54.8298126
                ],
                [
                    83.0543669,
                    54.8303301
                ],
                [
                    83.0526148,
                    54.8311582
                ],
                [
                    83.0510569,
                    54.8331609
                ],
                [
                    83.0500265,
                    54.8340299
                ],
                [
                    83.04918,
                    54.8349731
                ],
                [
                    83.0474687,
                    54.8358845
                ],
                [
                    83.0460334,
                    54.8354076
                ],
                [
                    83.0440093,
                    54.8344115
                ],
                [
                    83.0441013,
                    54.8339981
                ],
                [
                    83.0437885,
                    54.8338074
                ],
                [
                    83.0432181,
                    54.833712
                ],
                [
                    83.0427763,
                    54.8340087
                ],
                [
                    83.0398194,
                    54.8401789
                ],
                [
                    83.0391755,
                    54.8403379
                ],
                [
                    83.0385545,
                    54.8401657
                ],
                [
                    83.0383475,
                    54.8394504
                ],
                [
                    83.0368754,
                    54.8394769
                ],
                [
                    83.0357483,
                    54.8396756
                ],
                [
                    83.0330801,
                    54.8414902
                ],
                [
                    83.0152541,
                    54.8404173
                ],
                [
                    83.0114588,
                    54.8405101
                ],
                [
                    83.0083997,
                    54.8407882
                ],
                [
                    83.0065596,
                    54.8411326
                ],
                [
                    83.0031784,
                    54.8419273
                ],
                [
                    82.9995954,
                    54.8433198
                ],
                [
                    82.9815255,
                    54.8519119
                ],
                [
                    82.9774342,
                    54.8496141
                ],
                [
                    82.9737683,
                    54.8474621
                ],
                [
                    82.9700665,
                    54.8465516
                ],
                [
                    82.9685211,
                    54.8439442
                ],
                [
                    82.9675508,
                    54.8433648
                ],
                [
                    82.9654663,
                    54.8431372
                ],
                [
                    82.9603987,
                    54.8414195
                ],
                [
                    82.9582424,
                    54.8401984
                ],
                [
                    82.9558704,
                    54.838998
                ],
                [
                    82.953714,
                    54.8379218
                ],
                [
                    82.9515217,
                    54.8364522
                ],
                [
                    82.9494012,
                    54.835645
                ],
                [
                    82.9453401,
                    54.8344513
                ],
                [
                    82.9435382,
                    54.8337798
                ],
                [
                    82.938592,
                    54.8323282
                ],
                [
                    82.9340227,
                    54.8315278
                ],
                [
                    82.9305603,
                    54.8312768
                ],
                [
                    82.9271333,
                    54.8305171
                ],
                [
                    82.9264031,
                    54.8304018
                ],
                [
                    82.9248368,
                    54.8300287
                ],
                [
                    82.9242244,
                    54.8300694
                ],
                [
                    82.9231682,
                    54.829894
                ],
                [
                    82.9245488,
                    54.8585883
                ],
                [
                    82.9249986,
                    54.8679314
                ],
                [
                    82.9410086,
                    54.8677569
                ],
                [
                    82.9411434,
                    54.8730305
                ],
                [
                    82.9744121,
                    54.8726154
                ],
                [
                    82.9749491,
                    54.8726196
                ],
                [
                    82.9812136,
                    54.8726265
                ],
                [
                    82.9815251,
                    54.8692029
                ],
                [
                    82.9906969,
                    54.8684084
                ],
                [
                    82.9908443,
                    54.8738963
                ],
                [
                    82.9976688,
                    54.8737124
                ],
                [
                    83.0037182,
                    54.8810287
                ],
                [
                    83.0135341,
                    54.8778766
                ],
                [
                    83.0153366,
                    54.8814791
                ],
                [
                    83.0175929,
                    54.8840079
                ],
                [
                    83.0187118,
                    54.8871506
                ],
                [
                    83.0217564,
                    54.8915501
                ],
                [
                    83.0235811,
                    54.8958304
                ],
                [
                    83.0245961,
                    54.8978306
                ],
                [
                    83.0255144,
                    54.900202
                ],
                [
                    83.0305039,
                    54.9110622
                ],
                [
                    83.0322733,
                    54.9125503
                ],
                [
                    83.0374285,
                    54.9209223
                ],
                [
                    83.0387031,
                    54.923908
                ],
                [
                    83.0398567,
                    54.9283476
                ],
                [
                    83.0395615,
                    54.9305177
                ],
                [
                    83.0389204,
                    54.9324606
                ],
                [
                    83.0381557,
                    54.934449
                ],
                [
                    83.0381521,
                    54.9368762
                ],
                [
                    83.0350754,
                    54.9411185
                ],
                [
                    82.9974946,
                    54.9393848
                ],
                [
                    82.9943944,
                    54.9392717
                ],
                [
                    82.9880648,
                    54.939077
                ],
                [
                    82.9630813,
                    54.9379264
                ],
                [
                    82.9526472,
                    54.9373328
                ],
                [
                    82.9383412,
                    54.9367962
                ],
                [
                    82.9365744,
                    54.9363013
                ],
                [
                    82.9362733,
                    54.9345503
                ],
                [
                    82.9296918,
                    54.9312248
                ],
                [
                    82.9292315,
                    54.9311146
                ],
                [
                    82.9211956,
                    54.9269486
                ],
                [
                    82.9174229,
                    54.9293514
                ],
                [
                    82.9166407,
                    54.9296659
                ],
                [
                    82.9158189,
                    54.92974
                ],
                [
                    82.9145686,
                    54.9297438
                ],
                [
                    82.9093948,
                    54.9302621
                ],
                [
                    82.9048332,
                    54.9307191
                ],
                [
                    82.8939321,
                    54.9317789
                ],
                [
                    82.8863109,
                    54.9322595
                ],
                [
                    82.8768116,
                    54.9327784
                ],
                [
                    82.8763096,
                    54.930859
                ],
                [
                    82.8757891,
                    54.9308242
                ],
                [
                    82.8753423,
                    54.9309653
                ],
                [
                    82.8740883,
                    54.9310168
                ],
                [
                    82.8741838,
                    54.9312295
                ],
                [
                    82.8733716,
                    54.9313874
                ],
                [
                    82.8723613,
                    54.9311468
                ],
                [
                    82.8722657,
                    54.9310404
                ],
                [
                    82.871161,
                    54.9303061
                ],
                [
                    82.8709281,
                    54.9302478
                ],
                [
                    82.8687902,
                    54.9286831
                ],
                [
                    82.8694352,
                    54.928539
                ],
                [
                    82.8693038,
                    54.9281993
                ],
                [
                    82.8692859,
                    54.9276537
                ],
                [
                    82.868645,
                    54.9276626
                ],
                [
                    82.8686354,
                    54.9278372
                ],
                [
                    82.8679972,
                    54.9278438
                ],
                [
                    82.8679557,
                    54.9281639
                ],
                [
                    82.8659403,
                    54.9282496
                ],
                [
                    82.8659066,
                    54.9285993
                ],
                [
                    82.8655435,
                    54.9286256
                ],
                [
                    82.8654556,
                    54.9287289
                ],
                [
                    82.8653065,
                    54.9287508
                ],
                [
                    82.8652913,
                    54.9289111
                ],
                [
                    82.8641332,
                    54.9292515
                ],
                [
                    82.8636076,
                    54.9295954
                ],
                [
                    82.8637657,
                    54.9300449
                ],
                [
                    82.8624536,
                    54.9306073
                ],
                [
                    82.8632593,
                    54.9319746
                ],
                [
                    82.8626764,
                    54.9326223
                ],
                [
                    82.8631913,
                    54.9337557
                ],
                [
                    82.846892,
                    54.9346136
                ],
                [
                    82.839281,
                    54.9351446
                ],
                [
                    82.834819,
                    54.9410045
                ],
                [
                    82.8330648,
                    54.9419065
                ],
                [
                    82.8322157,
                    54.9423542
                ],
                [
                    82.8299056,
                    54.9435706
                ],
                [
                    82.8182822,
                    54.9499149
                ],
                [
                    82.817468,
                    54.9503952
                ],
                [
                    82.8048658,
                    54.9578283
                ],
                [
                    82.7645761,
                    54.9812188
                ],
                [
                    82.757741,
                    54.9853163
                ],
                [
                    82.7562362,
                    54.9856583
                ],
                [
                    82.7556328,
                    54.9863162
                ],
                [
                    82.7521094,
                    54.9874003
                ],
                [
                    82.75184,
                    54.989138
                ],
                [
                    82.751713,
                    54.9908711
                ]
            ],
            "longitude": 82.9234509,
            "latitude": 55.0282171
        },
        "18": {
            "name": "БЕРДСК",
            "population": 102808,
            "type": "city",
            "poly": [
                [
                    83.0136175,
                    54.770446
                ],
                [
                    83.0153319,
                    54.773429
                ],
                [
                    83.0174404,
                    54.7740793
                ],
                [
                    83.020015,
                    54.7735035
                ],
                [
                    83.0219065,
                    54.7726397
                ],
                [
                    83.0238768,
                    54.7733974
                ],
                [
                    83.0270029,
                    54.772867
                ],
                [
                    83.0283165,
                    54.7737156
                ],
                [
                    83.0283953,
                    54.7755339
                ],
                [
                    83.0303131,
                    54.7768219
                ],
                [
                    83.0307334,
                    54.7776855
                ],
                [
                    83.0313902,
                    54.7809279
                ],
                [
                    83.0302606,
                    54.7810794
                ],
                [
                    83.0291572,
                    54.7804127
                ],
                [
                    83.0280801,
                    54.7808066
                ],
                [
                    83.0271869,
                    54.7820187
                ],
                [
                    83.0268191,
                    54.7830337
                ],
                [
                    83.0256369,
                    54.7837003
                ],
                [
                    83.0236141,
                    54.7833973
                ],
                [
                    83.0269179,
                    54.7847555
                ],
                [
                    83.0289174,
                    54.7860857
                ],
                [
                    83.0300996,
                    54.7876005
                ],
                [
                    83.0304608,
                    54.7893804
                ],
                [
                    83.0330222,
                    54.7909898
                ],
                [
                    83.0369956,
                    54.7926559
                ],
                [
                    83.0379184,
                    54.7937905
                ],
                [
                    83.0378008,
                    54.7955365
                ],
                [
                    83.0394546,
                    54.7987273
                ],
                [
                    83.0426767,
                    54.7978809
                ],
                [
                    83.046411,
                    54.7972992
                ],
                [
                    83.0520685,
                    54.7981838
                ],
                [
                    83.0590234,
                    54.80073
                ],
                [
                    83.0833145,
                    54.8047001
                ],
                [
                    83.0836341,
                    54.8094514
                ],
                [
                    83.09474,
                    54.8087332
                ],
                [
                    83.0953876,
                    54.8086524
                ],
                [
                    83.0954996,
                    54.8085568
                ],
                [
                    83.0957305,
                    54.8085139
                ],
                [
                    83.0983612,
                    54.8083186
                ],
                [
                    83.0984578,
                    54.8082707
                ],
                [
                    83.0986899,
                    54.8079455
                ],
                [
                    83.1052787,
                    54.806974
                ],
                [
                    83.1025365,
                    54.7964722
                ],
                [
                    83.1092527,
                    54.793388
                ],
                [
                    83.1291106,
                    54.784731
                ],
                [
                    83.1284873,
                    54.7839554
                ],
                [
                    83.1385997,
                    54.7799547
                ],
                [
                    83.1436604,
                    54.7812176
                ],
                [
                    83.1454171,
                    54.783273
                ],
                [
                    83.150637,
                    54.7847255
                ],
                [
                    83.1512958,
                    54.7848745
                ],
                [
                    83.1537416,
                    54.7840477
                ],
                [
                    83.1563456,
                    54.7840919
                ],
                [
                    83.1572106,
                    54.7842485
                ],
                [
                    83.1573879,
                    54.7837375
                ],
                [
                    83.1590578,
                    54.7828906
                ],
                [
                    83.161484,
                    54.781334
                ],
                [
                    83.1654898,
                    54.7810458
                ],
                [
                    83.1686254,
                    54.7796718
                ],
                [
                    83.1682212,
                    54.7789146
                ],
                [
                    83.1697957,
                    54.7780621
                ],
                [
                    83.1686389,
                    54.776598
                ],
                [
                    83.1689281,
                    54.7750227
                ],
                [
                    83.1701813,
                    54.7749856
                ],
                [
                    83.1715308,
                    54.7756899
                ],
                [
                    83.1721273,
                    54.7753834
                ],
                [
                    83.1691934,
                    54.7722696
                ],
                [
                    83.1647264,
                    54.7700502
                ],
                [
                    83.1641038,
                    54.769705
                ],
                [
                    83.1614466,
                    54.7657091
                ],
                [
                    83.1559859,
                    54.7660648
                ],
                [
                    83.1466968,
                    54.7673702
                ],
                [
                    83.1338653,
                    54.771299
                ],
                [
                    83.1310247,
                    54.7624861
                ],
                [
                    83.1313437,
                    54.7593272
                ],
                [
                    83.1307683,
                    54.7579824
                ],
                [
                    83.1279503,
                    54.7566432
                ],
                [
                    83.1260099,
                    54.7557702
                ],
                [
                    83.1271299,
                    54.7548468
                ],
                [
                    83.1278495,
                    54.7545182
                ],
                [
                    83.1285951,
                    54.7542527
                ],
                [
                    83.1293675,
                    54.7540225
                ],
                [
                    83.1301307,
                    54.7538633
                ],
                [
                    83.1305622,
                    54.7537815
                ],
                [
                    83.1310212,
                    54.7537061
                ],
                [
                    83.1367505,
                    54.753047
                ],
                [
                    83.1387914,
                    54.7528666
                ],
                [
                    83.1396518,
                    54.7528541
                ],
                [
                    83.1405465,
                    54.7528864
                ],
                [
                    83.1411389,
                    54.7529245
                ],
                [
                    83.1417375,
                    54.7529954
                ],
                [
                    83.1433699,
                    54.7532953
                ],
                [
                    83.1473501,
                    54.754161
                ],
                [
                    83.1489537,
                    54.7545136
                ],
                [
                    83.1497587,
                    54.7546468
                ],
                [
                    83.1505801,
                    54.7547513
                ],
                [
                    83.1514022,
                    54.7548285
                ],
                [
                    83.1522456,
                    54.7548714
                ],
                [
                    83.1531765,
                    54.7548805
                ],
                [
                    83.1541292,
                    54.7548504
                ],
                [
                    83.154925,
                    54.7547877
                ],
                [
                    83.1556571,
                    54.7547117
                ],
                [
                    83.1567515,
                    54.7545679
                ],
                [
                    83.1578028,
                    54.7543551
                ],
                [
                    83.1586748,
                    54.7541465
                ],
                [
                    83.1595092,
                    54.7538954
                ],
                [
                    83.1602005,
                    54.7536479
                ],
                [
                    83.1608069,
                    54.7533991
                ],
                [
                    83.1614278,
                    54.7531166
                ],
                [
                    83.1619843,
                    54.7528296
                ],
                [
                    83.1676023,
                    54.7497312
                ],
                [
                    83.1668346,
                    54.7493861
                ],
                [
                    83.1659509,
                    54.7489539
                ],
                [
                    83.1652248,
                    54.7472322
                ],
                [
                    83.1626753,
                    54.7466386
                ],
                [
                    83.1620013,
                    54.7455695
                ],
                [
                    83.1605434,
                    54.7449153
                ],
                [
                    83.1533631,
                    54.7422877
                ],
                [
                    83.1473953,
                    54.7408579
                ],
                [
                    83.1431671,
                    54.7387126
                ],
                [
                    83.1441286,
                    54.7372438
                ],
                [
                    83.144228,
                    54.7337231
                ],
                [
                    83.1386811,
                    54.7336655
                ],
                [
                    83.1303684,
                    54.7332648
                ],
                [
                    83.1288633,
                    54.7354038
                ],
                [
                    83.1275652,
                    54.7376485
                ],
                [
                    83.1243637,
                    54.7414603
                ],
                [
                    83.1243886,
                    54.7419611
                ],
                [
                    83.1240454,
                    54.7425483
                ],
                [
                    83.1228596,
                    54.7436831
                ],
                [
                    83.1227473,
                    54.7446557
                ],
                [
                    83.1222416,
                    54.7458754
                ],
                [
                    83.1197792,
                    54.7468425
                ],
                [
                    83.1174639,
                    54.7464429
                ],
                [
                    83.1148489,
                    54.7459915
                ],
                [
                    83.1121816,
                    54.7451311
                ],
                [
                    83.1102423,
                    54.7443296
                ],
                [
                    83.1075997,
                    54.7431588
                ],
                [
                    83.1057275,
                    54.741639
                ],
                [
                    83.1136601,
                    54.7311228
                ],
                [
                    83.1166158,
                    54.720814
                ],
                [
                    83.1219698,
                    54.7022605
                ],
                [
                    83.0972936,
                    54.7084553
                ],
                [
                    83.0848521,
                    54.7015755
                ],
                [
                    83.0791926,
                    54.7010877
                ],
                [
                    83.0783997,
                    54.7048018
                ],
                [
                    83.0743123,
                    54.7073234
                ],
                [
                    83.0617997,
                    54.699225
                ],
                [
                    83.0643124,
                    54.6967332
                ],
                [
                    83.0648087,
                    54.6951735
                ],
                [
                    83.0648396,
                    54.6936138
                ],
                [
                    83.0634165,
                    54.6923464
                ],
                [
                    83.0558879,
                    54.6962739
                ],
                [
                    83.0448567,
                    54.6905057
                ],
                [
                    83.0454215,
                    54.6893449
                ],
                [
                    83.0357565,
                    54.6836129
                ],
                [
                    83.0238681,
                    54.6783497
                ],
                [
                    83.0182465,
                    54.6813634
                ],
                [
                    83.0191879,
                    54.6839394
                ],
                [
                    83.0213218,
                    54.6863702
                ],
                [
                    83.0169913,
                    54.6878213
                ],
                [
                    83.0300227,
                    54.6948396
                ],
                [
                    83.0307985,
                    54.6952574
                ],
                [
                    83.0333741,
                    54.6955272
                ],
                [
                    83.0346193,
                    54.6963629
                ],
                [
                    83.0375916,
                    54.6955737
                ],
                [
                    83.0382669,
                    54.6964267
                ],
                [
                    83.0329725,
                    54.69945
                ],
                [
                    83.0267467,
                    54.6988233
                ],
                [
                    83.024468,
                    54.701431
                ],
                [
                    83.0256539,
                    54.7049952
                ],
                [
                    83.0137647,
                    54.70959
                ],
                [
                    83.0221481,
                    54.7156727
                ],
                [
                    83.0209713,
                    54.7205009
                ],
                [
                    83.0198618,
                    54.7260864
                ],
                [
                    83.0172201,
                    54.7333241
                ],
                [
                    83.0168915,
                    54.7456207
                ],
                [
                    83.0203495,
                    54.7572237
                ],
                [
                    83.0146673,
                    54.767183
                ],
                [
                    83.0136175,
                    54.770446
                ]
            ],
            "longitude": 83.1068095,
            "latitude": 54.75795
        },
        "19": {
            "name": "БРАТСК",
            "population": 236313,
            "type": "city",
            "poly": [
                [
                    101.3530298,
                    56.1480657
                ],
                [
                    101.3532282,
                    56.1487039
                ],
                [
                    101.3536146,
                    56.1493572
                ],
                [
                    101.3539123,
                    56.1496354
                ],
                [
                    101.3542923,
                    56.1499499
                ],
                [
                    101.3549113,
                    56.1500769
                ],
                [
                    101.3555158,
                    56.1500361
                ],
                [
                    101.356388,
                    56.1497443
                ],
                [
                    101.3571264,
                    56.1494902
                ],
                [
                    101.3577019,
                    56.1494116
                ],
                [
                    101.35831,
                    56.1494176
                ],
                [
                    101.3602211,
                    56.1494237
                ],
                [
                    101.3616238,
                    56.1496282
                ],
                [
                    101.3627077,
                    56.1495809
                ],
                [
                    101.3638804,
                    56.1491757
                ],
                [
                    101.3648569,
                    56.1485377
                ],
                [
                    101.3645645,
                    56.1482261
                ],
                [
                    101.3640433,
                    56.1481232
                ],
                [
                    101.36351,
                    56.1480087
                ],
                [
                    101.3631638,
                    56.1477059
                ],
                [
                    101.3630552,
                    56.1473611
                ],
                [
                    101.3624037,
                    56.1471373
                ],
                [
                    101.3619325,
                    56.147297
                ],
                [
                    101.3614264,
                    56.1476696
                ],
                [
                    101.3607133,
                    56.1477581
                ],
                [
                    101.3595696,
                    56.1476575
                ],
                [
                    101.3589507,
                    56.1472099
                ],
                [
                    101.3591879,
                    56.14675
                ],
                [
                    101.3597614,
                    56.1461967
                ],
                [
                    101.3604709,
                    56.1460424
                ],
                [
                    101.361307,
                    56.1460968
                ],
                [
                    101.3628384,
                    56.1464966
                ],
                [
                    101.364768,
                    56.1465236
                ],
                [
                    101.3657807,
                    56.1469558
                ],
                [
                    101.366617,
                    56.1474666
                ],
                [
                    101.3666711,
                    56.1478692
                ],
                [
                    101.3665625,
                    56.1481535
                ],
                [
                    101.3665299,
                    56.1488007
                ],
                [
                    101.3673083,
                    56.149183
                ],
                [
                    101.3678981,
                    56.1494902
                ],
                [
                    101.3680501,
                    56.1499499
                ],
                [
                    101.3678654,
                    56.150706
                ],
                [
                    101.3674276,
                    56.1511244
                ],
                [
                    101.3672683,
                    56.1513289
                ],
                [
                    101.3674963,
                    56.1516555
                ],
                [
                    101.3678981,
                    56.1521152
                ],
                [
                    101.3687384,
                    56.1530197
                ],
                [
                    101.3692229,
                    56.1534095
                ],
                [
                    101.3698634,
                    56.1535849
                ],
                [
                    101.370439,
                    56.1536635
                ],
                [
                    101.3709494,
                    56.1534639
                ],
                [
                    101.3710688,
                    56.1531252
                ],
                [
                    101.3711588,
                    56.1527535
                ],
                [
                    101.3706613,
                    56.1516217
                ],
                [
                    101.3711479,
                    56.151047
                ],
                [
                    101.3724696,
                    56.1509721
                ],
                [
                    101.3733686,
                    56.1511339
                ],
                [
                    101.37688,
                    56.1524253
                ],
                [
                    101.3777577,
                    56.1527684
                ],
                [
                    101.378583,
                    56.1527442
                ],
                [
                    101.3799151,
                    56.1524713
                ],
                [
                    101.3827924,
                    56.1513047
                ],
                [
                    101.3843489,
                    56.1505064
                ],
                [
                    101.3854346,
                    56.1495122
                ],
                [
                    101.3877293,
                    56.148257
                ],
                [
                    101.3896589,
                    56.1462367
                ],
                [
                    101.3923703,
                    56.1440663
                ],
                [
                    101.3937958,
                    56.144028
                ],
                [
                    101.3947948,
                    56.1442095
                ],
                [
                    101.3966733,
                    56.1444031
                ],
                [
                    101.3970208,
                    56.1445664
                ],
                [
                    101.3976625,
                    56.1446779
                ],
                [
                    101.4013595,
                    56.1450607
                ],
                [
                    101.4018855,
                    56.1452379
                ],
                [
                    101.4025044,
                    56.1453891
                ],
                [
                    101.4029387,
                    56.1453347
                ],
                [
                    101.4034032,
                    56.1453064
                ],
                [
                    101.4044451,
                    56.1449921
                ],
                [
                    101.4054036,
                    56.1449778
                ],
                [
                    101.4062946,
                    56.1450235
                ],
                [
                    101.4074776,
                    56.1452984
                ],
                [
                    101.4085872,
                    56.1455939
                ],
                [
                    101.4091173,
                    56.1459093
                ],
                [
                    101.4098014,
                    56.1460485
                ],
                [
                    101.4106483,
                    56.1461634
                ],
                [
                    101.4113215,
                    56.1460908
                ],
                [
                    101.411669,
                    56.1459638
                ],
                [
                    101.4119915,
                    56.1456641
                ],
                [
                    101.413565,
                    56.1458159
                ],
                [
                    101.4154613,
                    56.145941
                ],
                [
                    101.4176962,
                    56.1459005
                ],
                [
                    101.41853,
                    56.1461669
                ],
                [
                    101.4188422,
                    56.1467651
                ],
                [
                    101.4186317,
                    56.1470953
                ],
                [
                    101.4181023,
                    56.1472541
                ],
                [
                    101.4173151,
                    56.1471709
                ],
                [
                    101.4156727,
                    56.1472087
                ],
                [
                    101.4127789,
                    56.1473371
                ],
                [
                    101.4107541,
                    56.1475732
                ],
                [
                    101.4090353,
                    56.1477606
                ],
                [
                    101.4082071,
                    56.148067
                ],
                [
                    101.4076101,
                    56.1486377
                ],
                [
                    101.4075444,
                    56.1490442
                ],
                [
                    101.407985,
                    56.1492733
                ],
                [
                    101.4087342,
                    56.1496362
                ],
                [
                    101.4088157,
                    56.1499393
                ],
                [
                    101.4081695,
                    56.1505011
                ],
                [
                    101.4083976,
                    56.150985
                ],
                [
                    101.4093673,
                    56.151445
                ],
                [
                    101.410135,
                    56.1516382
                ],
                [
                    101.4104499,
                    56.1520858
                ],
                [
                    101.4106454,
                    56.1522491
                ],
                [
                    101.4110313,
                    56.152251
                ],
                [
                    101.4111883,
                    56.1519104
                ],
                [
                    101.4116118,
                    56.1514205
                ],
                [
                    101.4124587,
                    56.1509003
                ],
                [
                    101.413584,
                    56.1506527
                ],
                [
                    101.4142065,
                    56.1507109
                ],
                [
                    101.4146847,
                    56.1510646
                ],
                [
                    101.4148605,
                    56.1513349
                ],
                [
                    101.414516,
                    56.152353
                ],
                [
                    101.4139866,
                    56.1525873
                ],
                [
                    101.4130104,
                    56.152626
                ],
                [
                    101.4122085,
                    56.1527234
                ],
                [
                    101.4116792,
                    56.1528897
                ],
                [
                    101.411299,
                    56.1533131
                ],
                [
                    101.4108919,
                    56.1539179
                ],
                [
                    101.410634,
                    56.1545227
                ],
                [
                    101.4108512,
                    56.1548931
                ],
                [
                    101.4114982,
                    56.155046
                ],
                [
                    101.4122852,
                    56.1549996
                ],
                [
                    101.4143642,
                    56.1546867
                ],
                [
                    101.4157091,
                    56.1546112
                ],
                [
                    101.4168798,
                    56.1544978
                ],
                [
                    101.4176986,
                    56.1541186
                ],
                [
                    101.4180359,
                    56.1536478
                ],
                [
                    101.418288,
                    56.1531371
                ],
                [
                    101.4181014,
                    56.1527969
                ],
                [
                    101.4177475,
                    56.1522747
                ],
                [
                    101.4177451,
                    56.1519464
                ],
                [
                    101.4182201,
                    56.1516912
                ],
                [
                    101.4187994,
                    56.1516093
                ],
                [
                    101.4192754,
                    56.1517216
                ],
                [
                    101.4195096,
                    56.1518897
                ],
                [
                    101.4195266,
                    56.1522488
                ],
                [
                    101.4193274,
                    56.1524905
                ],
                [
                    101.4186996,
                    56.152989
                ],
                [
                    101.4190176,
                    56.1536096
                ],
                [
                    101.4195605,
                    56.1542144
                ],
                [
                    101.4205051,
                    56.1544321
                ],
                [
                    101.4218384,
                    56.1542326
                ],
                [
                    101.4229804,
                    56.1541445
                ],
                [
                    101.4238732,
                    56.1539696
                ],
                [
                    101.4251,
                    56.1533998
                ],
                [
                    101.42594,
                    56.1532697
                ],
                [
                    101.426651,
                    56.1533157
                ],
                [
                    101.4272628,
                    56.1534538
                ],
                [
                    101.4277257,
                    56.1537393
                ],
                [
                    101.4279738,
                    56.1541169
                ],
                [
                    101.4285134,
                    56.1544101
                ],
                [
                    101.4289327,
                    56.1544208
                ],
                [
                    101.4295776,
                    56.1542827
                ],
                [
                    101.4301893,
                    56.1540893
                ],
                [
                    101.43052,
                    56.1538498
                ],
                [
                    101.4313137,
                    56.1534907
                ],
                [
                    101.4323719,
                    56.1533065
                ],
                [
                    101.4336615,
                    56.1533341
                ],
                [
                    101.4348189,
                    56.1533986
                ],
                [
                    101.4355299,
                    56.1532144
                ],
                [
                    101.4363401,
                    56.1526711
                ],
                [
                    101.436894,
                    56.1525407
                ],
                [
                    101.4372291,
                    56.1526693
                ],
                [
                    101.4373751,
                    56.1528226
                ],
                [
                    101.4371952,
                    56.1530112
                ],
                [
                    101.4367507,
                    56.1532234
                ],
                [
                    101.4360841,
                    56.1535004
                ],
                [
                    101.4359042,
                    56.1537656
                ],
                [
                    101.4361899,
                    56.1542194
                ],
                [
                    101.4369095,
                    56.1546084
                ],
                [
                    101.4377243,
                    56.15485
                ],
                [
                    101.4384544,
                    56.1549149
                ],
                [
                    101.4389306,
                    56.1552331
                ],
                [
                    101.4392693,
                    56.1556692
                ],
                [
                    101.4391528,
                    56.1560287
                ],
                [
                    101.4391317,
                    56.1562468
                ],
                [
                    101.4394386,
                    56.1564177
                ],
                [
                    101.4398508,
                    56.1565329
                ],
                [
                    101.4405761,
                    56.156375
                ],
                [
                    101.4406501,
                    56.1562159
                ],
                [
                    101.440555,
                    56.1559801
                ],
                [
                    101.440301,
                    56.1557326
                ],
                [
                    101.4403962,
                    56.1551963
                ],
                [
                    101.4407772,
                    56.1544714
                ],
                [
                    101.4413274,
                    56.1543417
                ],
                [
                    101.4437507,
                    56.1542474
                ],
                [
                    101.4444703,
                    56.1540765
                ],
                [
                    101.4447983,
                    56.1537405
                ],
                [
                    101.4451475,
                    56.1535637
                ],
                [
                    101.4459875,
                    56.1534884
                ],
                [
                    101.446397,
                    56.1534052
                ],
                [
                    101.4472465,
                    56.1533576
                ],
                [
                    101.4477718,
                    56.1535225
                ],
                [
                    101.4485232,
                    56.1538997
                ],
                [
                    101.4488935,
                    56.1541826
                ],
                [
                    101.4485232,
                    56.1544183
                ],
                [
                    101.4477426,
                    56.1546301
                ],
                [
                    101.4467025,
                    56.1549017
                ],
                [
                    101.4464306,
                    56.1553473
                ],
                [
                    101.446667,
                    56.1556931
                ],
                [
                    101.4470715,
                    56.1558759
                ],
                [
                    101.4480664,
                    56.1561158
                ],
                [
                    101.4481657,
                    56.1565322
                ],
                [
                    101.4478348,
                    56.1569498
                ],
                [
                    101.4478328,
                    56.1574806
                ],
                [
                    101.4481511,
                    56.1576803
                ],
                [
                    101.4471621,
                    56.1590211
                ],
                [
                    101.4379949,
                    56.1590003
                ],
                [
                    101.4391735,
                    56.1627509
                ],
                [
                    101.444094,
                    56.1636155
                ],
                [
                    101.448528,
                    56.1648552
                ],
                [
                    101.4502305,
                    56.1658136
                ],
                [
                    101.4615306,
                    56.1689073
                ],
                [
                    101.4607278,
                    56.1703955
                ],
                [
                    101.4697178,
                    56.171882
                ],
                [
                    101.4718545,
                    56.1678342
                ],
                [
                    101.475267,
                    56.1683409
                ],
                [
                    101.4793261,
                    56.1646608
                ],
                [
                    101.4836007,
                    56.1652275
                ],
                [
                    101.4849178,
                    56.1649475
                ],
                [
                    101.493321,
                    56.1715355
                ],
                [
                    101.4946333,
                    56.1714715
                ],
                [
                    101.4986182,
                    56.169701
                ],
                [
                    101.4989191,
                    56.1700313
                ],
                [
                    101.4991623,
                    56.1704529
                ],
                [
                    101.4991584,
                    56.1707827
                ],
                [
                    101.4990533,
                    56.1711283
                ],
                [
                    101.4993023,
                    56.1714856
                ],
                [
                    101.4995705,
                    56.1716295
                ],
                [
                    101.5000495,
                    56.1715229
                ],
                [
                    101.5001644,
                    56.1710109
                ],
                [
                    101.5002411,
                    56.170643
                ],
                [
                    101.5007966,
                    56.1705363
                ],
                [
                    101.5014288,
                    56.1707016
                ],
                [
                    101.5017737,
                    56.1713309
                ],
                [
                    101.5021136,
                    56.1718411
                ],
                [
                    101.5023833,
                    56.1724589
                ],
                [
                    101.5024691,
                    56.1729571
                ],
                [
                    101.50223,
                    56.1732131
                ],
                [
                    101.5016231,
                    56.1734588
                ],
                [
                    101.5011082,
                    56.1737011
                ],
                [
                    101.501243,
                    56.1739502
                ],
                [
                    101.5016967,
                    56.174254
                ],
                [
                    101.5022178,
                    56.1743529
                ],
                [
                    101.5028308,
                    56.1742779
                ],
                [
                    101.503597,
                    56.1744383
                ],
                [
                    101.504155,
                    56.1745987
                ],
                [
                    101.5049642,
                    56.1744894
                ],
                [
                    101.5053443,
                    56.1740765
                ],
                [
                    101.5053995,
                    56.1736875
                ],
                [
                    101.505749,
                    56.1735851
                ],
                [
                    101.5061352,
                    56.1735714
                ],
                [
                    101.5066624,
                    56.1736943
                ],
                [
                    101.5071038,
                    56.1739605
                ],
                [
                    101.5075758,
                    56.1743188
                ],
                [
                    101.5076249,
                    56.174701
                ],
                [
                    101.5071467,
                    56.1752846
                ],
                [
                    101.5066931,
                    56.1754859
                ],
                [
                    101.50608,
                    56.1756395
                ],
                [
                    101.5058838,
                    56.1757385
                ],
                [
                    101.5058532,
                    56.1758511
                ],
                [
                    101.50608,
                    56.176206
                ],
                [
                    101.5066808,
                    56.1763595
                ],
                [
                    101.5078701,
                    56.1766394
                ],
                [
                    101.5089981,
                    56.1769601
                ],
                [
                    101.509697,
                    56.1769908
                ],
                [
                    101.5106779,
                    56.1768953
                ],
                [
                    101.5116096,
                    56.1766632
                ],
                [
                    101.5125232,
                    56.1765609
                ],
                [
                    101.513314,
                    56.1766735
                ],
                [
                    101.5140313,
                    56.1768646
                ],
                [
                    101.5146505,
                    56.1773014
                ],
                [
                    101.5153003,
                    56.1777382
                ],
                [
                    101.5164958,
                    56.1784616
                ],
                [
                    101.5167471,
                    56.1787789
                ],
                [
                    101.5168329,
                    56.179086
                ],
                [
                    101.517072,
                    56.1793556
                ],
                [
                    101.5174889,
                    56.1795535
                ],
                [
                    101.5182307,
                    56.1796593
                ],
                [
                    101.5191012,
                    56.179649
                ],
                [
                    101.5202231,
                    56.1793658
                ],
                [
                    101.5209894,
                    56.1794409
                ],
                [
                    101.521253,
                    56.1795569
                ],
                [
                    101.5213634,
                    56.1793965
                ],
                [
                    101.5215534,
                    56.179202
                ],
                [
                    101.522191,
                    56.1791065
                ],
                [
                    101.5226753,
                    56.1791031
                ],
                [
                    101.5230799,
                    56.1793317
                ],
                [
                    101.5230921,
                    56.1797992
                ],
                [
                    101.5233497,
                    56.1802803
                ],
                [
                    101.5235949,
                    56.1804679
                ],
                [
                    101.524024,
                    56.1805396
                ],
                [
                    101.524962,
                    56.1804304
                ],
                [
                    101.5261391,
                    56.1800551
                ],
                [
                    101.526795,
                    56.1796047
                ],
                [
                    101.5269115,
                    56.179202
                ],
                [
                    101.5270035,
                    56.178854
                ],
                [
                    101.5276656,
                    56.1786936
                ],
                [
                    101.5283644,
                    56.1787175
                ],
                [
                    101.5287261,
                    56.1788403
                ],
                [
                    101.5285851,
                    56.1791952
                ],
                [
                    101.5280824,
                    56.1794989
                ],
                [
                    101.5275491,
                    56.1800073
                ],
                [
                    101.5273529,
                    56.180369
                ],
                [
                    101.5275307,
                    56.1806113
                ],
                [
                    101.5284625,
                    56.1807477
                ],
                [
                    101.5292902,
                    56.1807034
                ],
                [
                    101.5301423,
                    56.1806249
                ],
                [
                    101.5310803,
                    56.1805396
                ],
                [
                    101.5317853,
                    56.1804133
                ],
                [
                    101.5322573,
                    56.1801881
                ],
                [
                    101.5327171,
                    56.1798981
                ],
                [
                    101.5329869,
                    56.1797889
                ],
                [
                    101.5333853,
                    56.1797343
                ],
                [
                    101.533845,
                    56.1798026
                ],
                [
                    101.5347157,
                    56.1802871
                ],
                [
                    101.5352184,
                    56.1808842
                ],
                [
                    101.5355249,
                    56.1818055
                ],
                [
                    101.5355617,
                    56.1825049
                ],
                [
                    101.535672,
                    56.1829587
                ],
                [
                    101.5359847,
                    56.1831941
                ],
                [
                    101.5367449,
                    56.1834807
                ],
                [
                    101.5372292,
                    56.1837571
                ],
                [
                    101.537548,
                    56.184436
                ],
                [
                    101.5377257,
                    56.1850877
                ],
                [
                    101.5377687,
                    56.1856335
                ],
                [
                    101.5374376,
                    56.1864319
                ],
                [
                    101.537315,
                    56.1872882
                ],
                [
                    101.5372292,
                    56.1887619
                ],
                [
                    101.5371372,
                    56.1892122
                ],
                [
                    101.5367387,
                    56.1898501
                ],
                [
                    101.5359785,
                    56.1902458
                ],
                [
                    101.5354575,
                    56.1904403
                ],
                [
                    101.5348075,
                    56.1904505
                ],
                [
                    101.5338819,
                    56.1904505
                ],
                [
                    101.5332014,
                    56.190239
                ],
                [
                    101.53276,
                    56.190106
                ],
                [
                    101.5320979,
                    56.1901298
                ],
                [
                    101.5316381,
                    56.1905972
                ],
                [
                    101.5316565,
                    56.1912624
                ],
                [
                    101.5319998,
                    56.1916444
                ],
                [
                    101.5323738,
                    56.1919071
                ],
                [
                    101.5332076,
                    56.192139
                ],
                [
                    101.5340229,
                    56.1920947
                ],
                [
                    101.5346543,
                    56.1919344
                ],
                [
                    101.5354391,
                    56.192064
                ],
                [
                    101.5366406,
                    56.1919514
                ],
                [
                    101.5378054,
                    56.1918457
                ],
                [
                    101.5384798,
                    56.1918934
                ],
                [
                    101.5387986,
                    56.1922857
                ],
                [
                    101.5387618,
                    56.1926097
                ],
                [
                    101.5387557,
                    56.1931214
                ],
                [
                    101.5389089,
                    56.1938855
                ],
                [
                    101.5395525,
                    56.1950724
                ],
                [
                    101.5400492,
                    56.1960275
                ],
                [
                    101.5400061,
                    56.1971249
                ],
                [
                    101.5396976,
                    56.1971323
                ],
                [
                    101.5394345,
                    56.1971684
                ],
                [
                    101.5392605,
                    56.1971233
                ],
                [
                    101.5391026,
                    56.1970716
                ],
                [
                    101.538961,
                    56.1970558
                ],
                [
                    101.5388274,
                    56.1970243
                ],
                [
                    101.538791,
                    56.196968
                ],
                [
                    101.5386654,
                    56.1969792
                ],
                [
                    101.5384996,
                    56.1969972
                ],
                [
                    101.5383903,
                    56.1970423
                ],
                [
                    101.5383377,
                    56.1971166
                ],
                [
                    101.5382324,
                    56.1971684
                ],
                [
                    101.5381313,
                    56.1971661
                ],
                [
                    101.5380179,
                    56.1971278
                ],
                [
                    101.5379451,
                    56.1970648
                ],
                [
                    101.5378317,
                    56.1970558
                ],
                [
                    101.5377589,
                    56.1970851
                ],
                [
                    101.5375606,
                    56.1972359
                ],
                [
                    101.5374149,
                    56.1973913
                ],
                [
                    101.5372246,
                    56.1974971
                ],
                [
                    101.537002,
                    56.1975579
                ],
                [
                    101.5366944,
                    56.197603
                ],
                [
                    101.536407,
                    56.1975849
                ],
                [
                    101.5360913,
                    56.1975534
                ],
                [
                    101.5359618,
                    56.1975737
                ],
                [
                    101.5355125,
                    56.1974701
                ],
                [
                    101.5351928,
                    56.197389
                ],
                [
                    101.5348892,
                    56.1974116
                ],
                [
                    101.5346302,
                    56.1974543
                ],
                [
                    101.5343792,
                    56.1974543
                ],
                [
                    101.5337239,
                    56.1974266
                ],
                [
                    101.5330124,
                    56.1973386
                ],
                [
                    101.5323404,
                    56.1971792
                ],
                [
                    101.5318563,
                    56.1970528
                ],
                [
                    101.5312831,
                    56.1971352
                ],
                [
                    101.5302851,
                    56.1972397
                ],
                [
                    101.529376,
                    56.1973221
                ],
                [
                    101.5287337,
                    56.1973606
                ],
                [
                    101.5274984,
                    56.1972782
                ],
                [
                    101.5265795,
                    56.1972012
                ],
                [
                    101.5251566,
                    56.1971737
                ],
                [
                    101.5243167,
                    56.1971737
                ],
                [
                    101.5237846,
                    56.1971609
                ],
                [
                    101.5239222,
                    56.1977893
                ],
                [
                    101.5245103,
                    56.1996434
                ],
                [
                    101.5249214,
                    56.2013356
                ],
                [
                    101.5267807,
                    56.2015854
                ],
                [
                    101.538685,
                    56.203186
                ],
                [
                    101.5375541,
                    56.2040453
                ],
                [
                    101.5370514,
                    56.204792
                ],
                [
                    101.5369778,
                    56.2052456
                ],
                [
                    101.536984,
                    56.2057639
                ],
                [
                    101.5374376,
                    56.2064833
                ],
                [
                    101.5378545,
                    56.2073392
                ],
                [
                    101.538394,
                    56.2080586
                ],
                [
                    101.5392032,
                    56.208744
                ],
                [
                    101.5398285,
                    56.2094361
                ],
                [
                    101.540558,
                    56.2097566
                ],
                [
                    101.5412876,
                    56.2099782
                ],
                [
                    101.5427037,
                    56.2100226
                ],
                [
                    101.5439114,
                    56.2099851
                ],
                [
                    101.5446348,
                    56.2100328
                ],
                [
                    101.5449107,
                    56.2102919
                ],
                [
                    101.5449904,
                    56.2106601
                ],
                [
                    101.5443344,
                    56.211833
                ],
                [
                    101.5436172,
                    56.212791
                ],
                [
                    101.5432555,
                    56.2135819
                ],
                [
                    101.5434025,
                    56.2141205
                ],
                [
                    101.543752,
                    56.2145058
                ],
                [
                    101.5445245,
                    56.2146865
                ],
                [
                    101.5452172,
                    56.2149967
                ],
                [
                    101.545536,
                    56.2153649
                ],
                [
                    101.5454747,
                    56.215716
                ],
                [
                    101.5446716,
                    56.2165716
                ],
                [
                    101.5446532,
                    56.2170659
                ],
                [
                    101.5456157,
                    56.2174716
                ],
                [
                    101.5472587,
                    56.217809
                ],
                [
                    101.5481599,
                    56.2176863
                ],
                [
                    101.5485461,
                    56.2174068
                ],
                [
                    101.5487116,
                    56.2168614
                ],
                [
                    101.54911,
                    56.2166534
                ],
                [
                    101.5496251,
                    56.216858
                ],
                [
                    101.5499377,
                    56.2173216
                ],
                [
                    101.5498642,
                    56.2177579
                ],
                [
                    101.5501155,
                    56.2181567
                ],
                [
                    101.5504895,
                    56.2183306
                ],
                [
                    101.5515317,
                    56.2183306
                ],
                [
                    101.5521631,
                    56.2188078
                ],
                [
                    101.5531379,
                    56.2190226
                ],
                [
                    101.5546337,
                    56.2192714
                ],
                [
                    101.5550322,
                    56.2193668
                ],
                [
                    101.5559947,
                    56.2192578
                ],
                [
                    101.5575335,
                    56.2189101
                ],
                [
                    101.5600776,
                    56.2182113
                ],
                [
                    101.5619045,
                    56.2174545
                ],
                [
                    101.5630141,
                    56.2166432
                ],
                [
                    101.5637621,
                    56.2164046
                ],
                [
                    101.5642525,
                    56.216425
                ],
                [
                    101.5655767,
                    56.2166705
                ],
                [
                    101.5665147,
                    56.2171545
                ],
                [
                    101.5672805,
                    56.2176686
                ],
                [
                    101.5673132,
                    56.2177981
                ],
                [
                    101.5671823,
                    56.2178951
                ],
                [
                    101.5665166,
                    56.2181945
                ],
                [
                    101.5654944,
                    56.2188175
                ],
                [
                    101.5654726,
                    56.2190177
                ],
                [
                    101.5656654,
                    56.2191836
                ],
                [
                    101.5663019,
                    56.2193575
                ],
                [
                    101.5676479,
                    56.2198854
                ],
                [
                    101.5692885,
                    56.2207511
                ],
                [
                    101.5703034,
                    56.2212183
                ],
                [
                    101.571613,
                    56.2216794
                ],
                [
                    101.5730607,
                    56.2221365
                ],
                [
                    101.5742394,
                    56.2224135
                ],
                [
                    101.5750724,
                    56.2229475
                ],
                [
                    101.5757854,
                    56.2236371
                ],
                [
                    101.5764648,
                    56.2246511
                ],
                [
                    101.5768934,
                    56.2248288
                ],
                [
                    101.5787897,
                    56.2251116
                ],
                [
                    101.5802718,
                    56.2251156
                ],
                [
                    101.5814197,
                    56.2251641
                ],
                [
                    101.5821171,
                    56.2253781
                ],
                [
                    101.5829672,
                    56.2259032
                ],
                [
                    101.5841005,
                    56.2269492
                ],
                [
                    101.5845219,
                    56.2275914
                ],
                [
                    101.5847617,
                    56.2286778
                ],
                [
                    101.584798,
                    56.229752
                ],
                [
                    101.5850014,
                    56.2302326
                ],
                [
                    101.5854083,
                    56.2306728
                ],
                [
                    101.5859822,
                    56.2310645
                ],
                [
                    101.5863818,
                    56.2315209
                ],
                [
                    101.5872391,
                    56.2330998
                ],
                [
                    101.5877186,
                    56.2335601
                ],
                [
                    101.5887285,
                    56.2340891
                ],
                [
                    101.5898981,
                    56.2344647
                ],
                [
                    101.5911333,
                    56.2347958
                ],
                [
                    101.5919179,
                    56.2353368
                ],
                [
                    101.5926735,
                    56.2359991
                ],
                [
                    101.5932983,
                    56.2363261
                ],
                [
                    101.5935235,
                    56.2365684
                ],
                [
                    101.5935815,
                    56.2369277
                ],
                [
                    101.5934,
                    56.2373194
                ],
                [
                    101.5928043,
                    56.2383651
                ],
                [
                    101.5923466,
                    56.2388577
                ],
                [
                    101.5918815,
                    56.2391282
                ],
                [
                    101.5905157,
                    56.2396208
                ],
                [
                    101.589099,
                    56.240186
                ],
                [
                    101.588387,
                    56.2403072
                ],
                [
                    101.5877186,
                    56.2402103
                ],
                [
                    101.5864617,
                    56.2398065
                ],
                [
                    101.585154,
                    56.2395441
                ],
                [
                    101.584224,
                    56.2395239
                ],
                [
                    101.5835484,
                    56.239746
                ],
                [
                    101.5815804,
                    56.2386473
                ],
                [
                    101.5817664,
                    56.2385594
                ],
                [
                    101.581971,
                    56.2381718
                ],
                [
                    101.5819198,
                    56.2378488
                ],
                [
                    101.5801018,
                    56.237792
                ],
                [
                    101.5772654,
                    56.2379832
                ],
                [
                    101.5699235,
                    56.2389031
                ],
                [
                    101.5718243,
                    56.2441998
                ],
                [
                    101.5709458,
                    56.2443148
                ],
                [
                    101.5713889,
                    56.2454965
                ],
                [
                    101.5676126,
                    56.2459628
                ],
                [
                    101.5673686,
                    56.2453163
                ],
                [
                    101.5654819,
                    56.2453097
                ],
                [
                    101.5649968,
                    56.2453874
                ],
                [
                    101.5654045,
                    56.246692
                ],
                [
                    101.5639594,
                    56.2466525
                ],
                [
                    101.5625347,
                    56.2466938
                ],
                [
                    101.562464,
                    56.2465781
                ],
                [
                    101.5614628,
                    56.246583
                ],
                [
                    101.5604535,
                    56.2465879
                ],
                [
                    101.5548124,
                    56.2466153
                ],
                [
                    101.5549713,
                    56.2485897
                ],
                [
                    101.5548762,
                    56.2489464
                ],
                [
                    101.5530646,
                    56.2488169
                ],
                [
                    101.5533024,
                    56.2504256
                ],
                [
                    101.5549903,
                    56.2503464
                ],
                [
                    101.5550454,
                    56.2535449
                ],
                [
                    101.5550599,
                    56.2543867
                ],
                [
                    101.554091,
                    56.2544725
                ],
                [
                    101.5545725,
                    56.2562157
                ],
                [
                    101.5551133,
                    56.2562058
                ],
                [
                    101.555149,
                    56.2564006
                ],
                [
                    101.5580077,
                    56.2562355
                ],
                [
                    101.5603018,
                    56.2561794
                ],
                [
                    101.5616747,
                    56.2561332
                ],
                [
                    101.5626673,
                    56.2561431
                ],
                [
                    101.5641174,
                    56.2563808
                ],
                [
                    101.5683907,
                    56.2572556
                ],
                [
                    101.5705719,
                    56.2580248
                ],
                [
                    101.571083,
                    56.2581701
                ],
                [
                    101.571707,
                    56.2581866
                ],
                [
                    101.5733831,
                    56.2576254
                ],
                [
                    101.5736624,
                    56.2579852
                ],
                [
                    101.5741081,
                    56.2589591
                ],
                [
                    101.5751244,
                    56.2616692
                ],
                [
                    101.5753622,
                    56.2626265
                ],
                [
                    101.5757485,
                    56.2635771
                ],
                [
                    101.5759387,
                    56.2637454
                ],
                [
                    101.5781793,
                    56.2629796
                ],
                [
                    101.5789044,
                    56.2626364
                ],
                [
                    101.579261,
                    56.2620851
                ],
                [
                    101.5801287,
                    56.2616197
                ],
                [
                    101.5802832,
                    56.2613424
                ],
                [
                    101.580737,
                    56.2613966
                ],
                [
                    101.5811175,
                    56.2613702
                ],
                [
                    101.5817237,
                    56.2611853
                ],
                [
                    101.582116,
                    56.2611622
                ],
                [
                    101.5824666,
                    56.2612315
                ],
                [
                    101.5829064,
                    56.2614098
                ],
                [
                    101.5832987,
                    56.2617663
                ],
                [
                    101.5838455,
                    56.2626542
                ],
                [
                    101.5841724,
                    56.2629381
                ],
                [
                    101.5847786,
                    56.2631262
                ],
                [
                    101.5856938,
                    56.2633177
                ],
                [
                    101.5864605,
                    56.2633639
                ],
                [
                    101.5870251,
                    56.2632186
                ],
                [
                    101.5873045,
                    56.262915
                ],
                [
                    101.5877562,
                    56.2627136
                ],
                [
                    101.5882019,
                    56.2627136
                ],
                [
                    101.5895213,
                    56.2628291
                ],
                [
                    101.5903059,
                    56.2629645
                ],
                [
                    101.5908051,
                    56.2631295
                ],
                [
                    101.5909715,
                    56.2633243
                ],
                [
                    101.5909715,
                    56.2634959
                ],
                [
                    101.5908705,
                    56.263694
                ],
                [
                    101.5906565,
                    56.2638062
                ],
                [
                    101.590294,
                    56.2638392
                ],
                [
                    101.5899374,
                    56.2638128
                ],
                [
                    101.5894441,
                    56.2637402
                ],
                [
                    101.5889092,
                    56.2637435
                ],
                [
                    101.5883267,
                    56.2638524
                ],
                [
                    101.5878572,
                    56.2640207
                ],
                [
                    101.5874471,
                    56.2643145
                ],
                [
                    101.587358,
                    56.2646248
                ],
                [
                    101.5874293,
                    56.2649779
                ],
                [
                    101.5877323,
                    56.2654202
                ],
                [
                    101.5881128,
                    56.2656413
                ],
                [
                    101.5885882,
                    56.2657503
                ],
                [
                    101.5894084,
                    56.2658295
                ],
                [
                    101.5900919,
                    56.2658922
                ],
                [
                    101.5905852,
                    56.2657866
                ],
                [
                    101.5908824,
                    56.2656116
                ],
                [
                    101.5912627,
                    56.2652552
                ],
                [
                    101.5915955,
                    56.2649977
                ],
                [
                    101.5922196,
                    56.2647106
                ],
                [
                    101.5924217,
                    56.2644168
                ],
                [
                    101.5925168,
                    56.2638194
                ],
                [
                    101.5926713,
                    56.2634563
                ],
                [
                    101.5928555,
                    56.2631856
                ],
                [
                    101.5931586,
                    56.2631031
                ],
                [
                    101.5934201,
                    56.2630965
                ],
                [
                    101.5936162,
                    56.263212
                ],
                [
                    101.5943414,
                    56.2636081
                ],
                [
                    101.5950546,
                    56.2638227
                ],
                [
                    101.59553,
                    56.264199
                ],
                [
                    101.5957202,
                    56.2646347
                ],
                [
                    101.5956786,
                    56.2651727
                ],
                [
                    101.5953576,
                    56.2658757
                ],
                [
                    101.5949476,
                    56.2662651
                ],
                [
                    101.5943711,
                    56.2666744
                ],
                [
                    101.5941215,
                    56.2670111
                ],
                [
                    101.5941274,
                    56.2673015
                ],
                [
                    101.5939372,
                    56.2678428
                ],
                [
                    101.5934261,
                    56.2684632
                ],
                [
                    101.5926891,
                    56.2687867
                ],
                [
                    101.5920235,
                    56.2688824
                ],
                [
                    101.5909477,
                    56.2689517
                ],
                [
                    101.5903772,
                    56.2690243
                ],
                [
                    101.5899611,
                    56.2691794
                ],
                [
                    101.5894025,
                    56.269681
                ],
                [
                    101.5892539,
                    56.2699813
                ],
                [
                    101.5893549,
                    56.270285
                ],
                [
                    101.5897531,
                    56.2706843
                ],
                [
                    101.5901573,
                    56.2708691
                ],
                [
                    101.5907754,
                    56.2709549
                ],
                [
                    101.5912627,
                    56.2710638
                ],
                [
                    101.5915777,
                    56.2712651
                ],
                [
                    101.591649,
                    56.2716215
                ],
                [
                    101.5915242,
                    56.2718954
                ],
                [
                    101.5917322,
                    56.2721924
                ],
                [
                    101.5920591,
                    56.2723442
                ],
                [
                    101.5924098,
                    56.2724102
                ],
                [
                    101.5928734,
                    56.2723838
                ],
                [
                    101.5934617,
                    56.2723442
                ],
                [
                    101.5939075,
                    56.2724135
                ],
                [
                    101.5941512,
                    56.2725851
                ],
                [
                    101.5941631,
                    56.2727732
                ],
                [
                    101.5937946,
                    56.2729514
                ],
                [
                    101.5934855,
                    56.2730867
                ],
                [
                    101.5934558,
                    56.2733309
                ],
                [
                    101.5935034,
                    56.2734662
                ],
                [
                    101.593753,
                    56.273519
                ],
                [
                    101.5941096,
                    56.2735223
                ],
                [
                    101.5957975,
                    56.2731725
                ],
                [
                    101.597105,
                    56.2728953
                ],
                [
                    101.5976161,
                    56.2728491
                ],
                [
                    101.5980262,
                    56.272925
                ],
                [
                    101.5983887,
                    56.2731329
                ],
                [
                    101.5985017,
                    56.2732847
                ],
                [
                    101.5984363,
                    56.2735553
                ],
                [
                    101.5980678,
                    56.2738556
                ],
                [
                    101.5973367,
                    56.2741295
                ],
                [
                    101.5969029,
                    56.2743572
                ],
                [
                    101.59679,
                    56.2745387
                ],
                [
                    101.5968494,
                    56.2747432
                ],
                [
                    101.5970217,
                    56.2749148
                ],
                [
                    101.5973487,
                    56.2749478
                ],
                [
                    101.5976518,
                    56.2748752
                ],
                [
                    101.5980797,
                    56.2746838
                ],
                [
                    101.5987338,
                    56.2741722
                ],
                [
                    101.5991294,
                    56.2740168
                ],
                [
                    101.5994428,
                    56.2739357
                ],
                [
                    101.5997745,
                    56.2739306
                ],
                [
                    101.6001944,
                    56.2740286
                ],
                [
                    101.6008334,
                    56.2742939
                ],
                [
                    101.6015242,
                    56.274647
                ],
                [
                    101.6020567,
                    56.2750812
                ],
                [
                    101.602288,
                    56.2755509
                ],
                [
                    101.6024371,
                    56.2759513
                ],
                [
                    101.6028053,
                    56.2765713
                ],
                [
                    101.60293,
                    56.2774582
                ],
                [
                    101.6030335,
                    56.2780613
                ],
                [
                    101.6031674,
                    56.278308
                ],
                [
                    101.6034047,
                    56.2785411
                ],
                [
                    101.6038095,
                    56.2788029
                ],
                [
                    101.6043207,
                    56.2789989
                ],
                [
                    101.6045854,
                    56.2791442
                ],
                [
                    101.6047163,
                    56.2793587
                ],
                [
                    101.6047619,
                    56.2798081
                ],
                [
                    101.6046737,
                    56.2802473
                ],
                [
                    101.604771,
                    56.2808081
                ],
                [
                    101.6048045,
                    56.2812051
                ],
                [
                    101.6046067,
                    56.2815649
                ],
                [
                    101.6044393,
                    56.2817642
                ],
                [
                    101.6044241,
                    56.2819534
                ],
                [
                    101.6045763,
                    56.2822372
                ],
                [
                    101.6047862,
                    56.2825176
                ],
                [
                    101.6052305,
                    56.2828909
                ],
                [
                    101.6053827,
                    56.2832202
                ],
                [
                    101.6053644,
                    56.2834871
                ],
                [
                    101.6051605,
                    56.2837506
                ],
                [
                    101.6045398,
                    56.284406
                ],
                [
                    101.6040864,
                    56.2847269
                ],
                [
                    101.6036512,
                    56.2849667
                ],
                [
                    101.6032374,
                    56.2850799
                ],
                [
                    101.6028965,
                    56.2850782
                ],
                [
                    101.6027383,
                    56.2850259
                ],
                [
                    101.6026014,
                    56.2848265
                ],
                [
                    101.6024432,
                    56.2843604
                ],
                [
                    101.6022667,
                    56.2839753
                ],
                [
                    101.6020111,
                    56.2838351
                ],
                [
                    101.6017128,
                    56.2837506
                ],
                [
                    101.6014785,
                    56.2837793
                ],
                [
                    101.6010951,
                    56.2839381
                ],
                [
                    101.60066,
                    56.2843063
                ],
                [
                    101.6000392,
                    56.2849009
                ],
                [
                    101.5997927,
                    56.2853417
                ],
                [
                    101.599744,
                    56.2856711
                ],
                [
                    101.5997866,
                    56.2859143
                ],
                [
                    101.5999844,
                    56.2861963
                ],
                [
                    101.6004135,
                    56.2865493
                ],
                [
                    101.6008395,
                    56.2867554
                ],
                [
                    101.6013872,
                    56.2868652
                ],
                [
                    101.601868,
                    56.2868229
                ],
                [
                    101.6021602,
                    56.2868381
                ],
                [
                    101.6024401,
                    56.2869395
                ],
                [
                    101.6024827,
                    56.2871134
                ],
                [
                    101.6022605,
                    56.2873972
                ],
                [
                    101.6019228,
                    56.2877012
                ],
                [
                    101.6012199,
                    56.2881504
                ],
                [
                    101.6001609,
                    56.2888226
                ],
                [
                    101.5993272,
                    56.2892026
                ],
                [
                    101.5983351,
                    56.2894695
                ],
                [
                    101.5976718,
                    56.2897093
                ],
                [
                    101.5974131,
                    56.2899525
                ],
                [
                    101.5973249,
                    56.2902412
                ],
                [
                    101.5975105,
                    56.2906398
                ],
                [
                    101.5978194,
                    56.2909788
                ],
                [
                    101.5977167,
                    56.2912047
                ],
                [
                    101.5972944,
                    56.2914369
                ],
                [
                    101.59668,
                    56.2916797
                ],
                [
                    101.5959307,
                    56.2918551
                ],
                [
                    101.5953454,
                    56.2917966
                ],
                [
                    101.594994,
                    56.2914782
                ],
                [
                    101.5946546,
                    56.2905557
                ],
                [
                    101.5942917,
                    56.2901074
                ],
                [
                    101.5935776,
                    56.2898475
                ],
                [
                    101.5925357,
                    56.2899969
                ],
                [
                    101.591564,
                    56.2902828
                ],
                [
                    101.5909201,
                    56.2906141
                ],
                [
                    101.5907913,
                    56.2910559
                ],
                [
                    101.5909201,
                    56.2916147
                ],
                [
                    101.5915289,
                    56.2922319
                ],
                [
                    101.591564,
                    56.2926282
                ],
                [
                    101.5917513,
                    56.2932259
                ],
                [
                    101.5917513,
                    56.2935962
                ],
                [
                    101.5910957,
                    56.2939275
                ],
                [
                    101.5868461,
                    56.2947851
                ],
                [
                    101.5843057,
                    56.2952463
                ],
                [
                    101.5835447,
                    56.2955581
                ],
                [
                    101.5834862,
                    56.2959414
                ],
                [
                    101.5837905,
                    56.2963247
                ],
                [
                    101.5846217,
                    56.2966625
                ],
                [
                    101.5846217,
                    56.2970653
                ],
                [
                    101.5839427,
                    56.2980851
                ],
                [
                    101.5836618,
                    56.2983774
                ],
                [
                    101.5829711,
                    56.2984879
                ],
                [
                    101.582175,
                    56.298319
                ],
                [
                    101.5815545,
                    56.2983645
                ],
                [
                    101.5813438,
                    56.2985788
                ],
                [
                    101.5811916,
                    56.2989621
                ],
                [
                    101.5814257,
                    56.2992933
                ],
                [
                    101.5826784,
                    56.299761
                ],
                [
                    101.5837671,
                    56.2995662
                ],
                [
                    101.5847622,
                    56.2993388
                ],
                [
                    101.5855466,
                    56.298988
                ],
                [
                    101.5864129,
                    56.2990985
                ],
                [
                    101.5872675,
                    56.2995467
                ],
                [
                    101.5883446,
                    56.3001053
                ],
                [
                    101.5891992,
                    56.3007613
                ],
                [
                    101.5902879,
                    56.3013849
                ],
                [
                    101.590885,
                    56.3016187
                ],
                [
                    101.5916342,
                    56.3019045
                ],
                [
                    101.5917513,
                    56.3022423
                ],
                [
                    101.5914001,
                    56.3028788
                ],
                [
                    101.5910722,
                    56.3034958
                ],
                [
                    101.5910957,
                    56.3040024
                ],
                [
                    101.591482,
                    56.304561
                ],
                [
                    101.5919737,
                    56.3048987
                ],
                [
                    101.5929688,
                    56.305204
                ],
                [
                    101.5941044,
                    56.3050026
                ],
                [
                    101.5951697,
                    56.3049896
                ],
                [
                    101.59572,
                    56.3053079
                ],
                [
                    101.5955795,
                    56.3058209
                ],
                [
                    101.5952751,
                    56.3065743
                ],
                [
                    101.5955561,
                    56.3073861
                ],
                [
                    101.5960244,
                    56.3083927
                ],
                [
                    101.5962117,
                    56.3095941
                ],
                [
                    101.5962234,
                    56.3098474
                ],
                [
                    101.5957902,
                    56.3100941
                ],
                [
                    101.5951697,
                    56.3101786
                ],
                [
                    101.5940576,
                    56.3103993
                ],
                [
                    101.5938177,
                    56.3107993
                ],
                [
                    101.5940355,
                    56.3112512
                ],
                [
                    101.5946898,
                    56.3115422
                ],
                [
                    101.5951815,
                    56.3117176
                ],
                [
                    101.5956966,
                    56.3116981
                ],
                [
                    101.5960829,
                    56.3113864
                ],
                [
                    101.596797,
                    56.3110292
                ],
                [
                    101.5974643,
                    56.3108539
                ],
                [
                    101.5981784,
                    56.3108085
                ],
                [
                    101.5988223,
                    56.3106721
                ],
                [
                    101.5987872,
                    56.3103149
                ],
                [
                    101.5988105,
                    56.3099318
                ],
                [
                    101.5999345,
                    56.3099578
                ],
                [
                    101.6026037,
                    56.3110552
                ],
                [
                    101.6032125,
                    56.3114189
                ],
                [
                    101.6034115,
                    56.311815
                ],
                [
                    101.6031305,
                    56.3121981
                ],
                [
                    101.6028612,
                    56.3123669
                ],
                [
                    101.6022057,
                    56.3125033
                ],
                [
                    101.6012574,
                    56.3123864
                ],
                [
                    101.6004028,
                    56.312328
                ],
                [
                    101.5999111,
                    56.3124254
                ],
                [
                    101.5997355,
                    56.3125877
                ],
                [
                    101.5997823,
                    56.3128474
                ],
                [
                    101.5999111,
                    56.3133929
                ],
                [
                    101.6003911,
                    56.3136266
                ],
                [
                    101.6015266,
                    56.3136007
                ],
                [
                    101.6028378,
                    56.3134903
                ],
                [
                    101.6032242,
                    56.3136201
                ],
                [
                    101.6033412,
                    56.3139448
                ],
                [
                    101.6032007,
                    56.3144448
                ],
                [
                    101.6037627,
                    56.3148473
                ],
                [
                    101.6043246,
                    56.3148603
                ],
                [
                    101.6050856,
                    56.314737
                ],
                [
                    101.6056475,
                    56.3142045
                ],
                [
                    101.6058699,
                    56.3138214
                ],
                [
                    101.6056826,
                    56.3134318
                ],
                [
                    101.6051674,
                    56.3130163
                ],
                [
                    101.605109,
                    56.3127176
                ],
                [
                    101.6053665,
                    56.3125357
                ],
                [
                    101.6060221,
                    56.3125098
                ],
                [
                    101.6064904,
                    56.312763
                ],
                [
                    101.6067948,
                    56.3136721
                ],
                [
                    101.6073684,
                    56.3141591
                ],
                [
                    101.607825,
                    56.3145941
                ],
                [
                    101.6077548,
                    56.3148603
                ],
                [
                    101.6073099,
                    56.3150226
                ],
                [
                    101.6066192,
                    56.315172
                ],
                [
                    101.6061859,
                    56.3153798
                ],
                [
                    101.6061626,
                    56.3156914
                ],
                [
                    101.6064085,
                    56.3160226
                ],
                [
                    101.6068533,
                    56.3163926
                ],
                [
                    101.6066075,
                    56.3167043
                ],
                [
                    101.6063265,
                    56.3168147
                ],
                [
                    101.6056358,
                    56.3168277
                ],
                [
                    101.6052495,
                    56.3170224
                ],
                [
                    101.6053548,
                    56.3175678
                ],
                [
                    101.6055304,
                    56.3177951
                ],
                [
                    101.6065957,
                    56.3181522
                ],
                [
                    101.6069002,
                    56.3186715
                ],
                [
                    101.6074387,
                    56.3188079
                ],
                [
                    101.6080709,
                    56.3188144
                ],
                [
                    101.6087967,
                    56.3185871
                ],
                [
                    101.6090894,
                    56.3182041
                ],
                [
                    101.6090425,
                    56.3178795
                ],
                [
                    101.6085391,
                    56.3177301
                ],
                [
                    101.6080006,
                    56.3174639
                ],
                [
                    101.6078718,
                    56.3170679
                ],
                [
                    101.6086445,
                    56.3162563
                ],
                [
                    101.6100845,
                    56.3156914
                ],
                [
                    101.6105644,
                    56.3156525
                ],
                [
                    101.6110678,
                    56.3159446
                ],
                [
                    101.6115713,
                    56.3166134
                ],
                [
                    101.6122151,
                    56.3168082
                ],
                [
                    101.613421,
                    56.3172367
                ],
                [
                    101.6139009,
                    56.3178665
                ],
                [
                    101.6140765,
                    56.3181586
                ],
                [
                    101.6140297,
                    56.3183015
                ],
                [
                    101.6136317,
                    56.3184703
                ],
                [
                    101.612941,
                    56.3183794
                ],
                [
                    101.6120746,
                    56.3181522
                ],
                [
                    101.6114542,
                    56.3182171
                ],
                [
                    101.6110093,
                    56.3185612
                ],
                [
                    101.6109391,
                    56.3189637
                ],
                [
                    101.6109859,
                    56.3193532
                ],
                [
                    101.6114893,
                    56.3195415
                ],
                [
                    101.6122503,
                    56.3196649
                ],
                [
                    101.6131517,
                    56.3196584
                ],
                [
                    101.6139946,
                    56.3193662
                ],
                [
                    101.6144512,
                    56.3189118
                ],
                [
                    101.6148492,
                    56.3186845
                ],
                [
                    101.6153526,
                    56.3186586
                ],
                [
                    101.6157858,
                    56.3188339
                ],
                [
                    101.6160082,
                    56.3191455
                ],
                [
                    101.615575,
                    56.3198012
                ],
                [
                    101.615376,
                    56.320353
                ],
                [
                    101.6157624,
                    56.3208399
                ],
                [
                    101.6170267,
                    56.3213983
                ],
                [
                    101.6184784,
                    56.3224564
                ],
                [
                    101.6195437,
                    56.3230342
                ],
                [
                    101.6204803,
                    56.3232679
                ],
                [
                    101.6208081,
                    56.3235211
                ],
                [
                    101.6205037,
                    56.3239625
                ],
                [
                    101.6196724,
                    56.3245467
                ],
                [
                    101.6195203,
                    56.3249622
                ],
                [
                    101.6195905,
                    56.3256502
                ],
                [
                    101.6192393,
                    56.3258969
                ],
                [
                    101.6185486,
                    56.3261241
                ],
                [
                    101.6175535,
                    56.3260592
                ],
                [
                    101.6169213,
                    56.3259164
                ],
                [
                    101.6165701,
                    56.325449
                ],
                [
                    101.6162892,
                    56.3252478
                ],
                [
                    101.6156687,
                    56.3252932
                ],
                [
                    101.6152472,
                    56.3255658
                ],
                [
                    101.6154813,
                    56.3259748
                ],
                [
                    101.6165818,
                    56.32652
                ],
                [
                    101.6165233,
                    56.3268446
                ],
                [
                    101.6157154,
                    56.3270393
                ],
                [
                    101.6133156,
                    56.3273768
                ],
                [
                    101.613827,
                    56.3275321
                ],
                [
                    101.624915,
                    56.3308988
                ],
                [
                    101.6810224,
                    56.3294803
                ],
                [
                    101.6950583,
                    56.3291471
                ],
                [
                    101.7196754,
                    56.3288404
                ],
                [
                    101.7361843,
                    56.3283413
                ],
                [
                    101.7363675,
                    56.3306068
                ],
                [
                    101.7427564,
                    56.3305056
                ],
                [
                    101.7415431,
                    56.3318191
                ],
                [
                    101.739746,
                    56.3329994
                ],
                [
                    101.7392768,
                    56.3335134
                ],
                [
                    101.7394027,
                    56.335969
                ],
                [
                    101.752005,
                    56.3357849
                ],
                [
                    101.7519592,
                    56.3364956
                ],
                [
                    101.7561714,
                    56.336743
                ],
                [
                    101.7654143,
                    56.342393
                ],
                [
                    101.7716858,
                    56.339633
                ],
                [
                    101.7724697,
                    56.3399457
                ],
                [
                    101.7750262,
                    56.3381835
                ],
                [
                    101.7779968,
                    56.3368985
                ],
                [
                    101.7857116,
                    56.3334913
                ],
                [
                    101.7889562,
                    56.3326448
                ],
                [
                    101.7915788,
                    56.334858
                ],
                [
                    101.7926923,
                    56.3357961
                ],
                [
                    101.7961939,
                    56.3380944
                ],
                [
                    101.7978489,
                    56.3389121
                ],
                [
                    101.7981645,
                    56.3391501
                ],
                [
                    101.7989996,
                    56.3391176
                ],
                [
                    101.7996223,
                    56.3389227
                ],
                [
                    101.7982744,
                    56.3383461
                ],
                [
                    101.7968897,
                    56.336972
                ],
                [
                    101.7952442,
                    56.3340374
                ],
                [
                    101.7944932,
                    56.3315786
                ],
                [
                    101.794672,
                    56.3289609
                ],
                [
                    101.7966572,
                    56.3244589
                ],
                [
                    101.7986782,
                    56.3196786
                ],
                [
                    101.8011284,
                    56.3154334
                ],
                [
                    101.8051704,
                    56.310652
                ],
                [
                    101.8077637,
                    56.3078245
                ],
                [
                    101.8116969,
                    56.3051526
                ],
                [
                    101.8179183,
                    56.3145068
                ],
                [
                    101.8265835,
                    56.3276514
                ],
                [
                    101.8336256,
                    56.3384832
                ],
                [
                    101.8348105,
                    56.339301
                ],
                [
                    101.8363307,
                    56.3397719
                ],
                [
                    101.8385887,
                    56.3397843
                ],
                [
                    101.8420761,
                    56.3399206
                ],
                [
                    101.844446,
                    56.3399206
                ],
                [
                    101.8472181,
                    56.3388178
                ],
                [
                    101.8515999,
                    56.3377149
                ],
                [
                    101.8572336,
                    56.3368227
                ],
                [
                    101.8606092,
                    56.3362526
                ],
                [
                    101.8631803,
                    56.3368599
                ],
                [
                    101.8655965,
                    56.3380171
                ],
                [
                    101.8762128,
                    56.3409998
                ],
                [
                    101.8766816,
                    56.3403637
                ],
                [
                    101.8823921,
                    56.3333363
                ],
                [
                    101.8855887,
                    56.327565
                ],
                [
                    101.8875014,
                    56.3230352
                ],
                [
                    101.8881567,
                    56.3194757
                ],
                [
                    101.8883625,
                    56.3183536
                ],
                [
                    101.8992903,
                    56.3181941
                ],
                [
                    101.9220129,
                    56.3178609
                ],
                [
                    101.9331707,
                    56.3176995
                ],
                [
                    101.9364721,
                    56.3174264
                ],
                [
                    101.9367989,
                    56.3135825
                ],
                [
                    101.9396792,
                    56.3126261
                ],
                [
                    101.940607,
                    56.3100187
                ],
                [
                    101.9401344,
                    56.3007821
                ],
                [
                    101.9417625,
                    56.2981836
                ],
                [
                    101.9576417,
                    56.3035164
                ],
                [
                    101.9607755,
                    56.3045945
                ],
                [
                    101.9647759,
                    56.3052113
                ],
                [
                    101.9704308,
                    56.3050899
                ],
                [
                    101.9706577,
                    56.3019368
                ],
                [
                    101.9711444,
                    56.2899808
                ],
                [
                    101.9728976,
                    56.2684023
                ],
                [
                    101.9805821,
                    56.2686596
                ],
                [
                    101.9801956,
                    56.2632218
                ],
                [
                    101.9961195,
                    56.2573704
                ],
                [
                    101.9981764,
                    56.2557745
                ],
                [
                    102.0017024,
                    56.2536888
                ],
                [
                    102.0026819,
                    56.2507323
                ],
                [
                    102.003237,
                    56.2438754
                ],
                [
                    102.0028126,
                    56.2409544
                ],
                [
                    102.0001354,
                    56.2391764
                ],
                [
                    101.9957604,
                    56.2389224
                ],
                [
                    101.9900142,
                    56.2401743
                ],
                [
                    101.9792852,
                    56.2469717
                ],
                [
                    101.976878,
                    56.249535
                ],
                [
                    101.9756785,
                    56.2521145
                ],
                [
                    101.9719041,
                    56.2521621
                ],
                [
                    101.9709541,
                    56.2525234
                ],
                [
                    101.9702266,
                    56.2521953
                ],
                [
                    101.9632625,
                    56.2507742
                ],
                [
                    101.9584604,
                    56.2511688
                ],
                [
                    101.9573489,
                    56.2550274
                ],
                [
                    101.9557267,
                    56.2560465
                ],
                [
                    101.9529651,
                    56.2579428
                ],
                [
                    101.9512571,
                    56.2607091
                ],
                [
                    101.9431911,
                    56.2604743
                ],
                [
                    101.9422448,
                    56.2601453
                ],
                [
                    101.9420389,
                    56.2592956
                ],
                [
                    101.9415731,
                    56.258714
                ],
                [
                    101.9402042,
                    56.2582003
                ],
                [
                    101.9375993,
                    56.2582122
                ],
                [
                    101.9325546,
                    56.2603706
                ],
                [
                    101.9281236,
                    56.2623299
                ],
                [
                    101.9229265,
                    56.2638672
                ],
                [
                    101.9215825,
                    56.2644365
                ],
                [
                    101.9192709,
                    56.2662489
                ],
                [
                    101.9074928,
                    56.2657319
                ],
                [
                    101.8928487,
                    56.2651336
                ],
                [
                    101.8751397,
                    56.2644423
                ],
                [
                    101.8669285,
                    56.2642448
                ],
                [
                    101.8632884,
                    56.2644365
                ],
                [
                    101.8579223,
                    56.2649245
                ],
                [
                    101.8579312,
                    56.2629233
                ],
                [
                    101.8586437,
                    56.2248295
                ],
                [
                    101.8591643,
                    56.2083541
                ],
                [
                    101.8615048,
                    56.2083759
                ],
                [
                    101.8647173,
                    56.2069491
                ],
                [
                    101.8646535,
                    56.2056352
                ],
                [
                    101.8614932,
                    56.2037176
                ],
                [
                    101.8559389,
                    56.2019597
                ],
                [
                    101.8496184,
                    56.1955133
                ],
                [
                    101.8501929,
                    56.1943056
                ],
                [
                    101.8440321,
                    56.1925295
                ],
                [
                    101.8434894,
                    56.1912685
                ],
                [
                    101.839978,
                    56.190629
                ],
                [
                    101.8351897,
                    56.1906113
                ],
                [
                    101.8299865,
                    56.1913218
                ],
                [
                    101.824879,
                    56.1940748
                ],
                [
                    101.8191331,
                    56.1983726
                ],
                [
                    101.8137575,
                    56.2043234
                ],
                [
                    101.8107951,
                    56.209664
                ],
                [
                    101.8119188,
                    56.213936
                ],
                [
                    101.8151031,
                    56.2159196
                ],
                [
                    101.8219436,
                    56.2244778
                ],
                [
                    101.8177105,
                    56.225977
                ],
                [
                    101.8164357,
                    56.2268946
                ],
                [
                    101.8164721,
                    56.2327438
                ],
                [
                    101.8160144,
                    56.2345752
                ],
                [
                    101.8144193,
                    56.2372712
                ],
                [
                    101.8144323,
                    56.2404829
                ],
                [
                    101.815766,
                    56.2443191
                ],
                [
                    101.8149684,
                    56.2454452
                ],
                [
                    101.816289,
                    56.2488015
                ],
                [
                    101.8172827,
                    56.2499202
                ],
                [
                    101.8165767,
                    56.2528984
                ],
                [
                    101.8158313,
                    56.2544237
                ],
                [
                    101.8156875,
                    56.25523
                ],
                [
                    101.8163675,
                    56.2560507
                ],
                [
                    101.8188779,
                    56.2576267
                ],
                [
                    101.8180019,
                    56.258629
                ],
                [
                    101.8167989,
                    56.2604663
                ],
                [
                    101.8172435,
                    56.2623181
                ],
                [
                    101.817165,
                    56.2631169
                ],
                [
                    101.7972385,
                    56.2741894
                ],
                [
                    101.7667807,
                    56.2923283
                ],
                [
                    101.761291,
                    56.2883872
                ],
                [
                    101.7539456,
                    56.2855
                ],
                [
                    101.7381972,
                    56.2837549
                ],
                [
                    101.7293083,
                    56.2795346
                ],
                [
                    101.7196478,
                    56.27936
                ],
                [
                    101.7143316,
                    56.2812799
                ],
                [
                    101.710616,
                    56.284564
                ],
                [
                    101.7067289,
                    56.2790427
                ],
                [
                    101.7037565,
                    56.2758215
                ],
                [
                    101.6912092,
                    56.2711401
                ],
                [
                    101.6868648,
                    56.2652676
                ],
                [
                    101.6814629,
                    56.2642835
                ],
                [
                    101.6804911,
                    56.2597594
                ],
                [
                    101.6798909,
                    56.2574098
                ],
                [
                    101.6858358,
                    56.254425
                ],
                [
                    101.6897229,
                    56.2462156
                ],
                [
                    101.6881224,
                    56.2431823
                ],
                [
                    101.6814343,
                    56.2409747
                ],
                [
                    101.6862931,
                    56.2355265
                ],
                [
                    101.6890655,
                    56.2310466
                ],
                [
                    101.6878651,
                    56.2285364
                ],
                [
                    101.6891799,
                    56.2268523
                ],
                [
                    101.6903803,
                    56.2235314
                ],
                [
                    101.6912377,
                    56.2192091
                ],
                [
                    101.6858072,
                    56.2145366
                ],
                [
                    101.6778901,
                    56.2115008
                ],
                [
                    101.6672864,
                    56.2108491
                ],
                [
                    101.6569971,
                    56.2108967
                ],
                [
                    101.6627134,
                    56.2074473
                ],
                [
                    101.6794907,
                    56.202996
                ],
                [
                    101.6952106,
                    56.1972085
                ],
                [
                    101.7066718,
                    56.1894321
                ],
                [
                    101.7103874,
                    56.1842788
                ],
                [
                    101.722363,
                    56.1790135
                ],
                [
                    101.7297942,
                    56.1700719
                ],
                [
                    101.735139,
                    56.1654571
                ],
                [
                    101.7407981,
                    56.1610327
                ],
                [
                    101.7399121,
                    56.1575629
                ],
                [
                    101.7238493,
                    56.1503516
                ],
                [
                    101.6849726,
                    56.1272449
                ],
                [
                    101.6750762,
                    56.1183032
                ],
                [
                    101.6663932,
                    56.1132345
                ],
                [
                    101.6667561,
                    56.1122684
                ],
                [
                    101.7084154,
                    56.0889323
                ],
                [
                    101.7157871,
                    56.0880852
                ],
                [
                    101.7256832,
                    56.0854725
                ],
                [
                    101.7397133,
                    56.0836149
                ],
                [
                    101.7522983,
                    56.0839722
                ],
                [
                    101.7633651,
                    56.0830025
                ],
                [
                    101.7666211,
                    56.0820329
                ],
                [
                    101.7730051,
                    56.078154
                ],
                [
                    101.7745233,
                    56.076684
                ],
                [
                    101.7761879,
                    56.0726105
                ],
                [
                    101.7767367,
                    56.070783
                ],
                [
                    101.7740843,
                    56.0671582
                ],
                [
                    101.7709014,
                    56.0664026
                ],
                [
                    101.7528471,
                    56.0678526
                ],
                [
                    101.7387255,
                    56.0708647
                ],
                [
                    101.7340976,
                    56.0704256
                ],
                [
                    101.7355427,
                    56.0684346
                ],
                [
                    101.7439388,
                    56.0641662
                ],
                [
                    101.7450546,
                    56.0615928
                ],
                [
                    101.7407742,
                    56.05858
                ],
                [
                    101.7425486,
                    56.0572216
                ],
                [
                    101.7534324,
                    56.052288
                ],
                [
                    101.7637126,
                    56.0495196
                ],
                [
                    101.769932,
                    56.0486717
                ],
                [
                    101.7724379,
                    56.0478851
                ],
                [
                    101.7746148,
                    56.0461687
                ],
                [
                    101.7709198,
                    56.0444625
                ],
                [
                    101.7711393,
                    56.0418366
                ],
                [
                    101.7848584,
                    56.0390164
                ],
                [
                    101.7907119,
                    56.0365128
                ],
                [
                    101.7923215,
                    56.0345098
                ],
                [
                    101.7931813,
                    56.0314642
                ],
                [
                    101.826065,
                    56.0278117
                ],
                [
                    101.8259578,
                    56.0254359
                ],
                [
                    101.803164,
                    56.0213029
                ],
                [
                    101.7834893,
                    56.0183634
                ],
                [
                    101.7638943,
                    56.0216055
                ],
                [
                    101.7493237,
                    56.0328614
                ],
                [
                    101.7268968,
                    56.0389092
                ],
                [
                    101.7167191,
                    56.045363
                ],
                [
                    101.7096594,
                    56.0515536
                ],
                [
                    101.6942666,
                    56.0534156
                ],
                [
                    101.6800446,
                    56.0527221
                ],
                [
                    101.6790718,
                    56.056389
                ],
                [
                    101.6763272,
                    56.0570604
                ],
                [
                    101.6715134,
                    56.058238
                ],
                [
                    101.6711952,
                    56.0585828
                ],
                [
                    101.6691186,
                    56.0586977
                ],
                [
                    101.6644414,
                    56.0578724
                ],
                [
                    101.6614854,
                    56.0583112
                ],
                [
                    101.6601383,
                    56.0627714
                ],
                [
                    101.6613919,
                    56.0649125
                ],
                [
                    101.660681,
                    56.0673042
                ],
                [
                    101.6611861,
                    56.0690378
                ],
                [
                    101.6650214,
                    56.0698315
                ],
                [
                    101.6699231,
                    56.068996
                ],
                [
                    101.6714011,
                    56.0681292
                ],
                [
                    101.6750119,
                    56.0680874
                ],
                [
                    101.6713597,
                    56.0813188
                ],
                [
                    101.6635693,
                    56.0810069
                ],
                [
                    101.6430644,
                    56.0804014
                ],
                [
                    101.6399026,
                    56.0803596
                ],
                [
                    101.6373582,
                    56.0806311
                ],
                [
                    101.6345863,
                    56.0812441
                ],
                [
                    101.6308504,
                    56.0829211
                ],
                [
                    101.6243129,
                    56.08711
                ],
                [
                    101.6217625,
                    56.0881121
                ],
                [
                    101.6156558,
                    56.0898222
                ],
                [
                    101.5921875,
                    56.0963013
                ],
                [
                    101.5786213,
                    56.1009028
                ],
                [
                    101.5742509,
                    56.1023719
                ],
                [
                    101.5740953,
                    56.0969959
                ],
                [
                    101.5351449,
                    56.096722
                ],
                [
                    101.5347977,
                    56.0969157
                ],
                [
                    101.5204413,
                    56.0969157
                ],
                [
                    101.5181543,
                    56.0966085
                ],
                [
                    101.5097727,
                    56.0964482
                ],
                [
                    101.5093656,
                    56.0990729
                ],
                [
                    101.502835,
                    56.0985877
                ],
                [
                    101.5026905,
                    56.0990117
                ],
                [
                    101.488837,
                    56.0981034
                ],
                [
                    101.4582921,
                    56.0959929
                ],
                [
                    101.4563883,
                    56.096053
                ],
                [
                    101.4550712,
                    56.0962267
                ],
                [
                    101.4407028,
                    56.1001336
                ],
                [
                    101.4388941,
                    56.1005677
                ],
                [
                    101.4332933,
                    56.1004936
                ],
                [
                    101.4294345,
                    56.0993033
                ],
                [
                    101.4219542,
                    56.0956807
                ],
                [
                    101.417682,
                    56.094751
                ],
                [
                    101.4139654,
                    56.0956379
                ],
                [
                    101.4124135,
                    56.0969577
                ],
                [
                    101.4085437,
                    56.0978767
                ],
                [
                    101.405773,
                    56.0989557
                ],
                [
                    101.4035841,
                    56.1011157
                ],
                [
                    101.398701,
                    56.1015226
                ],
                [
                    101.3954457,
                    56.10242
                ],
                [
                    101.3884111,
                    56.1068333
                ],
                [
                    101.3839397,
                    56.1079392
                ],
                [
                    101.3781961,
                    56.1082835
                ],
                [
                    101.376101,
                    56.1086153
                ],
                [
                    101.3768657,
                    56.1089381
                ],
                [
                    101.3763069,
                    56.1096164
                ],
                [
                    101.3747244,
                    56.110168
                ],
                [
                    101.3734626,
                    56.1107371
                ],
                [
                    101.3731303,
                    56.1112682
                ],
                [
                    101.3736325,
                    56.1119932
                ],
                [
                    101.3754149,
                    56.1125864
                ],
                [
                    101.3762589,
                    56.1131094
                ],
                [
                    101.376346,
                    56.113437
                ],
                [
                    101.3760977,
                    56.1142836
                ],
                [
                    101.3760977,
                    56.1158149
                ],
                [
                    101.3785048,
                    56.1168187
                ],
                [
                    101.3791524,
                    56.1185581
                ],
                [
                    101.3797123,
                    56.1192647
                ],
                [
                    101.3796735,
                    56.119922
                ],
                [
                    101.3793201,
                    56.1206759
                ],
                [
                    101.3787861,
                    56.121453
                ],
                [
                    101.378614,
                    56.1215982
                ],
                [
                    101.3784002,
                    56.121793
                ],
                [
                    101.3778868,
                    56.1219401
                ],
                [
                    101.3771023,
                    56.1219003
                ],
                [
                    101.3753468,
                    56.1217518
                ],
                [
                    101.373551,
                    56.1215227
                ],
                [
                    101.3724314,
                    56.1211649
                ],
                [
                    101.3717967,
                    56.1210933
                ],
                [
                    101.3711001,
                    56.121281
                ],
                [
                    101.3691368,
                    56.1219719
                ],
                [
                    101.3684094,
                    56.1219719
                ],
                [
                    101.3672969,
                    56.1220196
                ],
                [
                    101.3668691,
                    56.1217731
                ],
                [
                    101.3663782,
                    56.1213424
                ],
                [
                    101.3647672,
                    56.1212897
                ],
                [
                    101.3638033,
                    56.1214516
                ],
                [
                    101.363048,
                    56.121872
                ],
                [
                    101.362285,
                    56.1223694
                ],
                [
                    101.3613287,
                    56.1226241
                ],
                [
                    101.3603928,
                    56.1225513
                ],
                [
                    101.3590219,
                    56.1222723
                ],
                [
                    101.3575895,
                    56.1226646
                ],
                [
                    101.3562671,
                    56.1239246
                ],
                [
                    101.3547755,
                    56.125244
                ],
                [
                    101.3544299,
                    56.1267362
                ],
                [
                    101.3549905,
                    56.1272222
                ],
                [
                    101.3563977,
                    56.1282787
                ],
                [
                    101.3570632,
                    56.128968
                ],
                [
                    101.3577596,
                    56.129623
                ],
                [
                    101.3584359,
                    56.1298903
                ],
                [
                    101.3595224,
                    56.1301081
                ],
                [
                    101.3609151,
                    56.130569
                ],
                [
                    101.3629041,
                    56.131006
                ],
                [
                    101.3636165,
                    56.131364
                ],
                [
                    101.3657132,
                    56.1317893
                ],
                [
                    101.3659653,
                    56.1319273
                ],
                [
                    101.3677969,
                    56.1333741
                ],
                [
                    101.3679707,
                    56.133814
                ],
                [
                    101.3677244,
                    56.1344567
                ],
                [
                    101.3674312,
                    56.1349952
                ],
                [
                    101.3664453,
                    56.136123
                ],
                [
                    101.3654658,
                    56.1369738
                ],
                [
                    101.3645523,
                    56.1377707
                ],
                [
                    101.3632941,
                    56.1383412
                ],
                [
                    101.3618731,
                    56.1391414
                ],
                [
                    101.3602863,
                    56.1401986
                ],
                [
                    101.3589724,
                    56.1409003
                ],
                [
                    101.3570938,
                    56.1416929
                ],
                [
                    101.3551662,
                    56.1430826
                ],
                [
                    101.3541973,
                    56.1440879
                ],
                [
                    101.3534425,
                    56.1461774
                ],
                [
                    101.353087,
                    56.1470768
                ],
                [
                    101.3530298,
                    56.1480657
                ]
            ],
            "longitude": 101.611282,
            "latitude": 56.1633
        },
        "20": {
            "name": "АНГАРСК",
            "population": 227507,
            "type": "city",
            "poly": [
                [
                    103.810827,
                    52.4973872
                ],
                [
                    103.819968,
                    52.5146496
                ],
                [
                    103.8286377,
                    52.5141121
                ],
                [
                    103.830152,
                    52.5218785
                ],
                [
                    103.8315666,
                    52.522016
                ],
                [
                    103.8329853,
                    52.521519
                ],
                [
                    103.8378529,
                    52.5206467
                ],
                [
                    103.8430092,
                    52.5265385
                ],
                [
                    103.8476103,
                    52.5299743
                ],
                [
                    103.8470293,
                    52.5331756
                ],
                [
                    103.8554827,
                    52.5339087
                ],
                [
                    103.8574011,
                    52.5355952
                ],
                [
                    103.8596971,
                    52.5370798
                ],
                [
                    103.8616145,
                    52.5386023
                ],
                [
                    103.8642383,
                    52.5400339
                ],
                [
                    103.8651186,
                    52.5419455
                ],
                [
                    103.8604878,
                    52.5452985
                ],
                [
                    103.8601457,
                    52.5458128
                ],
                [
                    103.8605346,
                    52.5471521
                ],
                [
                    103.8717582,
                    52.5551863
                ],
                [
                    103.8625318,
                    52.5646777
                ],
                [
                    103.8641248,
                    52.5672653
                ],
                [
                    103.8708872,
                    52.5692831
                ],
                [
                    103.873579,
                    52.5716965
                ],
                [
                    103.8735674,
                    52.5801183
                ],
                [
                    103.8705397,
                    52.5849803
                ],
                [
                    103.8683826,
                    52.5884742
                ],
                [
                    103.8653784,
                    52.5903879
                ],
                [
                    103.862055,
                    52.5912774
                ],
                [
                    103.8560398,
                    52.5901708
                ],
                [
                    103.8536544,
                    52.5907283
                ],
                [
                    103.8503278,
                    52.5933392
                ],
                [
                    103.8460528,
                    52.5970322
                ],
                [
                    103.8452957,
                    52.5986643
                ],
                [
                    103.8473457,
                    52.6001243
                ],
                [
                    103.8502767,
                    52.5992704
                ],
                [
                    103.8530891,
                    52.5992416
                ],
                [
                    103.8573718,
                    52.6005433
                ],
                [
                    103.867687,
                    52.6081442
                ],
                [
                    103.8844237,
                    52.6138126
                ],
                [
                    103.9025468,
                    52.6209015
                ],
                [
                    103.9340339,
                    52.6154736
                ],
                [
                    103.93732,
                    52.6062459
                ],
                [
                    103.9394333,
                    52.5969171
                ],
                [
                    103.941794,
                    52.5890636
                ],
                [
                    103.9387049,
                    52.5821199
                ],
                [
                    103.9403331,
                    52.5742815
                ],
                [
                    103.9543816,
                    52.5658446
                ],
                [
                    103.9597893,
                    52.5503536
                ],
                [
                    103.9561475,
                    52.5387557
                ],
                [
                    103.9579478,
                    52.5267433
                ],
                [
                    103.9556819,
                    52.5195598
                ],
                [
                    103.9535176,
                    52.5059659
                ],
                [
                    103.9593739,
                    52.4935322
                ],
                [
                    103.9650519,
                    52.4834011
                ],
                [
                    104.0042765,
                    52.4490042
                ],
                [
                    103.985315,
                    52.4445173
                ],
                [
                    103.9249722,
                    52.5003836
                ],
                [
                    103.9046585,
                    52.5140638
                ],
                [
                    103.896596,
                    52.5131939
                ],
                [
                    103.8637979,
                    52.4942478
                ],
                [
                    103.974651,
                    52.4423351
                ],
                [
                    103.9624297,
                    52.4340604
                ],
                [
                    103.9393293,
                    52.4308927
                ],
                [
                    103.8584087,
                    52.4592875
                ],
                [
                    103.810827,
                    52.4973872
                ]
            ],
            "longitude": 103.8822032,
            "latitude": 52.5308164
        },
        "21": {
            "name": "ИРКУТСК",
            "population": 620099,
            "type": "city",
            "poly": [
                [
                    104.0579985,
                    52.3959159
                ],
                [
                    104.0597871,
                    52.3984625
                ],
                [
                    104.0599694,
                    52.4009656
                ],
                [
                    104.0598641,
                    52.4016229
                ],
                [
                    104.0640494,
                    52.4035126
                ],
                [
                    104.0694758,
                    52.3998706
                ],
                [
                    104.0739403,
                    52.4022575
                ],
                [
                    104.0756611,
                    52.4015555
                ],
                [
                    104.0781699,
                    52.3998676
                ],
                [
                    104.0784167,
                    52.4007817
                ],
                [
                    104.0815705,
                    52.4019724
                ],
                [
                    104.0817817,
                    52.4037535
                ],
                [
                    104.0831525,
                    52.4049495
                ],
                [
                    104.0832939,
                    52.405314
                ],
                [
                    104.0837566,
                    52.4057917
                ],
                [
                    104.084792,
                    52.4064846
                ],
                [
                    104.0858256,
                    52.4067164
                ],
                [
                    104.0864918,
                    52.4071717
                ],
                [
                    104.0856446,
                    52.4085196
                ],
                [
                    104.0863402,
                    52.4095501
                ],
                [
                    104.0887251,
                    52.4104594
                ],
                [
                    104.0889238,
                    52.4114292
                ],
                [
                    104.0907125,
                    52.412399
                ],
                [
                    104.0972708,
                    52.4139749
                ],
                [
                    104.0974696,
                    52.4148234
                ],
                [
                    104.1001904,
                    52.4165433
                ],
                [
                    104.1084002,
                    52.4217324
                ],
                [
                    104.1294664,
                    52.4085802
                ],
                [
                    104.141192,
                    52.3997292
                ],
                [
                    104.1483466,
                    52.3980921
                ],
                [
                    104.1641463,
                    52.4029424
                ],
                [
                    104.1809397,
                    52.3980921
                ],
                [
                    104.1852126,
                    52.3892389
                ],
                [
                    104.192864,
                    52.3846903
                ],
                [
                    104.2266495,
                    52.3757131
                ],
                [
                    104.244536,
                    52.3704351
                ],
                [
                    104.2588452,
                    52.3672802
                ],
                [
                    104.2738499,
                    52.358178
                ],
                [
                    104.2759367,
                    52.356236
                ],
                [
                    104.2807064,
                    52.3575105
                ],
                [
                    104.2823957,
                    52.357207
                ],
                [
                    104.2856748,
                    52.3545367
                ],
                [
                    104.2856748,
                    52.3521089
                ],
                [
                    104.287066,
                    52.3493775
                ],
                [
                    104.2885566,
                    52.3479207
                ],
                [
                    104.2891528,
                    52.3459783
                ],
                [
                    104.3096228,
                    52.3340787
                ],
                [
                    104.3229383,
                    52.3386325
                ],
                [
                    104.326615,
                    52.340636
                ],
                [
                    104.326615,
                    52.3453712
                ],
                [
                    104.3247269,
                    52.345614
                ],
                [
                    104.3261181,
                    52.3526552
                ],
                [
                    104.3331733,
                    52.3675835
                ],
                [
                    104.3410235,
                    52.368433
                ],
                [
                    104.3553327,
                    52.3712238
                ],
                [
                    104.3625866,
                    52.3686757
                ],
                [
                    104.3700393,
                    52.3678262
                ],
                [
                    104.4024337,
                    52.3542939
                ],
                [
                    104.462928,
                    52.2972128
                ],
                [
                    104.4607419,
                    52.2935664
                ],
                [
                    104.4555747,
                    52.293141
                ],
                [
                    104.4523949,
                    52.2911961
                ],
                [
                    104.4493144,
                    52.2934448
                ],
                [
                    104.4442466,
                    52.289555
                ],
                [
                    104.4342103,
                    52.2905275
                ],
                [
                    104.431428,
                    52.2935056
                ],
                [
                    104.4179138,
                    52.2896766
                ],
                [
                    104.4134421,
                    52.2904059
                ],
                [
                    104.412051,
                    52.2902236
                ],
                [
                    104.4103617,
                    52.2911353
                ],
                [
                    104.4084737,
                    52.2916823
                ],
                [
                    104.406685,
                    52.2918039
                ],
                [
                    104.4050951,
                    52.2926547
                ],
                [
                    104.4012197,
                    52.2915607
                ],
                [
                    104.3998286,
                    52.2915607
                ],
                [
                    104.3998286,
                    52.2906491
                ],
                [
                    104.3978412,
                    52.2899197
                ],
                [
                    104.3967481,
                    52.28761
                ],
                [
                    104.3954563,
                    52.2870021
                ],
                [
                    104.3937869,
                    52.2871655
                ],
                [
                    104.3921589,
                    52.2878502
                ],
                [
                    104.3900729,
                    52.2878502
                ],
                [
                    104.3874782,
                    52.2869165
                ],
                [
                    104.3866641,
                    52.2873834
                ],
                [
                    104.386062,
                    52.2879525
                ],
                [
                    104.3835098,
                    52.2869788
                ],
                [
                    104.3831027,
                    52.2858584
                ],
                [
                    104.3819834,
                    52.2853293
                ],
                [
                    104.3813729,
                    52.2849247
                ],
                [
                    104.3770484,
                    52.283742
                ],
                [
                    104.3741484,
                    52.2837731
                ],
                [
                    104.3732326,
                    52.2830573
                ],
                [
                    104.3743567,
                    52.2819607
                ],
                [
                    104.375115,
                    52.2812209
                ],
                [
                    104.3746063,
                    52.2796023
                ],
                [
                    104.3757256,
                    52.27954
                ],
                [
                    104.3747589,
                    52.27733
                ],
                [
                    104.3738431,
                    52.2773922
                ],
                [
                    104.3737154,
                    52.2771685
                ],
                [
                    104.3728575,
                    52.2756654
                ],
                [
                    104.3727476,
                    52.2754728
                ],
                [
                    104.3727238,
                    52.2754311
                ],
                [
                    104.3839168,
                    52.2722246
                ],
                [
                    104.3967378,
                    52.2689244
                ],
                [
                    104.416936,
                    52.2633199
                ],
                [
                    104.4174956,
                    52.2620432
                ],
                [
                    104.4222781,
                    52.2601436
                ],
                [
                    104.4254324,
                    52.2593651
                ],
                [
                    104.4273658,
                    52.2584931
                ],
                [
                    104.4270605,
                    52.258026
                ],
                [
                    104.4215149,
                    52.2593962
                ],
                [
                    104.4147483,
                    52.2598634
                ],
                [
                    104.4105763,
                    52.2596142
                ],
                [
                    104.3958729,
                    52.2629462
                ],
                [
                    104.3957202,
                    52.2623857
                ],
                [
                    104.3932781,
                    52.2627905
                ],
                [
                    104.3918536,
                    52.2637558
                ],
                [
                    104.3907343,
                    52.2631642
                ],
                [
                    104.3882922,
                    52.2637869
                ],
                [
                    104.3866641,
                    52.2636935
                ],
                [
                    104.3801519,
                    52.2647522
                ],
                [
                    104.3731308,
                    52.2652504
                ],
                [
                    104.3716045,
                    52.2649702
                ],
                [
                    104.3682975,
                    52.2657486
                ],
                [
                    104.3666695,
                    52.2654684
                ],
                [
                    104.3642782,
                    52.2628216
                ],
                [
                    104.3634133,
                    52.2625103
                ],
                [
                    104.3632607,
                    52.2618563
                ],
                [
                    104.3562397,
                    52.2558149
                ],
                [
                    104.3562905,
                    52.2549428
                ],
                [
                    104.3647361,
                    52.2547248
                ],
                [
                    104.3649396,
                    52.2540396
                ],
                [
                    104.3659063,
                    52.2540396
                ],
                [
                    104.3665168,
                    52.2544445
                ],
                [
                    104.3670765,
                    52.2540708
                ],
                [
                    104.3678905,
                    52.2544757
                ],
                [
                    104.3685519,
                    52.2541642
                ],
                [
                    104.3726729,
                    52.2541019
                ],
                [
                    104.3726729,
                    52.2511431
                ],
                [
                    104.369773,
                    52.2484955
                ],
                [
                    104.3719098,
                    52.2444148
                ],
                [
                    104.3501853,
                    52.2339154
                ],
                [
                    104.3493037,
                    52.2094352
                ],
                [
                    104.3217784,
                    52.209837
                ],
                [
                    104.321222,
                    52.2106164
                ],
                [
                    104.3126365,
                    52.2148054
                ],
                [
                    104.3007916,
                    52.2136364
                ],
                [
                    104.2964194,
                    52.2150977
                ],
                [
                    104.294909,
                    52.2155847
                ],
                [
                    104.2928421,
                    52.2178252
                ],
                [
                    104.2911727,
                    52.2179713
                ],
                [
                    104.2830642,
                    52.2168511
                ],
                [
                    104.2824282,
                    52.2174355
                ],
                [
                    104.2801229,
                    52.2175329
                ],
                [
                    104.2802023,
                    52.219335
                ],
                [
                    104.2767045,
                    52.2208934
                ],
                [
                    104.277261,
                    52.2218674
                ],
                [
                    104.2771815,
                    52.2229875
                ],
                [
                    104.2753531,
                    52.2239614
                ],
                [
                    104.2699474,
                    52.2283926
                ],
                [
                    104.2679883,
                    52.2284612
                ],
                [
                    104.265592,
                    52.2292155
                ],
                [
                    104.2650594,
                    52.2303571
                ],
                [
                    104.2654162,
                    52.2323852
                ],
                [
                    104.2650187,
                    52.2365721
                ],
                [
                    104.261203,
                    52.2426571
                ],
                [
                    104.261203,
                    52.2439714
                ],
                [
                    104.2550818,
                    52.2454316
                ],
                [
                    104.2530944,
                    52.2465511
                ],
                [
                    104.2499941,
                    52.2479625
                ],
                [
                    104.2449859,
                    52.2486926
                ],
                [
                    104.2417266,
                    52.24952
                ],
                [
                    104.2377518,
                    52.2489846
                ],
                [
                    104.2373543,
                    52.2468431
                ],
                [
                    104.2272584,
                    52.2507367
                ],
                [
                    104.2272584,
                    52.252732
                ],
                [
                    104.2244761,
                    52.2542406
                ],
                [
                    104.2213758,
                    52.2542893
                ],
                [
                    104.2224887,
                    52.2515154
                ],
                [
                    104.2226477,
                    52.2505907
                ],
                [
                    104.2162389,
                    52.2438945
                ],
                [
                    104.195694,
                    52.2430158
                ],
                [
                    104.1879141,
                    52.2455595
                ],
                [
                    104.1803608,
                    52.2533283
                ],
                [
                    104.1826268,
                    52.2570735
                ],
                [
                    104.1904444,
                    52.2612547
                ],
                [
                    104.1880023,
                    52.2632227
                ],
                [
                    104.1879616,
                    52.26397
                ],
                [
                    104.1916655,
                    52.2655393
                ],
                [
                    104.1923574,
                    52.2668097
                ],
                [
                    104.1931715,
                    52.2674573
                ],
                [
                    104.1919911,
                    52.2691759
                ],
                [
                    104.1917876,
                    52.2707202
                ],
                [
                    104.1882673,
                    52.2737623
                ],
                [
                    104.1870251,
                    52.2768023
                ],
                [
                    104.19808,
                    52.281514
                ],
                [
                    104.1866773,
                    52.28893
                ],
                [
                    104.1856837,
                    52.2900241
                ],
                [
                    104.1870748,
                    52.2931846
                ],
                [
                    104.1920433,
                    52.2965271
                ],
                [
                    104.1995953,
                    52.3000518
                ],
                [
                    104.1986811,
                    52.3010483
                ],
                [
                    104.1993171,
                    52.3036733
                ],
                [
                    104.2016225,
                    52.3051316
                ],
                [
                    104.2073461,
                    52.3046455
                ],
                [
                    104.2106055,
                    52.3043052
                ],
                [
                    104.2141032,
                    52.3048399
                ],
                [
                    104.218396,
                    52.3042566
                ],
                [
                    104.2175215,
                    52.3059093
                ],
                [
                    104.2193499,
                    52.3094575
                ],
                [
                    104.2063127,
                    52.3161642
                ],
                [
                    104.20043,
                    52.3161642
                ],
                [
                    104.1920035,
                    52.320489
                ],
                [
                    104.1891417,
                    52.322627
                ],
                [
                    104.1931165,
                    52.3224326
                ],
                [
                    104.1855644,
                    52.3263682
                ],
                [
                    104.1830206,
                    52.328603
                ],
                [
                    104.181913,
                    52.3293933
                ],
                [
                    104.1815285,
                    52.328694
                ],
                [
                    104.1761507,
                    52.3252649
                ],
                [
                    104.173905,
                    52.3238488
                ],
                [
                    104.1739783,
                    52.3223481
                ],
                [
                    104.1726311,
                    52.3213649
                ],
                [
                    104.1710168,
                    52.3214123
                ],
                [
                    104.1692182,
                    52.3221132
                ],
                [
                    104.1690612,
                    52.3227096
                ],
                [
                    104.1698412,
                    52.3233049
                ],
                [
                    104.1682597,
                    52.3244367
                ],
                [
                    104.1683061,
                    52.3248127
                ],
                [
                    104.1687114,
                    52.3251535
                ],
                [
                    104.1706945,
                    52.3263331
                ],
                [
                    104.1663701,
                    52.3289557
                ],
                [
                    104.1652136,
                    52.3304491
                ],
                [
                    104.1617158,
                    52.3336067
                ],
                [
                    104.1603644,
                    52.3323922
                ],
                [
                    104.1567871,
                    52.3291374
                ],
                [
                    104.1531303,
                    52.3273884
                ],
                [
                    104.1510634,
                    52.328603
                ],
                [
                    104.1493145,
                    52.3294775
                ],
                [
                    104.1491555,
                    52.3302062
                ],
                [
                    104.1446243,
                    52.3330723
                ],
                [
                    104.1461347,
                    52.3346754
                ],
                [
                    104.1419215,
                    52.3372498
                ],
                [
                    104.1478836,
                    52.3407469
                ],
                [
                    104.1511429,
                    52.3390469
                ],
                [
                    104.1524148,
                    52.3399212
                ],
                [
                    104.1475656,
                    52.342981
                ],
                [
                    104.1486786,
                    52.3438552
                ],
                [
                    104.1485991,
                    52.3451664
                ],
                [
                    104.1437498,
                    52.3463805
                ],
                [
                    104.1359593,
                    52.3530816
                ],
                [
                    104.1230016,
                    52.3624518
                ],
                [
                    104.1197422,
                    52.3625489
                ],
                [
                    104.1169599,
                    52.3636654
                ],
                [
                    104.114893,
                    52.3650246
                ],
                [
                    104.1141776,
                    52.3657042
                ],
                [
                    104.1087761,
                    52.3659519
                ],
                [
                    104.1079812,
                    52.3631
                ],
                [
                    104.1000317,
                    52.3650418
                ],
                [
                    104.0956594,
                    52.3655272
                ],
                [
                    104.0912872,
                    52.3665587
                ],
                [
                    104.0877099,
                    52.3693497
                ],
                [
                    104.0892004,
                    52.3744458
                ],
                [
                    104.09556,
                    52.3711091
                ],
                [
                    104.0986405,
                    52.376751
                ],
                [
                    104.0984417,
                    52.381725
                ],
                [
                    104.0894985,
                    52.3842724
                ],
                [
                    104.077773,
                    52.3858493
                ],
                [
                    104.0589922,
                    52.3932479
                ],
                [
                    104.0579985,
                    52.3959159
                ]
            ],
            "longitude": 104.29201318326395,
            "latitude": 52.28603309596527
        },
        "22": {
            "name": "РУБЦОВСК",
            "population": 146386,
            "type": "city",
            "poly": [
                [
                    81.1382758,
                    51.5228209
                ],
                [
                    81.1385963,
                    51.523519
                ],
                [
                    81.1396055,
                    51.5245421
                ],
                [
                    81.1538436,
                    51.5347293
                ],
                [
                    81.1672678,
                    51.5448703
                ],
                [
                    81.1745094,
                    51.5503508
                ],
                [
                    81.1747568,
                    51.5519797
                ],
                [
                    81.1754691,
                    51.5529071
                ],
                [
                    81.1761815,
                    51.5534977
                ],
                [
                    81.1807813,
                    51.5573042
                ],
                [
                    81.1821585,
                    51.5579353
                ],
                [
                    81.1833636,
                    51.5582379
                ],
                [
                    81.1847869,
                    51.5583837
                ],
                [
                    81.1923261,
                    51.5578116
                ],
                [
                    81.194426,
                    51.5578116
                ],
                [
                    81.1955391,
                    51.5578855
                ],
                [
                    81.1969854,
                    51.5583812
                ],
                [
                    81.1989445,
                    51.5594705
                ],
                [
                    81.2000225,
                    51.5609931
                ],
                [
                    81.2014324,
                    51.5649188
                ],
                [
                    81.2018716,
                    51.5659627
                ],
                [
                    81.2030125,
                    51.5670284
                ],
                [
                    81.2035679,
                    51.5675473
                ],
                [
                    81.2093161,
                    51.5626133
                ],
                [
                    81.2144807,
                    51.5680609
                ],
                [
                    81.2216627,
                    51.578533
                ],
                [
                    81.2255399,
                    51.5779393
                ],
                [
                    81.2416431,
                    51.5735026
                ],
                [
                    81.2382863,
                    51.5683377
                ],
                [
                    81.2354,
                    51.5644038
                ],
                [
                    81.2500852,
                    51.5603531
                ],
                [
                    81.248652,
                    51.5584252
                ],
                [
                    81.2535031,
                    51.5570988
                ],
                [
                    81.2528538,
                    51.5561761
                ],
                [
                    81.2534011,
                    51.5560435
                ],
                [
                    81.2504885,
                    51.5519487
                ],
                [
                    81.2558962,
                    51.5504721
                ],
                [
                    81.2568911,
                    51.5498562
                ],
                [
                    81.2570437,
                    51.5498356
                ],
                [
                    81.2566285,
                    51.5490102
                ],
                [
                    81.2562606,
                    51.5480855
                ],
                [
                    81.2561188,
                    51.5474253
                ],
                [
                    81.2561205,
                    51.5461592
                ],
                [
                    81.2563652,
                    51.5449381
                ],
                [
                    81.2567446,
                    51.5439791
                ],
                [
                    81.2570635,
                    51.5432217
                ],
                [
                    81.2571631,
                    51.5428689
                ],
                [
                    81.2570635,
                    51.5425066
                ],
                [
                    81.2568412,
                    51.5421014
                ],
                [
                    81.2563506,
                    51.5417915
                ],
                [
                    81.2556761,
                    51.5417296
                ],
                [
                    81.2546259,
                    51.5418344
                ],
                [
                    81.2538747,
                    51.5420108
                ],
                [
                    81.2532079,
                    51.5420061
                ],
                [
                    81.2525486,
                    51.5418726
                ],
                [
                    81.2517975,
                    51.541863
                ],
                [
                    81.2513069,
                    51.541987
                ],
                [
                    81.2509236,
                    51.542335
                ],
                [
                    81.2510233,
                    51.5427545
                ],
                [
                    81.2513222,
                    51.5431931
                ],
                [
                    81.2517591,
                    51.5432456
                ],
                [
                    81.2524132,
                    51.543191
                ],
                [
                    81.2536167,
                    51.5428192
                ],
                [
                    81.2543832,
                    51.5428573
                ],
                [
                    81.2548354,
                    51.5431004
                ],
                [
                    81.2546975,
                    51.5435295
                ],
                [
                    81.2540536,
                    51.5439585
                ],
                [
                    81.2526968,
                    51.5445306
                ],
                [
                    81.2514551,
                    51.5449358
                ],
                [
                    81.2507192,
                    51.5452981
                ],
                [
                    81.2501443,
                    51.5454935
                ],
                [
                    81.2493625,
                    51.5455459
                ],
                [
                    81.2486573,
                    51.5454887
                ],
                [
                    81.2479674,
                    51.5452599
                ],
                [
                    81.2474078,
                    51.5448929
                ],
                [
                    81.2472545,
                    51.5443637
                ],
                [
                    81.2473925,
                    51.543806
                ],
                [
                    81.2476148,
                    51.5435104
                ],
                [
                    81.248113,
                    51.543191
                ],
                [
                    81.2485544,
                    51.5430462
                ],
                [
                    81.2493187,
                    51.5429181
                ],
                [
                    81.2497658,
                    51.5428119
                ],
                [
                    81.2501778,
                    51.5425641
                ],
                [
                    81.2502835,
                    51.5423838
                ],
                [
                    81.2503994,
                    51.5422865
                ],
                [
                    81.2525352,
                    51.5400047
                ],
                [
                    81.2543758,
                    51.5342893
                ],
                [
                    81.2546743,
                    51.5271305
                ],
                [
                    81.2517185,
                    51.5114907
                ],
                [
                    81.260774,
                    51.5088586
                ],
                [
                    81.261581,
                    51.5119471
                ],
                [
                    81.2637793,
                    51.5126975
                ],
                [
                    81.2653932,
                    51.5145158
                ],
                [
                    81.2656808,
                    51.5159069
                ],
                [
                    81.2651613,
                    51.5172691
                ],
                [
                    81.2661631,
                    51.5194798
                ],
                [
                    81.2667845,
                    51.5195317
                ],
                [
                    81.2687324,
                    51.5234101
                ],
                [
                    81.2832881,
                    51.5179857
                ],
                [
                    81.2832695,
                    51.5173854
                ],
                [
                    81.2796521,
                    51.5171718
                ],
                [
                    81.2761624,
                    51.5083063
                ],
                [
                    81.2802941,
                    51.5069171
                ],
                [
                    81.2779953,
                    51.5015302
                ],
                [
                    81.2818539,
                    51.5003153
                ],
                [
                    81.2893931,
                    51.4990173
                ],
                [
                    81.2917528,
                    51.4990542
                ],
                [
                    81.2974962,
                    51.5020383
                ],
                [
                    81.3005312,
                    51.5061584
                ],
                [
                    81.3048084,
                    51.504988
                ],
                [
                    81.3077172,
                    51.5084206
                ],
                [
                    81.3212219,
                    51.5049814
                ],
                [
                    81.3200068,
                    51.5033475
                ],
                [
                    81.3183001,
                    51.5007203
                ],
                [
                    81.3153968,
                    51.4987051
                ],
                [
                    81.3112043,
                    51.4971345
                ],
                [
                    81.3078929,
                    51.4936119
                ],
                [
                    81.3048557,
                    51.4911664
                ],
                [
                    81.3047037,
                    51.4909624
                ],
                [
                    81.2994146,
                    51.4824847
                ],
                [
                    81.2984058,
                    51.4788454
                ],
                [
                    81.2983595,
                    51.477625
                ],
                [
                    81.2972696,
                    51.4751625
                ],
                [
                    81.2933317,
                    51.4694078
                ],
                [
                    81.2875345,
                    51.4705778
                ],
                [
                    81.2880215,
                    51.4692128
                ],
                [
                    81.2760053,
                    51.4716476
                ],
                [
                    81.2751937,
                    51.4700045
                ],
                [
                    81.2522266,
                    51.4749004
                ],
                [
                    81.2442655,
                    51.4692516
                ],
                [
                    81.2394043,
                    51.463945
                ],
                [
                    81.2378646,
                    51.4657883
                ],
                [
                    81.2367793,
                    51.4637485
                ],
                [
                    81.2238815,
                    51.4635501
                ],
                [
                    81.2092443,
                    51.4631492
                ],
                [
                    81.2089653,
                    51.4661005
                ],
                [
                    81.2091865,
                    51.4679588
                ],
                [
                    81.207491,
                    51.4680742
                ],
                [
                    81.2070611,
                    51.4653935
                ],
                [
                    81.1968064,
                    51.4668505
                ],
                [
                    81.1992532,
                    51.4724321
                ],
                [
                    81.1851704,
                    51.4745066
                ],
                [
                    81.1853083,
                    51.4753413
                ],
                [
                    81.1858116,
                    51.4783874
                ],
                [
                    81.1888357,
                    51.4808185
                ],
                [
                    81.1892737,
                    51.4811706
                ],
                [
                    81.1843394,
                    51.4816674
                ],
                [
                    81.1829984,
                    51.479233
                ],
                [
                    81.1838191,
                    51.4790176
                ],
                [
                    81.1830858,
                    51.4779339
                ],
                [
                    81.1814217,
                    51.4782983
                ],
                [
                    81.1813305,
                    51.4782392
                ],
                [
                    81.1808974,
                    51.4783504
                ],
                [
                    81.1808936,
                    51.478419
                ],
                [
                    81.1772122,
                    51.4792669
                ],
                [
                    81.1781573,
                    51.4802991
                ],
                [
                    81.1789931,
                    51.4801453
                ],
                [
                    81.182392,
                    51.4853862
                ],
                [
                    81.1555779,
                    51.4950167
                ],
                [
                    81.1543999,
                    51.4932265
                ],
                [
                    81.147601,
                    51.4970783
                ],
                [
                    81.1544494,
                    51.5018344
                ],
                [
                    81.1435189,
                    51.5071152
                ],
                [
                    81.144534,
                    51.5081276
                ],
                [
                    81.14752,
                    51.5082199
                ],
                [
                    81.1551691,
                    51.514361
                ],
                [
                    81.1385429,
                    51.5224552
                ],
                [
                    81.1382758,
                    51.5228209
                ]
            ],
            "longitude": 81.216377,
            "latitude": 51.527691
        },
        "23": {
            "name": "БАРНАУЛ",
            "population": 635585,
            "type": "city",
            "poly": [
                [
                    83.533418,
                    53.3437922
                ],
                [
                    83.5352834,
                    53.3546265
                ],
                [
                    83.5681797,
                    53.3527943
                ],
                [
                    83.5876039,
                    53.3517123
                ],
                [
                    83.6039209,
                    53.3506867
                ],
                [
                    83.6201748,
                    53.3496045
                ],
                [
                    83.6283255,
                    53.3487763
                ],
                [
                    83.632585,
                    53.3527994
                ],
                [
                    83.6319996,
                    53.3530845
                ],
                [
                    83.6321536,
                    53.3534983
                ],
                [
                    83.6296117,
                    53.3546843
                ],
                [
                    83.6514724,
                    53.3727581
                ],
                [
                    83.6547076,
                    53.3755337
                ],
                [
                    83.656433,
                    53.3815623
                ],
                [
                    83.647436,
                    53.384806
                ],
                [
                    83.632361,
                    53.3818766
                ],
                [
                    83.6321287,
                    53.3852616
                ],
                [
                    83.6258438,
                    53.3846857
                ],
                [
                    83.6268623,
                    53.3889541
                ],
                [
                    83.625745,
                    53.3900062
                ],
                [
                    83.6260684,
                    53.3917597
                ],
                [
                    83.631508,
                    53.3940391
                ],
                [
                    83.6332721,
                    53.3933376
                ],
                [
                    83.6370063,
                    53.3950034
                ],
                [
                    83.6419167,
                    53.3987202
                ],
                [
                    83.6401819,
                    53.3997018
                ],
                [
                    83.6375973,
                    53.3994215
                ],
                [
                    83.6363507,
                    53.3987623
                ],
                [
                    83.636186,
                    53.3993513
                ],
                [
                    83.6381384,
                    53.4000806
                ],
                [
                    83.6384442,
                    53.4016934
                ],
                [
                    83.6371738,
                    53.4020439
                ],
                [
                    83.6360449,
                    53.4052274
                ],
                [
                    83.6323457,
                    53.4075114
                ],
                [
                    83.6324633,
                    53.4080582
                ],
                [
                    83.6301817,
                    53.4096427
                ],
                [
                    83.6302052,
                    53.4124609
                ],
                [
                    83.6419194,
                    53.4127694
                ],
                [
                    83.6564327,
                    53.4091519
                ],
                [
                    83.6578205,
                    53.4099652
                ],
                [
                    83.6586203,
                    53.4109046
                ],
                [
                    83.6595848,
                    53.4127413
                ],
                [
                    83.6601258,
                    53.4129797
                ],
                [
                    83.6617488,
                    53.4132881
                ],
                [
                    83.6632778,
                    53.4137368
                ],
                [
                    83.6638659,
                    53.4143677
                ],
                [
                    83.6635836,
                    53.4151668
                ],
                [
                    83.6639129,
                    53.4157415
                ],
                [
                    83.6658652,
                    53.4166108
                ],
                [
                    83.667159,
                    53.417466
                ],
                [
                    83.6716988,
                    53.4176482
                ],
                [
                    83.6750861,
                    53.4167229
                ],
                [
                    83.6743804,
                    53.4156575
                ],
                [
                    83.6743569,
                    53.4149845
                ],
                [
                    83.6747096,
                    53.4144097
                ],
                [
                    83.6764503,
                    53.4139751
                ],
                [
                    83.6788497,
                    53.4137227
                ],
                [
                    83.6800964,
                    53.4144097
                ],
                [
                    83.6791084,
                    53.4157837
                ],
                [
                    83.678638,
                    53.4177744
                ],
                [
                    83.6790614,
                    53.4190921
                ],
                [
                    83.678191,
                    53.419751
                ],
                [
                    83.6772737,
                    53.4198351
                ],
                [
                    83.6746156,
                    53.4195968
                ],
                [
                    83.6716988,
                    53.4220639
                ],
                [
                    83.671299,
                    53.4234516
                ],
                [
                    83.6719341,
                    53.4242366
                ],
                [
                    83.6732278,
                    53.4248673
                ],
                [
                    83.6745686,
                    53.4249514
                ],
                [
                    83.6760975,
                    53.4246851
                ],
                [
                    83.6770149,
                    53.4240403
                ],
                [
                    83.6769208,
                    53.4226807
                ],
                [
                    83.6783557,
                    53.4220219
                ],
                [
                    83.6831543,
                    53.4200454
                ],
                [
                    83.6843069,
                    53.4199192
                ],
                [
                    83.6857182,
                    53.4198491
                ],
                [
                    83.6869649,
                    53.4201995
                ],
                [
                    83.687012,
                    53.4212649
                ],
                [
                    83.6859535,
                    53.4232273
                ],
                [
                    83.6832719,
                    53.4233255
                ],
                [
                    83.6766621,
                    53.4268716
                ],
                [
                    83.673416,
                    53.4279929
                ],
                [
                    83.6694641,
                    53.4288898
                ],
                [
                    83.6638423,
                    53.4280489
                ],
                [
                    83.6609725,
                    53.4260867
                ],
                [
                    83.659867,
                    53.4248112
                ],
                [
                    83.6591378,
                    53.422961
                ],
                [
                    83.6581499,
                    53.4218677
                ],
                [
                    83.6567621,
                    53.4219518
                ],
                [
                    83.6552096,
                    53.4230732
                ],
                [
                    83.6541275,
                    53.4256242
                ],
                [
                    83.655633,
                    53.4293804
                ],
                [
                    83.654104,
                    53.4314826
                ],
                [
                    83.6470708,
                    53.4286095
                ],
                [
                    83.6474942,
                    53.4268856
                ],
                [
                    83.6462946,
                    53.4256522
                ],
                [
                    83.6440702,
                    53.4248217
                ],
                [
                    83.6415969,
                    53.4249679
                ],
                [
                    83.6422793,
                    53.4262518
                ],
                [
                    83.6412018,
                    53.4273006
                ],
                [
                    83.6428898,
                    53.4289697
                ],
                [
                    83.6448652,
                    53.4298043
                ],
                [
                    83.647927,
                    53.4333296
                ],
                [
                    83.6471638,
                    53.4346936
                ],
                [
                    83.6450088,
                    53.4354425
                ],
                [
                    83.6416416,
                    53.4346669
                ],
                [
                    83.6412377,
                    53.4353088
                ],
                [
                    83.6414622,
                    53.4365925
                ],
                [
                    83.6364789,
                    53.4370472
                ],
                [
                    83.6375113,
                    53.4388658
                ],
                [
                    83.6386787,
                    53.4431177
                ],
                [
                    83.639397,
                    53.4464066
                ],
                [
                    83.6403847,
                    53.4485723
                ],
                [
                    83.6435722,
                    53.4523153
                ],
                [
                    83.6477025,
                    53.4552292
                ],
                [
                    83.6534939,
                    53.4585707
                ],
                [
                    83.6617097,
                    53.4608962
                ],
                [
                    83.6617546,
                    53.4620722
                ],
                [
                    83.6639993,
                    53.4622593
                ],
                [
                    83.6639095,
                    53.4637026
                ],
                [
                    83.6539938,
                    53.4647644
                ],
                [
                    83.6631758,
                    53.475076
                ],
                [
                    83.6693956,
                    53.477812
                ],
                [
                    83.6786173,
                    53.4824039
                ],
                [
                    83.682331,
                    53.4824921
                ],
                [
                    83.6904839,
                    53.4822571
                ],
                [
                    83.6935367,
                    53.4816586
                ],
                [
                    83.6966614,
                    53.4800343
                ],
                [
                    83.6979185,
                    53.476422
                ],
                [
                    83.6846656,
                    53.4663315
                ],
                [
                    83.6828698,
                    53.4632099
                ],
                [
                    83.6841335,
                    53.458809
                ],
                [
                    83.6821694,
                    53.4571717
                ],
                [
                    83.675323,
                    53.4558352
                ],
                [
                    83.6674103,
                    53.4536631
                ],
                [
                    83.6628647,
                    53.4507223
                ],
                [
                    83.6579161,
                    53.4467151
                ],
                [
                    83.6584099,
                    53.4434797
                ],
                [
                    83.6594874,
                    53.437222
                ],
                [
                    83.6626299,
                    53.4336382
                ],
                [
                    83.6671644,
                    53.4325149
                ],
                [
                    83.6732701,
                    53.4312844
                ],
                [
                    83.6809471,
                    53.4366872
                ],
                [
                    83.6854814,
                    53.438586
                ],
                [
                    83.6894771,
                    53.4389069
                ],
                [
                    83.6947297,
                    53.438372
                ],
                [
                    83.7008195,
                    53.4359224
                ],
                [
                    83.7140724,
                    53.4397521
                ],
                [
                    83.7157244,
                    53.4447794
                ],
                [
                    83.7172329,
                    53.4477527
                ],
                [
                    83.7205372,
                    53.4498702
                ],
                [
                    83.7260323,
                    53.4517096
                ],
                [
                    83.7355859,
                    53.4520089
                ],
                [
                    83.7444571,
                    53.4512177
                ],
                [
                    83.7491621,
                    53.447667
                ],
                [
                    83.752179,
                    53.4436028
                ],
                [
                    83.7544058,
                    53.4399874
                ],
                [
                    83.7648213,
                    53.436393
                ],
                [
                    83.7745185,
                    53.4344247
                ],
                [
                    83.783401,
                    53.4333134
                ],
                [
                    83.7792575,
                    53.4125384
                ],
                [
                    83.7812803,
                    53.4095515
                ],
                [
                    83.7874635,
                    53.4102366
                ],
                [
                    83.7970257,
                    53.4106613
                ],
                [
                    83.8068408,
                    53.4092227
                ],
                [
                    83.8160812,
                    53.4074277
                ],
                [
                    83.8232069,
                    53.4039197
                ],
                [
                    83.8263962,
                    53.4008023
                ],
                [
                    83.8698824,
                    53.4007085
                ],
                [
                    83.8691789,
                    53.3930834
                ],
                [
                    83.8682582,
                    53.3920596
                ],
                [
                    83.869207,
                    53.3886162
                ],
                [
                    83.8681438,
                    53.3865872
                ],
                [
                    83.8656631,
                    53.3850231
                ],
                [
                    83.8628281,
                    53.3835013
                ],
                [
                    83.8600639,
                    53.3828671
                ],
                [
                    83.8590715,
                    53.3812184
                ],
                [
                    83.8582211,
                    53.3797809
                ],
                [
                    83.8590007,
                    53.3784702
                ],
                [
                    83.8592422,
                    53.3752592
                ],
                [
                    83.859336,
                    53.3685017
                ],
                [
                    83.8590232,
                    53.3664388
                ],
                [
                    83.8614925,
                    53.3647348
                ],
                [
                    83.8603532,
                    53.3642946
                ],
                [
                    83.8599433,
                    53.3648961
                ],
                [
                    83.8585909,
                    53.3645587
                ],
                [
                    83.8608368,
                    53.362837
                ],
                [
                    83.8675171,
                    53.3595009
                ],
                [
                    83.8688449,
                    53.3582095
                ],
                [
                    83.8805443,
                    53.3444721
                ],
                [
                    83.8878795,
                    53.3439691
                ],
                [
                    83.8842119,
                    53.3387101
                ],
                [
                    83.8751148,
                    53.3365374
                ],
                [
                    83.8763502,
                    53.3293344
                ],
                [
                    83.8749913,
                    53.3256736
                ],
                [
                    83.8748835,
                    53.323248
                ],
                [
                    83.8733382,
                    53.3211226
                ],
                [
                    83.8723319,
                    53.3206075
                ],
                [
                    83.8723139,
                    53.3202104
                ],
                [
                    83.8731944,
                    53.3201138
                ],
                [
                    83.8738952,
                    53.3203284
                ],
                [
                    83.8741827,
                    53.3201567
                ],
                [
                    83.8738233,
                    53.3198132
                ],
                [
                    83.8726733,
                    53.319094
                ],
                [
                    83.8709302,
                    53.3185358
                ],
                [
                    83.8697083,
                    53.3185036
                ],
                [
                    83.8691872,
                    53.3188901
                ],
                [
                    83.8692052,
                    53.3194268
                ],
                [
                    83.8697263,
                    53.3199849
                ],
                [
                    83.8707505,
                    53.3204358
                ],
                [
                    83.8701035,
                    53.3204572
                ],
                [
                    83.8686481,
                    53.3206934
                ],
                [
                    83.868145,
                    53.3205216
                ],
                [
                    83.8676778,
                    53.3199313
                ],
                [
                    83.8672285,
                    53.3188042
                ],
                [
                    83.8673184,
                    53.317924
                ],
                [
                    83.8685044,
                    53.3161635
                ],
                [
                    83.8689356,
                    53.3156804
                ],
                [
                    83.869888,
                    53.3153476
                ],
                [
                    83.8744523,
                    53.3153905
                ],
                [
                    83.8769931,
                    53.31506
                ],
                [
                    83.8781935,
                    53.310757
                ],
                [
                    83.8892369,
                    53.3034412
                ],
                [
                    83.8905463,
                    53.2992329
                ],
                [
                    83.8896754,
                    53.2966638
                ],
                [
                    83.8843513,
                    53.2962692
                ],
                [
                    83.8791536,
                    53.2970081
                ],
                [
                    83.8759256,
                    53.2968537
                ],
                [
                    83.8692721,
                    53.2954598
                ],
                [
                    83.8604923,
                    53.2939429
                ],
                [
                    83.854456,
                    53.2967102
                ],
                [
                    83.851438,
                    53.2966897
                ],
                [
                    83.8491401,
                    53.2975506
                ],
                [
                    83.8435842,
                    53.2964232
                ],
                [
                    83.8423495,
                    53.2959518
                ],
                [
                    83.8417322,
                    53.2940864
                ],
                [
                    83.8426582,
                    53.2916879
                ],
                [
                    83.8468766,
                    53.2892482
                ],
                [
                    83.8505463,
                    53.2877927
                ],
                [
                    83.8522269,
                    53.28605
                ],
                [
                    83.8554164,
                    53.286337
                ],
                [
                    83.8577485,
                    53.286132
                ],
                [
                    83.8584002,
                    53.2853733
                ],
                [
                    83.8574742,
                    53.2847582
                ],
                [
                    83.8559651,
                    53.283692
                ],
                [
                    83.8564796,
                    53.2829334
                ],
                [
                    83.8611439,
                    53.2813545
                ],
                [
                    83.8632017,
                    53.2820312
                ],
                [
                    83.8670086,
                    53.2826873
                ],
                [
                    83.8735248,
                    53.2807804
                ],
                [
                    83.8780177,
                    53.2786272
                ],
                [
                    83.8832307,
                    53.2750384
                ],
                [
                    83.8885466,
                    53.270034
                ],
                [
                    83.8937597,
                    53.2619726
                ],
                [
                    83.8976694,
                    53.2572745
                ],
                [
                    83.8968463,
                    53.2556742
                ],
                [
                    83.8986297,
                    53.2482872
                ],
                [
                    83.8951658,
                    53.2409811
                ],
                [
                    83.8915628,
                    53.2376096
                ],
                [
                    83.8878823,
                    53.2359449
                ],
                [
                    83.8809006,
                    53.2349107
                ],
                [
                    83.8785,
                    53.2323147
                ],
                [
                    83.8791673,
                    53.2307906
                ],
                [
                    83.8788864,
                    53.230202
                ],
                [
                    83.8770952,
                    53.2300233
                ],
                [
                    83.8715464,
                    53.2310744
                ],
                [
                    83.8682979,
                    53.2323357
                ],
                [
                    83.871722,
                    53.2359092
                ],
                [
                    83.8591668,
                    53.2363191
                ],
                [
                    83.8417395,
                    53.2363189
                ],
                [
                    83.8416725,
                    53.2348346
                ],
                [
                    83.8479732,
                    53.2323471
                ],
                [
                    83.8497828,
                    53.2311836
                ],
                [
                    83.8497159,
                    53.2292777
                ],
                [
                    83.8465321,
                    53.2266295
                ],
                [
                    83.8442531,
                    53.2238205
                ],
                [
                    83.8440185,
                    53.2217538
                ],
                [
                    83.845091,
                    53.2193459
                ],
                [
                    83.8489451,
                    53.2162755
                ],
                [
                    83.8524306,
                    53.2150714
                ],
                [
                    83.8563517,
                    53.2144694
                ],
                [
                    83.8581615,
                    53.2138471
                ],
                [
                    83.8596026,
                    53.2118202
                ],
                [
                    83.860608,
                    53.2093915
                ],
                [
                    83.858396,
                    53.2060997
                ],
                [
                    83.859435,
                    53.2048553
                ],
                [
                    83.8586976,
                    53.2041326
                ],
                [
                    83.8560501,
                    53.2048151
                ],
                [
                    83.8528326,
                    53.2052768
                ],
                [
                    83.8493137,
                    53.2050359
                ],
                [
                    83.8459288,
                    53.2046544
                ],
                [
                    83.8434152,
                    53.2035103
                ],
                [
                    83.8410693,
                    53.1992745
                ],
                [
                    83.8394606,
                    53.1969857
                ],
                [
                    83.8433221,
                    53.1915898
                ],
                [
                    83.8428265,
                    53.1899561
                ],
                [
                    83.8418935,
                    53.1884238
                ],
                [
                    83.8398547,
                    53.1873265
                ],
                [
                    83.8366755,
                    53.1869745
                ],
                [
                    83.8327361,
                    53.1868709
                ],
                [
                    83.8284511,
                    53.1878027
                ],
                [
                    83.8252374,
                    53.1889829
                ],
                [
                    83.8120024,
                    53.1969951
                ],
                [
                    83.7990784,
                    53.1936621
                ],
                [
                    83.7989747,
                    53.1992101
                ],
                [
                    83.7947934,
                    53.2043849
                ],
                [
                    83.7838736,
                    53.2113595
                ],
                [
                    83.7803143,
                    53.2189537
                ],
                [
                    83.7751308,
                    53.2286566
                ],
                [
                    83.7732303,
                    53.2312216
                ],
                [
                    83.7710533,
                    53.2330005
                ],
                [
                    83.7674594,
                    53.2346759
                ],
                [
                    83.7646949,
                    53.2353377
                ],
                [
                    83.7596843,
                    53.2370544
                ],
                [
                    83.7538443,
                    53.242907
                ],
                [
                    83.7453435,
                    53.241294
                ],
                [
                    83.7485917,
                    53.2492758
                ],
                [
                    83.7499394,
                    53.2535969
                ],
                [
                    83.7495593,
                    53.258455
                ],
                [
                    83.750285,
                    53.2631266
                ],
                [
                    83.7510849,
                    53.2659627
                ],
                [
                    83.753462,
                    53.2686126
                ],
                [
                    83.7540673,
                    53.2684445
                ],
                [
                    83.7548021,
                    53.2689486
                ],
                [
                    83.7556233,
                    53.2693364
                ],
                [
                    83.7556665,
                    53.2699179
                ],
                [
                    83.7570929,
                    53.2711846
                ],
                [
                    83.7588866,
                    53.2713785
                ],
                [
                    83.7594268,
                    53.2720247
                ],
                [
                    83.7545211,
                    53.2735109
                ],
                [
                    83.7534837,
                    53.271624
                ],
                [
                    83.7514492,
                    53.2719514
                ],
                [
                    83.7509823,
                    53.2719337
                ],
                [
                    83.7476918,
                    53.2724382
                ],
                [
                    83.7441908,
                    53.273834
                ],
                [
                    83.7403655,
                    53.2722831
                ],
                [
                    83.7380531,
                    53.2759017
                ],
                [
                    83.7262963,
                    53.2910447
                ],
                [
                    83.715711,
                    53.3045914
                ],
                [
                    83.7139201,
                    53.3050659
                ],
                [
                    83.712011,
                    53.305086
                ],
                [
                    83.7102032,
                    53.3055404
                ],
                [
                    83.7083448,
                    53.3041775
                ],
                [
                    83.707027,
                    53.3042885
                ],
                [
                    83.7052699,
                    53.3037535
                ],
                [
                    83.7045941,
                    53.3043289
                ],
                [
                    83.7042731,
                    53.305076
                ],
                [
                    83.7036142,
                    53.3068932
                ],
                [
                    83.7028032,
                    53.3074787
                ],
                [
                    83.7019247,
                    53.3090434
                ],
                [
                    83.7040197,
                    53.3094876
                ],
                [
                    83.7071115,
                    53.311244
                ],
                [
                    83.7088685,
                    53.3117992
                ],
                [
                    83.7093584,
                    53.3125865
                ],
                [
                    83.7016544,
                    53.3226792
                ],
                [
                    83.6998297,
                    53.3236682
                ],
                [
                    83.694153,
                    53.322437
                ],
                [
                    83.6796233,
                    53.3177644
                ],
                [
                    83.6748928,
                    53.3160789
                ],
                [
                    83.6672224,
                    53.3162302
                ],
                [
                    83.6658707,
                    53.3150695
                ],
                [
                    83.6650768,
                    53.3129599
                ],
                [
                    83.6583019,
                    53.3115266
                ],
                [
                    83.6544498,
                    53.309215
                ],
                [
                    83.650234,
                    53.3079648
                ],
                [
                    83.6466204,
                    53.3075292
                ],
                [
                    83.6427532,
                    53.3075481
                ],
                [
                    83.6390866,
                    53.3056414
                ],
                [
                    83.6345855,
                    53.3041008
                ],
                [
                    83.6318595,
                    53.3035073
                ],
                [
                    83.6332119,
                    53.3019413
                ],
                [
                    83.6328527,
                    53.3016067
                ],
                [
                    83.6322821,
                    53.3019477
                ],
                [
                    83.6319651,
                    53.3019098
                ],
                [
                    83.6319863,
                    53.3010194
                ],
                [
                    83.6310142,
                    53.3008679
                ],
                [
                    83.6309296,
                    53.3016318
                ],
                [
                    83.6311938,
                    53.3024844
                ],
                [
                    83.6308028,
                    53.302838
                ],
                [
                    83.6291334,
                    53.3026801
                ],
                [
                    83.6289221,
                    53.3024465
                ],
                [
                    83.6258579,
                    53.301954
                ],
                [
                    83.6205642,
                    53.3002238
                ],
                [
                    83.6198457,
                    53.299605
                ],
                [
                    83.617817,
                    53.2991124
                ],
                [
                    83.6172147,
                    53.2992386
                ],
                [
                    83.6138864,
                    53.3027875
                ],
                [
                    83.6121323,
                    53.3048206
                ],
                [
                    83.6122803,
                    53.3050479
                ],
                [
                    83.6090682,
                    53.3095494
                ],
                [
                    83.6111498,
                    53.3102249
                ],
                [
                    83.6083814,
                    53.3136907
                ],
                [
                    83.6087195,
                    53.3138169
                ],
                [
                    83.6003828,
                    53.3231206
                ],
                [
                    83.600404,
                    53.3252222
                ],
                [
                    83.5971496,
                    53.3257271
                ],
                [
                    83.5961105,
                    53.3267528
                ],
                [
                    83.5868843,
                    53.3292367
                ],
                [
                    83.5568111,
                    53.3381031
                ],
                [
                    83.5527022,
                    53.338976
                ],
                [
                    83.552803,
                    53.3397437
                ],
                [
                    83.533418,
                    53.3437922
                ]
            ],
            "longitude": 83.778412,
            "latitude": 53.347378
        },
        "24": {
            "name": "БИЙСК",
            "population": 203826,
            "type": "city",
            "poly": [
                [
                    85.0665423,
                    52.5369733
                ],
                [
                    85.0687272,
                    52.5442155
                ],
                [
                    85.0698197,
                    52.5543126
                ],
                [
                    85.0738146,
                    52.5618577
                ],
                [
                    85.0760488,
                    52.5688877
                ],
                [
                    85.0771002,
                    52.5702856
                ],
                [
                    85.08216,
                    52.569287
                ],
                [
                    85.0985879,
                    52.5635754
                ],
                [
                    85.1148022,
                    52.5574534
                ],
                [
                    85.1249054,
                    52.5606993
                ],
                [
                    85.1402655,
                    52.5716335
                ],
                [
                    85.1573171,
                    52.5834306
                ],
                [
                    85.1661407,
                    52.5923976
                ],
                [
                    85.1869964,
                    52.5815785
                ],
                [
                    85.2034628,
                    52.5722466
                ],
                [
                    85.2152909,
                    52.5619117
                ],
                [
                    85.2343496,
                    52.5658715
                ],
                [
                    85.232698,
                    52.5688084
                ],
                [
                    85.2431794,
                    52.5709857
                ],
                [
                    85.2448308,
                    52.568049
                ],
                [
                    85.2536745,
                    52.5698862
                ],
                [
                    85.2801452,
                    52.5731038
                ],
                [
                    85.2894501,
                    52.5757363
                ],
                [
                    85.3087015,
                    52.5733963
                ],
                [
                    85.3090224,
                    52.5694962
                ],
                [
                    85.3050116,
                    52.5668634
                ],
                [
                    85.3183272,
                    52.5553552
                ],
                [
                    85.3242631,
                    52.551551
                ],
                [
                    85.3367765,
                    52.5500877
                ],
                [
                    85.351536,
                    52.5537945
                ],
                [
                    85.3637284,
                    52.5571109
                ],
                [
                    85.3653328,
                    52.5527214
                ],
                [
                    85.3635681,
                    52.5485269
                ],
                [
                    85.3499317,
                    52.5458928
                ],
                [
                    85.3293968,
                    52.5455026
                ],
                [
                    85.3170437,
                    52.5404291
                ],
                [
                    85.2851385,
                    52.5275536
                ],
                [
                    85.2215311,
                    52.514017
                ],
                [
                    85.1854973,
                    52.5006669
                ],
                [
                    85.1845573,
                    52.4819699
                ],
                [
                    85.1717104,
                    52.4604013
                ],
                [
                    85.1313178,
                    52.4665066
                ],
                [
                    85.1212874,
                    52.468119
                ],
                [
                    85.1219212,
                    52.470888
                ],
                [
                    85.0738617,
                    52.5250111
                ],
                [
                    85.0665423,
                    52.5369733
                ]
            ],
            "longitude": 85.2148673,
            "latitude": 52.5394905
        },
        "25": {
            "name": "УЛАН-УДЭ",
            "population": 430550,
            "type": "city",
            "poly": [
                [
                    107.399006,
                    51.8070477
                ],
                [
                    107.4409578,
                    51.8118133
                ],
                [
                    107.4296665,
                    51.8205595
                ],
                [
                    107.449217,
                    51.8194126
                ],
                [
                    107.4750241,
                    51.822365
                ],
                [
                    107.466801,
                    51.8316159
                ],
                [
                    107.4868108,
                    51.8414215
                ],
                [
                    107.4997852,
                    51.8460834
                ],
                [
                    107.5144676,
                    51.853511
                ],
                [
                    107.5208634,
                    51.8510139
                ],
                [
                    107.5338257,
                    51.8535083
                ],
                [
                    107.5327602,
                    51.8604379
                ],
                [
                    107.5355366,
                    51.8626974
                ],
                [
                    107.5343656,
                    51.8636489
                ],
                [
                    107.5340065,
                    51.8649311
                ],
                [
                    107.5305457,
                    51.8696232
                ],
                [
                    107.5253168,
                    51.8745936
                ],
                [
                    107.5232478,
                    51.8784023
                ],
                [
                    107.5151599,
                    51.8843238
                ],
                [
                    107.5133426,
                    51.8898936
                ],
                [
                    107.5121237,
                    51.8946455
                ],
                [
                    107.5178751,
                    51.8949121
                ],
                [
                    107.52145,
                    51.8991374
                ],
                [
                    107.5224602,
                    51.9042941
                ],
                [
                    107.5287054,
                    51.9091102
                ],
                [
                    107.5307259,
                    51.9089969
                ],
                [
                    107.5298075,
                    51.9130762
                ],
                [
                    107.5381651,
                    51.9123963
                ],
                [
                    107.5368793,
                    51.9075238
                ],
                [
                    107.5419306,
                    51.9074104
                ],
                [
                    107.5460634,
                    51.9063339
                ],
                [
                    107.54673,
                    51.9059382
                ],
                [
                    107.5496265,
                    51.9059614
                ],
                [
                    107.5542129,
                    51.908077
                ],
                [
                    107.5604245,
                    51.9072638
                ],
                [
                    107.56093,
                    51.9057377
                ],
                [
                    107.5761405,
                    51.8849421
                ],
                [
                    107.5771549,
                    51.8850423
                ],
                [
                    107.6636427,
                    51.8906903
                ],
                [
                    107.674367,
                    51.8847622
                ],
                [
                    107.6755272,
                    51.8842669
                ],
                [
                    107.7160066,
                    51.8752871
                ],
                [
                    107.7572498,
                    51.883928
                ],
                [
                    107.7860072,
                    51.8721114
                ],
                [
                    107.7856132,
                    51.8693012
                ],
                [
                    107.7852769,
                    51.8673261
                ],
                [
                    107.7567233,
                    51.8333222
                ],
                [
                    107.7661798,
                    51.7948394
                ],
                [
                    107.7444295,
                    51.7853297
                ],
                [
                    107.6776185,
                    51.7646646
                ],
                [
                    107.6114644,
                    51.7560945
                ],
                [
                    107.6028065,
                    51.7562866
                ],
                [
                    107.5429055,
                    51.761815
                ],
                [
                    107.5122316,
                    51.7664047
                ],
                [
                    107.5393756,
                    51.8195484
                ],
                [
                    107.5398249,
                    51.8233331
                ],
                [
                    107.5390791,
                    51.8243615
                ],
                [
                    107.5337307,
                    51.8248222
                ],
                [
                    107.5313572,
                    51.8266534
                ],
                [
                    107.5279101,
                    51.8301165
                ],
                [
                    107.5292936,
                    51.8319485
                ],
                [
                    107.5327153,
                    51.833402
                ],
                [
                    107.533922,
                    51.8345187
                ],
                [
                    107.5241462,
                    51.8369874
                ],
                [
                    107.517869,
                    51.8301509
                ],
                [
                    107.5293458,
                    51.8218278
                ],
                [
                    107.5033673,
                    51.7808117
                ],
                [
                    107.4692097,
                    51.785728
                ],
                [
                    107.4497451,
                    51.7790774
                ],
                [
                    107.4211796,
                    51.783732
                ],
                [
                    107.4088233,
                    51.7965815
                ],
                [
                    107.399006,
                    51.8070477
                ]
            ],
            "longitude": 107.5836959,
            "latitude": 51.8357642
        },
        "26": {
            "name": "Коргон",
            "population": null,
            "type": "village",
            "poly": [
                [
                    84.0309593,
                    51.1020279
                ],
                [
                    84.0309593,
                    51.1031879
                ],
                [
                    84.0369364,
                    51.1030515
                ],
                [
                    84.0479125,
                    51.098138
                ],
                [
                    84.0498687,
                    51.0933605
                ],
                [
                    84.0475865,
                    51.0922684
                ],
                [
                    84.0426961,
                    51.0922002
                ],
                [
                    84.0409573,
                    51.0960905
                ],
                [
                    84.0309593,
                    51.1020279
                ]
            ],
            "longitude": 84.0439538,
            "latitude": 51.0962984
        },
        "27": {
            "name": "Усть-Кумир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.2868999,
            "latitude": 51.0320863
        },
        "28": {
            "name": "Талица",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.3075025,
            "latitude": 51.0372887
        },
        "29": {
            "name": "Тюдрала",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.4891514,
            "latitude": 50.9894894
        },
        "30": {
            "name": "Кайсын",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.5920139,
            "latitude": 50.9493629
        },
        "31": {
            "name": "Карагай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.6189308,
            "latitude": 50.39577
        },
        "32": {
            "name": "Козуль",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.6896652,
            "latitude": 50.9729098
        },
        "33": {
            "name": "Чёрный Ануй",
            "population": null,
            "type": "village",
            "poly": [
                [
                    84.7183118,
                    51.3650128
                ],
                [
                    84.7200117,
                    51.3669481
                ],
                [
                    84.7260114,
                    51.3634519
                ],
                [
                    84.7357109,
                    51.3627027
                ],
                [
                    84.7423106,
                    51.3639514
                ],
                [
                    84.7505101,
                    51.3648879
                ],
                [
                    84.7576098,
                    51.3664487
                ],
                [
                    84.7590098,
                    51.3635144
                ],
                [
                    84.7476103,
                    51.361454
                ],
                [
                    84.7367109,
                    51.3587067
                ],
                [
                    84.7355109,
                    51.3555845
                ],
                [
                    84.7355109,
                    51.3501514
                ],
                [
                    84.7388108,
                    51.3410324
                ],
                [
                    84.7363109,
                    51.3401579
                ],
                [
                    84.732011,
                    51.3452174
                ],
                [
                    84.7286113,
                    51.349402
                ],
                [
                    84.7258114,
                    51.353836
                ],
                [
                    84.7221116,
                    51.3570207
                ],
                [
                    84.7203117,
                    51.3621408
                ],
                [
                    84.7183118,
                    51.3650128
                ]
            ],
            "longitude": 84.7276667,
            "latitude": 51.3581364
        },
        "34": {
            "name": "Келей",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.7513736,
            "latitude": 51.1751049
        },
        "35": {
            "name": "Усть-Мута",
            "population": null,
            "type": "village",
            "poly": [
                [
                    84.7465133,
                    51.2257374
                ],
                [
                    84.7468725,
                    51.228212
                ],
                [
                    84.7496266,
                    51.2309116
                ],
                [
                    84.7521414,
                    51.2334609
                ],
                [
                    84.7508242,
                    51.2379595
                ],
                [
                    84.750465,
                    51.2408084
                ],
                [
                    84.7529797,
                    51.2426826
                ],
                [
                    84.7556141,
                    51.2432823
                ],
                [
                    84.7570511,
                    51.2364601
                ],
                [
                    84.7625595,
                    51.2341358
                ],
                [
                    84.7686667,
                    51.2326362
                ],
                [
                    84.7599251,
                    51.2311365
                ],
                [
                    84.7570511,
                    51.2290368
                ],
                [
                    84.7575301,
                    51.2248374
                ],
                [
                    84.7560931,
                    51.2224376
                ],
                [
                    84.7525007,
                    51.2218376
                ],
                [
                    84.7523809,
                    51.2257374
                ],
                [
                    84.7465133,
                    51.2257374
                ]
            ],
            "longitude": 84.7540343,
            "latitude": 51.2264657
        },
        "36": {
            "name": "Озерное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.7620856,
            "latitude": 51.0030743
        },
        "37": {
            "name": "Турота",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.7713486,
            "latitude": 51.3143419
        },
        "38": {
            "name": "Мендур-Соккон",
            "population": 686,
            "type": "village",
            "poly": null,
            "longitude": 84.8132539,
            "latitude": 50.7960745
        },
        "39": {
            "name": "Банное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.8716164,
            "latitude": 50.3773821
        },
        "40": {
            "name": "Яконур",
            "population": 1699,
            "type": "village",
            "poly": null,
            "longitude": 84.8760395,
            "latitude": 51.0350778
        },
        "41": {
            "name": "Белый Ануй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.8918872,
            "latitude": 51.234327
        },
        "42": {
            "name": "Кырлык",
            "population": 1006,
            "type": "village",
            "poly": null,
            "longitude": 84.9467182,
            "latitude": 50.8059343
        },
        "43": {
            "name": "Сугаш",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.9589062,
            "latitude": 50.5683012
        },
        "44": {
            "name": "Верхний Белоануй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.9837796,
            "latitude": 51.1453616
        },
        "45": {
            "name": "Оро",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.0024675,
            "latitude": 50.9112056
        },
        "46": {
            "name": "Талда",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.0182152,
            "latitude": 50.5007073
        },
        "47": {
            "name": "Ябоган",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.0717762,
            "latitude": 50.9092277
        },
        "48": {
            "name": "Ильинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.1084067,
            "latitude": 51.4437736
        },
        "49": {
            "name": "Амур",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.1193237,
            "latitude": 50.4002565
        },
        "50": {
            "name": "Барагаш",
            "population": 760,
            "type": "village",
            "poly": null,
            "longitude": 85.2010339,
            "latitude": 51.2778898
        },
        "51": {
            "name": "Юстик",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.2344437,
            "latitude": 50.3590412
        },
        "52": {
            "name": "Беш-Озёк",
            "population": 577,
            "type": "village",
            "poly": null,
            "longitude": 85.2451524,
            "latitude": 51.1232971
        },
        "53": {
            "name": "Шыргайту",
            "population": 511,
            "type": "village",
            "poly": null,
            "longitude": 85.2916326,
            "latitude": 51.2022756
        },
        "54": {
            "name": "Мухор-Черга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.3499976,
            "latitude": 51.407388
        },
        "55": {
            "name": "Тюгурюк",
            "population": 330,
            "type": "village",
            "poly": [
                [
                    85.3869356,
                    50.3039267
                ],
                [
                    85.4099382,
                    50.3076543
                ],
                [
                    85.4141439,
                    50.3041076
                ],
                [
                    85.4072775,
                    50.3014761
                ],
                [
                    85.4051317,
                    50.2969091
                ],
                [
                    85.394317,
                    50.2963608
                ],
                [
                    85.3882231,
                    50.3015858
                ],
                [
                    85.3869356,
                    50.3039267
                ]
            ],
            "longitude": 85.4039713,
            "latitude": 50.3029947
        },
        "56": {
            "name": "Улусчерга",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.4339028,
                    51.5126493
                ],
                [
                    85.4390441,
                    51.511681
                ],
                [
                    85.4424001,
                    51.5123822
                ],
                [
                    85.4499961,
                    51.5152132
                ],
                [
                    85.4569484,
                    51.5190588
                ],
                [
                    85.4584418,
                    51.5235916
                ],
                [
                    85.4615317,
                    51.5242591
                ],
                [
                    85.4620038,
                    51.5193458
                ],
                [
                    85.4587851,
                    51.5161947
                ],
                [
                    85.4549227,
                    51.514245
                ],
                [
                    85.4514037,
                    51.5093307
                ],
                [
                    85.4456101,
                    51.5073007
                ],
                [
                    85.4373704,
                    51.5079952
                ],
                [
                    85.435319,
                    51.5099517
                ],
                [
                    85.4339028,
                    51.5126493
                ]
            ],
            "longitude": 85.4552236,
            "latitude": 51.5148158
        },
        "57": {
            "name": "Верхняя Черга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.458634,
            "latitude": 51.3731497
        },
        "58": {
            "name": "Кайтанак",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.4588617,
                    50.1545788
                ],
                [
                    85.4605783,
                    50.1652463
                ],
                [
                    85.4652131,
                    50.1652463
                ],
                [
                    85.469848,
                    50.1556786
                ],
                [
                    85.4678739,
                    50.1527805
                ],
                [
                    85.4623808,
                    50.1509106
                ],
                [
                    85.4588617,
                    50.1545788
                ]
            ],
            "longitude": 85.4650823,
            "latitude": 50.1559671
        },
        "59": {
            "name": "Огневка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.4943098,
                    50.220377
                ],
                [
                    85.5015196,
                    50.2254291
                ],
                [
                    85.5141367,
                    50.2332644
                ],
                [
                    85.5255522,
                    50.2399236
                ],
                [
                    85.5457224,
                    50.2496226
                ],
                [
                    85.551473,
                    50.2459617
                ],
                [
                    85.5349077,
                    50.238425
                ],
                [
                    85.5229772,
                    50.2315788
                ],
                [
                    85.5112184,
                    50.2238202
                ],
                [
                    85.5024637,
                    50.2155824
                ],
                [
                    85.4943098,
                    50.220377
                ]
            ],
            "longitude": 85.5137476,
            "latitude": 50.2298209
        },
        "60": {
            "name": "Березовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.53669,
            "latitude": 50.243942
        },
        "61": {
            "name": "Малая Черга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.5528456,
            "latitude": 51.3431804
        },
        "62": {
            "name": "Ело",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.5591644,
            "latitude": 50.7689085
        },
        "63": {
            "name": "Черга",
            "population": 1952,
            "type": "village",
            "poly": null,
            "longitude": 85.569199,
            "latitude": 51.570702
        },
        "64": {
            "name": "Каярлык",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.5774494,
            "latitude": 50.6847582
        },
        "65": {
            "name": "Озёрное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.5787024,
            "latitude": 50.9079045
        },
        "66": {
            "name": "Кара Кобы",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.5796641,
            "latitude": 50.8150607
        },
        "67": {
            "name": "Дъектиек",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.6090424,
            "latitude": 51.2719675
        },
        "68": {
            "name": "Мыюта",
            "population": 284,
            "type": "village",
            "poly": null,
            "longitude": 85.6216874,
            "latitude": 51.4177279
        },
        "69": {
            "name": "Теньга",
            "population": 643,
            "type": "village",
            "poly": null,
            "longitude": 85.652866,
            "latitude": 50.8382213
        },
        "70": {
            "name": "Баштала",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.6595324,
            "latitude": 50.2871581
        },
        "71": {
            "name": "Актел",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.6657777,
            "latitude": 51.5192977
        },
        "72": {
            "name": "Камлак",
            "population": 572,
            "type": "village",
            "poly": [
                [
                    85.6524974,
                    51.621849
                ],
                [
                    85.6660587,
                    51.6267512
                ],
                [
                    85.6920709,
                    51.6332815
                ],
                [
                    85.6927493,
                    51.6321621
                ],
                [
                    85.6773883,
                    51.6252593
                ],
                [
                    85.6620918,
                    51.6192638
                ],
                [
                    85.6564456,
                    51.6195042
                ],
                [
                    85.6524974,
                    51.621849
                ]
            ],
            "longitude": 85.6668291,
            "latitude": 51.6240334
        },
        "73": {
            "name": "Октябрьское",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 85.7249679,
            "latitude": 50.2409338
        },
        "74": {
            "name": "Шиба",
            "population": 329,
            "type": "village",
            "poly": null,
            "longitude": 85.7382164,
            "latitude": 50.848423
        },
        "75": {
            "name": "Верх-Уймон",
            "population": 562,
            "type": "village",
            "poly": null,
            "longitude": 85.739822,
            "latitude": 50.212151
        },
        "76": {
            "name": "Усть-Муны",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.7335681,
                    51.7284845
                ],
                [
                    85.7347697,
                    51.7288033
                ],
                [
                    85.738675,
                    51.7289097
                ],
                [
                    85.7427091,
                    51.7288033
                ],
                [
                    85.7454127,
                    51.7267433
                ],
                [
                    85.7474083,
                    51.7267035
                ],
                [
                    85.7501763,
                    51.7264244
                ],
                [
                    85.7547039,
                    51.7246167
                ],
                [
                    85.7629222,
                    51.7237528
                ],
                [
                    85.766055,
                    51.7223438
                ],
                [
                    85.7662267,
                    51.7207752
                ],
                [
                    85.7647245,
                    51.7195789
                ],
                [
                    85.7634801,
                    51.7195789
                ],
                [
                    85.7636518,
                    51.7201638
                ],
                [
                    85.7627076,
                    51.7207221
                ],
                [
                    85.7621068,
                    51.7214931
                ],
                [
                    85.761978,
                    51.7217323
                ],
                [
                    85.7603473,
                    51.7219982
                ],
                [
                    85.759489,
                    51.7217855
                ],
                [
                    85.758888,
                    51.7217323
                ],
                [
                    85.7582015,
                    51.7223172
                ],
                [
                    85.7563561,
                    51.7232742
                ],
                [
                    85.7555408,
                    51.7234337
                ],
                [
                    85.7524079,
                    51.7251617
                ],
                [
                    85.7516784,
                    51.7254142
                ],
                [
                    85.7508844,
                    51.7256402
                ],
                [
                    85.7497472,
                    51.7260123
                ],
                [
                    85.7489961,
                    51.7262383
                ],
                [
                    85.7483739,
                    51.726318
                ],
                [
                    85.7473868,
                    51.7262915
                ],
                [
                    85.7463354,
                    51.7262383
                ],
                [
                    85.745284,
                    51.7263446
                ],
                [
                    85.7439321,
                    51.7264643
                ],
                [
                    85.7426876,
                    51.7266237
                ],
                [
                    85.7416791,
                    51.7263578
                ],
                [
                    85.7398123,
                    51.7263845
                ],
                [
                    85.738203,
                    51.7266105
                ],
                [
                    85.7367009,
                    51.7267168
                ],
                [
                    85.734126,
                    51.7278332
                ],
                [
                    85.7335681,
                    51.7284845
                ]
            ],
            "longitude": 85.762192,
            "latitude": 51.722095
        },
        "77": {
            "name": "Усть-Сема",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.7551116,
                    51.6482176
                ],
                [
                    85.7576865,
                    51.6485371
                ],
                [
                    85.7618064,
                    51.6488034
                ],
                [
                    85.764038,
                    51.6487502
                ],
                [
                    85.7653254,
                    51.6466199
                ],
                [
                    85.7655829,
                    51.641986
                ],
                [
                    85.7667846,
                    51.6370323
                ],
                [
                    85.7687587,
                    51.6343154
                ],
                [
                    85.7652396,
                    51.6327172
                ],
                [
                    85.7622355,
                    51.6347416
                ],
                [
                    85.7610339,
                    51.6360734
                ],
                [
                    85.7587165,
                    51.637565
                ],
                [
                    85.7573431,
                    51.6396957
                ],
                [
                    85.7572574,
                    51.6413469
                ],
                [
                    85.7583732,
                    51.6442764
                ],
                [
                    85.7563991,
                    51.6470992
                ],
                [
                    85.7551116,
                    51.6482176
                ]
            ],
            "longitude": 85.762215,
            "latitude": 51.641487
        },
        "78": {
            "name": "Верх Барангол",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.7626323,
                    51.6535487
                ],
                [
                    85.76455,
                    51.6556902
                ],
                [
                    85.7659563,
                    51.6574351
                ],
                [
                    85.7680019,
                    51.6587834
                ],
                [
                    85.7702812,
                    51.6580038
                ],
                [
                    85.7717095,
                    51.6573558
                ],
                [
                    85.7714538,
                    51.655373
                ],
                [
                    85.7700475,
                    51.6532314
                ],
                [
                    85.7680019,
                    51.651645
                ],
                [
                    85.7672348,
                    51.6498206
                ],
                [
                    85.76657,
                    51.6491193
                ],
                [
                    85.7649336,
                    51.6499792
                ],
                [
                    85.7645815,
                    51.6510451
                ],
                [
                    85.7642944,
                    51.651883
                ],
                [
                    85.7636433,
                    51.6525416
                ],
                [
                    85.7626323,
                    51.6535487
                ]
            ],
            "longitude": 85.7657043,
            "latitude": 51.6539683
        },
        "79": {
            "name": "Талда",
            "population": 138,
            "type": "village",
            "poly": null,
            "longitude": 85.7673747,
            "latitude": 50.8417939
        },
        "80": {
            "name": "Манжерок",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.7637805,
                    51.8355067
                ],
                [
                    85.7735651,
                    51.8362492
                ],
                [
                    85.7823199,
                    51.8358249
                ],
                [
                    85.7821483,
                    51.8346581
                ],
                [
                    85.7862681,
                    51.8322183
                ],
                [
                    85.7879848,
                    51.8283992
                ],
                [
                    85.7921046,
                    51.8261713
                ],
                [
                    85.790903,
                    51.8232005
                ],
                [
                    85.7874698,
                    51.8212906
                ],
                [
                    85.7843799,
                    51.8185318
                ],
                [
                    85.7855815,
                    51.8161972
                ],
                [
                    85.7852382,
                    51.8141808
                ],
                [
                    85.7830065,
                    51.8158789
                ],
                [
                    85.7814616,
                    51.8175766
                ],
                [
                    85.7795733,
                    51.8163033
                ],
                [
                    85.7778567,
                    51.8143932
                ],
                [
                    85.7757968,
                    51.8144993
                ],
                [
                    85.7761401,
                    51.8160911
                ],
                [
                    85.7794016,
                    51.819699
                ],
                [
                    85.7814616,
                    51.820654
                ],
                [
                    85.7795733,
                    51.8220334
                ],
                [
                    85.7785434,
                    51.8233066
                ],
                [
                    85.7766551,
                    51.8262774
                ],
                [
                    85.7759685,
                    51.8282931
                ],
                [
                    85.7739085,
                    51.8298844
                ],
                [
                    85.770132,
                    51.8303088
                ],
                [
                    85.7668704,
                    51.8295662
                ],
                [
                    85.7648105,
                    51.8307331
                ],
                [
                    85.7682437,
                    51.8323244
                ],
                [
                    85.7682437,
                    51.8347642
                ],
                [
                    85.7637805,
                    51.8355067
                ]
            ],
            "longitude": 85.7774361,
            "latitude": 51.8310511
        },
        "81": {
            "name": "Кулада",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.7802725,
            "latitude": 50.6906609
        },
        "82": {
            "name": "Барангол",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.7694453,
                    51.6687634
                ],
                [
                    85.7717091,
                    51.6696152
                ],
                [
                    85.7745844,
                    51.6715581
                ],
                [
                    85.7743377,
                    51.6731283
                ],
                [
                    85.7768697,
                    51.6758096
                ],
                [
                    85.7784146,
                    51.6774329
                ],
                [
                    85.7792193,
                    51.6784707
                ],
                [
                    85.7781892,
                    51.6792424
                ],
                [
                    85.7787258,
                    51.6804066
                ],
                [
                    85.7802278,
                    51.6805596
                ],
                [
                    85.7802063,
                    51.6812613
                ],
                [
                    85.7792568,
                    51.6816406
                ],
                [
                    85.7789188,
                    51.6824888
                ],
                [
                    85.7792407,
                    51.6832604
                ],
                [
                    85.7797343,
                    51.6833535
                ],
                [
                    85.7821483,
                    51.6821296
                ],
                [
                    85.7833499,
                    51.6814643
                ],
                [
                    85.7842511,
                    51.6802137
                ],
                [
                    85.7850236,
                    51.6786703
                ],
                [
                    85.787813,
                    51.6747584
                ],
                [
                    85.7854098,
                    51.6733412
                ],
                [
                    85.780893,
                    51.673115
                ],
                [
                    85.7795519,
                    51.6721569
                ],
                [
                    85.7774919,
                    51.671059
                ],
                [
                    85.7738871,
                    51.6690496
                ],
                [
                    85.7727927,
                    51.6678851
                ],
                [
                    85.7721275,
                    51.6688566
                ],
                [
                    85.7694453,
                    51.6687634
                ]
            ],
            "longitude": 85.781784,
            "latitude": 51.678883
        },
        "83": {
            "name": "Черемшанка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.7739085,
                    51.8707092
                ],
                [
                    85.780775,
                    51.8729879
                ],
                [
                    85.7852379,
                    51.8725724
                ],
                [
                    85.7859034,
                    51.8694187
                ],
                [
                    85.780775,
                    51.8673704
                ],
                [
                    85.7776851,
                    51.8664694
                ],
                [
                    85.7739085,
                    51.8707092
                ]
            ],
            "longitude": 85.782997,
            "latitude": 51.870026
        },
        "84": {
            "name": "Озёрное",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.7923621,
                    51.813836
                ],
                [
                    85.7923621,
                    51.8148707
                ],
                [
                    85.7941646,
                    51.81694
                ],
                [
                    85.7955808,
                    51.8176563
                ],
                [
                    85.7988852,
                    51.8189562
                ],
                [
                    85.7999152,
                    51.8181604
                ],
                [
                    85.7985419,
                    51.8167809
                ],
                [
                    85.8003873,
                    51.8156136
                ],
                [
                    85.8024472,
                    51.8163033
                ],
                [
                    85.8038205,
                    51.8183195
                ],
                [
                    85.8069533,
                    51.8175767
                ],
                [
                    85.805623,
                    51.8152156
                ],
                [
                    85.8044213,
                    51.8131727
                ],
                [
                    85.801546,
                    51.8118727
                ],
                [
                    85.7974367,
                    51.8123145
                ],
                [
                    85.7956237,
                    51.8125094
                ],
                [
                    85.7923621,
                    51.813836
                ]
            ],
            "longitude": 85.7990141,
            "latitude": 51.814701
        },
        "85": {
            "name": "Тихонькая",
            "population": 439,
            "type": "village",
            "poly": null,
            "longitude": 85.8012916,
            "latitude": 50.2020537
        },
        "86": {
            "name": "Боочи",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.8172551,
            "latitude": 50.7405218
        },
        "87": {
            "name": "Бархатово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.8303114,
            "latitude": 50.9184572
        },
        "88": {
            "name": "Чепош",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.8200339,
                    51.596916
                ],
                [
                    85.8224697,
                    51.5976376
                ],
                [
                    85.8262874,
                    51.5954434
                ],
                [
                    85.8336044,
                    51.5887276
                ],
                [
                    85.8398713,
                    51.5850447
                ],
                [
                    85.840698,
                    51.5851874
                ],
                [
                    85.8414327,
                    51.5846167
                ],
                [
                    85.840962,
                    51.5843028
                ],
                [
                    85.843015,
                    51.5829335
                ],
                [
                    85.8415475,
                    51.5811353
                ],
                [
                    85.8419838,
                    51.580429
                ],
                [
                    85.840345,
                    51.5799226
                ],
                [
                    85.8317326,
                    51.5846586
                ],
                [
                    85.8258314,
                    51.5889387
                ],
                [
                    85.8226034,
                    51.5908874
                ],
                [
                    85.820337,
                    51.5935743
                ],
                [
                    85.8200339,
                    51.596916
                ]
            ],
            "longitude": 85.8317792,
            "latitude": 51.5883105
        },
        "89": {
            "name": "Горбуново",
            "population": 296,
            "type": "village",
            "poly": null,
            "longitude": 85.8375549,
            "latitude": 50.2226565
        },
        "90": {
            "name": "Дубровка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.8328742,
                    51.9309773
                ],
                [
                    85.838539,
                    51.9325649
                ],
                [
                    85.844118,
                    51.9303951
                ],
                [
                    85.8463496,
                    51.928966
                ],
                [
                    85.8436889,
                    51.9271136
                ],
                [
                    85.8430022,
                    51.9234085
                ],
                [
                    85.8411998,
                    51.9229321
                ],
                [
                    85.8372516,
                    51.9252082
                ],
                [
                    85.8365649,
                    51.9276958
                ],
                [
                    85.8342475,
                    51.9281722
                ],
                [
                    85.8328742,
                    51.9309773
                ]
            ],
            "longitude": 85.839424,
            "latitude": 51.928261
        },
        "91": {
            "name": "Соузга",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.8321876,
                    51.8832143
                ],
                [
                    85.8339042,
                    51.8843799
                ],
                [
                    85.8345908,
                    51.8851746
                ],
                [
                    85.8357924,
                    51.886446
                ],
                [
                    85.8378953,
                    51.8878101
                ],
                [
                    85.840599,
                    51.888075
                ],
                [
                    85.841865,
                    51.8884193
                ],
                [
                    85.8430022,
                    51.8883134
                ],
                [
                    85.8460278,
                    51.889108
                ],
                [
                    85.8473152,
                    51.8892272
                ],
                [
                    85.850212,
                    51.8893729
                ],
                [
                    85.853259,
                    51.8897967
                ],
                [
                    85.8574432,
                    51.8909356
                ],
                [
                    85.8608335,
                    51.8921538
                ],
                [
                    85.8625072,
                    51.8923658
                ],
                [
                    85.8638162,
                    51.8929484
                ],
                [
                    85.864932,
                    51.8937959
                ],
                [
                    85.8652752,
                    51.8945507
                ],
                [
                    85.8657903,
                    51.8949744
                ],
                [
                    85.8662838,
                    51.8955438
                ],
                [
                    85.8663482,
                    51.8963515
                ],
                [
                    85.8665198,
                    51.8976757
                ],
                [
                    85.8672923,
                    51.8989865
                ],
                [
                    85.8678717,
                    51.8996353
                ],
                [
                    85.8677429,
                    51.9007474
                ],
                [
                    85.8677,
                    51.9019521
                ],
                [
                    85.8676356,
                    51.9030113
                ],
                [
                    85.8673781,
                    51.9037925
                ],
                [
                    85.8681935,
                    51.9053414
                ],
                [
                    85.8695668,
                    51.9051693
                ],
                [
                    85.8691161,
                    51.9035277
                ],
                [
                    85.8689445,
                    51.9014227
                ],
                [
                    85.869996,
                    51.8997941
                ],
                [
                    85.8684939,
                    51.8978345
                ],
                [
                    85.867464,
                    51.8951863
                ],
                [
                    85.8686656,
                    51.8921142
                ],
                [
                    85.8695239,
                    51.8893067
                ],
                [
                    85.8682364,
                    51.8867109
                ],
                [
                    85.8606833,
                    51.8867639
                ],
                [
                    85.8504695,
                    51.8836911
                ],
                [
                    85.845663,
                    51.8834791
                ],
                [
                    85.8401698,
                    51.8832143
                ],
                [
                    85.8369082,
                    51.8827375
                ],
                [
                    85.8338183,
                    51.8822077
                ],
                [
                    85.8321876,
                    51.8832143
                ]
            ],
            "longitude": 85.849403,
            "latitude": 51.886547
        },
        "92": {
            "name": "Карлушка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.8515045,
            "latitude": 51.9814669
        },
        "93": {
            "name": "Рыбалка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.8555764,
                    51.9190148
                ],
                [
                    85.8565206,
                    51.9201265
                ],
                [
                    85.8635158,
                    51.9182207
                ],
                [
                    85.8650178,
                    51.9167384
                ],
                [
                    85.864932,
                    51.9149912
                ],
                [
                    85.8657044,
                    51.9132442
                ],
                [
                    85.8668202,
                    51.9112322
                ],
                [
                    85.8655328,
                    51.9108086
                ],
                [
                    85.8630437,
                    51.9126618
                ],
                [
                    85.8609838,
                    51.9147531
                ],
                [
                    85.8594819,
                    51.9155562
                ],
                [
                    85.856821,
                    51.9174266
                ],
                [
                    85.8555764,
                    51.9190148
                ]
            ],
            "longitude": 85.8618254,
            "latitude": 51.9166112
        },
        "94": {
            "name": "Теректа",
            "population": 435,
            "type": "village",
            "poly": null,
            "longitude": 85.8739998,
            "latitude": 50.2937144
        },
        "95": {
            "name": "Туекта",
            "population": 360,
            "type": "village",
            "poly": null,
            "longitude": 85.8811841,
            "latitude": 50.8388397
        },
        "96": {
            "name": "Подгорное",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.8806544,
                    52.0312912
                ],
                [
                    85.8809663,
                    52.0315287
                ],
                [
                    85.8819606,
                    52.0326531
                ],
                [
                    85.8831902,
                    52.0338325
                ],
                [
                    85.886048,
                    52.0336659
                ],
                [
                    85.8886375,
                    52.0334567
                ],
                [
                    85.8896165,
                    52.0333262
                ],
                [
                    85.8900383,
                    52.0332067
                ],
                [
                    85.8904601,
                    52.0330101
                ],
                [
                    85.8907975,
                    52.0327836
                ],
                [
                    85.891751,
                    52.0339474
                ],
                [
                    85.8922239,
                    52.034578
                ],
                [
                    85.8930086,
                    52.0342965
                ],
                [
                    85.8941334,
                    52.0358265
                ],
                [
                    85.8944094,
                    52.036215
                ],
                [
                    85.8945679,
                    52.0361709
                ],
                [
                    85.8960479,
                    52.0379714
                ],
                [
                    85.8989701,
                    52.0371796
                ],
                [
                    85.8990867,
                    52.0371375
                ],
                [
                    85.8985676,
                    52.0365734
                ],
                [
                    85.8982015,
                    52.0362111
                ],
                [
                    85.8976049,
                    52.0356657
                ],
                [
                    85.8973226,
                    52.0353599
                ],
                [
                    85.8968862,
                    52.034904
                ],
                [
                    85.8964429,
                    52.0344395
                ],
                [
                    85.8958957,
                    52.0337791
                ],
                [
                    85.8955356,
                    52.0333146
                ],
                [
                    85.8952862,
                    52.0328715
                ],
                [
                    85.8951061,
                    52.0326627
                ],
                [
                    85.8950299,
                    52.0322067
                ],
                [
                    85.8948637,
                    52.0319851
                ],
                [
                    85.894724,
                    52.031703
                ],
                [
                    85.8944974,
                    52.0314273
                ],
                [
                    85.8943686,
                    52.0312613
                ],
                [
                    85.8941542,
                    52.0310141
                ],
                [
                    85.8939536,
                    52.0307973
                ],
                [
                    85.8936377,
                    52.0305619
                ],
                [
                    85.8933538,
                    52.0303019
                ],
                [
                    85.8931804,
                    52.0300982
                ],
                [
                    85.8928135,
                    52.029667
                ],
                [
                    85.8924326,
                    52.0292877
                ],
                [
                    85.8913451,
                    52.0282053
                ],
                [
                    85.8909157,
                    52.0277322
                ],
                [
                    85.8904655,
                    52.0271399
                ],
                [
                    85.8903547,
                    52.0268884
                ],
                [
                    85.8902252,
                    52.0266627
                ],
                [
                    85.8899027,
                    52.0269223
                ],
                [
                    85.8842967,
                    52.0270076
                ],
                [
                    85.88429660039425,
                    52.027007601516495
                ],
                [
                    85.8843533,
                    52.0272257
                ],
                [
                    85.8858972,
                    52.0271832
                ],
                [
                    85.8862883,
                    52.0278705
                ],
                [
                    85.8869683,
                    52.0280294
                ],
                [
                    85.887275,
                    52.0280042
                ],
                [
                    85.8876048,
                    52.0279334
                ],
                [
                    85.888098,
                    52.029006
                ],
                [
                    85.888364,
                    52.0294244
                ],
                [
                    85.8827249,
                    52.0308131
                ],
                [
                    85.8821396,
                    52.0301306
                ],
                [
                    85.8820194,
                    52.0301023
                ],
                [
                    85.8818303,
                    52.0297531
                ],
                [
                    85.8809024,
                    52.0296603
                ],
                [
                    85.880749,
                    52.0296729
                ],
                [
                    85.8816104,
                    52.0310726
                ],
                [
                    85.8806544,
                    52.0312912
                ]
            ],
            "longitude": 85.8883698,
            "latitude": 52.0326576
        },
        "97": {
            "name": "Аскат",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.8900137,
                    51.5383753
                ],
                [
                    85.8910951,
                    51.5394683
                ],
                [
                    85.895015,
                    51.5398045
                ],
                [
                    85.8973034,
                    51.5396158
                ],
                [
                    85.8981222,
                    51.5394042
                ],
                [
                    85.8989075,
                    51.5401669
                ],
                [
                    85.8995684,
                    51.5405565
                ],
                [
                    85.8999762,
                    51.5397595
                ],
                [
                    85.9006535,
                    51.538942
                ],
                [
                    85.9018071,
                    51.5375982
                ],
                [
                    85.9045327,
                    51.5364056
                ],
                [
                    85.9103602,
                    51.5354459
                ],
                [
                    85.9115257,
                    51.535307
                ],
                [
                    85.9110536,
                    51.5349091
                ],
                [
                    85.8998074,
                    51.5350328
                ],
                [
                    85.8992019,
                    51.534979
                ],
                [
                    85.8995047,
                    51.5331763
                ],
                [
                    85.9012182,
                    51.5337212
                ],
                [
                    85.9021399,
                    51.5317649
                ],
                [
                    85.8982435,
                    51.5309933
                ],
                [
                    85.8983368,
                    51.5346561
                ],
                [
                    85.8901489,
                    51.5369461
                ],
                [
                    85.8900137,
                    51.5383753
                ]
            ],
            "longitude": 85.897095,
            "latitude": 51.537136
        },
        "98": {
            "name": "Верх-Апшуяхта",
            "population": 269,
            "type": "village",
            "poly": null,
            "longitude": 85.9036885,
            "latitude": 51.2340429
        },
        "99": {
            "name": "Бичикту-Боом",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.9099912,
            "latitude": 50.7914897
        },
        "100": {
            "name": "Узнезя",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.9281127,
                    51.5308365
                ],
                [
                    85.9291561,
                    51.5325546
                ],
                [
                    85.9333604,
                    51.5305788
                ],
                [
                    85.9375493,
                    51.5286696
                ],
                [
                    85.9428123,
                    51.5265981
                ],
                [
                    85.9442086,
                    51.5262258
                ],
                [
                    85.9504383,
                    51.5255575
                ],
                [
                    85.9520648,
                    51.5255098
                ],
                [
                    85.9519881,
                    51.5248034
                ],
                [
                    85.9497632,
                    51.5239728
                ],
                [
                    85.9482135,
                    51.5231517
                ],
                [
                    85.9457277,
                    51.5236673
                ],
                [
                    85.9441473,
                    51.5242687
                ],
                [
                    85.9421065,
                    51.5241064
                ],
                [
                    85.9406488,
                    51.5229322
                ],
                [
                    85.9403419,
                    51.5183971
                ],
                [
                    85.9411091,
                    51.5153607
                ],
                [
                    85.9397128,
                    51.5152365
                ],
                [
                    85.9387768,
                    51.5174709
                ],
                [
                    85.9383012,
                    51.5192468
                ],
                [
                    85.9377948,
                    51.5214523
                ],
                [
                    85.93758,
                    51.5239345
                ],
                [
                    85.9388075,
                    51.5244979
                ],
                [
                    85.9364906,
                    51.5258534
                ],
                [
                    85.9352937,
                    51.5270468
                ],
                [
                    85.9324397,
                    51.5289942
                ],
                [
                    85.9281127,
                    51.5308365
                ]
            ],
            "longitude": 85.9424926,
            "latitude": 51.5254227
        },
        "101": {
            "name": "Анос",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.9369856,
                    51.5065725
                ],
                [
                    85.9385123,
                    51.5071491
                ],
                [
                    85.9453223,
                    51.5018966
                ],
                [
                    85.9480093,
                    51.5011493
                ],
                [
                    85.952278,
                    51.5002833
                ],
                [
                    85.9557464,
                    51.4988241
                ],
                [
                    85.9562391,
                    51.4957615
                ],
                [
                    85.9486183,
                    51.4956735
                ],
                [
                    85.9443286,
                    51.4977601
                ],
                [
                    85.939944,
                    51.4996319
                ],
                [
                    85.9369856,
                    51.5065725
                ]
            ],
            "longitude": 85.944695,
            "latitude": 51.500214
        },
        "102": {
            "name": "Каракол",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.9347563,
                    50.8139623
                ],
                [
                    85.93746,
                    50.8168365
                ],
                [
                    85.9438973,
                    50.8162942
                ],
                [
                    85.9515319,
                    50.8163687
                ],
                [
                    85.9557805,
                    50.8178871
                ],
                [
                    85.9620033,
                    50.8181311
                ],
                [
                    85.963718,
                    50.8174039
                ],
                [
                    85.9622349,
                    50.8162309
                ],
                [
                    85.9584456,
                    50.8160501
                ],
                [
                    85.9553557,
                    50.8107083
                ],
                [
                    85.9347563,
                    50.8139623
                ]
            ],
            "longitude": 85.9461955,
            "latitude": 50.8143273
        },
        "103": {
            "name": "Чендек",
            "population": 870,
            "type": "village",
            "poly": null,
            "longitude": 85.9555126,
            "latitude": 50.2652825
        },
        "104": {
            "name": "Мульта",
            "population": 704,
            "type": "village",
            "poly": [
                [
                    85.9470559,
                    50.1721461
                ],
                [
                    85.9471415,
                    50.1728288
                ],
                [
                    85.9507103,
                    50.1727618
                ],
                [
                    85.9524043,
                    50.175663
                ],
                [
                    85.9550118,
                    50.177723
                ],
                [
                    85.958495,
                    50.1778205
                ],
                [
                    85.9608932,
                    50.1776377
                ],
                [
                    85.9615213,
                    50.1761384
                ],
                [
                    85.9613329,
                    50.1750765
                ],
                [
                    85.9614746,
                    50.1699053
                ],
                [
                    85.960542,
                    50.1656016
                ],
                [
                    85.9599956,
                    50.1646456
                ],
                [
                    85.9589392,
                    50.1640054
                ],
                [
                    85.9578734,
                    50.1605243
                ],
                [
                    85.9568836,
                    50.1582806
                ],
                [
                    85.9549898,
                    50.158744
                ],
                [
                    85.9526868,
                    50.1621155
                ],
                [
                    85.9521949,
                    50.1648373
                ],
                [
                    85.9516239,
                    50.1671112
                ],
                [
                    85.9518999,
                    50.169263
                ],
                [
                    85.9496444,
                    50.1695556
                ],
                [
                    85.9478457,
                    50.1708051
                ],
                [
                    85.9470559,
                    50.1721461
                ]
            ],
            "longitude": 85.9588012,
            "latitude": 50.1691036
        },
        "105": {
            "name": "Курота",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.9631191,
                    50.8156909
                ],
                [
                    85.9653979,
                    50.8171618
                ],
                [
                    85.9723888,
                    50.8187817
                ],
                [
                    85.9703739,
                    50.8146794
                ],
                [
                    85.9748392,
                    50.8126607
                ],
                [
                    85.9735089,
                    50.8110608
                ],
                [
                    85.9786158,
                    50.8086202
                ],
                [
                    85.9767275,
                    50.807671
                ],
                [
                    85.9653549,
                    50.8106269
                ],
                [
                    85.9631191,
                    50.8156909
                ]
            ],
            "longitude": 85.9691123,
            "latitude": 50.8140968
        },
        "106": {
            "name": "Замульта",
            "population": 212,
            "type": "village",
            "poly": null,
            "longitude": 85.9730399,
            "latitude": 50.1810709
        },
        "107": {
            "name": "Нижняя Талда",
            "population": 509,
            "type": "village",
            "poly": null,
            "longitude": 85.9732179,
            "latitude": 50.8590793
        },
        "108": {
            "name": "Аюла",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.9724018,
                    51.4339629
                ],
                [
                    85.9730919,
                    51.4342455
                ],
                [
                    85.9752017,
                    51.438388
                ],
                [
                    85.9752609,
                    51.4429293
                ],
                [
                    85.9800918,
                    51.4423024
                ],
                [
                    85.9790249,
                    51.4407465
                ],
                [
                    85.978537,
                    51.4389561
                ],
                [
                    85.9784534,
                    51.4371049
                ],
                [
                    85.9771985,
                    51.4332892
                ],
                [
                    85.9757903,
                    51.4319766
                ],
                [
                    85.9742454,
                    51.4282773
                ],
                [
                    85.973838,
                    51.4283408
                ],
                [
                    85.9734173,
                    51.4284064
                ],
                [
                    85.972806,
                    51.429519
                ],
                [
                    85.9729046,
                    51.4303303
                ],
                [
                    85.9730328,
                    51.4320084
                ],
                [
                    85.9724018,
                    51.4339629
                ]
            ],
            "longitude": 85.9761739,
            "latitude": 51.4370615
        },
        "109": {
            "name": "Элекмонар",
            "population": 1895,
            "type": "village",
            "poly": [
                [
                    85.9835028,
                    51.4463533
                ],
                [
                    85.9847073,
                    51.4498034
                ],
                [
                    85.9852231,
                    51.4512998
                ],
                [
                    85.9852612,
                    51.4529981
                ],
                [
                    85.985551,
                    51.4542442
                ],
                [
                    85.9858978,
                    51.454942
                ],
                [
                    85.9857304,
                    51.4569465
                ],
                [
                    85.9852216,
                    51.4580779
                ],
                [
                    85.9856406,
                    51.4608255
                ],
                [
                    85.9864089,
                    51.4621992
                ],
                [
                    85.9865111,
                    51.4637476
                ],
                [
                    85.9871431,
                    51.4645613
                ],
                [
                    85.9872632,
                    51.465223
                ],
                [
                    85.9890128,
                    51.4681226
                ],
                [
                    85.9902799,
                    51.4703475
                ],
                [
                    85.9917066,
                    51.4720688
                ],
                [
                    85.9917066,
                    51.4733678
                ],
                [
                    85.9901801,
                    51.4737593
                ],
                [
                    85.988514,
                    51.4749462
                ],
                [
                    85.9873766,
                    51.4768849
                ],
                [
                    85.9870773,
                    51.4780283
                ],
                [
                    85.9877058,
                    51.48157
                ],
                [
                    85.9872381,
                    51.4837537
                ],
                [
                    85.9863011,
                    51.4866737
                ],
                [
                    85.9869361,
                    51.4871218
                ],
                [
                    85.9909996,
                    51.4875435
                ],
                [
                    85.9930877,
                    51.4863837
                ],
                [
                    85.995698,
                    51.4856457
                ],
                [
                    85.9966433,
                    51.4846705
                ],
                [
                    85.9989854,
                    51.4833525
                ],
                [
                    85.9990419,
                    51.479249
                ],
                [
                    85.9975886,
                    51.4766216
                ],
                [
                    85.9970525,
                    51.4746706
                ],
                [
                    85.9960789,
                    51.4732909
                ],
                [
                    85.9938779,
                    51.4721484
                ],
                [
                    85.9922412,
                    51.4691074
                ],
                [
                    85.9892203,
                    51.4658261
                ],
                [
                    85.9896568,
                    51.4633408
                ],
                [
                    85.9884881,
                    51.4607832
                ],
                [
                    85.9883611,
                    51.4591745
                ],
                [
                    85.9896733,
                    51.4592976
                ],
                [
                    85.9921424,
                    51.4585591
                ],
                [
                    85.9942128,
                    51.4591205
                ],
                [
                    85.9975745,
                    51.4589282
                ],
                [
                    86.0008196,
                    51.4601151
                ],
                [
                    86.0080435,
                    51.4601679
                ],
                [
                    86.0121777,
                    51.4607832
                ],
                [
                    86.0133629,
                    51.4606161
                ],
                [
                    86.013504,
                    51.4601767
                ],
                [
                    86.0052922,
                    51.4589282
                ],
                [
                    86.0044317,
                    51.4581459
                ],
                [
                    86.0000436,
                    51.4576888
                ],
                [
                    85.9996909,
                    51.4572227
                ],
                [
                    85.9969114,
                    51.4568448
                ],
                [
                    85.9948796,
                    51.4571084
                ],
                [
                    85.9939407,
                    51.4571904
                ],
                [
                    85.9931301,
                    51.4569766
                ],
                [
                    85.9927491,
                    51.4563261
                ],
                [
                    85.9910842,
                    51.4562206
                ],
                [
                    85.9898144,
                    51.4568887
                ],
                [
                    85.9887925,
                    51.4565421
                ],
                [
                    85.9885445,
                    51.4551216
                ],
                [
                    85.9856734,
                    51.4478512
                ],
                [
                    85.9848364,
                    51.4433342
                ],
                [
                    85.9838429,
                    51.4434174
                ],
                [
                    85.9838557,
                    51.4448417
                ],
                [
                    85.9835028,
                    51.4463533
                ]
            ],
            "longitude": 85.993034,
            "latitude": 51.457378
        },
        "110": {
            "name": "Кызыл-Озёк",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.9853349,
                    51.897185
                ],
                [
                    85.9858499,
                    51.9034343
                ],
                [
                    85.9904847,
                    51.9062939
                ],
                [
                    85.9940896,
                    51.9067175
                ],
                [
                    85.9968362,
                    51.9027989
                ],
                [
                    86.0004411,
                    51.895808
                ],
                [
                    86.0026727,
                    51.8933715
                ],
                [
                    86.0073075,
                    51.8931596
                ],
                [
                    86.003016,
                    51.8911467
                ],
                [
                    86.0026727,
                    51.886273
                ],
                [
                    86.0042176,
                    51.8809752
                ],
                [
                    85.9995828,
                    51.8791737
                ],
                [
                    85.992373,
                    51.8832004
                ],
                [
                    85.9856782,
                    51.8899814
                ],
                [
                    85.9856377,
                    51.8908313
                ],
                [
                    85.9856322,
                    51.890946
                ],
                [
                    85.9853349,
                    51.897185
                ]
            ],
            "longitude": 85.9949911,
            "latitude": 51.8924438
        },
        "111": {
            "name": "Каспа",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 85.9978897,
            "latitude": 51.1136002
        },
        "112": {
            "name": "Бешпельтир",
            "population": 480,
            "type": "village",
            "poly": [
                [
                    85.9829791,
                    51.6318411
                ],
                [
                    85.9934786,
                    51.6316768
                ],
                [
                    85.9950715,
                    51.638091
                ],
                [
                    85.9966972,
                    51.6382424
                ],
                [
                    85.9979195,
                    51.6335294
                ],
                [
                    86.0013926,
                    51.6355069
                ],
                [
                    86.0060514,
                    51.63353
                ],
                [
                    86.0013352,
                    51.6305006
                ],
                [
                    85.9984225,
                    51.6234173
                ],
                [
                    85.9943099,
                    51.6249806
                ],
                [
                    85.9831109,
                    51.6272714
                ],
                [
                    85.9829791,
                    51.6318411
                ]
            ],
            "longitude": 86.0003208,
            "latitude": 51.6313743
        },
        "113": {
            "name": "Алфёрово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0028308,
            "latitude": 51.9723343
        },
        "114": {
            "name": "Филиал",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0300647,
            "latitude": 51.8392488
        },
        "115": {
            "name": "Шашикман",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0566622,
            "latitude": 50.7885879
        },
        "116": {
            "name": "Бирюля",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.0442029,
                    51.7695706
                ],
                [
                    86.0471478,
                    51.7738226
                ],
                [
                    86.0502018,
                    51.7770956
                ],
                [
                    86.0530649,
                    51.779795
                ],
                [
                    86.0507744,
                    51.7843328
                ],
                [
                    86.0516741,
                    51.7849738
                ],
                [
                    86.0470933,
                    51.7903712
                ],
                [
                    86.0486203,
                    51.7920916
                ],
                [
                    86.0499291,
                    51.7928336
                ],
                [
                    86.0485657,
                    51.7938793
                ],
                [
                    86.0474364,
                    51.7947197
                ],
                [
                    86.0495201,
                    51.7951441
                ],
                [
                    86.051347,
                    51.7938287
                ],
                [
                    86.0526013,
                    51.7920072
                ],
                [
                    86.0531467,
                    51.7913664
                ],
                [
                    86.0524377,
                    51.7906917
                ],
                [
                    86.0519469,
                    51.7890388
                ],
                [
                    86.0526831,
                    51.7875545
                ],
                [
                    86.0556826,
                    51.7852774
                ],
                [
                    86.0578912,
                    51.7848726
                ],
                [
                    86.0615995,
                    51.780706
                ],
                [
                    86.0592274,
                    51.7768258
                ],
                [
                    86.0601817,
                    51.7730971
                ],
                [
                    86.0584092,
                    51.7721185
                ],
                [
                    86.056337,
                    51.7726753
                ],
                [
                    86.0559007,
                    51.7753411
                ],
                [
                    86.0528195,
                    51.7753242
                ],
                [
                    86.0496292,
                    51.7737045
                ],
                [
                    86.045839,
                    51.7690475
                ],
                [
                    86.0442029,
                    51.7695706
                ]
            ],
            "longitude": 86.0574061,
            "latitude": 51.7795599
        },
        "117": {
            "name": "Верх-Карагуж",
            "population": 481,
            "type": "village",
            "poly": null,
            "longitude": 86.057404,
            "latitude": 52.054863
        },
        "118": {
            "name": "Толгоек",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.0526688,
                    51.3404124
                ],
                [
                    86.0539484,
                    51.3418969
                ],
                [
                    86.0591075,
                    51.3424044
                ],
                [
                    86.061748,
                    51.3420999
                ],
                [
                    86.0636243,
                    51.3411246
                ],
                [
                    86.0637995,
                    51.3399936
                ],
                [
                    86.0620933,
                    51.3386994
                ],
                [
                    86.0607687,
                    51.3378789
                ],
                [
                    86.0585185,
                    51.3376462
                ],
                [
                    86.0555946,
                    51.3373439
                ],
                [
                    86.0535699,
                    51.3385358
                ],
                [
                    86.0526688,
                    51.3404124
                ]
            ],
            "longitude": 86.058212,
            "latitude": 51.340599
        },
        "119": {
            "name": "Еланда",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.0849299,
                    51.2103016
                ],
                [
                    86.0871505,
                    51.2159194
                ],
                [
                    86.0906352,
                    51.2199407
                ],
                [
                    86.091442,
                    51.2293582
                ],
                [
                    86.0950469,
                    51.2247356
                ],
                [
                    86.0960769,
                    51.2197902
                ],
                [
                    86.0920085,
                    51.2153172
                ],
                [
                    86.0890387,
                    51.2103276
                ],
                [
                    86.0849299,
                    51.2103016
                ]
            ],
            "longitude": 86.092484,
            "latitude": 51.222984
        },
        "120": {
            "name": "Нижний Куюм",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.09481,
            "latitude": 51.56797
        },
        "121": {
            "name": "Александровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.1124715,
            "latitude": 51.7400112
        },
        "122": {
            "name": "Ороктой",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.1134838,
            "latitude": 51.0554047
        },
        "123": {
            "name": "Карасук",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.141335,
            "latitude": 51.850983
        },
        "124": {
            "name": "Катанда",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.1769294,
            "latitude": 50.1674347
        },
        "125": {
            "name": "Сухой Карасук",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.2009004,
            "latitude": 51.9015226
        },
        "126": {
            "name": "Куюс",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.2270109,
                    51.033152
                ],
                [
                    86.2312596,
                    51.0341505
                ],
                [
                    86.2376969,
                    51.0221665
                ],
                [
                    86.2324183,
                    51.0216536
                ],
                [
                    86.2270109,
                    51.033152
                ]
            ],
            "longitude": 86.23381,
            "latitude": 51.02697
        },
        "127": {
            "name": "Эдиган",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.2606135,
            "latitude": 51.1100258
        },
        "128": {
            "name": "Сугул",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.2676864,
            "latitude": 51.9440709
        },
        "129": {
            "name": "Хабаровка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.2823281,
                    50.6790845
                ],
                [
                    86.2891366,
                    50.6967042
                ],
                [
                    86.2918553,
                    50.6978989
                ],
                [
                    86.2922415,
                    50.694963
                ],
                [
                    86.2918832,
                    50.6894456
                ],
                [
                    86.2905528,
                    50.6853672
                ],
                [
                    86.2857613,
                    50.6804441
                ],
                [
                    86.2863621,
                    50.6782415
                ],
                [
                    86.2823281,
                    50.6790845
                ]
            ],
            "longitude": 86.2880597,
            "latitude": 50.6853699
        },
        "130": {
            "name": "Тюнгур",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.2950728,
                    50.1603416
                ],
                [
                    86.2957747,
                    50.1606582
                ],
                [
                    86.2961638,
                    50.1608146
                ],
                [
                    86.2965681,
                    50.1609557
                ],
                [
                    86.2967818,
                    50.1610168
                ],
                [
                    86.2981551,
                    50.1613333
                ],
                [
                    86.3010771,
                    50.1618522
                ],
                [
                    86.3015578,
                    50.1619094
                ],
                [
                    86.3021909,
                    50.1619666
                ],
                [
                    86.3035414,
                    50.1620277
                ],
                [
                    86.3039076,
                    50.1620161
                ],
                [
                    86.305065,
                    50.1619304
                ],
                [
                    86.3053267,
                    50.1618903
                ],
                [
                    86.305464,
                    50.1618446
                ],
                [
                    86.3057006,
                    50.1617149
                ],
                [
                    86.3057921,
                    50.1616385
                ],
                [
                    86.3063942,
                    50.1618968
                ],
                [
                    86.3112395,
                    50.1612213
                ],
                [
                    86.3126214,
                    50.1613037
                ],
                [
                    86.3125741,
                    50.1617249
                ],
                [
                    86.3140869,
                    50.1620961
                ],
                [
                    86.3162755,
                    50.1623985
                ],
                [
                    86.3186252,
                    50.1628449
                ],
                [
                    86.3197302,
                    50.1628587
                ],
                [
                    86.3213717,
                    50.1624947
                ],
                [
                    86.3224124,
                    50.1620824
                ],
                [
                    86.3238822,
                    50.1621305
                ],
                [
                    86.3245582,
                    50.1623917
                ],
                [
                    86.325159,
                    50.1624947
                ],
                [
                    86.3250791,
                    50.1630367
                ],
                [
                    86.3236784,
                    50.1641369
                ],
                [
                    86.3237428,
                    50.164625
                ],
                [
                    86.3250517,
                    50.1645563
                ],
                [
                    86.3254058,
                    50.1642332
                ],
                [
                    86.3258778,
                    50.1639995
                ],
                [
                    86.3264571,
                    50.1639377
                ],
                [
                    86.3266289,
                    50.1641164
                ],
                [
                    86.3272619,
                    50.1642126
                ],
                [
                    86.3275558,
                    50.163943
                ],
                [
                    86.3271868,
                    50.1636131
                ],
                [
                    86.327174,
                    50.1633738
                ],
                [
                    86.3271611,
                    50.1631292
                ],
                [
                    86.3277339,
                    50.1630855
                ],
                [
                    86.3278949,
                    50.163003
                ],
                [
                    86.3301265,
                    50.1640889
                ],
                [
                    86.3309311,
                    50.1640752
                ],
                [
                    86.3324117,
                    50.1638414
                ],
                [
                    86.3331198,
                    50.1634635
                ],
                [
                    86.3331413,
                    50.1631542
                ],
                [
                    86.3324439,
                    50.1625016
                ],
                [
                    86.3317787,
                    50.1619174
                ],
                [
                    86.330974,
                    50.1614638
                ],
                [
                    86.3304483,
                    50.1611957
                ],
                [
                    86.3287961,
                    50.1607283
                ],
                [
                    86.3264465,
                    50.1605221
                ],
                [
                    86.3263821,
                    50.1602197
                ],
                [
                    86.3257491,
                    50.1600479
                ],
                [
                    86.324172,
                    50.1603297
                ],
                [
                    86.3239681,
                    50.1604534
                ],
                [
                    86.324011,
                    50.1606802
                ],
                [
                    86.3234102,
                    50.160694
                ],
                [
                    86.3226807,
                    50.1606665
                ],
                [
                    86.3222944,
                    50.1606459
                ],
                [
                    86.3221979,
                    50.1607696
                ],
                [
                    86.3215863,
                    50.1606321
                ],
                [
                    86.3204491,
                    50.1605428
                ],
                [
                    86.3198375,
                    50.1606252
                ],
                [
                    86.3187968,
                    50.1605565
                ],
                [
                    86.3162219,
                    50.1600823
                ],
                [
                    86.3151812,
                    50.1600341
                ],
                [
                    86.3144838,
                    50.160144
                ],
                [
                    86.313486,
                    50.160474
                ],
                [
                    86.3136362,
                    50.1600135
                ],
                [
                    86.3122844,
                    50.1598211
                ],
                [
                    86.3119304,
                    50.1600548
                ],
                [
                    86.3113295,
                    50.160041
                ],
                [
                    86.3078234,
                    50.1599128
                ],
                [
                    86.3074886,
                    50.1601716
                ],
                [
                    86.307274,
                    50.1599998
                ],
                [
                    86.3054823,
                    50.1597592
                ],
                [
                    86.3033151,
                    50.159491
                ],
                [
                    86.3031756,
                    50.1601029
                ],
                [
                    86.2992596,
                    50.1594774
                ],
                [
                    86.2991201,
                    50.1597248
                ],
                [
                    86.2973606,
                    50.1594705
                ],
                [
                    86.2971559,
                    50.1599734
                ],
                [
                    86.2963628,
                    50.1598623
                ],
                [
                    86.2956224,
                    50.1599654
                ],
                [
                    86.2950728,
                    50.1603416
                ]
            ],
            "longitude": 86.3112599,
            "latitude": 50.1608392
        },
        "131": {
            "name": "Кучерла",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.318078,
                    50.1411286
                ],
                [
                    86.3184857,
                    50.1414793
                ],
                [
                    86.320214,
                    50.1426382
                ],
                [
                    86.3218545,
                    50.1433495
                ],
                [
                    86.3228742,
                    50.1450423
                ],
                [
                    86.3230664,
                    50.1453428
                ],
                [
                    86.3231424,
                    50.1454617
                ],
                [
                    86.3231925,
                    50.1459129
                ],
                [
                    86.3233834,
                    50.1461829
                ],
                [
                    86.3239885,
                    50.1464661
                ],
                [
                    86.3246333,
                    50.146416
                ],
                [
                    86.3248586,
                    50.1468903
                ],
                [
                    86.3279163,
                    50.1481692
                ],
                [
                    86.3291485,
                    50.1490557
                ],
                [
                    86.3297177,
                    50.1490767
                ],
                [
                    86.329855,
                    50.1480877
                ],
                [
                    86.3306307,
                    50.1478461
                ],
                [
                    86.3296115,
                    50.1463267
                ],
                [
                    86.3291716,
                    50.1458935
                ],
                [
                    86.3296222,
                    50.1449516
                ],
                [
                    86.3293111,
                    50.1447178
                ],
                [
                    86.3277447,
                    50.1440027
                ],
                [
                    86.3269936,
                    50.1440784
                ],
                [
                    86.3265967,
                    50.1438721
                ],
                [
                    86.3259422,
                    50.1439752
                ],
                [
                    86.3257169,
                    50.1438446
                ],
                [
                    86.3263714,
                    50.1433839
                ],
                [
                    86.3255667,
                    50.1429851
                ],
                [
                    86.3248801,
                    50.1422769
                ],
                [
                    86.3224232,
                    50.1403035
                ],
                [
                    86.3217365,
                    50.1395746
                ],
                [
                    86.3214468,
                    50.1381855
                ],
                [
                    86.3212859,
                    50.1365627
                ],
                [
                    86.3214361,
                    50.1358819
                ],
                [
                    86.321039,
                    50.1349879
                ],
                [
                    86.3204169,
                    50.1347815
                ],
                [
                    86.3200566,
                    50.1348743
                ],
                [
                    86.3196208,
                    50.1365986
                ],
                [
                    86.3196813,
                    50.1384002
                ],
                [
                    86.3196162,
                    50.1403836
                ],
                [
                    86.318078,
                    50.1411286
                ]
            ],
            "longitude": 86.3245335,
            "latitude": 50.1442076
        },
        "132": {
            "name": "Паспаул",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.3327775,
                    51.9442982
                ],
                [
                    86.3334642,
                    51.9458854
                ],
                [
                    86.338099,
                    51.9468377
                ],
                [
                    86.3413606,
                    51.9430284
                ],
                [
                    86.3463388,
                    51.9411236
                ],
                [
                    86.350287,
                    51.9410178
                ],
                [
                    86.3568101,
                    51.9448273
                ],
                [
                    86.36093,
                    51.9447215
                ],
                [
                    86.3724313,
                    51.9491655
                ],
                [
                    86.3739762,
                    51.951599
                ],
                [
                    86.379126,
                    51.9537149
                ],
                [
                    86.3818727,
                    51.9524454
                ],
                [
                    86.3798127,
                    51.9492713
                ],
                [
                    86.3744912,
                    51.9453564
                ],
                [
                    86.3626466,
                    51.9412294
                ],
                [
                    86.3545785,
                    51.9358321
                ],
                [
                    86.3451371,
                    51.9192126
                ],
                [
                    86.3430772,
                    51.9176245
                ],
                [
                    86.338099,
                    51.9194243
                ],
                [
                    86.3406739,
                    51.9249296
                ],
                [
                    86.3432489,
                    51.9289522
                ],
                [
                    86.3459954,
                    51.9332919
                ],
                [
                    86.3444504,
                    51.9358321
                ],
                [
                    86.3403306,
                    51.9387953
                ],
                [
                    86.3353524,
                    51.9408061
                ],
                [
                    86.3327775,
                    51.9442982
                ]
            ],
            "longitude": 86.346281,
            "latitude": 51.9376061
        },
        "133": {
            "name": "Большой Яломан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.41597,
            "latitude": 50.488804
        },
        "134": {
            "name": "Левинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.4227353,
            "latitude": 51.9837905
        },
        "135": {
            "name": "Купчегень",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.4253135,
            "latitude": 50.6200073
        },
        "136": {
            "name": "Иня",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.627296,
            "latitude": 50.454182
        },
        "137": {
            "name": "Инегень",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.6968659,
            "latitude": 50.3189127
        },
        "138": {
            "name": "Каракокша",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.6986068,
            "latitude": 51.7664579
        },
        "139": {
            "name": "Большая Кузя",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.7244747,
            "latitude": 51.6986713
        },
        "140": {
            "name": "Сёйка",
            "population": 1444,
            "type": "village",
            "poly": null,
            "longitude": 86.7347285,
            "latitude": 51.882322
        },
        "141": {
            "name": "Озеро-Куреево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.751414,
            "latitude": 52.4655521
        },
        "142": {
            "name": "Ынырга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.79284,
            "latitude": 51.8257768
        },
        "143": {
            "name": "Красносельск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.7943324,
            "latitude": 51.8098691
        },
        "144": {
            "name": "Ускуч",
            "population": 331,
            "type": "village",
            "poly": null,
            "longitude": 86.9054117,
            "latitude": 52.0363379
        },
        "145": {
            "name": "Дмитриевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.914474,
            "latitude": 52.440552
        },
        "146": {
            "name": "Уймень",
            "population": 387,
            "type": "village",
            "poly": null,
            "longitude": 86.9208461,
            "latitude": 51.6573297
        },
        "147": {
            "name": "Иодро",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.9728242,
                    50.399157
                ],
                [
                    86.9729499,
                    50.3994661
                ],
                [
                    86.9745158,
                    50.3997541
                ],
                [
                    86.9758399,
                    50.4002633
                ],
                [
                    86.9752619,
                    50.4012346
                ],
                [
                    86.9745158,
                    50.4016633
                ],
                [
                    86.9739063,
                    50.4020853
                ],
                [
                    86.9736646,
                    50.4022662
                ],
                [
                    86.97414,
                    50.4024582
                ],
                [
                    86.9748094,
                    50.4027284
                ],
                [
                    86.9751871,
                    50.403168
                ],
                [
                    86.9758439,
                    50.4031052
                ],
                [
                    86.9762544,
                    50.4034819
                ],
                [
                    86.976481,
                    50.4040078
                ],
                [
                    86.9766597,
                    50.4043092
                ],
                [
                    86.9775319,
                    50.4037666
                ],
                [
                    86.9778682,
                    50.4031437
                ],
                [
                    86.9785198,
                    50.4027083
                ],
                [
                    86.9790347,
                    50.4020384
                ],
                [
                    86.9796863,
                    50.4011609
                ],
                [
                    86.9803379,
                    50.4009935
                ],
                [
                    86.980506,
                    50.4004308
                ],
                [
                    86.9798545,
                    50.3999485
                ],
                [
                    86.9796968,
                    50.3986288
                ],
                [
                    86.9779523,
                    50.3982804
                ],
                [
                    86.9776499,
                    50.3981106
                ],
                [
                    86.9772692,
                    50.3978986
                ],
                [
                    86.9771326,
                    50.3963243
                ],
                [
                    86.9790873,
                    50.3942071
                ],
                [
                    86.9816515,
                    50.3928807
                ],
                [
                    86.9830808,
                    50.3918489
                ],
                [
                    86.9843103,
                    50.3909243
                ],
                [
                    86.9831859,
                    50.3896915
                ],
                [
                    86.980485,
                    50.3909913
                ],
                [
                    86.9788246,
                    50.392204
                ],
                [
                    86.9762918,
                    50.3910516
                ],
                [
                    86.9756297,
                    50.3918154
                ],
                [
                    86.9752619,
                    50.3932626
                ],
                [
                    86.9772272,
                    50.3934703
                ],
                [
                    86.9764285,
                    50.395259
                ],
                [
                    86.9757664,
                    50.3959959
                ],
                [
                    86.9753355,
                    50.3971952
                ],
                [
                    86.9745999,
                    50.3979723
                ],
                [
                    86.9736961,
                    50.3984345
                ],
                [
                    86.973055,
                    50.3988364
                ],
                [
                    86.9728242,
                    50.399157
                ]
            ],
            "longitude": 86.9765744,
            "latitude": 50.3981337
        },
        "148": {
            "name": "Верх-Бийск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.0911951,
            "latitude": 52.0378376
        },
        "149": {
            "name": "Усть-Пыжа",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.0915004,
            "latitude": 51.8591327
        },
        "150": {
            "name": "Новотроицк",
            "population": 49,
            "type": "village",
            "poly": null,
            "longitude": 87.1002871,
            "latitude": 51.7599278
        },
        "151": {
            "name": "Кебезень",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.103081,
            "latitude": 51.908039
        },
        "152": {
            "name": "Тондошка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.1124508,
            "latitude": 52.1201912
        },
        "153": {
            "name": "Артыбаш",
            "population": 602,
            "type": "village",
            "poly": [
                [
                    87.2401632,
                    51.7869997
                ],
                [
                    87.2406181,
                    51.7875848
                ],
                [
                    87.2411873,
                    51.789133
                ],
                [
                    87.2431752,
                    51.7915602
                ],
                [
                    87.2582189,
                    51.7943515
                ],
                [
                    87.2582959,
                    51.7943706
                ],
                [
                    87.2589425,
                    51.7944858
                ],
                [
                    87.2594069,
                    51.794595
                ],
                [
                    87.2682083,
                    51.7984611
                ],
                [
                    87.270268,
                    51.7991778
                ],
                [
                    87.2716498,
                    51.7998224
                ],
                [
                    87.2750853,
                    51.8015892
                ],
                [
                    87.2811949,
                    51.800746
                ],
                [
                    87.2853341,
                    51.8006675
                ],
                [
                    87.287155,
                    51.800633
                ],
                [
                    87.2955969,
                    51.8033765
                ],
                [
                    87.3037952,
                    51.8016016
                ],
                [
                    87.3080875,
                    51.8015831
                ],
                [
                    87.3098947,
                    51.7980736
                ],
                [
                    87.3137942,
                    51.7979234
                ],
                [
                    87.3178908,
                    51.7974167
                ],
                [
                    87.3196509,
                    51.7951646
                ],
                [
                    87.3234896,
                    51.7933815
                ],
                [
                    87.3245517,
                    51.7914765
                ],
                [
                    87.3196964,
                    51.790829
                ],
                [
                    87.3145225,
                    51.7896652
                ],
                [
                    87.3122924,
                    51.7907162
                ],
                [
                    87.3077857,
                    51.7919927
                ],
                [
                    87.3038267,
                    51.7929638
                ],
                [
                    87.2982481,
                    51.7925993
                ],
                [
                    87.2955443,
                    51.793082
                ],
                [
                    87.2923443,
                    51.793086
                ],
                [
                    87.2872191,
                    51.7929814
                ],
                [
                    87.2787365,
                    51.7935838
                ],
                [
                    87.2648598,
                    51.7922205
                ],
                [
                    87.2632954,
                    51.7923865
                ],
                [
                    87.2611112,
                    51.7918935
                ],
                [
                    87.2598728,
                    51.7915635
                ],
                [
                    87.2593687,
                    51.7911113
                ],
                [
                    87.2586646,
                    51.7908782
                ],
                [
                    87.2577253,
                    51.7905211
                ],
                [
                    87.2557474,
                    51.7899337
                ],
                [
                    87.2555646,
                    51.7896197
                ],
                [
                    87.2547656,
                    51.7893211
                ],
                [
                    87.2536399,
                    51.789175
                ],
                [
                    87.2500798,
                    51.7883495
                ],
                [
                    87.2478618,
                    51.7877725
                ],
                [
                    87.2462586,
                    51.7874166
                ],
                [
                    87.2447477,
                    51.7871443
                ],
                [
                    87.2439627,
                    51.7871911
                ],
                [
                    87.2431975,
                    51.7870239
                ],
                [
                    87.2431128,
                    51.7867327
                ],
                [
                    87.2413445,
                    51.7867696
                ],
                [
                    87.2401632,
                    51.7869997
                ]
            ],
            "longitude": 87.2517352,
            "latitude": 51.7899858
        },
        "154": {
            "name": "Иогач",
            "population": 1289,
            "type": "village",
            "poly": [
                [
                    87.2368909,
                    51.7836426
                ],
                [
                    87.2383988,
                    51.7840931
                ],
                [
                    87.2398213,
                    51.784046
                ],
                [
                    87.2404041,
                    51.7842683
                ],
                [
                    87.2423117,
                    51.7851991
                ],
                [
                    87.2436018,
                    51.785001
                ],
                [
                    87.2448368,
                    51.7854616
                ],
                [
                    87.2484398,
                    51.7860224
                ],
                [
                    87.2505745,
                    51.7857609
                ],
                [
                    87.2514198,
                    51.7853844
                ],
                [
                    87.2523694,
                    51.7851989
                ],
                [
                    87.2538397,
                    51.7855955
                ],
                [
                    87.2559062,
                    51.7860369
                ],
                [
                    87.2599046,
                    51.7873884
                ],
                [
                    87.2636197,
                    51.7875837
                ],
                [
                    87.2705892,
                    51.7880773
                ],
                [
                    87.2748261,
                    51.7883271
                ],
                [
                    87.2770689,
                    51.788996
                ],
                [
                    87.2796905,
                    51.7886148
                ],
                [
                    87.2824541,
                    51.7888306
                ],
                [
                    87.2854712,
                    51.7889342
                ],
                [
                    87.285897,
                    51.7873033
                ],
                [
                    87.278676,
                    51.7849339
                ],
                [
                    87.2731212,
                    51.7805578
                ],
                [
                    87.2613336,
                    51.7752997
                ],
                [
                    87.2495449,
                    51.7743322
                ],
                [
                    87.2456675,
                    51.7763035
                ],
                [
                    87.2422614,
                    51.7780514
                ],
                [
                    87.2415905,
                    51.7794715
                ],
                [
                    87.2406469,
                    51.7817523
                ],
                [
                    87.2369377,
                    51.7829892
                ],
                [
                    87.2368909,
                    51.7836426
                ]
            ],
            "longitude": 87.253296,
            "latitude": 51.784008
        },
        "155": {
            "name": "Каяшкан",
            "population": 204,
            "type": "village",
            "poly": null,
            "longitude": 87.3605257,
            "latitude": 52.3761057
        },
        "156": {
            "name": "Беляши",
            "population": null,
            "type": "village",
            "poly": [
                [
                    87.4177411,
                    49.7055831
                ],
                [
                    87.4203589,
                    49.7102456
                ],
                [
                    87.4222408,
                    49.7111739
                ],
                [
                    87.424307,
                    49.7147411
                ],
                [
                    87.426925,
                    49.715851
                ],
                [
                    87.4281266,
                    49.7157123
                ],
                [
                    87.427691,
                    49.7110074
                ],
                [
                    87.431474,
                    49.7096073
                ],
                [
                    87.4312165,
                    49.7059439
                ],
                [
                    87.4303153,
                    49.701503
                ],
                [
                    87.4332764,
                    49.6990326
                ],
                [
                    87.4394498,
                    49.6961028
                ],
                [
                    87.4389413,
                    49.6951187
                ],
                [
                    87.4327121,
                    49.698046
                ],
                [
                    87.4315105,
                    49.6968801
                ],
                [
                    87.4296222,
                    49.6971022
                ],
                [
                    87.4273477,
                    49.6977684
                ],
                [
                    87.4262383,
                    49.6995324
                ],
                [
                    87.4266246,
                    49.7005316
                ],
                [
                    87.4177411,
                    49.7055831
                ]
            ],
            "longitude": 87.42392,
            "latitude": 49.708313
        },
        "157": {
            "name": "Чибит",
            "population": 622,
            "type": "village",
            "poly": [
                [
                    87.4925409,
                    50.3205896
                ],
                [
                    87.4949441,
                    50.3225624
                ],
                [
                    87.5036988,
                    50.322672
                ],
                [
                    87.5122819,
                    50.3202608
                ],
                [
                    87.5164962,
                    50.3152735
                ],
                [
                    87.5105653,
                    50.3140129
                ],
                [
                    87.5042138,
                    50.3123685
                ],
                [
                    87.498549,
                    50.3140129
                ],
                [
                    87.4946008,
                    50.3169725
                ],
                [
                    87.4925409,
                    50.3205896
                ]
            ],
            "longitude": 87.5060451,
            "latitude": 50.31562
        },
        "158": {
            "name": "Акташ",
            "population": 2418,
            "type": "village",
            "poly": null,
            "longitude": 87.6028375,
            "latitude": 50.3127248
        },
        "159": {
            "name": "Курмач-Байгол",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.6589396,
            "latitude": 52.1251372
        },
        "160": {
            "name": "Балыкча",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.7192822,
            "latitude": 51.2844011
        },
        "161": {
            "name": "Паспарта",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.8815929,
            "latitude": 50.8354928
        },
        "162": {
            "name": "Чибиля",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.91877,
            "latitude": 50.621716
        },
        "163": {
            "name": "Курай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.935722,
            "latitude": 50.232323
        },
        "164": {
            "name": "Кызыл-Таш",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.939804,
            "latitude": 50.214592
        },
        "165": {
            "name": "Балыктуюль",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.041569,
            "latitude": 50.7599549
        },
        "166": {
            "name": "Майск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.145279,
            "latitude": 52.330456
        },
        "167": {
            "name": "Бельтир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.165741,
            "latitude": 49.975143
        },
        "168": {
            "name": "Саратан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.2633266,
            "latitude": 50.5219274
        },
        "169": {
            "name": "Чаган-Узун",
            "population": 439,
            "type": "village",
            "poly": [
                [
                    88.3561692,
                    50.1015359
                ],
                [
                    88.3587442,
                    50.1042885
                ],
                [
                    88.3717904,
                    50.0987831
                ],
                [
                    88.3674216,
                    50.0960852
                ],
                [
                    88.3561692,
                    50.1015359
                ]
            ],
            "longitude": 88.3622738,
            "latitude": 50.1020921
        },
        "170": {
            "name": "Ортолык",
            "population": 658,
            "type": "village",
            "poly": null,
            "longitude": 88.5003607,
            "latitude": 50.0354722
        },
        "171": {
            "name": "Мухор-Тархата",
            "population": 807,
            "type": "village",
            "poly": null,
            "longitude": 88.533943,
            "latitude": 49.9879
        },
        "172": {
            "name": "Новый Бельтир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.6026582,
            "latitude": 49.9300519
        },
        "173": {
            "name": "Теленгит-Сортогой",
            "population": 605,
            "type": "village",
            "poly": null,
            "longitude": 88.7512753,
            "latitude": 50.0113215
        },
        "174": {
            "name": "Язула",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.7741393,
            "latitude": 50.6166643
        },
        "175": {
            "name": "Тобелер",
            "population": 915,
            "type": "village",
            "poly": [
                [
                    88.7822305,
                    49.9189592
                ],
                [
                    88.786007,
                    49.9207277
                ],
                [
                    88.8002292,
                    49.9159031
                ],
                [
                    88.8030014,
                    49.9113321
                ],
                [
                    88.7995683,
                    49.9077946
                ],
                [
                    88.795001,
                    49.908564
                ],
                [
                    88.7880669,
                    49.913322
                ],
                [
                    88.7822305,
                    49.9189592
                ]
            ],
            "longitude": 88.7945208,
            "latitude": 49.9145513
        },
        "176": {
            "name": "Жана-Аул",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.922668,
            "latitude": 49.842999
        },
        "177": {
            "name": "Кокоря",
            "population": 941,
            "type": "village",
            "poly": null,
            "longitude": 89.001228,
            "latitude": 49.913734
        },
        "178": {
            "name": "Ташанта",
            "population": 547,
            "type": "village",
            "poly": null,
            "longitude": 89.192589,
            "latitude": 49.717453
        },
        "179": {
            "name": "Диксон",
            "population": 609,
            "type": "village",
            "poly": [
                [
                    80.5041757,
                    73.5099405
                ],
                [
                    80.505034,
                    73.5105253
                ],
                [
                    80.5143037,
                    73.5108664
                ],
                [
                    80.5328432,
                    73.5096483
                ],
                [
                    80.5440012,
                    73.5097944
                ],
                [
                    80.549151,
                    73.5091122
                ],
                [
                    80.548636,
                    73.5070655
                ],
                [
                    80.5409113,
                    73.5057497
                ],
                [
                    80.5270067,
                    73.5057984
                ],
                [
                    80.5211702,
                    73.5043849
                ],
                [
                    80.5170502,
                    73.5054572
                ],
                [
                    80.5155054,
                    73.5076991
                ],
                [
                    80.5067507,
                    73.5078453
                ],
                [
                    80.5041757,
                    73.5099405
                ]
            ],
            "longitude": 80.5123816,
            "latitude": 73.5083894
        },
        "180": {
            "name": "Носок",
            "population": 1692,
            "type": "village",
            "poly": null,
            "longitude": 82.347794,
            "latitude": 70.163818
        },
        "181": {
            "name": "Караул",
            "population": 801,
            "type": "village",
            "poly": null,
            "longitude": 83.209244,
            "latitude": 70.069992
        },
        "182": {
            "name": "Тухард",
            "population": 814,
            "type": "village",
            "poly": null,
            "longitude": 84.336929,
            "latitude": 69.293747
        },
        "183": {
            "name": "Усть-Порт",
            "population": 338,
            "type": "village",
            "poly": null,
            "longitude": 84.407906,
            "latitude": 69.663567
        },
        "184": {
            "name": "Келлог",
            "population": 306,
            "type": "village",
            "poly": null,
            "longitude": 86.27655,
            "latitude": 62.485683
        },
        "185": {
            "name": "Потапово",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 86.2789108,
            "latitude": 68.6836525
        },
        "186": {
            "name": "Фарково",
            "population": 278,
            "type": "village",
            "poly": null,
            "longitude": 86.9762142,
            "latitude": 65.7169203
        },
        "187": {
            "name": "Снежногорск",
            "population": 720,
            "type": "village",
            "poly": null,
            "longitude": 87.790344,
            "latitude": 68.095169
        },
        "188": {
            "name": "Верхнеимбатск",
            "population": 547,
            "type": "village",
            "poly": null,
            "longitude": 87.9639337,
            "latitude": 63.1569728
        },
        "189": {
            "name": "Сым",
            "population": 179,
            "type": "village",
            "poly": null,
            "longitude": 88.3629839,
            "latitude": 60.3491261
        },
        "190": {
            "name": "Светлогорск",
            "population": 978,
            "type": "village",
            "poly": null,
            "longitude": 88.370033,
            "latitude": 66.940491
        },
        "191": {
            "name": "Сандакчес",
            "population": 375,
            "type": "village",
            "poly": null,
            "longitude": 88.5032855,
            "latitude": 61.3038766
        },
        "192": {
            "name": "Инголь",
            "population": 500,
            "type": "village",
            "poly": [
                [
                    88.7004933,
                    55.5110777
                ],
                [
                    88.7007946,
                    55.5112377
                ],
                [
                    88.7034501,
                    55.512432
                ],
                [
                    88.7036667,
                    55.5123201
                ],
                [
                    88.7051074,
                    55.5129172
                ],
                [
                    88.7058513,
                    55.5133331
                ],
                [
                    88.7054181,
                    55.5134398
                ],
                [
                    88.705098,
                    55.5136264
                ],
                [
                    88.7043164,
                    55.5145967
                ],
                [
                    88.7011435,
                    55.5174131
                ],
                [
                    88.7010023,
                    55.5175677
                ],
                [
                    88.7073585,
                    55.5216619
                ],
                [
                    88.7106545,
                    55.5240256
                ],
                [
                    88.7165688,
                    55.5221532
                ],
                [
                    88.7176355,
                    55.5226217
                ],
                [
                    88.7207621,
                    55.5209454
                ],
                [
                    88.7212191,
                    55.5208289
                ],
                [
                    88.7219631,
                    55.520088
                ],
                [
                    88.7216524,
                    55.5196028
                ],
                [
                    88.7216849,
                    55.5195207
                ],
                [
                    88.7217183,
                    55.5194749
                ],
                [
                    88.7182435,
                    55.5180995
                ],
                [
                    88.7183848,
                    55.5179022
                ],
                [
                    88.7181023,
                    55.5178063
                ],
                [
                    88.7180646,
                    55.5174064
                ],
                [
                    88.7013784,
                    55.5106138
                ],
                [
                    88.7004933,
                    55.5110777
                ]
            ],
            "longitude": 88.710587,
            "latitude": 55.516315
        },
        "193": {
            "name": "Ивановка",
            "population": 770,
            "type": "village",
            "poly": [
                [
                    88.7645354,
                    55.5595231
                ],
                [
                    88.7646422,
                    55.5600801
                ],
                [
                    88.7649622,
                    55.5603447
                ],
                [
                    88.765225,
                    55.5604932
                ],
                [
                    88.7659554,
                    55.5607206
                ],
                [
                    88.7665299,
                    55.5611941
                ],
                [
                    88.7668089,
                    55.5617789
                ],
                [
                    88.766136,
                    55.562192
                ],
                [
                    88.7674573,
                    55.5627257
                ],
                [
                    88.7678348,
                    55.5631573
                ],
                [
                    88.7693778,
                    55.5633105
                ],
                [
                    88.7706663,
                    55.5637003
                ],
                [
                    88.7712983,
                    55.564118
                ],
                [
                    88.7714378,
                    55.5644243
                ],
                [
                    88.7716219,
                    55.5645603
                ],
                [
                    88.772183,
                    55.5647779
                ],
                [
                    88.7742669,
                    55.5649048
                ],
                [
                    88.7758057,
                    55.5654214
                ],
                [
                    88.7785213,
                    55.566716
                ],
                [
                    88.7797031,
                    55.5669202
                ],
                [
                    88.7807208,
                    55.5674326
                ],
                [
                    88.7811936,
                    55.5679189
                ],
                [
                    88.7814542,
                    55.5684966
                ],
                [
                    88.7816978,
                    55.5685836
                ],
                [
                    88.7819543,
                    55.5685256
                ],
                [
                    88.7822492,
                    55.5686852
                ],
                [
                    88.7818004,
                    55.5689317
                ],
                [
                    88.7819415,
                    55.569142
                ],
                [
                    88.7824672,
                    55.5693704
                ],
                [
                    88.7811849,
                    55.5702042
                ],
                [
                    88.7810566,
                    55.5704217
                ],
                [
                    88.7816657,
                    55.5710742
                ],
                [
                    88.7832206,
                    55.5721074
                ],
                [
                    88.7836743,
                    55.5726311
                ],
                [
                    88.7845476,
                    55.5728056
                ],
                [
                    88.7843572,
                    55.573084
                ],
                [
                    88.7848824,
                    55.5732881
                ],
                [
                    88.7852961,
                    55.5733178
                ],
                [
                    88.7858016,
                    55.5733958
                ],
                [
                    88.7858345,
                    55.5737558
                ],
                [
                    88.7882244,
                    55.5751552
                ],
                [
                    88.788986,
                    55.5756971
                ],
                [
                    88.790877,
                    55.5768292
                ],
                [
                    88.791376,
                    55.5765471
                ],
                [
                    88.7940679,
                    55.5781134
                ],
                [
                    88.7940942,
                    55.5785031
                ],
                [
                    88.7945407,
                    55.5789411
                ],
                [
                    88.7950462,
                    55.579212
                ],
                [
                    88.7954336,
                    55.5794013
                ],
                [
                    88.7959654,
                    55.5793976
                ],
                [
                    88.7966746,
                    55.5789077
                ],
                [
                    88.7967008,
                    55.5785365
                ],
                [
                    88.7964054,
                    55.5781282
                ],
                [
                    88.7961099,
                    55.5779501
                ],
                [
                    88.794324,
                    55.5770296
                ],
                [
                    88.7946129,
                    55.5769146
                ],
                [
                    88.7954074,
                    55.5767216
                ],
                [
                    88.7961427,
                    55.577141
                ],
                [
                    88.7966089,
                    55.5773228
                ],
                [
                    88.7968847,
                    55.5770222
                ],
                [
                    88.7972655,
                    55.5772004
                ],
                [
                    88.798014,
                    55.5771558
                ],
                [
                    88.7982109,
                    55.5770593
                ],
                [
                    88.7984013,
                    55.5771744
                ],
                [
                    88.7994059,
                    55.5773303
                ],
                [
                    88.7993009,
                    55.5774045
                ],
                [
                    88.7993928,
                    55.577668
                ],
                [
                    88.7997539,
                    55.5778165
                ],
                [
                    88.7997867,
                    55.5779241
                ],
                [
                    88.8008504,
                    55.5783546
                ],
                [
                    88.8018746,
                    55.578633
                ],
                [
                    88.8037609,
                    55.5795208
                ],
                [
                    88.8049726,
                    55.5796396
                ],
                [
                    88.8054055,
                    55.5798842
                ],
                [
                    88.8057902,
                    55.5797302
                ],
                [
                    88.8058062,
                    55.5794584
                ],
                [
                    88.8064634,
                    55.579558
                ],
                [
                    88.8075053,
                    55.5792499
                ],
                [
                    88.8096213,
                    55.5792046
                ],
                [
                    88.8099579,
                    55.5794765
                ],
                [
                    88.8112723,
                    55.5800473
                ],
                [
                    88.8117372,
                    55.5800926
                ],
                [
                    88.8120737,
                    55.5799748
                ],
                [
                    88.8130677,
                    55.5805457
                ],
                [
                    88.8146225,
                    55.579857
                ],
                [
                    88.8131317,
                    55.5790687
                ],
                [
                    88.8131157,
                    55.5785069
                ],
                [
                    88.8118173,
                    55.5774921
                ],
                [
                    88.8106472,
                    55.576894
                ],
                [
                    88.8090121,
                    55.5778002
                ],
                [
                    88.8083709,
                    55.5782895
                ],
                [
                    88.8072168,
                    55.5775102
                ],
                [
                    88.8063191,
                    55.5779451
                ],
                [
                    88.805726,
                    55.5776552
                ],
                [
                    88.8050207,
                    55.5769756
                ],
                [
                    88.8055658,
                    55.5768125
                ],
                [
                    88.8053574,
                    55.5764047
                ],
                [
                    88.8047643,
                    55.5762506
                ],
                [
                    88.7988612,
                    55.5733403
                ],
                [
                    88.7988612,
                    55.5729865
                ],
                [
                    88.7997845,
                    55.5720701
                ],
                [
                    88.7992716,
                    55.5718207
                ],
                [
                    88.7986253,
                    55.5716815
                ],
                [
                    88.7985534,
                    55.5711595
                ],
                [
                    88.8004821,
                    55.5700226
                ],
                [
                    88.800554,
                    55.5698312
                ],
                [
                    88.7989638,
                    55.5689089
                ],
                [
                    88.7984303,
                    55.5689321
                ],
                [
                    88.7957629,
                    55.5685087
                ],
                [
                    88.7946448,
                    55.5670237
                ],
                [
                    88.795209,
                    55.566838
                ],
                [
                    88.7959579,
                    55.5664552
                ],
                [
                    88.7962759,
                    55.5658983
                ],
                [
                    88.7964709,
                    55.5650397
                ],
                [
                    88.7964195,
                    55.5643552
                ],
                [
                    88.7979378,
                    55.5635952
                ],
                [
                    88.7979995,
                    55.563369
                ],
                [
                    88.7935778,
                    55.5608743
                ],
                [
                    88.7932945,
                    55.5610118
                ],
                [
                    88.793176,
                    55.5609603
                ],
                [
                    88.7930637,
                    55.5608668
                ],
                [
                    88.7934484,
                    55.5605549
                ],
                [
                    88.7932945,
                    55.5602866
                ],
                [
                    88.7923199,
                    55.5597499
                ],
                [
                    88.7903707,
                    55.5591407
                ],
                [
                    88.7894474,
                    55.5586475
                ],
                [
                    88.7882804,
                    55.5593438
                ],
                [
                    88.7880367,
                    55.5592205
                ],
                [
                    88.7865492,
                    55.559148
                ],
                [
                    88.7843307,
                    55.5579368
                ],
                [
                    88.7836254,
                    55.5575451
                ],
                [
                    88.7829842,
                    55.5576031
                ],
                [
                    88.7821891,
                    55.5577482
                ],
                [
                    88.7815094,
                    55.5575451
                ],
                [
                    88.7807143,
                    55.5571462
                ],
                [
                    88.7737944,
                    55.5602035
                ],
                [
                    88.7723478,
                    55.5590895
                ],
                [
                    88.7711373,
                    55.5582598
                ],
                [
                    88.770573,
                    55.5581322
                ],
                [
                    88.7682135,
                    55.5578943
                ],
                [
                    88.7670337,
                    55.5576622
                ],
                [
                    88.7668489,
                    55.5578653
                ],
                [
                    88.7665627,
                    55.5579589
                ],
                [
                    88.7662344,
                    55.5581631
                ],
                [
                    88.7660949,
                    55.5584741
                ],
                [
                    88.7656928,
                    55.5585437
                ],
                [
                    88.7654055,
                    55.5586784
                ],
                [
                    88.7646833,
                    55.5592307
                ],
                [
                    88.7645354,
                    55.5595231
                ]
            ],
            "longitude": 88.78997,
            "latitude": 55.564251
        },
        "194": {
            "name": "Горячегорск",
            "population": 634,
            "type": "village",
            "poly": [
                [
                    88.8794914,
                    55.4114556
                ],
                [
                    88.8850352,
                    55.412043
                ],
                [
                    88.8880974,
                    55.4125345
                ],
                [
                    88.8887627,
                    55.4126245
                ],
                [
                    88.8901882,
                    55.4124866
                ],
                [
                    88.8910963,
                    55.4134696
                ],
                [
                    88.8909696,
                    55.4135416
                ],
                [
                    88.8908323,
                    55.4137693
                ],
                [
                    88.8925852,
                    55.4147044
                ],
                [
                    88.8925113,
                    55.4149801
                ],
                [
                    88.8922051,
                    55.4152798
                ],
                [
                    88.8942431,
                    55.4176713
                ],
                [
                    88.8989948,
                    55.4178751
                ],
                [
                    88.8992483,
                    55.4165924
                ],
                [
                    88.9002092,
                    55.4154177
                ],
                [
                    88.9009589,
                    55.4144527
                ],
                [
                    88.9010012,
                    55.4136614
                ],
                [
                    88.9011173,
                    55.4132958
                ],
                [
                    88.9014974,
                    55.4125465
                ],
                [
                    88.9022049,
                    55.4121149
                ],
                [
                    88.9033558,
                    55.4119291
                ],
                [
                    88.9067983,
                    55.4113057
                ],
                [
                    88.9069673,
                    55.4111319
                ],
                [
                    88.907189,
                    55.410928
                ],
                [
                    88.9077487,
                    55.4108681
                ],
                [
                    88.9092587,
                    55.4105504
                ],
                [
                    88.9098606,
                    55.4102866
                ],
                [
                    88.9145173,
                    55.4099809
                ],
                [
                    88.9150347,
                    55.4100588
                ],
                [
                    88.9156682,
                    55.4102327
                ],
                [
                    88.9163758,
                    55.4106463
                ],
                [
                    88.9176007,
                    55.410988
                ],
                [
                    88.919079,
                    55.4115635
                ],
                [
                    88.9197865,
                    55.4121449
                ],
                [
                    88.9200187,
                    55.4127144
                ],
                [
                    88.9174317,
                    55.4137813
                ],
                [
                    88.9201139,
                    55.4145186
                ],
                [
                    88.9249818,
                    55.4145605
                ],
                [
                    88.9251296,
                    55.4143328
                ],
                [
                    88.9251719,
                    55.414081
                ],
                [
                    88.9250663,
                    55.4138113
                ],
                [
                    88.9257432,
                    55.4126311
                ],
                [
                    88.9281975,
                    55.4120808
                ],
                [
                    88.9303424,
                    55.4117764
                ],
                [
                    88.9317654,
                    55.4120457
                ],
                [
                    88.9328845,
                    55.4123753
                ],
                [
                    88.9347565,
                    55.41175
                ],
                [
                    88.9367569,
                    55.4109021
                ],
                [
                    88.9372197,
                    55.4103942
                ],
                [
                    88.9377042,
                    55.41049
                ],
                [
                    88.9385224,
                    55.4100979
                ],
                [
                    88.9386254,
                    55.4100161
                ],
                [
                    88.9359481,
                    55.4094931
                ],
                [
                    88.9350918,
                    55.4090413
                ],
                [
                    88.9318046,
                    55.4070523
                ],
                [
                    88.9313937,
                    55.4069418
                ],
                [
                    88.9307493,
                    55.4069565
                ],
                [
                    88.9302965,
                    55.4066763
                ],
                [
                    88.9300642,
                    55.4063466
                ],
                [
                    88.9297897,
                    55.4056451
                ],
                [
                    88.9291456,
                    55.4051775
                ],
                [
                    88.9291877,
                    55.4046379
                ],
                [
                    88.9293567,
                    55.404494
                ],
                [
                    88.9297158,
                    55.4041043
                ],
                [
                    88.9302543,
                    55.4029112
                ],
                [
                    88.9303282,
                    55.4004948
                ],
                [
                    88.9236229,
                    55.4005068
                ],
                [
                    88.9227782,
                    55.4008666
                ],
                [
                    88.9222291,
                    55.400243
                ],
                [
                    88.9220073,
                    55.3997753
                ],
                [
                    88.9222282,
                    55.3924
                ],
                [
                    88.9222713,
                    55.3909599
                ],
                [
                    88.9216694,
                    55.3896105
                ],
                [
                    88.9208139,
                    55.3870713
                ],
                [
                    88.9204972,
                    55.3861316
                ],
                [
                    88.9204762,
                    55.3857537
                ],
                [
                    88.9204129,
                    55.3852559
                ],
                [
                    88.9202756,
                    55.3850519
                ],
                [
                    88.9199377,
                    55.384908
                ],
                [
                    88.9192196,
                    55.384776
                ],
                [
                    88.9173084,
                    55.3844881
                ],
                [
                    88.917773,
                    55.3834263
                ],
                [
                    88.9117963,
                    55.3824425
                ],
                [
                    88.9082694,
                    55.3820406
                ],
                [
                    88.9064674,
                    55.3829071
                ],
                [
                    88.8950829,
                    55.3806575
                ],
                [
                    88.8903806,
                    55.3791225
                ],
                [
                    88.8880915,
                    55.3795233
                ],
                [
                    88.8852701,
                    55.3817074
                ],
                [
                    88.8869531,
                    55.3822323
                ],
                [
                    88.8893289,
                    55.3821573
                ],
                [
                    88.8911934,
                    55.3829634
                ],
                [
                    88.8923317,
                    55.3839382
                ],
                [
                    88.8936352,
                    55.3847442
                ],
                [
                    88.8937672,
                    55.3855784
                ],
                [
                    88.8941962,
                    55.3862532
                ],
                [
                    88.8993605,
                    55.389196
                ],
                [
                    88.9001359,
                    55.3891491
                ],
                [
                    88.9003503,
                    55.3889804
                ],
                [
                    88.9003503,
                    55.3888305
                ],
                [
                    88.9008619,
                    55.3888211
                ],
                [
                    88.9009609,
                    55.389046
                ],
                [
                    88.9015384,
                    55.3892053
                ],
                [
                    88.9022313,
                    55.3892241
                ],
                [
                    88.9024788,
                    55.3892147
                ],
                [
                    88.9025613,
                    55.3896177
                ],
                [
                    88.9031058,
                    55.389777
                ],
                [
                    88.9035018,
                    55.3900488
                ],
                [
                    88.9034298,
                    55.3901877
                ],
                [
                    88.9036621,
                    55.3903916
                ],
                [
                    88.9041479,
                    55.3904036
                ],
                [
                    88.9048765,
                    55.3903376
                ],
                [
                    88.9050242,
                    55.3904336
                ],
                [
                    88.9053411,
                    55.3905355
                ],
                [
                    88.9053517,
                    55.3906915
                ],
                [
                    88.9051827,
                    55.3908054
                ],
                [
                    88.9054467,
                    55.3909554
                ],
                [
                    88.9060169,
                    55.3910273
                ],
                [
                    88.9068511,
                    55.3908354
                ],
                [
                    88.9072841,
                    55.3905535
                ],
                [
                    88.9080338,
                    55.3907334
                ],
                [
                    88.9083506,
                    55.3916451
                ],
                [
                    88.907981,
                    55.3948356
                ],
                [
                    88.9079915,
                    55.395819
                ],
                [
                    88.9085512,
                    55.3970064
                ],
                [
                    88.9096705,
                    55.3989073
                ],
                [
                    88.8971047,
                    55.4010839
                ],
                [
                    88.8950033,
                    55.4012637
                ],
                [
                    88.8928703,
                    55.4012278
                ],
                [
                    88.8909696,
                    55.4009819
                ],
                [
                    88.8895652,
                    55.4004843
                ],
                [
                    88.8894702,
                    55.3998727
                ],
                [
                    88.8872316,
                    55.3996568
                ],
                [
                    88.8864185,
                    55.3999146
                ],
                [
                    88.8857638,
                    55.4004963
                ],
                [
                    88.8840109,
                    55.4029905
                ],
                [
                    88.883409,
                    55.403686
                ],
                [
                    88.8822158,
                    55.4054907
                ],
                [
                    88.8794914,
                    55.4114556
                ]
            ],
            "longitude": 88.915428,
            "latitude": 55.405281
        },
        "195": {
            "name": "Поваренкино",
            "population": 281,
            "type": "village",
            "poly": [
                [
                    88.939268,
                    57.0587713
                ],
                [
                    88.9399481,
                    57.0591296
                ],
                [
                    88.9394168,
                    57.0597537
                ],
                [
                    88.9396499,
                    57.0600763
                ],
                [
                    88.9425059,
                    57.0630738
                ],
                [
                    88.9425391,
                    57.0650419
                ],
                [
                    88.9398822,
                    57.0661253
                ],
                [
                    88.9396831,
                    57.0671905
                ],
                [
                    88.9426387,
                    57.0698986
                ],
                [
                    88.9460261,
                    57.0711262
                ],
                [
                    88.9453951,
                    57.07174
                ],
                [
                    88.9456276,
                    57.0733285
                ],
                [
                    88.9467899,
                    57.0730036
                ],
                [
                    88.9512732,
                    57.0729494
                ],
                [
                    88.9539964,
                    57.0738159
                ],
                [
                    88.9561882,
                    57.0734729
                ],
                [
                    88.9591771,
                    57.0744477
                ],
                [
                    88.9587121,
                    57.0750073
                ],
                [
                    88.964889,
                    57.0776606
                ],
                [
                    88.964557,
                    57.0782021
                ],
                [
                    88.9665828,
                    57.0785812
                ],
                [
                    88.9683429,
                    57.0784729
                ],
                [
                    88.9686418,
                    57.0784187
                ],
                [
                    88.967878,
                    57.0767221
                ],
                [
                    88.9690071,
                    57.0763972
                ],
                [
                    88.9684757,
                    57.075621
                ],
                [
                    88.9690071,
                    57.07526
                ],
                [
                    88.9680673,
                    57.0746826
                ],
                [
                    88.9676423,
                    57.0742898
                ],
                [
                    88.9678123,
                    57.0735966
                ],
                [
                    88.9685987,
                    57.0732847
                ],
                [
                    88.969555,
                    57.0732616
                ],
                [
                    88.9701928,
                    57.0728919
                ],
                [
                    88.9685349,
                    57.072268
                ],
                [
                    88.967536,
                    57.0727533
                ],
                [
                    88.9671958,
                    57.072707
                ],
                [
                    88.9671109,
                    57.0723489
                ],
                [
                    88.9675147,
                    57.0720601
                ],
                [
                    88.9647516,
                    57.0713322
                ],
                [
                    88.9628175,
                    57.0714939
                ],
                [
                    88.9608834,
                    57.0702924
                ],
                [
                    88.959842,
                    57.0707314
                ],
                [
                    88.9568239,
                    57.0708585
                ],
                [
                    88.9595444,
                    57.0692294
                ],
                [
                    88.9590981,
                    57.068929
                ],
                [
                    88.9566326,
                    57.0692987
                ],
                [
                    88.9536783,
                    57.0681317
                ],
                [
                    88.9535083,
                    57.0676695
                ],
                [
                    88.9543797,
                    57.0676464
                ],
                [
                    88.9549961,
                    57.0678082
                ],
                [
                    88.9552511,
                    57.0675309
                ],
                [
                    88.9538696,
                    57.0661789
                ],
                [
                    88.9551873,
                    57.0652314
                ],
                [
                    88.954571,
                    57.0647229
                ],
                [
                    88.9532957,
                    57.0643416
                ],
                [
                    88.9532745,
                    57.063706
                ],
                [
                    88.9499163,
                    57.0621113
                ],
                [
                    88.9491087,
                    57.0621922
                ],
                [
                    88.947132,
                    57.0610249
                ],
                [
                    88.9483434,
                    57.0601004
                ],
                [
                    88.9472171,
                    57.0595919
                ],
                [
                    88.9450491,
                    57.0590833
                ],
                [
                    88.9450279,
                    57.0587366
                ],
                [
                    88.946388,
                    57.0590024
                ],
                [
                    88.9467707,
                    57.0587135
                ],
                [
                    88.9464519,
                    57.0584592
                ],
                [
                    88.9431788,
                    57.0574653
                ],
                [
                    88.9435188,
                    57.0563557
                ],
                [
                    88.9445178,
                    57.0561707
                ],
                [
                    88.9444752,
                    57.0559165
                ],
                [
                    88.9434126,
                    57.0560089
                ],
                [
                    88.9422861,
                    57.0557778
                ],
                [
                    88.939438,
                    57.0569798
                ],
                [
                    88.9399481,
                    57.0582281
                ],
                [
                    88.940692,
                    57.0586326
                ],
                [
                    88.940437,
                    57.0589215
                ],
                [
                    88.9395443,
                    57.0585286
                ],
                [
                    88.939268,
                    57.0587713
                ]
            ],
            "longitude": 88.950058,
            "latitude": 57.067268
        },
        "196": {
            "name": "Двинка",
            "population": 346,
            "type": "village",
            "poly": [
                [
                    88.9570155,
                    56.4792294
                ],
                [
                    88.9581616,
                    56.4831909
                ],
                [
                    88.9589681,
                    56.4829565
                ],
                [
                    88.9605388,
                    56.4840113
                ],
                [
                    88.9646139,
                    56.4843629
                ],
                [
                    88.9666939,
                    56.4857223
                ],
                [
                    88.9669061,
                    56.4866832
                ],
                [
                    88.9692408,
                    56.488066
                ],
                [
                    88.973146,
                    56.4899175
                ],
                [
                    88.9674579,
                    56.4916048
                ],
                [
                    88.9688163,
                    56.4931748
                ],
                [
                    88.9758204,
                    56.4907143
                ],
                [
                    88.9776881,
                    56.4916751
                ],
                [
                    88.9798955,
                    56.4913001
                ],
                [
                    88.9814236,
                    56.4913001
                ],
                [
                    88.9833763,
                    56.48973
                ],
                [
                    88.9830367,
                    56.4887691
                ],
                [
                    88.9849045,
                    56.4864254
                ],
                [
                    88.9854563,
                    56.4855348
                ],
                [
                    88.9806171,
                    56.4829331
                ],
                [
                    88.9760326,
                    56.4827924
                ],
                [
                    88.9728065,
                    56.479792
                ],
                [
                    88.970769,
                    56.4787137
                ],
                [
                    88.9669909,
                    56.4783855
                ],
                [
                    88.9641894,
                    56.4760177
                ],
                [
                    88.9629583,
                    56.4777057
                ],
                [
                    88.9606661,
                    56.4772602
                ],
                [
                    88.9601567,
                    56.4777525
                ],
                [
                    88.9584587,
                    56.4780573
                ],
                [
                    88.9583739,
                    56.4787371
                ],
                [
                    88.9570155,
                    56.4792294
                ]
            ],
            "longitude": 88.971016,
            "latitude": 56.483829
        },
        "197": {
            "name": "Безымянка",
            "population": 316,
            "type": "village",
            "poly": null,
            "longitude": 89.0004938,
            "latitude": 59.305684
        },
        "198": {
            "name": "Верх-Четск",
            "population": 230,
            "type": "village",
            "poly": [
                [
                    89.0572305,
                    56.923378
                ],
                [
                    89.0585268,
                    56.9245099
                ],
                [
                    89.0583786,
                    56.9254599
                ],
                [
                    89.057749,
                    56.9265311
                ],
                [
                    89.0584898,
                    56.9269353
                ],
                [
                    89.0605638,
                    56.9268342
                ],
                [
                    89.0636007,
                    56.9263492
                ],
                [
                    89.0644896,
                    56.9270363
                ],
                [
                    89.0640822,
                    56.9283096
                ],
                [
                    89.0624526,
                    56.9283702
                ],
                [
                    89.0643044,
                    56.9286127
                ],
                [
                    89.0653414,
                    56.9290776
                ],
                [
                    89.0651562,
                    56.9294211
                ],
                [
                    89.0658969,
                    56.9294211
                ],
                [
                    89.0666746,
                    56.9287946
                ],
                [
                    89.070082,
                    56.9274001
                ],
                [
                    89.0700449,
                    56.9269555
                ],
                [
                    89.0686746,
                    56.9266321
                ],
                [
                    89.0691931,
                    56.9256216
                ],
                [
                    89.0700078,
                    56.9252578
                ],
                [
                    89.069826,
                    56.9250668
                ],
                [
                    89.069045,
                    56.9242472
                ],
                [
                    89.0694524,
                    56.9237216
                ],
                [
                    89.0684524,
                    56.9224887
                ],
                [
                    89.0684894,
                    56.9217812
                ],
                [
                    89.067008,
                    56.9210333
                ],
                [
                    89.0676006,
                    56.9208918
                ],
                [
                    89.068008,
                    56.9207301
                ],
                [
                    89.0678968,
                    56.9200226
                ],
                [
                    89.0688228,
                    56.9195981
                ],
                [
                    89.0634526,
                    56.9183043
                ],
                [
                    89.0627859,
                    56.9186277
                ],
                [
                    89.0625637,
                    56.9201034
                ],
                [
                    89.0614526,
                    56.9205886
                ],
                [
                    89.0596749,
                    56.9204673
                ],
                [
                    89.0589712,
                    56.9208918
                ],
                [
                    89.0593045,
                    56.9216599
                ],
                [
                    89.0575268,
                    56.9228323
                ],
                [
                    89.0572305,
                    56.923378
                ]
            ],
            "longitude": 89.064262,
            "latitude": 56.922562
        },
        "199": {
            "name": "Дубинино",
            "population": 399,
            "type": "village",
            "poly": [
                [
                    89.0780663,
                    55.6731287
                ],
                [
                    89.0783223,
                    55.6736839
                ],
                [
                    89.0790904,
                    55.6738838
                ],
                [
                    89.0803114,
                    55.674217
                ],
                [
                    89.08104,
                    55.6745279
                ],
                [
                    89.0821231,
                    55.6746056
                ],
                [
                    89.083226,
                    55.674861
                ],
                [
                    89.0838955,
                    55.6751387
                ],
                [
                    89.0852936,
                    55.6751498
                ],
                [
                    89.0867904,
                    55.6747944
                ],
                [
                    89.0871449,
                    55.674861
                ],
                [
                    89.0883659,
                    55.6747056
                ],
                [
                    89.0889567,
                    55.6747056
                ],
                [
                    89.089961,
                    55.6751609
                ],
                [
                    89.0905715,
                    55.6752053
                ],
                [
                    89.0909654,
                    55.6750054
                ],
                [
                    89.091694,
                    55.6752719
                ],
                [
                    89.0921076,
                    55.6749277
                ],
                [
                    89.0927772,
                    55.674639
                ],
                [
                    89.0939982,
                    55.6746056
                ],
                [
                    89.0956524,
                    55.6738616
                ],
                [
                    89.0978186,
                    55.6722958
                ],
                [
                    89.0993941,
                    55.6727511
                ],
                [
                    89.1000834,
                    55.6733397
                ],
                [
                    89.1005954,
                    55.6740948
                ],
                [
                    89.101895,
                    55.6749721
                ],
                [
                    89.1038841,
                    55.6751054
                ],
                [
                    89.1053805,
                    55.6753431
                ],
                [
                    89.1076019,
                    55.6759649
                ],
                [
                    89.1087047,
                    55.6768799
                ],
                [
                    89.1095555,
                    55.678923
                ],
                [
                    89.1110049,
                    55.6784345
                ],
                [
                    89.1131002,
                    55.6780436
                ],
                [
                    89.1144551,
                    55.6780081
                ],
                [
                    89.1139982,
                    55.6775195
                ],
                [
                    89.1143921,
                    55.6770753
                ],
                [
                    89.1148332,
                    55.6768355
                ],
                [
                    89.1150223,
                    55.676489
                ],
                [
                    89.1159045,
                    55.6759471
                ],
                [
                    89.1168498,
                    55.6755296
                ],
                [
                    89.1171964,
                    55.6751831
                ],
                [
                    89.1170704,
                    55.6745524
                ],
                [
                    89.1171176,
                    55.6740194
                ],
                [
                    89.1173067,
                    55.6734152
                ],
                [
                    89.1173697,
                    55.6727667
                ],
                [
                    89.1171176,
                    55.6723758
                ],
                [
                    89.1166135,
                    55.6721448
                ],
                [
                    89.1155263,
                    55.6721004
                ],
                [
                    89.1145969,
                    55.6718516
                ],
                [
                    89.113951,
                    55.671283
                ],
                [
                    89.1136674,
                    55.6707321
                ],
                [
                    89.1139352,
                    55.670279
                ],
                [
                    89.1149435,
                    55.6696393
                ],
                [
                    89.1152586,
                    55.6691773
                ],
                [
                    89.1153216,
                    55.6682532
                ],
                [
                    89.1155579,
                    55.6677467
                ],
                [
                    89.1155263,
                    55.6673025
                ],
                [
                    89.1151326,
                    55.6667871
                ],
                [
                    89.1147072,
                    55.6660674
                ],
                [
                    89.1147545,
                    55.665392
                ],
                [
                    89.1150538,
                    55.6651254
                ],
                [
                    89.1151956,
                    55.6648766
                ],
                [
                    89.1153374,
                    55.6643612
                ],
                [
                    89.1157312,
                    55.6641302
                ],
                [
                    89.1156637,
                    55.6640259
                ],
                [
                    89.1153592,
                    55.6639211
                ],
                [
                    89.1145642,
                    55.6637959
                ],
                [
                    89.1141305,
                    55.663694
                ],
                [
                    89.1141522,
                    55.6636283
                ],
                [
                    89.1146721,
                    55.6635839
                ],
                [
                    89.1147194,
                    55.6627752
                ],
                [
                    89.1144673,
                    55.662713
                ],
                [
                    89.1145145,
                    55.6624286
                ],
                [
                    89.1131754,
                    55.6621976
                ],
                [
                    89.1132384,
                    55.6620554
                ],
                [
                    89.1129391,
                    55.6620021
                ],
                [
                    89.1129548,
                    55.6618688
                ],
                [
                    89.1125767,
                    55.6617355
                ],
                [
                    89.112561,
                    55.6610512
                ],
                [
                    89.112167,
                    55.6610867
                ],
                [
                    89.1120883,
                    55.6612822
                ],
                [
                    89.1112533,
                    55.6611934
                ],
                [
                    89.1111746,
                    55.6615044
                ],
                [
                    89.1109698,
                    55.6615844
                ],
                [
                    89.1110485,
                    55.6619665
                ],
                [
                    89.1103553,
                    55.6619932
                ],
                [
                    89.1102293,
                    55.6621354
                ],
                [
                    89.1091895,
                    55.6621531
                ],
                [
                    89.1089217,
                    55.6624553
                ],
                [
                    89.1090792,
                    55.6625264
                ],
                [
                    89.1087326,
                    55.6627308
                ],
                [
                    89.1087011,
                    55.6630418
                ],
                [
                    89.1082915,
                    55.662873
                ],
                [
                    89.1075668,
                    55.6628019
                ],
                [
                    89.1061174,
                    55.6631573
                ],
                [
                    89.1058338,
                    55.663575
                ],
                [
                    89.1031239,
                    55.6630063
                ],
                [
                    89.1024465,
                    55.6636105
                ],
                [
                    89.0999888,
                    55.6631218
                ],
                [
                    89.0993271,
                    55.6639749
                ],
                [
                    89.0995162,
                    55.6642859
                ],
                [
                    89.1007293,
                    55.6650856
                ],
                [
                    89.1000834,
                    55.6658498
                ],
                [
                    89.1003512,
                    55.6663652
                ],
                [
                    89.1008081,
                    55.6666407
                ],
                [
                    89.0996265,
                    55.6674226
                ],
                [
                    89.0962853,
                    55.6667545
                ],
                [
                    89.0961605,
                    55.6667295
                ],
                [
                    89.0960029,
                    55.6667917
                ],
                [
                    89.0936712,
                    55.665841
                ],
                [
                    89.0916074,
                    55.6679202
                ],
                [
                    89.0943172,
                    55.6690842
                ],
                [
                    89.0920879,
                    55.6707299
                ],
                [
                    89.0904731,
                    55.6718737
                ],
                [
                    89.0874994,
                    55.6728621
                ],
                [
                    89.0860421,
                    55.6724623
                ],
                [
                    89.0852544,
                    55.6726178
                ],
                [
                    89.0840728,
                    55.6723735
                ],
                [
                    89.0828518,
                    55.6723624
                ],
                [
                    89.0817687,
                    55.6725512
                ],
                [
                    89.0812368,
                    55.6723624
                ],
                [
                    89.0808628,
                    55.6724957
                ],
                [
                    89.0804886,
                    55.6731287
                ],
                [
                    89.0788541,
                    55.6727955
                ],
                [
                    89.0780663,
                    55.6731287
                ]
            ],
            "longitude": 89.109779,
            "latitude": 55.670662
        },
        "200": {
            "name": "Холмогорское",
            "population": 2028,
            "type": "village",
            "poly": [
                [
                    89.0932979,
                    55.4529001
                ],
                [
                    89.1001257,
                    55.4588787
                ],
                [
                    89.1007921,
                    55.4593856
                ],
                [
                    89.1020995,
                    55.4601891
                ],
                [
                    89.1012054,
                    55.4603947
                ],
                [
                    89.1002752,
                    55.4608409
                ],
                [
                    89.0978027,
                    55.4622274
                ],
                [
                    89.0973276,
                    55.4631456
                ],
                [
                    89.0964855,
                    55.4641769
                ],
                [
                    89.0954868,
                    55.464532
                ],
                [
                    89.1005725,
                    55.4663753
                ],
                [
                    89.1018955,
                    55.4651366
                ],
                [
                    89.1028077,
                    55.4640073
                ],
                [
                    89.1024731,
                    55.4638236
                ],
                [
                    89.1035528,
                    55.4629606
                ],
                [
                    89.1051723,
                    55.4623668
                ],
                [
                    89.1057499,
                    55.4620975
                ],
                [
                    89.1186268,
                    55.4677529
                ],
                [
                    89.1197339,
                    55.4681414
                ],
                [
                    89.1227177,
                    55.4698866
                ],
                [
                    89.1236245,
                    55.4710042
                ],
                [
                    89.1247209,
                    55.4720023
                ],
                [
                    89.1263553,
                    55.4734963
                ],
                [
                    89.1289912,
                    55.4750919
                ],
                [
                    89.1243836,
                    55.4776435
                ],
                [
                    89.1258176,
                    55.4784382
                ],
                [
                    89.1261128,
                    55.4789939
                ],
                [
                    89.1264185,
                    55.4791253
                ],
                [
                    89.1250584,
                    55.4799977
                ],
                [
                    89.1250795,
                    55.4807744
                ],
                [
                    89.1244363,
                    55.4812285
                ],
                [
                    89.1252904,
                    55.4816348
                ],
                [
                    89.1266687,
                    55.482209
                ],
                [
                    89.1271242,
                    55.4817071
                ],
                [
                    89.1317576,
                    55.4804623
                ],
                [
                    89.1341721,
                    55.4816274
                ],
                [
                    89.1355533,
                    55.4811255
                ],
                [
                    89.1429722,
                    55.4794948
                ],
                [
                    89.1427086,
                    55.4776275
                ],
                [
                    89.1424054,
                    55.4770524
                ],
                [
                    89.1411928,
                    55.4758946
                ],
                [
                    89.1410347,
                    55.4748862
                ],
                [
                    89.1417247,
                    55.4745694
                ],
                [
                    89.1417787,
                    55.4741028
                ],
                [
                    89.14161,
                    55.4738963
                ],
                [
                    89.1419204,
                    55.4736974
                ],
                [
                    89.1428111,
                    55.4736286
                ],
                [
                    89.1437423,
                    55.4733953
                ],
                [
                    89.144019,
                    55.4731964
                ],
                [
                    89.1439043,
                    55.4729784
                ],
                [
                    89.1434656,
                    55.4728407
                ],
                [
                    89.1431485,
                    55.4726686
                ],
                [
                    89.14327,
                    55.4725041
                ],
                [
                    89.1435062,
                    55.4722823
                ],
                [
                    89.1437761,
                    55.4721484
                ],
                [
                    89.1441675,
                    55.4721522
                ],
                [
                    89.144262,
                    55.4723396
                ],
                [
                    89.1440528,
                    55.472527
                ],
                [
                    89.1445724,
                    55.4727336
                ],
                [
                    89.1454294,
                    55.4727298
                ],
                [
                    89.1457263,
                    55.4723511
                ],
                [
                    89.1456048,
                    55.472156
                ],
                [
                    89.1458207,
                    55.4718998
                ],
                [
                    89.1461716,
                    55.4718424
                ],
                [
                    89.1466777,
                    55.4719724
                ],
                [
                    89.1473593,
                    55.4720413
                ],
                [
                    89.1481151,
                    55.4720566
                ],
                [
                    89.1486009,
                    55.4719686
                ],
                [
                    89.1487494,
                    55.4717468
                ],
                [
                    89.1479059,
                    55.4714293
                ],
                [
                    89.1473746,
                    55.4711025
                ],
                [
                    89.1472278,
                    55.4707574
                ],
                [
                    89.1467743,
                    55.4705468
                ],
                [
                    89.1466448,
                    55.4702335
                ],
                [
                    89.1463554,
                    55.4701845
                ],
                [
                    89.1460185,
                    55.4702482
                ],
                [
                    89.1456774,
                    55.4702482
                ],
                [
                    89.1456385,
                    55.4701086
                ],
                [
                    89.1458284,
                    55.4699128
                ],
                [
                    89.1461654,
                    55.4698761
                ],
                [
                    89.1464591,
                    55.46969
                ],
                [
                    89.1464866,
                    55.4696414
                ],
                [
                    89.1418896,
                    55.4675949
                ],
                [
                    89.1418962,
                    55.4675037
                ],
                [
                    89.1419486,
                    55.4673797
                ],
                [
                    89.1428343,
                    55.4671359
                ],
                [
                    89.143973,
                    55.4664473
                ],
                [
                    89.1458793,
                    55.4655531
                ],
                [
                    89.1454576,
                    55.4649458
                ],
                [
                    89.1449009,
                    55.4646685
                ],
                [
                    89.1444622,
                    55.4644724
                ],
                [
                    89.1443526,
                    55.4643577
                ],
                [
                    89.1443104,
                    55.4640755
                ],
                [
                    89.1448418,
                    55.4639321
                ],
                [
                    89.1455588,
                    55.4638651
                ],
                [
                    89.1465963,
                    55.4634108
                ],
                [
                    89.1471699,
                    55.4631
                ],
                [
                    89.147482,
                    55.462837
                ],
                [
                    89.1473807,
                    55.4624066
                ],
                [
                    89.1478109,
                    55.462177
                ],
                [
                    89.1479628,
                    55.4617658
                ],
                [
                    89.1473807,
                    55.4612254
                ],
                [
                    89.1470602,
                    55.461058
                ],
                [
                    89.1468998,
                    55.461015
                ],
                [
                    89.1468156,
                    55.4608476
                ],
                [
                    89.1469759,
                    55.4606132
                ],
                [
                    89.1475747,
                    55.4603263
                ],
                [
                    89.1483676,
                    55.4602546
                ],
                [
                    89.1486713,
                    55.4602354
                ],
                [
                    89.1486713,
                    55.4601446
                ],
                [
                    89.1485701,
                    55.4600489
                ],
                [
                    89.1478278,
                    55.4597811
                ],
                [
                    89.147406,
                    55.4591785
                ],
                [
                    89.1472795,
                    55.4588437
                ],
                [
                    89.1473807,
                    55.4585137
                ],
                [
                    89.1474904,
                    55.4584181
                ],
                [
                    89.1473892,
                    55.4581741
                ],
                [
                    89.1470096,
                    55.4580689
                ],
                [
                    89.1468662,
                    55.4577915
                ],
                [
                    89.1470686,
                    55.4572558
                ],
                [
                    89.1471952,
                    55.457098
                ],
                [
                    89.1476085,
                    55.4569497
                ],
                [
                    89.1478194,
                    55.4565432
                ],
                [
                    89.1477891,
                    55.4563413
                ],
                [
                    89.1473779,
                    55.4560184
                ],
                [
                    89.1474982,
                    55.4558193
                ],
                [
                    89.1475111,
                    55.4556087
                ],
                [
                    89.1472995,
                    55.4554372
                ],
                [
                    89.1471095,
                    55.4554054
                ],
                [
                    89.1466474,
                    55.455447
                ],
                [
                    89.1465006,
                    55.4553687
                ],
                [
                    89.1460817,
                    55.4553883
                ],
                [
                    89.1459607,
                    55.4553466
                ],
                [
                    89.1459002,
                    55.4550748
                ],
                [
                    89.1454252,
                    55.4549352
                ],
                [
                    89.1446047,
                    55.4552634
                ],
                [
                    89.1442894,
                    55.4552217
                ],
                [
                    89.1441123,
                    55.4547834
                ],
                [
                    89.143607,
                    55.4546144
                ],
                [
                    89.1429592,
                    55.4544919
                ],
                [
                    89.1426137,
                    55.453963
                ],
                [
                    89.1425619,
                    55.4533115
                ],
                [
                    89.1422294,
                    55.4530225
                ],
                [
                    89.1423244,
                    55.4526797
                ],
                [
                    89.1429895,
                    55.4522756
                ],
                [
                    89.1430024,
                    55.4518984
                ],
                [
                    89.1392726,
                    55.4517429
                ],
                [
                    89.1369794,
                    55.4515337
                ],
                [
                    89.1352265,
                    55.4511002
                ],
                [
                    89.1337372,
                    55.4505769
                ],
                [
                    89.1220996,
                    55.4456809
                ],
                [
                    89.1213615,
                    55.445367
                ],
                [
                    89.1215566,
                    55.4452079
                ],
                [
                    89.1141121,
                    55.4420702
                ],
                [
                    89.1138962,
                    55.4420794
                ],
                [
                    89.1131135,
                    55.4418467
                ],
                [
                    89.112795,
                    55.4418253
                ],
                [
                    89.1123631,
                    55.4420702
                ],
                [
                    89.112212,
                    55.4424346
                ],
                [
                    89.1120715,
                    55.4427041
                ],
                [
                    89.1122714,
                    55.4431879
                ],
                [
                    89.1115912,
                    55.443044
                ],
                [
                    89.111521,
                    55.4438095
                ],
                [
                    89.0978163,
                    55.4403069
                ],
                [
                    89.0955058,
                    55.4398139
                ],
                [
                    89.0954735,
                    55.4403253
                ],
                [
                    89.0950632,
                    55.4410939
                ],
                [
                    89.0937244,
                    55.4413205
                ],
                [
                    89.0946691,
                    55.4427138
                ],
                [
                    89.0959755,
                    55.442478
                ],
                [
                    89.0967637,
                    55.4427689
                ],
                [
                    89.0974115,
                    55.4437151
                ],
                [
                    89.0972225,
                    55.4447317
                ],
                [
                    89.0967852,
                    55.4455247
                ],
                [
                    89.0972549,
                    55.4473189
                ],
                [
                    89.0965693,
                    55.4479252
                ],
                [
                    89.0967366,
                    55.4483783
                ],
                [
                    89.0974923,
                    55.4489661
                ],
                [
                    89.0974762,
                    55.4498081
                ],
                [
                    89.0971254,
                    55.4506408
                ],
                [
                    89.0962238,
                    55.4505796
                ],
                [
                    89.0952575,
                    55.4508796
                ],
                [
                    89.0946691,
                    55.4515042
                ],
                [
                    89.0945341,
                    55.4518409
                ],
                [
                    89.0945719,
                    55.4522603
                ],
                [
                    89.0941778,
                    55.452444
                ],
                [
                    89.0941239,
                    55.4527654
                ],
                [
                    89.0938053,
                    55.4528144
                ],
                [
                    89.093611,
                    55.4529093
                ],
                [
                    89.0932979,
                    55.4529001
                ]
            ],
            "longitude": 89.131393,
            "latitude": 55.46183
        },
        "201": {
            "name": "Береш",
            "population": 438,
            "type": "village",
            "poly": [
                [
                    89.1368911,
                    55.4914145
                ],
                [
                    89.1369342,
                    55.4915001
                ],
                [
                    89.1371773,
                    55.4916805
                ],
                [
                    89.13735,
                    55.4916775
                ],
                [
                    89.1376361,
                    55.4915643
                ],
                [
                    89.1381868,
                    55.4916163
                ],
                [
                    89.1383055,
                    55.4917601
                ],
                [
                    89.1381706,
                    55.4918793
                ],
                [
                    89.13796,
                    55.4920689
                ],
                [
                    89.1379276,
                    55.4924206
                ],
                [
                    89.138122,
                    55.4927999
                ],
                [
                    89.1384891,
                    55.4930292
                ],
                [
                    89.1393798,
                    55.4933412
                ],
                [
                    89.1400438,
                    55.4936348
                ],
                [
                    89.1400546,
                    55.4937571
                ],
                [
                    89.1415985,
                    55.4938458
                ],
                [
                    89.1423381,
                    55.4942127
                ],
                [
                    89.1429643,
                    55.4937724
                ],
                [
                    89.1429967,
                    55.4936409
                ],
                [
                    89.1441574,
                    55.492962
                ],
                [
                    89.1447565,
                    55.4934207
                ],
                [
                    89.1453018,
                    55.4937785
                ],
                [
                    89.1466946,
                    55.4943687
                ],
                [
                    89.1478499,
                    55.4950384
                ],
                [
                    89.1481198,
                    55.4950354
                ],
                [
                    89.1483303,
                    55.4949253
                ],
                [
                    89.1484923,
                    55.4946562
                ],
                [
                    89.1486272,
                    55.4942189
                ],
                [
                    89.1487892,
                    55.4940415
                ],
                [
                    89.148692,
                    55.4938274
                ],
                [
                    89.1487784,
                    55.4936378
                ],
                [
                    89.1492534,
                    55.4931546
                ],
                [
                    89.1502845,
                    55.4925552
                ],
                [
                    89.1511753,
                    55.4920751
                ],
                [
                    89.1516179,
                    55.4919252
                ],
                [
                    89.1512939,
                    55.4918702
                ],
                [
                    89.1505652,
                    55.4916867
                ],
                [
                    89.1489835,
                    55.4914328
                ],
                [
                    89.1481668,
                    55.4911466
                ],
                [
                    89.1479103,
                    55.4909593
                ],
                [
                    89.1479036,
                    55.4907452
                ],
                [
                    89.1480723,
                    55.4901756
                ],
                [
                    89.1479373,
                    55.4899883
                ],
                [
                    89.1480925,
                    55.4896901
                ],
                [
                    89.1481465,
                    55.489583
                ],
                [
                    89.148349,
                    55.4895868
                ],
                [
                    89.1484569,
                    55.489648
                ],
                [
                    89.1484299,
                    55.4897168
                ],
                [
                    89.1487201,
                    55.4898009
                ],
                [
                    89.1492937,
                    55.4896748
                ],
                [
                    89.1501507,
                    55.4896289
                ],
                [
                    89.1503531,
                    55.4897015
                ],
                [
                    89.1510009,
                    55.4896212
                ],
                [
                    89.1514395,
                    55.4898544
                ],
                [
                    89.1518579,
                    55.4900035
                ],
                [
                    89.1524855,
                    55.4899921
                ],
                [
                    89.1531332,
                    55.4898315
                ],
                [
                    89.1537473,
                    55.4893077
                ],
                [
                    89.1543209,
                    55.4892275
                ],
                [
                    89.1545234,
                    55.4891548
                ],
                [
                    89.1548743,
                    55.4891166
                ],
                [
                    89.1551104,
                    55.4889942
                ],
                [
                    89.1550362,
                    55.4886922
                ],
                [
                    89.1551307,
                    55.4886005
                ],
                [
                    89.1555963,
                    55.4885852
                ],
                [
                    89.1559134,
                    55.4887572
                ],
                [
                    89.1561496,
                    55.4889331
                ],
                [
                    89.1563993,
                    55.4889331
                ],
                [
                    89.1567367,
                    55.4888451
                ],
                [
                    89.1571618,
                    55.4885852
                ],
                [
                    89.1592536,
                    55.487939
                ],
                [
                    89.1594831,
                    55.4879696
                ],
                [
                    89.1598947,
                    55.487832
                ],
                [
                    89.1602389,
                    55.4878396
                ],
                [
                    89.1609407,
                    55.4877441
                ],
                [
                    89.1610554,
                    55.4876294
                ],
                [
                    89.1609947,
                    55.4875758
                ],
                [
                    89.1606708,
                    55.4874764
                ],
                [
                    89.160691,
                    55.4872585
                ],
                [
                    89.1605425,
                    55.4871209
                ],
                [
                    89.1609339,
                    55.4870482
                ],
                [
                    89.1610756,
                    55.4868838
                ],
                [
                    89.1608125,
                    55.4867309
                ],
                [
                    89.1611499,
                    55.4865665
                ],
                [
                    89.1618247,
                    55.4865588
                ],
                [
                    89.1627289,
                    55.4864288
                ],
                [
                    89.163235,
                    55.4864403
                ],
                [
                    89.1638221,
                    55.4866315
                ],
                [
                    89.1644766,
                    55.4866926
                ],
                [
                    89.1649556,
                    55.4865512
                ],
                [
                    89.1643686,
                    55.4854883
                ],
                [
                    89.1637073,
                    55.4846968
                ],
                [
                    89.1634522,
                    55.4844295
                ],
                [
                    89.1559607,
                    55.4765785
                ],
                [
                    89.1557717,
                    55.4762687
                ],
                [
                    89.1556368,
                    55.4757715
                ],
                [
                    89.1563998,
                    55.4736338
                ],
                [
                    89.1513326,
                    55.4715826
                ],
                [
                    89.1512562,
                    55.4716282
                ],
                [
                    89.1507812,
                    55.471417
                ],
                [
                    89.1497663,
                    55.4718576
                ],
                [
                    89.1494802,
                    55.4724482
                ],
                [
                    89.1497771,
                    55.4728949
                ],
                [
                    89.149966,
                    55.4730999
                ],
                [
                    89.1497339,
                    55.473256
                ],
                [
                    89.1493398,
                    55.4733814
                ],
                [
                    89.1493722,
                    55.4738404
                ],
                [
                    89.1496583,
                    55.4739934
                ],
                [
                    89.1505544,
                    55.4738679
                ],
                [
                    89.1508298,
                    55.4739505
                ],
                [
                    89.1511213,
                    55.4742198
                ],
                [
                    89.1511267,
                    55.4744921
                ],
                [
                    89.1504735,
                    55.4747797
                ],
                [
                    89.150047,
                    55.4753243
                ],
                [
                    89.1496042,
                    55.4756119
                ],
                [
                    89.1496691,
                    55.4757374
                ],
                [
                    89.1496097,
                    55.4758934
                ],
                [
                    89.1491616,
                    55.4759699
                ],
                [
                    89.1488432,
                    55.4762697
                ],
                [
                    89.148557,
                    55.4765971
                ],
                [
                    89.1478121,
                    55.4766001
                ],
                [
                    89.1468404,
                    55.4771386
                ],
                [
                    89.147256,
                    55.4775302
                ],
                [
                    89.1483357,
                    55.4776648
                ],
                [
                    89.1486866,
                    55.4780289
                ],
                [
                    89.1489673,
                    55.4785643
                ],
                [
                    89.1486596,
                    55.4789406
                ],
                [
                    89.147947,
                    55.4789651
                ],
                [
                    89.1467593,
                    55.4783012
                ],
                [
                    89.1457013,
                    55.478396
                ],
                [
                    89.1463437,
                    55.4791976
                ],
                [
                    89.146565,
                    55.4795371
                ],
                [
                    89.1465326,
                    55.4802775
                ],
                [
                    89.1463761,
                    55.4803601
                ],
                [
                    89.1454422,
                    55.4801612
                ],
                [
                    89.1455879,
                    55.4804029
                ],
                [
                    89.1454584,
                    55.4808434
                ],
                [
                    89.1453018,
                    55.4809536
                ],
                [
                    89.1450319,
                    55.4814522
                ],
                [
                    89.1448268,
                    55.4816419
                ],
                [
                    89.1446,
                    55.4816572
                ],
                [
                    89.1442383,
                    55.4814614
                ],
                [
                    89.1435581,
                    55.481596
                ],
                [
                    89.1436715,
                    55.4820151
                ],
                [
                    89.1432936,
                    55.4827217
                ],
                [
                    89.1428725,
                    55.4828227
                ],
                [
                    89.1410155,
                    55.483049
                ],
                [
                    89.1409561,
                    55.4834436
                ],
                [
                    89.1414204,
                    55.4836333
                ],
                [
                    89.1417335,
                    55.483725
                ],
                [
                    89.1417065,
                    55.4837923
                ],
                [
                    89.1414042,
                    55.4837281
                ],
                [
                    89.1413124,
                    55.4837923
                ],
                [
                    89.1412152,
                    55.4839453
                ],
                [
                    89.1412854,
                    55.4840371
                ],
                [
                    89.1415284,
                    55.4841778
                ],
                [
                    89.141496,
                    55.4843491
                ],
                [
                    89.1412045,
                    55.4845265
                ],
                [
                    89.1407995,
                    55.4847375
                ],
                [
                    89.1405728,
                    55.48497
                ],
                [
                    89.140265,
                    55.4855573
                ],
                [
                    89.1402813,
                    55.4857439
                ],
                [
                    89.1404433,
                    55.4859672
                ],
                [
                    89.1404649,
                    55.4861018
                ],
                [
                    89.1403569,
                    55.4862302
                ],
                [
                    89.1401248,
                    55.4862761
                ],
                [
                    89.1400168,
                    55.4863985
                ],
                [
                    89.1399466,
                    55.48653
                ],
                [
                    89.1395903,
                    55.4866432
                ],
                [
                    89.1395094,
                    55.4867166
                ],
                [
                    89.1394608,
                    55.4868206
                ],
                [
                    89.1390559,
                    55.4870591
                ],
                [
                    89.1389641,
                    55.4871968
                ],
                [
                    89.1388993,
                    55.4874109
                ],
                [
                    89.1389533,
                    55.4875852
                ],
                [
                    89.1392178,
                    55.4877321
                ],
                [
                    89.1393528,
                    55.48794
                ],
                [
                    89.1395148,
                    55.4879798
                ],
                [
                    89.1397685,
                    55.4879798
                ],
                [
                    89.1398279,
                    55.488044
                ],
                [
                    89.1397793,
                    55.4882031
                ],
                [
                    89.1395903,
                    55.4884508
                ],
                [
                    89.1392124,
                    55.4886741
                ],
                [
                    89.1391207,
                    55.4888331
                ],
                [
                    89.1391747,
                    55.4890014
                ],
                [
                    89.1390505,
                    55.4891115
                ],
                [
                    89.1384027,
                    55.4894448
                ],
                [
                    89.1382677,
                    55.4896467
                ],
                [
                    89.1381382,
                    55.4899893
                ],
                [
                    89.1382084,
                    55.4903716
                ],
                [
                    89.1381652,
                    55.4907661
                ],
                [
                    89.1380626,
                    55.490916
                ],
                [
                    89.1378197,
                    55.4910689
                ],
                [
                    89.1372582,
                    55.4912524
                ],
                [
                    89.1368911,
                    55.4914145
                ]
            ],
            "longitude": 89.154678,
            "latitude": 55.482769
        },
        "202": {
            "name": "Леонтьевка",
            "population": 299,
            "type": "village",
            "poly": [
                [
                    89.1223121,
                    56.597018
                ],
                [
                    89.1270014,
                    56.5984006
                ],
                [
                    89.1268459,
                    56.5991836
                ],
                [
                    89.1294461,
                    56.5992448
                ],
                [
                    89.1300462,
                    56.5987065
                ],
                [
                    89.1361134,
                    56.6026335
                ],
                [
                    89.1376692,
                    56.6025479
                ],
                [
                    89.1418474,
                    56.6042972
                ],
                [
                    89.1430253,
                    56.6042972
                ],
                [
                    89.1435142,
                    56.6037957
                ],
                [
                    89.1447588,
                    56.6035755
                ],
                [
                    89.1459811,
                    56.6036856
                ],
                [
                    89.1483147,
                    56.6021442
                ],
                [
                    89.152004,
                    56.6034042
                ],
                [
                    89.1524485,
                    56.6051657
                ],
                [
                    89.1529819,
                    56.6056795
                ],
                [
                    89.1545153,
                    56.6061566
                ],
                [
                    89.1537594,
                    56.6081681
                ],
                [
                    89.154584,
                    56.6083115
                ],
                [
                    89.152978,
                    56.610772
                ],
                [
                    89.1531083,
                    56.6134235
                ],
                [
                    89.152978,
                    56.6174601
                ],
                [
                    89.1595325,
                    56.6163614
                ],
                [
                    89.1620067,
                    56.6162659
                ],
                [
                    89.1625276,
                    56.6158598
                ],
                [
                    89.168431,
                    56.6157882
                ],
                [
                    89.1693425,
                    56.6148566
                ],
                [
                    89.1674326,
                    56.6147372
                ],
                [
                    89.1650886,
                    56.6132802
                ],
                [
                    89.1644375,
                    56.6108915
                ],
                [
                    89.1653925,
                    56.6091476
                ],
                [
                    89.1649584,
                    56.6080487
                ],
                [
                    89.1696898,
                    56.6086698
                ],
                [
                    89.1714261,
                    56.6080726
                ],
                [
                    89.1697766,
                    56.6050862
                ],
                [
                    89.1706448,
                    56.6053013
                ],
                [
                    89.1719904,
                    56.6049907
                ],
                [
                    89.1736399,
                    56.6047995
                ],
                [
                    89.1740305,
                    56.6053252
                ],
                [
                    89.1729453,
                    56.6063525
                ],
                [
                    89.1729019,
                    56.6069258
                ],
                [
                    89.1741607,
                    56.6069736
                ],
                [
                    89.1762877,
                    56.6063525
                ],
                [
                    89.1778938,
                    56.6050385
                ],
                [
                    89.1777201,
                    56.6037244
                ],
                [
                    89.1762317,
                    56.6033105
                ],
                [
                    89.1752941,
                    56.6020872
                ],
                [
                    89.1761621,
                    56.6013608
                ],
                [
                    89.1797737,
                    56.6006918
                ],
                [
                    89.1796868,
                    56.6004047
                ],
                [
                    89.1795306,
                    56.5998889
                ],
                [
                    89.1735231,
                    56.5999654
                ],
                [
                    89.1720299,
                    56.5985508
                ],
                [
                    89.1708492,
                    56.5995257
                ],
                [
                    89.1694601,
                    56.598742
                ],
                [
                    89.1693559,
                    56.5976905
                ],
                [
                    89.1671682,
                    56.5987802
                ],
                [
                    89.1666125,
                    56.5994875
                ],
                [
                    89.1655361,
                    56.6000419
                ],
                [
                    89.1663001,
                    56.6007683
                ],
                [
                    89.1658487,
                    56.601724
                ],
                [
                    89.1649111,
                    56.6019343
                ],
                [
                    89.1649111,
                    56.6029665
                ],
                [
                    89.1638346,
                    56.6040942
                ],
                [
                    89.1619594,
                    56.6053175
                ],
                [
                    89.1612649,
                    56.6044956
                ],
                [
                    89.1601471,
                    56.6044621
                ],
                [
                    89.1596588,
                    56.6041038
                ],
                [
                    89.1607439,
                    56.6036558
                ],
                [
                    89.1605812,
                    56.602939
                ],
                [
                    89.1586279,
                    56.6026702
                ],
                [
                    89.1585736,
                    56.6018638
                ],
                [
                    89.1504889,
                    56.600012
                ],
                [
                    89.147342,
                    56.5986978
                ],
                [
                    89.1400171,
                    56.5949639
                ],
                [
                    89.1321495,
                    56.5936793
                ],
                [
                    89.1266746,
                    56.5923353
                ],
                [
                    89.1252679,
                    56.5921114
                ],
                [
                    89.1243567,
                    56.5935431
                ],
                [
                    89.1230455,
                    56.5936532
                ],
                [
                    89.1276237,
                    56.5948646
                ],
                [
                    89.1284016,
                    56.595819
                ],
                [
                    89.1234455,
                    56.5953173
                ],
                [
                    89.1223121,
                    56.597018
                ]
            ],
            "longitude": 89.16024,
            "latitude": 56.606274
        },
        "203": {
            "name": "Родники",
            "population": 902,
            "type": "village",
            "poly": [
                [
                    89.1875706,
                    55.6506034
                ],
                [
                    89.1882478,
                    55.6506458
                ],
                [
                    89.1905992,
                    55.6514843
                ],
                [
                    89.1915209,
                    55.6509006
                ],
                [
                    89.1911635,
                    55.6516435
                ],
                [
                    89.1918218,
                    55.6519726
                ],
                [
                    89.1940228,
                    55.6524608
                ],
                [
                    89.1964306,
                    55.6522379
                ],
                [
                    89.1970891,
                    55.6510492
                ],
                [
                    89.1973148,
                    55.651962
                ],
                [
                    89.1985375,
                    55.6521636
                ],
                [
                    89.2000424,
                    55.6521105
                ],
                [
                    89.2009642,
                    55.6517709
                ],
                [
                    89.2017919,
                    55.6510916
                ],
                [
                    89.204068,
                    55.6501576
                ],
                [
                    89.2052719,
                    55.6495314
                ],
                [
                    89.207059,
                    55.6481939
                ],
                [
                    89.2071154,
                    55.6478118
                ],
                [
                    89.2066828,
                    55.6476844
                ],
                [
                    89.2069793,
                    55.6474255
                ],
                [
                    89.2070214,
                    55.6473872
                ],
                [
                    89.2077362,
                    55.6473872
                ],
                [
                    89.2091282,
                    55.6464319
                ],
                [
                    89.2093916,
                    55.6459011
                ],
                [
                    89.2086956,
                    55.6457313
                ],
                [
                    89.2077738,
                    55.6452005
                ],
                [
                    89.2090342,
                    55.6442451
                ],
                [
                    89.2094857,
                    55.6438417
                ],
                [
                    89.209354,
                    55.6436081
                ],
                [
                    89.2082817,
                    55.6433852
                ],
                [
                    89.207007,
                    55.6429653
                ],
                [
                    89.2078648,
                    55.6424643
                ],
                [
                    89.2108746,
                    55.6407232
                ],
                [
                    89.2121538,
                    55.639602
                ],
                [
                    89.2103629,
                    55.6367141
                ],
                [
                    89.2087828,
                    55.6356268
                ],
                [
                    89.2081658,
                    55.635389
                ],
                [
                    89.2079852,
                    55.6351341
                ],
                [
                    89.2082109,
                    55.6346329
                ],
                [
                    89.2089333,
                    55.6342082
                ],
                [
                    89.2092794,
                    55.633775
                ],
                [
                    89.2099265,
                    55.6316427
                ],
                [
                    89.2098211,
                    55.6309291
                ],
                [
                    89.2075481,
                    55.6304103
                ],
                [
                    89.2053096,
                    55.6299006
                ],
                [
                    89.203372,
                    55.6294015
                ],
                [
                    89.2025504,
                    55.6291756
                ],
                [
                    89.2022622,
                    55.6291041
                ],
                [
                    89.1955088,
                    55.6388307
                ],
                [
                    89.1911851,
                    55.6450569
                ],
                [
                    89.1908061,
                    55.6456145
                ],
                [
                    89.1875706,
                    55.6506034
                ]
            ],
            "longitude": 89.198967,
            "latitude": 55.645168
        },
        "204": {
            "name": "Ажинское",
            "population": 404,
            "type": "village",
            "poly": [
                [
                    89.2047711,
                    55.5481045
                ],
                [
                    89.2072594,
                    55.5517226
                ],
                [
                    89.2076813,
                    55.551697
                ],
                [
                    89.2080353,
                    55.5517359
                ],
                [
                    89.2088818,
                    55.5520019
                ],
                [
                    89.2114213,
                    55.5528798
                ],
                [
                    89.2130908,
                    55.5535315
                ],
                [
                    89.2162818,
                    55.5536812
                ],
                [
                    89.2165984,
                    55.5526341
                ],
                [
                    89.2161404,
                    55.5523523
                ],
                [
                    89.2166419,
                    55.5518067
                ],
                [
                    89.2177403,
                    55.5502103
                ],
                [
                    89.2160013,
                    55.5499187
                ],
                [
                    89.2162443,
                    55.5495951
                ],
                [
                    89.2163935,
                    55.5489118
                ],
                [
                    89.2154469,
                    55.5487238
                ],
                [
                    89.215877,
                    55.5479088
                ],
                [
                    89.2159372,
                    55.5476959
                ],
                [
                    89.2163906,
                    55.547084
                ],
                [
                    89.2163434,
                    55.5467115
                ],
                [
                    89.2170682,
                    55.5455202
                ],
                [
                    89.2164925,
                    55.5453911
                ],
                [
                    89.2161746,
                    55.545827
                ],
                [
                    89.2155968,
                    55.5460231
                ],
                [
                    89.2148551,
                    55.5460667
                ],
                [
                    89.2133719,
                    55.5458978
                ],
                [
                    89.2124666,
                    55.5459632
                ],
                [
                    89.2110026,
                    55.5463773
                ],
                [
                    89.2099528,
                    55.5476142
                ],
                [
                    89.2090571,
                    55.5480882
                ],
                [
                    89.2086814,
                    55.5488401
                ],
                [
                    89.2052527,
                    55.5481263
                ],
                [
                    89.2049599,
                    55.5480819
                ],
                [
                    89.2047711,
                    55.5481045
                ]
            ],
            "longitude": 89.212158,
            "latitude": 55.549683
        },
        "205": {
            "name": "Парная",
            "population": 1142,
            "type": "village",
            "poly": [
                [
                    89.2037281,
                    55.27597
                ],
                [
                    89.2038754,
                    55.2761657
                ],
                [
                    89.2046509,
                    55.2762831
                ],
                [
                    89.2048178,
                    55.2764229
                ],
                [
                    89.2047393,
                    55.276546
                ],
                [
                    89.2044251,
                    55.2766354
                ],
                [
                    89.2062708,
                    55.277368
                ],
                [
                    89.2068794,
                    55.277491
                ],
                [
                    89.2068302,
                    55.27767
                ],
                [
                    89.2074194,
                    55.2782068
                ],
                [
                    89.2071641,
                    55.2788107
                ],
                [
                    89.2072034,
                    55.2792357
                ],
                [
                    89.2074586,
                    55.279437
                ],
                [
                    89.2080968,
                    55.2794817
                ],
                [
                    89.2094515,
                    55.2792468
                ],
                [
                    89.2094319,
                    55.2799402
                ],
                [
                    89.2100406,
                    55.2804434
                ],
                [
                    89.2102664,
                    55.2806112
                ],
                [
                    89.2115819,
                    55.2809019
                ],
                [
                    89.2123967,
                    55.2813772
                ],
                [
                    89.2120137,
                    55.2815226
                ],
                [
                    89.2110027,
                    55.2814723
                ],
                [
                    89.2105555,
                    55.2860741
                ],
                [
                    89.210622,
                    55.2865368
                ],
                [
                    89.2108167,
                    55.2867801
                ],
                [
                    89.2131289,
                    55.2873025
                ],
                [
                    89.2132608,
                    55.2874814
                ],
                [
                    89.2137949,
                    55.2877605
                ],
                [
                    89.2133362,
                    55.2882757
                ],
                [
                    89.2170558,
                    55.2892632
                ],
                [
                    89.2167479,
                    55.2895887
                ],
                [
                    89.2162076,
                    55.2899429
                ],
                [
                    89.215485,
                    55.290222
                ],
                [
                    89.214951,
                    55.2907908
                ],
                [
                    89.2149384,
                    55.2911558
                ],
                [
                    89.2152651,
                    55.2915922
                ],
                [
                    89.2159123,
                    55.2916674
                ],
                [
                    89.2164726,
                    55.2918595
                ],
                [
                    89.2163345,
                    55.2921041
                ],
                [
                    89.215092,
                    55.2926543
                ],
                [
                    89.2131286,
                    55.2933967
                ],
                [
                    89.211073,
                    55.2939994
                ],
                [
                    89.2101528,
                    55.2944448
                ],
                [
                    89.2088641,
                    55.2949775
                ],
                [
                    89.2082384,
                    55.2943883
                ],
                [
                    89.2065358,
                    55.2949785
                ],
                [
                    89.2082762,
                    55.2971427
                ],
                [
                    89.2135603,
                    55.2974575
                ],
                [
                    89.2185615,
                    55.2980298
                ],
                [
                    89.2224059,
                    55.2985103
                ],
                [
                    89.2223574,
                    55.2986361
                ],
                [
                    89.2226715,
                    55.2991548
                ],
                [
                    89.2226951,
                    55.2998254
                ],
                [
                    89.2224437,
                    55.3011488
                ],
                [
                    89.2227108,
                    55.3015959
                ],
                [
                    89.2228128,
                    55.3026555
                ],
                [
                    89.2289467,
                    55.3029148
                ],
                [
                    89.229198,
                    55.3023247
                ],
                [
                    89.2294069,
                    55.3023378
                ],
                [
                    89.2303761,
                    55.3025527
                ],
                [
                    89.2319468,
                    55.3027717
                ],
                [
                    89.2321118,
                    55.3026868
                ],
                [
                    89.2329364,
                    55.3012204
                ],
                [
                    89.2344286,
                    55.301435
                ],
                [
                    89.2347506,
                    55.3013277
                ],
                [
                    89.2369502,
                    55.2959976
                ],
                [
                    89.2361884,
                    55.2956309
                ],
                [
                    89.2361569,
                    55.2949915
                ],
                [
                    89.2352145,
                    55.2945622
                ],
                [
                    89.2350496,
                    55.2943118
                ],
                [
                    89.2344841,
                    55.2942581
                ],
                [
                    89.2346804,
                    55.2931983
                ],
                [
                    89.234437,
                    55.2931402
                ],
                [
                    89.2341228,
                    55.2922011
                ],
                [
                    89.2343663,
                    55.2919999
                ],
                [
                    89.2382539,
                    55.2931357
                ],
                [
                    89.2399425,
                    55.2935024
                ],
                [
                    89.2404215,
                    55.2933727
                ],
                [
                    89.2404607,
                    55.2935561
                ],
                [
                    89.2408928,
                    55.2937975
                ],
                [
                    89.2424477,
                    55.294048
                ],
                [
                    89.24405,
                    55.2945935
                ],
                [
                    89.2444426,
                    55.2946024
                ],
                [
                    89.2448825,
                    55.2944728
                ],
                [
                    89.2450553,
                    55.2943252
                ],
                [
                    89.2449139,
                    55.2939496
                ],
                [
                    89.2448825,
                    55.2937036
                ],
                [
                    89.2446233,
                    55.2934622
                ],
                [
                    89.2440264,
                    55.2930955
                ],
                [
                    89.2440656,
                    55.2921475
                ],
                [
                    89.2441914,
                    55.2920088
                ],
                [
                    89.2445134,
                    55.2919373
                ],
                [
                    89.2453459,
                    55.2920849
                ],
                [
                    89.2454244,
                    55.291821
                ],
                [
                    89.2453066,
                    55.2915214
                ],
                [
                    89.245385,
                    55.2912441
                ],
                [
                    89.2440186,
                    55.2907433
                ],
                [
                    89.2426834,
                    55.2904213
                ],
                [
                    89.2398404,
                    55.2896118
                ],
                [
                    89.2375942,
                    55.2888694
                ],
                [
                    89.2373821,
                    55.2889991
                ],
                [
                    89.236746,
                    55.2886861
                ],
                [
                    89.2370052,
                    55.288297
                ],
                [
                    89.2363775,
                    55.2881359
                ],
                [
                    89.2364246,
                    55.2879794
                ],
                [
                    89.2367467,
                    55.287805
                ],
                [
                    89.237375,
                    55.2876261
                ],
                [
                    89.2378462,
                    55.2873756
                ],
                [
                    89.2384509,
                    55.2873801
                ],
                [
                    89.2395425,
                    55.2876439
                ],
                [
                    89.2406421,
                    55.2877289
                ],
                [
                    89.2407913,
                    55.2874159
                ],
                [
                    89.2405636,
                    55.2873667
                ],
                [
                    89.2406186,
                    55.2872414
                ],
                [
                    89.2406421,
                    55.2871251
                ],
                [
                    89.2394012,
                    55.2865348
                ],
                [
                    89.2392913,
                    55.2863782
                ],
                [
                    89.2392834,
                    55.2861725
                ],
                [
                    89.2391578,
                    55.2860607
                ],
                [
                    89.2396368,
                    55.2858997
                ],
                [
                    89.240705,
                    55.2857163
                ],
                [
                    89.243226,
                    55.2869462
                ],
                [
                    89.243493,
                    55.2867763
                ],
                [
                    89.2427619,
                    55.2863726
                ],
                [
                    89.2426212,
                    55.2859547
                ],
                [
                    89.2428021,
                    55.2858602
                ],
                [
                    89.2412791,
                    55.2851074
                ],
                [
                    89.2424302,
                    55.2847066
                ],
                [
                    89.2440436,
                    55.2845434
                ],
                [
                    89.2443603,
                    55.2844576
                ],
                [
                    89.2454309,
                    55.2844805
                ],
                [
                    89.2455566,
                    55.2846379
                ],
                [
                    89.2468434,
                    55.2848984
                ],
                [
                    89.2468484,
                    55.2849585
                ],
                [
                    89.247733,
                    55.2851074
                ],
                [
                    89.2477732,
                    55.285219
                ],
                [
                    89.2482105,
                    55.2852705
                ],
                [
                    89.2482457,
                    55.285219
                ],
                [
                    89.2526033,
                    55.2861555
                ],
                [
                    89.255839,
                    55.2867862
                ],
                [
                    89.2557604,
                    55.2869203
                ],
                [
                    89.2566008,
                    55.2871216
                ],
                [
                    89.2570328,
                    55.2871305
                ],
                [
                    89.261533,
                    55.2879713
                ],
                [
                    89.2612895,
                    55.288347
                ],
                [
                    89.2616475,
                    55.2884308
                ],
                [
                    89.2618799,
                    55.2880551
                ],
                [
                    89.2626151,
                    55.2881767
                ],
                [
                    89.2626779,
                    55.2880479
                ],
                [
                    89.2630549,
                    55.2878404
                ],
                [
                    89.2632644,
                    55.2874773
                ],
                [
                    89.2633376,
                    55.2873896
                ],
                [
                    89.2676603,
                    55.2881123
                ],
                [
                    89.2700667,
                    55.283196
                ],
                [
                    89.2713862,
                    55.2831996
                ],
                [
                    89.2712848,
                    55.2782569
                ],
                [
                    89.2685517,
                    55.2789503
                ],
                [
                    89.267083,
                    55.2793573
                ],
                [
                    89.2648918,
                    55.2801894
                ],
                [
                    89.2635409,
                    55.2805875
                ],
                [
                    89.2634852,
                    55.2804953
                ],
                [
                    89.2634436,
                    55.2804353
                ],
                [
                    89.2647592,
                    55.2800389
                ],
                [
                    89.2661657,
                    55.2794823
                ],
                [
                    89.2660542,
                    55.2793216
                ],
                [
                    89.2645691,
                    55.2798279
                ],
                [
                    89.2635802,
                    55.2800462
                ],
                [
                    89.2615775,
                    55.2800904
                ],
                [
                    89.2605835,
                    55.2802372
                ],
                [
                    89.2596754,
                    55.2802302
                ],
                [
                    89.2569511,
                    55.2805307
                ],
                [
                    89.2562638,
                    55.2805238
                ],
                [
                    89.2535519,
                    55.2809501
                ],
                [
                    89.2506803,
                    55.281006
                ],
                [
                    89.2497278,
                    55.2808057
                ],
                [
                    89.2489789,
                    55.2807541
                ],
                [
                    89.2481495,
                    55.2810003
                ],
                [
                    89.2477977,
                    55.2811148
                ],
                [
                    89.2472096,
                    55.2810919
                ],
                [
                    89.2434398,
                    55.2822113
                ],
                [
                    89.2427964,
                    55.2829012
                ],
                [
                    89.2420424,
                    55.2832647
                ],
                [
                    89.2408232,
                    55.2835347
                ],
                [
                    89.2393981,
                    55.2838342
                ],
                [
                    89.2383469,
                    55.2839007
                ],
                [
                    89.2379636,
                    55.2839987
                ],
                [
                    89.2378353,
                    55.2842695
                ],
                [
                    89.2373339,
                    55.2842429
                ],
                [
                    89.2370713,
                    55.28378
                ],
                [
                    89.2356338,
                    55.2832676
                ],
                [
                    89.2346033,
                    55.2829556
                ],
                [
                    89.2336785,
                    55.2829327
                ],
                [
                    89.2326832,
                    55.2826149
                ],
                [
                    89.2322711,
                    55.2826149
                ],
                [
                    89.2317534,
                    55.2824432
                ],
                [
                    89.2304264,
                    55.2821454
                ],
                [
                    89.2289134,
                    55.2816502
                ],
                [
                    89.2275915,
                    55.281361
                ],
                [
                    89.2267722,
                    55.2811177
                ],
                [
                    89.2257719,
                    55.28086
                ],
                [
                    89.2234547,
                    55.2803562
                ],
                [
                    89.2214642,
                    55.280276
                ],
                [
                    89.2204339,
                    55.2801787
                ],
                [
                    89.2175537,
                    55.2793542
                ],
                [
                    89.2151109,
                    55.2785926
                ],
                [
                    89.2141307,
                    55.2781746
                ],
                [
                    89.2132411,
                    55.2776965
                ],
                [
                    89.2123413,
                    55.2768863
                ],
                [
                    89.2121553,
                    55.2761304
                ],
                [
                    89.210746,
                    55.2738705
                ],
                [
                    89.2101963,
                    55.2728325
                ],
                [
                    89.2105811,
                    55.2720988
                ],
                [
                    89.2111073,
                    55.2715172
                ],
                [
                    89.2112487,
                    55.2711726
                ],
                [
                    89.210856,
                    55.2704836
                ],
                [
                    89.2112879,
                    55.2694097
                ],
                [
                    89.2113979,
                    55.2680226
                ],
                [
                    89.212144,
                    55.267432
                ],
                [
                    89.2136754,
                    55.2667697
                ],
                [
                    89.2138561,
                    55.2659464
                ],
                [
                    89.214563,
                    55.2653915
                ],
                [
                    89.2146808,
                    55.2648858
                ],
                [
                    89.2139425,
                    55.2648858
                ],
                [
                    89.2120629,
                    55.2643814
                ],
                [
                    89.2111008,
                    55.2642975
                ],
                [
                    89.2101486,
                    55.264057
                ],
                [
                    89.2085876,
                    55.2635144
                ],
                [
                    89.2077302,
                    55.2633655
                ],
                [
                    89.2071739,
                    55.263313
                ],
                [
                    89.2060646,
                    55.2651421
                ],
                [
                    89.2056228,
                    55.2655952
                ],
                [
                    89.2053676,
                    55.2662385
                ],
                [
                    89.2048473,
                    55.268034
                ],
                [
                    89.2047687,
                    55.2686492
                ],
                [
                    89.2050876,
                    55.2687946
                ],
                [
                    89.2054167,
                    55.2689345
                ],
                [
                    89.2056621,
                    55.2696951
                ],
                [
                    89.2057014,
                    55.2702432
                ],
                [
                    89.2058191,
                    55.2705285
                ],
                [
                    89.2065849,
                    55.2706963
                ],
                [
                    89.2073212,
                    55.2712108
                ],
                [
                    89.2072623,
                    55.27243
                ],
                [
                    89.2074586,
                    55.2734031
                ],
                [
                    89.2082048,
                    55.2749019
                ],
                [
                    89.2083126,
                    55.2754275
                ],
                [
                    89.2079055,
                    55.275989
                ],
                [
                    89.2078513,
                    55.2760651
                ],
                [
                    89.2051025,
                    55.2758526
                ],
                [
                    89.2037281,
                    55.27597
                ]
            ],
            "longitude": 89.230446,
            "latitude": 55.287418
        },
        "206": {
            "name": "Каштан",
            "population": 342,
            "type": "village",
            "poly": [
                [
                    89.2278297,
                    56.1164705
                ],
                [
                    89.2281103,
                    56.1179529
                ],
                [
                    89.2314376,
                    56.1181243
                ],
                [
                    89.2316113,
                    56.1179008
                ],
                [
                    89.2363168,
                    56.1177463
                ],
                [
                    89.2363502,
                    56.1180257
                ],
                [
                    89.2404703,
                    56.1181006
                ],
                [
                    89.2404745,
                    56.1192209
                ],
                [
                    89.2399786,
                    56.1199775
                ],
                [
                    89.239822,
                    56.1204285
                ],
                [
                    89.2409443,
                    56.1211414
                ],
                [
                    89.2441544,
                    56.1225525
                ],
                [
                    89.2461118,
                    56.1232654
                ],
                [
                    89.2503398,
                    56.1232072
                ],
                [
                    89.2503659,
                    56.1237163
                ],
                [
                    89.2526626,
                    56.1235563
                ],
                [
                    89.2526626,
                    56.1237309
                ],
                [
                    89.2553247,
                    56.1244728
                ],
                [
                    89.2561859,
                    56.1237891
                ],
                [
                    89.255403,
                    56.1233527
                ],
                [
                    89.2557422,
                    56.1229453
                ],
                [
                    89.2568645,
                    56.1230326
                ],
                [
                    89.2575431,
                    56.1222034
                ],
                [
                    89.2640938,
                    56.1236291
                ],
                [
                    89.2653205,
                    56.1241091
                ],
                [
                    89.2651639,
                    56.1243273
                ],
                [
                    89.2714276,
                    56.1275276
                ],
                [
                    89.2730979,
                    56.1292294
                ],
                [
                    89.2755251,
                    56.1284876
                ],
                [
                    89.2745594,
                    56.1272512
                ],
                [
                    89.2729152,
                    56.1261021
                ],
                [
                    89.2683479,
                    56.1238182
                ],
                [
                    89.2657381,
                    56.1225234
                ],
                [
                    89.2624496,
                    56.1217815
                ],
                [
                    89.2629455,
                    56.1210686
                ],
                [
                    89.2579606,
                    56.1202393
                ],
                [
                    89.2525321,
                    56.1190609
                ],
                [
                    89.2532107,
                    56.1176932
                ],
                [
                    89.2539675,
                    56.1173586
                ],
                [
                    89.2535239,
                    56.1167911
                ],
                [
                    89.2528714,
                    56.1162237
                ],
                [
                    89.2532368,
                    56.1156417
                ],
                [
                    89.2536283,
                    56.1155835
                ],
                [
                    89.253837,
                    56.114463
                ],
                [
                    89.2546983,
                    56.1144776
                ],
                [
                    89.2546983,
                    56.1139538
                ],
                [
                    89.2528714,
                    56.1138665
                ],
                [
                    89.2524016,
                    56.1141575
                ],
                [
                    89.2508357,
                    56.1133863
                ],
                [
                    89.2481214,
                    56.1131389
                ],
                [
                    89.2480692,
                    56.1134736
                ],
                [
                    89.2426407,
                    56.1134154
                ],
                [
                    89.2425531,
                    56.112715
                ],
                [
                    89.2409704,
                    56.1125132
                ],
                [
                    89.240344,
                    56.1147104
                ],
                [
                    89.2411009,
                    56.1160345
                ],
                [
                    89.2410486,
                    56.1165438
                ],
                [
                    89.2362131,
                    56.1164972
                ],
                [
                    89.2362333,
                    56.1169082
                ],
                [
                    89.2315979,
                    56.1170888
                ],
                [
                    89.2315578,
                    56.1167536
                ],
                [
                    89.2278297,
                    56.1164705
                ]
            ],
            "longitude": 89.248352,
            "latitude": 56.117229
        },
        "207": {
            "name": "Темра",
            "population": 357,
            "type": "village",
            "poly": [
                [
                    89.2581595,
                    55.4359485
                ],
                [
                    89.258834,
                    55.4379945
                ],
                [
                    89.2605111,
                    55.4382701
                ],
                [
                    89.2640303,
                    55.4404326
                ],
                [
                    89.2662434,
                    55.4407871
                ],
                [
                    89.2684799,
                    55.4418702
                ],
                [
                    89.2698638,
                    55.4426188
                ],
                [
                    89.270366,
                    55.4430527
                ],
                [
                    89.2708507,
                    55.4435098
                ],
                [
                    89.2712302,
                    55.443682
                ],
                [
                    89.2716974,
                    55.4437681
                ],
                [
                    89.2733908,
                    55.4437615
                ],
                [
                    89.2745538,
                    55.4438817
                ],
                [
                    89.275021,
                    55.4438568
                ],
                [
                    89.2762618,
                    55.444039
                ],
                [
                    89.2771232,
                    55.4444986
                ],
                [
                    89.2773494,
                    55.4443744
                ],
                [
                    89.2775319,
                    55.4443288
                ],
                [
                    89.2772399,
                    55.4440183
                ],
                [
                    89.2772034,
                    55.4436954
                ],
                [
                    89.2769042,
                    55.4436291
                ],
                [
                    89.2765976,
                    55.4434594
                ],
                [
                    89.2765538,
                    55.443095
                ],
                [
                    89.2768458,
                    55.4427265
                ],
                [
                    89.2769407,
                    55.4423622
                ],
                [
                    89.2766122,
                    55.4412236
                ],
                [
                    89.2768166,
                    55.4408965
                ],
                [
                    89.2767801,
                    55.4405238
                ],
                [
                    89.2766779,
                    55.4400684
                ],
                [
                    89.2772764,
                    55.4396501
                ],
                [
                    89.2777509,
                    55.4393727
                ],
                [
                    89.2779772,
                    55.439029
                ],
                [
                    89.2779991,
                    55.4384618
                ],
                [
                    89.277583,
                    55.4379649
                ],
                [
                    89.2776049,
                    55.4375301
                ],
                [
                    89.2769334,
                    55.4371822
                ],
                [
                    89.2771597,
                    55.4365859
                ],
                [
                    89.277167,
                    55.4363748
                ],
                [
                    89.2769334,
                    55.4361056
                ],
                [
                    89.2766049,
                    55.4360186
                ],
                [
                    89.2761524,
                    55.4359317
                ],
                [
                    89.2759772,
                    55.4357909
                ],
                [
                    89.2760867,
                    55.4356749
                ],
                [
                    89.2751524,
                    55.4347307
                ],
                [
                    89.274656,
                    55.4344988
                ],
                [
                    89.2739261,
                    55.4344698
                ],
                [
                    89.2737509,
                    55.4344036
                ],
                [
                    89.2739042,
                    55.4338362
                ],
                [
                    89.2735903,
                    55.4337244
                ],
                [
                    89.2735392,
                    55.4335008
                ],
                [
                    89.2732799,
                    55.4333629
                ],
                [
                    89.2729295,
                    55.4329488
                ],
                [
                    89.2729178,
                    55.4326141
                ],
                [
                    89.2730521,
                    55.4323524
                ],
                [
                    89.2733032,
                    55.4322265
                ],
                [
                    89.273058,
                    55.4320343
                ],
                [
                    89.2730989,
                    55.4317362
                ],
                [
                    89.2734375,
                    55.4314777
                ],
                [
                    89.2737821,
                    55.4315208
                ],
                [
                    89.2739981,
                    55.4314148
                ],
                [
                    89.2740332,
                    55.4312425
                ],
                [
                    89.2735018,
                    55.4309542
                ],
                [
                    89.273531,
                    55.4307985
                ],
                [
                    89.2737529,
                    55.430719
                ],
                [
                    89.2735135,
                    55.4304009
                ],
                [
                    89.273274,
                    55.4298178
                ],
                [
                    89.2733908,
                    55.4297648
                ],
                [
                    89.2735018,
                    55.4295428
                ],
                [
                    89.2735368,
                    55.4292313
                ],
                [
                    89.2732974,
                    55.4288271
                ],
                [
                    89.2733032,
                    55.4285984
                ],
                [
                    89.2737295,
                    55.4283996
                ],
                [
                    89.2737061,
                    55.4277005
                ],
                [
                    89.2739806,
                    55.4272399
                ],
                [
                    89.2741499,
                    55.4266136
                ],
                [
                    89.2739748,
                    55.4261862
                ],
                [
                    89.2745821,
                    55.4253014
                ],
                [
                    89.2750142,
                    55.4249336
                ],
                [
                    89.2705529,
                    55.4241515
                ],
                [
                    89.2688244,
                    55.4241482
                ],
                [
                    89.2683222,
                    55.424019
                ],
                [
                    89.2678901,
                    55.4240024
                ],
                [
                    89.267131,
                    55.4241316
                ],
                [
                    89.2659398,
                    55.4241283
                ],
                [
                    89.2650989,
                    55.4239196
                ],
                [
                    89.264188,
                    55.423903
                ],
                [
                    89.2635515,
                    55.423956
                ],
                [
                    89.2634388,
                    55.4249488
                ],
                [
                    89.2626647,
                    55.4263998
                ],
                [
                    89.2613143,
                    55.4280048
                ],
                [
                    89.2607213,
                    55.4286313
                ],
                [
                    89.2603158,
                    55.4298517
                ],
                [
                    89.2604762,
                    55.4311257
                ],
                [
                    89.2610108,
                    55.4338557
                ],
                [
                    89.2608504,
                    55.4344926
                ],
                [
                    89.2602089,
                    55.4351902
                ],
                [
                    89.2581595,
                    55.4359485
                ]
            ],
            "longitude": 89.270065,
            "latitude": 55.434406
        },
        "208": {
            "name": "Зареченка",
            "population": 475,
            "type": "village",
            "poly": [
                [
                    89.261477,
                    56.5810858
                ],
                [
                    89.2627496,
                    56.583372
                ],
                [
                    89.2651736,
                    56.5840061
                ],
                [
                    89.2675067,
                    56.583956
                ],
                [
                    89.2698701,
                    56.5863255
                ],
                [
                    89.2777178,
                    56.5866925
                ],
                [
                    89.2768391,
                    56.5872265
                ],
                [
                    89.2768088,
                    56.5883444
                ],
                [
                    89.2800509,
                    56.5881942
                ],
                [
                    89.2824142,
                    56.5887114
                ],
                [
                    89.2831111,
                    56.5898293
                ],
                [
                    89.2835656,
                    56.5897625
                ],
                [
                    89.2837777,
                    56.5893454
                ],
                [
                    89.284717,
                    56.5893287
                ],
                [
                    89.2850503,
                    56.5895289
                ],
                [
                    89.2861108,
                    56.5895289
                ],
                [
                    89.2866865,
                    56.5874434
                ],
                [
                    89.2921707,
                    56.5878605
                ],
                [
                    89.2993519,
                    56.5879773
                ],
                [
                    89.2994802,
                    56.5873711
                ],
                [
                    89.3003334,
                    56.5871895
                ],
                [
                    89.3044057,
                    56.5885884
                ],
                [
                    89.3045997,
                    56.5874778
                ],
                [
                    89.3040373,
                    56.5871895
                ],
                [
                    89.3039985,
                    56.584381
                ],
                [
                    89.3023502,
                    56.5813373
                ],
                [
                    89.3013806,
                    56.5808246
                ],
                [
                    89.3014,
                    56.5803013
                ],
                [
                    89.2988984,
                    56.5806003
                ],
                [
                    89.2981615,
                    56.5805683
                ],
                [
                    89.2977349,
                    56.5800129
                ],
                [
                    89.2971725,
                    56.5799381
                ],
                [
                    89.2954079,
                    56.578838
                ],
                [
                    89.2954854,
                    56.578571
                ],
                [
                    89.2948454,
                    56.5783574
                ],
                [
                    89.2935269,
                    56.5787526
                ],
                [
                    89.2914907,
                    56.578539
                ],
                [
                    89.290909,
                    56.578838
                ],
                [
                    89.290269,
                    56.5787846
                ],
                [
                    89.2895709,
                    56.5780156
                ],
                [
                    89.2884268,
                    56.5780263
                ],
                [
                    89.2877481,
                    56.5788807
                ],
                [
                    89.2848975,
                    56.5800343
                ],
                [
                    89.2779551,
                    56.5796711
                ],
                [
                    89.2653698,
                    56.5808887
                ],
                [
                    89.261477,
                    56.5810858
                ]
            ],
            "longitude": 89.2883,
            "latitude": 56.582932
        },
        "209": {
            "name": "Гляден",
            "population": 647,
            "type": "village",
            "poly": [
                [
                    89.2786188,
                    55.5014611
                ],
                [
                    89.2793001,
                    55.5024005
                ],
                [
                    89.2791102,
                    55.5025934
                ],
                [
                    89.2804281,
                    55.503324
                ],
                [
                    89.2819527,
                    55.5038364
                ],
                [
                    89.2827233,
                    55.5039155
                ],
                [
                    89.2840301,
                    55.5041337
                ],
                [
                    89.2852921,
                    55.5045638
                ],
                [
                    89.2855546,
                    55.5045037
                ],
                [
                    89.2865207,
                    55.5045164
                ],
                [
                    89.2892962,
                    55.5047821
                ],
                [
                    89.2896424,
                    55.5048453
                ],
                [
                    89.2900333,
                    55.5048137
                ],
                [
                    89.2906141,
                    55.5044057
                ],
                [
                    89.2909268,
                    55.504333
                ],
                [
                    89.2913624,
                    55.5041495
                ],
                [
                    89.2913457,
                    55.5040736
                ],
                [
                    89.2913401,
                    55.5038206
                ],
                [
                    89.2916416,
                    55.5036909
                ],
                [
                    89.2919041,
                    55.5036909
                ],
                [
                    89.2925686,
                    55.5034917
                ],
                [
                    89.2927362,
                    55.5031912
                ],
                [
                    89.2926971,
                    55.5026282
                ],
                [
                    89.2927864,
                    55.5025491
                ],
                [
                    89.2931383,
                    55.5025302
                ],
                [
                    89.2937525,
                    55.5021791
                ],
                [
                    89.2938307,
                    55.5020146
                ],
                [
                    89.2937693,
                    55.50173
                ],
                [
                    89.2938643,
                    55.5015162
                ],
                [
                    89.2945833,
                    55.5011525
                ],
                [
                    89.2949323,
                    55.5010774
                ],
                [
                    89.2952394,
                    55.5011011
                ],
                [
                    89.2955256,
                    55.5010102
                ],
                [
                    89.2959235,
                    55.5007057
                ],
                [
                    89.2957909,
                    55.5005318
                ],
                [
                    89.295763,
                    55.5002866
                ],
                [
                    89.2960143,
                    55.5001917
                ],
                [
                    89.2961259,
                    55.4999901
                ],
                [
                    89.2962446,
                    55.4987486
                ],
                [
                    89.2965587,
                    55.4984481
                ],
                [
                    89.2972847,
                    55.4980487
                ],
                [
                    89.2976198,
                    55.4978866
                ],
                [
                    89.2975988,
                    55.497685
                ],
                [
                    89.2977175,
                    55.4975189
                ],
                [
                    89.2983318,
                    55.4974873
                ],
                [
                    89.2984016,
                    55.497163
                ],
                [
                    89.2987506,
                    55.4970088
                ],
                [
                    89.299693,
                    55.4969732
                ],
                [
                    89.3002375,
                    55.4966846
                ],
                [
                    89.3007471,
                    55.4967123
                ],
                [
                    89.3011799,
                    55.4969851
                ],
                [
                    89.3016545,
                    55.4968783
                ],
                [
                    89.3021711,
                    55.4968902
                ],
                [
                    89.3023456,
                    55.4967716
                ],
                [
                    89.3027221,
                    55.4966536
                ],
                [
                    89.3032526,
                    55.4964242
                ],
                [
                    89.3035458,
                    55.4964361
                ],
                [
                    89.3041392,
                    55.4969383
                ],
                [
                    89.3040694,
                    55.4962107
                ],
                [
                    89.3049559,
                    55.496361
                ],
                [
                    89.305647,
                    55.4963728
                ],
                [
                    89.3065125,
                    55.4962147
                ],
                [
                    89.3069802,
                    55.4962265
                ],
                [
                    89.3075736,
                    55.4963847
                ],
                [
                    89.3079087,
                    55.4966219
                ],
                [
                    89.3082856,
                    55.4969857
                ],
                [
                    89.3084182,
                    55.497223
                ],
                [
                    89.3086416,
                    55.4972467
                ],
                [
                    89.3091093,
                    55.4971162
                ],
                [
                    89.3102471,
                    55.4970925
                ],
                [
                    89.3111546,
                    55.4969264
                ],
                [
                    89.3111616,
                    55.4966219
                ],
                [
                    89.3114827,
                    55.4963452
                ],
                [
                    89.3130742,
                    55.4961988
                ],
                [
                    89.3127601,
                    55.4958548
                ],
                [
                    89.31246,
                    55.4957441
                ],
                [
                    89.3122575,
                    55.4957204
                ],
                [
                    89.3118666,
                    55.4950284
                ],
                [
                    89.3117759,
                    55.4940793
                ],
                [
                    89.3115664,
                    55.4938539
                ],
                [
                    89.3117981,
                    55.4934379
                ],
                [
                    89.3116027,
                    55.4930978
                ],
                [
                    89.3113165,
                    55.4928447
                ],
                [
                    89.3106673,
                    55.4926786
                ],
                [
                    89.3090129,
                    55.4925363
                ],
                [
                    89.308622,
                    55.4923583
                ],
                [
                    89.3080077,
                    55.4922239
                ],
                [
                    89.3070653,
                    55.4921369
                ],
                [
                    89.3065418,
                    55.4922594
                ],
                [
                    89.3055506,
                    55.4922674
                ],
                [
                    89.3047059,
                    55.4918205
                ],
                [
                    89.3044267,
                    55.491516
                ],
                [
                    89.303966,
                    55.4910928
                ],
                [
                    89.3037915,
                    55.4905431
                ],
                [
                    89.3034215,
                    55.4899657
                ],
                [
                    89.3032749,
                    55.4898708
                ],
                [
                    89.3026606,
                    55.4897087
                ],
                [
                    89.3017811,
                    55.4894318
                ],
                [
                    89.3011807,
                    55.4890521
                ],
                [
                    89.3006991,
                    55.4889414
                ],
                [
                    89.3000639,
                    55.4890007
                ],
                [
                    89.2994496,
                    55.4891747
                ],
                [
                    89.297865,
                    55.489764
                ],
                [
                    89.2962385,
                    55.4904284
                ],
                [
                    89.2948215,
                    55.491168
                ],
                [
                    89.2931811,
                    55.4923188
                ],
                [
                    89.292469,
                    55.4929713
                ],
                [
                    89.2917221,
                    55.493426
                ],
                [
                    89.2867939,
                    55.4963483
                ],
                [
                    89.2861726,
                    55.4970758
                ],
                [
                    89.2861098,
                    55.497408
                ],
                [
                    89.2862773,
                    55.4976531
                ],
                [
                    89.2873453,
                    55.4984637
                ],
                [
                    89.2879336,
                    55.498763
                ],
                [
                    89.2880844,
                    55.4992122
                ],
                [
                    89.2813719,
                    55.5000188
                ],
                [
                    89.281386,
                    55.5000855
                ],
                [
                    89.2814054,
                    55.5001769
                ],
                [
                    89.2794843,
                    55.5005597
                ],
                [
                    89.2786188,
                    55.5014611
                ]
            ],
            "longitude": 89.297432,
            "latitude": 55.496422
        },
        "210": {
            "name": "Чиндат",
            "population": 135,
            "type": "village",
            "poly": [
                [
                    89.296188,
                    57.3956799
                ],
                [
                    89.2972389,
                    57.3963948
                ],
                [
                    89.3000414,
                    57.3970755
                ],
                [
                    89.3019734,
                    57.3968296
                ],
                [
                    89.3028864,
                    57.3967094
                ],
                [
                    89.3037887,
                    57.3961031
                ],
                [
                    89.302345,
                    57.395085
                ],
                [
                    89.3038842,
                    57.3946388
                ],
                [
                    89.3044362,
                    57.3923793
                ],
                [
                    89.3055509,
                    57.392282
                ],
                [
                    89.3057101,
                    57.3917958
                ],
                [
                    89.3044999,
                    57.3912752
                ],
                [
                    89.3040965,
                    57.389845
                ],
                [
                    89.305105,
                    57.3899079
                ],
                [
                    89.3056252,
                    57.3896505
                ],
                [
                    89.3053704,
                    57.3880658
                ],
                [
                    89.3058056,
                    57.3878827
                ],
                [
                    89.3050944,
                    57.3873563
                ],
                [
                    89.304691,
                    57.386481
                ],
                [
                    89.3034171,
                    57.3865496
                ],
                [
                    89.3029607,
                    57.3853023
                ],
                [
                    89.3014321,
                    57.3845013
                ],
                [
                    89.3006465,
                    57.3836316
                ],
                [
                    89.3022601,
                    57.3834657
                ],
                [
                    89.3023901,
                    57.3813996
                ],
                [
                    89.3028048,
                    57.3812745
                ],
                [
                    89.30171,
                    57.3803267
                ],
                [
                    89.3009471,
                    57.3801032
                ],
                [
                    89.3009139,
                    57.3794952
                ],
                [
                    89.3015774,
                    57.3790839
                ],
                [
                    89.3013949,
                    57.3777962
                ],
                [
                    89.3020418,
                    57.3771167
                ],
                [
                    89.3011295,
                    57.3763655
                ],
                [
                    89.3009471,
                    57.3754802
                ],
                [
                    89.3020584,
                    57.3735039
                ],
                [
                    89.3026223,
                    57.3726275
                ],
                [
                    89.3022242,
                    57.3720909
                ],
                [
                    89.3027052,
                    57.3718316
                ],
                [
                    89.3025891,
                    57.3715364
                ],
                [
                    89.3001509,
                    57.3709998
                ],
                [
                    89.2983742,
                    57.3710913
                ],
                [
                    89.297493,
                    57.3716922
                ],
                [
                    89.2968192,
                    57.3717062
                ],
                [
                    89.2966896,
                    57.3725725
                ],
                [
                    89.2979336,
                    57.3727961
                ],
                [
                    89.2979077,
                    57.3729359
                ],
                [
                    89.2970903,
                    57.3729816
                ],
                [
                    89.2974512,
                    57.373886
                ],
                [
                    89.2969629,
                    57.3739775
                ],
                [
                    89.297844,
                    57.3746529
                ],
                [
                    89.2978759,
                    57.375374
                ],
                [
                    89.2971115,
                    57.3755343
                ],
                [
                    89.2963472,
                    57.3759349
                ],
                [
                    89.2967082,
                    57.3779322
                ],
                [
                    89.2974194,
                    57.3781554
                ],
                [
                    89.2981519,
                    57.3792999
                ],
                [
                    89.2975043,
                    57.3793743
                ],
                [
                    89.2976529,
                    57.3796661
                ],
                [
                    89.2983323,
                    57.3797119
                ],
                [
                    89.2986402,
                    57.3802155
                ],
                [
                    89.2984279,
                    57.3804043
                ],
                [
                    89.2970054,
                    57.3804673
                ],
                [
                    89.2972602,
                    57.3811654
                ],
                [
                    89.2978652,
                    57.3814629
                ],
                [
                    89.2978016,
                    57.3818463
                ],
                [
                    89.2985234,
                    57.382018
                ],
                [
                    89.2985446,
                    57.3825959
                ],
                [
                    89.2980457,
                    57.3827218
                ],
                [
                    89.2978122,
                    57.383088
                ],
                [
                    89.2982899,
                    57.383397
                ],
                [
                    89.2988313,
                    57.3843583
                ],
                [
                    89.299861,
                    57.3845299
                ],
                [
                    89.3005085,
                    57.3851707
                ],
                [
                    89.3002325,
                    57.3854282
                ],
                [
                    89.3005722,
                    57.3864123
                ],
                [
                    89.3018567,
                    57.3861949
                ],
                [
                    89.300965,
                    57.3881745
                ],
                [
                    89.2990011,
                    57.3882088
                ],
                [
                    89.2976954,
                    57.3889125
                ],
                [
                    89.2990542,
                    57.3899709
                ],
                [
                    89.299309,
                    57.3912066
                ],
                [
                    89.299861,
                    57.3914125
                ],
                [
                    89.300052,
                    57.3929113
                ],
                [
                    89.3013259,
                    57.3935863
                ],
                [
                    89.2979183,
                    57.3940325
                ],
                [
                    89.2975362,
                    57.3942956
                ],
                [
                    89.2979502,
                    57.3952795
                ],
                [
                    89.2965595,
                    57.3953138
                ],
                [
                    89.296188,
                    57.3956799
                ]
            ],
            "longitude": 89.300613,
            "latitude": 57.377537
        },
        "211": {
            "name": "Большое Озеро",
            "population": 337,
            "type": "village",
            "poly": [
                [
                    89.3067044,
                    55.189257
                ],
                [
                    89.3073375,
                    55.1895307
                ],
                [
                    89.307945,
                    55.1895829
                ],
                [
                    89.3082341,
                    55.1894764
                ],
                [
                    89.308827,
                    55.1893489
                ],
                [
                    89.3093394,
                    55.1893656
                ],
                [
                    89.3097749,
                    55.1895599
                ],
                [
                    89.3108545,
                    55.1907194
                ],
                [
                    89.311268,
                    55.1917493
                ],
                [
                    89.3118243,
                    55.1923322
                ],
                [
                    89.312161,
                    55.1925411
                ],
                [
                    89.3114656,
                    55.1926789
                ],
                [
                    89.3108581,
                    55.1926184
                ],
                [
                    89.3102031,
                    55.1926184
                ],
                [
                    89.3101518,
                    55.1930194
                ],
                [
                    89.3095736,
                    55.1930236
                ],
                [
                    89.3092808,
                    55.1938425
                ],
                [
                    89.3093174,
                    55.1943355
                ],
                [
                    89.308161,
                    55.1950791
                ],
                [
                    89.3077035,
                    55.1954906
                ],
                [
                    89.3082268,
                    55.1954739
                ],
                [
                    89.3086989,
                    55.195359
                ],
                [
                    89.3092369,
                    55.195453
                ],
                [
                    89.3093357,
                    55.1955366
                ],
                [
                    89.309343,
                    55.1956473
                ],
                [
                    89.3095077,
                    55.1957183
                ],
                [
                    89.3097676,
                    55.1956828
                ],
                [
                    89.3098554,
                    55.1955951
                ],
                [
                    89.3099615,
                    55.1956222
                ],
                [
                    89.3102104,
                    55.1956139
                ],
                [
                    89.3105837,
                    55.1955115
                ],
                [
                    89.3117365,
                    55.1954865
                ],
                [
                    89.3120988,
                    55.1955262
                ],
                [
                    89.3125379,
                    55.1954572
                ],
                [
                    89.3126367,
                    55.1955053
                ],
                [
                    89.3126843,
                    55.1956014
                ],
                [
                    89.3126221,
                    55.195735
                ],
                [
                    89.3128197,
                    55.1959084
                ],
                [
                    89.3133211,
                    55.1959481
                ],
                [
                    89.3136987,
                    55.1956218
                ],
                [
                    89.3140509,
                    55.1955878
                ],
                [
                    89.3143208,
                    55.1958045
                ],
                [
                    89.3143437,
                    55.1962066
                ],
                [
                    89.3141932,
                    55.196531
                ],
                [
                    89.3148219,
                    55.1967948
                ],
                [
                    89.3163305,
                    55.1959445
                ],
                [
                    89.3172703,
                    55.195891
                ],
                [
                    89.3193812,
                    55.1969122
                ],
                [
                    89.320245,
                    55.1971881
                ],
                [
                    89.3204043,
                    55.1971475
                ],
                [
                    89.3205373,
                    55.1972149
                ],
                [
                    89.3207135,
                    55.1972256
                ],
                [
                    89.3208371,
                    55.1971635
                ],
                [
                    89.3208933,
                    55.1970213
                ],
                [
                    89.3209795,
                    55.1969721
                ],
                [
                    89.3211369,
                    55.1970042
                ],
                [
                    89.321358,
                    55.1969978
                ],
                [
                    89.3216653,
                    55.1969122
                ],
                [
                    89.3218639,
                    55.1969218
                ],
                [
                    89.3219464,
                    55.1968972
                ],
                [
                    89.3219164,
                    55.1967518
                ],
                [
                    89.3221872,
                    55.1966102
                ],
                [
                    89.3223886,
                    55.1963709
                ],
                [
                    89.3223207,
                    55.1962854
                ],
                [
                    89.32196,
                    55.196264
                ],
                [
                    89.3219436,
                    55.1961945
                ],
                [
                    89.3223347,
                    55.1960073
                ],
                [
                    89.3225854,
                    55.1960621
                ],
                [
                    89.3228336,
                    55.1959017
                ],
                [
                    89.3228383,
                    55.1957573
                ],
                [
                    89.3230374,
                    55.1956691
                ],
                [
                    89.3231779,
                    55.1956423
                ],
                [
                    89.3233934,
                    55.1957025
                ],
                [
                    89.3236838,
                    55.1957132
                ],
                [
                    89.3238408,
                    55.1957854
                ],
                [
                    89.3239134,
                    55.1959512
                ],
                [
                    89.3240539,
                    55.1960327
                ],
                [
                    89.3241827,
                    55.1960421
                ],
                [
                    89.3242553,
                    55.1958616
                ],
                [
                    89.3243092,
                    55.1957988
                ],
                [
                    89.3244451,
                    55.1958402
                ],
                [
                    89.3247004,
                    55.1958349
                ],
                [
                    89.3248104,
                    55.1955675
                ],
                [
                    89.3250985,
                    55.1953496
                ],
                [
                    89.3255037,
                    55.1954846
                ],
                [
                    89.3256185,
                    55.1953883
                ],
                [
                    89.3255599,
                    55.1952907
                ],
                [
                    89.3254054,
                    55.1952172
                ],
                [
                    89.3254545,
                    55.1951424
                ],
                [
                    89.3256232,
                    55.1951183
                ],
                [
                    89.3259675,
                    55.1951236
                ],
                [
                    89.3259277,
                    55.1950247
                ],
                [
                    89.3261291,
                    55.1949231
                ],
                [
                    89.3260217,
                    55.1947635
                ],
                [
                    89.3281222,
                    55.1947514
                ],
                [
                    89.3282947,
                    55.1947635
                ],
                [
                    89.3282894,
                    55.1932054
                ],
                [
                    89.3293095,
                    55.191307
                ],
                [
                    89.3310113,
                    55.1897218
                ],
                [
                    89.332315,
                    55.1887922
                ],
                [
                    89.3330607,
                    55.1884971
                ],
                [
                    89.3329818,
                    55.1884537
                ],
                [
                    89.3328594,
                    55.18839
                ],
                [
                    89.3319171,
                    55.1868178
                ],
                [
                    89.3313681,
                    55.1866951
                ],
                [
                    89.3293316,
                    55.186762
                ],
                [
                    89.3291911,
                    55.1868075
                ],
                [
                    89.3290084,
                    55.1869238
                ],
                [
                    89.3285611,
                    55.1873758
                ],
                [
                    89.3282613,
                    55.1873143
                ],
                [
                    89.3281723,
                    55.1870255
                ],
                [
                    89.3279966,
                    55.1866577
                ],
                [
                    89.3274626,
                    55.1866658
                ],
                [
                    89.3269684,
                    55.1867995
                ],
                [
                    89.3262962,
                    55.1866016
                ],
                [
                    89.3258441,
                    55.1867179
                ],
                [
                    89.3247245,
                    55.1868677
                ],
                [
                    89.3236846,
                    55.1868463
                ],
                [
                    89.3228461,
                    55.1866658
                ],
                [
                    89.3222676,
                    55.1865133
                ],
                [
                    89.3222465,
                    55.1863542
                ],
                [
                    89.3224737,
                    55.1861376
                ],
                [
                    89.3228367,
                    55.1860426
                ],
                [
                    89.323071,
                    55.185933
                ],
                [
                    89.3232958,
                    55.1858782
                ],
                [
                    89.3234715,
                    55.1851093
                ],
                [
                    89.3234621,
                    55.1846065
                ],
                [
                    89.3223952,
                    55.1833827
                ],
                [
                    89.3215256,
                    55.1831638
                ],
                [
                    89.3206287,
                    55.1821608
                ],
                [
                    89.3191562,
                    55.1816139
                ],
                [
                    89.3189346,
                    55.1812221
                ],
                [
                    89.3188774,
                    55.1807732
                ],
                [
                    89.3184379,
                    55.1806601
                ],
                [
                    89.3179987,
                    55.1804198
                ],
                [
                    89.3176831,
                    55.1804146
                ],
                [
                    89.3177471,
                    55.1808482
                ],
                [
                    89.3180857,
                    55.181577
                ],
                [
                    89.3183007,
                    55.1818277
                ],
                [
                    89.3174818,
                    55.1814307
                ],
                [
                    89.3172394,
                    55.1818643
                ],
                [
                    89.3168414,
                    55.1819583
                ],
                [
                    89.3164663,
                    55.182337
                ],
                [
                    89.3153089,
                    55.1839564
                ],
                [
                    89.3149978,
                    55.1845049
                ],
                [
                    89.3148972,
                    55.1848209
                ],
                [
                    89.3146437,
                    55.1850434
                ],
                [
                    89.3146181,
                    55.185476
                ],
                [
                    89.3144638,
                    55.1854904
                ],
                [
                    89.3141058,
                    55.1856285
                ],
                [
                    89.3135166,
                    55.1855219
                ],
                [
                    89.3129258,
                    55.1853354
                ],
                [
                    89.3120146,
                    55.1853124
                ],
                [
                    89.3112351,
                    55.185561
                ],
                [
                    89.3091783,
                    55.1861064
                ],
                [
                    89.3083037,
                    55.1864114
                ],
                [
                    89.3082268,
                    55.186518
                ],
                [
                    89.308139,
                    55.1872283
                ],
                [
                    89.3079487,
                    55.1875501
                ],
                [
                    89.307978,
                    55.1877569
                ],
                [
                    89.3081134,
                    55.1878509
                ],
                [
                    89.3071326,
                    55.1885655
                ],
                [
                    89.3067044,
                    55.189257
                ]
            ],
            "longitude": 89.318443,
            "latitude": 55.189583
        },
        "212": {
            "name": "Новокурск",
            "population": 273,
            "type": "village",
            "poly": [
                [
                    89.2976397,
                    55.7545275
                ],
                [
                    89.2979833,
                    55.7547933
                ],
                [
                    89.3021489,
                    55.756056
                ],
                [
                    89.3021703,
                    55.7563943
                ],
                [
                    89.3023529,
                    55.7564366
                ],
                [
                    89.3024173,
                    55.7567689
                ],
                [
                    89.3041995,
                    55.7572582
                ],
                [
                    89.304586,
                    55.7570951
                ],
                [
                    89.3048866,
                    55.7570045
                ],
                [
                    89.3050262,
                    55.7571193
                ],
                [
                    89.304747,
                    55.7574395
                ],
                [
                    89.3049403,
                    55.7576147
                ],
                [
                    89.3061427,
                    55.7579288
                ],
                [
                    89.3073452,
                    55.7582611
                ],
                [
                    89.3077746,
                    55.757959
                ],
                [
                    89.3083973,
                    55.75811
                ],
                [
                    89.3087409,
                    55.7583335
                ],
                [
                    89.3092347,
                    55.758394
                ],
                [
                    89.3093636,
                    55.7585027
                ],
                [
                    89.3094817,
                    55.7586114
                ],
                [
                    89.3099326,
                    55.7586839
                ],
                [
                    89.3112746,
                    55.7591612
                ],
                [
                    89.3121764,
                    55.759729
                ],
                [
                    89.3126918,
                    55.7596142
                ],
                [
                    89.3129065,
                    55.7595176
                ],
                [
                    89.3131534,
                    55.7596444
                ],
                [
                    89.3129816,
                    55.7599646
                ],
                [
                    89.3131427,
                    55.7601639
                ],
                [
                    89.3135184,
                    55.7602243
                ],
                [
                    89.3142914,
                    55.7607016
                ],
                [
                    89.314839,
                    55.7608647
                ],
                [
                    89.3154402,
                    55.7611546
                ],
                [
                    89.3160092,
                    55.7612331
                ],
                [
                    89.3181886,
                    55.7619097
                ],
                [
                    89.320089,
                    55.7621392
                ],
                [
                    89.3201104,
                    55.7619641
                ],
                [
                    89.3202285,
                    55.7617828
                ],
                [
                    89.3210981,
                    55.7619399
                ],
                [
                    89.3215383,
                    55.7612996
                ],
                [
                    89.3218175,
                    55.7618493
                ],
                [
                    89.3225905,
                    55.7620728
                ],
                [
                    89.3240076,
                    55.7620788
                ],
                [
                    89.3244693,
                    55.7621875
                ],
                [
                    89.3250168,
                    55.7625137
                ],
                [
                    89.3255858,
                    55.7627795
                ],
                [
                    89.3266595,
                    55.7627131
                ],
                [
                    89.3267561,
                    55.762556
                ],
                [
                    89.3273144,
                    55.7625258
                ],
                [
                    89.3278404,
                    55.7624473
                ],
                [
                    89.3288604,
                    55.7627191
                ],
                [
                    89.3302668,
                    55.7630211
                ],
                [
                    89.3306104,
                    55.7632386
                ],
                [
                    89.3310935,
                    55.763305
                ],
                [
                    89.3317484,
                    55.7637158
                ],
                [
                    89.3330904,
                    55.7637097
                ],
                [
                    89.334411,
                    55.763601
                ],
                [
                    89.3353556,
                    55.7634258
                ],
                [
                    89.3355811,
                    55.7634862
                ],
                [
                    89.3362468,
                    55.7632809
                ],
                [
                    89.338555,
                    55.7632869
                ],
                [
                    89.3401011,
                    55.7634439
                ],
                [
                    89.3406164,
                    55.7633111
                ],
                [
                    89.3409922,
                    55.7634379
                ],
                [
                    89.3418404,
                    55.7634802
                ],
                [
                    89.3421088,
                    55.7636916
                ],
                [
                    89.3420335,
                    55.7625439
                ],
                [
                    89.3418296,
                    55.7621392
                ],
                [
                    89.3415126,
                    55.761992
                ],
                [
                    89.3377108,
                    55.7619175
                ],
                [
                    89.337798,
                    55.7618239
                ],
                [
                    89.3381072,
                    55.7614141
                ],
                [
                    89.3381553,
                    55.7611899
                ],
                [
                    89.3379011,
                    55.7606602
                ],
                [
                    89.3377705,
                    55.7603742
                ],
                [
                    89.3360802,
                    55.7601383
                ],
                [
                    89.3352625,
                    55.7599141
                ],
                [
                    89.3329538,
                    55.7595159
                ],
                [
                    89.3324385,
                    55.7593342
                ],
                [
                    89.3317033,
                    55.7587697
                ],
                [
                    89.3302453,
                    55.7584302
                ],
                [
                    89.328796,
                    55.7579228
                ],
                [
                    89.3262837,
                    55.7571253
                ],
                [
                    89.3244753,
                    55.7567132
                ],
                [
                    89.3242975,
                    55.7566722
                ],
                [
                    89.3237606,
                    55.7572824
                ],
                [
                    89.323503,
                    55.7571253
                ],
                [
                    89.3198742,
                    55.7562977
                ],
                [
                    89.3132071,
                    55.7546181
                ],
                [
                    89.3114786,
                    55.754026
                ],
                [
                    89.3102547,
                    55.7535125
                ],
                [
                    89.309428,
                    55.7528056
                ],
                [
                    89.3086657,
                    55.7524793
                ],
                [
                    89.3072378,
                    55.7518932
                ],
                [
                    89.3059923,
                    55.751144
                ],
                [
                    89.3049295,
                    55.7508419
                ],
                [
                    89.3035124,
                    55.7507271
                ],
                [
                    89.3016872,
                    55.7509023
                ],
                [
                    89.3007639,
                    55.7514884
                ],
                [
                    89.3002164,
                    55.7522497
                ],
                [
                    89.3000339,
                    55.7522981
                ],
                [
                    89.3000339,
                    55.7527089
                ],
                [
                    89.2991213,
                    55.7534279
                ],
                [
                    89.2987777,
                    55.7539958
                ],
                [
                    89.2976397,
                    55.7545275
                ]
            ],
            "longitude": 89.318787,
            "latitude": 55.759022
        },
        "213": {
            "name": "Юрьевка",
            "population": 863,
            "type": "village",
            "poly": [
                [
                    89.2985221,
                    56.3169521
                ],
                [
                    89.2988393,
                    56.3174248
                ],
                [
                    89.2999094,
                    56.3180732
                ],
                [
                    89.3001831,
                    56.3181824
                ],
                [
                    89.2992158,
                    56.3188945
                ],
                [
                    89.2998501,
                    56.3190616
                ],
                [
                    89.2999611,
                    56.3194045
                ],
                [
                    89.3081896,
                    56.3207585
                ],
                [
                    89.3081737,
                    56.3217168
                ],
                [
                    89.3089823,
                    56.3218135
                ],
                [
                    89.3119154,
                    56.3216904
                ],
                [
                    89.3149277,
                    56.3221036
                ],
                [
                    89.317401,
                    56.3221388
                ],
                [
                    89.3183047,
                    56.3215322
                ],
                [
                    89.3185425,
                    56.3212333
                ],
                [
                    89.3291808,
                    56.3215673
                ],
                [
                    89.3318285,
                    56.3207937
                ],
                [
                    89.3322249,
                    56.3170481
                ],
                [
                    89.3397875,
                    56.3180241
                ],
                [
                    89.3437511,
                    56.3167667
                ],
                [
                    89.3431169,
                    56.3163271
                ],
                [
                    89.3417693,
                    56.316116
                ],
                [
                    89.342864,
                    56.3159195
                ],
                [
                    89.3452992,
                    56.3155706
                ],
                [
                    89.3474097,
                    56.3148503
                ],
                [
                    89.3512147,
                    56.3132464
                ],
                [
                    89.3512451,
                    56.3129312
                ],
                [
                    89.3510829,
                    56.3124641
                ],
                [
                    89.3501595,
                    56.3117324
                ],
                [
                    89.3526557,
                    56.3106293
                ],
                [
                    89.3519758,
                    56.3097906
                ],
                [
                    89.3512047,
                    56.3090083
                ],
                [
                    89.3496015,
                    56.3096893
                ],
                [
                    89.3454615,
                    56.3115917
                ],
                [
                    89.3427828,
                    56.3118506
                ],
                [
                    89.3406012,
                    56.312571
                ],
                [
                    89.3398402,
                    56.3129762
                ],
                [
                    89.340936,
                    56.3139048
                ],
                [
                    89.339759,
                    56.3141243
                ],
                [
                    89.3395357,
                    56.3149628
                ],
                [
                    89.3327303,
                    56.3139839
                ],
                [
                    89.3275589,
                    56.3135373
                ],
                [
                    89.3259502,
                    56.3132904
                ],
                [
                    89.3229265,
                    56.3134536
                ],
                [
                    89.3230429,
                    56.3127799
                ],
                [
                    89.3240474,
                    56.3113053
                ],
                [
                    89.3247117,
                    56.3114985
                ],
                [
                    89.3266903,
                    56.3117658
                ],
                [
                    89.3313579,
                    56.3125397
                ],
                [
                    89.3342624,
                    56.3122864
                ],
                [
                    89.3354283,
                    56.3120013
                ],
                [
                    89.3394997,
                    56.3100314
                ],
                [
                    89.340692,
                    56.3098274
                ],
                [
                    89.3425058,
                    56.3088494
                ],
                [
                    89.3452073,
                    56.3080051
                ],
                [
                    89.3445985,
                    56.3072945
                ],
                [
                    89.3440658,
                    56.3074422
                ],
                [
                    89.3437868,
                    56.3073648
                ],
                [
                    89.3422648,
                    56.3078081
                ],
                [
                    89.3413135,
                    56.3077307
                ],
                [
                    89.3425945,
                    56.3072945
                ],
                [
                    89.3419222,
                    56.306612
                ],
                [
                    89.341415,
                    56.3067668
                ],
                [
                    89.3411993,
                    56.306626
                ],
                [
                    89.3396773,
                    56.3070904
                ],
                [
                    89.3384597,
                    56.3069778
                ],
                [
                    89.3352698,
                    56.3080507
                ],
                [
                    89.3347523,
                    56.3088781
                ],
                [
                    89.3256303,
                    56.3080845
                ],
                [
                    89.318771,
                    56.3081802
                ],
                [
                    89.3178274,
                    56.3083659
                ],
                [
                    89.3175636,
                    56.3087205
                ],
                [
                    89.317665,
                    56.3092158
                ],
                [
                    89.3170258,
                    56.3103922
                ],
                [
                    89.3221702,
                    56.3111239
                ],
                [
                    89.3223122,
                    56.3109607
                ],
                [
                    89.3236717,
                    56.3110905
                ],
                [
                    89.3228297,
                    56.3126617
                ],
                [
                    89.322502,
                    56.3134458
                ],
                [
                    89.3154072,
                    56.31316
                ],
                [
                    89.3106706,
                    56.3134788
                ],
                [
                    89.3092834,
                    56.3142592
                ],
                [
                    89.3050423,
                    56.3150726
                ],
                [
                    89.3033776,
                    56.3151276
                ],
                [
                    89.3005436,
                    56.3156662
                ],
                [
                    89.3004445,
                    56.3161388
                ],
                [
                    89.2985221,
                    56.3169521
                ]
            ],
            "longitude": 89.322311,
            "latitude": 56.315815
        },
        "214": {
            "name": "Александровка",
            "population": 459,
            "type": "village",
            "poly": [
                [
                    89.3330391,
                    56.0143026
                ],
                [
                    89.3330581,
                    56.0148776
                ],
                [
                    89.3343726,
                    56.0155698
                ],
                [
                    89.3338964,
                    56.0158254
                ],
                [
                    89.3343536,
                    56.016443
                ],
                [
                    89.3347536,
                    56.0171032
                ],
                [
                    89.3354966,
                    56.0178273
                ],
                [
                    89.3372302,
                    56.0182425
                ],
                [
                    89.3428692,
                    56.0181573
                ],
                [
                    89.3433836,
                    56.0177527
                ],
                [
                    89.3425072,
                    56.0172097
                ],
                [
                    89.3425644,
                    56.0170819
                ],
                [
                    89.3438979,
                    56.016443
                ],
                [
                    89.3446219,
                    56.0158573
                ],
                [
                    89.3447171,
                    56.0149415
                ],
                [
                    89.3448886,
                    56.0145369
                ],
                [
                    89.3459173,
                    56.0133868
                ],
                [
                    89.3459745,
                    56.0130353
                ],
                [
                    89.3466222,
                    56.0124709
                ],
                [
                    89.3464698,
                    56.0116189
                ],
                [
                    89.3476128,
                    56.0110012
                ],
                [
                    89.3486797,
                    56.0100321
                ],
                [
                    89.3474414,
                    56.0097445
                ],
                [
                    89.3482034,
                    56.0088712
                ],
                [
                    89.3489654,
                    56.0077848
                ],
                [
                    89.3497084,
                    56.0065813
                ],
                [
                    89.3503371,
                    56.0064428
                ],
                [
                    89.3508705,
                    56.0057292
                ],
                [
                    89.3503371,
                    56.0056013
                ],
                [
                    89.3514992,
                    56.003961
                ],
                [
                    89.3485844,
                    56.0031834
                ],
                [
                    89.3456506,
                    56.0033432
                ],
                [
                    89.3445076,
                    56.0032686
                ],
                [
                    89.3436693,
                    56.0033538
                ],
                [
                    89.3418024,
                    56.0056333
                ],
                [
                    89.3411165,
                    56.0072949
                ],
                [
                    89.3393639,
                    56.00836
                ],
                [
                    89.3381637,
                    56.009212
                ],
                [
                    89.33864,
                    56.0095315
                ],
                [
                    89.3380875,
                    56.0099256
                ],
                [
                    89.3371921,
                    56.010735
                ],
                [
                    89.3362015,
                    56.0104155
                ],
                [
                    89.3355347,
                    56.0107882
                ],
                [
                    89.3336296,
                    56.0130992
                ],
                [
                    89.3340488,
                    56.0133548
                ],
                [
                    89.3330391,
                    56.0143026
                ]
            ],
            "longitude": 89.343414,
            "latitude": 56.009918
        },
        "215": {
            "name": "Малое Озеро",
            "population": 363,
            "type": "village",
            "poly": [
                [
                    89.325907,
                    55.1351443
                ],
                [
                    89.3264186,
                    55.135348
                ],
                [
                    89.3271404,
                    55.1352331
                ],
                [
                    89.3278987,
                    55.1354315
                ],
                [
                    89.3292601,
                    55.1344549
                ],
                [
                    89.328922,
                    55.1342146
                ],
                [
                    89.3295159,
                    55.1340318
                ],
                [
                    89.3303564,
                    55.1340109
                ],
                [
                    89.3306762,
                    55.1338856
                ],
                [
                    89.330996,
                    55.1336453
                ],
                [
                    89.3309868,
                    55.1334782
                ],
                [
                    89.3313249,
                    55.1334834
                ],
                [
                    89.3313523,
                    55.1330656
                ],
                [
                    89.3322659,
                    55.1322038
                ],
                [
                    89.3347693,
                    55.1316188
                ],
                [
                    89.3375468,
                    55.1311591
                ],
                [
                    89.3389159,
                    55.1313005
                ],
                [
                    89.3392025,
                    55.1316448
                ],
                [
                    89.3396995,
                    55.1316147
                ],
                [
                    89.3403018,
                    55.1312103
                ],
                [
                    89.3416759,
                    55.130876
                ],
                [
                    89.3425647,
                    55.1308459
                ],
                [
                    89.343395,
                    55.1309261
                ],
                [
                    89.3434067,
                    55.130672
                ],
                [
                    89.3449328,
                    55.1308058
                ],
                [
                    89.3457865,
                    55.1307188
                ],
                [
                    89.3465116,
                    55.1307021
                ],
                [
                    89.3472835,
                    55.1304648
                ],
                [
                    89.347717,
                    55.130466
                ],
                [
                    89.3494879,
                    55.1300703
                ],
                [
                    89.3514234,
                    55.1292947
                ],
                [
                    89.3529557,
                    55.1290561
                ],
                [
                    89.353577,
                    55.1287166
                ],
                [
                    89.355989,
                    55.1281002
                ],
                [
                    89.3570833,
                    55.1274082
                ],
                [
                    89.3579824,
                    55.1272661
                ],
                [
                    89.3617904,
                    55.1271156
                ],
                [
                    89.3636616,
                    55.1268565
                ],
                [
                    89.3620243,
                    55.1266559
                ],
                [
                    89.360007,
                    55.1265264
                ],
                [
                    89.3596635,
                    55.1262004
                ],
                [
                    89.3580628,
                    55.1259162
                ],
                [
                    89.3560674,
                    55.125026
                ],
                [
                    89.3558335,
                    55.1250051
                ],
                [
                    89.3550879,
                    55.1253311
                ],
                [
                    89.344627,
                    55.123516
                ],
                [
                    89.3427428,
                    55.1232331
                ],
                [
                    89.3389877,
                    55.1226323
                ],
                [
                    89.337736,
                    55.1225173
                ],
                [
                    89.3360732,
                    55.1222561
                ],
                [
                    89.3355712,
                    55.1223421
                ],
                [
                    89.3350847,
                    55.1225373
                ],
                [
                    89.3339948,
                    55.1230937
                ],
                [
                    89.3331715,
                    55.1233826
                ],
                [
                    89.331698,
                    55.1238079
                ],
                [
                    89.3306922,
                    55.12449
                ],
                [
                    89.3299063,
                    55.1248885
                ],
                [
                    89.328924,
                    55.125616
                ],
                [
                    89.3286854,
                    55.1260172
                ],
                [
                    89.3268096,
                    55.127285
                ],
                [
                    89.3266599,
                    55.1274829
                ],
                [
                    89.3265991,
                    55.1282853
                ],
                [
                    89.3268657,
                    55.1285929
                ],
                [
                    89.3271651,
                    55.1287079
                ],
                [
                    89.3267956,
                    55.1294166
                ],
                [
                    89.3267114,
                    55.1297723
                ],
                [
                    89.3269593,
                    55.1303714
                ],
                [
                    89.3271932,
                    55.1305078
                ],
                [
                    89.3274739,
                    55.1304997
                ],
                [
                    89.3283112,
                    55.1303125
                ],
                [
                    89.3299297,
                    55.1303072
                ],
                [
                    89.330201,
                    55.1301681
                ],
                [
                    89.3310965,
                    55.1303547
                ],
                [
                    89.3310143,
                    55.1306629
                ],
                [
                    89.3297717,
                    55.1318277
                ],
                [
                    89.3296895,
                    55.1322664
                ],
                [
                    89.3288581,
                    55.1330551
                ],
                [
                    89.3291596,
                    55.1332902
                ],
                [
                    89.3271861,
                    55.1346795
                ],
                [
                    89.3266105,
                    55.1345071
                ],
                [
                    89.325907,
                    55.1351443
                ]
            ],
            "longitude": 89.344162,
            "latitude": 55.126801
        },
        "216": {
            "name": "Большая Косуль",
            "population": 1180,
            "type": "village",
            "poly": [
                [
                    89.333866,
                    56.1311683
                ],
                [
                    89.3341141,
                    56.1316778
                ],
                [
                    89.3345843,
                    56.1325439
                ],
                [
                    89.3349891,
                    56.1328204
                ],
                [
                    89.3361515,
                    56.1329296
                ],
                [
                    89.3369677,
                    56.1325174
                ],
                [
                    89.3408449,
                    56.1343368
                ],
                [
                    89.3416866,
                    56.134479
                ],
                [
                    89.3437782,
                    56.1351328
                ],
                [
                    89.3439058,
                    56.1353886
                ],
                [
                    89.3453597,
                    56.135744
                ],
                [
                    89.346431,
                    56.1356161
                ],
                [
                    89.3465841,
                    56.1364831
                ],
                [
                    89.3495429,
                    56.1370374
                ],
                [
                    89.3508438,
                    56.1369095
                ],
                [
                    89.3532671,
                    56.1380039
                ],
                [
                    89.354823,
                    56.1383734
                ],
                [
                    89.3603582,
                    56.1407326
                ],
                [
                    89.3611744,
                    56.14096
                ],
                [
                    89.3621182,
                    56.1409031
                ],
                [
                    89.3638017,
                    56.1413295
                ],
                [
                    89.3654597,
                    56.1407895
                ],
                [
                    89.3669136,
                    56.139013
                ],
                [
                    89.3646689,
                    56.1386719
                ],
                [
                    89.3623988,
                    56.1357724
                ],
                [
                    89.3625008,
                    56.1322899
                ],
                [
                    89.3651026,
                    56.1303709
                ],
                [
                    89.3628579,
                    56.1293047
                ],
                [
                    89.3595419,
                    56.1293047
                ],
                [
                    89.3591593,
                    56.1285797
                ],
                [
                    89.3572973,
                    56.127812
                ],
                [
                    89.3550526,
                    56.1276841
                ],
                [
                    89.3534201,
                    56.1275561
                ],
                [
                    89.3520937,
                    56.1274424
                ],
                [
                    89.3515836,
                    56.1278689
                ],
                [
                    89.3512009,
                    56.1277409
                ],
                [
                    89.3502572,
                    56.1279258
                ],
                [
                    89.3492624,
                    56.1284233
                ],
                [
                    89.3485481,
                    56.128139
                ],
                [
                    89.3477829,
                    56.1290204
                ],
                [
                    89.3483696,
                    56.1292621
                ],
                [
                    89.348191,
                    56.1295037
                ],
                [
                    89.3473493,
                    56.1298307
                ],
                [
                    89.3472473,
                    56.1307831
                ],
                [
                    89.3482676,
                    56.1311812
                ],
                [
                    89.3486502,
                    56.1318919
                ],
                [
                    89.3458443,
                    56.1316787
                ],
                [
                    89.3432171,
                    56.1308827
                ],
                [
                    89.3399521,
                    56.1302714
                ],
                [
                    89.3391103,
                    56.130442
                ],
                [
                    89.3381665,
                    56.1301861
                ],
                [
                    89.3359984,
                    56.1301434
                ],
                [
                    89.3351312,
                    56.1300439
                ],
                [
                    89.33457,
                    56.1302145
                ],
                [
                    89.3345843,
                    56.1308408
                ],
                [
                    89.333866,
                    56.1311683
                ]
            ],
            "longitude": 89.349327,
            "latitude": 56.133965
        },
        "217": {
            "name": "Скрипачи",
            "population": 292,
            "type": "village",
            "poly": [
                [
                    89.3731564,
                    55.7929054
                ],
                [
                    89.373508,
                    55.7932584
                ],
                [
                    89.3742989,
                    55.7947817
                ],
                [
                    89.3746505,
                    55.7947252
                ],
                [
                    89.3764788,
                    55.7947026
                ],
                [
                    89.377634,
                    55.794889
                ],
                [
                    89.3783372,
                    55.795273
                ],
                [
                    89.3793618,
                    55.7961709
                ],
                [
                    89.3803764,
                    55.7967412
                ],
                [
                    89.3810193,
                    55.7972494
                ],
                [
                    89.3823956,
                    55.7978875
                ],
                [
                    89.3828074,
                    55.797944
                ],
                [
                    89.3832393,
                    55.7977746
                ],
                [
                    89.3856503,
                    55.7978423
                ],
                [
                    89.3881114,
                    55.7978536
                ],
                [
                    89.3891562,
                    55.7974753
                ],
                [
                    89.3910034,
                    55.7957744
                ],
                [
                    89.3911641,
                    55.7945049
                ],
                [
                    89.3914856,
                    55.7933845
                ],
                [
                    89.3911561,
                    55.7924041
                ],
                [
                    89.3912605,
                    55.791618
                ],
                [
                    89.3917508,
                    55.7903709
                ],
                [
                    89.3920401,
                    55.7889025
                ],
                [
                    89.3928517,
                    55.7891465
                ],
                [
                    89.3937116,
                    55.7892549
                ],
                [
                    89.3954475,
                    55.7880666
                ],
                [
                    89.3952225,
                    55.7873843
                ],
                [
                    89.3947564,
                    55.7871538
                ],
                [
                    89.3933018,
                    55.7867472
                ],
                [
                    89.3924258,
                    55.7867562
                ],
                [
                    89.3923475,
                    55.7866827
                ],
                [
                    89.3922972,
                    55.7866206
                ],
                [
                    89.3898059,
                    55.7872939
                ],
                [
                    89.3878772,
                    55.7874747
                ],
                [
                    89.3877114,
                    55.7871155
                ],
                [
                    89.3876149,
                    55.7863428
                ],
                [
                    89.3879605,
                    55.7857328
                ],
                [
                    89.388073,
                    55.7849736
                ],
                [
                    89.3883783,
                    55.7847296
                ],
                [
                    89.3887079,
                    55.7841693
                ],
                [
                    89.3880328,
                    55.7841241
                ],
                [
                    89.3877516,
                    55.7839614
                ],
                [
                    89.3875506,
                    55.7839117
                ],
                [
                    89.3871328,
                    55.7840111
                ],
                [
                    89.3866827,
                    55.7837445
                ],
                [
                    89.3855255,
                    55.7836044
                ],
                [
                    89.3849629,
                    55.7833604
                ],
                [
                    89.3845611,
                    55.7833106
                ],
                [
                    89.3826351,
                    55.7827234
                ],
                [
                    89.3828443,
                    55.7830671
                ],
                [
                    89.3826193,
                    55.7834874
                ],
                [
                    89.3829407,
                    55.7839438
                ],
                [
                    89.3829648,
                    55.7845584
                ],
                [
                    89.3833506,
                    55.7852227
                ],
                [
                    89.3835836,
                    55.78553
                ],
                [
                    89.3837283,
                    55.7858282
                ],
                [
                    89.3830854,
                    55.7863569
                ],
                [
                    89.383021,
                    55.7866145
                ],
                [
                    89.3826354,
                    55.78675
                ],
                [
                    89.3821532,
                    55.7868991
                ],
                [
                    89.3820005,
                    55.7871567
                ],
                [
                    89.381687,
                    55.7872019
                ],
                [
                    89.3811486,
                    55.78736
                ],
                [
                    89.3809075,
                    55.7876899
                ],
                [
                    89.3809476,
                    55.7881282
                ],
                [
                    89.3796619,
                    55.7884038
                ],
                [
                    89.3789306,
                    55.7883677
                ],
                [
                    89.3776929,
                    55.7886207
                ],
                [
                    89.3775162,
                    55.7888421
                ],
                [
                    89.3774599,
                    55.7897593
                ],
                [
                    89.3776126,
                    55.7903467
                ],
                [
                    89.3778537,
                    55.7906675
                ],
                [
                    89.3770983,
                    55.7906449
                ],
                [
                    89.3767367,
                    55.7913271
                ],
                [
                    89.376841,
                    55.7915395
                ],
                [
                    89.3772751,
                    55.7916027
                ],
                [
                    89.3777412,
                    55.7915892
                ],
                [
                    89.3777899,
                    55.7917688
                ],
                [
                    89.3771118,
                    55.7918183
                ],
                [
                    89.3750273,
                    55.7922277
                ],
                [
                    89.3743367,
                    55.7924042
                ],
                [
                    89.3734201,
                    55.7924536
                ],
                [
                    89.3731564,
                    55.7929054
                ]
            ],
            "longitude": 89.383156,
            "latitude": 55.790306
        },
        "218": {
            "name": "Красинка",
            "population": 158,
            "type": "village",
            "poly": [
                [
                    89.3673508,
                    56.8499521
                ],
                [
                    89.3693201,
                    56.850532
                ],
                [
                    89.3709107,
                    56.8501385
                ],
                [
                    89.3709865,
                    56.8497657
                ],
                [
                    89.3724256,
                    56.8500142
                ],
                [
                    89.3737511,
                    56.8509462
                ],
                [
                    89.3732588,
                    56.8515881
                ],
                [
                    89.3735996,
                    56.8517124
                ],
                [
                    89.3744327,
                    56.851174
                ],
                [
                    89.3759856,
                    56.8512361
                ],
                [
                    89.37644,
                    56.8509462
                ],
                [
                    89.3777277,
                    56.8513603
                ],
                [
                    89.3784094,
                    56.8511118
                ],
                [
                    89.3782579,
                    56.8506148
                ],
                [
                    89.3822723,
                    56.8495586
                ],
                [
                    89.382954,
                    56.8491237
                ],
                [
                    89.3838787,
                    56.8491212
                ],
                [
                    89.383995,
                    56.8496408
                ],
                [
                    89.3834909,
                    56.8504679
                ],
                [
                    89.3833495,
                    56.851941
                ],
                [
                    89.3839176,
                    56.8524173
                ],
                [
                    89.3816453,
                    56.8534527
                ],
                [
                    89.3816832,
                    56.8540739
                ],
                [
                    89.3828572,
                    56.8554198
                ],
                [
                    89.3828193,
                    56.8574697
                ],
                [
                    89.381153,
                    56.8583601
                ],
                [
                    89.3807743,
                    56.8596023
                ],
                [
                    89.3859626,
                    56.8598922
                ],
                [
                    89.3861142,
                    56.8604512
                ],
                [
                    89.3916435,
                    56.8600785
                ],
                [
                    89.3913783,
                    56.8572627
                ],
                [
                    89.3949762,
                    56.8573662
                ],
                [
                    89.3968698,
                    56.857097
                ],
                [
                    89.3979681,
                    56.8560203
                ],
                [
                    89.3984983,
                    56.8545916
                ],
                [
                    89.3995966,
                    56.8527072
                ],
                [
                    89.4014902,
                    56.8519617
                ],
                [
                    89.3998617,
                    56.8507191
                ],
                [
                    89.3980438,
                    56.8509884
                ],
                [
                    89.3959609,
                    56.8510505
                ],
                [
                    89.3950897,
                    56.8497044
                ],
                [
                    89.3931962,
                    56.8494352
                ],
                [
                    89.3837266,
                    56.8518025
                ],
                [
                    89.3837654,
                    56.8506574
                ],
                [
                    89.3843859,
                    56.8497667
                ],
                [
                    89.3841726,
                    56.8490139
                ],
                [
                    89.3855686,
                    56.8492047
                ],
                [
                    89.3870423,
                    56.8491517
                ],
                [
                    89.3884578,
                    56.8485685
                ],
                [
                    89.3914052,
                    56.847699
                ],
                [
                    89.3918124,
                    56.847243
                ],
                [
                    89.3930728,
                    56.8471794
                ],
                [
                    89.3938096,
                    56.8468189
                ],
                [
                    89.3940035,
                    56.8473385
                ],
                [
                    89.3947015,
                    56.8473066
                ],
                [
                    89.3952445,
                    56.8469143
                ],
                [
                    89.3967763,
                    56.8469037
                ],
                [
                    89.3970672,
                    56.84719
                ],
                [
                    89.3973453,
                    56.8456235
                ],
                [
                    89.3973453,
                    56.8451679
                ],
                [
                    89.3953381,
                    56.8449193
                ],
                [
                    89.3931415,
                    56.8433244
                ],
                [
                    89.387991,
                    56.8445672
                ],
                [
                    89.387688,
                    56.8461621
                ],
                [
                    89.3841659,
                    56.846452
                ],
                [
                    89.3843553,
                    56.8457892
                ],
                [
                    89.3805681,
                    56.846307
                ],
                [
                    89.3791289,
                    56.8468662
                ],
                [
                    89.3781063,
                    56.8460171
                ],
                [
                    89.3722741,
                    56.8474876
                ],
                [
                    89.3731452,
                    56.8481089
                ],
                [
                    89.3728801,
                    56.8487095
                ],
                [
                    89.3715546,
                    56.8491237
                ],
                [
                    89.3693201,
                    56.8487923
                ],
                [
                    89.3684112,
                    56.8483781
                ],
                [
                    89.3676159,
                    56.8488752
                ],
                [
                    89.3681461,
                    56.8492066
                ],
                [
                    89.3681082,
                    56.8496829
                ],
                [
                    89.3673508,
                    56.8499521
                ]
            ],
            "longitude": 89.389305,
            "latitude": 56.852524
        },
        "219": {
            "name": "Майское",
            "population": 522,
            "type": "village",
            "poly": null,
            "longitude": 89.420494,
            "latitude": 60.019062
        },
        "220": {
            "name": "Лазарево",
            "population": 396,
            "type": "village",
            "poly": [
                [
                    89.4322353,
                    56.4398159
                ],
                [
                    89.4332024,
                    56.4409378
                ],
                [
                    89.4339634,
                    56.4411744
                ],
                [
                    89.4363099,
                    56.4426643
                ],
                [
                    89.439893,
                    56.4437335
                ],
                [
                    89.441304,
                    56.4443031
                ],
                [
                    89.4417321,
                    56.4447238
                ],
                [
                    89.443793,
                    56.4450743
                ],
                [
                    89.4434126,
                    56.4460821
                ],
                [
                    89.4413991,
                    56.4458367
                ],
                [
                    89.4397661,
                    56.4459857
                ],
                [
                    89.4386087,
                    56.4454248
                ],
                [
                    89.4386563,
                    56.4449691
                ],
                [
                    89.4359452,
                    56.4444609
                ],
                [
                    89.4346293,
                    56.4467831
                ],
                [
                    89.4337256,
                    56.4474666
                ],
                [
                    89.4337731,
                    56.4483078
                ],
                [
                    89.4367221,
                    56.4490877
                ],
                [
                    89.4388307,
                    56.4494645
                ],
                [
                    89.4395442,
                    56.4501654
                ],
                [
                    89.4428887,
                    56.4505849
                ],
                [
                    89.4431463,
                    56.4516801
                ],
                [
                    89.445901,
                    56.4521949
                ],
                [
                    89.4464361,
                    56.4522935
                ],
                [
                    89.4477639,
                    56.4530601
                ],
                [
                    89.4492305,
                    56.4525235
                ],
                [
                    89.4495872,
                    56.4517787
                ],
                [
                    89.4495674,
                    56.4505301
                ],
                [
                    89.4512717,
                    56.4497963
                ],
                [
                    89.451787,
                    56.4496977
                ],
                [
                    89.4519852,
                    56.4494349
                ],
                [
                    89.4516086,
                    56.449172
                ],
                [
                    89.4516967,
                    56.4477525
                ],
                [
                    89.4540533,
                    56.4475653
                ],
                [
                    89.4541325,
                    56.4479684
                ],
                [
                    89.454624,
                    56.4481787
                ],
                [
                    89.4543704,
                    56.4489936
                ],
                [
                    89.4567485,
                    56.4495895
                ],
                [
                    89.4587937,
                    56.4504044
                ],
                [
                    89.4599194,
                    56.4502204
                ],
                [
                    89.4611085,
                    56.449239
                ],
                [
                    89.4615683,
                    56.4500714
                ],
                [
                    89.4639147,
                    56.4509038
                ],
                [
                    89.4677669,
                    56.4477773
                ],
                [
                    89.4663115,
                    56.4476917
                ],
                [
                    89.4650109,
                    56.4474008
                ],
                [
                    89.4633078,
                    56.4485645
                ],
                [
                    89.4580127,
                    56.4465279
                ],
                [
                    89.4592203,
                    56.4456208
                ],
                [
                    89.4548232,
                    56.4439263
                ],
                [
                    89.4546684,
                    56.4433614
                ],
                [
                    89.452191,
                    56.4421119
                ],
                [
                    89.4520673,
                    56.4416497
                ],
                [
                    89.4516337,
                    56.4414957
                ],
                [
                    89.4509525,
                    56.4418551
                ],
                [
                    89.4503332,
                    56.4418723
                ],
                [
                    89.450488,
                    56.4415299
                ],
                [
                    89.450457,
                    56.441256
                ],
                [
                    89.4438613,
                    56.4387397
                ],
                [
                    89.4436136,
                    56.4406227
                ],
                [
                    89.4417247,
                    56.440229
                ],
                [
                    89.4407648,
                    56.4402461
                ],
                [
                    89.4401764,
                    56.4398695
                ],
                [
                    89.4388139,
                    56.4397497
                ],
                [
                    89.4363646,
                    56.4406328
                ],
                [
                    89.4353601,
                    56.4392922
                ],
                [
                    89.4351049,
                    56.4393514
                ],
                [
                    89.4322353,
                    56.4398159
                ]
            ],
            "longitude": 89.448631,
            "latitude": 56.444084
        },
        "221": {
            "name": "Шушь",
            "population": 379,
            "type": "village",
            "poly": [
                [
                    89.4392778,
                    55.6010612
                ],
                [
                    89.4393239,
                    55.6016849
                ],
                [
                    89.4394274,
                    55.6022046
                ],
                [
                    89.4398874,
                    55.602536
                ],
                [
                    89.4401289,
                    55.6028348
                ],
                [
                    89.4400254,
                    55.6030297
                ],
                [
                    89.4401864,
                    55.6034065
                ],
                [
                    89.4402554,
                    55.6041276
                ],
                [
                    89.4400139,
                    55.6046278
                ],
                [
                    89.4406464,
                    55.6047188
                ],
                [
                    89.4414399,
                    55.6049397
                ],
                [
                    89.4420379,
                    55.6053424
                ],
                [
                    89.4429349,
                    55.6059011
                ],
                [
                    89.4436134,
                    55.606044
                ],
                [
                    89.4444299,
                    55.6059336
                ],
                [
                    89.4455109,
                    55.6060115
                ],
                [
                    89.4460399,
                    55.6059206
                ],
                [
                    89.4470173,
                    55.6058946
                ],
                [
                    89.4481099,
                    55.6059661
                ],
                [
                    89.4486274,
                    55.6058361
                ],
                [
                    89.4486274,
                    55.6060895
                ],
                [
                    89.4490644,
                    55.6063558
                ],
                [
                    89.4554354,
                    55.6075641
                ],
                [
                    89.4560449,
                    55.6064727
                ],
                [
                    89.4616569,
                    55.6067651
                ],
                [
                    89.4627378,
                    55.6069989
                ],
                [
                    89.4626229,
                    55.6072718
                ],
                [
                    89.4633244,
                    55.6072977
                ],
                [
                    89.4640029,
                    55.6073237
                ],
                [
                    89.4643134,
                    55.6055438
                ],
                [
                    89.4614499,
                    55.6049202
                ],
                [
                    89.4604149,
                    55.6045044
                ],
                [
                    89.4596904,
                    55.6039262
                ],
                [
                    89.4593454,
                    55.6032311
                ],
                [
                    89.4582529,
                    55.6027438
                ],
                [
                    89.4562979,
                    55.6022176
                ],
                [
                    89.4534919,
                    55.6017239
                ],
                [
                    89.4532964,
                    55.6015939
                ],
                [
                    89.4533424,
                    55.6011196
                ],
                [
                    89.4539059,
                    55.5988197
                ],
                [
                    89.4541704,
                    55.5971433
                ],
                [
                    89.4542947,
                    55.5970654
                ],
                [
                    89.4557322,
                    55.5971694
                ],
                [
                    89.4555597,
                    55.5981895
                ],
                [
                    89.4559622,
                    55.5985533
                ],
                [
                    89.455861,
                    55.598876
                ],
                [
                    89.4562635,
                    55.5988955
                ],
                [
                    89.4578274,
                    55.598889
                ],
                [
                    89.4592075,
                    55.5987785
                ],
                [
                    89.460185,
                    55.598772
                ],
                [
                    89.460346,
                    55.5981093
                ],
                [
                    89.460116,
                    55.5974401
                ],
                [
                    89.460323,
                    55.5961405
                ],
                [
                    89.459311,
                    55.5961275
                ],
                [
                    89.4592075,
                    55.596251
                ],
                [
                    89.4576435,
                    55.5960041
                ],
                [
                    89.4574825,
                    55.5958287
                ],
                [
                    89.457908,
                    55.5950749
                ],
                [
                    89.457793,
                    55.594672
                ],
                [
                    89.45685,
                    55.5944121
                ],
                [
                    89.455217,
                    55.5942756
                ],
                [
                    89.455217,
                    55.5940612
                ],
                [
                    89.4547779,
                    55.5942017
                ],
                [
                    89.4548138,
                    55.5937448
                ],
                [
                    89.4559638,
                    55.5919984
                ],
                [
                    89.4572216,
                    55.5909221
                ],
                [
                    89.4594137,
                    55.5903332
                ],
                [
                    89.4572755,
                    55.5896934
                ],
                [
                    89.4545982,
                    55.5892974
                ],
                [
                    89.4545982,
                    55.5900184
                ],
                [
                    89.4529629,
                    55.5903138
                ],
                [
                    89.4507318,
                    55.5905412
                ],
                [
                    89.4503524,
                    55.5908077
                ],
                [
                    89.4500764,
                    55.5912561
                ],
                [
                    89.4490644,
                    55.5913666
                ],
                [
                    89.4486158,
                    55.591646
                ],
                [
                    89.4481789,
                    55.591659
                ],
                [
                    89.4473509,
                    55.5918669
                ],
                [
                    89.4466379,
                    55.5921854
                ],
                [
                    89.4456833,
                    55.5921139
                ],
                [
                    89.4450509,
                    55.5919319
                ],
                [
                    89.4449819,
                    55.5916525
                ],
                [
                    89.4444759,
                    55.5909961
                ],
                [
                    89.4429349,
                    55.5913146
                ],
                [
                    89.4425439,
                    55.5916785
                ],
                [
                    89.4420724,
                    55.5919709
                ],
                [
                    89.4419804,
                    55.5923088
                ],
                [
                    89.4421184,
                    55.5925233
                ],
                [
                    89.4420724,
                    55.5927052
                ],
                [
                    89.4417159,
                    55.5928092
                ],
                [
                    89.4410374,
                    55.5927117
                ],
                [
                    89.4406118,
                    55.5928547
                ],
                [
                    89.4402784,
                    55.5932186
                ],
                [
                    89.4405429,
                    55.5937125
                ],
                [
                    89.4410029,
                    55.5939464
                ],
                [
                    89.4409684,
                    55.5941478
                ],
                [
                    89.4407729,
                    55.5943493
                ],
                [
                    89.4404049,
                    55.5945637
                ],
                [
                    89.4404509,
                    55.5947846
                ],
                [
                    89.4407844,
                    55.5949211
                ],
                [
                    89.4414053,
                    55.5949536
                ],
                [
                    89.4414974,
                    55.5951095
                ],
                [
                    89.4416239,
                    55.5954149
                ],
                [
                    89.4419574,
                    55.5954669
                ],
                [
                    89.4420379,
                    55.5955904
                ],
                [
                    89.4420034,
                    55.5957138
                ],
                [
                    89.4420609,
                    55.5959737
                ],
                [
                    89.4419458,
                    55.5961817
                ],
                [
                    89.4417619,
                    55.5961622
                ],
                [
                    89.4415204,
                    55.5962661
                ],
                [
                    89.4415319,
                    55.5964741
                ],
                [
                    89.4417849,
                    55.596617
                ],
                [
                    89.4421874,
                    55.5965455
                ],
                [
                    89.4425439,
                    55.596552
                ],
                [
                    89.4426704,
                    55.596773
                ],
                [
                    89.4426474,
                    55.5971758
                ],
                [
                    89.4424748,
                    55.5973123
                ],
                [
                    89.4422449,
                    55.5976112
                ],
                [
                    89.4419919,
                    55.5976696
                ],
                [
                    89.4419114,
                    55.5979035
                ],
                [
                    89.4416813,
                    55.5981245
                ],
                [
                    89.4413364,
                    55.5981699
                ],
                [
                    89.4409569,
                    55.5980205
                ],
                [
                    89.4403358,
                    55.598131
                ],
                [
                    89.4401289,
                    55.5985208
                ],
                [
                    89.4399449,
                    55.5990276
                ],
                [
                    89.4396229,
                    55.5994499
                ],
                [
                    89.4398644,
                    55.5997423
                ],
                [
                    89.4401404,
                    55.5999242
                ],
                [
                    89.4397724,
                    55.6000866
                ],
                [
                    89.4392894,
                    55.600444
                ],
                [
                    89.4392778,
                    55.6010612
                ]
            ],
            "longitude": 89.451073,
            "latitude": 55.596157
        },
        "222": {
            "name": "Новоалтатка",
            "population": 828,
            "type": "village",
            "poly": [
                [
                    89.4540982,
                    55.740698
                ],
                [
                    89.4561426,
                    55.7415479
                ],
                [
                    89.4563396,
                    55.7418805
                ],
                [
                    89.4554955,
                    55.7431845
                ],
                [
                    89.4582092,
                    55.7435296
                ],
                [
                    89.4579511,
                    55.7440358
                ],
                [
                    89.4577396,
                    55.7442504
                ],
                [
                    89.4578288,
                    55.7442665
                ],
                [
                    89.4597064,
                    55.7446045
                ],
                [
                    89.4602597,
                    55.7446415
                ],
                [
                    89.4627824,
                    55.7450479
                ],
                [
                    89.4652677,
                    55.7453119
                ],
                [
                    89.4653333,
                    55.7463518
                ],
                [
                    89.4667025,
                    55.7462937
                ],
                [
                    89.4668151,
                    55.7463729
                ],
                [
                    89.4692253,
                    55.7461301
                ],
                [
                    89.4690564,
                    55.7455494
                ],
                [
                    89.4684938,
                    55.7455019
                ],
                [
                    89.4681468,
                    55.7452485
                ],
                [
                    89.4684281,
                    55.7447998
                ],
                [
                    89.4693659,
                    55.7442614
                ],
                [
                    89.4699755,
                    55.7438971
                ],
                [
                    89.470135,
                    55.7436596
                ],
                [
                    89.4699943,
                    55.7435382
                ],
                [
                    89.4708946,
                    55.7432953
                ],
                [
                    89.4717011,
                    55.7430842
                ],
                [
                    89.4745477,
                    55.742076
                ],
                [
                    89.4750166,
                    55.7417487
                ],
                [
                    89.475101,
                    55.7414795
                ],
                [
                    89.474904,
                    55.7408829
                ],
                [
                    89.4749322,
                    55.7395472
                ],
                [
                    89.4760294,
                    55.7396211
                ],
                [
                    89.4775768,
                    55.7396158
                ],
                [
                    89.478102,
                    55.7394839
                ],
                [
                    89.4785428,
                    55.7392146
                ],
                [
                    89.4788334,
                    55.7387658
                ],
                [
                    89.4791242,
                    55.7383646
                ],
                [
                    89.4790774,
                    55.7379316
                ],
                [
                    89.4789273,
                    55.7373456
                ],
                [
                    89.4786553,
                    55.736749
                ],
                [
                    89.4792554,
                    55.7366803
                ],
                [
                    89.4797245,
                    55.7365958
                ],
                [
                    89.4800621,
                    55.736279
                ],
                [
                    89.4802871,
                    55.7359728
                ],
                [
                    89.4804372,
                    55.7359622
                ],
                [
                    89.4805966,
                    55.7360626
                ],
                [
                    89.4807842,
                    55.7360309
                ],
                [
                    89.480878,
                    55.7359042
                ],
                [
                    89.4813187,
                    55.7359147
                ],
                [
                    89.4817033,
                    55.73592
                ],
                [
                    89.4817595,
                    55.7357616
                ],
                [
                    89.4814876,
                    55.7354554
                ],
                [
                    89.4809905,
                    55.7353075
                ],
                [
                    89.4807936,
                    55.735165
                ],
                [
                    89.480606,
                    55.7347953
                ],
                [
                    89.480456,
                    55.7347056
                ],
                [
                    89.4797338,
                    55.7346845
                ],
                [
                    89.4787491,
                    55.7344363
                ],
                [
                    89.4778207,
                    55.7343043
                ],
                [
                    89.476836,
                    55.7342515
                ],
                [
                    89.4757575,
                    55.734336
                ],
                [
                    89.4750822,
                    55.734336
                ],
                [
                    89.4746227,
                    55.73413
                ],
                [
                    89.4744726,
                    55.7339505
                ],
                [
                    89.4743667,
                    55.7338967
                ],
                [
                    89.4748002,
                    55.7330273
                ],
                [
                    89.4763832,
                    55.7307959
                ],
                [
                    89.4766014,
                    55.7307411
                ],
                [
                    89.4775905,
                    55.7308443
                ],
                [
                    89.4780118,
                    55.7310505
                ],
                [
                    89.47999,
                    55.7313187
                ],
                [
                    89.4829206,
                    55.7314528
                ],
                [
                    89.4841662,
                    55.7311537
                ],
                [
                    89.4849172,
                    55.731164
                ],
                [
                    89.4858697,
                    55.7309886
                ],
                [
                    89.4865291,
                    55.7305142
                ],
                [
                    89.4866207,
                    55.7297716
                ],
                [
                    89.4862727,
                    55.7288949
                ],
                [
                    89.4863826,
                    55.7283276
                ],
                [
                    89.4868954,
                    55.727915
                ],
                [
                    89.4866939,
                    55.7272549
                ],
                [
                    89.4866024,
                    55.726966
                ],
                [
                    89.4874999,
                    55.7270382
                ],
                [
                    89.4884706,
                    55.7268216
                ],
                [
                    89.4895697,
                    55.7265019
                ],
                [
                    89.490229,
                    55.7261821
                ],
                [
                    89.4905954,
                    55.7255941
                ],
                [
                    89.4917311,
                    55.7241912
                ],
                [
                    89.4914071,
                    55.7236865
                ],
                [
                    89.4917373,
                    55.7235133
                ],
                [
                    89.4921124,
                    55.7228837
                ],
                [
                    89.4896545,
                    55.7223469
                ],
                [
                    89.4894565,
                    55.7222922
                ],
                [
                    89.4880385,
                    55.7234922
                ],
                [
                    89.4870632,
                    55.7231119
                ],
                [
                    89.4869956,
                    55.7232091
                ],
                [
                    89.4859378,
                    55.7228922
                ],
                [
                    89.4847749,
                    55.7220893
                ],
                [
                    89.4846023,
                    55.7217259
                ],
                [
                    89.4837095,
                    55.7214766
                ],
                [
                    89.4834244,
                    55.7211977
                ],
                [
                    89.4822015,
                    55.7209696
                ],
                [
                    89.4818238,
                    55.7211994
                ],
                [
                    89.4815613,
                    55.7211191
                ],
                [
                    89.4806759,
                    55.7206078
                ],
                [
                    89.4777349,
                    55.7198979
                ],
                [
                    89.4772398,
                    55.719974
                ],
                [
                    89.4764445,
                    55.7203923
                ],
                [
                    89.4747564,
                    55.7207177
                ],
                [
                    89.4744863,
                    55.7208783
                ],
                [
                    89.4736535,
                    55.7218713
                ],
                [
                    89.4731584,
                    55.7226741
                ],
                [
                    89.4730683,
                    55.723384
                ],
                [
                    89.4731058,
                    55.7240389
                ],
                [
                    89.4736385,
                    55.7242122
                ],
                [
                    89.4738711,
                    55.724246
                ],
                [
                    89.4741637,
                    55.7246262
                ],
                [
                    89.473511,
                    55.7256783
                ],
                [
                    89.4733609,
                    55.7267768
                ],
                [
                    89.4733834,
                    55.7272585
                ],
                [
                    89.4729783,
                    55.7279091
                ],
                [
                    89.4726782,
                    55.7288428
                ],
                [
                    89.4728508,
                    55.7302201
                ],
                [
                    89.4730383,
                    55.7304144
                ],
                [
                    89.4743438,
                    55.7304482
                ],
                [
                    89.4740737,
                    55.7308537
                ],
                [
                    89.473541,
                    55.7316522
                ],
                [
                    89.4734059,
                    55.7324928
                ],
                [
                    89.4730083,
                    55.7328773
                ],
                [
                    89.4724156,
                    55.7336799
                ],
                [
                    89.4711295,
                    55.7347902
                ],
                [
                    89.4702291,
                    55.7353446
                ],
                [
                    89.4702319,
                    55.7355147
                ],
                [
                    89.4688942,
                    55.7364154
                ],
                [
                    89.4680563,
                    55.7366555
                ],
                [
                    89.4649807,
                    55.7375472
                ],
                [
                    89.4624607,
                    55.7382366
                ],
                [
                    89.4621451,
                    55.7380637
                ],
                [
                    89.4618262,
                    55.7378209
                ],
                [
                    89.4613761,
                    55.7377522
                ],
                [
                    89.4603539,
                    55.7378314
                ],
                [
                    89.459416,
                    55.7376361
                ],
                [
                    89.4587127,
                    55.737673
                ],
                [
                    89.4583188,
                    55.7377681
                ],
                [
                    89.4577373,
                    55.7384703
                ],
                [
                    89.4573341,
                    55.738919
                ],
                [
                    89.4568745,
                    55.7391197
                ],
                [
                    89.4562181,
                    55.7392464
                ],
                [
                    89.4554959,
                    55.7392464
                ],
                [
                    89.4552052,
                    55.7398905
                ],
                [
                    89.4546519,
                    55.7401597
                ],
                [
                    89.4540982,
                    55.740698
                ]
            ],
            "longitude": 89.474472,
            "latitude": 55.730236
        },
        "223": {
            "name": "Ораки",
            "population": 349,
            "type": "village",
            "poly": [
                [
                    89.4989965,
                    55.312658
                ],
                [
                    89.4999434,
                    55.313989
                ],
                [
                    89.5039287,
                    55.3201095
                ],
                [
                    89.5039162,
                    55.3225392
                ],
                [
                    89.501656,
                    55.3243152
                ],
                [
                    89.500146,
                    55.3264302
                ],
                [
                    89.5007063,
                    55.3263704
                ],
                [
                    89.5014265,
                    55.326322
                ],
                [
                    89.502867,
                    55.3262794
                ],
                [
                    89.5037674,
                    55.3263448
                ],
                [
                    89.5051979,
                    55.3265241
                ],
                [
                    89.5061132,
                    55.3265383
                ],
                [
                    89.5067735,
                    55.3266151
                ],
                [
                    89.5074337,
                    55.3267972
                ],
                [
                    89.508194,
                    55.3271387
                ],
                [
                    89.5084891,
                    55.327392
                ],
                [
                    89.5090593,
                    55.327833
                ],
                [
                    89.5092306,
                    55.3279073
                ],
                [
                    89.509437,
                    55.327983
                ],
                [
                    89.5095745,
                    55.3280464
                ],
                [
                    89.5098546,
                    55.3281431
                ],
                [
                    89.5100147,
                    55.3283082
                ],
                [
                    89.5100047,
                    55.3284988
                ],
                [
                    89.5097746,
                    55.3286724
                ],
                [
                    89.5095645,
                    55.3287805
                ],
                [
                    89.5095995,
                    55.3289512
                ],
                [
                    89.5098446,
                    55.329122
                ],
                [
                    89.5099747,
                    55.3293809
                ],
                [
                    89.5101447,
                    55.3296967
                ],
                [
                    89.5118904,
                    55.3312161
                ],
                [
                    89.5121755,
                    55.3313925
                ],
                [
                    89.5139991,
                    55.3321841
                ],
                [
                    89.5143552,
                    55.3319838
                ],
                [
                    89.516428,
                    55.333065
                ],
                [
                    89.51641,
                    55.3333537
                ],
                [
                    89.517509,
                    55.333826
                ],
                [
                    89.5194995,
                    55.3343539
                ],
                [
                    89.5208183,
                    55.3347011
                ],
                [
                    89.5212946,
                    55.334979
                ],
                [
                    89.5218075,
                    55.3355207
                ],
                [
                    89.5239567,
                    55.3364723
                ],
                [
                    89.5243719,
                    55.3365278
                ],
                [
                    89.5256541,
                    55.3365417
                ],
                [
                    89.5262158,
                    55.3370348
                ],
                [
                    89.527669,
                    55.337139
                ],
                [
                    89.5287314,
                    55.3373751
                ],
                [
                    89.5297449,
                    55.337264
                ],
                [
                    89.5299525,
                    55.3371112
                ],
                [
                    89.5299159,
                    55.3368751
                ],
                [
                    89.5307463,
                    55.3363611
                ],
                [
                    89.5308806,
                    55.3350554
                ],
                [
                    89.5306364,
                    55.3349373
                ],
                [
                    89.5284627,
                    55.3346039
                ],
                [
                    89.5277911,
                    55.3340205
                ],
                [
                    89.5290245,
                    55.3325549
                ],
                [
                    89.5294152,
                    55.3324576
                ],
                [
                    89.5300502,
                    55.332027
                ],
                [
                    89.5275835,
                    55.3311934
                ],
                [
                    89.5263501,
                    55.3306516
                ],
                [
                    89.5250069,
                    55.3302279
                ],
                [
                    89.5235733,
                    55.3299582
                ],
                [
                    89.523456,
                    55.3299361
                ],
                [
                    89.5231751,
                    55.3296791
                ],
                [
                    89.5222471,
                    55.3292553
                ],
                [
                    89.5213678,
                    55.3290539
                ],
                [
                    89.5221372,
                    55.3285607
                ],
                [
                    89.5223814,
                    55.328255
                ],
                [
                    89.5226623,
                    55.3280605
                ],
                [
                    89.5222837,
                    55.3278799
                ],
                [
                    89.5205985,
                    55.3276506
                ],
                [
                    89.5197926,
                    55.3279077
                ],
                [
                    89.518376,
                    55.3278868
                ],
                [
                    89.5184981,
                    55.3277271
                ],
                [
                    89.5176922,
                    55.3269073
                ],
                [
                    89.5173625,
                    55.3267545
                ],
                [
                    89.5150911,
                    55.324844
                ],
                [
                    89.5153231,
                    55.3230237
                ],
                [
                    89.5149934,
                    55.3222386
                ],
                [
                    89.5149324,
                    55.3209949
                ],
                [
                    89.5146881,
                    55.3197373
                ],
                [
                    89.5148713,
                    55.319112
                ],
                [
                    89.5149446,
                    55.3183963
                ],
                [
                    89.5142485,
                    55.3177361
                ],
                [
                    89.5133571,
                    55.3172219
                ],
                [
                    89.508851,
                    55.3160406
                ],
                [
                    89.5075078,
                    55.3154778
                ],
                [
                    89.5073246,
                    55.3152901
                ],
                [
                    89.5070071,
                    55.3151442
                ],
                [
                    89.5065431,
                    55.3151234
                ],
                [
                    89.5055783,
                    55.3150052
                ],
                [
                    89.5029651,
                    55.3137961
                ],
                [
                    89.4989965,
                    55.312658
                ]
            ],
            "longitude": 89.51181,
            "latitude": 55.324841
        },
        "224": {
            "name": "Белоозёрка",
            "population": 276,
            "type": "village",
            "poly": [
                [
                    89.5325311,
                    55.6546063
                ],
                [
                    89.5326101,
                    55.6547402
                ],
                [
                    89.5330584,
                    55.6549286
                ],
                [
                    89.5336736,
                    55.6551616
                ],
                [
                    89.5327948,
                    55.6556326
                ],
                [
                    89.5327068,
                    55.6558012
                ],
                [
                    89.5329266,
                    55.6562375
                ],
                [
                    89.5342973,
                    55.6574828
                ],
                [
                    89.5353176,
                    55.6585112
                ],
                [
                    89.5354353,
                    55.6584772
                ],
                [
                    89.5357834,
                    55.6581799
                ],
                [
                    89.5361541,
                    55.6575834
                ],
                [
                    89.5362365,
                    55.6571961
                ],
                [
                    89.5370467,
                    55.6565067
                ],
                [
                    89.5373898,
                    55.6556933
                ],
                [
                    89.5378705,
                    55.6556158
                ],
                [
                    89.5387767,
                    55.6555228
                ],
                [
                    89.5392025,
                    55.6556158
                ],
                [
                    89.5396831,
                    55.6556235
                ],
                [
                    89.5400813,
                    55.6555228
                ],
                [
                    89.5419899,
                    55.653989
                ],
                [
                    89.542237,
                    55.653896
                ],
                [
                    89.5430609,
                    55.6538883
                ],
                [
                    89.5438024,
                    55.6542059
                ],
                [
                    89.5468506,
                    55.6549728
                ],
                [
                    89.5473588,
                    55.6542834
                ],
                [
                    89.5476197,
                    55.6540664
                ],
                [
                    89.548471,
                    55.6537023
                ],
                [
                    89.5502972,
                    55.6547404
                ],
                [
                    89.5505169,
                    55.6554299
                ],
                [
                    89.5521234,
                    55.6575059
                ],
                [
                    89.5523706,
                    55.6581179
                ],
                [
                    89.553785,
                    55.6587221
                ],
                [
                    89.5541832,
                    55.6587453
                ],
                [
                    89.557616,
                    55.6556545
                ],
                [
                    89.5584261,
                    55.6560264
                ],
                [
                    89.5593186,
                    55.6558947
                ],
                [
                    89.5606368,
                    55.6550503
                ],
                [
                    89.5623532,
                    55.6532143
                ],
                [
                    89.5591891,
                    55.6521802
                ],
                [
                    89.5562891,
                    55.6511141
                ],
                [
                    89.5539163,
                    55.650141
                ],
                [
                    89.551972,
                    55.6496266
                ],
                [
                    89.5509065,
                    55.6494716
                ],
                [
                    89.5518841,
                    55.648232
                ],
                [
                    89.5520269,
                    55.6479902
                ],
                [
                    89.5518951,
                    55.6478476
                ],
                [
                    89.5500385,
                    55.6473084
                ],
                [
                    89.549753,
                    55.6469055
                ],
                [
                    89.549753,
                    55.6460996
                ],
                [
                    89.5488083,
                    55.6448226
                ],
                [
                    89.5482371,
                    55.6444693
                ],
                [
                    89.5464246,
                    55.6437192
                ],
                [
                    89.5456007,
                    55.6429815
                ],
                [
                    89.5453176,
                    55.6425467
                ],
                [
                    89.5420221,
                    55.6436973
                ],
                [
                    89.5415827,
                    55.6445205
                ],
                [
                    89.5413543,
                    55.6449767
                ],
                [
                    89.5407567,
                    55.6454231
                ],
                [
                    89.5404667,
                    55.6462612
                ],
                [
                    89.5398427,
                    55.6462512
                ],
                [
                    89.5393418,
                    55.6467471
                ],
                [
                    89.5386388,
                    55.6469951
                ],
                [
                    89.538173,
                    55.6474017
                ],
                [
                    89.53834,
                    55.6475009
                ],
                [
                    89.5376457,
                    55.6480513
                ],
                [
                    89.5375051,
                    55.6479819
                ],
                [
                    89.5365209,
                    55.6486761
                ],
                [
                    89.5368548,
                    55.6488249
                ],
                [
                    89.5366439,
                    55.6489191
                ],
                [
                    89.5360727,
                    55.6490133
                ],
                [
                    89.5358882,
                    55.6489142
                ],
                [
                    89.5357212,
                    55.6489588
                ],
                [
                    89.5348248,
                    55.6495836
                ],
                [
                    89.5350269,
                    55.6508034
                ],
                [
                    89.5351324,
                    55.6510116
                ],
                [
                    89.5354488,
                    55.6511406
                ],
                [
                    89.5358969,
                    55.6512496
                ],
                [
                    89.5353872,
                    55.6518794
                ],
                [
                    89.5345612,
                    55.6524545
                ],
                [
                    89.5339109,
                    55.6533371
                ],
                [
                    89.5328036,
                    55.654294
                ],
                [
                    89.5325311,
                    55.6546063
                ]
            ],
            "longitude": 89.545105,
            "latitude": 55.651161
        },
        "225": {
            "name": "Ашпан",
            "population": 298,
            "type": "village",
            "poly": [
                [
                    89.546762,
                    55.372804
                ],
                [
                    89.5469791,
                    55.3736673
                ],
                [
                    89.5474578,
                    55.3740445
                ],
                [
                    89.548377,
                    55.3746284
                ],
                [
                    89.5494877,
                    55.3749585
                ],
                [
                    89.5502984,
                    55.3752015
                ],
                [
                    89.5507324,
                    55.3752487
                ],
                [
                    89.5562667,
                    55.3760829
                ],
                [
                    89.5563242,
                    55.3763259
                ],
                [
                    89.5565221,
                    55.3765725
                ],
                [
                    89.5564582,
                    55.3779615
                ],
                [
                    89.5564838,
                    55.3782081
                ],
                [
                    89.556937,
                    55.378491
                ],
                [
                    89.559337,
                    55.3790785
                ],
                [
                    89.5600073,
                    55.3790713
                ],
                [
                    89.5610606,
                    55.3790931
                ],
                [
                    89.5617372,
                    55.3791656
                ],
                [
                    89.5620755,
                    55.3790387
                ],
                [
                    89.5627585,
                    55.3789262
                ],
                [
                    89.5633202,
                    55.3789697
                ],
                [
                    89.5641245,
                    55.3790713
                ],
                [
                    89.5654522,
                    55.3790677
                ],
                [
                    89.5657842,
                    55.3791583
                ],
                [
                    89.5658927,
                    55.3793143
                ],
                [
                    89.5658352,
                    55.379579
                ],
                [
                    89.5655863,
                    55.3798873
                ],
                [
                    89.5655671,
                    55.3800577
                ],
                [
                    89.5657459,
                    55.3802427
                ],
                [
                    89.569429,
                    55.3806924
                ],
                [
                    89.569678,
                    55.3806525
                ],
                [
                    89.5699716,
                    55.3802789
                ],
                [
                    89.5706227,
                    55.379307
                ],
                [
                    89.5721547,
                    55.3801012
                ],
                [
                    89.5722701,
                    55.380073
                ],
                [
                    89.5725632,
                    55.3798546
                ],
                [
                    89.57301,
                    55.3795464
                ],
                [
                    89.5730674,
                    55.3789153
                ],
                [
                    89.5725632,
                    55.3781356
                ],
                [
                    89.57241,
                    55.3774683
                ],
                [
                    89.5722696,
                    55.3771709
                ],
                [
                    89.5723653,
                    55.376616
                ],
                [
                    89.5724802,
                    55.3754663
                ],
                [
                    89.5726015,
                    55.3749222
                ],
                [
                    89.5738909,
                    55.3733916
                ],
                [
                    89.5747016,
                    55.3723833
                ],
                [
                    89.5748739,
                    55.372035
                ],
                [
                    89.5747334,
                    55.3716179
                ],
                [
                    89.574459,
                    55.3709505
                ],
                [
                    89.5745356,
                    55.3705043
                ],
                [
                    89.5753208,
                    55.3693072
                ],
                [
                    89.5756655,
                    55.3683677
                ],
                [
                    89.5754962,
                    55.3679007
                ],
                [
                    89.575149,
                    55.3676192
                ],
                [
                    89.5740511,
                    55.3671548
                ],
                [
                    89.5735812,
                    55.3670881
                ],
                [
                    89.5731319,
                    55.3668762
                ],
                [
                    89.5727182,
                    55.3667746
                ],
                [
                    89.5718552,
                    55.3666644
                ],
                [
                    89.5712577,
                    55.3669256
                ],
                [
                    89.570701,
                    55.3671577
                ],
                [
                    89.5699355,
                    55.3675737
                ],
                [
                    89.5690005,
                    55.3678713
                ],
                [
                    89.5684292,
                    55.367942
                ],
                [
                    89.5677194,
                    55.3679913
                ],
                [
                    89.5682914,
                    55.3685543
                ],
                [
                    89.5685467,
                    55.3687169
                ],
                [
                    89.5687561,
                    55.3692363
                ],
                [
                    89.5677552,
                    55.3705567
                ],
                [
                    89.5675253,
                    55.3711081
                ],
                [
                    89.5671679,
                    55.3716972
                ],
                [
                    89.5671526,
                    55.3722195
                ],
                [
                    89.566596,
                    55.372617
                ],
                [
                    89.566356,
                    55.3729101
                ],
                [
                    89.5662896,
                    55.3731713
                ],
                [
                    89.566024,
                    55.3734208
                ],
                [
                    89.5653755,
                    55.3736326
                ],
                [
                    89.5647576,
                    55.373563
                ],
                [
                    89.5653551,
                    55.3741869
                ],
                [
                    89.565447,
                    55.3744277
                ],
                [
                    89.5642265,
                    55.3745641
                ],
                [
                    89.5621379,
                    55.3746221
                ],
                [
                    89.5603557,
                    55.3747266
                ],
                [
                    89.558788,
                    55.3747643
                ],
                [
                    89.5539469,
                    55.3739721
                ],
                [
                    89.5533368,
                    55.3738196
                ],
                [
                    89.5531964,
                    55.3736854
                ],
                [
                    89.5529538,
                    55.3735621
                ],
                [
                    89.5525963,
                    55.3735403
                ],
                [
                    89.5524495,
                    55.3736745
                ],
                [
                    89.5520091,
                    55.3735621
                ],
                [
                    89.5519836,
                    55.3733807
                ],
                [
                    89.5519006,
                    55.3732683
                ],
                [
                    89.551141,
                    55.3732248
                ],
                [
                    89.5509559,
                    55.3731667
                ],
                [
                    89.5484536,
                    55.3730253
                ],
                [
                    89.5473876,
                    55.3727532
                ],
                [
                    89.5468642,
                    55.372532
                ],
                [
                    89.546762,
                    55.372804
                ]
            ],
            "longitude": 89.569847,
            "latitude": 55.374088
        },
        "226": {
            "name": "Березовское",
            "population": 1658,
            "type": "village",
            "poly": [
                [
                    89.5557681,
                    55.8452255
                ],
                [
                    89.5603953,
                    55.8455985
                ],
                [
                    89.5592549,
                    55.846119
                ],
                [
                    89.5592057,
                    55.8464691
                ],
                [
                    89.5590251,
                    55.8474547
                ],
                [
                    89.5584673,
                    55.8480305
                ],
                [
                    89.5559979,
                    55.849426
                ],
                [
                    89.5591237,
                    55.8505682
                ],
                [
                    89.5613224,
                    55.8493984
                ],
                [
                    89.5657527,
                    55.8476666
                ],
                [
                    89.5663761,
                    55.8466579
                ],
                [
                    89.5762459,
                    55.8502826
                ],
                [
                    89.5789789,
                    55.850722
                ],
                [
                    89.5836066,
                    55.8510027
                ],
                [
                    89.5869524,
                    55.850722
                ],
                [
                    89.5877216,
                    55.8513697
                ],
                [
                    89.5882428,
                    55.8515957
                ],
                [
                    89.588478,
                    55.8517773
                ],
                [
                    89.5894735,
                    55.852039
                ],
                [
                    89.5912236,
                    55.8538779
                ],
                [
                    89.5924576,
                    55.8544563
                ],
                [
                    89.5929103,
                    55.8547621
                ],
                [
                    89.5947678,
                    55.8550863
                ],
                [
                    89.5955685,
                    55.8551047
                ],
                [
                    89.5961265,
                    55.8549942
                ],
                [
                    89.5965794,
                    55.8554031
                ],
                [
                    89.5977542,
                    55.8549758
                ],
                [
                    89.5982465,
                    55.8554805
                ],
                [
                    89.5984735,
                    55.8554554
                ],
                [
                    89.5986443,
                    55.8553562
                ],
                [
                    89.6017317,
                    55.8549052
                ],
                [
                    89.6022935,
                    55.8553856
                ],
                [
                    89.6029761,
                    55.8557717
                ],
                [
                    89.6034487,
                    55.8562786
                ],
                [
                    89.6052917,
                    55.857369
                ],
                [
                    89.6056015,
                    55.8578022
                ],
                [
                    89.6066674,
                    55.858589
                ],
                [
                    89.6064468,
                    55.8588926
                ],
                [
                    89.6065256,
                    55.8590134
                ],
                [
                    89.6083884,
                    55.8600613
                ],
                [
                    89.6095541,
                    55.8597902
                ],
                [
                    89.6100687,
                    55.8595839
                ],
                [
                    89.6105202,
                    55.8596369
                ],
                [
                    89.6118171,
                    55.8593953
                ],
                [
                    89.6123527,
                    55.8591949
                ],
                [
                    89.6127255,
                    55.8589798
                ],
                [
                    89.6119116,
                    55.858582
                ],
                [
                    89.6117699,
                    55.8583108
                ],
                [
                    89.6111765,
                    55.8577126
                ],
                [
                    89.6109245,
                    55.8574651
                ],
                [
                    89.6109613,
                    55.8572323
                ],
                [
                    89.6107512,
                    55.8569994
                ],
                [
                    89.6108248,
                    55.8566576
                ],
                [
                    89.6108353,
                    55.8563747
                ],
                [
                    89.6104414,
                    55.8558737
                ],
                [
                    89.6103784,
                    55.8556084
                ],
                [
                    89.6093283,
                    55.8550072
                ],
                [
                    89.6091129,
                    55.8549925
                ],
                [
                    89.6074328,
                    55.8542616
                ],
                [
                    89.6063564,
                    55.8536426
                ],
                [
                    89.6063144,
                    55.8534805
                ],
                [
                    89.6057893,
                    55.8532123
                ],
                [
                    89.6052748,
                    55.8527997
                ],
                [
                    89.605238,
                    55.8526376
                ],
                [
                    89.6048494,
                    55.8522279
                ],
                [
                    89.6043296,
                    55.852057
                ],
                [
                    89.6035683,
                    55.8515972
                ],
                [
                    89.6032427,
                    55.8512229
                ],
                [
                    89.6028752,
                    55.8510666
                ],
                [
                    89.6028384,
                    55.8508868
                ],
                [
                    89.6020771,
                    55.8504182
                ],
                [
                    89.601321,
                    55.8502914
                ],
                [
                    89.6005754,
                    55.8500527
                ],
                [
                    89.6002813,
                    55.8498994
                ],
                [
                    89.6002078,
                    55.8497019
                ],
                [
                    89.6004231,
                    55.849643
                ],
                [
                    89.6004966,
                    55.8494691
                ],
                [
                    89.6005124,
                    55.8491065
                ],
                [
                    89.6002761,
                    55.8485612
                ],
                [
                    89.6006383,
                    55.8476592
                ],
                [
                    89.6015438,
                    55.8458967
                ],
                [
                    89.6012361,
                    55.8454534
                ],
                [
                    89.6009797,
                    55.8443364
                ],
                [
                    89.6012361,
                    55.8436454
                ],
                [
                    89.6022181,
                    55.8427613
                ],
                [
                    89.6067067,
                    55.842941
                ],
                [
                    89.6075271,
                    55.842941
                ],
                [
                    89.6053529,
                    55.8421521
                ],
                [
                    89.6046351,
                    55.8417203
                ],
                [
                    89.6041633,
                    55.841179
                ],
                [
                    89.6028712,
                    55.8371307
                ],
                [
                    89.6010662,
                    55.8322642
                ],
                [
                    89.6003689,
                    55.8317977
                ],
                [
                    89.5990972,
                    55.8310489
                ],
                [
                    89.5969026,
                    55.8305824
                ],
                [
                    89.5887086,
                    55.8291366
                ],
                [
                    89.5815592,
                    55.8349061
                ],
                [
                    89.5780418,
                    55.8377442
                ],
                [
                    89.5771764,
                    55.8374562
                ],
                [
                    89.5758625,
                    55.8369793
                ],
                [
                    89.5753658,
                    55.8366554
                ],
                [
                    89.5748049,
                    55.8365294
                ],
                [
                    89.5744364,
                    55.8362055
                ],
                [
                    89.5738274,
                    55.8360975
                ],
                [
                    89.5734429,
                    55.8362235
                ],
                [
                    89.572129,
                    55.8359535
                ],
                [
                    89.5716803,
                    55.8363405
                ],
                [
                    89.5704464,
                    55.8362865
                ],
                [
                    89.5695331,
                    55.8358995
                ],
                [
                    89.5680749,
                    55.8357106
                ],
                [
                    89.5680589,
                    55.8356116
                ],
                [
                    89.5685395,
                    55.8354676
                ],
                [
                    89.5673378,
                    55.8350447
                ],
                [
                    89.5670654,
                    55.8350717
                ],
                [
                    89.5665847,
                    55.8352696
                ],
                [
                    89.5641009,
                    55.8346667
                ],
                [
                    89.5636523,
                    55.8350717
                ],
                [
                    89.5616107,
                    55.8418658
                ],
                [
                    89.5611434,
                    55.8432127
                ],
                [
                    89.5592805,
                    55.8430552
                ],
                [
                    89.5584394,
                    55.8432014
                ],
                [
                    89.558199,
                    55.8447196
                ],
                [
                    89.5558092,
                    55.8445437
                ],
                [
                    89.5557681,
                    55.8452255
                ]
            ],
            "longitude": 89.584602,
            "latitude": 55.846169
        },
        "227": {
            "name": "Боготол",
            "population": 1992,
            "type": "village",
            "poly": [
                [
                    89.5606805,
                    56.1776948
                ],
                [
                    89.5639276,
                    56.1788958
                ],
                [
                    89.5647394,
                    56.1788839
                ],
                [
                    89.5652735,
                    56.1781823
                ],
                [
                    89.5679652,
                    56.1785628
                ],
                [
                    89.5683711,
                    56.1791455
                ],
                [
                    89.5688625,
                    56.18125
                ],
                [
                    89.5739895,
                    56.1799778
                ],
                [
                    89.5736691,
                    56.1793
                ],
                [
                    89.5743314,
                    56.1791573
                ],
                [
                    89.5741391,
                    56.1785747
                ],
                [
                    89.5765104,
                    56.1777542
                ],
                [
                    89.5764463,
                    56.177124
                ],
                [
                    89.5770231,
                    56.1766365
                ],
                [
                    89.5781553,
                    56.1761727
                ],
                [
                    89.5799925,
                    56.1755781
                ],
                [
                    89.5817443,
                    56.1749479
                ],
                [
                    89.5819365,
                    56.1752214
                ],
                [
                    89.5828979,
                    56.1749598
                ],
                [
                    89.5829833,
                    56.1745317
                ],
                [
                    89.5837737,
                    56.1740679
                ],
                [
                    89.5883881,
                    56.1750787
                ],
                [
                    89.588089,
                    56.176803
                ],
                [
                    89.5891144,
                    56.1766603
                ],
                [
                    89.5920412,
                    56.1755781
                ],
                [
                    89.594562,
                    56.1749835
                ],
                [
                    89.595566,
                    56.1750549
                ],
                [
                    89.5989841,
                    56.1754235
                ],
                [
                    89.6011631,
                    56.1754117
                ],
                [
                    89.6020176,
                    56.1746863
                ],
                [
                    89.6026158,
                    56.1748765
                ],
                [
                    89.6016331,
                    56.1756614
                ],
                [
                    89.6018681,
                    56.1762322
                ],
                [
                    89.6031498,
                    56.1766246
                ],
                [
                    89.6043675,
                    56.1765057
                ],
                [
                    89.6052861,
                    56.1756019
                ],
                [
                    89.608771,
                    56.1766706
                ],
                [
                    89.6088666,
                    56.1764195
                ],
                [
                    89.6091675,
                    56.175628
                ],
                [
                    89.6088394,
                    56.1742276
                ],
                [
                    89.6091538,
                    56.1728272
                ],
                [
                    89.6078139,
                    56.1714571
                ],
                [
                    89.6077456,
                    56.1704296
                ],
                [
                    89.6069116,
                    56.1702774
                ],
                [
                    89.6048607,
                    56.1693183
                ],
                [
                    89.6025228,
                    56.1688311
                ],
                [
                    89.6015794,
                    56.1683668
                ],
                [
                    89.5999251,
                    56.1682983
                ],
                [
                    89.5974834,
                    56.1677118
                ],
                [
                    89.5956249,
                    56.1673906
                ],
                [
                    89.5948772,
                    56.166677
                ],
                [
                    89.5926554,
                    56.1650831
                ],
                [
                    89.5918436,
                    56.1645597
                ],
                [
                    89.5880411,
                    56.1660703
                ],
                [
                    89.585563,
                    56.1668554
                ],
                [
                    89.5839607,
                    56.1680805
                ],
                [
                    89.5823372,
                    56.1692817
                ],
                [
                    89.5795814,
                    56.1700429
                ],
                [
                    89.5769751,
                    56.1703759
                ],
                [
                    89.5737493,
                    56.169924
                ],
                [
                    89.5726598,
                    56.1699716
                ],
                [
                    89.5656955,
                    56.1706257
                ],
                [
                    89.5648196,
                    56.1716247
                ],
                [
                    89.562662,
                    56.1719101
                ],
                [
                    89.561722,
                    56.1732302
                ],
                [
                    89.5646915,
                    56.1734799
                ],
                [
                    89.5644831,
                    56.1736279
                ],
                [
                    89.5610864,
                    56.176577
                ],
                [
                    89.5606805,
                    56.1776948
                ]
            ],
            "longitude": 89.587463,
            "latitude": 56.170795
        },
        "228": {
            "name": "Чайковский",
            "population": 324,
            "type": "village",
            "poly": [
                [
                    89.6077414,
                    56.3560343
                ],
                [
                    89.6095297,
                    56.3564559
                ],
                [
                    89.610963,
                    56.3565262
                ],
                [
                    89.6111786,
                    56.3563364
                ],
                [
                    89.6164423,
                    56.356751
                ],
                [
                    89.617254,
                    56.3563505
                ],
                [
                    89.6179897,
                    56.3572781
                ],
                [
                    89.6189536,
                    56.3579105
                ],
                [
                    89.6201713,
                    56.3581494
                ],
                [
                    89.620704,
                    56.357791
                ],
                [
                    89.6237607,
                    56.357271
                ],
                [
                    89.6254603,
                    56.3575451
                ],
                [
                    89.6281365,
                    56.3566316
                ],
                [
                    89.6283648,
                    56.3564137
                ],
                [
                    89.6280351,
                    56.3556829
                ],
                [
                    89.6276546,
                    56.3554018
                ],
                [
                    89.6267413,
                    56.3546148
                ],
                [
                    89.6253969,
                    56.3546851
                ],
                [
                    89.6236085,
                    56.3547905
                ],
                [
                    89.6213001,
                    56.3553611
                ],
                [
                    89.6213204,
                    56.3547483
                ],
                [
                    89.6205289,
                    56.3535002
                ],
                [
                    89.619565,
                    56.3536352
                ],
                [
                    89.618459,
                    56.3536239
                ],
                [
                    89.6181343,
                    56.352016
                ],
                [
                    89.620742,
                    56.3515831
                ],
                [
                    89.6207014,
                    56.3501662
                ],
                [
                    89.620397,
                    56.3500257
                ],
                [
                    89.6197375,
                    56.3479228
                ],
                [
                    89.6188141,
                    56.3477822
                ],
                [
                    89.6173631,
                    56.3478272
                ],
                [
                    89.6125434,
                    56.3481083
                ],
                [
                    89.6103516,
                    56.3483951
                ],
                [
                    89.6107347,
                    56.3504052
                ],
                [
                    89.6104682,
                    56.3515016
                ],
                [
                    89.6088829,
                    56.3535607
                ],
                [
                    89.6078682,
                    56.355184
                ],
                [
                    89.6077414,
                    56.3560343
                ]
            ],
            "longitude": 89.614594,
            "latitude": 56.35244
        },
        "229": {
            "name": "Ворогово",
            "population": 856,
            "type": "village",
            "poly": [
                [
                    89.5911593,
                    61.0354569
                ],
                [
                    89.5915486,
                    61.0368731
                ],
                [
                    89.5945435,
                    61.0365606
                ],
                [
                    89.5945225,
                    61.0359602
                ],
                [
                    89.5948877,
                    61.0353608
                ],
                [
                    89.5966479,
                    61.035242
                ],
                [
                    89.5995608,
                    61.0351624
                ],
                [
                    89.5998243,
                    61.0355417
                ],
                [
                    89.603683,
                    61.0351754
                ],
                [
                    89.6056226,
                    61.0355339
                ],
                [
                    89.6057801,
                    61.036995
                ],
                [
                    89.6034682,
                    61.0411215
                ],
                [
                    89.6089549,
                    61.0429874
                ],
                [
                    89.6091026,
                    61.0439379
                ],
                [
                    89.6121432,
                    61.0437079
                ],
                [
                    89.612377,
                    61.0454348
                ],
                [
                    89.6142795,
                    61.0454202
                ],
                [
                    89.6150524,
                    61.043752
                ],
                [
                    89.6154295,
                    61.043138
                ],
                [
                    89.6163136,
                    61.0415187
                ],
                [
                    89.6172068,
                    61.0404496
                ],
                [
                    89.6192214,
                    61.0367293
                ],
                [
                    89.6198287,
                    61.0351458
                ],
                [
                    89.6202841,
                    61.0336415
                ],
                [
                    89.6215053,
                    61.0310531
                ],
                [
                    89.6224212,
                    61.0282116
                ],
                [
                    89.6225774,
                    61.0263239
                ],
                [
                    89.6215665,
                    61.0227213
                ],
                [
                    89.621238,
                    61.0207587
                ],
                [
                    89.6211121,
                    61.019052
                ],
                [
                    89.6211966,
                    61.0179816
                ],
                [
                    89.6220783,
                    61.0119258
                ],
                [
                    89.6190332,
                    61.0117974
                ],
                [
                    89.6162326,
                    61.0126369
                ],
                [
                    89.613657,
                    61.014231
                ],
                [
                    89.6109713,
                    61.0169259
                ],
                [
                    89.6120975,
                    61.0186821
                ],
                [
                    89.612413,
                    61.0206424
                ],
                [
                    89.6129286,
                    61.0218389
                ],
                [
                    89.6133108,
                    61.0224545
                ],
                [
                    89.6135663,
                    61.0234237
                ],
                [
                    89.6135783,
                    61.0240374
                ],
                [
                    89.613349,
                    61.0252823
                ],
                [
                    89.6127376,
                    61.0264814
                ],
                [
                    89.6121261,
                    61.0274158
                ],
                [
                    89.6108591,
                    61.0286389
                ],
                [
                    89.6102249,
                    61.0292715
                ],
                [
                    89.6088205,
                    61.030197
                ],
                [
                    89.6067474,
                    61.0312381
                ],
                [
                    89.6051287,
                    61.0326718
                ],
                [
                    89.6023827,
                    61.0338174
                ],
                [
                    89.6003716,
                    61.0343259
                ],
                [
                    89.5966437,
                    61.0342525
                ],
                [
                    89.5956903,
                    61.0342981
                ],
                [
                    89.5944387,
                    61.0344564
                ],
                [
                    89.5924161,
                    61.0347271
                ],
                [
                    89.5914962,
                    61.0350615
                ],
                [
                    89.5911593,
                    61.0354569
                ]
            ],
            "longitude": 89.616098,
            "latitude": 61.0277303
        },
        "230": {
            "name": "Новомитрополька",
            "population": 349,
            "type": "village",
            "poly": [
                [
                    89.6250563,
                    56.5361118
                ],
                [
                    89.6259654,
                    56.5365379
                ],
                [
                    89.6286698,
                    56.5368512
                ],
                [
                    89.636783,
                    56.5375404
                ],
                [
                    89.637283,
                    56.5370391
                ],
                [
                    89.638942,
                    56.537177
                ],
                [
                    89.6387829,
                    56.539846
                ],
                [
                    89.6398965,
                    56.539846
                ],
                [
                    89.6402147,
                    56.5390316
                ],
                [
                    89.6419873,
                    56.5393448
                ],
                [
                    89.6445554,
                    56.5387935
                ],
                [
                    89.6455326,
                    56.5395202
                ],
                [
                    89.6505777,
                    56.5390065
                ],
                [
                    89.6510096,
                    56.5397082
                ],
                [
                    89.6523505,
                    56.5394576
                ],
                [
                    89.6524414,
                    56.5387559
                ],
                [
                    89.6542595,
                    56.538405
                ],
                [
                    89.6540549,
                    56.537578
                ],
                [
                    89.6558276,
                    56.537603
                ],
                [
                    89.6566684,
                    56.5371143
                ],
                [
                    89.6566002,
                    56.5360742
                ],
                [
                    89.6589183,
                    56.5347709
                ],
                [
                    89.6592819,
                    56.5331794
                ],
                [
                    89.6572366,
                    56.5319386
                ],
                [
                    89.651055,
                    56.531312
                ],
                [
                    89.6492142,
                    56.5325778
                ],
                [
                    89.6447145,
                    56.5328159
                ],
                [
                    89.6428282,
                    56.5322645
                ],
                [
                    89.6403056,
                    56.5322645
                ],
                [
                    89.6384648,
                    56.5318885
                ],
                [
                    89.6347604,
                    56.5320514
                ],
                [
                    89.6346241,
                    56.531713
                ],
                [
                    89.6331696,
                    56.5312493
                ],
                [
                    89.6322151,
                    56.5314122
                ],
                [
                    89.6322378,
                    56.5322519
                ],
                [
                    89.6295561,
                    56.5323146
                ],
                [
                    89.6255109,
                    56.5341945
                ],
                [
                    89.6250563,
                    56.5361118
                ]
            ],
            "longitude": 89.641861,
            "latitude": 56.535225
        },
        "231": {
            "name": "Медяково",
            "population": 272,
            "type": "village",
            "poly": [
                [
                    89.6393079,
                    56.2864552
                ],
                [
                    89.6398311,
                    56.2870007
                ],
                [
                    89.6405128,
                    56.2874583
                ],
                [
                    89.6420983,
                    56.2871503
                ],
                [
                    89.6424471,
                    56.2873087
                ],
                [
                    89.646918,
                    56.2871415
                ],
                [
                    89.6478217,
                    56.2868423
                ],
                [
                    89.6477583,
                    56.2863056
                ],
                [
                    89.6484718,
                    56.2860064
                ],
                [
                    89.6493279,
                    56.2855488
                ],
                [
                    89.6503426,
                    56.285364
                ],
                [
                    89.6513097,
                    56.2857864
                ],
                [
                    89.6518646,
                    56.2857952
                ],
                [
                    89.6522293,
                    56.2854608
                ],
                [
                    89.653133,
                    56.2856544
                ],
                [
                    89.6550038,
                    56.2858392
                ],
                [
                    89.6550672,
                    56.286376
                ],
                [
                    89.6592369,
                    56.2873263
                ],
                [
                    89.6603784,
                    56.2858656
                ],
                [
                    89.6614883,
                    56.2851088
                ],
                [
                    89.6612187,
                    56.2849239
                ],
                [
                    89.6619639,
                    56.2842551
                ],
                [
                    89.6642469,
                    56.2839647
                ],
                [
                    89.6649128,
                    56.2830759
                ],
                [
                    89.6650397,
                    56.2827414
                ],
                [
                    89.6628835,
                    56.2816677
                ],
                [
                    89.6605528,
                    56.28099
                ],
                [
                    89.6579052,
                    56.2805676
                ],
                [
                    89.6569222,
                    56.2801979
                ],
                [
                    89.6525781,
                    56.2797227
                ],
                [
                    89.6528476,
                    56.2816325
                ],
                [
                    89.6508499,
                    56.2816501
                ],
                [
                    89.650622,
                    56.2820055
                ],
                [
                    89.6494864,
                    56.2830319
                ],
                [
                    89.6487888,
                    56.2838679
                ],
                [
                    89.6500255,
                    56.2845367
                ],
                [
                    89.6501523,
                    56.2852144
                ],
                [
                    89.6492962,
                    56.285364
                ],
                [
                    89.6475522,
                    56.2861912
                ],
                [
                    89.6469973,
                    56.2862352
                ],
                [
                    89.6468546,
                    56.28576
                ],
                [
                    89.6463473,
                    56.2855488
                ],
                [
                    89.6423837,
                    56.2855312
                ],
                [
                    89.6404494,
                    56.2857072
                ],
                [
                    89.6398628,
                    56.2862528
                ],
                [
                    89.6393079,
                    56.2864552
                ]
            ],
            "longitude": 89.656403,
            "latitude": 56.28384
        },
        "232": {
            "name": "Зотино",
            "population": 498,
            "type": "village",
            "poly": null,
            "longitude": 89.6914992,
            "latitude": 60.8934259
        },
        "233": {
            "name": "Локшино",
            "population": 730,
            "type": "village",
            "poly": [
                [
                    89.6746948,
                    55.4678734
                ],
                [
                    89.6752177,
                    55.4683014
                ],
                [
                    89.6756067,
                    55.4688961
                ],
                [
                    89.6764864,
                    55.4696507
                ],
                [
                    89.6770027,
                    55.4699212
                ],
                [
                    89.6778852,
                    55.4701583
                ],
                [
                    89.6782545,
                    55.4703065
                ],
                [
                    89.6784799,
                    55.4704325
                ],
                [
                    89.6785813,
                    55.4708586
                ],
                [
                    89.678748,
                    55.471142
                ],
                [
                    89.6790323,
                    55.4712939
                ],
                [
                    89.6793722,
                    55.4712939
                ],
                [
                    89.679869,
                    55.4710049
                ],
                [
                    89.6803429,
                    55.4709271
                ],
                [
                    89.6805096,
                    55.4709975
                ],
                [
                    89.6807972,
                    55.4713347
                ],
                [
                    89.6809148,
                    55.4716774
                ],
                [
                    89.681088,
                    55.4718571
                ],
                [
                    89.6814051,
                    55.4720164
                ],
                [
                    89.6821077,
                    55.4721683
                ],
                [
                    89.6825097,
                    55.4721868
                ],
                [
                    89.6828333,
                    55.4722424
                ],
                [
                    89.6831732,
                    55.4724054
                ],
                [
                    89.6832777,
                    55.4726888
                ],
                [
                    89.6834216,
                    55.472887
                ],
                [
                    89.6838954,
                    55.4730149
                ],
                [
                    89.6843432,
                    55.4731705
                ],
                [
                    89.6845948,
                    55.473452
                ],
                [
                    89.6853105,
                    55.4742467
                ],
                [
                    89.6861309,
                    55.4749191
                ],
                [
                    89.6867453,
                    55.4759693
                ],
                [
                    89.6873402,
                    55.4765713
                ],
                [
                    89.6877781,
                    55.4767992
                ],
                [
                    89.6880461,
                    55.4767806
                ],
                [
                    89.688167,
                    55.4766843
                ],
                [
                    89.6885592,
                    55.4764417
                ],
                [
                    89.6888828,
                    55.4764028
                ],
                [
                    89.6892782,
                    55.4764713
                ],
                [
                    89.6897129,
                    55.4764658
                ],
                [
                    89.6900626,
                    55.4763102
                ],
                [
                    89.6901476,
                    55.4761046
                ],
                [
                    89.6902718,
                    55.4759842
                ],
                [
                    89.6905234,
                    55.4759582
                ],
                [
                    89.6908895,
                    55.4760657
                ],
                [
                    89.6911116,
                    55.4762676
                ],
                [
                    89.6914451,
                    55.4763843
                ],
                [
                    89.6919778,
                    55.4764046
                ],
                [
                    89.6921574,
                    55.476375
                ],
                [
                    89.6926837,
                    55.4761398
                ],
                [
                    89.6931119,
                    55.4761453
                ],
                [
                    89.6932426,
                    55.4762472
                ],
                [
                    89.6932458,
                    55.4764176
                ],
                [
                    89.6929027,
                    55.4768103
                ],
                [
                    89.6928373,
                    55.4769473
                ],
                [
                    89.6930171,
                    55.4770474
                ],
                [
                    89.6932622,
                    55.4771122
                ],
                [
                    89.6938505,
                    55.4771122
                ],
                [
                    89.6941708,
                    55.4772363
                ],
                [
                    89.6944486,
                    55.4774419
                ],
                [
                    89.6945695,
                    55.4777234
                ],
                [
                    89.6948996,
                    55.4780012
                ],
                [
                    89.6952427,
                    55.4780198
                ],
                [
                    89.6955532,
                    55.4779531
                ],
                [
                    89.6961284,
                    55.4775326
                ],
                [
                    89.696586,
                    55.47724
                ],
                [
                    89.69722,
                    55.4771381
                ],
                [
                    89.6980403,
                    55.4771455
                ],
                [
                    89.6984358,
                    55.4773141
                ],
                [
                    89.6985726,
                    55.4776877
                ],
                [
                    89.698658,
                    55.4781106
                ],
                [
                    89.6988781,
                    55.4783141
                ],
                [
                    89.6993409,
                    55.4784135
                ],
                [
                    89.6997079,
                    55.4782643
                ],
                [
                    89.6999415,
                    55.478417
                ],
                [
                    89.7003463,
                    55.4783683
                ],
                [
                    89.7010418,
                    55.4778451
                ],
                [
                    89.7016963,
                    55.4778451
                ],
                [
                    89.7041275,
                    55.4785517
                ],
                [
                    89.7047664,
                    55.4787901
                ],
                [
                    89.7051404,
                    55.4788873
                ],
                [
                    89.7056391,
                    55.4788961
                ],
                [
                    89.7066833,
                    55.4786047
                ],
                [
                    89.7073066,
                    55.478269
                ],
                [
                    89.7075643,
                    55.4777559
                ],
                [
                    89.7058189,
                    55.4746328
                ],
                [
                    89.7021161,
                    55.4705413
                ],
                [
                    89.6927033,
                    55.4618906
                ],
                [
                    89.6860464,
                    55.4628962
                ],
                [
                    89.6863975,
                    55.4633847
                ],
                [
                    89.6850379,
                    55.4638552
                ],
                [
                    89.6843421,
                    55.4639854
                ],
                [
                    89.6839463,
                    55.4641229
                ],
                [
                    89.6837995,
                    55.4643365
                ],
                [
                    89.6831073,
                    55.464477
                ],
                [
                    89.683008,
                    55.4648576
                ],
                [
                    89.682759,
                    55.4648648
                ],
                [
                    89.6821846,
                    55.4651977
                ],
                [
                    89.6815398,
                    55.465527
                ],
                [
                    89.6805377,
                    55.4662544
                ],
                [
                    89.6797078,
                    55.4664715
                ],
                [
                    89.6776587,
                    55.4664329
                ],
                [
                    89.6770255,
                    55.4660925
                ],
                [
                    89.6760491,
                    55.4660647
                ],
                [
                    89.6755956,
                    55.4660068
                ],
                [
                    89.6753015,
                    55.4667178
                ],
                [
                    89.6746948,
                    55.4678734
                ]
            ],
            "longitude": 89.692909,
            "latitude": 55.470497
        },
        "234": {
            "name": "Озеро Учум",
            "population": 885,
            "type": "village",
            "poly": [
                [
                    89.6794411,
                    55.0764443
                ],
                [
                    89.6842828,
                    55.082337
                ],
                [
                    89.6848091,
                    55.082337
                ],
                [
                    89.6855038,
                    55.0825418
                ],
                [
                    89.6868931,
                    55.0837226
                ],
                [
                    89.6873563,
                    55.0857227
                ],
                [
                    89.6875247,
                    55.0871926
                ],
                [
                    89.6872089,
                    55.087795
                ],
                [
                    89.6866615,
                    55.0881324
                ],
                [
                    89.6907665,
                    55.0917104
                ],
                [
                    89.697187,
                    55.0938185
                ],
                [
                    89.6974211,
                    55.0936502
                ],
                [
                    89.6975719,
                    55.093274
                ],
                [
                    89.6967744,
                    55.092429
                ],
                [
                    89.6959229,
                    55.0918986
                ],
                [
                    89.6950284,
                    55.0911954
                ],
                [
                    89.6947804,
                    55.0902641
                ],
                [
                    89.69422,
                    55.0895362
                ],
                [
                    89.6943925,
                    55.0888639
                ],
                [
                    89.6946188,
                    55.0881175
                ],
                [
                    89.6945865,
                    55.086526
                ],
                [
                    89.6946188,
                    55.08565
                ],
                [
                    89.6953948,
                    55.0848296
                ],
                [
                    89.6967313,
                    55.0847
                ],
                [
                    89.6989947,
                    55.0853909
                ],
                [
                    89.7000079,
                    55.0853786
                ],
                [
                    89.7007192,
                    55.0856007
                ],
                [
                    89.7014736,
                    55.085576
                ],
                [
                    89.7025192,
                    55.0858536
                ],
                [
                    89.7025946,
                    55.0862484
                ],
                [
                    89.7029503,
                    55.0864951
                ],
                [
                    89.7050412,
                    55.0863533
                ],
                [
                    89.7066148,
                    55.0865692
                ],
                [
                    89.7075202,
                    55.0866555
                ],
                [
                    89.7089213,
                    55.0863718
                ],
                [
                    89.7106458,
                    55.0861127
                ],
                [
                    89.7116698,
                    55.0856809
                ],
                [
                    89.7128446,
                    55.085576
                ],
                [
                    89.7137714,
                    55.0850578
                ],
                [
                    89.715205,
                    55.08499
                ],
                [
                    89.7178025,
                    55.0853724
                ],
                [
                    89.7184168,
                    55.0853539
                ],
                [
                    89.7185031,
                    55.0851442
                ],
                [
                    89.717727,
                    55.0849591
                ],
                [
                    89.7177054,
                    55.0847802
                ],
                [
                    89.7185246,
                    55.0837932
                ],
                [
                    89.7151511,
                    55.0830714
                ],
                [
                    89.7152072,
                    55.0829926
                ],
                [
                    89.7190229,
                    55.0811244
                ],
                [
                    89.7238436,
                    55.081739
                ],
                [
                    89.726496,
                    55.0824137
                ],
                [
                    89.7262894,
                    55.0721221
                ],
                [
                    89.718669,
                    55.0680481
                ],
                [
                    89.7151956,
                    55.0658181
                ],
                [
                    89.7131116,
                    55.0652274
                ],
                [
                    89.7032387,
                    55.0707602
                ],
                [
                    89.7017651,
                    55.0707722
                ],
                [
                    89.6994284,
                    55.0710253
                ],
                [
                    89.6985443,
                    55.0713628
                ],
                [
                    89.6960713,
                    55.0713471
                ],
                [
                    89.6890293,
                    55.0713025
                ],
                [
                    89.6883556,
                    55.071399
                ],
                [
                    89.6877452,
                    55.0721583
                ],
                [
                    89.6860611,
                    55.0736287
                ],
                [
                    89.6838099,
                    55.0749158
                ],
                [
                    89.6795253,
                    55.0762153
                ],
                [
                    89.6794411,
                    55.0764443
                ]
            ],
            "longitude": 89.702888,
            "latitude": 55.082218
        },
        "235": {
            "name": "Кулун",
            "population": 1338,
            "type": "village",
            "poly": [
                [
                    89.7556522,
                    55.3457588
                ],
                [
                    89.7558368,
                    55.3458124
                ],
                [
                    89.7577028,
                    55.3462987
                ],
                [
                    89.7582693,
                    55.3462261
                ],
                [
                    89.7593784,
                    55.3466843
                ],
                [
                    89.7626498,
                    55.3473014
                ],
                [
                    89.7631844,
                    55.347383
                ],
                [
                    89.7640621,
                    55.3476598
                ],
                [
                    89.764493,
                    55.3470246
                ],
                [
                    89.7654106,
                    55.3463441
                ],
                [
                    89.7654744,
                    55.3458677
                ],
                [
                    89.7654824,
                    55.3454911
                ],
                [
                    89.7653148,
                    55.3451372
                ],
                [
                    89.7654983,
                    55.3447379
                ],
                [
                    89.7660569,
                    55.3442751
                ],
                [
                    89.7667589,
                    55.3438441
                ],
                [
                    89.7668468,
                    55.3435038
                ],
                [
                    89.7670224,
                    55.3434448
                ],
                [
                    89.767541,
                    55.3432588
                ],
                [
                    89.7678841,
                    55.342923
                ],
                [
                    89.7680995,
                    55.3426462
                ],
                [
                    89.7681713,
                    55.3419883
                ],
                [
                    89.767932,
                    55.3412623
                ],
                [
                    89.7680206,
                    55.3402855
                ],
                [
                    89.769554,
                    55.3404556
                ],
                [
                    89.7698283,
                    55.3404131
                ],
                [
                    89.7750023,
                    55.3414766
                ],
                [
                    89.7786302,
                    55.3422848
                ],
                [
                    89.781398,
                    55.3398955
                ],
                [
                    89.783293,
                    55.3380307
                ],
                [
                    89.7840161,
                    55.3376833
                ],
                [
                    89.7848016,
                    55.3367686
                ],
                [
                    89.7858861,
                    55.3344853
                ],
                [
                    89.7858669,
                    55.3342582
                ],
                [
                    89.7859622,
                    55.3342188
                ],
                [
                    89.7877191,
                    55.3337758
                ],
                [
                    89.7903657,
                    55.3330332
                ],
                [
                    89.7931115,
                    55.3322109
                ],
                [
                    89.7916561,
                    55.3313104
                ],
                [
                    89.7900985,
                    55.330675
                ],
                [
                    89.7894794,
                    55.3307113
                ],
                [
                    89.7896964,
                    55.3304027
                ],
                [
                    89.7897603,
                    55.3301594
                ],
                [
                    89.7890517,
                    55.3297781
                ],
                [
                    89.7855856,
                    55.3280896
                ],
                [
                    89.7853686,
                    55.3281041
                ],
                [
                    89.785209,
                    55.3283402
                ],
                [
                    89.7850558,
                    55.3287251
                ],
                [
                    89.7815322,
                    55.3269639
                ],
                [
                    89.781245,
                    55.3271455
                ],
                [
                    89.7812131,
                    55.3274941
                ],
                [
                    89.7808237,
                    55.3276902
                ],
                [
                    89.7806194,
                    55.3278681
                ],
                [
                    89.780396,
                    55.3281768
                ],
                [
                    89.7761703,
                    55.3269966
                ],
                [
                    89.7748745,
                    55.3263901
                ],
                [
                    89.7737044,
                    55.3252909
                ],
                [
                    89.7734411,
                    55.324846
                ],
                [
                    89.7728427,
                    55.3247008
                ],
                [
                    89.771598,
                    55.3238609
                ],
                [
                    89.7691803,
                    55.3223992
                ],
                [
                    89.7693878,
                    55.322036
                ],
                [
                    89.7693399,
                    55.3217273
                ],
                [
                    89.7691803,
                    55.3215638
                ],
                [
                    89.7691564,
                    55.3212733
                ],
                [
                    89.7692282,
                    55.3209101
                ],
                [
                    89.7690367,
                    55.3206967
                ],
                [
                    89.76776,
                    55.3199885
                ],
                [
                    89.7653743,
                    55.3191259
                ],
                [
                    89.760531,
                    55.3170827
                ],
                [
                    89.7597569,
                    55.3176594
                ],
                [
                    89.7591985,
                    55.3178455
                ],
                [
                    89.7587038,
                    55.3178047
                ],
                [
                    89.7581532,
                    55.3177502
                ],
                [
                    89.7577702,
                    55.3178455
                ],
                [
                    89.7575548,
                    55.3181588
                ],
                [
                    89.7575229,
                    55.3187309
                ],
                [
                    89.7582729,
                    55.3199113
                ],
                [
                    89.7606906,
                    55.321523
                ],
                [
                    89.761656,
                    55.3225263
                ],
                [
                    89.7617279,
                    55.3240925
                ],
                [
                    89.7615682,
                    55.3245873
                ],
                [
                    89.761273,
                    55.3249686
                ],
                [
                    89.7613848,
                    55.3254452
                ],
                [
                    89.7610895,
                    55.3255814
                ],
                [
                    89.7594219,
                    55.3263077
                ],
                [
                    89.7586074,
                    55.3269106
                ],
                [
                    89.7584903,
                    55.3269926
                ],
                [
                    89.764512,
                    55.3294182
                ],
                [
                    89.764688,
                    55.3300234
                ],
                [
                    89.7556522,
                    55.3457588
                ]
            ],
            "longitude": 89.779221,
            "latitude": 55.33215
        },
        "236": {
            "name": "Златоруновск",
            "population": 978,
            "type": "village",
            "poly": [
                [
                    89.7658363,
                    55.1391356
                ],
                [
                    89.7675795,
                    55.1396732
                ],
                [
                    89.7673271,
                    55.1398554
                ],
                [
                    89.7670879,
                    55.1401098
                ],
                [
                    89.7671742,
                    55.1407477
                ],
                [
                    89.7673138,
                    55.1416627
                ],
                [
                    89.7675263,
                    55.1420499
                ],
                [
                    89.7676127,
                    55.142403
                ],
                [
                    89.7675662,
                    55.1428814
                ],
                [
                    89.7674134,
                    55.143299
                ],
                [
                    89.7669086,
                    55.1436559
                ],
                [
                    89.7665432,
                    55.1440507
                ],
                [
                    89.7663439,
                    55.1447797
                ],
                [
                    89.7663107,
                    55.1451821
                ],
                [
                    89.7671876,
                    55.1453643
                ],
                [
                    89.7683368,
                    55.145444
                ],
                [
                    89.7721232,
                    55.1457857
                ],
                [
                    89.7758896,
                    55.1462716
                ],
                [
                    89.7774507,
                    55.1463703
                ],
                [
                    89.7789158,
                    55.1465944
                ],
                [
                    89.7804403,
                    55.1406346
                ],
                [
                    89.7827487,
                    55.1343804
                ],
                [
                    89.7816527,
                    55.1341449
                ],
                [
                    89.7803374,
                    55.1336855
                ],
                [
                    89.7799256,
                    55.1336551
                ],
                [
                    89.7806164,
                    55.1307765
                ],
                [
                    89.7858624,
                    55.1311862
                ],
                [
                    89.7893265,
                    55.1315571
                ],
                [
                    89.792622,
                    55.1323211
                ],
                [
                    89.795658,
                    55.133352
                ],
                [
                    89.8013537,
                    55.1353397
                ],
                [
                    89.8019894,
                    55.1356661
                ],
                [
                    89.8009904,
                    55.1396856
                ],
                [
                    89.8005363,
                    55.1434898
                ],
                [
                    89.8006142,
                    55.1436381
                ],
                [
                    89.8009385,
                    55.1432747
                ],
                [
                    89.8019894,
                    55.1424516
                ],
                [
                    89.8040653,
                    55.1413319
                ],
                [
                    89.8079317,
                    55.1400342
                ],
                [
                    89.8118758,
                    55.138729
                ],
                [
                    89.8137441,
                    55.1377797
                ],
                [
                    89.8161833,
                    55.1339899
                ],
                [
                    89.8185576,
                    55.1298881
                ],
                [
                    89.8188715,
                    55.1288149
                ],
                [
                    89.818843,
                    55.1284194
                ],
                [
                    89.8074968,
                    55.1279596
                ],
                [
                    89.80208,
                    55.1285127
                ],
                [
                    89.7968073,
                    55.1280558
                ],
                [
                    89.7949431,
                    55.1284385
                ],
                [
                    89.7948421,
                    55.129903
                ],
                [
                    89.7946604,
                    55.129909
                ],
                [
                    89.7925613,
                    55.129871
                ],
                [
                    89.7847783,
                    55.129478
                ],
                [
                    89.7827169,
                    55.1294158
                ],
                [
                    89.7822118,
                    55.1295266
                ],
                [
                    89.7819724,
                    55.1296317
                ],
                [
                    89.7658363,
                    55.1391356
                ]
            ],
            "longitude": 89.807533,
            "latitude": 55.132473
        },
        "237": {
            "name": "Вагино",
            "population": 678,
            "type": "village",
            "poly": [
                [
                    89.7943769,
                    56.3407405
                ],
                [
                    89.794583,
                    56.3419531
                ],
                [
                    89.7947525,
                    56.3424205
                ],
                [
                    89.7974775,
                    56.3438209
                ],
                [
                    89.8007227,
                    56.3471707
                ],
                [
                    89.8016393,
                    56.3482277
                ],
                [
                    89.801986,
                    56.3490514
                ],
                [
                    89.8013172,
                    56.3502182
                ],
                [
                    89.8018622,
                    56.3505613
                ],
                [
                    89.8021347,
                    56.351481
                ],
                [
                    89.8040422,
                    56.3527301
                ],
                [
                    89.8082783,
                    56.3531281
                ],
                [
                    89.8126135,
                    56.3539929
                ],
                [
                    89.8151403,
                    56.3552281
                ],
                [
                    89.8156853,
                    56.3559418
                ],
                [
                    89.8178901,
                    56.3564085
                ],
                [
                    89.819748,
                    56.3562712
                ],
                [
                    89.8222995,
                    56.3565457
                ],
                [
                    89.8237612,
                    56.3571908
                ],
                [
                    89.8250989,
                    56.3574653
                ],
                [
                    89.8257182,
                    56.3569575
                ],
                [
                    89.8259907,
                    56.356291
                ],
                [
                    89.830097,
                    56.3570376
                ],
                [
                    89.8308897,
                    56.356168
                ],
                [
                    89.8294787,
                    56.3552896
                ],
                [
                    89.828575,
                    56.3539281
                ],
                [
                    89.8273224,
                    56.3520745
                ],
                [
                    89.8260066,
                    56.3513366
                ],
                [
                    89.8255151,
                    56.3512312
                ],
                [
                    89.8238662,
                    56.3515299
                ],
                [
                    89.8229149,
                    56.3513542
                ],
                [
                    89.8214722,
                    56.3506602
                ],
                [
                    89.8194587,
                    56.3504581
                ],
                [
                    89.8176354,
                    56.3503439
                ],
                [
                    89.8183489,
                    56.3495708
                ],
                [
                    89.8184756,
                    56.3488152
                ],
                [
                    89.8176195,
                    56.347761
                ],
                [
                    89.8167158,
                    56.3471196
                ],
                [
                    89.8134974,
                    56.3465397
                ],
                [
                    89.8103424,
                    56.345213
                ],
                [
                    89.8094862,
                    56.3449406
                ],
                [
                    89.8081544,
                    56.3450461
                ],
                [
                    89.8066958,
                    56.3456523
                ],
                [
                    89.8056019,
                    56.3457929
                ],
                [
                    89.8060141,
                    56.3451954
                ],
                [
                    89.8057446,
                    56.3446507
                ],
                [
                    89.8044921,
                    56.3436402
                ],
                [
                    89.8032871,
                    56.3429724
                ],
                [
                    89.8024786,
                    56.3428582
                ],
                [
                    89.8023517,
                    56.3425067
                ],
                [
                    89.8022566,
                    56.3414347
                ],
                [
                    89.8006394,
                    56.3402836
                ],
                [
                    89.7998467,
                    56.3400551
                ],
                [
                    89.7992125,
                    56.3394751
                ],
                [
                    89.797849,
                    56.3390269
                ],
                [
                    89.79666,
                    56.3392115
                ],
                [
                    89.7962478,
                    56.3394839
                ],
                [
                    89.7957246,
                    56.3399145
                ],
                [
                    89.7943769,
                    56.3407405
                ]
            ],
            "longitude": 89.809402,
            "latitude": 56.351032
        },
        "238": {
            "name": "Павловка",
            "population": 928,
            "type": "village",
            "poly": [
                [
                    89.8229869,
                    55.961125
                ],
                [
                    89.8246839,
                    55.9626202
                ],
                [
                    89.8250232,
                    55.9627183
                ],
                [
                    89.8256473,
                    55.9630492
                ],
                [
                    89.8262713,
                    55.9630369
                ],
                [
                    89.827793,
                    55.9633249
                ],
                [
                    89.8278368,
                    55.9637538
                ],
                [
                    89.8287017,
                    55.9637355
                ],
                [
                    89.8287455,
                    55.9639989
                ],
                [
                    89.8300264,
                    55.9648752
                ],
                [
                    89.8278806,
                    55.9654267
                ],
                [
                    89.8290301,
                    55.9666337
                ],
                [
                    89.8295775,
                    55.9680001
                ],
                [
                    89.8310117,
                    55.9696482
                ],
                [
                    89.8342741,
                    55.9712595
                ],
                [
                    89.8350295,
                    55.9723132
                ],
                [
                    89.8348215,
                    55.972883
                ],
                [
                    89.8354565,
                    55.9735507
                ],
                [
                    89.8370877,
                    55.9746044
                ],
                [
                    89.8379526,
                    55.9756029
                ],
                [
                    89.8386751,
                    55.975995
                ],
                [
                    89.8387737,
                    55.9771405
                ],
                [
                    89.8394086,
                    55.9775815
                ],
                [
                    89.8392444,
                    55.9778388
                ],
                [
                    89.8398246,
                    55.9779552
                ],
                [
                    89.8402297,
                    55.9777591
                ],
                [
                    89.8418938,
                    55.979609
                ],
                [
                    89.8413464,
                    55.9797437
                ],
                [
                    89.841642,
                    55.9807483
                ],
                [
                    89.8410398,
                    55.9807973
                ],
                [
                    89.8413026,
                    55.9812689
                ],
                [
                    89.8410946,
                    55.9813179
                ],
                [
                    89.8411384,
                    55.9816547
                ],
                [
                    89.8417077,
                    55.9816119
                ],
                [
                    89.8420361,
                    55.9828246
                ],
                [
                    89.8416858,
                    55.9832778
                ],
                [
                    89.8413245,
                    55.9833145
                ],
                [
                    89.8411931,
                    55.9839699
                ],
                [
                    89.8408647,
                    55.9843006
                ],
                [
                    89.8408537,
                    55.9848763
                ],
                [
                    89.8413354,
                    55.9855622
                ],
                [
                    89.8413792,
                    55.9858623
                ],
                [
                    89.8415763,
                    55.9860276
                ],
                [
                    89.8415544,
                    55.9863399
                ],
                [
                    89.8467108,
                    55.9862297
                ],
                [
                    89.8480355,
                    55.9850416
                ],
                [
                    89.8488237,
                    55.9849559
                ],
                [
                    89.8489113,
                    55.9847783
                ],
                [
                    89.8494806,
                    55.9844598
                ],
                [
                    89.8504112,
                    55.9834003
                ],
                [
                    89.8505098,
                    55.9833377
                ],
                [
                    89.8505843,
                    55.9832924
                ],
                [
                    89.8459876,
                    55.9772854
                ],
                [
                    89.8455112,
                    55.9769052
                ],
                [
                    89.8452099,
                    55.9767209
                ],
                [
                    89.8457284,
                    55.9766817
                ],
                [
                    89.8466554,
                    55.9764895
                ],
                [
                    89.8443098,
                    55.9736676
                ],
                [
                    89.8438062,
                    55.9733674
                ],
                [
                    89.8433026,
                    55.9732817
                ],
                [
                    89.8427771,
                    55.9732817
                ],
                [
                    89.8423064,
                    55.9731101
                ],
                [
                    89.8416276,
                    55.9731285
                ],
                [
                    89.8404891,
                    55.9724669
                ],
                [
                    89.841332,
                    55.9715112
                ],
                [
                    89.8414525,
                    55.9708679
                ],
                [
                    89.8410693,
                    55.970776
                ],
                [
                    89.8416495,
                    55.9699305
                ],
                [
                    89.8419889,
                    55.9699856
                ],
                [
                    89.8424487,
                    55.9693117
                ],
                [
                    89.8430508,
                    55.9693975
                ],
                [
                    89.8434012,
                    55.96865
                ],
                [
                    89.8432479,
                    55.9676513
                ],
                [
                    89.8428209,
                    55.9674124
                ],
                [
                    89.8435106,
                    55.9667139
                ],
                [
                    89.8419013,
                    55.9659296
                ],
                [
                    89.8424137,
                    55.9657095
                ],
                [
                    89.8429917,
                    55.9656751
                ],
                [
                    89.8433684,
                    55.965685
                ],
                [
                    89.8436924,
                    55.9656016
                ],
                [
                    89.8438851,
                    55.9654595
                ],
                [
                    89.8453827,
                    55.9651408
                ],
                [
                    89.8466001,
                    55.9650673
                ],
                [
                    89.8481766,
                    55.9644006
                ],
                [
                    89.8499896,
                    55.9638418
                ],
                [
                    89.8522054,
                    55.963734
                ],
                [
                    89.8534841,
                    55.9638075
                ],
                [
                    89.8554022,
                    55.9634692
                ],
                [
                    89.8567492,
                    55.9633748
                ],
                [
                    89.8567164,
                    55.9639937
                ],
                [
                    89.8584133,
                    55.9639998
                ],
                [
                    89.8606138,
                    55.9636628
                ],
                [
                    89.8604824,
                    55.9621492
                ],
                [
                    89.8598365,
                    55.960703
                ],
                [
                    89.8586979,
                    55.9597409
                ],
                [
                    89.8582381,
                    55.959606
                ],
                [
                    89.8568696,
                    55.9585581
                ],
                [
                    89.8581067,
                    55.9582088
                ],
                [
                    89.858479,
                    55.9580127
                ],
                [
                    89.8596613,
                    55.9576388
                ],
                [
                    89.8598584,
                    55.9574488
                ],
                [
                    89.8591228,
                    55.9566555
                ],
                [
                    89.8588443,
                    55.9566575
                ],
                [
                    89.8587098,
                    55.9565665
                ],
                [
                    89.8546377,
                    55.9573303
                ],
                [
                    89.8508279,
                    55.9577042
                ],
                [
                    89.849547,
                    55.9577961
                ],
                [
                    89.8484741,
                    55.9580228
                ],
                [
                    89.8473574,
                    55.9585131
                ],
                [
                    89.8420495,
                    55.9559269
                ],
                [
                    89.8415131,
                    55.9557799
                ],
                [
                    89.839422,
                    55.9559944
                ],
                [
                    89.8382397,
                    55.9563008
                ],
                [
                    89.8373638,
                    55.9563498
                ],
                [
                    89.8357874,
                    55.9560802
                ],
                [
                    89.8354151,
                    55.9561108
                ],
                [
                    89.8347366,
                    55.956346
                ],
                [
                    89.8343723,
                    55.956142
                ],
                [
                    89.8341425,
                    55.9562456
                ],
                [
                    89.8343443,
                    55.9563962
                ],
                [
                    89.8333073,
                    55.9567947
                ],
                [
                    89.8323936,
                    55.9570583
                ],
                [
                    89.832091,
                    55.9572184
                ],
                [
                    89.8298731,
                    55.9577421
                ],
                [
                    89.8242022,
                    55.9605796
                ],
                [
                    89.8229869,
                    55.961125
                ]
            ],
            "longitude": 89.837509,
            "latitude": 55.966049
        },
        "239": {
            "name": "Владимировка",
            "population": 339,
            "type": "village",
            "poly": [
                [
                    89.828763,
                    56.1750426
                ],
                [
                    89.8308884,
                    56.174944
                ],
                [
                    89.8317377,
                    56.1743653
                ],
                [
                    89.8332313,
                    56.1744387
                ],
                [
                    89.8329091,
                    56.1756287
                ],
                [
                    89.8323088,
                    56.1762726
                ],
                [
                    89.832382,
                    56.1765498
                ],
                [
                    89.8332313,
                    56.1765824
                ],
                [
                    89.8334363,
                    56.1761422
                ],
                [
                    89.8341099,
                    56.1761993
                ],
                [
                    89.8339781,
                    56.1764356
                ],
                [
                    89.8348859,
                    56.1766639
                ],
                [
                    89.8340366,
                    56.1769165
                ],
                [
                    89.8337291,
                    56.1775278
                ],
                [
                    89.8329824,
                    56.1773974
                ],
                [
                    89.8318549,
                    56.1784488
                ],
                [
                    89.8326016,
                    56.1789134
                ],
                [
                    89.8338463,
                    56.1789297
                ],
                [
                    89.8340074,
                    56.1787259
                ],
                [
                    89.8336852,
                    56.1783836
                ],
                [
                    89.8340074,
                    56.1780984
                ],
                [
                    89.8352081,
                    56.1782369
                ],
                [
                    89.8356766,
                    56.1774382
                ],
                [
                    89.8368481,
                    56.1776093
                ],
                [
                    89.8374484,
                    56.1770877
                ],
                [
                    89.8391616,
                    56.1773567
                ],
                [
                    89.8395277,
                    56.1773648
                ],
                [
                    89.8398938,
                    56.176998
                ],
                [
                    89.8394397,
                    56.1764275
                ],
                [
                    89.838122,
                    56.1761341
                ],
                [
                    89.8384881,
                    56.1755717
                ],
                [
                    89.8395691,
                    56.175862
                ],
                [
                    89.840999,
                    56.1763794
                ],
                [
                    89.8421072,
                    56.1737128
                ],
                [
                    89.8441807,
                    56.1719814
                ],
                [
                    89.8458966,
                    56.1723794
                ],
                [
                    89.8486493,
                    56.1699912
                ],
                [
                    89.8516165,
                    56.1703494
                ],
                [
                    89.8514019,
                    56.1711057
                ],
                [
                    89.8521316,
                    56.1712453
                ],
                [
                    89.8547234,
                    56.1694601
                ],
                [
                    89.855602,
                    56.167691
                ],
                [
                    89.8496277,
                    56.1666067
                ],
                [
                    89.8507845,
                    56.1655142
                ],
                [
                    89.8507991,
                    56.164226
                ],
                [
                    89.8526148,
                    56.1635248
                ],
                [
                    89.8528931,
                    56.1629622
                ],
                [
                    89.8544159,
                    56.1628236
                ],
                [
                    89.8560266,
                    56.1629622
                ],
                [
                    89.8556463,
                    56.1633596
                ],
                [
                    89.8560038,
                    56.1635586
                ],
                [
                    89.856969,
                    56.1631207
                ],
                [
                    89.856826,
                    56.162842
                ],
                [
                    89.8562183,
                    56.1627823
                ],
                [
                    89.8565043,
                    56.1622249
                ],
                [
                    89.8560753,
                    56.1616874
                ],
                [
                    89.8551458,
                    56.1616476
                ],
                [
                    89.8549671,
                    56.161986
                ],
                [
                    89.8532511,
                    56.1620657
                ],
                [
                    89.8526434,
                    56.1622846
                ],
                [
                    89.8521429,
                    56.1618268
                ],
                [
                    89.8507129,
                    56.16113
                ],
                [
                    89.8483535,
                    56.1617471
                ],
                [
                    89.8470665,
                    56.1626629
                ],
                [
                    89.8462799,
                    56.1639567
                ],
                [
                    89.8470308,
                    56.1642553
                ],
                [
                    89.8468878,
                    56.164534
                ],
                [
                    89.8462085,
                    56.1645539
                ],
                [
                    89.8451361,
                    56.1655293
                ],
                [
                    89.8448501,
                    56.1663255
                ],
                [
                    89.8427051,
                    56.1673207
                ],
                [
                    89.8415612,
                    56.1687537
                ],
                [
                    89.837736,
                    56.1687736
                ],
                [
                    89.8344829,
                    56.1694702
                ],
                [
                    89.8340181,
                    56.1699479
                ],
                [
                    89.8315872,
                    56.1697887
                ],
                [
                    89.828763,
                    56.1750426
                ]
            ],
            "longitude": 89.842171,
            "latitude": 56.171562
        },
        "240": {
            "name": "Прилужье",
            "population": 512,
            "type": "village",
            "poly": null,
            "longitude": 89.847488,
            "latitude": 55.169796
        },
        "241": {
            "name": "Михайловка",
            "population": 829,
            "type": "village",
            "poly": [
                [
                    89.8770916,
                    55.5912807
                ],
                [
                    89.8773288,
                    55.591471
                ],
                [
                    89.8780088,
                    55.5926027
                ],
                [
                    89.8779713,
                    55.5931949
                ],
                [
                    89.8781772,
                    55.5937942
                ],
                [
                    89.8783082,
                    55.5940339
                ],
                [
                    89.8792938,
                    55.5940551
                ],
                [
                    89.8793751,
                    55.5941926
                ],
                [
                    89.8810595,
                    55.5958776
                ],
                [
                    89.8840353,
                    55.5955039
                ],
                [
                    89.8850897,
                    55.5954757
                ],
                [
                    89.88489,
                    55.5953065
                ],
                [
                    89.8847154,
                    55.5952466
                ],
                [
                    89.88494,
                    55.5949434
                ],
                [
                    89.8855077,
                    55.594954
                ],
                [
                    89.8873606,
                    55.5950915
                ],
                [
                    89.8884149,
                    55.5949223
                ],
                [
                    89.8893195,
                    55.5948588
                ],
                [
                    89.88975,
                    55.5947354
                ],
                [
                    89.8901493,
                    55.594739
                ],
                [
                    89.890586,
                    55.5949857
                ],
                [
                    89.890823,
                    55.5951585
                ],
                [
                    89.8912847,
                    55.595229
                ],
                [
                    89.8919334,
                    55.5951972
                ],
                [
                    89.8924201,
                    55.5949963
                ],
                [
                    89.8926946,
                    55.5945416
                ],
                [
                    89.8931126,
                    55.5944111
                ],
                [
                    89.8938488,
                    55.5944499
                ],
                [
                    89.8943292,
                    55.5945662
                ],
                [
                    89.8948781,
                    55.5945486
                ],
                [
                    89.8952774,
                    55.5941961
                ],
                [
                    89.8957391,
                    55.5933324
                ],
                [
                    89.8975421,
                    55.5927084
                ],
                [
                    89.8986338,
                    55.592786
                ],
                [
                    89.8997943,
                    55.5927789
                ],
                [
                    89.9003932,
                    55.592511
                ],
                [
                    89.9021837,
                    55.59237
                ],
                [
                    89.9022149,
                    55.5921162
                ],
                [
                    89.9024582,
                    55.591954
                ],
                [
                    89.902951,
                    55.5919822
                ],
                [
                    89.9032817,
                    55.5921373
                ],
                [
                    89.9038993,
                    55.5921409
                ],
                [
                    89.9054465,
                    55.5926168
                ],
                [
                    89.9056648,
                    55.593001
                ],
                [
                    89.9059705,
                    55.5930363
                ],
                [
                    89.9065507,
                    55.5927895
                ],
                [
                    89.9069937,
                    55.5928283
                ],
                [
                    89.9081042,
                    55.5934382
                ],
                [
                    89.9084723,
                    55.5935263
                ],
                [
                    89.9092022,
                    55.5935263
                ],
                [
                    89.9102877,
                    55.5934064
                ],
                [
                    89.9111362,
                    55.5938929
                ],
                [
                    89.9121593,
                    55.5944288
                ],
                [
                    89.9123153,
                    55.5948165
                ],
                [
                    89.9126085,
                    55.5949187
                ],
                [
                    89.9130078,
                    55.5947495
                ],
                [
                    89.9141245,
                    55.5947566
                ],
                [
                    89.9147421,
                    55.5944288
                ],
                [
                    89.9149979,
                    55.5940586
                ],
                [
                    89.9154908,
                    55.5937836
                ],
                [
                    89.9164702,
                    55.5935052
                ],
                [
                    89.9172064,
                    55.5935827
                ],
                [
                    89.9182607,
                    55.5932126
                ],
                [
                    89.919758,
                    55.5930751
                ],
                [
                    89.9206626,
                    55.5928918
                ],
                [
                    89.9211992,
                    55.5926661
                ],
                [
                    89.9231011,
                    55.5926296
                ],
                [
                    89.9259573,
                    55.5920567
                ],
                [
                    89.9288629,
                    55.590867
                ],
                [
                    89.9289725,
                    55.59079
                ],
                [
                    89.9290054,
                    55.5884831
                ],
                [
                    89.9222891,
                    55.588125
                ],
                [
                    89.9135257,
                    55.5876843
                ],
                [
                    89.9108645,
                    55.5868304
                ],
                [
                    89.9068678,
                    55.5853484
                ],
                [
                    89.9057956,
                    55.5850509
                ],
                [
                    89.9043821,
                    55.5847369
                ],
                [
                    89.9032903,
                    55.5846598
                ],
                [
                    89.9005516,
                    55.5847285
                ],
                [
                    89.8918028,
                    55.58488
                ],
                [
                    89.8866606,
                    55.5845908
                ],
                [
                    89.882825,
                    55.584
                ],
                [
                    89.8826816,
                    55.5847369
                ],
                [
                    89.882875,
                    55.5850472
                ],
                [
                    89.8834489,
                    55.5853716
                ],
                [
                    89.8839979,
                    55.5855444
                ],
                [
                    89.8841164,
                    55.5857559
                ],
                [
                    89.8841164,
                    55.586373
                ],
                [
                    89.885202,
                    55.5874554
                ],
                [
                    89.886169,
                    55.5880019
                ],
                [
                    89.8861565,
                    55.5884496
                ],
                [
                    89.8867055,
                    55.5890772
                ],
                [
                    89.8866244,
                    55.5893099
                ],
                [
                    89.8860005,
                    55.5897577
                ],
                [
                    89.8838295,
                    55.5906849
                ],
                [
                    89.882145,
                    55.5911044
                ],
                [
                    89.8801362,
                    55.5913265
                ],
                [
                    89.8785515,
                    55.5915028
                ],
                [
                    89.8770916,
                    55.5912807
                ]
            ],
            "longitude": 89.899994,
            "latitude": 55.589893
        },
        "242": {
            "name": "Васильевка",
            "population": 113,
            "type": "village",
            "poly": [
                [
                    89.8949379,
                    55.4184546
                ],
                [
                    89.8993373,
                    55.423147
                ],
                [
                    89.9050263,
                    55.4307226
                ],
                [
                    89.9009303,
                    55.4325302
                ],
                [
                    89.9017646,
                    55.4343807
                ],
                [
                    89.9073777,
                    55.4393724
                ],
                [
                    89.9090465,
                    55.4392864
                ],
                [
                    89.9105635,
                    55.4381676
                ],
                [
                    89.9132183,
                    55.4394155
                ],
                [
                    89.9164041,
                    55.4393724
                ],
                [
                    89.9207277,
                    55.438727
                ],
                [
                    89.9167075,
                    55.4358008
                ],
                [
                    89.9160249,
                    55.4325732
                ],
                [
                    89.9164041,
                    55.4295175
                ],
                [
                    89.9153422,
                    55.4258159
                ],
                [
                    89.9124597,
                    55.4232331
                ],
                [
                    89.9079086,
                    55.418756
                ],
                [
                    89.9041161,
                    55.4177658
                ],
                [
                    89.8986547,
                    55.4180672
                ],
                [
                    89.8949379,
                    55.4184546
                ]
            ],
            "longitude": 89.908745,
            "latitude": 55.425472
        },
        "243": {
            "name": "Проточный",
            "population": 273,
            "type": "village",
            "poly": [
                [
                    89.9002964,
                    57.4983509
                ],
                [
                    89.9006761,
                    57.4990923
                ],
                [
                    89.9008987,
                    57.4993394
                ],
                [
                    89.9012966,
                    57.4995924
                ],
                [
                    89.901512,
                    57.4996846
                ],
                [
                    89.9032605,
                    57.4997062
                ],
                [
                    89.9033371,
                    57.500322
                ],
                [
                    89.9021617,
                    57.5004318
                ],
                [
                    89.902253,
                    57.5008633
                ],
                [
                    89.9025961,
                    57.5012673
                ],
                [
                    89.9036766,
                    57.5011124
                ],
                [
                    89.9038664,
                    57.5014478
                ],
                [
                    89.9041548,
                    57.501387
                ],
                [
                    89.9048958,
                    57.5009575
                ],
                [
                    89.9052899,
                    57.5006495
                ],
                [
                    89.9056733,
                    57.5004554
                ],
                [
                    89.9057427,
                    57.5003553
                ],
                [
                    89.905958,
                    57.5002573
                ],
                [
                    89.9060858,
                    57.5000768
                ],
                [
                    89.9067283,
                    57.5001102
                ],
                [
                    89.907002,
                    57.5002553
                ],
                [
                    89.9070969,
                    57.5002592
                ],
                [
                    89.9073452,
                    57.5003259
                ],
                [
                    89.9079972,
                    57.5003018
                ],
                [
                    89.9081309,
                    57.5008572
                ],
                [
                    89.9080328,
                    57.5033135
                ],
                [
                    89.9088438,
                    57.5054153
                ],
                [
                    89.9089775,
                    57.5057552
                ],
                [
                    89.9089597,
                    57.5061861
                ],
                [
                    89.9089864,
                    57.5064207
                ],
                [
                    89.9092894,
                    57.5065452
                ],
                [
                    89.9095122,
                    57.5065499
                ],
                [
                    89.9088077,
                    57.5087819
                ],
                [
                    89.9087773,
                    57.5090379
                ],
                [
                    89.9086302,
                    57.5094119
                ],
                [
                    89.9084993,
                    57.5099427
                ],
                [
                    89.908254,
                    57.5106091
                ],
                [
                    89.9081396,
                    57.5109228
                ],
                [
                    89.9084713,
                    57.5108073
                ],
                [
                    89.9088358,
                    57.5106116
                ],
                [
                    89.9091745,
                    57.5105011
                ],
                [
                    89.9097889,
                    57.5104924
                ],
                [
                    89.9100786,
                    57.5104585
                ],
                [
                    89.9103706,
                    57.5103593
                ],
                [
                    89.9108519,
                    57.5101197
                ],
                [
                    89.911534,
                    57.5099979
                ],
                [
                    89.9117093,
                    57.5099892
                ],
                [
                    89.9121134,
                    57.5100908
                ],
                [
                    89.9125176,
                    57.5101586
                ],
                [
                    89.9123774,
                    57.5103179
                ],
                [
                    89.9123727,
                    57.5104033
                ],
                [
                    89.9126437,
                    57.5104447
                ],
                [
                    89.9129568,
                    57.5104284
                ],
                [
                    89.9129848,
                    57.5103518
                ],
                [
                    89.9130385,
                    57.5102953
                ],
                [
                    89.9131881,
                    57.5102878
                ],
                [
                    89.9133446,
                    57.5103393
                ],
                [
                    89.9133913,
                    57.5104522
                ],
                [
                    89.9133306,
                    57.5106116
                ],
                [
                    89.9134123,
                    57.5107546
                ],
                [
                    89.9141109,
                    57.5107973
                ],
                [
                    89.9145688,
                    57.5107546
                ],
                [
                    89.9149402,
                    57.5107659
                ],
                [
                    89.9153187,
                    57.5108362
                ],
                [
                    89.9154845,
                    57.5109291
                ],
                [
                    89.9155827,
                    57.5110571
                ],
                [
                    89.9157065,
                    57.5111349
                ],
                [
                    89.9159004,
                    57.5111549
                ],
                [
                    89.9161012,
                    57.511116
                ],
                [
                    89.91669,
                    57.5107822
                ],
                [
                    89.9170568,
                    57.5107521
                ],
                [
                    89.917482,
                    57.5106442
                ],
                [
                    89.9176198,
                    57.5106379
                ],
                [
                    89.9182155,
                    57.5106906
                ],
                [
                    89.9184819,
                    57.5106731
                ],
                [
                    89.9187342,
                    57.5106103
                ],
                [
                    89.9189725,
                    57.5104999
                ],
                [
                    89.9202807,
                    57.5106078
                ],
                [
                    89.9206475,
                    57.5106191
                ],
                [
                    89.9208741,
                    57.5104861
                ],
                [
                    89.9215796,
                    57.5103543
                ],
                [
                    89.9222548,
                    57.5101962
                ],
                [
                    89.9225585,
                    57.5100833
                ],
                [
                    89.9236425,
                    57.5098662
                ],
                [
                    89.9239976,
                    57.5099277
                ],
                [
                    89.9242125,
                    57.5099954
                ],
                [
                    89.9243948,
                    57.5101862
                ],
                [
                    89.9248924,
                    57.5105175
                ],
                [
                    89.9253059,
                    57.5107245
                ],
                [
                    89.925696,
                    57.5108011
                ],
                [
                    89.9268127,
                    57.5107747
                ],
                [
                    89.9269225,
                    57.5105789
                ],
                [
                    89.9271548,
                    57.5105267
                ],
                [
                    89.9272826,
                    57.5105879
                ],
                [
                    89.927456,
                    57.5105879
                ],
                [
                    89.9276704,
                    57.5105193
                ],
                [
                    89.9278391,
                    57.5103894
                ],
                [
                    89.9278986,
                    57.5100071
                ],
                [
                    89.9279716,
                    57.5099703
                ],
                [
                    89.9279853,
                    57.5098404
                ],
                [
                    89.9281632,
                    57.5097522
                ],
                [
                    89.9282408,
                    57.5097546
                ],
                [
                    89.9285009,
                    57.5098012
                ],
                [
                    89.9291487,
                    57.509811
                ],
                [
                    89.9293724,
                    57.5097325
                ],
                [
                    89.9308918,
                    57.5095389
                ],
                [
                    89.9316584,
                    57.5095046
                ],
                [
                    89.9316538,
                    57.5096419
                ],
                [
                    89.9321511,
                    57.5096541
                ],
                [
                    89.9321785,
                    57.509485
                ],
                [
                    89.9332143,
                    57.5095365
                ],
                [
                    89.9332736,
                    57.5089923
                ],
                [
                    89.9332508,
                    57.5088796
                ],
                [
                    89.9329588,
                    57.5088772
                ],
                [
                    89.9330272,
                    57.5085389
                ],
                [
                    89.9330363,
                    57.50811
                ],
                [
                    89.9306674,
                    57.5081443
                ],
                [
                    89.9305068,
                    57.507749
                ],
                [
                    89.9301708,
                    57.5077318
                ],
                [
                    89.9299023,
                    57.5072706
                ],
                [
                    89.9294393,
                    57.5067008
                ],
                [
                    89.9282815,
                    57.5069428
                ],
                [
                    89.928156,
                    57.5067467
                ],
                [
                    89.9281788,
                    57.5064955
                ],
                [
                    89.9282929,
                    57.5062657
                ],
                [
                    89.9284811,
                    57.5061431
                ],
                [
                    89.9288746,
                    57.5061063
                ],
                [
                    89.9289488,
                    57.5058367
                ],
                [
                    89.9284355,
                    57.5056008
                ],
                [
                    89.9279449,
                    57.5055977
                ],
                [
                    89.9275457,
                    57.505518
                ],
                [
                    89.9275229,
                    57.5054445
                ],
                [
                    89.9265191,
                    57.5054016
                ],
                [
                    89.9259943,
                    57.5053465
                ],
                [
                    89.9249848,
                    57.5054445
                ],
                [
                    89.9238041,
                    57.5054506
                ],
                [
                    89.9216482,
                    57.5053771
                ],
                [
                    89.920998,
                    57.5052392
                ],
                [
                    89.9198173,
                    57.5051412
                ],
                [
                    89.9185055,
                    57.5048715
                ],
                [
                    89.9180949,
                    57.5047122
                ],
                [
                    89.9176386,
                    57.5046693
                ],
                [
                    89.9167832,
                    57.5045108
                ],
                [
                    89.9162859,
                    57.504349
                ],
                [
                    89.9158524,
                    57.5042853
                ],
                [
                    89.9155923,
                    57.5041505
                ],
                [
                    89.9153231,
                    57.5041211
                ],
                [
                    89.9148714,
                    57.5039593
                ],
                [
                    89.914479,
                    57.5038196
                ],
                [
                    89.9139907,
                    57.5037436
                ],
                [
                    89.9136348,
                    57.5035376
                ],
                [
                    89.9133702,
                    57.5034813
                ],
                [
                    89.9132835,
                    57.5034077
                ],
                [
                    89.9131877,
                    57.5033881
                ],
                [
                    89.9130873,
                    57.5032753
                ],
                [
                    89.9126675,
                    57.5030988
                ],
                [
                    89.9124394,
                    57.50304
                ],
                [
                    89.9122067,
                    57.5028709
                ],
                [
                    89.9119374,
                    57.5027091
                ],
                [
                    89.9116546,
                    57.5025914
                ],
                [
                    89.9115998,
                    57.5023732
                ],
                [
                    89.9113945,
                    57.5023438
                ],
                [
                    89.9111754,
                    57.5022286
                ],
                [
                    89.9109747,
                    57.5020251
                ],
                [
                    89.9106827,
                    57.5019246
                ],
                [
                    89.910669,
                    57.5018192
                ],
                [
                    89.9101032,
                    57.5018829
                ],
                [
                    89.9096013,
                    57.5013926
                ],
                [
                    89.9087891,
                    57.5004316
                ],
                [
                    89.9084697,
                    57.4999952
                ],
                [
                    89.9082735,
                    57.4995049
                ],
                [
                    89.9080225,
                    57.49912
                ],
                [
                    89.9075571,
                    57.498892
                ],
                [
                    89.9072058,
                    57.4988552
                ],
                [
                    89.9050338,
                    57.4969502
                ],
                [
                    89.904792,
                    57.4967172
                ],
                [
                    89.9034498,
                    57.4946286
                ],
                [
                    89.9029567,
                    57.4933637
                ],
                [
                    89.9029357,
                    57.4933512
                ],
                [
                    89.9024427,
                    57.4933549
                ],
                [
                    89.9022699,
                    57.493483
                ],
                [
                    89.9022629,
                    57.4935709
                ],
                [
                    89.902368,
                    57.4936889
                ],
                [
                    89.9023633,
                    57.4937855
                ],
                [
                    89.9023143,
                    57.4938835
                ],
                [
                    89.9021227,
                    57.4939337
                ],
                [
                    89.9020246,
                    57.4939965
                ],
                [
                    89.9019171,
                    57.4940956
                ],
                [
                    89.9018774,
                    57.4942036
                ],
                [
                    89.9019428,
                    57.4942727
                ],
                [
                    89.9018423,
                    57.4943329
                ],
                [
                    89.9017348,
                    57.4944158
                ],
                [
                    89.9017653,
                    57.4945187
                ],
                [
                    89.9019078,
                    57.494584
                ],
                [
                    89.901861,
                    57.4946292
                ],
                [
                    89.9017279,
                    57.4946706
                ],
                [
                    89.9017956,
                    57.4947685
                ],
                [
                    89.9017676,
                    57.494874
                ],
                [
                    89.9017602,
                    57.4949555
                ],
                [
                    89.9018989,
                    57.4950281
                ],
                [
                    89.9021398,
                    57.4950203
                ],
                [
                    89.9022858,
                    57.4950046
                ],
                [
                    89.9022931,
                    57.4951066
                ],
                [
                    89.9025669,
                    57.4953459
                ],
                [
                    89.9029356,
                    57.4955244
                ],
                [
                    89.9033189,
                    57.495799
                ],
                [
                    89.9037715,
                    57.4960658
                ],
                [
                    89.9024246,
                    57.4962894
                ],
                [
                    89.9025195,
                    57.4965934
                ],
                [
                    89.9029831,
                    57.4975977
                ],
                [
                    89.9008367,
                    57.4979507
                ],
                [
                    89.9009863,
                    57.4981861
                ],
                [
                    89.9002964,
                    57.4983509
                ]
            ],
            "longitude": 89.916382,
            "latitude": 57.508343
        },
        "244": {
            "name": "Хантайское Озеро",
            "population": 354,
            "type": "village",
            "poly": null,
            "longitude": 89.98658,
            "latitude": 68.219597
        },
        "245": {
            "name": "Тургужан",
            "population": 428,
            "type": "village",
            "poly": null,
            "longitude": 90.004211,
            "latitude": 55.130207
        },
        "246": {
            "name": "Критово",
            "population": 1156,
            "type": "village",
            "poly": [
                [
                    89.9869845,
                    56.2410452
                ],
                [
                    89.9890481,
                    56.2424048
                ],
                [
                    90.000974,
                    56.2448203
                ],
                [
                    90.0030332,
                    56.2445025
                ],
                [
                    90.0058073,
                    56.244725
                ],
                [
                    90.0063793,
                    56.2444866
                ],
                [
                    90.0064365,
                    56.2436602
                ],
                [
                    90.0060361,
                    56.2433424
                ],
                [
                    90.0064651,
                    56.2424207
                ],
                [
                    90.0141583,
                    56.2444866
                ],
                [
                    90.0157598,
                    56.246314
                ],
                [
                    90.0147303,
                    56.2470927
                ],
                [
                    90.0178673,
                    56.2487933
                ],
                [
                    90.020201,
                    56.2491492
                ],
                [
                    90.0211848,
                    56.249073
                ],
                [
                    90.0216424,
                    56.2485264
                ],
                [
                    90.0226719,
                    56.248145
                ],
                [
                    90.0245238,
                    56.2481331
                ],
                [
                    90.0250671,
                    56.2479265
                ],
                [
                    90.0251243,
                    56.2473068
                ],
                [
                    90.0262111,
                    56.2469096
                ],
                [
                    90.0248097,
                    56.2459879
                ],
                [
                    90.0246953,
                    56.2450504
                ],
                [
                    90.024295,
                    56.2445578
                ],
                [
                    90.0248097,
                    56.2440651
                ],
                [
                    90.0250384,
                    56.2430799
                ],
                [
                    90.0238946,
                    56.2421422
                ],
                [
                    90.0204627,
                    56.2408708
                ],
                [
                    90.0228078,
                    56.2386776
                ],
                [
                    90.0224646,
                    56.2382643
                ],
                [
                    90.0173453,
                    56.2373266
                ],
                [
                    90.0118257,
                    56.2361027
                ],
                [
                    90.0126265,
                    56.2346722
                ],
                [
                    90.0134558,
                    56.2347358
                ],
                [
                    90.0144854,
                    56.2323991
                ],
                [
                    90.0122261,
                    56.2322083
                ],
                [
                    90.0109963,
                    56.235912
                ],
                [
                    90.0049989,
                    56.2347345
                ],
                [
                    90.0003069,
                    56.2342999
                ],
                [
                    89.9931012,
                    56.2332443
                ],
                [
                    89.9919511,
                    56.2341314
                ],
                [
                    89.9915484,
                    56.2355455
                ],
                [
                    89.9897918,
                    56.2349934
                ],
                [
                    89.9887485,
                    56.2361226
                ],
                [
                    89.9908901,
                    56.2367635
                ],
                [
                    89.990917,
                    56.2372167
                ],
                [
                    89.9886291,
                    56.2393528
                ],
                [
                    89.9883545,
                    56.2402937
                ],
                [
                    89.987668,
                    56.2403954
                ],
                [
                    89.9869845,
                    56.2410452
                ]
            ],
            "longitude": 90.004562,
            "latitude": 56.240002
        },
        "247": {
            "name": "Крутояр",
            "population": 1547,
            "type": "village",
            "poly": [
                [
                    89.9831875,
                    55.5736384
                ],
                [
                    89.983504,
                    55.5757002
                ],
                [
                    89.9839505,
                    55.5777725
                ],
                [
                    89.9839692,
                    55.5807491
                ],
                [
                    89.9836766,
                    55.5820266
                ],
                [
                    89.9870149,
                    55.5819577
                ],
                [
                    89.988021,
                    55.5821688
                ],
                [
                    89.9899188,
                    55.5811478
                ],
                [
                    89.9904599,
                    55.5809711
                ],
                [
                    89.9908638,
                    55.580941
                ],
                [
                    89.9966868,
                    55.5806653
                ],
                [
                    89.9975176,
                    55.5804972
                ],
                [
                    89.999484,
                    55.580019
                ],
                [
                    89.9993087,
                    55.5808117
                ],
                [
                    89.99991,
                    55.580848
                ],
                [
                    89.9994146,
                    55.5836589
                ],
                [
                    90.0014819,
                    55.5837236
                ],
                [
                    90.0023584,
                    55.5838313
                ],
                [
                    90.0038066,
                    55.5836859
                ],
                [
                    90.0040066,
                    55.5834112
                ],
                [
                    90.0048069,
                    55.5831205
                ],
                [
                    90.0055881,
                    55.5830935
                ],
                [
                    90.0062646,
                    55.5831312
                ],
                [
                    90.0066647,
                    55.5829966
                ],
                [
                    90.0070267,
                    55.5825766
                ],
                [
                    90.0069791,
                    55.5823881
                ],
                [
                    90.0065123,
                    55.5821243
                ],
                [
                    90.0061121,
                    55.5820919
                ],
                [
                    90.0057977,
                    55.5820919
                ],
                [
                    90.0058263,
                    55.5822804
                ],
                [
                    90.0056739,
                    55.5822966
                ],
                [
                    90.0051404,
                    55.5820543
                ],
                [
                    90.0049212,
                    55.5815427
                ],
                [
                    90.005026,
                    55.581268
                ],
                [
                    90.0053881,
                    55.5811119
                ],
                [
                    90.0065409,
                    55.5808157
                ],
                [
                    90.006598,
                    55.5805949
                ],
                [
                    90.0064742,
                    55.580261
                ],
                [
                    90.0065313,
                    55.5799433
                ],
                [
                    90.006941,
                    55.5797225
                ],
                [
                    90.007484,
                    55.5796471
                ],
                [
                    90.0082081,
                    55.5797602
                ],
                [
                    90.0086749,
                    55.5795825
                ],
                [
                    90.0091418,
                    55.5792809
                ],
                [
                    90.0093514,
                    55.5787639
                ],
                [
                    90.009399,
                    55.5784246
                ],
                [
                    90.0099992,
                    55.5778484
                ],
                [
                    90.010104,
                    55.577369
                ],
                [
                    90.0102279,
                    55.5769382
                ],
                [
                    90.0108471,
                    55.5762919
                ],
                [
                    90.0113521,
                    55.5756133
                ],
                [
                    90.0121809,
                    55.5751824
                ],
                [
                    90.012543,
                    55.5747031
                ],
                [
                    90.0128192,
                    55.5741483
                ],
                [
                    90.0133528,
                    55.5742022
                ],
                [
                    90.0138768,
                    55.5744715
                ],
                [
                    90.0143436,
                    55.5746707
                ],
                [
                    90.0147151,
                    55.5745953
                ],
                [
                    90.0154773,
                    55.5740352
                ],
                [
                    90.0155345,
                    55.5738736
                ],
                [
                    90.0152487,
                    55.5732111
                ],
                [
                    90.0153249,
                    55.5727317
                ],
                [
                    90.0158203,
                    55.5724463
                ],
                [
                    90.0160585,
                    55.5721069
                ],
                [
                    90.0160204,
                    55.5718322
                ],
                [
                    90.0156107,
                    55.5713421
                ],
                [
                    90.0154106,
                    55.5711805
                ],
                [
                    90.0151153,
                    55.5711589
                ],
                [
                    90.0142769,
                    55.571132
                ],
                [
                    90.0138196,
                    55.5709919
                ],
                [
                    90.0139149,
                    55.5708411
                ],
                [
                    90.0142102,
                    55.5706795
                ],
                [
                    90.0155631,
                    55.5705287
                ],
                [
                    90.0157536,
                    55.5704048
                ],
                [
                    90.0159346,
                    55.5700816
                ],
                [
                    90.0162681,
                    55.5698338
                ],
                [
                    90.0163633,
                    55.5697045
                ],
                [
                    90.0160299,
                    55.5697261
                ],
                [
                    90.0156012,
                    55.5696668
                ],
                [
                    90.0148771,
                    55.5695968
                ],
                [
                    90.0144674,
                    55.5698069
                ],
                [
                    90.0137243,
                    55.5700493
                ],
                [
                    90.0134195,
                    55.5700277
                ],
                [
                    90.0133909,
                    55.5697422
                ],
                [
                    90.0136862,
                    55.5693598
                ],
                [
                    90.014134,
                    55.5693329
                ],
                [
                    90.0147437,
                    55.5689827
                ],
                [
                    90.0150105,
                    55.5686703
                ],
                [
                    90.0154773,
                    55.568541
                ],
                [
                    90.0165157,
                    55.5685733
                ],
                [
                    90.0174209,
                    55.5686056
                ],
                [
                    90.0178877,
                    55.5688427
                ],
                [
                    90.0182307,
                    55.5688696
                ],
                [
                    90.0184021,
                    55.5686164
                ],
                [
                    90.0185546,
                    55.5680185
                ],
                [
                    90.0188404,
                    55.5676414
                ],
                [
                    90.0188499,
                    55.5673936
                ],
                [
                    90.0186022,
                    55.5671997
                ],
                [
                    90.0181068,
                    55.566968
                ],
                [
                    90.0178591,
                    55.5665694
                ],
                [
                    90.0180782,
                    55.5663916
                ],
                [
                    90.0193072,
                    55.5664131
                ],
                [
                    90.0202123,
                    55.5663647
                ],
                [
                    90.0205553,
                    55.5662246
                ],
                [
                    90.0204886,
                    55.5659283
                ],
                [
                    90.020441,
                    55.5653034
                ],
                [
                    90.020298,
                    55.5651471
                ],
                [
                    90.019917,
                    55.5649586
                ],
                [
                    90.0199932,
                    55.5648455
                ],
                [
                    90.0207554,
                    55.564436
                ],
                [
                    90.0214478,
                    55.5643067
                ],
                [
                    90.0222313,
                    55.5638183
                ],
                [
                    90.0225056,
                    55.5635985
                ],
                [
                    90.0225819,
                    55.5631891
                ],
                [
                    90.0228791,
                    55.5628615
                ],
                [
                    90.0235498,
                    55.5624089
                ],
                [
                    90.0238471,
                    55.5619348
                ],
                [
                    90.0238699,
                    55.5616978
                ],
                [
                    90.0238471,
                    55.5615383
                ],
                [
                    90.0235346,
                    55.5613529
                ],
                [
                    90.0232678,
                    55.5612754
                ],
                [
                    90.0230849,
                    55.5613917
                ],
                [
                    90.0230315,
                    55.5616547
                ],
                [
                    90.0229096,
                    55.5617322
                ],
                [
                    90.0225209,
                    55.5615986
                ],
                [
                    90.0223608,
                    55.5613874
                ],
                [
                    90.0224142,
                    55.5610555
                ],
                [
                    90.0225971,
                    55.5605943
                ],
                [
                    90.022902,
                    55.5603961
                ],
                [
                    90.0231001,
                    55.5601676
                ],
                [
                    90.0229706,
                    55.5599995
                ],
                [
                    90.0233059,
                    55.55984
                ],
                [
                    90.0235955,
                    55.5595081
                ],
                [
                    90.0227267,
                    55.5589693
                ],
                [
                    90.0220179,
                    55.5584434
                ],
                [
                    90.0214539,
                    55.5577279
                ],
                [
                    90.0206078,
                    55.5557621
                ],
                [
                    90.0192664,
                    55.552434
                ],
                [
                    90.0187177,
                    55.5529341
                ],
                [
                    90.0187024,
                    55.5537101
                ],
                [
                    90.0183747,
                    55.5545077
                ],
                [
                    90.0174372,
                    55.5558009
                ],
                [
                    90.0020684,
                    55.5592924
                ],
                [
                    90.0002881,
                    55.5596656
                ],
                [
                    90.0006789,
                    55.5598761
                ],
                [
                    90.0009952,
                    55.5605285
                ],
                [
                    90.0011999,
                    55.5615388
                ],
                [
                    90.000958,
                    55.5628647
                ],
                [
                    89.9923612,
                    55.5620228
                ],
                [
                    89.9903516,
                    55.5692093
                ],
                [
                    89.988956,
                    55.5689042
                ],
                [
                    89.9839505,
                    55.568315
                ],
                [
                    89.9832621,
                    55.5724076
                ],
                [
                    89.9831875,
                    55.5736384
                ]
            ],
            "longitude": 90.007217,
            "latitude": 55.570072
        },
        "248": {
            "name": "Кривляк",
            "population": 773,
            "type": "village",
            "poly": null,
            "longitude": 90.021027,
            "latitude": 60.29945
        },
        "249": {
            "name": "Усть-Изыкчуль",
            "population": 414,
            "type": "village",
            "poly": [
                [
                    89.9770231,
                    55.4839136
                ],
                [
                    89.9779177,
                    55.485117
                ],
                [
                    89.9835038,
                    55.4870824
                ],
                [
                    89.9899011,
                    55.4899656
                ],
                [
                    90.0008994,
                    55.4961628
                ],
                [
                    90.0036882,
                    55.4980318
                ],
                [
                    90.0037667,
                    55.4985881
                ],
                [
                    90.0058683,
                    55.5014247
                ],
                [
                    90.0063593,
                    55.5028708
                ],
                [
                    90.0063397,
                    55.5036272
                ],
                [
                    90.0060254,
                    55.5041166
                ],
                [
                    90.0061825,
                    55.5044948
                ],
                [
                    90.0109353,
                    55.5038385
                ],
                [
                    90.011996,
                    55.5037829
                ],
                [
                    90.0139796,
                    55.503427
                ],
                [
                    90.0150794,
                    55.5030821
                ],
                [
                    90.0161399,
                    55.5032601
                ],
                [
                    90.018595,
                    55.5028485
                ],
                [
                    90.0192824,
                    55.502437
                ],
                [
                    90.0199698,
                    55.5022145
                ],
                [
                    90.0203429,
                    55.5016027
                ],
                [
                    90.0205493,
                    55.5008084
                ],
                [
                    90.0201632,
                    55.5002571
                ],
                [
                    90.0193426,
                    55.4999974
                ],
                [
                    90.0194955,
                    55.4997012
                ],
                [
                    90.0190611,
                    55.498799
                ],
                [
                    90.019045,
                    55.4984892
                ],
                [
                    90.0178382,
                    55.4982887
                ],
                [
                    90.017798,
                    55.4984345
                ],
                [
                    90.016873,
                    55.4983844
                ],
                [
                    90.0167764,
                    55.498111
                ],
                [
                    90.0173235,
                    55.4978922
                ],
                [
                    90.0178222,
                    55.4978421
                ],
                [
                    90.0180555,
                    55.4977829
                ],
                [
                    90.0186991,
                    55.497751
                ],
                [
                    90.0195598,
                    55.4974457
                ],
                [
                    90.0204367,
                    55.4973591
                ],
                [
                    90.02248,
                    55.4975642
                ],
                [
                    90.0242256,
                    55.4979788
                ],
                [
                    90.0252875,
                    55.4979788
                ],
                [
                    90.0272181,
                    55.4980791
                ],
                [
                    90.0276124,
                    55.4977874
                ],
                [
                    90.0288915,
                    55.4972543
                ],
                [
                    90.0292776,
                    55.4968852
                ],
                [
                    90.0296476,
                    55.4965571
                ],
                [
                    90.0311841,
                    55.4959829
                ],
                [
                    90.0325276,
                    55.4952493
                ],
                [
                    90.0328574,
                    55.4948118
                ],
                [
                    90.0329057,
                    55.4942194
                ],
                [
                    90.0319162,
                    55.4931256
                ],
                [
                    90.031182,
                    55.492447
                ],
                [
                    90.0314208,
                    55.4921337
                ],
                [
                    90.0331427,
                    55.4885232
                ],
                [
                    90.0335702,
                    55.4882668
                ],
                [
                    90.0312699,
                    55.4882455
                ],
                [
                    90.0301889,
                    55.48816
                ],
                [
                    90.0287937,
                    55.4877683
                ],
                [
                    90.0268454,
                    55.4870775
                ],
                [
                    90.0254117,
                    55.4867235
                ],
                [
                    90.0245301,
                    55.486698
                ],
                [
                    90.0203533,
                    55.4869095
                ],
                [
                    90.0192078,
                    55.4870699
                ],
                [
                    90.0181974,
                    55.4871356
                ],
                [
                    90.0177276,
                    55.487358
                ],
                [
                    90.0167687,
                    55.488255
                ],
                [
                    90.0157326,
                    55.489389
                ],
                [
                    90.0155587,
                    55.4898447
                ],
                [
                    90.0154237,
                    55.4899687
                ],
                [
                    90.0150697,
                    55.4901182
                ],
                [
                    90.014587,
                    55.4901109
                ],
                [
                    90.0141493,
                    55.4900197
                ],
                [
                    90.0135445,
                    55.4898192
                ],
                [
                    90.0129427,
                    55.4893355
                ],
                [
                    90.0129531,
                    55.4901926
                ],
                [
                    90.0124576,
                    55.490251
                ],
                [
                    90.012065,
                    55.4901525
                ],
                [
                    90.0110417,
                    55.4895728
                ],
                [
                    90.0103853,
                    55.4895837
                ],
                [
                    90.0099799,
                    55.4897004
                ],
                [
                    90.0095616,
                    55.4900358
                ],
                [
                    90.0090273,
                    55.4907432
                ],
                [
                    90.0079205,
                    55.491126
                ],
                [
                    90.0075408,
                    55.4914505
                ],
                [
                    90.0066527,
                    55.4912609
                ],
                [
                    90.0061957,
                    55.4910349
                ],
                [
                    90.0056165,
                    55.4904697
                ],
                [
                    90.0047284,
                    55.489303
                ],
                [
                    90.0043616,
                    55.4889967
                ],
                [
                    90.0037502,
                    55.4887342
                ],
                [
                    90.0029972,
                    55.4883987
                ],
                [
                    90.0024566,
                    55.4879575
                ],
                [
                    90.0022057,
                    55.4873887
                ],
                [
                    90.0014205,
                    55.4864443
                ],
                [
                    90.0008735,
                    55.4862328
                ],
                [
                    90.0002814,
                    55.4861052
                ],
                [
                    89.9991487,
                    55.4864953
                ],
                [
                    89.9986532,
                    55.4865245
                ],
                [
                    89.99837,
                    55.4863969
                ],
                [
                    89.9979839,
                    55.4860906
                ],
                [
                    89.9951072,
                    55.4846137
                ],
                [
                    89.9951522,
                    55.484384
                ],
                [
                    89.995371,
                    55.4840266
                ],
                [
                    89.9952809,
                    55.4838005
                ],
                [
                    89.994779,
                    55.4836073
                ],
                [
                    89.994972,
                    55.4830712
                ],
                [
                    89.9946438,
                    55.4828159
                ],
                [
                    89.9943285,
                    55.4827576
                ],
                [
                    89.9937815,
                    55.4828378
                ],
                [
                    89.9906216,
                    55.4828487
                ],
                [
                    89.9901582,
                    55.4829436
                ],
                [
                    89.989727,
                    55.4834031
                ],
                [
                    89.9891929,
                    55.4833483
                ],
                [
                    89.9881246,
                    55.4826919
                ],
                [
                    89.9877191,
                    55.4826555
                ],
                [
                    89.9873072,
                    55.4830129
                ],
                [
                    89.9869726,
                    55.4835125
                ],
                [
                    89.9866058,
                    55.4836291
                ],
                [
                    89.9858335,
                    55.4836073
                ],
                [
                    89.9852607,
                    55.4834833
                ],
                [
                    89.9847908,
                    55.4834723
                ],
                [
                    89.9845013,
                    55.4835599
                ],
                [
                    89.9843533,
                    55.4839683
                ],
                [
                    89.9835102,
                    55.4848362
                ],
                [
                    89.9828023,
                    55.4850112
                ],
                [
                    89.9821394,
                    55.4849237
                ],
                [
                    89.9808073,
                    55.4845736
                ],
                [
                    89.9797068,
                    55.4848435
                ],
                [
                    89.979237,
                    55.4848216
                ],
                [
                    89.9780786,
                    55.4841652
                ],
                [
                    89.9770231,
                    55.4839136
                ]
            ],
            "longitude": 90.021706,
            "latitude": 55.495125
        },
        "250": {
            "name": "Бор",
            "population": 2496,
            "type": "village",
            "poly": [
                [
                    89.9948469,
                    61.6012655
                ],
                [
                    89.9948469,
                    61.605429
                ],
                [
                    90.0065199,
                    61.6037963
                ],
                [
                    90.023686,
                    61.6001225
                ],
                [
                    90.0444571,
                    61.59506
                ],
                [
                    90.0439421,
                    61.5936718
                ],
                [
                    90.0593916,
                    61.5899967
                ],
                [
                    90.0597349,
                    61.5850143
                ],
                [
                    90.0408522,
                    61.5881182
                ],
                [
                    90.0290075,
                    61.585096
                ],
                [
                    90.0166479,
                    61.585341
                ],
                [
                    90.0163046,
                    61.588935
                ],
                [
                    90.0114981,
                    61.5920385
                ],
                [
                    90.0178495,
                    61.5957949
                ],
                [
                    90.0157155,
                    61.5969704
                ],
                [
                    90.0146309,
                    61.5975678
                ],
                [
                    90.014588,
                    61.5975914
                ],
                [
                    90.0054899,
                    61.5993877
                ],
                [
                    90.0054548,
                    61.5993782
                ],
                [
                    90.0032109,
                    61.5987683
                ],
                [
                    89.9982802,
                    61.597428
                ],
                [
                    89.9948469,
                    61.6012655
                ]
            ],
            "longitude": 90.024033,
            "latitude": 61.596855
        },
        "251": {
            "name": "Красный Завод",
            "population": 982,
            "type": "village",
            "poly": [
                [
                    [
                        90.0144813,
                        56.1790621
                    ],
                    [
                        90.0149572,
                        56.1802235
                    ],
                    [
                        90.0160737,
                        56.1818534
                    ],
                    [
                        90.0173,
                        56.1833407
                    ],
                    [
                        90.0202835,
                        56.1841862
                    ],
                    [
                        90.0217478,
                        56.1849501
                    ],
                    [
                        90.0226263,
                        56.185816
                    ],
                    [
                        90.023871,
                        56.1864882
                    ],
                    [
                        90.0250973,
                        56.1864271
                    ],
                    [
                        90.0289228,
                        56.1883624
                    ],
                    [
                        90.0318879,
                        56.1904503
                    ],
                    [
                        90.0317598,
                        56.1907456
                    ],
                    [
                        90.0356402,
                        56.1946054
                    ],
                    [
                        90.0353839,
                        56.1949007
                    ],
                    [
                        90.0358232,
                        56.1958682
                    ],
                    [
                        90.0363906,
                        56.1956645
                    ],
                    [
                        90.0379647,
                        56.1971818
                    ],
                    [
                        90.0387884,
                        56.1969578
                    ],
                    [
                        90.0394838,
                        56.1976502
                    ],
                    [
                        90.041241,
                        56.1969883
                    ],
                    [
                        90.0436388,
                        56.1953692
                    ],
                    [
                        90.0419183,
                        56.1946462
                    ],
                    [
                        90.0425955,
                        56.194086
                    ],
                    [
                        90.0434558,
                        56.1937907
                    ],
                    [
                        90.0445906,
                        56.1940657
                    ],
                    [
                        90.0447553,
                        56.193862
                    ],
                    [
                        90.0423575,
                        56.1931491
                    ],
                    [
                        90.0411861,
                        56.1922122
                    ],
                    [
                        90.0421745,
                        56.1916215
                    ],
                    [
                        90.0417352,
                        56.1913363
                    ],
                    [
                        90.0419915,
                        56.1911632
                    ],
                    [
                        90.0407834,
                        56.1902568
                    ],
                    [
                        90.0410031,
                        56.1900429
                    ],
                    [
                        90.03985,
                        56.1895642
                    ],
                    [
                        90.0389348,
                        56.1899105
                    ],
                    [
                        90.0392459,
                        56.1887087
                    ],
                    [
                        90.0399964,
                        56.1888411
                    ],
                    [
                        90.0404357,
                        56.1887494
                    ],
                    [
                        90.0420281,
                        56.1873031
                    ],
                    [
                        90.0434192,
                        56.1877716
                    ],
                    [
                        90.0443709,
                        56.187904
                    ],
                    [
                        90.0449566,
                        56.1873031
                    ],
                    [
                        90.0451763,
                        56.1869262
                    ],
                    [
                        90.0450482,
                        56.1866818
                    ],
                    [
                        90.0438035,
                        56.1867734
                    ],
                    [
                        90.0432544,
                        56.1863966
                    ],
                    [
                        90.042925,
                        56.185816
                    ],
                    [
                        90.0432361,
                        56.1851539
                    ],
                    [
                        90.0436022,
                        56.1845834
                    ],
                    [
                        90.0426686,
                        56.1841556
                    ],
                    [
                        90.0409116,
                        56.1845631
                    ],
                    [
                        90.0392643,
                        56.1841658
                    ],
                    [
                        90.0378915,
                        56.1851029
                    ],
                    [
                        90.0362259,
                        56.1854696
                    ],
                    [
                        90.0353656,
                        56.1858465
                    ],
                    [
                        90.034725,
                        56.186967
                    ],
                    [
                        90.0250241,
                        56.1842371
                    ],
                    [
                        90.0250058,
                        56.1836463
                    ],
                    [
                        90.0253902,
                        56.1834426
                    ],
                    [
                        90.0253902,
                        56.1827295
                    ],
                    [
                        90.0259759,
                        56.1823628
                    ],
                    [
                        90.0290692,
                        56.1825258
                    ],
                    [
                        90.0306982,
                        56.1820775
                    ],
                    [
                        90.030204,
                        56.1816802
                    ],
                    [
                        90.0322723,
                        56.1807227
                    ],
                    [
                        90.0352924,
                        56.1797956
                    ],
                    [
                        90.0401976,
                        56.1791742
                    ],
                    [
                        90.0400147,
                        56.1788176
                    ],
                    [
                        90.0392276,
                        56.1788787
                    ],
                    [
                        90.0389897,
                        56.1786138
                    ],
                    [
                        90.034121,
                        56.1792149
                    ],
                    [
                        90.0301674,
                        56.180468
                    ],
                    [
                        90.0282638,
                        56.1808857
                    ],
                    [
                        90.0270558,
                        56.1808245
                    ],
                    [
                        90.0261223,
                        56.1805495
                    ],
                    [
                        90.0257196,
                        56.1801929
                    ],
                    [
                        90.0252804,
                        56.1801929
                    ],
                    [
                        90.0259759,
                        56.1793372
                    ],
                    [
                        90.0260491,
                        56.179001
                    ],
                    [
                        90.0254634,
                        56.1786953
                    ],
                    [
                        90.0248777,
                        56.178675
                    ],
                    [
                        90.024292,
                        56.1786342
                    ],
                    [
                        90.0237429,
                        56.1770652
                    ],
                    [
                        90.023871,
                        56.1768513
                    ],
                    [
                        90.0230839,
                        56.1761381
                    ],
                    [
                        90.0224616,
                        56.1748238
                    ],
                    [
                        90.0224067,
                        56.1740392
                    ],
                    [
                        90.0230107,
                        56.1732648
                    ],
                    [
                        90.0243652,
                        56.1731935
                    ],
                    [
                        90.0244018,
                        56.1729999
                    ],
                    [
                        90.0234134,
                        56.1728573
                    ],
                    [
                        90.0230656,
                        56.1719912
                    ],
                    [
                        90.022425,
                        56.1712779
                    ],
                    [
                        90.0204299,
                        56.1712779
                    ],
                    [
                        90.020613,
                        56.1718893
                    ],
                    [
                        90.020979,
                        56.1724395
                    ],
                    [
                        90.0203384,
                        56.1729693
                    ],
                    [
                        90.0202103,
                        56.1733769
                    ],
                    [
                        90.0163848,
                        56.1734075
                    ],
                    [
                        90.016513,
                        56.1745894
                    ],
                    [
                        90.0184348,
                        56.1743041
                    ],
                    [
                        90.0192036,
                        56.175109
                    ],
                    [
                        90.0196246,
                        56.175863
                    ],
                    [
                        90.018325,
                        56.1761279
                    ],
                    [
                        90.0180321,
                        56.1758936
                    ],
                    [
                        90.0174098,
                        56.1760872
                    ],
                    [
                        90.0181786,
                        56.1774116
                    ],
                    [
                        90.0169705,
                        56.1774626
                    ],
                    [
                        90.0157808,
                        56.1780535
                    ],
                    [
                        90.0147008,
                        56.1781961
                    ],
                    [
                        90.0144813,
                        56.1790621
                    ]
                ],
                [
                    [
                        90.0096672,
                        56.1936577
                    ],
                    [
                        90.0110033,
                        56.1942687
                    ],
                    [
                        90.0110216,
                        56.1946761
                    ],
                    [
                        90.011589,
                        56.1947677
                    ],
                    [
                        90.0123761,
                        56.1942382
                    ],
                    [
                        90.0129252,
                        56.1941363
                    ],
                    [
                        90.0136024,
                        56.1945233
                    ],
                    [
                        90.0139502,
                        56.1944928
                    ],
                    [
                        90.0139868,
                        56.193953
                    ],
                    [
                        90.0147372,
                        56.19323
                    ],
                    [
                        90.017318,
                        56.1934642
                    ],
                    [
                        90.0184162,
                        56.1938206
                    ],
                    [
                        90.0185627,
                        56.1926189
                    ],
                    [
                        90.0190386,
                        56.1930263
                    ],
                    [
                        90.0199904,
                        56.1936577
                    ],
                    [
                        90.0209238,
                        56.1950936
                    ],
                    [
                        90.0219671,
                        56.1949714
                    ],
                    [
                        90.0213265,
                        56.1934031
                    ],
                    [
                        90.0240903,
                        56.1935966
                    ],
                    [
                        90.026122,
                        56.1939428
                    ],
                    [
                        90.0294715,
                        56.1960814
                    ],
                    [
                        90.0305698,
                        56.1957351
                    ],
                    [
                        90.0259024,
                        56.1919162
                    ],
                    [
                        90.0234863,
                        56.1903784
                    ],
                    [
                        90.022205,
                        56.1898589
                    ],
                    [
                        90.0204478,
                        56.1897265
                    ],
                    [
                        90.019002,
                        56.1887589
                    ],
                    [
                        90.0174828,
                        56.188321
                    ],
                    [
                        90.0168788,
                        56.1886877
                    ],
                    [
                        90.0128337,
                        56.186895
                    ],
                    [
                        90.0115158,
                        56.186182
                    ],
                    [
                        90.0113511,
                        56.1864468
                    ],
                    [
                        90.011589,
                        56.1868237
                    ],
                    [
                        90.0110216,
                        56.1875367
                    ],
                    [
                        90.0135841,
                        56.1890747
                    ],
                    [
                        90.0131631,
                        56.19102
                    ],
                    [
                        90.0110948,
                        56.1929346
                    ],
                    [
                        90.0096672,
                        56.1936577
                    ]
                ]
            ],
            "longitude": 90.02449,
            "latitude": 56.181721
        },
        "252": {
            "name": "Красная Сопка",
            "population": 1807,
            "type": "village",
            "poly": [
                [
                    90.0133735,
                    55.7059087
                ],
                [
                    90.0137572,
                    55.7071278
                ],
                [
                    90.013926,
                    55.7072489
                ],
                [
                    90.0159483,
                    55.7070862
                ],
                [
                    90.0159914,
                    55.7071745
                ],
                [
                    90.0165769,
                    55.7083744
                ],
                [
                    90.0237195,
                    55.7106049
                ],
                [
                    90.0258065,
                    55.7096643
                ],
                [
                    90.025119,
                    55.7092147
                ],
                [
                    90.0265308,
                    55.708447
                ],
                [
                    90.0288634,
                    55.7101346
                ],
                [
                    90.030328,
                    55.7102434
                ],
                [
                    90.031811,
                    55.7099889
                ],
                [
                    90.0334806,
                    55.7109184
                ],
                [
                    90.0352386,
                    55.711184
                ],
                [
                    90.0358769,
                    55.7107856
                ],
                [
                    90.0378314,
                    55.7101715
                ],
                [
                    90.0387601,
                    55.709622
                ],
                [
                    90.0397972,
                    55.709413
                ],
                [
                    90.0433548,
                    55.7080496
                ],
                [
                    90.0433045,
                    55.7079788
                ],
                [
                    90.0502434,
                    55.7049736
                ],
                [
                    90.0506708,
                    55.7051011
                ],
                [
                    90.0572071,
                    55.7025326
                ],
                [
                    90.0591615,
                    55.7022117
                ],
                [
                    90.0618491,
                    55.7000954
                ],
                [
                    90.0564475,
                    55.6963386
                ],
                [
                    90.0501751,
                    55.694211
                ],
                [
                    90.0461366,
                    55.6918285
                ],
                [
                    90.0468638,
                    55.6906504
                ],
                [
                    90.046746,
                    55.6903902
                ],
                [
                    90.046944,
                    55.6900526
                ],
                [
                    90.0459815,
                    55.6893717
                ],
                [
                    90.0458424,
                    55.6894325
                ],
                [
                    90.0458621,
                    55.6897149
                ],
                [
                    90.045646,
                    55.6898034
                ],
                [
                    90.0456067,
                    55.6901135
                ],
                [
                    90.045371,
                    55.6901854
                ],
                [
                    90.0454398,
                    55.6904954
                ],
                [
                    90.0450371,
                    55.6906228
                ],
                [
                    90.0447719,
                    55.6910988
                ],
                [
                    90.0438094,
                    55.6915694
                ],
                [
                    90.0427095,
                    55.692444
                ],
                [
                    90.0419434,
                    55.6926322
                ],
                [
                    90.0419139,
                    55.692837
                ],
                [
                    90.0416586,
                    55.6932079
                ],
                [
                    90.0413345,
                    55.6934183
                ],
                [
                    90.04103,
                    55.6934459
                ],
                [
                    90.0403818,
                    55.693684
                ],
                [
                    90.0400283,
                    55.6934736
                ],
                [
                    90.0389283,
                    55.6927263
                ],
                [
                    90.0377596,
                    55.692217
                ],
                [
                    90.0362569,
                    55.6918738
                ],
                [
                    90.0348819,
                    55.6918185
                ],
                [
                    90.0334677,
                    55.6918738
                ],
                [
                    90.0314838,
                    55.692134
                ],
                [
                    90.0322008,
                    55.6942264
                ],
                [
                    90.0329373,
                    55.6956047
                ],
                [
                    90.0320036,
                    55.6956746
                ],
                [
                    90.0253252,
                    55.6955016
                ],
                [
                    90.0242203,
                    55.6952733
                ],
                [
                    90.0226612,
                    55.6951418
                ],
                [
                    90.0210407,
                    55.695301
                ],
                [
                    90.0202918,
                    55.6958683
                ],
                [
                    90.017456,
                    55.6988364
                ],
                [
                    90.01888,
                    55.70031
                ],
                [
                    90.0173577,
                    55.7015345
                ],
                [
                    90.0163506,
                    55.7032023
                ],
                [
                    90.013972,
                    55.7050613
                ],
                [
                    90.0135577,
                    55.7055023
                ],
                [
                    90.0133735,
                    55.7059087
                ]
            ],
            "longitude": 90.036812,
            "latitude": 55.702316
        },
        "253": {
            "name": "Ельник",
            "population": 318,
            "type": "village",
            "poly": [
                [
                    90.0278042,
                    55.93848
                ],
                [
                    90.0278482,
                    55.9393995
                ],
                [
                    90.0283172,
                    55.939457
                ],
                [
                    90.0301202,
                    55.9407213
                ],
                [
                    90.0307798,
                    55.9415011
                ],
                [
                    90.0316154,
                    55.9415586
                ],
                [
                    90.0323336,
                    55.9417803
                ],
                [
                    90.0329786,
                    55.9424124
                ],
                [
                    90.033433,
                    55.9424534
                ],
                [
                    90.0334623,
                    55.9434549
                ],
                [
                    90.0340047,
                    55.943381
                ],
                [
                    90.0348549,
                    55.9434139
                ],
                [
                    90.0350747,
                    55.943734
                ],
                [
                    90.035749,
                    55.9441116
                ],
                [
                    90.0365699,
                    55.9439967
                ],
                [
                    90.0368777,
                    55.9442594
                ],
                [
                    90.0390325,
                    55.9442676
                ],
                [
                    90.039912,
                    55.9443661
                ],
                [
                    90.0402345,
                    55.9441937
                ],
                [
                    90.0403371,
                    55.9437012
                ],
                [
                    90.0406156,
                    55.9435206
                ],
                [
                    90.0415538,
                    55.9434303
                ],
                [
                    90.0419349,
                    55.9435616
                ],
                [
                    90.0423013,
                    55.9434959
                ],
                [
                    90.0424039,
                    55.9432086
                ],
                [
                    90.0430049,
                    55.9430773
                ],
                [
                    90.0442802,
                    55.9429952
                ],
                [
                    90.04579,
                    55.9426668
                ],
                [
                    90.0468015,
                    55.9427736
                ],
                [
                    90.0470946,
                    55.9423713
                ],
                [
                    90.0478841,
                    55.9423338
                ],
                [
                    90.0481207,
                    55.9423549
                ],
                [
                    90.0484285,
                    55.9427736
                ],
                [
                    90.0490735,
                    55.942634
                ],
                [
                    90.049396,
                    55.9423549
                ],
                [
                    90.0504514,
                    55.9423959
                ],
                [
                    90.0505833,
                    55.9420922
                ],
                [
                    90.0510377,
                    55.9419691
                ],
                [
                    90.0512869,
                    55.942084
                ],
                [
                    90.0514921,
                    55.942478
                ],
                [
                    90.0518586,
                    55.9425683
                ],
                [
                    90.0536029,
                    55.9420512
                ],
                [
                    90.0542039,
                    55.9420347
                ],
                [
                    90.0544385,
                    55.9418295
                ],
                [
                    90.0544678,
                    55.941419
                ],
                [
                    90.0551567,
                    55.9410743
                ],
                [
                    90.0558164,
                    55.9411235
                ],
                [
                    90.05623,
                    55.9414786
                ],
                [
                    90.0570802,
                    55.9414868
                ],
                [
                    90.0573587,
                    55.9413965
                ],
                [
                    90.0572854,
                    55.940986
                ],
                [
                    90.0574027,
                    55.9408136
                ],
                [
                    90.0579597,
                    55.9408382
                ],
                [
                    90.0557023,
                    55.9379484
                ],
                [
                    90.0552332,
                    55.937579
                ],
                [
                    90.0547935,
                    55.9364213
                ],
                [
                    90.0542365,
                    55.9358548
                ],
                [
                    90.0523602,
                    55.9350337
                ],
                [
                    90.0513926,
                    55.9349434
                ],
                [
                    90.0498243,
                    55.9351815
                ],
                [
                    90.0485197,
                    55.9357809
                ],
                [
                    90.0483585,
                    55.9352636
                ],
                [
                    90.0478747,
                    55.934886
                ],
                [
                    90.0471456,
                    55.9330138
                ],
                [
                    90.0464127,
                    55.9320778
                ],
                [
                    90.0451521,
                    55.9312484
                ],
                [
                    90.0445522,
                    55.9317774
                ],
                [
                    90.0440949,
                    55.9318365
                ],
                [
                    90.0433209,
                    55.9317577
                ],
                [
                    90.0417495,
                    55.9312256
                ],
                [
                    90.0410929,
                    55.9307263
                ],
                [
                    90.039451,
                    55.930227
                ],
                [
                    90.0390993,
                    55.9302796
                ],
                [
                    90.0376921,
                    55.9305621
                ],
                [
                    90.035253,
                    55.9321781
                ],
                [
                    90.0338106,
                    55.9334262
                ],
                [
                    90.0329076,
                    55.9343655
                ],
                [
                    90.0321102,
                    55.9351209
                ],
                [
                    90.030445,
                    55.9358697
                ],
                [
                    90.0302691,
                    55.9364346
                ],
                [
                    90.0299173,
                    55.9367498
                ],
                [
                    90.0291316,
                    55.9372293
                ],
                [
                    90.0282287,
                    55.938405
                ],
                [
                    90.0278042,
                    55.93848
                ]
            ],
            "longitude": 90.03936,
            "latitude": 55.937218
        },
        "254": {
            "name": "Ильинка",
            "population": 568,
            "type": "village",
            "poly": [
                [
                    90.0152537,
                    55.2948251
                ],
                [
                    90.0158776,
                    55.2948635
                ],
                [
                    90.0168389,
                    55.29535
                ],
                [
                    90.0173504,
                    55.2955068
                ],
                [
                    90.018098,
                    55.2956348
                ],
                [
                    90.0186264,
                    55.2956668
                ],
                [
                    90.0197563,
                    55.2955804
                ],
                [
                    90.021898,
                    55.295446
                ],
                [
                    90.0227693,
                    55.295446
                ],
                [
                    90.0235731,
                    55.295494
                ],
                [
                    90.0248773,
                    55.295622
                ],
                [
                    90.0255743,
                    55.2956572
                ],
                [
                    90.0266255,
                    55.2956572
                ],
                [
                    90.0271314,
                    55.2956156
                ],
                [
                    90.0301219,
                    55.2952187
                ],
                [
                    90.0313192,
                    55.2950523
                ],
                [
                    90.0374633,
                    55.2938745
                ],
                [
                    90.0400716,
                    55.2932312
                ],
                [
                    90.0411508,
                    55.293004
                ],
                [
                    90.0436354,
                    55.2925111
                ],
                [
                    90.044518,
                    55.2925335
                ],
                [
                    90.0450689,
                    55.2925943
                ],
                [
                    90.0457715,
                    55.2927991
                ],
                [
                    90.0463899,
                    55.2930744
                ],
                [
                    90.0470981,
                    55.2935737
                ],
                [
                    90.0475478,
                    55.2938297
                ],
                [
                    90.0490206,
                    55.2942746
                ],
                [
                    90.0489981,
                    55.2941786
                ],
                [
                    90.0498132,
                    55.2934969
                ],
                [
                    90.0501786,
                    55.2932728
                ],
                [
                    90.0506227,
                    55.2932472
                ],
                [
                    90.0510836,
                    55.2933048
                ],
                [
                    90.0519662,
                    55.2933912
                ],
                [
                    90.0522978,
                    55.2932056
                ],
                [
                    90.0525789,
                    55.2925719
                ],
                [
                    90.0527475,
                    55.292303
                ],
                [
                    90.0529499,
                    55.2922262
                ],
                [
                    90.0534895,
                    55.292223
                ],
                [
                    90.0543721,
                    55.2921558
                ],
                [
                    90.0547824,
                    55.2920886
                ],
                [
                    90.0549511,
                    55.2919765
                ],
                [
                    90.0550522,
                    55.2918549
                ],
                [
                    90.0551422,
                    55.2915316
                ],
                [
                    90.0551871,
                    55.2909395
                ],
                [
                    90.0551253,
                    55.2907763
                ],
                [
                    90.0550964,
                    55.2897676
                ],
                [
                    90.0551863,
                    55.2896139
                ],
                [
                    90.0554427,
                    55.2893963
                ],
                [
                    90.0558114,
                    55.2892298
                ],
                [
                    90.0562207,
                    55.289112
                ],
                [
                    90.0566029,
                    55.2889174
                ],
                [
                    90.0570166,
                    55.288815
                ],
                [
                    90.0575608,
                    55.2886613
                ],
                [
                    90.0579025,
                    55.2885
                ],
                [
                    90.0582488,
                    55.2881569
                ],
                [
                    90.0584782,
                    55.2877266
                ],
                [
                    90.0587974,
                    55.2873297
                ],
                [
                    90.0591032,
                    55.2871632
                ],
                [
                    90.0596968,
                    55.2869763
                ],
                [
                    90.0598048,
                    55.2869379
                ],
                [
                    90.060938,
                    55.2850428
                ],
                [
                    90.060268,
                    55.284925
                ],
                [
                    90.0588109,
                    55.2849992
                ],
                [
                    90.0562611,
                    55.2854039
                ],
                [
                    90.0554157,
                    55.2854807
                ],
                [
                    90.0540666,
                    55.2854781
                ],
                [
                    90.0535224,
                    55.2855524
                ],
                [
                    90.0515932,
                    55.2860774
                ],
                [
                    90.0510176,
                    55.2846919
                ],
                [
                    90.0498124,
                    55.2838416
                ],
                [
                    90.0481935,
                    55.2829529
                ],
                [
                    90.0476898,
                    55.2824407
                ],
                [
                    90.0473975,
                    55.2821129
                ],
                [
                    90.0454503,
                    55.2822281
                ],
                [
                    90.0449601,
                    55.2813778
                ],
                [
                    90.0419786,
                    55.2815366
                ],
                [
                    90.0412051,
                    55.2816109
                ],
                [
                    90.0403912,
                    55.2817287
                ],
                [
                    90.0389746,
                    55.2820949
                ],
                [
                    90.0243593,
                    55.2860595
                ],
                [
                    90.0168673,
                    55.2880852
                ],
                [
                    90.0184465,
                    55.2918485
                ],
                [
                    90.0166196,
                    55.2935961
                ],
                [
                    90.0162205,
                    55.2937945
                ],
                [
                    90.016243,
                    55.2939193
                ],
                [
                    90.0161868,
                    55.2939705
                ],
                [
                    90.0155797,
                    55.2939673
                ],
                [
                    90.0153886,
                    55.2940602
                ],
                [
                    90.0153211,
                    55.2941402
                ],
                [
                    90.0154785,
                    55.2944538
                ],
                [
                    90.0156134,
                    55.2945082
                ],
                [
                    90.0158945,
                    55.2946298
                ],
                [
                    90.0159395,
                    55.2946843
                ],
                [
                    90.0152537,
                    55.2948251
                ]
            ],
            "longitude": 90.040512,
            "latitude": 55.287849
        },
        "255": {
            "name": "Кибитень",
            "population": 282,
            "type": "village",
            "poly": [
                [
                    90.0349212,
                    55.795305
                ],
                [
                    90.0354976,
                    55.7962061
                ],
                [
                    90.0358699,
                    55.7966685
                ],
                [
                    90.0364463,
                    55.7970904
                ],
                [
                    90.0379773,
                    55.7978194
                ],
                [
                    90.0410154,
                    55.798626
                ],
                [
                    90.0453148,
                    55.7997082
                ],
                [
                    90.0443242,
                    55.8007122
                ],
                [
                    90.0442866,
                    55.8009232
                ],
                [
                    90.0447144,
                    55.8011299
                ],
                [
                    90.0463731,
                    55.8015095
                ],
                [
                    90.0463505,
                    55.8017753
                ],
                [
                    90.0453674,
                    55.8024038
                ],
                [
                    90.0443617,
                    55.803066
                ],
                [
                    90.0441966,
                    55.8032474
                ],
                [
                    90.0444518,
                    55.8034752
                ],
                [
                    90.0475889,
                    55.8039307
                ],
                [
                    90.048437,
                    55.8031673
                ],
                [
                    90.0487972,
                    55.8026316
                ],
                [
                    90.0492175,
                    55.802408
                ],
                [
                    90.0498704,
                    55.8024207
                ],
                [
                    90.0516191,
                    55.8027159
                ],
                [
                    90.0530076,
                    55.8030281
                ],
                [
                    90.0532177,
                    55.8030239
                ],
                [
                    90.0533078,
                    55.8029348
                ],
                [
                    90.0533753,
                    55.8028383
                ],
                [
                    90.0570828,
                    55.8043272
                ],
                [
                    90.0577958,
                    55.8044453
                ],
                [
                    90.0635672,
                    55.8051624
                ],
                [
                    90.0715352,
                    55.8060697
                ],
                [
                    90.0709841,
                    55.8036707
                ],
                [
                    90.0708316,
                    55.8033807
                ],
                [
                    90.0709137,
                    55.8028139
                ],
                [
                    90.0717932,
                    55.8021614
                ],
                [
                    90.0702922,
                    55.8013112
                ],
                [
                    90.0705736,
                    55.8006059
                ],
                [
                    90.0688381,
                    55.8003818
                ],
                [
                    90.0672315,
                    55.800105
                ],
                [
                    90.0645461,
                    55.7999797
                ],
                [
                    90.0631389,
                    55.799637
                ],
                [
                    90.0616496,
                    55.7995776
                ],
                [
                    90.0605356,
                    55.799459
                ],
                [
                    90.0580847,
                    55.7982923
                ],
                [
                    90.0576039,
                    55.7982132
                ],
                [
                    90.0574632,
                    55.7981011
                ],
                [
                    90.0574866,
                    55.7977979
                ],
                [
                    90.0578736,
                    55.7975606
                ],
                [
                    90.0567127,
                    55.7971058
                ],
                [
                    90.055798,
                    55.7964268
                ],
                [
                    90.0550592,
                    55.796262
                ],
                [
                    90.0539686,
                    55.7963675
                ],
                [
                    90.051635,
                    55.7955171
                ],
                [
                    90.0500284,
                    55.7951611
                ],
                [
                    90.0493014,
                    55.7951677
                ],
                [
                    90.0489965,
                    55.79526
                ],
                [
                    90.047988,
                    55.7953391
                ],
                [
                    90.0473547,
                    55.7952732
                ],
                [
                    90.0456454,
                    55.7947409
                ],
                [
                    90.0445607,
                    55.7947327
                ],
                [
                    90.0441356,
                    55.7946667
                ],
                [
                    90.0425525,
                    55.7938509
                ],
                [
                    90.0418782,
                    55.7937603
                ],
                [
                    90.0416876,
                    55.7940157
                ],
                [
                    90.0411892,
                    55.7942547
                ],
                [
                    90.0381843,
                    55.7947903
                ],
                [
                    90.037521,
                    55.7946772
                ],
                [
                    90.037221,
                    55.7952453
                ],
                [
                    90.0370947,
                    55.7953117
                ],
                [
                    90.0350113,
                    55.7947919
                ],
                [
                    90.0349212,
                    55.795305
                ]
            ],
            "longitude": 90.052391,
            "latitude": 55.800148
        },
        "256": {
            "name": "Красная Речка",
            "population": 344,
            "type": "village",
            "poly": [
                [
                    90.0397566,
                    56.224405
                ],
                [
                    90.0418615,
                    56.2248121
                ],
                [
                    90.0445841,
                    56.2259695
                ],
                [
                    90.0418386,
                    56.2256007
                ],
                [
                    90.041843,
                    56.226417
                ],
                [
                    90.0433073,
                    56.2278517
                ],
                [
                    90.0446434,
                    56.2284113
                ],
                [
                    90.0459247,
                    56.2285334
                ],
                [
                    90.0503118,
                    56.2295941
                ],
                [
                    90.0518447,
                    56.2293525
                ],
                [
                    90.0547275,
                    56.229734
                ],
                [
                    90.0561689,
                    56.2288183
                ],
                [
                    90.0596237,
                    56.2300519
                ],
                [
                    90.0607677,
                    56.2309549
                ],
                [
                    90.0618659,
                    56.2312601
                ],
                [
                    90.0640394,
                    56.2308404
                ],
                [
                    90.0648631,
                    56.230993
                ],
                [
                    90.0656868,
                    56.2308023
                ],
                [
                    90.0655723,
                    56.2310312
                ],
                [
                    90.0636734,
                    56.2314636
                ],
                [
                    90.063559,
                    56.2319977
                ],
                [
                    90.0645198,
                    56.232926
                ],
                [
                    90.0668765,
                    56.2339052
                ],
                [
                    90.0663274,
                    56.2342994
                ],
                [
                    90.0685238,
                    56.2351768
                ],
                [
                    90.0699195,
                    56.2344902
                ],
                [
                    90.0714524,
                    56.2360924
                ],
                [
                    90.0730311,
                    56.2362704
                ],
                [
                    90.0737632,
                    56.2359398
                ],
                [
                    90.0738776,
                    56.2351896
                ],
                [
                    90.0747241,
                    56.2332312
                ],
                [
                    90.0746784,
                    56.2320994
                ],
                [
                    90.0736946,
                    56.2309294
                ],
                [
                    90.0721616,
                    56.22892
                ],
                [
                    90.0697135,
                    56.2284495
                ],
                [
                    90.0644513,
                    56.2280298
                ],
                [
                    90.0598068,
                    56.2272666
                ],
                [
                    90.0545445,
                    56.2253079
                ],
                [
                    90.053286,
                    56.2248246
                ],
                [
                    90.0527828,
                    56.2233618
                ],
                [
                    90.0502889,
                    56.2238579
                ],
                [
                    90.0475892,
                    56.2238579
                ],
                [
                    90.0477264,
                    56.2248373
                ],
                [
                    90.0448816,
                    56.2246976
                ],
                [
                    90.0446985,
                    56.2254735
                ],
                [
                    90.04177,
                    56.2244686
                ],
                [
                    90.0426851,
                    56.2231076
                ],
                [
                    90.0404658,
                    56.2227769
                ],
                [
                    90.0397566,
                    56.224405
                ]
            ],
            "longitude": 90.058777,
            "latitude": 56.228275
        },
        "257": {
            "name": "Изыкчуль",
            "population": 275,
            "type": "village",
            "poly": [
                [
                    90.0500534,
                    55.4503887
                ],
                [
                    90.0503188,
                    55.4509577
                ],
                [
                    90.0506362,
                    55.4514978
                ],
                [
                    90.0509074,
                    55.4523128
                ],
                [
                    90.051046,
                    55.4530984
                ],
                [
                    90.0510922,
                    55.4534716
                ],
                [
                    90.0625608,
                    55.4542415
                ],
                [
                    90.0633874,
                    55.4538173
                ],
                [
                    90.0644587,
                    55.4533669
                ],
                [
                    90.0655253,
                    55.4531102
                ],
                [
                    90.0669891,
                    55.4526965
                ],
                [
                    90.0688593,
                    55.4520261
                ],
                [
                    90.0697274,
                    55.451615
                ],
                [
                    90.0701014,
                    55.4513322
                ],
                [
                    90.07042,
                    55.4510075
                ],
                [
                    90.070554,
                    55.450612
                ],
                [
                    90.070614,
                    55.4504104
                ],
                [
                    90.0706048,
                    55.4493943
                ],
                [
                    90.0709095,
                    55.4494022
                ],
                [
                    90.0709237,
                    55.4492679
                ],
                [
                    90.0709418,
                    55.4492057
                ],
                [
                    90.0713251,
                    55.4492398
                ],
                [
                    90.0703923,
                    55.4476789
                ],
                [
                    90.0698798,
                    55.4472258
                ],
                [
                    90.0697135,
                    55.4467466
                ],
                [
                    90.0697135,
                    55.4464009
                ],
                [
                    90.0698613,
                    55.4456413
                ],
                [
                    90.0696258,
                    55.4453925
                ],
                [
                    90.069298,
                    55.4452825
                ],
                [
                    90.0682267,
                    55.4453035
                ],
                [
                    90.0669476,
                    55.4449316
                ],
                [
                    90.0665874,
                    55.4446382
                ],
                [
                    90.0648927,
                    55.4446408
                ],
                [
                    90.0644032,
                    55.4447168
                ],
                [
                    90.0634197,
                    55.4447508
                ],
                [
                    90.0629441,
                    55.4455025
                ],
                [
                    90.0621821,
                    55.4457251
                ],
                [
                    90.0617804,
                    55.4459687
                ],
                [
                    90.0617158,
                    55.4461259
                ],
                [
                    90.0614849,
                    55.446139
                ],
                [
                    90.0613233,
                    55.4461861
                ],
                [
                    90.0611616,
                    55.4458561
                ],
                [
                    90.0591668,
                    55.4462778
                ],
                [
                    90.0588898,
                    55.4462044
                ],
                [
                    90.0582848,
                    55.4461809
                ],
                [
                    90.0561884,
                    55.4461547
                ],
                [
                    90.0552371,
                    55.4468985
                ],
                [
                    90.0547708,
                    55.4473332
                ],
                [
                    90.0544106,
                    55.4475794
                ],
                [
                    90.0528499,
                    55.4481268
                ],
                [
                    90.0521018,
                    55.4484096
                ],
                [
                    90.0513814,
                    55.4486375
                ],
                [
                    90.0520741,
                    55.4496352
                ],
                [
                    90.0520042,
                    55.4496515
                ],
                [
                    90.0504746,
                    55.4502015
                ],
                [
                    90.0505307,
                    55.4502249
                ],
                [
                    90.0500534,
                    55.4503887
                ]
            ],
            "longitude": 90.062454,
            "latitude": 55.448582
        },
        "258": {
            "name": "Алтат",
            "population": 265,
            "type": "village",
            "poly": [
                [
                    90.0472237,
                    56.0634798
                ],
                [
                    90.0500613,
                    56.0654441
                ],
                [
                    90.0559635,
                    56.0648738
                ],
                [
                    90.0614116,
                    56.0665846
                ],
                [
                    90.0709461,
                    56.0667747
                ],
                [
                    90.0800265,
                    56.0648738
                ],
                [
                    90.0878582,
                    56.0623392
                ],
                [
                    90.0791215,
                    56.0593428
                ],
                [
                    90.0719675,
                    56.0568891
                ],
                [
                    90.0683355,
                    56.058727
                ],
                [
                    90.0548285,
                    56.0525792
                ],
                [
                    90.0514233,
                    56.0535299
                ],
                [
                    90.0539204,
                    56.0568257
                ],
                [
                    90.0474507,
                    56.0591072
                ],
                [
                    90.0472237,
                    56.0634798
                ]
            ],
            "longitude": 90.064133,
            "latitude": 56.063797
        },
        "259": {
            "name": "Глядень",
            "population": 1138,
            "type": "village",
            "poly": [
                [
                    90.1226609,
                    55.7730231
                ],
                [
                    90.1242409,
                    55.7736841
                ],
                [
                    90.1238491,
                    55.7738457
                ],
                [
                    90.1230004,
                    55.7744626
                ],
                [
                    90.1235488,
                    55.7747637
                ],
                [
                    90.1241886,
                    55.7754908
                ],
                [
                    90.124489,
                    55.7756671
                ],
                [
                    90.1238883,
                    55.7759388
                ],
                [
                    90.1239144,
                    55.7761885
                ],
                [
                    90.1245151,
                    55.7764456
                ],
                [
                    90.1253116,
                    55.7763795
                ],
                [
                    90.1264999,
                    55.7769229
                ],
                [
                    90.1269308,
                    55.7769303
                ],
                [
                    90.1277534,
                    55.7762913
                ],
                [
                    90.1282627,
                    55.7764235
                ],
                [
                    90.1289287,
                    55.7770331
                ],
                [
                    90.1295554,
                    55.7777161
                ],
                [
                    90.1298688,
                    55.7785606
                ],
                [
                    90.1309004,
                    55.7799192
                ],
                [
                    90.1319189,
                    55.7811749
                ],
                [
                    90.1316708,
                    55.7816375
                ],
                [
                    90.1377427,
                    55.7819018
                ],
                [
                    90.1473134,
                    55.7823449
                ],
                [
                    90.1499877,
                    55.7822979
                ],
                [
                    90.1499793,
                    55.7823966
                ],
                [
                    90.1517678,
                    55.7823778
                ],
                [
                    90.1528056,
                    55.7823527
                ],
                [
                    90.1532654,
                    55.7822853
                ],
                [
                    90.1545613,
                    55.7810643
                ],
                [
                    90.1555187,
                    55.7799274
                ],
                [
                    90.1576634,
                    55.7796176
                ],
                [
                    90.1630708,
                    55.7791333
                ],
                [
                    90.1640603,
                    55.7773887
                ],
                [
                    90.1639764,
                    55.7773719
                ],
                [
                    90.1584978,
                    55.7762787
                ],
                [
                    90.1586101,
                    55.7761704
                ],
                [
                    90.1569361,
                    55.7758064
                ],
                [
                    90.1539195,
                    55.7747625
                ],
                [
                    90.1540773,
                    55.7731471
                ],
                [
                    90.1540438,
                    55.7729854
                ],
                [
                    90.1559109,
                    55.7723042
                ],
                [
                    90.1558168,
                    55.771818
                ],
                [
                    90.1557869,
                    55.7697383
                ],
                [
                    90.1539617,
                    55.7692531
                ],
                [
                    90.1526112,
                    55.7686739
                ],
                [
                    90.1521432,
                    55.7685461
                ],
                [
                    90.1518423,
                    55.7681624
                ],
                [
                    90.1504517,
                    55.7694825
                ],
                [
                    90.1435008,
                    55.7669534
                ],
                [
                    90.1357036,
                    55.7643629
                ],
                [
                    90.1357752,
                    55.7672439
                ],
                [
                    90.1354279,
                    55.7671697
                ],
                [
                    90.1345838,
                    55.7668453
                ],
                [
                    90.1337815,
                    55.7665115
                ],
                [
                    90.133138,
                    55.766488
                ],
                [
                    90.1328539,
                    55.7665538
                ],
                [
                    90.1326199,
                    55.7667324
                ],
                [
                    90.132553,
                    55.766991
                ],
                [
                    90.132294,
                    55.7673201
                ],
                [
                    90.132319,
                    55.7679642
                ],
                [
                    90.1326951,
                    55.7684437
                ],
                [
                    90.133581,
                    55.768895
                ],
                [
                    90.1335893,
                    55.769901
                ],
                [
                    90.1344835,
                    55.7700374
                ],
                [
                    90.1347426,
                    55.7716075
                ],
                [
                    90.1336979,
                    55.7714523
                ],
                [
                    90.1334321,
                    55.7716149
                ],
                [
                    90.1328438,
                    55.7722317
                ],
                [
                    90.1271528,
                    55.7700924
                ],
                [
                    90.1262387,
                    55.7705332
                ],
                [
                    90.1226609,
                    55.7730231
                ]
            ],
            "longitude": 90.140793,
            "latitude": 55.775406
        },
        "260": {
            "name": "Антропово",
            "population": 424,
            "type": "village",
            "poly": [
                [
                    90.1381086,
                    55.8170483
                ],
                [
                    90.1383569,
                    55.818113
                ],
                [
                    90.1394351,
                    55.8202458
                ],
                [
                    90.1408007,
                    55.8221289
                ],
                [
                    90.1408138,
                    55.8225474
                ],
                [
                    90.1403695,
                    55.8229364
                ],
                [
                    90.1404,
                    55.8229866
                ],
                [
                    90.1406635,
                    55.8234723
                ],
                [
                    90.1416175,
                    55.8242138
                ],
                [
                    90.1439306,
                    55.8269702
                ],
                [
                    90.1448585,
                    55.8273483
                ],
                [
                    90.1451377,
                    55.8276821
                ],
                [
                    90.1463756,
                    55.8275459
                ],
                [
                    90.1482006,
                    55.8278398
                ],
                [
                    90.1489918,
                    55.827933
                ],
                [
                    90.1496172,
                    55.8277538
                ],
                [
                    90.1500383,
                    55.8271087
                ],
                [
                    90.1510721,
                    55.8275531
                ],
                [
                    90.1511869,
                    55.827976
                ],
                [
                    90.151825,
                    55.8281481
                ],
                [
                    90.1520675,
                    55.8280549
                ],
                [
                    90.1520292,
                    55.8276176
                ],
                [
                    90.151557,
                    55.8269008
                ],
                [
                    90.151506,
                    55.8262484
                ],
                [
                    90.1513145,
                    55.8257036
                ],
                [
                    90.1515443,
                    55.8248577
                ],
                [
                    90.1517102,
                    55.824148
                ],
                [
                    90.1520675,
                    55.8235888
                ],
                [
                    90.1523993,
                    55.8231372
                ],
                [
                    90.1532544,
                    55.8226855
                ],
                [
                    90.1536117,
                    55.8226855
                ],
                [
                    90.1538287,
                    55.8223987
                ],
                [
                    90.1536245,
                    55.8219614
                ],
                [
                    90.1530885,
                    55.8210222
                ],
                [
                    90.1527056,
                    55.8205132
                ],
                [
                    90.1525908,
                    55.8197747
                ],
                [
                    90.152527,
                    55.8188641
                ],
                [
                    90.1524631,
                    55.8184196
                ],
                [
                    90.1529226,
                    55.8180324
                ],
                [
                    90.1536245,
                    55.8175664
                ],
                [
                    90.1540456,
                    55.8169999
                ],
                [
                    90.1541095,
                    55.8159674
                ],
                [
                    90.1542371,
                    55.8155157
                ],
                [
                    90.1541733,
                    55.814942
                ],
                [
                    90.1535862,
                    55.8143684
                ],
                [
                    90.1531408,
                    55.8138974
                ],
                [
                    90.1532796,
                    55.8132228
                ],
                [
                    90.153541,
                    55.812796
                ],
                [
                    90.1537942,
                    55.812516
                ],
                [
                    90.1539739,
                    55.812282
                ],
                [
                    90.1542516,
                    55.8121672
                ],
                [
                    90.1558525,
                    55.8121121
                ],
                [
                    90.1563752,
                    55.8121305
                ],
                [
                    90.1565304,
                    55.8122406
                ],
                [
                    90.1567428,
                    55.8125298
                ],
                [
                    90.1576739,
                    55.8128832
                ],
                [
                    90.1581476,
                    55.8128924
                ],
                [
                    90.1582048,
                    55.8120662
                ],
                [
                    90.1581231,
                    55.8118735
                ],
                [
                    90.1576331,
                    55.8116302
                ],
                [
                    90.1574044,
                    55.8113962
                ],
                [
                    90.1574779,
                    55.8110106
                ],
                [
                    90.1574534,
                    55.81057
                ],
                [
                    90.1570858,
                    55.8101845
                ],
                [
                    90.1566774,
                    55.8099504
                ],
                [
                    90.1560157,
                    55.8098455
                ],
                [
                    90.1556759,
                    55.8094343
                ],
                [
                    90.1555583,
                    55.8090561
                ],
                [
                    90.155114,
                    55.8083658
                ],
                [
                    90.1551467,
                    55.8073817
                ],
                [
                    90.1553231,
                    55.8070769
                ],
                [
                    90.1559896,
                    55.8067427
                ],
                [
                    90.1570089,
                    55.8056447
                ],
                [
                    90.1552839,
                    55.8056668
                ],
                [
                    90.1550617,
                    55.8057732
                ],
                [
                    90.1548788,
                    55.8056998
                ],
                [
                    90.1547546,
                    55.8055492
                ],
                [
                    90.1543495,
                    55.805362
                ],
                [
                    90.1539117,
                    55.8053289
                ],
                [
                    90.1533824,
                    55.8054391
                ],
                [
                    90.1524742,
                    55.8060009
                ],
                [
                    90.1515463,
                    55.8066252
                ],
                [
                    90.1510105,
                    55.8067611
                ],
                [
                    90.1503506,
                    55.8068786
                ],
                [
                    90.1489326,
                    55.8074551
                ],
                [
                    90.1448487,
                    55.8085567
                ],
                [
                    90.1445127,
                    55.8083162
                ],
                [
                    90.1441369,
                    55.8082887
                ],
                [
                    90.1442023,
                    55.8064068
                ],
                [
                    90.1436959,
                    55.8037168
                ],
                [
                    90.142438,
                    55.8033358
                ],
                [
                    90.1425361,
                    55.8065582
                ],
                [
                    90.1438184,
                    55.8082336
                ],
                [
                    90.1432385,
                    55.8081418
                ],
                [
                    90.1384225,
                    55.8095984
                ],
                [
                    90.138285,
                    55.8096466
                ],
                [
                    90.1386967,
                    55.8107077
                ],
                [
                    90.1387816,
                    55.8117358
                ],
                [
                    90.1385529,
                    55.8133917
                ],
                [
                    90.1381478,
                    55.8156166
                ],
                [
                    90.1381086,
                    55.8170483
                ]
            ],
            "longitude": 90.146675,
            "latitude": 55.815945
        },
        "261": {
            "name": "Новый Городок",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 90.1794946,
            "latitude": 59.830962
        },
        "262": {
            "name": "Сохновка",
            "population": 440,
            "type": "village",
            "poly": [
                [
                    90.1661504,
                    55.959991
                ],
                [
                    90.1674873,
                    55.9603061
                ],
                [
                    90.1662794,
                    55.9621637
                ],
                [
                    90.1680971,
                    55.9629514
                ],
                [
                    90.1683433,
                    55.9634896
                ],
                [
                    90.1689409,
                    55.9634295
                ],
                [
                    90.1719324,
                    55.9652925
                ],
                [
                    90.1754598,
                    55.968196
                ],
                [
                    90.1837842,
                    55.9665083
                ],
                [
                    90.1863758,
                    55.9664755
                ],
                [
                    90.1881583,
                    55.9665608
                ],
                [
                    90.1883928,
                    55.9662786
                ],
                [
                    90.1903629,
                    55.9656616
                ],
                [
                    90.1907851,
                    55.9658257
                ],
                [
                    90.192462,
                    55.9652482
                ],
                [
                    90.1926731,
                    55.965025
                ],
                [
                    90.19306,
                    55.9650053
                ],
                [
                    90.1933884,
                    55.9652678
                ],
                [
                    90.1943148,
                    55.964815
                ],
                [
                    90.1956516,
                    55.9646378
                ],
                [
                    90.1975748,
                    55.9634038
                ],
                [
                    90.197868,
                    55.9625243
                ],
                [
                    90.1977155,
                    55.96152
                ],
                [
                    90.1973637,
                    55.9605288
                ],
                [
                    90.1931656,
                    55.9597673
                ],
                [
                    90.1933951,
                    55.9584387
                ],
                [
                    90.1947085,
                    55.9585765
                ],
                [
                    90.1954238,
                    55.9569288
                ],
                [
                    90.1957053,
                    55.9569288
                ],
                [
                    90.1960454,
                    55.9566071
                ],
                [
                    90.1959281,
                    55.9561147
                ],
                [
                    90.1963033,
                    55.9549265
                ],
                [
                    90.1961743,
                    55.954677
                ],
                [
                    90.1957874,
                    55.9546639
                ],
                [
                    90.1926681,
                    55.9541189
                ],
                [
                    90.1923397,
                    55.9539482
                ],
                [
                    90.1905573,
                    55.9539023
                ],
                [
                    90.189924,
                    55.9539679
                ],
                [
                    90.1896543,
                    55.954178
                ],
                [
                    90.1893963,
                    55.9559375
                ],
                [
                    90.18915,
                    55.9564364
                ],
                [
                    90.1886458,
                    55.9566728
                ],
                [
                    90.188552,
                    55.9568369
                ],
                [
                    90.1890914,
                    55.9572045
                ],
                [
                    90.188917,
                    55.9577123
                ],
                [
                    90.1859624,
                    55.9575072
                ],
                [
                    90.1849317,
                    55.9577636
                ],
                [
                    90.1844049,
                    55.9576098
                ],
                [
                    90.1823894,
                    55.9576226
                ],
                [
                    90.1813129,
                    55.9577123
                ],
                [
                    90.1795035,
                    55.9572123
                ],
                [
                    90.1782438,
                    55.9572636
                ],
                [
                    90.1759306,
                    55.9570071
                ],
                [
                    90.1752893,
                    55.9570584
                ],
                [
                    90.1721545,
                    55.9567941
                ],
                [
                    90.1724242,
                    55.9554614
                ],
                [
                    90.1717793,
                    55.9553957
                ],
                [
                    90.1701258,
                    55.9558028
                ],
                [
                    90.1697388,
                    55.9558422
                ],
                [
                    90.1691525,
                    55.9562754
                ],
                [
                    90.168402,
                    55.9565709
                ],
                [
                    90.1677453,
                    55.9580151
                ],
                [
                    90.1664084,
                    55.9594396
                ],
                [
                    90.1661504,
                    55.959991
                ]
            ],
            "longitude": 90.182671,
            "latitude": 55.961445
        },
        "263": {
            "name": "Кирчиж",
            "population": 153,
            "type": "village",
            "poly": [
                [
                    90.1932346,
                    57.1339482
                ],
                [
                    90.1942666,
                    57.1345082
                ],
                [
                    90.1947169,
                    57.1346405
                ],
                [
                    90.1949295,
                    57.1345489
                ],
                [
                    90.195924,
                    57.134963
                ],
                [
                    90.1960741,
                    57.1353227
                ],
                [
                    90.1964118,
                    57.1354619
                ],
                [
                    90.1982193,
                    57.1358488
                ],
                [
                    90.1986133,
                    57.1361508
                ],
                [
                    90.1977752,
                    57.136911
                ],
                [
                    90.1991324,
                    57.137264
                ],
                [
                    90.1993701,
                    57.1373794
                ],
                [
                    90.1998829,
                    57.1377289
                ],
                [
                    90.2000893,
                    57.1380038
                ],
                [
                    90.1995388,
                    57.1387097
                ],
                [
                    90.1993263,
                    57.1390762
                ],
                [
                    90.1993138,
                    57.1393205
                ],
                [
                    90.199564,
                    57.1399076
                ],
                [
                    90.1997704,
                    57.1401995
                ],
                [
                    90.2004583,
                    57.1408714
                ],
                [
                    90.2006959,
                    57.1412955
                ],
                [
                    90.2010838,
                    57.1417808
                ],
                [
                    90.2028866,
                    57.1415705
                ],
                [
                    90.2042359,
                    57.1413973
                ],
                [
                    90.2063248,
                    57.1412989
                ],
                [
                    90.206894,
                    57.1419742
                ],
                [
                    90.2070128,
                    57.1420251
                ],
                [
                    90.2074444,
                    57.1419131
                ],
                [
                    90.2069002,
                    57.1410546
                ],
                [
                    90.2080135,
                    57.1406983
                ],
                [
                    90.2083762,
                    57.1406508
                ],
                [
                    90.2087015,
                    57.1401961
                ],
                [
                    90.2094207,
                    57.1403352
                ],
                [
                    90.2107654,
                    57.1404709
                ],
                [
                    90.2112344,
                    57.1400264
                ],
                [
                    90.21019,
                    57.1396735
                ],
                [
                    90.211641,
                    57.1386079
                ],
                [
                    90.2112034,
                    57.1383941
                ],
                [
                    90.2099705,
                    57.1381508
                ],
                [
                    90.2093942,
                    57.138335
                ],
                [
                    90.2082478,
                    57.1381178
                ],
                [
                    90.2083246,
                    57.1376209
                ],
                [
                    90.2081965,
                    57.1374037
                ],
                [
                    90.2077963,
                    57.1372316
                ],
                [
                    90.2073415,
                    57.1372091
                ],
                [
                    90.2079891,
                    57.1366079
                ],
                [
                    90.206376,
                    57.1350274
                ],
                [
                    90.2035541,
                    57.1338675
                ],
                [
                    90.2029537,
                    57.1333049
                ],
                [
                    90.2033059,
                    57.1330312
                ],
                [
                    90.2049751,
                    57.1321666
                ],
                [
                    90.2053674,
                    57.1317734
                ],
                [
                    90.2040945,
                    57.1313238
                ],
                [
                    90.2041625,
                    57.1310066
                ],
                [
                    90.2034821,
                    57.1303983
                ],
                [
                    90.2023841,
                    57.1299586
                ],
                [
                    90.2022732,
                    57.1299182
                ],
                [
                    90.2013714,
                    57.1304725
                ],
                [
                    90.2009962,
                    57.1307305
                ],
                [
                    90.2007022,
                    57.1308153
                ],
                [
                    90.2002581,
                    57.1308764
                ],
                [
                    90.1996702,
                    57.130907
                ],
                [
                    90.1994014,
                    57.13052
                ],
                [
                    90.1975814,
                    57.1304725
                ],
                [
                    90.1973187,
                    57.1305132
                ],
                [
                    90.1971561,
                    57.1306626
                ],
                [
                    90.1955861,
                    57.1315858
                ],
                [
                    90.1961867,
                    57.1319728
                ],
                [
                    90.1954174,
                    57.132414
                ],
                [
                    90.1949733,
                    57.1327025
                ],
                [
                    90.1948608,
                    57.1328179
                ],
                [
                    90.1947607,
                    57.133008
                ],
                [
                    90.1948545,
                    57.1331098
                ],
                [
                    90.1932346,
                    57.1339482
                ]
            ],
            "longitude": 90.20295,
            "latitude": 57.136925
        },
        "264": {
            "name": "Верхний Ададым",
            "population": 340,
            "type": "village",
            "poly": [
                [
                    90.1828719,
                    55.9125676
                ],
                [
                    90.1828819,
                    55.9127298
                ],
                [
                    90.1833808,
                    55.912864
                ],
                [
                    90.1833109,
                    55.9130765
                ],
                [
                    90.1829318,
                    55.9133282
                ],
                [
                    90.1830216,
                    55.9134904
                ],
                [
                    90.1833209,
                    55.9135016
                ],
                [
                    90.1842389,
                    55.913317
                ],
                [
                    90.1852967,
                    55.9133338
                ],
                [
                    90.1858754,
                    55.9133729
                ],
                [
                    90.1857956,
                    55.9138203
                ],
                [
                    90.1859951,
                    55.9139657
                ],
                [
                    90.1858754,
                    55.9141279
                ],
                [
                    90.185606,
                    55.9142286
                ],
                [
                    90.1856359,
                    55.9143684
                ],
                [
                    90.1859353,
                    55.9144075
                ],
                [
                    90.1867435,
                    55.9142397
                ],
                [
                    90.1891783,
                    55.9141447
                ],
                [
                    90.1911041,
                    55.913893
                ],
                [
                    90.1942972,
                    55.913043
                ],
                [
                    90.1945567,
                    55.9128808
                ],
                [
                    90.1956543,
                    55.9130206
                ],
                [
                    90.1960933,
                    55.9127689
                ],
                [
                    90.1969216,
                    55.912439
                ],
                [
                    90.19765,
                    55.912165
                ],
                [
                    90.1985057,
                    55.9118929
                ],
                [
                    90.1989547,
                    55.9118579
                ],
                [
                    90.1992291,
                    55.9117461
                ],
                [
                    90.1994162,
                    55.9113965
                ],
                [
                    90.1998902,
                    55.9111658
                ],
                [
                    90.1994412,
                    55.9111868
                ],
                [
                    90.1999152,
                    55.9108303
                ],
                [
                    90.2001022,
                    55.9107114
                ],
                [
                    90.2006635,
                    55.9110819
                ],
                [
                    90.2019607,
                    55.9105436
                ],
                [
                    90.2025719,
                    55.9101312
                ],
                [
                    90.2028962,
                    55.9101172
                ],
                [
                    90.2041061,
                    55.9095928
                ],
                [
                    90.2044928,
                    55.9093272
                ],
                [
                    90.2050665,
                    55.9092083
                ],
                [
                    90.2069874,
                    55.9098445
                ],
                [
                    90.2074364,
                    55.9105226
                ],
                [
                    90.2082267,
                    55.911996
                ],
                [
                    90.2100707,
                    55.9111683
                ],
                [
                    90.2113001,
                    55.9108238
                ],
                [
                    90.2131601,
                    55.9106583
                ],
                [
                    90.2151238,
                    55.9107075
                ],
                [
                    90.2276511,
                    55.9117701
                ],
                [
                    90.2347229,
                    55.9131019
                ],
                [
                    90.2344136,
                    55.9126098
                ],
                [
                    90.2344236,
                    55.9122575
                ],
                [
                    90.2346431,
                    55.9117262
                ],
                [
                    90.2344635,
                    55.9113403
                ],
                [
                    90.2328569,
                    55.909668
                ],
                [
                    90.2316965,
                    55.909005
                ],
                [
                    90.2324648,
                    55.9071593
                ],
                [
                    90.2301398,
                    55.906365
                ],
                [
                    90.2289624,
                    55.906242
                ],
                [
                    90.2237436,
                    55.9060015
                ],
                [
                    90.2234143,
                    55.9054925
                ],
                [
                    90.2233645,
                    55.9051345
                ],
                [
                    90.2229553,
                    55.9042731
                ],
                [
                    90.2224265,
                    55.9042115
                ],
                [
                    90.2211792,
                    55.9042787
                ],
                [
                    90.2203709,
                    55.9042675
                ],
                [
                    90.2185449,
                    55.9039766
                ],
                [
                    90.2179462,
                    55.9039207
                ],
                [
                    90.2171579,
                    55.9036633
                ],
                [
                    90.2164095,
                    55.9036689
                ],
                [
                    90.2158706,
                    55.9035347
                ],
                [
                    90.2155413,
                    55.9034452
                ],
                [
                    90.2149726,
                    55.9037417
                ],
                [
                    90.2142342,
                    55.9036242
                ],
                [
                    90.2133561,
                    55.9035682
                ],
                [
                    90.2131166,
                    55.9033277
                ],
                [
                    90.212438,
                    55.9032606
                ],
                [
                    90.212438,
                    55.9033557
                ],
                [
                    90.2114003,
                    55.903613
                ],
                [
                    90.2113304,
                    55.9037584
                ],
                [
                    90.2111009,
                    55.9039207
                ],
                [
                    90.2106619,
                    55.9038423
                ],
                [
                    90.2104923,
                    55.9039374
                ],
                [
                    90.2100133,
                    55.9032438
                ],
                [
                    90.2070297,
                    55.9029361
                ],
                [
                    90.2059421,
                    55.9027012
                ],
                [
                    90.2062913,
                    55.9021026
                ],
                [
                    90.2057026,
                    55.9019516
                ],
                [
                    90.2053533,
                    55.9019852
                ],
                [
                    90.2053234,
                    55.9022537
                ],
                [
                    90.2051438,
                    55.9024271
                ],
                [
                    90.2045351,
                    55.9025446
                ],
                [
                    90.2039065,
                    55.9024607
                ],
                [
                    90.2035273,
                    55.9022984
                ],
                [
                    90.2029785,
                    55.9023767
                ],
                [
                    90.202739,
                    55.902718
                ],
                [
                    90.2036271,
                    55.9028634
                ],
                [
                    90.2026392,
                    55.9032382
                ],
                [
                    90.2010526,
                    55.9034955
                ],
                [
                    90.198588,
                    55.9046366
                ],
                [
                    90.1970912,
                    55.9037752
                ],
                [
                    90.1964426,
                    55.9039766
                ],
                [
                    90.1956942,
                    55.9039766
                ],
                [
                    90.1947363,
                    55.9033725
                ],
                [
                    90.1927306,
                    55.9042227
                ],
                [
                    90.1940877,
                    55.9051401
                ],
                [
                    90.1933692,
                    55.9054197
                ],
                [
                    90.1923414,
                    55.9059511
                ],
                [
                    90.1913436,
                    55.9063147
                ],
                [
                    90.1908347,
                    55.9063706
                ],
                [
                    90.1924013,
                    55.9073998
                ],
                [
                    90.1889887,
                    55.9089267
                ],
                [
                    90.1843387,
                    55.9113261
                ],
                [
                    90.1839496,
                    55.911203
                ],
                [
                    90.1835604,
                    55.9111359
                ],
                [
                    90.1832112,
                    55.9111918
                ],
                [
                    90.183291,
                    55.9114603
                ],
                [
                    90.1838697,
                    55.9118182
                ],
                [
                    90.1838099,
                    55.9120531
                ],
                [
                    90.1835804,
                    55.912165
                ],
                [
                    90.1830216,
                    55.9124054
                ],
                [
                    90.1828719,
                    55.9125676
                ]
            ],
            "longitude": 90.212006,
            "latitude": 55.907665
        },
        "265": {
            "name": "Ярцево",
            "population": 1610,
            "type": "village",
            "poly": [
                [
                    90.1785205,
                    60.2652685
                ],
                [
                    90.1812294,
                    60.2658013
                ],
                [
                    90.1866939,
                    60.2629287
                ],
                [
                    90.1924854,
                    60.2605192
                ],
                [
                    90.1941201,
                    60.2594303
                ],
                [
                    90.2006122,
                    60.2563486
                ],
                [
                    90.2084587,
                    60.2535447
                ],
                [
                    90.2142969,
                    60.2516676
                ],
                [
                    90.2197614,
                    60.2501612
                ],
                [
                    90.2275613,
                    60.2476581
                ],
                [
                    90.2311109,
                    60.2464529
                ],
                [
                    90.2349407,
                    60.2445522
                ],
                [
                    90.2378832,
                    60.243115
                ],
                [
                    90.2389574,
                    60.2417473
                ],
                [
                    90.2373334,
                    60.2400954
                ],
                [
                    90.2352635,
                    60.2396761
                ],
                [
                    90.2338095,
                    60.2391634
                ],
                [
                    90.2332431,
                    60.2386905
                ],
                [
                    90.2346513,
                    60.2380523
                ],
                [
                    90.2366409,
                    60.2377104
                ],
                [
                    90.2423219,
                    60.2363874
                ],
                [
                    90.2467418,
                    60.2353457
                ],
                [
                    90.2503536,
                    60.2346065
                ],
                [
                    90.2481117,
                    60.2331225
                ],
                [
                    90.2438615,
                    60.2342819
                ],
                [
                    90.2381167,
                    60.2353716
                ],
                [
                    90.2324186,
                    60.2365773
                ],
                [
                    90.2291492,
                    60.2384321
                ],
                [
                    90.220789,
                    60.2402404
                ],
                [
                    90.2135496,
                    60.2401709
                ],
                [
                    90.2066839,
                    60.2400318
                ],
                [
                    90.2058432,
                    60.2424427
                ],
                [
                    90.2118682,
                    60.2449694
                ],
                [
                    90.2045354,
                    60.2467542
                ],
                [
                    90.2115413,
                    60.2507638
                ],
                [
                    90.2070575,
                    60.2521311
                ],
                [
                    90.2024804,
                    60.2534984
                ],
                [
                    90.1950075,
                    60.2560937
                ],
                [
                    90.1922519,
                    60.2570901
                ],
                [
                    90.1867406,
                    60.2599632
                ],
                [
                    90.1846389,
                    60.2611216
                ],
                [
                    90.1817899,
                    60.2631835
                ],
                [
                    90.1785205,
                    60.2652685
                ]
            ],
            "longitude": 90.222351,
            "latitude": 60.24379
        },
        "266": {
            "name": "Бычки",
            "population": 190,
            "type": "village",
            "poly": [
                [
                    90.2389735,
                    56.5564739
                ],
                [
                    90.2394125,
                    56.5565133
                ],
                [
                    90.2397702,
                    56.5565283
                ],
                [
                    90.2398516,
                    56.5564753
                ],
                [
                    90.2408456,
                    56.5565922
                ],
                [
                    90.2408628,
                    56.5567634
                ],
                [
                    90.2412476,
                    56.556864
                ],
                [
                    90.2413833,
                    56.5570027
                ],
                [
                    90.2415929,
                    56.5570081
                ],
                [
                    90.2417039,
                    56.5569211
                ],
                [
                    90.2419283,
                    56.5569673
                ],
                [
                    90.242165,
                    56.5569265
                ],
                [
                    90.2425252,
                    56.5570462
                ],
                [
                    90.2424685,
                    56.5572514
                ],
                [
                    90.2430062,
                    56.5574186
                ],
                [
                    90.2434132,
                    56.5575967
                ],
                [
                    90.2436968,
                    56.5576375
                ],
                [
                    90.2439238,
                    56.5577108
                ],
                [
                    90.2441242,
                    56.5577214
                ],
                [
                    90.2447678,
                    56.5577065
                ],
                [
                    90.2450915,
                    56.5576513
                ],
                [
                    90.2453806,
                    56.5577108
                ],
                [
                    90.2454499,
                    56.5578339
                ],
                [
                    90.2462361,
                    56.5580676
                ],
                [
                    90.2468104,
                    56.5583288
                ],
                [
                    90.2471765,
                    56.5583776
                ],
                [
                    90.2473152,
                    56.5585136
                ],
                [
                    90.2477854,
                    56.5585518
                ],
                [
                    90.2479472,
                    56.5585178
                ],
                [
                    90.2495081,
                    56.5587854
                ],
                [
                    90.2503482,
                    56.5589681
                ],
                [
                    90.2508839,
                    56.5591125
                ],
                [
                    90.2508761,
                    56.5592229
                ],
                [
                    90.2510072,
                    56.5593376
                ],
                [
                    90.2522443,
                    56.5595606
                ],
                [
                    90.2530922,
                    56.559739
                ],
                [
                    90.2533118,
                    56.5595733
                ],
                [
                    90.253863,
                    56.5596477
                ],
                [
                    90.2541789,
                    56.5597369
                ],
                [
                    90.2542522,
                    56.5598452
                ],
                [
                    90.2549382,
                    56.5600745
                ],
                [
                    90.255312,
                    56.5600639
                ],
                [
                    90.2556974,
                    56.5604016
                ],
                [
                    90.2562601,
                    56.5605014
                ],
                [
                    90.2562985,
                    56.5607584
                ],
                [
                    90.2567186,
                    56.5610748
                ],
                [
                    90.2562832,
                    56.5612086
                ],
                [
                    90.2562485,
                    56.5612872
                ],
                [
                    90.2562716,
                    56.5614379
                ],
                [
                    90.256368,
                    56.5615271
                ],
                [
                    90.25663,
                    56.561542
                ],
                [
                    90.2570424,
                    56.5615696
                ],
                [
                    90.2574779,
                    56.5618372
                ],
                [
                    90.2574201,
                    56.5623469
                ],
                [
                    90.2577668,
                    56.5624615
                ],
                [
                    90.2585955,
                    56.5622173
                ],
                [
                    90.2599328,
                    56.5628268
                ],
                [
                    90.2602411,
                    56.5627482
                ],
                [
                    90.2610196,
                    56.5627206
                ],
                [
                    90.2615129,
                    56.5627673
                ],
                [
                    90.2617441,
                    56.5627121
                ],
                [
                    90.2613587,
                    56.5621451
                ],
                [
                    90.2606573,
                    56.5617544
                ],
                [
                    90.2600446,
                    56.5616673
                ],
                [
                    90.2603375,
                    56.5612277
                ],
                [
                    90.2603722,
                    56.5608221
                ],
                [
                    90.2605648,
                    56.5607095
                ],
                [
                    90.2612316,
                    56.5600809
                ],
                [
                    90.2619754,
                    56.5595818
                ],
                [
                    90.2620423,
                    56.5595209
                ],
                [
                    90.2618252,
                    56.559049
                ],
                [
                    90.2615569,
                    56.5588663
                ],
                [
                    90.2614405,
                    56.5588217
                ],
                [
                    90.2613359,
                    56.5588413
                ],
                [
                    90.2611583,
                    56.5588543
                ],
                [
                    90.2607281,
                    56.5579833
                ],
                [
                    90.260809,
                    56.557868
                ],
                [
                    90.2603414,
                    56.5576647
                ],
                [
                    90.2596784,
                    56.5573156
                ],
                [
                    90.2588536,
                    56.5578561
                ],
                [
                    90.2576775,
                    56.5573744
                ],
                [
                    90.2578789,
                    56.5572297
                ],
                [
                    90.2569791,
                    56.5569068
                ],
                [
                    90.2578118,
                    56.556002
                ],
                [
                    90.2562076,
                    56.5556562
                ],
                [
                    90.2557142,
                    56.5561249
                ],
                [
                    90.2544376,
                    56.5557889
                ],
                [
                    90.2525414,
                    56.5554224
                ],
                [
                    90.2521349,
                    56.5558389
                ],
                [
                    90.2506412,
                    56.5553821
                ],
                [
                    90.25088,
                    56.555132
                ],
                [
                    90.2494341,
                    56.5546697
                ],
                [
                    90.2491089,
                    56.5550681
                ],
                [
                    90.2486953,
                    56.5550038
                ],
                [
                    90.2479913,
                    56.5548463
                ],
                [
                    90.2483196,
                    56.5544748
                ],
                [
                    90.2483133,
                    56.5541694
                ],
                [
                    90.2484142,
                    56.554038
                ],
                [
                    90.2475525,
                    56.5538414
                ],
                [
                    90.2467979,
                    56.5536839
                ],
                [
                    90.2457655,
                    56.5532559
                ],
                [
                    90.2463717,
                    56.5528557
                ],
                [
                    90.2460007,
                    56.5526469
                ],
                [
                    90.2463259,
                    56.5523423
                ],
                [
                    90.2462644,
                    56.552291
                ],
                [
                    90.2461144,
                    56.5522666
                ],
                [
                    90.2460134,
                    56.5522153
                ],
                [
                    90.2457482,
                    56.5521153
                ],
                [
                    90.2455224,
                    56.5520135
                ],
                [
                    90.2455745,
                    56.5519473
                ],
                [
                    90.2456155,
                    56.5518055
                ],
                [
                    90.245576,
                    56.5517638
                ],
                [
                    90.2453788,
                    56.5517229
                ],
                [
                    90.2448831,
                    56.551742
                ],
                [
                    90.2448421,
                    56.5518899
                ],
                [
                    90.2446448,
                    56.5519743
                ],
                [
                    90.2442549,
                    56.55205
                ],
                [
                    90.2440355,
                    56.5520457
                ],
                [
                    90.2438839,
                    56.5519691
                ],
                [
                    90.2436613,
                    56.551936
                ],
                [
                    90.2436124,
                    56.5517846
                ],
                [
                    90.2433472,
                    56.5514383
                ],
                [
                    90.2432367,
                    56.5513914
                ],
                [
                    90.2431215,
                    56.5512078
                ],
                [
                    90.2430078,
                    56.5510781
                ],
                [
                    90.2425879,
                    56.551072
                ],
                [
                    90.2425637,
                    56.5508743
                ],
                [
                    90.2428412,
                    56.5508212
                ],
                [
                    90.2428373,
                    56.5507659
                ],
                [
                    90.2430454,
                    56.5507702
                ],
                [
                    90.2430454,
                    56.550596
                ],
                [
                    90.2429375,
                    56.5505174
                ],
                [
                    90.2420241,
                    56.5504919
                ],
                [
                    90.2416889,
                    56.5504282
                ],
                [
                    90.2415964,
                    56.5503113
                ],
                [
                    90.2415386,
                    56.5500585
                ],
                [
                    90.2412918,
                    56.5500331
                ],
                [
                    90.2409489,
                    56.5499311
                ],
                [
                    90.2401165,
                    56.5499842
                ],
                [
                    90.2397003,
                    56.550067
                ],
                [
                    90.239812,
                    56.5504494
                ],
                [
                    90.2396155,
                    56.5507043
                ],
                [
                    90.2396309,
                    56.5508318
                ],
                [
                    90.2401126,
                    56.5508254
                ],
                [
                    90.240182,
                    56.5509677
                ],
                [
                    90.2400741,
                    56.55104
                ],
                [
                    90.2404325,
                    56.551486
                ],
                [
                    90.2402976,
                    56.5515285
                ],
                [
                    90.2402013,
                    56.551879
                ],
                [
                    90.240394,
                    56.5520426
                ],
                [
                    90.2406445,
                    56.5519597
                ],
                [
                    90.2410182,
                    56.5519704
                ],
                [
                    90.2416225,
                    56.5520599
                ],
                [
                    90.2419086,
                    56.5528185
                ],
                [
                    90.2418667,
                    56.5530306
                ],
                [
                    90.2412106,
                    56.553853
                ],
                [
                    90.2410503,
                    56.553921
                ],
                [
                    90.2406926,
                    56.5539387
                ],
                [
                    90.2406976,
                    56.55397
                ],
                [
                    90.2401451,
                    56.5540325
                ],
                [
                    90.2395013,
                    56.5553375
                ],
                [
                    90.2395975,
                    56.5555196
                ],
                [
                    90.2389735,
                    56.5564739
                ]
            ],
            "longitude": 90.2511358,
            "latitude": 56.5574201
        },
        "267": {
            "name": "Предгорный",
            "population": 288,
            "type": "village",
            "poly": [
                [
                    90.2492394,
                    55.6396605
                ],
                [
                    90.2526187,
                    55.6408147
                ],
                [
                    90.2566104,
                    55.6421972
                ],
                [
                    90.2572993,
                    55.6420306
                ],
                [
                    90.2587101,
                    55.6410122
                ],
                [
                    90.2596069,
                    55.6397407
                ],
                [
                    90.2602302,
                    55.6394198
                ],
                [
                    90.2608098,
                    55.6393272
                ],
                [
                    90.261127,
                    55.6391544
                ],
                [
                    90.2617285,
                    55.638389
                ],
                [
                    90.2620565,
                    55.6380001
                ],
                [
                    90.2616738,
                    55.6376298
                ],
                [
                    90.2608208,
                    55.6373273
                ],
                [
                    90.2601755,
                    55.6372903
                ],
                [
                    90.2587538,
                    55.6374446
                ],
                [
                    90.2568947,
                    55.6375989
                ],
                [
                    90.2557245,
                    55.6375989
                ],
                [
                    90.2556261,
                    55.6378396
                ],
                [
                    90.2545653,
                    55.6375989
                ],
                [
                    90.2541716,
                    55.6377841
                ],
                [
                    90.2532748,
                    55.637568
                ],
                [
                    90.2516891,
                    55.6372532
                ],
                [
                    90.2505846,
                    55.637531
                ],
                [
                    90.2500378,
                    55.638068
                ],
                [
                    90.2493488,
                    55.6391544
                ],
                [
                    90.2492394,
                    55.6396605
                ]
            ],
            "longitude": 90.255341,
            "latitude": 55.63942
        },
        "268": {
            "name": "Яга",
            "population": 312,
            "type": "village",
            "poly": [
                [
                    90.2111221,
                    55.4683328
                ],
                [
                    90.2127171,
                    55.4696144
                ],
                [
                    90.2148269,
                    55.4713432
                ],
                [
                    90.2156551,
                    55.4719332
                ],
                [
                    90.2173956,
                    55.4729451
                ],
                [
                    90.2201377,
                    55.4743788
                ],
                [
                    90.2208652,
                    55.4746516
                ],
                [
                    90.223613,
                    55.4758156
                ],
                [
                    90.2274231,
                    55.4777546
                ],
                [
                    90.2280095,
                    55.4782215
                ],
                [
                    90.2261427,
                    55.4799468
                ],
                [
                    90.2258696,
                    55.480307
                ],
                [
                    90.226671,
                    55.480713
                ],
                [
                    90.2311524,
                    55.4827172
                ],
                [
                    90.2331985,
                    55.4836229
                ],
                [
                    90.2337671,
                    55.483808
                ],
                [
                    90.2343401,
                    55.4841784
                ],
                [
                    90.236225,
                    55.4852058
                ],
                [
                    90.238647,
                    55.4864108
                ],
                [
                    90.2405452,
                    55.4874609
                ],
                [
                    90.2406124,
                    55.4875624
                ],
                [
                    90.2406035,
                    55.4876664
                ],
                [
                    90.2394305,
                    55.4888535
                ],
                [
                    90.2386501,
                    55.4894846
                ],
                [
                    90.2435695,
                    55.4916225
                ],
                [
                    90.2491518,
                    55.4939606
                ],
                [
                    90.2521696,
                    55.4951306
                ],
                [
                    90.2509253,
                    55.4968964
                ],
                [
                    90.2509381,
                    55.4969806
                ],
                [
                    90.2510053,
                    55.4970288
                ],
                [
                    90.2512112,
                    55.4971251
                ],
                [
                    90.2513276,
                    55.4972697
                ],
                [
                    90.2515112,
                    55.4976754
                ],
                [
                    90.2519186,
                    55.4989561
                ],
                [
                    90.2520976,
                    55.4995444
                ],
                [
                    90.2523484,
                    55.500044
                ],
                [
                    90.2525588,
                    55.5005511
                ],
                [
                    90.2526528,
                    55.501147
                ],
                [
                    90.2525991,
                    55.5021081
                ],
                [
                    90.2525006,
                    55.5025011
                ],
                [
                    90.2519499,
                    55.503883
                ],
                [
                    90.2515478,
                    55.5047197
                ],
                [
                    90.2518315,
                    55.5044974
                ],
                [
                    90.2521925,
                    55.5042978
                ],
                [
                    90.2526653,
                    55.5041469
                ],
                [
                    90.2539135,
                    55.5038147
                ],
                [
                    90.2543519,
                    55.5038813
                ],
                [
                    90.2559163,
                    55.5044184
                ],
                [
                    90.2563031,
                    55.5045109
                ],
                [
                    90.2571828,
                    55.5045904
                ],
                [
                    90.2578704,
                    55.5046018
                ],
                [
                    90.2589592,
                    55.5046115
                ],
                [
                    90.2613609,
                    55.5045376
                ],
                [
                    90.2608001,
                    55.5056755
                ],
                [
                    90.2613617,
                    55.5056807
                ],
                [
                    90.2613754,
                    55.505769
                ],
                [
                    90.2615267,
                    55.5057768
                ],
                [
                    90.2615267,
                    55.506087
                ],
                [
                    90.2630273,
                    55.5061094
                ],
                [
                    90.263053,
                    55.5062862
                ],
                [
                    90.2642508,
                    55.5063674
                ],
                [
                    90.2644055,
                    55.5065264
                ],
                [
                    90.2646576,
                    55.5066335
                ],
                [
                    90.2646433,
                    55.507461
                ],
                [
                    90.264884,
                    55.5077433
                ],
                [
                    90.2652106,
                    55.5078699
                ],
                [
                    90.266601,
                    55.5082479
                ],
                [
                    90.266711,
                    55.5083102
                ],
                [
                    90.2667844,
                    55.5082713
                ],
                [
                    90.2673183,
                    55.508196
                ],
                [
                    90.2676644,
                    55.5080912
                ],
                [
                    90.2679724,
                    55.5081054
                ],
                [
                    90.2683521,
                    55.5079959
                ],
                [
                    90.2686709,
                    55.5078052
                ],
                [
                    90.2687962,
                    55.5076105
                ],
                [
                    90.2688177,
                    55.5059209
                ],
                [
                    90.2687926,
                    55.5056532
                ],
                [
                    90.2687103,
                    55.5053753
                ],
                [
                    90.2689932,
                    55.5047526
                ],
                [
                    90.2695315,
                    55.5031065
                ],
                [
                    90.2703115,
                    55.501545
                ],
                [
                    90.2706988,
                    55.5011438
                ],
                [
                    90.2710427,
                    55.5008387
                ],
                [
                    90.2713613,
                    55.5007297
                ],
                [
                    90.2721819,
                    55.5008569
                ],
                [
                    90.2721223,
                    55.5010075
                ],
                [
                    90.2734564,
                    55.5012139
                ],
                [
                    90.2737979,
                    55.5006894
                ],
                [
                    90.2738713,
                    55.500122
                ],
                [
                    90.273963,
                    55.4999857
                ],
                [
                    90.2740744,
                    55.4995444
                ],
                [
                    90.2741051,
                    55.4995365
                ],
                [
                    90.2738203,
                    55.499479
                ],
                [
                    90.2734117,
                    55.4992539
                ],
                [
                    90.2725667,
                    55.4990225
                ],
                [
                    90.2726842,
                    55.4988323
                ],
                [
                    90.2726786,
                    55.4985407
                ],
                [
                    90.2724828,
                    55.4983346
                ],
                [
                    90.2715872,
                    55.4978306
                ],
                [
                    90.2706247,
                    55.4972664
                ],
                [
                    90.2703394,
                    55.4971427
                ],
                [
                    90.2700931,
                    55.4971491
                ],
                [
                    90.269942,
                    55.4970825
                ],
                [
                    90.2696397,
                    55.4970952
                ],
                [
                    90.2693321,
                    55.4970508
                ],
                [
                    90.268834,
                    55.4969557
                ],
                [
                    90.2685149,
                    55.4969557
                ],
                [
                    90.2683639,
                    55.4970635
                ],
                [
                    90.2683527,
                    55.4972474
                ],
                [
                    90.2685318,
                    55.4973805
                ],
                [
                    90.2685654,
                    55.4975136
                ],
                [
                    90.2685149,
                    55.4975992
                ],
                [
                    90.2681624,
                    55.4977102
                ],
                [
                    90.2677707,
                    55.4977387
                ],
                [
                    90.2672223,
                    55.4976119
                ],
                [
                    90.2667746,
                    55.497745
                ],
                [
                    90.2666235,
                    55.4980177
                ],
                [
                    90.2664052,
                    55.4982966
                ],
                [
                    90.2662485,
                    55.4985692
                ],
                [
                    90.2659127,
                    55.4984297
                ],
                [
                    90.2657616,
                    55.4983029
                ],
                [
                    90.2653586,
                    55.4981064
                ],
                [
                    90.2653083,
                    55.4980272
                ],
                [
                    90.2650173,
                    55.4978275
                ],
                [
                    90.2645864,
                    55.497726
                ],
                [
                    90.2655154,
                    55.4958747
                ],
                [
                    90.2665643,
                    55.4933576
                ],
                [
                    90.2649862,
                    55.4929042
                ],
                [
                    90.2636935,
                    55.4926601
                ],
                [
                    90.2632794,
                    55.4925333
                ],
                [
                    90.2618299,
                    55.4922924
                ],
                [
                    90.2615557,
                    55.4921782
                ],
                [
                    90.2615389,
                    55.4919119
                ],
                [
                    90.2613934,
                    55.49182
                ],
                [
                    90.2610576,
                    55.4917566
                ],
                [
                    90.2603525,
                    55.4916741
                ],
                [
                    90.2593564,
                    55.4915061
                ],
                [
                    90.2591549,
                    55.4915917
                ],
                [
                    90.2590542,
                    55.4915251
                ],
                [
                    90.2589701,
                    55.4912873
                ],
                [
                    90.2600895,
                    55.4896133
                ],
                [
                    90.2605764,
                    55.4882943
                ],
                [
                    90.2602574,
                    55.4881802
                ],
                [
                    90.2600671,
                    55.4879931
                ],
                [
                    90.2597817,
                    55.4876792
                ],
                [
                    90.2594403,
                    55.4875206
                ],
                [
                    90.2591101,
                    55.4875048
                ],
                [
                    90.2588135,
                    55.4872606
                ],
                [
                    90.2587184,
                    55.4870831
                ],
                [
                    90.2587408,
                    55.4866233
                ],
                [
                    90.258696,
                    55.4864013
                ],
                [
                    90.2585113,
                    55.4862809
                ],
                [
                    90.2583602,
                    55.4861318
                ],
                [
                    90.258377,
                    55.4858052
                ],
                [
                    90.258142,
                    55.4853803
                ],
                [
                    90.2577167,
                    55.4848191
                ],
                [
                    90.2573193,
                    55.4844544
                ],
                [
                    90.2569724,
                    55.483909
                ],
                [
                    90.2567037,
                    55.4835855
                ],
                [
                    90.2559986,
                    55.4829418
                ],
                [
                    90.2560322,
                    55.4828657
                ],
                [
                    90.2561609,
                    55.4828403
                ],
                [
                    90.2566982,
                    55.4828625
                ],
                [
                    90.2569276,
                    55.4827547
                ],
                [
                    90.2569836,
                    55.482409
                ],
                [
                    90.2570059,
                    55.4818731
                ],
                [
                    90.2571011,
                    55.4818002
                ],
                [
                    90.2572018,
                    55.4815972
                ],
                [
                    90.257157,
                    55.4815052
                ],
                [
                    90.2556237,
                    55.4818731
                ],
                [
                    90.2544149,
                    55.4823456
                ],
                [
                    90.2531445,
                    55.4827293
                ],
                [
                    90.252098,
                    55.4831384
                ],
                [
                    90.2514712,
                    55.483297
                ],
                [
                    90.2511914,
                    55.4832938
                ],
                [
                    90.2509956,
                    55.4831796
                ],
                [
                    90.2506374,
                    55.4828879
                ],
                [
                    90.2500946,
                    55.4826183
                ],
                [
                    90.2493558,
                    55.482149
                ],
                [
                    90.248578,
                    55.4817399
                ],
                [
                    90.2483036,
                    55.4815338
                ],
                [
                    90.2483653,
                    55.4813847
                ],
                [
                    90.2487011,
                    55.4811849
                ],
                [
                    90.2494622,
                    55.4808678
                ],
                [
                    90.2504414,
                    55.4805665
                ],
                [
                    90.250822,
                    55.4803889
                ],
                [
                    90.2509564,
                    55.4801606
                ],
                [
                    90.2507269,
                    55.4799862
                ],
                [
                    90.2504079,
                    55.479872
                ],
                [
                    90.2497868,
                    55.4797547
                ],
                [
                    90.2492215,
                    55.47965
                ],
                [
                    90.2486562,
                    55.4794914
                ],
                [
                    90.2470166,
                    55.4787715
                ],
                [
                    90.246166,
                    55.4792504
                ],
                [
                    90.2457127,
                    55.4794407
                ],
                [
                    90.2451698,
                    55.4795802
                ],
                [
                    90.2445598,
                    55.4796278
                ],
                [
                    90.2439722,
                    55.4796342
                ],
                [
                    90.2435804,
                    55.4795834
                ],
                [
                    90.2431888,
                    55.4794248
                ],
                [
                    90.2426347,
                    55.4791109
                ],
                [
                    90.2412468,
                    55.4779152
                ],
                [
                    90.2403178,
                    55.4771223
                ],
                [
                    90.2390307,
                    55.4762343
                ],
                [
                    90.2384151,
                    55.4756856
                ],
                [
                    90.2378723,
                    55.4752701
                ],
                [
                    90.2371224,
                    55.4750227
                ],
                [
                    90.2365516,
                    55.4748895
                ],
                [
                    90.236171,
                    55.4748609
                ],
                [
                    90.23588,
                    55.4747277
                ],
                [
                    90.2343299,
                    55.4736366
                ],
                [
                    90.2328021,
                    55.4721965
                ],
                [
                    90.2318619,
                    55.4715018
                ],
                [
                    90.2287504,
                    55.4694844
                ],
                [
                    90.2253423,
                    55.4677682
                ],
                [
                    90.2235514,
                    55.4667181
                ],
                [
                    90.2192759,
                    55.4645068
                ],
                [
                    90.2182574,
                    55.4639199
                ],
                [
                    90.2166065,
                    55.464345
                ],
                [
                    90.2152466,
                    55.4647511
                ],
                [
                    90.2146534,
                    55.4649256
                ],
                [
                    90.2140882,
                    55.4651604
                ],
                [
                    90.213702,
                    55.4655411
                ],
                [
                    90.2136349,
                    55.4659123
                ],
                [
                    90.2135845,
                    55.4663184
                ],
                [
                    90.2133886,
                    55.4667942
                ],
                [
                    90.2131144,
                    55.4672638
                ],
                [
                    90.2129633,
                    55.4674097
                ],
                [
                    90.2123533,
                    55.4677745
                ],
                [
                    90.2114075,
                    55.4681869
                ],
                [
                    90.2111221,
                    55.4683328
                ]
            ],
            "longitude": 90.264107,
            "latitude": 55.499271
        },
        "269": {
            "name": "Приреченск",
            "population": 902,
            "type": "village",
            "poly": null,
            "longitude": 90.271561,
            "latitude": 55.211536
        },
        "270": {
            "name": "Дорохово",
            "population": 1374,
            "type": "village",
            "poly": [
                [
                    90.2636743,
                    56.033379
                ],
                [
                    90.2658491,
                    56.0367811
                ],
                [
                    90.2690569,
                    56.0371456
                ],
                [
                    90.2764513,
                    56.0372063
                ],
                [
                    90.280964,
                    56.0362951
                ],
                [
                    90.2826495,
                    56.0341688
                ],
                [
                    90.2895545,
                    56.0317386
                ],
                [
                    90.2883583,
                    56.0294905
                ],
                [
                    90.2833563,
                    56.0271816
                ],
                [
                    90.2806921,
                    56.0289741
                ],
                [
                    90.2764513,
                    56.0287918
                ],
                [
                    90.2681326,
                    56.0261486
                ],
                [
                    90.2677792,
                    56.0267218
                ],
                [
                    90.2636743,
                    56.033379
                ]
            ],
            "longitude": 90.27504,
            "latitude": 56.032375
        },
        "271": {
            "name": "Кольцово",
            "population": 443,
            "type": "village",
            "poly": [
                [
                    90.2647784,
                    55.7858497
                ],
                [
                    90.2649394,
                    55.7865423
                ],
                [
                    90.2650164,
                    55.7868847
                ],
                [
                    90.2651843,
                    55.786991
                ],
                [
                    90.2653173,
                    55.7869792
                ],
                [
                    90.2653523,
                    55.7870579
                ],
                [
                    90.2651424,
                    55.7871405
                ],
                [
                    90.2651564,
                    55.7872192
                ],
                [
                    90.2653173,
                    55.7872625
                ],
                [
                    90.2653453,
                    55.787538
                ],
                [
                    90.2659613,
                    55.7878567
                ],
                [
                    90.2663042,
                    55.7879
                ],
                [
                    90.2665702,
                    55.7880456
                ],
                [
                    90.267641,
                    55.7881834
                ],
                [
                    90.2685159,
                    55.7885808
                ],
                [
                    90.2687539,
                    55.7886044
                ],
                [
                    90.2688169,
                    55.7885454
                ],
                [
                    90.2690899,
                    55.7885926
                ],
                [
                    90.2693628,
                    55.7890019
                ],
                [
                    90.2701677,
                    55.7895292
                ],
                [
                    90.2692754,
                    55.7901998
                ],
                [
                    90.2691879,
                    55.790849
                ],
                [
                    90.2693454,
                    55.7914491
                ],
                [
                    90.2694679,
                    55.7918623
                ],
                [
                    90.2698791,
                    55.7920394
                ],
                [
                    90.270334,
                    55.7920246
                ],
                [
                    90.2704828,
                    55.7917492
                ],
                [
                    90.2705528,
                    55.7912622
                ],
                [
                    90.2708777,
                    55.7909746
                ],
                [
                    90.2712854,
                    55.7908965
                ],
                [
                    90.2714421,
                    55.7909544
                ],
                [
                    90.271693,
                    55.7912113
                ],
                [
                    90.271702,
                    55.7913926
                ],
                [
                    90.2715049,
                    55.791642
                ],
                [
                    90.2715541,
                    55.791924
                ],
                [
                    90.2717647,
                    55.7920625
                ],
                [
                    90.2720917,
                    55.7921381
                ],
                [
                    90.273216,
                    55.7921053
                ],
                [
                    90.274085,
                    55.7922413
                ],
                [
                    90.2746001,
                    55.7925989
                ],
                [
                    90.2746405,
                    55.7929666
                ],
                [
                    90.2745643,
                    55.7931529
                ],
                [
                    90.2742731,
                    55.7933141
                ],
                [
                    90.2756259,
                    55.7937346
                ],
                [
                    90.2759006,
                    55.7952964
                ],
                [
                    90.2759986,
                    55.7963233
                ],
                [
                    90.2762155,
                    55.7964413
                ],
                [
                    90.2776434,
                    55.7964374
                ],
                [
                    90.2786792,
                    55.7961935
                ],
                [
                    90.2791412,
                    55.7959889
                ],
                [
                    90.2796451,
                    55.7953987
                ],
                [
                    90.2793861,
                    55.7952138
                ],
                [
                    90.2799391,
                    55.794053
                ],
                [
                    90.2794981,
                    55.793333
                ],
                [
                    90.2790082,
                    55.7927428
                ],
                [
                    90.2789382,
                    55.7920699
                ],
                [
                    90.2790362,
                    55.7916567
                ],
                [
                    90.2787282,
                    55.7912947
                ],
                [
                    90.2786512,
                    55.7910744
                ],
                [
                    90.2788542,
                    55.7908068
                ],
                [
                    90.2785602,
                    55.7908304
                ],
                [
                    90.2787002,
                    55.7907124
                ],
                [
                    90.2788192,
                    55.7902283
                ],
                [
                    90.2776923,
                    55.7901064
                ],
                [
                    90.2759744,
                    55.7897481
                ],
                [
                    90.2752465,
                    55.7895159
                ],
                [
                    90.2750995,
                    55.789386
                ],
                [
                    90.2745326,
                    55.7893191
                ],
                [
                    90.2742736,
                    55.7893388
                ],
                [
                    90.2737837,
                    55.7895001
                ],
                [
                    90.2735107,
                    55.789449
                ],
                [
                    90.2731258,
                    55.7892208
                ],
                [
                    90.2730348,
                    55.7886305
                ],
                [
                    90.2743156,
                    55.7886108
                ],
                [
                    90.2774372,
                    55.7883904
                ],
                [
                    90.2782211,
                    55.7882015
                ],
                [
                    90.2788021,
                    55.7879615
                ],
                [
                    90.279166,
                    55.7876152
                ],
                [
                    90.2797889,
                    55.7872925
                ],
                [
                    90.2806428,
                    55.787261
                ],
                [
                    90.2812447,
                    55.7874105
                ],
                [
                    90.2827575,
                    55.7879343
                ],
                [
                    90.2839824,
                    55.788259
                ],
                [
                    90.2860734,
                    55.7884754
                ],
                [
                    90.2866683,
                    55.7886525
                ],
                [
                    90.2882868,
                    55.7888886
                ],
                [
                    90.288908,
                    55.7892083
                ],
                [
                    90.2891267,
                    55.7894051
                ],
                [
                    90.2894154,
                    55.7895428
                ],
                [
                    90.2899054,
                    55.7895281
                ],
                [
                    90.2901941,
                    55.7894445
                ],
                [
                    90.2904741,
                    55.7890165
                ],
                [
                    90.2913577,
                    55.7885689
                ],
                [
                    90.2918564,
                    55.7884902
                ],
                [
                    90.2921831,
                    55.7882459
                ],
                [
                    90.2925522,
                    55.7876495
                ],
                [
                    90.2933191,
                    55.7872062
                ],
                [
                    90.2936667,
                    55.7870873
                ],
                [
                    90.2932833,
                    55.7869241
                ],
                [
                    90.2934159,
                    55.7866783
                ],
                [
                    90.293441,
                    55.786374
                ],
                [
                    90.2929715,
                    55.786227
                ],
                [
                    90.292735,
                    55.7862431
                ],
                [
                    90.2921545,
                    55.7859106
                ],
                [
                    90.2917531,
                    55.7856245
                ],
                [
                    90.291298,
                    55.7851892
                ],
                [
                    90.2903806,
                    55.7850965
                ],
                [
                    90.2894489,
                    55.7850623
                ],
                [
                    90.2880155,
                    55.7847661
                ],
                [
                    90.2874923,
                    55.7846149
                ],
                [
                    90.2859119,
                    55.7843328
                ],
                [
                    90.2851701,
                    55.7841394
                ],
                [
                    90.2844534,
                    55.783823
                ],
                [
                    90.2836328,
                    55.7836195
                ],
                [
                    90.2822101,
                    55.7834583
                ],
                [
                    90.2809487,
                    55.7831399
                ],
                [
                    90.2810321,
                    55.782495
                ],
                [
                    90.2793893,
                    55.7825347
                ],
                [
                    90.276528,
                    55.7824465
                ],
                [
                    90.2765728,
                    55.7831329
                ],
                [
                    90.2744227,
                    55.7829629
                ],
                [
                    90.273706,
                    55.7829409
                ],
                [
                    90.2720598,
                    55.7810957
                ],
                [
                    90.2719706,
                    55.7811189
                ],
                [
                    90.2709109,
                    55.7812091
                ],
                [
                    90.267886,
                    55.7819455
                ],
                [
                    90.267844,
                    55.7825437
                ],
                [
                    90.26804,
                    55.7831262
                ],
                [
                    90.2672911,
                    55.7839606
                ],
                [
                    90.2666122,
                    55.78485
                ],
                [
                    90.2662132,
                    55.7851924
                ],
                [
                    90.2647784,
                    55.7858497
                ]
            ],
            "longitude": 90.280991,
            "latitude": 55.785603
        },
        "272": {
            "name": "Верхняя Березовка",
            "population": 289,
            "type": "village",
            "poly": [
                [
                    90.2671816,
                    55.6816222
                ],
                [
                    90.2713237,
                    55.6837955
                ],
                [
                    90.2728411,
                    55.6848051
                ],
                [
                    90.2742081,
                    55.6856374
                ],
                [
                    90.2753837,
                    55.6867317
                ],
                [
                    90.2756025,
                    55.6869089
                ],
                [
                    90.2785962,
                    55.6880263
                ],
                [
                    90.27902,
                    55.6884038
                ],
                [
                    90.2811935,
                    55.6891513
                ],
                [
                    90.2820821,
                    55.6888739
                ],
                [
                    90.2828476,
                    55.6881495
                ],
                [
                    90.2912821,
                    55.6917634
                ],
                [
                    90.2946996,
                    55.6927959
                ],
                [
                    90.2969005,
                    55.6932813
                ],
                [
                    90.2981308,
                    55.6934123
                ],
                [
                    90.2988579,
                    55.6932385
                ],
                [
                    90.2984314,
                    55.6940767
                ],
                [
                    90.2981033,
                    55.6954635
                ],
                [
                    90.2958395,
                    55.6965976
                ],
                [
                    90.2953693,
                    55.6963018
                ],
                [
                    90.2934664,
                    55.6972448
                ],
                [
                    90.3023246,
                    55.7025324
                ],
                [
                    90.310472,
                    55.7005358
                ],
                [
                    90.3073224,
                    55.697331
                ],
                [
                    90.3071256,
                    55.6967517
                ],
                [
                    90.3072677,
                    55.6961785
                ],
                [
                    90.3066335,
                    55.6952786
                ],
                [
                    90.3057695,
                    55.694613
                ],
                [
                    90.3066772,
                    55.6941137
                ],
                [
                    90.3080442,
                    55.6937562
                ],
                [
                    90.3078802,
                    55.6936021
                ],
                [
                    90.3078692,
                    55.6930166
                ],
                [
                    90.3072787,
                    55.6927207
                ],
                [
                    90.3071365,
                    55.6923509
                ],
                [
                    90.3065132,
                    55.6923015
                ],
                [
                    90.3063054,
                    55.6922276
                ],
                [
                    90.3058461,
                    55.6914201
                ],
                [
                    90.305004,
                    55.6912228
                ],
                [
                    90.3042822,
                    55.6916358
                ],
                [
                    90.3036151,
                    55.6918762
                ],
                [
                    90.3032651,
                    55.6917591
                ],
                [
                    90.3028714,
                    55.6914324
                ],
                [
                    90.3015482,
                    55.6908591
                ],
                [
                    90.3005748,
                    55.6903968
                ],
                [
                    90.3005092,
                    55.6901009
                ],
                [
                    90.2995031,
                    55.6897126
                ],
                [
                    90.2989016,
                    55.6896448
                ],
                [
                    90.2977643,
                    55.6891023
                ],
                [
                    90.2959926,
                    55.6886276
                ],
                [
                    90.295249,
                    55.6883502
                ],
                [
                    90.2945709,
                    55.6877831
                ],
                [
                    90.2940351,
                    55.6873639
                ],
                [
                    90.2913866,
                    55.6860246
                ],
                [
                    90.2893568,
                    55.6848261
                ],
                [
                    90.2884994,
                    55.6844513
                ],
                [
                    90.287712,
                    55.6842984
                ],
                [
                    90.2874408,
                    55.6839235
                ],
                [
                    90.2863122,
                    55.6835635
                ],
                [
                    90.2863647,
                    55.683238
                ],
                [
                    90.2846587,
                    55.6823107
                ],
                [
                    90.28367,
                    55.6818914
                ],
                [
                    90.2831992,
                    55.6817518
                ],
                [
                    90.2814845,
                    55.6816877
                ],
                [
                    90.2812657,
                    55.6815693
                ],
                [
                    90.281292,
                    55.6812684
                ],
                [
                    90.2805571,
                    55.6808788
                ],
                [
                    90.2795335,
                    55.6809034
                ],
                [
                    90.2792185,
                    55.6808196
                ],
                [
                    90.2787111,
                    55.680494
                ],
                [
                    90.2777749,
                    55.6801734
                ],
                [
                    90.2767863,
                    55.6794581
                ],
                [
                    90.2750803,
                    55.6787971
                ],
                [
                    90.2735405,
                    55.6786344
                ],
                [
                    90.271537,
                    55.6781361
                ],
                [
                    90.2688861,
                    55.6798281
                ],
                [
                    90.2671816,
                    55.6816222
                ]
            ],
            "longitude": 90.286591,
            "latitude": 55.687668
        },
        "273": {
            "name": "Белый Яр",
            "population": 948,
            "type": "village",
            "poly": [
                [
                    90.2917006,
                    56.2858282
                ],
                [
                    90.2923349,
                    56.2880791
                ],
                [
                    90.296102,
                    56.2876524
                ],
                [
                    90.2961597,
                    56.2882605
                ],
                [
                    90.2986006,
                    56.2884418
                ],
                [
                    90.3047703,
                    56.2893059
                ],
                [
                    90.3046165,
                    56.2898285
                ],
                [
                    90.3129581,
                    56.2902339
                ],
                [
                    90.3171481,
                    56.2903726
                ],
                [
                    90.3172826,
                    56.2914926
                ],
                [
                    90.3281228,
                    56.2919406
                ],
                [
                    90.3308905,
                    56.2910979
                ],
                [
                    90.3312556,
                    56.2900312
                ],
                [
                    90.3329277,
                    56.2901379
                ],
                [
                    90.3341578,
                    56.2901699
                ],
                [
                    90.3387899,
                    56.2893485
                ],
                [
                    90.3388475,
                    56.2875031
                ],
                [
                    90.337925,
                    56.2870337
                ],
                [
                    90.3351189,
                    56.2867243
                ],
                [
                    90.3332738,
                    56.2861376
                ],
                [
                    90.331025,
                    56.2849534
                ],
                [
                    90.3288916,
                    56.2832784
                ],
                [
                    90.3272579,
                    56.2842066
                ],
                [
                    90.3238367,
                    56.2852308
                ],
                [
                    90.3199734,
                    56.2856575
                ],
                [
                    90.3164369,
                    56.2856682
                ],
                [
                    90.311209,
                    56.2850494
                ],
                [
                    90.3079032,
                    56.2842813
                ],
                [
                    90.3071728,
                    56.2849961
                ],
                [
                    90.3028867,
                    56.2840359
                ],
                [
                    90.3005995,
                    56.283033
                ],
                [
                    90.300119,
                    56.2821262
                ],
                [
                    90.2974666,
                    56.2816461
                ],
                [
                    90.2938725,
                    56.2825529
                ],
                [
                    90.2946221,
                    56.2851454
                ],
                [
                    90.2917006,
                    56.2858282
                ]
            ],
            "longitude": 90.316277,
            "latitude": 56.287903
        },
        "274": {
            "name": "Арабкаево",
            "population": 328,
            "type": "village",
            "poly": [
                [
                    90.2993667,
                    55.0747322
                ],
                [
                    90.3001928,
                    55.0747266
                ],
                [
                    90.3009353,
                    55.0748898
                ],
                [
                    90.3016089,
                    55.07507
                ],
                [
                    90.302612,
                    55.0757512
                ],
                [
                    90.3033643,
                    55.076393
                ],
                [
                    90.3040379,
                    55.0767758
                ],
                [
                    90.3044657,
                    55.0769701
                ],
                [
                    90.3052671,
                    55.0771868
                ],
                [
                    90.3066587,
                    55.0772684
                ],
                [
                    90.3070078,
                    55.0774204
                ],
                [
                    90.3080354,
                    55.0776287
                ],
                [
                    90.3090631,
                    55.0779384
                ],
                [
                    90.3101399,
                    55.0781917
                ],
                [
                    90.3105874,
                    55.0783437
                ],
                [
                    90.3106513,
                    55.0784873
                ],
                [
                    90.3106267,
                    55.0787434
                ],
                [
                    90.310548,
                    55.0789686
                ],
                [
                    90.3105677,
                    55.0790558
                ],
                [
                    90.310789,
                    55.079281
                ],
                [
                    90.3115806,
                    55.0799425
                ],
                [
                    90.3119543,
                    55.080314
                ],
                [
                    90.3135818,
                    55.0817494
                ],
                [
                    90.314044,
                    55.0825488
                ],
                [
                    90.3140637,
                    55.0828189
                ],
                [
                    90.314403,
                    55.0830469
                ],
                [
                    90.3146242,
                    55.0833987
                ],
                [
                    90.3150717,
                    55.0835929
                ],
                [
                    90.3157896,
                    55.0837308
                ],
                [
                    90.316414,
                    55.0837477
                ],
                [
                    90.3164516,
                    55.0839848
                ],
                [
                    90.316952,
                    55.0838474
                ],
                [
                    90.3176711,
                    55.0837489
                ],
                [
                    90.3177003,
                    55.0843418
                ],
                [
                    90.3179596,
                    55.0849758
                ],
                [
                    90.3206709,
                    55.0849124
                ],
                [
                    90.321182,
                    55.0849542
                ],
                [
                    90.3232791,
                    55.0849182
                ],
                [
                    90.3236139,
                    55.084862
                ],
                [
                    90.3243893,
                    55.0850839
                ],
                [
                    90.3253585,
                    55.0851862
                ],
                [
                    90.3264964,
                    55.0852092
                ],
                [
                    90.3274883,
                    55.0852049
                ],
                [
                    90.3281001,
                    55.0851818
                ],
                [
                    90.3290089,
                    55.0851487
                ],
                [
                    90.3291575,
                    55.0846256
                ],
                [
                    90.3303205,
                    55.0846501
                ],
                [
                    90.3303508,
                    55.084372
                ],
                [
                    90.3309927,
                    55.0843778
                ],
                [
                    90.3313074,
                    55.0845781
                ],
                [
                    90.3314484,
                    55.0846963
                ],
                [
                    90.331972,
                    55.0845882
                ],
                [
                    90.3323043,
                    55.0845305
                ],
                [
                    90.3325586,
                    55.0844254
                ],
                [
                    90.3332736,
                    55.0842841
                ],
                [
                    90.3333114,
                    55.0842164
                ],
                [
                    90.3332862,
                    55.0839614
                ],
                [
                    90.3331905,
                    55.0836098
                ],
                [
                    90.33276,
                    55.0835492
                ],
                [
                    90.3312621,
                    55.083532
                ],
                [
                    90.3298598,
                    55.0832726
                ],
                [
                    90.3299052,
                    55.0828086
                ],
                [
                    90.3313803,
                    55.0830093
                ],
                [
                    90.3316038,
                    55.0829391
                ],
                [
                    90.3317359,
                    55.0825248
                ],
                [
                    90.3328783,
                    55.0825896
                ],
                [
                    90.3340174,
                    55.0824563
                ],
                [
                    90.3342314,
                    55.0824545
                ],
                [
                    90.3343447,
                    55.0821879
                ],
                [
                    90.3343573,
                    55.0819249
                ],
                [
                    90.3334762,
                    55.0819033
                ],
                [
                    90.3334195,
                    55.0814404
                ],
                [
                    90.3328373,
                    55.081426
                ],
                [
                    90.3318335,
                    55.0811396
                ],
                [
                    90.3310373,
                    55.0810189
                ],
                [
                    90.3299548,
                    55.0809738
                ],
                [
                    90.3295363,
                    55.080864
                ],
                [
                    90.3290894,
                    55.0808279
                ],
                [
                    90.3286926,
                    55.0807914
                ],
                [
                    90.3287417,
                    55.0806577
                ],
                [
                    90.3292421,
                    55.0800672
                ],
                [
                    90.3292618,
                    55.0799602
                ],
                [
                    90.3291782,
                    55.0796562
                ],
                [
                    90.3290995,
                    55.0793663
                ],
                [
                    90.3287701,
                    55.0791074
                ],
                [
                    90.328062,
                    55.0789891
                ],
                [
                    90.3275212,
                    55.0789948
                ],
                [
                    90.3273048,
                    55.0790426
                ],
                [
                    90.3271425,
                    55.0792959
                ],
                [
                    90.327054,
                    55.079507
                ],
                [
                    90.3269754,
                    55.0795943
                ],
                [
                    90.3267246,
                    55.0795887
                ],
                [
                    90.3266607,
                    55.0794676
                ],
                [
                    90.3264787,
                    55.0793832
                ],
                [
                    90.3262476,
                    55.0793551
                ],
                [
                    90.3257363,
                    55.0793607
                ],
                [
                    90.3255986,
                    55.0794479
                ],
                [
                    90.3254216,
                    55.0796956
                ],
                [
                    90.3248709,
                    55.07969
                ],
                [
                    90.3247725,
                    55.079766
                ],
                [
                    90.3247578,
                    55.0798842
                ],
                [
                    90.3247775,
                    55.0799293
                ],
                [
                    90.3249348,
                    55.0799433
                ],
                [
                    90.32492,
                    55.0801122
                ],
                [
                    90.324748,
                    55.0804697
                ],
                [
                    90.324389,
                    55.0807821
                ],
                [
                    90.3244431,
                    55.0811029
                ],
                [
                    90.3245513,
                    55.0812409
                ],
                [
                    90.3245611,
                    55.0813506
                ],
                [
                    90.3223288,
                    55.0814351
                ],
                [
                    90.3207898,
                    55.0814632
                ],
                [
                    90.3207553,
                    55.0811874
                ],
                [
                    90.3195654,
                    55.0810382
                ],
                [
                    90.3192065,
                    55.0809031
                ],
                [
                    90.3188475,
                    55.0808243
                ],
                [
                    90.3179526,
                    55.0807427
                ],
                [
                    90.3187089,
                    55.0802785
                ],
                [
                    90.3234506,
                    55.0758202
                ],
                [
                    90.3282224,
                    55.0712928
                ],
                [
                    90.3287176,
                    55.0708374
                ],
                [
                    90.3301431,
                    55.0702102
                ],
                [
                    90.3303682,
                    55.0698665
                ],
                [
                    90.3305394,
                    55.0695579
                ],
                [
                    90.3290164,
                    55.0677458
                ],
                [
                    90.3265785,
                    55.0666826
                ],
                [
                    90.3218548,
                    55.06669
                ],
                [
                    90.3189624,
                    55.0673229
                ],
                [
                    90.3172837,
                    55.0681285
                ],
                [
                    90.3169802,
                    55.0695486
                ],
                [
                    90.318655,
                    55.0719483
                ],
                [
                    90.3192631,
                    55.0737458
                ],
                [
                    90.3171315,
                    55.0743922
                ],
                [
                    90.3133181,
                    55.0745823
                ],
                [
                    90.3092051,
                    55.0735309
                ],
                [
                    90.3064672,
                    55.072759
                ],
                [
                    90.3031103,
                    55.0733643
                ],
                [
                    90.2998019,
                    55.074188
                ],
                [
                    90.2993667,
                    55.0747322
                ]
            ],
            "longitude": 90.323479,
            "latitude": 55.083023
        },
        "275": {
            "name": "Мазульский",
            "population": 1273,
            "type": "village",
            "poly": [
                [
                    90.3071287,
                    56.2141362
                ],
                [
                    90.3084539,
                    56.2155511
                ],
                [
                    90.308719,
                    56.216347
                ],
                [
                    90.3083479,
                    56.2172608
                ],
                [
                    90.3090901,
                    56.2187935
                ],
                [
                    90.3103623,
                    56.220444
                ],
                [
                    90.3108394,
                    56.2213577
                ],
                [
                    90.3109454,
                    56.2226545
                ],
                [
                    90.3113695,
                    56.2232734
                ],
                [
                    90.3185259,
                    56.2271929
                ],
                [
                    90.3214944,
                    56.2279001
                ],
                [
                    90.3232438,
                    56.2286368
                ],
                [
                    90.3249401,
                    56.229344
                ],
                [
                    90.3272725,
                    56.2295503
                ],
                [
                    90.3294459,
                    56.2294619
                ],
                [
                    90.3322555,
                    56.2291083
                ],
                [
                    90.3340048,
                    56.2283716
                ],
                [
                    90.3559471,
                    56.2189106
                ],
                [
                    90.35995,
                    56.2232532
                ],
                [
                    90.3741627,
                    56.2200574
                ],
                [
                    90.3754587,
                    56.2160817
                ],
                [
                    90.3754587,
                    56.2153153
                ],
                [
                    90.3747695,
                    56.2148436
                ],
                [
                    90.3739214,
                    56.2141951
                ],
                [
                    90.3728612,
                    56.2140183
                ],
                [
                    90.371854,
                    56.2138119
                ],
                [
                    90.3704228,
                    56.2136645
                ],
                [
                    90.3679313,
                    56.2129865
                ],
                [
                    90.366235,
                    56.2125148
                ],
                [
                    90.3652872,
                    56.2120317
                ],
                [
                    90.366193,
                    56.2105631
                ],
                [
                    90.3663587,
                    56.2102945
                ],
                [
                    90.3748548,
                    56.2085236
                ],
                [
                    90.3783256,
                    56.2062322
                ],
                [
                    90.3768618,
                    56.204352
                ],
                [
                    90.3776767,
                    56.2044276
                ],
                [
                    90.3862945,
                    56.2008416
                ],
                [
                    90.3819559,
                    56.1985854
                ],
                [
                    90.3769194,
                    56.1970008
                ],
                [
                    90.3693928,
                    56.1963082
                ],
                [
                    90.3662993,
                    56.1958254
                ],
                [
                    90.3545851,
                    56.1938628
                ],
                [
                    90.3419635,
                    56.1913843
                ],
                [
                    90.3211194,
                    56.1952571
                ],
                [
                    90.3149699,
                    56.1966005
                ],
                [
                    90.3099334,
                    56.1972826
                ],
                [
                    90.3103463,
                    56.2041673
                ],
                [
                    90.3165185,
                    56.2058544
                ],
                [
                    90.3197646,
                    56.210248
                ],
                [
                    90.3261593,
                    56.2108774
                ],
                [
                    90.328555,
                    56.2106151
                ],
                [
                    90.3277686,
                    56.214091
                ],
                [
                    90.3260533,
                    56.213753
                ],
                [
                    90.3239859,
                    56.2133697
                ],
                [
                    90.3216004,
                    56.2131339
                ],
                [
                    90.319162,
                    56.2131339
                ],
                [
                    90.3166705,
                    56.2131339
                ],
                [
                    90.3148682,
                    56.2132223
                ],
                [
                    90.313967,
                    56.2130455
                ],
                [
                    90.3124827,
                    56.2124559
                ],
                [
                    90.3115285,
                    56.2119842
                ],
                [
                    90.3103093,
                    56.2119547
                ],
                [
                    90.3074998,
                    56.2130749
                ],
                [
                    90.3071287,
                    56.2141362
                ]
            ],
            "longitude": 90.325066,
            "latitude": 56.208691
        },
        "276": {
            "name": "Старая Кузурба",
            "population": 313,
            "type": "village",
            "poly": null,
            "longitude": 90.361252,
            "latitude": 55.218552
        },
        "277": {
            "name": "Средняя Берёзовка",
            "population": 349,
            "type": "village",
            "poly": [
                [
                    90.3472686,
                    55.7443785
                ],
                [
                    90.3472774,
                    55.744935
                ],
                [
                    90.3477586,
                    55.7452945
                ],
                [
                    90.3475048,
                    55.7454964
                ],
                [
                    90.3476798,
                    55.7457328
                ],
                [
                    90.348021,
                    55.745851
                ],
                [
                    90.3480648,
                    55.7459889
                ],
                [
                    90.3480823,
                    55.7462006
                ],
                [
                    90.3485197,
                    55.7467226
                ],
                [
                    90.3485285,
                    55.7471953
                ],
                [
                    90.3490359,
                    55.7475105
                ],
                [
                    90.349797,
                    55.747609
                ],
                [
                    90.3502432,
                    55.7479734
                ],
                [
                    90.3506107,
                    55.7481063
                ],
                [
                    90.351818,
                    55.7480866
                ],
                [
                    90.3521505,
                    55.7481999
                ],
                [
                    90.3527889,
                    55.7485674
                ],
                [
                    90.3531928,
                    55.7487955
                ],
                [
                    90.3544915,
                    55.7488494
                ],
                [
                    90.3548879,
                    55.7490187
                ],
                [
                    90.355134,
                    55.7493264
                ],
                [
                    90.3557901,
                    55.7495572
                ],
                [
                    90.3565557,
                    55.7496188
                ],
                [
                    90.3569521,
                    55.7497573
                ],
                [
                    90.3574169,
                    55.7500727
                ],
                [
                    90.3586199,
                    55.7504189
                ],
                [
                    90.3600142,
                    55.750642
                ],
                [
                    90.361969,
                    55.7513498
                ],
                [
                    90.3628029,
                    55.7518422
                ],
                [
                    90.3631583,
                    55.7518422
                ],
                [
                    90.3637735,
                    55.7515499
                ],
                [
                    90.3664529,
                    55.7515114
                ],
                [
                    90.3674781,
                    55.7516576
                ],
                [
                    90.372944,
                    55.7537281
                ],
                [
                    90.3740704,
                    55.7542327
                ],
                [
                    90.3745625,
                    55.7546574
                ],
                [
                    90.3764545,
                    55.7557836
                ],
                [
                    90.3774278,
                    55.755242
                ],
                [
                    90.3790245,
                    55.7542266
                ],
                [
                    90.3792104,
                    55.754842
                ],
                [
                    90.3803368,
                    55.754602
                ],
                [
                    90.3817038,
                    55.7539804
                ],
                [
                    90.3826006,
                    55.7536727
                ],
                [
                    90.3831364,
                    55.753285
                ],
                [
                    90.3830599,
                    55.7528049
                ],
                [
                    90.3846458,
                    55.7517998
                ],
                [
                    90.3882342,
                    55.7499918
                ],
                [
                    90.3901139,
                    55.7487993
                ],
                [
                    90.3909381,
                    55.7479431
                ],
                [
                    90.391603,
                    55.7476476
                ],
                [
                    90.391715,
                    55.7470567
                ],
                [
                    90.39147,
                    55.7466864
                ],
                [
                    90.391715,
                    55.7462334
                ],
                [
                    90.391659,
                    55.7455558
                ],
                [
                    90.3919599,
                    55.7444487
                ],
                [
                    90.3919319,
                    55.7438617
                ],
                [
                    90.391309,
                    55.7438381
                ],
                [
                    90.3907421,
                    55.743909
                ],
                [
                    90.3887333,
                    55.7432589
                ],
                [
                    90.3861437,
                    55.7432707
                ],
                [
                    90.3844499,
                    55.7438814
                ],
                [
                    90.383309,
                    55.7447442
                ],
                [
                    90.3814685,
                    55.7469052
                ],
                [
                    90.3798964,
                    55.7484363
                ],
                [
                    90.379766,
                    55.7489623
                ],
                [
                    90.3784389,
                    55.7496052
                ],
                [
                    90.3774031,
                    55.7499802
                ],
                [
                    90.376524,
                    55.7502543
                ],
                [
                    90.3755721,
                    55.7495075
                ],
                [
                    90.3735417,
                    55.748756
                ],
                [
                    90.3708624,
                    55.747925
                ],
                [
                    90.3702838,
                    55.7476311
                ],
                [
                    90.3699815,
                    55.7473097
                ],
                [
                    90.3697743,
                    55.7469725
                ],
                [
                    90.3698695,
                    55.7463075
                ],
                [
                    90.3700832,
                    55.7459379
                ],
                [
                    90.3700384,
                    55.745629
                ],
                [
                    90.36982,
                    55.7453548
                ],
                [
                    90.368409,
                    55.7444251
                ],
                [
                    90.3628943,
                    55.7408498
                ],
                [
                    90.3612313,
                    55.7418647
                ],
                [
                    90.3596299,
                    55.7429931
                ],
                [
                    90.3583757,
                    55.7440301
                ],
                [
                    90.3581782,
                    55.7440127
                ],
                [
                    90.3581237,
                    55.7439954
                ],
                [
                    90.3571811,
                    55.7437925
                ],
                [
                    90.353909,
                    55.7427041
                ],
                [
                    90.351818,
                    55.7416945
                ],
                [
                    90.3514681,
                    55.7414877
                ],
                [
                    90.3509956,
                    55.7414434
                ],
                [
                    90.3502607,
                    55.741601
                ],
                [
                    90.3496833,
                    55.7419014
                ],
                [
                    90.3496133,
                    55.742187
                ],
                [
                    90.3493858,
                    55.7423643
                ],
                [
                    90.3490621,
                    55.742384
                ],
                [
                    90.3490359,
                    55.7426204
                ],
                [
                    90.3491234,
                    55.7430932
                ],
                [
                    90.348511,
                    55.7437236
                ],
                [
                    90.3485022,
                    55.7440043
                ],
                [
                    90.3481173,
                    55.7442801
                ],
                [
                    90.3475748,
                    55.7443933
                ],
                [
                    90.3472686,
                    55.7443785
                ]
            ],
            "longitude": 90.366371,
            "latitude": 55.747974
        },
        "278": {
            "name": "Удачное",
            "population": 131,
            "type": "village",
            "poly": [
                [
                    90.3645684,
                    56.6797952
                ],
                [
                    90.3645684,
                    56.6799541
                ],
                [
                    90.3653922,
                    56.6805722
                ],
                [
                    90.3664018,
                    56.68109
                ],
                [
                    90.3668087,
                    56.6814578
                ],
                [
                    90.3682613,
                    56.6820039
                ],
                [
                    90.3706308,
                    56.6827791
                ],
                [
                    90.3713004,
                    56.6830988
                ],
                [
                    90.37214,
                    56.6833082
                ],
                [
                    90.3732629,
                    56.6838203
                ],
                [
                    90.3737419,
                    56.6837411
                ],
                [
                    90.3748236,
                    56.684024
                ],
                [
                    90.3750349,
                    56.6839618
                ],
                [
                    90.376472,
                    56.6843013
                ],
                [
                    90.3776104,
                    56.6842617
                ],
                [
                    90.379542,
                    56.6847964
                ],
                [
                    90.3802374,
                    56.6849435
                ],
                [
                    90.3805207,
                    56.6848388
                ],
                [
                    90.3808607,
                    56.6849463
                ],
                [
                    90.3810358,
                    56.6848275
                ],
                [
                    90.3810822,
                    56.6846238
                ],
                [
                    90.3810719,
                    56.6843522
                ],
                [
                    90.3814067,
                    56.6842815
                ],
                [
                    90.381793,
                    56.6844427
                ],
                [
                    90.3816539,
                    56.6848614
                ],
                [
                    90.3824729,
                    56.6848671
                ],
                [
                    90.382751,
                    56.6847568
                ],
                [
                    90.3829932,
                    56.6847652
                ],
                [
                    90.3829108,
                    56.684918
                ],
                [
                    90.3834619,
                    56.6850567
                ],
                [
                    90.3834619,
                    56.6849322
                ],
                [
                    90.3841522,
                    56.6849803
                ],
                [
                    90.3840852,
                    56.6851302
                ],
                [
                    90.3841161,
                    56.6851698
                ],
                [
                    90.3843684,
                    56.6851755
                ],
                [
                    90.3853884,
                    56.6849067
                ],
                [
                    90.3857644,
                    56.6847879
                ],
                [
                    90.3857799,
                    56.6846379
                ],
                [
                    90.3856769,
                    56.6843465
                ],
                [
                    90.3855172,
                    56.6840976
                ],
                [
                    90.3862744,
                    56.6835826
                ],
                [
                    90.3857335,
                    56.6834016
                ],
                [
                    90.3853163,
                    56.6832629
                ],
                [
                    90.3849454,
                    56.6829772
                ],
                [
                    90.3844818,
                    56.6824622
                ],
                [
                    90.3845128,
                    56.6820124
                ],
                [
                    90.3844406,
                    56.6816049
                ],
                [
                    90.3844355,
                    56.6811466
                ],
                [
                    90.3847652,
                    56.6809457
                ],
                [
                    90.3854296,
                    56.6801732
                ],
                [
                    90.385816,
                    56.6797884
                ],
                [
                    90.3860581,
                    56.6794658
                ],
                [
                    90.386022,
                    56.6791235
                ],
                [
                    90.3857902,
                    56.6788716
                ],
                [
                    90.3855686,
                    56.6787952
                ],
                [
                    90.3847497,
                    56.6784925
                ],
                [
                    90.3843119,
                    56.6784981
                ],
                [
                    90.3838534,
                    56.6785773
                ],
                [
                    90.3835753,
                    56.6785462
                ],
                [
                    90.3839461,
                    56.6784274
                ],
                [
                    90.3835959,
                    56.6782774
                ],
                [
                    90.3838998,
                    56.6781557
                ],
                [
                    90.3835444,
                    56.6779888
                ],
                [
                    90.3838277,
                    56.6775219
                ],
                [
                    90.383601,
                    56.6774738
                ],
                [
                    90.384317,
                    56.6765711
                ],
                [
                    90.3827975,
                    56.6762655
                ],
                [
                    90.3824163,
                    56.6767126
                ],
                [
                    90.3816384,
                    56.6766192
                ],
                [
                    90.381077,
                    56.6765088
                ],
                [
                    90.3813655,
                    56.6756514
                ],
                [
                    90.3816384,
                    56.6751024
                ],
                [
                    90.3809069,
                    56.6749694
                ],
                [
                    90.3807989,
                    56.6751392
                ],
                [
                    90.3787797,
                    56.6748109
                ],
                [
                    90.3786457,
                    56.6750345
                ],
                [
                    90.3756427,
                    56.6743072
                ],
                [
                    90.37538,
                    56.6746666
                ],
                [
                    90.3729404,
                    56.6741078
                ],
                [
                    90.371802,
                    56.674954
                ],
                [
                    90.3713128,
                    56.6748429
                ],
                [
                    90.3710938,
                    56.6745988
                ],
                [
                    90.3710037,
                    56.6744361
                ],
                [
                    90.3691687,
                    56.6753735
                ],
                [
                    90.3684539,
                    56.6760314
                ],
                [
                    90.3679131,
                    56.6763604
                ],
                [
                    90.367501,
                    56.6768945
                ],
                [
                    90.3659686,
                    56.6787727
                ],
                [
                    90.3651251,
                    56.6793386
                ],
                [
                    90.3645684,
                    56.6797952
                ]
            ],
            "longitude": 90.377283,
            "latitude": 56.679838
        },
        "279": {
            "name": "Солгон",
            "population": 1345,
            "type": "village",
            "poly": [
                [
                    90.3682556,
                    55.5297015
                ],
                [
                    90.3693684,
                    55.5308352
                ],
                [
                    90.3717424,
                    55.5302894
                ],
                [
                    90.3755259,
                    55.5317169
                ],
                [
                    90.3787159,
                    55.5359573
                ],
                [
                    90.3825737,
                    55.5369649
                ],
                [
                    90.3836865,
                    55.5417923
                ],
                [
                    90.3883603,
                    55.5448144
                ],
                [
                    90.3942211,
                    55.5460736
                ],
                [
                    90.3956306,
                    55.5452342
                ],
                [
                    90.3935595,
                    55.5411023
                ],
                [
                    90.3978939,
                    55.5399319
                ],
                [
                    90.4020224,
                    55.5386789
                ],
                [
                    90.4023314,
                    55.5357842
                ],
                [
                    90.3993102,
                    55.5346767
                ],
                [
                    90.3984347,
                    55.5330495
                ],
                [
                    90.3963233,
                    55.5325443
                ],
                [
                    90.3945123,
                    55.5324763
                ],
                [
                    90.3929673,
                    55.5327969
                ],
                [
                    90.3913709,
                    55.5323792
                ],
                [
                    90.3894654,
                    55.5318011
                ],
                [
                    90.3875686,
                    55.5291391
                ],
                [
                    90.3922635,
                    55.5260688
                ],
                [
                    90.3968683,
                    55.522861
                ],
                [
                    90.4003852,
                    55.5213268
                ],
                [
                    90.4011577,
                    55.5205518
                ],
                [
                    90.4005547,
                    55.5203647
                ],
                [
                    90.3997243,
                    55.5202542
                ],
                [
                    90.3987223,
                    55.5200525
                ],
                [
                    90.397435,
                    55.5200244
                ],
                [
                    90.3916626,
                    55.5198445
                ],
                [
                    90.3889554,
                    55.5196965
                ],
                [
                    90.3879742,
                    55.5195036
                ],
                [
                    90.3856502,
                    55.518878
                ],
                [
                    90.3840216,
                    55.5183441
                ],
                [
                    90.3822728,
                    55.5176121
                ],
                [
                    90.3725037,
                    55.5173319
                ],
                [
                    90.3717424,
                    55.5238227
                ],
                [
                    90.3691458,
                    55.5260484
                ],
                [
                    90.3682556,
                    55.5297015
                ]
            ],
            "longitude": 90.379555,
            "latitude": 55.524128
        },
        "280": {
            "name": "Степной",
            "population": 1840,
            "type": "village",
            "poly": [
                [
                    90.4085006,
                    55.6988831
                ],
                [
                    90.4093142,
                    55.699603
                ],
                [
                    90.4163571,
                    55.7031033
                ],
                [
                    90.417127,
                    55.7033547
                ],
                [
                    90.4186843,
                    55.7018265
                ],
                [
                    90.4188523,
                    55.7018681
                ],
                [
                    90.4189707,
                    55.7019091
                ],
                [
                    90.4183739,
                    55.7024679
                ],
                [
                    90.4207536,
                    55.7032567
                ],
                [
                    90.4208061,
                    55.7033947
                ],
                [
                    90.4241481,
                    55.7045039
                ],
                [
                    90.4273502,
                    55.7056476
                ],
                [
                    90.4276827,
                    55.7057067
                ],
                [
                    90.4308569,
                    55.7068799
                ],
                [
                    90.4329621,
                    55.7075192
                ],
                [
                    90.4430233,
                    55.7117705
                ],
                [
                    90.4502024,
                    55.7077368
                ],
                [
                    90.4436223,
                    55.7036408
                ],
                [
                    90.4461682,
                    55.7005694
                ],
                [
                    90.4403183,
                    55.6996429
                ],
                [
                    90.4405807,
                    55.699267
                ],
                [
                    90.439509,
                    55.6988356
                ],
                [
                    90.4392684,
                    55.6992855
                ],
                [
                    90.4376498,
                    55.6989034
                ],
                [
                    90.4372233,
                    55.6992177
                ],
                [
                    90.4329013,
                    55.697746
                ],
                [
                    90.43347,
                    55.6974933
                ],
                [
                    90.4336668,
                    55.6972653
                ],
                [
                    90.4338856,
                    55.6967167
                ],
                [
                    90.4342793,
                    55.6961312
                ],
                [
                    90.4340059,
                    55.695897
                ],
                [
                    90.4328138,
                    55.6952807
                ],
                [
                    90.4345855,
                    55.694276
                ],
                [
                    90.4310859,
                    55.6921433
                ],
                [
                    90.4292049,
                    55.6934192
                ],
                [
                    90.4286485,
                    55.6933141
                ],
                [
                    90.4251635,
                    55.6923193
                ],
                [
                    90.4239989,
                    55.6921477
                ],
                [
                    90.4222564,
                    55.6920997
                ],
                [
                    90.4085006,
                    55.6988831
                ]
            ],
            "longitude": 90.427856,
            "latitude": 55.700928
        },
        "281": {
            "name": "Причулымский",
            "population": 706,
            "type": "village",
            "poly": [
                [
                    90.4230785,
                    56.393543
                ],
                [
                    90.4238807,
                    56.393824
                ],
                [
                    90.4243064,
                    56.3944945
                ],
                [
                    90.423848,
                    56.3947211
                ],
                [
                    90.4239953,
                    56.3951288
                ],
                [
                    90.4255998,
                    56.396633
                ],
                [
                    90.4282193,
                    56.3976659
                ],
                [
                    90.4314774,
                    56.3958719
                ],
                [
                    90.4318867,
                    56.3958719
                ],
                [
                    90.4323124,
                    56.3954641
                ],
                [
                    90.4344244,
                    56.3958447
                ],
                [
                    90.4346373,
                    56.3956634
                ],
                [
                    90.4357997,
                    56.3959353
                ],
                [
                    90.4367329,
                    56.3947936
                ],
                [
                    90.4374533,
                    56.3949657
                ],
                [
                    90.4384356,
                    56.3939508
                ],
                [
                    90.4395325,
                    56.3931624
                ],
                [
                    90.440433,
                    56.3933618
                ],
                [
                    90.4421684,
                    56.3920025
                ],
                [
                    90.4400237,
                    56.3912866
                ],
                [
                    90.4384029,
                    56.3905707
                ],
                [
                    90.4367493,
                    56.389456
                ],
                [
                    90.4364709,
                    56.3886131
                ],
                [
                    90.4355705,
                    56.388169
                ],
                [
                    90.4351775,
                    56.3870452
                ],
                [
                    90.4356851,
                    56.3852144
                ],
                [
                    90.4348501,
                    56.3844439
                ],
                [
                    90.4344408,
                    56.3818697
                ],
                [
                    90.4328527,
                    56.3797848
                ],
                [
                    90.4316084,
                    56.3794131
                ],
                [
                    90.4282685,
                    56.3792953
                ],
                [
                    90.4276463,
                    56.380229
                ],
                [
                    90.42429,
                    56.3847702
                ],
                [
                    90.4235205,
                    56.3858579
                ],
                [
                    90.4237006,
                    56.38816
                ],
                [
                    90.4233732,
                    56.3901085
                ],
                [
                    90.4240281,
                    56.3908607
                ],
                [
                    90.4239298,
                    56.3910419
                ],
                [
                    90.4238971,
                    56.3924103
                ],
                [
                    90.4230785,
                    56.393543
                ]
            ],
            "longitude": 90.429695,
            "latitude": 56.387722
        },
        "282": {
            "name": "Малый Улуй",
            "population": 430,
            "type": "village",
            "poly": [
                [
                    90.4191563,
                    56.110768
                ],
                [
                    90.4195186,
                    56.113052
                ],
                [
                    90.420689,
                    56.1144348
                ],
                [
                    90.4239051,
                    56.1146436
                ],
                [
                    90.4223223,
                    56.1149046
                ],
                [
                    90.4229019,
                    56.1159859
                ],
                [
                    90.4218319,
                    56.1169305
                ],
                [
                    90.4246408,
                    56.1184716
                ],
                [
                    90.4242173,
                    56.1187574
                ],
                [
                    90.4253096,
                    56.1202115
                ],
                [
                    90.4263797,
                    56.1201369
                ],
                [
                    90.4282078,
                    56.1204103
                ],
                [
                    90.4292283,
                    56.1214105
                ],
                [
                    90.4291375,
                    56.1215797
                ],
                [
                    90.4289095,
                    56.121542
                ],
                [
                    90.4286104,
                    56.1215341
                ],
                [
                    90.4283327,
                    56.1216174
                ],
                [
                    90.4277377,
                    56.1219051
                ],
                [
                    90.4271377,
                    56.122262
                ],
                [
                    90.4270708,
                    56.1226223
                ],
                [
                    90.4285422,
                    56.1248963
                ],
                [
                    90.4291887,
                    56.1251076
                ],
                [
                    90.4297014,
                    56.1248591
                ],
                [
                    90.4327779,
                    56.125207
                ],
                [
                    90.4360996,
                    56.1292079
                ],
                [
                    90.4385741,
                    56.1290961
                ],
                [
                    90.4389085,
                    56.1297173
                ],
                [
                    90.4408927,
                    56.129357
                ],
                [
                    90.4409595,
                    56.1286736
                ],
                [
                    90.4396888,
                    56.1254182
                ],
                [
                    90.438262,
                    56.1235543
                ],
                [
                    90.435297,
                    56.1211932
                ],
                [
                    90.4312401,
                    56.1209119
                ],
                [
                    90.4305682,
                    56.120357
                ],
                [
                    90.4287146,
                    56.1206179
                ],
                [
                    90.4279362,
                    56.1197412
                ],
                [
                    90.4277671,
                    56.119313
                ],
                [
                    90.4302751,
                    56.118412
                ],
                [
                    90.4342879,
                    56.1172313
                ],
                [
                    90.4335634,
                    56.1159108
                ],
                [
                    90.4325323,
                    56.1159884
                ],
                [
                    90.4309997,
                    56.113658
                ],
                [
                    90.4279901,
                    56.1140308
                ],
                [
                    90.4272934,
                    56.1142328
                ],
                [
                    90.4256214,
                    56.1117935
                ],
                [
                    90.4262066,
                    56.1115604
                ],
                [
                    90.4262902,
                    56.1107991
                ],
                [
                    90.4253985,
                    56.110768
                ],
                [
                    90.423615,
                    56.1100377
                ],
                [
                    90.423197,
                    56.1099911
                ],
                [
                    90.4191563,
                    56.110768
                ]
            ],
            "longitude": 90.432739,
            "latitude": 56.122009
        },
        "283": {
            "name": "Преображенский",
            "population": 1708,
            "type": "village",
            "poly": [
                [
                    90.4220992,
                    55.9306177
                ],
                [
                    90.4224398,
                    55.9334233
                ],
                [
                    90.4227678,
                    55.9343702
                ],
                [
                    90.4233985,
                    55.9346776
                ],
                [
                    90.427303,
                    55.935469
                ],
                [
                    90.4273471,
                    55.9358046
                ],
                [
                    90.4275805,
                    55.9360943
                ],
                [
                    90.4283564,
                    55.9363311
                ],
                [
                    90.4325194,
                    55.9370624
                ],
                [
                    90.4320905,
                    55.9372602
                ],
                [
                    90.4321788,
                    55.9379527
                ],
                [
                    90.4325762,
                    55.9380057
                ],
                [
                    90.4340617,
                    55.93796
                ],
                [
                    90.4346215,
                    55.9384281
                ],
                [
                    90.4352995,
                    55.9391876
                ],
                [
                    90.4354336,
                    55.9403887
                ],
                [
                    90.435276,
                    55.9411217
                ],
                [
                    90.4347635,
                    55.9427953
                ],
                [
                    90.4348975,
                    55.9433295
                ],
                [
                    90.4354415,
                    55.9438594
                ],
                [
                    90.4357333,
                    55.9443407
                ],
                [
                    90.4356386,
                    55.9448308
                ],
                [
                    90.4356623,
                    55.9474181
                ],
                [
                    90.4350946,
                    55.9481509
                ],
                [
                    90.4350946,
                    55.9485969
                ],
                [
                    90.435481,
                    55.9491973
                ],
                [
                    90.4359777,
                    55.949524
                ],
                [
                    90.4380198,
                    55.9478419
                ],
                [
                    90.4401802,
                    55.9464821
                ],
                [
                    90.4422775,
                    55.945418
                ],
                [
                    90.4432709,
                    55.945078
                ],
                [
                    90.4441067,
                    55.9450869
                ],
                [
                    90.4463707,
                    55.9452503
                ],
                [
                    90.4473007,
                    55.9455242
                ],
                [
                    90.4474979,
                    55.9451999
                ],
                [
                    90.4479414,
                    55.9448343
                ],
                [
                    90.4484465,
                    55.9443514
                ],
                [
                    90.4488284,
                    55.9437856
                ],
                [
                    90.4456569,
                    55.941443
                ],
                [
                    90.4457455,
                    55.9412666
                ],
                [
                    90.4461931,
                    55.9409352
                ],
                [
                    90.4461221,
                    55.9405157
                ],
                [
                    90.4465558,
                    55.9399152
                ],
                [
                    90.4469579,
                    55.9396016
                ],
                [
                    90.4474231,
                    55.9395222
                ],
                [
                    90.4494494,
                    55.9395486
                ],
                [
                    90.4501669,
                    55.9396988
                ],
                [
                    90.4506794,
                    55.9399284
                ],
                [
                    90.4511761,
                    55.9400388
                ],
                [
                    90.4542431,
                    55.9393014
                ],
                [
                    90.4544561,
                    55.9389834
                ],
                [
                    90.4539357,
                    55.9385109
                ],
                [
                    90.4542431,
                    55.9381311
                ],
                [
                    90.4566165,
                    55.9364795
                ],
                [
                    90.458146,
                    55.9345098
                ],
                [
                    90.4586034,
                    55.933781
                ],
                [
                    90.4590923,
                    55.9335602
                ],
                [
                    90.4602513,
                    55.9335072
                ],
                [
                    90.4621909,
                    55.9331141
                ],
                [
                    90.4633026,
                    55.9326725
                ],
                [
                    90.4644617,
                    55.9315197
                ],
                [
                    90.4645957,
                    55.9295188
                ],
                [
                    90.4627744,
                    55.9302079
                ],
                [
                    90.4619938,
                    55.9303625
                ],
                [
                    90.4607401,
                    55.9303271
                ],
                [
                    90.4576493,
                    55.9296425
                ],
                [
                    90.4563642,
                    55.9291831
                ],
                [
                    90.4554969,
                    55.929161
                ],
                [
                    90.4549528,
                    55.9292317
                ],
                [
                    90.4541407,
                    55.9297441
                ],
                [
                    90.4515782,
                    55.9290462
                ],
                [
                    90.4498357,
                    55.9287193
                ],
                [
                    90.4456017,
                    55.9277211
                ],
                [
                    90.4459644,
                    55.9260336
                ],
                [
                    90.4452114,
                    55.925841
                ],
                [
                    90.4448203,
                    55.9255406
                ],
                [
                    90.4440382,
                    55.9228582
                ],
                [
                    90.4433128,
                    55.922063
                ],
                [
                    90.442764,
                    55.9220842
                ],
                [
                    90.4410042,
                    55.9222786
                ],
                [
                    90.4399445,
                    55.9226073
                ],
                [
                    90.4390677,
                    55.9229854
                ],
                [
                    90.4393264,
                    55.9247313
                ],
                [
                    90.4397048,
                    55.9253816
                ],
                [
                    90.44014,
                    55.9254982
                ],
                [
                    90.439894,
                    55.9264488
                ],
                [
                    90.4393705,
                    55.9273959
                ],
                [
                    90.4384748,
                    55.9275161
                ],
                [
                    90.4351759,
                    55.9279755
                ],
                [
                    90.4352128,
                    55.9280417
                ],
                [
                    90.4333647,
                    55.9282785
                ],
                [
                    90.4296368,
                    55.9288439
                ],
                [
                    90.4286402,
                    55.9290771
                ],
                [
                    90.4280536,
                    55.9292573
                ],
                [
                    90.4252592,
                    55.9265292
                ],
                [
                    90.4243762,
                    55.9268402
                ],
                [
                    90.4227614,
                    55.9273067
                ],
                [
                    90.4242564,
                    55.9290806
                ],
                [
                    90.4251205,
                    55.929593
                ],
                [
                    90.4248998,
                    55.9297485
                ],
                [
                    90.4231462,
                    55.9302361
                ],
                [
                    90.4220992,
                    55.9306177
                ]
            ],
            "longitude": 90.436195,
            "latitude": 55.93396
        },
        "284": {
            "name": "Жгутово",
            "population": 390,
            "type": "village",
            "poly": [
                [
                    90.4259225,
                    55.6668968
                ],
                [
                    90.430111,
                    55.6695983
                ],
                [
                    90.4304063,
                    55.6699129
                ],
                [
                    90.4304172,
                    55.671023
                ],
                [
                    90.4301657,
                    55.6713067
                ],
                [
                    90.4298704,
                    55.6747047
                ],
                [
                    90.4312484,
                    55.6754386
                ],
                [
                    90.4314233,
                    55.6758086
                ],
                [
                    90.4325826,
                    55.6758086
                ],
                [
                    90.4349229,
                    55.6760306
                ],
                [
                    90.4348682,
                    55.6776647
                ],
                [
                    90.4370554,
                    55.67801
                ],
                [
                    90.4372414,
                    55.6768076
                ],
                [
                    90.4383568,
                    55.6743717
                ],
                [
                    90.4386193,
                    55.6744087
                ],
                [
                    90.4388162,
                    55.6741621
                ],
                [
                    90.4398332,
                    55.6736749
                ],
                [
                    90.44038,
                    55.6731569
                ],
                [
                    90.4408393,
                    55.6729657
                ],
                [
                    90.4416267,
                    55.6729718
                ],
                [
                    90.4423485,
                    55.673274
                ],
                [
                    90.4426985,
                    55.6738661
                ],
                [
                    90.4426001,
                    55.6741929
                ],
                [
                    90.4428953,
                    55.6742607
                ],
                [
                    90.4435077,
                    55.6740757
                ],
                [
                    90.4441967,
                    55.6735392
                ],
                [
                    90.444317,
                    55.6729102
                ],
                [
                    90.4433546,
                    55.6716644
                ],
                [
                    90.4433656,
                    55.670986
                ],
                [
                    90.4441639,
                    55.6702583
                ],
                [
                    90.442611,
                    55.6699684
                ],
                [
                    90.4415174,
                    55.6696353
                ],
                [
                    90.4404456,
                    55.6689507
                ],
                [
                    90.4391661,
                    55.6685128
                ],
                [
                    90.4353057,
                    55.6669215
                ],
                [
                    90.4346427,
                    55.6670301
                ],
                [
                    90.4344198,
                    55.6670695
                ],
                [
                    90.4330419,
                    55.6661937
                ],
                [
                    90.4286674,
                    55.6649724
                ],
                [
                    90.4259225,
                    55.6668968
                ]
            ],
            "longitude": 90.436264,
            "latitude": 55.672482
        },
        "285": {
            "name": "Зачулымка",
            "population": 129,
            "type": "village",
            "poly": [
                [
                    90.4433418,
                    56.8952888
                ],
                [
                    90.443526,
                    56.8964731
                ],
                [
                    90.4439276,
                    56.8971387
                ],
                [
                    90.4467734,
                    56.8969406
                ],
                [
                    90.4472839,
                    56.8963671
                ],
                [
                    90.4499881,
                    56.8948715
                ],
                [
                    90.451245,
                    56.8945215
                ],
                [
                    90.4517499,
                    56.894732
                ],
                [
                    90.4522194,
                    56.8946086
                ],
                [
                    90.4534949,
                    56.8944562
                ],
                [
                    90.457255,
                    56.8923299
                ],
                [
                    90.4580566,
                    56.8921363
                ],
                [
                    90.4611214,
                    56.8907332
                ],
                [
                    90.4616528,
                    56.8903849
                ],
                [
                    90.461923,
                    56.8898188
                ],
                [
                    90.4638937,
                    56.8886575
                ],
                [
                    90.4637122,
                    56.8885994
                ],
                [
                    90.4632871,
                    56.8885825
                ],
                [
                    90.4631896,
                    56.8885002
                ],
                [
                    90.4634554,
                    56.8883139
                ],
                [
                    90.4639204,
                    56.8882535
                ],
                [
                    90.464381,
                    56.8882365
                ],
                [
                    90.4649213,
                    56.8883018
                ],
                [
                    90.4657451,
                    56.8885099
                ],
                [
                    90.4664227,
                    56.8885873
                ],
                [
                    90.4674502,
                    56.8885801
                ],
                [
                    90.4681322,
                    56.8885196
                ],
                [
                    90.4717727,
                    56.8869567
                ],
                [
                    90.4700455,
                    56.8849243
                ],
                [
                    90.4674463,
                    56.8840601
                ],
                [
                    90.4670742,
                    56.8843814
                ],
                [
                    90.4669714,
                    56.8843508
                ],
                [
                    90.4668652,
                    56.8843349
                ],
                [
                    90.4668794,
                    56.8842227
                ],
                [
                    90.4665179,
                    56.8838646
                ],
                [
                    90.4642327,
                    56.8841762
                ],
                [
                    90.4634532,
                    56.8840872
                ],
                [
                    90.4619014,
                    56.8842459
                ],
                [
                    90.4609129,
                    56.8841956
                ],
                [
                    90.4601688,
                    56.8844724
                ],
                [
                    90.4600023,
                    56.8849021
                ],
                [
                    90.4597968,
                    56.8850957
                ],
                [
                    90.4592689,
                    56.8852234
                ],
                [
                    90.4585284,
                    56.8855351
                ],
                [
                    90.4580749,
                    56.8856125
                ],
                [
                    90.457724,
                    56.8855331
                ],
                [
                    90.4570935,
                    56.8853324
                ],
                [
                    90.4561799,
                    56.8858676
                ],
                [
                    90.4559237,
                    56.886015
                ],
                [
                    90.4552111,
                    56.8862456
                ],
                [
                    90.4544775,
                    56.8863515
                ],
                [
                    90.4541523,
                    56.8864195
                ],
                [
                    90.4541016,
                    56.8866493
                ],
                [
                    90.4535347,
                    56.88675
                ],
                [
                    90.453342,
                    56.8869435
                ],
                [
                    90.4528998,
                    56.8869869
                ],
                [
                    90.4521487,
                    56.8872037
                ],
                [
                    90.4508505,
                    56.8879112
                ],
                [
                    90.4509214,
                    56.8882658
                ],
                [
                    90.4501787,
                    56.8885631
                ],
                [
                    90.4494588,
                    56.8891143
                ],
                [
                    90.4491524,
                    56.8898023
                ],
                [
                    90.4499425,
                    56.8901197
                ],
                [
                    90.4488901,
                    56.8908997
                ],
                [
                    90.4483694,
                    56.8907216
                ],
                [
                    90.4481285,
                    56.8910681
                ],
                [
                    90.4477777,
                    56.891188
                ],
                [
                    90.4471045,
                    56.8917377
                ],
                [
                    90.4474305,
                    56.8919022
                ],
                [
                    90.4469911,
                    56.892148
                ],
                [
                    90.4461727,
                    56.8922447
                ],
                [
                    90.4459105,
                    56.8926879
                ],
                [
                    90.4446066,
                    56.8928892
                ],
                [
                    90.4445783,
                    56.8931175
                ],
                [
                    90.4449963,
                    56.8932956
                ],
                [
                    90.4451523,
                    56.8934659
                ],
                [
                    90.4450743,
                    56.8936052
                ],
                [
                    90.444883,
                    56.8937
                ],
                [
                    90.4445074,
                    56.8937484
                ],
                [
                    90.4442665,
                    56.8940193
                ],
                [
                    90.4439583,
                    56.8941393
                ],
                [
                    90.4438378,
                    56.8943077
                ],
                [
                    90.4439618,
                    56.8945205
                ],
                [
                    90.4440646,
                    56.8948747
                ],
                [
                    90.4438909,
                    56.8950527
                ],
                [
                    90.4433418,
                    56.8952888
                ]
            ],
            "longitude": 90.4561979,
            "latitude": 56.888825
        },
        "286": {
            "name": "Тарханка",
            "population": 278,
            "type": "village",
            "poly": null,
            "longitude": 90.461548,
            "latitude": 55.594379
        },
        "287": {
            "name": "Медведск",
            "population": 502,
            "type": "village",
            "poly": [
                [
                    90.4746122,
                    55.6834162
                ],
                [
                    90.4750385,
                    55.6837452
                ],
                [
                    90.4758321,
                    55.6842296
                ],
                [
                    90.4772667,
                    55.6853344
                ],
                [
                    90.4785988,
                    55.6872696
                ],
                [
                    90.4798797,
                    55.6887136
                ],
                [
                    90.4802511,
                    55.6893923
                ],
                [
                    90.4824151,
                    55.6914977
                ],
                [
                    90.4828064,
                    55.6921241
                ],
                [
                    90.4829633,
                    55.6928058
                ],
                [
                    90.4833605,
                    55.6932989
                ],
                [
                    90.4843482,
                    55.6935261
                ],
                [
                    90.4874223,
                    55.6948888
                ],
                [
                    90.4882549,
                    55.6950512
                ],
                [
                    90.490032,
                    55.6958272
                ],
                [
                    90.4907335,
                    55.6958213
                ],
                [
                    90.4916942,
                    55.6956841
                ],
                [
                    90.4932993,
                    55.6955643
                ],
                [
                    90.493078,
                    55.6953979
                ],
                [
                    90.492996,
                    55.6951762
                ],
                [
                    90.4931846,
                    55.6950838
                ],
                [
                    90.4941929,
                    55.6948759
                ],
                [
                    90.4940125,
                    55.6946495
                ],
                [
                    90.4933649,
                    55.6945062
                ],
                [
                    90.4930862,
                    55.6942614
                ],
                [
                    90.492955,
                    55.6940304
                ],
                [
                    90.4931764,
                    55.693938
                ],
                [
                    90.4931682,
                    55.6937485
                ],
                [
                    90.4928977,
                    55.6936145
                ],
                [
                    90.4926271,
                    55.6934667
                ],
                [
                    90.4925452,
                    55.6931664
                ],
                [
                    90.4919467,
                    55.693037
                ],
                [
                    90.4916434,
                    55.6929261
                ],
                [
                    90.4917172,
                    55.692635
                ],
                [
                    90.4920943,
                    55.692538
                ],
                [
                    90.492578,
                    55.692404
                ],
                [
                    90.4928075,
                    55.6921545
                ],
                [
                    90.4927747,
                    55.6919512
                ],
                [
                    90.4930288,
                    55.6917155
                ],
                [
                    90.4935487,
                    55.6916091
                ],
                [
                    90.4936998,
                    55.6914458
                ],
                [
                    90.4943964,
                    55.6910886
                ],
                [
                    90.4944889,
                    55.6912069
                ],
                [
                    90.4946903,
                    55.6912921
                ],
                [
                    90.4948876,
                    55.6911312
                ],
                [
                    90.4950261,
                    55.6910034
                ],
                [
                    90.4952276,
                    55.6910295
                ],
                [
                    90.4954416,
                    55.6909585
                ],
                [
                    90.495769,
                    55.69102
                ],
                [
                    90.4962391,
                    55.6912164
                ],
                [
                    90.4962727,
                    55.6914269
                ],
                [
                    90.4964951,
                    55.6915381
                ],
                [
                    90.4968183,
                    55.6915925
                ],
                [
                    90.4971667,
                    55.691557
                ],
                [
                    90.4974227,
                    55.6915973
                ],
                [
                    90.4975948,
                    55.6919001
                ],
                [
                    90.4982285,
                    55.6921508
                ],
                [
                    90.4984006,
                    55.6921177
                ],
                [
                    90.4985265,
                    55.6917037
                ],
                [
                    90.4989085,
                    55.6917487
                ],
                [
                    90.4992023,
                    55.691602
                ],
                [
                    90.4993996,
                    55.6911856
                ],
                [
                    90.4996472,
                    55.6911194
                ],
                [
                    90.4996017,
                    55.6907781
                ],
                [
                    90.4998373,
                    55.690212
                ],
                [
                    90.498934,
                    55.6902783
                ],
                [
                    90.4978978,
                    55.6904558
                ],
                [
                    90.4990586,
                    55.6889993
                ],
                [
                    90.4999177,
                    55.6882747
                ],
                [
                    90.5006063,
                    55.6872212
                ],
                [
                    90.5012359,
                    55.6866666
                ],
                [
                    90.5014916,
                    55.6859679
                ],
                [
                    90.5002065,
                    55.6855379
                ],
                [
                    90.4988097,
                    55.684902
                ],
                [
                    90.4975474,
                    55.6845123
                ],
                [
                    90.496757,
                    55.6843474
                ],
                [
                    90.4952158,
                    55.6835636
                ],
                [
                    90.4893201,
                    55.6808905
                ],
                [
                    90.4870248,
                    55.6798071
                ],
                [
                    90.485982,
                    55.6794669
                ],
                [
                    90.4856803,
                    55.6795076
                ],
                [
                    90.4841785,
                    55.6803322
                ],
                [
                    90.4838703,
                    55.6805688
                ],
                [
                    90.4801453,
                    55.6822992
                ],
                [
                    90.4793931,
                    55.6824364
                ],
                [
                    90.4777601,
                    55.6825325
                ],
                [
                    90.4769993,
                    55.6825104
                ],
                [
                    90.4763304,
                    55.6825843
                ],
                [
                    90.4756156,
                    55.6828579
                ],
                [
                    90.4746122,
                    55.6834162
                ]
            ],
            "longitude": 90.491364,
            "latitude": 55.687687
        },
        "288": {
            "name": "Ключи",
            "population": 1015,
            "type": "village",
            "poly": [
                [
                    90.4674262,
                    56.1660504
                ],
                [
                    90.4692988,
                    56.1661745
                ],
                [
                    90.469388,
                    56.1673413
                ],
                [
                    90.4714167,
                    56.1672916
                ],
                [
                    90.4713275,
                    56.16893
                ],
                [
                    90.4719517,
                    56.1691658
                ],
                [
                    90.4719293,
                    56.1696871
                ],
                [
                    90.4729995,
                    56.1707421
                ],
                [
                    90.474025,
                    56.1712137
                ],
                [
                    90.4752734,
                    56.1710151
                ],
                [
                    90.476923,
                    56.1695754
                ],
                [
                    90.4771461,
                    56.1685328
                ],
                [
                    90.4775918,
                    56.1682474
                ],
                [
                    90.4787735,
                    56.1683343
                ],
                [
                    90.4804232,
                    56.1683343
                ],
                [
                    90.4847927,
                    56.166882
                ],
                [
                    90.4847704,
                    56.1665593
                ],
                [
                    90.486264,
                    56.1663235
                ],
                [
                    90.4873341,
                    56.1663731
                ],
                [
                    90.4892959,
                    56.1661125
                ],
                [
                    90.4890507,
                    56.1671303
                ],
                [
                    90.4872672,
                    56.1694389
                ],
                [
                    90.489831,
                    56.1717226
                ],
                [
                    90.4913056,
                    56.1714099
                ],
                [
                    90.4926153,
                    56.1714254
                ],
                [
                    90.4933398,
                    56.1711772
                ],
                [
                    90.4952905,
                    56.1712082
                ],
                [
                    90.4969346,
                    56.170929
                ],
                [
                    90.4986345,
                    56.1715185
                ],
                [
                    90.501867,
                    56.172077
                ],
                [
                    90.5030932,
                    56.172077
                ],
                [
                    90.5097533,
                    56.1664607
                ],
                [
                    90.5104075,
                    56.1647072
                ],
                [
                    90.5105188,
                    56.1629321
                ],
                [
                    90.502315,
                    56.1589223
                ],
                [
                    90.4992608,
                    56.1589843
                ],
                [
                    90.4988372,
                    56.1581401
                ],
                [
                    90.4981684,
                    56.1573579
                ],
                [
                    90.4961397,
                    56.157867
                ],
                [
                    90.4933308,
                    56.1580035
                ],
                [
                    90.4917257,
                    56.1583636
                ],
                [
                    90.4892959,
                    56.1584531
                ],
                [
                    90.4864424,
                    56.1593097
                ],
                [
                    90.4836557,
                    56.1608119
                ],
                [
                    90.4804009,
                    56.1612712
                ],
                [
                    90.4793085,
                    56.1618299
                ],
                [
                    90.4794646,
                    56.1620409
                ],
                [
                    90.4774359,
                    56.1627485
                ],
                [
                    90.4794646,
                    56.1648339
                ],
                [
                    90.4777703,
                    56.1654546
                ],
                [
                    90.4767224,
                    56.1642009
                ],
                [
                    90.4752511,
                    56.1632202
                ],
                [
                    90.4741811,
                    56.1635678
                ],
                [
                    90.4743594,
                    56.1650822
                ],
                [
                    90.4725981,
                    56.1653305
                ],
                [
                    90.4723975,
                    56.1642753
                ],
                [
                    90.4681619,
                    56.164325
                ],
                [
                    90.4676044,
                    56.164747
                ],
                [
                    90.4674262,
                    56.1660504
                ]
            ],
            "longitude": 90.493248,
            "latitude": 56.164299
        },
        "289": {
            "name": "Сучково",
            "population": 357,
            "type": "village",
            "poly": [
                [
                    [
                        90.4706631,
                        56.5706771
                    ],
                    [
                        90.4718451,
                        56.5710331
                    ],
                    [
                        90.4719948,
                        56.5710941
                    ],
                    [
                        90.4720143,
                        56.571235
                    ],
                    [
                        90.4718994,
                        56.5713509
                    ],
                    [
                        90.4718083,
                        56.5715063
                    ],
                    [
                        90.4720338,
                        56.5715505
                    ],
                    [
                        90.4722269,
                        56.5714597
                    ],
                    [
                        90.4732766,
                        56.5713258
                    ],
                    [
                        90.4735672,
                        56.5711789
                    ],
                    [
                        90.4739359,
                        56.5708838
                    ],
                    [
                        90.4740465,
                        56.5708312
                    ],
                    [
                        90.4750528,
                        56.5706412
                    ],
                    [
                        90.4752654,
                        56.5705636
                    ],
                    [
                        90.4754583,
                        56.5705349
                    ],
                    [
                        90.475851,
                        56.5705779
                    ],
                    [
                        90.4762348,
                        56.5705325
                    ],
                    [
                        90.4762499,
                        56.5708109
                    ],
                    [
                        90.4776966,
                        56.570885
                    ],
                    [
                        90.4776702,
                        56.5711864
                    ],
                    [
                        90.4777244,
                        56.5713395
                    ],
                    [
                        90.4779277,
                        56.5715691
                    ],
                    [
                        90.4778192,
                        56.5717222
                    ],
                    [
                        90.4775617,
                        56.5720769
                    ],
                    [
                        90.4774769,
                        56.5722748
                    ],
                    [
                        90.4773143,
                        56.5724503
                    ],
                    [
                        90.4776532,
                        56.5725044
                    ],
                    [
                        90.4781819,
                        56.5725567
                    ],
                    [
                        90.4781988,
                        56.5726986
                    ],
                    [
                        90.4785106,
                        56.572833
                    ],
                    [
                        90.478697,
                        56.572833
                    ],
                    [
                        90.4789172,
                        56.5727695
                    ],
                    [
                        90.4796831,
                        56.5727378
                    ],
                    [
                        90.4799745,
                        56.5725754
                    ],
                    [
                        90.4802219,
                        56.5725642
                    ],
                    [
                        90.4802863,
                        56.5723439
                    ],
                    [
                        90.4803948,
                        56.5722543
                    ],
                    [
                        90.4801609,
                        56.5721049
                    ],
                    [
                        90.4801203,
                        56.5719967
                    ],
                    [
                        90.4801236,
                        56.5715187
                    ],
                    [
                        90.4798661,
                        56.5713806
                    ],
                    [
                        90.4800627,
                        56.5710296
                    ],
                    [
                        90.4801372,
                        56.5707888
                    ],
                    [
                        90.4803575,
                        56.5706674
                    ],
                    [
                        90.4811538,
                        56.5707477
                    ],
                    [
                        90.4819468,
                        56.5707664
                    ],
                    [
                        90.483805,
                        56.5709429
                    ],
                    [
                        90.4843768,
                        56.5710274
                    ],
                    [
                        90.4853458,
                        56.57108
                    ],
                    [
                        90.4854676,
                        56.5711675
                    ],
                    [
                        90.486929,
                        56.5712287
                    ],
                    [
                        90.4891724,
                        56.5714333
                    ],
                    [
                        90.4896002,
                        56.571452
                    ],
                    [
                        90.4896526,
                        56.571518
                    ],
                    [
                        90.4899527,
                        56.5715945
                    ],
                    [
                        90.4899961,
                        56.571647
                    ],
                    [
                        90.4898451,
                        56.5717216
                    ],
                    [
                        90.4897862,
                        56.5718162
                    ],
                    [
                        90.4898226,
                        56.5720905
                    ],
                    [
                        90.4900204,
                        56.5722349
                    ],
                    [
                        90.4900499,
                        56.5724394
                    ],
                    [
                        90.4901037,
                        56.5725809
                    ],
                    [
                        90.4902269,
                        56.5726382
                    ],
                    [
                        90.4903726,
                        56.5726421
                    ],
                    [
                        90.4905288,
                        56.5727338
                    ],
                    [
                        90.4905583,
                        56.5728533
                    ],
                    [
                        90.4906381,
                        56.5728743
                    ],
                    [
                        90.4907856,
                        56.572837
                    ],
                    [
                        90.4909261,
                        56.5727998
                    ],
                    [
                        90.4910474,
                        56.5728208
                    ],
                    [
                        90.4910649,
                        56.5728705
                    ],
                    [
                        90.4910423,
                        56.572968
                    ],
                    [
                        90.4911222,
                        56.5729842
                    ],
                    [
                        90.4912297,
                        56.5729766
                    ],
                    [
                        90.4912957,
                        56.5729374
                    ],
                    [
                        90.4914466,
                        56.5729766
                    ],
                    [
                        90.4914657,
                        56.5730091
                    ],
                    [
                        90.4914241,
                        56.5731209
                    ],
                    [
                        90.4914466,
                        56.5731505
                    ],
                    [
                        90.4916687,
                        56.5731964
                    ],
                    [
                        90.4916982,
                        56.5732767
                    ],
                    [
                        90.4917902,
                        56.5732872
                    ],
                    [
                        90.4920209,
                        56.5732499
                    ],
                    [
                        90.4920608,
                        56.5732251
                    ],
                    [
                        90.4920417,
                        56.5731869
                    ],
                    [
                        90.4919637,
                        56.5731735
                    ],
                    [
                        90.4918891,
                        56.5731372
                    ],
                    [
                        90.491771,
                        56.5730119
                    ],
                    [
                        90.4917954,
                        56.5729804
                    ],
                    [
                        90.4918821,
                        56.5729164
                    ],
                    [
                        90.4919775,
                        56.5729106
                    ],
                    [
                        90.4922309,
                        56.5729709
                    ],
                    [
                        90.492413,
                        56.5730827
                    ],
                    [
                        90.4927548,
                        56.5730827
                    ],
                    [
                        90.4931713,
                        56.5731553
                    ],
                    [
                        90.4931208,
                        56.5732738
                    ],
                    [
                        90.4934697,
                        56.5732891
                    ],
                    [
                        90.49352,
                        56.5732633
                    ],
                    [
                        90.4934575,
                        56.5732174
                    ],
                    [
                        90.4935235,
                        56.5732041
                    ],
                    [
                        90.4936848,
                        56.5732356
                    ],
                    [
                        90.4937473,
                        56.5732834
                    ],
                    [
                        90.4937142,
                        56.573314
                    ],
                    [
                        90.4937142,
                        56.5733388
                    ],
                    [
                        90.4937594,
                        56.5733474
                    ],
                    [
                        90.4938688,
                        56.5733274
                    ],
                    [
                        90.4939781,
                        56.5732366
                    ],
                    [
                        90.4944517,
                        56.5732433
                    ],
                    [
                        90.4945888,
                        56.5733178
                    ],
                    [
                        90.4949393,
                        56.5733503
                    ],
                    [
                        90.4952308,
                        56.5733952
                    ],
                    [
                        90.4953436,
                        56.5734554
                    ],
                    [
                        90.4953557,
                        56.573529
                    ],
                    [
                        90.4955223,
                        56.5736017
                    ],
                    [
                        90.4956836,
                        56.5735883
                    ],
                    [
                        90.4960116,
                        56.5735921
                    ],
                    [
                        90.4962094,
                        56.5736189
                    ],
                    [
                        90.4964592,
                        56.5737145
                    ],
                    [
                        90.4965026,
                        56.5738655
                    ],
                    [
                        90.4972556,
                        56.574005
                    ],
                    [
                        90.4975367,
                        56.5740432
                    ],
                    [
                        90.4981179,
                        56.5740069
                    ],
                    [
                        90.4986298,
                        56.5740786
                    ],
                    [
                        90.4995459,
                        56.5742841
                    ],
                    [
                        90.4999154,
                        56.5744858
                    ],
                    [
                        90.5013677,
                        56.5749063
                    ],
                    [
                        90.5016679,
                        56.5750573
                    ],
                    [
                        90.5028799,
                        56.57557
                    ],
                    [
                        90.5031315,
                        56.5756331
                    ],
                    [
                        90.5033675,
                        56.5756388
                    ],
                    [
                        90.5036607,
                        56.5755987
                    ],
                    [
                        90.5038568,
                        56.5755471
                    ],
                    [
                        90.5049304,
                        56.5757284
                    ],
                    [
                        90.5058603,
                        56.5759957
                    ],
                    [
                        90.5064052,
                        56.5762078
                    ],
                    [
                        90.50743,
                        56.5763332
                    ],
                    [
                        90.5087312,
                        56.57649
                    ],
                    [
                        90.5091271,
                        56.5768096
                    ],
                    [
                        90.5093901,
                        56.577053
                    ],
                    [
                        90.5096313,
                        56.5771292
                    ],
                    [
                        90.5097913,
                        56.5771396
                    ],
                    [
                        90.5100542,
                        56.5770724
                    ],
                    [
                        90.5108161,
                        56.5766722
                    ],
                    [
                        90.5110789,
                        56.576219
                    ],
                    [
                        90.5118937,
                        56.5763261
                    ],
                    [
                        90.5115798,
                        56.5756275
                    ],
                    [
                        90.5115962,
                        56.575506
                    ],
                    [
                        90.5116557,
                        56.5749728
                    ],
                    [
                        90.5115777,
                        56.5747315
                    ],
                    [
                        90.5114844,
                        56.5746395
                    ],
                    [
                        90.5114237,
                        56.5741831
                    ],
                    [
                        90.5112934,
                        56.5740338
                    ],
                    [
                        90.5112307,
                        56.573882
                    ],
                    [
                        90.5076703,
                        56.5732551
                    ],
                    [
                        90.5077283,
                        56.5729729
                    ],
                    [
                        90.5074541,
                        56.5728563
                    ],
                    [
                        90.5073587,
                        56.5727741
                    ],
                    [
                        90.5074212,
                        56.5726861
                    ],
                    [
                        90.5077595,
                        56.5725237
                    ],
                    [
                        90.5077769,
                        56.5724835
                    ],
                    [
                        90.5076988,
                        56.5724329
                    ],
                    [
                        90.5077023,
                        56.5723583
                    ],
                    [
                        90.5078393,
                        56.5721805
                    ],
                    [
                        90.5078237,
                        56.5721193
                    ],
                    [
                        90.5077665,
                        56.5720649
                    ],
                    [
                        90.5065641,
                        56.5718039
                    ],
                    [
                        90.5064964,
                        56.5719702
                    ],
                    [
                        90.5061319,
                        56.5720085
                    ],
                    [
                        90.5060063,
                        56.5719253
                    ],
                    [
                        90.5034442,
                        56.5715286
                    ],
                    [
                        90.5035906,
                        56.5710388
                    ],
                    [
                        90.5033683,
                        56.5710149
                    ],
                    [
                        90.5033818,
                        56.5709059
                    ],
                    [
                        90.5024438,
                        56.5707147
                    ],
                    [
                        90.5024547,
                        56.5705504
                    ],
                    [
                        90.5026254,
                        56.5703876
                    ],
                    [
                        90.5025224,
                        56.5701501
                    ],
                    [
                        90.5006463,
                        56.5698439
                    ],
                    [
                        90.5005081,
                        56.5700904
                    ],
                    [
                        90.5001286,
                        56.5700904
                    ],
                    [
                        90.5000689,
                        56.5701427
                    ],
                    [
                        90.4997517,
                        56.5701367
                    ],
                    [
                        90.499684,
                        56.5700635
                    ],
                    [
                        90.4993288,
                        56.5700725
                    ],
                    [
                        90.4991526,
                        56.5700426
                    ],
                    [
                        90.4987405,
                        56.5699141
                    ],
                    [
                        90.4987161,
                        56.5698395
                    ],
                    [
                        90.4984965,
                        56.569829
                    ],
                    [
                        90.497854,
                        56.5696617
                    ],
                    [
                        90.4979299,
                        56.5695094
                    ],
                    [
                        90.4978052,
                        56.5694646
                    ],
                    [
                        90.4974989,
                        56.5695527
                    ],
                    [
                        90.4973308,
                        56.5695079
                    ],
                    [
                        90.4968076,
                        56.5694108
                    ],
                    [
                        90.4964931,
                        56.5694063
                    ],
                    [
                        90.4963602,
                        56.5693331
                    ],
                    [
                        90.4955822,
                        56.5693376
                    ],
                    [
                        90.4952921,
                        56.5691494
                    ],
                    [
                        90.4950915,
                        56.5691674
                    ],
                    [
                        90.4948258,
                        56.5690165
                    ],
                    [
                        90.4945654,
                        56.5689433
                    ],
                    [
                        90.4941236,
                        56.5688671
                    ],
                    [
                        90.4938959,
                        56.5691106
                    ],
                    [
                        90.493717,
                        56.5691121
                    ],
                    [
                        90.4935164,
                        56.5697245
                    ],
                    [
                        90.4924889,
                        56.5695841
                    ],
                    [
                        90.4923967,
                        56.5696528
                    ],
                    [
                        90.4923696,
                        56.5697439
                    ],
                    [
                        90.492169,
                        56.5697961
                    ],
                    [
                        90.4920199,
                        56.5697618
                    ],
                    [
                        90.491925,
                        56.5696961
                    ],
                    [
                        90.491822,
                        56.5696065
                    ],
                    [
                        90.4916729,
                        56.5696065
                    ],
                    [
                        90.4916159,
                        56.5696587
                    ],
                    [
                        90.4914885,
                        56.5698634
                    ],
                    [
                        90.4911848,
                        56.5698335
                    ],
                    [
                        90.4906915,
                        56.5700262
                    ],
                    [
                        90.4905559,
                        56.5701203
                    ],
                    [
                        90.4903472,
                        56.5701441
                    ],
                    [
                        90.4899324,
                        56.5700396
                    ],
                    [
                        90.4896884,
                        56.5700127
                    ],
                    [
                        90.489645,
                        56.5701397
                    ],
                    [
                        90.4895447,
                        56.570189
                    ],
                    [
                        90.4895717,
                        56.5703099
                    ],
                    [
                        90.4890865,
                        56.5708566
                    ],
                    [
                        90.4887965,
                        56.5708454
                    ],
                    [
                        90.4879777,
                        56.57092
                    ],
                    [
                        90.4869231,
                        56.5709171
                    ],
                    [
                        90.4869042,
                        56.5708513
                    ],
                    [
                        90.4862237,
                        56.5708394
                    ],
                    [
                        90.4858469,
                        56.5707782
                    ],
                    [
                        90.485283,
                        56.5707737
                    ],
                    [
                        90.4838542,
                        56.5706019
                    ],
                    [
                        90.4834123,
                        56.5704107
                    ],
                    [
                        90.4833934,
                        56.5703644
                    ],
                    [
                        90.4817613,
                        56.5702091
                    ],
                    [
                        90.4813492,
                        56.5702031
                    ],
                    [
                        90.4811812,
                        56.5701419
                    ],
                    [
                        90.4807854,
                        56.5701434
                    ],
                    [
                        90.4799829,
                        56.5700433
                    ],
                    [
                        90.4796765,
                        56.5700209
                    ],
                    [
                        90.4794624,
                        56.5699328
                    ],
                    [
                        90.4794597,
                        56.5698835
                    ],
                    [
                        90.47879,
                        56.5696729
                    ],
                    [
                        90.4782749,
                        56.569534
                    ],
                    [
                        90.478058,
                        56.5695908
                    ],
                    [
                        90.4778764,
                        56.5695639
                    ],
                    [
                        90.4778629,
                        56.5694982
                    ],
                    [
                        90.4778683,
                        56.5693219
                    ],
                    [
                        90.4774616,
                        56.5691711
                    ],
                    [
                        90.4770902,
                        56.5690949
                    ],
                    [
                        90.4768136,
                        56.5690904
                    ],
                    [
                        90.4766971,
                        56.5691173
                    ],
                    [
                        90.4764232,
                        56.569071
                    ],
                    [
                        90.476464,
                        56.5689665
                    ],
                    [
                        90.4763825,
                        56.5689007
                    ],
                    [
                        90.4761115,
                        56.568956
                    ],
                    [
                        90.4759569,
                        56.5689605
                    ],
                    [
                        90.4758458,
                        56.568947
                    ],
                    [
                        90.4756316,
                        56.5688425
                    ],
                    [
                        90.4755124,
                        56.568835
                    ],
                    [
                        90.4754826,
                        56.5687603
                    ],
                    [
                        90.4754175,
                        56.5687484
                    ],
                    [
                        90.4753089,
                        56.5687696
                    ],
                    [
                        90.4750507,
                        56.5689629
                    ],
                    [
                        90.474872,
                        56.5689848
                    ],
                    [
                        90.474561,
                        56.5690577
                    ],
                    [
                        90.4749316,
                        56.5693458
                    ],
                    [
                        90.4746073,
                        56.5694515
                    ],
                    [
                        90.4742696,
                        56.5695974
                    ],
                    [
                        90.4736079,
                        56.5696703
                    ],
                    [
                        90.4731115,
                        56.5696229
                    ],
                    [
                        90.4729435,
                        56.5696863
                    ],
                    [
                        90.472949,
                        56.5698825
                    ],
                    [
                        90.4724394,
                        56.5698717
                    ],
                    [
                        90.4719839,
                        56.5699339
                    ],
                    [
                        90.4706631,
                        56.5706771
                    ]
                ],
                [
                    [
                        90.440268,
                        56.577134
                    ],
                    [
                        90.4423394,
                        56.5791615
                    ],
                    [
                        90.4448556,
                        56.5783263
                    ],
                    [
                        90.4462577,
                        56.5797005
                    ],
                    [
                        90.4475115,
                        56.5799525
                    ],
                    [
                        90.4477826,
                        56.5801928
                    ],
                    [
                        90.4479436,
                        56.5802837
                    ],
                    [
                        90.4481766,
                        56.5802907
                    ],
                    [
                        90.4484942,
                        56.5802278
                    ],
                    [
                        90.4487357,
                        56.5802161
                    ],
                    [
                        90.4491254,
                        56.5802558
                    ],
                    [
                        90.4499005,
                        56.5802824
                    ],
                    [
                        90.4506291,
                        56.5800864
                    ],
                    [
                        90.4513171,
                        56.5798587
                    ],
                    [
                        90.4523574,
                        56.5794872
                    ],
                    [
                        90.4527844,
                        56.579351
                    ],
                    [
                        90.4532148,
                        56.5790897
                    ],
                    [
                        90.4536418,
                        56.5787724
                    ],
                    [
                        90.4536892,
                        56.5786025
                    ],
                    [
                        90.453818,
                        56.578498
                    ],
                    [
                        90.4540688,
                        56.5784999
                    ],
                    [
                        90.4545127,
                        56.5784364
                    ],
                    [
                        90.4562173,
                        56.5779978
                    ],
                    [
                        90.4588978,
                        56.5775106
                    ],
                    [
                        90.4592976,
                        56.5774957
                    ],
                    [
                        90.4596366,
                        56.5776301
                    ],
                    [
                        90.4601449,
                        56.5776413
                    ],
                    [
                        90.4606227,
                        56.5776002
                    ],
                    [
                        90.4616156,
                        56.5775199
                    ],
                    [
                        90.461846,
                        56.5774677
                    ],
                    [
                        90.4621104,
                        56.5773575
                    ],
                    [
                        90.4621748,
                        56.5771933
                    ],
                    [
                        90.4621544,
                        56.5770775
                    ],
                    [
                        90.4615038,
                        56.5762544
                    ],
                    [
                        90.4611818,
                        56.5759034
                    ],
                    [
                        90.4616359,
                        56.5760061
                    ],
                    [
                        90.4621917,
                        56.5760192
                    ],
                    [
                        90.4623611,
                        56.5760024
                    ],
                    [
                        90.4626526,
                        56.5759146
                    ],
                    [
                        90.4629202,
                        56.5756458
                    ],
                    [
                        90.4630592,
                        56.5755749
                    ],
                    [
                        90.463249,
                        56.5753976
                    ],
                    [
                        90.4634356,
                        56.5753613
                    ],
                    [
                        90.4634025,
                        56.5751571
                    ],
                    [
                        90.4636209,
                        56.5747123
                    ],
                    [
                        90.4635282,
                        56.5743915
                    ],
                    [
                        90.4637401,
                        56.5742019
                    ],
                    [
                        90.4643225,
                        56.5734508
                    ],
                    [
                        90.4643622,
                        56.5732393
                    ],
                    [
                        90.4642629,
                        56.5731154
                    ],
                    [
                        90.4639717,
                        56.5730242
                    ],
                    [
                        90.463932,
                        56.572893
                    ],
                    [
                        90.4636936,
                        56.5727544
                    ],
                    [
                        90.4633827,
                        56.5727982
                    ],
                    [
                        90.4626215,
                        56.5727544
                    ],
                    [
                        90.4623237,
                        56.572583
                    ],
                    [
                        90.4620986,
                        56.5725429
                    ],
                    [
                        90.4611455,
                        56.5725757
                    ],
                    [
                        90.4577104,
                        56.572408
                    ],
                    [
                        90.4571643,
                        56.5727085
                    ],
                    [
                        90.456118,
                        56.5729886
                    ],
                    [
                        90.4538052,
                        56.5735626
                    ],
                    [
                        90.4517931,
                        56.574076
                    ],
                    [
                        90.4517475,
                        56.5743177
                    ],
                    [
                        90.4499684,
                        56.574908
                    ],
                    [
                        90.4491339,
                        56.5750877
                    ],
                    [
                        90.446783,
                        56.575608
                    ],
                    [
                        90.4445633,
                        56.5759837
                    ],
                    [
                        90.4425978,
                        56.576427
                    ],
                    [
                        90.440861,
                        56.5769683
                    ],
                    [
                        90.440268,
                        56.577134
                    ]
                ]
            ],
            "longitude": 90.500293,
            "latitude": 56.5727248
        },
        "290": {
            "name": "Большая Салырь",
            "population": 1143,
            "type": "village",
            "poly": [
                [
                    90.5047799,
                    56.309376
                ],
                [
                    90.5071094,
                    56.3130243
                ],
                [
                    90.5074902,
                    56.3132803
                ],
                [
                    90.5086601,
                    56.3131298
                ],
                [
                    90.5090247,
                    56.3128994
                ],
                [
                    90.5098131,
                    56.3119495
                ],
                [
                    90.5117221,
                    56.312312
                ],
                [
                    90.5186435,
                    56.3138733
                ],
                [
                    90.5187925,
                    56.314057
                ],
                [
                    90.519786,
                    56.3144519
                ],
                [
                    90.5199351,
                    56.3146172
                ],
                [
                    90.5204648,
                    56.3147457
                ],
                [
                    90.5212763,
                    56.3144427
                ],
                [
                    90.5217234,
                    56.3143508
                ],
                [
                    90.5237435,
                    56.3151774
                ],
                [
                    90.5255035,
                    56.3154345
                ],
                [
                    90.5262571,
                    56.315753
                ],
                [
                    90.5271446,
                    56.3160028
                ],
                [
                    90.5262439,
                    56.3172591
                ],
                [
                    90.5265088,
                    56.3173913
                ],
                [
                    90.526522,
                    56.3175529
                ],
                [
                    90.5268267,
                    56.3176925
                ],
                [
                    90.5257802,
                    56.3187283
                ],
                [
                    90.5254093,
                    56.3192132
                ],
                [
                    90.5244821,
                    56.3200066
                ],
                [
                    90.524535,
                    56.3202269
                ],
                [
                    90.5252371,
                    56.320462
                ],
                [
                    90.5254888,
                    56.3202784
                ],
                [
                    90.5257935,
                    56.3203885
                ],
                [
                    90.52684,
                    56.3198229
                ],
                [
                    90.527648,
                    56.3190442
                ],
                [
                    90.5281116,
                    56.3183684
                ],
                [
                    90.5292376,
                    56.3183169
                ],
                [
                    90.5298205,
                    56.3180672
                ],
                [
                    90.5305755,
                    56.3181112
                ],
                [
                    90.5308007,
                    56.3186989
                ],
                [
                    90.5310391,
                    56.3194042
                ],
                [
                    90.5310391,
                    56.3208219
                ],
                [
                    90.5393448,
                    56.3206016
                ],
                [
                    90.5393448,
                    56.3187136
                ],
                [
                    90.5395965,
                    56.3186916
                ],
                [
                    90.5395832,
                    56.3169872
                ],
                [
                    90.5384573,
                    56.3170093
                ],
                [
                    90.5385632,
                    56.3151946
                ],
                [
                    90.5389606,
                    56.3137693
                ],
                [
                    90.539411,
                    56.3137693
                ],
                [
                    90.5398084,
                    56.3131815
                ],
                [
                    90.5400204,
                    56.3123439
                ],
                [
                    90.5399674,
                    56.3119031
                ],
                [
                    90.538603,
                    56.3115577
                ],
                [
                    90.5377552,
                    56.3115137
                ],
                [
                    90.5376757,
                    56.311161
                ],
                [
                    90.5369604,
                    56.3110434
                ],
                [
                    90.5370012,
                    56.3106064
                ],
                [
                    90.5365896,
                    56.3106012
                ],
                [
                    90.5362899,
                    56.3103057
                ],
                [
                    90.5351112,
                    56.3101708
                ],
                [
                    90.5335958,
                    56.3097246
                ],
                [
                    90.5329035,
                    56.3096831
                ],
                [
                    90.5319307,
                    56.3097868
                ],
                [
                    90.5313132,
                    56.3093198
                ],
                [
                    90.5306397,
                    56.3092576
                ],
                [
                    90.5293675,
                    56.3090707
                ],
                [
                    90.5294049,
                    56.3096831
                ],
                [
                    90.528694,
                    56.3093925
                ],
                [
                    90.5281514,
                    56.3089358
                ],
                [
                    90.527534,
                    56.3092057
                ],
                [
                    90.526636,
                    56.3086141
                ],
                [
                    90.5255509,
                    56.3084169
                ],
                [
                    90.5249896,
                    56.3080018
                ],
                [
                    90.5242224,
                    56.307898
                ],
                [
                    90.5237548,
                    56.3074828
                ],
                [
                    90.5230251,
                    56.3076697
                ],
                [
                    90.5225761,
                    56.3081056
                ],
                [
                    90.5221458,
                    56.3081575
                ],
                [
                    90.5219587,
                    56.3077838
                ],
                [
                    90.5223515,
                    56.3074413
                ],
                [
                    90.5213413,
                    56.3072234
                ],
                [
                    90.5210794,
                    56.3068186
                ],
                [
                    90.5201626,
                    56.3067356
                ],
                [
                    90.5204806,
                    56.306227
                ],
                [
                    90.5191681,
                    56.306158
                ],
                [
                    90.5186199,
                    56.3058286
                ],
                [
                    90.517615,
                    56.3062087
                ],
                [
                    90.5158793,
                    56.3062594
                ],
                [
                    90.5151485,
                    56.3057526
                ],
                [
                    90.5124079,
                    56.3058033
                ],
                [
                    90.5111746,
                    56.307425
                ],
                [
                    90.5094389,
                    56.30968
                ],
                [
                    90.5086168,
                    56.3095027
                ],
                [
                    90.5082513,
                    56.3100347
                ],
                [
                    90.5047799,
                    56.309376
                ]
            ],
            "longitude": 90.522827,
            "latitude": 56.311993
        },
        "291": {
            "name": "Малый Имыш",
            "population": 1053,
            "type": "village",
            "poly": null,
            "longitude": 90.526726,
            "latitude": 55.220963
        },
        "292": {
            "name": "Полевое",
            "population": 145,
            "type": "village",
            "poly": [
                [
                    90.525083,
                    57.3411317
                ],
                [
                    90.5259624,
                    57.3428717
                ],
                [
                    90.5262398,
                    57.3439413
                ],
                [
                    90.5266086,
                    57.3443786
                ],
                [
                    90.5271252,
                    57.344785
                ],
                [
                    90.5281861,
                    57.3453605
                ],
                [
                    90.5289993,
                    57.3456357
                ],
                [
                    90.5288876,
                    57.3456867
                ],
                [
                    90.5311462,
                    57.3465392
                ],
                [
                    90.5319547,
                    57.3469142
                ],
                [
                    90.5314234,
                    57.3473878
                ],
                [
                    90.531355,
                    57.3476401
                ],
                [
                    90.531509,
                    57.3479725
                ],
                [
                    90.5317257,
                    57.3482463
                ],
                [
                    90.5314349,
                    57.3485695
                ],
                [
                    90.5311269,
                    57.3488372
                ],
                [
                    90.5306421,
                    57.3491511
                ],
                [
                    90.530585,
                    57.3494311
                ],
                [
                    90.5314292,
                    57.3506035
                ],
                [
                    90.5299348,
                    57.3508619
                ],
                [
                    90.5296496,
                    57.3514773
                ],
                [
                    90.5300432,
                    57.3523327
                ],
                [
                    90.5306249,
                    57.3527327
                ],
                [
                    90.5312124,
                    57.3533542
                ],
                [
                    90.5325185,
                    57.3544588
                ],
                [
                    90.5331117,
                    57.3545942
                ],
                [
                    90.5346403,
                    57.3543911
                ],
                [
                    90.5359863,
                    57.354065
                ],
                [
                    90.5370472,
                    57.3535727
                ],
                [
                    90.5394256,
                    57.3528743
                ],
                [
                    90.5401442,
                    57.352782
                ],
                [
                    90.5410397,
                    57.3524958
                ],
                [
                    90.5414715,
                    57.3530611
                ],
                [
                    90.5417852,
                    57.353365
                ],
                [
                    90.5423555,
                    57.3535073
                ],
                [
                    90.5435247,
                    57.3536457
                ],
                [
                    90.5451289,
                    57.3536573
                ],
                [
                    90.546127,
                    57.3536842
                ],
                [
                    90.5455281,
                    57.3528342
                ],
                [
                    90.5458783,
                    57.3524494
                ],
                [
                    90.5463527,
                    57.35225
                ],
                [
                    90.5452779,
                    57.3507007
                ],
                [
                    90.5451821,
                    57.3497923
                ],
                [
                    90.5446665,
                    57.3492753
                ],
                [
                    90.5439866,
                    57.3480518
                ],
                [
                    90.5439547,
                    57.3476998
                ],
                [
                    90.5423896,
                    57.3460602
                ],
                [
                    90.5414725,
                    57.3445879
                ],
                [
                    90.5413584,
                    57.3439847
                ],
                [
                    90.5399211,
                    57.3425074
                ],
                [
                    90.5395059,
                    57.3427315
                ],
                [
                    90.5383697,
                    57.3434676
                ],
                [
                    90.5380321,
                    57.3437015
                ],
                [
                    90.5376214,
                    57.3443589
                ],
                [
                    90.5373431,
                    57.3447184
                ],
                [
                    90.5366039,
                    57.3453388
                ],
                [
                    90.5362617,
                    57.3455038
                ],
                [
                    90.5360974,
                    57.3456638
                ],
                [
                    90.5360563,
                    57.34591
                ],
                [
                    90.5355274,
                    57.346087
                ],
                [
                    90.5350164,
                    57.3463233
                ],
                [
                    90.5348156,
                    57.3465523
                ],
                [
                    90.5345966,
                    57.346604
                ],
                [
                    90.534227,
                    57.3465203
                ],
                [
                    90.5340901,
                    57.3465203
                ],
                [
                    90.533976,
                    57.3465745
                ],
                [
                    90.5337525,
                    57.3467763
                ],
                [
                    90.5327988,
                    57.34686
                ],
                [
                    90.5325387,
                    57.3468945
                ],
                [
                    90.5321783,
                    57.3467542
                ],
                [
                    90.5293325,
                    57.3456682
                ],
                [
                    90.5295207,
                    57.3455575
                ],
                [
                    90.5297831,
                    57.3455821
                ],
                [
                    90.5309466,
                    57.3446711
                ],
                [
                    90.5311576,
                    57.3446588
                ],
                [
                    90.5322071,
                    57.3441233
                ],
                [
                    90.5333235,
                    57.3431237
                ],
                [
                    90.533681,
                    57.3427617
                ],
                [
                    90.5328592,
                    57.3425611
                ],
                [
                    90.5320211,
                    57.3421356
                ],
                [
                    90.5325991,
                    57.3414402
                ],
                [
                    90.5321383,
                    57.341331
                ],
                [
                    90.5314492,
                    57.3415226
                ],
                [
                    90.5313065,
                    57.3419639
                ],
                [
                    90.5311665,
                    57.3419601
                ],
                [
                    90.5306714,
                    57.3415988
                ],
                [
                    90.5297614,
                    57.3414053
                ],
                [
                    90.5282854,
                    57.3417294
                ],
                [
                    90.5272704,
                    57.3416338
                ],
                [
                    90.527028,
                    57.3415739
                ],
                [
                    90.5265871,
                    57.3416117
                ],
                [
                    90.5264323,
                    57.3415597
                ],
                [
                    90.5261607,
                    57.3415865
                ],
                [
                    90.5259154,
                    57.3415408
                ],
                [
                    90.5257607,
                    57.341596
                ],
                [
                    90.5256292,
                    57.3414415
                ],
                [
                    90.5254803,
                    57.3413155
                ],
                [
                    90.5253255,
                    57.341109
                ],
                [
                    90.525083,
                    57.3411317
                ]
            ],
            "longitude": 90.536217,
            "latitude": 57.350273
        },
        "293": {
            "name": "Ильинка",
            "population": 473,
            "type": "village",
            "poly": [
                [
                    90.5239143,
                    55.8846409
                ],
                [
                    90.5239636,
                    55.8864006
                ],
                [
                    90.5240807,
                    55.8866702
                ],
                [
                    90.5244937,
                    55.88685
                ],
                [
                    90.5254615,
                    55.8869813
                ],
                [
                    90.5263861,
                    55.8870124
                ],
                [
                    90.5273168,
                    55.8871646
                ],
                [
                    90.5276022,
                    55.8872824
                ],
                [
                    90.5279567,
                    55.887533
                ],
                [
                    90.5279644,
                    55.8873904
                ],
                [
                    90.5281493,
                    55.8872219
                ],
                [
                    90.5286732,
                    55.8872003
                ],
                [
                    90.5291895,
                    55.887317
                ],
                [
                    90.5295438,
                    55.8873127
                ],
                [
                    90.5296903,
                    55.8871053
                ],
                [
                    90.5299368,
                    55.8869843
                ],
                [
                    90.5303837,
                    55.8869843
                ],
                [
                    90.5312005,
                    55.8875071
                ],
                [
                    90.531447,
                    55.8874725
                ],
                [
                    90.5316318,
                    55.8873429
                ],
                [
                    90.531578,
                    55.8872003
                ],
                [
                    90.5317321,
                    55.886954
                ],
                [
                    90.5324024,
                    55.8864744
                ],
                [
                    90.5329418,
                    55.8863836
                ],
                [
                    90.5334118,
                    55.886483
                ],
                [
                    90.533512,
                    55.8868201
                ],
                [
                    90.5331652,
                    55.8871874
                ],
                [
                    90.5328493,
                    55.8872954
                ],
                [
                    90.5323615,
                    55.8873869
                ],
                [
                    90.532217,
                    55.887468
                ],
                [
                    90.5322772,
                    55.8876503
                ],
                [
                    90.5326745,
                    55.8878326
                ],
                [
                    90.5330116,
                    55.887819
                ],
                [
                    90.5333487,
                    55.887711
                ],
                [
                    90.5342113,
                    55.8877763
                ],
                [
                    90.5346277,
                    55.8878582
                ],
                [
                    90.5348896,
                    55.8878798
                ],
                [
                    90.5350207,
                    55.8877718
                ],
                [
                    90.5351055,
                    55.887586
                ],
                [
                    90.5355678,
                    55.887573
                ],
                [
                    90.5367851,
                    55.8875471
                ],
                [
                    90.5377329,
                    55.887815
                ],
                [
                    90.5381489,
                    55.8878193
                ],
                [
                    90.5391506,
                    55.8884415
                ],
                [
                    90.5401445,
                    55.8886576
                ],
                [
                    90.5403834,
                    55.8888261
                ],
                [
                    90.5409998,
                    55.8890854
                ],
                [
                    90.5419167,
                    55.8893619
                ],
                [
                    90.542063,
                    55.8896946
                ],
                [
                    90.542325,
                    55.8897594
                ],
                [
                    90.5428103,
                    55.889794
                ],
                [
                    90.5426255,
                    55.8901483
                ],
                [
                    90.5427796,
                    55.890481
                ],
                [
                    90.5431341,
                    55.8906279
                ],
                [
                    90.544521,
                    55.8907403
                ],
                [
                    90.5460388,
                    55.8909174
                ],
                [
                    90.5474153,
                    55.8909643
                ],
                [
                    90.5471934,
                    55.8912443
                ],
                [
                    90.5479268,
                    55.8915968
                ],
                [
                    90.5482844,
                    55.891901
                ],
                [
                    90.5488207,
                    55.8924644
                ],
                [
                    90.5491474,
                    55.8926476
                ],
                [
                    90.5495362,
                    55.8927558
                ],
                [
                    90.5507039,
                    55.892935
                ],
                [
                    90.5517691,
                    55.8933
                ],
                [
                    90.552349,
                    55.893446
                ],
                [
                    90.5531222,
                    55.8935367
                ],
                [
                    90.5530906,
                    55.8933486
                ],
                [
                    90.5522622,
                    55.892862
                ],
                [
                    90.5518795,
                    55.8924107
                ],
                [
                    90.5524003,
                    55.8922824
                ],
                [
                    90.5528421,
                    55.8923687
                ],
                [
                    90.553351,
                    55.8926032
                ],
                [
                    90.5538638,
                    55.8927735
                ],
                [
                    90.5541044,
                    55.892977
                ],
                [
                    90.5546805,
                    55.8929018
                ],
                [
                    90.5547278,
                    55.8922824
                ],
                [
                    90.5548225,
                    55.8921452
                ],
                [
                    90.5553511,
                    55.8919771
                ],
                [
                    90.5555523,
                    55.8918134
                ],
                [
                    90.5552327,
                    55.891382
                ],
                [
                    90.5553905,
                    55.8911343
                ],
                [
                    90.5558482,
                    55.89099
                ],
                [
                    90.5565648,
                    55.891016
                ],
                [
                    90.5573585,
                    55.8911153
                ],
                [
                    90.557736,
                    55.8914567
                ],
                [
                    90.5581444,
                    55.8915517
                ],
                [
                    90.5597701,
                    55.89134
                ],
                [
                    90.5595929,
                    55.8909987
                ],
                [
                    90.5597316,
                    55.8904283
                ],
                [
                    90.559354,
                    55.8896592
                ],
                [
                    90.5589919,
                    55.8891494
                ],
                [
                    90.5585423,
                    55.888797
                ],
                [
                    90.5587711,
                    55.8887565
                ],
                [
                    90.5600954,
                    55.887656
                ],
                [
                    90.5597823,
                    55.8875817
                ],
                [
                    90.5570736,
                    55.8863191
                ],
                [
                    90.5566763,
                    55.8867445
                ],
                [
                    90.554136,
                    55.885097
                ],
                [
                    90.5528007,
                    55.8854467
                ],
                [
                    90.5504661,
                    55.8858313
                ],
                [
                    90.549973,
                    55.8858702
                ],
                [
                    90.5499653,
                    55.885585
                ],
                [
                    90.5494413,
                    55.8851183
                ],
                [
                    90.5486939,
                    55.8849109
                ],
                [
                    90.5481546,
                    55.8845781
                ],
                [
                    90.5477231,
                    55.8843923
                ],
                [
                    90.5462515,
                    55.8843016
                ],
                [
                    90.5445024,
                    55.8842411
                ],
                [
                    90.5434623,
                    55.8840596
                ],
                [
                    90.5424991,
                    55.8836231
                ],
                [
                    90.5412895,
                    55.8829878
                ],
                [
                    90.5382922,
                    55.8820932
                ],
                [
                    90.5376785,
                    55.8817852
                ],
                [
                    90.5369573,
                    55.8809312
                ],
                [
                    90.5352499,
                    55.880257
                ],
                [
                    90.5346397,
                    55.8805474
                ],
                [
                    90.5338199,
                    55.881073
                ],
                [
                    90.5333144,
                    55.8812597
                ],
                [
                    90.5326146,
                    55.8812941
                ],
                [
                    90.5315946,
                    55.8813081
                ],
                [
                    90.5313851,
                    55.8811871
                ],
                [
                    90.5305468,
                    55.8811733
                ],
                [
                    90.5289441,
                    55.8809381
                ],
                [
                    90.5299488,
                    55.8817506
                ],
                [
                    90.5300105,
                    55.8820514
                ],
                [
                    90.528605,
                    55.8818993
                ],
                [
                    90.526947,
                    55.8815121
                ],
                [
                    90.5289688,
                    55.8832131
                ],
                [
                    90.5303002,
                    55.8835312
                ],
                [
                    90.5304112,
                    55.8837905
                ],
                [
                    90.5306146,
                    55.8838008
                ],
                [
                    90.5310769,
                    55.8840532
                ],
                [
                    90.5308857,
                    55.8842053
                ],
                [
                    90.5301954,
                    55.8838665
                ],
                [
                    90.5294557,
                    55.8837248
                ],
                [
                    90.5290859,
                    55.8838389
                ],
                [
                    90.5292585,
                    55.8839737
                ],
                [
                    90.5293016,
                    55.8841915
                ],
                [
                    90.5294742,
                    55.8844646
                ],
                [
                    90.5291722,
                    55.8844611
                ],
                [
                    90.5290057,
                    55.8843332
                ],
                [
                    90.5284757,
                    55.8842848
                ],
                [
                    90.5277976,
                    55.8844231
                ],
                [
                    90.5272983,
                    55.8843229
                ],
                [
                    90.5271504,
                    55.8842295
                ],
                [
                    90.5270703,
                    55.8839633
                ],
                [
                    90.5263059,
                    55.8839737
                ],
                [
                    90.5259916,
                    55.8845372
                ],
                [
                    90.5255663,
                    55.884755
                ],
                [
                    90.5252827,
                    55.8847999
                ],
                [
                    90.5249129,
                    55.8849071
                ],
                [
                    90.5242224,
                    55.8847965
                ],
                [
                    90.5239143,
                    55.8846409
                ]
            ],
            "longitude": 90.542389,
            "latitude": 55.886326
        },
        "294": {
            "name": "Карловка",
            "population": 429,
            "type": "village",
            "poly": [
                [
                    90.5330507,
                    56.2120171
                ],
                [
                    90.539393,
                    56.2139204
                ],
                [
                    90.5414846,
                    56.2147366
                ],
                [
                    90.5427791,
                    56.2155973
                ],
                [
                    90.5449014,
                    56.2166974
                ],
                [
                    90.5458168,
                    56.2173649
                ],
                [
                    90.5465094,
                    56.2183751
                ],
                [
                    90.5467459,
                    56.2195612
                ],
                [
                    90.5464423,
                    56.2204731
                ],
                [
                    90.5457626,
                    56.2212272
                ],
                [
                    90.5464805,
                    56.2214546
                ],
                [
                    90.5497564,
                    56.2206233
                ],
                [
                    90.5498934,
                    56.2210992
                ],
                [
                    90.5539454,
                    56.2232061
                ],
                [
                    90.556331,
                    56.2243039
                ],
                [
                    90.5575523,
                    56.223663
                ],
                [
                    90.5581572,
                    56.2236186
                ],
                [
                    90.5590361,
                    56.2241833
                ],
                [
                    90.560988,
                    56.2253636
                ],
                [
                    90.560988,
                    56.2258014
                ],
                [
                    90.5617404,
                    56.2262245
                ],
                [
                    90.5643543,
                    56.2277664
                ],
                [
                    90.5651647,
                    56.2288196
                ],
                [
                    90.5665116,
                    56.228826
                ],
                [
                    90.5676758,
                    56.2286547
                ],
                [
                    90.568646,
                    56.2284072
                ],
                [
                    90.5686118,
                    56.2278235
                ],
                [
                    90.5684519,
                    56.2274745
                ],
                [
                    90.5687373,
                    56.2273032
                ],
                [
                    90.5679155,
                    56.2267131
                ],
                [
                    90.5664653,
                    56.2252836
                ],
                [
                    90.5638861,
                    56.2236462
                ],
                [
                    90.5636944,
                    56.2217983
                ],
                [
                    90.5643975,
                    56.2211078
                ],
                [
                    90.5627904,
                    56.2207778
                ],
                [
                    90.5627447,
                    56.2204174
                ],
                [
                    90.5601514,
                    56.2187825
                ],
                [
                    90.5594574,
                    56.2189095
                ],
                [
                    90.5593205,
                    56.218747
                ],
                [
                    90.5586356,
                    56.2186708
                ],
                [
                    90.5566632,
                    56.217564
                ],
                [
                    90.5505726,
                    56.214817
                ],
                [
                    90.5507918,
                    56.2146545
                ],
                [
                    90.5503444,
                    56.2144108
                ],
                [
                    90.5497052,
                    56.2143752
                ],
                [
                    90.5484542,
                    56.2137913
                ],
                [
                    90.5483537,
                    56.2133647
                ],
                [
                    90.5458974,
                    56.2119784
                ],
                [
                    90.5448473,
                    56.2117652
                ],
                [
                    90.5433132,
                    56.2116382
                ],
                [
                    90.5421992,
                    56.2113183
                ],
                [
                    90.5411308,
                    56.2107698
                ],
                [
                    90.5350402,
                    56.2092158
                ],
                [
                    90.5337801,
                    56.2106632
                ],
                [
                    90.5343645,
                    56.210846
                ],
                [
                    90.5340267,
                    56.2112624
                ],
                [
                    90.5334331,
                    56.2114655
                ],
                [
                    90.5330507,
                    56.2120171
                ]
            ],
            "longitude": 90.55397,
            "latitude": 56.218834
        },
        "295": {
            "name": "Горный",
            "population": 1146,
            "type": "village",
            "poly": [
                [
                    90.5390199,
                    56.2442451
                ],
                [
                    90.5393506,
                    56.2453441
                ],
                [
                    90.5502233,
                    56.2468585
                ],
                [
                    90.5502512,
                    56.24771
                ],
                [
                    90.549248,
                    56.2499395
                ],
                [
                    90.5521461,
                    56.2497692
                ],
                [
                    90.554264,
                    56.2460843
                ],
                [
                    90.5554344,
                    56.2462392
                ],
                [
                    90.5558803,
                    56.2467811
                ],
                [
                    90.5566048,
                    56.2468585
                ],
                [
                    90.5625404,
                    56.2466108
                ],
                [
                    90.5618437,
                    56.2478184
                ],
                [
                    90.5621503,
                    56.2483139
                ],
                [
                    90.5639059,
                    56.2483758
                ],
                [
                    90.5645468,
                    56.246812
                ],
                [
                    90.5663024,
                    56.2467656
                ],
                [
                    90.5663024,
                    56.2469669
                ],
                [
                    90.5676957,
                    56.2467346
                ],
                [
                    90.5669991,
                    56.2439321
                ],
                [
                    90.5651599,
                    56.2431578
                ],
                [
                    90.5647419,
                    56.2411138
                ],
                [
                    90.5652713,
                    56.2406802
                ],
                [
                    90.5646025,
                    56.2401847
                ],
                [
                    90.5618716,
                    56.2396582
                ],
                [
                    90.5605897,
                    56.2392091
                ],
                [
                    90.5595029,
                    56.2391161
                ],
                [
                    90.5571064,
                    56.2377378
                ],
                [
                    90.5553787,
                    56.2372577
                ],
                [
                    90.5538739,
                    56.23574
                ],
                [
                    90.5523969,
                    56.2352754
                ],
                [
                    90.5510036,
                    56.2353373
                ],
                [
                    90.5496103,
                    56.235709
                ],
                [
                    90.5487185,
                    56.2355541
                ],
                [
                    90.5481055,
                    56.2364524
                ],
                [
                    90.5468515,
                    56.2366383
                ],
                [
                    90.5460155,
                    56.2375675
                ],
                [
                    90.544873,
                    56.2377223
                ],
                [
                    90.5439534,
                    56.2383418
                ],
                [
                    90.5409159,
                    56.2384347
                ],
                [
                    90.5394357,
                    56.2396466
                ],
                [
                    90.5397495,
                    56.2424985
                ],
                [
                    90.5390199,
                    56.2442451
                ]
            ],
            "longitude": 90.5552951,
            "latitude": 56.2416248
        },
        "296": {
            "name": "Сосновый Бор",
            "population": 290,
            "type": "village",
            "poly": [
                [
                    90.549561,
                    56.6200805
                ],
                [
                    90.5497515,
                    56.6207098
                ],
                [
                    90.5498236,
                    56.6208613
                ],
                [
                    90.5501329,
                    56.6210221
                ],
                [
                    90.5507979,
                    56.6210804
                ],
                [
                    90.5503277,
                    56.6213623
                ],
                [
                    90.5498406,
                    56.6218564
                ],
                [
                    90.549722,
                    56.6220848
                ],
                [
                    90.5508785,
                    56.6228905
                ],
                [
                    90.5521959,
                    56.6231748
                ],
                [
                    90.5527974,
                    56.6233868
                ],
                [
                    90.5532083,
                    56.6233868
                ],
                [
                    90.5542715,
                    56.6235407
                ],
                [
                    90.5552754,
                    56.6235709
                ],
                [
                    90.5559659,
                    56.6243703
                ],
                [
                    90.5569825,
                    56.6240067
                ],
                [
                    90.5575205,
                    56.6237457
                ],
                [
                    90.5577789,
                    56.6237015
                ],
                [
                    90.5584355,
                    56.6236012
                ],
                [
                    90.5588336,
                    56.6238832
                ],
                [
                    90.5592615,
                    56.6240813
                ],
                [
                    90.5596681,
                    56.6239345
                ],
                [
                    90.5593293,
                    56.6237597
                ],
                [
                    90.5594055,
                    56.6236968
                ],
                [
                    90.5591429,
                    56.6233379
                ],
                [
                    90.5596978,
                    56.6228392
                ],
                [
                    90.5599223,
                    56.6227367
                ],
                [
                    90.5606636,
                    56.6224873
                ],
                [
                    90.560833,
                    56.6223149
                ],
                [
                    90.5604391,
                    56.6220748
                ],
                [
                    90.5611211,
                    56.6214502
                ],
                [
                    90.5617184,
                    56.6215831
                ],
                [
                    90.56243,
                    56.620814
                ],
                [
                    90.5616887,
                    56.6204854
                ],
                [
                    90.5618962,
                    56.6203462
                ],
                [
                    90.5622393,
                    56.6199617
                ],
                [
                    90.5633619,
                    56.6192485
                ],
                [
                    90.5627138,
                    56.6190737
                ],
                [
                    90.5625273,
                    56.6190877
                ],
                [
                    90.562252,
                    56.6192765
                ],
                [
                    90.5621843,
                    56.6192648
                ],
                [
                    90.5621376,
                    56.6190504
                ],
                [
                    90.5620021,
                    56.6189036
                ],
                [
                    90.5617141,
                    56.6188779
                ],
                [
                    90.5614302,
                    56.6189385
                ],
                [
                    90.5612778,
                    56.6191063
                ],
                [
                    90.5607017,
                    56.6189082
                ],
                [
                    90.5605999,
                    56.6189991
                ],
                [
                    90.5603585,
                    56.6189222
                ],
                [
                    90.5597316,
                    56.6185237
                ],
                [
                    90.5595029,
                    56.6185377
                ],
                [
                    90.5593123,
                    56.6184468
                ],
                [
                    90.5593927,
                    56.6181647
                ],
                [
                    90.5586557,
                    56.6176776
                ],
                [
                    90.558266,
                    56.6176287
                ],
                [
                    90.5577322,
                    56.6176357
                ],
                [
                    90.557512,
                    56.6177406
                ],
                [
                    90.5573298,
                    56.6179527
                ],
                [
                    90.5573976,
                    56.6181624
                ],
                [
                    90.5575331,
                    56.6183232
                ],
                [
                    90.5573731,
                    56.6184283
                ],
                [
                    90.5572746,
                    56.618505
                ],
                [
                    90.5567114,
                    56.6182556
                ],
                [
                    90.5561988,
                    56.6186682
                ],
                [
                    90.5556481,
                    56.6183838
                ],
                [
                    90.5557412,
                    56.6182766
                ],
                [
                    90.5552076,
                    56.6180669
                ],
                [
                    90.5549872,
                    56.6181414
                ],
                [
                    90.5539453,
                    56.6178151
                ],
                [
                    90.5523779,
                    56.6181717
                ],
                [
                    90.5522466,
                    56.6181228
                ],
                [
                    90.5519331,
                    56.6181368
                ],
                [
                    90.5515985,
                    56.6182766
                ],
                [
                    90.5508995,
                    56.6192229
                ],
                [
                    90.5506158,
                    56.6192905
                ],
                [
                    90.5499846,
                    56.6196937
                ],
                [
                    90.549561,
                    56.6200805
                ]
            ],
            "longitude": 90.5558211,
            "latitude": 56.6211344
        },
        "297": {
            "name": "Малиновка",
            "population": 2769,
            "type": "village",
            "poly": [
                [
                    90.5679753,
                    56.2786968
                ],
                [
                    90.5692872,
                    56.2790657
                ],
                [
                    90.5699517,
                    56.2789333
                ],
                [
                    90.5702243,
                    56.2790941
                ],
                [
                    90.5695427,
                    56.2793495
                ],
                [
                    90.5690487,
                    56.2800588
                ],
                [
                    90.5695257,
                    56.2810993
                ],
                [
                    90.5707866,
                    56.2820356
                ],
                [
                    90.5710421,
                    56.2834448
                ],
                [
                    90.5716896,
                    56.2834259
                ],
                [
                    90.5733764,
                    56.2821775
                ],
                [
                    90.5769543,
                    56.2833597
                ],
                [
                    90.577704,
                    56.2828962
                ],
                [
                    90.5784366,
                    56.2829435
                ],
                [
                    90.5791352,
                    56.2823477
                ],
                [
                    90.5796804,
                    56.2823288
                ],
                [
                    90.5815205,
                    56.2813641
                ],
                [
                    90.5811456,
                    56.2809952
                ],
                [
                    90.5818272,
                    56.2799264
                ],
                [
                    90.5834628,
                    56.2799548
                ],
                [
                    90.5838888,
                    56.2787819
                ],
                [
                    90.5833436,
                    56.2787252
                ],
                [
                    90.5823894,
                    56.278205
                ],
                [
                    90.5816057,
                    56.2780063
                ],
                [
                    90.5822361,
                    56.2773631
                ],
                [
                    90.5816398,
                    56.2772496
                ],
                [
                    90.581299,
                    56.2769091
                ],
                [
                    90.5765794,
                    56.2763699
                ],
                [
                    90.5731378,
                    56.2752915
                ],
                [
                    90.5720474,
                    56.2746861
                ],
                [
                    90.5705992,
                    56.2745442
                ],
                [
                    90.569168,
                    56.2739104
                ],
                [
                    90.5685887,
                    56.2743267
                ],
                [
                    90.5695257,
                    56.2747523
                ],
                [
                    90.5692532,
                    56.2750077
                ],
                [
                    90.5697473,
                    56.2755564
                ],
                [
                    90.5702924,
                    56.2759159
                ],
                [
                    90.5700369,
                    56.2762564
                ],
                [
                    90.5695427,
                    56.2765591
                ],
                [
                    90.5689635,
                    56.2775807
                ],
                [
                    90.5679753,
                    56.2786968
                ]
            ],
            "longitude": 90.575844,
            "latitude": 56.279224
        },
        "298": {
            "name": "Преображенка",
            "population": 594,
            "type": "village",
            "poly": [
                [
                    90.5633747,
                    56.3593421
                ],
                [
                    90.564249,
                    56.3598118
                ],
                [
                    90.5706471,
                    56.3612501
                ],
                [
                    90.5717068,
                    56.3610226
                ],
                [
                    90.5765948,
                    56.3603548
                ],
                [
                    90.5857085,
                    56.3600246
                ],
                [
                    90.5862433,
                    56.3570232
                ],
                [
                    90.5851008,
                    56.3558214
                ],
                [
                    90.5843225,
                    56.3554912
                ],
                [
                    90.5829979,
                    56.3552894
                ],
                [
                    90.5840245,
                    56.3529683
                ],
                [
                    90.5792722,
                    56.3522343
                ],
                [
                    90.5782125,
                    56.3504452
                ],
                [
                    90.5769375,
                    56.350225
                ],
                [
                    90.5738742,
                    56.3508397
                ],
                [
                    90.5722018,
                    56.3476742
                ],
                [
                    90.5685589,
                    56.348289
                ],
                [
                    90.5695856,
                    56.3498396
                ],
                [
                    90.5695856,
                    56.3516012
                ],
                [
                    90.5675158,
                    56.3525554
                ],
                [
                    90.5667045,
                    56.3536655
                ],
                [
                    90.5677144,
                    56.3577112
                ],
                [
                    90.5674164,
                    56.3580506
                ],
                [
                    90.5670191,
                    56.3581057
                ],
                [
                    90.565297,
                    56.357858
                ],
                [
                    90.5641214,
                    56.357858
                ],
                [
                    90.5633747,
                    56.3593421
                ]
            ],
            "longitude": 90.5770657,
            "latitude": 56.3565278
        },
        "299": {
            "name": "Большой Улуй",
            "population": 3340,
            "type": "village",
            "poly": [
                [
                    90.5589579,
                    56.6513378
                ],
                [
                    90.5616591,
                    56.6517839
                ],
                [
                    90.5623671,
                    56.6517989
                ],
                [
                    90.5628136,
                    56.6520503
                ],
                [
                    90.5626829,
                    56.6521432
                ],
                [
                    90.5626012,
                    56.6525054
                ],
                [
                    90.5624487,
                    56.6526431
                ],
                [
                    90.5634235,
                    56.6528617
                ],
                [
                    90.563783,
                    56.6529664
                ],
                [
                    90.5640934,
                    56.653161
                ],
                [
                    90.5643548,
                    56.6539663
                ],
                [
                    90.5638919,
                    56.6545171
                ],
                [
                    90.5665714,
                    56.655963
                ],
                [
                    90.5668437,
                    56.6558612
                ],
                [
                    90.5668273,
                    56.6559989
                ],
                [
                    90.5666748,
                    56.656439
                ],
                [
                    90.5668857,
                    56.6567394
                ],
                [
                    90.5673322,
                    56.6571794
                ],
                [
                    90.5679803,
                    56.6575027
                ],
                [
                    90.5689824,
                    56.6580415
                ],
                [
                    90.570181,
                    56.6587807
                ],
                [
                    90.5711722,
                    56.6591669
                ],
                [
                    90.5717495,
                    56.6596218
                ],
                [
                    90.571782,
                    56.6600409
                ],
                [
                    90.5720926,
                    56.660867
                ],
                [
                    90.5719237,
                    56.6622617
                ],
                [
                    90.5717712,
                    56.6625461
                ],
                [
                    90.5709925,
                    56.6632913
                ],
                [
                    90.5707311,
                    56.6638031
                ],
                [
                    90.5719619,
                    56.6642759
                ],
                [
                    90.5717658,
                    56.6642999
                ],
                [
                    90.5717549,
                    56.6643867
                ],
                [
                    90.5723952,
                    56.6644867
                ],
                [
                    90.572478,
                    56.6646423
                ],
                [
                    90.5721643,
                    56.6651355
                ],
                [
                    90.573724,
                    56.6657413
                ],
                [
                    90.5744428,
                    56.6658251
                ],
                [
                    90.5744734,
                    56.6660166
                ],
                [
                    90.5742163,
                    56.6664691
                ],
                [
                    90.5745082,
                    56.666493
                ],
                [
                    90.5744255,
                    56.6667061
                ],
                [
                    90.5742773,
                    56.6667085
                ],
                [
                    90.5743122,
                    56.6669814
                ],
                [
                    90.5752968,
                    56.6671921
                ],
                [
                    90.5757238,
                    56.6671849
                ],
                [
                    90.57602,
                    56.6670509
                ],
                [
                    90.576007,
                    56.6672903
                ],
                [
                    90.5761638,
                    56.6675416
                ],
                [
                    90.5765777,
                    56.6677715
                ],
                [
                    90.5769174,
                    56.6678912
                ],
                [
                    90.5783291,
                    56.6680851
                ],
                [
                    90.5793355,
                    56.668188
                ],
                [
                    90.5812743,
                    56.6683436
                ],
                [
                    90.5820411,
                    56.6683532
                ],
                [
                    90.582821,
                    56.668279
                ],
                [
                    90.5826685,
                    56.6694712
                ],
                [
                    90.5823722,
                    56.6712235
                ],
                [
                    90.582211,
                    56.6714533
                ],
                [
                    90.5820646,
                    56.6726454
                ],
                [
                    90.586724,
                    56.6726207
                ],
                [
                    90.5892001,
                    56.6700632
                ],
                [
                    90.589515,
                    56.6699276
                ],
                [
                    90.5898044,
                    56.6696565
                ],
                [
                    90.5914309,
                    56.6684924
                ],
                [
                    90.5910168,
                    56.6683882
                ],
                [
                    90.5915814,
                    56.6677619
                ],
                [
                    90.5924876,
                    56.6670264
                ],
                [
                    90.5949909,
                    56.6654162
                ],
                [
                    90.5938547,
                    56.6649373
                ],
                [
                    90.5933563,
                    56.6647803
                ],
                [
                    90.5936316,
                    56.6647285
                ],
                [
                    90.5939802,
                    56.6645811
                ],
                [
                    90.5950084,
                    56.6644125
                ],
                [
                    90.595566,
                    56.6644566
                ],
                [
                    90.5962213,
                    56.6643819
                ],
                [
                    90.5976031,
                    56.6646018
                ],
                [
                    90.597646,
                    56.6644675
                ],
                [
                    90.5979047,
                    56.6643282
                ],
                [
                    90.5983973,
                    56.6642194
                ],
                [
                    90.5986774,
                    56.6641615
                ],
                [
                    90.5987435,
                    56.6640713
                ],
                [
                    90.5989522,
                    56.6640134
                ],
                [
                    90.5991253,
                    56.6638928
                ],
                [
                    90.5991664,
                    56.6634505
                ],
                [
                    90.5990914,
                    56.6631563
                ],
                [
                    90.5990147,
                    56.6628807
                ],
                [
                    90.599252,
                    56.6627964
                ],
                [
                    90.5995733,
                    56.6627964
                ],
                [
                    90.5998445,
                    56.6628778
                ],
                [
                    90.6006761,
                    56.6627405
                ],
                [
                    90.6007814,
                    56.6625443
                ],
                [
                    90.6011472,
                    56.6624237
                ],
                [
                    90.6011115,
                    56.6620294
                ],
                [
                    90.6004583,
                    56.6619402
                ],
                [
                    90.6000444,
                    56.6618254
                ],
                [
                    90.599998,
                    56.6617774
                ],
                [
                    90.5997445,
                    56.6615508
                ],
                [
                    90.5995858,
                    56.6613851
                ],
                [
                    90.5993752,
                    56.6612517
                ],
                [
                    90.5990932,
                    56.6611615
                ],
                [
                    90.5988202,
                    56.6611428
                ],
                [
                    90.5981064,
                    56.6612723
                ],
                [
                    90.5977459,
                    56.6612988
                ],
                [
                    90.5971124,
                    56.6612546
                ],
                [
                    90.5967234,
                    56.6612301
                ],
                [
                    90.5963308,
                    56.661183
                ],
                [
                    90.5962058,
                    56.6611438
                ],
                [
                    90.5967519,
                    56.6609944
                ],
                [
                    90.5989084,
                    56.6591893
                ],
                [
                    90.5983926,
                    56.6589346
                ],
                [
                    90.5980615,
                    56.6588062
                ],
                [
                    90.5979569,
                    56.6586644
                ],
                [
                    90.5975526,
                    56.658561
                ],
                [
                    90.5971518,
                    56.6584307
                ],
                [
                    90.5963745,
                    56.6580725
                ],
                [
                    90.5959284,
                    56.6577602
                ],
                [
                    90.5959214,
                    56.6575878
                ],
                [
                    90.5957332,
                    56.6573752
                ],
                [
                    90.5956461,
                    56.6572755
                ],
                [
                    90.5949593,
                    56.6570993
                ],
                [
                    90.5944471,
                    56.6570648
                ],
                [
                    90.5940393,
                    56.6570284
                ],
                [
                    90.5938546,
                    56.6569307
                ],
                [
                    90.593635,
                    56.6568656
                ],
                [
                    90.5933283,
                    56.6568407
                ],
                [
                    90.5931087,
                    56.6567449
                ],
                [
                    90.5929658,
                    56.656764
                ],
                [
                    90.5929867,
                    56.6564326
                ],
                [
                    90.5928961,
                    56.6562659
                ],
                [
                    90.593377,
                    56.6561184
                ],
                [
                    90.5941578,
                    56.6561108
                ],
                [
                    90.5941787,
                    56.6555188
                ],
                [
                    90.5940009,
                    56.6555092
                ],
                [
                    90.5934642,
                    56.6555782
                ],
                [
                    90.5936559,
                    56.6545206
                ],
                [
                    90.5923279,
                    56.653645
                ],
                [
                    90.592544,
                    56.6532101
                ],
                [
                    90.5928814,
                    56.6530135
                ],
                [
                    90.5923935,
                    56.6524268
                ],
                [
                    90.5921539,
                    56.6523142
                ],
                [
                    90.5916441,
                    56.6518903
                ],
                [
                    90.5923368,
                    56.6514209
                ],
                [
                    90.5930644,
                    56.650779
                ],
                [
                    90.5931863,
                    56.6504053
                ],
                [
                    90.5930426,
                    56.6499048
                ],
                [
                    90.5936787,
                    56.6494521
                ],
                [
                    90.5938748,
                    56.6492389
                ],
                [
                    90.5938748,
                    56.648997
                ],
                [
                    90.5936003,
                    56.6484413
                ],
                [
                    90.5935742,
                    56.6482377
                ],
                [
                    90.5941362,
                    56.6481994
                ],
                [
                    90.5946852,
                    56.6479982
                ],
                [
                    90.5949422,
                    56.6477275
                ],
                [
                    90.59533,
                    56.6475143
                ],
                [
                    90.5953474,
                    56.6474353
                ],
                [
                    90.5933804,
                    56.6464267
                ],
                [
                    90.591202,
                    56.6470136
                ],
                [
                    90.5908055,
                    56.6470255
                ],
                [
                    90.5909275,
                    56.6472124
                ],
                [
                    90.5906703,
                    56.6472986
                ],
                [
                    90.5907358,
                    56.647404
                ],
                [
                    90.5906225,
                    56.6474759
                ],
                [
                    90.590518,
                    56.6475501
                ],
                [
                    90.5912978,
                    56.6479142
                ],
                [
                    90.5912368,
                    56.6480028
                ],
                [
                    90.5907749,
                    56.648113
                ],
                [
                    90.5909362,
                    56.6482735
                ],
                [
                    90.5914677,
                    56.6483789
                ],
                [
                    90.5915592,
                    56.6486112
                ],
                [
                    90.5907445,
                    56.6486424
                ],
                [
                    90.5902958,
                    56.6486184
                ],
                [
                    90.5900518,
                    56.6487717
                ],
                [
                    90.5899603,
                    56.6487813
                ],
                [
                    90.5894244,
                    56.6485993
                ],
                [
                    90.5886445,
                    56.6485346
                ],
                [
                    90.5885792,
                    56.6486424
                ],
                [
                    90.5876338,
                    56.6487454
                ],
                [
                    90.5872111,
                    56.6487669
                ],
                [
                    90.5867145,
                    56.6486831
                ],
                [
                    90.5863616,
                    56.6486687
                ],
                [
                    90.5864705,
                    56.6484675
                ],
                [
                    90.5861045,
                    56.6484076
                ],
                [
                    90.585207,
                    56.6481178
                ],
                [
                    90.5838738,
                    56.6479262
                ],
                [
                    90.5842398,
                    56.6473154
                ],
                [
                    90.58434,
                    56.6468267
                ],
                [
                    90.5823403,
                    56.646695
                ],
                [
                    90.5818262,
                    56.6475166
                ],
                [
                    90.5804973,
                    56.6474495
                ],
                [
                    90.57926,
                    56.6475789
                ],
                [
                    90.5782536,
                    56.647713
                ],
                [
                    90.5780357,
                    56.6477537
                ],
                [
                    90.5776611,
                    56.647737
                ],
                [
                    90.5775042,
                    56.6477034
                ],
                [
                    90.5774345,
                    56.6474328
                ],
                [
                    90.5773169,
                    56.6472268
                ],
                [
                    90.5773648,
                    56.6470639
                ],
                [
                    90.576781,
                    56.6463525
                ],
                [
                    90.5763061,
                    56.645768
                ],
                [
                    90.5761275,
                    56.6454278
                ],
                [
                    90.5756177,
                    56.6449248
                ],
                [
                    90.5752997,
                    56.6447571
                ],
                [
                    90.5741669,
                    56.6439762
                ],
                [
                    90.5728381,
                    56.6432168
                ],
                [
                    90.5727379,
                    56.642958
                ],
                [
                    90.5724547,
                    56.6426346
                ],
                [
                    90.5721018,
                    56.6424358
                ],
                [
                    90.5720974,
                    56.6422968
                ],
                [
                    90.5719667,
                    56.6422298
                ],
                [
                    90.5721671,
                    56.6420094
                ],
                [
                    90.5721192,
                    56.6416907
                ],
                [
                    90.5722935,
                    56.6413961
                ],
                [
                    90.5725898,
                    56.6412044
                ],
                [
                    90.5736702,
                    56.6408307
                ],
                [
                    90.5739316,
                    56.640742
                ],
                [
                    90.5740579,
                    56.6405384
                ],
                [
                    90.5740144,
                    56.6404018
                ],
                [
                    90.5738576,
                    56.6402892
                ],
                [
                    90.5735918,
                    56.6399922
                ],
                [
                    90.5734873,
                    56.6399227
                ],
                [
                    90.5730472,
                    56.6397478
                ],
                [
                    90.5729165,
                    56.6395537
                ],
                [
                    90.5730254,
                    56.6394507
                ],
                [
                    90.5760229,
                    56.6394411
                ],
                [
                    90.5763148,
                    56.6395058
                ],
                [
                    90.5768594,
                    56.6393932
                ],
                [
                    90.5770468,
                    56.6391656
                ],
                [
                    90.576611,
                    56.63872
                ],
                [
                    90.5760926,
                    56.6383726
                ],
                [
                    90.5757354,
                    56.6383247
                ],
                [
                    90.5750556,
                    56.6380755
                ],
                [
                    90.5747028,
                    56.6380467
                ],
                [
                    90.5744937,
                    56.637994
                ],
                [
                    90.573997,
                    56.6377688
                ],
                [
                    90.5736572,
                    56.637661
                ],
                [
                    90.5732651,
                    56.6373256
                ],
                [
                    90.5730254,
                    56.6369374
                ],
                [
                    90.5721236,
                    56.6370384
                ],
                [
                    90.5719494,
                    56.6371253
                ],
                [
                    90.5711597,
                    56.6379908
                ],
                [
                    90.5709854,
                    56.6382873
                ],
                [
                    90.5708765,
                    56.6385119
                ],
                [
                    90.5709363,
                    56.6387605
                ],
                [
                    90.5707131,
                    56.6388863
                ],
                [
                    90.5705877,
                    56.6391851
                ],
                [
                    90.5702225,
                    56.6392326
                ],
                [
                    90.5698209,
                    56.6393814
                ],
                [
                    90.5694353,
                    56.6396309
                ],
                [
                    90.5693924,
                    56.6401212
                ],
                [
                    90.568924,
                    56.6404147
                ],
                [
                    90.5687389,
                    56.6406243
                ],
                [
                    90.5700132,
                    56.6409148
                ],
                [
                    90.5697954,
                    56.6411933
                ],
                [
                    90.5692835,
                    56.6414808
                ],
                [
                    90.5688042,
                    56.6415856
                ],
                [
                    90.5683958,
                    56.6416335
                ],
                [
                    90.5679002,
                    56.6416305
                ],
                [
                    90.5673228,
                    56.6415168
                ],
                [
                    90.5665931,
                    56.6413071
                ],
                [
                    90.565956,
                    56.6411574
                ],
                [
                    90.564747,
                    56.6410196
                ],
                [
                    90.5633909,
                    56.6405315
                ],
                [
                    90.5626993,
                    56.6404357
                ],
                [
                    90.5617081,
                    56.6411484
                ],
                [
                    90.5614467,
                    56.6416186
                ],
                [
                    90.5611798,
                    56.641936
                ],
                [
                    90.5606189,
                    56.6432506
                ],
                [
                    90.5606026,
                    56.6434333
                ],
                [
                    90.5601723,
                    56.6437207
                ],
                [
                    90.5600852,
                    56.6437507
                ],
                [
                    90.5600144,
                    56.6438016
                ],
                [
                    90.5600253,
                    56.6439363
                ],
                [
                    90.560254,
                    56.644134
                ],
                [
                    90.5606951,
                    56.6451281
                ],
                [
                    90.5612723,
                    56.6453317
                ],
                [
                    90.5614303,
                    56.6452748
                ],
                [
                    90.5618334,
                    56.645682
                ],
                [
                    90.5626121,
                    56.6455593
                ],
                [
                    90.5631676,
                    56.6463617
                ],
                [
                    90.5624978,
                    56.6464665
                ],
                [
                    90.562318,
                    56.6465354
                ],
                [
                    90.5622853,
                    56.6468348
                ],
                [
                    90.5623507,
                    56.6472121
                ],
                [
                    90.5626012,
                    56.6476163
                ],
                [
                    90.562928,
                    56.6478498
                ],
                [
                    90.5629498,
                    56.6481163
                ],
                [
                    90.5635597,
                    56.6484996
                ],
                [
                    90.5638375,
                    56.6486073
                ],
                [
                    90.564344,
                    56.6486373
                ],
                [
                    90.5645563,
                    56.6487451
                ],
                [
                    90.5650901,
                    56.648796
                ],
                [
                    90.5652044,
                    56.6489756
                ],
                [
                    90.5655693,
                    56.6491942
                ],
                [
                    90.5661901,
                    56.6493049
                ],
                [
                    90.5665768,
                    56.6495115
                ],
                [
                    90.566604,
                    56.6497061
                ],
                [
                    90.5667293,
                    56.6498708
                ],
                [
                    90.5667075,
                    56.6500115
                ],
                [
                    90.5663372,
                    56.6501433
                ],
                [
                    90.5654223,
                    56.6503229
                ],
                [
                    90.5641316,
                    56.6507989
                ],
                [
                    90.5637776,
                    56.6508049
                ],
                [
                    90.5631241,
                    56.6504516
                ],
                [
                    90.5612996,
                    56.6498618
                ],
                [
                    90.5589579,
                    56.6513378
                ]
            ],
            "longitude": 90.57975,
            "latitude": 56.656811
        },
        "300": {
            "name": "Московка",
            "population": 310,
            "type": "village",
            "poly": [
                [
                    90.5652103,
                    55.6283462
                ],
                [
                    90.5660071,
                    55.6283048
                ],
                [
                    90.5662691,
                    55.6284409
                ],
                [
                    90.5663846,
                    55.6291393
                ],
                [
                    90.566762,
                    55.629459
                ],
                [
                    90.5680516,
                    55.6302047
                ],
                [
                    90.5696243,
                    55.6306723
                ],
                [
                    90.5709348,
                    55.6307611
                ],
                [
                    90.5724866,
                    55.6307078
                ],
                [
                    90.5724341,
                    55.6310926
                ],
                [
                    90.5718051,
                    55.631791
                ],
                [
                    90.5717736,
                    55.6320928
                ],
                [
                    90.5724341,
                    55.6323887
                ],
                [
                    90.5730527,
                    55.6322349
                ],
                [
                    90.5743842,
                    55.6325426
                ],
                [
                    90.5768167,
                    55.6325249
                ],
                [
                    90.5798734,
                    55.6330992
                ],
                [
                    90.5814194,
                    55.6338743
                ],
                [
                    90.5815242,
                    55.6340696
                ],
                [
                    90.5826985,
                    55.6346436
                ],
                [
                    90.5838308,
                    55.6351112
                ],
                [
                    90.5885488,
                    55.6364841
                ],
                [
                    90.5890311,
                    55.6360521
                ],
                [
                    90.5910441,
                    55.636999
                ],
                [
                    90.5918724,
                    55.6378452
                ],
                [
                    90.5922394,
                    55.6386027
                ],
                [
                    90.5924859,
                    55.639323
                ],
                [
                    90.5933751,
                    55.6392189
                ],
                [
                    90.5943481,
                    55.639465
                ],
                [
                    90.5948681,
                    55.6394035
                ],
                [
                    90.5959836,
                    55.6389206
                ],
                [
                    90.5968895,
                    55.6392094
                ],
                [
                    90.5975773,
                    55.6392236
                ],
                [
                    90.5993555,
                    55.639768
                ],
                [
                    90.5998419,
                    55.6395266
                ],
                [
                    90.6001187,
                    55.6395597
                ],
                [
                    90.6009743,
                    55.6399384
                ],
                [
                    90.6012762,
                    55.6398911
                ],
                [
                    90.601033,
                    55.6394224
                ],
                [
                    90.6007394,
                    55.6377561
                ],
                [
                    90.6001858,
                    55.6358245
                ],
                [
                    90.5989948,
                    55.6346172
                ],
                [
                    90.5985419,
                    55.6342952
                ],
                [
                    90.5976276,
                    55.6339827
                ],
                [
                    90.5934298,
                    55.6338574
                ],
                [
                    90.5929832,
                    55.6337435
                ],
                [
                    90.5920083,
                    55.6332804
                ],
                [
                    90.5914114,
                    55.6328489
                ],
                [
                    90.5901488,
                    55.6324417
                ],
                [
                    90.5891611,
                    55.6321508
                ],
                [
                    90.5879114,
                    55.6319132
                ],
                [
                    90.5862881,
                    55.6316102
                ],
                [
                    90.5851372,
                    55.6314962
                ],
                [
                    90.5763355,
                    55.6291047
                ],
                [
                    90.575792,
                    55.6287638
                ],
                [
                    90.5756578,
                    55.628654
                ],
                [
                    90.5717458,
                    55.6277864
                ],
                [
                    90.5684512,
                    55.6266916
                ],
                [
                    90.568382,
                    55.6267173
                ],
                [
                    90.5683035,
                    55.6267484
                ],
                [
                    90.5671629,
                    55.6262332
                ],
                [
                    90.5663442,
                    55.6274038
                ],
                [
                    90.5655122,
                    55.628063
                ],
                [
                    90.5652103,
                    55.6283462
                ]
            ],
            "longitude": 90.583694,
            "latitude": 55.633049
        },
        "301": {
            "name": "Интикуль",
            "population": 443,
            "type": "village",
            "poly": [
                [
                    90.5686529,
                    54.9510705
                ],
                [
                    90.5687831,
                    54.9513437
                ],
                [
                    90.5692788,
                    54.9517462
                ],
                [
                    90.5698996,
                    54.9520453
                ],
                [
                    90.570796,
                    54.9522379
                ],
                [
                    90.5715722,
                    54.9524479
                ],
                [
                    90.5720378,
                    54.9526348
                ],
                [
                    90.572173,
                    54.9527124
                ],
                [
                    90.5726988,
                    54.9533795
                ],
                [
                    90.5730393,
                    54.9538683
                ],
                [
                    90.5733698,
                    54.954222
                ],
                [
                    90.5740157,
                    54.954567
                ],
                [
                    90.5754326,
                    54.9556395
                ],
                [
                    90.5762813,
                    54.9562667
                ],
                [
                    90.5775096,
                    54.9568912
                ],
                [
                    90.5782451,
                    54.9571472
                ],
                [
                    90.5795047,
                    54.9574752
                ],
                [
                    90.5822587,
                    54.9580637
                ],
                [
                    90.5848093,
                    54.9584635
                ],
                [
                    90.5854743,
                    54.9585668
                ],
                [
                    90.5860689,
                    54.9587195
                ],
                [
                    90.5876728,
                    54.9589262
                ],
                [
                    90.5893705,
                    54.9589576
                ],
                [
                    90.5921715,
                    54.9594113
                ],
                [
                    90.5944614,
                    54.9599239
                ],
                [
                    90.5971508,
                    54.9607998
                ],
                [
                    90.5980212,
                    54.9612266
                ],
                [
                    90.6009161,
                    54.962226
                ],
                [
                    90.6027938,
                    54.962619
                ],
                [
                    90.6029234,
                    54.9631444
                ],
                [
                    90.6028745,
                    54.964562
                ],
                [
                    90.602692,
                    54.9646823
                ],
                [
                    90.6017706,
                    54.9649382
                ],
                [
                    90.6017506,
                    54.9650934
                ],
                [
                    90.6019609,
                    54.9656884
                ],
                [
                    90.6018507,
                    54.9657517
                ],
                [
                    90.6014001,
                    54.965858
                ],
                [
                    90.6012749,
                    54.9659615
                ],
                [
                    90.60132,
                    54.9664818
                ],
                [
                    90.6015403,
                    54.9671601
                ],
                [
                    90.6085955,
                    54.9654182
                ],
                [
                    90.60821,
                    54.9652774
                ],
                [
                    90.6070132,
                    54.9645616
                ],
                [
                    90.6071685,
                    54.9644984
                ],
                [
                    90.6126314,
                    54.9645443
                ],
                [
                    90.6122994,
                    54.9604461
                ],
                [
                    90.6124696,
                    54.9598712
                ],
                [
                    90.6123444,
                    54.9593738
                ],
                [
                    90.6123544,
                    54.9586119
                ],
                [
                    90.6122643,
                    54.9581404
                ],
                [
                    90.6121555,
                    54.9544929
                ],
                [
                    90.6118871,
                    54.9527599
                ],
                [
                    90.5981362,
                    54.9535876
                ],
                [
                    90.5973695,
                    54.9536281
                ],
                [
                    90.5966731,
                    54.9535517
                ],
                [
                    90.5746882,
                    54.9489509
                ],
                [
                    90.5739841,
                    54.9487576
                ],
                [
                    90.573233,
                    54.9484746
                ],
                [
                    90.5713868,
                    54.9476053
                ],
                [
                    90.5706909,
                    54.9481402
                ],
                [
                    90.5702653,
                    54.9486463
                ],
                [
                    90.5698497,
                    54.9494659
                ],
                [
                    90.5691736,
                    54.9501877
                ],
                [
                    90.5688382,
                    54.9505759
                ],
                [
                    90.5686529,
                    54.9510705
                ]
            ],
            "longitude": 90.590324,
            "latitude": 54.955624
        },
        "302": {
            "name": "Новая Еловка",
            "population": 643,
            "type": "village",
            "poly": [
                [
                    90.6334779,
                    56.5009434
                ],
                [
                    90.6336269,
                    56.5012974
                ],
                [
                    90.6336958,
                    56.5015575
                ],
                [
                    90.633664,
                    56.501803
                ],
                [
                    90.6335634,
                    56.501952
                ],
                [
                    90.6345747,
                    56.5022851
                ],
                [
                    90.6356257,
                    56.5024359
                ],
                [
                    90.6349859,
                    56.5029853
                ],
                [
                    90.635886,
                    56.5032032
                ],
                [
                    90.6363609,
                    56.5032247
                ],
                [
                    90.6368446,
                    56.5031685
                ],
                [
                    90.6376297,
                    56.5030021
                ],
                [
                    90.6416428,
                    56.5020726
                ],
                [
                    90.6408718,
                    56.5029238
                ],
                [
                    90.6408082,
                    56.5031693
                ],
                [
                    90.6413271,
                    56.5034177
                ],
                [
                    90.6414383,
                    56.5036427
                ],
                [
                    90.6412847,
                    56.5038238
                ],
                [
                    90.6412424,
                    56.5040401
                ],
                [
                    90.641846,
                    56.5042972
                ],
                [
                    90.6422908,
                    56.5044171
                ],
                [
                    90.6427038,
                    56.504382
                ],
                [
                    90.6433604,
                    56.5038443
                ],
                [
                    90.6451978,
                    56.5033563
                ],
                [
                    90.6459179,
                    56.5032014
                ],
                [
                    90.6459444,
                    56.5034001
                ],
                [
                    90.6462197,
                    56.5040167
                ],
                [
                    90.6464368,
                    56.5042709
                ],
                [
                    90.6464209,
                    56.5045661
                ],
                [
                    90.6463203,
                    56.5048408
                ],
                [
                    90.6457273,
                    56.5050628
                ],
                [
                    90.6455314,
                    56.5052294
                ],
                [
                    90.6455366,
                    56.5054602
                ],
                [
                    90.6495661,
                    56.5071696
                ],
                [
                    90.6503148,
                    56.5067596
                ],
                [
                    90.6504809,
                    56.5067615
                ],
                [
                    90.6505351,
                    56.506726
                ],
                [
                    90.650464,
                    56.5066942
                ],
                [
                    90.6518737,
                    56.5059106
                ],
                [
                    90.6532462,
                    56.504998
                ],
                [
                    90.6544085,
                    56.5042088
                ],
                [
                    90.653524,
                    56.5035448
                ],
                [
                    90.6531478,
                    56.5033784
                ],
                [
                    90.6529073,
                    56.5033204
                ],
                [
                    90.6534407,
                    56.5027801
                ],
                [
                    90.6535995,
                    56.5024528
                ],
                [
                    90.6538853,
                    56.5021313
                ],
                [
                    90.6540284,
                    56.5018274
                ],
                [
                    90.6541449,
                    56.5014066
                ],
                [
                    90.6540443,
                    56.5010968
                ],
                [
                    90.6538695,
                    56.5008688
                ],
                [
                    90.6535783,
                    56.5007052
                ],
                [
                    90.6531071,
                    56.5005269
                ],
                [
                    90.6528053,
                    56.5004655
                ],
                [
                    90.6526479,
                    56.5000371
                ],
                [
                    90.6525685,
                    56.499427
                ],
                [
                    90.6525354,
                    56.4992042
                ],
                [
                    90.6521974,
                    56.4988782
                ],
                [
                    90.6518518,
                    56.4987154
                ],
                [
                    90.651357,
                    56.4985246
                ],
                [
                    90.6510927,
                    56.4984274
                ],
                [
                    90.6509063,
                    56.4981954
                ],
                [
                    90.6508961,
                    56.498072
                ],
                [
                    90.6509614,
                    56.4977759
                ],
                [
                    90.6513087,
                    56.497168
                ],
                [
                    90.6507962,
                    56.4970698
                ],
                [
                    90.6512027,
                    56.4959848
                ],
                [
                    90.6518975,
                    56.4954073
                ],
                [
                    90.6525499,
                    56.4950519
                ],
                [
                    90.6529142,
                    56.4947292
                ],
                [
                    90.6529608,
                    56.4945
                ],
                [
                    90.6529057,
                    56.4942755
                ],
                [
                    90.6526515,
                    56.4937751
                ],
                [
                    90.6525245,
                    56.4935436
                ],
                [
                    90.6518594,
                    56.4923183
                ],
                [
                    90.6516688,
                    56.4917874
                ],
                [
                    90.651601,
                    56.4910789
                ],
                [
                    90.6515332,
                    56.4906416
                ],
                [
                    90.651313,
                    56.49052
                ],
                [
                    90.6503387,
                    56.4900429
                ],
                [
                    90.6498897,
                    56.4897014
                ],
                [
                    90.6485807,
                    56.4885929
                ],
                [
                    90.6482927,
                    56.4884666
                ],
                [
                    90.6466873,
                    56.4881673
                ],
                [
                    90.6462604,
                    56.4884435
                ],
                [
                    90.6431639,
                    56.486507
                ],
                [
                    90.6433164,
                    56.486093
                ],
                [
                    90.6433927,
                    56.4853609
                ],
                [
                    90.6437739,
                    56.4847809
                ],
                [
                    90.6485378,
                    56.4851861
                ],
                [
                    90.6487836,
                    56.4824568
                ],
                [
                    90.6398619,
                    56.4803496
                ],
                [
                    90.6394185,
                    56.4809856
                ],
                [
                    90.639359,
                    56.4816764
                ],
                [
                    90.6386177,
                    56.482707
                ],
                [
                    90.6378962,
                    56.4841214
                ],
                [
                    90.6380551,
                    56.4844247
                ],
                [
                    90.640418,
                    56.484538
                ],
                [
                    90.6407555,
                    56.4846111
                ],
                [
                    90.6418872,
                    56.4847061
                ],
                [
                    90.642205,
                    56.485353
                ],
                [
                    90.6421521,
                    56.4858098
                ],
                [
                    90.6424107,
                    56.4858824
                ],
                [
                    90.6425564,
                    56.4862004
                ],
                [
                    90.6424968,
                    56.4865475
                ],
                [
                    90.6419342,
                    56.486902
                ],
                [
                    90.6426888,
                    56.4875927
                ],
                [
                    90.6417721,
                    56.4902345
                ],
                [
                    90.6413353,
                    56.4909324
                ],
                [
                    90.6404616,
                    56.490768
                ],
                [
                    90.6398064,
                    56.4910347
                ],
                [
                    90.6390717,
                    56.4911188
                ],
                [
                    90.6388467,
                    56.4915061
                ],
                [
                    90.6393695,
                    56.4916778
                ],
                [
                    90.6397202,
                    56.4918094
                ],
                [
                    90.6398463,
                    56.4919466
                ],
                [
                    90.6391066,
                    56.4921134
                ],
                [
                    90.6390558,
                    56.4924969
                ],
                [
                    90.6388736,
                    56.4927168
                ],
                [
                    90.6385178,
                    56.4929272
                ],
                [
                    90.6381281,
                    56.4933528
                ],
                [
                    90.6377976,
                    56.4936124
                ],
                [
                    90.6378231,
                    56.4937807
                ],
                [
                    90.6382128,
                    56.493886
                ],
                [
                    90.6383695,
                    56.4939795
                ],
                [
                    90.6384458,
                    56.4942203
                ],
                [
                    90.6388397,
                    56.4946155
                ],
                [
                    90.6388482,
                    56.4953194
                ],
                [
                    90.6388058,
                    56.4955485
                ],
                [
                    90.6389329,
                    56.4957379
                ],
                [
                    90.6389075,
                    56.495759
                ],
                [
                    90.6371919,
                    56.4953007
                ],
                [
                    90.6367344,
                    56.49578
                ],
                [
                    90.6359242,
                    56.4963754
                ],
                [
                    90.6356542,
                    56.4964806
                ],
                [
                    90.635723,
                    56.4969687
                ],
                [
                    90.6358713,
                    56.4971002
                ],
                [
                    90.6361678,
                    56.4971645
                ],
                [
                    90.6363796,
                    56.4971499
                ],
                [
                    90.6361572,
                    56.497372
                ],
                [
                    90.6362313,
                    56.4976409
                ],
                [
                    90.6358659,
                    56.4982342
                ],
                [
                    90.63549,
                    56.4984271
                ],
                [
                    90.6352412,
                    56.4988071
                ],
                [
                    90.6346905,
                    56.4990672
                ],
                [
                    90.6342775,
                    56.4996838
                ],
                [
                    90.6339968,
                    56.4999352
                ],
                [
                    90.634341,
                    56.5004261
                ],
                [
                    90.6344628,
                    56.5005343
                ],
                [
                    90.6338698,
                    56.500657
                ],
                [
                    90.6334779,
                    56.5009434
                ]
            ],
            "longitude": 90.6446568,
            "latitude": 56.4956013
        },
        "303": {
            "name": "Красная Поляна",
            "population": 1502,
            "type": "village",
            "poly": [
                [
                    90.6490965,
                    55.9551164
                ],
                [
                    90.6500131,
                    55.9558005
                ],
                [
                    90.6507819,
                    55.956562
                ],
                [
                    90.6508706,
                    55.9591882
                ],
                [
                    90.6519843,
                    55.9594089
                ],
                [
                    90.6526839,
                    55.9594475
                ],
                [
                    90.6526249,
                    55.9598337
                ],
                [
                    90.654044,
                    55.9598613
                ],
                [
                    90.6538667,
                    55.9605123
                ],
                [
                    90.6545074,
                    55.9605178
                ],
                [
                    90.6546453,
                    55.960424
                ],
                [
                    90.6551874,
                    55.9604847
                ],
                [
                    90.6553352,
                    55.9601757
                ],
                [
                    90.6564884,
                    55.9603865
                ],
                [
                    90.6572177,
                    55.9602761
                ],
                [
                    90.6574247,
                    55.9601713
                ],
                [
                    90.6579569,
                    55.9602485
                ],
                [
                    90.6585482,
                    55.9603975
                ],
                [
                    90.6586073,
                    55.9605244
                ],
                [
                    90.6590213,
                    55.9605299
                ],
                [
                    90.6600561,
                    55.9606568
                ],
                [
                    90.6611107,
                    55.9606071
                ],
                [
                    90.662323,
                    55.9608113
                ],
                [
                    90.664777,
                    55.9610761
                ],
                [
                    90.6675169,
                    55.9616167
                ],
                [
                    90.6681083,
                    55.9618043
                ],
                [
                    90.6701287,
                    55.9615285
                ],
                [
                    90.6703296,
                    55.9614886
                ],
                [
                    90.6704642,
                    55.9614333
                ],
                [
                    90.6705194,
                    55.9611465
                ],
                [
                    90.6709767,
                    55.9608817
                ],
                [
                    90.6715207,
                    55.9607537
                ],
                [
                    90.6717888,
                    55.9608331
                ],
                [
                    90.6719859,
                    55.960789
                ],
                [
                    90.6718518,
                    55.960586
                ],
                [
                    90.671773,
                    55.9603123
                ],
                [
                    90.6720017,
                    55.9601711
                ],
                [
                    90.6724432,
                    55.9601887
                ],
                [
                    90.6728375,
                    55.9603476
                ],
                [
                    90.6731686,
                    55.960352
                ],
                [
                    90.6731686,
                    55.9591648
                ],
                [
                    90.6734446,
                    55.9586881
                ],
                [
                    90.6733973,
                    55.9584056
                ],
                [
                    90.6728454,
                    55.9581408
                ],
                [
                    90.6700621,
                    55.9589309
                ],
                [
                    90.6695417,
                    55.9589662
                ],
                [
                    90.6689661,
                    55.9587984
                ],
                [
                    90.6689188,
                    55.9586131
                ],
                [
                    90.6690765,
                    55.9582423
                ],
                [
                    90.6694707,
                    55.9581496
                ],
                [
                    90.6697309,
                    55.9578892
                ],
                [
                    90.6697467,
                    55.9576906
                ],
                [
                    90.6691238,
                    55.9574434
                ],
                [
                    90.6676808,
                    55.9572933
                ],
                [
                    90.6666559,
                    55.956565
                ],
                [
                    90.6658438,
                    55.9553379
                ],
                [
                    90.6661513,
                    55.9547464
                ],
                [
                    90.6670344,
                    55.9543712
                ],
                [
                    90.6678386,
                    55.9544374
                ],
                [
                    90.669371,
                    55.9548973
                ],
                [
                    90.6701043,
                    55.9549414
                ],
                [
                    90.670877,
                    55.9546633
                ],
                [
                    90.6716654,
                    55.9540586
                ],
                [
                    90.6721543,
                    55.9534229
                ],
                [
                    90.6717837,
                    55.9529683
                ],
                [
                    90.6714289,
                    55.9526813
                ],
                [
                    90.670601,
                    55.9526283
                ],
                [
                    90.6702461,
                    55.9523811
                ],
                [
                    90.67012,
                    55.9519397
                ],
                [
                    90.6694104,
                    55.9515909
                ],
                [
                    90.6688743,
                    55.95156
                ],
                [
                    90.668417,
                    55.9517234
                ],
                [
                    90.6677625,
                    55.9516969
                ],
                [
                    90.6674708,
                    55.9514806
                ],
                [
                    90.6674235,
                    55.9510656
                ],
                [
                    90.6678099,
                    55.9505668
                ],
                [
                    90.6681883,
                    55.949931
                ],
                [
                    90.667936,
                    55.9489863
                ],
                [
                    90.6676127,
                    55.9485978
                ],
                [
                    90.6676127,
                    55.9482534
                ],
                [
                    90.667865,
                    55.9479885
                ],
                [
                    90.668417,
                    55.9479664
                ],
                [
                    90.6692922,
                    55.9482313
                ],
                [
                    90.6699939,
                    55.9482446
                ],
                [
                    90.6708139,
                    55.9479664
                ],
                [
                    90.6712948,
                    55.9476265
                ],
                [
                    90.671216,
                    55.9473439
                ],
                [
                    90.670806,
                    55.9469068
                ],
                [
                    90.6707114,
                    55.9466817
                ],
                [
                    90.6708139,
                    55.9464565
                ],
                [
                    90.6723198,
                    55.9459134
                ],
                [
                    90.6725958,
                    55.9457015
                ],
                [
                    90.6722725,
                    55.9453836
                ],
                [
                    90.6722252,
                    55.9450701
                ],
                [
                    90.6710504,
                    55.944845
                ],
                [
                    90.6705063,
                    55.9444299
                ],
                [
                    90.6708927,
                    55.9442533
                ],
                [
                    90.6710268,
                    55.9438559
                ],
                [
                    90.6708454,
                    55.9429463
                ],
                [
                    90.6729822,
                    55.9429375
                ],
                [
                    90.6729664,
                    55.9425887
                ],
                [
                    90.6733133,
                    55.9425622
                ],
                [
                    90.6734316,
                    55.9420323
                ],
                [
                    90.6735341,
                    55.9418424
                ],
                [
                    90.6732108,
                    55.9415466
                ],
                [
                    90.6734316,
                    55.9413081
                ],
                [
                    90.6734947,
                    55.9411138
                ],
                [
                    90.6729822,
                    55.9411227
                ],
                [
                    90.6727535,
                    55.9409858
                ],
                [
                    90.6734631,
                    55.9402528
                ],
                [
                    90.6731477,
                    55.9400143
                ],
                [
                    90.6735498,
                    55.939714
                ],
                [
                    90.6736523,
                    55.9394844
                ],
                [
                    90.6742437,
                    55.9393563
                ],
                [
                    90.6751346,
                    55.9393254
                ],
                [
                    90.6756629,
                    55.9390605
                ],
                [
                    90.6761754,
                    55.9382568
                ],
                [
                    90.6783484,
                    55.9376036
                ],
                [
                    90.678514,
                    55.9374181
                ],
                [
                    90.6802723,
                    55.9363052
                ],
                [
                    90.6803196,
                    55.9355236
                ],
                [
                    90.6805561,
                    55.9353204
                ],
                [
                    90.6811711,
                    55.935263
                ],
                [
                    90.6822671,
                    55.9352409
                ],
                [
                    90.6823222,
                    55.9350068
                ],
                [
                    90.6825903,
                    55.9348611
                ],
                [
                    90.6823144,
                    55.9346624
                ],
                [
                    90.6819043,
                    55.9327765
                ],
                [
                    90.6814549,
                    55.9321096
                ],
                [
                    90.681384,
                    55.9319726
                ],
                [
                    90.6804694,
                    55.9319329
                ],
                [
                    90.679665,
                    55.9320345
                ],
                [
                    90.6794601,
                    55.9318534
                ],
                [
                    90.6791526,
                    55.931796
                ],
                [
                    90.6780567,
                    55.9318181
                ],
                [
                    90.6773392,
                    55.9316237
                ],
                [
                    90.6768425,
                    55.9311599
                ],
                [
                    90.6763457,
                    55.9308684
                ],
                [
                    90.6757779,
                    55.9304312
                ],
                [
                    90.6758564,
                    55.9301249
                ],
                [
                    90.6756987,
                    55.9300401
                ],
                [
                    90.6701606,
                    55.9310012
                ],
                [
                    90.6699903,
                    55.9312062
                ],
                [
                    90.6699083,
                    55.9314535
                ],
                [
                    90.6697125,
                    55.9352611
                ],
                [
                    90.6696204,
                    55.935253
                ],
                [
                    90.6694854,
                    55.9352611
                ],
                [
                    90.6693946,
                    55.9359479
                ],
                [
                    90.6683247,
                    55.9359282
                ],
                [
                    90.6675679,
                    55.9361345
                ],
                [
                    90.667477,
                    55.9366856
                ],
                [
                    90.6672146,
                    55.9368496
                ],
                [
                    90.6667454,
                    55.9369231
                ],
                [
                    90.6661247,
                    55.9376466
                ],
                [
                    90.6659582,
                    55.9378699
                ],
                [
                    90.6666091,
                    55.9378529
                ],
                [
                    90.6669421,
                    55.9380649
                ],
                [
                    90.6669674,
                    55.9384493
                ],
                [
                    90.6671087,
                    55.9386471
                ],
                [
                    90.6671389,
                    55.9388421
                ],
                [
                    90.6670484,
                    55.9389566
                ],
                [
                    90.6664832,
                    55.9392957
                ],
                [
                    90.666019,
                    55.9394144
                ],
                [
                    90.6657616,
                    55.9392449
                ],
                [
                    90.6651813,
                    55.9395133
                ],
                [
                    90.6649189,
                    55.9394201
                ],
                [
                    90.6647675,
                    55.9403018
                ],
                [
                    90.6641469,
                    55.940429
                ],
                [
                    90.6626431,
                    55.9415707
                ],
                [
                    90.6621234,
                    55.9415679
                ],
                [
                    90.6617348,
                    55.9416923
                ],
                [
                    90.6594186,
                    55.9409886
                ],
                [
                    90.6583993,
                    55.9410564
                ],
                [
                    90.6579653,
                    55.9412175
                ],
                [
                    90.657819,
                    55.9413729
                ],
                [
                    90.6563001,
                    55.9410931
                ],
                [
                    90.6556166,
                    55.9409729
                ],
                [
                    90.6550844,
                    55.9415469
                ],
                [
                    90.6550351,
                    55.9419719
                ],
                [
                    90.6554884,
                    55.9420271
                ],
                [
                    90.6559024,
                    55.9421706
                ],
                [
                    90.6568584,
                    55.9430427
                ],
                [
                    90.6570258,
                    55.9444888
                ],
                [
                    90.6567303,
                    55.9449358
                ],
                [
                    90.6555984,
                    55.9454075
                ],
                [
                    90.6544062,
                    55.9456512
                ],
                [
                    90.6539583,
                    55.9468627
                ],
                [
                    90.6531573,
                    55.9480001
                ],
                [
                    90.6527347,
                    55.9493951
                ],
                [
                    90.653151,
                    55.950045
                ],
                [
                    90.6535736,
                    55.9503523
                ],
                [
                    90.6535799,
                    55.9505854
                ],
                [
                    90.6527032,
                    55.9508396
                ],
                [
                    90.652741,
                    55.9511257
                ],
                [
                    90.6521733,
                    55.9513553
                ],
                [
                    90.6524193,
                    55.9519097
                ],
                [
                    90.6519526,
                    55.9520051
                ],
                [
                    90.6517822,
                    55.9522028
                ],
                [
                    90.6509686,
                    55.9522594
                ],
                [
                    90.6509623,
                    55.9524501
                ],
                [
                    90.6508298,
                    55.9525843
                ],
                [
                    90.6510001,
                    55.9527043
                ],
                [
                    90.6508172,
                    55.9531034
                ],
                [
                    90.6498963,
                    55.9533435
                ],
                [
                    90.650281,
                    55.9536614
                ],
                [
                    90.6498963,
                    55.9538662
                ],
                [
                    90.6498773,
                    55.9540957
                ],
                [
                    90.6500603,
                    55.9541346
                ],
                [
                    90.6500539,
                    55.9543323
                ],
                [
                    90.6494863,
                    55.9544065
                ],
                [
                    90.6499909,
                    55.9547667
                ],
                [
                    90.6490965,
                    55.9551164
                ]
            ],
            "longitude": 90.6602124,
            "latitude": 55.9534619
        },
        "304": {
            "name": "Берёзовый Лог",
            "population": 286,
            "type": "village",
            "poly": null,
            "longitude": 90.662605,
            "latitude": 55.160599
        },
        "305": {
            "name": "Большой Сереж",
            "population": 524,
            "type": "village",
            "poly": [
                [
                    90.6550501,
                    56.0027245
                ],
                [
                    90.6554246,
                    56.004036
                ],
                [
                    90.6556808,
                    56.0040581
                ],
                [
                    90.6560856,
                    56.004361
                ],
                [
                    90.6563782,
                    56.0042736
                ],
                [
                    90.6569838,
                    56.0042679
                ],
                [
                    90.6573622,
                    56.0043413
                ],
                [
                    90.6572159,
                    56.005072
                ],
                [
                    90.6571099,
                    56.0052131
                ],
                [
                    90.6568627,
                    56.0052639
                ],
                [
                    90.6571099,
                    56.0066633
                ],
                [
                    90.6576095,
                    56.0067225
                ],
                [
                    90.6579678,
                    56.0069031
                ],
                [
                    90.6581242,
                    56.0071739
                ],
                [
                    90.658099,
                    56.0075096
                ],
                [
                    90.6578517,
                    56.0079018
                ],
                [
                    90.657882,
                    56.0081557
                ],
                [
                    90.6582655,
                    56.0084406
                ],
                [
                    90.6587398,
                    56.0086466
                ],
                [
                    90.6598709,
                    56.0078886
                ],
                [
                    90.6606594,
                    56.0074547
                ],
                [
                    90.6620022,
                    56.0069381
                ],
                [
                    90.6632588,
                    56.0063044
                ],
                [
                    90.6644538,
                    56.0054916
                ],
                [
                    90.6661909,
                    56.004913
                ],
                [
                    90.6684703,
                    56.0044624
                ],
                [
                    90.6694241,
                    56.0041803
                ],
                [
                    90.670958,
                    56.0039574
                ],
                [
                    90.6738546,
                    56.0039997
                ],
                [
                    90.6753079,
                    56.0041577
                ],
                [
                    90.6786484,
                    56.0043157
                ],
                [
                    90.6794759,
                    56.0040562
                ],
                [
                    90.6796173,
                    56.0038728
                ],
                [
                    90.6795618,
                    56.0034016
                ],
                [
                    90.6794608,
                    56.0030799
                ],
                [
                    90.6792792,
                    56.0029078
                ],
                [
                    90.6792792,
                    56.0024451
                ],
                [
                    90.6795264,
                    56.0024027
                ],
                [
                    90.6794759,
                    56.0019992
                ],
                [
                    90.6788099,
                    56.0011149
                ],
                [
                    90.6785111,
                    56.0008147
                ],
                [
                    90.6779379,
                    56.0005529
                ],
                [
                    90.6774049,
                    56.0004061
                ],
                [
                    90.6762067,
                    56.0002964
                ],
                [
                    90.6754498,
                    56.0001751
                ],
                [
                    90.6741025,
                    56.000034
                ],
                [
                    90.6726038,
                    55.9998139
                ],
                [
                    90.6718923,
                    55.9994978
                ],
                [
                    90.6709939,
                    55.9989391
                ],
                [
                    90.6724624,
                    55.9983762
                ],
                [
                    90.6736719,
                    55.9979381
                ],
                [
                    90.674999,
                    55.9976954
                ],
                [
                    90.6759982,
                    55.9976616
                ],
                [
                    90.6787736,
                    55.9976305
                ],
                [
                    90.679041,
                    55.9982993
                ],
                [
                    90.6802369,
                    55.9989032
                ],
                [
                    90.6814783,
                    55.9984207
                ],
                [
                    90.681332,
                    55.9981582
                ],
                [
                    90.6815136,
                    55.9975826
                ],
                [
                    90.6818164,
                    55.9971508
                ],
                [
                    90.6832091,
                    55.9966174
                ],
                [
                    90.6840871,
                    55.9966372
                ],
                [
                    90.684728,
                    55.9968629
                ],
                [
                    90.68495,
                    55.9971169
                ],
                [
                    90.684945,
                    55.9973624
                ],
                [
                    90.6852579,
                    55.9975289
                ],
                [
                    90.6852377,
                    55.9979071
                ],
                [
                    90.6856817,
                    55.9983896
                ],
                [
                    90.6860804,
                    55.9989145
                ],
                [
                    90.6865396,
                    55.999239
                ],
                [
                    90.687135,
                    55.9991035
                ],
                [
                    90.6873873,
                    55.9992757
                ],
                [
                    90.6877961,
                    55.9993716
                ],
                [
                    90.6884016,
                    55.9991035
                ],
                [
                    90.6888103,
                    55.9992503
                ],
                [
                    90.6889718,
                    55.9990923
                ],
                [
                    90.6895168,
                    55.9992954
                ],
                [
                    90.6904705,
                    55.9995014
                ],
                [
                    90.6929785,
                    56.0002972
                ],
                [
                    90.6928473,
                    56.0004467
                ],
                [
                    90.6931752,
                    56.0008023
                ],
                [
                    90.6936445,
                    56.0012396
                ],
                [
                    90.6944671,
                    56.0013271
                ],
                [
                    90.6960516,
                    56.0014089
                ],
                [
                    90.6969548,
                    56.0016093
                ],
                [
                    90.6972223,
                    56.0015641
                ],
                [
                    90.697308,
                    56.0018152
                ],
                [
                    90.6975681,
                    56.0021011
                ],
                [
                    90.6980175,
                    56.0023436
                ],
                [
                    90.6990267,
                    56.0025111
                ],
                [
                    90.6999492,
                    56.0026743
                ],
                [
                    90.7011556,
                    56.0027977
                ],
                [
                    90.7027954,
                    56.0028374
                ],
                [
                    90.7037654,
                    56.0027051
                ],
                [
                    90.7050505,
                    56.0026302
                ],
                [
                    90.7056419,
                    56.0025156
                ],
                [
                    90.706178,
                    56.0022025
                ],
                [
                    90.7068088,
                    56.0020306
                ],
                [
                    90.7071794,
                    56.0021805
                ],
                [
                    90.7080855,
                    56.0018574
                ],
                [
                    90.7082675,
                    56.0017925
                ],
                [
                    90.7083649,
                    56.001089
                ],
                [
                    90.7070048,
                    56.0006206
                ],
                [
                    90.7068274,
                    56.0004662
                ],
                [
                    90.7070147,
                    56.0001356
                ],
                [
                    90.7072709,
                    56.0000309
                ],
                [
                    90.7078229,
                    55.9991049
                ],
                [
                    90.7073005,
                    55.9990443
                ],
                [
                    90.7071428,
                    55.99889
                ],
                [
                    90.7066993,
                    55.9988459
                ],
                [
                    90.7062557,
                    55.9985428
                ],
                [
                    90.7062064,
                    55.9980964
                ],
                [
                    90.7063445,
                    55.9978759
                ],
                [
                    90.7039594,
                    55.9967129
                ],
                [
                    90.7038806,
                    55.996294
                ],
                [
                    90.7035258,
                    55.9965255
                ],
                [
                    90.7022051,
                    55.9967515
                ],
                [
                    90.7010323,
                    55.9971043
                ],
                [
                    90.7004705,
                    55.9968287
                ],
                [
                    90.6990217,
                    55.9964539
                ],
                [
                    90.6975039,
                    55.9960129
                ],
                [
                    90.6969027,
                    55.9958696
                ],
                [
                    90.6970013,
                    55.9956988
                ],
                [
                    90.6952864,
                    55.9954011
                ],
                [
                    90.6948823,
                    55.9963216
                ],
                [
                    90.694695,
                    55.9963326
                ],
                [
                    90.6932561,
                    55.9970271
                ],
                [
                    90.6918072,
                    55.9967846
                ],
                [
                    90.6909104,
                    55.9964429
                ],
                [
                    90.6899643,
                    55.996294
                ],
                [
                    90.6887126,
                    55.9958366
                ],
                [
                    90.6874707,
                    55.9953901
                ],
                [
                    90.6865049,
                    55.9950759
                ],
                [
                    90.6853615,
                    55.9954838
                ],
                [
                    90.6837338,
                    55.9952336
                ],
                [
                    90.6832923,
                    55.995119
                ],
                [
                    90.6825275,
                    55.9951322
                ],
                [
                    90.681337,
                    55.9952248
                ],
                [
                    90.6802252,
                    55.994969
                ],
                [
                    90.6795077,
                    55.9951057
                ],
                [
                    90.6791766,
                    55.9950352
                ],
                [
                    90.679011,
                    55.9949073
                ],
                [
                    90.6792633,
                    55.9946868
                ],
                [
                    90.6792081,
                    55.9944531
                ],
                [
                    90.6791293,
                    55.9942723
                ],
                [
                    90.6785616,
                    55.9941709
                ],
                [
                    90.6777416,
                    55.9939548
                ],
                [
                    90.6745404,
                    55.9947838
                ],
                [
                    90.6727191,
                    55.9955555
                ],
                [
                    90.6694155,
                    55.9950572
                ],
                [
                    90.6698648,
                    55.9939504
                ],
                [
                    90.6688951,
                    55.9940033
                ],
                [
                    90.6686033,
                    55.9939019
                ],
                [
                    90.6687295,
                    55.9935138
                ],
                [
                    90.6686822,
                    55.9929053
                ],
                [
                    90.668351,
                    55.9925966
                ],
                [
                    90.6676729,
                    55.9921644
                ],
                [
                    90.6662222,
                    55.9922967
                ],
                [
                    90.6660799,
                    55.9923033
                ],
                [
                    90.6652097,
                    55.9922138
                ],
                [
                    90.6646082,
                    55.9923334
                ],
                [
                    90.6645678,
                    55.9925253
                ],
                [
                    90.6640874,
                    55.9928595
                ],
                [
                    90.6650373,
                    55.994844
                ],
                [
                    90.664107,
                    55.9950293
                ],
                [
                    90.6641147,
                    55.9956863
                ],
                [
                    90.6655104,
                    55.9954923
                ],
                [
                    90.665676,
                    55.9957789
                ],
                [
                    90.6660545,
                    55.996136
                ],
                [
                    90.666078,
                    55.9965549
                ],
                [
                    90.6651477,
                    55.9967798
                ],
                [
                    90.6652896,
                    55.9970797
                ],
                [
                    90.665061,
                    55.9972693
                ],
                [
                    90.6656287,
                    55.9978866
                ],
                [
                    90.6655576,
                    55.99954
                ],
                [
                    90.6656681,
                    55.9997384
                ],
                [
                    90.6650846,
                    55.99995
                ],
                [
                    90.6647929,
                    55.9998442
                ],
                [
                    90.6642173,
                    55.9999236
                ],
                [
                    90.6638703,
                    56.0001308
                ],
                [
                    90.664107,
                    56.0006951
                ],
                [
                    90.6638231,
                    56.001211
                ],
                [
                    90.6642173,
                    56.0015505
                ],
                [
                    90.6602933,
                    56.0022175
                ],
                [
                    90.6585193,
                    56.0023607
                ],
                [
                    90.6561243,
                    56.0025867
                ],
                [
                    90.6550501,
                    56.0027245
                ]
            ],
            "longitude": 90.671219,
            "latitude": 56.000298
        },
        "306": {
            "name": "Ястребово",
            "population": 839,
            "type": "village",
            "poly": [
                [
                    90.6597659,
                    56.1414655
                ],
                [
                    90.6604347,
                    56.1419375
                ],
                [
                    90.6617945,
                    56.1423474
                ],
                [
                    90.6608806,
                    56.1426206
                ],
                [
                    90.6605239,
                    56.1429435
                ],
                [
                    90.6603455,
                    56.1440613
                ],
                [
                    90.6633105,
                    56.1439371
                ],
                [
                    90.6636895,
                    56.1441358
                ],
                [
                    90.6646704,
                    56.1442352
                ],
                [
                    90.6650048,
                    56.1440241
                ],
                [
                    90.6652055,
                    56.1437508
                ],
                [
                    90.666922,
                    56.1436266
                ],
                [
                    90.6673233,
                    56.143875
                ],
                [
                    90.6669889,
                    56.1441234
                ],
                [
                    90.666387,
                    56.1445084
                ],
                [
                    90.6666991,
                    56.1449058
                ],
                [
                    90.6672342,
                    56.1452536
                ],
                [
                    90.6685718,
                    56.1456758
                ],
                [
                    90.6702883,
                    56.1458994
                ],
                [
                    90.6706005,
                    56.1453778
                ],
                [
                    90.6716259,
                    56.145117
                ],
                [
                    90.6713807,
                    56.144347
                ],
                [
                    90.6735432,
                    56.1434652
                ],
                [
                    90.677556,
                    56.1419499
                ],
                [
                    90.6779126,
                    56.1410308
                ],
                [
                    90.6789603,
                    56.1405712
                ],
                [
                    90.6798522,
                    56.1407078
                ],
                [
                    90.6811452,
                    56.1401613
                ],
                [
                    90.681591,
                    56.1398881
                ],
                [
                    90.6816133,
                    56.1396024
                ],
                [
                    90.6829732,
                    56.1391552
                ],
                [
                    90.6843777,
                    56.1380373
                ],
                [
                    90.6838427,
                    56.1371181
                ],
                [
                    90.6840656,
                    56.1358137
                ],
                [
                    90.6845338,
                    56.1350684
                ],
                [
                    90.6860274,
                    56.1339752
                ],
                [
                    90.6826834,
                    56.132621
                ],
                [
                    90.6811898,
                    56.133267
                ],
                [
                    90.6789381,
                    56.1323229
                ],
                [
                    90.6779795,
                    56.132062
                ],
                [
                    90.6782025,
                    56.1315526
                ],
                [
                    90.6759508,
                    56.1308693
                ],
                [
                    90.6753266,
                    56.1316644
                ],
                [
                    90.6735209,
                    56.1313662
                ],
                [
                    90.6667437,
                    56.1359876
                ],
                [
                    90.666231,
                    56.1367454
                ],
                [
                    90.6644252,
                    56.1368448
                ],
                [
                    90.6636895,
                    56.1377764
                ],
                [
                    90.6639793,
                    56.138323
                ],
                [
                    90.6648042,
                    56.1389068
                ],
                [
                    90.6644921,
                    56.1396024
                ],
                [
                    90.6631099,
                    56.1398135
                ],
                [
                    90.6623296,
                    56.1403601
                ],
                [
                    90.6608583,
                    56.1405961
                ],
                [
                    90.6597659,
                    56.1414655
                ]
            ],
            "longitude": 90.673477,
            "latitude": 56.138691
        },
        "307": {
            "name": "Берёзовка",
            "population": 359,
            "type": "village",
            "poly": [
                [
                    90.661087,
                    56.7892694
                ],
                [
                    90.6612889,
                    56.7897637
                ],
                [
                    90.6615732,
                    56.7900841
                ],
                [
                    90.6618388,
                    56.790282
                ],
                [
                    90.6618704,
                    56.7903527
                ],
                [
                    90.6620181,
                    56.7905708
                ],
                [
                    90.6623898,
                    56.7909492
                ],
                [
                    90.662593,
                    56.7911356
                ],
                [
                    90.6635212,
                    56.791813
                ],
                [
                    90.6640592,
                    56.7923228
                ],
                [
                    90.6645549,
                    56.7929352
                ],
                [
                    90.6653778,
                    56.7937916
                ],
                [
                    90.6658393,
                    56.7941483
                ],
                [
                    90.6662137,
                    56.7946928
                ],
                [
                    90.6658656,
                    56.7948098
                ],
                [
                    90.6659631,
                    56.7949917
                ],
                [
                    90.6659868,
                    56.7951751
                ],
                [
                    90.6663799,
                    56.7956445
                ],
                [
                    90.6670181,
                    56.7967796
                ],
                [
                    90.6670022,
                    56.7970467
                ],
                [
                    90.6671156,
                    56.7973312
                ],
                [
                    90.6670181,
                    56.7973991
                ],
                [
                    90.6669098,
                    56.7974207
                ],
                [
                    90.6667675,
                    56.7973991
                ],
                [
                    90.6665539,
                    56.7974352
                ],
                [
                    90.6663303,
                    56.7975615
                ],
                [
                    90.6664538,
                    56.7984669
                ],
                [
                    90.6666548,
                    56.7990987
                ],
                [
                    90.666866,
                    56.7993158
                ],
                [
                    90.6668763,
                    56.7995386
                ],
                [
                    90.6669948,
                    56.799784
                ],
                [
                    90.6672958,
                    56.7999917
                ],
                [
                    90.6668992,
                    56.800144
                ],
                [
                    90.6666469,
                    56.8003329
                ],
                [
                    90.6665026,
                    56.8006093
                ],
                [
                    90.6662091,
                    56.8006798
                ],
                [
                    90.6660648,
                    56.8009534
                ],
                [
                    90.6657352,
                    56.8011282
                ],
                [
                    90.6652562,
                    56.8014921
                ],
                [
                    90.6649163,
                    56.8015767
                ],
                [
                    90.6645351,
                    56.8018925
                ],
                [
                    90.6635874,
                    56.8023973
                ],
                [
                    90.6629023,
                    56.8026539
                ],
                [
                    90.6633865,
                    56.8030657
                ],
                [
                    90.6638398,
                    56.8033308
                ],
                [
                    90.6641334,
                    56.8036607
                ],
                [
                    90.6648493,
                    56.8041063
                ],
                [
                    90.6653747,
                    56.8042839
                ],
                [
                    90.6662503,
                    56.8039173
                ],
                [
                    90.6664459,
                    56.8036522
                ],
                [
                    90.6665696,
                    56.8035225
                ],
                [
                    90.6667808,
                    56.803531
                ],
                [
                    90.6672031,
                    56.803703
                ],
                [
                    90.6676255,
                    56.8038017
                ],
                [
                    90.6681457,
                    56.803813
                ],
                [
                    90.6686092,
                    56.8039483
                ],
                [
                    90.6690625,
                    56.8042473
                ],
                [
                    90.6707261,
                    56.8036494
                ],
                [
                    90.6711073,
                    56.8034357
                ],
                [
                    90.670837,
                    56.8031271
                ],
                [
                    90.6713083,
                    56.8029809
                ],
                [
                    90.6717929,
                    56.8029484
                ],
                [
                    90.6724423,
                    56.8028888
                ],
                [
                    90.672495,
                    56.8030115
                ],
                [
                    90.6722709,
                    56.8030332
                ],
                [
                    90.6723434,
                    56.8033689
                ],
                [
                    90.672495,
                    56.8036613
                ],
                [
                    90.6722445,
                    56.8037894
                ],
                [
                    90.6722775,
                    56.8038652
                ],
                [
                    90.6727884,
                    56.8041161
                ],
                [
                    90.6733686,
                    56.8041468
                ],
                [
                    90.6734312,
                    56.8042208
                ],
                [
                    90.6732499,
                    56.8043489
                ],
                [
                    90.6732895,
                    56.8044933
                ],
                [
                    90.6732928,
                    56.8046593
                ],
                [
                    90.6731312,
                    56.8046377
                ],
                [
                    90.6714534,
                    56.804625
                ],
                [
                    90.6712325,
                    56.8048759
                ],
                [
                    90.6711007,
                    56.8049535
                ],
                [
                    90.6713182,
                    56.8050257
                ],
                [
                    90.671427,
                    56.8052098
                ],
                [
                    90.6716808,
                    56.8052585
                ],
                [
                    90.6718127,
                    56.8053993
                ],
                [
                    90.6718687,
                    56.8057025
                ],
                [
                    90.672083,
                    56.8057728
                ],
                [
                    90.6721951,
                    56.8061067
                ],
                [
                    90.6723599,
                    56.8063179
                ],
                [
                    90.6723665,
                    56.8066066
                ],
                [
                    90.6720698,
                    56.8067221
                ],
                [
                    90.6714863,
                    56.8066589
                ],
                [
                    90.6714204,
                    56.8065868
                ],
                [
                    90.6708237,
                    56.8066788
                ],
                [
                    90.6704513,
                    56.8068376
                ],
                [
                    90.6721885,
                    56.808025
                ],
                [
                    90.6742949,
                    56.8075324
                ],
                [
                    90.6743608,
                    56.8071877
                ],
                [
                    90.6746052,
                    56.8068272
                ],
                [
                    90.6754985,
                    56.8065456
                ],
                [
                    90.6772126,
                    56.8062244
                ],
                [
                    90.6773741,
                    56.8056162
                ],
                [
                    90.6777203,
                    56.8057461
                ],
                [
                    90.6779935,
                    56.8061727
                ],
                [
                    90.6781941,
                    56.8061395
                ],
                [
                    90.6785817,
                    56.8058695
                ],
                [
                    90.6785632,
                    56.80578
                ],
                [
                    90.6786397,
                    56.8057324
                ],
                [
                    90.6787373,
                    56.8057194
                ],
                [
                    90.6789007,
                    56.8057482
                ],
                [
                    90.6789957,
                    56.805754
                ],
                [
                    90.6791856,
                    56.8057006
                ],
                [
                    90.6794651,
                    56.8053873
                ],
                [
                    90.6794731,
                    56.8052429
                ],
                [
                    90.6794203,
                    56.8051245
                ],
                [
                    90.6792621,
                    56.8050451
                ],
                [
                    90.6790563,
                    56.8049888
                ],
                [
                    90.6789852,
                    56.8049137
                ],
                [
                    90.6790247,
                    56.804791
                ],
                [
                    90.6790749,
                    56.8046784
                ],
                [
                    90.6789193,
                    56.8045427
                ],
                [
                    90.6788823,
                    56.8044387
                ],
                [
                    90.6790326,
                    56.8042741
                ],
                [
                    90.6793913,
                    56.8041254
                ],
                [
                    90.6795917,
                    56.8040922
                ],
                [
                    90.6797341,
                    56.8041139
                ],
                [
                    90.6802141,
                    56.8043232
                ],
                [
                    90.6803512,
                    56.8043463
                ],
                [
                    90.6805806,
                    56.8043218
                ],
                [
                    90.6814825,
                    56.8038381
                ],
                [
                    90.6817146,
                    56.8037847
                ],
                [
                    90.6818623,
                    56.8037327
                ],
                [
                    90.6820469,
                    56.8035681
                ],
                [
                    90.6820732,
                    56.8033486
                ],
                [
                    90.6820785,
                    56.8030411
                ],
                [
                    90.6821655,
                    56.8029487
                ],
                [
                    90.6824108,
                    56.802901
                ],
                [
                    90.6825901,
                    56.8029285
                ],
                [
                    90.6827853,
                    56.8030295
                ],
                [
                    90.6828881,
                    56.8030815
                ],
                [
                    90.6830701,
                    56.8030931
                ],
                [
                    90.6832257,
                    56.8030728
                ],
                [
                    90.6833021,
                    56.8030209
                ],
                [
                    90.6833338,
                    56.8028173
                ],
                [
                    90.6834207,
                    56.8027234
                ],
                [
                    90.6837083,
                    56.8026613
                ],
                [
                    90.6840432,
                    56.8025964
                ],
                [
                    90.6843121,
                    56.8024823
                ],
                [
                    90.684502,
                    56.8022729
                ],
                [
                    90.6846049,
                    56.8018658
                ],
                [
                    90.6847394,
                    56.8017185
                ],
                [
                    90.6850242,
                    56.8016347
                ],
                [
                    90.6854539,
                    56.8015337
                ],
                [
                    90.6856703,
                    56.8014586
                ],
                [
                    90.6857677,
                    56.8013243
                ],
                [
                    90.6859973,
                    56.8009012
                ],
                [
                    90.6861449,
                    56.8007395
                ],
                [
                    90.6864298,
                    56.8006514
                ],
                [
                    90.6867014,
                    56.8005908
                ],
                [
                    90.6866776,
                    56.8005662
                ],
                [
                    90.6855885,
                    56.7998875
                ],
                [
                    90.6829488,
                    56.7986341
                ],
                [
                    90.6825506,
                    56.7982024
                ],
                [
                    90.6814061,
                    56.7976204
                ],
                [
                    90.680636,
                    56.7980132
                ],
                [
                    90.6795311,
                    56.7978688
                ],
                [
                    90.678943,
                    56.7979468
                ],
                [
                    90.6787539,
                    56.7979218
                ],
                [
                    90.6786097,
                    56.7978682
                ],
                [
                    90.6782492,
                    56.7972505
                ],
                [
                    90.6776826,
                    56.7966611
                ],
                [
                    90.6768122,
                    56.796678
                ],
                [
                    90.6754524,
                    56.796898
                ],
                [
                    90.6746887,
                    56.7957664
                ],
                [
                    90.6734896,
                    56.7940198
                ],
                [
                    90.6749935,
                    56.7935505
                ],
                [
                    90.6747423,
                    56.7932097
                ],
                [
                    90.6743838,
                    56.7929705
                ],
                [
                    90.6740171,
                    56.7924876
                ],
                [
                    90.6742396,
                    56.7924018
                ],
                [
                    90.6742148,
                    56.7922687
                ],
                [
                    90.6738646,
                    56.7918986
                ],
                [
                    90.6733578,
                    56.7918738
                ],
                [
                    90.6728963,
                    56.7914766
                ],
                [
                    90.6727562,
                    56.7915262
                ],
                [
                    90.6724842,
                    56.7916391
                ],
                [
                    90.6723524,
                    56.7917835
                ],
                [
                    90.6718743,
                    56.7918376
                ],
                [
                    90.6707536,
                    56.7916707
                ],
                [
                    90.6703333,
                    56.791357
                ],
                [
                    90.6697894,
                    56.7913479
                ],
                [
                    90.6696287,
                    56.7911448
                ],
                [
                    90.6694722,
                    56.7907093
                ],
                [
                    90.6682813,
                    56.7893755
                ],
                [
                    90.668269,
                    56.7891588
                ],
                [
                    90.6670081,
                    56.7880575
                ],
                [
                    90.6658255,
                    56.7868455
                ],
                [
                    90.6647377,
                    56.7862902
                ],
                [
                    90.6638147,
                    56.7865678
                ],
                [
                    90.6624673,
                    56.7869064
                ],
                [
                    90.6623436,
                    56.7873804
                ],
                [
                    90.662352,
                    56.7877934
                ],
                [
                    90.6615608,
                    56.7879085
                ],
                [
                    90.6613713,
                    56.7881003
                ],
                [
                    90.661326,
                    56.788299
                ],
                [
                    90.661223,
                    56.7884231
                ],
                [
                    90.6612394,
                    56.7886849
                ],
                [
                    90.6613054,
                    56.7888835
                ],
                [
                    90.6611941,
                    56.7891566
                ],
                [
                    90.661087,
                    56.7892694
                ]
            ],
            "longitude": 90.6737279,
            "latitude": 56.7999154
        },
        "308": {
            "name": "Арефьево",
            "population": 390,
            "type": "village",
            "poly": [
                [
                    90.6654501,
                    57.0381423
                ],
                [
                    90.6655202,
                    57.038724
                ],
                [
                    90.6663279,
                    57.0387425
                ],
                [
                    90.6666596,
                    57.0388952
                ],
                [
                    90.6667999,
                    57.0391057
                ],
                [
                    90.6668148,
                    57.0394688
                ],
                [
                    90.6670847,
                    57.0394943
                ],
                [
                    90.6671251,
                    57.0396631
                ],
                [
                    90.667074,
                    57.0399545
                ],
                [
                    90.666938,
                    57.0400899
                ],
                [
                    90.6669827,
                    57.0402691
                ],
                [
                    90.6665576,
                    57.0404345
                ],
                [
                    90.666666,
                    57.0407571
                ],
                [
                    90.6679222,
                    57.0404703
                ],
                [
                    90.6681845,
                    57.040442
                ],
                [
                    90.6681222,
                    57.0402297
                ],
                [
                    90.668256,
                    57.0402263
                ],
                [
                    90.6684253,
                    57.0402161
                ],
                [
                    90.6697206,
                    57.0403245
                ],
                [
                    90.6697995,
                    57.039534
                ],
                [
                    90.6704139,
                    57.0390461
                ],
                [
                    90.6706465,
                    57.0390144
                ],
                [
                    90.6707585,
                    57.0388179
                ],
                [
                    90.6710948,
                    57.0387547
                ],
                [
                    90.6714104,
                    57.038775
                ],
                [
                    90.6716915,
                    57.0389298
                ],
                [
                    90.6716996,
                    57.0385901
                ],
                [
                    90.6721132,
                    57.0379813
                ],
                [
                    90.6724537,
                    57.0377475
                ],
                [
                    90.6730132,
                    57.0366753
                ],
                [
                    90.6732808,
                    57.0362341
                ],
                [
                    90.6730336,
                    57.0353819
                ],
                [
                    90.673598,
                    57.0355866
                ],
                [
                    90.6747916,
                    57.0358902
                ],
                [
                    90.6750316,
                    57.0360243
                ],
                [
                    90.6757322,
                    57.0360949
                ],
                [
                    90.6785995,
                    57.0366526
                ],
                [
                    90.6798451,
                    57.0369844
                ],
                [
                    90.6803186,
                    57.0369808
                ],
                [
                    90.6806689,
                    57.0367832
                ],
                [
                    90.6814732,
                    57.0364408
                ],
                [
                    90.682148,
                    57.0352266
                ],
                [
                    90.6822907,
                    57.0350254
                ],
                [
                    90.682401,
                    57.0347147
                ],
                [
                    90.6823621,
                    57.033977
                ],
                [
                    90.6825769,
                    57.0333173
                ],
                [
                    90.6827014,
                    57.0330038
                ],
                [
                    90.6824575,
                    57.0327073
                ],
                [
                    90.6822136,
                    57.0321933
                ],
                [
                    90.6814819,
                    57.0317697
                ],
                [
                    90.6819177,
                    57.0314421
                ],
                [
                    90.6819593,
                    57.0312077
                ],
                [
                    90.6818502,
                    57.0307756
                ],
                [
                    90.6817413,
                    57.0306259
                ],
                [
                    90.6814715,
                    57.0303266
                ],
                [
                    90.6802778,
                    57.0290698
                ],
                [
                    90.6800339,
                    57.0287224
                ],
                [
                    90.6797069,
                    57.028375
                ],
                [
                    90.6818502,
                    57.0284823
                ],
                [
                    90.6820268,
                    57.0283976
                ],
                [
                    90.6824004,
                    57.0283044
                ],
                [
                    90.6831841,
                    57.0272452
                ],
                [
                    90.6832308,
                    57.0270447
                ],
                [
                    90.6823381,
                    57.0267933
                ],
                [
                    90.6816374,
                    57.0266493
                ],
                [
                    90.680828,
                    57.0265419
                ],
                [
                    90.6798056,
                    57.0265165
                ],
                [
                    90.6806359,
                    57.0255901
                ],
                [
                    90.6808228,
                    57.025285
                ],
                [
                    90.6806567,
                    57.0250873
                ],
                [
                    90.6798938,
                    57.0245139
                ],
                [
                    90.6794319,
                    57.0247229
                ],
                [
                    90.6789026,
                    57.0248246
                ],
                [
                    90.6779114,
                    57.0247568
                ],
                [
                    90.6775014,
                    57.0246777
                ],
                [
                    90.6776414,
                    57.0243529
                ],
                [
                    90.6781656,
                    57.0244009
                ],
                [
                    90.6784251,
                    57.0238925
                ],
                [
                    90.6778802,
                    57.0235818
                ],
                [
                    90.6772263,
                    57.0236496
                ],
                [
                    90.6767799,
                    57.0234999
                ],
                [
                    90.6759808,
                    57.0230394
                ],
                [
                    90.6757836,
                    57.0221016
                ],
                [
                    90.6758822,
                    57.0216863
                ],
                [
                    90.6758562,
                    57.0213756
                ],
                [
                    90.6762662,
                    57.0206411
                ],
                [
                    90.6767177,
                    57.0207089
                ],
                [
                    90.6769409,
                    57.0203445
                ],
                [
                    90.677299,
                    57.0203756
                ],
                [
                    90.6776674,
                    57.019723
                ],
                [
                    90.6779633,
                    57.0191156
                ],
                [
                    90.6783006,
                    57.0188021
                ],
                [
                    90.6797277,
                    57.018432
                ],
                [
                    90.6803297,
                    57.0175279
                ],
                [
                    90.6807761,
                    57.0175788
                ],
                [
                    90.6814611,
                    57.0169629
                ],
                [
                    90.6817206,
                    57.0159514
                ],
                [
                    90.680859,
                    57.015851
                ],
                [
                    90.6812326,
                    57.015399
                ],
                [
                    90.6817724,
                    57.0145598
                ],
                [
                    90.6821564,
                    57.0137461
                ],
                [
                    90.6818917,
                    57.0132771
                ],
                [
                    90.6822083,
                    57.0130002
                ],
                [
                    90.6834175,
                    57.0122147
                ],
                [
                    90.6844399,
                    57.0116976
                ],
                [
                    90.6854622,
                    57.0108414
                ],
                [
                    90.6841491,
                    57.0098976
                ],
                [
                    90.6840466,
                    57.0098459
                ],
                [
                    90.6838638,
                    57.0097987
                ],
                [
                    90.6833708,
                    57.0099598
                ],
                [
                    90.6827117,
                    57.0100898
                ],
                [
                    90.6822394,
                    57.0101209
                ],
                [
                    90.6816477,
                    57.010248
                ],
                [
                    90.6815129,
                    57.0103158
                ],
                [
                    90.6815181,
                    57.0103837
                ],
                [
                    90.6815855,
                    57.0104515
                ],
                [
                    90.6815544,
                    57.010556
                ],
                [
                    90.6812845,
                    57.0106945
                ],
                [
                    90.6804853,
                    57.0114574
                ],
                [
                    90.6790737,
                    57.0124775
                ],
                [
                    90.6778956,
                    57.013198
                ],
                [
                    90.6773041,
                    57.0136444
                ],
                [
                    90.6747352,
                    57.0150232
                ],
                [
                    90.6722233,
                    57.0164867
                ],
                [
                    90.671694,
                    57.0168342
                ],
                [
                    90.6721922,
                    57.0174727
                ],
                [
                    90.6725399,
                    57.0183739
                ],
                [
                    90.6723567,
                    57.0190544
                ],
                [
                    90.6725884,
                    57.019081
                ],
                [
                    90.6726137,
                    57.0195083
                ],
                [
                    90.672504,
                    57.0203498
                ],
                [
                    90.6722462,
                    57.0203961
                ],
                [
                    90.6722994,
                    57.0209081
                ],
                [
                    90.6725304,
                    57.0211945
                ],
                [
                    90.6727086,
                    57.0213347
                ],
                [
                    90.6730354,
                    57.0214881
                ],
                [
                    90.6730673,
                    57.0216327
                ],
                [
                    90.6726873,
                    57.0221158
                ],
                [
                    90.6726235,
                    57.0222893
                ],
                [
                    90.6727325,
                    57.0223862
                ],
                [
                    90.6730912,
                    57.0225164
                ],
                [
                    90.6735137,
                    57.0226668
                ],
                [
                    90.6733196,
                    57.0231123
                ],
                [
                    90.6729583,
                    57.0232453
                ],
                [
                    90.672682,
                    57.0233003
                ],
                [
                    90.6727484,
                    57.0234868
                ],
                [
                    90.672961,
                    57.0235794
                ],
                [
                    90.6728972,
                    57.0236994
                ],
                [
                    90.6728174,
                    57.0237009
                ],
                [
                    90.6726714,
                    57.0239395
                ],
                [
                    90.6725146,
                    57.0240379
                ],
                [
                    90.6724189,
                    57.0242664
                ],
                [
                    90.6729344,
                    57.0244341
                ],
                [
                    90.6732904,
                    57.0245715
                ],
                [
                    90.673511,
                    57.0247291
                ],
                [
                    90.6735774,
                    57.0248564
                ],
                [
                    90.6733755,
                    57.0253366
                ],
                [
                    90.6732373,
                    57.0253857
                ],
                [
                    90.6726288,
                    57.025377
                ],
                [
                    90.6725172,
                    57.0256764
                ],
                [
                    90.6723126,
                    57.0259382
                ],
                [
                    90.6719327,
                    57.0259642
                ],
                [
                    90.6713986,
                    57.0263127
                ],
                [
                    90.6709416,
                    57.02668
                ],
                [
                    90.6707317,
                    57.0267466
                ],
                [
                    90.6706784,
                    57.0266771
                ],
                [
                    90.6706626,
                    57.0265007
                ],
                [
                    90.6705032,
                    57.0264472
                ],
                [
                    90.6697326,
                    57.026521
                ],
                [
                    90.6693579,
                    57.026829
                ],
                [
                    90.6677371,
                    57.0269736
                ],
                [
                    90.6671632,
                    57.0269837
                ],
                [
                    90.6667114,
                    57.0270661
                ],
                [
                    90.6670383,
                    57.0272238
                ],
                [
                    90.6669772,
                    57.0273684
                ],
                [
                    90.6668549,
                    57.0274233
                ],
                [
                    90.6666928,
                    57.0273828
                ],
                [
                    90.6665653,
                    57.0274132
                ],
                [
                    90.6665148,
                    57.0275144
                ],
                [
                    90.6668284,
                    57.0278282
                ],
                [
                    90.6669373,
                    57.0282288
                ],
                [
                    90.6668921,
                    57.0284515
                ],
                [
                    90.6665175,
                    57.0287306
                ],
                [
                    90.6661056,
                    57.0288361
                ],
                [
                    90.6660312,
                    57.028946
                ],
                [
                    90.6659329,
                    57.029001
                ],
                [
                    90.6657416,
                    57.0292121
                ],
                [
                    90.6657496,
                    57.0292743
                ],
                [
                    90.6658877,
                    57.0293842
                ],
                [
                    90.6659542,
                    57.0294695
                ],
                [
                    90.6664378,
                    57.0295809
                ],
                [
                    90.6668656,
                    57.0297833
                ],
                [
                    90.6670542,
                    57.0298411
                ],
                [
                    90.6669825,
                    57.0299163
                ],
                [
                    90.6669958,
                    57.0299959
                ],
                [
                    90.6672429,
                    57.0300233
                ],
                [
                    90.6674847,
                    57.0300768
                ],
                [
                    90.6676574,
                    57.0300335
                ],
                [
                    90.6677158,
                    57.0298325
                ],
                [
                    90.6678965,
                    57.0297847
                ],
                [
                    90.6682393,
                    57.0298686
                ],
                [
                    90.6685236,
                    57.0300175
                ],
                [
                    90.6685714,
                    57.0301072
                ],
                [
                    90.6684279,
                    57.0302504
                ],
                [
                    90.6687415,
                    57.0303487
                ],
                [
                    90.6687627,
                    57.0305555
                ],
                [
                    90.6693234,
                    57.0310399
                ],
                [
                    90.6691587,
                    57.031452
                ],
                [
                    90.6686325,
                    57.031611
                ],
                [
                    90.6687734,
                    57.0319002
                ],
                [
                    90.6685608,
                    57.0319016
                ],
                [
                    90.6682765,
                    57.0320057
                ],
                [
                    90.6677564,
                    57.0334846
                ],
                [
                    90.6674844,
                    57.0341809
                ],
                [
                    90.6675843,
                    57.0343579
                ],
                [
                    90.66758,
                    57.0345129
                ],
                [
                    90.6676969,
                    57.0345788
                ],
                [
                    90.6675906,
                    57.0349859
                ],
                [
                    90.6672101,
                    57.0352601
                ],
                [
                    90.6671187,
                    57.0355295
                ],
                [
                    90.6663109,
                    57.0365393
                ],
                [
                    90.6661048,
                    57.0368573
                ],
                [
                    90.6661494,
                    57.0370378
                ],
                [
                    90.6662918,
                    57.0372298
                ],
                [
                    90.6660878,
                    57.0373234
                ],
                [
                    90.6658391,
                    57.0375524
                ],
                [
                    90.6656478,
                    57.0376681
                ],
                [
                    90.6654501,
                    57.0381423
                ]
            ],
            "longitude": 90.674637,
            "latitude": 57.028027
        },
        "309": {
            "name": "Берёзовый",
            "population": 377,
            "type": "village",
            "poly": [
                [
                    90.6692533,
                    56.2446475
                ],
                [
                    90.6704393,
                    56.2448995
                ],
                [
                    90.6733693,
                    56.2453356
                ],
                [
                    90.6731077,
                    56.2471089
                ],
                [
                    90.675375,
                    56.2472834
                ],
                [
                    90.675689,
                    56.2470024
                ],
                [
                    90.6765436,
                    56.246983
                ],
                [
                    90.6769273,
                    56.2457716
                ],
                [
                    90.6823863,
                    56.2467213
                ],
                [
                    90.6825084,
                    56.2450158
                ],
                [
                    90.6858571,
                    56.2457813
                ],
                [
                    90.6859791,
                    56.247671
                ],
                [
                    90.6944206,
                    56.2455584
                ],
                [
                    90.6929676,
                    56.243846
                ],
                [
                    90.6917902,
                    56.2430343
                ],
                [
                    90.6864925,
                    56.2419561
                ],
                [
                    90.6862091,
                    56.2411445
                ],
                [
                    90.6857296,
                    56.2408416
                ],
                [
                    90.6851191,
                    56.2398603
                ],
                [
                    90.6845304,
                    56.2377037
                ],
                [
                    90.6819797,
                    56.2373281
                ],
                [
                    90.679429,
                    56.237316
                ],
                [
                    90.6778375,
                    56.237425
                ],
                [
                    90.6769001,
                    56.2379096
                ],
                [
                    90.6751342,
                    56.2376794
                ],
                [
                    90.6737825,
                    56.2386487
                ],
                [
                    90.6741313,
                    56.2390606
                ],
                [
                    90.6740005,
                    56.239412
                ],
                [
                    90.6735863,
                    56.2395453
                ],
                [
                    90.6739568,
                    56.2408052
                ],
                [
                    90.6729977,
                    56.2411929
                ],
                [
                    90.6727796,
                    56.241726
                ],
                [
                    90.6733901,
                    56.2420894
                ],
                [
                    90.6722346,
                    56.2429859
                ],
                [
                    90.6707009,
                    56.2428934
                ],
                [
                    90.6697765,
                    56.2431066
                ],
                [
                    90.6692533,
                    56.2446475
                ]
            ],
            "longitude": 90.679634,
            "latitude": 56.242836
        },
        "310": {
            "name": "Сахапта",
            "population": 1191,
            "type": "village",
            "poly": [
                [
                    90.6645535,
                    55.7651199
                ],
                [
                    90.6645535,
                    55.766808
                ],
                [
                    90.6647905,
                    55.7680937
                ],
                [
                    90.6680092,
                    55.7685463
                ],
                [
                    90.669233,
                    55.7689141
                ],
                [
                    90.6720325,
                    55.7680559
                ],
                [
                    90.6739604,
                    55.7686689
                ],
                [
                    90.6753015,
                    55.7688952
                ],
                [
                    90.6757709,
                    55.7687444
                ],
                [
                    90.678034,
                    55.7668488
                ],
                [
                    90.6790063,
                    55.7674901
                ],
                [
                    90.6794087,
                    55.7675656
                ],
                [
                    90.6802301,
                    55.768188
                ],
                [
                    90.6812695,
                    55.7678956
                ],
                [
                    90.6826944,
                    55.7683389
                ],
                [
                    90.6834823,
                    55.7686595
                ],
                [
                    90.6859466,
                    55.7710358
                ],
                [
                    90.6885618,
                    55.7701494
                ],
                [
                    90.68826,
                    55.7697062
                ],
                [
                    90.6905567,
                    55.768933
                ],
                [
                    90.6916296,
                    55.7680654
                ],
                [
                    90.6938472,
                    55.767586
                ],
                [
                    90.6961873,
                    55.7666359
                ],
                [
                    90.6971603,
                    55.7662727
                ],
                [
                    90.6974606,
                    55.7662244
                ],
                [
                    90.6978212,
                    55.7659347
                ],
                [
                    90.697744,
                    55.7657946
                ],
                [
                    90.697538,
                    55.7655918
                ],
                [
                    90.6968342,
                    55.7656015
                ],
                [
                    90.6961819,
                    55.7653359
                ],
                [
                    90.6962333,
                    55.7650462
                ],
                [
                    90.6952978,
                    55.764824
                ],
                [
                    90.6947227,
                    55.7645391
                ],
                [
                    90.694903,
                    55.7644909
                ],
                [
                    90.6957012,
                    55.7644957
                ],
                [
                    90.6963793,
                    55.7642977
                ],
                [
                    90.6971517,
                    55.7646599
                ],
                [
                    90.6985165,
                    55.7636748
                ],
                [
                    90.6985508,
                    55.7634382
                ],
                [
                    90.7008425,
                    55.7631484
                ],
                [
                    90.7008126,
                    55.7630743
                ],
                [
                    90.7008167,
                    55.7629697
                ],
                [
                    90.7044302,
                    55.7627476
                ],
                [
                    90.7042157,
                    55.762313
                ],
                [
                    90.7043272,
                    55.7618397
                ],
                [
                    90.704662,
                    55.7616128
                ],
                [
                    90.7046534,
                    55.7614148
                ],
                [
                    90.7044732,
                    55.7612892
                ],
                [
                    90.7041641,
                    55.7606518
                ],
                [
                    90.7036921,
                    55.7600239
                ],
                [
                    90.7037608,
                    55.7592609
                ],
                [
                    90.7034446,
                    55.7591128
                ],
                [
                    90.7042343,
                    55.7587225
                ],
                [
                    90.7044608,
                    55.7587187
                ],
                [
                    90.7047286,
                    55.7588037
                ],
                [
                    90.7050857,
                    55.7587844
                ],
                [
                    90.7053123,
                    55.7586955
                ],
                [
                    90.7055252,
                    55.7582666
                ],
                [
                    90.705635,
                    55.7579073
                ],
                [
                    90.705278,
                    55.7575093
                ],
                [
                    90.7058547,
                    55.757235
                ],
                [
                    90.7057861,
                    55.7561802
                ],
                [
                    90.705635,
                    55.7558943
                ],
                [
                    90.7056282,
                    55.7555272
                ],
                [
                    90.7058684,
                    55.7552838
                ],
                [
                    90.7058204,
                    55.754963
                ],
                [
                    90.7054771,
                    55.7543912
                ],
                [
                    90.7049209,
                    55.7542096
                ],
                [
                    90.7035339,
                    55.7544878
                ],
                [
                    90.7030051,
                    55.75448
                ],
                [
                    90.7028129,
                    55.753912
                ],
                [
                    90.7025108,
                    55.7532203
                ],
                [
                    90.7014877,
                    55.7525441
                ],
                [
                    90.6977042,
                    55.7507781
                ],
                [
                    90.6953215,
                    55.7499125
                ],
                [
                    90.6928344,
                    55.749058
                ],
                [
                    90.6893599,
                    55.749116
                ],
                [
                    90.6886183,
                    55.7490696
                ],
                [
                    90.686373,
                    55.7496648
                ],
                [
                    90.6854529,
                    55.7500396
                ],
                [
                    90.6854649,
                    55.7499304
                ],
                [
                    90.6851216,
                    55.7500271
                ],
                [
                    90.6849018,
                    55.750286
                ],
                [
                    90.6846272,
                    55.7504831
                ],
                [
                    90.6843113,
                    55.7510705
                ],
                [
                    90.6837002,
                    55.7515033
                ],
                [
                    90.6832264,
                    55.7523341
                ],
                [
                    90.6827183,
                    55.7529717
                ],
                [
                    90.6813038,
                    55.7542314
                ],
                [
                    90.6803836,
                    55.7548381
                ],
                [
                    90.6795872,
                    55.7555645
                ],
                [
                    90.6793606,
                    55.7561363
                ],
                [
                    90.6787357,
                    55.7560552
                ],
                [
                    90.6782207,
                    55.7559354
                ],
                [
                    90.6776508,
                    55.7560591
                ],
                [
                    90.6773487,
                    55.7560088
                ],
                [
                    90.67728,
                    55.7557654
                ],
                [
                    90.6771702,
                    55.7556804
                ],
                [
                    90.6746845,
                    55.7556611
                ],
                [
                    90.6745883,
                    55.7572028
                ],
                [
                    90.6733867,
                    55.7584778
                ],
                [
                    90.6733798,
                    55.7586586
                ],
                [
                    90.6734142,
                    55.7588371
                ],
                [
                    90.6727001,
                    55.7587676
                ],
                [
                    90.671471,
                    55.7587792
                ],
                [
                    90.6718873,
                    55.759458
                ],
                [
                    90.6720382,
                    55.7607974
                ],
                [
                    90.6726417,
                    55.7627969
                ],
                [
                    90.6722915,
                    55.7629354
                ],
                [
                    90.6721172,
                    55.7629354
                ],
                [
                    90.6713662,
                    55.7625129
                ],
                [
                    90.6708833,
                    55.7625355
                ],
                [
                    90.669663,
                    55.7629354
                ],
                [
                    90.6691533,
                    55.7630184
                ],
                [
                    90.6685497,
                    55.7629882
                ],
                [
                    90.6675574,
                    55.7627242
                ],
                [
                    90.6662968,
                    55.764452
                ],
                [
                    90.665653,
                    55.7647689
                ],
                [
                    90.6645535,
                    55.7651199
                ]
            ],
            "longitude": 90.687187,
            "latitude": 55.757648
        },
        "311": {
            "name": "Петропавловка",
            "population": 403,
            "type": "village",
            "poly": [
                [
                    90.6947435,
                    55.3878529
                ],
                [
                    90.6954044,
                    55.3879169
                ],
                [
                    90.6958625,
                    55.3880577
                ],
                [
                    90.6958475,
                    55.3882411
                ],
                [
                    90.6955921,
                    55.3886933
                ],
                [
                    90.6956297,
                    55.3887871
                ],
                [
                    90.6954494,
                    55.3894868
                ],
                [
                    90.6952617,
                    55.390148
                ],
                [
                    90.6955546,
                    55.3906257
                ],
                [
                    90.6957799,
                    55.3908091
                ],
                [
                    90.6953443,
                    55.3908859
                ],
                [
                    90.695119,
                    55.3912187
                ],
                [
                    90.6954945,
                    55.3920078
                ],
                [
                    90.6959752,
                    55.3924258
                ],
                [
                    90.6967638,
                    55.3926434
                ],
                [
                    90.6979579,
                    55.3927884
                ],
                [
                    90.6986113,
                    55.3927927
                ],
                [
                    90.699122,
                    55.3928054
                ],
                [
                    90.7003237,
                    55.3927073
                ],
                [
                    90.7010747,
                    55.3925325
                ],
                [
                    90.7011724,
                    55.3919737
                ],
                [
                    90.7016155,
                    55.3907665
                ],
                [
                    90.701607,
                    55.3905203
                ],
                [
                    90.7012898,
                    55.3899306
                ],
                [
                    90.7014004,
                    55.3889123
                ],
                [
                    90.7012033,
                    55.3882161
                ],
                [
                    90.7008572,
                    55.3877274
                ],
                [
                    90.7018329,
                    55.3880741
                ],
                [
                    90.7025684,
                    55.388541
                ],
                [
                    90.702876,
                    55.3886311
                ],
                [
                    90.7037603,
                    55.3895157
                ],
                [
                    90.7041449,
                    55.3896877
                ],
                [
                    90.7045246,
                    55.3897777
                ],
                [
                    90.7041112,
                    55.3899552
                ],
                [
                    90.7038902,
                    55.3901572
                ],
                [
                    90.7036025,
                    55.3907016
                ],
                [
                    90.7035785,
                    55.3910906
                ],
                [
                    90.7039991,
                    55.3913841
                ],
                [
                    90.7041973,
                    55.3913977
                ],
                [
                    90.70466,
                    55.3914387
                ],
                [
                    90.7050866,
                    55.3916195
                ],
                [
                    90.70609,
                    55.3917424
                ],
                [
                    90.7077002,
                    55.3917833
                ],
                [
                    90.7089259,
                    55.3919301
                ],
                [
                    90.7101516,
                    55.3925272
                ],
                [
                    90.7113653,
                    55.39279
                ],
                [
                    90.7112331,
                    55.3928719
                ],
                [
                    90.7108545,
                    55.3929538
                ],
                [
                    90.7102597,
                    55.3934042
                ],
                [
                    90.709731,
                    55.3938888
                ],
                [
                    90.7094546,
                    55.3943017
                ],
                [
                    90.7102656,
                    55.3945064
                ],
                [
                    90.7109447,
                    55.3947623
                ],
                [
                    90.7111429,
                    55.3947418
                ],
                [
                    90.7117485,
                    55.3947973
                ],
                [
                    90.711614,
                    55.3949146
                ],
                [
                    90.7117582,
                    55.3952559
                ],
                [
                    90.7120033,
                    55.3955261
                ],
                [
                    90.7121667,
                    55.3957745
                ],
                [
                    90.7121475,
                    55.3960393
                ],
                [
                    90.7118975,
                    55.3960666
                ],
                [
                    90.7117966,
                    55.3964651
                ],
                [
                    90.7114842,
                    55.3966453
                ],
                [
                    90.7110852,
                    55.3976634
                ],
                [
                    90.7133231,
                    55.398164
                ],
                [
                    90.7136884,
                    55.3979947
                ],
                [
                    90.7141835,
                    55.3976781
                ],
                [
                    90.7146737,
                    55.3972414
                ],
                [
                    90.7149429,
                    55.3968729
                ],
                [
                    90.7155651,
                    55.3955268
                ],
                [
                    90.7157959,
                    55.3952211
                ],
                [
                    90.7164562,
                    55.3948342
                ],
                [
                    90.7172022,
                    55.3945241
                ],
                [
                    90.7174483,
                    55.3944236
                ],
                [
                    90.7183249,
                    55.394131
                ],
                [
                    90.719021,
                    55.394
                ],
                [
                    90.7213628,
                    55.3937707
                ],
                [
                    90.7219127,
                    55.3932422
                ],
                [
                    90.7220434,
                    55.3929976
                ],
                [
                    90.7220281,
                    55.3927071
                ],
                [
                    90.721832,
                    55.3925237
                ],
                [
                    90.721582,
                    55.3924538
                ],
                [
                    90.7214128,
                    55.3923227
                ],
                [
                    90.7209591,
                    55.3922266
                ],
                [
                    90.7210126,
                    55.3921927
                ],
                [
                    90.7215592,
                    55.3918864
                ],
                [
                    90.7216974,
                    55.3916338
                ],
                [
                    90.7215592,
                    55.3913335
                ],
                [
                    90.7212287,
                    55.3911322
                ],
                [
                    90.7212107,
                    55.3909616
                ],
                [
                    90.7211386,
                    55.3907909
                ],
                [
                    90.720694,
                    55.3906169
                ],
                [
                    90.7198408,
                    55.390436
                ],
                [
                    90.7190837,
                    55.390146
                ],
                [
                    90.7186331,
                    55.3897296
                ],
                [
                    90.7183207,
                    55.3893918
                ],
                [
                    90.7182726,
                    55.3890983
                ],
                [
                    90.7184228,
                    55.388699
                ],
                [
                    90.718543,
                    55.3885215
                ],
                [
                    90.7190777,
                    55.3882417
                ],
                [
                    90.7193181,
                    55.3880676
                ],
                [
                    90.7196726,
                    55.3876615
                ],
                [
                    90.7197927,
                    55.3872622
                ],
                [
                    90.7196485,
                    55.3871257
                ],
                [
                    90.7189456,
                    55.3869141
                ],
                [
                    90.7190417,
                    55.386624
                ],
                [
                    90.7190837,
                    55.3862554
                ],
                [
                    90.7190958,
                    55.3859038
                ],
                [
                    90.7188975,
                    55.3858287
                ],
                [
                    90.7185971,
                    55.3858492
                ],
                [
                    90.7171731,
                    55.3853953
                ],
                [
                    90.7162779,
                    55.3849994
                ],
                [
                    90.715677,
                    55.3847195
                ],
                [
                    90.7150221,
                    55.3852758
                ],
                [
                    90.714956,
                    55.3846581
                ],
                [
                    90.7146917,
                    55.3837945
                ],
                [
                    90.7141509,
                    55.3833986
                ],
                [
                    90.7137484,
                    55.3832382
                ],
                [
                    90.7119218,
                    55.3828662
                ],
                [
                    90.7111161,
                    55.3827803
                ],
                [
                    90.7107931,
                    55.3828955
                ],
                [
                    90.7100721,
                    55.3832965
                ],
                [
                    90.7098168,
                    55.3832282
                ],
                [
                    90.7092911,
                    55.3832197
                ],
                [
                    90.7082922,
                    55.3833221
                ],
                [
                    90.7063395,
                    55.3836848
                ],
                [
                    90.7054458,
                    55.3839578
                ],
                [
                    90.7058964,
                    55.3833477
                ],
                [
                    90.7051153,
                    55.3831984
                ],
                [
                    90.7042216,
                    55.3829339
                ],
                [
                    90.7031701,
                    55.3830661
                ],
                [
                    90.7027045,
                    55.3831259
                ],
                [
                    90.7023365,
                    55.3830107
                ],
                [
                    90.7017507,
                    55.3835269
                ],
                [
                    90.7014127,
                    55.3834586
                ],
                [
                    90.7009621,
                    55.3836122
                ],
                [
                    90.7005415,
                    55.3836848
                ],
                [
                    90.7000833,
                    55.384073
                ],
                [
                    90.6992497,
                    55.3843759
                ],
                [
                    90.6985888,
                    55.3845253
                ],
                [
                    90.6982133,
                    55.3847471
                ],
                [
                    90.6982058,
                    55.3849306
                ],
                [
                    90.6984085,
                    55.3850372
                ],
                [
                    90.6988291,
                    55.3850585
                ],
                [
                    90.6993923,
                    55.3850927
                ],
                [
                    90.6997153,
                    55.3852676
                ],
                [
                    90.699843,
                    55.3854468
                ],
                [
                    90.6998205,
                    55.3856942
                ],
                [
                    90.6995802,
                    55.3859374
                ],
                [
                    90.6991971,
                    55.3860825
                ],
                [
                    90.6989042,
                    55.3862403
                ],
                [
                    90.6983334,
                    55.386236
                ],
                [
                    90.6975974,
                    55.3863256
                ],
                [
                    90.6972368,
                    55.3866029
                ],
                [
                    90.6967562,
                    55.3868589
                ],
                [
                    90.6962531,
                    55.3869485
                ],
                [
                    90.6953969,
                    55.3868845
                ],
                [
                    90.6953368,
                    55.3869954
                ],
                [
                    90.695517,
                    55.3872812
                ],
                [
                    90.6955621,
                    55.3875287
                ],
                [
                    90.6953218,
                    55.3876823
                ],
                [
                    90.6947435,
                    55.3878529
                ]
            ],
            "longitude": 90.710175,
            "latitude": 55.389595
        },
        "312": {
            "name": "Толстый Мыс",
            "population": 669,
            "type": "village",
            "poly": [
                [
                    90.7309483,
                    54.9651661
                ],
                [
                    90.7318389,
                    54.9651761
                ],
                [
                    90.7324472,
                    54.9651411
                ],
                [
                    90.7324863,
                    54.9651935
                ],
                [
                    90.7341329,
                    54.9655227
                ],
                [
                    90.7351277,
                    54.9657547
                ],
                [
                    90.7367092,
                    54.9663507
                ],
                [
                    90.7375607,
                    54.9665178
                ],
                [
                    90.7382037,
                    54.9665977
                ],
                [
                    90.7384165,
                    54.9666924
                ],
                [
                    90.7411275,
                    54.9674581
                ],
                [
                    90.7412666,
                    54.9675379
                ],
                [
                    90.7420529,
                    54.9677399
                ],
                [
                    90.7415099,
                    54.9683359
                ],
                [
                    90.743252,
                    54.9687973
                ],
                [
                    90.743769,
                    54.9682486
                ],
                [
                    90.7444945,
                    54.9683983
                ],
                [
                    90.7451071,
                    54.9686302
                ],
                [
                    90.7457545,
                    54.9687599
                ],
                [
                    90.7465017,
                    54.9687848
                ],
                [
                    90.7475183,
                    54.9687898
                ],
                [
                    90.7479484,
                    54.9688796
                ],
                [
                    90.7482135,
                    54.9689993
                ],
                [
                    90.7486262,
                    54.9693434
                ],
                [
                    90.7489607,
                    54.9695953
                ],
                [
                    90.7499294,
                    54.9699993
                ],
                [
                    90.7510982,
                    54.9703759
                ],
                [
                    90.7536876,
                    54.9710193
                ],
                [
                    90.754413,
                    54.9711739
                ],
                [
                    90.7559206,
                    54.9712736
                ],
                [
                    90.756064,
                    54.9714133
                ],
                [
                    90.7573239,
                    54.9717424
                ],
                [
                    90.7576976,
                    54.971912
                ],
                [
                    90.757993,
                    54.9720092
                ],
                [
                    90.7584557,
                    54.9720789
                ],
                [
                    90.7581298,
                    54.9723812
                ],
                [
                    90.7578692,
                    54.9728239
                ],
                [
                    90.7579235,
                    54.9729111
                ],
                [
                    90.7583797,
                    54.9731231
                ],
                [
                    90.7640981,
                    54.9750338
                ],
                [
                    90.7665365,
                    54.975361
                ],
                [
                    90.7675357,
                    54.9754202
                ],
                [
                    90.7689749,
                    54.9756384
                ],
                [
                    90.7703814,
                    54.9758036
                ],
                [
                    90.7731224,
                    54.9756343
                ],
                [
                    90.7753541,
                    54.9756684
                ],
                [
                    90.7775349,
                    54.9759654
                ],
                [
                    90.778918,
                    54.9760628
                ],
                [
                    90.7827025,
                    54.9768615
                ],
                [
                    90.7833219,
                    54.9761505
                ],
                [
                    90.7838565,
                    54.9753323
                ],
                [
                    90.7838989,
                    54.9749038
                ],
                [
                    90.7836018,
                    54.9746749
                ],
                [
                    90.783254,
                    54.9744996
                ],
                [
                    90.782694,
                    54.9744801
                ],
                [
                    90.7823121,
                    54.9742853
                ],
                [
                    90.7793422,
                    54.9736229
                ],
                [
                    90.7788162,
                    54.9733648
                ],
                [
                    90.7783664,
                    54.9729167
                ],
                [
                    90.7774076,
                    54.9716943
                ],
                [
                    90.7760754,
                    54.9704377
                ],
                [
                    90.7760414,
                    54.9700724
                ],
                [
                    90.7758632,
                    54.9698483
                ],
                [
                    90.7749214,
                    54.9694928
                ],
                [
                    90.7741492,
                    54.9691275
                ],
                [
                    90.7735213,
                    54.9689618
                ],
                [
                    90.7724266,
                    54.9685819
                ],
                [
                    90.7719599,
                    54.9684602
                ],
                [
                    90.7712726,
                    54.9680266
                ],
                [
                    90.7709926,
                    54.9677295
                ],
                [
                    90.7709417,
                    54.9675931
                ],
                [
                    90.7709423,
                    54.9674531
                ],
                [
                    90.7708612,
                    54.9671206
                ],
                [
                    90.7707024,
                    54.9669724
                ],
                [
                    90.767248,
                    54.9671396
                ],
                [
                    90.7664877,
                    54.9670922
                ],
                [
                    90.7658651,
                    54.9669914
                ],
                [
                    90.7642658,
                    54.9665788
                ],
                [
                    90.7630989,
                    54.9663091
                ],
                [
                    90.755483,
                    54.9643987
                ],
                [
                    90.7480582,
                    54.9635581
                ],
                [
                    90.7403129,
                    54.9630359
                ],
                [
                    90.7392945,
                    54.9629221
                ],
                [
                    90.7382518,
                    54.9626707
                ],
                [
                    90.7361317,
                    54.9619424
                ],
                [
                    90.733794,
                    54.961123
                ],
                [
                    90.7309483,
                    54.9651661
                ]
            ],
            "longitude": 90.753609,
            "latitude": 54.966999
        },
        "313": {
            "name": "Лапшиха",
            "population": 434,
            "type": "village",
            "poly": [
                [
                    90.7307584,
                    56.4500714
                ],
                [
                    90.7320871,
                    56.450604
                ],
                [
                    90.7352845,
                    56.4513463
                ],
                [
                    90.7374307,
                    56.4522742
                ],
                [
                    90.740891,
                    56.4527179
                ],
                [
                    90.7418108,
                    56.4527502
                ],
                [
                    90.741913,
                    56.4522903
                ],
                [
                    90.74476,
                    56.4530245
                ],
                [
                    90.744103,
                    56.4538314
                ],
                [
                    90.7458842,
                    56.454146
                ],
                [
                    90.7470668,
                    56.4544526
                ],
                [
                    90.7486875,
                    56.4544042
                ],
                [
                    90.7504249,
                    56.4543235
                ],
                [
                    90.7520601,
                    56.4547027
                ],
                [
                    90.7532427,
                    56.4547834
                ],
                [
                    90.7637695,
                    56.4584632
                ],
                [
                    90.764901,
                    56.4588161
                ],
                [
                    90.7666306,
                    56.4590274
                ],
                [
                    90.7678169,
                    56.4595921
                ],
                [
                    90.7706275,
                    56.4603584
                ],
                [
                    90.7714671,
                    56.4603988
                ],
                [
                    90.7736022,
                    56.4610038
                ],
                [
                    90.7751354,
                    56.4610139
                ],
                [
                    90.7761026,
                    56.4606105
                ],
                [
                    90.7760844,
                    56.4601971
                ],
                [
                    90.7748067,
                    56.4596122
                ],
                [
                    90.7745696,
                    56.4592593
                ],
                [
                    90.7749529,
                    56.4587148
                ],
                [
                    90.7744966,
                    56.4576963
                ],
                [
                    90.7719416,
                    56.4565265
                ],
                [
                    90.7687113,
                    56.4556391
                ],
                [
                    90.7695873,
                    56.4548222
                ],
                [
                    90.7691858,
                    56.4541465
                ],
                [
                    90.7670323,
                    56.453027
                ],
                [
                    90.7666672,
                    56.4524421
                ],
                [
                    90.7649517,
                    56.4522605
                ],
                [
                    90.765189,
                    56.4515142
                ],
                [
                    90.763802,
                    56.4508989
                ],
                [
                    90.7626704,
                    56.4509393
                ],
                [
                    90.7618126,
                    56.4506569
                ],
                [
                    90.7602356,
                    56.450005
                ],
                [
                    90.7592966,
                    56.4507378
                ],
                [
                    90.7569207,
                    56.4498472
                ],
                [
                    90.756601,
                    56.4500618
                ],
                [
                    90.7558628,
                    56.4506608
                ],
                [
                    90.7553302,
                    56.4511153
                ],
                [
                    90.7541622,
                    56.4515542
                ],
                [
                    90.75291,
                    56.4514406
                ],
                [
                    90.7494059,
                    56.450604
                ],
                [
                    90.7408764,
                    56.4491677
                ],
                [
                    90.7348319,
                    56.4487077
                ],
                [
                    90.7341165,
                    56.4494178
                ],
                [
                    90.7313279,
                    56.448974
                ],
                [
                    90.730846,
                    56.4492887
                ],
                [
                    90.7307584,
                    56.4500714
                ]
            ],
            "longitude": 90.758537,
            "latitude": 56.453716
        },
        "314": {
            "name": "Бараит",
            "population": 450,
            "type": "village",
            "poly": null,
            "longitude": 90.758591,
            "latitude": 55.158764
        },
        "315": {
            "name": "Покровка",
            "population": 319,
            "type": "village",
            "poly": [
                [
                    90.7488434,
                    56.2900425
                ],
                [
                    90.7503155,
                    56.2901484
                ],
                [
                    90.7511197,
                    56.2914268
                ],
                [
                    90.7490751,
                    56.2922286
                ],
                [
                    90.7514331,
                    56.2936204
                ],
                [
                    90.7518556,
                    56.2944146
                ],
                [
                    90.7520738,
                    56.2953752
                ],
                [
                    90.7556586,
                    56.2954433
                ],
                [
                    90.7575805,
                    56.2949743
                ],
                [
                    90.7581666,
                    56.2946718
                ],
                [
                    90.7605246,
                    56.2945205
                ],
                [
                    90.7629099,
                    56.295466
                ],
                [
                    90.7644911,
                    56.2957232
                ],
                [
                    90.7666329,
                    56.2957708
                ],
                [
                    90.7678937,
                    56.2956195
                ],
                [
                    90.7679959,
                    56.296442
                ],
                [
                    90.7676722,
                    56.2978507
                ],
                [
                    90.7678767,
                    56.2978885
                ],
                [
                    90.7674894,
                    56.2988219
                ],
                [
                    90.761475,
                    56.3035012
                ],
                [
                    90.7634344,
                    56.304352
                ],
                [
                    90.766433,
                    56.3043803
                ],
                [
                    90.7697214,
                    56.3024615
                ],
                [
                    90.770437,
                    56.301743
                ],
                [
                    90.7699769,
                    56.2988314
                ],
                [
                    90.7687502,
                    56.2982169
                ],
                [
                    90.7696191,
                    56.2955035
                ],
                [
                    90.7730097,
                    56.2951254
                ],
                [
                    90.7755313,
                    56.2945581
                ],
                [
                    90.7763151,
                    56.2941326
                ],
                [
                    90.7758891,
                    56.2935275
                ],
                [
                    90.7773543,
                    56.2926387
                ],
                [
                    90.7780529,
                    56.2919579
                ],
                [
                    90.7767921,
                    56.2915703
                ],
                [
                    90.7761617,
                    56.2911637
                ],
                [
                    90.7754973,
                    56.2901897
                ],
                [
                    90.7737253,
                    56.2904167
                ],
                [
                    90.773572,
                    56.290133
                ],
                [
                    90.7704198,
                    56.290237
                ],
                [
                    90.7684606,
                    56.2904639
                ],
                [
                    90.7680857,
                    56.2901046
                ],
                [
                    90.7681194,
                    56.288415
                ],
                [
                    90.7622946,
                    56.2878726
                ],
                [
                    90.7618759,
                    56.2887309
                ],
                [
                    90.7609938,
                    56.2893909
                ],
                [
                    90.7585539,
                    56.2903592
                ],
                [
                    90.7575862,
                    56.2914636
                ],
                [
                    90.7559096,
                    56.2919629
                ],
                [
                    90.7548192,
                    56.2920763
                ],
                [
                    90.7522237,
                    56.2914268
                ],
                [
                    90.7515013,
                    56.2913436
                ],
                [
                    90.7505199,
                    56.2897853
                ],
                [
                    90.7491705,
                    56.2896567
                ],
                [
                    90.7488434,
                    56.2900425
                ]
            ],
            "longitude": 90.765564,
            "latitude": 56.292179
        },
        "316": {
            "name": "Новоникольск",
            "population": 150,
            "type": "village",
            "poly": [
                [
                    90.7504213,
                    56.6685051
                ],
                [
                    90.7508624,
                    56.6689151
                ],
                [
                    90.7514843,
                    56.6691947
                ],
                [
                    90.7518572,
                    56.6690973
                ],
                [
                    90.7520076,
                    56.6691991
                ],
                [
                    90.7520772,
                    56.6693804
                ],
                [
                    90.7531482,
                    56.6701503
                ],
                [
                    90.7534898,
                    56.6702616
                ],
                [
                    90.7548735,
                    56.6698353
                ],
                [
                    90.7575599,
                    56.6692882
                ],
                [
                    90.7589667,
                    56.6691228
                ],
                [
                    90.7607152,
                    56.6687187
                ],
                [
                    90.7608367,
                    56.6686329
                ],
                [
                    90.7607383,
                    56.6684483
                ],
                [
                    90.7636677,
                    56.6683338
                ],
                [
                    90.7649705,
                    56.6682066
                ],
                [
                    90.7652194,
                    56.669021
                ],
                [
                    90.7659663,
                    56.6690846
                ],
                [
                    90.7659431,
                    56.6687919
                ],
                [
                    90.7671995,
                    56.6687272
                ],
                [
                    90.7670936,
                    56.6681802
                ],
                [
                    90.7670719,
                    56.6681006
                ],
                [
                    90.7678101,
                    56.668041
                ],
                [
                    90.7687654,
                    56.6680847
                ],
                [
                    90.7695904,
                    56.6682319
                ],
                [
                    90.7700391,
                    56.6682358
                ],
                [
                    90.7713489,
                    56.6679336
                ],
                [
                    90.771935,
                    56.6677785
                ],
                [
                    90.7728832,
                    56.6676592
                ],
                [
                    90.7739687,
                    56.6674644
                ],
                [
                    90.7750687,
                    56.6674166
                ],
                [
                    90.7754161,
                    56.6674286
                ],
                [
                    90.7769141,
                    56.6673172
                ],
                [
                    90.7772686,
                    56.6673331
                ],
                [
                    90.7777536,
                    56.6674286
                ],
                [
                    90.7784122,
                    56.6673649
                ],
                [
                    90.7789549,
                    56.6671462
                ],
                [
                    90.7798813,
                    56.6669196
                ],
                [
                    90.7811694,
                    56.6667167
                ],
                [
                    90.7816905,
                    56.6666372
                ],
                [
                    90.7818714,
                    56.66651
                ],
                [
                    90.7819727,
                    56.6662594
                ],
                [
                    90.7819872,
                    56.6660168
                ],
                [
                    90.7818497,
                    56.6657504
                ],
                [
                    90.7826096,
                    56.6657027
                ],
                [
                    90.7825371,
                    56.6655118
                ],
                [
                    90.7819365,
                    56.6655317
                ],
                [
                    90.7817556,
                    56.6648238
                ],
                [
                    90.7816181,
                    56.6647959
                ],
                [
                    90.7816109,
                    56.6646647
                ],
                [
                    90.7809017,
                    56.6647124
                ],
                [
                    90.7808943,
                    56.664784
                ],
                [
                    90.7801707,
                    56.6648198
                ],
                [
                    90.7794905,
                    56.6649033
                ],
                [
                    90.7774062,
                    56.6649073
                ],
                [
                    90.7764799,
                    56.6646607
                ],
                [
                    90.7758937,
                    56.6645494
                ],
                [
                    90.7745404,
                    56.6645613
                ],
                [
                    90.7738022,
                    56.6647442
                ],
                [
                    90.772268,
                    56.6647641
                ],
                [
                    90.7688955,
                    56.6650664
                ],
                [
                    90.7670719,
                    56.6651817
                ],
                [
                    90.7665653,
                    56.6653567
                ],
                [
                    90.7657909,
                    56.6653527
                ],
                [
                    90.7652844,
                    56.6654641
                ],
                [
                    90.7642206,
                    56.6654959
                ],
                [
                    90.7641627,
                    56.6652374
                ],
                [
                    90.7631712,
                    56.6652215
                ],
                [
                    90.7630771,
                    56.6655197
                ],
                [
                    90.7617817,
                    56.6655754
                ],
                [
                    90.7597844,
                    56.6657623
                ],
                [
                    90.7596396,
                    56.6655754
                ],
                [
                    90.7571863,
                    56.66616
                ],
                [
                    90.7551672,
                    56.6666412
                ],
                [
                    90.7518527,
                    56.6676791
                ],
                [
                    90.7515922,
                    56.6675519
                ],
                [
                    90.7510639,
                    56.6677268
                ],
                [
                    90.7512303,
                    56.6679018
                ],
                [
                    90.7507599,
                    56.6680688
                ],
                [
                    90.7509987,
                    56.6683273
                ],
                [
                    90.7504213,
                    56.6685051
                ]
            ],
            "longitude": 90.7655715,
            "latitude": 56.6668693
        },
        "317": {
            "name": "Николаевка",
            "population": 309,
            "type": "village",
            "poly": [
                [
                    90.7546552,
                    55.108672
                ],
                [
                    90.7551818,
                    55.1090163
                ],
                [
                    90.7559302,
                    55.1096686
                ],
                [
                    90.7566152,
                    55.1101103
                ],
                [
                    90.7573754,
                    55.110416
                ],
                [
                    90.7581159,
                    55.1106131
                ],
                [
                    90.7585673,
                    55.1106878
                ],
                [
                    90.7596324,
                    55.1108033
                ],
                [
                    90.7603848,
                    55.1107105
                ],
                [
                    90.7606738,
                    55.1107331
                ],
                [
                    90.7609747,
                    55.110681
                ],
                [
                    90.7612123,
                    55.1105837
                ],
                [
                    90.7617904,
                    55.1104523
                ],
                [
                    90.762123,
                    55.1102734
                ],
                [
                    90.7625428,
                    55.1098543
                ],
                [
                    90.7628318,
                    55.1096664
                ],
                [
                    90.7630813,
                    55.109569
                ],
                [
                    90.763299,
                    55.1095373
                ],
                [
                    90.7636237,
                    55.1095803
                ],
                [
                    90.7640672,
                    55.109723
                ],
                [
                    90.764289,
                    55.1098113
                ],
                [
                    90.7646057,
                    55.1100627
                ],
                [
                    90.7650096,
                    55.1104478
                ],
                [
                    90.765267,
                    55.1106199
                ],
                [
                    90.7656234,
                    55.1109302
                ],
                [
                    90.7659005,
                    55.1111091
                ],
                [
                    90.7663795,
                    55.1115802
                ],
                [
                    90.7678051,
                    55.1123797
                ],
                [
                    90.7681892,
                    55.1127284
                ],
                [
                    90.7682526,
                    55.1129142
                ],
                [
                    90.7684466,
                    55.1130546
                ],
                [
                    90.7686802,
                    55.1131406
                ],
                [
                    90.7692979,
                    55.1132742
                ],
                [
                    90.7703234,
                    55.1135483
                ],
                [
                    90.7707432,
                    55.1136049
                ],
                [
                    90.7711786,
                    55.1135958
                ],
                [
                    90.7716262,
                    55.1135166
                ],
                [
                    90.7718994,
                    55.1134192
                ],
                [
                    90.7722003,
                    55.1133716
                ],
                [
                    90.7725844,
                    55.1132335
                ],
                [
                    90.7734397,
                    55.1130002
                ],
                [
                    90.7739584,
                    55.1127828
                ],
                [
                    90.7741603,
                    55.1125835
                ],
                [
                    90.7743346,
                    55.1121917
                ],
                [
                    90.7746988,
                    55.1120626
                ],
                [
                    90.7750116,
                    55.111972
                ],
                [
                    90.7752651,
                    55.1119471
                ],
                [
                    90.7756768,
                    55.1118112
                ],
                [
                    90.7760214,
                    55.1115236
                ],
                [
                    90.7762827,
                    55.1110162
                ],
                [
                    90.7759738,
                    55.1104546
                ],
                [
                    90.7754433,
                    55.1097819
                ],
                [
                    90.7753443,
                    55.1097162
                ],
                [
                    90.7749206,
                    55.1095622
                ],
                [
                    90.7745721,
                    55.1093742
                ],
                [
                    90.7743979,
                    55.1092881
                ],
                [
                    90.7740653,
                    55.1090752
                ],
                [
                    90.7738554,
                    55.1090186
                ],
                [
                    90.7735545,
                    55.1089914
                ],
                [
                    90.7731942,
                    55.1089891
                ],
                [
                    90.7725963,
                    55.1089348
                ],
                [
                    90.7723429,
                    55.1088057
                ],
                [
                    90.7719548,
                    55.1084682
                ],
                [
                    90.7719548,
                    55.1080265
                ],
                [
                    90.7721211,
                    55.1076324
                ],
                [
                    90.7725448,
                    55.1071386
                ],
                [
                    90.7729289,
                    55.1068283
                ],
                [
                    90.7735981,
                    55.1065429
                ],
                [
                    90.7740019,
                    55.1064681
                ],
                [
                    90.7755619,
                    55.1062779
                ],
                [
                    90.7758312,
                    55.1062688
                ],
                [
                    90.7767579,
                    55.1061669
                ],
                [
                    90.7771023,
                    55.1060989
                ],
                [
                    90.7774666,
                    55.1059721
                ],
                [
                    90.7777952,
                    55.1059132
                ],
                [
                    90.7777121,
                    55.1053944
                ],
                [
                    90.7776131,
                    55.1050819
                ],
                [
                    90.7772568,
                    55.1046265
                ],
                [
                    90.7767381,
                    55.1041146
                ],
                [
                    90.776635,
                    55.1038133
                ],
                [
                    90.7767103,
                    55.1035007
                ],
                [
                    90.7771736,
                    55.1028075
                ],
                [
                    90.7782071,
                    55.1019875
                ],
                [
                    90.7795058,
                    55.1011787
                ],
                [
                    90.7729012,
                    55.1027826
                ],
                [
                    90.7720934,
                    55.1029593
                ],
                [
                    90.7647206,
                    55.1040059
                ],
                [
                    90.7647561,
                    55.1042369
                ],
                [
                    90.7644949,
                    55.1044363
                ],
                [
                    90.7637346,
                    55.1046039
                ],
                [
                    90.7610183,
                    55.1056617
                ],
                [
                    90.7594028,
                    55.1061895
                ],
                [
                    90.7546552,
                    55.108672
                ]
            ],
            "longitude": 90.767502,
            "latitude": 55.107368
        },
        "318": {
            "name": "Бобровка",
            "population": 203,
            "type": "village",
            "poly": [
                [
                    90.8030517,
                    56.6244621
                ],
                [
                    90.8031169,
                    56.6246452
                ],
                [
                    90.805505,
                    56.6254175
                ],
                [
                    90.8047957,
                    56.6261421
                ],
                [
                    90.8045281,
                    56.6264924
                ],
                [
                    90.8045715,
                    56.626791
                ],
                [
                    90.8050057,
                    56.6274518
                ],
                [
                    90.8053625,
                    56.6276733
                ],
                [
                    90.8053891,
                    56.6279136
                ],
                [
                    90.805961,
                    56.6283555
                ],
                [
                    90.8066195,
                    56.6283077
                ],
                [
                    90.806786,
                    56.6285266
                ],
                [
                    90.8075097,
                    56.6283634
                ],
                [
                    90.8082406,
                    56.6283117
                ],
                [
                    90.8090873,
                    56.6283953
                ],
                [
                    90.809963,
                    56.6277026
                ],
                [
                    90.8099702,
                    56.6273284
                ],
                [
                    90.8108531,
                    56.6267273
                ],
                [
                    90.8160999,
                    56.6242869
                ],
                [
                    90.8168308,
                    56.6240042
                ],
                [
                    90.8171782,
                    56.6237813
                ],
                [
                    90.8185315,
                    56.6233433
                ],
                [
                    90.8211585,
                    56.6220733
                ],
                [
                    90.8210644,
                    56.6219697
                ],
                [
                    90.8218387,
                    56.621703
                ],
                [
                    90.8223019,
                    56.6213367
                ],
                [
                    90.8230835,
                    56.6209903
                ],
                [
                    90.8231841,
                    56.6206272
                ],
                [
                    90.8227035,
                    56.6200983
                ],
                [
                    90.8224774,
                    56.6197173
                ],
                [
                    90.822647,
                    56.6193518
                ],
                [
                    90.8225763,
                    56.6188307
                ],
                [
                    90.8210074,
                    56.6177419
                ],
                [
                    90.8197494,
                    56.6173997
                ],
                [
                    90.8186611,
                    56.6162098
                ],
                [
                    90.8159613,
                    56.6146932
                ],
                [
                    90.8131767,
                    56.6136665
                ],
                [
                    90.8124418,
                    56.6133242
                ],
                [
                    90.8106326,
                    56.6130831
                ],
                [
                    90.8100247,
                    56.613402
                ],
                [
                    90.8097103,
                    56.6137773
                ],
                [
                    90.8097403,
                    56.613882
                ],
                [
                    90.8099357,
                    56.6140652
                ],
                [
                    90.8112456,
                    56.6148098
                ],
                [
                    90.8105509,
                    56.6151682
                ],
                [
                    90.8102542,
                    56.615232
                ],
                [
                    90.8099647,
                    56.6155266
                ],
                [
                    90.8098851,
                    56.6158452
                ],
                [
                    90.81037,
                    56.6161837
                ],
                [
                    90.8109996,
                    56.6167332
                ],
                [
                    90.8110502,
                    56.6169841
                ],
                [
                    90.8123367,
                    56.6192065
                ],
                [
                    90.8124669,
                    56.6194175
                ],
                [
                    90.8119097,
                    56.6193299
                ],
                [
                    90.8114827,
                    56.6193618
                ],
                [
                    90.8111281,
                    56.6195051
                ],
                [
                    90.8108531,
                    56.6195091
                ],
                [
                    90.8108531,
                    56.6197719
                ],
                [
                    90.8103393,
                    56.6199909
                ],
                [
                    90.8100209,
                    56.6198038
                ],
                [
                    90.8085083,
                    56.6207474
                ],
                [
                    90.8083419,
                    56.6217308
                ],
                [
                    90.8076327,
                    56.6218782
                ],
                [
                    90.8067281,
                    56.6222683
                ],
                [
                    90.8057294,
                    56.622977
                ],
                [
                    90.8042675,
                    56.6237335
                ],
                [
                    90.8036886,
                    56.6241356
                ],
                [
                    90.803428,
                    56.6241236
                ],
                [
                    90.8031603,
                    56.6242112
                ],
                [
                    90.8030517,
                    56.6244621
                ]
            ],
            "longitude": 90.8142908,
            "latitude": 56.6209582
        },
        "319": {
            "name": "Новоназимово",
            "population": 1054,
            "type": "village",
            "poly": null,
            "longitude": 90.8200784,
            "latitude": 59.5707365
        },
        "320": {
            "name": "Тарутино",
            "population": 1318,
            "type": "village",
            "poly": [
                [
                    90.8099157,
                    56.29726
                ],
                [
                    90.8100466,
                    56.2978106
                ],
                [
                    90.8110389,
                    56.2977682
                ],
                [
                    90.8142884,
                    56.2985427
                ],
                [
                    90.8157932,
                    56.2981736
                ],
                [
                    90.8183775,
                    56.2969332
                ],
                [
                    90.8189118,
                    56.2964734
                ],
                [
                    90.8220086,
                    56.2970058
                ],
                [
                    90.8217905,
                    56.2974536
                ],
                [
                    90.8226629,
                    56.2978408
                ],
                [
                    90.8339379,
                    56.2987544
                ],
                [
                    90.8338943,
                    56.2994502
                ],
                [
                    90.8317789,
                    56.3006663
                ],
                [
                    90.8305249,
                    56.2998132
                ],
                [
                    90.8292818,
                    56.2995047
                ],
                [
                    90.8273953,
                    56.300025
                ],
                [
                    90.8273844,
                    56.3008599
                ],
                [
                    90.826185,
                    56.3013923
                ],
                [
                    90.8229028,
                    56.3023603
                ],
                [
                    90.8210708,
                    56.3034432
                ],
                [
                    90.8207873,
                    56.3036489
                ],
                [
                    90.8205365,
                    56.304762
                ],
                [
                    90.8210236,
                    56.3047795
                ],
                [
                    90.8214336,
                    56.3046537
                ],
                [
                    90.8213202,
                    56.3041939
                ],
                [
                    90.8215819,
                    56.3041165
                ],
                [
                    90.8216866,
                    56.3037777
                ],
                [
                    90.822524,
                    56.3035986
                ],
                [
                    90.8227421,
                    56.3037148
                ],
                [
                    90.8232044,
                    56.3036906
                ],
                [
                    90.8232568,
                    56.3038213
                ],
                [
                    90.8223146,
                    56.3041891
                ],
                [
                    90.8228293,
                    56.3045763
                ],
                [
                    90.8238499,
                    56.3045569
                ],
                [
                    90.8266153,
                    56.3037051
                ],
                [
                    90.8278715,
                    56.3038987
                ],
                [
                    90.8277842,
                    56.3055296
                ],
                [
                    90.8304013,
                    56.3057426
                ],
                [
                    90.8327668,
                    56.3070351
                ],
                [
                    90.8321066,
                    56.307484
                ],
                [
                    90.8331501,
                    56.3080866
                ],
                [
                    90.832213,
                    56.3085828
                ],
                [
                    90.833001,
                    56.3090553
                ],
                [
                    90.832852,
                    56.3092207
                ],
                [
                    90.834641,
                    56.3099059
                ],
                [
                    90.8386875,
                    56.3095397
                ],
                [
                    90.8404765,
                    56.3092207
                ],
                [
                    90.8409237,
                    56.3088545
                ],
                [
                    90.8414774,
                    56.3092443
                ],
                [
                    90.8419034,
                    56.3092443
                ],
                [
                    90.8467378,
                    56.3066452
                ],
                [
                    90.8465462,
                    56.3063616
                ],
                [
                    90.8457693,
                    56.3058096
                ],
                [
                    90.8437793,
                    56.3051896
                ],
                [
                    90.8416257,
                    56.304267
                ],
                [
                    90.8391313,
                    56.3044863
                ],
                [
                    90.8380681,
                    56.3050157
                ],
                [
                    90.8371822,
                    56.3042973
                ],
                [
                    90.8350286,
                    56.3028303
                ],
                [
                    90.8382999,
                    56.2998128
                ],
                [
                    90.8387302,
                    56.2985667
                ],
                [
                    90.8396287,
                    56.2985667
                ],
                [
                    90.8400386,
                    56.2983053
                ],
                [
                    90.8470594,
                    56.2983791
                ],
                [
                    90.8575819,
                    56.298364
                ],
                [
                    90.8611532,
                    56.2977665
                ],
                [
                    90.8593267,
                    56.2967379
                ],
                [
                    90.8592177,
                    56.2961177
                ],
                [
                    90.8577456,
                    56.2962765
                ],
                [
                    90.8556873,
                    56.296216
                ],
                [
                    90.8554421,
                    56.295558
                ],
                [
                    90.8558101,
                    56.2946352
                ],
                [
                    90.854079,
                    56.2943175
                ],
                [
                    90.8526342,
                    56.2941587
                ],
                [
                    90.853043,
                    56.2939545
                ],
                [
                    90.8534657,
                    56.2929863
                ],
                [
                    90.8530159,
                    56.2926535
                ],
                [
                    90.8512848,
                    56.2919122
                ],
                [
                    90.8502489,
                    56.2906186
                ],
                [
                    90.8484769,
                    56.2894234
                ],
                [
                    90.8468316,
                    56.2888502
                ],
                [
                    90.846692,
                    56.2892685
                ],
                [
                    90.8471945,
                    56.2898611
                ],
                [
                    90.8474666,
                    56.2903104
                ],
                [
                    90.8472154,
                    56.2912709
                ],
                [
                    90.846043,
                    56.2909881
                ],
                [
                    90.8446205,
                    56.2909524
                ],
                [
                    90.8436827,
                    56.2903956
                ],
                [
                    90.8422542,
                    56.2902141
                ],
                [
                    90.8409675,
                    56.2898631
                ],
                [
                    90.8386776,
                    56.2895484
                ],
                [
                    90.8374235,
                    56.2889674
                ],
                [
                    90.8337598,
                    56.2889069
                ],
                [
                    90.8310446,
                    56.2889553
                ],
                [
                    90.8284671,
                    56.289259
                ],
                [
                    90.8274651,
                    56.2899454
                ],
                [
                    90.8257859,
                    56.2901451
                ],
                [
                    90.8244227,
                    56.2906293
                ],
                [
                    90.8230489,
                    56.2913373
                ],
                [
                    90.8225364,
                    56.2919546
                ],
                [
                    90.8211002,
                    56.2934628
                ],
                [
                    90.8200861,
                    56.2931119
                ],
                [
                    90.8185704,
                    56.2930392
                ],
                [
                    90.8170765,
                    56.2931845
                ],
                [
                    90.8157025,
                    56.2949877
                ],
                [
                    90.8131291,
                    56.2943523
                ],
                [
                    90.8108534,
                    56.2972055
                ],
                [
                    90.8099157,
                    56.29726
                ]
            ],
            "longitude": 90.835228,
            "latitude": 56.295097
        },
        "321": {
            "name": "Светлолобово",
            "population": 927,
            "type": "village",
            "poly": [
                [
                    90.8181276,
                    55.0931157
                ],
                [
                    90.8186078,
                    55.0934439
                ],
                [
                    90.8188612,
                    55.0938179
                ],
                [
                    90.8197549,
                    55.0941461
                ],
                [
                    90.8201017,
                    55.09394
                ],
                [
                    90.8203818,
                    55.0940011
                ],
                [
                    90.8205419,
                    55.0947338
                ],
                [
                    90.8223959,
                    55.0951613
                ],
                [
                    90.8236097,
                    55.0951613
                ],
                [
                    90.8249436,
                    55.0948865
                ],
                [
                    90.8273712,
                    55.0948102
                ],
                [
                    90.8285717,
                    55.0949552
                ],
                [
                    90.8308126,
                    55.093879
                ],
                [
                    90.83268,
                    55.0929859
                ],
                [
                    90.8346408,
                    55.0928027
                ],
                [
                    90.8360947,
                    55.0928943
                ],
                [
                    90.8374344,
                    55.0936
                ],
                [
                    90.8385015,
                    55.094764
                ],
                [
                    90.8386015,
                    55.0973304
                ],
                [
                    90.838118,
                    55.097836
                ],
                [
                    90.8383513,
                    55.0988759
                ],
                [
                    90.8411192,
                    55.1002401
                ],
                [
                    90.8437035,
                    55.102415
                ],
                [
                    90.8442871,
                    55.1027775
                ],
                [
                    90.8454208,
                    55.1025676
                ],
                [
                    90.8466547,
                    55.1021097
                ],
                [
                    90.8471215,
                    55.1013085
                ],
                [
                    90.8469381,
                    55.1004308
                ],
                [
                    90.8472716,
                    55.0995627
                ],
                [
                    90.8492191,
                    55.0980624
                ],
                [
                    90.8506696,
                    55.0968604
                ],
                [
                    90.8519034,
                    55.0965169
                ],
                [
                    90.8532873,
                    55.0963547
                ],
                [
                    90.8551547,
                    55.0952289
                ],
                [
                    90.8562885,
                    55.0940268
                ],
                [
                    90.8572338,
                    55.0911349
                ],
                [
                    90.8580448,
                    55.0899428
                ],
                [
                    90.8592661,
                    55.0891359
                ],
                [
                    90.8596103,
                    55.0887795
                ],
                [
                    90.860867,
                    55.0880666
                ],
                [
                    90.8616265,
                    55.0878039
                ],
                [
                    90.8632163,
                    55.0876976
                ],
                [
                    90.8649319,
                    55.0873067
                ],
                [
                    90.8654345,
                    55.0864969
                ],
                [
                    90.8666802,
                    55.0845612
                ],
                [
                    90.8664943,
                    55.0843204
                ],
                [
                    90.8666037,
                    55.0838013
                ],
                [
                    90.8663773,
                    55.0832397
                ],
                [
                    90.8653666,
                    55.0822139
                ],
                [
                    90.8649295,
                    55.0816385
                ],
                [
                    90.8646562,
                    55.0815009
                ],
                [
                    90.864099,
                    55.0813695
                ],
                [
                    90.8629244,
                    55.0813758
                ],
                [
                    90.863214,
                    55.0806059
                ],
                [
                    90.8637594,
                    55.0790479
                ],
                [
                    90.846823,
                    55.0841912
                ],
                [
                    90.8456592,
                    55.0846447
                ],
                [
                    90.8448397,
                    55.08517
                ],
                [
                    90.842179,
                    55.0877185
                ],
                [
                    90.8408804,
                    55.088604
                ],
                [
                    90.8399352,
                    55.0891293
                ],
                [
                    90.8391757,
                    55.0894701
                ],
                [
                    90.8382524,
                    55.0897828
                ],
                [
                    90.8371597,
                    55.089961
                ],
                [
                    90.8226447,
                    55.0910348
                ],
                [
                    90.8191061,
                    55.091335
                ],
                [
                    90.8191547,
                    55.0916501
                ],
                [
                    90.8186878,
                    55.0922532
                ],
                [
                    90.8186477,
                    55.0925051
                ],
                [
                    90.8181276,
                    55.0931157
                ]
            ],
            "longitude": 90.849915,
            "latitude": 55.091137
        },
        "322": {
            "name": "Маковское",
            "population": 103,
            "type": "village",
            "poly": null,
            "longitude": 90.877945,
            "latitude": 58.187645
        },
        "323": {
            "name": "Маталассы",
            "population": 289,
            "type": "village",
            "poly": [
                [
                    90.8553469,
                    57.1523891
                ],
                [
                    90.8553669,
                    57.1525479
                ],
                [
                    90.8560053,
                    57.1527761
                ],
                [
                    90.8558125,
                    57.1529797
                ],
                [
                    90.8558676,
                    57.1531495
                ],
                [
                    90.8560453,
                    57.1532472
                ],
                [
                    90.8567788,
                    57.1534862
                ],
                [
                    90.8566311,
                    57.1536804
                ],
                [
                    90.8586138,
                    57.1542249
                ],
                [
                    90.8594575,
                    57.1535704
                ],
                [
                    90.8595626,
                    57.1533966
                ],
                [
                    90.8597078,
                    57.1532309
                ],
                [
                    90.8597854,
                    57.1530001
                ],
                [
                    90.8596903,
                    57.1528399
                ],
                [
                    90.8601835,
                    57.152571
                ],
                [
                    90.8611423,
                    57.1530639
                ],
                [
                    90.8616905,
                    57.1527896
                ],
                [
                    90.8612549,
                    57.1525262
                ],
                [
                    90.861723,
                    57.1522343
                ],
                [
                    90.8616504,
                    57.152017
                ],
                [
                    90.861335,
                    57.1517414
                ],
                [
                    90.8608093,
                    57.1515703
                ],
                [
                    90.8607092,
                    57.1514277
                ],
                [
                    90.8610847,
                    57.1511711
                ],
                [
                    90.8614352,
                    57.1511439
                ],
                [
                    90.8617733,
                    57.1510484
                ],
                [
                    90.8619532,
                    57.1509869
                ],
                [
                    90.8624539,
                    57.1511248
                ],
                [
                    90.863025,
                    57.15146
                ],
                [
                    90.8633222,
                    57.1514834
                ],
                [
                    90.8634943,
                    57.1516807
                ],
                [
                    90.8634983,
                    57.1517507
                ],
                [
                    90.8637134,
                    57.1518292
                ],
                [
                    90.8640694,
                    57.1518144
                ],
                [
                    90.8642336,
                    57.1518356
                ],
                [
                    90.8644605,
                    57.1518037
                ],
                [
                    90.8646873,
                    57.1518059
                ],
                [
                    90.8647226,
                    57.1518504
                ],
                [
                    90.8647148,
                    57.1519311
                ],
                [
                    90.8645505,
                    57.1519862
                ],
                [
                    90.8642258,
                    57.152018
                ],
                [
                    90.8640811,
                    57.1520647
                ],
                [
                    90.8640733,
                    57.1522875
                ],
                [
                    90.8642336,
                    57.1523766
                ],
                [
                    90.8645035,
                    57.1523936
                ],
                [
                    90.8647656,
                    57.1525633
                ],
                [
                    90.8648218,
                    57.1526053
                ],
                [
                    90.8649469,
                    57.1525947
                ],
                [
                    90.8651151,
                    57.1524823
                ],
                [
                    90.8652716,
                    57.1524844
                ],
                [
                    90.8654007,
                    57.1525735
                ],
                [
                    90.8654867,
                    57.1525502
                ],
                [
                    90.8655454,
                    57.1524759
                ],
                [
                    90.8656315,
                    57.1525077
                ],
                [
                    90.8656431,
                    57.1526393
                ],
                [
                    90.8657488,
                    57.1527114
                ],
                [
                    90.8657253,
                    57.1527475
                ],
                [
                    90.8656315,
                    57.152809
                ],
                [
                    90.865694,
                    57.1529851
                ],
                [
                    90.8657957,
                    57.1530509
                ],
                [
                    90.86605,
                    57.1530488
                ],
                [
                    90.8661478,
                    57.1530806
                ],
                [
                    90.8662456,
                    57.1530954
                ],
                [
                    90.8662925,
                    57.1530297
                ],
                [
                    90.866359,
                    57.1529087
                ],
                [
                    90.8663121,
                    57.1528812
                ],
                [
                    90.8663121,
                    57.1528005
                ],
                [
                    90.8664177,
                    57.1526308
                ],
                [
                    90.8666015,
                    57.152635
                ],
                [
                    90.8672195,
                    57.1527836
                ],
                [
                    90.8672939,
                    57.152879
                ],
                [
                    90.8674934,
                    57.1529533
                ],
                [
                    90.8676342,
                    57.1531039
                ],
                [
                    90.8676537,
                    57.1534985
                ],
                [
                    90.8676928,
                    57.1536874
                ],
                [
                    90.8678728,
                    57.1538401
                ],
                [
                    90.8682209,
                    57.1539844
                ],
                [
                    90.8684712,
                    57.1539971
                ],
                [
                    90.8688507,
                    57.1539186
                ],
                [
                    90.8689602,
                    57.1536937
                ],
                [
                    90.8690893,
                    57.1536258
                ],
                [
                    90.8697777,
                    57.1536258
                ],
                [
                    90.8703879,
                    57.1537659
                ],
                [
                    90.8705913,
                    57.1537892
                ],
                [
                    90.8708299,
                    57.1536301
                ],
                [
                    90.8715223,
                    57.1535792
                ],
                [
                    90.8718899,
                    57.1536386
                ],
                [
                    90.872199,
                    57.1538019
                ],
                [
                    90.8724297,
                    57.1541223
                ],
                [
                    90.8728483,
                    57.1543493
                ],
                [
                    90.8732629,
                    57.1544532
                ],
                [
                    90.8735427,
                    57.1545774
                ],
                [
                    90.8736835,
                    57.1546856
                ],
                [
                    90.8737031,
                    57.1548193
                ],
                [
                    90.873883,
                    57.1549678
                ],
                [
                    90.8741099,
                    57.1550081
                ],
                [
                    90.8740981,
                    57.1550866
                ],
                [
                    90.8740825,
                    57.1551884
                ],
                [
                    90.8742781,
                    57.1551905
                ],
                [
                    90.8743798,
                    57.1552414
                ],
                [
                    90.8745245,
                    57.1553709
                ],
                [
                    90.8750682,
                    57.1555512
                ],
                [
                    90.875248,
                    57.1554684
                ],
                [
                    90.8756862,
                    57.1555278
                ],
                [
                    90.8762964,
                    57.1554854
                ],
                [
                    90.8770827,
                    57.1554727
                ],
                [
                    90.877595,
                    57.155566
                ],
                [
                    90.8783578,
                    57.155583
                ],
                [
                    90.8786511,
                    57.1555194
                ],
                [
                    90.8791636,
                    57.15553
                ],
                [
                    90.8794609,
                    57.1554897
                ],
                [
                    90.8797308,
                    57.1555682
                ],
                [
                    90.8800672,
                    57.1558015
                ],
                [
                    90.8803019,
                    57.155897
                ],
                [
                    90.8808221,
                    57.1559988
                ],
                [
                    90.8816317,
                    57.1559437
                ],
                [
                    90.8825627,
                    57.15595
                ],
                [
                    90.8829226,
                    57.1559097
                ],
                [
                    90.8832316,
                    57.1559924
                ],
                [
                    90.8834389,
                    57.1560603
                ],
                [
                    90.8836384,
                    57.1562491
                ],
                [
                    90.883615,
                    57.1563913
                ],
                [
                    90.8838966,
                    57.1568113
                ],
                [
                    90.8839944,
                    57.1568792
                ],
                [
                    90.8844403,
                    57.1571338
                ],
                [
                    90.8845459,
                    57.157085
                ],
                [
                    90.8847063,
                    57.1569662
                ],
                [
                    90.8847728,
                    57.1568113
                ],
                [
                    90.8846515,
                    57.1565461
                ],
                [
                    90.8847834,
                    57.1565425
                ],
                [
                    90.8848862,
                    57.1565461
                ],
                [
                    90.8847884,
                    57.1563828
                ],
                [
                    90.8855434,
                    57.156351
                ],
                [
                    90.8862083,
                    57.1564846
                ],
                [
                    90.8881876,
                    57.1567392
                ],
                [
                    90.8883831,
                    57.1567774
                ],
                [
                    90.8886178,
                    57.1567477
                ],
                [
                    90.8888447,
                    57.156491
                ],
                [
                    90.8890559,
                    57.1563892
                ],
                [
                    90.8896672,
                    57.1563163
                ],
                [
                    90.8901408,
                    57.1557984
                ],
                [
                    90.8905457,
                    57.1550609
                ],
                [
                    90.8904311,
                    57.15492
                ],
                [
                    90.8893234,
                    57.1542487
                ],
                [
                    90.8881392,
                    57.1536354
                ],
                [
                    90.8875892,
                    57.1532169
                ],
                [
                    90.8873829,
                    57.1531423
                ],
                [
                    90.8872072,
                    57.1528108
                ],
                [
                    90.8871919,
                    57.152152
                ],
                [
                    90.8873751,
                    57.1516423
                ],
                [
                    90.8876121,
                    57.1509461
                ],
                [
                    90.8878566,
                    57.1499764
                ],
                [
                    90.8882844,
                    57.1491724
                ],
                [
                    90.8886511,
                    57.1488989
                ],
                [
                    90.8894456,
                    57.1485798
                ],
                [
                    90.8898734,
                    57.1483228
                ],
                [
                    90.8900874,
                    57.1479996
                ],
                [
                    90.8900721,
                    57.1476514
                ],
                [
                    90.8899804,
                    57.1471707
                ],
                [
                    90.8898234,
                    57.1468216
                ],
                [
                    90.8887905,
                    57.145376
                ],
                [
                    90.8867125,
                    57.1452864
                ],
                [
                    90.8853618,
                    57.1455583
                ],
                [
                    90.8852884,
                    57.1458136
                ],
                [
                    90.8850317,
                    57.1458733
                ],
                [
                    90.8841761,
                    57.1463906
                ],
                [
                    90.882587,
                    57.1465597
                ],
                [
                    90.882092,
                    57.1467719
                ],
                [
                    90.8819269,
                    57.1470537
                ],
                [
                    90.8800873,
                    57.1474416
                ],
                [
                    90.8799651,
                    57.1476538
                ],
                [
                    90.8798428,
                    57.1477267
                ],
                [
                    90.8791033,
                    57.1479489
                ],
                [
                    90.878816,
                    57.1477997
                ],
                [
                    90.8783149,
                    57.1477466
                ],
                [
                    90.8781987,
                    57.1477599
                ],
                [
                    90.8769091,
                    57.1481909
                ],
                [
                    90.8759374,
                    57.1487247
                ],
                [
                    90.8752894,
                    57.1487545
                ],
                [
                    90.8748006,
                    57.1489468
                ],
                [
                    90.8741222,
                    57.1490794
                ],
                [
                    90.8733276,
                    57.1493646
                ],
                [
                    90.8730893,
                    57.1492353
                ],
                [
                    90.8721114,
                    57.1494408
                ],
                [
                    90.8716102,
                    57.1496198
                ],
                [
                    90.8705772,
                    57.149706
                ],
                [
                    90.8694283,
                    57.1498387
                ],
                [
                    90.868811,
                    57.149905
                ],
                [
                    90.8684321,
                    57.1501702
                ],
                [
                    90.8663174,
                    57.1499613
                ],
                [
                    90.8662685,
                    57.1498718
                ],
                [
                    90.8635671,
                    57.1493679
                ],
                [
                    90.8634021,
                    57.1493745
                ],
                [
                    90.8632065,
                    57.1495734
                ],
                [
                    90.862797,
                    57.1498353
                ],
                [
                    90.8627908,
                    57.1501304
                ],
                [
                    90.8621491,
                    57.1501735
                ],
                [
                    90.8620697,
                    57.1501834
                ],
                [
                    90.8621002,
                    57.1503127
                ],
                [
                    90.8621186,
                    57.1504487
                ],
                [
                    90.8619963,
                    57.1504884
                ],
                [
                    90.861758,
                    57.1504984
                ],
                [
                    90.8616907,
                    57.1505581
                ],
                [
                    90.861758,
                    57.15081
                ],
                [
                    90.8614463,
                    57.1509559
                ],
                [
                    90.8606456,
                    57.1511515
                ],
                [
                    90.8595516,
                    57.1504586
                ],
                [
                    90.8587938,
                    57.1509725
                ],
                [
                    90.859026,
                    57.1512277
                ],
                [
                    90.8587387,
                    57.1514631
                ],
                [
                    90.8585187,
                    57.1516123
                ],
                [
                    90.8582057,
                    57.1517617
                ],
                [
                    90.8580831,
                    57.1519396
                ],
                [
                    90.8579479,
                    57.1520428
                ],
                [
                    90.8576876,
                    57.1520944
                ],
                [
                    90.8572444,
                    57.1520659
                ],
                [
                    90.8568364,
                    57.1519926
                ],
                [
                    90.8566637,
                    57.1521813
                ],
                [
                    90.8556873,
                    57.1519627
                ],
                [
                    90.8553469,
                    57.1523891
                ]
            ],
            "longitude": 90.878441,
            "latitude": 57.15197
        },
        "324": {
            "name": "Орловка",
            "population": 232,
            "type": "village",
            "poly": [
                [
                    90.915054,
                    56.889336
                ],
                [
                    90.9151022,
                    56.8907726
                ],
                [
                    90.9157281,
                    56.8912681
                ],
                [
                    90.9161162,
                    56.8914828
                ],
                [
                    90.9165528,
                    56.89161
                ],
                [
                    90.9170622,
                    56.891928
                ],
                [
                    90.9180083,
                    56.8932079
                ],
                [
                    90.9182946,
                    56.8941036
                ],
                [
                    90.9189059,
                    56.8950947
                ],
                [
                    90.9192067,
                    56.8959585
                ],
                [
                    90.9192793,
                    56.8968197
                ],
                [
                    90.9195075,
                    56.8973443
                ],
                [
                    90.9195754,
                    56.8982107
                ],
                [
                    90.9194395,
                    56.8986373
                ],
                [
                    90.9190029,
                    56.8993288
                ],
                [
                    90.9185758,
                    56.9002906
                ],
                [
                    90.918149,
                    56.9009185
                ],
                [
                    90.9172892,
                    56.9028247
                ],
                [
                    90.916607,
                    56.9037199
                ],
                [
                    90.9158235,
                    56.9037951
                ],
                [
                    90.9155955,
                    56.9038852
                ],
                [
                    90.9154936,
                    56.9040547
                ],
                [
                    90.9159302,
                    56.9043408
                ],
                [
                    90.9165367,
                    56.9049978
                ],
                [
                    90.9168666,
                    56.9054879
                ],
                [
                    90.9168957,
                    56.9070959
                ],
                [
                    90.9174391,
                    56.9080309
                ],
                [
                    90.9202579,
                    56.9085899
                ],
                [
                    90.9215764,
                    56.9074598
                ],
                [
                    90.922178,
                    56.9070137
                ],
                [
                    90.922997,
                    56.9068993
                ],
                [
                    90.9233696,
                    56.9066683
                ],
                [
                    90.9239984,
                    56.9059181
                ],
                [
                    90.9259972,
                    56.9040573
                ],
                [
                    90.9264979,
                    56.9028811
                ],
                [
                    90.9260593,
                    56.9020057
                ],
                [
                    90.926061,
                    56.9011684
                ],
                [
                    90.9263441,
                    56.9008497
                ],
                [
                    90.9262646,
                    56.9000941
                ],
                [
                    90.9277252,
                    56.8997997
                ],
                [
                    90.9291362,
                    56.8988298
                ],
                [
                    90.9300776,
                    56.8985747
                ],
                [
                    90.9305744,
                    56.8977879
                ],
                [
                    90.9308725,
                    56.8974772
                ],
                [
                    90.9305819,
                    56.8973009
                ],
                [
                    90.9303037,
                    56.8968708
                ],
                [
                    90.9297572,
                    56.8962983
                ],
                [
                    90.9293597,
                    56.8959971
                ],
                [
                    90.9294144,
                    56.8955616
                ],
                [
                    90.9299185,
                    56.8953595
                ],
                [
                    90.9331653,
                    56.8943447
                ],
                [
                    90.9349687,
                    56.8940815
                ],
                [
                    90.9361858,
                    56.8940028
                ],
                [
                    90.9377045,
                    56.8926879
                ],
                [
                    90.9375023,
                    56.8912722
                ],
                [
                    90.9371421,
                    56.8908766
                ],
                [
                    90.9361919,
                    56.8900811
                ],
                [
                    90.9347588,
                    56.8894956
                ],
                [
                    90.9341037,
                    56.889309
                ],
                [
                    90.9333709,
                    56.889136
                ],
                [
                    90.9328958,
                    56.8884169
                ],
                [
                    90.9322355,
                    56.8882753
                ],
                [
                    90.9311585,
                    56.8878672
                ],
                [
                    90.9306822,
                    56.8872749
                ],
                [
                    90.9297798,
                    56.88688
                ],
                [
                    90.9288774,
                    56.8864188
                ],
                [
                    90.9281158,
                    56.8861675
                ],
                [
                    90.9257288,
                    56.8857011
                ],
                [
                    90.9224782,
                    56.8849225
                ],
                [
                    90.9201919,
                    56.8846774
                ],
                [
                    90.9195369,
                    56.8851578
                ],
                [
                    90.9181785,
                    56.8851313
                ],
                [
                    90.9181208,
                    56.8854402
                ],
                [
                    90.9178525,
                    56.8858935
                ],
                [
                    90.9178575,
                    56.8860468
                ],
                [
                    90.9176662,
                    56.8861798
                ],
                [
                    90.9175793,
                    56.8862884
                ],
                [
                    90.9175245,
                    56.8867186
                ],
                [
                    90.917393,
                    56.8870469
                ],
                [
                    90.9173309,
                    56.8874418
                ],
                [
                    90.9171147,
                    56.8877499
                ],
                [
                    90.9166677,
                    56.8883442
                ],
                [
                    90.9151265,
                    56.8892779
                ],
                [
                    90.915054,
                    56.889336
                ]
            ],
            "longitude": 90.924736,
            "latitude": 56.89267
        },
        "325": {
            "name": "Грузенка",
            "population": 389,
            "type": "village",
            "poly": [
                [
                    90.9510933,
                    55.4755403
                ],
                [
                    90.952283,
                    55.4773769
                ],
                [
                    90.9525993,
                    55.4775566
                ],
                [
                    90.9529256,
                    55.4779316
                ],
                [
                    90.9532791,
                    55.4790669
                ],
                [
                    90.9532972,
                    55.4797809
                ],
                [
                    90.9530072,
                    55.4805155
                ],
                [
                    90.9524995,
                    55.4811216
                ],
                [
                    90.9524723,
                    55.4819229
                ],
                [
                    90.9527128,
                    55.482256
                ],
                [
                    90.9544317,
                    55.4825988
                ],
                [
                    90.9558341,
                    55.4827887
                ],
                [
                    90.9553951,
                    55.4835511
                ],
                [
                    90.9565565,
                    55.4837919
                ],
                [
                    90.9584827,
                    55.4844259
                ],
                [
                    90.959984,
                    55.4846506
                ],
                [
                    90.9606355,
                    55.4842654
                ],
                [
                    90.9610462,
                    55.4843938
                ],
                [
                    90.9617261,
                    55.4849636
                ],
                [
                    90.9621085,
                    55.4851161
                ],
                [
                    90.963539,
                    55.4846506
                ],
                [
                    90.963978,
                    55.4846667
                ],
                [
                    90.9640489,
                    55.4843457
                ],
                [
                    90.9648137,
                    55.4843938
                ],
                [
                    90.9648278,
                    55.4837438
                ],
                [
                    90.963454,
                    55.4836635
                ],
                [
                    90.9642047,
                    55.4831499
                ],
                [
                    90.9646182,
                    55.4830902
                ],
                [
                    90.965706,
                    55.4829332
                ],
                [
                    90.9679438,
                    55.4819781
                ],
                [
                    90.9685669,
                    55.4818176
                ],
                [
                    90.9696286,
                    55.4811627
                ],
                [
                    90.9696858,
                    55.4811274
                ],
                [
                    90.9683687,
                    55.4803649
                ],
                [
                    90.9687369,
                    55.4799475
                ],
                [
                    90.9669948,
                    55.4794338
                ],
                [
                    90.9669098,
                    55.4790967
                ],
                [
                    90.9659892,
                    55.4789763
                ],
                [
                    90.965101,
                    55.4789434
                ],
                [
                    90.9646297,
                    55.4784914
                ],
                [
                    90.9626083,
                    55.4783835
                ],
                [
                    90.9627261,
                    55.4775102
                ],
                [
                    90.962729,
                    55.4771065
                ],
                [
                    90.9627352,
                    55.4762259
                ],
                [
                    90.9617097,
                    55.4746356
                ],
                [
                    90.9616293,
                    55.4745614
                ],
                [
                    90.9615213,
                    55.4728371
                ],
                [
                    90.9605037,
                    55.4728433
                ],
                [
                    90.9594557,
                    55.4727148
                ],
                [
                    90.9581385,
                    55.4731804
                ],
                [
                    90.9562689,
                    55.4731885
                ],
                [
                    90.9554616,
                    55.4732447
                ],
                [
                    90.9549659,
                    55.4735256
                ],
                [
                    90.9545835,
                    55.4747217
                ],
                [
                    90.9551383,
                    55.4749624
                ],
                [
                    90.9543905,
                    55.4755018
                ],
                [
                    90.9510933,
                    55.4755403
                ]
            ],
            "longitude": 90.959686,
            "latitude": 55.480099
        },
        "326": {
            "name": "Подсосное",
            "population": 985,
            "type": "village",
            "poly": [
                [
                    90.9915309,
                    55.8370587
                ],
                [
                    90.9915561,
                    55.8372501
                ],
                [
                    90.9930249,
                    55.8396666
                ],
                [
                    90.9936111,
                    55.8407635
                ],
                [
                    90.9942423,
                    55.8414225
                ],
                [
                    90.9948932,
                    55.8424276
                ],
                [
                    90.9952976,
                    55.8430616
                ],
                [
                    90.9962247,
                    55.8435876
                ],
                [
                    90.9969002,
                    55.8445207
                ],
                [
                    90.9972234,
                    55.8447651
                ],
                [
                    90.9980617,
                    55.8474748
                ],
                [
                    91.0000157,
                    55.8492776
                ],
                [
                    91.0006876,
                    55.8495129
                ],
                [
                    91.0010143,
                    55.8498935
                ],
                [
                    91.0013903,
                    55.8509108
                ],
                [
                    91.0020745,
                    55.8517101
                ],
                [
                    91.0028142,
                    55.8524194
                ],
                [
                    91.0029806,
                    55.8527205
                ],
                [
                    91.0029436,
                    55.8530734
                ],
                [
                    91.0023457,
                    55.8531287
                ],
                [
                    91.002358,
                    55.8547964
                ],
                [
                    91.0028758,
                    55.855004
                ],
                [
                    91.0033381,
                    55.8553154
                ],
                [
                    91.0042504,
                    55.8571282
                ],
                [
                    91.0096254,
                    55.8566819
                ],
                [
                    91.0101432,
                    55.8567304
                ],
                [
                    91.0107102,
                    55.8567996
                ],
                [
                    91.0110184,
                    55.8567062
                ],
                [
                    91.0110246,
                    55.8565954
                ],
                [
                    91.0109753,
                    55.8563498
                ],
                [
                    91.0112773,
                    55.8560938
                ],
                [
                    91.0119923,
                    55.8559035
                ],
                [
                    91.0122759,
                    55.8555714
                ],
                [
                    91.0127998,
                    55.8552358
                ],
                [
                    91.0129663,
                    55.8550905
                ],
                [
                    91.0131512,
                    55.8550836
                ],
                [
                    91.0136689,
                    55.8552358
                ],
                [
                    91.0138724,
                    55.8552185
                ],
                [
                    91.0141313,
                    55.8549971
                ],
                [
                    91.0140758,
                    55.8546199
                ],
                [
                    91.0137429,
                    55.8544435
                ],
                [
                    91.0135888,
                    55.8542463
                ],
                [
                    91.0135457,
                    55.8540006
                ],
                [
                    91.0138169,
                    55.8538242
                ],
                [
                    91.0142237,
                    55.8537065
                ],
                [
                    91.014612,
                    55.85371
                ],
                [
                    91.0152922,
                    55.8538741
                ],
                [
                    91.0168825,
                    55.8539294
                ],
                [
                    91.0179181,
                    55.8543792
                ],
                [
                    91.0186824,
                    55.8544242
                ],
                [
                    91.0192125,
                    55.8544
                ],
                [
                    91.0202358,
                    55.8539848
                ],
                [
                    91.0205563,
                    55.8537322
                ],
                [
                    91.0186578,
                    55.8519365
                ],
                [
                    91.0179204,
                    55.850831
                ],
                [
                    91.021212,
                    55.8503604
                ],
                [
                    91.0206387,
                    55.8498656
                ],
                [
                    91.020312,
                    55.8492636
                ],
                [
                    91.0197326,
                    55.8486545
                ],
                [
                    91.020047,
                    55.8478863
                ],
                [
                    91.0194614,
                    55.8464572
                ],
                [
                    91.0195107,
                    55.8462841
                ],
                [
                    91.0197449,
                    55.8458965
                ],
                [
                    91.0197881,
                    55.8456716
                ],
                [
                    91.0193443,
                    55.8457789
                ],
                [
                    91.0190053,
                    55.8457927
                ],
                [
                    91.0187032,
                    55.8456681
                ],
                [
                    91.0187032,
                    55.8454259
                ],
                [
                    91.0193566,
                    55.8446334
                ],
                [
                    91.0186662,
                    55.8445088
                ],
                [
                    91.0175506,
                    55.8441074
                ],
                [
                    91.0163591,
                    55.8435145
                ],
                [
                    91.0160751,
                    55.8431866
                ],
                [
                    91.015653,
                    55.8430405
                ],
                [
                    91.0153374,
                    55.8427503
                ],
                [
                    91.0151638,
                    55.842201
                ],
                [
                    91.0151046,
                    55.8416118
                ],
                [
                    91.0148245,
                    55.8413881
                ],
                [
                    91.0146746,
                    55.8408897
                ],
                [
                    91.0145511,
                    55.8402389
                ],
                [
                    91.0147237,
                    55.8392283
                ],
                [
                    91.0153894,
                    55.8382591
                ],
                [
                    91.0156976,
                    55.8376776
                ],
                [
                    91.0161291,
                    55.837425
                ],
                [
                    91.0164311,
                    55.8373488
                ],
                [
                    91.0172201,
                    55.8373142
                ],
                [
                    91.0177502,
                    55.8370131
                ],
                [
                    91.0176577,
                    55.8361235
                ],
                [
                    91.0172965,
                    55.835511
                ],
                [
                    91.0170154,
                    55.8353117
                ],
                [
                    91.0169168,
                    55.8350264
                ],
                [
                    91.0169513,
                    55.8340239
                ],
                [
                    91.0172225,
                    55.8338772
                ],
                [
                    91.0178586,
                    55.8336529
                ],
                [
                    91.0188942,
                    55.833531
                ],
                [
                    91.0190964,
                    55.833279
                ],
                [
                    91.0185884,
                    55.8327777
                ],
                [
                    91.0182875,
                    55.8321048
                ],
                [
                    91.0175332,
                    55.8312767
                ],
                [
                    91.0167738,
                    55.8306508
                ],
                [
                    91.015822,
                    55.8299916
                ],
                [
                    91.0156593,
                    55.8302298
                ],
                [
                    91.0151514,
                    55.830504
                ],
                [
                    91.0150232,
                    55.8308059
                ],
                [
                    91.0144512,
                    55.8307172
                ],
                [
                    91.0136375,
                    55.8314179
                ],
                [
                    91.0131148,
                    55.8313598
                ],
                [
                    91.0119831,
                    55.8324746
                ],
                [
                    91.0111663,
                    55.8329333
                ],
                [
                    91.0103804,
                    55.8336862
                ],
                [
                    91.0092632,
                    55.8336213
                ],
                [
                    91.0074602,
                    55.8336992
                ],
                [
                    91.0059423,
                    55.8335218
                ],
                [
                    91.0041933,
                    55.8336127
                ],
                [
                    91.0038697,
                    55.8334482
                ],
                [
                    91.0027679,
                    55.8333098
                ],
                [
                    90.9995703,
                    55.8318775
                ],
                [
                    90.9993144,
                    55.8310693
                ],
                [
                    90.999058,
                    55.8310072
                ],
                [
                    90.9987216,
                    55.8302191
                ],
                [
                    90.9983467,
                    55.8301997
                ],
                [
                    90.9967146,
                    55.8285157
                ],
                [
                    90.9961722,
                    55.8282194
                ],
                [
                    90.9950627,
                    55.8282831
                ],
                [
                    90.9949788,
                    55.8286431
                ],
                [
                    90.995324,
                    55.8291084
                ],
                [
                    90.9954917,
                    55.829535
                ],
                [
                    90.9954374,
                    55.8298618
                ],
                [
                    90.9952353,
                    55.8300446
                ],
                [
                    90.9949295,
                    55.8300944
                ],
                [
                    90.9945547,
                    55.8299919
                ],
                [
                    90.9941553,
                    55.8300003
                ],
                [
                    90.9947421,
                    55.830665
                ],
                [
                    90.995615,
                    55.8324679
                ],
                [
                    90.9954621,
                    55.8331021
                ],
                [
                    90.9950035,
                    55.8339024
                ],
                [
                    90.9940715,
                    55.8353535
                ],
                [
                    90.9939713,
                    55.8356538
                ],
                [
                    90.9925334,
                    55.837174
                ],
                [
                    90.9924997,
                    55.8372128
                ],
                [
                    90.9915309,
                    55.8370587
                ]
            ],
            "longitude": 91.00647,
            "latitude": 55.842262
        },
        "327": {
            "name": "Легостаево",
            "population": 438,
            "type": "village",
            "poly": null,
            "longitude": 91.030128,
            "latitude": 55.133102
        },
        "328": {
            "name": "Анаш",
            "population": 994,
            "type": "village",
            "poly": null,
            "longitude": 91.049149,
            "latitude": 54.86969
        },
        "329": {
            "name": "Новочернореченский",
            "population": 3818,
            "type": "village",
            "poly": [
                [
                    91.0470203,
                    56.265574
                ],
                [
                    91.0516634,
                    56.2698292
                ],
                [
                    91.0517131,
                    56.2698748
                ],
                [
                    91.051879,
                    56.2700898
                ],
                [
                    91.0520247,
                    56.2702935
                ],
                [
                    91.0526303,
                    56.270984
                ],
                [
                    91.0530176,
                    56.2713979
                ],
                [
                    91.0538271,
                    56.2721109
                ],
                [
                    91.0545639,
                    56.2725814
                ],
                [
                    91.0553733,
                    56.2730358
                ],
                [
                    91.056078,
                    56.2732783
                ],
                [
                    91.0571002,
                    56.273524
                ],
                [
                    91.0577466,
                    56.2737633
                ],
                [
                    91.0591531,
                    56.2744893
                ],
                [
                    91.0597821,
                    56.2748045
                ],
                [
                    91.0603615,
                    56.2752556
                ],
                [
                    91.0608158,
                    56.275275
                ],
                [
                    91.0613895,
                    56.2754043
                ],
                [
                    91.0616718,
                    56.2755579
                ],
                [
                    91.0623242,
                    56.2763129
                ],
                [
                    91.0626503,
                    56.2765506
                ],
                [
                    91.0631279,
                    56.2768125
                ],
                [
                    91.0637336,
                    56.2773912
                ],
                [
                    91.0638122,
                    56.2777065
                ],
                [
                    91.063652,
                    56.2779102
                ],
                [
                    91.0638413,
                    56.2781009
                ],
                [
                    91.0638675,
                    56.2782205
                ],
                [
                    91.0640685,
                    56.278379
                ],
                [
                    91.0641849,
                    56.2786182
                ],
                [
                    91.0642665,
                    56.2789302
                ],
                [
                    91.064514,
                    56.2790272
                ],
                [
                    91.0645518,
                    56.2791646
                ],
                [
                    91.0648052,
                    56.2794071
                ],
                [
                    91.0652216,
                    56.2796738
                ],
                [
                    91.0654856,
                    56.2797791
                ],
                [
                    91.0656676,
                    56.280068
                ],
                [
                    91.0659806,
                    56.280256
                ],
                [
                    91.0671714,
                    56.2807865
                ],
                [
                    91.0671038,
                    56.2808253
                ],
                [
                    91.0673391,
                    56.2809598
                ],
                [
                    91.067388,
                    56.2811189
                ],
                [
                    91.0673484,
                    56.281221
                ],
                [
                    91.0675068,
                    56.2813077
                ],
                [
                    91.0678764,
                    56.2823558
                ],
                [
                    91.0685336,
                    56.2830507
                ],
                [
                    91.0689995,
                    56.2838886
                ],
                [
                    91.069307,
                    56.284702
                ],
                [
                    91.0694187,
                    56.285642
                ],
                [
                    91.0696363,
                    56.2854381
                ],
                [
                    91.0704112,
                    56.2850041
                ],
                [
                    91.0714918,
                    56.2846726
                ],
                [
                    91.0731838,
                    56.2843964
                ],
                [
                    91.0741293,
                    56.284203
                ],
                [
                    91.0753166,
                    56.2836663
                ],
                [
                    91.0757218,
                    56.2834848
                ],
                [
                    91.0767384,
                    56.2833388
                ],
                [
                    91.0771294,
                    56.2832441
                ],
                [
                    91.0780678,
                    56.2828179
                ],
                [
                    91.0784873,
                    56.2826916
                ],
                [
                    91.0792764,
                    56.2825377
                ],
                [
                    91.0817505,
                    56.2823167
                ],
                [
                    91.083725,
                    56.2820062
                ],
                [
                    91.0854223,
                    56.281878
                ],
                [
                    91.0862221,
                    56.2815425
                ],
                [
                    91.0867908,
                    56.2812071
                ],
                [
                    91.0877239,
                    56.2809456
                ],
                [
                    91.0882305,
                    56.2806299
                ],
                [
                    91.0887103,
                    56.2803388
                ],
                [
                    91.0898745,
                    56.280107
                ],
                [
                    91.0908165,
                    56.2800379
                ],
                [
                    91.0913852,
                    56.2798406
                ],
                [
                    91.0926293,
                    56.2797025
                ],
                [
                    91.093047,
                    56.2795643
                ],
                [
                    91.0937135,
                    56.2792091
                ],
                [
                    91.0941909,
                    56.2790668
                ],
                [
                    91.0948824,
                    56.2789506
                ],
                [
                    91.0959926,
                    56.2789077
                ],
                [
                    91.0963794,
                    56.2788673
                ],
                [
                    91.0968843,
                    56.278741
                ],
                [
                    91.0981038,
                    56.2783393
                ],
                [
                    91.0986543,
                    56.2782055
                ],
                [
                    91.0995552,
                    56.2781423
                ],
                [
                    91.1004333,
                    56.2781145
                ],
                [
                    91.1006387,
                    56.277822
                ],
                [
                    91.1006737,
                    56.2775284
                ],
                [
                    91.1006154,
                    56.277421
                ],
                [
                    91.1005361,
                    56.2773486
                ],
                [
                    91.1005409,
                    56.2772697
                ],
                [
                    91.1006131,
                    56.2771908
                ],
                [
                    91.1007994,
                    56.2771637
                ],
                [
                    91.1011745,
                    56.2771546
                ],
                [
                    91.1014075,
                    56.2772063
                ],
                [
                    91.1015706,
                    56.277293
                ],
                [
                    91.1019316,
                    56.2777056
                ],
                [
                    91.1020062,
                    56.277734
                ],
                [
                    91.102097,
                    56.2777146
                ],
                [
                    91.1021832,
                    56.2776642
                ],
                [
                    91.1022182,
                    56.2775723
                ],
                [
                    91.1022834,
                    56.2774896
                ],
                [
                    91.1023952,
                    56.2774456
                ],
                [
                    91.1025513,
                    56.2774236
                ],
                [
                    91.102768,
                    56.2774572
                ],
                [
                    91.1030056,
                    56.2774598
                ],
                [
                    91.1036998,
                    56.2771934
                ],
                [
                    91.1041703,
                    56.2771688
                ],
                [
                    91.1043823,
                    56.2771585
                ],
                [
                    91.1046363,
                    56.2772426
                ],
                [
                    91.1052839,
                    56.2773771
                ],
                [
                    91.1054901,
                    56.2773391
                ],
                [
                    91.1058541,
                    56.2773517
                ],
                [
                    91.1059678,
                    56.2773833
                ],
                [
                    91.1061043,
                    56.2775127
                ],
                [
                    91.1062238,
                    56.2775411
                ],
                [
                    91.1063148,
                    56.277519
                ],
                [
                    91.1064513,
                    56.2774117
                ],
                [
                    91.1065593,
                    56.2773706
                ],
                [
                    91.1066043,
                    56.2774289
                ],
                [
                    91.1066509,
                    56.2774631
                ],
                [
                    91.1068168,
                    56.2775189
                ],
                [
                    91.1069416,
                    56.2775065
                ],
                [
                    91.1070106,
                    56.2774693
                ],
                [
                    91.1070274,
                    56.2773886
                ],
                [
                    91.1071243,
                    56.277341
                ],
                [
                    91.1073405,
                    56.2772789
                ],
                [
                    91.1074858,
                    56.2773172
                ],
                [
                    91.1074802,
                    56.2775065
                ],
                [
                    91.1076908,
                    56.2775831
                ],
                [
                    91.1078772,
                    56.2775955
                ],
                [
                    91.1079927,
                    56.2775686
                ],
                [
                    91.1080505,
                    56.2775055
                ],
                [
                    91.1082257,
                    56.2774755
                ],
                [
                    91.1083077,
                    56.2773741
                ],
                [
                    91.1084177,
                    56.2773368
                ],
                [
                    91.1087904,
                    56.2774041
                ],
                [
                    91.108919,
                    56.277491
                ],
                [
                    91.1089432,
                    56.2775717
                ],
                [
                    91.1090159,
                    56.2776565
                ],
                [
                    91.1089917,
                    56.2777331
                ],
                [
                    91.1091538,
                    56.2778066
                ],
                [
                    91.1094166,
                    56.2778759
                ],
                [
                    91.1100707,
                    56.2777269
                ],
                [
                    91.1106727,
                    56.2775044
                ],
                [
                    91.1114871,
                    56.2773441
                ],
                [
                    91.111789,
                    56.2772116
                ],
                [
                    91.1121189,
                    56.2769157
                ],
                [
                    91.1122624,
                    56.2767791
                ],
                [
                    91.1128028,
                    56.2765153
                ],
                [
                    91.113142,
                    56.276177
                ],
                [
                    91.1135967,
                    56.2759173
                ],
                [
                    91.1140011,
                    56.2756493
                ],
                [
                    91.1141521,
                    56.2754837
                ],
                [
                    91.1142676,
                    56.2753906
                ],
                [
                    91.1145192,
                    56.2750512
                ],
                [
                    91.1147112,
                    56.2744987
                ],
                [
                    91.1151063,
                    56.2739223
                ],
                [
                    91.1151417,
                    56.2737661
                ],
                [
                    91.1149721,
                    56.273347
                ],
                [
                    91.1148044,
                    56.2732798
                ],
                [
                    91.1147373,
                    56.2732187
                ],
                [
                    91.1147149,
                    56.2731608
                ],
                [
                    91.1147429,
                    56.2731142
                ],
                [
                    91.1148788,
                    56.2730811
                ],
                [
                    91.115138,
                    56.2730583
                ],
                [
                    91.1152775,
                    56.2730121
                ],
                [
                    91.1153574,
                    56.2729605
                ],
                [
                    91.1152965,
                    56.2729088
                ],
                [
                    91.1152823,
                    56.2728479
                ],
                [
                    91.1153884,
                    56.2727923
                ],
                [
                    91.1154755,
                    56.2727247
                ],
                [
                    91.1154779,
                    56.2726638
                ],
                [
                    91.1153693,
                    56.272489
                ],
                [
                    91.1153753,
                    56.2724254
                ],
                [
                    91.1154457,
                    56.2723797
                ],
                [
                    91.1155924,
                    56.2723684
                ],
                [
                    91.1157129,
                    56.2723896
                ],
                [
                    91.1157284,
                    56.2725068
                ],
                [
                    91.1157904,
                    56.272575
                ],
                [
                    91.1159371,
                    56.2726148
                ],
                [
                    91.1162055,
                    56.2726188
                ],
                [
                    91.1163343,
                    56.2725592
                ],
                [
                    91.1165036,
                    56.2724605
                ],
                [
                    91.1165716,
                    56.2723433
                ],
                [
                    91.1165466,
                    56.2721929
                ],
                [
                    91.1164893,
                    56.2720856
                ],
                [
                    91.1163498,
                    56.2719585
                ],
                [
                    91.1163319,
                    56.2718704
                ],
                [
                    91.1163906,
                    56.2718557
                ],
                [
                    91.1179563,
                    56.2714645
                ],
                [
                    91.1189056,
                    56.2713319
                ],
                [
                    91.1195783,
                    56.2711088
                ],
                [
                    91.1196889,
                    56.2708808
                ],
                [
                    91.1198782,
                    56.2707029
                ],
                [
                    91.1199685,
                    56.2705413
                ],
                [
                    91.1195754,
                    56.2704911
                ],
                [
                    91.1194764,
                    56.2704572
                ],
                [
                    91.1192754,
                    56.2704604
                ],
                [
                    91.1191939,
                    56.270462
                ],
                [
                    91.1190666,
                    56.2704336
                ],
                [
                    91.1190292,
                    56.270364
                ],
                [
                    91.1190114,
                    56.2702887
                ],
                [
                    91.1189383,
                    56.2702266
                ],
                [
                    91.1189607,
                    56.2701637
                ],
                [
                    91.1190367,
                    56.2701099
                ],
                [
                    91.1190919,
                    56.2700974
                ],
                [
                    91.1190994,
                    56.2700378
                ],
                [
                    91.1192052,
                    56.2699882
                ],
                [
                    91.1194453,
                    56.2699699
                ],
                [
                    91.1195794,
                    56.2699923
                ],
                [
                    91.119654,
                    56.2699741
                ],
                [
                    91.1196659,
                    56.2699343
                ],
                [
                    91.1195884,
                    56.2695452
                ],
                [
                    91.1195258,
                    56.2694467
                ],
                [
                    91.1195094,
                    56.2693962
                ],
                [
                    91.119566,
                    56.2693225
                ],
                [
                    91.1195571,
                    56.2691727
                ],
                [
                    91.1194393,
                    56.2691106
                ],
                [
                    91.1193498,
                    56.2690353
                ],
                [
                    91.1193364,
                    56.2689781
                ],
                [
                    91.119411,
                    56.2689351
                ],
                [
                    91.1195034,
                    56.2688349
                ],
                [
                    91.1195824,
                    56.2687778
                ],
                [
                    91.1196778,
                    56.2687662
                ],
                [
                    91.1197852,
                    56.2687753
                ],
                [
                    91.1199015,
                    56.2688275
                ],
                [
                    91.1199373,
                    56.2689036
                ],
                [
                    91.1199745,
                    56.2690228
                ],
                [
                    91.1200297,
                    56.2690618
                ],
                [
                    91.1201102,
                    56.2690568
                ],
                [
                    91.1201594,
                    56.2690295
                ],
                [
                    91.1201803,
                    56.2689922
                ],
                [
                    91.1201922,
                    56.268464
                ],
                [
                    91.1202414,
                    56.2684226
                ],
                [
                    91.1203115,
                    56.2684027
                ],
                [
                    91.1203965,
                    56.2684069
                ],
                [
                    91.1205605,
                    56.2683986
                ],
                [
                    91.1206499,
                    56.2683423
                ],
                [
                    91.1206797,
                    56.2682951
                ],
                [
                    91.1206589,
                    56.2682521
                ],
                [
                    91.1205559,
                    56.2682057
                ],
                [
                    91.1205053,
                    56.2681403
                ],
                [
                    91.1205068,
                    56.2680757
                ],
                [
                    91.1207572,
                    56.2679052
                ],
                [
                    91.1209764,
                    56.2679027
                ],
                [
                    91.1211598,
                    56.2677214
                ],
                [
                    91.1213521,
                    56.2672677
                ],
                [
                    91.1216071,
                    56.2670507
                ],
                [
                    91.1220216,
                    56.2667875
                ],
                [
                    91.1222049,
                    56.2666028
                ],
                [
                    91.1223242,
                    56.2663975
                ],
                [
                    91.1223361,
                    56.2660721
                ],
                [
                    91.1222005,
                    56.2656035
                ],
                [
                    91.1218769,
                    56.2652723
                ],
                [
                    91.1215743,
                    56.2651299
                ],
                [
                    91.1209705,
                    56.2649212
                ],
                [
                    91.1206559,
                    56.2647987
                ],
                [
                    91.1204546,
                    56.2646745
                ],
                [
                    91.1201285,
                    56.2643719
                ],
                [
                    91.119929,
                    56.2639579
                ],
                [
                    91.1199161,
                    56.2636091
                ],
                [
                    91.1196159,
                    56.2632685
                ],
                [
                    91.1192172,
                    56.2630698
                ],
                [
                    91.1188705,
                    56.2629767
                ],
                [
                    91.1187345,
                    56.2627728
                ],
                [
                    91.1186842,
                    56.2624881
                ],
                [
                    91.1185854,
                    56.2622894
                ],
                [
                    91.1179437,
                    56.2621772
                ],
                [
                    91.117405,
                    56.2619492
                ],
                [
                    91.1161034,
                    56.2617778
                ],
                [
                    91.115725,
                    56.2617589
                ],
                [
                    91.1153701,
                    56.2617412
                ],
                [
                    91.1150152,
                    56.2615795
                ],
                [
                    91.1149603,
                    56.261579
                ],
                [
                    91.1146115,
                    56.2615761
                ],
                [
                    91.1144191,
                    56.2615745
                ],
                [
                    91.1143763,
                    56.2615899
                ],
                [
                    91.1142872,
                    56.2616219
                ],
                [
                    91.1142201,
                    56.2616147
                ],
                [
                    91.1142089,
                    56.2615919
                ],
                [
                    91.1142108,
                    56.2614822
                ],
                [
                    91.1141716,
                    56.2614491
                ],
                [
                    91.1141176,
                    56.2614574
                ],
                [
                    91.1140524,
                    56.2615029
                ],
                [
                    91.1140114,
                    56.2615174
                ],
                [
                    91.1139443,
                    56.2615008
                ],
                [
                    91.1139238,
                    56.2614698
                ],
                [
                    91.1138213,
                    56.2614325
                ],
                [
                    91.1136368,
                    56.2614253
                ],
                [
                    91.1135511,
                    56.2614004
                ],
                [
                    91.1135144,
                    56.2614012
                ],
                [
                    91.1134169,
                    56.2614035
                ],
                [
                    91.1134001,
                    56.2613394
                ],
                [
                    91.1133218,
                    56.2613176
                ],
                [
                    91.1132585,
                    56.2613611
                ],
                [
                    91.1132392,
                    56.2613625
                ],
                [
                    91.113156,
                    56.2613683
                ],
                [
                    91.1130926,
                    56.2613156
                ],
                [
                    91.1130367,
                    56.2613038
                ],
                [
                    91.1129789,
                    56.2612917
                ],
                [
                    91.1128727,
                    56.2613363
                ],
                [
                    91.112718,
                    56.261329
                ],
                [
                    91.1125242,
                    56.2612866
                ],
                [
                    91.1124739,
                    56.2612265
                ],
                [
                    91.1124496,
                    56.2611789
                ],
                [
                    91.1122931,
                    56.261181
                ],
                [
                    91.1122539,
                    56.2611624
                ],
                [
                    91.1121347,
                    56.2610526
                ],
                [
                    91.1119986,
                    56.2610402
                ],
                [
                    91.111788,
                    56.2610516
                ],
                [
                    91.1116706,
                    56.2610174
                ],
                [
                    91.1116185,
                    56.2609616
                ],
                [
                    91.1115905,
                    56.2609036
                ],
                [
                    91.1114656,
                    56.2608487
                ],
                [
                    91.1113386,
                    56.260818
                ],
                [
                    91.1111609,
                    56.2608196
                ],
                [
                    91.1109775,
                    56.2608326
                ],
                [
                    91.1108872,
                    56.2608374
                ],
                [
                    91.1108435,
                    56.2607679
                ],
                [
                    91.1107619,
                    56.2607468
                ],
                [
                    91.1106484,
                    56.2606789
                ],
                [
                    91.1104621,
                    56.2606417
                ],
                [
                    91.1103281,
                    56.2606239
                ],
                [
                    91.1102815,
                    56.2605285
                ],
                [
                    91.1101913,
                    56.2604768
                ],
                [
                    91.1100253,
                    56.2604525
                ],
                [
                    91.1097719,
                    56.2604881
                ],
                [
                    91.1095157,
                    56.2604865
                ],
                [
                    91.1093002,
                    56.2604541
                ],
                [
                    91.1091837,
                    56.2603797
                ],
                [
                    91.1091837,
                    56.2602471
                ],
                [
                    91.1090934,
                    56.260142
                ],
                [
                    91.1089187,
                    56.2600417
                ],
                [
                    91.1087003,
                    56.2599996
                ],
                [
                    91.1080819,
                    56.2599234
                ],
                [
                    91.1078672,
                    56.2598264
                ],
                [
                    91.1075651,
                    56.2598426
                ],
                [
                    91.1072812,
                    56.2597091
                ],
                [
                    91.107161,
                    56.2596869
                ],
                [
                    91.1068516,
                    56.2595878
                ],
                [
                    91.1065386,
                    56.2594402
                ],
                [
                    91.1054539,
                    56.2593371
                ],
                [
                    91.1051954,
                    56.2593675
                ],
                [
                    91.1053302,
                    56.2591208
                ],
                [
                    91.1058252,
                    56.2590622
                ],
                [
                    91.105989,
                    56.2586315
                ],
                [
                    91.1057378,
                    56.2585587
                ],
                [
                    91.1055304,
                    56.2584031
                ],
                [
                    91.1052901,
                    56.258302
                ],
                [
                    91.1043656,
                    56.2581463
                ],
                [
                    91.1038123,
                    56.2579785
                ],
                [
                    91.1033537,
                    56.2578531
                ],
                [
                    91.102531,
                    56.2577419
                ],
                [
                    91.1017448,
                    56.2576934
                ],
                [
                    91.1009149,
                    56.2575559
                ],
                [
                    91.0999758,
                    56.257566
                ],
                [
                    91.0997319,
                    56.25756
                ],
                [
                    91.0994371,
                    56.2575135
                ],
                [
                    91.0988984,
                    56.2573719
                ],
                [
                    91.0984361,
                    56.2572446
                ],
                [
                    91.0980467,
                    56.2572446
                ],
                [
                    91.0978428,
                    56.2571799
                ],
                [
                    91.0976681,
                    56.2571152
                ],
                [
                    91.0972022,
                    56.2569736
                ],
                [
                    91.096769,
                    56.2569312
                ],
                [
                    91.0961721,
                    56.2569069
                ],
                [
                    91.0951383,
                    56.2569372
                ],
                [
                    91.094818,
                    56.2570484
                ],
                [
                    91.0946106,
                    56.257008
                ],
                [
                    91.0934603,
                    56.2569655
                ],
                [
                    91.0926632,
                    56.2568159
                ],
                [
                    91.0903773,
                    56.2560577
                ],
                [
                    91.0899114,
                    56.2557767
                ],
                [
                    91.0895001,
                    56.2554896
                ],
                [
                    91.0822311,
                    56.2572409
                ],
                [
                    91.0676515,
                    56.260754
                ],
                [
                    91.0487069,
                    56.2651575
                ],
                [
                    91.0470203,
                    56.265574
                ]
            ],
            "longitude": 91.08831,
            "latitude": 56.268379
        },
        "330": {
            "name": "Кожаны",
            "population": 1356,
            "type": "village",
            "poly": [
                [
                    [
                        91.0771932,
                        55.3623672
                    ],
                    [
                        91.0801506,
                        55.3632876
                    ],
                    [
                        91.0815379,
                        55.3635654
                    ],
                    [
                        91.084041,
                        55.3637955
                    ],
                    [
                        91.0880006,
                        55.3636299
                    ],
                    [
                        91.0877589,
                        55.3638081
                    ],
                    [
                        91.0862401,
                        55.3682472
                    ],
                    [
                        91.084625,
                        55.3722748
                    ],
                    [
                        91.0847093,
                        55.3724392
                    ],
                    [
                        91.0850776,
                        55.3725963
                    ],
                    [
                        91.0852758,
                        55.3726583
                    ],
                    [
                        91.0864571,
                        55.372131
                    ],
                    [
                        91.0865897,
                        55.3724049
                    ],
                    [
                        91.0872526,
                        55.3727063
                    ],
                    [
                        91.0876865,
                        55.3732816
                    ],
                    [
                        91.088458,
                        55.3731515
                    ],
                    [
                        91.0886388,
                        55.3733159
                    ],
                    [
                        91.0889401,
                        55.3732542
                    ],
                    [
                        91.0887352,
                        55.3723981
                    ],
                    [
                        91.0889281,
                        55.3721584
                    ],
                    [
                        91.089362,
                        55.3719666
                    ],
                    [
                        91.0897718,
                        55.3721036
                    ],
                    [
                        91.0906155,
                        55.3714734
                    ],
                    [
                        91.0901937,
                        55.3713022
                    ],
                    [
                        91.0903624,
                        55.3711857
                    ],
                    [
                        91.0901696,
                        55.3707405
                    ],
                    [
                        91.090483,
                        55.3706309
                    ],
                    [
                        91.0903142,
                        55.3704871
                    ],
                    [
                        91.0907843,
                        55.370124
                    ],
                    [
                        91.0907602,
                        55.3699802
                    ],
                    [
                        91.0915446,
                        55.3694305
                    ],
                    [
                        91.0918645,
                        55.3693339
                    ],
                    [
                        91.0923108,
                        55.3694305
                    ],
                    [
                        91.0924846,
                        55.3692935
                    ],
                    [
                        91.0922396,
                        55.3692172
                    ],
                    [
                        91.0923819,
                        55.3689097
                    ],
                    [
                        91.0927887,
                        55.3685394
                    ],
                    [
                        91.0930376,
                        55.3685102
                    ],
                    [
                        91.0931995,
                        55.3682431
                    ],
                    [
                        91.0926426,
                        55.3682431
                    ],
                    [
                        91.0922792,
                        55.3682633
                    ],
                    [
                        91.0921133,
                        55.3680568
                    ],
                    [
                        91.0922279,
                        55.3678323
                    ],
                    [
                        91.0927295,
                        55.3671567
                    ],
                    [
                        91.0931243,
                        55.3669412
                    ],
                    [
                        91.0934562,
                        55.3669726
                    ],
                    [
                        91.0941632,
                        55.3669502
                    ],
                    [
                        91.094495,
                        55.3667369
                    ],
                    [
                        91.0949848,
                        55.3665641
                    ],
                    [
                        91.0950993,
                        55.366288
                    ],
                    [
                        91.0949137,
                        55.365976
                    ],
                    [
                        91.0946885,
                        55.3658794
                    ],
                    [
                        91.0946885,
                        55.3656864
                    ],
                    [
                        91.0945937,
                        55.3654215
                    ],
                    [
                        91.0939223,
                        55.3651836
                    ],
                    [
                        91.0938828,
                        55.3649636
                    ],
                    [
                        91.0938591,
                        55.3647705
                    ],
                    [
                        91.0939894,
                        55.3645932
                    ],
                    [
                        91.0940763,
                        55.3643889
                    ],
                    [
                        91.0933417,
                        55.363895
                    ],
                    [
                        91.0928282,
                        55.3639422
                    ],
                    [
                        91.092611,
                        55.3633922
                    ],
                    [
                        91.0963439,
                        55.363192
                    ],
                    [
                        91.0963822,
                        55.3631073
                    ],
                    [
                        91.0964031,
                        55.362889
                    ],
                    [
                        91.0966757,
                        55.361881
                    ],
                    [
                        91.0966915,
                        55.3612097
                    ],
                    [
                        91.0980778,
                        55.3614971
                    ],
                    [
                        91.0986505,
                        55.3615375
                    ],
                    [
                        91.0998315,
                        55.3618294
                    ],
                    [
                        91.100495,
                        55.3618338
                    ],
                    [
                        91.1007478,
                        55.3610795
                    ],
                    [
                        91.0984771,
                        55.3607003
                    ],
                    [
                        91.0974502,
                        55.3599201
                    ],
                    [
                        91.0970157,
                        55.3593364
                    ],
                    [
                        91.0963102,
                        55.3593695
                    ],
                    [
                        91.0960036,
                        55.3594122
                    ],
                    [
                        91.0956087,
                        55.35898
                    ],
                    [
                        91.0951742,
                        55.3587162
                    ],
                    [
                        91.0944336,
                        55.3587358
                    ],
                    [
                        91.0938856,
                        55.3586685
                    ],
                    [
                        91.0935992,
                        55.358371
                    ],
                    [
                        91.0921576,
                        55.3584945
                    ],
                    [
                        91.0912689,
                        55.3587948
                    ],
                    [
                        91.0904445,
                        55.3592185
                    ],
                    [
                        91.0883561,
                        55.3605066
                    ],
                    [
                        91.0871958,
                        55.3605768
                    ],
                    [
                        91.0868799,
                        55.3606161
                    ],
                    [
                        91.0865491,
                        55.3609529
                    ],
                    [
                        91.0847273,
                        55.3612166
                    ],
                    [
                        91.0847865,
                        55.3614439
                    ],
                    [
                        91.0841052,
                        55.3615001
                    ],
                    [
                        91.0830042,
                        55.3614888
                    ],
                    [
                        91.0801456,
                        55.3609388
                    ],
                    [
                        91.0780325,
                        55.3606975
                    ],
                    [
                        91.0772452,
                        55.3622895
                    ],
                    [
                        91.0771932,
                        55.3623672
                    ]
                ],
                [
                    [
                        91.0772714,
                        55.3543914
                    ],
                    [
                        91.0774739,
                        55.3548902
                    ],
                    [
                        91.07812,
                        55.3553671
                    ],
                    [
                        91.0792771,
                        55.3557344
                    ],
                    [
                        91.0816107,
                        55.3554822
                    ],
                    [
                        91.0824882,
                        55.3553342
                    ],
                    [
                        91.0837629,
                        55.3553744
                    ],
                    [
                        91.0860772,
                        55.3553569
                    ],
                    [
                        91.0866249,
                        55.356212
                    ],
                    [
                        91.0885149,
                        55.3558437
                    ],
                    [
                        91.089078,
                        55.3558787
                    ],
                    [
                        91.0896103,
                        55.3557691
                    ],
                    [
                        91.090559,
                        55.3555718
                    ],
                    [
                        91.0911454,
                        55.3553437
                    ],
                    [
                        91.0936063,
                        55.3550806
                    ],
                    [
                        91.0942697,
                        55.3559051
                    ],
                    [
                        91.0951408,
                        55.3557605
                    ],
                    [
                        91.0949966,
                        55.355393
                    ],
                    [
                        91.0959161,
                        55.3552351
                    ],
                    [
                        91.0988821,
                        55.3558424
                    ],
                    [
                        91.0998949,
                        55.3558546
                    ],
                    [
                        91.1013691,
                        55.3559656
                    ],
                    [
                        91.1029033,
                        55.3560803
                    ],
                    [
                        91.104768,
                        55.3559534
                    ],
                    [
                        91.1016555,
                        55.3541721
                    ],
                    [
                        91.1023961,
                        55.3536774
                    ],
                    [
                        91.1027108,
                        55.3534213
                    ],
                    [
                        91.1029515,
                        55.3528319
                    ],
                    [
                        91.1029885,
                        55.3520565
                    ],
                    [
                        91.1028836,
                        55.3510565
                    ],
                    [
                        91.102575,
                        55.3510881
                    ],
                    [
                        91.101279,
                        55.350646
                    ],
                    [
                        91.1002669,
                        55.3507582
                    ],
                    [
                        91.099008,
                        55.3515933
                    ],
                    [
                        91.0988105,
                        55.3521793
                    ],
                    [
                        91.0983785,
                        55.3525757
                    ],
                    [
                        91.0963666,
                        55.352681
                    ],
                    [
                        91.094904,
                        55.3528845
                    ],
                    [
                        91.0936635,
                        55.3528669
                    ],
                    [
                        91.0935833,
                        55.3524143
                    ],
                    [
                        91.0930032,
                        55.3524003
                    ],
                    [
                        91.0925033,
                        55.3526213
                    ],
                    [
                        91.090726,
                        55.3527968
                    ],
                    [
                        91.090584,
                        55.3529371
                    ],
                    [
                        91.0908432,
                        55.3530669
                    ],
                    [
                        91.0909605,
                        55.3534739
                    ],
                    [
                        91.0905655,
                        55.3535722
                    ],
                    [
                        91.0905655,
                        55.3540107
                    ],
                    [
                        91.0896398,
                        55.3539756
                    ],
                    [
                        91.0881772,
                        55.354116
                    ],
                    [
                        91.0878884,
                        55.3536907
                    ],
                    [
                        91.0882278,
                        55.3534627
                    ],
                    [
                        91.0882355,
                        55.3530723
                    ],
                    [
                        91.0883049,
                        55.3530329
                    ],
                    [
                        91.0882818,
                        55.3529145
                    ],
                    [
                        91.0879115,
                        55.3529364
                    ],
                    [
                        91.0877804,
                        55.3526908
                    ],
                    [
                        91.0875952,
                        55.3526601
                    ],
                    [
                        91.0863378,
                        55.3526952
                    ],
                    [
                        91.0851652,
                        55.352454
                    ],
                    [
                        91.0849724,
                        55.3519277
                    ],
                    [
                        91.0846252,
                        55.3519803
                    ],
                    [
                        91.0843861,
                        55.3518838
                    ],
                    [
                        91.082959,
                        55.3516864
                    ],
                    [
                        91.0822338,
                        55.3517829
                    ],
                    [
                        91.0818558,
                        55.3518926
                    ],
                    [
                        91.0807373,
                        55.3518882
                    ],
                    [
                        91.080097,
                        55.3518487
                    ],
                    [
                        91.0790247,
                        55.3519277
                    ],
                    [
                        91.0785001,
                        55.3520285
                    ],
                    [
                        91.0784461,
                        55.3521776
                    ],
                    [
                        91.078369,
                        55.3522566
                    ],
                    [
                        91.078693,
                        55.3524145
                    ],
                    [
                        91.0787316,
                        55.3526513
                    ],
                    [
                        91.077775,
                        55.3526996
                    ],
                    [
                        91.0777729,
                        55.3527961
                    ],
                    [
                        91.0777054,
                        55.35375
                    ],
                    [
                        91.0772714,
                        55.3543914
                    ]
                ]
            ],
            "longitude": 91.093132,
            "latitude": 55.354282
        },
        "331": {
            "name": "Шадрино",
            "population": 461,
            "type": "village",
            "poly": [
                [
                    91.0897937,
                    55.8751844
                ],
                [
                    91.0918784,
                    55.8753057
                ],
                [
                    91.0918784,
                    55.8750851
                ],
                [
                    91.0932354,
                    55.875052
                ],
                [
                    91.0941792,
                    55.8752947
                ],
                [
                    91.0959493,
                    55.8752947
                ],
                [
                    91.0960477,
                    55.8761773
                ],
                [
                    91.0956347,
                    55.8761773
                ],
                [
                    91.095497,
                    55.8769386
                ],
                [
                    91.0965786,
                    55.8769937
                ],
                [
                    91.095733,
                    55.8779866
                ],
                [
                    91.095379,
                    55.8778984
                ],
                [
                    91.0945727,
                    55.8786927
                ],
                [
                    91.0951823,
                    55.878814
                ],
                [
                    91.0951037,
                    55.8790677
                ],
                [
                    91.0954577,
                    55.879156
                ],
                [
                    91.09473,
                    55.879862
                ],
                [
                    91.093255,
                    55.8797738
                ],
                [
                    91.0927634,
                    55.8803253
                ],
                [
                    91.0933533,
                    55.880546
                ],
                [
                    91.0935499,
                    55.8803805
                ],
                [
                    91.093904,
                    55.8805239
                ],
                [
                    91.094199,
                    55.8802812
                ],
                [
                    91.0961067,
                    55.8800496
                ],
                [
                    91.096264,
                    55.8802592
                ],
                [
                    91.0953003,
                    55.8806783
                ],
                [
                    91.0950643,
                    55.8815277
                ],
                [
                    91.0968146,
                    55.8825426
                ],
                [
                    91.0973456,
                    55.881958
                ],
                [
                    91.0985453,
                    55.8821675
                ],
                [
                    91.1003743,
                    55.8812409
                ],
                [
                    91.1030095,
                    55.881252
                ],
                [
                    91.1033046,
                    55.8810093
                ],
                [
                    91.1042289,
                    55.8809983
                ],
                [
                    91.1042682,
                    55.8813292
                ],
                [
                    91.1061169,
                    55.8812851
                ],
                [
                    91.1062152,
                    55.8805018
                ],
                [
                    91.1074935,
                    55.8803584
                ],
                [
                    91.1080049,
                    55.8799503
                ],
                [
                    91.1104632,
                    55.8799834
                ],
                [
                    91.1099912,
                    55.880546
                ],
                [
                    91.1109548,
                    55.8816601
                ],
                [
                    91.1130395,
                    55.8813954
                ],
                [
                    91.1129215,
                    55.8811858
                ],
                [
                    91.1149668,
                    55.8804026
                ],
                [
                    91.1173661,
                    55.8800606
                ],
                [
                    91.1166778,
                    55.8789023
                ],
                [
                    91.1165598,
                    55.8771592
                ],
                [
                    91.1158518,
                    55.8765414
                ],
                [
                    91.1163631,
                    55.8760339
                ],
                [
                    91.1183887,
                    55.8763097
                ],
                [
                    91.1186051,
                    55.8769606
                ],
                [
                    91.1193524,
                    55.8769606
                ],
                [
                    91.1201391,
                    55.8767069
                ],
                [
                    91.1204734,
                    55.8761773
                ],
                [
                    91.1223417,
                    55.8751182
                ],
                [
                    91.1222803,
                    55.874271
                ],
                [
                    91.1158456,
                    55.874324
                ],
                [
                    91.1143194,
                    55.8741122
                ],
                [
                    91.1105907,
                    55.8738209
                ],
                [
                    91.1104019,
                    55.8728411
                ],
                [
                    91.1087342,
                    55.8726381
                ],
                [
                    91.1080576,
                    55.8721615
                ],
                [
                    91.1093635,
                    55.8659468
                ],
                [
                    91.1075649,
                    55.8654166
                ],
                [
                    91.1068777,
                    55.865214
                ],
                [
                    91.1059486,
                    55.8651309
                ],
                [
                    91.1055394,
                    55.8650942
                ],
                [
                    91.1043132,
                    55.8649845
                ],
                [
                    91.1032464,
                    55.8669877
                ],
                [
                    91.1035359,
                    55.8670865
                ],
                [
                    91.103347,
                    55.8674538
                ],
                [
                    91.1041274,
                    55.8677292
                ],
                [
                    91.1044673,
                    55.8673337
                ],
                [
                    91.1063804,
                    55.8674679
                ],
                [
                    91.1060909,
                    55.868725
                ],
                [
                    91.1043288,
                    55.8685343
                ],
                [
                    91.1041778,
                    55.8690499
                ],
                [
                    91.1018115,
                    55.8680965
                ],
                [
                    91.1010311,
                    55.8679835
                ],
                [
                    91.1006409,
                    55.8694736
                ],
                [
                    91.1020632,
                    55.8707024
                ],
                [
                    91.1043288,
                    55.8710272
                ],
                [
                    91.1036617,
                    55.8732375
                ],
                [
                    91.1022017,
                    55.8733999
                ],
                [
                    91.1020632,
                    55.8731527
                ],
                [
                    91.1010563,
                    55.8731316
                ],
                [
                    91.1009933,
                    55.8734564
                ],
                [
                    91.099055,
                    55.8736894
                ],
                [
                    91.0990676,
                    55.8733505
                ],
                [
                    91.0906787,
                    55.8732977
                ],
                [
                    91.0906983,
                    55.8739928
                ],
                [
                    91.0900494,
                    55.874401
                ],
                [
                    91.0897937,
                    55.8751844
                ]
            ],
            "longitude": 91.107185,
            "latitude": 55.877411
        },
        "332": {
            "name": "Ровное",
            "population": 639,
            "type": "village",
            "poly": [
                [
                    91.1126058,
                    55.5140098
                ],
                [
                    91.1133935,
                    55.5145146
                ],
                [
                    91.1131944,
                    55.5146617
                ],
                [
                    91.1133502,
                    55.5148871
                ],
                [
                    91.1131165,
                    55.5152351
                ],
                [
                    91.113532,
                    55.5157301
                ],
                [
                    91.1138956,
                    55.5163525
                ],
                [
                    91.1144236,
                    55.516676
                ],
                [
                    91.1148824,
                    55.516725
                ],
                [
                    91.1152199,
                    55.5165143
                ],
                [
                    91.1156355,
                    55.516181
                ],
                [
                    91.1166569,
                    55.5175287
                ],
                [
                    91.1172022,
                    55.5177885
                ],
                [
                    91.1177562,
                    55.5178473
                ],
                [
                    91.1187346,
                    55.5175949
                ],
                [
                    91.1188477,
                    55.5175619
                ],
                [
                    91.1197341,
                    55.5165732
                ],
                [
                    91.1199912,
                    55.5166485
                ],
                [
                    91.1203147,
                    55.5169797
                ],
                [
                    91.1206737,
                    55.5170425
                ],
                [
                    91.121436,
                    55.5165707
                ],
                [
                    91.1215069,
                    55.5164754
                ],
                [
                    91.1210992,
                    55.516099
                ],
                [
                    91.1209307,
                    55.5159835
                ],
                [
                    91.1213285,
                    55.5161291
                ],
                [
                    91.1224019,
                    55.5163682
                ],
                [
                    91.1226443,
                    55.5161761
                ],
                [
                    91.1229213,
                    55.5161801
                ],
                [
                    91.1233991,
                    55.5159683
                ],
                [
                    91.1236415,
                    55.5156311
                ],
                [
                    91.1240777,
                    55.5157292
                ],
                [
                    91.1247148,
                    55.5155488
                ],
                [
                    91.1248118,
                    55.5153214
                ],
                [
                    91.124791,
                    55.5149058
                ],
                [
                    91.1249849,
                    55.5146509
                ],
                [
                    91.1253796,
                    55.5142824
                ],
                [
                    91.1255458,
                    55.5139648
                ],
                [
                    91.1261829,
                    55.5136589
                ],
                [
                    91.1264807,
                    55.5133884
                ],
                [
                    91.1278458,
                    55.5136948
                ],
                [
                    91.128566,
                    55.5136634
                ],
                [
                    91.1296048,
                    55.5140673
                ],
                [
                    91.1305327,
                    55.5140241
                ],
                [
                    91.1308928,
                    55.5137026
                ],
                [
                    91.1303596,
                    55.5125694
                ],
                [
                    91.1306158,
                    55.512295
                ],
                [
                    91.1368829,
                    55.5128204
                ],
                [
                    91.1365298,
                    55.511397
                ],
                [
                    91.1379425,
                    55.5110872
                ],
                [
                    91.136973,
                    55.5093579
                ],
                [
                    91.1358096,
                    55.5089854
                ],
                [
                    91.1290277,
                    55.5081656
                ],
                [
                    91.1297311,
                    55.5075663
                ],
                [
                    91.1300185,
                    55.5072216
                ],
                [
                    91.1298325,
                    55.5068865
                ],
                [
                    91.1284292,
                    55.5062642
                ],
                [
                    91.1251002,
                    55.5049262
                ],
                [
                    91.1249304,
                    55.5044869
                ],
                [
                    91.1239817,
                    55.5032789
                ],
                [
                    91.1233377,
                    55.5027612
                ],
                [
                    91.1224444,
                    55.5024043
                ],
                [
                    91.1216895,
                    55.5023376
                ],
                [
                    91.1198821,
                    55.5024749
                ],
                [
                    91.1194528,
                    55.5029259
                ],
                [
                    91.1162742,
                    55.5049183
                ],
                [
                    91.1160077,
                    55.505368
                ],
                [
                    91.1153238,
                    55.505971
                ],
                [
                    91.1150382,
                    55.506074
                ],
                [
                    91.1144582,
                    55.5066279
                ],
                [
                    91.1151507,
                    55.5070838
                ],
                [
                    91.1167174,
                    55.5075348
                ],
                [
                    91.116328,
                    55.5080446
                ],
                [
                    91.1166309,
                    55.5084269
                ],
                [
                    91.1172975,
                    55.5085054
                ],
                [
                    91.1167608,
                    55.5088436
                ],
                [
                    91.1158432,
                    55.5098681
                ],
                [
                    91.1153844,
                    55.5106131
                ],
                [
                    91.1143197,
                    55.5114513
                ],
                [
                    91.1143976,
                    55.5117405
                ],
                [
                    91.1150468,
                    55.512015
                ],
                [
                    91.1140947,
                    55.512858
                ],
                [
                    91.1142158,
                    55.5131962
                ],
                [
                    91.1143976,
                    55.5133727
                ],
                [
                    91.1138177,
                    55.5133089
                ],
                [
                    91.1130819,
                    55.5137746
                ],
                [
                    91.1126058,
                    55.5140098
                ]
            ],
            "longitude": 91.121803,
            "latitude": 55.510571
        },
        "333": {
            "name": "Суломай",
            "population": 177,
            "type": "village",
            "poly": null,
            "longitude": 91.1809827,
            "latitude": 61.6137378
        },
        "334": {
            "name": "Чистое Поле",
            "population": 1066,
            "type": "village",
            "poly": [
                [
                    91.1659696,
                    55.2516749
                ],
                [
                    91.1662656,
                    55.252392
                ],
                [
                    91.1666233,
                    55.2527178
                ],
                [
                    91.1671372,
                    55.2528186
                ],
                [
                    91.1679761,
                    55.252767
                ],
                [
                    91.1693206,
                    55.2527342
                ],
                [
                    91.1697276,
                    55.2527834
                ],
                [
                    91.1716601,
                    55.25276
                ],
                [
                    91.174937,
                    55.2529732
                ],
                [
                    91.1759994,
                    55.2531234
                ],
                [
                    91.1792994,
                    55.2540603
                ],
                [
                    91.1803033,
                    55.2542677
                ],
                [
                    91.1814325,
                    55.2543506
                ],
                [
                    91.1824866,
                    55.2544593
                ],
                [
                    91.1836609,
                    55.2545589
                ],
                [
                    91.1838717,
                    55.2546526
                ],
                [
                    91.1841181,
                    55.2546855
                ],
                [
                    91.1848893,
                    55.2546058
                ],
                [
                    91.1876801,
                    55.2544447
                ],
                [
                    91.1898284,
                    55.2540815
                ],
                [
                    91.1925832,
                    55.2536801
                ],
                [
                    91.1974144,
                    55.2524645
                ],
                [
                    91.200215,
                    55.2512953
                ],
                [
                    91.1999661,
                    55.2517027
                ],
                [
                    91.200223,
                    55.2519636
                ],
                [
                    91.2006004,
                    55.2520276
                ],
                [
                    91.2011626,
                    55.2519636
                ],
                [
                    91.2012429,
                    55.2516798
                ],
                [
                    91.2012269,
                    55.2513044
                ],
                [
                    91.2018451,
                    55.2513548
                ],
                [
                    91.2029855,
                    55.2513044
                ],
                [
                    91.2035316,
                    55.251483
                ],
                [
                    91.2051618,
                    55.2515104
                ],
                [
                    91.2064547,
                    55.2515196
                ],
                [
                    91.2073702,
                    55.2516523
                ],
                [
                    91.2081653,
                    55.2517942
                ],
                [
                    91.208631,
                    55.2517622
                ],
                [
                    91.209418,
                    55.2514189
                ],
                [
                    91.2094582,
                    55.2510344
                ],
                [
                    91.2085587,
                    55.2477157
                ],
                [
                    91.2053064,
                    55.2483474
                ],
                [
                    91.2046318,
                    55.2483657
                ],
                [
                    91.2041179,
                    55.2480911
                ],
                [
                    91.2028731,
                    55.2475006
                ],
                [
                    91.2030257,
                    55.2473404
                ],
                [
                    91.2029454,
                    55.2472351
                ],
                [
                    91.2026483,
                    55.2472396
                ],
                [
                    91.2025278,
                    55.2468414
                ],
                [
                    91.2025759,
                    55.2466857
                ],
                [
                    91.2024796,
                    55.2466033
                ],
                [
                    91.2019335,
                    55.246553
                ],
                [
                    91.2014276,
                    55.2465713
                ],
                [
                    91.2006888,
                    55.2468917
                ],
                [
                    91.2003129,
                    55.246383
                ],
                [
                    91.2002165,
                    55.2460534
                ],
                [
                    91.2002037,
                    55.2459253
                ],
                [
                    91.1998054,
                    55.2458447
                ],
                [
                    91.1999467,
                    55.2455261
                ],
                [
                    91.1994263,
                    55.2454308
                ],
                [
                    91.1995998,
                    55.2452953
                ],
                [
                    91.1995934,
                    55.2451488
                ],
                [
                    91.1993235,
                    55.2449291
                ],
                [
                    91.1992465,
                    55.2443907
                ],
                [
                    91.1990086,
                    55.2444017
                ],
                [
                    91.1983663,
                    55.2446947
                ],
                [
                    91.1979808,
                    55.2447863
                ],
                [
                    91.1971135,
                    55.2448229
                ],
                [
                    91.1966189,
                    55.2446398
                ],
                [
                    91.1960471,
                    55.2444896
                ],
                [
                    91.1954689,
                    55.2441344
                ],
                [
                    91.195289,
                    55.2437242
                ],
                [
                    91.1952826,
                    55.2434238
                ],
                [
                    91.1953082,
                    55.2433359
                ],
                [
                    91.1946787,
                    55.2433323
                ],
                [
                    91.1938306,
                    55.2432847
                ],
                [
                    91.1926229,
                    55.2427756
                ],
                [
                    91.1924944,
                    55.24264
                ],
                [
                    91.1917491,
                    55.242261
                ],
                [
                    91.1912673,
                    55.2422667
                ],
                [
                    91.1911963,
                    55.2421591
                ],
                [
                    91.1906001,
                    55.2421327
                ],
                [
                    91.190523,
                    55.2420155
                ],
                [
                    91.190045,
                    55.2418953
                ],
                [
                    91.1899576,
                    55.241828
                ],
                [
                    91.1888321,
                    55.2415818
                ],
                [
                    91.1885751,
                    55.2414441
                ],
                [
                    91.1882513,
                    55.2417635
                ],
                [
                    91.187871,
                    55.2424374
                ],
                [
                    91.1877681,
                    55.2424286
                ],
                [
                    91.1876089,
                    55.2427832
                ],
                [
                    91.187244,
                    55.2426982
                ],
                [
                    91.1866272,
                    55.2426865
                ],
                [
                    91.1865296,
                    55.2423905
                ],
                [
                    91.1861698,
                    55.2423671
                ],
                [
                    91.1859745,
                    55.2426748
                ],
                [
                    91.1857432,
                    55.2426425
                ],
                [
                    91.1857895,
                    55.2425253
                ],
                [
                    91.1854606,
                    55.2424872
                ],
                [
                    91.1847051,
                    55.2425839
                ],
                [
                    91.1842322,
                    55.2427832
                ],
                [
                    91.1841037,
                    55.2430996
                ],
                [
                    91.1838467,
                    55.2434952
                ],
                [
                    91.183307,
                    55.2438468
                ],
                [
                    91.1829268,
                    55.2438409
                ],
                [
                    91.1825156,
                    55.2437794
                ],
                [
                    91.1821558,
                    55.2436124
                ],
                [
                    91.1819143,
                    55.2434747
                ],
                [
                    91.1811536,
                    55.2432695
                ],
                [
                    91.1806191,
                    55.2431055
                ],
                [
                    91.1800024,
                    55.2431055
                ],
                [
                    91.1795963,
                    55.2435069
                ],
                [
                    91.1777748,
                    55.2430513
                ],
                [
                    91.1767366,
                    55.2429576
                ],
                [
                    91.1765413,
                    55.2430132
                ],
                [
                    91.1759194,
                    55.2428814
                ],
                [
                    91.1753334,
                    55.2426997
                ],
                [
                    91.1756933,
                    55.2423422
                ],
                [
                    91.1749686,
                    55.2420815
                ],
                [
                    91.1735398,
                    55.2434117
                ],
                [
                    91.1743056,
                    55.2438512
                ],
                [
                    91.1736528,
                    55.2449822
                ],
                [
                    91.1732571,
                    55.2455183
                ],
                [
                    91.1724554,
                    55.2455681
                ],
                [
                    91.1724194,
                    55.2462889
                ],
                [
                    91.1725273,
                    55.2467137
                ],
                [
                    91.1718898,
                    55.2477319
                ],
                [
                    91.1718506,
                    55.2478056
                ],
                [
                    91.1735035,
                    55.2488579
                ],
                [
                    91.1738201,
                    55.2490384
                ],
                [
                    91.173339,
                    55.2490759
                ],
                [
                    91.1727099,
                    55.2490431
                ],
                [
                    91.1705677,
                    55.2490829
                ],
                [
                    91.1691122,
                    55.2491462
                ],
                [
                    91.1675539,
                    55.2492282
                ],
                [
                    91.1668755,
                    55.249329
                ],
                [
                    91.166415,
                    55.2495306
                ],
                [
                    91.166267,
                    55.2497134
                ],
                [
                    91.1664643,
                    55.2499477
                ],
                [
                    91.1668179,
                    55.2500555
                ],
                [
                    91.1664684,
                    55.2502618
                ],
                [
                    91.1663081,
                    55.2505102
                ],
                [
                    91.1664273,
                    55.2509274
                ],
                [
                    91.1665164,
                    55.2511687
                ],
                [
                    91.1666357,
                    55.2514335
                ],
                [
                    91.1662039,
                    55.2514992
                ],
                [
                    91.1659696,
                    55.2516749
                ]
            ],
            "longitude": 91.181557,
            "latitude": 55.24762
        },
        "335": {
            "name": "Кытат",
            "population": 462,
            "type": "village",
            "poly": [
                [
                    91.1891902,
                    56.7984577
                ],
                [
                    91.1911048,
                    56.7987722
                ],
                [
                    91.1915214,
                    56.7990127
                ],
                [
                    91.1917354,
                    56.7992501
                ],
                [
                    91.1916736,
                    56.7997404
                ],
                [
                    91.1911273,
                    56.800169
                ],
                [
                    91.1918256,
                    56.8004589
                ],
                [
                    91.1930757,
                    56.801205
                ],
                [
                    91.1934418,
                    56.8013684
                ],
                [
                    91.1935881,
                    56.8012944
                ],
                [
                    91.1941061,
                    56.8019974
                ],
                [
                    91.1922248,
                    56.802335
                ],
                [
                    91.1920136,
                    56.8024083
                ],
                [
                    91.1926612,
                    56.8027821
                ],
                [
                    91.1925837,
                    56.8030172
                ],
                [
                    91.1922811,
                    56.8031559
                ],
                [
                    91.1923374,
                    56.8035837
                ],
                [
                    91.1925767,
                    56.8037109
                ],
                [
                    91.1928583,
                    56.803734
                ],
                [
                    91.1931469,
                    56.8036762
                ],
                [
                    91.193534,
                    56.8040269
                ],
                [
                    91.1934355,
                    56.8045665
                ],
                [
                    91.1933651,
                    56.80521
                ],
                [
                    91.1933619,
                    56.8055545
                ],
                [
                    91.1940542,
                    56.8057445
                ],
                [
                    91.1943483,
                    56.8059624
                ],
                [
                    91.1945299,
                    56.806196
                ],
                [
                    91.1964155,
                    56.8073356
                ],
                [
                    91.1969097,
                    56.8080073
                ],
                [
                    91.1974143,
                    56.8082909
                ],
                [
                    91.1985225,
                    56.8086534
                ],
                [
                    91.1990531,
                    56.8088422
                ],
                [
                    91.2005523,
                    56.8090553
                ],
                [
                    91.2019939,
                    56.8094143
                ],
                [
                    91.2027868,
                    56.8095524
                ],
                [
                    91.2035544,
                    56.8102035
                ],
                [
                    91.202641,
                    56.8117179
                ],
                [
                    91.2033224,
                    56.8117734
                ],
                [
                    91.2036208,
                    56.8114497
                ],
                [
                    91.2035082,
                    56.8113295
                ],
                [
                    91.2034913,
                    56.8111939
                ],
                [
                    91.2036039,
                    56.8110952
                ],
                [
                    91.2037954,
                    56.8110398
                ],
                [
                    91.2040094,
                    56.8110737
                ],
                [
                    91.204122,
                    56.8107408
                ],
                [
                    91.2042403,
                    56.8106729
                ],
                [
                    91.2041952,
                    56.8103647
                ],
                [
                    91.2043698,
                    56.8102938
                ],
                [
                    91.2045387,
                    56.810303
                ],
                [
                    91.204657,
                    56.8104171
                ],
                [
                    91.2046682,
                    56.8105805
                ],
                [
                    91.2045443,
                    56.8107315
                ],
                [
                    91.20455,
                    56.8108641
                ],
                [
                    91.2047921,
                    56.8110428
                ],
                [
                    91.205068,
                    56.8110583
                ],
                [
                    91.2049892,
                    56.8108394
                ],
                [
                    91.2052257,
                    56.8100102
                ],
                [
                    91.2053382,
                    56.8098715
                ],
                [
                    91.2056931,
                    56.8098191
                ],
                [
                    91.2057719,
                    56.8097543
                ],
                [
                    91.2055072,
                    56.8096495
                ],
                [
                    91.2050061,
                    56.809631
                ],
                [
                    91.2048597,
                    56.8095016
                ],
                [
                    91.2049385,
                    56.809295
                ],
                [
                    91.2055242,
                    56.8093104
                ],
                [
                    91.2059634,
                    56.8093289
                ],
                [
                    91.2060141,
                    56.808996
                ],
                [
                    91.2059034,
                    56.8089056
                ],
                [
                    91.2058803,
                    56.808797
                ],
                [
                    91.2054144,
                    56.8088399
                ],
                [
                    91.2054075,
                    56.8089611
                ],
                [
                    91.2052022,
                    56.8089864
                ],
                [
                    91.2049508,
                    56.8089725
                ],
                [
                    91.2048377,
                    56.8089144
                ],
                [
                    91.2048377,
                    56.8087086
                ],
                [
                    91.2050661,
                    56.8086795
                ],
                [
                    91.2051953,
                    56.8086101
                ],
                [
                    91.2045932,
                    56.8084598
                ],
                [
                    91.2043465,
                    56.8084535
                ],
                [
                    91.2062747,
                    56.8070304
                ],
                [
                    91.2068375,
                    56.8072969
                ],
                [
                    91.2093866,
                    56.8059815
                ],
                [
                    91.210302,
                    56.8054744
                ],
                [
                    91.2116679,
                    56.8064116
                ],
                [
                    91.2128067,
                    56.8059557
                ],
                [
                    91.198686,
                    56.7955371
                ],
                [
                    91.1966256,
                    56.7949394
                ],
                [
                    91.1958012,
                    56.7952167
                ],
                [
                    91.1955422,
                    56.7952167
                ],
                [
                    91.1931771,
                    56.7959476
                ],
                [
                    91.1921466,
                    56.7961912
                ],
                [
                    91.1917524,
                    56.796222
                ],
                [
                    91.1910259,
                    56.7966229
                ],
                [
                    91.1904403,
                    56.7967709
                ],
                [
                    91.1891902,
                    56.7984577
                ]
            ],
            "longitude": 91.2025412,
            "latitude": 56.803285
        },
        "336": {
            "name": "Кома",
            "population": 739,
            "type": "village",
            "poly": null,
            "longitude": 91.206848,
            "latitude": 55.009888
        },
        "337": {
            "name": "Балахтон",
            "population": 602,
            "type": "village",
            "poly": [
                [
                    91.2236893,
                    55.986832
                ],
                [
                    91.2280643,
                    55.9878245
                ],
                [
                    91.2291346,
                    55.988211
                ],
                [
                    91.2297049,
                    55.9881487
                ],
                [
                    91.2300678,
                    55.9882033
                ],
                [
                    91.2309705,
                    55.9882033
                ],
                [
                    91.2313174,
                    55.9882471
                ],
                [
                    91.2315711,
                    55.9884808
                ],
                [
                    91.2324346,
                    55.9887256
                ],
                [
                    91.2335146,
                    55.9888689
                ],
                [
                    91.2343987,
                    55.9891318
                ],
                [
                    91.2351586,
                    55.9892189
                ],
                [
                    91.2359789,
                    55.9892202
                ],
                [
                    91.2370269,
                    55.9894178
                ],
                [
                    91.2376228,
                    55.9887484
                ],
                [
                    91.2386575,
                    55.9888898
                ],
                [
                    91.2396692,
                    55.987951
                ],
                [
                    91.2410257,
                    55.9885812
                ],
                [
                    91.2423133,
                    55.9881568
                ],
                [
                    91.2430031,
                    55.9896872
                ],
                [
                    91.2503377,
                    55.9941368
                ],
                [
                    91.2527749,
                    55.9927865
                ],
                [
                    91.2534187,
                    55.9919892
                ],
                [
                    91.2477166,
                    55.988414
                ],
                [
                    91.2490042,
                    55.9877581
                ],
                [
                    91.2503837,
                    55.9870635
                ],
                [
                    91.2502917,
                    55.9859574
                ],
                [
                    91.2490042,
                    55.9845683
                ],
                [
                    91.2468887,
                    55.9827161
                ],
                [
                    91.2482224,
                    55.9805679
                ],
                [
                    91.2445436,
                    55.9798861
                ],
                [
                    91.2396002,
                    55.9795131
                ],
                [
                    91.2381057,
                    55.9790885
                ],
                [
                    91.2386575,
                    55.9787283
                ],
                [
                    91.2396002,
                    55.9776606
                ],
                [
                    91.2400371,
                    55.976284
                ],
                [
                    91.2418765,
                    55.9763226
                ],
                [
                    91.2419684,
                    55.9753191
                ],
                [
                    91.2388874,
                    55.9752677
                ],
                [
                    91.2380596,
                    55.9749718
                ],
                [
                    91.237071,
                    55.9738524
                ],
                [
                    91.2366112,
                    55.9738524
                ],
                [
                    91.2355535,
                    55.9734407
                ],
                [
                    91.2334842,
                    55.9734407
                ],
                [
                    91.2329094,
                    55.976387
                ],
                [
                    91.2299433,
                    55.9768244
                ],
                [
                    91.2294605,
                    55.9773261
                ],
                [
                    91.2264944,
                    55.9769144
                ],
                [
                    91.2236893,
                    55.986832
                ]
            ],
            "longitude": 91.233818,
            "latitude": 55.983154
        },
        "338": {
            "name": "Тюльково",
            "population": 990,
            "type": "village",
            "poly": [
                [
                    91.2153402,
                    55.3572193
                ],
                [
                    91.2153864,
                    55.3578859
                ],
                [
                    91.2157953,
                    55.3583156
                ],
                [
                    91.2197913,
                    55.3589471
                ],
                [
                    91.2207941,
                    55.3589778
                ],
                [
                    91.2240958,
                    55.3596092
                ],
                [
                    91.223849,
                    55.360153
                ],
                [
                    91.2219821,
                    55.3601179
                ],
                [
                    91.2219821,
                    55.360232
                ],
                [
                    91.2219976,
                    55.3603678
                ],
                [
                    91.2441335,
                    55.3607706
                ],
                [
                    91.2444421,
                    55.3614612
                ],
                [
                    91.2444999,
                    55.3622175
                ],
                [
                    91.244606,
                    55.3625793
                ],
                [
                    91.2477592,
                    55.3632534
                ],
                [
                    91.2490417,
                    55.3634507
                ],
                [
                    91.251462,
                    55.3633192
                ],
                [
                    91.2514427,
                    55.3636042
                ],
                [
                    91.2516163,
                    55.3640371
                ],
                [
                    91.2521949,
                    55.3645468
                ],
                [
                    91.2527156,
                    55.3646564
                ],
                [
                    91.2535642,
                    55.3646235
                ],
                [
                    91.2565823,
                    55.3632698
                ],
                [
                    91.2574984,
                    55.3630396
                ],
                [
                    91.2580191,
                    55.3624916
                ],
                [
                    91.257537,
                    55.3617845
                ],
                [
                    91.2590462,
                    55.3609837
                ],
                [
                    91.2593547,
                    55.3605014
                ],
                [
                    91.2605601,
                    55.3595586
                ],
                [
                    91.2631058,
                    55.3629842
                ],
                [
                    91.2644558,
                    55.363346
                ],
                [
                    91.2652561,
                    55.3634008
                ],
                [
                    91.2656611,
                    55.3631322
                ],
                [
                    91.2659986,
                    55.362902
                ],
                [
                    91.2664518,
                    55.3625293
                ],
                [
                    91.2675993,
                    55.3624636
                ],
                [
                    91.2679175,
                    55.3622717
                ],
                [
                    91.2679316,
                    55.3602799
                ],
                [
                    91.2708245,
                    55.3601154
                ],
                [
                    91.2711137,
                    55.3598852
                ],
                [
                    91.2732448,
                    55.359655
                ],
                [
                    91.2734272,
                    55.3582345
                ],
                [
                    91.2734859,
                    55.3581531
                ],
                [
                    91.272107,
                    55.3581257
                ],
                [
                    91.2720684,
                    55.3577968
                ],
                [
                    91.2730134,
                    55.3563716
                ],
                [
                    91.2733702,
                    55.3562401
                ],
                [
                    91.2770923,
                    55.3555439
                ],
                [
                    91.2777673,
                    55.3548477
                ],
                [
                    91.2783748,
                    55.3544914
                ],
                [
                    91.2785291,
                    55.3541899
                ],
                [
                    91.2811133,
                    55.354305
                ],
                [
                    91.2813256,
                    55.3534523
                ],
                [
                    91.2815569,
                    55.3525233
                ],
                [
                    91.2796305,
                    55.3519402
                ],
                [
                    91.2777707,
                    55.3518465
                ],
                [
                    91.2747573,
                    55.3527165
                ],
                [
                    91.2723804,
                    55.3533986
                ],
                [
                    91.2710921,
                    55.3528548
                ],
                [
                    91.2695569,
                    55.353039
                ],
                [
                    91.2683689,
                    55.3536047
                ],
                [
                    91.2668261,
                    55.3535916
                ],
                [
                    91.265885,
                    55.3534907
                ],
                [
                    91.264643,
                    55.3538503
                ],
                [
                    91.2646902,
                    55.3552086
                ],
                [
                    91.2639866,
                    55.355163
                ],
                [
                    91.2628943,
                    55.3552752
                ],
                [
                    91.2582287,
                    55.3567452
                ],
                [
                    91.2560767,
                    55.3574169
                ],
                [
                    91.2559638,
                    55.3574503
                ],
                [
                    91.2533868,
                    55.355224
                ],
                [
                    91.2532557,
                    55.3553687
                ],
                [
                    91.2518748,
                    55.3556582
                ],
                [
                    91.25071,
                    55.3559695
                ],
                [
                    91.2498845,
                    55.3565966
                ],
                [
                    91.2505017,
                    55.3567896
                ],
                [
                    91.247902,
                    55.3576359
                ],
                [
                    91.2465674,
                    55.3575263
                ],
                [
                    91.2460737,
                    55.3570483
                ],
                [
                    91.2454103,
                    55.3567326
                ],
                [
                    91.2440294,
                    55.3565616
                ],
                [
                    91.2414452,
                    55.3566054
                ],
                [
                    91.2408589,
                    55.3560178
                ],
                [
                    91.2400026,
                    55.355781
                ],
                [
                    91.2390075,
                    55.3559564
                ],
                [
                    91.2364078,
                    55.3564388
                ],
                [
                    91.2342015,
                    55.3558994
                ],
                [
                    91.2313086,
                    55.3561055
                ],
                [
                    91.2290407,
                    55.3556187
                ],
                [
                    91.2262481,
                    55.3565002
                ],
                [
                    91.223363,
                    55.3563291
                ],
                [
                    91.2213727,
                    55.3564168
                ],
                [
                    91.2209098,
                    55.3552723
                ],
                [
                    91.2183179,
                    55.3544522
                ],
                [
                    91.2178682,
                    55.3544084
                ],
                [
                    91.2174384,
                    55.3551451
                ],
                [
                    91.2167441,
                    55.3564607
                ],
                [
                    91.2168753,
                    55.3568905
                ],
                [
                    91.216181,
                    55.3568554
                ],
                [
                    91.2155793,
                    55.3569431
                ],
                [
                    91.2153402,
                    55.3572193
                ]
            ],
            "longitude": 91.254005,
            "latitude": 55.359093
        },
        "339": {
            "name": "Беллык",
            "population": 1093,
            "type": "village",
            "poly": null,
            "longitude": 91.3348796,
            "latitude": 54.5493081
        },
        "340": {
            "name": "Чистые Пруды",
            "population": 295,
            "type": "village",
            "poly": [
                [
                    91.3452656,
                    55.4532565
                ],
                [
                    91.346369,
                    55.4538607
                ],
                [
                    91.347262,
                    55.4541585
                ],
                [
                    91.3484287,
                    55.4545475
                ],
                [
                    91.3490382,
                    55.4546175
                ],
                [
                    91.3495087,
                    55.4545169
                ],
                [
                    91.3505383,
                    55.4539309
                ],
                [
                    91.3514312,
                    55.4532958
                ],
                [
                    91.3551592,
                    55.4543465
                ],
                [
                    91.3559923,
                    55.4536116
                ],
                [
                    91.3564473,
                    55.4533753
                ],
                [
                    91.3567173,
                    55.4530429
                ],
                [
                    91.3554755,
                    55.4525835
                ],
                [
                    91.3542643,
                    55.4522904
                ],
                [
                    91.3552903,
                    55.4514899
                ],
                [
                    91.3560694,
                    55.4507811
                ],
                [
                    91.3543885,
                    55.4502019
                ],
                [
                    91.3542412,
                    55.4501512
                ],
                [
                    91.3547657,
                    55.4498843
                ],
                [
                    91.3551515,
                    55.4493768
                ],
                [
                    91.3550975,
                    55.4490749
                ],
                [
                    91.3554022,
                    55.4478628
                ],
                [
                    91.3554092,
                    55.4478219
                ],
                [
                    91.3556244,
                    55.4465607
                ],
                [
                    91.35244,
                    55.4464557
                ],
                [
                    91.3515389,
                    55.4463577
                ],
                [
                    91.3511829,
                    55.4464452
                ],
                [
                    91.3510699,
                    55.4464942
                ],
                [
                    91.3510557,
                    55.4476236
                ],
                [
                    91.3488817,
                    55.4476375
                ],
                [
                    91.3470856,
                    55.4478152
                ],
                [
                    91.3471644,
                    55.4488252
                ],
                [
                    91.3472183,
                    55.4495174
                ],
                [
                    91.3460853,
                    55.4495311
                ],
                [
                    91.3460732,
                    55.4498934
                ],
                [
                    91.3463505,
                    55.450242
                ],
                [
                    91.3469531,
                    55.4504744
                ],
                [
                    91.3477607,
                    55.4505223
                ],
                [
                    91.3472183,
                    55.4513699
                ],
                [
                    91.3452656,
                    55.4532565
                ]
            ],
            "longitude": 91.351685,
            "latitude": 55.450474
        },
        "341": {
            "name": "Алтат",
            "population": 103,
            "type": "village",
            "poly": null,
            "longitude": 91.3935477,
            "latitude": 57.491625
        },
        "342": {
            "name": "Чулым",
            "population": 722,
            "type": "village",
            "poly": null,
            "longitude": 91.398033,
            "latitude": 55.251724
        },
        "343": {
            "name": "Суриково",
            "population": 699,
            "type": "village",
            "poly": [
                [
                    91.3845445,
                    56.9818945
                ],
                [
                    91.3850734,
                    56.9835555
                ],
                [
                    91.3850317,
                    56.9840459
                ],
                [
                    91.3852637,
                    56.9849434
                ],
                [
                    91.3883677,
                    56.9844403
                ],
                [
                    91.3881496,
                    56.984951
                ],
                [
                    91.3881171,
                    56.9852822
                ],
                [
                    91.3884929,
                    56.9854895
                ],
                [
                    91.3883537,
                    56.9863161
                ],
                [
                    91.3881685,
                    56.9869366
                ],
                [
                    91.3884298,
                    56.9870046
                ],
                [
                    91.3891188,
                    56.9869754
                ],
                [
                    91.389389,
                    56.9870369
                ],
                [
                    91.3897186,
                    56.9872003
                ],
                [
                    91.3897275,
                    56.9872715
                ],
                [
                    91.3896752,
                    56.9873741
                ],
                [
                    91.3901567,
                    56.9876269
                ],
                [
                    91.3909164,
                    56.9878007
                ],
                [
                    91.3914848,
                    56.9877722
                ],
                [
                    91.3918386,
                    56.988044
                ],
                [
                    91.3920271,
                    56.9882956
                ],
                [
                    91.3920493,
                    56.9884917
                ],
                [
                    91.3921496,
                    56.9886211
                ],
                [
                    91.3920865,
                    56.9892399
                ],
                [
                    91.3916897,
                    56.9893671
                ],
                [
                    91.3913965,
                    56.9893024
                ],
                [
                    91.3910364,
                    56.989359
                ],
                [
                    91.3905613,
                    56.9894197
                ],
                [
                    91.390565,
                    56.9896866
                ],
                [
                    91.3897856,
                    56.989814
                ],
                [
                    91.389496,
                    56.989994
                ],
                [
                    91.3898635,
                    56.990362
                ],
                [
                    91.3899859,
                    56.9906026
                ],
                [
                    91.3902883,
                    56.9908092
                ],
                [
                    91.3907248,
                    56.990869
                ],
                [
                    91.3913543,
                    56.990869
                ],
                [
                    91.3921739,
                    56.9908059
                ],
                [
                    91.3931568,
                    56.990869
                ],
                [
                    91.3937536,
                    56.9911246
                ],
                [
                    91.3954253,
                    56.9912346
                ],
                [
                    91.3956807,
                    56.9910421
                ],
                [
                    91.3956779,
                    56.9908464
                ],
                [
                    91.395905,
                    56.9906024
                ],
                [
                    91.3960269,
                    56.9905771
                ],
                [
                    91.3959167,
                    56.990318
                ],
                [
                    91.395975,
                    56.9900749
                ],
                [
                    91.3962682,
                    56.9898545
                ],
                [
                    91.397623,
                    56.9897231
                ],
                [
                    91.3983283,
                    56.990627
                ],
                [
                    91.3992005,
                    56.9915672
                ],
                [
                    91.3997796,
                    56.9927258
                ],
                [
                    91.4001804,
                    56.9926814
                ],
                [
                    91.4004217,
                    56.9925883
                ],
                [
                    91.4005776,
                    56.9924387
                ],
                [
                    91.40047,
                    56.9918786
                ],
                [
                    91.4003565,
                    56.9911128
                ],
                [
                    91.4021025,
                    56.9910837
                ],
                [
                    91.4027231,
                    56.9913474
                ],
                [
                    91.4029221,
                    56.9914088
                ],
                [
                    91.4030913,
                    56.9914088
                ],
                [
                    91.4034774,
                    56.9913263
                ],
                [
                    91.4042583,
                    56.9913069
                ],
                [
                    91.4048403,
                    56.9912357
                ],
                [
                    91.4053006,
                    56.9911079
                ],
                [
                    91.4056302,
                    56.9910724
                ],
                [
                    91.4056451,
                    56.991129
                ],
                [
                    91.4058766,
                    56.9913037
                ],
                [
                    91.4059153,
                    56.9915722
                ],
                [
                    91.4059984,
                    56.9917696
                ],
                [
                    91.4059984,
                    56.9918375
                ],
                [
                    91.40604,
                    56.9918957
                ],
                [
                    91.4062954,
                    56.9919135
                ],
                [
                    91.4066517,
                    56.9918197
                ],
                [
                    91.4069457,
                    56.99181
                ],
                [
                    91.4070051,
                    56.9919427
                ],
                [
                    91.4073822,
                    56.9920106
                ],
                [
                    91.4075307,
                    56.9918537
                ],
                [
                    91.4077653,
                    56.9917016
                ],
                [
                    91.4080325,
                    56.9915771
                ],
                [
                    91.4078543,
                    56.9915027
                ],
                [
                    91.4075426,
                    56.9913359
                ],
                [
                    91.4075136,
                    56.9912001
                ],
                [
                    91.4072817,
                    56.9911495
                ],
                [
                    91.4068872,
                    56.9911527
                ],
                [
                    91.4070497,
                    56.9905429
                ],
                [
                    91.4064348,
                    56.9895286
                ],
                [
                    91.4059999,
                    56.9889915
                ],
                [
                    91.4060637,
                    56.988843
                ],
                [
                    91.4065393,
                    56.9887545
                ],
                [
                    91.4068061,
                    56.988625
                ],
                [
                    91.4077439,
                    56.98837
                ],
                [
                    91.4088994,
                    56.9881324
                ],
                [
                    91.4090849,
                    56.9879353
                ],
                [
                    91.4093077,
                    56.9878594
                ],
                [
                    91.4096881,
                    56.9878341
                ],
                [
                    91.4102402,
                    56.987637
                ],
                [
                    91.4109733,
                    56.9869342
                ],
                [
                    91.4108852,
                    56.9866182
                ],
                [
                    91.4106717,
                    56.9863933
                ],
                [
                    91.4107135,
                    56.9861607
                ],
                [
                    91.4110336,
                    56.9859281
                ],
                [
                    91.4104305,
                    56.9857486
                ],
                [
                    91.410565,
                    56.9855388
                ],
                [
                    91.4095675,
                    56.9853189
                ],
                [
                    91.409252,
                    56.9853138
                ],
                [
                    91.4075724,
                    56.9840523
                ],
                [
                    91.406946,
                    56.9833293
                ],
                [
                    91.4060365,
                    56.9834304
                ],
                [
                    91.4051968,
                    56.9832711
                ],
                [
                    91.4048256,
                    56.9830562
                ],
                [
                    91.4045194,
                    56.982447
                ],
                [
                    91.40419,
                    56.9824697
                ],
                [
                    91.4039116,
                    56.9825051
                ],
                [
                    91.4035497,
                    56.9824368
                ],
                [
                    91.4034244,
                    56.9823104
                ],
                [
                    91.4032852,
                    56.9817719
                ],
                [
                    91.4038652,
                    56.981466
                ],
                [
                    91.4040972,
                    56.9814407
                ],
                [
                    91.4042225,
                    56.9814812
                ],
                [
                    91.4045194,
                    56.9815267
                ],
                [
                    91.4047189,
                    56.9815216
                ],
                [
                    91.4050855,
                    56.9812865
                ],
                [
                    91.4053963,
                    56.9811272
                ],
                [
                    91.4054427,
                    56.9810236
                ],
                [
                    91.4057953,
                    56.9809882
                ],
                [
                    91.4057675,
                    56.9807985
                ],
                [
                    91.4060181,
                    56.9806974
                ],
                [
                    91.4061758,
                    56.9805912
                ],
                [
                    91.4062083,
                    56.9807657
                ],
                [
                    91.4063196,
                    56.9809325
                ],
                [
                    91.4065238,
                    56.9809376
                ],
                [
                    91.4070665,
                    56.9808617
                ],
                [
                    91.4077023,
                    56.9807252
                ],
                [
                    91.4077359,
                    56.9805704
                ],
                [
                    91.4073821,
                    56.980052
                ],
                [
                    91.407272,
                    56.9800362
                ],
                [
                    91.4071038,
                    56.9800615
                ],
                [
                    91.4068312,
                    56.9799003
                ],
                [
                    91.4068022,
                    56.9797866
                ],
                [
                    91.406663,
                    56.9796317
                ],
                [
                    91.4057176,
                    56.9797676
                ],
                [
                    91.4054624,
                    56.979736
                ],
                [
                    91.4053348,
                    56.9795843
                ],
                [
                    91.4051357,
                    56.9794479
                ],
                [
                    91.4046161,
                    56.9794656
                ],
                [
                    91.4040918,
                    56.979544
                ],
                [
                    91.4040315,
                    56.979458
                ],
                [
                    91.4039155,
                    56.9793771
                ],
                [
                    91.4036092,
                    56.9793619
                ],
                [
                    91.4031592,
                    56.979367
                ],
                [
                    91.4035768,
                    56.978927
                ],
                [
                    91.4037716,
                    56.9786565
                ],
                [
                    91.4037948,
                    56.9783455
                ],
                [
                    91.4035442,
                    56.9779485
                ],
                [
                    91.4033216,
                    56.9778246
                ],
                [
                    91.4027694,
                    56.9777285
                ],
                [
                    91.4024725,
                    56.9777387
                ],
                [
                    91.4024957,
                    56.9774403
                ],
                [
                    91.4031592,
                    56.9771495
                ],
                [
                    91.4029597,
                    56.9769093
                ],
                [
                    91.4026163,
                    56.9765806
                ],
                [
                    91.40231,
                    56.9766311
                ],
                [
                    91.4021802,
                    56.9766969
                ],
                [
                    91.4022915,
                    56.9768941
                ],
                [
                    91.4022962,
                    56.9770307
                ],
                [
                    91.4020874,
                    56.9771697
                ],
                [
                    91.4015074,
                    56.977324
                ],
                [
                    91.4014193,
                    56.9774757
                ],
                [
                    91.400895,
                    56.9777235
                ],
                [
                    91.4007139,
                    56.9778069
                ],
                [
                    91.4005284,
                    56.9778095
                ],
                [
                    91.4003752,
                    56.977721
                ],
                [
                    91.4003381,
                    56.9775869
                ],
                [
                    91.4001526,
                    56.9775338
                ],
                [
                    91.4000505,
                    56.9775642
                ],
                [
                    91.3997581,
                    56.9775869
                ],
                [
                    91.3997304,
                    56.9773366
                ],
                [
                    91.3993314,
                    56.9773467
                ],
                [
                    91.3984359,
                    56.977018
                ],
                [
                    91.3981158,
                    56.9769472
                ],
                [
                    91.3976425,
                    56.9768916
                ],
                [
                    91.397132,
                    56.9767348
                ],
                [
                    91.3970949,
                    56.9766059
                ],
                [
                    91.3972992,
                    56.9765603
                ],
                [
                    91.3972992,
                    56.9764693
                ],
                [
                    91.3971275,
                    56.9761811
                ],
                [
                    91.3970625,
                    56.9761128
                ],
                [
                    91.3969744,
                    56.9761001
                ],
                [
                    91.3966635,
                    56.9761684
                ],
                [
                    91.3963526,
                    56.9761128
                ],
                [
                    91.3959119,
                    56.9761684
                ],
                [
                    91.3959026,
                    56.9760445
                ],
                [
                    91.3960928,
                    56.9757259
                ],
                [
                    91.3966635,
                    56.9752328
                ],
                [
                    91.3976147,
                    56.9747119
                ],
                [
                    91.3977121,
                    56.9745956
                ],
                [
                    91.3966449,
                    56.9740064
                ],
                [
                    91.3957541,
                    56.9734096
                ],
                [
                    91.3955082,
                    56.9733919
                ],
                [
                    91.3947009,
                    56.9735209
                ],
                [
                    91.3946034,
                    56.9738901
                ],
                [
                    91.3943761,
                    56.9739836
                ],
                [
                    91.3943668,
                    56.9741986
                ],
                [
                    91.3941256,
                    56.9743806
                ],
                [
                    91.3944503,
                    56.9748459
                ],
                [
                    91.3949282,
                    56.9759611
                ],
                [
                    91.3945617,
                    56.9763454
                ],
                [
                    91.3941533,
                    56.9764693
                ],
                [
                    91.3940791,
                    56.9765882
                ],
                [
                    91.394042,
                    56.9768916
                ],
                [
                    91.3940745,
                    56.9771419
                ],
                [
                    91.3939307,
                    56.9774428
                ],
                [
                    91.3934899,
                    56.97764
                ],
                [
                    91.3934296,
                    56.9778019
                ],
                [
                    91.3932115,
                    56.9779106
                ],
                [
                    91.3919866,
                    56.9778853
                ],
                [
                    91.3914809,
                    56.9779308
                ],
                [
                    91.3923347,
                    56.979442
                ],
                [
                    91.3917733,
                    56.9796089
                ],
                [
                    91.3911469,
                    56.9799452
                ],
                [
                    91.3893745,
                    56.9801651
                ],
                [
                    91.387217,
                    56.980112
                ],
                [
                    91.3864654,
                    56.9801348
                ],
                [
                    91.3860014,
                    56.980241
                ],
                [
                    91.3857091,
                    56.9803927
                ],
                [
                    91.3860198,
                    56.9809514
                ],
                [
                    91.3861174,
                    56.9813105
                ],
                [
                    91.3845445,
                    56.9818945
                ]
            ],
            "longitude": 91.4008658,
            "latitude": 56.9860299
        },
        "344": {
            "name": "Лазурный",
            "population": 516,
            "type": "village",
            "poly": [
                [
                    91.4083504,
                    56.1583045
                ],
                [
                    91.4085135,
                    56.1587246
                ],
                [
                    91.4095966,
                    56.1600959
                ],
                [
                    91.4098389,
                    56.16014
                ],
                [
                    91.4102565,
                    56.1602935
                ],
                [
                    91.4108082,
                    56.1603785
                ],
                [
                    91.4207667,
                    56.1602686
                ],
                [
                    91.4206832,
                    56.1599517
                ],
                [
                    91.4206519,
                    56.1597657
                ],
                [
                    91.4208033,
                    56.159661
                ],
                [
                    91.4213357,
                    56.1593965
                ],
                [
                    91.4214558,
                    56.159193
                ],
                [
                    91.421414,
                    56.1591058
                ],
                [
                    91.421273,
                    56.1588936
                ],
                [
                    91.4211687,
                    56.1587831
                ],
                [
                    91.4212835,
                    56.1583848
                ],
                [
                    91.4217429,
                    56.158318
                ],
                [
                    91.4222231,
                    56.1580593
                ],
                [
                    91.4222962,
                    56.1578267
                ],
                [
                    91.4223276,
                    56.1572976
                ],
                [
                    91.4224894,
                    56.1568964
                ],
                [
                    91.4225677,
                    56.1568295
                ],
                [
                    91.4219413,
                    56.1568092
                ],
                [
                    91.4218545,
                    56.1565911
                ],
                [
                    91.4216261,
                    56.1562141
                ],
                [
                    91.4212463,
                    56.1552602
                ],
                [
                    91.4205892,
                    56.1552833
                ],
                [
                    91.4198323,
                    56.1552506
                ],
                [
                    91.4180444,
                    56.1554722
                ],
                [
                    91.4176333,
                    56.1555231
                ],
                [
                    91.4170461,
                    56.1546582
                ],
                [
                    91.4152973,
                    56.1546328
                ],
                [
                    91.4146774,
                    56.1544874
                ],
                [
                    91.4142272,
                    56.1544801
                ],
                [
                    91.4128765,
                    56.1543529
                ],
                [
                    91.4122697,
                    56.1543202
                ],
                [
                    91.4117999,
                    56.1543129
                ],
                [
                    91.4115584,
                    56.1544038
                ],
                [
                    91.411304,
                    56.1545746
                ],
                [
                    91.411056,
                    56.1547163
                ],
                [
                    91.4109255,
                    56.1553887
                ],
                [
                    91.4101229,
                    56.1553923
                ],
                [
                    91.4100772,
                    56.1554504
                ],
                [
                    91.4099206,
                    56.1555449
                ],
                [
                    91.409627,
                    56.1555667
                ],
                [
                    91.4093921,
                    56.1556358
                ],
                [
                    91.4091963,
                    56.1557666
                ],
                [
                    91.4090538,
                    56.1560259
                ],
                [
                    91.4089159,
                    56.1565795
                ],
                [
                    91.4085944,
                    56.1569376
                ],
                [
                    91.4084357,
                    56.1570632
                ],
                [
                    91.4083772,
                    56.1575772
                ],
                [
                    91.4087948,
                    56.1579307
                ],
                [
                    91.4089076,
                    56.1582935
                ],
                [
                    91.4083504,
                    56.1583045
                ]
            ],
            "longitude": 91.414825,
            "latitude": 56.157696
        },
        "345": {
            "name": "Кульчек",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 91.415001,
            "latitude": 54.911186
        },
        "346": {
            "name": "Новая Сыда",
            "population": 511,
            "type": "village",
            "poly": null,
            "longitude": 91.420883,
            "latitude": 54.395
        },
        "347": {
            "name": "Еловка",
            "population": 584,
            "type": "village",
            "poly": [
                [
                    91.4436811,
                    55.5202483
                ],
                [
                    91.4448159,
                    55.5205499
                ],
                [
                    91.4439278,
                    55.5214884
                ],
                [
                    91.4455264,
                    55.5219576
                ],
                [
                    91.4459704,
                    55.52198
                ],
                [
                    91.4462664,
                    55.5221252
                ],
                [
                    91.4465032,
                    55.522505
                ],
                [
                    91.4463059,
                    55.5228122
                ],
                [
                    91.4463999,
                    55.5230072
                ],
                [
                    91.4462938,
                    55.5231016
                ],
                [
                    91.4462786,
                    55.5232846
                ],
                [
                    91.4469152,
                    55.5237537
                ],
                [
                    91.4475013,
                    55.5237108
                ],
                [
                    91.4474912,
                    55.5240768
                ],
                [
                    91.4485269,
                    55.5247403
                ],
                [
                    91.4492443,
                    55.5250263
                ],
                [
                    91.449795,
                    55.5250148
                ],
                [
                    91.4502007,
                    55.5248708
                ],
                [
                    91.4502951,
                    55.5248375
                ],
                [
                    91.4509873,
                    55.5258728
                ],
                [
                    91.4518373,
                    55.5268291
                ],
                [
                    91.4520102,
                    55.5270237
                ],
                [
                    91.451909,
                    55.5270612
                ],
                [
                    91.4517882,
                    55.5271284
                ],
                [
                    91.450271,
                    55.5274007
                ],
                [
                    91.4479582,
                    55.5281718
                ],
                [
                    91.4475698,
                    55.5283013
                ],
                [
                    91.4471011,
                    55.5285805
                ],
                [
                    91.4465337,
                    55.52916
                ],
                [
                    91.4459624,
                    55.5294852
                ],
                [
                    91.4459046,
                    55.5301942
                ],
                [
                    91.4464744,
                    55.5309484
                ],
                [
                    91.4467981,
                    55.531069
                ],
                [
                    91.4466876,
                    55.5317213
                ],
                [
                    91.4464902,
                    55.5319938
                ],
                [
                    91.4467034,
                    55.5321904
                ],
                [
                    91.4476743,
                    55.5324718
                ],
                [
                    91.4476417,
                    55.5325073
                ],
                [
                    91.447477,
                    55.5326863
                ],
                [
                    91.4478322,
                    55.5329007
                ],
                [
                    91.4477928,
                    55.5331152
                ],
                [
                    91.4479506,
                    55.5332626
                ],
                [
                    91.4483217,
                    55.5331777
                ],
                [
                    91.4492847,
                    55.5327935
                ],
                [
                    91.4495531,
                    55.5328471
                ],
                [
                    91.4508096,
                    55.531413
                ],
                [
                    91.4509662,
                    55.5312343
                ],
                [
                    91.4514793,
                    55.5316587
                ],
                [
                    91.4517477,
                    55.5315471
                ],
                [
                    91.4520082,
                    55.5316453
                ],
                [
                    91.4522814,
                    55.5324242
                ],
                [
                    91.4528877,
                    55.5324528
                ],
                [
                    91.4530266,
                    55.5325207
                ],
                [
                    91.4534118,
                    55.532485
                ],
                [
                    91.4535318,
                    55.5326387
                ],
                [
                    91.4540623,
                    55.5327673
                ],
                [
                    91.4543212,
                    55.5327102
                ],
                [
                    91.4545044,
                    55.5327566
                ],
                [
                    91.4545612,
                    55.532871
                ],
                [
                    91.454898,
                    55.5330445
                ],
                [
                    91.4557171,
                    55.5329439
                ],
                [
                    91.4560427,
                    55.5327764
                ],
                [
                    91.4563881,
                    55.5330836
                ],
                [
                    91.4562992,
                    55.533575
                ],
                [
                    91.4561019,
                    55.5337816
                ],
                [
                    91.456171,
                    55.5339268
                ],
                [
                    91.4564374,
                    55.5340831
                ],
                [
                    91.4574538,
                    55.5338933
                ],
                [
                    91.4573945,
                    55.5334298
                ],
                [
                    91.4571281,
                    55.5331617
                ],
                [
                    91.4578978,
                    55.5328881
                ],
                [
                    91.4579373,
                    55.5326703
                ],
                [
                    91.4576215,
                    55.5324525
                ],
                [
                    91.4572761,
                    55.5325139
                ],
                [
                    91.4573156,
                    55.5321789
                ],
                [
                    91.4570097,
                    55.5320448
                ],
                [
                    91.4569308,
                    55.5318494
                ],
                [
                    91.4566841,
                    55.5318215
                ],
                [
                    91.4566249,
                    55.5316539
                ],
                [
                    91.4554408,
                    55.5305761
                ],
                [
                    91.4552335,
                    55.5305035
                ],
                [
                    91.4543652,
                    55.5293251
                ],
                [
                    91.4539014,
                    55.5289788
                ],
                [
                    91.4542949,
                    55.5290308
                ],
                [
                    91.4547143,
                    55.5289191
                ],
                [
                    91.454961,
                    55.5285701
                ],
                [
                    91.4538386,
                    55.5269155
                ],
                [
                    91.4535425,
                    55.5257146
                ],
                [
                    91.4540606,
                    55.5252329
                ],
                [
                    91.4547336,
                    55.5240146
                ],
                [
                    91.4551213,
                    55.5233128
                ],
                [
                    91.4559724,
                    55.5222306
                ],
                [
                    91.4570702,
                    55.5218116
                ],
                [
                    91.4594631,
                    55.5213787
                ],
                [
                    91.4624727,
                    55.5211134
                ],
                [
                    91.4654946,
                    55.5215812
                ],
                [
                    91.4668514,
                    55.5221538
                ],
                [
                    91.467316,
                    55.5224104
                ],
                [
                    91.4688743,
                    55.5232709
                ],
                [
                    91.4704638,
                    55.5244594
                ],
                [
                    91.4712178,
                    55.5245696
                ],
                [
                    91.4716665,
                    55.524528
                ],
                [
                    91.4718962,
                    55.5245068
                ],
                [
                    91.472957,
                    55.5241018
                ],
                [
                    91.47329,
                    55.523655
                ],
                [
                    91.4734997,
                    55.523236
                ],
                [
                    91.4741781,
                    55.5228729
                ],
                [
                    91.4750538,
                    55.5226146
                ],
                [
                    91.4752321,
                    55.5214486
                ],
                [
                    91.4762999,
                    55.5205489
                ],
                [
                    91.4770999,
                    55.5203933
                ],
                [
                    91.4775207,
                    55.5204081
                ],
                [
                    91.4802837,
                    55.5197238
                ],
                [
                    91.4807277,
                    55.5196889
                ],
                [
                    91.4811347,
                    55.5198425
                ],
                [
                    91.4819858,
                    55.5197378
                ],
                [
                    91.4825039,
                    55.5195772
                ],
                [
                    91.4821215,
                    55.5189068
                ],
                [
                    91.4818378,
                    55.5189278
                ],
                [
                    91.4819068,
                    55.5186088
                ],
                [
                    91.4819118,
                    55.5185856
                ],
                [
                    91.4824052,
                    55.5185228
                ],
                [
                    91.4823805,
                    55.5176359
                ],
                [
                    91.4821708,
                    55.5170144
                ],
                [
                    91.4824915,
                    55.5169655
                ],
                [
                    91.4822325,
                    55.5165256
                ],
                [
                    91.4808881,
                    55.516742
                ],
                [
                    91.4808511,
                    55.5169166
                ],
                [
                    91.4803577,
                    55.5172379
                ],
                [
                    91.4800616,
                    55.5172728
                ],
                [
                    91.4791736,
                    55.5169725
                ],
                [
                    91.4784952,
                    55.5168817
                ],
                [
                    91.4788775,
                    55.5167071
                ],
                [
                    91.4787789,
                    55.5165535
                ],
                [
                    91.4780758,
                    55.5162183
                ],
                [
                    91.4777551,
                    55.5162672
                ],
                [
                    91.4771384,
                    55.5162183
                ],
                [
                    91.4768917,
                    55.5162951
                ],
                [
                    91.4765957,
                    55.5166513
                ],
                [
                    91.4760529,
                    55.5168258
                ],
                [
                    91.4753252,
                    55.5173985
                ],
                [
                    91.4746715,
                    55.517601
                ],
                [
                    91.4744125,
                    55.5179082
                ],
                [
                    91.4729323,
                    55.5179013
                ],
                [
                    91.4722909,
                    55.5179292
                ],
                [
                    91.4722169,
                    55.5171331
                ],
                [
                    91.4719332,
                    55.5161624
                ],
                [
                    91.4704778,
                    55.5154571
                ],
                [
                    91.4696267,
                    55.5152685
                ],
                [
                    91.4678382,
                    55.5150939
                ],
                [
                    91.4671104,
                    55.5153733
                ],
                [
                    91.4668514,
                    55.5153663
                ],
                [
                    91.4668812,
                    55.5154374
                ],
                [
                    91.4669624,
                    55.5156317
                ],
                [
                    91.4668021,
                    55.5161973
                ],
                [
                    91.4654576,
                    55.5161275
                ],
                [
                    91.4649149,
                    55.516358
                ],
                [
                    91.4645942,
                    55.516763
                ],
                [
                    91.4645819,
                    55.5171052
                ],
                [
                    91.4643599,
                    55.5173007
                ],
                [
                    91.4636815,
                    55.517608
                ],
                [
                    91.4642572,
                    55.5185641
                ],
                [
                    91.4640993,
                    55.5185016
                ],
                [
                    91.463452,
                    55.5184122
                ],
                [
                    91.4630573,
                    55.5184345
                ],
                [
                    91.4626784,
                    55.5183764
                ],
                [
                    91.4622995,
                    55.5183898
                ],
                [
                    91.461668,
                    55.5180904
                ],
                [
                    91.4609496,
                    55.5178401
                ],
                [
                    91.460547,
                    55.517858
                ],
                [
                    91.4603102,
                    55.517639
                ],
                [
                    91.4595997,
                    55.5174424
                ],
                [
                    91.4593313,
                    55.5174558
                ],
                [
                    91.4592997,
                    55.5170357
                ],
                [
                    91.4588971,
                    55.5166334
                ],
                [
                    91.4584235,
                    55.5165396
                ],
                [
                    91.4584393,
                    55.5164278
                ],
                [
                    91.4584314,
                    55.5160077
                ],
                [
                    91.4583682,
                    55.5157395
                ],
                [
                    91.458684,
                    55.5154714
                ],
                [
                    91.4588024,
                    55.5152792
                ],
                [
                    91.4586209,
                    55.5150781
                ],
                [
                    91.4581156,
                    55.5148814
                ],
                [
                    91.4580762,
                    55.5145417
                ],
                [
                    91.4586445,
                    55.5140456
                ],
                [
                    91.4574414,
                    55.5133651
                ],
                [
                    91.4573578,
                    55.5133126
                ],
                [
                    91.4551554,
                    55.5144523
                ],
                [
                    91.4544686,
                    55.5149797
                ],
                [
                    91.4507694,
                    55.5177928
                ],
                [
                    91.4501,
                    55.5183148
                ],
                [
                    91.4497969,
                    55.5188332
                ],
                [
                    91.4497497,
                    55.5195332
                ],
                [
                    91.4468289,
                    55.5195053
                ],
                [
                    91.4474308,
                    55.5186785
                ],
                [
                    91.4456349,
                    55.5180528
                ],
                [
                    91.4437436,
                    55.5201779
                ],
                [
                    91.4436811,
                    55.5202483
                ]
            ],
            "longitude": 91.452087,
            "latitude": 55.522758
        },
        "348": {
            "name": "Рассвет",
            "population": 2744,
            "type": "village",
            "poly": [
                [
                    91.4515768,
                    57.0019837
                ],
                [
                    91.4515883,
                    57.0031046
                ],
                [
                    91.4517536,
                    57.003471
                ],
                [
                    91.4522344,
                    57.0039957
                ],
                [
                    91.4524206,
                    57.0042058
                ],
                [
                    91.4526829,
                    57.0043518
                ],
                [
                    91.4530848,
                    57.0044527
                ],
                [
                    91.4539943,
                    57.0044679
                ],
                [
                    91.4545372,
                    57.0045209
                ],
                [
                    91.4551914,
                    57.0045361
                ],
                [
                    91.4559423,
                    57.0046308
                ],
                [
                    91.4591808,
                    57.0055758
                ],
                [
                    91.4597979,
                    57.0053332
                ],
                [
                    91.4600437,
                    57.0051614
                ],
                [
                    91.4602115,
                    57.0047785
                ],
                [
                    91.4610016,
                    57.0042181
                ],
                [
                    91.4627548,
                    57.0046942
                ],
                [
                    91.4650876,
                    57.0054665
                ],
                [
                    91.4659571,
                    57.00572
                ],
                [
                    91.4668978,
                    57.0060253
                ],
                [
                    91.4673943,
                    57.0061469
                ],
                [
                    91.4680594,
                    57.0063746
                ],
                [
                    91.468708,
                    57.0066489
                ],
                [
                    91.4697104,
                    57.00698
                ],
                [
                    91.469537,
                    57.0075582
                ],
                [
                    91.469556,
                    57.0082529
                ],
                [
                    91.4694515,
                    57.0083227
                ],
                [
                    91.4693446,
                    57.0083887
                ],
                [
                    91.4691831,
                    57.0084184
                ],
                [
                    91.4690976,
                    57.0084676
                ],
                [
                    91.4690856,
                    57.0085323
                ],
                [
                    91.4691427,
                    57.0086047
                ],
                [
                    91.4692852,
                    57.0086474
                ],
                [
                    91.4695845,
                    57.0086306
                ],
                [
                    91.4696843,
                    57.0087147
                ],
                [
                    91.4696582,
                    57.0088285
                ],
                [
                    91.4695703,
                    57.0088841
                ],
                [
                    91.4694776,
                    57.0089242
                ],
                [
                    91.4695155,
                    57.0089604
                ],
                [
                    91.4696178,
                    57.0089798
                ],
                [
                    91.4697627,
                    57.0090083
                ],
                [
                    91.4699147,
                    57.0090561
                ],
                [
                    91.4699884,
                    57.0090484
                ],
                [
                    91.470435,
                    57.0090419
                ],
                [
                    91.4705253,
                    57.0090743
                ],
                [
                    91.4705348,
                    57.0091428
                ],
                [
                    91.4704017,
                    57.0093575
                ],
                [
                    91.4701974,
                    57.0094183
                ],
                [
                    91.4700502,
                    57.0094403
                ],
                [
                    91.4699955,
                    57.0094649
                ],
                [
                    91.4700121,
                    57.009514
                ],
                [
                    91.4701357,
                    57.0095347
                ],
                [
                    91.4707437,
                    57.0095606
                ],
                [
                    91.4708935,
                    57.0095477
                ],
                [
                    91.471131,
                    57.0095619
                ],
                [
                    91.471131,
                    57.0096059
                ],
                [
                    91.4710835,
                    57.0096576
                ],
                [
                    91.471207,
                    57.0097042
                ],
                [
                    91.471352,
                    57.0097068
                ],
                [
                    91.4716442,
                    57.0096887
                ],
                [
                    91.471991,
                    57.009298
                ],
                [
                    91.4722238,
                    57.0093433
                ],
                [
                    91.4722879,
                    57.0094468
                ],
                [
                    91.4724162,
                    57.009483
                ],
                [
                    91.4726348,
                    57.0094804
                ],
                [
                    91.4727559,
                    57.0095516
                ],
                [
                    91.4728747,
                    57.0098038
                ],
                [
                    91.4732952,
                    57.0098167
                ],
                [
                    91.473661,
                    57.0099577
                ],
                [
                    91.4735327,
                    57.0104842
                ],
                [
                    91.473642,
                    57.0106743
                ],
                [
                    91.473889,
                    57.0108075
                ],
                [
                    91.4743119,
                    57.0107933
                ],
                [
                    91.4745732,
                    57.0107131
                ],
                [
                    91.474768,
                    57.0109485
                ],
                [
                    91.4746421,
                    57.0111244
                ],
                [
                    91.4752745,
                    57.0115172
                ],
                [
                    91.476086,
                    57.0116866
                ],
                [
                    91.4766798,
                    57.0119518
                ],
                [
                    91.4772969,
                    57.0122019
                ],
                [
                    91.4780265,
                    57.0123953
                ],
                [
                    91.4781862,
                    57.0123895
                ],
                [
                    91.4785205,
                    57.0122779
                ],
                [
                    91.479326,
                    57.0123527
                ],
                [
                    91.4798753,
                    57.0125184
                ],
                [
                    91.4804915,
                    57.0128559
                ],
                [
                    91.4814231,
                    57.0131065
                ],
                [
                    91.482069,
                    57.0131812
                ],
                [
                    91.4831937,
                    57.0135066
                ],
                [
                    91.4837615,
                    57.0135672
                ],
                [
                    91.484181,
                    57.0134783
                ],
                [
                    91.4843473,
                    57.0134945
                ],
                [
                    91.4844303,
                    57.013467
                ],
                [
                    91.4849679,
                    57.0135187
                ],
                [
                    91.4851431,
                    57.0136093
                ],
                [
                    91.4848194,
                    57.0138421
                ],
                [
                    91.4853035,
                    57.0140296
                ],
                [
                    91.4859508,
                    57.0136012
                ],
                [
                    91.4859929,
                    57.0135962
                ],
                [
                    91.4864295,
                    57.0136852
                ],
                [
                    91.4873114,
                    57.0134912
                ],
                [
                    91.4874153,
                    57.0133845
                ],
                [
                    91.4874539,
                    57.0131969
                ],
                [
                    91.4874718,
                    57.0129787
                ],
                [
                    91.4875668,
                    57.0128946
                ],
                [
                    91.4877746,
                    57.0128671
                ],
                [
                    91.4880746,
                    57.0127491
                ],
                [
                    91.4885378,
                    57.0124791
                ],
                [
                    91.4888318,
                    57.012353
                ],
                [
                    91.489592,
                    57.0122042
                ],
                [
                    91.4897909,
                    57.0121186
                ],
                [
                    91.4898681,
                    57.0120684
                ],
                [
                    91.4898414,
                    57.0119634
                ],
                [
                    91.4896662,
                    57.0118162
                ],
                [
                    91.489583,
                    57.0116174
                ],
                [
                    91.4896513,
                    57.0114201
                ],
                [
                    91.4899008,
                    57.0111695
                ],
                [
                    91.4915927,
                    57.0098633
                ],
                [
                    91.4922816,
                    57.0096095
                ],
                [
                    91.4925875,
                    57.0096014
                ],
                [
                    91.4929765,
                    57.0096984
                ],
                [
                    91.4936595,
                    57.0096337
                ],
                [
                    91.4941435,
                    57.0096661
                ],
                [
                    91.4942058,
                    57.0095982
                ],
                [
                    91.4945977,
                    57.0095965
                ],
                [
                    91.4949126,
                    57.0096531
                ],
                [
                    91.4954114,
                    57.0096402
                ],
                [
                    91.4957143,
                    57.0095173
                ],
                [
                    91.4961508,
                    57.0092602
                ],
                [
                    91.4961299,
                    57.0089934
                ],
                [
                    91.4960261,
                    57.0088932
                ],
                [
                    91.4960677,
                    57.0086911
                ],
                [
                    91.4962251,
                    57.0085003
                ],
                [
                    91.4964389,
                    57.008434
                ],
                [
                    91.4967417,
                    57.0084178
                ],
                [
                    91.4968308,
                    57.0083564
                ],
                [
                    91.497009,
                    57.0080039
                ],
                [
                    91.4971634,
                    57.0078228
                ],
                [
                    91.497303,
                    57.0073442
                ],
                [
                    91.497383,
                    57.0067233
                ],
                [
                    91.4972822,
                    57.0063514
                ],
                [
                    91.4970595,
                    57.0061379
                ],
                [
                    91.4966586,
                    57.00596
                ],
                [
                    91.4961182,
                    57.0057725
                ],
                [
                    91.495943,
                    57.0055202
                ],
                [
                    91.4957559,
                    57.0053601
                ],
                [
                    91.4950462,
                    57.0056771
                ],
                [
                    91.4944671,
                    57.0053278
                ],
                [
                    91.4945443,
                    57.0052631
                ],
                [
                    91.4951114,
                    57.0051046
                ],
                [
                    91.4954768,
                    57.0048993
                ],
                [
                    91.4943305,
                    57.0038562
                ],
                [
                    91.4950046,
                    57.0036379
                ],
                [
                    91.4946334,
                    57.0034261
                ],
                [
                    91.4942415,
                    57.0034503
                ],
                [
                    91.4933506,
                    57.003363
                ],
                [
                    91.4927181,
                    57.002983
                ],
                [
                    91.4915036,
                    57.0033355
                ],
                [
                    91.4914769,
                    57.0032741
                ],
                [
                    91.4915927,
                    57.0030962
                ],
                [
                    91.4913997,
                    57.0027631
                ],
                [
                    91.4903663,
                    57.0027695
                ],
                [
                    91.4900338,
                    57.0031787
                ],
                [
                    91.4889915,
                    57.003308
                ],
                [
                    91.4886619,
                    57.0031948
                ],
                [
                    91.4882016,
                    57.0031398
                ],
                [
                    91.4868535,
                    57.0029021
                ],
                [
                    91.4860369,
                    57.0026693
                ],
                [
                    91.4860577,
                    57.0023588
                ],
                [
                    91.4861764,
                    57.0019512
                ],
                [
                    91.4865595,
                    57.0019254
                ],
                [
                    91.486797,
                    57.0018299
                ],
                [
                    91.4868683,
                    57.0016682
                ],
                [
                    91.4865951,
                    57.0014483
                ],
                [
                    91.486895,
                    57.0013286
                ],
                [
                    91.4871919,
                    57.0011701
                ],
                [
                    91.4868357,
                    57.0008337
                ],
                [
                    91.4862625,
                    57.0004149
                ],
                [
                    91.4865862,
                    57.0003243
                ],
                [
                    91.486895,
                    57.0001981
                ],
                [
                    91.487471,
                    57.0000817
                ],
                [
                    91.4872068,
                    56.9998359
                ],
                [
                    91.4861942,
                    56.9994024
                ],
                [
                    91.4864259,
                    56.9993151
                ],
                [
                    91.4857904,
                    56.9991097
                ],
                [
                    91.4856954,
                    56.9990159
                ],
                [
                    91.485443,
                    56.9988574
                ],
                [
                    91.4854816,
                    56.9984595
                ],
                [
                    91.485348,
                    56.9978854
                ],
                [
                    91.4851549,
                    56.9976767
                ],
                [
                    91.4847422,
                    56.9974956
                ],
                [
                    91.4846352,
                    56.9972756
                ],
                [
                    91.483694,
                    56.9964718
                ],
                [
                    91.4840978,
                    56.995904
                ],
                [
                    91.4837979,
                    56.9957601
                ],
                [
                    91.4838098,
                    56.9955207
                ],
                [
                    91.4836909,
                    56.9953654
                ],
                [
                    91.4834742,
                    56.9953088
                ],
                [
                    91.4832009,
                    56.9952959
                ],
                [
                    91.4829843,
                    56.9950791
                ],
                [
                    91.4826873,
                    56.9951471
                ],
                [
                    91.481847,
                    56.9954107
                ],
                [
                    91.4807334,
                    56.994898
                ],
                [
                    91.480285,
                    56.9948931
                ],
                [
                    91.4800059,
                    56.9950727
                ],
                [
                    91.4792012,
                    56.9953412
                ],
                [
                    91.4789993,
                    56.9952134
                ],
                [
                    91.4789547,
                    56.9949708
                ],
                [
                    91.4785865,
                    56.9950209
                ],
                [
                    91.4783549,
                    56.9950969
                ],
                [
                    91.4778531,
                    56.9950096
                ],
                [
                    91.4772443,
                    56.9946117
                ],
                [
                    91.4770335,
                    56.9946651
                ],
                [
                    91.4768583,
                    56.9946845
                ],
                [
                    91.4768464,
                    56.9945923
                ],
                [
                    91.4763446,
                    56.9941458
                ],
                [
                    91.4755309,
                    56.9937317
                ],
                [
                    91.4753795,
                    56.9935942
                ],
                [
                    91.4754092,
                    56.9933726
                ],
                [
                    91.4753616,
                    56.9931397
                ],
                [
                    91.4751716,
                    56.9930313
                ],
                [
                    91.4738829,
                    56.9930249
                ],
                [
                    91.4736899,
                    56.9929602
                ],
                [
                    91.4736245,
                    56.9928324
                ],
                [
                    91.4731673,
                    56.9928178
                ],
                [
                    91.4729683,
                    56.9926496
                ],
                [
                    91.4724813,
                    56.9924911
                ],
                [
                    91.4723209,
                    56.9923519
                ],
                [
                    91.4721844,
                    56.9923519
                ],
                [
                    91.4720953,
                    56.9924425
                ],
                [
                    91.4718755,
                    56.9924134
                ],
                [
                    91.4717122,
                    56.9924587
                ],
                [
                    91.4716677,
                    56.9925315
                ],
                [
                    91.4709817,
                    56.9925752
                ],
                [
                    91.4703196,
                    56.9922646
                ],
                [
                    91.4699662,
                    56.9922614
                ],
                [
                    91.4698385,
                    56.9921789
                ],
                [
                    91.4697702,
                    56.9920171
                ],
                [
                    91.4691466,
                    56.9918375
                ],
                [
                    91.4688378,
                    56.9918133
                ],
                [
                    91.4683746,
                    56.9916822
                ],
                [
                    91.4681934,
                    56.9915367
                ],
                [
                    91.4672273,
                    56.991237
                ],
                [
                    91.4671438,
                    56.9913204
                ],
                [
                    91.4669489,
                    56.9917197
                ],
                [
                    91.4669095,
                    56.9920997
                ],
                [
                    91.4662147,
                    56.9920608
                ],
                [
                    91.4648428,
                    56.9919395
                ],
                [
                    91.4644241,
                    56.9920301
                ],
                [
                    91.4643054,
                    56.9922355
                ],
                [
                    91.4638065,
                    56.9922485
                ],
                [
                    91.4636224,
                    56.9925397
                ],
                [
                    91.4635571,
                    56.9927661
                ],
                [
                    91.4630107,
                    56.9930605
                ],
                [
                    91.462586,
                    56.9930104
                ],
                [
                    91.4624554,
                    56.9927467
                ],
                [
                    91.4621317,
                    56.9924863
                ],
                [
                    91.4619357,
                    56.9924814
                ],
                [
                    91.4615675,
                    56.9927419
                ],
                [
                    91.4611666,
                    56.9927402
                ],
                [
                    91.4606707,
                    56.9926416
                ],
                [
                    91.4604212,
                    56.9927629
                ],
                [
                    91.4601838,
                    56.9929117
                ],
                [
                    91.4605693,
                    56.9932595
                ],
                [
                    91.4603261,
                    56.9934466
                ],
                [
                    91.4596541,
                    56.9935187
                ],
                [
                    91.4592086,
                    56.9937481
                ],
                [
                    91.4588893,
                    56.994028
                ],
                [
                    91.4589236,
                    56.9945639
                ],
                [
                    91.4587781,
                    56.9946464
                ],
                [
                    91.4584247,
                    56.994771
                ],
                [
                    91.4582287,
                    56.9947661
                ],
                [
                    91.4577149,
                    56.9949942
                ],
                [
                    91.4576794,
                    56.9950799
                ],
                [
                    91.4577922,
                    56.995232
                ],
                [
                    91.4583921,
                    56.9955037
                ],
                [
                    91.4586592,
                    56.9957577
                ],
                [
                    91.4589711,
                    56.995845
                ],
                [
                    91.4593481,
                    56.9958175
                ],
                [
                    91.4595135,
                    56.9958599
                ],
                [
                    91.4596751,
                    56.996085
                ],
                [
                    91.4598153,
                    56.9962442
                ],
                [
                    91.4596609,
                    56.9964008
                ],
                [
                    91.4596086,
                    56.9964668
                ],
                [
                    91.4594993,
                    56.9964913
                ],
                [
                    91.4592428,
                    56.9965017
                ],
                [
                    91.4591026,
                    56.9965509
                ],
                [
                    91.4589648,
                    56.9966596
                ],
                [
                    91.4587843,
                    56.9970607
                ],
                [
                    91.4594851,
                    56.9973143
                ],
                [
                    91.4591525,
                    56.9977038
                ],
                [
                    91.4587867,
                    56.9978577
                ],
                [
                    91.4586394,
                    56.9980026
                ],
                [
                    91.4585539,
                    56.9981178
                ],
                [
                    91.4585586,
                    56.9982265
                ],
                [
                    91.4587368,
                    56.9983779
                ],
                [
                    91.4587415,
                    56.9984749
                ],
                [
                    91.4585966,
                    56.9986341
                ],
                [
                    91.4583852,
                    56.9987738
                ],
                [
                    91.4581952,
                    56.9988424
                ],
                [
                    91.4581263,
                    56.9988954
                ],
                [
                    91.4581144,
                    56.9990261
                ],
                [
                    91.4579101,
                    56.9990274
                ],
                [
                    91.4577532,
                    56.9990675
                ],
                [
                    91.4575775,
                    56.9990145
                ],
                [
                    91.4573422,
                    56.9990662
                ],
                [
                    91.4567318,
                    56.9997274
                ],
                [
                    91.4563375,
                    57.0004739
                ],
                [
                    91.4561926,
                    57.001069
                ],
                [
                    91.4563161,
                    57.0012036
                ],
                [
                    91.4559598,
                    57.001148
                ],
                [
                    91.4556153,
                    57.001179
                ],
                [
                    91.4552922,
                    57.0012618
                ],
                [
                    91.4541306,
                    57.001778
                ],
                [
                    91.4536792,
                    57.0019165
                ],
                [
                    91.4515768,
                    57.0019837
                ]
            ],
            "longitude": 91.470993,
            "latitude": 57.000469
        },
        "349": {
            "name": "Никитино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 91.4840642,
            "latitude": 53.0153045
        },
        "350": {
            "name": "Сизая",
            "population": 1717,
            "type": "village",
            "poly": null,
            "longitude": 91.511802,
            "latitude": 53.0011599
        },
        "351": {
            "name": "Кедровый",
            "population": 303,
            "type": "village",
            "poly": [
                [
                    91.5199392,
                    56.2786284
                ],
                [
                    91.5257734,
                    56.2845483
                ],
                [
                    91.529636,
                    56.2838241
                ],
                [
                    91.5293281,
                    56.2827582
                ],
                [
                    91.5328609,
                    56.281859
                ],
                [
                    91.5338284,
                    56.2827582
                ],
                [
                    91.5328536,
                    56.2829372
                ],
                [
                    91.5354408,
                    56.2858094
                ],
                [
                    91.5386973,
                    56.2865399
                ],
                [
                    91.5409488,
                    56.2881378
                ],
                [
                    91.5451354,
                    56.2858141
                ],
                [
                    91.5438513,
                    56.2843658
                ],
                [
                    91.5486839,
                    56.2823855
                ],
                [
                    91.5451291,
                    56.2791428
                ],
                [
                    91.5383348,
                    56.2766444
                ],
                [
                    91.5344649,
                    56.2782679
                ],
                [
                    91.53253,
                    56.2771942
                ],
                [
                    91.5267116,
                    56.2784535
                ],
                [
                    91.5254289,
                    56.2775461
                ],
                [
                    91.5199392,
                    56.2786284
                ]
            ],
            "longitude": 91.535675,
            "latitude": 56.280407
        },
        "352": {
            "name": "Большие Сыры",
            "population": 657,
            "type": "village",
            "poly": [
                [
                    91.53756,
                    55.5189922
                ],
                [
                    91.5376318,
                    55.5191193
                ],
                [
                    91.5383413,
                    55.5192718
                ],
                [
                    91.5385568,
                    55.5194752
                ],
                [
                    91.538449,
                    55.5197192
                ],
                [
                    91.5382336,
                    55.5197955
                ],
                [
                    91.5379731,
                    55.5200496
                ],
                [
                    91.5379978,
                    55.520405
                ],
                [
                    91.5382941,
                    55.5205372
                ],
                [
                    91.5390574,
                    55.5205423
                ],
                [
                    91.5413112,
                    55.5212184
                ],
                [
                    91.5415267,
                    55.5211777
                ],
                [
                    91.5420925,
                    55.5210557
                ],
                [
                    91.5421374,
                    55.5211574
                ],
                [
                    91.5428018,
                    55.521564
                ],
                [
                    91.5433496,
                    55.5217979
                ],
                [
                    91.5437447,
                    55.5216454
                ],
                [
                    91.5438255,
                    55.5214014
                ],
                [
                    91.544041,
                    55.5208015
                ],
                [
                    91.5445259,
                    55.5205169
                ],
                [
                    91.5449839,
                    55.5201966
                ],
                [
                    91.5454239,
                    55.5201305
                ],
                [
                    91.5455227,
                    55.5199424
                ],
                [
                    91.5470761,
                    55.5207863
                ],
                [
                    91.5477496,
                    55.5204558
                ],
                [
                    91.5478753,
                    55.5211624
                ],
                [
                    91.5481177,
                    55.5212946
                ],
                [
                    91.5485937,
                    55.5213454
                ],
                [
                    91.5501202,
                    55.5206084
                ],
                [
                    91.5521585,
                    55.5197086
                ],
                [
                    91.5526041,
                    55.519671
                ],
                [
                    91.5536163,
                    55.5196789
                ],
                [
                    91.5541767,
                    55.519718
                ],
                [
                    91.5542238,
                    55.519795
                ],
                [
                    91.5533078,
                    55.5199272
                ],
                [
                    91.5534696,
                    55.5203135
                ],
                [
                    91.5544752,
                    55.520222
                ],
                [
                    91.5544207,
                    55.520051
                ],
                [
                    91.5543047,
                    55.5196882
                ],
                [
                    91.55461,
                    55.5196527
                ],
                [
                    91.5555259,
                    55.5192358
                ],
                [
                    91.5558761,
                    55.5188952
                ],
                [
                    91.5565225,
                    55.5184682
                ],
                [
                    91.5566462,
                    55.5178222
                ],
                [
                    91.5568163,
                    55.5175775
                ],
                [
                    91.5571795,
                    55.5174266
                ],
                [
                    91.5573404,
                    55.5170543
                ],
                [
                    91.5569036,
                    55.516794
                ],
                [
                    91.5562048,
                    55.5165442
                ],
                [
                    91.5561129,
                    55.5165442
                ],
                [
                    91.5564255,
                    55.5163463
                ],
                [
                    91.5570646,
                    55.5161667
                ],
                [
                    91.5579519,
                    55.5156279
                ],
                [
                    91.5581082,
                    55.5155602
                ],
                [
                    91.5584668,
                    55.5156461
                ],
                [
                    91.5587289,
                    55.5156643
                ],
                [
                    91.5587289,
                    55.5158596
                ],
                [
                    91.5594921,
                    55.5161563
                ],
                [
                    91.5597081,
                    55.5163854
                ],
                [
                    91.560485,
                    55.5166509
                ],
                [
                    91.5607656,
                    55.5166535
                ],
                [
                    91.5611242,
                    55.5169138
                ],
                [
                    91.5612805,
                    55.5169112
                ],
                [
                    91.5619856,
                    55.5168013
                ],
                [
                    91.5621035,
                    55.5168071
                ],
                [
                    91.562269,
                    55.5163073
                ],
                [
                    91.5623747,
                    55.5155082
                ],
                [
                    91.5621264,
                    55.5148652
                ],
                [
                    91.5608713,
                    55.5135298
                ],
                [
                    91.5606828,
                    55.5129128
                ],
                [
                    91.5608529,
                    55.5124416
                ],
                [
                    91.5614782,
                    55.5117856
                ],
                [
                    91.5614169,
                    55.5117614
                ],
                [
                    91.5593449,
                    55.5118715
                ],
                [
                    91.5584438,
                    55.5119652
                ],
                [
                    91.5578591,
                    55.5115221
                ],
                [
                    91.5563887,
                    55.5111281
                ],
                [
                    91.5562877,
                    55.5108738
                ],
                [
                    91.5563999,
                    55.5106577
                ],
                [
                    91.5562316,
                    55.5104798
                ],
                [
                    91.5556816,
                    55.5106196
                ],
                [
                    91.5549744,
                    55.5106387
                ],
                [
                    91.5547275,
                    55.5105433
                ],
                [
                    91.553953,
                    55.5102001
                ],
                [
                    91.5533806,
                    55.5104988
                ],
                [
                    91.5528642,
                    55.5103526
                ],
                [
                    91.5525724,
                    55.5106005
                ],
                [
                    91.5523591,
                    55.5106069
                ],
                [
                    91.5518877,
                    55.5109628
                ],
                [
                    91.5520561,
                    55.5110645
                ],
                [
                    91.5527071,
                    55.5113314
                ],
                [
                    91.5524937,
                    55.5112997
                ],
                [
                    91.5520673,
                    55.5114204
                ],
                [
                    91.552,
                    55.5117827
                ],
                [
                    91.5522132,
                    55.5121767
                ],
                [
                    91.5526061,
                    55.5122975
                ],
                [
                    91.5525724,
                    55.5123547
                ],
                [
                    91.5521908,
                    55.5123102
                ],
                [
                    91.5520112,
                    55.5123611
                ],
                [
                    91.5514612,
                    55.5121767
                ],
                [
                    91.5509224,
                    55.5120623
                ],
                [
                    91.5509898,
                    55.5118717
                ],
                [
                    91.5508214,
                    55.5118335
                ],
                [
                    91.5508102,
                    55.5117255
                ],
                [
                    91.5505632,
                    55.5116619
                ],
                [
                    91.5500469,
                    55.5117319
                ],
                [
                    91.5498224,
                    55.5120179
                ],
                [
                    91.5496653,
                    55.512234
                ],
                [
                    91.5495764,
                    55.5124401
                ],
                [
                    91.5494355,
                    55.5124788
                ],
                [
                    91.5491818,
                    55.5125882
                ],
                [
                    91.5489264,
                    55.512546
                ],
                [
                    91.5479662,
                    55.5125991
                ],
                [
                    91.5481612,
                    55.5123801
                ],
                [
                    91.5470835,
                    55.5120051
                ],
                [
                    91.5466796,
                    55.5120115
                ],
                [
                    91.5447826,
                    55.5125835
                ],
                [
                    91.543952,
                    55.5131682
                ],
                [
                    91.5434581,
                    55.5137402
                ],
                [
                    91.5403041,
                    55.5158438
                ],
                [
                    91.540248,
                    55.5165238
                ],
                [
                    91.5391944,
                    55.5170604
                ],
                [
                    91.5379461,
                    55.5172231
                ],
                [
                    91.5377307,
                    55.5179806
                ],
                [
                    91.5383322,
                    55.5181687
                ],
                [
                    91.5379731,
                    55.5184381
                ],
                [
                    91.5382336,
                    55.5186364
                ],
                [
                    91.5379193,
                    55.5190075
                ],
                [
                    91.53756,
                    55.5189922
                ]
            ],
            "longitude": 91.549423,
            "latitude": 55.5158
        },
        "353": {
            "name": "Лебяжье",
            "population": 1243,
            "type": "village",
            "poly": null,
            "longitude": 91.5766543,
            "latitude": 54.1929805
        },
        "354": {
            "name": "Шунеры",
            "population": 641,
            "type": "village",
            "poly": null,
            "longitude": 91.585464,
            "latitude": 53.127377
        },
        "355": {
            "name": "Быстрая",
            "population": 1033,
            "type": "village",
            "poly": null,
            "longitude": 91.5879932,
            "latitude": 53.7282037
        },
        "356": {
            "name": "Селиваниха",
            "population": 2014,
            "type": "village",
            "poly": null,
            "longitude": 91.607178,
            "latitude": 53.689816
        },
        "357": {
            "name": "Зелёный Бор",
            "population": 2813,
            "type": "village",
            "poly": null,
            "longitude": 91.615334,
            "latitude": 53.618069
        },
        "358": {
            "name": "Косачи",
            "population": 442,
            "type": "village",
            "poly": [
                [
                    91.6306766,
                    56.1354485
                ],
                [
                    91.6311996,
                    56.1366111
                ],
                [
                    91.6313483,
                    56.1367047
                ],
                [
                    91.6319771,
                    56.1367047
                ],
                [
                    91.6322315,
                    56.1367849
                ],
                [
                    91.6322987,
                    56.1369106
                ],
                [
                    91.6321019,
                    56.1371192
                ],
                [
                    91.6337288,
                    56.1376112
                ],
                [
                    91.6351254,
                    56.1374133
                ],
                [
                    91.6352742,
                    56.1376941
                ],
                [
                    91.6352598,
                    56.138015
                ],
                [
                    91.6348518,
                    56.1380391
                ],
                [
                    91.6343815,
                    56.1380204
                ],
                [
                    91.6341367,
                    56.1381594
                ],
                [
                    91.6339976,
                    56.1384723
                ],
                [
                    91.6342183,
                    56.1390044
                ],
                [
                    91.6343959,
                    56.1391568
                ],
                [
                    91.6349046,
                    56.1394483
                ],
                [
                    91.6352117,
                    56.1398735
                ],
                [
                    91.6354085,
                    56.1402799
                ],
                [
                    91.6359125,
                    56.1403173
                ],
                [
                    91.6364644,
                    56.1404885
                ],
                [
                    91.6370211,
                    56.1404537
                ],
                [
                    91.6371075,
                    56.140804
                ],
                [
                    91.6372658,
                    56.1408762
                ],
                [
                    91.6391711,
                    56.1406703
                ],
                [
                    91.6398958,
                    56.1411489
                ],
                [
                    91.6409612,
                    56.1410954
                ],
                [
                    91.6415851,
                    56.1408575
                ],
                [
                    91.6411196,
                    56.1405874
                ],
                [
                    91.6408796,
                    56.1404965
                ],
                [
                    91.6403277,
                    56.1403147
                ],
                [
                    91.6396942,
                    56.1401623
                ],
                [
                    91.639555,
                    56.1400954
                ],
                [
                    91.6397038,
                    56.1400339
                ],
                [
                    91.6399918,
                    56.139959
                ],
                [
                    91.6400878,
                    56.1397745
                ],
                [
                    91.6404813,
                    56.1394376
                ],
                [
                    91.6410908,
                    56.1392691
                ],
                [
                    91.6415755,
                    56.1392852
                ],
                [
                    91.641921,
                    56.1391007
                ],
                [
                    91.6418779,
                    56.1387905
                ],
                [
                    91.6421562,
                    56.1384763
                ],
                [
                    91.643368,
                    56.1386133
                ],
                [
                    91.6435599,
                    56.1379816
                ],
                [
                    91.6438059,
                    56.137634
                ],
                [
                    91.6430381,
                    56.1376039
                ],
                [
                    91.6427441,
                    56.1375437
                ],
                [
                    91.6410524,
                    56.1369721
                ],
                [
                    91.6404765,
                    56.1367515
                ],
                [
                    91.6400866,
                    56.1366746
                ],
                [
                    91.6396846,
                    56.1367147
                ],
                [
                    91.6394807,
                    56.1366178
                ],
                [
                    91.6397266,
                    56.1365242
                ],
                [
                    91.6398526,
                    56.1364139
                ],
                [
                    91.6400926,
                    56.1363537
                ],
                [
                    91.6406865,
                    56.1363771
                ],
                [
                    91.6409324,
                    56.1359659
                ],
                [
                    91.6413943,
                    56.1355916
                ],
                [
                    91.6420722,
                    56.135411
                ],
                [
                    91.6420902,
                    56.1352606
                ],
                [
                    91.6417663,
                    56.1351403
                ],
                [
                    91.640861,
                    56.1352122
                ],
                [
                    91.6400174,
                    56.1352017
                ],
                [
                    91.6399893,
                    56.1353166
                ],
                [
                    91.6382926,
                    56.1353741
                ],
                [
                    91.6382458,
                    56.1348727
                ],
                [
                    91.6357525,
                    56.1351756
                ],
                [
                    91.6355931,
                    56.1348361
                ],
                [
                    91.6350307,
                    56.1347421
                ],
                [
                    91.634637,
                    56.1347839
                ],
                [
                    91.6340746,
                    56.1347891
                ],
                [
                    91.6336435,
                    56.1349823
                ],
                [
                    91.6318951,
                    56.1351939
                ],
                [
                    91.6306766,
                    56.1354485
                ]
            ],
            "longitude": 91.63707,
            "latitude": 56.136925
        },
        "359": {
            "name": "Топольки",
            "population": 486,
            "type": "village",
            "poly": null,
            "longitude": 91.6449846,
            "latitude": 53.6647118
        },
        "360": {
            "name": "Восточное",
            "population": 826,
            "type": "village",
            "poly": null,
            "longitude": 91.6588259,
            "latitude": 54.0922647
        },
        "361": {
            "name": "Малая Кеть",
            "population": 219,
            "type": "village",
            "poly": null,
            "longitude": 91.659691,
            "latitude": 57.328171
        },
        "362": {
            "name": "Опытное Поле",
            "population": 394,
            "type": "village",
            "poly": null,
            "longitude": 91.6670746,
            "latitude": 53.6758344
        },
        "363": {
            "name": "Белоярск",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 91.6770395,
            "latitude": 54.3886449
        },
        "364": {
            "name": "Николо-Петровка",
            "population": 507,
            "type": "village",
            "poly": null,
            "longitude": 91.6824534,
            "latitude": 53.9336025
        },
        "365": {
            "name": "Шишмарево",
            "population": 340,
            "type": "village",
            "poly": null,
            "longitude": 91.688057,
            "latitude": 59.083046
        },
        "366": {
            "name": "Красная",
            "population": 214,
            "type": "village",
            "poly": [
                [
                    91.6698207,
                    55.3129534
                ],
                [
                    91.670102,
                    55.3132797
                ],
                [
                    91.6700669,
                    55.3133578
                ],
                [
                    91.6700787,
                    55.3136493
                ],
                [
                    91.6703964,
                    55.313962
                ],
                [
                    91.6710833,
                    55.3143774
                ],
                [
                    91.6714439,
                    55.3145093
                ],
                [
                    91.6720622,
                    55.3144849
                ],
                [
                    91.6726835,
                    55.3142599
                ],
                [
                    91.6732193,
                    55.3145531
                ],
                [
                    91.6737483,
                    55.3147368
                ],
                [
                    91.6741399,
                    55.3147486
                ],
                [
                    91.6750947,
                    55.3143889
                ],
                [
                    91.6747306,
                    55.3137361
                ],
                [
                    91.6748268,
                    55.3136032
                ],
                [
                    91.6760357,
                    55.3137009
                ],
                [
                    91.6757679,
                    55.3130363
                ],
                [
                    91.6759534,
                    55.312747
                ],
                [
                    91.6762969,
                    55.3124616
                ],
                [
                    91.6776433,
                    55.311887
                ],
                [
                    91.6780622,
                    55.3117736
                ],
                [
                    91.678866,
                    55.3117267
                ],
                [
                    91.6795673,
                    55.3117843
                ],
                [
                    91.6801993,
                    55.3116748
                ],
                [
                    91.6803092,
                    55.3116248
                ],
                [
                    91.6803862,
                    55.3114653
                ],
                [
                    91.680562,
                    55.3113245
                ],
                [
                    91.6809302,
                    55.3112307
                ],
                [
                    91.6816391,
                    55.3112276
                ],
                [
                    91.6817271,
                    55.3112526
                ],
                [
                    91.6824799,
                    55.3112151
                ],
                [
                    91.6828866,
                    55.3112338
                ],
                [
                    91.6831504,
                    55.3112151
                ],
                [
                    91.6831944,
                    55.31109
                ],
                [
                    91.6832603,
                    55.3109586
                ],
                [
                    91.6834252,
                    55.3109086
                ],
                [
                    91.6836065,
                    55.3109336
                ],
                [
                    91.6837879,
                    55.3109148
                ],
                [
                    91.6839143,
                    55.3108179
                ],
                [
                    91.6839308,
                    55.3107084
                ],
                [
                    91.6840077,
                    55.3106333
                ],
                [
                    91.6843539,
                    55.310624
                ],
                [
                    91.6850793,
                    55.3103737
                ],
                [
                    91.6853431,
                    55.3103644
                ],
                [
                    91.6858157,
                    55.3103737
                ],
                [
                    91.6861124,
                    55.3104363
                ],
                [
                    91.6863653,
                    55.310502
                ],
                [
                    91.6865631,
                    55.3104863
                ],
                [
                    91.6866565,
                    55.3102518
                ],
                [
                    91.6868874,
                    55.3101267
                ],
                [
                    91.6872719,
                    55.3100328
                ],
                [
                    91.6875963,
                    55.3100578
                ],
                [
                    91.6881513,
                    55.3101923
                ],
                [
                    91.689003,
                    55.3101392
                ],
                [
                    91.6893494,
                    55.3100015
                ],
                [
                    91.6894922,
                    55.3098796
                ],
                [
                    91.6895142,
                    55.3096293
                ],
                [
                    91.6897285,
                    55.3091477
                ],
                [
                    91.6899978,
                    55.3088443
                ],
                [
                    91.690443,
                    55.3086535
                ],
                [
                    91.6912233,
                    55.3095637
                ],
                [
                    91.6923884,
                    55.3092728
                ],
                [
                    91.6926906,
                    55.3090726
                ],
                [
                    91.693438,
                    55.3087974
                ],
                [
                    91.6927071,
                    55.3079591
                ],
                [
                    91.6929105,
                    55.3079247
                ],
                [
                    91.6933171,
                    55.3078058
                ],
                [
                    91.6938502,
                    55.3077839
                ],
                [
                    91.6945536,
                    55.3077777
                ],
                [
                    91.6950757,
                    55.307859
                ],
                [
                    91.6957297,
                    55.3080467
                ],
                [
                    91.6960869,
                    55.3082656
                ],
                [
                    91.6967683,
                    55.3085284
                ],
                [
                    91.6976696,
                    55.3087848
                ],
                [
                    91.6985818,
                    55.3088568
                ],
                [
                    91.6998018,
                    55.3088349
                ],
                [
                    91.7008075,
                    55.308666
                ],
                [
                    91.7011702,
                    55.308494
                ],
                [
                    91.7016648,
                    55.3083688
                ],
                [
                    91.7018572,
                    55.3082093
                ],
                [
                    91.7019176,
                    55.3080436
                ],
                [
                    91.702709,
                    55.3077933
                ],
                [
                    91.7032864,
                    55.3074547
                ],
                [
                    91.7031436,
                    55.3070763
                ],
                [
                    91.7028963,
                    55.3067259
                ],
                [
                    91.7024126,
                    55.3062348
                ],
                [
                    91.7022533,
                    55.305922
                ],
                [
                    91.7021159,
                    55.3058438
                ],
                [
                    91.7014839,
                    55.3058376
                ],
                [
                    91.7011157,
                    55.3057656
                ],
                [
                    91.7010388,
                    55.3056218
                ],
                [
                    91.700764,
                    55.305481
                ],
                [
                    91.7006046,
                    55.3054466
                ],
                [
                    91.7003682,
                    55.305481
                ],
                [
                    91.7001894,
                    55.3055601
                ],
                [
                    91.6996014,
                    55.3053161
                ],
                [
                    91.6993761,
                    55.3051972
                ],
                [
                    91.6989804,
                    55.3052098
                ],
                [
                    91.6987386,
                    55.3051879
                ],
                [
                    91.6981506,
                    55.3048625
                ],
                [
                    91.6981451,
                    55.3047374
                ],
                [
                    91.698233,
                    55.304556
                ],
                [
                    91.6981451,
                    55.3044121
                ],
                [
                    91.6978703,
                    55.3042901
                ],
                [
                    91.6977824,
                    55.3041587
                ],
                [
                    91.6962326,
                    55.3032766
                ],
                [
                    91.6963151,
                    55.3031765
                ],
                [
                    91.696458,
                    55.3029919
                ],
                [
                    91.6964909,
                    55.3027979
                ],
                [
                    91.6963875,
                    55.3026863
                ],
                [
                    91.6965304,
                    55.3026237
                ],
                [
                    91.6965359,
                    55.3024736
                ],
                [
                    91.696426,
                    55.3023766
                ],
                [
                    91.6962117,
                    55.3022953
                ],
                [
                    91.6961347,
                    55.3022171
                ],
                [
                    91.6959369,
                    55.3021795
                ],
                [
                    91.6960688,
                    55.3019574
                ],
                [
                    91.6959149,
                    55.3017916
                ],
                [
                    91.6953489,
                    55.3015163
                ],
                [
                    91.6945905,
                    55.3016102
                ],
                [
                    91.6943926,
                    55.3015132
                ],
                [
                    91.6935903,
                    55.301532
                ],
                [
                    91.6933155,
                    55.301582
                ],
                [
                    91.6930407,
                    55.301582
                ],
                [
                    91.6928704,
                    55.3016821
                ],
                [
                    91.6904963,
                    55.300631
                ],
                [
                    91.6899193,
                    55.300997
                ],
                [
                    91.689106,
                    55.3016258
                ],
                [
                    91.6869682,
                    55.3009344
                ],
                [
                    91.6863747,
                    55.3007874
                ],
                [
                    91.6857592,
                    55.3012879
                ],
                [
                    91.6853195,
                    55.3017259
                ],
                [
                    91.6878098,
                    55.3025895
                ],
                [
                    91.6894498,
                    55.3030539
                ],
                [
                    91.6905843,
                    55.303256
                ],
                [
                    91.689172,
                    55.3040975
                ],
                [
                    91.6884356,
                    55.3042915
                ],
                [
                    91.6884301,
                    55.3045292
                ],
                [
                    91.6888807,
                    55.3048076
                ],
                [
                    91.6892929,
                    55.3048889
                ],
                [
                    91.6888093,
                    55.3049953
                ],
                [
                    91.6749669,
                    55.3096166
                ],
                [
                    91.6750004,
                    55.3096528
                ],
                [
                    91.6751533,
                    55.3097367
                ],
                [
                    91.6761691,
                    55.3100731
                ],
                [
                    91.6759089,
                    55.3101371
                ],
                [
                    91.6757787,
                    55.3102172
                ],
                [
                    91.6756275,
                    55.3102132
                ],
                [
                    91.6754481,
                    55.3102912
                ],
                [
                    91.6753567,
                    55.3104234
                ],
                [
                    91.6753778,
                    55.3105395
                ],
                [
                    91.6735805,
                    55.3108237
                ],
                [
                    91.6734503,
                    55.3109318
                ],
                [
                    91.6731655,
                    55.3110179
                ],
                [
                    91.6728912,
                    55.311194
                ],
                [
                    91.6729369,
                    55.3112781
                ],
                [
                    91.67306,
                    55.3113141
                ],
                [
                    91.6729721,
                    55.3114062
                ],
                [
                    91.6726555,
                    55.3114262
                ],
                [
                    91.6719591,
                    55.3117184
                ],
                [
                    91.6708512,
                    55.3123289
                ],
                [
                    91.6708687,
                    55.3125011
                ],
                [
                    91.6710376,
                    55.3127633
                ],
                [
                    91.6708653,
                    55.3126692
                ],
                [
                    91.6707246,
                    55.3126392
                ],
                [
                    91.6698207,
                    55.3129534
                ]
            ],
            "longitude": 91.690887,
            "latitude": 55.306755
        },
        "367": {
            "name": "Кортуз",
            "population": 962,
            "type": "village",
            "poly": null,
            "longitude": 91.7003789,
            "latitude": 54.4927748
        },
        "368": {
            "name": "Чайда",
            "population": 158,
            "type": "village",
            "poly": null,
            "longitude": 91.7085602,
            "latitude": 57.4313639
        },
        "369": {
            "name": "Жуковка",
            "population": 675,
            "type": "village",
            "poly": [
                [
                    [
                        91.6857205,
                        56.0850976
                    ],
                    [
                        91.6858935,
                        56.0874318
                    ],
                    [
                        91.6898554,
                        56.0900462
                    ],
                    [
                        91.6900808,
                        56.0887398
                    ],
                    [
                        91.692039,
                        56.0885098
                    ],
                    [
                        91.6928291,
                        56.0892956
                    ],
                    [
                        91.6922107,
                        56.0900239
                    ],
                    [
                        91.6941218,
                        56.0914193
                    ],
                    [
                        91.6946156,
                        56.0912888
                    ],
                    [
                        91.6957149,
                        56.091883
                    ],
                    [
                        91.695337,
                        56.0927262
                    ],
                    [
                        91.6947515,
                        56.092845
                    ],
                    [
                        91.6948835,
                        56.0939336
                    ],
                    [
                        91.6957149,
                        56.0939336
                    ],
                    [
                        91.6961272,
                        56.0949301
                    ],
                    [
                        91.695159,
                        56.0953487
                    ],
                    [
                        91.6957666,
                        56.0966818
                    ],
                    [
                        91.6967385,
                        56.0965968
                    ],
                    [
                        91.6981541,
                        56.0973255
                    ],
                    [
                        91.6975013,
                        56.0982836
                    ],
                    [
                        91.6969149,
                        56.0988756
                    ],
                    [
                        91.6957484,
                        56.0993692
                    ],
                    [
                        91.6960701,
                        56.1005358
                    ],
                    [
                        91.6968746,
                        56.1004797
                    ],
                    [
                        91.6970154,
                        56.1006031
                    ],
                    [
                        91.6974378,
                        56.1005694
                    ],
                    [
                        91.697478,
                        56.1004124
                    ],
                    [
                        91.6984836,
                        56.0999637
                    ],
                    [
                        91.6998713,
                        56.0999973
                    ],
                    [
                        91.7009373,
                        56.0998179
                    ],
                    [
                        91.7013596,
                        56.0996047
                    ],
                    [
                        91.7018423,
                        56.0998066
                    ],
                    [
                        91.7022848,
                        56.099515
                    ],
                    [
                        91.7016613,
                        56.0992121
                    ],
                    [
                        91.7011786,
                        56.0992121
                    ],
                    [
                        91.7009171,
                        56.0988083
                    ],
                    [
                        91.7025462,
                        56.0983371
                    ],
                    [
                        91.703934,
                        56.0979445
                    ],
                    [
                        91.7061463,
                        56.0982249
                    ],
                    [
                        91.7074737,
                        56.0987971
                    ],
                    [
                        91.7088614,
                        56.0987746
                    ],
                    [
                        91.7109933,
                        56.0980455
                    ],
                    [
                        91.7120793,
                        56.0977538
                    ],
                    [
                        91.7131654,
                        56.0978548
                    ],
                    [
                        91.7141509,
                        56.0983932
                    ],
                    [
                        91.7147542,
                        56.0989429
                    ],
                    [
                        91.7158045,
                        56.099257
                    ],
                    [
                        91.7182501,
                        56.0992031
                    ],
                    [
                        91.7180249,
                        56.0981262
                    ],
                    [
                        91.7183949,
                        56.0979737
                    ],
                    [
                        91.7202131,
                        56.0977852
                    ],
                    [
                        91.7217255,
                        56.0974442
                    ],
                    [
                        91.722353,
                        56.0966185
                    ],
                    [
                        91.720921,
                        56.0947697
                    ],
                    [
                        91.7206958,
                        56.0943837
                    ],
                    [
                        91.7219668,
                        56.0945273
                    ],
                    [
                        91.7227391,
                        56.0936208
                    ],
                    [
                        91.7222565,
                        56.0935311
                    ],
                    [
                        91.7233666,
                        56.0922476
                    ],
                    [
                        91.7220956,
                        56.0920501
                    ],
                    [
                        91.7238653,
                        56.0901293
                    ],
                    [
                        91.7256514,
                        56.0901562
                    ],
                    [
                        91.7270512,
                        56.089842
                    ],
                    [
                        91.7270512,
                        56.0896804
                    ],
                    [
                        91.7266489,
                        56.0889264
                    ],
                    [
                        91.7277108,
                        56.0885674
                    ],
                    [
                        91.7282257,
                        56.088693
                    ],
                    [
                        91.7290462,
                        56.0886482
                    ],
                    [
                        91.7285797,
                        56.0871849
                    ],
                    [
                        91.7279039,
                        56.0859371
                    ],
                    [
                        91.7267455,
                        56.0853626
                    ],
                    [
                        91.7255548,
                        56.0853357
                    ],
                    [
                        91.7234471,
                        56.0842404
                    ],
                    [
                        91.7225943,
                        56.0834953
                    ],
                    [
                        91.7226909,
                        56.0828399
                    ],
                    [
                        91.7215163,
                        56.0817715
                    ],
                    [
                        91.7204222,
                        56.0816458
                    ],
                    [
                        91.7194813,
                        56.0838794
                    ],
                    [
                        91.7170302,
                        56.0862114
                    ],
                    [
                        91.7107452,
                        56.0899809
                    ],
                    [
                        91.7096767,
                        56.0909101
                    ],
                    [
                        91.7058743,
                        56.0897705
                    ],
                    [
                        91.7058743,
                        56.0894374
                    ],
                    [
                        91.7070684,
                        56.0884907
                    ],
                    [
                        91.7063142,
                        56.0878771
                    ],
                    [
                        91.7047116,
                        56.0874738
                    ],
                    [
                        91.7050887,
                        56.0863517
                    ],
                    [
                        91.7059371,
                        56.0857205
                    ],
                    [
                        91.7046173,
                        56.0851243
                    ],
                    [
                        91.7030775,
                        56.0849841
                    ],
                    [
                        91.7027004,
                        56.0852821
                    ],
                    [
                        91.7005949,
                        56.0851945
                    ],
                    [
                        91.7000921,
                        56.085475
                    ],
                    [
                        91.6951898,
                        56.0832306
                    ],
                    [
                        91.6927386,
                        56.0834586
                    ],
                    [
                        91.6922044,
                        56.0794429
                    ],
                    [
                        91.6905389,
                        56.0796533
                    ],
                    [
                        91.6896275,
                        56.0765493
                    ],
                    [
                        91.686718,
                        56.0784315
                    ],
                    [
                        91.6870576,
                        56.0789252
                    ],
                    [
                        91.6879508,
                        56.0805739
                    ],
                    [
                        91.6877103,
                        56.0820692
                    ],
                    [
                        91.6869889,
                        56.0838328
                    ],
                    [
                        91.6857205,
                        56.0850976
                    ]
                ],
                [
                    [
                        91.7091912,
                        56.1047793
                    ],
                    [
                        91.7099228,
                        56.1051142
                    ],
                    [
                        91.7107824,
                        56.1045668
                    ],
                    [
                        91.7115294,
                        56.1047555
                    ],
                    [
                        91.7119348,
                        56.1049493
                    ],
                    [
                        91.7123524,
                        56.1050615
                    ],
                    [
                        91.7124378,
                        56.1051125
                    ],
                    [
                        91.7122671,
                        56.1053318
                    ],
                    [
                        91.7120994,
                        56.1056293
                    ],
                    [
                        91.7128433,
                        56.1057806
                    ],
                    [
                        91.7130475,
                        56.105427
                    ],
                    [
                        91.7135474,
                        56.1056157
                    ],
                    [
                        91.7137761,
                        56.1058214
                    ],
                    [
                        91.7139834,
                        56.1059676
                    ],
                    [
                        91.7139559,
                        56.1067258
                    ],
                    [
                        91.714023,
                        56.1070199
                    ],
                    [
                        91.7141571,
                        56.1070454
                    ],
                    [
                        91.7144925,
                        56.1070233
                    ],
                    [
                        91.714965,
                        56.1069349
                    ],
                    [
                        91.7151266,
                        56.106872
                    ],
                    [
                        91.7150991,
                        56.1066867
                    ],
                    [
                        91.7156844,
                        56.1067343
                    ],
                    [
                        91.7159039,
                        56.106753
                    ],
                    [
                        91.7161051,
                        56.1068652
                    ],
                    [
                        91.7165746,
                        56.1072562
                    ],
                    [
                        91.7180257,
                        56.1072885
                    ],
                    [
                        91.7181332,
                        56.1066663
                    ],
                    [
                        91.7188122,
                        56.1067759
                    ],
                    [
                        91.7195536,
                        56.1068978
                    ],
                    [
                        91.7198813,
                        56.1069126
                    ],
                    [
                        91.720874,
                        56.1069021
                    ],
                    [
                        91.7211113,
                        56.106836
                    ],
                    [
                        91.7211753,
                        56.1067681
                    ],
                    [
                        91.7215904,
                        56.1068456
                    ],
                    [
                        91.7218807,
                        56.1068604
                    ],
                    [
                        91.722029,
                        56.1068412
                    ],
                    [
                        91.7221227,
                        56.1067681
                    ],
                    [
                        91.7222084,
                        56.1066166
                    ],
                    [
                        91.7222881,
                        56.1064077
                    ],
                    [
                        91.7224394,
                        56.1060335
                    ],
                    [
                        91.7225816,
                        56.1058707
                    ],
                    [
                        91.7231278,
                        56.1054268
                    ],
                    [
                        91.723184,
                        56.1052928
                    ],
                    [
                        91.7232901,
                        56.1050638
                    ],
                    [
                        91.7234213,
                        56.1049542
                    ],
                    [
                        91.7234978,
                        56.1048201
                    ],
                    [
                        91.723788,
                        56.1048584
                    ],
                    [
                        91.7243141,
                        56.1048671
                    ],
                    [
                        91.7247527,
                        56.1047252
                    ],
                    [
                        91.7250305,
                        56.1046069
                    ],
                    [
                        91.7248357,
                        56.1043606
                    ],
                    [
                        91.7246589,
                        56.1042256
                    ],
                    [
                        91.7240092,
                        56.1041876
                    ],
                    [
                        91.7235429,
                        56.1040418
                    ],
                    [
                        91.7230922,
                        56.103785
                    ],
                    [
                        91.7223137,
                        56.1034172
                    ],
                    [
                        91.7213733,
                        56.1031125
                    ],
                    [
                        91.7212348,
                        56.1029809
                    ],
                    [
                        91.7198617,
                        56.1043654
                    ],
                    [
                        91.7186899,
                        56.1043814
                    ],
                    [
                        91.7186851,
                        56.1041556
                    ],
                    [
                        91.7188709,
                        56.1037943
                    ],
                    [
                        91.7185756,
                        56.1034675
                    ],
                    [
                        91.7179516,
                        56.1032603
                    ],
                    [
                        91.7175039,
                        56.103255
                    ],
                    [
                        91.7171228,
                        56.1034171
                    ],
                    [
                        91.7162845,
                        56.1032736
                    ],
                    [
                        91.7164369,
                        56.1028141
                    ],
                    [
                        91.7167036,
                        56.1028087
                    ],
                    [
                        91.7171466,
                        56.1025803
                    ],
                    [
                        91.7170847,
                        56.1021977
                    ],
                    [
                        91.7163321,
                        56.1020198
                    ],
                    [
                        91.7163178,
                        56.1016771
                    ],
                    [
                        91.7158081,
                        56.1012626
                    ],
                    [
                        91.7158272,
                        56.1010182
                    ],
                    [
                        91.7157319,
                        56.1006596
                    ],
                    [
                        91.7158272,
                        56.0999317
                    ],
                    [
                        91.7153509,
                        56.0997484
                    ],
                    [
                        91.7150413,
                        56.099411
                    ],
                    [
                        91.7149861,
                        56.099444
                    ],
                    [
                        91.7144279,
                        56.1005607
                    ],
                    [
                        91.7143907,
                        56.1010588
                    ],
                    [
                        91.7140112,
                        56.1017146
                    ],
                    [
                        91.7133637,
                        56.1020757
                    ],
                    [
                        91.712158,
                        56.1028768
                    ],
                    [
                        91.7120463,
                        56.1031217
                    ],
                    [
                        91.710973,
                        56.1036332
                    ],
                    [
                        91.7108956,
                        56.1037394
                    ],
                    [
                        91.7101514,
                        56.1041197
                    ],
                    [
                        91.7091912,
                        56.1047793
                    ]
                ]
            ],
            "longitude": 91.71244,
            "latitude": 56.095398
        },
        "370": {
            "name": "Салба",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 91.7167267,
            "latitude": 54.6812042
        },
        "371": {
            "name": "Заречный",
            "population": 519,
            "type": "village",
            "poly": [
                [
                    91.7204491,
                    56.042467
                ],
                [
                    91.7207788,
                    56.042597
                ],
                [
                    91.7213316,
                    56.0426458
                ],
                [
                    91.7220491,
                    56.0430683
                ],
                [
                    91.7217,
                    56.043377
                ],
                [
                    91.7220976,
                    56.0435937
                ],
                [
                    91.7215643,
                    56.0440324
                ],
                [
                    91.7242516,
                    56.044585
                ],
                [
                    91.7249098,
                    56.0447203
                ],
                [
                    91.7259571,
                    56.0437453
                ],
                [
                    91.7268881,
                    56.04218
                ],
                [
                    91.7264252,
                    56.0419815
                ],
                [
                    91.7260839,
                    56.0418862
                ],
                [
                    91.7259287,
                    56.0419729
                ],
                [
                    91.7255098,
                    56.0418212
                ],
                [
                    91.7256417,
                    56.0416869
                ],
                [
                    91.7250862,
                    56.0414794
                ],
                [
                    91.7246294,
                    56.0418621
                ],
                [
                    91.7237209,
                    56.0415293
                ],
                [
                    91.7242074,
                    56.041105
                ],
                [
                    91.7229313,
                    56.0406169
                ],
                [
                    91.7228867,
                    56.0406501
                ],
                [
                    91.722311,
                    56.0404249
                ],
                [
                    91.7207691,
                    56.0419633
                ],
                [
                    91.7208273,
                    56.04205
                ],
                [
                    91.7204491,
                    56.042467
                ]
            ],
            "longitude": 91.723724,
            "latitude": 56.042652
        },
        "372": {
            "name": "Усть-Пит",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 91.759964,
            "latitude": 58.984028
        },
        "373": {
            "name": "Суходол",
            "population": 388,
            "type": "village",
            "poly": null,
            "longitude": 91.7744987,
            "latitude": 53.7834297
        },
        "374": {
            "name": "Малая Минуса",
            "population": 1651,
            "type": "village",
            "poly": null,
            "longitude": 91.779358,
            "latitude": 53.725357
        },
        "375": {
            "name": "Лугавское",
            "population": 1490,
            "type": "village",
            "poly": null,
            "longitude": 91.7924454,
            "latitude": 53.5233563
        },
        "376": {
            "name": "Новотроицкое",
            "population": 781,
            "type": "village",
            "poly": null,
            "longitude": 91.7964129,
            "latitude": 53.8713374
        },
        "377": {
            "name": "Озеро Тагарское",
            "population": 357,
            "type": "village",
            "poly": null,
            "longitude": 91.797536,
            "latitude": 53.5985363
        },
        "378": {
            "name": "Каптырево",
            "population": 1812,
            "type": "village",
            "poly": null,
            "longitude": 91.8025341,
            "latitude": 53.1907232
        },
        "379": {
            "name": "Городок",
            "population": 2127,
            "type": "village",
            "poly": null,
            "longitude": 91.8025517,
            "latitude": 53.9270389
        },
        "380": {
            "name": "Ильичёво",
            "population": 2151,
            "type": "village",
            "poly": null,
            "longitude": 91.8414527,
            "latitude": 53.2752148
        },
        "381": {
            "name": "Огур",
            "population": 682,
            "type": "village",
            "poly": null,
            "longitude": 91.859886,
            "latitude": 55.355312
        },
        "382": {
            "name": "Саянск",
            "population": 731,
            "type": "village",
            "poly": null,
            "longitude": 91.8791707,
            "latitude": 54.1520135
        },
        "383": {
            "name": "Добромысловский",
            "population": 443,
            "type": "village",
            "poly": null,
            "longitude": 91.8792535,
            "latitude": 54.4943277
        },
        "384": {
            "name": "Кетский",
            "population": 942,
            "type": "village",
            "poly": null,
            "longitude": 91.88115,
            "latitude": 57.5817002
        },
        "385": {
            "name": "Комаровка",
            "population": 241,
            "type": "village",
            "poly": null,
            "longitude": 91.8820853,
            "latitude": 57.5639176
        },
        "386": {
            "name": "Алтан",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 91.8880364,
            "latitude": 53.2420406
        },
        "387": {
            "name": "Подгорное",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 91.8901848,
            "latitude": 58.1137379
        },
        "388": {
            "name": "Чалбышево",
            "population": 348,
            "type": "village",
            "poly": null,
            "longitude": 91.8916255,
            "latitude": 58.0527211
        },
        "389": {
            "name": "Приморск",
            "population": 1696,
            "type": "village",
            "poly": [
                [
                    91.864505,
                    55.1978175
                ],
                [
                    91.8650673,
                    55.1980927
                ],
                [
                    91.8689809,
                    55.199514
                ],
                [
                    91.8665134,
                    55.2035159
                ],
                [
                    91.8721141,
                    55.2047734
                ],
                [
                    91.8727913,
                    55.2051271
                ],
                [
                    91.8735258,
                    55.205317
                ],
                [
                    91.8741685,
                    55.2054021
                ],
                [
                    91.8748112,
                    55.2054152
                ],
                [
                    91.8763606,
                    55.2048258
                ],
                [
                    91.8775656,
                    55.2047865
                ],
                [
                    91.8783805,
                    55.2050092
                ],
                [
                    91.878874,
                    55.2052581
                ],
                [
                    91.8793286,
                    55.2053498
                ],
                [
                    91.8792346,
                    55.2056381
                ],
                [
                    91.8791993,
                    55.2064697
                ],
                [
                    91.8797693,
                    55.2066206
                ],
                [
                    91.8807271,
                    55.2069157
                ],
                [
                    91.8801984,
                    55.2079336
                ],
                [
                    91.8825655,
                    55.2082856
                ],
                [
                    91.8822498,
                    55.2089896
                ],
                [
                    91.8817047,
                    55.2097099
                ],
                [
                    91.8834805,
                    55.2096851
                ],
                [
                    91.885124,
                    55.2097428
                ],
                [
                    91.8866114,
                    55.2097532
                ],
                [
                    91.8873918,
                    55.2099785
                ],
                [
                    91.8888425,
                    55.2102352
                ],
                [
                    91.8895862,
                    55.210539
                ],
                [
                    91.8900832,
                    55.2107034
                ],
                [
                    91.8903116,
                    55.2106648
                ],
                [
                    91.8894393,
                    55.2090355
                ],
                [
                    91.8895679,
                    55.2090198
                ],
                [
                    91.8899627,
                    55.208936
                ],
                [
                    91.8900912,
                    55.2087474
                ],
                [
                    91.891193,
                    55.2086374
                ],
                [
                    91.8978587,
                    55.2085378
                ],
                [
                    91.8972711,
                    55.2094442
                ],
                [
                    91.8972987,
                    55.209879
                ],
                [
                    91.8975282,
                    55.2103085
                ],
                [
                    91.8991809,
                    55.2109791
                ],
                [
                    91.900301,
                    55.2114244
                ],
                [
                    91.9006132,
                    55.2113982
                ],
                [
                    91.9016415,
                    55.2114401
                ],
                [
                    91.9022567,
                    55.2116287
                ],
                [
                    91.9025872,
                    55.2114558
                ],
                [
                    91.9039185,
                    55.2111467
                ],
                [
                    91.9070127,
                    55.2111415
                ],
                [
                    91.9079584,
                    55.2111677
                ],
                [
                    91.908748,
                    55.2110577
                ],
                [
                    91.91052,
                    55.2104867
                ],
                [
                    91.9106118,
                    55.2083388
                ],
                [
                    91.9089867,
                    55.2082811
                ],
                [
                    91.908748,
                    55.2073748
                ],
                [
                    91.9084634,
                    55.2069557
                ],
                [
                    91.9079308,
                    55.2066937
                ],
                [
                    91.9088214,
                    55.2060912
                ],
                [
                    91.9088949,
                    55.2059864
                ],
                [
                    91.9085276,
                    55.2056092
                ],
                [
                    91.9081328,
                    55.2048967
                ],
                [
                    91.9081604,
                    55.2046085
                ],
                [
                    91.9084064,
                    55.204318
                ],
                [
                    91.9089178,
                    55.204275
                ],
                [
                    91.909324,
                    55.2043437
                ],
                [
                    91.9100573,
                    55.204363
                ],
                [
                    91.9109825,
                    55.2043781
                ],
                [
                    91.9117346,
                    55.2042944
                ],
                [
                    91.912152,
                    55.2042192
                ],
                [
                    91.9123288,
                    55.2042622
                ],
                [
                    91.9125662,
                    55.2043899
                ],
                [
                    91.9131656,
                    55.2043697
                ],
                [
                    91.9151579,
                    55.2046147
                ],
                [
                    91.9151438,
                    55.2043009
                ],
                [
                    91.9153882,
                    55.2040702
                ],
                [
                    91.9156186,
                    55.2036651
                ],
                [
                    91.9155763,
                    55.2032922
                ],
                [
                    91.9152801,
                    55.2031286
                ],
                [
                    91.914763,
                    55.2030266
                ],
                [
                    91.9145468,
                    55.2029193
                ],
                [
                    91.914354,
                    55.2025545
                ],
                [
                    91.9143963,
                    55.2023774
                ],
                [
                    91.9148664,
                    55.202085
                ],
                [
                    91.9148758,
                    55.2010253
                ],
                [
                    91.9161639,
                    55.2008697
                ],
                [
                    91.9160464,
                    55.2006041
                ],
                [
                    91.9168267,
                    55.2004539
                ],
                [
                    91.9169857,
                    55.2005961
                ],
                [
                    91.9178465,
                    55.2004913
                ],
                [
                    91.9176595,
                    55.1998484
                ],
                [
                    91.9173295,
                    55.1995619
                ],
                [
                    91.9157802,
                    55.19948
                ],
                [
                    91.9141447,
                    55.1998239
                ],
                [
                    91.9143169,
                    55.1995783
                ],
                [
                    91.9110747,
                    55.1967289
                ],
                [
                    91.9123658,
                    55.1960493
                ],
                [
                    91.9110603,
                    55.1952304
                ],
                [
                    91.9070004,
                    55.1957708
                ],
                [
                    91.9050923,
                    55.1969745
                ],
                [
                    91.9048628,
                    55.1976541
                ],
                [
                    91.9062257,
                    55.1984484
                ],
                [
                    91.9067429,
                    55.199116
                ],
                [
                    91.9068164,
                    55.1995562
                ],
                [
                    91.9064491,
                    55.1999335
                ],
                [
                    91.9025103,
                    55.2020714
                ],
                [
                    91.9020599,
                    55.2016922
                ],
                [
                    91.9004263,
                    55.2009209
                ],
                [
                    91.8993745,
                    55.2000255
                ],
                [
                    91.89911,
                    55.1998444
                ],
                [
                    91.8986164,
                    55.1998243
                ],
                [
                    91.8981934,
                    55.1997405
                ],
                [
                    91.897829,
                    55.1997606
                ],
                [
                    91.8975,
                    55.199935
                ],
                [
                    91.8969065,
                    55.2000088
                ],
                [
                    91.8965245,
                    55.1999551
                ],
                [
                    91.8959604,
                    55.1997807
                ],
                [
                    91.8955608,
                    55.1997774
                ],
                [
                    91.8950085,
                    55.1999182
                ],
                [
                    91.8943974,
                    55.2000524
                ],
                [
                    91.893657,
                    55.2001463
                ],
                [
                    91.8925229,
                    55.1998545
                ],
                [
                    91.8925875,
                    55.1997807
                ],
                [
                    91.8924524,
                    55.1995828
                ],
                [
                    91.8924759,
                    55.1990764
                ],
                [
                    91.8921409,
                    55.1988082
                ],
                [
                    91.8915592,
                    55.1986774
                ],
                [
                    91.8910538,
                    55.1985331
                ],
                [
                    91.8901372,
                    55.1984292
                ],
                [
                    91.88801,
                    55.1976511
                ],
                [
                    91.8875928,
                    55.1972319
                ],
                [
                    91.8872813,
                    55.1970675
                ],
                [
                    91.8862648,
                    55.1973258
                ],
                [
                    91.8857829,
                    55.1972252
                ],
                [
                    91.8854127,
                    55.1972956
                ],
                [
                    91.885113,
                    55.197413
                ],
                [
                    91.8827327,
                    55.1976256
                ],
                [
                    91.8808523,
                    55.1977933
                ],
                [
                    91.8793539,
                    55.1977161
                ],
                [
                    91.8789485,
                    55.1972499
                ],
                [
                    91.8787839,
                    55.1965892
                ],
                [
                    91.8781375,
                    55.1969045
                ],
                [
                    91.8776884,
                    55.1979643
                ],
                [
                    91.8768506,
                    55.1986914
                ],
                [
                    91.8764833,
                    55.1989337
                ],
                [
                    91.8763915,
                    55.1988551
                ],
                [
                    91.8767702,
                    55.1983377
                ],
                [
                    91.8767014,
                    55.1981412
                ],
                [
                    91.8772523,
                    55.1977219
                ],
                [
                    91.8769998,
                    55.1976237
                ],
                [
                    91.8771834,
                    55.197532
                ],
                [
                    91.877126,
                    55.1972634
                ],
                [
                    91.8768735,
                    55.1971324
                ],
                [
                    91.8768735,
                    55.197021
                ],
                [
                    91.8772064,
                    55.1968507
                ],
                [
                    91.8769539,
                    55.1965953
                ],
                [
                    91.8773211,
                    55.1964708
                ],
                [
                    91.8775851,
                    55.1961302
                ],
                [
                    91.8774359,
                    55.1959074
                ],
                [
                    91.8776769,
                    55.195462
                ],
                [
                    91.8774129,
                    55.1949969
                ],
                [
                    91.8761046,
                    55.1944466
                ],
                [
                    91.8757947,
                    55.1943025
                ],
                [
                    91.8747618,
                    55.1940208
                ],
                [
                    91.8743945,
                    55.1937784
                ],
                [
                    91.8735223,
                    55.1936605
                ],
                [
                    91.8730058,
                    55.1933919
                ],
                [
                    91.872673,
                    55.1933723
                ],
                [
                    91.8708138,
                    55.1929399
                ],
                [
                    91.8693791,
                    55.1929333
                ],
                [
                    91.8676691,
                    55.1927761
                ],
                [
                    91.8665788,
                    55.1930316
                ],
                [
                    91.8652819,
                    55.1934771
                ],
                [
                    91.8646808,
                    55.1936853
                ],
                [
                    91.8651885,
                    55.194501
                ],
                [
                    91.865071,
                    55.1946405
                ],
                [
                    91.8650898,
                    55.1947237
                ],
                [
                    91.8653767,
                    55.1950252
                ],
                [
                    91.8652989,
                    55.1952272
                ],
                [
                    91.8654282,
                    55.1953211
                ],
                [
                    91.8656297,
                    55.1954986
                ],
                [
                    91.8656986,
                    55.1960817
                ],
                [
                    91.8656182,
                    55.1966843
                ],
                [
                    91.8653887,
                    55.1969529
                ],
                [
                    91.8649526,
                    55.1974966
                ],
                [
                    91.864505,
                    55.1978175
                ]
            ],
            "longitude": 91.892891,
            "latitude": 55.20636
        },
        "390": {
            "name": "Николаевка",
            "population": 524,
            "type": "village",
            "poly": null,
            "longitude": 91.8952842,
            "latitude": 54.2943796
        },
        "391": {
            "name": "Нижняя Коя",
            "population": 303,
            "type": "village",
            "poly": null,
            "longitude": 91.9138795,
            "latitude": 53.4573744
        },
        "392": {
            "name": "Знаменка",
            "population": 2262,
            "type": "village",
            "poly": null,
            "longitude": 91.915726,
            "latitude": 53.535999
        },
        "393": {
            "name": "Субботино",
            "population": 1560,
            "type": "village",
            "poly": null,
            "longitude": 91.9205511,
            "latitude": 53.0708276
        },
        "394": {
            "name": "Кавказское",
            "population": 1094,
            "type": "village",
            "poly": null,
            "longitude": 91.928261,
            "latitude": 53.965584
        },
        "395": {
            "name": "Большой Хабык",
            "population": 479,
            "type": "village",
            "poly": null,
            "longitude": 91.9414139,
            "latitude": 54.4254565
        },
        "396": {
            "name": "Плотбище",
            "population": 346,
            "type": "village",
            "poly": null,
            "longitude": 91.9559915,
            "latitude": 58.4425159
        },
        "397": {
            "name": "Малобелая",
            "population": 174,
            "type": "village",
            "poly": null,
            "longitude": 91.9634378,
            "latitude": 58.2312979
        },
        "398": {
            "name": "Зарничный",
            "population": 365,
            "type": "village",
            "poly": null,
            "longitude": 91.9717131,
            "latitude": 53.2440173
        },
        "399": {
            "name": "Средняя Шушь",
            "population": 500,
            "type": "village",
            "poly": null,
            "longitude": 91.974863,
            "latitude": 53.0399251
        },
        "400": {
            "name": "Иджа",
            "population": 637,
            "type": "village",
            "poly": null,
            "longitude": 91.97683,
            "latitude": 53.187931
        },
        "401": {
            "name": "Зеледеево",
            "population": 452,
            "type": "village",
            "poly": [
                [
                    91.959833,
                    56.0751415
                ],
                [
                    91.9599423,
                    56.0767879
                ],
                [
                    91.9599592,
                    56.0770432
                ],
                [
                    91.9625589,
                    56.0782123
                ],
                [
                    91.963821,
                    56.0776911
                ],
                [
                    91.9639219,
                    56.0779588
                ],
                [
                    91.965083,
                    56.0782405
                ],
                [
                    91.966345,
                    56.0785081
                ],
                [
                    91.9658654,
                    56.0787616
                ],
                [
                    91.9666225,
                    56.0790574
                ],
                [
                    91.9670517,
                    56.0787194
                ],
                [
                    91.9697272,
                    56.0799589
                ],
                [
                    91.9697272,
                    56.0804659
                ],
                [
                    91.973816,
                    56.0809589
                ],
                [
                    91.974649,
                    56.0805504
                ],
                [
                    91.9739675,
                    56.0800857
                ],
                [
                    91.9740432,
                    56.0795504
                ],
                [
                    91.9752295,
                    56.0793814
                ],
                [
                    91.9759363,
                    56.0786208
                ],
                [
                    91.9776021,
                    56.078663
                ],
                [
                    91.9779807,
                    56.0794237
                ],
                [
                    91.9788389,
                    56.0793391
                ],
                [
                    91.9792175,
                    56.0798603
                ],
                [
                    91.9786622,
                    56.0800152
                ],
                [
                    91.9789903,
                    56.0802688
                ],
                [
                    91.979899,
                    56.0802828
                ],
                [
                    91.9803785,
                    56.0806913
                ],
                [
                    91.9806309,
                    56.0806913
                ],
                [
                    91.9809591,
                    56.0804659
                ],
                [
                    91.9806309,
                    56.0799307
                ],
                [
                    91.9812872,
                    56.079804
                ],
                [
                    91.9813123,
                    56.0793955
                ],
                [
                    91.9820949,
                    56.0792687
                ],
                [
                    91.9827511,
                    56.0799448
                ],
                [
                    91.9850732,
                    56.0804237
                ],
                [
                    91.9869158,
                    56.0804237
                ],
                [
                    91.9878749,
                    56.0800152
                ],
                [
                    91.9874205,
                    56.0793955
                ],
                [
                    91.9877235,
                    56.0787757
                ],
                [
                    91.988203,
                    56.0778602
                ],
                [
                    91.9888845,
                    56.0780151
                ],
                [
                    91.989566,
                    56.0774517
                ],
                [
                    91.9894903,
                    56.076846
                ],
                [
                    91.9899951,
                    56.0771136
                ],
                [
                    91.9903989,
                    56.0769446
                ],
                [
                    91.9904494,
                    56.0766206
                ],
                [
                    91.9912066,
                    56.076677
                ],
                [
                    91.9909542,
                    56.0774094
                ],
                [
                    91.9916357,
                    56.0772404
                ],
                [
                    91.9923677,
                    56.0775503
                ],
                [
                    91.9923929,
                    56.0779588
                ],
                [
                    91.9933773,
                    56.0778602
                ],
                [
                    91.9949422,
                    56.0769446
                ],
                [
                    91.9959831,
                    56.0750123
                ],
                [
                    91.9964613,
                    56.0752359
                ],
                [
                    91.9976372,
                    56.0745291
                ],
                [
                    91.9967714,
                    56.074118
                ],
                [
                    91.9954675,
                    56.0732286
                ],
                [
                    91.9959723,
                    56.0726369
                ],
                [
                    91.9950637,
                    56.072017
                ],
                [
                    91.9951141,
                    56.0716226
                ],
                [
                    91.9942559,
                    56.071369
                ],
                [
                    91.9939531,
                    56.0706505
                ],
                [
                    91.9880469,
                    56.0700588
                ],
                [
                    91.984589,
                    56.0704673
                ],
                [
                    91.9844123,
                    56.0696502
                ],
                [
                    91.9837055,
                    56.0687344
                ],
                [
                    91.9821659,
                    56.0689035
                ],
                [
                    91.9810553,
                    56.0686217
                ],
                [
                    91.9795914,
                    56.068664
                ],
                [
                    91.9792633,
                    56.0691571
                ],
                [
                    91.9721203,
                    56.0709323
                ],
                [
                    91.9729028,
                    56.0724397
                ],
                [
                    91.9681322,
                    56.0725101
                ],
                [
                    91.9648258,
                    56.073454
                ],
                [
                    91.9644978,
                    56.0726651
                ],
                [
                    91.9630843,
                    56.0731581
                ],
                [
                    91.9608379,
                    56.0736371
                ],
                [
                    91.9604593,
                    56.0743415
                ],
                [
                    91.9609136,
                    56.0747922
                ],
                [
                    91.959833,
                    56.0751415
                ]
            ],
            "longitude": 91.9805087,
            "latitude": 56.0737914
        },
        "402": {
            "name": "Майское Утро",
            "population": 345,
            "type": "village",
            "poly": null,
            "longitude": 91.995653,
            "latitude": 54.38944
        },
        "403": {
            "name": "Икшурма",
            "population": 253,
            "type": "village",
            "poly": null,
            "longitude": 92.0028763,
            "latitude": 57.6387242
        },
        "404": {
            "name": "Казанцево",
            "population": 2171,
            "type": "village",
            "poly": null,
            "longitude": 92.005074,
            "latitude": 53.407478
        },
        "405": {
            "name": "Притубинский",
            "population": 411,
            "type": "village",
            "poly": null,
            "longitude": 92.0089836,
            "latitude": 53.9008369
        },
        "406": {
            "name": "Романовка",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 92.0154141,
            "latitude": 54.7273053
        },
        "407": {
            "name": "Тубинск",
            "population": 908,
            "type": "village",
            "poly": null,
            "longitude": 92.0333559,
            "latitude": 54.07867
        },
        "408": {
            "name": "Малая Ничка",
            "population": 450,
            "type": "village",
            "poly": null,
            "longitude": 92.034261,
            "latitude": 53.6293354
        },
        "409": {
            "name": "Погодаево",
            "population": 284,
            "type": "village",
            "poly": null,
            "longitude": 92.049866,
            "latitude": 58.699722
        },
        "410": {
            "name": "Усть-Кемь",
            "population": 1160,
            "type": "village",
            "poly": null,
            "longitude": 92.0546481,
            "latitude": 58.5426684
        },
        "411": {
            "name": "Новоберёзовка",
            "population": 485,
            "type": "village",
            "poly": null,
            "longitude": 92.0564916,
            "latitude": 54.5319957
        },
        "412": {
            "name": "Большой Телек",
            "population": 443,
            "type": "village",
            "poly": null,
            "longitude": 92.063203,
            "latitude": 54.2926693
        },
        "413": {
            "name": "Прихолмье",
            "population": 1072,
            "type": "village",
            "poly": null,
            "longitude": 92.0780892,
            "latitude": 53.7970327
        },
        "414": {
            "name": "Малый Хабык",
            "population": 310,
            "type": "village",
            "poly": null,
            "longitude": 92.0785375,
            "latitude": 54.4394971
        },
        "415": {
            "name": "Озёрное",
            "population": 1746,
            "type": "village",
            "poly": null,
            "longitude": 92.0808486,
            "latitude": 58.4647693
        },
        "416": {
            "name": "Подтёсово",
            "population": 4163,
            "type": "village",
            "poly": [
                [
                    92.0647061,
                    58.6076315
                ],
                [
                    92.0647061,
                    58.6091516
                ],
                [
                    92.0669259,
                    58.6118216
                ],
                [
                    92.0679397,
                    58.6120742
                ],
                [
                    92.0687602,
                    58.6115916
                ],
                [
                    92.0689533,
                    58.6108194
                ],
                [
                    92.0678915,
                    58.6104332
                ],
                [
                    92.0695324,
                    58.6092266
                ],
                [
                    92.0682293,
                    58.6078752
                ],
                [
                    92.0689533,
                    58.6074891
                ],
                [
                    92.0704495,
                    58.6067651
                ],
                [
                    92.0727179,
                    58.6065721
                ],
                [
                    92.0739245,
                    58.6065721
                ],
                [
                    92.0747933,
                    58.6070065
                ],
                [
                    92.0764826,
                    58.6062825
                ],
                [
                    92.0781718,
                    58.6073926
                ],
                [
                    92.0764343,
                    58.6083096
                ],
                [
                    92.0773996,
                    58.609661
                ],
                [
                    92.0790887,
                    58.6111089
                ],
                [
                    92.0821294,
                    58.6123638
                ],
                [
                    92.0846393,
                    58.61386
                ],
                [
                    92.0881626,
                    58.6123156
                ],
                [
                    92.089514,
                    58.6104332
                ],
                [
                    92.0885487,
                    58.6080683
                ],
                [
                    92.0905758,
                    58.6070547
                ],
                [
                    92.0919755,
                    58.6087922
                ],
                [
                    92.0934717,
                    58.6081165
                ],
                [
                    92.0941474,
                    58.6096127
                ],
                [
                    92.0975258,
                    58.6078752
                ],
                [
                    92.0962227,
                    58.6060412
                ],
                [
                    92.1003735,
                    58.6039175
                ],
                [
                    92.0993117,
                    58.6027109
                ],
                [
                    92.1008079,
                    58.6018422
                ],
                [
                    92.1024006,
                    58.6017939
                ],
                [
                    92.1049103,
                    58.601456
                ],
                [
                    92.1042829,
                    58.6009734
                ],
                [
                    92.1029315,
                    58.6001046
                ],
                [
                    92.1043312,
                    58.5996703
                ],
                [
                    92.1062135,
                    58.5993324
                ],
                [
                    92.1073718,
                    58.5986567
                ],
                [
                    92.1086267,
                    58.599622
                ],
                [
                    92.1106538,
                    58.5983188
                ],
                [
                    92.1090128,
                    58.5960022
                ],
                [
                    92.1097367,
                    58.5944577
                ],
                [
                    92.111426,
                    58.5944577
                ],
                [
                    92.1116191,
                    58.5938785
                ],
                [
                    92.1091576,
                    58.593058
                ],
                [
                    92.1125361,
                    58.5913205
                ],
                [
                    92.1143218,
                    58.5919962
                ],
                [
                    92.115094,
                    58.591224
                ],
                [
                    92.1138393,
                    58.5905483
                ],
                [
                    92.1144667,
                    58.5896795
                ],
                [
                    92.1151907,
                    58.588859
                ],
                [
                    92.1145632,
                    58.5884246
                ],
                [
                    92.1101228,
                    58.5915136
                ],
                [
                    92.1050551,
                    58.593782
                ],
                [
                    92.098636,
                    58.5962917
                ],
                [
                    92.0943403,
                    58.5976431
                ],
                [
                    92.0931338,
                    58.5982223
                ],
                [
                    92.091155,
                    58.5991876
                ],
                [
                    92.0891278,
                    58.5995255
                ],
                [
                    92.0902862,
                    58.6009251
                ],
                [
                    92.0887417,
                    58.6015043
                ],
                [
                    92.0874869,
                    58.6015043
                ],
                [
                    92.0868112,
                    58.6026144
                ],
                [
                    92.0854115,
                    58.6035314
                ],
                [
                    92.0857976,
                    58.6042554
                ],
                [
                    92.0865216,
                    58.6052689
                ],
                [
                    92.0851219,
                    58.6049311
                ],
                [
                    92.0844462,
                    58.6044002
                ],
                [
                    92.0828535,
                    58.6045932
                ],
                [
                    92.0819847,
                    58.6032418
                ],
                [
                    92.0826121,
                    58.6027592
                ],
                [
                    92.0868594,
                    58.6010699
                ],
                [
                    92.0857694,
                    58.5992892
                ],
                [
                    92.0811855,
                    58.601014
                ],
                [
                    92.0755207,
                    58.6021766
                ],
                [
                    92.0735751,
                    58.6037458
                ],
                [
                    92.0647061,
                    58.6076315
                ]
            ],
            "longitude": 92.090935,
            "latitude": 58.604252
        },
        "417": {
            "name": "Синеборск",
            "population": 1191,
            "type": "village",
            "poly": null,
            "longitude": 92.0960198,
            "latitude": 53.4847301
        },
        "418": {
            "name": "Куреж",
            "population": 336,
            "type": "village",
            "poly": null,
            "longitude": 92.1037642,
            "latitude": 54.2104117
        },
        "419": {
            "name": "Галактионово",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 92.1122018,
            "latitude": 54.1376661
        },
        "420": {
            "name": "Большая Иня",
            "population": 915,
            "type": "village",
            "poly": null,
            "longitude": 92.11554,
            "latitude": 53.77042
        },
        "421": {
            "name": "Кузьмовка",
            "population": 186,
            "type": "village",
            "poly": null,
            "longitude": 92.1162251,
            "latitude": 62.3137069
        },
        "422": {
            "name": "Большая Ничка",
            "population": 853,
            "type": "village",
            "poly": null,
            "longitude": 92.1333876,
            "latitude": 53.6668742
        },
        "423": {
            "name": "Восточное",
            "population": 534,
            "type": "village",
            "poly": null,
            "longitude": 92.1358577,
            "latitude": 53.5767904
        },
        "424": {
            "name": "Екатериновка",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 92.1569969,
            "latitude": 54.5528593
        },
        "425": {
            "name": "Верхняя Коя",
            "population": 333,
            "type": "village",
            "poly": null,
            "longitude": 92.1617626,
            "latitude": 53.4968924
        },
        "426": {
            "name": "Сибирь",
            "population": 171,
            "type": "village",
            "poly": null,
            "longitude": 92.164375,
            "latitude": 54.3972409
        },
        "427": {
            "name": "Троица",
            "population": 520,
            "type": "village",
            "poly": null,
            "longitude": 92.1754903,
            "latitude": 57.7736065
        },
        "428": {
            "name": "Черемушки",
            "population": 585,
            "type": "village",
            "poly": null,
            "longitude": 92.1843382,
            "latitude": 55.176267
        },
        "429": {
            "name": "Жеблахты",
            "population": 597,
            "type": "village",
            "poly": null,
            "longitude": 92.1848207,
            "latitude": 53.3197004
        },
        "430": {
            "name": "Тесь",
            "population": 2401,
            "type": "village",
            "poly": null,
            "longitude": 92.186226,
            "latitude": 53.866264
        },
        "431": {
            "name": "Ивановка",
            "population": 435,
            "type": "village",
            "poly": null,
            "longitude": 92.1918424,
            "latitude": 53.3845764
        },
        "432": {
            "name": "Малая Иня",
            "population": 316,
            "type": "village",
            "poly": null,
            "longitude": 92.209198,
            "latitude": 53.802078
        },
        "433": {
            "name": "Бушуй",
            "population": 148,
            "type": "village",
            "poly": null,
            "longitude": 92.2100797,
            "latitude": 57.4663114
        },
        "434": {
            "name": "Мигна",
            "population": 1155,
            "type": "village",
            "poly": null,
            "longitude": 92.2229672,
            "latitude": 53.1361286
        },
        "435": {
            "name": "Кача",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 92.2271559,
            "latitude": 56.0970001
        },
        "436": {
            "name": "Алексеевка",
            "population": 606,
            "type": "village",
            "poly": null,
            "longitude": 92.2301047,
            "latitude": 54.0465469
        },
        "437": {
            "name": "Семенниково",
            "population": 707,
            "type": "village",
            "poly": null,
            "longitude": 92.2359133,
            "latitude": 53.1993513
        },
        "438": {
            "name": "Никольское",
            "population": 513,
            "type": "village",
            "poly": null,
            "longitude": 92.2409329,
            "latitude": 54.4869995
        },
        "439": {
            "name": "Епишино",
            "population": 920,
            "type": "village",
            "poly": null,
            "longitude": 92.2476557,
            "latitude": 58.4880802
        },
        "440": {
            "name": "Центральный",
            "population": 355,
            "type": "village",
            "poly": null,
            "longitude": 92.261102,
            "latitude": 54.3656495
        },
        "441": {
            "name": "Верхнепашино",
            "population": 2870,
            "type": "village",
            "poly": null,
            "longitude": 92.2635944,
            "latitude": 58.4124243
        },
        "442": {
            "name": "Енисейск-4",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 92.2663586,
            "latitude": 58.4463452
        },
        "443": {
            "name": "Пировское",
            "population": 2993,
            "type": "village",
            "poly": null,
            "longitude": 92.272644,
            "latitude": 57.624046
        },
        "444": {
            "name": "Новопокровка",
            "population": 313,
            "type": "village",
            "poly": null,
            "longitude": 92.2752864,
            "latitude": 54.1223257
        },
        "445": {
            "name": "Шалоболино",
            "population": 768,
            "type": "village",
            "poly": [
                [
                    92.2718729,
                    53.9387054
                ],
                [
                    92.27298,
                    53.9425283
                ],
                [
                    92.2804342,
                    53.944418
                ],
                [
                    92.2824269,
                    53.9468939
                ],
                [
                    92.2836099,
                    53.9490213
                ],
                [
                    92.2867687,
                    53.9501505
                ],
                [
                    92.2934111,
                    53.9488649
                ],
                [
                    92.2959795,
                    53.9464846
                ],
                [
                    92.297824,
                    53.9429354
                ],
                [
                    92.2961908,
                    53.9410011
                ],
                [
                    92.2941249,
                    53.9398132
                ],
                [
                    92.2949736,
                    53.9384664
                ],
                [
                    92.2936083,
                    53.9376844
                ],
                [
                    92.2891431,
                    53.933861
                ],
                [
                    92.2862002,
                    53.9329974
                ],
                [
                    92.2850195,
                    53.9317276
                ],
                [
                    92.2823441,
                    53.9322708
                ],
                [
                    92.2818367,
                    53.9337644
                ],
                [
                    92.2794009,
                    53.9341651
                ],
                [
                    92.2741608,
                    53.9345127
                ],
                [
                    92.2741977,
                    53.9362289
                ],
                [
                    92.2718729,
                    53.9387054
                ]
            ],
            "longitude": 92.286148,
            "latitude": 53.939526
        },
        "446": {
            "name": "Каменный Яр",
            "population": 405,
            "type": "village",
            "poly": null,
            "longitude": 92.2982865,
            "latitude": 56.1158041
        },
        "447": {
            "name": "Колмаково",
            "population": 347,
            "type": "village",
            "poly": null,
            "longitude": 92.3002679,
            "latitude": 53.7127399
        },
        "448": {
            "name": "Солоуха",
            "population": 203,
            "type": "village",
            "poly": null,
            "longitude": 92.3027588,
            "latitude": 57.7555502
        },
        "449": {
            "name": "Дубенское",
            "population": 413,
            "type": "village",
            "poly": null,
            "longitude": 92.3069978,
            "latitude": 53.4648939
        },
        "450": {
            "name": "Потапово",
            "population": 616,
            "type": "village",
            "poly": null,
            "longitude": 92.3114533,
            "latitude": 58.4352374
        },
        "451": {
            "name": "Памяти 13 Борцов",
            "population": 2968,
            "type": "village",
            "poly": null,
            "longitude": 92.318954,
            "latitude": 56.21492
        },
        "452": {
            "name": "Курганчики",
            "population": 417,
            "type": "village",
            "poly": null,
            "longitude": 92.3247627,
            "latitude": 53.9767793
        },
        "453": {
            "name": "Большая Салба",
            "population": 158,
            "type": "village",
            "poly": null,
            "longitude": 92.3268561,
            "latitude": 54.2319987
        },
        "454": {
            "name": "Николаевка",
            "population": 352,
            "type": "village",
            "poly": [
                [
                    92.3343679,
                    53.3148034
                ],
                [
                    92.3347455,
                    53.3153001
                ],
                [
                    92.3366638,
                    53.3167262
                ],
                [
                    92.3371488,
                    53.3176844
                ],
                [
                    92.3373419,
                    53.3187099
                ],
                [
                    92.3376852,
                    53.3188765
                ],
                [
                    92.3386936,
                    53.3186072
                ],
                [
                    92.3399254,
                    53.3178671
                ],
                [
                    92.3414489,
                    53.3172518
                ],
                [
                    92.3433715,
                    53.3165179
                ],
                [
                    92.345131,
                    53.3162359
                ],
                [
                    92.3464484,
                    53.3170723
                ],
                [
                    92.3478562,
                    53.3167999
                ],
                [
                    92.3475128,
                    53.3158129
                ],
                [
                    92.3494097,
                    53.3152777
                ],
                [
                    92.3510189,
                    53.3150085
                ],
                [
                    92.3529845,
                    53.3146976
                ],
                [
                    92.3536798,
                    53.3140855
                ],
                [
                    92.3532206,
                    53.3128516
                ],
                [
                    92.3527055,
                    53.3113645
                ],
                [
                    92.3514053,
                    53.3113292
                ],
                [
                    92.350268,
                    53.3112395
                ],
                [
                    92.3491865,
                    53.3109671
                ],
                [
                    92.346706,
                    53.3105216
                ],
                [
                    92.3451525,
                    53.3108004
                ],
                [
                    92.3434788,
                    53.3114158
                ],
                [
                    92.3416419,
                    53.3123549
                ],
                [
                    92.3406764,
                    53.3123932
                ],
                [
                    92.3390027,
                    53.3126369
                ],
                [
                    92.3376208,
                    53.3127491
                ],
                [
                    92.336505,
                    53.3131208
                ],
                [
                    92.3354837,
                    53.3137649
                ],
                [
                    92.3343679,
                    53.3148034
                ]
            ],
            "longitude": 92.3442039,
            "latitude": 53.3133787
        },
        "455": {
            "name": "Новоозёрный",
            "population": 305,
            "type": "village",
            "poly": [
                [
                    92.4090317,
                    53.2393053
                ],
                [
                    92.4102548,
                    53.2398575
                ],
                [
                    92.4115852,
                    53.2406665
                ],
                [
                    92.4117354,
                    53.2418736
                ],
                [
                    92.4145034,
                    53.2429907
                ],
                [
                    92.4149755,
                    53.2441721
                ],
                [
                    92.4152544,
                    53.2450709
                ],
                [
                    92.4167779,
                    53.2459697
                ],
                [
                    92.4175504,
                    53.2465475
                ],
                [
                    92.4191994,
                    53.2470533
                ],
                [
                    92.4211092,
                    53.2465783
                ],
                [
                    92.4222035,
                    53.2449348
                ],
                [
                    92.4217529,
                    53.2435223
                ],
                [
                    92.4205545,
                    53.2426569
                ],
                [
                    92.4193314,
                    53.2420277
                ],
                [
                    92.4176577,
                    53.2408077
                ],
                [
                    92.4160913,
                    53.239973
                ],
                [
                    92.4106839,
                    53.2386632
                ],
                [
                    92.4098525,
                    53.238377
                ],
                [
                    92.409375,
                    53.2387274
                ],
                [
                    92.4090317,
                    53.2393053
                ]
            ],
            "longitude": 92.417535,
            "latitude": 53.24405
        },
        "456": {
            "name": "Тигрицкое",
            "population": 1162,
            "type": "village",
            "poly": null,
            "longitude": 92.4181981,
            "latitude": 53.5969971
        },
        "457": {
            "name": "Городище",
            "population": 263,
            "type": "village",
            "poly": null,
            "longitude": 92.4372362,
            "latitude": 58.2929738
        },
        "458": {
            "name": "Жерлык",
            "population": 607,
            "type": "village",
            "poly": null,
            "longitude": 92.437729,
            "latitude": 53.752277
        },
        "459": {
            "name": "Шошино",
            "population": 629,
            "type": "village",
            "poly": null,
            "longitude": 92.44072,
            "latitude": 53.818592
        },
        "460": {
            "name": "Разъезжее",
            "population": 631,
            "type": "village",
            "poly": [
                [
                    92.4154658,
                    53.1179501
                ],
                [
                    92.4181094,
                    53.1187318
                ],
                [
                    92.4377818,
                    53.1208605
                ],
                [
                    92.4394984,
                    53.1233844
                ],
                [
                    92.4368376,
                    53.1241312
                ],
                [
                    92.4373333,
                    53.1251188
                ],
                [
                    92.4345631,
                    53.1266549
                ],
                [
                    92.43493,
                    53.1297012
                ],
                [
                    92.4411957,
                    53.1301389
                ],
                [
                    92.4454207,
                    53.1315217
                ],
                [
                    92.4478476,
                    53.1290831
                ],
                [
                    92.452697,
                    53.1260717
                ],
                [
                    92.452697,
                    53.1185
                ],
                [
                    92.4416871,
                    53.1155032
                ],
                [
                    92.4354643,
                    53.1155546
                ],
                [
                    92.4323551,
                    53.1171864
                ],
                [
                    92.4174399,
                    53.115735
                ],
                [
                    92.4155774,
                    53.1169031
                ],
                [
                    92.4154658,
                    53.1179501
                ]
            ],
            "longitude": 92.4416384,
            "latitude": 53.1192331
        },
        "461": {
            "name": "Пойлово",
            "population": 748,
            "type": "village",
            "poly": null,
            "longitude": 92.449766,
            "latitude": 53.85728
        },
        "462": {
            "name": "Детлово",
            "population": 310,
            "type": "village",
            "poly": null,
            "longitude": 92.4521105,
            "latitude": 54.0910988
        },
        "463": {
            "name": "Арейское",
            "population": 2117,
            "type": "village",
            "poly": null,
            "longitude": 92.452278,
            "latitude": 56.09734
        },
        "464": {
            "name": "Крутая",
            "population": 387,
            "type": "village",
            "poly": null,
            "longitude": 92.4662205,
            "latitude": 56.2363913
        },
        "465": {
            "name": "Нижний Суэтук",
            "population": 856,
            "type": "village",
            "poly": [
                [
                    92.4531908,
                    53.3508069
                ],
                [
                    92.4544568,
                    53.3513577
                ],
                [
                    92.45496,
                    53.3516811
                ],
                [
                    92.455358,
                    53.352139
                ],
                [
                    92.4560543,
                    53.3522575
                ],
                [
                    92.4581475,
                    53.3518572
                ],
                [
                    92.4596066,
                    53.3512168
                ],
                [
                    92.4605507,
                    53.3512937
                ],
                [
                    92.4625893,
                    53.3520621
                ],
                [
                    92.4648305,
                    53.3525136
                ],
                [
                    92.4666018,
                    53.3525617
                ],
                [
                    92.4670954,
                    53.351537
                ],
                [
                    92.4675556,
                    53.3503234
                ],
                [
                    92.4679419,
                    53.3493756
                ],
                [
                    92.4698634,
                    53.348591
                ],
                [
                    92.4715156,
                    53.3499488
                ],
                [
                    92.4714727,
                    53.3518828
                ],
                [
                    92.4725124,
                    53.3529747
                ],
                [
                    92.4747343,
                    53.3536631
                ],
                [
                    92.4774262,
                    53.3541018
                ],
                [
                    92.4784465,
                    53.3532661
                ],
                [
                    92.4783918,
                    53.3525392
                ],
                [
                    92.4772974,
                    53.3520397
                ],
                [
                    92.4766869,
                    53.35114
                ],
                [
                    92.4745937,
                    53.3505284
                ],
                [
                    92.473597,
                    53.3503971
                ],
                [
                    92.4727698,
                    53.3502338
                ],
                [
                    92.4722452,
                    53.3497054
                ],
                [
                    92.4718804,
                    53.3490265
                ],
                [
                    92.4714824,
                    53.3485046
                ],
                [
                    92.4753351,
                    53.3487063
                ],
                [
                    92.4756666,
                    53.34821
                ],
                [
                    92.475216,
                    53.347941
                ],
                [
                    92.4747869,
                    53.3473774
                ],
                [
                    92.4733063,
                    53.3473133
                ],
                [
                    92.4721808,
                    53.3464134
                ],
                [
                    92.4717399,
                    53.3458274
                ],
                [
                    92.4747343,
                    53.3446457
                ],
                [
                    92.4745508,
                    53.3437137
                ],
                [
                    92.4747558,
                    53.3427497
                ],
                [
                    92.475409,
                    53.3418433
                ],
                [
                    92.4757213,
                    53.3410585
                ],
                [
                    92.4752493,
                    53.3406487
                ],
                [
                    92.4740691,
                    53.3395853
                ],
                [
                    92.4737784,
                    53.3389351
                ],
                [
                    92.474863,
                    53.3384835
                ],
                [
                    92.4744982,
                    53.3373432
                ],
                [
                    92.471962,
                    53.3375527
                ],
                [
                    92.4677176,
                    53.3382529
                ],
                [
                    92.4671479,
                    53.3377308
                ],
                [
                    92.4668379,
                    53.3359594
                ],
                [
                    92.46628,
                    53.3360107
                ],
                [
                    92.4654431,
                    53.3361132
                ],
                [
                    92.4651738,
                    53.3368211
                ],
                [
                    92.4649378,
                    53.3373208
                ],
                [
                    92.4629637,
                    53.3375386
                ],
                [
                    92.4628682,
                    53.3390857
                ],
                [
                    92.4614735,
                    53.3401618
                ],
                [
                    92.4580928,
                    53.3418433
                ],
                [
                    92.4582763,
                    53.3429419
                ],
                [
                    92.4608511,
                    53.343877
                ],
                [
                    92.4625463,
                    53.3447866
                ],
                [
                    92.464735,
                    53.3446072
                ],
                [
                    92.4663443,
                    53.3453758
                ],
                [
                    92.4666018,
                    53.3456833
                ],
                [
                    92.4651642,
                    53.3456064
                ],
                [
                    92.4628253,
                    53.346106
                ],
                [
                    92.4608608,
                    53.346327
                ],
                [
                    92.4594017,
                    53.3468266
                ],
                [
                    92.4574705,
                    53.3475311
                ],
                [
                    92.456109,
                    53.3486935
                ],
                [
                    92.4542948,
                    53.3496446
                ],
                [
                    92.4536511,
                    53.350221
                ],
                [
                    92.4531908,
                    53.3508069
                ]
            ],
            "longitude": 92.4665764,
            "latitude": 53.3462666
        },
        "466": {
            "name": "Усть-Мана",
            "population": 874,
            "type": "village",
            "poly": null,
            "longitude": 92.4767763,
            "latitude": 55.9398167
        },
        "467": {
            "name": "Кириково",
            "population": 264,
            "type": "village",
            "poly": null,
            "longitude": 92.4802048,
            "latitude": 57.5803214
        },
        "468": {
            "name": "Ойский",
            "population": 1085,
            "type": "village",
            "poly": [
                [
                    92.4811832,
                    53.2402085
                ],
                [
                    92.4818054,
                    53.2416725
                ],
                [
                    92.4825565,
                    53.2423531
                ],
                [
                    92.4848524,
                    53.2427512
                ],
                [
                    92.4858609,
                    53.2435601
                ],
                [
                    92.4868051,
                    53.2450111
                ],
                [
                    92.4871269,
                    53.2465005
                ],
                [
                    92.4870174,
                    53.247905
                ],
                [
                    92.4859897,
                    53.2487859
                ],
                [
                    92.4844876,
                    53.2492738
                ],
                [
                    92.4820414,
                    53.2496975
                ],
                [
                    92.4814621,
                    53.2514435
                ],
                [
                    92.4863545,
                    53.2521881
                ],
                [
                    92.4926629,
                    53.252355
                ],
                [
                    92.4953431,
                    53.2521932
                ],
                [
                    92.4997226,
                    53.2513023
                ],
                [
                    92.4998492,
                    53.2497925
                ],
                [
                    92.5028318,
                    53.2491119
                ],
                [
                    92.5055162,
                    53.2457301
                ],
                [
                    92.50528,
                    53.2445103
                ],
                [
                    92.5092283,
                    53.2438169
                ],
                [
                    92.5107497,
                    53.2421913
                ],
                [
                    92.5108591,
                    53.2376658
                ],
                [
                    92.5114813,
                    53.2359577
                ],
                [
                    92.5115457,
                    53.2346092
                ],
                [
                    92.5104943,
                    53.234545
                ],
                [
                    92.5076834,
                    53.2345193
                ],
                [
                    92.5071448,
                    53.2352307
                ],
                [
                    92.5083915,
                    53.2364586
                ],
                [
                    92.5078121,
                    53.2374603
                ],
                [
                    92.5049368,
                    53.237242
                ],
                [
                    92.5034562,
                    53.2369595
                ],
                [
                    92.5018469,
                    53.2372805
                ],
                [
                    92.500774,
                    53.2379483
                ],
                [
                    92.4992934,
                    53.2378584
                ],
                [
                    92.4973837,
                    53.2385519
                ],
                [
                    92.4961392,
                    53.239194
                ],
                [
                    92.4948732,
                    53.2389372
                ],
                [
                    92.492942,
                    53.2385519
                ],
                [
                    92.4915901,
                    53.2382951
                ],
                [
                    92.4905387,
                    53.2388473
                ],
                [
                    92.4903456,
                    53.2395664
                ],
                [
                    92.490043,
                    53.2404448
                ],
                [
                    92.4893371,
                    53.2409919
                ],
                [
                    92.4884788,
                    53.2410048
                ],
                [
                    92.4872965,
                    53.2405604
                ],
                [
                    92.4842515,
                    53.2393353
                ],
                [
                    92.4821058,
                    53.2394252
                ],
                [
                    92.4811832,
                    53.2402085
                ]
            ],
            "longitude": 92.493988,
            "latitude": 53.24609
        },
        "469": {
            "name": "Кочергино",
            "population": 888,
            "type": "village",
            "poly": null,
            "longitude": 92.498428,
            "latitude": 53.817822
        },
        "470": {
            "name": "Манский",
            "population": 302,
            "type": "village",
            "poly": null,
            "longitude": 92.5015495,
            "latitude": 55.897891
        },
        "471": {
            "name": "Никольское",
            "population": 1061,
            "type": "village",
            "poly": null,
            "longitude": 92.5151351,
            "latitude": 56.3776066
        },
        "472": {
            "name": "Новотроицкое",
            "population": 176,
            "type": "village",
            "poly": null,
            "longitude": 92.5368078,
            "latitude": 54.5429372
        },
        "473": {
            "name": "Минино",
            "population": 1975,
            "type": "village",
            "poly": null,
            "longitude": 92.5400938,
            "latitude": 56.0508005
        },
        "474": {
            "name": "Еловое",
            "population": 1517,
            "type": "village",
            "poly": null,
            "longitude": 92.5415493,
            "latitude": 56.1428702
        },
        "475": {
            "name": "Отрок",
            "population": 481,
            "type": "village",
            "poly": null,
            "longitude": 92.5505089,
            "latitude": 54.4471031
        },
        "476": {
            "name": "Овсянка",
            "population": 2228,
            "type": "village",
            "poly": null,
            "longitude": 92.562515,
            "latitude": 55.961285
        },
        "477": {
            "name": "Байдово",
            "population": 431,
            "type": "village",
            "poly": null,
            "longitude": 92.5643256,
            "latitude": 54.0097484
        },
        "478": {
            "name": "Большие Кныши",
            "population": 511,
            "type": "village",
            "poly": null,
            "longitude": 92.5716217,
            "latitude": 54.2501936
        },
        "479": {
            "name": "Элита",
            "population": 1746,
            "type": "village",
            "poly": [
                [
                    92.5482757,
                    56.089079
                ],
                [
                    92.5482902,
                    56.0891441
                ],
                [
                    92.54852,
                    56.0894757
                ],
                [
                    92.5488354,
                    56.089787
                ],
                [
                    92.5495153,
                    56.0898459
                ],
                [
                    92.5498253,
                    56.0899578
                ],
                [
                    92.5506201,
                    56.0899802
                ],
                [
                    92.5510175,
                    56.0899293
                ],
                [
                    92.5518853,
                    56.0897015
                ],
                [
                    92.5521113,
                    56.0895855
                ],
                [
                    92.5524468,
                    56.0895916
                ],
                [
                    92.5526141,
                    56.0896391
                ],
                [
                    92.552853,
                    56.0895548
                ],
                [
                    92.5531914,
                    56.0893319
                ],
                [
                    92.5535818,
                    56.0893007
                ],
                [
                    92.5540893,
                    56.0891933
                ],
                [
                    92.554311,
                    56.0892047
                ],
                [
                    92.5547397,
                    56.089286
                ],
                [
                    92.5550927,
                    56.0892437
                ],
                [
                    92.5558277,
                    56.0891097
                ],
                [
                    92.5565727,
                    56.0890088
                ],
                [
                    92.5571255,
                    56.0889957
                ],
                [
                    92.5593118,
                    56.0882325
                ],
                [
                    92.5608423,
                    56.0890352
                ],
                [
                    92.5614585,
                    56.0895539
                ],
                [
                    92.5619515,
                    56.0900095
                ],
                [
                    92.561907,
                    56.0911568
                ],
                [
                    92.5614104,
                    56.0913674
                ],
                [
                    92.5611245,
                    56.0916128
                ],
                [
                    92.5610465,
                    56.0917528
                ],
                [
                    92.5609852,
                    56.0924472
                ],
                [
                    92.5606532,
                    56.0926568
                ],
                [
                    92.5594823,
                    56.0927352
                ],
                [
                    92.5556715,
                    56.0933706
                ],
                [
                    92.5555262,
                    56.0934816
                ],
                [
                    92.5557633,
                    56.0938559
                ],
                [
                    92.555931,
                    56.094765
                ],
                [
                    92.5563795,
                    56.0957677
                ],
                [
                    92.5564336,
                    56.0958755
                ],
                [
                    92.5569446,
                    56.0968944
                ],
                [
                    92.5587203,
                    56.0968497
                ],
                [
                    92.5596792,
                    56.0965629
                ],
                [
                    92.560609,
                    56.0963555
                ],
                [
                    92.5617648,
                    56.0963758
                ],
                [
                    92.562494,
                    56.0964735
                ],
                [
                    92.5631758,
                    56.0964877
                ],
                [
                    92.5654364,
                    56.0967236
                ],
                [
                    92.5673032,
                    56.0967521
                ],
                [
                    92.5680392,
                    56.0968671
                ],
                [
                    92.5691268,
                    56.0968797
                ],
                [
                    92.5692702,
                    56.0967758
                ],
                [
                    92.5694124,
                    56.0968637
                ],
                [
                    92.5696239,
                    56.0968624
                ],
                [
                    92.5698712,
                    56.0968044
                ],
                [
                    92.5702141,
                    56.0968217
                ],
                [
                    92.5703443,
                    56.0967238
                ],
                [
                    92.57049,
                    56.0967771
                ],
                [
                    92.5709345,
                    56.0967744
                ],
                [
                    92.5711304,
                    56.0967984
                ],
                [
                    92.5714841,
                    56.0967424
                ],
                [
                    92.5716489,
                    56.0967784
                ],
                [
                    92.5720767,
                    56.0967751
                ],
                [
                    92.572226,
                    56.0967431
                ],
                [
                    92.5726633,
                    56.0968158
                ],
                [
                    92.5731436,
                    56.0967458
                ],
                [
                    92.5738234,
                    56.0966971
                ],
                [
                    92.5746513,
                    56.0967098
                ],
                [
                    92.5755068,
                    56.0966831
                ],
                [
                    92.5755749,
                    56.0968224
                ],
                [
                    92.576157,
                    56.0983572
                ],
                [
                    92.5785597,
                    56.0983748
                ],
                [
                    92.5788276,
                    56.0985369
                ],
                [
                    92.5818412,
                    56.0986163
                ],
                [
                    92.5821717,
                    56.0986831
                ],
                [
                    92.5829521,
                    56.0986767
                ],
                [
                    92.5832941,
                    56.0985941
                ],
                [
                    92.583596,
                    56.0983971
                ],
                [
                    92.5837945,
                    56.0980878
                ],
                [
                    92.5831508,
                    56.0972548
                ],
                [
                    92.5821131,
                    56.0958852
                ],
                [
                    92.5831972,
                    56.0959979
                ],
                [
                    92.5836359,
                    56.0961377
                ],
                [
                    92.5843081,
                    56.096125
                ],
                [
                    92.5845759,
                    56.0962076
                ],
                [
                    92.5851912,
                    56.0961854
                ],
                [
                    92.5857779,
                    56.0960074
                ],
                [
                    92.5860172,
                    56.096017
                ],
                [
                    92.5864787,
                    56.0963824
                ],
                [
                    92.5878345,
                    56.0962807
                ],
                [
                    92.5889284,
                    56.0958994
                ],
                [
                    92.5900678,
                    56.0947999
                ],
                [
                    92.5907457,
                    56.0941929
                ],
                [
                    92.590985,
                    56.0940117
                ],
                [
                    92.5915205,
                    56.0933825
                ],
                [
                    92.5919307,
                    56.0929789
                ],
                [
                    92.5924662,
                    56.0924799
                ],
                [
                    92.5927397,
                    56.091946
                ],
                [
                    92.592996,
                    56.0907796
                ],
                [
                    92.5933948,
                    56.0901503
                ],
                [
                    92.593936,
                    56.0896958
                ],
                [
                    92.5945513,
                    56.0890856
                ],
                [
                    92.5954629,
                    56.0883863
                ],
                [
                    92.5976847,
                    56.08742
                ],
                [
                    92.5988469,
                    56.0869592
                ],
                [
                    92.5997299,
                    56.0867621
                ],
                [
                    92.601063,
                    56.0859897
                ],
                [
                    92.6025101,
                    56.0855383
                ],
                [
                    92.604561,
                    56.0850297
                ],
                [
                    92.6064695,
                    56.0845752
                ],
                [
                    92.6060177,
                    56.084263
                ],
                [
                    92.6038458,
                    56.0843027
                ],
                [
                    92.6019586,
                    56.0846961
                ],
                [
                    92.6000928,
                    56.0848908
                ],
                [
                    92.5979066,
                    56.084565
                ],
                [
                    92.5973725,
                    56.08441
                ],
                [
                    92.5969524,
                    56.0845332
                ],
                [
                    92.5964539,
                    56.0844497
                ],
                [
                    92.5962402,
                    56.0844259
                ],
                [
                    92.5958771,
                    56.084414
                ],
                [
                    92.5957489,
                    56.0843822
                ],
                [
                    92.5959553,
                    56.0842153
                ],
                [
                    92.595051,
                    56.0841915
                ],
                [
                    92.5946237,
                    56.0840961
                ],
                [
                    92.5944878,
                    56.0839567
                ],
                [
                    92.5941251,
                    56.0840365
                ],
                [
                    92.5936196,
                    56.0839491
                ],
                [
                    92.593463,
                    56.0837981
                ],
                [
                    92.5921598,
                    56.0834603
                ],
                [
                    92.5921455,
                    56.0833411
                ],
                [
                    92.5923236,
                    56.0831067
                ],
                [
                    92.5922879,
                    56.0829954
                ],
                [
                    92.5920316,
                    56.0830153
                ],
                [
                    92.5917396,
                    56.0831822
                ],
                [
                    92.5916114,
                    56.0833054
                ],
                [
                    92.5912767,
                    56.0833014
                ],
                [
                    92.5908566,
                    56.0831941
                ],
                [
                    92.5900447,
                    56.0830948
                ],
                [
                    92.5896388,
                    56.0829517
                ],
                [
                    92.5889481,
                    56.0828206
                ],
                [
                    92.5888626,
                    56.0827411
                ],
                [
                    92.5888982,
                    56.0825345
                ],
                [
                    92.5886276,
                    56.0824431
                ],
                [
                    92.5884211,
                    56.0823994
                ],
                [
                    92.5876022,
                    56.0825702
                ],
                [
                    92.586534,
                    56.0825901
                ],
                [
                    92.5862135,
                    56.0827371
                ],
                [
                    92.5855299,
                    56.0827371
                ],
                [
                    92.5852521,
                    56.0826895
                ],
                [
                    92.5856224,
                    56.0822404
                ],
                [
                    92.5854658,
                    56.082161
                ],
                [
                    92.5848605,
                    56.082157
                ],
                [
                    92.5844902,
                    56.082304
                ],
                [
                    92.5842052,
                    56.0825345
                ],
                [
                    92.5837994,
                    56.0824391
                ],
                [
                    92.5839561,
                    56.0823318
                ],
                [
                    92.5837994,
                    56.0822603
                ],
                [
                    92.5831086,
                    56.0821689
                ],
                [
                    92.583056,
                    56.0818378
                ],
                [
                    92.5827364,
                    56.0817219
                ],
                [
                    92.5819104,
                    56.0817167
                ],
                [
                    92.5817447,
                    56.0818456
                ],
                [
                    92.581733,
                    56.0821164
                ],
                [
                    92.5811496,
                    56.0819862
                ],
                [
                    92.5811846,
                    56.0817701
                ],
                [
                    92.5810493,
                    56.0815097
                ],
                [
                    92.581425,
                    56.0815344
                ],
                [
                    92.5816677,
                    56.0814901
                ],
                [
                    92.582069,
                    56.0812453
                ],
                [
                    92.5820014,
                    56.0811086
                ],
                [
                    92.581754,
                    56.080981
                ],
                [
                    92.5814483,
                    56.0808833
                ],
                [
                    92.5812243,
                    56.0808898
                ],
                [
                    92.581117,
                    56.0810669
                ],
                [
                    92.581166,
                    56.081287
                ],
                [
                    92.581047,
                    56.0813586
                ],
                [
                    92.5809046,
                    56.0812779
                ],
                [
                    92.5808392,
                    56.0810174
                ],
                [
                    92.5806083,
                    56.0809432
                ],
                [
                    92.5804099,
                    56.0809536
                ],
                [
                    92.5802536,
                    56.0811776
                ],
                [
                    92.5799222,
                    56.0815735
                ],
                [
                    92.5798942,
                    56.0816568
                ],
                [
                    92.5797192,
                    56.0816008
                ],
                [
                    92.5793132,
                    56.0815682
                ],
                [
                    92.5791335,
                    56.0815305
                ],
                [
                    92.5785174,
                    56.0813534
                ],
                [
                    92.5773764,
                    56.0809654
                ],
                [
                    92.5769003,
                    56.0807271
                ],
                [
                    92.57659,
                    56.0805604
                ],
                [
                    92.576464,
                    56.0804198
                ],
                [
                    92.576485,
                    56.080158
                ],
                [
                    92.5771056,
                    56.0795242
                ],
                [
                    92.577098,
                    56.079368
                ],
                [
                    92.5769909,
                    56.0792532
                ],
                [
                    92.5767393,
                    56.0791478
                ],
                [
                    92.5763394,
                    56.079077
                ],
                [
                    92.5760749,
                    56.0790902
                ],
                [
                    92.5760221,
                    56.0791743
                ],
                [
                    92.5760603,
                    56.0792609
                ],
                [
                    92.5760603,
                    56.0794085
                ],
                [
                    92.575792,
                    56.0795105
                ],
                [
                    92.5755006,
                    56.0795028
                ],
                [
                    92.5752506,
                    56.079464
                ],
                [
                    92.5744487,
                    56.0792737
                ],
                [
                    92.5742007,
                    56.0791923
                ],
                [
                    92.574087,
                    56.0790768
                ],
                [
                    92.574084,
                    56.0785868
                ],
                [
                    92.5739528,
                    56.0784371
                ],
                [
                    92.5738216,
                    56.0783459
                ],
                [
                    92.5732148,
                    56.0781961
                ],
                [
                    92.5728211,
                    56.0781555
                ],
                [
                    92.5726169,
                    56.078175
                ],
                [
                    92.5722756,
                    56.0783622
                ],
                [
                    92.5721269,
                    56.0783703
                ],
                [
                    92.5719606,
                    56.0783247
                ],
                [
                    92.5718731,
                    56.0782303
                ],
                [
                    92.5718468,
                    56.077799
                ],
                [
                    92.5715289,
                    56.0772536
                ],
                [
                    92.5709076,
                    56.0773009
                ],
                [
                    92.5642019,
                    56.0778847
                ],
                [
                    92.5628455,
                    56.0787522
                ],
                [
                    92.5616206,
                    56.0790479
                ],
                [
                    92.5609655,
                    56.0795406
                ],
                [
                    92.5618827,
                    56.0797727
                ],
                [
                    92.5617163,
                    56.0803991
                ],
                [
                    92.5619683,
                    56.0805084
                ],
                [
                    92.5628907,
                    56.0807707
                ],
                [
                    92.5635151,
                    56.0809182
                ],
                [
                    92.5658304,
                    56.0813887
                ],
                [
                    92.5658304,
                    56.0814548
                ],
                [
                    92.5656116,
                    56.0817448
                ],
                [
                    92.565566,
                    56.0820728
                ],
                [
                    92.5651012,
                    56.082935
                ],
                [
                    92.5619346,
                    56.0819419
                ],
                [
                    92.5595608,
                    56.0832028
                ],
                [
                    92.5583049,
                    56.0828976
                ],
                [
                    92.5579762,
                    56.0831692
                ],
                [
                    92.5580832,
                    56.0833452
                ],
                [
                    92.5583317,
                    56.0836279
                ],
                [
                    92.5587219,
                    56.0840321
                ],
                [
                    92.5568756,
                    56.0857602
                ],
                [
                    92.5559167,
                    56.085569
                ],
                [
                    92.5558839,
                    56.0859107
                ],
                [
                    92.555738,
                    56.0861813
                ],
                [
                    92.5557709,
                    56.0865373
                ],
                [
                    92.5542942,
                    56.0865251
                ],
                [
                    92.5529126,
                    56.0864294
                ],
                [
                    92.5508887,
                    56.0864376
                ],
                [
                    92.5503819,
                    56.0863969
                ],
                [
                    92.5498496,
                    56.087351
                ],
                [
                    92.5520482,
                    56.0875728
                ],
                [
                    92.5520454,
                    56.0877283
                ],
                [
                    92.5497104,
                    56.0880821
                ],
                [
                    92.5488189,
                    56.0883854
                ],
                [
                    92.5482757,
                    56.089079
                ]
            ],
            "longitude": 92.5720813,
            "latitude": 56.0896885
        },
        "480": {
            "name": "Ойха",
            "population": 523,
            "type": "village",
            "poly": null,
            "longitude": 92.5756974,
            "latitude": 53.8659063
        },
        "481": {
            "name": "Первомайский",
            "population": 299,
            "type": "village",
            "poly": null,
            "longitude": 92.581993,
            "latitude": 56.56889
        },
        "482": {
            "name": "Слизнево",
            "population": 401,
            "type": "village",
            "poly": null,
            "longitude": 92.5880449,
            "latitude": 55.9574932
        },
        "483": {
            "name": "Маринино",
            "population": 686,
            "type": "village",
            "poly": null,
            "longitude": 92.5918256,
            "latitude": 54.0175494
        },
        "484": {
            "name": "Таскино",
            "population": 697,
            "type": "village",
            "poly": null,
            "longitude": 92.5944199,
            "latitude": 53.7135109
        },
        "485": {
            "name": "Мурино",
            "population": 411,
            "type": "village",
            "poly": null,
            "longitude": 92.5959955,
            "latitude": 53.8390051
        },
        "486": {
            "name": "Салба",
            "population": 575,
            "type": "village",
            "poly": null,
            "longitude": 92.6,
            "latitude": 53.2379951
        },
        "487": {
            "name": "Брагино",
            "population": 659,
            "type": "village",
            "poly": null,
            "longitude": 92.6039058,
            "latitude": 54.1100989
        },
        "488": {
            "name": "Новополтавка",
            "population": 507,
            "type": "village",
            "poly": null,
            "longitude": 92.6187064,
            "latitude": 53.3260741
        },
        "489": {
            "name": "Высокогорский",
            "population": 983,
            "type": "village",
            "poly": null,
            "longitude": 92.6213127,
            "latitude": 58.1683266
        },
        "490": {
            "name": "Тея",
            "population": 1534,
            "type": "village",
            "poly": null,
            "longitude": 92.6306,
            "latitude": 60.373081
        },
        "491": {
            "name": "Абалаково",
            "population": 983,
            "type": "village",
            "poly": null,
            "longitude": 92.6391156,
            "latitude": 58.0827072
        },
        "492": {
            "name": "Бурный",
            "population": 192,
            "type": "village",
            "poly": null,
            "longitude": 92.6443074,
            "latitude": 61.8153623
        },
        "493": {
            "name": "Гаревое",
            "population": 488,
            "type": "village",
            "poly": null,
            "longitude": 92.6484618,
            "latitude": 56.6445632
        },
        "494": {
            "name": "Бугачево",
            "population": 455,
            "type": "village",
            "poly": null,
            "longitude": 92.6543547,
            "latitude": 56.0456629
        },
        "495": {
            "name": "Весёлая Гора",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 92.6666123,
            "latitude": 56.1894195
        },
        "496": {
            "name": "Белый Яр",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 92.6691744,
            "latitude": 53.8396028
        },
        "497": {
            "name": "Минино",
            "population": 1067,
            "type": "village",
            "poly": null,
            "longitude": 92.6956189,
            "latitude": 56.0733284
        },
        "498": {
            "name": "Отношка",
            "population": 428,
            "type": "village",
            "poly": null,
            "longitude": 92.7101939,
            "latitude": 57.3798389
        },
        "499": {
            "name": "Абалаково",
            "population": 1451,
            "type": "village",
            "poly": null,
            "longitude": 92.72598,
            "latitude": 58.1112655
        },
        "500": {
            "name": "Черемушка",
            "population": 671,
            "type": "village",
            "poly": null,
            "longitude": 92.726852,
            "latitude": 53.532482
        },
        "501": {
            "name": "Талое",
            "population": 772,
            "type": "village",
            "poly": null,
            "longitude": 92.7461012,
            "latitude": 56.48294
        },
        "502": {
            "name": "Мостовское",
            "population": 375,
            "type": "village",
            "poly": null,
            "longitude": 92.7513073,
            "latitude": 56.7607379
        },
        "503": {
            "name": "Дрокино",
            "population": 1334,
            "type": "village",
            "poly": [
                [
                    92.7325477,
                    56.1031238
                ],
                [
                    92.7327193,
                    56.1066778
                ],
                [
                    92.7340068,
                    56.1095735
                ],
                [
                    92.7346934,
                    56.1103273
                ],
                [
                    92.7357234,
                    56.1105067
                ],
                [
                    92.7370323,
                    56.1108417
                ],
                [
                    92.7401222,
                    56.1112485
                ],
                [
                    92.7410878,
                    56.1109016
                ],
                [
                    92.7408732,
                    56.1098128
                ],
                [
                    92.741517,
                    56.109059
                ],
                [
                    92.7423753,
                    56.1085923
                ],
                [
                    92.7423967,
                    56.1078146
                ],
                [
                    92.7419461,
                    56.1071325
                ],
                [
                    92.7418603,
                    56.1064744
                ],
                [
                    92.742504,
                    56.1061394
                ],
                [
                    92.7430834,
                    56.1053376
                ],
                [
                    92.7456368,
                    56.1040572
                ],
                [
                    92.7481259,
                    56.1032555
                ],
                [
                    92.7487697,
                    56.1033632
                ],
                [
                    92.7519669,
                    56.1027768
                ],
                [
                    92.7546276,
                    56.1013527
                ],
                [
                    92.7550997,
                    56.1008859
                ],
                [
                    92.7550353,
                    56.1002995
                ],
                [
                    92.7555718,
                    56.099749
                ],
                [
                    92.7564086,
                    56.0994259
                ],
                [
                    92.7571382,
                    56.0982649
                ],
                [
                    92.7577604,
                    56.0979418
                ],
                [
                    92.7586831,
                    56.0978939
                ],
                [
                    92.7591981,
                    56.0981094
                ],
                [
                    92.7593698,
                    56.0987437
                ],
                [
                    92.7589835,
                    56.0991506
                ],
                [
                    92.7585758,
                    56.0997849
                ],
                [
                    92.7589835,
                    56.1001798
                ],
                [
                    92.7596273,
                    56.1002277
                ],
                [
                    92.7602924,
                    56.1002277
                ],
                [
                    92.761537,
                    56.0997729
                ],
                [
                    92.7625884,
                    56.0988514
                ],
                [
                    92.7643265,
                    56.0982889
                ],
                [
                    92.7664937,
                    56.0981333
                ],
                [
                    92.767867,
                    56.0980016
                ],
                [
                    92.7690472,
                    56.0976905
                ],
                [
                    92.7688755,
                    56.0968526
                ],
                [
                    92.7687897,
                    56.0961584
                ],
                [
                    92.7686609,
                    56.0948897
                ],
                [
                    92.7685751,
                    56.0945067
                ],
                [
                    92.7691759,
                    56.09398
                ],
                [
                    92.771429,
                    56.093968
                ],
                [
                    92.7720512,
                    56.0937167
                ],
                [
                    92.7721585,
                    56.0927232
                ],
                [
                    92.7724804,
                    56.0922084
                ],
                [
                    92.7728452,
                    56.0920049
                ],
                [
                    92.773167,
                    56.0921127
                ],
                [
                    92.7745832,
                    56.0918373
                ],
                [
                    92.7754201,
                    56.0914902
                ],
                [
                    92.7760638,
                    56.0914423
                ],
                [
                    92.7765359,
                    56.0912149
                ],
                [
                    92.7755274,
                    56.0908797
                ],
                [
                    92.7754982,
                    56.0907288
                ],
                [
                    92.7754416,
                    56.0904368
                ],
                [
                    92.7757634,
                    56.0898382
                ],
                [
                    92.7739181,
                    56.0885214
                ],
                [
                    92.7735049,
                    56.0882791
                ],
                [
                    92.7730812,
                    56.0880306
                ],
                [
                    92.773446,
                    56.0877073
                ],
                [
                    92.7723517,
                    56.0868094
                ],
                [
                    92.7729525,
                    56.0865939
                ],
                [
                    92.7722873,
                    56.0860552
                ],
                [
                    92.7731456,
                    56.0858636
                ],
                [
                    92.7728237,
                    56.0855523
                ],
                [
                    92.7726521,
                    56.0854087
                ],
                [
                    92.7733172,
                    56.085289
                ],
                [
                    92.7731456,
                    56.0849777
                ],
                [
                    92.7740039,
                    56.0848579
                ],
                [
                    92.7739181,
                    56.0846544
                ],
                [
                    92.774712,
                    56.0846065
                ],
                [
                    92.7731241,
                    56.0810385
                ],
                [
                    92.7723517,
                    56.0811103
                ],
                [
                    92.7722873,
                    56.0809427
                ],
                [
                    92.7695622,
                    56.0811941
                ],
                [
                    92.7678885,
                    56.0817928
                ],
                [
                    92.7675237,
                    56.0820802
                ],
                [
                    92.7661933,
                    56.0824035
                ],
                [
                    92.7665581,
                    56.0827747
                ],
                [
                    92.7659358,
                    56.0829303
                ],
                [
                    92.7661504,
                    56.0831817
                ],
                [
                    92.7646414,
                    56.0840132
                ],
                [
                    92.7644338,
                    56.0841276
                ],
                [
                    92.7616228,
                    56.085277
                ],
                [
                    92.7589406,
                    56.0864263
                ],
                [
                    92.7584042,
                    56.0867975
                ],
                [
                    92.7571596,
                    56.0877911
                ],
                [
                    92.7545847,
                    56.0903171
                ],
                [
                    92.751409,
                    56.0938962
                ],
                [
                    92.750379,
                    56.0950932
                ],
                [
                    92.7499284,
                    56.0949735
                ],
                [
                    92.7488555,
                    56.0945905
                ],
                [
                    92.7482547,
                    56.0947461
                ],
                [
                    92.7481474,
                    56.0949136
                ],
                [
                    92.7451433,
                    56.0961106
                ],
                [
                    92.7448644,
                    56.0968407
                ],
                [
                    92.7434696,
                    56.0973553
                ],
                [
                    92.7434482,
                    56.0974511
                ],
                [
                    92.7438129,
                    56.0979298
                ],
                [
                    92.7437486,
                    56.0980615
                ],
                [
                    92.7431478,
                    56.0983128
                ],
                [
                    92.7430619,
                    56.0983966
                ],
                [
                    92.7432336,
                    56.0988394
                ],
                [
                    92.7411737,
                    56.0994498
                ],
                [
                    92.740723,
                    56.0994498
                ],
                [
                    92.7384271,
                    56.100503
                ],
                [
                    92.7375688,
                    56.0999525
                ],
                [
                    92.7370109,
                    56.0995575
                ],
                [
                    92.7356161,
                    56.0996054
                ],
                [
                    92.7333631,
                    56.1014963
                ],
                [
                    92.7325477,
                    56.1031238
                ]
            ],
            "longitude": 92.7554055,
            "latitude": 56.0952596
        },
        "504": {
            "name": "Логовой",
            "population": 523,
            "type": "village",
            "poly": null,
            "longitude": 92.7604132,
            "latitude": 56.1253118
        },
        "505": {
            "name": "Лебедевка",
            "population": 198,
            "type": "village",
            "poly": null,
            "longitude": 92.7634271,
            "latitude": 53.5907951
        },
        "506": {
            "name": "Творогово",
            "population": 542,
            "type": "village",
            "poly": null,
            "longitude": 92.76889,
            "latitude": 56.137268
        },
        "507": {
            "name": "Талажанка",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 92.7715637,
            "latitude": 57.5159353
        },
        "508": {
            "name": "Золотая Горка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 92.7804285,
            "latitude": 56.4592715
        },
        "509": {
            "name": "Красные Ключи",
            "population": 393,
            "type": "village",
            "poly": null,
            "longitude": 92.7862515,
            "latitude": 56.9275014
        },
        "510": {
            "name": "Рощинский",
            "population": 1259,
            "type": "village",
            "poly": null,
            "longitude": 92.7884448,
            "latitude": 53.8781844
        },
        "511": {
            "name": "Верх-Казанка",
            "population": 609,
            "type": "village",
            "poly": null,
            "longitude": 92.7904906,
            "latitude": 57.0479328
        },
        "512": {
            "name": "Сагайское",
            "population": 562,
            "type": "village",
            "poly": null,
            "longitude": 92.793053,
            "latitude": 53.646313
        },
        "513": {
            "name": "Берёзовское",
            "population": 1324,
            "type": "village",
            "poly": null,
            "longitude": 92.8057372,
            "latitude": 53.9317288
        },
        "514": {
            "name": "Уджей",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 92.814102,
            "latitude": 53.739208
        },
        "515": {
            "name": "Усть-Авам",
            "population": 513,
            "type": "village",
            "poly": null,
            "longitude": 92.824127,
            "latitude": 71.113937
        },
        "516": {
            "name": "Устюг",
            "population": 1022,
            "type": "village",
            "poly": null,
            "longitude": 92.838127,
            "latitude": 56.371014
        },
        "517": {
            "name": "Арей",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 92.8411815,
            "latitude": 56.2333152
        },
        "518": {
            "name": "Матвеевка",
            "population": 361,
            "type": "village",
            "poly": null,
            "longitude": 92.8446824,
            "latitude": 57.5297177
        },
        "519": {
            "name": "Григорьевка",
            "population": 642,
            "type": "village",
            "poly": null,
            "longitude": 92.8449585,
            "latitude": 53.2242739
        },
        "520": {
            "name": "Солонцы",
            "population": 3786,
            "type": "village",
            "poly": [
                [
                    92.7858056,
                    56.0713248
                ],
                [
                    92.7956472,
                    56.0730913
                ],
                [
                    92.7969346,
                    56.0751991
                ],
                [
                    92.8090614,
                    56.0731877
                ],
                [
                    92.8092951,
                    56.0737022
                ],
                [
                    92.809173,
                    56.084154
                ],
                [
                    92.8209346,
                    56.0920986
                ],
                [
                    92.8252502,
                    56.0929548
                ],
                [
                    92.831415,
                    56.0991764
                ],
                [
                    92.8400002,
                    56.1003397
                ],
                [
                    92.8535657,
                    56.0992266
                ],
                [
                    92.8633633,
                    56.0929788
                ],
                [
                    92.8601489,
                    56.0907523
                ],
                [
                    92.8570665,
                    56.0883562
                ],
                [
                    92.8579034,
                    56.0845132
                ],
                [
                    92.8638611,
                    56.0812463
                ],
                [
                    92.8586329,
                    56.0774127
                ],
                [
                    92.8588336,
                    56.0759954
                ],
                [
                    92.8683123,
                    56.0766627
                ],
                [
                    92.869018,
                    56.070521
                ],
                [
                    92.8710433,
                    56.0665983
                ],
                [
                    92.870996,
                    56.0652334
                ],
                [
                    92.869498,
                    56.064825
                ],
                [
                    92.8713177,
                    56.0597642
                ],
                [
                    92.8630956,
                    56.0572947
                ],
                [
                    92.8581196,
                    56.0558075
                ],
                [
                    92.8552888,
                    56.0552851
                ],
                [
                    92.8523727,
                    56.0549855
                ],
                [
                    92.8499909,
                    56.0550892
                ],
                [
                    92.84941,
                    56.054032
                ],
                [
                    92.85019,
                    56.053012
                ],
                [
                    92.85013,
                    56.052293
                ],
                [
                    92.847881,
                    56.051213
                ],
                [
                    92.846203,
                    56.051213
                ],
                [
                    92.845603,
                    56.050674
                ],
                [
                    92.846023,
                    56.049834
                ],
                [
                    92.848001,
                    56.050014
                ],
                [
                    92.849081,
                    56.049534
                ],
                [
                    92.848121,
                    56.047915
                ],
                [
                    92.846562,
                    56.047496
                ],
                [
                    92.8464445,
                    56.0466749
                ],
                [
                    92.8445218,
                    56.044692
                ],
                [
                    92.8426239,
                    56.0438359
                ],
                [
                    92.8411926,
                    56.0427624
                ],
                [
                    92.8393736,
                    56.0423488
                ],
                [
                    92.8381055,
                    56.0416117
                ],
                [
                    92.8380379,
                    56.0420576
                ],
                [
                    92.837915,
                    56.0423344
                ],
                [
                    92.8357376,
                    56.0466404
                ],
                [
                    92.8354951,
                    56.0474044
                ],
                [
                    92.835302,
                    56.0484524
                ],
                [
                    92.83412,
                    56.048395
                ],
                [
                    92.833101,
                    56.048935
                ],
                [
                    92.83364,
                    56.049474
                ],
                [
                    92.832621,
                    56.050854
                ],
                [
                    92.8234155,
                    56.0502368
                ],
                [
                    92.808516,
                    56.047855
                ],
                [
                    92.804109,
                    56.046776
                ],
                [
                    92.8036849,
                    56.0472527
                ],
                [
                    92.8027958,
                    56.0482521
                ],
                [
                    92.797334,
                    56.054391
                ],
                [
                    92.797693,
                    56.057809
                ],
                [
                    92.794755,
                    56.059248
                ],
                [
                    92.7858056,
                    56.0713248
                ]
            ],
            "longitude": 92.8492582,
            "latitude": 56.0675351
        },
        "521": {
            "name": "Вороковка",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 92.853264,
            "latitude": 57.595745
        },
        "522": {
            "name": "Бугуртак",
            "population": 444,
            "type": "village",
            "poly": null,
            "longitude": 92.8672675,
            "latitude": 53.8106363
        },
        "523": {
            "name": "Старая Копь",
            "population": 304,
            "type": "village",
            "poly": null,
            "longitude": 92.890633,
            "latitude": 53.653343
        },
        "524": {
            "name": "Шуваево",
            "population": 1101,
            "type": "village",
            "poly": null,
            "longitude": 92.8960311,
            "latitude": 56.1879537
        },
        "525": {
            "name": "Борск",
            "population": 817,
            "type": "village",
            "poly": null,
            "longitude": 92.904335,
            "latitude": 56.441799
        },
        "526": {
            "name": "Сухая Балка",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 92.90464,
            "latitude": 56.137848
        },
        "527": {
            "name": "Качулька",
            "population": 632,
            "type": "village",
            "poly": null,
            "longitude": 92.9111927,
            "latitude": 53.7628549
        },
        "528": {
            "name": "Курское",
            "population": 229,
            "type": "village",
            "poly": null,
            "longitude": 92.91226,
            "latitude": 53.9864945
        },
        "529": {
            "name": "Шилинка",
            "population": 822,
            "type": "village",
            "poly": null,
            "longitude": 92.9175189,
            "latitude": 56.5354881
        },
        "530": {
            "name": "Еруда",
            "population": 679,
            "type": "village",
            "poly": null,
            "longitude": 92.9177675,
            "latitude": 59.880324
        },
        "531": {
            "name": "Большая Ирба",
            "population": 4269,
            "type": "village",
            "poly": null,
            "longitude": 92.932541,
            "latitude": 54.080906
        },
        "532": {
            "name": "Моторское",
            "population": 1099,
            "type": "village",
            "poly": null,
            "longitude": 92.938141,
            "latitude": 53.404842
        },
        "533": {
            "name": "Танзыбей",
            "population": 1463,
            "type": "village",
            "poly": [
                [
                    92.9248302,
                    53.1364224
                ],
                [
                    92.9262892,
                    53.138173
                ],
                [
                    92.9285639,
                    53.1388939
                ],
                [
                    92.9308597,
                    53.1402712
                ],
                [
                    92.9339035,
                    53.1407049
                ],
                [
                    92.937766,
                    53.1414386
                ],
                [
                    92.9406015,
                    53.1411722
                ],
                [
                    92.9436486,
                    53.1408632
                ],
                [
                    92.9446786,
                    53.1413266
                ],
                [
                    92.9447183,
                    53.1418119
                ],
                [
                    92.9449146,
                    53.1420345
                ],
                [
                    92.9461162,
                    53.141983
                ],
                [
                    92.9466527,
                    53.1424979
                ],
                [
                    92.946717,
                    53.1429998
                ],
                [
                    92.9482373,
                    53.1434336
                ],
                [
                    92.9500215,
                    53.1428968
                ],
                [
                    92.9498713,
                    53.141584
                ],
                [
                    92.9506223,
                    53.1400008
                ],
                [
                    92.9504077,
                    53.1387394
                ],
                [
                    92.9501073,
                    53.1380186
                ],
                [
                    92.9488628,
                    53.1361263
                ],
                [
                    92.9494851,
                    53.1345687
                ],
                [
                    92.9493349,
                    53.132393
                ],
                [
                    92.9494636,
                    53.1311056
                ],
                [
                    92.9500611,
                    53.1297371
                ],
                [
                    92.9497211,
                    53.1287624
                ],
                [
                    92.9491632,
                    53.1275521
                ],
                [
                    92.9493563,
                    53.1258268
                ],
                [
                    92.9493563,
                    53.124256
                ],
                [
                    92.9494421,
                    53.1232001
                ],
                [
                    92.9495065,
                    53.121848
                ],
                [
                    92.9491847,
                    53.1211526
                ],
                [
                    92.9471891,
                    53.1201482
                ],
                [
                    92.9466312,
                    53.119118
                ],
                [
                    92.9466098,
                    53.1183711
                ],
                [
                    92.9461806,
                    53.11774
                ],
                [
                    92.9461377,
                    53.1164522
                ],
                [
                    92.9481762,
                    53.1155378
                ],
                [
                    92.9482835,
                    53.1146362
                ],
                [
                    92.9473393,
                    53.1127043
                ],
                [
                    92.9465454,
                    53.1119958
                ],
                [
                    92.9463093,
                    53.1102056
                ],
                [
                    92.9463952,
                    53.1091493
                ],
                [
                    92.9458372,
                    53.1063155
                ],
                [
                    92.9437988,
                    53.1052591
                ],
                [
                    92.9422968,
                    53.1037777
                ],
                [
                    92.941653,
                    53.1025538
                ],
                [
                    92.9404514,
                    53.1014588
                ],
                [
                    92.9399793,
                    53.1008146
                ],
                [
                    92.9397004,
                    53.0990109
                ],
                [
                    92.9407947,
                    53.0971169
                ],
                [
                    92.9435198,
                    53.0960604
                ],
                [
                    92.9426401,
                    53.0947203
                ],
                [
                    92.9397218,
                    53.0946173
                ],
                [
                    92.9369538,
                    53.0946173
                ],
                [
                    92.9367606,
                    53.0960475
                ],
                [
                    92.9373186,
                    53.0987403
                ],
                [
                    92.9381736,
                    53.1007077
                ],
                [
                    92.9385599,
                    53.1028849
                ],
                [
                    92.9379623,
                    53.1042414
                ],
                [
                    92.9384773,
                    53.1064314
                ],
                [
                    92.9404299,
                    53.1072816
                ],
                [
                    92.9406842,
                    53.1092356
                ],
                [
                    92.9414996,
                    53.1111935
                ],
                [
                    92.9397186,
                    53.1136664
                ],
                [
                    92.9392251,
                    53.1153665
                ],
                [
                    92.9401081,
                    53.1178817
                ],
                [
                    92.9398291,
                    53.1190922
                ],
                [
                    92.9381983,
                    53.1203542
                ],
                [
                    92.9376834,
                    53.1215647
                ],
                [
                    92.9362886,
                    53.1218995
                ],
                [
                    92.9347866,
                    53.1227752
                ],
                [
                    92.9346975,
                    53.1236212
                ],
                [
                    92.9357704,
                    53.1241748
                ],
                [
                    92.9377906,
                    53.1249513
                ],
                [
                    92.937383,
                    53.1264191
                ],
                [
                    92.9372971,
                    53.1270371
                ],
                [
                    92.9376404,
                    53.1280801
                ],
                [
                    92.9356234,
                    53.1291101
                ],
                [
                    92.9340141,
                    53.130861
                ],
                [
                    92.9335817,
                    53.132505
                ],
                [
                    92.9324691,
                    53.1332298
                ],
                [
                    92.930023,
                    53.1342082
                ],
                [
                    92.9263323,
                    53.1348519
                ],
                [
                    92.9248302,
                    53.1364224
                ]
            ],
            "longitude": 92.94384,
            "latitude": 53.130917
        },
        "534": {
            "name": "Новокаргино",
            "population": 963,
            "type": "village",
            "poly": null,
            "longitude": 92.949288,
            "latitude": 58.0205104
        },
        "535": {
            "name": "Таскино",
            "population": 908,
            "type": "village",
            "poly": null,
            "longitude": 92.9529985,
            "latitude": 56.3184611
        },
        "536": {
            "name": "Совхоз «Сибиряк»",
            "population": 480,
            "type": "village",
            "poly": [
                [
                    92.9380262,
                    56.26135
                ],
                [
                    92.9390604,
                    56.2621604
                ],
                [
                    92.9398285,
                    56.2626281
                ],
                [
                    92.9399631,
                    56.263314
                ],
                [
                    92.9406367,
                    56.2636383
                ],
                [
                    92.9411084,
                    56.2641994
                ],
                [
                    92.9407042,
                    56.2649726
                ],
                [
                    92.9399406,
                    56.2658081
                ],
                [
                    92.9394916,
                    56.2661572
                ],
                [
                    92.9399406,
                    56.2664565
                ],
                [
                    92.939806,
                    56.2669553
                ],
                [
                    92.9411308,
                    56.266868
                ],
                [
                    92.9429496,
                    56.2665937
                ],
                [
                    92.9434348,
                    56.2666119
                ],
                [
                    92.9446112,
                    56.266656
                ],
                [
                    92.9451534,
                    56.266817
                ],
                [
                    92.9455768,
                    56.2669428
                ],
                [
                    92.9460571,
                    56.2669266
                ],
                [
                    92.9463987,
                    56.2669151
                ],
                [
                    92.9470587,
                    56.2668929
                ],
                [
                    92.9486958,
                    56.2667679
                ],
                [
                    92.9488551,
                    56.2667558
                ],
                [
                    92.9497511,
                    56.2666994
                ],
                [
                    92.95021,
                    56.2666706
                ],
                [
                    92.9506111,
                    56.2666454
                ],
                [
                    92.9509843,
                    56.2666219
                ],
                [
                    92.9512352,
                    56.2666061
                ],
                [
                    92.9517452,
                    56.2663954
                ],
                [
                    92.9522008,
                    56.2662071
                ],
                [
                    92.9523549,
                    56.2659564
                ],
                [
                    92.9525151,
                    56.2656958
                ],
                [
                    92.952758,
                    56.2657363
                ],
                [
                    92.9536379,
                    56.2658829
                ],
                [
                    92.9550524,
                    56.2652344
                ],
                [
                    92.9552992,
                    56.2650808
                ],
                [
                    92.9557935,
                    56.2647731
                ],
                [
                    92.9568264,
                    56.2646484
                ],
                [
                    92.9575225,
                    56.2641745
                ],
                [
                    92.9587126,
                    56.2637006
                ],
                [
                    92.9592505,
                    56.2634818
                ],
                [
                    92.9594502,
                    56.2634006
                ],
                [
                    92.9603068,
                    56.2630521
                ],
                [
                    92.9608456,
                    56.2625782
                ],
                [
                    92.9606212,
                    56.2614434
                ],
                [
                    92.9603068,
                    56.260508
                ],
                [
                    92.959476,
                    56.2593731
                ],
                [
                    92.9572306,
                    56.2586871
                ],
                [
                    92.9565345,
                    56.256941
                ],
                [
                    92.9554342,
                    56.255544
                ],
                [
                    92.9538175,
                    56.2550077
                ],
                [
                    92.951617,
                    56.2550326
                ],
                [
                    92.9469322,
                    56.2554145
                ],
                [
                    92.9475148,
                    56.2570594
                ],
                [
                    92.941807,
                    56.2578222
                ],
                [
                    92.940644,
                    56.2587042
                ],
                [
                    92.9394853,
                    56.2587995
                ],
                [
                    92.939275,
                    56.2602535
                ],
                [
                    92.9380262,
                    56.26135
                ]
            ],
            "longitude": 92.9536307,
            "latitude": 56.2627282
        },
        "537": {
            "name": "Шарье",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 92.9668668,
            "latitude": 56.1805104
        },
        "538": {
            "name": "Межово",
            "population": 555,
            "type": "village",
            "poly": null,
            "longitude": 92.9733246,
            "latitude": 56.7514977
        },
        "539": {
            "name": "Старцево",
            "population": 3424,
            "type": "village",
            "poly": null,
            "longitude": 92.9834366,
            "latitude": 56.1653984
        },
        "540": {
            "name": "Айтат",
            "population": 232,
            "type": "village",
            "poly": null,
            "longitude": 92.98719,
            "latitude": 57.009253
        },
        "541": {
            "name": "Миндерла",
            "population": 2313,
            "type": "village",
            "poly": null,
            "longitude": 92.998474,
            "latitude": 56.437431
        },
        "542": {
            "name": "Лакино",
            "population": 502,
            "type": "village",
            "poly": null,
            "longitude": 93.0074441,
            "latitude": 56.7979609
        },
        "543": {
            "name": "Нижнеусинское",
            "population": 392,
            "type": "village",
            "poly": null,
            "longitude": 93.0111013,
            "latitude": 52.2592124
        },
        "544": {
            "name": "Верхнеусинское",
            "population": 1393,
            "type": "village",
            "poly": null,
            "longitude": 93.025047,
            "latitude": 52.240841
        },
        "545": {
            "name": "Шапкино",
            "population": 718,
            "type": "village",
            "poly": null,
            "longitude": 93.039426,
            "latitude": 57.8938979
        },
        "546": {
            "name": "Кузнецово",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 93.047523,
            "latitude": 55.945637
        },
        "547": {
            "name": "Шила",
            "population": 1722,
            "type": "village",
            "poly": null,
            "longitude": 93.047783,
            "latitude": 56.552422
        },
        "548": {
            "name": "Новая Калами",
            "population": 639,
            "type": "village",
            "poly": null,
            "longitude": 93.05249,
            "latitude": 60.171886
        },
        "549": {
            "name": "Красный Пахарь",
            "population": 293,
            "type": "village",
            "poly": null,
            "longitude": 93.065236,
            "latitude": 56.2848219
        },
        "550": {
            "name": "Нижний Кужебар",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 93.0785223,
            "latitude": 53.5350091
        },
        "551": {
            "name": "Песчанка",
            "population": 765,
            "type": "village",
            "poly": null,
            "longitude": 93.0818319,
            "latitude": 56.0831621
        },
        "552": {
            "name": "Дудовка",
            "population": 411,
            "type": "village",
            "poly": null,
            "longitude": 93.089176,
            "latitude": 57.4575376
        },
        "553": {
            "name": "Жербатиха",
            "population": 298,
            "type": "village",
            "poly": null,
            "longitude": 93.103439,
            "latitude": 53.863697
        },
        "554": {
            "name": "Кубеково",
            "population": 303,
            "type": "village",
            "poly": null,
            "longitude": 93.1142225,
            "latitude": 56.1483926
        },
        "555": {
            "name": "Малый Кантат",
            "population": 293,
            "type": "village",
            "poly": null,
            "longitude": 93.1175479,
            "latitude": 56.9517279
        },
        "556": {
            "name": "Ширыштык",
            "population": 549,
            "type": "village",
            "poly": null,
            "longitude": 93.118492,
            "latitude": 53.352016
        },
        "557": {
            "name": "Большой Кантат",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 93.1313419,
            "latitude": 57.0501731
        },
        "558": {
            "name": "Бартат",
            "population": 728,
            "type": "village",
            "poly": null,
            "longitude": 93.1390729,
            "latitude": 56.7217234
        },
        "559": {
            "name": "Раздольное",
            "population": 521,
            "type": "village",
            "poly": null,
            "longitude": 93.1440233,
            "latitude": 57.2371125
        },
        "560": {
            "name": "Ермолаевский Затон",
            "population": 775,
            "type": "village",
            "poly": null,
            "longitude": 93.145233,
            "latitude": 56.143478
        },
        "561": {
            "name": "Рождественское",
            "population": 548,
            "type": "village",
            "poly": null,
            "longitude": 93.145859,
            "latitude": 57.618469
        },
        "562": {
            "name": "Ермолаево",
            "population": 439,
            "type": "village",
            "poly": null,
            "longitude": 93.150597,
            "latitude": 56.130852
        },
        "563": {
            "name": "Тигино",
            "population": 323,
            "type": "village",
            "poly": null,
            "longitude": 93.15387,
            "latitude": 56.808899
        },
        "564": {
            "name": "Таловка",
            "population": 822,
            "type": "village",
            "poly": null,
            "longitude": 93.154689,
            "latitude": 57.1585285
        },
        "565": {
            "name": "Зыково",
            "population": 5924,
            "type": "village",
            "poly": null,
            "longitude": 93.164253,
            "latitude": 55.959805
        },
        "566": {
            "name": "Имисское",
            "population": 870,
            "type": "village",
            "poly": null,
            "longitude": 93.1644157,
            "latitude": 53.9054967
        },
        "567": {
            "name": "Пятково",
            "population": 231,
            "type": "village",
            "poly": null,
            "longitude": 93.1944186,
            "latitude": 57.4110214
        },
        "568": {
            "name": "Нижние Куряты",
            "population": 489,
            "type": "village",
            "poly": null,
            "longitude": 93.1954708,
            "latitude": 53.780933
        },
        "569": {
            "name": "Мокрушинское",
            "population": 787,
            "type": "village",
            "poly": null,
            "longitude": 93.1969242,
            "latitude": 57.5193527
        },
        "570": {
            "name": "Подсопки",
            "population": 432,
            "type": "village",
            "poly": null,
            "longitude": 93.20546,
            "latitude": 56.423412
        },
        "571": {
            "name": "Челноки",
            "population": 308,
            "type": "village",
            "poly": null,
            "longitude": 93.2086477,
            "latitude": 57.5767983
        },
        "572": {
            "name": "Верхний Кужебар",
            "population": 956,
            "type": "village",
            "poly": null,
            "longitude": 93.2415549,
            "latitude": 53.3686118
        },
        "573": {
            "name": "Журавлево",
            "population": 662,
            "type": "village",
            "poly": null,
            "longitude": 93.2505345,
            "latitude": 54.1606213
        },
        "574": {
            "name": "Маганск",
            "population": 831,
            "type": "village",
            "poly": null,
            "longitude": 93.263618,
            "latitude": 55.865284
        },
        "575": {
            "name": "Вознесенка",
            "population": 1236,
            "type": "village",
            "poly": [
                [
                    93.2526088,
                    56.0016436
                ],
                [
                    93.2637714,
                    56.0104198
                ],
                [
                    93.261308,
                    56.0118905
                ],
                [
                    93.2588832,
                    56.0126821
                ],
                [
                    93.2601021,
                    56.0136945
                ],
                [
                    93.2655524,
                    56.0115834
                ],
                [
                    93.268432,
                    56.0135578
                ],
                [
                    93.2711335,
                    56.0123709
                ],
                [
                    93.2835124,
                    56.0092082
                ],
                [
                    93.2785235,
                    56.0047448
                ],
                [
                    93.2793711,
                    56.0025738
                ],
                [
                    93.2790278,
                    56.001386
                ],
                [
                    93.2779807,
                    56.0004813
                ],
                [
                    93.2690661,
                    55.9984252
                ],
                [
                    93.2687066,
                    55.9951462
                ],
                [
                    93.263368,
                    55.9953334
                ],
                [
                    93.2609432,
                    55.9973494
                ],
                [
                    93.25854,
                    55.9989334
                ],
                [
                    93.2526088,
                    56.0016436
                ]
            ],
            "longitude": 93.264992,
            "latitude": 56.002419
        },
        "576": {
            "name": "Еловка",
            "population": 344,
            "type": "village",
            "poly": null,
            "longitude": 93.2694573,
            "latitude": 56.7556672
        },
        "577": {
            "name": "Галанино",
            "population": 1417,
            "type": "village",
            "poly": null,
            "longitude": 93.2707862,
            "latitude": 57.6204506
        },
        "578": {
            "name": "Есаулово",
            "population": 1769,
            "type": "village",
            "poly": null,
            "longitude": 93.271797,
            "latitude": 56.142456
        },
        "579": {
            "name": "Кордово",
            "population": 1042,
            "type": "village",
            "poly": null,
            "longitude": 93.280478,
            "latitude": 54.0943365
        },
        "580": {
            "name": "Березовский",
            "population": 1339,
            "type": "village",
            "poly": null,
            "longitude": 93.2823303,
            "latitude": 55.8066885
        },
        "581": {
            "name": "Терентьево",
            "population": 346,
            "type": "village",
            "poly": null,
            "longitude": 93.296623,
            "latitude": 56.11422
        },
        "582": {
            "name": "Комарово",
            "population": 333,
            "type": "village",
            "poly": null,
            "longitude": 93.2994325,
            "latitude": 56.901013
        },
        "583": {
            "name": "Захаровка",
            "population": 63,
            "type": "village",
            "poly": null,
            "longitude": 93.3010756,
            "latitude": 57.8017099
        },
        "584": {
            "name": "Российка",
            "population": 685,
            "type": "village",
            "poly": null,
            "longitude": 93.3169055,
            "latitude": 57.0529829
        },
        "585": {
            "name": "Момотово",
            "population": 734,
            "type": "village",
            "poly": null,
            "longitude": 93.3190621,
            "latitude": 57.6250033
        },
        "586": {
            "name": "Киндяково",
            "population": 608,
            "type": "village",
            "poly": null,
            "longitude": 93.3250542,
            "latitude": 56.0641577
        },
        "587": {
            "name": "Пакуль",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 93.3283113,
            "latitude": 56.847007
        },
        "588": {
            "name": "Челноково",
            "population": 412,
            "type": "village",
            "poly": [
                [
                    93.3167587,
                    56.0372397
                ],
                [
                    93.318647,
                    56.03887
                ],
                [
                    93.3229385,
                    56.0416029
                ],
                [
                    93.3261357,
                    56.0455006
                ],
                [
                    93.3287106,
                    56.0469387
                ],
                [
                    93.3322297,
                    56.0471305
                ],
                [
                    93.3354698,
                    56.047641
                ],
                [
                    93.3372937,
                    56.0474181
                ],
                [
                    93.3395038,
                    56.0465888
                ],
                [
                    93.3413063,
                    56.0452465
                ],
                [
                    93.3366929,
                    56.0428159
                ],
                [
                    93.3323155,
                    56.0416652
                ],
                [
                    93.3295689,
                    56.0404187
                ],
                [
                    93.3295689,
                    56.0384528
                ],
                [
                    93.32929,
                    56.0362328
                ],
                [
                    93.3272301,
                    56.0348901
                ],
                [
                    93.3211361,
                    56.0348422
                ],
                [
                    93.3175312,
                    56.035993
                ],
                [
                    93.3167587,
                    56.0372397
                ]
            ],
            "longitude": 93.329056,
            "latitude": 56.042835
        },
        "589": {
            "name": "Можарка",
            "population": 682,
            "type": "village",
            "poly": null,
            "longitude": 93.3352738,
            "latitude": 53.9645711
        },
        "590": {
            "name": "Частоостровское",
            "population": 1283,
            "type": "village",
            "poly": null,
            "longitude": 93.339455,
            "latitude": 56.197365
        },
        "591": {
            "name": "Пискуновка",
            "population": 309,
            "type": "village",
            "poly": null,
            "longitude": 93.3413439,
            "latitude": 57.5550538
        },
        "592": {
            "name": "Бузим",
            "population": 483,
            "type": "village",
            "poly": null,
            "longitude": 93.358047,
            "latitude": 56.504944
        },
        "593": {
            "name": "Бархатово",
            "population": 1513,
            "type": "village",
            "poly": null,
            "longitude": 93.359413,
            "latitude": 56.044079
        },
        "594": {
            "name": "Тартат",
            "population": 564,
            "type": "village",
            "poly": null,
            "longitude": 93.3745756,
            "latitude": 56.1701822
        },
        "595": {
            "name": "Кошурниково",
            "population": 3339,
            "type": "village",
            "poly": [
                [
                    93.3603776,
                    54.3096456
                ],
                [
                    93.3604416,
                    54.3101605
                ],
                [
                    93.3606974,
                    54.310571
                ],
                [
                    93.3605567,
                    54.3114217
                ],
                [
                    93.360659,
                    54.3116605
                ],
                [
                    93.3615288,
                    54.3118321
                ],
                [
                    93.3620149,
                    54.3121306
                ],
                [
                    93.3623603,
                    54.3125634
                ],
                [
                    93.362258,
                    54.3129962
                ],
                [
                    93.36213,
                    54.3137797
                ],
                [
                    93.3621812,
                    54.3151004
                ],
                [
                    93.3622452,
                    54.3156973
                ],
                [
                    93.3621556,
                    54.3168837
                ],
                [
                    93.3657116,
                    54.3226583
                ],
                [
                    93.3670803,
                    54.3247173
                ],
                [
                    93.3676018,
                    54.3254325
                ],
                [
                    93.3696706,
                    54.3259814
                ],
                [
                    93.3781461,
                    54.3282301
                ],
                [
                    93.3821493,
                    54.3276954
                ],
                [
                    93.3824358,
                    54.3263969
                ],
                [
                    93.3882564,
                    54.3242866
                ],
                [
                    93.3851783,
                    54.3191873
                ],
                [
                    93.3849649,
                    54.3191833
                ],
                [
                    93.3848255,
                    54.3191136
                ],
                [
                    93.3882475,
                    54.3165684
                ],
                [
                    93.3893035,
                    54.3159763
                ],
                [
                    93.3911782,
                    54.3152648
                ],
                [
                    93.3927091,
                    54.3146631
                ],
                [
                    93.3931185,
                    54.313899
                ],
                [
                    93.393536,
                    54.313431
                ],
                [
                    93.3956972,
                    54.3125045
                ],
                [
                    93.3993648,
                    54.3110574
                ],
                [
                    93.3994303,
                    54.3119123
                ],
                [
                    93.4032779,
                    54.3108616
                ],
                [
                    93.4033926,
                    54.3084545
                ],
                [
                    93.402813,
                    54.3070441
                ],
                [
                    93.4023935,
                    54.3069247
                ],
                [
                    93.4021274,
                    54.3066023
                ],
                [
                    93.4023423,
                    54.3061425
                ],
                [
                    93.4025142,
                    54.3040089
                ],
                [
                    93.4038445,
                    54.3026729
                ],
                [
                    93.4046888,
                    54.3022699
                ],
                [
                    93.4047783,
                    54.3009637
                ],
                [
                    93.4046504,
                    54.3004636
                ],
                [
                    93.4035248,
                    54.2974628
                ],
                [
                    93.4037038,
                    54.2968432
                ],
                [
                    93.4036271,
                    54.296582
                ],
                [
                    93.4031922,
                    54.2965745
                ],
                [
                    93.4014014,
                    54.296246
                ],
                [
                    93.4008641,
                    54.2964401
                ],
                [
                    93.4002373,
                    54.2964028
                ],
                [
                    93.3994443,
                    54.2961191
                ],
                [
                    93.4004548,
                    54.2954249
                ],
                [
                    93.3994827,
                    54.2942006
                ],
                [
                    93.3980628,
                    54.2939094
                ],
                [
                    93.3972058,
                    54.2940662
                ],
                [
                    93.3962848,
                    54.2932524
                ],
                [
                    93.3950568,
                    54.291065
                ],
                [
                    93.3928311,
                    54.2898555
                ],
                [
                    93.3906949,
                    54.2894224
                ],
                [
                    93.3862407,
                    54.2901769
                ],
                [
                    93.3781081,
                    54.2890193
                ],
                [
                    93.3763713,
                    54.288358
                ],
                [
                    93.3761226,
                    54.2862714
                ],
                [
                    93.3743459,
                    54.2862587
                ],
                [
                    93.3747808,
                    54.2897978
                ],
                [
                    93.3745633,
                    54.2898575
                ],
                [
                    93.3739493,
                    54.2925527
                ],
                [
                    93.3734761,
                    54.2928588
                ],
                [
                    93.3726574,
                    54.2932769
                ],
                [
                    93.3704061,
                    54.2934038
                ],
                [
                    93.3677839,
                    54.2934188
                ],
                [
                    93.3662617,
                    54.2933964
                ],
                [
                    93.3642023,
                    54.2934337
                ],
                [
                    93.360966,
                    54.2957853
                ],
                [
                    93.361823,
                    54.2968528
                ],
                [
                    93.3629103,
                    54.2977933
                ],
                [
                    93.3630766,
                    54.3062052
                ],
                [
                    93.3614137,
                    54.3074889
                ],
                [
                    93.3608765,
                    54.3081605
                ],
                [
                    93.3604032,
                    54.3090188
                ],
                [
                    93.3603776,
                    54.3096456
                ]
            ],
            "longitude": 93.394783,
            "latitude": 54.300556
        },
        "596": {
            "name": "Седельниково",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 93.40061589049061,
            "latitude": 56.52268590033301
        },
        "597": {
            "name": "Большой Унгут",
            "population": 463,
            "type": "village",
            "poly": null,
            "longitude": 93.404961,
            "latitude": 55.421055
        },
        "598": {
            "name": "Высотино",
            "population": 986,
            "type": "village",
            "poly": null,
            "longitude": 93.4008703294754,
            "latitude": 56.549764638263476
        },
        "599": {
            "name": "Подгорный",
            "population": 6558,
            "type": "village",
            "poly": [
                [
                    93.3990277,
                    56.1072548
                ],
                [
                    93.3992834,
                    56.1193615
                ],
                [
                    93.4014356,
                    56.1187319
                ],
                [
                    93.4075939,
                    56.1199079
                ],
                [
                    93.4091921,
                    56.1214759
                ],
                [
                    93.4097462,
                    56.1226637
                ],
                [
                    93.4104494,
                    56.1227231
                ],
                [
                    93.4091069,
                    56.1275691
                ],
                [
                    93.4103295,
                    56.1284587
                ],
                [
                    93.407173,
                    56.1298801
                ],
                [
                    93.4125429,
                    56.132469
                ],
                [
                    93.4133319,
                    56.13203
                ],
                [
                    93.4208818,
                    56.1362433
                ],
                [
                    93.4233366,
                    56.1363101
                ],
                [
                    93.4360471,
                    56.1373132
                ],
                [
                    93.4366254,
                    56.1376476
                ],
                [
                    93.4677881,
                    56.1371507
                ],
                [
                    93.4739251,
                    56.1314699
                ],
                [
                    93.4953024,
                    56.1148883
                ],
                [
                    93.495132,
                    56.0947243
                ],
                [
                    93.4855343,
                    56.0902451
                ],
                [
                    93.4136115,
                    56.0897316
                ],
                [
                    93.4135475,
                    56.1016061
                ],
                [
                    93.4166717,
                    56.1028222
                ],
                [
                    93.4162242,
                    56.1044028
                ],
                [
                    93.4190583,
                    56.104379
                ],
                [
                    93.4191861,
                    56.1098333
                ],
                [
                    93.4160111,
                    56.1137066
                ],
                [
                    93.3990277,
                    56.1072548
                ]
            ],
            "longitude": 93.432945,
            "latitude": 56.122833
        },
        "600": {
            "name": "Додоново",
            "population": 880,
            "type": "village",
            "poly": null,
            "longitude": 93.436493,
            "latitude": 56.273659
        },
        "601": {
            "name": "Артёмовск",
            "population": 1837,
            "type": "village",
            "poly": null,
            "longitude": 93.437813,
            "latitude": 54.349564
        },
        "602": {
            "name": "Предивинск",
            "population": 1631,
            "type": "village",
            "poly": null,
            "longitude": 93.4391071,
            "latitude": 57.0652229
        },
        "603": {
            "name": "Юксеево",
            "population": 531,
            "type": "village",
            "poly": null,
            "longitude": 93.4399691,
            "latitude": 56.8443285
        },
        "604": {
            "name": "Арадан",
            "population": 278,
            "type": "village",
            "poly": null,
            "longitude": 93.4426151,
            "latitude": 52.5745347
        },
        "605": {
            "name": "Щетинкино",
            "population": 223,
            "type": "village",
            "poly": null,
            "longitude": 93.4431635,
            "latitude": 54.5399173
        },
        "606": {
            "name": "Большие Пруды",
            "population": 401,
            "type": "village",
            "poly": null,
            "longitude": 93.4515587,
            "latitude": 56.3937019
        },
        "607": {
            "name": "Новый Путь",
            "population": 697,
            "type": "village",
            "poly": [
                [
                    93.4407514,
                    56.1702337
                ],
                [
                    93.4586702,
                    56.1739745
                ],
                [
                    93.4710706,
                    56.1758538
                ],
                [
                    93.4800625,
                    56.1643236
                ],
                [
                    93.4456531,
                    56.1595695
                ],
                [
                    93.4407514,
                    56.1702337
                ]
            ],
            "longitude": 93.4598073,
            "latitude": 56.1677532
        },
        "608": {
            "name": "Брянка",
            "population": 651,
            "type": "village",
            "poly": null,
            "longitude": 93.47525,
            "latitude": 59.107403
        },
        "609": {
            "name": "Малиновка",
            "population": 309,
            "type": "village",
            "poly": null,
            "longitude": 93.4781915,
            "latitude": 56.5879906
        },
        "610": {
            "name": "Шивера",
            "population": 436,
            "type": "village",
            "poly": null,
            "longitude": 93.4863656,
            "latitude": 56.3215109
        },
        "611": {
            "name": "Мингуль",
            "population": 481,
            "type": "village",
            "poly": null,
            "longitude": 93.4864671,
            "latitude": 56.458013
        },
        "612": {
            "name": "Таяты",
            "population": 559,
            "type": "village",
            "poly": null,
            "longitude": 93.494598,
            "latitude": 53.773319
        },
        "613": {
            "name": "Колбинский",
            "population": 538,
            "type": "village",
            "poly": null,
            "longitude": 93.5027594,
            "latitude": 55.1633035
        },
        "614": {
            "name": "Тюхтят",
            "population": 517,
            "type": "village",
            "poly": null,
            "longitude": 93.5175302,
            "latitude": 53.9250653
        },
        "615": {
            "name": "Нахвальское",
            "population": 401,
            "type": "village",
            "poly": null,
            "longitude": 93.571243,
            "latitude": 56.673904
        },
        "616": {
            "name": "Новотроицкое",
            "population": 144,
            "type": "village",
            "poly": null,
            "longitude": 93.5716166,
            "latitude": 57.6006942
        },
        "617": {
            "name": "Павловщина",
            "population": 757,
            "type": "village",
            "poly": null,
            "longitude": 93.572222,
            "latitude": 56.7425503
        },
        "618": {
            "name": "Новоангарск",
            "population": 1307,
            "type": "village",
            "poly": null,
            "longitude": 93.5837762,
            "latitude": 58.1026125
        },
        "619": {
            "name": "Ветвистый",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 93.59687,
            "latitude": 55.8931415
        },
        "620": {
            "name": "Новоникольск",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 93.610976,
            "latitude": 55.783842
        },
        "621": {
            "name": "Вангаш",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 93.61451,
            "latitude": 59.971928
        },
        "622": {
            "name": "Первоманск",
            "population": 1749,
            "type": "village",
            "poly": null,
            "longitude": 93.6223592,
            "latitude": 55.8547649
        },
        "623": {
            "name": "Атаманово",
            "population": 1968,
            "type": "village",
            "poly": [
                [
                    93.5988035,
                    56.3910348
                ],
                [
                    93.5988276,
                    56.3913538
                ],
                [
                    93.5990094,
                    56.3913158
                ],
                [
                    93.5991775,
                    56.3913026
                ],
                [
                    93.5991226,
                    56.3921666
                ],
                [
                    93.5994074,
                    56.3921135
                ],
                [
                    93.6004847,
                    56.3921059
                ],
                [
                    93.6009616,
                    56.3920622
                ],
                [
                    93.6016342,
                    56.391867
                ],
                [
                    93.6015956,
                    56.3919952
                ],
                [
                    93.6017671,
                    56.392204
                ],
                [
                    93.602256,
                    56.392458
                ],
                [
                    93.6025562,
                    56.3925672
                ],
                [
                    93.6030108,
                    56.3933268
                ],
                [
                    93.6046062,
                    56.3948009
                ],
                [
                    93.6050351,
                    56.3951023
                ],
                [
                    93.6054125,
                    56.3954204
                ],
                [
                    93.6050866,
                    56.3956127
                ],
                [
                    93.6048249,
                    56.3957195
                ],
                [
                    93.6054425,
                    56.3962749
                ],
                [
                    93.6055411,
                    56.3966024
                ],
                [
                    93.605391,
                    56.3966499
                ],
                [
                    93.6059915,
                    56.3970534
                ],
                [
                    93.6059014,
                    56.3973074
                ],
                [
                    93.6062316,
                    56.3975447
                ],
                [
                    93.6065704,
                    56.3974806
                ],
                [
                    93.6074067,
                    56.3976705
                ],
                [
                    93.6078742,
                    56.397877
                ],
                [
                    93.6082087,
                    56.3984134
                ],
                [
                    93.6090064,
                    56.3991112
                ],
                [
                    93.6088348,
                    56.3992369
                ],
                [
                    93.6089592,
                    56.3995906
                ],
                [
                    93.6095253,
                    56.3999323
                ],
                [
                    93.6096883,
                    56.4002646
                ],
                [
                    93.609967,
                    56.4005185
                ],
                [
                    93.6101858,
                    56.4006135
                ],
                [
                    93.6103058,
                    56.4005802
                ],
                [
                    93.6105546,
                    56.4003049
                ],
                [
                    93.6106361,
                    56.4002765
                ],
                [
                    93.6110092,
                    56.4004426
                ],
                [
                    93.611511,
                    56.4004734
                ],
                [
                    93.6118412,
                    56.4005897
                ],
                [
                    93.6119012,
                    56.4004094
                ],
                [
                    93.6130677,
                    56.4006467
                ],
                [
                    93.6128404,
                    56.4010335
                ],
                [
                    93.6130034,
                    56.4010857
                ],
                [
                    93.6130892,
                    56.4011997
                ],
                [
                    93.6134451,
                    56.4011736
                ],
                [
                    93.6137539,
                    56.4011047
                ],
                [
                    93.6139298,
                    56.4012922
                ],
                [
                    93.6141914,
                    56.4014014
                ],
                [
                    93.6143243,
                    56.4015746
                ],
                [
                    93.6143715,
                    56.402054
                ],
                [
                    93.614929,
                    56.4021347
                ],
                [
                    93.6154051,
                    56.4021157
                ],
                [
                    93.6156667,
                    56.4019116
                ],
                [
                    93.6153407,
                    56.401717
                ],
                [
                    93.6154136,
                    56.4015628
                ],
                [
                    93.6159154,
                    56.4017882
                ],
                [
                    93.6166745,
                    56.4022178
                ],
                [
                    93.6177252,
                    56.4027066
                ],
                [
                    93.6193549,
                    56.4036559
                ],
                [
                    93.6205772,
                    56.404261
                ],
                [
                    93.62059,
                    56.4044651
                ],
                [
                    93.6208216,
                    56.4044959
                ],
                [
                    93.6210661,
                    56.4045363
                ],
                [
                    93.6217351,
                    56.4048424
                ],
                [
                    93.6220653,
                    56.4049753
                ],
                [
                    93.6222455,
                    56.40498
                ],
                [
                    93.6227644,
                    56.405476
                ],
                [
                    93.6230432,
                    56.4056611
                ],
                [
                    93.6231761,
                    56.4058509
                ],
                [
                    93.6234849,
                    56.4058604
                ],
                [
                    93.6236736,
                    56.4059933
                ],
                [
                    93.6234592,
                    56.4062733
                ],
                [
                    93.6236264,
                    56.4063872
                ],
                [
                    93.6237679,
                    56.4063991
                ],
                [
                    93.6240381,
                    56.4066791
                ],
                [
                    93.6242225,
                    56.4067621
                ],
                [
                    93.6246257,
                    56.4067645
                ],
                [
                    93.6248229,
                    56.4067123
                ],
                [
                    93.6248658,
                    56.4066363
                ],
                [
                    93.6247801,
                    56.4063729
                ],
                [
                    93.6249216,
                    56.4062662
                ],
                [
                    93.6249345,
                    56.4060574
                ],
                [
                    93.6247843,
                    56.405877
                ],
                [
                    93.624853,
                    56.405794
                ],
                [
                    93.6251403,
                    56.4059221
                ],
                [
                    93.625389,
                    56.4060051
                ],
                [
                    93.6254234,
                    56.4059719
                ],
                [
                    93.6254319,
                    56.405858
                ],
                [
                    93.6263454,
                    56.4059553
                ],
                [
                    93.626577,
                    56.4060265
                ],
                [
                    93.6267614,
                    56.4061926
                ],
                [
                    93.6266456,
                    56.4064655
                ],
                [
                    93.6268729,
                    56.4065936
                ],
                [
                    93.6269029,
                    56.406717
                ],
                [
                    93.6267657,
                    56.4068926
                ],
                [
                    93.6269244,
                    56.406978
                ],
                [
                    93.6270573,
                    56.4071536
                ],
                [
                    93.6272846,
                    56.4071631
                ],
                [
                    93.6273961,
                    56.4072794
                ],
                [
                    93.627439,
                    56.4074502
                ],
                [
                    93.6275891,
                    56.4074882
                ],
                [
                    93.6278079,
                    56.407436
                ],
                [
                    93.6279279,
                    56.407277
                ],
                [
                    93.6278893,
                    56.4071607
                ],
                [
                    93.6280094,
                    56.4070919
                ],
                [
                    93.6282067,
                    56.4070801
                ],
                [
                    93.6283225,
                    56.4071109
                ],
                [
                    93.6283096,
                    56.4070184
                ],
                [
                    93.628181,
                    56.4069401
                ],
                [
                    93.6282239,
                    56.4067479
                ],
                [
                    93.6283782,
                    56.4067099
                ],
                [
                    93.6285326,
                    56.4067835
                ],
                [
                    93.6288586,
                    56.4067265
                ],
                [
                    93.6293989,
                    56.4068689
                ],
                [
                    93.6295019,
                    56.4069472
                ],
                [
                    93.6293089,
                    56.4070872
                ],
                [
                    93.6294719,
                    56.4072011
                ],
                [
                    93.6293904,
                    56.4073529
                ],
                [
                    93.6294333,
                    56.4073862
                ],
                [
                    93.6296048,
                    56.4077872
                ],
                [
                    93.6297163,
                    56.4078821
                ],
                [
                    93.6299865,
                    56.4079106
                ],
                [
                    93.6301623,
                    56.407818
                ],
                [
                    93.6304926,
                    56.4077895
                ],
                [
                    93.6305655,
                    56.4079319
                ],
                [
                    93.6306169,
                    56.4081929
                ],
                [
                    93.6308789,
                    56.4087716
                ],
                [
                    93.6311898,
                    56.4089971
                ],
                [
                    93.6307521,
                    56.40913
                ],
                [
                    93.6309404,
                    56.4093539
                ],
                [
                    93.6312109,
                    56.4099868
                ],
                [
                    93.6314962,
                    56.4101539
                ],
                [
                    93.6324606,
                    56.4108918
                ],
                [
                    93.6329335,
                    56.4117675
                ],
                [
                    93.6335677,
                    56.4122272
                ],
                [
                    93.6337012,
                    56.4124702
                ],
                [
                    93.6340033,
                    56.4127121
                ],
                [
                    93.6341737,
                    56.4129658
                ],
                [
                    93.6341597,
                    56.4131305
                ],
                [
                    93.6338277,
                    56.4133025
                ],
                [
                    93.6334693,
                    56.4134657
                ],
                [
                    93.6333551,
                    56.4135581
                ],
                [
                    93.6333499,
                    56.4137281
                ],
                [
                    93.6333709,
                    56.413834
                ],
                [
                    93.6334869,
                    56.4139312
                ],
                [
                    93.633594,
                    56.4140838
                ],
                [
                    93.6336678,
                    56.4145978
                ],
                [
                    93.6338347,
                    56.4148456
                ],
                [
                    93.6339067,
                    56.4149166
                ],
                [
                    93.6340297,
                    56.4149603
                ],
                [
                    93.6350362,
                    56.4150234
                ],
                [
                    93.6352769,
                    56.4151498
                ],
                [
                    93.6353717,
                    56.4151653
                ],
                [
                    93.6354877,
                    56.4153082
                ],
                [
                    93.6354403,
                    56.4155598
                ],
                [
                    93.6356897,
                    56.4161292
                ],
                [
                    93.6354666,
                    56.4161671
                ],
                [
                    93.6351645,
                    56.4161613
                ],
                [
                    93.6350819,
                    56.4160671
                ],
                [
                    93.6349291,
                    56.4160097
                ],
                [
                    93.6348518,
                    56.4160029
                ],
                [
                    93.6346603,
                    56.4161341
                ],
                [
                    93.6346884,
                    56.4161701
                ],
                [
                    93.6348992,
                    56.4162021
                ],
                [
                    93.6349115,
                    56.4163673
                ],
                [
                    93.634973,
                    56.4163965
                ],
                [
                    93.6351961,
                    56.4163926
                ],
                [
                    93.6352172,
                    56.4165286
                ],
                [
                    93.6353735,
                    56.4165859
                ],
                [
                    93.6357846,
                    56.4165782
                ],
                [
                    93.6358337,
                    56.4170397
                ],
                [
                    93.6359145,
                    56.4173244
                ],
                [
                    93.6360797,
                    56.4174148
                ],
                [
                    93.6362114,
                    56.4176169
                ],
                [
                    93.6363414,
                    56.4177208
                ],
                [
                    93.6364679,
                    56.4179356
                ],
                [
                    93.6365873,
                    56.4180094
                ],
                [
                    93.636756,
                    56.4180318
                ],
                [
                    93.6370283,
                    56.418058
                ],
                [
                    93.6371477,
                    56.4180259
                ],
                [
                    93.6373813,
                    56.4179919
                ],
                [
                    93.6380102,
                    56.4176525
                ],
                [
                    93.6391008,
                    56.417064
                ],
                [
                    93.6431804,
                    56.4148
                ],
                [
                    93.6437128,
                    56.414633
                ],
                [
                    93.6440834,
                    56.4143915
                ],
                [
                    93.6444676,
                    56.4140013
                ],
                [
                    93.645453,
                    56.4134684
                ],
                [
                    93.6459498,
                    56.4132892
                ],
                [
                    93.6462655,
                    56.4130129
                ],
                [
                    93.6472865,
                    56.4124101
                ],
                [
                    93.6473194,
                    56.4123402
                ],
                [
                    93.6472618,
                    56.4122613
                ],
                [
                    93.647421,
                    56.4122476
                ],
                [
                    93.6477366,
                    56.4121884
                ],
                [
                    93.6481401,
                    56.4120973
                ],
                [
                    93.6486836,
                    56.4117875
                ],
                [
                    93.6488071,
                    56.4116007
                ],
                [
                    93.648851,
                    56.4115719
                ],
                [
                    93.6490761,
                    56.4114868
                ],
                [
                    93.649616,
                    56.4110736
                ],
                [
                    93.6511633,
                    56.4101437
                ],
                [
                    93.6513005,
                    56.4100013
                ],
                [
                    93.6536232,
                    56.4087599
                ],
                [
                    93.6541653,
                    56.4085378
                ],
                [
                    93.6562993,
                    56.4073305
                ],
                [
                    93.6566321,
                    56.4073951
                ],
                [
                    93.6569444,
                    56.4072261
                ],
                [
                    93.6573423,
                    56.4069319
                ],
                [
                    93.6575276,
                    56.40693
                ],
                [
                    93.6571948,
                    56.4068465
                ],
                [
                    93.6569924,
                    56.4068142
                ],
                [
                    93.6585843,
                    56.405865
                ],
                [
                    93.65855,
                    56.4057606
                ],
                [
                    93.6550505,
                    56.4055708
                ],
                [
                    93.6532493,
                    56.4054664
                ],
                [
                    93.6531772,
                    56.4053885
                ],
                [
                    93.6510363,
                    56.4053202
                ],
                [
                    93.6492179,
                    56.4051892
                ],
                [
                    93.6476671,
                    56.4051095
                ],
                [
                    93.648024,
                    56.4044944
                ],
                [
                    93.6481783,
                    56.4044203
                ],
                [
                    93.6483979,
                    56.4040615
                ],
                [
                    93.6484803,
                    56.4038717
                ],
                [
                    93.6486373,
                    56.4036227
                ],
                [
                    93.6486098,
                    56.4034101
                ],
                [
                    93.6484726,
                    56.4032992
                ],
                [
                    93.6482173,
                    56.4029742
                ],
                [
                    93.6483079,
                    56.4025474
                ],
                [
                    93.6483381,
                    56.4022573
                ],
                [
                    93.6483162,
                    56.402113
                ],
                [
                    93.6481652,
                    56.4019414
                ],
                [
                    93.64827,
                    56.4012028
                ],
                [
                    93.6461311,
                    56.4010485
                ],
                [
                    93.6451071,
                    56.4009269
                ],
                [
                    93.6449838,
                    56.4008616
                ],
                [
                    93.6445282,
                    56.4007608
                ],
                [
                    93.643976,
                    56.4007311
                ],
                [
                    93.6437616,
                    56.4007815
                ],
                [
                    93.6431826,
                    56.4007875
                ],
                [
                    93.6428824,
                    56.4007282
                ],
                [
                    93.642148,
                    56.4006926
                ],
                [
                    93.6404271,
                    56.4004078
                ],
                [
                    93.6401698,
                    56.400384
                ],
                [
                    93.6378271,
                    56.400034
                ],
                [
                    93.6331471,
                    56.3990372
                ],
                [
                    93.6328416,
                    56.3988503
                ],
                [
                    93.6328255,
                    56.3987672
                ],
                [
                    93.6302738,
                    56.3982243
                ],
                [
                    93.6299092,
                    56.3981916
                ],
                [
                    93.6294214,
                    56.3981204
                ],
                [
                    93.6290729,
                    56.3981412
                ],
                [
                    93.6257921,
                    56.3974766
                ],
                [
                    93.6252775,
                    56.397266
                ],
                [
                    93.6239694,
                    56.3968744
                ],
                [
                    93.6229509,
                    56.3966667
                ],
                [
                    93.6228115,
                    56.3965807
                ],
                [
                    93.6228008,
                    56.3964323
                ],
                [
                    93.6225059,
                    56.39637
                ],
                [
                    93.6223451,
                    56.396373
                ],
                [
                    93.6222593,
                    56.3964204
                ],
                [
                    93.6219484,
                    56.3963997
                ],
                [
                    93.6210895,
                    56.3961416
                ],
                [
                    93.6174772,
                    56.3949247
                ],
                [
                    93.6162208,
                    56.394519
                ],
                [
                    93.6143754,
                    56.3937077
                ],
                [
                    93.6134199,
                    56.3934035
                ],
                [
                    93.6106322,
                    56.3919546
                ],
                [
                    93.6082371,
                    56.3904695
                ],
                [
                    93.6076511,
                    56.3900348
                ],
                [
                    93.6057739,
                    56.3889293
                ],
                [
                    93.604024,
                    56.3874685
                ],
                [
                    93.6037461,
                    56.3872064
                ],
                [
                    93.6030155,
                    56.3867193
                ],
                [
                    93.60218,
                    56.3856801
                ],
                [
                    93.6019688,
                    56.3858553
                ],
                [
                    93.6015438,
                    56.3859485
                ],
                [
                    93.6015962,
                    56.3861153
                ],
                [
                    93.6018148,
                    56.3863894
                ],
                [
                    93.6017806,
                    56.3864287
                ],
                [
                    93.601567,
                    56.3864981
                ],
                [
                    93.6015578,
                    56.386588
                ],
                [
                    93.6017677,
                    56.3865735
                ],
                [
                    93.601867,
                    56.3866844
                ],
                [
                    93.6017849,
                    56.3867302
                ],
                [
                    93.6017891,
                    56.3869724
                ],
                [
                    93.6017038,
                    56.3870971
                ],
                [
                    93.6018578,
                    56.3872288
                ],
                [
                    93.6016776,
                    56.3873095
                ],
                [
                    93.6016262,
                    56.3875113
                ],
                [
                    93.6017505,
                    56.3876704
                ],
                [
                    93.6018921,
                    56.387725
                ],
                [
                    93.6022137,
                    56.3877226
                ],
                [
                    93.6024153,
                    56.3879576
                ],
                [
                    93.6025397,
                    56.3879695
                ],
                [
                    93.6026383,
                    56.3880502
                ],
                [
                    93.6025354,
                    56.3883351
                ],
                [
                    93.6024153,
                    56.3884728
                ],
                [
                    93.6024753,
                    56.3885416
                ],
                [
                    93.6024753,
                    56.3886437
                ],
                [
                    93.6016519,
                    56.3887743
                ],
                [
                    93.6016819,
                    56.388912
                ],
                [
                    93.6019049,
                    56.3891897
                ],
                [
                    93.6019006,
                    56.3893132
                ],
                [
                    93.6017548,
                    56.3894034
                ],
                [
                    93.601103,
                    56.3894675
                ],
                [
                    93.6010858,
                    56.3895292
                ],
                [
                    93.6013088,
                    56.3898663
                ],
                [
                    93.6013774,
                    56.3898758
                ],
                [
                    93.6014675,
                    56.3898568
                ],
                [
                    93.6016648,
                    56.3898402
                ],
                [
                    93.6018149,
                    56.3898853
                ],
                [
                    93.6018406,
                    56.3899542
                ],
                [
                    93.6016133,
                    56.3900847
                ],
                [
                    93.6016004,
                    56.3901963
                ],
                [
                    93.6017548,
                    56.3903648
                ],
                [
                    93.6016519,
                    56.3905738
                ],
                [
                    93.6017806,
                    56.3908206
                ],
                [
                    93.6016262,
                    56.3910414
                ],
                [
                    93.6014503,
                    56.3910675
                ],
                [
                    93.6012273,
                    56.3910177
                ],
                [
                    93.6007008,
                    56.3908164
                ],
                [
                    93.6004264,
                    56.3906303
                ],
                [
                    93.5996304,
                    56.3906056
                ],
                [
                    93.599452,
                    56.39056
                ],
                [
                    93.5991569,
                    56.3906759
                ],
                [
                    93.5988722,
                    56.3907024
                ],
                [
                    93.598903,
                    56.3908449
                ],
                [
                    93.5988035,
                    56.3910348
                ]
            ],
            "longitude": 93.6211941777867,
            "latitude": 56.39827015322315
        },
        "624": {
            "name": "Чибижек",
            "population": 165,
            "type": "village",
            "poly": null,
            "longitude": 93.645981,
            "latitude": 54.400734
        },
        "625": {
            "name": "Нарва",
            "population": 1206,
            "type": "village",
            "poly": null,
            "longitude": 93.6462767,
            "latitude": 55.4023626
        },
        "626": {
            "name": "Хлоптуново",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 93.65008787377718,
            "latitude": 56.46979273632914
        },
        "627": {
            "name": "Петропавловка",
            "population": 790,
            "type": "village",
            "poly": null,
            "longitude": 93.6653927,
            "latitude": 53.9019866
        },
        "628": {
            "name": "Орешное",
            "population": 390,
            "type": "village",
            "poly": null,
            "longitude": 93.6700342,
            "latitude": 55.3002181
        },
        "629": {
            "name": "Камарчага",
            "population": 1857,
            "type": "village",
            "poly": null,
            "longitude": 93.6839028,
            "latitude": 55.8083208
        },
        "630": {
            "name": "Александровка",
            "population": 86,
            "type": "village",
            "poly": null,
            "longitude": 93.6852895,
            "latitude": 57.3784226
        },
        "631": {
            "name": "Кононово",
            "population": 937,
            "type": "village",
            "poly": null,
            "longitude": 93.712807,
            "latitude": 56.505638
        },
        "632": {
            "name": "Нижняя Есауловка",
            "population": 690,
            "type": "village",
            "poly": null,
            "longitude": 93.7174912,
            "latitude": 55.7856477
        },
        "633": {
            "name": "Черемшанка",
            "population": 1077,
            "type": "village",
            "poly": null,
            "longitude": 93.7393209,
            "latitude": 53.8788347
        },
        "634": {
            "name": "Тертеж",
            "population": 485,
            "type": "village",
            "poly": null,
            "longitude": 93.7539053,
            "latitude": 55.8793438
        },
        "635": {
            "name": "Кулаково",
            "population": 841,
            "type": "village",
            "poly": null,
            "longitude": 93.7542114,
            "latitude": 58.0952163
        },
        "636": {
            "name": "Степной Баджей",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 93.7554071,
            "latitude": 55.2029371
        },
        "637": {
            "name": "Шалинское",
            "population": 3932,
            "type": "village",
            "poly": null,
            "longitude": 93.764816,
            "latitude": 55.719715
        },
        "638": {
            "name": "Гуляевка",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 93.7700088,
            "latitude": 53.84256
        },
        "639": {
            "name": "Кияй",
            "population": 459,
            "type": "village",
            "poly": null,
            "longitude": 93.7716802,
            "latitude": 55.5169213
        },
        "640": {
            "name": "Казанка",
            "population": 240,
            "type": "village",
            "poly": null,
            "longitude": 93.7807876,
            "latitude": 57.3424554
        },
        "641": {
            "name": "Верхняя Есауловка",
            "population": 520,
            "type": "village",
            "poly": null,
            "longitude": 93.7886919,
            "latitude": 55.676098
        },
        "642": {
            "name": "Тутончаны",
            "population": 223,
            "type": "village",
            "poly": null,
            "longitude": 93.7979341,
            "latitude": 64.2092694
        },
        "643": {
            "name": "Жаровск",
            "population": 378,
            "type": "village",
            "poly": null,
            "longitude": 93.9052874,
            "latitude": 53.7739745
        },
        "644": {
            "name": "Выезжий Лог",
            "population": 409,
            "type": "village",
            "poly": [
                [
                    93.9103812,
                    54.9777979
                ],
                [
                    93.9105692,
                    54.9803868
                ],
                [
                    93.9154563,
                    54.9807104
                ],
                [
                    93.9241969,
                    54.9796317
                ],
                [
                    93.947129,
                    54.9725117
                ],
                [
                    93.9446854,
                    54.968196
                ],
                [
                    93.9383885,
                    54.9674407
                ],
                [
                    93.9269224,
                    54.9745076
                ],
                [
                    93.9103812,
                    54.9777979
                ]
            ],
            "longitude": 93.9302261,
            "latitude": 54.975382
        },
        "645": {
            "name": "Роща",
            "population": 629,
            "type": "village",
            "poly": null,
            "longitude": 93.949668,
            "latitude": 55.8437568
        },
        "646": {
            "name": "Мана",
            "population": 700,
            "type": "village",
            "poly": [
                [
                    93.9448734,
                    54.9545443
                ],
                [
                    93.9627304,
                    54.9619913
                ],
                [
                    93.9620725,
                    54.9580521
                ],
                [
                    93.9577492,
                    54.95503
                ],
                [
                    93.9585951,
                    54.9526554
                ],
                [
                    93.9493846,
                    54.951522
                ],
                [
                    93.9448734,
                    54.9545443
                ]
            ],
            "longitude": 93.9542463,
            "latitude": 54.9557406
        },
        "647": {
            "name": "Балай",
            "population": 1324,
            "type": "village",
            "poly": [
                [
                    93.9671892,
                    55.8727173
                ],
                [
                    93.9746707,
                    55.8767734
                ],
                [
                    93.9833163,
                    55.8756429
                ],
                [
                    93.9855411,
                    55.8750838
                ],
                [
                    93.9926327,
                    55.8748498
                ],
                [
                    93.998751,
                    55.8734326
                ],
                [
                    93.9995853,
                    55.8717423
                ],
                [
                    94.0015784,
                    55.8714563
                ],
                [
                    94.0047997,
                    55.8711442
                ],
                [
                    94.004962,
                    55.8714173
                ],
                [
                    94.007349,
                    55.8712352
                ],
                [
                    94.006839,
                    55.870143
                ],
                [
                    94.006839,
                    55.8693888
                ],
                [
                    94.0107326,
                    55.8691158
                ],
                [
                    94.0115669,
                    55.8688427
                ],
                [
                    94.0124939,
                    55.8679584
                ],
                [
                    94.012759,
                    55.866655
                ],
                [
                    94.0118842,
                    55.8659386
                ],
                [
                    94.0111266,
                    55.8646814
                ],
                [
                    94.0098519,
                    55.8642782
                ],
                [
                    94.0058193,
                    55.8640832
                ],
                [
                    94.0044985,
                    55.8616772
                ],
                [
                    94.0053328,
                    55.8605977
                ],
                [
                    94.0062829,
                    55.8588418
                ],
                [
                    94.0034556,
                    55.8572289
                ],
                [
                    93.9999793,
                    55.8577492
                ],
                [
                    93.9979399,
                    55.8595181
                ],
                [
                    93.9960395,
                    55.8617942
                ],
                [
                    93.9930267,
                    55.8624835
                ],
                [
                    93.988832,
                    55.8630297
                ],
                [
                    93.9871634,
                    55.8630037
                ],
                [
                    93.9835944,
                    55.8640441
                ],
                [
                    93.9798236,
                    55.8644918
                ],
                [
                    93.9718186,
                    55.867306
                ],
                [
                    93.9671892,
                    55.8727173
                ]
            ],
            "longitude": 93.9854802,
            "latitude": 55.870255
        },
        "648": {
            "name": "Кожелак",
            "population": 200,
            "type": "village",
            "poly": null,
            "longitude": 93.9993995,
            "latitude": 55.3358999
        },
        "649": {
            "name": "Первомайск",
            "population": 936,
            "type": "village",
            "poly": [
                [
                    94.081346,
                    58.0185975
                ],
                [
                    94.0837557,
                    58.0212625
                ],
                [
                    94.0884541,
                    58.0253411
                ],
                [
                    94.092612,
                    58.0253036
                ],
                [
                    94.1015184,
                    58.0240775
                ],
                [
                    94.1080387,
                    58.0200239
                ],
                [
                    94.116,
                    58.0174213
                ],
                [
                    94.1165199,
                    58.0149186
                ],
                [
                    94.1139211,
                    58.0114021
                ],
                [
                    94.1095743,
                    58.0108264
                ],
                [
                    94.1013294,
                    58.0109265
                ],
                [
                    94.0968059,
                    58.0090255
                ],
                [
                    94.0932561,
                    58.0087866
                ],
                [
                    94.0908589,
                    58.0089813
                ],
                [
                    94.0891079,
                    58.0103138
                ],
                [
                    94.0815572,
                    58.0144022
                ],
                [
                    94.081346,
                    58.0185975
                ]
            ],
            "longitude": 94.0964083,
            "latitude": 58.0160752
        },
        "650": {
            "name": "Запасной Имбеж",
            "population": 948,
            "type": "village",
            "poly": null,
            "longitude": 94.127151,
            "latitude": 55.559559
        },
        "651": {
            "name": "Мина",
            "population": 541,
            "type": "village",
            "poly": [
                [
                    94.1298343,
                    54.9806025
                ],
                [
                    94.1360373,
                    54.984863
                ],
                [
                    94.1444019,
                    54.9806025
                ],
                [
                    94.1467514,
                    54.9790924
                ],
                [
                    94.1470335,
                    54.9754246
                ],
                [
                    94.149947,
                    54.9728354
                ],
                [
                    94.149571,
                    54.9711092
                ],
                [
                    94.1423343,
                    54.9729972
                ],
                [
                    94.138199,
                    54.9725117
                ],
                [
                    94.1346276,
                    54.973213
                ],
                [
                    94.131886,
                    54.9728464
                ],
                [
                    94.1300222,
                    54.9753707
                ],
                [
                    94.1298343,
                    54.9806025
                ]
            ],
            "longitude": 94.13781,
            "latitude": 54.977322
        },
        "652": {
            "name": "Сухоной",
            "population": 419,
            "type": "village",
            "poly": null,
            "longitude": 94.1706276,
            "latitude": 55.609986
        },
        "653": {
            "name": "Сушиновка",
            "population": 842,
            "type": "village",
            "poly": null,
            "longitude": 94.2119142,
            "latitude": 55.7779708
        },
        "654": {
            "name": "Партизанск",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 94.2401778,
            "latitude": 58.6841302
        },
        "655": {
            "name": "Солонечно-Талое",
            "population": 358,
            "type": "village",
            "poly": null,
            "longitude": 94.241776,
            "latitude": 55.295036
        },
        "656": {
            "name": "Ольгино",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 94.3060927,
            "latitude": 55.8659167
        },
        "657": {
            "name": "Вершино-Рыбное",
            "population": 761,
            "type": "village",
            "poly": null,
            "longitude": 94.3342563,
            "latitude": 55.2849858
        },
        "658": {
            "name": "Машуковка",
            "population": 631,
            "type": "village",
            "poly": null,
            "longitude": 94.3870054,
            "latitude": 57.7964584
        },
        "659": {
            "name": "Партизанское",
            "population": 3525,
            "type": "village",
            "poly": null,
            "longitude": 94.393066,
            "latitude": 55.499271
        },
        "660": {
            "name": "Громадск",
            "population": 1952,
            "type": "village",
            "poly": [
                [
                    94.3866747,
                    55.8995372
                ],
                [
                    94.3886395,
                    55.9039415
                ],
                [
                    94.3960367,
                    55.9077874
                ],
                [
                    94.3995167,
                    55.9090112
                ],
                [
                    94.4015668,
                    55.9087078
                ],
                [
                    94.4074639,
                    55.9056249
                ],
                [
                    94.4097015,
                    55.9059063
                ],
                [
                    94.4110399,
                    55.9050388
                ],
                [
                    94.4114372,
                    55.9039955
                ],
                [
                    94.4178153,
                    55.9004902
                ],
                [
                    94.4192164,
                    55.8994702
                ],
                [
                    94.4203247,
                    55.8967033
                ],
                [
                    94.4090532,
                    55.8950969
                ],
                [
                    94.4085305,
                    55.893596
                ],
                [
                    94.4059224,
                    55.8927483
                ],
                [
                    94.4047548,
                    55.8935778
                ],
                [
                    94.3988274,
                    55.8911921
                ],
                [
                    94.3959415,
                    55.892869
                ],
                [
                    94.3937014,
                    55.8972108
                ],
                [
                    94.3927625,
                    55.8974485
                ],
                [
                    94.3866747,
                    55.8995372
                ]
            ],
            "longitude": 94.398573,
            "latitude": 55.9004671
        },
        "661": {
            "name": "Толстихино",
            "population": 571,
            "type": "village",
            "poly": null,
            "longitude": 94.4526439,
            "latitude": 55.6861578
        },
        "662": {
            "name": "Новопятницкое",
            "population": 776,
            "type": "village",
            "poly": null,
            "longitude": 94.4824412,
            "latitude": 55.8508334
        },
        "663": {
            "name": "Восточное",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 94.4864606,
            "latitude": 55.6288742
        },
        "664": {
            "name": "Унжа",
            "population": 197,
            "type": "village",
            "poly": null,
            "longitude": 94.4912471,
            "latitude": 57.2149723
        },
        "665": {
            "name": "Ивановка",
            "population": 299,
            "type": "village",
            "poly": null,
            "longitude": 94.4939611,
            "latitude": 55.2596866
        },
        "666": {
            "name": "Стойба",
            "population": 658,
            "type": "village",
            "poly": null,
            "longitude": 94.4960755,
            "latitude": 55.5002204
        },
        "667": {
            "name": "Успенка",
            "population": 799,
            "type": "village",
            "poly": null,
            "longitude": 94.49881,
            "latitude": 55.924328
        },
        "668": {
            "name": "Рыбное",
            "population": 344,
            "type": "village",
            "poly": null,
            "longitude": 94.5117575,
            "latitude": 58.1311345
        },
        "669": {
            "name": "Сивохино",
            "population": 447,
            "type": "village",
            "poly": null,
            "longitude": 94.5182985,
            "latitude": 57.0942662
        },
        "670": {
            "name": "Бельск",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 94.5216538,
            "latitude": 58.1708145
        },
        "671": {
            "name": "Волочанка",
            "population": 530,
            "type": "village",
            "poly": [
                [
                    94.5299603,
                    70.9747407
                ],
                [
                    94.532192,
                    70.975636
                ],
                [
                    94.5361402,
                    70.976979
                ],
                [
                    94.5431784,
                    70.9784337
                ],
                [
                    94.54541,
                    70.9789372
                ],
                [
                    94.5455816,
                    70.9782099
                ],
                [
                    94.5490148,
                    70.9774824
                ],
                [
                    94.554508,
                    70.9774824
                ],
                [
                    94.5617178,
                    70.9787694
                ],
                [
                    94.5642927,
                    70.9787694
                ],
                [
                    94.5600012,
                    70.9770349
                ],
                [
                    94.5562245,
                    70.9762516
                ],
                [
                    94.5546797,
                    70.9746288
                ],
                [
                    94.5466,
                    70.9747802
                ],
                [
                    94.5377501,
                    70.9744611
                ],
                [
                    94.5319655,
                    70.9737451
                ],
                [
                    94.5299603,
                    70.9747407
                ]
            ],
            "longitude": 94.540245,
            "latitude": 70.975899
        },
        "672": {
            "name": "Иннокентьевка",
            "population": 359,
            "type": "village",
            "poly": null,
            "longitude": 94.5508201,
            "latitude": 55.4126258
        },
        "673": {
            "name": "Александровка",
            "population": 644,
            "type": "village",
            "poly": [
                [
                    94.535263,
                    55.992549
                ],
                [
                    94.5457416,
                    55.9975082
                ],
                [
                    94.5577727,
                    55.9968992
                ],
                [
                    94.5616536,
                    55.9951592
                ],
                [
                    94.5681738,
                    55.9938976
                ],
                [
                    94.5716666,
                    55.9948112
                ],
                [
                    94.5742281,
                    55.9938106
                ],
                [
                    94.5838529,
                    55.9920269
                ],
                [
                    94.5835424,
                    55.9850655
                ],
                [
                    94.57058,
                    55.9854136
                ],
                [
                    94.5677857,
                    55.983325
                ],
                [
                    94.563439,
                    55.9829769
                ],
                [
                    94.5569965,
                    55.9841082
                ],
                [
                    94.5581708,
                    55.9896321
                ],
                [
                    94.5371259,
                    55.9892425
                ],
                [
                    94.535263,
                    55.992549
                ]
            ],
            "longitude": 94.5579701,
            "latitude": 55.9929136
        },
        "674": {
            "name": "Раздолинск",
            "population": 2359,
            "type": "village",
            "poly": null,
            "longitude": 94.618317,
            "latitude": 58.41917
        },
        "675": {
            "name": "Авда",
            "population": 411,
            "type": "village",
            "poly": null,
            "longitude": 94.6206492,
            "latitude": 55.7378276
        },
        "676": {
            "name": "Богуславка",
            "population": 376,
            "type": "village",
            "poly": null,
            "longitude": 94.637047,
            "latitude": 55.4833921
        },
        "677": {
            "name": "Сухово",
            "population": 854,
            "type": "village",
            "poly": null,
            "longitude": 94.6445747,
            "latitude": 57.06438
        },
        "678": {
            "name": "Южно-Енисейск",
            "population": 650,
            "type": "village",
            "poly": null,
            "longitude": 94.647484,
            "latitude": 58.789608
        },
        "679": {
            "name": "Полигус",
            "population": 244,
            "type": "village",
            "poly": null,
            "longitude": 94.6579826,
            "latitude": 61.9894286
        },
        "680": {
            "name": "Высотино",
            "population": null,
            "type": "village",
            "poly": [
                [
                    94.6563269,
                    56.0316159
                ],
                [
                    94.6563711,
                    56.0359988
                ],
                [
                    94.6571459,
                    56.0360951
                ],
                [
                    94.6574615,
                    56.0369305
                ],
                [
                    94.6598144,
                    56.0374285
                ],
                [
                    94.6611056,
                    56.0381674
                ],
                [
                    94.6632864,
                    56.0384887
                ],
                [
                    94.664922,
                    56.0387296
                ],
                [
                    94.6682505,
                    56.0395006
                ],
                [
                    94.6709191,
                    56.0395006
                ],
                [
                    94.6718086,
                    56.0394043
                ],
                [
                    94.673559,
                    56.0387457
                ],
                [
                    94.6732433,
                    56.0379907
                ],
                [
                    94.6722735,
                    56.0376448
                ],
                [
                    94.6710626,
                    56.0374445
                ],
                [
                    94.6698287,
                    56.0369465
                ],
                [
                    94.669427,
                    56.0359506
                ],
                [
                    94.6689679,
                    56.0355811
                ],
                [
                    94.6669306,
                    56.035067
                ],
                [
                    94.6661558,
                    56.0347618
                ],
                [
                    94.6658402,
                    56.0342316
                ],
                [
                    94.665955,
                    56.0338943
                ],
                [
                    94.6667583,
                    56.0338771
                ],
                [
                    94.6669019,
                    56.0333159
                ],
                [
                    94.6667584,
                    56.0320146
                ],
                [
                    94.6658689,
                    56.032111
                ],
                [
                    94.665582,
                    56.0318379
                ],
                [
                    94.6657541,
                    56.0315005
                ],
                [
                    94.6661272,
                    56.0314041
                ],
                [
                    94.6662706,
                    56.0312273
                ],
                [
                    94.6660698,
                    56.0310506
                ],
                [
                    94.6656107,
                    56.03089
                ],
                [
                    94.6655683,
                    56.0306413
                ],
                [
                    94.6651048,
                    56.0304091
                ],
                [
                    94.6647999,
                    56.0296648
                ],
                [
                    94.6647109,
                    56.0294629
                ],
                [
                    94.663699,
                    56.029382
                ],
                [
                    94.6627161,
                    56.0291068
                ],
                [
                    94.6606056,
                    56.0276983
                ],
                [
                    94.6595938,
                    56.0266137
                ],
                [
                    94.6590155,
                    56.0261442
                ],
                [
                    94.6579748,
                    56.0260956
                ],
                [
                    94.657252,
                    56.0297381
                ],
                [
                    94.6571075,
                    56.0313245
                ],
                [
                    94.6563269,
                    56.0316159
                ]
            ],
            "longitude": 94.6618989,
            "latitude": 56.0340629
        },
        "681": {
            "name": "Кулижниково",
            "population": 227,
            "type": "village",
            "poly": null,
            "longitude": 94.6866606,
            "latitude": 55.277985
        },
        "682": {
            "name": "Налобино",
            "population": 347,
            "type": "village",
            "poly": null,
            "longitude": 94.6902597,
            "latitude": 55.9056212
        },
        "683": {
            "name": "Большой Арбай",
            "population": 349,
            "type": "village",
            "poly": null,
            "longitude": 94.6946897,
            "latitude": 55.1822616
        },
        "684": {
            "name": "Усть-Кандыга",
            "population": 407,
            "type": "village",
            "poly": null,
            "longitude": 94.7380314,
            "latitude": 55.5416881
        },
        "685": {
            "name": "Переясловка",
            "population": 1211,
            "type": "village",
            "poly": [
                [
                    94.7275128,
                    55.6746331
                ],
                [
                    94.728442,
                    55.6769405
                ],
                [
                    94.7297444,
                    55.6782133
                ],
                [
                    94.7308173,
                    55.6809475
                ],
                [
                    94.7462518,
                    55.679336
                ],
                [
                    94.7479813,
                    55.6797619
                ],
                [
                    94.7501142,
                    55.6797958
                ],
                [
                    94.7524316,
                    55.6802797
                ],
                [
                    94.753732,
                    55.6797619
                ],
                [
                    94.7553499,
                    55.6787069
                ],
                [
                    94.765877,
                    55.6781165
                ],
                [
                    94.7647612,
                    55.6732053
                ],
                [
                    94.7606413,
                    55.6692604
                ],
                [
                    94.7512858,
                    55.6678082
                ],
                [
                    94.7468655,
                    55.6649763
                ],
                [
                    94.737555,
                    55.6637902
                ],
                [
                    94.7285857,
                    55.6643227
                ],
                [
                    94.7278562,
                    55.6717775
                ],
                [
                    94.7275128,
                    55.6746331
                ]
            ],
            "longitude": 94.7430638,
            "latitude": 55.673071
        },
        "686": {
            "name": "Средняя Агинка",
            "population": 255,
            "type": "village",
            "poly": null,
            "longitude": 94.748075,
            "latitude": 55.3219934
        },
        "687": {
            "name": "Урал",
            "population": 1740,
            "type": "village",
            "poly": null,
            "longitude": 94.748611,
            "latitude": 55.906376
        },
        "688": {
            "name": "Малиновка",
            "population": 231,
            "type": "village",
            "poly": null,
            "longitude": 94.76634,
            "latitude": 55.1286102
        },
        "689": {
            "name": "Рыбное",
            "population": 1352,
            "type": "village",
            "poly": [
                [
                    94.7544627,
                    55.7758241
                ],
                [
                    94.7653203,
                    55.7790101
                ],
                [
                    94.7650628,
                    55.7806754
                ],
                [
                    94.7736459,
                    55.7817372
                ],
                [
                    94.7807269,
                    55.7834507
                ],
                [
                    94.7831302,
                    55.7838127
                ],
                [
                    94.7826581,
                    55.782413
                ],
                [
                    94.7851043,
                    55.7819062
                ],
                [
                    94.7910695,
                    55.7829922
                ],
                [
                    94.792829,
                    55.7825578
                ],
                [
                    94.7935586,
                    55.7828474
                ],
                [
                    94.7932153,
                    55.784609
                ],
                [
                    94.7970347,
                    55.7852606
                ],
                [
                    94.8009828,
                    55.7843436
                ],
                [
                    94.8055749,
                    55.7869738
                ],
                [
                    94.8075919,
                    55.7874564
                ],
                [
                    94.8128705,
                    55.7809891
                ],
                [
                    94.811111,
                    55.7805788
                ],
                [
                    94.8044591,
                    55.7795652
                ],
                [
                    94.7964767,
                    55.7785033
                ],
                [
                    94.7921424,
                    55.7771275
                ],
                [
                    94.7918849,
                    55.7751242
                ],
                [
                    94.7934728,
                    55.7722517
                ],
                [
                    94.790106,
                    55.7705849
                ],
                [
                    94.7821237,
                    55.7696434
                ],
                [
                    94.7661164,
                    55.7697399
                ],
                [
                    94.7580676,
                    55.7711413
                ],
                [
                    94.7551064,
                    55.7724207
                ],
                [
                    94.7544627,
                    55.7758241
                ]
            ],
            "longitude": 94.7694872,
            "latitude": 55.7759822
        },
        "690": {
            "name": "Двуречное",
            "population": 715,
            "type": "village",
            "poly": null,
            "longitude": 94.7701486,
            "latitude": 55.7097174
        },
        "691": {
            "name": "Унер",
            "population": 938,
            "type": "village",
            "poly": [
                [
                    94.7632634,
                    55.4410495
                ],
                [
                    94.7762512,
                    55.4424089
                ],
                [
                    94.7771789,
                    55.4449523
                ],
                [
                    94.7808896,
                    55.4456538
                ],
                [
                    94.78777,
                    55.4468377
                ],
                [
                    94.7965058,
                    55.4478462
                ],
                [
                    94.8006805,
                    55.4469254
                ],
                [
                    94.8031543,
                    55.4434175
                ],
                [
                    94.8006032,
                    55.4410934
                ],
                [
                    94.7850643,
                    55.4383744
                ],
                [
                    94.7811216,
                    55.4371902
                ],
                [
                    94.7728496,
                    55.4359184
                ],
                [
                    94.7654281,
                    55.4358306
                ],
                [
                    94.76365,
                    55.4366201
                ],
                [
                    94.7632634,
                    55.4410495
                ]
            ],
            "longitude": 94.7840042,
            "latitude": 55.4412673
        },
        "692": {
            "name": "Ирша",
            "population": 1326,
            "type": "village",
            "poly": null,
            "longitude": 94.797691,
            "latitude": 55.927376
        },
        "693": {
            "name": "Новая",
            "population": 120,
            "type": "village",
            "poly": null,
            "longitude": 94.8005336,
            "latitude": 55.8724581
        },
        "694": {
            "name": "Красногорьевка",
            "population": 479,
            "type": "village",
            "poly": null,
            "longitude": 94.8274611,
            "latitude": 55.576099
        },
        "695": {
            "name": "Троицк",
            "population": 582,
            "type": "village",
            "poly": null,
            "longitude": 94.8398886,
            "latitude": 57.4155086
        },
        "696": {
            "name": "Шеломки",
            "population": 530,
            "type": "village",
            "poly": null,
            "longitude": 94.8617755,
            "latitude": 56.8017128
        },
        "697": {
            "name": "Кирсантьево",
            "population": 355,
            "type": "village",
            "poly": null,
            "longitude": 94.8842747,
            "latitude": 57.7416196
        },
        "698": {
            "name": "Хандала",
            "population": 370,
            "type": "village",
            "poly": null,
            "longitude": 94.9159976,
            "latitude": 57.12773
        },
        "699": {
            "name": "Улюколь",
            "population": 644,
            "type": "village",
            "poly": null,
            "longitude": 94.923889,
            "latitude": 56.7061603
        },
        "700": {
            "name": "Малая Камала",
            "population": 403,
            "type": "village",
            "poly": null,
            "longitude": 94.9426974,
            "latitude": 56.0886241
        },
        "701": {
            "name": "Большой Ильбин",
            "population": 94,
            "type": "village",
            "poly": null,
            "longitude": 94.9436177,
            "latitude": 55.1770361
        },
        "702": {
            "name": "Вознесенка",
            "population": 350,
            "type": "village",
            "poly": null,
            "longitude": 94.9453934,
            "latitude": 55.0597832
        },
        "703": {
            "name": "Бородино",
            "population": 877,
            "type": "village",
            "poly": null,
            "longitude": 94.9679723,
            "latitude": 55.8714578
        },
        "704": {
            "name": "Межово",
            "population": 614,
            "type": "village",
            "poly": [
                [
                    94.9702825,
                    55.5432967
                ],
                [
                    94.9724798,
                    55.5465939
                ],
                [
                    94.9795179,
                    55.548439
                ],
                [
                    94.9956884,
                    55.5496092
                ],
                [
                    95.0016622,
                    55.5539739
                ],
                [
                    95.007842,
                    55.5514493
                ],
                [
                    95.007533,
                    55.5495121
                ],
                [
                    95.0047865,
                    55.5472785
                ],
                [
                    94.9992933,
                    55.5420341
                ],
                [
                    95.0001516,
                    55.5381488
                ],
                [
                    94.9962034,
                    55.5366918
                ],
                [
                    94.9822988,
                    55.5351375
                ],
                [
                    94.9810629,
                    55.5378526
                ],
                [
                    94.9711408,
                    55.5414513
                ],
                [
                    94.9702825,
                    55.5432967
                ]
            ],
            "longitude": 94.982389,
            "latitude": 55.5437555
        },
        "705": {
            "name": "Новокамала",
            "population": 1099,
            "type": "village",
            "poly": null,
            "longitude": 94.9872319,
            "latitude": 55.9729227
        },
        "706": {
            "name": "Таёжное",
            "population": 1028,
            "type": "village",
            "poly": null,
            "longitude": 94.996941,
            "latitude": 56.254204
        },
        "707": {
            "name": "Тинская",
            "population": 233,
            "type": "village",
            "poly": null,
            "longitude": 95.0377077,
            "latitude": 55.4198249
        },
        "708": {
            "name": "Красный Курыш",
            "population": 570,
            "type": "village",
            "poly": null,
            "longitude": 95.0455472,
            "latitude": 56.2144777
        },
        "709": {
            "name": "Нагорное",
            "population": 339,
            "type": "village",
            "poly": null,
            "longitude": 95.0584022,
            "latitude": 55.3194937
        },
        "710": {
            "name": "Гладково",
            "population": 359,
            "type": "village",
            "poly": null,
            "longitude": 95.081596,
            "latitude": 55.210724
        },
        "711": {
            "name": "Верхняя Уря",
            "population": 586,
            "type": "village",
            "poly": null,
            "longitude": 95.0822803,
            "latitude": 55.6737235
        },
        "712": {
            "name": "Денисово",
            "population": 972,
            "type": "village",
            "poly": null,
            "longitude": 95.094667,
            "latitude": 56.8530522
        },
        "713": {
            "name": "Елисеевка",
            "population": 419,
            "type": "village",
            "poly": null,
            "longitude": 95.097582,
            "latitude": 55.592025
        },
        "714": {
            "name": "Николаевка",
            "population": 317,
            "type": "village",
            "poly": null,
            "longitude": 95.1084792,
            "latitude": 56.4822839
        },
        "715": {
            "name": "Орьё",
            "population": 292,
            "type": "village",
            "poly": [
                [
                    95.1001753,
                    55.0132225
                ],
                [
                    95.1039979,
                    55.0146442
                ],
                [
                    95.1112297,
                    55.0134595
                ],
                [
                    95.1107274,
                    55.0128665
                ],
                [
                    95.1094734,
                    55.0113861
                ],
                [
                    95.1101966,
                    55.0101421
                ],
                [
                    95.1117462,
                    55.0090757
                ],
                [
                    95.1147423,
                    55.0089572
                ],
                [
                    95.1175318,
                    55.0082462
                ],
                [
                    95.1209411,
                    55.0035063
                ],
                [
                    95.114639,
                    55.0021435
                ],
                [
                    95.1111264,
                    55.0045729
                ],
                [
                    95.1036879,
                    55.0001881
                ],
                [
                    95.1011051,
                    55.0013732
                ],
                [
                    95.108337,
                    55.0055801
                ],
                [
                    95.1032747,
                    55.0105567
                ],
                [
                    95.1001753,
                    55.0132225
                ]
            ],
            "longitude": 95.1148376,
            "latitude": 55.0064798
        },
        "716": {
            "name": "Михайловка",
            "population": 195,
            "type": "village",
            "poly": null,
            "longitude": 95.1356363,
            "latitude": 56.6938174
        },
        "717": {
            "name": "Большие Ключи",
            "population": 508,
            "type": "village",
            "poly": null,
            "longitude": 95.1756416,
            "latitude": 55.9508053
        },
        "718": {
            "name": "Мокруша",
            "population": 930,
            "type": "village",
            "poly": null,
            "longitude": 95.1875341,
            "latitude": 56.4224758
        },
        "719": {
            "name": "Весёлое",
            "population": 400,
            "type": "village",
            "poly": null,
            "longitude": 95.1926728,
            "latitude": 57.0816798
        },
        "720": {
            "name": "Новая Солянка",
            "population": 2429,
            "type": "village",
            "poly": null,
            "longitude": 95.2025853,
            "latitude": 56.0063708
        },
        "721": {
            "name": "Терское",
            "population": 302,
            "type": "village",
            "poly": null,
            "longitude": 95.2034686,
            "latitude": 56.2138031
        },
        "722": {
            "name": "Хаерино",
            "population": 274,
            "type": "village",
            "poly": null,
            "longitude": 95.2035459,
            "latitude": 56.3396067
        },
        "723": {
            "name": "Николаевка",
            "population": 271,
            "type": "village",
            "poly": null,
            "longitude": 95.2041092,
            "latitude": 55.4339905
        },
        "724": {
            "name": "Ивановка",
            "population": 596,
            "type": "village",
            "poly": null,
            "longitude": 95.2301771,
            "latitude": 55.4488292
        },
        "725": {
            "name": "Александро-Ерша",
            "population": 439,
            "type": "village",
            "poly": null,
            "longitude": 95.2681805,
            "latitude": 56.6286757
        },
        "726": {
            "name": "Усть-Яруль",
            "population": 695,
            "type": "village",
            "poly": null,
            "longitude": 95.2793842,
            "latitude": 55.8042924
        },
        "727": {
            "name": "Тугач",
            "population": 534,
            "type": "village",
            "poly": null,
            "longitude": 95.288056,
            "latitude": 55.1357839
        },
        "728": {
            "name": "Усолка",
            "population": 539,
            "type": "village",
            "poly": null,
            "longitude": 95.3211407,
            "latitude": 56.7793854
        },
        "729": {
            "name": "Бошняково",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 95.3282041,
            "latitude": 56.1147684
        },
        "730": {
            "name": "Первое Мая",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 95.3487816,
            "latitude": 55.6098065
        },
        "731": {
            "name": "Нижний Танай",
            "population": 317,
            "type": "village",
            "poly": null,
            "longitude": 95.3628863,
            "latitude": 56.752651
        },
        "732": {
            "name": "Сухая Речка",
            "population": 302,
            "type": "village",
            "poly": null,
            "longitude": 95.3662127,
            "latitude": 56.2013153
        },
        "733": {
            "name": "Успенка",
            "population": 76,
            "type": "village",
            "poly": null,
            "longitude": 95.3742193,
            "latitude": 55.2912303
        },
        "734": {
            "name": "Александровка",
            "population": 431,
            "type": "village",
            "poly": null,
            "longitude": 95.3804606,
            "latitude": 55.5648271
        },
        "735": {
            "name": "Георгиевка",
            "population": 1120,
            "type": "village",
            "poly": [
                [
                    95.3774596,
                    56.5101625
                ],
                [
                    95.386386,
                    56.5177394
                ],
                [
                    95.3992606,
                    56.5166977
                ],
                [
                    95.4047881,
                    56.5194393
                ],
                [
                    95.4150535,
                    56.5200122
                ],
                [
                    95.4178,
                    56.5178341
                ],
                [
                    95.4231216,
                    56.51755
                ],
                [
                    95.4270698,
                    56.5095942
                ],
                [
                    95.3922225,
                    56.5094047
                ],
                [
                    95.3774596,
                    56.5101625
                ]
            ],
            "longitude": 95.4071936,
            "latitude": 56.5130937
        },
        "736": {
            "name": "Усть-Каначуль",
            "population": 156,
            "type": "village",
            "poly": null,
            "longitude": 95.421129,
            "latitude": 55.8651896
        },
        "737": {
            "name": "Изумрудный",
            "population": 658,
            "type": "village",
            "poly": [
                [
                    95.4073316,
                    55.6494083
                ],
                [
                    95.4102498,
                    55.6513454
                ],
                [
                    95.4102927,
                    55.6531275
                ],
                [
                    95.4199058,
                    55.6561298
                ],
                [
                    95.4315358,
                    55.656769
                ],
                [
                    95.4319221,
                    55.6527401
                ],
                [
                    95.422309,
                    55.6512873
                ],
                [
                    95.4145414,
                    55.6503769
                ],
                [
                    95.4089195,
                    55.6491564
                ],
                [
                    95.4073316,
                    55.6494083
                ]
            ],
            "longitude": 95.4225845,
            "latitude": 55.6542159
        },
        "738": {
            "name": "Нагорная",
            "population": 271,
            "type": "village",
            "poly": null,
            "longitude": 95.4324662,
            "latitude": 55.6722869
        },
        "739": {
            "name": "Красный Маяк",
            "population": 1134,
            "type": "village",
            "poly": null,
            "longitude": 95.4382282,
            "latitude": 56.2026184
        },
        "740": {
            "name": "Орджоникидзе",
            "population": 1461,
            "type": "village",
            "poly": null,
            "longitude": 95.458481,
            "latitude": 58.456604
        },
        "741": {
            "name": "Филимоново",
            "population": 2900,
            "type": "village",
            "poly": null,
            "longitude": 95.461113,
            "latitude": 56.201477
        },
        "742": {
            "name": "Чухломино",
            "population": 446,
            "type": "village",
            "poly": null,
            "longitude": 95.4661193,
            "latitude": 55.7976101
        },
        "743": {
            "name": "Астафьевка",
            "population": 976,
            "type": "village",
            "poly": [
                [
                    95.4536398,
                    56.3972311
                ],
                [
                    95.4556568,
                    56.4022422
                ],
                [
                    95.4688748,
                    56.403572
                ],
                [
                    95.4849787,
                    56.4034853
                ],
                [
                    95.489384,
                    56.4021175
                ],
                [
                    95.4889012,
                    56.3964224
                ],
                [
                    95.4846998,
                    56.3958951
                ],
                [
                    95.4789878,
                    56.3964651
                ],
                [
                    95.4770137,
                    56.3933773
                ],
                [
                    95.4764986,
                    56.392831
                ],
                [
                    95.4751254,
                    56.3922372
                ],
                [
                    95.4714347,
                    56.3909545
                ],
                [
                    95.4694327,
                    56.3905803
                ],
                [
                    95.4590901,
                    56.3930032
                ],
                [
                    95.4587038,
                    56.3953785
                ],
                [
                    95.4567727,
                    56.395616
                ],
                [
                    95.4536398,
                    56.3972311
                ]
            ],
            "longitude": 95.4719291,
            "latitude": 56.3969159
        },
        "744": {
            "name": "Большая Уря",
            "population": 1223,
            "type": "village",
            "poly": null,
            "longitude": 95.482086,
            "latitude": 56.026051
        },
        "745": {
            "name": "Фаначет",
            "population": 473,
            "type": "village",
            "poly": null,
            "longitude": 95.4869723,
            "latitude": 57.1454287
        },
        "746": {
            "name": "Курай",
            "population": 648,
            "type": "village",
            "poly": null,
            "longitude": 95.4915724,
            "latitude": 56.6872028
        },
        "747": {
            "name": "Орловка",
            "population": 465,
            "type": "village",
            "poly": null,
            "longitude": 95.501343,
            "latitude": 56.935833
        },
        "748": {
            "name": "Тайна",
            "population": 305,
            "type": "village",
            "poly": null,
            "longitude": 95.5040715,
            "latitude": 56.4407927
        },
        "749": {
            "name": "Юдино",
            "population": 822,
            "type": "village",
            "poly": null,
            "longitude": 95.5043234,
            "latitude": 55.6685791
        },
        "750": {
            "name": "Анцирь",
            "population": 1262,
            "type": "village",
            "poly": null,
            "longitude": 95.5381308,
            "latitude": 56.2534217
        },
        "751": {
            "name": "Сотниково",
            "population": 1041,
            "type": "village",
            "poly": [
                [
                    95.5190846,
                    56.3472276
                ],
                [
                    95.5211445,
                    56.3492727
                ],
                [
                    95.5292555,
                    56.3489398
                ],
                [
                    95.5361885,
                    56.3517352
                ],
                [
                    95.5397183,
                    56.351885
                ],
                [
                    95.5411538,
                    56.3528254
                ],
                [
                    95.5412096,
                    56.3541391
                ],
                [
                    95.5433768,
                    56.3545814
                ],
                [
                    95.545235,
                    56.3541831
                ],
                [
                    95.5454345,
                    56.353767
                ],
                [
                    95.5458509,
                    56.3529514
                ],
                [
                    95.5465075,
                    56.3510325
                ],
                [
                    95.5473958,
                    56.349765
                ],
                [
                    95.5517432,
                    56.3515081
                ],
                [
                    95.5573651,
                    56.3523403
                ],
                [
                    95.5597683,
                    56.3499624
                ],
                [
                    95.5588242,
                    56.3480599
                ],
                [
                    95.5575668,
                    56.3474107
                ],
                [
                    95.5552923,
                    56.3473631
                ],
                [
                    95.5522453,
                    56.3462691
                ],
                [
                    95.5485545,
                    56.3438432
                ],
                [
                    95.5486103,
                    56.3421141
                ],
                [
                    95.5469667,
                    56.3416075
                ],
                [
                    95.5456363,
                    56.3412507
                ],
                [
                    95.5439326,
                    56.3411151
                ],
                [
                    95.5407139,
                    56.3410913
                ],
                [
                    95.5369374,
                    56.3412816
                ],
                [
                    95.5330621,
                    56.3414886
                ],
                [
                    95.5292555,
                    56.3414719
                ],
                [
                    95.5277535,
                    56.3413292
                ],
                [
                    95.5271527,
                    56.341567
                ],
                [
                    95.5273672,
                    56.3436363
                ],
                [
                    95.5241486,
                    56.3438979
                ],
                [
                    95.5238353,
                    56.3428919
                ],
                [
                    95.5231186,
                    56.3428039
                ],
                [
                    95.5215737,
                    56.3431369
                ],
                [
                    95.5217453,
                    56.3440644
                ],
                [
                    95.5202003,
                    56.3441596
                ],
                [
                    95.5195566,
                    56.3452536
                ],
                [
                    95.5190846,
                    56.3472276
                ]
            ],
            "longitude": 95.5420466,
            "latitude": 56.3436364
        },
        "752": {
            "name": "Тумаково",
            "population": 563,
            "type": "village",
            "poly": null,
            "longitude": 95.5613828,
            "latitude": 55.7939558
        },
        "753": {
            "name": "Мельничное",
            "population": 442,
            "type": "village",
            "poly": [
                [
                    95.5750383,
                    55.5979449
                ],
                [
                    95.5806001,
                    55.602057
                ],
                [
                    95.586265,
                    55.6061298
                ],
                [
                    95.5881531,
                    55.6086509
                ],
                [
                    95.5884279,
                    55.6110361
                ],
                [
                    95.5937493,
                    55.6126843
                ],
                [
                    95.5994142,
                    55.6094848
                ],
                [
                    95.6002725,
                    55.606091
                ],
                [
                    95.594436,
                    55.602794
                ],
                [
                    95.5800165,
                    55.5960051
                ],
                [
                    95.57521,
                    55.5960051
                ],
                [
                    95.5750383,
                    55.5979449
                ]
            ],
            "longitude": 95.59079,
            "latitude": 55.605072
        },
        "754": {
            "name": "Рудяное",
            "population": 633,
            "type": "village",
            "poly": null,
            "longitude": 95.6183696,
            "latitude": 56.5013584
        },
        "755": {
            "name": "Верх-Амонаш",
            "population": 768,
            "type": "village",
            "poly": null,
            "longitude": 95.624789,
            "latitude": 55.9050721
        },
        "756": {
            "name": "Берёзовка",
            "population": 609,
            "type": "village",
            "poly": null,
            "longitude": 95.629143,
            "latitude": 56.617229
        },
        "757": {
            "name": "Бережки",
            "population": 331,
            "type": "village",
            "poly": null,
            "longitude": 95.6365629,
            "latitude": 56.2311259
        },
        "758": {
            "name": "Маловка",
            "population": 255,
            "type": "village",
            "poly": null,
            "longitude": 95.6563793,
            "latitude": 55.6807249
        },
        "759": {
            "name": "Талое",
            "population": 546,
            "type": "village",
            "poly": null,
            "longitude": 95.6648973,
            "latitude": 55.4089041
        },
        "760": {
            "name": "Шахтинский",
            "population": 345,
            "type": "village",
            "poly": null,
            "longitude": 95.6848695,
            "latitude": 56.293691
        },
        "761": {
            "name": "Чечеул",
            "population": 2480,
            "type": "village",
            "poly": null,
            "longitude": 95.7173697,
            "latitude": 56.1310472
        },
        "762": {
            "name": "Степняки",
            "population": 360,
            "type": "village",
            "poly": null,
            "longitude": 95.7291595,
            "latitude": 55.9558882
        },
        "763": {
            "name": "Арефьевка",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 95.7312072,
            "latitude": 56.3576182
        },
        "764": {
            "name": "Петропавловка-1",
            "population": 259,
            "type": "village",
            "poly": null,
            "longitude": 95.7436634,
            "latitude": 55.6801696
        },
        "765": {
            "name": "Степановка",
            "population": 663,
            "type": "village",
            "poly": null,
            "longitude": 95.767585,
            "latitude": 55.1743158
        },
        "766": {
            "name": "Зелёный Луг",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 95.7686033,
            "latitude": 56.1636835
        },
        "767": {
            "name": "Бычковка",
            "population": 289,
            "type": "village",
            "poly": null,
            "longitude": 95.7714595,
            "latitude": 55.6353431
        },
        "768": {
            "name": "Покровка",
            "population": 92,
            "type": "village",
            "poly": null,
            "longitude": 95.779541,
            "latitude": 56.903278
        },
        "769": {
            "name": "Новый Путь",
            "population": 346,
            "type": "village",
            "poly": null,
            "longitude": 95.782951,
            "latitude": 56.185532
        },
        "770": {
            "name": "Благовещенка",
            "population": 304,
            "type": "village",
            "poly": null,
            "longitude": 95.8085052,
            "latitude": 55.4432606
        },
        "771": {
            "name": "Заозёрка",
            "population": 157,
            "type": "village",
            "poly": null,
            "longitude": 95.8171397,
            "latitude": 56.7144195
        },
        "772": {
            "name": "Ашкаул",
            "population": 598,
            "type": "village",
            "poly": null,
            "longitude": 95.8211824,
            "latitude": 56.1068137
        },
        "773": {
            "name": "Тарай",
            "population": 377,
            "type": "village",
            "poly": null,
            "longitude": 95.8365367,
            "latitude": 55.8612048
        },
        "774": {
            "name": "Амонаш",
            "population": 308,
            "type": "village",
            "poly": null,
            "longitude": 95.8405721,
            "latitude": 55.9035802
        },
        "775": {
            "name": "Бражное",
            "population": 1756,
            "type": "village",
            "poly": null,
            "longitude": 95.859383,
            "latitude": 56.063446
        },
        "776": {
            "name": "Агул",
            "population": 353,
            "type": "village",
            "poly": null,
            "longitude": 95.8874405,
            "latitude": 55.5041068
        },
        "777": {
            "name": "Карапсель",
            "population": 874,
            "type": "village",
            "poly": null,
            "longitude": 95.8884259,
            "latitude": 56.2153603
        },
        "778": {
            "name": "Соколовка",
            "population": 404,
            "type": "village",
            "poly": null,
            "longitude": 95.9015174,
            "latitude": 56.4266589
        },
        "779": {
            "name": "Самойловка",
            "population": 599,
            "type": "village",
            "poly": null,
            "longitude": 95.9020494,
            "latitude": 56.8353719
        },
        "780": {
            "name": "Далай",
            "population": 476,
            "type": "village",
            "poly": null,
            "longitude": 95.9022088,
            "latitude": 56.2947426
        },
        "781": {
            "name": "Кучердаевка",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 95.927705,
            "latitude": 55.9448144
        },
        "782": {
            "name": "Никольск",
            "population": 322,
            "type": "village",
            "poly": null,
            "longitude": 95.951298,
            "latitude": 56.7747446
        },
        "783": {
            "name": "Устьянск",
            "population": 908,
            "type": "village",
            "poly": null,
            "longitude": 96.016266,
            "latitude": 56.522594
        },
        "784": {
            "name": "Денисовка",
            "population": 343,
            "type": "village",
            "poly": null,
            "longitude": 96.064444,
            "latitude": 56.5795079
        },
        "785": {
            "name": "Новопокровка",
            "population": 566,
            "type": "village",
            "poly": null,
            "longitude": 96.1097307,
            "latitude": 56.3562021
        },
        "786": {
            "name": "Нижнетерянск",
            "population": 518,
            "type": "village",
            "poly": null,
            "longitude": 96.15786,
            "latitude": 58.503815
        },
        "787": {
            "name": "Новогородка",
            "population": 600,
            "type": "village",
            "poly": null,
            "longitude": 96.163349,
            "latitude": 56.460006
        },
        "788": {
            "name": "Южно-Александровка",
            "population": 970,
            "type": "village",
            "poly": null,
            "longitude": 96.181023,
            "latitude": 55.851036
        },
        "789": {
            "name": "Новониколаевка",
            "population": 1471,
            "type": "village",
            "poly": null,
            "longitude": 96.1907477,
            "latitude": 55.7890537
        },
        "790": {
            "name": "Петропавловка",
            "population": 207,
            "type": "village",
            "poly": null,
            "longitude": 96.2119862,
            "latitude": 56.6189756
        },
        "791": {
            "name": "Апано-Ключи",
            "population": 370,
            "type": "village",
            "poly": null,
            "longitude": 96.221741,
            "latitude": 56.862183
        },
        "792": {
            "name": "Юрубчён-5",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 96.2403792,
            "latitude": 60.4310103
        },
        "793": {
            "name": "Манзя",
            "population": 1881,
            "type": "village",
            "poly": [
                [
                    96.2167158,
                    58.4816688
                ],
                [
                    96.2313832,
                    58.4855194
                ],
                [
                    96.2396092,
                    58.4866647
                ],
                [
                    96.2463809,
                    58.4880337
                ],
                [
                    96.2542753,
                    58.4910857
                ],
                [
                    96.2646088,
                    58.4954477
                ],
                [
                    96.2695017,
                    58.4982005
                ],
                [
                    96.276205,
                    58.5012669
                ],
                [
                    96.2823848,
                    58.5043835
                ],
                [
                    96.2941351,
                    58.509254
                ],
                [
                    96.3087692,
                    58.5135579
                ],
                [
                    96.3097648,
                    58.5116694
                ],
                [
                    96.2981262,
                    58.507483
                ],
                [
                    96.2954225,
                    58.5064293
                ],
                [
                    96.2982549,
                    58.5033578
                ],
                [
                    96.301259,
                    58.5016089
                ],
                [
                    96.3003149,
                    58.5012714
                ],
                [
                    96.2966242,
                    58.5022131
                ],
                [
                    96.2922125,
                    58.4983519
                ],
                [
                    96.285037,
                    58.4937815
                ],
                [
                    96.2810888,
                    58.4934227
                ],
                [
                    96.275424,
                    58.4910902
                ],
                [
                    96.2656049,
                    58.4884838
                ],
                [
                    96.2460699,
                    58.4835533
                ],
                [
                    96.2352209,
                    58.4832796
                ],
                [
                    96.2262945,
                    58.4822027
                ],
                [
                    96.2252989,
                    58.4811303
                ],
                [
                    96.2167158,
                    58.4816688
                ]
            ],
            "longitude": 96.2623016,
            "latitude": 58.491356
        },
        "794": {
            "name": "Степаново",
            "population": 342,
            "type": "village",
            "poly": null,
            "longitude": 96.2988977,
            "latitude": 56.2238153
        },
        "795": {
            "name": "Новоуспенка",
            "population": 620,
            "type": "village",
            "poly": null,
            "longitude": 96.3227404,
            "latitude": 56.7706757
        },
        "796": {
            "name": "Касьяново",
            "population": 184,
            "type": "village",
            "poly": null,
            "longitude": 96.3546485,
            "latitude": 56.054909
        },
        "797": {
            "name": "Залипье",
            "population": 467,
            "type": "village",
            "poly": null,
            "longitude": 96.370374,
            "latitude": 56.6704083
        },
        "798": {
            "name": "Сулемка",
            "population": 816,
            "type": "village",
            "poly": null,
            "longitude": 96.3840453,
            "latitude": 56.2046465
        },
        "799": {
            "name": "Байкит",
            "population": 3312,
            "type": "village",
            "poly": null,
            "longitude": 96.385361,
            "latitude": 61.678383
        },
        "800": {
            "name": "Стретенка",
            "population": 390,
            "type": "village",
            "poly": null,
            "longitude": 96.4000046,
            "latitude": 56.4644767
        },
        "801": {
            "name": "Турово",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 96.4172404,
            "latitude": 56.6521721
        },
        "802": {
            "name": "Ельники",
            "population": 434,
            "type": "village",
            "poly": null,
            "longitude": 96.4172579,
            "latitude": 55.7417533
        },
        "803": {
            "name": "Почет",
            "population": 947,
            "type": "village",
            "poly": null,
            "longitude": 96.422195,
            "latitude": 57.192383
        },
        "804": {
            "name": "Учами",
            "population": 103,
            "type": "village",
            "poly": null,
            "longitude": 96.445068,
            "latitude": 63.812748
        },
        "805": {
            "name": "Верхний Ингаш",
            "population": 725,
            "type": "village",
            "poly": [
                [
                    96.4061066,
                    56.2094297
                ],
                [
                    96.4068257,
                    56.2097601
                ],
                [
                    96.4380305,
                    56.2109426
                ],
                [
                    96.4402192,
                    56.209308
                ],
                [
                    96.4430333,
                    56.2115512
                ],
                [
                    96.4464102,
                    56.2119859
                ],
                [
                    96.4499121,
                    56.2122293
                ],
                [
                    96.4589484,
                    56.2109599
                ],
                [
                    96.4584794,
                    56.2093601
                ],
                [
                    96.4618562,
                    56.2089949
                ],
                [
                    96.4603867,
                    56.2079863
                ],
                [
                    96.4587295,
                    56.2079515
                ],
                [
                    96.4587295,
                    56.2049081
                ],
                [
                    96.4106403,
                    56.2075516
                ],
                [
                    96.4080452,
                    56.2078298
                ],
                [
                    96.4061066,
                    56.2094297
                ]
            ],
            "longitude": 96.4455267,
            "latitude": 56.2084252
        },
        "806": {
            "name": "Ивановка",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 96.5124752,
            "latitude": 56.3115186
        },
        "807": {
            "name": "Новоалександровка",
            "population": 289,
            "type": "village",
            "poly": null,
            "longitude": 96.5795577,
            "latitude": 56.4221837
        },
        "808": {
            "name": "Хайрюзовка",
            "population": 782,
            "type": "village",
            "poly": null,
            "longitude": 96.6221543,
            "latitude": 55.7920117
        },
        "809": {
            "name": "Павловка",
            "population": 368,
            "type": "village",
            "poly": null,
            "longitude": 96.6228384,
            "latitude": 56.0852939
        },
        "810": {
            "name": "Такучет",
            "population": 705,
            "type": "village",
            "poly": null,
            "longitude": 96.6980743,
            "latitude": 57.6175579
        },
        "811": {
            "name": "Артюгино",
            "population": 687,
            "type": "village",
            "poly": null,
            "longitude": 96.7373664,
            "latitude": 58.5033752
        },
        "812": {
            "name": "Поймо-Тины",
            "population": 1234,
            "type": "village",
            "poly": null,
            "longitude": 96.738109,
            "latitude": 56.0754092
        },
        "813": {
            "name": "Соколовка",
            "population": 600,
            "type": "village",
            "poly": null,
            "longitude": 96.7464014,
            "latitude": 56.3741332
        },
        "814": {
            "name": "Долгий Мост",
            "population": 2254,
            "type": "village",
            "poly": null,
            "longitude": 96.806709,
            "latitude": 56.74707
        },
        "815": {
            "name": "Тины",
            "population": 1406,
            "type": "village",
            "poly": null,
            "longitude": 96.8497647,
            "latitude": 56.1298002
        },
        "816": {
            "name": "Тинской",
            "population": 3474,
            "type": "village",
            "poly": null,
            "longitude": 96.912376,
            "latitude": 56.146004
        },
        "817": {
            "name": "Осиновый Мыс",
            "population": 1600,
            "type": "village",
            "poly": null,
            "longitude": 96.9143418,
            "latitude": 57.5679609
        },
        "818": {
            "name": "Пинчуга",
            "population": 2370,
            "type": "village",
            "poly": null,
            "longitude": 96.9354914,
            "latitude": 58.3720368
        },
        "819": {
            "name": "Кучерово",
            "population": 368,
            "type": "village",
            "poly": null,
            "longitude": 96.962008,
            "latitude": 56.311517
        },
        "820": {
            "name": "Куюмба",
            "population": 179,
            "type": "village",
            "poly": null,
            "longitude": 96.975212,
            "latitude": 60.960072
        },
        "821": {
            "name": "Вознесенка",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 96.9972948,
            "latitude": 56.971481
        },
        "822": {
            "name": "Александровка",
            "population": 269,
            "type": "village",
            "poly": null,
            "longitude": 97.010858,
            "latitude": 56.3402501
        },
        "823": {
            "name": "Хандальск",
            "population": 222,
            "type": "village",
            "poly": null,
            "longitude": 97.1261731,
            "latitude": 57.0917272
        },
        "824": {
            "name": "Ангарский",
            "population": 2008,
            "type": "village",
            "poly": null,
            "longitude": 97.145955,
            "latitude": 58.4381343
        },
        "825": {
            "name": "Беляки",
            "population": 234,
            "type": "village",
            "poly": null,
            "longitude": 97.202237,
            "latitude": 58.8649503
        },
        "826": {
            "name": "Бельняки",
            "population": 455,
            "type": "village",
            "poly": null,
            "longitude": 97.2395364,
            "latitude": 56.241349
        },
        "827": {
            "name": "Курдояки",
            "population": 515,
            "type": "village",
            "poly": null,
            "longitude": 97.2513289,
            "latitude": 56.0892518
        },
        "828": {
            "name": "Таёжный",
            "population": 6048,
            "type": "village",
            "poly": [
                [
                    97.2847962,
                    58.0597635
                ],
                [
                    97.2868835,
                    58.061974
                ],
                [
                    97.2884361,
                    58.0666655
                ],
                [
                    97.2881709,
                    58.078679
                ],
                [
                    97.2893771,
                    58.0813074
                ],
                [
                    97.3019313,
                    58.0881749
                ],
                [
                    97.3287419,
                    58.0823569
                ],
                [
                    97.3448733,
                    58.06612
                ],
                [
                    97.34659,
                    58.0642132
                ],
                [
                    97.3459033,
                    58.0625787
                ],
                [
                    97.3428155,
                    58.0616385
                ],
                [
                    97.334601,
                    58.0618832
                ],
                [
                    97.3215548,
                    58.0568429
                ],
                [
                    97.3169779,
                    58.0551562
                ],
                [
                    97.2868835,
                    58.055753
                ],
                [
                    97.2847962,
                    58.0597635
                ]
            ],
            "longitude": 97.307556,
            "latitude": 58.075111
        },
        "829": {
            "name": "Канифольный",
            "population": 1310,
            "type": "village",
            "poly": null,
            "longitude": 97.3244924,
            "latitude": 56.2694334
        },
        "830": {
            "name": "Чунояр",
            "population": 3028,
            "type": "village",
            "poly": null,
            "longitude": 97.3263487,
            "latitude": 57.4495181
        },
        "831": {
            "name": "Карабула",
            "population": 631,
            "type": "village",
            "poly": [
                [
                    97.3750215,
                    58.0398801
                ],
                [
                    97.3767243,
                    58.0414662
                ],
                [
                    97.381054,
                    58.0419391
                ],
                [
                    97.3856443,
                    58.0354852
                ],
                [
                    97.3904066,
                    58.0364014
                ],
                [
                    97.395124,
                    58.036508
                ],
                [
                    97.3996562,
                    58.034247
                ],
                [
                    97.3998064,
                    58.0321113
                ],
                [
                    97.3986788,
                    58.0307179
                ],
                [
                    97.3920135,
                    58.0298955
                ],
                [
                    97.3843656,
                    58.030591
                ],
                [
                    97.3776843,
                    58.0363549
                ],
                [
                    97.3750215,
                    58.0398801
                ]
            ],
            "longitude": 97.389473,
            "latitude": 58.032879
        },
        "832": {
            "name": "Суринда",
            "population": 442,
            "type": "village",
            "poly": null,
            "longitude": 97.408539,
            "latitude": 62.556477
        },
        "833": {
            "name": "Покатеево",
            "population": 533,
            "type": "village",
            "poly": null,
            "longitude": 97.4119931,
            "latitude": 56.9973844
        },
        "834": {
            "name": "Новохайский",
            "population": 1069,
            "type": "village",
            "poly": null,
            "longitude": 97.4197364,
            "latitude": 57.7533657
        },
        "835": {
            "name": "Гремучий",
            "population": 1881,
            "type": "village",
            "poly": null,
            "longitude": 97.442589,
            "latitude": 58.406101
        },
        "836": {
            "name": "Октябрьский",
            "population": 5879,
            "type": "village",
            "poly": null,
            "longitude": 97.522934,
            "latitude": 57.443951
        },
        "837": {
            "name": "Красногорьевский",
            "population": 1512,
            "type": "village",
            "poly": null,
            "longitude": 97.5287064,
            "latitude": 58.409848
        },
        "838": {
            "name": "Поканаевка",
            "population": 551,
            "type": "village",
            "poly": null,
            "longitude": 97.660767,
            "latitude": 56.517387
        },
        "839": {
            "name": "Тиличеть",
            "population": 471,
            "type": "village",
            "poly": [
                [
                    97.6914527,
                    56.6842336
                ],
                [
                    97.6988244,
                    56.6862163
                ],
                [
                    97.7047141,
                    56.6863206
                ],
                [
                    97.7120562,
                    56.6852894
                ],
                [
                    97.7139101,
                    56.6809948
                ],
                [
                    97.7156873,
                    56.6792245
                ],
                [
                    97.7199056,
                    56.6788408
                ],
                [
                    97.7257899,
                    56.6763315
                ],
                [
                    97.727074,
                    56.6753355
                ],
                [
                    97.7293578,
                    56.6758816
                ],
                [
                    97.7369079,
                    56.6761326
                ],
                [
                    97.7388693,
                    56.6750255
                ],
                [
                    97.7364243,
                    56.6740217
                ],
                [
                    97.7227212,
                    56.6714678
                ],
                [
                    97.6939328,
                    56.6786073
                ],
                [
                    97.6914527,
                    56.6842336
                ]
            ],
            "longitude": 97.707365,
            "latitude": 56.682048
        },
        "840": {
            "name": "Кежек",
            "population": 275,
            "type": "village",
            "poly": null,
            "longitude": 97.7848807,
            "latitude": 57.8195231
        },
        "841": {
            "name": "Шиверский",
            "population": 1013,
            "type": "village",
            "poly": null,
            "longitude": 97.8043089,
            "latitude": 58.4198407
        },
        "842": {
            "name": "Ошарово",
            "population": 112,
            "type": "village",
            "poly": null,
            "longitude": 98.3129065,
            "latitude": 60.3733178
        },
        "843": {
            "name": "Невонка",
            "population": 1736,
            "type": "village",
            "poly": null,
            "longitude": 98.3244912,
            "latitude": 58.4244732
        },
        "844": {
            "name": "Хребтовый",
            "population": 1523,
            "type": "village",
            "poly": null,
            "longitude": 98.6193261,
            "latitude": 58.5834763
        },
        "845": {
            "name": "Говорково",
            "population": 739,
            "type": "village",
            "poly": null,
            "longitude": 98.7227975,
            "latitude": 58.6016648
        },
        "846": {
            "name": "Заледеево",
            "population": 1167,
            "type": "village",
            "poly": null,
            "longitude": 98.817421,
            "latitude": 58.670349
        },
        "847": {
            "name": "Ирба",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 98.9915319,
            "latitude": 58.0972481
        },
        "848": {
            "name": "Тагара",
            "population": 1551,
            "type": "village",
            "poly": null,
            "longitude": 99.0013117,
            "latitude": 58.7237617
        },
        "849": {
            "name": "Мирюга",
            "population": 44,
            "type": "village",
            "poly": null,
            "longitude": 99.3652817,
            "latitude": 60.3080775
        },
        "850": {
            "name": "Катырык",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 99.3844909,
            "latitude": 71.2741932
        },
        "851": {
            "name": "Яркино",
            "population": 144,
            "type": "village",
            "poly": null,
            "longitude": 99.3962526,
            "latitude": 59.1289942
        },
        "852": {
            "name": "Имбинский",
            "population": 605,
            "type": "village",
            "poly": null,
            "longitude": 99.6131285,
            "latitude": 58.1035374
        },
        "853": {
            "name": "Хета",
            "population": 368,
            "type": "village",
            "poly": null,
            "longitude": 99.6524644,
            "latitude": 71.5634237
        },
        "854": {
            "name": "Нидым",
            "population": 206,
            "type": "village",
            "poly": null,
            "longitude": 99.9175066,
            "latitude": 64.1145202
        },
        "855": {
            "name": "Болтурино",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 100.076194,
            "latitude": 58.3065189
        },
        "856": {
            "name": "Чиринда",
            "population": 194,
            "type": "village",
            "poly": null,
            "longitude": 100.41082,
            "latitude": 67.542549
        },
        "857": {
            "name": "Таёжный",
            "population": 237,
            "type": "village",
            "poly": null,
            "longitude": 100.4825824,
            "latitude": 58.6610554
        },
        "858": {
            "name": "Муторай",
            "population": 89,
            "type": "village",
            "poly": null,
            "longitude": 100.4826283,
            "latitude": 61.326463
        },
        "859": {
            "name": "Недокура",
            "population": 486,
            "type": "village",
            "poly": null,
            "longitude": 100.6210033,
            "latitude": 58.5752438
        },
        "860": {
            "name": "Новая Кежма",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 101.2160931,
            "latitude": 59.007947
        },
        "861": {
            "name": "Новая",
            "population": 313,
            "type": "village",
            "poly": null,
            "longitude": 101.2288092,
            "latitude": 71.7480948
        },
        "862": {
            "name": "Кресты",
            "population": 274,
            "type": "village",
            "poly": null,
            "longitude": 102.123001,
            "latitude": 71.914948
        },
        "863": {
            "name": "Ессей",
            "population": 630,
            "type": "village",
            "poly": null,
            "longitude": 102.186325,
            "latitude": 68.464638
        },
        "864": {
            "name": "Стрелка-Чуня",
            "population": 182,
            "type": "village",
            "poly": null,
            "longitude": 102.7989591,
            "latitude": 61.7389896
        },
        "865": {
            "name": "Чемдальск",
            "population": 46,
            "type": "village",
            "poly": null,
            "longitude": 103.324638,
            "latitude": 59.629391
        },
        "866": {
            "name": "Кислокан",
            "population": 115,
            "type": "village",
            "poly": null,
            "longitude": 103.95089,
            "latitude": 63.58852
        },
        "867": {
            "name": "Эконда",
            "population": 273,
            "type": "village",
            "poly": null,
            "longitude": 105.328712,
            "latitude": 65.75399
        },
        "868": {
            "name": "Юкта",
            "population": 90,
            "type": "village",
            "poly": null,
            "longitude": 105.6568364,
            "latitude": 63.3831793
        },
        "869": {
            "name": "Новорыбная",
            "population": 556,
            "type": "village",
            "poly": null,
            "longitude": 105.79924,
            "latitude": 72.833984
        },
        "870": {
            "name": "Сындасско",
            "population": 496,
            "type": "village",
            "poly": null,
            "longitude": 108.207542,
            "latitude": 73.260483
        },
        "871": {
            "name": "Попигай",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 110.7882575,
            "latitude": 71.8895161
        },
        "872": {
            "name": "Кара-Холь",
            "population": 1392,
            "type": "village",
            "poly": null,
            "longitude": 89.7635383,
            "latitude": 51.2812549
        },
        "873": {
            "name": "Кызыл-Хая",
            "population": 1393,
            "type": "village",
            "poly": null,
            "longitude": 89.8706419,
            "latitude": 50.0483456
        },
        "874": {
            "name": "Бай-Тал",
            "population": 1786,
            "type": "village",
            "poly": null,
            "longitude": 90.0583621,
            "latitude": 50.9109348
        },
        "875": {
            "name": "Кызыл-Даг",
            "population": 858,
            "type": "village",
            "poly": null,
            "longitude": 90.1068754,
            "latitude": 51.0397186
        },
        "876": {
            "name": "Хемчик",
            "population": 800,
            "type": "village",
            "poly": null,
            "longitude": 90.187257,
            "latitude": 51.0179155
        },
        "877": {
            "name": "Тээли",
            "population": 3389,
            "type": "village",
            "poly": null,
            "longitude": 90.2043058,
            "latitude": 51.0110954
        },
        "878": {
            "name": "Дружба",
            "population": 578,
            "type": "village",
            "poly": null,
            "longitude": 90.2180158,
            "latitude": 51.0078721
        },
        "879": {
            "name": "Хонделен",
            "population": 558,
            "type": "village",
            "poly": null,
            "longitude": 90.3056838,
            "latitude": 51.2528323
        },
        "880": {
            "name": "Шуй",
            "population": 1832,
            "type": "village",
            "poly": null,
            "longitude": 90.3405632,
            "latitude": 50.886521
        },
        "881": {
            "name": "Аксы-Барлык",
            "population": 933,
            "type": "village",
            "poly": null,
            "longitude": 90.4021823,
            "latitude": 51.1175678
        },
        "882": {
            "name": "Эрги-Барлык",
            "population": 1616,
            "type": "village",
            "poly": null,
            "longitude": 90.4042675,
            "latitude": 50.9346854
        },
        "883": {
            "name": "Барлык",
            "population": 1470,
            "type": "village",
            "poly": null,
            "longitude": 90.541542,
            "latitude": 51.1348844
        },
        "884": {
            "name": "Бижиктиг-Хая",
            "population": 574,
            "type": "village",
            "poly": null,
            "longitude": 90.6385447,
            "latitude": 51.0998154
        },
        "885": {
            "name": "Тоолайлыг",
            "population": 161,
            "type": "village",
            "poly": null,
            "longitude": 90.6561789,
            "latitude": 50.531638
        },
        "886": {
            "name": "Шекпээр",
            "population": 1271,
            "type": "village",
            "poly": null,
            "longitude": 90.6817543,
            "latitude": 51.1683632
        },
        "887": {
            "name": "Дон-Терезин",
            "population": 810,
            "type": "village",
            "poly": null,
            "longitude": 90.7030085,
            "latitude": 51.2144574
        },
        "888": {
            "name": "Аянгаты",
            "population": 540,
            "type": "village",
            "poly": null,
            "longitude": 90.8429369,
            "latitude": 50.9934854
        },
        "889": {
            "name": "Алдан-Маадыр",
            "population": 1110,
            "type": "village",
            "poly": null,
            "longitude": 90.9751627,
            "latitude": 51.2965803
        },
        "890": {
            "name": "Чыргакы",
            "population": 793,
            "type": "village",
            "poly": null,
            "longitude": 91.0065595,
            "latitude": 51.0626072
        },
        "891": {
            "name": "Хорум-Даг",
            "population": 447,
            "type": "village",
            "poly": null,
            "longitude": 91.0480747,
            "latitude": 51.2823568
        },
        "892": {
            "name": "Чыраа-Бажы",
            "population": 1516,
            "type": "village",
            "poly": null,
            "longitude": 91.0529139,
            "latitude": 51.1684485
        },
        "893": {
            "name": "Элдиг-Хем",
            "population": 227,
            "type": "village",
            "poly": null,
            "longitude": 91.1070559,
            "latitude": 50.8703093
        },
        "894": {
            "name": "Ак-Даш",
            "population": 548,
            "type": "village",
            "poly": null,
            "longitude": 91.1281674,
            "latitude": 51.3410954
        },
        "895": {
            "name": "Бора-Тайга",
            "population": 766,
            "type": "village",
            "poly": null,
            "longitude": 91.146738,
            "latitude": 51.4044258
        },
        "896": {
            "name": "Суг-Аксы",
            "population": 3139,
            "type": "village",
            "poly": null,
            "longitude": 91.278786,
            "latitude": 51.402248
        },
        "897": {
            "name": "Шеми",
            "population": 1109,
            "type": "village",
            "poly": null,
            "longitude": 91.2914366,
            "latitude": 51.1566992
        },
        "898": {
            "name": "Кара-Чыраа",
            "population": 777,
            "type": "village",
            "poly": null,
            "longitude": 91.3184404,
            "latitude": 51.4169104
        },
        "899": {
            "name": "Саглы",
            "population": 818,
            "type": "village",
            "poly": [
                [
                    91.318615,
                    50.4973132
                ],
                [
                    91.3233142,
                    50.4976271
                ],
                [
                    91.3259621,
                    50.4972587
                ],
                [
                    91.338223,
                    50.4946379
                ],
                [
                    91.3383453,
                    50.4911583
                ],
                [
                    91.3339787,
                    50.4917562
                ],
                [
                    91.329331,
                    50.4922913
                ],
                [
                    91.3196106,
                    50.494414
                ],
                [
                    91.318615,
                    50.4973132
                ]
            ],
            "longitude": 91.3298518,
            "latitude": 50.4934482
        },
        "900": {
            "name": "Кызыл-Тайга",
            "population": 477,
            "type": "village",
            "poly": null,
            "longitude": 91.3890933,
            "latitude": 51.4806993
        },
        "901": {
            "name": "Баян-Тала",
            "population": 748,
            "type": "village",
            "poly": null,
            "longitude": 91.430771,
            "latitude": 51.4573557
        },
        "902": {
            "name": "Теве-Хая",
            "population": 1477,
            "type": "village",
            "poly": null,
            "longitude": 91.4509672,
            "latitude": 51.3658128
        },
        "903": {
            "name": "Ишкин",
            "population": 1109,
            "type": "village",
            "poly": null,
            "longitude": 91.4749089,
            "latitude": 51.5669621
        },
        "904": {
            "name": "Хайыракан",
            "population": 1334,
            "type": "village",
            "poly": null,
            "longitude": 91.5614388,
            "latitude": 51.2961671
        },
        "905": {
            "name": "Ийме",
            "population": 679,
            "type": "village",
            "poly": null,
            "longitude": 91.5933809,
            "latitude": 51.5782693
        },
        "906": {
            "name": "Хондергей",
            "population": 916,
            "type": "village",
            "poly": null,
            "longitude": 91.6193587,
            "latitude": 51.1280656
        },
        "907": {
            "name": "Бора-Шай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 91.6659795,
            "latitude": 50.7192346
        },
        "908": {
            "name": "Бажын-Алаак",
            "population": 1457,
            "type": "village",
            "poly": null,
            "longitude": 91.7340114,
            "latitude": 51.2293018
        },
        "909": {
            "name": "Шанчы",
            "population": 304,
            "type": "village",
            "poly": null,
            "longitude": 91.9618584,
            "latitude": 51.6060807
        },
        "910": {
            "name": "Солчур",
            "population": 932,
            "type": "village",
            "poly": null,
            "longitude": 92.031431,
            "latitude": 50.7489479
        },
        "911": {
            "name": "Хандагайты",
            "population": 3209,
            "type": "village",
            "poly": null,
            "longitude": 92.0726451,
            "latitude": 50.7330745
        },
        "912": {
            "name": "Ак-Дуруг",
            "population": 1408,
            "type": "village",
            "poly": null,
            "longitude": 92.2074823,
            "latitude": 51.3995087
        },
        "913": {
            "name": "Булун-Терек",
            "population": 1072,
            "type": "village",
            "poly": null,
            "longitude": 92.2654182,
            "latitude": 51.4769681
        },
        "914": {
            "name": "Чаа-Холь",
            "population": 3248,
            "type": "village",
            "poly": null,
            "longitude": 92.3348586,
            "latitude": 51.5141315
        },
        "915": {
            "name": "Иштии-Хем",
            "population": 529,
            "type": "village",
            "poly": null,
            "longitude": 92.4753913,
            "latitude": 51.3205615
        },
        "916": {
            "name": "Арыг-Узуу",
            "population": 1420,
            "type": "village",
            "poly": null,
            "longitude": 92.5956837,
            "latitude": 51.4225518
        },
        "917": {
            "name": "Эйлиг-Хем",
            "population": 653,
            "type": "village",
            "poly": null,
            "longitude": 92.6727561,
            "latitude": 51.6130028
        },
        "918": {
            "name": "Дус-Даг",
            "population": 972,
            "type": "village",
            "poly": null,
            "longitude": 92.682277,
            "latitude": 50.8132729
        },
        "919": {
            "name": "Арыскан",
            "population": 633,
            "type": "village",
            "poly": null,
            "longitude": 92.7097671,
            "latitude": 51.406536
        },
        "920": {
            "name": "Чаа-Суур",
            "population": 619,
            "type": "village",
            "poly": null,
            "longitude": 92.7598487,
            "latitude": 50.8233451
        },
        "921": {
            "name": "Торгалыг",
            "population": 1199,
            "type": "village",
            "poly": null,
            "longitude": 92.8239747,
            "latitude": 51.3301908
        },
        "922": {
            "name": "Чодураа",
            "population": 815,
            "type": "village",
            "poly": null,
            "longitude": 92.884032,
            "latitude": 51.3752608
        },
        "923": {
            "name": "Арыг-Бажы",
            "population": 586,
            "type": "village",
            "poly": null,
            "longitude": 93.0547938,
            "latitude": 51.4458735
        },
        "924": {
            "name": "Хайыракан",
            "population": 1678,
            "type": "village",
            "poly": null,
            "longitude": 93.140133,
            "latitude": 51.5644653
        },
        "925": {
            "name": "Ак-Чыраа",
            "population": 472,
            "type": "village",
            "poly": null,
            "longitude": 93.2379767,
            "latitude": 50.6973582
        },
        "926": {
            "name": "Холчук",
            "population": 207,
            "type": "village",
            "poly": null,
            "longitude": 93.2771986,
            "latitude": 51.0748276
        },
        "927": {
            "name": "Ийи-Тал",
            "population": 610,
            "type": "village",
            "poly": null,
            "longitude": 93.337079,
            "latitude": 51.5656919
        },
        "928": {
            "name": "Ак-Тал",
            "population": 919,
            "type": "village",
            "poly": null,
            "longitude": 93.4071913,
            "latitude": 51.1743221
        },
        "929": {
            "name": "Тарлаг",
            "population": 486,
            "type": "village",
            "poly": null,
            "longitude": 93.4099547,
            "latitude": 52.0673346
        },
        "930": {
            "name": "Терлиг-Хая",
            "population": 498,
            "type": "village",
            "poly": null,
            "longitude": 93.5235071,
            "latitude": 51.7104566
        },
        "931": {
            "name": "Баян-Кол",
            "population": 1119,
            "type": "village",
            "poly": null,
            "longitude": 93.5542113,
            "latitude": 51.57916
        },
        "932": {
            "name": "Аржаан",
            "population": 786,
            "type": "village",
            "poly": [
                [
                    93.594244,
                    52.0610425
                ],
                [
                    93.6127835,
                    52.0655805
                ],
                [
                    93.6172467,
                    52.0590372
                ],
                [
                    93.6062603,
                    52.0541818
                ],
                [
                    93.597334,
                    52.0541818
                ],
                [
                    93.594244,
                    52.0610425
                ]
            ],
            "longitude": 93.6053528,
            "latitude": 52.0592442
        },
        "933": {
            "name": "Хадын",
            "population": 653,
            "type": "village",
            "poly": null,
            "longitude": 93.6290708,
            "latitude": 51.9561678
        },
        "934": {
            "name": "Сайлыг",
            "population": 1150,
            "type": "village",
            "poly": null,
            "longitude": 93.6846541,
            "latitude": 51.1235704
        },
        "935": {
            "name": "О-Шынаа",
            "population": 861,
            "type": "village",
            "poly": null,
            "longitude": 93.7471198,
            "latitude": 50.6583627
        },
        "936": {
            "name": "Чал-Кежиг",
            "population": 308,
            "type": "village",
            "poly": [
                [
                    93.9286425,
                    51.3004067
                ],
                [
                    93.9290118,
                    51.3009034
                ],
                [
                    93.931009,
                    51.3000114
                ],
                [
                    93.9324636,
                    51.2994658
                ],
                [
                    93.9348917,
                    51.2991405
                ],
                [
                    93.9354568,
                    51.2986122
                ],
                [
                    93.9361449,
                    51.2977167
                ],
                [
                    93.9368051,
                    51.2974613
                ],
                [
                    93.9365142,
                    51.2968631
                ],
                [
                    93.936324,
                    51.296083
                ],
                [
                    93.9357589,
                    51.2952504
                ],
                [
                    93.9349309,
                    51.2946487
                ],
                [
                    93.9345728,
                    51.2945822
                ],
                [
                    93.9339742,
                    51.293949
                ],
                [
                    93.9338511,
                    51.2936831
                ],
                [
                    93.9335994,
                    51.2933473
                ],
                [
                    93.9329,
                    51.292819
                ],
                [
                    93.9322678,
                    51.2929449
                ],
                [
                    93.9321,
                    51.2931269
                ],
                [
                    93.9320329,
                    51.2934487
                ],
                [
                    93.9320664,
                    51.2940015
                ],
                [
                    93.9324412,
                    51.2946662
                ],
                [
                    93.9326818,
                    51.2954707
                ],
                [
                    93.9327266,
                    51.2958521
                ],
                [
                    93.932072,
                    51.2967092
                ],
                [
                    93.9314342,
                    51.29715
                ],
                [
                    93.9310258,
                    51.2975943
                ],
                [
                    93.931093,
                    51.2984792
                ],
                [
                    93.9292579,
                    51.2994448
                ],
                [
                    93.9286425,
                    51.3004067
                ]
            ],
            "longitude": 93.9343032,
            "latitude": 51.2966733
        },
        "937": {
            "name": "Найырал",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 93.9396681,
            "latitude": 52.1510599
        },
        "938": {
            "name": "Элегест",
            "population": 1429,
            "type": "village",
            "poly": [
                [
                    93.9473947,
                    51.361136
                ],
                [
                    93.9478457,
                    51.3640803
                ],
                [
                    93.9480119,
                    51.3650238
                ],
                [
                    93.9509077,
                    51.3657253
                ],
                [
                    93.9521973,
                    51.3657204
                ],
                [
                    93.9525613,
                    51.3655452
                ],
                [
                    93.9575854,
                    51.3653599
                ],
                [
                    93.962024,
                    51.3647076
                ],
                [
                    93.9640495,
                    51.3653104
                ],
                [
                    93.9661067,
                    51.3651375
                ],
                [
                    93.967966,
                    51.3648855
                ],
                [
                    93.9675546,
                    51.3633393
                ],
                [
                    93.9665811,
                    51.3612084
                ],
                [
                    93.9655293,
                    51.3612992
                ],
                [
                    93.9608857,
                    51.3617672
                ],
                [
                    93.960248,
                    51.3601674
                ],
                [
                    93.9569919,
                    51.3561148
                ],
                [
                    93.9547428,
                    51.3549619
                ],
                [
                    93.9535008,
                    51.3551855
                ],
                [
                    93.9518448,
                    51.3572188
                ],
                [
                    93.9488572,
                    51.35986
                ],
                [
                    93.9473947,
                    51.361136
                ]
            ],
            "longitude": 93.9628826,
            "latitude": 51.3638133
        },
        "939": {
            "name": "Уюк",
            "population": 736,
            "type": "village",
            "poly": null,
            "longitude": 94.0316506,
            "latitude": 52.0776634
        },
        "940": {
            "name": "Кочетово",
            "population": 785,
            "type": "village",
            "poly": null,
            "longitude": 94.0612703,
            "latitude": 51.345228
        },
        "941": {
            "name": "Усть-Элегест",
            "population": 1260,
            "type": "village",
            "poly": [
                [
                    94.0708667,
                    51.565996
                ],
                [
                    94.0710029,
                    51.5662182
                ],
                [
                    94.0720579,
                    51.5664895
                ],
                [
                    94.0740149,
                    51.5670068
                ],
                [
                    94.0745004,
                    51.5670251
                ],
                [
                    94.0767711,
                    51.5670644
                ],
                [
                    94.07771,
                    51.5672282
                ],
                [
                    94.0793318,
                    51.5676873
                ],
                [
                    94.0809687,
                    51.5679461
                ],
                [
                    94.0835823,
                    51.5680736
                ],
                [
                    94.0846574,
                    51.5680945
                ],
                [
                    94.0885091,
                    51.5690394
                ],
                [
                    94.0905321,
                    51.568471
                ],
                [
                    94.0895606,
                    51.566901
                ],
                [
                    94.090875,
                    51.5656861
                ],
                [
                    94.0945781,
                    51.5651604
                ],
                [
                    94.0972297,
                    51.5658565
                ],
                [
                    94.0987155,
                    51.5657785
                ],
                [
                    94.0990927,
                    51.5663753
                ],
                [
                    94.1005442,
                    51.5662829
                ],
                [
                    94.1024872,
                    51.567789
                ],
                [
                    94.1069104,
                    51.5664676
                ],
                [
                    94.1081448,
                    51.5641869
                ],
                [
                    94.1082819,
                    51.5618352
                ],
                [
                    94.1070133,
                    51.5610607
                ],
                [
                    94.1016072,
                    51.5611531
                ],
                [
                    94.1003271,
                    51.5611673
                ],
                [
                    94.0980869,
                    51.562361
                ],
                [
                    94.0932866,
                    51.563988
                ],
                [
                    94.0903263,
                    51.5652385
                ],
                [
                    94.0882966,
                    51.5654561
                ],
                [
                    94.0869193,
                    51.5653992
                ],
                [
                    94.0853935,
                    51.5648912
                ],
                [
                    94.0801017,
                    51.5641985
                ],
                [
                    94.0797964,
                    51.5649442
                ],
                [
                    94.0769358,
                    51.5645701
                ],
                [
                    94.0753242,
                    51.5643264
                ],
                [
                    94.074271,
                    51.5641256
                ],
                [
                    94.0732591,
                    51.5638531
                ],
                [
                    94.073084,
                    51.5640138
                ],
                [
                    94.0726726,
                    51.5650902
                ],
                [
                    94.0713411,
                    51.5655271
                ],
                [
                    94.0708667,
                    51.565996
                ]
            ],
            "longitude": 94.0993685,
            "latitude": 51.5641892
        },
        "942": {
            "name": "Суш",
            "population": 493,
            "type": "village",
            "poly": null,
            "longitude": 94.1625176,
            "latitude": 52.0630166
        },
        "943": {
            "name": "Ээрбек",
            "population": 1166,
            "type": "village",
            "poly": [
                [
                    94.2021904,
                    51.650766
                ],
                [
                    94.2033763,
                    51.6511072
                ],
                [
                    94.2030464,
                    51.6515487
                ],
                [
                    94.2084249,
                    51.6529298
                ],
                [
                    94.2094403,
                    51.6541963
                ],
                [
                    94.2087717,
                    51.6552002
                ],
                [
                    94.2090757,
                    51.6556668
                ],
                [
                    94.2104432,
                    51.6564634
                ],
                [
                    94.2125781,
                    51.6571515
                ],
                [
                    94.216787,
                    51.6580894
                ],
                [
                    94.2172201,
                    51.6575568
                ],
                [
                    94.2152979,
                    51.6565293
                ],
                [
                    94.2127148,
                    51.6555302
                ],
                [
                    94.2110054,
                    51.6544555
                ],
                [
                    94.2104052,
                    51.6535222
                ],
                [
                    94.2102912,
                    51.6527304
                ],
                [
                    94.2105647,
                    51.651797
                ],
                [
                    94.211636,
                    51.650232
                ],
                [
                    94.2108307,
                    51.6488697
                ],
                [
                    94.20922,
                    51.6479505
                ],
                [
                    94.2093644,
                    51.646574
                ],
                [
                    94.2085742,
                    51.6461662
                ],
                [
                    94.2082913,
                    51.6462138
                ],
                [
                    94.2080881,
                    51.6463281
                ],
                [
                    94.2061051,
                    51.6474555
                ],
                [
                    94.2036308,
                    51.6507665
                ],
                [
                    94.202464,
                    51.6504077
                ],
                [
                    94.2021904,
                    51.650766
                ]
            ],
            "longitude": 94.2090227,
            "latitude": 51.6508488
        },
        "944": {
            "name": "Успенка",
            "population": 424,
            "type": "village",
            "poly": null,
            "longitude": 94.2477472,
            "latitude": 51.2344759
        },
        "945": {
            "name": "Сесерлиг",
            "population": 715,
            "type": "village",
            "poly": null,
            "longitude": 94.258762,
            "latitude": 51.8768916
        },
        "946": {
            "name": "Сукпак",
            "population": 4185,
            "type": "village",
            "poly": null,
            "longitude": 94.2671278,
            "latitude": 51.6473874
        },
        "947": {
            "name": "Межегей",
            "population": 1108,
            "type": "village",
            "poly": null,
            "longitude": 94.3219435,
            "latitude": 51.2555542
        },
        "948": {
            "name": "Холь-Оожу",
            "population": 410,
            "type": "village",
            "poly": null,
            "longitude": 94.4130714,
            "latitude": 50.7394457
        },
        "949": {
            "name": "Кара-Хаак",
            "population": 1278,
            "type": "village",
            "poly": null,
            "longitude": 94.4604279,
            "latitude": 51.8863432
        },
        "950": {
            "name": "Бай-Хаак",
            "population": 3110,
            "type": "village",
            "poly": null,
            "longitude": 94.4651991,
            "latitude": 51.1601031
        },
        "951": {
            "name": "Дурген",
            "population": 1599,
            "type": "village",
            "poly": null,
            "longitude": 94.5006472,
            "latitude": 51.1490635
        },
        "952": {
            "name": "Сосновка",
            "population": 740,
            "type": "village",
            "poly": null,
            "longitude": 94.5236342,
            "latitude": 51.1453988
        },
        "953": {
            "name": "Хут",
            "population": 331,
            "type": "village",
            "poly": [
                [
                    94.5485096,
                    52.6106774
                ],
                [
                    94.5503563,
                    52.6127031
                ],
                [
                    94.5544668,
                    52.6135712
                ],
                [
                    94.5564921,
                    52.6117626
                ],
                [
                    94.5563731,
                    52.6098816
                ],
                [
                    94.5535732,
                    52.6096645
                ],
                [
                    94.5488074,
                    52.6093028
                ],
                [
                    94.5485096,
                    52.6106774
                ]
            ],
            "longitude": 94.5529206,
            "latitude": 52.6119734
        },
        "954": {
            "name": "Черби",
            "population": 1052,
            "type": "village",
            "poly": null,
            "longitude": 94.5928084,
            "latitude": 51.888064
        },
        "955": {
            "name": "Ак-Эрик",
            "population": 837,
            "type": "village",
            "poly": null,
            "longitude": 94.6152832,
            "latitude": 50.5142008
        },
        "956": {
            "name": "Берт-Даг",
            "population": 1030,
            "type": "village",
            "poly": null,
            "longitude": 94.7941167,
            "latitude": 50.6253442
        },
        "957": {
            "name": "Целинное",
            "population": 1277,
            "type": "village",
            "poly": null,
            "longitude": 94.8057351,
            "latitude": 51.3288301
        },
        "958": {
            "name": "Суг-Бажы",
            "population": 784,
            "type": "village",
            "poly": null,
            "longitude": 94.8554704,
            "latitude": 51.6560787
        },
        "959": {
            "name": "Бельдир-Арыг",
            "population": 1040,
            "type": "village",
            "poly": null,
            "longitude": 94.9732734,
            "latitude": 50.5733792
        },
        "960": {
            "name": "Самагалтай",
            "population": 3231,
            "type": "village",
            "poly": null,
            "longitude": 95.001846,
            "latitude": 50.599998
        },
        "961": {
            "name": "Бурен-Хем",
            "population": 951,
            "type": "village",
            "poly": null,
            "longitude": 95.0071514,
            "latitude": 51.6519455
        },
        "962": {
            "name": "Шамбалыг",
            "population": 513,
            "type": "village",
            "poly": null,
            "longitude": 95.0914385,
            "latitude": 51.2406402
        },
        "963": {
            "name": "Бай-Даг",
            "population": 1267,
            "type": "village",
            "poly": null,
            "longitude": 95.1019495,
            "latitude": 50.3013082
        },
        "964": {
            "name": "Эрзин",
            "population": 3174,
            "type": "village",
            "poly": null,
            "longitude": 95.1582961,
            "latitude": 50.2599782
        },
        "965": {
            "name": "Балгазын",
            "population": 3098,
            "type": "village",
            "poly": null,
            "longitude": 95.1670684,
            "latitude": 50.9964468
        },
        "966": {
            "name": "Кундус-Туг",
            "population": 651,
            "type": "village",
            "poly": null,
            "longitude": 95.1798664,
            "latitude": 51.5734175
        },
        "967": {
            "name": "Кызыл-Арыг",
            "population": 550,
            "type": "village",
            "poly": null,
            "longitude": 95.1963496,
            "latitude": 50.9292407
        },
        "968": {
            "name": "Булун-Бажы",
            "population": 801,
            "type": "village",
            "poly": null,
            "longitude": 95.2137767,
            "latitude": 50.2671627
        },
        "969": {
            "name": "Сой",
            "population": 323,
            "type": "village",
            "poly": null,
            "longitude": 95.2275229,
            "latitude": 51.003366
        },
        "970": {
            "name": "Владимировка",
            "population": 893,
            "type": "village",
            "poly": null,
            "longitude": 95.3055046,
            "latitude": 50.9977926
        },
        "971": {
            "name": "Шуурмак",
            "population": 657,
            "type": "village",
            "poly": null,
            "longitude": 95.3271335,
            "latitude": 50.6532098
        },
        "972": {
            "name": "Бояровка",
            "population": 674,
            "type": "village",
            "poly": [
                [
                    95.3451514,
                    51.5349813
                ],
                [
                    95.3479262,
                    51.5373918
                ],
                [
                    95.3514664,
                    51.5394748
                ],
                [
                    95.3627092,
                    51.544414
                ],
                [
                    95.3640008,
                    51.5437297
                ],
                [
                    95.3625657,
                    51.5430453
                ],
                [
                    95.3599212,
                    51.5404292
                ],
                [
                    95.3573031,
                    51.5384928
                ],
                [
                    95.3572073,
                    51.5344457
                ],
                [
                    95.3559157,
                    51.5331065
                ],
                [
                    95.3545283,
                    51.5322732
                ],
                [
                    95.3517057,
                    51.5314399
                ],
                [
                    95.3497442,
                    51.5311422
                ],
                [
                    95.3451514,
                    51.5349813
                ]
            ],
            "longitude": 95.3540499,
            "latitude": 51.5380167
        },
        "973": {
            "name": "Морен",
            "population": 1059,
            "type": "village",
            "poly": null,
            "longitude": 95.3711059,
            "latitude": 50.3155303
        },
        "974": {
            "name": "Ильинка",
            "population": 840,
            "type": "village",
            "poly": null,
            "longitude": 95.4779459,
            "latitude": 51.1141651
        },
        "975": {
            "name": "Кок-Хаак",
            "population": 394,
            "type": "village",
            "poly": null,
            "longitude": 95.4860581,
            "latitude": 51.511767
        },
        "976": {
            "name": "Сыстыг-Хем",
            "population": 141,
            "type": "village",
            "poly": null,
            "longitude": 95.50383,
            "latitude": 52.666992
        },
        "977": {
            "name": "Бурен-Бай-Хаак",
            "population": 791,
            "type": "village",
            "poly": null,
            "longitude": 95.55685,
            "latitude": 51.2449768
        },
        "978": {
            "name": "Нарын",
            "population": 1689,
            "type": "village",
            "poly": null,
            "longitude": 95.5698333,
            "latitude": 50.1998486
        },
        "979": {
            "name": "Дерзиг-Аксы",
            "population": 836,
            "type": "village",
            "poly": null,
            "longitude": 95.6081696,
            "latitude": 51.456125
        },
        "980": {
            "name": "Усть-Бурен",
            "population": 513,
            "type": "village",
            "poly": null,
            "longitude": 95.6560897,
            "latitude": 51.4138176
        },
        "981": {
            "name": "Ырбан",
            "population": 325,
            "type": "village",
            "poly": null,
            "longitude": 95.7278747,
            "latitude": 52.7137562
        },
        "982": {
            "name": "Сизим",
            "population": 348,
            "type": "village",
            "poly": null,
            "longitude": 95.9441084,
            "latitude": 51.3192221
        },
        "983": {
            "name": "Ий",
            "population": 1275,
            "type": "village",
            "poly": null,
            "longitude": 96.0338107,
            "latitude": 52.5695197
        },
        "984": {
            "name": "Салдам",
            "population": 544,
            "type": "village",
            "poly": null,
            "longitude": 96.0951619,
            "latitude": 52.480453
        },
        "985": {
            "name": "Тоора-Хем",
            "population": 2387,
            "type": "village",
            "poly": null,
            "longitude": 96.117896,
            "latitude": 52.4679232
        },
        "986": {
            "name": "Адыр-Кежиг",
            "population": 1202,
            "type": "village",
            "poly": null,
            "longitude": 96.241468,
            "latitude": 52.4497728
        },
        "987": {
            "name": "Качык",
            "population": 269,
            "type": "village",
            "poly": null,
            "longitude": 96.4202883,
            "latitude": 49.9353978
        },
        "988": {
            "name": "Белдир-Чазы",
            "population": 148,
            "type": "village",
            "poly": null,
            "longitude": 97.1076072,
            "latitude": 50.592116
        },
        "989": {
            "name": "Чазылары",
            "population": 140,
            "type": "village",
            "poly": null,
            "longitude": 97.4257898,
            "latitude": 52.7542023
        },
        "990": {
            "name": "Тал",
            "population": 99,
            "type": "village",
            "poly": null,
            "longitude": 97.4838841,
            "latitude": 50.3578383
        },
        "991": {
            "name": "Кунгуртуг",
            "population": 1468,
            "type": "village",
            "poly": null,
            "longitude": 97.5254386,
            "latitude": 50.5986817
        },
        "992": {
            "name": "Оттук-Даш",
            "population": 173,
            "type": "village",
            "poly": null,
            "longitude": 97.8117949,
            "latitude": 50.5987114
        },
        "993": {
            "name": "Юргинский",
            "population": 823,
            "type": "village",
            "poly": null,
            "longitude": 84.641525,
            "latitude": 55.693752
        },
        "994": {
            "name": "Сокольники",
            "population": 316,
            "type": "village",
            "poly": null,
            "longitude": 84.6424486,
            "latitude": 55.8635303
        },
        "995": {
            "name": "Лебяжье-Асаново",
            "population": 477,
            "type": "village",
            "poly": null,
            "longitude": 84.6468135,
            "latitude": 55.7442178
        },
        "996": {
            "name": "Макурино",
            "population": 373,
            "type": "village",
            "poly": null,
            "longitude": 84.6622089,
            "latitude": 56.035164
        },
        "997": {
            "name": "Заозёрный",
            "population": 532,
            "type": "village",
            "poly": null,
            "longitude": 84.717761,
            "latitude": 55.8912032
        },
        "998": {
            "name": "Проскоково",
            "population": 1749,
            "type": "village",
            "poly": null,
            "longitude": 84.724236,
            "latitude": 55.838284
        },
        "999": {
            "name": "Безменово",
            "population": 580,
            "type": "village",
            "poly": null,
            "longitude": 84.7535348,
            "latitude": 55.836388
        },
        "1000": {
            "name": "Юрга 2-я",
            "population": 2868,
            "type": "village",
            "poly": null,
            "longitude": 84.7755623,
            "latitude": 55.6729622
        },
        "1001": {
            "name": "Линейный",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 84.7761858,
            "latitude": 55.4727253
        },
        "1002": {
            "name": "Сарсаз",
            "population": 476,
            "type": "village",
            "poly": [
                [
                    84.8101051,
                    55.6866603
                ],
                [
                    84.8206627,
                    55.692536
                ],
                [
                    84.8231752,
                    55.6941931
                ],
                [
                    84.8275853,
                    55.6983506
                ],
                [
                    84.8279328,
                    55.6981548
                ],
                [
                    84.8278793,
                    55.6973866
                ],
                [
                    84.8324649,
                    55.6955584
                ],
                [
                    84.8329185,
                    55.6938115
                ],
                [
                    84.8300176,
                    55.6900502
                ],
                [
                    84.8301969,
                    55.68938
                ],
                [
                    84.8330697,
                    55.6877181
                ],
                [
                    84.8280046,
                    55.6841809
                ],
                [
                    84.8101051,
                    55.6866603
                ]
            ],
            "longitude": 84.825694,
            "latitude": 55.6913113
        },
        "1003": {
            "name": "Мальцево",
            "population": 513,
            "type": "village",
            "poly": null,
            "longitude": 84.8266683,
            "latitude": 55.9570185
        },
        "1004": {
            "name": "Арлюк",
            "population": 1760,
            "type": "village",
            "poly": [
                [
                    84.8322739,
                    55.4334113
                ],
                [
                    84.8330455,
                    55.4353813
                ],
                [
                    84.837225,
                    55.4353448
                ],
                [
                    84.8414045,
                    55.4351624
                ],
                [
                    84.8426262,
                    55.4377524
                ],
                [
                    84.844105,
                    55.4373876
                ],
                [
                    84.8459698,
                    55.4411811
                ],
                [
                    84.8491206,
                    55.4407069
                ],
                [
                    84.8521427,
                    55.4441719
                ],
                [
                    84.8532059,
                    55.4486823
                ],
                [
                    84.855585,
                    55.4486094
                ],
                [
                    84.8574068,
                    55.4475588
                ],
                [
                    84.8586249,
                    55.4411893
                ],
                [
                    84.8617671,
                    55.4342042
                ],
                [
                    84.863654,
                    55.4319341
                ],
                [
                    84.859812,
                    55.4300638
                ],
                [
                    84.8579479,
                    55.4312376
                ],
                [
                    84.856061,
                    55.4303346
                ],
                [
                    84.8519689,
                    55.430799
                ],
                [
                    84.8506959,
                    55.4288899
                ],
                [
                    84.8528783,
                    55.4285803
                ],
                [
                    84.858789,
                    55.4274451
                ],
                [
                    84.8495137,
                    55.4257423
                ],
                [
                    84.8451338,
                    55.4259683
                ],
                [
                    84.8415331,
                    55.4269535
                ],
                [
                    84.8421118,
                    55.4277927
                ],
                [
                    84.8356818,
                    55.4295805
                ],
                [
                    84.8322739,
                    55.4334113
                ]
            ],
            "longitude": 84.8542761,
            "latitude": 55.4347314
        },
        "1005": {
            "name": "Ёлгино",
            "population": 441,
            "type": "village",
            "poly": null,
            "longitude": 84.8583344,
            "latitude": 55.915786
        },
        "1006": {
            "name": "Зеледеево",
            "population": 586,
            "type": "village",
            "poly": null,
            "longitude": 84.8767856,
            "latitude": 56.0394794
        },
        "1007": {
            "name": "Томилово",
            "population": 347,
            "type": "village",
            "poly": null,
            "longitude": 84.8862442,
            "latitude": 55.990389
        },
        "1008": {
            "name": "Талая",
            "population": 1396,
            "type": "village",
            "poly": null,
            "longitude": 84.8934553,
            "latitude": 55.7870061
        },
        "1009": {
            "name": "Варюхино",
            "population": 381,
            "type": "village",
            "poly": null,
            "longitude": 84.8956684,
            "latitude": 56.1048235
        },
        "1010": {
            "name": "Озерки",
            "population": 560,
            "type": "village",
            "poly": [
                [
                    84.8891324,
                    54.9819486
                ],
                [
                    84.8913983,
                    54.9846771
                ],
                [
                    84.8967198,
                    54.987435
                ],
                [
                    84.9025219,
                    54.9945553
                ],
                [
                    84.9075,
                    54.9964263
                ],
                [
                    84.91265,
                    54.9981987
                ],
                [
                    84.9167698,
                    54.9981002
                ],
                [
                    84.9179714,
                    54.9967217
                ],
                [
                    84.9195164,
                    54.9956385
                ],
                [
                    84.9106244,
                    54.9934425
                ],
                [
                    84.9099034,
                    54.9924873
                ],
                [
                    84.9054402,
                    54.9907146
                ],
                [
                    84.900462,
                    54.9865781
                ],
                [
                    84.9037579,
                    54.9837906
                ],
                [
                    84.9046162,
                    54.9833966
                ],
                [
                    84.8968571,
                    54.9791904
                ],
                [
                    84.8941105,
                    54.9809636
                ],
                [
                    84.8985737,
                    54.9832292
                ],
                [
                    84.8970288,
                    54.9843127
                ],
                [
                    84.8917416,
                    54.981525
                ],
                [
                    84.8906772,
                    54.9807665
                ],
                [
                    84.8891324,
                    54.9819486
                ]
            ],
            "longitude": 84.8998964,
            "latitude": 54.9896844
        },
        "1011": {
            "name": "Зимник",
            "population": 852,
            "type": "village",
            "poly": [
                [
                    84.9128575,
                    55.6684326
                ],
                [
                    84.9175446,
                    55.6689869
                ],
                [
                    84.9171666,
                    55.6698822
                ],
                [
                    84.9185272,
                    55.670607
                ],
                [
                    84.9197369,
                    55.6731223
                ],
                [
                    84.9217025,
                    55.6732076
                ],
                [
                    84.9275235,
                    55.6703512
                ],
                [
                    84.9322106,
                    55.6694132
                ],
                [
                    84.9326642,
                    55.666386
                ],
                [
                    84.9350834,
                    55.6663008
                ],
                [
                    84.9359906,
                    55.6632307
                ],
                [
                    84.9348566,
                    55.6628043
                ],
                [
                    84.9295647,
                    55.6634439
                ],
                [
                    84.9271455,
                    55.6614823
                ],
                [
                    84.9289599,
                    55.6606721
                ],
                [
                    84.9282039,
                    55.658028
                ],
                [
                    84.9298671,
                    55.657431
                ],
                [
                    84.9288843,
                    55.65645
                ],
                [
                    84.9269944,
                    55.6564074
                ],
                [
                    84.9235168,
                    55.6543602
                ],
                [
                    84.9206441,
                    55.6540616
                ],
                [
                    84.9201905,
                    55.6513745
                ],
                [
                    84.915957,
                    55.6524408
                ],
                [
                    84.9179981,
                    55.6541469
                ],
                [
                    84.9135378,
                    55.6572604
                ],
                [
                    84.9202661,
                    55.6611412
                ],
                [
                    84.9178469,
                    55.6610559
                ],
                [
                    84.9166374,
                    55.6622499
                ],
                [
                    84.9192077,
                    55.6633586
                ],
                [
                    84.9210221,
                    55.6658317
                ],
                [
                    84.9138402,
                    55.6673241
                ],
                [
                    84.9128575,
                    55.6684326
                ]
            ],
            "longitude": 84.925949,
            "latitude": 55.661999
        },
        "1012": {
            "name": "Пятково",
            "population": 686,
            "type": "village",
            "poly": null,
            "longitude": 84.9471598,
            "latitude": 55.8545622
        },
        "1013": {
            "name": "Поломошное",
            "population": 1684,
            "type": "village",
            "poly": null,
            "longitude": 84.9599296,
            "latitude": 55.7391859
        },
        "1014": {
            "name": "Поперечное",
            "population": 1011,
            "type": "village",
            "poly": [
                [
                    84.9727121,
                    55.5082759
                ],
                [
                    84.9750556,
                    55.5096458
                ],
                [
                    84.9747532,
                    55.5108872
                ],
                [
                    84.9769455,
                    55.5112725
                ],
                [
                    84.97687,
                    55.511829
                ],
                [
                    84.9752068,
                    55.5120002
                ],
                [
                    84.9760383,
                    55.5151677
                ],
                [
                    84.9791379,
                    55.5156814
                ],
                [
                    84.9791379,
                    55.514012
                ],
                [
                    84.9816327,
                    55.5146113
                ],
                [
                    84.9840518,
                    55.5143117
                ],
                [
                    84.9837493,
                    55.5127279
                ],
                [
                    84.9851858,
                    55.5125139
                ],
                [
                    84.986849,
                    55.5116577
                ],
                [
                    84.9887389,
                    55.5115721
                ],
                [
                    84.9912337,
                    55.5105875
                ],
                [
                    84.9907045,
                    55.5097314
                ],
                [
                    84.9919897,
                    55.5093033
                ],
                [
                    84.9912337,
                    55.5086611
                ],
                [
                    84.99645,
                    55.5058356
                ],
                [
                    84.9956184,
                    55.5042087
                ],
                [
                    84.9858662,
                    55.5031811
                ],
                [
                    84.9866222,
                    55.5004836
                ],
                [
                    84.9884365,
                    55.4992846
                ],
                [
                    84.985337,
                    55.4989421
                ],
                [
                    84.9854126,
                    55.4971436
                ],
                [
                    84.9879074,
                    55.494617
                ],
                [
                    84.9858662,
                    55.4939746
                ],
                [
                    84.9832959,
                    55.4950452
                ],
                [
                    84.9820107,
                    55.4947026
                ],
                [
                    84.9798938,
                    55.4964584
                ],
                [
                    84.9808767,
                    55.4971008
                ],
                [
                    84.9808767,
                    55.4983854
                ],
                [
                    84.9790623,
                    55.4980428
                ],
                [
                    84.9752068,
                    55.5002267
                ],
                [
                    84.9750556,
                    55.5011259
                ],
                [
                    84.9764919,
                    55.5012115
                ],
                [
                    84.9767188,
                    55.5059212
                ],
                [
                    84.9727121,
                    55.5082759
                ]
            ],
            "longitude": 84.982834,
            "latitude": 55.504913
        },
        "1015": {
            "name": "Тутальская",
            "population": 680,
            "type": "village",
            "poly": null,
            "longitude": 84.9874266,
            "latitude": 55.7516627
        },
        "1016": {
            "name": "Абышево",
            "population": 731,
            "type": "village",
            "poly": null,
            "longitude": 84.994672,
            "latitude": 55.0629203
        },
        "1017": {
            "name": "Усть-Сосново",
            "population": 572,
            "type": "village",
            "poly": [
                [
                    84.9806098,
                    55.2311323
                ],
                [
                    84.9831717,
                    55.2319981
                ],
                [
                    84.9854491,
                    55.2288595
                ],
                [
                    84.9871571,
                    55.2310241
                ],
                [
                    84.9870622,
                    55.2330803
                ],
                [
                    84.984968,
                    55.2341285
                ],
                [
                    84.9955954,
                    55.2355894
                ],
                [
                    84.9980626,
                    55.2327217
                ],
                [
                    85.0008266,
                    55.2320498
                ],
                [
                    85.0003066,
                    55.2299071
                ],
                [
                    85.0020567,
                    55.2299345
                ],
                [
                    85.0029107,
                    55.2280404
                ],
                [
                    84.9964109,
                    55.2242792
                ],
                [
                    85.00023,
                    55.2217731
                ],
                [
                    85.0027797,
                    55.2216582
                ],
                [
                    85.0039874,
                    55.2208163
                ],
                [
                    85.0049938,
                    55.2172185
                ],
                [
                    85.003719,
                    55.2159553
                ],
                [
                    85.0045242,
                    55.2131227
                ],
                [
                    85.0015719,
                    55.2125102
                ],
                [
                    84.9989552,
                    55.2155726
                ],
                [
                    85.0002971,
                    55.2170271
                ],
                [
                    85.0022429,
                    55.2169123
                ],
                [
                    84.998821,
                    55.2204335
                ],
                [
                    84.9949294,
                    55.222041
                ],
                [
                    84.9902998,
                    55.2229212
                ],
                [
                    84.9872805,
                    55.2238779
                ],
                [
                    84.9873476,
                    55.225026
                ],
                [
                    84.9855892,
                    55.22574
                ],
                [
                    84.9845324,
                    55.2275672
                ],
                [
                    84.9841298,
                    55.2283421
                ],
                [
                    84.9836265,
                    55.2278351
                ],
                [
                    84.9840628,
                    55.2261896
                ],
                [
                    84.9831401,
                    55.2261131
                ],
                [
                    84.9826873,
                    55.2254338
                ],
                [
                    84.9815467,
                    55.2255773
                ],
                [
                    84.9810938,
                    55.228103
                ],
                [
                    84.9822679,
                    55.2287535
                ],
                [
                    84.9806098,
                    55.2311323
                ]
            ],
            "longitude": 84.9946836,
            "latitude": 55.2267306
        },
        "1018": {
            "name": "Саломатово",
            "population": 358,
            "type": "village",
            "poly": null,
            "longitude": 85.020668,
            "latitude": 55.928406
        },
        "1019": {
            "name": "Падунская",
            "population": 2149,
            "type": "village",
            "poly": null,
            "longitude": 85.047272,
            "latitude": 55.034611
        },
        "1020": {
            "name": "Журавлёво",
            "population": 1127,
            "type": "village",
            "poly": [
                [
                    85.0451071,
                    54.7859827
                ],
                [
                    85.0466472,
                    54.7871705
                ],
                [
                    85.0455307,
                    54.7875479
                ],
                [
                    85.0463007,
                    54.7882583
                ],
                [
                    85.0480718,
                    54.7878476
                ],
                [
                    85.0492845,
                    54.7885802
                ],
                [
                    85.0501509,
                    54.7883582
                ],
                [
                    85.0496888,
                    54.7880807
                ],
                [
                    85.0497658,
                    54.7878254
                ],
                [
                    85.0521099,
                    54.7884661
                ],
                [
                    85.0574678,
                    54.7895772
                ],
                [
                    85.0606167,
                    54.7899566
                ],
                [
                    85.0625907,
                    54.7904714
                ],
                [
                    85.0640477,
                    54.7910134
                ],
                [
                    85.0649877,
                    54.7909592
                ],
                [
                    85.0661626,
                    54.7910676
                ],
                [
                    85.0672436,
                    54.7916637
                ],
                [
                    85.0680895,
                    54.7919889
                ],
                [
                    85.0706745,
                    54.7913657
                ],
                [
                    85.0728835,
                    54.7913386
                ],
                [
                    85.0737764,
                    54.7907966
                ],
                [
                    85.0740585,
                    54.7900108
                ],
                [
                    85.0738235,
                    54.7890352
                ],
                [
                    85.0737764,
                    54.7859729
                ],
                [
                    85.0740585,
                    54.7856477
                ],
                [
                    85.0772544,
                    54.7829645
                ],
                [
                    85.0794634,
                    54.7809589
                ],
                [
                    85.0779124,
                    54.7796036
                ],
                [
                    85.0769253,
                    54.7781128
                ],
                [
                    85.0754684,
                    54.7772996
                ],
                [
                    85.0749459,
                    54.7770457
                ],
                [
                    85.077025,
                    54.77568
                ],
                [
                    85.0744069,
                    54.7739367
                ],
                [
                    85.0738678,
                    54.7742254
                ],
                [
                    85.0728668,
                    54.7738479
                ],
                [
                    85.0716154,
                    54.7746918
                ],
                [
                    85.0705375,
                    54.7737813
                ],
                [
                    85.0700369,
                    54.7737924
                ],
                [
                    85.0679386,
                    54.7759687
                ],
                [
                    85.0673033,
                    54.7759132
                ],
                [
                    85.0672456,
                    54.7749028
                ],
                [
                    85.0665333,
                    54.7744253
                ],
                [
                    85.0636457,
                    54.7741588
                ],
                [
                    85.0606425,
                    54.776857
                ],
                [
                    85.0618746,
                    54.7775787
                ],
                [
                    85.0582362,
                    54.7779784
                ],
                [
                    85.0562726,
                    54.7783781
                ],
                [
                    85.0552138,
                    54.7788777
                ],
                [
                    85.0543283,
                    54.7799435
                ],
                [
                    85.0512481,
                    54.7818753
                ],
                [
                    85.0507861,
                    54.7816088
                ],
                [
                    85.0495541,
                    54.7822749
                ],
                [
                    85.0494193,
                    54.7827967
                ],
                [
                    85.0453381,
                    54.7849837
                ],
                [
                    85.0451071,
                    54.7859827
                ]
            ],
            "longitude": 85.0642041,
            "latitude": 54.7837082
        },
        "1021": {
            "name": "Ленинский",
            "population": 706,
            "type": "village",
            "poly": null,
            "longitude": 85.065834,
            "latitude": 56.025146
        },
        "1022": {
            "name": "Голубево",
            "population": 432,
            "type": "village",
            "poly": null,
            "longitude": 85.0740683,
            "latitude": 54.8508059
        },
        "1023": {
            "name": "Васьково",
            "population": 1152,
            "type": "village",
            "poly": null,
            "longitude": 85.089447,
            "latitude": 55.049778
        },
        "1024": {
            "name": "Речной",
            "population": 562,
            "type": "village",
            "poly": null,
            "longitude": 85.1052802,
            "latitude": 55.6915434
        },
        "1025": {
            "name": "Шахтёр",
            "population": 588,
            "type": "village",
            "poly": null,
            "longitude": 85.1250358,
            "latitude": 55.8113459
        },
        "1026": {
            "name": "Пашково",
            "population": 907,
            "type": "village",
            "poly": null,
            "longitude": 85.1425802,
            "latitude": 56.0487661
        },
        "1027": {
            "name": "Тарасово",
            "population": 1274,
            "type": "village",
            "poly": null,
            "longitude": 85.1490068,
            "latitude": 54.8843768
        },
        "1028": {
            "name": "Ваганово",
            "population": 1507,
            "type": "village",
            "poly": null,
            "longitude": 85.173269,
            "latitude": 54.7013661
        },
        "1029": {
            "name": "Усть-Каменка",
            "population": 485,
            "type": "village",
            "poly": null,
            "longitude": 85.1881335,
            "latitude": 55.0037911
        },
        "1030": {
            "name": "Красносёлка",
            "population": 796,
            "type": "village",
            "poly": null,
            "longitude": 85.204369,
            "latitude": 55.865311
        },
        "1031": {
            "name": "Верх-Падунский",
            "population": 565,
            "type": "village",
            "poly": [
                [
                    85.1920909,
                    55.1580066
                ],
                [
                    85.1958727,
                    55.1587384
                ],
                [
                    85.1955677,
                    55.1591566
                ],
                [
                    85.1980686,
                    55.1594702
                ],
                [
                    85.1993495,
                    55.1592263
                ],
                [
                    85.2019723,
                    55.1599581
                ],
                [
                    85.2011794,
                    55.1606201
                ],
                [
                    85.2059371,
                    55.1625366
                ],
                [
                    85.2070655,
                    55.1612822
                ],
                [
                    85.2049612,
                    55.1604633
                ],
                [
                    85.2067299,
                    55.1590695
                ],
                [
                    85.2094444,
                    55.1591566
                ],
                [
                    85.2110303,
                    55.1582854
                ],
                [
                    85.2122502,
                    55.1584771
                ],
                [
                    85.2124637,
                    55.1581634
                ],
                [
                    85.2110303,
                    55.1575536
                ],
                [
                    85.2115793,
                    55.1573096
                ],
                [
                    85.2119757,
                    55.1575013
                ],
                [
                    85.2134091,
                    55.1567521
                ],
                [
                    85.2126466,
                    55.1563687
                ],
                [
                    85.2137141,
                    55.1556717
                ],
                [
                    85.2127077,
                    55.154208
                ],
                [
                    85.2119757,
                    55.1538072
                ],
                [
                    85.2126466,
                    55.1532844
                ],
                [
                    85.2107558,
                    55.1518206
                ],
                [
                    85.2074315,
                    55.1513849
                ],
                [
                    85.2038632,
                    55.1511409
                ],
                [
                    85.2042292,
                    55.1504264
                ],
                [
                    85.2026738,
                    55.1501302
                ],
                [
                    85.2007524,
                    55.151716
                ],
                [
                    85.1982821,
                    55.1512455
                ],
                [
                    85.1978856,
                    55.15196
                ],
                [
                    85.1987395,
                    55.1522911
                ],
                [
                    85.1994105,
                    55.152082
                ],
                [
                    85.2000204,
                    55.1525874
                ],
                [
                    85.1979161,
                    55.1534761
                ],
                [
                    85.1988615,
                    55.1548353
                ],
                [
                    85.198343,
                    55.155602
                ],
                [
                    85.1971841,
                    55.1554452
                ],
                [
                    85.1965132,
                    55.155846
                ],
                [
                    85.1964217,
                    55.1568043
                ],
                [
                    85.1952932,
                    55.1565255
                ],
                [
                    85.1942258,
                    55.1574142
                ],
                [
                    85.1933108,
                    55.1570309
                ],
                [
                    85.1924264,
                    55.1574665
                ],
                [
                    85.1920909,
                    55.1580066
                ]
            ],
            "longitude": 85.2064545,
            "latitude": 55.1554678
        },
        "1032": {
            "name": "Верх-Тайменка",
            "population": 626,
            "type": "village",
            "poly": null,
            "longitude": 85.211964,
            "latitude": 55.6554946
        },
        "1033": {
            "name": "Опарино",
            "population": 747,
            "type": "village",
            "poly": [
                [
                    85.204977,
                    55.4302351
                ],
                [
                    85.2055123,
                    55.4318834
                ],
                [
                    85.2076529,
                    55.43184
                ],
                [
                    85.207844,
                    55.4321436
                ],
                [
                    85.208532,
                    55.432187
                ],
                [
                    85.2083027,
                    55.432534
                ],
                [
                    85.208876,
                    55.433575
                ],
                [
                    85.2096405,
                    55.4340955
                ],
                [
                    85.2113224,
                    55.4336618
                ],
                [
                    85.2130043,
                    55.4335316
                ],
                [
                    85.2139599,
                    55.4343124
                ],
                [
                    85.2149537,
                    55.4343341
                ],
                [
                    85.2149919,
                    55.4339003
                ],
                [
                    85.2182793,
                    55.4340521
                ],
                [
                    85.2181646,
                    55.4344425
                ],
                [
                    85.2186997,
                    55.4345726
                ],
                [
                    85.2186997,
                    55.434963
                ],
                [
                    85.2196553,
                    55.4350497
                ],
                [
                    85.2206109,
                    55.4348328
                ],
                [
                    85.2212225,
                    55.4344642
                ],
                [
                    85.2248921,
                    55.4360473
                ],
                [
                    85.2261153,
                    55.4351798
                ],
                [
                    85.2277589,
                    55.435722
                ],
                [
                    85.228447,
                    55.4351798
                ],
                [
                    85.2288674,
                    55.4353967
                ],
                [
                    85.2299759,
                    55.4350063
                ],
                [
                    85.2291732,
                    55.4340521
                ],
                [
                    85.226918,
                    55.4327726
                ],
                [
                    85.2274913,
                    55.432122
                ],
                [
                    85.2275104,
                    55.4314825
                ],
                [
                    85.2305684,
                    55.4315693
                ],
                [
                    85.2328619,
                    55.432285
                ],
                [
                    85.2325561,
                    55.4328489
                ],
                [
                    85.2344673,
                    55.4332393
                ],
                [
                    85.2331677,
                    55.4344754
                ],
                [
                    85.2346584,
                    55.4351097
                ],
                [
                    85.2365028,
                    55.4340308
                ],
                [
                    85.2370092,
                    55.4333365
                ],
                [
                    85.2366652,
                    55.433163
                ],
                [
                    85.2429722,
                    55.4293241
                ],
                [
                    85.2428192,
                    55.4283698
                ],
                [
                    85.2434309,
                    55.4275239
                ],
                [
                    85.2429722,
                    55.4266562
                ],
                [
                    85.2433545,
                    55.4262658
                ],
                [
                    85.2427429,
                    55.4260923
                ],
                [
                    85.2419402,
                    55.4263309
                ],
                [
                    85.2416726,
                    55.4261357
                ],
                [
                    85.2406405,
                    55.4262658
                ],
                [
                    85.2389587,
                    55.4260055
                ],
                [
                    85.2381942,
                    55.4263959
                ],
                [
                    85.2369328,
                    55.4260055
                ],
                [
                    85.2348304,
                    55.4256151
                ],
                [
                    85.2341042,
                    55.4255934
                ],
                [
                    85.2328045,
                    55.4248342
                ],
                [
                    85.2289056,
                    55.4296712
                ],
                [
                    85.2240894,
                    55.429823
                ],
                [
                    85.2237453,
                    55.4313846
                ],
                [
                    85.2219917,
                    55.4308042
                ],
                [
                    85.2222,
                    55.4305302
                ],
                [
                    85.2208403,
                    55.4302134
                ],
                [
                    85.2189291,
                    55.429888
                ],
                [
                    85.2177823,
                    55.4292157
                ],
                [
                    85.2180499,
                    55.4286301
                ],
                [
                    85.2165209,
                    55.4272636
                ],
                [
                    85.2129661,
                    55.4257669
                ],
                [
                    85.2112842,
                    55.4263526
                ],
                [
                    85.2102521,
                    55.4271117
                ],
                [
                    85.2111695,
                    55.4274805
                ],
                [
                    85.211246,
                    55.4281095
                ],
                [
                    85.2091436,
                    55.4286301
                ],
                [
                    85.2086849,
                    55.4294543
                ],
                [
                    85.204977,
                    55.4302351
                ]
            ],
            "longitude": 85.2227914,
            "latitude": 55.4322159
        },
        "1034": {
            "name": "Шишино",
            "population": 1212,
            "type": "village",
            "poly": [
                [
                    85.2037297,
                    55.3638243
                ],
                [
                    85.2103609,
                    55.3663184
                ],
                [
                    85.210946,
                    55.3684798
                ],
                [
                    85.2081722,
                    55.3704872
                ],
                [
                    85.2114802,
                    55.3732055
                ],
                [
                    85.2142616,
                    55.3744092
                ],
                [
                    85.2170896,
                    55.373301
                ],
                [
                    85.2266464,
                    55.3757944
                ],
                [
                    85.2309372,
                    55.371694
                ],
                [
                    85.2324974,
                    55.372636
                ],
                [
                    85.2342528,
                    55.3720819
                ],
                [
                    85.2363006,
                    55.3730793
                ],
                [
                    85.2389336,
                    55.3715832
                ],
                [
                    85.2559017,
                    55.3649883
                ],
                [
                    85.2390311,
                    55.356064
                ],
                [
                    85.2401038,
                    55.3531258
                ],
                [
                    85.2436145,
                    55.3512962
                ],
                [
                    85.243517,
                    55.3502427
                ],
                [
                    85.2318989,
                    55.3513014
                ],
                [
                    85.2205027,
                    55.3530149
                ],
                [
                    85.2037297,
                    55.3638243
                ]
            ],
            "longitude": 85.2255802,
            "latitude": 55.368246
        },
        "1035": {
            "name": "Ботьево",
            "population": 543,
            "type": "village",
            "poly": null,
            "longitude": 85.228798,
            "latitude": 55.937004
        },
        "1036": {
            "name": "Зырянка",
            "population": 389,
            "type": "village",
            "poly": null,
            "longitude": 85.2316876,
            "latitude": 55.71586
        },
        "1037": {
            "name": "Титово",
            "population": 1120,
            "type": "village",
            "poly": null,
            "longitude": 85.251778,
            "latitude": 55.022217
        },
        "1038": {
            "name": "Белянино",
            "population": 456,
            "type": "village",
            "poly": null,
            "longitude": 85.253611,
            "latitude": 55.5380529
        },
        "1039": {
            "name": "Магистральный",
            "population": 422,
            "type": "village",
            "poly": [
                [
                    85.2770293,
                    55.1815269
                ],
                [
                    85.2928854,
                    55.1878353
                ],
                [
                    85.2963812,
                    55.1846278
                ],
                [
                    85.2961315,
                    55.1833447
                ],
                [
                    85.2991904,
                    55.1830952
                ],
                [
                    85.3001892,
                    55.1811348
                ],
                [
                    85.3016874,
                    55.1814556
                ],
                [
                    85.3021023,
                    55.1808943
                ],
                [
                    85.3007118,
                    55.1803776
                ],
                [
                    85.3011974,
                    55.1795585
                ],
                [
                    85.2997445,
                    55.1786659
                ],
                [
                    85.2978023,
                    55.1785398
                ],
                [
                    85.2966546,
                    55.1790692
                ],
                [
                    85.2956394,
                    55.1806319
                ],
                [
                    85.2946683,
                    55.1806571
                ],
                [
                    85.2937412,
                    55.1797245
                ],
                [
                    85.292417,
                    55.1801278
                ],
                [
                    85.2917108,
                    55.1795733
                ],
                [
                    85.2900334,
                    55.1798253
                ],
                [
                    85.2902982,
                    55.1791448
                ],
                [
                    85.2912694,
                    55.1790944
                ],
                [
                    85.2919315,
                    55.1785398
                ],
                [
                    85.2919315,
                    55.1773299
                ],
                [
                    85.2910928,
                    55.1770527
                ],
                [
                    85.2902982,
                    55.1760696
                ],
                [
                    85.2894154,
                    55.1763217
                ],
                [
                    85.2887974,
                    55.1750865
                ],
                [
                    85.2869435,
                    55.1757167
                ],
                [
                    85.2853103,
                    55.1758427
                ],
                [
                    85.2821652,
                    55.1755213
                ],
                [
                    85.2770293,
                    55.1815269
                ]
            ],
            "longitude": 85.289016,
            "latitude": 55.1813834
        },
        "1040": {
            "name": "Шуринка",
            "population": 473,
            "type": "village",
            "poly": null,
            "longitude": 85.2907962,
            "latitude": 54.8322776
        },
        "1041": {
            "name": "Литвиново",
            "population": 210,
            "type": "village",
            "poly": null,
            "longitude": 85.2976845,
            "latitude": 55.835997
        },
        "1042": {
            "name": "Пьяново",
            "population": 952,
            "type": "village",
            "poly": null,
            "longitude": 85.307716,
            "latitude": 54.929699
        },
        "1043": {
            "name": "Раздолье",
            "population": 776,
            "type": "village",
            "poly": [
                [
                    85.3018673,
                    55.4818159
                ],
                [
                    85.3046194,
                    55.4827906
                ],
                [
                    85.3064924,
                    55.4809711
                ],
                [
                    85.3076009,
                    55.4818592
                ],
                [
                    85.3082125,
                    55.4831805
                ],
                [
                    85.3088241,
                    55.4840902
                ],
                [
                    85.3056133,
                    55.487274
                ],
                [
                    85.3058808,
                    55.4882485
                ],
                [
                    85.3046194,
                    55.4889849
                ],
                [
                    85.3064542,
                    55.4898511
                ],
                [
                    85.3071805,
                    55.489418
                ],
                [
                    85.3076009,
                    55.4888549
                ],
                [
                    85.308977,
                    55.487967
                ],
                [
                    85.3099326,
                    55.4875988
                ],
                [
                    85.3113851,
                    55.4864293
                ],
                [
                    85.3132964,
                    55.4874905
                ],
                [
                    85.3142695,
                    55.4870817
                ],
                [
                    85.3168473,
                    55.4888569
                ],
                [
                    85.3192799,
                    55.4895766
                ],
                [
                    85.3190366,
                    55.4912304
                ],
                [
                    85.3205773,
                    55.4915367
                ],
                [
                    85.3214692,
                    55.490082
                ],
                [
                    85.3245573,
                    55.4908629
                ],
                [
                    85.3312161,
                    55.4873566
                ],
                [
                    85.3300722,
                    55.4864035
                ],
                [
                    85.3271261,
                    55.484671
                ],
                [
                    85.3265145,
                    55.4840212
                ],
                [
                    85.3207426,
                    55.4822018
                ],
                [
                    85.3196341,
                    55.4821585
                ],
                [
                    85.3176464,
                    55.4812054
                ],
                [
                    85.3168259,
                    55.4804103
                ],
                [
                    85.3174942,
                    55.4796365
                ],
                [
                    85.3136786,
                    55.4777977
                ],
                [
                    85.3108881,
                    55.4786317
                ],
                [
                    85.3064924,
                    55.4762271
                ],
                [
                    85.303014,
                    55.4782417
                ],
                [
                    85.305575,
                    55.4796065
                ],
                [
                    85.3031668,
                    55.4813827
                ],
                [
                    85.3024789,
                    55.4811661
                ],
                [
                    85.3018673,
                    55.4818159
                ]
            ],
            "longitude": 85.3172318,
            "latitude": 55.4857093
        },
        "1044": {
            "name": "Новороманово",
            "population": 1037,
            "type": "village",
            "poly": null,
            "longitude": 85.341263,
            "latitude": 55.66267
        },
        "1045": {
            "name": "Литвиново",
            "population": 1356,
            "type": "village",
            "poly": null,
            "longitude": 85.3424157,
            "latitude": 55.8419352
        },
        "1046": {
            "name": "Центральный",
            "population": 707,
            "type": "village",
            "poly": null,
            "longitude": 85.3431063,
            "latitude": 55.2465055
        },
        "1047": {
            "name": "Дубровка",
            "population": 411,
            "type": "village",
            "poly": null,
            "longitude": 85.3465927,
            "latitude": 55.9224372
        },
        "1048": {
            "name": "Прогресс",
            "population": 361,
            "type": "village",
            "poly": null,
            "longitude": 85.3506213,
            "latitude": 54.7574182
        },
        "1049": {
            "name": "Акация",
            "population": 906,
            "type": "village",
            "poly": null,
            "longitude": 85.3637949,
            "latitude": 55.7367594
        },
        "1050": {
            "name": "Большой Корчуган",
            "population": 222,
            "type": "village",
            "poly": [
                [
                    85.3829468,
                    55.2135648
                ],
                [
                    85.3861234,
                    55.2143993
                ],
                [
                    85.3896077,
                    55.2105842
                ],
                [
                    85.3901092,
                    55.2107511
                ],
                [
                    85.3909869,
                    55.2099642
                ],
                [
                    85.392617,
                    55.210298
                ],
                [
                    85.3921154,
                    55.2109419
                ],
                [
                    85.3952082,
                    55.2124919
                ],
                [
                    85.3968383,
                    55.2125635
                ],
                [
                    85.3975907,
                    55.2117289
                ],
                [
                    85.398343,
                    55.2116096
                ],
                [
                    85.4004328,
                    55.2100119
                ],
                [
                    85.4004328,
                    55.2090818
                ],
                [
                    85.3966509,
                    55.2075117
                ],
                [
                    85.3969903,
                    55.2072214
                ],
                [
                    85.3958618,
                    55.2070306
                ],
                [
                    85.3935213,
                    55.2051226
                ],
                [
                    85.3955693,
                    55.2051703
                ],
                [
                    85.3954439,
                    55.2037392
                ],
                [
                    85.3941064,
                    55.2037392
                ],
                [
                    85.393981,
                    55.2046694
                ],
                [
                    85.3925182,
                    55.2042401
                ],
                [
                    85.3922256,
                    55.2047887
                ],
                [
                    85.389885,
                    55.2066728
                ],
                [
                    85.3891745,
                    55.2066013
                ],
                [
                    85.3867085,
                    55.2085331
                ],
                [
                    85.3857054,
                    55.2097493
                ],
                [
                    85.3849113,
                    55.2113471
                ],
                [
                    85.3840754,
                    55.212134
                ],
                [
                    85.3832812,
                    55.2125632
                ],
                [
                    85.3829468,
                    55.2135648
                ]
            ],
            "longitude": 85.3922526,
            "latitude": 55.2090768
        },
        "1051": {
            "name": "Красное",
            "population": 2982,
            "type": "village",
            "poly": [
                [
                    85.3362913,
                    54.6115598
                ],
                [
                    85.3575774,
                    54.6158342
                ],
                [
                    85.3726836,
                    54.6112615
                ],
                [
                    85.3915662,
                    54.6181204
                ],
                [
                    85.3968878,
                    54.6181204
                ],
                [
                    85.4052992,
                    54.6099691
                ],
                [
                    85.4193755,
                    54.6107644
                ],
                [
                    85.424697,
                    54.6068871
                ],
                [
                    85.391738,
                    54.5948551
                ],
                [
                    85.3814383,
                    54.602214
                ],
                [
                    85.3726836,
                    54.5990319
                ],
                [
                    85.365302,
                    54.6021145
                ],
                [
                    85.3666754,
                    54.6066883
                ],
                [
                    85.3525992,
                    54.6109633
                ],
                [
                    85.3378363,
                    54.6077819
                ],
                [
                    85.3362913,
                    54.6115598
                ]
            ],
            "longitude": 85.395073,
            "latitude": 54.608673
        },
        "1052": {
            "name": "Кокуй",
            "population": 264,
            "type": "village",
            "poly": null,
            "longitude": 85.401833,
            "latitude": 54.578209
        },
        "1053": {
            "name": "Яшкинский",
            "population": 993,
            "type": "village",
            "poly": null,
            "longitude": 85.4024903,
            "latitude": 55.8751611
        },
        "1054": {
            "name": "Ариничево",
            "population": 765,
            "type": "village",
            "poly": null,
            "longitude": 85.406494,
            "latitude": 54.550442
        },
        "1055": {
            "name": "Урск",
            "population": 1665,
            "type": "village",
            "poly": [
                [
                    85.3808457,
                    54.4514816
                ],
                [
                    85.3900381,
                    54.4604928
                ],
                [
                    85.405007,
                    54.4615954
                ],
                [
                    85.4130322,
                    54.4593403
                ],
                [
                    85.4147664,
                    54.4549942
                ],
                [
                    85.4115902,
                    54.4498299
                ],
                [
                    85.3888537,
                    54.4435316
                ],
                [
                    85.3808457,
                    54.4514816
                ]
            ],
            "longitude": 85.407219,
            "latitude": 54.456802
        },
        "1056": {
            "name": "Власково",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 85.4133367,
            "latitude": 55.7568247
        },
        "1057": {
            "name": "Рассвет",
            "population": 805,
            "type": "village",
            "poly": [
                [
                    85.4129035,
                    55.354252
                ],
                [
                    85.4156735,
                    55.3570515
                ],
                [
                    85.4201363,
                    55.3568765
                ],
                [
                    85.4219955,
                    55.3583249
                ],
                [
                    85.4322786,
                    55.35783
                ],
                [
                    85.4314081,
                    55.3556959
                ],
                [
                    85.4353255,
                    55.3544278
                ],
                [
                    85.434727,
                    55.3537473
                ],
                [
                    85.4358151,
                    55.3531596
                ],
                [
                    85.4333668,
                    55.3511799
                ],
                [
                    85.439842,
                    55.3488157
                ],
                [
                    85.4413039,
                    55.3472844
                ],
                [
                    85.4397651,
                    55.3463657
                ],
                [
                    85.4373028,
                    55.3472407
                ],
                [
                    85.4288389,
                    55.3468907
                ],
                [
                    85.4241453,
                    55.3479407
                ],
                [
                    85.4183745,
                    55.3487282
                ],
                [
                    85.4210675,
                    55.3508281
                ],
                [
                    85.4129035,
                    55.354252
                ]
            ],
            "longitude": 85.4265235,
            "latitude": 55.3546898
        },
        "1058": {
            "name": "Окунево",
            "population": 1447,
            "type": "village",
            "poly": null,
            "longitude": 85.4299083,
            "latitude": 54.9513359
        },
        "1059": {
            "name": "Усть-Тарсьма",
            "population": 602,
            "type": "village",
            "poly": null,
            "longitude": 85.4341463,
            "latitude": 55.0021393
        },
        "1060": {
            "name": "Краснинское",
            "population": 1379,
            "type": "village",
            "poly": [
                [
                    85.4394194,
                    54.7964304
                ],
                [
                    85.4494677,
                    54.8029177
                ],
                [
                    85.4567026,
                    54.8057556
                ],
                [
                    85.4622293,
                    54.8039602
                ],
                [
                    85.4657463,
                    54.7970676
                ],
                [
                    85.4657463,
                    54.7910427
                ],
                [
                    85.4550949,
                    54.78803
                ],
                [
                    85.4430368,
                    54.7912166
                ],
                [
                    85.4394194,
                    54.7964304
                ]
            ],
            "longitude": 85.452217,
            "latitude": 54.795383
        },
        "1061": {
            "name": "Большеямное",
            "population": 410,
            "type": "village",
            "poly": [
                [
                    85.4826363,
                    55.5915001
                ],
                [
                    85.4934231,
                    55.5893357
                ],
                [
                    85.4949082,
                    55.5849624
                ],
                [
                    85.4970315,
                    55.5805879
                ],
                [
                    85.5002276,
                    55.5800717
                ],
                [
                    85.4987906,
                    55.5790095
                ],
                [
                    85.4954743,
                    55.5778222
                ],
                [
                    85.4996749,
                    55.5751664
                ],
                [
                    85.4995186,
                    55.5692394
                ],
                [
                    85.4970252,
                    55.5670782
                ],
                [
                    85.4966383,
                    55.5613144
                ],
                [
                    85.4929904,
                    55.5625021
                ],
                [
                    85.4937642,
                    55.5683778
                ],
                [
                    85.4860318,
                    55.5787148
                ],
                [
                    85.4854847,
                    55.5819843
                ],
                [
                    85.4857192,
                    55.5878599
                ],
                [
                    85.4826363,
                    55.5915001
                ]
            ],
            "longitude": 85.4914282,
            "latitude": 55.5805408
        },
        "1062": {
            "name": "Пача",
            "population": 1203,
            "type": "village",
            "poly": null,
            "longitude": 85.4929336,
            "latitude": 55.7061539
        },
        "1063": {
            "name": "Таёжный",
            "population": 1179,
            "type": "village",
            "poly": null,
            "longitude": 85.5043874,
            "latitude": 56.1044404
        },
        "1064": {
            "name": "Зарубино",
            "population": 1427,
            "type": "village",
            "poly": [
                [
                    85.5104273,
                    55.4539876
                ],
                [
                    85.5107687,
                    55.4578292
                ],
                [
                    85.516672,
                    55.4604976
                ],
                [
                    85.5171318,
                    55.4617242
                ],
                [
                    85.5165941,
                    55.4628885
                ],
                [
                    85.5164746,
                    55.4641218
                ],
                [
                    85.5144505,
                    55.4639033
                ],
                [
                    85.5137047,
                    55.4641724
                ],
                [
                    85.5127676,
                    55.4648807
                ],
                [
                    85.5127798,
                    55.4657793
                ],
                [
                    85.5144075,
                    55.4658547
                ],
                [
                    85.5160997,
                    55.4671593
                ],
                [
                    85.5218975,
                    55.4675711
                ],
                [
                    85.5240128,
                    55.4666958
                ],
                [
                    85.5266679,
                    55.4662974
                ],
                [
                    85.5274868,
                    55.4659099
                ],
                [
                    85.5298241,
                    55.463936
                ],
                [
                    85.5327802,
                    55.4635124
                ],
                [
                    85.5333813,
                    55.4641958
                ],
                [
                    85.5356484,
                    55.4646723
                ],
                [
                    85.5395325,
                    55.4654615
                ],
                [
                    85.540334,
                    55.4660318
                ],
                [
                    85.540334,
                    55.4669614
                ],
                [
                    85.5439262,
                    55.46705
                ],
                [
                    85.5469859,
                    55.4680754
                ],
                [
                    85.5498646,
                    55.4687974
                ],
                [
                    85.5525944,
                    55.4686879
                ],
                [
                    85.554744,
                    55.4685543
                ],
                [
                    85.551822,
                    55.4668617
                ],
                [
                    85.5480017,
                    55.4665566
                ],
                [
                    85.5483916,
                    55.4651906
                ],
                [
                    85.5493145,
                    55.4632427
                ],
                [
                    85.5489468,
                    55.4623411
                ],
                [
                    85.5457252,
                    55.4613502
                ],
                [
                    85.5321869,
                    55.4598504
                ],
                [
                    85.531433,
                    55.4573532
                ],
                [
                    85.5342347,
                    55.4579528
                ],
                [
                    85.5364521,
                    55.4575189
                ],
                [
                    85.536411,
                    55.4563371
                ],
                [
                    85.5302374,
                    55.4537446
                ],
                [
                    85.5308849,
                    55.4497371
                ],
                [
                    85.5308849,
                    55.4482313
                ],
                [
                    85.5347895,
                    55.4476555
                ],
                [
                    85.5356484,
                    55.447124
                ],
                [
                    85.5351799,
                    55.4449537
                ],
                [
                    85.5288545,
                    55.4440235
                ],
                [
                    85.5251842,
                    55.4460167
                ],
                [
                    85.5222948,
                    55.4469911
                ],
                [
                    85.5195436,
                    55.4468817
                ],
                [
                    85.5165388,
                    55.4475983
                ],
                [
                    85.5144634,
                    55.4510156
                ],
                [
                    85.5137758,
                    55.4522081
                ],
                [
                    85.5115269,
                    55.4524996
                ],
                [
                    85.5104273,
                    55.4539876
                ]
            ],
            "longitude": 85.52668,
            "latitude": 55.45784
        },
        "1065": {
            "name": "Иваново-Родионовский",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 85.5362809,
            "latitude": 54.8927673
        },
        "1066": {
            "name": "Каменка",
            "population": 862,
            "type": "village",
            "poly": null,
            "longitude": 85.5435454,
            "latitude": 54.840696
        },
        "1067": {
            "name": "Кузель",
            "population": 359,
            "type": "village",
            "poly": null,
            "longitude": 85.5468517,
            "latitude": 56.008781
        },
        "1068": {
            "name": "Мокроусовский",
            "population": 344,
            "type": "village",
            "poly": null,
            "longitude": 85.5656614,
            "latitude": 55.1783362
        },
        "1069": {
            "name": "Малый Корчуган",
            "population": 500,
            "type": "village",
            "poly": [
                [
                    85.5687859,
                    55.2382643
                ],
                [
                    85.5711669,
                    55.2392768
                ],
                [
                    85.5732655,
                    55.2384024
                ],
                [
                    85.5757982,
                    55.2399536
                ],
                [
                    85.5747079,
                    55.2405068
                ],
                [
                    85.5739945,
                    55.2411901
                ],
                [
                    85.5753371,
                    55.2417668
                ],
                [
                    85.575902,
                    55.2412491
                ],
                [
                    85.5770523,
                    55.2417898
                ],
                [
                    85.5772944,
                    55.2417093
                ],
                [
                    85.5782025,
                    55.242457
                ],
                [
                    85.5834691,
                    55.2403057
                ],
                [
                    85.5834691,
                    55.2400296
                ],
                [
                    85.5851641,
                    55.2392013
                ],
                [
                    85.585975,
                    55.2392128
                ],
                [
                    85.5874018,
                    55.2382528
                ],
                [
                    85.5891996,
                    55.2366338
                ],
                [
                    85.5895278,
                    55.2366176
                ],
                [
                    85.5906098,
                    55.235501
                ],
                [
                    85.5902672,
                    55.2351756
                ],
                [
                    85.5910378,
                    55.2341992
                ],
                [
                    85.5909237,
                    55.2335158
                ],
                [
                    85.59041,
                    55.233288
                ],
                [
                    85.5904385,
                    55.2328649
                ],
                [
                    85.5876419,
                    55.2330113
                ],
                [
                    85.5862436,
                    55.2355824
                ],
                [
                    85.5857585,
                    55.2354847
                ],
                [
                    85.585416,
                    55.2358915
                ],
                [
                    85.5857585,
                    55.2359891
                ],
                [
                    85.5844855,
                    55.2373162
                ],
                [
                    85.5828873,
                    55.2368349
                ],
                [
                    85.5826466,
                    55.2369216
                ],
                [
                    85.5816377,
                    55.2366109
                ],
                [
                    85.5818898,
                    55.23626
                ],
                [
                    85.5810626,
                    55.2360241
                ],
                [
                    85.5813048,
                    55.2356042
                ],
                [
                    85.5803967,
                    55.2353856
                ],
                [
                    85.5807801,
                    55.2349656
                ],
                [
                    85.5804673,
                    55.2348735
                ],
                [
                    85.5799023,
                    55.2352187
                ],
                [
                    85.5781889,
                    55.2345744
                ],
                [
                    85.5789355,
                    55.2340336
                ],
                [
                    85.5775633,
                    55.2334928
                ],
                [
                    85.577301,
                    55.2336884
                ],
                [
                    85.5769782,
                    55.2336424
                ],
                [
                    85.5766553,
                    55.2340106
                ],
                [
                    85.5758482,
                    55.2337866
                ],
                [
                    85.5709507,
                    55.2358934
                ],
                [
                    85.5710011,
                    55.2361983
                ],
                [
                    85.5693061,
                    55.2369922
                ],
                [
                    85.5696996,
                    55.2372166
                ],
                [
                    85.5687859,
                    55.2382643
                ]
            ],
            "longitude": 85.5790155,
            "latitude": 55.237611
        },
        "1070": {
            "name": "Лебеди",
            "population": 706,
            "type": "village",
            "poly": [
                [
                    85.573517,
                    55.0420462
                ],
                [
                    85.5735744,
                    55.0443833
                ],
                [
                    85.5754703,
                    55.046457
                ],
                [
                    85.5786302,
                    55.0471811
                ],
                [
                    85.57593,
                    55.041717
                ],
                [
                    85.5772514,
                    55.0414537
                ],
                [
                    85.5778258,
                    55.0398406
                ],
                [
                    85.57886,
                    55.0398735
                ],
                [
                    85.5812155,
                    55.0435604
                ],
                [
                    85.5801814,
                    55.0438237
                ],
                [
                    85.5813879,
                    55.0460291
                ],
                [
                    85.5809283,
                    55.0465558
                ],
                [
                    85.5797218,
                    55.049156
                ],
                [
                    85.5827982,
                    55.049572
                ],
                [
                    85.5836814,
                    55.0484329
                ],
                [
                    85.5841892,
                    55.0471994
                ],
                [
                    85.5849407,
                    55.0471762
                ],
                [
                    85.5860173,
                    55.0475136
                ],
                [
                    85.5883126,
                    55.0464314
                ],
                [
                    85.5878759,
                    55.0457739
                ],
                [
                    85.5905608,
                    55.0440393
                ],
                [
                    85.5897788,
                    55.0436204
                ],
                [
                    85.590317,
                    55.043277
                ],
                [
                    85.5891084,
                    55.0425729
                ],
                [
                    85.5907301,
                    55.041731
                ],
                [
                    85.5910604,
                    55.0412084
                ],
                [
                    85.5924171,
                    55.0420687
                ],
                [
                    85.593981,
                    55.0437096
                ],
                [
                    85.5937374,
                    55.0447221
                ],
                [
                    85.591828,
                    55.0445708
                ],
                [
                    85.5914827,
                    55.0461419
                ],
                [
                    85.5934124,
                    55.0467121
                ],
                [
                    85.5944686,
                    55.0474336
                ],
                [
                    85.5969467,
                    55.0476198
                ],
                [
                    85.5971296,
                    55.0473871
                ],
                [
                    85.5996686,
                    55.0475267
                ],
                [
                    85.5996889,
                    55.0463397
                ],
                [
                    85.5990795,
                    55.0460488
                ],
                [
                    85.5964999,
                    55.0459441
                ],
                [
                    85.5974546,
                    55.0419406
                ],
                [
                    85.5980842,
                    55.0419756
                ],
                [
                    85.5985311,
                    55.0413122
                ],
                [
                    85.5993436,
                    55.0408233
                ],
                [
                    85.5986327,
                    55.0401366
                ],
                [
                    85.5990592,
                    55.0392171
                ],
                [
                    85.5980233,
                    55.0378437
                ],
                [
                    85.5968858,
                    55.0379601
                ],
                [
                    85.5957889,
                    55.0380299
                ],
                [
                    85.595078,
                    55.0388796
                ],
                [
                    85.5942452,
                    55.0377156
                ],
                [
                    85.5934937,
                    55.0374363
                ],
                [
                    85.5901827,
                    55.0374945
                ],
                [
                    85.5861,
                    55.0373781
                ],
                [
                    85.5860187,
                    55.0368776
                ],
                [
                    85.5816922,
                    55.0367728
                ],
                [
                    85.580311,
                    55.0362723
                ],
                [
                    85.5789094,
                    55.0363887
                ],
                [
                    85.5789805,
                    55.0373199
                ],
                [
                    85.5782087,
                    55.0374188
                ],
                [
                    85.5781477,
                    55.036931
                ],
                [
                    85.5770215,
                    55.0369764
                ],
                [
                    85.5767917,
                    55.037569
                ],
                [
                    85.5755278,
                    55.0385567
                ],
                [
                    85.5760449,
                    55.0401698
                ],
                [
                    85.5747235,
                    55.0402027
                ],
                [
                    85.5744361,
                    55.0419804
                ],
                [
                    85.573517,
                    55.0420462
                ]
            ],
            "longitude": 85.5858385,
            "latitude": 55.0410351
        },
        "1071": {
            "name": "Октябрьский",
            "population": 292,
            "type": "village",
            "poly": [
                [
                    85.5900709,
                    55.3215775
                ],
                [
                    85.5906121,
                    55.3219432
                ],
                [
                    85.5903753,
                    55.3223473
                ],
                [
                    85.5906121,
                    55.3228283
                ],
                [
                    85.5900709,
                    55.3247141
                ],
                [
                    85.5910179,
                    55.3252528
                ],
                [
                    85.5922693,
                    55.3257724
                ],
                [
                    85.5912885,
                    55.3267729
                ],
                [
                    85.5921002,
                    55.327023
                ],
                [
                    85.5932163,
                    55.3270615
                ],
                [
                    85.5936221,
                    55.3265228
                ],
                [
                    85.5942986,
                    55.3265035
                ],
                [
                    85.5946368,
                    55.3262341
                ],
                [
                    85.5952456,
                    55.326061
                ],
                [
                    85.5954485,
                    55.3256954
                ],
                [
                    85.5957528,
                    55.3256184
                ],
                [
                    85.596463,
                    55.3242908
                ],
                [
                    85.5953809,
                    55.3239059
                ],
                [
                    85.5954823,
                    55.3234249
                ],
                [
                    85.596463,
                    55.3236173
                ],
                [
                    85.5972749,
                    55.3242523
                ],
                [
                    85.5981879,
                    55.3238867
                ],
                [
                    85.5987968,
                    55.3222318
                ],
                [
                    85.5982557,
                    55.3222511
                ],
                [
                    85.598391,
                    55.3214813
                ],
                [
                    85.5995408,
                    55.3201343
                ],
                [
                    85.5992703,
                    55.3194222
                ],
                [
                    85.600082,
                    55.3184792
                ],
                [
                    85.5992365,
                    55.3180751
                ],
                [
                    85.5989321,
                    55.3184023
                ],
                [
                    85.5966999,
                    55.3169781
                ],
                [
                    85.5954147,
                    55.3165162
                ],
                [
                    85.5956853,
                    55.3162083
                ],
                [
                    85.5947383,
                    55.3157849
                ],
                [
                    85.5931148,
                    55.3166702
                ],
                [
                    85.5918296,
                    55.3174593
                ],
                [
                    85.5930134,
                    55.3180751
                ],
                [
                    85.5932839,
                    55.3191528
                ],
                [
                    85.5900709,
                    55.3215775
                ]
            ],
            "longitude": 85.5940321,
            "latitude": 55.3209983
        },
        "1072": {
            "name": "Шабаново",
            "population": 1421,
            "type": "village",
            "poly": null,
            "longitude": 85.615562,
            "latitude": 54.674416
        },
        "1073": {
            "name": "Уфимцево",
            "population": 789,
            "type": "village",
            "poly": [
                [
                    85.6196101,
                    54.9958498
                ],
                [
                    85.6261059,
                    54.9955414
                ],
                [
                    85.6259268,
                    54.9945905
                ],
                [
                    85.6293763,
                    54.994462
                ],
                [
                    85.6348866,
                    54.9947704
                ],
                [
                    85.6373506,
                    54.9953615
                ],
                [
                    85.6389634,
                    54.9951302
                ],
                [
                    85.6394562,
                    54.9935368
                ],
                [
                    85.6385602,
                    54.9928943
                ],
                [
                    85.6390978,
                    54.9919177
                ],
                [
                    85.6375745,
                    54.9904784
                ],
                [
                    85.6377986,
                    54.9865973
                ],
                [
                    85.638381,
                    54.9859032
                ],
                [
                    85.638829,
                    54.9859803
                ],
                [
                    85.6414721,
                    54.9842067
                ],
                [
                    85.6423681,
                    54.9835897
                ],
                [
                    85.6424417,
                    54.983222
                ],
                [
                    85.6416513,
                    54.9831784
                ],
                [
                    85.6417448,
                    54.9820041
                ],
                [
                    85.6410637,
                    54.9819677
                ],
                [
                    85.6410162,
                    54.9814497
                ],
                [
                    85.6396699,
                    54.9814133
                ],
                [
                    85.6393372,
                    54.980359
                ],
                [
                    85.6378167,
                    54.9803408
                ],
                [
                    85.6368981,
                    54.9798863
                ],
                [
                    85.631006,
                    54.9806135
                ],
                [
                    85.6311327,
                    54.9817042
                ],
                [
                    85.6305308,
                    54.9817587
                ],
                [
                    85.6296755,
                    54.980977
                ],
                [
                    85.6285192,
                    54.9812133
                ],
                [
                    85.6289061,
                    54.9821093
                ],
                [
                    85.6280101,
                    54.9823793
                ],
                [
                    85.6271365,
                    54.9839988
                ],
                [
                    85.6261279,
                    54.9840989
                ],
                [
                    85.624884,
                    54.9849524
                ],
                [
                    85.6242883,
                    54.985273
                ],
                [
                    85.6230786,
                    54.9862305
                ],
                [
                    85.6228916,
                    54.9868607
                ],
                [
                    85.6217156,
                    54.9870856
                ],
                [
                    85.6205957,
                    54.9890134
                ],
                [
                    85.6209541,
                    54.9893732
                ],
                [
                    85.6206404,
                    54.9915836
                ],
                [
                    85.6199237,
                    54.9925859
                ],
                [
                    85.6196101,
                    54.9958498
                ]
            ],
            "longitude": 85.6274749,
            "latitude": 54.9865111
        },
        "1074": {
            "name": "Горскино",
            "population": 1047,
            "type": "village",
            "poly": null,
            "longitude": 85.634682,
            "latitude": 54.466091
        },
        "1075": {
            "name": "Колмогорово",
            "population": 1582,
            "type": "village",
            "poly": null,
            "longitude": 85.662025,
            "latitude": 55.637383
        },
        "1076": {
            "name": "Кедровый",
            "population": 308,
            "type": "village",
            "poly": null,
            "longitude": 85.6734571,
            "latitude": 56.1141431
        },
        "1077": {
            "name": "Глубокое",
            "population": 723,
            "type": "village",
            "poly": [
                [
                    85.6899272,
                    55.5186075
                ],
                [
                    85.690821,
                    55.5203317
                ],
                [
                    85.6926087,
                    55.5211937
                ],
                [
                    85.6933221,
                    55.522666
                ],
                [
                    85.6979101,
                    55.5248391
                ],
                [
                    85.7007191,
                    55.5256341
                ],
                [
                    85.7034345,
                    55.523832
                ],
                [
                    85.7065244,
                    55.524256
                ],
                [
                    85.7078036,
                    55.5261971
                ],
                [
                    85.7188274,
                    55.5308064
                ],
                [
                    85.7203171,
                    55.5301881
                ],
                [
                    85.7257131,
                    55.531762
                ],
                [
                    85.7328637,
                    55.5343848
                ],
                [
                    85.7337575,
                    55.5320055
                ],
                [
                    85.7354458,
                    55.5315371
                ],
                [
                    85.732334,
                    55.5306753
                ],
                [
                    85.7348831,
                    55.5288579
                ],
                [
                    85.7283615,
                    55.5282395
                ],
                [
                    85.7137955,
                    55.5178016
                ],
                [
                    85.7063801,
                    55.517333
                ],
                [
                    85.70158,
                    55.514128
                ],
                [
                    85.697773,
                    55.5134907
                ],
                [
                    85.6942639,
                    55.5148402
                ],
                [
                    85.6931715,
                    55.5160398
                ],
                [
                    85.6966143,
                    55.5155899
                ],
                [
                    85.6954557,
                    55.5182701
                ],
                [
                    85.6974088,
                    55.5193384
                ],
                [
                    85.6980378,
                    55.520669
                ],
                [
                    85.6953564,
                    55.5196757
                ],
                [
                    85.6918804,
                    55.5182889
                ],
                [
                    85.6899272,
                    55.5186075
                ]
            ],
            "longitude": 85.71026,
            "latitude": 55.5253966
        },
        "1078": {
            "name": "Еремино",
            "population": 460,
            "type": "village",
            "poly": null,
            "longitude": 85.7106294,
            "latitude": 54.901095
        },
        "1079": {
            "name": "Сосновка",
            "population": 1154,
            "type": "village",
            "poly": null,
            "longitude": 85.728386,
            "latitude": 54.290611
        },
        "1080": {
            "name": "Новопестерево",
            "population": 1056,
            "type": "village",
            "poly": [
                [
                    85.7327435,
                    54.4469673
                ],
                [
                    85.7333869,
                    54.4498104
                ],
                [
                    85.738534,
                    54.4520548
                ],
                [
                    85.7490857,
                    54.45198
                ],
                [
                    85.7547002,
                    54.4477323
                ],
                [
                    85.7518926,
                    54.4462874
                ],
                [
                    85.7466408,
                    54.4429267
                ],
                [
                    85.7399495,
                    54.4430764
                ],
                [
                    85.7380193,
                    54.4437498
                ],
                [
                    85.7327435,
                    54.4469673
                ]
            ],
            "longitude": 85.7433213,
            "latitude": 54.4474064
        },
        "1081": {
            "name": "Топки",
            "population": 1562,
            "type": "village",
            "poly": [
                [
                    85.7477224,
                    55.3341681
                ],
                [
                    85.7563365,
                    55.3365378
                ],
                [
                    85.7601714,
                    55.3385893
                ],
                [
                    85.7596262,
                    55.3389379
                ],
                [
                    85.7622596,
                    55.3405759
                ],
                [
                    85.7676221,
                    55.3415802
                ],
                [
                    85.7709819,
                    55.3417834
                ],
                [
                    85.7740299,
                    55.3425839
                ],
                [
                    85.7783724,
                    55.34266
                ],
                [
                    85.7911373,
                    55.3389141
                ],
                [
                    85.7954479,
                    55.3376423
                ],
                [
                    85.7981178,
                    55.3369446
                ],
                [
                    85.799105,
                    55.3372469
                ],
                [
                    85.7996745,
                    55.336923
                ],
                [
                    85.7989531,
                    55.3359728
                ],
                [
                    85.799155,
                    55.3353856
                ],
                [
                    85.7992948,
                    55.3349794
                ],
                [
                    85.797814,
                    55.3348066
                ],
                [
                    85.7969561,
                    55.3344701
                ],
                [
                    85.7951999,
                    55.3315079
                ],
                [
                    85.7993074,
                    55.3299902
                ],
                [
                    85.7981937,
                    55.3294505
                ],
                [
                    85.7971499,
                    55.3292206
                ],
                [
                    85.7909098,
                    55.3303871
                ],
                [
                    85.7901366,
                    55.3291425
                ],
                [
                    85.785702,
                    55.3297313
                ],
                [
                    85.7826645,
                    55.3254113
                ],
                [
                    85.7813222,
                    55.3256357
                ],
                [
                    85.7807661,
                    55.3288457
                ],
                [
                    85.7790717,
                    55.3291895
                ],
                [
                    85.7768553,
                    55.330876
                ],
                [
                    85.7771152,
                    55.3317692
                ],
                [
                    85.7734002,
                    55.3312648
                ],
                [
                    85.7695274,
                    55.3292777
                ],
                [
                    85.7702488,
                    55.3302065
                ],
                [
                    85.772413,
                    55.3312
                ],
                [
                    85.7715018,
                    55.3317831
                ],
                [
                    85.7696465,
                    55.3315344
                ],
                [
                    85.7689217,
                    55.3320307
                ],
                [
                    85.7703849,
                    55.3327153
                ],
                [
                    85.7661704,
                    55.3341839
                ],
                [
                    85.7651073,
                    55.333428
                ],
                [
                    85.7633228,
                    55.3324994
                ],
                [
                    85.7635126,
                    55.3317219
                ],
                [
                    85.7649927,
                    55.3305066
                ],
                [
                    85.7600575,
                    55.3281149
                ],
                [
                    85.755767,
                    55.3304692
                ],
                [
                    85.754552,
                    55.3316571
                ],
                [
                    85.7529573,
                    55.3309659
                ],
                [
                    85.7509829,
                    55.330858
                ],
                [
                    85.7477224,
                    55.3341681
                ]
            ],
            "longitude": 85.7662135,
            "latitude": 55.334955
        },
        "1082": {
            "name": "Трещевский",
            "population": 758,
            "type": "village",
            "poly": [
                [
                    85.7546646,
                    55.1202985
                ],
                [
                    85.7568363,
                    55.1221428
                ],
                [
                    85.7571213,
                    55.1235336
                ],
                [
                    85.7579817,
                    55.1243282
                ],
                [
                    85.7594358,
                    55.1282098
                ],
                [
                    85.7654429,
                    55.129107
                ],
                [
                    85.7704378,
                    55.1306918
                ],
                [
                    85.7747684,
                    55.1284031
                ],
                [
                    85.7762553,
                    55.127214
                ],
                [
                    85.770635,
                    55.1244139
                ],
                [
                    85.7685185,
                    55.1209574
                ],
                [
                    85.7621767,
                    55.1182527
                ],
                [
                    85.7587069,
                    55.1174121
                ],
                [
                    85.7581625,
                    55.1184675
                ],
                [
                    85.7546646,
                    55.1202985
                ]
            ],
            "longitude": 85.767207,
            "latitude": 55.125449
        },
        "1083": {
            "name": "Калинкино",
            "population": 719,
            "type": "village",
            "poly": null,
            "longitude": 85.7744631,
            "latitude": 54.9256452
        },
        "1084": {
            "name": "Мусохраново",
            "population": 505,
            "type": "village",
            "poly": [
                [
                    85.7563604,
                    54.7074635
                ],
                [
                    85.7601304,
                    54.7094711
                ],
                [
                    85.7609827,
                    54.7119898
                ],
                [
                    85.7587863,
                    54.7162695
                ],
                [
                    85.7659326,
                    54.7172731
                ],
                [
                    85.7682275,
                    54.7139972
                ],
                [
                    85.7767179,
                    54.7151712
                ],
                [
                    85.7823236,
                    54.7160991
                ],
                [
                    85.7819958,
                    54.7121224
                ],
                [
                    85.7852084,
                    54.7124633
                ],
                [
                    85.7856674,
                    54.7113838
                ],
                [
                    85.7916009,
                    54.7114975
                ],
                [
                    85.7919021,
                    54.7136844
                ],
                [
                    85.7987658,
                    54.7115836
                ],
                [
                    85.8036318,
                    54.7101928
                ],
                [
                    85.8036318,
                    54.7067897
                ],
                [
                    85.7998414,
                    54.7069672
                ],
                [
                    85.7903142,
                    54.7067897
                ],
                [
                    85.7893922,
                    54.7054875
                ],
                [
                    85.7850896,
                    54.7056651
                ],
                [
                    85.7684938,
                    54.7061386
                ],
                [
                    85.7633716,
                    54.7076775
                ],
                [
                    85.7622448,
                    54.7070856
                ],
                [
                    85.7625009,
                    54.704718
                ],
                [
                    85.7595731,
                    54.703808
                ],
                [
                    85.7563604,
                    54.7074635
                ]
            ],
            "longitude": 85.779839,
            "latitude": 54.710529
        },
        "1085": {
            "name": "Морозово",
            "population": 471,
            "type": "village",
            "poly": null,
            "longitude": 85.7820791,
            "latitude": 54.9052669
        },
        "1086": {
            "name": "Камышино",
            "population": 621,
            "type": "village",
            "poly": null,
            "longitude": 85.796303,
            "latitude": 54.61713
        },
        "1087": {
            "name": "Усть-Хмелевка",
            "population": 295,
            "type": "village",
            "poly": null,
            "longitude": 85.805107,
            "latitude": 55.620613
        },
        "1088": {
            "name": "Благодатный",
            "population": 439,
            "type": "village",
            "poly": [
                [
                    85.8016295,
                    55.399692
                ],
                [
                    85.8024905,
                    55.4001265
                ],
                [
                    85.8018926,
                    55.4005475
                ],
                [
                    85.8026101,
                    55.4010364
                ],
                [
                    85.8039015,
                    55.4010907
                ],
                [
                    85.8042363,
                    55.40234
                ],
                [
                    85.8078236,
                    55.4026931
                ],
                [
                    85.8082541,
                    55.4029375
                ],
                [
                    85.8078236,
                    55.4033992
                ],
                [
                    85.8092585,
                    55.4033177
                ],
                [
                    85.8120804,
                    55.4045127
                ],
                [
                    85.8150938,
                    55.4056804
                ],
                [
                    85.8182028,
                    55.4064136
                ],
                [
                    85.8198769,
                    55.4065494
                ],
                [
                    85.8223402,
                    55.4060606
                ],
                [
                    85.8228663,
                    55.4053002
                ],
                [
                    85.8230577,
                    55.4042954
                ],
                [
                    85.8237989,
                    55.4041732
                ],
                [
                    85.8236316,
                    55.4038881
                ],
                [
                    85.8214792,
                    55.4032498
                ],
                [
                    85.8202835,
                    55.4027067
                ],
                [
                    85.8194704,
                    55.402503
                ],
                [
                    85.8173419,
                    55.4012129
                ],
                [
                    85.8148547,
                    55.4000451
                ],
                [
                    85.8148786,
                    55.3997599
                ],
                [
                    85.8123674,
                    55.3978993
                ],
                [
                    85.8116979,
                    55.3976956
                ],
                [
                    85.8103586,
                    55.3972067
                ],
                [
                    85.809402,
                    55.3970573
                ],
                [
                    85.8084932,
                    55.3964597
                ],
                [
                    85.8056234,
                    55.3980216
                ],
                [
                    85.8021079,
                    55.3993525
                ],
                [
                    85.8016295,
                    55.399692
                ]
            ],
            "longitude": 85.811966,
            "latitude": 55.401524
        },
        "1089": {
            "name": "Пор-Искитим",
            "population": 742,
            "type": "village",
            "poly": null,
            "longitude": 85.8180908,
            "latitude": 55.059562
        },
        "1090": {
            "name": "Таловка",
            "population": 534,
            "type": "village",
            "poly": null,
            "longitude": 85.831711,
            "latitude": 55.959728
        },
        "1091": {
            "name": "Кулебакино",
            "population": 365,
            "type": "village",
            "poly": null,
            "longitude": 85.836197,
            "latitude": 54.409882
        },
        "1092": {
            "name": "Звёздный",
            "population": 1385,
            "type": "village",
            "poly": [
                [
                    85.8235124,
                    55.4535707
                ],
                [
                    85.8246044,
                    55.4552218
                ],
                [
                    85.8250676,
                    55.45525
                ],
                [
                    85.825779,
                    55.4560192
                ],
                [
                    85.8265234,
                    55.4558598
                ],
                [
                    85.8274665,
                    55.455916
                ],
                [
                    85.8277974,
                    55.4563663
                ],
                [
                    85.8300143,
                    55.4572106
                ],
                [
                    85.8313379,
                    55.4568073
                ],
                [
                    85.8330089,
                    55.4580831
                ],
                [
                    85.8306596,
                    55.4604282
                ],
                [
                    85.838303,
                    55.4646678
                ],
                [
                    85.843531,
                    55.4620603
                ],
                [
                    85.8448711,
                    55.4611692
                ],
                [
                    85.8452185,
                    55.460869
                ],
                [
                    85.8553271,
                    55.4563382
                ],
                [
                    85.8608694,
                    55.4542274
                ],
                [
                    85.8587187,
                    55.4530077
                ],
                [
                    85.8563859,
                    55.4540397
                ],
                [
                    85.8544006,
                    55.4531297
                ],
                [
                    85.8546652,
                    55.4523041
                ],
                [
                    85.8521837,
                    55.4511688
                ],
                [
                    85.8521671,
                    55.4504182
                ],
                [
                    85.8513896,
                    55.4502587
                ],
                [
                    85.851009,
                    55.4499773
                ],
                [
                    85.8484281,
                    55.4501743
                ],
                [
                    85.8485108,
                    55.4510375
                ],
                [
                    85.8473197,
                    55.4508123
                ],
                [
                    85.8458638,
                    55.4508874
                ],
                [
                    85.8435807,
                    55.4495926
                ],
                [
                    85.8433158,
                    55.4491516
                ],
                [
                    85.8406523,
                    55.4488795
                ],
                [
                    85.8403711,
                    55.4491328
                ],
                [
                    85.8333728,
                    55.4480162
                ],
                [
                    85.8333067,
                    55.4494612
                ],
                [
                    85.8285088,
                    55.4532235
                ],
                [
                    85.8281614,
                    55.4539553
                ],
                [
                    85.8235124,
                    55.4535707
                ]
            ],
            "longitude": 85.846062,
            "latitude": 55.456921
        },
        "1093": {
            "name": "Черемичкино",
            "population": 747,
            "type": "village",
            "poly": [
                [
                    85.8464663,
                    55.1536741
                ],
                [
                    85.8469123,
                    55.1548991
                ],
                [
                    85.8493984,
                    55.1574918
                ],
                [
                    85.8606786,
                    55.1618999
                ],
                [
                    85.8624666,
                    55.1599771
                ],
                [
                    85.8614578,
                    55.158645
                ],
                [
                    85.86689,
                    55.1572015
                ],
                [
                    85.8549709,
                    55.1539511
                ],
                [
                    85.8480493,
                    55.1496615
                ],
                [
                    85.8465776,
                    55.1508329
                ],
                [
                    85.8464663,
                    55.1536741
                ]
            ],
            "longitude": 85.8591103,
            "latitude": 55.1575307
        },
        "1094": {
            "name": "Возвышенка",
            "population": 324,
            "type": "village",
            "poly": null,
            "longitude": 85.859764,
            "latitude": 54.569763
        },
        "1095": {
            "name": "Камышная",
            "population": 417,
            "type": "village",
            "poly": [
                [
                    85.843711,
                    55.3298329
                ],
                [
                    85.8477081,
                    55.333997
                ],
                [
                    85.8516615,
                    55.3385498
                ],
                [
                    85.8543932,
                    55.3390739
                ],
                [
                    85.8614173,
                    55.3397693
                ],
                [
                    85.8641768,
                    55.3402957
                ],
                [
                    85.8691924,
                    55.3357142
                ],
                [
                    85.8788329,
                    55.3388506
                ],
                [
                    85.8793498,
                    55.3379362
                ],
                [
                    85.8807567,
                    55.3374898
                ],
                [
                    85.8781354,
                    55.3343616
                ],
                [
                    85.8771323,
                    55.3336261
                ],
                [
                    85.8702409,
                    55.3283908
                ],
                [
                    85.8597559,
                    55.3280999
                ],
                [
                    85.8601304,
                    55.3300855
                ],
                [
                    85.8599491,
                    55.3323857
                ],
                [
                    85.8577275,
                    55.3318802
                ],
                [
                    85.8534966,
                    55.3288692
                ],
                [
                    85.8520477,
                    55.3288801
                ],
                [
                    85.8511785,
                    55.329023
                ],
                [
                    85.8507342,
                    55.3293967
                ],
                [
                    85.8494592,
                    55.3293417
                ],
                [
                    85.8464648,
                    55.3263634
                ],
                [
                    85.8451543,
                    55.3266974
                ],
                [
                    85.8446102,
                    55.3280559
                ],
                [
                    85.8448614,
                    55.3290889
                ],
                [
                    85.845325,
                    55.3297373
                ],
                [
                    85.843711,
                    55.3298329
                ]
            ],
            "longitude": 85.863792,
            "latitude": 55.334999
        },
        "1096": {
            "name": "Байрак",
            "population": 360,
            "type": "village",
            "poly": null,
            "longitude": 85.869025,
            "latitude": 54.8680575
        },
        "1097": {
            "name": "Новопокасьма",
            "population": 304,
            "type": "village",
            "poly": null,
            "longitude": 85.8868809,
            "latitude": 54.7061004
        },
        "1098": {
            "name": "Ясногорский",
            "population": 3175,
            "type": "village",
            "poly": [
                [
                    85.875007,
                    55.3498028
                ],
                [
                    85.8757409,
                    55.3501373
                ],
                [
                    85.8765139,
                    55.351839
                ],
                [
                    85.8805743,
                    55.3553591
                ],
                [
                    85.8856985,
                    55.3542033
                ],
                [
                    85.8928775,
                    55.3514443
                ],
                [
                    85.893502,
                    55.3517483
                ],
                [
                    85.9009387,
                    55.3483323
                ],
                [
                    85.9033142,
                    55.3487408
                ],
                [
                    85.9040267,
                    55.3484879
                ],
                [
                    85.9017527,
                    55.3457502
                ],
                [
                    85.8991593,
                    55.3441793
                ],
                [
                    85.8986659,
                    55.342985
                ],
                [
                    85.8990379,
                    55.3423612
                ],
                [
                    85.8977529,
                    55.342432
                ],
                [
                    85.8975886,
                    55.3423631
                ],
                [
                    85.897694,
                    55.3421834
                ],
                [
                    85.8989478,
                    55.3418869
                ],
                [
                    85.8986905,
                    55.3413699
                ],
                [
                    85.8938126,
                    55.3428332
                ],
                [
                    85.8916087,
                    55.3395987
                ],
                [
                    85.891248,
                    55.3397061
                ],
                [
                    85.8911984,
                    55.3396595
                ],
                [
                    85.8885251,
                    55.3371512
                ],
                [
                    85.8895649,
                    55.3364075
                ],
                [
                    85.8908591,
                    55.3359485
                ],
                [
                    85.8901399,
                    55.3347882
                ],
                [
                    85.8831649,
                    55.3365321
                ],
                [
                    85.8808043,
                    55.3375122
                ],
                [
                    85.8793865,
                    55.3379523
                ],
                [
                    85.8788733,
                    55.3388644
                ],
                [
                    85.8838553,
                    55.3405338
                ],
                [
                    85.8842028,
                    55.3403306
                ],
                [
                    85.884306,
                    55.3395873
                ],
                [
                    85.8850737,
                    55.3393056
                ],
                [
                    85.8854659,
                    55.33851
                ],
                [
                    85.8875708,
                    55.3376475
                ],
                [
                    85.8906381,
                    55.3416873
                ],
                [
                    85.8917532,
                    55.3433458
                ],
                [
                    85.8916198,
                    55.3438532
                ],
                [
                    85.8912074,
                    55.3442274
                ],
                [
                    85.8894816,
                    55.3446586
                ],
                [
                    85.8879335,
                    55.3447849
                ],
                [
                    85.8794207,
                    55.3441697
                ],
                [
                    85.8785126,
                    55.3445991
                ],
                [
                    85.877519,
                    55.3447701
                ],
                [
                    85.876643,
                    55.345231
                ],
                [
                    85.8758194,
                    55.3453648
                ],
                [
                    85.8753487,
                    55.3460042
                ],
                [
                    85.875218,
                    55.3472605
                ],
                [
                    85.8759501,
                    55.3472531
                ],
                [
                    85.876813,
                    55.3479965
                ],
                [
                    85.8765907,
                    55.3486729
                ],
                [
                    85.8758063,
                    55.3488142
                ],
                [
                    85.8757671,
                    55.3494809
                ],
                [
                    85.8750611,
                    55.3492379
                ],
                [
                    85.875007,
                    55.3498028
                ]
            ],
            "longitude": 85.891579,
            "latitude": 55.345409
        },
        "1099": {
            "name": "Мазурово",
            "population": 1108,
            "type": "village",
            "poly": [
                [
                    85.8773024,
                    55.3336064
                ],
                [
                    85.8784267,
                    55.3345137
                ],
                [
                    85.8807887,
                    55.3374873
                ],
                [
                    85.8831532,
                    55.3364756
                ],
                [
                    85.8901615,
                    55.3347578
                ],
                [
                    85.890897,
                    55.3359692
                ],
                [
                    85.8895918,
                    55.3364127
                ],
                [
                    85.8885941,
                    55.337158
                ],
                [
                    85.8912711,
                    55.3396641
                ],
                [
                    85.8916357,
                    55.3395627
                ],
                [
                    85.893735,
                    55.3425962
                ],
                [
                    85.9025401,
                    55.3399309
                ],
                [
                    85.8999301,
                    55.3363919
                ],
                [
                    85.8981211,
                    55.3339881
                ],
                [
                    85.8968966,
                    55.3322823
                ],
                [
                    85.8934802,
                    55.3312852
                ],
                [
                    85.8944843,
                    55.3295932
                ],
                [
                    85.9033484,
                    55.3261868
                ],
                [
                    85.9027793,
                    55.3239419
                ],
                [
                    85.897968,
                    55.3206987
                ],
                [
                    85.890176,
                    55.3173808
                ],
                [
                    85.8879534,
                    55.317366
                ],
                [
                    85.8812073,
                    55.3240609
                ],
                [
                    85.8844327,
                    55.3276063
                ],
                [
                    85.8834157,
                    55.3276799
                ],
                [
                    85.8816499,
                    55.3285056
                ],
                [
                    85.8816408,
                    55.3292576
                ],
                [
                    85.8838224,
                    55.3306775
                ],
                [
                    85.8841461,
                    55.3313454
                ],
                [
                    85.8848024,
                    55.3316346
                ],
                [
                    85.8853108,
                    55.3324759
                ],
                [
                    85.8829688,
                    55.3329854
                ],
                [
                    85.8797079,
                    55.3331751
                ],
                [
                    85.8780868,
                    55.3328479
                ],
                [
                    85.8773024,
                    55.3336064
                ]
            ],
            "longitude": 85.892815,
            "latitude": 55.332935
        },
        "1100": {
            "name": "Соревнование",
            "population": 357,
            "type": "village",
            "poly": null,
            "longitude": 85.8968368,
            "latitude": 55.0542176
        },
        "1101": {
            "name": "Черёмушки",
            "population": 286,
            "type": "village",
            "poly": null,
            "longitude": 85.915787,
            "latitude": 55.611546
        },
        "1102": {
            "name": "Труд",
            "population": 394,
            "type": "village",
            "poly": null,
            "longitude": 85.9204845,
            "latitude": 54.8619133
        },
        "1103": {
            "name": "Мозжуха",
            "population": 1913,
            "type": "village",
            "poly": [
                [
                    85.9053256,
                    55.4247213
                ],
                [
                    85.9060991,
                    55.4256724
                ],
                [
                    85.9079184,
                    55.4244693
                ],
                [
                    85.9089444,
                    55.4248191
                ],
                [
                    85.9107272,
                    55.432682
                ],
                [
                    85.911335,
                    55.4333717
                ],
                [
                    85.9128746,
                    55.4311417
                ],
                [
                    85.9157514,
                    55.4290726
                ],
                [
                    85.9207351,
                    55.4262906
                ],
                [
                    85.9309456,
                    55.4219448
                ],
                [
                    85.9371448,
                    55.4184807
                ],
                [
                    85.939353,
                    55.4160084
                ],
                [
                    85.9301774,
                    55.4125339
                ],
                [
                    85.9208184,
                    55.4077832
                ],
                [
                    85.9184633,
                    55.4102438
                ],
                [
                    85.9172478,
                    55.4101748
                ],
                [
                    85.915465,
                    55.4095998
                ],
                [
                    85.9131149,
                    55.4094158
                ],
                [
                    85.9119399,
                    55.4107959
                ],
                [
                    85.9136822,
                    55.4132109
                ],
                [
                    85.91664,
                    55.4148209
                ],
                [
                    85.9140063,
                    55.4187306
                ],
                [
                    85.908739,
                    55.4200874
                ],
                [
                    85.9083482,
                    55.421819
                ],
                [
                    85.9053256,
                    55.4247213
                ]
            ],
            "longitude": 85.924171,
            "latitude": 55.420567
        },
        "1104": {
            "name": "Мирный",
            "population": 785,
            "type": "village",
            "poly": null,
            "longitude": 85.924988,
            "latitude": 54.612045
        },
        "1105": {
            "name": "Щегловский",
            "population": 1070,
            "type": "village",
            "poly": null,
            "longitude": 85.92514,
            "latitude": 55.564667
        },
        "1106": {
            "name": "Плотниково",
            "population": 5190,
            "type": "village",
            "poly": null,
            "longitude": 85.939255,
            "latitude": 55.022854
        },
        "1107": {
            "name": "Ур-Бедари",
            "population": 443,
            "type": "village",
            "poly": null,
            "longitude": 85.94165,
            "latitude": 54.44289
        },
        "1108": {
            "name": "Пригородный",
            "population": 2387,
            "type": "village",
            "poly": [
                [
                    85.9283796,
                    55.3408881
                ],
                [
                    85.9341802,
                    55.3501296
                ],
                [
                    85.935986,
                    55.3539252
                ],
                [
                    85.9374088,
                    55.3624794
                ],
                [
                    85.9556311,
                    55.3630704
                ],
                [
                    85.9585315,
                    55.3601726
                ],
                [
                    85.9644413,
                    55.3542674
                ],
                [
                    85.9623526,
                    55.3486251
                ],
                [
                    85.9576446,
                    55.3434931
                ],
                [
                    85.9531561,
                    55.3437462
                ],
                [
                    85.9522275,
                    55.3430311
                ],
                [
                    85.954433,
                    55.3417768
                ],
                [
                    85.9481669,
                    55.3383923
                ],
                [
                    85.9288174,
                    55.3400479
                ],
                [
                    85.9283796,
                    55.3408881
                ]
            ],
            "longitude": 85.94915,
            "latitude": 55.34964
        },
        "1109": {
            "name": "Барановка",
            "population": 1152,
            "type": "village",
            "poly": [
                [
                    85.9319749,
                    55.6395059
                ],
                [
                    85.9352457,
                    55.6423671
                ],
                [
                    85.9444039,
                    55.645505
                ],
                [
                    85.9533986,
                    55.6427363
                ],
                [
                    85.9537257,
                    55.6378444
                ],
                [
                    85.9609215,
                    55.6409827
                ],
                [
                    85.9676266,
                    55.6386751
                ],
                [
                    85.9749858,
                    55.6358136
                ],
                [
                    85.969589,
                    55.6305516
                ],
                [
                    85.9622298,
                    55.6322134
                ],
                [
                    85.9617392,
                    55.6345213
                ],
                [
                    85.9581413,
                    55.6354444
                ],
                [
                    85.9527445,
                    55.6325826
                ],
                [
                    85.9515997,
                    55.6287974
                ],
                [
                    85.9406425,
                    55.6288897
                ],
                [
                    85.9321384,
                    55.6313825
                ],
                [
                    85.9370445,
                    55.6357213
                ],
                [
                    85.9319749,
                    55.6395059
                ]
            ],
            "longitude": 85.950188,
            "latitude": 55.638813
        },
        "1110": {
            "name": "Лебедянка",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 85.953499,
            "latitude": 56.136898
        },
        "1111": {
            "name": "Малая Салаирка",
            "population": 1242,
            "type": "village",
            "poly": null,
            "longitude": 85.954163,
            "latitude": 54.331799
        },
        "1112": {
            "name": "Верхотомское",
            "population": 1697,
            "type": "village",
            "poly": [
                [
                    85.9466185,
                    55.4686701
                ],
                [
                    85.9486867,
                    55.4723355
                ],
                [
                    85.9480968,
                    55.4738561
                ],
                [
                    85.94775,
                    55.47475
                ],
                [
                    85.9541682,
                    55.4767301
                ],
                [
                    85.9565934,
                    55.477678
                ],
                [
                    85.9663073,
                    55.4775179
                ],
                [
                    85.9693288,
                    55.4769578
                ],
                [
                    85.9735645,
                    55.4747493
                ],
                [
                    85.9755695,
                    55.4735009
                ],
                [
                    85.9734234,
                    55.4714682
                ],
                [
                    85.9744682,
                    55.4713881
                ],
                [
                    85.9785627,
                    55.4712921
                ],
                [
                    85.9790428,
                    55.4696915
                ],
                [
                    85.9752483,
                    55.4692343
                ],
                [
                    85.9747442,
                    55.4677367
                ],
                [
                    85.9746258,
                    55.4673848
                ],
                [
                    85.9719944,
                    55.4672373
                ],
                [
                    85.9717053,
                    55.4652538
                ],
                [
                    85.9735716,
                    55.464432
                ],
                [
                    85.9705713,
                    55.4619805
                ],
                [
                    85.9707919,
                    55.4590787
                ],
                [
                    85.9644383,
                    55.4597291
                ],
                [
                    85.9617027,
                    55.4614552
                ],
                [
                    85.9530989,
                    55.4636315
                ],
                [
                    85.9519076,
                    55.4642569
                ],
                [
                    85.9502308,
                    55.4615053
                ],
                [
                    85.9466185,
                    55.4686701
                ]
            ],
            "longitude": 85.954659,
            "latitude": 55.469341
        },
        "1113": {
            "name": "Чкаловский",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 85.956734,
            "latitude": 54.690117
        },
        "1114": {
            "name": "Вознесенка",
            "population": 391,
            "type": "village",
            "poly": [
                [
                    85.9317707,
                    56.3217255
                ],
                [
                    85.9321323,
                    56.3219833
                ],
                [
                    85.9323519,
                    56.3218974
                ],
                [
                    85.9330236,
                    56.3222197
                ],
                [
                    85.9342765,
                    56.3217541
                ],
                [
                    85.9353873,
                    56.3221911
                ],
                [
                    85.936821,
                    56.3232153
                ],
                [
                    85.9371956,
                    56.3231293
                ],
                [
                    85.9373118,
                    56.3224847
                ],
                [
                    85.9374927,
                    56.3220621
                ],
                [
                    85.9402029,
                    56.3220149
                ],
                [
                    85.9403881,
                    56.3217802
                ],
                [
                    85.9432394,
                    56.3222917
                ],
                [
                    85.9436178,
                    56.3225854
                ],
                [
                    85.9452072,
                    56.3228652
                ],
                [
                    85.9465947,
                    56.3225575
                ],
                [
                    85.9484685,
                    56.3213905
                ],
                [
                    85.9492277,
                    56.321512
                ],
                [
                    85.9510487,
                    56.320111
                ],
                [
                    85.9519374,
                    56.3204452
                ],
                [
                    85.9514131,
                    56.3209347
                ],
                [
                    85.9512272,
                    56.3212926
                ],
                [
                    85.9514475,
                    56.3216242
                ],
                [
                    85.9502526,
                    56.3221518
                ],
                [
                    85.9516654,
                    56.3227673
                ],
                [
                    85.9530085,
                    56.3221695
                ],
                [
                    85.9534453,
                    56.3224221
                ],
                [
                    85.9543431,
                    56.3222357
                ],
                [
                    85.9546991,
                    56.321986
                ],
                [
                    85.954945,
                    56.3215502
                ],
                [
                    85.9598391,
                    56.3233408
                ],
                [
                    85.9610248,
                    56.3235227
                ],
                [
                    85.9656204,
                    56.3255158
                ],
                [
                    85.9668633,
                    56.3263884
                ],
                [
                    85.9659821,
                    56.3271774
                ],
                [
                    85.9654245,
                    56.3280029
                ],
                [
                    85.9655589,
                    56.3285268
                ],
                [
                    85.9659828,
                    56.3287943
                ],
                [
                    85.9667598,
                    56.3288377
                ],
                [
                    85.9675211,
                    56.3287078
                ],
                [
                    85.9692115,
                    56.3291753
                ],
                [
                    85.9700663,
                    56.3292073
                ],
                [
                    85.9717488,
                    56.3289931
                ],
                [
                    85.9723361,
                    56.32903
                ],
                [
                    85.9757689,
                    56.3308892
                ],
                [
                    85.9791137,
                    56.3308847
                ],
                [
                    85.9794578,
                    56.3306101
                ],
                [
                    85.9775321,
                    56.3277932
                ],
                [
                    85.9772961,
                    56.3266828
                ],
                [
                    85.9770233,
                    56.3264353
                ],
                [
                    85.9771886,
                    56.3261557
                ],
                [
                    85.9760313,
                    56.3248036
                ],
                [
                    85.9754692,
                    56.3249777
                ],
                [
                    85.9743945,
                    56.3243131
                ],
                [
                    85.9744111,
                    56.3240702
                ],
                [
                    85.9721874,
                    56.3225162
                ],
                [
                    85.9697736,
                    56.3212969
                ],
                [
                    85.9694512,
                    56.321164
                ],
                [
                    85.9683186,
                    56.3203021
                ],
                [
                    85.9672109,
                    56.3200592
                ],
                [
                    85.965798,
                    56.3195172
                ],
                [
                    85.9640862,
                    56.3186105
                ],
                [
                    85.9634413,
                    56.3183538
                ],
                [
                    85.9625121,
                    56.3180559
                ],
                [
                    85.960358,
                    56.3168913
                ],
                [
                    85.9599364,
                    56.316285
                ],
                [
                    85.9580351,
                    56.3158277
                ],
                [
                    85.9566567,
                    56.3151583
                ],
                [
                    85.9558197,
                    56.315383
                ],
                [
                    85.9551135,
                    56.3151447
                ],
                [
                    85.9547678,
                    56.3147079
                ],
                [
                    85.9557184,
                    56.3141141
                ],
                [
                    85.9545466,
                    56.3134711
                ],
                [
                    85.9533066,
                    56.3134527
                ],
                [
                    85.9523394,
                    56.3130538
                ],
                [
                    85.9517773,
                    56.3120864
                ],
                [
                    85.9503059,
                    56.311449
                ],
                [
                    85.9501037,
                    56.3107291
                ],
                [
                    85.9486107,
                    56.3116576
                ],
                [
                    85.9460609,
                    56.3107004
                ],
                [
                    85.9462418,
                    56.3104712
                ],
                [
                    85.9459318,
                    56.3101631
                ],
                [
                    85.9448856,
                    56.3110228
                ],
                [
                    85.9449372,
                    56.3116175
                ],
                [
                    85.9474301,
                    56.3128713
                ],
                [
                    85.9472105,
                    56.3129142
                ],
                [
                    85.9457639,
                    56.3129644
                ],
                [
                    85.9444206,
                    56.3130933
                ],
                [
                    85.9438909,
                    56.3133154
                ],
                [
                    85.9425735,
                    56.3135375
                ],
                [
                    85.9411475,
                    56.313645
                ],
                [
                    85.9402408,
                    56.313185
                ],
                [
                    85.938789,
                    56.3134229
                ],
                [
                    85.9368386,
                    56.3153786
                ],
                [
                    85.9363865,
                    56.3166753
                ],
                [
                    85.9365674,
                    56.3169618
                ],
                [
                    85.9383498,
                    56.3155864
                ],
                [
                    85.9389182,
                    56.3155291
                ],
                [
                    85.9393185,
                    56.3157368
                ],
                [
                    85.9381948,
                    56.3171624
                ],
                [
                    85.937549,
                    56.3172913
                ],
                [
                    85.9372778,
                    56.3175062
                ],
                [
                    85.9381303,
                    56.3178071
                ],
                [
                    85.937704,
                    56.3188529
                ],
                [
                    85.937239,
                    56.3184804
                ],
                [
                    85.9368128,
                    56.3184661
                ],
                [
                    85.9369807,
                    56.3188386
                ],
                [
                    85.9367869,
                    56.3189675
                ],
                [
                    85.935986,
                    56.3186595
                ],
                [
                    85.9357407,
                    56.3174704
                ],
                [
                    85.9345911,
                    56.3179145
                ],
                [
                    85.9348753,
                    56.3184947
                ],
                [
                    85.9330623,
                    56.3208803
                ],
                [
                    85.9317707,
                    56.3217255
                ]
            ],
            "longitude": 85.9589362,
            "latitude": 56.3188296
        },
        "1115": {
            "name": "Щербиновка",
            "population": 294,
            "type": "village",
            "poly": [
                [
                    85.9634013,
                    56.1759432
                ],
                [
                    85.9638146,
                    56.1763804
                ],
                [
                    85.964321,
                    56.1765644
                ],
                [
                    85.9644243,
                    56.176829
                ],
                [
                    85.9646103,
                    56.1773007
                ],
                [
                    85.9670489,
                    56.178474
                ],
                [
                    85.9707482,
                    56.179469
                ],
                [
                    85.9706035,
                    56.1799923
                ],
                [
                    85.9717505,
                    56.181827
                ],
                [
                    85.9728665,
                    56.1822353
                ],
                [
                    85.9734348,
                    56.1823158
                ],
                [
                    85.9752844,
                    56.1814589
                ],
                [
                    85.9759974,
                    56.1813611
                ],
                [
                    85.9771133,
                    56.1815682
                ],
                [
                    85.9774027,
                    56.1820398
                ],
                [
                    85.9752224,
                    56.1841331
                ],
                [
                    85.9753051,
                    56.1848864
                ],
                [
                    85.9759664,
                    56.1850991
                ],
                [
                    85.9768756,
                    56.1851394
                ],
                [
                    85.9772477,
                    56.1847829
                ],
                [
                    85.9779194,
                    56.1847254
                ],
                [
                    85.9785291,
                    56.1850819
                ],
                [
                    85.9789423,
                    56.1855707
                ],
                [
                    85.979893,
                    56.185772
                ],
                [
                    85.9800894,
                    56.1861112
                ],
                [
                    85.9798827,
                    56.1864045
                ],
                [
                    85.9793247,
                    56.1865943
                ],
                [
                    85.9785394,
                    56.1862837
                ],
                [
                    85.9779297,
                    56.1862147
                ],
                [
                    85.9778057,
                    56.186439
                ],
                [
                    85.9784774,
                    56.1868645
                ],
                [
                    85.9796554,
                    56.1871808
                ],
                [
                    85.979645,
                    56.1875085
                ],
                [
                    85.979304,
                    56.1880433
                ],
                [
                    85.9809573,
                    56.1887391
                ],
                [
                    85.9831066,
                    56.1882446
                ],
                [
                    85.9834993,
                    56.1882388
                ],
                [
                    85.983706,
                    56.1881008
                ],
                [
                    85.984109,
                    56.1881008
                ],
                [
                    85.9853386,
                    56.1877615
                ],
                [
                    85.9874259,
                    56.1877098
                ],
                [
                    85.9878392,
                    56.1871578
                ],
                [
                    85.9881802,
                    56.1870428
                ],
                [
                    85.9881389,
                    56.1868875
                ],
                [
                    85.9883559,
                    56.1866518
                ],
                [
                    85.9884592,
                    56.1860997
                ],
                [
                    85.9888828,
                    56.185772
                ],
                [
                    85.9889552,
                    56.1854442
                ],
                [
                    85.9899988,
                    56.1848231
                ],
                [
                    85.9899265,
                    56.1845298
                ],
                [
                    85.9900298,
                    56.1841215
                ],
                [
                    85.9895649,
                    56.1829656
                ],
                [
                    85.9890069,
                    56.180648
                ],
                [
                    85.9891619,
                    56.179607
                ],
                [
                    85.9892239,
                    56.1790491
                ],
                [
                    85.9882112,
                    56.1785487
                ],
                [
                    85.9874466,
                    56.1774847
                ],
                [
                    85.9859165,
                    56.1771402
                ],
                [
                    85.9839857,
                    56.1767785
                ],
                [
                    85.983613,
                    56.1771281
                ],
                [
                    85.9833044,
                    56.1772484
                ],
                [
                    85.9829699,
                    56.1769244
                ],
                [
                    85.9818643,
                    56.1762629
                ],
                [
                    85.9795806,
                    56.1752046
                ],
                [
                    85.9788765,
                    56.1747979
                ],
                [
                    85.9781674,
                    56.1748273
                ],
                [
                    85.9770721,
                    56.1742349
                ],
                [
                    85.9747988,
                    56.172584
                ],
                [
                    85.9740445,
                    56.1716061
                ],
                [
                    85.9724222,
                    56.172515
                ],
                [
                    85.9718022,
                    56.1725322
                ],
                [
                    85.9708102,
                    56.1731477
                ],
                [
                    85.9704175,
                    56.1736712
                ],
                [
                    85.9698699,
                    56.1738898
                ],
                [
                    85.9696322,
                    56.1740796
                ],
                [
                    85.9693532,
                    56.1740796
                ],
                [
                    85.9688676,
                    56.1741774
                ],
                [
                    85.9679996,
                    56.1744765
                ],
                [
                    85.9679066,
                    56.1747008
                ],
                [
                    85.9674725,
                    56.1749654
                ],
                [
                    85.9671729,
                    56.1749827
                ],
                [
                    85.9650236,
                    56.1756671
                ],
                [
                    85.9643313,
                    56.1756211
                ],
                [
                    85.9636182,
                    56.1756959
                ],
                [
                    85.9634013,
                    56.1759432
                ]
            ],
            "longitude": 85.9790358,
            "latitude": 56.1797225
        },
        "1116": {
            "name": "Ново-Урский",
            "population": 277,
            "type": "village",
            "poly": null,
            "longitude": 85.98069,
            "latitude": 54.487534
        },
        "1117": {
            "name": "Подгорное",
            "population": 801,
            "type": "village",
            "poly": null,
            "longitude": 85.999931,
            "latitude": 54.489502
        },
        "1118": {
            "name": "Раздольный",
            "population": 1193,
            "type": "village",
            "poly": null,
            "longitude": 86.001625,
            "latitude": 54.291389
        },
        "1119": {
            "name": "Никитинский",
            "population": 2257,
            "type": "village",
            "poly": [
                [
                    85.9808743,
                    54.5870764
                ],
                [
                    86.0028258,
                    54.5946057
                ],
                [
                    86.0027524,
                    54.5938826
                ],
                [
                    86.0050283,
                    54.5926065
                ],
                [
                    86.0076713,
                    54.5926065
                ],
                [
                    86.0122965,
                    54.595584
                ],
                [
                    86.0167749,
                    54.591373
                ],
                [
                    86.0137649,
                    54.5883952
                ],
                [
                    86.0158939,
                    54.5867786
                ],
                [
                    86.0211568,
                    54.5893798
                ],
                [
                    86.0218185,
                    54.5890661
                ],
                [
                    86.022137,
                    54.5875598
                ],
                [
                    86.0184614,
                    54.5859158
                ],
                [
                    86.0185601,
                    54.5857728
                ],
                [
                    86.0264071,
                    54.5812003
                ],
                [
                    86.0134286,
                    54.5809107
                ],
                [
                    86.0118348,
                    54.579133
                ],
                [
                    86.0065723,
                    54.579011
                ],
                [
                    86.0059408,
                    54.5783487
                ],
                [
                    85.9983628,
                    54.5782964
                ],
                [
                    85.9951151,
                    54.5821655
                ],
                [
                    85.9952955,
                    54.5838907
                ],
                [
                    86.0006182,
                    54.5859122
                ],
                [
                    85.996318,
                    54.5896063
                ],
                [
                    85.9950249,
                    54.5895714
                ],
                [
                    85.9929199,
                    54.5882646
                ],
                [
                    85.9887099,
                    54.5883343
                ],
                [
                    85.9886197,
                    54.5870797
                ],
                [
                    85.9865147,
                    54.5870797
                ],
                [
                    85.9832369,
                    54.5857728
                ],
                [
                    85.9808743,
                    54.5870764
                ]
            ],
            "longitude": 86.006111,
            "latitude": 54.585873
        },
        "1120": {
            "name": "Ягуново",
            "population": 2471,
            "type": "village",
            "poly": [
                [
                    85.9756583,
                    55.2441154
                ],
                [
                    85.9824285,
                    55.2464513
                ],
                [
                    85.9829684,
                    55.2484836
                ],
                [
                    85.9860233,
                    55.2485554
                ],
                [
                    85.9872517,
                    55.2496146
                ],
                [
                    85.9859289,
                    55.2506737
                ],
                [
                    85.9878501,
                    55.2518585
                ],
                [
                    85.9905901,
                    55.250943
                ],
                [
                    85.9936252,
                    55.2519211
                ],
                [
                    85.9954068,
                    55.254155
                ],
                [
                    86.0030678,
                    55.2593841
                ],
                [
                    86.0050276,
                    55.2589779
                ],
                [
                    86.0063511,
                    55.2572662
                ],
                [
                    86.0091252,
                    55.2558812
                ],
                [
                    86.0137671,
                    55.2569996
                ],
                [
                    86.0178648,
                    55.2566696
                ],
                [
                    86.0169072,
                    55.2581419
                ],
                [
                    86.0188224,
                    55.2581546
                ],
                [
                    86.0216285,
                    55.2544612
                ],
                [
                    86.0211608,
                    55.2543724
                ],
                [
                    86.0221346,
                    55.2527056
                ],
                [
                    86.019722,
                    55.249797
                ],
                [
                    86.0190134,
                    55.2498778
                ],
                [
                    86.0173442,
                    55.2476697
                ],
                [
                    86.0265456,
                    55.2452157
                ],
                [
                    86.0293079,
                    55.2395998
                ],
                [
                    86.0298118,
                    55.2360083
                ],
                [
                    86.0192926,
                    55.2344998
                ],
                [
                    86.0150408,
                    55.2357928
                ],
                [
                    86.0130566,
                    55.2349667
                ],
                [
                    86.0139384,
                    55.2329732
                ],
                [
                    86.0111039,
                    55.2304768
                ],
                [
                    86.0064112,
                    55.2307821
                ],
                [
                    85.9970257,
                    55.2310156
                ],
                [
                    85.9927619,
                    55.2320779
                ],
                [
                    85.9890205,
                    55.2348717
                ],
                [
                    85.9897331,
                    55.2379193
                ],
                [
                    85.9960579,
                    55.2442677
                ],
                [
                    85.9926727,
                    55.2451818
                ],
                [
                    85.9811813,
                    55.2382749
                ],
                [
                    85.9756583,
                    55.2441154
                ]
            ],
            "longitude": 86.010689,
            "latitude": 55.248917
        },
        "1121": {
            "name": "Протопопово",
            "population": 494,
            "type": "village",
            "poly": [
                [
                    85.9983085,
                    54.8755492
                ],
                [
                    85.9997615,
                    54.8758543
                ],
                [
                    86.0001074,
                    54.876279
                ],
                [
                    86.001399,
                    54.8761993
                ],
                [
                    86.0022984,
                    54.8764913
                ],
                [
                    86.0033824,
                    54.8761463
                ],
                [
                    86.0043048,
                    54.8763851
                ],
                [
                    86.0063345,
                    54.8761861
                ],
                [
                    86.008364,
                    54.8773538
                ],
                [
                    86.0172663,
                    54.8802064
                ],
                [
                    86.0183734,
                    54.8795563
                ],
                [
                    86.0184656,
                    54.8784949
                ],
                [
                    86.0197802,
                    54.8773007
                ],
                [
                    86.0235856,
                    54.8751776
                ],
                [
                    86.0245773,
                    54.8742753
                ],
                [
                    86.0245773,
                    54.8738374
                ],
                [
                    86.0213716,
                    54.8727359
                ],
                [
                    86.0210717,
                    54.8729085
                ],
                [
                    86.0203798,
                    54.872643
                ],
                [
                    86.0195726,
                    54.8728686
                ],
                [
                    86.0188116,
                    54.8726165
                ],
                [
                    86.0166898,
                    54.8722317
                ],
                [
                    86.0144757,
                    54.8712231
                ],
                [
                    86.0132072,
                    54.8694448
                ],
                [
                    86.0128844,
                    54.8683698
                ],
                [
                    86.0112008,
                    54.8671089
                ],
                [
                    86.0109471,
                    54.8673345
                ],
                [
                    86.0101629,
                    54.8667638
                ],
                [
                    86.00871,
                    54.8670824
                ],
                [
                    86.006173,
                    54.8683432
                ],
                [
                    86.006888,
                    54.8689537
                ],
                [
                    86.0054811,
                    54.8700287
                ],
                [
                    86.0060577,
                    54.8704932
                ],
                [
                    86.005066,
                    54.871807
                ],
                [
                    86.0049507,
                    54.8722715
                ],
                [
                    86.0055503,
                    54.8724971
                ],
                [
                    86.0045125,
                    54.8736649
                ],
                [
                    86.0038667,
                    54.8733596
                ],
                [
                    86.0035438,
                    54.8735321
                ],
                [
                    86.0028058,
                    54.8734393
                ],
                [
                    86.0024368,
                    54.8736781
                ],
                [
                    86.0012837,
                    54.8733331
                ],
                [
                    86.0008224,
                    54.873572
                ],
                [
                    86.0012606,
                    54.873771
                ],
                [
                    86.0010991,
                    54.8740364
                ],
                [
                    86.0004303,
                    54.8739701
                ],
                [
                    86.0001536,
                    54.8742089
                ],
                [
                    86.0006379,
                    54.8743682
                ],
                [
                    85.9995539,
                    54.8748193
                ],
                [
                    85.9993694,
                    54.8752572
                ],
                [
                    85.9983777,
                    54.8750582
                ],
                [
                    85.9983085,
                    54.8755492
                ]
            ],
            "longitude": 86.0154088,
            "latitude": 54.8731843
        },
        "1122": {
            "name": "Лесной",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 86.032967,
            "latitude": 54.235229
        },
        "1123": {
            "name": "Драченино",
            "population": 1077,
            "type": "village",
            "poly": [
                [
                    86.0256481,
                    54.7581166
                ],
                [
                    86.0270424,
                    54.761416
                ],
                [
                    86.0270283,
                    54.763675
                ],
                [
                    86.0273804,
                    54.7647963
                ],
                [
                    86.0282677,
                    54.7656738
                ],
                [
                    86.0287747,
                    54.765747
                ],
                [
                    86.0299718,
                    54.7662589
                ],
                [
                    86.030845,
                    54.7672907
                ],
                [
                    86.0345068,
                    54.7671201
                ],
                [
                    86.0365349,
                    54.7668439
                ],
                [
                    86.0382532,
                    54.766267
                ],
                [
                    86.0424079,
                    54.7646094
                ],
                [
                    86.0471964,
                    54.7631955
                ],
                [
                    86.0510977,
                    54.7619929
                ],
                [
                    86.0553934,
                    54.7609136
                ],
                [
                    86.0555925,
                    54.7603752
                ],
                [
                    86.0554594,
                    54.7595855
                ],
                [
                    86.0546231,
                    54.758719
                ],
                [
                    86.0549054,
                    54.7568904
                ],
                [
                    86.0530582,
                    54.7550203
                ],
                [
                    86.0461263,
                    54.7574807
                ],
                [
                    86.0404047,
                    54.75856
                ],
                [
                    86.0363336,
                    54.755179
                ],
                [
                    86.0344355,
                    54.7531471
                ],
                [
                    86.0335553,
                    54.7510834
                ],
                [
                    86.0336653,
                    54.749337
                ],
                [
                    86.0321799,
                    54.7490513
                ],
                [
                    86.0319013,
                    54.7491761
                ],
                [
                    86.0317886,
                    54.7521186
                ],
                [
                    86.0300012,
                    54.7521296
                ],
                [
                    86.0301972,
                    54.7561661
                ],
                [
                    86.0257185,
                    54.7563449
                ],
                [
                    86.0256481,
                    54.7581166
                ]
            ],
            "longitude": 86.037697,
            "latitude": 54.761208
        },
        "1124": {
            "name": "Худяшово",
            "population": 341,
            "type": "village",
            "poly": null,
            "longitude": 86.040161,
            "latitude": 54.816643
        },
        "1125": {
            "name": "Красная Горка",
            "population": 642,
            "type": "village",
            "poly": null,
            "longitude": 86.0440318,
            "latitude": 56.1083239
        },
        "1126": {
            "name": "Новогородец",
            "population": 436,
            "type": "village",
            "poly": null,
            "longitude": 86.044296,
            "latitude": 54.606956
        },
        "1127": {
            "name": "Новоискитимск",
            "population": 1168,
            "type": "village",
            "poly": null,
            "longitude": 86.054596,
            "latitude": 55.301994
        },
        "1128": {
            "name": "348-го Квартала",
            "population": 603,
            "type": "village",
            "poly": null,
            "longitude": 86.0703364,
            "latitude": 56.0148189
        },
        "1129": {
            "name": "Кайла",
            "population": 726,
            "type": "village",
            "poly": [
                [
                    86.0661244,
                    56.2227458
                ],
                [
                    86.0681136,
                    56.2231058
                ],
                [
                    86.0686681,
                    56.2233058
                ],
                [
                    86.0696754,
                    56.223447
                ],
                [
                    86.0711568,
                    56.2237623
                ],
                [
                    86.0720541,
                    56.2242117
                ],
                [
                    86.0727863,
                    56.2244941
                ],
                [
                    86.072799,
                    56.2246917
                ],
                [
                    86.0720752,
                    56.2251764
                ],
                [
                    86.0724519,
                    56.2255482
                ],
                [
                    86.0717366,
                    56.2273976
                ],
                [
                    86.0718848,
                    56.2277152
                ],
                [
                    86.0717492,
                    56.2278399
                ],
                [
                    86.0717747,
                    56.2279975
                ],
                [
                    86.0715504,
                    56.2281834
                ],
                [
                    86.0712499,
                    56.2285787
                ],
                [
                    86.0694003,
                    56.2293268
                ],
                [
                    86.0691252,
                    56.2299103
                ],
                [
                    86.0689347,
                    56.230449
                ],
                [
                    86.0683634,
                    56.2306137
                ],
                [
                    86.0676904,
                    56.2308161
                ],
                [
                    86.0675888,
                    56.2310043
                ],
                [
                    86.0694807,
                    56.2310984
                ],
                [
                    86.0744581,
                    56.2336626
                ],
                [
                    86.0767436,
                    56.2363161
                ],
                [
                    86.0789784,
                    56.2367795
                ],
                [
                    86.0813146,
                    56.2358809
                ],
                [
                    86.0817421,
                    56.2363161
                ],
                [
                    86.0822924,
                    56.236563
                ],
                [
                    86.0831345,
                    56.2365583
                ],
                [
                    86.0840235,
                    56.2364172
                ],
                [
                    86.0843113,
                    56.2365042
                ],
                [
                    86.0844044,
                    56.2368077
                ],
                [
                    86.084908,
                    56.2372593
                ],
                [
                    86.0853948,
                    56.237885
                ],
                [
                    86.0867238,
                    56.2381931
                ],
                [
                    86.0867661,
                    56.2383295
                ],
                [
                    86.0870708,
                    56.2386212
                ],
                [
                    86.090097,
                    56.237925
                ],
                [
                    86.090296,
                    56.2377415
                ],
                [
                    86.0889754,
                    56.2362855
                ],
                [
                    86.0887123,
                    56.2357294
                ],
                [
                    86.086893,
                    56.2336952
                ],
                [
                    86.0870378,
                    56.2330198
                ],
                [
                    86.0872957,
                    56.2327956
                ],
                [
                    86.0879438,
                    56.232711
                ],
                [
                    86.089855,
                    56.2332366
                ],
                [
                    86.0926723,
                    56.2332734
                ],
                [
                    86.0957672,
                    56.2333175
                ],
                [
                    86.0967725,
                    56.2334388
                ],
                [
                    86.0970238,
                    56.2316781
                ],
                [
                    86.0963294,
                    56.231362
                ],
                [
                    86.0960847,
                    56.2309246
                ],
                [
                    86.0957276,
                    56.2308841
                ],
                [
                    86.0952051,
                    56.2314318
                ],
                [
                    86.0950993,
                    56.2316781
                ],
                [
                    86.0944975,
                    56.2318068
                ],
                [
                    86.0934791,
                    56.2315789
                ],
                [
                    86.0927186,
                    56.2316009
                ],
                [
                    86.0920903,
                    56.2312554
                ],
                [
                    86.0920043,
                    56.2306856
                ],
                [
                    86.0915943,
                    56.2306378
                ],
                [
                    86.0910586,
                    56.2310826
                ],
                [
                    86.090847,
                    56.2311525
                ],
                [
                    86.0890945,
                    56.2309797
                ],
                [
                    86.0894516,
                    56.2301599
                ],
                [
                    86.0896434,
                    56.2298953
                ],
                [
                    86.0896367,
                    56.2296306
                ],
                [
                    86.0893061,
                    56.2294358
                ],
                [
                    86.0888894,
                    56.2294872
                ],
                [
                    86.0861582,
                    56.2291159
                ],
                [
                    86.0838568,
                    56.2290939
                ],
                [
                    86.083718,
                    56.228991
                ],
                [
                    86.0836981,
                    56.2288219
                ],
                [
                    86.0833079,
                    56.2282962
                ],
                [
                    86.082058,
                    56.227458
                ],
                [
                    86.0808875,
                    56.2273918
                ],
                [
                    86.0803122,
                    56.2272631
                ],
                [
                    86.0805238,
                    56.2266492
                ],
                [
                    86.0808412,
                    56.2262338
                ],
                [
                    86.0804114,
                    56.2256198
                ],
                [
                    86.0802262,
                    56.2252632
                ],
                [
                    86.0798492,
                    56.225072
                ],
                [
                    86.0796376,
                    56.2245757
                ],
                [
                    86.0789102,
                    56.2236712
                ],
                [
                    86.0783282,
                    56.2237154
                ],
                [
                    86.078143,
                    56.2234065
                ],
                [
                    86.0786588,
                    56.2233146
                ],
                [
                    86.0784538,
                    56.2231822
                ],
                [
                    86.0782554,
                    56.2227006
                ],
                [
                    86.0781959,
                    56.2213181
                ],
                [
                    86.0780901,
                    56.2212519
                ],
                [
                    86.0781959,
                    56.2193068
                ],
                [
                    86.0766749,
                    56.2171851
                ],
                [
                    86.0755439,
                    56.2164202
                ],
                [
                    86.0750745,
                    56.2163357
                ],
                [
                    86.0742149,
                    56.2163635
                ],
                [
                    86.0731991,
                    56.2162634
                ],
                [
                    86.071887,
                    56.2165576
                ],
                [
                    86.0717283,
                    56.21664
                ],
                [
                    86.0719134,
                    56.2167518
                ],
                [
                    86.0718976,
                    56.2169871
                ],
                [
                    86.0715908,
                    56.2171842
                ],
                [
                    86.0712733,
                    56.2170725
                ],
                [
                    86.0711252,
                    56.2172372
                ],
                [
                    86.0703369,
                    56.2174078
                ],
                [
                    86.0700883,
                    56.2175755
                ],
                [
                    86.0697179,
                    56.2177608
                ],
                [
                    86.069173,
                    56.217449
                ],
                [
                    86.0689614,
                    56.2174255
                ],
                [
                    86.0675382,
                    56.2178638
                ],
                [
                    86.0674434,
                    56.2191951
                ],
                [
                    86.0676296,
                    56.2196526
                ],
                [
                    86.0681883,
                    56.2199124
                ],
                [
                    86.0689332,
                    56.2198992
                ],
                [
                    86.069265,
                    56.2199764
                ],
                [
                    86.0693361,
                    56.2200875
                ],
                [
                    86.0696849,
                    56.2200988
                ],
                [
                    86.0698068,
                    56.2203943
                ],
                [
                    86.0696442,
                    56.2206974
                ],
                [
                    86.0662786,
                    56.2206127
                ],
                [
                    86.0661244,
                    56.2227458
                ]
            ],
            "longitude": 86.0753983,
            "latitude": 56.2214029
        },
        "1130": {
            "name": "Восходящий",
            "population": 950,
            "type": "village",
            "poly": null,
            "longitude": 86.076897,
            "latitude": 54.682083
        },
        "1131": {
            "name": "Егозово",
            "population": 815,
            "type": "village",
            "poly": null,
            "longitude": 86.080162,
            "latitude": 54.687725
        },
        "1132": {
            "name": "Клейзавода",
            "population": 329,
            "type": "village",
            "poly": null,
            "longitude": 86.0848176,
            "latitude": 54.6890203
        },
        "1133": {
            "name": "Колычево",
            "population": 919,
            "type": "village",
            "poly": null,
            "longitude": 86.0960801,
            "latitude": 55.0122109
        },
        "1134": {
            "name": "Улановка",
            "population": 755,
            "type": "village",
            "poly": [
                [
                    86.0890579,
                    56.4091829
                ],
                [
                    86.0893405,
                    56.4095848
                ],
                [
                    86.0899459,
                    56.409864
                ],
                [
                    86.0906119,
                    56.409864
                ],
                [
                    86.0918834,
                    56.4103776
                ],
                [
                    86.0924283,
                    56.409998
                ],
                [
                    86.0926705,
                    56.4104892
                ],
                [
                    86.0939016,
                    56.4106456
                ],
                [
                    86.0949901,
                    56.4112751
                ],
                [
                    86.09705,
                    56.411349
                ],
                [
                    86.0980591,
                    56.4116504
                ],
                [
                    86.0986242,
                    56.4123538
                ],
                [
                    86.0995727,
                    56.4126664
                ],
                [
                    86.0996131,
                    56.413113
                ],
                [
                    86.1017524,
                    56.4136936
                ],
                [
                    86.1042347,
                    56.413381
                ],
                [
                    86.105042,
                    56.4136266
                ],
                [
                    86.1052035,
                    56.4135038
                ],
                [
                    86.106152,
                    56.4137159
                ],
                [
                    86.1066768,
                    56.4135373
                ],
                [
                    86.1076657,
                    56.4138276
                ],
                [
                    86.1079886,
                    56.4137941
                ],
                [
                    86.1087757,
                    56.4141848
                ],
                [
                    86.1095628,
                    56.4135261
                ],
                [
                    86.1106324,
                    56.412566
                ],
                [
                    86.1112379,
                    56.4124208
                ],
                [
                    86.112469,
                    56.4126218
                ],
                [
                    86.1141037,
                    56.4129121
                ],
                [
                    86.1143459,
                    56.4125995
                ],
                [
                    86.1152339,
                    56.4126218
                ],
                [
                    86.115577,
                    56.4121864
                ],
                [
                    86.1163237,
                    56.4118291
                ],
                [
                    86.1172925,
                    56.4117956
                ],
                [
                    86.1175952,
                    56.411483
                ],
                [
                    86.1175346,
                    56.411014
                ],
                [
                    86.1164043,
                    56.4105674
                ],
                [
                    86.1158796,
                    56.4108354
                ],
                [
                    86.1151128,
                    56.4106344
                ],
                [
                    86.1150926,
                    56.4102101
                ],
                [
                    86.1155999,
                    56.4073201
                ],
                [
                    86.1151579,
                    56.4062861
                ],
                [
                    86.1161429,
                    56.4054442
                ],
                [
                    86.1169709,
                    56.4029205
                ],
                [
                    86.1105615,
                    56.4009316
                ],
                [
                    86.1096786,
                    56.4001987
                ],
                [
                    86.1089533,
                    56.3969178
                ],
                [
                    86.1083857,
                    56.3964989
                ],
                [
                    86.1010697,
                    56.3941253
                ],
                [
                    86.1001552,
                    56.3940904
                ],
                [
                    86.099279,
                    56.3947686
                ],
                [
                    86.0986012,
                    56.3950477
                ],
                [
                    86.0972372,
                    56.394979
                ],
                [
                    86.0960303,
                    56.3948418
                ],
                [
                    86.0955095,
                    56.3954777
                ],
                [
                    86.0957905,
                    56.39583
                ],
                [
                    86.0952119,
                    56.3965483
                ],
                [
                    86.0937818,
                    56.3973718
                ],
                [
                    86.0939967,
                    56.39766
                ],
                [
                    86.0954516,
                    56.3983005
                ],
                [
                    86.0953772,
                    56.3985247
                ],
                [
                    86.0951871,
                    56.3986985
                ],
                [
                    86.0960137,
                    56.3989913
                ],
                [
                    86.0964271,
                    56.3991194
                ],
                [
                    86.09813,
                    56.3998513
                ],
                [
                    86.0995187,
                    56.4002082
                ],
                [
                    86.1006182,
                    56.4006885
                ],
                [
                    86.1004446,
                    56.400812
                ],
                [
                    86.1022632,
                    56.4013701
                ],
                [
                    86.1020038,
                    56.4019087
                ],
                [
                    86.1021491,
                    56.4020427
                ],
                [
                    86.1019877,
                    56.4023375
                ],
                [
                    86.1018262,
                    56.402543
                ],
                [
                    86.1019877,
                    56.4027664
                ],
                [
                    86.1017132,
                    56.4029451
                ],
                [
                    86.1007445,
                    56.4028557
                ],
                [
                    86.1007445,
                    56.4023286
                ],
                [
                    86.0993882,
                    56.4017836
                ],
                [
                    86.0984357,
                    56.4017389
                ],
                [
                    86.0975477,
                    56.4016407
                ],
                [
                    86.0951581,
                    56.4010778
                ],
                [
                    86.0938988,
                    56.4012922
                ],
                [
                    86.0930313,
                    56.4011174
                ],
                [
                    86.0928554,
                    56.4011744
                ],
                [
                    86.0917482,
                    56.4009702
                ],
                [
                    86.0913419,
                    56.4011988
                ],
                [
                    86.0913994,
                    56.4013993
                ],
                [
                    86.0915552,
                    56.401521
                ],
                [
                    86.0913351,
                    56.4016747
                ],
                [
                    86.0912166,
                    56.4017253
                ],
                [
                    86.0913419,
                    56.4019426
                ],
                [
                    86.0916325,
                    56.4021755
                ],
                [
                    86.0942245,
                    56.4041244
                ],
                [
                    86.0945676,
                    56.4043813
                ],
                [
                    86.0955969,
                    56.4046716
                ],
                [
                    86.096283,
                    56.4050513
                ],
                [
                    86.0982003,
                    56.4057995
                ],
                [
                    86.0975747,
                    56.4061456
                ],
                [
                    86.0965454,
                    56.4056766
                ],
                [
                    86.0944465,
                    56.4053975
                ],
                [
                    86.0942245,
                    56.4056655
                ],
                [
                    86.0919238,
                    56.4052076
                ],
                [
                    86.0907936,
                    56.4051406
                ],
                [
                    86.0895826,
                    56.4055761
                ],
                [
                    86.0892396,
                    56.4066258
                ],
                [
                    86.0897844,
                    56.4082673
                ],
                [
                    86.0890579,
                    56.4091829
                ]
            ],
            "longitude": 86.1038386,
            "latitude": 56.4084317
        },
        "1135": {
            "name": "Безлесный",
            "population": 380,
            "type": "village",
            "poly": [
                [
                    86.1008841,
                    56.1429764
                ],
                [
                    86.1015922,
                    56.1431826
                ],
                [
                    86.1024773,
                    56.1433082
                ],
                [
                    86.1023726,
                    56.1443197
                ],
                [
                    86.1035267,
                    56.1451268
                ],
                [
                    86.1031828,
                    56.1461528
                ],
                [
                    86.1033057,
                    56.1464127
                ],
                [
                    86.1043616,
                    56.1463716
                ],
                [
                    86.1044353,
                    56.1472607
                ],
                [
                    86.1047299,
                    56.147548
                ],
                [
                    86.1054911,
                    56.147507
                ],
                [
                    86.1062278,
                    56.1484234
                ],
                [
                    86.1073082,
                    56.1493809
                ],
                [
                    86.1086342,
                    56.1500921
                ],
                [
                    86.109641,
                    56.1500101
                ],
                [
                    86.1122438,
                    56.1485055
                ],
                [
                    86.1138399,
                    56.1478079
                ],
                [
                    86.1141368,
                    56.1475536
                ],
                [
                    86.114778,
                    56.1474556
                ],
                [
                    86.1155072,
                    56.1474626
                ],
                [
                    86.116513,
                    56.1475886
                ],
                [
                    86.117217,
                    56.1478127
                ],
                [
                    86.1174559,
                    56.1476657
                ],
                [
                    86.1174182,
                    56.1472665
                ],
                [
                    86.1176319,
                    56.1467622
                ],
                [
                    86.1174685,
                    56.1461739
                ],
                [
                    86.1175942,
                    56.1456486
                ],
                [
                    86.117393,
                    56.1451233
                ],
                [
                    86.1180342,
                    56.1441358
                ],
                [
                    86.1177199,
                    56.1430571
                ],
                [
                    86.1161735,
                    56.1426229
                ],
                [
                    86.1158089,
                    56.1422656
                ],
                [
                    86.1158969,
                    56.1414391
                ],
                [
                    86.1157461,
                    56.141341
                ],
                [
                    86.1152306,
                    56.1414041
                ],
                [
                    86.1152055,
                    56.1410819
                ],
                [
                    86.1154318,
                    56.1406476
                ],
                [
                    86.1149289,
                    56.1393167
                ],
                [
                    86.1155323,
                    56.1382519
                ],
                [
                    86.1172673,
                    56.1372291
                ],
                [
                    86.1058894,
                    56.1388263
                ],
                [
                    86.1013004,
                    56.1400312
                ],
                [
                    86.101728,
                    56.1410118
                ],
                [
                    86.1016023,
                    56.1415021
                ],
                [
                    86.1014262,
                    56.1415582
                ],
                [
                    86.1010491,
                    56.1417613
                ],
                [
                    86.1015037,
                    56.1422906
                ],
                [
                    86.1013347,
                    56.1426447
                ],
                [
                    86.1011255,
                    56.1426402
                ],
                [
                    86.1008841,
                    56.1429764
                ]
            ],
            "longitude": 86.1089156,
            "latitude": 56.1439951
        },
        "1136": {
            "name": "Сухая Речка",
            "population": 551,
            "type": "village",
            "poly": null,
            "longitude": 86.118065,
            "latitude": 55.239616
        },
        "1137": {
            "name": "Ленинградский",
            "population": 415,
            "type": "village",
            "poly": null,
            "longitude": 86.125961,
            "latitude": 55.20134
        },
        "1138": {
            "name": "Клейзавода",
            "population": 329,
            "type": "village",
            "poly": null,
            "longitude": 86.1287949,
            "latitude": 54.7001665
        },
        "1139": {
            "name": "Свердловский",
            "population": 588,
            "type": "village",
            "poly": [
                [
                    86.121619,
                    54.585807
                ],
                [
                    86.1231516,
                    54.5878792
                ],
                [
                    86.1281872,
                    54.5896975
                ],
                [
                    86.1335148,
                    54.5869911
                ],
                [
                    86.14001,
                    54.5875831
                ],
                [
                    86.1469431,
                    54.588302
                ],
                [
                    86.1489136,
                    54.5882598
                ],
                [
                    86.1508841,
                    54.5907124
                ],
                [
                    86.1530005,
                    54.590205
                ],
                [
                    86.1514679,
                    54.5879214
                ],
                [
                    86.1484027,
                    54.5839884
                ],
                [
                    86.1465781,
                    54.5820429
                ],
                [
                    86.1458484,
                    54.5792514
                ],
                [
                    86.1448997,
                    54.5766711
                ],
                [
                    86.1413237,
                    54.5747253
                ],
                [
                    86.1397181,
                    54.5738369
                ],
                [
                    86.1358501,
                    54.5769249
                ],
                [
                    86.1313254,
                    54.5801819
                ],
                [
                    86.1257059,
                    54.5834386
                ],
                [
                    86.121619,
                    54.585807
                ]
            ],
            "longitude": 86.138451,
            "latitude": 54.583015
        },
        "1140": {
            "name": "Каменный Ключ",
            "population": 680,
            "type": "village",
            "poly": null,
            "longitude": 86.14579,
            "latitude": 54.104118
        },
        "1141": {
            "name": "Кузбасский",
            "population": 1520,
            "type": "village",
            "poly": null,
            "longitude": 86.154114,
            "latitude": 55.145493
        },
        "1142": {
            "name": "Разведчик",
            "population": 1034,
            "type": "village",
            "poly": [
                [
                    86.1460873,
                    55.732083
                ],
                [
                    86.1465041,
                    55.733251
                ],
                [
                    86.1481164,
                    55.7336764
                ],
                [
                    86.1484815,
                    55.7351735
                ],
                [
                    86.1477355,
                    55.7358507
                ],
                [
                    86.1487291,
                    55.7396009
                ],
                [
                    86.1503858,
                    55.7404674
                ],
                [
                    86.1508017,
                    55.7417145
                ],
                [
                    86.1502837,
                    55.7428521
                ],
                [
                    86.1500915,
                    55.7445774
                ],
                [
                    86.1499474,
                    55.7462719
                ],
                [
                    86.1532177,
                    55.7469809
                ],
                [
                    86.1549932,
                    55.7453746
                ],
                [
                    86.1555529,
                    55.7466286
                ],
                [
                    86.1562294,
                    55.7465178
                ],
                [
                    86.1623445,
                    55.7410252
                ],
                [
                    86.165753,
                    55.7385545
                ],
                [
                    86.165538,
                    55.7377403
                ],
                [
                    86.1670713,
                    55.736224
                ],
                [
                    86.1678898,
                    55.7359467
                ],
                [
                    86.1688216,
                    55.7339535
                ],
                [
                    86.1690515,
                    55.7328874
                ],
                [
                    86.1691462,
                    55.7311117
                ],
                [
                    86.1694704,
                    55.7305408
                ],
                [
                    86.1684487,
                    55.7293989
                ],
                [
                    86.169712,
                    55.727965
                ],
                [
                    86.1688964,
                    55.7276162
                ],
                [
                    86.1702623,
                    55.7263335
                ],
                [
                    86.1685793,
                    55.7260945
                ],
                [
                    86.167222,
                    55.7256429
                ],
                [
                    86.1667654,
                    55.7251818
                ],
                [
                    86.1664639,
                    55.7248909
                ],
                [
                    86.1655877,
                    55.7242598
                ],
                [
                    86.1648268,
                    55.7239543
                ],
                [
                    86.1639591,
                    55.724215
                ],
                [
                    86.1634073,
                    55.7241555
                ],
                [
                    86.1625809,
                    55.7241418
                ],
                [
                    86.1620684,
                    55.723288
                ],
                [
                    86.1593982,
                    55.7235188
                ],
                [
                    86.1582473,
                    55.723996
                ],
                [
                    86.156951,
                    55.7238041
                ],
                [
                    86.1556413,
                    55.7237243
                ],
                [
                    86.1528965,
                    55.7235152
                ],
                [
                    86.1523629,
                    55.724289
                ],
                [
                    86.150194,
                    55.7235252
                ],
                [
                    86.149306,
                    55.7237813
                ],
                [
                    86.1483704,
                    55.7251729
                ],
                [
                    86.1492837,
                    55.7266571
                ],
                [
                    86.1529097,
                    55.7280015
                ],
                [
                    86.1519859,
                    55.7292406
                ],
                [
                    86.1517484,
                    55.7301223
                ],
                [
                    86.1504342,
                    55.7309736
                ],
                [
                    86.1460873,
                    55.732083
                ]
            ],
            "longitude": 86.16552,
            "latitude": 55.731522
        },
        "1143": {
            "name": "Судженка",
            "population": 596,
            "type": "village",
            "poly": null,
            "longitude": 86.1683557,
            "latitude": 56.1143787
        },
        "1144": {
            "name": "Турат",
            "population": 403,
            "type": "village",
            "poly": [
                [
                    86.1670112,
                    56.0849697
                ],
                [
                    86.1676775,
                    56.0852012
                ],
                [
                    86.1677907,
                    56.0857974
                ],
                [
                    86.1671872,
                    56.0864848
                ],
                [
                    86.170104,
                    56.0874037
                ],
                [
                    86.170632,
                    56.0868566
                ],
                [
                    86.1730585,
                    56.087502
                ],
                [
                    86.174366,
                    56.0871863
                ],
                [
                    86.1763147,
                    56.0872705
                ],
                [
                    86.1774712,
                    56.0869478
                ],
                [
                    86.1781251,
                    56.0866041
                ],
                [
                    86.1789674,
                    56.0868496
                ],
                [
                    86.1770187,
                    56.0881473
                ],
                [
                    86.1786783,
                    56.0888697
                ],
                [
                    86.1768553,
                    56.0902655
                ],
                [
                    86.1799858,
                    56.0915911
                ],
                [
                    86.1802875,
                    56.0913597
                ],
                [
                    86.1809538,
                    56.0904409
                ],
                [
                    86.1810921,
                    56.0892204
                ],
                [
                    86.1822236,
                    56.0885471
                ],
                [
                    86.1806521,
                    56.0876913
                ],
                [
                    86.181331,
                    56.0871442
                ],
                [
                    86.1813184,
                    56.0868356
                ],
                [
                    86.1827265,
                    56.0873897
                ],
                [
                    86.1833426,
                    56.0878877
                ],
                [
                    86.1849393,
                    56.0877545
                ],
                [
                    86.1868754,
                    56.0872635
                ],
                [
                    86.1870514,
                    56.0868005
                ],
                [
                    86.1863976,
                    56.0864287
                ],
                [
                    86.1863348,
                    56.086092
                ],
                [
                    86.1858822,
                    56.0854747
                ],
                [
                    86.1859828,
                    56.0852713
                ],
                [
                    86.1862971,
                    56.0852713
                ],
                [
                    86.1864102,
                    56.0853765
                ],
                [
                    86.1874663,
                    56.0854677
                ],
                [
                    86.188032,
                    56.0857694
                ],
                [
                    86.1889372,
                    56.0857413
                ],
                [
                    86.1888492,
                    56.086569
                ],
                [
                    86.1894024,
                    56.086569
                ],
                [
                    86.1908105,
                    56.0868496
                ],
                [
                    86.191502,
                    56.0866742
                ],
                [
                    86.1924826,
                    56.0867514
                ],
                [
                    86.1929729,
                    56.0866742
                ],
                [
                    86.1930735,
                    56.0844576
                ],
                [
                    86.1872777,
                    56.0836929
                ],
                [
                    86.1876172,
                    56.0820444
                ],
                [
                    86.1859828,
                    56.0814831
                ],
                [
                    86.1840341,
                    56.0818199
                ],
                [
                    86.1824248,
                    56.0831387
                ],
                [
                    86.1815699,
                    56.0833001
                ],
                [
                    86.1798349,
                    56.0829844
                ],
                [
                    86.1789674,
                    56.0821285
                ],
                [
                    86.1793069,
                    56.0813147
                ],
                [
                    86.177069,
                    56.0802905
                ],
                [
                    86.1788417,
                    56.0799888
                ],
                [
                    86.1793195,
                    56.0788452
                ],
                [
                    86.17854,
                    56.0790908
                ],
                [
                    86.1781628,
                    56.0791609
                ],
                [
                    86.1783891,
                    56.0777788
                ],
                [
                    86.1776976,
                    56.0774841
                ],
                [
                    86.1773204,
                    56.078312
                ],
                [
                    86.1768679,
                    56.0786347
                ],
                [
                    86.1758244,
                    56.0780875
                ],
                [
                    86.1751957,
                    56.0784944
                ],
                [
                    86.1745168,
                    56.0783471
                ],
                [
                    86.1737248,
                    56.078761
                ],
                [
                    86.1728824,
                    56.0785225
                ],
                [
                    86.1722537,
                    56.0784102
                ],
                [
                    86.1694376,
                    56.0791679
                ],
                [
                    86.1685324,
                    56.0804869
                ],
                [
                    86.1698022,
                    56.0812656
                ],
                [
                    86.1712983,
                    56.0819251
                ],
                [
                    86.1717132,
                    56.0822478
                ],
                [
                    86.1715875,
                    56.0825775
                ],
                [
                    86.1712355,
                    56.0826477
                ],
                [
                    86.1700285,
                    56.0824653
                ],
                [
                    86.1693999,
                    56.0829704
                ],
                [
                    86.1687587,
                    56.0828792
                ],
                [
                    86.1684319,
                    56.0831668
                ],
                [
                    86.168545,
                    56.0833913
                ],
                [
                    86.168017,
                    56.0838052
                ],
                [
                    86.1670112,
                    56.0849697
                ]
            ],
            "longitude": 86.1768881,
            "latitude": 56.0842356
        },
        "1145": {
            "name": "Щебзавод",
            "population": 1302,
            "type": "village",
            "poly": [
                [
                    86.163117,
                    54.1877416
                ],
                [
                    86.165344,
                    54.1890781
                ],
                [
                    86.1639735,
                    54.1896461
                ],
                [
                    86.1699124,
                    54.1953591
                ],
                [
                    86.1735956,
                    54.1996851
                ],
                [
                    86.1759368,
                    54.2017227
                ],
                [
                    86.1751088,
                    54.203042
                ],
                [
                    86.1727104,
                    54.2061315
                ],
                [
                    86.1703406,
                    54.2105399
                ],
                [
                    86.1782495,
                    54.212293
                ],
                [
                    86.1827322,
                    54.2114749
                ],
                [
                    86.1797057,
                    54.2083524
                ],
                [
                    86.1819327,
                    54.2049625
                ],
                [
                    86.1835316,
                    54.2045116
                ],
                [
                    86.1867295,
                    54.2061649
                ],
                [
                    86.1895561,
                    54.2048122
                ],
                [
                    86.1827322,
                    54.197781
                ],
                [
                    86.183703,
                    54.1969125
                ],
                [
                    86.1829892,
                    54.194574
                ],
                [
                    86.1836459,
                    54.1927031
                ],
                [
                    86.1850735,
                    54.191467
                ],
                [
                    86.1860442,
                    54.1903143
                ],
                [
                    86.1831605,
                    54.1889444
                ],
                [
                    86.1814474,
                    54.1896127
                ],
                [
                    86.1807621,
                    54.190331
                ],
                [
                    86.1785636,
                    54.1905482
                ],
                [
                    86.1784494,
                    54.1915505
                ],
                [
                    86.1758797,
                    54.1912164
                ],
                [
                    86.1720251,
                    54.1876413
                ],
                [
                    86.1699694,
                    54.1892117
                ],
                [
                    86.1684562,
                    54.1898298
                ],
                [
                    86.1651727,
                    54.1870232
                ],
                [
                    86.163117,
                    54.1877416
                ]
            ],
            "longitude": 86.177834,
            "latitude": 54.197178
        },
        "1146": {
            "name": "Барачаты",
            "population": 683,
            "type": "village",
            "poly": [
                [
                    86.175307,
                    54.9768987
                ],
                [
                    86.175632,
                    54.9771503
                ],
                [
                    86.1763121,
                    54.9787767
                ],
                [
                    86.1769318,
                    54.9797091
                ],
                [
                    86.1779899,
                    54.980802
                ],
                [
                    86.1788136,
                    54.9809581
                ],
                [
                    86.1810808,
                    54.9805505
                ],
                [
                    86.1833707,
                    54.9802599
                ],
                [
                    86.1851239,
                    54.9799563
                ],
                [
                    86.1864389,
                    54.9793492
                ],
                [
                    86.1865372,
                    54.9797568
                ],
                [
                    86.1867866,
                    54.9799303
                ],
                [
                    86.1875574,
                    54.9797872
                ],
                [
                    86.1881846,
                    54.9798652
                ],
                [
                    86.1884643,
                    54.9801688
                ],
                [
                    86.1884869,
                    54.9804204
                ],
                [
                    86.1879882,
                    54.9807023
                ],
                [
                    86.1880411,
                    54.9809928
                ],
                [
                    86.1886154,
                    54.9812357
                ],
                [
                    86.189817,
                    54.981227
                ],
                [
                    86.1900135,
                    54.9813051
                ],
                [
                    86.1899908,
                    54.9816477
                ],
                [
                    86.1894467,
                    54.9817517
                ],
                [
                    86.1892502,
                    54.9816954
                ],
                [
                    86.1887666,
                    54.9820596
                ],
                [
                    86.1887439,
                    54.9823198
                ],
                [
                    86.1929004,
                    54.9829443
                ],
                [
                    86.1936788,
                    54.9828532
                ],
                [
                    86.1944496,
                    54.9827361
                ],
                [
                    86.194699,
                    54.9827795
                ],
                [
                    86.1948124,
                    54.9826711
                ],
                [
                    86.1957948,
                    54.9828532
                ],
                [
                    86.1961274,
                    54.9831004
                ],
                [
                    86.1966488,
                    54.9827969
                ],
                [
                    86.1952431,
                    54.9810492
                ],
                [
                    86.1952465,
                    54.9804671
                ],
                [
                    86.1968364,
                    54.97975
                ],
                [
                    86.1976801,
                    54.9788331
                ],
                [
                    86.1980429,
                    54.9784417
                ],
                [
                    86.1984101,
                    54.9782668
                ],
                [
                    86.1991756,
                    54.9780548
                ],
                [
                    86.2000362,
                    54.9780708
                ],
                [
                    86.2006676,
                    54.9779429
                ],
                [
                    86.2013027,
                    54.976658
                ],
                [
                    86.2011287,
                    54.9762472
                ],
                [
                    86.202145,
                    54.9756335
                ],
                [
                    86.2050964,
                    54.9754525
                ],
                [
                    86.2059525,
                    54.9755525
                ],
                [
                    86.2067263,
                    54.9758467
                ],
                [
                    86.2088839,
                    54.9774613
                ],
                [
                    86.209942,
                    54.9775318
                ],
                [
                    86.2103015,
                    54.976133
                ],
                [
                    86.2127421,
                    54.9750336
                ],
                [
                    86.2126178,
                    54.9722821
                ],
                [
                    86.2108938,
                    54.9731903
                ],
                [
                    86.209713,
                    54.9735427
                ],
                [
                    86.2094058,
                    54.9729938
                ],
                [
                    86.2084495,
                    54.9720856
                ],
                [
                    86.2075757,
                    54.9716382
                ],
                [
                    86.2064893,
                    54.9714959
                ],
                [
                    86.2037734,
                    54.9715162
                ],
                [
                    86.2015372,
                    54.9713862
                ],
                [
                    86.191451,
                    54.9717063
                ],
                [
                    86.190461,
                    54.9718841
                ],
                [
                    86.187219,
                    54.973103
                ],
                [
                    86.1837252,
                    54.971846
                ],
                [
                    86.1822327,
                    54.9734943
                ],
                [
                    86.1813825,
                    54.9742371
                ],
                [
                    86.1811001,
                    54.9754302
                ],
                [
                    86.175307,
                    54.9768987
                ]
            ],
            "longitude": 86.191116,
            "latitude": 54.975975
        },
        "1147": {
            "name": "Беково",
            "population": 704,
            "type": "village",
            "poly": null,
            "longitude": 86.194893,
            "latitude": 54.367714
        },
        "1148": {
            "name": "Металлплощадка",
            "population": 5189,
            "type": "village",
            "poly": null,
            "longitude": 86.198402,
            "latitude": 55.317013
        },
        "1149": {
            "name": "Старобачаты",
            "population": 4382,
            "type": "village",
            "poly": [
                [
                    86.1505179,
                    54.2223312
                ],
                [
                    86.1531543,
                    54.2289752
                ],
                [
                    86.1764637,
                    54.2282991
                ],
                [
                    86.178421,
                    54.2294952
                ],
                [
                    86.1734388,
                    54.2317314
                ],
                [
                    86.1750403,
                    54.2353714
                ],
                [
                    86.1883854,
                    54.2354754
                ],
                [
                    86.1942572,
                    54.2384911
                ],
                [
                    86.1930812,
                    54.2424465
                ],
                [
                    86.2062636,
                    54.2452939
                ],
                [
                    86.2043106,
                    54.2495123
                ],
                [
                    86.2045775,
                    54.2551777
                ],
                [
                    86.2085984,
                    54.2575858
                ],
                [
                    86.2152535,
                    54.2573605
                ],
                [
                    86.2184563,
                    54.2631807
                ],
                [
                    86.2310008,
                    54.2629729
                ],
                [
                    86.230378,
                    54.2542422
                ],
                [
                    86.2272641,
                    54.2492004
                ],
                [
                    86.2191681,
                    54.2399469
                ],
                [
                    86.221084,
                    54.235678
                ],
                [
                    86.2229937,
                    54.2308993
                ],
                [
                    86.2200578,
                    54.2286111
                ],
                [
                    86.2145936,
                    54.2272516
                ],
                [
                    86.1830988,
                    54.2194738
                ],
                [
                    86.1695234,
                    54.2194738
                ],
                [
                    86.1505179,
                    54.2223312
                ]
            ],
            "longitude": 86.206093,
            "latitude": 54.237862
        },
        "1150": {
            "name": "Сухово",
            "population": 363,
            "type": "village",
            "poly": null,
            "longitude": 86.208717,
            "latitude": 55.358959
        },
        "1151": {
            "name": "Челухоево",
            "population": 615,
            "type": "village",
            "poly": null,
            "longitude": 86.213242,
            "latitude": 54.371429
        },
        "1152": {
            "name": "Андреевка",
            "population": 1229,
            "type": "village",
            "poly": null,
            "longitude": 86.213356,
            "latitude": 55.444168
        },
        "1153": {
            "name": "Ишим",
            "population": 378,
            "type": "village",
            "poly": null,
            "longitude": 86.221596,
            "latitude": 56.513992
        },
        "1154": {
            "name": "Журавлево",
            "population": 293,
            "type": "village",
            "poly": null,
            "longitude": 86.224922,
            "latitude": 55.36821
        },
        "1155": {
            "name": "Новостройка",
            "population": 2967,
            "type": "village",
            "poly": null,
            "longitude": 86.225311,
            "latitude": 55.249348
        },
        "1156": {
            "name": "Новый",
            "population": 544,
            "type": "village",
            "poly": null,
            "longitude": 86.229576,
            "latitude": 54.840572
        },
        "1157": {
            "name": "Скарюпино",
            "population": 312,
            "type": "village",
            "poly": [
                [
                    86.2230165,
                    54.9622586
                ],
                [
                    86.2230543,
                    54.9633433
                ],
                [
                    86.2233188,
                    54.9635765
                ],
                [
                    86.2234983,
                    54.9640429
                ],
                [
                    86.2232905,
                    54.9642815
                ],
                [
                    86.2233377,
                    54.9647425
                ],
                [
                    86.2235739,
                    54.965019
                ],
                [
                    86.2246697,
                    54.965339
                ],
                [
                    86.2260233,
                    54.966047
                ],
                [
                    86.2262594,
                    54.9658558
                ],
                [
                    86.2270974,
                    54.9656386
                ],
                [
                    86.2276698,
                    54.9655557
                ],
                [
                    86.2289046,
                    54.965377
                ],
                [
                    86.2298115,
                    54.9651638
                ],
                [
                    86.2315808,
                    54.9659505
                ],
                [
                    86.2322144,
                    54.9659561
                ],
                [
                    86.2425152,
                    54.9635331
                ],
                [
                    86.2432426,
                    54.9634975
                ],
                [
                    86.2466773,
                    54.9639531
                ],
                [
                    86.2500478,
                    54.964183
                ],
                [
                    86.2525138,
                    54.9640943
                ],
                [
                    86.2566998,
                    54.9636106
                ],
                [
                    86.2582113,
                    54.9631712
                ],
                [
                    86.2567235,
                    54.9612458
                ],
                [
                    86.2522599,
                    54.9614492
                ],
                [
                    86.2497566,
                    54.9615034
                ],
                [
                    86.2479972,
                    54.961639
                ],
                [
                    86.2460016,
                    54.961578
                ],
                [
                    86.2456945,
                    54.9616526
                ],
                [
                    86.2435454,
                    54.9612187
                ],
                [
                    86.244313,
                    54.9598967
                ],
                [
                    86.2447617,
                    54.959395
                ],
                [
                    86.2444901,
                    54.9592458
                ],
                [
                    86.2430613,
                    54.9589678
                ],
                [
                    86.242282,
                    54.9590153
                ],
                [
                    86.2409949,
                    54.9592662
                ],
                [
                    86.2396251,
                    54.9589814
                ],
                [
                    86.2383498,
                    54.9592187
                ],
                [
                    86.2373697,
                    54.9590492
                ],
                [
                    86.2359173,
                    54.9582017
                ],
                [
                    86.234701,
                    54.9586221
                ],
                [
                    86.2334139,
                    54.9586356
                ],
                [
                    86.2334139,
                    54.9584458
                ],
                [
                    86.2323394,
                    54.9579305
                ],
                [
                    86.2316899,
                    54.958378
                ],
                [
                    86.2327881,
                    54.958934
                ],
                [
                    86.2322449,
                    54.9592933
                ],
                [
                    86.2323512,
                    54.9594763
                ],
                [
                    86.2362361,
                    54.9618424
                ],
                [
                    86.234845,
                    54.9625092
                ],
                [
                    86.2338368,
                    54.9631296
                ],
                [
                    86.2319625,
                    54.9623833
                ],
                [
                    86.2283444,
                    54.9613257
                ],
                [
                    86.2255293,
                    54.9603658
                ],
                [
                    86.2241407,
                    54.9611413
                ],
                [
                    86.2232527,
                    54.9618681
                ],
                [
                    86.2230165,
                    54.9622586
                ]
            ],
            "longitude": 86.232101,
            "latitude": 54.963547
        },
        "1158": {
            "name": "Демьяновка",
            "population": 1090,
            "type": "village",
            "poly": [
                [
                    86.2305167,
                    54.7404949
                ],
                [
                    86.2373266,
                    54.7480913
                ],
                [
                    86.2345995,
                    54.7492592
                ],
                [
                    86.2358105,
                    54.751022
                ],
                [
                    86.2399645,
                    54.7537395
                ],
                [
                    86.2479719,
                    54.7569569
                ],
                [
                    86.2520386,
                    54.7575384
                ],
                [
                    86.2557336,
                    54.7630775
                ],
                [
                    86.2593755,
                    54.7630666
                ],
                [
                    86.2623244,
                    54.7605044
                ],
                [
                    86.2594595,
                    54.7593188
                ],
                [
                    86.2606013,
                    54.7585008
                ],
                [
                    86.255461,
                    54.755608
                ],
                [
                    86.2538721,
                    54.7561264
                ],
                [
                    86.2483666,
                    54.7532042
                ],
                [
                    86.2521547,
                    54.7518431
                ],
                [
                    86.2464495,
                    54.7496148
                ],
                [
                    86.2473659,
                    54.7468855
                ],
                [
                    86.2529024,
                    54.7438357
                ],
                [
                    86.2514768,
                    54.7430566
                ],
                [
                    86.2484167,
                    54.7439338
                ],
                [
                    86.243808,
                    54.7435753
                ],
                [
                    86.2483137,
                    54.7418924
                ],
                [
                    86.2401269,
                    54.7368531
                ],
                [
                    86.2305167,
                    54.7404949
                ]
            ],
            "longitude": 86.243301,
            "latitude": 54.747231
        },
        "1159": {
            "name": "Заречное",
            "population": 454,
            "type": "village",
            "poly": null,
            "longitude": 86.2454949,
            "latitude": 54.3121892
        },
        "1160": {
            "name": "Берёзово",
            "population": 2360,
            "type": "village",
            "poly": null,
            "longitude": 86.247391,
            "latitude": 55.233673
        },
        "1161": {
            "name": "Конёво",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 86.24791,
            "latitude": 54.530586
        },
        "1162": {
            "name": "Судженка",
            "population": 564,
            "type": "village",
            "poly": [
                [
                    86.2352782,
                    56.1779585
                ],
                [
                    86.2383782,
                    56.179684
                ],
                [
                    86.2394218,
                    56.1794449
                ],
                [
                    86.2398209,
                    56.1791886
                ],
                [
                    86.2411407,
                    56.1792228
                ],
                [
                    86.241417,
                    56.178864
                ],
                [
                    86.2419081,
                    56.1790348
                ],
                [
                    86.2411714,
                    56.1798207
                ],
                [
                    86.2430744,
                    56.1804699
                ],
                [
                    86.2435962,
                    56.1803332
                ],
                [
                    86.2442408,
                    56.1797695
                ],
                [
                    86.2446091,
                    56.1795303
                ],
                [
                    86.2450695,
                    56.1795474
                ],
                [
                    86.2437804,
                    56.1807432
                ],
                [
                    86.2456834,
                    56.1813412
                ],
                [
                    86.2469419,
                    56.1812045
                ],
                [
                    86.2480162,
                    56.1815291
                ],
                [
                    86.2487221,
                    56.180692
                ],
                [
                    86.2497657,
                    56.1809482
                ],
                [
                    86.249735,
                    56.1811874
                ],
                [
                    86.2503182,
                    56.1814095
                ],
                [
                    86.2497963,
                    56.1819049
                ],
                [
                    86.2487835,
                    56.1816828
                ],
                [
                    86.2457141,
                    56.1833911
                ],
                [
                    86.2428289,
                    56.1847235
                ],
                [
                    86.2430437,
                    56.1851164
                ],
                [
                    86.2420922,
                    56.1855263
                ],
                [
                    86.2416625,
                    56.1852701
                ],
                [
                    86.2397288,
                    56.185885
                ],
                [
                    86.2394832,
                    56.1861754
                ],
                [
                    86.2397902,
                    56.1867562
                ],
                [
                    86.2409258,
                    56.1874736
                ],
                [
                    86.2494281,
                    56.1895915
                ],
                [
                    86.2509836,
                    56.1881585
                ],
                [
                    86.2512586,
                    56.1874152
                ],
                [
                    86.2525944,
                    56.1865188
                ],
                [
                    86.2531445,
                    56.1865079
                ],
                [
                    86.2537141,
                    56.1858738
                ],
                [
                    86.25615,
                    56.1865297
                ],
                [
                    86.2583109,
                    56.1870107
                ],
                [
                    86.259077,
                    56.1867811
                ],
                [
                    86.2597842,
                    56.1870107
                ],
                [
                    86.260845,
                    56.1871419
                ],
                [
                    86.2613754,
                    56.1867046
                ],
                [
                    86.2628487,
                    56.1870654
                ],
                [
                    86.2659132,
                    56.1877322
                ],
                [
                    86.2673472,
                    56.1878962
                ],
                [
                    86.2680151,
                    56.1878743
                ],
                [
                    86.2688205,
                    56.1876994
                ],
                [
                    86.2694884,
                    56.1872512
                ],
                [
                    86.2694884,
                    56.1869233
                ],
                [
                    86.2688795,
                    56.1862236
                ],
                [
                    86.2691152,
                    56.1859941
                ],
                [
                    86.2693313,
                    56.1856661
                ],
                [
                    86.2688598,
                    56.1853709
                ],
                [
                    86.2686044,
                    56.1853819
                ],
                [
                    86.267799,
                    56.1846057
                ],
                [
                    86.2670722,
                    56.1842668
                ],
                [
                    86.2658935,
                    56.1841137
                ],
                [
                    86.2658739,
                    56.1839169
                ],
                [
                    86.26664,
                    56.1832391
                ],
                [
                    86.2673276,
                    56.1820583
                ],
                [
                    86.2685259,
                    56.1822005
                ],
                [
                    86.2697634,
                    56.1829767
                ],
                [
                    86.270451,
                    56.1829111
                ],
                [
                    86.2708242,
                    56.1829111
                ],
                [
                    86.2711778,
                    56.1832063
                ],
                [
                    86.2715511,
                    56.1833375
                ],
                [
                    86.2720422,
                    56.1827581
                ],
                [
                    86.2717672,
                    56.1815773
                ],
                [
                    86.2766389,
                    56.1774771
                ],
                [
                    86.2644595,
                    56.1722611
                ],
                [
                    86.2585749,
                    56.1758912
                ],
                [
                    86.2572551,
                    56.1759083
                ],
                [
                    86.2571016,
                    56.175652
                ],
                [
                    86.2564263,
                    56.1754811
                ],
                [
                    86.2563036,
                    56.1756862
                ],
                [
                    86.2556283,
                    56.1756349
                ],
                [
                    86.2551679,
                    56.1753274
                ],
                [
                    86.2530807,
                    56.175054
                ],
                [
                    86.2532956,
                    56.1763013
                ],
                [
                    86.2528658,
                    56.1769676
                ],
                [
                    86.2522827,
                    56.1771384
                ],
                [
                    86.25084,
                    56.177053
                ],
                [
                    86.2503796,
                    56.1773605
                ],
                [
                    86.2493667,
                    56.1775485
                ],
                [
                    86.2488449,
                    56.1771043
                ],
                [
                    86.248231,
                    56.177053
                ],
                [
                    86.2481083,
                    56.1765917
                ],
                [
                    86.2472181,
                    56.1763525
                ],
                [
                    86.2458982,
                    56.176643
                ],
                [
                    86.2458062,
                    56.1762671
                ],
                [
                    86.2447319,
                    56.1760621
                ],
                [
                    86.244824,
                    56.1757887
                ],
                [
                    86.2415704,
                    56.1740288
                ],
                [
                    86.2406496,
                    56.173858
                ],
                [
                    86.2400357,
                    56.1734137
                ],
                [
                    86.2393297,
                    56.1731916
                ],
                [
                    86.238808,
                    56.1722176
                ],
                [
                    86.2370584,
                    56.1716195
                ],
                [
                    86.2363217,
                    56.1724739
                ],
                [
                    86.237304,
                    56.1731745
                ],
                [
                    86.2366593,
                    56.1736187
                ],
                [
                    86.2377337,
                    56.174268
                ],
                [
                    86.2375802,
                    56.1754299
                ],
                [
                    86.2394525,
                    56.1752249
                ],
                [
                    86.2399743,
                    56.1757374
                ],
                [
                    86.2392377,
                    56.1762842
                ],
                [
                    86.238501,
                    56.1761817
                ],
                [
                    86.2352782,
                    56.1779585
                ]
            ],
            "longitude": 86.2516182,
            "latitude": 56.1832397
        },
        "1163": {
            "name": "Ивановка",
            "population": 588,
            "type": "village",
            "poly": [
                [
                    86.2303064,
                    54.4663283
                ],
                [
                    86.2321133,
                    54.467974
                ],
                [
                    86.2369406,
                    54.4694942
                ],
                [
                    86.2446806,
                    54.4710614
                ],
                [
                    86.2438716,
                    54.4722995
                ],
                [
                    86.2534184,
                    54.4749322
                ],
                [
                    86.2602145,
                    54.4747911
                ],
                [
                    86.2628035,
                    54.4725189
                ],
                [
                    86.2629922,
                    54.4672843
                ],
                [
                    86.2584346,
                    54.4670963
                ],
                [
                    86.2481595,
                    54.4680523
                ],
                [
                    86.2413095,
                    54.467253
                ],
                [
                    86.2389633,
                    54.466532
                ],
                [
                    86.2314391,
                    54.4649176
                ],
                [
                    86.2303064,
                    54.4663283
                ]
            ],
            "longitude": 86.251663,
            "latitude": 54.470654
        },
        "1164": {
            "name": "Шестаки",
            "population": 274,
            "type": "village",
            "poly": [
                [
                    86.2460444,
                    54.2055065
                ],
                [
                    86.2470179,
                    54.2070787
                ],
                [
                    86.2462933,
                    54.2083648
                ],
                [
                    86.2461799,
                    54.2086563
                ],
                [
                    86.2469983,
                    54.2092601
                ],
                [
                    86.2485411,
                    54.2095457
                ],
                [
                    86.2513184,
                    54.2116941
                ],
                [
                    86.2513531,
                    54.212218
                ],
                [
                    86.2499276,
                    54.2135312
                ],
                [
                    86.2486724,
                    54.2142512
                ],
                [
                    86.2475692,
                    54.2151715
                ],
                [
                    86.2483531,
                    54.2159091
                ],
                [
                    86.2495642,
                    54.2171041
                ],
                [
                    86.2531597,
                    54.2172369
                ],
                [
                    86.2567173,
                    54.2151566
                ],
                [
                    86.2571336,
                    54.2138288
                ],
                [
                    86.2588745,
                    54.2151345
                ],
                [
                    86.2648165,
                    54.2167279
                ],
                [
                    86.2679578,
                    54.2152894
                ],
                [
                    86.2671252,
                    54.2144042
                ],
                [
                    86.2705692,
                    54.2121689
                ],
                [
                    86.2677686,
                    54.2108852
                ],
                [
                    86.2634162,
                    54.2125894
                ],
                [
                    86.2584961,
                    54.2100663
                ],
                [
                    86.2578527,
                    54.2082955
                ],
                [
                    86.2546357,
                    54.2060599
                ],
                [
                    86.2492614,
                    54.2049974
                ],
                [
                    86.2460444,
                    54.2055065
                ]
            ],
            "longitude": 86.252815,
            "latitude": 54.210114
        },
        "1165": {
            "name": "Елыкаево",
            "population": 2748,
            "type": "village",
            "poly": null,
            "longitude": 86.255035,
            "latitude": 55.299999
        },
        "1166": {
            "name": "Красные Ключи",
            "population": 531,
            "type": "village",
            "poly": null,
            "longitude": 86.263359,
            "latitude": 54.997761
        },
        "1167": {
            "name": "Артышта",
            "population": 2780,
            "type": "village",
            "poly": null,
            "longitude": 86.270058,
            "latitude": 54.116268
        },
        "1168": {
            "name": "Красногорский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.296455,
            "latitude": 54.52832
        },
        "1169": {
            "name": "Силино",
            "population": 859,
            "type": "village",
            "poly": null,
            "longitude": 86.297424,
            "latitude": 55.270569
        },
        "1170": {
            "name": "Осиновка",
            "population": 303,
            "type": "village",
            "poly": null,
            "longitude": 86.303604,
            "latitude": 55.389694
        },
        "1171": {
            "name": "Убинский",
            "population": 567,
            "type": "village",
            "poly": [
                [
                    86.2999911,
                    54.4785731
                ],
                [
                    86.3100176,
                    54.482246
                ],
                [
                    86.3137221,
                    54.4828775
                ],
                [
                    86.3142101,
                    54.4812537
                ],
                [
                    86.3149865,
                    54.479153
                ],
                [
                    86.3082651,
                    54.4765238
                ],
                [
                    86.3065349,
                    54.4750802
                ],
                [
                    86.3045163,
                    54.4747193
                ],
                [
                    86.2999911,
                    54.4785731
                ]
            ],
            "longitude": 86.309639,
            "latitude": 54.479538
        },
        "1172": {
            "name": "Береговая",
            "population": 1974,
            "type": "village",
            "poly": null,
            "longitude": 86.316956,
            "latitude": 55.148563
        },
        "1173": {
            "name": "Новогеоргиевка",
            "population": 612,
            "type": "village",
            "poly": null,
            "longitude": 86.317245,
            "latitude": 54.698189
        },
        "1174": {
            "name": "Барзас",
            "population": 2111,
            "type": "village",
            "poly": null,
            "longitude": 86.317558,
            "latitude": 55.72924
        },
        "1175": {
            "name": "Красноярка",
            "population": 732,
            "type": "village",
            "poly": null,
            "longitude": 86.323273,
            "latitude": 54.648109
        },
        "1176": {
            "name": "Чусовитино",
            "population": 1113,
            "type": "village",
            "poly": null,
            "longitude": 86.333199,
            "latitude": 54.838352
        },
        "1177": {
            "name": "Смолино",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 86.34317,
            "latitude": 55.1782
        },
        "1178": {
            "name": "Новобачаты",
            "population": 1342,
            "type": "village",
            "poly": null,
            "longitude": 86.347168,
            "latitude": 54.256969
        },
        "1179": {
            "name": "Мохово",
            "population": 2184,
            "type": "village",
            "poly": null,
            "longitude": 86.347221,
            "latitude": 54.587914
        },
        "1180": {
            "name": "Шевели",
            "population": 973,
            "type": "village",
            "poly": null,
            "longitude": 86.34861,
            "latitude": 55.073467
        },
        "1181": {
            "name": "Сергеевка",
            "population": 323,
            "type": "village",
            "poly": [
                [
                    86.3383152,
                    56.3871688
                ],
                [
                    86.3385422,
                    56.3890681
                ],
                [
                    86.3408127,
                    56.391805
                ],
                [
                    86.3425282,
                    56.3961615
                ],
                [
                    86.3426038,
                    56.3956169
                ],
                [
                    86.3431084,
                    56.3949607
                ],
                [
                    86.3449248,
                    56.3942346
                ],
                [
                    86.3509289,
                    56.3900177
                ],
                [
                    86.3523669,
                    56.3899618
                ],
                [
                    86.3534011,
                    56.3901573
                ],
                [
                    86.3546626,
                    56.3900037
                ],
                [
                    86.3557726,
                    56.3888167
                ],
                [
                    86.3573619,
                    56.3880905
                ],
                [
                    86.360263,
                    56.3869175
                ],
                [
                    86.361701,
                    56.3870152
                ],
                [
                    86.3634921,
                    56.3855069
                ],
                [
                    86.3644256,
                    56.3838868
                ],
                [
                    86.3641481,
                    56.3824063
                ],
                [
                    86.3642742,
                    56.3801855
                ],
                [
                    86.3626596,
                    56.3793474
                ],
                [
                    86.3607171,
                    56.3779506
                ],
                [
                    86.3598342,
                    56.3763721
                ],
                [
                    86.3593281,
                    56.3762767
                ],
                [
                    86.3536825,
                    56.3778256
                ],
                [
                    86.3519775,
                    56.3785522
                ],
                [
                    86.3511508,
                    56.3791816
                ],
                [
                    86.3503552,
                    56.3793189
                ],
                [
                    86.3497249,
                    56.3789813
                ],
                [
                    86.3500865,
                    56.3784492
                ],
                [
                    86.3499522,
                    56.3781174
                ],
                [
                    86.3494149,
                    56.3779515
                ],
                [
                    86.3491358,
                    56.3776883
                ],
                [
                    86.3484436,
                    56.3774651
                ],
                [
                    86.3464906,
                    56.3775281
                ],
                [
                    86.345106,
                    56.3772363
                ],
                [
                    86.344889,
                    56.377591
                ],
                [
                    86.344207,
                    56.3779743
                ],
                [
                    86.3439073,
                    56.378844
                ],
                [
                    86.344796,
                    56.3796336
                ],
                [
                    86.3471102,
                    56.3796971
                ],
                [
                    86.3475736,
                    56.3791519
                ],
                [
                    86.3481791,
                    56.3792357
                ],
                [
                    86.3490367,
                    56.3801436
                ],
                [
                    86.3458582,
                    56.3814007
                ],
                [
                    86.3400811,
                    56.3828533
                ],
                [
                    86.3400054,
                    56.3834958
                ],
                [
                    86.3383152,
                    56.3871688
                ]
            ],
            "longitude": 86.3559409,
            "latitude": 56.3835206
        },
        "1182": {
            "name": "Грамотеино",
            "population": 1557,
            "type": "village",
            "poly": null,
            "longitude": 86.3563926,
            "latitude": 54.5255113
        },
        "1183": {
            "name": "Михайловка",
            "population": 573,
            "type": "village",
            "poly": null,
            "longitude": 86.360275,
            "latitude": 54.047287
        },
        "1184": {
            "name": "Снежинский",
            "population": 725,
            "type": "village",
            "poly": [
                [
                    86.3649667,
                    54.4384082
                ],
                [
                    86.3680319,
                    54.4396704
                ],
                [
                    86.3650597,
                    54.440291
                ],
                [
                    86.3667566,
                    54.4453172
                ],
                [
                    86.3743415,
                    54.4452912
                ],
                [
                    86.3751917,
                    54.4435738
                ],
                [
                    86.3801588,
                    54.4419995
                ],
                [
                    86.3756839,
                    54.4391629
                ],
                [
                    86.3765749,
                    54.4385427
                ],
                [
                    86.3736327,
                    54.4351669
                ],
                [
                    86.3710077,
                    54.4359358
                ],
                [
                    86.3714776,
                    54.4365734
                ],
                [
                    86.3703589,
                    54.4372501
                ],
                [
                    86.3686808,
                    54.4365734
                ],
                [
                    86.3665776,
                    54.437159
                ],
                [
                    86.3649667,
                    54.4384082
                ]
            ],
            "longitude": 86.372208,
            "latitude": 54.440605
        },
        "1185": {
            "name": "Старочервово",
            "population": 563,
            "type": "village",
            "poly": [
                [
                    86.3456967,
                    55.1444855
                ],
                [
                    86.3477783,
                    55.1457927
                ],
                [
                    86.3498342,
                    55.1477754
                ],
                [
                    86.3512405,
                    55.1508987
                ],
                [
                    86.3505255,
                    55.1511178
                ],
                [
                    86.3500586,
                    55.1512609
                ],
                [
                    86.3529966,
                    55.1533978
                ],
                [
                    86.3556036,
                    55.1552026
                ],
                [
                    86.3585928,
                    55.1569248
                ],
                [
                    86.3594714,
                    55.1577029
                ],
                [
                    86.3597146,
                    55.1582625
                ],
                [
                    86.3600669,
                    55.1589597
                ],
                [
                    86.3602499,
                    55.1595
                ],
                [
                    86.3613156,
                    55.1597962
                ],
                [
                    86.36125,
                    55.16025
                ],
                [
                    86.36175,
                    55.161
                ],
                [
                    86.362,
                    55.16125
                ],
                [
                    86.3635,
                    55.16225
                ],
                [
                    86.36375,
                    55.16275
                ],
                [
                    86.3635,
                    55.163
                ],
                [
                    86.36375,
                    55.16325
                ],
                [
                    86.3662499,
                    55.16575
                ],
                [
                    86.36775,
                    55.168
                ],
                [
                    86.36775,
                    55.169
                ],
                [
                    86.3673734,
                    55.1695634
                ],
                [
                    86.3673798,
                    55.170141
                ],
                [
                    86.3673594,
                    55.1702333
                ],
                [
                    86.3657928,
                    55.1757679
                ],
                [
                    86.3649253,
                    55.1772152
                ],
                [
                    86.3627851,
                    55.1789787
                ],
                [
                    86.3602499,
                    55.18075
                ],
                [
                    86.3594358,
                    55.1814476
                ],
                [
                    86.3610833,
                    55.181497
                ],
                [
                    86.3724156,
                    55.1796845
                ],
                [
                    86.3730242,
                    55.1785951
                ],
                [
                    86.3708903,
                    55.175071
                ],
                [
                    86.3760877,
                    55.1749282
                ],
                [
                    86.3745352,
                    55.1728693
                ],
                [
                    86.3769168,
                    55.1721554
                ],
                [
                    86.3793087,
                    55.1713139
                ],
                [
                    86.3804652,
                    55.1691709
                ],
                [
                    86.3813837,
                    55.1653474
                ],
                [
                    86.3804365,
                    55.1623083
                ],
                [
                    86.3821306,
                    55.1626648
                ],
                [
                    86.3838374,
                    55.1622792
                ],
                [
                    86.3835827,
                    55.1607875
                ],
                [
                    86.3823853,
                    55.1597469
                ],
                [
                    86.3791441,
                    55.1587665
                ],
                [
                    86.3786957,
                    55.1592835
                ],
                [
                    86.3774059,
                    55.1595087
                ],
                [
                    86.3739428,
                    55.1595087
                ],
                [
                    86.3727685,
                    55.1590653
                ],
                [
                    86.3713356,
                    55.1574279
                ],
                [
                    86.3699424,
                    55.1544145
                ],
                [
                    86.3685711,
                    55.1494728
                ],
                [
                    86.3685711,
                    55.1479261
                ],
                [
                    86.3691443,
                    55.1459789
                ],
                [
                    86.3631098,
                    55.1452873
                ],
                [
                    86.3563008,
                    55.1450023
                ],
                [
                    86.3481997,
                    55.1424682
                ],
                [
                    86.3458507,
                    55.143428
                ],
                [
                    86.3456967,
                    55.1444855
                ]
            ],
            "longitude": 86.375137,
            "latitude": 55.165092
        },
        "1186": {
            "name": "Панфилово",
            "population": 1443,
            "type": "village",
            "poly": [
                [
                    86.3664884,
                    54.9568572
                ],
                [
                    86.3699673,
                    54.9588496
                ],
                [
                    86.375396,
                    54.9606887
                ],
                [
                    86.3764562,
                    54.9587739
                ],
                [
                    86.3841513,
                    54.9568202
                ],
                [
                    86.3859918,
                    54.9544932
                ],
                [
                    86.3894265,
                    54.9531321
                ],
                [
                    86.3896386,
                    54.9513137
                ],
                [
                    86.3849393,
                    54.951284
                ],
                [
                    86.3848893,
                    54.9509848
                ],
                [
                    86.3843968,
                    54.948043
                ],
                [
                    86.3843611,
                    54.9459538
                ],
                [
                    86.3879835,
                    54.9435605
                ],
                [
                    86.3830732,
                    54.9395415
                ],
                [
                    86.3781181,
                    54.9394572
                ],
                [
                    86.3743259,
                    54.9357683
                ],
                [
                    86.3680313,
                    54.9368457
                ],
                [
                    86.369867,
                    54.9389313
                ],
                [
                    86.3690611,
                    54.9401106
                ],
                [
                    86.3740232,
                    54.9435016
                ],
                [
                    86.374079,
                    54.9459268
                ],
                [
                    86.3734231,
                    54.9480519
                ],
                [
                    86.3734037,
                    54.9527046
                ],
                [
                    86.3710597,
                    54.9552536
                ],
                [
                    86.3664884,
                    54.9568572
                ]
            ],
            "longitude": 86.380577,
            "latitude": 54.946575
        },
        "1187": {
            "name": "Марьевка",
            "population": 533,
            "type": "village",
            "poly": [
                [
                    86.3700091,
                    56.3032491
                ],
                [
                    86.3762925,
                    56.3050859
                ],
                [
                    86.3774415,
                    56.3057142
                ],
                [
                    86.3785167,
                    56.3061095
                ],
                [
                    86.3788598,
                    56.306423
                ],
                [
                    86.3787209,
                    56.3072241
                ],
                [
                    86.3791917,
                    56.3075734
                ],
                [
                    86.3808984,
                    56.3045669
                ],
                [
                    86.381931,
                    56.304709
                ],
                [
                    86.3817574,
                    56.3051264
                ],
                [
                    86.3834851,
                    56.3054749
                ],
                [
                    86.3841381,
                    56.3041954
                ],
                [
                    86.3844853,
                    56.3042734
                ],
                [
                    86.3849565,
                    56.3032598
                ],
                [
                    86.3848077,
                    56.3027645
                ],
                [
                    86.3819641,
                    56.3025902
                ],
                [
                    86.3835712,
                    56.3002591
                ],
                [
                    86.3867338,
                    56.300792
                ],
                [
                    86.391054,
                    56.3008445
                ],
                [
                    86.3972347,
                    56.2978526
                ],
                [
                    86.3976131,
                    56.2913254
                ],
                [
                    86.3991898,
                    56.2902928
                ],
                [
                    86.39796,
                    56.2884377
                ],
                [
                    86.39796,
                    56.2873526
                ],
                [
                    86.3985276,
                    56.2865474
                ],
                [
                    86.4006404,
                    56.2856723
                ],
                [
                    86.3995682,
                    56.284202
                ],
                [
                    86.3983699,
                    56.2841495
                ],
                [
                    86.3964462,
                    56.2847621
                ],
                [
                    86.396131,
                    56.2855148
                ],
                [
                    86.3978654,
                    56.2865999
                ],
                [
                    86.3975816,
                    56.2867575
                ],
                [
                    86.3961941,
                    56.2861799
                ],
                [
                    86.3951534,
                    56.2850597
                ],
                [
                    86.3932614,
                    56.2853922
                ],
                [
                    86.3929776,
                    56.2848321
                ],
                [
                    86.3912747,
                    56.2847971
                ],
                [
                    86.3912432,
                    56.2860048
                ],
                [
                    86.3926307,
                    56.2860924
                ],
                [
                    86.3918738,
                    56.2874051
                ],
                [
                    86.3925849,
                    56.2891916
                ],
                [
                    86.3915378,
                    56.2913109
                ],
                [
                    86.3906756,
                    56.291892
                ],
                [
                    86.3881504,
                    56.2913451
                ],
                [
                    86.3861795,
                    56.2920971
                ],
                [
                    86.3834695,
                    56.2915843
                ],
                [
                    86.378727,
                    56.2914476
                ],
                [
                    86.3778648,
                    56.2932592
                ],
                [
                    86.3700091,
                    56.3032491
                ]
            ],
            "longitude": 86.3888646,
            "latitude": 56.2976015
        },
        "1188": {
            "name": "Зелёновский",
            "population": 797,
            "type": "village",
            "poly": [
                [
                    86.3796008,
                    54.9991898
                ],
                [
                    86.3799904,
                    54.9997451
                ],
                [
                    86.3797779,
                    54.9997722
                ],
                [
                    86.3800022,
                    55.0000635
                ],
                [
                    86.3801439,
                    55.0000161
                ],
                [
                    86.3806045,
                    55.0011268
                ],
                [
                    86.3815609,
                    55.0018379
                ],
                [
                    86.3818916,
                    55.0020953
                ],
                [
                    86.3826001,
                    55.0030638
                ],
                [
                    86.3836392,
                    55.0038155
                ],
                [
                    86.3836038,
                    55.0042896
                ],
                [
                    86.3830488,
                    55.0043844
                ],
                [
                    86.3832023,
                    55.0046146
                ],
                [
                    86.3838753,
                    55.004574
                ],
                [
                    86.3841588,
                    55.0049397
                ],
                [
                    86.3832259,
                    55.0052986
                ],
                [
                    86.3838636,
                    55.0060368
                ],
                [
                    86.3837927,
                    55.0065311
                ],
                [
                    86.3843359,
                    55.0069103
                ],
                [
                    86.3847137,
                    55.0071338
                ],
                [
                    86.3847964,
                    55.0077703
                ],
                [
                    86.3855758,
                    55.0083256
                ],
                [
                    86.386733,
                    55.0080547
                ],
                [
                    86.3874178,
                    55.0085897
                ],
                [
                    86.3883389,
                    55.0090095
                ],
                [
                    86.3887876,
                    55.0093142
                ],
                [
                    86.3913028,
                    55.0089283
                ],
                [
                    86.3913264,
                    55.0084475
                ],
                [
                    86.3927316,
                    55.0072963
                ],
                [
                    86.394739,
                    55.0069577
                ],
                [
                    86.3953985,
                    55.0072419
                ],
                [
                    86.3962399,
                    55.0071935
                ],
                [
                    86.3965123,
                    55.0070732
                ],
                [
                    86.3965999,
                    55.0067115
                ],
                [
                    86.3964007,
                    55.0051866
                ],
                [
                    86.396089,
                    55.0038755
                ],
                [
                    86.3956733,
                    55.0030682
                ],
                [
                    86.3939541,
                    55.0031116
                ],
                [
                    86.3937368,
                    55.0020822
                ],
                [
                    86.3930566,
                    55.000538
                ],
                [
                    86.3925276,
                    54.999942
                ],
                [
                    86.3924993,
                    54.9990588
                ],
                [
                    86.3922348,
                    54.9981701
                ],
                [
                    86.3923292,
                    54.9971026
                ],
                [
                    86.3926599,
                    54.9967775
                ],
                [
                    86.3925276,
                    54.9960406
                ],
                [
                    86.3926788,
                    54.9954174
                ],
                [
                    86.3928378,
                    54.9952409
                ],
                [
                    86.3916806,
                    54.9941367
                ],
                [
                    86.3907596,
                    54.9938658
                ],
                [
                    86.3908186,
                    54.9931816
                ],
                [
                    86.3913618,
                    54.9924567
                ],
                [
                    86.3921766,
                    54.9918945
                ],
                [
                    86.3931094,
                    54.9918335
                ],
                [
                    86.393074,
                    54.9915083
                ],
                [
                    86.3932984,
                    54.9912238
                ],
                [
                    86.3929795,
                    54.9907361
                ],
                [
                    86.3911256,
                    54.9895708
                ],
                [
                    86.3907005,
                    54.9890424
                ],
                [
                    86.3896496,
                    54.989266
                ],
                [
                    86.3887048,
                    54.9897673
                ],
                [
                    86.3901456,
                    54.9905938
                ],
                [
                    86.3904644,
                    54.9909054
                ],
                [
                    86.3878075,
                    54.9915354
                ],
                [
                    86.3875241,
                    54.991068
                ],
                [
                    86.3848082,
                    54.9914541
                ],
                [
                    86.3840171,
                    54.9920774
                ],
                [
                    86.3868392,
                    54.9961959
                ],
                [
                    86.3839698,
                    54.9963179
                ],
                [
                    86.3822104,
                    54.9965143
                ],
                [
                    86.3815846,
                    54.9967581
                ],
                [
                    86.3810296,
                    54.9970697
                ],
                [
                    86.3808879,
                    54.9974965
                ],
                [
                    86.3816082,
                    54.9988376
                ],
                [
                    86.3796008,
                    54.9991898
                ]
            ],
            "longitude": 86.389099,
            "latitude": 55.003395
        },
        "1189": {
            "name": "Вишнёвка",
            "population": 737,
            "type": "village",
            "poly": [
                [
                    86.3804991,
                    54.4109386
                ],
                [
                    86.3846472,
                    54.411702
                ],
                [
                    86.3858456,
                    54.4121312
                ],
                [
                    86.3904241,
                    54.4143754
                ],
                [
                    86.4022605,
                    54.4201495
                ],
                [
                    86.4065844,
                    54.417076
                ],
                [
                    86.4068534,
                    54.4163831
                ],
                [
                    86.4041261,
                    54.4152878
                ],
                [
                    86.4140134,
                    54.4112594
                ],
                [
                    86.4106525,
                    54.4030856
                ],
                [
                    86.4032705,
                    54.3977054
                ],
                [
                    86.3959485,
                    54.401531
                ],
                [
                    86.4001196,
                    54.4042908
                ],
                [
                    86.3995075,
                    54.4072635
                ],
                [
                    86.3916573,
                    54.4069841
                ],
                [
                    86.3884164,
                    54.4076128
                ],
                [
                    86.3804991,
                    54.4109386
                ]
            ],
            "longitude": 86.399742,
            "latitude": 54.412445
        },
        "1190": {
            "name": "Трудармейский",
            "population": 4769,
            "type": "village",
            "poly": null,
            "longitude": 86.408707,
            "latitude": 54.129562
        },
        "1191": {
            "name": "Старопестерево",
            "population": 3286,
            "type": "village",
            "poly": null,
            "longitude": 86.417503,
            "latitude": 54.501209
        },
        "1192": {
            "name": "Коротково",
            "population": 389,
            "type": "village",
            "poly": [
                [
                    86.4288906,
                    54.4609436
                ],
                [
                    86.4300234,
                    54.4618606
                ],
                [
                    86.4334977,
                    54.4632543
                ],
                [
                    86.4365708,
                    54.4651926
                ],
                [
                    86.4401725,
                    54.4663069
                ],
                [
                    86.4416547,
                    54.4660606
                ],
                [
                    86.443973,
                    54.4646685
                ],
                [
                    86.4499217,
                    54.4619919
                ],
                [
                    86.4497748,
                    54.4608901
                ],
                [
                    86.4397727,
                    54.4584777
                ],
                [
                    86.4356697,
                    54.4562631
                ],
                [
                    86.4289254,
                    54.4581924
                ],
                [
                    86.4288906,
                    54.4609436
                ]
            ],
            "longitude": 86.438202,
            "latitude": 54.460793
        },
        "1193": {
            "name": "Яя-Борик",
            "population": 444,
            "type": "village",
            "poly": [
                [
                    86.4397156,
                    56.2830892
                ],
                [
                    86.4426484,
                    56.2847871
                ],
                [
                    86.4448873,
                    56.2844195
                ],
                [
                    86.4473155,
                    56.2836144
                ],
                [
                    86.4515095,
                    56.2808311
                ],
                [
                    86.4756333,
                    56.2789055
                ],
                [
                    86.4759171,
                    56.2753515
                ],
                [
                    86.474498,
                    56.273233
                ],
                [
                    86.4730474,
                    56.2721474
                ],
                [
                    86.4708716,
                    56.2701863
                ],
                [
                    86.4711554,
                    56.2695034
                ],
                [
                    86.4698625,
                    56.2680675
                ],
                [
                    86.4689795,
                    56.2663864
                ],
                [
                    86.4652269,
                    56.2642499
                ],
                [
                    86.4620105,
                    56.2634443
                ],
                [
                    86.4613482,
                    56.2626036
                ],
                [
                    86.4596138,
                    56.2624635
                ],
                [
                    86.4595192,
                    56.263094
                ],
                [
                    86.4589832,
                    56.2635844
                ],
                [
                    86.4593616,
                    56.2642674
                ],
                [
                    86.4582263,
                    56.2685403
                ],
                [
                    86.4524871,
                    56.2727778
                ],
                [
                    86.4503742,
                    56.2748788
                ],
                [
                    86.4481038,
                    56.2756141
                ],
                [
                    86.4420176,
                    56.2799908
                ],
                [
                    86.4399049,
                    56.2806736
                ],
                [
                    86.4397156,
                    56.2830892
                ]
            ],
            "longitude": 86.4572598,
            "latitude": 56.2733039
        },
        "1194": {
            "name": "Верх-Чумыш",
            "population": 345,
            "type": "village",
            "poly": null,
            "longitude": 86.4657558,
            "latitude": 53.9621039
        },
        "1195": {
            "name": "Новониколаевка",
            "population": 588,
            "type": "village",
            "poly": [
                [
                    86.4492011,
                    56.1641148
                ],
                [
                    86.4494077,
                    56.1643852
                ],
                [
                    86.4509887,
                    56.1646671
                ],
                [
                    86.4526317,
                    56.1651792
                ],
                [
                    86.4526627,
                    56.1653058
                ],
                [
                    86.4528797,
                    56.1655014
                ],
                [
                    86.4533757,
                    56.1655704
                ],
                [
                    86.4544193,
                    56.1658524
                ],
                [
                    86.4538819,
                    56.1662839
                ],
                [
                    86.4536133,
                    56.1663241
                ],
                [
                    86.4533447,
                    56.1664565
                ],
                [
                    86.4522287,
                    56.1677682
                ],
                [
                    86.4515467,
                    56.1680213
                ],
                [
                    86.4512264,
                    56.1682342
                ],
                [
                    86.4503377,
                    56.1684471
                ],
                [
                    86.4493561,
                    56.1695401
                ],
                [
                    86.4501621,
                    56.1698508
                ],
                [
                    86.4512884,
                    56.1705411
                ],
                [
                    86.4521874,
                    56.1709495
                ],
                [
                    86.4527454,
                    56.1710876
                ],
                [
                    86.4536442,
                    56.1713637
                ],
                [
                    86.454626,
                    56.1718584
                ],
                [
                    86.4562896,
                    56.1723244
                ],
                [
                    86.4578809,
                    56.1726523
                ],
                [
                    86.4626342,
                    56.1741364
                ],
                [
                    86.4632438,
                    56.1744125
                ],
                [
                    86.4648765,
                    56.1746598
                ],
                [
                    86.4655481,
                    56.1746713
                ],
                [
                    86.4657755,
                    56.1748209
                ],
                [
                    86.4653208,
                    56.1754881
                ],
                [
                    86.4677181,
                    56.1761553
                ],
                [
                    86.4679248,
                    56.176742
                ],
                [
                    86.469454,
                    56.1771619
                ],
                [
                    86.4713553,
                    56.1775357
                ],
                [
                    86.474476,
                    56.1772137
                ],
                [
                    86.4764496,
                    56.1780937
                ],
                [
                    86.475561,
                    56.1786515
                ],
                [
                    86.4784956,
                    56.1788413
                ],
                [
                    86.4784791,
                    56.1770502
                ],
                [
                    86.4783166,
                    56.176633
                ],
                [
                    86.4783946,
                    56.1765426
                ],
                [
                    86.478679,
                    56.17665
                ],
                [
                    86.479921,
                    56.1760591
                ],
                [
                    86.4815847,
                    56.1756104
                ],
                [
                    86.4843643,
                    56.1753171
                ],
                [
                    86.4844263,
                    56.175225
                ],
                [
                    86.4856766,
                    56.1754551
                ],
                [
                    86.4858522,
                    56.1753343
                ],
                [
                    86.4853976,
                    56.1745693
                ],
                [
                    86.4859039,
                    56.1741436
                ],
                [
                    86.4861312,
                    56.1738618
                ],
                [
                    86.4861385,
                    56.1713295
                ],
                [
                    86.4858299,
                    56.1699282
                ],
                [
                    86.4847035,
                    56.1693883
                ],
                [
                    86.4824481,
                    56.1677276
                ],
                [
                    86.4771136,
                    56.166239
                ],
                [
                    86.477527,
                    56.1656637
                ],
                [
                    86.4776174,
                    56.16534
                ],
                [
                    86.4770749,
                    56.1650524
                ],
                [
                    86.4766099,
                    56.1647287
                ],
                [
                    86.4755766,
                    56.164441
                ],
                [
                    86.4741299,
                    56.1642325
                ],
                [
                    86.4730837,
                    56.1654479
                ],
                [
                    86.463657,
                    56.162423
                ],
                [
                    86.4624402,
                    56.1623346
                ],
                [
                    86.4593716,
                    56.1617085
                ],
                [
                    86.4579895,
                    56.161657
                ],
                [
                    86.4566338,
                    56.1617417
                ],
                [
                    86.4569181,
                    56.1628575
                ],
                [
                    86.4562568,
                    56.1628685
                ],
                [
                    86.4560518,
                    56.1631189
                ],
                [
                    86.455741,
                    56.1629127
                ],
                [
                    86.4555558,
                    56.1630085
                ],
                [
                    86.454167,
                    56.1621063
                ],
                [
                    86.4542001,
                    56.1614544
                ],
                [
                    86.4540745,
                    56.16081
                ],
                [
                    86.453929,
                    56.1603312
                ],
                [
                    86.453261,
                    56.1597825
                ],
                [
                    86.45256,
                    56.1598341
                ],
                [
                    86.4516011,
                    56.1600808
                ],
                [
                    86.4499346,
                    56.1610715
                ],
                [
                    86.4495094,
                    56.1618526
                ],
                [
                    86.4492011,
                    56.1641148
                ]
            ],
            "longitude": 86.4667718,
            "latitude": 56.1700024
        },
        "1196": {
            "name": "Бекет",
            "population": 260,
            "type": "village",
            "poly": [
                [
                    86.4555945,
                    56.3612731
                ],
                [
                    86.4570476,
                    56.3621138
                ],
                [
                    86.457758,
                    56.3626415
                ],
                [
                    86.4582262,
                    56.3634017
                ],
                [
                    86.4597439,
                    56.3642781
                ],
                [
                    86.4598731,
                    56.3648058
                ],
                [
                    86.4596793,
                    56.3651724
                ],
                [
                    86.4601475,
                    56.3655212
                ],
                [
                    86.4605027,
                    56.3658342
                ],
                [
                    86.4616491,
                    56.3660757
                ],
                [
                    86.462086,
                    56.3658931
                ],
                [
                    86.4624233,
                    56.3655451
                ],
                [
                    86.4623505,
                    56.3653986
                ],
                [
                    86.4630382,
                    56.3651972
                ],
                [
                    86.4636335,
                    56.3647906
                ],
                [
                    86.463779,
                    56.3642448
                ],
                [
                    86.4631838,
                    56.3636513
                ],
                [
                    86.4633293,
                    56.3635231
                ],
                [
                    86.4665367,
                    56.3634572
                ],
                [
                    86.4666558,
                    56.3632594
                ],
                [
                    86.4676015,
                    56.3633253
                ],
                [
                    86.4698961,
                    56.3634095
                ],
                [
                    86.4706832,
                    56.363296
                ],
                [
                    86.4733813,
                    56.3632813
                ],
                [
                    86.4739766,
                    56.3627538
                ],
                [
                    86.4753257,
                    56.3627831
                ],
                [
                    86.4756564,
                    56.3624424
                ],
                [
                    86.4764301,
                    56.3622593
                ],
                [
                    86.4771906,
                    56.3626366
                ],
                [
                    86.4773626,
                    56.3631714
                ],
                [
                    86.4786984,
                    56.3635011
                ],
                [
                    86.4800674,
                    56.3633656
                ],
                [
                    86.4807221,
                    56.3635488
                ],
                [
                    86.4812842,
                    56.3635378
                ],
                [
                    86.4819654,
                    56.3634095
                ],
                [
                    86.4824151,
                    56.3630945
                ],
                [
                    86.4814032,
                    56.3627905
                ],
                [
                    86.4813569,
                    56.3623252
                ],
                [
                    86.4810263,
                    56.3621018
                ],
                [
                    86.4812115,
                    56.3619662
                ],
                [
                    86.4830632,
                    56.3619809
                ],
                [
                    86.4833409,
                    56.3618343
                ],
                [
                    86.4829441,
                    56.3612922
                ],
                [
                    86.4825143,
                    56.3612885
                ],
                [
                    86.4824481,
                    56.3611017
                ],
                [
                    86.4819257,
                    56.3604312
                ],
                [
                    86.4810527,
                    56.3602554
                ],
                [
                    86.4819323,
                    56.3598414
                ],
                [
                    86.4824204,
                    56.3597496
                ],
                [
                    86.4828442,
                    56.3596154
                ],
                [
                    86.4825213,
                    56.3589446
                ],
                [
                    86.4816534,
                    56.3582961
                ],
                [
                    86.4800995,
                    56.3572675
                ],
                [
                    86.4791307,
                    56.3572116
                ],
                [
                    86.4780409,
                    56.3566301
                ],
                [
                    86.478162,
                    56.3563283
                ],
                [
                    86.4755989,
                    56.3552772
                ],
                [
                    86.4748724,
                    56.3558363
                ],
                [
                    86.472955,
                    56.3561941
                ],
                [
                    86.472955,
                    56.3566861
                ],
                [
                    86.4736817,
                    56.3580613
                ],
                [
                    86.4735807,
                    56.3585756
                ],
                [
                    86.4741458,
                    56.3600514
                ],
                [
                    86.4740449,
                    56.3602527
                ],
                [
                    86.4713809,
                    56.3602639
                ],
                [
                    86.4709369,
                    56.3599396
                ],
                [
                    86.4701498,
                    56.3599173
                ],
                [
                    86.4695444,
                    56.3602303
                ],
                [
                    86.4672436,
                    56.3602192
                ],
                [
                    86.4660932,
                    56.3603757
                ],
                [
                    86.4651042,
                    56.3609235
                ],
                [
                    86.4631428,
                    56.3606445
                ],
                [
                    86.4624074,
                    56.3602137
                ],
                [
                    86.4615683,
                    56.3603429
                ],
                [
                    86.4606319,
                    56.3604413
                ],
                [
                    86.4601314,
                    56.3602266
                ],
                [
                    86.4598731,
                    56.3601998
                ],
                [
                    86.4594694,
                    56.3603161
                ],
                [
                    86.4581132,
                    56.3600657
                ],
                [
                    86.4579195,
                    56.359851
                ],
                [
                    86.4571282,
                    56.3595737
                ],
                [
                    86.4563533,
                    56.3597705
                ],
                [
                    86.4557398,
                    56.3603876
                ],
                [
                    86.4561434,
                    56.3604681
                ],
                [
                    86.4555945,
                    56.3612731
                ]
            ],
            "longitude": 86.4741505,
            "latitude": 56.3612716
        },
        "1197": {
            "name": "Плотниковский",
            "population": 351,
            "type": "village",
            "poly": [
                [
                    86.4732453,
                    55.0114895
                ],
                [
                    86.4761926,
                    55.0134611
                ],
                [
                    86.4749079,
                    55.0140678
                ],
                [
                    86.4756919,
                    55.015059
                ],
                [
                    86.4758242,
                    55.0156385
                ],
                [
                    86.4770334,
                    55.0161151
                ],
                [
                    86.4793289,
                    55.0173879
                ],
                [
                    86.481615,
                    55.0175721
                ],
                [
                    86.4835704,
                    55.0170251
                ],
                [
                    86.4875474,
                    55.0165809
                ],
                [
                    86.491789,
                    55.0157089
                ],
                [
                    86.4907876,
                    55.0145823
                ],
                [
                    86.490098,
                    55.0140786
                ],
                [
                    86.4892478,
                    55.0126324
                ],
                [
                    86.4879159,
                    55.0122803
                ],
                [
                    86.4876136,
                    55.0116249
                ],
                [
                    86.4868767,
                    55.0106119
                ],
                [
                    86.4866311,
                    55.0105632
                ],
                [
                    86.4860549,
                    55.0092902
                ],
                [
                    86.4852897,
                    55.0089706
                ],
                [
                    86.4838727,
                    55.0086347
                ],
                [
                    86.4831264,
                    55.0093389
                ],
                [
                    86.4819456,
                    55.0099619
                ],
                [
                    86.4810293,
                    55.0101569
                ],
                [
                    86.4800563,
                    55.0101461
                ],
                [
                    86.4793572,
                    55.0099944
                ],
                [
                    86.4769011,
                    55.0099348
                ],
                [
                    86.4732453,
                    55.0114895
                ]
            ],
            "longitude": 86.481636,
            "latitude": 55.013847
        },
        "1198": {
            "name": "Менчереп",
            "population": 1108,
            "type": "village",
            "poly": [
                [
                    86.4705089,
                    54.4406055
                ],
                [
                    86.4744285,
                    54.4410819
                ],
                [
                    86.4772744,
                    54.4360755
                ],
                [
                    86.4805561,
                    54.4358611
                ],
                [
                    86.4823241,
                    54.4334843
                ],
                [
                    86.4802882,
                    54.428913
                ],
                [
                    86.4820179,
                    54.4287997
                ],
                [
                    86.4826609,
                    54.4272764
                ],
                [
                    86.4886937,
                    54.4264795
                ],
                [
                    86.4884659,
                    54.4252686
                ],
                [
                    86.4898416,
                    54.4208086
                ],
                [
                    86.4910538,
                    54.4164639
                ],
                [
                    86.4862358,
                    54.4156298
                ],
                [
                    86.4848492,
                    54.4146768
                ],
                [
                    86.4816968,
                    54.4156211
                ],
                [
                    86.4779449,
                    54.4160606
                ],
                [
                    86.4755885,
                    54.4192657
                ],
                [
                    86.474883,
                    54.4257509
                ],
                [
                    86.4723432,
                    54.4321119
                ],
                [
                    86.4717721,
                    54.4336658
                ],
                [
                    86.4707911,
                    54.4354767
                ],
                [
                    86.4705089,
                    54.4406055
                ]
            ],
            "longitude": 86.481743,
            "latitude": 54.42601
        },
        "1199": {
            "name": "Томское",
            "population": 7,
            "type": "village",
            "poly": null,
            "longitude": 86.491745,
            "latitude": 53.610046
        },
        "1200": {
            "name": "Новостройка",
            "population": 503,
            "type": "village",
            "poly": null,
            "longitude": 86.492264,
            "latitude": 53.864063
        },
        "1201": {
            "name": "Большой Керлегеш",
            "population": 1043,
            "type": "village",
            "poly": null,
            "longitude": 86.494141,
            "latitude": 53.895531
        },
        "1202": {
            "name": "Заринское",
            "population": 579,
            "type": "village",
            "poly": [
                [
                    86.4921909,
                    54.5984789
                ],
                [
                    86.4968644,
                    54.6010818
                ],
                [
                    86.4987527,
                    54.6012558
                ],
                [
                    86.5010743,
                    54.6037491
                ],
                [
                    86.5041214,
                    54.604122
                ],
                [
                    86.5079409,
                    54.6023819
                ],
                [
                    86.509694,
                    54.5997145
                ],
                [
                    86.5124684,
                    54.5999482
                ],
                [
                    86.5145433,
                    54.5990432
                ],
                [
                    86.5162665,
                    54.5972607
                ],
                [
                    86.5163459,
                    54.5956123
                ],
                [
                    86.5142494,
                    54.5927356
                ],
                [
                    86.5049754,
                    54.5889747
                ],
                [
                    86.502143,
                    54.5920319
                ],
                [
                    86.4979802,
                    54.5944935
                ],
                [
                    86.4942894,
                    54.5971041
                ],
                [
                    86.4921909,
                    54.5984789
                ]
            ],
            "longitude": 86.505211,
            "latitude": 54.596119
        },
        "1203": {
            "name": "Берёзовка",
            "population": 403,
            "type": "village",
            "poly": null,
            "longitude": 86.50972,
            "latitude": 55.114231
        },
        "1204": {
            "name": "Поморцево",
            "population": 517,
            "type": "village",
            "poly": [
                [
                    86.5106245,
                    54.3996484
                ],
                [
                    86.5111937,
                    54.4007122
                ],
                [
                    86.5120925,
                    54.4018631
                ],
                [
                    86.5132609,
                    54.4028571
                ],
                [
                    86.5148786,
                    54.4040255
                ],
                [
                    86.5162068,
                    54.4031683
                ],
                [
                    86.5162567,
                    54.4031361
                ],
                [
                    86.5175149,
                    54.4030838
                ],
                [
                    86.5185335,
                    54.4037465
                ],
                [
                    86.5207804,
                    54.4017236
                ],
                [
                    86.5202112,
                    54.4007471
                ],
                [
                    86.5209302,
                    54.4000844
                ],
                [
                    86.5215294,
                    54.3998228
                ],
                [
                    86.5222184,
                    54.3996833
                ],
                [
                    86.523237,
                    54.3997356
                ],
                [
                    86.5238062,
                    54.3996135
                ],
                [
                    86.5236264,
                    54.3990729
                ],
                [
                    86.5238661,
                    54.3985671
                ],
                [
                    86.5243754,
                    54.3981834
                ],
                [
                    86.5253341,
                    54.3980788
                ],
                [
                    86.5260231,
                    54.3976777
                ],
                [
                    86.5271316,
                    54.3977649
                ],
                [
                    86.5283299,
                    54.398602
                ],
                [
                    86.5308464,
                    54.3983404
                ],
                [
                    86.533303,
                    54.3970498
                ],
                [
                    86.5320447,
                    54.3955673
                ],
                [
                    86.5317451,
                    54.394015
                ],
                [
                    86.530427,
                    54.3933348
                ],
                [
                    86.5285096,
                    54.3917649
                ],
                [
                    86.5278805,
                    54.3900032
                ],
                [
                    86.5295881,
                    54.3888519
                ],
                [
                    86.5278505,
                    54.3875261
                ],
                [
                    86.5233868,
                    54.3866539
                ],
                [
                    86.5129912,
                    54.3912417
                ],
                [
                    86.5155077,
                    54.3949743
                ],
                [
                    86.517455,
                    54.3961603
                ],
                [
                    86.5106545,
                    54.398166
                ],
                [
                    86.5106245,
                    54.3996484
                ]
            ],
            "longitude": 86.521919,
            "latitude": 54.396828
        },
        "1205": {
            "name": "Колыон",
            "population": 697,
            "type": "village",
            "poly": [
                [
                    86.5351113,
                    56.479654
                ],
                [
                    86.5351352,
                    56.4840936
                ],
                [
                    86.5448559,
                    56.4840341
                ],
                [
                    86.5585247,
                    56.4838194
                ],
                [
                    86.5691726,
                    56.4826468
                ],
                [
                    86.5774577,
                    56.4801693
                ],
                [
                    86.5676771,
                    56.4767667
                ],
                [
                    86.5748854,
                    56.4674491
                ],
                [
                    86.5724029,
                    56.465896
                ],
                [
                    86.5645067,
                    56.4649872
                ],
                [
                    86.5579264,
                    56.4607734
                ],
                [
                    86.5561319,
                    56.4609717
                ],
                [
                    86.5406087,
                    56.4658464
                ],
                [
                    86.5449755,
                    56.4716291
                ],
                [
                    86.5351113,
                    56.479654
                ]
            ],
            "longitude": 86.552055,
            "latitude": 56.475079
        },
        "1206": {
            "name": "Карагайла",
            "population": 1150,
            "type": "village",
            "poly": null,
            "longitude": 86.555199,
            "latitude": 54.1721
        },
        "1207": {
            "name": "Борисово",
            "population": 1405,
            "type": "village",
            "poly": null,
            "longitude": 86.55851,
            "latitude": 54.808437
        },
        "1208": {
            "name": "Свободный",
            "population": 349,
            "type": "village",
            "poly": null,
            "longitude": 86.560562,
            "latitude": 53.879818
        },
        "1209": {
            "name": "Тихоновка",
            "population": 385,
            "type": "village",
            "poly": null,
            "longitude": 86.578629,
            "latitude": 54.235355
        },
        "1210": {
            "name": "Перехляй",
            "population": 881,
            "type": "village",
            "poly": [
                [
                    86.5424665,
                    54.8829667
                ],
                [
                    86.5456953,
                    54.8865433
                ],
                [
                    86.5478356,
                    54.8872013
                ],
                [
                    86.5486105,
                    54.886936
                ],
                [
                    86.5522637,
                    54.8873711
                ],
                [
                    86.552891,
                    54.887647
                ],
                [
                    86.5525588,
                    54.8882413
                ],
                [
                    86.5593855,
                    54.8887613
                ],
                [
                    86.5684816,
                    54.8881458
                ],
                [
                    86.5743119,
                    54.8879972
                ],
                [
                    86.5796441,
                    54.8876046
                ],
                [
                    86.580585,
                    54.8873499
                ],
                [
                    86.5816737,
                    54.8865115
                ],
                [
                    86.579515,
                    54.8849832
                ],
                [
                    86.579515,
                    54.8842509
                ],
                [
                    86.5786478,
                    54.8838901
                ],
                [
                    86.5798471,
                    54.8830835
                ],
                [
                    86.5809726,
                    54.8827757
                ],
                [
                    86.5813231,
                    54.882574
                ],
                [
                    86.5829836,
                    54.8819478
                ],
                [
                    86.5838693,
                    54.8820327
                ],
                [
                    86.5840169,
                    54.8815975
                ],
                [
                    86.5846442,
                    54.8811411
                ],
                [
                    86.5847364,
                    54.8813322
                ],
                [
                    86.5852161,
                    54.881226
                ],
                [
                    86.585456,
                    54.8809713
                ],
                [
                    86.5860649,
                    54.8806847
                ],
                [
                    86.5871534,
                    54.8799948
                ],
                [
                    86.588611,
                    54.8798887
                ],
                [
                    86.5892752,
                    54.8797082
                ],
                [
                    86.589755,
                    54.8789652
                ],
                [
                    86.5904192,
                    54.8788697
                ],
                [
                    86.5911018,
                    54.8785725
                ],
                [
                    86.5907144,
                    54.8781372
                ],
                [
                    86.5913417,
                    54.877787
                ],
                [
                    86.5927255,
                    54.876821
                ],
                [
                    86.5920797,
                    54.8767361
                ],
                [
                    86.5922642,
                    54.8755471
                ],
                [
                    86.5911387,
                    54.8741459
                ],
                [
                    86.5887955,
                    54.8736151
                ],
                [
                    86.5879468,
                    54.8727976
                ],
                [
                    86.5875225,
                    54.8721288
                ],
                [
                    86.5857143,
                    54.8726171
                ],
                [
                    86.5845335,
                    54.8725853
                ],
                [
                    86.5842198,
                    54.8722668
                ],
                [
                    86.5838139,
                    54.8722243
                ],
                [
                    86.5836294,
                    54.8724048
                ],
                [
                    86.5816552,
                    54.8726915
                ],
                [
                    86.5802899,
                    54.8731692
                ],
                [
                    86.5794965,
                    54.8734877
                ],
                [
                    86.5795334,
                    54.8740397
                ],
                [
                    86.5799762,
                    54.8744431
                ],
                [
                    86.5800316,
                    54.8748677
                ],
                [
                    86.5807327,
                    54.8759824
                ],
                [
                    86.5806958,
                    54.8765238
                ],
                [
                    86.580419,
                    54.8768634
                ],
                [
                    86.5801054,
                    54.8781266
                ],
                [
                    86.5806773,
                    54.8789758
                ],
                [
                    86.5794042,
                    54.8795065
                ],
                [
                    86.5780943,
                    54.8792199
                ],
                [
                    86.5776146,
                    54.879273
                ],
                [
                    86.5759909,
                    54.879825
                ],
                [
                    86.5723193,
                    54.879825
                ],
                [
                    86.5709909,
                    54.8799311
                ],
                [
                    86.5650129,
                    54.8783495
                ],
                [
                    86.5639613,
                    54.8785406
                ],
                [
                    86.5613044,
                    54.8785512
                ],
                [
                    86.5601051,
                    54.8783708
                ],
                [
                    86.5585922,
                    54.8786468
                ],
                [
                    86.5542563,
                    54.8787741
                ],
                [
                    86.5499574,
                    54.879549
                ],
                [
                    86.548426,
                    54.8805361
                ],
                [
                    86.5473374,
                    54.8816082
                ],
                [
                    86.5467655,
                    54.8825103
                ],
                [
                    86.5459721,
                    54.8830516
                ],
                [
                    86.5440163,
                    54.8832851
                ],
                [
                    86.5424665,
                    54.8829667
                ]
            ],
            "longitude": 86.581581,
            "latitude": 54.880028
        },
        "1211": {
            "name": "Смышляево",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 86.583237,
            "latitude": 53.823025
        },
        "1212": {
            "name": "Сидорёнково",
            "population": 500,
            "type": "village",
            "poly": [
                [
                    86.5765549,
                    54.3797303
                ],
                [
                    86.5811845,
                    54.3830597
                ],
                [
                    86.6017586,
                    54.3798734
                ],
                [
                    86.6057835,
                    54.3782971
                ],
                [
                    86.6095356,
                    54.3768683
                ],
                [
                    86.6108025,
                    54.3762022
                ],
                [
                    86.6124434,
                    54.3745209
                ],
                [
                    86.6020695,
                    54.3693549
                ],
                [
                    86.5972331,
                    54.3693037
                ],
                [
                    86.5957382,
                    54.3676644
                ],
                [
                    86.5899346,
                    54.3680742
                ],
                [
                    86.5847873,
                    54.3696999
                ],
                [
                    86.5831637,
                    54.3727869
                ],
                [
                    86.5818447,
                    54.373965
                ],
                [
                    86.5780328,
                    54.3765563
                ],
                [
                    86.5765549,
                    54.3797303
                ]
            ],
            "longitude": 86.600815,
            "latitude": 54.375546
        },
        "1213": {
            "name": "Новосафоновский",
            "population": 1468,
            "type": "village",
            "poly": null,
            "longitude": 86.605751,
            "latitude": 53.844315
        },
        "1214": {
            "name": "Верх-Егос",
            "population": 1039,
            "type": "village",
            "poly": null,
            "longitude": 86.606064,
            "latitude": 53.925385
        },
        "1215": {
            "name": "Карагайлинский",
            "population": 4245,
            "type": "village",
            "poly": null,
            "longitude": 86.611023,
            "latitude": 54.14595
        },
        "1216": {
            "name": "Ижморка 2-я",
            "population": 493,
            "type": "village",
            "poly": [
                [
                    86.6205751,
                    56.1642553
                ],
                [
                    86.6243283,
                    56.1679446
                ],
                [
                    86.6283131,
                    56.1679446
                ],
                [
                    86.6285449,
                    56.1686928
                ],
                [
                    86.6327152,
                    56.1687702
                ],
                [
                    86.635588,
                    56.1675835
                ],
                [
                    86.6385535,
                    56.1650809
                ],
                [
                    86.6400826,
                    56.1631975
                ],
                [
                    86.6434188,
                    56.1570821
                ],
                [
                    86.6386462,
                    56.1546821
                ],
                [
                    86.6349393,
                    56.1512238
                ],
                [
                    86.624977,
                    56.1518174
                ],
                [
                    86.6215945,
                    56.1553789
                ],
                [
                    86.6213628,
                    56.1622944
                ],
                [
                    86.6205751,
                    56.1642553
                ]
            ],
            "longitude": 86.631409,
            "latitude": 56.158791
        },
        "1217": {
            "name": "Тёплая Речка",
            "population": 388,
            "type": "village",
            "poly": [
                [
                    86.6474556,
                    56.3502818
                ],
                [
                    86.6484737,
                    56.3506848
                ],
                [
                    86.6478919,
                    56.3528205
                ],
                [
                    86.6484737,
                    56.3535055
                ],
                [
                    86.6512372,
                    56.3535055
                ],
                [
                    86.6526188,
                    56.3541502
                ],
                [
                    86.6571278,
                    56.3543919
                ],
                [
                    86.6581458,
                    56.3529817
                ],
                [
                    86.6600368,
                    56.352619
                ],
                [
                    86.6669455,
                    56.3475012
                ],
                [
                    86.6695636,
                    56.340569
                ],
                [
                    86.6636002,
                    56.3348852
                ],
                [
                    86.6584368,
                    56.3344014
                ],
                [
                    86.6554552,
                    56.3403674
                ],
                [
                    86.6551643,
                    56.34202
                ],
                [
                    86.6498554,
                    56.3452443
                ],
                [
                    86.6474556,
                    56.3502818
                ]
            ],
            "longitude": 86.658897,
            "latitude": 56.346031
        },
        "1218": {
            "name": "Коновалово",
            "population": 497,
            "type": "village",
            "poly": [
                [
                    86.6471382,
                    54.352197
                ],
                [
                    86.6472086,
                    54.355772
                ],
                [
                    86.6642016,
                    54.3596342
                ],
                [
                    86.6667399,
                    54.3587303
                ],
                [
                    86.6735201,
                    54.3523111
                ],
                [
                    86.6702062,
                    54.3506673
                ],
                [
                    86.6652592,
                    54.3524847
                ],
                [
                    86.6565086,
                    54.3482715
                ],
                [
                    86.6535495,
                    54.3487188
                ],
                [
                    86.6471382,
                    54.352197
                ]
            ],
            "longitude": 86.660156,
            "latitude": 54.354179
        },
        "1219": {
            "name": "Уроп",
            "population": 329,
            "type": "village",
            "poly": null,
            "longitude": 86.677559,
            "latitude": 54.52309
        },
        "1220": {
            "name": "Тараданово",
            "population": 860,
            "type": "village",
            "poly": null,
            "longitude": 86.679214,
            "latitude": 54.752506
        },
        "1221": {
            "name": "Бурлаки",
            "population": 955,
            "type": "village",
            "poly": null,
            "longitude": 86.689301,
            "latitude": 54.144283
        },
        "1222": {
            "name": "Почитанка",
            "population": 306,
            "type": "village",
            "poly": [
                [
                    86.6781113,
                    56.2853891
                ],
                [
                    86.6803165,
                    56.2874113
                ],
                [
                    86.683231,
                    56.2882824
                ],
                [
                    86.6871407,
                    56.2877141
                ],
                [
                    86.6911434,
                    56.2937068
                ],
                [
                    86.6999717,
                    56.2960662
                ],
                [
                    86.7099934,
                    56.2861125
                ],
                [
                    86.7093883,
                    56.278775
                ],
                [
                    86.7076662,
                    56.2772764
                ],
                [
                    86.7086436,
                    56.2759585
                ],
                [
                    86.7061303,
                    56.2756484
                ],
                [
                    86.7016197,
                    56.2789974
                ],
                [
                    86.6912513,
                    56.2828568
                ],
                [
                    86.6850029,
                    56.2804983
                ],
                [
                    86.6819559,
                    56.2827186
                ],
                [
                    86.6781577,
                    56.2839424
                ],
                [
                    86.6781113,
                    56.2853891
                ]
            ],
            "longitude": 86.698494,
            "latitude": 56.284737
        },
        "1223": {
            "name": "Евтино",
            "population": 941,
            "type": "village",
            "poly": [
                [
                    86.6872162,
                    54.3464897
                ],
                [
                    86.6901394,
                    54.3511783
                ],
                [
                    86.6914907,
                    54.3515025
                ],
                [
                    86.6932431,
                    54.3515733
                ],
                [
                    86.6938384,
                    54.3525919
                ],
                [
                    86.6940677,
                    54.3536225
                ],
                [
                    86.6944828,
                    54.3542304
                ],
                [
                    86.6942707,
                    54.3544584
                ],
                [
                    86.6942506,
                    54.3547432
                ],
                [
                    86.6943397,
                    54.3550977
                ],
                [
                    86.6947871,
                    54.3558387
                ],
                [
                    86.6894422,
                    54.3579517
                ],
                [
                    86.6875585,
                    54.3595021
                ],
                [
                    86.6880058,
                    54.3601332
                ],
                [
                    86.6894657,
                    54.3603253
                ],
                [
                    86.6903605,
                    54.3605997
                ],
                [
                    86.6918203,
                    54.3588847
                ],
                [
                    86.6945516,
                    54.3587749
                ],
                [
                    86.6966236,
                    54.360778
                ],
                [
                    86.6974478,
                    54.3612308
                ],
                [
                    86.6975419,
                    54.3619168
                ],
                [
                    86.6989782,
                    54.363124
                ],
                [
                    86.6991666,
                    54.3641392
                ],
                [
                    86.6997788,
                    54.3644547
                ],
                [
                    86.7017566,
                    54.3646605
                ],
                [
                    86.7031841,
                    54.3643209
                ],
                [
                    86.703655,
                    54.3637722
                ],
                [
                    86.7058919,
                    54.363635
                ],
                [
                    86.7067748,
                    54.3639608
                ],
                [
                    86.7076284,
                    54.3637036
                ],
                [
                    86.7077461,
                    54.3633778
                ],
                [
                    86.7089234,
                    54.3637208
                ],
                [
                    86.7091,
                    54.3633778
                ],
                [
                    86.7089823,
                    54.3630005
                ],
                [
                    86.7103361,
                    54.3624346
                ],
                [
                    86.7117195,
                    54.3626918
                ],
                [
                    86.7132498,
                    54.3619201
                ],
                [
                    86.7126907,
                    54.359845
                ],
                [
                    86.7120432,
                    54.3591762
                ],
                [
                    86.7119549,
                    54.3579414
                ],
                [
                    86.710395,
                    54.3565007
                ],
                [
                    86.7103067,
                    54.3553858
                ],
                [
                    86.709306,
                    54.3545625
                ],
                [
                    86.7091588,
                    54.3537907
                ],
                [
                    86.7094237,
                    54.3528301
                ],
                [
                    86.7093943,
                    54.3525042
                ],
                [
                    86.7089528,
                    54.352144
                ],
                [
                    86.7076578,
                    54.351029
                ],
                [
                    86.7051561,
                    54.3507203
                ],
                [
                    86.7038022,
                    54.3492278
                ],
                [
                    86.7039788,
                    54.3481128
                ],
                [
                    86.7033018,
                    54.3476325
                ],
                [
                    86.703449,
                    54.3469462
                ],
                [
                    86.7021245,
                    54.3471521
                ],
                [
                    86.701065,
                    54.3467061
                ],
                [
                    86.6999543,
                    54.3450958
                ],
                [
                    86.6872162,
                    54.3464897
                ]
            ],
            "longitude": 86.70076,
            "latitude": 54.354439
        },
        "1224": {
            "name": "Каменка",
            "population": 883,
            "type": "village",
            "poly": null,
            "longitude": 86.705849,
            "latitude": 54.799759
        },
        "1225": {
            "name": "Дунай-Ключ",
            "population": 288,
            "type": "village",
            "poly": null,
            "longitude": 86.707985,
            "latitude": 54.468292
        },
        "1226": {
            "name": "Новый Каракан",
            "population": 1290,
            "type": "village",
            "poly": [
                [
                    86.6973305,
                    54.3903421
                ],
                [
                    86.6981389,
                    54.3924863
                ],
                [
                    86.7092766,
                    54.396356
                ],
                [
                    86.7147556,
                    54.3966697
                ],
                [
                    86.717653,
                    54.3969912
                ],
                [
                    86.7237561,
                    54.3960222
                ],
                [
                    86.7260679,
                    54.392469
                ],
                [
                    86.7211669,
                    54.3920921
                ],
                [
                    86.7173756,
                    54.3916614
                ],
                [
                    86.7147051,
                    54.3910099
                ],
                [
                    86.7118239,
                    54.3887527
                ],
                [
                    86.7093307,
                    54.3848769
                ],
                [
                    86.7035281,
                    54.3834904
                ],
                [
                    86.7003844,
                    54.386681
                ],
                [
                    86.7018215,
                    54.3885639
                ],
                [
                    86.6973305,
                    54.3903421
                ]
            ],
            "longitude": 86.708687,
            "latitude": 54.393536
        },
        "1227": {
            "name": "Банново",
            "population": 820,
            "type": "village",
            "poly": [
                [
                    86.690942,
                    55.0873521
                ],
                [
                    86.6981176,
                    55.0929674
                ],
                [
                    86.7051098,
                    55.0961262
                ],
                [
                    86.7096832,
                    55.0979035
                ],
                [
                    86.7150781,
                    55.0912291
                ],
                [
                    86.7282037,
                    55.0964935
                ],
                [
                    86.7292891,
                    55.0894929
                ],
                [
                    86.7207272,
                    55.086111
                ],
                [
                    86.7190763,
                    55.0817448
                ],
                [
                    86.7104425,
                    55.0790116
                ],
                [
                    86.7062629,
                    55.0776884
                ],
                [
                    86.6941477,
                    55.0826446
                ],
                [
                    86.690942,
                    55.0873521
                ]
            ],
            "longitude": 86.711746,
            "latitude": 55.085411
        },
        "1228": {
            "name": "Севск",
            "population": 658,
            "type": "village",
            "poly": null,
            "longitude": 86.719025,
            "latitude": 54.054279
        },
        "1229": {
            "name": "Каменный",
            "population": 493,
            "type": "village",
            "poly": null,
            "longitude": 86.719566,
            "latitude": 54.955471
        },
        "1230": {
            "name": "Сары-Чумыш",
            "population": 514,
            "type": "village",
            "poly": null,
            "longitude": 86.720901,
            "latitude": 53.24052
        },
        "1231": {
            "name": "Индустрия",
            "population": 381,
            "type": "village",
            "poly": null,
            "longitude": 86.72274,
            "latitude": 53.830406
        },
        "1232": {
            "name": "Постниково",
            "population": 503,
            "type": "village",
            "poly": null,
            "longitude": 86.770088,
            "latitude": 56.243198
        },
        "1233": {
            "name": "Каракан",
            "population": 908,
            "type": "village",
            "poly": [
                [
                    86.7493605,
                    54.3887457
                ],
                [
                    86.7530809,
                    54.3921154
                ],
                [
                    86.7657576,
                    54.3946023
                ],
                [
                    86.7731983,
                    54.3951638
                ],
                [
                    86.7730605,
                    54.3972495
                ],
                [
                    86.7682092,
                    54.4026037
                ],
                [
                    86.7735885,
                    54.4034941
                ],
                [
                    86.7811901,
                    54.4050298
                ],
                [
                    86.7867018,
                    54.4018216
                ],
                [
                    86.7722338,
                    54.3809624
                ],
                [
                    86.7493605,
                    54.3887457
                ]
            ],
            "longitude": 86.771339,
            "latitude": 54.390175
        },
        "1234": {
            "name": "Октябрьский",
            "population": 537,
            "type": "village",
            "poly": null,
            "longitude": 86.78302,
            "latitude": 54.266342
        },
        "1235": {
            "name": "Новославянка",
            "population": 297,
            "type": "village",
            "poly": [
                [
                    86.7610739,
                    56.5253249
                ],
                [
                    86.7644538,
                    56.5269911
                ],
                [
                    86.7690671,
                    56.5301906
                ],
                [
                    86.7711345,
                    56.5315419
                ],
                [
                    86.7733669,
                    56.5325665
                ],
                [
                    86.7766906,
                    56.5342971
                ],
                [
                    86.7792292,
                    56.5367063
                ],
                [
                    86.7847064,
                    56.5393107
                ],
                [
                    86.7869496,
                    56.54157
                ],
                [
                    86.7900267,
                    56.5433192
                ],
                [
                    86.7930513,
                    56.5441588
                ],
                [
                    86.7952945,
                    56.5464178
                ],
                [
                    86.7971788,
                    56.5467476
                ],
                [
                    86.7971489,
                    56.5484458
                ],
                [
                    86.7980725,
                    56.5488922
                ],
                [
                    86.807853,
                    56.5461223
                ],
                [
                    86.8123993,
                    56.5385204
                ],
                [
                    86.808511,
                    56.5347932
                ],
                [
                    86.7840447,
                    56.5282118
                ],
                [
                    86.7843336,
                    56.5263501
                ],
                [
                    86.7835665,
                    56.5243249
                ],
                [
                    86.781012,
                    56.521005
                ],
                [
                    86.7683206,
                    56.5242255
                ],
                [
                    86.7673635,
                    56.5241833
                ],
                [
                    86.7656407,
                    56.5234019
                ],
                [
                    86.7636306,
                    56.5243628
                ],
                [
                    86.7625587,
                    56.5243628
                ],
                [
                    86.7620993,
                    56.5241516
                ],
                [
                    86.7611997,
                    56.5248379
                ],
                [
                    86.7610739,
                    56.5253249
                ]
            ],
            "longitude": 86.784912,
            "latitude": 56.534817
        },
        "1236": {
            "name": "Берёзово",
            "population": 365,
            "type": "village",
            "poly": null,
            "longitude": 86.795563,
            "latitude": 53.701546
        },
        "1237": {
            "name": "Инюшка",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 86.802017,
            "latitude": 54.606499
        },
        "1238": {
            "name": "Святославка",
            "population": 570,
            "type": "village",
            "poly": [
                [
                    86.7803246,
                    56.4363141
                ],
                [
                    86.7850565,
                    56.4418365
                ],
                [
                    86.8011797,
                    56.4446458
                ],
                [
                    86.8064957,
                    56.4440968
                ],
                [
                    86.8093582,
                    56.4440646
                ],
                [
                    86.820516,
                    56.4447427
                ],
                [
                    86.8271756,
                    56.4404156
                ],
                [
                    86.8218012,
                    56.4337625
                ],
                [
                    86.8007124,
                    56.4291434
                ],
                [
                    86.7989599,
                    56.4292727
                ],
                [
                    86.7859911,
                    56.4321152
                ],
                [
                    86.7803246,
                    56.4363141
                ]
            ],
            "longitude": 86.815193,
            "latitude": 56.44006
        },
        "1239": {
            "name": "Школьный",
            "population": 825,
            "type": "village",
            "poly": null,
            "longitude": 86.821915,
            "latitude": 54.003143
        },
        "1240": {
            "name": "Костенково",
            "population": 1688,
            "type": "village",
            "poly": null,
            "longitude": 86.827049,
            "latitude": 53.636299
        },
        "1241": {
            "name": "Междугорное",
            "population": 346,
            "type": "village",
            "poly": null,
            "longitude": 86.831528,
            "latitude": 54.930344
        },
        "1242": {
            "name": "Новый Свет",
            "population": 283,
            "type": "village",
            "poly": [
                [
                    86.8195044,
                    55.8203728
                ],
                [
                    86.8206201,
                    55.8333746
                ],
                [
                    86.8233392,
                    55.8332179
                ],
                [
                    86.8459288,
                    55.8291064
                ],
                [
                    86.849345,
                    55.8219787
                ],
                [
                    86.8482296,
                    55.8186493
                ],
                [
                    86.8364467,
                    55.8177484
                ],
                [
                    86.8326818,
                    55.8195894
                ],
                [
                    86.8221539,
                    55.8197461
                ],
                [
                    86.8195044,
                    55.8203728
                ]
            ],
            "longitude": 86.831627,
            "latitude": 55.826855
        },
        "1243": {
            "name": "Ключи",
            "population": 340,
            "type": "village",
            "poly": null,
            "longitude": 86.84819,
            "latitude": 54.7757
        },
        "1244": {
            "name": "Кольчегиз",
            "population": 446,
            "type": "village",
            "poly": null,
            "longitude": 86.866653,
            "latitude": 54.1213
        },
        "1245": {
            "name": "Терентьевская",
            "population": 964,
            "type": "village",
            "poly": [
                [
                    86.8627609,
                    54.0660015
                ],
                [
                    86.8721118,
                    54.0692039
                ],
                [
                    86.8742152,
                    54.0674526
                ],
                [
                    86.865461,
                    54.0638831
                ],
                [
                    86.8627609,
                    54.0660015
                ]
            ],
            "longitude": 86.868286,
            "latitude": 54.066822
        },
        "1246": {
            "name": "Арсеново",
            "population": 342,
            "type": "village",
            "poly": null,
            "longitude": 86.876198,
            "latitude": 54.803707
        },
        "1247": {
            "name": "Троицкое",
            "population": 699,
            "type": "village",
            "poly": [
                [
                    86.866769,
                    56.056093
                ],
                [
                    86.8695049,
                    56.0628808
                ],
                [
                    86.8712124,
                    56.0640702
                ],
                [
                    86.8703612,
                    56.064886
                ],
                [
                    86.8689499,
                    56.0657782
                ],
                [
                    86.8690964,
                    56.0680524
                ],
                [
                    86.8682288,
                    56.0709156
                ],
                [
                    86.8780837,
                    56.0717746
                ],
                [
                    86.8795492,
                    56.0718171
                ],
                [
                    86.8858285,
                    56.0705517
                ],
                [
                    86.8868727,
                    56.0699335
                ],
                [
                    86.8953665,
                    56.0649299
                ],
                [
                    86.9016772,
                    56.054085
                ],
                [
                    86.8992088,
                    56.0526852
                ],
                [
                    86.903599,
                    56.0486354
                ],
                [
                    86.902554,
                    56.0432689
                ],
                [
                    86.8929773,
                    56.0440597
                ],
                [
                    86.8907335,
                    56.0440627
                ],
                [
                    86.88613,
                    56.0466597
                ],
                [
                    86.8766791,
                    56.0461897
                ],
                [
                    86.8723768,
                    56.0491112
                ],
                [
                    86.8721712,
                    56.0529297
                ],
                [
                    86.869259,
                    56.0549807
                ],
                [
                    86.866769,
                    56.056093
                ]
            ],
            "longitude": 86.885109,
            "latitude": 56.058857
        },
        "1248": {
            "name": "Плодопитомник",
            "population": 463,
            "type": "village",
            "poly": null,
            "longitude": 86.888985,
            "latitude": 53.988255
        },
        "1249": {
            "name": "Соколово",
            "population": 388,
            "type": "village",
            "poly": null,
            "longitude": 86.896828,
            "latitude": 54.194633
        },
        "1250": {
            "name": "Шарап",
            "population": 795,
            "type": "village",
            "poly": null,
            "longitude": 86.902702,
            "latitude": 53.91296
        },
        "1251": {
            "name": "Лучшево",
            "population": 630,
            "type": "village",
            "poly": [
                [
                    86.8931448,
                    53.8419432
                ],
                [
                    86.8936169,
                    53.8432345
                ],
                [
                    86.8954622,
                    53.8439688
                ],
                [
                    86.8973913,
                    53.8441916
                ],
                [
                    86.8998825,
                    53.8457917
                ],
                [
                    86.903099,
                    53.8455841
                ],
                [
                    86.9037878,
                    53.8450575
                ],
                [
                    86.9098797,
                    53.8444448
                ],
                [
                    86.9104376,
                    53.8426218
                ],
                [
                    86.9088947,
                    53.8408797
                ],
                [
                    86.9102659,
                    53.8390008
                ],
                [
                    86.912712,
                    53.8372282
                ],
                [
                    86.9152033,
                    53.8325481
                ],
                [
                    86.9150329,
                    53.8317513
                ],
                [
                    86.9146454,
                    53.8299394
                ],
                [
                    86.9183361,
                    53.8263174
                ],
                [
                    86.907176,
                    53.8248685
                ],
                [
                    86.8980801,
                    53.826748
                ],
                [
                    86.8944323,
                    53.8294582
                ],
                [
                    86.8947756,
                    53.8309526
                ],
                [
                    86.8969214,
                    53.8318897
                ],
                [
                    86.8989384,
                    53.8342197
                ],
                [
                    86.901685,
                    53.8359164
                ],
                [
                    86.89752,
                    53.8381398
                ],
                [
                    86.8931448,
                    53.8419432
                ]
            ],
            "longitude": 86.9048769,
            "latitude": 53.8395088
        },
        "1252": {
            "name": "Пермяки",
            "population": 1553,
            "type": "village",
            "poly": null,
            "longitude": 86.912712,
            "latitude": 54.462101
        },
        "1253": {
            "name": "Котино",
            "population": 830,
            "type": "village",
            "poly": null,
            "longitude": 86.918686,
            "latitude": 54.246418
        },
        "1254": {
            "name": "Ясная Поляна",
            "population": 957,
            "type": "village",
            "poly": null,
            "longitude": 86.926056,
            "latitude": 53.98996
        },
        "1255": {
            "name": "Калачево",
            "population": 1843,
            "type": "village",
            "poly": [
                [
                    86.9070923,
                    53.7839453
                ],
                [
                    86.9125404,
                    53.7856377
                ],
                [
                    86.9160187,
                    53.787216
                ],
                [
                    86.9226277,
                    53.7895485
                ],
                [
                    86.9227993,
                    53.7909175
                ],
                [
                    86.9239151,
                    53.7921597
                ],
                [
                    86.9253741,
                    53.793047
                ],
                [
                    86.9276917,
                    53.7935793
                ],
                [
                    86.9271337,
                    53.7940863
                ],
                [
                    86.9284212,
                    53.7946947
                ],
                [
                    86.9302215,
                    53.7943842
                ],
                [
                    86.9310391,
                    53.7948215
                ],
                [
                    86.928977,
                    53.7960065
                ],
                [
                    86.9282925,
                    53.7959115
                ],
                [
                    86.9281208,
                    53.7964691
                ],
                [
                    86.9274341,
                    53.7970775
                ],
                [
                    86.9258034,
                    53.7973056
                ],
                [
                    86.9266617,
                    53.7978126
                ],
                [
                    86.9277775,
                    53.7975844
                ],
                [
                    86.931658,
                    53.7995141
                ],
                [
                    86.9325356,
                    53.7999444
                ],
                [
                    86.9339003,
                    53.8000407
                ],
                [
                    86.9350922,
                    53.8000711
                ],
                [
                    86.9369537,
                    53.8008093
                ],
                [
                    86.9367542,
                    53.8019042
                ],
                [
                    86.9336986,
                    53.8039146
                ],
                [
                    86.9359312,
                    53.8067454
                ],
                [
                    86.9501813,
                    53.8017122
                ],
                [
                    86.9507843,
                    53.8000679
                ],
                [
                    86.9444694,
                    53.7980597
                ],
                [
                    86.9410791,
                    53.7961079
                ],
                [
                    86.9403946,
                    53.7940863
                ],
                [
                    86.9422829,
                    53.7943145
                ],
                [
                    86.9429266,
                    53.7940103
                ],
                [
                    86.9424545,
                    53.7932751
                ],
                [
                    86.9449123,
                    53.7932703
                ],
                [
                    86.9488897,
                    53.7937758
                ],
                [
                    86.9518079,
                    53.7921787
                ],
                [
                    86.95387,
                    53.7919062
                ],
                [
                    86.9582023,
                    53.7900239
                ],
                [
                    86.9598353,
                    53.7894217
                ],
                [
                    86.9610797,
                    53.7894217
                ],
                [
                    86.9617235,
                    53.7887119
                ],
                [
                    86.9634401,
                    53.7876217
                ],
                [
                    86.9636097,
                    53.7869562
                ],
                [
                    86.9642554,
                    53.785999
                ],
                [
                    86.9650752,
                    53.7857661
                ],
                [
                    86.964999,
                    53.7851253
                ],
                [
                    86.9654979,
                    53.7845728
                ],
                [
                    86.9653949,
                    53.7841966
                ],
                [
                    86.9660043,
                    53.7838727
                ],
                [
                    86.9657017,
                    53.7832154
                ],
                [
                    86.9658938,
                    53.782797
                ],
                [
                    86.966927,
                    53.7828648
                ],
                [
                    86.9679407,
                    53.7834195
                ],
                [
                    86.9686329,
                    53.783152
                ],
                [
                    86.9681071,
                    53.7815862
                ],
                [
                    86.9685513,
                    53.7811627
                ],
                [
                    86.9693914,
                    53.781171
                ],
                [
                    86.9710436,
                    53.7824306
                ],
                [
                    86.9741743,
                    53.7814258
                ],
                [
                    86.9724094,
                    53.7803431
                ],
                [
                    86.9717067,
                    53.7798803
                ],
                [
                    86.9684215,
                    53.777889
                ],
                [
                    86.9652016,
                    53.7792601
                ],
                [
                    86.9633972,
                    53.7799976
                ],
                [
                    86.962909,
                    53.7806296
                ],
                [
                    86.9619692,
                    53.7808959
                ],
                [
                    86.9614735,
                    53.7811589
                ],
                [
                    86.9601321,
                    53.7813482
                ],
                [
                    86.9570701,
                    53.7802308
                ],
                [
                    86.9565189,
                    53.781571
                ],
                [
                    86.9597494,
                    53.7837171
                ],
                [
                    86.9596636,
                    53.7843256
                ],
                [
                    86.9597902,
                    53.7850546
                ],
                [
                    86.957947,
                    53.7856694
                ],
                [
                    86.9570436,
                    53.7861702
                ],
                [
                    86.9550717,
                    53.7848074
                ],
                [
                    86.9539559,
                    53.7853398
                ],
                [
                    86.9561016,
                    53.7863793
                ],
                [
                    86.9527092,
                    53.7866519
                ],
                [
                    86.950351,
                    53.78714
                ],
                [
                    86.9483769,
                    53.7870132
                ],
                [
                    86.9465631,
                    53.7864398
                ],
                [
                    86.9460615,
                    53.7865581
                ],
                [
                    86.9442591,
                    53.7860003
                ],
                [
                    86.9418558,
                    53.786051
                ],
                [
                    86.9399676,
                    53.7862031
                ],
                [
                    86.9389762,
                    53.7852828
                ],
                [
                    86.9381609,
                    53.7850292
                ],
                [
                    86.9340839,
                    53.7854095
                ],
                [
                    86.9341697,
                    53.7821386
                ],
                [
                    86.930994,
                    53.7815047
                ],
                [
                    86.9296229,
                    53.7819421
                ],
                [
                    86.9270909,
                    53.7811053
                ],
                [
                    86.9260158,
                    53.7813779
                ],
                [
                    86.9153728,
                    53.776509
                ],
                [
                    86.9124567,
                    53.7753995
                ],
                [
                    86.9115534,
                    53.7756468
                ],
                [
                    86.9105684,
                    53.7782652
                ],
                [
                    86.9070923,
                    53.7839453
                ]
            ],
            "longitude": 86.934181,
            "latitude": 53.788517
        },
        "1256": {
            "name": "Рассвет",
            "population": 829,
            "type": "village",
            "poly": null,
            "longitude": 86.935822,
            "latitude": 53.724277
        },
        "1257": {
            "name": "Воскресенка",
            "population": 272,
            "type": "village",
            "poly": [
                [
                    86.9324132,
                    56.139479
                ],
                [
                    86.9371838,
                    56.1421438
                ],
                [
                    86.938349,
                    56.1431072
                ],
                [
                    86.9447018,
                    56.1426016
                ],
                [
                    86.9556045,
                    56.1441184
                ],
                [
                    86.9596271,
                    56.1424854
                ],
                [
                    86.9664705,
                    56.1345382
                ],
                [
                    86.9612582,
                    56.1316268
                ],
                [
                    86.9430461,
                    56.1303692
                ],
                [
                    86.9381528,
                    56.1351465
                ],
                [
                    86.9324132,
                    56.139479
                ]
            ],
            "longitude": 86.946114,
            "latitude": 56.134521
        },
        "1258": {
            "name": "Терентьевское",
            "population": 2845,
            "type": "village",
            "poly": [
                [
                    86.9367426,
                    54.0899938
                ],
                [
                    86.9405117,
                    54.093657
                ],
                [
                    86.9444803,
                    54.093996
                ],
                [
                    86.9444803,
                    54.0956151
                ],
                [
                    86.942742,
                    54.097354
                ],
                [
                    86.9451961,
                    54.0982534
                ],
                [
                    86.944787,
                    54.0996925
                ],
                [
                    86.9412082,
                    54.0998124
                ],
                [
                    86.9416172,
                    54.1022707
                ],
                [
                    86.9449915,
                    54.104429
                ],
                [
                    86.944378,
                    54.1055081
                ],
                [
                    86.9391631,
                    54.106827
                ],
                [
                    86.9428442,
                    54.1114429
                ],
                [
                    86.9558305,
                    54.1111431
                ],
                [
                    86.9514334,
                    54.1067071
                ],
                [
                    86.9536831,
                    54.1034098
                ],
                [
                    86.9561372,
                    54.1034098
                ],
                [
                    86.9552169,
                    54.0981335
                ],
                [
                    86.9594093,
                    54.093876
                ],
                [
                    86.9526606,
                    54.0903378
                ],
                [
                    86.944378,
                    54.0877589
                ],
                [
                    86.9367426,
                    54.0899938
                ]
            ],
            "longitude": 86.946999,
            "latitude": 54.098316
        },
        "1259": {
            "name": "Красный Яр",
            "population": 697,
            "type": "village",
            "poly": [
                [
                    86.9201901,
                    55.8965958
                ],
                [
                    86.9251521,
                    55.8987774
                ],
                [
                    86.9211184,
                    55.9024798
                ],
                [
                    86.9217736,
                    55.9070479
                ],
                [
                    86.9310988,
                    55.9104185
                ],
                [
                    86.9365893,
                    55.9105162
                ],
                [
                    86.9408597,
                    55.9091484
                ],
                [
                    86.9435613,
                    55.9120304
                ],
                [
                    86.9504464,
                    55.9125188
                ],
                [
                    86.9567213,
                    55.9108092
                ],
                [
                    86.9599458,
                    55.9088065
                ],
                [
                    86.9604688,
                    55.9064616
                ],
                [
                    86.9613403,
                    55.906022
                ],
                [
                    86.9688353,
                    55.9061197
                ],
                [
                    86.9676152,
                    55.9027487
                ],
                [
                    86.9573313,
                    55.8973741
                ],
                [
                    86.9610788,
                    55.8909235
                ],
                [
                    86.9526252,
                    55.8902393
                ],
                [
                    86.9511436,
                    55.8918032
                ],
                [
                    86.9494877,
                    55.8920964
                ],
                [
                    86.9485289,
                    55.8946376
                ],
                [
                    86.9468732,
                    55.8952729
                ],
                [
                    86.9462631,
                    55.8971297
                ],
                [
                    86.9439972,
                    55.8982047
                ],
                [
                    86.9395525,
                    55.8978138
                ],
                [
                    86.9374608,
                    55.8994751
                ],
                [
                    86.9361536,
                    55.8995729
                ],
                [
                    86.9349335,
                    55.8982536
                ],
                [
                    86.9328984,
                    55.8977166
                ],
                [
                    86.9314705,
                    55.8974765
                ],
                [
                    86.9321845,
                    55.8965358
                ],
                [
                    86.9300784,
                    55.8962356
                ],
                [
                    86.9294715,
                    55.896856
                ],
                [
                    86.9284363,
                    55.8965558
                ],
                [
                    86.9285434,
                    55.8954149
                ],
                [
                    86.9262231,
                    55.8941139
                ],
                [
                    86.9253662,
                    55.8954149
                ],
                [
                    86.9242596,
                    55.8953949
                ],
                [
                    86.9241169,
                    55.8944141
                ],
                [
                    86.9229031,
                    55.8939137
                ],
                [
                    86.9222963,
                    55.894194
                ],
                [
                    86.922582,
                    55.8957152
                ],
                [
                    86.9212612,
                    55.8957552
                ],
                [
                    86.9201901,
                    55.8965958
                ]
            ],
            "longitude": 86.949387,
            "latitude": 55.903286
        },
        "1260": {
            "name": "Бунгур",
            "population": 581,
            "type": "village",
            "poly": null,
            "longitude": 86.986267,
            "latitude": 53.742912
        },
        "1261": {
            "name": "Каралда",
            "population": 522,
            "type": "village",
            "poly": null,
            "longitude": 86.989746,
            "latitude": 54.390499
        },
        "1262": {
            "name": "Бенжереп 1-й",
            "population": 498,
            "type": "village",
            "poly": null,
            "longitude": 86.997871,
            "latitude": 53.324463
        },
        "1263": {
            "name": "Загорский",
            "population": 1632,
            "type": "village",
            "poly": [
                [
                    87.0033202,
                    53.7592905
                ],
                [
                    87.0046076,
                    53.7596076
                ],
                [
                    87.0056805,
                    53.7601277
                ],
                [
                    87.0056376,
                    53.7606224
                ],
                [
                    87.006174,
                    53.7609776
                ],
                [
                    87.0066032,
                    53.7611932
                ],
                [
                    87.0101094,
                    53.7609915
                ],
                [
                    87.0104527,
                    53.7608647
                ],
                [
                    87.011032,
                    53.7608393
                ],
                [
                    87.0111608,
                    53.7611945
                ],
                [
                    87.0125255,
                    53.7614089
                ],
                [
                    87.0155382,
                    53.7613975
                ],
                [
                    87.0155382,
                    53.7586194
                ],
                [
                    87.0131134,
                    53.7586828
                ],
                [
                    87.013092,
                    53.7584038
                ],
                [
                    87.0144224,
                    53.7560569
                ],
                [
                    87.007808,
                    53.7544647
                ],
                [
                    87.0041655,
                    53.7575031
                ],
                [
                    87.0034146,
                    53.7581881
                ],
                [
                    87.0033202,
                    53.7592905
                ]
            ],
            "longitude": 87.008606,
            "latitude": 53.758934
        },
        "1264": {
            "name": "Северный",
            "population": 464,
            "type": "village",
            "poly": null,
            "longitude": 87.010345,
            "latitude": 53.935837
        },
        "1265": {
            "name": "Мир",
            "population": 572,
            "type": "village",
            "poly": [
                [
                    87.0018929,
                    53.7372146
                ],
                [
                    87.0107035,
                    53.7416071
                ],
                [
                    87.0192436,
                    53.7398304
                ],
                [
                    87.0123643,
                    53.7332545
                ],
                [
                    87.0045537,
                    53.7347015
                ],
                [
                    87.0018929,
                    53.7372146
                ]
            ],
            "longitude": 87.01107,
            "latitude": 53.737267
        },
        "1266": {
            "name": "Металлургов",
            "population": 3317,
            "type": "village",
            "poly": null,
            "longitude": 87.029922,
            "latitude": 53.899036
        },
        "1267": {
            "name": "Лыс",
            "population": 314,
            "type": "village",
            "poly": [
                [
                    87.0049357,
                    53.1566119
                ],
                [
                    87.0100946,
                    53.1565137
                ],
                [
                    87.0113229,
                    53.1550897
                ],
                [
                    87.0136977,
                    53.1551388
                ],
                [
                    87.0159087,
                    53.1565628
                ],
                [
                    87.0145165,
                    53.1578395
                ],
                [
                    87.0112411,
                    53.1594598
                ],
                [
                    87.0124694,
                    53.1607363
                ],
                [
                    87.0127151,
                    53.1625038
                ],
                [
                    87.0158268,
                    53.1616201
                ],
                [
                    87.0155811,
                    53.1596562
                ],
                [
                    87.0179559,
                    53.16108
                ],
                [
                    87.0192661,
                    53.1612764
                ],
                [
                    87.0200031,
                    53.159067
                ],
                [
                    87.0203307,
                    53.1602454
                ],
                [
                    87.0236881,
                    53.1610309
                ],
                [
                    87.0229511,
                    53.1623075
                ],
                [
                    87.0260629,
                    53.1628966
                ],
                [
                    87.0258991,
                    53.1649586
                ],
                [
                    87.0275369,
                    53.1637803
                ],
                [
                    87.0285195,
                    53.1613254
                ],
                [
                    87.0298296,
                    53.1627002
                ],
                [
                    87.0322864,
                    53.1643694
                ],
                [
                    87.0323683,
                    53.1599999
                ],
                [
                    87.038428,
                    53.161571
                ],
                [
                    87.0401477,
                    53.1611782
                ],
                [
                    87.0390831,
                    53.1601472
                ],
                [
                    87.0398201,
                    53.1592143
                ],
                [
                    87.0420311,
                    53.1574467
                ],
                [
                    87.0441601,
                    53.1576431
                ],
                [
                    87.0462893,
                    53.1599508
                ],
                [
                    87.0434232,
                    53.1613746
                ],
                [
                    87.0458799,
                    53.1632403
                ],
                [
                    87.0493192,
                    53.162062
                ],
                [
                    87.0515302,
                    53.1618165
                ],
                [
                    87.0516939,
                    53.1607854
                ],
                [
                    87.0534955,
                    53.1614237
                ],
                [
                    87.0548876,
                    53.162602
                ],
                [
                    87.0592276,
                    53.1622093
                ],
                [
                    87.057508,
                    53.1604418
                ],
                [
                    87.0574261,
                    53.1581341
                ],
                [
                    87.0588182,
                    53.1564646
                ],
                [
                    87.0586544,
                    53.1538621
                ],
                [
                    87.055297,
                    53.1526835
                ],
                [
                    87.0552151,
                    53.1516031
                ],
                [
                    87.0578356,
                    53.1482145
                ],
                [
                    87.052349,
                    53.1476743
                ],
                [
                    87.0534136,
                    53.1505719
                ],
                [
                    87.0520215,
                    53.1535183
                ],
                [
                    87.0509569,
                    53.1527817
                ],
                [
                    87.0515302,
                    53.1505719
                ],
                [
                    87.0498105,
                    53.1491477
                ],
                [
                    87.0495648,
                    53.1477725
                ],
                [
                    87.0505474,
                    53.1463482
                ],
                [
                    87.0485822,
                    53.1472814
                ],
                [
                    87.0462893,
                    53.1484601
                ],
                [
                    87.0458799,
                    53.1474778
                ],
                [
                    87.0449791,
                    53.1447274
                ],
                [
                    87.0417854,
                    53.142468
                ],
                [
                    87.040639,
                    53.1434012
                ],
                [
                    87.0396563,
                    53.1459553
                ],
                [
                    87.0370359,
                    53.1476252
                ],
                [
                    87.0356438,
                    53.1470849
                ],
                [
                    87.0307305,
                    53.145808
                ],
                [
                    87.0294203,
                    53.1456606
                ],
                [
                    87.0301573,
                    53.1434012
                ],
                [
                    87.0281101,
                    53.143745
                ],
                [
                    87.0273731,
                    53.1459553
                ],
                [
                    87.0242613,
                    53.1464464
                ],
                [
                    87.0231967,
                    53.145415
                ],
                [
                    87.020085,
                    53.1465447
                ],
                [
                    87.0220503,
                    53.1481654
                ],
                [
                    87.0240975,
                    53.1490494
                ],
                [
                    87.0224597,
                    53.1508174
                ],
                [
                    87.0209038,
                    53.1511121
                ],
                [
                    87.0157449,
                    53.1512103
                ],
                [
                    87.0108316,
                    53.1532237
                ],
                [
                    87.0072285,
                    53.1539603
                ],
                [
                    87.0049357,
                    53.1566119
                ]
            ],
            "longitude": 87.038979,
            "latitude": 53.153645
        },
        "1268": {
            "name": "Большая Талда",
            "population": 1239,
            "type": "village",
            "poly": null,
            "longitude": 87.058716,
            "latitude": 54.165207
        },
        "1269": {
            "name": "Берикуль",
            "population": 321,
            "type": "village",
            "poly": null,
            "longitude": 87.06189,
            "latitude": 56.209278
        },
        "1270": {
            "name": "Анисимово",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 87.063347,
            "latitude": 54.048965
        },
        "1271": {
            "name": "Кирсановка",
            "population": 317,
            "type": "village",
            "poly": [
                [
                    87.0467068,
                    56.4964834
                ],
                [
                    87.0467068,
                    56.4991816
                ],
                [
                    87.0474737,
                    56.4993054
                ],
                [
                    87.0478082,
                    56.4999369
                ],
                [
                    87.0469633,
                    56.5018896
                ],
                [
                    87.0496168,
                    56.5023092
                ],
                [
                    87.0476737,
                    56.5033323
                ],
                [
                    87.0624999,
                    56.5067711
                ],
                [
                    87.0627148,
                    56.5049628
                ],
                [
                    87.0600826,
                    56.5044589
                ],
                [
                    87.0599752,
                    56.5039252
                ],
                [
                    87.0626611,
                    56.5026504
                ],
                [
                    87.0665288,
                    56.5038067
                ],
                [
                    87.0672271,
                    56.5037177
                ],
                [
                    87.067818,
                    56.5024429
                ],
                [
                    87.0691609,
                    56.5024726
                ],
                [
                    87.0700205,
                    56.5031248
                ],
                [
                    87.0720618,
                    56.5033323
                ],
                [
                    87.0732436,
                    56.5031544
                ],
                [
                    87.0765741,
                    56.5043996
                ],
                [
                    87.077541,
                    56.5041624
                ],
                [
                    87.078884,
                    56.5049925
                ],
                [
                    87.0801195,
                    56.5040735
                ],
                [
                    87.0778096,
                    56.5029173
                ],
                [
                    87.0780245,
                    56.5025022
                ],
                [
                    87.0799583,
                    56.5014053
                ],
                [
                    87.0743179,
                    56.4999821
                ],
                [
                    87.0734584,
                    56.4991519
                ],
                [
                    87.0720618,
                    56.4991816
                ],
                [
                    87.0658842,
                    56.4981735
                ],
                [
                    87.0650784,
                    56.4972247
                ],
                [
                    87.063628,
                    56.4974619
                ],
                [
                    87.0620701,
                    56.4965427
                ],
                [
                    87.0618016,
                    56.4970764
                ],
                [
                    87.060781,
                    56.4970764
                ],
                [
                    87.0595454,
                    56.4965723
                ],
                [
                    87.0556777,
                    56.4966316
                ],
                [
                    87.0524546,
                    56.4961276
                ],
                [
                    87.0512191,
                    56.4955938
                ],
                [
                    87.0501448,
                    56.4955345
                ],
                [
                    87.0490167,
                    56.4969578
                ],
                [
                    87.0473514,
                    56.4963944
                ],
                [
                    87.0467068,
                    56.4964834
                ]
            ],
            "longitude": 87.063622,
            "latitude": 56.50074
        },
        "1272": {
            "name": "Красулино",
            "population": 1216,
            "type": "village",
            "poly": null,
            "longitude": 87.081032,
            "latitude": 54.025478
        },
        "1273": {
            "name": "Таргайский дом отдыха",
            "population": 342,
            "type": "village",
            "poly": null,
            "longitude": 87.1038436,
            "latitude": 53.5575721
        },
        "1274": {
            "name": "Степной",
            "population": 1681,
            "type": "village",
            "poly": null,
            "longitude": 87.118156,
            "latitude": 53.954166
        },
        "1275": {
            "name": "Малопесчанка",
            "population": 719,
            "type": "village",
            "poly": [
                [
                    87.1088704,
                    56.4351686
                ],
                [
                    87.1100421,
                    56.4358164
                ],
                [
                    87.1100634,
                    56.4366291
                ],
                [
                    87.109616,
                    56.4368293
                ],
                [
                    87.1096586,
                    56.438066
                ],
                [
                    87.1102765,
                    56.4383369
                ],
                [
                    87.11164,
                    56.4373005
                ],
                [
                    87.1123217,
                    56.4374536
                ],
                [
                    87.1127691,
                    56.4385372
                ],
                [
                    87.1136213,
                    56.4395971
                ],
                [
                    87.11458,
                    56.4400447
                ],
                [
                    87.1146013,
                    56.4410222
                ],
                [
                    87.1157091,
                    56.4416581
                ],
                [
                    87.1166252,
                    56.441823
                ],
                [
                    87.1191178,
                    56.4418701
                ],
                [
                    87.1210991,
                    56.4421292
                ],
                [
                    87.1223135,
                    56.4416346
                ],
                [
                    87.1230592,
                    56.4416464
                ],
                [
                    87.1271283,
                    56.443354
                ],
                [
                    87.1267022,
                    56.4438132
                ],
                [
                    87.1275757,
                    56.4444256
                ],
                [
                    87.1282574,
                    56.4439428
                ],
                [
                    87.1289818,
                    56.4441312
                ],
                [
                    87.1298553,
                    56.444143
                ],
                [
                    87.130324,
                    56.4437779
                ],
                [
                    87.1311122,
                    56.4437661
                ],
                [
                    87.1318366,
                    56.444143
                ],
                [
                    87.1336262,
                    56.4435306
                ],
                [
                    87.1301535,
                    56.4404451
                ],
                [
                    87.1309205,
                    56.4399505
                ],
                [
                    87.137461,
                    56.4391025
                ],
                [
                    87.1374397,
                    56.4388787
                ],
                [
                    87.1337753,
                    56.4364642
                ],
                [
                    87.1365662,
                    56.4361698
                ],
                [
                    87.1306435,
                    56.4321531
                ],
                [
                    87.1304731,
                    56.4313756
                ],
                [
                    87.1291734,
                    56.4313285
                ],
                [
                    87.1274053,
                    56.4300327
                ],
                [
                    87.1275785,
                    56.4233389
                ],
                [
                    87.1248559,
                    56.4233389
                ],
                [
                    87.1257861,
                    56.4196645
                ],
                [
                    87.1176265,
                    56.4180737
                ],
                [
                    87.1172217,
                    56.4196056
                ],
                [
                    87.1160713,
                    56.4210432
                ],
                [
                    87.1166039,
                    56.4219504
                ],
                [
                    87.1141752,
                    56.4244955
                ],
                [
                    87.1141752,
                    56.4263806
                ],
                [
                    87.1131313,
                    56.4280299
                ],
                [
                    87.1135148,
                    56.4291373
                ],
                [
                    87.1129821,
                    56.4299266
                ],
                [
                    87.1130887,
                    56.4334842
                ],
                [
                    87.1108517,
                    56.4334488
                ],
                [
                    87.1108304,
                    56.4339082
                ],
                [
                    87.10919,
                    56.4341438
                ],
                [
                    87.1088917,
                    56.4343558
                ],
                [
                    87.1088704,
                    56.4351686
                ]
            ],
            "longitude": 87.12056,
            "latitude": 56.432613
        },
        "1276": {
            "name": "Недорезово",
            "population": 691,
            "type": "village",
            "poly": null,
            "longitude": 87.121033,
            "latitude": 54.004021
        },
        "1277": {
            "name": "Бедарево",
            "population": 392,
            "type": "village",
            "poly": null,
            "longitude": 87.12661,
            "latitude": 53.855629
        },
        "1278": {
            "name": "Сосновка",
            "population": 2430,
            "type": "village",
            "poly": [
                [
                    87.1156727,
                    53.653541
                ],
                [
                    87.116059,
                    53.6544566
                ],
                [
                    87.1207367,
                    53.6553467
                ],
                [
                    87.1231829,
                    53.6555502
                ],
                [
                    87.1252278,
                    53.6557537
                ],
                [
                    87.1290473,
                    53.6573051
                ],
                [
                    87.130221,
                    53.6591107
                ],
                [
                    87.1312939,
                    53.6609672
                ],
                [
                    87.13683,
                    53.6640441
                ],
                [
                    87.137096,
                    53.6650447
                ],
                [
                    87.1342551,
                    53.6653918
                ],
                [
                    87.1324097,
                    53.6642475
                ],
                [
                    87.1307789,
                    53.6646288
                ],
                [
                    87.1335684,
                    53.6674513
                ],
                [
                    87.1302575,
                    53.667567
                ],
                [
                    87.1293627,
                    53.6685955
                ],
                [
                    87.1306931,
                    53.6705023
                ],
                [
                    87.1305214,
                    53.672104
                ],
                [
                    87.1353709,
                    53.6723583
                ],
                [
                    87.1381604,
                    53.6736803
                ],
                [
                    87.138332,
                    53.6768325
                ],
                [
                    87.1360146,
                    53.68062
                ],
                [
                    87.131766,
                    53.6814079
                ],
                [
                    87.1271311,
                    53.6805691
                ],
                [
                    87.126687,
                    53.6824742
                ],
                [
                    87.1329526,
                    53.6841263
                ],
                [
                    87.1191771,
                    53.697899
                ],
                [
                    87.1286013,
                    53.7008363
                ],
                [
                    87.1301446,
                    53.7005521
                ],
                [
                    87.1305588,
                    53.7000741
                ],
                [
                    87.1305064,
                    53.6996018
                ],
                [
                    87.1330105,
                    53.696859
                ],
                [
                    87.1341113,
                    53.6938595
                ],
                [
                    87.1372441,
                    53.6906323
                ],
                [
                    87.1395186,
                    53.6865153
                ],
                [
                    87.1391753,
                    53.6827792
                ],
                [
                    87.1408639,
                    53.6796032
                ],
                [
                    87.1426944,
                    53.6754331
                ],
                [
                    87.1417653,
                    53.6726379
                ],
                [
                    87.1423232,
                    53.6715193
                ],
                [
                    87.1549424,
                    53.6745459
                ],
                [
                    87.1617059,
                    53.6804408
                ],
                [
                    87.1637229,
                    53.6804662
                ],
                [
                    87.1662549,
                    53.6824742
                ],
                [
                    87.1702031,
                    53.68039
                ],
                [
                    87.1675574,
                    53.6785611
                ],
                [
                    87.1676303,
                    53.6777222
                ],
                [
                    87.1648387,
                    53.675611
                ],
                [
                    87.1640812,
                    53.6737819
                ],
                [
                    87.1646241,
                    53.6732468
                ],
                [
                    87.1657828,
                    53.6739332
                ],
                [
                    87.1687011,
                    53.6716706
                ],
                [
                    87.1670338,
                    53.6708519
                ],
                [
                    87.1718489,
                    53.6709091
                ],
                [
                    87.1707181,
                    53.6675771
                ],
                [
                    87.1659695,
                    53.6671971
                ],
                [
                    87.1622209,
                    53.6683145
                ],
                [
                    87.1615449,
                    53.6663516
                ],
                [
                    87.153994,
                    53.6624281
                ],
                [
                    87.151492,
                    53.6607892
                ],
                [
                    87.1511208,
                    53.6592888
                ],
                [
                    87.1463143,
                    53.6590599
                ],
                [
                    87.1439539,
                    53.658653
                ],
                [
                    87.1385466,
                    53.6572796
                ],
                [
                    87.1361004,
                    53.6566947
                ],
                [
                    87.1340255,
                    53.6557028
                ],
                [
                    87.1328818,
                    53.6544566
                ],
                [
                    87.1279315,
                    53.6521675
                ],
                [
                    87.1264724,
                    53.6533884
                ],
                [
                    87.119048,
                    53.6489116
                ],
                [
                    87.1176747,
                    53.6484792
                ],
                [
                    87.1165589,
                    53.6483774
                ],
                [
                    87.1164023,
                    53.6491151
                ],
                [
                    87.1176318,
                    53.6496239
                ],
                [
                    87.1156727,
                    53.653541
                ]
            ],
            "longitude": 87.152794,
            "latitude": 53.667896
        },
        "1279": {
            "name": "Ильинка",
            "population": 1708,
            "type": "village",
            "poly": [
                [
                    87.1476509,
                    53.8990468
                ],
                [
                    87.1500578,
                    53.902619
                ],
                [
                    87.148989,
                    53.9076047
                ],
                [
                    87.1634569,
                    53.9173297
                ],
                [
                    87.17401,
                    53.9218405
                ],
                [
                    87.2090734,
                    53.9261504
                ],
                [
                    87.2197967,
                    53.9208381
                ],
                [
                    87.2026054,
                    53.9124173
                ],
                [
                    87.1869938,
                    53.9055448
                ],
                [
                    87.1838812,
                    53.9033746
                ],
                [
                    87.1765421,
                    53.8986299
                ],
                [
                    87.1700027,
                    53.8970987
                ],
                [
                    87.1634917,
                    53.8952141
                ],
                [
                    87.1590655,
                    53.8930265
                ],
                [
                    87.1565525,
                    53.8915287
                ],
                [
                    87.1535825,
                    53.8884489
                ],
                [
                    87.1507841,
                    53.8853521
                ],
                [
                    87.1494357,
                    53.8863269
                ],
                [
                    87.1509974,
                    53.8913891
                ],
                [
                    87.152336,
                    53.8930982
                ],
                [
                    87.1476509,
                    53.8990468
                ]
            ],
            "longitude": 87.163513,
            "latitude": 53.900764
        },
        "1280": {
            "name": "Симбирка",
            "population": 566,
            "type": "village",
            "poly": [
                [
                    87.1401674,
                    56.0341859
                ],
                [
                    87.1436021,
                    56.0371385
                ],
                [
                    87.1493973,
                    56.0411414
                ],
                [
                    87.1497795,
                    56.0476804
                ],
                [
                    87.1666472,
                    56.0518167
                ],
                [
                    87.1769686,
                    56.0487212
                ],
                [
                    87.1872899,
                    56.0462659
                ],
                [
                    87.1872421,
                    56.0431966
                ],
                [
                    87.1867643,
                    56.0415685
                ],
                [
                    87.1856652,
                    56.0396733
                ],
                [
                    87.183945,
                    56.0386056
                ],
                [
                    87.1817469,
                    56.0372442
                ],
                [
                    87.1786888,
                    56.0351619
                ],
                [
                    87.1745316,
                    56.0339072
                ],
                [
                    87.1707089,
                    56.0333199
                ],
                [
                    87.1663128,
                    56.0329728
                ],
                [
                    87.1627767,
                    56.0322787
                ],
                [
                    87.1574727,
                    56.0329461
                ],
                [
                    87.1468159,
                    56.0334262
                ],
                [
                    87.1427571,
                    56.0324885
                ],
                [
                    87.1401674,
                    56.0341859
                ]
            ],
            "longitude": 87.170036,
            "latitude": 56.043968
        },
        "1281": {
            "name": "Николаевка",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 87.172012,
            "latitude": 53.475719
        },
        "1282": {
            "name": "Белогородка",
            "population": 681,
            "type": "village",
            "poly": [
                [
                    87.1462755,
                    56.2893754
                ],
                [
                    87.1464244,
                    56.2905535
                ],
                [
                    87.1496271,
                    56.2967533
                ],
                [
                    87.160315,
                    56.2950588
                ],
                [
                    87.162177,
                    56.2967533
                ],
                [
                    87.1636293,
                    56.2969599
                ],
                [
                    87.1642624,
                    56.2974352
                ],
                [
                    87.1642996,
                    56.2979104
                ],
                [
                    87.1645603,
                    56.2981584
                ],
                [
                    87.1657148,
                    56.2976211
                ],
                [
                    87.1675395,
                    56.2985303
                ],
                [
                    87.1705187,
                    56.296526
                ],
                [
                    87.1733862,
                    56.2976831
                ],
                [
                    87.1739448,
                    56.2969392
                ],
                [
                    87.1755461,
                    56.2964433
                ],
                [
                    87.1774453,
                    56.2954514
                ],
                [
                    87.1804245,
                    56.2932402
                ],
                [
                    87.1812811,
                    56.2923102
                ],
                [
                    87.1782274,
                    56.2910702
                ],
                [
                    87.184372,
                    56.2869572
                ],
                [
                    87.1869788,
                    56.2875566
                ],
                [
                    87.187798,
                    56.2873913
                ],
                [
                    87.1889525,
                    56.2863578
                ],
                [
                    87.1884684,
                    56.2856963
                ],
                [
                    87.1881704,
                    56.2850762
                ],
                [
                    87.1886546,
                    56.2846835
                ],
                [
                    87.1886546,
                    56.2841667
                ],
                [
                    87.1893994,
                    56.2837946
                ],
                [
                    87.1888035,
                    56.2822649
                ],
                [
                    87.1869415,
                    56.2805285
                ],
                [
                    87.1863829,
                    56.2806318
                ],
                [
                    87.1788605,
                    56.2767245
                ],
                [
                    87.1768123,
                    56.2774481
                ],
                [
                    87.1758068,
                    56.278151
                ],
                [
                    87.1737957,
                    56.2785852
                ],
                [
                    87.1724924,
                    56.2791847
                ],
                [
                    87.1707049,
                    56.27904
                ],
                [
                    87.167316,
                    56.2778822
                ],
                [
                    87.1648955,
                    56.2775928
                ],
                [
                    87.1624749,
                    56.2779443
                ],
                [
                    87.1606501,
                    56.2775514
                ],
                [
                    87.159086,
                    56.2774067
                ],
                [
                    87.1580061,
                    56.2780683
                ],
                [
                    87.1543193,
                    56.2797429
                ],
                [
                    87.1522339,
                    56.2825957
                ],
                [
                    87.1492174,
                    56.2849109
                ],
                [
                    87.1462755,
                    56.2893754
                ]
            ],
            "longitude": 87.172188,
            "latitude": 56.290577
        },
        "1283": {
            "name": "Чичербаево",
            "population": 331,
            "type": "village",
            "poly": null,
            "longitude": 87.176262,
            "latitude": 53.993416
        },
        "1284": {
            "name": "Ерунаково",
            "population": 572,
            "type": "village",
            "poly": null,
            "longitude": 87.189011,
            "latitude": 54.001217
        },
        "1285": {
            "name": "Кузедеево",
            "population": 3609,
            "type": "village",
            "poly": [
                [
                    87.1304582,
                    53.3418355
                ],
                [
                    87.1435188,
                    53.3459949
                ],
                [
                    87.1578094,
                    53.3446281
                ],
                [
                    87.1650575,
                    53.348004
                ],
                [
                    87.173471,
                    53.3444881
                ],
                [
                    87.1879134,
                    53.3453743
                ],
                [
                    87.1930254,
                    53.3500572
                ],
                [
                    87.2020428,
                    53.3442594
                ],
                [
                    87.2176302,
                    53.3405992
                ],
                [
                    87.2207193,
                    53.3377727
                ],
                [
                    87.2248163,
                    53.3374794
                ],
                [
                    87.2254707,
                    53.3393621
                ],
                [
                    87.2362914,
                    53.3383047
                ],
                [
                    87.2527371,
                    53.3432568
                ],
                [
                    87.2445246,
                    53.3357204
                ],
                [
                    87.2328438,
                    53.3298435
                ],
                [
                    87.2203012,
                    53.3266899
                ],
                [
                    87.2030386,
                    53.3163203
                ],
                [
                    87.1927805,
                    53.3316746
                ],
                [
                    87.1790402,
                    53.3321856
                ],
                [
                    87.1607295,
                    53.3247144
                ],
                [
                    87.156362,
                    53.3211284
                ],
                [
                    87.1487995,
                    53.3146542
                ],
                [
                    87.1453401,
                    53.3155914
                ],
                [
                    87.1394904,
                    53.3210606
                ],
                [
                    87.1420627,
                    53.3236225
                ],
                [
                    87.1342638,
                    53.3247937
                ],
                [
                    87.1322646,
                    53.3298712
                ],
                [
                    87.1404899,
                    53.335044
                ],
                [
                    87.1304582,
                    53.3418355
                ]
            ],
            "longitude": 87.189774,
            "latitude": 53.336449
        },
        "1286": {
            "name": "Куртуково",
            "population": 1067,
            "type": "village",
            "poly": [
                [
                    87.1832129,
                    53.6426173
                ],
                [
                    87.1847149,
                    53.6442709
                ],
                [
                    87.1881653,
                    53.6459627
                ],
                [
                    87.1938773,
                    53.6456408
                ],
                [
                    87.1968793,
                    53.6441641
                ],
                [
                    87.2002975,
                    53.6434033
                ],
                [
                    87.2037479,
                    53.6430905
                ],
                [
                    87.2124747,
                    53.6428323
                ],
                [
                    87.2164723,
                    53.6427954
                ],
                [
                    87.2175881,
                    53.6438639
                ],
                [
                    87.2272376,
                    53.6435699
                ],
                [
                    87.2343615,
                    53.6421199
                ],
                [
                    87.2365502,
                    53.6408987
                ],
                [
                    87.2276238,
                    53.6356319
                ],
                [
                    87.2269865,
                    53.6353914
                ],
                [
                    87.2258214,
                    53.6343596
                ],
                [
                    87.225478,
                    53.6335707
                ],
                [
                    87.2247055,
                    53.6328328
                ],
                [
                    87.2242829,
                    53.6331776
                ],
                [
                    87.2245833,
                    53.6336611
                ],
                [
                    87.2239759,
                    53.6342578
                ],
                [
                    87.2227744,
                    53.6340542
                ],
                [
                    87.2219654,
                    53.6347298
                ],
                [
                    87.2214869,
                    53.634614
                ],
                [
                    87.2206715,
                    53.6352502
                ],
                [
                    87.219899,
                    53.636268
                ],
                [
                    87.2173241,
                    53.636497
                ],
                [
                    87.2146205,
                    53.6369804
                ],
                [
                    87.2136763,
                    53.6378964
                ],
                [
                    87.2138051,
                    53.6381763
                ],
                [
                    87.2146205,
                    53.6383544
                ],
                [
                    87.2144123,
                    53.6388773
                ],
                [
                    87.2129897,
                    53.6389396
                ],
                [
                    87.2124747,
                    53.6384562
                ],
                [
                    87.2107152,
                    53.6384816
                ],
                [
                    87.2090479,
                    53.6379104
                ],
                [
                    87.2089577,
                    53.6372094
                ],
                [
                    87.2092153,
                    53.6365223
                ],
                [
                    87.2085285,
                    53.6362934
                ],
                [
                    87.2059537,
                    53.6364715
                ],
                [
                    87.2049237,
                    53.6368532
                ],
                [
                    87.2050139,
                    53.6372743
                ],
                [
                    87.2044088,
                    53.6377692
                ],
                [
                    87.2014047,
                    53.6379982
                ],
                [
                    87.1977569,
                    53.6391177
                ],
                [
                    87.1912767,
                    53.6397538
                ],
                [
                    87.1915342,
                    53.6390668
                ],
                [
                    87.1938988,
                    53.638343
                ],
                [
                    87.1943666,
                    53.6375148
                ],
                [
                    87.1923925,
                    53.6363952
                ],
                [
                    87.1900321,
                    53.6389905
                ],
                [
                    87.1844102,
                    53.6381509
                ],
                [
                    87.1833416,
                    53.6402002
                ],
                [
                    87.1843673,
                    53.6400336
                ],
                [
                    87.1832129,
                    53.6426173
                ]
            ],
            "longitude": 87.206154,
            "latitude": 53.639267
        },
        "1287": {
            "name": "Кругленькое",
            "population": 388,
            "type": "village",
            "poly": [
                [
                    87.2004944,
                    53.8071146
                ],
                [
                    87.2014949,
                    53.8109619
                ],
                [
                    87.2040572,
                    53.8132672
                ],
                [
                    87.2092794,
                    53.8145063
                ],
                [
                    87.2157462,
                    53.8135266
                ],
                [
                    87.212647,
                    53.8089446
                ],
                [
                    87.2102311,
                    53.8060771
                ],
                [
                    87.2025686,
                    53.8059185
                ],
                [
                    87.2004944,
                    53.8071146
                ]
            ],
            "longitude": 87.209396,
            "latitude": 53.812115
        },
        "1288": {
            "name": "Успенка",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 87.220848,
            "latitude": 54.081867
        },
        "1289": {
            "name": "Красные Орлы",
            "population": 1391,
            "type": "village",
            "poly": [
                [
                    87.2115022,
                    56.1729487
                ],
                [
                    87.2117376,
                    56.1731453
                ],
                [
                    87.2117455,
                    56.1733375
                ],
                [
                    87.2116121,
                    56.1734206
                ],
                [
                    87.2116278,
                    56.173923
                ],
                [
                    87.2121693,
                    56.1742289
                ],
                [
                    87.2135428,
                    56.1744736
                ],
                [
                    87.215615,
                    56.174408
                ],
                [
                    87.2158348,
                    56.1745129
                ],
                [
                    87.2155286,
                    56.1755309
                ],
                [
                    87.216133,
                    56.175828
                ],
                [
                    87.2181267,
                    56.1760814
                ],
                [
                    87.2195238,
                    56.1759285
                ],
                [
                    87.2201831,
                    56.1757406
                ],
                [
                    87.2218001,
                    56.1758848
                ],
                [
                    87.2237545,
                    56.1756795
                ],
                [
                    87.2247827,
                    56.1754828
                ],
                [
                    87.2257246,
                    56.1758673
                ],
                [
                    87.2261092,
                    56.1759372
                ],
                [
                    87.2264153,
                    56.1758018
                ],
                [
                    87.2269804,
                    56.1758236
                ],
                [
                    87.227514,
                    56.1752513
                ],
                [
                    87.2276397,
                    56.1757232
                ],
                [
                    87.2274121,
                    56.1759635
                ],
                [
                    87.2273964,
                    56.1763173
                ],
                [
                    87.2277261,
                    56.1762431
                ],
                [
                    87.2287935,
                    56.1762737
                ],
                [
                    87.2287543,
                    56.1765096
                ],
                [
                    87.228511,
                    56.1768329
                ],
                [
                    87.2294764,
                    56.1770732
                ],
                [
                    87.2312581,
                    56.1770819
                ],
                [
                    87.2320508,
                    56.1768198
                ],
                [
                    87.2327808,
                    56.1768329
                ],
                [
                    87.2343663,
                    56.176846
                ],
                [
                    87.2349628,
                    56.1781436
                ],
                [
                    87.2357556,
                    56.1778203
                ],
                [
                    87.2360146,
                    56.1780562
                ],
                [
                    87.2355907,
                    56.1784494
                ],
                [
                    87.2358655,
                    56.1786635
                ],
                [
                    87.2339895,
                    56.1796333
                ],
                [
                    87.2343977,
                    56.1798649
                ],
                [
                    87.2354651,
                    56.1799348
                ],
                [
                    87.2368701,
                    56.1796901
                ],
                [
                    87.2373882,
                    56.1794848
                ],
                [
                    87.2371213,
                    56.1791265
                ],
                [
                    87.2374353,
                    56.1788644
                ],
                [
                    87.2380318,
                    56.1788732
                ],
                [
                    87.238746,
                    56.1782047
                ],
                [
                    87.2386911,
                    56.1792576
                ],
                [
                    87.2388402,
                    56.1794455
                ],
                [
                    87.2399548,
                    56.1793188
                ],
                [
                    87.239892,
                    56.178978
                ],
                [
                    87.2407946,
                    56.1787115
                ],
                [
                    87.2416973,
                    56.1777067
                ],
                [
                    87.2416894,
                    56.1773222
                ],
                [
                    87.2402452,
                    56.1772567
                ],
                [
                    87.2406455,
                    56.1768416
                ],
                [
                    87.2444523,
                    56.1780387
                ],
                [
                    87.2452136,
                    56.1774664
                ],
                [
                    87.2452686,
                    56.177012
                ],
                [
                    87.2459043,
                    56.1766319
                ],
                [
                    87.2459827,
                    56.1760727
                ],
                [
                    87.2452136,
                    56.1751464
                ],
                [
                    87.2448603,
                    56.1743206
                ],
                [
                    87.245143,
                    56.1740716
                ],
                [
                    87.2473171,
                    56.1743512
                ],
                [
                    87.2473956,
                    56.1740017
                ],
                [
                    87.250653,
                    56.1747445
                ],
                [
                    87.2510376,
                    56.1738968
                ],
                [
                    87.250912,
                    56.1732633
                ],
                [
                    87.2491773,
                    56.1730644
                ],
                [
                    87.2493049,
                    56.1725729
                ],
                [
                    87.2486672,
                    56.1723763
                ],
                [
                    87.2486377,
                    56.1713986
                ],
                [
                    87.2481962,
                    56.1707595
                ],
                [
                    87.2486279,
                    56.1703826
                ],
                [
                    87.2478725,
                    56.1699019
                ],
                [
                    87.248883,
                    56.1698309
                ],
                [
                    87.2493441,
                    56.169454
                ],
                [
                    87.2498053,
                    56.1693885
                ],
                [
                    87.2500211,
                    56.1694431
                ],
                [
                    87.2502272,
                    56.1697763
                ],
                [
                    87.2515978,
                    56.1700636
                ],
                [
                    87.2518755,
                    56.1691372
                ],
                [
                    87.2517176,
                    56.1680465
                ],
                [
                    87.2504301,
                    56.1663961
                ],
                [
                    87.2487833,
                    56.1660627
                ],
                [
                    87.2430944,
                    56.1660127
                ],
                [
                    87.2425587,
                    56.1664529
                ],
                [
                    87.2427157,
                    56.1670757
                ],
                [
                    87.2424704,
                    56.1671139
                ],
                [
                    87.2418915,
                    56.1666223
                ],
                [
                    87.2413127,
                    56.1655297
                ],
                [
                    87.2398802,
                    56.1655625
                ],
                [
                    87.2398704,
                    56.1658247
                ],
                [
                    87.2390953,
                    56.1658356
                ],
                [
                    87.2385655,
                    56.1654587
                ],
                [
                    87.2376629,
                    56.1654642
                ],
                [
                    87.2373391,
                    56.1658247
                ],
                [
                    87.2367504,
                    56.1658302
                ],
                [
                    87.2365346,
                    56.1659558
                ],
                [
                    87.235838,
                    56.1659667
                ],
                [
                    87.2356614,
                    56.1657482
                ],
                [
                    87.2342093,
                    56.1656991
                ],
                [
                    87.2340916,
                    56.1657592
                ],
                [
                    87.2334048,
                    56.1657701
                ],
                [
                    87.232875,
                    56.1655789
                ],
                [
                    87.231835,
                    56.1655789
                ],
                [
                    87.2317271,
                    56.1652019
                ],
                [
                    87.2311286,
                    56.165262
                ],
                [
                    87.2310795,
                    56.1647977
                ],
                [
                    87.2307165,
                    56.1646775
                ],
                [
                    87.2283618,
                    56.1643279
                ],
                [
                    87.2270177,
                    56.164306
                ],
                [
                    87.2267135,
                    56.1639946
                ],
                [
                    87.2260169,
                    56.1639782
                ],
                [
                    87.2246237,
                    56.164235
                ],
                [
                    87.2230441,
                    56.1654532
                ],
                [
                    87.2230244,
                    56.1656936
                ],
                [
                    87.2236719,
                    56.1663218
                ],
                [
                    87.222789,
                    56.1666551
                ],
                [
                    87.2218864,
                    56.1665349
                ],
                [
                    87.2211486,
                    56.1661361
                ],
                [
                    87.2204893,
                    56.1661448
                ],
                [
                    87.2190529,
                    56.1669096
                ],
                [
                    87.2190372,
                    56.1671194
                ],
                [
                    87.2192648,
                    56.1672854
                ],
                [
                    87.2189116,
                    56.16767
                ],
                [
                    87.2199712,
                    56.1687232
                ],
                [
                    87.2205756,
                    56.1699074
                ],
                [
                    87.2223415,
                    56.1698856
                ],
                [
                    87.2235503,
                    56.1700822
                ],
                [
                    87.223417,
                    56.1702351
                ],
                [
                    87.2245237,
                    56.1707551
                ],
                [
                    87.2245394,
                    56.1712402
                ],
                [
                    87.2212428,
                    56.1710261
                ],
                [
                    87.2169808,
                    56.1709081
                ],
                [
                    87.2165177,
                    56.171297
                ],
                [
                    87.216502,
                    56.1716684
                ],
                [
                    87.2129228,
                    56.1715548
                ],
                [
                    87.2126403,
                    56.1714193
                ],
                [
                    87.2122871,
                    56.1714193
                ],
                [
                    87.2116278,
                    56.1719524
                ],
                [
                    87.2115022,
                    56.1729487
                ]
            ],
            "longitude": 87.231705,
            "latitude": 56.172802
        },
        "1290": {
            "name": "Николаевка",
            "population": 676,
            "type": "village",
            "poly": [
                [
                    87.2482178,
                    55.8769721
                ],
                [
                    87.2519352,
                    55.8848737
                ],
                [
                    87.2637296,
                    55.8892337
                ],
                [
                    87.2851336,
                    55.8905659
                ],
                [
                    87.289933,
                    55.8886537
                ],
                [
                    87.2825086,
                    55.8840001
                ],
                [
                    87.2554369,
                    55.8725697
                ],
                [
                    87.2501777,
                    55.8738543
                ],
                [
                    87.2513623,
                    55.8756002
                ],
                [
                    87.2482178,
                    55.8769721
                ]
            ],
            "longitude": 87.2617703,
            "latitude": 55.8797373
        },
        "1291": {
            "name": "Ашмарино",
            "population": 422,
            "type": "village",
            "poly": [
                [
                    87.2404447,
                    53.6163662
                ],
                [
                    87.2405606,
                    53.6176976
                ],
                [
                    87.2407448,
                    53.6189583
                ],
                [
                    87.2416636,
                    53.6210778
                ],
                [
                    87.2423528,
                    53.6227467
                ],
                [
                    87.2432525,
                    53.6244497
                ],
                [
                    87.2441968,
                    53.62697
                ],
                [
                    87.2444201,
                    53.6275792
                ],
                [
                    87.244097,
                    53.6284401
                ],
                [
                    87.2459487,
                    53.6324002
                ],
                [
                    87.2434167,
                    53.637184
                ],
                [
                    87.2527786,
                    53.6396151
                ],
                [
                    87.2624691,
                    53.6342632
                ],
                [
                    87.2646245,
                    53.6354827
                ],
                [
                    87.2676511,
                    53.6344044
                ],
                [
                    87.2742934,
                    53.6400219
                ],
                [
                    87.2785409,
                    53.6382676
                ],
                [
                    87.2735745,
                    53.6334712
                ],
                [
                    87.2726121,
                    53.6309716
                ],
                [
                    87.2776257,
                    53.6316237
                ],
                [
                    87.2778347,
                    53.6287102
                ],
                [
                    87.272124,
                    53.6260866
                ],
                [
                    87.272183,
                    53.6210845
                ],
                [
                    87.2803239,
                    53.6217361
                ],
                [
                    87.2881282,
                    53.6227123
                ],
                [
                    87.290231,
                    53.6232722
                ],
                [
                    87.2920399,
                    53.6231361
                ],
                [
                    87.2891646,
                    53.6211507
                ],
                [
                    87.2828067,
                    53.6179777
                ],
                [
                    87.2758608,
                    53.6147103
                ],
                [
                    87.2731143,
                    53.6128519
                ],
                [
                    87.2722129,
                    53.6120881
                ],
                [
                    87.2705329,
                    53.6116133
                ],
                [
                    87.2608426,
                    53.6106623
                ],
                [
                    87.2586968,
                    53.6115025
                ],
                [
                    87.2575381,
                    53.6116298
                ],
                [
                    87.2554782,
                    53.6109424
                ],
                [
                    87.2520879,
                    53.6092875
                ],
                [
                    87.2526458,
                    53.6081417
                ],
                [
                    87.2519162,
                    53.606945
                ],
                [
                    87.2536328,
                    53.6066394
                ],
                [
                    87.2545341,
                    53.6072505
                ],
                [
                    87.2556412,
                    53.6069029
                ],
                [
                    87.2559416,
                    53.6064701
                ],
                [
                    87.2567405,
                    53.6058891
                ],
                [
                    87.2559974,
                    53.6024533
                ],
                [
                    87.2536794,
                    53.6015733
                ],
                [
                    87.2520842,
                    53.6018099
                ],
                [
                    87.2491555,
                    53.6025051
                ],
                [
                    87.2481086,
                    53.6030967
                ],
                [
                    87.2487318,
                    53.6041319
                ],
                [
                    87.2469246,
                    53.6049527
                ],
                [
                    87.2458155,
                    53.6047753
                ],
                [
                    87.2451923,
                    53.6053742
                ],
                [
                    87.2451799,
                    53.6058771
                ],
                [
                    87.2445194,
                    53.6061359
                ],
                [
                    87.2436123,
                    53.6085905
                ],
                [
                    87.2431631,
                    53.6091205
                ],
                [
                    87.2419189,
                    53.6098398
                ],
                [
                    87.2419699,
                    53.6101842
                ],
                [
                    87.2422698,
                    53.6102751
                ],
                [
                    87.2414276,
                    53.6109868
                ],
                [
                    87.2409811,
                    53.6119338
                ],
                [
                    87.2407666,
                    53.6136499
                ],
                [
                    87.2406271,
                    53.614891
                ],
                [
                    87.2404447,
                    53.6163662
                ]
            ],
            "longitude": 87.262169,
            "latitude": 53.631451
        },
        "1292": {
            "name": "Тюменево",
            "population": 420,
            "type": "village",
            "poly": [
                [
                    87.235499,
                    56.2351481
                ],
                [
                    87.2360779,
                    56.235737
                ],
                [
                    87.2371669,
                    56.2361132
                ],
                [
                    87.2374318,
                    56.2360042
                ],
                [
                    87.2392764,
                    56.2368766
                ],
                [
                    87.2401005,
                    56.2373564
                ],
                [
                    87.2421609,
                    56.2379999
                ],
                [
                    87.2430928,
                    56.2389813
                ],
                [
                    87.2441427,
                    56.2392757
                ],
                [
                    87.2452318,
                    56.2392103
                ],
                [
                    87.2465661,
                    56.2397937
                ],
                [
                    87.2476355,
                    56.2399082
                ],
                [
                    87.2480182,
                    56.239701
                ],
                [
                    87.2501374,
                    56.2398373
                ],
                [
                    87.2520604,
                    56.2403498
                ],
                [
                    87.25364,
                    56.2411349
                ],
                [
                    87.2547291,
                    56.2419418
                ],
                [
                    87.2577607,
                    56.2429723
                ],
                [
                    87.2587026,
                    56.2427651
                ],
                [
                    87.2598505,
                    56.2428796
                ],
                [
                    87.2606649,
                    56.243114
                ],
                [
                    87.2598603,
                    56.24373
                ],
                [
                    87.2597131,
                    56.2447277
                ],
                [
                    87.2604686,
                    56.2450493
                ],
                [
                    87.2610573,
                    56.2450493
                ],
                [
                    87.2621071,
                    56.2452783
                ],
                [
                    87.2627841,
                    56.2453001
                ],
                [
                    87.2639614,
                    56.244526
                ],
                [
                    87.2659629,
                    56.2454473
                ],
                [
                    87.2674444,
                    56.2457526
                ],
                [
                    87.2680527,
                    56.2463141
                ],
                [
                    87.2695342,
                    56.2471863
                ],
                [
                    87.2712806,
                    56.2472135
                ],
                [
                    87.2734587,
                    56.2457853
                ],
                [
                    87.2737727,
                    56.2450984
                ],
                [
                    87.274901,
                    56.2437682
                ],
                [
                    87.2731742,
                    56.2430867
                ],
                [
                    87.2722127,
                    56.2423071
                ],
                [
                    87.2710844,
                    56.2421327
                ],
                [
                    87.2690829,
                    56.2413203
                ],
                [
                    87.2703692,
                    56.2403624
                ],
                [
                    87.2697315,
                    56.2400898
                ],
                [
                    87.2687246,
                    56.2404799
                ],
                [
                    87.2674628,
                    56.2404821
                ],
                [
                    87.2666791,
                    56.2406675
                ],
                [
                    87.2661205,
                    56.2410426
                ],
                [
                    87.2656182,
                    56.241429
                ],
                [
                    87.2654012,
                    56.241429
                ],
                [
                    87.2639539,
                    56.2408596
                ],
                [
                    87.2624821,
                    56.2406006
                ],
                [
                    87.2608511,
                    56.2400077
                ],
                [
                    87.2600293,
                    56.239626
                ],
                [
                    87.2598945,
                    56.2392853
                ],
                [
                    87.2584596,
                    56.2386923
                ],
                [
                    87.2577728,
                    56.2382629
                ],
                [
                    87.2542408,
                    56.2370429
                ],
                [
                    87.2521804,
                    56.2371179
                ],
                [
                    87.2494333,
                    56.2366612
                ],
                [
                    87.2476059,
                    56.2367839
                ],
                [
                    87.2472871,
                    56.2365658
                ],
                [
                    87.246539,
                    56.2365453
                ],
                [
                    87.2471522,
                    56.235816
                ],
                [
                    87.2468456,
                    56.2356456
                ],
                [
                    87.2459012,
                    56.2364704
                ],
                [
                    87.2453126,
                    56.2364908
                ],
                [
                    87.2449814,
                    56.2362932
                ],
                [
                    87.2454597,
                    56.2355707
                ],
                [
                    87.2453861,
                    56.2353389
                ],
                [
                    87.2440126,
                    56.2347936
                ],
                [
                    87.2444173,
                    56.2345278
                ],
                [
                    87.2439512,
                    56.2343096
                ],
                [
                    87.2434975,
                    56.2345823
                ],
                [
                    87.2431785,
                    56.2344869
                ],
                [
                    87.2431418,
                    56.2343096
                ],
                [
                    87.2425654,
                    56.2342074
                ],
                [
                    87.2418664,
                    56.2342074
                ],
                [
                    87.2409833,
                    56.2347595
                ],
                [
                    87.2405418,
                    56.2348686
                ],
                [
                    87.23999,
                    56.235223
                ],
                [
                    87.2390427,
                    56.234433
                ],
                [
                    87.2364017,
                    56.2347664
                ],
                [
                    87.235499,
                    56.2351481
                ]
            ],
            "longitude": 87.26358,
            "latitude": 56.242439
        },
        "1293": {
            "name": "Елань",
            "population": 1704,
            "type": "village",
            "poly": [
                [
                    87.2462719,
                    53.7087996
                ],
                [
                    87.2465068,
                    53.7100703
                ],
                [
                    87.2494938,
                    53.7113314
                ],
                [
                    87.2574331,
                    53.7114584
                ],
                [
                    87.2629863,
                    53.7183246
                ],
                [
                    87.2660162,
                    53.7207028
                ],
                [
                    87.2691232,
                    53.720407
                ],
                [
                    87.2729255,
                    53.7204489
                ],
                [
                    87.275346,
                    53.7185024
                ],
                [
                    87.2801096,
                    53.7167247
                ],
                [
                    87.2786944,
                    53.7132827
                ],
                [
                    87.2772171,
                    53.7103535
                ],
                [
                    87.276745,
                    53.7092994
                ],
                [
                    87.2761624,
                    53.7070088
                ],
                [
                    87.2758406,
                    53.7035286
                ],
                [
                    87.2752612,
                    53.7007721
                ],
                [
                    87.2731401,
                    53.6967241
                ],
                [
                    87.2689741,
                    53.6954238
                ],
                [
                    87.2679902,
                    53.6966225
                ],
                [
                    87.267,
                    53.6974438
                ],
                [
                    87.2620036,
                    53.6995443
                ],
                [
                    87.2592538,
                    53.701331
                ],
                [
                    87.2571509,
                    53.7021821
                ],
                [
                    87.2563355,
                    53.703935
                ],
                [
                    87.2550695,
                    53.7055482
                ],
                [
                    87.2534387,
                    53.7068945
                ],
                [
                    87.2515934,
                    53.7071485
                ],
                [
                    87.2462719,
                    53.7087996
                ]
            ],
            "longitude": 87.265854,
            "latitude": 53.706509
        },
        "1294": {
            "name": "Постоянный",
            "population": null,
            "type": "village",
            "poly": [
                [
                    87.260688,
                    53.5386958
                ],
                [
                    87.2613746,
                    53.540379
                ],
                [
                    87.2628827,
                    53.5416383
                ],
                [
                    87.2647152,
                    53.5433876
                ],
                [
                    87.2647635,
                    53.5481127
                ],
                [
                    87.2707876,
                    53.5500842
                ],
                [
                    87.2758087,
                    53.5504972
                ],
                [
                    87.2852844,
                    53.549703
                ],
                [
                    87.2815448,
                    53.5456833
                ],
                [
                    87.2793132,
                    53.5410931
                ],
                [
                    87.2783939,
                    53.5334827
                ],
                [
                    87.2767063,
                    53.5334847
                ],
                [
                    87.2744209,
                    53.5335437
                ],
                [
                    87.2719318,
                    53.5329825
                ],
                [
                    87.268756,
                    53.5333397
                ],
                [
                    87.2665244,
                    53.5342069
                ],
                [
                    87.2648937,
                    53.5355842
                ],
                [
                    87.2632629,
                    53.5370636
                ],
                [
                    87.2620612,
                    53.5380837
                ],
                [
                    87.260688,
                    53.5386958
                ]
            ],
            "longitude": 87.2716446,
            "latitude": 53.5449712
        },
        "1295": {
            "name": "Казанково",
            "population": 870,
            "type": "village",
            "poly": null,
            "longitude": 87.273628,
            "latitude": 53.999435
        },
        "1296": {
            "name": "Кондома",
            "population": 321,
            "type": "village",
            "poly": null,
            "longitude": 87.274208,
            "latitude": 52.821659
        },
        "1297": {
            "name": "Малиновка",
            "population": 8835,
            "type": "village",
            "poly": [
                [
                    87.268085,
                    53.4016213
                ],
                [
                    87.2700591,
                    53.4069429
                ],
                [
                    87.2757375,
                    53.4122934
                ],
                [
                    87.2840495,
                    53.4162029
                ],
                [
                    87.2872253,
                    53.4148729
                ],
                [
                    87.3242226,
                    53.4111588
                ],
                [
                    87.317266,
                    53.3955313
                ],
                [
                    87.3016448,
                    53.3924092
                ],
                [
                    87.268085,
                    53.4016213
                ]
            ],
            "longitude": 87.284531,
            "latitude": 53.40292
        },
        "1298": {
            "name": "Заречный",
            "population": 351,
            "type": "village",
            "poly": [
                [
                    87.2965866,
                    53.6009607
                ],
                [
                    87.3049766,
                    53.602509
                ],
                [
                    87.3082596,
                    53.5965803
                ],
                [
                    87.3001915,
                    53.5950012
                ],
                [
                    87.2965866,
                    53.6009607
                ]
            ],
            "longitude": 87.303146,
            "latitude": 53.598549
        },
        "1299": {
            "name": "Сарбала",
            "population": 1046,
            "type": "village",
            "poly": [
                [
                    87.2926326,
                    53.4580271
                ],
                [
                    87.2934909,
                    53.4590491
                ],
                [
                    87.2928043,
                    53.4608888
                ],
                [
                    87.2954649,
                    53.4619619
                ],
                [
                    87.2947784,
                    53.4643125
                ],
                [
                    87.2960657,
                    53.4659986
                ],
                [
                    87.3217291,
                    53.4670716
                ],
                [
                    87.3304839,
                    53.462013
                ],
                [
                    87.3308273,
                    53.4490828
                ],
                [
                    87.3241325,
                    53.443971
                ],
                [
                    87.3200126,
                    53.4438176
                ],
                [
                    87.3089404,
                    53.4549607
                ],
                [
                    87.3041339,
                    53.4548585
                ],
                [
                    87.2968383,
                    53.4520985
                ],
                [
                    87.2935767,
                    53.4545518
                ],
                [
                    87.2936626,
                    53.4558806
                ],
                [
                    87.2926326,
                    53.4580271
                ]
            ],
            "longitude": 87.312462,
            "latitude": 53.460785
        },
        "1300": {
            "name": "Красная Орловка",
            "population": 396,
            "type": "village",
            "poly": [
                [
                    87.319407,
                    53.5801982
                ],
                [
                    87.3226465,
                    53.5860684
                ],
                [
                    87.3204476,
                    53.5863915
                ],
                [
                    87.3209626,
                    53.5877671
                ],
                [
                    87.3208585,
                    53.5879424
                ],
                [
                    87.3210249,
                    53.5885626
                ],
                [
                    87.3219508,
                    53.5885722
                ],
                [
                    87.3255304,
                    53.5885004
                ],
                [
                    87.3306862,
                    53.5869431
                ],
                [
                    87.3392305,
                    53.5885747
                ],
                [
                    87.3425533,
                    53.5881423
                ],
                [
                    87.3447666,
                    53.5854012
                ],
                [
                    87.3448449,
                    53.5838133
                ],
                [
                    87.3456041,
                    53.5827101
                ],
                [
                    87.3403388,
                    53.5788196
                ],
                [
                    87.319407,
                    53.5801982
                ]
            ],
            "longitude": 87.330635,
            "latitude": 53.585495
        },
        "1301": {
            "name": "Терехино",
            "population": 494,
            "type": "village",
            "poly": null,
            "longitude": 87.3348475,
            "latitude": 53.9925328
        },
        "1302": {
            "name": "Сидорово",
            "population": 1071,
            "type": "village",
            "poly": null,
            "longitude": 87.342735,
            "latitude": 53.961102
        },
        "1303": {
            "name": "Колеул",
            "population": 330,
            "type": "village",
            "poly": [
                [
                    87.3287707,
                    56.5205178
                ],
                [
                    87.3291048,
                    56.5207089
                ],
                [
                    87.3306891,
                    56.5207158
                ],
                [
                    87.3333625,
                    56.51948
                ],
                [
                    87.3367539,
                    56.5188108
                ],
                [
                    87.3398481,
                    56.5190293
                ],
                [
                    87.3413334,
                    56.5197258
                ],
                [
                    87.3429672,
                    56.5202925
                ],
                [
                    87.3443781,
                    56.5218696
                ],
                [
                    87.3447371,
                    56.5236857
                ],
                [
                    87.3443163,
                    56.5247166
                ],
                [
                    87.3451703,
                    56.525133
                ],
                [
                    87.3481654,
                    56.5251262
                ],
                [
                    87.3505048,
                    56.5253173
                ],
                [
                    87.3519653,
                    56.5250511
                ],
                [
                    87.3523242,
                    56.5242318
                ],
                [
                    87.3519653,
                    56.5239929
                ],
                [
                    87.3519777,
                    56.5226002
                ],
                [
                    87.3531906,
                    56.521658
                ],
                [
                    87.3542922,
                    56.5202242
                ],
                [
                    87.353958,
                    56.5198691
                ],
                [
                    87.3530545,
                    56.5193297
                ],
                [
                    87.3512226,
                    56.516858
                ],
                [
                    87.3507895,
                    56.5160386
                ],
                [
                    87.3510864,
                    56.5130954
                ],
                [
                    87.3508885,
                    56.5124398
                ],
                [
                    87.3511608,
                    56.5110261
                ],
                [
                    87.3519529,
                    56.5100222
                ],
                [
                    87.3494527,
                    56.5099676
                ],
                [
                    87.3488586,
                    56.5103159
                ],
                [
                    87.3484502,
                    56.5099949
                ],
                [
                    87.3473486,
                    56.5100017
                ],
                [
                    87.3470145,
                    56.5104524
                ],
                [
                    87.3446133,
                    56.510432
                ],
                [
                    87.3443039,
                    56.5101998
                ],
                [
                    87.3434994,
                    56.5101998
                ],
                [
                    87.3420884,
                    56.5106164
                ],
                [
                    87.3391179,
                    56.5107871
                ],
                [
                    87.3371376,
                    56.5110739
                ],
                [
                    87.3362712,
                    56.5119617
                ],
                [
                    87.3362588,
                    56.5127881
                ],
                [
                    87.3359865,
                    56.5142426
                ],
                [
                    87.3351201,
                    56.5148231
                ],
                [
                    87.334068,
                    56.5154923
                ],
                [
                    87.3368653,
                    56.5179505
                ],
                [
                    87.3349097,
                    56.5182031
                ],
                [
                    87.3306272,
                    56.5186265
                ],
                [
                    87.3291296,
                    56.5194458
                ],
                [
                    87.3291172,
                    56.5203266
                ],
                [
                    87.3287707,
                    56.5205178
                ]
            ],
            "longitude": 87.345764,
            "latitude": 56.515823
        },
        "1304": {
            "name": "Чистогорский",
            "population": 4607,
            "type": "village",
            "poly": null,
            "longitude": 87.377029,
            "latitude": 53.967369
        },
        "1305": {
            "name": "Благовещенка",
            "population": 1147,
            "type": "village",
            "poly": [
                [
                    87.3671887,
                    56.3853615
                ],
                [
                    87.3674884,
                    56.3857762
                ],
                [
                    87.3680127,
                    56.3858176
                ],
                [
                    87.369311,
                    56.3868128
                ],
                [
                    87.3710836,
                    56.3868404
                ],
                [
                    87.3721072,
                    56.3875038
                ],
                [
                    87.3726315,
                    56.3882916
                ],
                [
                    87.3733056,
                    56.3885127
                ],
                [
                    87.3763516,
                    56.3885404
                ],
                [
                    87.3774751,
                    56.388955
                ],
                [
                    87.3785486,
                    56.3893281
                ],
                [
                    87.380521,
                    56.3893419
                ],
                [
                    87.3830426,
                    56.3883054
                ],
                [
                    87.3843658,
                    56.388333
                ],
                [
                    87.3888848,
                    56.386564
                ],
                [
                    87.3888598,
                    56.385942
                ],
                [
                    87.3933039,
                    56.3838549
                ],
                [
                    87.3942026,
                    56.3838549
                ],
                [
                    87.3952263,
                    56.3851542
                ],
                [
                    87.3953159,
                    56.3851812
                ],
                [
                    87.3974733,
                    56.3858315
                ],
                [
                    87.4078094,
                    56.3757958
                ],
                [
                    87.408159,
                    56.3743856
                ],
                [
                    87.4066859,
                    56.373086
                ],
                [
                    87.4035402,
                    56.3671265
                ],
                [
                    87.4026164,
                    56.3642916
                ],
                [
                    87.3994456,
                    56.3644852
                ],
                [
                    87.3993458,
                    56.3658542
                ],
                [
                    87.3955509,
                    56.3689794
                ],
                [
                    87.3928794,
                    56.3681636
                ],
                [
                    87.3926298,
                    56.3683572
                ],
                [
                    87.3928794,
                    56.3702792
                ],
                [
                    87.3918307,
                    56.3704727
                ],
                [
                    87.3917809,
                    56.371095
                ],
                [
                    87.3906075,
                    56.3712885
                ],
                [
                    87.387212,
                    56.3729615
                ],
                [
                    87.387212,
                    56.3756713
                ],
                [
                    87.3729062,
                    56.3809384
                ],
                [
                    87.3711585,
                    56.3792242
                ],
                [
                    87.3697604,
                    56.3799016
                ],
                [
                    87.369336,
                    56.3822239
                ],
                [
                    87.3706842,
                    56.3838688
                ],
                [
                    87.3688117,
                    56.3847534
                ],
                [
                    87.3671887,
                    56.3853615
                ]
            ],
            "longitude": 87.38681,
            "latitude": 56.380539
        },
        "1306": {
            "name": "Атаманово",
            "population": 2954,
            "type": "village",
            "poly": [
                [
                    87.3722072,
                    53.7776954
                ],
                [
                    87.3755975,
                    53.7798965
                ],
                [
                    87.3787304,
                    53.7823689
                ],
                [
                    87.3784557,
                    53.7834541
                ],
                [
                    87.381589,
                    53.7866676
                ],
                [
                    87.3854423,
                    53.7889002
                ],
                [
                    87.3870731,
                    53.7876833
                ],
                [
                    87.3953129,
                    53.7886974
                ],
                [
                    87.4033588,
                    53.7920429
                ],
                [
                    87.4059559,
                    53.7917904
                ],
                [
                    87.4121608,
                    53.7872704
                ],
                [
                    87.4160839,
                    53.7872776
                ],
                [
                    87.4176421,
                    53.7838487
                ],
                [
                    87.3974183,
                    53.7776697
                ],
                [
                    87.3976157,
                    53.7768702
                ],
                [
                    87.3920806,
                    53.7694949
                ],
                [
                    87.3898394,
                    53.7683668
                ],
                [
                    87.3871589,
                    53.7675478
                ],
                [
                    87.3835541,
                    53.7675478
                ],
                [
                    87.381065,
                    53.7676493
                ],
                [
                    87.3786253,
                    53.7675428
                ],
                [
                    87.3767734,
                    53.7689682
                ],
                [
                    87.3772026,
                    53.7696785
                ],
                [
                    87.3756576,
                    53.771251
                ],
                [
                    87.3734818,
                    53.7737442
                ],
                [
                    87.3722072,
                    53.7776954
                ]
            ],
            "longitude": 87.393791,
            "latitude": 53.785049
        },
        "1307": {
            "name": "Тальжино",
            "population": 1532,
            "type": "village",
            "poly": null,
            "longitude": 87.406693,
            "latitude": 53.760323
        },
        "1308": {
            "name": "Славино",
            "population": 344,
            "type": "village",
            "poly": null,
            "longitude": 87.410324,
            "latitude": 54.032951
        },
        "1309": {
            "name": "Баевка",
            "population": 304,
            "type": "village",
            "poly": null,
            "longitude": 87.413681,
            "latitude": 53.725246
        },
        "1310": {
            "name": "Усманка",
            "population": 772,
            "type": "village",
            "poly": [
                [
                    87.3971395,
                    55.9477651
                ],
                [
                    87.4042474,
                    55.9544871
                ],
                [
                    87.4134458,
                    55.9590012
                ],
                [
                    87.4198369,
                    55.9603051
                ],
                [
                    87.4196577,
                    55.9608735
                ],
                [
                    87.4158947,
                    55.9627792
                ],
                [
                    87.4161336,
                    55.9640831
                ],
                [
                    87.4130277,
                    55.9661892
                ],
                [
                    87.4138639,
                    55.9667575
                ],
                [
                    87.4148196,
                    55.9668912
                ],
                [
                    87.4190007,
                    55.9695989
                ],
                [
                    87.4206731,
                    55.9694652
                ],
                [
                    87.4237791,
                    55.9668578
                ],
                [
                    87.4253918,
                    55.9635816
                ],
                [
                    87.4281393,
                    55.9607732
                ],
                [
                    87.4292145,
                    55.9607732
                ],
                [
                    87.4377558,
                    55.9630467
                ],
                [
                    87.439488,
                    55.9614419
                ],
                [
                    87.4335055,
                    55.9569134
                ],
                [
                    87.4289182,
                    55.9543025
                ],
                [
                    87.4236811,
                    55.9519696
                ],
                [
                    87.4184439,
                    55.9499791
                ],
                [
                    87.4137037,
                    55.9486306
                ],
                [
                    87.4081609,
                    55.9476032
                ],
                [
                    87.4026562,
                    55.9470681
                ],
                [
                    87.3983341,
                    55.9468955
                ],
                [
                    87.3971395,
                    55.9477651
                ]
            ],
            "longitude": 87.4164101,
            "latitude": 55.9547936
        },
        "1311": {
            "name": "Тайжина",
            "population": 5011,
            "type": "village",
            "poly": null,
            "longitude": 87.437691,
            "latitude": 53.674171
        },
        "1312": {
            "name": "Георгиевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.4540584,
            "latitude": 54.2991283
        },
        "1313": {
            "name": "Таёжно-Михайловка",
            "population": 335,
            "type": "village",
            "poly": [
                [
                    87.4494583,
                    56.5272237
                ],
                [
                    87.4510468,
                    56.528045
                ],
                [
                    87.4518079,
                    56.5275705
                ],
                [
                    87.4524036,
                    56.5276252
                ],
                [
                    87.4584267,
                    56.531385
                ],
                [
                    87.4571691,
                    56.5332283
                ],
                [
                    87.4587576,
                    56.533721
                ],
                [
                    87.4591216,
                    56.535035
                ],
                [
                    87.4602137,
                    56.5353634
                ],
                [
                    87.4591216,
                    56.5358196
                ],
                [
                    87.4580296,
                    56.5354729
                ],
                [
                    87.4572684,
                    56.5360204
                ],
                [
                    87.4572684,
                    56.5368051
                ],
                [
                    87.4587245,
                    56.5370788
                ],
                [
                    87.4599159,
                    56.5357649
                ],
                [
                    87.4611073,
                    56.5356189
                ],
                [
                    87.4625633,
                    56.5357467
                ],
                [
                    87.4656742,
                    56.5377539
                ],
                [
                    87.4662699,
                    56.5379547
                ],
                [
                    87.4675275,
                    56.5374437
                ],
                [
                    87.4674282,
                    56.5366226
                ],
                [
                    87.4679908,
                    56.5363489
                ],
                [
                    87.4692814,
                    56.5363306
                ],
                [
                    87.4693145,
                    56.5358014
                ],
                [
                    87.4697448,
                    56.5355824
                ],
                [
                    87.470539,
                    56.5356007
                ],
                [
                    87.4704397,
                    56.5361846
                ],
                [
                    87.4715317,
                    56.5362394
                ],
                [
                    87.4723923,
                    56.5366226
                ],
                [
                    87.4720944,
                    56.5371153
                ],
                [
                    87.4734844,
                    56.5372977
                ],
                [
                    87.4739477,
                    56.5370605
                ],
                [
                    87.4742786,
                    56.5376445
                ],
                [
                    87.4762312,
                    56.5376627
                ],
                [
                    87.4770585,
                    56.5371518
                ],
                [
                    87.4773232,
                    56.5374802
                ],
                [
                    87.4767276,
                    56.5380459
                ],
                [
                    87.477952,
                    56.5383561
                ],
                [
                    87.4794082,
                    56.5379364
                ],
                [
                    87.4787793,
                    56.5372795
                ],
                [
                    87.4803348,
                    56.5374985
                ],
                [
                    87.4830485,
                    56.5385021
                ],
                [
                    87.4851996,
                    56.5385386
                ],
                [
                    87.486424,
                    56.5377904
                ],
                [
                    87.4858284,
                    56.5375167
                ],
                [
                    87.4867881,
                    56.5369875
                ],
                [
                    87.4863579,
                    56.5360204
                ],
                [
                    87.4872514,
                    56.5355277
                ],
                [
                    87.4851003,
                    56.5351262
                ],
                [
                    87.4836442,
                    56.5339765
                ],
                [
                    87.482519,
                    56.5336663
                ],
                [
                    87.4820888,
                    56.5339218
                ],
                [
                    87.4802355,
                    56.533064
                ],
                [
                    87.4776542,
                    56.5323705
                ],
                [
                    87.4780181,
                    56.531604
                ],
                [
                    87.4771909,
                    56.5315675
                ],
                [
                    87.4766944,
                    56.5320603
                ],
                [
                    87.4757017,
                    56.5320238
                ],
                [
                    87.4746757,
                    56.531385
                ],
                [
                    87.4745765,
                    56.5305272
                ],
                [
                    87.4722599,
                    56.5305272
                ],
                [
                    87.4718959,
                    56.5299249
                ],
                [
                    87.4726239,
                    56.5292314
                ],
                [
                    87.4733189,
                    56.5293044
                ],
                [
                    87.4769923,
                    56.5305272
                ],
                [
                    87.4789779,
                    56.5284831
                ],
                [
                    87.478647,
                    56.5280815
                ],
                [
                    87.477621,
                    56.5275522
                ],
                [
                    87.4695462,
                    56.5261102
                ],
                [
                    87.4674613,
                    56.5260737
                ],
                [
                    87.467726,
                    56.524723
                ],
                [
                    87.4671634,
                    56.5243214
                ],
                [
                    87.4631922,
                    56.5242484
                ],
                [
                    87.4604784,
                    56.5251428
                ],
                [
                    87.4581288,
                    56.5251063
                ],
                [
                    87.4570035,
                    56.5255444
                ],
                [
                    87.454323,
                    56.5255444
                ],
                [
                    87.4533633,
                    56.5264205
                ],
                [
                    87.4497892,
                    56.5268221
                ],
                [
                    87.4494583,
                    56.5272237
                ]
            ],
            "longitude": 87.466362,
            "latitude": 56.532303
        },
        "1314": {
            "name": "Белый Этап",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.4705339,
            "latitude": 54.118747
        },
        "1315": {
            "name": "Барзас",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.4773915,
            "latitude": 54.1485621
        },
        "1316": {
            "name": "Боровково",
            "population": 300,
            "type": "village",
            "poly": [
                [
                    87.4913028,
                    53.793259
                ],
                [
                    87.4941307,
                    53.7950639
                ],
                [
                    87.5043378,
                    53.7913772
                ],
                [
                    87.5069057,
                    53.7911084
                ],
                [
                    87.5074583,
                    53.7896106
                ],
                [
                    87.4964388,
                    53.7900522
                ],
                [
                    87.4913028,
                    53.793259
                ]
            ],
            "longitude": 87.498199,
            "latitude": 53.791348
        },
        "1317": {
            "name": "Амзас",
            "population": 391,
            "type": "village",
            "poly": null,
            "longitude": 87.5423069,
            "latitude": 53.0147248
        },
        "1318": {
            "name": "Безруково",
            "population": 1814,
            "type": "village",
            "poly": [
                [
                    87.5418423,
                    53.7844972
                ],
                [
                    87.5434323,
                    53.7848653
                ],
                [
                    87.5491902,
                    53.7811586
                ],
                [
                    87.5563837,
                    53.7794162
                ],
                [
                    87.5610499,
                    53.7758455
                ],
                [
                    87.5652462,
                    53.7731672
                ],
                [
                    87.5625606,
                    53.7718578
                ],
                [
                    87.5523888,
                    53.7756669
                ],
                [
                    87.5444998,
                    53.7801898
                ],
                [
                    87.5418423,
                    53.7844972
                ]
            ],
            "longitude": 87.552422,
            "latitude": 53.778408
        },
        "1319": {
            "name": "Тенгулы",
            "population": 309,
            "type": "village",
            "poly": [
                [
                    87.5403635,
                    56.3806822
                ],
                [
                    87.5430161,
                    56.3814597
                ],
                [
                    87.5449926,
                    56.3811718
                ],
                [
                    87.5474372,
                    56.3824388
                ],
                [
                    87.5501939,
                    56.38241
                ],
                [
                    87.5532106,
                    56.3839074
                ],
                [
                    87.5556031,
                    56.3841666
                ],
                [
                    87.5530026,
                    56.385232
                ],
                [
                    87.5515982,
                    56.3851456
                ],
                [
                    87.550766,
                    56.3854336
                ],
                [
                    87.5511821,
                    56.3858079
                ],
                [
                    87.5549271,
                    56.3860383
                ],
                [
                    87.554875,
                    56.3856639
                ],
                [
                    87.5538868,
                    56.3852608
                ],
                [
                    87.5563834,
                    56.3843682
                ],
                [
                    87.5602324,
                    56.3864702
                ],
                [
                    87.5630411,
                    56.3851168
                ],
                [
                    87.5631451,
                    56.3846849
                ],
                [
                    87.5617407,
                    56.3831875
                ],
                [
                    87.5595562,
                    56.3822949
                ],
                [
                    87.5611686,
                    56.3809414
                ],
                [
                    87.5623129,
                    56.3809414
                ],
                [
                    87.5636652,
                    56.3819781
                ],
                [
                    87.5638733,
                    56.3832739
                ],
                [
                    87.5648095,
                    56.3840514
                ],
                [
                    87.566682,
                    56.3843394
                ],
                [
                    87.5722993,
                    56.384397
                ],
                [
                    87.5719845,
                    56.3833967
                ],
                [
                    87.5701538,
                    56.3827885
                ],
                [
                    87.5692883,
                    56.3832308
                ],
                [
                    87.5673243,
                    56.3811482
                ],
                [
                    87.5681898,
                    56.38054
                ],
                [
                    87.566592,
                    56.379213
                ],
                [
                    87.5684894,
                    56.3768168
                ],
                [
                    87.569622,
                    56.3763556
                ],
                [
                    87.5683267,
                    56.3756289
                ],
                [
                    87.5541469,
                    56.3755558
                ],
                [
                    87.5526905,
                    56.3771111
                ],
                [
                    87.5543549,
                    56.3782055
                ],
                [
                    87.5563314,
                    56.3786375
                ],
                [
                    87.5579438,
                    56.3793575
                ],
                [
                    87.5582039,
                    56.3797318
                ],
                [
                    87.5592961,
                    56.3803366
                ],
                [
                    87.5604404,
                    56.3802502
                ],
                [
                    87.5608045,
                    56.3805958
                ],
                [
                    87.558724,
                    56.3823812
                ],
                [
                    87.5569556,
                    56.3816613
                ],
                [
                    87.5574757,
                    56.3811142
                ],
                [
                    87.5552911,
                    56.3807398
                ],
                [
                    87.5529506,
                    56.3799046
                ],
                [
                    87.5498818,
                    56.3798758
                ],
                [
                    87.5435883,
                    56.3788679
                ],
                [
                    87.5425999,
                    56.3788679
                ],
                [
                    87.5422359,
                    56.3798182
                ],
                [
                    87.5408836,
                    56.3799046
                ],
                [
                    87.5403635,
                    56.3806822
                ]
            ],
            "longitude": 87.552467,
            "latitude": 56.382576
        },
        "1320": {
            "name": "Осиновое Плесо",
            "population": 795,
            "type": "village",
            "poly": null,
            "longitude": 87.554848,
            "latitude": 54.211418
        },
        "1321": {
            "name": "Калары",
            "population": 444,
            "type": "village",
            "poly": null,
            "longitude": 87.5729454,
            "latitude": 52.9184794
        },
        "1322": {
            "name": "Верх-Чебула",
            "population": 4638,
            "type": "village",
            "poly": [
                [
                    87.5637103,
                    56.0149735
                ],
                [
                    87.5691539,
                    56.0164607
                ],
                [
                    87.5729766,
                    56.019999
                ],
                [
                    87.5808361,
                    56.0271599
                ],
                [
                    87.5853316,
                    56.0302871
                ],
                [
                    87.5943226,
                    56.0347809
                ],
                [
                    87.5989033,
                    56.0373939
                ],
                [
                    87.602335,
                    56.0403846
                ],
                [
                    87.6126716,
                    56.0491131
                ],
                [
                    87.6282425,
                    56.0619266
                ],
                [
                    87.6312702,
                    56.06319
                ],
                [
                    87.6318197,
                    56.0568885
                ],
                [
                    87.6463787,
                    56.0536783
                ],
                [
                    87.6449602,
                    56.0495505
                ],
                [
                    87.6478721,
                    56.0477158
                ],
                [
                    87.6479467,
                    56.0470069
                ],
                [
                    87.6440643,
                    56.0447967
                ],
                [
                    87.6439896,
                    56.032284
                ],
                [
                    87.6414511,
                    56.0279454
                ],
                [
                    87.6349474,
                    56.0223078
                ],
                [
                    87.6370939,
                    56.0206387
                ],
                [
                    87.6330285,
                    56.0169873
                ],
                [
                    87.6279254,
                    56.0164364
                ],
                [
                    87.6241923,
                    56.0186273
                ],
                [
                    87.6070199,
                    56.0128368
                ],
                [
                    87.6041268,
                    56.0154452
                ],
                [
                    87.6034735,
                    56.0133063
                ],
                [
                    87.6017002,
                    56.0136193
                ],
                [
                    87.6031002,
                    56.0169059
                ],
                [
                    87.600767,
                    56.0194097
                ],
                [
                    87.5832324,
                    56.0154479
                ],
                [
                    87.581784,
                    56.0174179
                ],
                [
                    87.5654535,
                    56.0133837
                ],
                [
                    87.5637103,
                    56.0149735
                ]
            ],
            "longitude": 87.610344,
            "latitude": 56.0294
        },
        "1323": {
            "name": "Базанча",
            "population": 663,
            "type": "village",
            "poly": null,
            "longitude": 87.61187,
            "latitude": 52.888298
        },
        "1324": {
            "name": "Берензас",
            "population": 360,
            "type": "village",
            "poly": null,
            "longitude": 87.6182002,
            "latitude": 53.7224178
        },
        "1325": {
            "name": "Обояновка",
            "population": 282,
            "type": "village",
            "poly": [
                [
                    87.6016655,
                    56.3550577
                ],
                [
                    87.6047863,
                    56.3574891
                ],
                [
                    87.608346,
                    56.3584076
                ],
                [
                    87.6121495,
                    56.3584346
                ],
                [
                    87.616977,
                    56.359056
                ],
                [
                    87.6171233,
                    56.3601095
                ],
                [
                    87.6191226,
                    56.3624596
                ],
                [
                    87.6202929,
                    56.3627297
                ],
                [
                    87.6218045,
                    56.3624866
                ],
                [
                    87.6228773,
                    56.3624326
                ],
                [
                    87.6249741,
                    56.3645934
                ],
                [
                    87.6255593,
                    56.3645664
                ],
                [
                    87.6278511,
                    56.3638641
                ],
                [
                    87.6290702,
                    56.3637561
                ],
                [
                    87.6299967,
                    56.3626216
                ],
                [
                    87.6312157,
                    56.3603796
                ],
                [
                    87.6318009,
                    56.3603256
                ],
                [
                    87.6329224,
                    56.36119
                ],
                [
                    87.6337026,
                    56.36119
                ],
                [
                    87.6345316,
                    56.3607848
                ],
                [
                    87.6356044,
                    56.3607578
                ],
                [
                    87.6357019,
                    56.3614331
                ],
                [
                    87.6364334,
                    56.3614601
                ],
                [
                    87.6363846,
                    56.3607038
                ],
                [
                    87.6386277,
                    56.3596773
                ],
                [
                    87.6412609,
                    56.3598934
                ],
                [
                    87.6418948,
                    56.3593531
                ],
                [
                    87.6375061,
                    56.3557601
                ],
                [
                    87.6294603,
                    56.3534637
                ],
                [
                    87.6287288,
                    56.3544093
                ],
                [
                    87.6218533,
                    56.3527072
                ],
                [
                    87.6210243,
                    56.3531665
                ],
                [
                    87.6109792,
                    56.3509779
                ],
                [
                    87.6091413,
                    56.3508478
                ],
                [
                    87.6085898,
                    56.3513832
                ],
                [
                    87.6045424,
                    56.3520857
                ],
                [
                    87.6053227,
                    56.3535717
                ],
                [
                    87.6030796,
                    56.3546795
                ],
                [
                    87.6022506,
                    56.3541391
                ],
                [
                    87.6016655,
                    56.3550577
                ]
            ],
            "longitude": 87.62458,
            "latitude": 56.358444
        },
        "1326": {
            "name": "Калининский",
            "population": 1533,
            "type": "village",
            "poly": [
                [
                    87.6246828,
                    56.1962719
                ],
                [
                    87.6248345,
                    56.1968837
                ],
                [
                    87.6272993,
                    56.1985292
                ],
                [
                    87.6305983,
                    56.198603
                ],
                [
                    87.6302002,
                    56.1999215
                ],
                [
                    87.6302191,
                    56.200375
                ],
                [
                    87.6305225,
                    56.2006281
                ],
                [
                    87.6319634,
                    56.2009445
                ],
                [
                    87.6319065,
                    56.2011766
                ],
                [
                    87.6315463,
                    56.2013875
                ],
                [
                    87.6308258,
                    56.201725
                ],
                [
                    87.631224,
                    56.2027797
                ],
                [
                    87.6317928,
                    56.203423
                ],
                [
                    87.6323237,
                    56.2037605
                ],
                [
                    87.6327976,
                    56.2037077
                ],
                [
                    87.6332148,
                    56.2035074
                ],
                [
                    87.6355468,
                    56.2005437
                ],
                [
                    87.6357553,
                    56.1997738
                ],
                [
                    87.6363621,
                    56.199816
                ],
                [
                    87.6372722,
                    56.1991409
                ],
                [
                    87.6379737,
                    56.1989089
                ],
                [
                    87.6384856,
                    56.1988456
                ],
                [
                    87.6392819,
                    56.1992886
                ],
                [
                    87.6394715,
                    56.1997
                ],
                [
                    87.6416329,
                    56.2005543
                ],
                [
                    87.6424103,
                    56.2006176
                ],
                [
                    87.6430739,
                    56.2003644
                ],
                [
                    87.6426568,
                    56.200048
                ],
                [
                    87.643434,
                    56.199489
                ],
                [
                    87.6431687,
                    56.1993308
                ],
                [
                    87.6432824,
                    56.1992042
                ],
                [
                    87.6444959,
                    56.1991937
                ],
                [
                    87.6446475,
                    56.1987612
                ],
                [
                    87.6452163,
                    56.1987401
                ],
                [
                    87.6475105,
                    56.1976221
                ],
                [
                    87.6516058,
                    56.1987085
                ],
                [
                    87.6559476,
                    56.1995628
                ],
                [
                    87.6578056,
                    56.1966095
                ],
                [
                    87.6358726,
                    56.1917397
                ],
                [
                    87.6348872,
                    56.1916223
                ],
                [
                    87.6342616,
                    56.1913374
                ],
                [
                    87.6322329,
                    56.1908943
                ],
                [
                    87.6296354,
                    56.1905462
                ],
                [
                    87.6291384,
                    56.1913878
                ],
                [
                    87.6292522,
                    56.191546
                ],
                [
                    87.6262944,
                    56.194869
                ],
                [
                    87.6262186,
                    56.1950588
                ],
                [
                    87.6273372,
                    56.1954808
                ],
                [
                    87.6268443,
                    56.195523
                ],
                [
                    87.6246828,
                    56.1962719
                ]
            ],
            "longitude": 87.638901,
            "latitude": 56.195591
        },
        "1327": {
            "name": "Центральный",
            "population": 369,
            "type": "village",
            "poly": [
                [
                    87.6293994,
                    55.2139272
                ],
                [
                    87.6297206,
                    55.2151575
                ],
                [
                    87.632703,
                    55.2159428
                ],
                [
                    87.6345362,
                    55.2158765
                ],
                [
                    87.634742,
                    55.2168109
                ],
                [
                    87.6333793,
                    55.2176253
                ],
                [
                    87.6333793,
                    55.2179629
                ],
                [
                    87.6372334,
                    55.2179367
                ],
                [
                    87.6370959,
                    55.216183
                ],
                [
                    87.6397111,
                    55.2165233
                ],
                [
                    87.6437489,
                    55.2164709
                ],
                [
                    87.6438866,
                    55.2158427
                ],
                [
                    87.6427853,
                    55.2156595
                ],
                [
                    87.6454007,
                    55.2139057
                ],
                [
                    87.6480161,
                    55.216628
                ],
                [
                    87.6465937,
                    55.2168636
                ],
                [
                    87.6476031,
                    55.2185387
                ],
                [
                    87.6524209,
                    55.2208682
                ],
                [
                    87.6547609,
                    55.2207896
                ],
                [
                    87.6547151,
                    55.2220459
                ],
                [
                    87.6569633,
                    55.2222291
                ],
                [
                    87.6584775,
                    55.2219674
                ],
                [
                    87.6595339,
                    55.2230631
                ],
                [
                    87.6593683,
                    55.2256107
                ],
                [
                    87.6613798,
                    55.2261659
                ],
                [
                    87.6618989,
                    55.2256477
                ],
                [
                    87.6603416,
                    55.2246115
                ],
                [
                    87.662418,
                    55.2205772
                ],
                [
                    87.6596926,
                    55.2196888
                ],
                [
                    87.6570323,
                    55.2172088
                ],
                [
                    87.6604714,
                    55.2173568
                ],
                [
                    87.6591087,
                    55.2142103
                ],
                [
                    87.6554101,
                    55.2128405
                ],
                [
                    87.6583301,
                    55.2114707
                ],
                [
                    87.6561238,
                    55.2096196
                ],
                [
                    87.6563509,
                    55.2077035
                ],
                [
                    87.6581004,
                    55.2078205
                ],
                [
                    87.6555741,
                    55.2043425
                ],
                [
                    87.6534652,
                    55.2023614
                ],
                [
                    87.6559634,
                    55.2031576
                ],
                [
                    87.6577154,
                    55.2026576
                ],
                [
                    87.6581697,
                    55.20188
                ],
                [
                    87.6588454,
                    55.2018168
                ],
                [
                    87.6594781,
                    55.2010761
                ],
                [
                    87.6607628,
                    55.2009899
                ],
                [
                    87.6612217,
                    55.1989736
                ],
                [
                    87.6570463,
                    55.1970095
                ],
                [
                    87.6535133,
                    55.1976118
                ],
                [
                    87.6537886,
                    55.1997592
                ],
                [
                    87.6527332,
                    55.1997592
                ],
                [
                    87.651265,
                    55.199733
                ],
                [
                    87.651265,
                    55.2000472
                ],
                [
                    87.6498426,
                    55.1999163
                ],
                [
                    87.6484202,
                    55.1981094
                ],
                [
                    87.6478926,
                    55.1983189
                ],
                [
                    87.6485349,
                    55.2002698
                ],
                [
                    87.647319,
                    55.2006626
                ],
                [
                    87.6494296,
                    55.2017362
                ],
                [
                    87.6493608,
                    55.2021813
                ],
                [
                    87.6477549,
                    55.2021159
                ],
                [
                    87.6438526,
                    55.2029313
                ],
                [
                    87.6422467,
                    55.2021458
                ],
                [
                    87.6365113,
                    55.2042929
                ],
                [
                    87.637429,
                    55.2051569
                ],
                [
                    87.6353642,
                    55.2058377
                ],
                [
                    87.6352724,
                    55.2052878
                ],
                [
                    87.6342171,
                    55.2058115
                ],
                [
                    87.6356854,
                    55.2079322
                ],
                [
                    87.6332536,
                    55.2094245
                ],
                [
                    87.6329783,
                    55.2106026
                ],
                [
                    87.6345383,
                    55.212566
                ],
                [
                    87.6309594,
                    55.2127231
                ],
                [
                    87.6293994,
                    55.2139272
                ]
            ],
            "longitude": 87.648727,
            "latitude": 55.21376
        },
        "1328": {
            "name": "Подобас",
            "population": 1126,
            "type": "village",
            "poly": null,
            "longitude": 87.662628,
            "latitude": 53.76976
        },
        "1329": {
            "name": "Алтамаш",
            "population": 303,
            "type": "village",
            "poly": null,
            "longitude": 87.679642,
            "latitude": 52.545834
        },
        "1330": {
            "name": "Малый Антибес",
            "population": 238,
            "type": "village",
            "poly": [
                [
                    87.6916508,
                    56.2848634
                ],
                [
                    87.6916691,
                    56.2859535
                ],
                [
                    87.6919628,
                    56.2861573
                ],
                [
                    87.6925684,
                    56.2870946
                ],
                [
                    87.6935597,
                    56.2870946
                ],
                [
                    87.7013126,
                    56.2848884
                ],
                [
                    87.7016049,
                    56.2838875
                ],
                [
                    87.7030146,
                    56.2841157
                ],
                [
                    87.7043656,
                    56.284833
                ],
                [
                    87.7032202,
                    56.2854198
                ],
                [
                    87.7036754,
                    56.2858274
                ],
                [
                    87.7043215,
                    56.2858274
                ],
                [
                    87.7043656,
                    56.2856155
                ],
                [
                    87.7050411,
                    56.2856073
                ],
                [
                    87.7056431,
                    56.286512
                ],
                [
                    87.7073025,
                    56.2874656
                ],
                [
                    87.7076696,
                    56.2874656
                ],
                [
                    87.7124421,
                    56.2902937
                ],
                [
                    87.7190501,
                    56.2872374
                ],
                [
                    87.7183599,
                    56.2869521
                ],
                [
                    87.7183304,
                    56.2865691
                ],
                [
                    87.7178084,
                    56.2862365
                ],
                [
                    87.7163752,
                    56.2860148
                ],
                [
                    87.7163752,
                    56.2854019
                ],
                [
                    87.7157409,
                    56.2850433
                ],
                [
                    87.7146836,
                    56.2852389
                ],
                [
                    87.7132034,
                    56.2852193
                ],
                [
                    87.7123693,
                    56.2847238
                ],
                [
                    87.7123811,
                    56.283374
                ],
                [
                    87.7120756,
                    56.2831914
                ],
                [
                    87.7103722,
                    56.2832109
                ],
                [
                    87.7097614,
                    56.2828066
                ],
                [
                    87.7086805,
                    56.2828392
                ],
                [
                    87.7064484,
                    56.281209
                ],
                [
                    87.7064838,
                    56.2806155
                ],
                [
                    87.7050271,
                    56.2801003
                ],
                [
                    87.7042576,
                    56.2799705
                ],
                [
                    87.701282,
                    56.2805675
                ],
                [
                    87.699819,
                    56.2806043
                ],
                [
                    87.6994519,
                    56.2803801
                ],
                [
                    87.698736,
                    56.28037
                ],
                [
                    87.6980018,
                    56.2807877
                ],
                [
                    87.6979651,
                    56.2811342
                ],
                [
                    87.6987727,
                    56.281501
                ],
                [
                    87.6987177,
                    56.2819188
                ],
                [
                    87.6967535,
                    56.2831618
                ],
                [
                    87.6960377,
                    56.2835694
                ],
                [
                    87.6957624,
                    56.2837222
                ],
                [
                    87.6947345,
                    56.2837324
                ],
                [
                    87.6943857,
                    56.2839056
                ],
                [
                    87.694349,
                    56.2844966
                ],
                [
                    87.6940921,
                    56.2847003
                ],
                [
                    87.6933945,
                    56.2842928
                ],
                [
                    87.6924584,
                    56.284303
                ],
                [
                    87.6916508,
                    56.2848634
                ]
            ],
            "longitude": 87.701164,
            "latitude": 56.283062
        },
        "1331": {
            "name": "Бородино",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 87.7484839,
            "latitude": 53.7391116
        },
        "1332": {
            "name": "Спасск",
            "population": 1710,
            "type": "village",
            "poly": [
                [
                    87.7258419,
                    52.7489884
                ],
                [
                    87.7263369,
                    52.7527576
                ],
                [
                    87.7318036,
                    52.7568784
                ],
                [
                    87.7556585,
                    52.7582018
                ],
                [
                    87.7592863,
                    52.7601567
                ],
                [
                    87.78006,
                    52.7584725
                ],
                [
                    87.7906953,
                    52.7564874
                ],
                [
                    87.7876526,
                    52.7512777
                ],
                [
                    87.7749882,
                    52.7505559
                ],
                [
                    87.7645318,
                    52.7498098
                ],
                [
                    87.7628619,
                    52.7479808
                ],
                [
                    87.7585681,
                    52.7479327
                ],
                [
                    87.7588464,
                    52.7476439
                ],
                [
                    87.7589259,
                    52.7468016
                ],
                [
                    87.7599994,
                    52.7468016
                ],
                [
                    87.7600407,
                    52.7465965
                ],
                [
                    87.7587939,
                    52.7465811
                ],
                [
                    87.7587939,
                    52.7459496
                ],
                [
                    87.7598626,
                    52.7440857
                ],
                [
                    87.7619236,
                    52.7416056
                ],
                [
                    87.7612366,
                    52.7410048
                ],
                [
                    87.7637048,
                    52.7401884
                ],
                [
                    87.7661476,
                    52.7387865
                ],
                [
                    87.7680558,
                    52.737061
                ],
                [
                    87.7673944,
                    52.7368298
                ],
                [
                    87.7652061,
                    52.7369377
                ],
                [
                    87.7646208,
                    52.7376464
                ],
                [
                    87.7641119,
                    52.7385092
                ],
                [
                    87.7635521,
                    52.7387711
                ],
                [
                    87.7599389,
                    52.7399419
                ],
                [
                    87.7552061,
                    52.7408507
                ],
                [
                    87.7533486,
                    52.7405272
                ],
                [
                    87.7514402,
                    52.7403886
                ],
                [
                    87.7503715,
                    52.7404194
                ],
                [
                    87.7496845,
                    52.7401113
                ],
                [
                    87.7490738,
                    52.740404
                ],
                [
                    87.7486413,
                    52.740173
                ],
                [
                    87.7488957,
                    52.7397878
                ],
                [
                    87.7493283,
                    52.739603
                ],
                [
                    87.7495064,
                    52.7390637
                ],
                [
                    87.744737,
                    52.7378201
                ],
                [
                    87.7438052,
                    52.7393246
                ],
                [
                    87.7460416,
                    52.7442147
                ],
                [
                    87.7456781,
                    52.7443506
                ],
                [
                    87.7460507,
                    52.7447779
                ],
                [
                    87.7465385,
                    52.7447027
                ],
                [
                    87.7468705,
                    52.7455162
                ],
                [
                    87.7455488,
                    52.7461601
                ],
                [
                    87.7451215,
                    52.7459838
                ],
                [
                    87.7442077,
                    52.7458829
                ],
                [
                    87.7426068,
                    52.7458869
                ],
                [
                    87.7409948,
                    52.7459855
                ],
                [
                    87.7388686,
                    52.7460107
                ],
                [
                    87.7379827,
                    52.7459539
                ],
                [
                    87.7363464,
                    52.7454239
                ],
                [
                    87.7356064,
                    52.7453356
                ],
                [
                    87.7348873,
                    52.7457015
                ],
                [
                    87.7339597,
                    52.7457899
                ],
                [
                    87.7309893,
                    52.7457899
                ],
                [
                    87.7296761,
                    52.7459727
                ],
                [
                    87.7258419,
                    52.7489884
                ]
            ],
            "longitude": 87.754295,
            "latitude": 52.748081
        },
        "1333": {
            "name": "Большой Антибес",
            "population": 396,
            "type": "village",
            "poly": [
                [
                    87.7416978,
                    56.3051634
                ],
                [
                    87.7420322,
                    56.3084677
                ],
                [
                    87.7433538,
                    56.3085899
                ],
                [
                    87.7437209,
                    56.3083455
                ],
                [
                    87.7441247,
                    56.3083659
                ],
                [
                    87.7446937,
                    56.3093026
                ],
                [
                    87.7460888,
                    56.3100765
                ],
                [
                    87.7473553,
                    56.310555
                ],
                [
                    87.7490073,
                    56.3110844
                ],
                [
                    87.7493928,
                    56.3115121
                ],
                [
                    87.7497599,
                    56.3124793
                ],
                [
                    87.7507878,
                    56.3132225
                ],
                [
                    87.7527151,
                    56.3141184
                ],
                [
                    87.7541284,
                    56.3143831
                ],
                [
                    87.7593782,
                    56.3105143
                ],
                [
                    87.7647197,
                    56.3076938
                ],
                [
                    87.7649974,
                    56.3065594
                ],
                [
                    87.7651235,
                    56.3060442
                ],
                [
                    87.7664084,
                    56.3054231
                ],
                [
                    87.7678768,
                    56.3054435
                ],
                [
                    87.7674914,
                    56.3045066
                ],
                [
                    87.7657659,
                    56.3039567
                ],
                [
                    87.7657659,
                    56.3032133
                ],
                [
                    87.7651786,
                    56.3028467
                ],
                [
                    87.7648114,
                    56.3028161
                ],
                [
                    87.7641323,
                    56.3034373
                ],
                [
                    87.762517,
                    56.3026532
                ],
                [
                    87.7618746,
                    56.302643
                ],
                [
                    87.7603694,
                    56.3033762
                ],
                [
                    87.7604036,
                    56.3024259
                ],
                [
                    87.7604061,
                    56.3023579
                ],
                [
                    87.7591212,
                    56.3017468
                ],
                [
                    87.7590662,
                    56.3014108
                ],
                [
                    87.7598371,
                    56.3010441
                ],
                [
                    87.7598371,
                    56.3006368
                ],
                [
                    87.7581851,
                    56.2994961
                ],
                [
                    87.7571572,
                    56.2995063
                ],
                [
                    87.7551931,
                    56.3004738
                ],
                [
                    87.7543855,
                    56.3003007
                ],
                [
                    87.7544038,
                    56.2998729
                ],
                [
                    87.7551748,
                    56.2997202
                ],
                [
                    87.7531924,
                    56.2985998
                ],
                [
                    87.7508846,
                    56.2971448
                ],
                [
                    87.7479156,
                    56.2963056
                ],
                [
                    87.7471314,
                    56.2963056
                ],
                [
                    87.7465153,
                    56.2968961
                ],
                [
                    87.7472435,
                    56.2973624
                ],
                [
                    87.7460111,
                    56.2981705
                ],
                [
                    87.7464592,
                    56.2985124
                ],
                [
                    87.7464032,
                    56.2996003
                ],
                [
                    87.7467953,
                    56.3001597
                ],
                [
                    87.7441274,
                    56.3026087
                ],
                [
                    87.7416978,
                    56.3051634
                ]
            ],
            "longitude": 87.755768,
            "latitude": 56.306705
        },
        "1334": {
            "name": "Усть-Чебула",
            "population": 595,
            "type": "village",
            "poly": null,
            "longitude": 87.7659717,
            "latitude": 56.1267188
        },
        "1335": {
            "name": "Чумай",
            "population": 1291,
            "type": "village",
            "poly": [
                [
                    87.7441224,
                    55.7330931
                ],
                [
                    87.7442037,
                    55.733769
                ],
                [
                    87.7455263,
                    55.7361402
                ],
                [
                    87.7456076,
                    55.7382822
                ],
                [
                    87.7454856,
                    55.7386373
                ],
                [
                    87.749799,
                    55.7435394
                ],
                [
                    87.7534613,
                    55.7457268
                ],
                [
                    87.764916,
                    55.7467918
                ],
                [
                    87.7645295,
                    55.7486584
                ],
                [
                    87.7684766,
                    55.7493111
                ],
                [
                    87.7695753,
                    55.747101
                ],
                [
                    87.7708775,
                    55.7465742
                ],
                [
                    87.7736242,
                    55.7467117
                ],
                [
                    87.773848,
                    55.7490134
                ],
                [
                    87.7749467,
                    55.7496318
                ],
                [
                    87.7765744,
                    55.75017
                ],
                [
                    87.7795246,
                    55.7486012
                ],
                [
                    87.7851401,
                    55.7497119
                ],
                [
                    87.787256,
                    55.749105
                ],
                [
                    87.787663,
                    55.7491623
                ],
                [
                    87.7881106,
                    55.7500097
                ],
                [
                    87.7901859,
                    55.7514181
                ],
                [
                    87.7949265,
                    55.7531814
                ],
                [
                    87.796249,
                    55.754189
                ],
                [
                    87.7990568,
                    55.7532387
                ],
                [
                    87.8004605,
                    55.7516929
                ],
                [
                    87.7871136,
                    55.7392558
                ],
                [
                    87.7932175,
                    55.7348458
                ],
                [
                    87.793543,
                    55.7337804
                ],
                [
                    87.7920781,
                    55.7311799
                ],
                [
                    87.7889448,
                    55.7291177
                ],
                [
                    87.7865439,
                    55.7284074
                ],
                [
                    87.7834107,
                    55.7305383
                ],
                [
                    87.7826985,
                    55.7303894
                ],
                [
                    87.7827799,
                    55.7298051
                ],
                [
                    87.7825765,
                    55.7295072
                ],
                [
                    87.7814371,
                    55.7305956
                ],
                [
                    87.7808267,
                    55.7309393
                ],
                [
                    87.7801756,
                    55.7304009
                ],
                [
                    87.7805215,
                    55.7288198
                ],
                [
                    87.7784462,
                    55.7284417
                ],
                [
                    87.77867,
                    55.7297249
                ],
                [
                    87.7779986,
                    55.7298051
                ],
                [
                    87.7769203,
                    55.7297135
                ],
                [
                    87.7764523,
                    55.7290031
                ],
                [
                    87.7713048,
                    55.7300228
                ],
                [
                    87.7701247,
                    55.7292208
                ],
                [
                    87.7501245,
                    55.7335398
                ],
                [
                    87.7475202,
                    55.7338033
                ],
                [
                    87.7463808,
                    55.7336888
                ],
                [
                    87.7444886,
                    55.7324057
                ],
                [
                    87.7441224,
                    55.7330931
                ]
            ],
            "longitude": 87.773697,
            "latitude": 55.738312
        },
        "1336": {
            "name": "Чугунаш",
            "population": 639,
            "type": "village",
            "poly": null,
            "longitude": 87.775978,
            "latitude": 52.889339
        },
        "1337": {
            "name": "Новоивановский",
            "population": 1333,
            "type": "village",
            "poly": [
                [
                    87.7850993,
                    55.8588361
                ],
                [
                    87.7880279,
                    55.8601261
                ],
                [
                    87.7854496,
                    55.8615822
                ],
                [
                    87.7874733,
                    55.8623646
                ],
                [
                    87.7867771,
                    55.8630656
                ],
                [
                    87.7893542,
                    55.8646078
                ],
                [
                    87.7911855,
                    55.8637327
                ],
                [
                    87.791792,
                    55.8645946
                ],
                [
                    87.7934754,
                    55.8656621
                ],
                [
                    87.79623,
                    55.8667623
                ],
                [
                    87.7973492,
                    55.8663927
                ],
                [
                    87.7999862,
                    55.8662283
                ],
                [
                    87.800894,
                    55.8657519
                ],
                [
                    87.7985967,
                    55.8614313
                ],
                [
                    87.8039311,
                    55.8591399
                ],
                [
                    87.8072274,
                    55.8586784
                ],
                [
                    87.8008012,
                    55.8522239
                ],
                [
                    87.7987908,
                    55.8512087
                ],
                [
                    87.7952335,
                    55.8514608
                ],
                [
                    87.7897643,
                    55.8551662
                ],
                [
                    87.7875344,
                    55.8567193
                ],
                [
                    87.7850993,
                    55.8588361
                ]
            ],
            "longitude": 87.7947773,
            "latitude": 55.8598129
        },
        "1338": {
            "name": "1-й",
            "population": 1110,
            "type": "village",
            "poly": [
                [
                    87.8058726,
                    56.0303212
                ],
                [
                    87.8085298,
                    56.0303915
                ],
                [
                    87.8084669,
                    56.0308396
                ],
                [
                    87.8089386,
                    56.0308747
                ],
                [
                    87.8091115,
                    56.0324297
                ],
                [
                    87.8097876,
                    56.0325878
                ],
                [
                    87.8099449,
                    56.0338967
                ],
                [
                    87.8113128,
                    56.0338967
                ],
                [
                    87.8117216,
                    56.032825
                ],
                [
                    87.8152279,
                    56.0338616
                ],
                [
                    87.817209,
                    56.0338704
                ],
                [
                    87.8184354,
                    56.0331764
                ],
                [
                    87.8189857,
                    56.03409
                ],
                [
                    87.8220517,
                    56.033967
                ],
                [
                    87.8215958,
                    56.0326844
                ],
                [
                    87.8223662,
                    56.0315072
                ],
                [
                    87.822429,
                    56.0293373
                ],
                [
                    87.8209511,
                    56.0280106
                ],
                [
                    87.8201335,
                    56.0277119
                ],
                [
                    87.8207153,
                    56.0275362
                ],
                [
                    87.8225549,
                    56.0275625
                ],
                [
                    87.8233252,
                    56.0274747
                ],
                [
                    87.8237656,
                    56.0271496
                ],
                [
                    87.8232939,
                    56.0251024
                ],
                [
                    87.8225706,
                    56.0253484
                ],
                [
                    87.8221146,
                    56.0253747
                ],
                [
                    87.8216272,
                    56.0251726
                ],
                [
                    87.8209197,
                    56.0243028
                ],
                [
                    87.8207153,
                    56.0242413
                ],
                [
                    87.8205265,
                    56.0240304
                ],
                [
                    87.820731,
                    56.0238458
                ],
                [
                    87.8209354,
                    56.0238283
                ],
                [
                    87.8218002,
                    56.0241534
                ],
                [
                    87.823514,
                    56.0238722
                ],
                [
                    87.8242844,
                    56.0239161
                ],
                [
                    87.824992,
                    56.0238458
                ],
                [
                    87.8249448,
                    56.0235998
                ],
                [
                    87.8253064,
                    56.0233626
                ],
                [
                    87.825275,
                    56.0225981
                ],
                [
                    87.8255895,
                    56.0225805
                ],
                [
                    87.8256837,
                    56.0219039
                ],
                [
                    87.8259825,
                    56.0218512
                ],
                [
                    87.8260454,
                    56.019584
                ],
                [
                    87.8248976,
                    56.0191358
                ],
                [
                    87.8208253,
                    56.0191094
                ],
                [
                    87.8153537,
                    56.0188458
                ],
                [
                    87.8106524,
                    56.0187491
                ],
                [
                    87.8090172,
                    56.0215085
                ],
                [
                    87.8070989,
                    56.0236525
                ],
                [
                    87.8074448,
                    56.0239337
                ],
                [
                    87.807948,
                    56.0240392
                ],
                [
                    87.8084983,
                    56.0238722
                ],
                [
                    87.8091587,
                    56.0232747
                ],
                [
                    87.8097405,
                    56.0231429
                ],
                [
                    87.8098663,
                    56.022932
                ],
                [
                    87.809709,
                    56.0227387
                ],
                [
                    87.8101493,
                    56.0224839
                ],
                [
                    87.8120046,
                    56.023635
                ],
                [
                    87.811926,
                    56.0246367
                ],
                [
                    87.81147,
                    56.0264027
                ],
                [
                    87.8061084,
                    56.0263676
                ],
                [
                    87.8058726,
                    56.0303212
                ]
            ],
            "longitude": 87.8168376,
            "latitude": 56.0256656
        },
        "1339": {
            "name": "Пристань 2-я",
            "population": 994,
            "type": "village",
            "poly": [
                [
                    87.7931522,
                    56.2149539
                ],
                [
                    87.7989096,
                    56.2139052
                ],
                [
                    87.8031114,
                    56.2125705
                ],
                [
                    87.810608,
                    56.2098901
                ],
                [
                    87.8122475,
                    56.2095053
                ],
                [
                    87.8188682,
                    56.2083368
                ],
                [
                    87.8269975,
                    56.2068112
                ],
                [
                    87.830713,
                    56.2060345
                ],
                [
                    87.8309998,
                    56.2054831
                ],
                [
                    87.8309873,
                    56.2050982
                ],
                [
                    87.8306568,
                    56.205015
                ],
                [
                    87.8301083,
                    56.2049907
                ],
                [
                    87.8306817,
                    56.2047133
                ],
                [
                    87.8307379,
                    56.2044429
                ],
                [
                    87.8298028,
                    56.2035378
                ],
                [
                    87.8295846,
                    56.2029934
                ],
                [
                    87.8301831,
                    56.2026015
                ],
                [
                    87.8308252,
                    56.2024489
                ],
                [
                    87.8305135,
                    56.2016305
                ],
                [
                    87.8294101,
                    56.201738
                ],
                [
                    87.8273396,
                    56.1949642
                ],
                [
                    87.8272443,
                    56.1946088
                ],
                [
                    87.8272549,
                    56.1942479
                ],
                [
                    87.8282176,
                    56.1874628
                ],
                [
                    87.8281593,
                    56.187135
                ],
                [
                    87.8278726,
                    56.1868852
                ],
                [
                    87.8273614,
                    56.1866632
                ],
                [
                    87.8253375,
                    56.1865335
                ],
                [
                    87.8243513,
                    56.1866623
                ],
                [
                    87.8237302,
                    56.1870146
                ],
                [
                    87.8237302,
                    56.1872179
                ],
                [
                    87.8233528,
                    56.189508
                ],
                [
                    87.8225492,
                    56.1898603
                ],
                [
                    87.8224396,
                    56.1899823
                ],
                [
                    87.8224396,
                    56.1916286
                ],
                [
                    87.8215264,
                    56.1921977
                ],
                [
                    87.8209542,
                    56.1924958
                ],
                [
                    87.8203331,
                    56.1927329
                ],
                [
                    87.8194443,
                    56.1929836
                ],
                [
                    87.818799,
                    56.1930446
                ],
                [
                    87.8186152,
                    56.1928153
                ],
                [
                    87.8178237,
                    56.1927272
                ],
                [
                    87.8168497,
                    56.1933098
                ],
                [
                    87.8169245,
                    56.194111
                ],
                [
                    87.8193472,
                    56.1949445
                ],
                [
                    87.821512,
                    56.1962207
                ],
                [
                    87.8232901,
                    56.1984167
                ],
                [
                    87.8229745,
                    56.1999722
                ],
                [
                    87.821961,
                    56.201713
                ],
                [
                    87.8206229,
                    56.2030755
                ],
                [
                    87.8185737,
                    56.2042451
                ],
                [
                    87.8177024,
                    56.2046506
                ],
                [
                    87.816969,
                    56.2049374
                ],
                [
                    87.8165644,
                    56.2052094
                ],
                [
                    87.8152575,
                    56.2056643
                ],
                [
                    87.8132261,
                    56.2062132
                ],
                [
                    87.8113768,
                    56.2065791
                ],
                [
                    87.8101588,
                    56.2069747
                ],
                [
                    87.8077762,
                    56.2073851
                ],
                [
                    87.8046601,
                    56.2074346
                ],
                [
                    87.8027975,
                    56.2072541
                ],
                [
                    87.7987346,
                    56.2065371
                ],
                [
                    87.7954496,
                    56.2056755
                ],
                [
                    87.793939,
                    56.2078362
                ],
                [
                    87.7939702,
                    56.2091292
                ],
                [
                    87.7957965,
                    56.2106104
                ],
                [
                    87.7968453,
                    56.2117927
                ],
                [
                    87.7969595,
                    56.212646
                ],
                [
                    87.796531,
                    56.2132973
                ],
                [
                    87.7956333,
                    56.2141324
                ],
                [
                    87.7931522,
                    56.2149539
                ]
            ],
            "longitude": 87.823303,
            "latitude": 56.20586
        },
        "1340": {
            "name": "Кураково",
            "population": 357,
            "type": "village",
            "poly": [
                [
                    87.8345041,
                    55.7463696
                ],
                [
                    87.835852,
                    55.7469136
                ],
                [
                    87.8382936,
                    55.7486599
                ],
                [
                    87.8400738,
                    55.7508356
                ],
                [
                    87.8397686,
                    55.7514225
                ],
                [
                    87.8409894,
                    55.7522526
                ],
                [
                    87.8414218,
                    55.7534978
                ],
                [
                    87.8431766,
                    55.7550292
                ],
                [
                    87.8435072,
                    55.7561169
                ],
                [
                    87.843024,
                    55.7569326
                ],
                [
                    87.8429732,
                    55.757505
                ],
                [
                    87.8421085,
                    55.7590219
                ],
                [
                    87.8421085,
                    55.7604673
                ],
                [
                    87.8424645,
                    55.7619411
                ],
                [
                    87.8465083,
                    55.7613115
                ],
                [
                    87.8485429,
                    55.761426
                ],
                [
                    87.8487718,
                    55.7606962
                ],
                [
                    87.8494585,
                    55.7600237
                ],
                [
                    87.8484919,
                    55.7583351
                ],
                [
                    87.8488735,
                    55.7563745
                ],
                [
                    87.8472967,
                    55.7535264
                ],
                [
                    87.8478308,
                    55.7532402
                ],
                [
                    87.8489498,
                    55.7533976
                ],
                [
                    87.8518237,
                    55.7504921
                ],
                [
                    87.8553588,
                    55.7493184
                ],
                [
                    87.8612592,
                    55.7458543
                ],
                [
                    87.8572154,
                    55.7435638
                ],
                [
                    87.8540618,
                    55.7426189
                ],
                [
                    87.8486192,
                    55.7401135
                ],
                [
                    87.8478054,
                    55.7404571
                ],
                [
                    87.8518237,
                    55.742576
                ],
                [
                    87.8506538,
                    55.7430771
                ],
                [
                    87.8484157,
                    55.746341
                ],
                [
                    87.847373,
                    55.7473144
                ],
                [
                    87.8433038,
                    55.7474719
                ],
                [
                    87.8421338,
                    55.7444084
                ],
                [
                    87.8351145,
                    55.7448236
                ],
                [
                    87.8346313,
                    55.7457541
                ],
                [
                    87.8345041,
                    55.7463696
                ]
            ],
            "longitude": 87.8454082,
            "latitude": 55.7502709
        },
        "1341": {
            "name": "Дмитриевка",
            "population": 550,
            "type": "village",
            "poly": [
                [
                    87.894509,
                    56.0260084
                ],
                [
                    87.8962484,
                    56.0267116
                ],
                [
                    87.899431,
                    56.0283452
                ],
                [
                    87.8986539,
                    56.0301236
                ],
                [
                    87.9002082,
                    56.0307853
                ],
                [
                    87.8981728,
                    56.0345071
                ],
                [
                    87.9004672,
                    56.035024
                ],
                [
                    87.8999121,
                    56.0370087
                ],
                [
                    87.9056851,
                    56.0375256
                ],
                [
                    87.9070545,
                    56.038704
                ],
                [
                    87.9063514,
                    56.0392828
                ],
                [
                    87.9078686,
                    56.0407299
                ],
                [
                    87.9092378,
                    56.0406679
                ],
                [
                    87.9123465,
                    56.0395516
                ],
                [
                    87.9152701,
                    56.0404198
                ],
                [
                    87.9182675,
                    56.0390141
                ],
                [
                    87.9154551,
                    56.0358096
                ],
                [
                    87.9176015,
                    56.0330184
                ],
                [
                    87.9177495,
                    56.0313436
                ],
                [
                    87.9134937,
                    56.0283659
                ],
                [
                    87.9144929,
                    56.0265668
                ],
                [
                    87.9117544,
                    56.0244781
                ],
                [
                    87.9134567,
                    56.0231545
                ],
                [
                    87.9111623,
                    56.0217274
                ],
                [
                    87.9107109,
                    56.0198329
                ],
                [
                    87.9085731,
                    56.0177355
                ],
                [
                    87.8989926,
                    56.0247494
                ],
                [
                    87.8966109,
                    56.0241522
                ],
                [
                    87.8946941,
                    56.0251399
                ],
                [
                    87.894509,
                    56.0260084
                ]
            ],
            "longitude": 87.909805,
            "latitude": 56.032875
        },
        "1342": {
            "name": "Алчедат",
            "population": 606,
            "type": "village",
            "poly": [
                [
                    87.8998764,
                    55.9921926
                ],
                [
                    87.9049677,
                    55.9926428
                ],
                [
                    87.9045308,
                    55.9936951
                ],
                [
                    87.9069641,
                    55.9939843
                ],
                [
                    87.9092514,
                    55.9939995
                ],
                [
                    87.9101112,
                    55.9928718
                ],
                [
                    87.9147131,
                    55.9921438
                ],
                [
                    87.917702,
                    55.9913969
                ],
                [
                    87.9214996,
                    55.9892198
                ],
                [
                    87.9263937,
                    55.9861189
                ],
                [
                    87.925275,
                    55.9855828
                ],
                [
                    87.9232052,
                    55.9851078
                ],
                [
                    87.9207507,
                    55.9838154
                ],
                [
                    87.9208964,
                    55.9823167
                ],
                [
                    87.9212945,
                    55.9803421
                ],
                [
                    87.9227274,
                    55.9789167
                ],
                [
                    87.9222233,
                    55.9783822
                ],
                [
                    87.9225433,
                    55.9778676
                ],
                [
                    87.9218491,
                    55.9769495
                ],
                [
                    87.919941,
                    55.9762292
                ],
                [
                    87.9172235,
                    55.9761805
                ],
                [
                    87.9136962,
                    55.9768923
                ],
                [
                    87.9120914,
                    55.978232
                ],
                [
                    87.9101158,
                    55.978215
                ],
                [
                    87.9098865,
                    55.9767735
                ],
                [
                    87.9087963,
                    55.9770095
                ],
                [
                    87.908203,
                    55.9786393
                ],
                [
                    87.9069887,
                    55.979804
                ],
                [
                    87.9055576,
                    55.9802233
                ],
                [
                    87.9032472,
                    55.9804446
                ],
                [
                    87.9034893,
                    55.9834958
                ],
                [
                    87.9047336,
                    55.9854651
                ],
                [
                    87.9021873,
                    55.9877947
                ],
                [
                    87.9012642,
                    55.9890878
                ],
                [
                    87.8998764,
                    55.9921926
                ]
            ],
            "longitude": 87.913458,
            "latitude": 55.9849751
        },
        "1343": {
            "name": "Приметкино",
            "population": 365,
            "type": "village",
            "poly": [
                [
                    87.9047607,
                    56.2296373
                ],
                [
                    87.9048186,
                    56.2312765
                ],
                [
                    87.9065533,
                    56.2329799
                ],
                [
                    87.9090975,
                    56.233912
                ],
                [
                    87.9134343,
                    56.2349404
                ],
                [
                    87.9160364,
                    56.2353582
                ],
                [
                    87.9176554,
                    56.2360652
                ],
                [
                    87.9203153,
                    56.2358724
                ],
                [
                    87.9205466,
                    56.2339763
                ],
                [
                    87.9255773,
                    56.2344583
                ],
                [
                    87.930261,
                    56.2339441
                ],
                [
                    87.9307814,
                    56.231855
                ],
                [
                    87.9289888,
                    56.229573
                ],
                [
                    87.9256929,
                    56.2280302
                ],
                [
                    87.9204888,
                    56.2276766
                ],
                [
                    87.9155738,
                    56.227998
                ],
                [
                    87.9152846,
                    56.2267123
                ],
                [
                    87.9117574,
                    56.227098
                ],
                [
                    87.9101962,
                    56.2281266
                ],
                [
                    87.9062062,
                    56.2286409
                ],
                [
                    87.9047607,
                    56.2296373
                ]
            ],
            "longitude": 87.916405,
            "latitude": 56.232849
        },
        "1344": {
            "name": "Усть-Серта",
            "population": 1316,
            "type": "village",
            "poly": [
                [
                    87.9698535,
                    56.0012561
                ],
                [
                    87.9725869,
                    56.0024877
                ],
                [
                    87.9716315,
                    56.0040458
                ],
                [
                    87.9730911,
                    56.0048619
                ],
                [
                    87.9731177,
                    56.0056779
                ],
                [
                    87.9775229,
                    56.00731
                ],
                [
                    87.9784516,
                    56.008942
                ],
                [
                    87.9782925,
                    56.0104256
                ],
                [
                    87.9767002,
                    56.0123691
                ],
                [
                    87.9787967,
                    56.0120872
                ],
                [
                    87.9821139,
                    56.0135262
                ],
                [
                    87.9834408,
                    56.0121614
                ],
                [
                    87.984635,
                    56.0124729
                ],
                [
                    87.988138,
                    56.014164
                ],
                [
                    87.992039,
                    56.0127103
                ],
                [
                    87.9943213,
                    56.0133927
                ],
                [
                    87.9978242,
                    56.0132295
                ],
                [
                    87.999788,
                    56.0135707
                ],
                [
                    88.0006107,
                    56.0128289
                ],
                [
                    88.0017253,
                    56.013274
                ],
                [
                    88.0028664,
                    56.0123246
                ],
                [
                    88.005069,
                    56.0131553
                ],
                [
                    88.0072186,
                    56.0123691
                ],
                [
                    88.0060244,
                    56.0109004
                ],
                [
                    88.0003188,
                    56.0083041
                ],
                [
                    88.0028929,
                    56.0069243
                ],
                [
                    88.007371,
                    56.0075136
                ],
                [
                    88.0136069,
                    56.0076495
                ],
                [
                    88.0143358,
                    56.0051138
                ],
                [
                    88.01304,
                    56.0038912
                ],
                [
                    88.007452,
                    56.0029403
                ],
                [
                    88.0081808,
                    55.9981852
                ],
                [
                    88.0031652,
                    55.9977034
                ],
                [
                    88.0031793,
                    55.9926572
                ],
                [
                    87.9976526,
                    55.9927501
                ],
                [
                    87.9984081,
                    55.9951716
                ],
                [
                    87.9932597,
                    55.9980062
                ],
                [
                    87.9893056,
                    55.9988818
                ],
                [
                    87.9862007,
                    55.9971157
                ],
                [
                    87.9841573,
                    55.9966112
                ],
                [
                    87.9820874,
                    56.000618
                ],
                [
                    87.9735953,
                    55.9986146
                ],
                [
                    87.9698535,
                    56.0012561
                ]
            ],
            "longitude": 87.9944142,
            "latitude": 56.0062967
        },
        "1345": {
            "name": "Первомайский",
            "population": 751,
            "type": "village",
            "poly": [
                [
                    88.004095,
                    56.1735042
                ],
                [
                    88.0082879,
                    56.1751677
                ],
                [
                    88.010377,
                    56.1755931
                ],
                [
                    88.0189609,
                    56.1788562
                ],
                [
                    88.0204597,
                    56.1772003
                ],
                [
                    88.0246547,
                    56.177777
                ],
                [
                    88.0279836,
                    56.1746004
                ],
                [
                    88.0293143,
                    56.1749786
                ],
                [
                    88.0313694,
                    56.1753189
                ],
                [
                    88.0356435,
                    56.1772098
                ],
                [
                    88.0400084,
                    56.1770207
                ],
                [
                    88.0421314,
                    56.1716316
                ],
                [
                    88.0409484,
                    56.1713196
                ],
                [
                    88.0398046,
                    56.1706199
                ],
                [
                    88.0386726,
                    56.1708752
                ],
                [
                    88.0380781,
                    56.1706766
                ],
                [
                    88.0374497,
                    56.1706766
                ],
                [
                    88.0369062,
                    56.1708468
                ],
                [
                    88.0358023,
                    56.1707995
                ],
                [
                    88.0351059,
                    56.1708941
                ],
                [
                    88.0344376,
                    56.170601
                ],
                [
                    88.0311936,
                    56.169107
                ],
                [
                    88.0284312,
                    56.1684924
                ],
                [
                    88.0272083,
                    56.1684829
                ],
                [
                    88.0251033,
                    56.1690062
                ],
                [
                    88.0227256,
                    56.1690724
                ],
                [
                    88.0187613,
                    56.1694096
                ],
                [
                    88.0164913,
                    56.1682465
                ],
                [
                    88.0139207,
                    56.167386
                ],
                [
                    88.0130376,
                    56.1691827
                ],
                [
                    88.0086277,
                    56.1685964
                ],
                [
                    88.0069403,
                    56.1681898
                ],
                [
                    88.0063289,
                    56.1690408
                ],
                [
                    88.0096748,
                    56.1700904
                ],
                [
                    88.0068894,
                    56.1716884
                ],
                [
                    88.004095,
                    56.1735042
                ]
            ],
            "longitude": 88.0146924,
            "latitude": 56.1753932
        },
        "1346": {
            "name": "Ключевой",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 88.0153866,
            "latitude": 52.6286601
        },
        "1347": {
            "name": "Макаракский",
            "population": 442,
            "type": "village",
            "poly": null,
            "longitude": 88.048836,
            "latitude": 55.595734
        },
        "1348": {
            "name": "Пихтовка",
            "population": 295,
            "type": "village",
            "poly": [
                [
                    88.0676285,
                    56.6537203
                ],
                [
                    88.0683233,
                    56.6546578
                ],
                [
                    88.0726504,
                    56.6556648
                ],
                [
                    88.0734716,
                    56.6554044
                ],
                [
                    88.0748297,
                    56.655387
                ],
                [
                    88.0748297,
                    56.6559773
                ],
                [
                    88.0770406,
                    56.655821
                ],
                [
                    88.0771038,
                    56.6563418
                ],
                [
                    88.0777986,
                    56.6563766
                ],
                [
                    88.0778617,
                    56.656012
                ],
                [
                    88.0793463,
                    56.656012
                ],
                [
                    88.0792831,
                    56.6556127
                ],
                [
                    88.0799464,
                    56.65563
                ],
                [
                    88.0805149,
                    56.6560814
                ],
                [
                    88.0806412,
                    56.655005
                ],
                [
                    88.0813361,
                    56.6549877
                ],
                [
                    88.0817467,
                    56.6556474
                ],
                [
                    88.0829785,
                    56.6561162
                ],
                [
                    88.0849051,
                    56.6562377
                ],
                [
                    88.0851262,
                    56.6534772
                ],
                [
                    88.0863896,
                    56.6522445
                ],
                [
                    88.0863896,
                    56.6516195
                ],
                [
                    88.083168,
                    56.6512722
                ],
                [
                    88.0821573,
                    56.650595
                ],
                [
                    88.0817151,
                    56.6500568
                ],
                [
                    88.0810202,
                    56.6502651
                ],
                [
                    88.0805781,
                    56.6500741
                ],
                [
                    88.079662,
                    56.6501262
                ],
                [
                    88.0773248,
                    56.6498484
                ],
                [
                    88.0771038,
                    56.6492754
                ],
                [
                    88.0719239,
                    56.6491886
                ],
                [
                    88.0693972,
                    56.6505429
                ],
                [
                    88.0694288,
                    56.6524008
                ],
                [
                    88.0678496,
                    56.6525223
                ],
                [
                    88.0680707,
                    56.6534251
                ],
                [
                    88.0676285,
                    56.6537203
                ]
            ],
            "longitude": 88.076248,
            "latitude": 56.652843
        },
        "1349": {
            "name": "Николаевка 2-я",
            "population": 518,
            "type": "village",
            "poly": [
                [
                    88.0689054,
                    56.2812024
                ],
                [
                    88.0723813,
                    56.2832821
                ],
                [
                    88.0722343,
                    56.2835311
                ],
                [
                    88.0712662,
                    56.2841439
                ],
                [
                    88.0729782,
                    56.2846989
                ],
                [
                    88.0738739,
                    56.2847133
                ],
                [
                    88.0748826,
                    56.2852008
                ],
                [
                    88.0753788,
                    56.2853189
                ],
                [
                    88.0770479,
                    56.2860021
                ],
                [
                    88.078674,
                    56.2868515
                ],
                [
                    88.0790827,
                    56.2869432
                ],
                [
                    88.0795001,
                    56.2871942
                ],
                [
                    88.0796543,
                    56.2875071
                ],
                [
                    88.0788805,
                    56.2885001
                ],
                [
                    88.0791001,
                    56.2894047
                ],
                [
                    88.0793386,
                    56.2901951
                ],
                [
                    88.0805001,
                    56.2905871
                ],
                [
                    88.0812306,
                    56.2903796
                ],
                [
                    88.0819176,
                    56.2906353
                ],
                [
                    88.0825589,
                    56.2906309
                ],
                [
                    88.0828654,
                    56.2902493
                ],
                [
                    88.0835872,
                    56.2900707
                ],
                [
                    88.0833524,
                    56.2896798
                ],
                [
                    88.0843176,
                    56.288589
                ],
                [
                    88.0848024,
                    56.2884018
                ],
                [
                    88.0854307,
                    56.2883574
                ],
                [
                    88.0873612,
                    56.2889221
                ],
                [
                    88.0888656,
                    56.2896267
                ],
                [
                    88.0893543,
                    56.2891872
                ],
                [
                    88.0914603,
                    56.2916003
                ],
                [
                    88.1080511,
                    56.2975328
                ],
                [
                    88.1092242,
                    56.2971887
                ],
                [
                    88.1106865,
                    56.2966311
                ],
                [
                    88.1122491,
                    56.294275
                ],
                [
                    88.1129227,
                    56.2943706
                ],
                [
                    88.1143552,
                    56.2933984
                ],
                [
                    88.1141851,
                    56.2931837
                ],
                [
                    88.1105677,
                    56.2912777
                ],
                [
                    88.1067803,
                    56.2899864
                ],
                [
                    88.105863,
                    56.2890061
                ],
                [
                    88.1047248,
                    56.2883577
                ],
                [
                    88.1039609,
                    56.2885065
                ],
                [
                    88.1008528,
                    56.2869982
                ],
                [
                    88.1007678,
                    56.287281
                ],
                [
                    88.0927174,
                    56.2845
                ],
                [
                    88.0926665,
                    56.2838213
                ],
                [
                    88.0923095,
                    56.2835405
                ],
                [
                    88.0913927,
                    56.2837553
                ],
                [
                    88.0905635,
                    56.2836433
                ],
                [
                    88.0883865,
                    56.2827842
                ],
                [
                    88.0878831,
                    56.282262
                ],
                [
                    88.0849557,
                    56.281898
                ],
                [
                    88.083546,
                    56.2812946
                ],
                [
                    88.0825775,
                    56.281523
                ],
                [
                    88.080562,
                    56.2806436
                ],
                [
                    88.0798942,
                    56.2793922
                ],
                [
                    88.0777202,
                    56.2794393
                ],
                [
                    88.0766746,
                    56.2783057
                ],
                [
                    88.074748,
                    56.2772141
                ],
                [
                    88.0689054,
                    56.2812024
                ]
            ],
            "longitude": 88.092201,
            "latitude": 56.287209
        },
        "1350": {
            "name": "Курск-Смоленка",
            "population": 576,
            "type": "village",
            "poly": [
                [
                    88.0771531,
                    55.9620114
                ],
                [
                    88.0799026,
                    55.9625146
                ],
                [
                    88.0814898,
                    55.9626264
                ],
                [
                    88.0841826,
                    55.9640964
                ],
                [
                    88.0856367,
                    55.9642832
                ],
                [
                    88.087677,
                    55.9668984
                ],
                [
                    88.089305,
                    55.9670395
                ],
                [
                    88.0911018,
                    55.9667387
                ],
                [
                    88.0910985,
                    55.966279
                ],
                [
                    88.0922534,
                    55.9652676
                ],
                [
                    88.0921624,
                    55.9642133
                ],
                [
                    88.0933404,
                    55.9638379
                ],
                [
                    88.0941898,
                    55.9639058
                ],
                [
                    88.0961224,
                    55.965136
                ],
                [
                    88.0979465,
                    55.9645375
                ],
                [
                    88.0991425,
                    55.9636622
                ],
                [
                    88.0991729,
                    55.9626968
                ],
                [
                    88.1002341,
                    55.960862
                ],
                [
                    88.1018209,
                    55.9603026
                ],
                [
                    88.1028489,
                    55.9584649
                ],
                [
                    88.1037872,
                    55.9581465
                ],
                [
                    88.1049899,
                    55.9581891
                ],
                [
                    88.1056768,
                    55.9586219
                ],
                [
                    88.104955,
                    55.9593112
                ],
                [
                    88.1048677,
                    55.9600172
                ],
                [
                    88.1069037,
                    55.9604483
                ],
                [
                    88.1072691,
                    55.9605115
                ],
                [
                    88.1074189,
                    55.9614237
                ],
                [
                    88.1083306,
                    55.96107
                ],
                [
                    88.1084446,
                    55.9599299
                ],
                [
                    88.1098592,
                    55.9584912
                ],
                [
                    88.11183,
                    55.9576376
                ],
                [
                    88.1125554,
                    55.9574572
                ],
                [
                    88.1147209,
                    55.9580039
                ],
                [
                    88.1191058,
                    55.9575633
                ],
                [
                    88.1207078,
                    55.9569224
                ],
                [
                    88.1222647,
                    55.9564271
                ],
                [
                    88.124866,
                    55.9570542
                ],
                [
                    88.1262682,
                    55.9563647
                ],
                [
                    88.1282766,
                    55.9566511
                ],
                [
                    88.1297924,
                    55.9569375
                ],
                [
                    88.1324829,
                    55.9551873
                ],
                [
                    88.1278219,
                    55.9532884
                ],
                [
                    88.1271916,
                    55.9520703
                ],
                [
                    88.1257028,
                    55.9515918
                ],
                [
                    88.1245832,
                    55.9505935
                ],
                [
                    88.1224407,
                    55.9500316
                ],
                [
                    88.1283145,
                    55.9467532
                ],
                [
                    88.1280303,
                    55.9462758
                ],
                [
                    88.1245629,
                    55.9445463
                ],
                [
                    88.1230281,
                    55.9440582
                ],
                [
                    88.1173628,
                    55.9464349
                ],
                [
                    88.110049,
                    55.9438884
                ],
                [
                    88.1066703,
                    55.9466929
                ],
                [
                    88.1045556,
                    55.9493862
                ],
                [
                    88.1032632,
                    55.950346
                ],
                [
                    88.1037678,
                    55.9510346
                ],
                [
                    88.1017859,
                    55.9521708
                ],
                [
                    88.0936317,
                    55.9503852
                ],
                [
                    88.0935324,
                    55.9515508
                ],
                [
                    88.0979696,
                    55.9525916
                ],
                [
                    88.0993574,
                    55.9534981
                ],
                [
                    88.0968709,
                    55.9556023
                ],
                [
                    88.0974835,
                    55.9563317
                ],
                [
                    88.0946158,
                    55.957577
                ],
                [
                    88.0932147,
                    55.957761
                ],
                [
                    88.0911596,
                    55.9575233
                ],
                [
                    88.0891895,
                    55.9579131
                ],
                [
                    88.0874741,
                    55.9575613
                ],
                [
                    88.0844295,
                    55.9577861
                ],
                [
                    88.0779626,
                    55.9601017
                ],
                [
                    88.0775656,
                    55.9603166
                ],
                [
                    88.0771531,
                    55.9620114
                ]
            ],
            "longitude": 88.0981211,
            "latitude": 55.9572973
        },
        "1351": {
            "name": "Берикульский",
            "population": 694,
            "type": "village",
            "poly": null,
            "longitude": 88.117325,
            "latitude": 55.518356
        },
        "1352": {
            "name": "Суслово",
            "population": 2829,
            "type": "village",
            "poly": [
                [
                    88.0948803,
                    56.2119366
                ],
                [
                    88.0951354,
                    56.2124944
                ],
                [
                    88.0969067,
                    56.2146898
                ],
                [
                    88.0989823,
                    56.2159847
                ],
                [
                    88.1062778,
                    56.2181944
                ],
                [
                    88.1074347,
                    56.2182031
                ],
                [
                    88.1098142,
                    56.220713
                ],
                [
                    88.1124147,
                    56.2215374
                ],
                [
                    88.1153918,
                    56.2221228
                ],
                [
                    88.1152296,
                    56.2233583
                ],
                [
                    88.1174067,
                    56.2232457
                ],
                [
                    88.1185515,
                    56.2297206
                ],
                [
                    88.1192155,
                    56.2312117
                ],
                [
                    88.1342577,
                    56.2243204
                ],
                [
                    88.1341333,
                    56.2237441
                ],
                [
                    88.128038,
                    56.2221074
                ],
                [
                    88.128038,
                    56.2212544
                ],
                [
                    88.130899,
                    56.2205627
                ],
                [
                    88.1294478,
                    56.2182111
                ],
                [
                    88.1290979,
                    56.2179987
                ],
                [
                    88.1308176,
                    56.2168536
                ],
                [
                    88.132978,
                    56.2160512
                ],
                [
                    88.1337187,
                    56.2163205
                ],
                [
                    88.1349262,
                    56.2167434
                ],
                [
                    88.1385692,
                    56.2169421
                ],
                [
                    88.1421262,
                    56.2169329
                ],
                [
                    88.1420514,
                    56.2153797
                ],
                [
                    88.1438236,
                    56.2145662
                ],
                [
                    88.1447998,
                    56.2135452
                ],
                [
                    88.1477777,
                    56.2132233
                ],
                [
                    88.1495558,
                    56.2125887
                ],
                [
                    88.1539875,
                    56.2114228
                ],
                [
                    88.1561902,
                    56.210375
                ],
                [
                    88.1571946,
                    56.2094793
                ],
                [
                    88.1601708,
                    56.2101683
                ],
                [
                    88.1613145,
                    56.2103399
                ],
                [
                    88.1639915,
                    56.2100383
                ],
                [
                    88.1652687,
                    56.2117069
                ],
                [
                    88.1660814,
                    56.2115935
                ],
                [
                    88.1653191,
                    56.2099469
                ],
                [
                    88.1652395,
                    56.2081463
                ],
                [
                    88.1645057,
                    56.2080486
                ],
                [
                    88.1655224,
                    56.2043289
                ],
                [
                    88.1640656,
                    56.2031232
                ],
                [
                    88.1616581,
                    56.2028474
                ],
                [
                    88.1565086,
                    56.2040134
                ],
                [
                    88.1551817,
                    56.2052238
                ],
                [
                    88.1531194,
                    56.2060234
                ],
                [
                    88.1525544,
                    56.2071279
                ],
                [
                    88.152475,
                    56.2085769
                ],
                [
                    88.1517053,
                    56.2087219
                ],
                [
                    88.1512386,
                    56.2089271
                ],
                [
                    88.1509836,
                    56.2094766
                ],
                [
                    88.1492168,
                    56.2091025
                ],
                [
                    88.1477561,
                    56.2089786
                ],
                [
                    88.1475863,
                    56.2084556
                ],
                [
                    88.1468268,
                    56.2081206
                ],
                [
                    88.1460862,
                    56.2084012
                ],
                [
                    88.1453254,
                    56.2079055
                ],
                [
                    88.1441732,
                    56.2082561
                ],
                [
                    88.1429483,
                    56.2081051
                ],
                [
                    88.1420434,
                    56.2082059
                ],
                [
                    88.1417057,
                    56.208377
                ],
                [
                    88.1409231,
                    56.2081231
                ],
                [
                    88.1397166,
                    56.2080445
                ],
                [
                    88.1395318,
                    56.2078904
                ],
                [
                    88.1383993,
                    56.2079596
                ],
                [
                    88.1386574,
                    56.2089023
                ],
                [
                    88.1383035,
                    56.2090057
                ],
                [
                    88.1368571,
                    56.2088196
                ],
                [
                    88.1363143,
                    56.2086188
                ],
                [
                    88.1360595,
                    56.2082282
                ],
                [
                    88.1338686,
                    56.2081352
                ],
                [
                    88.1327979,
                    56.2082052
                ],
                [
                    88.131484,
                    56.2074801
                ],
                [
                    88.1310206,
                    56.2074641
                ],
                [
                    88.1312816,
                    56.2078027
                ],
                [
                    88.1307272,
                    56.2079659
                ],
                [
                    88.1292686,
                    56.2081202
                ],
                [
                    88.1285206,
                    56.2079296
                ],
                [
                    88.1283114,
                    56.207522
                ],
                [
                    88.127477,
                    56.2079175
                ],
                [
                    88.126613,
                    56.2081251
                ],
                [
                    88.1260532,
                    56.2080324
                ],
                [
                    88.125956,
                    56.2075749
                ],
                [
                    88.1256293,
                    56.2075306
                ],
                [
                    88.1254316,
                    56.2083227
                ],
                [
                    88.1242597,
                    56.2084556
                ],
                [
                    88.1234553,
                    56.207845
                ],
                [
                    88.1230545,
                    56.2081697
                ],
                [
                    88.1215531,
                    56.2077543
                ],
                [
                    88.12064,
                    56.2079055
                ],
                [
                    88.1201074,
                    56.2077301
                ],
                [
                    88.1189008,
                    56.207972
                ],
                [
                    88.1169878,
                    56.2077845
                ],
                [
                    88.1134503,
                    56.2077499
                ],
                [
                    88.1138266,
                    56.2069964
                ],
                [
                    88.1135203,
                    56.2069986
                ],
                [
                    88.1133572,
                    56.2073372
                ],
                [
                    88.1127594,
                    56.2074883
                ],
                [
                    88.112042,
                    56.2072586
                ],
                [
                    88.1114333,
                    56.2072888
                ],
                [
                    88.1108572,
                    56.2076636
                ],
                [
                    88.1103789,
                    56.2075727
                ],
                [
                    88.109955,
                    56.2073432
                ],
                [
                    88.1096289,
                    56.2067024
                ],
                [
                    88.1088028,
                    56.2064001
                ],
                [
                    88.1083245,
                    56.2060192
                ],
                [
                    88.107531,
                    56.2056504
                ],
                [
                    88.1068027,
                    56.2055536
                ],
                [
                    88.1066077,
                    56.2049624
                ],
                [
                    88.1047675,
                    56.2046721
                ],
                [
                    88.1035853,
                    56.205862
                ],
                [
                    88.1030418,
                    56.2058439
                ],
                [
                    88.1025947,
                    56.206056
                ],
                [
                    88.1019656,
                    56.206001
                ],
                [
                    88.1004982,
                    56.2052151
                ],
                [
                    88.1001971,
                    56.2054003
                ],
                [
                    88.0964091,
                    56.2101009
                ],
                [
                    88.0960543,
                    56.2104253
                ],
                [
                    88.0960869,
                    56.2108968
                ],
                [
                    88.0960543,
                    56.2114349
                ],
                [
                    88.0971739,
                    56.2117069
                ],
                [
                    88.09675,
                    56.2123295
                ],
                [
                    88.0948803,
                    56.2119366
                ]
            ],
            "longitude": 88.119827,
            "latitude": 56.219307
        },
        "1353": {
            "name": "Куликовка",
            "population": 620,
            "type": "village",
            "poly": null,
            "longitude": 88.1312322,
            "latitude": 55.7957086
        },
        "1354": {
            "name": "Лебяжий",
            "population": 333,
            "type": "village",
            "poly": [
                [
                    88.1525963,
                    56.3803168
                ],
                [
                    88.1533187,
                    56.3872021
                ],
                [
                    88.154977,
                    56.3871693
                ],
                [
                    88.1553679,
                    56.3874906
                ],
                [
                    88.1570616,
                    56.3877266
                ],
                [
                    88.1572511,
                    56.3874381
                ],
                [
                    88.1583527,
                    56.387425
                ],
                [
                    88.1584237,
                    56.3881725
                ],
                [
                    88.1599279,
                    56.387884
                ],
                [
                    88.1599516,
                    56.3870644
                ],
                [
                    88.1597977,
                    56.3866448
                ],
                [
                    88.160171,
                    56.3865892
                ],
                [
                    88.1600856,
                    56.386428
                ],
                [
                    88.1603884,
                    56.3864023
                ],
                [
                    88.1606096,
                    56.3861874
                ],
                [
                    88.1605397,
                    56.3860177
                ],
                [
                    88.1604311,
                    56.3859231
                ],
                [
                    88.1600779,
                    56.3859081
                ],
                [
                    88.1600818,
                    56.3857018
                ],
                [
                    88.1598722,
                    56.3855278
                ],
                [
                    88.15955,
                    56.3856545
                ],
                [
                    88.1593366,
                    56.3851711
                ],
                [
                    88.160924,
                    56.3850486
                ],
                [
                    88.1611025,
                    56.3859833
                ],
                [
                    88.1612888,
                    56.3861337
                ],
                [
                    88.1615566,
                    56.3861337
                ],
                [
                    88.161968,
                    56.385994
                ],
                [
                    88.1620844,
                    56.3858673
                ],
                [
                    88.162492,
                    56.3858952
                ],
                [
                    88.1625114,
                    56.3861401
                ],
                [
                    88.1629732,
                    56.3862325
                ],
                [
                    88.1631206,
                    56.3864345
                ],
                [
                    88.1632682,
                    56.3864474
                ],
                [
                    88.1636447,
                    56.3859124
                ],
                [
                    88.1652748,
                    56.3859468
                ],
                [
                    88.1657289,
                    56.3859919
                ],
                [
                    88.1657405,
                    56.3860714
                ],
                [
                    88.1662295,
                    56.3860821
                ],
                [
                    88.1662839,
                    56.3862175
                ],
                [
                    88.1665517,
                    56.3862261
                ],
                [
                    88.1666565,
                    56.3859124
                ],
                [
                    88.1668389,
                    56.3856717
                ],
                [
                    88.1671766,
                    56.385517
                ],
                [
                    88.1677083,
                    56.3854955
                ],
                [
                    88.1677704,
                    56.3850057
                ],
                [
                    88.1682361,
                    56.3849498
                ],
                [
                    88.168456,
                    56.3845072
                ],
                [
                    88.1612782,
                    56.3822776
                ],
                [
                    88.1611716,
                    56.3819563
                ],
                [
                    88.1611953,
                    56.3811759
                ],
                [
                    88.1609821,
                    56.3808677
                ],
                [
                    88.1601886,
                    56.3803627
                ],
                [
                    88.160532,
                    56.3797135
                ],
                [
                    88.1601649,
                    56.3795495
                ],
                [
                    88.1599279,
                    56.3793331
                ],
                [
                    88.158708,
                    56.3790773
                ],
                [
                    88.158175,
                    56.3790445
                ],
                [
                    88.1576065,
                    56.3796086
                ],
                [
                    88.1567418,
                    56.3793134
                ],
                [
                    88.1552731,
                    56.378592
                ],
                [
                    88.1541953,
                    56.3793659
                ],
                [
                    88.1529398,
                    56.3798709
                ],
                [
                    88.1527029,
                    56.3801135
                ],
                [
                    88.1525963,
                    56.3803168
                ]
            ],
            "longitude": 88.159012,
            "latitude": 56.383942
        },
        "1355": {
            "name": "Комсомольск",
            "population": 2036,
            "type": "village",
            "poly": null,
            "longitude": 88.182556,
            "latitude": 55.632576
        },
        "1356": {
            "name": "Листвянка",
            "population": 535,
            "type": "village",
            "poly": [
                [
                    88.1884326,
                    55.918934
                ],
                [
                    88.189654,
                    55.9249805
                ],
                [
                    88.1970476,
                    55.9317653
                ],
                [
                    88.1972105,
                    55.9328037
                ],
                [
                    88.200607,
                    55.9328339
                ],
                [
                    88.2014029,
                    55.9333926
                ],
                [
                    88.2021381,
                    55.9333636
                ],
                [
                    88.2024095,
                    55.9325657
                ],
                [
                    88.2048042,
                    55.9324515
                ],
                [
                    88.20618,
                    55.9320519
                ],
                [
                    88.2072071,
                    55.9305817
                ],
                [
                    88.2087446,
                    55.930758
                ],
                [
                    88.2088974,
                    55.9326133
                ],
                [
                    88.2098995,
                    55.9333553
                ],
                [
                    88.2105282,
                    55.9335549
                ],
                [
                    88.2122571,
                    55.9327744
                ],
                [
                    88.2156386,
                    55.9324347
                ],
                [
                    88.2182926,
                    55.9331102
                ],
                [
                    88.2205939,
                    55.9331231
                ],
                [
                    88.2216514,
                    55.9326703
                ],
                [
                    88.2217304,
                    55.9303969
                ],
                [
                    88.2220143,
                    55.9302368
                ],
                [
                    88.224074,
                    55.9305373
                ],
                [
                    88.2248385,
                    55.9300829
                ],
                [
                    88.2259599,
                    55.9290454
                ],
                [
                    88.2295749,
                    55.9268687
                ],
                [
                    88.2294366,
                    55.9256025
                ],
                [
                    88.2281821,
                    55.9248141
                ],
                [
                    88.226044,
                    55.924088
                ],
                [
                    88.2215911,
                    55.9211652
                ],
                [
                    88.2135098,
                    55.9199368
                ],
                [
                    88.2103319,
                    55.9185658
                ],
                [
                    88.2113402,
                    55.9163955
                ],
                [
                    88.2059371,
                    55.9164785
                ],
                [
                    88.1961672,
                    55.9170177
                ],
                [
                    88.1884326,
                    55.918934
                ]
            ],
            "longitude": 88.2036733,
            "latitude": 55.9242252
        },
        "1357": {
            "name": "Майзас",
            "population": 623,
            "type": "village",
            "poly": [
                [
                    88.1975106,
                    53.6195425
                ],
                [
                    88.2009804,
                    53.6211311
                ],
                [
                    88.1987889,
                    53.6235501
                ],
                [
                    88.197815,
                    53.6262576
                ],
                [
                    88.2012543,
                    53.627431
                ],
                [
                    88.2051502,
                    53.627792
                ],
                [
                    88.2100809,
                    53.6245971
                ],
                [
                    88.2130941,
                    53.6212214
                ],
                [
                    88.209807,
                    53.6191453
                ],
                [
                    88.2102026,
                    53.6169968
                ],
                [
                    88.213855,
                    53.6157511
                ],
                [
                    88.212181,
                    53.6142706
                ],
                [
                    88.2080864,
                    53.6138959
                ],
                [
                    88.2055458,
                    53.6157331
                ],
                [
                    88.201863,
                    53.6200118
                ],
                [
                    88.1980889,
                    53.618694
                ],
                [
                    88.1975106,
                    53.6195425
                ]
            ],
            "longitude": 88.2045587,
            "latitude": 53.6226188
        },
        "1358": {
            "name": "Колба",
            "population": 419,
            "type": "village",
            "poly": null,
            "longitude": 88.2131147,
            "latitude": 55.8264795
        },
        "1359": {
            "name": "Усть-Колба",
            "population": 514,
            "type": "village",
            "poly": null,
            "longitude": 88.3025503,
            "latitude": 55.8824606
        },
        "1360": {
            "name": "Утинка",
            "population": 441,
            "type": "village",
            "poly": null,
            "longitude": 88.3347496,
            "latitude": 55.7408909
        },
        "1361": {
            "name": "Валерьяновка",
            "population": 418,
            "type": "village",
            "poly": [
                [
                    88.3761791,
                    56.0079127
                ],
                [
                    88.377854,
                    56.008973
                ],
                [
                    88.3780041,
                    56.0096795
                ],
                [
                    88.3783475,
                    56.0101352
                ],
                [
                    88.3793572,
                    56.0104923
                ],
                [
                    88.3797024,
                    56.0109969
                ],
                [
                    88.3795894,
                    56.0116164
                ],
                [
                    88.3814641,
                    56.0131106
                ],
                [
                    88.3814555,
                    56.014499
                ],
                [
                    88.3838322,
                    56.0154898
                ],
                [
                    88.3849251,
                    56.0148302
                ],
                [
                    88.3855926,
                    56.0148934
                ],
                [
                    88.3858295,
                    56.0156044
                ],
                [
                    88.3892559,
                    56.0174873
                ],
                [
                    88.3929288,
                    56.0195056
                ],
                [
                    88.3961884,
                    56.0222745
                ],
                [
                    88.3985124,
                    56.0193276
                ],
                [
                    88.3979823,
                    56.0185724
                ],
                [
                    88.401527,
                    56.0195293
                ],
                [
                    88.4051999,
                    56.0198615
                ],
                [
                    88.4078886,
                    56.0208273
                ],
                [
                    88.4119398,
                    56.0200123
                ],
                [
                    88.4082145,
                    56.0189004
                ],
                [
                    88.4075139,
                    56.0178918
                ],
                [
                    88.4068983,
                    56.0177019
                ],
                [
                    88.406877,
                    56.0172985
                ],
                [
                    88.4052848,
                    56.016278
                ],
                [
                    88.4040534,
                    56.0158626
                ],
                [
                    88.4042657,
                    56.0151862
                ],
                [
                    88.4034378,
                    56.0151269
                ],
                [
                    88.4028468,
                    56.0153878
                ],
                [
                    88.4020603,
                    56.0134255
                ],
                [
                    88.399108,
                    56.0122016
                ],
                [
                    88.3983118,
                    56.0109592
                ],
                [
                    88.3975749,
                    56.0112918
                ],
                [
                    88.3966747,
                    56.0107031
                ],
                [
                    88.3973167,
                    56.0102545
                ],
                [
                    88.3965912,
                    56.0099648
                ],
                [
                    88.3961992,
                    56.0102474
                ],
                [
                    88.3956896,
                    56.0100195
                ],
                [
                    88.3964369,
                    56.0091839
                ],
                [
                    88.3957593,
                    56.0087593
                ],
                [
                    88.3937006,
                    56.0087777
                ],
                [
                    88.3927681,
                    56.0082449
                ],
                [
                    88.3919614,
                    56.0072717
                ],
                [
                    88.3901142,
                    56.0067375
                ],
                [
                    88.3903479,
                    56.0060728
                ],
                [
                    88.3892651,
                    56.0057048
                ],
                [
                    88.3890316,
                    56.0064408
                ],
                [
                    88.3885009,
                    56.0064408
                ],
                [
                    88.3869723,
                    56.0059422
                ],
                [
                    88.386484,
                    56.0052182
                ],
                [
                    88.3871634,
                    56.0050045
                ],
                [
                    88.3864628,
                    56.0044703
                ],
                [
                    88.38538,
                    56.0050282
                ],
                [
                    88.3845733,
                    56.0047671
                ],
                [
                    88.3845383,
                    56.0039125
                ],
                [
                    88.3840725,
                    56.0040082
                ],
                [
                    88.3837328,
                    56.0043728
                ],
                [
                    88.3829011,
                    56.0042352
                ],
                [
                    88.3824148,
                    56.0043652
                ],
                [
                    88.3827383,
                    56.0047536
                ],
                [
                    88.3819362,
                    56.0051221
                ],
                [
                    88.3785896,
                    56.0044823
                ],
                [
                    88.3766976,
                    56.0041855
                ],
                [
                    88.376518,
                    56.0046468
                ],
                [
                    88.3793038,
                    56.0064271
                ],
                [
                    88.3761791,
                    56.0079127
                ]
            ],
            "longitude": 88.3897542,
            "latitude": 56.0109784
        },
        "1362": {
            "name": "Листвянка",
            "population": 644,
            "type": "village",
            "poly": [
                [
                    88.3825646,
                    56.0716218
                ],
                [
                    88.3881662,
                    56.073891
                ],
                [
                    88.3957556,
                    56.0739919
                ],
                [
                    88.4041581,
                    56.0770677
                ],
                [
                    88.407501,
                    56.0748491
                ],
                [
                    88.4058747,
                    56.0733363
                ],
                [
                    88.40723,
                    56.0719244
                ],
                [
                    88.405694,
                    56.0706132
                ],
                [
                    88.4079528,
                    56.0663768
                ],
                [
                    88.4061458,
                    56.0651663
                ],
                [
                    88.405694,
                    56.0639558
                ],
                [
                    88.4062361,
                    56.0626948
                ],
                [
                    88.4028028,
                    56.0614842
                ],
                [
                    88.4007248,
                    56.0617364
                ],
                [
                    88.4003634,
                    56.0646619
                ],
                [
                    88.397924,
                    56.0651159
                ],
                [
                    88.3871724,
                    56.0647124
                ],
                [
                    88.3825646,
                    56.0716218
                ]
            ],
            "longitude": 88.396622,
            "latitude": 56.069378
        },
        "1363": {
            "name": "Дворниково",
            "population": 291,
            "type": "village",
            "poly": null,
            "longitude": 88.409667,
            "latitude": 55.7953226
        },
        "1364": {
            "name": "Третьяково",
            "population": 349,
            "type": "village",
            "poly": null,
            "longitude": 88.4423887,
            "latitude": 55.7952663
        },
        "1365": {
            "name": "Усть-Кабырза",
            "population": 523,
            "type": "village",
            "poly": [
                [
                    88.4292089,
                    52.8266025
                ],
                [
                    88.4327263,
                    52.8286501
                ],
                [
                    88.4417744,
                    52.8276071
                ],
                [
                    88.4470111,
                    52.8268148
                ],
                [
                    88.4518937,
                    52.8263468
                ],
                [
                    88.4591404,
                    52.8259382
                ],
                [
                    88.4567475,
                    52.8219234
                ],
                [
                    88.4599621,
                    52.8204468
                ],
                [
                    88.4632741,
                    52.8189686
                ],
                [
                    88.4692862,
                    52.8172908
                ],
                [
                    88.4736178,
                    52.8158603
                ],
                [
                    88.4781524,
                    52.8149632
                ],
                [
                    88.4773299,
                    52.814242
                ],
                [
                    88.472522,
                    52.8138989
                ],
                [
                    88.4523452,
                    52.8178894
                ],
                [
                    88.4350434,
                    52.8206555
                ],
                [
                    88.4344989,
                    52.8215796
                ],
                [
                    88.4319705,
                    52.8225417
                ],
                [
                    88.4344238,
                    52.8260677
                ],
                [
                    88.4292089,
                    52.8266025
                ]
            ],
            "longitude": 88.445816,
            "latitude": 52.824162
        },
        "1366": {
            "name": "Полуторник",
            "population": 1134,
            "type": "village",
            "poly": [
                [
                    88.4348679,
                    55.3107479
                ],
                [
                    88.449465,
                    55.3136161
                ],
                [
                    88.4560611,
                    55.3185767
                ],
                [
                    88.4575431,
                    55.3210568
                ],
                [
                    88.4638486,
                    55.3203789
                ],
                [
                    88.4704448,
                    55.3252064
                ],
                [
                    88.4705319,
                    55.3262479
                ],
                [
                    88.4729147,
                    55.327653
                ],
                [
                    88.4761982,
                    55.3280167
                ],
                [
                    88.4769247,
                    55.3297192
                ],
                [
                    88.4769828,
                    55.3314713
                ],
                [
                    88.476111,
                    55.3319342
                ],
                [
                    88.4761401,
                    55.3333225
                ],
                [
                    88.4785519,
                    55.3333887
                ],
                [
                    88.482097,
                    55.3314218
                ],
                [
                    88.4853805,
                    55.3309094
                ],
                [
                    88.4873025,
                    55.3296109
                ],
                [
                    88.4867569,
                    55.3289636
                ],
                [
                    88.4871493,
                    55.3283049
                ],
                [
                    88.4879741,
                    55.3280571
                ],
                [
                    88.4874308,
                    55.3274693
                ],
                [
                    88.4867699,
                    55.3265262
                ],
                [
                    88.486109,
                    55.3255831
                ],
                [
                    88.4860264,
                    55.3234509
                ],
                [
                    88.4807169,
                    55.3199137
                ],
                [
                    88.4769076,
                    55.3177162
                ],
                [
                    88.4727949,
                    55.3156993
                ],
                [
                    88.4641294,
                    55.313737
                ],
                [
                    88.459328,
                    55.3126726
                ],
                [
                    88.4544149,
                    55.3113732
                ],
                [
                    88.4495603,
                    55.308833
                ],
                [
                    88.4461806,
                    55.3069837
                ],
                [
                    88.4443019,
                    55.3058053
                ],
                [
                    88.4423659,
                    55.304549
                ],
                [
                    88.4390039,
                    55.3065903
                ],
                [
                    88.4348679,
                    55.3107479
                ]
            ],
            "longitude": 88.4691302,
            "latitude": 55.3190171
        },
        "1367": {
            "name": "Белогорск",
            "population": 2755,
            "type": "village",
            "poly": null,
            "longitude": 88.486359,
            "latitude": 55.018394
        },
        "1368": {
            "name": "Нововосточный",
            "population": 455,
            "type": "village",
            "poly": [
                [
                    88.5333135,
                    56.1559675
                ],
                [
                    88.5357155,
                    56.1593119
                ],
                [
                    88.5393187,
                    56.1610583
                ],
                [
                    88.5422545,
                    56.1610583
                ],
                [
                    88.5437892,
                    56.1628418
                ],
                [
                    88.5447901,
                    56.1625074
                ],
                [
                    88.5437225,
                    56.1603895
                ],
                [
                    88.5492606,
                    56.1599436
                ],
                [
                    88.5486601,
                    56.1564506
                ],
                [
                    88.5514625,
                    56.1555959
                ],
                [
                    88.549661,
                    56.1540351
                ],
                [
                    88.5468585,
                    56.152883
                ],
                [
                    88.5377173,
                    56.1541838
                ],
                [
                    88.5381176,
                    56.155373
                ],
                [
                    88.5333135,
                    56.1559675
                ]
            ],
            "longitude": 88.5423612,
            "latitude": 56.1579077
        },
        "1369": {
            "name": "Теба",
            "population": 706,
            "type": "village",
            "poly": null,
            "longitude": 88.5504161,
            "latitude": 53.6440023
        },
        "1370": {
            "name": "Ступишино",
            "population": 541,
            "type": "village",
            "poly": null,
            "longitude": 88.5518026,
            "latitude": 56.2101649
        },
        "1371": {
            "name": "Преображенка",
            "population": 885,
            "type": "village",
            "poly": null,
            "longitude": 88.5670804,
            "latitude": 56.0375514
        },
        "1372": {
            "name": "Тяжино-Вершинка",
            "population": 374,
            "type": "village",
            "poly": null,
            "longitude": 88.5929061,
            "latitude": 55.91932
        },
        "1373": {
            "name": "Георгиевка",
            "population": 280,
            "type": "village",
            "poly": [
                [
                    88.606771,
                    56.2686162
                ],
                [
                    88.6081776,
                    56.2691987
                ],
                [
                    88.6085829,
                    56.2689604
                ],
                [
                    88.6088928,
                    56.2691854
                ],
                [
                    88.6102517,
                    56.271052
                ],
                [
                    88.6134224,
                    56.272058
                ],
                [
                    88.6140661,
                    56.2724683
                ],
                [
                    88.613017,
                    56.2730243
                ],
                [
                    88.6116821,
                    56.2739376
                ],
                [
                    88.6137562,
                    56.275526
                ],
                [
                    88.6087736,
                    56.2779746
                ],
                [
                    88.6087974,
                    56.2781466
                ],
                [
                    88.610657,
                    56.2791128
                ],
                [
                    88.6107046,
                    56.279298
                ],
                [
                    88.6095365,
                    56.2798407
                ],
                [
                    88.6095842,
                    56.2801053
                ],
                [
                    88.6118251,
                    56.2815743
                ],
                [
                    88.6128978,
                    56.2818655
                ],
                [
                    88.6133747,
                    56.2815876
                ],
                [
                    88.6141138,
                    56.2822228
                ],
                [
                    88.6146859,
                    56.2822625
                ],
                [
                    88.6153058,
                    56.2818522
                ],
                [
                    88.6158064,
                    56.281839
                ],
                [
                    88.6162439,
                    56.2823747
                ],
                [
                    88.616884,
                    56.2822777
                ],
                [
                    88.6203763,
                    56.28063
                ],
                [
                    88.621715,
                    56.2808884
                ],
                [
                    88.624858,
                    56.2812762
                ],
                [
                    88.6296306,
                    56.2834408
                ],
                [
                    88.6299851,
                    56.283126
                ],
                [
                    88.63076,
                    56.2835891
                ],
                [
                    88.632101,
                    56.2830764
                ],
                [
                    88.6293892,
                    56.2808762
                ],
                [
                    88.6313262,
                    56.2804958
                ],
                [
                    88.631058,
                    56.2799002
                ],
                [
                    88.6303726,
                    56.2798506
                ],
                [
                    88.6289422,
                    56.2781797
                ],
                [
                    88.626737,
                    56.2777992
                ],
                [
                    88.625843,
                    56.2770878
                ],
                [
                    88.6255152,
                    56.2753671
                ],
                [
                    88.6244722,
                    56.2747715
                ],
                [
                    88.6244722,
                    56.2743083
                ],
                [
                    88.625396,
                    56.2736133
                ],
                [
                    88.626588,
                    56.2734313
                ],
                [
                    88.6272436,
                    56.2724055
                ],
                [
                    88.6268264,
                    56.2711314
                ],
                [
                    88.6265284,
                    56.2709328
                ],
                [
                    88.6268562,
                    56.2707343
                ],
                [
                    88.6267668,
                    56.2697911
                ],
                [
                    88.6260814,
                    56.2695594
                ],
                [
                    88.626141,
                    56.2689802
                ],
                [
                    88.6265284,
                    56.2685996
                ],
                [
                    88.6254854,
                    56.2682356
                ],
                [
                    88.6242934,
                    56.2685996
                ],
                [
                    88.623161,
                    56.2686162
                ],
                [
                    88.6229822,
                    56.2682356
                ],
                [
                    88.6212836,
                    56.2673916
                ],
                [
                    88.6213134,
                    56.2666304
                ],
                [
                    88.6239656,
                    56.2657202
                ],
                [
                    88.622416,
                    56.2651575
                ],
                [
                    88.6207174,
                    56.2656043
                ],
                [
                    88.6206876,
                    56.2649755
                ],
                [
                    88.618244,
                    56.2649755
                ],
                [
                    88.6183036,
                    56.2644624
                ],
                [
                    88.6225352,
                    56.2634529
                ],
                [
                    88.6236378,
                    56.2626916
                ],
                [
                    88.6238464,
                    56.262344
                ],
                [
                    88.6226246,
                    56.2614834
                ],
                [
                    88.6201512,
                    56.2620957
                ],
                [
                    88.6189294,
                    56.2613013
                ],
                [
                    88.6165156,
                    56.2621619
                ],
                [
                    88.6171712,
                    56.2630557
                ],
                [
                    88.6165454,
                    56.2628736
                ],
                [
                    88.610645,
                    56.262675
                ],
                [
                    88.609602,
                    56.262824
                ],
                [
                    88.608261,
                    56.2636515
                ],
                [
                    88.6078438,
                    56.2667297
                ],
                [
                    88.606771,
                    56.2686162
                ]
            ],
            "longitude": 88.6182128,
            "latitude": 56.2697328
        },
        "1374": {
            "name": "Ортон",
            "population": 658,
            "type": "village",
            "poly": [
                [
                    88.61215,
                    53.2086102
                ],
                [
                    88.6128744,
                    53.2103891
                ],
                [
                    88.6152649,
                    53.2104324
                ],
                [
                    88.6162791,
                    53.2116472
                ],
                [
                    88.6166777,
                    53.2090007
                ],
                [
                    88.6206681,
                    53.21034
                ],
                [
                    88.6242538,
                    53.2091436
                ],
                [
                    88.6276718,
                    53.2055378
                ],
                [
                    88.6268009,
                    53.2050699
                ],
                [
                    88.6274825,
                    53.2021037
                ],
                [
                    88.62444,
                    53.2024074
                ],
                [
                    88.6223753,
                    53.2014094
                ],
                [
                    88.6196225,
                    53.2022773
                ],
                [
                    88.6203832,
                    53.2005849
                ],
                [
                    88.6248384,
                    53.1995651
                ],
                [
                    88.6242588,
                    53.1986755
                ],
                [
                    88.6178839,
                    53.2016915
                ],
                [
                    88.6150224,
                    53.2086555
                ],
                [
                    88.61215,
                    53.2086102
                ]
            ],
            "longitude": 88.6217456,
            "latitude": 53.2056078
        },
        "1375": {
            "name": "Тамбар",
            "population": 1077,
            "type": "village",
            "poly": [
                [
                    88.5978863,
                    55.5915483
                ],
                [
                    88.5985155,
                    55.5922189
                ],
                [
                    88.5985155,
                    55.595777
                ],
                [
                    88.599535,
                    55.5973447
                ],
                [
                    88.6037116,
                    55.5973447
                ],
                [
                    88.6045542,
                    55.5968686
                ],
                [
                    88.6148124,
                    55.59691
                ],
                [
                    88.6146659,
                    55.5982969
                ],
                [
                    88.6136401,
                    55.5992905
                ],
                [
                    88.6171938,
                    55.6010912
                ],
                [
                    88.6178532,
                    55.604589
                ],
                [
                    88.616168,
                    55.6079002
                ],
                [
                    88.6163512,
                    55.6097627
                ],
                [
                    88.6289175,
                    55.6111077
                ],
                [
                    88.6311157,
                    55.6109835
                ],
                [
                    88.6389193,
                    55.606286
                ],
                [
                    88.6363913,
                    55.595875
                ],
                [
                    88.6390658,
                    55.5909686
                ],
                [
                    88.638846,
                    55.5906374
                ],
                [
                    88.6295037,
                    55.5897057
                ],
                [
                    88.6230557,
                    55.5848814
                ],
                [
                    88.6175602,
                    55.5844466
                ],
                [
                    88.6155818,
                    55.5839082
                ],
                [
                    88.5978863,
                    55.5915483
                ]
            ],
            "longitude": 88.6233854,
            "latitude": 55.5900116
        },
        "1376": {
            "name": "Даниловка",
            "population": 460,
            "type": "village",
            "poly": [
                [
                    88.6285142,
                    56.3142151
                ],
                [
                    88.6306002,
                    56.3146283
                ],
                [
                    88.6324255,
                    56.3168182
                ],
                [
                    88.6331705,
                    56.3184502
                ],
                [
                    88.6343997,
                    56.3178511
                ],
                [
                    88.6384972,
                    56.3174793
                ],
                [
                    88.638609,
                    56.3166736
                ],
                [
                    88.6391304,
                    56.3166736
                ],
                [
                    88.6410302,
                    56.317252
                ],
                [
                    88.6429672,
                    56.3184915
                ],
                [
                    88.6452395,
                    56.317376
                ],
                [
                    88.6470647,
                    56.3174379
                ],
                [
                    88.6495977,
                    56.3165083
                ],
                [
                    88.6495977,
                    56.3155786
                ],
                [
                    88.651274,
                    56.3136779
                ],
                [
                    88.654552,
                    56.3141531
                ],
                [
                    88.6565262,
                    56.3151241
                ],
                [
                    88.6561537,
                    56.3155993
                ],
                [
                    88.6567125,
                    56.3158679
                ],
                [
                    88.6585377,
                    56.316467
                ],
                [
                    88.659618,
                    56.3155167
                ],
                [
                    88.6605864,
                    56.3157233
                ],
                [
                    88.66379,
                    56.3139672
                ],
                [
                    88.6612942,
                    56.3125002
                ],
                [
                    88.6648702,
                    56.3099175
                ],
                [
                    88.6662485,
                    56.3098555
                ],
                [
                    88.6710537,
                    56.3110746
                ],
                [
                    88.6717242,
                    56.3096282
                ],
                [
                    88.668707,
                    56.3085951
                ],
                [
                    88.6661367,
                    56.3078925
                ],
                [
                    88.6657642,
                    56.3071073
                ],
                [
                    88.663343,
                    56.3070866
                ],
                [
                    88.6623,
                    56.3074379
                ],
                [
                    88.6604002,
                    56.3074379
                ],
                [
                    88.660214,
                    56.3076446
                ],
                [
                    88.658426,
                    56.3075206
                ],
                [
                    88.657532,
                    56.3066113
                ],
                [
                    88.6550362,
                    56.3071073
                ],
                [
                    88.6538442,
                    56.3040075
                ],
                [
                    88.6529502,
                    56.3040282
                ],
                [
                    88.652913,
                    56.3044829
                ],
                [
                    88.651721,
                    56.3049375
                ],
                [
                    88.6498957,
                    56.3049788
                ],
                [
                    88.6488155,
                    56.3044002
                ],
                [
                    88.6492625,
                    56.3031396
                ],
                [
                    88.6472882,
                    56.3020649
                ],
                [
                    88.6455002,
                    56.3018789
                ],
                [
                    88.6437867,
                    56.3004942
                ],
                [
                    88.6427065,
                    56.3004322
                ],
                [
                    88.6368582,
                    56.3018169
                ],
                [
                    88.6361132,
                    56.3023129
                ],
                [
                    88.6353682,
                    56.3044829
                ],
                [
                    88.6330215,
                    56.3079752
                ],
                [
                    88.6330587,
                    56.309029
                ],
                [
                    88.6313825,
                    56.3105374
                ],
                [
                    88.6312707,
                    56.3112812
                ],
                [
                    88.6306747,
                    56.3113639
                ],
                [
                    88.6290357,
                    56.3138432
                ],
                [
                    88.6285515,
                    56.3138432
                ],
                [
                    88.6285142,
                    56.3142151
                ]
            ],
            "longitude": 88.6446,
            "latitude": 56.3102206
        },
        "1377": {
            "name": "Тисуль",
            "population": 712,
            "type": "village",
            "poly": [
                [
                    88.6682948,
                    56.0860758
                ],
                [
                    88.6750531,
                    56.0881678
                ],
                [
                    88.6770898,
                    56.0874446
                ],
                [
                    88.6803764,
                    56.0841904
                ],
                [
                    88.680006,
                    56.0837255
                ],
                [
                    88.6771824,
                    56.0827182
                ],
                [
                    88.6806078,
                    56.079541
                ],
                [
                    88.6828759,
                    56.0796702
                ],
                [
                    88.69056,
                    56.0783786
                ],
                [
                    88.6965776,
                    56.0756145
                ],
                [
                    88.6947261,
                    56.0738836
                ],
                [
                    88.6956055,
                    56.0730051
                ],
                [
                    88.6947724,
                    56.0724368
                ],
                [
                    88.6997716,
                    56.0707574
                ],
                [
                    88.7020861,
                    56.0697497
                ],
                [
                    88.7015769,
                    56.0668816
                ],
                [
                    88.6986607,
                    56.066649
                ],
                [
                    88.701438,
                    56.064375
                ],
                [
                    88.7033359,
                    56.063729
                ],
                [
                    88.7065762,
                    56.0637031
                ],
                [
                    88.7075945,
                    56.0635481
                ],
                [
                    88.7083351,
                    56.0593356
                ],
                [
                    88.6959758,
                    56.0576298
                ],
                [
                    88.6913469,
                    56.0547091
                ],
                [
                    88.6848201,
                    56.0654862
                ],
                [
                    88.6790802,
                    56.068587
                ],
                [
                    88.6712572,
                    56.0725918
                ],
                [
                    88.6699149,
                    56.0744778
                ],
                [
                    88.6689429,
                    56.076622
                ],
                [
                    88.6691743,
                    56.0780686
                ],
                [
                    88.6706556,
                    56.0796185
                ],
                [
                    88.6717202,
                    56.0802643
                ],
                [
                    88.6744049,
                    56.0813492
                ],
                [
                    88.6682948,
                    56.0860758
                ]
            ],
            "longitude": 88.6841535,
            "latitude": 56.0748379
        },
        "1378": {
            "name": "Большой Барандат",
            "population": 590,
            "type": "village",
            "poly": null,
            "longitude": 88.754021,
            "latitude": 55.758247
        },
        "1379": {
            "name": "Акимо-Анненка",
            "population": 439,
            "type": "village",
            "poly": null,
            "longitude": 88.7967634,
            "latitude": 56.0794363
        },
        "1380": {
            "name": "Малопичугино",
            "population": 292,
            "type": "village",
            "poly": null,
            "longitude": 88.8767576,
            "latitude": 55.8519267
        },
        "1381": {
            "name": "Новопокровка",
            "population": 416,
            "type": "village",
            "poly": null,
            "longitude": 88.9459371,
            "latitude": 55.9535489
        },
        "1382": {
            "name": "Новомарьинка",
            "population": 253,
            "type": "village",
            "poly": null,
            "longitude": 89.013915,
            "latitude": 56.0878653
        },
        "1383": {
            "name": "Серебряково",
            "population": 534,
            "type": "village",
            "poly": null,
            "longitude": 89.0188932,
            "latitude": 55.6933824
        },
        "1384": {
            "name": "Итатский",
            "population": 3299,
            "type": "village",
            "poly": null,
            "longitude": 89.032578,
            "latitude": 56.068081
        },
        "1385": {
            "name": "Новоподзорново",
            "population": 604,
            "type": "village",
            "poly": null,
            "longitude": 89.0988874,
            "latitude": 55.8636807
        },
        "1386": {
            "name": "Кубитет",
            "population": 757,
            "type": "village",
            "poly": null,
            "longitude": 89.1348751,
            "latitude": 55.9441929
        },
        "1387": {
            "name": "Чулым",
            "population": 234,
            "type": "village",
            "poly": null,
            "longitude": 89.2083193,
            "latitude": 56.045594
        },
        "1388": {
            "name": "Старый Урюп",
            "population": 488,
            "type": "village",
            "poly": null,
            "longitude": 89.3361234,
            "latitude": 55.8350601
        },
        "1389": {
            "name": "Приисковое",
            "population": 470,
            "type": "village",
            "poly": null,
            "longitude": 88.695641,
            "latitude": 54.653049
        },
        "1390": {
            "name": "Орджоникидзевское",
            "population": 522,
            "type": "village",
            "poly": null,
            "longitude": 88.963654,
            "latitude": 54.777313
        },
        "1391": {
            "name": "Балыкса",
            "population": 1996,
            "type": "village",
            "poly": null,
            "longitude": 89.137718,
            "latitude": 53.416523
        },
        "1392": {
            "name": "Гайдаровск",
            "population": 291,
            "type": "village",
            "poly": null,
            "longitude": 89.1717794,
            "latitude": 54.6221899
        },
        "1393": {
            "name": "Сарала",
            "population": 918,
            "type": "village",
            "poly": null,
            "longitude": 89.2425,
            "latitude": 54.863907
        },
        "1394": {
            "name": "Коммунар",
            "population": 2299,
            "type": "village",
            "poly": null,
            "longitude": 89.290825,
            "latitude": 54.350353
        },
        "1395": {
            "name": "Чёрное Озеро",
            "population": 957,
            "type": "village",
            "poly": null,
            "longitude": 89.4291398,
            "latitude": 54.6869463
        },
        "1396": {
            "name": "Верхний Таштып",
            "population": 533,
            "type": "village",
            "poly": null,
            "longitude": 89.44495,
            "latitude": 52.8110468
        },
        "1397": {
            "name": "Ефремкино",
            "population": 451,
            "type": "village",
            "poly": null,
            "longitude": 89.447456,
            "latitude": 54.467525
        },
        "1398": {
            "name": "Подкамень",
            "population": 319,
            "type": "village",
            "poly": null,
            "longitude": 89.448189,
            "latitude": 54.821259
        },
        "1399": {
            "name": "Матур",
            "population": 1231,
            "type": "village",
            "poly": null,
            "longitude": 89.45974,
            "latitude": 52.654572
        },
        "1400": {
            "name": "Белый Балахчин",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 89.47953,
            "latitude": 54.555183
        },
        "1401": {
            "name": "Анчул",
            "population": 313,
            "type": "village",
            "poly": null,
            "longitude": 89.48201,
            "latitude": 52.808495
        },
        "1402": {
            "name": "Беренжак",
            "population": 250,
            "type": "village",
            "poly": null,
            "longitude": 89.482201,
            "latitude": 54.140209
        },
        "1403": {
            "name": "Бискамжа",
            "population": 1144,
            "type": "village",
            "poly": null,
            "longitude": 89.528656,
            "latitude": 53.450871
        },
        "1404": {
            "name": "Устинкино",
            "population": 1158,
            "type": "village",
            "poly": null,
            "longitude": 89.561111,
            "latitude": 54.907589
        },
        "1405": {
            "name": "Вершина Тёи",
            "population": 3545,
            "type": "village",
            "poly": null,
            "longitude": 89.562622,
            "latitude": 53.26786
        },
        "1406": {
            "name": "Верхняя Сея",
            "population": 242,
            "type": "village",
            "poly": null,
            "longitude": 89.700256,
            "latitude": 52.682571
        },
        "1407": {
            "name": "Малый Кобежиков",
            "population": 284,
            "type": "village",
            "poly": null,
            "longitude": 89.731331,
            "latitude": 54.541687
        },
        "1408": {
            "name": "Июс",
            "population": 1201,
            "type": "village",
            "poly": null,
            "longitude": 89.758881,
            "latitude": 54.700157
        },
        "1409": {
            "name": "Нижние Сиры",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 89.7616369,
            "latitude": 52.7535232
        },
        "1410": {
            "name": "Кобяково",
            "population": 371,
            "type": "village",
            "poly": null,
            "longitude": 89.775406,
            "latitude": 54.795418
        },
        "1411": {
            "name": "Отты",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 89.780022,
            "latitude": 52.961269
        },
        "1412": {
            "name": "Большая Сея",
            "population": 433,
            "type": "village",
            "poly": null,
            "longitude": 89.796463,
            "latitude": 52.742954
        },
        "1413": {
            "name": "Фыркал",
            "population": 716,
            "type": "village",
            "poly": null,
            "longitude": 89.815819,
            "latitude": 54.63015
        },
        "1414": {
            "name": "Малая Сея",
            "population": 291,
            "type": "village",
            "poly": null,
            "longitude": 89.8326332,
            "latitude": 52.7536753
        },
        "1415": {
            "name": "Нижний Курлугаш",
            "population": 310,
            "type": "village",
            "poly": null,
            "longitude": 89.8343187,
            "latitude": 52.7790742
        },
        "1416": {
            "name": "Верхний Имек",
            "population": 244,
            "type": "village",
            "poly": null,
            "longitude": 89.844406,
            "latitude": 52.873665
        },
        "1417": {
            "name": "Копьёво",
            "population": 721,
            "type": "village",
            "poly": null,
            "longitude": 89.847221,
            "latitude": 55.03561
        },
        "1418": {
            "name": "Усть-Чуль",
            "population": 993,
            "type": "village",
            "poly": null,
            "longitude": 89.867302,
            "latitude": 52.959057
        },
        "1419": {
            "name": "Харой",
            "population": 167,
            "type": "village",
            "poly": null,
            "longitude": 89.8766903,
            "latitude": 52.9020882
        },
        "1420": {
            "name": "Солёноозёрное",
            "population": 736,
            "type": "village",
            "poly": null,
            "longitude": 89.878975,
            "latitude": 54.729546
        },
        "1421": {
            "name": "Бирикчуль",
            "population": 2519,
            "type": "village",
            "poly": null,
            "longitude": 89.884003,
            "latitude": 53.327736
        },
        "1422": {
            "name": "Усть-Хойза",
            "population": 437,
            "type": "village",
            "poly": null,
            "longitude": 89.912445,
            "latitude": 53.136806
        },
        "1423": {
            "name": "Целинное",
            "population": 1533,
            "type": "village",
            "poly": null,
            "longitude": 89.913689,
            "latitude": 54.58194
        },
        "1424": {
            "name": "Имек",
            "population": 1260,
            "type": "village",
            "poly": null,
            "longitude": 89.927124,
            "latitude": 52.850498
        },
        "1425": {
            "name": "Туим",
            "population": 4211,
            "type": "village",
            "poly": null,
            "longitude": 89.944397,
            "latitude": 54.339775
        },
        "1426": {
            "name": "Малый Спирин",
            "population": 696,
            "type": "village",
            "poly": null,
            "longitude": 89.944855,
            "latitude": 54.440174
        },
        "1427": {
            "name": "Кызлас",
            "population": 1036,
            "type": "village",
            "poly": null,
            "longitude": 89.956627,
            "latitude": 53.116982
        },
        "1428": {
            "name": "Нижний Имек",
            "population": 409,
            "type": "village",
            "poly": null,
            "longitude": 89.958496,
            "latitude": 52.827698
        },
        "1429": {
            "name": "Бутрахты",
            "population": 519,
            "type": "village",
            "poly": null,
            "longitude": 89.988907,
            "latitude": 52.812019
        },
        "1430": {
            "name": "Нижняя Тёя",
            "population": 433,
            "type": "village",
            "poly": null,
            "longitude": 90.042847,
            "latitude": 52.931854
        },
        "1431": {
            "name": "Казановка",
            "population": 361,
            "type": "village",
            "poly": null,
            "longitude": 90.048378,
            "latitude": 53.214287
        },
        "1432": {
            "name": "Сафронов",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 90.057327,
            "latitude": 53.045673
        },
        "1433": {
            "name": "Новомарьясово",
            "population": 958,
            "type": "village",
            "poly": null,
            "longitude": 90.121277,
            "latitude": 55.07449
        },
        "1434": {
            "name": "Колодезный",
            "population": 1419,
            "type": "village",
            "poly": null,
            "longitude": 90.14344,
            "latitude": 54.482887
        },
        "1435": {
            "name": "Жемчужный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 90.156975,
            "latitude": 54.495186
        },
        "1436": {
            "name": "Верхний Аскиз",
            "population": 732,
            "type": "village",
            "poly": null,
            "longitude": 90.17955,
            "latitude": 53.163086
        },
        "1437": {
            "name": "Полтаков",
            "population": 1151,
            "type": "village",
            "poly": null,
            "longitude": 90.18573,
            "latitude": 52.955486
        },
        "1438": {
            "name": "Сонское",
            "population": 740,
            "type": "village",
            "poly": null,
            "longitude": 90.216064,
            "latitude": 54.16127
        },
        "1439": {
            "name": "Усть-Таштып",
            "population": 435,
            "type": "village",
            "poly": null,
            "longitude": 90.244148,
            "latitude": 52.881306
        },
        "1440": {
            "name": "Усть-Бюр",
            "population": 2134,
            "type": "village",
            "poly": null,
            "longitude": 90.246674,
            "latitude": 53.832451
        },
        "1441": {
            "name": "Усть-Есь",
            "population": 969,
            "type": "village",
            "poly": null,
            "longitude": 90.252899,
            "latitude": 52.955238
        },
        "1442": {
            "name": "Большой Монок",
            "population": 570,
            "type": "village",
            "poly": null,
            "longitude": 90.284157,
            "latitude": 52.869522
        },
        "1443": {
            "name": "Арбаты",
            "population": 902,
            "type": "village",
            "poly": null,
            "longitude": 90.287102,
            "latitude": 52.698696
        },
        "1444": {
            "name": "Верхняя База",
            "population": 318,
            "type": "village",
            "poly": null,
            "longitude": 90.294716,
            "latitude": 53.245544
        },
        "1445": {
            "name": "Малые Арбаты",
            "population": 1472,
            "type": "village",
            "poly": null,
            "longitude": 90.316284,
            "latitude": 52.715145
        },
        "1446": {
            "name": "Ербинская",
            "population": null,
            "type": "village",
            "poly": [
                [
                    90.3068932,
                    53.9662276
                ],
                [
                    90.3106734,
                    53.9715029
                ],
                [
                    90.3087029,
                    53.9721415
                ],
                [
                    90.3073758,
                    53.9730877
                ],
                [
                    90.3075367,
                    53.9739392
                ],
                [
                    90.310955,
                    53.9761152
                ],
                [
                    90.3099496,
                    53.9784567
                ],
                [
                    90.3125636,
                    53.979048
                ],
                [
                    90.3139712,
                    53.9805379
                ],
                [
                    90.3162635,
                    53.9805379
                ],
                [
                    90.3177917,
                    53.9827372
                ],
                [
                    90.3243469,
                    53.9809399
                ],
                [
                    90.3266392,
                    53.978504
                ],
                [
                    90.3270815,
                    53.97647
                ],
                [
                    90.3243469,
                    53.9711954
                ],
                [
                    90.3229795,
                    53.9714556
                ],
                [
                    90.3200437,
                    53.9672685
                ],
                [
                    90.3167059,
                    53.9675287
                ],
                [
                    90.3148157,
                    53.9645006
                ],
                [
                    90.3068932,
                    53.9662276
                ]
            ],
            "longitude": 90.3168234,
            "latitude": 53.974978
        },
        "1447": {
            "name": "Нижняя База",
            "population": 300,
            "type": "village",
            "poly": null,
            "longitude": 90.347763,
            "latitude": 53.216244
        },
        "1448": {
            "name": "Борец",
            "population": 1424,
            "type": "village",
            "poly": null,
            "longitude": 90.37207,
            "latitude": 54.464703
        },
        "1449": {
            "name": "Большие Арбаты",
            "population": 205,
            "type": "village",
            "poly": null,
            "longitude": 90.375443,
            "latitude": 52.713818
        },
        "1450": {
            "name": "Чарков",
            "population": 1129,
            "type": "village",
            "poly": null,
            "longitude": 90.3795084,
            "latitude": 53.7023163
        },
        "1451": {
            "name": "Сон",
            "population": 602,
            "type": "village",
            "poly": null,
            "longitude": 90.386726,
            "latitude": 54.388302
        },
        "1452": {
            "name": "Джирим",
            "population": 836,
            "type": "village",
            "poly": null,
            "longitude": 90.388298,
            "latitude": 54.808208
        },
        "1453": {
            "name": "Власьево",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 90.396004,
            "latitude": 54.463825
        },
        "1454": {
            "name": "Бельтирское",
            "population": 4853,
            "type": "village",
            "poly": [
                [
                    90.3733034,
                    53.0349018
                ],
                [
                    90.3738985,
                    53.0363237
                ],
                [
                    90.3899752,
                    53.0413129
                ],
                [
                    90.4042393,
                    53.045739
                ],
                [
                    90.4253476,
                    53.0358488
                ],
                [
                    90.424417,
                    53.0289178
                ],
                [
                    90.4273533,
                    53.0262304
                ],
                [
                    90.427406,
                    53.0235363
                ],
                [
                    90.4262329,
                    53.0223271
                ],
                [
                    90.4183234,
                    53.0172395
                ],
                [
                    90.4135245,
                    53.015298
                ],
                [
                    90.410011,
                    53.0145572
                ],
                [
                    90.4018669,
                    53.0164304
                ],
                [
                    90.4013515,
                    53.0171826
                ],
                [
                    90.399779,
                    53.0178564
                ],
                [
                    90.395999,
                    53.0180068
                ],
                [
                    90.3866187,
                    53.017464
                ],
                [
                    90.3733034,
                    53.0349018
                ]
            ],
            "longitude": 90.399498,
            "latitude": 53.025295
        },
        "1455": {
            "name": "Апчинаев",
            "population": 472,
            "type": "village",
            "poly": [
                [
                    90.4141585,
                    53.0449264
                ],
                [
                    90.4153798,
                    53.0457526
                ],
                [
                    90.4255302,
                    53.0525799
                ],
                [
                    90.4329922,
                    53.0490179
                ],
                [
                    90.4257497,
                    53.0439383
                ],
                [
                    90.4222931,
                    53.0432125
                ],
                [
                    90.4192753,
                    53.0412664
                ],
                [
                    90.4146116,
                    53.0432125
                ],
                [
                    90.4141585,
                    53.0449264
                ]
            ],
            "longitude": 90.425102,
            "latitude": 53.045708
        },
        "1456": {
            "name": "Пушное",
            "population": 616,
            "type": "village",
            "poly": null,
            "longitude": 90.484009,
            "latitude": 54.227364
        },
        "1457": {
            "name": "Бондарево",
            "population": 1586,
            "type": "village",
            "poly": [
                [
                    90.4592955,
                    52.9274797
                ],
                [
                    90.465661,
                    52.9327637
                ],
                [
                    90.4750485,
                    52.9412374
                ],
                [
                    90.4875008,
                    52.9441176
                ],
                [
                    90.5216215,
                    52.9369879
                ],
                [
                    90.5223073,
                    52.9325958
                ],
                [
                    90.5042182,
                    52.9284099
                ],
                [
                    90.5049041,
                    52.9256192
                ],
                [
                    90.5133914,
                    52.9183003
                ],
                [
                    90.518278,
                    52.9133169
                ],
                [
                    90.5142487,
                    52.9065958
                ],
                [
                    90.5079904,
                    52.9053548
                ],
                [
                    90.5046469,
                    52.9133169
                ],
                [
                    90.4905014,
                    52.9213292
                ],
                [
                    90.4768701,
                    52.925154
                ],
                [
                    90.4607529,
                    52.9211225
                ],
                [
                    90.4592955,
                    52.9274797
                ]
            ],
            "longitude": 90.495697,
            "latitude": 52.934788
        },
        "1458": {
            "name": "Ворота",
            "population": 512,
            "type": "village",
            "poly": null,
            "longitude": 90.5195388,
            "latitude": 54.7052482
        },
        "1459": {
            "name": "Луговая",
            "population": 500,
            "type": "village",
            "poly": null,
            "longitude": 90.571342,
            "latitude": 53.15678
        },
        "1460": {
            "name": "Пуланколь",
            "population": 608,
            "type": "village",
            "poly": null,
            "longitude": 90.602264,
            "latitude": 53.390011
        },
        "1461": {
            "name": "Большая Ерба",
            "population": 828,
            "type": "village",
            "poly": null,
            "longitude": 90.6222,
            "latitude": 54.255283
        },
        "1462": {
            "name": "Койбалы",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 90.652451,
            "latitude": 53.161961
        },
        "1463": {
            "name": "Усть-Камышта",
            "population": 1213,
            "type": "village",
            "poly": null,
            "longitude": 90.703941,
            "latitude": 53.35376
        },
        "1464": {
            "name": "Заречная",
            "population": 270,
            "type": "village",
            "poly": null,
            "longitude": 90.7093604,
            "latitude": 54.5844869
        },
        "1465": {
            "name": "Весеннее",
            "population": 725,
            "type": "village",
            "poly": null,
            "longitude": 90.710983,
            "latitude": 53.618706
        },
        "1466": {
            "name": "Катанов",
            "population": 708,
            "type": "village",
            "poly": null,
            "longitude": 90.712387,
            "latitude": 53.238533
        },
        "1467": {
            "name": "Табат",
            "population": 1534,
            "type": "village",
            "poly": null,
            "longitude": 90.718742,
            "latitude": 52.948189
        },
        "1468": {
            "name": "Сарагаш",
            "population": 901,
            "type": "village",
            "poly": null,
            "longitude": 90.74099,
            "latitude": 54.771664
        },
        "1469": {
            "name": "Куйбышево",
            "population": 669,
            "type": "village",
            "poly": null,
            "longitude": 90.777634,
            "latitude": 53.195202
        },
        "1470": {
            "name": "Первомайское",
            "population": 1466,
            "type": "village",
            "poly": null,
            "longitude": 90.7833781,
            "latitude": 54.583716
        },
        "1471": {
            "name": "Буденовка",
            "population": 462,
            "type": "village",
            "poly": null,
            "longitude": 90.828674,
            "latitude": 52.991718
        },
        "1472": {
            "name": "Шалгинов",
            "population": 245,
            "type": "village",
            "poly": null,
            "longitude": 90.941658,
            "latitude": 53.348732
        },
        "1473": {
            "name": "Вершино-Биджа",
            "population": 1088,
            "type": "village",
            "poly": null,
            "longitude": 90.966454,
            "latitude": 53.980663
        },
        "1474": {
            "name": "Знаменка",
            "population": 1448,
            "type": "village",
            "poly": null,
            "longitude": 90.983704,
            "latitude": 54.363499
        },
        "1475": {
            "name": "Доможаков",
            "population": 1069,
            "type": "village",
            "poly": null,
            "longitude": 91.033585,
            "latitude": 53.441132
        },
        "1476": {
            "name": "Новотроицкое",
            "population": 807,
            "type": "village",
            "poly": null,
            "longitude": 91.050529,
            "latitude": 53.151272
        },
        "1477": {
            "name": "Аршаново",
            "population": 1506,
            "type": "village",
            "poly": null,
            "longitude": 91.064278,
            "latitude": 53.411091
        },
        "1478": {
            "name": "Толчея",
            "population": 311,
            "type": "village",
            "poly": null,
            "longitude": 91.077179,
            "latitude": 54.05938
        },
        "1479": {
            "name": "Троицкое",
            "population": 616,
            "type": "village",
            "poly": null,
            "longitude": 91.091789,
            "latitude": 54.280178
        },
        "1480": {
            "name": "Московское",
            "population": 1113,
            "type": "village",
            "poly": null,
            "longitude": 91.110077,
            "latitude": 53.929935
        },
        "1481": {
            "name": "Курганная",
            "population": 338,
            "type": "village",
            "poly": [
                [
                    91.113408,
                    53.7918518
                ],
                [
                    91.1150299,
                    53.7924275
                ],
                [
                    91.1210031,
                    53.7941687
                ],
                [
                    91.1246447,
                    53.7945372
                ],
                [
                    91.1246603,
                    53.7938969
                ],
                [
                    91.1260986,
                    53.7940256
                ],
                [
                    91.1259156,
                    53.7896
                ],
                [
                    91.1238259,
                    53.7890932
                ],
                [
                    91.1213618,
                    53.7886234
                ],
                [
                    91.1202155,
                    53.7889358
                ],
                [
                    91.1193109,
                    53.7893596
                ],
                [
                    91.1150143,
                    53.7891201
                ],
                [
                    91.1144529,
                    53.7907646
                ],
                [
                    91.113408,
                    53.7918518
                ]
            ],
            "longitude": 91.1226957,
            "latitude": 53.790793
        },
        "1482": {
            "name": "Бородино",
            "population": 1222,
            "type": "village",
            "poly": null,
            "longitude": 91.129494,
            "latitude": 54.098881
        },
        "1483": {
            "name": "Райков",
            "population": 1554,
            "type": "village",
            "poly": null,
            "longitude": 91.175919,
            "latitude": 53.52449
        },
        "1484": {
            "name": "Сабинка",
            "population": 902,
            "type": "village",
            "poly": null,
            "longitude": 91.182098,
            "latitude": 53.09034
        },
        "1485": {
            "name": "Солнечное",
            "population": 1112,
            "type": "village",
            "poly": null,
            "longitude": 91.182915,
            "latitude": 53.688675
        },
        "1486": {
            "name": "Сартыков",
            "population": 274,
            "type": "village",
            "poly": null,
            "longitude": 91.183556,
            "latitude": 53.471912
        },
        "1487": {
            "name": "Красноозёрное",
            "population": 600,
            "type": "village",
            "poly": null,
            "longitude": 91.2148749,
            "latitude": 53.6493356
        },
        "1488": {
            "name": "Кирба",
            "population": 1458,
            "type": "village",
            "poly": null,
            "longitude": 91.221893,
            "latitude": 53.281242
        },
        "1489": {
            "name": "Новокурск",
            "population": 1168,
            "type": "village",
            "poly": null,
            "longitude": 91.259888,
            "latitude": 53.109344
        },
        "1490": {
            "name": "Пригорск",
            "population": 2434,
            "type": "village",
            "poly": null,
            "longitude": 91.263443,
            "latitude": 53.90966
        },
        "1491": {
            "name": "Богословка",
            "population": 200,
            "type": "village",
            "poly": null,
            "longitude": 91.272728,
            "latitude": 52.9762
        },
        "1492": {
            "name": "Калы",
            "population": 674,
            "type": "village",
            "poly": null,
            "longitude": 91.28344,
            "latitude": 53.074226
        },
        "1493": {
            "name": "Сапогов",
            "population": 1289,
            "type": "village",
            "poly": null,
            "longitude": 91.285347,
            "latitude": 53.620724
        },
        "1494": {
            "name": "Изыхские Копи",
            "population": 1580,
            "type": "village",
            "poly": null,
            "longitude": 91.28968,
            "latitude": 53.550091
        },
        "1495": {
            "name": "Ташеба",
            "population": 944,
            "type": "village",
            "poly": null,
            "longitude": 91.297379,
            "latitude": 53.675846
        },
        "1496": {
            "name": "Новониколаевка",
            "population": 535,
            "type": "village",
            "poly": null,
            "longitude": 91.298203,
            "latitude": 53.191898
        },
        "1497": {
            "name": "Зелёное",
            "population": 1499,
            "type": "village",
            "poly": null,
            "longitude": 91.313568,
            "latitude": 53.774803
        },
        "1498": {
            "name": "Тепличный",
            "population": 1601,
            "type": "village",
            "poly": null,
            "longitude": 91.332916,
            "latitude": 53.786877
        },
        "1499": {
            "name": "Чапаево",
            "population": 1623,
            "type": "village",
            "poly": [
                [
                    91.3117908,
                    53.6493345
                ],
                [
                    91.3132235,
                    53.6515553
                ],
                [
                    91.3189172,
                    53.6514464
                ],
                [
                    91.3240967,
                    53.6499876
                ],
                [
                    91.3278435,
                    53.6494651
                ],
                [
                    91.3314067,
                    53.6496611
                ],
                [
                    91.3348412,
                    53.6520016
                ],
                [
                    91.3366229,
                    53.6531772
                ],
                [
                    91.3390137,
                    53.6555956
                ],
                [
                    91.3384626,
                    53.6570215
                ],
                [
                    91.3366811,
                    53.6587087
                ],
                [
                    91.3385546,
                    53.6594379
                ],
                [
                    91.3417504,
                    53.6591005
                ],
                [
                    91.3451666,
                    53.6589808
                ],
                [
                    91.3482155,
                    53.6589917
                ],
                [
                    91.3498318,
                    53.6589264
                ],
                [
                    91.351595,
                    53.6597427
                ],
                [
                    91.3542215,
                    53.6589917
                ],
                [
                    91.3545019,
                    53.6551
                ],
                [
                    91.3532515,
                    53.6527109
                ],
                [
                    91.349891,
                    53.6511911
                ],
                [
                    91.3466776,
                    53.6496136
                ],
                [
                    91.3412778,
                    53.6486773
                ],
                [
                    91.335731,
                    53.6482637
                ],
                [
                    91.3304148,
                    53.6458071
                ],
                [
                    91.3238395,
                    53.6453498
                ],
                [
                    91.316052,
                    53.6468958
                ],
                [
                    91.3117908,
                    53.6493345
                ]
            ],
            "longitude": 91.344978,
            "latitude": 53.654575
        },
        "1500": {
            "name": "Расцвет",
            "population": 1400,
            "type": "village",
            "poly": null,
            "longitude": 91.3531147,
            "latitude": 53.7861168
        },
        "1501": {
            "name": "Краснополье",
            "population": 658,
            "type": "village",
            "poly": null,
            "longitude": 91.369179,
            "latitude": 53.428658
        },
        "1502": {
            "name": "Калинино",
            "population": 3718,
            "type": "village",
            "poly": [
                [
                    [
                        91.3763804,
                        53.7717695
                    ],
                    [
                        91.3870621,
                        53.7727993
                    ],
                    [
                        91.3889178,
                        53.7722242
                    ],
                    [
                        91.3906151,
                        53.7714752
                    ],
                    [
                        91.3997806,
                        53.7679574
                    ],
                    [
                        91.4055741,
                        53.7629545
                    ],
                    [
                        91.4066151,
                        53.761202
                    ],
                    [
                        91.4070677,
                        53.7579242
                    ],
                    [
                        91.4069948,
                        53.7559756
                    ],
                    [
                        91.4065472,
                        53.7527461
                    ],
                    [
                        91.4059237,
                        53.7517113
                    ],
                    [
                        91.4045727,
                        53.7509738
                    ],
                    [
                        91.4016051,
                        53.7518033
                    ],
                    [
                        91.3998485,
                        53.7525989
                    ],
                    [
                        91.396816,
                        53.7567334
                    ],
                    [
                        91.3952318,
                        53.7590079
                    ],
                    [
                        91.3916335,
                        53.7587136
                    ],
                    [
                        91.3915883,
                        53.7629144
                    ],
                    [
                        91.3769688,
                        53.7621384
                    ],
                    [
                        91.3763804,
                        53.7717695
                    ]
                ],
                [
                    [
                        91.3799814,
                        53.7304057
                    ],
                    [
                        91.3850193,
                        53.7370063
                    ],
                    [
                        91.3890476,
                        53.7415816
                    ],
                    [
                        91.3916629,
                        53.7410747
                    ],
                    [
                        91.3928124,
                        53.7410718
                    ],
                    [
                        91.3953826,
                        53.7431629
                    ],
                    [
                        91.3955558,
                        53.7434171
                    ],
                    [
                        91.3962226,
                        53.7443962
                    ],
                    [
                        91.3963494,
                        53.7444897
                    ],
                    [
                        91.3973721,
                        53.7447594
                    ],
                    [
                        91.3981945,
                        53.7448833
                    ],
                    [
                        91.3989191,
                        53.7450724
                    ],
                    [
                        91.3995316,
                        53.7454436
                    ],
                    [
                        91.4024666,
                        53.7466166
                    ],
                    [
                        91.4025033,
                        53.7466339
                    ],
                    [
                        91.4027656,
                        53.7464548
                    ],
                    [
                        91.4019677,
                        53.7458449
                    ],
                    [
                        91.4011841,
                        53.7453395
                    ],
                    [
                        91.4001858,
                        53.7445378
                    ],
                    [
                        91.3991865,
                        53.7435652
                    ],
                    [
                        91.3985718,
                        53.742804
                    ],
                    [
                        91.3980637,
                        53.742058
                    ],
                    [
                        91.3973864,
                        53.7408353
                    ],
                    [
                        91.3974221,
                        53.7399182
                    ],
                    [
                        91.3921895,
                        53.7343949
                    ],
                    [
                        91.3894608,
                        53.7331105
                    ],
                    [
                        91.3845018,
                        53.7311094
                    ],
                    [
                        91.3809332,
                        53.7301705
                    ],
                    [
                        91.3799814,
                        53.7304057
                    ]
                ]
            ],
            "longitude": 91.402077,
            "latitude": 53.755917
        },
        "1503": {
            "name": "Советская Хакасия",
            "population": 817,
            "type": "village",
            "poly": null,
            "longitude": 91.433891,
            "latitude": 54.112991
        },
        "1504": {
            "name": "Кайбалы",
            "population": 964,
            "type": "village",
            "poly": [
                [
                    91.4623984,
                    53.6532243
                ],
                [
                    91.4632208,
                    53.6535536
                ],
                [
                    91.4640727,
                    53.6537292
                ],
                [
                    91.464258,
                    53.654199
                ],
                [
                    91.4644579,
                    53.654941
                ],
                [
                    91.4644654,
                    53.6555908
                ],
                [
                    91.4640802,
                    53.6564338
                ],
                [
                    91.4636431,
                    53.6572942
                ],
                [
                    91.4634504,
                    53.6578475
                ],
                [
                    91.4640579,
                    53.6583173
                ],
                [
                    91.4647025,
                    53.65855
                ],
                [
                    91.4652137,
                    53.6590768
                ],
                [
                    91.466036,
                    53.6597046
                ],
                [
                    91.4670732,
                    53.6602621
                ],
                [
                    91.4687475,
                    53.6604245
                ],
                [
                    91.4716516,
                    53.6605562
                ],
                [
                    91.4727925,
                    53.6608987
                ],
                [
                    91.4747558,
                    53.6618074
                ],
                [
                    91.4753929,
                    53.6623517
                ],
                [
                    91.4758819,
                    53.662839
                ],
                [
                    91.4762893,
                    53.6637125
                ],
                [
                    91.4767412,
                    53.6643315
                ],
                [
                    91.4771783,
                    53.6648582
                ],
                [
                    91.4787712,
                    53.6663945
                ],
                [
                    91.4800899,
                    53.6670661
                ],
                [
                    91.4838015,
                    53.666873
                ],
                [
                    91.4851424,
                    53.6666667
                ],
                [
                    91.488217,
                    53.6657098
                ],
                [
                    91.4894764,
                    53.6643973
                ],
                [
                    91.4851943,
                    53.6622946
                ],
                [
                    91.4813271,
                    53.6602972
                ],
                [
                    91.4782007,
                    53.6586817
                ],
                [
                    91.4770005,
                    53.6576017
                ],
                [
                    91.4754744,
                    53.6559596
                ],
                [
                    91.4738742,
                    53.6542912
                ],
                [
                    91.4711182,
                    53.6538126
                ],
                [
                    91.4674881,
                    53.6525875
                ],
                [
                    91.4669991,
                    53.6524954
                ],
                [
                    91.4658804,
                    53.6523944
                ],
                [
                    91.4642283,
                    53.6525437
                ],
                [
                    91.4628578,
                    53.6529872
                ],
                [
                    91.4623984,
                    53.6532243
                ]
            ],
            "longitude": 91.471825,
            "latitude": 53.657898
        },
        "1505": {
            "name": "Новоенисейка",
            "population": 1071,
            "type": "village",
            "poly": null,
            "longitude": 91.507805,
            "latitude": 53.163784
        },
        "1506": {
            "name": "Подсинее",
            "population": 3549,
            "type": "village",
            "poly": null,
            "longitude": 91.545029,
            "latitude": 53.664356
        },
        "1507": {
            "name": "Лукьяновка",
            "population": 397,
            "type": "village",
            "poly": null,
            "longitude": 91.557571,
            "latitude": 53.413704
        },
        "1508": {
            "name": "Новомихайловка",
            "population": 1011,
            "type": "village",
            "poly": null,
            "longitude": 91.566116,
            "latitude": 53.254532
        },
        "1509": {
            "name": "Новороссийское",
            "population": 980,
            "type": "village",
            "poly": [
                [
                    91.5866628,
                    53.3810659
                ],
                [
                    91.610953,
                    53.3863901
                ],
                [
                    91.6102663,
                    53.3741537
                ],
                [
                    91.5906969,
                    53.3709277
                ],
                [
                    91.5866628,
                    53.3810659
                ]
            ],
            "longitude": 91.59906,
            "latitude": 53.378452
        },
        "1510": {
            "name": "Летник",
            "population": 391,
            "type": "village",
            "poly": [
                [
                    91.6330973,
                    53.507131
                ],
                [
                    91.6421095,
                    53.5116737
                ],
                [
                    91.643912,
                    53.5100916
                ],
                [
                    91.6500059,
                    53.5125924
                ],
                [
                    91.6551558,
                    53.5088155
                ],
                [
                    91.6402212,
                    53.5027409
                ],
                [
                    91.6330973,
                    53.507131
                ]
            ],
            "longitude": 91.64135,
            "latitude": 53.507832
        },
        "1511": {
            "name": "Очуры",
            "population": 1997,
            "type": "village",
            "poly": null,
            "longitude": 91.650909,
            "latitude": 53.167343
        },
        "1512": {
            "name": "Алтай",
            "population": 300,
            "type": "village",
            "poly": null,
            "longitude": 91.808655,
            "latitude": 53.43866
        },
        "1513": {
            "name": "Кирово",
            "population": 1263,
            "type": "village",
            "poly": null,
            "longitude": 91.886078,
            "latitude": 53.342438
        },
        "1514": {
            "name": "Усть-Урлук",
            "population": 170,
            "type": "village",
            "poly": null,
            "longitude": 107.804169,
            "latitude": 49.945618
        },
        "1515": {
            "name": "Урлук",
            "population": 1485,
            "type": "village",
            "poly": null,
            "longitude": 107.88958,
            "latitude": 50.055202
        },
        "1516": {
            "name": "Жиндо 1-е",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 107.9845129,
            "latitude": 49.9451718
        },
        "1517": {
            "name": "Жиндокон",
            "population": 238,
            "type": "village",
            "poly": null,
            "longitude": 108.0552203,
            "latitude": 50.0745482
        },
        "1518": {
            "name": "Конкино",
            "population": 308,
            "type": "village",
            "poly": null,
            "longitude": 108.0733486,
            "latitude": 49.8057128
        },
        "1519": {
            "name": "Хилкотой",
            "population": 91,
            "type": "village",
            "poly": null,
            "longitude": 108.076218,
            "latitude": 49.921173
        },
        "1520": {
            "name": "Пески",
            "population": 548,
            "type": "village",
            "poly": null,
            "longitude": 108.1211071,
            "latitude": 50.770521
        },
        "1521": {
            "name": "Новая Зардама",
            "population": 112,
            "type": "village",
            "poly": null,
            "longitude": 108.1670701,
            "latitude": 50.7923287
        },
        "1522": {
            "name": "Старая Зардама",
            "population": 2,
            "type": "village",
            "poly": null,
            "longitude": 108.1805495,
            "latitude": 50.7537695
        },
        "1523": {
            "name": "Гутай",
            "population": 104,
            "type": "village",
            "poly": null,
            "longitude": 108.1968883,
            "latitude": 49.996642
        },
        "1524": {
            "name": "Альбитуй",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 108.22593,
            "latitude": 50.14068
        },
        "1525": {
            "name": "Нижний Нарым",
            "population": 163,
            "type": "village",
            "poly": null,
            "longitude": 108.23655,
            "latitude": 50.08754
        },
        "1526": {
            "name": "Бурсомон",
            "population": 191,
            "type": "village",
            "poly": null,
            "longitude": 108.258736,
            "latitude": 50.180317
        },
        "1527": {
            "name": "Красная Долина",
            "population": 169,
            "type": "village",
            "poly": null,
            "longitude": 108.2649915,
            "latitude": 50.8211829
        },
        "1528": {
            "name": "Новоникольское",
            "population": 4,
            "type": "village",
            "poly": null,
            "longitude": 108.30989,
            "latitude": 50.8439
        },
        "1529": {
            "name": "Верхний Шергольджин",
            "population": 365,
            "type": "village",
            "poly": null,
            "longitude": 108.323357,
            "latitude": 50.194931
        },
        "1530": {
            "name": "Сохотой",
            "population": 110,
            "type": "village",
            "poly": null,
            "longitude": 108.3511372,
            "latitude": 50.812179
        },
        "1531": {
            "name": "Котый",
            "population": 84,
            "type": "village",
            "poly": null,
            "longitude": 108.3782078,
            "latitude": 50.12032
        },
        "1532": {
            "name": "Малета",
            "population": 2976,
            "type": "village",
            "poly": null,
            "longitude": 108.424332,
            "latitude": 50.837921
        },
        "1533": {
            "name": "Маргинтуй",
            "population": 2,
            "type": "village",
            "poly": null,
            "longitude": 108.46417,
            "latitude": 50.14155
        },
        "1534": {
            "name": "Прииск Большая Речка",
            "population": 736,
            "type": "village",
            "poly": null,
            "longitude": 108.4682,
            "latitude": 50.1328
        },
        "1535": {
            "name": "Этытэй",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 108.47483,
            "latitude": 50.29798
        },
        "1536": {
            "name": "Харауз",
            "population": 876,
            "type": "village",
            "poly": null,
            "longitude": 108.4757664,
            "latitude": 51.2487743
        },
        "1537": {
            "name": "Алентуй",
            "population": 117,
            "type": "village",
            "poly": null,
            "longitude": 108.4764545,
            "latitude": 50.8827262
        },
        "1538": {
            "name": "Обор",
            "population": 186,
            "type": "village",
            "poly": null,
            "longitude": 108.548419,
            "latitude": 50.9679647
        },
        "1539": {
            "name": "Мостовка",
            "population": 87,
            "type": "village",
            "poly": null,
            "longitude": 108.5523609,
            "latitude": 50.3126284
        },
        "1540": {
            "name": "Усть-Обор",
            "population": 919,
            "type": "village",
            "poly": null,
            "longitude": 108.574211,
            "latitude": 50.930923
        },
        "1541": {
            "name": "Байхор",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 108.5850019,
            "latitude": 50.2961383
        },
        "1542": {
            "name": "Гремяча",
            "population": 33,
            "type": "village",
            "poly": null,
            "longitude": 108.632689,
            "latitude": 50.3273861
        },
        "1543": {
            "name": "Катаево",
            "population": 659,
            "type": "village",
            "poly": null,
            "longitude": 108.661354,
            "latitude": 50.947624
        },
        "1544": {
            "name": "Кандобаево",
            "population": 18,
            "type": "village",
            "poly": null,
            "longitude": 108.7111822,
            "latitude": 50.963981
        },
        "1545": {
            "name": "Архангельское",
            "population": 652,
            "type": "village",
            "poly": null,
            "longitude": 108.7488141,
            "latitude": 50.3233406
        },
        "1546": {
            "name": "Красный Чикой",
            "population": 7254,
            "type": "village",
            "poly": null,
            "longitude": 108.75798,
            "latitude": 50.364742
        },
        "1547": {
            "name": "Орсук",
            "population": 213,
            "type": "village",
            "poly": null,
            "longitude": 108.8116228,
            "latitude": 50.9581175
        },
        "1548": {
            "name": "Александровка",
            "population": 137,
            "type": "village",
            "poly": null,
            "longitude": 108.8173522,
            "latitude": 50.3448844
        },
        "1549": {
            "name": "Малоархангельск",
            "population": 1025,
            "type": "village",
            "poly": null,
            "longitude": 108.833371,
            "latitude": 50.3955588
        },
        "1550": {
            "name": "Менза",
            "population": 367,
            "type": "village",
            "poly": null,
            "longitude": 108.854622,
            "latitude": 49.430981
        },
        "1551": {
            "name": "Укыр",
            "population": 307,
            "type": "village",
            "poly": null,
            "longitude": 108.8777873,
            "latitude": 49.4647198
        },
        "1552": {
            "name": "Барахоево",
            "population": 554,
            "type": "village",
            "poly": null,
            "longitude": 108.9114416,
            "latitude": 50.426639
        },
        "1553": {
            "name": "Катангар",
            "population": 158,
            "type": "village",
            "poly": [
                [
                    108.9491953,
                    51.0094951
                ],
                [
                    108.9495528,
                    51.0106656
                ],
                [
                    108.9518686,
                    51.0126327
                ],
                [
                    108.9556604,
                    51.0120345
                ],
                [
                    108.9572362,
                    51.0131115
                ],
                [
                    108.9602561,
                    51.0138071
                ],
                [
                    108.968452,
                    51.0150279
                ],
                [
                    108.969946,
                    51.0131826
                ],
                [
                    108.9642979,
                    51.0113246
                ],
                [
                    108.9603301,
                    51.0107126
                ],
                [
                    108.9588397,
                    51.0085267
                ],
                [
                    108.95747,
                    51.007951
                ],
                [
                    108.9553068,
                    51.0093829
                ],
                [
                    108.9548029,
                    51.0097183
                ],
                [
                    108.9521425,
                    51.0087564
                ],
                [
                    108.9491953,
                    51.0094951
                ]
            ],
            "longitude": 108.960846,
            "latitude": 51.012379
        },
        "1554": {
            "name": "Коротково",
            "population": 547,
            "type": "village",
            "poly": null,
            "longitude": 108.9707397,
            "latitude": 50.4450789
        },
        "1555": {
            "name": "Баляга-Катангар",
            "population": 78,
            "type": "village",
            "poly": null,
            "longitude": 108.9755419,
            "latitude": 51.1100929
        },
        "1556": {
            "name": "Шонуй",
            "population": 94,
            "type": "village",
            "poly": null,
            "longitude": 108.9789131,
            "latitude": 49.6451393
        },
        "1557": {
            "name": "Быково",
            "population": 119,
            "type": "village",
            "poly": null,
            "longitude": 109.0152903,
            "latitude": 50.4188624
        },
        "1558": {
            "name": "Большаково",
            "population": 129,
            "type": "village",
            "poly": null,
            "longitude": 109.0270658,
            "latitude": 50.4511982
        },
        "1559": {
            "name": "Кули",
            "population": 263,
            "type": "village",
            "poly": [
                [
                    109.0324842,
                    51.1350027
                ],
                [
                    109.0345206,
                    51.1359713
                ],
                [
                    109.0366226,
                    51.1343844
                ],
                [
                    109.0399071,
                    51.1358064
                ],
                [
                    109.0369839,
                    51.1378673
                ],
                [
                    109.0409253,
                    51.1393305
                ],
                [
                    109.0431916,
                    51.1375376
                ],
                [
                    109.0445382,
                    51.1383001
                ],
                [
                    109.0446696,
                    51.1405876
                ],
                [
                    109.0559026,
                    51.1352912
                ],
                [
                    109.0529465,
                    51.1332714
                ],
                [
                    109.0478884,
                    51.1327149
                ],
                [
                    109.0399071,
                    51.1297057
                ],
                [
                    109.0324842,
                    51.1350027
                ]
            ],
            "longitude": 109.0450563,
            "latitude": 51.1348311
        },
        "1560": {
            "name": "Красные Речки",
            "population": 132,
            "type": "village",
            "poly": null,
            "longitude": 109.1024435,
            "latitude": 50.464158
        },
        "1561": {
            "name": "Зугмара",
            "population": 285,
            "type": "village",
            "poly": [
                [
                    109.2031814,
                    51.1829851
                ],
                [
                    109.2067512,
                    51.1861042
                ],
                [
                    109.2091502,
                    51.1861004
                ],
                [
                    109.2144455,
                    51.1879055
                ],
                [
                    109.2232012,
                    51.1899434
                ],
                [
                    109.2269172,
                    51.1883422
                ],
                [
                    109.2276604,
                    51.184339
                ],
                [
                    109.2206233,
                    51.1817476
                ],
                [
                    109.2168608,
                    51.1815001
                ],
                [
                    109.2147009,
                    51.1837275
                ],
                [
                    109.2031814,
                    51.1829851
                ]
            ],
            "longitude": 109.217911,
            "latitude": 51.18541
        },
        "1562": {
            "name": "Фомичёво",
            "population": 374,
            "type": "village",
            "poly": null,
            "longitude": 109.265047,
            "latitude": 50.509118
        },
        "1563": {
            "name": "Толбага",
            "population": 559,
            "type": "village",
            "poly": null,
            "longitude": 109.328285,
            "latitude": 51.205585
        },
        "1564": {
            "name": "Захарово",
            "population": 744,
            "type": "village",
            "poly": null,
            "longitude": 109.3804336,
            "latitude": 50.5359725
        },
        "1565": {
            "name": "Осиновка",
            "population": 201,
            "type": "village",
            "poly": null,
            "longitude": 109.4598393,
            "latitude": 50.557375
        },
        "1566": {
            "name": "Аца",
            "population": 183,
            "type": "village",
            "poly": null,
            "longitude": 109.5521042,
            "latitude": 50.4872286
        },
        "1567": {
            "name": "Хохотуй",
            "population": 1633,
            "type": "village",
            "poly": [
                [
                    109.5503692,
                    51.2790155
                ],
                [
                    109.5587014,
                    51.2808127
                ],
                [
                    109.5524394,
                    51.292003
                ],
                [
                    109.5579988,
                    51.2959885
                ],
                [
                    109.571237,
                    51.2890462
                ],
                [
                    109.5835108,
                    51.2968447
                ],
                [
                    109.5895944,
                    51.2916415
                ],
                [
                    109.5860545,
                    51.2866641
                ],
                [
                    109.5816882,
                    51.2884362
                ],
                [
                    109.5737736,
                    51.2818406
                ],
                [
                    109.5776457,
                    51.2798581
                ],
                [
                    109.5719516,
                    51.2795811
                ],
                [
                    109.5740865,
                    51.277732
                ],
                [
                    109.5731012,
                    51.2765815
                ],
                [
                    109.5676161,
                    51.2783484
                ],
                [
                    109.5657977,
                    51.2762953
                ],
                [
                    109.5551654,
                    51.2764081
                ],
                [
                    109.5503692,
                    51.2790155
                ]
            ],
            "longitude": 109.563087,
            "latitude": 51.283916
        },
        "1568": {
            "name": "Шимбилик",
            "population": 677,
            "type": "village",
            "poly": null,
            "longitude": 109.5757564,
            "latitude": 50.5641659
        },
        "1569": {
            "name": "Ушоты",
            "population": 176,
            "type": "village",
            "poly": null,
            "longitude": 109.64566,
            "latitude": 51.315639
        },
        "1570": {
            "name": "Закульта",
            "population": 460,
            "type": "village",
            "poly": null,
            "longitude": 109.739746,
            "latitude": 51.359848
        },
        "1571": {
            "name": "Шэлэ",
            "population": 160,
            "type": "village",
            "poly": [
                [
                    109.7855442,
                    51.3808423
                ],
                [
                    109.7861448,
                    51.3823182
                ],
                [
                    109.7889324,
                    51.3827144
                ],
                [
                    109.7939374,
                    51.383899
                ],
                [
                    109.7973334,
                    51.3823867
                ],
                [
                    109.799614,
                    51.378882
                ],
                [
                    109.8020887,
                    51.377836
                ],
                [
                    109.7919754,
                    51.3759877
                ],
                [
                    109.7886927,
                    51.3773515
                ],
                [
                    109.7855442,
                    51.3808423
                ]
            ],
            "longitude": 109.7876555,
            "latitude": 51.3810411
        },
        "1572": {
            "name": "Бада",
            "population": 5444,
            "type": "village",
            "poly": [
                [
                    109.8251644,
                    51.3797536
                ],
                [
                    109.8270866,
                    51.3844774
                ],
                [
                    109.838979,
                    51.3914957
                ],
                [
                    109.8502776,
                    51.3937091
                ],
                [
                    109.8696211,
                    51.3967967
                ],
                [
                    109.8723786,
                    51.4035176
                ],
                [
                    109.881973,
                    51.4038526
                ],
                [
                    109.8897769,
                    51.3948217
                ],
                [
                    109.9082118,
                    51.3948272
                ],
                [
                    109.9100839,
                    51.3923679
                ],
                [
                    109.8968868,
                    51.3879262
                ],
                [
                    109.8559197,
                    51.3801285
                ],
                [
                    109.8303303,
                    51.3739794
                ],
                [
                    109.8251644,
                    51.3797536
                ]
            ],
            "longitude": 109.86763,
            "latitude": 51.391209
        },
        "1573": {
            "name": "Тэрэпхэн",
            "population": 197,
            "type": "village",
            "poly": null,
            "longitude": 109.8975475,
            "latitude": 51.3542528
        },
        "1574": {
            "name": "Зурун",
            "population": 292,
            "type": "village",
            "poly": [
                [
                    109.9517545,
                    51.4014083
                ],
                [
                    109.9630894,
                    51.4047477
                ],
                [
                    109.9631427,
                    51.4075628
                ],
                [
                    109.9670556,
                    51.4078269
                ],
                [
                    109.9684965,
                    51.4043511
                ],
                [
                    109.9734576,
                    51.4043504
                ],
                [
                    109.9754157,
                    51.4043642
                ],
                [
                    109.9812151,
                    51.4018759
                ],
                [
                    109.9809968,
                    51.3992081
                ],
                [
                    109.9788316,
                    51.3990572
                ],
                [
                    109.973872,
                    51.3991186
                ],
                [
                    109.9720945,
                    51.4002138
                ],
                [
                    109.9628469,
                    51.4007511
                ],
                [
                    109.9544375,
                    51.3987516
                ],
                [
                    109.9517545,
                    51.4014083
                ]
            ],
            "longitude": 109.9706328,
            "latitude": 51.4023705
        },
        "1575": {
            "name": "Большая Речка",
            "population": 5,
            "type": "village",
            "poly": null,
            "longitude": 109.9828414,
            "latitude": 50.5767766
        },
        "1576": {
            "name": "Глинка",
            "population": 371,
            "type": "village",
            "poly": null,
            "longitude": 110.04628,
            "latitude": 51.426929
        },
        "1577": {
            "name": "Зашулан",
            "population": 0,
            "type": "village",
            "poly": null,
            "longitude": 110.0681673,
            "latitude": 50.5365396
        },
        "1578": {
            "name": "Афонькино",
            "population": 255,
            "type": "village",
            "poly": null,
            "longitude": 110.1138075,
            "latitude": 50.5726553
        },
        "1579": {
            "name": "Черемхово",
            "population": 712,
            "type": "village",
            "poly": null,
            "longitude": 110.158401,
            "latitude": 50.580055
        },
        "1580": {
            "name": "Жипхеген",
            "population": 1328,
            "type": "village",
            "poly": null,
            "longitude": 110.1650237,
            "latitude": 51.4596241
        },
        "1581": {
            "name": "Стеклозавод",
            "population": 58,
            "type": "village",
            "poly": null,
            "longitude": 110.2512967,
            "latitude": 50.583641
        },
        "1582": {
            "name": "Ямаровка",
            "population": 108,
            "type": "village",
            "poly": null,
            "longitude": 110.251656,
            "latitude": 50.61385
        },
        "1583": {
            "name": "Усть-Ямаровка",
            "population": 67,
            "type": "village",
            "poly": null,
            "longitude": 110.2688187,
            "latitude": 50.5859999
        },
        "1584": {
            "name": "Сосновка",
            "population": 9,
            "type": "village",
            "poly": null,
            "longitude": 110.3069408,
            "latitude": 51.4291403
        },
        "1585": {
            "name": "Ядрихино",
            "population": 149,
            "type": "village",
            "poly": null,
            "longitude": 110.3426747,
            "latitude": 50.6036067
        },
        "1586": {
            "name": "Энгорок",
            "population": 176,
            "type": "village",
            "poly": null,
            "longitude": 110.350311,
            "latitude": 50.9783626
        },
        "1587": {
            "name": "Семиозёрье",
            "population": 28,
            "type": "village",
            "poly": null,
            "longitude": 110.4476231,
            "latitude": 49.8204395
        },
        "1588": {
            "name": "Жилкин Хутор",
            "population": 13,
            "type": "village",
            "poly": null,
            "longitude": 110.5419704,
            "latitude": 51.3723678
        },
        "1589": {
            "name": "Хилогосон",
            "population": 228,
            "type": "village",
            "poly": null,
            "longitude": 110.6386059,
            "latitude": 51.1525481
        },
        "1590": {
            "name": "Линёво Озеро",
            "population": 1828,
            "type": "village",
            "poly": [
                [
                    110.6310841,
                    51.3630552
                ],
                [
                    110.6421034,
                    51.37155
                ],
                [
                    110.6483317,
                    51.3710715
                ],
                [
                    110.6542726,
                    51.3692171
                ],
                [
                    110.6583928,
                    51.3693367
                ],
                [
                    110.6723826,
                    51.360303
                ],
                [
                    110.6698913,
                    51.3536611
                ],
                [
                    110.6597343,
                    51.3541997
                ],
                [
                    110.641241,
                    51.3586875
                ],
                [
                    110.6315632,
                    51.3597046
                ],
                [
                    110.6310841,
                    51.3630552
                ]
            ],
            "longitude": 110.6540103,
            "latitude": 51.3628117
        },
        "1591": {
            "name": "Гыршелун",
            "population": 902,
            "type": "village",
            "poly": null,
            "longitude": 110.66243,
            "latitude": 51.399441
        },
        "1592": {
            "name": "Улястуй",
            "population": 34,
            "type": "village",
            "poly": [
                [
                    110.6810707,
                    51.212265
                ],
                [
                    110.6816239,
                    51.2143225
                ],
                [
                    110.6834562,
                    51.2157194
                ],
                [
                    110.686879,
                    51.2155786
                ],
                [
                    110.6888842,
                    51.2138136
                ],
                [
                    110.6923589,
                    51.2130555
                ],
                [
                    110.6930849,
                    51.2123084
                ],
                [
                    110.689835,
                    51.2099043
                ],
                [
                    110.68477,
                    51.2104457
                ],
                [
                    110.6810707,
                    51.212265
                ]
            ],
            "longitude": 110.6879335,
            "latitude": 51.2133523
        },
        "1593": {
            "name": "Алентуйка",
            "population": 173,
            "type": "village",
            "poly": null,
            "longitude": 110.8036594,
            "latitude": 51.4125764
        },
        "1594": {
            "name": "Хушенга",
            "population": 1817,
            "type": "village",
            "poly": null,
            "longitude": 110.921417,
            "latitude": 51.43705
        },
        "1595": {
            "name": "Дайгур",
            "population": 98,
            "type": "village",
            "poly": null,
            "longitude": 111.0564186,
            "latitude": 51.4855001
        },
        "1596": {
            "name": "Харагун",
            "population": 2924,
            "type": "village",
            "poly": null,
            "longitude": 111.176079,
            "latitude": 51.554287
        },
        "1597": {
            "name": "Арей",
            "population": 200,
            "type": "village",
            "poly": null,
            "longitude": 111.2469651,
            "latitude": 50.970478
        },
        "1598": {
            "name": "Шумунда",
            "population": 195,
            "type": "village",
            "poly": null,
            "longitude": 111.2997867,
            "latitude": 49.4983471
        },
        "1599": {
            "name": "Шебартуй 2-й",
            "population": 181,
            "type": "village",
            "poly": null,
            "longitude": 111.3866951,
            "latitude": 51.0292707
        },
        "1600": {
            "name": "Аренур",
            "population": 31,
            "type": "village",
            "poly": null,
            "longitude": 111.4202837,
            "latitude": 51.3773904
        },
        "1601": {
            "name": "Новосалия",
            "population": 164,
            "type": "village",
            "poly": null,
            "longitude": 111.4252758,
            "latitude": 50.9771027
        },
        "1602": {
            "name": "Ленинский",
            "population": 714,
            "type": "village",
            "poly": null,
            "longitude": 111.5191916,
            "latitude": 50.8445712
        },
        "1603": {
            "name": "Алтан",
            "population": 970,
            "type": "village",
            "poly": null,
            "longitude": 111.531548,
            "latitude": 49.510048
        },
        "1604": {
            "name": "Танга",
            "population": 1006,
            "type": "village",
            "poly": [
                [
                    111.529456,
                    50.9868102
                ],
                [
                    111.5371989,
                    50.988725
                ],
                [
                    111.5475966,
                    50.9923107
                ],
                [
                    111.563525,
                    50.9956176
                ],
                [
                    111.5703277,
                    50.9903264
                ],
                [
                    111.5685026,
                    50.9858005
                ],
                [
                    111.5626401,
                    50.9858005
                ],
                [
                    111.5525742,
                    50.984373
                ],
                [
                    111.548924,
                    50.9846166
                ],
                [
                    111.5456609,
                    50.9822491
                ],
                [
                    111.5374755,
                    50.9786278
                ],
                [
                    111.5295666,
                    50.9814831
                ],
                [
                    111.529456,
                    50.9868102
                ]
            ],
            "longitude": 111.5503067,
            "latitude": 50.9888294
        },
        "1605": {
            "name": "Билютуй",
            "population": 720,
            "type": "village",
            "poly": null,
            "longitude": 111.6914181,
            "latitude": 49.5893105
        },
        "1606": {
            "name": "Загарино",
            "population": 43,
            "type": "village",
            "poly": null,
            "longitude": 111.698799,
            "latitude": 51.682377
        },
        "1607": {
            "name": "Былыра",
            "population": 280,
            "type": "village",
            "poly": [
                [
                    111.7112389,
                    49.6811092
                ],
                [
                    111.7153588,
                    49.6871623
                ],
                [
                    111.7189636,
                    49.6899942
                ],
                [
                    111.7195645,
                    49.692937
                ],
                [
                    111.7230835,
                    49.6941585
                ],
                [
                    111.7256584,
                    49.692937
                ],
                [
                    111.7272892,
                    49.6942695
                ],
                [
                    111.729435,
                    49.6937698
                ],
                [
                    111.7271176,
                    49.6899387
                ],
                [
                    111.7212811,
                    49.687551
                ],
                [
                    111.7187062,
                    49.6860517
                ],
                [
                    111.7145863,
                    49.6807205
                ],
                [
                    111.7112389,
                    49.6811092
                ]
            ],
            "longitude": 111.722565,
            "latitude": 49.689995
        },
        "1608": {
            "name": "Дешулан",
            "population": 275,
            "type": "village",
            "poly": null,
            "longitude": 111.7788131,
            "latitude": 50.9793805
        },
        "1609": {
            "name": "Николаевское",
            "population": 1313,
            "type": "village",
            "poly": null,
            "longitude": 111.7831262,
            "latitude": 51.0534122
        },
        "1610": {
            "name": "Новые Ключи",
            "population": 125,
            "type": "village",
            "poly": null,
            "longitude": 111.7946062,
            "latitude": 50.9902324
        },
        "1611": {
            "name": "Укурик",
            "population": 130,
            "type": "village",
            "poly": null,
            "longitude": 111.818197,
            "latitude": 51.6753747
        },
        "1612": {
            "name": "Надёжный",
            "population": 47,
            "type": "village",
            "poly": null,
            "longitude": 111.8224233,
            "latitude": 50.0281952
        },
        "1613": {
            "name": "Шехолан",
            "population": 347,
            "type": "village",
            "poly": null,
            "longitude": 111.9328068,
            "latitude": 51.0329432
        },
        "1614": {
            "name": "Горекацан",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 111.9431978,
            "latitude": 51.1256725
        },
        "1615": {
            "name": "Кыра",
            "population": 4877,
            "type": "village",
            "poly": [
                [
                    111.9490574,
                    49.5754464
                ],
                [
                    111.9530056,
                    49.5806777
                ],
                [
                    111.960902,
                    49.584128
                ],
                [
                    111.9686268,
                    49.5873554
                ],
                [
                    111.9794415,
                    49.5896923
                ],
                [
                    111.9864796,
                    49.5892472
                ],
                [
                    111.9881962,
                    49.5817908
                ],
                [
                    111.9897411,
                    49.5724408
                ],
                [
                    111.9851063,
                    49.5714388
                ],
                [
                    111.9729183,
                    49.5705483
                ],
                [
                    111.9597004,
                    49.571105
                ],
                [
                    111.950774,
                    49.5731087
                ],
                [
                    111.9490574,
                    49.5754464
                ]
            ],
            "longitude": 111.971039,
            "latitude": 49.578625
        },
        "1616": {
            "name": "Горека",
            "population": 317,
            "type": "village",
            "poly": null,
            "longitude": 111.9883651,
            "latitude": 51.0727242
        },
        "1617": {
            "name": "Мордой",
            "population": 569,
            "type": "village",
            "poly": null,
            "longitude": 112.0241747,
            "latitude": 49.6965452
        },
        "1618": {
            "name": "Аблатукан",
            "population": 147,
            "type": "village",
            "poly": null,
            "longitude": 112.1269673,
            "latitude": 51.2443734
        },
        "1619": {
            "name": "Доронинское",
            "population": 801,
            "type": "village",
            "poly": [
                [
                    112.1181095,
                    51.1327086
                ],
                [
                    112.1184875,
                    51.1349618
                ],
                [
                    112.1415444,
                    51.1302773
                ],
                [
                    112.149293,
                    51.1302773
                ],
                [
                    112.1586481,
                    51.1260074
                ],
                [
                    112.1654517,
                    51.1218558
                ],
                [
                    112.1569471,
                    51.1185936
                ],
                [
                    112.1398434,
                    51.1209068
                ],
                [
                    112.1346462,
                    51.1177631
                ],
                [
                    112.1293544,
                    51.1212034
                ],
                [
                    112.1302049,
                    51.1242282
                ],
                [
                    112.1181095,
                    51.1327086
                ]
            ],
            "longitude": 112.1425838,
            "latitude": 51.1256516
        },
        "1620": {
            "name": "Любовь",
            "population": 826,
            "type": "village",
            "poly": null,
            "longitude": 112.1521173,
            "latitude": 49.6398149
        },
        "1621": {
            "name": "Гавань",
            "population": 419,
            "type": "village",
            "poly": null,
            "longitude": 112.1756656,
            "latitude": 49.468145
        },
        "1622": {
            "name": "Аблатуйский Бор",
            "population": 550,
            "type": "village",
            "poly": [
                [
                    112.2073124,
                    51.1899806
                ],
                [
                    112.2089145,
                    51.1917719
                ],
                [
                    112.2114426,
                    51.1905135
                ],
                [
                    112.2120257,
                    51.1910312
                ],
                [
                    112.2132405,
                    51.1904983
                ],
                [
                    112.2143824,
                    51.1910769
                ],
                [
                    112.216326,
                    51.1897978
                ],
                [
                    112.2186341,
                    51.1917316
                ],
                [
                    112.221428,
                    51.1927365
                ],
                [
                    112.2244407,
                    51.1926909
                ],
                [
                    112.2230072,
                    51.1907267
                ],
                [
                    112.2240359,
                    51.1900271
                ],
                [
                    112.2321909,
                    51.1899197
                ],
                [
                    112.2298912,
                    51.1873432
                ],
                [
                    112.2333085,
                    51.1873767
                ],
                [
                    112.233388,
                    51.1854631
                ],
                [
                    112.2313891,
                    51.1848031
                ],
                [
                    112.2275019,
                    51.184727
                ],
                [
                    112.2260455,
                    51.184399
                ],
                [
                    112.2209464,
                    51.184349
                ],
                [
                    112.2188041,
                    51.1836153
                ],
                [
                    112.2166162,
                    51.1819906
                ],
                [
                    112.2131718,
                    51.1822326
                ],
                [
                    112.2138479,
                    51.1837828
                ],
                [
                    112.2148683,
                    51.1851686
                ],
                [
                    112.2137507,
                    51.1861889
                ],
                [
                    112.2110539,
                    51.1862041
                ],
                [
                    112.2086973,
                    51.186661
                ],
                [
                    112.2073301,
                    51.1886269
                ],
                [
                    112.2073124,
                    51.1899806
                ]
            ],
            "longitude": 112.2189455,
            "latitude": 51.1868252
        },
        "1623": {
            "name": "Гонгота",
            "population": 382,
            "type": "village",
            "poly": null,
            "longitude": 112.255531,
            "latitude": 51.776855
        },
        "1624": {
            "name": "Бальзой",
            "population": 570,
            "type": "village",
            "poly": [
                [
                    112.3440467,
                    51.3660887
                ],
                [
                    112.347753,
                    51.3659352
                ],
                [
                    112.3510254,
                    51.3645015
                ],
                [
                    112.3538959,
                    51.3652901
                ],
                [
                    112.3537097,
                    51.368976
                ],
                [
                    112.35607,
                    51.3702168
                ],
                [
                    112.378665,
                    51.361586
                ],
                [
                    112.3770189,
                    51.3586127
                ],
                [
                    112.3772494,
                    51.3543957
                ],
                [
                    112.3814051,
                    51.3506547
                ],
                [
                    112.3781145,
                    51.3482632
                ],
                [
                    112.3716602,
                    51.3503955
                ],
                [
                    112.3667484,
                    51.3464762
                ],
                [
                    112.3544268,
                    51.3508017
                ],
                [
                    112.3449621,
                    51.3576775
                ],
                [
                    112.3440467,
                    51.3660887
                ]
            ],
            "longitude": 112.3644339,
            "latitude": 51.356352
        },
        "1625": {
            "name": "Хапчеранга",
            "population": 980,
            "type": "village",
            "poly": [
                [
                    112.3752134,
                    49.709447
                ],
                [
                    112.3771065,
                    49.7114842
                ],
                [
                    112.3836941,
                    49.7042364
                ],
                [
                    112.3886653,
                    49.7039777
                ],
                [
                    112.3860436,
                    49.7167131
                ],
                [
                    112.3891125,
                    49.7180114
                ],
                [
                    112.3921839,
                    49.7180114
                ],
                [
                    112.3949286,
                    49.7172931
                ],
                [
                    112.3989149,
                    49.7175889
                ],
                [
                    112.4018062,
                    49.7174396
                ],
                [
                    112.404731,
                    49.7155185
                ],
                [
                    112.4055152,
                    49.7121381
                ],
                [
                    112.4038399,
                    49.7111487
                ],
                [
                    112.4001648,
                    49.7111581
                ],
                [
                    112.3992957,
                    49.7090138
                ],
                [
                    112.4019438,
                    49.7061414
                ],
                [
                    112.4069824,
                    49.7054278
                ],
                [
                    112.4089133,
                    49.7041932
                ],
                [
                    112.4071784,
                    49.7022165
                ],
                [
                    112.4037209,
                    49.7019232
                ],
                [
                    112.407345,
                    49.6988677
                ],
                [
                    112.4087849,
                    49.6953799
                ],
                [
                    112.4083252,
                    49.6926116
                ],
                [
                    112.4044042,
                    49.6900328
                ],
                [
                    112.4017184,
                    49.6767732
                ],
                [
                    112.3895046,
                    49.6767139
                ],
                [
                    112.3870867,
                    49.6819574
                ],
                [
                    112.391269,
                    49.6860586
                ],
                [
                    112.3931641,
                    49.6921465
                ],
                [
                    112.3876748,
                    49.6948943
                ],
                [
                    112.3814156,
                    49.6951193
                ],
                [
                    112.3768268,
                    49.6984027
                ],
                [
                    112.3793101,
                    49.699713
                ],
                [
                    112.3755995,
                    49.7012439
                ],
                [
                    112.3785259,
                    49.7024181
                ],
                [
                    112.3752134,
                    49.709447
                ]
            ],
            "longitude": 112.386902,
            "latitude": 49.6991
        },
        "1626": {
            "name": "Тырин",
            "population": 335,
            "type": "village",
            "poly": [
                [
                    112.3893872,
                    49.5729996
                ],
                [
                    112.3923483,
                    49.5736118
                ],
                [
                    112.3995581,
                    49.5660695
                ],
                [
                    112.4103298,
                    49.5652901
                ],
                [
                    112.410244,
                    49.5628128
                ],
                [
                    112.4027338,
                    49.5624788
                ],
                [
                    112.4037638,
                    49.5607251
                ],
                [
                    112.4002877,
                    49.5594725
                ],
                [
                    112.3973265,
                    49.5636757
                ],
                [
                    112.3935499,
                    49.5627293
                ],
                [
                    112.3905888,
                    49.5669045
                ],
                [
                    112.3927346,
                    49.5686023
                ],
                [
                    112.3893872,
                    49.5729996
                ]
            ],
            "longitude": 112.3999872,
            "latitude": 49.5645664
        },
        "1627": {
            "name": "Арта",
            "population": 797,
            "type": "village",
            "poly": [
                [
                    112.3792956,
                    51.2512888
                ],
                [
                    112.3942581,
                    51.2637855
                ],
                [
                    112.4043723,
                    51.2641174
                ],
                [
                    112.4058913,
                    51.2619085
                ],
                [
                    112.4093793,
                    51.2633978
                ],
                [
                    112.4107034,
                    51.2618358
                ],
                [
                    112.4170784,
                    51.2610566
                ],
                [
                    112.4192033,
                    51.2587421
                ],
                [
                    112.4148818,
                    51.2527562
                ],
                [
                    112.4149098,
                    51.2498933
                ],
                [
                    112.4051684,
                    51.2471713
                ],
                [
                    112.4033913,
                    51.2456366
                ],
                [
                    112.4029393,
                    51.2421657
                ],
                [
                    112.3994869,
                    51.237475
                ],
                [
                    112.3943382,
                    51.2366991
                ],
                [
                    112.3909723,
                    51.2371352
                ],
                [
                    112.386794,
                    51.2386248
                ],
                [
                    112.382096,
                    51.2419423
                ],
                [
                    112.3792956,
                    51.2512888
                ]
            ],
            "longitude": 112.4018631,
            "latitude": 51.2520796
        },
        "1628": {
            "name": "Верхний Стан",
            "population": 18,
            "type": "village",
            "poly": [
                [
                    112.4698741,
                    49.7718684
                ],
                [
                    112.470914,
                    49.7739277
                ],
                [
                    112.4810417,
                    49.7709643
                ],
                [
                    112.4844548,
                    49.7690237
                ],
                [
                    112.4838639,
                    49.7682077
                ],
                [
                    112.4825764,
                    49.7669881
                ],
                [
                    112.4774853,
                    49.7683614
                ],
                [
                    112.4698741,
                    49.7718684
                ]
            ],
            "longitude": 112.4800244,
            "latitude": 49.7698302
        },
        "1629": {
            "name": "Улёты",
            "population": 6630,
            "type": "village",
            "poly": [
                [
                    112.4566454,
                    51.3602115
                ],
                [
                    112.4662198,
                    51.3661091
                ],
                [
                    112.4783051,
                    51.3705156
                ],
                [
                    112.4712555,
                    51.3797975
                ],
                [
                    112.4845968,
                    51.379618
                ],
                [
                    112.495793,
                    51.3811548
                ],
                [
                    112.4967357,
                    51.3838029
                ],
                [
                    112.5013377,
                    51.3901771
                ],
                [
                    112.5063106,
                    51.3827237
                ],
                [
                    112.505913,
                    51.3782216
                ],
                [
                    112.4994663,
                    51.3738347
                ],
                [
                    112.4930026,
                    51.3734944
                ],
                [
                    112.4906759,
                    51.3707347
                ],
                [
                    112.4923046,
                    51.3633263
                ],
                [
                    112.4964684,
                    51.357907
                ],
                [
                    112.4956766,
                    51.355771
                ],
                [
                    112.4933499,
                    51.3543543
                ],
                [
                    112.4929479,
                    51.3413406
                ],
                [
                    112.490471,
                    51.3319429
                ],
                [
                    112.4859209,
                    51.3324613
                ],
                [
                    112.4851671,
                    51.3368473
                ],
                [
                    112.4721839,
                    51.3429123
                ],
                [
                    112.4727587,
                    51.3451267
                ],
                [
                    112.4696758,
                    51.3458169
                ],
                [
                    112.4603995,
                    51.3524208
                ],
                [
                    112.4566454,
                    51.3602115
                ]
            ],
            "longitude": 112.485115,
            "latitude": 51.35854
        },
        "1630": {
            "name": "Ягодный",
            "population": 366,
            "type": "village",
            "poly": [
                [
                    112.4872749,
                    51.9048354
                ],
                [
                    112.4903978,
                    51.908546
                ],
                [
                    112.5009229,
                    51.9041932
                ],
                [
                    112.4987254,
                    51.9025995
                ],
                [
                    112.4947158,
                    51.9009581
                ],
                [
                    112.492364,
                    51.8992215
                ],
                [
                    112.4909761,
                    51.8999352
                ],
                [
                    112.4907239,
                    51.9010795
                ],
                [
                    112.492017,
                    51.901862
                ],
                [
                    112.4872749,
                    51.9048354
                ]
            ],
            "longitude": 112.493866,
            "latitude": 51.90424
        },
        "1631": {
            "name": "Тарбальджей",
            "population": 490,
            "type": "village",
            "poly": [
                [
                    112.501575,
                    49.7362209
                ],
                [
                    112.5051929,
                    49.7377911
                ],
                [
                    112.5139143,
                    49.7380514
                ],
                [
                    112.5145813,
                    49.7413796
                ],
                [
                    112.5186941,
                    49.7414606
                ],
                [
                    112.5214205,
                    49.7400353
                ],
                [
                    112.5372183,
                    49.7407264
                ],
                [
                    112.5454502,
                    49.7342451
                ],
                [
                    112.5338842,
                    49.731373
                ],
                [
                    112.5286625,
                    49.7294016
                ],
                [
                    112.5114266,
                    49.7299393
                ],
                [
                    112.5017073,
                    49.7337331
                ],
                [
                    112.501575,
                    49.7362209
                ]
            ],
            "longitude": 112.5156441,
            "latitude": 49.7354486
        },
        "1632": {
            "name": "Нижний Стан",
            "population": 37,
            "type": "village",
            "poly": [
                [
                    112.5226395,
                    49.7577524
                ],
                [
                    112.5235846,
                    49.7591165
                ],
                [
                    112.5256567,
                    49.7593753
                ],
                [
                    112.527212,
                    49.7587433
                ],
                [
                    112.5319714,
                    49.7581982
                ],
                [
                    112.5331499,
                    49.7575343
                ],
                [
                    112.5323181,
                    49.7570418
                ],
                [
                    112.5358531,
                    49.753743
                ],
                [
                    112.5353448,
                    49.7527578
                ],
                [
                    112.5355695,
                    49.751954
                ],
                [
                    112.5318165,
                    49.7513971
                ],
                [
                    112.5296611,
                    49.7541012
                ],
                [
                    112.5268655,
                    49.755982
                ],
                [
                    112.5235384,
                    49.7572508
                ],
                [
                    112.5226395,
                    49.7577524
                ]
            ],
            "longitude": 112.5289479,
            "latitude": 49.7559696
        },
        "1633": {
            "name": "Сохондо",
            "population": 1072,
            "type": "village",
            "poly": null,
            "longitude": 112.535202,
            "latitude": 51.817394
        },
        "1634": {
            "name": "Верхний Ульхун",
            "population": 1085,
            "type": "village",
            "poly": [
                [
                    112.5343498,
                    49.581078
                ],
                [
                    112.5398045,
                    49.5920952
                ],
                [
                    112.540767,
                    49.5965137
                ],
                [
                    112.5508842,
                    49.5963826
                ],
                [
                    112.5570477,
                    49.5863106
                ],
                [
                    112.5563832,
                    49.5749043
                ],
                [
                    112.5571073,
                    49.5722042
                ],
                [
                    112.5484126,
                    49.5658076
                ],
                [
                    112.5346701,
                    49.5674265
                ],
                [
                    112.539209,
                    49.5804254
                ],
                [
                    112.5343498,
                    49.581078
                ]
            ],
            "longitude": 112.5452557,
            "latitude": 49.5839354
        },
        "1635": {
            "name": "Хадакта",
            "population": 994,
            "type": "village",
            "poly": null,
            "longitude": 112.5705332,
            "latitude": 51.427184
        },
        "1636": {
            "name": "Иргень",
            "population": 506,
            "type": "village",
            "poly": [
                [
                    112.5691384,
                    51.9825393
                ],
                [
                    112.5692387,
                    51.9856356
                ],
                [
                    112.5709042,
                    51.987497
                ],
                [
                    112.5729643,
                    51.9885885
                ],
                [
                    112.5777513,
                    51.9911248
                ],
                [
                    112.5856162,
                    51.9911058
                ],
                [
                    112.5891478,
                    51.9770776
                ],
                [
                    112.5940055,
                    51.9769351
                ],
                [
                    112.5933501,
                    51.9747977
                ],
                [
                    112.5884538,
                    51.9740852
                ],
                [
                    112.5866032,
                    51.9763651
                ],
                [
                    112.5776973,
                    51.9750827
                ],
                [
                    112.5691384,
                    51.9825393
                ]
            ],
            "longitude": 112.578735,
            "latitude": 51.983963
        },
        "1637": {
            "name": "Тургутуй",
            "population": 22,
            "type": "village",
            "poly": null,
            "longitude": 112.643875,
            "latitude": 51.843033
        },
        "1638": {
            "name": "Беклемишево",
            "population": 1175,
            "type": "village",
            "poly": [
                [
                    112.6606337,
                    52.1229374
                ],
                [
                    112.6629059,
                    52.1411045
                ],
                [
                    112.6765859,
                    52.1378261
                ],
                [
                    112.6710488,
                    52.129029
                ],
                [
                    112.6760387,
                    52.1239869
                ],
                [
                    112.6867951,
                    52.1152575
                ],
                [
                    112.6875873,
                    52.1149247
                ],
                [
                    112.7031069,
                    52.1141695
                ],
                [
                    112.7077451,
                    52.106104
                ],
                [
                    112.7173341,
                    52.1027429
                ],
                [
                    112.71822,
                    52.1012064
                ],
                [
                    112.7102987,
                    52.0997979
                ],
                [
                    112.7016998,
                    52.102839
                ],
                [
                    112.6910685,
                    52.1091447
                ],
                [
                    112.6750173,
                    52.1139454
                ],
                [
                    112.6708678,
                    52.1149103
                ],
                [
                    112.6642817,
                    52.1164416
                ],
                [
                    112.6606337,
                    52.1229374
                ]
            ],
            "longitude": 112.672441,
            "latitude": 52.1216376
        },
        "1639": {
            "name": "Мангут",
            "population": 2404,
            "type": "village",
            "poly": [
                [
                    112.6563206,
                    49.6921041
                ],
                [
                    112.6681652,
                    49.6976562
                ],
                [
                    112.6801815,
                    49.706316
                ],
                [
                    112.6927128,
                    49.7048727
                ],
                [
                    112.6920262,
                    49.7015422
                ],
                [
                    112.6776066,
                    49.6919931
                ],
                [
                    112.6600971,
                    49.6863293
                ],
                [
                    112.6563206,
                    49.6921041
                ]
            ],
            "longitude": 112.6769115,
            "latitude": 49.6958425
        },
        "1640": {
            "name": "Шакша",
            "population": 254,
            "type": "village",
            "poly": [
                [
                    112.7125194,
                    52.1100388
                ],
                [
                    112.7128529,
                    52.1128296
                ],
                [
                    112.7261525,
                    52.1143914
                ],
                [
                    112.7313222,
                    52.1101156
                ],
                [
                    112.7260691,
                    52.1066588
                ],
                [
                    112.7217332,
                    52.1100644
                ],
                [
                    112.7153127,
                    52.1095267
                ],
                [
                    112.7125194,
                    52.1100388
                ]
            ],
            "longitude": 112.721649,
            "latitude": 52.111599
        },
        "1641": {
            "name": "Черемхово",
            "population": 571,
            "type": "village",
            "poly": null,
            "longitude": 112.7245812,
            "latitude": 51.458884
        },
        "1642": {
            "name": "Курулга",
            "population": 420,
            "type": "village",
            "poly": [
                [
                    112.7548542,
                    50.1148939
                ],
                [
                    112.755455,
                    50.1159396
                ],
                [
                    112.7592316,
                    50.1172605
                ],
                [
                    112.766098,
                    50.1248549
                ],
                [
                    112.7697029,
                    50.1238094
                ],
                [
                    112.7661839,
                    50.1183612
                ],
                [
                    112.7659264,
                    50.112362
                ],
                [
                    112.7647248,
                    50.1115914
                ],
                [
                    112.7548542,
                    50.1148939
                ]
            ],
            "longitude": 112.7626648,
            "latitude": 50.1162148
        },
        "1643": {
            "name": "Яблоново",
            "population": 705,
            "type": "village",
            "poly": [
                [
                    112.7469277,
                    51.8485013
                ],
                [
                    112.7478539,
                    51.8486205
                ],
                [
                    112.7490021,
                    51.8488432
                ],
                [
                    112.7508622,
                    51.8494956
                ],
                [
                    112.7548777,
                    51.8468563
                ],
                [
                    112.7553794,
                    51.8465226
                ],
                [
                    112.7515588,
                    51.8451874
                ],
                [
                    112.7505554,
                    51.8443768
                ],
                [
                    112.7585826,
                    51.8408957
                ],
                [
                    112.7600877,
                    51.8426601
                ],
                [
                    112.7583511,
                    51.8434469
                ],
                [
                    112.7586984,
                    51.8442576
                ],
                [
                    112.7571161,
                    51.8447583
                ],
                [
                    112.7575406,
                    51.8454497
                ],
                [
                    112.7586984,
                    51.8454497
                ],
                [
                    112.759042,
                    51.8456946
                ],
                [
                    112.7597018,
                    51.8461649
                ],
                [
                    112.7594902,
                    51.8463635
                ],
                [
                    112.7590906,
                    51.8467388
                ],
                [
                    112.758737,
                    51.8470709
                ],
                [
                    112.7631751,
                    51.8494549
                ],
                [
                    112.7624429,
                    51.8482458
                ],
                [
                    112.7629822,
                    51.8475716
                ],
                [
                    112.7645252,
                    51.8476226
                ],
                [
                    112.7651433,
                    51.8476431
                ],
                [
                    112.764989,
                    51.8464272
                ],
                [
                    112.763947,
                    51.8460457
                ],
                [
                    112.7644873,
                    51.8450444
                ],
                [
                    112.7643715,
                    51.8425409
                ],
                [
                    112.7703919,
                    51.8368658
                ],
                [
                    112.7715883,
                    51.8354589
                ],
                [
                    112.7710094,
                    51.8349581
                ],
                [
                    112.768771,
                    51.8350296
                ],
                [
                    112.7610911,
                    51.8379627
                ],
                [
                    112.7590843,
                    51.8378912
                ],
                [
                    112.7527938,
                    51.8399657
                ],
                [
                    112.7506326,
                    51.8418971
                ],
                [
                    112.7485872,
                    51.8428984
                ],
                [
                    112.747661,
                    51.8439476
                ],
                [
                    112.7474294,
                    51.8463795
                ],
                [
                    112.7469277,
                    51.8485013
                ]
            ],
            "longitude": 112.763557,
            "latitude": 51.839775
        },
        "1644": {
            "name": "Ульхун-Партия",
            "population": 725,
            "type": "village",
            "poly": [
                [
                    112.7517446,
                    49.8502758
                ],
                [
                    112.7558982,
                    49.858619
                ],
                [
                    112.7632796,
                    49.8683226
                ],
                [
                    112.7675579,
                    49.8676425
                ],
                [
                    112.7714529,
                    49.8665308
                ],
                [
                    112.7752748,
                    49.8613576
                ],
                [
                    112.7743245,
                    49.8594916
                ],
                [
                    112.7689442,
                    49.8582297
                ],
                [
                    112.767142,
                    49.8535227
                ],
                [
                    112.7686669,
                    49.8481596
                ],
                [
                    112.7677876,
                    49.8469425
                ],
                [
                    112.7517446,
                    49.8502758
                ]
            ],
            "longitude": 112.7648106,
            "latitude": 49.8575038
        },
        "1645": {
            "name": "Арахлей",
            "population": 319,
            "type": "village",
            "poly": [
                [
                    112.8233659,
                    52.162387
                ],
                [
                    112.8289483,
                    52.1671264
                ],
                [
                    112.8462522,
                    52.161847
                ],
                [
                    112.8395037,
                    52.1575178
                ],
                [
                    112.8285571,
                    52.1594563
                ],
                [
                    112.8233659,
                    52.162387
                ]
            ],
            "longitude": 112.831795,
            "latitude": 52.162918
        },
        "1646": {
            "name": "Татаурово",
            "population": 670,
            "type": "village",
            "poly": [
                [
                    112.9100019,
                    51.5911083
                ],
                [
                    112.9132547,
                    51.5933536
                ],
                [
                    112.9156642,
                    51.5912954
                ],
                [
                    112.926748,
                    51.5954492
                ],
                [
                    112.9290973,
                    51.6009871
                ],
                [
                    112.9379523,
                    51.6103027
                ],
                [
                    112.946747,
                    51.6092179
                ],
                [
                    112.9446387,
                    51.6053646
                ],
                [
                    112.9385547,
                    51.6029701
                ],
                [
                    112.9366271,
                    51.6013239
                ],
                [
                    112.9321092,
                    51.5950376
                ],
                [
                    112.9155438,
                    51.5866546
                ],
                [
                    112.9100019,
                    51.5911083
                ]
            ],
            "longitude": 112.9317478,
            "latitude": 51.6000517
        },
        "1647": {
            "name": "Кука",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 112.95372,
            "latitude": 51.729156
        },
        "1648": {
            "name": "Нарасун",
            "population": 1013,
            "type": "village",
            "poly": [
                [
                    112.9669508,
                    50.0866722
                ],
                [
                    112.9791837,
                    50.101745
                ],
                [
                    112.9864763,
                    50.0997919
                ],
                [
                    112.9860516,
                    50.1004093
                ],
                [
                    112.9868727,
                    50.1044773
                ],
                [
                    112.9895907,
                    50.1042593
                ],
                [
                    112.9877394,
                    50.1016944
                ],
                [
                    112.9890577,
                    50.0958239
                ],
                [
                    112.993498,
                    50.0923995
                ],
                [
                    112.992146,
                    50.0908364
                ],
                [
                    112.9865893,
                    50.0874227
                ],
                [
                    112.9831637,
                    50.0868409
                ],
                [
                    112.9822478,
                    50.0854214
                ],
                [
                    112.9713611,
                    50.0765024
                ],
                [
                    112.967557,
                    50.0787331
                ],
                [
                    112.9674498,
                    50.0811181
                ],
                [
                    112.968639,
                    50.0821356
                ],
                [
                    112.9679595,
                    50.0828078
                ],
                [
                    112.9684691,
                    50.0842612
                ],
                [
                    112.9683559,
                    50.0857509
                ],
                [
                    112.9669508,
                    50.0866722
                ]
            ],
            "longitude": 112.9764691,
            "latitude": 50.089349
        },
        "1649": {
            "name": "Иван-Озеро",
            "population": 125,
            "type": "village",
            "poly": [
                [
                    112.9726672,
                    52.2524019
                ],
                [
                    112.9870009,
                    52.262174
                ],
                [
                    112.9925799,
                    52.2622266
                ],
                [
                    112.9969573,
                    52.2641702
                ],
                [
                    112.9966139,
                    52.2665865
                ],
                [
                    113.0004763,
                    52.269633
                ],
                [
                    113.0109477,
                    52.2739398
                ],
                [
                    113.0263114,
                    52.2692128
                ],
                [
                    113.0241656,
                    52.2670593
                ],
                [
                    113.0156684,
                    52.2711562
                ],
                [
                    113.009746,
                    52.270736
                ],
                [
                    113.0020213,
                    52.2669542
                ],
                [
                    113.0012488,
                    52.264748
                ],
                [
                    112.9848551,
                    52.2569204
                ],
                [
                    112.9792761,
                    52.2532426
                ],
                [
                    112.9758429,
                    52.2503526
                ],
                [
                    112.9726672,
                    52.2524019
                ]
            ],
            "longitude": 112.9885459,
            "latitude": 52.2599151
        },
        "1650": {
            "name": "Домно-Ключи",
            "population": 388,
            "type": "village",
            "poly": [
                [
                    112.9810739,
                    51.9739101
                ],
                [
                    112.9829365,
                    51.9751388
                ],
                [
                    112.9885361,
                    51.9748103
                ],
                [
                    113.0022495,
                    51.960095
                ],
                [
                    113.0116965,
                    51.9553767
                ],
                [
                    113.0080777,
                    51.9519256
                ],
                [
                    112.9965874,
                    51.9589288
                ],
                [
                    112.9883095,
                    51.9514131
                ],
                [
                    112.9837505,
                    51.9530058
                ],
                [
                    112.9942318,
                    51.9618001
                ],
                [
                    112.9845364,
                    51.9719944
                ],
                [
                    112.9810739,
                    51.9739101
                ]
            ],
            "longitude": 112.9971221,
            "latitude": 51.9620246
        },
        "1651": {
            "name": "Лесная",
            "population": 799,
            "type": "village",
            "poly": [
                [
                    112.9944424,
                    51.7691025
                ],
                [
                    112.9987211,
                    51.773293
                ],
                [
                    113.0027036,
                    51.7740012
                ],
                [
                    113.0054332,
                    51.7738664
                ],
                [
                    113.0135527,
                    51.7709989
                ],
                [
                    113.0159621,
                    51.7731054
                ],
                [
                    113.0179855,
                    51.7735417
                ],
                [
                    113.0240119,
                    51.7701221
                ],
                [
                    113.0184147,
                    51.7667213
                ],
                [
                    113.0134042,
                    51.7651016
                ],
                [
                    113.0081138,
                    51.7627709
                ],
                [
                    113.0044779,
                    51.7639595
                ],
                [
                    113.0026506,
                    51.7638672
                ],
                [
                    113.0026506,
                    51.7619977
                ],
                [
                    112.9998991,
                    51.7618992
                ],
                [
                    112.9995182,
                    51.7641557
                ],
                [
                    112.998657,
                    51.7654489
                ],
                [
                    112.9951777,
                    51.7669872
                ],
                [
                    112.9944424,
                    51.7691025
                ]
            ],
            "longitude": 113.0001041,
            "latitude": 51.7667417
        },
        "1652": {
            "name": "Михайло-Павловск",
            "population": 316,
            "type": "village",
            "poly": null,
            "longitude": 113.0108817,
            "latitude": 49.6807749
        },
        "1653": {
            "name": "Жипковщина",
            "population": 612,
            "type": "village",
            "poly": [
                [
                    112.9983494,
                    51.8042953
                ],
                [
                    112.998974,
                    51.8076292
                ],
                [
                    113.0014504,
                    51.8092767
                ],
                [
                    113.0065972,
                    51.8100564
                ],
                [
                    113.0092877,
                    51.8117485
                ],
                [
                    113.0145819,
                    51.8112974
                ],
                [
                    113.023751,
                    51.8094814
                ],
                [
                    113.0175954,
                    51.804636
                ],
                [
                    113.0199572,
                    51.8014565
                ],
                [
                    113.0241493,
                    51.7992694
                ],
                [
                    113.0248485,
                    51.7974532
                ],
                [
                    113.0219489,
                    51.7970391
                ],
                [
                    113.0123199,
                    51.797868
                ],
                [
                    113.0109277,
                    51.7991936
                ],
                [
                    112.9993255,
                    51.8033354
                ],
                [
                    112.9983494,
                    51.8042953
                ]
            ],
            "longitude": 113.0126093,
            "latitude": 51.801984
        },
        "1654": {
            "name": "Голубичная",
            "population": 287,
            "type": "village",
            "poly": [
                [
                    113.0350557,
                    51.6091064
                ],
                [
                    113.0360659,
                    51.6111773
                ],
                [
                    113.0370029,
                    51.6130981
                ],
                [
                    113.0386474,
                    51.6137418
                ],
                [
                    113.0449169,
                    51.6161959
                ],
                [
                    113.0452734,
                    51.6163353
                ],
                [
                    113.053167,
                    51.6136831
                ],
                [
                    113.0521829,
                    51.612383
                ],
                [
                    113.0461947,
                    51.6128901
                ],
                [
                    113.0474336,
                    51.6110185
                ],
                [
                    113.0483722,
                    51.6096005
                ],
                [
                    113.0511472,
                    51.6080115
                ],
                [
                    113.0514217,
                    51.6078542
                ],
                [
                    113.0516614,
                    51.607717
                ],
                [
                    113.0524745,
                    51.6072514
                ],
                [
                    113.0532089,
                    51.6068308
                ],
                [
                    113.0551352,
                    51.6050232
                ],
                [
                    113.0484141,
                    51.6024093
                ],
                [
                    113.0476366,
                    51.6027991
                ],
                [
                    113.0350557,
                    51.6091064
                ]
            ],
            "longitude": 113.0423002,
            "latitude": 51.6116419
        },
        "1655": {
            "name": "Новая Кука",
            "population": 519,
            "type": "village",
            "poly": [
                [
                    113.0394164,
                    51.7884676
                ],
                [
                    113.0426119,
                    51.7934882
                ],
                [
                    113.0600523,
                    51.7905378
                ],
                [
                    113.0607224,
                    51.7987585
                ],
                [
                    113.0624332,
                    51.8024999
                ],
                [
                    113.069525,
                    51.8062321
                ],
                [
                    113.0730788,
                    51.8024327
                ],
                [
                    113.0702086,
                    51.7999319
                ],
                [
                    113.0721637,
                    51.7953703
                ],
                [
                    113.0765019,
                    51.7911523
                ],
                [
                    113.0762937,
                    51.7872577
                ],
                [
                    113.0711754,
                    51.7879554
                ],
                [
                    113.0711845,
                    51.7829044
                ],
                [
                    113.0671146,
                    51.777352
                ],
                [
                    113.0677557,
                    51.7745808
                ],
                [
                    113.0621045,
                    51.7737299
                ],
                [
                    113.0607861,
                    51.7759162
                ],
                [
                    113.0581131,
                    51.7758108
                ],
                [
                    113.0580633,
                    51.7791741
                ],
                [
                    113.0544224,
                    51.7800387
                ],
                [
                    113.0458873,
                    51.7790139
                ],
                [
                    113.0394164,
                    51.7884676
                ]
            ],
            "longitude": 113.059143,
            "latitude": 51.788258
        },
        "1656": {
            "name": "Старая Кука",
            "population": 298,
            "type": "village",
            "poly": [
                [
                    113.057405,
                    51.760136
                ],
                [
                    113.0574905,
                    51.7616658
                ],
                [
                    113.0609104,
                    51.7627443
                ],
                [
                    113.0630733,
                    51.7664831
                ],
                [
                    113.065123,
                    51.7723235
                ],
                [
                    113.0663855,
                    51.7702681
                ],
                [
                    113.0673598,
                    51.76807
                ],
                [
                    113.0677107,
                    51.7671189
                ],
                [
                    113.0684092,
                    51.7578603
                ],
                [
                    113.0691122,
                    51.752471
                ],
                [
                    113.0686759,
                    51.7500428
                ],
                [
                    113.0580761,
                    51.7504788
                ],
                [
                    113.058566,
                    51.7523298
                ],
                [
                    113.060829,
                    51.7535072
                ],
                [
                    113.0609122,
                    51.7579866
                ],
                [
                    113.057405,
                    51.760136
                ]
            ],
            "longitude": 113.0662433,
            "latitude": 51.7601182
        },
        "1657": {
            "name": "Лесной Городок",
            "population": 1368,
            "type": "village",
            "poly": [
                [
                    113.0489128,
                    51.7416244
                ],
                [
                    113.0525078,
                    51.744345
                ],
                [
                    113.0564174,
                    51.7430387
                ],
                [
                    113.0723458,
                    51.7433248
                ],
                [
                    113.0806349,
                    51.7380561
                ],
                [
                    113.0899932,
                    51.7398113
                ],
                [
                    113.0916174,
                    51.738861
                ],
                [
                    113.0879443,
                    51.731193
                ],
                [
                    113.0839856,
                    51.7245574
                ],
                [
                    113.0825255,
                    51.7244164
                ],
                [
                    113.080562,
                    51.7313971
                ],
                [
                    113.0771876,
                    51.731435
                ],
                [
                    113.0752354,
                    51.728164
                ],
                [
                    113.0692153,
                    51.7296822
                ],
                [
                    113.0651063,
                    51.7248404
                ],
                [
                    113.0628658,
                    51.7202383
                ],
                [
                    113.04996,
                    51.7224335
                ],
                [
                    113.05387,
                    51.729543
                ],
                [
                    113.0502915,
                    51.7366733
                ],
                [
                    113.0533634,
                    51.7396704
                ],
                [
                    113.0489128,
                    51.7416244
                ]
            ],
            "longitude": 113.067932,
            "latitude": 51.7332
        },
        "1658": {
            "name": "Ленинский",
            "population": 337,
            "type": "village",
            "poly": null,
            "longitude": 113.078735,
            "latitude": 51.130802
        },
        "1659": {
            "name": "Ингода",
            "population": 1142,
            "type": "village",
            "poly": [
                [
                    113.09213,
                    51.851418
                ],
                [
                    113.0950482,
                    51.854493
                ],
                [
                    113.0992539,
                    51.8529555
                ],
                [
                    113.1030304,
                    51.8578858
                ],
                [
                    113.102258,
                    51.859317
                ],
                [
                    113.1084378,
                    51.8663136
                ],
                [
                    113.1141026,
                    51.8644054
                ],
                [
                    113.1116993,
                    51.8602182
                ],
                [
                    113.1079228,
                    51.8573557
                ],
                [
                    113.1032879,
                    51.8482899
                ],
                [
                    113.1053479,
                    51.8434116
                ],
                [
                    113.1029446,
                    51.8402829
                ],
                [
                    113.0992539,
                    51.8399117
                ],
                [
                    113.0949624,
                    51.8410253
                ],
                [
                    113.0975373,
                    51.8439949
                ],
                [
                    113.0934174,
                    51.8454797
                ],
                [
                    113.0958207,
                    51.8498275
                ],
                [
                    113.09213,
                    51.851418
                ]
            ],
            "longitude": 113.1005414,
            "latitude": 51.8516301
        },
        "1660": {
            "name": "Бытэв",
            "population": 484,
            "type": "village",
            "poly": [
                [
                    113.1120816,
                    50.1492809
                ],
                [
                    113.1137123,
                    50.1499958
                ],
                [
                    113.1180897,
                    50.1494184
                ],
                [
                    113.1363716,
                    50.1567052
                ],
                [
                    113.1439677,
                    50.1573376
                ],
                [
                    113.1452551,
                    50.1558253
                ],
                [
                    113.141264,
                    50.1526632
                ],
                [
                    113.1371441,
                    50.1510683
                ],
                [
                    113.134543,
                    50.1522865
                ],
                [
                    113.1332817,
                    50.1528282
                ],
                [
                    113.1160298,
                    50.1467233
                ],
                [
                    113.1120816,
                    50.1492809
                ]
            ],
            "longitude": 113.1310072,
            "latitude": 50.1524157
        },
        "1661": {
            "name": "Колочное 2-е",
            "population": 718,
            "type": "village",
            "poly": [
                [
                    113.1238493,
                    51.9774775
                ],
                [
                    113.1242499,
                    51.9812936
                ],
                [
                    113.1309614,
                    51.9844652
                ],
                [
                    113.138994,
                    51.9811586
                ],
                [
                    113.1502947,
                    51.9754627
                ],
                [
                    113.1417293,
                    51.9689254
                ],
                [
                    113.1298262,
                    51.9749299
                ],
                [
                    113.1238493,
                    51.9774775
                ]
            ],
            "longitude": 113.1380001,
            "latitude": 51.9759085
        },
        "1662": {
            "name": "Турген",
            "population": 147,
            "type": "village",
            "poly": null,
            "longitude": 113.1393062,
            "latitude": 49.7600017
        },
        "1663": {
            "name": "Домна",
            "population": 7100,
            "type": "village",
            "poly": [
                [
                    113.1333711,
                    51.8854372
                ],
                [
                    113.1392935,
                    51.8910525
                ],
                [
                    113.1374052,
                    51.8947604
                ],
                [
                    113.1431558,
                    51.8991564
                ],
                [
                    113.1501081,
                    51.8989975
                ],
                [
                    113.1670168,
                    51.9121301
                ],
                [
                    113.1814363,
                    51.903446
                ],
                [
                    113.1805212,
                    51.9030137
                ],
                [
                    113.17045,
                    51.898256
                ],
                [
                    113.1710508,
                    51.8954489
                ],
                [
                    113.1604936,
                    51.8903109
                ],
                [
                    113.1528547,
                    51.888245
                ],
                [
                    113.1495073,
                    51.8846955
                ],
                [
                    113.149164,
                    51.8795563
                ],
                [
                    113.1350019,
                    51.8797153
                ],
                [
                    113.1333711,
                    51.8854372
                ]
            ],
            "longitude": 113.157509,
            "latitude": 51.896191
        },
        "1664": {
            "name": "Колочное 1-е",
            "population": 52,
            "type": "village",
            "poly": [
                [
                    113.1584693,
                    51.9617782
                ],
                [
                    113.1591503,
                    51.9635064
                ],
                [
                    113.159028,
                    51.9651318
                ],
                [
                    113.1614974,
                    51.9661676
                ],
                [
                    113.1656818,
                    51.9640811
                ],
                [
                    113.1678991,
                    51.9612031
                ],
                [
                    113.1674678,
                    51.9595475
                ],
                [
                    113.1649045,
                    51.958494
                ],
                [
                    113.1636794,
                    51.9593377
                ],
                [
                    113.161363,
                    51.9585602
                ],
                [
                    113.1584693,
                    51.9617782
                ]
            ],
            "longitude": 113.1633578,
            "latitude": 51.9622539
        },
        "1665": {
            "name": "Амодово",
            "population": 73,
            "type": "village",
            "poly": [
                [
                    113.1934097,
                    51.877119
                ],
                [
                    113.1986883,
                    51.8799537
                ],
                [
                    113.2087734,
                    51.8729327
                ],
                [
                    113.2026365,
                    51.8691436
                ],
                [
                    113.1934097,
                    51.877119
                ]
            ],
            "longitude": 113.2024554,
            "latitude": 51.8753606
        },
        "1666": {
            "name": "Урейск",
            "population": 1046,
            "type": "village",
            "poly": [
                [
                    113.1943037,
                    50.297717
                ],
                [
                    113.1948002,
                    50.2996834
                ],
                [
                    113.1962036,
                    50.3052415
                ],
                [
                    113.1958034,
                    50.3063433
                ],
                [
                    113.2005965,
                    50.3062881
                ],
                [
                    113.2038707,
                    50.3045394
                ],
                [
                    113.2082882,
                    50.303947
                ],
                [
                    113.2118236,
                    50.3019304
                ],
                [
                    113.2142849,
                    50.3022338
                ],
                [
                    113.2173508,
                    50.3017098
                ],
                [
                    113.219078,
                    50.3037508
                ],
                [
                    113.2226621,
                    50.303144
                ],
                [
                    113.2261053,
                    50.3009004
                ],
                [
                    113.2284915,
                    50.3008547
                ],
                [
                    113.2298301,
                    50.300441
                ],
                [
                    113.2320699,
                    50.2982058
                ],
                [
                    113.2380523,
                    50.2965578
                ],
                [
                    113.2402268,
                    50.2959587
                ],
                [
                    113.2433459,
                    50.2950621
                ],
                [
                    113.2420504,
                    50.2941794
                ],
                [
                    113.2391584,
                    50.2933309
                ],
                [
                    113.2339755,
                    50.2931863
                ],
                [
                    113.2184652,
                    50.2965639
                ],
                [
                    113.2051737,
                    50.2957242
                ],
                [
                    113.2064691,
                    50.2973241
                ],
                [
                    113.1943037,
                    50.297717
                ]
            ],
            "longitude": 113.221527,
            "latitude": 50.298187
        },
        "1667": {
            "name": "Сивяково",
            "population": 666,
            "type": "village",
            "poly": [
                [
                    113.2252529,
                    51.8921384
                ],
                [
                    113.2256391,
                    51.9012748
                ],
                [
                    113.2369688,
                    51.8983355
                ],
                [
                    113.2418611,
                    51.8947074
                ],
                [
                    113.239415,
                    51.8891455
                ],
                [
                    113.2334068,
                    51.8908142
                ],
                [
                    113.2305744,
                    51.8871855
                ],
                [
                    113.2257571,
                    51.8884398
                ],
                [
                    113.2252529,
                    51.8921384
                ]
            ],
            "longitude": 113.2317888,
            "latitude": 51.8946568
        },
        "1668": {
            "name": "Дворцы",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.256323,
            "latitude": 52.0503956
        },
        "1669": {
            "name": "Рудник Кадала",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.2496948,
                    52.0415591
                ],
                [
                    113.2561597,
                    52.0486632
                ],
                [
                    113.2578041,
                    52.0482168
                ],
                [
                    113.2594054,
                    52.0465759
                ],
                [
                    113.2627306,
                    52.0472367
                ],
                [
                    113.2661713,
                    52.0456922
                ],
                [
                    113.268342,
                    52.0448657
                ],
                [
                    113.2825972,
                    52.042132
                ],
                [
                    113.287739,
                    52.0410087
                ],
                [
                    113.2893026,
                    52.0402119
                ],
                [
                    113.2884087,
                    52.0393224
                ],
                [
                    113.2883301,
                    52.0341545
                ],
                [
                    113.2889335,
                    52.0311514
                ],
                [
                    113.2852277,
                    52.0311861
                ],
                [
                    113.2822979,
                    52.0313277
                ],
                [
                    113.2810632,
                    52.0313147
                ],
                [
                    113.2804089,
                    52.0308348
                ],
                [
                    113.280268,
                    52.0318427
                ],
                [
                    113.2788658,
                    52.0317526
                ],
                [
                    113.278824,
                    52.032744
                ],
                [
                    113.2772544,
                    52.0337868
                ],
                [
                    113.275371,
                    52.0335422
                ],
                [
                    113.2712662,
                    52.0351779
                ],
                [
                    113.2663768,
                    52.0366023
                ],
                [
                    113.2632957,
                    52.0372095
                ],
                [
                    113.2567168,
                    52.0385652
                ],
                [
                    113.2496948,
                    52.0415591
                ]
            ],
            "longitude": 113.2677883,
            "latitude": 52.0395354
        },
        "1670": {
            "name": "Восточный",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.2571368,
                    51.9845667
                ],
                [
                    113.2617717,
                    51.9932878
                ],
                [
                    113.2670074,
                    51.9956132
                ],
                [
                    113.273273,
                    51.9970929
                ],
                [
                    113.2795386,
                    51.996036
                ],
                [
                    113.2830577,
                    51.9946619
                ],
                [
                    113.282886,
                    51.9927593
                ],
                [
                    113.2870044,
                    51.9912377
                ],
                [
                    113.2876518,
                    51.9916247
                ],
                [
                    113.2924369,
                    51.989907
                ],
                [
                    113.2907846,
                    51.9892859
                ],
                [
                    113.2884243,
                    51.9896955
                ],
                [
                    113.2877698,
                    51.9893586
                ],
                [
                    113.2833152,
                    51.9881082
                ],
                [
                    113.2808497,
                    51.9851762
                ],
                [
                    113.2792618,
                    51.9850441
                ],
                [
                    113.2763436,
                    51.9819252
                ],
                [
                    113.2741549,
                    51.9821102
                ],
                [
                    113.2701209,
                    51.9809208
                ],
                [
                    113.2571368,
                    51.9845667
                ]
            ],
            "longitude": 113.2706377,
            "latitude": 51.9870516
        },
        "1671": {
            "name": "Улача",
            "population": 391,
            "type": "village",
            "poly": [
                [
                    113.2713467,
                    50.4006088
                ],
                [
                    113.2716128,
                    50.4020585
                ],
                [
                    113.2753893,
                    50.4035903
                ],
                [
                    113.278043,
                    50.4036349
                ],
                [
                    113.2819124,
                    50.4036998
                ],
                [
                    113.2855173,
                    50.4026056
                ],
                [
                    113.2853457,
                    50.4009644
                ],
                [
                    113.2840496,
                    50.3991862
                ],
                [
                    113.2807881,
                    50.398092
                ],
                [
                    113.276076,
                    50.3974628
                ],
                [
                    113.2735783,
                    50.3986392
                ],
                [
                    113.2713467,
                    50.4006088
                ]
            ],
            "longitude": 113.2740812,
            "latitude": 50.4010227
        },
        "1672": {
            "name": "Ара-Иля",
            "population": 349,
            "type": "village",
            "poly": null,
            "longitude": 113.2768426,
            "latitude": 50.9407101
        },
        "1673": {
            "name": "Застепь",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.272846,
                    52.0986682
                ],
                [
                    113.2791546,
                    52.1032552
                ],
                [
                    113.2848194,
                    52.1004872
                ],
                [
                    113.287051,
                    52.1015944
                ],
                [
                    113.2958486,
                    52.0970073
                ],
                [
                    113.2885101,
                    52.0922352
                ],
                [
                    113.2916429,
                    52.0895457
                ],
                [
                    113.2884243,
                    52.0876471
                ],
                [
                    113.2850769,
                    52.0897039
                ],
                [
                    113.2870081,
                    52.0911541
                ],
                [
                    113.272846,
                    52.0986682
                ]
            ],
            "longitude": 113.2837917,
            "latitude": 52.0973495
        },
        "1674": {
            "name": "Акша",
            "population": 4178,
            "type": "village",
            "poly": [
                [
                    113.2491783,
                    50.2547618
                ],
                [
                    113.2587535,
                    50.2615504
                ],
                [
                    113.2650559,
                    50.265392
                ],
                [
                    113.271357,
                    50.2706024
                ],
                [
                    113.2744358,
                    50.2706805
                ],
                [
                    113.2746075,
                    50.2716731
                ],
                [
                    113.2727822,
                    50.2735429
                ],
                [
                    113.2705021,
                    50.2746938
                ],
                [
                    113.2728346,
                    50.2769679
                ],
                [
                    113.2743385,
                    50.2782145
                ],
                [
                    113.2758888,
                    50.278614
                ],
                [
                    113.2771046,
                    50.2798184
                ],
                [
                    113.2781913,
                    50.2822251
                ],
                [
                    113.2846713,
                    50.2909719
                ],
                [
                    113.2878597,
                    50.2930674
                ],
                [
                    113.2913553,
                    50.2941959
                ],
                [
                    113.2926105,
                    50.292684
                ],
                [
                    113.2952109,
                    50.293307
                ],
                [
                    113.2984221,
                    50.2963151
                ],
                [
                    113.3006868,
                    50.2955752
                ],
                [
                    113.2997367,
                    50.2946008
                ],
                [
                    113.3010869,
                    50.2950321
                ],
                [
                    113.3030872,
                    50.2966614
                ],
                [
                    113.3047961,
                    50.2961989
                ],
                [
                    113.3047875,
                    50.2954155
                ],
                [
                    113.3039124,
                    50.2939938
                ],
                [
                    113.3021371,
                    50.2930194
                ],
                [
                    113.308235,
                    50.2905402
                ],
                [
                    113.3072629,
                    50.2893292
                ],
                [
                    113.3044487,
                    50.2887775
                ],
                [
                    113.3026122,
                    50.2865335
                ],
                [
                    113.3001367,
                    50.2877477
                ],
                [
                    113.298499,
                    50.2855445
                ],
                [
                    113.2988365,
                    50.2849837
                ],
                [
                    113.2971863,
                    50.2827948
                ],
                [
                    113.2969612,
                    50.2805739
                ],
                [
                    113.2962202,
                    50.2790513
                ],
                [
                    113.2948609,
                    50.2781931
                ],
                [
                    113.2923104,
                    50.277474
                ],
                [
                    113.2922854,
                    50.2769946
                ],
                [
                    113.2974863,
                    50.2749332
                ],
                [
                    113.3022371,
                    50.2736228
                ],
                [
                    113.301962,
                    50.272664
                ],
                [
                    113.2951609,
                    50.2733511
                ],
                [
                    113.2931356,
                    50.2744378
                ],
                [
                    113.2918104,
                    50.2762276
                ],
                [
                    113.2901101,
                    50.2744059
                ],
                [
                    113.2884848,
                    50.2747095
                ],
                [
                    113.2858844,
                    50.2725041
                ],
                [
                    113.2878097,
                    50.2714174
                ],
                [
                    113.2873596,
                    50.270938
                ],
                [
                    113.2851092,
                    50.271817
                ],
                [
                    113.284096,
                    50.2709371
                ],
                [
                    113.2846842,
                    50.2702827
                ],
                [
                    113.2830089,
                    50.2688283
                ],
                [
                    113.283534,
                    50.2681411
                ],
                [
                    113.2829589,
                    50.2674379
                ],
                [
                    113.2821338,
                    50.2679333
                ],
                [
                    113.2790582,
                    50.2655519
                ],
                [
                    113.2769829,
                    50.2627867
                ],
                [
                    113.2737582,
                    50.2608993
                ],
                [
                    113.2737824,
                    50.2582309
                ],
                [
                    113.2729572,
                    50.2581988
                ],
                [
                    113.2719821,
                    50.2560887
                ],
                [
                    113.2722071,
                    50.2541383
                ],
                [
                    113.2696567,
                    50.2517402
                ],
                [
                    113.2670812,
                    50.2528114
                ],
                [
                    113.2692316,
                    50.2554173
                ],
                [
                    113.2705318,
                    50.2597016
                ],
                [
                    113.2697317,
                    50.2596216
                ],
                [
                    113.2660061,
                    50.2562007
                ],
                [
                    113.2617554,
                    50.2551775
                ],
                [
                    113.2581298,
                    50.2534988
                ],
                [
                    113.2524038,
                    50.2516922
                ],
                [
                    113.2491783,
                    50.2547618
                ]
            ],
            "longitude": 113.285149,
            "latitude": 50.280815
        },
        "1675": {
            "name": "Аэропорт",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.2812523,
                    52.0273521
                ],
                [
                    113.2830119,
                    52.0309695
                ],
                [
                    113.3261938,
                    52.0256521
                ],
                [
                    113.3259636,
                    52.0248964
                ],
                [
                    113.331413,
                    52.0238102
                ],
                [
                    113.3300042,
                    52.0217275
                ],
                [
                    113.3247256,
                    52.0220708
                ],
                [
                    113.3227515,
                    52.0217011
                ],
                [
                    113.3208632,
                    52.0198524
                ],
                [
                    113.3105363,
                    52.0212125
                ],
                [
                    113.3094477,
                    52.0189809
                ],
                [
                    113.3094077,
                    52.0174076
                ],
                [
                    113.3125802,
                    52.0168514
                ],
                [
                    113.3134278,
                    52.0154681
                ],
                [
                    113.3131113,
                    52.0140088
                ],
                [
                    113.3104377,
                    52.0143967
                ],
                [
                    113.3048179,
                    52.0178715
                ],
                [
                    113.2969859,
                    52.0191524
                ],
                [
                    113.2898451,
                    52.0208632
                ],
                [
                    113.2867822,
                    52.0228583
                ],
                [
                    113.286436,
                    52.0249437
                ],
                [
                    113.2859755,
                    52.0260299
                ],
                [
                    113.2812523,
                    52.0273521
                ]
            ],
            "longitude": 113.3030049,
            "latitude": 52.0192183
        },
        "1676": {
            "name": "Кадала",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.3201366,
                    52.0191507
                ],
                [
                    113.3227544,
                    52.0220821
                ],
                [
                    113.3315091,
                    52.0219765
                ],
                [
                    113.3318095,
                    52.0211843
                ],
                [
                    113.3382039,
                    52.0209994
                ],
                [
                    113.3384614,
                    52.0219237
                ],
                [
                    113.3453708,
                    52.0213954
                ],
                [
                    113.3454566,
                    52.0182528
                ],
                [
                    113.3281853,
                    52.0161019
                ],
                [
                    113.3255097,
                    52.0162374
                ],
                [
                    113.3228402,
                    52.016668
                ],
                [
                    113.3201366,
                    52.0191507
                ]
            ],
            "longitude": 113.332902,
            "latitude": 52.0186843
        },
        "1677": {
            "name": "Ерёмино",
            "population": 336,
            "type": "village",
            "poly": [
                [
                    113.3317811,
                    51.9612454
                ],
                [
                    113.3329923,
                    51.9621143
                ],
                [
                    113.3342577,
                    51.9614348
                ],
                [
                    113.3352701,
                    51.9619249
                ],
                [
                    113.3389398,
                    51.9608222
                ],
                [
                    113.3413803,
                    51.9618915
                ],
                [
                    113.3439834,
                    51.9601761
                ],
                [
                    113.3436038,
                    51.9583046
                ],
                [
                    113.342248,
                    51.9565444
                ],
                [
                    113.3409826,
                    51.9558092
                ],
                [
                    113.3378551,
                    51.9552633
                ],
                [
                    113.3345771,
                    51.9570803
                ],
                [
                    113.3342577,
                    51.9572574
                ],
                [
                    113.3348723,
                    51.957703
                ],
                [
                    113.3334442,
                    51.958494
                ],
                [
                    113.3347096,
                    51.9594966
                ],
                [
                    113.3317811,
                    51.9612454
                ]
            ],
            "longitude": 113.3365349,
            "latitude": 51.9600304
        },
        "1678": {
            "name": "Кадала",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.3151584,
                    52.0120458
                ],
                [
                    113.3167892,
                    52.0142646
                ],
                [
                    113.3557134,
                    52.0188338
                ],
                [
                    113.3615499,
                    52.0159286
                ],
                [
                    113.3730512,
                    52.0099855
                ],
                [
                    113.373652,
                    52.0083477
                ],
                [
                    113.3689313,
                    52.0081891
                ],
                [
                    113.3645969,
                    52.0102497
                ],
                [
                    113.3527951,
                    52.0035661
                ],
                [
                    113.3555846,
                    52.0004485
                ],
                [
                    113.350349,
                    51.999286
                ],
                [
                    113.3469157,
                    52.0024301
                ],
                [
                    113.3425813,
                    52.0040945
                ],
                [
                    113.3340411,
                    52.0012147
                ],
                [
                    113.3309083,
                    51.9987047
                ],
                [
                    113.3261876,
                    51.9981234
                ],
                [
                    113.3237844,
                    51.9999465
                ],
                [
                    113.3231835,
                    52.0005806
                ],
                [
                    113.3274751,
                    52.0027207
                ],
                [
                    113.3287196,
                    52.0039624
                ],
                [
                    113.3288913,
                    52.0066306
                ],
                [
                    113.328548,
                    52.008427
                ],
                [
                    113.3264451,
                    52.0089025
                ],
                [
                    113.317905,
                    52.0106723
                ],
                [
                    113.3151584,
                    52.0120458
                ]
            ],
            "longitude": 113.3459287,
            "latitude": 52.0097742
        },
        "1679": {
            "name": "Тохтор",
            "population": 431,
            "type": "village",
            "poly": null,
            "longitude": 113.3532467,
            "latitude": 50.0807623
        },
        "1680": {
            "name": "Энергетиков",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.3252006,
                    52.0684838
                ],
                [
                    113.3288913,
                    52.0722298
                ],
                [
                    113.3377318,
                    52.0696973
                ],
                [
                    113.3476024,
                    52.0795624
                ],
                [
                    113.3534389,
                    52.0777162
                ],
                [
                    113.3512931,
                    52.0756061
                ],
                [
                    113.3572154,
                    52.0717549
                ],
                [
                    113.3609996,
                    52.0716725
                ],
                [
                    113.3653662,
                    52.070724
                ],
                [
                    113.3675646,
                    52.0688624
                ],
                [
                    113.3696122,
                    52.0663721
                ],
                [
                    113.3659701,
                    52.0648959
                ],
                [
                    113.3618503,
                    52.0647904
                ],
                [
                    113.3612495,
                    52.0618354
                ],
                [
                    113.369575,
                    52.0544998
                ],
                [
                    113.3525806,
                    52.0495911
                ],
                [
                    113.34374,
                    52.0549747
                ],
                [
                    113.3421092,
                    52.0582996
                ],
                [
                    113.3445125,
                    52.0610438
                ],
                [
                    113.3252006,
                    52.0684838
                ]
            ],
            "longitude": 113.3534389,
            "latitude": 52.0646848
        },
        "1681": {
            "name": "Текстильщиков",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.3633952,
                    52.0816723
                ],
                [
                    113.3635669,
                    52.084415
                ],
                [
                    113.3783298,
                    52.0878432
                ],
                [
                    113.3782439,
                    52.0899
                ],
                [
                    113.3830505,
                    52.0901109
                ],
                [
                    113.3954959,
                    52.0871048
                ],
                [
                    113.3960967,
                    52.0839404
                ],
                [
                    113.4052806,
                    52.0787712
                ],
                [
                    113.4062247,
                    52.0768194
                ],
                [
                    113.4174686,
                    52.0759226
                ],
                [
                    113.4179835,
                    52.0710691
                ],
                [
                    113.420614,
                    52.0700618
                ],
                [
                    113.4232192,
                    52.0690642
                ],
                [
                    113.4271674,
                    52.0640516
                ],
                [
                    113.4264956,
                    52.0637905
                ],
                [
                    113.4180694,
                    52.0605161
                ],
                [
                    113.4214168,
                    52.0576664
                ],
                [
                    113.4171252,
                    52.0557664
                ],
                [
                    113.4124045,
                    52.0581941
                ],
                [
                    113.3966117,
                    52.059144
                ],
                [
                    113.3835654,
                    52.0663205
                ],
                [
                    113.387857,
                    52.0688004
                ],
                [
                    113.3840804,
                    52.0710691
                ],
                [
                    113.3791022,
                    52.0694863
                ],
                [
                    113.371635,
                    52.0706998
                ],
                [
                    113.366571,
                    52.0769249
                ],
                [
                    113.3633952,
                    52.0816723
                ]
            ],
            "longitude": 113.3885621,
            "latitude": 52.070444
        },
        "1682": {
            "name": "Оленгуй",
            "population": 271,
            "type": "village",
            "poly": [
                [
                    113.402426,
                    51.3027302
                ],
                [
                    113.4123702,
                    51.3088703
                ],
                [
                    113.4162988,
                    51.3142422
                ],
                [
                    113.4226779,
                    51.3145466
                ],
                [
                    113.4280547,
                    51.3118991
                ],
                [
                    113.4224373,
                    51.3075655
                ],
                [
                    113.4224373,
                    51.3058004
                ],
                [
                    113.4210868,
                    51.3048026
                ],
                [
                    113.4159305,
                    51.3050329
                ],
                [
                    113.414089,
                    51.3042653
                ],
                [
                    113.4132296,
                    51.3027302
                ],
                [
                    113.4134751,
                    51.3013486
                ],
                [
                    113.4048813,
                    51.3011184
                ],
                [
                    113.402426,
                    51.3027302
                ]
            ],
            "longitude": 113.412376,
            "latitude": 51.30574
        },
        "1683": {
            "name": "Угдан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.4128899,
            "latitude": 52.1058278
        },
        "1684": {
            "name": "Засопка",
            "population": 3271,
            "type": "village",
            "poly": [
                [
                    113.3925653,
                    52.0179132
                ],
                [
                    113.3999038,
                    52.0204618
                ],
                [
                    113.3965993,
                    52.023974
                ],
                [
                    113.4117362,
                    52.027083
                ],
                [
                    113.4149977,
                    52.0228579
                ],
                [
                    113.4064147,
                    52.0208773
                ],
                [
                    113.4223792,
                    52.0132973
                ],
                [
                    113.4332276,
                    52.0086024
                ],
                [
                    113.4334851,
                    52.0063042
                ],
                [
                    113.4254261,
                    52.0053725
                ],
                [
                    113.413229,
                    52.0068721
                ],
                [
                    113.4094886,
                    52.0086168
                ],
                [
                    113.4076286,
                    52.0123798
                ],
                [
                    113.4009832,
                    52.0126228
                ],
                [
                    113.3951617,
                    52.0153644
                ],
                [
                    113.3925653,
                    52.0179132
                ]
            ],
            "longitude": 113.41585,
            "latitude": 52.0106333
        },
        "1685": {
            "name": "Верх-Нарым",
            "population": 344,
            "type": "village",
            "poly": [
                [
                    113.4235088,
                    51.58362
                ],
                [
                    113.4244684,
                    51.5844648
                ],
                [
                    113.4448606,
                    51.5866262
                ],
                [
                    113.4498187,
                    51.5847878
                ],
                [
                    113.4512582,
                    51.5822784
                ],
                [
                    113.4597349,
                    51.5811354
                ],
                [
                    113.4588553,
                    51.5765634
                ],
                [
                    113.4258679,
                    51.5817318
                ],
                [
                    113.4235088,
                    51.58362
                ]
            ],
            "longitude": 113.4418618,
            "latitude": 51.5824026
        },
        "1686": {
            "name": "Биофабрика",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.4292172,
                    52.1165044
                ],
                [
                    113.4388273,
                    52.1169192
                ],
                [
                    113.4354079,
                    52.1219237
                ],
                [
                    113.4354564,
                    52.125244
                ],
                [
                    113.4346777,
                    52.1272076
                ],
                [
                    113.4396926,
                    52.1305721
                ],
                [
                    113.4396801,
                    52.1326842
                ],
                [
                    113.4380348,
                    52.1328348
                ],
                [
                    113.4384407,
                    52.1370846
                ],
                [
                    113.4470665,
                    52.1405008
                ],
                [
                    113.449823,
                    52.1398896
                ],
                [
                    113.4597341,
                    52.1377937
                ],
                [
                    113.4627824,
                    52.1369392
                ],
                [
                    113.4627367,
                    52.1360523
                ],
                [
                    113.4587176,
                    52.1321837
                ],
                [
                    113.4543268,
                    52.1309504
                ],
                [
                    113.4527075,
                    52.129803
                ],
                [
                    113.4512264,
                    52.1285963
                ],
                [
                    113.4509844,
                    52.1264359
                ],
                [
                    113.4468711,
                    52.1238458
                ],
                [
                    113.4456886,
                    52.122967
                ],
                [
                    113.4449998,
                    52.1209557
                ],
                [
                    113.4465168,
                    52.1198548
                ],
                [
                    113.4475271,
                    52.1186267
                ],
                [
                    113.4476698,
                    52.1174637
                ],
                [
                    113.4475298,
                    52.1157836
                ],
                [
                    113.4506705,
                    52.1160243
                ],
                [
                    113.4510706,
                    52.1146808
                ],
                [
                    113.4503027,
                    52.1139001
                ],
                [
                    113.4482904,
                    52.1133162
                ],
                [
                    113.4468169,
                    52.1126981
                ],
                [
                    113.4458396,
                    52.1118215
                ],
                [
                    113.4445054,
                    52.1108139
                ],
                [
                    113.4430065,
                    52.1107154
                ],
                [
                    113.4432716,
                    52.1125073
                ],
                [
                    113.4326029,
                    52.1097925
                ],
                [
                    113.4297193,
                    52.1115089
                ],
                [
                    113.4292172,
                    52.1165044
                ]
            ],
            "longitude": 113.4430672,
            "latitude": 52.1221157
        },
        "1687": {
            "name": "Заречный",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.4340561,
                    52.1072491
                ],
                [
                    113.4342399,
                    52.1100719
                ],
                [
                    113.4427651,
                    52.1096097
                ],
                [
                    113.4438715,
                    52.1095489
                ],
                [
                    113.4443921,
                    52.1093819
                ],
                [
                    113.4455902,
                    52.1086507
                ],
                [
                    113.446327,
                    52.1077879
                ],
                [
                    113.4458063,
                    52.1072391
                ],
                [
                    113.4477645,
                    52.1069623
                ],
                [
                    113.4480493,
                    52.1080013
                ],
                [
                    113.4467233,
                    52.1080886
                ],
                [
                    113.4472065,
                    52.1094966
                ],
                [
                    113.4477426,
                    52.1095073
                ],
                [
                    113.4493869,
                    52.1094612
                ],
                [
                    113.4515302,
                    52.1092214
                ],
                [
                    113.4523279,
                    52.1092362
                ],
                [
                    113.4528504,
                    52.1092089
                ],
                [
                    113.4533221,
                    52.1091603
                ],
                [
                    113.4540278,
                    52.1088453
                ],
                [
                    113.4548784,
                    52.1084755
                ],
                [
                    113.454894,
                    52.1082237
                ],
                [
                    113.4558452,
                    52.1081154
                ],
                [
                    113.4560562,
                    52.1079401
                ],
                [
                    113.4562207,
                    52.1079308
                ],
                [
                    113.4564224,
                    52.1068039
                ],
                [
                    113.4561629,
                    52.1057195
                ],
                [
                    113.4547098,
                    52.1059343
                ],
                [
                    113.4548476,
                    52.1050552
                ],
                [
                    113.4517633,
                    52.1051594
                ],
                [
                    113.4511336,
                    52.1052251
                ],
                [
                    113.4493855,
                    52.1054076
                ],
                [
                    113.4491448,
                    52.1036882
                ],
                [
                    113.4474505,
                    52.1037739
                ],
                [
                    113.4470558,
                    52.1035739
                ],
                [
                    113.4474748,
                    52.1033041
                ],
                [
                    113.4471105,
                    52.1030888
                ],
                [
                    113.4479968,
                    52.1020288
                ],
                [
                    113.4480516,
                    52.1015978
                ],
                [
                    113.4451836,
                    52.1008696
                ],
                [
                    113.4442694,
                    52.1007833
                ],
                [
                    113.4440144,
                    52.0991723
                ],
                [
                    113.44279,
                    52.0991197
                ],
                [
                    113.4421811,
                    52.1000597
                ],
                [
                    113.4345255,
                    52.1024808
                ],
                [
                    113.434903,
                    52.1066825
                ],
                [
                    113.4350028,
                    52.1072224
                ],
                [
                    113.4340561,
                    52.1072491
                ]
            ],
            "longitude": 113.447585,
            "latitude": 52.1056119
        },
        "1688": {
            "name": "Сыпчегур",
            "population": 284,
            "type": "village",
            "poly": [
                [
                    113.439584,
                    51.3539456
                ],
                [
                    113.4415038,
                    51.3557382
                ],
                [
                    113.4422964,
                    51.3564784
                ],
                [
                    113.4476697,
                    51.3550265
                ],
                [
                    113.4509762,
                    51.3565913
                ],
                [
                    113.4571503,
                    51.3561235
                ],
                [
                    113.4583128,
                    51.3556072
                ],
                [
                    113.4543087,
                    51.3531389
                ],
                [
                    113.4494521,
                    51.3509608
                ],
                [
                    113.4474888,
                    51.3508964
                ],
                [
                    113.4448797,
                    51.3512836
                ],
                [
                    113.439584,
                    51.3539456
                ]
            ],
            "longitude": 113.4492923,
            "latitude": 51.353262
        },
        "1689": {
            "name": "Угдан",
            "population": 1331,
            "type": "village",
            "poly": [
                [
                    113.4436426,
                    52.152287
                ],
                [
                    113.4581943,
                    52.1621301
                ],
                [
                    113.4916818,
                    52.1550342
                ],
                [
                    113.4795943,
                    52.1337752
                ],
                [
                    113.4533427,
                    52.140377
                ],
                [
                    113.4451637,
                    52.1412676
                ],
                [
                    113.4436426,
                    52.152287
                ]
            ],
            "longitude": 113.4553691,
            "latitude": 52.1561655
        },
        "1690": {
            "name": "Новокургатай",
            "population": 748,
            "type": "village",
            "poly": [
                [
                    113.4354916,
                    50.3069784
                ],
                [
                    113.4534302,
                    50.3104866
                ],
                [
                    113.4644165,
                    50.3142686
                ],
                [
                    113.4637299,
                    50.3170638
                ],
                [
                    113.4685364,
                    50.3211741
                ],
                [
                    113.4722271,
                    50.3184887
                ],
                [
                    113.4764328,
                    50.3196944
                ],
                [
                    113.481926,
                    50.317557
                ],
                [
                    113.4684506,
                    50.3128983
                ],
                [
                    113.4551468,
                    50.3080199
                ],
                [
                    113.4360924,
                    50.304676
                ],
                [
                    113.4354916,
                    50.3069784
                ]
            ],
            "longitude": 113.4569989,
            "latitude": 50.3108561
        },
        "1691": {
            "name": "Алханай",
            "population": 1225,
            "type": "village",
            "poly": [
                [
                    113.4544667,
                    50.7321408
                ],
                [
                    113.4649683,
                    50.7376587
                ],
                [
                    113.4647702,
                    50.7434895
                ],
                [
                    113.473439,
                    50.744085
                ],
                [
                    113.4839901,
                    50.7348685
                ],
                [
                    113.4786402,
                    50.7298833
                ],
                [
                    113.4868632,
                    50.7186568
                ],
                [
                    113.4767083,
                    50.7148931
                ],
                [
                    113.4606091,
                    50.7278765
                ],
                [
                    113.4544667,
                    50.7321408
                ]
            ],
            "longitude": 113.472755,
            "latitude": 50.730034
        },
        "1692": {
            "name": "Каштак",
            "population": null,
            "type": "village",
            "poly": [
                [
                    113.4732794,
                    52.1048206
                ],
                [
                    113.4776937,
                    52.1078396
                ],
                [
                    113.4802122,
                    52.1083968
                ],
                [
                    113.4802258,
                    52.1087793
                ],
                [
                    113.4826631,
                    52.1086712
                ],
                [
                    113.4830522,
                    52.1072984
                ],
                [
                    113.4845915,
                    52.1076329
                ],
                [
                    113.4847167,
                    52.1075944
                ],
                [
                    113.4846308,
                    52.1065665
                ],
                [
                    113.4843304,
                    52.0978146
                ],
                [
                    113.4933222,
                    52.0982434
                ],
                [
                    113.4937289,
                    52.0982628
                ],
                [
                    113.4966471,
                    52.0840507
                ],
                [
                    113.4812834,
                    52.083075
                ],
                [
                    113.4810329,
                    52.0836259
                ],
                [
                    113.4811489,
                    52.0851565
                ],
                [
                    113.4815409,
                    52.0907223
                ],
                [
                    113.4767773,
                    52.0911969
                ],
                [
                    113.4755328,
                    52.0947827
                ],
                [
                    113.4743741,
                    52.0968655
                ],
                [
                    113.4779656,
                    52.1018964
                ],
                [
                    113.4732794,
                    52.1048206
                ]
            ],
            "longitude": 113.4853208,
            "latitude": 52.0905951
        },
        "1693": {
            "name": "Береговой",
            "population": 335,
            "type": "village",
            "poly": [
                [
                    113.4854549,
                    52.1944521
                ],
                [
                    113.4869999,
                    52.1978455
                ],
                [
                    113.4863991,
                    52.199713
                ],
                [
                    113.4896606,
                    52.2030797
                ],
                [
                    113.4938663,
                    52.201791
                ],
                [
                    113.4932655,
                    52.1990555
                ],
                [
                    113.4908623,
                    52.1977402
                ],
                [
                    113.4892315,
                    52.1945047
                ],
                [
                    113.4928793,
                    52.1940838
                ],
                [
                    113.4913343,
                    52.1930841
                ],
                [
                    113.4878582,
                    52.192558
                ],
                [
                    113.4854549,
                    52.1944521
                ]
            ],
            "longitude": 113.488892,
            "latitude": 52.197083
        },
        "1694": {
            "name": "Ясный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.4938275,
            "latitude": 52.1279608
        },
        "1695": {
            "name": "Верх-Чита",
            "population": 1714,
            "type": "village",
            "poly": [
                [
                    113.4898752,
                    52.2265869
                ],
                [
                    113.496055,
                    52.2304247
                ],
                [
                    113.4995312,
                    52.2306875
                ],
                [
                    113.5082001,
                    52.2371269
                ],
                [
                    113.5154528,
                    52.2409112
                ],
                [
                    113.514337,
                    52.2428558
                ],
                [
                    113.5217184,
                    52.2475067
                ],
                [
                    113.5270399,
                    52.244012
                ],
                [
                    113.5119337,
                    52.2315286
                ],
                [
                    113.514809,
                    52.2305561
                ],
                [
                    113.5143799,
                    52.2271915
                ],
                [
                    113.5053677,
                    52.2242735
                ],
                [
                    113.4957117,
                    52.216728
                ],
                [
                    113.4924072,
                    52.2182267
                ],
                [
                    113.4968704,
                    52.2216446
                ],
                [
                    113.4898752,
                    52.2265869
                ]
            ],
            "longitude": 113.50386,
            "latitude": 52.227592
        },
        "1696": {
            "name": "Смоленка",
            "population": 3758,
            "type": "village",
            "poly": [
                [
                    113.4801877,
                    52.1337382
                ],
                [
                    113.4949108,
                    52.1551302
                ],
                [
                    113.5263979,
                    52.1538808
                ],
                [
                    113.5572585,
                    52.1395576
                ],
                [
                    113.5539688,
                    52.1317692
                ],
                [
                    113.5326641,
                    52.1344617
                ],
                [
                    113.5183303,
                    52.1225849
                ],
                [
                    113.5072192,
                    52.1279204
                ],
                [
                    113.4801877,
                    52.1337382
                ]
            ],
            "longitude": 113.519203,
            "latitude": 52.140629
        },
        "1697": {
            "name": "Красноярово",
            "population": 201,
            "type": "village",
            "poly": null,
            "longitude": 113.5318872,
            "latitude": 50.9590673
        },
        "1698": {
            "name": "Карповка",
            "population": 518,
            "type": "village",
            "poly": [
                [
                    113.5289041,
                    52.2048903
                ],
                [
                    113.531994,
                    52.2063631
                ],
                [
                    113.5331956,
                    52.2085722
                ],
                [
                    113.5373155,
                    52.2107812
                ],
                [
                    113.5388604,
                    52.21015
                ],
                [
                    113.5349122,
                    52.2074151
                ],
                [
                    113.5326806,
                    52.2058371
                ],
                [
                    113.5307923,
                    52.2041539
                ],
                [
                    113.5294039,
                    52.2046954
                ],
                [
                    113.5289041,
                    52.2048903
                ]
            ],
            "longitude": 113.535004,
            "latitude": 52.207947
        },
        "1699": {
            "name": "Шишкино",
            "population": 1656,
            "type": "village",
            "poly": [
                [
                    113.5616887,
                    52.302517
                ],
                [
                    113.5708221,
                    52.3102096
                ],
                [
                    113.5636847,
                    52.3118367
                ],
                [
                    113.5728182,
                    52.3174572
                ],
                [
                    113.5782289,
                    52.319657
                ],
                [
                    113.5768707,
                    52.3219307
                ],
                [
                    113.577778,
                    52.3227442
                ],
                [
                    113.5876978,
                    52.3172353
                ],
                [
                    113.595749,
                    52.320924
                ],
                [
                    113.6010047,
                    52.3182706
                ],
                [
                    113.5996135,
                    52.3157933
                ],
                [
                    113.5934439,
                    52.3139075
                ],
                [
                    113.5924157,
                    52.3091002
                ],
                [
                    113.5907501,
                    52.3092387
                ],
                [
                    113.5861884,
                    52.3072559
                ],
                [
                    113.5846059,
                    52.3046408
                ],
                [
                    113.5832373,
                    52.3010839
                ],
                [
                    113.5798157,
                    52.2978668
                ],
                [
                    113.5764473,
                    52.2959698
                ],
                [
                    113.573562,
                    52.2971379
                ],
                [
                    113.5616887,
                    52.302517
                ]
            ],
            "longitude": 113.583679,
            "latitude": 52.308483
        },
        "1700": {
            "name": "Дульдурга",
            "population": 7241,
            "type": "village",
            "poly": [
                [
                    113.5584146,
                    50.6809591
                ],
                [
                    113.5593049,
                    50.6833566
                ],
                [
                    113.5805833,
                    50.6824258
                ],
                [
                    113.582453,
                    50.6834694
                ],
                [
                    113.5818743,
                    50.6920712
                ],
                [
                    113.5957185,
                    50.6917327
                ],
                [
                    113.6026184,
                    50.6864872
                ],
                [
                    113.6064467,
                    50.6793513
                ],
                [
                    113.6181543,
                    50.6744711
                ],
                [
                    113.6237632,
                    50.6681797
                ],
                [
                    113.6151272,
                    50.6677283
                ],
                [
                    113.6136582,
                    50.6643988
                ],
                [
                    113.6025294,
                    50.6651607
                ],
                [
                    113.6019062,
                    50.6612667
                ],
                [
                    113.6004372,
                    50.6608998
                ],
                [
                    113.5999475,
                    50.6585859
                ],
                [
                    113.5890412,
                    50.6577957
                ],
                [
                    113.5878393,
                    50.6606741
                ],
                [
                    113.5822749,
                    50.6585012
                ],
                [
                    113.5779124,
                    50.6632702
                ],
                [
                    113.5817407,
                    50.6654993
                ],
                [
                    113.5642462,
                    50.6758534
                ],
                [
                    113.5584146,
                    50.6809591
                ]
            ],
            "longitude": 113.589348,
            "latitude": 50.675007
        },
        "1701": {
            "name": "Бальзино",
            "population": 1037,
            "type": "village",
            "poly": null,
            "longitude": 113.5935158,
            "latitude": 51.0480485
        },
        "1702": {
            "name": "Иля",
            "population": 374,
            "type": "village",
            "poly": null,
            "longitude": 113.5948246,
            "latitude": 50.8371246
        },
        "1703": {
            "name": "Забайкальский",
            "population": 341,
            "type": "village",
            "poly": [
                [
                    113.5894859,
                    52.1443381
                ],
                [
                    113.5897985,
                    52.1453378
                ],
                [
                    113.5934745,
                    52.1463984
                ],
                [
                    113.6011993,
                    52.1462932
                ],
                [
                    113.6013227,
                    52.14478
                ],
                [
                    113.6010276,
                    52.1434489
                ],
                [
                    113.6013452,
                    52.1422517
                ],
                [
                    113.6030618,
                    52.14025
                ],
                [
                    113.6066667,
                    52.1404607
                ],
                [
                    113.6066142,
                    52.1389923
                ],
                [
                    113.6030093,
                    52.1388869
                ],
                [
                    113.6007777,
                    52.1376226
                ],
                [
                    113.5954562,
                    52.139203
                ],
                [
                    113.5915875,
                    52.142001
                ],
                [
                    113.5894859,
                    52.1443381
                ]
            ],
            "longitude": 113.598137,
            "latitude": 52.140156
        },
        "1704": {
            "name": "Елизаветино",
            "population": 868,
            "type": "village",
            "poly": [
                [
                    113.596202,
                    51.6634845
                ],
                [
                    113.5972115,
                    51.6646169
                ],
                [
                    113.6001496,
                    51.667912
                ],
                [
                    113.6062062,
                    51.6686331
                ],
                [
                    113.606971,
                    51.6677212
                ],
                [
                    113.6075631,
                    51.6670153
                ],
                [
                    113.6162915,
                    51.6566078
                ],
                [
                    113.616666,
                    51.6560414
                ],
                [
                    113.6175893,
                    51.6546453
                ],
                [
                    113.6073958,
                    51.6516593
                ],
                [
                    113.6022315,
                    51.6514412
                ],
                [
                    113.6021234,
                    51.6516366
                ],
                [
                    113.5974998,
                    51.659996
                ],
                [
                    113.596202,
                    51.6634845
                ]
            ],
            "longitude": 113.605797,
            "latitude": 51.658268
        },
        "1705": {
            "name": "Узон",
            "population": 1282,
            "type": "village",
            "poly": null,
            "longitude": 113.6067934,
            "latitude": 50.5783646
        },
        "1706": {
            "name": "Убур-Тохтор",
            "population": 278,
            "type": "village",
            "poly": [
                [
                    113.6173474,
                    50.1107334
                ],
                [
                    113.6199137,
                    50.112979
                ],
                [
                    113.6230036,
                    50.1130892
                ],
                [
                    113.6259744,
                    50.1116375
                ],
                [
                    113.630385,
                    50.1107774
                ],
                [
                    113.6321714,
                    50.1104045
                ],
                [
                    113.6333591,
                    50.1084497
                ],
                [
                    113.6341305,
                    50.1063847
                ],
                [
                    113.6347871,
                    50.1054324
                ],
                [
                    113.6357065,
                    50.1036212
                ],
                [
                    113.6370798,
                    50.1018595
                ],
                [
                    113.6348482,
                    50.1009787
                ],
                [
                    113.6333033,
                    50.1002079
                ],
                [
                    113.629604,
                    50.1015017
                ],
                [
                    113.6262952,
                    50.1029358
                ],
                [
                    113.62142,
                    50.1066104
                ],
                [
                    113.6173474,
                    50.1107334
                ]
            ],
            "longitude": 113.6278874,
            "latitude": 50.1075573
        },
        "1707": {
            "name": "Каланга",
            "population": 70,
            "type": "village",
            "poly": null,
            "longitude": 113.667686,
            "latitude": 51.1167452
        },
        "1708": {
            "name": "Усть-Иля",
            "population": 606,
            "type": "village",
            "poly": null,
            "longitude": 113.715806,
            "latitude": 50.3985636
        },
        "1709": {
            "name": "Орой",
            "population": 448,
            "type": "village",
            "poly": [
                [
                    113.7261721,
                    50.1638101
                ],
                [
                    113.7284037,
                    50.1645799
                ],
                [
                    113.730569,
                    50.165614
                ],
                [
                    113.7373301,
                    50.167219
                ],
                [
                    113.7380167,
                    50.1683185
                ],
                [
                    113.7373301,
                    50.1701877
                ],
                [
                    113.7447115,
                    50.1723866
                ],
                [
                    113.749029,
                    50.16982
                ],
                [
                    113.7522646,
                    50.1676588
                ],
                [
                    113.7436815,
                    50.1640301
                ],
                [
                    113.7332102,
                    50.1621606
                ],
                [
                    113.727285,
                    50.162849
                ],
                [
                    113.7261721,
                    50.1638101
                ]
            ],
            "longitude": 113.7430721,
            "latitude": 50.1697204
        },
        "1710": {
            "name": "Александровка",
            "population": 1004,
            "type": "village",
            "poly": [
                [
                    113.717167,
                    51.7723687
                ],
                [
                    113.7193741,
                    51.7737095
                ],
                [
                    113.7281626,
                    51.7726419
                ],
                [
                    113.7337407,
                    51.7709533
                ],
                [
                    113.7373925,
                    51.7742807
                ],
                [
                    113.7408437,
                    51.7739331
                ],
                [
                    113.7438133,
                    51.7718472
                ],
                [
                    113.7496322,
                    51.7702083
                ],
                [
                    113.7626744,
                    51.7674765
                ],
                [
                    113.7616712,
                    51.7643224
                ],
                [
                    113.7580193,
                    51.7626584
                ],
                [
                    113.74686,
                    51.757481
                ],
                [
                    113.7400282,
                    51.7599927
                ],
                [
                    113.7384359,
                    51.761344
                ],
                [
                    113.7377424,
                    51.7646821
                ],
                [
                    113.7398485,
                    51.7678451
                ],
                [
                    113.7396944,
                    51.7693232
                ],
                [
                    113.7259795,
                    51.7672411
                ],
                [
                    113.7175041,
                    51.7683855
                ],
                [
                    113.717167,
                    51.7723687
                ]
            ],
            "longitude": 113.7455332,
            "latitude": 51.765561
        },
        "1711": {
            "name": "Бургень",
            "population": 741,
            "type": "village",
            "poly": [
                [
                    113.7673658,
                    52.420138
                ],
                [
                    113.778953,
                    52.4267853
                ],
                [
                    113.7972349,
                    52.4232262
                ],
                [
                    113.7871069,
                    52.4141702
                ],
                [
                    113.7696833,
                    52.4131755
                ],
                [
                    113.7673658,
                    52.420138
                ]
            ],
            "longitude": 113.776291,
            "latitude": 52.420975
        },
        "1712": {
            "name": "Тыргетуй",
            "population": 864,
            "type": "village",
            "poly": null,
            "longitude": 113.79258,
            "latitude": 51.446392
        },
        "1713": {
            "name": "Таптанай",
            "population": 803,
            "type": "village",
            "poly": null,
            "longitude": 113.810265,
            "latitude": 50.776756
        },
        "1714": {
            "name": "Могойтуй",
            "population": 972,
            "type": "village",
            "poly": [
                [
                    113.8320872,
                    50.3550957
                ],
                [
                    113.8389536,
                    50.3629808
                ],
                [
                    113.8424641,
                    50.3613108
                ],
                [
                    113.8432451,
                    50.3586003
                ],
                [
                    113.8398119,
                    50.3538909
                ],
                [
                    113.8439318,
                    50.3511526
                ],
                [
                    113.8500172,
                    50.3477296
                ],
                [
                    113.8471934,
                    50.3430464
                ],
                [
                    113.8412625,
                    50.3394037
                ],
                [
                    113.835941,
                    50.3345828
                ],
                [
                    113.833652,
                    50.334127
                ],
                [
                    113.8326021,
                    50.3364728
                ],
                [
                    113.8338038,
                    50.3454565
                ],
                [
                    113.8341471,
                    50.3494
                ],
                [
                    113.8341471,
                    50.3529051
                ],
                [
                    113.8320872,
                    50.3550957
                ]
            ],
            "longitude": 113.8458973,
            "latitude": 50.3465246
        },
        "1715": {
            "name": "Новодоронинск",
            "population": 394,
            "type": "village",
            "poly": null,
            "longitude": 113.863693,
            "latitude": 51.534649
        },
        "1716": {
            "name": "Шара-Горохон",
            "population": 447,
            "type": "village",
            "poly": null,
            "longitude": 113.879233,
            "latitude": 51.4008853
        },
        "1717": {
            "name": "Чиндалей",
            "population": 1030,
            "type": "village",
            "poly": null,
            "longitude": 113.8978085,
            "latitude": 50.5733238
        },
        "1718": {
            "name": "Маккавеево",
            "population": 4690,
            "type": "village",
            "poly": [
                [
                    113.8984938,
                    51.7595866
                ],
                [
                    113.913085,
                    51.7667049
                ],
                [
                    113.9283629,
                    51.7623491
                ],
                [
                    113.9412375,
                    51.7663862
                ],
                [
                    113.9431257,
                    51.7718039
                ],
                [
                    113.9541121,
                    51.7726537
                ],
                [
                    113.9570303,
                    51.7629864
                ],
                [
                    113.9760847,
                    51.7512982
                ],
                [
                    113.9788313,
                    51.7453466
                ],
                [
                    113.9690466,
                    51.7417327
                ],
                [
                    113.9407225,
                    51.7495977
                ],
                [
                    113.9127417,
                    51.7506605
                ],
                [
                    113.8996954,
                    51.7528922
                ],
                [
                    113.8996425,
                    51.7531871
                ],
                [
                    113.8984938,
                    51.7595866
                ]
            ],
            "longitude": 113.960785,
            "latitude": 51.747688
        },
        "1719": {
            "name": "Танха",
            "population": 384,
            "type": "village",
            "poly": [
                [
                    113.96162,
                    51.9816874
                ],
                [
                    113.9635667,
                    51.9873109
                ],
                [
                    113.9664447,
                    51.9903945
                ],
                [
                    113.965982,
                    51.9909759
                ],
                [
                    113.9636169,
                    51.9939473
                ],
                [
                    113.9721095,
                    51.9996958
                ],
                [
                    113.9770877,
                    52.0013867
                ],
                [
                    113.9785658,
                    51.999902
                ],
                [
                    113.9796363,
                    51.9988149
                ],
                [
                    113.9803493,
                    51.9981105
                ],
                [
                    113.9794091,
                    51.9967144
                ],
                [
                    113.9788773,
                    51.9960742
                ],
                [
                    113.9779722,
                    51.994985
                ],
                [
                    113.9727534,
                    51.9887031
                ],
                [
                    113.9695013,
                    51.9891091
                ],
                [
                    113.9672745,
                    51.9890578
                ],
                [
                    113.9655995,
                    51.9877479
                ],
                [
                    113.9651303,
                    51.9869171
                ],
                [
                    113.9643073,
                    51.9854598
                ],
                [
                    113.9642327,
                    51.9832719
                ],
                [
                    113.9636737,
                    51.9820848
                ],
                [
                    113.9626061,
                    51.9815704
                ],
                [
                    113.96162,
                    51.9816874
                ]
            ],
            "longitude": 113.9695221,
            "latitude": 51.993883
        },
        "1720": {
            "name": "Жимбира",
            "population": 436,
            "type": "village",
            "poly": null,
            "longitude": 114.013763,
            "latitude": 51.517796
        },
        "1721": {
            "name": "Куранжа",
            "population": 140,
            "type": "village",
            "poly": null,
            "longitude": 114.038277,
            "latitude": 50.444984
        },
        "1722": {
            "name": "Большая Тура",
            "population": 1202,
            "type": "village",
            "poly": null,
            "longitude": 114.079239,
            "latitude": 51.633308
        },
        "1723": {
            "name": "Хойто-Ага",
            "population": 854,
            "type": "village",
            "poly": null,
            "longitude": 114.085152,
            "latitude": 51.094105
        },
        "1724": {
            "name": "Новотроицк",
            "population": 877,
            "type": "village",
            "poly": [
                [
                    114.0694998,
                    51.9864187
                ],
                [
                    114.0741059,
                    51.9866923
                ],
                [
                    114.0729314,
                    51.9877387
                ],
                [
                    114.0739985,
                    51.9913199
                ],
                [
                    114.0770396,
                    51.9940139
                ],
                [
                    114.0736783,
                    51.9978245
                ],
                [
                    114.0767188,
                    51.9995838
                ],
                [
                    114.0930083,
                    51.9985349
                ],
                [
                    114.0895242,
                    51.995952
                ],
                [
                    114.1042521,
                    51.9922422
                ],
                [
                    114.1033467,
                    51.989861
                ],
                [
                    114.1069893,
                    51.9889786
                ],
                [
                    114.0974035,
                    51.9730708
                ],
                [
                    114.0935644,
                    51.9712174
                ],
                [
                    114.0883549,
                    51.9729922
                ],
                [
                    114.0882736,
                    51.9747679
                ],
                [
                    114.0862364,
                    51.9758137
                ],
                [
                    114.0838219,
                    51.974675
                ],
                [
                    114.0827279,
                    51.9761855
                ],
                [
                    114.0834069,
                    51.9771848
                ],
                [
                    114.0798607,
                    51.9773939
                ],
                [
                    114.0776419,
                    51.9811171
                ],
                [
                    114.076169,
                    51.9811717
                ],
                [
                    114.0694998,
                    51.9864187
                ]
            ],
            "longitude": 114.089333,
            "latitude": 51.992844
        },
        "1725": {
            "name": "Солонцово",
            "population": 115,
            "type": "village",
            "poly": null,
            "longitude": 114.0931811,
            "latitude": 51.553308
        },
        "1726": {
            "name": "Токчин",
            "population": 1211,
            "type": "village",
            "poly": null,
            "longitude": 114.131912,
            "latitude": 50.513649
        },
        "1727": {
            "name": "Тут-Халтуй",
            "population": 483,
            "type": "village",
            "poly": null,
            "longitude": 114.1680564,
            "latitude": 50.4595465
        },
        "1728": {
            "name": "Ильинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 114.1754956,
            "latitude": 52.0661649
        },
        "1729": {
            "name": "Зуткулей",
            "population": 1800,
            "type": "village",
            "poly": null,
            "longitude": 114.187119,
            "latitude": 50.661808
        },
        "1730": {
            "name": "Сахюрта",
            "population": 988,
            "type": "village",
            "poly": [
                [
                    114.2049217,
                    51.0229217
                ],
                [
                    114.2058588,
                    51.0289922
                ],
                [
                    114.2213198,
                    51.0379491
                ],
                [
                    114.2318146,
                    51.0392453
                ],
                [
                    114.2340635,
                    51.0260455
                ],
                [
                    114.2275043,
                    51.0170863
                ],
                [
                    114.2145732,
                    51.0175579
                ],
                [
                    114.2049217,
                    51.0229217
                ]
            ],
            "longitude": 114.2224831,
            "latitude": 51.0264599
        },
        "1731": {
            "name": "Кадахта",
            "population": 1020,
            "type": "village",
            "poly": null,
            "longitude": 114.250565,
            "latitude": 51.610931
        },
        "1732": {
            "name": "Южный Аргалей",
            "population": 802,
            "type": "village",
            "poly": null,
            "longitude": 114.257805,
            "latitude": 51.140713
        },
        "1733": {
            "name": "Урда-Ага",
            "population": 1153,
            "type": "village",
            "poly": [
                [
                    114.2803694,
                    51.0113385
                ],
                [
                    114.2881655,
                    51.0169979
                ],
                [
                    114.3003845,
                    51.0119516
                ],
                [
                    114.2867412,
                    50.9975174
                ],
                [
                    114.2821685,
                    50.9984138
                ],
                [
                    114.2803694,
                    51.0113385
                ]
            ],
            "longitude": 114.2926926,
            "latitude": 51.0085337
        },
        "1734": {
            "name": "Старый Дурулгуй",
            "population": 168,
            "type": "village",
            "poly": null,
            "longitude": 114.296715,
            "latitude": 50.480053
        },
        "1735": {
            "name": "Маяки",
            "population": 235,
            "type": "village",
            "poly": null,
            "longitude": 114.330475,
            "latitude": 51.476059
        },
        "1736": {
            "name": "Олентуй",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 114.3560204,
            "latitude": 51.4667997
        },
        "1737": {
            "name": "Челутай",
            "population": 758,
            "type": "village",
            "poly": null,
            "longitude": 114.3697149,
            "latitude": 51.2193425
        },
        "1738": {
            "name": "Подлесное",
            "population": 74,
            "type": "village",
            "poly": null,
            "longitude": 114.3852173,
            "latitude": 51.7025017
        },
        "1739": {
            "name": "Атамановка",
            "population": 211,
            "type": "village",
            "poly": null,
            "longitude": 114.4112539,
            "latitude": 51.6636059
        },
        "1740": {
            "name": "Новый Дурулгуй",
            "population": 888,
            "type": "village",
            "poly": null,
            "longitude": 114.4113427,
            "latitude": 50.3460112
        },
        "1741": {
            "name": "Судунтуй",
            "population": 1452,
            "type": "village",
            "poly": null,
            "longitude": 114.4670111,
            "latitude": 50.7604364
        },
        "1742": {
            "name": "Амитхаша",
            "population": 2949,
            "type": "village",
            "poly": null,
            "longitude": 114.4696338,
            "latitude": 51.0821034
        },
        "1743": {
            "name": "Адриановка",
            "population": 1228,
            "type": "village",
            "poly": null,
            "longitude": 114.519371,
            "latitude": 51.566547
        },
        "1744": {
            "name": "Гунэй",
            "population": 1207,
            "type": "village",
            "poly": [
                [
                    114.5361324,
                    50.5134266
                ],
                [
                    114.5472531,
                    50.5270266
                ],
                [
                    114.5682924,
                    50.523205
                ],
                [
                    114.5747544,
                    50.5162298
                ],
                [
                    114.5720494,
                    50.5111013
                ],
                [
                    114.5575223,
                    50.5143505
                ],
                [
                    114.5447986,
                    50.510942
                ],
                [
                    114.5361324,
                    50.5134266
                ]
            ],
            "longitude": 114.5524836,
            "latitude": 50.5198691
        },
        "1745": {
            "name": "Кайдалово",
            "population": 870,
            "type": "village",
            "poly": [
                [
                    114.5577515,
                    51.6278029
                ],
                [
                    114.5642053,
                    51.6321942
                ],
                [
                    114.5677218,
                    51.6386904
                ],
                [
                    114.569087,
                    51.6460073
                ],
                [
                    114.5781471,
                    51.6576604
                ],
                [
                    114.5811257,
                    51.6564284
                ],
                [
                    114.5769473,
                    51.6479325
                ],
                [
                    114.5777747,
                    51.6428239
                ],
                [
                    114.5755407,
                    51.6377918
                ],
                [
                    114.5796778,
                    51.6366364
                ],
                [
                    114.5878691,
                    51.6410525
                ],
                [
                    114.594902,
                    51.6411038
                ],
                [
                    114.5978393,
                    51.6387931
                ],
                [
                    114.5922543,
                    51.6330929
                ],
                [
                    114.5805879,
                    51.6283422
                ],
                [
                    114.5759544,
                    51.6315779
                ],
                [
                    114.5775679,
                    51.6340172
                ],
                [
                    114.5736377,
                    51.6351214
                ],
                [
                    114.569087,
                    51.6296005
                ],
                [
                    114.5631297,
                    51.6250805
                ],
                [
                    114.5577515,
                    51.6278029
                ]
            ],
            "longitude": 114.574501,
            "latitude": 51.635742
        },
        "1746": {
            "name": "Усть-Лиска",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 114.5872035,
            "latitude": 50.4335503
        },
        "1747": {
            "name": "Цокто-Хангил",
            "population": 1505,
            "type": "village",
            "poly": null,
            "longitude": 114.6264399,
            "latitude": 50.9041616
        },
        "1748": {
            "name": "Большевик",
            "population": 443,
            "type": "village",
            "poly": null,
            "longitude": 114.6602953,
            "latitude": 50.4896586
        },
        "1749": {
            "name": "Догой",
            "population": 676,
            "type": "village",
            "poly": null,
            "longitude": 114.661697,
            "latitude": 51.355373
        },
        "1750": {
            "name": "Новоорловск",
            "population": 2980,
            "type": "village",
            "poly": null,
            "longitude": 114.729599,
            "latitude": 51.066452
        },
        "1751": {
            "name": "Поселье",
            "population": 311,
            "type": "village",
            "poly": null,
            "longitude": 114.746623,
            "latitude": 51.7139062
        },
        "1752": {
            "name": "Ага-Хангил",
            "population": 1317,
            "type": "village",
            "poly": null,
            "longitude": 114.750259,
            "latitude": 51.185596
        },
        "1753": {
            "name": "Урта-Харгана",
            "population": 61,
            "type": "village",
            "poly": null,
            "longitude": 114.7582896,
            "latitude": 50.3959519
        },
        "1754": {
            "name": "Урульга",
            "population": 3173,
            "type": "village",
            "poly": null,
            "longitude": 114.800743,
            "latitude": 51.764462
        },
        "1755": {
            "name": "Кубухай",
            "population": 555,
            "type": "village",
            "poly": null,
            "longitude": 114.8087092,
            "latitude": 50.4972404
        },
        "1756": {
            "name": "Ушарбай",
            "population": 1240,
            "type": "village",
            "poly": null,
            "longitude": 114.830505,
            "latitude": 51.399696
        },
        "1757": {
            "name": "Орловский",
            "population": 2045,
            "type": "village",
            "poly": null,
            "longitude": 114.8534215,
            "latitude": 51.0382866
        },
        "1758": {
            "name": "Нарын-Талача",
            "population": 682,
            "type": "village",
            "poly": [
                [
                    114.8507893,
                    51.9334941
                ],
                [
                    114.8520657,
                    51.934004
                ],
                [
                    114.8515419,
                    51.934752
                ],
                [
                    114.8557366,
                    51.9354599
                ],
                [
                    114.8556589,
                    51.9356796
                ],
                [
                    114.8580062,
                    51.9364899
                ],
                [
                    114.8613708,
                    51.9365951
                ],
                [
                    114.8621078,
                    51.9363386
                ],
                [
                    114.8629912,
                    51.9363018
                ],
                [
                    114.8641035,
                    51.9363309
                ],
                [
                    114.8648437,
                    51.9361211
                ],
                [
                    114.8667048,
                    51.9349821
                ],
                [
                    114.8668925,
                    51.9345233
                ],
                [
                    114.867491,
                    51.9345938
                ],
                [
                    114.8675891,
                    51.9341274
                ],
                [
                    114.8665107,
                    51.9322317
                ],
                [
                    114.8668407,
                    51.9303768
                ],
                [
                    114.8671864,
                    51.9296522
                ],
                [
                    114.8676374,
                    51.9291016
                ],
                [
                    114.8699691,
                    51.9300874
                ],
                [
                    114.8711557,
                    51.9299538
                ],
                [
                    114.8724771,
                    51.928557
                ],
                [
                    114.8709809,
                    51.9270959
                ],
                [
                    114.8709981,
                    51.9258488
                ],
                [
                    114.8774506,
                    51.9178433
                ],
                [
                    114.8776074,
                    51.9171696
                ],
                [
                    114.8763171,
                    51.9166679
                ],
                [
                    114.8742974,
                    51.916962
                ],
                [
                    114.8733998,
                    51.9185536
                ],
                [
                    114.8722778,
                    51.9186575
                ],
                [
                    114.8710155,
                    51.9181039
                ],
                [
                    114.8698236,
                    51.9182675
                ],
                [
                    114.8699215,
                    51.9192977
                ],
                [
                    114.8704805,
                    51.9198844
                ],
                [
                    114.8689958,
                    51.9212008
                ],
                [
                    114.8692202,
                    51.9224464
                ],
                [
                    114.8689397,
                    51.9227578
                ],
                [
                    114.8690238,
                    51.9236919
                ],
                [
                    114.867986,
                    51.9237092
                ],
                [
                    114.8664993,
                    51.924332
                ],
                [
                    114.8653772,
                    51.9243839
                ],
                [
                    114.8679018,
                    51.9232594
                ],
                [
                    114.8681823,
                    51.9222042
                ],
                [
                    114.8676213,
                    51.9215641
                ],
                [
                    114.8667798,
                    51.9212873
                ],
                [
                    114.8650126,
                    51.9214429
                ],
                [
                    114.8643302,
                    51.920784
                ],
                [
                    114.8634137,
                    51.9207336
                ],
                [
                    114.8615342,
                    51.9228615
                ],
                [
                    114.8602555,
                    51.9236553
                ],
                [
                    114.8602177,
                    51.9240285
                ],
                [
                    114.8587829,
                    51.9237679
                ],
                [
                    114.8569148,
                    51.9251981
                ],
                [
                    114.8572755,
                    51.9255673
                ],
                [
                    114.856776,
                    51.9264948
                ],
                [
                    114.8557203,
                    51.9272144
                ],
                [
                    114.8544317,
                    51.9296077
                ],
                [
                    114.8532874,
                    51.9323704
                ],
                [
                    114.8524471,
                    51.9334699
                ],
                [
                    114.8513312,
                    51.9330329
                ],
                [
                    114.8507893,
                    51.9334941
                ]
            ],
            "longitude": 114.862022,
            "latitude": 51.930378
        },
        "1759": {
            "name": "Буйлэсан",
            "population": 560,
            "type": "village",
            "poly": null,
            "longitude": 114.871094,
            "latitude": 50.244946
        },
        "1760": {
            "name": "Будулан",
            "population": 960,
            "type": "village",
            "poly": [
                [
                    114.9019563,
                    50.5631745
                ],
                [
                    114.916056,
                    50.5650454
                ],
                [
                    114.9315969,
                    50.5454572
                ],
                [
                    114.9104161,
                    50.5467315
                ],
                [
                    114.9019563,
                    50.5631745
                ]
            ],
            "longitude": 114.912468,
            "latitude": 50.5563347
        },
        "1761": {
            "name": "Средняя Талача",
            "population": 183,
            "type": "village",
            "poly": [
                [
                    114.9135469,
                    51.8447558
                ],
                [
                    114.913603,
                    51.8470259
                ],
                [
                    114.9150055,
                    51.8483602
                ],
                [
                    114.9152299,
                    51.852155
                ],
                [
                    114.9166605,
                    51.8527787
                ],
                [
                    114.9182875,
                    51.8528827
                ],
                [
                    114.9194095,
                    51.8536276
                ],
                [
                    114.9208682,
                    51.8536797
                ],
                [
                    114.9216781,
                    51.8543232
                ],
                [
                    114.9221305,
                    51.8567117
                ],
                [
                    114.9231403,
                    51.8574393
                ],
                [
                    114.924526,
                    51.8574131
                ],
                [
                    114.9248514,
                    51.8564345
                ],
                [
                    114.9249861,
                    51.8529319
                ],
                [
                    114.9257245,
                    51.8486417
                ],
                [
                    114.9253089,
                    51.8473803
                ],
                [
                    114.9269646,
                    51.8449493
                ],
                [
                    114.926664,
                    51.8422569
                ],
                [
                    114.9248234,
                    51.8400765
                ],
                [
                    114.9241221,
                    51.8400418
                ],
                [
                    114.9232245,
                    51.8389326
                ],
                [
                    114.923,
                    51.8380313
                ],
                [
                    114.9218332,
                    51.8365486
                ],
                [
                    114.9198256,
                    51.8384981
                ],
                [
                    114.919129,
                    51.8400245
                ],
                [
                    114.9174179,
                    51.8446518
                ],
                [
                    114.9140518,
                    51.8444092
                ],
                [
                    114.9135469,
                    51.8447558
                ]
            ],
            "longitude": 114.9212919,
            "latitude": 51.8432723
        },
        "1762": {
            "name": "Уронай",
            "population": 115,
            "type": "village",
            "poly": null,
            "longitude": 114.9402735,
            "latitude": 51.2133793
        },
        "1763": {
            "name": "Верхняя Талача",
            "population": 274,
            "type": "village",
            "poly": [
                [
                    114.9885267,
                    51.9268632
                ],
                [
                    114.9899293,
                    51.9277973
                ],
                [
                    114.9944736,
                    51.9283854
                ],
                [
                    114.9961005,
                    51.9303227
                ],
                [
                    114.998008,
                    51.9305649
                ],
                [
                    115.0012619,
                    51.9297346
                ],
                [
                    115.0027205,
                    51.9305995
                ],
                [
                    115.0040312,
                    51.9327996
                ],
                [
                    115.0065916,
                    51.9343008
                ],
                [
                    115.0107992,
                    51.9338165
                ],
                [
                    115.0124367,
                    51.9340274
                ],
                [
                    115.0096211,
                    51.9348888
                ],
                [
                    115.0097894,
                    51.9354077
                ],
                [
                    115.0111358,
                    51.9354423
                ],
                [
                    115.0109114,
                    51.9382785
                ],
                [
                    115.0137165,
                    51.9394891
                ],
                [
                    115.0133908,
                    51.9445342
                ],
                [
                    115.0154557,
                    51.9440888
                ],
                [
                    115.0161175,
                    51.9421807
                ],
                [
                    115.0158484,
                    51.9379672
                ],
                [
                    115.017307,
                    51.9360303
                ],
                [
                    115.0203365,
                    51.936895
                ],
                [
                    115.0229733,
                    51.9362724
                ],
                [
                    115.0253382,
                    51.9362495
                ],
                [
                    115.025554,
                    51.9343008
                ],
                [
                    115.0239832,
                    51.9337819
                ],
                [
                    115.0191411,
                    51.9326259
                ],
                [
                    115.0100699,
                    51.9308416
                ],
                [
                    115.0008573,
                    51.9273388
                ],
                [
                    114.9995227,
                    51.9262405
                ],
                [
                    114.9972786,
                    51.9274168
                ],
                [
                    114.993632,
                    51.9263789
                ],
                [
                    114.9917807,
                    51.9245106
                ],
                [
                    114.9900415,
                    51.9240954
                ],
                [
                    114.9891439,
                    51.9254102
                ],
                [
                    114.9893683,
                    51.9263097
                ],
                [
                    114.9885267,
                    51.9268632
                ]
            ],
            "longitude": 115.014473,
            "latitude": 51.935135
        },
        "1764": {
            "name": "Зугалай",
            "population": 1537,
            "type": "village",
            "poly": [
                [
                    115.004181,
                    51.4774843
                ],
                [
                    115.0397501,
                    51.4792548
                ],
                [
                    115.0422905,
                    51.4594543
                ],
                [
                    115.0067214,
                    51.457683
                ],
                [
                    115.004181,
                    51.4774843
                ]
            ],
            "longitude": 115.024513,
            "latitude": 51.46933
        },
        "1765": {
            "name": "Харганаша",
            "population": 244,
            "type": "village",
            "poly": null,
            "longitude": 115.0473044,
            "latitude": 51.2629272
        },
        "1766": {
            "name": "Цаган-Челутай",
            "population": 1356,
            "type": "village",
            "poly": null,
            "longitude": 115.084145,
            "latitude": 51.069057
        },
        "1767": {
            "name": "Саввино",
            "population": 279,
            "type": "village",
            "poly": [
                [
                    115.0773283,
                    51.758545
                ],
                [
                    115.0856977,
                    51.762741
                ],
                [
                    115.0851955,
                    51.7642691
                ],
                [
                    115.0828521,
                    51.7665482
                ],
                [
                    115.0784581,
                    51.7677912
                ],
                [
                    115.0862835,
                    51.7694227
                ],
                [
                    115.0869112,
                    51.7666518
                ],
                [
                    115.0882503,
                    51.7642173
                ],
                [
                    115.0927698,
                    51.7637511
                ],
                [
                    115.087246,
                    51.7605654
                ],
                [
                    115.0786674,
                    51.757224
                ],
                [
                    115.0773283,
                    51.758545
                ]
            ],
            "longitude": 115.0853859,
            "latitude": 51.7662138
        },
        "1768": {
            "name": "Байн-Цаган",
            "population": 82,
            "type": "village",
            "poly": null,
            "longitude": 115.0867368,
            "latitude": 50.3104118
        },
        "1769": {
            "name": "Ара-Булак",
            "population": 188,
            "type": "village",
            "poly": null,
            "longitude": 115.0874095,
            "latitude": 51.1990015
        },
        "1770": {
            "name": "Верхний Цасучей",
            "population": 945,
            "type": "village",
            "poly": [
                [
                    115.0792373,
                    50.5096289
                ],
                [
                    115.1033128,
                    50.5150324
                ],
                [
                    115.103699,
                    50.5118395
                ],
                [
                    115.0806105,
                    50.5062719
                ],
                [
                    115.0792373,
                    50.5096289
                ]
            ],
            "longitude": 115.090736,
            "latitude": 50.510666
        },
        "1771": {
            "name": "Нижний Цасучей",
            "population": 3372,
            "type": "village",
            "poly": null,
            "longitude": 115.118385,
            "latitude": 50.510593
        },
        "1772": {
            "name": "Бильчиртуй",
            "population": 308,
            "type": "village",
            "poly": null,
            "longitude": 115.1562529,
            "latitude": 51.0639633
        },
        "1773": {
            "name": "Кункур",
            "population": 1085,
            "type": "village",
            "poly": [
                [
                    115.152129,
                    50.579348
                ],
                [
                    115.1610634,
                    50.5830451
                ],
                [
                    115.168492,
                    50.5817065
                ],
                [
                    115.1650788,
                    50.5861046
                ],
                [
                    115.1701985,
                    50.5913308
                ],
                [
                    115.1845538,
                    50.5873794
                ],
                [
                    115.1754186,
                    50.5773718
                ],
                [
                    115.1718413,
                    50.5750624
                ],
                [
                    115.1698265,
                    50.5750624
                ],
                [
                    115.1666604,
                    50.5761591
                ],
                [
                    115.1653035,
                    50.5775692
                ],
                [
                    115.1612328,
                    50.5773864
                ],
                [
                    115.1580518,
                    50.5748218
                ],
                [
                    115.152129,
                    50.579348
                ]
            ],
            "longitude": 115.1693344,
            "latitude": 50.5795662
        },
        "1774": {
            "name": "Ага",
            "population": 1920,
            "type": "village",
            "poly": null,
            "longitude": 115.179909,
            "latitude": 51.185352
        },
        "1775": {
            "name": "Галкино",
            "population": 647,
            "type": "village",
            "poly": [
                [
                    115.1731802,
                    51.7716864
                ],
                [
                    115.1745414,
                    51.7775454
                ],
                [
                    115.1739496,
                    51.7827812
                ],
                [
                    115.1814655,
                    51.7846483
                ],
                [
                    115.1845429,
                    51.7846483
                ],
                [
                    115.1864367,
                    51.7796323
                ],
                [
                    115.1957281,
                    51.7797423
                ],
                [
                    115.1955505,
                    51.7753117
                ],
                [
                    115.1922956,
                    51.7747625
                ],
                [
                    115.1920589,
                    51.7705512
                ],
                [
                    115.2018828,
                    51.7708074
                ],
                [
                    115.2020012,
                    51.7685003
                ],
                [
                    115.1845429,
                    51.7685003
                ],
                [
                    115.1731802,
                    51.7716864
                ]
            ],
            "longitude": 115.1863183,
            "latitude": 51.7764469
        },
        "1776": {
            "name": "Верх-Усугли",
            "population": 2984,
            "type": "village",
            "poly": null,
            "longitude": 115.188309,
            "latitude": 52.690086
        },
        "1777": {
            "name": "Хара-Шибирь",
            "population": 1643,
            "type": "village",
            "poly": [
                [
                    115.175472,
                    51.5403847
                ],
                [
                    115.1789637,
                    51.5413049
                ],
                [
                    115.1807983,
                    51.540716
                ],
                [
                    115.1860062,
                    51.5407895
                ],
                [
                    115.1876211,
                    51.5419773
                ],
                [
                    115.1931079,
                    51.5421883
                ],
                [
                    115.2013322,
                    51.5411152
                ],
                [
                    115.2078153,
                    51.5372651
                ],
                [
                    115.2003871,
                    51.5312554
                ],
                [
                    115.1971321,
                    51.5310344
                ],
                [
                    115.1907901,
                    51.5267147
                ],
                [
                    115.1848226,
                    51.5283837
                ],
                [
                    115.1791412,
                    51.5333538
                ],
                [
                    115.1757679,
                    51.5374399
                ],
                [
                    115.175472,
                    51.5403847
                ]
            ],
            "longitude": 115.191803,
            "latitude": 51.534863
        },
        "1778": {
            "name": "Усугли",
            "population": 889,
            "type": "village",
            "poly": null,
            "longitude": 115.264076,
            "latitude": 52.649963
        },
        "1779": {
            "name": "Икарал",
            "population": 174,
            "type": "village",
            "poly": null,
            "longitude": 115.2921229,
            "latitude": 50.5341091
        },
        "1780": {
            "name": "Берея",
            "population": 142,
            "type": "village",
            "poly": null,
            "longitude": 115.3115079,
            "latitude": 51.617448
        },
        "1781": {
            "name": "Красная Ималка",
            "population": 731,
            "type": "village",
            "poly": null,
            "longitude": 115.3127028,
            "latitude": 50.2619281
        },
        "1782": {
            "name": "Байцетуй",
            "population": 140,
            "type": "village",
            "poly": null,
            "longitude": 115.3222356,
            "latitude": 51.897846
        },
        "1783": {
            "name": "Усть-Ималка",
            "population": 300,
            "type": "village",
            "poly": null,
            "longitude": 115.3393698,
            "latitude": 50.0957006
        },
        "1784": {
            "name": "Улан-Сарта",
            "population": 52,
            "type": "village",
            "poly": null,
            "longitude": 115.3916849,
            "latitude": 51.3146021
        },
        "1785": {
            "name": "Степь",
            "population": 2000,
            "type": "village",
            "poly": null,
            "longitude": 115.402542,
            "latitude": 51.008972
        },
        "1786": {
            "name": "Чиндант 1-й",
            "population": 684,
            "type": "village",
            "poly": null,
            "longitude": 115.4119623,
            "latitude": 50.576072
        },
        "1787": {
            "name": "Цаган-Ола",
            "population": 1494,
            "type": "village",
            "poly": null,
            "longitude": 115.481148,
            "latitude": 51.360119
        },
        "1788": {
            "name": "Размахнино",
            "population": 1025,
            "type": "village",
            "poly": [
                [
                    115.4769973,
                    51.7742177
                ],
                [
                    115.4791733,
                    51.7799138
                ],
                [
                    115.4774158,
                    51.7808977
                ],
                [
                    115.4776669,
                    51.7826063
                ],
                [
                    115.4804288,
                    51.7830206
                ],
                [
                    115.4836091,
                    51.7880944
                ],
                [
                    115.4854504,
                    51.7892333
                ],
                [
                    115.4884634,
                    51.7892851
                ],
                [
                    115.4930666,
                    51.7861788
                ],
                [
                    115.4917275,
                    51.7763409
                ],
                [
                    115.4982556,
                    51.7720944
                ],
                [
                    115.4990089,
                    51.7695048
                ],
                [
                    115.5072946,
                    51.7676402
                ],
                [
                    115.5077967,
                    51.7655167
                ],
                [
                    115.4846972,
                    51.7641699
                ],
                [
                    115.478169,
                    51.7679509
                ],
                [
                    115.4794244,
                    51.7710586
                ],
                [
                    115.4769973,
                    51.7742177
                ]
            ],
            "longitude": 115.486786,
            "latitude": 51.777271
        },
        "1789": {
            "name": "Номоконово",
            "population": 559,
            "type": "village",
            "poly": null,
            "longitude": 115.4963003,
            "latitude": 51.6374348
        },
        "1790": {
            "name": "Новая Заря",
            "population": 990,
            "type": "village",
            "poly": null,
            "longitude": 115.5607564,
            "latitude": 50.3614692
        },
        "1791": {
            "name": "Старый Чиндант",
            "population": 118,
            "type": "village",
            "poly": null,
            "longitude": 115.5626367,
            "latitude": 50.5588116
        },
        "1792": {
            "name": "Шиванда",
            "population": 128,
            "type": "village",
            "poly": [
                [
                    115.5602922,
                    51.7190907
                ],
                [
                    115.5668683,
                    51.72942
                ],
                [
                    115.569804,
                    51.7289109
                ],
                [
                    115.5676903,
                    51.7263651
                ],
                [
                    115.573327,
                    51.7250558
                ],
                [
                    115.569804,
                    51.7234555
                ],
                [
                    115.5702738,
                    51.7159623
                ],
                [
                    115.5628756,
                    51.7156712
                ],
                [
                    115.5602922,
                    51.7190907
                ]
            ],
            "longitude": 115.5661637,
            "latitude": 51.7206911
        },
        "1793": {
            "name": "Ононск",
            "population": 690,
            "type": "village",
            "poly": null,
            "longitude": 115.5707034,
            "latitude": 50.9856973
        },
        "1794": {
            "name": "Оловорудник",
            "population": 42,
            "type": "village",
            "poly": null,
            "longitude": 115.5871938,
            "latitude": 50.9674469
        },
        "1795": {
            "name": "Усть-Нарин",
            "population": 568,
            "type": "village",
            "poly": null,
            "longitude": 115.615166,
            "latitude": 51.405544
        },
        "1796": {
            "name": "Кулинда",
            "population": 203,
            "type": "village",
            "poly": null,
            "longitude": 115.6161042,
            "latitude": 50.9567816
        },
        "1797": {
            "name": "Цугол",
            "population": 842,
            "type": "village",
            "poly": null,
            "longitude": 115.624397,
            "latitude": 51.046543
        },
        "1798": {
            "name": "Тунгокочен",
            "population": 967,
            "type": "village",
            "poly": [
                [
                    115.5952941,
                    53.5224898
                ],
                [
                    115.6015567,
                    53.5266837
                ],
                [
                    115.6047257,
                    53.5303839
                ],
                [
                    115.6005758,
                    53.5339717
                ],
                [
                    115.6040089,
                    53.5395321
                ],
                [
                    115.6215139,
                    53.5399357
                ],
                [
                    115.6298892,
                    53.5378954
                ],
                [
                    115.6324546,
                    53.5351376
                ],
                [
                    115.6350954,
                    53.5312809
                ],
                [
                    115.632266,
                    53.5294869
                ],
                [
                    115.6285311,
                    53.5283657
                ],
                [
                    115.6240039,
                    53.5276481
                ],
                [
                    115.6220421,
                    53.5303839
                ],
                [
                    115.6199294,
                    53.5317294
                ],
                [
                    115.6138932,
                    53.5322003
                ],
                [
                    115.6132519,
                    53.5294421
                ],
                [
                    115.5952941,
                    53.5224898
                ]
            ],
            "longitude": 115.6279401,
            "latitude": 53.5352035
        },
        "1799": {
            "name": "Ортуй",
            "population": 1101,
            "type": "village",
            "poly": null,
            "longitude": 115.635109,
            "latitude": 50.816471
        },
        "1800": {
            "name": "Кусоча",
            "population": 1049,
            "type": "village",
            "poly": null,
            "longitude": 115.63826,
            "latitude": 50.703457
        },
        "1801": {
            "name": "Средняя Кия",
            "population": 323,
            "type": "village",
            "poly": [
                [
                    115.6354531,
                    51.9948519
                ],
                [
                    115.6368933,
                    51.9983434
                ],
                [
                    115.6468396,
                    52.0013081
                ],
                [
                    115.6523753,
                    51.9974567
                ],
                [
                    115.6476047,
                    51.9931891
                ],
                [
                    115.6485048,
                    51.9890043
                ],
                [
                    115.6466146,
                    51.9880897
                ],
                [
                    115.6444993,
                    51.9903069
                ],
                [
                    115.6369833,
                    51.9915262
                ],
                [
                    115.6354531,
                    51.9948519
                ]
            ],
            "longitude": 115.6411525,
            "latitude": 51.9938806
        },
        "1802": {
            "name": "Нуринск",
            "population": 863,
            "type": "village",
            "poly": null,
            "longitude": 115.663399,
            "latitude": 51.083088
        },
        "1803": {
            "name": "Усть-Борзя",
            "population": 501,
            "type": "village",
            "poly": null,
            "longitude": 115.6743355,
            "latitude": 50.6052552
        },
        "1804": {
            "name": "Солнцево",
            "population": 320,
            "type": "village",
            "poly": [
                [
                    115.665708,
                    51.751352
                ],
                [
                    115.6696107,
                    51.7568521
                ],
                [
                    115.6672027,
                    51.762557
                ],
                [
                    115.6760045,
                    51.7641502
                ],
                [
                    115.6804054,
                    51.7606555
                ],
                [
                    115.684059,
                    51.7552587
                ],
                [
                    115.6815679,
                    51.7537166
                ],
                [
                    115.6808206,
                    51.7510436
                ],
                [
                    115.6751741,
                    51.7504781
                ],
                [
                    115.6734304,
                    51.7517633
                ],
                [
                    115.665708,
                    51.751352
                ]
            ],
            "longitude": 115.6749442,
            "latitude": 51.7535097
        },
        "1805": {
            "name": "Кулусутай",
            "population": 903,
            "type": "village",
            "poly": null,
            "longitude": 115.6830319,
            "latitude": 50.2342453
        },
        "1806": {
            "name": "Соловьёвск",
            "population": 570,
            "type": "village",
            "poly": [
                [
                    115.6932518,
                    49.8972152
                ],
                [
                    115.6967279,
                    49.9000625
                ],
                [
                    115.6984016,
                    49.8995649
                ],
                [
                    115.7006761,
                    49.9003942
                ],
                [
                    115.7019636,
                    49.8990673
                ],
                [
                    115.7092163,
                    49.9018869
                ],
                [
                    115.7120058,
                    49.8993714
                ],
                [
                    115.7049248,
                    49.8964135
                ],
                [
                    115.7018778,
                    49.8938701
                ],
                [
                    115.7039377,
                    49.8933172
                ],
                [
                    115.7004186,
                    49.8903036
                ],
                [
                    115.6934234,
                    49.8932342
                ],
                [
                    115.6955692,
                    49.8959159
                ],
                [
                    115.6932518,
                    49.8972152
                ]
            ],
            "longitude": 115.701576,
            "latitude": 49.896633
        },
        "1807": {
            "name": "Неляты",
            "population": 72,
            "type": "village",
            "poly": null,
            "longitude": 115.702751,
            "latitude": 56.49205
        },
        "1808": {
            "name": "Нижний Стан",
            "population": 656,
            "type": "village",
            "poly": null,
            "longitude": 115.7121232,
            "latitude": 52.2911685
        },
        "1809": {
            "name": "Малый Соловьёвск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 115.7557906,
            "latitude": 49.8968236
        },
        "1810": {
            "name": "Верхний Шаранай",
            "population": 367,
            "type": "village",
            "poly": null,
            "longitude": 115.7663745,
            "latitude": 51.0791656
        },
        "1811": {
            "name": "Холуй-База",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 115.7684732,
            "latitude": 50.4904983
        },
        "1812": {
            "name": "Усть-Ножовая",
            "population": 450,
            "type": "village",
            "poly": null,
            "longitude": 115.7725355,
            "latitude": 51.4687312
        },
        "1813": {
            "name": "Чирон",
            "population": 1041,
            "type": "village",
            "poly": [
                [
                    115.7666452,
                    51.6341968
                ],
                [
                    115.7725875,
                    51.6407417
                ],
                [
                    115.7789482,
                    51.6405859
                ],
                [
                    115.7802873,
                    51.6365863
                ],
                [
                    115.7805384,
                    51.6323267
                ],
                [
                    115.7836351,
                    51.6251571
                ],
                [
                    115.7902469,
                    51.6142447
                ],
                [
                    115.7858948,
                    51.6128935
                ],
                [
                    115.7689049,
                    51.6241179
                ],
                [
                    115.769156,
                    51.6288459
                ],
                [
                    115.7668126,
                    51.6295213
                ],
                [
                    115.7666452,
                    51.6341968
                ]
            ],
            "longitude": 115.777247,
            "latitude": 51.6252291
        },
        "1814": {
            "name": "Богомягково",
            "population": 596,
            "type": "village",
            "poly": [
                [
                    115.7784944,
                    51.9888575
                ],
                [
                    115.7787943,
                    51.9981536
                ],
                [
                    115.7890336,
                    52.0008594
                ],
                [
                    115.7887062,
                    51.9978053
                ],
                [
                    115.7906149,
                    51.9955389
                ],
                [
                    115.7937047,
                    51.9954723
                ],
                [
                    115.7975852,
                    51.9992588
                ],
                [
                    115.8003964,
                    51.9982521
                ],
                [
                    115.7984614,
                    51.9947773
                ],
                [
                    115.8033739,
                    51.9954762
                ],
                [
                    115.8111191,
                    51.9949759
                ],
                [
                    115.8077277,
                    51.9892712
                ],
                [
                    115.806683,
                    51.988143
                ],
                [
                    115.8086365,
                    51.9867483
                ],
                [
                    115.8022857,
                    51.9862361
                ],
                [
                    115.7989265,
                    51.9844917
                ],
                [
                    115.7935634,
                    51.990133
                ],
                [
                    115.7868343,
                    51.9910005
                ],
                [
                    115.7826749,
                    51.9902735
                ],
                [
                    115.7802203,
                    51.988285
                ],
                [
                    115.7784944,
                    51.9888575
                ]
            ],
            "longitude": 115.7894684,
            "latitude": 51.9925647
        },
        "1815": {
            "name": "Ульяновка",
            "population": 189,
            "type": "village",
            "poly": null,
            "longitude": 115.791364,
            "latitude": 52.0605525
        },
        "1816": {
            "name": "Ясная",
            "population": 7267,
            "type": "village",
            "poly": null,
            "longitude": 115.802956,
            "latitude": 50.830166
        },
        "1817": {
            "name": "Средний Шаранай",
            "population": 1,
            "type": "village",
            "poly": null,
            "longitude": 115.8233769,
            "latitude": 51.0907751
        },
        "1818": {
            "name": "Кыкер",
            "population": 487,
            "type": "village",
            "poly": null,
            "longitude": 115.8244362,
            "latitude": 53.1674604
        },
        "1819": {
            "name": "Бутиха",
            "population": 90,
            "type": "village",
            "poly": null,
            "longitude": 115.8282074,
            "latitude": 52.3266982
        },
        "1820": {
            "name": "Кироча",
            "population": 161,
            "type": "village",
            "poly": null,
            "longitude": 115.8331668,
            "latitude": 51.59576
        },
        "1821": {
            "name": "Усть-Ага",
            "population": 98,
            "type": "village",
            "poly": null,
            "longitude": 115.837768,
            "latitude": 51.5364398
        },
        "1822": {
            "name": "Боржигантай",
            "population": 1064,
            "type": "village",
            "poly": null,
            "longitude": 115.848457,
            "latitude": 51.211895
        },
        "1823": {
            "name": "Сухайтуй",
            "population": 37,
            "type": "village",
            "poly": null,
            "longitude": 115.859067,
            "latitude": 52.2537179
        },
        "1824": {
            "name": "Казаново",
            "population": 2212,
            "type": "village",
            "poly": [
                [
                    115.841779,
                    51.769281
                ],
                [
                    115.8484745,
                    51.7751332
                ],
                [
                    115.8598569,
                    51.7865764
                ],
                [
                    115.8663014,
                    51.791598
                ],
                [
                    115.8701513,
                    51.7860585
                ],
                [
                    115.8745871,
                    51.7866799
                ],
                [
                    115.871323,
                    51.7824861
                ],
                [
                    115.8811152,
                    51.7777224
                ],
                [
                    115.8688959,
                    51.7686076
                ],
                [
                    115.8648786,
                    51.7606309
                ],
                [
                    115.8619493,
                    51.7505801
                ],
                [
                    115.8556722,
                    51.7507355
                ],
                [
                    115.8555048,
                    51.7588695
                ],
                [
                    115.841779,
                    51.769281
                ]
            ],
            "longitude": 115.87035,
            "latitude": 51.7722661
        },
        "1825": {
            "name": "Единение",
            "population": 581,
            "type": "village",
            "poly": null,
            "longitude": 115.8858847,
            "latitude": 51.1716708
        },
        "1826": {
            "name": "Верхняя Хила",
            "population": 921,
            "type": "village",
            "poly": null,
            "longitude": 115.889604,
            "latitude": 52.089388
        },
        "1827": {
            "name": "Хара-Бырка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 115.9205916,
            "latitude": 50.9534777
        },
        "1828": {
            "name": "Золотухино",
            "population": 246,
            "type": "village",
            "poly": null,
            "longitude": 115.9262561,
            "latitude": 52.1374617
        },
        "1829": {
            "name": "Васильевка",
            "population": 141,
            "type": "village",
            "poly": [
                [
                    115.9305713,
                    52.0293923
                ],
                [
                    115.9352155,
                    52.0321256
                ],
                [
                    115.9395961,
                    52.0318285
                ],
                [
                    115.9485769,
                    52.0333138
                ],
                [
                    115.9483598,
                    52.0316953
                ],
                [
                    115.947927,
                    52.0283532
                ],
                [
                    115.9401232,
                    52.0247735
                ],
                [
                    115.9334687,
                    52.0255933
                ],
                [
                    115.9305713,
                    52.0293923
                ]
            ],
            "longitude": 115.9396394,
            "latitude": 52.0289537
        },
        "1830": {
            "name": "Митрофаново",
            "population": 648,
            "type": "village",
            "poly": null,
            "longitude": 115.950718,
            "latitude": 51.8198145
        },
        "1831": {
            "name": "Бырка",
            "population": 403,
            "type": "village",
            "poly": null,
            "longitude": 115.95195,
            "latitude": 50.741375
        },
        "1832": {
            "name": "Ононское",
            "population": 1368,
            "type": "village",
            "poly": null,
            "longitude": 115.9540582,
            "latitude": 51.477927
        },
        "1833": {
            "name": "Караксар",
            "population": 133,
            "type": "village",
            "poly": null,
            "longitude": 115.9560541,
            "latitude": 51.2643136
        },
        "1834": {
            "name": "Лаха",
            "population": 141,
            "type": "village",
            "poly": null,
            "longitude": 115.9567239,
            "latitude": 50.4904399
        },
        "1835": {
            "name": "Усть-Теленгуй",
            "population": 567,
            "type": "village",
            "poly": null,
            "longitude": 115.9644093,
            "latitude": 51.54726
        },
        "1836": {
            "name": "Уртуйский",
            "population": 585,
            "type": "village",
            "poly": null,
            "longitude": 115.9681577,
            "latitude": 50.7280634
        },
        "1837": {
            "name": "Новое",
            "population": 203,
            "type": "village",
            "poly": null,
            "longitude": 115.9786,
            "latitude": 51.341755
        },
        "1838": {
            "name": "Островки",
            "population": 150,
            "type": "village",
            "poly": [
                [
                    115.9731211,
                    52.0762513
                ],
                [
                    115.9772491,
                    52.0799093
                ],
                [
                    115.9846412,
                    52.0764136
                ],
                [
                    115.9901132,
                    52.0750122
                ],
                [
                    115.9903052,
                    52.0698932
                ],
                [
                    115.9799372,
                    52.0724454
                ],
                [
                    115.9731211,
                    52.0762513
                ]
            ],
            "longitude": 115.9798412,
            "latitude": 52.0751155
        },
        "1839": {
            "name": "Макарово",
            "population": 63,
            "type": "village",
            "poly": null,
            "longitude": 116.012627,
            "latitude": 51.490631
        },
        "1840": {
            "name": "Джида",
            "population": 0,
            "type": "village",
            "poly": null,
            "longitude": 116.0436032,
            "latitude": 51.4491212
        },
        "1841": {
            "name": "Мирная",
            "population": 1148,
            "type": "village",
            "poly": null,
            "longitude": 116.044701,
            "latitude": 50.756752
        },
        "1842": {
            "name": "Илим",
            "population": 820,
            "type": "village",
            "poly": null,
            "longitude": 116.0576079,
            "latitude": 52.2111545
        },
        "1843": {
            "name": "Заря",
            "population": 94,
            "type": "village",
            "poly": null,
            "longitude": 116.0583487,
            "latitude": 51.148688
        },
        "1844": {
            "name": "Верхний Теленгуй",
            "population": 111,
            "type": "village",
            "poly": null,
            "longitude": 116.0618665,
            "latitude": 51.6398231
        },
        "1845": {
            "name": "Олекан",
            "population": 925,
            "type": "village",
            "poly": null,
            "longitude": 116.0663964,
            "latitude": 52.3666874
        },
        "1846": {
            "name": "Кибасово",
            "population": 216,
            "type": "village",
            "poly": null,
            "longitude": 116.075722,
            "latitude": 51.864914
        },
        "1847": {
            "name": "Куанда",
            "population": 1860,
            "type": "village",
            "poly": null,
            "longitude": 116.0826644,
            "latitude": 56.3256949
        },
        "1848": {
            "name": "Новоберёзовское",
            "population": 463,
            "type": "village",
            "poly": null,
            "longitude": 116.099998,
            "latitude": 52.116669
        },
        "1849": {
            "name": "Тасырхой",
            "population": 24,
            "type": "village",
            "poly": null,
            "longitude": 116.107139,
            "latitude": 50.4079652
        },
        "1850": {
            "name": "Нижняя Хила",
            "population": 192,
            "type": "village",
            "poly": null,
            "longitude": 116.1502925,
            "latitude": 52.0576593
        },
        "1851": {
            "name": "Мирсаново",
            "population": 745,
            "type": "village",
            "poly": null,
            "longitude": 116.162361,
            "latitude": 51.889057
        },
        "1852": {
            "name": "Безречная",
            "population": 538,
            "type": "village",
            "poly": null,
            "longitude": 116.176285,
            "latitude": 50.731003
        },
        "1853": {
            "name": "Крупянка",
            "population": 152,
            "type": "village",
            "poly": null,
            "longitude": 116.1775003,
            "latitude": 52.4754054
        },
        "1854": {
            "name": "Большой Луг",
            "population": 55,
            "type": "village",
            "poly": null,
            "longitude": 116.2042725,
            "latitude": 52.4213714
        },
        "1855": {
            "name": "Зюльзя",
            "population": 1670,
            "type": "village",
            "poly": null,
            "longitude": 116.204521,
            "latitude": 52.534538
        },
        "1856": {
            "name": "Победа",
            "population": 179,
            "type": "village",
            "poly": null,
            "longitude": 116.2095562,
            "latitude": 51.0628819
        },
        "1857": {
            "name": "Олинск",
            "population": 938,
            "type": "village",
            "poly": null,
            "longitude": 116.2160761,
            "latitude": 52.3946197
        },
        "1858": {
            "name": "Улан-Цацык",
            "population": 463,
            "type": "village",
            "poly": null,
            "longitude": 116.2227462,
            "latitude": 50.8612763
        },
        "1859": {
            "name": "Ундино-Поселье",
            "population": 1278,
            "type": "village",
            "poly": null,
            "longitude": 116.238205,
            "latitude": 51.421551
        },
        "1860": {
            "name": "Аренда",
            "population": 232,
            "type": "village",
            "poly": null,
            "longitude": 116.2383908,
            "latitude": 51.2855426
        },
        "1861": {
            "name": "Улятуй",
            "population": 859,
            "type": "village",
            "poly": null,
            "longitude": 116.241806,
            "latitude": 51.168884
        },
        "1862": {
            "name": "Шивия",
            "population": 58,
            "type": "village",
            "poly": null,
            "longitude": 116.2579792,
            "latitude": 51.3317631
        },
        "1863": {
            "name": "Приозёрное",
            "population": 296,
            "type": "village",
            "poly": null,
            "longitude": 116.2737783,
            "latitude": 50.4856233
        },
        "1864": {
            "name": "Беломестново",
            "population": 139,
            "type": "village",
            "poly": [
                [
                    116.2704419,
                    52.1664651
                ],
                [
                    116.2714548,
                    52.1688233
                ],
                [
                    116.2734158,
                    52.1747169
                ],
                [
                    116.2745646,
                    52.1757249
                ],
                [
                    116.2762121,
                    52.1763032
                ],
                [
                    116.278578,
                    52.1732469
                ],
                [
                    116.2796428,
                    52.1732134
                ],
                [
                    116.2801354,
                    52.1727447
                ],
                [
                    116.2793152,
                    52.1710869
                ],
                [
                    116.2802162,
                    52.1695966
                ],
                [
                    116.2820182,
                    52.1697473
                ],
                [
                    116.2832741,
                    52.1682402
                ],
                [
                    116.2836073,
                    52.1666733
                ],
                [
                    116.2826302,
                    52.1661887
                ],
                [
                    116.2804892,
                    52.1661637
                ],
                [
                    116.2776195,
                    52.1653999
                ],
                [
                    116.2746192,
                    52.1625965
                ],
                [
                    116.2715615,
                    52.1628213
                ],
                [
                    116.2704419,
                    52.1664651
                ]
            ],
            "longitude": 116.2779702,
            "latitude": 52.1684517
        },
        "1865": {
            "name": "Арбагар",
            "population": 491,
            "type": "village",
            "poly": [
                [
                    116.2631941,
                    51.9443927
                ],
                [
                    116.2660124,
                    51.9447908
                ],
                [
                    116.2700638,
                    51.9433069
                ],
                [
                    116.2725298,
                    51.9439584
                ],
                [
                    116.2707096,
                    51.9475414
                ],
                [
                    116.284449,
                    51.9519565
                ],
                [
                    116.2913774,
                    51.9504728
                ],
                [
                    116.2897334,
                    51.9455871
                ],
                [
                    116.2906141,
                    51.9430897
                ],
                [
                    116.3014177,
                    51.9432345
                ],
                [
                    116.301359,
                    51.9417143
                ],
                [
                    116.2960746,
                    51.9407732
                ],
                [
                    116.2898508,
                    51.9410266
                ],
                [
                    116.2775206,
                    51.9378774
                ],
                [
                    116.2755243,
                    51.9404836
                ],
                [
                    116.2732344,
                    51.9393253
                ],
                [
                    116.2731757,
                    51.9367189
                ],
                [
                    116.2647207,
                    51.9366104
                ],
                [
                    116.2648968,
                    51.9387823
                ],
                [
                    116.2636051,
                    51.940013
                ],
                [
                    116.2631941,
                    51.9443927
                ]
            ],
            "longitude": 116.280457,
            "latitude": 51.943813
        },
        "1866": {
            "name": "Апрелково",
            "population": 23,
            "type": "village",
            "poly": null,
            "longitude": 116.281807,
            "latitude": 51.877331
        },
        "1867": {
            "name": "Зюльзикан",
            "population": 340,
            "type": "village",
            "poly": null,
            "longitude": 116.2840923,
            "latitude": 52.6726325
        },
        "1868": {
            "name": "Знаменка",
            "population": 908,
            "type": "village",
            "poly": [
                [
                    116.2829435,
                    52.1837209
                ],
                [
                    116.2918269,
                    52.186852
                ],
                [
                    116.3025987,
                    52.1824315
                ],
                [
                    116.3041866,
                    52.1766159
                ],
                [
                    116.3018219,
                    52.1731024
                ],
                [
                    116.296376,
                    52.1720365
                ],
                [
                    116.2898528,
                    52.1724313
                ],
                [
                    116.2865441,
                    52.1761816
                ],
                [
                    116.2832868,
                    52.1798264
                ],
                [
                    116.2829435,
                    52.1837209
                ]
            ],
            "longitude": 116.2927282,
            "latitude": 52.1797462
        },
        "1869": {
            "name": "Хада-Булак",
            "population": 1290,
            "type": "village",
            "poly": null,
            "longitude": 116.302849,
            "latitude": 50.646523
        },
        "1870": {
            "name": "Андронниково",
            "population": 171,
            "type": "village",
            "poly": null,
            "longitude": 116.3127576,
            "latitude": 51.725675
        },
        "1871": {
            "name": "Бурулятуй",
            "population": 636,
            "type": "village",
            "poly": null,
            "longitude": 116.3210044,
            "latitude": 51.0870904
        },
        "1872": {
            "name": "Кангил",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 116.329071,
            "latitude": 52.2452824
        },
        "1873": {
            "name": "Матусово",
            "population": 535,
            "type": "village",
            "poly": null,
            "longitude": 116.3535187,
            "latitude": 51.4727754
        },
        "1874": {
            "name": "Правые Кумаки",
            "population": 191,
            "type": "village",
            "poly": [
                [
                    116.3465034,
                    52.0784104
                ],
                [
                    116.3505968,
                    52.0788719
                ],
                [
                    116.351085,
                    52.0805914
                ],
                [
                    116.3562674,
                    52.0787451
                ],
                [
                    116.3582766,
                    52.0775103
                ],
                [
                    116.3605111,
                    52.0746713
                ],
                [
                    116.3622949,
                    52.0712089
                ],
                [
                    116.3636093,
                    52.068381
                ],
                [
                    116.3613748,
                    52.0678616
                ],
                [
                    116.3555164,
                    52.074198
                ],
                [
                    116.356305,
                    52.0750291
                ],
                [
                    116.3543334,
                    52.07571
                ],
                [
                    116.3531692,
                    52.0769679
                ],
                [
                    116.3520614,
                    52.0783758
                ],
                [
                    116.3477427,
                    52.0773487
                ],
                [
                    116.3465034,
                    52.0784104
                ]
            ],
            "longitude": 116.3576464,
            "latitude": 52.0749548
        },
        "1875": {
            "name": "Комкай",
            "population": 141,
            "type": "village",
            "poly": null,
            "longitude": 116.3592289,
            "latitude": 51.1900481
        },
        "1876": {
            "name": "Котельниково",
            "population": 78,
            "type": "village",
            "poly": null,
            "longitude": 116.3605474,
            "latitude": 51.7432713
        },
        "1877": {
            "name": "Левые Кумаки",
            "population": 272,
            "type": "village",
            "poly": [
                [
                    116.3680888,
                    52.0666556
                ],
                [
                    116.3699665,
                    52.0669234
                ],
                [
                    116.3711682,
                    52.0633311
                ],
                [
                    116.3745481,
                    52.0612993
                ],
                [
                    116.3795052,
                    52.0567459
                ],
                [
                    116.3832907,
                    52.0550187
                ],
                [
                    116.3844473,
                    52.0558962
                ],
                [
                    116.3875868,
                    52.0546122
                ],
                [
                    116.389089,
                    52.0528387
                ],
                [
                    116.3873014,
                    52.0514346
                ],
                [
                    116.3816533,
                    52.0535777
                ],
                [
                    116.3790095,
                    52.0535315
                ],
                [
                    116.3732862,
                    52.0568291
                ],
                [
                    116.3709279,
                    52.0594798
                ],
                [
                    116.3696059,
                    52.062934
                ],
                [
                    116.3680888,
                    52.0666556
                ]
            ],
            "longitude": 116.3749622,
            "latitude": 52.0579972
        },
        "1878": {
            "name": "Чиндант 2-й",
            "population": 617,
            "type": "village",
            "poly": null,
            "longitude": 116.3773817,
            "latitude": 50.3758726
        },
        "1879": {
            "name": "Сарбактуй",
            "population": 267,
            "type": "village",
            "poly": null,
            "longitude": 116.3795154,
            "latitude": 51.4568473
        },
        "1880": {
            "name": "Сенная",
            "population": 91,
            "type": "village",
            "poly": null,
            "longitude": 116.3871813,
            "latitude": 52.0445405
        },
        "1881": {
            "name": "Кулаково",
            "population": 73,
            "type": "village",
            "poly": null,
            "longitude": 116.3992393,
            "latitude": 51.7769233
        },
        "1882": {
            "name": "Долгокыча",
            "population": 886,
            "type": "village",
            "poly": null,
            "longitude": 116.4182276,
            "latitude": 51.0702562
        },
        "1883": {
            "name": "Новоивановка",
            "population": 232,
            "type": "village",
            "poly": null,
            "longitude": 116.4187477,
            "latitude": 51.4925298
        },
        "1884": {
            "name": "Ключевая",
            "population": 10,
            "type": "village",
            "poly": null,
            "longitude": 116.4289073,
            "latitude": 51.0293481
        },
        "1885": {
            "name": "Бишигино",
            "population": 416,
            "type": "village",
            "poly": null,
            "longitude": 116.4398555,
            "latitude": 51.8530073
        },
        "1886": {
            "name": "Пешково",
            "population": 479,
            "type": "village",
            "poly": null,
            "longitude": 116.4486532,
            "latitude": 51.8245628
        },
        "1887": {
            "name": "Берёзово",
            "population": 325,
            "type": "village",
            "poly": [
                [
                    116.4420301,
                    52.1563145
                ],
                [
                    116.4454386,
                    52.1571904
                ],
                [
                    116.4463178,
                    52.1598447
                ],
                [
                    116.450308,
                    52.1608758
                ],
                [
                    116.4537994,
                    52.1612336
                ],
                [
                    116.4570835,
                    52.161009
                ],
                [
                    116.4589887,
                    52.1602127
                ],
                [
                    116.4608873,
                    52.1572808
                ],
                [
                    116.4621783,
                    52.1568642
                ],
                [
                    116.4637365,
                    52.1557821
                ],
                [
                    116.464458,
                    52.1537815
                ],
                [
                    116.4571823,
                    52.1513666
                ],
                [
                    116.4514983,
                    52.1502787
                ],
                [
                    116.449629,
                    52.1524957
                ],
                [
                    116.4492643,
                    52.1554941
                ],
                [
                    116.4426588,
                    52.1544115
                ],
                [
                    116.4420301,
                    52.1563145
                ]
            ],
            "longitude": 116.4499888,
            "latitude": 52.1574208
        },
        "1888": {
            "name": "Право-Пешково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 116.4737591,
            "latitude": 51.8189383
        },
        "1889": {
            "name": "квартал Борзя-2",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 116.4751212,
            "latitude": 50.3770112
        },
        "1890": {
            "name": "Макеевка",
            "population": 35,
            "type": "village",
            "poly": null,
            "longitude": 116.5040535,
            "latitude": 51.9908529
        },
        "1891": {
            "name": "Савватеево",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 116.5061952,
            "latitude": 51.8673353
        },
        "1892": {
            "name": "Заречный",
            "population": 957,
            "type": "village",
            "poly": [
                [
                    116.4982483,
                    52.0360001
                ],
                [
                    116.5054703,
                    52.0353139
                ],
                [
                    116.5132207,
                    52.0337245
                ],
                [
                    116.5193271,
                    52.0307264
                ],
                [
                    116.5245528,
                    52.0261384
                ],
                [
                    116.5207363,
                    52.0236094
                ],
                [
                    116.5112831,
                    52.0280891
                ],
                [
                    116.5022997,
                    52.0316655
                ],
                [
                    116.4982483,
                    52.0360001
                ]
            ],
            "longitude": 116.510123,
            "latitude": 52.0324098
        },
        "1893": {
            "name": "Барановск",
            "population": 139,
            "type": "village",
            "poly": null,
            "longitude": 116.5137855,
            "latitude": 51.4864601
        },
        "1894": {
            "name": "Новый Олов",
            "population": 373,
            "type": "village",
            "poly": [
                [
                    116.5131814,
                    52.619152
                ],
                [
                    116.520477,
                    52.6195688
                ],
                [
                    116.5273349,
                    52.5972504
                ],
                [
                    116.514347,
                    52.5946704
                ],
                [
                    116.5142484,
                    52.6041551
                ],
                [
                    116.5131814,
                    52.619152
                ]
            ],
            "longitude": 116.5203011,
            "latitude": 52.6078429
        },
        "1895": {
            "name": "Калангуй",
            "population": 1802,
            "type": "village",
            "poly": null,
            "longitude": 116.520874,
            "latitude": 51.010525
        },
        "1896": {
            "name": "Усть-Каренга",
            "population": 217,
            "type": "village",
            "poly": [
                [
                    116.5151733,
                    54.4472529
                ],
                [
                    116.5224167,
                    54.448569
                ],
                [
                    116.5243031,
                    54.4461999
                ],
                [
                    116.5261139,
                    54.4432164
                ],
                [
                    116.5243785,
                    54.4387408
                ],
                [
                    116.5245294,
                    54.4360201
                ],
                [
                    116.5200777,
                    54.4361078
                ],
                [
                    116.5189459,
                    54.4396623
                ],
                [
                    116.5151733,
                    54.4472529
                ]
            ],
            "longitude": 116.522041,
            "latitude": 54.44278
        },
        "1897": {
            "name": "Верхний Умыкэй",
            "population": 249,
            "type": "village",
            "poly": null,
            "longitude": 116.5445076,
            "latitude": 52.1382447
        },
        "1898": {
            "name": "Булум",
            "population": 496,
            "type": "village",
            "poly": null,
            "longitude": 116.5508672,
            "latitude": 50.8642565
        },
        "1899": {
            "name": "Хада-Булак",
            "population": 615,
            "type": "village",
            "poly": null,
            "longitude": 116.5561848,
            "latitude": 50.6104309
        },
        "1900": {
            "name": "Кадая",
            "population": 285,
            "type": "village",
            "poly": [
                [
                    116.5554101,
                    52.5588207
                ],
                [
                    116.5628688,
                    52.5601147
                ],
                [
                    116.5668256,
                    52.5526108
                ],
                [
                    116.5710227,
                    52.5481641
                ],
                [
                    116.5644565,
                    52.5449523
                ],
                [
                    116.5578992,
                    52.5504188
                ],
                [
                    116.5554101,
                    52.5588207
                ]
            ],
            "longitude": 116.5617573,
            "latitude": 52.5518253
        },
        "1901": {
            "name": "Нагорный",
            "population": 525,
            "type": "village",
            "poly": null,
            "longitude": 116.5629382,
            "latitude": 52.0182476
        },
        "1902": {
            "name": "Южное",
            "population": 577,
            "type": "village",
            "poly": [
                [
                    116.5540526,
                    50.2475292
                ],
                [
                    116.5556237,
                    50.2481474
                ],
                [
                    116.5701254,
                    50.2507748
                ],
                [
                    116.5703671,
                    50.2528354
                ],
                [
                    116.5730257,
                    50.2546898
                ],
                [
                    116.5771345,
                    50.2560033
                ],
                [
                    116.5797529,
                    50.2539944
                ],
                [
                    116.5818476,
                    50.251599
                ],
                [
                    116.5824116,
                    50.2495898
                ],
                [
                    116.5728646,
                    50.2476065
                ],
                [
                    116.5732674,
                    50.2463957
                ],
                [
                    116.5569127,
                    50.2429952
                ],
                [
                    116.5540526,
                    50.2475292
                ]
            ],
            "longitude": 116.5745565,
            "latitude": 50.2510324
        },
        "1903": {
            "name": "Новоборзинское",
            "population": 253,
            "type": "village",
            "poly": null,
            "longitude": 116.5751785,
            "latitude": 50.3004022
        },
        "1904": {
            "name": "Антия",
            "population": 290,
            "type": "village",
            "poly": null,
            "longitude": 116.5774426,
            "latitude": 50.9516108
        },
        "1905": {
            "name": "Соктуй",
            "population": 55,
            "type": "village",
            "poly": null,
            "longitude": 116.5910544,
            "latitude": 50.2518838
        },
        "1906": {
            "name": "Нижний Кокуй",
            "population": 343,
            "type": "village",
            "poly": null,
            "longitude": 116.6202512,
            "latitude": 51.5447101
        },
        "1907": {
            "name": "Турга",
            "population": 748,
            "type": "village",
            "poly": null,
            "longitude": 116.6257923,
            "latitude": 51.0515383
        },
        "1908": {
            "name": "Бородинск",
            "population": 69,
            "type": "village",
            "poly": null,
            "longitude": 116.6282635,
            "latitude": 52.9081268
        },
        "1909": {
            "name": "Калинино",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 116.65815,
            "latitude": 51.899109
        },
        "1910": {
            "name": "Старый Олов",
            "population": 891,
            "type": "village",
            "poly": [
                [
                    116.6469857,
                    52.4560705
                ],
                [
                    116.6504872,
                    52.4631357
                ],
                [
                    116.6580597,
                    52.465979
                ],
                [
                    116.6675571,
                    52.4625903
                ],
                [
                    116.6720932,
                    52.4679719
                ],
                [
                    116.6811653,
                    52.4641903
                ],
                [
                    116.6794941,
                    52.4582262
                ],
                [
                    116.6953665,
                    52.4498124
                ],
                [
                    116.6830142,
                    52.4440511
                ],
                [
                    116.6760921,
                    52.4478964
                ],
                [
                    116.6609918,
                    52.4501153
                ],
                [
                    116.6469857,
                    52.4560705
                ]
            ],
            "longitude": 116.6644108,
            "latitude": 52.4578921
        },
        "1911": {
            "name": "Харанор",
            "population": 1259,
            "type": "village",
            "poly": [
                [
                    116.6520135,
                    50.1286449
                ],
                [
                    116.6560012,
                    50.1263441
                ],
                [
                    116.665401,
                    50.1320412
                ],
                [
                    116.6683064,
                    50.130909
                ],
                [
                    116.6716105,
                    50.1314204
                ],
                [
                    116.6767377,
                    50.1312378
                ],
                [
                    116.6835738,
                    50.1280971
                ],
                [
                    116.6863083,
                    50.1246275
                ],
                [
                    116.6901252,
                    50.1257597
                ],
                [
                    116.6949675,
                    50.1183451
                ],
                [
                    116.7055635,
                    50.1099794
                ],
                [
                    116.7007213,
                    50.1063623
                ],
                [
                    116.7073865,
                    50.1025258
                ],
                [
                    116.7054496,
                    50.101795
                ],
                [
                    116.6906379,
                    50.1084084
                ],
                [
                    116.6871059,
                    50.112208
                ],
                [
                    116.6836308,
                    50.1101985
                ],
                [
                    116.679643,
                    50.1104543
                ],
                [
                    116.6767946,
                    50.1115869
                ],
                [
                    116.6778201,
                    50.1081525
                ],
                [
                    116.6608435,
                    50.1006987
                ],
                [
                    116.6594763,
                    50.10322
                ],
                [
                    116.6603308,
                    50.1082622
                ],
                [
                    116.6540643,
                    50.1173953
                ],
                [
                    116.6520135,
                    50.1286449
                ]
            ],
            "longitude": 116.678108,
            "latitude": 50.116627
        },
        "1912": {
            "name": "Лесоучасток Саранная",
            "population": 218,
            "type": "village",
            "poly": null,
            "longitude": 116.6799123,
            "latitude": 51.4349484
        },
        "1913": {
            "name": "Каменка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 116.6885367,
            "latitude": 51.5950828
        },
        "1914": {
            "name": "Ургучан",
            "population": 137,
            "type": "village",
            "poly": null,
            "longitude": 116.6923562,
            "latitude": 51.7576292
        },
        "1915": {
            "name": "Шивки",
            "population": 126,
            "type": "village",
            "poly": null,
            "longitude": 116.7032684,
            "latitude": 51.9188951
        },
        "1916": {
            "name": "Усть-Горбица",
            "population": 4,
            "type": "village",
            "poly": null,
            "longitude": 116.7301957,
            "latitude": 52.818651
        },
        "1917": {
            "name": "Алеур",
            "population": 223,
            "type": "village",
            "poly": null,
            "longitude": 116.7320868,
            "latitude": 52.0849742
        },
        "1918": {
            "name": "Ложниково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 116.7324391,
            "latitude": 51.6155262
        },
        "1919": {
            "name": "Золотореченск",
            "population": 1152,
            "type": "village",
            "poly": null,
            "longitude": 116.744385,
            "latitude": 51.055717
        },
        "1920": {
            "name": "Буторино",
            "population": 150,
            "type": "village",
            "poly": null,
            "longitude": 116.7457221,
            "latitude": 51.6265566
        },
        "1921": {
            "name": "Байгул",
            "population": 1103,
            "type": "village",
            "poly": [
                [
                    116.740883,
                    52.2492336
                ],
                [
                    116.7423243,
                    52.2521637
                ],
                [
                    116.7458323,
                    52.2525133
                ],
                [
                    116.7488508,
                    52.251298
                ],
                [
                    116.7545071,
                    52.2490338
                ],
                [
                    116.7607344,
                    52.2488174
                ],
                [
                    116.763345,
                    52.248551
                ],
                [
                    116.7614142,
                    52.2452211
                ],
                [
                    116.7592659,
                    52.2413913
                ],
                [
                    116.7562475,
                    52.2413747
                ],
                [
                    116.7506999,
                    52.2421573
                ],
                [
                    116.7432761,
                    52.2451212
                ],
                [
                    116.7442007,
                    52.2461202
                ],
                [
                    116.7441191,
                    52.2481347
                ],
                [
                    116.740883,
                    52.2492336
                ]
            ],
            "longitude": 116.7500792,
            "latitude": 52.246717
        },
        "1922": {
            "name": "Новоильинск",
            "population": 366,
            "type": "village",
            "poly": [
                [
                    116.7501599,
                    52.5235325
                ],
                [
                    116.7539365,
                    52.5249425
                ],
                [
                    116.7588288,
                    52.5181533
                ],
                [
                    116.7667253,
                    52.5103705
                ],
                [
                    116.7718751,
                    52.5035268
                ],
                [
                    116.768356,
                    52.5019593
                ],
                [
                    116.7580564,
                    52.5094824
                ],
                [
                    116.7553098,
                    52.5144971
                ],
                [
                    116.7501599,
                    52.5235325
                ]
            ],
            "longitude": 116.7593395,
            "latitude": 52.5129797
        },
        "1923": {
            "name": "Нижние Ключи",
            "population": 517,
            "type": "village",
            "poly": null,
            "longitude": 116.7647652,
            "latitude": 51.9627312
        },
        "1924": {
            "name": "Подойницыно",
            "population": 519,
            "type": "village",
            "poly": null,
            "longitude": 116.7920807,
            "latitude": 51.6508304
        },
        "1925": {
            "name": "Передняя Бырка",
            "population": 648,
            "type": "village",
            "poly": null,
            "longitude": 116.7947676,
            "latitude": 50.7284826
        },
        "1926": {
            "name": "Багульный",
            "population": 520,
            "type": "village",
            "poly": [
                [
                    116.7904294,
                    52.4114382
                ],
                [
                    116.7937879,
                    52.4130809
                ],
                [
                    116.7957587,
                    52.4123753
                ],
                [
                    116.797601,
                    52.4130809
                ],
                [
                    116.7961443,
                    52.4146227
                ],
                [
                    116.7985435,
                    52.4148057
                ],
                [
                    116.8008102,
                    52.4134929
                ],
                [
                    116.8106499,
                    52.4055672
                ],
                [
                    116.8079691,
                    52.4046914
                ],
                [
                    116.8068552,
                    52.4028879
                ],
                [
                    116.8079061,
                    52.401211
                ],
                [
                    116.806716,
                    52.400319
                ],
                [
                    116.8035562,
                    52.4023388
                ],
                [
                    116.8014569,
                    52.4024434
                ],
                [
                    116.7992719,
                    52.4038811
                ],
                [
                    116.795673,
                    52.4088733
                ],
                [
                    116.7914744,
                    52.4105459
                ],
                [
                    116.7904294,
                    52.4114382
                ]
            ],
            "longitude": 116.8016541,
            "latitude": 52.4066602
        },
        "1927": {
            "name": "Онохово",
            "population": 156,
            "type": "village",
            "poly": null,
            "longitude": 116.8138944,
            "latitude": 51.6326074
        },
        "1928": {
            "name": "Бухта",
            "population": 43,
            "type": "village",
            "poly": null,
            "longitude": 116.8169544,
            "latitude": 52.9246271
        },
        "1929": {
            "name": "Верхние Ключи",
            "population": 447,
            "type": "village",
            "poly": null,
            "longitude": 116.8178917,
            "latitude": 51.9928284
        },
        "1930": {
            "name": "Бочкарёво",
            "population": 71,
            "type": "village",
            "poly": null,
            "longitude": 116.8366351,
            "latitude": 51.669312
        },
        "1931": {
            "name": "Даурия",
            "population": 4854,
            "type": "village",
            "poly": [
                [
                    116.8246229,
                    49.9439733
                ],
                [
                    116.8383995,
                    49.9492095
                ],
                [
                    116.8402123,
                    49.9465136
                ],
                [
                    116.8444419,
                    49.9375698
                ],
                [
                    116.8533847,
                    49.9431178
                ],
                [
                    116.8608369,
                    49.9490799
                ],
                [
                    116.8675641,
                    49.9480431
                ],
                [
                    116.8710687,
                    49.9429882
                ],
                [
                    116.8701825,
                    49.9331102
                ],
                [
                    116.8686518,
                    49.93171
                ],
                [
                    116.8717132,
                    49.9297133
                ],
                [
                    116.8715924,
                    49.9277685
                ],
                [
                    116.8684906,
                    49.9225818
                ],
                [
                    116.8711896,
                    49.9176021
                ],
                [
                    116.8663556,
                    49.9150082
                ],
                [
                    116.8661542,
                    49.9135816
                ],
                [
                    116.8611189,
                    49.9122326
                ],
                [
                    116.852861,
                    49.9121289
                ],
                [
                    116.8455296,
                    49.9170314
                ],
                [
                    116.8382787,
                    49.9193139
                ],
                [
                    116.8346414,
                    49.9204867
                ],
                [
                    116.8325586,
                    49.922504
                ],
                [
                    116.832478,
                    49.9234636
                ],
                [
                    116.8283481,
                    49.9292499
                ],
                [
                    116.8362646,
                    49.9319174
                ],
                [
                    116.8305444,
                    49.9352104
                ],
                [
                    116.8246229,
                    49.9439733
                ]
            ],
            "longitude": 116.8470203,
            "latitude": 49.926261
        },
        "1932": {
            "name": "Ключевское",
            "population": 190,
            "type": "village",
            "poly": null,
            "longitude": 116.850632,
            "latitude": 50.375137
        },
        "1933": {
            "name": "Комсомольское",
            "population": 1158,
            "type": "village",
            "poly": [
                [
                    116.8260056,
                    52.353079
                ],
                [
                    116.829537,
                    52.3548114
                ],
                [
                    116.8354528,
                    52.3528584
                ],
                [
                    116.8407778,
                    52.3534609
                ],
                [
                    116.8491047,
                    52.3485232
                ],
                [
                    116.8607072,
                    52.3540614
                ],
                [
                    116.8573644,
                    52.3620533
                ],
                [
                    116.8602306,
                    52.3629811
                ],
                [
                    116.868283,
                    52.3552482
                ],
                [
                    116.8886425,
                    52.3468802
                ],
                [
                    116.8756931,
                    52.3393444
                ],
                [
                    116.8699167,
                    52.3430783
                ],
                [
                    116.8479725,
                    52.3345134
                ],
                [
                    116.8367998,
                    52.3412695
                ],
                [
                    116.8260056,
                    52.353079
                ]
            ],
            "longitude": 116.863316,
            "latitude": 52.3511551
        },
        "1934": {
            "name": "Ареда",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 116.8633563,
            "latitude": 52.3275766
        },
        "1935": {
            "name": "Верхний Кокуй",
            "population": 145,
            "type": "village",
            "poly": null,
            "longitude": 116.8638003,
            "latitude": 51.6558382
        },
        "1936": {
            "name": "Ёлкино",
            "population": 128,
            "type": "village",
            "poly": [
                [
                    116.8717743,
                    51.6904749
                ],
                [
                    116.87253,
                    51.6913522
                ],
                [
                    116.8745746,
                    51.6922051
                ],
                [
                    116.8773753,
                    51.6928639
                ],
                [
                    116.8790802,
                    51.694052
                ],
                [
                    116.8797706,
                    51.6950205
                ],
                [
                    116.8818776,
                    51.6960016
                ],
                [
                    116.8835494,
                    51.6959214
                ],
                [
                    116.8872193,
                    51.6945475
                ],
                [
                    116.889778,
                    51.6930352
                ],
                [
                    116.8898972,
                    51.6920856
                ],
                [
                    116.8878733,
                    51.6913717
                ],
                [
                    116.8861623,
                    51.6904112
                ],
                [
                    116.8803683,
                    51.689614
                ],
                [
                    116.8787498,
                    51.6903227
                ],
                [
                    116.8773361,
                    51.6904933
                ],
                [
                    116.8745383,
                    51.6899977
                ],
                [
                    116.8727792,
                    51.6893108
                ],
                [
                    116.8721039,
                    51.6897724
                ],
                [
                    116.8717743,
                    51.6904749
                ]
            ],
            "longitude": 116.8830494,
            "latitude": 51.6930223
        },
        "1937": {
            "name": "Кумаканда",
            "population": 80,
            "type": "village",
            "poly": null,
            "longitude": 116.8981216,
            "latitude": 52.7104435
        },
        "1938": {
            "name": "Унда",
            "population": 1070,
            "type": "village",
            "poly": [
                [
                    116.9048504,
                    51.7088744
                ],
                [
                    116.9072536,
                    51.7122781
                ],
                [
                    116.91618,
                    51.7132354
                ],
                [
                    116.9228748,
                    51.7129163
                ],
                [
                    116.9252781,
                    51.7160007
                ],
                [
                    116.9324878,
                    51.7158943
                ],
                [
                    116.9305996,
                    51.7116399
                ],
                [
                    116.9299129,
                    51.7083425
                ],
                [
                    116.9245914,
                    51.7083425
                ],
                [
                    116.9227031,
                    51.7103635
                ],
                [
                    116.9158367,
                    51.7066405
                ],
                [
                    116.9120601,
                    51.7072788
                ],
                [
                    116.9087986,
                    51.7065341
                ],
                [
                    116.9048504,
                    51.7088744
                ]
            ],
            "longitude": 116.9125751,
            "latitude": 51.7099381
        },
        "1939": {
            "name": "Биликтуй",
            "population": 266,
            "type": "village",
            "poly": null,
            "longitude": 116.9159476,
            "latitude": 50.7225033
        },
        "1940": {
            "name": "Мильгидун",
            "population": 717,
            "type": "village",
            "poly": null,
            "longitude": 116.919785,
            "latitude": 52.661884
        },
        "1941": {
            "name": "Лесково",
            "population": 67,
            "type": "village",
            "poly": null,
            "longitude": 116.9303235,
            "latitude": 51.7496759
        },
        "1942": {
            "name": "Нижнее Гирюнино",
            "population": 202,
            "type": "village",
            "poly": null,
            "longitude": 116.9793311,
            "latitude": 51.1960613
        },
        "1943": {
            "name": "Утан",
            "population": 1794,
            "type": "village",
            "poly": null,
            "longitude": 116.985054,
            "latitude": 52.574669
        },
        "1944": {
            "name": "Жетково",
            "population": 60,
            "type": "village",
            "poly": null,
            "longitude": 117.0057761,
            "latitude": 51.3061353
        },
        "1945": {
            "name": "Щебёночный Завод",
            "population": 15,
            "type": "village",
            "poly": null,
            "longitude": 117.0078438,
            "latitude": 52.2427866
        },
        "1946": {
            "name": "Укурей",
            "population": 809,
            "type": "village",
            "poly": null,
            "longitude": 117.0173119,
            "latitude": 52.3475462
        },
        "1947": {
            "name": "Нижняя Куэнга",
            "population": 474,
            "type": "village",
            "poly": null,
            "longitude": 117.0219254,
            "latitude": 52.0901271
        },
        "1948": {
            "name": "Казаковский Промысел",
            "population": 777,
            "type": "village",
            "poly": [
                [
                    117.0170445,
                    51.7700919
                ],
                [
                    117.0209069,
                    51.773969
                ],
                [
                    117.0190186,
                    51.7791203
                ],
                [
                    117.0209069,
                    51.7815099
                ],
                [
                    117.0328373,
                    51.7709947
                ],
                [
                    117.0265717,
                    51.7649927
                ],
                [
                    117.0184178,
                    51.7658426
                ],
                [
                    117.0170445,
                    51.7700919
                ]
            ],
            "longitude": 117.022308,
            "latitude": 51.769009
        },
        "1949": {
            "name": "Гаур",
            "population": 510,
            "type": "village",
            "poly": null,
            "longitude": 117.023781,
            "latitude": 52.446098
        },
        "1950": {
            "name": "Большое Казаково",
            "population": 147,
            "type": "village",
            "poly": [
                [
                    117.0217652,
                    51.7492666
                ],
                [
                    117.0251126,
                    51.7508075
                ],
                [
                    117.0379014,
                    51.7403385
                ],
                [
                    117.0249409,
                    51.7389034
                ],
                [
                    117.0217652,
                    51.7492666
                ]
            ],
            "longitude": 117.0284853,
            "latitude": 51.7430829
        },
        "1951": {
            "name": "Ложниково",
            "population": 157,
            "type": "village",
            "poly": null,
            "longitude": 117.0425162,
            "latitude": 51.3677254
        },
        "1952": {
            "name": "Шивия-Наделяево",
            "population": 116,
            "type": "village",
            "poly": null,
            "longitude": 117.0469444,
            "latitude": 52.2969575
        },
        "1953": {
            "name": "Дунаево",
            "population": 1141,
            "type": "village",
            "poly": null,
            "longitude": 117.0499787,
            "latitude": 52.0674978
        },
        "1954": {
            "name": "Алеур",
            "population": 1047,
            "type": "village",
            "poly": null,
            "longitude": 117.056239,
            "latitude": 52.5547715
        },
        "1955": {
            "name": "Верхняя Куэнга",
            "population": 525,
            "type": "village",
            "poly": null,
            "longitude": 117.05881,
            "latitude": 52.1338274
        },
        "1956": {
            "name": "Красный Великан",
            "population": 643,
            "type": "village",
            "poly": null,
            "longitude": 117.0613724,
            "latitude": 50.0765751
        },
        "1957": {
            "name": "Арабатук",
            "population": 162,
            "type": "village",
            "poly": null,
            "longitude": 117.0706473,
            "latitude": 50.1582504
        },
        "1958": {
            "name": "Усть-Озёрная",
            "population": 401,
            "type": "village",
            "poly": null,
            "longitude": 117.0912443,
            "latitude": 50.7034194
        },
        "1959": {
            "name": "Билитуй",
            "population": 1510,
            "type": "village",
            "poly": null,
            "longitude": 117.0998597,
            "latitude": 49.8270983
        },
        "1960": {
            "name": "Гробово",
            "population": 151,
            "type": "village",
            "poly": null,
            "longitude": 117.1204887,
            "latitude": 51.6507622
        },
        "1961": {
            "name": "Курунзулай",
            "population": 317,
            "type": "village",
            "poly": [
                [
                    117.1126548,
                    50.9456866
                ],
                [
                    117.1242373,
                    50.9489164
                ],
                [
                    117.1375187,
                    50.9393257
                ],
                [
                    117.1327434,
                    50.9293569
                ],
                [
                    117.1211035,
                    50.9294509
                ],
                [
                    117.1144121,
                    50.9354799
                ],
                [
                    117.1126548,
                    50.9456866
                ]
            ],
            "longitude": 117.121254,
            "latitude": 50.93829
        },
        "1962": {
            "name": "Алия",
            "population": 185,
            "type": "village",
            "poly": null,
            "longitude": 117.1271873,
            "latitude": 51.6263006
        },
        "1963": {
            "name": "Колобово",
            "population": 331,
            "type": "village",
            "poly": null,
            "longitude": 117.1509659,
            "latitude": 51.7659394
        },
        "1964": {
            "name": "Улей",
            "population": 33,
            "type": "village",
            "poly": null,
            "longitude": 117.1530997,
            "latitude": 52.6502826
        },
        "1965": {
            "name": "Нижний Ильдикан",
            "population": 640,
            "type": "village",
            "poly": null,
            "longitude": 117.1543534,
            "latitude": 51.6133632
        },
        "1966": {
            "name": "Цаган-Олуй",
            "population": 746,
            "type": "village",
            "poly": null,
            "longitude": 117.157631,
            "latitude": 50.470581
        },
        "1967": {
            "name": "Акурай",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 117.159813,
            "latitude": 50.761539
        },
        "1968": {
            "name": "Журавлёво",
            "population": 57,
            "type": "village",
            "poly": null,
            "longitude": 117.165265,
            "latitude": 51.5343354
        },
        "1969": {
            "name": "Икшица",
            "population": 260,
            "type": "village",
            "poly": null,
            "longitude": 117.196617,
            "latitude": 52.470169
        },
        "1970": {
            "name": "Усть-Ягьё",
            "population": 76,
            "type": "village",
            "poly": null,
            "longitude": 117.212012,
            "latitude": 51.7471423
        },
        "1971": {
            "name": "Жидка",
            "population": 321,
            "type": "village",
            "poly": null,
            "longitude": 117.2183428,
            "latitude": 51.7691166
        },
        "1972": {
            "name": "Болотово",
            "population": 220,
            "type": "village",
            "poly": null,
            "longitude": 117.2374826,
            "latitude": 52.0847304
        },
        "1973": {
            "name": "Курлыч",
            "population": 264,
            "type": "village",
            "poly": null,
            "longitude": 117.248329,
            "latitude": 52.3741235
        },
        "1974": {
            "name": "Бушулей",
            "population": 403,
            "type": "village",
            "poly": null,
            "longitude": 117.2717623,
            "latitude": 52.7489812
        },
        "1975": {
            "name": "Шоноктуй",
            "population": 287,
            "type": "village",
            "poly": [
                [
                    117.2659749,
                    50.7740126
                ],
                [
                    117.2673501,
                    50.7759618
                ],
                [
                    117.2700839,
                    50.7752789
                ],
                [
                    117.2725783,
                    50.7784807
                ],
                [
                    117.2738296,
                    50.7782772
                ],
                [
                    117.2760061,
                    50.7816649
                ],
                [
                    117.2841438,
                    50.7793056
                ],
                [
                    117.2810892,
                    50.7747652
                ],
                [
                    117.2795817,
                    50.7748405
                ],
                [
                    117.2778141,
                    50.7728822
                ],
                [
                    117.2827553,
                    50.771253
                ],
                [
                    117.290372,
                    50.7714287
                ],
                [
                    117.2914034,
                    50.7721813
                ],
                [
                    117.2927125,
                    50.772106
                ],
                [
                    117.2927919,
                    50.7710774
                ],
                [
                    117.2950189,
                    50.7665186
                ],
                [
                    117.2947964,
                    50.7651522
                ],
                [
                    117.2921968,
                    50.7656079
                ],
                [
                    117.2921175,
                    50.7666115
                ],
                [
                    117.2793437,
                    50.7682173
                ],
                [
                    117.2796611,
                    50.7688194
                ],
                [
                    117.2662277,
                    50.7710478
                ],
                [
                    117.2659749,
                    50.7740126
                ]
            ],
            "longitude": 117.2764819,
            "latitude": 50.770595
        },
        "1976": {
            "name": "Баян",
            "population": 13,
            "type": "village",
            "poly": null,
            "longitude": 117.3019561,
            "latitude": 52.1044532
        },
        "1977": {
            "name": "Онон-Борзя",
            "population": 305,
            "type": "village",
            "poly": [
                [
                    117.3099048,
                    51.0645471
                ],
                [
                    117.3264082,
                    51.0770802
                ],
                [
                    117.3318459,
                    51.0656291
                ],
                [
                    117.3248895,
                    51.0551291
                ],
                [
                    117.3141573,
                    51.0523288
                ],
                [
                    117.3099048,
                    51.0645471
                ]
            ],
            "longitude": 117.3244845,
            "latitude": 51.0650561
        },
        "1978": {
            "name": "Верхний Тергень",
            "population": 104,
            "type": "village",
            "poly": null,
            "longitude": 117.3522881,
            "latitude": 51.7371671
        },
        "1979": {
            "name": "Кулан",
            "population": 119,
            "type": "village",
            "poly": null,
            "longitude": 117.3550651,
            "latitude": 52.4007842
        },
        "1980": {
            "name": "Кокертай",
            "population": 5,
            "type": "village",
            "poly": null,
            "longitude": 117.3581874,
            "latitude": 52.1251144
        },
        "1981": {
            "name": "Усть-Наринзор",
            "population": 663,
            "type": "village",
            "poly": [
                [
                    117.3373706,
                    52.2685209
                ],
                [
                    117.3610394,
                    52.2712435
                ],
                [
                    117.3633528,
                    52.2733125
                ],
                [
                    117.3758694,
                    52.2720057
                ],
                [
                    117.3733186,
                    52.2621677
                ],
                [
                    117.3653697,
                    52.2619497
                ],
                [
                    117.3608614,
                    52.2586095
                ],
                [
                    117.352082,
                    52.2596261
                ],
                [
                    117.3376672,
                    52.2665606
                ],
                [
                    117.3373706,
                    52.2685209
                ]
            ],
            "longitude": 117.360412,
            "latitude": 52.2661547
        },
        "1982": {
            "name": "Селекционная",
            "population": 87,
            "type": "village",
            "poly": null,
            "longitude": 117.3689661,
            "latitude": 51.8119122
        },
        "1983": {
            "name": "Шаранча",
            "population": 390,
            "type": "village",
            "poly": [
                [
                    117.3451087,
                    50.9304262
                ],
                [
                    117.3488377,
                    50.9357764
                ],
                [
                    117.3517336,
                    50.9362264
                ],
                [
                    117.354883,
                    50.9381639
                ],
                [
                    117.3570494,
                    50.9381764
                ],
                [
                    117.3617304,
                    50.9372514
                ],
                [
                    117.3631189,
                    50.9365514
                ],
                [
                    117.3669272,
                    50.9366764
                ],
                [
                    117.3691487,
                    50.9371764
                ],
                [
                    117.3753373,
                    50.9411511
                ],
                [
                    117.3792249,
                    50.9424009
                ],
                [
                    117.3806057,
                    50.9414152
                ],
                [
                    117.3786695,
                    50.9396512
                ],
                [
                    117.3764084,
                    50.9387763
                ],
                [
                    117.3774398,
                    50.9359264
                ],
                [
                    117.3821784,
                    50.9355503
                ],
                [
                    117.3835323,
                    50.9358472
                ],
                [
                    117.3842017,
                    50.9339198
                ],
                [
                    117.3802564,
                    50.9330014
                ],
                [
                    117.3789472,
                    50.9316263
                ],
                [
                    117.3794506,
                    50.9301663
                ],
                [
                    117.3727809,
                    50.9287525
                ],
                [
                    117.3592709,
                    50.9295511
                ],
                [
                    117.3570494,
                    50.9266006
                ],
                [
                    117.3457369,
                    50.9282003
                ],
                [
                    117.3451087,
                    50.9304262
                ]
            ],
            "longitude": 117.3703754,
            "latitude": 50.9324879
        },
        "1984": {
            "name": "Кутугай",
            "population": 252,
            "type": "village",
            "poly": [
                [
                    117.3560857,
                    50.8521743
                ],
                [
                    117.3578389,
                    50.8538124
                ],
                [
                    117.3571095,
                    50.8539186
                ],
                [
                    117.3587859,
                    50.8558724
                ],
                [
                    117.3668713,
                    50.856495
                ],
                [
                    117.3673481,
                    50.8569821
                ],
                [
                    117.3666609,
                    50.857292
                ],
                [
                    117.3667731,
                    50.8576373
                ],
                [
                    117.3677128,
                    50.8574425
                ],
                [
                    117.3683644,
                    50.8578493
                ],
                [
                    117.3698137,
                    50.858832
                ],
                [
                    117.3790197,
                    50.8586729
                ],
                [
                    117.3865701,
                    50.8546588
                ],
                [
                    117.3827225,
                    50.8536793
                ],
                [
                    117.3814882,
                    50.8540335
                ],
                [
                    117.3768318,
                    50.8519793
                ],
                [
                    117.3756793,
                    50.8522628
                ],
                [
                    117.375006,
                    50.8516961
                ],
                [
                    117.3754829,
                    50.8510497
                ],
                [
                    117.3752164,
                    50.8508461
                ],
                [
                    117.3733791,
                    50.8516253
                ],
                [
                    117.3724698,
                    50.8508901
                ],
                [
                    117.3711938,
                    50.8519952
                ],
                [
                    117.3691458,
                    50.8514391
                ],
                [
                    117.3675469,
                    50.8499338
                ],
                [
                    117.3668456,
                    50.8480919
                ],
                [
                    117.369466,
                    50.8472154
                ],
                [
                    117.3695081,
                    50.8461173
                ],
                [
                    117.368947,
                    50.8449041
                ],
                [
                    117.3675725,
                    50.8444524
                ],
                [
                    117.3643747,
                    50.8449572
                ],
                [
                    117.3632246,
                    50.8458694
                ],
                [
                    117.3620605,
                    50.8480921
                ],
                [
                    117.3621447,
                    50.8493584
                ],
                [
                    117.3627337,
                    50.8500226
                ],
                [
                    117.3612453,
                    50.853271
                ],
                [
                    117.3585822,
                    50.852617
                ],
                [
                    117.3568979,
                    50.8516901
                ],
                [
                    117.3560857,
                    50.8521743
                ]
            ],
            "longitude": 117.374275,
            "latitude": 50.854218
        },
        "1985": {
            "name": "Средний Калар",
            "population": 94,
            "type": "village",
            "poly": null,
            "longitude": 117.379738,
            "latitude": 55.861233
        },
        "1986": {
            "name": "Глинянка",
            "population": 188,
            "type": "village",
            "poly": null,
            "longitude": 117.4048873,
            "latitude": 51.6594915
        },
        "1987": {
            "name": "Шивия",
            "population": 406,
            "type": "village",
            "poly": null,
            "longitude": 117.4285303,
            "latitude": 51.8900529
        },
        "1988": {
            "name": "Мыгжа",
            "population": 8,
            "type": "village",
            "poly": null,
            "longitude": 117.4294929,
            "latitude": 52.344813
        },
        "1989": {
            "name": "Верх-Ягьё",
            "population": 132,
            "type": "village",
            "poly": null,
            "longitude": 117.4349594,
            "latitude": 51.623283
        },
        "1990": {
            "name": "Дая",
            "population": 147,
            "type": "village",
            "poly": null,
            "longitude": 117.4454788,
            "latitude": 51.7950371
        },
        "1991": {
            "name": "Делюн",
            "population": 62,
            "type": "village",
            "poly": null,
            "longitude": 117.4484929,
            "latitude": 52.2115874
        },
        "1992": {
            "name": "Клин",
            "population": 138,
            "type": "village",
            "poly": [
                [
                    117.4538212,
                    50.9930182
                ],
                [
                    117.4585798,
                    50.9990718
                ],
                [
                    117.4658696,
                    51.0000276
                ],
                [
                    117.4653634,
                    50.9936555
                ],
                [
                    117.4720458,
                    50.9912976
                ],
                [
                    117.4645285,
                    50.9896263
                ],
                [
                    117.4584786,
                    50.9893219
                ],
                [
                    117.4538212,
                    50.9930182
                ]
            ],
            "longitude": 117.4601998,
            "latitude": 50.9938467
        },
        "1993": {
            "name": "Усть-Курлыч",
            "population": 194,
            "type": "village",
            "poly": null,
            "longitude": 117.46078,
            "latitude": 52.16497
        },
        "1994": {
            "name": "Степной",
            "population": 650,
            "type": "village",
            "poly": null,
            "longitude": 117.4663332,
            "latitude": 50.0142742
        },
        "1995": {
            "name": "Кондуй",
            "population": 557,
            "type": "village",
            "poly": null,
            "longitude": 117.4763701,
            "latitude": 50.5570742
        },
        "1996": {
            "name": "Кириллиха",
            "population": 173,
            "type": "village",
            "poly": [
                [
                    117.4738816,
                    50.9277066
                ],
                [
                    117.4780766,
                    50.9299342
                ],
                [
                    117.4796475,
                    50.9311187
                ],
                [
                    117.4814988,
                    50.9317729
                ],
                [
                    117.4796475,
                    50.9323563
                ],
                [
                    117.4816506,
                    50.933362
                ],
                [
                    117.482705,
                    50.9352025
                ],
                [
                    117.4827841,
                    50.9376503
                ],
                [
                    117.484865,
                    50.937907
                ],
                [
                    117.490241,
                    50.9335746
                ],
                [
                    117.4927192,
                    50.936051
                ],
                [
                    117.4980425,
                    50.9373195
                ],
                [
                    117.4989465,
                    50.9363338
                ],
                [
                    117.496983,
                    50.9353262
                ],
                [
                    117.495917,
                    50.9343008
                ],
                [
                    117.4967025,
                    50.9326214
                ],
                [
                    117.4928875,
                    50.9324269
                ],
                [
                    117.4909801,
                    50.9318259
                ],
                [
                    117.4895495,
                    50.9298811
                ],
                [
                    117.4894092,
                    50.9282192
                ],
                [
                    117.4899029,
                    50.9271863
                ],
                [
                    117.4914008,
                    50.9263805
                ],
                [
                    117.4914569,
                    50.9243294
                ],
                [
                    117.4890734,
                    50.9240318
                ],
                [
                    117.4863096,
                    50.9240925
                ],
                [
                    117.4865271,
                    50.9251148
                ],
                [
                    117.4822562,
                    50.9263274
                ],
                [
                    117.4774595,
                    50.9263981
                ],
                [
                    117.47443,
                    50.9265573
                ],
                [
                    117.4738816,
                    50.9277066
                ]
            ],
            "longitude": 117.484459,
            "latitude": 50.930374
        },
        "1997": {
            "name": "Чикичей",
            "population": 398,
            "type": "village",
            "poly": null,
            "longitude": 117.4935283,
            "latitude": 52.3680648
        },
        "1998": {
            "name": "Адом",
            "population": 95,
            "type": "village",
            "poly": null,
            "longitude": 117.5123607,
            "latitude": 52.4386735
        },
        "1999": {
            "name": "Купряково",
            "population": 82,
            "type": "village",
            "poly": [
                [
                    117.5336907,
                    51.6890793
                ],
                [
                    117.5416562,
                    51.692716
                ],
                [
                    117.5462849,
                    51.6870439
                ],
                [
                    117.5388575,
                    51.6840074
                ],
                [
                    117.5336907,
                    51.6890793
                ]
            ],
            "longitude": 117.540526,
            "latitude": 51.6880449
        },
        "2000": {
            "name": "Даякон",
            "population": 208,
            "type": "village",
            "poly": null,
            "longitude": 117.5446418,
            "latitude": 51.8244522
        },
        "2001": {
            "name": "Шелопугино",
            "population": 3315,
            "type": "village",
            "poly": null,
            "longitude": 117.564728,
            "latitude": 51.649864
        },
        "2002": {
            "name": "Ишикан",
            "population": 111,
            "type": "village",
            "poly": null,
            "longitude": 117.5681835,
            "latitude": 51.9680794
        },
        "2003": {
            "name": "Алия",
            "population": 579,
            "type": "village",
            "poly": null,
            "longitude": 117.6156041,
            "latitude": 52.3169241
        },
        "2004": {
            "name": "Ковыли",
            "population": 700,
            "type": "village",
            "poly": null,
            "longitude": 117.616409,
            "latitude": 50.372738
        },
        "2005": {
            "name": "Некрасово",
            "population": 62,
            "type": "village",
            "poly": [
                [
                    117.6304873,
                    52.0216179
                ],
                [
                    117.6305229,
                    52.0227186
                ],
                [
                    117.6343988,
                    52.0266807
                ],
                [
                    117.6358772,
                    52.0271175
                ],
                [
                    117.6386284,
                    52.0226704
                ],
                [
                    117.6387011,
                    52.0213416
                ],
                [
                    117.637713,
                    52.0208838
                ],
                [
                    117.6382956,
                    52.0200001
                ],
                [
                    117.6354283,
                    52.0176214
                ],
                [
                    117.6335967,
                    52.0174376
                ],
                [
                    117.6304873,
                    52.0216179
                ]
            ],
            "longitude": 117.6363383,
            "latitude": 52.0216078
        },
        "2006": {
            "name": "Мироново",
            "population": 323,
            "type": "village",
            "poly": [
                [
                    117.6380359,
                    51.9660903
                ],
                [
                    117.6385663,
                    51.9687411
                ],
                [
                    117.6414544,
                    51.9695763
                ],
                [
                    117.6465232,
                    51.9695037
                ],
                [
                    117.6473483,
                    51.9708472
                ],
                [
                    117.6395351,
                    51.9715508
                ],
                [
                    117.6385663,
                    51.9743329
                ],
                [
                    117.6395683,
                    51.9770196
                ],
                [
                    117.6396245,
                    51.9864869
                ],
                [
                    117.640662,
                    51.9898206
                ],
                [
                    117.6442529,
                    51.9900501
                ],
                [
                    117.6486188,
                    51.9858005
                ],
                [
                    117.6480166,
                    51.9844226
                ],
                [
                    117.6482233,
                    51.9813252
                ],
                [
                    117.6498767,
                    51.9802516
                ],
                [
                    117.6499402,
                    51.9796302
                ],
                [
                    117.6482922,
                    51.9789847
                ],
                [
                    117.653214,
                    51.9760756
                ],
                [
                    117.6535271,
                    51.9743574
                ],
                [
                    117.6567833,
                    51.9721185
                ],
                [
                    117.6567424,
                    51.9700658
                ],
                [
                    117.651133,
                    51.9689988
                ],
                [
                    117.6423974,
                    51.9651461
                ],
                [
                    117.6395094,
                    51.965255
                ],
                [
                    117.6380359,
                    51.9660903
                ]
            ],
            "longitude": 117.6452781,
            "latitude": 51.9790935
        },
        "2007": {
            "name": "Копунь",
            "population": 537,
            "type": "village",
            "poly": [
                [
                    117.6331761,
                    51.8923894
                ],
                [
                    117.6468417,
                    51.9008222
                ],
                [
                    117.6534643,
                    51.8953086
                ],
                [
                    117.6508363,
                    51.8814244
                ],
                [
                    117.6610329,
                    51.8650692
                ],
                [
                    117.6547697,
                    51.8601064
                ],
                [
                    117.6513619,
                    51.8602654
                ],
                [
                    117.6430574,
                    51.8846687
                ],
                [
                    117.6331761,
                    51.8923894
                ]
            ],
            "longitude": 117.6510465,
            "latitude": 51.8745455
        },
        "2008": {
            "name": "Богданово",
            "population": 33,
            "type": "village",
            "poly": [
                [
                    117.6481572,
                    51.9940555
                ],
                [
                    117.6506995,
                    51.9952102
                ],
                [
                    117.6495742,
                    51.9979816
                ],
                [
                    117.650296,
                    52.0004956
                ],
                [
                    117.6518665,
                    52.0006758
                ],
                [
                    117.6561228,
                    51.9951604
                ],
                [
                    117.6572467,
                    51.9912597
                ],
                [
                    117.6529084,
                    51.9907193
                ],
                [
                    117.6504255,
                    51.9893187
                ],
                [
                    117.6489908,
                    51.9908476
                ],
                [
                    117.6495326,
                    51.9926954
                ],
                [
                    117.6484073,
                    51.9926954
                ],
                [
                    117.6481572,
                    51.9940555
                ]
            ],
            "longitude": 117.6525359,
            "latitude": 51.994658
        },
        "2009": {
            "name": "Николаевка",
            "population": 156,
            "type": "village",
            "poly": [
                [
                    117.6364232,
                    51.0141601
                ],
                [
                    117.6367654,
                    51.0148556
                ],
                [
                    117.6396082,
                    51.0147728
                ],
                [
                    117.6428195,
                    51.0139779
                ],
                [
                    117.6446621,
                    51.0150709
                ],
                [
                    117.6445042,
                    51.0171905
                ],
                [
                    117.6424805,
                    51.0191119
                ],
                [
                    117.6423984,
                    51.02032
                ],
                [
                    117.6451885,
                    51.0215287
                ],
                [
                    117.6460572,
                    51.0199061
                ],
                [
                    117.6477944,
                    51.0183165
                ],
                [
                    117.6505846,
                    51.0175051
                ],
                [
                    117.6554016,
                    51.0211314
                ],
                [
                    117.6584023,
                    51.0204525
                ],
                [
                    117.6601659,
                    51.0168759
                ],
                [
                    117.6601103,
                    51.0156982
                ],
                [
                    117.6612977,
                    51.0147728
                ],
                [
                    117.6633509,
                    51.014276
                ],
                [
                    117.6650355,
                    51.0143423
                ],
                [
                    117.6669833,
                    51.0152034
                ],
                [
                    117.6674571,
                    51.019459
                ],
                [
                    117.6696945,
                    51.0192769
                ],
                [
                    117.6706421,
                    51.0185649
                ],
                [
                    117.6711935,
                    51.0131501
                ],
                [
                    117.665483,
                    51.0106989
                ],
                [
                    117.6638247,
                    51.0085459
                ],
                [
                    117.6588642,
                    51.0086015
                ],
                [
                    117.6530589,
                    51.0103511
                ],
                [
                    117.650295,
                    51.0106161
                ],
                [
                    117.6494001,
                    51.0091918
                ],
                [
                    117.647347,
                    51.0093243
                ],
                [
                    117.6459782,
                    51.0113117
                ],
                [
                    117.6428094,
                    51.0128818
                ],
                [
                    117.6388052,
                    51.0123689
                ],
                [
                    117.6380815,
                    51.0132659
                ],
                [
                    117.6364232,
                    51.0141601
                ]
            ],
            "longitude": 117.6543476,
            "latitude": 51.0144819
        },
        "2010": {
            "name": "Банщиково",
            "population": 123,
            "type": "village",
            "poly": null,
            "longitude": 117.65633,
            "latitude": 51.58445
        },
        "2011": {
            "name": "Малышево",
            "population": 161,
            "type": "village",
            "poly": null,
            "longitude": 117.6679549,
            "latitude": 51.5388709
        },
        "2012": {
            "name": "Нижняя Шахтама",
            "population": 267,
            "type": "village",
            "poly": null,
            "longitude": 117.6877465,
            "latitude": 51.3911086
        },
        "2013": {
            "name": "Ундинские Кавыкучи",
            "population": 60,
            "type": "village",
            "poly": null,
            "longitude": 117.6971073,
            "latitude": 51.4427024
        },
        "2014": {
            "name": "Моргул",
            "population": 50,
            "type": "village",
            "poly": null,
            "longitude": 117.7105367,
            "latitude": 52.2614
        },
        "2015": {
            "name": "Маньково",
            "population": 380,
            "type": "village",
            "poly": null,
            "longitude": 117.7137791,
            "latitude": 50.8579893
        },
        "2016": {
            "name": "Чонгуль",
            "population": 55,
            "type": "village",
            "poly": null,
            "longitude": 117.7248752,
            "latitude": 51.9528123
        },
        "2017": {
            "name": "Средняя Шахтама",
            "population": 3,
            "type": "village",
            "poly": null,
            "longitude": 117.7365118,
            "latitude": 51.3446566
        },
        "2018": {
            "name": "Большой Тонтой",
            "population": 214,
            "type": "village",
            "poly": null,
            "longitude": 117.7600675,
            "latitude": 51.8288755
        },
        "2019": {
            "name": "Новый Акатуй",
            "population": 813,
            "type": "village",
            "poly": [
                [
                    117.7607662,
                    51.0472256
                ],
                [
                    117.7609161,
                    51.0510911
                ],
                [
                    117.7633157,
                    51.0518925
                ],
                [
                    117.7645155,
                    51.0544378
                ],
                [
                    117.7677399,
                    51.0554276
                ],
                [
                    117.7740387,
                    51.053118
                ],
                [
                    117.772614,
                    51.0569359
                ],
                [
                    117.7753885,
                    51.0577843
                ],
                [
                    117.7747136,
                    51.0599523
                ],
                [
                    117.7717141,
                    51.0595281
                ],
                [
                    117.772614,
                    51.0627328
                ],
                [
                    117.7672899,
                    51.0652305
                ],
                [
                    117.7732139,
                    51.0692358
                ],
                [
                    117.777638,
                    51.0660787
                ],
                [
                    117.7790628,
                    51.0612248
                ],
                [
                    117.7818373,
                    51.0628271
                ],
                [
                    117.7856616,
                    51.0626386
                ],
                [
                    117.7866364,
                    51.0544378
                ],
                [
                    117.7849396,
                    51.0426026
                ],
                [
                    117.7730639,
                    51.0440198
                ],
                [
                    117.7714892,
                    51.0490641
                ],
                [
                    117.7607662,
                    51.0472256
                ]
            ],
            "longitude": 117.776878,
            "latitude": 51.048714
        },
        "2020": {
            "name": "Соктуй-Милозан",
            "population": 809,
            "type": "village",
            "poly": null,
            "longitude": 117.781151,
            "latitude": 50.075806
        },
        "2021": {
            "name": "Старый Акатуй",
            "population": 212,
            "type": "village",
            "poly": [
                [
                    117.7774131,
                    51.0290723
                ],
                [
                    117.7801876,
                    51.0363816
                ],
                [
                    117.7843118,
                    51.0398708
                ],
                [
                    117.7891109,
                    51.0379847
                ],
                [
                    117.7864114,
                    51.0287893
                ],
                [
                    117.7874612,
                    51.0245918
                ],
                [
                    117.7827371,
                    51.0240257
                ],
                [
                    117.7812374,
                    51.0283177
                ],
                [
                    117.7774131,
                    51.0290723
                ]
            ],
            "longitude": 117.783187,
            "latitude": 51.0321376
        },
        "2022": {
            "name": "Малый Тонтой",
            "population": 275,
            "type": "village",
            "poly": null,
            "longitude": 117.7881675,
            "latitude": 51.8359604
        },
        "2023": {
            "name": "Базаново",
            "population": 105,
            "type": "village",
            "poly": [
                [
                    117.7807631,
                    50.9525825
                ],
                [
                    117.7875051,
                    50.9546267
                ],
                [
                    117.79347,
                    50.9575042
                ],
                [
                    117.7957691,
                    50.9559164
                ],
                [
                    117.7986463,
                    50.9548899
                ],
                [
                    117.7995973,
                    50.955723
                ],
                [
                    117.7989393,
                    50.9562039
                ],
                [
                    117.7994544,
                    50.957042
                ],
                [
                    117.8031769,
                    50.9579564
                ],
                [
                    117.8038469,
                    50.9560337
                ],
                [
                    117.7991938,
                    50.954744
                ],
                [
                    117.7984918,
                    50.9538328
                ],
                [
                    117.7988077,
                    50.9529208
                ],
                [
                    117.7982812,
                    50.9515776
                ],
                [
                    117.797202,
                    50.9515279
                ],
                [
                    117.7965703,
                    50.9511133
                ],
                [
                    117.7973073,
                    50.9504666
                ],
                [
                    117.7969388,
                    50.9499525
                ],
                [
                    117.7955177,
                    50.9496768
                ],
                [
                    117.7976676,
                    50.947779
                ],
                [
                    117.7974491,
                    50.9471733
                ],
                [
                    117.7808418,
                    50.9485997
                ],
                [
                    117.7811557,
                    50.9495093
                ],
                [
                    117.7807631,
                    50.9525825
                ]
            ],
            "longitude": 117.789215,
            "latitude": 50.952305
        },
        "2024": {
            "name": "Васильевский Хутор",
            "population": 313,
            "type": "village",
            "poly": null,
            "longitude": 117.80233,
            "latitude": 50.526073
        },
        "2025": {
            "name": "Абагайтуй",
            "population": 932,
            "type": "village",
            "poly": null,
            "longitude": 117.829453,
            "latitude": 49.585087
        },
        "2026": {
            "name": "Журавлёво",
            "population": 155,
            "type": "village",
            "poly": null,
            "longitude": 117.831276,
            "latitude": 50.907158
        },
        "2027": {
            "name": "Деревцово",
            "population": 88,
            "type": "village",
            "poly": null,
            "longitude": 117.834168,
            "latitude": 51.8762043
        },
        "2028": {
            "name": "Молодовск",
            "population": 306,
            "type": "village",
            "poly": null,
            "longitude": 117.8730211,
            "latitude": 52.2612911
        },
        "2029": {
            "name": "Маргуцек",
            "population": 1394,
            "type": "village",
            "poly": null,
            "longitude": 117.889397,
            "latitude": 50.40424
        },
        "2030": {
            "name": "Вершино-Шахтаминский",
            "population": 1432,
            "type": "village",
            "poly": null,
            "longitude": 117.889755,
            "latitude": 51.299221
        },
        "2031": {
            "name": "Рудник Абагайтуй",
            "population": 548,
            "type": "village",
            "poly": null,
            "longitude": 117.891159,
            "latitude": 49.70787
        },
        "2032": {
            "name": "Манкечур",
            "population": 481,
            "type": "village",
            "poly": null,
            "longitude": 117.909172,
            "latitude": 50.654545
        },
        "2033": {
            "name": "Ульякан",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 117.92777,
            "latitude": 53.1573227
        },
        "2034": {
            "name": "Александровский Завод",
            "population": 2651,
            "type": "village",
            "poly": [
                [
                    117.905609,
                    50.9284032
                ],
                [
                    117.905872,
                    50.9311699
                ],
                [
                    117.9132721,
                    50.9315459
                ],
                [
                    117.9163689,
                    50.9303219
                ],
                [
                    117.9196755,
                    50.9309505
                ],
                [
                    117.9238011,
                    50.9302342
                ],
                [
                    117.9269712,
                    50.9312482
                ],
                [
                    117.9293331,
                    50.9343576
                ],
                [
                    117.9303829,
                    50.9347546
                ],
                [
                    117.9357127,
                    50.9342019
                ],
                [
                    117.9381536,
                    50.9357449
                ],
                [
                    117.9387375,
                    50.9356706
                ],
                [
                    117.9391643,
                    50.9349806
                ],
                [
                    117.9401293,
                    50.9346883
                ],
                [
                    117.9411128,
                    50.9345596
                ],
                [
                    117.9413355,
                    50.9349572
                ],
                [
                    117.94135,
                    50.9353904
                ],
                [
                    117.9512654,
                    50.9246897
                ],
                [
                    117.9549377,
                    50.9229453
                ],
                [
                    117.9604735,
                    50.9196184
                ],
                [
                    117.9575828,
                    50.9154532
                ],
                [
                    117.955426,
                    50.9164831
                ],
                [
                    117.9493394,
                    50.9135816
                ],
                [
                    117.951195,
                    50.9106331
                ],
                [
                    117.9498014,
                    50.9097842
                ],
                [
                    117.9413228,
                    50.9103055
                ],
                [
                    117.9379083,
                    50.9129264
                ],
                [
                    117.9318481,
                    50.9146037
                ],
                [
                    117.9161396,
                    50.9143564
                ],
                [
                    117.911545,
                    50.9181604
                ],
                [
                    117.9163164,
                    50.9210585
                ],
                [
                    117.9140594,
                    50.9233083
                ],
                [
                    117.9092831,
                    50.9237715
                ],
                [
                    117.9066588,
                    50.9261867
                ],
                [
                    117.905609,
                    50.9284032
                ]
            ],
            "longitude": 117.934097,
            "latitude": 50.923641
        },
        "2035": {
            "name": "Верхний Аленуй",
            "population": 192,
            "type": "village",
            "poly": null,
            "longitude": 117.9702248,
            "latitude": 51.1414764
        },
        "2036": {
            "name": "Почекуй",
            "population": 39,
            "type": "village",
            "poly": null,
            "longitude": 117.9901454,
            "latitude": 50.5302567
        },
        "2037": {
            "name": "Ломы",
            "population": 393,
            "type": "village",
            "poly": null,
            "longitude": 117.9989232,
            "latitude": 52.2854657
        },
        "2038": {
            "name": "Кличка",
            "population": 1503,
            "type": "village",
            "poly": null,
            "longitude": 117.999504,
            "latitude": 50.442791
        },
        "2039": {
            "name": "Кокуй 2-й",
            "population": 184,
            "type": "village",
            "poly": null,
            "longitude": 118.000053,
            "latitude": 51.055096
        },
        "2040": {
            "name": "Брусиловка",
            "population": 127,
            "type": "village",
            "poly": null,
            "longitude": 118.013557,
            "latitude": 49.677666
        },
        "2041": {
            "name": "Ералга",
            "population": 40,
            "type": "village",
            "poly": null,
            "longitude": 118.070536,
            "latitude": 52.3132274
        },
        "2042": {
            "name": "Мулино",
            "population": 190,
            "type": "village",
            "poly": null,
            "longitude": 118.07362,
            "latitude": 50.5448595
        },
        "2043": {
            "name": "Урюм",
            "population": 627,
            "type": "village",
            "poly": null,
            "longitude": 118.1099274,
            "latitude": 53.1688275
        },
        "2044": {
            "name": "Целинный",
            "population": 1793,
            "type": "village",
            "poly": [
                [
                    118.0960845,
                    50.2674677
                ],
                [
                    118.0970276,
                    50.2684228
                ],
                [
                    118.0999664,
                    50.2693269
                ],
                [
                    118.1021435,
                    50.2716991
                ],
                [
                    118.1048925,
                    50.2706951
                ],
                [
                    118.1078098,
                    50.2705875
                ],
                [
                    118.1089073,
                    50.2720433
                ],
                [
                    118.1204327,
                    50.2708743
                ],
                [
                    118.1291846,
                    50.2707667
                ],
                [
                    118.1289041,
                    50.2680774
                ],
                [
                    118.1335721,
                    50.2638756
                ],
                [
                    118.1364217,
                    50.2610483
                ],
                [
                    118.1356516,
                    50.2567293
                ],
                [
                    118.1303387,
                    50.2513447
                ],
                [
                    118.1111049,
                    50.2580221
                ],
                [
                    118.0984764,
                    50.2635263
                ],
                [
                    118.096365,
                    50.2655312
                ],
                [
                    118.0960845,
                    50.2674677
                ]
            ],
            "longitude": 118.109993,
            "latitude": 50.265282
        },
        "2045": {
            "name": "Бори",
            "population": 273,
            "type": "village",
            "poly": null,
            "longitude": 118.1110964,
            "latitude": 52.4741638
        },
        "2046": {
            "name": "Урулюнгуй",
            "population": 1793,
            "type": "village",
            "poly": null,
            "longitude": 118.1119506,
            "latitude": 50.2695464
        },
        "2047": {
            "name": "Бутунтай",
            "population": 420,
            "type": "village",
            "poly": [
                [
                    118.1119171,
                    50.6569513
                ],
                [
                    118.1130722,
                    50.6598805
                ],
                [
                    118.1156047,
                    50.6632038
                ],
                [
                    118.1283114,
                    50.661852
                ],
                [
                    118.1323544,
                    50.6487402
                ],
                [
                    118.1173374,
                    50.6514868
                ],
                [
                    118.1144495,
                    50.6520502
                ],
                [
                    118.1119171,
                    50.6569513
                ]
            ],
            "longitude": 118.1189781,
            "latitude": 50.6575569
        },
        "2048": {
            "name": "Фирсово",
            "population": 543,
            "type": "village",
            "poly": null,
            "longitude": 118.127373,
            "latitude": 52.313564
        },
        "2049": {
            "name": "Новоивановка",
            "population": 284,
            "type": "village",
            "poly": [
                [
                    118.1484776,
                    50.3724933
                ],
                [
                    118.1485282,
                    50.3742016
                ],
                [
                    118.1503829,
                    50.3760623
                ],
                [
                    118.1498263,
                    50.3768842
                ],
                [
                    118.1500021,
                    50.3780425
                ],
                [
                    118.1504713,
                    50.3788779
                ],
                [
                    118.1579113,
                    50.3785282
                ],
                [
                    118.159974,
                    50.3779212
                ],
                [
                    118.1625396,
                    50.3777062
                ],
                [
                    118.1642227,
                    50.3771338
                ],
                [
                    118.1675264,
                    50.3728737
                ],
                [
                    118.1695407,
                    50.3675614
                ],
                [
                    118.1716498,
                    50.3676735
                ],
                [
                    118.1728801,
                    50.368589
                ],
                [
                    118.1767761,
                    50.3681032
                ],
                [
                    118.1762602,
                    50.3658353
                ],
                [
                    118.1702144,
                    50.3652444
                ],
                [
                    118.164861,
                    50.3678795
                ],
                [
                    118.160614,
                    50.3695682
                ],
                [
                    118.1556934,
                    50.3699135
                ],
                [
                    118.1510303,
                    50.3709949
                ],
                [
                    118.1484776,
                    50.3724933
                ]
            ],
            "longitude": 118.1576761,
            "latitude": 50.3735603
        },
        "2050": {
            "name": "Кудея",
            "population": 130,
            "type": "village",
            "poly": null,
            "longitude": 118.162353,
            "latitude": 52.3863377
        },
        "2051": {
            "name": "Бохто",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 118.1812478,
            "latitude": 51.0646071
        },
        "2052": {
            "name": "Газимурские Кавыкучи",
            "population": 143,
            "type": "village",
            "poly": null,
            "longitude": 118.1830273,
            "latitude": 51.3615071
        },
        "2053": {
            "name": "Трубачёво",
            "population": 556,
            "type": "village",
            "poly": null,
            "longitude": 118.2014274,
            "latitude": 51.4048849
        },
        "2054": {
            "name": "Догьё",
            "population": 84,
            "type": "village",
            "poly": null,
            "longitude": 118.2233101,
            "latitude": 51.4940393
        },
        "2055": {
            "name": "Красноярово",
            "population": 163,
            "type": "village",
            "poly": null,
            "longitude": 118.2337253,
            "latitude": 51.2549003
        },
        "2056": {
            "name": "Чиндагатай",
            "population": 518,
            "type": "village",
            "poly": null,
            "longitude": 118.2366243,
            "latitude": 50.7643285
        },
        "2057": {
            "name": "Чара",
            "population": 2266,
            "type": "village",
            "poly": null,
            "longitude": 118.260986,
            "latitude": 56.902946
        },
        "2058": {
            "name": "Среднеаргунск",
            "population": 317,
            "type": "village",
            "poly": null,
            "longitude": 118.261604,
            "latitude": 49.746487
        },
        "2059": {
            "name": "Уктыча",
            "population": 80,
            "type": "village",
            "poly": null,
            "longitude": 118.268976,
            "latitude": 52.3317101
        },
        "2060": {
            "name": "Корабль",
            "population": 115,
            "type": "village",
            "poly": null,
            "longitude": 118.2898088,
            "latitude": 51.5281974
        },
        "2061": {
            "name": "Игдоча",
            "population": 281,
            "type": "village",
            "poly": null,
            "longitude": 118.3145898,
            "latitude": 51.5680835
        },
        "2062": {
            "name": "Кузнецово",
            "population": 248,
            "type": "village",
            "poly": null,
            "longitude": 118.315002,
            "latitude": 51.098988
        },
        "2063": {
            "name": "Кюсть-Кемда",
            "population": 315,
            "type": "village",
            "poly": [
                [
                    118.3095143,
                    56.9591518
                ],
                [
                    118.3157412,
                    56.9668356
                ],
                [
                    118.3201759,
                    56.97071
                ],
                [
                    118.3286808,
                    56.9668687
                ],
                [
                    118.3155589,
                    56.9602449
                ],
                [
                    118.3118228,
                    56.9579925
                ],
                [
                    118.3095143,
                    56.9591518
                ]
            ],
            "longitude": 118.318939,
            "latitude": 56.965942
        },
        "2064": {
            "name": "Павловск",
            "population": 155,
            "type": "village",
            "poly": null,
            "longitude": 118.3256457,
            "latitude": 51.5094874
        },
        "2065": {
            "name": "Селинда",
            "population": 350,
            "type": "village",
            "poly": [
                [
                    118.3166613,
                    50.5648979
                ],
                [
                    118.3335393,
                    50.5718441
                ],
                [
                    118.3393949,
                    50.5683985
                ],
                [
                    118.3399116,
                    50.5613971
                ],
                [
                    118.3266503,
                    50.5574036
                ],
                [
                    118.3166613,
                    50.5648979
                ]
            ],
            "longitude": 118.3292337,
            "latitude": 50.5642415
        },
        "2066": {
            "name": "Газимурский Завод",
            "population": 2836,
            "type": "village",
            "poly": [
                [
                    118.3188182,
                    51.5503507
                ],
                [
                    118.3224231,
                    51.5512046
                ],
                [
                    118.3189899,
                    51.5568616
                ],
                [
                    118.326543,
                    51.557075
                ],
                [
                    118.3311778,
                    51.5599566
                ],
                [
                    118.3329169,
                    51.5599566
                ],
                [
                    118.3359843,
                    51.5599566
                ],
                [
                    118.3395892,
                    51.5564346
                ],
                [
                    118.3435374,
                    51.5557943
                ],
                [
                    118.3497172,
                    51.556648
                ],
                [
                    118.3526355,
                    51.5596364
                ],
                [
                    118.3620769,
                    51.5583557
                ],
                [
                    118.3663684,
                    51.5555808
                ],
                [
                    118.3655101,
                    51.551845
                ],
                [
                    118.3567554,
                    51.548963
                ],
                [
                    118.3593303,
                    51.5456537
                ],
                [
                    118.357442,
                    51.5429848
                ],
                [
                    118.3612186,
                    51.5387141
                ],
                [
                    118.3521205,
                    51.5378599
                ],
                [
                    118.3481723,
                    51.5311327
                ],
                [
                    118.346782,
                    51.5301945
                ],
                [
                    118.3380443,
                    51.5242978
                ],
                [
                    118.3325511,
                    51.525793
                ],
                [
                    118.3263713,
                    51.5238705
                ],
                [
                    118.3246547,
                    51.5255794
                ],
                [
                    118.3323794,
                    51.5291037
                ],
                [
                    118.3325511,
                    51.5336956
                ],
                [
                    118.3292895,
                    51.5342295
                ],
                [
                    118.3283673,
                    51.5346975
                ],
                [
                    118.3227664,
                    51.5375396
                ],
                [
                    118.3236247,
                    51.5405292
                ],
                [
                    118.3236247,
                    51.5440523
                ],
                [
                    118.3227664,
                    51.5469347
                ],
                [
                    118.3188182,
                    51.5503507
                ]
            ],
            "longitude": 118.3349104,
            "latitude": 51.5511167
        },
        "2067": {
            "name": "Ямкун",
            "population": 162,
            "type": "village",
            "poly": null,
            "longitude": 118.3364545,
            "latitude": 51.5272337
        },
        "2068": {
            "name": "Верхний Тасуркай",
            "population": 261,
            "type": "village",
            "poly": [
                [
                    118.3413089,
                    50.4314839
                ],
                [
                    118.3424655,
                    50.4324047
                ],
                [
                    118.3472724,
                    50.4341904
                ],
                [
                    118.3515179,
                    50.4318961
                ],
                [
                    118.3524731,
                    50.4308585
                ],
                [
                    118.352417,
                    50.4300723
                ],
                [
                    118.3520804,
                    50.4296435
                ],
                [
                    118.3515475,
                    50.4296613
                ],
                [
                    118.3521646,
                    50.4283926
                ],
                [
                    118.3519963,
                    50.4279459
                ],
                [
                    118.3539839,
                    50.4264598
                ],
                [
                    118.3544768,
                    50.4256206
                ],
                [
                    118.3490509,
                    50.4226561
                ],
                [
                    118.3457729,
                    50.4239106
                ],
                [
                    118.3459373,
                    50.4257657
                ],
                [
                    118.3459583,
                    50.4277627
                ],
                [
                    118.3447311,
                    50.4289466
                ],
                [
                    118.3440859,
                    50.4289108
                ],
                [
                    118.3421223,
                    50.4284283
                ],
                [
                    118.3413089,
                    50.4314839
                ]
            ],
            "longitude": 118.3466555,
            "latitude": 50.4296105
        },
        "2069": {
            "name": "Шара",
            "population": 145,
            "type": "village",
            "poly": [
                [
                    118.3388352,
                    50.8417744
                ],
                [
                    118.3468072,
                    50.8420104
                ],
                [
                    118.3561494,
                    50.838392
                ],
                [
                    118.3623776,
                    50.8311544
                ],
                [
                    118.3504195,
                    50.8274567
                ],
                [
                    118.3412019,
                    50.833436
                ],
                [
                    118.3388352,
                    50.8417744
                ]
            ],
            "longitude": 118.34743,
            "latitude": 50.8362681
        },
        "2070": {
            "name": "Кокуй 1-й",
            "population": 256,
            "type": "village",
            "poly": null,
            "longitude": 118.3490677,
            "latitude": 51.1790363
        },
        "2071": {
            "name": "Савво-Борзя",
            "population": 266,
            "type": "village",
            "poly": [
                [
                    118.3379956,
                    50.6973939
                ],
                [
                    118.3379956,
                    50.705157
                ],
                [
                    118.3481917,
                    50.7147733
                ],
                [
                    118.3583878,
                    50.7121634
                ],
                [
                    118.3540491,
                    50.7065309
                ],
                [
                    118.3602318,
                    50.705844
                ],
                [
                    118.3563269,
                    50.6947143
                ],
                [
                    118.3445038,
                    50.6972565
                ],
                [
                    118.3379956,
                    50.6973939
                ]
            ],
            "longitude": 118.3494711,
            "latitude": 50.6981955
        },
        "2072": {
            "name": "Юбилейный",
            "population": 700,
            "type": "village",
            "poly": [
                [
                    118.3480869,
                    50.2602812
                ],
                [
                    118.3497859,
                    50.2629778
                ],
                [
                    118.3503828,
                    50.2658922
                ],
                [
                    118.3538644,
                    50.2688641
                ],
                [
                    118.3554688,
                    50.2722651
                ],
                [
                    118.3587049,
                    50.2747175
                ],
                [
                    118.3603314,
                    50.2738003
                ],
                [
                    118.3620304,
                    50.2744743
                ],
                [
                    118.3609759,
                    50.2757473
                ],
                [
                    118.3612102,
                    50.2763464
                ],
                [
                    118.3681381,
                    50.2719375
                ],
                [
                    118.3668345,
                    50.2709545
                ],
                [
                    118.372576,
                    50.2676217
                ],
                [
                    118.3761988,
                    50.2678692
                ],
                [
                    118.376677,
                    50.266311
                ],
                [
                    118.3734798,
                    50.2639513
                ],
                [
                    118.3700917,
                    50.2662836
                ],
                [
                    118.3634365,
                    50.2597568
                ],
                [
                    118.3582223,
                    50.2619666
                ],
                [
                    118.356992,
                    50.2615545
                ],
                [
                    118.3598042,
                    50.2588579
                ],
                [
                    118.3583893,
                    50.2570351
                ],
                [
                    118.3565819,
                    50.2564607
                ],
                [
                    118.3534768,
                    50.25706
                ],
                [
                    118.3480869,
                    50.2602812
                ]
            ],
            "longitude": 118.357712,
            "latitude": 50.268307
        },
        "2073": {
            "name": "Ушмун",
            "population": 616,
            "type": "village",
            "poly": null,
            "longitude": 118.3613183,
            "latitude": 51.6800464
        },
        "2074": {
            "name": "Калдага",
            "population": 108,
            "type": "village",
            "poly": null,
            "longitude": 118.3644938,
            "latitude": 51.6318376
        },
        "2075": {
            "name": "Джелонда",
            "population": 115,
            "type": "village",
            "poly": null,
            "longitude": 118.3825182,
            "latitude": 53.2672623
        },
        "2076": {
            "name": "Кайластуй",
            "population": 986,
            "type": "village",
            "poly": null,
            "longitude": 118.397873,
            "latitude": 49.832508
        },
        "2077": {
            "name": "Шаракан",
            "population": 77,
            "type": "village",
            "poly": null,
            "longitude": 118.4110106,
            "latitude": 50.8486719
        },
        "2078": {
            "name": "Усть-Тасуркай",
            "population": 469,
            "type": "village",
            "poly": [
                [
                    118.3939118,
                    50.3644387
                ],
                [
                    118.3989027,
                    50.3661529
                ],
                [
                    118.4151746,
                    50.3619915
                ],
                [
                    118.4219996,
                    50.3585664
                ],
                [
                    118.4230458,
                    50.357103
                ],
                [
                    118.4227521,
                    50.3565297
                ],
                [
                    118.4227405,
                    50.3564573
                ],
                [
                    118.421168,
                    50.354921
                ],
                [
                    118.4170893,
                    50.3537317
                ],
                [
                    118.4159591,
                    50.3535571
                ],
                [
                    118.4144111,
                    50.3532906
                ],
                [
                    118.4062538,
                    50.3503275
                ],
                [
                    118.400177,
                    50.3545983
                ],
                [
                    118.3939118,
                    50.3644387
                ]
            ],
            "longitude": 118.4119418,
            "latitude": 50.3569863
        },
        "2079": {
            "name": "Кунгара",
            "population": 71,
            "type": "village",
            "poly": null,
            "longitude": 118.4405825,
            "latitude": 51.8007671
        },
        "2080": {
            "name": "Тайна",
            "population": 623,
            "type": "village",
            "poly": [
                [
                    118.4355549,
                    51.5876618
                ],
                [
                    118.4365848,
                    51.5913947
                ],
                [
                    118.4468845,
                    51.5929943
                ],
                [
                    118.4528927,
                    51.5980063
                ],
                [
                    118.4456829,
                    51.6029111
                ],
                [
                    118.4599308,
                    51.6026979
                ],
                [
                    118.462334,
                    51.5980063
                ],
                [
                    118.4714321,
                    51.5935275
                ],
                [
                    118.4686855,
                    51.5880885
                ],
                [
                    118.4786419,
                    51.586062
                ],
                [
                    118.4776059,
                    51.5848462
                ],
                [
                    118.4770969,
                    51.5842487
                ],
                [
                    118.4667972,
                    51.5856353
                ],
                [
                    118.4614757,
                    51.5842487
                ],
                [
                    118.4523777,
                    51.585422
                ],
                [
                    118.4453396,
                    51.5828621
                ],
                [
                    118.4395031,
                    51.5787019
                ],
                [
                    118.4384731,
                    51.5796619
                ],
                [
                    118.4436229,
                    51.5845687
                ],
                [
                    118.4473995,
                    51.5859553
                ],
                [
                    118.4355549,
                    51.5876618
                ]
            ],
            "longitude": 118.4566692,
            "latitude": 51.5876618
        },
        "2081": {
            "name": "Курюмдюкан",
            "population": 75,
            "type": "village",
            "poly": null,
            "longitude": 118.4753366,
            "latitude": 51.807773
        },
        "2082": {
            "name": "Сбега",
            "population": 1500,
            "type": "village",
            "poly": [
                [
                    118.4974663,
                    53.3186363
                ],
                [
                    118.4977731,
                    53.3212482
                ],
                [
                    118.5039099,
                    53.32079
                ],
                [
                    118.5183312,
                    53.3243181
                ],
                [
                    118.5268459,
                    53.3273877
                ],
                [
                    118.5391194,
                    53.3231726
                ],
                [
                    118.530528,
                    53.3116248
                ],
                [
                    118.5222434,
                    53.3038328
                ],
                [
                    118.5085891,
                    53.3071331
                ],
                [
                    118.5003812,
                    53.3137788
                ],
                [
                    118.4974663,
                    53.3186363
                ]
            ],
            "longitude": 118.5076519,
            "latitude": 53.3113585
        },
        "2083": {
            "name": "Мангидай",
            "population": 186,
            "type": "village",
            "poly": null,
            "longitude": 118.5109478,
            "latitude": 52.3774776
        },
        "2084": {
            "name": "Урулюнгуй",
            "population": 840,
            "type": "village",
            "poly": [
                [
                    118.4978634,
                    50.465642
                ],
                [
                    118.5052836,
                    50.4681287
                ],
                [
                    118.5141781,
                    50.4697395
                ],
                [
                    118.5103942,
                    50.4724293
                ],
                [
                    118.5144238,
                    50.4739149
                ],
                [
                    118.5171019,
                    50.4755255
                ],
                [
                    118.5219423,
                    50.4750564
                ],
                [
                    118.5223108,
                    50.4720853
                ],
                [
                    118.5288957,
                    50.4723042
                ],
                [
                    118.5282814,
                    50.4743371
                ],
                [
                    118.5312299,
                    50.4750407
                ],
                [
                    118.5331709,
                    50.4732423
                ],
                [
                    118.5307876,
                    50.4704433
                ],
                [
                    118.5243502,
                    50.4681287
                ],
                [
                    118.5264878,
                    50.467206
                ],
                [
                    118.5282814,
                    50.4649695
                ],
                [
                    118.5262912,
                    50.4610906
                ],
                [
                    118.5242142,
                    50.4600989
                ],
                [
                    118.5234907,
                    50.4597534
                ],
                [
                    118.5219669,
                    50.4590258
                ],
                [
                    118.5231344,
                    50.457611
                ],
                [
                    118.5234028,
                    50.4572857
                ],
                [
                    118.5238016,
                    50.4568025
                ],
                [
                    118.5255296,
                    50.4547084
                ],
                [
                    118.522876,
                    50.4531753
                ],
                [
                    118.5167334,
                    50.4573052
                ],
                [
                    118.5126793,
                    50.457446
                ],
                [
                    118.5053819,
                    50.4599174
                ],
                [
                    118.4978634,
                    50.465642
                ]
            ],
            "longitude": 118.5179769,
            "latitude": 50.4647288
        },
        "2085": {
            "name": "Бурукан",
            "population": 324,
            "type": "village",
            "poly": null,
            "longitude": 118.5275271,
            "latitude": 51.8404355
        },
        "2086": {
            "name": "Бырка",
            "population": 1205,
            "type": "village",
            "poly": [
                [
                    118.5321044,
                    50.6357662
                ],
                [
                    118.5385622,
                    50.6506843
                ],
                [
                    118.5568976,
                    50.6545593
                ],
                [
                    118.5711969,
                    50.6529509
                ],
                [
                    118.5780006,
                    50.6470284
                ],
                [
                    118.5723501,
                    50.6400813
                ],
                [
                    118.5535534,
                    50.6299878
                ],
                [
                    118.5321044,
                    50.6357662
                ]
            ],
            "longitude": 118.554016,
            "latitude": 50.645126
        },
        "2087": {
            "name": "Аргун",
            "population": 105,
            "type": "village",
            "poly": null,
            "longitude": 118.5622579,
            "latitude": 52.384919
        },
        "2088": {
            "name": "Большие Боты",
            "population": 159,
            "type": "village",
            "poly": null,
            "longitude": 118.5627033,
            "latitude": 52.3970582
        },
        "2089": {
            "name": "Бура",
            "population": 68,
            "type": "village",
            "poly": null,
            "longitude": 118.5658259,
            "latitude": 51.8434984
        },
        "2090": {
            "name": "Богословск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 118.5810476,
            "latitude": 50.9007766
        },
        "2091": {
            "name": "Доно",
            "population": 843,
            "type": "village",
            "poly": [
                [
                    118.5787123,
                    50.8809487
                ],
                [
                    118.5967273,
                    50.902601
                ],
                [
                    118.6102385,
                    50.906746
                ],
                [
                    118.6120644,
                    50.9012192
                ],
                [
                    118.6024483,
                    50.8884744
                ],
                [
                    118.5874763,
                    50.8791055
                ],
                [
                    118.5834513,
                    50.879952
                ],
                [
                    118.5787123,
                    50.8809487
                ]
            ],
            "longitude": 118.5984314,
            "latitude": 50.8941563
        },
        "2092": {
            "name": "Капцегайтуй",
            "population": 746,
            "type": "village",
            "poly": null,
            "longitude": 118.598541,
            "latitude": 49.956806
        },
        "2093": {
            "name": "Куйтун",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 118.609795,
            "latitude": 50.240829
        },
        "2094": {
            "name": "Чалбучи",
            "population": 31,
            "type": "village",
            "poly": null,
            "longitude": 118.624583,
            "latitude": 52.4524653
        },
        "2095": {
            "name": "Досатуй",
            "population": 1530,
            "type": "village",
            "poly": [
                [
                    118.6086376,
                    50.3953763
                ],
                [
                    118.6278866,
                    50.4030767
                ],
                [
                    118.6544369,
                    50.4042613
                ],
                [
                    118.6590832,
                    50.401469
                ],
                [
                    118.6511181,
                    50.3775165
                ],
                [
                    118.636781,
                    50.3757387
                ],
                [
                    118.6086376,
                    50.3953763
                ]
            ],
            "longitude": 118.6354534,
            "latitude": 50.3932605
        },
        "2096": {
            "name": "Новоширокинский",
            "population": 932,
            "type": "village",
            "poly": [
                [
                    118.643598,
                    51.571094
                ],
                [
                    118.6454863,
                    51.5734412
                ],
                [
                    118.644628,
                    51.574188
                ],
                [
                    118.6460013,
                    51.5763217
                ],
                [
                    118.6489195,
                    51.5766418
                ],
                [
                    118.6504645,
                    51.5776019
                ],
                [
                    118.6496062,
                    51.5783487
                ],
                [
                    118.6528677,
                    51.5802688
                ],
                [
                    118.6559576,
                    51.5789886
                ],
                [
                    118.6595625,
                    51.5796288
                ],
                [
                    118.6600189,
                    51.5775017
                ],
                [
                    118.6602492,
                    51.5764284
                ],
                [
                    118.6576743,
                    51.5740813
                ],
                [
                    118.655271,
                    51.5709873
                ],
                [
                    118.6509795,
                    51.5706672
                ],
                [
                    118.6497778,
                    51.5735479
                ],
                [
                    118.6480612,
                    51.5732278
                ],
                [
                    118.6468596,
                    51.5714141
                ],
                [
                    118.643598,
                    51.571094
                ]
            ],
            "longitude": 118.6508177,
            "latitude": 51.5742586
        },
        "2097": {
            "name": "Погадаево",
            "population": 641,
            "type": "village",
            "poly": [
                [
                    118.6585082,
                    50.3304623
                ],
                [
                    118.6611414,
                    50.3407444
                ],
                [
                    118.6767855,
                    50.3377786
                ],
                [
                    118.6764428,
                    50.3240133
                ],
                [
                    118.6585082,
                    50.3304623
                ]
            ],
            "longitude": 118.6668724,
            "latitude": 50.3335274
        },
        "2098": {
            "name": "Шилкинский Завод",
            "population": 270,
            "type": "village",
            "poly": null,
            "longitude": 118.6675793,
            "latitude": 52.5708999
        },
        "2099": {
            "name": "Широкая",
            "population": 379,
            "type": "village",
            "poly": null,
            "longitude": 118.6942333,
            "latitude": 51.5986281
        },
        "2100": {
            "name": "Итака",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 118.711655,
            "latitude": 53.888115
        },
        "2101": {
            "name": "Старолончаково",
            "population": 207,
            "type": "village",
            "poly": null,
            "longitude": 118.7255286,
            "latitude": 52.6072634
        },
        "2102": {
            "name": "Богдановка",
            "population": 520,
            "type": "village",
            "poly": null,
            "longitude": 118.7547,
            "latitude": 50.007072
        },
        "2103": {
            "name": "Икабья",
            "population": 607,
            "type": "village",
            "poly": [
                [
                    118.7518556,
                    56.9929659
                ],
                [
                    118.7817534,
                    57.0064879
                ],
                [
                    118.7875862,
                    57.0031447
                ],
                [
                    118.7803122,
                    56.9977162
                ],
                [
                    118.7749212,
                    56.994366
                ],
                [
                    118.770193,
                    56.9927434
                ],
                [
                    118.763379,
                    56.9902269
                ],
                [
                    118.7556232,
                    56.9898108
                ],
                [
                    118.7518556,
                    56.9929659
                ]
            ],
            "longitude": 118.771309,
            "latitude": 56.998291
        },
        "2104": {
            "name": "Верхний Калгукан",
            "population": 348,
            "type": "village",
            "poly": [
                [
                    118.7693079,
                    50.8194107
                ],
                [
                    118.7746301,
                    50.8227221
                ],
                [
                    118.7842263,
                    50.820124
                ],
                [
                    118.7919677,
                    50.8222127
                ],
                [
                    118.7910001,
                    50.8174238
                ],
                [
                    118.7832586,
                    50.8125326
                ],
                [
                    118.7693079,
                    50.8194107
                ]
            ],
            "longitude": 118.780876,
            "latitude": 50.817596
        },
        "2105": {
            "name": "Луговское",
            "population": 209,
            "type": "village",
            "poly": null,
            "longitude": 118.8189627,
            "latitude": 52.0553076
        },
        "2106": {
            "name": "Усть-Карск",
            "population": 1787,
            "type": "village",
            "poly": null,
            "longitude": 118.821434,
            "latitude": 52.71125
        },
        "2107": {
            "name": "Чапо-Олого",
            "population": 171,
            "type": "village",
            "poly": null,
            "longitude": 118.822693,
            "latitude": 57.073608
        },
        "2108": {
            "name": "Талман-Борзя",
            "population": 489,
            "type": "village",
            "poly": [
                [
                    118.8325467,
                    50.5630059
                ],
                [
                    118.8379414,
                    50.5661129
                ],
                [
                    118.8444151,
                    50.5660215
                ],
                [
                    118.8484432,
                    50.5641025
                ],
                [
                    118.8497379,
                    50.5604471
                ],
                [
                    118.852687,
                    50.5594875
                ],
                [
                    118.853766,
                    50.5538667
                ],
                [
                    118.8505291,
                    50.5526784
                ],
                [
                    118.8344169,
                    50.5567
                ],
                [
                    118.8325467,
                    50.5630059
                ]
            ],
            "longitude": 118.8415379,
            "latitude": 50.5602187
        },
        "2109": {
            "name": "Солонцы",
            "population": 35,
            "type": "village",
            "poly": [
                [
                    118.842564,
                    51.4556436
                ],
                [
                    118.8440945,
                    51.4571583
                ],
                [
                    118.8454822,
                    51.4585316
                ],
                [
                    118.853722,
                    51.4567132
                ],
                [
                    118.8576702,
                    51.4533973
                ],
                [
                    118.8604168,
                    51.4513648
                ],
                [
                    118.8578418,
                    51.4501881
                ],
                [
                    118.8518337,
                    51.4522205
                ],
                [
                    118.8482288,
                    51.4538252
                ],
                [
                    118.842564,
                    51.4556436
                ]
            ],
            "longitude": 118.8496021,
            "latitude": 51.4558576
        },
        "2110": {
            "name": "Батакан",
            "population": 589,
            "type": "village",
            "poly": null,
            "longitude": 118.858429,
            "latitude": 52.073296
        },
        "2111": {
            "name": "Моклакан",
            "population": 85,
            "type": "village",
            "poly": null,
            "longitude": 118.877335,
            "latitude": 54.730373
        },
        "2112": {
            "name": "Горда",
            "population": 127,
            "type": "village",
            "poly": [
                [
                    118.8812868,
                    50.1664283
                ],
                [
                    118.8816682,
                    50.1722103
                ],
                [
                    118.8915852,
                    50.1708258
                ],
                [
                    118.8901866,
                    50.1638221
                ],
                [
                    118.8812868,
                    50.1664283
                ]
            ],
            "longitude": 118.8857367,
            "latitude": 50.1689529
        },
        "2113": {
            "name": "Калга",
            "population": 3825,
            "type": "village",
            "poly": [
                [
                    118.8621861,
                    50.9281109
                ],
                [
                    118.879895,
                    50.9436903
                ],
                [
                    118.900295,
                    50.9444457
                ],
                [
                    118.9111235,
                    50.9390177
                ],
                [
                    118.9195834,
                    50.9211127
                ],
                [
                    118.9127946,
                    50.9107747
                ],
                [
                    118.8815661,
                    50.9084038
                ],
                [
                    118.8700774,
                    50.9180181
                ],
                [
                    118.8621861,
                    50.9281109
                ]
            ],
            "longitude": 118.899208,
            "latitude": 50.92355
        },
        "2114": {
            "name": "Рудник Солонечный",
            "population": 711,
            "type": "village",
            "poly": null,
            "longitude": 118.9026976,
            "latitude": 51.530074
        },
        "2115": {
            "name": "Лужанки",
            "population": 40,
            "type": "village",
            "poly": null,
            "longitude": 118.903981,
            "latitude": 52.7608743
        },
        "2116": {
            "name": "Нижний Калгукан",
            "population": 860,
            "type": "village",
            "poly": [
                [
                    118.8934405,
                    50.7397634
                ],
                [
                    118.900213,
                    50.7491317
                ],
                [
                    118.907143,
                    50.7482348
                ],
                [
                    118.910923,
                    50.7541141
                ],
                [
                    118.931398,
                    50.7499289
                ],
                [
                    118.932028,
                    50.7426538
                ],
                [
                    118.9473055,
                    50.7379692
                ],
                [
                    118.945258,
                    50.7318886
                ],
                [
                    118.9166976,
                    50.73522
                ],
                [
                    118.8934405,
                    50.7397634
                ]
            ],
            "longitude": 118.9142304,
            "latitude": 50.7421556
        },
        "2117": {
            "name": "Закаменная",
            "population": 99,
            "type": "village",
            "poly": null,
            "longitude": 118.9193921,
            "latitude": 52.0799261
        },
        "2118": {
            "name": "Улан",
            "population": 653,
            "type": "village",
            "poly": [
                [
                    118.9218351,
                    50.4807685
                ],
                [
                    118.9241979,
                    50.4826523
                ],
                [
                    118.9296918,
                    50.4825627
                ],
                [
                    118.9410441,
                    50.4802484
                ],
                [
                    118.9371975,
                    50.4730116
                ],
                [
                    118.9266193,
                    50.4739908
                ],
                [
                    118.9218351,
                    50.4807685
                ]
            ],
            "longitude": 118.929457,
            "latitude": 50.4772739
        },
        "2119": {
            "name": "Дурой",
            "population": 820,
            "type": "village",
            "poly": null,
            "longitude": 118.930763,
            "latitude": 50.007519
        },
        "2120": {
            "name": "Козлово",
            "population": 189,
            "type": "village",
            "poly": [
                [
                    118.9226556,
                    51.2094241
                ],
                [
                    118.9303371,
                    51.2114864
                ],
                [
                    118.9348637,
                    51.2094669
                ],
                [
                    118.9489235,
                    51.2097247
                ],
                [
                    118.9494721,
                    51.2071467
                ],
                [
                    118.9356867,
                    51.2044827
                ],
                [
                    118.9305428,
                    51.2009159
                ],
                [
                    118.9242331,
                    51.2044827
                ],
                [
                    118.9226556,
                    51.2094241
                ]
            ],
            "longitude": 118.933492,
            "latitude": 51.2064593
        },
        "2121": {
            "name": "Верхние Куларки",
            "population": 359,
            "type": "village",
            "poly": null,
            "longitude": 118.946477,
            "latitude": 52.8329948
        },
        "2122": {
            "name": "Нижние Куларки",
            "population": 189,
            "type": "village",
            "poly": null,
            "longitude": 118.9535798,
            "latitude": 52.8676011
        },
        "2123": {
            "name": "Пограничный",
            "population": 649,
            "type": "village",
            "poly": [
                [
                    118.954157,
                    50.5871763
                ],
                [
                    118.9557698,
                    50.6000382
                ],
                [
                    118.9636436,
                    50.6000764
                ],
                [
                    118.9689746,
                    50.6001022
                ],
                [
                    118.9680674,
                    50.5872403
                ],
                [
                    118.954157,
                    50.5871763
                ]
            ],
            "longitude": 118.9615277,
            "latitude": 50.5938426
        },
        "2124": {
            "name": "Молодёжный",
            "population": 1608,
            "type": "village",
            "poly": [
                [
                    118.9775201,
                    50.281901
                ],
                [
                    118.9848558,
                    50.2830412
                ],
                [
                    118.9816836,
                    50.2895019
                ],
                [
                    118.9980402,
                    50.2915286
                ],
                [
                    119.0047812,
                    50.2793037
                ],
                [
                    118.9972472,
                    50.2749958
                ],
                [
                    118.978908,
                    50.2778467
                ],
                [
                    118.9780246,
                    50.2804271
                ],
                [
                    118.9775201,
                    50.281901
                ]
            ],
            "longitude": 118.993279,
            "latitude": 50.282852
        },
        "2125": {
            "name": "Чупрово",
            "population": 571,
            "type": "village",
            "poly": [
                [
                    118.9851024,
                    50.9905505
                ],
                [
                    118.9858786,
                    50.9974055
                ],
                [
                    118.9932391,
                    50.9953706
                ],
                [
                    118.9981882,
                    50.9918474
                ],
                [
                    119.0042092,
                    50.9943739
                ],
                [
                    119.0095612,
                    50.9875521
                ],
                [
                    119.0063076,
                    50.9868028
                ],
                [
                    119.0040754,
                    50.9862887
                ],
                [
                    119.0062533,
                    50.9851966
                ],
                [
                    119.0119696,
                    50.9823298
                ],
                [
                    119.0048782,
                    50.9769385
                ],
                [
                    118.99297,
                    50.9845199
                ],
                [
                    118.9851024,
                    50.9905505
                ]
            ],
            "longitude": 118.9969839,
            "latitude": 50.986373
        },
        "2126": {
            "name": "Чингильтуй",
            "population": 488,
            "type": "village",
            "poly": null,
            "longitude": 119.0367609,
            "latitude": 50.796375
        },
        "2127": {
            "name": "Усть-Чёрная",
            "population": 31,
            "type": "village",
            "poly": null,
            "longitude": 119.052237,
            "latitude": 52.9225225
        },
        "2128": {
            "name": "Явленка",
            "population": 729,
            "type": "village",
            "poly": [
                [
                    119.0737913,
                    51.037851
                ],
                [
                    119.0762775,
                    51.0415166
                ],
                [
                    119.0870795,
                    51.0403307
                ],
                [
                    119.0925662,
                    51.0415705
                ],
                [
                    119.0955668,
                    51.0400611
                ],
                [
                    119.0962527,
                    51.0373119
                ],
                [
                    119.0911946,
                    51.0346164
                ],
                [
                    119.0798781,
                    51.0327833
                ],
                [
                    119.0737913,
                    51.037851
                ]
            ],
            "longitude": 119.0822786,
            "latitude": 51.0374197
        },
        "2129": {
            "name": "Новоцурухайтуй",
            "population": 1920,
            "type": "village",
            "poly": [
                [
                    119.0995782,
                    50.3860743
                ],
                [
                    119.101698,
                    50.3893179
                ],
                [
                    119.1235687,
                    50.4036311
                ],
                [
                    119.1340523,
                    50.4001945
                ],
                [
                    119.1184536,
                    50.3900154
                ],
                [
                    119.1167025,
                    50.3875476
                ],
                [
                    119.1090711,
                    50.3814434
                ],
                [
                    119.1026934,
                    50.3844758
                ],
                [
                    119.09991,
                    50.3839469
                ],
                [
                    119.0995782,
                    50.3860743
                ]
            ],
            "longitude": 119.116844,
            "latitude": 50.393013
        },
        "2130": {
            "name": "Шивия",
            "population": 244,
            "type": "village",
            "poly": [
                [
                    119.104262,
                    50.8795613
                ],
                [
                    119.1062787,
                    50.8866596
                ],
                [
                    119.1171051,
                    50.8909114
                ],
                [
                    119.1231168,
                    50.8912069
                ],
                [
                    119.1334509,
                    50.8917148
                ],
                [
                    119.1322303,
                    50.8854543
                ],
                [
                    119.1225417,
                    50.8767305
                ],
                [
                    119.1216692,
                    50.8759448
                ],
                [
                    119.104262,
                    50.8795613
                ]
            ],
            "longitude": 119.1197586,
            "latitude": 50.8869944
        },
        "2131": {
            "name": "Курлея",
            "population": 5,
            "type": "village",
            "poly": null,
            "longitude": 119.120784,
            "latitude": 52.1851597
        },
        "2132": {
            "name": "Запокровский",
            "population": 12,
            "type": "village",
            "poly": [
                [
                    119.1597395,
                    50.8190341
                ],
                [
                    119.1638138,
                    50.8223634
                ],
                [
                    119.1674452,
                    50.8221116
                ],
                [
                    119.171688,
                    50.8260344
                ],
                [
                    119.1723166,
                    50.8266155
                ],
                [
                    119.1774537,
                    50.8279863
                ],
                [
                    119.1820594,
                    50.827203
                ],
                [
                    119.1933965,
                    50.8276226
                ],
                [
                    119.1843179,
                    50.8221395
                ],
                [
                    119.1866651,
                    50.8208526
                ],
                [
                    119.1863994,
                    50.817859
                ],
                [
                    119.1749242,
                    50.8150017
                ],
                [
                    119.1717316,
                    50.8142067
                ],
                [
                    119.1698809,
                    50.8137459
                ],
                [
                    119.1688761,
                    50.8140402
                ],
                [
                    119.1650095,
                    50.8151729
                ],
                [
                    119.1621752,
                    50.8139417
                ],
                [
                    119.1602709,
                    50.814977
                ],
                [
                    119.1614813,
                    50.8161653
                ],
                [
                    119.1623524,
                    50.8170476
                ],
                [
                    119.1597395,
                    50.8190341
                ]
            ],
            "longitude": 119.1727152,
            "latitude": 50.8202651
        },
        "2133": {
            "name": "Кути",
            "population": 115,
            "type": "village",
            "poly": null,
            "longitude": 119.1890535,
            "latitude": 50.0915977
        },
        "2134": {
            "name": "Золотоноша",
            "population": 139,
            "type": "village",
            "poly": [
                [
                    119.1952945,
                    51.2857188
                ],
                [
                    119.1959811,
                    51.2926969
                ],
                [
                    119.199586,
                    51.2926969
                ],
                [
                    119.1982127,
                    51.2858262
                ],
                [
                    119.1952945,
                    51.2857188
                ]
            ],
            "longitude": 119.1967014,
            "latitude": 51.2892235
        },
        "2135": {
            "name": "Горбица",
            "population": 64,
            "type": "village",
            "poly": null,
            "longitude": 119.2145221,
            "latitude": 53.0990835
        },
        "2136": {
            "name": "Чалдонка",
            "population": 284,
            "type": "village",
            "poly": null,
            "longitude": 119.2190009,
            "latitude": 53.7823478
        },
        "2137": {
            "name": "Большой Зерентуй",
            "population": 918,
            "type": "village",
            "poly": [
                [
                    119.2035859,
                    51.3629008
                ],
                [
                    119.2056308,
                    51.3637497
                ],
                [
                    119.2063621,
                    51.3655336
                ],
                [
                    119.2092156,
                    51.3666434
                ],
                [
                    119.212573,
                    51.3640748
                ],
                [
                    119.2163857,
                    51.3659455
                ],
                [
                    119.2092876,
                    51.3708754
                ],
                [
                    119.2150179,
                    51.3726438
                ],
                [
                    119.2207868,
                    51.3726332
                ],
                [
                    119.2242467,
                    51.3709785
                ],
                [
                    119.225892,
                    51.3709858
                ],
                [
                    119.2274387,
                    51.3729952
                ],
                [
                    119.2329868,
                    51.3720983
                ],
                [
                    119.2323977,
                    51.3706944
                ],
                [
                    119.2353501,
                    51.3678979
                ],
                [
                    119.2383482,
                    51.3662132
                ],
                [
                    119.2394288,
                    51.3631817
                ],
                [
                    119.2382175,
                    51.3630128
                ],
                [
                    119.2372927,
                    51.3618136
                ],
                [
                    119.2346705,
                    51.3600738
                ],
                [
                    119.2322352,
                    51.3568431
                ],
                [
                    119.2297799,
                    51.3563436
                ],
                [
                    119.224066,
                    51.3601532
                ],
                [
                    119.2189963,
                    51.361431
                ],
                [
                    119.2166276,
                    51.3634128
                ],
                [
                    119.2156605,
                    51.362817
                ],
                [
                    119.2170154,
                    51.3598205
                ],
                [
                    119.2137648,
                    51.3586969
                ],
                [
                    119.2098289,
                    51.3581467
                ],
                [
                    119.2035859,
                    51.3629008
                ]
            ],
            "longitude": 119.2260197,
            "latitude": 51.3642375
        },
        "2138": {
            "name": "Чашино-Ильдикан",
            "population": 330,
            "type": "village",
            "poly": [
                [
                    119.2344902,
                    51.0708802
                ],
                [
                    119.2455873,
                    51.0748793
                ],
                [
                    119.2594587,
                    51.074059
                ],
                [
                    119.262233,
                    51.071803
                ],
                [
                    119.2591323,
                    51.0673936
                ],
                [
                    119.2385701,
                    51.0647272
                ],
                [
                    119.2344902,
                    51.0708802
                ]
            ],
            "longitude": 119.2434658,
            "latitude": 51.0693421
        },
        "2139": {
            "name": "Усть-Начин",
            "population": 125,
            "type": "village",
            "poly": null,
            "longitude": 119.2445905,
            "latitude": 52.3689352
        },
        "2140": {
            "name": "Зоргол",
            "population": 803,
            "type": "village",
            "poly": null,
            "longitude": 119.2707134,
            "latitude": 50.6056829
        },
        "2141": {
            "name": "Байка",
            "population": 337,
            "type": "village",
            "poly": null,
            "longitude": 119.2954431,
            "latitude": 51.2555987
        },
        "2142": {
            "name": "Кудеча",
            "population": 222,
            "type": "village",
            "poly": [
                [
                    119.2825206,
                    53.4707298
                ],
                [
                    119.2850451,
                    53.4742107
                ],
                [
                    119.2956897,
                    53.4726831
                ],
                [
                    119.3024215,
                    53.4733092
                ],
                [
                    119.3056612,
                    53.4715562
                ],
                [
                    119.3014538,
                    53.4667727
                ],
                [
                    119.3109625,
                    53.4615877
                ],
                [
                    119.3173577,
                    53.4576048
                ],
                [
                    119.3122247,
                    53.4531956
                ],
                [
                    119.2959843,
                    53.4587321
                ],
                [
                    119.2863073,
                    53.4649192
                ],
                [
                    119.2825206,
                    53.4707298
                ]
            ],
            "longitude": 119.2963776,
            "latitude": 53.4638332
        },
        "2143": {
            "name": "Кадая",
            "population": 1063,
            "type": "village",
            "poly": [
                [
                    119.2748667,
                    50.9462356
                ],
                [
                    119.2773024,
                    50.9463472
                ],
                [
                    119.288418,
                    50.9390921
                ],
                [
                    119.3049808,
                    50.94498
                ],
                [
                    119.318665,
                    50.942357
                ],
                [
                    119.3143006,
                    50.934561
                ],
                [
                    119.3133064,
                    50.9327849
                ],
                [
                    119.3094536,
                    50.9287656
                ],
                [
                    119.3000651,
                    50.92737
                ],
                [
                    119.2888609,
                    50.9273142
                ],
                [
                    119.2766381,
                    50.9408781
                ],
                [
                    119.2748667,
                    50.9462356
                ]
            ],
            "longitude": 119.300064,
            "latitude": 50.933846
        },
        "2144": {
            "name": "Поперечный Зерентуй",
            "population": 0,
            "type": "village",
            "poly": [
                [
                    119.2985873,
                    51.372648
                ],
                [
                    119.299107,
                    51.3753587
                ],
                [
                    119.302837,
                    51.3761256
                ],
                [
                    119.3035218,
                    51.3803475
                ],
                [
                    119.3079284,
                    51.3803083
                ],
                [
                    119.3082184,
                    51.3752091
                ],
                [
                    119.3060424,
                    51.3750725
                ],
                [
                    119.3059411,
                    51.3711156
                ],
                [
                    119.2985873,
                    51.372648
                ]
            ],
            "longitude": 119.3055735,
            "latitude": 51.3761758
        },
        "2145": {
            "name": "Давенда",
            "population": 744,
            "type": "village",
            "poly": null,
            "longitude": 119.317032,
            "latitude": 53.555576
        },
        "2146": {
            "name": "Староцурухайтуй",
            "population": 971,
            "type": "village",
            "poly": null,
            "longitude": 119.330727,
            "latitude": 50.19923
        },
        "2147": {
            "name": "Михайловка",
            "population": 773,
            "type": "village",
            "poly": [
                [
                    119.4142299,
                    51.1181436
                ],
                [
                    119.4183742,
                    51.1204513
                ],
                [
                    119.4271976,
                    51.1219617
                ],
                [
                    119.4320772,
                    51.1234721
                ],
                [
                    119.4362215,
                    51.1224652
                ],
                [
                    119.438962,
                    51.1194023
                ],
                [
                    119.4390481,
                    51.1165577
                ],
                [
                    119.43943,
                    51.1111359
                ],
                [
                    119.4292736,
                    51.1099086
                ],
                [
                    119.4142299,
                    51.1181436
                ]
            ],
            "longitude": 119.433414,
            "latitude": 51.1171785
        },
        "2148": {
            "name": "Георгиевка",
            "population": 297,
            "type": "village",
            "poly": [
                [
                    119.4252366,
                    51.3760646
                ],
                [
                    119.437944,
                    51.3798732
                ],
                [
                    119.4537302,
                    51.3735836
                ],
                [
                    119.4540101,
                    51.3697744
                ],
                [
                    119.4481882,
                    51.3639378
                ],
                [
                    119.4422544,
                    51.3631339
                ],
                [
                    119.4252366,
                    51.3760646
                ]
            ],
            "longitude": 119.4432564,
            "latitude": 51.3689514
        },
        "2149": {
            "name": "Бура",
            "population": 629,
            "type": "village",
            "poly": [
                [
                    119.4371352,
                    50.7571411
                ],
                [
                    119.4402794,
                    50.7595503
                ],
                [
                    119.4451508,
                    50.7602507
                ],
                [
                    119.4459923,
                    50.7583457
                ],
                [
                    119.4494022,
                    50.7608389
                ],
                [
                    119.4514837,
                    50.7600266
                ],
                [
                    119.4522365,
                    50.758962
                ],
                [
                    119.4517494,
                    50.7576734
                ],
                [
                    119.4503322,
                    50.757001
                ],
                [
                    119.4511294,
                    50.7566648
                ],
                [
                    119.4550708,
                    50.7577854
                ],
                [
                    119.4573293,
                    50.7562726
                ],
                [
                    119.4575508,
                    50.7547597
                ],
                [
                    119.4562665,
                    50.751986
                ],
                [
                    119.4571079,
                    50.750529
                ],
                [
                    119.4571079,
                    50.7487917
                ],
                [
                    119.4558236,
                    50.7471946
                ],
                [
                    119.4524579,
                    50.7466622
                ],
                [
                    119.440368,
                    50.7486797
                ],
                [
                    119.4373571,
                    50.7543981
                ],
                [
                    119.4371352,
                    50.7571411
                ]
            ],
            "longitude": 119.4480294,
            "latitude": 50.7524062
        },
        "2150": {
            "name": "Ключевский",
            "population": 1309,
            "type": "village",
            "poly": null,
            "longitude": 119.453285,
            "latitude": 53.533886
        },
        "2151": {
            "name": "Уровские Ключи",
            "population": 380,
            "type": "village",
            "poly": [
                [
                    119.4545761,
                    51.685318
                ],
                [
                    119.4547911,
                    51.6876279
                ],
                [
                    119.4571915,
                    51.6911372
                ],
                [
                    119.4578872,
                    51.6918685
                ],
                [
                    119.4556402,
                    51.6931735
                ],
                [
                    119.4563544,
                    51.6937966
                ],
                [
                    119.4592125,
                    51.6927635
                ],
                [
                    119.4618131,
                    51.6953345
                ],
                [
                    119.4598785,
                    51.6978883
                ],
                [
                    119.46991,
                    51.7023736
                ],
                [
                    119.4752482,
                    51.6995093
                ],
                [
                    119.4752692,
                    51.6984421
                ],
                [
                    119.4753199,
                    51.6958675
                ],
                [
                    119.4708682,
                    51.6935279
                ],
                [
                    119.4657871,
                    51.6934824
                ],
                [
                    119.4640995,
                    51.6920156
                ],
                [
                    119.4640444,
                    51.6900143
                ],
                [
                    119.4625953,
                    51.6865232
                ],
                [
                    119.4604415,
                    51.6852456
                ],
                [
                    119.4588037,
                    51.6842741
                ],
                [
                    119.4573052,
                    51.6846441
                ],
                [
                    119.4545761,
                    51.685318
                ]
            ],
            "longitude": 119.4586962,
            "latitude": 51.6878946
        },
        "2152": {
            "name": "Ивановка",
            "population": 511,
            "type": "village",
            "poly": [
                [
                    119.4513067,
                    51.2566135
                ],
                [
                    119.452165,
                    51.2621996
                ],
                [
                    119.4597181,
                    51.2660665
                ],
                [
                    119.4636663,
                    51.2660665
                ],
                [
                    119.4677862,
                    51.2639183
                ],
                [
                    119.4657262,
                    51.2605883
                ],
                [
                    119.4588871,
                    51.257586
                ],
                [
                    119.4542249,
                    51.2555392
                ],
                [
                    119.4513067,
                    51.2566135
                ]
            ],
            "longitude": 119.459515,
            "latitude": 51.2613027
        },
        "2153": {
            "name": "Средняя Борзя",
            "population": 501,
            "type": "village",
            "poly": [
                [
                    119.4697984,
                    50.9117676
                ],
                [
                    119.4711839,
                    50.9175911
                ],
                [
                    119.4778035,
                    50.919338
                ],
                [
                    119.4829606,
                    50.9167662
                ],
                [
                    119.4913505,
                    50.9146309
                ],
                [
                    119.4932718,
                    50.915718
                ],
                [
                    119.4951437,
                    50.9150968
                ],
                [
                    119.4952915,
                    50.9142582
                ],
                [
                    119.4963753,
                    50.913637
                ],
                [
                    119.4977546,
                    50.9134507
                ],
                [
                    119.4962768,
                    50.9091953
                ],
                [
                    119.4922865,
                    50.9042251
                ],
                [
                    119.4892323,
                    50.9048153
                ],
                [
                    119.4861288,
                    50.9021126
                ],
                [
                    119.4747492,
                    50.90466
                ],
                [
                    119.4697984,
                    50.9117676
                ]
            ],
            "longitude": 119.4840598,
            "latitude": 50.911028
        },
        "2154": {
            "name": "Горный Зерентуй",
            "population": 1290,
            "type": "village",
            "poly": [
                [
                    119.4971333,
                    51.2141732
                ],
                [
                    119.4972685,
                    51.2147501
                ],
                [
                    119.4987108,
                    51.2214332
                ],
                [
                    119.5225781,
                    51.2207889
                ],
                [
                    119.5319056,
                    51.2259862
                ],
                [
                    119.5412331,
                    51.2248265
                ],
                [
                    119.5398614,
                    51.2129702
                ],
                [
                    119.5297849,
                    51.2137243
                ],
                [
                    119.5250804,
                    51.2132931
                ],
                [
                    119.5149653,
                    51.2100057
                ],
                [
                    119.5121533,
                    51.2100916
                ],
                [
                    119.5104124,
                    51.212305
                ],
                [
                    119.5098215,
                    51.2130561
                ],
                [
                    119.5039918,
                    51.2150324
                ],
                [
                    119.5002882,
                    51.2124116
                ],
                [
                    119.4983158,
                    51.213513
                ],
                [
                    119.4971333,
                    51.2141732
                ]
            ],
            "longitude": 119.519913,
            "latitude": 51.215183
        },
        "2155": {
            "name": "Зерен",
            "population": 268,
            "type": "village",
            "poly": null,
            "longitude": 119.5452383,
            "latitude": 52.0333975
        },
        "2156": {
            "name": "Кактолга",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 119.5911085,
            "latitude": 52.7780857
        },
        "2157": {
            "name": "Широкая",
            "population": 449,
            "type": "village",
            "poly": [
                [
                    119.58636,
                    51.3665625
                ],
                [
                    119.5872053,
                    51.3671397
                ],
                [
                    119.5883675,
                    51.3667934
                ],
                [
                    119.5935714,
                    51.3693826
                ],
                [
                    119.5918016,
                    51.3711306
                ],
                [
                    119.5933865,
                    51.3720211
                ],
                [
                    119.5918808,
                    51.3735546
                ],
                [
                    119.5939148,
                    51.374346
                ],
                [
                    119.5948394,
                    51.3732743
                ],
                [
                    119.5970847,
                    51.3741812
                ],
                [
                    119.5993828,
                    51.3718067
                ],
                [
                    119.6017866,
                    51.3727961
                ],
                [
                    119.6034772,
                    51.3708832
                ],
                [
                    119.605115,
                    51.3714109
                ],
                [
                    119.6063037,
                    51.3702236
                ],
                [
                    119.6032395,
                    51.3687558
                ],
                [
                    119.5985639,
                    51.3669418
                ],
                [
                    119.5924355,
                    51.3659193
                ],
                [
                    119.588526,
                    51.3657709
                ],
                [
                    119.58636,
                    51.3665625
                ]
            ],
            "longitude": 119.598931,
            "latitude": 51.3701988
        },
        "2158": {
            "name": "Нерчинский Завод",
            "population": 3006,
            "type": "village",
            "poly": [
                [
                    119.5786985,
                    51.3106807
                ],
                [
                    119.5798861,
                    51.3124424
                ],
                [
                    119.5818426,
                    51.3125924
                ],
                [
                    119.586341,
                    51.3166092
                ],
                [
                    119.5866895,
                    51.3169203
                ],
                [
                    119.5970509,
                    51.3169697
                ],
                [
                    119.6081139,
                    51.3143376
                ],
                [
                    119.6081079,
                    51.3119729
                ],
                [
                    119.6081068,
                    51.3115194
                ],
                [
                    119.6109019,
                    51.3113178
                ],
                [
                    119.6110078,
                    51.3113102
                ],
                [
                    119.6112708,
                    51.3112912
                ],
                [
                    119.611579,
                    51.311269
                ],
                [
                    119.6119488,
                    51.3112423
                ],
                [
                    119.61257,
                    51.3111975
                ],
                [
                    119.6138863,
                    51.3111778
                ],
                [
                    119.6197798,
                    51.3110902
                ],
                [
                    119.6369459,
                    51.3177425
                ],
                [
                    119.6408942,
                    51.3180644
                ],
                [
                    119.6431258,
                    51.3165624
                ],
                [
                    119.6405481,
                    51.3163106
                ],
                [
                    119.6377712,
                    51.3155923
                ],
                [
                    119.6311095,
                    51.3086221
                ],
                [
                    119.6264548,
                    51.3062169
                ],
                [
                    119.6299127,
                    51.3048938
                ],
                [
                    119.630208,
                    51.305086
                ],
                [
                    119.6299865,
                    51.3060555
                ],
                [
                    119.6306325,
                    51.3062786
                ],
                [
                    119.6313094,
                    51.30509
                ],
                [
                    119.6337767,
                    51.305216
                ],
                [
                    119.6343689,
                    51.3035571
                ],
                [
                    119.6329999,
                    51.3033071
                ],
                [
                    119.6306156,
                    51.3047303
                ],
                [
                    119.6302142,
                    51.3041014
                ],
                [
                    119.6252919,
                    51.3051592
                ],
                [
                    119.6249231,
                    51.3049421
                ],
                [
                    119.6233968,
                    51.3042495
                ],
                [
                    119.6196574,
                    51.3021964
                ],
                [
                    119.6194324,
                    51.3019516
                ],
                [
                    119.6198559,
                    51.3017971
                ],
                [
                    119.6197324,
                    51.3017015
                ],
                [
                    119.6192898,
                    51.3018259
                ],
                [
                    119.6179203,
                    51.3020039
                ],
                [
                    119.6175482,
                    51.3022903
                ],
                [
                    119.61463,
                    51.3005732
                ],
                [
                    119.6137717,
                    51.2946697
                ],
                [
                    119.6118834,
                    51.2924155
                ],
                [
                    119.6098234,
                    51.2934889
                ],
                [
                    119.6065967,
                    51.2955025
                ],
                [
                    119.6015837,
                    51.2925228
                ],
                [
                    119.5945456,
                    51.2902685
                ],
                [
                    119.5895674,
                    51.2928449
                ],
                [
                    119.6008971,
                    51.2986412
                ],
                [
                    119.6053,
                    51.3023044
                ],
                [
                    119.6095782,
                    51.3006156
                ],
                [
                    119.6105101,
                    51.3035783
                ],
                [
                    119.6096665,
                    51.3042694
                ],
                [
                    119.6103677,
                    51.3059127
                ],
                [
                    119.6103161,
                    51.305928
                ],
                [
                    119.6093938,
                    51.3062009
                ],
                [
                    119.608743,
                    51.3063935
                ],
                [
                    119.6084323,
                    51.3069309
                ],
                [
                    119.6060319,
                    51.3084429
                ],
                [
                    119.6050032,
                    51.3084009
                ],
                [
                    119.6039841,
                    51.3086773
                ],
                [
                    119.6041091,
                    51.3091762
                ],
                [
                    119.602667,
                    51.3092603
                ],
                [
                    119.6020946,
                    51.309739
                ],
                [
                    119.6005616,
                    51.3099394
                ],
                [
                    119.5965231,
                    51.3096434
                ],
                [
                    119.5962504,
                    51.3101279
                ],
                [
                    119.594807,
                    51.3101956
                ],
                [
                    119.5923796,
                    51.3093778
                ],
                [
                    119.5912122,
                    51.3076399
                ],
                [
                    119.5904257,
                    51.3077636
                ],
                [
                    119.5874162,
                    51.3093431
                ],
                [
                    119.5854475,
                    51.3089439
                ],
                [
                    119.5836237,
                    51.309226
                ],
                [
                    119.5818065,
                    51.309834
                ],
                [
                    119.5786985,
                    51.3106807
                ]
            ],
            "longitude": 119.616234,
            "latitude": 51.30904
        },
        "2159": {
            "name": "Солонечная",
            "population": 42,
            "type": "village",
            "poly": [
                [
                    119.6344998,
                    51.3996929
                ],
                [
                    119.6382649,
                    51.4021501
                ],
                [
                    119.640694,
                    51.4047262
                ],
                [
                    119.6431752,
                    51.4035248
                ],
                [
                    119.6403991,
                    51.4005263
                ],
                [
                    119.6375316,
                    51.399357
                ],
                [
                    119.6374016,
                    51.399304
                ],
                [
                    119.6359399,
                    51.3987079
                ],
                [
                    119.6344998,
                    51.3996929
                ]
            ],
            "longitude": 119.6394139,
            "latitude": 51.4014306
        },
        "2160": {
            "name": "Булдуруй 1-й",
            "population": 324,
            "type": "village",
            "poly": [
                [
                    119.6407359,
                    51.0221194
                ],
                [
                    119.6470796,
                    51.0242583
                ],
                [
                    119.6512373,
                    51.0269632
                ],
                [
                    119.6557665,
                    51.0299915
                ],
                [
                    119.6603385,
                    51.025121
                ],
                [
                    119.6631389,
                    51.0246897
                ],
                [
                    119.6638533,
                    51.0264061
                ],
                [
                    119.6663716,
                    51.0261233
                ],
                [
                    119.6688968,
                    51.02167
                ],
                [
                    119.6685174,
                    51.0184839
                ],
                [
                    119.666082,
                    51.0165805
                ],
                [
                    119.6653658,
                    51.0165485
                ],
                [
                    119.663165,
                    51.0163217
                ],
                [
                    119.6620711,
                    51.016924
                ],
                [
                    119.6604386,
                    51.0177482
                ],
                [
                    119.656486,
                    51.0175291
                ],
                [
                    119.6551922,
                    51.0174175
                ],
                [
                    119.651598,
                    51.0179372
                ],
                [
                    119.6513896,
                    51.0193027
                ],
                [
                    119.6568474,
                    51.0203003
                ],
                [
                    119.6557187,
                    51.0228437
                ],
                [
                    119.6543757,
                    51.0221697
                ],
                [
                    119.6520182,
                    51.0229336
                ],
                [
                    119.6419472,
                    51.0201579
                ],
                [
                    119.6407359,
                    51.0221194
                ]
            ],
            "longitude": 119.6599343,
            "latitude": 51.0229651
        },
        "2161": {
            "name": "Булдуруй 2-й",
            "population": 158,
            "type": "village",
            "poly": [
                [
                    119.6965035,
                    51.0802031
                ],
                [
                    119.6987359,
                    51.0812914
                ],
                [
                    119.7041652,
                    51.078722
                ],
                [
                    119.704951,
                    51.0793503
                ],
                [
                    119.7039866,
                    51.0803489
                ],
                [
                    119.705844,
                    51.0808538
                ],
                [
                    119.7068751,
                    51.0799013
                ],
                [
                    119.7075884,
                    51.0786489
                ],
                [
                    119.7081645,
                    51.0773908
                ],
                [
                    119.7074055,
                    51.0763165
                ],
                [
                    119.7057413,
                    51.0758856
                ],
                [
                    119.7033912,
                    51.0761154
                ],
                [
                    119.6976762,
                    51.0791028
                ],
                [
                    119.6965035,
                    51.0802031
                ]
            ],
            "longitude": 119.7025043,
            "latitude": 51.0790137
        },
        "2162": {
            "name": "Чалбучи-Килга",
            "population": 254,
            "type": "village",
            "poly": [
                [
                    119.7054375,
                    51.1485963
                ],
                [
                    119.7082411,
                    51.1499532
                ],
                [
                    119.7112861,
                    51.1471597
                ],
                [
                    119.7126849,
                    51.1452527
                ],
                [
                    119.716096,
                    51.1432695
                ],
                [
                    119.7212396,
                    51.142698
                ],
                [
                    119.7227179,
                    51.1390819
                ],
                [
                    119.7167743,
                    51.1377408
                ],
                [
                    119.713471,
                    51.1364499
                ],
                [
                    119.7116764,
                    51.1365144
                ],
                [
                    119.7117107,
                    51.1375472
                ],
                [
                    119.7140882,
                    51.13896
                ],
                [
                    119.713871,
                    51.1413983
                ],
                [
                    119.7090018,
                    51.1442811
                ],
                [
                    119.7076589,
                    51.1457437
                ],
                [
                    119.7054375,
                    51.1485963
                ]
            ],
            "longitude": 119.7099185,
            "latitude": 51.145084
        },
        "2163": {
            "name": "Горбуновка",
            "population": 315,
            "type": "village",
            "poly": [
                [
                    119.74957,
                    51.2312271
                ],
                [
                    119.7501065,
                    51.2324804
                ],
                [
                    119.7567303,
                    51.2338113
                ],
                [
                    119.7599494,
                    51.2338371
                ],
                [
                    119.7610637,
                    51.2331911
                ],
                [
                    119.7605891,
                    51.2313175
                ],
                [
                    119.7665113,
                    51.2294052
                ],
                [
                    119.7703416,
                    51.2263386
                ],
                [
                    119.768117,
                    51.2255171
                ],
                [
                    119.7625466,
                    51.2266728
                ],
                [
                    119.7580168,
                    51.2280705
                ],
                [
                    119.7568793,
                    51.2275696
                ],
                [
                    119.7523809,
                    51.2284225
                ],
                [
                    119.7505811,
                    51.2298187
                ],
                [
                    119.74957,
                    51.2312271
                ]
            ],
            "longitude": 119.7598031,
            "latitude": 51.2298047
        },
        "2164": {
            "name": "Олочи",
            "population": 388,
            "type": "village",
            "poly": [
                [
                    119.890992,
                    51.3505313
                ],
                [
                    119.8949518,
                    51.3535303
                ],
                [
                    119.8942216,
                    51.3582129
                ],
                [
                    119.8979567,
                    51.3586338
                ],
                [
                    119.8998382,
                    51.3573887
                ],
                [
                    119.9035733,
                    51.3588618
                ],
                [
                    119.9073365,
                    51.3559506
                ],
                [
                    119.9104537,
                    51.3571432
                ],
                [
                    119.9137114,
                    51.3551087
                ],
                [
                    119.9066344,
                    51.3470934
                ],
                [
                    119.8944743,
                    51.3476898
                ],
                [
                    119.890992,
                    51.3505313
                ]
            ],
            "longitude": 119.899811,
            "latitude": 51.35376
        },
        "2165": {
            "name": "Заречное",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 119.931732,
            "latitude": 54.45797
        },
        "2166": {
            "name": "Тупик",
            "population": 1041,
            "type": "village",
            "poly": null,
            "longitude": 119.94368,
            "latitude": 54.426773
        },
        "2167": {
            "name": "Ишага",
            "population": 293,
            "type": "village",
            "poly": [
                [
                    119.9615318,
                    51.4830868
                ],
                [
                    119.9617772,
                    51.4895151
                ],
                [
                    119.9690218,
                    51.4901525
                ],
                [
                    119.9699425,
                    51.4904159
                ],
                [
                    119.9736637,
                    51.4857882
                ],
                [
                    119.9731394,
                    51.4819294
                ],
                [
                    119.9764123,
                    51.4784376
                ],
                [
                    119.9777312,
                    51.4775852
                ],
                [
                    119.9787017,
                    51.4768258
                ],
                [
                    119.9784712,
                    51.4761587
                ],
                [
                    119.9794899,
                    51.4748958
                ],
                [
                    119.9725802,
                    51.4723776
                ],
                [
                    119.9715102,
                    51.4726256
                ],
                [
                    119.9715454,
                    51.4732882
                ],
                [
                    119.9669056,
                    51.4767056
                ],
                [
                    119.9656376,
                    51.4787476
                ],
                [
                    119.9646423,
                    51.4784066
                ],
                [
                    119.9639207,
                    51.4786701
                ],
                [
                    119.9615318,
                    51.4830868
                ]
            ],
            "longitude": 119.9712692,
            "latitude": 51.479275
        },
        "2168": {
            "name": "Домасово",
            "population": 172,
            "type": "village",
            "poly": [
                [
                    119.983081,
                    51.5484483
                ],
                [
                    119.983961,
                    51.5489324
                ],
                [
                    119.9852798,
                    51.5489942
                ],
                [
                    119.9924712,
                    51.548004
                ],
                [
                    119.9941176,
                    51.5475674
                ],
                [
                    119.9987171,
                    51.5437793
                ],
                [
                    120.0019007,
                    51.5391291
                ],
                [
                    119.9969503,
                    51.5384553
                ],
                [
                    119.9930684,
                    51.5380684
                ],
                [
                    119.9896594,
                    51.5381922
                ],
                [
                    119.9886889,
                    51.5380065
                ],
                [
                    119.9884185,
                    51.5390595
                ],
                [
                    119.9896521,
                    51.539441
                ],
                [
                    119.9885396,
                    51.5419377
                ],
                [
                    119.9868973,
                    51.5451721
                ],
                [
                    119.984384,
                    51.5465029
                ],
                [
                    119.984384,
                    51.547091
                ],
                [
                    119.983081,
                    51.5484483
                ]
            ],
            "longitude": 119.993689,
            "latitude": 51.5424973
        },
        "2169": {
            "name": "Аргунск",
            "population": 498,
            "type": "village",
            "poly": [
                [
                    120.005116,
                    51.5797264
                ],
                [
                    120.0059232,
                    51.5813805
                ],
                [
                    120.0109,
                    51.5804527
                ],
                [
                    120.0119949,
                    51.5808856
                ],
                [
                    120.0111489,
                    51.5832669
                ],
                [
                    120.0120609,
                    51.5843967
                ],
                [
                    120.0099047,
                    51.5886783
                ],
                [
                    120.00876,
                    51.5885237
                ],
                [
                    120.0084614,
                    51.5892968
                ],
                [
                    120.01033,
                    51.5895849
                ],
                [
                    120.0156777,
                    51.5839163
                ],
                [
                    120.020754,
                    51.5833287
                ],
                [
                    120.0217494,
                    51.5848749
                ],
                [
                    120.0278993,
                    51.5839371
                ],
                [
                    120.0294744,
                    51.5809774
                ],
                [
                    120.0280368,
                    51.5766009
                ],
                [
                    120.0279966,
                    51.5728626
                ],
                [
                    120.031938,
                    51.571583
                ],
                [
                    120.0319325,
                    51.5703864
                ],
                [
                    120.0284526,
                    51.5687941
                ],
                [
                    120.023277,
                    51.5691853
                ],
                [
                    120.0221233,
                    51.5712747
                ],
                [
                    120.0113348,
                    51.5719845
                ],
                [
                    120.005116,
                    51.5797264
                ]
            ],
            "longitude": 120.0219722,
            "latitude": 51.5761111
        },
        "2170": {
            "name": "Часовая",
            "population": 0,
            "type": "village",
            "poly": null,
            "longitude": 120.0494612,
            "latitude": 53.4875463
        },
        "2171": {
            "name": "Таптугары",
            "population": 581,
            "type": "village",
            "poly": [
                [
                    120.0502281,
                    53.6855157
                ],
                [
                    120.052493,
                    53.6879919
                ],
                [
                    120.0581553,
                    53.6879145
                ],
                [
                    120.0663003,
                    53.6869086
                ],
                [
                    120.0716577,
                    53.689591
                ],
                [
                    120.0767102,
                    53.6886109
                ],
                [
                    120.0784089,
                    53.6864185
                ],
                [
                    120.0753164,
                    53.6810014
                ],
                [
                    120.0597668,
                    53.6823428
                ],
                [
                    120.0502281,
                    53.6855157
                ]
            ],
            "longitude": 120.0680487,
            "latitude": 53.684151
        },
        "2172": {
            "name": "Средняя",
            "population": 42,
            "type": "village",
            "poly": [
                [
                    120.0892669,
                    51.6883623
                ],
                [
                    120.0895158,
                    51.6887326
                ],
                [
                    120.0902125,
                    51.6890411
                ],
                [
                    120.0921783,
                    51.6894113
                ],
                [
                    120.0924272,
                    51.6891337
                ],
                [
                    120.0943432,
                    51.6909693
                ],
                [
                    120.0949404,
                    51.6910465
                ],
                [
                    120.0940255,
                    51.6881888
                ],
                [
                    120.0942437,
                    51.6872053
                ],
                [
                    120.0949404,
                    51.6866344
                ],
                [
                    120.0979763,
                    51.686326
                ],
                [
                    120.0975284,
                    51.6850764
                ],
                [
                    120.0997181,
                    51.6848912
                ],
                [
                    120.1009126,
                    51.6843821
                ],
                [
                    120.1009375,
                    51.6833639
                ],
                [
                    120.0994195,
                    51.6830245
                ],
                [
                    120.0996933,
                    51.6825153
                ],
                [
                    120.0976576,
                    51.6820347
                ],
                [
                    120.0903276,
                    51.6831914
                ],
                [
                    120.0893757,
                    51.6850552
                ],
                [
                    120.0901876,
                    51.6851689
                ],
                [
                    120.0902623,
                    51.6860792
                ],
                [
                    120.0894909,
                    51.6866962
                ],
                [
                    120.0899637,
                    51.6880075
                ],
                [
                    120.0892669,
                    51.6883623
                ]
            ],
            "longitude": 120.0930422,
            "latitude": 51.6832534
        },
        "2173": {
            "name": "Аникино",
            "population": 0,
            "type": "village",
            "poly": null,
            "longitude": 120.3330408,
            "latitude": 53.4358195
        },
        "2174": {
            "name": "Семиозёрный",
            "population": 985,
            "type": "village",
            "poly": null,
            "longitude": 120.3654341,
            "latitude": 53.7104662
        },
        "2175": {
            "name": "Средняя Олёкма",
            "population": 99,
            "type": "village",
            "poly": null,
            "longitude": 120.547829,
            "latitude": 55.425037
        },
        "2176": {
            "name": "Закамень",
            "population": null,
            "type": "village",
            "poly": [
                [
                    120.704669,
                    52.2097656
                ],
                [
                    120.7050466,
                    52.2118479
                ],
                [
                    120.7060535,
                    52.2136988
                ],
                [
                    120.7117802,
                    52.2150483
                ],
                [
                    120.7139199,
                    52.213159
                ],
                [
                    120.7128501,
                    52.2096499
                ],
                [
                    120.704669,
                    52.2097656
                ]
            ],
            "longitude": 120.7098294,
            "latitude": 52.212195
        },
        "2177": {
            "name": "Гуля",
            "population": 36,
            "type": "village",
            "poly": null,
            "longitude": 120.997459,
            "latitude": 54.671566
        },
        "2178": {
            "name": "Малая Бича",
            "population": 894,
            "type": "village",
            "poly": null,
            "longitude": 70.456322,
            "latitude": 57.937202
        },
        "2179": {
            "name": "Загваздино",
            "population": 398,
            "type": "village",
            "poly": null,
            "longitude": 70.5743885,
            "latitude": 57.817139
        },
        "2180": {
            "name": "Большая Бича",
            "population": 325,
            "type": "village",
            "poly": null,
            "longitude": 70.622459,
            "latitude": 57.873371
        },
        "2181": {
            "name": "Кисляки",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 70.631897,
            "latitude": 55.344563
        },
        "2182": {
            "name": "Кайлы",
            "population": 270,
            "type": "village",
            "poly": null,
            "longitude": 70.691887,
            "latitude": 57.29081
        },
        "2183": {
            "name": "Саургачи",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 70.7158491,
            "latitude": 57.7469252
        },
        "2184": {
            "name": "Мангут",
            "population": 1149,
            "type": "village",
            "poly": null,
            "longitude": 70.770058,
            "latitude": 55.780849
        },
        "2185": {
            "name": "Большепесчанка",
            "population": 780,
            "type": "village",
            "poly": null,
            "longitude": 70.808037,
            "latitude": 55.527
        },
        "2186": {
            "name": "Паново",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 70.8267065,
            "latitude": 57.7971902
        },
        "2187": {
            "name": "Большая Тебендя",
            "population": 214,
            "type": "village",
            "poly": null,
            "longitude": 70.8421108,
            "latitude": 57.7290721
        },
        "2188": {
            "name": "Орехово",
            "population": 442,
            "type": "village",
            "poly": null,
            "longitude": 70.8494343,
            "latitude": 57.4557996
        },
        "2189": {
            "name": "Зимино",
            "population": 881,
            "type": "village",
            "poly": null,
            "longitude": 70.8683746,
            "latitude": 56.2794241
        },
        "2190": {
            "name": "Слободчики",
            "population": 319,
            "type": "village",
            "poly": null,
            "longitude": 70.934387,
            "latitude": 57.501663
        },
        "2191": {
            "name": "Скородум",
            "population": 684,
            "type": "village",
            "poly": null,
            "longitude": 70.9353764,
            "latitude": 57.7978351
        },
        "2192": {
            "name": "Паново",
            "population": 865,
            "type": "village",
            "poly": null,
            "longitude": 70.9636,
            "latitude": 56.351177
        },
        "2193": {
            "name": "Искра",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 70.9782521,
            "latitude": 55.923589
        },
        "2194": {
            "name": "Князево",
            "population": 591,
            "type": "village",
            "poly": null,
            "longitude": 70.9952477,
            "latitude": 55.3445376
        },
        "2195": {
            "name": "Рыжково",
            "population": 341,
            "type": "village",
            "poly": null,
            "longitude": 70.999825,
            "latitude": 55.99752
        },
        "2196": {
            "name": "Покровка",
            "population": 533,
            "type": "village",
            "poly": null,
            "longitude": 71.0014247,
            "latitude": 55.5218518
        },
        "2197": {
            "name": "Рославка",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 71.03154,
            "latitude": 54.9457142
        },
        "2198": {
            "name": "Благовещенка",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 71.0491115,
            "latitude": 54.8872393
        },
        "2199": {
            "name": "Первотаровка",
            "population": 678,
            "type": "village",
            "poly": null,
            "longitude": 71.0544813,
            "latitude": 55.0733788
        },
        "2200": {
            "name": "Кромы",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 71.0800069,
            "latitude": 54.7681892
        },
        "2201": {
            "name": "Северный",
            "population": 210,
            "type": "village",
            "poly": null,
            "longitude": 71.0938768,
            "latitude": 54.9943791
        },
        "2202": {
            "name": "Новоильиновка",
            "population": 1133,
            "type": "village",
            "poly": null,
            "longitude": 71.1145364,
            "latitude": 54.2354743
        },
        "2203": {
            "name": "Каскат",
            "population": 376,
            "type": "village",
            "poly": null,
            "longitude": 71.1303665,
            "latitude": 54.7985361
        },
        "2204": {
            "name": "Комсомольский",
            "population": 400,
            "type": "village",
            "poly": null,
            "longitude": 71.1396817,
            "latitude": 54.8751624
        },
        "2205": {
            "name": "Тюрметяки",
            "population": 66,
            "type": "village",
            "poly": null,
            "longitude": 71.1473594,
            "latitude": 57.5790781
        },
        "2206": {
            "name": "Лесной",
            "population": 1189,
            "type": "village",
            "poly": [
                [
                    71.1415355,
                    54.9671297
                ],
                [
                    71.1418661,
                    54.9678887
                ],
                [
                    71.1442701,
                    54.9675696
                ],
                [
                    71.1453819,
                    54.9673539
                ],
                [
                    71.1453819,
                    54.9671124
                ],
                [
                    71.1467192,
                    54.9667416
                ],
                [
                    71.1468093,
                    54.9683544
                ],
                [
                    71.146614,
                    54.9683544
                ],
                [
                    71.146629,
                    54.9697258
                ],
                [
                    71.1469445,
                    54.9697258
                ],
                [
                    71.1468093,
                    54.9707003
                ],
                [
                    71.1459829,
                    54.9706831
                ],
                [
                    71.1458477,
                    54.9721492
                ],
                [
                    71.1470497,
                    54.9721405
                ],
                [
                    71.1471248,
                    54.9724941
                ],
                [
                    71.1479512,
                    54.9724941
                ],
                [
                    71.1479963,
                    54.9728908
                ],
                [
                    71.1505205,
                    54.9730892
                ],
                [
                    71.1505134,
                    54.9734366
                ],
                [
                    71.1513528,
                    54.9734366
                ],
                [
                    71.1514165,
                    54.9731134
                ],
                [
                    71.1529252,
                    54.9729731
                ],
                [
                    71.1531377,
                    54.9728939
                ],
                [
                    71.153127,
                    54.9719669
                ],
                [
                    71.1541045,
                    54.9718084
                ],
                [
                    71.154427,
                    54.972175
                ],
                [
                    71.1592801,
                    54.9708124
                ],
                [
                    71.1590998,
                    54.970502
                ],
                [
                    71.1636524,
                    54.9693808
                ],
                [
                    71.160993,
                    54.9640504
                ],
                [
                    71.1573118,
                    54.9617128
                ],
                [
                    71.1571015,
                    54.9620319
                ],
                [
                    71.157432,
                    54.962239
                ],
                [
                    71.1570865,
                    54.9623511
                ],
                [
                    71.1563953,
                    54.9625236
                ],
                [
                    71.1556891,
                    54.9627738
                ],
                [
                    71.1538561,
                    54.9617645
                ],
                [
                    71.1537208,
                    54.9621441
                ],
                [
                    71.1509112,
                    54.9643264
                ],
                [
                    71.1494237,
                    54.9636536
                ],
                [
                    71.1465389,
                    54.9649389
                ],
                [
                    71.1469145,
                    54.966431
                ],
                [
                    71.1456374,
                    54.9664569
                ],
                [
                    71.1459078,
                    54.9663017
                ],
                [
                    71.1459227,
                    54.9659998
                ],
                [
                    71.1453669,
                    54.9657238
                ],
                [
                    71.144796,
                    54.9656979
                ],
                [
                    71.1446157,
                    54.9660257
                ],
                [
                    71.1446607,
                    54.9663362
                ],
                [
                    71.144841,
                    54.9664828
                ],
                [
                    71.1447208,
                    54.9665949
                ],
                [
                    71.1445706,
                    54.9665518
                ],
                [
                    71.1415355,
                    54.9671297
                ]
            ],
            "longitude": 71.1506868,
            "latitude": 54.9688643
        },
        "2207": {
            "name": "Никольск",
            "population": 391,
            "type": "village",
            "poly": null,
            "longitude": 71.1704456,
            "latitude": 57.7400147
        },
        "2208": {
            "name": "Южный",
            "population": 363,
            "type": "village",
            "poly": null,
            "longitude": 71.185461,
            "latitude": 57.6603033
        },
        "2209": {
            "name": "Ашеваны",
            "population": 310,
            "type": "village",
            "poly": null,
            "longitude": 71.1900858,
            "latitude": 57.6330234
        },
        "2210": {
            "name": "Большая Тава",
            "population": 309,
            "type": "village",
            "poly": [
                [
                    71.1858079,
                    57.4944803
                ],
                [
                    71.1882009,
                    57.4977181
                ],
                [
                    71.1913339,
                    57.4991905
                ],
                [
                    71.1961041,
                    57.5008309
                ],
                [
                    71.2014643,
                    57.5001523
                ],
                [
                    71.2069377,
                    57.4978196
                ],
                [
                    71.208654,
                    57.4947824
                ],
                [
                    71.203035,
                    57.489798
                ],
                [
                    71.1980536,
                    57.4889094
                ],
                [
                    71.1957385,
                    57.4896611
                ],
                [
                    71.1931749,
                    57.4902556
                ],
                [
                    71.1889074,
                    57.4922321
                ],
                [
                    71.1858079,
                    57.4944803
                ]
            ],
            "longitude": 71.195152,
            "latitude": 57.496265
        },
        "2211": {
            "name": "Толоконцево",
            "population": 268,
            "type": "village",
            "poly": null,
            "longitude": 71.202385,
            "latitude": 56.450352
        },
        "2212": {
            "name": "Кудряевка",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 71.2318296,
            "latitude": 54.747984
        },
        "2213": {
            "name": "Никольск",
            "population": 102,
            "type": "village",
            "poly": null,
            "longitude": 71.2387779,
            "latitude": 56.4925913
        },
        "2214": {
            "name": "Терпенье",
            "population": 356,
            "type": "village",
            "poly": null,
            "longitude": 71.2462555,
            "latitude": 54.2507719
        },
        "2215": {
            "name": "Путь Социализма",
            "population": 491,
            "type": "village",
            "poly": null,
            "longitude": 71.263229,
            "latitude": 55.755714
        },
        "2216": {
            "name": "Солнцевка",
            "population": 1805,
            "type": "village",
            "poly": null,
            "longitude": 71.287582,
            "latitude": 54.990009
        },
        "2217": {
            "name": "Соловьёвка",
            "population": 1049,
            "type": "village",
            "poly": null,
            "longitude": 71.2890145,
            "latitude": 54.4794586
        },
        "2218": {
            "name": "Медвежье",
            "population": 861,
            "type": "village",
            "poly": null,
            "longitude": 71.2902544,
            "latitude": 55.1871748
        },
        "2219": {
            "name": "Петровка",
            "population": 245,
            "type": "village",
            "poly": null,
            "longitude": 71.3253847,
            "latitude": 55.0087479
        },
        "2220": {
            "name": "Утускун",
            "population": 120,
            "type": "village",
            "poly": null,
            "longitude": 71.3286651,
            "latitude": 57.7366112
        },
        "2221": {
            "name": "Украинка",
            "population": 1551,
            "type": "village",
            "poly": null,
            "longitude": 71.332848,
            "latitude": 54.653961
        },
        "2222": {
            "name": "Жирновка",
            "population": 548,
            "type": "village",
            "poly": null,
            "longitude": 71.3333413,
            "latitude": 55.3859767
        },
        "2223": {
            "name": "Водяное",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 71.343147,
            "latitude": 55.007309
        },
        "2224": {
            "name": "Ленинский",
            "population": 411,
            "type": "village",
            "poly": null,
            "longitude": 71.3496155,
            "latitude": 54.8405243
        },
        "2225": {
            "name": "Вольное",
            "population": 1219,
            "type": "village",
            "poly": null,
            "longitude": 71.3573897,
            "latitude": 54.2860993
        },
        "2226": {
            "name": "Боровое",
            "population": 480,
            "type": "village",
            "poly": null,
            "longitude": 71.3597082,
            "latitude": 54.772024
        },
        "2227": {
            "name": "Святогорск",
            "population": 286,
            "type": "village",
            "poly": null,
            "longitude": 71.3799035,
            "latitude": 54.3879541
        },
        "2228": {
            "name": "Яман",
            "population": 759,
            "type": "village",
            "poly": null,
            "longitude": 71.393486,
            "latitude": 56.044758
        },
        "2229": {
            "name": "Новодонка",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 71.4043273,
            "latitude": 54.653961
        },
        "2230": {
            "name": "Муравьёвка",
            "population": 377,
            "type": "village",
            "poly": null,
            "longitude": 71.4106376,
            "latitude": 55.6712831
        },
        "2231": {
            "name": "Старинка",
            "population": 345,
            "type": "village",
            "poly": null,
            "longitude": 71.4126567,
            "latitude": 55.7424837
        },
        "2232": {
            "name": "Мясники",
            "population": 289,
            "type": "village",
            "poly": null,
            "longitude": 71.4164566,
            "latitude": 54.5842343
        },
        "2233": {
            "name": "Добрянка",
            "population": 331,
            "type": "village",
            "poly": null,
            "longitude": 71.427723,
            "latitude": 54.2194286
        },
        "2234": {
            "name": "Боевой",
            "population": 1506,
            "type": "village",
            "poly": null,
            "longitude": 71.447296,
            "latitude": 54.933403
        },
        "2235": {
            "name": "Лубянск",
            "population": 343,
            "type": "village",
            "poly": null,
            "longitude": 71.4504005,
            "latitude": 54.4738968
        },
        "2236": {
            "name": "Ярково",
            "population": 220,
            "type": "village",
            "poly": null,
            "longitude": 71.4598692,
            "latitude": 57.649836
        },
        "2237": {
            "name": "Новорождественка",
            "population": 718,
            "type": "village",
            "poly": null,
            "longitude": 71.4612713,
            "latitude": 55.0951862
        },
        "2238": {
            "name": "Гофнунгсталь",
            "population": 407,
            "type": "village",
            "poly": null,
            "longitude": 71.4966317,
            "latitude": 54.9620961
        },
        "2239": {
            "name": "Воронцовка",
            "population": 910,
            "type": "village",
            "poly": null,
            "longitude": 71.500679,
            "latitude": 54.32745
        },
        "2240": {
            "name": "Пучково",
            "population": 391,
            "type": "village",
            "poly": null,
            "longitude": 71.5088353,
            "latitude": 54.9331847
        },
        "2241": {
            "name": "Фомиха",
            "population": 394,
            "type": "village",
            "poly": null,
            "longitude": 71.5097024,
            "latitude": 55.4723898
        },
        "2242": {
            "name": "Аксеново",
            "population": 607,
            "type": "village",
            "poly": null,
            "longitude": 71.5134569,
            "latitude": 57.690324
        },
        "2243": {
            "name": "Николайполь",
            "population": 441,
            "type": "village",
            "poly": null,
            "longitude": 71.5179221,
            "latitude": 54.868198
        },
        "2244": {
            "name": "Баррикада",
            "population": 868,
            "type": "village",
            "poly": null,
            "longitude": 71.5396757,
            "latitude": 54.7835299
        },
        "2245": {
            "name": "Ильчебага",
            "population": 297,
            "type": "village",
            "poly": null,
            "longitude": 71.5405615,
            "latitude": 57.6174312
        },
        "2246": {
            "name": "Аполлоновка",
            "population": 836,
            "type": "village",
            "poly": null,
            "longitude": 71.542999,
            "latitude": 55.168213
        },
        "2247": {
            "name": "Шипуново",
            "population": 736,
            "type": "village",
            "poly": null,
            "longitude": 71.5511908,
            "latitude": 56.2567578
        },
        "2248": {
            "name": "Маргенау",
            "population": 701,
            "type": "village",
            "poly": null,
            "longitude": 71.566658,
            "latitude": 54.919445
        },
        "2249": {
            "name": "Никоновка",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 71.595085,
            "latitude": 54.303505
        },
        "2250": {
            "name": "Лорис-Меликово",
            "population": 516,
            "type": "village",
            "poly": null,
            "longitude": 71.59684,
            "latitude": 55.583809
        },
        "2251": {
            "name": "Китерма",
            "population": 626,
            "type": "village",
            "poly": null,
            "longitude": 71.625198,
            "latitude": 56.095715
        },
        "2252": {
            "name": "Утичье",
            "population": 346,
            "type": "village",
            "poly": null,
            "longitude": 71.6400412,
            "latitude": 55.3170207
        },
        "2253": {
            "name": "Миролюбовка",
            "population": 590,
            "type": "village",
            "poly": null,
            "longitude": 71.646194,
            "latitude": 54.866489
        },
        "2254": {
            "name": "Звездино",
            "population": 901,
            "type": "village",
            "poly": null,
            "longitude": 71.662933,
            "latitude": 54.965183
        },
        "2255": {
            "name": "Ольгино",
            "population": 1343,
            "type": "village",
            "poly": null,
            "longitude": 71.678612,
            "latitude": 54.266537
        },
        "2256": {
            "name": "Красногорка",
            "population": 818,
            "type": "village",
            "poly": null,
            "longitude": 71.6792491,
            "latitude": 54.5676764
        },
        "2257": {
            "name": "Кайсы",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 71.6978957,
            "latitude": 57.6600774
        },
        "2258": {
            "name": "Кочковатский",
            "population": 69,
            "type": "village",
            "poly": null,
            "longitude": 71.6981637,
            "latitude": 55.4521322
        },
        "2259": {
            "name": "Тавинск",
            "population": 355,
            "type": "village",
            "poly": null,
            "longitude": 71.7093985,
            "latitude": 57.5879459
        },
        "2260": {
            "name": "Родная Долина",
            "population": 416,
            "type": "village",
            "poly": null,
            "longitude": 71.746185,
            "latitude": 54.865433
        },
        "2261": {
            "name": "Утьма",
            "population": 473,
            "type": "village",
            "poly": null,
            "longitude": 71.7540915,
            "latitude": 57.5762237
        },
        "2262": {
            "name": "Богодуховка",
            "population": 123,
            "type": "village",
            "poly": null,
            "longitude": 71.7631824,
            "latitude": 55.4820243
        },
        "2263": {
            "name": "Бельдеж № 3",
            "population": 517,
            "type": "village",
            "poly": null,
            "longitude": 71.769707,
            "latitude": 54.391434
        },
        "2264": {
            "name": "Корнеевка",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 71.77296,
            "latitude": 54.9197813
        },
        "2265": {
            "name": "Черемновка",
            "population": 456,
            "type": "village",
            "poly": null,
            "longitude": 71.7747205,
            "latitude": 55.4177698
        },
        "2266": {
            "name": "Георгиевка",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 71.775018,
            "latitude": 54.2985684
        },
        "2267": {
            "name": "Оглухино",
            "population": 1061,
            "type": "village",
            "poly": null,
            "longitude": 71.784355,
            "latitude": 55.86145
        },
        "2268": {
            "name": "Шевченко",
            "population": 940,
            "type": "village",
            "poly": null,
            "longitude": 71.79081,
            "latitude": 54.814659
        },
        "2269": {
            "name": "Весёлый",
            "population": 274,
            "type": "village",
            "poly": null,
            "longitude": 71.7990592,
            "latitude": 54.9664494
        },
        "2270": {
            "name": "Новокарасук",
            "population": 1263,
            "type": "village",
            "poly": null,
            "longitude": 71.8081456,
            "latitude": 56.2655388
        },
        "2271": {
            "name": "Доброе Поле",
            "population": 451,
            "type": "village",
            "poly": null,
            "longitude": 71.816505,
            "latitude": 54.875927
        },
        "2272": {
            "name": "Налимово",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 71.8192073,
            "latitude": 55.6400236
        },
        "2273": {
            "name": "Екатериновка",
            "population": 695,
            "type": "village",
            "poly": null,
            "longitude": 71.827614,
            "latitude": 54.91774
        },
        "2274": {
            "name": "Кип",
            "population": 397,
            "type": "village",
            "poly": null,
            "longitude": 71.8471551,
            "latitude": 57.5458389
        },
        "2275": {
            "name": "Ярославка",
            "population": 361,
            "type": "village",
            "poly": null,
            "longitude": 71.860281,
            "latitude": 55.9894035
        },
        "2276": {
            "name": "Бельдеж № 12",
            "population": 362,
            "type": "village",
            "poly": null,
            "longitude": 71.8817226,
            "latitude": 54.392242
        },
        "2277": {
            "name": "Гвоздевка",
            "population": 716,
            "type": "village",
            "poly": null,
            "longitude": 71.88266,
            "latitude": 54.581463
        },
        "2278": {
            "name": "Нейфельд",
            "population": 459,
            "type": "village",
            "poly": null,
            "longitude": 71.88266,
            "latitude": 54.937847
        },
        "2279": {
            "name": "Листвяги",
            "population": 110,
            "type": "village",
            "poly": [
                [
                    71.8897954,
                    57.2313173
                ],
                [
                    71.8913102,
                    57.2316794
                ],
                [
                    71.8936204,
                    57.2326701
                ],
                [
                    71.894037,
                    57.2328136
                ],
                [
                    71.8948575,
                    57.2328136
                ],
                [
                    71.8952741,
                    57.2327384
                ],
                [
                    71.8954761,
                    57.2326291
                ],
                [
                    71.8954887,
                    57.232267
                ],
                [
                    71.8967258,
                    57.2317341
                ],
                [
                    71.8971677,
                    57.2317341
                ],
                [
                    71.8978999,
                    57.2319186
                ],
                [
                    71.8984174,
                    57.232144
                ],
                [
                    71.8987583,
                    57.2325881
                ],
                [
                    71.899036,
                    57.2327179
                ],
                [
                    71.8996041,
                    57.2324788
                ],
                [
                    71.9003236,
                    57.2326838
                ],
                [
                    71.9011189,
                    57.2324651
                ],
                [
                    71.9013966,
                    57.2324037
                ],
                [
                    71.9020531,
                    57.2325813
                ],
                [
                    71.902659,
                    57.2326291
                ],
                [
                    71.9028862,
                    57.2327589
                ],
                [
                    71.9032018,
                    57.233572
                ],
                [
                    71.9033659,
                    57.233613
                ],
                [
                    71.9033028,
                    57.2337428
                ],
                [
                    71.9006771,
                    57.2339887
                ],
                [
                    71.8997933,
                    57.2347129
                ],
                [
                    71.9008033,
                    57.2352527
                ],
                [
                    71.9015481,
                    57.236052
                ],
                [
                    71.9067996,
                    57.238566
                ],
                [
                    71.9088825,
                    57.2384157
                ],
                [
                    71.9106877,
                    57.2371655
                ],
                [
                    71.9121268,
                    57.2366258
                ],
                [
                    71.9136417,
                    57.2365644
                ],
                [
                    71.9144749,
                    57.2366053
                ],
                [
                    71.9166083,
                    57.2364414
                ],
                [
                    71.9195244,
                    57.2365712
                ],
                [
                    71.9221627,
                    57.2369059
                ],
                [
                    71.9245486,
                    57.2373773
                ],
                [
                    71.9252177,
                    57.234549
                ],
                [
                    71.923362,
                    57.2327043
                ],
                [
                    71.9195622,
                    57.232103
                ],
                [
                    71.9176561,
                    57.2321099
                ],
                [
                    71.91729,
                    57.230593
                ],
                [
                    71.9154974,
                    57.2308117
                ],
                [
                    71.9144117,
                    57.2310303
                ],
                [
                    71.9140204,
                    57.2312421
                ],
                [
                    71.9129853,
                    57.2302719
                ],
                [
                    71.9122026,
                    57.2301284
                ],
                [
                    71.9093117,
                    57.2302309
                ],
                [
                    71.9076328,
                    57.2302241
                ],
                [
                    71.9047419,
                    57.2300464
                ],
                [
                    71.9045021,
                    57.2300601
                ],
                [
                    71.8990234,
                    57.2304154
                ],
                [
                    71.8954256,
                    57.2305384
                ],
                [
                    71.8943652,
                    57.2306477
                ],
                [
                    71.8936961,
                    57.2305247
                ],
                [
                    71.8934184,
                    57.2302992
                ],
                [
                    71.8928125,
                    57.2307707
                ],
                [
                    71.8926231,
                    57.2309962
                ],
                [
                    71.8919414,
                    57.2310645
                ],
                [
                    71.890111,
                    57.2308732
                ],
                [
                    71.8898459,
                    57.2311465
                ],
                [
                    71.8897954,
                    57.2313173
                ]
            ],
            "longitude": 71.9109675,
            "latitude": 57.235567
        },
        "2280": {
            "name": "Волчанка",
            "population": 406,
            "type": "village",
            "poly": null,
            "longitude": 71.917394,
            "latitude": 54.9652572
        },
        "2281": {
            "name": "Алексеевка",
            "population": 1202,
            "type": "village",
            "poly": null,
            "longitude": 71.921577,
            "latitude": 54.843067
        },
        "2282": {
            "name": "Новоцарицыно",
            "population": 1446,
            "type": "village",
            "poly": null,
            "longitude": 71.941666,
            "latitude": 54.663315
        },
        "2283": {
            "name": "Коконовка",
            "population": 288,
            "type": "village",
            "poly": null,
            "longitude": 71.95049,
            "latitude": 54.3116064
        },
        "2284": {
            "name": "Розенталь",
            "population": 390,
            "type": "village",
            "poly": null,
            "longitude": 71.9506466,
            "latitude": 54.9088071
        },
        "2285": {
            "name": "Клаус",
            "population": 461,
            "type": "village",
            "poly": null,
            "longitude": 71.950829,
            "latitude": 54.925709
        },
        "2286": {
            "name": "Тумановка",
            "population": 731,
            "type": "village",
            "poly": null,
            "longitude": 71.9530396,
            "latitude": 55.0954904
        },
        "2287": {
            "name": "Драгунский",
            "population": 558,
            "type": "village",
            "poly": null,
            "longitude": 71.9546699,
            "latitude": 55.3274445
        },
        "2288": {
            "name": "Жанааул",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 71.9587279,
            "latitude": 54.7361487
        },
        "2289": {
            "name": "Валуевка",
            "population": 577,
            "type": "village",
            "poly": null,
            "longitude": 72.0193627,
            "latitude": 55.6964366
        },
        "2290": {
            "name": "Ильичевка",
            "population": 608,
            "type": "village",
            "poly": null,
            "longitude": 72.025002,
            "latitude": 55.04845
        },
        "2291": {
            "name": "Красноусово",
            "population": 581,
            "type": "village",
            "poly": null,
            "longitude": 72.0255412,
            "latitude": 55.8627372
        },
        "2292": {
            "name": "Атрачи",
            "population": 684,
            "type": "village",
            "poly": [
                [
                    71.9984483,
                    55.9462798
                ],
                [
                    72.0004034,
                    55.9467775
                ],
                [
                    72.0014537,
                    55.9471394
                ],
                [
                    72.0030048,
                    55.9478813
                ],
                [
                    72.0036609,
                    55.9482696
                ],
                [
                    72.0072487,
                    55.9491205
                ],
                [
                    72.00734,
                    55.9493124
                ],
                [
                    72.0076143,
                    55.9494212
                ],
                [
                    72.0122646,
                    55.9506175
                ],
                [
                    72.0128587,
                    55.9507966
                ],
                [
                    72.0134757,
                    55.9510781
                ],
                [
                    72.0153495,
                    55.95127
                ],
                [
                    72.0148582,
                    55.9523639
                ],
                [
                    72.0148239,
                    55.952703
                ],
                [
                    72.0164807,
                    55.9530356
                ],
                [
                    72.0161608,
                    55.9536945
                ],
                [
                    72.0161265,
                    55.9542574
                ],
                [
                    72.0183431,
                    55.9550314
                ],
                [
                    72.0183545,
                    55.955396
                ],
                [
                    72.0188915,
                    55.9555623
                ],
                [
                    72.0186858,
                    55.9560101
                ],
                [
                    72.0192457,
                    55.9562148
                ],
                [
                    72.0190972,
                    55.956509
                ],
                [
                    72.0196913,
                    55.9566817
                ],
                [
                    72.0195885,
                    55.956912
                ],
                [
                    72.020274,
                    55.9570335
                ],
                [
                    72.020434,
                    55.956816
                ],
                [
                    72.0208796,
                    55.9568992
                ],
                [
                    72.0211766,
                    55.95688
                ],
                [
                    72.0213937,
                    55.9567457
                ],
                [
                    72.0216908,
                    55.9568672
                ],
                [
                    72.0255413,
                    55.9576923
                ],
                [
                    72.0248213,
                    55.9586645
                ],
                [
                    72.02473,
                    55.9590291
                ],
                [
                    72.023576,
                    55.9602251
                ],
                [
                    72.0252556,
                    55.960174
                ],
                [
                    72.0254727,
                    55.9604809
                ],
                [
                    72.0257469,
                    55.9605001
                ],
                [
                    72.0265924,
                    55.9601867
                ],
                [
                    72.0271409,
                    55.96011
                ],
                [
                    72.0278493,
                    55.960078
                ],
                [
                    72.0285264,
                    55.9601167
                ],
                [
                    72.0295047,
                    55.9588005
                ],
                [
                    72.0297794,
                    55.958493
                ],
                [
                    72.0301833,
                    55.957697
                ],
                [
                    72.0304096,
                    55.9570819
                ],
                [
                    72.0336251,
                    55.9571904
                ],
                [
                    72.0339483,
                    55.9572447
                ],
                [
                    72.0360488,
                    55.9572538
                ],
                [
                    72.0361943,
                    55.9566839
                ],
                [
                    72.0364043,
                    55.9564215
                ],
                [
                    72.0366289,
                    55.9562558
                ],
                [
                    72.0367598,
                    55.9561592
                ],
                [
                    72.037083,
                    55.956123
                ],
                [
                    72.0435787,
                    55.9529026
                ],
                [
                    72.0444027,
                    55.9521426
                ],
                [
                    72.0425607,
                    55.9513013
                ],
                [
                    72.0438049,
                    55.9502066
                ],
                [
                    72.0431747,
                    55.9498989
                ],
                [
                    72.0424637,
                    55.9504056
                ],
                [
                    72.0420275,
                    55.9507946
                ],
                [
                    72.0411872,
                    55.9511927
                ],
                [
                    72.040864,
                    55.9516089
                ],
                [
                    72.0397976,
                    55.9522602
                ],
                [
                    72.0382302,
                    55.9529749
                ],
                [
                    72.0380202,
                    55.9529116
                ],
                [
                    72.0367112,
                    55.9533911
                ],
                [
                    72.0364043,
                    55.9532011
                ],
                [
                    72.0355803,
                    55.953373
                ],
                [
                    72.0355318,
                    55.9536082
                ],
                [
                    72.0349178,
                    55.9536715
                ],
                [
                    72.0347885,
                    55.9538253
                ],
                [
                    72.0338028,
                    55.9538705
                ],
                [
                    72.0336412,
                    55.9537077
                ],
                [
                    72.0329141,
                    55.9537258
                ],
                [
                    72.0328495,
                    55.9539339
                ],
                [
                    72.0315083,
                    55.9539158
                ],
                [
                    72.0308943,
                    55.9537529
                ],
                [
                    72.0294562,
                    55.9537529
                ],
                [
                    72.0284059,
                    55.9536896
                ],
                [
                    72.0255782,
                    55.952405
                ],
                [
                    72.022702,
                    55.951636
                ],
                [
                    72.0198097,
                    55.9506589
                ],
                [
                    72.0199389,
                    55.9504146
                ],
                [
                    72.0197612,
                    55.950297
                ],
                [
                    72.0182908,
                    55.9497904
                ],
                [
                    72.0175313,
                    55.9496185
                ],
                [
                    72.0154307,
                    55.9488675
                ],
                [
                    72.0142189,
                    55.9485509
                ],
                [
                    72.0128454,
                    55.9480985
                ],
                [
                    72.0108902,
                    55.9472751
                ],
                [
                    72.0101793,
                    55.9470942
                ],
                [
                    72.0092582,
                    55.9469403
                ],
                [
                    72.0085634,
                    55.9468318
                ],
                [
                    72.0082402,
                    55.9467141
                ],
                [
                    72.0079494,
                    55.9464427
                ],
                [
                    72.006786,
                    55.9463341
                ],
                [
                    72.0057034,
                    55.945755
                ],
                [
                    72.0046208,
                    55.9454926
                ],
                [
                    72.0031988,
                    55.9450312
                ],
                [
                    72.0025524,
                    55.9460627
                ],
                [
                    72.0028433,
                    55.9461532
                ],
                [
                    72.0026818,
                    55.946307
                ],
                [
                    72.0016315,
                    55.946117
                ],
                [
                    72.0014376,
                    55.9458817
                ],
                [
                    71.9991108,
                    55.9454564
                ],
                [
                    71.9984483,
                    55.9462798
                ]
            ],
            "longitude": 72.0261745,
            "latitude": 55.9555689
        },
        "2293": {
            "name": "Еремеевка",
            "population": 1308,
            "type": "village",
            "poly": null,
            "longitude": 72.04921,
            "latitude": 54.286747
        },
        "2294": {
            "name": "Мироновка",
            "population": 348,
            "type": "village",
            "poly": null,
            "longitude": 72.054184,
            "latitude": 55.058266
        },
        "2295": {
            "name": "Красное Знамя",
            "population": 806,
            "type": "village",
            "poly": null,
            "longitude": 72.0568756,
            "latitude": 55.0889378
        },
        "2296": {
            "name": "Алексеевка",
            "population": 1314,
            "type": "village",
            "poly": null,
            "longitude": 72.0770311,
            "latitude": 55.347893
        },
        "2297": {
            "name": "Петрово",
            "population": 560,
            "type": "village",
            "poly": null,
            "longitude": 72.0822242,
            "latitude": 57.5277981
        },
        "2298": {
            "name": "Элита",
            "population": 1582,
            "type": "village",
            "poly": null,
            "longitude": 72.113762,
            "latitude": 54.910904
        },
        "2299": {
            "name": "Северное",
            "population": 449,
            "type": "village",
            "poly": null,
            "longitude": 72.1218281,
            "latitude": 54.9895705
        },
        "2300": {
            "name": "Домбай",
            "population": 403,
            "type": "village",
            "poly": null,
            "longitude": 72.1585081,
            "latitude": 54.7639593
        },
        "2301": {
            "name": "Ивановка",
            "population": 795,
            "type": "village",
            "poly": null,
            "longitude": 72.170639,
            "latitude": 55.078976
        },
        "2302": {
            "name": "Максимовка",
            "population": 921,
            "type": "village",
            "poly": null,
            "longitude": 72.1810067,
            "latitude": 54.5254243
        },
        "2303": {
            "name": "Хутора",
            "population": 522,
            "type": "village",
            "poly": null,
            "longitude": 72.1962136,
            "latitude": 56.222854
        },
        "2304": {
            "name": "Бабеж",
            "population": 668,
            "type": "village",
            "poly": null,
            "longitude": 72.209045,
            "latitude": 54.635021
        },
        "2305": {
            "name": "Октябрьский",
            "population": 1193,
            "type": "village",
            "poly": null,
            "longitude": 72.2131391,
            "latitude": 55.8173385
        },
        "2306": {
            "name": "Кузнецово",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 72.2135613,
            "latitude": 57.5848691
        },
        "2307": {
            "name": "Троицк",
            "population": 504,
            "type": "village",
            "poly": null,
            "longitude": 72.2345752,
            "latitude": 55.7015102
        },
        "2308": {
            "name": "Утузы",
            "population": 362,
            "type": "village",
            "poly": null,
            "longitude": 72.2542288,
            "latitude": 57.514595
        },
        "2309": {
            "name": "Ларга",
            "population": 53,
            "type": "village",
            "poly": null,
            "longitude": 72.2639027,
            "latitude": 54.5224481
        },
        "2310": {
            "name": "Новоскатовка",
            "population": 445,
            "type": "village",
            "poly": null,
            "longitude": 72.284157,
            "latitude": 54.336384
        },
        "2311": {
            "name": "Никольское",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 72.2851446,
            "latitude": 55.6112753
        },
        "2312": {
            "name": "Таловское",
            "population": 954,
            "type": "village",
            "poly": null,
            "longitude": 72.2920933,
            "latitude": 54.4473103
        },
        "2313": {
            "name": "Урожайный",
            "population": 433,
            "type": "village",
            "poly": null,
            "longitude": 72.2950704,
            "latitude": 55.0728275
        },
        "2314": {
            "name": "Отрадное",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 72.296303,
            "latitude": 54.802719
        },
        "2315": {
            "name": "Веселая Поляна",
            "population": 483,
            "type": "village",
            "poly": null,
            "longitude": 72.3079297,
            "latitude": 55.3771103
        },
        "2316": {
            "name": "Пикетное",
            "population": 819,
            "type": "village",
            "poly": [
                [
                    72.2913121,
                    54.9507705
                ],
                [
                    72.2915086,
                    54.9510829
                ],
                [
                    72.2915388,
                    54.9513518
                ],
                [
                    72.2916446,
                    54.9516989
                ],
                [
                    72.2920977,
                    54.9518811
                ],
                [
                    72.292264,
                    54.9518724
                ],
                [
                    72.2925662,
                    54.9517076
                ],
                [
                    72.2970083,
                    54.9523149
                ],
                [
                    72.2972803,
                    54.9524104
                ],
                [
                    72.2979904,
                    54.9525058
                ],
                [
                    72.2977789,
                    54.9537465
                ],
                [
                    72.3002416,
                    54.9539027
                ],
                [
                    72.300287,
                    54.953816
                ],
                [
                    72.3021001,
                    54.9538507
                ],
                [
                    72.3021152,
                    54.9544667
                ],
                [
                    72.3023569,
                    54.954484
                ],
                [
                    72.3025231,
                    54.9537032
                ],
                [
                    72.3027951,
                    54.9536945
                ],
                [
                    72.3028102,
                    54.9533821
                ],
                [
                    72.3033389,
                    54.9533648
                ],
                [
                    72.3033389,
                    54.9537205
                ],
                [
                    72.3046082,
                    54.9537118
                ],
                [
                    72.3046837,
                    54.9539895
                ],
                [
                    72.3039887,
                    54.9539461
                ],
                [
                    72.3039736,
                    54.9540329
                ],
                [
                    72.3034901,
                    54.9542237
                ],
                [
                    72.303475,
                    54.9545014
                ],
                [
                    72.30417,
                    54.9545274
                ],
                [
                    72.30417,
                    54.9547269
                ],
                [
                    72.3043512,
                    54.9548397
                ],
                [
                    72.3046233,
                    54.9549178
                ],
                [
                    72.3050463,
                    54.9549352
                ],
                [
                    72.3053636,
                    54.9548831
                ],
                [
                    72.3055298,
                    54.9547443
                ],
                [
                    72.3056809,
                    54.9547443
                ],
                [
                    72.3057565,
                    54.9548137
                ],
                [
                    72.3056809,
                    54.9551607
                ],
                [
                    72.3057414,
                    54.9552909
                ],
                [
                    72.305832,
                    54.9552562
                ],
                [
                    72.3059529,
                    54.9551
                ],
                [
                    72.3060586,
                    54.9549612
                ],
                [
                    72.3063155,
                    54.9549178
                ],
                [
                    72.3064968,
                    54.9550133
                ],
                [
                    72.306527,
                    54.9551954
                ],
                [
                    72.306391,
                    54.9553603
                ],
                [
                    72.3064062,
                    54.9556292
                ],
                [
                    72.3065572,
                    54.9556553
                ],
                [
                    72.3066026,
                    54.9561671
                ],
                [
                    72.3072825,
                    54.9561845
                ],
                [
                    72.3072825,
                    54.9563493
                ],
                [
                    72.3082646,
                    54.9563493
                ],
                [
                    72.3082646,
                    54.9560457
                ],
                [
                    72.3093222,
                    54.9560283
                ],
                [
                    72.3093826,
                    54.9561151
                ],
                [
                    72.3100626,
                    54.9561324
                ],
                [
                    72.3100474,
                    54.9565315
                ],
                [
                    72.3114979,
                    54.9564881
                ],
                [
                    72.3115433,
                    54.9564187
                ],
                [
                    72.3124347,
                    54.9563927
                ],
                [
                    72.3124347,
                    54.9561671
                ],
                [
                    72.311649,
                    54.9558808
                ],
                [
                    72.3152752,
                    54.9557854
                ],
                [
                    72.3160155,
                    54.9556292
                ],
                [
                    72.3162724,
                    54.9557941
                ],
                [
                    72.3168465,
                    54.9558114
                ],
                [
                    72.3172243,
                    54.9564968
                ],
                [
                    72.3175869,
                    54.9568438
                ],
                [
                    72.3178286,
                    54.9568438
                ],
                [
                    72.3204576,
                    54.958041
                ],
                [
                    72.3208656,
                    54.95831
                ],
                [
                    72.3215757,
                    54.9583186
                ],
                [
                    72.3217721,
                    54.9581451
                ],
                [
                    72.3218023,
                    54.9577201
                ],
                [
                    72.3219232,
                    54.957642
                ],
                [
                    72.3221498,
                    54.9577287
                ],
                [
                    72.3223463,
                    54.957668
                ],
                [
                    72.3225125,
                    54.9562626
                ],
                [
                    72.3228751,
                    54.9535557
                ],
                [
                    72.3244162,
                    54.9537205
                ],
                [
                    72.3276949,
                    54.9537726
                ],
                [
                    72.3278921,
                    54.9510542
                ],
                [
                    72.3214189,
                    54.9508887
                ],
                [
                    72.3199769,
                    54.9508212
                ],
                [
                    72.319389,
                    54.9507537
                ],
                [
                    72.3191291,
                    54.9506364
                ],
                [
                    72.3192624,
                    54.9487709
                ],
                [
                    72.3148142,
                    54.9485932
                ],
                [
                    72.3148065,
                    54.9479312
                ],
                [
                    72.3142263,
                    54.9479223
                ],
                [
                    72.3142495,
                    54.9472648
                ],
                [
                    72.3115574,
                    54.9471537
                ],
                [
                    72.3115188,
                    54.9472381
                ],
                [
                    72.3105286,
                    54.9472337
                ],
                [
                    72.3093682,
                    54.9471626
                ],
                [
                    72.3090433,
                    54.9474736
                ],
                [
                    72.308904,
                    54.9474914
                ],
                [
                    72.3090742,
                    54.944479
                ],
                [
                    72.3089505,
                    54.9443768
                ],
                [
                    72.3075039,
                    54.9443501
                ],
                [
                    72.3074187,
                    54.9436392
                ],
                [
                    72.3072069,
                    54.9434032
                ],
                [
                    72.3034598,
                    54.9432383
                ],
                [
                    72.3036261,
                    54.9440193
                ],
                [
                    72.3039132,
                    54.9445314
                ],
                [
                    72.3044873,
                    54.9445227
                ],
                [
                    72.3045024,
                    54.9448351
                ],
                [
                    72.3041851,
                    54.9448438
                ],
                [
                    72.3038074,
                    54.9452343
                ],
                [
                    72.3037318,
                    54.9456595
                ],
                [
                    72.3035656,
                    54.945755
                ],
                [
                    72.3027498,
                    54.9458417
                ],
                [
                    72.3024174,
                    54.945295
                ],
                [
                    72.3016619,
                    54.9453124
                ],
                [
                    72.3008611,
                    54.9454426
                ],
                [
                    72.3002719,
                    54.9455727
                ],
                [
                    72.3005136,
                    54.9463451
                ],
                [
                    72.3005287,
                    54.9465533
                ],
                [
                    72.2999697,
                    54.946562
                ],
                [
                    72.2998488,
                    54.9472562
                ],
                [
                    72.2987306,
                    54.9472996
                ],
                [
                    72.2986401,
                    54.9475252
                ],
                [
                    72.2974011,
                    54.9475252
                ],
                [
                    72.2969932,
                    54.948983
                ],
                [
                    72.296691,
                    54.9498247
                ],
                [
                    72.2921432,
                    54.949764
                ],
                [
                    72.2922489,
                    54.9504494
                ],
                [
                    72.2924605,
                    54.9504842
                ],
                [
                    72.2924756,
                    54.9506577
                ],
                [
                    72.2914935,
                    54.9506403
                ],
                [
                    72.2913121,
                    54.9507705
                ]
            ],
            "longitude": 72.314781,
            "latitude": 54.95187
        },
        "2317": {
            "name": "Москаленский",
            "population": 2468,
            "type": "village",
            "poly": null,
            "longitude": 72.329659,
            "latitude": 54.888092
        },
        "2318": {
            "name": "Новый Кошкуль",
            "population": 657,
            "type": "village",
            "poly": null,
            "longitude": 72.3367716,
            "latitude": 55.9914489
        },
        "2319": {
            "name": "Пролетарский",
            "population": 524,
            "type": "village",
            "poly": null,
            "longitude": 72.3511864,
            "latitude": 55.2141688
        },
        "2320": {
            "name": "Артакшил",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 72.3706304,
            "latitude": 54.7272212
        },
        "2321": {
            "name": "Заря Свободы",
            "population": 751,
            "type": "village",
            "poly": [
                [
                    72.3656471,
                    54.9817017
                ],
                [
                    72.3657244,
                    54.9818571
                ],
                [
                    72.3683546,
                    54.9832499
                ],
                [
                    72.3689741,
                    54.9825785
                ],
                [
                    72.3693136,
                    54.9825311
                ],
                [
                    72.3694053,
                    54.9824153
                ],
                [
                    72.3695154,
                    54.9823205
                ],
                [
                    72.3697998,
                    54.9822995
                ],
                [
                    72.3701393,
                    54.9819678
                ],
                [
                    72.3707356,
                    54.9820099
                ],
                [
                    72.3709282,
                    54.9818836
                ],
                [
                    72.3715888,
                    54.9819941
                ],
                [
                    72.3717539,
                    54.9816625
                ],
                [
                    72.3741026,
                    54.9820994
                ],
                [
                    72.3725613,
                    54.9833576
                ],
                [
                    72.3725613,
                    54.983863
                ],
                [
                    72.3726621,
                    54.9841157
                ],
                [
                    72.3729833,
                    54.9844158
                ],
                [
                    72.3740659,
                    54.9848316
                ],
                [
                    72.3764145,
                    54.9854791
                ],
                [
                    72.376598,
                    54.9852159
                ],
                [
                    72.3772402,
                    54.9851001
                ],
                [
                    72.3785338,
                    54.9847632
                ],
                [
                    72.3802219,
                    54.9841315
                ],
                [
                    72.3802586,
                    54.9842789
                ],
                [
                    72.3811852,
                    54.9845948
                ],
                [
                    72.3813595,
                    54.9845895
                ],
                [
                    72.3816531,
                    54.9843842
                ],
                [
                    72.3833045,
                    54.9847264
                ],
                [
                    72.3854513,
                    54.9851054
                ],
                [
                    72.3854972,
                    54.9852633
                ],
                [
                    72.384488,
                    54.9852686
                ],
                [
                    72.3843779,
                    54.9852896
                ],
                [
                    72.3843687,
                    54.9854686
                ],
                [
                    72.3853963,
                    54.9854897
                ],
                [
                    72.385488,
                    54.9855739
                ],
                [
                    72.3859651,
                    54.9855791
                ],
                [
                    72.386121,
                    54.9854949
                ],
                [
                    72.3861302,
                    54.9853265
                ],
                [
                    72.3867999,
                    54.9852949
                ],
                [
                    72.3872954,
                    54.9857423
                ],
                [
                    72.3887452,
                    54.9853352
                ],
                [
                    72.390015,
                    54.9854193
                ],
                [
                    72.3904212,
                    54.9851142
                ],
                [
                    72.3906532,
                    54.9847924
                ],
                [
                    72.3907596,
                    54.9841265
                ],
                [
                    72.3905565,
                    54.98406
                ],
                [
                    72.3906146,
                    54.983838
                ],
                [
                    72.391069,
                    54.9838769
                ],
                [
                    72.3911657,
                    54.983777
                ],
                [
                    72.3918233,
                    54.983838
                ],
                [
                    72.3919006,
                    54.9835384
                ],
                [
                    72.391833,
                    54.9830612
                ],
                [
                    72.3917169,
                    54.9823288
                ],
                [
                    72.3914944,
                    54.9815963
                ],
                [
                    72.3912624,
                    54.9808084
                ],
                [
                    72.3911754,
                    54.98032
                ],
                [
                    72.3912431,
                    54.9799704
                ],
                [
                    72.3913688,
                    54.979693
                ],
                [
                    72.3917653,
                    54.9792158
                ],
                [
                    72.3824628,
                    54.9778895
                ],
                [
                    72.3811381,
                    54.9777341
                ],
                [
                    72.3802582,
                    54.9776786
                ],
                [
                    72.3798327,
                    54.9776952
                ],
                [
                    72.379562,
                    54.9777674
                ],
                [
                    72.3793202,
                    54.9779283
                ],
                [
                    72.3790591,
                    54.9782335
                ],
                [
                    72.3787594,
                    54.9784167
                ],
                [
                    72.3784306,
                    54.9784611
                ],
                [
                    72.3779084,
                    54.9784722
                ],
                [
                    72.3776376,
                    54.9783945
                ],
                [
                    72.3772314,
                    54.978178
                ],
                [
                    72.3766997,
                    54.9778728
                ],
                [
                    72.3761485,
                    54.9777008
                ],
                [
                    72.3751525,
                    54.9776453
                ],
                [
                    72.3744176,
                    54.9775121
                ],
                [
                    72.3706947,
                    54.9772624
                ],
                [
                    72.3701726,
                    54.978622
                ],
                [
                    72.3687608,
                    54.9784611
                ],
                [
                    72.3679195,
                    54.9784777
                ],
                [
                    72.367407,
                    54.9786553
                ],
                [
                    72.3665464,
                    54.9800703
                ],
                [
                    72.3662949,
                    54.9806141
                ],
                [
                    72.3660145,
                    54.9806474
                ],
                [
                    72.3656664,
                    54.9813355
                ],
                [
                    72.3656471,
                    54.9817017
                ]
            ],
            "longitude": 72.3803048,
            "latitude": 54.9818204
        },
        "2322": {
            "name": "Становка",
            "population": 407,
            "type": "village",
            "poly": null,
            "longitude": 72.3818452,
            "latitude": 56.8576767
        },
        "2323": {
            "name": "Белый Яр",
            "population": 877,
            "type": "village",
            "poly": null,
            "longitude": 72.3898028,
            "latitude": 57.5890028
        },
        "2324": {
            "name": "Сажино",
            "population": 678,
            "type": "village",
            "poly": null,
            "longitude": 72.3914524,
            "latitude": 55.8933024
        },
        "2325": {
            "name": "Луговой",
            "population": 166,
            "type": "village",
            "poly": null,
            "longitude": 72.39688,
            "latitude": 55.1196499
        },
        "2326": {
            "name": "Уютное",
            "population": 415,
            "type": "village",
            "poly": [
                [
                    72.414614,
                    54.8772274
                ],
                [
                    72.4155041,
                    54.8774994
                ],
                [
                    72.4159891,
                    54.877663
                ],
                [
                    72.4146677,
                    54.8789861
                ],
                [
                    72.4163487,
                    54.879395
                ],
                [
                    72.4174025,
                    54.8797126
                ],
                [
                    72.4179628,
                    54.8799291
                ],
                [
                    72.4188158,
                    54.8800734
                ],
                [
                    72.4190166,
                    54.8799868
                ],
                [
                    72.4192089,
                    54.8796597
                ],
                [
                    72.4193344,
                    54.8795634
                ],
                [
                    72.4197441,
                    54.8795779
                ],
                [
                    72.4215673,
                    54.8799868
                ],
                [
                    72.4217597,
                    54.8799965
                ],
                [
                    72.4219269,
                    54.879982
                ],
                [
                    72.4220105,
                    54.8799339
                ],
                [
                    72.422228,
                    54.8799099
                ],
                [
                    72.4229723,
                    54.8800734
                ],
                [
                    72.4234574,
                    54.8802322
                ],
                [
                    72.4234741,
                    54.8802899
                ],
                [
                    72.4235828,
                    54.8803236
                ],
                [
                    72.424001,
                    54.8798233
                ],
                [
                    72.4242519,
                    54.879881
                ],
                [
                    72.4244777,
                    54.8796019
                ],
                [
                    72.4246366,
                    54.8796549
                ],
                [
                    72.4244944,
                    54.8799147
                ],
                [
                    72.4243857,
                    54.8798906
                ],
                [
                    72.4241599,
                    54.8802081
                ],
                [
                    72.4248038,
                    54.8803813
                ],
                [
                    72.4250213,
                    54.8800446
                ],
                [
                    72.4246366,
                    54.8799435
                ],
                [
                    72.4257321,
                    54.8784424
                ],
                [
                    72.4254227,
                    54.8783125
                ],
                [
                    72.4255899,
                    54.8781104
                ],
                [
                    72.425314,
                    54.8780334
                ],
                [
                    72.4256067,
                    54.8779372
                ],
                [
                    72.4209149,
                    54.8761521
                ],
                [
                    72.4208397,
                    54.8755362
                ],
                [
                    72.4219102,
                    54.8758249
                ],
                [
                    72.4220774,
                    54.8756806
                ],
                [
                    72.4222363,
                    54.8757335
                ],
                [
                    72.4224789,
                    54.8754592
                ],
                [
                    72.4222196,
                    54.8753678
                ],
                [
                    72.4226127,
                    54.8749396
                ],
                [
                    72.4224621,
                    54.8749011
                ],
                [
                    72.4232399,
                    54.8740638
                ],
                [
                    72.4249042,
                    54.8745257
                ],
                [
                    72.4247285,
                    54.8752042
                ],
                [
                    72.4255816,
                    54.875286
                ],
                [
                    72.4256234,
                    54.875209
                ],
                [
                    72.4276138,
                    54.8753678
                ],
                [
                    72.4276724,
                    54.8751657
                ],
                [
                    72.4289185,
                    54.8752475
                ],
                [
                    72.4288683,
                    54.8758682
                ],
                [
                    72.4335098,
                    54.8765515
                ],
                [
                    72.4341704,
                    54.8747519
                ],
                [
                    72.430566,
                    54.8743814
                ],
                [
                    72.4306078,
                    54.8740927
                ],
                [
                    72.4303987,
                    54.8740638
                ],
                [
                    72.4296126,
                    54.8727597
                ],
                [
                    72.4295707,
                    54.8729378
                ],
                [
                    72.4278312,
                    54.8728464
                ],
                [
                    72.4261837,
                    54.8726828
                ],
                [
                    72.4255816,
                    54.8724806
                ],
                [
                    72.4257405,
                    54.8723074
                ],
                [
                    72.4254143,
                    54.8722112
                ],
                [
                    72.4252889,
                    54.8723315
                ],
                [
                    72.4243689,
                    54.8721101
                ],
                [
                    72.4242351,
                    54.8722208
                ],
                [
                    72.4239424,
                    54.872163
                ],
                [
                    72.4231479,
                    54.8729234
                ],
                [
                    72.4212579,
                    54.8723122
                ],
                [
                    72.4209735,
                    54.8726106
                ],
                [
                    72.4203045,
                    54.8724373
                ],
                [
                    72.4189329,
                    54.8721967
                ],
                [
                    72.418774,
                    54.8722015
                ],
                [
                    72.4153618,
                    54.8761136
                ],
                [
                    72.4158559,
                    54.8762476
                ],
                [
                    72.4155484,
                    54.8765912
                ],
                [
                    72.4150575,
                    54.8764721
                ],
                [
                    72.414614,
                    54.8772274
                ]
            ],
            "longitude": 72.4201141,
            "latitude": 54.8760154
        },
        "2327": {
            "name": "Кабырдак",
            "population": 745,
            "type": "village",
            "poly": null,
            "longitude": 72.4363427,
            "latitude": 56.1169704
        },
        "2328": {
            "name": "Шандровка",
            "population": 120,
            "type": "village",
            "poly": null,
            "longitude": 72.4542015,
            "latitude": 55.2039749
        },
        "2329": {
            "name": "Новокиевка",
            "population": 583,
            "type": "village",
            "poly": [
                [
                    72.4433113,
                    55.2626273
                ],
                [
                    72.4438081,
                    55.2642974
                ],
                [
                    72.4449507,
                    55.2643116
                ],
                [
                    72.4449383,
                    55.2649343
                ],
                [
                    72.4438577,
                    55.2649485
                ],
                [
                    72.443895,
                    55.2662577
                ],
                [
                    72.4448637,
                    55.2662789
                ],
                [
                    72.4448389,
                    55.2668521
                ],
                [
                    72.4449134,
                    55.2670148
                ],
                [
                    72.4451246,
                    55.2671351
                ],
                [
                    72.4452364,
                    55.267312
                ],
                [
                    72.4452239,
                    55.2677295
                ],
                [
                    72.4467018,
                    55.2677508
                ],
                [
                    72.4466771,
                    55.2688263
                ],
                [
                    72.4503658,
                    55.26889
                ],
                [
                    72.4507881,
                    55.268515
                ],
                [
                    72.451496,
                    55.268522
                ],
                [
                    72.4515084,
                    55.2693641
                ],
                [
                    72.4509744,
                    55.2695481
                ],
                [
                    72.4509744,
                    55.2696613
                ],
                [
                    72.4513594,
                    55.2699585
                ],
                [
                    72.4513718,
                    55.2703122
                ],
                [
                    72.4516078,
                    55.2703618
                ],
                [
                    72.4516078,
                    55.2711259
                ],
                [
                    72.4511854,
                    55.2711472
                ],
                [
                    72.4511731,
                    55.2712675
                ],
                [
                    72.4521543,
                    55.2713382
                ],
                [
                    72.4521294,
                    55.2715576
                ],
                [
                    72.4511234,
                    55.2715717
                ],
                [
                    72.4511234,
                    55.2718618
                ],
                [
                    72.4538186,
                    55.2718618
                ],
                [
                    72.4539055,
                    55.271225
                ],
                [
                    72.4556567,
                    55.2712321
                ],
                [
                    72.4556691,
                    55.2696613
                ],
                [
                    72.4558803,
                    55.2694278
                ],
                [
                    72.4559796,
                    55.2681753
                ],
                [
                    72.455222,
                    55.2681329
                ],
                [
                    72.4556567,
                    55.2677508
                ],
                [
                    72.4563771,
                    55.2677295
                ],
                [
                    72.4564019,
                    55.2669724
                ],
                [
                    72.4558678,
                    55.2669511
                ],
                [
                    72.4559548,
                    55.2664346
                ],
                [
                    72.4565261,
                    55.2664416
                ],
                [
                    72.4565882,
                    55.2659887
                ],
                [
                    72.4559051,
                    55.2659534
                ],
                [
                    72.4559043,
                    55.2655715
                ],
                [
                    72.4561078,
                    55.2653867
                ],
                [
                    72.4593891,
                    55.2653396
                ],
                [
                    72.4594843,
                    55.2646512
                ],
                [
                    72.4599486,
                    55.2646548
                ],
                [
                    72.4599486,
                    55.2644737
                ],
                [
                    72.4587404,
                    55.2642671
                ],
                [
                    72.4587913,
                    55.264115
                ],
                [
                    72.459052,
                    55.2640352
                ],
                [
                    72.4591411,
                    55.2637345
                ],
                [
                    72.4591856,
                    55.2634265
                ],
                [
                    72.4594781,
                    55.2634156
                ],
                [
                    72.4594972,
                    55.2630932
                ],
                [
                    72.4580918,
                    55.2630553
                ],
                [
                    72.4581539,
                    55.2625316
                ],
                [
                    72.4594828,
                    55.2625245
                ],
                [
                    72.4595574,
                    55.2619725
                ],
                [
                    72.4645874,
                    55.2621636
                ],
                [
                    72.4657673,
                    55.2623122
                ],
                [
                    72.4666367,
                    55.2623122
                ],
                [
                    72.466823,
                    55.2622485
                ],
                [
                    72.4668976,
                    55.2619867
                ],
                [
                    72.4663014,
                    55.261831
                ],
                [
                    72.466289,
                    55.261555
                ],
                [
                    72.4664629,
                    55.2613285
                ],
                [
                    72.4665622,
                    55.2609605
                ],
                [
                    72.4646123,
                    55.2607198
                ],
                [
                    72.4607745,
                    55.2604792
                ],
                [
                    72.4611223,
                    55.2575773
                ],
                [
                    72.461172,
                    55.2568908
                ],
                [
                    72.4610478,
                    55.2553831
                ],
                [
                    72.4611968,
                    55.2540948
                ],
                [
                    72.4616315,
                    55.2513907
                ],
                [
                    72.461085,
                    55.2511641
                ],
                [
                    72.4607745,
                    55.2512349
                ],
                [
                    72.4606255,
                    55.2511854
                ],
                [
                    72.4591227,
                    55.2514048
                ],
                [
                    72.4590481,
                    55.2517092
                ],
                [
                    72.4588618,
                    55.2517942
                ],
                [
                    72.4586383,
                    55.2518225
                ],
                [
                    72.4563033,
                    55.2517942
                ],
                [
                    72.4558065,
                    55.2519782
                ],
                [
                    72.455198,
                    55.2519924
                ],
                [
                    72.4549744,
                    55.252948
                ],
                [
                    72.4529251,
                    55.2529056
                ],
                [
                    72.4527761,
                    55.2529622
                ],
                [
                    72.4524656,
                    55.2529764
                ],
                [
                    72.452391,
                    55.2530401
                ],
                [
                    72.4521178,
                    55.2530967
                ],
                [
                    72.4521178,
                    55.2536559
                ],
                [
                    72.4517328,
                    55.2540028
                ],
                [
                    72.4515713,
                    55.2545974
                ],
                [
                    72.4513228,
                    55.2547389
                ],
                [
                    72.4507268,
                    55.2548664
                ],
                [
                    72.4500561,
                    55.2548451
                ],
                [
                    72.4494102,
                    55.2548027
                ],
                [
                    72.4492488,
                    55.2580586
                ],
                [
                    72.4486154,
                    55.2580515
                ],
                [
                    72.4485781,
                    55.2583063
                ],
                [
                    72.4497828,
                    55.2584338
                ],
                [
                    72.4498201,
                    55.2586744
                ],
                [
                    72.4505653,
                    55.2585753
                ],
                [
                    72.4505529,
                    55.2587452
                ],
                [
                    72.4498822,
                    55.258908
                ],
                [
                    72.4500188,
                    55.2598068
                ],
                [
                    72.4509379,
                    55.2598776
                ],
                [
                    72.4509503,
                    55.2600192
                ],
                [
                    72.4501554,
                    55.2600121
                ],
                [
                    72.4501803,
                    55.2601607
                ],
                [
                    72.452863,
                    55.2601466
                ],
                [
                    72.4528382,
                    55.2602456
                ],
                [
                    72.4524656,
                    55.2602456
                ],
                [
                    72.4524283,
                    55.260734
                ],
                [
                    72.4518694,
                    55.260734
                ],
                [
                    72.4519067,
                    55.2611657
                ],
                [
                    72.4528882,
                    55.2611614
                ],
                [
                    72.4531167,
                    55.261218
                ],
                [
                    72.4533751,
                    55.2613709
                ],
                [
                    72.4533452,
                    55.2614445
                ],
                [
                    72.453077,
                    55.2616427
                ],
                [
                    72.4528385,
                    55.2616936
                ],
                [
                    72.4525305,
                    55.2617219
                ],
                [
                    72.4523815,
                    55.2618125
                ],
                [
                    72.4522722,
                    55.2620616
                ],
                [
                    72.4523218,
                    55.2626788
                ],
                [
                    72.4528783,
                    55.2626788
                ],
                [
                    72.4528186,
                    55.2632223
                ],
                [
                    72.4517456,
                    55.263177
                ],
                [
                    72.4508016,
                    55.2630694
                ],
                [
                    72.4500465,
                    55.2630694
                ],
                [
                    72.4499371,
                    55.2634771
                ],
                [
                    72.4499372,
                    55.2640715
                ],
                [
                    72.4483872,
                    55.2639809
                ],
                [
                    72.4478108,
                    55.26393
                ],
                [
                    72.4477811,
                    55.264632
                ],
                [
                    72.4464596,
                    55.264632
                ],
                [
                    72.4464596,
                    55.2643659
                ],
                [
                    72.4462311,
                    55.2643602
                ],
                [
                    72.4461814,
                    55.2625259
                ],
                [
                    72.4460622,
                    55.261269
                ],
                [
                    72.4457083,
                    55.2612755
                ],
                [
                    72.4443545,
                    55.2611198
                ],
                [
                    72.4439074,
                    55.2625353
                ],
                [
                    72.4433113,
                    55.2626273
                ]
            ],
            "longitude": 72.4549628,
            "latitude": 55.2605975
        },
        "2330": {
            "name": "Екатеринославка",
            "population": 1394,
            "type": "village",
            "poly": null,
            "longitude": 72.4625158,
            "latitude": 54.3443249
        },
        "2331": {
            "name": "Орловка",
            "population": 1275,
            "type": "village",
            "poly": null,
            "longitude": 72.464752,
            "latitude": 55.027702
        },
        "2332": {
            "name": "Северное",
            "population": 305,
            "type": "village",
            "poly": null,
            "longitude": 72.4869675,
            "latitude": 54.6993288
        },
        "2333": {
            "name": "Орехово",
            "population": 946,
            "type": "village",
            "poly": null,
            "longitude": 72.4881522,
            "latitude": 53.9832588
        },
        "2334": {
            "name": "Брезицк",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 72.4945492,
            "latitude": 54.1902691
        },
        "2335": {
            "name": "Цветково",
            "population": 277,
            "type": "village",
            "poly": null,
            "longitude": 72.5008663,
            "latitude": 54.0811035
        },
        "2336": {
            "name": "Центрально-Любинский",
            "population": 1027,
            "type": "village",
            "poly": null,
            "longitude": 72.5038905,
            "latitude": 55.1255485
        },
        "2337": {
            "name": "Кутузовка",
            "population": 1292,
            "type": "village",
            "poly": null,
            "longitude": 72.519051,
            "latitude": 54.465439
        },
        "2338": {
            "name": "Чернецовка",
            "population": 419,
            "type": "village",
            "poly": null,
            "longitude": 72.519094,
            "latitude": 56.5507239
        },
        "2339": {
            "name": "Ровная Поляна",
            "population": 298,
            "type": "village",
            "poly": null,
            "longitude": 72.5192585,
            "latitude": 55.1051449
        },
        "2340": {
            "name": "Малиновка",
            "population": 619,
            "type": "village",
            "poly": null,
            "longitude": 72.5254726,
            "latitude": 55.6395146
        },
        "2341": {
            "name": "Марьяновский",
            "population": 1108,
            "type": "village",
            "poly": null,
            "longitude": 72.5297397,
            "latitude": 54.9212881
        },
        "2342": {
            "name": "Смоляновка",
            "population": 312,
            "type": "village",
            "poly": [
                [
                    72.5276026,
                    55.256811
                ],
                [
                    72.5276492,
                    55.2576781
                ],
                [
                    72.5278043,
                    55.2580585
                ],
                [
                    72.5283323,
                    55.2608807
                ],
                [
                    72.53065,
                    55.2607082
                ],
                [
                    72.5306698,
                    55.2612461
                ],
                [
                    72.528623,
                    55.261331
                ],
                [
                    72.5286826,
                    55.2618066
                ],
                [
                    72.5288217,
                    55.261818
                ],
                [
                    72.5290999,
                    55.263239
                ],
                [
                    72.529557,
                    55.263341
                ],
                [
                    72.5300737,
                    55.2633636
                ],
                [
                    72.5311169,
                    55.2632674
                ],
                [
                    72.5311169,
                    55.2638392
                ],
                [
                    72.5278977,
                    55.2639411
                ],
                [
                    72.5278977,
                    55.2643034
                ],
                [
                    72.5312064,
                    55.2642694
                ],
                [
                    72.5312859,
                    55.2646431
                ],
                [
                    72.5283249,
                    55.2646374
                ],
                [
                    72.5284839,
                    55.2654923
                ],
                [
                    72.5280666,
                    55.2655489
                ],
                [
                    72.528007,
                    55.2669076
                ],
                [
                    72.5298253,
                    55.2668793
                ],
                [
                    72.5297657,
                    55.2680058
                ],
                [
                    72.5324682,
                    55.2678303
                ],
                [
                    72.5325279,
                    55.2679152
                ],
                [
                    72.532657,
                    55.2679662
                ],
                [
                    72.5329054,
                    55.2679832
                ],
                [
                    72.5355782,
                    55.2678303
                ],
                [
                    72.5356974,
                    55.2684304
                ],
                [
                    72.5372772,
                    55.2683738
                ],
                [
                    72.5373071,
                    55.2679322
                ],
                [
                    72.538241,
                    55.2677284
                ],
                [
                    72.5384497,
                    55.2684304
                ],
                [
                    72.5370288,
                    55.2685606
                ],
                [
                    72.5370487,
                    55.2689455
                ],
                [
                    72.5385491,
                    55.2688323
                ],
                [
                    72.5387776,
                    55.2701286
                ],
                [
                    72.5390657,
                    55.2709098
                ],
                [
                    72.5396023,
                    55.2708645
                ],
                [
                    72.5394433,
                    55.2706041
                ],
                [
                    72.5398209,
                    55.2705305
                ],
                [
                    72.5399302,
                    55.2707682
                ],
                [
                    72.5409635,
                    55.2707343
                ],
                [
                    72.5416491,
                    55.2699135
                ],
                [
                    72.5416491,
                    55.2698173
                ],
                [
                    72.5409138,
                    55.2698003
                ],
                [
                    72.5409138,
                    55.2695399
                ],
                [
                    72.5411125,
                    55.2694663
                ],
                [
                    72.541202,
                    55.2693757
                ],
                [
                    72.5412417,
                    55.2692512
                ],
                [
                    72.54151,
                    55.2691776
                ],
                [
                    72.5415994,
                    55.2689285
                ],
                [
                    72.5415199,
                    55.2683455
                ],
                [
                    72.5406654,
                    55.2683058
                ],
                [
                    72.5405561,
                    55.2681756
                ],
                [
                    72.540427,
                    55.2678756
                ],
                [
                    72.5392148,
                    55.2678926
                ],
                [
                    72.5389266,
                    55.2667547
                ],
                [
                    72.5397513,
                    55.2666981
                ],
                [
                    72.5399003,
                    55.2666189
                ],
                [
                    72.5399103,
                    55.2662452
                ],
                [
                    72.5398705,
                    55.2660697
                ],
                [
                    72.5397414,
                    55.2659565
                ],
                [
                    72.539175,
                    55.2659565
                ],
                [
                    72.5390558,
                    55.265815
                ],
                [
                    72.5390955,
                    55.2655772
                ],
                [
                    72.5393439,
                    55.2653904
                ],
                [
                    72.5397712,
                    55.2653734
                ],
                [
                    72.5399997,
                    55.2646261
                ],
                [
                    72.5400096,
                    55.2642015
                ],
                [
                    72.5405859,
                    55.2641619
                ],
                [
                    72.5406555,
                    55.265113
                ],
                [
                    72.5408045,
                    55.265781
                ],
                [
                    72.5414603,
                    55.2656961
                ],
                [
                    72.5417683,
                    55.2658716
                ],
                [
                    72.5420366,
                    55.2658716
                ],
                [
                    72.5423843,
                    55.2656735
                ],
                [
                    72.5420115,
                    55.2640511
                ],
                [
                    72.5426673,
                    55.2640574
                ],
                [
                    72.5438472,
                    55.2641017
                ],
                [
                    72.5438989,
                    55.2629097
                ],
                [
                    72.5437951,
                    55.2628535
                ],
                [
                    72.5429257,
                    55.2628624
                ],
                [
                    72.5427239,
                    55.2629243
                ],
                [
                    72.5422737,
                    55.2629243
                ],
                [
                    72.5421805,
                    55.2623051
                ],
                [
                    72.5383925,
                    55.2622874
                ],
                [
                    72.5379267,
                    55.2610046
                ],
                [
                    72.5414043,
                    55.26058
                ],
                [
                    72.5414974,
                    55.2604561
                ],
                [
                    72.5414043,
                    55.2602615
                ],
                [
                    72.540302,
                    55.2591998
                ],
                [
                    72.540271,
                    55.2588459
                ],
                [
                    72.5400692,
                    55.2586071
                ],
                [
                    72.5396655,
                    55.2582532
                ],
                [
                    72.5392463,
                    55.258032
                ],
                [
                    72.5354427,
                    55.2590583
                ],
                [
                    72.5350391,
                    55.2583593
                ],
                [
                    72.5326016,
                    55.2586336
                ],
                [
                    72.5304903,
                    55.2587752
                ],
                [
                    72.530009,
                    55.2566783
                ],
                [
                    72.5276026,
                    55.256811
                ]
            ],
            "longitude": 72.5336325,
            "latitude": 55.264004
        },
        "2343": {
            "name": "Большаковка",
            "population": 780,
            "type": "village",
            "poly": null,
            "longitude": 72.5350779,
            "latitude": 55.4306156
        },
        "2344": {
            "name": "Байбы",
            "population": 465,
            "type": "village",
            "poly": null,
            "longitude": 72.540398,
            "latitude": 57.461323
        },
        "2345": {
            "name": "Большая Роща",
            "population": 437,
            "type": "village",
            "poly": null,
            "longitude": 72.5449841,
            "latitude": 54.7952184
        },
        "2346": {
            "name": "Центральное",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 72.5503129,
            "latitude": 54.6427808
        },
        "2347": {
            "name": "Шереметьевка",
            "population": 356,
            "type": "village",
            "poly": null,
            "longitude": 72.559074,
            "latitude": 54.8497249
        },
        "2348": {
            "name": "Солнцево",
            "population": 432,
            "type": "village",
            "poly": null,
            "longitude": 72.5709586,
            "latitude": 54.2949564
        },
        "2349": {
            "name": "Желанное",
            "population": 1757,
            "type": "village",
            "poly": null,
            "longitude": 72.575775,
            "latitude": 54.166344
        },
        "2350": {
            "name": "Борисовское",
            "population": 979,
            "type": "village",
            "poly": null,
            "longitude": 72.5847612,
            "latitude": 54.6244997
        },
        "2351": {
            "name": "Протопоповка",
            "population": 488,
            "type": "village",
            "poly": null,
            "longitude": 72.60994,
            "latitude": 55.099388
        },
        "2352": {
            "name": "Старосолдатское",
            "population": 938,
            "type": "village",
            "poly": null,
            "longitude": 72.613777,
            "latitude": 56.202625
        },
        "2353": {
            "name": "Берёзовка",
            "population": 456,
            "type": "village",
            "poly": null,
            "longitude": 72.625572,
            "latitude": 55.047794
        },
        "2354": {
            "name": "Аёв",
            "population": 814,
            "type": "village",
            "poly": [
                [
                    72.6062349,
                    56.9326635
                ],
                [
                    72.607518,
                    56.9329353
                ],
                [
                    72.607767,
                    56.9335128
                ],
                [
                    72.6083895,
                    56.9347921
                ],
                [
                    72.6092195,
                    56.9352902
                ],
                [
                    72.6105268,
                    56.9358223
                ],
                [
                    72.6100081,
                    56.9364563
                ],
                [
                    72.6096553,
                    56.9369544
                ],
                [
                    72.610664,
                    56.9375694
                ],
                [
                    72.6107538,
                    56.9375097
                ],
                [
                    72.6113124,
                    56.9371378
                ],
                [
                    72.6124226,
                    56.9363986
                ],
                [
                    72.6135177,
                    56.935608
                ],
                [
                    72.6138235,
                    56.9354037
                ],
                [
                    72.614139,
                    56.9352364
                ],
                [
                    72.6145298,
                    56.9350701
                ],
                [
                    72.6153832,
                    56.9347698
                ],
                [
                    72.6163036,
                    56.9345852
                ],
                [
                    72.6171339,
                    56.934531
                ],
                [
                    72.6176092,
                    56.9345318
                ],
                [
                    72.6180938,
                    56.9345527
                ],
                [
                    72.6199667,
                    56.9346997
                ],
                [
                    72.62246,
                    56.9349291
                ],
                [
                    72.6257452,
                    56.9352151
                ],
                [
                    72.6292705,
                    56.9355125
                ],
                [
                    72.6324975,
                    56.9358076
                ],
                [
                    72.6342474,
                    56.9359218
                ],
                [
                    72.6351363,
                    56.9359339
                ],
                [
                    72.6368638,
                    56.9359116
                ],
                [
                    72.6388149,
                    56.9357787
                ],
                [
                    72.6407671,
                    56.9356326
                ],
                [
                    72.6425816,
                    56.9354292
                ],
                [
                    72.6430878,
                    56.9354043
                ],
                [
                    72.6436132,
                    56.935437
                ],
                [
                    72.6444567,
                    56.9350886
                ],
                [
                    72.6496678,
                    56.9331803
                ],
                [
                    72.6534602,
                    56.9317204
                ],
                [
                    72.6576665,
                    56.9301071
                ],
                [
                    72.6603748,
                    56.9290571
                ],
                [
                    72.6620746,
                    56.9283978
                ],
                [
                    72.6624886,
                    56.9282265
                ],
                [
                    72.6629488,
                    56.9280146
                ],
                [
                    72.6642955,
                    56.9272941
                ],
                [
                    72.6652957,
                    56.9267104
                ],
                [
                    72.6666459,
                    56.9258347
                ],
                [
                    72.6671627,
                    56.9254544
                ],
                [
                    72.6257746,
                    56.9188173
                ],
                [
                    72.6238593,
                    56.9196591
                ],
                [
                    72.6233867,
                    56.9201478
                ],
                [
                    72.6226901,
                    56.920528
                ],
                [
                    72.6218942,
                    56.9206366
                ],
                [
                    72.6212972,
                    56.9205416
                ],
                [
                    72.6207002,
                    56.92027
                ],
                [
                    72.6200784,
                    56.9200935
                ],
                [
                    72.6196803,
                    56.9200935
                ],
                [
                    72.6193321,
                    56.920175
                ],
                [
                    72.6192824,
                    56.9203243
                ],
                [
                    72.6197053,
                    56.9208131
                ],
                [
                    72.6194814,
                    56.9209624
                ],
                [
                    72.6189342,
                    56.9209624
                ],
                [
                    72.6176904,
                    56.9207995
                ],
                [
                    72.6169939,
                    56.9208538
                ],
                [
                    72.6164716,
                    56.9210032
                ],
                [
                    72.616397,
                    56.9212475
                ],
                [
                    72.6165958,
                    56.9214105
                ],
                [
                    72.6171929,
                    56.9216413
                ],
                [
                    72.6173671,
                    56.9218449
                ],
                [
                    72.6169939,
                    56.922035
                ],
                [
                    72.6162477,
                    56.9220621
                ],
                [
                    72.6153522,
                    56.9221164
                ],
                [
                    72.6150537,
                    56.9221979
                ],
                [
                    72.6147552,
                    56.9225373
                ],
                [
                    72.615004,
                    56.9227681
                ],
                [
                    72.6156258,
                    56.9230667
                ],
                [
                    72.6158746,
                    56.9235283
                ],
                [
                    72.6153273,
                    56.9241935
                ],
                [
                    72.6140674,
                    56.9247669
                ],
                [
                    72.6140833,
                    56.9254793
                ],
                [
                    72.6138126,
                    56.9255488
                ],
                [
                    72.6133032,
                    56.9254185
                ],
                [
                    72.6130485,
                    56.9252534
                ],
                [
                    72.6126983,
                    56.9253229
                ],
                [
                    72.6125072,
                    56.9254619
                ],
                [
                    72.6125232,
                    56.9256617
                ],
                [
                    72.6130963,
                    56.9262264
                ],
                [
                    72.6130167,
                    56.9264523
                ],
                [
                    72.6122366,
                    56.9267651
                ],
                [
                    72.6120933,
                    56.9269562
                ],
                [
                    72.6122366,
                    56.92713
                ],
                [
                    72.6129211,
                    56.9273385
                ],
                [
                    72.613144,
                    56.9275469
                ],
                [
                    72.6130485,
                    56.9276859
                ],
                [
                    72.6123003,
                    56.9279118
                ],
                [
                    72.6119819,
                    56.9280856
                ],
                [
                    72.6119023,
                    56.9282419
                ],
                [
                    72.6127938,
                    56.9288066
                ],
                [
                    72.6131599,
                    56.9292757
                ],
                [
                    72.6131122,
                    56.9296319
                ],
                [
                    72.612555,
                    56.9298664
                ],
                [
                    72.611966,
                    56.9297882
                ],
                [
                    72.6107083,
                    56.929267
                ],
                [
                    72.6101192,
                    56.9293539
                ],
                [
                    72.6099282,
                    56.9296058
                ],
                [
                    72.6099919,
                    56.9297708
                ],
                [
                    72.61117,
                    56.9302399
                ],
                [
                    72.6110745,
                    56.9304484
                ],
                [
                    72.6103103,
                    56.9306916
                ],
                [
                    72.6099282,
                    56.9309262
                ],
                [
                    72.6098805,
                    56.9310739
                ],
                [
                    72.6103581,
                    56.9315342
                ],
                [
                    72.6102944,
                    56.9318383
                ],
                [
                    72.6098646,
                    56.9321857
                ],
                [
                    72.6091959,
                    56.9323942
                ],
                [
                    72.6086228,
                    56.93229
                ],
                [
                    72.6082248,
                    56.9321075
                ],
                [
                    72.6078746,
                    56.9320902
                ],
                [
                    72.6062349,
                    56.9326635
                ]
            ],
            "longitude": 72.6306616,
            "latitude": 56.9288028
        },
        "2355": {
            "name": "Усовка",
            "population": 827,
            "type": "village",
            "poly": null,
            "longitude": 72.6502582,
            "latitude": 54.9150122
        },
        "2356": {
            "name": "Боголюбовка",
            "population": 1079,
            "type": "village",
            "poly": null,
            "longitude": 72.6512196,
            "latitude": 54.8020146
        },
        "2357": {
            "name": "Замелетеновка",
            "population": 636,
            "type": "village",
            "poly": null,
            "longitude": 72.651633,
            "latitude": 55.2344806
        },
        "2358": {
            "name": "Изюмовка",
            "population": 877,
            "type": "village",
            "poly": null,
            "longitude": 72.6527077,
            "latitude": 54.6734615
        },
        "2359": {
            "name": "Боголюбовка",
            "population": 602,
            "type": "village",
            "poly": null,
            "longitude": 72.6604807,
            "latitude": 55.305557
        },
        "2360": {
            "name": "Журавлевка",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 72.6638693,
            "latitude": 57.5025602
        },
        "2361": {
            "name": "Екатериновка",
            "population": 343,
            "type": "village",
            "poly": null,
            "longitude": 72.6653535,
            "latitude": 57.6034678
        },
        "2362": {
            "name": "Красноярка",
            "population": 781,
            "type": "village",
            "poly": null,
            "longitude": 72.667145,
            "latitude": 54.384167
        },
        "2363": {
            "name": "Белоглазово",
            "population": 352,
            "type": "village",
            "poly": null,
            "longitude": 72.6681888,
            "latitude": 56.0540122
        },
        "2364": {
            "name": "Побочино",
            "population": 1089,
            "type": "village",
            "poly": null,
            "longitude": 72.677376,
            "latitude": 54.195236
        },
        "2365": {
            "name": "Петелино",
            "population": 281,
            "type": "village",
            "poly": null,
            "longitude": 72.6922008,
            "latitude": 57.4291359
        },
        "2366": {
            "name": "Квасовка",
            "population": 505,
            "type": "village",
            "poly": null,
            "longitude": 72.699097,
            "latitude": 55.276981
        },
        "2367": {
            "name": "Максимовка",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 72.7024844,
            "latitude": 55.643515
        },
        "2368": {
            "name": "Бекишево",
            "population": 495,
            "type": "village",
            "poly": null,
            "longitude": 72.705856,
            "latitude": 55.581596
        },
        "2369": {
            "name": "Александровское",
            "population": 1299,
            "type": "village",
            "poly": null,
            "longitude": 72.709828,
            "latitude": 54.6631981
        },
        "2370": {
            "name": "Нагибино",
            "population": 711,
            "type": "village",
            "poly": null,
            "longitude": 72.710426,
            "latitude": 55.763302
        },
        "2371": {
            "name": "Петровка",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 72.7107127,
            "latitude": 54.9666036
        },
        "2372": {
            "name": "Алексеевка",
            "population": 388,
            "type": "village",
            "poly": null,
            "longitude": 72.713356,
            "latitude": 54.943783
        },
        "2373": {
            "name": "1-е Комиссаровское",
            "population": 382,
            "type": "village",
            "poly": null,
            "longitude": 72.7256119,
            "latitude": 54.5036733
        },
        "2374": {
            "name": "Васильевка",
            "population": 441,
            "type": "village",
            "poly": [
                [
                    72.7397237,
                    54.9117604
                ],
                [
                    72.7399524,
                    54.9123217
                ],
                [
                    72.7400632,
                    54.9123217
                ],
                [
                    72.7400544,
                    54.912699
                ],
                [
                    72.739806,
                    54.9128826
                ],
                [
                    72.7401031,
                    54.913191
                ],
                [
                    72.7404003,
                    54.9132854
                ],
                [
                    72.7442897,
                    54.9125257
                ],
                [
                    72.7447066,
                    54.9130024
                ],
                [
                    72.7448929,
                    54.9130942
                ],
                [
                    72.7451102,
                    54.9131502
                ],
                [
                    72.7453807,
                    54.9131783
                ],
                [
                    72.7455892,
                    54.9131502
                ],
                [
                    72.7463919,
                    54.9129718
                ],
                [
                    72.7466004,
                    54.9132038
                ],
                [
                    72.7468265,
                    54.9135403
                ],
                [
                    72.746887,
                    54.9135454
                ],
                [
                    72.746887,
                    54.9137744
                ],
                [
                    72.7468274,
                    54.9138411
                ],
                [
                    72.7468243,
                    54.9138969
                ],
                [
                    72.7468713,
                    54.9139781
                ],
                [
                    72.7467867,
                    54.9140357
                ],
                [
                    72.7464354,
                    54.9140285
                ],
                [
                    72.7462535,
                    54.9141187
                ],
                [
                    72.7460654,
                    54.9141493
                ],
                [
                    72.7457706,
                    54.9141114
                ],
                [
                    72.7459499,
                    54.9143637
                ],
                [
                    72.7466225,
                    54.9143025
                ],
                [
                    72.7484675,
                    54.9141394
                ],
                [
                    72.7488311,
                    54.9140935
                ],
                [
                    72.749319,
                    54.9140068
                ],
                [
                    72.7512615,
                    54.9138334
                ],
                [
                    72.7521485,
                    54.9137213
                ],
                [
                    72.7535499,
                    54.9134103
                ],
                [
                    72.7547651,
                    54.9129871
                ],
                [
                    72.75559,
                    54.9125996
                ],
                [
                    72.7562553,
                    54.9122223
                ],
                [
                    72.7568229,
                    54.9118501
                ],
                [
                    72.7574882,
                    54.9113096
                ],
                [
                    72.7587122,
                    54.9101777
                ],
                [
                    72.7609207,
                    54.9082604
                ],
                [
                    72.7616925,
                    54.9074649
                ],
                [
                    72.7627126,
                    54.9073731
                ],
                [
                    72.7622425,
                    54.9072508
                ],
                [
                    72.7617987,
                    54.9071858
                ],
                [
                    72.7607789,
                    54.9070366
                ],
                [
                    72.758659,
                    54.9068326
                ],
                [
                    72.7546675,
                    54.9064705
                ],
                [
                    72.7498867,
                    54.9058739
                ],
                [
                    72.7490263,
                    54.9066847
                ],
                [
                    72.7464983,
                    54.9078576
                ],
                [
                    72.7456589,
                    54.9083118
                ],
                [
                    72.7455936,
                    54.9083471
                ],
                [
                    72.7454872,
                    54.9086938
                ],
                [
                    72.7454161,
                    54.9090559
                ],
                [
                    72.7439882,
                    54.9091324
                ],
                [
                    72.7440769,
                    54.9093465
                ],
                [
                    72.7437975,
                    54.9094077
                ],
                [
                    72.7438551,
                    54.9095352
                ],
                [
                    72.7415312,
                    54.9100502
                ],
                [
                    72.7413605,
                    54.9096306
                ],
                [
                    72.7406676,
                    54.9096839
                ],
                [
                    72.7409645,
                    54.9103603
                ],
                [
                    72.7415841,
                    54.9102121
                ],
                [
                    72.7421299,
                    54.9111184
                ],
                [
                    72.7399923,
                    54.9115697
                ],
                [
                    72.7400081,
                    54.9115951
                ],
                [
                    72.7400519,
                    54.9117022
                ],
                [
                    72.7397237,
                    54.9117604
                ]
            ],
            "longitude": 72.748573,
            "latitude": 54.909664
        },
        "2375": {
            "name": "Казанка",
            "population": 749,
            "type": "village",
            "poly": null,
            "longitude": 72.7515853,
            "latitude": 55.2692755
        },
        "2376": {
            "name": "Александровка",
            "population": 1284,
            "type": "village",
            "poly": null,
            "longitude": 72.7547461,
            "latitude": 54.5606016
        },
        "2377": {
            "name": "Тавричанка",
            "population": 425,
            "type": "village",
            "poly": null,
            "longitude": 72.7679239,
            "latitude": 55.4580207
        },
        "2378": {
            "name": "Старая Шараповка",
            "population": 495,
            "type": "village",
            "poly": null,
            "longitude": 72.774124,
            "latitude": 54.969559
        },
        "2379": {
            "name": "Новая Шараповка",
            "population": 662,
            "type": "village",
            "poly": null,
            "longitude": 72.777687,
            "latitude": 54.980877
        },
        "2380": {
            "name": "Матюшино",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 72.7779371,
            "latitude": 55.2669703
        },
        "2381": {
            "name": "Белосток",
            "population": 1002,
            "type": "village",
            "poly": null,
            "longitude": 72.7823507,
            "latitude": 54.1684586
        },
        "2382": {
            "name": "Северо-Любинский",
            "population": 1457,
            "type": "village",
            "poly": null,
            "longitude": 72.790131,
            "latitude": 55.194275
        },
        "2383": {
            "name": "Ташетканы",
            "population": 286,
            "type": "village",
            "poly": null,
            "longitude": 72.7998727,
            "latitude": 57.4085848
        },
        "2384": {
            "name": "Белогривка",
            "population": 449,
            "type": "village",
            "poly": null,
            "longitude": 72.8269699,
            "latitude": 56.6260838
        },
        "2385": {
            "name": "Степное",
            "population": 798,
            "type": "village",
            "poly": null,
            "longitude": 72.827377,
            "latitude": 55.031963
        },
        "2386": {
            "name": "Кара-Терек",
            "population": 307,
            "type": "village",
            "poly": null,
            "longitude": 72.8398681,
            "latitude": 54.8571661
        },
        "2387": {
            "name": "Конезаводский",
            "population": 1957,
            "type": "village",
            "poly": [
                [
                    72.8412342,
                    54.945227
                ],
                [
                    72.8415993,
                    54.9452561
                ],
                [
                    72.841579,
                    54.9455299
                ],
                [
                    72.8414978,
                    54.9455415
                ],
                [
                    72.8414978,
                    54.9459143
                ],
                [
                    72.8417818,
                    54.945891
                ],
                [
                    72.8418123,
                    54.9459609
                ],
                [
                    72.841721,
                    54.9460425
                ],
                [
                    72.8418833,
                    54.9469046
                ],
                [
                    72.8419542,
                    54.94832
                ],
                [
                    72.8420759,
                    54.9492811
                ],
                [
                    72.8422788,
                    54.9504168
                ],
                [
                    72.8419238,
                    54.9504518
                ],
                [
                    72.841934,
                    54.9509701
                ],
                [
                    72.841579,
                    54.9509876
                ],
                [
                    72.8416297,
                    54.9513778
                ],
                [
                    72.8420861,
                    54.9513138
                ],
                [
                    72.8436378,
                    54.9512264
                ],
                [
                    72.8450881,
                    54.9511856
                ],
                [
                    72.8454836,
                    54.9511565
                ],
                [
                    72.8466904,
                    54.9510575
                ],
                [
                    72.8476236,
                    54.9510691
                ],
                [
                    72.8487189,
                    54.9512031
                ],
                [
                    72.8492869,
                    54.9513662
                ],
                [
                    72.8503315,
                    54.9518205
                ],
                [
                    72.8511022,
                    54.9521291
                ],
                [
                    72.8517513,
                    54.9523097
                ],
                [
                    72.8517716,
                    54.9520418
                ],
                [
                    72.8519846,
                    54.9518845
                ],
                [
                    72.8521874,
                    54.9518205
                ],
                [
                    72.8523091,
                    54.9518787
                ],
                [
                    72.8523294,
                    54.9519835
                ],
                [
                    72.8523091,
                    54.9521874
                ],
                [
                    72.8523801,
                    54.9522514
                ],
                [
                    72.8525526,
                    54.9522631
                ],
                [
                    72.8527554,
                    54.9521932
                ],
                [
                    72.8529988,
                    54.952036
                ],
                [
                    72.8531408,
                    54.952001
                ],
                [
                    72.8532929,
                    54.9515875
                ],
                [
                    72.8528365,
                    54.9515118
                ],
                [
                    72.8529177,
                    54.9513895
                ],
                [
                    72.8535566,
                    54.9514652
                ],
                [
                    72.8545505,
                    54.9514594
                ],
                [
                    72.8549663,
                    54.9515525
                ],
                [
                    72.855372,
                    54.9517739
                ],
                [
                    72.8582422,
                    54.9513487
                ],
                [
                    72.8589927,
                    54.9511682
                ],
                [
                    72.8594491,
                    54.9510225
                ],
                [
                    72.859804,
                    54.9508536
                ],
                [
                    72.8601184,
                    54.9506207
                ],
                [
                    72.8603213,
                    54.9503702
                ],
                [
                    72.8606052,
                    54.9498751
                ],
                [
                    72.8606052,
                    54.9497237
                ],
                [
                    72.8606052,
                    54.9494034
                ],
                [
                    72.8604835,
                    54.9486986
                ],
                [
                    72.8603213,
                    54.9481103
                ],
                [
                    72.860443,
                    54.9480754
                ],
                [
                    72.8593375,
                    54.9461473
                ],
                [
                    72.8597229,
                    54.9457338
                ],
                [
                    72.8600069,
                    54.945594
                ],
                [
                    72.8598649,
                    54.9454076
                ],
                [
                    72.8601286,
                    54.9452445
                ],
                [
                    72.8611022,
                    54.9452561
                ],
                [
                    72.8612036,
                    54.9446561
                ],
                [
                    72.8617716,
                    54.9446736
                ],
                [
                    72.8618121,
                    54.9443299
                ],
                [
                    72.861234,
                    54.944295
                ],
                [
                    72.8612442,
                    54.9438056
                ],
                [
                    72.8606661,
                    54.9437707
                ],
                [
                    72.8606965,
                    54.9434794
                ],
                [
                    72.8597939,
                    54.9434445
                ],
                [
                    72.8597533,
                    54.9435551
                ],
                [
                    72.8593375,
                    54.9435726
                ],
                [
                    72.8592868,
                    54.9439629
                ],
                [
                    72.8581813,
                    54.9439629
                ],
                [
                    72.8580089,
                    54.9438872
                ],
                [
                    72.8582117,
                    54.943695
                ],
                [
                    72.858303,
                    54.9434736
                ],
                [
                    72.8575221,
                    54.9431648
                ],
                [
                    72.8570353,
                    54.9435027
                ],
                [
                    72.8557168,
                    54.942961
                ],
                [
                    72.8560008,
                    54.9427279
                ],
                [
                    72.8543983,
                    54.9420463
                ],
                [
                    72.8544491,
                    54.9413939
                ],
                [
                    72.8536376,
                    54.9413764
                ],
                [
                    72.8536682,
                    54.9410152
                ],
                [
                    72.8543679,
                    54.9410094
                ],
                [
                    72.8543477,
                    54.9397277
                ],
                [
                    72.8534349,
                    54.9397627
                ],
                [
                    72.8534045,
                    54.9390752
                ],
                [
                    72.846224,
                    54.9391335
                ],
                [
                    72.8453416,
                    54.9390053
                ],
                [
                    72.8445708,
                    54.9387431
                ],
                [
                    72.8440333,
                    54.9386208
                ],
                [
                    72.8433943,
                    54.938545
                ],
                [
                    72.842796,
                    54.938545
                ],
                [
                    72.8427149,
                    54.9387722
                ],
                [
                    72.8427555,
                    54.9389995
                ],
                [
                    72.8430394,
                    54.9391626
                ],
                [
                    72.8427352,
                    54.9400773
                ],
                [
                    72.8430496,
                    54.9401355
                ],
                [
                    72.8425019,
                    54.9425066
                ],
                [
                    72.8413659,
                    54.9439338
                ],
                [
                    72.8412342,
                    54.945227
                ]
            ],
            "longitude": 72.84861,
            "latitude": 54.94849
        },
        "2388": {
            "name": "Голенки",
            "population": 389,
            "type": "village",
            "poly": null,
            "longitude": 72.854859,
            "latitude": 54.9175859
        },
        "2389": {
            "name": "Коршуновка",
            "population": 453,
            "type": "village",
            "poly": null,
            "longitude": 72.867068,
            "latitude": 56.0054012
        },
        "2390": {
            "name": "16 Партсъезд",
            "population": 315,
            "type": "village",
            "poly": null,
            "longitude": 72.8756823,
            "latitude": 55.098742
        },
        "2391": {
            "name": "Цветнополье",
            "population": 1876,
            "type": "village",
            "poly": null,
            "longitude": 72.876732,
            "latitude": 54.490437
        },
        "2392": {
            "name": "Фирстово",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 72.8831184,
            "latitude": 57.0391981
        },
        "2393": {
            "name": "Трубецкое",
            "population": 700,
            "type": "village",
            "poly": null,
            "longitude": 72.902847,
            "latitude": 54.609833
        },
        "2394": {
            "name": "Увало-Ядрино",
            "population": 581,
            "type": "village",
            "poly": null,
            "longitude": 72.9051959,
            "latitude": 55.3735474
        },
        "2395": {
            "name": "Сегизбай",
            "population": 350,
            "type": "village",
            "poly": null,
            "longitude": 72.913513,
            "latitude": 54.769199
        },
        "2396": {
            "name": "Ермиловка",
            "population": 192,
            "type": "village",
            "poly": null,
            "longitude": 72.9146926,
            "latitude": 57.6353162
        },
        "2397": {
            "name": "Красный Яр",
            "population": 5230,
            "type": "village",
            "poly": [
                [
                    72.8985263,
                    55.23136
                ],
                [
                    72.9003593,
                    55.2330315
                ],
                [
                    72.9009972,
                    55.2334735
                ],
                [
                    72.9029432,
                    55.234643
                ],
                [
                    72.9041706,
                    55.2353751
                ],
                [
                    72.9045742,
                    55.2356467
                ],
                [
                    72.9052445,
                    55.2361854
                ],
                [
                    72.9056805,
                    55.2366366
                ],
                [
                    72.9059712,
                    55.237005
                ],
                [
                    72.9062377,
                    55.23747
                ],
                [
                    72.9064638,
                    55.2379534
                ],
                [
                    72.9072309,
                    55.2397029
                ],
                [
                    72.908434,
                    55.2421612
                ],
                [
                    72.9087732,
                    55.2427366
                ],
                [
                    72.9091769,
                    55.2431647
                ],
                [
                    72.9096129,
                    55.2436251
                ],
                [
                    72.9101055,
                    55.244067
                ],
                [
                    72.9110987,
                    55.2447483
                ],
                [
                    72.9120838,
                    55.2453191
                ],
                [
                    72.9131335,
                    55.2458254
                ],
                [
                    72.914159,
                    55.2462121
                ],
                [
                    72.9153621,
                    55.2465112
                ],
                [
                    72.9173808,
                    55.2468979
                ],
                [
                    72.9354036,
                    55.2498897
                ],
                [
                    72.9378502,
                    55.2504006
                ],
                [
                    72.9411609,
                    55.2482097
                ],
                [
                    72.9434218,
                    55.2467552
                ],
                [
                    72.9453436,
                    55.2454111
                ],
                [
                    72.9457917,
                    55.2446585
                ],
                [
                    72.9483741,
                    55.2445787
                ],
                [
                    72.9499742,
                    55.2444938
                ],
                [
                    72.9506526,
                    55.2445951
                ],
                [
                    72.9520415,
                    55.2444938
                ],
                [
                    72.9526508,
                    55.2443717
                ],
                [
                    72.9530589,
                    55.2443511
                ],
                [
                    72.9534142,
                    55.2444017
                ],
                [
                    72.9536726,
                    55.244526
                ],
                [
                    72.9540278,
                    55.2447424
                ],
                [
                    72.9544558,
                    55.2451244
                ],
                [
                    72.9548595,
                    55.2453822
                ],
                [
                    72.9553925,
                    55.2455479
                ],
                [
                    72.9558043,
                    55.2456584
                ],
                [
                    72.9559173,
                    55.2458241
                ],
                [
                    72.9559254,
                    55.2460542
                ],
                [
                    72.9558124,
                    55.246358
                ],
                [
                    72.9556912,
                    55.2466434
                ],
                [
                    72.9557962,
                    55.246915
                ],
                [
                    72.9560788,
                    55.2471083
                ],
                [
                    72.9563614,
                    55.2471912
                ],
                [
                    72.9569832,
                    55.2472096
                ],
                [
                    72.9577826,
                    55.2472142
                ],
                [
                    72.9585254,
                    55.2472556
                ],
                [
                    72.9591068,
                    55.2473293
                ],
                [
                    72.9593733,
                    55.2474351
                ],
                [
                    72.9593572,
                    55.2476791
                ],
                [
                    72.9594541,
                    55.2478632
                ],
                [
                    72.9594783,
                    55.2481624
                ],
                [
                    72.9603181,
                    55.2482544
                ],
                [
                    72.9606007,
                    55.247297
                ],
                [
                    72.9609398,
                    55.2472004
                ],
                [
                    72.9610852,
                    55.246915
                ],
                [
                    72.9613112,
                    55.2466802
                ],
                [
                    72.9614162,
                    55.2463672
                ],
                [
                    72.9616585,
                    55.2460773
                ],
                [
                    72.9616665,
                    55.2458701
                ],
                [
                    72.9619814,
                    55.2454282
                ],
                [
                    72.9620218,
                    55.2452073
                ],
                [
                    72.9619814,
                    55.2450093
                ],
                [
                    72.962151,
                    55.244839
                ],
                [
                    72.9620702,
                    55.24419
                ],
                [
                    72.962151,
                    55.2432003
                ],
                [
                    72.9619572,
                    55.2422059
                ],
                [
                    72.9619491,
                    55.2414602
                ],
                [
                    72.9618119,
                    55.2413267
                ],
                [
                    72.9620299,
                    55.2413451
                ],
                [
                    72.9626839,
                    55.2414602
                ],
                [
                    72.9625225,
                    55.241055
                ],
                [
                    72.9621672,
                    55.2405118
                ],
                [
                    72.9616585,
                    55.2399363
                ],
                [
                    72.9610529,
                    55.2395266
                ],
                [
                    72.9601485,
                    55.2390846
                ],
                [
                    72.9600844,
                    55.2388717
                ],
                [
                    72.9590825,
                    55.2389364
                ],
                [
                    72.956747,
                    55.2391244
                ],
                [
                    72.9557363,
                    55.2394171
                ],
                [
                    72.9544208,
                    55.2396915
                ],
                [
                    72.9534903,
                    55.2397556
                ],
                [
                    72.9520465,
                    55.2400666
                ],
                [
                    72.9511321,
                    55.2401031
                ],
                [
                    72.9487363,
                    55.2406832
                ],
                [
                    72.9475225,
                    55.2408531
                ],
                [
                    72.9452073,
                    55.2413527
                ],
                [
                    72.9426282,
                    55.2415904
                ],
                [
                    72.9404013,
                    55.2416992
                ],
                [
                    72.9394495,
                    55.2418723
                ],
                [
                    72.93853,
                    55.2418287
                ],
                [
                    72.936864,
                    55.2416516
                ],
                [
                    72.9351123,
                    55.2412607
                ],
                [
                    72.9341489,
                    55.2410982
                ],
                [
                    72.9329514,
                    55.24092
                ],
                [
                    72.9321085,
                    55.2405879
                ],
                [
                    72.9314625,
                    55.2402564
                ],
                [
                    72.9305453,
                    55.2399064
                ],
                [
                    72.9299506,
                    55.2395847
                ],
                [
                    72.92912,
                    55.2393035
                ],
                [
                    72.9284268,
                    55.2388694
                ],
                [
                    72.9276181,
                    55.2383685
                ],
                [
                    72.9271243,
                    55.2375668
                ],
                [
                    72.9267147,
                    55.2370646
                ],
                [
                    72.9264683,
                    55.2366724
                ],
                [
                    72.9263143,
                    55.2362977
                ],
                [
                    72.9262835,
                    55.2359816
                ],
                [
                    72.9263054,
                    55.2358777
                ],
                [
                    72.9260679,
                    55.2357181
                ],
                [
                    72.9258948,
                    55.2353101
                ],
                [
                    72.925729,
                    55.2350975
                ],
                [
                    72.9256982,
                    55.2348575
                ],
                [
                    72.9257393,
                    55.2346702
                ],
                [
                    72.9259652,
                    55.2344828
                ],
                [
                    72.9260679,
                    55.2341725
                ],
                [
                    72.9259549,
                    55.2336924
                ],
                [
                    72.9257598,
                    55.2333294
                ],
                [
                    72.9257496,
                    55.2330016
                ],
                [
                    72.9258537,
                    55.232547
                ],
                [
                    72.9259974,
                    55.2317157
                ],
                [
                    72.9262321,
                    55.2304019
                ],
                [
                    72.926305,
                    55.2303613
                ],
                [
                    72.926473,
                    55.2303515
                ],
                [
                    72.9266819,
                    55.2303932
                ],
                [
                    72.9268175,
                    55.2303073
                ],
                [
                    72.9267589,
                    55.2302252
                ],
                [
                    72.9265591,
                    55.2301538
                ],
                [
                    72.926374,
                    55.2300691
                ],
                [
                    72.926318,
                    55.2299806
                ],
                [
                    72.9263072,
                    55.229875
                ],
                [
                    72.9263696,
                    55.229724
                ],
                [
                    72.9263804,
                    55.2296024
                ],
                [
                    72.9266366,
                    55.2289848
                ],
                [
                    72.9268576,
                    55.2285447
                ],
                [
                    72.9270307,
                    55.2283045
                ],
                [
                    72.9272374,
                    55.2280798
                ],
                [
                    72.927386,
                    55.2278182
                ],
                [
                    72.9275518,
                    55.2276929
                ],
                [
                    72.9280039,
                    55.2271759
                ],
                [
                    72.9284083,
                    55.2268476
                ],
                [
                    72.9268443,
                    55.2263386
                ],
                [
                    72.9258431,
                    55.2262879
                ],
                [
                    72.9256413,
                    55.2262557
                ],
                [
                    72.925504,
                    55.2261314
                ],
                [
                    72.925504,
                    55.2260439
                ],
                [
                    72.9243654,
                    55.225284
                ],
                [
                    72.9217654,
                    55.2223778
                ],
                [
                    72.9192945,
                    55.2230272
                ],
                [
                    72.9179057,
                    55.2234418
                ],
                [
                    72.9165007,
                    55.2239023
                ],
                [
                    72.8990956,
                    55.2301558
                ],
                [
                    72.8987524,
                    55.2312863
                ],
                [
                    72.8985263,
                    55.23136
                ]
            ],
            "longitude": 72.923889,
            "latitude": 55.240089
        },
        "2398": {
            "name": "Пятилетка",
            "population": 957,
            "type": "village",
            "poly": null,
            "longitude": 72.9355863,
            "latitude": 54.936873
        },
        "2399": {
            "name": "Фёдоровка",
            "population": 340,
            "type": "village",
            "poly": null,
            "longitude": 72.936684,
            "latitude": 55.080925
        },
        "2400": {
            "name": "Камышловский",
            "population": 1451,
            "type": "village",
            "poly": null,
            "longitude": 72.9445483,
            "latitude": 55.116098
        },
        "2401": {
            "name": "Роза Долина",
            "population": 415,
            "type": "village",
            "poly": null,
            "longitude": 72.946907,
            "latitude": 54.473461
        },
        "2402": {
            "name": "Кутырлы",
            "population": 788,
            "type": "village",
            "poly": null,
            "longitude": 72.9571301,
            "latitude": 56.2055425
        },
        "2403": {
            "name": "Уралы",
            "population": 350,
            "type": "village",
            "poly": null,
            "longitude": 72.9641197,
            "latitude": 57.0711792
        },
        "2404": {
            "name": "Михайловка",
            "population": 407,
            "type": "village",
            "poly": null,
            "longitude": 72.9649352,
            "latitude": 55.6667083
        },
        "2405": {
            "name": "Бородинка",
            "population": 475,
            "type": "village",
            "poly": null,
            "longitude": 72.9696384,
            "latitude": 57.4654737
        },
        "2406": {
            "name": "Привальное",
            "population": 863,
            "type": "village",
            "poly": null,
            "longitude": 72.992996,
            "latitude": 54.689003
        },
        "2407": {
            "name": "Бакшеево",
            "population": 528,
            "type": "village",
            "poly": null,
            "longitude": 72.9967791,
            "latitude": 57.4003186
        },
        "2408": {
            "name": "Авлы",
            "population": 298,
            "type": "village",
            "poly": null,
            "longitude": 72.9981264,
            "latitude": 55.3219567
        },
        "2409": {
            "name": "Любино-Малороссы",
            "population": 1347,
            "type": "village",
            "poly": null,
            "longitude": 73.000114,
            "latitude": 55.202602
        },
        "2410": {
            "name": "Сереброполье",
            "population": 649,
            "type": "village",
            "poly": null,
            "longitude": 73.012047,
            "latitude": 54.434582
        },
        "2411": {
            "name": "ДОЛ им. Ю.А. Гагарина",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 73.0196451,
            "latitude": 55.2892572
        },
        "2412": {
            "name": "Чернолучье",
            "population": 258,
            "type": "village",
            "poly": null,
            "longitude": 73.0239806,
            "latitude": 55.2449588
        },
        "2413": {
            "name": "База отдыха \"Иртыш\"",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 73.0275071,
            "latitude": 55.2510929
        },
        "2414": {
            "name": "Лузино",
            "population": 8964,
            "type": "village",
            "poly": [
                [
                    73.0124744,
                    54.9540981
                ],
                [
                    73.0126375,
                    54.9541814
                ],
                [
                    73.0198188,
                    54.9537892
                ],
                [
                    73.0361786,
                    54.9528528
                ],
                [
                    73.0388811,
                    54.9508785
                ],
                [
                    73.042373,
                    54.9508568
                ],
                [
                    73.0422614,
                    54.9493298
                ],
                [
                    73.0480786,
                    54.9488066
                ],
                [
                    73.0466776,
                    54.9384323
                ],
                [
                    73.0325902,
                    54.9355333
                ],
                [
                    73.0241797,
                    54.9381505
                ],
                [
                    73.0135815,
                    54.9346622
                ],
                [
                    73.0145084,
                    54.9411915
                ],
                [
                    73.0201015,
                    54.9435424
                ],
                [
                    73.0178669,
                    54.94776
                ],
                [
                    73.015324,
                    54.9490484
                ],
                [
                    73.0141228,
                    54.9511532
                ],
                [
                    73.0133529,
                    54.9528448
                ],
                [
                    73.0131895,
                    54.9530942
                ],
                [
                    73.0131059,
                    54.9535679
                ],
                [
                    73.0127885,
                    54.9538762
                ],
                [
                    73.0125046,
                    54.9539421
                ],
                [
                    73.0124744,
                    54.9540981
                ]
            ],
            "longitude": 73.027802,
            "latitude": 54.948967
        },
        "2415": {
            "name": "Чернолучинский",
            "population": 1796,
            "type": "village",
            "poly": null,
            "longitude": 73.028519,
            "latitude": 55.282883
        },
        "2416": {
            "name": "Новоархангелка",
            "population": 1061,
            "type": "village",
            "poly": null,
            "longitude": 73.0302731,
            "latitude": 55.3527027
        },
        "2417": {
            "name": "Мельничное",
            "population": 665,
            "type": "village",
            "poly": null,
            "longitude": 73.0407741,
            "latitude": 55.0240771
        },
        "2418": {
            "name": "Петровка",
            "population": 1460,
            "type": "village",
            "poly": [
                [
                    73.0388402,
                    54.9546892
                ],
                [
                    73.039564,
                    54.9559305
                ],
                [
                    73.0409339,
                    54.9579684
                ],
                [
                    73.0418074,
                    54.9593673
                ],
                [
                    73.0420373,
                    54.9596735
                ],
                [
                    73.042212,
                    54.9607715
                ],
                [
                    73.0430854,
                    54.9610883
                ],
                [
                    73.054229,
                    54.9654114
                ],
                [
                    73.054606,
                    54.9657017
                ],
                [
                    73.0545415,
                    54.9658389
                ],
                [
                    73.0537601,
                    54.9663826
                ],
                [
                    73.0546244,
                    54.9662295
                ],
                [
                    73.0553967,
                    54.9660184
                ],
                [
                    73.0559944,
                    54.9657861
                ],
                [
                    73.0565368,
                    54.9655275
                ],
                [
                    73.0569795,
                    54.9653222
                ],
                [
                    73.0589733,
                    54.9641129
                ],
                [
                    73.0599019,
                    54.9635692
                ],
                [
                    73.063497,
                    54.9610196
                ],
                [
                    73.064205,
                    54.9604548
                ],
                [
                    73.0646187,
                    54.9599955
                ],
                [
                    73.064775,
                    54.9594043
                ],
                [
                    73.0636165,
                    54.9586599
                ],
                [
                    73.0654093,
                    54.9579578
                ],
                [
                    73.0662093,
                    54.9575672
                ],
                [
                    73.0659151,
                    54.9570023
                ],
                [
                    73.0643429,
                    54.9559517
                ],
                [
                    73.0636901,
                    54.9557299
                ],
                [
                    73.0632855,
                    54.9556718
                ],
                [
                    73.0624856,
                    54.9552178
                ],
                [
                    73.0620993,
                    54.9551967
                ],
                [
                    73.0598836,
                    54.9560467
                ],
                [
                    73.0598008,
                    54.9559517
                ],
                [
                    73.059948,
                    54.9558725
                ],
                [
                    73.0598652,
                    54.9557246
                ],
                [
                    73.0591297,
                    54.955392
                ],
                [
                    73.0587067,
                    54.9551175
                ],
                [
                    73.0584401,
                    54.9547585
                ],
                [
                    73.0583481,
                    54.9542569
                ],
                [
                    73.0579436,
                    54.9540193
                ],
                [
                    73.0577505,
                    54.9537342
                ],
                [
                    73.051342,
                    54.9540827
                ],
                [
                    73.0388402,
                    54.9546892
                ]
            ],
            "longitude": 73.047379,
            "latitude": 54.959862
        },
        "2419": {
            "name": "Преображеновка",
            "population": 328,
            "type": "village",
            "poly": null,
            "longitude": 73.0488915,
            "latitude": 55.5377711
        },
        "2420": {
            "name": "Александровка",
            "population": 80,
            "type": "village",
            "poly": null,
            "longitude": 73.0498824,
            "latitude": 57.5800671
        },
        "2421": {
            "name": "Лукьяновка",
            "population": 1730,
            "type": "village",
            "poly": null,
            "longitude": 73.0593247,
            "latitude": 54.3133827
        },
        "2422": {
            "name": "Пришиб",
            "population": 729,
            "type": "village",
            "poly": null,
            "longitude": 73.065971,
            "latitude": 54.432041
        },
        "2423": {
            "name": "Новотроицк",
            "population": 804,
            "type": "village",
            "poly": null,
            "longitude": 73.067069,
            "latitude": 55.7831711
        },
        "2424": {
            "name": "Мирная Долина",
            "population": 305,
            "type": "village",
            "poly": null,
            "longitude": 73.074554,
            "latitude": 54.900494
        },
        "2425": {
            "name": "Чебаклы",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 73.0751028,
            "latitude": 57.0911705
        },
        "2426": {
            "name": "Берёзовка",
            "population": 2200,
            "type": "village",
            "poly": null,
            "longitude": 73.075363,
            "latitude": 54.795788
        },
        "2427": {
            "name": "Китайлы",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 73.0763272,
            "latitude": 55.2182431
        },
        "2428": {
            "name": "Баженово",
            "population": 793,
            "type": "village",
            "poly": null,
            "longitude": 73.0932523,
            "latitude": 55.6331885
        },
        "2429": {
            "name": "Красноярка",
            "population": 4902,
            "type": "village",
            "poly": [
                [
                    73.0750514,
                    55.3297349
                ],
                [
                    73.0769681,
                    55.3307136
                ],
                [
                    73.0781551,
                    55.3315003
                ],
                [
                    73.0809538,
                    55.3331295
                ],
                [
                    73.0813675,
                    55.3329003
                ],
                [
                    73.0819774,
                    55.3332905
                ],
                [
                    73.0835564,
                    55.3339285
                ],
                [
                    73.0839158,
                    55.3341825
                ],
                [
                    73.0851899,
                    55.3346594
                ],
                [
                    73.0863225,
                    55.3349319
                ],
                [
                    73.0876511,
                    55.3351054
                ],
                [
                    73.0886638,
                    55.3351921
                ],
                [
                    73.0909289,
                    55.3352045
                ],
                [
                    73.0917566,
                    55.3352292
                ],
                [
                    73.0920833,
                    55.3353222
                ],
                [
                    73.0928129,
                    55.3354398
                ],
                [
                    73.0934009,
                    55.3354522
                ],
                [
                    73.0938474,
                    55.3356566
                ],
                [
                    73.0950344,
                    55.3356566
                ],
                [
                    73.0970382,
                    55.3360035
                ],
                [
                    73.0976044,
                    55.3360035
                ],
                [
                    73.0997498,
                    55.3357619
                ],
                [
                    73.1000765,
                    55.3357743
                ],
                [
                    73.1003596,
                    55.33583
                ],
                [
                    73.1035939,
                    55.3358362
                ],
                [
                    73.1049442,
                    55.3362203
                ],
                [
                    73.1060223,
                    55.336629
                ],
                [
                    73.1066757,
                    55.3369945
                ],
                [
                    73.107438,
                    55.3370688
                ],
                [
                    73.1081677,
                    55.3370936
                ],
                [
                    73.1082874,
                    55.3367901
                ],
                [
                    73.1110208,
                    55.3368396
                ],
                [
                    73.1109881,
                    55.3361273
                ],
                [
                    73.1098774,
                    55.3361026
                ],
                [
                    73.1094527,
                    55.3349443
                ],
                [
                    73.1094636,
                    55.33404
                ],
                [
                    73.1090171,
                    55.3332967
                ],
                [
                    73.1085161,
                    55.3319959
                ],
                [
                    73.1085597,
                    55.3317171
                ],
                [
                    73.1086577,
                    55.3314632
                ],
                [
                    73.107144,
                    55.3303296
                ],
                [
                    73.1079172,
                    55.3299641
                ],
                [
                    73.1069589,
                    55.329134
                ],
                [
                    73.1060114,
                    55.3295181
                ],
                [
                    73.1054343,
                    55.329072
                ],
                [
                    73.1061421,
                    55.3287561
                ],
                [
                    73.1050205,
                    55.3278578
                ],
                [
                    73.1043016,
                    55.3281366
                ],
                [
                    73.1041602,
                    55.3280251
                ],
                [
                    73.1037572,
                    55.3281552
                ],
                [
                    73.1035286,
                    55.3280313
                ],
                [
                    73.1032454,
                    55.3281242
                ],
                [
                    73.1026574,
                    55.3277029
                ],
                [
                    73.1019931,
                    55.3280499
                ],
                [
                    73.1031256,
                    55.3287065
                ],
                [
                    73.1031256,
                    55.3289605
                ],
                [
                    73.1029296,
                    55.3290472
                ],
                [
                    73.1022,
                    55.3285702
                ],
                [
                    73.1019604,
                    55.3286074
                ],
                [
                    73.1014377,
                    55.3281428
                ],
                [
                    73.1010239,
                    55.3282791
                ],
                [
                    73.1011981,
                    55.3277401
                ],
                [
                    73.1010021,
                    55.3276967
                ],
                [
                    73.1008061,
                    55.3277897
                ],
                [
                    73.1004031,
                    55.3280932
                ],
                [
                    73.0997389,
                    55.3277959
                ],
                [
                    73.0995645,
                    55.3274489
                ],
                [
                    73.0999784,
                    55.3272383
                ],
                [
                    73.0997171,
                    55.3269843
                ],
                [
                    73.1001527,
                    55.3268418
                ],
                [
                    73.1002071,
                    55.3266807
                ],
                [
                    73.1007843,
                    55.3264143
                ],
                [
                    73.1002725,
                    55.3259869
                ],
                [
                    73.097354,
                    55.3256357
                ],
                [
                    73.0967868,
                    55.325555
                ],
                [
                    73.0960831,
                    55.3254638
                ],
                [
                    73.0956225,
                    55.3252062
                ],
                [
                    73.0957205,
                    55.3250514
                ],
                [
                    73.0997498,
                    55.3226227
                ],
                [
                    73.1044651,
                    55.3197725
                ],
                [
                    73.1056521,
                    55.319128
                ],
                [
                    73.1095616,
                    55.3173806
                ],
                [
                    73.1073836,
                    55.3158686
                ],
                [
                    73.1066866,
                    55.3157013
                ],
                [
                    73.1061421,
                    55.3156331
                ],
                [
                    73.1010457,
                    55.3152737
                ],
                [
                    73.1006754,
                    55.3151931
                ],
                [
                    73.1005012,
                    55.3149452
                ],
                [
                    73.1004794,
                    55.3145362
                ],
                [
                    73.1006754,
                    55.3098819
                ],
                [
                    73.0920724,
                    55.309727
                ],
                [
                    73.0920724,
                    55.3101918
                ],
                [
                    73.0918328,
                    55.3103901
                ],
                [
                    73.0928347,
                    55.3150258
                ],
                [
                    73.0885222,
                    55.3191776
                ],
                [
                    73.0863442,
                    55.3213401
                ],
                [
                    73.0841009,
                    55.3218358
                ],
                [
                    73.0845039,
                    55.3226412
                ],
                [
                    73.0831644,
                    55.3231989
                ],
                [
                    73.0833822,
                    55.3233909
                ],
                [
                    73.0828595,
                    55.3236326
                ],
                [
                    73.0828813,
                    55.3237999
                ],
                [
                    73.0821081,
                    55.3241034
                ],
                [
                    73.0824021,
                    55.3242893
                ],
                [
                    73.0826635,
                    55.3242831
                ],
                [
                    73.0830555,
                    55.3241034
                ],
                [
                    73.0833822,
                    55.3241654
                ],
                [
                    73.0835238,
                    55.3242955
                ],
                [
                    73.0834584,
                    55.3244752
                ],
                [
                    73.0831426,
                    55.3248035
                ],
                [
                    73.0803113,
                    55.3259373
                ],
                [
                    73.0806162,
                    55.3261913
                ],
                [
                    73.0785471,
                    55.3268294
                ],
                [
                    73.0783728,
                    55.3270463
                ],
                [
                    73.0783074,
                    55.3272817
                ],
                [
                    73.0757919,
                    55.3283286
                ],
                [
                    73.0764453,
                    55.3288614
                ],
                [
                    73.0750514,
                    55.3297349
                ]
            ],
            "longitude": 73.095306,
            "latitude": 55.325813
        },
        "2430": {
            "name": "Поповка",
            "population": 532,
            "type": "village",
            "poly": null,
            "longitude": 73.103104,
            "latitude": 54.862507
        },
        "2431": {
            "name": "Иванов Мыс",
            "population": 380,
            "type": "village",
            "poly": null,
            "longitude": 73.1069193,
            "latitude": 57.3860515
        },
        "2432": {
            "name": "Кудук-Чилик",
            "population": 354,
            "type": "village",
            "poly": null,
            "longitude": 73.1110626,
            "latitude": 54.5085996
        },
        "2433": {
            "name": "Красная Горка",
            "population": 926,
            "type": "village",
            "poly": null,
            "longitude": 73.1218119,
            "latitude": 55.125488
        },
        "2434": {
            "name": "Дружино",
            "population": 2838,
            "type": "village",
            "poly": [
                [
                    73.1144443,
                    55.018253
                ],
                [
                    73.1148791,
                    55.0196126
                ],
                [
                    73.1152135,
                    55.0236795
                ],
                [
                    73.1155359,
                    55.0264659
                ],
                [
                    73.1175544,
                    55.0258498
                ],
                [
                    73.1204208,
                    55.0250077
                ],
                [
                    73.123323,
                    55.0244189
                ],
                [
                    73.1249115,
                    55.0261099
                ],
                [
                    73.1280168,
                    55.02624
                ],
                [
                    73.1279452,
                    55.0268767
                ],
                [
                    73.1276585,
                    55.0272943
                ],
                [
                    73.1275749,
                    55.0275407
                ],
                [
                    73.1272286,
                    55.0279104
                ],
                [
                    73.1268822,
                    55.0284649
                ],
                [
                    73.1264761,
                    55.0288688
                ],
                [
                    73.1260223,
                    55.0291494
                ],
                [
                    73.125437,
                    55.0293548
                ],
                [
                    73.1251264,
                    55.0296355
                ],
                [
                    73.1250548,
                    55.0299024
                ],
                [
                    73.1251862,
                    55.0300804
                ],
                [
                    73.1259625,
                    55.030587
                ],
                [
                    73.1259506,
                    55.0309224
                ],
                [
                    73.1255326,
                    55.0312783
                ],
                [
                    73.1255206,
                    55.0316343
                ],
                [
                    73.1256998,
                    55.0318875
                ],
                [
                    73.126285,
                    55.0324351
                ],
                [
                    73.1265239,
                    55.0328253
                ],
                [
                    73.1271569,
                    55.0340026
                ],
                [
                    73.1273599,
                    55.0347487
                ],
                [
                    73.1279213,
                    55.0353852
                ],
                [
                    73.1283035,
                    55.0355495
                ],
                [
                    73.1297127,
                    55.0358506
                ],
                [
                    73.142274,
                    55.0284394
                ],
                [
                    73.1434608,
                    55.0281397
                ],
                [
                    73.1504107,
                    55.0255896
                ],
                [
                    73.1469471,
                    55.0223102
                ],
                [
                    73.146123,
                    55.0221596
                ],
                [
                    73.1506735,
                    55.0204
                ],
                [
                    73.1488342,
                    55.0144358
                ],
                [
                    73.1353978,
                    55.0159492
                ],
                [
                    73.1351112,
                    55.0154014
                ],
                [
                    73.133463,
                    55.0155794
                ],
                [
                    73.1315043,
                    55.0156821
                ],
                [
                    73.1286618,
                    55.016004
                ],
                [
                    73.123765,
                    55.0168531
                ],
                [
                    73.119955,
                    55.0174283
                ],
                [
                    73.117926,
                    55.0177387
                ],
                [
                    73.1144443,
                    55.018253
                ]
            ],
            "longitude": 73.1353452,
            "latitude": 55.0201263
        },
        "2435": {
            "name": "Пахомовка",
            "population": 538,
            "type": "village",
            "poly": [
                [
                    73.132413,
                    54.6841209
                ],
                [
                    73.1326112,
                    54.6845099
                ],
                [
                    73.1330363,
                    54.6848948
                ],
                [
                    73.1334612,
                    54.685161
                ],
                [
                    73.1360608,
                    54.6851487
                ],
                [
                    73.1369604,
                    54.6850217
                ],
                [
                    73.1375129,
                    54.6857342
                ],
                [
                    73.1379874,
                    54.6861846
                ],
                [
                    73.1385399,
                    54.6865244
                ],
                [
                    73.139227,
                    54.6867496
                ],
                [
                    73.1405161,
                    54.686942
                ],
                [
                    73.1417982,
                    54.6868724
                ],
                [
                    73.1445039,
                    54.6860249
                ],
                [
                    73.1450422,
                    54.6857833
                ],
                [
                    73.1450706,
                    54.6855622
                ],
                [
                    73.1446243,
                    54.6851569
                ],
                [
                    73.1430376,
                    54.6841864
                ],
                [
                    73.1448156,
                    54.6835231
                ],
                [
                    73.145531,
                    54.6829539
                ],
                [
                    73.146388,
                    54.6824134
                ],
                [
                    73.1473868,
                    54.6822128
                ],
                [
                    73.1468201,
                    54.6815248
                ],
                [
                    73.1468272,
                    54.6809761
                ],
                [
                    73.1487832,
                    54.6803868
                ],
                [
                    73.1491152,
                    54.680438
                ],
                [
                    73.1497459,
                    54.6808155
                ],
                [
                    73.1502662,
                    54.6808731
                ],
                [
                    73.1506093,
                    54.6808347
                ],
                [
                    73.1516053,
                    54.6803612
                ],
                [
                    73.1528892,
                    54.6799069
                ],
                [
                    73.1554394,
                    54.6784152
                ],
                [
                    73.1554394,
                    54.6776591
                ],
                [
                    73.1555027,
                    54.6773996
                ],
                [
                    73.1565727,
                    54.6767758
                ],
                [
                    73.1569489,
                    54.6764875
                ],
                [
                    73.1569308,
                    54.6761127
                ],
                [
                    73.1567313,
                    54.6758191
                ],
                [
                    73.1567223,
                    54.675253
                ],
                [
                    73.1586353,
                    54.6746344
                ],
                [
                    73.1587305,
                    54.6743591
                ],
                [
                    73.1584993,
                    54.6740498
                ],
                [
                    73.1584948,
                    54.6737929
                ],
                [
                    73.1587305,
                    54.6734994
                ],
                [
                    73.1576742,
                    54.673523
                ],
                [
                    73.157298,
                    54.673156
                ],
                [
                    73.1567087,
                    54.6729201
                ],
                [
                    73.1561194,
                    54.6729646
                ],
                [
                    73.1554439,
                    54.672941
                ],
                [
                    73.1534538,
                    54.6717431
                ],
                [
                    73.1524972,
                    54.6713708
                ],
                [
                    73.1513413,
                    54.6707181
                ],
                [
                    73.1512597,
                    54.6704376
                ],
                [
                    73.150965,
                    54.6704376
                ],
                [
                    73.15073,
                    54.6707579
                ],
                [
                    73.1482651,
                    54.6725601
                ],
                [
                    73.1476913,
                    54.672556
                ],
                [
                    73.1472097,
                    54.6728181
                ],
                [
                    73.1465722,
                    54.6728181
                ],
                [
                    73.1464022,
                    54.6731622
                ],
                [
                    73.1456514,
                    54.6733833
                ],
                [
                    73.1454531,
                    54.6736004
                ],
                [
                    73.1446881,
                    54.6740018
                ],
                [
                    73.1442773,
                    54.6744154
                ],
                [
                    73.142719,
                    54.6753083
                ],
                [
                    73.1417344,
                    54.6753697
                ],
                [
                    73.1416282,
                    54.6755909
                ],
                [
                    73.1397582,
                    54.6764714
                ],
                [
                    73.1384974,
                    54.6771512
                ],
                [
                    73.1390074,
                    54.6774338
                ],
                [
                    73.1390428,
                    54.6774952
                ],
                [
                    73.138887,
                    54.6776918
                ],
                [
                    73.1391845,
                    54.6780522
                ],
                [
                    73.139227,
                    54.6782692
                ],
                [
                    73.1387382,
                    54.6788999
                ],
                [
                    73.1388232,
                    54.6790105
                ],
                [
                    73.1385966,
                    54.6795838
                ],
                [
                    73.1388728,
                    54.6795961
                ],
                [
                    73.1389365,
                    54.6796944
                ],
                [
                    73.137952,
                    54.6803004
                ],
                [
                    73.1378599,
                    54.6805175
                ],
                [
                    73.1332913,
                    54.6825281
                ],
                [
                    73.1327813,
                    54.6829376
                ],
                [
                    73.1325121,
                    54.683388
                ],
                [
                    73.132413,
                    54.6841209
                ]
            ],
            "longitude": 73.144035,
            "latitude": 54.677902
        },
        "2436": {
            "name": "Сосновка",
            "population": 1778,
            "type": "village",
            "poly": null,
            "longitude": 73.1477928,
            "latitude": 54.8169229
        },
        "2437": {
            "name": "Таскатлы",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 73.1496386,
            "latitude": 56.2406421
        },
        "2438": {
            "name": "Горячий Ключ",
            "population": 2846,
            "type": "village",
            "poly": [
                [
                    73.1414757,
                    55.0304558
                ],
                [
                    73.1421236,
                    55.0311787
                ],
                [
                    73.1431948,
                    55.0317183
                ],
                [
                    73.1463392,
                    55.0328075
                ],
                [
                    73.1467107,
                    55.0325105
                ],
                [
                    73.1497873,
                    55.0337977
                ],
                [
                    73.1553705,
                    55.0362011
                ],
                [
                    73.1580242,
                    55.0331368
                ],
                [
                    73.1597798,
                    55.0287622
                ],
                [
                    73.1618497,
                    55.025569
                ],
                [
                    73.1587955,
                    55.0250648
                ],
                [
                    73.1574504,
                    55.0237507
                ],
                [
                    73.1511055,
                    55.0262162
                ],
                [
                    73.1504993,
                    55.0256691
                ],
                [
                    73.1435803,
                    55.0282346
                ],
                [
                    73.1426462,
                    55.0293364
                ],
                [
                    73.1414757,
                    55.0304558
                ]
            ],
            "longitude": 73.1508843,
            "latitude": 55.0318045
        },
        "2439": {
            "name": "Верблюжье",
            "population": 965,
            "type": "village",
            "poly": null,
            "longitude": 73.1548487,
            "latitude": 55.3954732
        },
        "2440": {
            "name": "Буняковка",
            "population": 1013,
            "type": "village",
            "poly": null,
            "longitude": 73.1603192,
            "latitude": 54.131062
        },
        "2441": {
            "name": "Сосновское",
            "population": 3443,
            "type": "village",
            "poly": null,
            "longitude": 73.160698,
            "latitude": 54.598995
        },
        "2442": {
            "name": "Политотдел",
            "population": 360,
            "type": "village",
            "poly": [
                [
                    73.1497885,
                    55.2081967
                ],
                [
                    73.1525385,
                    55.2095812
                ],
                [
                    73.1527973,
                    55.2093597
                ],
                [
                    73.1531971,
                    55.2091355
                ],
                [
                    73.153943,
                    55.2095036
                ],
                [
                    73.1552927,
                    55.2101119
                ],
                [
                    73.1569307,
                    55.2109499
                ],
                [
                    73.1582895,
                    55.2116964
                ],
                [
                    73.1585275,
                    55.2119523
                ],
                [
                    73.1595844,
                    55.2133801
                ],
                [
                    73.1593464,
                    55.2133123
                ],
                [
                    73.1591085,
                    55.2132888
                ],
                [
                    73.1575483,
                    55.2133097
                ],
                [
                    73.1572555,
                    55.2133436
                ],
                [
                    73.1572464,
                    55.2140797
                ],
                [
                    73.1566699,
                    55.2140927
                ],
                [
                    73.1566835,
                    55.2161861
                ],
                [
                    73.159987,
                    55.2159329
                ],
                [
                    73.1600921,
                    55.2142676
                ],
                [
                    73.1602798,
                    55.2141423
                ],
                [
                    73.1608792,
                    55.2144686
                ],
                [
                    73.1619178,
                    55.2139466
                ],
                [
                    73.1633863,
                    55.2131765
                ],
                [
                    73.1646172,
                    55.2125083
                ],
                [
                    73.1652852,
                    55.2121324
                ],
                [
                    73.1663146,
                    55.2116051
                ],
                [
                    73.1672572,
                    55.2108794
                ],
                [
                    73.1681768,
                    55.2103599
                ],
                [
                    73.1691056,
                    55.2093235
                ],
                [
                    73.1688951,
                    55.2091146
                ],
                [
                    73.1695814,
                    55.2083811
                ],
                [
                    73.166612,
                    55.2075326
                ],
                [
                    73.1675042,
                    55.2067363
                ],
                [
                    73.1657702,
                    55.2062455
                ],
                [
                    73.1644113,
                    55.2076344
                ],
                [
                    73.1658388,
                    55.208073
                ],
                [
                    73.1651571,
                    55.2087413
                ],
                [
                    73.1647361,
                    55.2095532
                ],
                [
                    73.162142,
                    55.2085325
                ],
                [
                    73.1600693,
                    55.207684
                ],
                [
                    73.158802,
                    55.207188
                ],
                [
                    73.1576581,
                    55.2067624
                ],
                [
                    73.1524544,
                    55.2048036
                ],
                [
                    73.1519691,
                    55.2052615
                ],
                [
                    73.1507268,
                    55.206203
                ],
                [
                    73.1508821,
                    55.2062805
                ],
                [
                    73.1509856,
                    55.2062178
                ],
                [
                    73.1515874,
                    55.2065131
                ],
                [
                    73.1501186,
                    55.2075211
                ],
                [
                    73.1504743,
                    55.2076872
                ],
                [
                    73.1497885,
                    55.2081967
                ]
            ],
            "longitude": 73.1609436,
            "latitude": 55.2107482
        },
        "2443": {
            "name": "Новотроицкое",
            "population": 1181,
            "type": "village",
            "poly": null,
            "longitude": 73.161186,
            "latitude": 55.269352
        },
        "2444": {
            "name": "Десподзиновка",
            "population": 453,
            "type": "village",
            "poly": null,
            "longitude": 73.1702605,
            "latitude": 55.709365
        },
        "2445": {
            "name": "Коянбай",
            "population": 415,
            "type": "village",
            "poly": null,
            "longitude": 73.1729682,
            "latitude": 54.4501384
        },
        "2446": {
            "name": "Ребровка",
            "population": 466,
            "type": "village",
            "poly": [
                [
                    73.1692881,
                    54.9228008
                ],
                [
                    73.1725193,
                    54.9241271
                ],
                [
                    73.1717871,
                    54.9263314
                ],
                [
                    73.1720657,
                    54.9264366
                ],
                [
                    73.171811,
                    54.926958
                ],
                [
                    73.17162,
                    54.9271821
                ],
                [
                    73.1714608,
                    54.927493
                ],
                [
                    73.1714767,
                    54.9277811
                ],
                [
                    73.1713017,
                    54.9280006
                ],
                [
                    73.1708162,
                    54.9283756
                ],
                [
                    73.170076,
                    54.9287963
                ],
                [
                    73.169824,
                    54.9292656
                ],
                [
                    73.169702,
                    54.9297063
                ],
                [
                    73.1696622,
                    54.9304197
                ],
                [
                    73.169503,
                    54.9315629
                ],
                [
                    73.1696383,
                    54.9320704
                ],
                [
                    73.1701158,
                    54.9323448
                ],
                [
                    73.1726307,
                    54.9326877
                ],
                [
                    73.1732913,
                    54.93261
                ],
                [
                    73.1754878,
                    54.9310462
                ],
                [
                    73.1757903,
                    54.9308038
                ],
                [
                    73.1771353,
                    54.9292399
                ],
                [
                    73.1786793,
                    54.9273513
                ],
                [
                    73.1810191,
                    54.9244747
                ],
                [
                    73.1827063,
                    54.9245478
                ],
                [
                    73.1827541,
                    54.9241088
                ],
                [
                    73.1840354,
                    54.9241591
                ],
                [
                    73.1853962,
                    54.9244061
                ],
                [
                    73.1863752,
                    54.9244609
                ],
                [
                    73.1872507,
                    54.9245616
                ],
                [
                    73.1883012,
                    54.9246302
                ],
                [
                    73.1843776,
                    54.9220278
                ],
                [
                    73.1840911,
                    54.9219363
                ],
                [
                    73.1807803,
                    54.92136
                ],
                [
                    73.1811464,
                    54.9208798
                ],
                [
                    73.1812721,
                    54.9201042
                ],
                [
                    73.1816859,
                    54.9189561
                ],
                [
                    73.1820281,
                    54.9170075
                ],
                [
                    73.1833652,
                    54.9131192
                ],
                [
                    73.1841531,
                    54.9104337
                ],
                [
                    73.184742,
                    54.9079631
                ],
                [
                    73.1846863,
                    54.9066225
                ],
                [
                    73.1814233,
                    54.9063937
                ],
                [
                    73.1813278,
                    54.9066408
                ],
                [
                    73.178399,
                    54.9065996
                ],
                [
                    73.1742685,
                    54.9069702
                ],
                [
                    73.1727882,
                    54.9069245
                ],
                [
                    73.1725097,
                    54.9090246
                ],
                [
                    73.1801143,
                    54.9096057
                ],
                [
                    73.179115,
                    54.9141787
                ],
                [
                    73.1779112,
                    54.9175984
                ],
                [
                    73.1760512,
                    54.9198755
                ],
                [
                    73.1758761,
                    54.9198617
                ],
                [
                    73.1754703,
                    54.9204701
                ],
                [
                    73.1728758,
                    54.919999
                ],
                [
                    73.1723938,
                    54.9199254
                ],
                [
                    73.1719183,
                    54.9199125
                ],
                [
                    73.1709657,
                    54.9200081
                ],
                [
                    73.1692881,
                    54.9228008
                ]
            ],
            "longitude": 73.176346,
            "latitude": 54.921623
        },
        "2447": {
            "name": "Благодаровка",
            "population": 889,
            "type": "village",
            "poly": null,
            "longitude": 73.1813103,
            "latitude": 54.0728605
        },
        "2448": {
            "name": "Приветная",
            "population": 1225,
            "type": "village",
            "poly": [
                [
                    73.1765225,
                    54.9566788
                ],
                [
                    73.1779742,
                    54.9597662
                ],
                [
                    73.1779106,
                    54.959941
                ],
                [
                    73.1781926,
                    54.9600219
                ],
                [
                    73.1783336,
                    54.9602142
                ],
                [
                    73.1785273,
                    54.9604064
                ],
                [
                    73.1786331,
                    54.9607201
                ],
                [
                    73.1790385,
                    54.9611147
                ],
                [
                    73.1795142,
                    54.961226
                ],
                [
                    73.1800959,
                    54.9616104
                ],
                [
                    73.1806069,
                    54.9617116
                ],
                [
                    73.1810475,
                    54.9620657
                ],
                [
                    73.1826688,
                    54.9618735
                ],
                [
                    73.183127,
                    54.9618937
                ],
                [
                    73.1834795,
                    54.9619646
                ],
                [
                    73.1838672,
                    54.9619038
                ],
                [
                    73.1842196,
                    54.9619241
                ],
                [
                    73.1842549,
                    54.9621062
                ],
                [
                    73.1834266,
                    54.9623591
                ],
                [
                    73.1834266,
                    54.9625514
                ],
                [
                    73.1828979,
                    54.9628853
                ],
                [
                    73.1820168,
                    54.962946
                ],
                [
                    73.1818934,
                    54.9626424
                ],
                [
                    73.1811709,
                    54.962774
                ],
                [
                    73.1817877,
                    54.9648176
                ],
                [
                    73.1825807,
                    54.9656371
                ],
                [
                    73.1854897,
                    54.9656775
                ],
                [
                    73.1874133,
                    54.9681559
                ],
                [
                    73.1915518,
                    54.9670912
                ],
                [
                    73.192769,
                    54.966933
                ],
                [
                    73.1933303,
                    54.9667277
                ],
                [
                    73.1938675,
                    54.9664909
                ],
                [
                    73.1942997,
                    54.9661389
                ],
                [
                    73.1942662,
                    54.9659456
                ],
                [
                    73.1954756,
                    54.9656084
                ],
                [
                    73.1952699,
                    54.9653294
                ],
                [
                    73.19684,
                    54.9648636
                ],
                [
                    73.19467,
                    54.9617521
                ],
                [
                    73.1912331,
                    54.9580419
                ],
                [
                    73.1915571,
                    54.9576197
                ],
                [
                    73.1932393,
                    54.957126
                ],
                [
                    73.1946599,
                    54.9566037
                ],
                [
                    73.1944356,
                    54.9564105
                ],
                [
                    73.1948344,
                    54.9562173
                ],
                [
                    73.1937004,
                    54.9555662
                ],
                [
                    73.1933141,
                    54.9553801
                ],
                [
                    73.1893015,
                    54.9538059
                ],
                [
                    73.188367,
                    54.9533909
                ],
                [
                    73.1875944,
                    54.9528041
                ],
                [
                    73.1871956,
                    54.9526324
                ],
                [
                    73.1871956,
                    54.9531404
                ],
                [
                    73.1867843,
                    54.9538632
                ],
                [
                    73.1859619,
                    54.9548292
                ],
                [
                    73.185937,
                    54.9552835
                ],
                [
                    73.184292,
                    54.9553658
                ],
                [
                    73.1831581,
                    54.9556091
                ],
                [
                    73.1801522,
                    54.9562028
                ],
                [
                    73.1765225,
                    54.9566788
                ]
            ],
            "longitude": 73.1905037,
            "latitude": 54.9617136
        },
        "2449": {
            "name": "Харино",
            "population": 1373,
            "type": "village",
            "poly": [
                [
                    73.1889452,
                    55.1555531
                ],
                [
                    73.1889791,
                    55.1562174
                ],
                [
                    73.1893177,
                    55.1579716
                ],
                [
                    73.1894983,
                    55.1604029
                ],
                [
                    73.1897467,
                    55.161138
                ],
                [
                    73.1901982,
                    55.1618732
                ],
                [
                    73.1907513,
                    55.1625051
                ],
                [
                    73.1917447,
                    55.1638786
                ],
                [
                    73.19258,
                    55.1649168
                ],
                [
                    73.1933025,
                    55.1662386
                ],
                [
                    73.1940701,
                    55.1670833
                ],
                [
                    73.1975921,
                    55.1700749
                ],
                [
                    73.1982694,
                    55.1704811
                ],
                [
                    73.1985403,
                    55.1702877
                ],
                [
                    73.2038439,
                    55.1688157
                ],
                [
                    73.2026885,
                    55.1678334
                ],
                [
                    73.2023661,
                    55.1673884
                ],
                [
                    73.2016674,
                    55.1655926
                ],
                [
                    73.2014122,
                    55.1645182
                ],
                [
                    73.2007673,
                    55.1644721
                ],
                [
                    73.2010293,
                    55.1621045
                ],
                [
                    73.2015622,
                    55.1612573
                ],
                [
                    73.201254,
                    55.1567406
                ],
                [
                    73.1985741,
                    55.1567849
                ],
                [
                    73.197355,
                    55.1553983
                ],
                [
                    73.1997255,
                    55.1552306
                ],
                [
                    73.1995449,
                    55.1534246
                ],
                [
                    73.2000867,
                    55.1534117
                ],
                [
                    73.1996804,
                    55.1519669
                ],
                [
                    73.1994546,
                    55.1505608
                ],
                [
                    73.1984838,
                    55.1505479
                ],
                [
                    73.1984838,
                    55.1503544
                ],
                [
                    73.1976937,
                    55.1503285
                ],
                [
                    73.1976485,
                    55.1506769
                ],
                [
                    73.1964519,
                    55.150664
                ],
                [
                    73.1981677,
                    55.149877
                ],
                [
                    73.2001545,
                    55.1493223
                ],
                [
                    73.1991611,
                    55.1477999
                ],
                [
                    73.1947165,
                    55.1471002
                ],
                [
                    73.1943511,
                    55.1456731
                ],
                [
                    73.1909507,
                    55.1454268
                ],
                [
                    73.1889552,
                    55.1454525
                ],
                [
                    73.1898483,
                    55.1511348
                ],
                [
                    73.1894645,
                    55.1542696
                ],
                [
                    73.1889452,
                    55.1555531
                ]
            ],
            "longitude": 73.1947159,
            "latitude": 55.1582
        },
        "2450": {
            "name": "Генераловка",
            "population": 431,
            "type": "village",
            "poly": null,
            "longitude": 73.198631,
            "latitude": 54.24984
        },
        "2451": {
            "name": "Тайчи",
            "population": 495,
            "type": "village",
            "poly": null,
            "longitude": 73.2063277,
            "latitude": 57.3285298
        },
        "2452": {
            "name": "Ключи",
            "population": 3688,
            "type": "village",
            "poly": [
                [
                    73.2007673,
                    55.1644721
                ],
                [
                    73.2014121,
                    55.1645182
                ],
                [
                    73.2016674,
                    55.1655926
                ],
                [
                    73.2023661,
                    55.1673884
                ],
                [
                    73.2026884,
                    55.1678334
                ],
                [
                    73.2038439,
                    55.1688157
                ],
                [
                    73.205174,
                    55.168409
                ],
                [
                    73.2075386,
                    55.1679562
                ],
                [
                    73.2080492,
                    55.1678027
                ],
                [
                    73.208264,
                    55.1677951
                ],
                [
                    73.2096077,
                    55.1674421
                ],
                [
                    73.2100376,
                    55.1668282
                ],
                [
                    73.210266,
                    55.1645719
                ],
                [
                    73.2121334,
                    55.1645335
                ],
                [
                    73.2164963,
                    55.1643892
                ],
                [
                    73.2186919,
                    55.1645255
                ],
                [
                    73.2197722,
                    55.1641528
                ],
                [
                    73.2231744,
                    55.1629787
                ],
                [
                    73.2254619,
                    55.1641793
                ],
                [
                    73.2264722,
                    55.1627367
                ],
                [
                    73.2269071,
                    55.1623039
                ],
                [
                    73.2273939,
                    55.1621062
                ],
                [
                    73.23316,
                    55.1600625
                ],
                [
                    73.2399364,
                    55.1576619
                ],
                [
                    73.2415384,
                    55.1571034
                ],
                [
                    73.2404709,
                    55.1566407
                ],
                [
                    73.2394978,
                    55.1561921
                ],
                [
                    73.2382448,
                    55.1558179
                ],
                [
                    73.236976,
                    55.1554181
                ],
                [
                    73.2355931,
                    55.1551883
                ],
                [
                    73.2335911,
                    55.1550667
                ],
                [
                    73.2323393,
                    55.1552172
                ],
                [
                    73.2308872,
                    55.1554416
                ],
                [
                    73.2302527,
                    55.155495
                ],
                [
                    73.2294871,
                    55.1554068
                ],
                [
                    73.229316,
                    55.1547691
                ],
                [
                    73.2292292,
                    55.1545112
                ],
                [
                    73.2287778,
                    55.1533929
                ],
                [
                    73.2267543,
                    55.1496716
                ],
                [
                    73.2244626,
                    55.1457167
                ],
                [
                    73.2218436,
                    55.1460058
                ],
                [
                    73.2142049,
                    55.1477066
                ],
                [
                    73.2085998,
                    55.1476329
                ],
                [
                    73.2093054,
                    55.1514317
                ],
                [
                    73.2064338,
                    55.1515573
                ],
                [
                    73.2057926,
                    55.159579
                ],
                [
                    73.2036207,
                    55.1594862
                ],
                [
                    73.2022518,
                    55.1612641
                ],
                [
                    73.2010293,
                    55.1621045
                ],
                [
                    73.2007673,
                    55.1644721
                ]
            ],
            "longitude": 73.2161244,
            "latitude": 55.1539697
        },
        "2453": {
            "name": "Верхний Карбуш",
            "population": 505,
            "type": "village",
            "poly": null,
            "longitude": 73.226563,
            "latitude": 54.893501
        },
        "2454": {
            "name": "Нижняя Ильинка",
            "population": 447,
            "type": "village",
            "poly": null,
            "longitude": 73.236115,
            "latitude": 55.3786338
        },
        "2455": {
            "name": "Магистральный",
            "population": 2103,
            "type": "village",
            "poly": [
                [
                    73.2220035,
                    54.9279762
                ],
                [
                    73.2275588,
                    54.9298473
                ],
                [
                    73.2289304,
                    54.9367556
                ],
                [
                    73.2380166,
                    54.9357692
                ],
                [
                    73.2426912,
                    54.935006
                ],
                [
                    73.2456865,
                    54.9350924
                ],
                [
                    73.248655,
                    54.927492
                ],
                [
                    73.2479182,
                    54.9266213
                ],
                [
                    73.2412689,
                    54.9229664
                ],
                [
                    73.2401975,
                    54.9233964
                ],
                [
                    73.2367102,
                    54.9222788
                ],
                [
                    73.2320094,
                    54.9271651
                ],
                [
                    73.2280237,
                    54.9274037
                ],
                [
                    73.2233321,
                    54.9268311
                ],
                [
                    73.2220035,
                    54.9279762
                ]
            ],
            "longitude": 73.243011,
            "latitude": 54.928009
        },
        "2456": {
            "name": "Путинцево",
            "population": 389,
            "type": "village",
            "poly": null,
            "longitude": 73.249901,
            "latitude": 54.79686
        },
        "2457": {
            "name": "Нижнеиртышское",
            "population": 1484,
            "type": "village",
            "poly": null,
            "longitude": 73.2513897,
            "latitude": 55.445982
        },
        "2458": {
            "name": "Зелёное Поле",
            "population": 286,
            "type": "village",
            "poly": null,
            "longitude": 73.2519294,
            "latitude": 54.5218489
        },
        "2459": {
            "name": "Надеждино",
            "population": 1840,
            "type": "village",
            "poly": [
                [
                    73.2300241,
                    55.1883532
                ],
                [
                    73.2302151,
                    55.1888329
                ],
                [
                    73.2310809,
                    55.1901849
                ],
                [
                    73.2318576,
                    55.1911152
                ],
                [
                    73.2325834,
                    55.1915731
                ],
                [
                    73.2326216,
                    55.1921037
                ],
                [
                    73.233029,
                    55.1923653
                ],
                [
                    73.2334365,
                    55.1922927
                ],
                [
                    73.2334237,
                    55.1925034
                ],
                [
                    73.2332327,
                    55.192736
                ],
                [
                    73.23322,
                    55.1930994
                ],
                [
                    73.2335383,
                    55.1937462
                ],
                [
                    73.2335638,
                    55.194175
                ],
                [
                    73.2338439,
                    55.1943931
                ],
                [
                    73.233793,
                    55.1945675
                ],
                [
                    73.2341622,
                    55.1949381
                ],
                [
                    73.2360339,
                    55.1951998
                ],
                [
                    73.2378801,
                    55.1949454
                ],
                [
                    73.2388859,
                    55.1949163
                ],
                [
                    73.2389751,
                    55.1947855
                ],
                [
                    73.238835,
                    55.1945311
                ],
                [
                    73.2382621,
                    55.1941678
                ],
                [
                    73.2376891,
                    55.194066
                ],
                [
                    73.2373835,
                    55.1938916
                ],
                [
                    73.237218,
                    55.1935355
                ],
                [
                    73.2373071,
                    55.193332
                ],
                [
                    73.2374599,
                    55.1933756
                ],
                [
                    73.2375618,
                    55.1937462
                ],
                [
                    73.2379565,
                    55.1939861
                ],
                [
                    73.2383894,
                    55.1940733
                ],
                [
                    73.2394207,
                    55.1945311
                ],
                [
                    73.2404011,
                    55.1943713
                ],
                [
                    73.2405284,
                    55.1944585
                ],
                [
                    73.2400446,
                    55.1948364
                ],
                [
                    73.2404138,
                    55.1947782
                ],
                [
                    73.2410759,
                    55.1949745
                ],
                [
                    73.2417635,
                    55.1949381
                ],
                [
                    73.2422219,
                    55.1950399
                ],
                [
                    73.242642,
                    55.1949963
                ],
                [
                    73.2429349,
                    55.1943495
                ],
                [
                    73.2430877,
                    55.1943858
                ],
                [
                    73.2430113,
                    55.1948146
                ],
                [
                    73.2434824,
                    55.1949309
                ],
                [
                    73.2434187,
                    55.1952288
                ],
                [
                    73.2436861,
                    55.1953669
                ],
                [
                    73.2438898,
                    55.1955922
                ],
                [
                    73.2455322,
                    55.196457
                ],
                [
                    73.2456469,
                    55.1963843
                ],
                [
                    73.2462326,
                    55.1967041
                ],
                [
                    73.2464745,
                    55.1965878
                ],
                [
                    73.2468565,
                    55.1961954
                ],
                [
                    73.2471621,
                    55.1961227
                ],
                [
                    73.2484608,
                    55.196675
                ],
                [
                    73.248499,
                    55.1968276
                ],
                [
                    73.2481552,
                    55.1968422
                ],
                [
                    73.2476841,
                    55.1966605
                ],
                [
                    73.2474931,
                    55.1967114
                ],
                [
                    73.2470984,
                    55.1969585
                ],
                [
                    73.2468437,
                    55.1969657
                ],
                [
                    73.2466655,
                    55.1970602
                ],
                [
                    73.2470984,
                    55.1973218
                ],
                [
                    73.2473021,
                    55.1973218
                ],
                [
                    73.2477478,
                    55.1969875
                ],
                [
                    73.2479897,
                    55.196973
                ],
                [
                    73.2483589,
                    55.1970602
                ],
                [
                    73.2484353,
                    55.1971474
                ],
                [
                    73.2478369,
                    55.1971983
                ],
                [
                    73.2474422,
                    55.1974454
                ],
                [
                    73.2482189,
                    55.1979177
                ],
                [
                    73.2484226,
                    55.1978886
                ],
                [
                    73.2484481,
                    55.1977869
                ],
                [
                    73.249021,
                    55.1977506
                ],
                [
                    73.2491611,
                    55.1978523
                ],
                [
                    73.2487282,
                    55.1980412
                ],
                [
                    73.248779,
                    55.1981284
                ],
                [
                    73.2492375,
                    55.1983828
                ],
                [
                    73.249594,
                    55.1983755
                ],
                [
                    73.2497213,
                    55.1984555
                ],
                [
                    73.2496576,
                    55.1987534
                ],
                [
                    73.2498358,
                    55.1988479
                ],
                [
                    73.2501033,
                    55.1987316
                ],
                [
                    73.2502051,
                    55.1987897
                ],
                [
                    73.2499887,
                    55.1990804
                ],
                [
                    73.2505489,
                    55.1993347
                ],
                [
                    73.2510964,
                    55.1989859
                ],
                [
                    73.2514402,
                    55.1989278
                ],
                [
                    73.2515293,
                    55.1990731
                ],
                [
                    73.2513001,
                    55.1991821
                ],
                [
                    73.2516184,
                    55.1991894
                ],
                [
                    73.2516821,
                    55.1992766
                ],
                [
                    73.2513256,
                    55.1994946
                ],
                [
                    73.2516566,
                    55.1995019
                ],
                [
                    73.251733,
                    55.1995818
                ],
                [
                    73.251593,
                    55.1996399
                ],
                [
                    73.2513256,
                    55.1995818
                ],
                [
                    73.2509309,
                    55.1997344
                ],
                [
                    73.2509182,
                    55.1998507
                ],
                [
                    73.2512365,
                    55.2001413
                ],
                [
                    73.2531718,
                    55.2003811
                ],
                [
                    73.2540758,
                    55.2001341
                ],
                [
                    73.2544451,
                    55.1999306
                ],
                [
                    73.2546997,
                    55.1999379
                ],
                [
                    73.2557774,
                    55.1985939
                ],
                [
                    73.256514,
                    55.1987651
                ],
                [
                    73.2570486,
                    55.1990478
                ],
                [
                    73.2582416,
                    55.1995538
                ],
                [
                    73.2617619,
                    55.2005695
                ],
                [
                    73.2633004,
                    55.2000784
                ],
                [
                    73.26405,
                    55.1996282
                ],
                [
                    73.2649888,
                    55.1987576
                ],
                [
                    73.2654582,
                    55.1980172
                ],
                [
                    73.2658884,
                    55.1981288
                ],
                [
                    73.2703214,
                    55.1988395
                ],
                [
                    73.2712796,
                    55.1989213
                ],
                [
                    73.2731245,
                    55.1989102
                ],
                [
                    73.2793704,
                    55.1984819
                ],
                [
                    73.2736285,
                    55.1924141
                ],
                [
                    73.2723711,
                    55.1889889
                ],
                [
                    73.2685449,
                    55.1892326
                ],
                [
                    73.2498605,
                    55.1898897
                ],
                [
                    73.2496102,
                    55.1899659
                ],
                [
                    73.2493599,
                    55.1902003
                ],
                [
                    73.2432659,
                    55.1905556
                ],
                [
                    73.2351426,
                    55.1890074
                ],
                [
                    73.2343405,
                    55.1883896
                ],
                [
                    73.2335765,
                    55.188375
                ],
                [
                    73.23322,
                    55.1883169
                ],
                [
                    73.2326216,
                    55.1882951
                ],
                [
                    73.2323797,
                    55.1883823
                ],
                [
                    73.2321123,
                    55.1883241
                ],
                [
                    73.2316666,
                    55.1883677
                ],
                [
                    73.2310427,
                    55.1885567
                ],
                [
                    73.2304824,
                    55.1883459
                ],
                [
                    73.2300241,
                    55.1883532
                ]
            ],
            "longitude": 73.2572752,
            "latitude": 55.1942334
        },
        "2460": {
            "name": "Талбакуль",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 73.2637681,
            "latitude": 56.3503205
        },
        "2461": {
            "name": "Ганновка",
            "population": 790,
            "type": "village",
            "poly": null,
            "longitude": 73.2640887,
            "latitude": 54.1086972
        },
        "2462": {
            "name": "Неверовка",
            "population": 1039,
            "type": "village",
            "poly": null,
            "longitude": 73.2961905,
            "latitude": 54.4574244
        },
        "2463": {
            "name": "Троицкое",
            "population": 3793,
            "type": "village",
            "poly": [
                [
                    73.2903748,
                    54.8528146
                ],
                [
                    73.2908917,
                    54.8546232
                ],
                [
                    73.292473,
                    54.8590106
                ],
                [
                    73.2937494,
                    54.8616406
                ],
                [
                    73.2957516,
                    54.8657273
                ],
                [
                    73.2967953,
                    54.867699
                ],
                [
                    73.2979339,
                    54.8694461
                ],
                [
                    73.300095,
                    54.8732556
                ],
                [
                    73.3045121,
                    54.8730433
                ],
                [
                    73.3071582,
                    54.8725035
                ],
                [
                    73.307738,
                    54.8729706
                ],
                [
                    73.3076853,
                    54.8732496
                ],
                [
                    73.3073901,
                    54.8734558
                ],
                [
                    73.3073796,
                    54.8736985
                ],
                [
                    73.3074534,
                    54.8738865
                ],
                [
                    73.3073796,
                    54.874396
                ],
                [
                    73.3071898,
                    54.8749601
                ],
                [
                    73.3069474,
                    54.8753301
                ],
                [
                    73.306979,
                    54.8757062
                ],
                [
                    73.3073058,
                    54.8760458
                ],
                [
                    73.3072636,
                    54.8766948
                ],
                [
                    73.3076642,
                    54.8767555
                ],
                [
                    73.3079489,
                    54.8766766
                ],
                [
                    73.3081492,
                    54.8769071
                ],
                [
                    73.3084233,
                    54.8769192
                ],
                [
                    73.3084865,
                    54.8770223
                ],
                [
                    73.3081492,
                    54.8772164
                ],
                [
                    73.3072847,
                    54.8779624
                ],
                [
                    73.3077907,
                    54.8791694
                ],
                [
                    73.3075272,
                    54.8793089
                ],
                [
                    73.3084127,
                    54.8815286
                ],
                [
                    73.3091275,
                    54.8814437
                ],
                [
                    73.3103543,
                    54.8814326
                ],
                [
                    73.3125166,
                    54.88049
                ],
                [
                    73.3152665,
                    54.8794724
                ],
                [
                    73.3132199,
                    54.8765109
                ],
                [
                    73.3118466,
                    54.8626816
                ],
                [
                    73.3116807,
                    54.860515
                ],
                [
                    73.3114767,
                    54.8578513
                ],
                [
                    73.3125165,
                    54.851899
                ],
                [
                    73.306167,
                    54.8524496
                ],
                [
                    73.3011548,
                    54.8524848
                ],
                [
                    73.2903748,
                    54.8528146
                ]
            ],
            "longitude": 73.296219,
            "latitude": 54.858746
        },
        "2464": {
            "name": "Новоомский",
            "population": 4946,
            "type": "village",
            "poly": [
                [
                    73.2873056,
                    54.8437729
                ],
                [
                    73.2873056,
                    54.8445917
                ],
                [
                    73.2873857,
                    54.8452692
                ],
                [
                    73.2880717,
                    54.8478697
                ],
                [
                    73.2893035,
                    54.8522775
                ],
                [
                    73.2895856,
                    54.8522888
                ],
                [
                    73.2897459,
                    54.8525725
                ],
                [
                    73.2903748,
                    54.8528146
                ],
                [
                    73.3011548,
                    54.8524848
                ],
                [
                    73.306167,
                    54.8524496
                ],
                [
                    73.3065948,
                    54.851584
                ],
                [
                    73.3066926,
                    54.8501412
                ],
                [
                    73.3085875,
                    54.8467347
                ],
                [
                    73.3108124,
                    54.8427647
                ],
                [
                    73.3116741,
                    54.8410293
                ],
                [
                    73.3127039,
                    54.8395151
                ],
                [
                    73.3109762,
                    54.8387699
                ],
                [
                    73.3108307,
                    54.8383105
                ],
                [
                    73.3109465,
                    54.8378009
                ],
                [
                    73.3110843,
                    54.837196
                ],
                [
                    73.317001,
                    54.829029
                ],
                [
                    73.31729,
                    54.8281058
                ],
                [
                    73.3171605,
                    54.8273301
                ],
                [
                    73.3168757,
                    54.8267184
                ],
                [
                    73.3163189,
                    54.8260173
                ],
                [
                    73.3151147,
                    54.82507
                ],
                [
                    73.3130559,
                    54.8242122
                ],
                [
                    73.3112432,
                    54.8239958
                ],
                [
                    73.3086923,
                    54.824063
                ],
                [
                    73.3061674,
                    54.8242942
                ],
                [
                    73.3025677,
                    54.8243613
                ],
                [
                    73.3013765,
                    54.824615
                ],
                [
                    73.3001075,
                    54.8258681
                ],
                [
                    73.3065947,
                    54.8271361
                ],
                [
                    73.3050409,
                    54.8295378
                ],
                [
                    73.3097164,
                    54.8304879
                ],
                [
                    73.3055834,
                    54.8368845
                ],
                [
                    73.3038719,
                    54.8366873
                ],
                [
                    73.3029184,
                    54.836638
                ],
                [
                    73.3025761,
                    54.8365747
                ],
                [
                    73.3021482,
                    54.8362508
                ],
                [
                    73.3011213,
                    54.8360959
                ],
                [
                    73.301647,
                    54.8344696
                ],
                [
                    73.3016512,
                    54.834393
                ],
                [
                    73.3015072,
                    54.834238
                ],
                [
                    73.2943214,
                    54.8326195
                ],
                [
                    73.287566,
                    54.8431501
                ],
                [
                    73.2873857,
                    54.8435105
                ],
                [
                    73.2873056,
                    54.8437729
                ]
            ],
            "longitude": 73.299973,
            "latitude": 54.841866
        },
        "2465": {
            "name": "Калачево",
            "population": 293,
            "type": "village",
            "poly": [
                [
                    73.3154498,
                    54.7698033
                ],
                [
                    73.3213972,
                    54.7690834
                ],
                [
                    73.3226956,
                    54.7688839
                ],
                [
                    73.3238806,
                    54.7686909
                ],
                [
                    73.325746,
                    54.7683278
                ],
                [
                    73.3266702,
                    54.7682264
                ],
                [
                    73.3304237,
                    54.7679059
                ],
                [
                    73.3322551,
                    54.7676704
                ],
                [
                    73.3357535,
                    54.7675297
                ],
                [
                    73.3355437,
                    54.7641343
                ],
                [
                    73.3221003,
                    54.7646643
                ],
                [
                    73.3201158,
                    54.7647264
                ],
                [
                    73.3193107,
                    54.7647853
                ],
                [
                    73.3185679,
                    54.7649456
                ],
                [
                    73.3180633,
                    54.765096
                ],
                [
                    73.3172638,
                    54.7654591
                ],
                [
                    73.3165438,
                    54.7658877
                ],
                [
                    73.3160108,
                    54.7662638
                ],
                [
                    73.315699,
                    54.7665484
                ],
                [
                    73.3155289,
                    54.766905
                ],
                [
                    73.3154498,
                    54.7698033
                ]
            ],
            "longitude": 73.3245357,
            "latitude": 54.7678238
        },
        "2466": {
            "name": "Крайчиково",
            "population": 572,
            "type": "village",
            "poly": null,
            "longitude": 73.3252131,
            "latitude": 56.2686025
        },
        "2467": {
            "name": "Калинино",
            "population": 785,
            "type": "village",
            "poly": null,
            "longitude": 73.3300684,
            "latitude": 53.6216534
        },
        "2468": {
            "name": "Кошкарево",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 73.330505,
            "latitude": 54.742424
        },
        "2469": {
            "name": "Увальная Бития",
            "population": 601,
            "type": "village",
            "poly": null,
            "longitude": 73.3333903,
            "latitude": 55.4905023
        },
        "2470": {
            "name": "Дачный",
            "population": 461,
            "type": "village",
            "poly": [
                [
                    73.3416785,
                    55.2520013
                ],
                [
                    73.3418991,
                    55.2520699
                ],
                [
                    73.341879,
                    55.2526585
                ],
                [
                    73.3427513,
                    55.2526728
                ],
                [
                    73.3429067,
                    55.2527557
                ],
                [
                    73.3429168,
                    55.2529214
                ],
                [
                    73.3434482,
                    55.2529528
                ],
                [
                    73.3434632,
                    55.2531957
                ],
                [
                    73.3439494,
                    55.2535386
                ],
                [
                    73.3442503,
                    55.2535329
                ],
                [
                    73.3442754,
                    55.25387
                ],
                [
                    73.3447366,
                    55.2541643
                ],
                [
                    73.3461303,
                    55.2543101
                ],
                [
                    73.346391,
                    55.2543129
                ],
                [
                    73.346752,
                    55.2542843
                ],
                [
                    73.346752,
                    55.2546101
                ],
                [
                    73.3470077,
                    55.2549044
                ],
                [
                    73.3481657,
                    55.2547358
                ],
                [
                    73.3477094,
                    55.2541643
                ],
                [
                    73.3480605,
                    55.2541615
                ],
                [
                    73.3482811,
                    55.2542529
                ],
                [
                    73.3491534,
                    55.2540958
                ],
                [
                    73.3502996,
                    55.2537672
                ],
                [
                    73.3504669,
                    55.2531786
                ],
                [
                    73.3504276,
                    55.252311
                ],
                [
                    73.3499054,
                    55.2509269
                ],
                [
                    73.3497951,
                    55.2508469
                ],
                [
                    73.3495494,
                    55.2508412
                ],
                [
                    73.349399,
                    55.2506726
                ],
                [
                    73.3489127,
                    55.2506726
                ],
                [
                    73.3485718,
                    55.250784
                ],
                [
                    73.3484515,
                    55.2502925
                ],
                [
                    73.347138,
                    55.2502125
                ],
                [
                    73.3455087,
                    55.2502068
                ],
                [
                    73.3453983,
                    55.2512412
                ],
                [
                    73.3459148,
                    55.2513555
                ],
                [
                    73.3458847,
                    55.2518327
                ],
                [
                    73.3461954,
                    55.2519242
                ],
                [
                    73.3461755,
                    55.2524814
                ],
                [
                    73.343734,
                    55.2520527
                ],
                [
                    73.342681,
                    55.2519327
                ],
                [
                    73.3417286,
                    55.2519127
                ],
                [
                    73.3416785,
                    55.2520013
                ]
            ],
            "longitude": 73.346344,
            "latitude": 55.251934
        },
        "2471": {
            "name": "Омский",
            "population": 1628,
            "type": "village",
            "poly": null,
            "longitude": 73.3482544,
            "latitude": 55.1042423
        },
        "2472": {
            "name": "Липов Кут",
            "population": 397,
            "type": "village",
            "poly": null,
            "longitude": 73.3644624,
            "latitude": 54.2244444
        },
        "2473": {
            "name": "Круч",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 73.368927,
            "latitude": 54.749557
        },
        "2474": {
            "name": "Звонарёв Кут",
            "population": 1273,
            "type": "village",
            "poly": null,
            "longitude": 73.372215,
            "latitude": 54.691441
        },
        "2475": {
            "name": "Усть-Шиш",
            "population": 517,
            "type": "village",
            "poly": null,
            "longitude": 73.3777302,
            "latitude": 57.3250962
        },
        "2476": {
            "name": "Юрьевка",
            "population": 998,
            "type": "village",
            "poly": null,
            "longitude": 73.391388,
            "latitude": 54.025852
        },
        "2477": {
            "name": "Гауф",
            "population": 1212,
            "type": "village",
            "poly": null,
            "longitude": 73.392029,
            "latitude": 54.785969
        },
        "2478": {
            "name": "Березянка",
            "population": 403,
            "type": "village",
            "poly": [
                [
                    73.388817,
                    55.1846618
                ],
                [
                    73.3896637,
                    55.1900061
                ],
                [
                    73.3900557,
                    55.1896391
                ],
                [
                    73.3908241,
                    55.1892989
                ],
                [
                    73.3914983,
                    55.1891646
                ],
                [
                    73.3924078,
                    55.1891736
                ],
                [
                    73.3933173,
                    55.1892989
                ],
                [
                    73.3943208,
                    55.1893347
                ],
                [
                    73.3951519,
                    55.189281
                ],
                [
                    73.3963749,
                    55.1890841
                ],
                [
                    73.3970962,
                    55.1889677
                ],
                [
                    73.3994326,
                    55.1887976
                ],
                [
                    73.4004205,
                    55.1886276
                ],
                [
                    73.4007341,
                    55.1886365
                ],
                [
                    73.4013456,
                    55.1888782
                ],
                [
                    73.4008595,
                    55.1882963
                ],
                [
                    73.4008752,
                    55.1880099
                ],
                [
                    73.4009693,
                    55.1878488
                ],
                [
                    73.4014554,
                    55.1875444
                ],
                [
                    73.4005302,
                    55.184814
                ],
                [
                    73.4002323,
                    55.1844917
                ],
                [
                    73.4001382,
                    55.1841247
                ],
                [
                    73.3998717,
                    55.1841157
                ],
                [
                    73.3996835,
                    55.1836412
                ],
                [
                    73.3964377,
                    55.1839277
                ],
                [
                    73.3953557,
                    55.1825758
                ],
                [
                    73.3939602,
                    55.1826743
                ],
                [
                    73.3939131,
                    55.1829071
                ],
                [
                    73.3937406,
                    55.1830056
                ],
                [
                    73.3933016,
                    55.1830056
                ],
                [
                    73.3932859,
                    55.182925
                ],
                [
                    73.3926116,
                    55.182916
                ],
                [
                    73.3925489,
                    55.1829966
                ],
                [
                    73.3927685,
                    55.1831936
                ],
                [
                    73.3927841,
                    55.1833726
                ],
                [
                    73.3926116,
                    55.1834801
                ],
                [
                    73.3926116,
                    55.1836502
                ],
                [
                    73.392988,
                    55.1838829
                ],
                [
                    73.3927685,
                    55.1844559
                ],
                [
                    73.3912631,
                    55.1845454
                ],
                [
                    73.3905105,
                    55.1846618
                ],
                [
                    73.388817,
                    55.1846618
                ]
            ],
            "longitude": 73.3966752,
            "latitude": 55.1857769
        },
        "2479": {
            "name": "Богодуховка",
            "population": 1014,
            "type": "village",
            "poly": null,
            "longitude": 73.400829,
            "latitude": 54.0784257
        },
        "2480": {
            "name": "Строкино",
            "population": 826,
            "type": "village",
            "poly": null,
            "longitude": 73.4055615,
            "latitude": 56.3653482
        },
        "2481": {
            "name": "Новобелозёровка",
            "population": 393,
            "type": "village",
            "poly": null,
            "longitude": 73.4247063,
            "latitude": 54.5829778
        },
        "2482": {
            "name": "Завьялово",
            "population": 840,
            "type": "village",
            "poly": null,
            "longitude": 73.4359584,
            "latitude": 57.1461496
        },
        "2483": {
            "name": "Покровка",
            "population": 1262,
            "type": "village",
            "poly": [
                [
                    73.432503,
                    55.3767479
                ],
                [
                    73.4335581,
                    55.3787181
                ],
                [
                    73.4330339,
                    55.378909
                ],
                [
                    73.4341427,
                    55.3788784
                ],
                [
                    73.4344921,
                    55.3794015
                ],
                [
                    73.4340822,
                    55.379623
                ],
                [
                    73.4332489,
                    55.3799284
                ],
                [
                    73.4329427,
                    55.3802515
                ],
                [
                    73.4334573,
                    55.3813372
                ],
                [
                    73.432817,
                    55.3816151
                ],
                [
                    73.4332108,
                    55.382316
                ],
                [
                    73.4334076,
                    55.3829498
                ],
                [
                    73.4342394,
                    55.3848843
                ],
                [
                    73.4349046,
                    55.3850638
                ],
                [
                    73.4349718,
                    55.385373
                ],
                [
                    73.434871,
                    55.3855829
                ],
                [
                    73.4346169,
                    55.3857356
                ],
                [
                    73.4358194,
                    55.3875333
                ],
                [
                    73.4367955,
                    55.3871949
                ],
                [
                    73.4385189,
                    55.3867581
                ],
                [
                    73.4416542,
                    55.3862277
                ],
                [
                    73.448105,
                    55.3852678
                ],
                [
                    73.4464041,
                    55.381206
                ],
                [
                    73.4433433,
                    55.3739665
                ],
                [
                    73.4428594,
                    55.3726835
                ],
                [
                    73.4424347,
                    55.372213
                ],
                [
                    73.4389817,
                    55.3706631
                ],
                [
                    73.4381284,
                    55.3707686
                ],
                [
                    73.4382843,
                    55.3711994
                ],
                [
                    73.4379241,
                    55.3711688
                ],
                [
                    73.4370789,
                    55.3712503
                ],
                [
                    73.436677,
                    55.3713817
                ],
                [
                    73.4365036,
                    55.3713254
                ],
                [
                    73.4356817,
                    55.3714086
                ],
                [
                    73.4352441,
                    55.371382
                ],
                [
                    73.4352303,
                    55.3716025
                ],
                [
                    73.435232,
                    55.3724228
                ],
                [
                    73.4355209,
                    55.3733252
                ],
                [
                    73.4357018,
                    55.3739529
                ],
                [
                    73.4361251,
                    55.374434
                ],
                [
                    73.4365956,
                    55.3755681
                ],
                [
                    73.4354061,
                    55.3761867
                ],
                [
                    73.4350701,
                    55.3763088
                ],
                [
                    73.4346197,
                    55.3763585
                ],
                [
                    73.4335916,
                    55.3764081
                ],
                [
                    73.432503,
                    55.3767479
                ]
            ],
            "longitude": 73.4397136,
            "latitude": 55.378315
        },
        "2484": {
            "name": "Лежанка",
            "population": 851,
            "type": "village",
            "poly": [
                [
                    73.4231579,
                    55.465044
                ],
                [
                    73.4340017,
                    55.470356
                ],
                [
                    73.4448251,
                    55.4740206
                ],
                [
                    73.4514337,
                    55.4701704
                ],
                [
                    73.4545027,
                    55.4675029
                ],
                [
                    73.4550347,
                    55.4660879
                ],
                [
                    73.4571215,
                    55.4644872
                ],
                [
                    73.4533509,
                    55.4641344
                ],
                [
                    73.4531523,
                    55.4641625
                ],
                [
                    73.4515565,
                    55.4647192
                ],
                [
                    73.4483647,
                    55.4633273
                ],
                [
                    73.4471779,
                    55.4622137
                ],
                [
                    73.4400579,
                    55.4606361
                ],
                [
                    73.4390758,
                    55.4601025
                ],
                [
                    73.4258586,
                    55.4628633
                ],
                [
                    73.4231579,
                    55.465044
                ]
            ],
            "longitude": 73.441528,
            "latitude": 55.466969
        },
        "2485": {
            "name": "Пушкино",
            "population": 2203,
            "type": "village",
            "poly": [
                [
                    73.4507048,
                    55.0843272
                ],
                [
                    73.4516204,
                    55.0848294
                ],
                [
                    73.4561373,
                    55.0825104
                ],
                [
                    73.4591249,
                    55.0864149
                ],
                [
                    73.4595565,
                    55.0866619
                ],
                [
                    73.4632467,
                    55.0910711
                ],
                [
                    73.4613045,
                    55.0916516
                ],
                [
                    73.4611535,
                    55.0922197
                ],
                [
                    73.461024,
                    55.0922938
                ],
                [
                    73.4583264,
                    55.0930841
                ],
                [
                    73.4600959,
                    55.0954305
                ],
                [
                    73.4567725,
                    55.0962702
                ],
                [
                    73.458499,
                    55.098678
                ],
                [
                    73.4649085,
                    55.0972457
                ],
                [
                    73.4662034,
                    55.0989373
                ],
                [
                    73.4680809,
                    55.0984681
                ],
                [
                    73.4676924,
                    55.0978137
                ],
                [
                    73.4683614,
                    55.0976532
                ],
                [
                    73.4687067,
                    55.0971963
                ],
                [
                    73.4692031,
                    55.0970975
                ],
                [
                    73.4689225,
                    55.0966159
                ],
                [
                    73.4694179,
                    55.0962599
                ],
                [
                    73.4701962,
                    55.0971418
                ],
                [
                    73.4706082,
                    55.097395
                ],
                [
                    73.4708371,
                    55.0975172
                ],
                [
                    73.4713101,
                    55.0980149
                ],
                [
                    73.4716916,
                    55.0978927
                ],
                [
                    73.4731566,
                    55.0994556
                ],
                [
                    73.4751709,
                    55.1011581
                ],
                [
                    73.4765138,
                    55.1018303
                ],
                [
                    73.4779482,
                    55.1020573
                ],
                [
                    73.4799084,
                    55.1026985
                ],
                [
                    73.4808323,
                    55.1025375
                ],
                [
                    73.4817326,
                    55.1032533
                ],
                [
                    73.4824041,
                    55.1036287
                ],
                [
                    73.4841132,
                    55.1033145
                ],
                [
                    73.4844794,
                    55.1031049
                ],
                [
                    73.4862495,
                    55.1026597
                ],
                [
                    73.4864632,
                    55.1029041
                ],
                [
                    73.4864632,
                    55.10307
                ],
                [
                    73.4927502,
                    55.1029303
                ],
                [
                    73.4953139,
                    55.1023192
                ],
                [
                    73.483106,
                    55.096225
                ],
                [
                    73.481458,
                    55.0943825
                ],
                [
                    73.4811528,
                    55.0939023
                ],
                [
                    73.4826786,
                    55.0930989
                ],
                [
                    73.4751861,
                    55.0869858
                ],
                [
                    73.4741637,
                    55.0875185
                ],
                [
                    73.4723478,
                    55.0863395
                ],
                [
                    73.4669153,
                    55.0820946
                ],
                [
                    73.4611776,
                    55.0783909
                ],
                [
                    73.4507048,
                    55.0843272
                ]
            ],
            "longitude": 73.4717054,
            "latitude": 55.0936844
        },
        "2486": {
            "name": "Щербаки",
            "population": 752,
            "type": "village",
            "poly": null,
            "longitude": 73.4730222,
            "latitude": 56.0159916
        },
        "2487": {
            "name": "Хлебодаровка",
            "population": 809,
            "type": "village",
            "poly": null,
            "longitude": 73.4765923,
            "latitude": 53.7719396
        },
        "2488": {
            "name": "Черниговка",
            "population": 309,
            "type": "village",
            "poly": null,
            "longitude": 73.482519,
            "latitude": 54.5879809
        },
        "2489": {
            "name": "Шухово",
            "population": 721,
            "type": "village",
            "poly": null,
            "longitude": 73.4837348,
            "latitude": 57.2346138
        },
        "2490": {
            "name": "Явлено-Покровка",
            "population": 498,
            "type": "village",
            "poly": null,
            "longitude": 73.5123445,
            "latitude": 54.1137072
        },
        "2491": {
            "name": "Новоягодное",
            "population": 427,
            "type": "village",
            "poly": null,
            "longitude": 73.5136779,
            "latitude": 57.3544341
        },
        "2492": {
            "name": "Ракитинка",
            "population": 1369,
            "type": "village",
            "poly": [
                [
                    73.5045982,
                    54.8974903
                ],
                [
                    73.5055944,
                    54.8984689
                ],
                [
                    73.5068292,
                    54.8995787
                ],
                [
                    73.5072132,
                    54.8997756
                ],
                [
                    73.5076075,
                    54.899889
                ],
                [
                    73.508064,
                    54.8999666
                ],
                [
                    73.5085414,
                    54.8999964
                ],
                [
                    73.5091743,
                    54.8999427
                ],
                [
                    73.5172785,
                    54.8992326
                ],
                [
                    73.5169465,
                    54.8996086
                ],
                [
                    73.516355,
                    54.9005393
                ],
                [
                    73.5154089,
                    54.9023831
                ],
                [
                    73.519582,
                    54.9029669
                ],
                [
                    73.5218244,
                    54.9042976
                ],
                [
                    73.5244203,
                    54.9032032
                ],
                [
                    73.5256237,
                    54.9035238
                ],
                [
                    73.5283385,
                    54.9040427
                ],
                [
                    73.53098,
                    54.9044055
                ],
                [
                    73.532252,
                    54.9045785
                ],
                [
                    73.5367451,
                    54.905014
                ],
                [
                    73.5391421,
                    54.9008257
                ],
                [
                    73.5413938,
                    54.9010883
                ],
                [
                    73.5419438,
                    54.8997458
                ],
                [
                    73.5394015,
                    54.8994057
                ],
                [
                    73.5395987,
                    54.896637
                ],
                [
                    73.5384572,
                    54.895366
                ],
                [
                    73.5320652,
                    54.8937727
                ],
                [
                    73.5331236,
                    54.8925553
                ],
                [
                    73.533601,
                    54.891684
                ],
                [
                    73.5304984,
                    54.8907411
                ],
                [
                    73.5274684,
                    54.8901622
                ],
                [
                    73.5260364,
                    54.8903711
                ],
                [
                    73.5256732,
                    54.8909559
                ],
                [
                    73.5252062,
                    54.8913856
                ],
                [
                    73.5247808,
                    54.8916721
                ],
                [
                    73.5239299,
                    54.8921018
                ],
                [
                    73.523463,
                    54.8925613
                ],
                [
                    73.5218339,
                    54.8928537
                ],
                [
                    73.5206198,
                    54.8935459
                ],
                [
                    73.520599,
                    54.8950259
                ],
                [
                    73.5202981,
                    54.8951035
                ],
                [
                    73.5193019,
                    54.8941009
                ],
                [
                    73.519717,
                    54.8939338
                ],
                [
                    73.5194367,
                    54.8937727
                ],
                [
                    73.5189699,
                    54.8936116
                ],
                [
                    73.5184821,
                    54.8937429
                ],
                [
                    73.5181086,
                    54.8934982
                ],
                [
                    73.5171021,
                    54.8938861
                ],
                [
                    73.5165935,
                    54.8937548
                ],
                [
                    73.5159192,
                    54.8941725
                ],
                [
                    73.5156597,
                    54.8943933
                ],
                [
                    73.5152551,
                    54.8951035
                ],
                [
                    73.5155871,
                    54.8953839
                ],
                [
                    73.5151409,
                    54.8955689
                ],
                [
                    73.5148089,
                    54.8953779
                ],
                [
                    73.5140202,
                    54.8956166
                ],
                [
                    73.5134184,
                    54.8951035
                ],
                [
                    73.5134184,
                    54.8948707
                ],
                [
                    73.5132212,
                    54.8947514
                ],
                [
                    73.5132524,
                    54.8944769
                ],
                [
                    73.5108346,
                    54.8924598
                ],
                [
                    73.5102328,
                    54.8918451
                ],
                [
                    73.505335,
                    54.8933908
                ],
                [
                    73.505335,
                    54.8935221
                ],
                [
                    73.5054906,
                    54.8937071
                ],
                [
                    73.5061962,
                    54.8943874
                ],
                [
                    73.5046086,
                    54.8950438
                ],
                [
                    73.5065179,
                    54.8966072
                ],
                [
                    73.5045982,
                    54.8974903
                ]
            ],
            "longitude": 73.5187221,
            "latitude": 54.896515
        },
        "2493": {
            "name": "Новоселецк",
            "population": 510,
            "type": "village",
            "poly": null,
            "longitude": 73.5223376,
            "latitude": 54.6488492
        },
        "2494": {
            "name": "Камышино",
            "population": 281,
            "type": "village",
            "poly": null,
            "longitude": 73.5269937,
            "latitude": 54.7611064
        },
        "2495": {
            "name": "Хорошки",
            "population": 1069,
            "type": "village",
            "poly": null,
            "longitude": 73.5285774,
            "latitude": 54.2698973
        },
        "2496": {
            "name": "Белоусовка",
            "population": 291,
            "type": "village",
            "poly": null,
            "longitude": 73.5329823,
            "latitude": 54.0458087
        },
        "2497": {
            "name": "Новомосковка",
            "population": 1112,
            "type": "village",
            "poly": null,
            "longitude": 73.5362153,
            "latitude": 55.0197659
        },
        "2498": {
            "name": "Петровка",
            "population": 1544,
            "type": "village",
            "poly": null,
            "longitude": 73.5443615,
            "latitude": 55.2565045
        },
        "2499": {
            "name": "Морозовка",
            "population": 2717,
            "type": "village",
            "poly": [
                [
                    73.5364065,
                    54.9248724
                ],
                [
                    73.5439351,
                    54.9247199
                ],
                [
                    73.5429005,
                    54.9278501
                ],
                [
                    73.543881,
                    54.9281189
                ],
                [
                    73.544313,
                    54.9288581
                ],
                [
                    73.5449247,
                    54.9287392
                ],
                [
                    73.5458783,
                    54.9286978
                ],
                [
                    73.5458243,
                    54.9282429
                ],
                [
                    73.5456714,
                    54.9278087
                ],
                [
                    73.5459143,
                    54.9274055
                ],
                [
                    73.546391,
                    54.9275089
                ],
                [
                    73.5468049,
                    54.9274986
                ],
                [
                    73.5478395,
                    54.9277984
                ],
                [
                    73.5478845,
                    54.9279793
                ],
                [
                    73.5482533,
                    54.9282223
                ],
                [
                    73.5520948,
                    54.9278811
                ],
                [
                    73.5519868,
                    54.9285479
                ],
                [
                    73.5558956,
                    54.9289162
                ],
                [
                    73.5590594,
                    54.9291662
                ],
                [
                    73.5619866,
                    54.9293335
                ],
                [
                    73.5696102,
                    54.9300709
                ],
                [
                    73.5696304,
                    54.9299319
                ],
                [
                    73.5690682,
                    54.9295391
                ],
                [
                    73.5688208,
                    54.9292109
                ],
                [
                    73.5691046,
                    54.9286017
                ],
                [
                    73.5694829,
                    54.9257218
                ],
                [
                    73.5692804,
                    54.9255728
                ],
                [
                    73.5679043,
                    54.9245673
                ],
                [
                    73.5673061,
                    54.9237272
                ],
                [
                    73.5664784,
                    54.921623
                ],
                [
                    73.5663345,
                    54.9211189
                ],
                [
                    73.5662805,
                    54.9207053
                ],
                [
                    73.5606308,
                    54.9201469
                ],
                [
                    73.5605364,
                    54.9204985
                ],
                [
                    73.5544639,
                    54.9219332
                ],
                [
                    73.5541445,
                    54.9221659
                ],
                [
                    73.5544684,
                    54.9230965
                ],
                [
                    73.5512837,
                    54.9230887
                ],
                [
                    73.5513242,
                    54.9229026
                ],
                [
                    73.5515896,
                    54.9226183
                ],
                [
                    73.5517425,
                    54.9219255
                ],
                [
                    73.5519044,
                    54.9215817
                ],
                [
                    73.5518055,
                    54.9211293
                ],
                [
                    73.551837,
                    54.9206252
                ],
                [
                    73.5519944,
                    54.9202478
                ],
                [
                    73.5523632,
                    54.9198315
                ],
                [
                    73.5525746,
                    54.9193197
                ],
                [
                    73.5564298,
                    54.9197215
                ],
                [
                    73.5567906,
                    54.9186305
                ],
                [
                    73.5453926,
                    54.9181562
                ],
                [
                    73.5367666,
                    54.9179295
                ],
                [
                    73.5364065,
                    54.9248724
                ]
            ],
            "longitude": 73.545181,
            "latitude": 54.924221
        },
        "2500": {
            "name": "Подгородка",
            "population": 671,
            "type": "village",
            "poly": [
                [
                    73.5374293,
                    55.1453249
                ],
                [
                    73.5378118,
                    55.1456163
                ],
                [
                    73.5408907,
                    55.1439004
                ],
                [
                    73.5414262,
                    55.144221
                ],
                [
                    73.5419107,
                    55.1439733
                ],
                [
                    73.5421147,
                    55.1440826
                ],
                [
                    73.5429561,
                    55.1437328
                ],
                [
                    73.5448812,
                    55.1449205
                ],
                [
                    73.545149,
                    55.1448913
                ],
                [
                    73.5458884,
                    55.1445562
                ],
                [
                    73.547788,
                    55.1453504
                ],
                [
                    73.5470996,
                    55.1460936
                ],
                [
                    73.548298,
                    55.1465599
                ],
                [
                    73.548706,
                    55.1461956
                ],
                [
                    73.548553,
                    55.1461008
                ],
                [
                    73.5488717,
                    55.1455762
                ],
                [
                    73.5492287,
                    55.1452775
                ],
                [
                    73.5495857,
                    55.1454232
                ],
                [
                    73.5493944,
                    55.14562
                ],
                [
                    73.5500446,
                    55.1458458
                ],
                [
                    73.5500446,
                    55.1460936
                ],
                [
                    73.5504653,
                    55.1462101
                ],
                [
                    73.5502231,
                    55.1464797
                ],
                [
                    73.5505801,
                    55.1465453
                ],
                [
                    73.5508095,
                    55.1464287
                ],
                [
                    73.5510391,
                    55.146487
                ],
                [
                    73.5514981,
                    55.1467784
                ],
                [
                    73.552008,
                    55.146538
                ],
                [
                    73.5523905,
                    55.1466983
                ],
                [
                    73.5526455,
                    55.1466181
                ],
                [
                    73.5531809,
                    55.1468003
                ],
                [
                    73.5533722,
                    55.1466546
                ],
                [
                    73.5545706,
                    55.1471209
                ],
                [
                    73.5551316,
                    55.1466109
                ],
                [
                    73.5553738,
                    55.146232
                ],
                [
                    73.5562153,
                    55.1452994
                ],
                [
                    73.5573691,
                    55.1437547
                ],
                [
                    73.5561643,
                    55.1434523
                ],
                [
                    73.5556287,
                    55.1439806
                ],
                [
                    73.5545961,
                    55.1436162
                ],
                [
                    73.5543666,
                    55.1437984
                ],
                [
                    73.5539586,
                    55.143711
                ],
                [
                    73.5536527,
                    55.143966
                ],
                [
                    73.5529387,
                    55.1437547
                ],
                [
                    73.5524797,
                    55.1438858
                ],
                [
                    73.552059,
                    55.1438275
                ],
                [
                    73.5512303,
                    55.1435288
                ],
                [
                    73.5508861,
                    55.1431863
                ],
                [
                    73.5490757,
                    55.1423375
                ],
                [
                    73.5483681,
                    55.1426675
                ],
                [
                    73.5445953,
                    55.1406228
                ],
                [
                    73.5434937,
                    55.1400145
                ],
                [
                    73.5422135,
                    55.1395138
                ],
                [
                    73.541235,
                    55.1400312
                ],
                [
                    73.5404317,
                    55.1409712
                ],
                [
                    73.5397178,
                    55.1415104
                ],
                [
                    73.5400365,
                    55.1419403
                ],
                [
                    73.5402788,
                    55.1420423
                ],
                [
                    73.5408397,
                    55.1425087
                ],
                [
                    73.5404063,
                    55.1426544
                ],
                [
                    73.540878,
                    55.1430187
                ],
                [
                    73.5401003,
                    55.1433831
                ],
                [
                    73.5374293,
                    55.1453249
                ]
            ],
            "longitude": 73.5482295,
            "latitude": 55.1439936
        },
        "2501": {
            "name": "Весёлые Рощи",
            "population": 490,
            "type": "village",
            "poly": null,
            "longitude": 73.5493018,
            "latitude": 54.518023
        },
        "2502": {
            "name": "Слобода",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 73.5549886,
            "latitude": 57.1255926
        },
        "2503": {
            "name": "Ясная Поляна",
            "population": 289,
            "type": "village",
            "poly": null,
            "longitude": 73.566063,
            "latitude": 54.312298
        },
        "2504": {
            "name": "Любомировка",
            "population": 1213,
            "type": "village",
            "poly": null,
            "longitude": 73.5752977,
            "latitude": 54.4363048
        },
        "2505": {
            "name": "Глинкино",
            "population": 360,
            "type": "village",
            "poly": null,
            "longitude": 73.5796507,
            "latitude": 54.2662278
        },
        "2506": {
            "name": "Хвойный",
            "population": 519,
            "type": "village",
            "poly": [
                [
                    73.5777763,
                    55.1096881
                ],
                [
                    73.578631,
                    55.1097963
                ],
                [
                    73.5796397,
                    55.1107299
                ],
                [
                    73.5799339,
                    55.1109062
                ],
                [
                    73.5801979,
                    55.1109631
                ],
                [
                    73.5808704,
                    55.1108453
                ],
                [
                    73.581356,
                    55.1105937
                ],
                [
                    73.5836536,
                    55.1105737
                ],
                [
                    73.5837167,
                    55.1105096
                ],
                [
                    73.5834435,
                    55.1103533
                ],
                [
                    73.5819094,
                    55.1079451
                ],
                [
                    73.5809637,
                    55.1080853
                ],
                [
                    73.5811598,
                    55.1084179
                ],
                [
                    73.5807745,
                    55.1084379
                ],
                [
                    73.580088,
                    55.1088146
                ],
                [
                    73.5788691,
                    55.1092634
                ],
                [
                    73.5782806,
                    55.1095439
                ],
                [
                    73.5777763,
                    55.1096881
                ]
            ],
            "longitude": 73.5807548,
            "latitude": 55.1095636
        },
        "2507": {
            "name": "Ростовка",
            "population": 5468,
            "type": "village",
            "poly": null,
            "longitude": 73.580765,
            "latitude": 55.019558
        },
        "2508": {
            "name": "Иртышский",
            "population": 3527,
            "type": "village",
            "poly": [
                [
                    73.5751276,
                    54.8240289
                ],
                [
                    73.5836598,
                    54.8266646
                ],
                [
                    73.5900898,
                    54.819897
                ],
                [
                    73.6074015,
                    54.8117031
                ],
                [
                    73.592192,
                    54.8006567
                ],
                [
                    73.5858856,
                    54.8077838
                ],
                [
                    73.5815743,
                    54.8112412
                ],
                [
                    73.5833678,
                    54.8131091
                ],
                [
                    73.5829626,
                    54.8143933
                ],
                [
                    73.5776168,
                    54.8218832
                ],
                [
                    73.5751276,
                    54.8240289
                ]
            ],
            "longitude": 73.5873907,
            "latitude": 54.8163172
        },
        "2509": {
            "name": "Октябрьское",
            "population": 1025,
            "type": "village",
            "poly": [
                [
                    73.5807963,
                    55.5521955
                ],
                [
                    73.5847966,
                    55.5549743
                ],
                [
                    73.5844924,
                    55.5573162
                ],
                [
                    73.5882046,
                    55.5590544
                ],
                [
                    73.587906,
                    55.5604703
                ],
                [
                    73.5904961,
                    55.5616472
                ],
                [
                    73.5914992,
                    55.5609783
                ],
                [
                    73.5921835,
                    55.5612888
                ],
                [
                    73.5919679,
                    55.5615327
                ],
                [
                    73.5931656,
                    55.5619188
                ],
                [
                    73.5934052,
                    55.5616885
                ],
                [
                    73.5983691,
                    55.5635093
                ],
                [
                    73.6012934,
                    55.5598919
                ],
                [
                    73.6049986,
                    55.5592602
                ],
                [
                    73.6067516,
                    55.5577636
                ],
                [
                    73.6096494,
                    55.5572284
                ],
                [
                    73.612955,
                    55.5559982
                ],
                [
                    73.6090393,
                    55.5518475
                ],
                [
                    73.6076064,
                    55.5518475
                ],
                [
                    73.6062613,
                    55.5523437
                ],
                [
                    73.6001174,
                    55.5523316
                ],
                [
                    73.5995545,
                    55.5506649
                ],
                [
                    73.5996143,
                    55.5484357
                ],
                [
                    73.595039,
                    55.547067
                ],
                [
                    73.5916273,
                    55.5490593
                ],
                [
                    73.5814747,
                    55.549721
                ],
                [
                    73.5807963,
                    55.5521955
                ]
            ],
            "longitude": 73.5989288,
            "latitude": 55.5544981
        },
        "2510": {
            "name": "Усть-Заостровка",
            "population": 1868,
            "type": "village",
            "poly": null,
            "longitude": 73.603821,
            "latitude": 54.762009
        },
        "2511": {
            "name": "Красный Путь",
            "population": 291,
            "type": "village",
            "poly": null,
            "longitude": 73.6083506,
            "latitude": 55.6448954
        },
        "2512": {
            "name": "Хохлово",
            "population": 784,
            "type": "village",
            "poly": null,
            "longitude": 73.6187995,
            "latitude": 55.8765953
        },
        "2513": {
            "name": "Харламово",
            "population": 1453,
            "type": "village",
            "poly": null,
            "longitude": 73.621384,
            "latitude": 54.689373
        },
        "2514": {
            "name": "Андреевка",
            "population": 1443,
            "type": "village",
            "poly": [
                [
                    73.6016001,
                    55.0472394
                ],
                [
                    73.602641,
                    55.0487647
                ],
                [
                    73.6074211,
                    55.0481265
                ],
                [
                    73.6109983,
                    55.0479713
                ],
                [
                    73.6146511,
                    55.0481593
                ],
                [
                    73.6160088,
                    55.0446484
                ],
                [
                    73.6372334,
                    55.0467696
                ],
                [
                    73.6390757,
                    55.0447371
                ],
                [
                    73.6390236,
                    55.0442894
                ],
                [
                    73.639297,
                    55.0434314
                ],
                [
                    73.6400133,
                    55.0432225
                ],
                [
                    73.6401448,
                    55.0422764
                ],
                [
                    73.6388621,
                    55.0420637
                ],
                [
                    73.6374369,
                    55.0412403
                ],
                [
                    73.6365666,
                    55.0401898
                ],
                [
                    73.6360175,
                    55.0401509
                ],
                [
                    73.6359654,
                    55.0392555
                ],
                [
                    73.6351693,
                    55.0383018
                ],
                [
                    73.6337776,
                    55.0375994
                ],
                [
                    73.6322242,
                    55.03725
                ],
                [
                    73.6300398,
                    55.0367193
                ],
                [
                    73.6287135,
                    55.0359752
                ],
                [
                    73.6258077,
                    55.0337436
                ],
                [
                    73.6237241,
                    55.0337809
                ],
                [
                    73.6222917,
                    55.0346205
                ],
                [
                    73.622422,
                    55.0356652
                ],
                [
                    73.6211785,
                    55.0362477
                ],
                [
                    73.6198187,
                    55.0377989
                ],
                [
                    73.6179813,
                    55.0387185
                ],
                [
                    73.6186944,
                    55.039275
                ],
                [
                    73.6179619,
                    55.0394429
                ],
                [
                    73.6153687,
                    55.0387274
                ],
                [
                    73.6138198,
                    55.0379027
                ],
                [
                    73.6133717,
                    55.0375868
                ],
                [
                    73.6132578,
                    55.0366633
                ],
                [
                    73.6144948,
                    55.0350402
                ],
                [
                    73.6154064,
                    55.0344992
                ],
                [
                    73.6150971,
                    55.0337343
                ],
                [
                    73.6131275,
                    55.0332492
                ],
                [
                    73.6116626,
                    55.0331839
                ],
                [
                    73.6107509,
                    55.0333611
                ],
                [
                    73.6100674,
                    55.0337249
                ],
                [
                    73.6100837,
                    55.0344619
                ],
                [
                    73.6120044,
                    55.0374095
                ],
                [
                    73.6118987,
                    55.038062
                ],
                [
                    73.6112435,
                    55.0388231
                ],
                [
                    73.6100625,
                    55.0400502
                ],
                [
                    73.6089346,
                    55.0404776
                ],
                [
                    73.6079605,
                    55.0408178
                ],
                [
                    73.6077238,
                    55.040232
                ],
                [
                    73.6055075,
                    55.0402496
                ],
                [
                    73.6046257,
                    55.0403673
                ],
                [
                    73.6040244,
                    55.0408401
                ],
                [
                    73.6043473,
                    55.0413423
                ],
                [
                    73.6022988,
                    55.0442441
                ],
                [
                    73.6016276,
                    55.0459864
                ],
                [
                    73.6016001,
                    55.0472394
                ]
            ],
            "longitude": 73.6241327,
            "latitude": 55.0438666
        },
        "2515": {
            "name": "имени Комиссарова",
            "population": 292,
            "type": "village",
            "poly": null,
            "longitude": 73.6377101,
            "latitude": 54.7341958
        },
        "2516": {
            "name": "Новосанжаровка",
            "population": 960,
            "type": "village",
            "poly": null,
            "longitude": 73.644697,
            "latitude": 53.6703959
        },
        "2517": {
            "name": "Октябрьский",
            "population": 379,
            "type": "village",
            "poly": [
                [
                    73.6410852,
                    54.9216865
                ],
                [
                    73.6461666,
                    54.9275604
                ],
                [
                    73.6537396,
                    54.9252831
                ],
                [
                    73.6538966,
                    54.9258017
                ],
                [
                    73.6543282,
                    54.9261963
                ],
                [
                    73.656604,
                    54.9276393
                ],
                [
                    73.6570356,
                    54.9279437
                ],
                [
                    73.6575065,
                    54.9283495
                ],
                [
                    73.6577419,
                    54.9286088
                ],
                [
                    73.6578399,
                    54.928947
                ],
                [
                    73.6580558,
                    54.9292288
                ],
                [
                    73.6681401,
                    54.9265571
                ],
                [
                    73.6666294,
                    54.9254748
                ],
                [
                    73.6659427,
                    54.925114
                ],
                [
                    73.6620581,
                    54.9208296
                ],
                [
                    73.6603513,
                    54.9193638
                ],
                [
                    73.6607044,
                    54.9191721
                ],
                [
                    73.6592134,
                    54.9188113
                ],
                [
                    73.6583893,
                    54.9187887
                ],
                [
                    73.6572318,
                    54.9188
                ],
                [
                    73.6553288,
                    54.9188451
                ],
                [
                    73.6546421,
                    54.9188677
                ],
                [
                    73.6541124,
                    54.9187662
                ],
                [
                    73.6532883,
                    54.9183039
                ],
                [
                    73.6520327,
                    54.9172214
                ],
                [
                    73.6506986,
                    54.9167027
                ],
                [
                    73.6493449,
                    54.916432
                ],
                [
                    73.6476969,
                    54.9163418
                ],
                [
                    73.6470495,
                    54.9161501
                ],
                [
                    73.6458331,
                    54.916759
                ],
                [
                    73.6457154,
                    54.9206041
                ],
                [
                    73.6410852,
                    54.9216865
                ]
            ],
            "longitude": 73.6513155,
            "latitude": 54.9228823
        },
        "2518": {
            "name": "Чередово",
            "population": 317,
            "type": "village",
            "poly": null,
            "longitude": 73.655572,
            "latitude": 57.0152034
        },
        "2519": {
            "name": "Милоградовка",
            "population": 623,
            "type": "village",
            "poly": null,
            "longitude": 73.6688491,
            "latitude": 54.0943349
        },
        "2520": {
            "name": "Ульяновка",
            "population": 1419,
            "type": "village",
            "poly": null,
            "longitude": 73.6713836,
            "latitude": 54.9713973
        },
        "2521": {
            "name": "Бородинка",
            "population": 385,
            "type": "village",
            "poly": [
                [
                    73.6667915,
                    55.2946443
                ],
                [
                    73.6768492,
                    55.2986078
                ],
                [
                    73.6731281,
                    55.3010804
                ],
                [
                    73.6725849,
                    55.301822
                ],
                [
                    73.6715845,
                    55.3023915
                ],
                [
                    73.6709672,
                    55.3031427
                ],
                [
                    73.6705415,
                    55.3038212
                ],
                [
                    73.6703074,
                    55.304633
                ],
                [
                    73.6699094,
                    55.305315
                ],
                [
                    73.6696263,
                    55.3068094
                ],
                [
                    73.669364,
                    55.3070066
                ],
                [
                    73.6695837,
                    55.3071893
                ],
                [
                    73.6690823,
                    55.3079487
                ],
                [
                    73.6712725,
                    55.3084412
                ],
                [
                    73.6757356,
                    55.3074937
                ],
                [
                    73.6792842,
                    55.3060192
                ],
                [
                    73.6802432,
                    55.305188
                ],
                [
                    73.6806825,
                    55.3045543
                ],
                [
                    73.6824181,
                    55.3049278
                ],
                [
                    73.6828492,
                    55.3042513
                ],
                [
                    73.6831093,
                    55.3041644
                ],
                [
                    73.6831529,
                    55.3039349
                ],
                [
                    73.6838504,
                    55.3031781
                ],
                [
                    73.6839049,
                    55.3029796
                ],
                [
                    73.6837523,
                    55.302688
                ],
                [
                    73.683785,
                    55.3024027
                ],
                [
                    73.6844062,
                    55.3018816
                ],
                [
                    73.6846459,
                    55.3017637
                ],
                [
                    73.6845914,
                    55.3013108
                ],
                [
                    73.6840047,
                    55.300971
                ],
                [
                    73.6845369,
                    55.3010255
                ],
                [
                    73.6846677,
                    55.3009262
                ],
                [
                    73.686237,
                    55.3008704
                ],
                [
                    73.6876268,
                    55.3006024
                ],
                [
                    73.6870979,
                    55.3001197
                ],
                [
                    73.6848966,
                    55.2993194
                ],
                [
                    73.6822856,
                    55.298089
                ],
                [
                    73.6870298,
                    55.2918009
                ],
                [
                    73.6872144,
                    55.2909818
                ],
                [
                    73.6855117,
                    55.2905788
                ],
                [
                    73.6852328,
                    55.2909064
                ],
                [
                    73.6838746,
                    55.2906023
                ],
                [
                    73.6826652,
                    55.2918956
                ],
                [
                    73.6826434,
                    55.2921934
                ],
                [
                    73.6823383,
                    55.2924602
                ],
                [
                    73.6817607,
                    55.2933848
                ],
                [
                    73.6829813,
                    55.2937323
                ],
                [
                    73.6822608,
                    55.2945683
                ],
                [
                    73.678669,
                    55.2937273
                ],
                [
                    73.6782412,
                    55.2938275
                ],
                [
                    73.6779579,
                    55.2940881
                ],
                [
                    73.6774675,
                    55.2946838
                ],
                [
                    73.6761162,
                    55.2946651
                ],
                [
                    73.6742398,
                    55.2943202
                ],
                [
                    73.6715717,
                    55.2942308
                ],
                [
                    73.6694358,
                    55.2939206
                ],
                [
                    73.668989,
                    55.2934242
                ],
                [
                    73.6683878,
                    55.2931609
                ],
                [
                    73.6677268,
                    55.293632
                ],
                [
                    73.6678534,
                    55.2938188
                ],
                [
                    73.6669816,
                    55.2943499
                ],
                [
                    73.6667915,
                    55.2946443
                ]
            ],
            "longitude": 73.678169,
            "latitude": 55.298382
        },
        "2522": {
            "name": "Розовка",
            "population": 2325,
            "type": "village",
            "poly": [
                [
                    73.6543391,
                    54.7219631
                ],
                [
                    73.6543391,
                    54.7220904
                ],
                [
                    73.6551724,
                    54.7227487
                ],
                [
                    73.656772,
                    54.7221457
                ],
                [
                    73.6582567,
                    54.7218746
                ],
                [
                    73.6590613,
                    54.7220074
                ],
                [
                    73.659454,
                    54.7221789
                ],
                [
                    73.6604537,
                    54.7228296
                ],
                [
                    73.6610249,
                    54.7230087
                ],
                [
                    73.6615913,
                    54.7233844
                ],
                [
                    73.6612931,
                    54.7228759
                ],
                [
                    73.6656392,
                    54.7205029
                ],
                [
                    73.6662451,
                    54.7207682
                ],
                [
                    73.6825956,
                    54.7112794
                ],
                [
                    73.6829596,
                    54.7115008
                ],
                [
                    73.6829979,
                    54.7116723
                ],
                [
                    73.6832948,
                    54.7118881
                ],
                [
                    73.6832853,
                    54.7121205
                ],
                [
                    73.6827776,
                    54.7124193
                ],
                [
                    73.6828925,
                    54.7125078
                ],
                [
                    73.6763313,
                    54.7162316
                ],
                [
                    73.6767336,
                    54.7164805
                ],
                [
                    73.6833523,
                    54.7126628
                ],
                [
                    73.683563,
                    54.7127347
                ],
                [
                    73.6840036,
                    54.7123086
                ],
                [
                    73.6838217,
                    54.7121924
                ],
                [
                    73.6841186,
                    54.7117
                ],
                [
                    73.6842239,
                    54.7111743
                ],
                [
                    73.6839462,
                    54.7111134
                ],
                [
                    73.683314,
                    54.7108091
                ],
                [
                    73.6958638,
                    54.7035507
                ],
                [
                    73.6951838,
                    54.7027289
                ],
                [
                    73.6934692,
                    54.7016607
                ],
                [
                    73.6917211,
                    54.7025794
                ],
                [
                    73.6910171,
                    54.7022031
                ],
                [
                    73.6908926,
                    54.7022031
                ],
                [
                    73.6900353,
                    54.7016662
                ],
                [
                    73.6895851,
                    54.7015057
                ],
                [
                    73.6888955,
                    54.7012954
                ],
                [
                    73.6876503,
                    54.7007197
                ],
                [
                    73.6870181,
                    54.7011293
                ],
                [
                    73.6861751,
                    54.7014171
                ],
                [
                    73.6847959,
                    54.7019734
                ],
                [
                    73.6832586,
                    54.7024992
                ],
                [
                    73.6826455,
                    54.702798
                ],
                [
                    73.6816015,
                    54.703191
                ],
                [
                    73.680998,
                    54.7034068
                ],
                [
                    73.6807442,
                    54.7035812
                ],
                [
                    73.6806819,
                    54.7037002
                ],
                [
                    73.6807107,
                    54.703797
                ],
                [
                    73.6808783,
                    54.7038662
                ],
                [
                    73.6811896,
                    54.7039216
                ],
                [
                    73.681271,
                    54.7040101
                ],
                [
                    73.68118,
                    54.7040655
                ],
                [
                    73.6810028,
                    54.7040461
                ],
                [
                    73.680567,
                    54.7039354
                ],
                [
                    73.6802797,
                    54.7039409
                ],
                [
                    73.680112,
                    54.7040101
                ],
                [
                    73.6798055,
                    54.7042564
                ],
                [
                    73.6794703,
                    54.7043339
                ],
                [
                    73.6791398,
                    54.7043643
                ],
                [
                    73.6789004,
                    54.7044501
                ],
                [
                    73.6787088,
                    54.7046051
                ],
                [
                    73.6783879,
                    54.7049094
                ],
                [
                    73.6779473,
                    54.7051806
                ],
                [
                    73.6776504,
                    54.7053909
                ],
                [
                    73.6775306,
                    54.7055846
                ],
                [
                    73.6774444,
                    54.7057534
                ],
                [
                    73.6771475,
                    54.7059361
                ],
                [
                    73.6769751,
                    54.7060772
                ],
                [
                    73.6769655,
                    54.7061796
                ],
                [
                    73.6770996,
                    54.7062432
                ],
                [
                    73.6772337,
                    54.7063068
                ],
                [
                    73.6772241,
                    54.7064535
                ],
                [
                    73.6770948,
                    54.7064563
                ],
                [
                    73.6766159,
                    54.7064341
                ],
                [
                    73.6764818,
                    54.7064673
                ],
                [
                    73.6758399,
                    54.7069433
                ],
                [
                    73.6753563,
                    54.7071619
                ],
                [
                    73.6746283,
                    54.7076295
                ],
                [
                    73.6736657,
                    54.7082852
                ],
                [
                    73.6735125,
                    54.7084402
                ],
                [
                    73.6732969,
                    54.7086615
                ],
                [
                    73.6730718,
                    54.7088331
                ],
                [
                    73.6726073,
                    54.7090738
                ],
                [
                    73.6724301,
                    54.7091983
                ],
                [
                    73.6717931,
                    54.7097351
                ],
                [
                    73.6715728,
                    54.7098873
                ],
                [
                    73.6713046,
                    54.7099869
                ],
                [
                    73.6706102,
                    54.7102774
                ],
                [
                    73.6701791,
                    54.7105513
                ],
                [
                    73.6696859,
                    54.7108916
                ],
                [
                    73.6693937,
                    54.7111572
                ],
                [
                    73.6691589,
                    54.7113758
                ],
                [
                    73.668977,
                    54.7115169
                ],
                [
                    73.6687615,
                    54.7116552
                ],
                [
                    73.6683353,
                    54.7119125
                ],
                [
                    73.6673918,
                    54.7125378
                ],
                [
                    73.6671523,
                    54.7127481
                ],
                [
                    73.667114,
                    54.712939
                ],
                [
                    73.6672002,
                    54.7130635
                ],
                [
                    73.6675642,
                    54.713105
                ],
                [
                    73.6677653,
                    54.7131658
                ],
                [
                    73.6677606,
                    54.7132461
                ],
                [
                    73.667684,
                    54.713282
                ],
                [
                    73.6673679,
                    54.7132405
                ],
                [
                    73.6672386,
                    54.7132959
                ],
                [
                    73.6673391,
                    54.7133705
                ],
                [
                    73.6675355,
                    54.713484
                ],
                [
                    73.6675499,
                    54.7135559
                ],
                [
                    73.6674636,
                    54.7135753
                ],
                [
                    73.6672911,
                    54.7134812
                ],
                [
                    73.667138,
                    54.7134701
                ],
                [
                    73.6671284,
                    54.7135365
                ],
                [
                    73.6672098,
                    54.7136002
                ],
                [
                    73.6673966,
                    54.7136859
                ],
                [
                    73.6673391,
                    54.7137357
                ],
                [
                    73.6671907,
                    54.7137053
                ],
                [
                    73.6669273,
                    54.7136306
                ],
                [
                    73.6667069,
                    54.7136666
                ],
                [
                    73.6665058,
                    54.7138104
                ],
                [
                    73.666137,
                    54.7140816
                ],
                [
                    73.6658401,
                    54.714361
                ],
                [
                    73.6657189,
                    54.7145541
                ],
                [
                    73.6656529,
                    54.7146968
                ],
                [
                    73.665524,
                    54.714787
                ],
                [
                    73.6651409,
                    54.7150858
                ],
                [
                    73.6637185,
                    54.7160955
                ],
                [
                    73.6625355,
                    54.7168452
                ],
                [
                    73.6618746,
                    54.7173542
                ],
                [
                    73.6614484,
                    54.7176862
                ],
                [
                    73.6606917,
                    54.7182118
                ],
                [
                    73.6590011,
                    54.7194483
                ],
                [
                    73.6590346,
                    54.7195645
                ],
                [
                    73.6594417,
                    54.7196613
                ],
                [
                    73.6596524,
                    54.7197498
                ],
                [
                    73.6595806,
                    54.7198189
                ],
                [
                    73.6591687,
                    54.719783
                ],
                [
                    73.6586179,
                    54.7196696
                ],
                [
                    73.658388,
                    54.7197553
                ],
                [
                    73.6580144,
                    54.7199213
                ],
                [
                    73.6573057,
                    54.7203224
                ],
                [
                    73.657162,
                    54.7204828
                ],
                [
                    73.6571716,
                    54.7205686
                ],
                [
                    73.6575019,
                    54.7206405
                ],
                [
                    73.6577032,
                    54.720729
                ],
                [
                    73.6576409,
                    54.7208147
                ],
                [
                    73.6575308,
                    54.7208424
                ],
                [
                    73.6569034,
                    54.7206764
                ],
                [
                    73.656616,
                    54.7206903
                ],
                [
                    73.6564628,
                    54.7207456
                ],
                [
                    73.6562951,
                    54.7208562
                ],
                [
                    73.6561015,
                    54.7208788
                ],
                [
                    73.6551245,
                    54.7214818
                ],
                [
                    73.654569,
                    54.7217474
                ],
                [
                    73.6543391,
                    54.7219631
                ]
            ],
            "longitude": 73.6784938,
            "latitude": 54.7091528
        },
        "2523": {
            "name": "Ивановка",
            "population": 580,
            "type": "village",
            "poly": null,
            "longitude": 73.687264,
            "latitude": 55.6746903
        },
        "2524": {
            "name": "Стрела",
            "population": 659,
            "type": "village",
            "poly": null,
            "longitude": 73.701393,
            "latitude": 54.570621
        },
        "2525": {
            "name": "Андреевский",
            "population": 587,
            "type": "village",
            "poly": null,
            "longitude": 73.7110231,
            "latitude": 55.091936
        },
        "2526": {
            "name": "Серебряковка",
            "population": 302,
            "type": "village",
            "poly": null,
            "longitude": 73.7214323,
            "latitude": 54.8683788
        },
        "2527": {
            "name": "Логиновка",
            "population": 683,
            "type": "village",
            "poly": [
                [
                    73.7192072,
                    54.2786304
                ],
                [
                    73.7192898,
                    54.2787751
                ],
                [
                    73.7201163,
                    54.2788717
                ],
                [
                    73.7205414,
                    54.2790371
                ],
                [
                    73.7210491,
                    54.2805191
                ],
                [
                    73.7222179,
                    54.2831866
                ],
                [
                    73.7251224,
                    54.2827937
                ],
                [
                    73.7283102,
                    54.2824698
                ],
                [
                    73.7292784,
                    54.2823526
                ],
                [
                    73.7296561,
                    54.2821803
                ],
                [
                    73.7298923,
                    54.2816427
                ],
                [
                    73.7306952,
                    54.2816289
                ],
                [
                    73.7316515,
                    54.2817185
                ],
                [
                    73.7319467,
                    54.2817667
                ],
                [
                    73.7323954,
                    54.2817598
                ],
                [
                    73.7345324,
                    54.2821045
                ],
                [
                    73.7348984,
                    54.2826283
                ],
                [
                    73.737425,
                    54.2831521
                ],
                [
                    73.7417935,
                    54.2745493
                ],
                [
                    73.7362444,
                    54.2746252
                ],
                [
                    73.7361263,
                    54.2723501
                ],
                [
                    73.7329029,
                    54.2723708
                ],
                [
                    73.7328558,
                    54.2719985
                ],
                [
                    73.7321238,
                    54.2720123
                ],
                [
                    73.7321592,
                    54.2725776
                ],
                [
                    73.7300458,
                    54.2726052
                ],
                [
                    73.7299395,
                    54.2727086
                ],
                [
                    73.7301757,
                    54.2729499
                ],
                [
                    73.7297861,
                    54.2733429
                ],
                [
                    73.7301757,
                    54.2736531
                ],
                [
                    73.7302229,
                    54.2745493
                ],
                [
                    73.7276907,
                    54.2743875
                ],
                [
                    73.7202344,
                    54.2743494
                ],
                [
                    73.721297,
                    54.2781341
                ],
                [
                    73.7192898,
                    54.2784443
                ],
                [
                    73.7192072,
                    54.2786304
                ]
            ],
            "longitude": 73.7300194,
            "latitude": 54.2773346
        },
        "2528": {
            "name": "Богословка",
            "population": 1438,
            "type": "village",
            "poly": null,
            "longitude": 73.730513,
            "latitude": 55.0332885
        },
        "2529": {
            "name": "Карповка",
            "population": 1380,
            "type": "village",
            "poly": null,
            "longitude": 73.737312,
            "latitude": 54.510391
        },
        "2530": {
            "name": "Божедаровка",
            "population": 311,
            "type": "village",
            "poly": null,
            "longitude": 73.7443866,
            "latitude": 54.1857287
        },
        "2531": {
            "name": "Семяновка",
            "population": 310,
            "type": "village",
            "poly": null,
            "longitude": 73.7517396,
            "latitude": 54.2653759
        },
        "2532": {
            "name": "Семёновка",
            "population": 498,
            "type": "village",
            "poly": null,
            "longitude": 73.752472,
            "latitude": 57.137356
        },
        "2533": {
            "name": "Калинино",
            "population": 1336,
            "type": "village",
            "poly": null,
            "longitude": 73.7539052,
            "latitude": 54.8544562
        },
        "2534": {
            "name": "Алабота",
            "population": 1000,
            "type": "village",
            "poly": null,
            "longitude": 73.76545,
            "latitude": 53.950451
        },
        "2535": {
            "name": "Копейкино",
            "population": 720,
            "type": "village",
            "poly": null,
            "longitude": 73.7692831,
            "latitude": 54.6480244
        },
        "2536": {
            "name": "Новологиново",
            "population": 470,
            "type": "village",
            "poly": null,
            "longitude": 73.7750465,
            "latitude": 56.4950006
        },
        "2537": {
            "name": "Демьяновка",
            "population": 449,
            "type": "village",
            "poly": [
                [
                    73.7757934,
                    55.4209607
                ],
                [
                    73.7766752,
                    55.4219966
                ],
                [
                    73.7792183,
                    55.4215776
                ],
                [
                    73.7801412,
                    55.4236144
                ],
                [
                    73.7856989,
                    55.4233816
                ],
                [
                    73.7871755,
                    55.4270825
                ],
                [
                    73.7933279,
                    55.4285953
                ],
                [
                    73.7988446,
                    55.424336
                ],
                [
                    73.8023246,
                    55.4230674
                ],
                [
                    73.7981747,
                    55.4149437
                ],
                [
                    73.7973346,
                    55.4148185
                ],
                [
                    73.7963162,
                    55.4146278
                ],
                [
                    73.7957806,
                    55.4144311
                ],
                [
                    73.7929196,
                    55.412683
                ],
                [
                    73.7924729,
                    55.4128422
                ],
                [
                    73.7876332,
                    55.4136004
                ],
                [
                    73.7828483,
                    55.4141628
                ],
                [
                    73.778357,
                    55.4146634
                ],
                [
                    73.7791363,
                    55.4171429
                ],
                [
                    73.7788082,
                    55.4172011
                ],
                [
                    73.7790748,
                    55.4180275
                ],
                [
                    73.7773521,
                    55.4184466
                ],
                [
                    73.7778237,
                    55.4197037
                ],
                [
                    73.77727,
                    55.4198201
                ],
                [
                    73.777434,
                    55.4202507
                ],
                [
                    73.7763472,
                    55.4204602
                ],
                [
                    73.7764907,
                    55.4207279
                ],
                [
                    73.7757934,
                    55.4209607
                ]
            ],
            "longitude": 73.788361,
            "latitude": 55.420059
        },
        "2538": {
            "name": "Набережный",
            "population": 367,
            "type": "village",
            "poly": null,
            "longitude": 73.7905504,
            "latitude": 54.6681758
        },
        "2539": {
            "name": "Речной",
            "population": 837,
            "type": "village",
            "poly": [
                [
                    73.7891511,
                    54.6707216
                ],
                [
                    73.7971247,
                    54.6768922
                ],
                [
                    73.797335,
                    54.6768279
                ],
                [
                    73.7976939,
                    54.6771856
                ],
                [
                    73.7983868,
                    54.6773072
                ],
                [
                    73.7988942,
                    54.6771641
                ],
                [
                    73.8000202,
                    54.6788025
                ],
                [
                    73.8018764,
                    54.6784018
                ],
                [
                    73.8048586,
                    54.6772714
                ],
                [
                    73.8052736,
                    54.6771866
                ],
                [
                    73.8091648,
                    54.6763914
                ],
                [
                    73.8088925,
                    54.6755829
                ],
                [
                    73.8103032,
                    54.6754255
                ],
                [
                    73.8100557,
                    54.6746385
                ],
                [
                    73.8098949,
                    54.6744381
                ],
                [
                    73.8098454,
                    54.6739015
                ],
                [
                    73.8094494,
                    54.67305
                ],
                [
                    73.8089915,
                    54.6724418
                ],
                [
                    73.8089296,
                    54.6719123
                ],
                [
                    73.8089946,
                    54.6707567
                ],
                [
                    73.8007874,
                    54.6709714
                ],
                [
                    73.8004897,
                    54.6703371
                ],
                [
                    73.8002177,
                    54.6699059
                ],
                [
                    73.796746,
                    54.6699901
                ],
                [
                    73.7891511,
                    54.6707216
                ]
            ],
            "longitude": 73.8043231,
            "latitude": 54.6746019
        },
        "2540": {
            "name": "Соусканово",
            "population": 245,
            "type": "village",
            "poly": null,
            "longitude": 73.8258763,
            "latitude": 56.9773113
        },
        "2541": {
            "name": "Девятериковка",
            "population": 287,
            "type": "village",
            "poly": [
                [
                    73.8124558,
                    55.2559334
                ],
                [
                    73.8130929,
                    55.2567852
                ],
                [
                    73.8130726,
                    55.2580849
                ],
                [
                    73.8148158,
                    55.2582356
                ],
                [
                    73.8167326,
                    55.258276
                ],
                [
                    73.819488,
                    55.2580492
                ],
                [
                    73.8216733,
                    55.2578133
                ],
                [
                    73.8221732,
                    55.2577082
                ],
                [
                    73.8228292,
                    55.2574869
                ],
                [
                    73.8250022,
                    55.2566334
                ],
                [
                    73.8255217,
                    55.2564266
                ],
                [
                    73.8290252,
                    55.2551323
                ],
                [
                    73.833022,
                    55.2552944
                ],
                [
                    73.8340111,
                    55.2551917
                ],
                [
                    73.8346829,
                    55.2549205
                ],
                [
                    73.8351308,
                    55.2545297
                ],
                [
                    73.8352737,
                    55.2540241
                ],
                [
                    73.8352147,
                    55.2517138
                ],
                [
                    73.8342951,
                    55.2503898
                ],
                [
                    73.8334813,
                    55.2495333
                ],
                [
                    73.8318328,
                    55.2487857
                ],
                [
                    73.8312959,
                    55.24806
                ],
                [
                    73.8318277,
                    55.2472143
                ],
                [
                    73.8317438,
                    55.2461692
                ],
                [
                    73.8319397,
                    55.2454511
                ],
                [
                    73.8316079,
                    55.2427768
                ],
                [
                    73.830862,
                    55.2428899
                ],
                [
                    73.8285317,
                    55.2419962
                ],
                [
                    73.8269852,
                    55.2448288
                ],
                [
                    73.8257485,
                    55.2474639
                ],
                [
                    73.8198336,
                    55.2473338
                ],
                [
                    73.819605,
                    55.2487546
                ],
                [
                    73.8190615,
                    55.2490469
                ],
                [
                    73.8189085,
                    55.2502722
                ],
                [
                    73.814973,
                    55.2501936
                ],
                [
                    73.812749,
                    55.2534008
                ],
                [
                    73.8135241,
                    55.2536372
                ],
                [
                    73.8134804,
                    55.2540734
                ],
                [
                    73.8134585,
                    55.2547838
                ],
                [
                    73.8141802,
                    55.2550954
                ],
                [
                    73.8143769,
                    55.2556936
                ],
                [
                    73.8139178,
                    55.2559429
                ],
                [
                    73.8128462,
                    55.2555192
                ],
                [
                    73.8124558,
                    55.2559334
                ]
            ],
            "longitude": 73.827072,
            "latitude": 55.252132
        },
        "2542": {
            "name": "Андреевка",
            "population": 828,
            "type": "village",
            "poly": null,
            "longitude": 73.8272932,
            "latitude": 55.7171135
        },
        "2543": {
            "name": "Ламаново",
            "population": 518,
            "type": "village",
            "poly": null,
            "longitude": 73.8312402,
            "latitude": 56.2923599
        },
        "2544": {
            "name": "Тихвинка",
            "population": 928,
            "type": "village",
            "poly": [
                [
                    73.8099927,
                    54.3561381
                ],
                [
                    73.8099927,
                    54.3565946
                ],
                [
                    73.8162911,
                    54.3717224
                ],
                [
                    73.8170668,
                    54.3713908
                ],
                [
                    73.817866,
                    54.3710715
                ],
                [
                    73.8271374,
                    54.3688233
                ],
                [
                    73.8353697,
                    54.3668477
                ],
                [
                    73.8461597,
                    54.3642933
                ],
                [
                    73.8468697,
                    54.3641114
                ],
                [
                    73.8476553,
                    54.3638209
                ],
                [
                    73.8487858,
                    54.3632954
                ],
                [
                    73.8494595,
                    54.3629561
                ],
                [
                    73.85043,
                    54.3624172
                ],
                [
                    73.850978,
                    54.3620913
                ],
                [
                    73.8512064,
                    54.361752
                ],
                [
                    73.8515261,
                    54.3612929
                ],
                [
                    73.8518572,
                    54.3607474
                ],
                [
                    73.8521655,
                    54.3601952
                ],
                [
                    73.8550657,
                    54.3544132
                ],
                [
                    73.8460912,
                    54.3514122
                ],
                [
                    73.8451206,
                    54.3512325
                ],
                [
                    73.8439903,
                    54.3510927
                ],
                [
                    73.8278567,
                    54.3492228
                ],
                [
                    73.8252991,
                    54.3489765
                ],
                [
                    73.826498,
                    54.3528495
                ],
                [
                    73.8108929,
                    54.3548878
                ],
                [
                    73.8106767,
                    54.3550684
                ],
                [
                    73.8099927,
                    54.3561381
                ]
            ],
            "longitude": 73.831848,
            "latitude": 54.357952
        },
        "2545": {
            "name": "Качуково",
            "population": 464,
            "type": "village",
            "poly": null,
            "longitude": 73.8409778,
            "latitude": 57.1976057
        },
        "2546": {
            "name": "Бражниково",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 73.8420362,
            "latitude": 56.5122174
        },
        "2547": {
            "name": "Берёзовка",
            "population": 187,
            "type": "village",
            "poly": null,
            "longitude": 73.8658585,
            "latitude": 55.9185677
        },
        "2548": {
            "name": "Ачаир",
            "population": 2023,
            "type": "village",
            "poly": null,
            "longitude": 73.872101,
            "latitude": 54.659481
        },
        "2549": {
            "name": "Ложниково",
            "population": 528,
            "type": "village",
            "poly": null,
            "longitude": 73.8760305,
            "latitude": 56.8922654
        },
        "2550": {
            "name": "Степное",
            "population": 271,
            "type": "village",
            "poly": null,
            "longitude": 73.8775629,
            "latitude": 54.0470656
        },
        "2551": {
            "name": "Чебаклы",
            "population": 540,
            "type": "village",
            "poly": null,
            "longitude": 73.8781295,
            "latitude": 55.966574
        },
        "2552": {
            "name": "Сыропятское",
            "population": 1199,
            "type": "village",
            "poly": null,
            "longitude": 73.87896,
            "latitude": 55.047356
        },
        "2553": {
            "name": "Немировка",
            "population": 620,
            "type": "village",
            "poly": null,
            "longitude": 73.8813686,
            "latitude": 54.9249982
        },
        "2554": {
            "name": "Георгиевка",
            "population": 793,
            "type": "village",
            "poly": [
                [
                    73.8639266,
                    55.5822888
                ],
                [
                    73.8676275,
                    55.5840706
                ],
                [
                    73.8676088,
                    55.588751
                ],
                [
                    73.8801402,
                    55.5906669
                ],
                [
                    73.8888949,
                    55.5910792
                ],
                [
                    73.8975528,
                    55.5876396
                ],
                [
                    73.8977828,
                    55.5824179
                ],
                [
                    73.8943561,
                    55.5817722
                ],
                [
                    73.8897414,
                    55.5813849
                ],
                [
                    73.8901525,
                    55.5804035
                ],
                [
                    73.8911578,
                    55.580481
                ],
                [
                    73.8914319,
                    55.5799386
                ],
                [
                    73.8923457,
                    55.5793446
                ],
                [
                    73.8939905,
                    55.5767618
                ],
                [
                    73.8903353,
                    55.5760644
                ],
                [
                    73.8875026,
                    55.5782857
                ],
                [
                    73.8767198,
                    55.5765552
                ],
                [
                    73.8709628,
                    55.5811783
                ],
                [
                    73.865343,
                    55.5801969
                ],
                [
                    73.8639266,
                    55.5822888
                ]
            ],
            "longitude": 73.8823909,
            "latitude": 55.5842965
        },
        "2555": {
            "name": "Солнечное",
            "population": 1186,
            "type": "village",
            "poly": null,
            "longitude": 73.8909611,
            "latitude": 53.7716707
        },
        "2556": {
            "name": "Луговое",
            "population": 1259,
            "type": "village",
            "poly": null,
            "longitude": 73.8990815,
            "latitude": 54.6216188
        },
        "2557": {
            "name": "Аникино",
            "population": 282,
            "type": "village",
            "poly": null,
            "longitude": 73.901282,
            "latitude": 56.5301607
        },
        "2558": {
            "name": "Киселево",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 73.9037177,
            "latitude": 57.1183895
        },
        "2559": {
            "name": "Алексеевка",
            "population": 1159,
            "type": "village",
            "poly": null,
            "longitude": 73.9114429,
            "latitude": 55.1499097
        },
        "2560": {
            "name": "Сухое",
            "population": 1018,
            "type": "village",
            "poly": null,
            "longitude": 73.929,
            "latitude": 55.4241771
        },
        "2561": {
            "name": "Павлодаровка",
            "population": 680,
            "type": "village",
            "poly": null,
            "longitude": 73.9400741,
            "latitude": 55.2657876
        },
        "2562": {
            "name": "Чапаево",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 73.9463044,
            "latitude": 56.2279346
        },
        "2563": {
            "name": "Богданово",
            "population": 291,
            "type": "village",
            "poly": null,
            "longitude": 73.9595605,
            "latitude": 55.7008813
        },
        "2564": {
            "name": "Корсино",
            "population": 273,
            "type": "village",
            "poly": null,
            "longitude": 73.9636934,
            "latitude": 56.5700214
        },
        "2565": {
            "name": "Раздольное",
            "population": 439,
            "type": "village",
            "poly": null,
            "longitude": 73.9676678,
            "latitude": 54.08555
        },
        "2566": {
            "name": "Вставское",
            "population": 339,
            "type": "village",
            "poly": null,
            "longitude": 73.9701981,
            "latitude": 56.8592035
        },
        "2567": {
            "name": "Бологое",
            "population": 823,
            "type": "village",
            "poly": null,
            "longitude": 73.9783741,
            "latitude": 53.8524384
        },
        "2568": {
            "name": "Черниговка",
            "population": 660,
            "type": "village",
            "poly": null,
            "longitude": 73.996826,
            "latitude": 54.879818
        },
        "2569": {
            "name": "Ачаирский",
            "population": 2355,
            "type": "village",
            "poly": null,
            "longitude": 73.9995788,
            "latitude": 54.6052535
        },
        "2570": {
            "name": "Большие Туралы",
            "population": 753,
            "type": "village",
            "poly": null,
            "longitude": 74.0008169,
            "latitude": 56.7552857
        },
        "2571": {
            "name": "Южное",
            "population": 1286,
            "type": "village",
            "poly": null,
            "longitude": 74.021515,
            "latitude": 54.008953
        },
        "2572": {
            "name": "Борки",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 74.031397,
            "latitude": 55.026563
        },
        "2573": {
            "name": "Отделение № 1 Опытного Хозя",
            "population": 359,
            "type": "village",
            "poly": null,
            "longitude": 74.032688,
            "latitude": 54.4399238
        },
        "2574": {
            "name": "Трубчевка",
            "population": 119,
            "type": "village",
            "poly": null,
            "longitude": 74.0340301,
            "latitude": 55.8485774
        },
        "2575": {
            "name": "Бельсенды-Казах",
            "population": 176,
            "type": "village",
            "poly": null,
            "longitude": 74.0354467,
            "latitude": 55.3569066
        },
        "2576": {
            "name": "Новопокровка",
            "population": 969,
            "type": "village",
            "poly": [
                [
                    74.0206707,
                    55.7140362
                ],
                [
                    74.045624,
                    55.716244
                ],
                [
                    74.0625224,
                    55.7198258
                ],
                [
                    74.0634177,
                    55.7183299
                ],
                [
                    74.0638767,
                    55.7173255
                ],
                [
                    74.0640196,
                    55.7148885
                ],
                [
                    74.0568901,
                    55.7141043
                ],
                [
                    74.056887,
                    55.7136564
                ],
                [
                    74.0566035,
                    55.7136321
                ],
                [
                    74.0574124,
                    55.6981546
                ],
                [
                    74.0234123,
                    55.6973413
                ],
                [
                    74.0246657,
                    55.7017889
                ],
                [
                    74.0226878,
                    55.7037885
                ],
                [
                    74.0217711,
                    55.7060063
                ],
                [
                    74.0209211,
                    55.7068596
                ],
                [
                    74.0206707,
                    55.7140362
                ]
            ],
            "longitude": 74.0371135,
            "latitude": 55.7091335
        },
        "2577": {
            "name": "Черноглазовка",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 74.03884,
            "latitude": 54.345721
        },
        "2578": {
            "name": "Алексеевка",
            "population": 313,
            "type": "village",
            "poly": null,
            "longitude": 74.0393759,
            "latitude": 55.5200461
        },
        "2579": {
            "name": "Ротовка",
            "population": 328,
            "type": "village",
            "poly": null,
            "longitude": 74.0451489,
            "latitude": 53.7764079
        },
        "2580": {
            "name": "Цветочное",
            "population": 1218,
            "type": "village",
            "poly": null,
            "longitude": 74.0494306,
            "latitude": 53.6640958
        },
        "2581": {
            "name": "Пашенная Роща",
            "population": 326,
            "type": "village",
            "poly": null,
            "longitude": 74.06200301743044,
            "latitude": 54.207753397701204
        },
        "2582": {
            "name": "Победитель",
            "population": 1360,
            "type": "village",
            "poly": null,
            "longitude": 74.067703,
            "latitude": 54.779404
        },
        "2583": {
            "name": "Алексеевский",
            "population": 1219,
            "type": "village",
            "poly": null,
            "longitude": 74.0683806,
            "latitude": 55.5366778
        },
        "2584": {
            "name": "Тихорецкое",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 74.0708305,
            "latitude": 54.4114708
        },
        "2585": {
            "name": "Орлово",
            "population": 389,
            "type": "village",
            "poly": null,
            "longitude": 74.0722808,
            "latitude": 56.6600964
        },
        "2586": {
            "name": "Старокарасук",
            "population": 628,
            "type": "village",
            "poly": null,
            "longitude": 74.0745873,
            "latitude": 55.810663
        },
        "2587": {
            "name": "Бутаково",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 74.086128,
            "latitude": 57.047527
        },
        "2588": {
            "name": "Жатва",
            "population": 495,
            "type": "village",
            "poly": null,
            "longitude": 74.086449,
            "latitude": 54.360023
        },
        "2589": {
            "name": "Прииртышье",
            "population": 1412,
            "type": "village",
            "poly": null,
            "longitude": 74.094917,
            "latitude": 54.533592
        },
        "2590": {
            "name": "Новоуральский",
            "population": 1868,
            "type": "village",
            "poly": null,
            "longitude": 74.125267,
            "latitude": 54.360226
        },
        "2591": {
            "name": "Некрасовка",
            "population": 739,
            "type": "village",
            "poly": null,
            "longitude": 74.1270663,
            "latitude": 54.8874579
        },
        "2592": {
            "name": "Рощинский",
            "population": 416,
            "type": "village",
            "poly": null,
            "longitude": 74.1335629,
            "latitude": 55.1050751
        },
        "2593": {
            "name": "Покрово-Иртышское",
            "population": 509,
            "type": "village",
            "poly": null,
            "longitude": 74.1438107,
            "latitude": 54.5574578
        },
        "2594": {
            "name": "Богдановка",
            "population": 588,
            "type": "village",
            "poly": null,
            "longitude": 74.1458855,
            "latitude": 55.0377849
        },
        "2595": {
            "name": "Пологрудово",
            "population": 723,
            "type": "village",
            "poly": null,
            "longitude": 74.162514,
            "latitude": 57.117008
        },
        "2596": {
            "name": "Сосновка",
            "population": 521,
            "type": "village",
            "poly": null,
            "longitude": 74.1708238,
            "latitude": 54.9234385
        },
        "2597": {
            "name": "Сягаевка",
            "population": 384,
            "type": "village",
            "poly": null,
            "longitude": 74.1740351,
            "latitude": 55.6106434
        },
        "2598": {
            "name": "Максима Горького",
            "population": 695,
            "type": "village",
            "poly": null,
            "longitude": 74.1846033,
            "latitude": 57.0970238
        },
        "2599": {
            "name": "Юрьево",
            "population": 1002,
            "type": "village",
            "poly": [
                [
                    74.1898532,
                    55.1431037
                ],
                [
                    74.1898652,
                    55.143333
                ],
                [
                    74.190476,
                    55.1456773
                ],
                [
                    74.1906257,
                    55.1458279
                ],
                [
                    74.1910029,
                    55.1458245
                ],
                [
                    74.1973025,
                    55.1453248
                ],
                [
                    74.1982035,
                    55.1476708
                ],
                [
                    74.1977277,
                    55.1478401
                ],
                [
                    74.1974283,
                    55.1477648
                ],
                [
                    74.1972007,
                    55.1477203
                ],
                [
                    74.1966678,
                    55.1479291
                ],
                [
                    74.1965959,
                    55.1480968
                ],
                [
                    74.1967097,
                    55.148261
                ],
                [
                    74.1974882,
                    55.1488119
                ],
                [
                    74.198009,
                    55.1490207
                ],
                [
                    74.1982606,
                    55.1491781
                ],
                [
                    74.1987216,
                    55.149534
                ],
                [
                    74.199596,
                    55.1498659
                ],
                [
                    74.2002906,
                    55.1498933
                ],
                [
                    74.2007996,
                    55.150232
                ],
                [
                    74.2005122,
                    55.1503757
                ],
                [
                    74.2004343,
                    55.150913
                ],
                [
                    74.2003625,
                    55.151197
                ],
                [
                    74.200093,
                    55.1515118
                ],
                [
                    74.1992607,
                    55.1522406
                ],
                [
                    74.1987696,
                    55.1524938
                ],
                [
                    74.1979073,
                    55.1526067
                ],
                [
                    74.1968534,
                    55.1526033
                ],
                [
                    74.1959372,
                    55.1525212
                ],
                [
                    74.1950869,
                    55.1523843
                ],
                [
                    74.1944881,
                    55.1521414
                ],
                [
                    74.1939252,
                    55.1521208
                ],
                [
                    74.1928593,
                    55.1519566
                ],
                [
                    74.1925958,
                    55.1520148
                ],
                [
                    74.1925538,
                    55.152244
                ],
                [
                    74.1920389,
                    55.1523501
                ],
                [
                    74.1997601,
                    55.1595409
                ],
                [
                    74.2133014,
                    55.1599328
                ],
                [
                    74.2136964,
                    55.1598483
                ],
                [
                    74.2138265,
                    55.1598795
                ],
                [
                    74.2154524,
                    55.1594635
                ],
                [
                    74.2150883,
                    55.1581475
                ],
                [
                    74.2148258,
                    55.1578088
                ],
                [
                    74.2145463,
                    55.157025
                ],
                [
                    74.2142245,
                    55.1574218
                ],
                [
                    74.2139958,
                    55.157296
                ],
                [
                    74.2139535,
                    55.1571073
                ],
                [
                    74.2138011,
                    55.1569863
                ],
                [
                    74.2119464,
                    55.1531251
                ],
                [
                    74.2118956,
                    55.1528251
                ],
                [
                    74.2120227,
                    55.1518283
                ],
                [
                    74.2119041,
                    55.1514895
                ],
                [
                    74.2106507,
                    55.1506621
                ],
                [
                    74.2106338,
                    55.1505024
                ],
                [
                    74.2107015,
                    55.1504249
                ],
                [
                    74.213945,
                    55.1485183
                ],
                [
                    74.209914,
                    55.144332
                ],
                [
                    74.2090163,
                    55.1447869
                ],
                [
                    74.2082965,
                    55.1448837
                ],
                [
                    74.207725,
                    55.1456294
                ],
                [
                    74.2071501,
                    55.1458074
                ],
                [
                    74.2064914,
                    55.1458621
                ],
                [
                    74.2060303,
                    55.1463241
                ],
                [
                    74.2059165,
                    55.1466561
                ],
                [
                    74.2053296,
                    55.1470222
                ],
                [
                    74.2050243,
                    55.147361
                ],
                [
                    74.2046051,
                    55.1473884
                ],
                [
                    74.2042279,
                    55.147207
                ],
                [
                    74.2038386,
                    55.1472002
                ],
                [
                    74.2036291,
                    55.1473816
                ],
                [
                    74.203677,
                    55.1476724
                ],
                [
                    74.203659,
                    55.1479188
                ],
                [
                    74.2033296,
                    55.1482987
                ],
                [
                    74.2030901,
                    55.1489095
                ],
                [
                    74.2027099,
                    55.149356
                ],
                [
                    74.2018925,
                    55.1497239
                ],
                [
                    74.2008296,
                    55.1493868
                ],
                [
                    74.2018236,
                    55.1485553
                ],
                [
                    74.1996379,
                    55.1471865
                ],
                [
                    74.1992068,
                    55.1450647
                ],
                [
                    74.1992427,
                    55.1445514
                ],
                [
                    74.199614,
                    55.1444761
                ],
                [
                    74.1981229,
                    55.1417827
                ],
                [
                    74.1974402,
                    55.1401569
                ],
                [
                    74.1973325,
                    55.1399379
                ],
                [
                    74.197045,
                    55.1398181
                ],
                [
                    74.1962187,
                    55.1396949
                ],
                [
                    74.1937575,
                    55.1395271
                ],
                [
                    74.1931619,
                    55.1396301
                ],
                [
                    74.1930449,
                    55.1396504
                ],
                [
                    74.1927575,
                    55.1398078
                ],
                [
                    74.1933623,
                    55.1404205
                ],
                [
                    74.193494,
                    55.1407285
                ],
                [
                    74.1926256,
                    55.1408859
                ],
                [
                    74.1923024,
                    55.1413001
                ],
                [
                    74.1919071,
                    55.1414301
                ],
                [
                    74.191913,
                    55.1417382
                ],
                [
                    74.191979,
                    55.1420291
                ],
                [
                    74.1921706,
                    55.1422071
                ],
                [
                    74.192476,
                    55.1423816
                ],
                [
                    74.1928413,
                    55.1427889
                ],
                [
                    74.1929251,
                    55.1431209
                ],
                [
                    74.1927036,
                    55.1432578
                ],
                [
                    74.1921107,
                    55.1432954
                ],
                [
                    74.1912844,
                    55.1432201
                ],
                [
                    74.1901287,
                    55.1430729
                ],
                [
                    74.1898532,
                    55.1431037
                ]
            ],
            "longitude": 74.199768,
            "latitude": 55.154942
        },
        "2600": {
            "name": "Новоуральское",
            "population": 805,
            "type": "village",
            "poly": null,
            "longitude": 74.2081151,
            "latitude": 54.2471668
        },
        "2601": {
            "name": "Ингалы",
            "population": 1117,
            "type": "village",
            "poly": null,
            "longitude": 74.2191009,
            "latitude": 55.8483434
        },
        "2602": {
            "name": "Уленкуль",
            "population": 613,
            "type": "village",
            "poly": null,
            "longitude": 74.2253828,
            "latitude": 56.3528608
        },
        "2603": {
            "name": "Бас-Агаш",
            "population": 291,
            "type": "village",
            "poly": null,
            "longitude": 74.2358813,
            "latitude": 53.9080133
        },
        "2604": {
            "name": "Рощино",
            "population": 412,
            "type": "village",
            "poly": [
                [
                    74.2209167,
                    55.461679
                ],
                [
                    74.2267916,
                    55.4621926
                ],
                [
                    74.2353544,
                    55.4628533
                ],
                [
                    74.2428209,
                    55.4634313
                ],
                [
                    74.2500268,
                    55.4639137
                ],
                [
                    74.2527757,
                    55.4533774
                ],
                [
                    74.2397241,
                    55.4525738
                ],
                [
                    74.239084,
                    55.4527934
                ],
                [
                    74.238601,
                    55.4530085
                ],
                [
                    74.2382905,
                    55.4531868
                ],
                [
                    74.2381219,
                    55.453428
                ],
                [
                    74.2378958,
                    55.4544648
                ],
                [
                    74.2282891,
                    55.4536446
                ],
                [
                    74.2239251,
                    55.4548378
                ],
                [
                    74.222391,
                    55.4570355
                ],
                [
                    74.2209167,
                    55.461679
                ]
            ],
            "longitude": 74.2371879,
            "latitude": 55.4562027
        },
        "2605": {
            "name": "Бобринка",
            "population": 1180,
            "type": "village",
            "poly": null,
            "longitude": 74.2379083,
            "latitude": 54.1192051
        },
        "2606": {
            "name": "Ударный",
            "population": 432,
            "type": "village",
            "poly": null,
            "longitude": 74.2394801,
            "latitude": 55.1874116
        },
        "2607": {
            "name": "Красная Поляна",
            "population": 693,
            "type": "village",
            "poly": null,
            "longitude": 74.2402578,
            "latitude": 55.2723517
        },
        "2608": {
            "name": "Новоселье",
            "population": 680,
            "type": "village",
            "poly": null,
            "longitude": 74.243912,
            "latitude": 54.867672
        },
        "2609": {
            "name": "Добровольск",
            "population": 947,
            "type": "village",
            "poly": null,
            "longitude": 74.2520587,
            "latitude": 53.6439885
        },
        "2610": {
            "name": "Байдалин",
            "population": 303,
            "type": "village",
            "poly": null,
            "longitude": 74.2639241,
            "latitude": 54.3923846
        },
        "2611": {
            "name": "Чекрушево",
            "population": 795,
            "type": "village",
            "poly": null,
            "longitude": 74.269045,
            "latitude": 56.9199865
        },
        "2612": {
            "name": "2-я Фоминовка",
            "population": 374,
            "type": "village",
            "poly": null,
            "longitude": 74.270332,
            "latitude": 54.801914
        },
        "2613": {
            "name": "Атирка",
            "population": 881,
            "type": "village",
            "poly": null,
            "longitude": 74.2723217,
            "latitude": 57.2542208
        },
        "2614": {
            "name": "Михайловка",
            "population": 808,
            "type": "village",
            "poly": null,
            "longitude": 74.276314,
            "latitude": 54.761314
        },
        "2615": {
            "name": "Верхнеильинка",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 74.283791,
            "latitude": 54.542915
        },
        "2616": {
            "name": "Георгиевка",
            "population": 731,
            "type": "village",
            "poly": null,
            "longitude": 74.302216,
            "latitude": 55.073986
        },
        "2617": {
            "name": "Кольтюгино",
            "population": 413,
            "type": "village",
            "poly": null,
            "longitude": 74.3112889,
            "latitude": 56.6881115
        },
        "2618": {
            "name": "Целинное",
            "population": 1016,
            "type": "village",
            "poly": null,
            "longitude": 74.3150849,
            "latitude": 53.9496295
        },
        "2619": {
            "name": "Курносово",
            "population": 632,
            "type": "village",
            "poly": null,
            "longitude": 74.3158147,
            "latitude": 56.1226815
        },
        "2620": {
            "name": "Серебряное",
            "population": 823,
            "type": "village",
            "poly": null,
            "longitude": 74.329918,
            "latitude": 55.707008
        },
        "2621": {
            "name": "Сибирское",
            "population": 941,
            "type": "village",
            "poly": null,
            "longitude": 74.3361003,
            "latitude": 53.7375484
        },
        "2622": {
            "name": "Пристанское",
            "population": 1747,
            "type": "village",
            "poly": null,
            "longitude": 74.3458071,
            "latitude": 54.4662964
        },
        "2623": {
            "name": "Самсоново",
            "population": 440,
            "type": "village",
            "poly": null,
            "longitude": 74.352623,
            "latitude": 56.973103
        },
        "2624": {
            "name": "Славянка",
            "population": 2101,
            "type": "village",
            "poly": null,
            "longitude": 74.5290353,
            "latitude": 54.1794225
        },
        "2625": {
            "name": "Иртыш",
            "population": 2532,
            "type": "village",
            "poly": null,
            "longitude": 74.377518,
            "latitude": 54.488911
        },
        "2626": {
            "name": "Рямовка",
            "population": 229,
            "type": "village",
            "poly": null,
            "longitude": 74.3794993,
            "latitude": 55.9858453
        },
        "2627": {
            "name": "Веселый Привал",
            "population": 395,
            "type": "village",
            "poly": null,
            "longitude": 74.3836522,
            "latitude": 54.8778883
        },
        "2628": {
            "name": "Яготово",
            "population": 170,
            "type": "village",
            "poly": null,
            "longitude": 74.3937285,
            "latitude": 56.4059867
        },
        "2629": {
            "name": "Индейка",
            "population": 738,
            "type": "village",
            "poly": null,
            "longitude": 74.416342,
            "latitude": 54.9622635
        },
        "2630": {
            "name": "Могильно-Старожильск",
            "population": 767,
            "type": "village",
            "poly": null,
            "longitude": 74.4198465,
            "latitude": 55.9017305
        },
        "2631": {
            "name": "Могильно-Посельское",
            "population": 508,
            "type": "village",
            "poly": null,
            "longitude": 74.4334901,
            "latitude": 55.9083403
        },
        "2632": {
            "name": "Астыровка",
            "population": 788,
            "type": "village",
            "poly": null,
            "longitude": 74.4340215,
            "latitude": 55.3602984
        },
        "2633": {
            "name": "Бердниково",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 74.4371679,
            "latitude": 54.4135551
        },
        "2634": {
            "name": "Куликово",
            "population": 1244,
            "type": "village",
            "poly": null,
            "longitude": 74.454369,
            "latitude": 55.044426
        },
        "2635": {
            "name": "Почекуево",
            "population": 794,
            "type": "village",
            "poly": null,
            "longitude": 74.4623073,
            "latitude": 56.5161028
        },
        "2636": {
            "name": "Царицыно",
            "population": 608,
            "type": "village",
            "poly": null,
            "longitude": 74.4886687,
            "latitude": 54.8271764
        },
        "2637": {
            "name": "Победа",
            "population": 1079,
            "type": "village",
            "poly": null,
            "longitude": 74.4895861,
            "latitude": 54.0492697
        },
        "2638": {
            "name": "Паутовка",
            "population": 521,
            "type": "village",
            "poly": null,
            "longitude": 74.4933324,
            "latitude": 55.4906272
        },
        "2639": {
            "name": "Черлакское",
            "population": 1024,
            "type": "village",
            "poly": null,
            "longitude": 74.503654,
            "latitude": 53.778271
        },
        "2640": {
            "name": "Фрунзе",
            "population": 291,
            "type": "village",
            "poly": null,
            "longitude": 74.5089106,
            "latitude": 56.825578
        },
        "2641": {
            "name": "Баженово",
            "population": 286,
            "type": "village",
            "poly": null,
            "longitude": 74.5114792,
            "latitude": 57.0583458
        },
        "2642": {
            "name": "Заливино",
            "population": 868,
            "type": "village",
            "poly": [
                [
                    74.504434,
                    56.8015135
                ],
                [
                    74.5062483,
                    56.8017256
                ],
                [
                    74.5069346,
                    56.8016028
                ],
                [
                    74.5074918,
                    56.8016437
                ],
                [
                    74.5099041,
                    56.8021088
                ],
                [
                    74.512031,
                    56.802239
                ],
                [
                    74.5122824,
                    56.8017553
                ],
                [
                    74.514715,
                    56.8025217
                ],
                [
                    74.516475,
                    56.802745
                ],
                [
                    74.5175486,
                    56.8027152
                ],
                [
                    74.5174603,
                    56.8022688
                ],
                [
                    74.5198725,
                    56.8022725
                ],
                [
                    74.5198453,
                    56.8006056
                ],
                [
                    74.5194105,
                    56.799988
                ],
                [
                    74.5193969,
                    56.7992587
                ],
                [
                    74.5196687,
                    56.7990541
                ],
                [
                    74.5199201,
                    56.7986299
                ],
                [
                    74.5199065,
                    56.7978894
                ],
                [
                    74.5201375,
                    56.7951172
                ],
                [
                    74.5188465,
                    56.7934575
                ],
                [
                    74.518697,
                    56.7930444
                ],
                [
                    74.5187921,
                    56.792702
                ],
                [
                    74.5189212,
                    56.7924713
                ],
                [
                    74.5196891,
                    56.791593
                ],
                [
                    74.5199201,
                    56.791273
                ],
                [
                    74.5197638,
                    56.790149
                ],
                [
                    74.5199201,
                    56.7900188
                ],
                [
                    74.5205656,
                    56.7899071
                ],
                [
                    74.5203958,
                    56.7887645
                ],
                [
                    74.5202599,
                    56.7886231
                ],
                [
                    74.5196755,
                    56.7886603
                ],
                [
                    74.5196143,
                    56.7881616
                ],
                [
                    74.5198046,
                    56.788102
                ],
                [
                    74.5196415,
                    56.7877894
                ],
                [
                    74.5193289,
                    56.7877856
                ],
                [
                    74.5193085,
                    56.7872683
                ],
                [
                    74.5192474,
                    56.7860884
                ],
                [
                    74.5190231,
                    56.7851095
                ],
                [
                    74.5184795,
                    56.7837657
                ],
                [
                    74.5183164,
                    56.7834419
                ],
                [
                    74.5179563,
                    56.7831776
                ],
                [
                    74.5177457,
                    56.782582
                ],
                [
                    74.5102579,
                    56.7821211
                ],
                [
                    74.504434,
                    56.8015135
                ]
            ],
            "longitude": 74.513741,
            "latitude": 56.792255
        },
        "2643": {
            "name": "Мартюшево",
            "population": 690,
            "type": "village",
            "poly": null,
            "longitude": 74.5159246,
            "latitude": 57.1167445
        },
        "2644": {
            "name": "Черняево",
            "population": 530,
            "type": "village",
            "poly": null,
            "longitude": 74.5227973,
            "latitude": 56.694627
        },
        "2645": {
            "name": "Семёновка",
            "population": 304,
            "type": "village",
            "poly": null,
            "longitude": 74.5228383,
            "latitude": 54.6244092
        },
        "2646": {
            "name": "Стародубка",
            "population": 529,
            "type": "village",
            "poly": null,
            "longitude": 74.5304652,
            "latitude": 55.0783064
        },
        "2647": {
            "name": "Каразюк",
            "population": 410,
            "type": "village",
            "poly": null,
            "longitude": 74.554817,
            "latitude": 54.070599
        },
        "2648": {
            "name": "Русановка",
            "population": 923,
            "type": "village",
            "poly": null,
            "longitude": 74.5559422,
            "latitude": 54.1256557
        },
        "2649": {
            "name": "Ботвино",
            "population": 89,
            "type": "village",
            "poly": null,
            "longitude": 74.5561653,
            "latitude": 56.2806931
        },
        "2650": {
            "name": "Старомалиновка",
            "population": 817,
            "type": "village",
            "poly": null,
            "longitude": 74.563553,
            "latitude": 55.857418
        },
        "2651": {
            "name": "Имшегал",
            "population": 266,
            "type": "village",
            "poly": null,
            "longitude": 74.564835,
            "latitude": 57.355339
        },
        "2652": {
            "name": "Шипицыно",
            "population": 1268,
            "type": "village",
            "poly": null,
            "longitude": 74.5666183,
            "latitude": 56.0173564
        },
        "2653": {
            "name": "Екатерининское",
            "population": 2317,
            "type": "village",
            "poly": null,
            "longitude": 74.579773,
            "latitude": 56.877277
        },
        "2654": {
            "name": "Заречное",
            "population": 1232,
            "type": "village",
            "poly": null,
            "longitude": 74.588073,
            "latitude": 54.3254404
        },
        "2655": {
            "name": "Междуречье",
            "population": 1288,
            "type": "village",
            "poly": null,
            "longitude": 74.5925199,
            "latitude": 56.8168164
        },
        "2656": {
            "name": "Осокино",
            "population": 1411,
            "type": "village",
            "poly": null,
            "longitude": 74.6105563,
            "latitude": 54.8917533
        },
        "2657": {
            "name": "Соляное",
            "population": 2052,
            "type": "village",
            "poly": null,
            "longitude": 74.6130458,
            "latitude": 54.3722162
        },
        "2658": {
            "name": "Красный Яр",
            "population": 1213,
            "type": "village",
            "poly": null,
            "longitude": 74.6132038,
            "latitude": 56.1456048
        },
        "2659": {
            "name": "Новологиново",
            "population": 851,
            "type": "village",
            "poly": null,
            "longitude": 74.6132405,
            "latitude": 56.5815935
        },
        "2660": {
            "name": "Воскресенка",
            "population": 2047,
            "type": "village",
            "poly": null,
            "longitude": 74.620895,
            "latitude": 55.083611
        },
        "2661": {
            "name": "Тургеневка",
            "population": 434,
            "type": "village",
            "poly": null,
            "longitude": 74.6319049,
            "latitude": 55.0738054
        },
        "2662": {
            "name": "Изумрудное",
            "population": 588,
            "type": "village",
            "poly": null,
            "longitude": 74.6366754,
            "latitude": 54.2182217
        },
        "2663": {
            "name": "Великорусское",
            "population": 627,
            "type": "village",
            "poly": null,
            "longitude": 74.637012,
            "latitude": 54.6520171
        },
        "2664": {
            "name": "Атак",
            "population": 378,
            "type": "village",
            "poly": null,
            "longitude": 74.6411715,
            "latitude": 56.8041697
        },
        "2665": {
            "name": "Кедровый",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 74.646722,
            "latitude": 57.3718194
        },
        "2666": {
            "name": "Гринское",
            "population": 359,
            "type": "village",
            "poly": null,
            "longitude": 74.6499746,
            "latitude": 54.3152145
        },
        "2667": {
            "name": "Усть-Тара",
            "population": 205,
            "type": "village",
            "poly": null,
            "longitude": 74.6550321,
            "latitude": 56.6741209
        },
        "2668": {
            "name": "Новороссийка",
            "population": 717,
            "type": "village",
            "poly": null,
            "longitude": 74.6691203,
            "latitude": 54.1143205
        },
        "2669": {
            "name": "Евгащино",
            "population": 1681,
            "type": "village",
            "poly": null,
            "longitude": 74.675644,
            "latitude": 56.424458
        },
        "2670": {
            "name": "Дробышево",
            "population": 322,
            "type": "village",
            "poly": null,
            "longitude": 74.6757916,
            "latitude": 53.9862578
        },
        "2671": {
            "name": "Елизаветинка",
            "population": 1399,
            "type": "village",
            "poly": null,
            "longitude": 74.6765646,
            "latitude": 54.2591971
        },
        "2672": {
            "name": "Такмык",
            "population": 1427,
            "type": "village",
            "poly": null,
            "longitude": 74.6833556,
            "latitude": 56.2496044
        },
        "2673": {
            "name": "Решетниково",
            "population": 292,
            "type": "village",
            "poly": null,
            "longitude": 74.702164,
            "latitude": 56.298401
        },
        "2674": {
            "name": "Глуховка",
            "population": 722,
            "type": "village",
            "poly": null,
            "longitude": 74.71199,
            "latitude": 55.086632
        },
        "2675": {
            "name": "Ермаковка",
            "population": 400,
            "type": "village",
            "poly": null,
            "longitude": 74.7205637,
            "latitude": 57.0418938
        },
        "2676": {
            "name": "Красный Яр",
            "population": 407,
            "type": "village",
            "poly": null,
            "longitude": 74.7238311,
            "latitude": 54.1408184
        },
        "2677": {
            "name": "Петровка",
            "population": 299,
            "type": "village",
            "poly": null,
            "longitude": 74.7366598,
            "latitude": 55.1004626
        },
        "2678": {
            "name": "Карташово",
            "population": 402,
            "type": "village",
            "poly": null,
            "longitude": 74.7385314,
            "latitude": 56.1168745
        },
        "2679": {
            "name": "Васисс",
            "population": 360,
            "type": "village",
            "poly": null,
            "longitude": 74.7436822,
            "latitude": 57.3601876
        },
        "2680": {
            "name": "Артын",
            "population": 1082,
            "type": "village",
            "poly": null,
            "longitude": 74.751274,
            "latitude": 56.152332
        },
        "2681": {
            "name": "Репинка",
            "population": 759,
            "type": "village",
            "poly": null,
            "longitude": 74.7527586,
            "latitude": 54.6041389
        },
        "2682": {
            "name": "Привольное",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 74.7598872,
            "latitude": 54.4145638
        },
        "2683": {
            "name": "Ситниково",
            "population": 536,
            "type": "village",
            "poly": null,
            "longitude": 74.7834049,
            "latitude": 55.6656041
        },
        "2684": {
            "name": "Богдановка",
            "population": 396,
            "type": "village",
            "poly": null,
            "longitude": 74.7848032,
            "latitude": 54.0881767
        },
        "2685": {
            "name": "Золотухино",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 74.7954851,
            "latitude": 54.4322986
        },
        "2686": {
            "name": "Путь Ленина",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 74.804802,
            "latitude": 54.248398
        },
        "2687": {
            "name": "Сорочино",
            "population": 1342,
            "type": "village",
            "poly": null,
            "longitude": 74.8115811,
            "latitude": 55.1094965
        },
        "2688": {
            "name": "Лагушино",
            "population": 585,
            "type": "village",
            "poly": null,
            "longitude": 74.8251618,
            "latitude": 54.9454408
        },
        "2689": {
            "name": "Смирновка",
            "population": 649,
            "type": "village",
            "poly": null,
            "longitude": 74.8342962,
            "latitude": 55.4762504
        },
        "2690": {
            "name": "Александровка",
            "population": 546,
            "type": "village",
            "poly": null,
            "longitude": 74.8532078,
            "latitude": 53.9720607
        },
        "2691": {
            "name": "Камышино-Курское",
            "population": 890,
            "type": "village",
            "poly": null,
            "longitude": 74.8539989,
            "latitude": 55.9672694
        },
        "2692": {
            "name": "Новый Свет",
            "population": 556,
            "type": "village",
            "poly": null,
            "longitude": 74.8565379,
            "latitude": 55.1186076
        },
        "2693": {
            "name": "Сергеевка",
            "population": 664,
            "type": "village",
            "poly": null,
            "longitude": 74.875534,
            "latitude": 54.8138229
        },
        "2694": {
            "name": "Нагорное",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 74.8873957,
            "latitude": 56.7285814
        },
        "2695": {
            "name": "Докучаевка",
            "population": 180,
            "type": "village",
            "poly": null,
            "longitude": 74.8964797,
            "latitude": 55.1781362
        },
        "2696": {
            "name": "Егоровка",
            "population": 263,
            "type": "village",
            "poly": null,
            "longitude": 74.8981415,
            "latitude": 57.1683685
        },
        "2697": {
            "name": "Золотая Нива",
            "population": 1299,
            "type": "village",
            "poly": [
                [
                    74.8869979,
                    54.9004046
                ],
                [
                    74.8872554,
                    54.9057344
                ],
                [
                    74.897598,
                    54.9085223
                ],
                [
                    74.9145924,
                    54.896703
                ],
                [
                    74.9172961,
                    54.8873981
                ],
                [
                    74.9057948,
                    54.8859602
                ],
                [
                    74.8941326,
                    54.8886385
                ],
                [
                    74.892491,
                    54.8892494
                ],
                [
                    74.8894011,
                    54.8912734
                ],
                [
                    74.8869979,
                    54.9004046
                ]
            ],
            "longitude": 74.900017,
            "latitude": 54.895344
        },
        "2698": {
            "name": "Унара",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 74.9004197,
            "latitude": 57.0555515
        },
        "2699": {
            "name": "Большегривское",
            "population": 3519,
            "type": "village",
            "poly": [
                [
                    74.8844537,
                    53.9147416
                ],
                [
                    74.8846137,
                    53.915142
                ],
                [
                    74.8923322,
                    53.9142469
                ],
                [
                    74.8925122,
                    53.9170853
                ],
                [
                    74.8965421,
                    53.9166267
                ],
                [
                    74.8979898,
                    53.914087
                ],
                [
                    74.9046108,
                    53.9132855
                ],
                [
                    74.9052795,
                    53.9159514
                ],
                [
                    74.9015304,
                    53.9165906
                ],
                [
                    74.9016504,
                    53.917945
                ],
                [
                    74.9009705,
                    53.919264
                ],
                [
                    74.9013505,
                    53.9197939
                ],
                [
                    74.9021503,
                    53.9197232
                ],
                [
                    74.9026902,
                    53.9202414
                ],
                [
                    74.90391,
                    53.9199352
                ],
                [
                    74.9048698,
                    53.9201354
                ],
                [
                    74.9051097,
                    53.9204416
                ],
                [
                    74.9094089,
                    53.9213483
                ],
                [
                    74.9102287,
                    53.9222315
                ],
                [
                    74.9120484,
                    53.9223257
                ],
                [
                    74.9187671,
                    53.9206418
                ],
                [
                    74.9182672,
                    53.9199117
                ],
                [
                    74.9217265,
                    53.9192051
                ],
                [
                    74.9211066,
                    53.9175917
                ],
                [
                    74.917398,
                    53.9182436
                ],
                [
                    74.916283,
                    53.9157365
                ],
                [
                    74.9186943,
                    53.9153687
                ],
                [
                    74.9191426,
                    53.91613
                ],
                [
                    74.9258457,
                    53.9144471
                ],
                [
                    74.929125,
                    53.9138936
                ],
                [
                    74.9281653,
                    53.911267
                ],
                [
                    74.929125,
                    53.9110079
                ],
                [
                    74.9286452,
                    53.9100303
                ],
                [
                    74.9301649,
                    53.9097947
                ],
                [
                    74.929625,
                    53.9088288
                ],
                [
                    74.9264856,
                    53.9093118
                ],
                [
                    74.9266856,
                    53.9099243
                ],
                [
                    74.9260057,
                    53.9101245
                ],
                [
                    74.9230663,
                    53.9094413
                ],
                [
                    74.9490213,
                    53.9055659
                ],
                [
                    74.9457019,
                    53.9049886
                ],
                [
                    74.9318446,
                    53.9072504
                ],
                [
                    74.9315446,
                    53.9067439
                ],
                [
                    74.9225264,
                    53.9082516
                ],
                [
                    74.9225464,
                    53.9088171
                ],
                [
                    74.9114485,
                    53.910525
                ],
                [
                    74.9107286,
                    53.910101
                ],
                [
                    74.90371,
                    53.9111257
                ],
                [
                    74.90389,
                    53.9113495
                ],
                [
                    74.8949516,
                    53.9123978
                ],
                [
                    74.8915523,
                    53.9136816
                ],
                [
                    74.8844537,
                    53.9147416
                ]
            ],
            "longitude": 74.910225,
            "latitude": 53.914665
        },
        "2700": {
            "name": "Береговое",
            "population": 290,
            "type": "village",
            "poly": null,
            "longitude": 74.9137427,
            "latitude": 53.9478727
        },
        "2701": {
            "name": "Хортицы",
            "population": 941,
            "type": "village",
            "poly": null,
            "longitude": 74.917068,
            "latitude": 55.586838
        },
        "2702": {
            "name": "Моховой Привал",
            "population": 616,
            "type": "village",
            "poly": null,
            "longitude": 74.9244979,
            "latitude": 56.0357043
        },
        "2703": {
            "name": "Макаркино",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 74.9351871,
            "latitude": 54.4433564
        },
        "2704": {
            "name": "Большой Атмас",
            "population": 2033,
            "type": "village",
            "poly": [
                [
                    74.9168001,
                    54.0810209
                ],
                [
                    74.9449726,
                    54.0802898
                ],
                [
                    74.9569322,
                    54.0707405
                ],
                [
                    74.9609527,
                    54.0661992
                ],
                [
                    74.9619899,
                    54.0633494
                ],
                [
                    74.9471176,
                    54.0494946
                ],
                [
                    74.9306439,
                    54.057476
                ],
                [
                    74.9168001,
                    54.0810209
                ]
            ],
            "longitude": 74.9354682,
            "latitude": 54.0658059
        },
        "2705": {
            "name": "Малый Атмас",
            "population": 384,
            "type": "village",
            "poly": null,
            "longitude": 74.9355799,
            "latitude": 53.9922852
        },
        "2706": {
            "name": "Алкул",
            "population": 284,
            "type": "village",
            "poly": null,
            "longitude": 74.9447718,
            "latitude": 53.9412046
        },
        "2707": {
            "name": "Поречье",
            "population": 232,
            "type": "village",
            "poly": null,
            "longitude": 74.9449999,
            "latitude": 56.5791861
        },
        "2708": {
            "name": "Костино",
            "population": 528,
            "type": "village",
            "poly": null,
            "longitude": 74.9482674,
            "latitude": 56.172302
        },
        "2709": {
            "name": "Антоновка",
            "population": 745,
            "type": "village",
            "poly": null,
            "longitude": 74.9539826,
            "latitude": 55.3486206
        },
        "2710": {
            "name": "Соловецкое",
            "population": 532,
            "type": "village",
            "poly": null,
            "longitude": 74.9957682,
            "latitude": 55.3133043
        },
        "2711": {
            "name": "Караман",
            "population": 352,
            "type": "village",
            "poly": null,
            "longitude": 74.9976563,
            "latitude": 53.8543348
        },
        "2712": {
            "name": "Ермак",
            "population": 1032,
            "type": "village",
            "poly": [
                [
                    75.0070788,
                    53.9414091
                ],
                [
                    75.0071782,
                    53.9459404
                ],
                [
                    75.0104315,
                    53.9461523
                ],
                [
                    75.0103197,
                    53.9478916
                ],
                [
                    75.0106301,
                    53.9487905
                ],
                [
                    75.0117353,
                    53.9506758
                ],
                [
                    75.0126417,
                    53.9512092
                ],
                [
                    75.0142684,
                    53.9513481
                ],
                [
                    75.0157336,
                    53.9512458
                ],
                [
                    75.0179066,
                    53.950252
                ],
                [
                    75.0197692,
                    53.9485712
                ],
                [
                    75.0202535,
                    53.9449538
                ],
                [
                    75.0214952,
                    53.9414091
                ],
                [
                    75.0203155,
                    53.9391433
                ],
                [
                    75.0169629,
                    53.9392456
                ],
                [
                    75.0133992,
                    53.9390483
                ],
                [
                    75.0100341,
                    53.9390775
                ],
                [
                    75.0102204,
                    53.9414676
                ],
                [
                    75.0070788,
                    53.9414091
                ]
            ],
            "longitude": 75.0136051,
            "latitude": 53.9454121
        },
        "2713": {
            "name": "Красный Октябрь",
            "population": 1307,
            "type": "village",
            "poly": null,
            "longitude": 75.0146464,
            "latitude": 54.1328053
        },
        "2714": {
            "name": "Николаевка",
            "population": 1032,
            "type": "village",
            "poly": null,
            "longitude": 75.016314,
            "latitude": 54.2589123
        },
        "2715": {
            "name": "Глухониколаевка",
            "population": 550,
            "type": "village",
            "poly": null,
            "longitude": 75.0315202,
            "latitude": 55.2874188
        },
        "2716": {
            "name": "Бергамак",
            "population": 638,
            "type": "village",
            "poly": null,
            "longitude": 75.053276,
            "latitude": 56.413803
        },
        "2717": {
            "name": "Южно-Подольск",
            "population": 1008,
            "type": "village",
            "poly": null,
            "longitude": 75.0559459,
            "latitude": 54.414883
        },
        "2718": {
            "name": "Татарка",
            "population": 1339,
            "type": "village",
            "poly": null,
            "longitude": 75.0638202,
            "latitude": 53.9627235
        },
        "2719": {
            "name": "Маяк",
            "population": 761,
            "type": "village",
            "poly": null,
            "longitude": 75.064514,
            "latitude": 54.5586627
        },
        "2720": {
            "name": "Кукарка",
            "population": 345,
            "type": "village",
            "poly": null,
            "longitude": 75.0665331,
            "latitude": 56.9407239
        },
        "2721": {
            "name": "Новотроицк",
            "population": 527,
            "type": "village",
            "poly": null,
            "longitude": 75.0777789,
            "latitude": 55.7913949
        },
        "2722": {
            "name": "Лисино",
            "population": 558,
            "type": "village",
            "poly": null,
            "longitude": 75.0895564,
            "latitude": 56.3986059
        },
        "2723": {
            "name": "Львовка",
            "population": 242,
            "type": "village",
            "poly": null,
            "longitude": 75.0919245,
            "latitude": 55.0420233
        },
        "2724": {
            "name": "Литковка",
            "population": 428,
            "type": "village",
            "poly": null,
            "longitude": 75.105873,
            "latitude": 57.342171
        },
        "2725": {
            "name": "Любимовка",
            "population": 1348,
            "type": "village",
            "poly": null,
            "longitude": 75.1117261,
            "latitude": 54.6683803
        },
        "2726": {
            "name": "Орловка",
            "population": 419,
            "type": "village",
            "poly": null,
            "longitude": 75.1343616,
            "latitude": 55.1933594
        },
        "2727": {
            "name": "Хомутинка",
            "population": 767,
            "type": "village",
            "poly": null,
            "longitude": 75.1392035,
            "latitude": 55.4969176
        },
        "2728": {
            "name": "Гурово",
            "population": 760,
            "type": "village",
            "poly": null,
            "longitude": 75.1547496,
            "latitude": 56.3045427
        },
        "2729": {
            "name": "Кокшенево",
            "population": 284,
            "type": "village",
            "poly": null,
            "longitude": 75.1615566,
            "latitude": 56.3870842
        },
        "2730": {
            "name": "Красовка",
            "population": 722,
            "type": "village",
            "poly": [
                [
                    75.1618151,
                    54.9342965
                ],
                [
                    75.1685711,
                    54.9352081
                ],
                [
                    75.1675986,
                    54.9370017
                ],
                [
                    75.172768,
                    54.9378544
                ],
                [
                    75.1764019,
                    54.9283269
                ],
                [
                    75.1799846,
                    54.9258859
                ],
                [
                    75.1848981,
                    54.920621
                ],
                [
                    75.1754295,
                    54.916591
                ],
                [
                    75.1643454,
                    54.9186244
                ],
                [
                    75.1623781,
                    54.927974
                ],
                [
                    75.1618151,
                    54.9342965
                ]
            ],
            "longitude": 75.168221,
            "latitude": 54.925247
        },
        "2731": {
            "name": "Новоуйка",
            "population": 210,
            "type": "village",
            "poly": null,
            "longitude": 75.1983577,
            "latitude": 57.0309621
        },
        "2732": {
            "name": "Кабанье",
            "population": 656,
            "type": "village",
            "poly": [
                [
                    75.1930045,
                    54.9910111
                ],
                [
                    75.198326,
                    54.994704
                ],
                [
                    75.1941203,
                    55.0003166
                ],
                [
                    75.2161057,
                    55.0075946
                ],
                [
                    75.2207621,
                    54.9997554
                ],
                [
                    75.2186721,
                    54.9985443
                ],
                [
                    75.2134665,
                    54.9913459
                ],
                [
                    75.1952618,
                    54.9878029
                ],
                [
                    75.1930045,
                    54.9910111
                ]
            ],
            "longitude": 75.2073631,
            "latitude": 54.9993201
        },
        "2733": {
            "name": "Рязаны",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 75.209,
            "latitude": 56.571251
        },
        "2734": {
            "name": "Ивановка",
            "population": 1101,
            "type": "village",
            "poly": null,
            "longitude": 75.214714,
            "latitude": 55.129902
        },
        "2735": {
            "name": "Первый Шаг",
            "population": 299,
            "type": "village",
            "poly": null,
            "longitude": 75.2564144,
            "latitude": 54.0687057
        },
        "2736": {
            "name": "Голубовка",
            "population": 448,
            "type": "village",
            "poly": null,
            "longitude": 75.2672394,
            "latitude": 56.8804031
        },
        "2737": {
            "name": "Ковалево",
            "population": 401,
            "type": "village",
            "poly": [
                [
                    75.266152,
                    55.0997772
                ],
                [
                    75.2663835,
                    55.0999949
                ],
                [
                    75.2693706,
                    55.1011868
                ],
                [
                    75.2720027,
                    55.09973
                ],
                [
                    75.2741415,
                    55.1006083
                ],
                [
                    75.2770325,
                    55.0991497
                ],
                [
                    75.2783997,
                    55.0998749
                ],
                [
                    75.2832484,
                    55.1000405
                ],
                [
                    75.2929277,
                    55.1005395
                ],
                [
                    75.2958395,
                    55.1025038
                ],
                [
                    75.3013591,
                    55.1004649
                ],
                [
                    75.3026631,
                    55.0981523
                ],
                [
                    75.2982734,
                    55.0957898
                ],
                [
                    75.2896956,
                    55.0904677
                ],
                [
                    75.2792323,
                    55.0918122
                ],
                [
                    75.2708299,
                    55.0872568
                ],
                [
                    75.2672769,
                    55.0875438
                ],
                [
                    75.2669412,
                    55.087571
                ],
                [
                    75.269013,
                    55.0977883
                ],
                [
                    75.266152,
                    55.0997772
                ]
            ],
            "longitude": 75.278119,
            "latitude": 55.0954379
        },
        "2738": {
            "name": "Дурново",
            "population": 493,
            "type": "village",
            "poly": null,
            "longitude": 75.4102676,
            "latitude": 56.2956754
        },
        "2739": {
            "name": "Мыс",
            "population": 579,
            "type": "village",
            "poly": null,
            "longitude": 75.42848780474176,
            "latitude": 56.3501982840876
        },
        "2740": {
            "name": "Крестики",
            "population": 752,
            "type": "village",
            "poly": null,
            "longitude": 75.436485,
            "latitude": 54.628708
        },
        "2741": {
            "name": "Евлантьевка",
            "population": 256,
            "type": "village",
            "poly": null,
            "longitude": 75.4645396,
            "latitude": 56.9294052
        },
        "2742": {
            "name": "Куломзино",
            "population": 474,
            "type": "village",
            "poly": null,
            "longitude": 75.4667271,
            "latitude": 54.8325258
        },
        "2743": {
            "name": "Медет",
            "population": 242,
            "type": "village",
            "poly": null,
            "longitude": 75.539387,
            "latitude": 54.1831127
        },
        "2744": {
            "name": "Чистово",
            "population": 909,
            "type": "village",
            "poly": null,
            "longitude": 75.5533146,
            "latitude": 54.6804795
        },
        "2745": {
            "name": "Кондратьево",
            "population": 445,
            "type": "village",
            "poly": null,
            "longitude": 75.5700445,
            "latitude": 56.4587457
        },
        "2746": {
            "name": "Джартаргуль",
            "population": 208,
            "type": "village",
            "poly": null,
            "longitude": 75.5740345,
            "latitude": 54.3810072
        },
        "2747": {
            "name": "Бакино",
            "population": 193,
            "type": "village",
            "poly": null,
            "longitude": 75.6693971,
            "latitude": 56.8300027
        },
        "2748": {
            "name": "Ушаково",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 75.68688737833563,
            "latitude": 56.36510244026156
        },
        "2749": {
            "name": "Кейзес",
            "population": 939,
            "type": "village",
            "poly": null,
            "longitude": 75.734657,
            "latitude": 56.936356
        },
        "2750": {
            "name": "Курганка",
            "population": 264,
            "type": "village",
            "poly": null,
            "longitude": 75.8235397,
            "latitude": 56.4430373
        },
        "2751": {
            "name": "Лебединка",
            "population": 273,
            "type": "village",
            "poly": null,
            "longitude": 75.8406454,
            "latitude": 56.9209409
        },
        "2752": {
            "name": "Низовое",
            "population": 695,
            "type": "village",
            "poly": null,
            "longitude": 75.860832,
            "latitude": 56.395493
        },
        "2753": {
            "name": "Карбыза",
            "population": 345,
            "type": "village",
            "poly": null,
            "longitude": 75.918427,
            "latitude": 56.588669
        },
        "2754": {
            "name": "Рагозино",
            "population": 445,
            "type": "village",
            "poly": null,
            "longitude": 75.9393579,
            "latitude": 56.9370605
        },
        "2755": {
            "name": "Саратовка",
            "population": 119,
            "type": "village",
            "poly": null,
            "longitude": 75.9434827,
            "latitude": 57.0762912
        },
        "2756": {
            "name": "Ельничное",
            "population": 239,
            "type": "village",
            "poly": null,
            "longitude": 76.1551364,
            "latitude": 56.9216264
        },
        "2757": {
            "name": "Новый Васюган",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 76.502968,
            "latitude": 58.576908
        },
        "2758": {
            "name": "Катыльга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 76.7220858,
            "latitude": 59.0682965
        },
        "2759": {
            "name": "Северный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 77.176849,
            "latitude": 60.680233
        },
        "2760": {
            "name": "Майск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 77.2222909,
            "latitude": 57.8111957
        },
        "2761": {
            "name": "Новый Тевриз",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 77.531815,
            "latitude": 59.141102
        },
        "2762": {
            "name": "Средний Васюган",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 78.238243,
            "latitude": 59.223167
        },
        "2763": {
            "name": "Лукашкин Яр",
            "population": 402,
            "type": "village",
            "poly": null,
            "longitude": 78.395966,
            "latitude": 60.328899
        },
        "2764": {
            "name": "Мыльджино",
            "population": null,
            "type": "village",
            "poly": [
                [
                    78.4276192,
                    58.9816953
                ],
                [
                    78.4310524,
                    58.9885944
                ],
                [
                    78.4648697,
                    58.9993782
                ],
                [
                    78.4741394,
                    59.0061102
                ],
                [
                    78.5027983,
                    58.9927598
                ],
                [
                    78.4879839,
                    58.9908762
                ],
                [
                    78.4849026,
                    58.9956867
                ],
                [
                    78.4796326,
                    58.9922292
                ],
                [
                    78.467273,
                    58.9916013
                ],
                [
                    78.4336273,
                    58.9800146
                ],
                [
                    78.4276192,
                    58.9816953
                ]
            ],
            "longitude": 78.454674,
            "latitude": 58.992275
        },
        "2765": {
            "name": "вахт.п.Лугинецкий",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 78.8759211,
            "latitude": 58.1611298
        },
        "2766": {
            "name": "Назино",
            "population": 402,
            "type": "village",
            "poly": null,
            "longitude": 78.939453,
            "latitude": 60.127083
        },
        "2767": {
            "name": "Новоникольское",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 79.210281,
            "latitude": 59.764801
        },
        "2768": {
            "name": "Октябрьский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 79.406624,
            "latitude": 59.485847
        },
        "2769": {
            "name": "Пудино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 79.446182,
            "latitude": 57.571121
        },
        "2770": {
            "name": "Старая Берёзовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 79.548805,
            "latitude": 58.983143
        },
        "2771": {
            "name": "Вертикос",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 79.680962,
            "latitude": 59.382378
        },
        "2772": {
            "name": "Усть-Тым",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.024078,
            "latitude": 59.439648
        },
        "2773": {
            "name": "Большая Грива",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.244484,
            "latitude": 58.927742
        },
        "2774": {
            "name": "Тымск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.2977876,
            "latitude": 59.3757885
        },
        "2775": {
            "name": "Завьялово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.3888718,
            "latitude": 59.198017
        },
        "2776": {
            "name": "Киевский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.393082,
            "latitude": 59.770733
        },
        "2777": {
            "name": "Староюгино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.484955,
            "latitude": 59.002155
        },
        "2778": {
            "name": "Новоюгино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.569611,
            "latitude": 58.991562
        },
        "2779": {
            "name": "Старица",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.5747933,
            "latitude": 58.1379744
        },
        "2780": {
            "name": "Киндал",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.5821,
            "latitude": 59.153996
        },
        "2781": {
            "name": "Неготка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.644218,
            "latitude": 59.726353
        },
        "2782": {
            "name": "Лозунга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.67511,
            "latitude": 58.986984
        },
        "2783": {
            "name": "Бондарка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.735779,
            "latitude": 59.031776
        },
        "2784": {
            "name": "5-й километр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.8024023,
            "latitude": 59.0630876
        },
        "2785": {
            "name": "Нефтяников",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.836067,
            "latitude": 59.046715
        },
        "2786": {
            "name": "Геологический",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.846413,
            "latitude": 59.034485
        },
        "2787": {
            "name": "Павлово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.918602,
            "latitude": 59.002262
        },
        "2788": {
            "name": "Пашня",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.923843,
            "latitude": 58.985752
        },
        "2789": {
            "name": "Сосновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.2987425,
            "latitude": 59.1216147
        },
        "2790": {
            "name": "Заводской",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.3163398,
            "latitude": 58.6749581
        },
        "2791": {
            "name": "Высокий Яр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.3224449,
            "latitude": 58.7625493
        },
        "2792": {
            "name": "Прокоп",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.3516952,
            "latitude": 58.7066838
        },
        "2793": {
            "name": "Парбиг",
            "population": 1500,
            "type": "village",
            "poly": null,
            "longitude": 81.406067,
            "latitude": 57.230362
        },
        "2794": {
            "name": "Толмачево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.4415832,
            "latitude": 58.7086125
        },
        "2795": {
            "name": "Бугры",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.4779906,
            "latitude": 58.6840329
        },
        "2796": {
            "name": "Костарево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.479884,
            "latitude": 58.7187507
        },
        "2797": {
            "name": "Кирзавод",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.4925027,
            "latitude": 58.681218
        },
        "2798": {
            "name": "Сухушино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.5167268,
            "latitude": 58.6750186
        },
        "2799": {
            "name": "Шпалозавод",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.555504,
            "latitude": 58.932831
        },
        "2800": {
            "name": "Талиновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.5777226,
            "latitude": 58.9795552
        },
        "2801": {
            "name": "Малое Нестерово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.5795938,
            "latitude": 58.6601838
        },
        "2802": {
            "name": "Нарым",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.601074,
            "latitude": 58.928993
        },
        "2803": {
            "name": "Луговское",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.6412073,
            "latitude": 58.9010733
        },
        "2804": {
            "name": "Новосельцево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.6924959,
            "latitude": 58.6368731
        },
        "2805": {
            "name": "Молодежный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.7237868,
            "latitude": 59.9252916
        },
        "2806": {
            "name": "Верхняя Чигара",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.8129072,
            "latitude": 58.5651206
        },
        "2807": {
            "name": "Крыловка",
            "population": 300,
            "type": "village",
            "poly": null,
            "longitude": 81.898788,
            "latitude": 57.452362
        },
        "2808": {
            "name": "Высокий Яр",
            "population": 200,
            "type": "village",
            "poly": null,
            "longitude": 81.913658,
            "latitude": 57.323238
        },
        "2809": {
            "name": "Напас",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.004333,
            "latitude": 59.889999
        },
        "2810": {
            "name": "Вавиловка",
            "population": 150,
            "type": "village",
            "poly": null,
            "longitude": 82.028336,
            "latitude": 57.054386
        },
        "2811": {
            "name": "Пасека",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.0545745,
            "latitude": 58.5002338
        },
        "2812": {
            "name": "Инкино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.126717,
            "latitude": 58.48243
        },
        "2813": {
            "name": "Гореловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.2203491,
            "latitude": 57.4766938
        },
        "2814": {
            "name": "Копыловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.269485,
            "latitude": 58.674797
        },
        "2815": {
            "name": "Усть-Бакчар",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.319565,
            "latitude": 57.610844
        },
        "2816": {
            "name": "Новые Ключи",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.3404002,
            "latitude": 57.6192339
        },
        "2817": {
            "name": "Поротниково",
            "population": 170,
            "type": "village",
            "poly": null,
            "longitude": 82.345993,
            "latitude": 57.005028
        },
        "2818": {
            "name": "Третья Тига",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.3763504,
            "latitude": 57.4944703
        },
        "2819": {
            "name": "Иванкино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.4292547,
            "latitude": 58.4410019
        },
        "2820": {
            "name": "Варгатёр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.4447936,
            "latitude": 57.675592
        },
        "2821": {
            "name": "Стрельниково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.445621,
            "latitude": 57.7135513
        },
        "2822": {
            "name": "Лесоучасток Чая",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.4652038,
            "latitude": 57.7057451
        },
        "2823": {
            "name": "Куржино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.565392,
            "latitude": 58.908764
        },
        "2824": {
            "name": "Чаинск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.595982,
            "latitude": 57.9288357
        },
        "2825": {
            "name": "Черёмушки",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.609952,
            "latitude": 57.7736177
        },
        "2826": {
            "name": "Элитное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.6118403,
            "latitude": 57.7597924
        },
        "2827": {
            "name": "Григорьевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.6250582,
            "latitude": 57.7560376
        },
        "2828": {
            "name": "Усть-Чая",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.6352339,
            "latitude": 58.2712065
        },
        "2829": {
            "name": "Минеевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.63584,
            "latitude": 57.8249757
        },
        "2830": {
            "name": "Новогорное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.6391883,
            "latitude": 58.2495626
        },
        "2831": {
            "name": "Гришкино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.6475904,
            "latitude": 58.0395966
        },
        "2832": {
            "name": "Мушкино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.6564688,
            "latitude": 57.8055418
        },
        "2833": {
            "name": "Кирпичное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.6575742,
            "latitude": 57.7682153
        },
        "2834": {
            "name": "Игнашкино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.7441934,
            "latitude": 58.0783504
        },
        "2835": {
            "name": "Ермиловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.7514528,
            "latitude": 57.7134671
        },
        "2836": {
            "name": "Могильный Мыс",
            "population": null,
            "type": "village",
            "poly": [
                [
                    82.796353,
                    58.1206662
                ],
                [
                    82.8108197,
                    58.1245926
                ],
                [
                    82.8130471,
                    58.1235671
                ],
                [
                    82.8180553,
                    58.1247048
                ],
                [
                    82.8218919,
                    58.1207171
                ],
                [
                    82.8051935,
                    58.1165862
                ],
                [
                    82.796353,
                    58.1206662
                ]
            ],
            "longitude": 82.8110932,
            "latitude": 58.1201214
        },
        "2837": {
            "name": "Чажемто",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.820007,
            "latitude": 58.062641
        },
        "2838": {
            "name": "Березовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.826145,
            "latitude": 59.3624889
        },
        "2839": {
            "name": "Тогур",
            "population": 8418,
            "type": "village",
            "poly": [
                [
                    82.8176231,
                    58.3551207
                ],
                [
                    82.8181914,
                    58.366301
                ],
                [
                    82.8211992,
                    58.3691798
                ],
                [
                    82.82899,
                    58.3647359
                ],
                [
                    82.8450459,
                    58.3708838
                ],
                [
                    82.8514399,
                    58.3754288
                ],
                [
                    82.8538553,
                    58.3785579
                ],
                [
                    82.8591126,
                    58.3785951
                ],
                [
                    82.8660038,
                    58.3794146
                ],
                [
                    82.8662169,
                    58.3770306
                ],
                [
                    82.8641567,
                    58.3734917
                ],
                [
                    82.8669274,
                    58.3691327
                ],
                [
                    82.8583311,
                    58.3633199
                ],
                [
                    82.8579048,
                    58.3607113
                ],
                [
                    82.8532159,
                    58.3593324
                ],
                [
                    82.8494506,
                    58.3544498
                ],
                [
                    82.8561998,
                    58.3514678
                ],
                [
                    82.8628068,
                    58.352176
                ],
                [
                    82.8668563,
                    58.3503867
                ],
                [
                    82.8693429,
                    58.3419608
                ],
                [
                    82.8599651,
                    58.3390523
                ],
                [
                    82.8506584,
                    58.346696
                ],
                [
                    82.8425594,
                    58.3515796
                ],
                [
                    82.8284927,
                    58.3559035
                ],
                [
                    82.8197543,
                    58.3538534
                ],
                [
                    82.8176231,
                    58.3551207
                ]
            ],
            "longitude": 82.829697,
            "latitude": 58.358292
        },
        "2840": {
            "name": "Сухой Лог",
            "population": null,
            "type": "village",
            "poly": [
                [
                    82.8129006,
                    57.6938086
                ],
                [
                    82.8178788,
                    57.6960104
                ],
                [
                    82.8271485,
                    57.6984872
                ],
                [
                    82.8307534,
                    57.7019728
                ],
                [
                    82.8302384,
                    57.7048161
                ],
                [
                    82.8338433,
                    57.7072924
                ],
                [
                    82.8388215,
                    57.7057333
                ],
                [
                    82.8417397,
                    57.7027983
                ],
                [
                    82.8395081,
                    57.6997714
                ],
                [
                    82.8343583,
                    57.6961021
                ],
                [
                    82.8273202,
                    57.6891294
                ],
                [
                    82.8183938,
                    57.6903222
                ],
                [
                    82.8129006,
                    57.6938086
                ]
            ],
            "longitude": 82.8337753,
            "latitude": 57.6996863
        },
        "2841": {
            "name": "Новокороткино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.8767347,
            "latitude": 58.0029332
        },
        "2842": {
            "name": "Озёрное",
            "population": null,
            "type": "village",
            "poly": [
                [
                    82.8836525,
                    58.2259798
                ],
                [
                    82.895632,
                    58.2315713
                ],
                [
                    82.8970575,
                    58.2339583
                ],
                [
                    82.8987853,
                    58.239314
                ],
                [
                    82.9054337,
                    58.2413159
                ],
                [
                    82.9062559,
                    58.2386876
                ],
                [
                    82.9030641,
                    58.2239359
                ],
                [
                    82.9024938,
                    58.2216411
                ],
                [
                    82.8997687,
                    58.2175049
                ],
                [
                    82.8917195,
                    58.2194803
                ],
                [
                    82.8910205,
                    58.2214326
                ],
                [
                    82.8836525,
                    58.2259798
                ]
            ],
            "longitude": 82.9012929,
            "latitude": 58.226754
        },
        "2843": {
            "name": "Дальнее",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.9391583,
            "latitude": 58.7195711
        },
        "2844": {
            "name": "Сугот",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.9767117,
            "latitude": 57.9880846
        },
        "2845": {
            "name": "Новоселово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 82.9987551,
            "latitude": 58.3980744
        },
        "2846": {
            "name": "Чемондаевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.0061983,
            "latitude": 57.7426139
        },
        "2847": {
            "name": "Староабрамкино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.0581977,
            "latitude": 57.9659045
        },
        "2848": {
            "name": "Маракса 1-я",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.0689573,
            "latitude": 58.3818398
        },
        "2849": {
            "name": "Чугунка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.0756921,
            "latitude": 58.2914064
        },
        "2850": {
            "name": "Плотниково",
            "population": 300,
            "type": "village",
            "poly": [
                [
                    83.0695123,
                    56.8575625
                ],
                [
                    83.0735335,
                    56.860955
                ],
                [
                    83.074748,
                    56.8702748
                ],
                [
                    83.0753489,
                    56.8706031
                ],
                [
                    83.0792842,
                    56.8705727
                ],
                [
                    83.0841894,
                    56.8622055
                ],
                [
                    83.0859919,
                    56.8540429
                ],
                [
                    83.0855627,
                    56.8487864
                ],
                [
                    83.0862494,
                    56.8456415
                ],
                [
                    83.0825586,
                    56.8447965
                ],
                [
                    83.0763788,
                    56.8515086
                ],
                [
                    83.0763788,
                    56.8550284
                ],
                [
                    83.0695123,
                    56.8575625
                ]
            ],
            "longitude": 83.0803571,
            "latitude": 56.8575642
        },
        "2851": {
            "name": "Коломинские Гривы",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.1457896,
            "latitude": 57.7962504
        },
        "2852": {
            "name": "Леботёр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.178349,
            "latitude": 57.8787863
        },
        "2853": {
            "name": "Большая Саровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.2506021,
            "latitude": 58.1032319
        },
        "2854": {
            "name": "Павлов Мыс",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.2540048,
            "latitude": 58.4103873
        },
        "2855": {
            "name": "Новоколомино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.2696374,
            "latitude": 57.8284961
        },
        "2856": {
            "name": "Хмелёвка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.329514,
            "latitude": 56.285652
        },
        "2857": {
            "name": "Елгай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.334297,
            "latitude": 56.25124
        },
        "2858": {
            "name": "Новая Тювинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.3412315,
            "latitude": 57.5694089
        },
        "2859": {
            "name": "Белояровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.3430722,
            "latitude": 58.4227649
        },
        "2860": {
            "name": "Базой",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.363556,
            "latitude": 55.747101
        },
        "2861": {
            "name": "Обское",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.3865388,
            "latitude": 57.7406433
        },
        "2862": {
            "name": "Князевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.3877243,
            "latitude": 57.505461
        },
        "2863": {
            "name": "Новоуспенка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.420128,
            "latitude": 56.383095
        },
        "2864": {
            "name": "Новая Ювала",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.424271,
            "latitude": 56.292034
        },
        "2865": {
            "name": "Палочка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.610641,
            "latitude": 58.378704
        },
        "2866": {
            "name": "Кожевниково-на-Шегарке",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.426651,
            "latitude": 56.440834
        },
        "2867": {
            "name": "Колбинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.4325064,
            "latitude": 57.5137704
        },
        "2868": {
            "name": "Терсалгай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.441238,
            "latitude": 56.383476
        },
        "2869": {
            "name": "Старая Ювала",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.441788,
            "latitude": 56.311939
        },
        "2870": {
            "name": "Песочнодубровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.453773,
            "latitude": 56.406845
        },
        "2871": {
            "name": "Сарафановка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.4565766,
            "latitude": 57.7134205
        },
        "2872": {
            "name": "Вороновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.464707,
            "latitude": 56.8255473
        },
        "2873": {
            "name": "Муллова",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.482178,
            "latitude": 56.449005
        },
        "2874": {
            "name": "Малиновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.4824458,
            "latitude": 57.3685456
        },
        "2875": {
            "name": "Тунгусово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.484917,
            "latitude": 57.620281
        },
        "2876": {
            "name": "Осиновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.495827,
            "latitude": 55.955612
        },
        "2877": {
            "name": "Чилино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.527153,
            "latitude": 55.835213
        },
        "2878": {
            "name": "Борзуновка",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 83.553787,
            "latitude": 56.139809
        },
        "2879": {
            "name": "Татьяновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.56221,
            "latitude": 56.82198
        },
        "2880": {
            "name": "Нарга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.563866,
            "latitude": 57.682804
        },
        "2881": {
            "name": "Маркелово",
            "population": null,
            "type": "village",
            "poly": [
                [
                    83.5550532,
                    56.7045732
                ],
                [
                    83.5557399,
                    56.7090961
                ],
                [
                    83.5560832,
                    56.7126765
                ],
                [
                    83.5610614,
                    56.7126765
                ],
                [
                    83.5648379,
                    56.7123938
                ],
                [
                    83.5691295,
                    56.7110748
                ],
                [
                    83.5679278,
                    56.7088135
                ],
                [
                    83.5693011,
                    56.707777
                ],
                [
                    83.5713611,
                    56.7039135
                ],
                [
                    83.5751376,
                    56.6991072
                ],
                [
                    83.5636363,
                    56.6967509
                ],
                [
                    83.5591731,
                    56.6999554
                ],
                [
                    83.5569414,
                    56.7024999
                ],
                [
                    83.5550532,
                    56.7045732
                ]
            ],
            "longitude": 83.5649495,
            "latitude": 56.7040831
        },
        "2882": {
            "name": "Анастасьевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.575279,
            "latitude": 56.77383
        },
        "2883": {
            "name": "Гынгазово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.5796008,
            "latitude": 56.6401559
        },
        "2884": {
            "name": "Могочино",
            "population": 3182,
            "type": "village",
            "poly": null,
            "longitude": 83.583992,
            "latitude": 57.709698
        },
        "2885": {
            "name": "Батурино",
            "population": null,
            "type": "village",
            "poly": [
                [
                    83.5796008,
                    55.6905249
                ],
                [
                    83.5808024,
                    55.69246
                ],
                [
                    83.5809741,
                    55.694008
                ],
                [
                    83.5796008,
                    55.695943
                ],
                [
                    83.5809741,
                    55.6979746
                ],
                [
                    83.5833774,
                    55.699329
                ],
                [
                    83.5861239,
                    55.699329
                ],
                [
                    83.5902438,
                    55.7001028
                ],
                [
                    83.595737,
                    55.7005865
                ],
                [
                    83.6019168,
                    55.6985551
                ],
                [
                    83.6024318,
                    55.6975876
                ],
                [
                    83.6025537,
                    55.6961477
                ],
                [
                    83.6012301,
                    55.6944918
                ],
                [
                    83.5976253,
                    55.6938145
                ],
                [
                    83.5929904,
                    55.6935243
                ],
                [
                    83.5923037,
                    55.694395
                ],
                [
                    83.5902438,
                    55.694395
                ],
                [
                    83.5859523,
                    55.6938145
                ],
                [
                    83.5838923,
                    55.6907184
                ],
                [
                    83.5809741,
                    55.6898476
                ],
                [
                    83.5796008,
                    55.6905249
                ]
            ],
            "longitude": 83.591179,
            "latitude": 55.696346
        },
        "2886": {
            "name": "Малиновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.599564,
            "latitude": 56.091309
        },
        "2887": {
            "name": "Ерестная",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.603714,
            "latitude": 55.872597
        },
        "2888": {
            "name": "Гришино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.6076691,
            "latitude": 57.5318726
        },
        "2889": {
            "name": "Бабарыкино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.6150403,
            "latitude": 56.5514235
        },
        "2890": {
            "name": "Майково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.6363616,
            "latitude": 57.6374205
        },
        "2891": {
            "name": "Зайцево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.672813,
            "latitude": 56.286415
        },
        "2892": {
            "name": "Пудовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.6884394,
            "latitude": 57.2328722
        },
        "2893": {
            "name": "Гуревка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.6949549,
            "latitude": 57.3452152
        },
        "2894": {
            "name": "Новосергеевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.721184,
            "latitude": 56.143631
        },
        "2895": {
            "name": "Монастырка",
            "population": 571,
            "type": "village",
            "poly": null,
            "longitude": 83.723793,
            "latitude": 56.943867
        },
        "2896": {
            "name": "Еловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.73143,
            "latitude": 55.944759
        },
        "2897": {
            "name": "Тека",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.759628,
            "latitude": 56.185471
        },
        "2898": {
            "name": "Новоисламбуль",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.7932528,
            "latitude": 57.4085479
        },
        "2899": {
            "name": "Новокривошеино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.7953845,
            "latitude": 57.3132424
        },
        "2900": {
            "name": "Игреково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.8001156,
            "latitude": 57.7494751
        },
        "2901": {
            "name": "Вороново",
            "population": 1195,
            "type": "village",
            "poly": null,
            "longitude": 83.805969,
            "latitude": 56.008984
        },
        "2902": {
            "name": "Соколовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.8283952,
            "latitude": 57.496837
        },
        "2903": {
            "name": "Баткат",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.861298,
            "latitude": 56.551414
        },
        "2904": {
            "name": "Красный Яр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.862213,
            "latitude": 56.084995
        },
        "2905": {
            "name": "Новопокровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.8685069,
            "latitude": 56.3217456
        },
        "2906": {
            "name": "Аркадьево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.870567,
            "latitude": 56.288452
        },
        "2907": {
            "name": "Десятово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.880524,
            "latitude": 56.423561
        },
        "2908": {
            "name": "Володино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.8948281,
            "latitude": 57.0976659
        },
        "2909": {
            "name": "Новониколаевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.90131,
            "latitude": 57.1207314
        },
        "2910": {
            "name": "Вознесенка",
            "population": 270,
            "type": "village",
            "poly": null,
            "longitude": 83.9035828,
            "latitude": 56.7190263
        },
        "2911": {
            "name": "Сафроновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.9160571,
            "latitude": 56.3589472
        },
        "2912": {
            "name": "Сулзат",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.9233743,
            "latitude": 57.7958674
        },
        "2913": {
            "name": "Петровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.9271005,
            "latitude": 57.1926569
        },
        "2914": {
            "name": "Жарковка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.9325936,
            "latitude": 56.8648443
        },
        "2915": {
            "name": "Уртам",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.934677,
            "latitude": 56.133099
        },
        "2916": {
            "name": "Жуково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.9420287,
            "latitude": 57.400239
        },
        "2917": {
            "name": "Елизарьево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.9590295,
            "latitude": 57.3001115
        },
        "2918": {
            "name": "Каргала",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.960686,
            "latitude": 56.6208
        },
        "2919": {
            "name": "Рыбалово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.0108651,
            "latitude": 57.1384072
        },
        "2920": {
            "name": "Гусево",
            "population": 507,
            "type": "village",
            "poly": null,
            "longitude": 84.0215728,
            "latitude": 56.8869035
        },
        "2921": {
            "name": "Егорово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.0536087,
            "latitude": 57.18309
        },
        "2922": {
            "name": "Нащёково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.069954,
            "latitude": 56.530502
        },
        "2923": {
            "name": "Новоильинка",
            "population": 307,
            "type": "village",
            "poly": null,
            "longitude": 84.0856025,
            "latitude": 56.9853337
        },
        "2924": {
            "name": "Киреевск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.090408,
            "latitude": 56.36853
        },
        "2925": {
            "name": "Иштан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.1284531,
            "latitude": 57.1581487
        },
        "2926": {
            "name": "Оськино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.153412,
            "latitude": 56.513073
        },
        "2927": {
            "name": "Победа",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.166733,
            "latitude": 56.526524
        },
        "2928": {
            "name": "Лебединка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.1919872,
            "latitude": 56.5265322
        },
        "2929": {
            "name": "Трубачево",
            "population": 620,
            "type": "village",
            "poly": null,
            "longitude": 84.2440659,
            "latitude": 56.674354
        },
        "2930": {
            "name": "Подоба",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.2457626,
            "latitude": 57.0318827
        },
        "2931": {
            "name": "Бушуево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.2903175,
            "latitude": 56.9006769
        },
        "2932": {
            "name": "Верхнее Сеченово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.350838,
            "latitude": 56.431194
        },
        "2933": {
            "name": "Чернышёвка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.361647,
            "latitude": 56.5399672
        },
        "2934": {
            "name": "Никольское",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.3663414,
            "latitude": 57.1915683
        },
        "2935": {
            "name": "Харск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.3721506,
            "latitude": 57.8791205
        },
        "2936": {
            "name": "Малобрагино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.379624,
            "latitude": 56.8494243
        },
        "2937": {
            "name": "Половинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.3803838,
            "latitude": 56.7054188
        },
        "2938": {
            "name": "Карнаухово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.3978758,
            "latitude": 57.0651016
        },
        "2939": {
            "name": "Лаврово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.42218,
            "latitude": 56.439819
        },
        "2940": {
            "name": "Карбышево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.449371,
            "latitude": 56.488102
        },
        "2941": {
            "name": "Золотушка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.4789073,
            "latitude": 57.7869631
        },
        "2942": {
            "name": "Козюлино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.503326,
            "latitude": 56.8075073
        },
        "2943": {
            "name": "Красный Яр",
            "population": 3119,
            "type": "village",
            "poly": null,
            "longitude": 84.5039413,
            "latitude": 57.1455792
        },
        "2944": {
            "name": "Рыбалово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.518204,
            "latitude": 56.508194
        },
        "2945": {
            "name": "Нелюбино",
            "population": 1415,
            "type": "village",
            "poly": null,
            "longitude": 84.555923,
            "latitude": 56.561172
        },
        "2946": {
            "name": "Нагорный Иштан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.560336,
            "latitude": 56.748145
        },
        "2947": {
            "name": "Мало-Жирово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.989624,
            "latitude": 56.796688
        },
        "2948": {
            "name": "Губино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.625992,
            "latitude": 56.588463
        },
        "2949": {
            "name": "Берёзкино",
            "population": 431,
            "type": "village",
            "poly": null,
            "longitude": 84.629532,
            "latitude": 56.485256
        },
        "2950": {
            "name": "Орловка",
            "population": 819,
            "type": "village",
            "poly": [
                [
                    84.6239231,
                    56.8186508
                ],
                [
                    84.6248701,
                    56.8196874
                ],
                [
                    84.6261526,
                    56.8219764
                ],
                [
                    84.6279282,
                    56.8220088
                ],
                [
                    84.6291713,
                    56.8196118
                ],
                [
                    84.6317954,
                    56.8195902
                ],
                [
                    84.644322,
                    56.8213681
                ],
                [
                    84.6464923,
                    56.8177616
                ],
                [
                    84.6524923,
                    56.817301
                ],
                [
                    84.658727,
                    56.8140181
                ],
                [
                    84.657188,
                    56.8120309
                ],
                [
                    84.6601081,
                    56.8106053
                ],
                [
                    84.6600884,
                    56.8099249
                ],
                [
                    84.6571091,
                    56.8098817
                ],
                [
                    84.6559253,
                    56.8091364
                ],
                [
                    84.6560437,
                    56.8062957
                ],
                [
                    84.6570696,
                    56.805518
                ],
                [
                    84.656971,
                    56.8045674
                ],
                [
                    84.655728,
                    56.8041029
                ],
                [
                    84.6518214,
                    56.8061229
                ],
                [
                    84.6346562,
                    56.8151628
                ],
                [
                    84.6239231,
                    56.8186508
                ]
            ],
            "longitude": 84.653862,
            "latitude": 56.811905
        },
        "2951": {
            "name": "Моряковский Затон",
            "population": 4731,
            "type": "village",
            "poly": null,
            "longitude": 84.653976,
            "latitude": 56.696075
        },
        "2952": {
            "name": "Кудринский Участок",
            "population": 382,
            "type": "village",
            "poly": null,
            "longitude": 84.667549,
            "latitude": 56.537655
        },
        "2953": {
            "name": "Суйга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.731628,
            "latitude": 57.868862
        },
        "2954": {
            "name": "Зоркальцево",
            "population": 1248,
            "type": "village",
            "poly": [
                [
                    84.7210591,
                    56.5132554
                ],
                [
                    84.7223573,
                    56.5146051
                ],
                [
                    84.7242133,
                    56.5143387
                ],
                [
                    84.7266702,
                    56.5143801
                ],
                [
                    84.7292237,
                    56.5141197
                ],
                [
                    84.7320239,
                    56.5139539
                ],
                [
                    84.7350173,
                    56.5139954
                ],
                [
                    84.7359936,
                    56.5143801
                ],
                [
                    84.7378068,
                    56.515197
                ],
                [
                    84.7392123,
                    56.515487
                ],
                [
                    84.7407679,
                    56.5154397
                ],
                [
                    84.7415833,
                    56.5154515
                ],
                [
                    84.7426669,
                    56.5153568
                ],
                [
                    84.7441582,
                    56.5156113
                ],
                [
                    84.745156,
                    56.5160612
                ],
                [
                    84.7460465,
                    56.5171799
                ],
                [
                    84.7461002,
                    56.5178014
                ],
                [
                    84.7463362,
                    56.51834
                ],
                [
                    84.7458319,
                    56.5185708
                ],
                [
                    84.7450595,
                    56.5187721
                ],
                [
                    84.7438686,
                    56.5188253
                ],
                [
                    84.7431175,
                    56.518991
                ],
                [
                    84.7417013,
                    56.5188608
                ],
                [
                    84.7408645,
                    56.5184347
                ],
                [
                    84.7400062,
                    56.5185945
                ],
                [
                    84.7384827,
                    56.51892
                ],
                [
                    84.7378282,
                    56.5190739
                ],
                [
                    84.7374527,
                    56.5193343
                ],
                [
                    84.7378389,
                    56.5199913
                ],
                [
                    84.7380321,
                    56.520447
                ],
                [
                    84.737045,
                    56.5213999
                ],
                [
                    84.7362404,
                    56.5221689
                ],
                [
                    84.7356181,
                    56.5228377
                ],
                [
                    84.7347276,
                    56.523252
                ],
                [
                    84.7342019,
                    56.5236544
                ],
                [
                    84.7328715,
                    56.5233644
                ],
                [
                    84.7320347,
                    56.5238674
                ],
                [
                    84.7319596,
                    56.5242107
                ],
                [
                    84.7325067,
                    56.5245657
                ],
                [
                    84.7320883,
                    56.5251575
                ],
                [
                    84.7319274,
                    56.5257907
                ],
                [
                    84.7320132,
                    56.5271044
                ],
                [
                    84.7317743,
                    56.5272936
                ],
                [
                    84.7310583,
                    56.5272168
                ],
                [
                    84.7301357,
                    56.5272464
                ],
                [
                    84.7290628,
                    56.5278204
                ],
                [
                    84.728183,
                    56.5281044
                ],
                [
                    84.726971,
                    56.5286391
                ],
                [
                    84.7265297,
                    56.528344
                ],
                [
                    84.7262575,
                    56.5281991
                ],
                [
                    84.726048,
                    56.528276
                ],
                [
                    84.7252433,
                    56.528631
                ],
                [
                    84.7250931,
                    56.5288086
                ],
                [
                    84.7252004,
                    56.5292997
                ],
                [
                    84.7259407,
                    56.529844
                ],
                [
                    84.7254364,
                    56.5302937
                ],
                [
                    84.724739,
                    56.5309683
                ],
                [
                    84.7247927,
                    56.531341
                ],
                [
                    84.7254042,
                    56.5321812
                ],
                [
                    84.7268419,
                    56.5325362
                ],
                [
                    84.7289126,
                    56.5322936
                ],
                [
                    84.7301678,
                    56.5320451
                ],
                [
                    84.7308759,
                    56.5318084
                ],
                [
                    84.7322492,
                    56.5314475
                ],
                [
                    84.7336654,
                    56.5310925
                ],
                [
                    84.7351353,
                    56.5311931
                ],
                [
                    84.7364335,
                    56.5320569
                ],
                [
                    84.738472,
                    56.5333763
                ],
                [
                    84.7401993,
                    56.5346128
                ],
                [
                    84.7405318,
                    56.5352045
                ],
                [
                    84.7405748,
                    56.5356245
                ],
                [
                    84.7398131,
                    56.5360031
                ],
                [
                    84.739738,
                    56.5361629
                ],
                [
                    84.7418436,
                    56.537369
                ],
                [
                    84.7444533,
                    56.5369396
                ],
                [
                    84.7455851,
                    56.5361569
                ],
                [
                    84.7456388,
                    56.5356837
                ],
                [
                    84.7433965,
                    56.5341632
                ],
                [
                    84.7387187,
                    56.5308026
                ],
                [
                    84.7367017,
                    56.5296133
                ],
                [
                    84.735425,
                    56.5292287
                ],
                [
                    84.7352319,
                    56.52856
                ],
                [
                    84.7353177,
                    56.5275245
                ],
                [
                    84.7354035,
                    56.5270689
                ],
                [
                    84.7361545,
                    56.5269209
                ],
                [
                    84.7369056,
                    56.5263351
                ],
                [
                    84.7374205,
                    56.5255244
                ],
                [
                    84.7380857,
                    56.5254179
                ],
                [
                    84.7389226,
                    56.525341
                ],
                [
                    84.7396198,
                    56.525483
                ],
                [
                    84.7399525,
                    56.5253824
                ],
                [
                    84.7403173,
                    56.5255658
                ],
                [
                    84.7408538,
                    56.525625
                ],
                [
                    84.7415726,
                    56.5255422
                ],
                [
                    84.7421198,
                    56.5253469
                ],
                [
                    84.7424202,
                    56.5249741
                ],
                [
                    84.7422914,
                    56.5247078
                ],
                [
                    84.7424631,
                    56.5244474
                ],
                [
                    84.7432785,
                    56.5241041
                ],
                [
                    84.745317,
                    56.5236544
                ],
                [
                    84.7465722,
                    56.5233762
                ],
                [
                    84.7475593,
                    56.5231928
                ],
                [
                    84.7479777,
                    56.5234413
                ],
                [
                    84.7489326,
                    56.5239503
                ],
                [
                    84.749587,
                    56.524116
                ],
                [
                    84.7498016,
                    56.523826
                ],
                [
                    84.7507136,
                    56.5237787
                ],
                [
                    84.7529017,
                    56.5238793
                ],
                [
                    84.755305,
                    56.5237609
                ],
                [
                    84.7558521,
                    56.5234117
                ],
                [
                    84.7560881,
                    56.5229028
                ],
                [
                    84.7561418,
                    56.5218139
                ],
                [
                    84.7558092,
                    56.520524
                ],
                [
                    84.7560238,
                    56.5195888
                ],
                [
                    84.7563671,
                    56.5186418
                ],
                [
                    84.7567319,
                    56.5178487
                ],
                [
                    84.757322,
                    56.517097
                ],
                [
                    84.7572469,
                    56.5168307
                ],
                [
                    84.7559809,
                    56.5154042
                ],
                [
                    84.7554015,
                    56.5145814
                ],
                [
                    84.7552942,
                    56.5137704
                ],
                [
                    84.7548329,
                    56.5132495
                ],
                [
                    84.7550046,
                    56.5127878
                ],
                [
                    84.7549187,
                    56.5122076
                ],
                [
                    84.7544574,
                    56.51174
                ],
                [
                    84.7538673,
                    56.5107514
                ],
                [
                    84.753878,
                    56.5103725
                ],
                [
                    84.7538566,
                    56.5097805
                ],
                [
                    84.7535884,
                    56.5092181
                ],
                [
                    84.7529232,
                    56.5082886
                ],
                [
                    84.7504024,
                    56.5075722
                ],
                [
                    84.745907,
                    56.5074064
                ],
                [
                    84.7426348,
                    56.5075367
                ],
                [
                    84.7380321,
                    56.5079629
                ],
                [
                    84.734395,
                    56.5086675
                ],
                [
                    84.7317128,
                    56.5093187
                ],
                [
                    84.7291915,
                    56.5101002
                ],
                [
                    84.7267023,
                    56.5110237
                ],
                [
                    84.7252648,
                    56.5115446
                ],
                [
                    84.7227757,
                    56.5125273
                ],
                [
                    84.7210591,
                    56.5132554
                ]
            ],
            "longitude": 84.743027,
            "latitude": 56.522221
        },
        "2955": {
            "name": "Поросино",
            "population": 924,
            "type": "village",
            "poly": [
                [
                    84.7488733,
                    56.5501232
                ],
                [
                    84.7532259,
                    56.5569977
                ],
                [
                    84.7558629,
                    56.5576703
                ],
                [
                    84.7612388,
                    56.5576377
                ],
                [
                    84.7666777,
                    56.5541488
                ],
                [
                    84.7737157,
                    56.5487081
                ],
                [
                    84.7700512,
                    56.5440354
                ],
                [
                    84.7577083,
                    56.5409553
                ],
                [
                    84.7532259,
                    56.5432475
                ],
                [
                    84.7488733,
                    56.5501232
                ]
            ],
            "longitude": 84.760414,
            "latitude": 56.550472
        },
        "2956": {
            "name": "Борики",
            "population": 441,
            "type": "village",
            "poly": null,
            "longitude": 84.782341,
            "latitude": 56.556252
        },
        "2957": {
            "name": "Петрово",
            "population": 495,
            "type": "village",
            "poly": null,
            "longitude": 84.803391,
            "latitude": 56.534683
        },
        "2958": {
            "name": "Кандинка",
            "population": 1093,
            "type": "village",
            "poly": [
                [
                    84.7933355,
                    56.2940097
                ],
                [
                    84.7933355,
                    56.2946233
                ],
                [
                    84.795933,
                    56.2996485
                ],
                [
                    84.8077274,
                    56.3011287
                ],
                [
                    84.8089911,
                    56.2974671
                ],
                [
                    84.8155903,
                    56.2981293
                ],
                [
                    84.8249275,
                    56.2994538
                ],
                [
                    84.8249977,
                    56.302492
                ],
                [
                    84.8334222,
                    56.3035826
                ],
                [
                    84.8382663,
                    56.3013624
                ],
                [
                    84.8386876,
                    56.3003107
                ],
                [
                    84.8322989,
                    56.2968438
                ],
                [
                    84.8309475,
                    56.2947207
                ],
                [
                    84.8259981,
                    56.2937078
                ],
                [
                    84.8218911,
                    56.2934448
                ],
                [
                    84.821329,
                    56.2934274
                ],
                [
                    84.8187495,
                    56.2933474
                ],
                [
                    84.8150638,
                    56.2948765
                ],
                [
                    84.8039364,
                    56.2906299
                ],
                [
                    84.7996188,
                    56.2908442
                ],
                [
                    84.7967053,
                    56.2914188
                ],
                [
                    84.7933355,
                    56.2940097
                ]
            ],
            "longitude": 84.823906,
            "latitude": 56.296127
        },
        "2959": {
            "name": "Дзержинское",
            "population": null,
            "type": "village",
            "poly": [
                [
                    84.8152424,
                    56.5248022
                ],
                [
                    84.8209823,
                    56.5273148
                ],
                [
                    84.8264346,
                    56.5298557
                ],
                [
                    84.8318034,
                    56.5320472
                ],
                [
                    84.8358246,
                    56.5315372
                ],
                [
                    84.8375841,
                    56.5304497
                ],
                [
                    84.8398779,
                    56.5280095
                ],
                [
                    84.8413671,
                    56.5269905
                ],
                [
                    84.8442703,
                    56.5268
                ],
                [
                    84.8475619,
                    56.5261361
                ],
                [
                    84.8485576,
                    56.5251336
                ],
                [
                    84.8485129,
                    56.5226872
                ],
                [
                    84.8483411,
                    56.5210774
                ],
                [
                    84.8485129,
                    56.5198464
                ],
                [
                    84.8491996,
                    56.5182365
                ],
                [
                    84.8509162,
                    56.5167212
                ],
                [
                    84.8534637,
                    56.5155794
                ],
                [
                    84.855551,
                    56.5146377
                ],
                [
                    84.8588125,
                    56.5140694
                ],
                [
                    84.8561337,
                    56.5130436
                ],
                [
                    84.8558505,
                    56.5128387
                ],
                [
                    84.8557078,
                    56.5124569
                ],
                [
                    84.8554213,
                    56.5119002
                ],
                [
                    84.8546927,
                    56.511228
                ],
                [
                    84.8534131,
                    56.5107785
                ],
                [
                    84.8521728,
                    56.5106459
                ],
                [
                    84.8512779,
                    56.5114759
                ],
                [
                    84.851057,
                    56.5125698
                ],
                [
                    84.8499455,
                    56.5131263
                ],
                [
                    84.8483575,
                    56.5125876
                ],
                [
                    84.8478795,
                    56.5123949
                ],
                [
                    84.8477907,
                    56.5122133
                ],
                [
                    84.8476421,
                    56.5119546
                ],
                [
                    84.8477439,
                    56.5114072
                ],
                [
                    84.8468898,
                    56.5113835
                ],
                [
                    84.8452183,
                    56.5115978
                ],
                [
                    84.8445146,
                    56.5117458
                ],
                [
                    84.8440102,
                    56.5122348
                ],
                [
                    84.8441798,
                    56.5127699
                ],
                [
                    84.8420577,
                    56.5131997
                ],
                [
                    84.8390128,
                    56.5139029
                ],
                [
                    84.838309,
                    56.5136425
                ],
                [
                    84.8374657,
                    56.5135158
                ],
                [
                    84.8356525,
                    56.5146417
                ],
                [
                    84.8339552,
                    56.515069
                ],
                [
                    84.8314361,
                    56.51362
                ],
                [
                    84.829462,
                    56.5148903
                ],
                [
                    84.8305714,
                    56.515758
                ],
                [
                    84.8298018,
                    56.5169107
                ],
                [
                    84.8275702,
                    56.51871
                ],
                [
                    84.8243087,
                    56.5188994
                ],
                [
                    84.8213793,
                    56.5200784
                ],
                [
                    84.8196412,
                    56.521133
                ],
                [
                    84.8152424,
                    56.5248022
                ]
            ],
            "longitude": 84.845261,
            "latitude": 56.518383
        },
        "2960": {
            "name": "Курлек",
            "population": 1386,
            "type": "village",
            "poly": [
                [
                    84.8367331,
                    56.2149495
                ],
                [
                    84.8440378,
                    56.2195444
                ],
                [
                    84.8446313,
                    56.2229457
                ],
                [
                    84.8470054,
                    56.2238595
                ],
                [
                    84.8543101,
                    56.2223112
                ],
                [
                    84.857321,
                    56.2294509
                ],
                [
                    84.863381,
                    56.2301687
                ],
                [
                    84.8702895,
                    56.2288049
                ],
                [
                    84.8704187,
                    56.2246773
                ],
                [
                    84.8661573,
                    56.2224518
                ],
                [
                    84.8638976,
                    56.2204328
                ],
                [
                    84.8607473,
                    56.2155588
                ],
                [
                    84.8581451,
                    56.2091099
                ],
                [
                    84.8585559,
                    56.2073071
                ],
                [
                    84.8597886,
                    56.2019997
                ],
                [
                    84.8558624,
                    56.2018727
                ],
                [
                    84.8510686,
                    56.2034218
                ],
                [
                    84.8480098,
                    56.2037012
                ],
                [
                    84.8437639,
                    56.2024314
                ],
                [
                    84.842029,
                    56.2055042
                ],
                [
                    84.8439009,
                    56.2104302
                ],
                [
                    84.8386861,
                    56.2113504
                ],
                [
                    84.8367331,
                    56.2149495
                ]
            ],
            "longitude": 84.852257,
            "latitude": 56.214279
        },
        "2961": {
            "name": "Кисловка",
            "population": 2937,
            "type": "village",
            "poly": [
                [
                    84.8436228,
                    56.4131023
                ],
                [
                    84.8438266,
                    56.4134198
                ],
                [
                    84.8440239,
                    56.4135975
                ],
                [
                    84.8451942,
                    56.4146513
                ],
                [
                    84.8458648,
                    56.4150134
                ],
                [
                    84.8471576,
                    56.4161588
                ],
                [
                    84.8450225,
                    56.4173843
                ],
                [
                    84.8542494,
                    56.4210309
                ],
                [
                    84.8577041,
                    56.422372
                ],
                [
                    84.8603796,
                    56.4222457
                ],
                [
                    84.8663823,
                    56.4217947
                ],
                [
                    84.8690928,
                    56.4226359
                ],
                [
                    84.8725421,
                    56.4232411
                ],
                [
                    84.874682,
                    56.4236869
                ],
                [
                    84.8756052,
                    56.4250004
                ],
                [
                    84.8765171,
                    56.4250449
                ],
                [
                    84.8772521,
                    56.4240689
                ],
                [
                    84.8777685,
                    56.4233766
                ],
                [
                    84.8782737,
                    56.4221114
                ],
                [
                    84.8801675,
                    56.4171277
                ],
                [
                    84.8805873,
                    56.4159862
                ],
                [
                    84.8821227,
                    56.4158773
                ],
                [
                    84.8824862,
                    56.4154549
                ],
                [
                    84.882593,
                    56.4153306
                ],
                [
                    84.8830289,
                    56.4148241
                ],
                [
                    84.8856045,
                    56.4150847
                ],
                [
                    84.8860277,
                    56.4130317
                ],
                [
                    84.8857976,
                    56.4125266
                ],
                [
                    84.8846383,
                    56.4111116
                ],
                [
                    84.882337,
                    56.4106783
                ],
                [
                    84.880733,
                    56.4100343
                ],
                [
                    84.8776217,
                    56.4094437
                ],
                [
                    84.8767634,
                    56.4076214
                ],
                [
                    84.8726418,
                    56.4077175
                ],
                [
                    84.873097,
                    56.4057246
                ],
                [
                    84.8706104,
                    56.4037568
                ],
                [
                    84.8645655,
                    56.4032486
                ],
                [
                    84.8603651,
                    56.4028568
                ],
                [
                    84.8597643,
                    56.402652
                ],
                [
                    84.8592861,
                    56.4027743
                ],
                [
                    84.8580102,
                    56.4040471
                ],
                [
                    84.857106,
                    56.4049019
                ],
                [
                    84.8553977,
                    56.4065167
                ],
                [
                    84.8538635,
                    56.408063
                ],
                [
                    84.8528112,
                    56.4090223
                ],
                [
                    84.8465831,
                    56.4070278
                ],
                [
                    84.8439814,
                    56.4092538
                ],
                [
                    84.8444221,
                    56.4104225
                ],
                [
                    84.8436228,
                    56.4131023
                ]
            ],
            "longitude": 84.869949,
            "latitude": 56.419777
        },
        "2962": {
            "name": "Кафтанчиково",
            "population": 1532,
            "type": "village",
            "poly": [
                [
                    84.8519763,
                    56.3317404
                ],
                [
                    84.8533496,
                    56.3337388
                ],
                [
                    84.8530349,
                    56.3339313
                ],
                [
                    84.8538176,
                    56.3344306
                ],
                [
                    84.8546029,
                    56.3349727
                ],
                [
                    84.8549558,
                    56.3351806
                ],
                [
                    84.8552976,
                    56.3352873
                ],
                [
                    84.8554907,
                    56.3355666
                ],
                [
                    84.8563608,
                    56.3356323
                ],
                [
                    84.8569545,
                    56.3357372
                ],
                [
                    84.8619326,
                    56.335642
                ],
                [
                    84.8636493,
                    56.3382112
                ],
                [
                    84.8603877,
                    56.3384015
                ],
                [
                    84.858765,
                    56.3397724
                ],
                [
                    84.8623613,
                    56.3433503
                ],
                [
                    84.8654405,
                    56.344398
                ],
                [
                    84.8668181,
                    56.3445502
                ],
                [
                    84.8665158,
                    56.3451675
                ],
                [
                    84.867047,
                    56.3462357
                ],
                [
                    84.8695508,
                    56.3479405
                ],
                [
                    84.8699239,
                    56.3482178
                ],
                [
                    84.8688417,
                    56.3486367
                ],
                [
                    84.8690474,
                    56.349389
                ],
                [
                    84.868619,
                    56.3501742
                ],
                [
                    84.8669974,
                    56.3509495
                ],
                [
                    84.8673364,
                    56.3517993
                ],
                [
                    84.871374,
                    56.3530517
                ],
                [
                    84.8741206,
                    56.3534321
                ],
                [
                    84.8758372,
                    56.3535273
                ],
                [
                    84.8763154,
                    56.3558508
                ],
                [
                    84.875184,
                    56.3560913
                ],
                [
                    84.8757602,
                    56.3566899
                ],
                [
                    84.8761142,
                    56.3567968
                ],
                [
                    84.8760579,
                    56.3570245
                ],
                [
                    84.8758433,
                    56.3573098
                ],
                [
                    84.8756931,
                    56.3575832
                ],
                [
                    84.8750413,
                    56.35773
                ],
                [
                    84.8750413,
                    56.3579559
                ],
                [
                    84.8751352,
                    56.3582133
                ],
                [
                    84.8756395,
                    56.3583916
                ],
                [
                    84.8762081,
                    56.3584213
                ],
                [
                    84.8763797,
                    56.3582787
                ],
                [
                    84.8765942,
                    56.358243
                ],
                [
                    84.877466,
                    56.3583957
                ],
                [
                    84.8779998,
                    56.3584035
                ],
                [
                    84.878268,
                    56.3582252
                ],
                [
                    84.878496,
                    56.3581342
                ],
                [
                    84.8775921,
                    56.3565965
                ],
                [
                    84.8793311,
                    56.3559165
                ],
                [
                    84.8788943,
                    56.3545124
                ],
                [
                    84.8797854,
                    56.3544784
                ],
                [
                    84.8775749,
                    56.3468284
                ],
                [
                    84.8754051,
                    56.3448008
                ],
                [
                    84.8736056,
                    56.3428732
                ],
                [
                    84.8720607,
                    56.3410656
                ],
                [
                    84.871374,
                    56.3382112
                ],
                [
                    84.8732622,
                    56.3378306
                ],
                [
                    84.8725756,
                    56.3365936
                ],
                [
                    84.8693141,
                    56.3353565
                ],
                [
                    84.8687991,
                    56.3348808
                ],
                [
                    84.8669108,
                    56.3347856
                ],
                [
                    84.8657892,
                    56.3343939
                ],
                [
                    84.8699745,
                    56.3302738
                ],
                [
                    84.8638784,
                    56.3280521
                ],
                [
                    84.8619326,
                    56.3293612
                ],
                [
                    84.8569545,
                    56.329837
                ],
                [
                    84.8554094,
                    56.3309791
                ],
                [
                    84.8519763,
                    56.3317404
                ]
            ],
            "longitude": 84.871429,
            "latitude": 56.342319
        },
        "2963": {
            "name": "Барабинка",
            "population": 630,
            "type": "village",
            "poly": [
                [
                    84.8640196,
                    56.3277154
                ],
                [
                    84.8743837,
                    56.331439
                ],
                [
                    84.8733966,
                    56.3330568
                ],
                [
                    84.8725758,
                    56.336203
                ],
                [
                    84.8733537,
                    56.3372199
                ],
                [
                    84.8759608,
                    56.3379788
                ],
                [
                    84.8814014,
                    56.3337294
                ],
                [
                    84.8822801,
                    56.3328308
                ],
                [
                    84.8815076,
                    56.3296545
                ],
                [
                    84.8806708,
                    56.3271681
                ],
                [
                    84.8827735,
                    56.323575
                ],
                [
                    84.8821513,
                    56.3223732
                ],
                [
                    84.8795978,
                    56.3215284
                ],
                [
                    84.8679893,
                    56.323801
                ],
                [
                    84.8640196,
                    56.3277154
                ]
            ],
            "longitude": 84.872757,
            "latitude": 56.326679
        },
        "2964": {
            "name": "Тимирязевское",
            "population": 6211,
            "type": "village",
            "poly": [
                [
                    84.8617869,
                    56.487938
                ],
                [
                    84.861965,
                    56.4888489
                ],
                [
                    84.8649207,
                    56.490153
                ],
                [
                    84.8717341,
                    56.4932002
                ],
                [
                    84.8766544,
                    56.4980238
                ],
                [
                    84.8813771,
                    56.4983941
                ],
                [
                    84.8852381,
                    56.49832
                ],
                [
                    84.8898041,
                    56.4968745
                ],
                [
                    84.8927922,
                    56.4955402
                ],
                [
                    84.8951423,
                    56.494076
                ],
                [
                    84.8970224,
                    56.4927787
                ],
                [
                    84.8990704,
                    56.4905545
                ],
                [
                    84.8997083,
                    56.4897575
                ],
                [
                    84.8999073,
                    56.4873645
                ],
                [
                    84.896631,
                    56.4859554
                ],
                [
                    84.8950347,
                    56.4849205
                ],
                [
                    84.8939841,
                    56.4838398
                ],
                [
                    84.89318,
                    56.4825758
                ],
                [
                    84.8929099,
                    56.4815492
                ],
                [
                    84.8932111,
                    56.4798056
                ],
                [
                    84.8937711,
                    56.4789215
                ],
                [
                    84.8944989,
                    56.4782049
                ],
                [
                    84.894547,
                    56.4781544
                ],
                [
                    84.8946049,
                    56.4774857
                ],
                [
                    84.8945559,
                    56.4767983
                ],
                [
                    84.8941491,
                    56.4760524
                ],
                [
                    84.8929962,
                    56.4748318
                ],
                [
                    84.8921252,
                    56.4735947
                ],
                [
                    84.8918508,
                    56.4727801
                ],
                [
                    84.8919146,
                    56.4718652
                ],
                [
                    84.8922632,
                    56.4712081
                ],
                [
                    84.8924422,
                    56.4704171
                ],
                [
                    84.892915,
                    56.4698718
                ],
                [
                    84.894603,
                    56.4679005
                ],
                [
                    84.8972117,
                    56.4655982
                ],
                [
                    84.9004286,
                    56.4634521
                ],
                [
                    84.9035306,
                    56.461875
                ],
                [
                    84.907972,
                    56.460266
                ],
                [
                    84.9037332,
                    56.4589445
                ],
                [
                    84.8977264,
                    56.4569608
                ],
                [
                    84.884097,
                    56.4603597
                ],
                [
                    84.8837288,
                    56.4645956
                ],
                [
                    84.8845164,
                    56.4666046
                ],
                [
                    84.882549,
                    56.4682955
                ],
                [
                    84.8818366,
                    56.4689734
                ],
                [
                    84.8814016,
                    56.4692924
                ],
                [
                    84.879427,
                    56.4708453
                ],
                [
                    84.878792,
                    56.4713785
                ],
                [
                    84.8720604,
                    56.4772623
                ],
                [
                    84.872394,
                    56.4773835
                ],
                [
                    84.8775474,
                    56.4792567
                ],
                [
                    84.877094,
                    56.4798082
                ],
                [
                    84.8784674,
                    56.4801874
                ],
                [
                    84.8749483,
                    56.4830311
                ],
                [
                    84.8656862,
                    56.4852958
                ],
                [
                    84.8622484,
                    56.485897
                ],
                [
                    84.8623923,
                    56.4870598
                ],
                [
                    84.8617869,
                    56.487938
                ]
            ],
            "longitude": 84.878471,
            "latitude": 56.489021
        },
        "2965": {
            "name": "Калтай",
            "population": 1064,
            "type": "village",
            "poly": [
                [
                    84.8596662,
                    56.2859259
                ],
                [
                    84.8598795,
                    56.287366
                ],
                [
                    84.869191,
                    56.2866755
                ],
                [
                    84.871594,
                    56.289448
                ],
                [
                    84.8828958,
                    56.2907498
                ],
                [
                    84.8911412,
                    56.29288
                ],
                [
                    84.892776,
                    56.2930772
                ],
                [
                    84.894553,
                    56.2924066
                ],
                [
                    84.8924206,
                    56.2896453
                ],
                [
                    84.892776,
                    56.2869232
                ],
                [
                    84.8963301,
                    56.2828988
                ],
                [
                    84.8964404,
                    56.2826504
                ],
                [
                    84.8905346,
                    56.2799022
                ],
                [
                    84.888298,
                    56.2780048
                ],
                [
                    84.8880968,
                    56.2761213
                ],
                [
                    84.8892781,
                    56.2742935
                ],
                [
                    84.9001952,
                    56.2646927
                ],
                [
                    84.8959916,
                    56.25684
                ],
                [
                    84.8883023,
                    56.2577309
                ],
                [
                    84.8898268,
                    56.26232
                ],
                [
                    84.8889996,
                    56.2634194
                ],
                [
                    84.8756669,
                    56.2699958
                ],
                [
                    84.8712341,
                    56.2710562
                ],
                [
                    84.8700781,
                    56.2714748
                ],
                [
                    84.8693696,
                    56.2737338
                ],
                [
                    84.8707315,
                    56.2768328
                ],
                [
                    84.8722896,
                    56.2786326
                ],
                [
                    84.8702289,
                    56.2794418
                ],
                [
                    84.8699215,
                    56.2846141
                ],
                [
                    84.8596662,
                    56.2859259
                ]
            ],
            "longitude": 84.879135,
            "latitude": 56.278866
        },
        "2966": {
            "name": "Лысая Гора",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.8807683,
            "latitude": 57.8514398
        },
        "2967": {
            "name": "Тахтамышево",
            "population": 697,
            "type": "village",
            "poly": [
                [
                    84.8580613,
                    56.3745214
                ],
                [
                    84.8627225,
                    56.3769495
                ],
                [
                    84.8680332,
                    56.3797297
                ],
                [
                    84.8724289,
                    56.3813841
                ],
                [
                    84.8802609,
                    56.382287
                ],
                [
                    84.8817415,
                    56.3839502
                ],
                [
                    84.8817998,
                    56.3840046
                ],
                [
                    84.8832468,
                    56.3853549
                ],
                [
                    84.8869053,
                    56.3878138
                ],
                [
                    84.8887608,
                    56.3887403
                ],
                [
                    84.8899732,
                    56.3891204
                ],
                [
                    84.8910889,
                    56.389352
                ],
                [
                    84.8918937,
                    56.3893876
                ],
                [
                    84.8925132,
                    56.3892896
                ],
                [
                    84.8928485,
                    56.3891382
                ],
                [
                    84.893157,
                    56.3886423
                ],
                [
                    84.8928244,
                    56.3884997
                ],
                [
                    84.8925562,
                    56.3883216
                ],
                [
                    84.8924489,
                    56.3881672
                ],
                [
                    84.8922879,
                    56.3880662
                ],
                [
                    84.8920626,
                    56.3879949
                ],
                [
                    84.8918266,
                    56.3879474
                ],
                [
                    84.8915477,
                    56.3879652
                ],
                [
                    84.8913653,
                    56.3880187
                ],
                [
                    84.8911399,
                    56.3881434
                ],
                [
                    84.8909468,
                    56.3882325
                ],
                [
                    84.890625,
                    56.3882503
                ],
                [
                    84.8903567,
                    56.3881969
                ],
                [
                    84.8901851,
                    56.3880959
                ],
                [
                    84.889874,
                    56.3878999
                ],
                [
                    84.8895199,
                    56.3878227
                ],
                [
                    84.8889942,
                    56.3872763
                ],
                [
                    84.8881681,
                    56.3860409
                ],
                [
                    84.8878462,
                    56.3850668
                ],
                [
                    84.887932,
                    56.3841046
                ],
                [
                    84.8881895,
                    56.383475
                ],
                [
                    84.8897023,
                    56.3823523
                ],
                [
                    84.88989,
                    56.3823842
                ],
                [
                    84.8900698,
                    56.3824147
                ],
                [
                    84.8905526,
                    56.3823553
                ],
                [
                    84.8903391,
                    56.3820509
                ],
                [
                    84.8867122,
                    56.3768782
                ],
                [
                    84.8863045,
                    56.3769436
                ],
                [
                    84.8836008,
                    56.373165
                ],
                [
                    84.8782257,
                    56.3730224
                ],
                [
                    84.8711339,
                    56.372862
                ],
                [
                    84.8687843,
                    56.372458
                ],
                [
                    84.866013,
                    56.3725441
                ],
                [
                    84.8620573,
                    56.3729808
                ],
                [
                    84.8580613,
                    56.3745214
                ]
            ],
            "longitude": 84.88166,
            "latitude": 56.379612
        },
        "2968": {
            "name": "Эушта",
            "population": null,
            "type": "village",
            "poly": [
                [
                    84.8855445,
                    56.5301723
                ],
                [
                    84.8906944,
                    56.5304563
                ],
                [
                    84.8912093,
                    56.5350002
                ],
                [
                    84.8937842,
                    56.5347162
                ],
                [
                    84.893441,
                    56.5320656
                ],
                [
                    84.8936126,
                    56.5286575
                ],
                [
                    84.8948142,
                    56.5265746
                ],
                [
                    84.8980758,
                    56.5233553
                ],
                [
                    84.8964822,
                    56.5229715
                ],
                [
                    84.8956726,
                    56.5226925
                ],
                [
                    84.8944709,
                    56.5241128
                ],
                [
                    84.8893211,
                    56.5235447
                ],
                [
                    84.8891493,
                    56.5265746
                ],
                [
                    84.8903511,
                    56.5282788
                ],
                [
                    84.8858879,
                    56.5282788
                ],
                [
                    84.8855445,
                    56.5301723
                ]
            ],
            "longitude": 84.891838,
            "latitude": 56.529686
        },
        "2969": {
            "name": "Нижний Склад",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.9100794,
            "latitude": 56.5085835
        },
        "2970": {
            "name": "Чёрная Речка",
            "population": 1237,
            "type": "village",
            "poly": [
                [
                    84.8982967,
                    56.3931034
                ],
                [
                    84.8993267,
                    56.3948848
                ],
                [
                    84.8985241,
                    56.3950475
                ],
                [
                    84.901172,
                    56.3988987
                ],
                [
                    84.9018286,
                    56.3994177
                ],
                [
                    84.9028157,
                    56.3999164
                ],
                [
                    84.9113987,
                    56.4034786
                ],
                [
                    84.9119137,
                    56.4030749
                ],
                [
                    84.9131583,
                    56.4035973
                ],
                [
                    84.9146603,
                    56.4042385
                ],
                [
                    84.9163834,
                    56.4054127
                ],
                [
                    84.9182609,
                    56.4074702
                ],
                [
                    84.9200247,
                    56.4118354
                ],
                [
                    84.9219988,
                    56.4116217
                ],
                [
                    84.9203552,
                    56.4068778
                ],
                [
                    84.9188102,
                    56.4041946
                ],
                [
                    84.9183811,
                    56.4032209
                ],
                [
                    84.918866,
                    56.4017688
                ],
                [
                    84.9190248,
                    56.4004424
                ],
                [
                    84.9197285,
                    56.3992887
                ],
                [
                    84.9179322,
                    56.3970978
                ],
                [
                    84.9163997,
                    56.3972382
                ],
                [
                    84.9144329,
                    56.3957874
                ],
                [
                    84.912845,
                    56.3954074
                ],
                [
                    84.9101113,
                    56.3949288
                ],
                [
                    84.908768,
                    56.3952886
                ],
                [
                    84.9073089,
                    56.3951224
                ],
                [
                    84.9003266,
                    56.3933611
                ],
                [
                    84.8982967,
                    56.3931034
                ]
            ],
            "longitude": 84.911087,
            "latitude": 56.399586
        },
        "2971": {
            "name": "Синий Утёс",
            "population": 473,
            "type": "village",
            "poly": [
                [
                    84.914789,
                    56.3310532
                ],
                [
                    84.9148191,
                    56.3330315
                ],
                [
                    84.9152912,
                    56.3347206
                ],
                [
                    84.9161924,
                    56.3360766
                ],
                [
                    84.9199689,
                    56.3398113
                ],
                [
                    84.9216426,
                    56.3392404
                ],
                [
                    84.9215568,
                    56.3386457
                ],
                [
                    84.922973,
                    56.3376466
                ],
                [
                    84.9237154,
                    56.3379523
                ],
                [
                    84.9269641,
                    56.3364572
                ],
                [
                    84.9218143,
                    56.3321512
                ],
                [
                    84.9215997,
                    56.3311996
                ],
                [
                    84.9202822,
                    56.3309343
                ],
                [
                    84.9186085,
                    56.3308629
                ],
                [
                    84.9166344,
                    56.3309343
                ],
                [
                    84.914789,
                    56.3310532
                ]
            ],
            "longitude": 84.9216804,
            "latitude": 56.3368961
        },
        "2972": {
            "name": "Вершинино",
            "population": 639,
            "type": "village",
            "poly": [
                [
                    84.9220513,
                    56.2222031
                ],
                [
                    84.9222311,
                    56.2235258
                ],
                [
                    84.9221624,
                    56.2241446
                ],
                [
                    84.9227686,
                    56.2256677
                ],
                [
                    84.9228906,
                    56.2263244
                ],
                [
                    84.9229238,
                    56.2265
                ],
                [
                    84.9230622,
                    56.227231
                ],
                [
                    84.9244355,
                    56.2288532
                ],
                [
                    84.9258947,
                    56.2297597
                ],
                [
                    84.9285553,
                    56.2317158
                ],
                [
                    84.931731,
                    56.234435
                ],
                [
                    84.9328469,
                    56.2354368
                ],
                [
                    84.9355935,
                    56.2360092
                ],
                [
                    84.9341344,
                    56.2343396
                ],
                [
                    84.9346494,
                    56.2340534
                ],
                [
                    84.9334478,
                    56.2330039
                ],
                [
                    84.9328469,
                    56.2333378
                ],
                [
                    84.9320745,
                    56.2324314
                ],
                [
                    84.9310445,
                    56.2320497
                ],
                [
                    84.9308728,
                    56.2316681
                ],
                [
                    84.9310445,
                    56.2301414
                ],
                [
                    84.930787,
                    56.2298551
                ],
                [
                    84.9284696,
                    56.2289486
                ],
                [
                    84.9283837,
                    56.2279944
                ],
                [
                    84.9290704,
                    56.2279467
                ],
                [
                    84.929757,
                    56.2272787
                ],
                [
                    84.9300145,
                    56.2266107
                ],
                [
                    84.9305295,
                    56.2254178
                ],
                [
                    84.9308728,
                    56.2243204
                ],
                [
                    84.9307012,
                    56.2232229
                ],
                [
                    84.9311303,
                    56.2224116
                ],
                [
                    84.9311303,
                    56.2217913
                ],
                [
                    84.9303579,
                    56.2212664
                ],
                [
                    84.9294137,
                    56.2211709
                ],
                [
                    84.9269246,
                    56.2211709
                ],
                [
                    84.925035,
                    56.2207094
                ],
                [
                    84.9247217,
                    56.2210482
                ],
                [
                    84.9244074,
                    56.22143
                ],
                [
                    84.9240249,
                    56.2212627
                ],
                [
                    84.9245214,
                    56.2196438
                ],
                [
                    84.9224349,
                    56.2192351
                ],
                [
                    84.9222219,
                    56.2210843
                ],
                [
                    84.9220513,
                    56.2222031
                ]
            ],
            "longitude": 84.926575,
            "latitude": 56.225468
        },
        "2973": {
            "name": "Ярское",
            "population": 268,
            "type": "village",
            "poly": [
                [
                    84.9251287,
                    56.1605331
                ],
                [
                    84.9251287,
                    56.1616802
                ],
                [
                    84.9271885,
                    56.1621581
                ],
                [
                    84.9330251,
                    56.1623493
                ],
                [
                    84.9354284,
                    56.1613934
                ],
                [
                    84.9364583,
                    56.1594815
                ],
                [
                    84.9369733,
                    56.157952
                ],
                [
                    84.9378316,
                    56.1570916
                ],
                [
                    84.9390333,
                    56.1568048
                ],
                [
                    84.9410932,
                    56.1575696
                ],
                [
                    84.9428098,
                    56.1583344
                ],
                [
                    84.9452131,
                    56.1587168
                ],
                [
                    84.9452131,
                    56.157474
                ],
                [
                    84.9438398,
                    56.1567092
                ],
                [
                    84.9431531,
                    56.1558487
                ],
                [
                    84.9443548,
                    56.1548927
                ],
                [
                    84.947003,
                    56.1537289
                ],
                [
                    84.9495046,
                    56.153841
                ],
                [
                    84.9491613,
                    56.1527893
                ],
                [
                    84.9503629,
                    56.1523112
                ],
                [
                    84.9522512,
                    56.1525024
                ],
                [
                    84.9544827,
                    56.15212
                ],
                [
                    84.9560277,
                    56.1511638
                ],
                [
                    84.9560277,
                    56.150112
                ],
                [
                    84.9548261,
                    56.1498252
                ],
                [
                    84.9532812,
                    56.1505901
                ],
                [
                    84.9507062,
                    56.1513551
                ],
                [
                    84.9484746,
                    56.1520244
                ],
                [
                    84.9469297,
                    56.1517375
                ],
                [
                    84.9453847,
                    56.1509726
                ],
                [
                    84.9426382,
                    56.1522156
                ],
                [
                    84.9405782,
                    56.1531717
                ],
                [
                    84.9376599,
                    56.1546059
                ],
                [
                    84.9345701,
                    56.1558487
                ],
                [
                    84.9321668,
                    56.1571872
                ],
                [
                    84.9316518,
                    56.1575696
                ],
                [
                    84.9280469,
                    56.1594815
                ],
                [
                    84.9251287,
                    56.1605331
                ]
            ],
            "longitude": 84.936867,
            "latitude": 56.156025
        },
        "2974": {
            "name": "Коларово",
            "population": 299,
            "type": "village",
            "poly": [
                [
                    84.928552,
                    56.3345303
                ],
                [
                    84.928552,
                    56.3350537
                ],
                [
                    84.930569,
                    56.3370043
                ],
                [
                    84.9337877,
                    56.3380748
                ],
                [
                    84.9340022,
                    56.3389074
                ],
                [
                    84.9348176,
                    56.3400967
                ],
                [
                    84.9372338,
                    56.3405688
                ],
                [
                    84.9396242,
                    56.3418093
                ],
                [
                    84.9411262,
                    56.3412384
                ],
                [
                    84.9445793,
                    56.3393474
                ],
                [
                    84.9436282,
                    56.3385232
                ],
                [
                    84.9476922,
                    56.3380034
                ],
                [
                    84.9519537,
                    56.3370484
                ],
                [
                    84.9561164,
                    56.3364774
                ],
                [
                    84.9605797,
                    56.3355021
                ],
                [
                    84.9614681,
                    56.335125
                ],
                [
                    84.9607514,
                    56.3338844
                ],
                [
                    84.955889,
                    56.3342448
                ],
                [
                    84.946748,
                    56.3342448
                ],
                [
                    84.9411691,
                    56.3335073
                ],
                [
                    84.9384354,
                    56.3334324
                ],
                [
                    84.9364913,
                    56.3341259
                ],
                [
                    84.9322556,
                    56.3344791
                ],
                [
                    84.9295519,
                    56.3341937
                ],
                [
                    84.928552,
                    56.3345303
                ]
            ],
            "longitude": 84.940498,
            "latitude": 56.335175
        },
        "2975": {
            "name": "Батурино",
            "population": 978,
            "type": "village",
            "poly": [
                [
                    84.9645794,
                    56.2622003
                ],
                [
                    84.9659742,
                    56.2620573
                ],
                [
                    84.9659098,
                    56.2660256
                ],
                [
                    84.9679483,
                    56.2669431
                ],
                [
                    84.9721969,
                    56.2669074
                ],
                [
                    84.9713601,
                    56.267944
                ],
                [
                    84.9724544,
                    56.2683134
                ],
                [
                    84.9724759,
                    56.2686471
                ],
                [
                    84.9736346,
                    56.2690641
                ],
                [
                    84.9760164,
                    56.2675508
                ],
                [
                    84.9819387,
                    56.2588156
                ],
                [
                    84.9825006,
                    56.2577837
                ],
                [
                    84.9843205,
                    56.2544412
                ],
                [
                    84.9826253,
                    56.2536068
                ],
                [
                    84.9806727,
                    56.2544889
                ],
                [
                    84.9789131,
                    56.2542863
                ],
                [
                    84.9782909,
                    56.2551445
                ],
                [
                    84.9726046,
                    56.2549657
                ],
                [
                    84.9727333,
                    56.2540598
                ],
                [
                    84.9707163,
                    56.2533207
                ],
                [
                    84.9689997,
                    56.2540598
                ],
                [
                    84.9671544,
                    56.2549538
                ],
                [
                    84.9666394,
                    56.2579693
                ],
                [
                    84.9660171,
                    56.2601385
                ],
                [
                    84.9645794,
                    56.2622003
                ]
            ],
            "longitude": 84.974373,
            "latitude": 56.257439
        },
        "2976": {
            "name": "Басандайка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.9814968,
            "latitude": 56.4110674
        },
        "2977": {
            "name": "Аникино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.9893495,
            "latitude": 56.409311
        },
        "2978": {
            "name": "Кузовлево",
            "population": null,
            "type": "village",
            "poly": [
                [
                    84.996315,
                    56.5745537
                ],
                [
                    85.0002789,
                    56.5778093
                ],
                [
                    85.0010887,
                    56.5775589
                ],
                [
                    85.0018986,
                    56.5776841
                ],
                [
                    85.0026941,
                    56.5788579
                ],
                [
                    85.0036887,
                    56.5791631
                ],
                [
                    85.0044986,
                    56.5798752
                ],
                [
                    85.0050385,
                    56.5798439
                ],
                [
                    85.0059478,
                    56.5782945
                ],
                [
                    85.0109772,
                    56.5779971
                ],
                [
                    85.011233,
                    56.5775432
                ],
                [
                    85.0112472,
                    56.5760407
                ],
                [
                    85.0111193,
                    56.5754146
                ],
                [
                    85.0106647,
                    56.5745537
                ],
                [
                    85.0099543,
                    56.5736772
                ],
                [
                    85.0090734,
                    56.5730432
                ],
                [
                    85.0030494,
                    56.5694428
                ],
                [
                    84.9976931,
                    56.5706169
                ],
                [
                    84.996315,
                    56.5745537
                ]
            ],
            "longitude": 85.005905,
            "latitude": 56.57378
        },
        "2979": {
            "name": "Просторный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.0130329,
            "latitude": 56.4149614
        },
        "2980": {
            "name": "Ключи",
            "population": 186,
            "type": "village",
            "poly": null,
            "longitude": 85.0284142,
            "latitude": 56.404613
        },
        "2981": {
            "name": "Лучаново",
            "population": 1265,
            "type": "village",
            "poly": [
                [
                    85.0466162,
                    56.3461123
                ],
                [
                    85.0479552,
                    56.3494405
                ],
                [
                    85.0508219,
                    56.3579542
                ],
                [
                    85.0519892,
                    56.3605919
                ],
                [
                    85.0535771,
                    56.3613289
                ],
                [
                    85.0592848,
                    56.3607583
                ],
                [
                    85.062246,
                    56.3607583
                ],
                [
                    85.0655075,
                    56.3626602
                ],
                [
                    85.0710865,
                    56.3630168
                ],
                [
                    85.0809571,
                    56.3587613
                ],
                [
                    85.0801846,
                    56.3554327
                ],
                [
                    85.0753351,
                    56.3547907
                ],
                [
                    85.069327,
                    56.3578579
                ],
                [
                    85.0599199,
                    56.3578591
                ],
                [
                    85.0610014,
                    56.3529598
                ],
                [
                    85.0598341,
                    56.3493228
                ],
                [
                    85.0565382,
                    56.3487271
                ],
                [
                    85.0523325,
                    56.3478947
                ],
                [
                    85.0493283,
                    56.3451598
                ],
                [
                    85.0466162,
                    56.3461123
                ]
            ],
            "longitude": 85.054466,
            "latitude": 56.357693
        },
        "2982": {
            "name": "Стеклозавод",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.0518519,
                    56.3642778
                ],
                [
                    85.0534912,
                    56.3676283
                ],
                [
                    85.0602204,
                    56.3673917
                ],
                [
                    85.0617653,
                    56.3671541
                ],
                [
                    85.0652415,
                    56.3632794
                ],
                [
                    85.0655075,
                    56.3626602
                ],
                [
                    85.062246,
                    56.3607583
                ],
                [
                    85.0592848,
                    56.3607583
                ],
                [
                    85.0535771,
                    56.3613289
                ],
                [
                    85.0518519,
                    56.3642778
                ]
            ],
            "longitude": 85.0579888,
            "latitude": 56.3648483
        },
        "2983": {
            "name": "Апрель",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.0729427,
            "latitude": 56.3887438
        },
        "2984": {
            "name": "Позднеево",
            "population": 131,
            "type": "village",
            "poly": null,
            "longitude": 85.077408,
            "latitude": 56.410686
        },
        "2985": {
            "name": "Магадаево",
            "population": 13,
            "type": "village",
            "poly": null,
            "longitude": 85.079394,
            "latitude": 56.3728584
        },
        "2986": {
            "name": "Трубачево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.0998587,
            "latitude": 56.4285128
        },
        "2987": {
            "name": "Копылово",
            "population": 2413,
            "type": "village",
            "poly": [
                [
                    85.0941975,
                    56.6031969
                ],
                [
                    85.0950343,
                    56.6049685
                ],
                [
                    85.1042386,
                    56.6094084
                ],
                [
                    85.1090022,
                    56.6081094
                ],
                [
                    85.1110182,
                    56.6065983
                ],
                [
                    85.1150746,
                    56.6015669
                ],
                [
                    85.1018567,
                    56.6019803
                ],
                [
                    85.1014277,
                    56.6028071
                ],
                [
                    85.0941975,
                    56.6031969
                ]
            ],
            "longitude": 85.1028656,
            "latitude": 56.6067869
        },
        "2988": {
            "name": "Наумовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.10714,
            "latitude": 56.760071
        },
        "2989": {
            "name": "Лоскутово",
            "population": 3111,
            "type": "village",
            "poly": [
                [
                    85.095236,
                    56.3725772
                ],
                [
                    85.0963916,
                    56.3726848
                ],
                [
                    85.0997041,
                    56.3735944
                ],
                [
                    85.1009626,
                    56.3743103
                ],
                [
                    85.101263,
                    56.3747886
                ],
                [
                    85.102507,
                    56.3751091
                ],
                [
                    85.1028294,
                    56.3754656
                ],
                [
                    85.1022495,
                    56.3757742
                ],
                [
                    85.1012206,
                    56.3759881
                ],
                [
                    85.1003296,
                    56.3763508
                ],
                [
                    85.0993452,
                    56.377176
                ],
                [
                    85.0992765,
                    56.3776887
                ],
                [
                    85.1005329,
                    56.378406
                ],
                [
                    85.1013311,
                    56.3783041
                ],
                [
                    85.1029603,
                    56.3784999
                ],
                [
                    85.1026036,
                    56.3787036
                ],
                [
                    85.1025574,
                    56.3789062
                ],
                [
                    85.1019475,
                    56.3791313
                ],
                [
                    85.1007303,
                    56.3801237
                ],
                [
                    85.1017436,
                    56.3804985
                ],
                [
                    85.103332,
                    56.3813711
                ],
                [
                    85.1055652,
                    56.3825353
                ],
                [
                    85.109176,
                    56.384594
                ],
                [
                    85.1110654,
                    56.3841752
                ],
                [
                    85.1112896,
                    56.3839341
                ],
                [
                    85.1116587,
                    56.3828968
                ],
                [
                    85.1121474,
                    56.3816491
                ],
                [
                    85.1121664,
                    56.3809305
                ],
                [
                    85.1123432,
                    56.3800174
                ],
                [
                    85.1123606,
                    56.3792059
                ],
                [
                    85.1122952,
                    56.3785446
                ],
                [
                    85.1121898,
                    56.3778587
                ],
                [
                    85.1121721,
                    56.377488
                ],
                [
                    85.1093971,
                    56.3767821
                ],
                [
                    85.1106554,
                    56.3754466
                ],
                [
                    85.1114709,
                    56.3753777
                ],
                [
                    85.1118556,
                    56.3748106
                ],
                [
                    85.1124913,
                    56.3743674
                ],
                [
                    85.1122906,
                    56.3741704
                ],
                [
                    85.1125239,
                    56.3738511
                ],
                [
                    85.1123545,
                    56.3734872
                ],
                [
                    85.1120004,
                    56.3726854
                ],
                [
                    85.1121436,
                    56.3723431
                ],
                [
                    85.1108176,
                    56.3718663
                ],
                [
                    85.1102092,
                    56.3712234
                ],
                [
                    85.1097377,
                    56.3706946
                ],
                [
                    85.1080742,
                    56.3702095
                ],
                [
                    85.106865,
                    56.3699682
                ],
                [
                    85.105885,
                    56.3695128
                ],
                [
                    85.1048871,
                    56.3690555
                ],
                [
                    85.1036453,
                    56.3697492
                ],
                [
                    85.1014153,
                    56.370219
                ],
                [
                    85.1002765,
                    56.3708785
                ],
                [
                    85.1004808,
                    56.371312
                ],
                [
                    85.1000624,
                    56.3722448
                ],
                [
                    85.0998472,
                    56.372429
                ],
                [
                    85.0986441,
                    56.3724718
                ],
                [
                    85.0963428,
                    56.3721706
                ],
                [
                    85.0954614,
                    56.3724649
                ],
                [
                    85.095236,
                    56.3725772
                ]
            ],
            "longitude": 85.109108,
            "latitude": 56.378063
        },
        "2990": {
            "name": "Мирный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.116737,
            "latitude": 56.441978
        },
        "2991": {
            "name": "Некрасово",
            "population": 72,
            "type": "village",
            "poly": null,
            "longitude": 85.1352385,
            "latitude": 56.3441696
        },
        "2992": {
            "name": "Аксёново",
            "population": 18,
            "type": "village",
            "poly": [
                [
                    85.133865,
                    56.3253462
                ],
                [
                    85.1343821,
                    56.3255371
                ],
                [
                    85.1344884,
                    56.3258459
                ],
                [
                    85.134927,
                    56.3258095
                ],
                [
                    85.1371642,
                    56.3264424
                ],
                [
                    85.1390028,
                    56.3273118
                ],
                [
                    85.1394502,
                    56.3273647
                ],
                [
                    85.139756,
                    56.3273486
                ],
                [
                    85.1402013,
                    56.3273171
                ],
                [
                    85.1406572,
                    56.3272178
                ],
                [
                    85.1408289,
                    56.327075
                ],
                [
                    85.1414726,
                    56.3268846
                ],
                [
                    85.1417677,
                    56.3267103
                ],
                [
                    85.142111,
                    56.3264248
                ],
                [
                    85.1425616,
                    56.3263058
                ],
                [
                    85.1428191,
                    56.3261987
                ],
                [
                    85.1429478,
                    56.3263534
                ],
                [
                    85.1428835,
                    56.3265557
                ],
                [
                    85.1429049,
                    56.3266984
                ],
                [
                    85.1432751,
                    56.3267776
                ],
                [
                    85.1433985,
                    56.3265795
                ],
                [
                    85.1435701,
                    56.3264843
                ],
                [
                    85.1437471,
                    56.3263611
                ],
                [
                    85.1440207,
                    56.3261036
                ],
                [
                    85.1441978,
                    56.3257901
                ],
                [
                    85.1431938,
                    56.3234823
                ],
                [
                    85.1423946,
                    56.3232007
                ],
                [
                    85.1422844,
                    56.3224939
                ],
                [
                    85.1401821,
                    56.3209396
                ],
                [
                    85.1386426,
                    56.3211728
                ],
                [
                    85.1379055,
                    56.3213846
                ],
                [
                    85.1367397,
                    56.3210069
                ],
                [
                    85.1360183,
                    56.3211716
                ],
                [
                    85.1361438,
                    56.3217868
                ],
                [
                    85.1365483,
                    56.3222193
                ],
                [
                    85.1360514,
                    56.3230189
                ],
                [
                    85.1352984,
                    56.3237566
                ],
                [
                    85.1357265,
                    56.3242534
                ],
                [
                    85.1353338,
                    56.3245716
                ],
                [
                    85.1349582,
                    56.3247061
                ],
                [
                    85.1353381,
                    56.3248863
                ],
                [
                    85.1359325,
                    56.3251665
                ],
                [
                    85.135146,
                    56.3254313
                ],
                [
                    85.1346053,
                    56.3253254
                ],
                [
                    85.1341032,
                    56.3252159
                ],
                [
                    85.133865,
                    56.3253462
                ]
            ],
            "longitude": 85.139511,
            "latitude": 56.324608
        },
        "2993": {
            "name": "Новомихайловка",
            "population": 290,
            "type": "village",
            "poly": null,
            "longitude": 85.143005,
            "latitude": 56.5406
        },
        "2994": {
            "name": "Богашёво",
            "population": 3721,
            "type": "village",
            "poly": null,
            "longitude": 85.147224,
            "latitude": 56.366276
        },
        "2995": {
            "name": "Нулевой Пикет",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.152977,
            "latitude": 57.77922800000001
        },
        "2996": {
            "name": "Овражное",
            "population": 22,
            "type": "village",
            "poly": null,
            "longitude": 85.1567733,
            "latitude": 56.2318581
        },
        "2997": {
            "name": "Малое Протопопово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.161209,
            "latitude": 56.426544
        },
        "2998": {
            "name": "Корнилово",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.1440109,
                    56.5092768
                ],
                [
                    85.1463927,
                    56.5116508
                ],
                [
                    85.1491178,
                    56.5118224
                ],
                [
                    85.1494081,
                    56.5116402
                ],
                [
                    85.151542,
                    56.510301
                ],
                [
                    85.1526422,
                    56.510827
                ],
                [
                    85.1650448,
                    56.5076656
                ],
                [
                    85.1662464,
                    56.5062151
                ],
                [
                    85.1678235,
                    56.505552
                ],
                [
                    85.1730748,
                    56.5045937
                ],
                [
                    85.1802368,
                    56.5066414
                ],
                [
                    85.1845546,
                    56.506814
                ],
                [
                    85.1862176,
                    56.5062633
                ],
                [
                    85.1845546,
                    56.5022785
                ],
                [
                    85.1865502,
                    56.501639
                ],
                [
                    85.1916786,
                    56.4974527
                ],
                [
                    85.1909919,
                    56.4929517
                ],
                [
                    85.191899,
                    56.4894144
                ],
                [
                    85.1943129,
                    56.487436
                ],
                [
                    85.1932831,
                    56.4850369
                ],
                [
                    85.1902896,
                    56.4845333
                ],
                [
                    85.1854939,
                    56.4878862
                ],
                [
                    85.1836378,
                    56.4900245
                ],
                [
                    85.1797433,
                    56.4894026
                ],
                [
                    85.1718302,
                    56.4894452
                ],
                [
                    85.1694007,
                    56.4898468
                ],
                [
                    85.1643844,
                    56.4863828
                ],
                [
                    85.1615091,
                    56.4857075
                ],
                [
                    85.1605006,
                    56.4863472
                ],
                [
                    85.162539,
                    56.4873898
                ],
                [
                    85.1620562,
                    56.4878222
                ],
                [
                    85.1615305,
                    56.489155
                ],
                [
                    85.1648087,
                    56.4933651
                ],
                [
                    85.1634676,
                    56.4962611
                ],
                [
                    85.1600607,
                    56.4980804
                ],
                [
                    85.1596482,
                    56.4988254
                ],
                [
                    85.1549704,
                    56.5025323
                ],
                [
                    85.1520999,
                    56.5042384
                ],
                [
                    85.1486296,
                    56.5065111
                ],
                [
                    85.1473207,
                    56.5058599
                ],
                [
                    85.1456417,
                    56.5072166
                ],
                [
                    85.1440109,
                    56.5092768
                ]
            ],
            "longitude": 85.170868,
            "latitude": 56.495255
        },
        "2999": {
            "name": "Большое Протопопово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.17971,
            "latitude": 56.418282
        },
        "3000": {
            "name": "Белоусово",
            "population": 367,
            "type": "village",
            "poly": null,
            "longitude": 85.182785,
            "latitude": 56.305416
        },
        "3001": {
            "name": "Батурино",
            "population": null,
            "type": "village",
            "poly": [
                [
                    85.13509,
                    57.7484786
                ],
                [
                    85.1492988,
                    57.7547117
                ],
                [
                    85.1566081,
                    57.7529621
                ],
                [
                    85.162483,
                    57.7532902
                ],
                [
                    85.1735494,
                    57.7558415
                ],
                [
                    85.1818152,
                    57.7577731
                ],
                [
                    85.1895344,
                    57.762219
                ],
                [
                    85.1926768,
                    57.7650612
                ],
                [
                    85.2017622,
                    57.7676117
                ],
                [
                    85.2064757,
                    57.7700892
                ],
                [
                    85.2106428,
                    57.7711821
                ],
                [
                    85.2095498,
                    57.7673567
                ],
                [
                    85.2110526,
                    57.7630207
                ],
                [
                    85.2118041,
                    57.7621462
                ],
                [
                    85.2060659,
                    57.757518
                ],
                [
                    85.1999861,
                    57.7545294
                ],
                [
                    85.1947944,
                    57.751978
                ],
                [
                    85.1908324,
                    57.749317
                ],
                [
                    85.1859139,
                    57.7457809
                ],
                [
                    85.1822934,
                    57.743156
                ],
                [
                    85.1795609,
                    57.7414059
                ],
                [
                    85.1710903,
                    57.7416247
                ],
                [
                    85.1586575,
                    57.7415518
                ],
                [
                    85.1452684,
                    57.7415153
                ],
                [
                    85.1406915,
                    57.7423174
                ],
                [
                    85.13509,
                    57.7484786
                ]
            ],
            "longitude": 85.188324,
            "latitude": 57.757053
        },
        "3002": {
            "name": "Сафроново",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.1951428,
            "latitude": 56.4514171
        },
        "3003": {
            "name": "Рассвет",
            "population": 1845,
            "type": "village",
            "poly": [
                [
                    85.1884755,
                    56.6251168
                ],
                [
                    85.1940974,
                    56.6283746
                ],
                [
                    85.2005176,
                    56.631284
                ],
                [
                    85.2062854,
                    56.6297201
                ],
                [
                    85.2117614,
                    56.6327002
                ],
                [
                    85.216482,
                    56.6301509
                ],
                [
                    85.2099332,
                    56.6267693
                ],
                [
                    85.2115467,
                    56.6258321
                ],
                [
                    85.2039079,
                    56.6219366
                ],
                [
                    85.1988031,
                    56.6221963
                ],
                [
                    85.192795,
                    56.6226213
                ],
                [
                    85.1884755,
                    56.6251168
                ]
            ],
            "longitude": 85.200081,
            "latitude": 56.625328
        },
        "3004": {
            "name": "Аэропорт",
            "population": 1191,
            "type": "village",
            "poly": null,
            "longitude": 85.205238,
            "latitude": 56.389336
        },
        "3005": {
            "name": "Лисица",
            "population": 354,
            "type": "village",
            "poly": null,
            "longitude": 85.226944,
            "latitude": 58.699844
        },
        "3006": {
            "name": "Ягодное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.232315,
            "latitude": 58.254745
        },
        "3007": {
            "name": "Лязгино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.233185,
            "latitude": 56.484398
        },
        "3008": {
            "name": "Воронино",
            "population": 1056,
            "type": "village",
            "poly": null,
            "longitude": 85.255806,
            "latitude": 56.557327
        },
        "3009": {
            "name": "Петухово",
            "population": 628,
            "type": "village",
            "poly": null,
            "longitude": 85.2664647,
            "latitude": 56.3233471
        },
        "3010": {
            "name": "Гарь",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.271667,
            "latitude": 57.09639
        },
        "3011": {
            "name": "Сухарево",
            "population": 52,
            "type": "village",
            "poly": null,
            "longitude": 85.2793394,
            "latitude": 56.2951613
        },
        "3012": {
            "name": "Заречный",
            "population": 536,
            "type": "village",
            "poly": null,
            "longitude": 85.3210918,
            "latitude": 56.6525464
        },
        "3013": {
            "name": "Молодёжный",
            "population": 1528,
            "type": "village",
            "poly": null,
            "longitude": 85.322189,
            "latitude": 56.677029
        },
        "3014": {
            "name": "Малиновка",
            "population": 2255,
            "type": "village",
            "poly": null,
            "longitude": 85.343315,
            "latitude": 56.698982
        },
        "3015": {
            "name": "Заречный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.3545271,
            "latitude": 56.2918272
        },
        "3016": {
            "name": "Семилужки",
            "population": 1020,
            "type": "village",
            "poly": null,
            "longitude": 85.364891,
            "latitude": 56.6157
        },
        "3017": {
            "name": "Межениновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.367683,
            "latitude": 56.358738
        },
        "3018": {
            "name": "Александровское",
            "population": 930,
            "type": "village",
            "poly": null,
            "longitude": 85.386749,
            "latitude": 56.74192
        },
        "3019": {
            "name": "Сайга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.427574,
            "latitude": 58.024899
        },
        "3020": {
            "name": "Октябрьское",
            "population": 2109,
            "type": "village",
            "poly": null,
            "longitude": 85.4428792,
            "latitude": 56.7292253
        },
        "3021": {
            "name": "Сухоречье",
            "population": 232,
            "type": "village",
            "poly": null,
            "longitude": 85.4645583,
            "latitude": 56.477506
        },
        "3022": {
            "name": "Усть-Юл",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.4760525,
            "latitude": 57.7409586
        },
        "3023": {
            "name": "Первопашенск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.484489,
            "latitude": 57.572613
        },
        "3024": {
            "name": "Басандайка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.4869,
            "latitude": 56.283859
        },
        "3025": {
            "name": "Халдеево",
            "population": 395,
            "type": "village",
            "poly": [
                [
                    85.5793321,
                    56.6360752
                ],
                [
                    85.5810915,
                    56.6445
                ],
                [
                    85.5833662,
                    56.6445
                ],
                [
                    85.5883229,
                    56.6383467
                ],
                [
                    85.5918205,
                    56.6369484
                ],
                [
                    85.5940092,
                    56.636736
                ],
                [
                    85.6001461,
                    56.6376328
                ],
                [
                    85.6060255,
                    56.636736
                ],
                [
                    85.6079996,
                    56.6357211
                ],
                [
                    85.6089652,
                    56.6338861
                ],
                [
                    85.5954468,
                    56.6317617
                ],
                [
                    85.583173,
                    56.6295429
                ],
                [
                    85.5793321,
                    56.6360752
                ]
            ],
            "longitude": 85.587982,
            "latitude": 56.631714
        },
        "3026": {
            "name": "Макзыр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.603065,
            "latitude": 58.620972
        },
        "3027": {
            "name": "Итатка",
            "population": 1365,
            "type": "village",
            "poly": null,
            "longitude": 85.603767,
            "latitude": 56.823124
        },
        "3028": {
            "name": "Томское",
            "population": 835,
            "type": "village",
            "poly": null,
            "longitude": 85.61834,
            "latitude": 56.84264
        },
        "3029": {
            "name": "Альмяково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.6893467,
            "latitude": 57.6172155
        },
        "3030": {
            "name": "Апсагачево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.7835338,
            "latitude": 57.5856849
        },
        "3031": {
            "name": "Улу-Юл",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.7929652,
            "latitude": 57.7107009
        },
        "3032": {
            "name": "Нижние Соколы",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.793633,
            "latitude": 56.877575
        },
        "3033": {
            "name": "Моисеевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.808388,
            "latitude": 56.937557
        },
        "3034": {
            "name": "Подломск",
            "population": 254,
            "type": "village",
            "poly": null,
            "longitude": 85.810333,
            "latitude": 56.648956
        },
        "3035": {
            "name": "Филимоновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.817871,
            "latitude": 57.177773
        },
        "3036": {
            "name": "Цветковка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.839249,
            "latitude": 56.805428
        },
        "3037": {
            "name": "Клюквинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.857155,
            "latitude": 58.53862
        },
        "3038": {
            "name": "Большой Кордон",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.865646,
            "latitude": 57.374809
        },
        "3039": {
            "name": "Новониколаевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.869026,
            "latitude": 57.299557
        },
        "3040": {
            "name": "Новоархангельское",
            "population": 337,
            "type": "village",
            "poly": null,
            "longitude": 85.890915,
            "latitude": 56.71246
        },
        "3041": {
            "name": "Латат",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.911514,
            "latitude": 56.749184
        },
        "3042": {
            "name": "Казанка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.921555,
            "latitude": 57.088993
        },
        "3043": {
            "name": "Романовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.936508,
            "latitude": 56.45499
        },
        "3044": {
            "name": "Новиковка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.959297,
            "latitude": 56.925964
        },
        "3045": {
            "name": "Светлый",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.969597,
            "latitude": 56.93552
        },
        "3046": {
            "name": "Турунтаево",
            "population": 1010,
            "type": "village",
            "poly": [
                [
                    85.9498252,
                    56.6460337
                ],
                [
                    85.9622706,
                    56.6512715
                ],
                [
                    85.9915346,
                    56.6525454
                ],
                [
                    86.0056108,
                    56.6403256
                ],
                [
                    86.0145372,
                    56.6325844
                ],
                [
                    86.0074433,
                    56.6317795
                ],
                [
                    86.0003751,
                    56.6320651
                ],
                [
                    85.9923071,
                    56.6334813
                ],
                [
                    85.9909638,
                    56.6295134
                ],
                [
                    85.9837541,
                    56.6303632
                ],
                [
                    85.9870156,
                    56.639332
                ],
                [
                    85.95446,
                    56.6387208
                ],
                [
                    85.9498252,
                    56.6460337
                ]
            ],
            "longitude": 85.973747,
            "latitude": 56.645527
        },
        "3047": {
            "name": "Перовка",
            "population": 135,
            "type": "village",
            "poly": null,
            "longitude": 85.975204,
            "latitude": 56.690311
        },
        "3048": {
            "name": "Новорождественское",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.997566,
            "latitude": 56.487888
        },
        "3049": {
            "name": "Центральный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.001638,
            "latitude": 58.9490562
        },
        "3050": {
            "name": "Комсомольск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.026436,
            "latitude": 57.410019
        },
        "3051": {
            "name": "Балагачево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0269398,
            "latitude": 57.3743382
        },
        "3052": {
            "name": "Старо-Кусково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.040001,
            "latitude": 57.067257
        },
        "3053": {
            "name": "Сахалинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0484481,
            "latitude": 57.3140053
        },
        "3054": {
            "name": "Тазырбак",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0497721,
            "latitude": 57.3788664
        },
        "3055": {
            "name": "Царицынка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0592646,
            "latitude": 57.231034
        },
        "3056": {
            "name": "Ново-Кусково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.065926,
            "latitude": 57.052601
        },
        "3057": {
            "name": "Аргат-Юл",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0696937,
            "latitude": 57.8521919
        },
        "3058": {
            "name": "Тихомировка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0721887,
            "latitude": 56.9308222
        },
        "3059": {
            "name": "Дружный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.073906,
            "latitude": 58.761368
        },
        "3060": {
            "name": "Вознесенка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0747552,
            "latitude": 57.2020818
        },
        "3061": {
            "name": "Сергеево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0776753,
            "latitude": 57.2719391
        },
        "3062": {
            "name": "Итатка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.0886266,
            "latitude": 56.938588
        },
        "3063": {
            "name": "Ягодное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.090385,
            "latitude": 56.803173
        },
        "3064": {
            "name": "Ежи",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.1146683,
            "latitude": 57.156059
        },
        "3065": {
            "name": "Мазалово",
            "population": null,
            "type": "village",
            "poly": [
                [
                    86.1202809,
                    56.5950463
                ],
                [
                    86.1244437,
                    56.5978224
                ],
                [
                    86.1310526,
                    56.6015787
                ],
                [
                    86.1347004,
                    56.6034094
                ],
                [
                    86.1382409,
                    56.6024527
                ],
                [
                    86.1401936,
                    56.6044606
                ],
                [
                    86.1432599,
                    56.6036734
                ],
                [
                    86.1404082,
                    56.6000432
                ],
                [
                    86.1433886,
                    56.5992795
                ],
                [
                    86.1417385,
                    56.5968538
                ],
                [
                    86.1392709,
                    56.5940894
                ],
                [
                    86.1441611,
                    56.5907855
                ],
                [
                    86.1434337,
                    56.589848
                ],
                [
                    86.1388396,
                    56.5881507
                ],
                [
                    86.136417,
                    56.589978
                ],
                [
                    86.1348914,
                    56.5897458
                ],
                [
                    86.1328958,
                    56.5914826
                ],
                [
                    86.1299154,
                    56.5908523
                ],
                [
                    86.1223408,
                    56.5936759
                ],
                [
                    86.1202809,
                    56.5950463
                ]
            ],
            "longitude": 86.126656,
            "latitude": 56.595417
        },
        "3066": {
            "name": "Успенка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.1425633,
            "latitude": 57.1390759
        },
        "3067": {
            "name": "Воронино-Яя",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.1765599,
            "latitude": 56.8759418
        },
        "3068": {
            "name": "Рождественка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.1842341,
            "latitude": 57.312428
        },
        "3069": {
            "name": "Больше-Жирово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.1880612,
            "latitude": 56.8109724
        },
        "3070": {
            "name": "Новый",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.198645,
            "latitude": 57.1089184
        },
        "3071": {
            "name": "Больше-Дорохово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.198914,
            "latitude": 56.889816
        },
        "3072": {
            "name": "Узень",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.2068934,
            "latitude": 57.2987048
        },
        "3073": {
            "name": "Победа",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.256775,
            "latitude": 56.94735
        },
        "3074": {
            "name": "Беляй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.2636506,
            "latitude": 57.0508964
        },
        "3075": {
            "name": "Семёновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.286728,
            "latitude": 56.873623
        },
        "3076": {
            "name": "Ломовицк-2",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.3055987,
            "latitude": 57.127664
        },
        "3077": {
            "name": "Крутоложное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.3251252,
            "latitude": 57.0397623
        },
        "3078": {
            "name": "Торбеево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.3411326,
            "latitude": 57.0247521
        },
        "3079": {
            "name": "Мишутино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.343628,
            "latitude": 56.717613
        },
        "3080": {
            "name": "Тиндерлинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.379084,
            "latitude": 56.9924728
        },
        "3081": {
            "name": "Туендат",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.3991522,
            "latitude": 57.1339074
        },
        "3082": {
            "name": "Громышевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.420876,
            "latitude": 56.596073
        },
        "3083": {
            "name": "Калмаки",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.4308686,
            "latitude": 56.9893434
        },
        "3084": {
            "name": "Дубровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.446457,
            "latitude": 56.72995
        },
        "3085": {
            "name": "Цыганово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.466156,
            "latitude": 56.868717
        },
        "3086": {
            "name": "Куяново",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.4674324,
            "latitude": 56.949108
        },
        "3087": {
            "name": "Новомариинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.503349,
            "latitude": 57.137726
        },
        "3088": {
            "name": "Уйданово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.5494866,
            "latitude": 56.9333763
        },
        "3089": {
            "name": "Берлинка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.552155,
            "latitude": 56.832485
        },
        "3090": {
            "name": "Причулымский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.5691495,
            "latitude": 56.8410301
        },
        "3091": {
            "name": "Калиновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.6027445,
            "latitude": 57.1272913
        },
        "3092": {
            "name": "Городок",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.6478467,
            "latitude": 56.9162338
        },
        "3093": {
            "name": "Орехово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.687546,
            "latitude": 57.220161
        },
        "3094": {
            "name": "Богословка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.724182,
            "latitude": 56.803886
        },
        "3095": {
            "name": "Берёзовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.7565083,
            "latitude": 57.006642
        },
        "3096": {
            "name": "Степановка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.769531,
            "latitude": 58.636868
        },
        "3097": {
            "name": "Михайловка",
            "population": 375,
            "type": "village",
            "poly": [
                [
                    86.7946187,
                    56.7100543
                ],
                [
                    86.7956401,
                    56.7121613
                ],
                [
                    86.7994166,
                    56.7125853
                ],
                [
                    86.8191556,
                    56.7125146
                ],
                [
                    86.8231896,
                    56.7088883
                ],
                [
                    86.8140915,
                    56.706462
                ],
                [
                    86.8043498,
                    56.7050721
                ],
                [
                    86.8000604,
                    56.7048836
                ],
                [
                    86.7955543,
                    56.7068625
                ],
                [
                    86.7946187,
                    56.7100543
                ]
            ],
            "longitude": 86.807343,
            "latitude": 56.708427
        },
        "3098": {
            "name": "Иловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.820847,
            "latitude": 56.889511
        },
        "3099": {
            "name": "Максимкин Яр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.8212875,
            "latitude": 58.6785322
        },
        "3100": {
            "name": "Красноярка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.834068,
            "latitude": 56.815266
        },
        "3101": {
            "name": "Прушинский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.9080327,
            "latitude": 56.8862105
        },
        "3102": {
            "name": "Высокое",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.909538,
            "latitude": 56.604626
        },
        "3103": {
            "name": "Тавлы",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.9232678,
            "latitude": 56.5949152
        },
        "3104": {
            "name": "Чердаты",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 86.933632,
            "latitude": 56.954346
        },
        "3105": {
            "name": "Окунеево",
            "population": 272,
            "type": "village",
            "poly": [
                [
                    86.9769982,
                    56.7752563
                ],
                [
                    86.9802598,
                    56.7749741
                ],
                [
                    86.9822339,
                    56.7774901
                ],
                [
                    86.9869867,
                    56.78292
                ],
                [
                    86.9903019,
                    56.7821924
                ],
                [
                    86.9916323,
                    56.7725285
                ],
                [
                    86.9987134,
                    56.7683424
                ],
                [
                    86.9991425,
                    56.767237
                ],
                [
                    87.0031766,
                    56.7656142
                ],
                [
                    87.0082084,
                    56.7644275
                ],
                [
                    87.0074681,
                    56.7639442
                ],
                [
                    87.0053223,
                    56.7638031
                ],
                [
                    87.0029191,
                    56.7641794
                ],
                [
                    86.99837,
                    56.7658494
                ],
                [
                    86.985195,
                    56.7723639
                ],
                [
                    86.9821051,
                    56.773187
                ],
                [
                    86.9771269,
                    56.7738689
                ],
                [
                    86.9769982,
                    56.7752563
                ]
            ],
            "longitude": 86.987801,
            "latitude": 56.772156
        },
        "3106": {
            "name": "Шиняево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.028679,
            "latitude": 56.666519
        },
        "3107": {
            "name": "Кучуково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.0314768,
            "latitude": 56.9704429
        },
        "3108": {
            "name": "Беловодовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.073021,
            "latitude": 56.597076
        },
        "3109": {
            "name": "Красная Горка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.2356258,
            "latitude": 57.1061707
        },
        "3110": {
            "name": "Чёрный Яр",
            "population": null,
            "type": "village",
            "poly": [
                [
                    87.3022533,
                    57.0498203
                ],
                [
                    87.323558,
                    57.0539615
                ],
                [
                    87.3307678,
                    57.0448113
                ],
                [
                    87.3263396,
                    57.0408966
                ],
                [
                    87.307517,
                    57.0377573
                ],
                [
                    87.3022533,
                    57.0498203
                ]
            ],
            "longitude": 87.3157177,
            "latitude": 57.0457049
        },
        "3111": {
            "name": "Берегаево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.5486325,
            "latitude": 57.2056643
        },
        "3112": {
            "name": "Усть-Озёрное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.7239958,
            "latitude": 58.9054839
        },
        "3113": {
            "name": "Катайга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 87.930588,
            "latitude": 58.744049
        },
        "3114": {
            "name": "Четь-Конторка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.1183725,
            "latitude": 57.0605209
        },
        "3115": {
            "name": "Центрополигон",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.281715,
            "latitude": 57.418991
        },
        "3116": {
            "name": "Новошумилово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.5111013,
            "latitude": 57.4204933
        },
        "3117": {
            "name": "Белый Яр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 88.7660617,
            "latitude": 57.5006853
        },
        "3118": {
            "name": "Еланка",
            "population": 676,
            "type": "village",
            "poly": [
                [
                    75.2760195,
                    55.6281804
                ],
                [
                    75.2801725,
                    55.6306086
                ],
                [
                    75.2819523,
                    55.630818
                ],
                [
                    75.2827681,
                    55.6291642
                ],
                [
                    75.283176,
                    55.6280547
                ],
                [
                    75.2876998,
                    55.6265893
                ],
                [
                    75.2882189,
                    55.6268615
                ],
                [
                    75.2866985,
                    55.6303784
                ],
                [
                    75.2898504,
                    55.6309017
                ],
                [
                    75.2923348,
                    55.6280757
                ],
                [
                    75.295672,
                    55.6282432
                ],
                [
                    75.2937809,
                    55.6314459
                ],
                [
                    75.2964507,
                    55.6321158
                ],
                [
                    75.2977856,
                    55.6318646
                ],
                [
                    75.2990092,
                    55.6303156
                ],
                [
                    75.3013081,
                    55.6307552
                ],
                [
                    75.3029584,
                    55.6300532
                ],
                [
                    75.3065365,
                    55.6270708
                ],
                [
                    75.3083534,
                    55.6250611
                ],
                [
                    75.3078714,
                    55.6240561
                ],
                [
                    75.3048308,
                    55.6209574
                ],
                [
                    75.3027173,
                    55.6177957
                ],
                [
                    75.2836209,
                    55.6178794
                ],
                [
                    75.2827681,
                    55.6185704
                ],
                [
                    75.2812849,
                    55.6209365
                ],
                [
                    75.2829906,
                    55.6229884
                ],
                [
                    75.2788747,
                    55.6238049
                ],
                [
                    75.2760195,
                    55.6281804
                ]
            ],
            "longitude": 75.294067,
            "latitude": 55.625153
        },
        "3119": {
            "name": "Ускюль",
            "population": 346,
            "type": "village",
            "poly": [
                [
                    75.340312,
                    55.3376154
                ],
                [
                    75.3515316,
                    55.3417205
                ],
                [
                    75.3580044,
                    55.3429698
                ],
                [
                    75.3660464,
                    55.3384186
                ],
                [
                    75.3769914,
                    55.3398019
                ],
                [
                    75.3775014,
                    55.3367676
                ],
                [
                    75.3769522,
                    55.3361875
                ],
                [
                    75.3680864,
                    55.3323719
                ],
                [
                    75.3643988,
                    55.329471
                ],
                [
                    75.3638496,
                    55.3226418
                ],
                [
                    75.3585144,
                    55.3217043
                ],
                [
                    75.3549053,
                    55.3218829
                ],
                [
                    75.3532185,
                    55.3230212
                ],
                [
                    75.3487463,
                    55.3275295
                ],
                [
                    75.3468633,
                    55.3274402
                ],
                [
                    75.3403513,
                    55.3303413
                ],
                [
                    75.340312,
                    55.3376154
                ]
            ],
            "longitude": 75.354065,
            "latitude": 55.333885
        },
        "3120": {
            "name": "Увальское",
            "population": 661,
            "type": "village",
            "poly": [
                [
                    75.3598621,
                    55.4765198
                ],
                [
                    75.3624897,
                    55.4771999
                ],
                [
                    75.366557,
                    55.4775801
                ],
                [
                    75.3668505,
                    55.4812395
                ],
                [
                    75.372595,
                    55.4806217
                ],
                [
                    75.3736433,
                    55.4787445
                ],
                [
                    75.3833293,
                    55.4795049
                ],
                [
                    75.3857193,
                    55.4790534
                ],
                [
                    75.3860967,
                    55.4783881
                ],
                [
                    75.3971664,
                    55.4784356
                ],
                [
                    75.4054687,
                    55.4785069
                ],
                [
                    75.4054268,
                    55.4751799
                ],
                [
                    75.3941474,
                    55.4751086
                ],
                [
                    75.3947344,
                    55.4735639
                ],
                [
                    75.3929314,
                    55.4722568
                ],
                [
                    75.3895769,
                    55.4706168
                ],
                [
                    75.3740626,
                    55.4687154
                ],
                [
                    75.3721757,
                    55.4685015
                ],
                [
                    75.3646281,
                    55.4683826
                ],
                [
                    75.3598621,
                    55.4765198
                ]
            ],
            "longitude": 75.373253,
            "latitude": 55.473545
        },
        "3121": {
            "name": "Новопервомайское",
            "population": 946,
            "type": "village",
            "poly": [
                [
                    75.3880798,
                    55.1438374
                ],
                [
                    75.4056452,
                    55.1469491
                ],
                [
                    75.4090992,
                    55.1474021
                ],
                [
                    75.4163793,
                    55.1482486
                ],
                [
                    75.4165985,
                    55.1477636
                ],
                [
                    75.4172951,
                    55.1416068
                ],
                [
                    75.4169219,
                    55.1339984
                ],
                [
                    75.4112493,
                    55.1339984
                ],
                [
                    75.4076666,
                    55.1338989
                ],
                [
                    75.4032878,
                    55.1340695
                ],
                [
                    75.3984363,
                    55.1337566
                ],
                [
                    75.3977893,
                    55.1371131
                ],
                [
                    75.3952019,
                    55.1375539
                ],
                [
                    75.3892557,
                    55.1396587
                ],
                [
                    75.3880798,
                    55.1438374
                ]
            ],
            "longitude": 75.405014,
            "latitude": 55.140121
        },
        "3122": {
            "name": "Козино",
            "population": 643,
            "type": "village",
            "poly": [
                [
                    75.4774183,
                    55.5202887
                ],
                [
                    75.4775281,
                    55.5219036
                ],
                [
                    75.4785521,
                    55.5253612
                ],
                [
                    75.4803443,
                    55.5258373
                ],
                [
                    75.4840749,
                    55.5252162
                ],
                [
                    75.4842944,
                    55.5222142
                ],
                [
                    75.4870009,
                    55.5205578
                ],
                [
                    75.4864523,
                    55.5177418
                ],
                [
                    75.4922676,
                    55.5174726
                ],
                [
                    75.4935843,
                    55.5156297
                ],
                [
                    75.4966341,
                    55.5154911
                ],
                [
                    75.5018453,
                    55.5162107
                ],
                [
                    75.5032034,
                    55.5142215
                ],
                [
                    75.5049956,
                    55.5105145
                ],
                [
                    75.500314,
                    55.5075528
                ],
                [
                    75.4993265,
                    55.5080499
                ],
                [
                    75.4990339,
                    55.5104731
                ],
                [
                    75.4927431,
                    55.5105973
                ],
                [
                    75.4873666,
                    55.5103281
                ],
                [
                    75.4878787,
                    55.5118607
                ],
                [
                    75.4842211,
                    55.5139937
                ],
                [
                    75.4776012,
                    55.5176383
                ],
                [
                    75.4774183,
                    55.5202887
                ]
            ],
            "longitude": 75.489632,
            "latitude": 55.515091
        },
        "3123": {
            "name": "Неудачино",
            "population": 474,
            "type": "village",
            "poly": [
                [
                    75.4896543,
                    55.1423565
                ],
                [
                    75.5011768,
                    55.1426095
                ],
                [
                    75.5008613,
                    55.1408096
                ],
                [
                    75.5148722,
                    55.1403204
                ],
                [
                    75.516193,
                    55.1366935
                ],
                [
                    75.5156923,
                    55.1320472
                ],
                [
                    75.5145232,
                    55.132151
                ],
                [
                    75.5137517,
                    55.1295754
                ],
                [
                    75.5076543,
                    55.1298727
                ],
                [
                    75.5083123,
                    55.1337515
                ],
                [
                    75.4961129,
                    55.1343131
                ],
                [
                    75.4917765,
                    55.1364933
                ],
                [
                    75.4896543,
                    55.1423565
                ]
            ],
            "longitude": 75.507233,
            "latitude": 55.135757
        },
        "3124": {
            "name": "Никулино",
            "population": 445,
            "type": "village",
            "poly": [
                [
                    75.5027887,
                    55.0446519
                ],
                [
                    75.502912,
                    55.0464532
                ],
                [
                    75.5103403,
                    55.0463296
                ],
                [
                    75.510217,
                    55.0486958
                ],
                [
                    75.5077512,
                    55.0486958
                ],
                [
                    75.5079978,
                    55.0502674
                ],
                [
                    75.5085218,
                    55.0518742
                ],
                [
                    75.5177995,
                    55.0523156
                ],
                [
                    75.5190632,
                    55.05281
                ],
                [
                    75.5202653,
                    55.0551935
                ],
                [
                    75.5267998,
                    55.0566764
                ],
                [
                    75.5294198,
                    55.0561291
                ],
                [
                    75.5292039,
                    55.0544696
                ],
                [
                    75.5268306,
                    55.0542577
                ],
                [
                    75.5263683,
                    55.0521567
                ],
                [
                    75.5355844,
                    55.0522096
                ],
                [
                    75.5347213,
                    55.0475481
                ],
                [
                    75.527632,
                    55.0441223
                ],
                [
                    75.5027887,
                    55.0446519
                ]
            ],
            "longitude": 75.520653,
            "latitude": 55.046822
        },
        "3125": {
            "name": "Зубовка",
            "population": 432,
            "type": "village",
            "poly": [
                [
                    75.5112053,
                    54.8530764
                ],
                [
                    75.5169365,
                    54.8544349
                ],
                [
                    75.5160214,
                    54.8559874
                ],
                [
                    75.5202596,
                    54.8570131
                ],
                [
                    75.5219452,
                    54.8555715
                ],
                [
                    75.5273392,
                    54.8568745
                ],
                [
                    75.5292657,
                    54.8590091
                ],
                [
                    75.5370677,
                    54.8613653
                ],
                [
                    75.5378383,
                    54.8589814
                ],
                [
                    75.5408725,
                    54.8567913
                ],
                [
                    75.54015,
                    54.8512742
                ],
                [
                    75.5360233,
                    54.8507391
                ],
                [
                    75.5393313,
                    54.8451739
                ],
                [
                    75.5309513,
                    54.8425949
                ],
                [
                    75.5289767,
                    54.8418461
                ],
                [
                    75.5283025,
                    54.8430109
                ],
                [
                    75.5228121,
                    54.8417629
                ],
                [
                    75.5217526,
                    54.8435101
                ],
                [
                    75.5158288,
                    54.8417629
                ],
                [
                    75.5126983,
                    54.8453403
                ],
                [
                    75.5172254,
                    54.84681
                ],
                [
                    75.5112053,
                    54.8530764
                ]
            ],
            "longitude": 75.527527,
            "latitude": 54.848797
        },
        "3126": {
            "name": "Победа",
            "population": 366,
            "type": "village",
            "poly": [
                [
                    75.5405649,
                    55.644843
                ],
                [
                    75.5443355,
                    55.6455121
                ],
                [
                    75.5439867,
                    55.6460137
                ],
                [
                    75.5461478,
                    55.6465752
                ],
                [
                    75.5460172,
                    55.6467114
                ],
                [
                    75.5468315,
                    55.6470007
                ],
                [
                    75.5487065,
                    55.6475437
                ],
                [
                    75.5485403,
                    55.6476643
                ],
                [
                    75.5501414,
                    55.6481769
                ],
                [
                    75.553094,
                    55.6481862
                ],
                [
                    75.5541092,
                    55.6475906
                ],
                [
                    75.5585121,
                    55.6485165
                ],
                [
                    75.5589965,
                    55.6478313
                ],
                [
                    75.5620366,
                    55.648709
                ],
                [
                    75.5638742,
                    55.6471909
                ],
                [
                    75.55929,
                    55.6451485
                ],
                [
                    75.5595601,
                    55.6449881
                ],
                [
                    75.5588067,
                    55.6443062
                ],
                [
                    75.5588067,
                    55.6440013
                ],
                [
                    75.5582493,
                    55.6426835
                ],
                [
                    75.5538026,
                    55.6416105
                ],
                [
                    75.5529781,
                    55.6413698
                ],
                [
                    75.5526227,
                    55.6413217
                ],
                [
                    75.551727,
                    55.6408483
                ],
                [
                    75.5511869,
                    55.6407842
                ],
                [
                    75.5501206,
                    55.6405274
                ],
                [
                    75.549586,
                    55.640188
                ],
                [
                    75.5479748,
                    55.6422022
                ],
                [
                    75.5457197,
                    55.6417528
                ],
                [
                    75.5452698,
                    55.6423175
                ],
                [
                    75.5443405,
                    55.6421203
                ],
                [
                    75.5435142,
                    55.6419406
                ],
                [
                    75.5419662,
                    55.6441814
                ],
                [
                    75.5411559,
                    55.6440289
                ],
                [
                    75.5405649,
                    55.644843
                ]
            ],
            "longitude": 75.551895,
            "latitude": 55.644604
        },
        "3127": {
            "name": "Дмитриевка",
            "population": 893,
            "type": "village",
            "poly": [
                [
                    75.5893571,
                    55.1633044
                ],
                [
                    75.5918602,
                    55.1699021
                ],
                [
                    75.6136606,
                    55.1725096
                ],
                [
                    75.6197457,
                    55.1700059
                ],
                [
                    75.6244406,
                    55.1653741
                ],
                [
                    75.6222296,
                    55.15756
                ],
                [
                    75.6156514,
                    55.1518632
                ],
                [
                    75.5979538,
                    55.1515034
                ],
                [
                    75.5926352,
                    55.151593
                ],
                [
                    75.5893571,
                    55.1633044
                ]
            ],
            "longitude": 75.6069572,
            "latitude": 55.1636116
        },
        "3128": {
            "name": "Щербаки",
            "population": 631,
            "type": "village",
            "poly": [
                [
                    75.6544376,
                    55.5496339
                ],
                [
                    75.6556625,
                    55.5507685
                ],
                [
                    75.6597247,
                    55.5526562
                ],
                [
                    75.6633917,
                    55.5504106
                ],
                [
                    75.6670258,
                    55.5494476
                ],
                [
                    75.6690605,
                    55.548936
                ],
                [
                    75.6710983,
                    55.5487224
                ],
                [
                    75.6720447,
                    55.5488465
                ],
                [
                    75.6726551,
                    55.5492046
                ],
                [
                    75.6745415,
                    55.5495288
                ],
                [
                    75.6756643,
                    55.5496771
                ],
                [
                    75.677154,
                    55.549179
                ],
                [
                    75.6776287,
                    55.549
                ],
                [
                    75.6783748,
                    55.5488081
                ],
                [
                    75.6798665,
                    55.5487509
                ],
                [
                    75.6810199,
                    55.5495755
                ],
                [
                    75.6816529,
                    55.5500742
                ],
                [
                    75.6819816,
                    55.5505448
                ],
                [
                    75.6810868,
                    55.5530781
                ],
                [
                    75.6837781,
                    55.5534375
                ],
                [
                    75.6850809,
                    55.5543163
                ],
                [
                    75.6861752,
                    55.553777
                ],
                [
                    75.685457,
                    55.5518401
                ],
                [
                    75.6850893,
                    55.5510973
                ],
                [
                    75.6851996,
                    55.5503306
                ],
                [
                    75.6865814,
                    55.5486419
                ],
                [
                    75.688398,
                    55.54725
                ],
                [
                    75.6869657,
                    55.5469153
                ],
                [
                    75.6868953,
                    55.546469
                ],
                [
                    75.6845241,
                    55.5461862
                ],
                [
                    75.6842075,
                    55.5466339
                ],
                [
                    75.6833937,
                    55.5464676
                ],
                [
                    75.6838911,
                    55.545777
                ],
                [
                    75.6830094,
                    55.5456235
                ],
                [
                    75.6821051,
                    55.5464165
                ],
                [
                    75.6815851,
                    55.5458537
                ],
                [
                    75.6815231,
                    55.5452701
                ],
                [
                    75.6754949,
                    55.5444852
                ],
                [
                    75.6755436,
                    55.5439968
                ],
                [
                    75.6709239,
                    55.5435196
                ],
                [
                    75.670102,
                    55.5454235
                ],
                [
                    75.6694449,
                    55.5456363
                ],
                [
                    75.6684953,
                    55.5459049
                ],
                [
                    75.6666278,
                    55.546334
                ],
                [
                    75.6652172,
                    55.5463909
                ],
                [
                    75.6638608,
                    55.5462502
                ],
                [
                    75.6609521,
                    55.5456658
                ],
                [
                    75.6588645,
                    55.5451502
                ],
                [
                    75.657547,
                    55.5451294
                ],
                [
                    75.6555903,
                    55.5457621
                ],
                [
                    75.6561063,
                    55.5472783
                ],
                [
                    75.6559933,
                    55.5482198
                ],
                [
                    75.6554198,
                    55.5489732
                ],
                [
                    75.6544376,
                    55.5496339
                ]
            ],
            "longitude": 75.676186,
            "latitude": 55.546898
        },
        "3129": {
            "name": "Яркуль",
            "population": 401,
            "type": "village",
            "poly": [
                [
                    75.6631629,
                    55.9862375
                ],
                [
                    75.6636546,
                    55.9878455
                ],
                [
                    75.6652811,
                    55.9882687
                ],
                [
                    75.6697822,
                    55.9896016
                ],
                [
                    75.6747373,
                    55.9911249
                ],
                [
                    75.676515,
                    55.9922462
                ],
                [
                    75.6769689,
                    55.9936001
                ],
                [
                    75.6796923,
                    55.9948059
                ],
                [
                    75.6781793,
                    55.9963713
                ],
                [
                    75.6781037,
                    55.9979789
                ],
                [
                    75.6813188,
                    55.9973655
                ],
                [
                    75.6827938,
                    55.9951021
                ],
                [
                    75.6829831,
                    55.9940443
                ],
                [
                    75.68495,
                    55.9979366
                ],
                [
                    75.6877112,
                    55.9969213
                ],
                [
                    75.6858199,
                    55.9934309
                ],
                [
                    75.6887703,
                    55.9923942
                ],
                [
                    75.6870303,
                    55.9904902
                ],
                [
                    75.68321,
                    55.990194
                ],
                [
                    75.6833613,
                    55.9894958
                ],
                [
                    75.6865764,
                    55.9896439
                ],
                [
                    75.6867655,
                    55.987909
                ],
                [
                    75.6845717,
                    55.9867241
                ],
                [
                    75.6800705,
                    55.9860047
                ],
                [
                    75.6741321,
                    55.985899
                ],
                [
                    75.6719004,
                    55.9868934
                ],
                [
                    75.6694796,
                    55.9860259
                ],
                [
                    75.6684962,
                    55.9867241
                ],
                [
                    75.6645245,
                    55.9850526
                ],
                [
                    75.6631629,
                    55.9862375
                ]
            ],
            "longitude": 75.678429,
            "latitude": 55.993145
        },
        "3130": {
            "name": "Козловка",
            "population": 386,
            "type": "village",
            "poly": [
                [
                    75.6811019,
                    55.2398014
                ],
                [
                    75.6855422,
                    55.2445861
                ],
                [
                    75.7012541,
                    55.2445861
                ],
                [
                    75.7114522,
                    55.2403021
                ],
                [
                    75.7099884,
                    55.2380765
                ],
                [
                    75.7102324,
                    55.2331797
                ],
                [
                    75.7078902,
                    55.2311762
                ],
                [
                    75.706036,
                    55.2305919
                ],
                [
                    75.6986192,
                    55.2310928
                ],
                [
                    75.6853469,
                    55.2383269
                ],
                [
                    75.6816874,
                    55.2390224
                ],
                [
                    75.6811019,
                    55.2398014
                ]
            ],
            "longitude": 75.696579,
            "latitude": 55.239323
        },
        "3131": {
            "name": "Лопатино",
            "population": 488,
            "type": "village",
            "poly": [
                [
                    75.7120678,
                    55.3907028
                ],
                [
                    75.7179676,
                    55.3951483
                ],
                [
                    75.7326291,
                    55.395679
                ],
                [
                    75.7336805,
                    55.3965747
                ],
                [
                    75.7368347,
                    55.3963093
                ],
                [
                    75.7394633,
                    55.3918972
                ],
                [
                    75.7339724,
                    55.3844982
                ],
                [
                    75.7120678,
                    55.3907028
                ]
            ],
            "longitude": 75.727188,
            "latitude": 55.390049
        },
        "3132": {
            "name": "Николаевка",
            "population": 573,
            "type": "village",
            "poly": [
                [
                    75.7250612,
                    54.8172469
                ],
                [
                    75.7298696,
                    54.8202304
                ],
                [
                    75.7338642,
                    54.8208697
                ],
                [
                    75.7419013,
                    54.8239435
                ],
                [
                    75.7484127,
                    54.825475
                ],
                [
                    75.7568505,
                    54.8190601
                ],
                [
                    75.7565422,
                    54.8140651
                ],
                [
                    75.7635545,
                    54.8134656
                ],
                [
                    75.7630921,
                    54.8104461
                ],
                [
                    75.7546158,
                    54.8076705
                ],
                [
                    75.7496455,
                    54.8067601
                ],
                [
                    75.7403987,
                    54.8058053
                ],
                [
                    75.7258996,
                    54.8111797
                ],
                [
                    75.7250612,
                    54.8172469
                ]
            ],
            "longitude": 75.737129,
            "latitude": 54.815506
        },
        "3133": {
            "name": "Кушаги",
            "population": 437,
            "type": "village",
            "poly": [
                [
                    75.7393165,
                    55.6700073
                ],
                [
                    75.7437015,
                    55.6720938
                ],
                [
                    75.7491828,
                    55.675092
                ],
                [
                    75.7541159,
                    55.6770701
                ],
                [
                    75.7566647,
                    55.6776418
                ],
                [
                    75.7569661,
                    55.6767146
                ],
                [
                    75.758638,
                    55.677101
                ],
                [
                    75.7622282,
                    55.674752
                ],
                [
                    75.7544174,
                    55.6712438
                ],
                [
                    75.753513,
                    55.6720938
                ],
                [
                    75.7504435,
                    55.6705019
                ],
                [
                    75.7491828,
                    55.6707492
                ],
                [
                    75.7424408,
                    55.6679361
                ],
                [
                    75.7406594,
                    55.6678743
                ],
                [
                    75.7393165,
                    55.6700073
                ]
            ],
            "longitude": 75.750587,
            "latitude": 55.672108
        },
        "3134": {
            "name": "Рождественка",
            "population": 315,
            "type": "village",
            "poly": [
                [
                    75.7602445,
                    55.134117
                ],
                [
                    75.7638666,
                    55.1474214
                ],
                [
                    75.7883712,
                    55.1375367
                ],
                [
                    75.7756941,
                    55.1330228
                ],
                [
                    75.7629997,
                    55.1299953
                ],
                [
                    75.7602445,
                    55.134117
                ]
            ],
            "longitude": 75.766174,
            "latitude": 55.139385
        },
        "3135": {
            "name": "Богословка",
            "population": 315,
            "type": "village",
            "poly": [
                [
                    75.8318429,
                    55.5157496
                ],
                [
                    75.8338116,
                    55.5160282
                ],
                [
                    75.8335382,
                    55.517793
                ],
                [
                    75.8366006,
                    55.5190624
                ],
                [
                    75.8367646,
                    55.5184896
                ],
                [
                    75.8385692,
                    55.5190004
                ],
                [
                    75.8445573,
                    55.5199756
                ],
                [
                    75.8465534,
                    55.5201924
                ],
                [
                    75.8479479,
                    55.5197589
                ],
                [
                    75.8492603,
                    55.5172202
                ],
                [
                    75.8465534,
                    55.5162604
                ],
                [
                    75.8453776,
                    55.5161211
                ],
                [
                    75.8458698,
                    55.5148671
                ],
                [
                    75.8440925,
                    55.5142479
                ],
                [
                    75.8447214,
                    55.5120959
                ],
                [
                    75.8414129,
                    55.5115695
                ],
                [
                    75.8402918,
                    55.5135357
                ],
                [
                    75.8367373,
                    55.512839
                ],
                [
                    75.83496,
                    55.5126997
                ],
                [
                    75.8321437,
                    55.5148207
                ],
                [
                    75.8318429,
                    55.5157496
                ]
            ],
            "longitude": 75.840401,
            "latitude": 55.516739
        },
        "3136": {
            "name": "Константиновка",
            "population": 447,
            "type": "village",
            "poly": [
                [
                    75.8470728,
                    54.9316811
                ],
                [
                    75.8504634,
                    54.9354664
                ],
                [
                    75.8638328,
                    54.9395168
                ],
                [
                    75.8706524,
                    54.9397824
                ],
                [
                    75.8805543,
                    54.9427923
                ],
                [
                    75.8826349,
                    54.9433234
                ],
                [
                    75.8860254,
                    54.9415087
                ],
                [
                    75.8894545,
                    54.9397824
                ],
                [
                    75.8838678,
                    54.9371264
                ],
                [
                    75.8815175,
                    54.9358648
                ],
                [
                    75.8906103,
                    54.9341383
                ],
                [
                    75.8847154,
                    54.9288697
                ],
                [
                    75.8680325,
                    54.9328765
                ],
                [
                    75.8558189,
                    54.9283605
                ],
                [
                    75.8498854,
                    54.9289804
                ],
                [
                    75.8470728,
                    54.9316811
                ]
            ],
            "longitude": 75.865402,
            "latitude": 54.935707
        },
        "3137": {
            "name": "Казачий Мыс",
            "population": 657,
            "type": "village",
            "poly": [
                [
                    75.8541478,
                    55.5040709
                ],
                [
                    75.8549595,
                    55.5104582
                ],
                [
                    75.8574802,
                    55.5105066
                ],
                [
                    75.8610262,
                    55.5109179
                ],
                [
                    75.8677338,
                    55.5115227
                ],
                [
                    75.8709807,
                    55.5111114
                ],
                [
                    75.8734587,
                    55.5107727
                ],
                [
                    75.874954,
                    55.5114017
                ],
                [
                    75.8757229,
                    55.5121032
                ],
                [
                    75.8743559,
                    55.5130951
                ],
                [
                    75.8698699,
                    55.5141111
                ],
                [
                    75.8723906,
                    55.5155383
                ],
                [
                    75.8785428,
                    55.5176185
                ],
                [
                    75.889779,
                    55.5130467
                ],
                [
                    75.8927696,
                    55.5056678
                ],
                [
                    75.8844386,
                    55.5040225
                ],
                [
                    75.8811489,
                    55.5036354
                ],
                [
                    75.8806789,
                    55.5014576
                ],
                [
                    75.8780728,
                    55.5013367
                ],
                [
                    75.8730742,
                    55.5020868
                ],
                [
                    75.8670502,
                    55.5023772
                ],
                [
                    75.8541478,
                    55.5040709
                ]
            ],
            "longitude": 75.877525,
            "latitude": 55.508488
        },
        "3138": {
            "name": "Северотатарское",
            "population": 829,
            "type": "village",
            "poly": [
                [
                    75.8775857,
                    55.1920948
                ],
                [
                    75.8894635,
                    55.1952872
                ],
                [
                    75.9067742,
                    55.187169
                ],
                [
                    75.9074666,
                    55.1829117
                ],
                [
                    75.89724,
                    55.1774372
                ],
                [
                    75.8928191,
                    55.1765248
                ],
                [
                    75.8892504,
                    55.1786234
                ],
                [
                    75.8843502,
                    55.1834895
                ],
                [
                    75.8797162,
                    55.1849796
                ],
                [
                    75.8775857,
                    55.1920948
                ]
            ],
            "longitude": 75.895645,
            "latitude": 55.183365
        },
        "3139": {
            "name": "Ишимская",
            "population": 284,
            "type": "village",
            "poly": [
                [
                    75.8918141,
                    54.7234074
                ],
                [
                    75.8971552,
                    54.7257917
                ],
                [
                    75.8954513,
                    54.727419
                ],
                [
                    75.895484,
                    54.728384
                ],
                [
                    75.8964998,
                    54.7297275
                ],
                [
                    75.8933214,
                    54.7307303
                ],
                [
                    75.8942716,
                    54.7327358
                ],
                [
                    75.8957789,
                    54.7335871
                ],
                [
                    75.8974173,
                    54.7335871
                ],
                [
                    75.9022669,
                    54.7349304
                ],
                [
                    75.903512,
                    54.7348358
                ],
                [
                    75.9040691,
                    54.7340412
                ],
                [
                    75.9041018,
                    54.7329439
                ],
                [
                    75.904604,
                    54.7312644
                ],
                [
                    75.9062645,
                    54.7298599
                ],
                [
                    75.9047899,
                    54.7269081
                ],
                [
                    75.9053798,
                    54.7266243
                ],
                [
                    75.9044295,
                    54.7224044
                ],
                [
                    75.9009562,
                    54.7205119
                ],
                [
                    75.9002353,
                    54.7210039
                ],
                [
                    75.8957462,
                    54.719717
                ],
                [
                    75.8926005,
                    54.7219313
                ],
                [
                    75.8918141,
                    54.7234074
                ]
            ],
            "longitude": 75.901863,
            "latitude": 54.725471
        },
        "3140": {
            "name": "Польяново",
            "population": 369,
            "type": "village",
            "poly": [
                [
                    75.8868956,
                    54.5571449
                ],
                [
                    75.8906621,
                    54.5596483
                ],
                [
                    75.89611,
                    54.562216
                ],
                [
                    75.9003711,
                    54.5627724
                ],
                [
                    75.9012157,
                    54.5609027
                ],
                [
                    75.9072427,
                    54.5617485
                ],
                [
                    75.9133081,
                    54.5624831
                ],
                [
                    75.9173773,
                    54.5636627
                ],
                [
                    75.9186825,
                    54.5571407
                ],
                [
                    75.9084711,
                    54.5565174
                ],
                [
                    75.9082792,
                    54.5560054
                ],
                [
                    75.9015996,
                    54.5555824
                ],
                [
                    75.8992579,
                    54.5569849
                ],
                [
                    75.8926934,
                    54.555204
                ],
                [
                    75.8917053,
                    54.5543865
                ],
                [
                    75.8882403,
                    54.5563616
                ],
                [
                    75.8868956,
                    54.5571449
                ]
            ],
            "longitude": 75.904327,
            "latitude": 54.558567
        },
        "3141": {
            "name": "Орловка",
            "population": 234,
            "type": "village",
            "poly": [
                [
                    75.93085,
                    54.8669923
                ],
                [
                    75.9316165,
                    54.879582
                ],
                [
                    75.9358672,
                    54.8807847
                ],
                [
                    75.9398391,
                    54.8819472
                ],
                [
                    75.9541241,
                    54.8789406
                ],
                [
                    75.9585141,
                    54.8726862
                ],
                [
                    75.9370518,
                    54.8624206
                ],
                [
                    75.93085,
                    54.8669923
                ]
            ],
            "longitude": 75.9429665,
            "latitude": 54.8722367
        },
        "3142": {
            "name": "Новоникольск",
            "population": 327,
            "type": "village",
            "poly": [
                [
                    75.9699789,
                    55.7191367
                ],
                [
                    75.9724658,
                    55.7194721
                ],
                [
                    75.9788057,
                    55.7183278
                ],
                [
                    75.9874923,
                    55.7182489
                ],
                [
                    75.9946728,
                    55.7199653
                ],
                [
                    75.9996116,
                    55.7209517
                ],
                [
                    76.0010477,
                    55.7192551
                ],
                [
                    75.9952683,
                    55.7163746
                ],
                [
                    75.9850054,
                    55.7136517
                ],
                [
                    75.9785255,
                    55.7135136
                ],
                [
                    75.9706094,
                    55.7164732
                ],
                [
                    75.9699789,
                    55.7191367
                ]
            ],
            "longitude": 75.984055,
            "latitude": 55.71666
        },
        "3143": {
            "name": "Новосилиш",
            "population": 253,
            "type": "village",
            "poly": [
                [
                    75.9769163,
                    55.9446377
                ],
                [
                    75.9789488,
                    55.9457906
                ],
                [
                    75.9819313,
                    55.9464557
                ],
                [
                    75.9841484,
                    55.9474902
                ],
                [
                    75.9861807,
                    55.948377
                ],
                [
                    75.9970287,
                    55.9491012
                ],
                [
                    75.9980053,
                    55.9464852
                ],
                [
                    75.9918026,
                    55.9448298
                ],
                [
                    75.9784473,
                    55.9423319
                ],
                [
                    75.9769163,
                    55.9446377
                ]
            ],
            "longitude": 75.987877,
            "latitude": 55.946007
        },
        "3144": {
            "name": "Новопокровка",
            "population": 621,
            "type": "village",
            "poly": [
                [
                    75.9826676,
                    55.187129
                ],
                [
                    75.9826676,
                    55.1937486
                ],
                [
                    76.0129338,
                    55.2038632
                ],
                [
                    76.0285411,
                    55.1964961
                ],
                [
                    76.0224879,
                    55.1928328
                ],
                [
                    76.0238006,
                    55.1921667
                ],
                [
                    76.0198623,
                    55.1901684
                ],
                [
                    76.0186225,
                    55.1906263
                ],
                [
                    76.0159241,
                    55.1892108
                ],
                [
                    76.0014838,
                    55.1830485
                ],
                [
                    75.9917111,
                    55.1815078
                ],
                [
                    75.9917111,
                    55.183798
                ],
                [
                    75.9833969,
                    55.184839
                ],
                [
                    75.9826676,
                    55.187129
                ]
            ],
            "longitude": 76.00472162072752,
            "latitude": 55.19024035763238
        },
        "3145": {
            "name": "Новотроицк",
            "population": 286,
            "type": "village",
            "poly": [
                [
                    75.9844466,
                    55.3348567
                ],
                [
                    75.9867511,
                    55.341541
                ],
                [
                    75.9923741,
                    55.3463372
                ],
                [
                    75.9976284,
                    55.3492462
                ],
                [
                    76.0018687,
                    55.3490103
                ],
                [
                    76.0024679,
                    55.340676
                ],
                [
                    75.9984118,
                    55.3322875
                ],
                [
                    75.9921897,
                    55.3325759
                ],
                [
                    75.9844466,
                    55.3348567
                ]
            ],
            "longitude": 75.99482,
            "latitude": 55.339283
        },
        "3146": {
            "name": "Малокрасноярка",
            "population": 261,
            "type": "village",
            "poly": [
                [
                    75.9961761,
                    56.4652513
                ],
                [
                    75.99829,
                    56.467206
                ],
                [
                    75.9983819,
                    56.4678406
                ],
                [
                    75.9998523,
                    56.4695667
                ],
                [
                    76.0023337,
                    56.4695921
                ],
                [
                    76.0044935,
                    56.4701759
                ],
                [
                    76.0076641,
                    56.4694398
                ],
                [
                    76.0076182,
                    56.4684245
                ],
                [
                    76.0096861,
                    56.4675106
                ],
                [
                    76.0117999,
                    56.4681198
                ],
                [
                    76.0117999,
                    56.4676122
                ],
                [
                    76.0141434,
                    56.4680945
                ],
                [
                    76.0134082,
                    56.4692113
                ],
                [
                    76.0170384,
                    56.4695413
                ],
                [
                    76.0187846,
                    56.4678152
                ],
                [
                    76.0156598,
                    56.4669014
                ],
                [
                    76.0184629,
                    56.4639566
                ],
                [
                    76.012535,
                    56.4605293
                ],
                [
                    76.0085832,
                    56.4611386
                ],
                [
                    76.0027473,
                    56.4627127
                ],
                [
                    76.0038502,
                    56.4632204
                ],
                [
                    76.000128,
                    56.465886
                ],
                [
                    75.9970952,
                    56.4647436
                ],
                [
                    75.9961761,
                    56.4652513
                ]
            ],
            "longitude": 76.010971,
            "latitude": 56.4645
        },
        "3147": {
            "name": "Камышево",
            "population": 392,
            "type": "village",
            "poly": [
                [
                    76.0096827,
                    55.6188111
                ],
                [
                    76.0140017,
                    55.61977
                ],
                [
                    76.022492,
                    55.6213542
                ],
                [
                    76.0198094,
                    55.62462
                ],
                [
                    76.0332343,
                    55.6259605
                ],
                [
                    76.0395836,
                    55.6285448
                ],
                [
                    76.0410971,
                    55.6265233
                ],
                [
                    76.0478156,
                    55.6278362
                ],
                [
                    76.0490707,
                    55.6261689
                ],
                [
                    76.0447886,
                    55.6247934
                ],
                [
                    76.04549,
                    55.6238346
                ],
                [
                    76.0197235,
                    55.6174561
                ],
                [
                    76.0128204,
                    55.6167682
                ],
                [
                    76.0125251,
                    55.6177897
                ],
                [
                    76.0099411,
                    55.617477
                ],
                [
                    76.0096827,
                    55.6188111
                ]
            ],
            "longitude": 76.027687,
            "latitude": 55.623947
        },
        "3148": {
            "name": "Угуй",
            "population": 319,
            "type": "village",
            "poly": [
                [
                    76.0305722,
                    56.0211901
                ],
                [
                    76.0377417,
                    56.0267787
                ],
                [
                    76.0369745,
                    56.0275622
                ],
                [
                    76.0371068,
                    56.0281831
                ],
                [
                    76.0385618,
                    56.0293805
                ],
                [
                    76.0412603,
                    56.030371
                ],
                [
                    76.0450435,
                    56.0307553
                ],
                [
                    76.0604407,
                    56.0325587
                ],
                [
                    76.0620545,
                    56.0304449
                ],
                [
                    76.051287,
                    56.0284492
                ],
                [
                    76.0486679,
                    56.0272961
                ],
                [
                    76.0425037,
                    56.0264978
                ],
                [
                    76.0413132,
                    56.0261578
                ],
                [
                    76.0384825,
                    56.0229791
                ],
                [
                    76.0320537,
                    56.0211162
                ],
                [
                    76.0305722,
                    56.0211901
                ]
            ],
            "longitude": 76.045006,
            "latitude": 56.028999
        },
        "3149": {
            "name": "Романовка",
            "population": 539,
            "type": "village",
            "poly": [
                [
                    76.0272885,
                    54.6444293
                ],
                [
                    76.0272885,
                    54.646373
                ],
                [
                    76.0369869,
                    54.6497073
                ],
                [
                    76.0469212,
                    54.6525049
                ],
                [
                    76.0506455,
                    54.6535549
                ],
                [
                    76.05596,
                    54.6539731
                ],
                [
                    76.0553601,
                    54.6563673
                ],
                [
                    76.0579394,
                    54.6581369
                ],
                [
                    76.0633378,
                    54.6604962
                ],
                [
                    76.0671166,
                    54.6608085
                ],
                [
                    76.0678964,
                    54.6565755
                ],
                [
                    76.062498,
                    54.6557081
                ],
                [
                    76.062558,
                    54.6537996
                ],
                [
                    76.069276,
                    54.6514399
                ],
                [
                    76.0461829,
                    54.644464
                ],
                [
                    76.0348463,
                    54.6414096
                ],
                [
                    76.0272885,
                    54.6444293
                ]
            ],
            "longitude": 76.048569,
            "latitude": 54.648792
        },
        "3150": {
            "name": "Казаткуль",
            "population": 465,
            "type": "village",
            "poly": [
                [
                    76.034499,
                    55.0354368
                ],
                [
                    76.0345586,
                    55.0410705
                ],
                [
                    76.0467736,
                    55.040695
                ],
                [
                    76.0479057,
                    55.0381343
                ],
                [
                    76.0500507,
                    55.0383391
                ],
                [
                    76.0515999,
                    55.0372123
                ],
                [
                    76.0657813,
                    55.0359831
                ],
                [
                    76.0694756,
                    55.029768
                ],
                [
                    76.0669134,
                    55.0210244
                ],
                [
                    76.0554134,
                    55.0212976
                ],
                [
                    76.056486,
                    55.0265918
                ],
                [
                    76.0454031,
                    55.0256355
                ],
                [
                    76.0414109,
                    55.0262845
                ],
                [
                    76.0389083,
                    55.0289143
                ],
                [
                    76.0417684,
                    55.0310316
                ],
                [
                    76.0421259,
                    55.0325001
                ],
                [
                    76.0355715,
                    55.0341392
                ],
                [
                    76.034499,
                    55.0354368
                ]
            ],
            "longitude": 76.053322,
            "latitude": 55.030777
        },
        "3151": {
            "name": "Киевка",
            "population": 685,
            "type": "village",
            "poly": [
                [
                    76.0535328,
                    55.2549265
                ],
                [
                    76.0614352,
                    55.2604054
                ],
                [
                    76.0684234,
                    55.2637635
                ],
                [
                    76.069896,
                    55.2643245
                ],
                [
                    76.0703214,
                    55.2643562
                ],
                [
                    76.0739899,
                    55.2652576
                ],
                [
                    76.0943504,
                    55.2535616
                ],
                [
                    76.0871451,
                    55.248459
                ],
                [
                    76.0901473,
                    55.2473078
                ],
                [
                    76.091512,
                    55.2457519
                ],
                [
                    76.0889464,
                    55.2441027
                ],
                [
                    76.0861626,
                    55.2436982
                ],
                [
                    76.0833787,
                    55.2475256
                ],
                [
                    76.0825599,
                    55.2473389
                ],
                [
                    76.0553384,
                    55.2497349
                ],
                [
                    76.0535328,
                    55.2549265
                ]
            ],
            "longitude": 76.068405,
            "latitude": 55.257275
        },
        "3152": {
            "name": "Яркуль-Матюшкино",
            "population": 591,
            "type": "village",
            "poly": [
                [
                    76.0775652,
                    55.8427969
                ],
                [
                    76.0798829,
                    55.8435722
                ],
                [
                    76.0946766,
                    55.8470605
                ],
                [
                    76.0996078,
                    55.8488046
                ],
                [
                    76.0988188,
                    55.8492752
                ],
                [
                    76.1004954,
                    55.8507977
                ],
                [
                    76.104687,
                    55.8520987
                ],
                [
                    76.1083854,
                    55.8518773
                ],
                [
                    76.1107524,
                    55.8512406
                ],
                [
                    76.1152399,
                    55.8512683
                ],
                [
                    76.1137112,
                    55.8478634
                ],
                [
                    76.1169165,
                    55.8473097
                ],
                [
                    76.1087306,
                    55.843766
                ],
                [
                    76.1092731,
                    55.8422986
                ],
                [
                    76.1064623,
                    55.841551
                ],
                [
                    76.1055253,
                    55.84288
                ],
                [
                    76.1050322,
                    55.8453995
                ],
                [
                    76.1035528,
                    55.8453164
                ],
                [
                    76.1025666,
                    55.8462854
                ],
                [
                    76.096649,
                    55.8426031
                ],
                [
                    76.0944794,
                    55.8421324
                ],
                [
                    76.0907809,
                    55.8432399
                ],
                [
                    76.0833348,
                    55.841994
                ],
                [
                    76.080376,
                    55.841551
                ],
                [
                    76.0781569,
                    55.8417171
                ],
                [
                    76.0775652,
                    55.8427969
                ]
            ],
            "longitude": 76.093445,
            "latitude": 55.844444
        },
        "3153": {
            "name": "Кочневка",
            "population": 435,
            "type": "village",
            "poly": [
                [
                    76.1127503,
                    55.4746848
                ],
                [
                    76.1138694,
                    55.4868
                ],
                [
                    76.124366,
                    55.487128
                ],
                [
                    76.1308107,
                    55.4869749
                ],
                [
                    76.133319,
                    55.4859035
                ],
                [
                    76.1338593,
                    55.4782279
                ],
                [
                    76.139069,
                    55.4754066
                ],
                [
                    76.1394549,
                    55.4737443
                ],
                [
                    76.142465,
                    55.471732
                ],
                [
                    76.1413845,
                    55.4709226
                ],
                [
                    76.1268744,
                    55.4730225
                ],
                [
                    76.1142553,
                    55.4734162
                ],
                [
                    76.1127503,
                    55.4746848
                ]
            ],
            "longitude": 76.124832,
            "latitude": 55.480732
        },
        "3154": {
            "name": "Октябрьский",
            "population": 739,
            "type": "village",
            "poly": [
                [
                    76.1235453,
                    55.9389035
                ],
                [
                    76.1243043,
                    55.9403811
                ],
                [
                    76.1274485,
                    55.9412312
                ],
                [
                    76.1305204,
                    55.9434373
                ],
                [
                    76.1373148,
                    55.944004
                ],
                [
                    76.1407119,
                    55.9449957
                ],
                [
                    76.1457636,
                    55.9442773
                ],
                [
                    76.1459885,
                    55.94366
                ],
                [
                    76.143278,
                    55.9420003
                ],
                [
                    76.1390134,
                    55.9414741
                ],
                [
                    76.1398446,
                    55.9391059
                ],
                [
                    76.1480485,
                    55.93777
                ],
                [
                    76.1472895,
                    55.9363328
                ],
                [
                    76.1440731,
                    55.9347336
                ],
                [
                    76.1415071,
                    55.9311503
                ],
                [
                    76.1361222,
                    55.931292
                ],
                [
                    76.1305296,
                    55.9324176
                ],
                [
                    76.1323041,
                    55.9368191
                ],
                [
                    76.1331903,
                    55.9384512
                ],
                [
                    76.1259667,
                    55.9378307
                ],
                [
                    76.1240513,
                    55.9379522
                ],
                [
                    76.1235453,
                    55.9389035
                ]
            ],
            "longitude": 76.136307,
            "latitude": 55.940319
        },
        "3155": {
            "name": "Успенка",
            "population": 290,
            "type": "village",
            "poly": [
                [
                    76.1463938,
                    54.8792865
                ],
                [
                    76.1533298,
                    54.8916964
                ],
                [
                    76.156357,
                    54.8931068
                ],
                [
                    76.1710338,
                    54.8930407
                ],
                [
                    76.1782379,
                    54.8902638
                ],
                [
                    76.1808055,
                    54.8885006
                ],
                [
                    76.1817252,
                    54.8872443
                ],
                [
                    76.1850974,
                    54.8833648
                ],
                [
                    76.1623351,
                    54.8771921
                ],
                [
                    76.1463938,
                    54.8792865
                ]
            ],
            "longitude": 76.168175,
            "latitude": 54.884937
        },
        "3156": {
            "name": "Ольгино",
            "population": 287,
            "type": "village",
            "poly": [
                [
                    76.1557768,
                    54.7759838
                ],
                [
                    76.1567783,
                    54.7763593
                ],
                [
                    76.1601833,
                    54.7770236
                ],
                [
                    76.1620862,
                    54.7784098
                ],
                [
                    76.1616856,
                    54.7811245
                ],
                [
                    76.1605339,
                    54.7819908
                ],
                [
                    76.1628874,
                    54.7844454
                ],
                [
                    76.1657417,
                    54.7854271
                ],
                [
                    76.1758568,
                    54.7863511
                ],
                [
                    76.1775594,
                    54.7852827
                ],
                [
                    76.1812148,
                    54.7874483
                ],
                [
                    76.1865228,
                    54.7879392
                ],
                [
                    76.1890766,
                    54.7853116
                ],
                [
                    76.1856214,
                    54.784301
                ],
                [
                    76.1872238,
                    54.7832037
                ],
                [
                    76.185321,
                    54.7825106
                ],
                [
                    76.184019,
                    54.7833192
                ],
                [
                    76.1809645,
                    54.7812978
                ],
                [
                    76.1773089,
                    54.7804314
                ],
                [
                    76.176007,
                    54.7806624
                ],
                [
                    76.1738036,
                    54.7795939
                ],
                [
                    76.1712499,
                    54.7787275
                ],
                [
                    76.1676445,
                    54.7763304
                ],
                [
                    76.1668934,
                    54.776677
                ],
                [
                    76.1622864,
                    54.774713
                ],
                [
                    76.1594383,
                    54.7744565
                ],
                [
                    76.1583306,
                    54.7752907
                ],
                [
                    76.1569285,
                    54.7747996
                ],
                [
                    76.1557768,
                    54.7759838
                ]
            ],
            "longitude": 76.172417,
            "latitude": 54.78223
        },
        "3157": {
            "name": "Новокрасное",
            "population": 599,
            "type": "village",
            "poly": [
                [
                    76.1626044,
                    54.3363073
                ],
                [
                    76.1722489,
                    54.3365483
                ],
                [
                    76.1728001,
                    54.3378603
                ],
                [
                    76.1756934,
                    54.3374587
                ],
                [
                    76.1775305,
                    54.3366822
                ],
                [
                    76.1860269,
                    54.3356112
                ],
                [
                    76.1949366,
                    54.3440717
                ],
                [
                    76.1994373,
                    54.3445536
                ],
                [
                    76.2144093,
                    54.3408591
                ],
                [
                    76.2137664,
                    54.3374587
                ],
                [
                    76.1992537,
                    54.3402968
                ],
                [
                    76.1916299,
                    54.3358254
                ],
                [
                    76.1918136,
                    54.3335493
                ],
                [
                    76.1900225,
                    54.3318622
                ],
                [
                    76.1907114,
                    54.3299073
                ],
                [
                    76.1948907,
                    54.331166
                ],
                [
                    76.1951662,
                    54.3315944
                ],
                [
                    76.2004478,
                    54.3308446
                ],
                [
                    76.1993455,
                    54.326024
                ],
                [
                    76.1885068,
                    54.3249526
                ],
                [
                    76.1855217,
                    54.3291842
                ],
                [
                    76.175372,
                    54.3287557
                ],
                [
                    76.1752342,
                    54.3304697
                ],
                [
                    76.1648548,
                    54.3307375
                ],
                [
                    76.1629717,
                    54.3330941
                ],
                [
                    76.1626044,
                    54.3363073
                ]
            ],
            "longitude": 76.18959,
            "latitude": 54.337364
        },
        "3158": {
            "name": "Новомихайловка",
            "population": 681,
            "type": "village",
            "poly": [
                [
                    76.1664648,
                    55.0816066
                ],
                [
                    76.1717587,
                    55.0886859
                ],
                [
                    76.1832128,
                    55.0895122
                ],
                [
                    76.1929344,
                    55.0875015
                ],
                [
                    76.195052,
                    55.0861243
                ],
                [
                    76.1970252,
                    55.0834799
                ],
                [
                    76.1972658,
                    55.0814689
                ],
                [
                    76.2128107,
                    55.0797884
                ],
                [
                    76.2086718,
                    55.0732587
                ],
                [
                    76.213292,
                    55.0722667
                ],
                [
                    76.1982765,
                    55.0664523
                ],
                [
                    76.1716143,
                    55.0713574
                ],
                [
                    76.1742757,
                    55.0739313
                ],
                [
                    76.1751757,
                    55.0748017
                ],
                [
                    76.1795071,
                    55.0755456
                ],
                [
                    76.1792183,
                    55.0800088
                ],
                [
                    76.1664648,
                    55.0816066
                ]
            ],
            "longitude": 76.19014,
            "latitude": 55.080952
        },
        "3159": {
            "name": "Сергеевка",
            "population": 229,
            "type": "village",
            "poly": [
                [
                    76.1910749,
                    56.4563352
                ],
                [
                    76.19302,
                    56.456935
                ],
                [
                    76.1946031,
                    56.4572599
                ],
                [
                    76.1952816,
                    56.4572599
                ],
                [
                    76.1967743,
                    56.4566351
                ],
                [
                    76.198086,
                    56.4564351
                ],
                [
                    76.2003477,
                    56.456935
                ],
                [
                    76.2018856,
                    56.4561602
                ],
                [
                    76.2050066,
                    56.4565101
                ],
                [
                    76.2066802,
                    56.4574849
                ],
                [
                    76.2083991,
                    56.4577348
                ],
                [
                    76.2099822,
                    56.457235
                ],
                [
                    76.2122891,
                    56.4585346
                ],
                [
                    76.2152744,
                    56.4590095
                ],
                [
                    76.2170838,
                    56.4591594
                ],
                [
                    76.2178979,
                    56.4552604
                ],
                [
                    76.2188931,
                    56.4531358
                ],
                [
                    76.2129676,
                    56.451411
                ],
                [
                    76.2087157,
                    56.4521609
                ],
                [
                    76.2074492,
                    56.4517359
                ],
                [
                    76.2068612,
                    56.4497861
                ],
                [
                    76.2040115,
                    56.4494111
                ],
                [
                    76.2004834,
                    56.4518859
                ],
                [
                    76.2021117,
                    56.4533857
                ],
                [
                    76.2015689,
                    56.4537107
                ],
                [
                    76.1989907,
                    56.4537107
                ],
                [
                    76.1996692,
                    56.4527358
                ],
                [
                    76.1960505,
                    56.450486
                ],
                [
                    76.1951459,
                    56.451136
                ],
                [
                    76.194965,
                    56.4532357
                ],
                [
                    76.1942412,
                    56.4542606
                ],
                [
                    76.1913428,
                    56.4556164
                ],
                [
                    76.1910749,
                    56.4563352
                ]
            ],
            "longitude": 76.206795,
            "latitude": 56.454567
        },
        "3160": {
            "name": "Павловка",
            "population": 448,
            "type": "village",
            "poly": [
                [
                    76.2016871,
                    54.4910073
                ],
                [
                    76.2151073,
                    54.4933201
                ],
                [
                    76.2380031,
                    54.4973456
                ],
                [
                    76.2401414,
                    54.4934271
                ],
                [
                    76.2348324,
                    54.492335
                ],
                [
                    76.2365284,
                    54.4895511
                ],
                [
                    76.2107937,
                    54.4852678
                ],
                [
                    76.2089134,
                    54.4878593
                ],
                [
                    76.2032724,
                    54.4877308
                ],
                [
                    76.2016871,
                    54.4910073
                ]
            ],
            "longitude": 76.222099,
            "latitude": 54.490189
        },
        "3161": {
            "name": "Большеречье",
            "population": 441,
            "type": "village",
            "poly": [
                [
                    76.2099209,
                    56.5652076
                ],
                [
                    76.2101318,
                    56.5662926
                ],
                [
                    76.2165672,
                    56.5667383
                ],
                [
                    76.2196617,
                    56.5665833
                ],
                [
                    76.2207167,
                    56.5668933
                ],
                [
                    76.2231079,
                    56.5676295
                ],
                [
                    76.2242332,
                    56.5690825
                ],
                [
                    76.2229672,
                    56.5690632
                ],
                [
                    76.2189936,
                    56.570923
                ],
                [
                    76.2173408,
                    56.5717366
                ],
                [
                    76.2180793,
                    56.5725309
                ],
                [
                    76.2169891,
                    56.5728602
                ],
                [
                    76.2174111,
                    56.5734801
                ],
                [
                    76.2194507,
                    56.5727052
                ],
                [
                    76.2227211,
                    56.5733832
                ],
                [
                    76.2240925,
                    56.5730346
                ],
                [
                    76.2279959,
                    56.571756
                ],
                [
                    76.2287343,
                    56.5699156
                ],
                [
                    76.2300355,
                    56.5696444
                ],
                [
                    76.2304223,
                    56.5704774
                ],
                [
                    76.2319695,
                    56.5703418
                ],
                [
                    76.2329542,
                    56.5699543
                ],
                [
                    76.2328135,
                    56.569625
                ],
                [
                    76.2368575,
                    56.5685982
                ],
                [
                    76.2402333,
                    56.5665058
                ],
                [
                    76.2397762,
                    56.5652076
                ],
                [
                    76.2377718,
                    56.5651301
                ],
                [
                    76.2343256,
                    56.5637157
                ],
                [
                    76.2354509,
                    56.5630569
                ],
                [
                    76.2270464,
                    56.5580573
                ],
                [
                    76.2245145,
                    56.559782
                ],
                [
                    76.2245145,
                    56.5608285
                ],
                [
                    76.2202947,
                    56.5613517
                ],
                [
                    76.2174463,
                    56.560499
                ],
                [
                    76.2163209,
                    56.5610416
                ],
                [
                    76.2163209,
                    56.5618361
                ],
                [
                    76.2174463,
                    56.5621461
                ],
                [
                    76.2168485,
                    56.5639094
                ],
                [
                    76.2117144,
                    56.5632119
                ],
                [
                    76.2099209,
                    56.5652076
                ]
            ],
            "longitude": 76.232895,
            "latitude": 56.566631
        },
        "3162": {
            "name": "Варваровка",
            "population": 490,
            "type": "village",
            "poly": [
                [
                    76.246076,
                    54.4006679
                ],
                [
                    76.2469212,
                    54.4023353
                ],
                [
                    76.2502083,
                    54.4017613
                ],
                [
                    76.25049,
                    54.4000939
                ],
                [
                    76.2542935,
                    54.4022806
                ],
                [
                    76.251617,
                    54.4045766
                ],
                [
                    76.2572049,
                    54.4060525
                ],
                [
                    76.2578153,
                    54.4053965
                ],
                [
                    76.25913,
                    54.4056152
                ],
                [
                    76.2618066,
                    54.4032646
                ],
                [
                    76.2657981,
                    54.4047952
                ],
                [
                    76.2665964,
                    54.4039479
                ],
                [
                    76.2674885,
                    54.4020893
                ],
                [
                    76.2652346,
                    54.4012146
                ],
                [
                    76.2718086,
                    54.3965129
                ],
                [
                    76.2727478,
                    54.3966496
                ],
                [
                    76.2737339,
                    54.3952827
                ],
                [
                    76.2646711,
                    54.3927402
                ],
                [
                    76.2626989,
                    54.3916739
                ],
                [
                    76.2661737,
                    54.3891311
                ],
                [
                    76.2566414,
                    54.385139
                ],
                [
                    76.2539648,
                    54.3872445
                ],
                [
                    76.2500674,
                    54.3918926
                ],
                [
                    76.2487055,
                    54.3934783
                ],
                [
                    76.252744,
                    54.3959661
                ],
                [
                    76.246076,
                    54.4006679
                ]
            ],
            "longitude": 76.2576421,
            "latitude": 54.3956522
        },
        "3163": {
            "name": "Красноярка",
            "population": 285,
            "type": "village",
            "poly": [
                [
                    76.2920017,
                    55.5441598
                ],
                [
                    76.2997151,
                    55.54542
                ],
                [
                    76.3181941,
                    55.5473568
                ],
                [
                    76.3189367,
                    55.5434363
                ],
                [
                    76.3133682,
                    55.5411259
                ],
                [
                    76.3125845,
                    55.535991
                ],
                [
                    76.3165443,
                    55.5359443
                ],
                [
                    76.3148532,
                    55.5325362
                ],
                [
                    76.3002926,
                    55.5255091
                ],
                [
                    76.2964565,
                    55.5304586
                ],
                [
                    76.2979827,
                    55.5324195
                ],
                [
                    76.2990551,
                    55.5354541
                ],
                [
                    76.3020662,
                    55.5373448
                ],
                [
                    76.3025612,
                    55.5388853
                ],
                [
                    76.3011175,
                    55.5404257
                ],
                [
                    76.2977764,
                    55.5413826
                ],
                [
                    76.2934866,
                    55.5428529
                ],
                [
                    76.2920017,
                    55.5441598
                ]
            ],
            "longitude": 76.305443,
            "latitude": 55.535286
        },
        "3164": {
            "name": "Заливино",
            "population": 318,
            "type": "village",
            "poly": [
                [
                    76.3251314,
                    56.4542806
                ],
                [
                    76.325562,
                    56.4560205
                ],
                [
                    76.3287374,
                    56.4563476
                ],
                [
                    76.3296793,
                    56.4574034
                ],
                [
                    76.3316169,
                    56.4575075
                ],
                [
                    76.3332584,
                    56.457448
                ],
                [
                    76.3349269,
                    56.4566599
                ],
                [
                    76.3374026,
                    56.4569127
                ],
                [
                    76.3386136,
                    56.4565558
                ],
                [
                    76.3403359,
                    56.4557677
                ],
                [
                    76.3405243,
                    56.4553959
                ],
                [
                    76.3389634,
                    56.4547862
                ],
                [
                    76.3369182,
                    56.4546078
                ],
                [
                    76.3336082,
                    56.4540724
                ],
                [
                    76.3346039,
                    56.4525407
                ],
                [
                    76.3360033,
                    56.4519756
                ],
                [
                    76.3398515,
                    56.4530315
                ],
                [
                    76.340901,
                    56.4518864
                ],
                [
                    76.3380485,
                    56.4502058
                ],
                [
                    76.3397169,
                    56.4491945
                ],
                [
                    76.3405511,
                    56.4467999
                ],
                [
                    76.3408203,
                    56.445134
                ],
                [
                    76.3410356,
                    56.4441374
                ],
                [
                    76.3429193,
                    56.442278
                ],
                [
                    76.3440495,
                    56.4392879
                ],
                [
                    76.3443725,
                    56.4372497
                ],
                [
                    76.3405781,
                    56.4365951
                ],
                [
                    76.3398784,
                    56.4378151
                ],
                [
                    76.3357342,
                    56.4380382
                ],
                [
                    76.3343887,
                    56.4388565
                ],
                [
                    76.3325856,
                    56.4396301
                ],
                [
                    76.3340118,
                    56.4411177
                ],
                [
                    76.3350345,
                    56.4420549
                ],
                [
                    76.3375372,
                    56.4428879
                ],
                [
                    76.3379947,
                    56.4442266
                ],
                [
                    76.340255,
                    56.4445241
                ],
                [
                    76.3353305,
                    56.4465173
                ],
                [
                    76.3314554,
                    56.4482872
                ],
                [
                    76.3290604,
                    56.4500125
                ],
                [
                    76.3260195,
                    56.4530612
                ],
                [
                    76.3251314,
                    56.4542806
                ]
            ],
            "longitude": 76.33252,
            "latitude": 56.453327
        },
        "3165": {
            "name": "Табулга",
            "population": 2570,
            "type": "village",
            "poly": [
                [
                    76.3198009,
                    54.9040986
                ],
                [
                    76.3210378,
                    54.9052407
                ],
                [
                    76.3235114,
                    54.9059302
                ],
                [
                    76.3295455,
                    54.9068352
                ],
                [
                    76.3324688,
                    54.9075462
                ],
                [
                    76.3332934,
                    54.9085158
                ],
                [
                    76.334905,
                    54.9092053
                ],
                [
                    76.3359169,
                    54.9082357
                ],
                [
                    76.345624,
                    54.9107996
                ],
                [
                    76.3477978,
                    54.9109935
                ],
                [
                    76.3504963,
                    54.9106488
                ],
                [
                    76.3521453,
                    54.9075678
                ],
                [
                    76.3533072,
                    54.9043787
                ],
                [
                    76.3532697,
                    54.9022238
                ],
                [
                    76.3496717,
                    54.8985818
                ],
                [
                    76.3465235,
                    54.8995732
                ],
                [
                    76.3450993,
                    54.9010171
                ],
                [
                    76.3382781,
                    54.8972241
                ],
                [
                    76.3335183,
                    54.900349
                ],
                [
                    76.3307448,
                    54.8992715
                ],
                [
                    76.3264346,
                    54.9005861
                ],
                [
                    76.3289083,
                    54.9024609
                ],
                [
                    76.3287584,
                    54.903172
                ],
                [
                    76.3222371,
                    54.9023316
                ],
                [
                    76.3198009,
                    54.9040986
                ]
            ],
            "longitude": 76.333282,
            "latitude": 54.904236
        },
        "3166": {
            "name": "Орловка",
            "population": 322,
            "type": "village",
            "poly": [
                [
                    76.311603,
                    56.941524
                ],
                [
                    76.3153104,
                    56.9461316
                ],
                [
                    76.3205665,
                    56.9468739
                ],
                [
                    76.3258452,
                    56.9468115
                ],
                [
                    76.3320172,
                    56.9434951
                ],
                [
                    76.3366163,
                    56.9432391
                ],
                [
                    76.3406052,
                    56.9447494
                ],
                [
                    76.3416846,
                    56.946106
                ],
                [
                    76.3440311,
                    56.9469763
                ],
                [
                    76.3450635,
                    56.9463876
                ],
                [
                    76.3464245,
                    56.9447494
                ],
                [
                    76.3458613,
                    56.9426247
                ],
                [
                    76.3446412,
                    56.9405768
                ],
                [
                    76.3424355,
                    56.9411144
                ],
                [
                    76.3404645,
                    56.9404232
                ],
                [
                    76.3448758,
                    56.9363525
                ],
                [
                    76.3425826,
                    56.9348739
                ],
                [
                    76.3370856,
                    56.9329727
                ],
                [
                    76.3329558,
                    56.9319997
                ],
                [
                    76.3314541,
                    56.9336384
                ],
                [
                    76.3307501,
                    56.9354564
                ],
                [
                    76.3320641,
                    56.9373254
                ],
                [
                    76.3315948,
                    56.9393479
                ],
                [
                    76.3270896,
                    56.9388103
                ],
                [
                    76.3250248,
                    56.9378374
                ],
                [
                    76.3237577,
                    56.9378886
                ],
                [
                    76.319581,
                    56.9387335
                ],
                [
                    76.3149819,
                    56.9394247
                ],
                [
                    76.311603,
                    56.941524
                ]
            ],
            "longitude": 76.3347846,
            "latitude": 56.939608
        },
        "3167": {
            "name": "Селикла",
            "population": 306,
            "type": "village",
            "poly": null,
            "longitude": 76.347557,
            "latitude": 55.769127
        },
        "3168": {
            "name": "Новая Кулында",
            "population": 644,
            "type": "village",
            "poly": [
                [
                    76.3587274,
                    54.9157195
                ],
                [
                    76.3587742,
                    54.9163388
                ],
                [
                    76.366598,
                    54.9194623
                ],
                [
                    76.3736722,
                    54.9221009
                ],
                [
                    76.376096,
                    54.9226845
                ],
                [
                    76.3813554,
                    54.92482
                ],
                [
                    76.3857592,
                    54.9261661
                ],
                [
                    76.3864619,
                    54.9254392
                ],
                [
                    76.391709,
                    54.9265968
                ],
                [
                    76.3966748,
                    54.9257354
                ],
                [
                    76.3962064,
                    54.9242547
                ],
                [
                    76.3890386,
                    54.9211854
                ],
                [
                    76.3810743,
                    54.9182506
                ],
                [
                    76.3760146,
                    54.9176852
                ],
                [
                    76.3750047,
                    54.9185491
                ],
                [
                    76.370925,
                    54.9161967
                ],
                [
                    76.3658207,
                    54.9140569
                ],
                [
                    76.3628848,
                    54.9131525
                ],
                [
                    76.3615991,
                    54.9127885
                ],
                [
                    76.3587274,
                    54.9157195
                ]
            ],
            "longitude": 76.377663,
            "latitude": 54.920231
        },
        "3169": {
            "name": "Вознесенка",
            "population": 902,
            "type": "village",
            "poly": [
                [
                    76.3653952,
                    55.6148808
                ],
                [
                    76.3668033,
                    55.6152784
                ],
                [
                    76.3663633,
                    55.6161261
                ],
                [
                    76.3714359,
                    55.6171615
                ],
                [
                    76.3743694,
                    55.6145384
                ],
                [
                    76.3763251,
                    55.6157464
                ],
                [
                    76.383109,
                    55.6160571
                ],
                [
                    76.3879371,
                    55.617265
                ],
                [
                    76.4025438,
                    55.6182314
                ],
                [
                    76.4040105,
                    55.6189216
                ],
                [
                    76.4084109,
                    55.6187836
                ],
                [
                    76.4037661,
                    55.6170234
                ],
                [
                    76.4047439,
                    55.6162724
                ],
                [
                    76.4000502,
                    55.6142181
                ],
                [
                    76.4004414,
                    55.6139088
                ],
                [
                    76.3993462,
                    55.6134449
                ],
                [
                    76.398955,
                    55.6139309
                ],
                [
                    76.3975861,
                    55.6138868
                ],
                [
                    76.3981337,
                    55.6130915
                ],
                [
                    76.3951219,
                    55.6121637
                ],
                [
                    76.3947307,
                    55.6126718
                ],
                [
                    76.3925795,
                    55.6111695
                ],
                [
                    76.3905846,
                    55.6108382
                ],
                [
                    76.3847958,
                    55.6077673
                ],
                [
                    76.3836615,
                    55.6077452
                ],
                [
                    76.3834268,
                    55.608408
                ],
                [
                    76.3820578,
                    55.6090487
                ],
                [
                    76.3803368,
                    55.6091812
                ],
                [
                    76.3779507,
                    55.6089161
                ],
                [
                    76.3727095,
                    55.6092475
                ],
                [
                    76.3723184,
                    55.6086952
                ],
                [
                    76.3709494,
                    55.6089824
                ],
                [
                    76.371184,
                    55.6095789
                ],
                [
                    76.3699325,
                    55.6098882
                ],
                [
                    76.3689546,
                    55.6103742
                ],
                [
                    76.3686808,
                    55.6110812
                ],
                [
                    76.3693849,
                    55.6118986
                ],
                [
                    76.3674683,
                    55.612252
                ],
                [
                    76.3653952,
                    55.6148808
                ]
            ],
            "longitude": 76.385101,
            "latitude": 55.61211
        },
        "3170": {
            "name": "Еремино",
            "population": 300,
            "type": "village",
            "poly": [
                [
                    76.3801483,
                    56.6081605
                ],
                [
                    76.3813751,
                    56.6093084
                ],
                [
                    76.3836144,
                    56.61022
                ],
                [
                    76.3861909,
                    56.6115873
                ],
                [
                    76.3876326,
                    56.6121949
                ],
                [
                    76.3891662,
                    56.6114691
                ],
                [
                    76.389841,
                    56.6120599
                ],
                [
                    76.3918655,
                    56.612448
                ],
                [
                    76.391068,
                    56.6138153
                ],
                [
                    76.3917735,
                    56.6140009
                ],
                [
                    76.3933991,
                    56.6136802
                ],
                [
                    76.3943193,
                    56.613849
                ],
                [
                    76.3951474,
                    56.6137984
                ],
                [
                    76.3972946,
                    56.6152499
                ],
                [
                    76.3982762,
                    56.6155369
                ],
                [
                    76.4003006,
                    56.6147436
                ],
                [
                    76.4006993,
                    56.6141022
                ],
                [
                    76.4001166,
                    56.6133426
                ],
                [
                    76.3985216,
                    56.6132076
                ],
                [
                    76.4018035,
                    56.6117729
                ],
                [
                    76.4034907,
                    56.6115704
                ],
                [
                    76.4082757,
                    56.6115366
                ],
                [
                    76.410604,
                    56.6106996
                ],
                [
                    76.4081012,
                    56.6081666
                ],
                [
                    76.4050857,
                    56.6072151
                ],
                [
                    76.4059137,
                    56.606371
                ],
                [
                    76.405055,
                    56.6038048
                ],
                [
                    76.4027545,
                    56.603332
                ],
                [
                    76.3967119,
                    56.6037879
                ],
                [
                    76.3953621,
                    56.606371
                ],
                [
                    76.395669,
                    56.6068943
                ],
                [
                    76.3973867,
                    56.6079072
                ],
                [
                    76.3961597,
                    56.607941
                ],
                [
                    76.3918041,
                    56.6064892
                ],
                [
                    76.3897183,
                    56.6063541
                ],
                [
                    76.3885221,
                    56.6071982
                ],
                [
                    76.3817739,
                    56.605797
                ],
                [
                    76.3811912,
                    56.6069619
                ],
                [
                    76.3801483,
                    56.6081605
                ]
            ],
            "longitude": 76.39872,
            "latitude": 56.610477
        },
        "3171": {
            "name": "Новоложниково",
            "population": 133,
            "type": "village",
            "poly": [
                [
                    76.407528,
                    56.5097617
                ],
                [
                    76.4121946,
                    56.5104297
                ],
                [
                    76.4134932,
                    56.5089844
                ],
                [
                    76.4163988,
                    56.5079033
                ],
                [
                    76.4202949,
                    56.5062878
                ],
                [
                    76.4221879,
                    56.5071745
                ],
                [
                    76.4234424,
                    56.5069437
                ],
                [
                    76.4230022,
                    56.5060692
                ],
                [
                    76.4239927,
                    56.5058505
                ],
                [
                    76.4235306,
                    56.5052553
                ],
                [
                    76.424367,
                    56.5048909
                ],
                [
                    76.4236626,
                    56.5036032
                ],
                [
                    76.4215715,
                    56.5025342
                ],
                [
                    76.418732,
                    56.5026678
                ],
                [
                    76.4154963,
                    56.503834
                ],
                [
                    76.4127448,
                    56.5043807
                ],
                [
                    76.4119965,
                    56.5049395
                ],
                [
                    76.4119744,
                    56.5055711
                ],
                [
                    76.4103016,
                    56.5057169
                ],
                [
                    76.409267,
                    56.5071988
                ],
                [
                    76.4087607,
                    56.5073082
                ],
                [
                    76.407528,
                    56.5097617
                ]
            ],
            "longitude": 76.417221,
            "latitude": 56.506069
        },
        "3172": {
            "name": "Черновка",
            "population": 275,
            "type": "village",
            "poly": [
                [
                    76.4451943,
                    56.7766317
                ],
                [
                    76.4458179,
                    56.7793832
                ],
                [
                    76.4464744,
                    56.7798328
                ],
                [
                    76.4527109,
                    56.7812534
                ],
                [
                    76.4573718,
                    56.7817569
                ],
                [
                    76.4598336,
                    56.7810196
                ],
                [
                    76.467022,
                    56.7794731
                ],
                [
                    76.4730943,
                    56.7766857
                ],
                [
                    76.4717486,
                    56.7731966
                ],
                [
                    76.4689585,
                    56.7731067
                ],
                [
                    76.4647243,
                    56.7734664
                ],
                [
                    76.4596367,
                    56.7738081
                ],
                [
                    76.4562887,
                    56.7724592
                ],
                [
                    76.4540567,
                    56.7721534
                ],
                [
                    76.4511354,
                    56.7714699
                ],
                [
                    76.4484109,
                    56.771398
                ],
                [
                    76.4470324,
                    56.7720994
                ],
                [
                    76.4456538,
                    56.7744376
                ],
                [
                    76.4451943,
                    56.7766317
                ]
            ],
            "longitude": 76.459496,
            "latitude": 56.777809
        },
        "3173": {
            "name": "Усманка",
            "population": 304,
            "type": "village",
            "poly": [
                [
                    76.4718747,
                    56.2904933
                ],
                [
                    76.4740607,
                    56.2952559
                ],
                [
                    76.4775015,
                    56.2965362
                ],
                [
                    76.4871765,
                    56.297547
                ],
                [
                    76.4894839,
                    56.2956827
                ],
                [
                    76.4885933,
                    56.2889655
                ],
                [
                    76.4872979,
                    56.288651
                ],
                [
                    76.477623,
                    56.2882241
                ],
                [
                    76.4718747,
                    56.2904933
                ]
            ],
            "longitude": 76.481041,
            "latitude": 56.293644
        },
        "3174": {
            "name": "Елизаветинка",
            "population": 472,
            "type": "village",
            "poly": [
                [
                    76.4621605,
                    54.7464314
                ],
                [
                    76.4749457,
                    54.7483711
                ],
                [
                    76.4860141,
                    54.7512173
                ],
                [
                    76.4875847,
                    54.7503319
                ],
                [
                    76.488425,
                    54.7511962
                ],
                [
                    76.4873291,
                    54.7525244
                ],
                [
                    76.4887172,
                    54.7541055
                ],
                [
                    76.4945254,
                    54.7552649
                ],
                [
                    76.4978495,
                    54.7529882
                ],
                [
                    76.4988358,
                    54.7516811
                ],
                [
                    76.4952845,
                    54.7503733
                ],
                [
                    76.4948541,
                    54.7490036
                ],
                [
                    76.4912012,
                    54.7470429
                ],
                [
                    76.4866715,
                    54.74582
                ],
                [
                    76.4842606,
                    54.745588
                ],
                [
                    76.4835666,
                    54.7459886
                ],
                [
                    76.4807173,
                    54.7447235
                ],
                [
                    76.4678956,
                    54.7420245
                ],
                [
                    76.4657769,
                    54.742151
                ],
                [
                    76.4634389,
                    54.7431421
                ],
                [
                    76.4621605,
                    54.7464314
                ]
            ],
            "longitude": 76.490723,
            "latitude": 54.750904
        },
        "3175": {
            "name": "Яблоневка",
            "population": 465,
            "type": "village",
            "poly": [
                [
                    76.5082522,
                    54.7097631
                ],
                [
                    76.5115399,
                    54.7102591
                ],
                [
                    76.5129956,
                    54.7106254
                ],
                [
                    76.5126944,
                    54.7113749
                ],
                [
                    76.5219685,
                    54.7127874
                ],
                [
                    76.5233296,
                    54.713477
                ],
                [
                    76.5285439,
                    54.7140213
                ],
                [
                    76.5291512,
                    54.7125455
                ],
                [
                    76.53135,
                    54.7127874
                ],
                [
                    76.531903,
                    54.7119064
                ],
                [
                    76.5338038,
                    54.7123068
                ],
                [
                    76.5344008,
                    54.7109947
                ],
                [
                    76.5299954,
                    54.7100988
                ],
                [
                    76.5278125,
                    54.7096491
                ],
                [
                    76.5250035,
                    54.7097668
                ],
                [
                    76.5224302,
                    54.7093579
                ],
                [
                    76.5174983,
                    54.7073881
                ],
                [
                    76.5171016,
                    54.7066696
                ],
                [
                    76.5151501,
                    54.7061864
                ],
                [
                    76.5134026,
                    54.7079724
                ],
                [
                    76.5103368,
                    54.7071109
                ],
                [
                    76.5096552,
                    54.7078032
                ],
                [
                    76.5082522,
                    54.7097631
                ]
            ],
            "longitude": 76.521919,
            "latitude": 54.710808
        },
        "3176": {
            "name": "Вараксино",
            "population": 197,
            "type": "village",
            "poly": [
                [
                    76.5100355,
                    56.5106808
                ],
                [
                    76.5103853,
                    56.5117202
                ],
                [
                    76.5108697,
                    56.5122844
                ],
                [
                    76.5172475,
                    56.5142888
                ],
                [
                    76.5179472,
                    56.5138137
                ],
                [
                    76.5214186,
                    56.5147491
                ],
                [
                    76.5247017,
                    56.5147194
                ],
                [
                    76.5265047,
                    56.5144225
                ],
                [
                    76.5274735,
                    56.5149718
                ],
                [
                    76.5298147,
                    56.5139177
                ],
                [
                    76.5314831,
                    56.5085128
                ],
                [
                    76.5302101,
                    56.5073369
                ],
                [
                    76.5299654,
                    56.5067539
                ],
                [
                    76.5287921,
                    56.5042656
                ],
                [
                    76.5272208,
                    56.5042605
                ],
                [
                    76.5255628,
                    56.5045923
                ],
                [
                    76.5231678,
                    56.505617
                ],
                [
                    76.5194272,
                    56.5062111
                ],
                [
                    76.5180548,
                    56.5063744
                ],
                [
                    76.5157136,
                    56.5043547
                ],
                [
                    76.512888,
                    56.5053349
                ],
                [
                    76.513184,
                    56.5058695
                ],
                [
                    76.510789,
                    56.5074733
                ],
                [
                    76.5122422,
                    56.5084386
                ],
                [
                    76.5114617,
                    56.5096117
                ],
                [
                    76.5115694,
                    56.5106808
                ],
                [
                    76.5100355,
                    56.5106808
                ]
            ],
            "longitude": 76.522682,
            "latitude": 56.510044
        },
        "3177": {
            "name": "Воробьёво",
            "population": 548,
            "type": "village",
            "poly": [
                [
                    76.5267917,
                    56.1265581
                ],
                [
                    76.531909,
                    56.1290399
                ],
                [
                    76.5311454,
                    56.1344321
                ],
                [
                    76.5368624,
                    56.1334186
                ],
                [
                    76.537194,
                    56.1297343
                ],
                [
                    76.5451692,
                    56.1251493
                ],
                [
                    76.5443528,
                    56.1242043
                ],
                [
                    76.5398301,
                    56.1250831
                ],
                [
                    76.5361987,
                    56.1209454
                ],
                [
                    76.5307837,
                    56.1221237
                ],
                [
                    76.5267917,
                    56.1265581
                ]
            ],
            "longitude": 76.534836,
            "latitude": 56.125954
        },
        "3178": {
            "name": "Сибирцево 1-е",
            "population": 346,
            "type": "village",
            "poly": [
                [
                    76.5268684,
                    55.5953817
                ],
                [
                    76.5308757,
                    55.5966082
                ],
                [
                    76.5304583,
                    55.5973865
                ],
                [
                    76.5325454,
                    55.5982591
                ],
                [
                    76.5335472,
                    55.5984478
                ],
                [
                    76.5335055,
                    55.5989195
                ],
                [
                    76.5344656,
                    55.5993912
                ],
                [
                    76.5370954,
                    55.5994619
                ],
                [
                    76.5378884,
                    55.5992261
                ],
                [
                    76.5375546,
                    55.5988252
                ],
                [
                    76.5395999,
                    55.5985186
                ],
                [
                    76.5404348,
                    55.599344
                ],
                [
                    76.5444421,
                    55.5976459
                ],
                [
                    76.5484495,
                    55.5965374
                ],
                [
                    76.5488668,
                    55.5961601
                ],
                [
                    76.5505366,
                    55.5962308
                ],
                [
                    76.551121,
                    55.595594
                ],
                [
                    76.5505366,
                    55.5954289
                ],
                [
                    76.5515802,
                    55.5937307
                ],
                [
                    76.5500774,
                    55.5932353
                ],
                [
                    76.549493,
                    55.5938486
                ],
                [
                    76.5476981,
                    55.5938014
                ],
                [
                    76.5472807,
                    55.5944383
                ],
                [
                    76.545277,
                    55.5943911
                ],
                [
                    76.5438577,
                    55.5940609
                ],
                [
                    76.5421044,
                    55.5932117
                ],
                [
                    76.5383477,
                    55.5921267
                ],
                [
                    76.5377633,
                    55.5929759
                ],
                [
                    76.5338394,
                    55.5929759
                ],
                [
                    76.5332968,
                    55.5926456
                ],
                [
                    76.5293312,
                    55.5925041
                ],
                [
                    76.5292477,
                    55.5939665
                ],
                [
                    76.5293729,
                    55.5943911
                ],
                [
                    76.5286633,
                    55.5948157
                ],
                [
                    76.5281207,
                    55.5947213
                ],
                [
                    76.5279119,
                    55.5949572
                ],
                [
                    76.5272023,
                    55.5947921
                ],
                [
                    76.5268684,
                    55.5953817
                ]
            ],
            "longitude": 76.539017,
            "latitude": 55.595795
        },
        "3179": {
            "name": "Петропавловка 2-я",
            "population": 495,
            "type": "village",
            "poly": [
                [
                    76.5457516,
                    55.9733666
                ],
                [
                    76.5554319,
                    55.9798475
                ],
                [
                    76.5589463,
                    55.9864383
                ],
                [
                    76.5684135,
                    55.9841989
                ],
                [
                    76.5649128,
                    55.9755446
                ],
                [
                    76.5706165,
                    55.9694663
                ],
                [
                    76.5544747,
                    55.9664693
                ],
                [
                    76.5457516,
                    55.9733666
                ]
            ],
            "longitude": 76.558105,
            "latitude": 55.978115
        },
        "3180": {
            "name": "Щеглово",
            "population": 403,
            "type": "village",
            "poly": [
                [
                    76.5504157,
                    55.3492568
                ],
                [
                    76.551943,
                    55.3499156
                ],
                [
                    76.5537863,
                    55.3500653
                ],
                [
                    76.5549449,
                    55.3508737
                ],
                [
                    76.56374,
                    55.3520714
                ],
                [
                    76.564688,
                    55.3528499
                ],
                [
                    76.5643194,
                    55.3541074
                ],
                [
                    76.5653727,
                    55.3540176
                ],
                [
                    76.566742,
                    55.3527601
                ],
                [
                    76.5671633,
                    55.3504246
                ],
                [
                    76.5684799,
                    55.3510833
                ],
                [
                    76.5718505,
                    55.3504246
                ],
                [
                    76.5717452,
                    55.3489873
                ],
                [
                    76.5689539,
                    55.3472205
                ],
                [
                    76.5685853,
                    55.3454237
                ],
                [
                    76.5679533,
                    55.34749
                ],
                [
                    76.5644774,
                    55.3483584
                ],
                [
                    76.5608434,
                    55.3483584
                ],
                [
                    76.5579468,
                    55.346981
                ],
                [
                    76.5566829,
                    55.3458729
                ],
                [
                    76.5552608,
                    55.3458131
                ],
                [
                    76.5544709,
                    55.3463221
                ],
                [
                    76.5543656,
                    55.34749
                ],
                [
                    76.5530488,
                    55.3482986
                ],
                [
                    76.5512583,
                    55.3485381
                ],
                [
                    76.5504157,
                    55.3492568
                ]
            ],
            "longitude": 76.564423,
            "latitude": 55.349564
        },
        "3181": {
            "name": "Журавка",
            "population": 877,
            "type": "village",
            "poly": [
                [
                    76.5549828,
                    54.6148117
                ],
                [
                    76.5558418,
                    54.6198002
                ],
                [
                    76.5583178,
                    54.6202537
                ],
                [
                    76.5560187,
                    54.6224918
                ],
                [
                    76.5554629,
                    54.6256365
                ],
                [
                    76.5584441,
                    54.6261045
                ],
                [
                    76.5565745,
                    54.6279913
                ],
                [
                    76.5640528,
                    54.6304482
                ],
                [
                    76.5693585,
                    54.6305214
                ],
                [
                    76.5714302,
                    54.6309308
                ],
                [
                    76.5734514,
                    54.6310186
                ],
                [
                    76.5765842,
                    54.6320423
                ],
                [
                    76.5810309,
                    54.6295415
                ],
                [
                    76.5859828,
                    54.6307115
                ],
                [
                    76.5922485,
                    54.6210729
                ],
                [
                    76.5882565,
                    54.6195369
                ],
                [
                    76.5861596,
                    54.6196393
                ],
                [
                    76.5838353,
                    54.6211314
                ],
                [
                    76.5793634,
                    54.6185714
                ],
                [
                    76.5776959,
                    54.6181765
                ],
                [
                    76.5786307,
                    54.6171671
                ],
                [
                    76.576458,
                    54.61626
                ],
                [
                    76.5770643,
                    54.6142119
                ],
                [
                    76.5718092,
                    54.6124269
                ],
                [
                    76.5681963,
                    54.6116367
                ],
                [
                    76.5632444,
                    54.6111685
                ],
                [
                    76.5597578,
                    54.6112124
                ],
                [
                    76.5572039,
                    54.6116073
                ],
                [
                    76.5549828,
                    54.6148117
                ]
            ],
            "longitude": 76.57132,
            "latitude": 54.622936
        },
        "3182": {
            "name": "Очкино",
            "population": 557,
            "type": "village",
            "poly": [
                [
                    76.5904334,
                    54.7199193
                ],
                [
                    76.5930183,
                    54.7207726
                ],
                [
                    76.6021571,
                    54.7249879
                ],
                [
                    76.6035314,
                    54.725517
                ],
                [
                    76.6043494,
                    54.7251957
                ],
                [
                    76.6091919,
                    54.726783
                ],
                [
                    76.6107345,
                    54.726723
                ],
                [
                    76.6118709,
                    54.725819
                ],
                [
                    76.6123427,
                    54.7259614
                ],
                [
                    76.6143155,
                    54.7245187
                ],
                [
                    76.6110742,
                    54.7230605
                ],
                [
                    76.6065007,
                    54.721348
                ],
                [
                    76.6073551,
                    54.7205352
                ],
                [
                    76.6009891,
                    54.718029
                ],
                [
                    76.599845,
                    54.7178182
                ],
                [
                    76.6012576,
                    54.7163331
                ],
                [
                    76.6006812,
                    54.7160675
                ],
                [
                    76.6009694,
                    54.7158495
                ],
                [
                    76.6000087,
                    54.7150845
                ],
                [
                    76.5974923,
                    54.7139721
                ],
                [
                    76.5904334,
                    54.7199193
                ]
            ],
            "longitude": 76.600677,
            "latitude": 54.721859
        },
        "3183": {
            "name": "Земляная Заимка",
            "population": 540,
            "type": "village",
            "poly": [
                [
                    76.6078233,
                    55.1721743
                ],
                [
                    76.6094096,
                    55.1731413
                ],
                [
                    76.6093486,
                    55.1736552
                ],
                [
                    76.6179821,
                    55.1788468
                ],
                [
                    76.6203007,
                    55.1787074
                ],
                [
                    76.6224972,
                    55.1777928
                ],
                [
                    76.6229395,
                    55.1762772
                ],
                [
                    76.622665,
                    55.1748748
                ],
                [
                    76.6228957,
                    55.1748476
                ],
                [
                    76.6251972,
                    55.1745758
                ],
                [
                    76.6258377,
                    55.1745002
                ],
                [
                    76.626814,
                    55.1716081
                ],
                [
                    76.6247852,
                    55.1692384
                ],
                [
                    76.6262648,
                    55.1676964
                ],
                [
                    76.6289189,
                    55.1664156
                ],
                [
                    76.6297121,
                    55.1647427
                ],
                [
                    76.6250139,
                    55.1638714
                ],
                [
                    76.6240836,
                    55.1650477
                ],
                [
                    76.6186075,
                    55.1648473
                ],
                [
                    76.6109197,
                    55.1643071
                ],
                [
                    76.6102333,
                    55.1661804
                ],
                [
                    76.6123841,
                    55.1677486
                ],
                [
                    76.6121705,
                    55.169282
                ],
                [
                    76.6100655,
                    55.171277
                ],
                [
                    76.6078233,
                    55.1721743
                ]
            ],
            "longitude": 76.616425,
            "latitude": 55.171658
        },
        "3184": {
            "name": "Песчаное Озеро",
            "population": 352,
            "type": "village",
            "poly": [
                [
                    76.6324632,
                    55.0292169
                ],
                [
                    76.633736,
                    55.0306139
                ],
                [
                    76.6403978,
                    55.0315606
                ],
                [
                    76.6418872,
                    55.0313589
                ],
                [
                    76.6422664,
                    55.0309553
                ],
                [
                    76.6434038,
                    55.0312192
                ],
                [
                    76.6431871,
                    55.0317158
                ],
                [
                    76.6452182,
                    55.0322435
                ],
                [
                    76.6451369,
                    55.0325384
                ],
                [
                    76.6477367,
                    55.0331747
                ],
                [
                    76.6506614,
                    55.0333144
                ],
                [
                    76.6516633,
                    55.0332523
                ],
                [
                    76.6541006,
                    55.0241721
                ],
                [
                    76.6483324,
                    55.0225422
                ],
                [
                    76.6419413,
                    55.0228371
                ],
                [
                    76.6411019,
                    55.0258642
                ],
                [
                    76.6409936,
                    55.0282236
                ],
                [
                    76.6352254,
                    55.0276958
                ],
                [
                    76.6325444,
                    55.028146
                ],
                [
                    76.6324632,
                    55.0292169
                ]
            ],
            "longitude": 76.64666,
            "latitude": 55.027233
        },
        "3185": {
            "name": "Меньшиково",
            "population": 579,
            "type": "village",
            "poly": [
                [
                    76.6775758,
                    55.9293723
                ],
                [
                    76.685058,
                    55.9315308
                ],
                [
                    76.6854893,
                    55.9329252
                ],
                [
                    76.686623,
                    55.9347751
                ],
                [
                    76.6894326,
                    55.936549
                ],
                [
                    76.6908744,
                    55.9370322
                ],
                [
                    76.6924024,
                    55.9376395
                ],
                [
                    76.6935731,
                    55.938523
                ],
                [
                    76.6940414,
                    55.9389302
                ],
                [
                    76.6956064,
                    55.9397239
                ],
                [
                    76.6973685,
                    55.9401311
                ],
                [
                    76.69918,
                    55.9408419
                ],
                [
                    76.700363,
                    55.9410696
                ],
                [
                    76.7020882,
                    55.9409523
                ],
                [
                    76.7030124,
                    55.9410627
                ],
                [
                    76.7036532,
                    55.9416287
                ],
                [
                    76.704601,
                    55.9419667
                ],
                [
                    76.7061493,
                    55.9425189
                ],
                [
                    76.7084791,
                    55.9424434
                ],
                [
                    76.7105201,
                    55.9417317
                ],
                [
                    76.7136393,
                    55.9391976
                ],
                [
                    76.7146598,
                    55.9366633
                ],
                [
                    76.7068232,
                    55.9316374
                ],
                [
                    76.7044934,
                    55.929081
                ],
                [
                    76.7022792,
                    55.928272
                ],
                [
                    76.6980817,
                    55.9233853
                ],
                [
                    76.6973436,
                    55.9233964
                ],
                [
                    76.6952127,
                    55.9234284
                ],
                [
                    76.6897061,
                    55.9238707
                ],
                [
                    76.6834484,
                    55.9248309
                ],
                [
                    76.6803869,
                    55.9262764
                ],
                [
                    76.6786876,
                    55.9272857
                ],
                [
                    76.6775758,
                    55.9293723
                ]
            ],
            "longitude": 76.692268,
            "latitude": 55.929646
        },
        "3186": {
            "name": "Новопесчаное",
            "population": 420,
            "type": "village",
            "poly": [
                [
                    76.6881923,
                    54.8328838
                ],
                [
                    76.6900923,
                    54.8371555
                ],
                [
                    76.6948767,
                    54.8448539
                ],
                [
                    76.6978069,
                    54.8445244
                ],
                [
                    76.700531,
                    54.843773
                ],
                [
                    76.7036442,
                    54.848004
                ],
                [
                    76.707742,
                    54.8471737
                ],
                [
                    76.7064143,
                    54.8434962
                ],
                [
                    76.7099166,
                    54.8416244
                ],
                [
                    76.7054069,
                    54.8392252
                ],
                [
                    76.7042853,
                    54.8399107
                ],
                [
                    76.7005539,
                    54.8340045
                ],
                [
                    76.6995009,
                    54.8324091
                ],
                [
                    76.6970973,
                    54.8319081
                ],
                [
                    76.6881923,
                    54.8328838
                ]
            ],
            "longitude": 76.697464,
            "latitude": 54.840313
        },
        "3187": {
            "name": "Чаргары",
            "population": 306,
            "type": "village",
            "poly": [
                [
                    76.6901924,
                    55.7912116
                ],
                [
                    76.6910037,
                    55.7928308
                ],
                [
                    76.6931062,
                    55.7936434
                ],
                [
                    76.691941,
                    55.7946432
                ],
                [
                    76.6973552,
                    55.7965934
                ],
                [
                    76.6997731,
                    55.7972435
                ],
                [
                    76.7060721,
                    55.7988883
                ],
                [
                    76.7091821,
                    55.7996515
                ],
                [
                    76.7122659,
                    55.8002671
                ],
                [
                    76.7162695,
                    55.8003557
                ],
                [
                    76.7171894,
                    55.7988833
                ],
                [
                    76.714237,
                    55.7981348
                ],
                [
                    76.7122659,
                    55.7980216
                ],
                [
                    76.7132783,
                    55.7956175
                ],
                [
                    76.7071589,
                    55.7938379
                ],
                [
                    76.7050194,
                    55.7950886
                ],
                [
                    76.7040056,
                    55.7946044
                ],
                [
                    76.7010049,
                    55.793384
                ],
                [
                    76.7031444,
                    55.7922845
                ],
                [
                    76.7019154,
                    55.7913137
                ],
                [
                    76.7002334,
                    55.7918785
                ],
                [
                    76.6986276,
                    55.7920727
                ],
                [
                    76.6975511,
                    55.7915507
                ],
                [
                    76.6927401,
                    55.7897106
                ],
                [
                    76.6916133,
                    55.7901968
                ],
                [
                    76.6901924,
                    55.7912116
                ]
            ],
            "longitude": 76.69825,
            "latitude": 55.794205
        },
        "3188": {
            "name": "Колбаса",
            "population": 180,
            "type": "village",
            "poly": [
                [
                    76.6836816,
                    56.8884937
                ],
                [
                    76.6847051,
                    56.8902579
                ],
                [
                    76.6895686,
                    56.890958
                ],
                [
                    76.6943006,
                    56.8918016
                ],
                [
                    76.69992,
                    56.8915862
                ],
                [
                    76.7027789,
                    56.8919632
                ],
                [
                    76.7049149,
                    56.8918734
                ],
                [
                    76.7074124,
                    56.8931119
                ],
                [
                    76.7099099,
                    56.894153
                ],
                [
                    76.7111915,
                    56.8940273
                ],
                [
                    76.7133275,
                    56.8922145
                ],
                [
                    76.712736,
                    56.8916042
                ],
                [
                    76.7059665,
                    56.8889834
                ],
                [
                    76.7055722,
                    56.8879243
                ],
                [
                    76.6996242,
                    56.886165
                ],
                [
                    76.6981454,
                    56.886165
                ],
                [
                    76.6945635,
                    56.8861111
                ],
                [
                    76.6907187,
                    56.8810662
                ],
                [
                    76.6877283,
                    56.8805455
                ],
                [
                    76.686611,
                    56.8825743
                ],
                [
                    76.6868411,
                    56.8837772
                ],
                [
                    76.6891414,
                    56.8871165
                ],
                [
                    76.684245,
                    56.8872601
                ],
                [
                    76.6836816,
                    56.8884937
                ]
            ],
            "longitude": 76.699158,
            "latitude": 56.889893
        },
        "3189": {
            "name": "Новый Тартас",
            "population": 1158,
            "type": "village",
            "poly": [
                [
                    76.6811236,
                    55.6782685
                ],
                [
                    76.6848447,
                    55.6791782
                ],
                [
                    76.6922218,
                    55.6785585
                ],
                [
                    76.6971804,
                    55.6783275
                ],
                [
                    76.7009535,
                    55.6783452
                ],
                [
                    76.7032343,
                    55.6777622
                ],
                [
                    76.7070356,
                    55.6768877
                ],
                [
                    76.707521,
                    55.6767113
                ],
                [
                    76.708223,
                    55.6759974
                ],
                [
                    76.7092892,
                    55.6755861
                ],
                [
                    76.710648,
                    55.675624
                ],
                [
                    76.7140252,
                    55.6763303
                ],
                [
                    76.7157396,
                    55.676713
                ],
                [
                    76.717012,
                    55.6772133
                ],
                [
                    76.7175305,
                    55.6778317
                ],
                [
                    76.7177772,
                    55.6784802
                ],
                [
                    76.7180609,
                    55.6791107
                ],
                [
                    76.7190798,
                    55.6795786
                ],
                [
                    76.7196481,
                    55.6796888
                ],
                [
                    76.7202901,
                    55.6796122
                ],
                [
                    76.7217925,
                    55.6784048
                ],
                [
                    76.7230474,
                    55.6771436
                ],
                [
                    76.7240794,
                    55.6764556
                ],
                [
                    76.7253656,
                    55.6761332
                ],
                [
                    76.7269186,
                    55.6758965
                ],
                [
                    76.7284653,
                    55.6756889
                ],
                [
                    76.7300442,
                    55.6755357
                ],
                [
                    76.7315824,
                    55.6756009
                ],
                [
                    76.7335328,
                    55.6759377
                ],
                [
                    76.7336644,
                    55.6756994
                ],
                [
                    76.7345935,
                    55.6743467
                ],
                [
                    76.7303658,
                    55.6737975
                ],
                [
                    76.7310285,
                    55.6726898
                ],
                [
                    76.7267926,
                    55.6717396
                ],
                [
                    76.7301037,
                    55.6683383
                ],
                [
                    76.7253802,
                    55.6673782
                ],
                [
                    76.7195673,
                    55.6686952
                ],
                [
                    76.7110342,
                    55.6697495
                ],
                [
                    76.7045344,
                    55.6707007
                ],
                [
                    76.7080766,
                    55.6715897
                ],
                [
                    76.708135,
                    55.6722812
                ],
                [
                    76.7084529,
                    55.6724192
                ],
                [
                    76.7097191,
                    55.6726948
                ],
                [
                    76.7102057,
                    55.6737814
                ],
                [
                    76.7082789,
                    55.673946
                ],
                [
                    76.7082205,
                    55.6741326
                ],
                [
                    76.7044447,
                    55.6743521
                ],
                [
                    76.7043084,
                    55.6740009
                ],
                [
                    76.7026152,
                    55.6740777
                ],
                [
                    76.6984501,
                    55.6751094
                ],
                [
                    76.6953878,
                    55.6761905
                ],
                [
                    76.6943462,
                    55.6759664
                ],
                [
                    76.6897617,
                    55.6753956
                ],
                [
                    76.6889231,
                    55.6742357
                ],
                [
                    76.6915299,
                    55.6719173
                ],
                [
                    76.6879272,
                    55.6709381
                ],
                [
                    76.6841038,
                    55.6750039
                ],
                [
                    76.6811236,
                    55.6782685
                ]
            ],
            "longitude": 76.715065,
            "latitude": 55.672279
        },
        "3190": {
            "name": "Троицкое",
            "population": 445,
            "type": "village",
            "poly": [
                [
                    76.7023941,
                    54.9478673
                ],
                [
                    76.7083324,
                    54.9500268
                ],
                [
                    76.7076675,
                    54.9509617
                ],
                [
                    76.7163571,
                    54.9542533
                ],
                [
                    76.7233042,
                    54.9556883
                ],
                [
                    76.7241296,
                    54.9540821
                ],
                [
                    76.7348599,
                    54.9556357
                ],
                [
                    76.7371756,
                    54.9521335
                ],
                [
                    76.7364877,
                    54.951778
                ],
                [
                    76.7380239,
                    54.9499741
                ],
                [
                    76.7324754,
                    54.9482097
                ],
                [
                    76.7355477,
                    54.945339
                ],
                [
                    76.7292655,
                    54.9439958
                ],
                [
                    76.7295865,
                    54.9429554
                ],
                [
                    76.7248862,
                    54.9425208
                ],
                [
                    76.7244048,
                    54.9432319
                ],
                [
                    76.7188792,
                    54.9417701
                ],
                [
                    76.7165404,
                    54.9455497
                ],
                [
                    76.7058562,
                    54.9431398
                ],
                [
                    76.7023941,
                    54.9478673
                ]
            ],
            "longitude": 76.719742,
            "latitude": 54.94886
        },
        "3191": {
            "name": "Малый Тебис",
            "population": 315,
            "type": "village",
            "poly": [
                [
                    76.709462,
                    55.4854181
                ],
                [
                    76.7145295,
                    55.4866665
                ],
                [
                    76.7178894,
                    55.487197
                ],
                [
                    76.7199274,
                    55.4883205
                ],
                [
                    76.7248296,
                    55.4900681
                ],
                [
                    76.7285751,
                    55.4903489
                ],
                [
                    76.7296767,
                    55.4893503
                ],
                [
                    76.7227365,
                    55.4869785
                ],
                [
                    76.727804,
                    55.4842009
                ],
                [
                    76.7252703,
                    55.4828588
                ],
                [
                    76.7215798,
                    55.4850748
                ],
                [
                    76.720313,
                    55.4859799
                ],
                [
                    76.716237,
                    55.484669
                ],
                [
                    76.7097374,
                    55.4839824
                ],
                [
                    76.709462,
                    55.4854181
                ]
            ],
            "longitude": 76.720139,
            "latitude": 55.486511
        },
        "3192": {
            "name": "Барабо-Юдино",
            "population": 335,
            "type": "village",
            "poly": [
                [
                    76.7184228,
                    54.5467329
                ],
                [
                    76.7188104,
                    54.5471504
                ],
                [
                    76.7207925,
                    54.547433
                ],
                [
                    76.7220991,
                    54.54681
                ],
                [
                    76.7231954,
                    54.5474972
                ],
                [
                    76.7260301,
                    54.5463925
                ],
                [
                    76.7274252,
                    54.5476385
                ],
                [
                    76.7277907,
                    54.5478505
                ],
                [
                    76.7305036,
                    54.5494047
                ],
                [
                    76.7368153,
                    54.5493919
                ],
                [
                    76.7384873,
                    54.5493019
                ],
                [
                    76.7397607,
                    54.5487625
                ],
                [
                    76.7385759,
                    54.5476128
                ],
                [
                    76.7404251,
                    54.5470541
                ],
                [
                    76.7387088,
                    54.5451079
                ],
                [
                    76.7347003,
                    54.5439903
                ],
                [
                    76.7339695,
                    54.5436884
                ],
                [
                    76.7387198,
                    54.5408299
                ],
                [
                    76.741776,
                    54.5388193
                ],
                [
                    76.7406909,
                    54.5380291
                ],
                [
                    76.7384319,
                    54.5389606
                ],
                [
                    76.7369924,
                    54.5377721
                ],
                [
                    76.7311237,
                    54.5402197
                ],
                [
                    76.7296842,
                    54.5391983
                ],
                [
                    76.7276135,
                    54.5403803
                ],
                [
                    76.7244134,
                    54.538543
                ],
                [
                    76.720726,
                    54.5403931
                ],
                [
                    76.7230736,
                    54.5421404
                ],
                [
                    76.7201614,
                    54.5435407
                ],
                [
                    76.7221324,
                    54.544806
                ],
                [
                    76.7184228,
                    54.5467329
                ]
            ],
            "longitude": 76.728958,
            "latitude": 54.54348
        },
        "3193": {
            "name": "Заречье",
            "population": 984,
            "type": "village",
            "poly": [
                [
                    76.7151846,
                    55.7076529
                ],
                [
                    76.7174057,
                    55.7075392
                ],
                [
                    76.7175269,
                    55.7070841
                ],
                [
                    76.7189807,
                    55.7072661
                ],
                [
                    76.7226961,
                    55.7069021
                ],
                [
                    76.7233826,
                    55.7071524
                ],
                [
                    76.7205812,
                    55.7093259
                ],
                [
                    76.7373249,
                    55.7111269
                ],
                [
                    76.7377399,
                    55.7100772
                ],
                [
                    76.7362959,
                    55.7070172
                ],
                [
                    76.7357136,
                    55.7070843
                ],
                [
                    76.7346114,
                    55.7044653
                ],
                [
                    76.7407937,
                    55.7034284
                ],
                [
                    76.7393373,
                    55.7010464
                ],
                [
                    76.7384004,
                    55.7006823
                ],
                [
                    76.7375604,
                    55.7004456
                ],
                [
                    76.7366235,
                    55.7005185
                ],
                [
                    76.735202,
                    55.7021934
                ],
                [
                    76.734362,
                    55.7027031
                ],
                [
                    76.732682,
                    55.7029944
                ],
                [
                    76.7320358,
                    55.7030672
                ],
                [
                    76.7274159,
                    55.7026849
                ],
                [
                    76.7255743,
                    55.7027577
                ],
                [
                    76.7229574,
                    55.7031036
                ],
                [
                    76.7194359,
                    55.7039592
                ],
                [
                    76.7177236,
                    55.7040684
                ],
                [
                    76.7171752,
                    55.7037146
                ],
                [
                    76.7169373,
                    55.7036345
                ],
                [
                    76.7166788,
                    55.7055823
                ],
                [
                    76.7182134,
                    55.705332
                ],
                [
                    76.7184961,
                    55.7060147
                ],
                [
                    76.7153461,
                    55.7057871
                ],
                [
                    76.7151846,
                    55.7076529
                ]
            ],
            "longitude": 76.72908,
            "latitude": 55.706982
        },
        "3194": {
            "name": "Метелево",
            "population": 579,
            "type": "village",
            "poly": [
                [
                    76.7150444,
                    54.0906713
                ],
                [
                    76.747971,
                    54.0970697
                ],
                [
                    76.7501237,
                    54.0948031
                ],
                [
                    76.7474328,
                    54.0925651
                ],
                [
                    76.7192519,
                    54.0870843
                ],
                [
                    76.718469,
                    54.0886052
                ],
                [
                    76.7160718,
                    54.0882322
                ],
                [
                    76.7150444,
                    54.0906713
                ]
            ],
            "longitude": 76.73822,
            "latitude": 54.093178
        },
        "3195": {
            "name": "Старый Тартас",
            "population": 298,
            "type": "village",
            "poly": [
                [
                    76.7280529,
                    55.6105274
                ],
                [
                    76.7332036,
                    55.6131435
                ],
                [
                    76.7364045,
                    55.612229
                ],
                [
                    76.7423544,
                    55.6123353
                ],
                [
                    76.7439737,
                    55.6133562
                ],
                [
                    76.7452917,
                    55.6162273
                ],
                [
                    76.7498982,
                    55.6181337
                ],
                [
                    76.7670768,
                    55.6106155
                ],
                [
                    76.765086,
                    55.6092342
                ],
                [
                    76.7563119,
                    55.6068581
                ],
                [
                    76.7508128,
                    55.6058663
                ],
                [
                    76.7451874,
                    55.6101816
                ],
                [
                    76.7440532,
                    55.6108621
                ],
                [
                    76.7410503,
                    55.60987
                ],
                [
                    76.733876,
                    55.6075257
                ],
                [
                    76.7280529,
                    55.6105274
                ]
            ],
            "longitude": 76.743515,
            "latitude": 55.610928
        },
        "3196": {
            "name": "Павлово",
            "population": 423,
            "type": "village",
            "poly": [
                [
                    76.7688967,
                    56.1450651
                ],
                [
                    76.7709625,
                    56.1463066
                ],
                [
                    76.7727904,
                    56.145644
                ],
                [
                    76.7743087,
                    56.1463629
                ],
                [
                    76.7765453,
                    56.1464974
                ],
                [
                    76.7783785,
                    56.1472272
                ],
                [
                    76.7801127,
                    56.1480485
                ],
                [
                    76.77906,
                    56.1488819
                ],
                [
                    76.7787767,
                    56.1495279
                ],
                [
                    76.7779792,
                    56.1500112
                ],
                [
                    76.7774126,
                    56.1505043
                ],
                [
                    76.7755508,
                    56.153272
                ],
                [
                    76.7758331,
                    56.1541407
                ],
                [
                    76.7812652,
                    56.1539234
                ],
                [
                    76.7808017,
                    56.1520489
                ],
                [
                    76.7786859,
                    56.1522412
                ],
                [
                    76.7784911,
                    56.1522264
                ],
                [
                    76.7783938,
                    56.1518763
                ],
                [
                    76.7785317,
                    56.1516988
                ],
                [
                    76.7788275,
                    56.1516643
                ],
                [
                    76.779279,
                    56.1518517
                ],
                [
                    76.77958,
                    56.1516988
                ],
                [
                    76.7807574,
                    56.1510331
                ],
                [
                    76.7820765,
                    56.1506978
                ],
                [
                    76.7827405,
                    56.1501307
                ],
                [
                    76.7838034,
                    56.149786
                ],
                [
                    76.7850068,
                    56.1496771
                ],
                [
                    76.7853786,
                    56.1497264
                ],
                [
                    76.7877511,
                    56.1499138
                ],
                [
                    76.7883176,
                    56.1498447
                ],
                [
                    76.7898758,
                    56.1501998
                ],
                [
                    76.7900882,
                    56.1505055
                ],
                [
                    76.7909204,
                    56.1507126
                ],
                [
                    76.790885,
                    56.1509789
                ],
                [
                    76.7941234,
                    56.1518805
                ],
                [
                    76.7962788,
                    56.1500923
                ],
                [
                    76.7943489,
                    56.1489581
                ],
                [
                    76.7920962,
                    56.1470819
                ],
                [
                    76.791941,
                    56.1466798
                ],
                [
                    76.7918347,
                    56.1457329
                ],
                [
                    76.7905591,
                    56.1439238
                ],
                [
                    76.7888779,
                    56.1443619
                ],
                [
                    76.7876031,
                    56.144786
                ],
                [
                    76.7874438,
                    56.1443224
                ],
                [
                    76.7871782,
                    56.1442731
                ],
                [
                    76.7856378,
                    56.1448354
                ],
                [
                    76.7855139,
                    56.1451707
                ],
                [
                    76.7823985,
                    56.1456789
                ],
                [
                    76.7762525,
                    56.1412243
                ],
                [
                    76.7688967,
                    56.1450651
                ]
            ],
            "longitude": 76.787781,
            "latitude": 56.147499
        },
        "3197": {
            "name": "Красное",
            "population": 308,
            "type": "village",
            "poly": [
                [
                    76.7951442,
                    55.5309819
                ],
                [
                    76.7954822,
                    55.5325759
                ],
                [
                    76.7989745,
                    55.5336917
                ],
                [
                    76.8009462,
                    55.5342974
                ],
                [
                    76.8068608,
                    55.5357637
                ],
                [
                    76.8079874,
                    55.536465
                ],
                [
                    76.8075931,
                    55.53672
                ],
                [
                    76.8047203,
                    55.5359869
                ],
                [
                    76.8032556,
                    55.5370706
                ],
                [
                    76.8111419,
                    55.5393338
                ],
                [
                    76.8181832,
                    55.5405131
                ],
                [
                    76.8189155,
                    55.5395887
                ],
                [
                    76.8162679,
                    55.539015
                ],
                [
                    76.8177889,
                    55.5383775
                ],
                [
                    76.8214503,
                    55.5393656
                ],
                [
                    76.8234219,
                    55.5371025
                ],
                [
                    76.8214503,
                    55.5366244
                ],
                [
                    76.8221262,
                    55.5360187
                ],
                [
                    76.8191408,
                    55.5354131
                ],
                [
                    76.815423,
                    55.5348712
                ],
                [
                    76.8139584,
                    55.5349987
                ],
                [
                    76.7962708,
                    55.5301211
                ],
                [
                    76.7951442,
                    55.5309819
                ]
            ],
            "longitude": 76.813454,
            "latitude": 55.536861
        },
        "3198": {
            "name": "Красноселье",
            "population": 530,
            "type": "village",
            "poly": [
                [
                    76.8092914,
                    55.4619324
                ],
                [
                    76.8105307,
                    55.4627627
                ],
                [
                    76.8154314,
                    55.4641998
                ],
                [
                    76.8152624,
                    55.4649343
                ],
                [
                    76.8175719,
                    55.4657965
                ],
                [
                    76.816896,
                    55.4662755
                ],
                [
                    76.8193745,
                    55.4682234
                ],
                [
                    76.822698,
                    55.4687343
                ],
                [
                    76.8252328,
                    55.4614214
                ],
                [
                    76.8223036,
                    55.4602078
                ],
                [
                    76.8206137,
                    55.4589941
                ],
                [
                    76.821346,
                    55.4582915
                ],
                [
                    76.816896,
                    55.4554168
                ],
                [
                    76.8140231,
                    55.4541391
                ],
                [
                    76.8124459,
                    55.4554488
                ],
                [
                    76.8149807,
                    55.4578763
                ],
                [
                    76.8159383,
                    55.4580679
                ],
                [
                    76.8172339,
                    55.458036
                ],
                [
                    76.8151497,
                    55.4592177
                ],
                [
                    76.8143611,
                    55.4599523
                ],
                [
                    76.8150934,
                    55.4603355
                ],
                [
                    76.8133472,
                    55.4619324
                ],
                [
                    76.81008,
                    55.4612617
                ],
                [
                    76.8092914,
                    55.4619324
                ]
            ],
            "longitude": 76.817749,
            "latitude": 55.461124
        },
        "3199": {
            "name": "Моховое",
            "population": 337,
            "type": "village",
            "poly": [
                [
                    76.8081665,
                    55.2969971
                ],
                [
                    76.8131447,
                    55.2979744
                ],
                [
                    76.823101,
                    55.2978767
                ],
                [
                    76.8301392,
                    55.2956289
                ],
                [
                    76.8222427,
                    55.2925013
                ],
                [
                    76.8152046,
                    55.2921103
                ],
                [
                    76.8085098,
                    55.2931855
                ],
                [
                    76.8081665,
                    55.2969971
                ]
            ],
            "longitude": 76.817863,
            "latitude": 55.295074
        },
        "3200": {
            "name": "Ключевая",
            "population": 319,
            "type": "village",
            "poly": [
                [
                    76.826622,
                    55.711606
                ],
                [
                    76.8272658,
                    55.7129564
                ],
                [
                    76.828389,
                    55.7141447
                ],
                [
                    76.8297998,
                    55.7150012
                ],
                [
                    76.8300601,
                    55.7150706
                ],
                [
                    76.8308956,
                    55.7162975
                ],
                [
                    76.8289917,
                    55.7176863
                ],
                [
                    76.8284301,
                    55.7178869
                ],
                [
                    76.8271288,
                    55.7187664
                ],
                [
                    76.8283067,
                    55.7191831
                ],
                [
                    76.8279643,
                    55.719862
                ],
                [
                    76.8304436,
                    55.7206258
                ],
                [
                    76.8292125,
                    55.7228145
                ],
                [
                    76.8336231,
                    55.7244113
                ],
                [
                    76.8352189,
                    55.7233352
                ],
                [
                    76.836568,
                    55.7235165
                ],
                [
                    76.8375886,
                    55.7222899
                ],
                [
                    76.8409719,
                    55.7230961
                ],
                [
                    76.8422183,
                    55.7236746
                ],
                [
                    76.8439648,
                    55.7247585
                ],
                [
                    76.8451017,
                    55.7238212
                ],
                [
                    76.84554,
                    55.7234355
                ],
                [
                    76.8465674,
                    55.7205811
                ],
                [
                    76.8472454,
                    55.7192194
                ],
                [
                    76.8474372,
                    55.7173793
                ],
                [
                    76.8466496,
                    55.7144704
                ],
                [
                    76.8463825,
                    55.7142543
                ],
                [
                    76.8447799,
                    55.7134326
                ],
                [
                    76.8428211,
                    55.7129811
                ],
                [
                    76.839073,
                    55.7123236
                ],
                [
                    76.8363336,
                    55.7122002
                ],
                [
                    76.8354296,
                    55.7120999
                ],
                [
                    76.833142,
                    55.7119687
                ],
                [
                    76.8305395,
                    55.7113977
                ],
                [
                    76.8269095,
                    55.7113514
                ],
                [
                    76.826622,
                    55.711606
                ]
            ],
            "longitude": 76.837975,
            "latitude": 55.71822
        },
        "3201": {
            "name": "Вишневка",
            "population": 278,
            "type": "village",
            "poly": [
                [
                    76.8284569,
                    53.9828267
                ],
                [
                    76.8424628,
                    53.9845014
                ],
                [
                    76.8433675,
                    53.9829646
                ],
                [
                    76.8461151,
                    53.9835557
                ],
                [
                    76.8459476,
                    53.9844423
                ],
                [
                    76.8468523,
                    53.9845211
                ],
                [
                    76.8472208,
                    53.9852107
                ],
                [
                    76.8526155,
                    53.9858411
                ],
                [
                    76.8573735,
                    53.9854668
                ],
                [
                    76.8586803,
                    53.9829055
                ],
                [
                    76.8522469,
                    53.9818021
                ],
                [
                    76.852582,
                    53.9810336
                ],
                [
                    76.8459141,
                    53.9796543
                ],
                [
                    76.8366996,
                    53.9782159
                ],
                [
                    76.8361635,
                    53.9787873
                ],
                [
                    76.8359624,
                    53.9799499
                ],
                [
                    76.8298307,
                    53.9790632
                ],
                [
                    76.8289595,
                    53.9800287
                ],
                [
                    76.8284569,
                    53.9828267
                ]
            ],
            "longitude": 76.843376,
            "latitude": 53.982479
        },
        "3202": {
            "name": "Шипицыно",
            "population": 628,
            "type": "village",
            "poly": [
                [
                    76.8302024,
                    54.5168671
                ],
                [
                    76.8325613,
                    54.5173332
                ],
                [
                    76.8311058,
                    54.5209165
                ],
                [
                    76.8378314,
                    54.521907
                ],
                [
                    76.8423988,
                    54.5229848
                ],
                [
                    76.8446574,
                    54.5253733
                ],
                [
                    76.8486224,
                    54.5274123
                ],
                [
                    76.8518347,
                    54.5270627
                ],
                [
                    76.8544948,
                    54.524616
                ],
                [
                    76.8569541,
                    54.5263637
                ],
                [
                    76.8638804,
                    54.5255481
                ],
                [
                    76.8650349,
                    54.5240334
                ],
                [
                    76.8629771,
                    54.5196056
                ],
                [
                    76.8528887,
                    54.5200717
                ],
                [
                    76.852186,
                    54.5218196
                ],
                [
                    76.8481707,
                    54.5187899
                ],
                [
                    76.8428505,
                    54.517712
                ],
                [
                    76.8385341,
                    54.5168671
                ],
                [
                    76.8389858,
                    54.5160222
                ],
                [
                    76.8342176,
                    54.5150316
                ],
                [
                    76.8347195,
                    54.5140701
                ],
                [
                    76.8331636,
                    54.5137496
                ],
                [
                    76.8302024,
                    54.5168671
                ]
            ],
            "longitude": 76.855186,
            "latitude": 54.522568
        },
        "3203": {
            "name": "Новоселье",
            "population": 690,
            "type": "village",
            "poly": [
                [
                    76.8588586,
                    54.1658893
                ],
                [
                    76.8611369,
                    54.1673764
                ],
                [
                    76.8617915,
                    54.1675757
                ],
                [
                    76.8608226,
                    54.1695226
                ],
                [
                    76.8626295,
                    54.1697219
                ],
                [
                    76.863546,
                    54.1685875
                ],
                [
                    76.8651696,
                    54.1692467
                ],
                [
                    76.8680502,
                    54.1697372
                ],
                [
                    76.8690191,
                    54.1694306
                ],
                [
                    76.8716116,
                    54.1699518
                ],
                [
                    76.8714283,
                    54.1706723
                ],
                [
                    76.8772941,
                    54.1720365
                ],
                [
                    76.8802271,
                    54.1727263
                ],
                [
                    76.8806984,
                    54.1721438
                ],
                [
                    76.8832386,
                    54.172757
                ],
                [
                    76.8828981,
                    54.1733701
                ],
                [
                    76.8889735,
                    54.1747803
                ],
                [
                    76.9001813,
                    54.1776771
                ],
                [
                    76.9015788,
                    54.1759207
                ],
                [
                    76.9026168,
                    54.174627
                ],
                [
                    76.8977984,
                    54.1723891
                ],
                [
                    76.8913565,
                    54.1704117
                ],
                [
                    76.8859096,
                    54.1688634
                ],
                [
                    76.883448,
                    54.1685568
                ],
                [
                    76.88261,
                    54.1697985
                ],
                [
                    76.879232,
                    54.1676983
                ],
                [
                    76.8761157,
                    54.1666405
                ],
                [
                    76.8765609,
                    54.1655674
                ],
                [
                    76.875592,
                    54.1654141
                ],
                [
                    76.8745707,
                    54.1671311
                ],
                [
                    76.8686263,
                    54.1658433
                ],
                [
                    76.8599323,
                    54.1645555
                ],
                [
                    76.8592507,
                    54.1653192
                ],
                [
                    76.8588586,
                    54.1658893
                ]
            ],
            "longitude": 76.885658,
            "latitude": 54.17075
        },
        "3204": {
            "name": "Верх-Майзас",
            "population": 187,
            "type": "village",
            "poly": [
                [
                    76.8732313,
                    56.6872952
                ],
                [
                    76.8774815,
                    56.6879075
                ],
                [
                    76.8783176,
                    56.6913512
                ],
                [
                    76.881035,
                    56.6914086
                ],
                [
                    76.881662,
                    56.688998
                ],
                [
                    76.8834736,
                    56.6896102
                ],
                [
                    76.8862258,
                    56.689572
                ],
                [
                    76.8869922,
                    56.6877735
                ],
                [
                    76.8879677,
                    56.6880797
                ],
                [
                    76.8890825,
                    56.6895337
                ],
                [
                    76.890685,
                    56.6895528
                ],
                [
                    76.8917998,
                    56.6889789
                ],
                [
                    76.8920088,
                    56.6869699
                ],
                [
                    76.8935417,
                    56.6879649
                ],
                [
                    76.8957713,
                    56.6885771
                ],
                [
                    76.8986977,
                    56.6878118
                ],
                [
                    76.8994989,
                    56.6864533
                ],
                [
                    76.9031569,
                    56.6859941
                ],
                [
                    76.9051078,
                    56.6867595
                ],
                [
                    76.9062226,
                    56.6866447
                ],
                [
                    76.9072329,
                    56.6845782
                ],
                [
                    76.9064664,
                    56.6829517
                ],
                [
                    76.9041672,
                    56.6827412
                ],
                [
                    76.8981751,
                    56.6836789
                ],
                [
                    76.8972345,
                    56.6831239
                ],
                [
                    76.8927753,
                    56.6815931
                ],
                [
                    76.8894657,
                    56.6777657
                ],
                [
                    76.8887689,
                    56.6771915
                ],
                [
                    76.8862258,
                    56.6784738
                ],
                [
                    76.8869922,
                    56.6810573
                ],
                [
                    76.8858077,
                    56.682148
                ],
                [
                    76.8873057,
                    56.6838702
                ],
                [
                    76.8896399,
                    56.6848652
                ],
                [
                    76.8888734,
                    56.686549
                ],
                [
                    76.8827768,
                    56.6856306
                ],
                [
                    76.8741718,
                    56.6849226
                ],
                [
                    76.8732313,
                    56.6872952
                ]
            ],
            "longitude": 76.889801,
            "latitude": 56.684181
        },
        "3205": {
            "name": "Блюдчанское",
            "population": 714,
            "type": "village",
            "poly": [
                [
                    76.8763236,
                    55.1133992
                ],
                [
                    76.8765368,
                    55.1139175
                ],
                [
                    76.8788287,
                    55.1142681
                ],
                [
                    76.8793618,
                    55.1136584
                ],
                [
                    76.8809075,
                    55.1140547
                ],
                [
                    76.8815472,
                    55.1142986
                ],
                [
                    76.8811741,
                    55.114832
                ],
                [
                    76.8797616,
                    55.1148625
                ],
                [
                    76.8790153,
                    55.1145882
                ],
                [
                    76.8782691,
                    55.1149997
                ],
                [
                    76.8782691,
                    55.1154722
                ],
                [
                    76.8788287,
                    55.1166611
                ],
                [
                    76.8793084,
                    55.1173927
                ],
                [
                    76.8849052,
                    55.1178347
                ],
                [
                    76.8867707,
                    55.1180481
                ],
                [
                    76.8878634,
                    55.1176671
                ],
                [
                    76.8884231,
                    55.1168897
                ],
                [
                    76.8913546,
                    55.1176366
                ],
                [
                    76.8913281,
                    55.1181395
                ],
                [
                    76.8947927,
                    55.1191455
                ],
                [
                    76.8964717,
                    55.1194655
                ],
                [
                    76.8972712,
                    55.1174994
                ],
                [
                    76.8931137,
                    55.1165392
                ],
                [
                    76.8921276,
                    55.1157466
                ],
                [
                    76.892554,
                    55.1139632
                ],
                [
                    76.8942597,
                    55.1137193
                ],
                [
                    76.8946594,
                    55.1125913
                ],
                [
                    76.9042005,
                    55.1126066
                ],
                [
                    76.9043604,
                    55.1123322
                ],
                [
                    76.906066,
                    55.1123169
                ],
                [
                    76.9069722,
                    55.1117834
                ],
                [
                    76.9076384,
                    55.1103962
                ],
                [
                    76.9069455,
                    55.1098169
                ],
                [
                    76.9053464,
                    55.1097255
                ],
                [
                    76.9044403,
                    55.1104419
                ],
                [
                    76.9041738,
                    55.1111127
                ],
                [
                    76.9023081,
                    55.1108078
                ],
                [
                    76.9006825,
                    55.1110517
                ],
                [
                    76.8917012,
                    55.1110822
                ],
                [
                    76.8915413,
                    55.1102438
                ],
                [
                    76.890102,
                    55.1089327
                ],
                [
                    76.8877835,
                    55.1085669
                ],
                [
                    76.8877835,
                    55.1089022
                ],
                [
                    76.8878368,
                    55.109634
                ],
                [
                    76.8843988,
                    55.1083382
                ],
                [
                    76.8809875,
                    55.10814
                ],
                [
                    76.8804278,
                    55.1084144
                ],
                [
                    76.8801613,
                    55.1115243
                ],
                [
                    76.8792818,
                    55.1123779
                ],
                [
                    76.8777894,
                    55.1118749
                ],
                [
                    76.8770432,
                    55.1123474
                ],
                [
                    76.8781892,
                    55.1129267
                ],
                [
                    76.8778693,
                    55.1135059
                ],
                [
                    76.8763236,
                    55.1133992
                ]
            ],
            "longitude": 76.891884,
            "latitude": 55.112907
        },
        "3206": {
            "name": "Берёзовка",
            "population": 169,
            "type": "village",
            "poly": [
                [
                    76.9133685,
                    56.7925644
                ],
                [
                    76.915958,
                    56.7929674
                ],
                [
                    76.9145951,
                    56.7938034
                ],
                [
                    76.9163396,
                    56.7942961
                ],
                [
                    76.9170484,
                    56.7938482
                ],
                [
                    76.9186839,
                    56.7945648
                ],
                [
                    76.9177842,
                    56.7951619
                ],
                [
                    76.9200468,
                    56.7960724
                ],
                [
                    76.9225546,
                    56.7966994
                ],
                [
                    76.9236176,
                    56.7958784
                ],
                [
                    76.9242991,
                    56.7958336
                ],
                [
                    76.9260164,
                    56.7948185
                ],
                [
                    76.9261798,
                    56.7950872
                ],
                [
                    76.9253349,
                    56.7963411
                ],
                [
                    76.9243536,
                    56.7968039
                ],
                [
                    76.9245172,
                    56.7974905
                ],
                [
                    76.9270249,
                    56.7990428
                ],
                [
                    76.928197,
                    56.7993264
                ],
                [
                    76.9321495,
                    56.7969681
                ],
                [
                    76.9322313,
                    56.7974159
                ],
                [
                    76.93294,
                    56.7986697
                ],
                [
                    76.9344399,
                    56.7982964
                ],
                [
                    76.9350389,
                    56.7981473
                ],
                [
                    76.9358838,
                    56.7972517
                ],
                [
                    76.9362382,
                    56.7962217
                ],
                [
                    76.9372195,
                    56.7959082
                ],
                [
                    76.9359657,
                    56.794311
                ],
                [
                    76.9379828,
                    56.7935049
                ],
                [
                    76.9360474,
                    56.7917881
                ],
                [
                    76.9337305,
                    56.7925047
                ],
                [
                    76.9321767,
                    56.7910715
                ],
                [
                    76.928088,
                    56.7905639
                ],
                [
                    76.9258256,
                    56.7906983
                ],
                [
                    76.9229907,
                    56.7919523
                ],
                [
                    76.9212189,
                    56.7930421
                ],
                [
                    76.9183022,
                    56.7919523
                ],
                [
                    76.9170756,
                    56.7925047
                ],
                [
                    76.9145679,
                    56.7920419
                ],
                [
                    76.9136137,
                    56.7919672
                ],
                [
                    76.9133685,
                    56.7925644
                ]
            ],
            "longitude": 76.930824,
            "latitude": 56.794441
        },
        "3207": {
            "name": "Зыково",
            "population": 360,
            "type": "village",
            "poly": [
                [
                    76.9315302,
                    55.6713528
                ],
                [
                    76.9320721,
                    55.6720281
                ],
                [
                    76.9316877,
                    55.6722235
                ],
                [
                    76.932091,
                    55.672554
                ],
                [
                    76.9324566,
                    55.6724154
                ],
                [
                    76.9328591,
                    55.6726992
                ],
                [
                    76.9331265,
                    55.6726088
                ],
                [
                    76.93359,
                    55.6729807
                ],
                [
                    76.9341424,
                    55.6729304
                ],
                [
                    76.9355863,
                    55.6725384
                ],
                [
                    76.9357111,
                    55.672267
                ],
                [
                    76.9360141,
                    55.6720861
                ],
                [
                    76.9373509,
                    55.6718348
                ],
                [
                    76.9374222,
                    55.6715935
                ],
                [
                    76.9368162,
                    55.6711211
                ],
                [
                    76.9377431,
                    55.6707994
                ],
                [
                    76.9397216,
                    55.6716036
                ],
                [
                    76.9401494,
                    55.6713322
                ],
                [
                    76.9408446,
                    55.6716538
                ],
                [
                    76.946388,
                    55.6680953
                ],
                [
                    76.9461563,
                    55.6679747
                ],
                [
                    76.9463523,
                    55.6677234
                ],
                [
                    76.942324,
                    55.6664667
                ],
                [
                    76.9418249,
                    55.6664768
                ],
                [
                    76.9404701,
                    55.6675726
                ],
                [
                    76.9400959,
                    55.6677636
                ],
                [
                    76.9389017,
                    55.6677435
                ],
                [
                    76.9379213,
                    55.6671001
                ],
                [
                    76.9362102,
                    55.6666778
                ],
                [
                    76.9347345,
                    55.6678942
                ],
                [
                    76.9332519,
                    55.6690534
                ],
                [
                    76.9320927,
                    55.6702365
                ],
                [
                    76.9326834,
                    55.6705106
                ],
                [
                    76.9315302,
                    55.6713528
                ]
            ],
            "longitude": 76.939186,
            "latitude": 55.668819
        },
        "3208": {
            "name": "Благовещенка",
            "population": 467,
            "type": "village",
            "poly": [
                [
                    76.9165474,
                    53.927286
                ],
                [
                    76.9220147,
                    53.9295009
                ],
                [
                    76.9307671,
                    53.9285854
                ],
                [
                    76.9306919,
                    53.9302392
                ],
                [
                    76.9315446,
                    53.9306083
                ],
                [
                    76.9403723,
                    53.9291908
                ],
                [
                    76.9409742,
                    53.9286002
                ],
                [
                    76.9404475,
                    53.9274632
                ],
                [
                    76.9445604,
                    53.9269759
                ],
                [
                    76.9446607,
                    53.9274189
                ],
                [
                    76.9484225,
                    53.9269611
                ],
                [
                    76.9487987,
                    53.9280095
                ],
                [
                    76.9519085,
                    53.9274041
                ],
                [
                    76.9542909,
                    53.9279357
                ],
                [
                    76.9551436,
                    53.927094
                ],
                [
                    76.9556954,
                    53.9263557
                ],
                [
                    76.9554446,
                    53.9250266
                ],
                [
                    76.9532878,
                    53.9238157
                ],
                [
                    76.9513567,
                    53.9236975
                ],
                [
                    76.9514571,
                    53.9223093
                ],
                [
                    76.9420525,
                    53.9231068
                ],
                [
                    76.9370619,
                    53.9242144
                ],
                [
                    76.9165474,
                    53.927286
                ]
            ],
            "longitude": 76.944069,
            "latitude": 53.925667
        },
        "3209": {
            "name": "Озеро-Карачи",
            "population": 629,
            "type": "village",
            "poly": [
                [
                    76.9267323,
                    55.3333082
                ],
                [
                    76.9273652,
                    55.3334522
                ],
                [
                    76.92765,
                    55.3330922
                ],
                [
                    76.9300552,
                    55.3337042
                ],
                [
                    76.9297069,
                    55.3347662
                ],
                [
                    76.932302,
                    55.3355222
                ],
                [
                    76.9318906,
                    55.3358822
                ],
                [
                    76.9353717,
                    55.3366381
                ],
                [
                    76.9352451,
                    55.3370341
                ],
                [
                    76.9356564,
                    55.3371601
                ],
                [
                    76.935973,
                    55.3367461
                ],
                [
                    76.9372705,
                    55.3369261
                ],
                [
                    76.9372705,
                    55.3375021
                ],
                [
                    76.9397428,
                    55.3386181
                ],
                [
                    76.940625,
                    55.338726
                ],
                [
                    76.9413624,
                    55.3377455
                ],
                [
                    76.943758,
                    55.338204
                ],
                [
                    76.9440744,
                    55.337826
                ],
                [
                    76.9448656,
                    55.338366
                ],
                [
                    76.9472391,
                    55.3389419
                ],
                [
                    76.9490113,
                    55.3390319
                ],
                [
                    76.9499923,
                    55.3388879
                ],
                [
                    76.9499606,
                    55.3392119
                ],
                [
                    76.9538531,
                    55.3390679
                ],
                [
                    76.9560051,
                    55.3393739
                ],
                [
                    76.9657838,
                    55.3428833
                ],
                [
                    76.9666207,
                    55.3426703
                ],
                [
                    76.9658869,
                    55.3412725
                ],
                [
                    76.9608469,
                    55.3395179
                ],
                [
                    76.9611318,
                    55.33869
                ],
                [
                    76.9575241,
                    55.3374121
                ],
                [
                    76.9537898,
                    55.3368721
                ],
                [
                    76.9541696,
                    55.3361702
                ],
                [
                    76.9479353,
                    55.3352522
                ],
                [
                    76.941701,
                    55.3346402
                ],
                [
                    76.9389477,
                    55.3343702
                ],
                [
                    76.9272386,
                    55.3323542
                ],
                [
                    76.9267323,
                    55.3333082
                ]
            ],
            "longitude": 76.944824,
            "latitude": 55.336124
        },
        "3210": {
            "name": "Усть-Изес",
            "population": 531,
            "type": "village",
            "poly": [
                [
                    76.9314499,
                    55.9253301
                ],
                [
                    76.9317064,
                    55.92625
                ],
                [
                    76.9413787,
                    55.9275149
                ],
                [
                    76.9410708,
                    55.928363
                ],
                [
                    76.9447396,
                    55.9290816
                ],
                [
                    76.9440726,
                    55.9322723
                ],
                [
                    76.9459454,
                    55.9332783
                ],
                [
                    76.9473822,
                    55.933422
                ],
                [
                    76.9494603,
                    55.9312231
                ],
                [
                    76.9498452,
                    55.9313093
                ],
                [
                    76.9501274,
                    55.930677
                ],
                [
                    76.9519746,
                    55.9308926
                ],
                [
                    76.9533086,
                    55.9291678
                ],
                [
                    76.9547198,
                    55.9291535
                ],
                [
                    76.955746,
                    55.9289522
                ],
                [
                    76.9560795,
                    55.9268969
                ],
                [
                    76.9481006,
                    55.9253588
                ],
                [
                    76.9453041,
                    55.9248701
                ],
                [
                    76.9401984,
                    55.9253301
                ],
                [
                    76.9370942,
                    55.9246689
                ],
                [
                    76.9333997,
                    55.9231451
                ],
                [
                    76.931809,
                    55.9244389
                ],
                [
                    76.9314499,
                    55.9253301
                ]
            ],
            "longitude": 76.946419,
            "latitude": 55.928474
        },
        "3211": {
            "name": "Новый Майзас",
            "population": 346,
            "type": "village",
            "poly": [
                [
                    76.9444693,
                    56.5752571
                ],
                [
                    76.9461448,
                    56.5759164
                ],
                [
                    76.9456981,
                    56.5765317
                ],
                [
                    76.947581,
                    56.5769009
                ],
                [
                    76.948379,
                    56.5760395
                ],
                [
                    76.9500067,
                    56.5763471
                ],
                [
                    76.9492727,
                    56.5774283
                ],
                [
                    76.9494002,
                    56.5775777
                ],
                [
                    76.9512993,
                    56.5785709
                ],
                [
                    76.9530228,
                    56.5785973
                ],
                [
                    76.9568208,
                    56.5789752
                ],
                [
                    76.9579698,
                    56.5774546
                ],
                [
                    76.9587198,
                    56.577692
                ],
                [
                    76.9601241,
                    56.5771646
                ],
                [
                    76.9611135,
                    56.5763032
                ],
                [
                    76.9602518,
                    56.575934
                ],
                [
                    76.9603795,
                    56.575556
                ],
                [
                    76.9607625,
                    56.5746506
                ],
                [
                    76.9591188,
                    56.5740792
                ],
                [
                    76.9600444,
                    56.5729452
                ],
                [
                    76.9606986,
                    56.5733672
                ],
                [
                    76.9625976,
                    56.5726903
                ],
                [
                    76.9637147,
                    56.5736045
                ],
                [
                    76.9646084,
                    56.5733408
                ],
                [
                    76.9645924,
                    56.5726815
                ],
                [
                    76.9641615,
                    56.5718727
                ],
                [
                    76.9661084,
                    56.57102
                ],
                [
                    76.9655977,
                    56.5702639
                ],
                [
                    76.9656935,
                    56.5694199
                ],
                [
                    76.965103,
                    56.5688748
                ],
                [
                    76.9620391,
                    56.56971
                ],
                [
                    76.9579858,
                    56.5710463
                ],
                [
                    76.9576505,
                    56.5716353
                ],
                [
                    76.9569324,
                    56.5724969
                ],
                [
                    76.9552569,
                    56.5733935
                ],
                [
                    76.9546186,
                    56.5734902
                ],
                [
                    76.9544271,
                    56.5738594
                ],
                [
                    76.9550654,
                    56.574088
                ],
                [
                    76.9552889,
                    56.574633
                ],
                [
                    76.9545069,
                    56.5746066
                ],
                [
                    76.9536133,
                    56.5756263
                ],
                [
                    76.9536611,
                    56.5760482
                ],
                [
                    76.954842,
                    56.5762944
                ],
                [
                    76.9560708,
                    56.5761713
                ],
                [
                    76.9566293,
                    56.5763119
                ],
                [
                    76.955241,
                    56.5773228
                ],
                [
                    76.9540441,
                    56.5771646
                ],
                [
                    76.9542036,
                    56.5769097
                ],
                [
                    76.9531824,
                    56.5764614
                ],
                [
                    76.9527515,
                    56.5759603
                ],
                [
                    76.9524005,
                    56.5755208
                ],
                [
                    76.9527037,
                    56.5745275
                ],
                [
                    76.9535973,
                    56.5728221
                ],
                [
                    76.9539643,
                    56.5721364
                ],
                [
                    76.9547463,
                    56.5724265
                ],
                [
                    76.9563421,
                    56.5717057
                ],
                [
                    76.95639,
                    56.5710551
                ],
                [
                    76.9569324,
                    56.5706331
                ],
                [
                    76.9569485,
                    56.5702111
                ],
                [
                    76.9572836,
                    56.569921
                ],
                [
                    76.9581932,
                    56.5699122
                ],
                [
                    76.9585762,
                    56.5691122
                ],
                [
                    76.9573315,
                    56.5683033
                ],
                [
                    76.9565815,
                    56.5687693
                ],
                [
                    76.9557516,
                    56.5684792
                ],
                [
                    76.9547942,
                    56.5683473
                ],
                [
                    76.9534218,
                    56.5695342
                ],
                [
                    76.9526398,
                    56.5693672
                ],
                [
                    76.9514589,
                    56.570598
                ],
                [
                    76.9524643,
                    56.5711782
                ],
                [
                    76.9524962,
                    56.5716441
                ],
                [
                    76.9520813,
                    56.5720837
                ],
                [
                    76.9515547,
                    56.5719694
                ],
                [
                    76.9505174,
                    56.5720397
                ],
                [
                    76.9497195,
                    56.571732
                ],
                [
                    76.9482354,
                    56.5714683
                ],
                [
                    76.9475652,
                    56.5720925
                ],
                [
                    76.9483152,
                    56.5725057
                ],
                [
                    76.9477725,
                    56.5733144
                ],
                [
                    76.9493365,
                    56.5740089
                ],
                [
                    76.9484906,
                    56.5745803
                ],
                [
                    76.9478045,
                    56.5746418
                ],
                [
                    76.9453789,
                    56.5741056
                ],
                [
                    76.9444693,
                    56.5752571
                ]
            ],
            "longitude": 76.954453,
            "latitude": 56.571964
        },
        "3212": {
            "name": "Новояркуль",
            "population": 427,
            "type": "village",
            "poly": [
                [
                    76.9527618,
                    55.3674117
                ],
                [
                    76.9535903,
                    55.3670733
                ],
                [
                    76.9555062,
                    55.3674117
                ],
                [
                    76.9563864,
                    55.3669114
                ],
                [
                    76.9567231,
                    55.3665289
                ],
                [
                    76.9579659,
                    55.3667643
                ],
                [
                    76.9604514,
                    55.3675736
                ],
                [
                    76.9608657,
                    55.3675442
                ],
                [
                    76.9610986,
                    55.3671763
                ],
                [
                    76.9624968,
                    55.3675
                ],
                [
                    76.9634807,
                    55.3665583
                ],
                [
                    76.9649306,
                    55.3672352
                ],
                [
                    76.9648011,
                    55.3678532
                ],
                [
                    76.9643868,
                    55.3686771
                ],
                [
                    76.9667171,
                    55.3691185
                ],
                [
                    76.9671054,
                    55.3689861
                ],
                [
                    76.9674161,
                    55.3687507
                ],
                [
                    76.9685553,
                    55.3688831
                ],
                [
                    76.9687883,
                    55.3685153
                ],
                [
                    76.9682188,
                    55.3680739
                ],
                [
                    76.9685294,
                    55.3677943
                ],
                [
                    76.9691767,
                    55.3677649
                ],
                [
                    76.9721801,
                    55.3645865
                ],
                [
                    76.9700052,
                    55.3639979
                ],
                [
                    76.9700829,
                    55.3634976
                ],
                [
                    76.9686848,
                    55.3631885
                ],
                [
                    76.9692026,
                    55.3628795
                ],
                [
                    76.9655779,
                    55.3618494
                ],
                [
                    76.9628075,
                    55.3623497
                ],
                [
                    76.9601148,
                    55.3651751
                ],
                [
                    76.9567749,
                    55.3644541
                ],
                [
                    76.9550661,
                    55.3644835
                ],
                [
                    76.9532796,
                    55.3648661
                ],
                [
                    76.9536162,
                    55.3656018
                ],
                [
                    76.9527618,
                    55.3674117
                ]
            ],
            "longitude": 76.964294,
            "latitude": 55.365322
        },
        "3213": {
            "name": "Тармакуль",
            "population": 479,
            "type": "village",
            "poly": [
                [
                    76.9644727,
                    55.3082044
                ],
                [
                    76.9686817,
                    55.3083485
                ],
                [
                    76.9694095,
                    55.3085647
                ],
                [
                    76.9716564,
                    55.3088709
                ],
                [
                    76.9740932,
                    55.3099155
                ],
                [
                    76.9757704,
                    55.3111943
                ],
                [
                    76.9763717,
                    55.3131754
                ],
                [
                    76.9769096,
                    55.3134275
                ],
                [
                    76.9778647,
                    55.3131274
                ],
                [
                    76.9786186,
                    55.3138237
                ],
                [
                    76.9800427,
                    55.3136796
                ],
                [
                    76.9817516,
                    55.3127071
                ],
                [
                    76.9816883,
                    55.3108341
                ],
                [
                    76.9825334,
                    55.3100358
                ],
                [
                    76.9816883,
                    55.3086187
                ],
                [
                    76.978492,
                    55.3102037
                ],
                [
                    76.9771629,
                    55.3095013
                ],
                [
                    76.9745679,
                    55.3082044
                ],
                [
                    76.9750426,
                    55.3071237
                ],
                [
                    76.9761818,
                    55.3074659
                ],
                [
                    76.9777641,
                    55.3058088
                ],
                [
                    76.9757704,
                    55.3052143
                ],
                [
                    76.9746628,
                    55.3057547
                ],
                [
                    76.9697893,
                    55.3041516
                ],
                [
                    76.9687766,
                    55.3043497
                ],
                [
                    76.9668778,
                    55.3063492
                ],
                [
                    76.9660234,
                    55.3063672
                ],
                [
                    76.9654538,
                    55.3071237
                ],
                [
                    76.9645677,
                    55.3071237
                ],
                [
                    76.9644727,
                    55.3082044
                ]
            ],
            "longitude": 76.972878,
            "latitude": 55.307568
        },
        "3214": {
            "name": "Озеро-Карачи",
            "population": 1463,
            "type": "village",
            "poly": [
                [
                    76.9403729,
                    55.3447701
                ],
                [
                    76.9409797,
                    55.3460123
                ],
                [
                    76.9449444,
                    55.3468634
                ],
                [
                    76.9444994,
                    55.3476685
                ],
                [
                    76.948909,
                    55.3485426
                ],
                [
                    76.9601554,
                    55.3509117
                ],
                [
                    76.96056,
                    55.3501527
                ],
                [
                    76.9656573,
                    55.3508427
                ],
                [
                    76.9661023,
                    55.3533267
                ],
                [
                    76.9698645,
                    55.3534877
                ],
                [
                    76.9711996,
                    55.3545686
                ],
                [
                    76.9738696,
                    55.3559485
                ],
                [
                    76.9767823,
                    55.3568224
                ],
                [
                    76.9764992,
                    55.3575353
                ],
                [
                    76.9776723,
                    55.3578802
                ],
                [
                    76.9787646,
                    55.3568454
                ],
                [
                    76.983336,
                    55.3580872
                ],
                [
                    76.9862488,
                    55.3555345
                ],
                [
                    76.9855206,
                    55.3552815
                ],
                [
                    76.9863701,
                    55.3542236
                ],
                [
                    76.9879883,
                    55.3541776
                ],
                [
                    76.988231,
                    55.3533727
                ],
                [
                    76.9912652,
                    55.3530737
                ],
                [
                    76.9906988,
                    55.3512567
                ],
                [
                    76.9877456,
                    55.3510267
                ],
                [
                    76.9885547,
                    55.3497386
                ],
                [
                    76.987867,
                    55.3494396
                ],
                [
                    76.9857229,
                    55.3440799
                ],
                [
                    76.978886,
                    55.3449311
                ],
                [
                    76.9821628,
                    55.3505897
                ],
                [
                    76.9794524,
                    55.3526137
                ],
                [
                    76.9786028,
                    55.3502447
                ],
                [
                    76.9740314,
                    55.3498076
                ],
                [
                    76.97147,
                    55.3494396
                ],
                [
                    76.9699662,
                    55.3472314
                ],
                [
                    76.9659747,
                    55.3474481
                ],
                [
                    76.961422,
                    55.3468653
                ],
                [
                    76.9529419,
                    55.3457008
                ],
                [
                    76.9412794,
                    55.3432167
                ],
                [
                    76.9403729,
                    55.3447701
                ]
            ],
            "longitude": 76.973167,
            "latitude": 55.35207
        },
        "3215": {
            "name": "Петропавловка 1-я",
            "population": 575,
            "type": "village",
            "poly": [
                [
                    76.9808955,
                    55.803061
                ],
                [
                    76.9835565,
                    55.8062468
                ],
                [
                    76.984655,
                    55.806335
                ],
                [
                    76.9858431,
                    55.806883
                ],
                [
                    76.9863699,
                    55.807368
                ],
                [
                    76.986921,
                    55.8082884
                ],
                [
                    76.9861546,
                    55.8092891
                ],
                [
                    76.9878135,
                    55.8108007
                ],
                [
                    76.9892482,
                    55.8112542
                ],
                [
                    76.9914394,
                    55.8130962
                ],
                [
                    77.0001537,
                    55.8106322
                ],
                [
                    77.0002877,
                    55.8087929
                ],
                [
                    76.9954456,
                    55.8051773
                ],
                [
                    76.9974744,
                    55.8038985
                ],
                [
                    76.9942423,
                    55.8020681
                ],
                [
                    76.9858268,
                    55.7971324
                ],
                [
                    76.9824146,
                    55.7984157
                ],
                [
                    76.9833996,
                    55.7994243
                ],
                [
                    76.9843131,
                    55.8005887
                ],
                [
                    76.9834805,
                    55.8016761
                ],
                [
                    76.9808955,
                    55.803061
                ]
            ],
            "longitude": 76.991653,
            "latitude": 55.805836
        },
        "3216": {
            "name": "Советский",
            "population": 535,
            "type": "village",
            "poly": [
                [
                    77.0230439,
                    54.0305285
                ],
                [
                    77.0240206,
                    54.0308322
                ],
                [
                    77.0235445,
                    54.0318444
                ],
                [
                    77.0252845,
                    54.0324132
                ],
                [
                    77.0263021,
                    54.0326494
                ],
                [
                    77.0275824,
                    54.0319698
                ],
                [
                    77.0283128,
                    54.0313094
                ],
                [
                    77.0293223,
                    54.0315166
                ],
                [
                    77.030857,
                    54.0307309
                ],
                [
                    77.0324164,
                    54.0313528
                ],
                [
                    77.0322276,
                    54.0326976
                ],
                [
                    77.0313823,
                    54.0326639
                ],
                [
                    77.0295029,
                    54.034028
                ],
                [
                    77.0286534,
                    54.0346654
                ],
                [
                    77.0284688,
                    54.034804
                ],
                [
                    77.0280666,
                    54.0355511
                ],
                [
                    77.0311935,
                    54.0362307
                ],
                [
                    77.0324902,
                    54.0356908
                ],
                [
                    77.033672,
                    54.0350305
                ],
                [
                    77.0343696,
                    54.0351896
                ],
                [
                    77.0348374,
                    54.0349004
                ],
                [
                    77.0359208,
                    54.0353342
                ],
                [
                    77.0378905,
                    54.0342256
                ],
                [
                    77.0382516,
                    54.0334881
                ],
                [
                    77.0404511,
                    54.0337002
                ],
                [
                    77.0416,
                    54.0321577
                ],
                [
                    77.0418791,
                    54.0317866
                ],
                [
                    77.0402705,
                    54.03022
                ],
                [
                    77.0388114,
                    54.0298994
                ],
                [
                    77.0382516,
                    54.0297765
                ],
                [
                    77.0384061,
                    54.029508
                ],
                [
                    77.0388425,
                    54.0287497
                ],
                [
                    77.0382805,
                    54.0282257
                ],
                [
                    77.0380464,
                    54.0280073
                ],
                [
                    77.0369631,
                    54.0272697
                ],
                [
                    77.0351165,
                    54.0266575
                ],
                [
                    77.0372308,
                    54.0246158
                ],
                [
                    77.0362562,
                    54.0236515
                ],
                [
                    77.0338839,
                    54.0232222
                ],
                [
                    77.0341275,
                    54.021723
                ],
                [
                    77.031627,
                    54.0212936
                ],
                [
                    77.0276772,
                    54.0256403
                ],
                [
                    77.0265213,
                    54.02534
                ],
                [
                    77.0264591,
                    54.0253239
                ],
                [
                    77.024751,
                    54.0251437
                ],
                [
                    77.0246525,
                    54.0266478
                ],
                [
                    77.0236348,
                    54.0276265
                ],
                [
                    77.0232819,
                    54.02928
                ],
                [
                    77.0230439,
                    54.0305285
                ]
            ],
            "longitude": 77.028885,
            "latitude": 54.028252
        },
        "3217": {
            "name": "Туруновка",
            "population": 410,
            "type": "village",
            "poly": [
                [
                    77.0180843,
                    55.6392638
                ],
                [
                    77.0210864,
                    55.6399641
                ],
                [
                    77.0209663,
                    55.6402804
                ],
                [
                    77.0218069,
                    55.6406418
                ],
                [
                    77.0214866,
                    55.6413422
                ],
                [
                    77.0239683,
                    55.6426298
                ],
                [
                    77.02641,
                    55.6431945
                ],
                [
                    77.030693,
                    55.6436463
                ],
                [
                    77.0344956,
                    55.6438948
                ],
                [
                    77.0368973,
                    55.6442562
                ],
                [
                    77.0397392,
                    55.6441207
                ],
                [
                    77.0431016,
                    55.6433527
                ],
                [
                    77.0456634,
                    55.6424717
                ],
                [
                    77.0467441,
                    55.6413422
                ],
                [
                    77.0489056,
                    55.6410259
                ],
                [
                    77.0501465,
                    55.6390605
                ],
                [
                    77.0500664,
                    55.637592
                ],
                [
                    77.0477048,
                    55.6375468
                ],
                [
                    77.0467441,
                    55.638202
                ],
                [
                    77.0398994,
                    55.6378857
                ],
                [
                    77.0390988,
                    55.6386086
                ],
                [
                    77.0400195,
                    55.6399415
                ],
                [
                    77.0369373,
                    55.640303
                ],
                [
                    77.0318537,
                    55.6368464
                ],
                [
                    77.0300926,
                    55.6366205
                ],
                [
                    77.0248089,
                    55.6352422
                ],
                [
                    77.0242085,
                    55.6357845
                ],
                [
                    77.0217268,
                    55.6351971
                ],
                [
                    77.0202057,
                    55.636869
                ],
                [
                    77.0190449,
                    55.6377049
                ],
                [
                    77.0180843,
                    55.6392638
                ]
            ],
            "longitude": 77.032089,
            "latitude": 55.64209
        },
        "3218": {
            "name": "Киргинцево",
            "population": 590,
            "type": "village",
            "poly": [
                [
                    77.0206009,
                    54.2354965
                ],
                [
                    77.0233495,
                    54.2354965
                ],
                [
                    77.0271707,
                    54.2361724
                ],
                [
                    77.0297852,
                    54.237338
                ],
                [
                    77.0311762,
                    54.239385
                ],
                [
                    77.0320813,
                    54.2398062
                ],
                [
                    77.0305786,
                    54.2410295
                ],
                [
                    77.0304891,
                    54.2424407
                ],
                [
                    77.0301874,
                    54.2429402
                ],
                [
                    77.0321651,
                    54.243851
                ],
                [
                    77.0334891,
                    54.2441154
                ],
                [
                    77.0369248,
                    54.2405015
                ],
                [
                    77.0386007,
                    54.2408247
                ],
                [
                    77.0436789,
                    54.2416964
                ],
                [
                    77.044377,
                    54.240815
                ],
                [
                    77.0446174,
                    54.2405113
                ],
                [
                    77.0435616,
                    54.2402175
                ],
                [
                    77.0442822,
                    54.2390324
                ],
                [
                    77.0414834,
                    54.2378277
                ],
                [
                    77.0376454,
                    54.2371029
                ],
                [
                    77.0379136,
                    54.2365544
                ],
                [
                    77.0315617,
                    54.2348892
                ],
                [
                    77.0319303,
                    54.2345365
                ],
                [
                    77.0300198,
                    54.2337921
                ],
                [
                    77.0305561,
                    54.233077
                ],
                [
                    77.0301371,
                    54.2323619
                ],
                [
                    77.0273551,
                    54.2319113
                ],
                [
                    77.0220423,
                    54.2327831
                ],
                [
                    77.0213714,
                    54.2338464
                ],
                [
                    77.0211707,
                    54.2341643
                ],
                [
                    77.0206009,
                    54.2354965
                ]
            ],
            "longitude": 77.034821,
            "latitude": 54.237869
        },
        "3219": {
            "name": "Новофеклино",
            "population": 311,
            "type": "village",
            "poly": [
                [
                    77.0167398,
                    55.1283474
                ],
                [
                    77.0233367,
                    55.1298752
                ],
                [
                    77.0222512,
                    55.1310687
                ],
                [
                    77.0257862,
                    55.1322304
                ],
                [
                    77.0276511,
                    55.1325646
                ],
                [
                    77.0280687,
                    55.1314825
                ],
                [
                    77.0294883,
                    55.1316893
                ],
                [
                    77.0303791,
                    55.1307664
                ],
                [
                    77.0323274,
                    55.1314666
                ],
                [
                    77.0334131,
                    55.1313711
                ],
                [
                    77.0338307,
                    55.1308778
                ],
                [
                    77.0354729,
                    55.1311483
                ],
                [
                    77.0349441,
                    55.1317689
                ],
                [
                    77.0375049,
                    55.1328033
                ],
                [
                    77.0430441,
                    55.1333761
                ],
                [
                    77.0441854,
                    55.1314188
                ],
                [
                    77.0399544,
                    55.1299866
                ],
                [
                    77.0407895,
                    55.1275994
                ],
                [
                    77.0411792,
                    55.1261512
                ],
                [
                    77.0409843,
                    55.1248461
                ],
                [
                    77.0394254,
                    55.1243686
                ],
                [
                    77.0387575,
                    55.1244641
                ],
                [
                    77.0383678,
                    55.1249575
                ],
                [
                    77.0372266,
                    55.1249416
                ],
                [
                    77.0370039,
                    55.1251803
                ],
                [
                    77.0356956,
                    55.1251644
                ],
                [
                    77.0356678,
                    55.1269788
                ],
                [
                    77.036475,
                    55.1270424
                ],
                [
                    77.036475,
                    55.127488
                ],
                [
                    77.0357235,
                    55.1277904
                ],
                [
                    77.0357235,
                    55.1282201
                ],
                [
                    77.0348049,
                    55.1284907
                ],
                [
                    77.0344987,
                    55.1291113
                ],
                [
                    77.0325502,
                    55.1289681
                ],
                [
                    77.0289316,
                    55.1289681
                ],
                [
                    77.0288481,
                    55.1293023
                ],
                [
                    77.0175469,
                    55.127679
                ],
                [
                    77.016879,
                    55.1279018
                ],
                [
                    77.0167398,
                    55.1283474
                ]
            ],
            "longitude": 77.036087,
            "latitude": 55.129803
        },
        "3220": {
            "name": "Старая Преображенка",
            "population": 436,
            "type": "village",
            "poly": [
                [
                    77.0363855,
                    55.4964391
                ],
                [
                    77.0412245,
                    55.4974833
                ],
                [
                    77.0400148,
                    55.4981686
                ],
                [
                    77.0406485,
                    55.4988538
                ],
                [
                    77.0438169,
                    55.4999959
                ],
                [
                    77.0430104,
                    55.5007137
                ],
                [
                    77.0475613,
                    55.5026387
                ],
                [
                    77.0533221,
                    55.5047921
                ],
                [
                    77.0578731,
                    55.5054772
                ],
                [
                    77.0587948,
                    55.5041396
                ],
                [
                    77.0562025,
                    55.5035849
                ],
                [
                    77.0541862,
                    55.5007137
                ],
                [
                    77.0534373,
                    55.5002569
                ],
                [
                    77.0512482,
                    55.4998001
                ],
                [
                    77.0505569,
                    55.5003874
                ],
                [
                    77.0472157,
                    55.4993107
                ],
                [
                    77.0447386,
                    55.4977118
                ],
                [
                    77.0367888,
                    55.4954602
                ],
                [
                    77.0363855,
                    55.4964391
                ]
            ],
            "longitude": 77.047523,
            "latitude": 55.50111
        },
        "3221": {
            "name": "Старые Карачи",
            "population": 592,
            "type": "village",
            "poly": [
                [
                    77.0269378,
                    55.4922294
                ],
                [
                    77.0272835,
                    55.4953296
                ],
                [
                    77.0287813,
                    55.4940895
                ],
                [
                    77.0294726,
                    55.4941548
                ],
                [
                    77.0298758,
                    55.4945464
                ],
                [
                    77.0321225,
                    55.4941875
                ],
                [
                    77.0334475,
                    55.4936327
                ],
                [
                    77.0343116,
                    55.4937632
                ],
                [
                    77.03483,
                    55.4942854
                ],
                [
                    77.0428375,
                    55.4957865
                ],
                [
                    77.0479646,
                    55.4976791
                ],
                [
                    77.0503265,
                    55.4982339
                ],
                [
                    77.0503841,
                    55.4988538
                ],
                [
                    77.0517667,
                    55.4986581
                ],
                [
                    77.0538406,
                    55.4987233
                ],
                [
                    77.0557416,
                    55.4989844
                ],
                [
                    77.0582187,
                    55.5005506
                ],
                [
                    77.0613295,
                    55.5010074
                ],
                [
                    77.0651892,
                    55.5016599
                ],
                [
                    77.0659381,
                    55.5012031
                ],
                [
                    77.0605806,
                    55.4991149
                ],
                [
                    77.0613871,
                    55.4975812
                ],
                [
                    77.0571242,
                    55.4964718
                ],
                [
                    77.0532645,
                    55.4963412
                ],
                [
                    77.0524004,
                    55.4953296
                ],
                [
                    77.049232,
                    55.4942854
                ],
                [
                    77.0458907,
                    55.4935348
                ],
                [
                    77.0406485,
                    55.4931431
                ],
                [
                    77.0370192,
                    55.492262
                ],
                [
                    77.0329867,
                    55.4916419
                ],
                [
                    77.0324682,
                    55.4919356
                ],
                [
                    77.0283781,
                    55.4912176
                ],
                [
                    77.0276292,
                    55.4921315
                ],
                [
                    77.0269378,
                    55.4922294
                ]
            ],
            "longitude": 77.048927,
            "latitude": 55.495968
        },
        "3222": {
            "name": "Новопокровка",
            "population": 414,
            "type": "village",
            "poly": [
                [
                    77.0487347,
                    54.6480303
                ],
                [
                    77.0535955,
                    54.6487144
                ],
                [
                    77.0528729,
                    54.6514507
                ],
                [
                    77.0547122,
                    54.6515647
                ],
                [
                    77.054745,
                    54.6522107
                ],
                [
                    77.0577337,
                    54.6524578
                ],
                [
                    77.057471,
                    54.6528378
                ],
                [
                    77.0599014,
                    54.6531608
                ],
                [
                    77.0607553,
                    54.6525148
                ],
                [
                    77.0618719,
                    54.6499496
                ],
                [
                    77.0618391,
                    54.6454648
                ],
                [
                    77.0622661,
                    54.6439064
                ],
                [
                    77.0618391,
                    54.6402003
                ],
                [
                    77.0628901,
                    54.6383186
                ],
                [
                    77.0608538,
                    54.6371021
                ],
                [
                    77.0587519,
                    54.637007
                ],
                [
                    77.0588504,
                    54.6403333
                ],
                [
                    77.0569783,
                    54.6403143
                ],
                [
                    77.0555004,
                    54.6431842
                ],
                [
                    77.055172,
                    54.6447046
                ],
                [
                    77.0526102,
                    54.6447616
                ],
                [
                    77.0491616,
                    54.646358
                ],
                [
                    77.0487347,
                    54.6480303
                ]
            ],
            "longitude": 77.059166,
            "latitude": 54.642452
        },
        "3223": {
            "name": "Сибирцево 2-е",
            "population": 672,
            "type": "village",
            "poly": [
                [
                    77.0649715,
                    56.0171094
                ],
                [
                    77.0696217,
                    56.0250888
                ],
                [
                    77.0853676,
                    56.0321549
                ],
                [
                    77.0896099,
                    56.0282345
                ],
                [
                    77.088223,
                    56.0231283
                ],
                [
                    77.0842253,
                    56.0238578
                ],
                [
                    77.0819355,
                    56.0234475
                ],
                [
                    77.0807057,
                    56.0222672
                ],
                [
                    77.0764016,
                    56.0182629
                ],
                [
                    77.0790148,
                    56.0116766
                ],
                [
                    77.0747333,
                    56.0083197
                ],
                [
                    77.0675277,
                    56.0075315
                ],
                [
                    77.0649715,
                    56.0171094
                ]
            ],
            "longitude": 77.076309,
            "latitude": 56.022701
        },
        "3224": {
            "name": "Медяково",
            "population": 576,
            "type": "village",
            "poly": [
                [
                    77.0724907,
                    54.1219512
                ],
                [
                    77.0746775,
                    54.1236787
                ],
                [
                    77.0759972,
                    54.1244127
                ],
                [
                    77.0791763,
                    54.1271111
                ],
                [
                    77.0809199,
                    54.1284094
                ],
                [
                    77.083203,
                    54.1303964
                ],
                [
                    77.0847733,
                    54.131785
                ],
                [
                    77.0863146,
                    54.1331565
                ],
                [
                    77.0883472,
                    54.1370204
                ],
                [
                    77.0891873,
                    54.1381672
                ],
                [
                    77.0898038,
                    54.1384878
                ],
                [
                    77.0912218,
                    54.1381311
                ],
                [
                    77.0936572,
                    54.1379279
                ],
                [
                    77.0942352,
                    54.1368534
                ],
                [
                    77.0941196,
                    54.136289
                ],
                [
                    77.0937188,
                    54.1356975
                ],
                [
                    77.0938807,
                    54.1354537
                ],
                [
                    77.0937419,
                    54.1346861
                ],
                [
                    77.0975336,
                    54.1341217
                ],
                [
                    77.0976613,
                    54.1306284
                ],
                [
                    77.0964451,
                    54.1291185
                ],
                [
                    77.0950121,
                    54.1294783
                ],
                [
                    77.0936153,
                    54.1280459
                ],
                [
                    77.0955179,
                    54.1270228
                ],
                [
                    77.0989498,
                    54.1267123
                ],
                [
                    77.0999853,
                    54.1240026
                ],
                [
                    77.0972278,
                    54.1235368
                ],
                [
                    77.096999,
                    54.1216878
                ],
                [
                    77.0967943,
                    54.1212856
                ],
                [
                    77.0958069,
                    54.1164087
                ],
                [
                    77.0897619,
                    54.1167827
                ],
                [
                    77.0902556,
                    54.1194859
                ],
                [
                    77.0915921,
                    54.1212362
                ],
                [
                    77.0915802,
                    54.1223583
                ],
                [
                    77.0908818,
                    54.1248847
                ],
                [
                    77.0881965,
                    54.1262113
                ],
                [
                    77.0865588,
                    54.1266559
                ],
                [
                    77.0832834,
                    54.1246094
                ],
                [
                    77.0792253,
                    54.1218008
                ],
                [
                    77.0776358,
                    54.1222242
                ],
                [
                    77.0755044,
                    54.1205587
                ],
                [
                    77.074793,
                    54.1208277
                ],
                [
                    77.0751206,
                    54.1211269
                ],
                [
                    77.0724907,
                    54.1219512
                ]
            ],
            "longitude": 77.087288,
            "latitude": 54.129219
        },
        "3225": {
            "name": "Новопреображенка",
            "population": 423,
            "type": "village",
            "poly": [
                [
                    77.0799533,
                    55.3392756
                ],
                [
                    77.0817689,
                    55.3397402
                ],
                [
                    77.0829793,
                    55.3394476
                ],
                [
                    77.0834634,
                    55.3390002
                ],
                [
                    77.0841593,
                    55.3391895
                ],
                [
                    77.0855815,
                    55.3387593
                ],
                [
                    77.0860354,
                    55.3389658
                ],
                [
                    77.0860051,
                    55.3394132
                ],
                [
                    77.0875483,
                    55.3399811
                ],
                [
                    77.0873667,
                    55.340308
                ],
                [
                    77.0939328,
                    55.34196
                ],
                [
                    77.0952642,
                    55.3415298
                ],
                [
                    77.0997424,
                    55.3425278
                ],
                [
                    77.1018908,
                    55.3427859
                ],
                [
                    77.1017092,
                    55.3433365
                ],
                [
                    77.1039483,
                    55.3438355
                ],
                [
                    77.1050376,
                    55.3434742
                ],
                [
                    77.1064295,
                    55.3436807
                ],
                [
                    77.1068531,
                    55.3426483
                ],
                [
                    77.1060664,
                    55.3420632
                ],
                [
                    77.1041601,
                    55.3410824
                ],
                [
                    77.1016184,
                    55.3404629
                ],
                [
                    77.101104,
                    55.3406694
                ],
                [
                    77.0988649,
                    55.3398951
                ],
                [
                    77.0961417,
                    55.33857
                ],
                [
                    77.0950826,
                    55.3382602
                ],
                [
                    77.0903926,
                    55.3370556
                ],
                [
                    77.0901202,
                    55.3373137
                ],
                [
                    77.0883652,
                    55.3369179
                ],
                [
                    77.0881232,
                    55.3372449
                ],
                [
                    77.0868221,
                    55.3367458
                ],
                [
                    77.0871851,
                    55.3363328
                ],
                [
                    77.0861866,
                    55.3360919
                ],
                [
                    77.0842501,
                    55.3383807
                ],
                [
                    77.0837962,
                    55.3385012
                ],
                [
                    77.0802863,
                    55.337331
                ],
                [
                    77.0800744,
                    55.3376923
                ],
                [
                    77.0811032,
                    55.3380537
                ],
                [
                    77.0799533,
                    55.3392756
                ]
            ],
            "longitude": 77.093353,
            "latitude": 55.339912
        },
        "3226": {
            "name": "Камышино",
            "population": 467,
            "type": "village",
            "poly": [
                [
                    77.1030262,
                    54.2403377
                ],
                [
                    77.1168582,
                    54.2413163
                ],
                [
                    77.1238611,
                    54.2430702
                ],
                [
                    77.1329519,
                    54.2447477
                ],
                [
                    77.1332015,
                    54.2446301
                ],
                [
                    77.1343003,
                    54.2441123
                ],
                [
                    77.1423254,
                    54.2460693
                ],
                [
                    77.1439763,
                    54.2439347
                ],
                [
                    77.146872,
                    54.2444617
                ],
                [
                    77.1474798,
                    54.2419772
                ],
                [
                    77.1377366,
                    54.2400454
                ],
                [
                    77.1298854,
                    54.23866
                ],
                [
                    77.1105511,
                    54.235368
                ],
                [
                    77.1034177,
                    54.2342367
                ],
                [
                    77.1031132,
                    54.2351392
                ],
                [
                    77.105462,
                    54.2363849
                ],
                [
                    77.1030262,
                    54.2403377
                ]
            ],
            "longitude": 77.118454,
            "latitude": 54.239155
        },
        "3227": {
            "name": "Урез",
            "population": 287,
            "type": "village",
            "poly": [
                [
                    77.1114338,
                    55.914808
                ],
                [
                    77.1129303,
                    55.9150775
                ],
                [
                    77.1139458,
                    55.9158263
                ],
                [
                    77.1128769,
                    55.9165452
                ],
                [
                    77.1139458,
                    55.9171142
                ],
                [
                    77.1129303,
                    55.9177731
                ],
                [
                    77.1141595,
                    55.9187615
                ],
                [
                    77.114213,
                    55.9197198
                ],
                [
                    77.1139992,
                    55.9202888
                ],
                [
                    77.1153354,
                    55.9209177
                ],
                [
                    77.114694,
                    55.9221755
                ],
                [
                    77.1159233,
                    55.9223552
                ],
                [
                    77.1168318,
                    55.9229841
                ],
                [
                    77.1149078,
                    55.9237327
                ],
                [
                    77.1211074,
                    55.9251102
                ],
                [
                    77.1222298,
                    55.9237926
                ],
                [
                    77.123566,
                    55.924122
                ],
                [
                    77.1238332,
                    55.9237926
                ],
                [
                    77.1252228,
                    55.9240322
                ],
                [
                    77.1256504,
                    55.9234333
                ],
                [
                    77.1289105,
                    55.9229242
                ],
                [
                    77.1285148,
                    55.9223029
                ],
                [
                    77.1311018,
                    55.9216879
                ],
                [
                    77.1297122,
                    55.9199894
                ],
                [
                    77.1292847,
                    55.9187016
                ],
                [
                    77.124194,
                    55.9135724
                ],
                [
                    77.1172594,
                    55.911573
                ],
                [
                    77.1154422,
                    55.9111237
                ],
                [
                    77.1148143,
                    55.9115805
                ],
                [
                    77.1130438,
                    55.911543
                ],
                [
                    77.1118614,
                    55.9126214
                ],
                [
                    77.1123958,
                    55.912861
                ],
                [
                    77.1114338,
                    55.914808
                ]
            ],
            "longitude": 77.119736,
            "latitude": 55.919487
        },
        "3228": {
            "name": "Стеклянное",
            "population": 738,
            "type": "village",
            "poly": [
                [
                    77.1202777,
                    54.3525082
                ],
                [
                    77.1236957,
                    54.353074
                ],
                [
                    77.1256575,
                    54.3524728
                ],
                [
                    77.129217,
                    54.3533568
                ],
                [
                    77.1271742,
                    54.3557612
                ],
                [
                    77.1367406,
                    54.3584719
                ],
                [
                    77.1380956,
                    54.3572462
                ],
                [
                    77.1412103,
                    54.3587783
                ],
                [
                    77.1406844,
                    54.3595208
                ],
                [
                    77.1423226,
                    54.3598626
                ],
                [
                    77.143071,
                    54.3592144
                ],
                [
                    77.1509181,
                    54.3616538
                ],
                [
                    77.15739,
                    54.3619955
                ],
                [
                    77.1587249,
                    54.3605578
                ],
                [
                    77.1599586,
                    54.3603457
                ],
                [
                    77.1615766,
                    54.3599333
                ],
                [
                    77.1625271,
                    54.3584601
                ],
                [
                    77.1513833,
                    54.354783
                ],
                [
                    77.1362755,
                    54.350139
                ],
                [
                    77.1302687,
                    54.3478285
                ],
                [
                    77.1267496,
                    54.3508934
                ],
                [
                    77.1213092,
                    54.3496792
                ],
                [
                    77.1202777,
                    54.3525082
                ]
            ],
            "longitude": 77.142822,
            "latitude": 54.355637
        },
        "3229": {
            "name": "Теренгуль",
            "population": 445,
            "type": "village",
            "poly": [
                [
                    77.1485745,
                    53.8301976
                ],
                [
                    77.1524469,
                    53.8313627
                ],
                [
                    77.1558637,
                    53.8319901
                ],
                [
                    77.1611786,
                    53.8326174
                ],
                [
                    77.1612546,
                    53.8319901
                ],
                [
                    77.1667973,
                    53.8326622
                ],
                [
                    77.1708975,
                    53.8273296
                ],
                [
                    77.1747699,
                    53.826747
                ],
                [
                    77.1743902,
                    53.8245062
                ],
                [
                    77.1700914,
                    53.8252209
                ],
                [
                    77.1689993,
                    53.8254025
                ],
                [
                    77.1636843,
                    53.8246855
                ],
                [
                    77.1663418,
                    53.8198897
                ],
                [
                    77.1614065,
                    53.8192622
                ],
                [
                    77.1582175,
                    53.8203379
                ],
                [
                    77.1551183,
                    53.8253129
                ],
                [
                    77.1547248,
                    53.8271055
                ],
                [
                    77.1485745,
                    53.8301976
                ]
            ],
            "longitude": 77.160271,
            "latitude": 53.827644
        },
        "3230": {
            "name": "Крутиха",
            "population": 162,
            "type": "village",
            "poly": [
                [
                    77.1511261,
                    56.8183563
                ],
                [
                    77.1545227,
                    56.8198816
                ],
                [
                    77.1560034,
                    56.8200008
                ],
                [
                    77.1550453,
                    56.8180703
                ],
                [
                    77.1582678,
                    56.8194288
                ],
                [
                    77.1631015,
                    56.8207396
                ],
                [
                    77.1661063,
                    56.8220503
                ],
                [
                    77.1667595,
                    56.8235516
                ],
                [
                    77.1684143,
                    56.8238852
                ],
                [
                    77.1716803,
                    56.8241473
                ],
                [
                    77.1736835,
                    56.8237422
                ],
                [
                    77.1744238,
                    56.8234324
                ],
                [
                    77.179214,
                    56.8248384
                ],
                [
                    77.1813478,
                    56.823361
                ],
                [
                    77.1799108,
                    56.822789
                ],
                [
                    77.1762964,
                    56.8215498
                ],
                [
                    77.1742061,
                    56.8206442
                ],
                [
                    77.1719416,
                    56.8205489
                ],
                [
                    77.170461,
                    56.8196671
                ],
                [
                    77.1696336,
                    56.817546
                ],
                [
                    77.1706352,
                    56.8161636
                ],
                [
                    77.1716368,
                    56.8139469
                ],
                [
                    77.1672385,
                    56.8132318
                ],
                [
                    77.1675869,
                    56.8124214
                ],
                [
                    77.1634064,
                    56.8118016
                ],
                [
                    77.1631015,
                    56.8127074
                ],
                [
                    77.1631015,
                    56.8135179
                ],
                [
                    77.159792,
                    56.8135417
                ],
                [
                    77.1549147,
                    56.8119923
                ],
                [
                    77.1526067,
                    56.8135894
                ],
                [
                    77.1516922,
                    56.8160921
                ],
                [
                    77.1511261,
                    56.8183563
                ]
            ],
            "longitude": 77.165085,
            "latitude": 56.817802
        },
        "3231": {
            "name": "Новые Кулики",
            "population": 153,
            "type": "village",
            "poly": [
                [
                    77.1762449,
                    56.1480189
                ],
                [
                    77.1768398,
                    56.1494068
                ],
                [
                    77.177525,
                    56.1495623
                ],
                [
                    77.1803166,
                    56.1498026
                ],
                [
                    77.1877776,
                    56.1494351
                ],
                [
                    77.1883105,
                    56.1488272
                ],
                [
                    77.1888181,
                    56.1487565
                ],
                [
                    77.1891734,
                    56.1485445
                ],
                [
                    77.189884,
                    56.1475549
                ],
                [
                    77.1883613,
                    56.1470319
                ],
                [
                    77.1873461,
                    56.1468481
                ],
                [
                    77.1879553,
                    56.1462261
                ],
                [
                    77.1875746,
                    56.1461554
                ],
                [
                    77.1886405,
                    56.1448547
                ],
                [
                    77.1886658,
                    56.144572
                ],
                [
                    77.188006,
                    56.1442468
                ],
                [
                    77.1880314,
                    56.1438085
                ],
                [
                    77.1871939,
                    56.1434692
                ],
                [
                    77.1882852,
                    56.1423805
                ],
                [
                    77.1918888,
                    56.1433278
                ],
                [
                    77.1942235,
                    56.1413201
                ],
                [
                    77.1890719,
                    56.1394113
                ],
                [
                    77.1883105,
                    56.1397648
                ],
                [
                    77.1856459,
                    56.142126
                ],
                [
                    77.1848084,
                    56.1424936
                ],
                [
                    77.1836664,
                    56.1428047
                ],
                [
                    77.1831842,
                    56.1431723
                ],
                [
                    77.1783879,
                    56.1414191
                ],
                [
                    77.1781595,
                    56.1417019
                ],
                [
                    77.1771951,
                    56.1411646
                ],
                [
                    77.1764338,
                    56.1418291
                ],
                [
                    77.1768398,
                    56.1418998
                ],
                [
                    77.1762815,
                    56.1424371
                ],
                [
                    77.1790223,
                    56.1439782
                ],
                [
                    77.1765353,
                    56.1450668
                ],
                [
                    77.1780072,
                    56.1462685
                ],
                [
                    77.1776265,
                    56.1467209
                ],
                [
                    77.1778295,
                    56.1472015
                ],
                [
                    77.176586,
                    56.1474984
                ],
                [
                    77.1762449,
                    56.1480189
                ]
            ],
            "longitude": 77.182671,
            "latitude": 56.145264
        },
        "3232": {
            "name": "Кошкуль",
            "population": 469,
            "type": "village",
            "poly": null,
            "longitude": 77.184082,
            "latitude": 55.289734
        },
        "3233": {
            "name": "Куляба",
            "population": 218,
            "type": "village",
            "poly": [
                [
                    77.1790898,
                    56.5230382
                ],
                [
                    77.1865782,
                    56.526056
                ],
                [
                    77.1888707,
                    56.5260392
                ],
                [
                    77.1896042,
                    56.5250613
                ],
                [
                    77.1884428,
                    56.524387
                ],
                [
                    77.1931803,
                    56.5207958
                ],
                [
                    77.1934249,
                    56.521133
                ],
                [
                    77.192783,
                    56.5224481
                ],
                [
                    77.1933026,
                    56.5250613
                ],
                [
                    77.1959923,
                    56.5249265
                ],
                [
                    77.1985904,
                    56.523662
                ],
                [
                    77.1989265,
                    56.5228865
                ],
                [
                    77.1987125,
                    56.5219592
                ],
                [
                    77.1975512,
                    56.5207452
                ],
                [
                    77.1952282,
                    56.5197336
                ],
                [
                    77.1974289,
                    56.5182498
                ],
                [
                    77.1966036,
                    56.5151639
                ],
                [
                    77.1950142,
                    56.5148266
                ],
                [
                    77.192569,
                    56.5168165
                ],
                [
                    77.192294,
                    56.5180474
                ],
                [
                    77.1914993,
                    56.5185701
                ],
                [
                    77.190185,
                    56.5173223
                ],
                [
                    77.187159,
                    56.5162263
                ],
                [
                    77.1859058,
                    56.5168671
                ],
                [
                    77.1880148,
                    56.5182666
                ],
                [
                    77.189971,
                    56.5190085
                ],
                [
                    77.1867922,
                    56.5206778
                ],
                [
                    77.1855695,
                    56.5203237
                ],
                [
                    77.1843165,
                    56.5209476
                ],
                [
                    77.1790898,
                    56.5230382
                ]
            ],
            "longitude": 77.188881,
            "latitude": 56.521778
        },
        "3234": {
            "name": "Покровка",
            "population": 430,
            "type": "village",
            "poly": [
                [
                    77.2122853,
                    55.5596557
                ],
                [
                    77.2162915,
                    55.5609084
                ],
                [
                    77.2143591,
                    55.5634405
                ],
                [
                    77.2169042,
                    55.56424
                ],
                [
                    77.2159615,
                    55.5658658
                ],
                [
                    77.2188365,
                    55.5663721
                ],
                [
                    77.2194021,
                    55.5650662
                ],
                [
                    77.2224185,
                    55.565546
                ],
                [
                    77.2225127,
                    55.5662122
                ],
                [
                    77.2270844,
                    55.5663988
                ],
                [
                    77.2281685,
                    55.5656259
                ],
                [
                    77.2287812,
                    55.5639202
                ],
                [
                    77.2274144,
                    55.563707
                ],
                [
                    77.2280271,
                    55.5632539
                ],
                [
                    77.2269902,
                    55.5615481
                ],
                [
                    77.2282627,
                    55.5613616
                ],
                [
                    77.2297709,
                    55.5622678
                ],
                [
                    77.2297238,
                    55.5627475
                ],
                [
                    77.2314676,
                    55.5636004
                ],
                [
                    77.2331172,
                    55.5627475
                ],
                [
                    77.2343897,
                    55.5634671
                ],
                [
                    77.2368405,
                    55.5623211
                ],
                [
                    77.236275,
                    55.5616281
                ],
                [
                    77.2350024,
                    55.5611217
                ],
                [
                    77.2343426,
                    55.5611483
                ],
                [
                    77.233777,
                    55.5604287
                ],
                [
                    77.2383487,
                    55.5583496
                ],
                [
                    77.2382073,
                    55.5577898
                ],
                [
                    77.237736,
                    55.5573366
                ],
                [
                    77.2383959,
                    55.5567769
                ],
                [
                    77.2374061,
                    55.5560305
                ],
                [
                    77.2344369,
                    55.5554173
                ],
                [
                    77.2331172,
                    55.5556306
                ],
                [
                    77.2327402,
                    55.5561104
                ],
                [
                    77.2310906,
                    55.5559238
                ],
                [
                    77.2307134,
                    55.5561904
                ],
                [
                    77.2284041,
                    55.5556839
                ],
                [
                    77.2271316,
                    55.5564303
                ],
                [
                    77.2266603,
                    55.5572034
                ],
                [
                    77.2275557,
                    55.5584295
                ],
                [
                    77.2259062,
                    55.5596557
                ],
                [
                    77.2273672,
                    55.5600822
                ],
                [
                    77.2263775,
                    55.5605619
                ],
                [
                    77.223691,
                    55.5598956
                ],
                [
                    77.2228898,
                    55.5589893
                ],
                [
                    77.2236439,
                    55.5583229
                ],
                [
                    77.2240209,
                    55.5570434
                ],
                [
                    77.2234082,
                    55.5559238
                ],
                [
                    77.2205332,
                    55.5558172
                ],
                [
                    77.2198262,
                    55.5584295
                ],
                [
                    77.2186009,
                    55.5582963
                ],
                [
                    77.2136991,
                    55.5575232
                ],
                [
                    77.2122853,
                    55.5596557
                ]
            ],
            "longitude": 77.222984,
            "latitude": 55.56152
        },
        "3235": {
            "name": "Отреченское",
            "population": 514,
            "type": "village",
            "poly": [
                [
                    77.2194108,
                    55.1191484
                ],
                [
                    77.2204453,
                    55.1195371
                ],
                [
                    77.2211841,
                    55.1194019
                ],
                [
                    77.2218639,
                    55.1186244
                ],
                [
                    77.2223073,
                    55.1189455
                ],
                [
                    77.2215684,
                    55.120078
                ],
                [
                    77.2229279,
                    55.1206526
                ],
                [
                    77.2227801,
                    55.1213625
                ],
                [
                    77.2235781,
                    55.1215484
                ],
                [
                    77.2233417,
                    55.121954
                ],
                [
                    77.2223959,
                    55.1216836
                ],
                [
                    77.2217161,
                    55.1220723
                ],
                [
                    77.2210659,
                    55.1229511
                ],
                [
                    77.2210364,
                    55.1236778
                ],
                [
                    77.2238146,
                    55.1243538
                ],
                [
                    77.2263859,
                    55.1213456
                ],
                [
                    77.2273908,
                    55.1216498
                ],
                [
                    77.2286617,
                    55.1210413
                ],
                [
                    77.2292824,
                    55.1200611
                ],
                [
                    77.2317355,
                    55.1206357
                ],
                [
                    77.233627,
                    55.1185568
                ],
                [
                    77.2337157,
                    55.1173736
                ],
                [
                    77.2316467,
                    55.1173398
                ],
                [
                    77.2309375,
                    55.1179145
                ],
                [
                    77.2313808,
                    55.1188103
                ],
                [
                    77.230169,
                    55.1183709
                ],
                [
                    77.2303464,
                    55.117999
                ],
                [
                    77.2296075,
                    55.1176779
                ],
                [
                    77.2297257,
                    55.1172215
                ],
                [
                    77.2315581,
                    55.1166468
                ],
                [
                    77.2312921,
                    55.1156495
                ],
                [
                    77.2298735,
                    55.1154467
                ],
                [
                    77.2305237,
                    55.1151593
                ],
                [
                    77.2309079,
                    55.1145001
                ],
                [
                    77.2307897,
                    55.1135027
                ],
                [
                    77.2295484,
                    55.1135196
                ],
                [
                    77.2290164,
                    55.1137394
                ],
                [
                    77.2292232,
                    55.1143479
                ],
                [
                    77.2272726,
                    55.1142465
                ],
                [
                    77.2270361,
                    55.1137732
                ],
                [
                    77.2250264,
                    55.1137732
                ],
                [
                    77.2227801,
                    55.1143986
                ],
                [
                    77.2204453,
                    55.1146691
                ],
                [
                    77.2199724,
                    55.1147874
                ],
                [
                    77.2201793,
                    55.1152607
                ],
                [
                    77.2207999,
                    55.1155819
                ],
                [
                    77.2203566,
                    55.1161566
                ],
                [
                    77.2209773,
                    55.1164102
                ],
                [
                    77.2205635,
                    55.1170694
                ],
                [
                    77.2199724,
                    55.1179145
                ],
                [
                    77.2194108,
                    55.1191484
                ]
            ],
            "longitude": 77.227417,
            "latitude": 55.118225
        },
        "3236": {
            "name": "Осинцево",
            "population": 451,
            "type": "village",
            "poly": [
                [
                    77.216817,
                    55.5000363
                ],
                [
                    77.217984,
                    55.5014807
                ],
                [
                    77.2213122,
                    55.5013828
                ],
                [
                    77.2257209,
                    55.4999384
                ],
                [
                    77.2270608,
                    55.5002077
                ],
                [
                    77.2296542,
                    55.5002322
                ],
                [
                    77.2319882,
                    55.4995956
                ],
                [
                    77.2381259,
                    55.4990815
                ],
                [
                    77.2389471,
                    55.4989101
                ],
                [
                    77.2388175,
                    55.4971963
                ],
                [
                    77.2404167,
                    55.4971719
                ],
                [
                    77.2429236,
                    55.4948459
                ],
                [
                    77.2421887,
                    55.4942582
                ],
                [
                    77.2405464,
                    55.4930584
                ],
                [
                    77.2317288,
                    55.4941603
                ],
                [
                    77.2302161,
                    55.4949928
                ],
                [
                    77.2304322,
                    55.4963394
                ],
                [
                    77.2221766,
                    55.4980533
                ],
                [
                    77.2228681,
                    55.4997181
                ],
                [
                    77.2217012,
                    55.4999629
                ],
                [
                    77.2213122,
                    55.4991795
                ],
                [
                    77.216817,
                    55.5000363
                ]
            ],
            "longitude": 77.231178,
            "latitude": 55.497696
        },
        "3237": {
            "name": "Сибирский",
            "population": 384,
            "type": "village",
            "poly": [
                [
                    [
                        77.2177396,
                        54.5156812
                    ],
                    [
                        77.2208302,
                        54.5170382
                    ],
                    [
                        77.2202754,
                        54.5188091
                    ],
                    [
                        77.2213055,
                        54.519729
                    ],
                    [
                        77.2243169,
                        54.519775
                    ],
                    [
                        77.225149,
                        54.519016
                    ],
                    [
                        77.2329149,
                        54.5208558
                    ],
                    [
                        77.2347375,
                        54.5203039
                    ],
                    [
                        77.2367186,
                        54.5173601
                    ],
                    [
                        77.2337073,
                        54.5163712
                    ],
                    [
                        77.2334696,
                        54.5143472
                    ],
                    [
                        77.235411,
                        54.5141632
                    ],
                    [
                        77.2369563,
                        54.5123001
                    ],
                    [
                        77.2337469,
                        54.5107589
                    ],
                    [
                        77.2327564,
                        54.5107819
                    ],
                    [
                        77.2317262,
                        54.5120471
                    ],
                    [
                        77.2327564,
                        54.5137492
                    ],
                    [
                        77.2320828,
                        54.5141172
                    ],
                    [
                        77.2302998,
                        54.5138412
                    ],
                    [
                        77.2311319,
                        54.5129441
                    ],
                    [
                        77.229864,
                        54.5128061
                    ],
                    [
                        77.2290319,
                        54.5136342
                    ],
                    [
                        77.2223754,
                        54.5119091
                    ],
                    [
                        77.2190075,
                        54.5136572
                    ],
                    [
                        77.2177396,
                        54.5156812
                    ]
                ],
                [
                    [
                        77.2149265,
                        54.5214307
                    ],
                    [
                        77.2161944,
                        54.5227645
                    ],
                    [
                        77.2216622,
                        54.5232244
                    ],
                    [
                        77.223049,
                        54.5210628
                    ],
                    [
                        77.2186906,
                        54.5201659
                    ],
                    [
                        77.216551,
                        54.5204879
                    ],
                    [
                        77.2149265,
                        54.5214307
                    ]
                ]
            ],
            "longitude": 77.232292,
            "latitude": 54.517609
        },
        "3238": {
            "name": "Ивановка",
            "population": 526,
            "type": "village",
            "poly": [
                [
                    77.2289805,
                    54.0151905
                ],
                [
                    77.2315833,
                    54.0156919
                ],
                [
                    77.2317967,
                    54.0152156
                ],
                [
                    77.2327781,
                    54.0152406
                ],
                [
                    77.2332475,
                    54.014313
                ],
                [
                    77.2344849,
                    54.0144133
                ],
                [
                    77.2341435,
                    54.015366
                ],
                [
                    77.2363197,
                    54.0156167
                ],
                [
                    77.2375144,
                    54.0148896
                ],
                [
                    77.2380691,
                    54.0137865
                ],
                [
                    77.2407999,
                    54.0139118
                ],
                [
                    77.2420801,
                    54.0118057
                ],
                [
                    77.245451,
                    54.012257
                ],
                [
                    77.2464751,
                    54.0106774
                ],
                [
                    77.2465604,
                    54.009223
                ],
                [
                    77.2471151,
                    54.0091478
                ],
                [
                    77.2474138,
                    54.007869
                ],
                [
                    77.2466458,
                    54.0075931
                ],
                [
                    77.2474138,
                    54.0064647
                ],
                [
                    77.2463897,
                    54.0062641
                ],
                [
                    77.2465604,
                    54.0059882
                ],
                [
                    77.2428481,
                    54.0050353
                ],
                [
                    77.2434455,
                    54.004308
                ],
                [
                    77.2396479,
                    54.0028033
                ],
                [
                    77.2377705,
                    54.0024522
                ],
                [
                    77.2381972,
                    54.0015995
                ],
                [
                    77.2360209,
                    54.0012484
                ],
                [
                    77.2340582,
                    54.0052861
                ],
                [
                    77.2335462,
                    54.0052861
                ],
                [
                    77.2319674,
                    54.0082451
                ],
                [
                    77.230986,
                    54.0101257
                ],
                [
                    77.2317967,
                    54.0103514
                ],
                [
                    77.2289805,
                    54.0151905
                ]
            ],
            "longitude": 77.239647,
            "latitude": 54.009651
        },
        "3239": {
            "name": "Усть-Ламенка",
            "population": 338,
            "type": "village",
            "poly": [
                [
                    77.2640896,
                    55.679377
                ],
                [
                    77.26597,
                    55.680415
                ],
                [
                    77.2694173,
                    55.6807905
                ],
                [
                    77.2757244,
                    55.6829549
                ],
                [
                    77.2788583,
                    55.6823586
                ],
                [
                    77.2801902,
                    55.6823145
                ],
                [
                    77.2852829,
                    55.6815856
                ],
                [
                    77.2855571,
                    55.6819169
                ],
                [
                    77.2873983,
                    55.6817623
                ],
                [
                    77.2901797,
                    55.6817402
                ],
                [
                    77.2929218,
                    55.6816519
                ],
                [
                    77.2940579,
                    55.6811439
                ],
                [
                    77.2966434,
                    55.6754673
                ],
                [
                    77.2949197,
                    55.6746058
                ],
                [
                    77.2894745,
                    55.6740756
                ],
                [
                    77.2879075,
                    55.6742303
                ],
                [
                    77.2855571,
                    55.6739431
                ],
                [
                    77.2866931,
                    55.6724409
                ],
                [
                    77.2855179,
                    55.6721316
                ],
                [
                    77.2853221,
                    55.6716235
                ],
                [
                    77.2835984,
                    55.6704968
                ],
                [
                    77.283285,
                    55.6698562
                ],
                [
                    77.2819922,
                    55.669812
                ],
                [
                    77.2798768,
                    55.6701213
                ],
                [
                    77.2794851,
                    55.6706073
                ],
                [
                    77.2785449,
                    55.6705852
                ],
                [
                    77.2780356,
                    55.6710933
                ],
                [
                    77.2764687,
                    55.6713584
                ],
                [
                    77.2761945,
                    55.6725072
                ],
                [
                    77.2749409,
                    55.6730816
                ],
                [
                    77.2656734,
                    55.6740421
                ],
                [
                    77.2647948,
                    55.6748709
                ],
                [
                    77.2643247,
                    55.6753127
                ],
                [
                    77.2641288,
                    55.6759091
                ],
                [
                    77.2660483,
                    55.6760416
                ],
                [
                    77.2660875,
                    55.6771019
                ],
                [
                    77.2662442,
                    55.6784935
                ],
                [
                    77.2659308,
                    55.678891
                ],
                [
                    77.2649123,
                    55.6792444
                ],
                [
                    77.2640896,
                    55.679377
                ]
            ],
            "longitude": 77.278984,
            "latitude": 55.675861
        },
        "3240": {
            "name": "Шипицыно",
            "population": 405,
            "type": "village",
            "poly": [
                [
                    77.2710848,
                    56.0764081
                ],
                [
                    77.2731959,
                    56.0768239
                ],
                [
                    77.2747689,
                    56.0758998
                ],
                [
                    77.2779149,
                    56.0750451
                ],
                [
                    77.2795292,
                    56.0750219
                ],
                [
                    77.2813093,
                    56.0757612
                ],
                [
                    77.2823028,
                    56.0776325
                ],
                [
                    77.2830893,
                    56.078672
                ],
                [
                    77.2820957,
                    56.0805893
                ],
                [
                    77.2838344,
                    56.0806817
                ],
                [
                    77.2848279,
                    56.0801735
                ],
                [
                    77.2872702,
                    56.0800811
                ],
                [
                    77.2890916,
                    56.0797115
                ],
                [
                    77.2912441,
                    56.0796422
                ],
                [
                    77.2921962,
                    56.0788799
                ],
                [
                    77.2971222,
                    56.0766622
                ],
                [
                    77.2992747,
                    56.0764312
                ],
                [
                    77.3011375,
                    56.076616
                ],
                [
                    77.3015513,
                    56.0772167
                ],
                [
                    77.3027519,
                    56.0765467
                ],
                [
                    77.3063119,
                    56.0753223
                ],
                [
                    77.305484,
                    56.0744213
                ],
                [
                    77.3079677,
                    56.0733816
                ],
                [
                    77.3076365,
                    56.070586
                ],
                [
                    77.3049044,
                    56.0700776
                ],
                [
                    77.3034142,
                    56.0690379
                ],
                [
                    77.2986952,
                    56.0688761
                ],
                [
                    77.2959631,
                    56.0698928
                ],
                [
                    77.2913683,
                    56.0700545
                ],
                [
                    77.2908716,
                    56.0703318
                ],
                [
                    77.2880567,
                    56.0702625
                ],
                [
                    77.2830479,
                    56.0711174
                ],
                [
                    77.2777494,
                    56.0725037
                ],
                [
                    77.275514,
                    56.0731275
                ],
                [
                    77.2745205,
                    56.0731044
                ],
                [
                    77.2740238,
                    56.0739592
                ],
                [
                    77.2730717,
                    56.0736358
                ],
                [
                    77.2725336,
                    56.0745137
                ],
                [
                    77.2717471,
                    56.0747216
                ],
                [
                    77.2710848,
                    56.0764081
                ]
            ],
            "longitude": 77.290054,
            "latitude": 56.07473
        },
        "3241": {
            "name": "Таган",
            "population": 480,
            "type": "village",
            "poly": [
                [
                    77.2774367,
                    54.9544845
                ],
                [
                    77.2833367,
                    54.9561785
                ],
                [
                    77.2838493,
                    54.9563969
                ],
                [
                    77.2843065,
                    54.9566193
                ],
                [
                    77.2914593,
                    54.9580116
                ],
                [
                    77.2927477,
                    54.9581911
                ],
                [
                    77.2971169,
                    54.9592877
                ],
                [
                    77.2974806,
                    54.9588469
                ],
                [
                    77.3001477,
                    54.9597285
                ],
                [
                    77.3094826,
                    54.9604478
                ],
                [
                    77.3095635,
                    54.9597982
                ],
                [
                    77.310412,
                    54.9597749
                ],
                [
                    77.310695,
                    54.9592645
                ],
                [
                    77.308432,
                    54.9587076
                ],
                [
                    77.3083915,
                    54.9575707
                ],
                [
                    77.2989757,
                    54.9550182
                ],
                [
                    77.2922271,
                    54.952396
                ],
                [
                    77.285923,
                    54.9517462
                ],
                [
                    77.2851956,
                    54.9534171
                ],
                [
                    77.2863271,
                    54.9538116
                ],
                [
                    77.2858018,
                    54.9543221
                ],
                [
                    77.281599,
                    54.9528601
                ],
                [
                    77.2799826,
                    54.9530458
                ],
                [
                    77.279336,
                    54.9537188
                ],
                [
                    77.2779216,
                    54.9533939
                ],
                [
                    77.2774367,
                    54.9544845
                ]
            ],
            "longitude": 77.292007,
            "latitude": 54.954865
        },
        "3242": {
            "name": "Зятьковка",
            "population": 414,
            "type": "village",
            "poly": [
                [
                    77.3091222,
                    54.2754781
                ],
                [
                    77.312007,
                    54.2761242
                ],
                [
                    77.3112957,
                    54.2770932
                ],
                [
                    77.3139828,
                    54.2780392
                ],
                [
                    77.3182111,
                    54.278616
                ],
                [
                    77.3223208,
                    54.2785468
                ],
                [
                    77.3304219,
                    54.2806693
                ],
                [
                    77.3354801,
                    54.2830917
                ],
                [
                    77.3403012,
                    54.2840375
                ],
                [
                    77.341052,
                    54.282192
                ],
                [
                    77.3360334,
                    54.2810615
                ],
                [
                    77.3374955,
                    54.2784545
                ],
                [
                    77.3326349,
                    54.2771163
                ],
                [
                    77.3300268,
                    54.2778085
                ],
                [
                    77.3114142,
                    54.2725246
                ],
                [
                    77.3091222,
                    54.2754781
                ]
            ],
            "longitude": 77.327522,
            "latitude": 54.278442
        },
        "3243": {
            "name": "Чаинка",
            "population": 533,
            "type": "village",
            "poly": [
                [
                    77.3247693,
                    54.5143678
                ],
                [
                    77.3283473,
                    54.5152106
                ],
                [
                    77.327725,
                    54.5163695
                ],
                [
                    77.3271676,
                    54.5177164
                ],
                [
                    77.3376552,
                    54.5207789
                ],
                [
                    77.3498929,
                    54.523623
                ],
                [
                    77.3510596,
                    54.5220881
                ],
                [
                    77.3540931,
                    54.5229308
                ],
                [
                    77.3564525,
                    54.5195449
                ],
                [
                    77.3381997,
                    54.5133895
                ],
                [
                    77.3318216,
                    54.5113425
                ],
                [
                    77.3301622,
                    54.5125918
                ],
                [
                    77.3264286,
                    54.5117188
                ],
                [
                    77.3247693,
                    54.5143678
                ]
            ],
            "longitude": 77.337463,
            "latitude": 54.517754
        },
        "3244": {
            "name": "Филошенка",
            "population": 157,
            "type": "village",
            "poly": [
                [
                    77.345482,
                    56.2472658
                ],
                [
                    77.3479617,
                    56.2477858
                ],
                [
                    77.3477629,
                    56.2481171
                ],
                [
                    77.3499496,
                    56.2487135
                ],
                [
                    77.3498472,
                    56.2494518
                ],
                [
                    77.3518977,
                    56.2496633
                ],
                [
                    77.3542831,
                    56.250326
                ],
                [
                    77.3546409,
                    56.2506352
                ],
                [
                    77.3560721,
                    56.2509444
                ],
                [
                    77.3573841,
                    56.251607
                ],
                [
                    77.3612186,
                    56.2524125
                ],
                [
                    77.3627116,
                    56.2520046
                ],
                [
                    77.3674246,
                    56.2525627
                ],
                [
                    77.368357,
                    56.2485368
                ],
                [
                    77.3646198,
                    56.2480509
                ],
                [
                    77.3648584,
                    56.2470348
                ],
                [
                    77.3633079,
                    56.2465267
                ],
                [
                    77.3636657,
                    56.2452897
                ],
                [
                    77.3619164,
                    56.2444944
                ],
                [
                    77.3636173,
                    56.241764
                ],
                [
                    77.3611617,
                    56.241073
                ],
                [
                    77.3609225,
                    56.2418655
                ],
                [
                    77.3591334,
                    56.2416887
                ],
                [
                    77.3588551,
                    56.2420201
                ],
                [
                    77.3563504,
                    56.2415783
                ],
                [
                    77.355277,
                    56.242948
                ],
                [
                    77.3505459,
                    56.2420864
                ],
                [
                    77.3491928,
                    56.2424142
                ],
                [
                    77.345482,
                    56.2472658
                ]
            ],
            "longitude": 77.357162,
            "latitude": 56.245991
        },
        "3245": {
            "name": "Яркуль",
            "population": 829,
            "type": "village",
            "poly": [
                [
                    77.3585243,
                    54.630131
                ],
                [
                    77.3605391,
                    54.6312051
                ],
                [
                    77.3595052,
                    54.6330311
                ],
                [
                    77.3630575,
                    54.6358236
                ],
                [
                    77.3682533,
                    54.6382323
                ],
                [
                    77.3692341,
                    54.6383244
                ],
                [
                    77.3707186,
                    54.6390148
                ],
                [
                    77.3732634,
                    54.6393523
                ],
                [
                    77.3792281,
                    54.6427733
                ],
                [
                    77.3811633,
                    54.642804
                ],
                [
                    77.3838406,
                    54.6424051
                ],
                [
                    77.3868628,
                    54.6408711
                ],
                [
                    77.3882413,
                    54.6413159
                ],
                [
                    77.3872604,
                    54.6424358
                ],
                [
                    77.3914489,
                    54.643709
                ],
                [
                    77.3976256,
                    54.6454884
                ],
                [
                    77.3994812,
                    54.6442613
                ],
                [
                    77.3995077,
                    54.643663
                ],
                [
                    77.3965122,
                    54.6423898
                ],
                [
                    77.3884268,
                    54.640104
                ],
                [
                    77.3789365,
                    54.6364373
                ],
                [
                    77.3697908,
                    54.6313432
                ],
                [
                    77.3622092,
                    54.6283049
                ],
                [
                    77.3585243,
                    54.630131
                ]
            ],
            "longitude": 77.373901,
            "latitude": 54.637623
        },
        "3246": {
            "name": "Новониколаевка",
            "population": 446,
            "type": "village",
            "poly": [
                [
                    77.4147731,
                    54.4418988
                ],
                [
                    77.4188487,
                    54.4427644
                ],
                [
                    77.428205,
                    54.4431147
                ],
                [
                    77.4290556,
                    54.4417545
                ],
                [
                    77.4300479,
                    54.441837
                ],
                [
                    77.4295872,
                    54.4433002
                ],
                [
                    77.4372778,
                    54.4444337
                ],
                [
                    77.4375259,
                    54.4423934
                ],
                [
                    77.4384828,
                    54.4417751
                ],
                [
                    77.4433382,
                    54.4419606
                ],
                [
                    77.4435862,
                    54.4403943
                ],
                [
                    77.4391562,
                    54.4397553
                ],
                [
                    77.4397941,
                    54.4379415
                ],
                [
                    77.433521,
                    54.4373438
                ],
                [
                    77.430615,
                    54.4375499
                ],
                [
                    77.4242002,
                    54.4366018
                ],
                [
                    77.4201955,
                    54.4364575
                ],
                [
                    77.4192386,
                    54.4380858
                ],
                [
                    77.4209752,
                    54.4382713
                ],
                [
                    77.420798,
                    54.4397347
                ],
                [
                    77.4203018,
                    54.4406622
                ],
                [
                    77.4158363,
                    54.4402706
                ],
                [
                    77.4147731,
                    54.4418988
                ]
            ],
            "longitude": 77.423798,
            "latitude": 54.440216
        },
        "3247": {
            "name": "Казанка",
            "population": 629,
            "type": "village",
            "poly": [
                [
                    77.4168055,
                    53.9861477
                ],
                [
                    77.4178275,
                    53.9883509
                ],
                [
                    77.4207572,
                    53.989833
                ],
                [
                    77.4213022,
                    53.9895526
                ],
                [
                    77.4260715,
                    53.9912751
                ],
                [
                    77.4326121,
                    53.9875498
                ],
                [
                    77.4337022,
                    53.9878302
                ],
                [
                    77.4345198,
                    53.9873094
                ],
                [
                    77.4334978,
                    53.9867886
                ],
                [
                    77.4367682,
                    53.9846254
                ],
                [
                    77.4359506,
                    53.9841847
                ],
                [
                    77.4391528,
                    53.9810196
                ],
                [
                    77.4377219,
                    53.9803786
                ],
                [
                    77.438744,
                    53.9796173
                ],
                [
                    77.4371769,
                    53.9780547
                ],
                [
                    77.4393572,
                    53.9761314
                ],
                [
                    77.4367682,
                    53.9745286
                ],
                [
                    77.4347923,
                    53.9761715
                ],
                [
                    77.4329528,
                    53.9748892
                ],
                [
                    77.4290693,
                    53.9769729
                ],
                [
                    77.4270253,
                    53.9788561
                ],
                [
                    77.4277065,
                    53.9792968
                ],
                [
                    77.4269572,
                    53.9796173
                ],
                [
                    77.4261396,
                    53.9790163
                ],
                [
                    77.4244363,
                    53.9800981
                ],
                [
                    77.4269572,
                    53.9819812
                ],
                [
                    77.4262077,
                    53.982502
                ],
                [
                    77.4252539,
                    53.9821415
                ],
                [
                    77.4243,
                    53.9827023
                ],
                [
                    77.4228693,
                    53.9826623
                ],
                [
                    77.4208253,
                    53.9817007
                ],
                [
                    77.4196671,
                    53.9825421
                ],
                [
                    77.4206209,
                    53.9829828
                ],
                [
                    77.4194627,
                    53.9834635
                ],
                [
                    77.4200759,
                    53.983744
                ],
                [
                    77.4182363,
                    53.9846254
                ],
                [
                    77.4195989,
                    53.9853465
                ],
                [
                    77.4185088,
                    53.9857471
                ],
                [
                    77.4173506,
                    53.9853465
                ],
                [
                    77.4168055,
                    53.9861477
                ]
            ],
            "longitude": 77.430634,
            "latitude": 53.983753
        },
        "3248": {
            "name": "Погорелка",
            "population": 262,
            "type": "village",
            "poly": [
                [
                    77.4329979,
                    55.4462617
                ],
                [
                    77.4330946,
                    55.4470303
                ],
                [
                    77.4339011,
                    55.4474694
                ],
                [
                    77.4344174,
                    55.4479086
                ],
                [
                    77.4337076,
                    55.4482928
                ],
                [
                    77.4359015,
                    55.4490796
                ],
                [
                    77.4375469,
                    55.4479086
                ],
                [
                    77.4388697,
                    55.4482562
                ],
                [
                    77.4382244,
                    55.44886
                ],
                [
                    77.4400634,
                    55.4494273
                ],
                [
                    77.440386,
                    55.4492626
                ],
                [
                    77.4417409,
                    55.4496834
                ],
                [
                    77.4455803,
                    55.4500677
                ],
                [
                    77.4473547,
                    55.4500494
                ],
                [
                    77.4510649,
                    55.4491894
                ],
                [
                    77.4508714,
                    55.4486954
                ],
                [
                    77.4533232,
                    55.4480001
                ],
                [
                    77.4526781,
                    55.4474694
                ],
                [
                    77.4523554,
                    55.4469388
                ],
                [
                    77.4504519,
                    55.4467192
                ],
                [
                    77.4503552,
                    55.4463715
                ],
                [
                    77.4489356,
                    55.4464447
                ],
                [
                    77.4485806,
                    55.4465911
                ],
                [
                    77.4461933,
                    55.4460604
                ],
                [
                    77.4464514,
                    55.445237
                ],
                [
                    77.4423863,
                    55.4442305
                ],
                [
                    77.441612,
                    55.4444501
                ],
                [
                    77.4410958,
                    55.444871
                ],
                [
                    77.4403215,
                    55.4445599
                ],
                [
                    77.4409345,
                    55.4440658
                ],
                [
                    77.439773,
                    55.4433704
                ],
                [
                    77.4367081,
                    55.4425652
                ],
                [
                    77.4362564,
                    55.4431325
                ],
                [
                    77.437192,
                    55.4439926
                ],
                [
                    77.4402569,
                    55.4450723
                ],
                [
                    77.438418,
                    55.4471766
                ],
                [
                    77.4361273,
                    55.446463
                ],
                [
                    77.4364822,
                    55.4458225
                ],
                [
                    77.4356757,
                    55.4454932
                ],
                [
                    77.4349981,
                    55.4461153
                ],
                [
                    77.4336754,
                    55.4457493
                ],
                [
                    77.4329979,
                    55.4462617
                ]
            ],
            "longitude": 77.442673,
            "latitude": 55.446445
        },
        "3249": {
            "name": "Андреевка",
            "population": 613,
            "type": "village",
            "poly": [
                [
                    77.4329898,
                    53.8371968
                ],
                [
                    77.4337123,
                    53.8378788
                ],
                [
                    77.4343624,
                    53.8374951
                ],
                [
                    77.4384801,
                    53.8403937
                ],
                [
                    77.4368186,
                    53.8409052
                ],
                [
                    77.4403583,
                    53.8438888
                ],
                [
                    77.4364574,
                    53.8460198
                ],
                [
                    77.441153,
                    53.8493439
                ],
                [
                    77.4431757,
                    53.8500257
                ],
                [
                    77.4417309,
                    53.8510911
                ],
                [
                    77.4434647,
                    53.8517303
                ],
                [
                    77.4418032,
                    53.8529661
                ],
                [
                    77.4448373,
                    53.8545427
                ],
                [
                    77.4480159,
                    53.8521564
                ],
                [
                    77.4464988,
                    53.8515598
                ],
                [
                    77.4485215,
                    53.850324
                ],
                [
                    77.4475102,
                    53.8493439
                ],
                [
                    77.4496774,
                    53.8484064
                ],
                [
                    77.4515556,
                    53.8488325
                ],
                [
                    77.4529282,
                    53.848449
                ],
                [
                    77.4544453,
                    53.8493439
                ],
                [
                    77.4560345,
                    53.8484916
                ],
                [
                    77.4555289,
                    53.8467869
                ],
                [
                    77.4561068,
                    53.8464886
                ],
                [
                    77.4570459,
                    53.8471278
                ],
                [
                    77.4582018,
                    53.8465312
                ],
                [
                    77.4575516,
                    53.8423544
                ],
                [
                    77.4519168,
                    53.8374099
                ],
                [
                    77.4509055,
                    53.8377509
                ],
                [
                    77.4487383,
                    53.8354916
                ],
                [
                    77.4462098,
                    53.8357048
                ],
                [
                    77.4436092,
                    53.8335732
                ],
                [
                    77.4389136,
                    53.8357048
                ],
                [
                    77.4347236,
                    53.8331469
                ],
                [
                    77.4334955,
                    53.8336159
                ],
                [
                    77.4359517,
                    53.8357474
                ],
                [
                    77.4329898,
                    53.8371968
                ]
            ],
            "longitude": 77.445992,
            "latitude": 53.843163
        },
        "3250": {
            "name": "Тебисское",
            "population": 721,
            "type": "village",
            "poly": [
                [
                    77.445296,
                    55.3408458
                ],
                [
                    77.4459889,
                    55.3414275
                ],
                [
                    77.4494863,
                    55.3421968
                ],
                [
                    77.4498492,
                    55.3418778
                ],
                [
                    77.4553923,
                    55.3438666
                ],
                [
                    77.462453,
                    55.3454426
                ],
                [
                    77.4631459,
                    55.3444295
                ],
                [
                    77.4641027,
                    55.344467
                ],
                [
                    77.4661484,
                    55.3417277
                ],
                [
                    77.4670722,
                    55.3387818
                ],
                [
                    77.4658184,
                    55.3385941
                ],
                [
                    77.4650926,
                    55.3378811
                ],
                [
                    77.4631459,
                    55.3375808
                ],
                [
                    77.4634099,
                    55.336605
                ],
                [
                    77.4653895,
                    55.3366238
                ],
                [
                    77.4657854,
                    55.3359294
                ],
                [
                    77.4647626,
                    55.3356855
                ],
                [
                    77.4665443,
                    55.3335649
                ],
                [
                    77.4649936,
                    55.3333209
                ],
                [
                    77.4639378,
                    55.3336962
                ],
                [
                    77.4636738,
                    55.3348973
                ],
                [
                    77.4638058,
                    55.3353852
                ],
                [
                    77.4621231,
                    55.3349536
                ],
                [
                    77.4610343,
                    55.3360233
                ],
                [
                    77.4602094,
                    55.3373744
                ],
                [
                    77.4583617,
                    55.3372055
                ],
                [
                    77.4577019,
                    55.3382751
                ],
                [
                    77.4558872,
                    55.3378623
                ],
                [
                    77.4556232,
                    55.3381625
                ],
                [
                    77.4534786,
                    55.3377872
                ],
                [
                    77.4521258,
                    55.3389131
                ],
                [
                    77.4507071,
                    55.3404142
                ],
                [
                    77.4472427,
                    55.3390445
                ],
                [
                    77.445296,
                    55.3408458
                ]
            ],
            "longitude": 77.458611,
            "latitude": 55.340923
        },
        "3251": {
            "name": "Рождественка",
            "population": 355,
            "type": "village",
            "poly": [
                [
                    77.4608934,
                    55.3556972
                ],
                [
                    77.4611958,
                    55.3579611
                ],
                [
                    77.4755124,
                    55.3577605
                ],
                [
                    77.4761677,
                    55.3586774
                ],
                [
                    77.4787891,
                    55.3596517
                ],
                [
                    77.4818137,
                    55.3601675
                ],
                [
                    77.4826707,
                    55.3591932
                ],
                [
                    77.4857457,
                    55.3592219
                ],
                [
                    77.4870564,
                    55.3598236
                ],
                [
                    77.4876613,
                    55.3589067
                ],
                [
                    77.4918453,
                    55.3595657
                ],
                [
                    77.4914421,
                    55.3602821
                ],
                [
                    77.494265,
                    55.3614856
                ],
                [
                    77.495979,
                    55.3604827
                ],
                [
                    77.4942146,
                    55.3595084
                ],
                [
                    77.495122,
                    55.3594511
                ],
                [
                    77.4958782,
                    55.3585342
                ],
                [
                    77.4943659,
                    55.3585915
                ],
                [
                    77.4918958,
                    55.3577032
                ],
                [
                    77.4950716,
                    55.3574739
                ],
                [
                    77.5006043,
                    55.3566671
                ],
                [
                    77.4931056,
                    55.3545795
                ],
                [
                    77.4857457,
                    55.3544363
                ],
                [
                    77.4856449,
                    55.3532613
                ],
                [
                    77.48136,
                    55.3522295
                ],
                [
                    77.4811079,
                    55.3528027
                ],
                [
                    77.4767726,
                    55.3532326
                ],
                [
                    77.4760165,
                    55.3523728
                ],
                [
                    77.4735968,
                    55.3532039
                ],
                [
                    77.4701689,
                    55.3532039
                ],
                [
                    77.4690094,
                    55.3523155
                ],
                [
                    77.4683541,
                    55.3510831
                ],
                [
                    77.4635147,
                    55.3502519
                ],
                [
                    77.4620024,
                    55.3528314
                ],
                [
                    77.4693623,
                    55.3554393
                ],
                [
                    77.4608934,
                    55.3556972
                ]
            ],
            "longitude": 77.47673,
            "latitude": 55.355267
        },
        "3252": {
            "name": "Верх-Тарка",
            "population": 391,
            "type": "village",
            "poly": [
                [
                    77.4777526,
                    56.6158754
                ],
                [
                    77.4785579,
                    56.6166959
                ],
                [
                    77.4807052,
                    56.6180415
                ],
                [
                    77.4830911,
                    56.6174343
                ],
                [
                    77.4840753,
                    56.6170569
                ],
                [
                    77.4845823,
                    56.6175328
                ],
                [
                    77.4839858,
                    56.6182384
                ],
                [
                    77.4875349,
                    56.6194855
                ],
                [
                    77.4866103,
                    56.6214053
                ],
                [
                    77.4852384,
                    56.6229641
                ],
                [
                    77.4855665,
                    56.6237188
                ],
                [
                    77.4868489,
                    56.6239321
                ],
                [
                    77.4966312,
                    56.6243587
                ],
                [
                    77.5002697,
                    56.6267376
                ],
                [
                    77.511722,
                    56.6256876
                ],
                [
                    77.5167325,
                    56.6239157
                ],
                [
                    77.519357,
                    56.6218319
                ],
                [
                    77.521206,
                    56.6206998
                ],
                [
                    77.5200131,
                    56.619584
                ],
                [
                    77.5167623,
                    56.6197316
                ],
                [
                    77.5115431,
                    56.6217991
                ],
                [
                    77.5102308,
                    56.6229476
                ],
                [
                    77.5037292,
                    56.6226687
                ],
                [
                    77.5002398,
                    56.6209131
                ],
                [
                    77.4941558,
                    56.6184517
                ],
                [
                    77.4910839,
                    56.6164497
                ],
                [
                    77.488698,
                    56.6152353
                ],
                [
                    77.4865209,
                    56.614382
                ],
                [
                    77.4848805,
                    56.615104
                ],
                [
                    77.4815701,
                    56.6139389
                ],
                [
                    77.4805859,
                    56.6138568
                ],
                [
                    77.4786175,
                    56.6146774
                ],
                [
                    77.4777526,
                    56.6158754
                ]
            ],
            "longitude": 77.494278,
            "latitude": 56.622429
        },
        "3253": {
            "name": "Тебис",
            "population": 402,
            "type": "village",
            "poly": [
                [
                    77.4953969,
                    55.29846
                ],
                [
                    77.4976075,
                    55.30021
                ],
                [
                    77.4994727,
                    55.2994235
                ],
                [
                    77.4997836,
                    55.2996005
                ],
                [
                    77.5044466,
                    55.3007803
                ],
                [
                    77.5053102,
                    55.3013308
                ],
                [
                    77.5066573,
                    55.3021173
                ],
                [
                    77.5067609,
                    55.303415
                ],
                [
                    77.5073135,
                    55.3038279
                ],
                [
                    77.5061737,
                    55.3053222
                ],
                [
                    77.5071408,
                    55.3056171
                ],
                [
                    77.5080734,
                    55.3051846
                ],
                [
                    77.5100077,
                    55.3064428
                ],
                [
                    77.5084189,
                    55.3076814
                ],
                [
                    77.5068991,
                    55.3072489
                ],
                [
                    77.5053102,
                    55.3079173
                ],
                [
                    77.5059664,
                    55.3091755
                ],
                [
                    77.5085225,
                    55.310414
                ],
                [
                    77.5109748,
                    55.3092935
                ],
                [
                    77.5104913,
                    55.3084088
                ],
                [
                    77.5095242,
                    55.3077797
                ],
                [
                    77.5102841,
                    55.307013
                ],
                [
                    77.5114585,
                    55.3056957
                ],
                [
                    77.5136345,
                    55.3050863
                ],
                [
                    77.5157761,
                    55.3042212
                ],
                [
                    77.5148089,
                    55.3034544
                ],
                [
                    77.515327,
                    55.3028448
                ],
                [
                    77.5129783,
                    55.3016258
                ],
                [
                    77.5113548,
                    55.3010162
                ],
                [
                    77.5058974,
                    55.298342
                ],
                [
                    77.5007853,
                    55.2970441
                ],
                [
                    77.4996454,
                    55.2980667
                ],
                [
                    77.497193,
                    55.2972211
                ],
                [
                    77.4953969,
                    55.29846
                ]
            ],
            "longitude": 77.51017,
            "latitude": 55.301907
        },
        "3254": {
            "name": "Белово",
            "population": 370,
            "type": "village",
            "poly": [
                [
                    77.4953892,
                    55.0395373
                ],
                [
                    77.4959491,
                    55.039794
                ],
                [
                    77.4955012,
                    55.0402003
                ],
                [
                    77.4962104,
                    55.0404356
                ],
                [
                    77.4966957,
                    55.0400292
                ],
                [
                    77.4992712,
                    55.0409061
                ],
                [
                    77.503265,
                    55.0415905
                ],
                [
                    77.5024812,
                    55.0422108
                ],
                [
                    77.5022199,
                    55.0426599
                ],
                [
                    77.5051687,
                    55.0431946
                ],
                [
                    77.5049448,
                    55.04405
                ],
                [
                    77.5057286,
                    55.0446274
                ],
                [
                    77.5093866,
                    55.0459105
                ],
                [
                    77.5097972,
                    55.045547
                ],
                [
                    77.510357,
                    55.0456325
                ],
                [
                    77.510357,
                    55.0461886
                ],
                [
                    77.5121488,
                    55.0471722
                ],
                [
                    77.5135672,
                    55.047215
                ],
                [
                    77.5150601,
                    55.0467873
                ],
                [
                    77.5202112,
                    55.0477496
                ],
                [
                    77.5202112,
                    55.0481131
                ],
                [
                    77.5212937,
                    55.0482842
                ],
                [
                    77.5240185,
                    55.0481773
                ],
                [
                    77.5225628,
                    55.0507219
                ],
                [
                    77.5243171,
                    55.051064
                ],
                [
                    77.5252129,
                    55.0497169
                ],
                [
                    77.5266314,
                    55.0505936
                ],
                [
                    77.5281991,
                    55.0510212
                ],
                [
                    77.528535,
                    55.0505081
                ],
                [
                    77.5301774,
                    55.0509357
                ],
                [
                    77.530588,
                    55.0504867
                ],
                [
                    77.5326409,
                    55.0504867
                ],
                [
                    77.5329395,
                    55.050059
                ],
                [
                    77.5325289,
                    55.0490113
                ],
                [
                    77.5301027,
                    55.0462527
                ],
                [
                    77.5203232,
                    55.0442211
                ],
                [
                    77.5151349,
                    55.0428524
                ],
                [
                    77.5137538,
                    55.0423605
                ],
                [
                    77.5122981,
                    55.0423391
                ],
                [
                    77.50864,
                    55.04112
                ],
                [
                    77.5007269,
                    55.0392379
                ],
                [
                    77.498562,
                    55.0384893
                ],
                [
                    77.4974049,
                    55.0379118
                ],
                [
                    77.4965463,
                    55.0379545
                ],
                [
                    77.4953892,
                    55.0395373
                ]
            ],
            "longitude": 77.517822,
            "latitude": 55.04546
        },
        "3255": {
            "name": "Студёное",
            "population": 986,
            "type": "village",
            "poly": [
                [
                    77.5124146,
                    53.6116459
                ],
                [
                    77.5124146,
                    53.6139469
                ],
                [
                    77.5133843,
                    53.613883
                ],
                [
                    77.5132766,
                    53.6156086
                ],
                [
                    77.5202798,
                    53.6162477
                ],
                [
                    77.5260979,
                    53.6165993
                ],
                [
                    77.5301382,
                    53.6165353
                ],
                [
                    77.5334242,
                    53.6165673
                ],
                [
                    77.5402659,
                    53.6156086
                ],
                [
                    77.5403198,
                    53.6162477
                ],
                [
                    77.5389192,
                    53.6164395
                ],
                [
                    77.5395505,
                    53.617486
                ],
                [
                    77.5483887,
                    53.615676
                ],
                [
                    77.54902,
                    53.6153016
                ],
                [
                    77.5483887,
                    53.6145526
                ],
                [
                    77.5472313,
                    53.6145526
                ],
                [
                    77.5467052,
                    53.6123679
                ],
                [
                    77.5451682,
                    53.6102396
                ],
                [
                    77.5418282,
                    53.6096963
                ],
                [
                    77.536064,
                    53.6105912
                ],
                [
                    77.5350943,
                    53.6103675
                ],
                [
                    77.5318082,
                    53.6105912
                ],
                [
                    77.5249666,
                    53.6118057
                ],
                [
                    77.5166166,
                    53.6117737
                ],
                [
                    77.5124146,
                    53.6116459
                ]
            ],
            "longitude": 77.531433,
            "latitude": 53.613796
        },
        "3256": {
            "name": "Минино",
            "population": 392,
            "type": "village",
            "poly": [
                [
                    77.5206642,
                    56.1709541
                ],
                [
                    77.5238949,
                    56.1721662
                ],
                [
                    77.5303665,
                    56.173843
                ],
                [
                    77.5335602,
                    56.1730814
                ],
                [
                    77.5358253,
                    56.173705
                ],
                [
                    77.5376076,
                    56.1750309
                ],
                [
                    77.5378147,
                    56.1761781
                ],
                [
                    77.545679,
                    56.1748306
                ],
                [
                    77.5483262,
                    56.174712
                ],
                [
                    77.548438,
                    56.1742022
                ],
                [
                    77.5440191,
                    56.1733982
                ],
                [
                    77.5469865,
                    56.1721888
                ],
                [
                    77.5441102,
                    56.1704071
                ],
                [
                    77.5425509,
                    56.1706152
                ],
                [
                    77.5418028,
                    56.1714979
                ],
                [
                    77.5389247,
                    56.1711513
                ],
                [
                    77.5379524,
                    56.1716249
                ],
                [
                    77.5353597,
                    56.1712641
                ],
                [
                    77.5329694,
                    56.169753
                ],
                [
                    77.5339417,
                    56.1688959
                ],
                [
                    77.5323213,
                    56.1688057
                ],
                [
                    77.5324023,
                    56.167926
                ],
                [
                    77.5302957,
                    56.1675877
                ],
                [
                    77.530012,
                    56.168535
                ],
                [
                    77.5278245,
                    56.1683546
                ],
                [
                    77.5276219,
                    56.1674524
                ],
                [
                    77.5242595,
                    56.1672719
                ],
                [
                    77.5239759,
                    56.1680839
                ],
                [
                    77.5213387,
                    56.1674968
                ],
                [
                    77.5206642,
                    56.1709541
                ]
            ],
            "longitude": 77.534836,
            "latitude": 56.171734
        },
        "3257": {
            "name": "Вознесенка",
            "population": 727,
            "type": "village",
            "poly": [
                [
                    77.5204885,
                    54.1366917
                ],
                [
                    77.5245438,
                    54.1375181
                ],
                [
                    77.5235741,
                    54.1388092
                ],
                [
                    77.5255136,
                    54.1391708
                ],
                [
                    77.52904,
                    54.14103
                ],
                [
                    77.5367981,
                    54.1421661
                ],
                [
                    77.5451733,
                    54.1435088
                ],
                [
                    77.5610421,
                    54.1479496
                ],
                [
                    77.5688884,
                    54.1502731
                ],
                [
                    77.5699463,
                    54.1490339
                ],
                [
                    77.562629,
                    54.1463489
                ],
                [
                    77.5639513,
                    54.1446449
                ],
                [
                    77.5464957,
                    54.1394806
                ],
                [
                    77.5359165,
                    54.1379312
                ],
                [
                    77.521899,
                    54.1346773
                ],
                [
                    77.5204885,
                    54.1366917
                ]
            ],
            "longitude": 77.547646,
            "latitude": 54.14222
        },
        "3258": {
            "name": "Кузнецовка",
            "population": 542,
            "type": "village",
            "poly": [
                [
                    77.5391993,
                    53.9059986
                ],
                [
                    77.5464571,
                    53.9105305
                ],
                [
                    77.5503763,
                    53.9133521
                ],
                [
                    77.5504052,
                    53.9138786
                ],
                [
                    77.5570534,
                    53.9163444
                ],
                [
                    77.5631499,
                    53.9133521
                ],
                [
                    77.5680852,
                    53.914891
                ],
                [
                    77.5696819,
                    53.913694
                ],
                [
                    77.5628596,
                    53.9103595
                ],
                [
                    77.5602468,
                    53.9113001
                ],
                [
                    77.5432636,
                    53.9037752
                ],
                [
                    77.5391993,
                    53.9059986
                ]
            ],
            "longitude": 77.552986,
            "latitude": 53.911385
        },
        "3259": {
            "name": "Рождественка",
            "population": 667,
            "type": "village",
            "poly": [
                [
                    77.541048,
                    54.2872222
                ],
                [
                    77.5437637,
                    54.2878988
                ],
                [
                    77.5425051,
                    54.2888654
                ],
                [
                    77.5439625,
                    54.2895226
                ],
                [
                    77.5514987,
                    54.2912668
                ],
                [
                    77.558866,
                    54.2933887
                ],
                [
                    77.5645293,
                    54.2950123
                ],
                [
                    77.5676424,
                    54.2957468
                ],
                [
                    77.5704243,
                    54.2954182
                ],
                [
                    77.5723453,
                    54.2914557
                ],
                [
                    77.568669,
                    54.2907985
                ],
                [
                    77.5697289,
                    54.2881888
                ],
                [
                    77.576982,
                    54.2903345
                ],
                [
                    77.5858909,
                    54.2920356
                ],
                [
                    77.5880437,
                    54.289252
                ],
                [
                    77.5791677,
                    54.2862749
                ],
                [
                    77.5754254,
                    54.2850182
                ],
                [
                    77.5716829,
                    54.2845736
                ],
                [
                    77.5707887,
                    54.2857142
                ],
                [
                    77.5690334,
                    54.2851149
                ],
                [
                    77.5693646,
                    54.2843029
                ],
                [
                    77.5683048,
                    54.2834909
                ],
                [
                    77.5630948,
                    54.2824078
                ],
                [
                    77.5530038,
                    54.2791985
                ],
                [
                    77.5496589,
                    54.2825048
                ],
                [
                    77.5514473,
                    54.2834522
                ],
                [
                    77.5595283,
                    54.2856369
                ],
                [
                    77.5591309,
                    54.2863522
                ],
                [
                    77.5621447,
                    54.2869902
                ],
                [
                    77.5594621,
                    54.2891167
                ],
                [
                    77.5551285,
                    54.2879882
                ],
                [
                    77.543565,
                    54.2854242
                ],
                [
                    77.5422734,
                    54.2856755
                ],
                [
                    77.541048,
                    54.2872222
                ]
            ],
            "longitude": 77.563797,
            "latitude": 54.288879
        },
        "3260": {
            "name": "Петрушино",
            "population": 284,
            "type": "village",
            "poly": [
                [
                    77.5548835,
                    53.8458201
                ],
                [
                    77.5593648,
                    53.8461552
                ],
                [
                    77.5602484,
                    53.8452243
                ],
                [
                    77.5587967,
                    53.8448147
                ],
                [
                    77.5590492,
                    53.8430273
                ],
                [
                    77.5604378,
                    53.8432507
                ],
                [
                    77.5620788,
                    53.8400853
                ],
                [
                    77.5630887,
                    53.8400853
                ],
                [
                    77.5635936,
                    53.8391542
                ],
                [
                    77.5664339,
                    53.842059
                ],
                [
                    77.5683905,
                    53.8428411
                ],
                [
                    77.5672544,
                    53.843772
                ],
                [
                    77.5679487,
                    53.8441072
                ],
                [
                    77.5712939,
                    53.8436976
                ],
                [
                    77.5724931,
                    53.8426921
                ],
                [
                    77.5738185,
                    53.8425059
                ],
                [
                    77.5749546,
                    53.8427294
                ],
                [
                    77.5748284,
                    53.8444051
                ],
                [
                    77.5839172,
                    53.8441817
                ],
                [
                    77.5842328,
                    53.8398618
                ],
                [
                    77.5836647,
                    53.8397129
                ],
                [
                    77.5845484,
                    53.836212
                ],
                [
                    77.5839172,
                    53.8359885
                ],
                [
                    77.5834754,
                    53.834089
                ],
                [
                    77.5828443,
                    53.834089
                ],
                [
                    77.58215,
                    53.8325991
                ],
                [
                    77.5807614,
                    53.8329343
                ],
                [
                    77.5807614,
                    53.8336792
                ],
                [
                    77.5753965,
                    53.8334558
                ],
                [
                    77.5750809,
                    53.83394
                ],
                [
                    77.5712307,
                    53.8340145
                ],
                [
                    77.5712307,
                    53.8335675
                ],
                [
                    77.5683905,
                    53.8335675
                ],
                [
                    77.5665601,
                    53.8341262
                ],
                [
                    77.5638461,
                    53.8367334
                ],
                [
                    77.5628993,
                    53.8365844
                ],
                [
                    77.5647297,
                    53.8335303
                ],
                [
                    77.5657396,
                    53.8309229
                ],
                [
                    77.5651084,
                    53.8299916
                ],
                [
                    77.562205,
                    53.8290976
                ],
                [
                    77.5609427,
                    53.832897
                ],
                [
                    77.5617001,
                    53.8330833
                ],
                [
                    77.560564,
                    53.8366217
                ],
                [
                    77.559491,
                    53.8363237
                ],
                [
                    77.5589861,
                    53.8371803
                ],
                [
                    77.5605008,
                    53.8375155
                ],
                [
                    77.5596172,
                    53.8387818
                ],
                [
                    77.5577868,
                    53.8384466
                ],
                [
                    77.557345,
                    53.8391542
                ],
                [
                    77.5579762,
                    53.8394894
                ],
                [
                    77.5572188,
                    53.8417239
                ],
                [
                    77.5583549,
                    53.8419473
                ],
                [
                    77.5576606,
                    53.8428038
                ],
                [
                    77.5548835,
                    53.8458201
                ]
            ],
            "longitude": 77.572243,
            "latitude": 53.838558
        },
        "3261": {
            "name": "Шаитик",
            "population": 335,
            "type": "village",
            "poly": [
                [
                    77.5717176,
                    54.6472045
                ],
                [
                    77.5760129,
                    54.6483463
                ],
                [
                    77.5777832,
                    54.6482792
                ],
                [
                    77.5837619,
                    54.6499584
                ],
                [
                    77.5948775,
                    54.6514192
                ],
                [
                    77.5960094,
                    54.6496561
                ],
                [
                    77.5891891,
                    54.6480609
                ],
                [
                    77.5891311,
                    54.6476914
                ],
                [
                    77.5802212,
                    54.6451893
                ],
                [
                    77.5797278,
                    54.6456763
                ],
                [
                    77.5772609,
                    54.6450717
                ],
                [
                    77.5755776,
                    54.6475067
                ],
                [
                    77.5720078,
                    54.6467846
                ],
                [
                    77.5717176,
                    54.6472045
                ]
            ],
            "longitude": 77.584572,
            "latitude": 54.648167
        },
        "3262": {
            "name": "Новоичинское",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 77.622528,
            "latitude": 55.662266
        },
        "3263": {
            "name": "Лозовское",
            "population": 307,
            "type": "village",
            "poly": [
                [
                    77.6199212,
                    54.1050513
                ],
                [
                    77.6260997,
                    54.1060223
                ],
                [
                    77.6280105,
                    54.1047152
                ],
                [
                    77.6287749,
                    54.1028853
                ],
                [
                    77.6308131,
                    54.1005697
                ],
                [
                    77.6298577,
                    54.1003083
                ],
                [
                    77.6310679,
                    54.0985529
                ],
                [
                    77.6317686,
                    54.0985529
                ],
                [
                    77.6325966,
                    54.0973576
                ],
                [
                    77.6310679,
                    54.0962371
                ],
                [
                    77.6247621,
                    54.0949297
                ],
                [
                    77.623934,
                    54.0970215
                ],
                [
                    77.6232334,
                    54.0968347
                ],
                [
                    77.6217684,
                    54.0991131
                ],
                [
                    77.620813,
                    54.0992252
                ],
                [
                    77.6199212,
                    54.1050513
                ]
            ],
            "longitude": 77.625778,
            "latitude": 54.100494
        },
        "3264": {
            "name": "Копкуль",
            "population": 675,
            "type": "village",
            "poly": [
                [
                    77.6206942,
                    54.3867536
                ],
                [
                    77.6239864,
                    54.3876783
                ],
                [
                    77.6249547,
                    54.3885127
                ],
                [
                    77.627937,
                    54.3906777
                ],
                [
                    77.627511,
                    54.3918955
                ],
                [
                    77.6284018,
                    54.3930456
                ],
                [
                    77.6303384,
                    54.3942407
                ],
                [
                    77.6285954,
                    54.3952104
                ],
                [
                    77.6302222,
                    54.3962251
                ],
                [
                    77.6319651,
                    54.3953908
                ],
                [
                    77.6336305,
                    54.3962025
                ],
                [
                    77.6347925,
                    54.3955711
                ],
                [
                    77.6410281,
                    54.4004414
                ],
                [
                    77.6438169,
                    54.4019069
                ],
                [
                    77.6458309,
                    54.4019745
                ],
                [
                    77.6483872,
                    54.4006218
                ],
                [
                    77.6481935,
                    54.3999679
                ],
                [
                    77.6431972,
                    54.3963378
                ],
                [
                    77.6442042,
                    54.3960898
                ],
                [
                    77.6445915,
                    54.3940152
                ],
                [
                    77.6415317,
                    54.3909258
                ],
                [
                    77.6338242,
                    54.3876557
                ],
                [
                    77.6234829,
                    54.3840696
                ],
                [
                    77.6207717,
                    54.3857838
                ],
                [
                    77.6206942,
                    54.3867536
                ]
            ],
            "longitude": 77.636642,
            "latitude": 54.391872
        },
        "3265": {
            "name": "Поповка",
            "population": 803,
            "type": "village",
            "poly": [
                [
                    77.644022,
                    53.736451
                ],
                [
                    77.644022,
                    53.7372286
                ],
                [
                    77.6455995,
                    53.7369434
                ],
                [
                    77.6455557,
                    53.7392243
                ],
                [
                    77.6456433,
                    53.7403128
                ],
                [
                    77.645249,
                    53.7409089
                ],
                [
                    77.64595,
                    53.7419715
                ],
                [
                    77.6473523,
                    53.7431118
                ],
                [
                    77.6490175,
                    53.7430081
                ],
                [
                    77.6499815,
                    53.7426453
                ],
                [
                    77.6498939,
                    53.7422825
                ],
                [
                    77.6506827,
                    53.7423862
                ],
                [
                    77.6509018,
                    53.7433969
                ],
                [
                    77.6512546,
                    53.7435476
                ],
                [
                    77.6560688,
                    53.7431522
                ],
                [
                    77.6574061,
                    53.7422031
                ],
                [
                    77.6570049,
                    53.7414122
                ],
                [
                    77.6563363,
                    53.7414913
                ],
                [
                    77.6552665,
                    53.7399886
                ],
                [
                    77.6568712,
                    53.7392767
                ],
                [
                    77.6562026,
                    53.7388021
                ],
                [
                    77.6537954,
                    53.7382484
                ],
                [
                    77.6527256,
                    53.7322366
                ],
                [
                    77.6491149,
                    53.7321575
                ],
                [
                    77.6495161,
                    53.7292304
                ],
                [
                    77.650051,
                    53.7279646
                ],
                [
                    77.6528593,
                    53.7280437
                ],
                [
                    77.6532605,
                    53.7258283
                ],
                [
                    77.6517895,
                    53.7256701
                ],
                [
                    77.6510332,
                    53.7273522
                ],
                [
                    77.6506389,
                    53.7273781
                ],
                [
                    77.6503321,
                    53.7257966
                ],
                [
                    77.6484478,
                    53.726004
                ],
                [
                    77.6477905,
                    53.7250707
                ],
                [
                    77.6468265,
                    53.7250707
                ],
                [
                    77.6466949,
                    53.7279744
                ],
                [
                    77.6470018,
                    53.7291928
                ],
                [
                    77.6457748,
                    53.7338589
                ],
                [
                    77.6464321,
                    53.7349217
                ],
                [
                    77.6452928,
                    53.7349476
                ],
                [
                    77.644022,
                    53.736451
                ]
            ],
            "longitude": 77.649765,
            "latitude": 53.738373
        },
        "3266": {
            "name": "Казанцево",
            "population": 458,
            "type": "village",
            "poly": [
                [
                    77.6646653,
                    55.0732463
                ],
                [
                    77.6684247,
                    55.0740822
                ],
                [
                    77.6688262,
                    55.0744793
                ],
                [
                    77.6714907,
                    55.0749181
                ],
                [
                    77.6717462,
                    55.0755032
                ],
                [
                    77.6753231,
                    55.0774464
                ],
                [
                    77.6768561,
                    55.076527
                ],
                [
                    77.6816376,
                    55.0783658
                ],
                [
                    77.687879,
                    55.0798702
                ],
                [
                    77.6900325,
                    55.0803716
                ],
                [
                    77.6937918,
                    55.0797657
                ],
                [
                    77.6963834,
                    55.0801209
                ],
                [
                    77.6968579,
                    55.0795568
                ],
                [
                    77.6973689,
                    55.0795568
                ],
                [
                    77.6984274,
                    55.0782195
                ],
                [
                    77.6976244,
                    55.0778434
                ],
                [
                    77.6978799,
                    55.0776554
                ],
                [
                    77.6973323,
                    55.0770076
                ],
                [
                    77.6954709,
                    55.0768823
                ],
                [
                    77.6949599,
                    55.0762972
                ],
                [
                    77.6939379,
                    55.0760465
                ],
                [
                    77.6933539,
                    55.0762345
                ],
                [
                    77.689047,
                    55.075336
                ],
                [
                    77.6850685,
                    55.0746673
                ],
                [
                    77.6789366,
                    55.0725567
                ],
                [
                    77.6775861,
                    55.0726194
                ],
                [
                    77.6744472,
                    55.0713447
                ],
                [
                    77.6729141,
                    55.0705505
                ],
                [
                    77.6708337,
                    55.0705505
                ],
                [
                    77.6702132,
                    55.0700699
                ],
                [
                    77.6669648,
                    55.0694429
                ],
                [
                    77.6646653,
                    55.0732463
                ]
            ],
            "longitude": 77.681488,
            "latitude": 55.075672
        },
        "3267": {
            "name": "Кама",
            "population": 560,
            "type": "village",
            "poly": null,
            "longitude": 77.714478,
            "latitude": 55.876114
        },
        "3268": {
            "name": "Межовка",
            "population": 356,
            "type": "village",
            "poly": [
                [
                    77.719672,
                    56.6535346
                ],
                [
                    77.7219886,
                    56.6563229
                ],
                [
                    77.7240655,
                    56.6563887
                ],
                [
                    77.7244649,
                    56.6547202
                ],
                [
                    77.728459,
                    56.653842
                ],
                [
                    77.7298969,
                    56.6526783
                ],
                [
                    77.7323332,
                    56.6532931
                ],
                [
                    77.7316942,
                    56.6544348
                ],
                [
                    77.7343702,
                    56.6561911
                ],
                [
                    77.737246,
                    56.6554227
                ],
                [
                    77.7415596,
                    56.6536224
                ],
                [
                    77.7404812,
                    56.6505266
                ],
                [
                    77.7329324,
                    56.6511633
                ],
                [
                    77.7337311,
                    56.6499557
                ],
                [
                    77.7354086,
                    56.6502192
                ],
                [
                    77.7416395,
                    56.6479795
                ],
                [
                    77.7412001,
                    56.6458055
                ],
                [
                    77.7417593,
                    56.6441365
                ],
                [
                    77.7444753,
                    56.6418744
                ],
                [
                    77.7459131,
                    56.6408642
                ],
                [
                    77.7447947,
                    56.6381407
                ],
                [
                    77.7383244,
                    56.6378771
                ],
                [
                    77.7357682,
                    56.6412156
                ],
                [
                    77.7352489,
                    56.6433898
                ],
                [
                    77.7334117,
                    56.6442463
                ],
                [
                    77.7329324,
                    56.6451028
                ],
                [
                    77.7327327,
                    56.647716
                ],
                [
                    77.7326128,
                    56.6486382
                ],
                [
                    77.7270611,
                    56.650329
                ],
                [
                    77.719672,
                    56.6535346
                ]
            ],
            "longitude": 77.738838,
            "latitude": 56.643597
        },
        "3269": {
            "name": "Мироновка",
            "population": 782,
            "type": "village",
            "poly": [
                [
                    77.7292537,
                    53.8436127
                ],
                [
                    77.7303646,
                    53.843851
                ],
                [
                    77.7314248,
                    53.8437616
                ],
                [
                    77.7327883,
                    53.8441191
                ],
                [
                    77.7322833,
                    53.8459958
                ],
                [
                    77.7352625,
                    53.8471278
                ],
                [
                    77.7365248,
                    53.8474853
                ],
                [
                    77.7406148,
                    53.8475151
                ],
                [
                    77.7409682,
                    53.8469491
                ],
                [
                    77.7416168,
                    53.8470065
                ],
                [
                    77.742988,
                    53.8471278
                ],
                [
                    77.7433414,
                    53.8466214
                ],
                [
                    77.7453107,
                    53.8470384
                ],
                [
                    77.7451592,
                    53.8474555
                ],
                [
                    77.7488075,
                    53.8482559
                ],
                [
                    77.7512689,
                    53.8487959
                ],
                [
                    77.7520768,
                    53.8478129
                ],
                [
                    77.7531372,
                    53.8481108
                ],
                [
                    77.7535915,
                    53.8477236
                ],
                [
                    77.7597013,
                    53.8495406
                ],
                [
                    77.7608614,
                    53.8480986
                ],
                [
                    77.7611151,
                    53.8477831
                ],
                [
                    77.7628824,
                    53.846532
                ],
                [
                    77.7618726,
                    53.8457873
                ],
                [
                    77.762024,
                    53.8454298
                ],
                [
                    77.762529,
                    53.8454298
                ],
                [
                    77.7638418,
                    53.8437318
                ],
                [
                    77.7589439,
                    53.8420635
                ],
                [
                    77.7565707,
                    53.8442085
                ],
                [
                    77.731223,
                    53.8384287
                ],
                [
                    77.7295567,
                    53.8411697
                ],
                [
                    77.7305161,
                    53.8415272
                ],
                [
                    77.7292537,
                    53.8436127
                ]
            ],
            "longitude": 77.747231,
            "latitude": 53.844803
        },
        "3270": {
            "name": "Стретинка",
            "population": 181,
            "type": "village",
            "poly": [
                [
                    77.742702,
                    54.0415941
                ],
                [
                    77.7458319,
                    54.0458907
                ],
                [
                    77.7446475,
                    54.0458658
                ],
                [
                    77.7445207,
                    54.0462383
                ],
                [
                    77.7455358,
                    54.0510807
                ],
                [
                    77.7470586,
                    54.050882
                ],
                [
                    77.7466356,
                    54.0542341
                ],
                [
                    77.7440555,
                    54.0543582
                ],
                [
                    77.7439708,
                    54.0558231
                ],
                [
                    77.7444784,
                    54.0564438
                ],
                [
                    77.7471009,
                    54.0561707
                ],
                [
                    77.7473123,
                    54.0571638
                ],
                [
                    77.7528109,
                    54.056568
                ],
                [
                    77.7531915,
                    54.0560466
                ],
                [
                    77.7518381,
                    54.0545569
                ],
                [
                    77.7508653,
                    54.0529678
                ],
                [
                    77.7512883,
                    54.0519746
                ],
                [
                    77.7513305,
                    54.0503109
                ],
                [
                    77.7517535,
                    54.0491438
                ],
                [
                    77.7509499,
                    54.0459403
                ],
                [
                    77.7503577,
                    54.0454188
                ],
                [
                    77.748116,
                    54.0421902
                ],
                [
                    77.745705,
                    54.0414948
                ],
                [
                    77.7435056,
                    54.0415196
                ],
                [
                    77.742702,
                    54.0415941
                ]
            ],
            "longitude": 77.7484121,
            "latitude": 54.0496653
        },
        "3271": {
            "name": "Вороновка",
            "population": 277,
            "type": "village",
            "poly": [
                [
                    77.7364644,
                    54.3436728
                ],
                [
                    77.749207,
                    54.3465626
                ],
                [
                    77.7492843,
                    54.346224
                ],
                [
                    77.7521118,
                    54.3466981
                ],
                [
                    77.7584638,
                    54.3502423
                ],
                [
                    77.7595483,
                    54.3519353
                ],
                [
                    77.7602842,
                    54.3503552
                ],
                [
                    77.762182,
                    54.3506938
                ],
                [
                    77.7631503,
                    54.3467658
                ],
                [
                    77.7550167,
                    54.3441244
                ],
                [
                    77.7509886,
                    54.3428826
                ],
                [
                    77.7471155,
                    54.3419117
                ],
                [
                    77.7385558,
                    54.3403764
                ],
                [
                    77.7364644,
                    54.3436728
                ]
            ],
            "longitude": 77.751717,
            "latitude": 54.345104
        },
        "3272": {
            "name": "Павловка",
            "population": 313,
            "type": "village",
            "poly": [
                [
                    77.751035,
                    53.4301061
                ],
                [
                    77.7536021,
                    53.4390217
                ],
                [
                    77.7543667,
                    53.4392169
                ],
                [
                    77.7598832,
                    53.4378178
                ],
                [
                    77.7610301,
                    53.4344665
                ],
                [
                    77.7626688,
                    53.4338808
                ],
                [
                    77.7635427,
                    53.4330999
                ],
                [
                    77.7630511,
                    53.4301061
                ],
                [
                    77.7613033,
                    53.4280234
                ],
                [
                    77.7591732,
                    53.4284465
                ],
                [
                    77.759337,
                    53.4291299
                ],
                [
                    77.7565515,
                    53.4293577
                ],
                [
                    77.7565515,
                    53.4288695
                ],
                [
                    77.7530559,
                    53.4289997
                ],
                [
                    77.7534929,
                    53.429976
                ],
                [
                    77.751035,
                    53.4301061
                ]
            ],
            "longitude": 77.757042,
            "latitude": 53.432838
        },
        "3273": {
            "name": "Астродым",
            "population": 350,
            "type": "village",
            "poly": null,
            "longitude": 77.76664,
            "latitude": 53.644268
        },
        "3274": {
            "name": "Новорозино",
            "population": 290,
            "type": "village",
            "poly": [
                [
                    77.7718299,
                    54.6490869
                ],
                [
                    77.786192,
                    54.6522287
                ],
                [
                    77.7893079,
                    54.6535506
                ],
                [
                    77.7909102,
                    54.6519368
                ],
                [
                    77.7930468,
                    54.6505291
                ],
                [
                    77.7919785,
                    54.649911
                ],
                [
                    77.7863701,
                    54.648383
                ],
                [
                    77.7736104,
                    54.6444339
                ],
                [
                    77.7728092,
                    54.6451894
                ],
                [
                    77.7738478,
                    54.646769
                ],
                [
                    77.7718299,
                    54.6490869
                ]
            ],
            "longitude": 77.781166,
            "latitude": 54.649052
        },
        "3275": {
            "name": "Тычкино",
            "population": 295,
            "type": "village",
            "poly": [
                [
                    77.7786691,
                    54.1047255
                ],
                [
                    77.7796605,
                    54.1074378
                ],
                [
                    77.7807179,
                    54.1079802
                ],
                [
                    77.7818414,
                    54.1077865
                ],
                [
                    77.7827005,
                    54.1091038
                ],
                [
                    77.7840223,
                    54.1090651
                ],
                [
                    77.7840884,
                    54.1110797
                ],
                [
                    77.7871285,
                    54.1115446
                ],
                [
                    77.7867981,
                    54.1127069
                ],
                [
                    77.789706,
                    54.1134042
                ],
                [
                    77.7914904,
                    54.1115834
                ],
                [
                    77.7893095,
                    54.1108085
                ],
                [
                    77.7905651,
                    54.1093363
                ],
                [
                    77.7910939,
                    54.1082514
                ],
                [
                    77.7862694,
                    54.1042217
                ],
                [
                    77.7881859,
                    54.1034467
                ],
                [
                    77.787459,
                    54.1027492
                ],
                [
                    77.7887147,
                    54.101703
                ],
                [
                    77.7894416,
                    54.1025167
                ],
                [
                    77.7912921,
                    54.103253
                ],
                [
                    77.7931426,
                    54.1028267
                ],
                [
                    77.7943322,
                    54.1031367
                ],
                [
                    77.7947288,
                    54.1006179
                ],
                [
                    77.7911599,
                    54.0998816
                ],
                [
                    77.7891111,
                    54.1008504
                ],
                [
                    77.787459,
                    54.1006954
                ],
                [
                    77.7852118,
                    54.101703
                ],
                [
                    77.7793961,
                    54.103873
                ],
                [
                    77.7786691,
                    54.1047255
                ]
            ],
            "longitude": 77.78521,
            "latitude": 54.107166
        },
        "3276": {
            "name": "Омь",
            "population": 290,
            "type": "village",
            "poly": [
                [
                    77.780022,
                    55.4244405
                ],
                [
                    77.781319,
                    55.4246245
                ],
                [
                    77.781319,
                    55.4257408
                ],
                [
                    77.7820971,
                    55.4258266
                ],
                [
                    77.7820755,
                    55.426305
                ],
                [
                    77.7863555,
                    55.4265994
                ],
                [
                    77.7864203,
                    55.4263786
                ],
                [
                    77.7874795,
                    55.4259493
                ],
                [
                    77.7883009,
                    55.4260597
                ],
                [
                    77.7883009,
                    55.4271269
                ],
                [
                    77.7902248,
                    55.4275317
                ],
                [
                    77.791284,
                    55.4269797
                ],
                [
                    77.7925592,
                    55.4259616
                ],
                [
                    77.7907436,
                    55.4251397
                ],
                [
                    77.7913272,
                    55.4246613
                ],
                [
                    77.7919541,
                    55.4238885
                ],
                [
                    77.7919108,
                    55.4233242
                ],
                [
                    77.7886468,
                    55.4230666
                ],
                [
                    77.7879119,
                    55.4232138
                ],
                [
                    77.7870688,
                    55.4225513
                ],
                [
                    77.7816648,
                    55.422122
                ],
                [
                    77.7806272,
                    55.4241093
                ],
                [
                    77.780022,
                    55.4244405
                ]
            ],
            "longitude": 77.786224,
            "latitude": 55.424648
        },
        "3277": {
            "name": "Чумашки",
            "population": 515,
            "type": "village",
            "poly": [
                [
                    77.7745187,
                    54.4665619
                ],
                [
                    77.7847277,
                    54.4695284
                ],
                [
                    77.80019,
                    54.4728115
                ],
                [
                    77.8009354,
                    54.471513
                ],
                [
                    77.7955315,
                    54.4678004
                ],
                [
                    77.7822003,
                    54.4626446
                ],
                [
                    77.7771453,
                    54.4642577
                ],
                [
                    77.7745187,
                    54.4665619
                ]
            ],
            "longitude": 77.791283,
            "latitude": 54.468666
        },
        "3278": {
            "name": "Булатово",
            "population": 487,
            "type": "village",
            "poly": null,
            "longitude": 77.796364,
            "latitude": 55.519726
        },
        "3279": {
            "name": "Октябрьское",
            "population": 1049,
            "type": "village",
            "poly": [
                [
                    77.8003743,
                    53.5093594
                ],
                [
                    77.8003743,
                    53.5190575
                ],
                [
                    77.8023851,
                    53.5217806
                ],
                [
                    77.8038374,
                    53.5224116
                ],
                [
                    77.8099256,
                    53.52281
                ],
                [
                    77.8111545,
                    53.5110866
                ],
                [
                    77.8122157,
                    53.5076984
                ],
                [
                    77.8121599,
                    53.5018517
                ],
                [
                    77.8095346,
                    53.5018849
                ],
                [
                    77.8060716,
                    53.5030477
                ],
                [
                    77.8035581,
                    53.5040111
                ],
                [
                    77.80205,
                    53.5078978
                ],
                [
                    77.8003743,
                    53.5093594
                ]
            ],
            "longitude": 77.804672,
            "latitude": 53.513443
        },
        "3280": {
            "name": "Троицкое",
            "population": 600,
            "type": "village",
            "poly": null,
            "longitude": 77.82058,
            "latitude": 53.72477
        },
        "3281": {
            "name": "Богатиха",
            "population": 228,
            "type": "village",
            "poly": [
                [
                    77.8110499,
                    54.708557
                ],
                [
                    77.8142866,
                    54.7099792
                ],
                [
                    77.8136028,
                    54.7105059
                ],
                [
                    77.8236773,
                    54.7138504
                ],
                [
                    77.8246347,
                    54.7128234
                ],
                [
                    77.8277346,
                    54.7140347
                ],
                [
                    77.8264126,
                    54.7151934
                ],
                [
                    77.8323388,
                    54.7171419
                ],
                [
                    77.8369431,
                    54.7133764
                ],
                [
                    77.8297404,
                    54.7107166
                ],
                [
                    77.8283272,
                    54.7108482
                ],
                [
                    77.8268685,
                    54.7103479
                ],
                [
                    77.8272332,
                    54.7100055
                ],
                [
                    77.8247715,
                    54.7090574
                ],
                [
                    77.8239053,
                    54.7096105
                ],
                [
                    77.8202127,
                    54.7073455
                ],
                [
                    77.8194378,
                    54.7077932
                ],
                [
                    77.8165659,
                    54.7065817
                ],
                [
                    77.8144689,
                    54.708794
                ],
                [
                    77.8122352,
                    54.7076615
                ],
                [
                    77.8110499,
                    54.708557
                ]
            ],
            "longitude": 77.822441,
            "latitude": 54.711185
        },
        "3282": {
            "name": "Новониколаевка",
            "population": 416,
            "type": "village",
            "poly": [
                [
                    77.8128815,
                    54.7930895
                ],
                [
                    77.8176222,
                    54.7948371
                ],
                [
                    77.8195099,
                    54.7955287
                ],
                [
                    77.8222958,
                    54.7965698
                ],
                [
                    77.824971,
                    54.7976263
                ],
                [
                    77.8288811,
                    54.7990556
                ],
                [
                    77.8502621,
                    54.8027847
                ],
                [
                    77.8546532,
                    54.7990461
                ],
                [
                    77.8384759,
                    54.7971617
                ],
                [
                    77.8358487,
                    54.795999
                ],
                [
                    77.8305719,
                    54.7945813
                ],
                [
                    77.8264763,
                    54.7930061
                ],
                [
                    77.8189257,
                    54.7911448
                ],
                [
                    77.8128815,
                    54.7930895
                ]
            ],
            "longitude": 77.829422,
            "latitude": 54.796612
        },
        "3283": {
            "name": "Квашнино",
            "population": 442,
            "type": "village",
            "poly": [
                [
                    77.8230562,
                    55.00838
                ],
                [
                    77.8295303,
                    55.0106955
                ],
                [
                    77.8348364,
                    55.0122455
                ],
                [
                    77.8389745,
                    55.0133936
                ],
                [
                    77.8416109,
                    55.013872
                ],
                [
                    77.845315,
                    55.0150583
                ],
                [
                    77.8460493,
                    55.0140442
                ],
                [
                    77.8472841,
                    55.0138146
                ],
                [
                    77.8465833,
                    55.0127813
                ],
                [
                    77.8456822,
                    55.0122264
                ],
                [
                    77.8444475,
                    55.0118246
                ],
                [
                    77.8461827,
                    55.0101789
                ],
                [
                    77.8435131,
                    55.0095856
                ],
                [
                    77.8425119,
                    55.009777
                ],
                [
                    77.8422116,
                    55.0088584
                ],
                [
                    77.8414106,
                    55.008514
                ],
                [
                    77.8409101,
                    55.0090881
                ],
                [
                    77.8376063,
                    55.0080355
                ],
                [
                    77.8351034,
                    55.0070021
                ],
                [
                    77.832467,
                    55.0061409
                ],
                [
                    77.8268606,
                    55.0045715
                ],
                [
                    77.8253922,
                    55.0066002
                ],
                [
                    77.8246247,
                    55.0064088
                ],
                [
                    77.8241241,
                    55.0071935
                ],
                [
                    77.8230562,
                    55.00838
                ]
            ],
            "longitude": 77.837303,
            "latitude": 55.010712
        },
        "3284": {
            "name": "Зюзя",
            "population": 728,
            "type": "village",
            "poly": [
                [
                    77.8312255,
                    55.0878225
                ],
                [
                    77.8363362,
                    55.0890012
                ],
                [
                    77.8406842,
                    55.089154
                ],
                [
                    77.8433921,
                    55.0900053
                ],
                [
                    77.8470154,
                    55.0915549
                ],
                [
                    77.8470916,
                    55.0939121
                ],
                [
                    77.8492276,
                    55.0951343
                ],
                [
                    77.8492657,
                    55.0957672
                ],
                [
                    77.847206,
                    55.0971203
                ],
                [
                    77.8499904,
                    55.098386
                ],
                [
                    77.8526602,
                    55.0977531
                ],
                [
                    77.8540332,
                    55.0984733
                ],
                [
                    77.8538044,
                    55.0974913
                ],
                [
                    77.8523169,
                    55.0958981
                ],
                [
                    77.8532704,
                    55.0937593
                ],
                [
                    77.854529,
                    55.0937593
                ],
                [
                    77.8549867,
                    55.094676
                ],
                [
                    77.8574658,
                    55.0950034
                ],
                [
                    77.8622715,
                    55.0953307
                ],
                [
                    77.8637971,
                    55.09592
                ],
                [
                    77.8672297,
                    55.0961819
                ],
                [
                    77.8681069,
                    55.0953962
                ],
                [
                    77.8694418,
                    55.0960946
                ],
                [
                    77.8696325,
                    55.0968147
                ],
                [
                    77.8733321,
                    55.0977531
                ],
                [
                    77.8747433,
                    55.0970766
                ],
                [
                    77.8751247,
                    55.0961819
                ],
                [
                    77.8733702,
                    55.0953962
                ],
                [
                    77.873866,
                    55.0949161
                ],
                [
                    77.871959,
                    55.0945232
                ],
                [
                    77.8723023,
                    55.0939339
                ],
                [
                    77.8705097,
                    55.0931701
                ],
                [
                    77.8677255,
                    55.0919915
                ],
                [
                    77.8647124,
                    55.0910529
                ],
                [
                    77.8625384,
                    55.0906382
                ],
                [
                    77.8578472,
                    55.0904418
                ],
                [
                    77.8551393,
                    55.0893068
                ],
                [
                    77.8498759,
                    55.0880626
                ],
                [
                    77.8455661,
                    55.0871021
                ],
                [
                    77.8451084,
                    55.0872549
                ],
                [
                    77.8388152,
                    55.0860325
                ],
                [
                    77.8369465,
                    55.0852903
                ],
                [
                    77.8365651,
                    55.0855959
                ],
                [
                    77.8352302,
                    55.0856178
                ],
                [
                    77.8349632,
                    55.0861417
                ],
                [
                    77.8327891,
                    55.0855959
                ],
                [
                    77.8312255,
                    55.0878225
                ]
            ],
            "longitude": 77.854271,
            "latitude": 55.09177
        },
        "3285": {
            "name": "Петровка",
            "population": 394,
            "type": "village",
            "poly": [
                [
                    77.849868,
                    54.2689611
                ],
                [
                    77.8508748,
                    54.2696264
                ],
                [
                    77.8519611,
                    54.2699049
                ],
                [
                    77.8520406,
                    54.2695955
                ],
                [
                    77.8547961,
                    54.2700906
                ],
                [
                    77.8523584,
                    54.273912
                ],
                [
                    77.855485,
                    54.2746701
                ],
                [
                    77.8590618,
                    54.2691158
                ],
                [
                    77.8596711,
                    54.2690694
                ],
                [
                    77.860413,
                    54.2684505
                ],
                [
                    77.8621882,
                    54.2688682
                ],
                [
                    77.8613934,
                    54.2699049
                ],
                [
                    77.862983,
                    54.2701989
                ],
                [
                    77.8647316,
                    54.2683422
                ],
                [
                    77.8646258,
                    54.2667794
                ],
                [
                    77.8609959,
                    54.2660831
                ],
                [
                    77.8646787,
                    54.26093
                ],
                [
                    77.8637779,
                    54.2602336
                ],
                [
                    77.8621882,
                    54.259661
                ],
                [
                    77.8625856,
                    54.2570609
                ],
                [
                    77.8603336,
                    54.2529593
                ],
                [
                    77.857737,
                    54.2532843
                ],
                [
                    77.8574986,
                    54.2537487
                ],
                [
                    77.8581345,
                    54.2570609
                ],
                [
                    77.8593532,
                    54.2581598
                ],
                [
                    77.8593532,
                    54.2604657
                ],
                [
                    77.857843,
                    54.2611157
                ],
                [
                    77.8580815,
                    54.2617502
                ],
                [
                    77.8554585,
                    54.2642417
                ],
                [
                    77.8546106,
                    54.2658819
                ],
                [
                    77.8548226,
                    54.2666247
                ],
                [
                    77.8541867,
                    54.2670579
                ],
                [
                    77.8513782,
                    54.266733
                ],
                [
                    77.849868,
                    54.2689611
                ]
            ],
            "longitude": 77.859123,
            "latitude": 54.265553
        },
        "3286": {
            "name": "Половинное",
            "population": 138,
            "type": "village",
            "poly": [
                [
                    77.8568476,
                    55.2362351
                ],
                [
                    77.858299,
                    55.2365205
                ],
                [
                    77.8580738,
                    55.2375336
                ],
                [
                    77.8591499,
                    55.2376905
                ],
                [
                    77.8588496,
                    55.2385894
                ],
                [
                    77.8595753,
                    55.2386893
                ],
                [
                    77.8622029,
                    55.238618
                ],
                [
                    77.8639797,
                    55.2384896
                ],
                [
                    77.8678585,
                    55.2384468
                ],
                [
                    77.8675082,
                    55.2373481
                ],
                [
                    77.8677584,
                    55.2366061
                ],
                [
                    77.8671327,
                    55.2364349
                ],
                [
                    77.8671078,
                    55.2360924
                ],
                [
                    77.8649305,
                    55.2359783
                ],
                [
                    77.8649556,
                    55.2346655
                ],
                [
                    77.864305,
                    55.2338664
                ],
                [
                    77.8630036,
                    55.2331672
                ],
                [
                    77.862353,
                    55.2331814
                ],
                [
                    77.8620778,
                    55.2336381
                ],
                [
                    77.8606263,
                    55.2336381
                ],
                [
                    77.8603761,
                    55.234109
                ],
                [
                    77.8599006,
                    55.2341803
                ],
                [
                    77.8589246,
                    55.2355217
                ],
                [
                    77.8581238,
                    55.2357072
                ],
                [
                    77.8571729,
                    55.2355359
                ],
                [
                    77.8568476,
                    55.2362351
                ]
            ],
            "longitude": 77.860687,
            "latitude": 55.236923
        },
        "3287": {
            "name": "Калачи",
            "population": 275,
            "type": "village",
            "poly": [
                [
                    77.8647488,
                    53.5870417
                ],
                [
                    77.8668701,
                    53.5896232
                ],
                [
                    77.8683552,
                    53.5895602
                ],
                [
                    77.8698403,
                    53.5904417
                ],
                [
                    77.8722799,
                    53.591512
                ],
                [
                    77.8780078,
                    53.5932118
                ],
                [
                    77.88119,
                    53.5946598
                ],
                [
                    77.8843722,
                    53.5964854
                ],
                [
                    77.8859633,
                    53.5946598
                ],
                [
                    77.8865997,
                    53.5933377
                ],
                [
                    77.8859633,
                    53.5926452
                ],
                [
                    77.8851147,
                    53.5921416
                ],
                [
                    77.8858572,
                    53.5911342
                ],
                [
                    77.8858572,
                    53.5904417
                ],
                [
                    77.8851147,
                    53.5902528
                ],
                [
                    77.8862815,
                    53.5891195
                ],
                [
                    77.8790686,
                    53.5869788
                ],
                [
                    77.8779018,
                    53.5881751
                ],
                [
                    77.8747196,
                    53.5872936
                ],
                [
                    77.8727042,
                    53.5879862
                ],
                [
                    77.8718556,
                    53.5885528
                ],
                [
                    77.8705827,
                    53.5874825
                ],
                [
                    77.8696281,
                    53.5850268
                ],
                [
                    77.8647488,
                    53.5870417
                ]
            ],
            "longitude": 77.879082,
            "latitude": 53.590782
        },
        "3288": {
            "name": "Новоивановка",
            "population": 279,
            "type": "village",
            "poly": [
                [
                    77.8930977,
                    53.464554
                ],
                [
                    77.8942993,
                    53.465692
                ],
                [
                    77.8965933,
                    53.4661472
                ],
                [
                    77.8994335,
                    53.4661797
                ],
                [
                    77.9019459,
                    53.4550259
                ],
                [
                    77.9008536,
                    53.4547982
                ],
                [
                    77.8957415,
                    53.4545439
                ],
                [
                    77.8930977,
                    53.464554
                ]
            ],
            "longitude": 77.897743,
            "latitude": 53.461269
        },
        "3289": {
            "name": "Савкино",
            "population": 919,
            "type": "village",
            "poly": [
                [
                    77.8920718,
                    53.9032336
                ],
                [
                    77.894566,
                    53.9042054
                ],
                [
                    77.8958593,
                    53.904291
                ],
                [
                    77.897588,
                    53.9040422
                ],
                [
                    77.8950411,
                    53.9061879
                ],
                [
                    77.8923163,
                    53.9090855
                ],
                [
                    77.8928576,
                    53.9098447
                ],
                [
                    77.8985024,
                    53.9106645
                ],
                [
                    77.9042244,
                    53.9110593
                ],
                [
                    77.9089413,
                    53.9103002
                ],
                [
                    77.9128333,
                    53.9069902
                ],
                [
                    77.9132239,
                    53.9064557
                ],
                [
                    77.9158633,
                    53.9069659
                ],
                [
                    77.9170386,
                    53.9048157
                ],
                [
                    77.9132445,
                    53.903686
                ],
                [
                    77.9153065,
                    53.9003694
                ],
                [
                    77.9157189,
                    53.8990937
                ],
                [
                    77.910832,
                    53.8979759
                ],
                [
                    77.9114299,
                    53.8969675
                ],
                [
                    77.9111413,
                    53.8963964
                ],
                [
                    77.9103783,
                    53.8957889
                ],
                [
                    77.9094504,
                    53.8957403
                ],
                [
                    77.9081926,
                    53.8961534
                ],
                [
                    77.9047284,
                    53.8956431
                ],
                [
                    77.9026458,
                    53.8975507
                ],
                [
                    77.8982331,
                    53.8965058
                ],
                [
                    77.8959236,
                    53.898875
                ],
                [
                    77.895305,
                    53.8988143
                ],
                [
                    77.8920718,
                    53.9032336
                ]
            ],
            "longitude": 77.902786,
            "latitude": 53.903275
        },
        "3290": {
            "name": "Рассказово",
            "population": 302,
            "type": "village",
            "poly": [
                [
                    77.9145239,
                    53.6647379
                ],
                [
                    77.9168097,
                    53.6660483
                ],
                [
                    77.9159673,
                    53.6675202
                ],
                [
                    77.9186373,
                    53.6681123
                ],
                [
                    77.9191084,
                    53.66829
                ],
                [
                    77.9187658,
                    53.669322
                ],
                [
                    77.918025,
                    53.6692766
                ],
                [
                    77.9171661,
                    53.671074
                ],
                [
                    77.9192404,
                    53.6714204
                ],
                [
                    77.9197155,
                    53.6702673
                ],
                [
                    77.9215157,
                    53.6707654
                ],
                [
                    77.9220274,
                    53.67004
                ],
                [
                    77.9216254,
                    53.669975
                ],
                [
                    77.921863,
                    53.6693254
                ],
                [
                    77.9224478,
                    53.6694607
                ],
                [
                    77.9232062,
                    53.6683617
                ],
                [
                    77.9253902,
                    53.6690818
                ],
                [
                    77.9260207,
                    53.6680261
                ],
                [
                    77.9268107,
                    53.6668673
                ],
                [
                    77.9244019,
                    53.6664106
                ],
                [
                    77.9246507,
                    53.6653887
                ],
                [
                    77.9234031,
                    53.6648126
                ],
                [
                    77.924775,
                    53.6629601
                ],
                [
                    77.926262,
                    53.663356
                ],
                [
                    77.9269137,
                    53.6620366
                ],
                [
                    77.9262801,
                    53.6610228
                ],
                [
                    77.9279082,
                    53.659273
                ],
                [
                    77.9284595,
                    53.6586314
                ],
                [
                    77.9306145,
                    53.6569184
                ],
                [
                    77.9292583,
                    53.6562682
                ],
                [
                    77.9287329,
                    53.6569356
                ],
                [
                    77.9279727,
                    53.6567263
                ],
                [
                    77.9263977,
                    53.6579655
                ],
                [
                    77.92523,
                    53.6575632
                ],
                [
                    77.9231147,
                    53.6587403
                ],
                [
                    77.9211788,
                    53.6583832
                ],
                [
                    77.9206219,
                    53.6596946
                ],
                [
                    77.9199366,
                    53.6618521
                ],
                [
                    77.9195368,
                    53.6629773
                ],
                [
                    77.9201506,
                    53.6632904
                ],
                [
                    77.9196225,
                    53.6640264
                ],
                [
                    77.9190656,
                    53.6638233
                ],
                [
                    77.918166,
                    53.6654815
                ],
                [
                    77.9172738,
                    53.6654314
                ],
                [
                    77.9152207,
                    53.6645353
                ],
                [
                    77.9145239,
                    53.6647379
                ]
            ],
            "longitude": 77.922684,
            "latitude": 53.667519
        },
        "3291": {
            "name": "Верх-Красноярка",
            "population": 627,
            "type": "village",
            "poly": [
                [
                    77.904984,
                    56.3640184
                ],
                [
                    77.9076604,
                    56.365603
                ],
                [
                    77.9061469,
                    56.3670137
                ],
                [
                    77.9061837,
                    56.3672489
                ],
                [
                    77.9086755,
                    56.3680258
                ],
                [
                    77.9081368,
                    56.3689998
                ],
                [
                    77.9092904,
                    56.3693392
                ],
                [
                    77.9091822,
                    56.3697185
                ],
                [
                    77.91048,
                    56.3699182
                ],
                [
                    77.9105881,
                    56.3696586
                ],
                [
                    77.9149324,
                    56.3704178
                ],
                [
                    77.9150432,
                    56.3706631
                ],
                [
                    77.9163905,
                    56.3709186
                ],
                [
                    77.9165197,
                    56.3712253
                ],
                [
                    77.9185315,
                    56.3714195
                ],
                [
                    77.9189376,
                    56.371583
                ],
                [
                    77.9217984,
                    56.3716341
                ],
                [
                    77.9236625,
                    56.3721248
                ],
                [
                    77.9241793,
                    56.3721452
                ],
                [
                    77.9249176,
                    56.3725132
                ],
                [
                    77.9279076,
                    56.3727074
                ],
                [
                    77.9291442,
                    56.3731367
                ],
                [
                    77.929864,
                    56.3741588
                ],
                [
                    77.9298271,
                    56.3746494
                ],
                [
                    77.929015,
                    56.3753546
                ],
                [
                    77.9280737,
                    56.375559
                ],
                [
                    77.9272985,
                    56.3759269
                ],
                [
                    77.9263203,
                    56.3768059
                ],
                [
                    77.926228,
                    56.3771636
                ],
                [
                    77.92752,
                    56.3776337
                ],
                [
                    77.9281106,
                    56.3771125
                ],
                [
                    77.9288858,
                    56.376857
                ],
                [
                    77.9290704,
                    56.376673
                ],
                [
                    77.9295503,
                    56.3767139
                ],
                [
                    77.9299194,
                    56.3763357
                ],
                [
                    77.9303624,
                    56.3764686
                ],
                [
                    77.9316359,
                    56.3757736
                ],
                [
                    77.9325587,
                    56.3741588
                ],
                [
                    77.9337031,
                    56.3745778
                ],
                [
                    77.9349397,
                    56.3726972
                ],
                [
                    77.9363239,
                    56.3728403
                ],
                [
                    77.9392217,
                    56.3726154
                ],
                [
                    77.9391478,
                    56.3723292
                ],
                [
                    77.9423963,
                    56.3719714
                ],
                [
                    77.9424885,
                    56.371675
                ],
                [
                    77.9424885,
                    56.3710924
                ],
                [
                    77.9423593,
                    56.3708675
                ],
                [
                    77.9379481,
                    56.3700498
                ],
                [
                    77.9368592,
                    56.3697431
                ],
                [
                    77.9364716,
                    56.3699987
                ],
                [
                    77.9339983,
                    56.3694365
                ],
                [
                    77.934386,
                    56.368956
                ],
                [
                    77.9324479,
                    56.3681996
                ],
                [
                    77.9339615,
                    56.3658586
                ],
                [
                    77.9319866,
                    56.3652452
                ],
                [
                    77.922389,
                    56.364049
                ],
                [
                    77.9155229,
                    56.3622803
                ],
                [
                    77.9125884,
                    56.3618202
                ],
                [
                    77.911001,
                    56.3620656
                ],
                [
                    77.9068852,
                    56.3630982
                ],
                [
                    77.904984,
                    56.3640184
                ]
            ],
            "longitude": 77.923141,
            "latitude": 56.367542
        },
        "3292": {
            "name": "Озёрное Приволье",
            "population": 19,
            "type": "village",
            "poly": null,
            "longitude": 77.930527,
            "latitude": 53.801224
        },
        "3293": {
            "name": "Устьянцево",
            "population": 697,
            "type": "village",
            "poly": [
                [
                    77.9227391,
                    55.2909122
                ],
                [
                    77.931153,
                    55.2932939
                ],
                [
                    77.9332677,
                    55.2938925
                ],
                [
                    77.9387712,
                    55.2957829
                ],
                [
                    77.9434971,
                    55.2969749
                ],
                [
                    77.9469069,
                    55.2981158
                ],
                [
                    77.9505261,
                    55.2989161
                ],
                [
                    77.9514833,
                    55.2973666
                ],
                [
                    77.9469668,
                    55.2955274
                ],
                [
                    77.9471163,
                    55.2952209
                ],
                [
                    77.9490007,
                    55.2945397
                ],
                [
                    77.9522011,
                    55.2939947
                ],
                [
                    77.9536667,
                    55.293586
                ],
                [
                    77.9563288,
                    55.2931773
                ],
                [
                    77.9575851,
                    55.2915253
                ],
                [
                    77.9529489,
                    55.2898051
                ],
                [
                    77.9548333,
                    55.2881359
                ],
                [
                    77.9499578,
                    55.2866881
                ],
                [
                    77.9478641,
                    55.2878464
                ],
                [
                    77.9470864,
                    55.2875738
                ],
                [
                    77.9457404,
                    55.2858705
                ],
                [
                    77.9300373,
                    55.283111
                ],
                [
                    77.9251619,
                    55.287642
                ],
                [
                    77.9239056,
                    55.2901457
                ],
                [
                    77.9227391,
                    55.2909122
                ]
            ],
            "longitude": 77.939293,
            "latitude": 55.293018
        },
        "3294": {
            "name": "Сорочиха",
            "population": 542,
            "type": "village",
            "poly": null,
            "longitude": 77.946991,
            "latitude": 53.73138
        },
        "3295": {
            "name": "Кирзинское",
            "population": 191,
            "type": "village",
            "poly": [
                [
                    77.9402545,
                    55.3419368
                ],
                [
                    77.9411571,
                    55.344332
                ],
                [
                    77.9522549,
                    55.3432104
                ],
                [
                    77.9542941,
                    55.3433625
                ],
                [
                    77.9600436,
                    55.3430204
                ],
                [
                    77.9651246,
                    55.3417657
                ],
                [
                    77.973916,
                    55.3406252
                ],
                [
                    77.9732475,
                    55.3383059
                ],
                [
                    77.9699715,
                    55.3386671
                ],
                [
                    77.9700384,
                    55.3378306
                ],
                [
                    77.9673642,
                    55.33688
                ],
                [
                    77.9663614,
                    55.336842
                ],
                [
                    77.9596091,
                    55.3393705
                ],
                [
                    77.9569014,
                    55.3393515
                ],
                [
                    77.9551965,
                    55.3389142
                ],
                [
                    77.9516533,
                    55.3387621
                ],
                [
                    77.951553,
                    55.3397887
                ],
                [
                    77.9517202,
                    55.3406632
                ],
                [
                    77.944433,
                    55.3409293
                ],
                [
                    77.9447004,
                    55.3413856
                ],
                [
                    77.9402545,
                    55.3419368
                ]
            ],
            "longitude": 77.957703,
            "latitude": 55.340206
        },
        "3296": {
            "name": "Лягушье",
            "population": 867,
            "type": "village",
            "poly": [
                [
                    77.9560188,
                    54.3945625
                ],
                [
                    77.9564647,
                    54.3952941
                ],
                [
                    77.9662746,
                    54.3987395
                ],
                [
                    77.9669231,
                    54.3982204
                ],
                [
                    77.9684635,
                    54.3982912
                ],
                [
                    77.9683419,
                    54.3988339
                ],
                [
                    77.9693148,
                    54.3995891
                ],
                [
                    77.9757601,
                    54.4017128
                ],
                [
                    77.9769357,
                    54.4027038
                ],
                [
                    77.9799354,
                    54.403742
                ],
                [
                    77.9792463,
                    54.4043319
                ],
                [
                    77.981111,
                    54.4049925
                ],
                [
                    77.9826108,
                    54.4039308
                ],
                [
                    77.995542,
                    54.4078002
                ],
                [
                    77.9973256,
                    54.4044263
                ],
                [
                    77.996069,
                    54.4044027
                ],
                [
                    77.9970012,
                    54.4035297
                ],
                [
                    77.9949745,
                    54.4017836
                ],
                [
                    77.9967987,
                    54.3986923
                ],
                [
                    77.995461,
                    54.3976776
                ],
                [
                    77.9928666,
                    54.3967101
                ],
                [
                    77.9909208,
                    54.3991407
                ],
                [
                    77.9893399,
                    54.3988339
                ],
                [
                    77.9879211,
                    54.4003206
                ],
                [
                    77.9830567,
                    54.3994711
                ],
                [
                    77.9810703,
                    54.3995419
                ],
                [
                    77.9804623,
                    54.4001554
                ],
                [
                    77.9747873,
                    54.3973472
                ],
                [
                    77.9720713,
                    54.3957189
                ],
                [
                    77.970085,
                    54.3947041
                ],
                [
                    77.9657881,
                    54.393288
                ],
                [
                    77.9649774,
                    54.3941377
                ],
                [
                    77.9596671,
                    54.3919899
                ],
                [
                    77.9582888,
                    54.3918247
                ],
                [
                    77.9572349,
                    54.392698
                ],
                [
                    77.9560188,
                    54.3945625
                ]
            ],
            "longitude": 77.984741,
            "latitude": 54.403564
        },
        "3297": {
            "name": "Озёрное-Титово",
            "population": 348,
            "type": "village",
            "poly": null,
            "longitude": 77.993584,
            "latitude": 53.753647
        },
        "3298": {
            "name": "Новоключи",
            "population": 799,
            "type": "village",
            "poly": [
                [
                    77.9929097,
                    54.246156
                ],
                [
                    77.9951116,
                    54.2470137
                ],
                [
                    77.9951932,
                    54.2484909
                ],
                [
                    77.9969058,
                    54.2485862
                ],
                [
                    77.9985368,
                    54.2498727
                ],
                [
                    78.0023698,
                    54.2503968
                ],
                [
                    78.0131348,
                    54.2500632
                ],
                [
                    78.0122377,
                    54.2481097
                ],
                [
                    78.0107698,
                    54.248062
                ],
                [
                    78.0100358,
                    54.246299
                ],
                [
                    78.0115037,
                    54.2442022
                ],
                [
                    78.0105251,
                    54.2431062
                ],
                [
                    78.0110144,
                    54.2398178
                ],
                [
                    78.007997,
                    54.2378161
                ],
                [
                    78.0029407,
                    54.2373395
                ],
                [
                    77.9987815,
                    54.2382451
                ],
                [
                    77.9962534,
                    54.2381021
                ],
                [
                    77.9943777,
                    54.2391506
                ],
                [
                    77.9944592,
                    54.2399132
                ],
                [
                    77.9960903,
                    54.2400561
                ],
                [
                    77.9965796,
                    54.2419148
                ],
                [
                    77.9942146,
                    54.2441546
                ],
                [
                    77.9929097,
                    54.246156
                ]
            ],
            "longitude": 78.002693,
            "latitude": 54.244106
        },
        "3299": {
            "name": "Верх-Ича",
            "population": 396,
            "type": "village",
            "poly": [
                [
                    77.9919394,
                    55.7286495
                ],
                [
                    77.9937713,
                    55.7294411
                ],
                [
                    78.0008433,
                    55.7290093
                ],
                [
                    78.00783,
                    55.7294171
                ],
                [
                    78.0067223,
                    55.7308325
                ],
                [
                    78.0105565,
                    55.7316481
                ],
                [
                    78.0145611,
                    55.731792
                ],
                [
                    78.0175858,
                    55.7302327
                ],
                [
                    78.0213348,
                    55.7308085
                ],
                [
                    78.0244021,
                    55.7305926
                ],
                [
                    78.0255098,
                    55.7290813
                ],
                [
                    78.0253393,
                    55.7283856
                ],
                [
                    78.0318575,
                    55.7269701
                ],
                [
                    78.0316871,
                    55.7255067
                ],
                [
                    78.0283641,
                    55.7248349
                ],
                [
                    78.0259784,
                    55.7249549
                ],
                [
                    78.022272,
                    55.7240432
                ],
                [
                    78.0186083,
                    55.7247869
                ],
                [
                    78.0161374,
                    55.7213799
                ],
                [
                    78.0146889,
                    55.7212359
                ],
                [
                    78.0120476,
                    55.7217878
                ],
                [
                    78.0112807,
                    55.7227955
                ],
                [
                    78.0146463,
                    55.7261784
                ],
                [
                    78.007617,
                    55.7259385
                ],
                [
                    78.003016,
                    55.7259625
                ],
                [
                    77.9985427,
                    55.7259865
                ],
                [
                    77.9958161,
                    55.7268502
                ],
                [
                    77.9939416,
                    55.7270181
                ],
                [
                    77.9922803,
                    55.7279537
                ],
                [
                    77.9919394,
                    55.7286495
                ]
            ],
            "longitude": 78.018295,
            "latitude": 55.727604
        },
        "3300": {
            "name": "Тополевка",
            "population": 258,
            "type": "village",
            "poly": [
                [
                    78.0358287,
                    54.8146705
                ],
                [
                    78.0383087,
                    54.8153429
                ],
                [
                    78.0379585,
                    54.8157296
                ],
                [
                    78.0401466,
                    54.816318
                ],
                [
                    78.0406427,
                    54.8159817
                ],
                [
                    78.0429767,
                    54.8164693
                ],
                [
                    78.0436478,
                    54.8156119
                ],
                [
                    78.0446397,
                    54.8155615
                ],
                [
                    78.0457775,
                    54.81462
                ],
                [
                    78.047528,
                    54.8151412
                ],
                [
                    78.0485784,
                    54.8144351
                ],
                [
                    78.0483158,
                    54.8138467
                ],
                [
                    78.045515,
                    54.8128211
                ],
                [
                    78.0391839,
                    54.8112744
                ],
                [
                    78.0378127,
                    54.8114593
                ],
                [
                    78.0366164,
                    54.8132246
                ],
                [
                    78.0366164,
                    54.8137458
                ],
                [
                    78.0358287,
                    54.8146705
                ]
            ],
            "longitude": 78.041077,
            "latitude": 54.813728
        },
        "3301": {
            "name": "Михайловка",
            "population": 573,
            "type": "village",
            "poly": [
                [
                    78.0373039,
                    53.6471232
                ],
                [
                    78.0393877,
                    53.6477722
                ],
                [
                    78.0412243,
                    53.6478978
                ],
                [
                    78.0425664,
                    53.6479606
                ],
                [
                    78.0419408,
                    53.6488143
                ],
                [
                    78.050751,
                    53.6499119
                ],
                [
                    78.0544689,
                    53.6425799
                ],
                [
                    78.0526323,
                    53.6415749
                ],
                [
                    78.0506898,
                    53.6410933
                ],
                [
                    78.0524204,
                    53.6387691
                ],
                [
                    78.04684,
                    53.6373242
                ],
                [
                    78.0463809,
                    53.6379943
                ],
                [
                    78.0465928,
                    53.6381828
                ],
                [
                    78.0456745,
                    53.639481
                ],
                [
                    78.0453213,
                    53.6393763
                ],
                [
                    78.0441911,
                    53.6404233
                ],
                [
                    78.0424958,
                    53.6433337
                ],
                [
                    78.0417894,
                    53.6441293
                ],
                [
                    78.0400588,
                    53.6431662
                ],
                [
                    78.0373039,
                    53.6471232
                ]
            ],
            "longitude": 78.047157,
            "latitude": 53.645222
        },
        "3302": {
            "name": "Благодатное",
            "population": 777,
            "type": "village",
            "poly": [
                [
                    78.0325051,
                    53.8431799
                ],
                [
                    78.0370757,
                    53.8446031
                ],
                [
                    78.0388883,
                    53.8443896
                ],
                [
                    78.0409166,
                    53.8443645
                ],
                [
                    78.0421947,
                    53.8447686
                ],
                [
                    78.043212,
                    53.8453492
                ],
                [
                    78.0436317,
                    53.8464318
                ],
                [
                    78.0431027,
                    53.8477817
                ],
                [
                    78.0442841,
                    53.8500488
                ],
                [
                    78.0473926,
                    53.8507339
                ],
                [
                    78.0529907,
                    53.8507251
                ],
                [
                    78.0592683,
                    53.8521424
                ],
                [
                    78.0655367,
                    53.853699
                ],
                [
                    78.069155,
                    53.8532789
                ],
                [
                    78.0728216,
                    53.8521118
                ],
                [
                    78.0737908,
                    53.851775
                ],
                [
                    78.0743594,
                    53.8512439
                ],
                [
                    78.0721588,
                    53.8482981
                ],
                [
                    78.0689848,
                    53.8471996
                ],
                [
                    78.0680114,
                    53.8455268
                ],
                [
                    78.067165,
                    53.8453521
                ],
                [
                    78.0644415,
                    53.845274
                ],
                [
                    78.0625282,
                    53.8451174
                ],
                [
                    78.0541319,
                    53.8427205
                ],
                [
                    78.0478881,
                    53.8401522
                ],
                [
                    78.0424865,
                    53.8382316
                ],
                [
                    78.0398265,
                    53.8350393
                ],
                [
                    78.0385569,
                    53.8327417
                ],
                [
                    78.0403343,
                    53.8316928
                ],
                [
                    78.0393609,
                    53.8307687
                ],
                [
                    78.0377951,
                    53.8315429
                ],
                [
                    78.037245,
                    53.8308686
                ],
                [
                    78.034875,
                    53.8310933
                ],
                [
                    78.0334362,
                    53.8315679
                ],
                [
                    78.0330553,
                    53.8323921
                ],
                [
                    78.0336478,
                    53.8326918
                ],
                [
                    78.0352136,
                    53.8322922
                ],
                [
                    78.0361023,
                    53.8332412
                ],
                [
                    78.0342402,
                    53.8338656
                ],
                [
                    78.0366102,
                    53.8374866
                ],
                [
                    78.0389377,
                    53.8395093
                ],
                [
                    78.0361023,
                    53.841457
                ],
                [
                    78.0354252,
                    53.8412323
                ],
                [
                    78.0325051,
                    53.8431799
                ]
            ],
            "longitude": 78.050858,
            "latitude": 53.844585
        },
        "3303": {
            "name": "Лукошино",
            "population": 617,
            "type": "village",
            "poly": [
                [
                    78.0615186,
                    54.3170485
                ],
                [
                    78.063297,
                    54.3182932
                ],
                [
                    78.0646603,
                    54.3187427
                ],
                [
                    78.068395,
                    54.3190539
                ],
                [
                    78.0699215,
                    54.3193209
                ],
                [
                    78.0707069,
                    54.3194688
                ],
                [
                    78.0715368,
                    54.3187427
                ],
                [
                    78.0733448,
                    54.3191576
                ],
                [
                    78.0736412,
                    54.3187254
                ],
                [
                    78.0754788,
                    54.3191922
                ],
                [
                    78.0749157,
                    54.3195898
                ],
                [
                    78.0795395,
                    54.3212667
                ],
                [
                    78.0802508,
                    54.3204196
                ],
                [
                    78.0817328,
                    54.3215606
                ],
                [
                    78.0841336,
                    54.3225459
                ],
                [
                    78.082948,
                    54.3249314
                ],
                [
                    78.0848153,
                    54.3253462
                ],
                [
                    78.0857934,
                    54.3252598
                ],
                [
                    78.0874235,
                    54.3232892
                ],
                [
                    78.0854674,
                    54.3222002
                ],
                [
                    78.0844893,
                    54.3207999
                ],
                [
                    78.0864455,
                    54.3211457
                ],
                [
                    78.087394,
                    54.3195898
                ],
                [
                    78.0863566,
                    54.3191576
                ],
                [
                    78.080073,
                    54.3169274
                ],
                [
                    78.0790356,
                    54.3165471
                ],
                [
                    78.0803101,
                    54.3151985
                ],
                [
                    78.0749583,
                    54.3131175
                ],
                [
                    78.0743229,
                    54.3129854
                ],
                [
                    78.0733448,
                    54.3144378
                ],
                [
                    78.0692249,
                    54.3136424
                ],
                [
                    78.0674465,
                    54.3151639
                ],
                [
                    78.0649568,
                    54.3144205
                ],
                [
                    78.0628524,
                    54.3159938
                ],
                [
                    78.0615186,
                    54.3170485
                ]
            ],
            "longitude": 78.075218,
            "latitude": 54.318527
        },
        "3304": {
            "name": "Остяцк",
            "population": 208,
            "type": "village",
            "poly": [
                [
                    78.0684077,
                    56.7061349
                ],
                [
                    78.0684686,
                    56.7080066
                ],
                [
                    78.0705997,
                    56.7080735
                ],
                [
                    78.0738269,
                    56.7087753
                ],
                [
                    78.0736442,
                    56.7117164
                ],
                [
                    78.0755927,
                    56.7119503
                ],
                [
                    78.0751664,
                    56.7126187
                ],
                [
                    78.0769931,
                    56.7133873
                ],
                [
                    78.078698,
                    56.7135544
                ],
                [
                    78.0787589,
                    56.7151918
                ],
                [
                    78.0833256,
                    56.7149913
                ],
                [
                    78.0834474,
                    56.7142561
                ],
                [
                    78.0845434,
                    56.7141893
                ],
                [
                    78.08363,
                    56.7123179
                ],
                [
                    78.0845434,
                    56.7123513
                ],
                [
                    78.0852132,
                    56.713521
                ],
                [
                    78.0858221,
                    56.710179
                ],
                [
                    78.0865528,
                    56.7099117
                ],
                [
                    78.087527,
                    56.7100453
                ],
                [
                    78.0889884,
                    56.7089759
                ],
                [
                    78.0878314,
                    56.7082072
                ],
                [
                    78.0869181,
                    56.7079398
                ],
                [
                    78.0871617,
                    56.7073047
                ],
                [
                    78.0807074,
                    56.7057672
                ],
                [
                    78.0799767,
                    56.7050653
                ],
                [
                    78.0799767,
                    56.7032937
                ],
                [
                    78.0789415,
                    56.7032603
                ],
                [
                    78.0780245,
                    56.7038963
                ],
                [
                    78.0754709,
                    56.7035611
                ],
                [
                    78.0744966,
                    56.7037951
                ],
                [
                    78.0734614,
                    56.7036614
                ],
                [
                    78.0727308,
                    56.7049316
                ],
                [
                    78.0738877,
                    56.7049316
                ],
                [
                    78.0732788,
                    56.7059009
                ],
                [
                    78.0684077,
                    56.7061349
                ]
            ],
            "longitude": 78.079613,
            "latitude": 56.708874
        },
        "3305": {
            "name": "Красный Пахарь",
            "population": 117,
            "type": "village",
            "poly": [
                [
                    78.0763918,
                    55.2677316
                ],
                [
                    78.0779221,
                    55.2687991
                ],
                [
                    78.0793898,
                    55.2692084
                ],
                [
                    78.0830124,
                    55.2689415
                ],
                [
                    78.084449,
                    55.2684255
                ],
                [
                    78.0847925,
                    55.2679273
                ],
                [
                    78.0883525,
                    55.2655431
                ],
                [
                    78.0856981,
                    55.263906
                ],
                [
                    78.0833247,
                    55.2647423
                ],
                [
                    78.0813572,
                    55.2650092
                ],
                [
                    78.0763918,
                    55.2677316
                ]
            ],
            "longitude": 78.081734,
            "latitude": 55.266823
        },
        "3306": {
            "name": "Новоярково",
            "population": 584,
            "type": "village",
            "poly": [
                [
                    78.0773931,
                    54.9234331
                ],
                [
                    78.0783382,
                    54.92508
                ],
                [
                    78.0794662,
                    54.9266742
                ],
                [
                    78.08096,
                    54.9274099
                ],
                [
                    78.0828502,
                    54.9284085
                ],
                [
                    78.0844355,
                    54.9288989
                ],
                [
                    78.0860513,
                    54.9298624
                ],
                [
                    78.0884598,
                    54.9305105
                ],
                [
                    78.0907768,
                    54.9310535
                ],
                [
                    78.0932462,
                    54.931036
                ],
                [
                    78.0911731,
                    54.9326475
                ],
                [
                    78.0940389,
                    54.9338911
                ],
                [
                    78.0977488,
                    54.9310301
                ],
                [
                    78.0963864,
                    54.9300726
                ],
                [
                    78.0981546,
                    54.927988
                ],
                [
                    78.098246,
                    54.9268493
                ],
                [
                    78.0950754,
                    54.9253603
                ],
                [
                    78.0933986,
                    54.9248347
                ],
                [
                    78.0930633,
                    54.9250449
                ],
                [
                    78.0904414,
                    54.9241164
                ],
                [
                    78.089039,
                    54.9253953
                ],
                [
                    78.0886732,
                    54.9255354
                ],
                [
                    78.087911,
                    54.9246069
                ],
                [
                    78.0856855,
                    54.9235207
                ],
                [
                    78.0824234,
                    54.9221366
                ],
                [
                    78.0819051,
                    54.9223118
                ],
                [
                    78.0801369,
                    54.9216986
                ],
                [
                    78.0795272,
                    54.9218037
                ],
                [
                    78.0773931,
                    54.9234331
                ]
            ],
            "longitude": 78.086517,
            "latitude": 54.927784
        },
        "3307": {
            "name": "Бадажки",
            "population": 322,
            "type": "village",
            "poly": [
                [
                    78.11185,
                    55.1887246
                ],
                [
                    78.1167201,
                    55.1908396
                ],
                [
                    78.1204483,
                    55.1923028
                ],
                [
                    78.1236406,
                    55.1937925
                ],
                [
                    78.1257844,
                    55.1945107
                ],
                [
                    78.1262271,
                    55.1937925
                ],
                [
                    78.1289767,
                    55.1954151
                ],
                [
                    78.1365265,
                    55.1925023
                ],
                [
                    78.1369692,
                    55.1911455
                ],
                [
                    78.1337303,
                    55.1892434
                ],
                [
                    78.1286971,
                    55.1870884
                ],
                [
                    78.1220328,
                    55.1852392
                ],
                [
                    78.1134578,
                    55.1825784
                ],
                [
                    78.112852,
                    55.1832703
                ],
                [
                    78.1139938,
                    55.1841084
                ],
                [
                    78.1156715,
                    55.1851062
                ],
                [
                    78.1152287,
                    55.1875407
                ],
                [
                    78.1149957,
                    55.188259
                ],
                [
                    78.1141802,
                    55.1883521
                ],
                [
                    78.1134578,
                    55.1888975
                ],
                [
                    78.112246,
                    55.1883654
                ],
                [
                    78.11185,
                    55.1887246
                ]
            ],
            "longitude": 78.1247259,
            "latitude": 55.1877526
        },
        "3308": {
            "name": "Веснянка",
            "population": 188,
            "type": "village",
            "poly": [
                [
                    78.1152649,
                    55.5449251
                ],
                [
                    78.1172293,
                    55.54551
                ],
                [
                    78.1216059,
                    55.5475376
                ],
                [
                    78.1269819,
                    55.547947
                ],
                [
                    78.1299456,
                    55.5496626
                ],
                [
                    78.130742,
                    55.549466
                ],
                [
                    78.131841,
                    55.5491947
                ],
                [
                    78.132737,
                    55.5484929
                ],
                [
                    78.1318065,
                    55.5476351
                ],
                [
                    78.1322545,
                    55.5468748
                ],
                [
                    78.1256034,
                    55.5438138
                ],
                [
                    78.124225,
                    55.5430339
                ],
                [
                    78.1216747,
                    55.5417665
                ],
                [
                    78.1205376,
                    55.541513
                ],
                [
                    78.1158508,
                    55.541435
                ],
                [
                    78.1152649,
                    55.5449251
                ]
            ],
            "longitude": 78.125664,
            "latitude": 55.546314
        },
        "3309": {
            "name": "Палецкое",
            "population": 737,
            "type": "village",
            "poly": [
                [
                    78.1302849,
                    54.1126463
                ],
                [
                    78.1333001,
                    54.1140771
                ],
                [
                    78.1317686,
                    54.1144137
                ],
                [
                    78.1311464,
                    54.1149187
                ],
                [
                    78.1323429,
                    54.1153395
                ],
                [
                    78.131625,
                    54.1156762
                ],
                [
                    78.131912,
                    54.1163214
                ],
                [
                    78.1344009,
                    54.1176679
                ],
                [
                    78.1356931,
                    54.1166861
                ],
                [
                    78.1374161,
                    54.1173874
                ],
                [
                    78.1368896,
                    54.1179204
                ],
                [
                    78.1405749,
                    54.1195754
                ],
                [
                    78.1465574,
                    54.1217072
                ],
                [
                    78.149764,
                    54.1224365
                ],
                [
                    78.148759,
                    54.123306
                ],
                [
                    78.151152,
                    54.1241194
                ],
                [
                    78.1541672,
                    54.1249047
                ],
                [
                    78.1553637,
                    54.125662
                ],
                [
                    78.1587139,
                    54.1265594
                ],
                [
                    78.160389,
                    54.1255498
                ],
                [
                    78.1626385,
                    54.1261107
                ],
                [
                    78.1643614,
                    54.1255778
                ],
                [
                    78.1652229,
                    54.1260546
                ],
                [
                    78.1680467,
                    54.1261948
                ],
                [
                    78.1717708,
                    54.1254689
                ],
                [
                    78.1743164,
                    54.1240352
                ],
                [
                    78.1679988,
                    54.1220999
                ],
                [
                    78.165893,
                    54.1218194
                ],
                [
                    78.1594797,
                    54.1195754
                ],
                [
                    78.1543108,
                    54.1174154
                ],
                [
                    78.1475625,
                    54.1171069
                ],
                [
                    78.1431115,
                    54.1154237
                ],
                [
                    78.1363153,
                    54.1111593
                ],
                [
                    78.136411,
                    54.1105421
                ],
                [
                    78.1356452,
                    54.1102615
                ],
                [
                    78.133683,
                    54.1113277
                ],
                [
                    78.1332044,
                    54.1111032
                ],
                [
                    78.1302849,
                    54.1126463
                ]
            ],
            "longitude": 78.143257,
            "latitude": 54.117863
        },
        "3310": {
            "name": "Гражданцево",
            "population": 344,
            "type": "village",
            "poly": [
                [
                    78.1543261,
                    56.3636452
                ],
                [
                    78.1551154,
                    56.3647127
                ],
                [
                    78.1571589,
                    56.3649443
                ],
                [
                    78.1604098,
                    56.3637738
                ],
                [
                    78.160224,
                    56.3634394
                ],
                [
                    78.1623836,
                    56.3630021
                ],
                [
                    78.1629176,
                    56.3634908
                ],
                [
                    78.1632279,
                    56.3634813
                ],
                [
                    78.1644272,
                    56.3634448
                ],
                [
                    78.1654487,
                    56.3634137
                ],
                [
                    78.1674224,
                    56.3630278
                ],
                [
                    78.1681887,
                    56.3632979
                ],
                [
                    78.1689549,
                    56.3630792
                ],
                [
                    78.1688156,
                    56.3626162
                ],
                [
                    78.1704874,
                    56.362076
                ],
                [
                    78.1732275,
                    56.3606096
                ],
                [
                    78.1737848,
                    56.3601208
                ],
                [
                    78.1726006,
                    56.3593489
                ],
                [
                    78.1719272,
                    56.3595419
                ],
                [
                    78.1706267,
                    56.3586929
                ],
                [
                    78.1709055,
                    56.3576509
                ],
                [
                    78.1756424,
                    56.3577538
                ],
                [
                    78.1763622,
                    56.3544861
                ],
                [
                    78.1761533,
                    56.3528908
                ],
                [
                    78.1758282,
                    56.3518873
                ],
                [
                    78.1748258,
                    56.3518439
                ],
                [
                    78.172856,
                    56.3517586
                ],
                [
                    78.1727863,
                    56.352196
                ],
                [
                    78.1723219,
                    56.3524276
                ],
                [
                    78.1721361,
                    56.3527493
                ],
                [
                    78.1704178,
                    56.352685
                ],
                [
                    78.1717414,
                    56.3514627
                ],
                [
                    78.1729256,
                    56.3509995
                ],
                [
                    78.1715324,
                    56.3497385
                ],
                [
                    78.1698605,
                    56.3501503
                ],
                [
                    78.1695819,
                    56.3496613
                ],
                [
                    78.1700463,
                    56.3492882
                ],
                [
                    78.1682583,
                    56.3480915
                ],
                [
                    78.1675849,
                    56.3484389
                ],
                [
                    78.1665632,
                    56.3476798
                ],
                [
                    78.1629176,
                    56.3490051
                ],
                [
                    78.1615708,
                    56.3491595
                ],
                [
                    78.1628944,
                    56.3501631
                ],
                [
                    78.1635213,
                    56.349983
                ],
                [
                    78.1640786,
                    56.3502789
                ],
                [
                    78.1645431,
                    56.3502017
                ],
                [
                    78.1656576,
                    56.3513983
                ],
                [
                    78.1662381,
                    56.3514755
                ],
                [
                    78.1680493,
                    56.3529423
                ],
                [
                    78.1621281,
                    56.3550008
                ],
                [
                    78.1608278,
                    56.3548464
                ],
                [
                    78.1591327,
                    56.3543832
                ],
                [
                    78.1600383,
                    56.3524405
                ],
                [
                    78.1565552,
                    56.3518873
                ],
                [
                    78.1559515,
                    56.351913
                ],
                [
                    78.1553478,
                    56.3525048
                ],
                [
                    78.1559979,
                    56.3526721
                ],
                [
                    78.1560908,
                    56.3535341
                ],
                [
                    78.1555335,
                    56.3541388
                ],
                [
                    78.1551154,
                    56.3542803
                ],
                [
                    78.1544654,
                    56.3542417
                ],
                [
                    78.155371,
                    56.3550651
                ],
                [
                    78.1554174,
                    56.3559013
                ],
                [
                    78.1562766,
                    56.3561715
                ],
                [
                    78.1564856,
                    56.3566346
                ],
                [
                    78.1572286,
                    56.3563516
                ],
                [
                    78.1568803,
                    56.3562229
                ],
                [
                    78.1571822,
                    56.3555797
                ],
                [
                    78.1571822,
                    56.3551037
                ],
                [
                    78.1581342,
                    56.3551294
                ],
                [
                    78.1579251,
                    56.3554639
                ],
                [
                    78.1584129,
                    56.3557212
                ],
                [
                    78.1590398,
                    56.3557727
                ],
                [
                    78.1591095,
                    56.3560686
                ],
                [
                    78.1598525,
                    56.3564931
                ],
                [
                    78.1598293,
                    56.3570077
                ],
                [
                    78.1605955,
                    56.3571878
                ],
                [
                    78.1601776,
                    56.3576638
                ],
                [
                    78.159272,
                    56.357638
                ],
                [
                    78.1587612,
                    56.3584227
                ],
                [
                    78.1602705,
                    56.3586672
                ],
                [
                    78.1593881,
                    56.360661
                ],
                [
                    78.161478,
                    56.3608926
                ],
                [
                    78.1626773,
                    56.3611126
                ],
                [
                    78.1647288,
                    56.3605067
                ],
                [
                    78.1656112,
                    56.3608668
                ],
                [
                    78.1659827,
                    56.3614971
                ],
                [
                    78.1654254,
                    56.3612656
                ],
                [
                    78.1640786,
                    56.3610083
                ],
                [
                    78.1600847,
                    56.3617415
                ],
                [
                    78.1607581,
                    56.3627834
                ],
                [
                    78.1588076,
                    56.363285
                ],
                [
                    78.1582271,
                    56.3626291
                ],
                [
                    78.1543261,
                    56.3636452
                ]
            ],
            "longitude": 78.165695,
            "latitude": 56.357346
        },
        "3311": {
            "name": "Новочановское",
            "population": 878,
            "type": "village",
            "poly": [
                [
                    78.1589046,
                    54.9488067
                ],
                [
                    78.1654726,
                    54.9500372
                ],
                [
                    78.1689661,
                    54.9516422
                ],
                [
                    78.1707361,
                    54.9520167
                ],
                [
                    78.1754408,
                    54.9537554
                ],
                [
                    78.1770246,
                    54.9545311
                ],
                [
                    78.1795865,
                    54.9552533
                ],
                [
                    78.1824278,
                    54.9550928
                ],
                [
                    78.1830801,
                    54.9540764
                ],
                [
                    78.1844775,
                    54.9545311
                ],
                [
                    78.185083,
                    54.9541834
                ],
                [
                    78.1868997,
                    54.9549591
                ],
                [
                    78.1875984,
                    54.9543974
                ],
                [
                    78.1866201,
                    54.9538089
                ],
                [
                    78.1870859,
                    54.9534344
                ],
                [
                    78.1846638,
                    54.9527925
                ],
                [
                    78.1843843,
                    54.952097
                ],
                [
                    78.1862476,
                    54.9515887
                ],
                [
                    78.1867134,
                    54.951348
                ],
                [
                    78.1871792,
                    54.9514817
                ],
                [
                    78.187971,
                    54.9509735
                ],
                [
                    78.1874586,
                    54.9508665
                ],
                [
                    78.1875052,
                    54.9504385
                ],
                [
                    78.1864339,
                    54.9500105
                ],
                [
                    78.1867599,
                    54.9495289
                ],
                [
                    78.1814032,
                    54.9479506
                ],
                [
                    78.1761395,
                    54.94672
                ],
                [
                    78.171761,
                    54.9453823
                ],
                [
                    78.1685935,
                    54.9442854
                ],
                [
                    78.1644012,
                    54.944981
                ],
                [
                    78.1631435,
                    54.9457568
                ],
                [
                    78.1621653,
                    54.9472015
                ],
                [
                    78.1607679,
                    54.9473085
                ],
                [
                    78.1598829,
                    54.9481379
                ],
                [
                    78.1591375,
                    54.9483519
                ],
                [
                    78.1589046,
                    54.9488067
                ]
            ],
            "longitude": 78.178185,
            "latitude": 54.950142
        },
        "3312": {
            "name": "Гжатск",
            "population": 585,
            "type": "village",
            "poly": null,
            "longitude": 78.179413,
            "latitude": 55.702034
        },
        "3313": {
            "name": "Шилово-Курья",
            "population": 755,
            "type": "village",
            "poly": [
                [
                    78.1624295,
                    53.8011073
                ],
                [
                    78.1643686,
                    53.8023643
                ],
                [
                    78.1698076,
                    53.8055204
                ],
                [
                    78.1716994,
                    53.8067772
                ],
                [
                    78.173402,
                    53.8074475
                ],
                [
                    78.1763343,
                    53.8081736
                ],
                [
                    78.1783887,
                    53.8094479
                ],
                [
                    78.1822105,
                    53.8105887
                ],
                [
                    78.1838997,
                    53.8093554
                ],
                [
                    78.1855502,
                    53.8101391
                ],
                [
                    78.1859501,
                    53.8106344
                ],
                [
                    78.1877798,
                    53.8100168
                ],
                [
                    78.1898077,
                    53.8105027
                ],
                [
                    78.1902456,
                    53.8099635
                ],
                [
                    78.1896446,
                    53.8097894
                ],
                [
                    78.1905229,
                    53.8087321
                ],
                [
                    78.1921783,
                    53.8097934
                ],
                [
                    78.1952052,
                    53.810324
                ],
                [
                    78.196624,
                    53.8085646
                ],
                [
                    78.1941647,
                    53.8079781
                ],
                [
                    78.1937863,
                    53.8085366
                ],
                [
                    78.1899081,
                    53.8073916
                ],
                [
                    78.1903811,
                    53.8067213
                ],
                [
                    78.1923675,
                    53.806861
                ],
                [
                    78.1923202,
                    53.8065258
                ],
                [
                    78.1863609,
                    53.8053249
                ],
                [
                    78.1859353,
                    53.8057159
                ],
                [
                    78.1823881,
                    53.8055483
                ],
                [
                    78.1822463,
                    53.8052132
                ],
                [
                    78.180118,
                    53.8054087
                ],
                [
                    78.1743006,
                    53.803677
                ],
                [
                    78.1722669,
                    53.8035374
                ],
                [
                    78.1708954,
                    53.8029788
                ],
                [
                    78.1703278,
                    53.7991241
                ],
                [
                    78.1684833,
                    53.799599
                ],
                [
                    78.1686725,
                    53.8019732
                ],
                [
                    78.1678212,
                    53.8021129
                ],
                [
                    78.1640375,
                    53.800018
                ],
                [
                    78.1624295,
                    53.8011073
                ]
            ],
            "longitude": 78.183037,
            "latitude": 53.80785
        },
        "3314": {
            "name": "Новоспасск",
            "population": 576,
            "type": "village",
            "poly": [
                [
                    78.1667943,
                    55.1086121
                ],
                [
                    78.1708016,
                    55.1102294
                ],
                [
                    78.1729521,
                    55.1110778
                ],
                [
                    78.1713948,
                    55.1130996
                ],
                [
                    78.1792554,
                    55.1156303
                ],
                [
                    78.1863251,
                    55.1179911
                ],
                [
                    78.1907745,
                    55.1194471
                ],
                [
                    78.1916891,
                    55.1183163
                ],
                [
                    78.1924801,
                    55.1182173
                ],
                [
                    78.1932958,
                    55.1172984
                ],
                [
                    78.1926975,
                    55.1169617
                ],
                [
                    78.1931969,
                    55.1160685
                ],
                [
                    78.1937902,
                    55.1162099
                ],
                [
                    78.1946552,
                    55.114683
                ],
                [
                    78.1915159,
                    55.1135237
                ],
                [
                    78.1905767,
                    55.113651
                ],
                [
                    78.1880238,
                    55.1132805
                ],
                [
                    78.1835813,
                    55.1112333
                ],
                [
                    78.1803925,
                    55.1102436
                ],
                [
                    78.1683658,
                    55.1065492
                ],
                [
                    78.1667943,
                    55.1086121
                ]
            ],
            "longitude": 78.186302,
            "latitude": 55.114559
        },
        "3315": {
            "name": "Юный Пионер",
            "population": 451,
            "type": "village",
            "poly": [
                [
                    78.1851344,
                    55.153012
                ],
                [
                    78.1861085,
                    55.1533055
                ],
                [
                    78.1869232,
                    55.152668
                ],
                [
                    78.1882161,
                    55.1531132
                ],
                [
                    78.1883933,
                    55.1535889
                ],
                [
                    78.1897747,
                    55.1543377
                ],
                [
                    78.1932284,
                    55.1549145
                ],
                [
                    78.1925377,
                    55.1559265
                ],
                [
                    78.1942911,
                    55.1562401
                ],
                [
                    78.1940962,
                    55.1569991
                ],
                [
                    78.196257,
                    55.1577074
                ],
                [
                    78.1973551,
                    55.1567157
                ],
                [
                    78.1990199,
                    55.157161
                ],
                [
                    78.1989667,
                    55.1574949
                ],
                [
                    78.2025443,
                    55.1576568
                ],
                [
                    78.2033237,
                    55.1576062
                ],
                [
                    78.2058564,
                    55.1583449
                ],
                [
                    78.2067243,
                    55.1569991
                ],
                [
                    78.2018183,
                    55.15538
                ],
                [
                    78.2021725,
                    55.1550157
                ],
                [
                    78.2011276,
                    55.1544187
                ],
                [
                    78.2017297,
                    55.1538419
                ],
                [
                    78.1996398,
                    55.1527489
                ],
                [
                    78.1992147,
                    55.1528299
                ],
                [
                    78.1972665,
                    55.1522935
                ],
                [
                    78.1974791,
                    55.1515446
                ],
                [
                    78.1897747,
                    55.1489436
                ],
                [
                    78.1886588,
                    55.1499557
                ],
                [
                    78.186746,
                    55.1491359
                ],
                [
                    78.1855476,
                    55.1507443
                ],
                [
                    78.1851344,
                    55.153012
                ]
            ],
            "longitude": 78.192482,
            "latitude": 55.151848
        },
        "3316": {
            "name": "Александровский",
            "population": 489,
            "type": "village",
            "poly": [
                [
                    78.20692,
                    53.705724
                ],
                [
                    78.2085814,
                    53.7062079
                ],
                [
                    78.2077903,
                    53.7072538
                ],
                [
                    78.2094517,
                    53.7076909
                ],
                [
                    78.2102956,
                    53.7067075
                ],
                [
                    78.2118251,
                    53.7070509
                ],
                [
                    78.2121942,
                    53.7064421
                ],
                [
                    78.2144359,
                    53.7069104
                ],
                [
                    78.2150425,
                    53.7061923
                ],
                [
                    78.2145941,
                    53.706005
                ],
                [
                    78.214937,
                    53.7053338
                ],
                [
                    78.2138821,
                    53.7050372
                ],
                [
                    78.2143041,
                    53.7042878
                ],
                [
                    78.215148,
                    53.7045532
                ],
                [
                    78.2157282,
                    53.7034605
                ],
                [
                    78.2201586,
                    53.7004162
                ],
                [
                    78.2181279,
                    53.6996824
                ],
                [
                    78.213592,
                    53.6977464
                ],
                [
                    78.2121942,
                    53.6975747
                ],
                [
                    78.2116142,
                    53.6984022
                ],
                [
                    78.2090297,
                    53.7014466
                ],
                [
                    78.2077639,
                    53.7036478
                ],
                [
                    78.2082386,
                    53.7038195
                ],
                [
                    78.20692,
                    53.705724
                ]
            ],
            "longitude": 78.212799,
            "latitude": 53.702694
        },
        "3317": {
            "name": "Шубинское",
            "population": 519,
            "type": "village",
            "poly": [
                [
                    78.2049363,
                    55.3284358
                ],
                [
                    78.2111433,
                    55.3291136
                ],
                [
                    78.2227968,
                    55.3264469
                ],
                [
                    78.2204247,
                    55.323278
                ],
                [
                    78.2171683,
                    55.3188712
                ],
                [
                    78.2105738,
                    55.3189226
                ],
                [
                    78.2049363,
                    55.3284358
                ]
            ],
            "longitude": 78.215561,
            "latitude": 55.325039
        },
        "3318": {
            "name": "Абрамово",
            "population": 1222,
            "type": "village",
            "poly": [
                [
                    78.2039476,
                    55.4336415
                ],
                [
                    78.2066055,
                    55.4352208
                ],
                [
                    78.2078264,
                    55.4364945
                ],
                [
                    78.2115947,
                    55.4388899
                ],
                [
                    78.2148625,
                    55.4415614
                ],
                [
                    78.2245113,
                    55.4441335
                ],
                [
                    78.2280548,
                    55.4442186
                ],
                [
                    78.2494635,
                    55.4513747
                ],
                [
                    78.2503781,
                    55.4504372
                ],
                [
                    78.2409799,
                    55.4473244
                ],
                [
                    78.2315727,
                    55.4443693
                ],
                [
                    78.2322034,
                    55.4436883
                ],
                [
                    78.2340981,
                    55.4441915
                ],
                [
                    78.236499,
                    55.4419654
                ],
                [
                    78.2326896,
                    55.440703
                ],
                [
                    78.2338301,
                    55.4398128
                ],
                [
                    78.2287836,
                    55.4373338
                ],
                [
                    78.2264693,
                    55.4343058
                ],
                [
                    78.226626,
                    55.433737
                ],
                [
                    78.2241795,
                    55.4321621
                ],
                [
                    78.2206738,
                    55.433506
                ],
                [
                    78.2195719,
                    55.4360001
                ],
                [
                    78.2158235,
                    55.436709
                ],
                [
                    78.2135169,
                    55.4349096
                ],
                [
                    78.213723,
                    55.4336396
                ],
                [
                    78.2119792,
                    55.4329466
                ],
                [
                    78.2097131,
                    55.4320926
                ],
                [
                    78.2069277,
                    55.431447
                ],
                [
                    78.2047409,
                    55.4330709
                ],
                [
                    78.2039476,
                    55.4336415
                ]
            ],
            "longitude": 78.22184,
            "latitude": 55.437435
        },
        "3319": {
            "name": "Лепокурово",
            "population": 637,
            "type": "village",
            "poly": [
                [
                    78.2006737,
                    54.2306152
                ],
                [
                    78.2078584,
                    54.2326967
                ],
                [
                    78.2143558,
                    54.2350336
                ],
                [
                    78.2259137,
                    54.2389405
                ],
                [
                    78.2277879,
                    54.2410946
                ],
                [
                    78.2334107,
                    54.2441977
                ],
                [
                    78.2336606,
                    54.2486512
                ],
                [
                    78.237784,
                    54.2503668
                ],
                [
                    78.241345,
                    54.2526663
                ],
                [
                    78.24778,
                    54.2510968
                ],
                [
                    78.2498417,
                    54.2495273
                ],
                [
                    78.2494668,
                    54.2485052
                ],
                [
                    78.2507163,
                    54.2467531
                ],
                [
                    78.2505914,
                    54.2452929
                ],
                [
                    78.2499666,
                    54.2444168
                ],
                [
                    78.2440315,
                    54.240985
                ],
                [
                    78.2370343,
                    54.239123
                ],
                [
                    78.2333482,
                    54.23591
                ],
                [
                    78.2315365,
                    54.2358369
                ],
                [
                    78.2259137,
                    54.2332809
                ],
                [
                    78.2181668,
                    54.2306882
                ],
                [
                    78.2047346,
                    54.2263423
                ],
                [
                    78.2006737,
                    54.2306152
                ]
            ],
            "longitude": 78.230911,
            "latitude": 54.239708
        },
        "3320": {
            "name": "Кожевниково",
            "population": 304,
            "type": "village",
            "poly": [
                [
                    78.2390637,
                    55.0070757
                ],
                [
                    78.2401646,
                    55.007621
                ],
                [
                    78.2398143,
                    55.0078793
                ],
                [
                    78.2469033,
                    55.0112175
                ],
                [
                    78.2466032,
                    55.0113705
                ],
                [
                    78.2468367,
                    55.0116288
                ],
                [
                    78.2464363,
                    55.0118583
                ],
                [
                    78.2462028,
                    55.0122983
                ],
                [
                    78.24687,
                    55.0125469
                ],
                [
                    78.2454189,
                    55.0142111
                ],
                [
                    78.2468534,
                    55.0144598
                ],
                [
                    78.2472704,
                    55.0141824
                ],
                [
                    78.2490218,
                    55.0148328
                ],
                [
                    78.2489217,
                    55.0150432
                ],
                [
                    78.2502561,
                    55.0152631
                ],
                [
                    78.2509901,
                    55.015923
                ],
                [
                    78.2509067,
                    55.0162099
                ],
                [
                    78.2520409,
                    55.0184477
                ],
                [
                    78.2532085,
                    55.018266
                ],
                [
                    78.2532085,
                    55.0185051
                ],
                [
                    78.2535088,
                    55.0185051
                ],
                [
                    78.2536088,
                    55.0186486
                ],
                [
                    78.2544429,
                    55.0186103
                ],
                [
                    78.2544595,
                    55.0182374
                ],
                [
                    78.2546763,
                    55.0179122
                ],
                [
                    78.2545096,
                    55.0177305
                ],
                [
                    78.2545096,
                    55.0163343
                ],
                [
                    78.2558273,
                    55.0163534
                ],
                [
                    78.2561609,
                    55.0155692
                ],
                [
                    78.2577789,
                    55.0158752
                ],
                [
                    78.2581292,
                    55.0158752
                ],
                [
                    78.2582793,
                    55.0154735
                ],
                [
                    78.2586129,
                    55.0154927
                ],
                [
                    78.2586129,
                    55.015397
                ],
                [
                    78.2620157,
                    55.01599
                ],
                [
                    78.2620656,
                    55.0155596
                ],
                [
                    78.2597638,
                    55.0153779
                ],
                [
                    78.2602141,
                    55.0147658
                ],
                [
                    78.2608647,
                    55.0149284
                ],
                [
                    78.2617488,
                    55.0144407
                ],
                [
                    78.2608814,
                    55.0137234
                ],
                [
                    78.2599472,
                    55.0135416
                ],
                [
                    78.260381,
                    55.0130347
                ],
                [
                    78.2566779,
                    55.0116383
                ],
                [
                    78.2571784,
                    55.0110071
                ],
                [
                    78.2559107,
                    55.0107392
                ],
                [
                    78.256311,
                    55.0101749
                ],
                [
                    78.2554604,
                    55.0098975
                ],
                [
                    78.2540092,
                    55.0111218
                ],
                [
                    78.253342,
                    55.0109784
                ],
                [
                    78.2533253,
                    55.0105958
                ],
                [
                    78.2497057,
                    55.0102036
                ],
                [
                    78.249222,
                    55.0106053
                ],
                [
                    78.2482045,
                    55.0101271
                ],
                [
                    78.2486882,
                    55.0097541
                ],
                [
                    78.2470202,
                    55.0085201
                ],
                [
                    78.2462696,
                    55.0076975
                ],
                [
                    78.2420494,
                    55.0056026
                ],
                [
                    78.2415657,
                    55.0056791
                ],
                [
                    78.2404982,
                    55.0065018
                ],
                [
                    78.2394974,
                    55.0061287
                ],
                [
                    78.2391971,
                    55.0066262
                ],
                [
                    78.2390637,
                    55.0070757
                ]
            ],
            "longitude": 78.2531084,
            "latitude": 55.0135225
        },
        "3321": {
            "name": "Останинка",
            "population": 232,
            "type": "village",
            "poly": [
                [
                    78.2494451,
                    56.7176355
                ],
                [
                    78.251195,
                    56.7185735
                ],
                [
                    78.2532297,
                    56.7193104
                ],
                [
                    78.2528635,
                    56.720293
                ],
                [
                    78.257869,
                    56.7214988
                ],
                [
                    78.2629965,
                    56.7229726
                ],
                [
                    78.2635257,
                    56.7227046
                ],
                [
                    78.2670255,
                    56.7236424
                ],
                [
                    78.2676766,
                    56.7231289
                ],
                [
                    78.2691009,
                    56.7231065
                ],
                [
                    78.2712578,
                    56.7238434
                ],
                [
                    78.2706067,
                    56.7243569
                ],
                [
                    78.2721531,
                    56.7245356
                ],
                [
                    78.2731298,
                    56.7240443
                ],
                [
                    78.2736995,
                    56.7243569
                ],
                [
                    78.2724379,
                    56.7250714
                ],
                [
                    78.273903,
                    56.7257859
                ],
                [
                    78.2762633,
                    56.7262771
                ],
                [
                    78.2785829,
                    56.7248035
                ],
                [
                    78.2780946,
                    56.7246695
                ],
                [
                    78.2786643,
                    56.7241336
                ],
                [
                    78.2786049,
                    56.7240746
                ],
                [
                    78.2778097,
                    56.7232852
                ],
                [
                    78.2756936,
                    56.7229502
                ],
                [
                    78.2745134,
                    56.7234191
                ],
                [
                    78.2740658,
                    56.7231289
                ],
                [
                    78.2745948,
                    56.7226599
                ],
                [
                    78.2746762,
                    56.7219007
                ],
                [
                    78.2747169,
                    56.720427
                ],
                [
                    78.273618,
                    56.7202037
                ],
                [
                    78.2734146,
                    56.720494
                ],
                [
                    78.2700775,
                    56.7195784
                ],
                [
                    78.2712985,
                    56.7187075
                ],
                [
                    78.2704439,
                    56.7183725
                ],
                [
                    78.2720717,
                    56.7168762
                ],
                [
                    78.2703218,
                    56.7164296
                ],
                [
                    78.2691823,
                    56.7174122
                ],
                [
                    78.2634443,
                    56.7165189
                ],
                [
                    78.2629152,
                    56.7169656
                ],
                [
                    78.2610839,
                    56.7163849
                ],
                [
                    78.2583341,
                    56.7161448
                ],
                [
                    78.2539216,
                    56.7148216
                ],
                [
                    78.2534332,
                    56.7156926
                ],
                [
                    78.2542064,
                    56.7161393
                ],
                [
                    78.2537995,
                    56.7168316
                ],
                [
                    78.2505439,
                    56.7163402
                ],
                [
                    78.2494858,
                    56.7170549
                ],
                [
                    78.2494451,
                    56.7176355
                ]
            ],
            "longitude": 78.26532,
            "latitude": 56.720875
        },
        "3322": {
            "name": "Нагорное",
            "population": 1583,
            "type": "village",
            "poly": [
                [
                    78.2576886,
                    55.4266873
                ],
                [
                    78.2840772,
                    55.433267
                ],
                [
                    78.2877124,
                    55.431353
                ],
                [
                    78.2902919,
                    55.4297972
                ],
                [
                    78.2637619,
                    55.4222609
                ],
                [
                    78.2576886,
                    55.4266873
                ]
            ],
            "longitude": 78.271965,
            "latitude": 55.426979
        },
        "3323": {
            "name": "Новороссийское",
            "population": 474,
            "type": "village",
            "poly": [
                [
                    78.2641452,
                    54.3494515
                ],
                [
                    78.2655847,
                    54.3509297
                ],
                [
                    78.2762782,
                    54.3488922
                ],
                [
                    78.286766,
                    54.3467347
                ],
                [
                    78.2930038,
                    54.3446969
                ],
                [
                    78.2895764,
                    54.3409807
                ],
                [
                    78.2851208,
                    54.342659
                ],
                [
                    78.2766894,
                    54.343698
                ],
                [
                    78.2675726,
                    54.3462552
                ],
                [
                    78.2651049,
                    54.3476137
                ],
                [
                    78.2658589,
                    54.3491719
                ],
                [
                    78.2641452,
                    54.3494515
                ]
            ],
            "longitude": 78.278557,
            "latitude": 54.347057
        },
        "3324": {
            "name": "Биаза",
            "population": 519,
            "type": "village",
            "poly": [
                [
                    78.2886136,
                    56.5995628
                ],
                [
                    78.2890928,
                    56.5998323
                ],
                [
                    78.2913242,
                    56.6000043
                ],
                [
                    78.2916812,
                    56.5985793
                ],
                [
                    78.2939127,
                    56.5982599
                ],
                [
                    78.2938235,
                    56.5970069
                ],
                [
                    78.2945775,
                    56.5968835
                ],
                [
                    78.2948517,
                    56.5972986
                ],
                [
                    78.2951398,
                    56.5972404
                ],
                [
                    78.2962118,
                    56.5970237
                ],
                [
                    78.2966569,
                    56.5969338
                ],
                [
                    78.2968853,
                    56.5971225
                ],
                [
                    78.297548,
                    56.5971476
                ],
                [
                    78.2975709,
                    56.5984433
                ],
                [
                    78.2959257,
                    56.5983804
                ],
                [
                    78.2958343,
                    56.5999276
                ],
                [
                    78.2953543,
                    56.6000282
                ],
                [
                    78.2953316,
                    56.6049587
                ],
                [
                    78.2964741,
                    56.6051851
                ],
                [
                    78.2988505,
                    56.6053989
                ],
                [
                    78.2999702,
                    56.6053109
                ],
                [
                    78.2998102,
                    56.6051097
                ],
                [
                    78.3020724,
                    56.6048707
                ],
                [
                    78.3025521,
                    56.6038771
                ],
                [
                    78.3063224,
                    56.601676
                ],
                [
                    78.306711,
                    56.6010219
                ],
                [
                    78.3089503,
                    56.6009968
                ],
                [
                    78.3091102,
                    56.6001163
                ],
                [
                    78.3112582,
                    56.6000534
                ],
                [
                    78.3117226,
                    56.5992328
                ],
                [
                    78.3095443,
                    56.5975125
                ],
                [
                    78.308379,
                    56.596179
                ],
                [
                    78.3086989,
                    56.5958016
                ],
                [
                    78.3097043,
                    56.5955626
                ],
                [
                    78.310367,
                    56.5952103
                ],
                [
                    78.3106868,
                    56.5947826
                ],
                [
                    78.3104355,
                    56.5909832
                ],
                [
                    78.3099557,
                    56.5906938
                ],
                [
                    78.306254,
                    56.589876
                ],
                [
                    78.304723,
                    56.589876
                ],
                [
                    78.3036947,
                    56.5896369
                ],
                [
                    78.3031005,
                    56.5890078
                ],
                [
                    78.3018667,
                    56.5858495
                ],
                [
                    78.3022095,
                    56.5838739
                ],
                [
                    78.3012726,
                    56.5836726
                ],
                [
                    78.2993532,
                    56.5839998
                ],
                [
                    78.2983935,
                    56.5837355
                ],
                [
                    78.2973424,
                    56.5836222
                ],
                [
                    78.2966569,
                    56.5837984
                ],
                [
                    78.2951944,
                    56.5837607
                ],
                [
                    78.2933208,
                    56.5849309
                ],
                [
                    78.2953773,
                    56.5861767
                ],
                [
                    78.29588,
                    56.5861767
                ],
                [
                    78.29572,
                    56.5876489
                ],
                [
                    78.2953543,
                    56.5876615
                ],
                [
                    78.2949203,
                    56.5880516
                ],
                [
                    78.2940977,
                    56.5878125
                ],
                [
                    78.2930466,
                    56.5878125
                ],
                [
                    78.2926124,
                    56.5943549
                ],
                [
                    78.2910129,
                    56.5942668
                ],
                [
                    78.2906244,
                    56.5946317
                ],
                [
                    78.29083,
                    56.5956255
                ],
                [
                    78.2914242,
                    56.5965564
                ],
                [
                    78.2910586,
                    56.5973112
                ],
                [
                    78.289162,
                    56.597915
                ],
                [
                    78.2892306,
                    56.5982421
                ],
                [
                    78.2887507,
                    56.5989842
                ],
                [
                    78.2886136,
                    56.5995628
                ]
            ],
            "longitude": 78.302055,
            "latitude": 56.594597
        },
        "3325": {
            "name": "Красный Остров",
            "population": 118,
            "type": "village",
            "poly": [
                [
                    78.3017641,
                    54.1069176
                ],
                [
                    78.3072281,
                    54.1119854
                ],
                [
                    78.3109796,
                    54.1165267
                ],
                [
                    78.3203581,
                    54.1164789
                ],
                [
                    78.3189717,
                    54.11428
                ],
                [
                    78.3153019,
                    54.1120332
                ],
                [
                    78.3126054,
                    54.109945
                ],
                [
                    78.3118509,
                    54.1086317
                ],
                [
                    78.3073495,
                    54.1052394
                ],
                [
                    78.3017641,
                    54.1069176
                ]
            ],
            "longitude": 78.310982,
            "latitude": 54.112408
        },
        "3326": {
            "name": "Новокурупкаевка",
            "population": 358,
            "type": "village",
            "poly": [
                [
                    78.3146194,
                    55.0976633
                ],
                [
                    78.3153482,
                    55.0979552
                ],
                [
                    78.3148016,
                    55.0987058
                ],
                [
                    78.3186642,
                    55.0998108
                ],
                [
                    78.3210692,
                    55.1006656
                ],
                [
                    78.3210692,
                    55.1009783
                ],
                [
                    78.3219802,
                    55.1012493
                ],
                [
                    78.3209599,
                    55.1017497
                ],
                [
                    78.3227454,
                    55.102938
                ],
                [
                    78.3226361,
                    55.1040012
                ],
                [
                    78.3234013,
                    55.1041471
                ],
                [
                    78.3237657,
                    55.1036259
                ],
                [
                    78.3263529,
                    55.1045015
                ],
                [
                    78.3280654,
                    55.1048559
                ],
                [
                    78.3275917,
                    55.1055021
                ],
                [
                    78.3289765,
                    55.1057731
                ],
                [
                    78.3294502,
                    55.1053562
                ],
                [
                    78.3310535,
                    55.1057314
                ],
                [
                    78.3322925,
                    55.1048976
                ],
                [
                    78.3362643,
                    55.1059815
                ],
                [
                    78.3359727,
                    55.1062317
                ],
                [
                    78.337649,
                    55.1067111
                ],
                [
                    78.337977,
                    55.1060024
                ],
                [
                    78.3375396,
                    55.1056897
                ],
                [
                    78.3385236,
                    55.1047725
                ],
                [
                    78.3364101,
                    55.1040846
                ],
                [
                    78.3369931,
                    55.10348
                ],
                [
                    78.3342966,
                    55.1024585
                ],
                [
                    78.3341873,
                    55.1018122
                ],
                [
                    78.3296687,
                    55.0999984
                ],
                [
                    78.3241301,
                    55.0990394
                ],
                [
                    78.3217251,
                    55.0981637
                ],
                [
                    78.3155304,
                    55.0970587
                ],
                [
                    78.3146194,
                    55.0976633
                ]
            ],
            "longitude": 78.327118,
            "latitude": 55.101437
        },
        "3327": {
            "name": "Морозовка",
            "population": 693,
            "type": "village",
            "poly": [
                [
                    78.3158689,
                    53.9234231
                ],
                [
                    78.3169261,
                    53.9238381
                ],
                [
                    78.3170887,
                    53.9242053
                ],
                [
                    78.3186338,
                    53.9244926
                ],
                [
                    78.3184441,
                    53.9249714
                ],
                [
                    78.319447,
                    53.9250193
                ],
                [
                    78.3196876,
                    53.9245056
                ],
                [
                    78.3265491,
                    53.9262514
                ],
                [
                    78.3275657,
                    53.92473
                ],
                [
                    78.3289634,
                    53.9244307
                ],
                [
                    78.3323094,
                    53.9255531
                ],
                [
                    78.335359,
                    53.9253037
                ],
                [
                    78.3388744,
                    53.9256528
                ],
                [
                    78.3392556,
                    53.9229841
                ],
                [
                    78.3406533,
                    53.9226599
                ],
                [
                    78.3412887,
                    53.9217869
                ],
                [
                    78.3419663,
                    53.9213629
                ],
                [
                    78.3423899,
                    53.9215126
                ],
                [
                    78.3434064,
                    53.9211634
                ],
                [
                    78.3430252,
                    53.9207144
                ],
                [
                    78.3435758,
                    53.9203402
                ],
                [
                    78.3416699,
                    53.9181202
                ],
                [
                    78.3444229,
                    53.916873
                ],
                [
                    78.3444653,
                    53.9173469
                ],
                [
                    78.3455665,
                    53.9176463
                ],
                [
                    78.3455665,
                    53.9172971
                ],
                [
                    78.3464983,
                    53.9171723
                ],
                [
                    78.3476843,
                    53.9166734
                ],
                [
                    78.3456089,
                    53.9153014
                ],
                [
                    78.3436978,
                    53.9159379
                ],
                [
                    78.3433641,
                    53.9145281
                ],
                [
                    78.3415851,
                    53.9146278
                ],
                [
                    78.3398909,
                    53.9153762
                ],
                [
                    78.3402298,
                    53.9162493
                ],
                [
                    78.3333259,
                    53.9172222
                ],
                [
                    78.3333801,
                    53.9181552
                ],
                [
                    78.3316724,
                    53.9176603
                ],
                [
                    78.3295851,
                    53.9173889
                ],
                [
                    78.3245703,
                    53.915936
                ],
                [
                    78.3250582,
                    53.9155848
                ],
                [
                    78.3257359,
                    53.914579
                ],
                [
                    78.3288803,
                    53.9146907
                ],
                [
                    78.3290701,
                    53.9149302
                ],
                [
                    78.3309947,
                    53.9148344
                ],
                [
                    78.3310218,
                    53.9143554
                ],
                [
                    78.3327567,
                    53.9142756
                ],
                [
                    78.3329571,
                    53.914039
                ],
                [
                    78.3331633,
                    53.9138445
                ],
                [
                    78.3329464,
                    53.9125672
                ],
                [
                    78.3289617,
                    53.9127269
                ],
                [
                    78.3277147,
                    53.9128865
                ],
                [
                    78.3279045,
                    53.9123277
                ],
                [
                    78.326251,
                    53.9119445
                ],
                [
                    78.3245161,
                    53.9135891
                ],
                [
                    78.3240282,
                    53.9131101
                ],
                [
                    78.3222662,
                    53.9127907
                ],
                [
                    78.3222933,
                    53.9135092
                ],
                [
                    78.3231607,
                    53.9138285
                ],
                [
                    78.3229439,
                    53.9142117
                ],
                [
                    78.3213174,
                    53.9151378
                ],
                [
                    78.3209922,
                    53.9162873
                ],
                [
                    78.3193386,
                    53.9173729
                ],
                [
                    78.3170887,
                    53.9211085
                ],
                [
                    78.3158689,
                    53.9234231
                ]
            ],
            "longitude": 78.334526,
            "latitude": 53.921417
        },
        "3328": {
            "name": "Чулым",
            "population": 825,
            "type": "village",
            "poly": [
                [
                    78.3191325,
                    54.5631999
                ],
                [
                    78.3193085,
                    54.564186
                ],
                [
                    78.3207161,
                    54.5650361
                ],
                [
                    78.3196102,
                    54.5662378
                ],
                [
                    78.3251135,
                    54.5674861
                ],
                [
                    78.3309,
                    54.5691745
                ],
                [
                    78.3375035,
                    54.5687413
                ],
                [
                    78.3402464,
                    54.5669403
                ],
                [
                    78.3386042,
                    54.5656482
                ],
                [
                    78.3395426,
                    54.56405
                ],
                [
                    78.3415953,
                    54.5629618
                ],
                [
                    78.3421232,
                    54.5620777
                ],
                [
                    78.341478,
                    54.5608534
                ],
                [
                    78.3424766,
                    54.5590987
                ],
                [
                    78.3359229,
                    54.5568475
                ],
                [
                    78.3297481,
                    54.5566363
                ],
                [
                    78.3265435,
                    54.5570207
                ],
                [
                    78.3214868,
                    54.5595717
                ],
                [
                    78.3207416,
                    54.5616925
                ],
                [
                    78.3191325,
                    54.5631999
                ]
            ],
            "longitude": 78.334602,
            "latitude": 54.56353
        },
        "3329": {
            "name": "Комсомольский",
            "population": 195,
            "type": "village",
            "poly": [
                [
                    78.329046,
                    55.5447585
                ],
                [
                    78.3291298,
                    55.5464779
                ],
                [
                    78.332651,
                    55.5473909
                ],
                [
                    78.334223,
                    55.5456597
                ],
                [
                    78.33678,
                    55.5470115
                ],
                [
                    78.340909,
                    55.5481972
                ],
                [
                    78.3418732,
                    55.5476874
                ],
                [
                    78.3433403,
                    55.5475095
                ],
                [
                    78.3455411,
                    55.5461103
                ],
                [
                    78.345059,
                    55.5459087
                ],
                [
                    78.3478885,
                    55.5434304
                ],
                [
                    78.3503408,
                    55.5438929
                ],
                [
                    78.3511372,
                    55.5430154
                ],
                [
                    78.3500264,
                    55.5425884
                ],
                [
                    78.3434451,
                    55.5408333
                ],
                [
                    78.339861,
                    55.5410112
                ],
                [
                    78.3371782,
                    55.5410349
                ],
                [
                    78.3370315,
                    55.5416872
                ],
                [
                    78.3332588,
                    55.5410468
                ],
                [
                    78.3303874,
                    55.5433948
                ],
                [
                    78.329046,
                    55.5447585
                ]
            ],
            "longitude": 78.341759,
            "latitude": 55.54467
        },
        "3330": {
            "name": "Аул-Бергуль",
            "population": 540,
            "type": "village",
            "poly": [
                [
                    78.3433169,
                    55.6046764
                ],
                [
                    78.348822,
                    55.606239
                ],
                [
                    78.3502736,
                    55.6071209
                ],
                [
                    78.3567647,
                    55.6092558
                ],
                [
                    78.3594214,
                    55.6109265
                ],
                [
                    78.3597775,
                    55.6109265
                ],
                [
                    78.3615577,
                    55.6095961
                ],
                [
                    78.369117,
                    55.6125198
                ],
                [
                    78.3702947,
                    55.6111895
                ],
                [
                    78.3644883,
                    55.6090547
                ],
                [
                    78.3662448,
                    55.6074988
                ],
                [
                    78.3668985,
                    55.6069197
                ],
                [
                    78.3595858,
                    55.6046919
                ],
                [
                    78.3499449,
                    55.5997251
                ],
                [
                    78.3477148,
                    55.6024906
                ],
                [
                    78.3457271,
                    55.6024948
                ],
                [
                    78.3433169,
                    55.6046764
                ]
            ],
            "longitude": 78.358383,
            "latitude": 55.605766
        },
        "3331": {
            "name": "Чернокурья",
            "population": 643,
            "type": "village",
            "poly": [
                [
                    78.3584296,
                    53.847776
                ],
                [
                    78.3584573,
                    53.8481678
                ],
                [
                    78.3593705,
                    53.8486249
                ],
                [
                    78.3639092,
                    53.849833
                ],
                [
                    78.3689184,
                    53.8502412
                ],
                [
                    78.3704682,
                    53.8502575
                ],
                [
                    78.3718188,
                    53.8512901
                ],
                [
                    78.3736509,
                    53.8519227
                ],
                [
                    78.3767505,
                    53.8533755
                ],
                [
                    78.378577,
                    53.8535551
                ],
                [
                    78.380625,
                    53.8539795
                ],
                [
                    78.3827006,
                    53.8551875
                ],
                [
                    78.3837523,
                    53.8554813
                ],
                [
                    78.3843888,
                    53.8552854
                ],
                [
                    78.3858616,
                    53.8545666
                ],
                [
                    78.3864644,
                    53.8549263
                ],
                [
                    78.3872116,
                    53.8548447
                ],
                [
                    78.3869626,
                    53.8537673
                ],
                [
                    78.3854404,
                    53.8519553
                ],
                [
                    78.3834478,
                    53.8507962
                ],
                [
                    78.3823962,
                    53.8502412
                ],
                [
                    78.3802652,
                    53.849229
                ],
                [
                    78.3795733,
                    53.8492453
                ],
                [
                    78.3781896,
                    53.8487555
                ],
                [
                    78.3786324,
                    53.8480045
                ],
                [
                    78.3787984,
                    53.8472698
                ],
                [
                    78.3799054,
                    53.8463719
                ],
                [
                    78.3792689,
                    53.8454412
                ],
                [
                    78.375339,
                    53.8447718
                ],
                [
                    78.3719904,
                    53.8458004
                ],
                [
                    78.3713815,
                    53.8469106
                ],
                [
                    78.3651823,
                    53.846927
                ],
                [
                    78.3638608,
                    53.8463486
                ],
                [
                    78.3633185,
                    53.8456636
                ],
                [
                    78.3640113,
                    53.8444857
                ],
                [
                    78.365459,
                    53.8437268
                ],
                [
                    78.3675277,
                    53.8423055
                ],
                [
                    78.3661786,
                    53.8417184
                ],
                [
                    78.3654037,
                    53.8422736
                ],
                [
                    78.362996,
                    53.8410816
                ],
                [
                    78.3616676,
                    53.8420613
                ],
                [
                    78.3603392,
                    53.8436452
                ],
                [
                    78.3612524,
                    53.8443309
                ],
                [
                    78.3615569,
                    53.8456208
                ],
                [
                    78.3615569,
                    53.84598
                ],
                [
                    78.3598687,
                    53.846976
                ],
                [
                    78.3584296,
                    53.847776
                ]
            ],
            "longitude": 78.374512,
            "latitude": 53.849899
        },
        "3332": {
            "name": "Петраки",
            "population": 451,
            "type": "village",
            "poly": [
                [
                    78.3635271,
                    54.7565509
                ],
                [
                    78.3643129,
                    54.7564659
                ],
                [
                    78.3641164,
                    54.7578262
                ],
                [
                    78.3677997,
                    54.7579112
                ],
                [
                    78.3690274,
                    54.7598948
                ],
                [
                    78.3704025,
                    54.7606882
                ],
                [
                    78.375068,
                    54.7616516
                ],
                [
                    78.3784074,
                    54.7623033
                ],
                [
                    78.3874437,
                    54.7641167
                ],
                [
                    78.3881803,
                    54.7633517
                ],
                [
                    78.3943191,
                    54.7649384
                ],
                [
                    78.3953504,
                    54.7634084
                ],
                [
                    78.3924529,
                    54.76253
                ],
                [
                    78.3940244,
                    54.7609432
                ],
                [
                    78.3899483,
                    54.7594131
                ],
                [
                    78.3839078,
                    54.7573728
                ],
                [
                    78.3833184,
                    54.7581662
                ],
                [
                    78.3783583,
                    54.756891
                ],
                [
                    78.3771306,
                    54.7556441
                ],
                [
                    78.3769833,
                    54.7548789
                ],
                [
                    78.369273,
                    54.7537736
                ],
                [
                    78.3635762,
                    54.7547939
                ],
                [
                    78.3635271,
                    54.7565509
                ]
            ],
            "longitude": 78.377716,
            "latitude": 54.758919
        },
        "3333": {
            "name": "Кукарка",
            "population": 423,
            "type": "village",
            "poly": [
                [
                    78.3871701,
                    54.2116214
                ],
                [
                    78.3915931,
                    54.2170422
                ],
                [
                    78.3970693,
                    54.2146518
                ],
                [
                    78.4039262,
                    54.2115949
                ],
                [
                    78.407728,
                    54.2109993
                ],
                [
                    78.4107152,
                    54.2098479
                ],
                [
                    78.4061666,
                    54.1996032
                ],
                [
                    78.4050803,
                    54.1965055
                ],
                [
                    78.4003959,
                    54.196704
                ],
                [
                    78.4010748,
                    54.1985706
                ],
                [
                    78.3991739,
                    54.1987295
                ],
                [
                    78.3977482,
                    54.1973395
                ],
                [
                    78.3965941,
                    54.1973395
                ],
                [
                    78.3971372,
                    54.2001195
                ],
                [
                    78.399717,
                    54.2002386
                ],
                [
                    78.3995133,
                    54.2013903
                ],
                [
                    78.3975445,
                    54.2015491
                ],
                [
                    78.3980923,
                    54.2052917
                ],
                [
                    78.3925943,
                    54.2067817
                ],
                [
                    78.3871701,
                    54.2116214
                ]
            ],
            "longitude": 78.402504,
            "latitude": 54.208897
        },
        "3334": {
            "name": "Кармакла",
            "population": 410,
            "type": "village",
            "poly": [
                [
                    78.3943342,
                    54.9617558
                ],
                [
                    78.4011202,
                    54.9633231
                ],
                [
                    78.4006664,
                    54.9638666
                ],
                [
                    78.4065266,
                    54.9660963
                ],
                [
                    78.4125231,
                    54.9678566
                ],
                [
                    78.4129661,
                    54.9675046
                ],
                [
                    78.4187885,
                    54.9687134
                ],
                [
                    78.4197159,
                    54.9674891
                ],
                [
                    78.4203265,
                    54.9671987
                ],
                [
                    78.4224024,
                    54.9667781
                ],
                [
                    78.4232269,
                    54.9668489
                ],
                [
                    78.4234316,
                    54.9663775
                ],
                [
                    78.4180064,
                    54.964585
                ],
                [
                    78.4177447,
                    54.9649655
                ],
                [
                    78.4118833,
                    54.9628324
                ],
                [
                    78.3961771,
                    54.9590819
                ],
                [
                    78.3943342,
                    54.9617558
                ]
            ],
            "longitude": 78.407921,
            "latitude": 54.963764
        },
        "3335": {
            "name": "Витинск",
            "population": 306,
            "type": "village",
            "poly": [
                [
                    78.4024083,
                    56.2977448
                ],
                [
                    78.403498,
                    56.2977931
                ],
                [
                    78.40328,
                    56.2980955
                ],
                [
                    78.4037813,
                    56.2984824
                ],
                [
                    78.4070937,
                    56.2996311
                ],
                [
                    78.4091205,
                    56.2995465
                ],
                [
                    78.4098006,
                    56.2994027
                ],
                [
                    78.4118663,
                    56.2989661
                ],
                [
                    78.4113476,
                    56.2995615
                ],
                [
                    78.4112661,
                    56.299655
                ],
                [
                    78.4102755,
                    56.3007919
                ],
                [
                    78.4101665,
                    56.3013602
                ],
                [
                    78.4110818,
                    56.3017955
                ],
                [
                    78.4118881,
                    56.3017713
                ],
                [
                    78.4121279,
                    56.3025572
                ],
                [
                    78.4096435,
                    56.3037663
                ],
                [
                    78.4112344,
                    56.3048786
                ],
                [
                    78.410489,
                    56.3060063
                ],
                [
                    78.4135961,
                    56.3066675
                ],
                [
                    78.4148305,
                    56.3057702
                ],
                [
                    78.4140643,
                    56.3053452
                ],
                [
                    78.4159797,
                    56.3035505
                ],
                [
                    78.4146177,
                    56.3025351
                ],
                [
                    78.4132131,
                    56.3016613
                ],
                [
                    78.4135961,
                    56.3006695
                ],
                [
                    78.4142772,
                    56.3006695
                ],
                [
                    78.4147879,
                    56.3010237
                ],
                [
                    78.4172566,
                    56.3010946
                ],
                [
                    78.4172141,
                    56.301496
                ],
                [
                    78.4195551,
                    56.301496
                ],
                [
                    78.4196027,
                    56.3011547
                ],
                [
                    78.4200604,
                    56.3011426
                ],
                [
                    78.4200604,
                    56.3006347
                ],
                [
                    78.421891,
                    56.3006468
                ],
                [
                    78.4220217,
                    56.3001269
                ],
                [
                    78.4215423,
                    56.299873
                ],
                [
                    78.4214987,
                    56.2989056
                ],
                [
                    78.4225883,
                    56.2988814
                ],
                [
                    78.4231767,
                    56.2991958
                ],
                [
                    78.4252906,
                    56.297515
                ],
                [
                    78.4236998,
                    56.2969467
                ],
                [
                    78.4230024,
                    56.2974908
                ],
                [
                    78.4222162,
                    56.2974444
                ],
                [
                    78.4219781,
                    56.2974304
                ],
                [
                    78.421891,
                    56.2967411
                ],
                [
                    78.4196899,
                    56.2966927
                ],
                [
                    78.4199732,
                    56.2960518
                ],
                [
                    78.4214115,
                    56.2960034
                ],
                [
                    78.4211718,
                    56.295423
                ],
                [
                    78.4202565,
                    56.2950723
                ],
                [
                    78.4192759,
                    56.2949635
                ],
                [
                    78.4173799,
                    56.2949755
                ],
                [
                    78.4152878,
                    56.2941895
                ],
                [
                    78.4140456,
                    56.2942137
                ],
                [
                    78.4112779,
                    56.2938388
                ],
                [
                    78.4103626,
                    56.2928714
                ],
                [
                    78.4083141,
                    56.2934155
                ],
                [
                    78.4080962,
                    56.2937904
                ],
                [
                    78.4051324,
                    56.2941895
                ],
                [
                    78.4048927,
                    56.2940202
                ],
                [
                    78.4033236,
                    56.2939597
                ],
                [
                    78.402648,
                    56.2961969
                ],
                [
                    78.4024557,
                    56.297439
                ],
                [
                    78.4024083,
                    56.2977448
                ]
            ],
            "longitude": 78.412582,
            "latitude": 56.297817
        },
        "3336": {
            "name": "Сергино",
            "population": 167,
            "type": "village",
            "poly": null,
            "longitude": 78.426849,
            "latitude": 55.787617
        },
        "3337": {
            "name": "Среднеичинский",
            "population": 98,
            "type": "village",
            "poly": [
                [
                    78.4372133,
                    55.8887801
                ],
                [
                    78.4379478,
                    55.8892768
                ],
                [
                    78.4379046,
                    55.8896766
                ],
                [
                    78.4384447,
                    55.8907426
                ],
                [
                    78.4385743,
                    55.8924264
                ],
                [
                    78.4375806,
                    55.8930684
                ],
                [
                    78.4383583,
                    55.8939527
                ],
                [
                    78.4404105,
                    55.8949702
                ],
                [
                    78.4401945,
                    55.8953093
                ],
                [
                    78.4416202,
                    55.8964115
                ],
                [
                    78.4428083,
                    55.8965932
                ],
                [
                    78.4435644,
                    55.8965327
                ],
                [
                    78.4442773,
                    55.8967022
                ],
                [
                    78.4446661,
                    55.8975985
                ],
                [
                    78.4462863,
                    55.8972957
                ],
                [
                    78.4484466,
                    55.8977318
                ],
                [
                    78.4489002,
                    55.8973078
                ],
                [
                    78.4509956,
                    55.8980467
                ],
                [
                    78.4514925,
                    55.898519
                ],
                [
                    78.4513413,
                    55.8987491
                ],
                [
                    78.4518381,
                    55.8992942
                ],
                [
                    78.4530046,
                    55.8995243
                ],
                [
                    78.4539984,
                    55.8989187
                ],
                [
                    78.4535879,
                    55.8986159
                ],
                [
                    78.4541928,
                    55.898192
                ],
                [
                    78.4518165,
                    55.8972715
                ],
                [
                    78.4522702,
                    55.8965448
                ],
                [
                    78.4490298,
                    55.8953578
                ],
                [
                    78.4488786,
                    55.8955273
                ],
                [
                    78.4483817,
                    55.8953699
                ],
                [
                    78.446848,
                    55.8943888
                ],
                [
                    78.4472152,
                    55.8942555
                ],
                [
                    78.4468048,
                    55.8937589
                ],
                [
                    78.4459839,
                    55.8940011
                ],
                [
                    78.4455086,
                    55.8936377
                ],
                [
                    78.4454222,
                    55.8932501
                ],
                [
                    78.4421603,
                    55.8932622
                ],
                [
                    78.4430028,
                    55.8920388
                ],
                [
                    78.4428083,
                    55.8918571
                ],
                [
                    78.4434132,
                    55.8917723
                ],
                [
                    78.4434348,
                    55.8916027
                ],
                [
                    78.4425059,
                    55.8913968
                ],
                [
                    78.4419874,
                    55.8909485
                ],
                [
                    78.4405401,
                    55.8899915
                ],
                [
                    78.4403673,
                    55.8890587
                ],
                [
                    78.4405401,
                    55.8887316
                ],
                [
                    78.4390495,
                    55.8879563
                ],
                [
                    78.4372133,
                    55.8887801
                ]
            ],
            "longitude": 78.445183,
            "latitude": 55.895538
        },
        "3338": {
            "name": "Старощербаково",
            "population": 484,
            "type": "village",
            "poly": [
                [
                    78.4476643,
                    55.3658911
                ],
                [
                    78.4500207,
                    55.3667839
                ],
                [
                    78.4499731,
                    55.3671491
                ],
                [
                    78.4495447,
                    55.3675955
                ],
                [
                    78.4505444,
                    55.3679742
                ],
                [
                    78.4506396,
                    55.3682718
                ],
                [
                    78.4502825,
                    55.3687588
                ],
                [
                    78.4500207,
                    55.3687182
                ],
                [
                    78.4494495,
                    55.3694351
                ],
                [
                    78.4512584,
                    55.3699761
                ],
                [
                    78.4499493,
                    55.3713423
                ],
                [
                    78.4502587,
                    55.3718562
                ],
                [
                    78.451187,
                    55.3722079
                ],
                [
                    78.4538052,
                    55.3726542
                ],
                [
                    78.455162,
                    55.3717615
                ],
                [
                    78.4562331,
                    55.3716398
                ],
                [
                    78.4568995,
                    55.3716939
                ],
                [
                    78.4578992,
                    55.3721538
                ],
                [
                    78.4586133,
                    55.37283
                ],
                [
                    78.45828,
                    55.3732358
                ],
                [
                    78.4591607,
                    55.3733305
                ],
                [
                    78.4601366,
                    55.3715587
                ],
                [
                    78.4625168,
                    55.3723161
                ],
                [
                    78.4621598,
                    55.3727759
                ],
                [
                    78.4642543,
                    55.3737362
                ],
                [
                    78.4655396,
                    55.3742096
                ],
                [
                    78.4671582,
                    55.3739391
                ],
                [
                    78.4674676,
                    55.3728706
                ],
                [
                    78.467896,
                    55.3727354
                ],
                [
                    78.4680151,
                    55.3722349
                ],
                [
                    78.4660395,
                    55.3708148
                ],
                [
                    78.4654682,
                    55.3704766
                ],
                [
                    78.4610411,
                    55.3687588
                ],
                [
                    78.457447,
                    55.3670544
                ],
                [
                    78.4569947,
                    55.3671897
                ],
                [
                    78.4488544,
                    55.3648088
                ],
                [
                    78.4476643,
                    55.3658911
                ]
            ],
            "longitude": 78.456367,
            "latitude": 55.36911
        },
        "3339": {
            "name": "Нижний Урюм",
            "population": 418,
            "type": "village",
            "poly": [
                [
                    78.4456254,
                    54.5258235
                ],
                [
                    78.4517724,
                    54.526541
                ],
                [
                    78.4519299,
                    54.5282758
                ],
                [
                    78.4711727,
                    54.5299228
                ],
                [
                    78.4759136,
                    54.5305883
                ],
                [
                    78.4804599,
                    54.5306467
                ],
                [
                    78.482309,
                    54.5306031
                ],
                [
                    78.4864146,
                    54.5288558
                ],
                [
                    78.4855908,
                    54.5273891
                ],
                [
                    78.4824823,
                    54.5241556
                ],
                [
                    78.4858531,
                    54.5218632
                ],
                [
                    78.4853666,
                    54.5207598
                ],
                [
                    78.4816612,
                    54.5207857
                ],
                [
                    78.4736849,
                    54.5183348
                ],
                [
                    78.4721504,
                    54.5165748
                ],
                [
                    78.4670765,
                    54.5192286
                ],
                [
                    78.4569752,
                    54.521963
                ],
                [
                    78.4458819,
                    54.5250986
                ],
                [
                    78.4456254,
                    54.5258235
                ]
            ],
            "longitude": 78.470512,
            "latitude": 54.525696
        },
        "3340": {
            "name": "Белое",
            "population": 768,
            "type": "village",
            "poly": [
                [
                    78.4433261,
                    53.94095
                ],
                [
                    78.4440086,
                    53.942714
                ],
                [
                    78.4435635,
                    53.9435523
                ],
                [
                    78.4449878,
                    53.9439715
                ],
                [
                    78.4499727,
                    53.94591
                ],
                [
                    78.4499431,
                    53.9462243
                ],
                [
                    78.4508629,
                    53.9465736
                ],
                [
                    78.4506255,
                    53.9474118
                ],
                [
                    78.4519311,
                    53.9478659
                ],
                [
                    78.4525839,
                    53.9489136
                ],
                [
                    78.4522872,
                    53.9502931
                ],
                [
                    78.4517234,
                    53.9514107
                ],
                [
                    78.4513541,
                    53.9522648
                ],
                [
                    78.4541794,
                    53.9528616
                ],
                [
                    78.4547589,
                    53.9520516
                ],
                [
                    78.4564975,
                    53.9523927
                ],
                [
                    78.4580188,
                    53.9504743
                ],
                [
                    78.4569322,
                    53.9497922
                ],
                [
                    78.4595401,
                    53.9463389
                ],
                [
                    78.4608441,
                    53.9461683
                ],
                [
                    78.4618583,
                    53.9454862
                ],
                [
                    78.4643938,
                    53.9463389
                ],
                [
                    78.4661324,
                    53.9469358
                ],
                [
                    78.4685954,
                    53.947021
                ],
                [
                    78.4710585,
                    53.945273
                ],
                [
                    78.4733703,
                    53.9438065
                ],
                [
                    78.4759123,
                    53.9428318
                ],
                [
                    78.4774314,
                    53.9418546
                ],
                [
                    78.4788737,
                    53.9402165
                ],
                [
                    78.4812771,
                    53.9350986
                ],
                [
                    78.4803339,
                    53.9325234
                ],
                [
                    78.4791131,
                    53.9301759
                ],
                [
                    78.4763612,
                    53.9290543
                ],
                [
                    78.4743042,
                    53.9281557
                ],
                [
                    78.4714437,
                    53.9290348
                ],
                [
                    78.4697497,
                    53.9296909
                ],
                [
                    78.4697497,
                    53.9301421
                ],
                [
                    78.4709511,
                    53.930609
                ],
                [
                    78.4720787,
                    53.9316223
                ],
                [
                    78.4721908,
                    53.9319472
                ],
                [
                    78.4718583,
                    53.932356
                ],
                [
                    78.469343,
                    53.9318425
                ],
                [
                    78.4685957,
                    53.9317794
                ],
                [
                    78.4681456,
                    53.931884
                ],
                [
                    78.4681634,
                    53.9321883
                ],
                [
                    78.4648033,
                    53.9328871
                ],
                [
                    78.4638002,
                    53.9333276
                ],
                [
                    78.4641561,
                    53.9341902
                ],
                [
                    78.4635627,
                    53.9346968
                ],
                [
                    78.4605908,
                    53.9368528
                ],
                [
                    78.4525542,
                    53.9397274
                ],
                [
                    78.449854,
                    53.9406007
                ],
                [
                    78.4435635,
                    53.9400069
                ],
                [
                    78.4433261,
                    53.94095
                ]
            ],
            "longitude": 78.471031,
            "latitude": 53.935505
        },
        "3341": {
            "name": "Ирбизино",
            "population": 647,
            "type": "village",
            "poly": [
                [
                    78.4640589,
                    54.0358415
                ],
                [
                    78.4640589,
                    54.0363044
                ],
                [
                    78.4659597,
                    54.0388909
                ],
                [
                    78.467258,
                    54.0417768
                ],
                [
                    78.4678658,
                    54.0421129
                ],
                [
                    78.4700398,
                    54.0429202
                ],
                [
                    78.4686025,
                    54.0433558
                ],
                [
                    78.469298,
                    54.0453158
                ],
                [
                    78.4705961,
                    54.0473029
                ],
                [
                    78.4720334,
                    54.0477929
                ],
                [
                    78.4730997,
                    54.0471941
                ],
                [
                    78.4742124,
                    54.0469763
                ],
                [
                    78.4745834,
                    54.0478473
                ],
                [
                    78.4741197,
                    54.0486639
                ],
                [
                    78.4749079,
                    54.0495894
                ],
                [
                    78.4786632,
                    54.0485006
                ],
                [
                    78.4791269,
                    54.0444175
                ],
                [
                    78.4810742,
                    54.0441725
                ],
                [
                    78.4810742,
                    54.0437641
                ],
                [
                    78.4830215,
                    54.0430291
                ],
                [
                    78.4835778,
                    54.0419946
                ],
                [
                    78.4817233,
                    54.0413684
                ],
                [
                    78.4800078,
                    54.0416135
                ],
                [
                    78.4782924,
                    54.0393266
                ],
                [
                    78.4797296,
                    54.0386459
                ],
                [
                    78.4786632,
                    54.0380197
                ],
                [
                    78.4791269,
                    54.0375024
                ],
                [
                    78.4806106,
                    54.037938
                ],
                [
                    78.4813987,
                    54.0374207
                ],
                [
                    78.4812597,
                    54.036495
                ],
                [
                    78.4744443,
                    54.0323562
                ],
                [
                    78.473912,
                    54.0298894
                ],
                [
                    78.4741913,
                    54.0282898
                ],
                [
                    78.4735634,
                    54.0274
                ],
                [
                    78.4728066,
                    54.0261054
                ],
                [
                    78.4718016,
                    54.024731
                ],
                [
                    78.4701788,
                    54.024731
                ],
                [
                    78.4689131,
                    54.0255953
                ],
                [
                    78.4687863,
                    54.0272093
                ],
                [
                    78.4696704,
                    54.0272713
                ],
                [
                    78.4684159,
                    54.0317315
                ],
                [
                    78.469623,
                    54.0335033
                ],
                [
                    78.4680925,
                    54.0342623
                ],
                [
                    78.4678607,
                    54.0346162
                ],
                [
                    78.4640589,
                    54.0358415
                ]
            ],
            "longitude": 78.47216,
            "latitude": 54.040543
        },
        "3342": {
            "name": "Калиновка",
            "population": 701,
            "type": "village",
            "poly": [
                [
                    78.4808606,
                    53.7175912
                ],
                [
                    78.484751,
                    53.7197961
                ],
                [
                    78.4961393,
                    53.7209449
                ],
                [
                    78.4962256,
                    53.7243873
                ],
                [
                    78.4978323,
                    53.7246949
                ],
                [
                    78.5047326,
                    53.7227207
                ],
                [
                    78.5052599,
                    53.7200537
                ],
                [
                    78.504921,
                    53.7179913
                ],
                [
                    78.5077541,
                    53.7153135
                ],
                [
                    78.5009653,
                    53.7105523
                ],
                [
                    78.4936995,
                    53.7067153
                ],
                [
                    78.4852821,
                    53.7118984
                ],
                [
                    78.4808606,
                    53.7175912
                ]
            ],
            "longitude": 78.494576,
            "latitude": 53.712082
        },
        "3343": {
            "name": "Бергуль",
            "population": 407,
            "type": "village",
            "poly": [
                [
                    78.4626112,
                    56.6077251
                ],
                [
                    78.4634988,
                    56.608409
                ],
                [
                    78.4669161,
                    56.6078961
                ],
                [
                    78.4682475,
                    56.6078961
                ],
                [
                    78.4690907,
                    56.6075297
                ],
                [
                    78.4733956,
                    56.6070656
                ],
                [
                    78.4741944,
                    56.6072366
                ],
                [
                    78.4751708,
                    56.6069923
                ],
                [
                    78.4784993,
                    56.6077007
                ],
                [
                    78.4788987,
                    56.608409
                ],
                [
                    78.4775229,
                    56.6096058
                ],
                [
                    78.4762158,
                    56.6099141
                ],
                [
                    78.4759696,
                    56.6099722
                ],
                [
                    78.4753482,
                    56.6107537
                ],
                [
                    78.4772566,
                    56.6117795
                ],
                [
                    78.4816368,
                    56.6118942
                ],
                [
                    78.4829139,
                    56.6111494
                ],
                [
                    78.4829785,
                    56.6104052
                ],
                [
                    78.481321,
                    56.609142
                ],
                [
                    78.4813058,
                    56.6087055
                ],
                [
                    78.4820395,
                    56.6085524
                ],
                [
                    78.4830704,
                    56.6086532
                ],
                [
                    78.4842687,
                    56.6088731
                ],
                [
                    78.484392,
                    56.6088183
                ],
                [
                    78.4850265,
                    56.6085362
                ],
                [
                    78.4854226,
                    56.6083601
                ],
                [
                    78.4864433,
                    56.608238
                ],
                [
                    78.4868427,
                    56.6089219
                ],
                [
                    78.4855113,
                    56.6099233
                ],
                [
                    78.4857332,
                    56.610998
                ],
                [
                    78.4849787,
                    56.6125366
                ],
                [
                    78.4858664,
                    56.6135867
                ],
                [
                    78.4872421,
                    56.6143438
                ],
                [
                    78.4888842,
                    56.6138798
                ],
                [
                    78.4884197,
                    56.612667
                ],
                [
                    78.4886623,
                    56.612268
                ],
                [
                    78.4893723,
                    56.6120481
                ],
                [
                    78.4901712,
                    56.6122191
                ],
                [
                    78.4908369,
                    56.6130983
                ],
                [
                    78.4925677,
                    56.6130739
                ],
                [
                    78.4942542,
                    56.6138065
                ],
                [
                    78.49563,
                    56.613367
                ],
                [
                    78.4982484,
                    56.6139531
                ],
                [
                    78.5011331,
                    56.6114376
                ],
                [
                    78.5014438,
                    56.6086777
                ],
                [
                    78.5027308,
                    56.6083113
                ],
                [
                    78.5045947,
                    56.6078961
                ],
                [
                    78.5047279,
                    56.6056977
                ],
                [
                    78.5034852,
                    56.6055512
                ],
                [
                    78.5032633,
                    56.6046229
                ],
                [
                    78.5024201,
                    56.604916
                ],
                [
                    78.5007337,
                    56.6044031
                ],
                [
                    78.4998461,
                    56.6019358
                ],
                [
                    78.4966507,
                    56.6021801
                ],
                [
                    78.4959406,
                    56.6016426
                ],
                [
                    78.4903487,
                    56.6024977
                ],
                [
                    78.489683,
                    56.6014473
                ],
                [
                    78.4878635,
                    56.6019114
                ],
                [
                    78.4883516,
                    56.6026198
                ],
                [
                    78.4845792,
                    56.6029374
                ],
                [
                    78.4845349,
                    56.6034748
                ],
                [
                    78.4828485,
                    56.603597
                ],
                [
                    78.4827597,
                    56.6032794
                ],
                [
                    78.4798306,
                    56.6031817
                ],
                [
                    78.4752151,
                    56.6037191
                ],
                [
                    78.4718866,
                    56.6046718
                ],
                [
                    78.4682475,
                    56.6050382
                ],
                [
                    78.4634988,
                    56.6061862
                ],
                [
                    78.4626112,
                    56.6077251
                ]
            ],
            "longitude": 78.495499,
            "latitude": 56.607479
        },
        "3344": {
            "name": "Хорошее",
            "population": 1208,
            "type": "village",
            "poly": [
                [
                    78.4801787,
                    53.5805827
                ],
                [
                    78.4803359,
                    53.5813162
                ],
                [
                    78.4805491,
                    53.5815663
                ],
                [
                    78.481319,
                    53.5842427
                ],
                [
                    78.4815186,
                    53.5843146
                ],
                [
                    78.4816709,
                    53.5850408
                ],
                [
                    78.4818922,
                    53.5852503
                ],
                [
                    78.4822496,
                    53.5854205
                ],
                [
                    78.4827318,
                    53.5855319
                ],
                [
                    78.4832952,
                    53.5855862
                ],
                [
                    78.4834323,
                    53.585773
                ],
                [
                    78.4835842,
                    53.5858587
                ],
                [
                    78.4840516,
                    53.5859086
                ],
                [
                    78.4843206,
                    53.5862973
                ],
                [
                    78.4852949,
                    53.5865259
                ],
                [
                    78.4859043,
                    53.5868306
                ],
                [
                    78.4862045,
                    53.5872407
                ],
                [
                    78.4870007,
                    53.5877225
                ],
                [
                    78.4892361,
                    53.5886981
                ],
                [
                    78.4893893,
                    53.588749
                ],
                [
                    78.4899905,
                    53.5887741
                ],
                [
                    78.4904671,
                    53.5891499
                ],
                [
                    78.4907616,
                    53.5892644
                ],
                [
                    78.4914184,
                    53.5892591
                ],
                [
                    78.4927447,
                    53.5885911
                ],
                [
                    78.4936044,
                    53.5894566
                ],
                [
                    78.4909446,
                    53.5906546
                ],
                [
                    78.492328,
                    53.5917004
                ],
                [
                    78.4916955,
                    53.591988
                ],
                [
                    78.4914213,
                    53.5918736
                ],
                [
                    78.4903149,
                    53.5924038
                ],
                [
                    78.4901017,
                    53.5922652
                ],
                [
                    78.4897429,
                    53.5924286
                ],
                [
                    78.48999,
                    53.5926327
                ],
                [
                    78.4897667,
                    53.5929401
                ],
                [
                    78.4902348,
                    53.5932533
                ],
                [
                    78.4899291,
                    53.5934824
                ],
                [
                    78.4868586,
                    53.5948273
                ],
                [
                    78.4881199,
                    53.5957099
                ],
                [
                    78.4914824,
                    53.5939945
                ],
                [
                    78.4971458,
                    53.5908475
                ],
                [
                    78.4988695,
                    53.5919146
                ],
                [
                    78.4933302,
                    53.5953603
                ],
                [
                    78.4923414,
                    53.5957849
                ],
                [
                    78.4933217,
                    53.5965117
                ],
                [
                    78.4942203,
                    53.5961699
                ],
                [
                    78.4945577,
                    53.5963701
                ],
                [
                    78.4976803,
                    53.5944913
                ],
                [
                    78.4980202,
                    53.5941575
                ],
                [
                    78.4975153,
                    53.5938565
                ],
                [
                    78.497824,
                    53.5936562
                ],
                [
                    78.4985849,
                    53.5941249
                ],
                [
                    78.4989438,
                    53.5944742
                ],
                [
                    78.5000064,
                    53.5950417
                ],
                [
                    78.501504,
                    53.5941661
                ],
                [
                    78.5026336,
                    53.5949429
                ],
                [
                    78.5035955,
                    53.5943762
                ],
                [
                    78.5039257,
                    53.5946617
                ],
                [
                    78.5033155,
                    53.5951389
                ],
                [
                    78.504299,
                    53.595812
                ],
                [
                    78.5046924,
                    53.5959561
                ],
                [
                    78.5029147,
                    53.59728
                ],
                [
                    78.5017076,
                    53.5967109
                ],
                [
                    78.5011081,
                    53.5963189
                ],
                [
                    78.5006954,
                    53.5966385
                ],
                [
                    78.5009754,
                    53.5968046
                ],
                [
                    78.5004154,
                    53.5971753
                ],
                [
                    78.5002503,
                    53.5970773
                ],
                [
                    78.4997406,
                    53.5974863
                ],
                [
                    78.4994679,
                    53.597367
                ],
                [
                    78.4992525,
                    53.5974777
                ],
                [
                    78.4989343,
                    53.5973356
                ],
                [
                    78.4985849,
                    53.5976141
                ],
                [
                    78.4990156,
                    53.5978994
                ],
                [
                    78.4983103,
                    53.5984154
                ],
                [
                    78.4994861,
                    53.5991462
                ],
                [
                    78.5001355,
                    53.5987515
                ],
                [
                    78.5005922,
                    53.5990104
                ],
                [
                    78.5015353,
                    53.5995524
                ],
                [
                    78.5029591,
                    53.6001263
                ],
                [
                    78.5034807,
                    53.5998335
                ],
                [
                    78.5032079,
                    53.5996546
                ],
                [
                    78.5034878,
                    53.5995055
                ],
                [
                    78.5043463,
                    53.6000396
                ],
                [
                    78.5059126,
                    53.5988504
                ],
                [
                    78.5110219,
                    53.602777
                ],
                [
                    78.5135981,
                    53.601267
                ],
                [
                    78.5160339,
                    53.5994241
                ],
                [
                    78.5180544,
                    53.5978896
                ],
                [
                    78.5210787,
                    53.5962175
                ],
                [
                    78.520317,
                    53.595756
                ],
                [
                    78.5209768,
                    53.5953311
                ],
                [
                    78.5206661,
                    53.595109
                ],
                [
                    78.5209441,
                    53.5949082
                ],
                [
                    78.5202854,
                    53.5944969
                ],
                [
                    78.5210801,
                    53.5940108
                ],
                [
                    78.5217644,
                    53.5944543
                ],
                [
                    78.5229764,
                    53.5937529
                ],
                [
                    78.5229489,
                    53.59349
                ],
                [
                    78.5236381,
                    53.5930725
                ],
                [
                    78.5234658,
                    53.5929361
                ],
                [
                    78.5240472,
                    53.5925868
                ],
                [
                    78.5239467,
                    53.5924632
                ],
                [
                    78.5247824,
                    53.5919369
                ],
                [
                    78.5234413,
                    53.5912115
                ],
                [
                    78.5231499,
                    53.5912575
                ],
                [
                    78.5225756,
                    53.5912701
                ],
                [
                    78.522109,
                    53.5911595
                ],
                [
                    78.5216411,
                    53.5908992
                ],
                [
                    78.5206728,
                    53.5914312
                ],
                [
                    78.5155776,
                    53.5888267
                ],
                [
                    78.5156195,
                    53.588718
                ],
                [
                    78.5164236,
                    53.5881811
                ],
                [
                    78.5166533,
                    53.5882066
                ],
                [
                    78.5170136,
                    53.5882903
                ],
                [
                    78.5173568,
                    53.5879424
                ],
                [
                    78.5181668,
                    53.5874268
                ],
                [
                    78.518089,
                    53.5871967
                ],
                [
                    78.5179742,
                    53.587005
                ],
                [
                    78.5182613,
                    53.5868047
                ],
                [
                    78.518491,
                    53.5869411
                ],
                [
                    78.5187495,
                    53.5868005
                ],
                [
                    78.5190223,
                    53.5869411
                ],
                [
                    78.5194061,
                    53.5867253
                ],
                [
                    78.519006,
                    53.5863752
                ],
                [
                    78.5193816,
                    53.5861703
                ],
                [
                    78.5188334,
                    53.5858268
                ],
                [
                    78.5188976,
                    53.5855182
                ],
                [
                    78.5184839,
                    53.585128
                ],
                [
                    78.5174974,
                    53.5850317
                ],
                [
                    78.5163177,
                    53.5852326
                ],
                [
                    78.5154365,
                    53.5852879
                ],
                [
                    78.514124,
                    53.5855808
                ],
                [
                    78.5132591,
                    53.5860182
                ],
                [
                    78.5123503,
                    53.5860683
                ],
                [
                    78.5116803,
                    53.58599
                ],
                [
                    78.5108681,
                    53.5857911
                ],
                [
                    78.5097615,
                    53.5856766
                ],
                [
                    78.5084672,
                    53.5856615
                ],
                [
                    78.507135,
                    53.5855679
                ],
                [
                    78.5052134,
                    53.5853662
                ],
                [
                    78.5043099,
                    53.5851884
                ],
                [
                    78.5021966,
                    53.5844534
                ],
                [
                    78.5012744,
                    53.5839349
                ],
                [
                    78.500975,
                    53.5835823
                ],
                [
                    78.5000664,
                    53.583061
                ],
                [
                    78.4992644,
                    53.5827235
                ],
                [
                    78.4985249,
                    53.5821479
                ],
                [
                    78.4974725,
                    53.5811655
                ],
                [
                    78.4969606,
                    53.5804732
                ],
                [
                    78.496065,
                    53.5791617
                ],
                [
                    78.4956045,
                    53.5784261
                ],
                [
                    78.494985,
                    53.57705
                ],
                [
                    78.4942645,
                    53.5754364
                ],
                [
                    78.493745,
                    53.5738466
                ],
                [
                    78.4931782,
                    53.571931
                ],
                [
                    78.4928204,
                    53.5699281
                ],
                [
                    78.4927468,
                    53.5678225
                ],
                [
                    78.4928513,
                    53.5659038
                ],
                [
                    78.4927213,
                    53.5658088
                ],
                [
                    78.4920817,
                    53.566068
                ],
                [
                    78.4917552,
                    53.5662697
                ],
                [
                    78.4916903,
                    53.5665882
                ],
                [
                    78.4912696,
                    53.5668488
                ],
                [
                    78.4896351,
                    53.5681164
                ],
                [
                    78.4898027,
                    53.5682505
                ],
                [
                    78.4897519,
                    53.5686454
                ],
                [
                    78.489625,
                    53.5689529
                ],
                [
                    78.489056,
                    53.569539
                ],
                [
                    78.4882951,
                    53.5702702
                ],
                [
                    78.4880272,
                    53.5706455
                ],
                [
                    78.4869919,
                    53.5704705
                ],
                [
                    78.486743,
                    53.570942
                ],
                [
                    78.4859682,
                    53.5707979
                ],
                [
                    78.4855262,
                    53.5721706
                ],
                [
                    78.4861124,
                    53.5722475
                ],
                [
                    78.4860414,
                    53.5726997
                ],
                [
                    78.4862986,
                    53.5727264
                ],
                [
                    78.4860616,
                    53.5734924
                ],
                [
                    78.4851074,
                    53.5734381
                ],
                [
                    78.4846142,
                    53.5757395
                ],
                [
                    78.4863205,
                    53.5758373
                ],
                [
                    78.4868941,
                    53.575994
                ],
                [
                    78.4877671,
                    53.5760181
                ],
                [
                    78.4878484,
                    53.5761084
                ],
                [
                    78.487554,
                    53.5764009
                ],
                [
                    78.4871632,
                    53.5765485
                ],
                [
                    78.4845592,
                    53.5765033
                ],
                [
                    78.4842685,
                    53.576573
                ],
                [
                    78.4840516,
                    53.5769012
                ],
                [
                    78.483979,
                    53.5773874
                ],
                [
                    78.4827521,
                    53.5773472
                ],
                [
                    78.4827977,
                    53.5770707
                ],
                [
                    78.4803427,
                    53.5769485
                ],
                [
                    78.4801787,
                    53.5805827
                ]
            ],
            "longitude": 78.504364,
            "latitude": 53.5896
        },
        "3345": {
            "name": "Лянино",
            "population": 767,
            "type": "village",
            "poly": [
                [
                    78.4827182,
                    54.360214
                ],
                [
                    78.4843463,
                    54.3609319
                ],
                [
                    78.4832657,
                    54.3628314
                ],
                [
                    78.4860773,
                    54.3635082
                ],
                [
                    78.4875495,
                    54.362926
                ],
                [
                    78.4951934,
                    54.3660076
                ],
                [
                    78.5063465,
                    54.3689695
                ],
                [
                    78.5206816,
                    54.3733785
                ],
                [
                    78.5282225,
                    54.376814
                ],
                [
                    78.534285,
                    54.3780651
                ],
                [
                    78.5350043,
                    54.377211
                ],
                [
                    78.5391358,
                    54.3740794
                ],
                [
                    78.5337853,
                    54.3721511
                ],
                [
                    78.5295614,
                    54.3707077
                ],
                [
                    78.5213081,
                    54.3687255
                ],
                [
                    78.5105297,
                    54.3653203
                ],
                [
                    78.5034233,
                    54.3628753
                ],
                [
                    78.4962462,
                    54.3616122
                ],
                [
                    78.4896543,
                    54.3594925
                ],
                [
                    78.484647,
                    54.358236
                ],
                [
                    78.4827182,
                    54.360214
                ]
            ],
            "longitude": 78.512711,
            "latitude": 54.368759
        },
        "3346": {
            "name": "Алексеевка",
            "population": 463,
            "type": "village",
            "poly": [
                [
                    78.4931722,
                    54.8827584
                ],
                [
                    78.4981849,
                    54.8842711
                ],
                [
                    78.5097717,
                    54.886729
                ],
                [
                    78.511785,
                    54.8870362
                ],
                [
                    78.5142913,
                    54.8886433
                ],
                [
                    78.519994,
                    54.890175
                ],
                [
                    78.5286721,
                    54.8925188
                ],
                [
                    78.5297814,
                    54.89129
                ],
                [
                    78.5313428,
                    54.8913845
                ],
                [
                    78.5324932,
                    54.8891632
                ],
                [
                    78.5219337,
                    54.8867999
                ],
                [
                    78.511785,
                    54.8840347
                ],
                [
                    78.5034852,
                    54.8820493
                ],
                [
                    78.4941994,
                    54.8803238
                ],
                [
                    78.4931722,
                    54.8827584
                ]
            ],
            "longitude": 78.513062,
            "latitude": 54.886375
        },
        "3347": {
            "name": "Новоульяновское",
            "population": 571,
            "type": "village",
            "poly": [
                [
                    78.5177717,
                    55.3967493
                ],
                [
                    78.5190511,
                    55.3972055
                ],
                [
                    78.5189022,
                    55.3976279
                ],
                [
                    78.5236329,
                    55.3986416
                ],
                [
                    78.5285719,
                    55.3999932
                ],
                [
                    78.5295536,
                    55.4004832
                ],
                [
                    78.5349092,
                    55.4020543
                ],
                [
                    78.5383902,
                    55.4021219
                ],
                [
                    78.5400266,
                    55.4002635
                ],
                [
                    78.538777,
                    55.3997229
                ],
                [
                    78.5395803,
                    55.3988782
                ],
                [
                    78.5394297,
                    55.3987088
                ],
                [
                    78.5390448,
                    55.3978813
                ],
                [
                    78.5370216,
                    55.3960397
                ],
                [
                    78.5348199,
                    55.3943838
                ],
                [
                    78.5336893,
                    55.3938431
                ],
                [
                    78.5316364,
                    55.3930658
                ],
                [
                    78.5296132,
                    55.3948569
                ],
                [
                    78.5224131,
                    55.391866
                ],
                [
                    78.5204707,
                    55.3933799
                ],
                [
                    78.5177717,
                    55.3967493
                ]
            ],
            "longitude": 78.530273,
            "latitude": 55.398048
        },
        "3348": {
            "name": "Маландино",
            "population": 335,
            "type": "village",
            "poly": [
                [
                    78.5317902,
                    54.8066852
                ],
                [
                    78.5391567,
                    54.8081004
                ],
                [
                    78.5395403,
                    54.8092502
                ],
                [
                    78.542533,
                    54.8096039
                ],
                [
                    78.5449885,
                    54.8110632
                ],
                [
                    78.5476742,
                    54.8096039
                ],
                [
                    78.548595,
                    54.809029
                ],
                [
                    78.5503599,
                    54.8093386
                ],
                [
                    78.5510505,
                    54.8087637
                ],
                [
                    78.5557313,
                    54.8099135
                ],
                [
                    78.5564219,
                    54.8087195
                ],
                [
                    78.5526619,
                    54.8076581
                ],
                [
                    78.5534797,
                    54.8064924
                ],
                [
                    78.5396938,
                    54.8022182
                ],
                [
                    78.537622,
                    54.8041201
                ],
                [
                    78.5340922,
                    54.8034567
                ],
                [
                    78.5317902,
                    54.8066852
                ]
            ],
            "longitude": 78.541595,
            "latitude": 54.807224
        },
        "3349": {
            "name": "Новокозловское",
            "population": 606,
            "type": "village",
            "poly": [
                [
                    78.531447,
                    55.26814
                ],
                [
                    78.5332406,
                    55.2687107
                ],
                [
                    78.5337764,
                    55.2692283
                ],
                [
                    78.5397397,
                    55.270927
                ],
                [
                    78.5426282,
                    55.271564
                ],
                [
                    78.5433986,
                    55.2717432
                ],
                [
                    78.5447713,
                    55.2718028
                ],
                [
                    78.5454935,
                    55.2722938
                ],
                [
                    78.5476598,
                    55.2729971
                ],
                [
                    78.550921,
                    55.2742843
                ],
                [
                    78.5521789,
                    55.2743374
                ],
                [
                    78.5558129,
                    55.2750009
                ],
                [
                    78.5582588,
                    55.273382
                ],
                [
                    78.5575133,
                    55.272108
                ],
                [
                    78.5511074,
                    55.2693345
                ],
                [
                    78.5525283,
                    55.2676755
                ],
                [
                    78.5556731,
                    55.2679277
                ],
                [
                    78.5635466,
                    55.2680869
                ],
                [
                    78.5647346,
                    55.2672375
                ],
                [
                    78.5609764,
                    55.2662067
                ],
                [
                    78.5594341,
                    55.2657686
                ],
                [
                    78.5573004,
                    55.2652086
                ],
                [
                    78.5538328,
                    55.2643441
                ],
                [
                    78.5487314,
                    55.2665607
                ],
                [
                    78.5479859,
                    55.2672641
                ],
                [
                    78.5479613,
                    55.2680015
                ],
                [
                    78.5387824,
                    55.2662318
                ],
                [
                    78.5354536,
                    55.2666801
                ],
                [
                    78.5338874,
                    55.2670591
                ],
                [
                    78.5337531,
                    55.2670915
                ],
                [
                    78.5331241,
                    55.2679144
                ],
                [
                    78.5318197,
                    55.2675959
                ],
                [
                    78.531447,
                    55.26814
                ]
            ],
            "longitude": 78.54528,
            "latitude": 55.269753
        },
        "3350": {
            "name": "Чебаки",
            "population": 237,
            "type": "village",
            "poly": [
                [
                    78.5358031,
                    56.3266297
                ],
                [
                    78.5400807,
                    56.3269143
                ],
                [
                    78.5415718,
                    56.3271989
                ],
                [
                    78.5426962,
                    56.3277004
                ],
                [
                    78.5425984,
                    56.3285677
                ],
                [
                    78.5436495,
                    56.3291776
                ],
                [
                    78.5451949,
                    56.3284086
                ],
                [
                    78.5455561,
                    56.3282289
                ],
                [
                    78.5466072,
                    56.3279985
                ],
                [
                    78.5484893,
                    56.3277953
                ],
                [
                    78.5494671,
                    56.3276191
                ],
                [
                    78.5489538,
                    56.3267788
                ],
                [
                    78.5504693,
                    56.3261011
                ],
                [
                    78.5510804,
                    56.3254506
                ],
                [
                    78.5520337,
                    56.3255048
                ],
                [
                    78.5526448,
                    56.3263587
                ],
                [
                    78.5551869,
                    56.3261011
                ],
                [
                    78.5559935,
                    56.3253015
                ],
                [
                    78.5569918,
                    56.3254906
                ],
                [
                    78.5579246,
                    56.3256674
                ],
                [
                    78.5603934,
                    56.325681
                ],
                [
                    78.5610779,
                    56.3237835
                ],
                [
                    78.5582912,
                    56.323038
                ],
                [
                    78.5559935,
                    56.3225772
                ],
                [
                    78.5534759,
                    56.3222518
                ],
                [
                    78.5533536,
                    56.321303
                ],
                [
                    78.5537692,
                    56.321059
                ],
                [
                    78.5548203,
                    56.3208964
                ],
                [
                    78.5562624,
                    56.3209099
                ],
                [
                    78.5568002,
                    56.3207337
                ],
                [
                    78.5582424,
                    56.3210319
                ],
                [
                    78.5590246,
                    56.3208015
                ],
                [
                    78.5589023,
                    56.3204084
                ],
                [
                    78.5583402,
                    56.3197442
                ],
                [
                    78.5574846,
                    56.3183479
                ],
                [
                    78.5524003,
                    56.3183479
                ],
                [
                    78.5519115,
                    56.3185242
                ],
                [
                    78.5522292,
                    56.3198391
                ],
                [
                    78.5520826,
                    56.3220756
                ],
                [
                    78.5457517,
                    56.3212895
                ],
                [
                    78.5445295,
                    56.3212488
                ],
                [
                    78.5368786,
                    56.3219265
                ],
                [
                    78.5371719,
                    56.3226856
                ],
                [
                    78.5365608,
                    56.3245696
                ],
                [
                    78.5362186,
                    56.325044
                ],
                [
                    78.5358031,
                    56.3266297
                ]
            ],
            "longitude": 78.547653,
            "latitude": 56.324432
        },
        "3351": {
            "name": "Отрадненское",
            "population": 631,
            "type": "village",
            "poly": null,
            "longitude": 78.5495,
            "latitude": 55.52837
        },
        "3352": {
            "name": "Рождественский",
            "population": 445,
            "type": "village",
            "poly": [
                [
                    78.5705964,
                    54.0983698
                ],
                [
                    78.5721985,
                    54.1007343
                ],
                [
                    78.574808,
                    54.1027399
                ],
                [
                    78.573414,
                    54.1051375
                ],
                [
                    78.5732281,
                    54.1076985
                ],
                [
                    78.5749939,
                    54.1088427
                ],
                [
                    78.5791297,
                    54.1099324
                ],
                [
                    78.5821031,
                    54.1107849
                ],
                [
                    78.5868404,
                    54.1078882
                ],
                [
                    78.5856041,
                    54.1055848
                ],
                [
                    78.582522,
                    54.1045381
                ],
                [
                    78.5821038,
                    54.1028489
                ],
                [
                    78.5824755,
                    54.1024129
                ],
                [
                    78.5813602,
                    54.101868
                ],
                [
                    78.5811744,
                    54.1012413
                ],
                [
                    78.5826614,
                    54.0994429
                ],
                [
                    78.5831726,
                    54.0988707
                ],
                [
                    78.5837168,
                    54.0973698
                ],
                [
                    78.5844949,
                    54.0956188
                ],
                [
                    78.5857325,
                    54.0940227
                ],
                [
                    78.5762991,
                    54.0940406
                ],
                [
                    78.5705964,
                    54.0983698
                ]
            ],
            "longitude": 78.577538,
            "latitude": 54.099194
        },
        "3353": {
            "name": "Верх-Урюм",
            "population": 805,
            "type": "village",
            "poly": [
                [
                    78.5571862,
                    54.4973995
                ],
                [
                    78.5631858,
                    54.4978055
                ],
                [
                    78.5670844,
                    54.4974701
                ],
                [
                    78.5771196,
                    54.4971347
                ],
                [
                    78.5822454,
                    54.4978894
                ],
                [
                    78.5895372,
                    54.4988956
                ],
                [
                    78.5943355,
                    54.5011111
                ],
                [
                    78.5992534,
                    54.5016183
                ],
                [
                    78.6028753,
                    54.5015122
                ],
                [
                    78.6038961,
                    54.4999851
                ],
                [
                    78.606385,
                    54.501403
                ],
                [
                    78.6093307,
                    54.5015486
                ],
                [
                    78.6099574,
                    54.4999836
                ],
                [
                    78.6087666,
                    54.4991829
                ],
                [
                    78.6123825,
                    54.4954502
                ],
                [
                    78.6083279,
                    54.4923036
                ],
                [
                    78.606864,
                    54.4869452
                ],
                [
                    78.6018826,
                    54.4852257
                ],
                [
                    78.5922084,
                    54.4838836
                ],
                [
                    78.5857108,
                    54.4851838
                ],
                [
                    78.5777811,
                    54.4893456
                ],
                [
                    78.5707756,
                    54.4909789
                ],
                [
                    78.5724786,
                    54.4927768
                ],
                [
                    78.5597809,
                    54.4938482
                ],
                [
                    78.5571862,
                    54.4973995
                ]
            ],
            "longitude": 78.587952,
            "latitude": 54.492649
        },
        "3354": {
            "name": "Таскаево",
            "population": 875,
            "type": "village",
            "poly": [
                [
                    78.5797145,
                    55.091505
                ],
                [
                    78.5837663,
                    55.0924191
                ],
                [
                    78.5839611,
                    55.0931103
                ],
                [
                    78.5883635,
                    55.0927759
                ],
                [
                    78.5916361,
                    55.093088
                ],
                [
                    78.5929997,
                    55.0933778
                ],
                [
                    78.5945191,
                    55.0945594
                ],
                [
                    78.5945581,
                    55.0967218
                ],
                [
                    78.590779,
                    55.1000878
                ],
                [
                    78.5956489,
                    55.1015589
                ],
                [
                    78.596584,
                    55.1006005
                ],
                [
                    78.5959606,
                    55.0993076
                ],
                [
                    78.5968177,
                    55.097502
                ],
                [
                    78.5989215,
                    55.0966549
                ],
                [
                    78.6027006,
                    55.0967218
                ],
                [
                    78.6054667,
                    55.0972122
                ],
                [
                    78.6074536,
                    55.0983714
                ],
                [
                    78.6082718,
                    55.0999317
                ],
                [
                    78.610921,
                    55.1007788
                ],
                [
                    78.6131693,
                    55.1012731
                ],
                [
                    78.6150507,
                    55.1017149
                ],
                [
                    78.6170376,
                    55.1014029
                ],
                [
                    78.6184791,
                    55.1016035
                ],
                [
                    78.6201934,
                    55.1005782
                ],
                [
                    78.6172324,
                    55.0993968
                ],
                [
                    78.6181285,
                    55.0984828
                ],
                [
                    78.6166003,
                    55.0979909
                ],
                [
                    78.6108431,
                    55.095518
                ],
                [
                    78.6064017,
                    55.0940689
                ],
                [
                    78.6062459,
                    55.0930434
                ],
                [
                    78.6030123,
                    55.0916834
                ],
                [
                    78.6018435,
                    55.0920178
                ],
                [
                    78.5996228,
                    55.0920624
                ],
                [
                    78.5956879,
                    55.0907024
                ],
                [
                    78.5903672,
                    55.0888939
                ],
                [
                    78.5892596,
                    55.0885174
                ],
                [
                    78.584039,
                    55.0860646
                ],
                [
                    78.58213,
                    55.0877816
                ],
                [
                    78.5803379,
                    55.0898329
                ],
                [
                    78.5797145,
                    55.091505
                ]
            ],
            "longitude": 78.600731,
            "latitude": 55.094349
        },
        "3355": {
            "name": "Зубково",
            "population": 617,
            "type": "village",
            "poly": [
                [
                    78.6382298,
                    53.7255365
                ],
                [
                    78.6524241,
                    53.7273328
                ],
                [
                    78.6693197,
                    53.7274214
                ],
                [
                    78.6700784,
                    53.7225579
                ],
                [
                    78.6619215,
                    53.7224082
                ],
                [
                    78.6583805,
                    53.7188163
                ],
                [
                    78.6406756,
                    53.7217722
                ],
                [
                    78.6382298,
                    53.7255365
                ]
            ],
            "longitude": 78.656296,
            "latitude": 53.724369
        },
        "3356": {
            "name": "Зубково",
            "population": 711,
            "type": "village",
            "poly": [
                [
                    78.6507956,
                    53.7681169
                ],
                [
                    78.6571188,
                    53.7745147
                ],
                [
                    78.6558036,
                    53.7795366
                ],
                [
                    78.6601666,
                    53.7862111
                ],
                [
                    78.6722982,
                    53.7832346
                ],
                [
                    78.6766118,
                    53.7780051
                ],
                [
                    78.6623739,
                    53.7705124
                ],
                [
                    78.6552919,
                    53.7636953
                ],
                [
                    78.6507956,
                    53.7681169
                ]
            ],
            "longitude": 78.660782,
            "latitude": 53.778336
        },
        "3357": {
            "name": "Новотроицк",
            "population": 419,
            "type": "village",
            "poly": [
                [
                    78.6645804,
                    56.1872127
                ],
                [
                    78.6664045,
                    56.1875844
                ],
                [
                    78.6659935,
                    56.1882277
                ],
                [
                    78.6681259,
                    56.1885851
                ],
                [
                    78.66828,
                    56.1892571
                ],
                [
                    78.6688966,
                    56.1898718
                ],
                [
                    78.6699757,
                    56.1902292
                ],
                [
                    78.6694361,
                    56.1911441
                ],
                [
                    78.6674579,
                    56.1930596
                ],
                [
                    78.6673808,
                    56.1934885
                ],
                [
                    78.6681002,
                    56.1936886
                ],
                [
                    78.6685076,
                    56.1936738
                ],
                [
                    78.6703141,
                    56.1946789
                ],
                [
                    78.6718695,
                    56.1947347
                ],
                [
                    78.6732746,
                    56.1940647
                ],
                [
                    78.6741778,
                    56.1939809
                ],
                [
                    78.6777907,
                    56.1934505
                ],
                [
                    78.6822566,
                    56.1956281
                ],
                [
                    78.6836615,
                    56.1943439
                ],
                [
                    78.686321,
                    56.1950418
                ],
                [
                    78.687726,
                    56.194651
                ],
                [
                    78.6885791,
                    56.1937018
                ],
                [
                    78.6903353,
                    56.1943997
                ],
                [
                    78.6916902,
                    56.1945952
                ],
                [
                    78.6926435,
                    56.194986
                ],
                [
                    78.6932959,
                    56.1943439
                ],
                [
                    78.6927439,
                    56.1941205
                ],
                [
                    78.6936471,
                    56.1933109
                ],
                [
                    78.6935467,
                    56.1928921
                ],
                [
                    78.6880773,
                    56.1906864
                ],
                [
                    78.6847655,
                    56.189402
                ],
                [
                    78.6850666,
                    56.1880897
                ],
                [
                    78.6824573,
                    56.1872799
                ],
                [
                    78.6829591,
                    56.1862188
                ],
                [
                    78.6823569,
                    56.186135
                ],
                [
                    78.6819555,
                    56.1868052
                ],
                [
                    78.6800989,
                    56.1869448
                ],
                [
                    78.6802493,
                    56.186526
                ],
                [
                    78.6783425,
                    56.1864701
                ],
                [
                    78.677891,
                    56.186135
                ],
                [
                    78.6769878,
                    56.1860792
                ],
                [
                    78.6781969,
                    56.1840815
                ],
                [
                    78.6775032,
                    56.18391
                ],
                [
                    78.6785309,
                    56.183095
                ],
                [
                    78.6788135,
                    56.1831522
                ],
                [
                    78.6793017,
                    56.1812218
                ],
                [
                    78.6784795,
                    56.1811646
                ],
                [
                    78.6760388,
                    56.1805498
                ],
                [
                    78.6745744,
                    56.1804068
                ],
                [
                    78.6741377,
                    56.1794487
                ],
                [
                    78.6731357,
                    56.1792199
                ],
                [
                    78.6726733,
                    56.179892
                ],
                [
                    78.671183,
                    56.1799063
                ],
                [
                    78.6698986,
                    56.1795345
                ],
                [
                    78.6695903,
                    56.1796632
                ],
                [
                    78.6701298,
                    56.1803639
                ],
                [
                    78.6701298,
                    56.1807214
                ],
                [
                    78.6691278,
                    56.1818367
                ],
                [
                    78.6687682,
                    56.1826374
                ],
                [
                    78.6679203,
                    56.183338
                ],
                [
                    78.66512,
                    56.1842674
                ],
                [
                    78.6648374,
                    56.1854827
                ],
                [
                    78.6669697,
                    56.1859259
                ],
                [
                    78.6670982,
                    56.1864835
                ],
                [
                    78.6646575,
                    56.1865407
                ],
                [
                    78.6645804,
                    56.1872127
                ]
            ],
            "longitude": 78.677933,
            "latitude": 56.189171
        },
        "3358": {
            "name": "Веселовское",
            "population": 1650,
            "type": "village",
            "poly": [
                [
                    78.6794862,
                    53.9756196
                ],
                [
                    78.6867065,
                    53.9814605
                ],
                [
                    78.6905558,
                    53.9842501
                ],
                [
                    78.6931775,
                    53.9861219
                ],
                [
                    78.6939584,
                    53.9872692
                ],
                [
                    78.7001867,
                    54.0088759
                ],
                [
                    78.7180363,
                    54.0116544
                ],
                [
                    78.721327,
                    54.0059538
                ],
                [
                    78.7181741,
                    54.0007693
                ],
                [
                    78.7238968,
                    53.9966146
                ],
                [
                    78.7249762,
                    53.9962568
                ],
                [
                    78.7262075,
                    53.9955254
                ],
                [
                    78.7272185,
                    53.9948701
                ],
                [
                    78.7279389,
                    53.9941526
                ],
                [
                    78.7290848,
                    53.9932929
                ],
                [
                    78.7292219,
                    53.9930411
                ],
                [
                    78.7295458,
                    53.9924462
                ],
                [
                    78.7277914,
                    53.9908309
                ],
                [
                    78.7364795,
                    53.9854394
                ],
                [
                    78.7158241,
                    53.9813563
                ],
                [
                    78.6948846,
                    53.9728656
                ],
                [
                    78.6794862,
                    53.9756196
                ]
            ],
            "longitude": 78.703827,
            "latitude": 53.988678
        },
        "3359": {
            "name": "Светлое",
            "population": 483,
            "type": "village",
            "poly": [
                [
                    78.707334,
                    54.1977008
                ],
                [
                    78.7081392,
                    54.1980456
                ],
                [
                    78.7160935,
                    54.1999001
                ],
                [
                    78.7207982,
                    54.1945423
                ],
                [
                    78.7215367,
                    54.1947439
                ],
                [
                    78.7222753,
                    54.1946575
                ],
                [
                    78.7227978,
                    54.1936627
                ],
                [
                    78.723875,
                    54.1938189
                ],
                [
                    78.7240463,
                    54.1933428
                ],
                [
                    78.7232316,
                    54.193152
                ],
                [
                    78.7240642,
                    54.1918537
                ],
                [
                    78.722981,
                    54.1916136
                ],
                [
                    78.7247902,
                    54.1891598
                ],
                [
                    78.719327,
                    54.1880896
                ],
                [
                    78.7188877,
                    54.1887188
                ],
                [
                    78.7172551,
                    54.1883735
                ],
                [
                    78.7169972,
                    54.1887058
                ],
                [
                    78.7112281,
                    54.1872766
                ],
                [
                    78.710447,
                    54.188564
                ],
                [
                    78.7122535,
                    54.189094
                ],
                [
                    78.707334,
                    54.1977008
                ]
            ],
            "longitude": 78.716454,
            "latitude": 54.19347
        },
        "3360": {
            "name": "Горбуново",
            "population": 623,
            "type": "village",
            "poly": null,
            "longitude": 78.720894,
            "latitude": 55.512699
        },
        "3361": {
            "name": "Новый Баганёнок",
            "population": 398,
            "type": "village",
            "poly": [
                [
                    78.7103601,
                    53.867273
                ],
                [
                    78.717677,
                    53.8766947
                ],
                [
                    78.7386912,
                    53.8762116
                ],
                [
                    78.7398463,
                    53.874803
                ],
                [
                    78.7389352,
                    53.8734884
                ],
                [
                    78.7347634,
                    53.8735449
                ],
                [
                    78.7338043,
                    53.8724706
                ],
                [
                    78.7374487,
                    53.8690637
                ],
                [
                    78.7320349,
                    53.8668328
                ],
                [
                    78.7328405,
                    53.8647856
                ],
                [
                    78.7301936,
                    53.8619804
                ],
                [
                    78.7279302,
                    53.8651363
                ],
                [
                    78.7242475,
                    53.8653512
                ],
                [
                    78.7221508,
                    53.864203
                ],
                [
                    78.7203766,
                    53.8618983
                ],
                [
                    78.7157024,
                    53.8618473
                ],
                [
                    78.7145898,
                    53.8608631
                ],
                [
                    78.7103601,
                    53.867273
                ]
            ],
            "longitude": 78.726402,
            "latitude": 53.868198
        },
        "3362": {
            "name": "Цветники",
            "population": 725,
            "type": "village",
            "poly": [
                [
                    78.7435215,
                    54.7057761
                ],
                [
                    78.7447259,
                    54.7087177
                ],
                [
                    78.749051,
                    54.7079586
                ],
                [
                    78.7500364,
                    54.7096033
                ],
                [
                    78.757044,
                    54.7082432
                ],
                [
                    78.757263,
                    54.7092237
                ],
                [
                    78.7599456,
                    54.7092554
                ],
                [
                    78.7596171,
                    54.7087177
                ],
                [
                    78.761807,
                    54.7087809
                ],
                [
                    78.761369,
                    54.7067883
                ],
                [
                    78.7628472,
                    54.7066617
                ],
                [
                    78.762683,
                    54.7053332
                ],
                [
                    78.7601646,
                    54.70527
                ],
                [
                    78.7601646,
                    54.7046689
                ],
                [
                    78.7608763,
                    54.7044159
                ],
                [
                    78.7603305,
                    54.7024575
                ],
                [
                    78.76014,
                    54.7004296
                ],
                [
                    78.758026,
                    54.7001858
                ],
                [
                    78.7558943,
                    54.70043
                ],
                [
                    78.7557301,
                    54.7018219
                ],
                [
                    78.753376,
                    54.7016954
                ],
                [
                    78.7526095,
                    54.7012209
                ],
                [
                    78.7512408,
                    54.701379
                ],
                [
                    78.7497079,
                    54.7026444
                ],
                [
                    78.7454924,
                    54.7027077
                ],
                [
                    78.7454377,
                    54.7049536
                ],
                [
                    78.7435215,
                    54.7057761
                ]
            ],
            "longitude": 78.753174,
            "latitude": 54.705029
        },
        "3363": {
            "name": "Сарыбалык",
            "population": 745,
            "type": "village",
            "poly": [
                [
                    78.7312943,
                    54.8239689
                ],
                [
                    78.7501464,
                    54.8292892
                ],
                [
                    78.7536571,
                    54.8296545
                ],
                [
                    78.7542399,
                    54.8295113
                ],
                [
                    78.7556716,
                    54.8295711
                ],
                [
                    78.7564875,
                    54.8298075
                ],
                [
                    78.7583523,
                    54.8301024
                ],
                [
                    78.7593617,
                    54.830264
                ],
                [
                    78.7617612,
                    54.8315558
                ],
                [
                    78.7641834,
                    54.8341062
                ],
                [
                    78.7668327,
                    54.8351089
                ],
                [
                    78.7676653,
                    54.8348255
                ],
                [
                    78.7687251,
                    54.833474
                ],
                [
                    78.7680438,
                    54.8331907
                ],
                [
                    78.7686494,
                    54.8326021
                ],
                [
                    78.7759539,
                    54.834455
                ],
                [
                    78.7769,
                    54.8315776
                ],
                [
                    78.7685559,
                    54.8287022
                ],
                [
                    78.7638049,
                    54.8270649
                ],
                [
                    78.7610421,
                    54.8263672
                ],
                [
                    78.7594904,
                    54.8287218
                ],
                [
                    78.7531321,
                    54.826716
                ],
                [
                    78.7460168,
                    54.8232712
                ],
                [
                    78.7404533,
                    54.8215269
                ],
                [
                    78.7348519,
                    54.8202186
                ],
                [
                    78.7312943,
                    54.8239689
                ]
            ],
            "longitude": 78.76664,
            "latitude": 54.830956
        },
        "3364": {
            "name": "Лотошное",
            "population": 487,
            "type": "village",
            "poly": [
                [
                    78.7723519,
                    54.133198
                ],
                [
                    78.776071,
                    54.1493621
                ],
                [
                    78.7941766,
                    54.1477195
                ],
                [
                    78.8156067,
                    54.1423477
                ],
                [
                    78.8215024,
                    54.1324793
                ],
                [
                    78.8159712,
                    54.1316477
                ],
                [
                    78.8102726,
                    54.1314924
                ],
                [
                    78.8071388,
                    54.1320203
                ],
                [
                    78.8065525,
                    54.1339668
                ],
                [
                    78.804564,
                    54.1369204
                ],
                [
                    78.8021866,
                    54.1367819
                ],
                [
                    78.7997829,
                    54.1362896
                ],
                [
                    78.7937599,
                    54.1347496
                ],
                [
                    78.7906601,
                    54.1264181
                ],
                [
                    78.7777021,
                    54.1290362
                ],
                [
                    78.7723519,
                    54.133198
                ]
            ],
            "longitude": 78.78418,
            "latitude": 54.13763
        },
        "3365": {
            "name": "Константиновка",
            "population": 275,
            "type": "village",
            "poly": null,
            "longitude": 78.802719,
            "latitude": 55.637108
        },
        "3366": {
            "name": "Чуваши",
            "population": 315,
            "type": "village",
            "poly": [
                [
                    78.7962205,
                    56.395363
                ],
                [
                    78.7978732,
                    56.3955105
                ],
                [
                    78.7974734,
                    56.3960564
                ],
                [
                    78.7980598,
                    56.3962186
                ],
                [
                    78.7996591,
                    56.3955695
                ],
                [
                    78.8008854,
                    56.3954367
                ],
                [
                    78.8024849,
                    56.3954957
                ],
                [
                    78.8032846,
                    56.3959383
                ],
                [
                    78.8046707,
                    56.3973841
                ],
                [
                    78.8065634,
                    56.4000395
                ],
                [
                    78.8074431,
                    56.4003198
                ],
                [
                    78.8088026,
                    56.4001428
                ],
                [
                    78.8096556,
                    56.3998478
                ],
                [
                    78.8098155,
                    56.3996265
                ],
                [
                    78.8106952,
                    56.3992724
                ],
                [
                    78.8117348,
                    56.3993904
                ],
                [
                    78.8132809,
                    56.3997445
                ],
                [
                    78.8141073,
                    56.4004083
                ],
                [
                    78.814907,
                    56.4024587
                ],
                [
                    78.81584,
                    56.4026652
                ],
                [
                    78.8166663,
                    56.4026062
                ],
                [
                    78.8201851,
                    56.4012344
                ],
                [
                    78.8216778,
                    56.4012787
                ],
                [
                    78.8228241,
                    56.4016917
                ],
                [
                    78.8233039,
                    56.402621
                ],
                [
                    78.8242901,
                    56.4031668
                ],
                [
                    78.8245835,
                    56.4046418
                ],
                [
                    78.8255431,
                    56.4046418
                ],
                [
                    78.827569,
                    56.404037
                ],
                [
                    78.8278889,
                    56.4036683
                ],
                [
                    78.830368,
                    56.403093
                ],
                [
                    78.8306079,
                    56.4018097
                ],
                [
                    78.8305546,
                    56.4013672
                ],
                [
                    78.8312743,
                    56.4008361
                ],
                [
                    78.831301,
                    56.4004821
                ],
                [
                    78.8321007,
                    56.4003493
                ],
                [
                    78.8319408,
                    56.3999658
                ],
                [
                    78.8293817,
                    56.4001723
                ],
                [
                    78.8307679,
                    56.3986086
                ],
                [
                    78.828502,
                    56.3978267
                ],
                [
                    78.825463,
                    56.3972514
                ],
                [
                    78.82501,
                    56.3983135
                ],
                [
                    78.8227974,
                    56.397812
                ],
                [
                    78.8223976,
                    56.3986676
                ],
                [
                    78.8217312,
                    56.3984906
                ],
                [
                    78.821358,
                    56.3987414
                ],
                [
                    78.8208781,
                    56.3986676
                ],
                [
                    78.8209848,
                    56.3984316
                ],
                [
                    78.8194653,
                    56.398048
                ],
                [
                    78.8205583,
                    56.3966465
                ],
                [
                    78.8191454,
                    56.3961449
                ],
                [
                    78.8187989,
                    56.3962924
                ],
                [
                    78.818479,
                    56.3962039
                ],
                [
                    78.8185057,
                    56.3959383
                ],
                [
                    78.8179992,
                    56.3957613
                ],
                [
                    78.8178925,
                    56.395599
                ],
                [
                    78.8174927,
                    56.3955252
                ],
                [
                    78.8172528,
                    56.395717
                ],
                [
                    78.816613,
                    56.39554
                ],
                [
                    78.8162932,
                    56.395717
                ],
                [
                    78.8150669,
                    56.3951269
                ],
                [
                    78.813041,
                    56.3946548
                ],
                [
                    78.8120814,
                    56.395481
                ],
                [
                    78.8097355,
                    56.3952744
                ],
                [
                    78.8088559,
                    56.3953039
                ],
                [
                    78.805657,
                    56.3941827
                ],
                [
                    78.8053905,
                    56.3943597
                ],
                [
                    78.8034179,
                    56.393563
                ],
                [
                    78.8030447,
                    56.3936663
                ],
                [
                    78.8027247,
                    56.3935335
                ],
                [
                    78.8028581,
                    56.3933712
                ],
                [
                    78.8010187,
                    56.392722
                ],
                [
                    78.7996326,
                    56.3926925
                ],
                [
                    78.7992061,
                    56.3931351
                ],
                [
                    78.7974734,
                    56.3927958
                ],
                [
                    78.7971268,
                    56.3932679
                ],
                [
                    78.7985663,
                    56.3939466
                ],
                [
                    78.7983797,
                    56.3942269
                ],
                [
                    78.7974467,
                    56.3939171
                ],
                [
                    78.7970202,
                    56.3943892
                ],
                [
                    78.7964071,
                    56.3947285
                ],
                [
                    78.7962205,
                    56.395363
                ]
            ],
            "longitude": 78.816666,
            "latitude": 56.398643
        },
        "3367": {
            "name": "Ульяновка",
            "population": 326,
            "type": "village",
            "poly": [
                [
                    78.8024104,
                    53.7429618
                ],
                [
                    78.8154288,
                    53.7490791
                ],
                [
                    78.8242269,
                    53.7431646
                ],
                [
                    78.8274245,
                    53.7389305
                ],
                [
                    78.8237097,
                    53.7371834
                ],
                [
                    78.825731,
                    53.7331979
                ],
                [
                    78.821941,
                    53.7318936
                ],
                [
                    78.8205814,
                    53.7363009
                ],
                [
                    78.8181269,
                    53.739176
                ],
                [
                    78.814373,
                    53.7368987
                ],
                [
                    78.8024104,
                    53.7429618
                ]
            ],
            "longitude": 78.818611,
            "latitude": 53.743202
        },
        "3368": {
            "name": "Фёдоровка",
            "population": 230,
            "type": "village",
            "poly": [
                [
                    78.8204155,
                    56.0729734
                ],
                [
                    78.8223113,
                    56.0733933
                ],
                [
                    78.822522,
                    56.0731749
                ],
                [
                    78.8245382,
                    56.0735277
                ],
                [
                    78.8275475,
                    56.0746362
                ],
                [
                    78.8279687,
                    56.0744514
                ],
                [
                    78.8295036,
                    56.0751064
                ],
                [
                    78.8310985,
                    56.0754087
                ],
                [
                    78.8343184,
                    56.0767859
                ],
                [
                    78.8340777,
                    56.0770882
                ],
                [
                    78.83483,
                    56.0773065
                ],
                [
                    78.835161,
                    56.0769874
                ],
                [
                    78.8359435,
                    56.0772393
                ],
                [
                    78.8371171,
                    56.0782974
                ],
                [
                    78.8410292,
                    56.0797416
                ],
                [
                    78.8413903,
                    56.0792546
                ],
                [
                    78.845814,
                    56.0808163
                ],
                [
                    78.845814,
                    56.0810514
                ],
                [
                    78.8512909,
                    56.0831672
                ],
                [
                    78.8521034,
                    56.0829657
                ],
                [
                    78.852798,
                    56.0824203
                ],
                [
                    78.8541605,
                    56.0814956
                ],
                [
                    78.8516821,
                    56.0802454
                ],
                [
                    78.850689,
                    56.0794225
                ],
                [
                    78.8519529,
                    56.0785829
                ],
                [
                    78.8511404,
                    56.0780958
                ],
                [
                    78.8505385,
                    56.0783645
                ],
                [
                    78.849756,
                    56.0779783
                ],
                [
                    78.848432,
                    56.0789019
                ],
                [
                    78.8466866,
                    56.0780958
                ],
                [
                    78.8451519,
                    56.07776
                ],
                [
                    78.84455,
                    56.0782134
                ],
                [
                    78.8441889,
                    56.0783645
                ],
                [
                    78.843888,
                    56.0781294
                ],
                [
                    78.8440987,
                    56.0776592
                ],
                [
                    78.8426843,
                    56.0771218
                ],
                [
                    78.8422028,
                    56.0772058
                ],
                [
                    78.8406079,
                    56.0767523
                ],
                [
                    78.8416611,
                    56.0756943
                ],
                [
                    78.8433462,
                    56.0762317
                ],
                [
                    78.8444598,
                    56.075224
                ],
                [
                    78.8416009,
                    56.074401
                ],
                [
                    78.8408185,
                    56.0742835
                ],
                [
                    78.8400662,
                    56.0743506
                ],
                [
                    78.8378393,
                    56.0759798
                ],
                [
                    78.8370268,
                    56.0757278
                ],
                [
                    78.8368162,
                    56.0754423
                ],
                [
                    78.8360337,
                    56.0752072
                ],
                [
                    78.8366055,
                    56.074401
                ],
                [
                    78.8381101,
                    56.0742667
                ],
                [
                    78.8393138,
                    56.0733597
                ],
                [
                    78.8407282,
                    56.0716801
                ],
                [
                    78.8404875,
                    56.0710418
                ],
                [
                    78.8394944,
                    56.0710418
                ],
                [
                    78.8388324,
                    56.0713273
                ],
                [
                    78.8382606,
                    56.0712937
                ],
                [
                    78.8378694,
                    56.0710418
                ],
                [
                    78.8381101,
                    56.0704203
                ],
                [
                    78.8375685,
                    56.0701851
                ],
                [
                    78.8361541,
                    56.0702019
                ],
                [
                    78.835793,
                    56.0708066
                ],
                [
                    78.8330846,
                    56.0706891
                ],
                [
                    78.8335962,
                    56.0698324
                ],
                [
                    78.8334457,
                    56.0693789
                ],
                [
                    78.8327836,
                    56.0691437
                ],
                [
                    78.8327536,
                    56.0685054
                ],
                [
                    78.8308276,
                    56.0683542
                ],
                [
                    78.8301656,
                    56.0681358
                ],
                [
                    78.8297443,
                    56.0676655
                ],
                [
                    78.8285707,
                    56.0682366
                ],
                [
                    78.8293832,
                    56.0689253
                ],
                [
                    78.8301656,
                    56.0688413
                ],
                [
                    78.8303461,
                    56.0690429
                ],
                [
                    78.8297142,
                    56.0694293
                ],
                [
                    78.8297142,
                    56.0697652
                ],
                [
                    78.8301957,
                    56.0698324
                ],
                [
                    78.8301355,
                    56.0707562
                ],
                [
                    78.8292929,
                    56.0712434
                ],
                [
                    78.8290221,
                    56.0719824
                ],
                [
                    78.8276077,
                    56.071932
                ],
                [
                    78.826404,
                    56.0726039
                ],
                [
                    78.8256517,
                    56.0723855
                ],
                [
                    78.8260429,
                    56.0715457
                ],
                [
                    78.8251401,
                    56.071277
                ],
                [
                    78.8245984,
                    56.0720664
                ],
                [
                    78.8230035,
                    56.0716969
                ],
                [
                    78.8230637,
                    56.0711426
                ],
                [
                    78.8221308,
                    56.0709074
                ],
                [
                    78.821078,
                    56.0716869
                ],
                [
                    78.8204155,
                    56.0729734
                ]
            ],
            "longitude": 78.834679,
            "latitude": 56.074955
        },
        "3369": {
            "name": "Бакмасиха",
            "population": 425,
            "type": "village",
            "poly": [
                [
                    78.8219621,
                    55.1482145
                ],
                [
                    78.8239439,
                    55.1492159
                ],
                [
                    78.8307446,
                    55.1513377
                ],
                [
                    78.8351046,
                    55.1536979
                ],
                [
                    78.8372115,
                    55.1550567
                ],
                [
                    78.8384215,
                    55.1555215
                ],
                [
                    78.8392142,
                    55.1567849
                ],
                [
                    78.8428649,
                    55.1578933
                ],
                [
                    78.8429692,
                    55.1584654
                ],
                [
                    78.8442209,
                    55.1591447
                ],
                [
                    78.8463696,
                    55.1596572
                ],
                [
                    78.8473917,
                    55.1588945
                ],
                [
                    78.8483181,
                    55.1577752
                ],
                [
                    78.8486643,
                    55.157357
                ],
                [
                    78.8486434,
                    55.1567253
                ],
                [
                    78.8454517,
                    55.1544011
                ],
                [
                    78.8445129,
                    55.1534357
                ],
                [
                    78.8425995,
                    55.1524181
                ],
                [
                    78.8424268,
                    55.152339
                ],
                [
                    78.8404867,
                    55.1513377
                ],
                [
                    78.838797,
                    55.1499311
                ],
                [
                    78.8366483,
                    55.1486675
                ],
                [
                    78.8407579,
                    55.141085
                ],
                [
                    78.8303691,
                    55.1392965
                ],
                [
                    78.8283873,
                    55.1431239
                ],
                [
                    78.8269062,
                    55.1439465
                ],
                [
                    78.8247575,
                    55.1463786
                ],
                [
                    78.824028,
                    55.1476328
                ],
                [
                    78.8233807,
                    55.148298
                ],
                [
                    78.8222333,
                    55.1479523
                ],
                [
                    78.8219621,
                    55.1482145
                ]
            ],
            "longitude": 78.835938,
            "latitude": 55.152081
        },
        "3370": {
            "name": "Нижнечеремошное",
            "population": 850,
            "type": "village",
            "poly": [
                [
                    78.8783342,
                    53.9517296
                ],
                [
                    78.8848059,
                    53.9551906
                ],
                [
                    78.8861481,
                    53.9557736
                ],
                [
                    78.8876821,
                    53.9568548
                ],
                [
                    78.8906702,
                    53.9585941
                ],
                [
                    78.8897594,
                    53.9595061
                ],
                [
                    78.8883532,
                    53.9602582
                ],
                [
                    78.8876341,
                    53.962317
                ],
                [
                    78.8902228,
                    53.9627494
                ],
                [
                    78.8928535,
                    53.9623589
                ],
                [
                    78.8997861,
                    53.963302
                ],
                [
                    78.9080712,
                    53.9651909
                ],
                [
                    78.9111445,
                    53.963569
                ],
                [
                    78.9160584,
                    53.9639066
                ],
                [
                    78.9117586,
                    53.9593309
                ],
                [
                    78.9043605,
                    53.9594797
                ],
                [
                    78.9030594,
                    53.9588845
                ],
                [
                    78.9025383,
                    53.9583237
                ],
                [
                    78.902623,
                    53.9578257
                ],
                [
                    78.903783,
                    53.9565454
                ],
                [
                    78.9019911,
                    53.9558714
                ],
                [
                    78.9009099,
                    53.9548455
                ],
                [
                    78.9006069,
                    53.9543123
                ],
                [
                    78.9004601,
                    53.9539765
                ],
                [
                    78.900588,
                    53.95377
                ],
                [
                    78.9006914,
                    53.9531684
                ],
                [
                    78.9014332,
                    53.9526142
                ],
                [
                    78.9039281,
                    53.9521892
                ],
                [
                    78.9035308,
                    53.947508
                ],
                [
                    78.899471,
                    53.9458427
                ],
                [
                    78.8983587,
                    53.9467771
                ],
                [
                    78.8973989,
                    53.9481101
                ],
                [
                    78.8946796,
                    53.9487198
                ],
                [
                    78.8925563,
                    53.9507738
                ],
                [
                    78.8916991,
                    53.95125
                ],
                [
                    78.8906462,
                    53.951675
                ],
                [
                    78.8895636,
                    53.9518284
                ],
                [
                    78.8884636,
                    53.9518824
                ],
                [
                    78.8869484,
                    53.9510829
                ],
                [
                    78.8855666,
                    53.9501357
                ],
                [
                    78.8839799,
                    53.9492689
                ],
                [
                    78.8826979,
                    53.9482425
                ],
                [
                    78.8783342,
                    53.9517296
                ]
            ],
            "longitude": 78.897125,
            "latitude": 53.95768
        },
        "3371": {
            "name": "Нижний Чулым",
            "population": 882,
            "type": "village",
            "poly": [
                [
                    78.9123572,
                    54.6177183
                ],
                [
                    78.9164426,
                    54.618998
                ],
                [
                    78.9155719,
                    54.6201613
                ],
                [
                    78.9175142,
                    54.6208593
                ],
                [
                    78.9185858,
                    54.6202389
                ],
                [
                    78.9211308,
                    54.6212858
                ],
                [
                    78.9201931,
                    54.6220614
                ],
                [
                    78.9249483,
                    54.6245042
                ],
                [
                    78.9258859,
                    54.6239225
                ],
                [
                    78.9242034,
                    54.6228024
                ],
                [
                    78.9347264,
                    54.6176795
                ],
                [
                    78.93553,
                    54.6183775
                ],
                [
                    78.9373384,
                    54.6177958
                ],
                [
                    78.9424954,
                    54.6205103
                ],
                [
                    78.9455762,
                    54.6199286
                ],
                [
                    78.9447055,
                    54.6167875
                ],
                [
                    78.9425998,
                    54.6163563
                ],
                [
                    78.9515234,
                    54.611226
                ],
                [
                    78.9514163,
                    54.6099848
                ],
                [
                    78.9547918,
                    54.6090539
                ],
                [
                    78.957953,
                    54.609147
                ],
                [
                    78.9594532,
                    54.6087747
                ],
                [
                    78.9580065,
                    54.6064163
                ],
                [
                    78.9507198,
                    54.6066645
                ],
                [
                    78.9458441,
                    54.6060128
                ],
                [
                    78.9440224,
                    54.608123
                ],
                [
                    78.9359856,
                    54.6059508
                ],
                [
                    78.9344853,
                    54.6065714
                ],
                [
                    78.9324493,
                    54.6044301
                ],
                [
                    78.9270379,
                    54.6076886
                ],
                [
                    78.9290203,
                    54.6086505
                ],
                [
                    78.9274128,
                    54.6091781
                ],
                [
                    78.9218407,
                    54.6131187
                ],
                [
                    78.9250019,
                    54.6144839
                ],
                [
                    78.923073,
                    54.6155078
                ],
                [
                    78.9246922,
                    54.6171976
                ],
                [
                    78.9224301,
                    54.618393
                ],
                [
                    78.9201797,
                    54.618331
                ],
                [
                    78.9180902,
                    54.6174003
                ],
                [
                    78.9160006,
                    54.6156319
                ],
                [
                    78.9153575,
                    54.6156939
                ],
                [
                    78.9145539,
                    54.6167798
                ],
                [
                    78.9133216,
                    54.6165936
                ],
                [
                    78.9123572,
                    54.6177183
                ]
            ],
            "longitude": 78.933685,
            "latitude": 54.610977
        },
        "3372": {
            "name": "Кондусла",
            "population": 415,
            "type": "village",
            "poly": [
                [
                    78.927223,
                    55.4440354
                ],
                [
                    78.9326369,
                    55.447512
                ],
                [
                    78.9355616,
                    55.4465237
                ],
                [
                    78.9359972,
                    55.4483767
                ],
                [
                    78.9371795,
                    55.448659
                ],
                [
                    78.9382374,
                    55.4486237
                ],
                [
                    78.9387664,
                    55.450053
                ],
                [
                    78.9431534,
                    55.449259
                ],
                [
                    78.943029,
                    55.4481472
                ],
                [
                    78.9481629,
                    55.447759
                ],
                [
                    78.9479139,
                    55.4452002
                ],
                [
                    78.9439936,
                    55.4454825
                ],
                [
                    78.9437446,
                    55.4449355
                ],
                [
                    78.9429667,
                    55.4444854
                ],
                [
                    78.9420956,
                    55.4446001
                ],
                [
                    78.9415511,
                    55.4432589
                ],
                [
                    78.9428734,
                    55.4423235
                ],
                [
                    78.9436824,
                    55.441141
                ],
                [
                    78.9397931,
                    55.4398525
                ],
                [
                    78.9369929,
                    55.4416528
                ],
                [
                    78.9375218,
                    55.4420234
                ],
                [
                    78.927223,
                    55.4440354
                ]
            ],
            "longitude": 78.936943,
            "latitude": 55.444569
        },
        "3373": {
            "name": "Аксёниха",
            "population": 586,
            "type": "village",
            "poly": [
                [
                    78.9295636,
                    53.7148986
                ],
                [
                    78.9325731,
                    53.725016
                ],
                [
                    78.9383125,
                    53.7276553
                ],
                [
                    78.9450498,
                    53.7265162
                ],
                [
                    78.9477846,
                    53.7215061
                ],
                [
                    78.9614627,
                    53.7157794
                ],
                [
                    78.9548887,
                    53.7085042
                ],
                [
                    78.9448447,
                    53.7085897
                ],
                [
                    78.9295636,
                    53.7148986
                ]
            ],
            "longitude": 78.942459,
            "latitude": 53.715843
        },
        "3374": {
            "name": "Конёво",
            "population": 740,
            "type": "village",
            "poly": [
                [
                    78.9861054,
                    54.2182883
                ],
                [
                    78.9922768,
                    54.2235823
                ],
                [
                    78.9936965,
                    54.2244437
                ],
                [
                    78.9950508,
                    54.2255274
                ],
                [
                    78.9962096,
                    54.2276356
                ],
                [
                    78.9962731,
                    54.2296445
                ],
                [
                    78.9920344,
                    54.2359759
                ],
                [
                    78.9917868,
                    54.2422412
                ],
                [
                    78.9944765,
                    54.2461579
                ],
                [
                    79.0099396,
                    54.2443997
                ],
                [
                    79.02306,
                    54.2381477
                ],
                [
                    79.0100273,
                    54.2293204
                ],
                [
                    79.0040202,
                    54.2274261
                ],
                [
                    79.0014618,
                    54.2251061
                ],
                [
                    79.0007365,
                    54.2222894
                ],
                [
                    78.9959815,
                    54.2185629
                ],
                [
                    78.9913157,
                    54.2132599
                ],
                [
                    78.9861559,
                    54.214591
                ],
                [
                    78.9861054,
                    54.2182883
                ]
            ],
            "longitude": 79.003204,
            "latitude": 54.234505
        },
        "3375": {
            "name": "Лобино",
            "population": 840,
            "type": "village",
            "poly": [
                [
                    79.0115889,
                    53.8651535
                ],
                [
                    79.0154091,
                    53.8679848
                ],
                [
                    79.0191864,
                    53.8650197
                ],
                [
                    79.0261035,
                    53.8648191
                ],
                [
                    79.0278055,
                    53.8707389
                ],
                [
                    79.039552,
                    53.8693671
                ],
                [
                    79.0427498,
                    53.866621
                ],
                [
                    79.0375733,
                    53.8623272
                ],
                [
                    79.0323474,
                    53.8490579
                ],
                [
                    79.0188462,
                    53.8511088
                ],
                [
                    79.0115889,
                    53.8651535
                ]
            ],
            "longitude": 79.027725,
            "latitude": 53.862038
        },
        "3376": {
            "name": "Кожурла",
            "population": 1218,
            "type": "village",
            "poly": [
                [
                    79.0180508,
                    55.3343541
                ],
                [
                    79.0180508,
                    55.3372684
                ],
                [
                    79.0208539,
                    55.3379884
                ],
                [
                    79.0230842,
                    55.3383998
                ],
                [
                    79.0237171,
                    55.3387084
                ],
                [
                    79.0234761,
                    55.3413824
                ],
                [
                    79.0238981,
                    55.3426508
                ],
                [
                    79.0228733,
                    55.3450846
                ],
                [
                    79.021306,
                    55.3460615
                ],
                [
                    79.0213964,
                    55.3464557
                ],
                [
                    79.0240789,
                    55.3465928
                ],
                [
                    79.0247119,
                    55.3471412
                ],
                [
                    79.0258271,
                    55.3486665
                ],
                [
                    79.0289316,
                    55.3496262
                ],
                [
                    79.0306798,
                    55.3495576
                ],
                [
                    79.0344246,
                    55.3498402
                ],
                [
                    79.0356502,
                    55.3487918
                ],
                [
                    79.0394508,
                    55.3459244
                ],
                [
                    79.0405358,
                    55.3478953
                ],
                [
                    79.0419223,
                    55.3487693
                ],
                [
                    79.0469558,
                    55.3447247
                ],
                [
                    79.0509646,
                    55.343662
                ],
                [
                    79.0541293,
                    55.3439534
                ],
                [
                    79.0556364,
                    55.3435592
                ],
                [
                    79.0575051,
                    55.3433364
                ],
                [
                    79.0581682,
                    55.3421023
                ],
                [
                    79.061966,
                    55.3410396
                ],
                [
                    79.0627195,
                    55.3402339
                ],
                [
                    79.0622975,
                    55.3388626
                ],
                [
                    79.0532853,
                    55.3386569
                ],
                [
                    79.0505124,
                    55.3403196
                ],
                [
                    79.046986,
                    55.3398226
                ],
                [
                    79.046775,
                    55.3389998
                ],
                [
                    79.0479505,
                    55.3348855
                ],
                [
                    79.0480409,
                    55.3338398
                ],
                [
                    79.0468955,
                    55.3324511
                ],
                [
                    79.0454488,
                    55.3322111
                ],
                [
                    79.0379437,
                    55.3311138
                ],
                [
                    79.0366477,
                    55.331251
                ],
                [
                    79.0317046,
                    55.3312167
                ],
                [
                    79.028799,
                    55.331872
                ],
                [
                    79.0241391,
                    55.3316796
                ],
                [
                    79.0216978,
                    55.3317825
                ],
                [
                    79.0192263,
                    55.3317825
                ],
                [
                    79.0184279,
                    55.3327572
                ],
                [
                    79.0180508,
                    55.3343541
                ]
            ],
            "longitude": 79.032433,
            "latitude": 55.335751
        },
        "3377": {
            "name": "Локтёнок",
            "population": 481,
            "type": "village",
            "poly": [
                [
                    79.0047352,
                    53.9612256
                ],
                [
                    79.0136964,
                    53.9649336
                ],
                [
                    79.026269,
                    53.9665605
                ],
                [
                    79.0472804,
                    53.9598181
                ],
                [
                    79.046007,
                    53.9505455
                ],
                [
                    79.0553984,
                    53.9452058
                ],
                [
                    79.0498272,
                    53.9423014
                ],
                [
                    79.0356604,
                    53.9475479
                ],
                [
                    79.0374114,
                    53.9536366
                ],
                [
                    79.0264282,
                    53.9561655
                ],
                [
                    79.0191059,
                    53.9504518
                ],
                [
                    79.0047352,
                    53.9612256
                ]
            ],
            "longitude": 79.034554,
            "latitude": 53.959328
        },
        "3378": {
            "name": "Чумаково",
            "population": 1099,
            "type": "village",
            "poly": [
                [
                    79.0341343,
                    55.6803318
                ],
                [
                    79.0360554,
                    55.6812911
                ],
                [
                    79.0353811,
                    55.6820333
                ],
                [
                    79.0369866,
                    55.6845314
                ],
                [
                    79.0408718,
                    55.6870656
                ],
                [
                    79.0426379,
                    55.6878077
                ],
                [
                    79.0456561,
                    55.6882602
                ],
                [
                    79.0443397,
                    55.6893824
                ],
                [
                    79.0480642,
                    55.6905588
                ],
                [
                    79.0471011,
                    55.6914457
                ],
                [
                    79.0478396,
                    55.6916628
                ],
                [
                    79.0530092,
                    55.69188
                ],
                [
                    79.0620962,
                    55.6939251
                ],
                [
                    79.0645365,
                    55.6939613
                ],
                [
                    79.0668484,
                    55.6920791
                ],
                [
                    79.0682612,
                    55.6926763
                ],
                [
                    79.0706373,
                    55.6910475
                ],
                [
                    79.0660706,
                    55.6891575
                ],
                [
                    79.0579219,
                    55.6845314
                ],
                [
                    79.0527843,
                    55.6822144
                ],
                [
                    79.0518533,
                    55.6820333
                ],
                [
                    79.0511469,
                    55.6823411
                ],
                [
                    79.0484818,
                    55.6815264
                ],
                [
                    79.047008,
                    55.6819063
                ],
                [
                    79.0446467,
                    55.6817783
                ],
                [
                    79.0416269,
                    55.6810743
                ],
                [
                    79.0398105,
                    55.6802166
                ],
                [
                    79.0387661,
                    55.6793589
                ],
                [
                    79.0354285,
                    55.6787444
                ],
                [
                    79.0341343,
                    55.6803318
                ]
            ],
            "longitude": 79.051338,
            "latitude": 55.686729
        },
        "3379": {
            "name": "Ушково",
            "population": 512,
            "type": "village",
            "poly": [
                [
                    79.0435795,
                    55.6787316
                ],
                [
                    79.0489606,
                    55.6803318
                ],
                [
                    79.0505455,
                    55.6801487
                ],
                [
                    79.0522754,
                    55.6800886
                ],
                [
                    79.0546822,
                    55.6806519
                ],
                [
                    79.0574522,
                    55.6815351
                ],
                [
                    79.0611985,
                    55.6835064
                ],
                [
                    79.0673515,
                    55.6865527
                ],
                [
                    79.0678283,
                    55.6864247
                ],
                [
                    79.0710296,
                    55.6874486
                ],
                [
                    79.0733682,
                    55.6876918
                ],
                [
                    79.0776821,
                    55.6888309
                ],
                [
                    79.0801115,
                    55.6869495
                ],
                [
                    79.0742083,
                    55.6846072
                ],
                [
                    79.07523,
                    55.68366
                ],
                [
                    79.0783406,
                    55.6841976
                ],
                [
                    79.0798164,
                    55.6839928
                ],
                [
                    79.0805429,
                    55.6829048
                ],
                [
                    79.0803386,
                    55.6821496
                ],
                [
                    79.0793623,
                    55.6813559
                ],
                [
                    79.0769329,
                    55.6809975
                ],
                [
                    79.0750711,
                    55.6823544
                ],
                [
                    79.0668974,
                    55.6802294
                ],
                [
                    79.0675785,
                    55.6796278
                ],
                [
                    79.06608,
                    55.6788981
                ],
                [
                    79.0641501,
                    55.6781428
                ],
                [
                    79.0630374,
                    55.6793461
                ],
                [
                    79.0620839,
                    55.679871
                ],
                [
                    79.0611076,
                    55.6801526
                ],
                [
                    79.0598816,
                    55.680255
                ],
                [
                    79.0594275,
                    55.6795637
                ],
                [
                    79.0581787,
                    55.6792949
                ],
                [
                    79.0572932,
                    55.6795766
                ],
                [
                    79.0557493,
                    55.6785908
                ],
                [
                    79.0499823,
                    55.6756463
                ],
                [
                    79.0489606,
                    55.6746861
                ],
                [
                    79.0482567,
                    55.6746605
                ],
                [
                    79.0467488,
                    55.6749678
                ],
                [
                    79.0486654,
                    55.6762992
                ],
                [
                    79.0469399,
                    55.6773362
                ],
                [
                    79.0451235,
                    55.6763249
                ],
                [
                    79.04392,
                    55.6773618
                ],
                [
                    79.0444877,
                    55.6777459
                ],
                [
                    79.0435795,
                    55.6787316
                ]
            ],
            "longitude": 79.069199,
            "latitude": 55.684029
        },
        "3380": {
            "name": "Берёзовка",
            "population": 351,
            "type": "village",
            "poly": [
                [
                    79.0641221,
                    54.9006489
                ],
                [
                    79.0644889,
                    54.9015225
                ],
                [
                    79.0656939,
                    54.90092
                ],
                [
                    79.0678944,
                    54.900438
                ],
                [
                    79.0688374,
                    54.9017334
                ],
                [
                    79.0748102,
                    54.9035107
                ],
                [
                    79.0777441,
                    54.9018238
                ],
                [
                    79.081464,
                    54.9020045
                ],
                [
                    79.0852362,
                    54.9015225
                ],
                [
                    79.0876463,
                    54.9003175
                ],
                [
                    79.0883797,
                    54.8978773
                ],
                [
                    79.0865984,
                    54.8956176
                ],
                [
                    79.0848695,
                    54.8945631
                ],
                [
                    79.0796826,
                    54.8917007
                ],
                [
                    79.0771154,
                    54.8917911
                ],
                [
                    79.0754389,
                    54.892695
                ],
                [
                    79.0754389,
                    54.8948343
                ],
                [
                    79.0710903,
                    54.8940208
                ],
                [
                    79.0704092,
                    54.8948042
                ],
                [
                    79.0686803,
                    54.8945631
                ],
                [
                    79.0681039,
                    54.8954971
                ],
                [
                    79.0664798,
                    54.8953465
                ],
                [
                    79.0645937,
                    54.8984497
                ],
                [
                    79.0641221,
                    54.9006489
                ]
            ],
            "longitude": 79.076385,
            "latitude": 54.898087
        },
        "3381": {
            "name": "Кордон",
            "population": 408,
            "type": "village",
            "poly": [
                [
                    79.0715279,
                    56.4362088
                ],
                [
                    79.0729786,
                    56.4365233
                ],
                [
                    79.072296,
                    56.4379073
                ],
                [
                    79.0755959,
                    56.4382848
                ],
                [
                    79.0779286,
                    56.4389767
                ],
                [
                    79.0794647,
                    56.4399046
                ],
                [
                    79.0806879,
                    56.4404393
                ],
                [
                    79.0811431,
                    56.4411155
                ],
                [
                    79.0830491,
                    56.4411626
                ],
                [
                    79.0828215,
                    56.4417759
                ],
                [
                    79.0852111,
                    56.4426723
                ],
                [
                    79.0867775,
                    56.4435253
                ],
                [
                    79.0888221,
                    56.44269
                ],
                [
                    79.0901111,
                    56.4416826
                ],
                [
                    79.0908668,
                    56.4418546
                ],
                [
                    79.0914446,
                    56.4416334
                ],
                [
                    79.0922891,
                    56.4417317
                ],
                [
                    79.0925558,
                    56.4414369
                ],
                [
                    79.0935782,
                    56.4414369
                ],
                [
                    79.0938893,
                    56.4410929
                ],
                [
                    79.0924652,
                    56.4408481
                ],
                [
                    79.0947694,
                    56.439307
                ],
                [
                    79.0960211,
                    56.4393384
                ],
                [
                    79.0964192,
                    56.4390396
                ],
                [
                    79.0960211,
                    56.4387723
                ],
                [
                    79.0981262,
                    56.4371367
                ],
                [
                    79.0946556,
                    56.4354381
                ],
                [
                    79.0941151,
                    56.4357527
                ],
                [
                    79.0953952,
                    56.4364447
                ],
                [
                    79.0935177,
                    56.4367592
                ],
                [
                    79.0931479,
                    56.4364919
                ],
                [
                    79.0923229,
                    56.4365076
                ],
                [
                    79.092266,
                    56.4371367
                ],
                [
                    79.093091,
                    56.4371682
                ],
                [
                    79.0933186,
                    56.4378759
                ],
                [
                    79.0925505,
                    56.4377658
                ],
                [
                    79.0899048,
                    56.4392755
                ],
                [
                    79.0903885,
                    56.4395743
                ],
                [
                    79.0899618,
                    56.4398731
                ],
                [
                    79.089592,
                    56.439763
                ],
                [
                    79.088966,
                    56.4400461
                ],
                [
                    79.0884825,
                    56.4399989
                ],
                [
                    79.087942,
                    56.4402663
                ],
                [
                    79.0875438,
                    56.4401405
                ],
                [
                    79.0879135,
                    56.439826
                ],
                [
                    79.0868325,
                    56.4394485
                ],
                [
                    79.0872593,
                    56.438961
                ],
                [
                    79.0869464,
                    56.4388666
                ],
                [
                    79.0840447,
                    56.4384892
                ],
                [
                    79.0833336,
                    56.4382848
                ],
                [
                    79.0828215,
                    56.4386465
                ],
                [
                    79.0816552,
                    56.4379702
                ],
                [
                    79.0798913,
                    56.4374355
                ],
                [
                    79.0770182,
                    56.4364762
                ],
                [
                    79.0751692,
                    56.4365076
                ],
                [
                    79.0744294,
                    56.4366963
                ],
                [
                    79.0735761,
                    56.4363818
                ],
                [
                    79.0753398,
                    56.4336451
                ],
                [
                    79.0743726,
                    56.4334406
                ],
                [
                    79.0728364,
                    56.4346989
                ],
                [
                    79.0723813,
                    56.4349348
                ],
                [
                    79.0715279,
                    56.4362088
                ]
            ],
            "longitude": 79.087364,
            "latitude": 56.441681
        },
        "3382": {
            "name": "Верх-Каргат",
            "population": 828,
            "type": "village",
            "poly": [
                [
                    79.0671732,
                    54.7864739
                ],
                [
                    79.070311,
                    54.7878632
                ],
                [
                    79.068574,
                    54.789511
                ],
                [
                    79.0699188,
                    54.7904479
                ],
                [
                    79.0742334,
                    54.7918694
                ],
                [
                    79.0733929,
                    54.7928385
                ],
                [
                    79.0748497,
                    54.7942922
                ],
                [
                    79.0776514,
                    54.795649
                ],
                [
                    79.0801729,
                    54.7968119
                ],
                [
                    79.0801729,
                    54.7987176
                ],
                [
                    79.0823582,
                    54.7999127
                ],
                [
                    79.0854401,
                    54.8023028
                ],
                [
                    79.0872331,
                    54.8025935
                ],
                [
                    79.0940132,
                    54.8023351
                ],
                [
                    79.0975433,
                    54.8038531
                ],
                [
                    79.0964226,
                    54.8045959
                ],
                [
                    79.1009613,
                    54.8072764
                ],
                [
                    79.103819,
                    54.8080837
                ],
                [
                    79.1061164,
                    54.8064044
                ],
                [
                    79.1127844,
                    54.802755
                ],
                [
                    79.1126163,
                    54.8016569
                ],
                [
                    79.1101508,
                    54.8001388
                ],
                [
                    79.1128404,
                    54.7992345
                ],
                [
                    79.1077414,
                    54.7954229
                ],
                [
                    79.1024182,
                    54.7907386
                ],
                [
                    79.1015217,
                    54.7891879
                ],
                [
                    79.0974312,
                    54.7879925
                ],
                [
                    79.0972631,
                    54.7890586
                ],
                [
                    79.0906512,
                    54.7875078
                ],
                [
                    79.0891383,
                    54.7876694
                ],
                [
                    79.088634,
                    54.7884125
                ],
                [
                    79.087065,
                    54.7882186
                ],
                [
                    79.0860564,
                    54.7889294
                ],
                [
                    79.0824143,
                    54.7879925
                ],
                [
                    79.0807893,
                    54.7884125
                ],
                [
                    79.0783728,
                    54.7877636
                ],
                [
                    79.076923,
                    54.7884125
                ],
                [
                    79.0732146,
                    54.7874922
                ],
                [
                    79.0703823,
                    54.7858455
                ],
                [
                    79.06863,
                    54.7854723
                ],
                [
                    79.0671732,
                    54.7864739
                ]
            ],
            "longitude": 79.091942,
            "latitude": 54.79694
        },
        "3383": {
            "name": "Кульча",
            "population": 324,
            "type": "village",
            "poly": null,
            "longitude": 79.10881,
            "latitude": 55.536221
        },
        "3384": {
            "name": "Баклуши",
            "population": 794,
            "type": "village",
            "poly": [
                [
                    79.1039071,
                    54.3623585
                ],
                [
                    79.105326,
                    54.3639385
                ],
                [
                    79.1060828,
                    54.3637732
                ],
                [
                    79.1066188,
                    54.364306
                ],
                [
                    79.1069972,
                    54.364306
                ],
                [
                    79.1070288,
                    54.3647652
                ],
                [
                    79.106808,
                    54.3649306
                ],
                [
                    79.107218,
                    54.3654082
                ],
                [
                    79.1062405,
                    54.3657757
                ],
                [
                    79.1070288,
                    54.3666207
                ],
                [
                    79.1085738,
                    54.3661615
                ],
                [
                    79.1087946,
                    54.3664738
                ],
                [
                    79.1098982,
                    54.366088
                ],
                [
                    79.1108757,
                    54.3670065
                ],
                [
                    79.1124523,
                    54.3666575
                ],
                [
                    79.1122316,
                    54.36629
                ],
                [
                    79.115101,
                    54.36708
                ],
                [
                    79.1138082,
                    54.3694681
                ],
                [
                    79.113619,
                    54.370313
                ],
                [
                    79.1142812,
                    54.3703681
                ],
                [
                    79.1153217,
                    54.3767784
                ],
                [
                    79.1159524,
                    54.3812962
                ],
                [
                    79.1149434,
                    54.3841058
                ],
                [
                    79.1096459,
                    54.3869886
                ],
                [
                    79.1083531,
                    54.386346
                ],
                [
                    79.1068396,
                    54.3870437
                ],
                [
                    79.1082585,
                    54.3879434
                ],
                [
                    79.1069972,
                    54.3886044
                ],
                [
                    79.1054837,
                    54.3876864
                ],
                [
                    79.1048215,
                    54.3879985
                ],
                [
                    79.1063035,
                    54.3888247
                ],
                [
                    79.1046323,
                    54.3894306
                ],
                [
                    79.1046954,
                    54.390165
                ],
                [
                    79.1050738,
                    54.3905873
                ],
                [
                    79.1056413,
                    54.3902201
                ],
                [
                    79.1061143,
                    54.3903854
                ],
                [
                    79.1068711,
                    54.3901467
                ],
                [
                    79.1073126,
                    54.3903119
                ],
                [
                    79.1076279,
                    54.3929924
                ],
                [
                    79.1061143,
                    54.3935064
                ],
                [
                    79.1063666,
                    54.3942224
                ],
                [
                    79.1078486,
                    54.3937635
                ],
                [
                    79.1083846,
                    54.3950852
                ],
                [
                    79.1092991,
                    54.3949567
                ],
                [
                    79.1108442,
                    54.3967741
                ],
                [
                    79.1116009,
                    54.3965906
                ],
                [
                    79.1117901,
                    54.3968843
                ],
                [
                    79.1144172,
                    54.3963076
                ],
                [
                    79.1136801,
                    54.393283
                ],
                [
                    79.1144073,
                    54.3926803
                ],
                [
                    79.1140289,
                    54.3922397
                ],
                [
                    79.1135559,
                    54.3922397
                ],
                [
                    79.1132721,
                    54.3918909
                ],
                [
                    79.1125535,
                    54.3918516
                ],
                [
                    79.117529,
                    54.3867316
                ],
                [
                    79.1176867,
                    54.3864745
                ],
                [
                    79.1181912,
                    54.3864745
                ],
                [
                    79.1190425,
                    54.3858318
                ],
                [
                    79.1203038,
                    54.3860889
                ],
                [
                    79.1208399,
                    54.3851524
                ],
                [
                    79.1225742,
                    54.3851157
                ],
                [
                    79.1231417,
                    54.3841976
                ],
                [
                    79.1250967,
                    54.3835916
                ],
                [
                    79.126295,
                    54.3819022
                ],
                [
                    79.1253805,
                    54.3817369
                ],
                [
                    79.126007,
                    54.3784479
                ],
                [
                    79.1290668,
                    54.3800917
                ],
                [
                    79.1323807,
                    54.3810024
                ],
                [
                    79.1343987,
                    54.3811676
                ],
                [
                    79.1355339,
                    54.3811309
                ],
                [
                    79.1348087,
                    54.3792945
                ],
                [
                    79.1349158,
                    54.3787867
                ],
                [
                    79.1351899,
                    54.3773064
                ],
                [
                    79.1336104,
                    54.3756948
                ],
                [
                    79.1351555,
                    54.3732887
                ],
                [
                    79.1336104,
                    54.3727744
                ],
                [
                    79.1346825,
                    54.3713601
                ],
                [
                    79.132696,
                    54.3707172
                ],
                [
                    79.133642,
                    54.3696701
                ],
                [
                    79.13216,
                    54.3690639
                ],
                [
                    79.1326014,
                    54.3682924
                ],
                [
                    79.130205,
                    54.3672821
                ],
                [
                    79.1271779,
                    54.3690456
                ],
                [
                    79.1276508,
                    54.3698354
                ],
                [
                    79.1212813,
                    54.3713417
                ],
                [
                    79.1213444,
                    54.3716356
                ],
                [
                    79.1189164,
                    54.3719846
                ],
                [
                    79.1180966,
                    54.3698171
                ],
                [
                    79.1157947,
                    54.3631853
                ],
                [
                    79.1145965,
                    54.3623218
                ],
                [
                    79.11261,
                    54.3626525
                ],
                [
                    79.1118217,
                    54.3632036
                ],
                [
                    79.1117271,
                    54.363516
                ],
                [
                    79.1107811,
                    54.3637181
                ],
                [
                    79.1100559,
                    54.3627995
                ],
                [
                    79.1093306,
                    54.3629648
                ],
                [
                    79.1088261,
                    54.3618257
                ],
                [
                    79.1069972,
                    54.3620829
                ],
                [
                    79.1060828,
                    54.361495
                ],
                [
                    79.1041909,
                    54.3618808
                ],
                [
                    79.1039071,
                    54.3623585
                ]
            ],
            "longitude": 79.119644,
            "latitude": 54.378872
        },
        "3385": {
            "name": "Колыбелька",
            "population": 1101,
            "type": "village",
            "poly": [
                [
                    79.1210745,
                    54.0602064
                ],
                [
                    79.1230571,
                    54.0617772
                ],
                [
                    79.1290427,
                    54.0642122
                ],
                [
                    79.1355044,
                    54.0649308
                ],
                [
                    79.1386749,
                    54.0660088
                ],
                [
                    79.1401059,
                    54.0667098
                ],
                [
                    79.1413008,
                    54.0675218
                ],
                [
                    79.1424121,
                    54.0687155
                ],
                [
                    79.1433227,
                    54.0701313
                ],
                [
                    79.1438904,
                    54.0716025
                ],
                [
                    79.1453669,
                    54.0729534
                ],
                [
                    79.1493799,
                    54.0734324
                ],
                [
                    79.15716,
                    54.0728724
                ],
                [
                    79.1590877,
                    54.0716788
                ],
                [
                    79.1586856,
                    54.069118
                ],
                [
                    79.1596948,
                    54.0635757
                ],
                [
                    79.1573374,
                    54.0621219
                ],
                [
                    79.1551523,
                    54.060606
                ],
                [
                    79.1496145,
                    54.063177
                ],
                [
                    79.1454908,
                    54.064004
                ],
                [
                    79.142826,
                    54.0633436
                ],
                [
                    79.1409811,
                    54.0626078
                ],
                [
                    79.1371492,
                    54.0609975
                ],
                [
                    79.1298589,
                    54.0578249
                ],
                [
                    79.1237228,
                    54.0576098
                ],
                [
                    79.1224356,
                    54.0583914
                ],
                [
                    79.1210745,
                    54.0602064
                ]
            ],
            "longitude": 79.144791,
            "latitude": 54.066292
        },
        "3386": {
            "name": "Казанак",
            "population": 441,
            "type": "village",
            "poly": [
                [
                    79.1470925,
                    54.1817088
                ],
                [
                    79.1480311,
                    54.1826532
                ],
                [
                    79.1541209,
                    54.1881882
                ],
                [
                    79.1572431,
                    54.1909428
                ],
                [
                    79.1576482,
                    54.1917928
                ],
                [
                    79.1582489,
                    54.1926755
                ],
                [
                    79.1592756,
                    54.1933947
                ],
                [
                    79.1599531,
                    54.1936603
                ],
                [
                    79.1605244,
                    54.1937589
                ],
                [
                    79.1688975,
                    54.1964163
                ],
                [
                    79.1721857,
                    54.1939748
                ],
                [
                    79.1698461,
                    54.1895353
                ],
                [
                    79.176098,
                    54.1800538
                ],
                [
                    79.1637284,
                    54.1767693
                ],
                [
                    79.1537694,
                    54.1770006
                ],
                [
                    79.1479995,
                    54.1798686
                ],
                [
                    79.1470925,
                    54.1817088
                ]
            ],
            "longitude": 79.160789,
            "latitude": 54.183975
        },
        "3387": {
            "name": "Александро-Невское",
            "population": 429,
            "type": "village",
            "poly": [
                [
                    79.1512171,
                    55.2568623
                ],
                [
                    79.1534779,
                    55.2578678
                ],
                [
                    79.1585508,
                    55.2590305
                ],
                [
                    79.1627415,
                    55.2593761
                ],
                [
                    79.164892,
                    55.26123
                ],
                [
                    79.1705163,
                    55.2623926
                ],
                [
                    79.173935,
                    55.2646233
                ],
                [
                    79.1737144,
                    55.2661314
                ],
                [
                    79.1699649,
                    55.2665084
                ],
                [
                    79.1691929,
                    55.2679221
                ],
                [
                    79.17592,
                    55.2690845
                ],
                [
                    79.1805518,
                    55.2681106
                ],
                [
                    79.1827574,
                    55.2664455
                ],
                [
                    79.1859004,
                    55.2615128
                ],
                [
                    79.18375,
                    55.2578364
                ],
                [
                    79.1684761,
                    55.2578364
                ],
                [
                    79.1736593,
                    55.250294
                ],
                [
                    79.1788425,
                    55.2487225
                ],
                [
                    79.1781257,
                    55.2476538
                ],
                [
                    79.1689172,
                    55.2476224
                ],
                [
                    79.1636788,
                    55.2488168
                ],
                [
                    79.1632378,
                    55.2497911
                ],
                [
                    79.1629619,
                    55.252714
                ],
                [
                    79.1586611,
                    55.2530911
                ],
                [
                    79.1570069,
                    55.2551653
                ],
                [
                    79.1523751,
                    55.2547568
                ],
                [
                    79.1512171,
                    55.2568623
                ]
            ],
            "longitude": 79.176933,
            "latitude": 55.261948
        },
        "3388": {
            "name": "Кайгородский",
            "population": 631,
            "type": "village",
            "poly": [
                [
                    79.184388,
                    53.980473
                ],
                [
                    79.1877545,
                    53.9839105
                ],
                [
                    79.1993002,
                    53.9892814
                ],
                [
                    79.2088099,
                    53.9893781
                ],
                [
                    79.2108841,
                    53.9885133
                ],
                [
                    79.1936799,
                    53.9767313
                ],
                [
                    79.1921741,
                    53.9766618
                ],
                [
                    79.1909083,
                    53.976978
                ],
                [
                    79.1902362,
                    53.9781111
                ],
                [
                    79.1892841,
                    53.9785393
                ],
                [
                    79.1882325,
                    53.978575
                ],
                [
                    79.1865074,
                    53.9777713
                ],
                [
                    79.1847502,
                    53.9784007
                ],
                [
                    79.184388,
                    53.980473
                ]
            ],
            "longitude": 79.194077,
            "latitude": 53.980347
        },
        "3389": {
            "name": "Старогорносталево",
            "population": 670,
            "type": "village",
            "poly": [
                [
                    79.2191993,
                    54.6764362
                ],
                [
                    79.2204143,
                    54.6764027
                ],
                [
                    79.2212532,
                    54.6760682
                ],
                [
                    79.2220921,
                    54.6751316
                ],
                [
                    79.2222078,
                    54.6735593
                ],
                [
                    79.2232203,
                    54.6720371
                ],
                [
                    79.2250716,
                    54.6701803
                ],
                [
                    79.2272701,
                    54.6685576
                ],
                [
                    79.2288611,
                    54.6677044
                ],
                [
                    79.2307125,
                    54.6671691
                ],
                [
                    79.2328531,
                    54.6662824
                ],
                [
                    79.2357459,
                    54.6660482
                ],
                [
                    79.2393328,
                    54.6667007
                ],
                [
                    79.2427753,
                    54.6682063
                ],
                [
                    79.2437588,
                    54.6696617
                ],
                [
                    79.2362665,
                    54.6731076
                ],
                [
                    79.2365269,
                    54.6748138
                ],
                [
                    79.2377708,
                    54.6761686
                ],
                [
                    79.2388411,
                    54.6791624
                ],
                [
                    79.2347913,
                    54.6791958
                ],
                [
                    79.232101,
                    54.6784767
                ],
                [
                    79.2317539,
                    54.6780251
                ],
                [
                    79.2272412,
                    54.6771052
                ],
                [
                    79.2258815,
                    54.6794634
                ],
                [
                    79.226518,
                    54.6799986
                ],
                [
                    79.2307414,
                    54.6812863
                ],
                [
                    79.2294686,
                    54.6830256
                ],
                [
                    79.2267205,
                    54.6825908
                ],
                [
                    79.2264945,
                    54.6841423
                ],
                [
                    79.2312404,
                    54.6847302
                ],
                [
                    79.2315794,
                    54.6837504
                ],
                [
                    79.2344044,
                    54.6843383
                ],
                [
                    79.2414668,
                    54.6864286
                ],
                [
                    79.2451957,
                    54.6834238
                ],
                [
                    79.2471167,
                    54.6830972
                ],
                [
                    79.2461562,
                    54.6804841
                ],
                [
                    79.2435007,
                    54.6788509
                ],
                [
                    79.2424836,
                    54.6768909
                ],
                [
                    79.2416928,
                    54.6747675
                ],
                [
                    79.2422012,
                    54.6724806
                ],
                [
                    79.2475687,
                    54.6694421
                ],
                [
                    79.2493766,
                    54.6699322
                ],
                [
                    79.2511281,
                    54.6684293
                ],
                [
                    79.2431617,
                    54.6654559
                ],
                [
                    79.2385853,
                    54.662711
                ],
                [
                    79.2414668,
                    54.6600312
                ],
                [
                    79.2387548,
                    54.6560113
                ],
                [
                    79.2360065,
                    54.6548143
                ],
                [
                    79.2332002,
                    54.6535992
                ],
                [
                    79.2310885,
                    54.6545531
                ],
                [
                    79.2267205,
                    54.6585358
                ],
                [
                    79.2226996,
                    54.6615811
                ],
                [
                    79.2206457,
                    54.6634717
                ],
                [
                    79.2251873,
                    54.6646931
                ],
                [
                    79.2233649,
                    54.6658809
                ],
                [
                    79.221311,
                    54.6679386
                ],
                [
                    79.2218317,
                    54.6681896
                ],
                [
                    79.2209639,
                    54.6691097
                ],
                [
                    79.2191993,
                    54.6764362
                ]
            ],
            "longitude": 79.230797,
            "latitude": 54.663452
        },
        "3390": {
            "name": "Ильинка",
            "population": 849,
            "type": "village",
            "poly": [
                [
                    79.211423,
                    54.5185437
                ],
                [
                    79.2129844,
                    54.519825
                ],
                [
                    79.2135766,
                    54.5198875
                ],
                [
                    79.2176147,
                    54.5211531
                ],
                [
                    79.2217065,
                    54.5215125
                ],
                [
                    79.2255561,
                    54.522653
                ],
                [
                    79.2311017,
                    54.5271369
                ],
                [
                    79.2287445,
                    54.5310213
                ],
                [
                    79.2272124,
                    54.5328476
                ],
                [
                    79.2299441,
                    54.5339476
                ],
                [
                    79.2355166,
                    54.5357751
                ],
                [
                    79.2381548,
                    54.5368528
                ],
                [
                    79.2368624,
                    54.5381134
                ],
                [
                    79.2394544,
                    54.5396489
                ],
                [
                    79.2427093,
                    54.5412501
                ],
                [
                    79.2455729,
                    54.538791
                ],
                [
                    79.2398349,
                    54.5364747
                ],
                [
                    79.2361089,
                    54.5334166
                ],
                [
                    79.2361896,
                    54.5318233
                ],
                [
                    79.2371318,
                    54.5314016
                ],
                [
                    79.2383433,
                    54.5316983
                ],
                [
                    79.2396085,
                    54.5308861
                ],
                [
                    79.2426774,
                    54.5310267
                ],
                [
                    79.2443964,
                    54.53133
                ],
                [
                    79.2462578,
                    54.5317921
                ],
                [
                    79.2518303,
                    54.5334634
                ],
                [
                    79.2582104,
                    54.536353
                ],
                [
                    79.2595295,
                    54.5344943
                ],
                [
                    79.2617639,
                    54.5328699
                ],
                [
                    79.2601756,
                    54.5320576
                ],
                [
                    79.257322,
                    54.5277462
                ],
                [
                    79.255976,
                    54.5270275
                ],
                [
                    79.2556261,
                    54.5260277
                ],
                [
                    79.2546569,
                    54.5256371
                ],
                [
                    79.2534994,
                    54.5254653
                ],
                [
                    79.2515342,
                    54.524731
                ],
                [
                    79.2512919,
                    54.5249497
                ],
                [
                    79.2463386,
                    54.5239654
                ],
                [
                    79.2433773,
                    54.5230749
                ],
                [
                    79.2414712,
                    54.5216484
                ],
                [
                    79.240443,
                    54.5218875
                ],
                [
                    79.238805,
                    54.521691
                ],
                [
                    79.2373472,
                    54.5204188
                ],
                [
                    79.2366473,
                    54.5200594
                ],
                [
                    79.2349244,
                    54.5186687
                ],
                [
                    79.2307098,
                    54.5161046
                ],
                [
                    79.2285743,
                    54.5148536
                ],
                [
                    79.2260945,
                    54.512715
                ],
                [
                    79.2248831,
                    54.512293
                ],
                [
                    79.2210874,
                    54.5122149
                ],
                [
                    79.2154072,
                    54.512418
                ],
                [
                    79.2138189,
                    54.513387
                ],
                [
                    79.2123921,
                    54.515231
                ],
                [
                    79.211746,
                    54.5169655
                ],
                [
                    79.211423,
                    54.5185437
                ]
            ],
            "longitude": 79.233513,
            "latitude": 54.52475
        },
        "3391": {
            "name": "Половинное",
            "population": 3022,
            "type": "village",
            "poly": [
                [
                    79.2098008,
                    53.7279534
                ],
                [
                    79.2125864,
                    53.7307398
                ],
                [
                    79.2138501,
                    53.7325775
                ],
                [
                    79.2135342,
                    53.7336677
                ],
                [
                    79.2135236,
                    53.7358154
                ],
                [
                    79.2145346,
                    53.7382773
                ],
                [
                    79.2286658,
                    53.7476598
                ],
                [
                    79.2362018,
                    53.7496595
                ],
                [
                    79.2402385,
                    53.7553491
                ],
                [
                    79.2407303,
                    53.7585159
                ],
                [
                    79.2412568,
                    53.7601813
                ],
                [
                    79.2414658,
                    53.762158
                ],
                [
                    79.2398352,
                    53.7637608
                ],
                [
                    79.2384758,
                    53.7642887
                ],
                [
                    79.2366676,
                    53.7650073
                ],
                [
                    79.2270226,
                    53.7664186
                ],
                [
                    79.2266272,
                    53.7675083
                ],
                [
                    79.2243354,
                    53.7738244
                ],
                [
                    79.2447804,
                    53.7758682
                ],
                [
                    79.2484441,
                    53.7729115
                ],
                [
                    79.2496025,
                    53.7711922
                ],
                [
                    79.2498789,
                    53.7702275
                ],
                [
                    79.2511215,
                    53.769816
                ],
                [
                    79.251577,
                    53.7702275
                ],
                [
                    79.252538,
                    53.7709588
                ],
                [
                    79.2577804,
                    53.7687432
                ],
                [
                    79.2624791,
                    53.7662496
                ],
                [
                    79.2713031,
                    53.7526108
                ],
                [
                    79.2748141,
                    53.7497601
                ],
                [
                    79.2703911,
                    53.746771
                ],
                [
                    79.2620717,
                    53.7417264
                ],
                [
                    79.2688723,
                    53.7332409
                ],
                [
                    79.2645681,
                    53.7271122
                ],
                [
                    79.2506635,
                    53.7265716
                ],
                [
                    79.2490277,
                    53.7281846
                ],
                [
                    79.2453386,
                    53.7314998
                ],
                [
                    79.2418442,
                    53.7332291
                ],
                [
                    79.2403076,
                    53.7339563
                ],
                [
                    79.2379553,
                    53.7343892
                ],
                [
                    79.2365173,
                    53.7345623
                ],
                [
                    79.2349806,
                    53.7344613
                ],
                [
                    79.2330343,
                    53.7338957
                ],
                [
                    79.2313607,
                    53.7328579
                ],
                [
                    79.2306781,
                    53.7316333
                ],
                [
                    79.2309513,
                    53.7305829
                ],
                [
                    79.2318648,
                    53.7293988
                ],
                [
                    79.2212688,
                    53.7222249
                ],
                [
                    79.2098008,
                    53.7279534
                ]
            ],
            "longitude": 79.237946,
            "latitude": 53.743317
        },
        "3392": {
            "name": "Красный Хутор",
            "population": 497,
            "type": "village",
            "poly": [
                [
                    79.2516416,
                    53.9600161
                ],
                [
                    79.2583814,
                    53.9663566
                ],
                [
                    79.2674377,
                    53.9663022
                ],
                [
                    79.2710879,
                    53.9643723
                ],
                [
                    79.265183,
                    53.9600561
                ],
                [
                    79.2597029,
                    53.9555394
                ],
                [
                    79.2540474,
                    53.9569096
                ],
                [
                    79.2516416,
                    53.9600161
                ]
            ],
            "longitude": 79.261597,
            "latitude": 53.96286
        },
        "3393": {
            "name": "Новогандичево",
            "population": 298,
            "type": "village",
            "poly": [
                [
                    79.2834963,
                    55.0080594
                ],
                [
                    79.2885149,
                    55.0104847
                ],
                [
                    79.2900566,
                    55.0116806
                ],
                [
                    79.2933134,
                    55.0123695
                ],
                [
                    79.2975187,
                    55.0106471
                ],
                [
                    79.2960958,
                    55.0088702
                ],
                [
                    79.2995107,
                    55.0066762
                ],
                [
                    79.2994158,
                    55.0046272
                ],
                [
                    79.2981827,
                    55.0027775
                ],
                [
                    79.2936928,
                    55.0004018
                ],
                [
                    79.2921435,
                    55.0004743
                ],
                [
                    79.2875903,
                    55.0029951
                ],
                [
                    79.2855806,
                    55.0041716
                ],
                [
                    79.2844272,
                    55.0061794
                ],
                [
                    79.2834963,
                    55.0080594
                ]
            ],
            "longitude": 79.292931,
            "latitude": 55.006645
        },
        "3394": {
            "name": "Новосёлово",
            "population": 352,
            "type": "village",
            "poly": [
                [
                    79.2869745,
                    55.3978177
                ],
                [
                    79.2881325,
                    55.3985191
                ],
                [
                    79.287901,
                    55.403034
                ],
                [
                    79.2899465,
                    55.4035381
                ],
                [
                    79.2899852,
                    55.4052913
                ],
                [
                    79.2926099,
                    55.4052913
                ],
                [
                    79.2926871,
                    55.4038449
                ],
                [
                    79.2989398,
                    55.40356
                ],
                [
                    79.3021435,
                    55.3949243
                ],
                [
                    79.3007154,
                    55.3942448
                ],
                [
                    79.304112,
                    55.3898604
                ],
                [
                    79.3022979,
                    55.3891589
                ],
                [
                    79.296817,
                    55.3892027
                ],
                [
                    79.2949258,
                    55.39111
                ],
                [
                    79.2923397,
                    55.3948805
                ],
                [
                    79.2881711,
                    55.3967218
                ],
                [
                    79.2869745,
                    55.3978177
                ]
            ],
            "longitude": 79.296608,
            "latitude": 55.396591
        },
        "3395": {
            "name": "Круглоозёрное",
            "population": 829,
            "type": "village",
            "poly": [
                [
                    79.279025,
                    55.0747716
                ],
                [
                    79.2853476,
                    55.0784418
                ],
                [
                    79.2821642,
                    55.0788974
                ],
                [
                    79.2807051,
                    55.080416
                ],
                [
                    79.2818989,
                    55.0826178
                ],
                [
                    79.2906976,
                    55.0853004
                ],
                [
                    79.2951632,
                    55.0849461
                ],
                [
                    79.2984793,
                    55.0840604
                ],
                [
                    79.3041388,
                    55.0857559
                ],
                [
                    79.3082065,
                    55.0878057
                ],
                [
                    79.3128932,
                    55.0883371
                ],
                [
                    79.3158114,
                    55.0875273
                ],
                [
                    79.3153692,
                    55.0856041
                ],
                [
                    79.3124953,
                    55.0842628
                ],
                [
                    79.3084276,
                    55.0840098
                ],
                [
                    79.3047136,
                    55.0824154
                ],
                [
                    79.3087371,
                    55.0824154
                ],
                [
                    79.3110362,
                    55.0827697
                ],
                [
                    79.3132912,
                    55.0798845
                ],
                [
                    79.3086929,
                    55.0789733
                ],
                [
                    79.3083506,
                    55.0791347
                ],
                [
                    79.3056863,
                    55.0803907
                ],
                [
                    79.2957822,
                    55.0756322
                ],
                [
                    79.2813241,
                    55.0718098
                ],
                [
                    79.279025,
                    55.0747716
                ]
            ],
            "longitude": 79.297859,
            "latitude": 55.081085
        },
        "3396": {
            "name": "Борисоглебка",
            "population": 372,
            "type": "village",
            "poly": [
                [
                    79.3020225,
                    55.2661073
                ],
                [
                    79.3029246,
                    55.2679575
                ],
                [
                    79.3038627,
                    55.2689442
                ],
                [
                    79.3075791,
                    55.271822
                ],
                [
                    79.3068936,
                    55.2741242
                ],
                [
                    79.3080843,
                    55.2743503
                ],
                [
                    79.3108625,
                    55.2736925
                ],
                [
                    79.3133523,
                    55.2754191
                ],
                [
                    79.3145069,
                    55.2785636
                ],
                [
                    79.315445,
                    55.2794062
                ],
                [
                    79.3172852,
                    55.2801872
                ],
                [
                    79.320713,
                    55.2788925
                ],
                [
                    79.3257284,
                    55.2744119
                ],
                [
                    79.3254397,
                    55.2727059
                ],
                [
                    79.321146,
                    55.2697459
                ],
                [
                    79.3190532,
                    55.2686975
                ],
                [
                    79.3130275,
                    55.2657372
                ],
                [
                    79.3041153,
                    55.2641336
                ],
                [
                    79.302239,
                    55.2650999
                ],
                [
                    79.3020225,
                    55.2661073
                ]
            ],
            "longitude": 79.313156,
            "latitude": 55.270214
        },
        "3397": {
            "name": "Кундран",
            "population": 508,
            "type": "village",
            "poly": [
                [
                    79.2998516,
                    54.9048484
                ],
                [
                    79.3013251,
                    54.911988
                ],
                [
                    79.3218791,
                    54.9174369
                ],
                [
                    79.3258552,
                    54.9116807
                ],
                [
                    79.3246899,
                    54.9082368
                ],
                [
                    79.324532,
                    54.90742
                ],
                [
                    79.3266675,
                    54.9072848
                ],
                [
                    79.3279032,
                    54.9061658
                ],
                [
                    79.3297944,
                    54.9060283
                ],
                [
                    79.3318467,
                    54.9064519
                ],
                [
                    79.3348482,
                    54.9073405
                ],
                [
                    79.3376353,
                    54.9089326
                ],
                [
                    79.3381615,
                    54.9091747
                ],
                [
                    79.3413715,
                    54.9076015
                ],
                [
                    79.3345831,
                    54.9018228
                ],
                [
                    79.3295839,
                    54.8984641
                ],
                [
                    79.3218482,
                    54.8969208
                ],
                [
                    79.3135864,
                    54.8916853
                ],
                [
                    79.3109026,
                    54.8919577
                ],
                [
                    79.3052719,
                    54.8937735
                ],
                [
                    79.2998516,
                    54.9048484
                ]
            ],
            "longitude": 79.318283,
            "latitude": 54.905655
        },
        "3398": {
            "name": "Полойка",
            "population": 1129,
            "type": "village",
            "poly": [
                [
                    79.313784,
                    54.1940122
                ],
                [
                    79.315493,
                    54.1996664
                ],
                [
                    79.3173462,
                    54.2053674
                ],
                [
                    79.3210785,
                    54.2167179
                ],
                [
                    79.3234078,
                    54.2168006
                ],
                [
                    79.3253716,
                    54.2178245
                ],
                [
                    79.3268253,
                    54.218421
                ],
                [
                    79.3274813,
                    54.2183181
                ],
                [
                    79.3275493,
                    54.2178509
                ],
                [
                    79.3280919,
                    54.2177897
                ],
                [
                    79.3303504,
                    54.2181971
                ],
                [
                    79.3310718,
                    54.218879
                ],
                [
                    79.3319134,
                    54.2205941
                ],
                [
                    79.3349549,
                    54.2201161
                ],
                [
                    79.3350392,
                    54.2187735
                ],
                [
                    79.3353771,
                    54.2158669
                ],
                [
                    79.331997,
                    54.2100382
                ],
                [
                    79.3274397,
                    54.2046214
                ],
                [
                    79.327447,
                    54.2038049
                ],
                [
                    79.3277858,
                    54.2029858
                ],
                [
                    79.328486,
                    54.2021402
                ],
                [
                    79.329909,
                    54.2014532
                ],
                [
                    79.3317159,
                    54.2003169
                ],
                [
                    79.3290281,
                    54.1975951
                ],
                [
                    79.3295947,
                    54.1941599
                ],
                [
                    79.3297987,
                    54.1924442
                ],
                [
                    79.3304681,
                    54.190593
                ],
                [
                    79.3320428,
                    54.1900569
                ],
                [
                    79.3342105,
                    54.1901613
                ],
                [
                    79.3386737,
                    54.1919266
                ],
                [
                    79.3475698,
                    54.2024896
                ],
                [
                    79.3455439,
                    54.2126892
                ],
                [
                    79.3601652,
                    54.2073322
                ],
                [
                    79.355497,
                    54.2014076
                ],
                [
                    79.3514453,
                    54.2012015
                ],
                [
                    79.3491552,
                    54.1990376
                ],
                [
                    79.3503371,
                    54.1967681
                ],
                [
                    79.3513761,
                    54.1957903
                ],
                [
                    79.3529513,
                    54.1948473
                ],
                [
                    79.3492081,
                    54.1915762
                ],
                [
                    79.3403351,
                    54.18912
                ],
                [
                    79.3308347,
                    54.1875445
                ],
                [
                    79.3270584,
                    54.1857433
                ],
                [
                    79.3240658,
                    54.1871362
                ],
                [
                    79.3250485,
                    54.1887857
                ],
                [
                    79.3239342,
                    54.1901753
                ],
                [
                    79.3232729,
                    54.1906008
                ],
                [
                    79.3225755,
                    54.1907943
                ],
                [
                    79.3223795,
                    54.1911704
                ],
                [
                    79.3220887,
                    54.1914907
                ],
                [
                    79.3215357,
                    54.1917298
                ],
                [
                    79.3201952,
                    54.1919444
                ],
                [
                    79.3180311,
                    54.1926548
                ],
                [
                    79.3155102,
                    54.1936721
                ],
                [
                    79.313784,
                    54.1940122
                ]
            ],
            "longitude": 79.321495,
            "latitude": 54.201042
        },
        "3399": {
            "name": "Зоново",
            "population": 420,
            "type": "village",
            "poly": null,
            "longitude": 79.326996,
            "latitude": 55.729355
        },
        "3400": {
            "name": "Михайловка",
            "population": 211,
            "type": "village",
            "poly": null,
            "longitude": 79.356705,
            "latitude": 55.590782
        },
        "3401": {
            "name": "Орехов Лог",
            "population": 932,
            "type": "village",
            "poly": [
                [
                    79.3688748,
                    53.8477444
                ],
                [
                    79.3825287,
                    53.8515823
                ],
                [
                    79.3906193,
                    53.8505975
                ],
                [
                    79.3967832,
                    53.849533
                ],
                [
                    79.4041172,
                    53.8455083
                ],
                [
                    79.4101818,
                    53.8373501
                ],
                [
                    79.3981387,
                    53.8311134
                ],
                [
                    79.3872387,
                    53.8243058
                ],
                [
                    79.3729746,
                    53.833557
                ],
                [
                    79.3691673,
                    53.8403395
                ],
                [
                    79.3688748,
                    53.8477444
                ]
            ],
            "longitude": 79.390999,
            "latitude": 53.840603
        },
        "3402": {
            "name": "Волчанка",
            "population": 455,
            "type": "village",
            "poly": [
                [
                    79.3853766,
                    54.4317364
                ],
                [
                    79.3878988,
                    54.4332627
                ],
                [
                    79.389092,
                    54.4337945
                ],
                [
                    79.3900946,
                    54.433966
                ],
                [
                    79.3895638,
                    54.4349265
                ],
                [
                    79.3888561,
                    54.4349265
                ],
                [
                    79.3883253,
                    54.4360584
                ],
                [
                    79.3894459,
                    54.4362299
                ],
                [
                    79.3893869,
                    54.4379106
                ],
                [
                    79.3872103,
                    54.4401531
                ],
                [
                    79.3890981,
                    54.4460858
                ],
                [
                    79.3950367,
                    54.447447
                ],
                [
                    79.3961099,
                    54.4407915
                ],
                [
                    79.39841,
                    54.4379449
                ],
                [
                    79.3991176,
                    54.4381507
                ],
                [
                    79.4002971,
                    54.4377734
                ],
                [
                    79.40071,
                    54.4372589
                ],
                [
                    79.4027151,
                    54.4372589
                ],
                [
                    79.402892,
                    54.4384936
                ],
                [
                    79.405074,
                    54.4394883
                ],
                [
                    79.4088484,
                    54.4390424
                ],
                [
                    79.409792,
                    54.4389738
                ],
                [
                    79.4113843,
                    54.4389395
                ],
                [
                    79.4113253,
                    54.4380821
                ],
                [
                    79.4125047,
                    54.4382193
                ],
                [
                    79.4130945,
                    54.4370874
                ],
                [
                    79.4149922,
                    54.4364515
                ],
                [
                    79.4168204,
                    54.4356739
                ],
                [
                    79.4161022,
                    54.4334172
                ],
                [
                    79.4154535,
                    54.4311532
                ],
                [
                    79.4176801,
                    54.4292368
                ],
                [
                    79.4150407,
                    54.4275168
                ],
                [
                    79.4081997,
                    54.4265905
                ],
                [
                    79.4003543,
                    54.4245751
                ],
                [
                    79.3976433,
                    54.4247035
                ],
                [
                    79.396051,
                    54.4248064
                ],
                [
                    79.3947652,
                    54.4250453
                ],
                [
                    79.3935741,
                    54.4250123
                ],
                [
                    79.3924535,
                    54.424978
                ],
                [
                    79.3919788,
                    54.425188
                ],
                [
                    79.3913269,
                    54.4251501
                ],
                [
                    79.3907433,
                    54.4247378
                ],
                [
                    79.3897997,
                    54.4246692
                ],
                [
                    79.3889933,
                    54.4254025
                ],
                [
                    79.38691,
                    54.4255269
                ],
                [
                    79.3864382,
                    54.4262817
                ],
                [
                    79.3879715,
                    54.4290606
                ],
                [
                    79.3870869,
                    54.4290263
                ],
                [
                    79.3853766,
                    54.4317364
                ]
            ],
            "longitude": 79.401978,
            "latitude": 54.431187
        },
        "3403": {
            "name": "Гербаево",
            "population": 385,
            "type": "village",
            "poly": [
                [
                    79.4035965,
                    53.9876421
                ],
                [
                    79.4185375,
                    53.9901367
                ],
                [
                    79.4257259,
                    53.9882498
                ],
                [
                    79.4250932,
                    53.9853014
                ],
                [
                    79.4253309,
                    53.983785
                ],
                [
                    79.4253212,
                    53.983036
                ],
                [
                    79.4252903,
                    53.9826538
                ],
                [
                    79.4252049,
                    53.9822774
                ],
                [
                    79.4251585,
                    53.980789
                ],
                [
                    79.4253595,
                    53.9800681
                ],
                [
                    79.4256944,
                    53.9795999
                ],
                [
                    79.4231569,
                    53.9781982
                ],
                [
                    79.4214972,
                    53.9765672
                ],
                [
                    79.4105912,
                    53.981652
                ],
                [
                    79.4092935,
                    53.9840481
                ],
                [
                    79.4035965,
                    53.9876421
                ]
            ],
            "longitude": 79.415321,
            "latitude": 53.985466
        },
        "3404": {
            "name": "Балман",
            "population": 300,
            "type": "village",
            "poly": null,
            "longitude": 79.424332,
            "latitude": 55.803299
        },
        "3405": {
            "name": "Суздалка",
            "population": 953,
            "type": "village",
            "poly": [
                [
                    79.4240282,
                    54.5763907
                ],
                [
                    79.4326528,
                    54.5781207
                ],
                [
                    79.4377328,
                    54.5788679
                ],
                [
                    79.4411903,
                    54.5800893
                ],
                [
                    79.4460298,
                    54.5810369
                ],
                [
                    79.4486195,
                    54.5818599
                ],
                [
                    79.4515121,
                    54.5831494
                ],
                [
                    79.4532317,
                    54.5839877
                ],
                [
                    79.4540502,
                    54.5851353
                ],
                [
                    79.4546538,
                    54.5863809
                ],
                [
                    79.4530435,
                    54.5873861
                ],
                [
                    79.4519144,
                    54.5879053
                ],
                [
                    79.4457522,
                    54.588943
                ],
                [
                    79.4482583,
                    54.5903978
                ],
                [
                    79.4503062,
                    54.5907351
                ],
                [
                    79.4502142,
                    54.5962713
                ],
                [
                    79.4534083,
                    54.5968436
                ],
                [
                    79.4537047,
                    54.60125
                ],
                [
                    79.461904,
                    54.6010593
                ],
                [
                    79.4642749,
                    54.6001056
                ],
                [
                    79.4720461,
                    54.6032528
                ],
                [
                    79.476397,
                    54.6009191
                ],
                [
                    79.4738975,
                    54.6002612
                ],
                [
                    79.470332,
                    54.5993757
                ],
                [
                    79.4671645,
                    54.5977064
                ],
                [
                    79.4644189,
                    54.5962679
                ],
                [
                    79.4627682,
                    54.5934162
                ],
                [
                    79.4620118,
                    54.5920585
                ],
                [
                    79.460826,
                    54.5907316
                ],
                [
                    79.4583974,
                    54.5886167
                ],
                [
                    79.4587336,
                    54.5870256
                ],
                [
                    79.4599664,
                    54.5868145
                ],
                [
                    79.461265,
                    54.5869039
                ],
                [
                    79.4632728,
                    54.5872529
                ],
                [
                    79.4664389,
                    54.5884544
                ],
                [
                    79.4734998,
                    54.5911981
                ],
                [
                    79.4848555,
                    54.5960614
                ],
                [
                    79.485547,
                    54.5960614
                ],
                [
                    79.489268,
                    54.5936386
                ],
                [
                    79.4798173,
                    54.5902044
                ],
                [
                    79.4780062,
                    54.5902616
                ],
                [
                    79.4738572,
                    54.5886017
                ],
                [
                    79.4699386,
                    54.5865982
                ],
                [
                    79.4636018,
                    54.5840061
                ],
                [
                    79.4528327,
                    54.5787297
                ],
                [
                    79.4391817,
                    54.5712332
                ],
                [
                    79.4338472,
                    54.5709087
                ],
                [
                    79.4300933,
                    54.5707881
                ],
                [
                    79.4240282,
                    54.5763907
                ]
            ],
            "longitude": 79.4518893,
            "latitude": 54.5808575
        },
        "3406": {
            "name": "Шагалка",
            "population": 192,
            "type": "village",
            "poly": [
                [
                    79.4759773,
                    54.2978587
                ],
                [
                    79.4767722,
                    54.3014183
                ],
                [
                    79.4846905,
                    54.3033609
                ],
                [
                    79.4872197,
                    54.3016297
                ],
                [
                    79.4896655,
                    54.2997796
                ],
                [
                    79.4901486,
                    54.2989515
                ],
                [
                    79.4900667,
                    54.2984926
                ],
                [
                    79.490994,
                    54.2980176
                ],
                [
                    79.4966774,
                    54.2972287
                ],
                [
                    79.4976134,
                    54.2956531
                ],
                [
                    79.4960618,
                    54.292157
                ],
                [
                    79.4876751,
                    54.289526
                ],
                [
                    79.4837416,
                    54.2886382
                ],
                [
                    79.4781914,
                    54.2946871
                ],
                [
                    79.4759773,
                    54.2978587
                ]
            ],
            "longitude": 79.485764,
            "latitude": 54.295567
        },
        "3407": {
            "name": "Садовый",
            "population": 662,
            "type": "village",
            "poly": [
                [
                    79.4815498,
                    53.7512992
                ],
                [
                    79.4971109,
                    53.7538046
                ],
                [
                    79.5133381,
                    53.7537163
                ],
                [
                    79.5070877,
                    53.7404517
                ],
                [
                    79.4912123,
                    53.7380981
                ],
                [
                    79.4815498,
                    53.7512992
                ]
            ],
            "longitude": 79.494835,
            "latitude": 53.747803
        },
        "3408": {
            "name": "Мохнатый Лог",
            "population": 1024,
            "type": "village",
            "poly": [
                [
                    79.5611646,
                    54.0088742
                ],
                [
                    79.5613098,
                    54.0201358
                ],
                [
                    79.5820066,
                    54.0276502
                ],
                [
                    79.5858219,
                    54.0297678
                ],
                [
                    79.5919314,
                    54.0286102
                ],
                [
                    79.6018606,
                    54.0293749
                ],
                [
                    79.615419,
                    54.0292602
                ],
                [
                    79.622169,
                    54.029204
                ],
                [
                    79.6264367,
                    54.029869
                ],
                [
                    79.6289399,
                    54.0290225
                ],
                [
                    79.630661,
                    54.0272906
                ],
                [
                    79.6286235,
                    54.0264055
                ],
                [
                    79.6175467,
                    54.0222131
                ],
                [
                    79.6140525,
                    54.0156179
                ],
                [
                    79.6066928,
                    54.0153558
                ],
                [
                    79.5977719,
                    54.0209029
                ],
                [
                    79.5936831,
                    54.0206845
                ],
                [
                    79.5873641,
                    54.0154868
                ],
                [
                    79.5876449,
                    54.0144272
                ],
                [
                    79.5882362,
                    54.0133126
                ],
                [
                    79.5900838,
                    54.0110978
                ],
                [
                    79.5905518,
                    54.0096791
                ],
                [
                    79.5903548,
                    54.0083907
                ],
                [
                    79.5880332,
                    54.0066188
                ],
                [
                    79.5812399,
                    54.0062046
                ],
                [
                    79.5779388,
                    54.0064942
                ],
                [
                    79.5745639,
                    54.0075655
                ],
                [
                    79.5611646,
                    54.0088742
                ]
            ],
            "longitude": 79.587837,
            "latitude": 54.023464
        },
        "3409": {
            "name": "Раисино",
            "population": 2240,
            "type": "village",
            "poly": [
                [
                    79.5710693,
                    55.1822511
                ],
                [
                    79.5717791,
                    55.186472
                ],
                [
                    79.5791719,
                    55.1868434
                ],
                [
                    79.5863282,
                    55.1873837
                ],
                [
                    79.5799999,
                    55.1929544
                ],
                [
                    79.5859142,
                    55.1944736
                ],
                [
                    79.5894037,
                    55.1899159
                ],
                [
                    79.59242,
                    55.1949462
                ],
                [
                    79.607738,
                    55.1967015
                ],
                [
                    79.6096897,
                    55.1946761
                ],
                [
                    79.60898,
                    55.1925155
                ],
                [
                    79.5940168,
                    55.1851889
                ],
                [
                    79.5946083,
                    55.1836019
                ],
                [
                    79.5919468,
                    55.1831966
                ],
                [
                    79.5895811,
                    55.1838382
                ],
                [
                    79.5817151,
                    55.1800223
                ],
                [
                    79.5743222,
                    55.1785702
                ],
                [
                    79.5710693,
                    55.1822511
                ]
            ],
            "longitude": 79.591187,
            "latitude": 55.18771
        },
        "3410": {
            "name": "Владимировское",
            "population": 359,
            "type": "village",
            "poly": [
                [
                    79.5835019,
                    55.3730727
                ],
                [
                    79.5864475,
                    55.3756954
                ],
                [
                    79.5896453,
                    55.3770988
                ],
                [
                    79.5994129,
                    55.3781182
                ],
                [
                    79.6073674,
                    55.3783095
                ],
                [
                    79.6130703,
                    55.3760214
                ],
                [
                    79.6115384,
                    55.3712149
                ],
                [
                    79.6107459,
                    55.3706461
                ],
                [
                    79.5945833,
                    55.367866
                ],
                [
                    79.5889075,
                    55.3678353
                ],
                [
                    79.5883669,
                    55.3682347
                ],
                [
                    79.5853668,
                    55.3706307
                ],
                [
                    79.5835019,
                    55.3730727
                ]
            ],
            "longitude": 79.595558,
            "latitude": 55.373367
        },
        "3411": {
            "name": "Травное",
            "population": 691,
            "type": "village",
            "poly": [
                [
                    79.6014201,
                    54.2422967
                ],
                [
                    79.6055368,
                    54.2434321
                ],
                [
                    79.6092515,
                    54.2440222
                ],
                [
                    79.6109826,
                    54.2456449
                ],
                [
                    79.6122088,
                    54.2473939
                ],
                [
                    79.6119203,
                    54.2494168
                ],
                [
                    79.6132906,
                    54.2507864
                ],
                [
                    79.615155,
                    54.2540536
                ],
                [
                    79.6161759,
                    54.2556955
                ],
                [
                    79.6183037,
                    54.256791
                ],
                [
                    79.6221987,
                    54.2594243
                ],
                [
                    79.630471,
                    54.2622118
                ],
                [
                    79.6358803,
                    54.2595487
                ],
                [
                    79.6259067,
                    54.2480219
                ],
                [
                    79.6232807,
                    54.242547
                ],
                [
                    79.6209661,
                    54.2369737
                ],
                [
                    79.6216355,
                    54.2286269
                ],
                [
                    79.6159234,
                    54.2287408
                ],
                [
                    79.61174,
                    54.228277
                ],
                [
                    79.607443,
                    54.2290575
                ],
                [
                    79.6053565,
                    54.2332521
                ],
                [
                    79.6029402,
                    54.23536
                ],
                [
                    79.6038418,
                    54.2365614
                ],
                [
                    79.6029762,
                    54.2395122
                ],
                [
                    79.6014254,
                    54.2411772
                ],
                [
                    79.6014201,
                    54.2422967
                ]
            ],
            "longitude": 79.618347,
            "latitude": 54.243736
        },
        "3412": {
            "name": "Октябрьский",
            "population": 595,
            "type": "village",
            "poly": [
                [
                    79.6246888,
                    53.9531508
                ],
                [
                    79.637262,
                    53.966341
                ],
                [
                    79.653853,
                    53.9664009
                ],
                [
                    79.6597084,
                    53.9611013
                ],
                [
                    79.6484481,
                    53.9503015
                ],
                [
                    79.6393272,
                    53.9461265
                ],
                [
                    79.6246888,
                    53.9531508
                ]
            ],
            "longitude": 79.642044,
            "latitude": 53.958359
        },
        "3413": {
            "name": "Петропавловка",
            "population": 705,
            "type": "village",
            "poly": [
                [
                    79.6216649,
                    54.0096319
                ],
                [
                    79.6252282,
                    54.0124902
                ],
                [
                    79.6257397,
                    54.0231546
                ],
                [
                    79.6385264,
                    54.0241329
                ],
                [
                    79.6400727,
                    54.0220715
                ],
                [
                    79.6539299,
                    54.0215125
                ],
                [
                    79.6616614,
                    54.0264387
                ],
                [
                    79.6723628,
                    54.029836
                ],
                [
                    79.6752744,
                    54.0285255
                ],
                [
                    79.6769471,
                    54.0179896
                ],
                [
                    79.6309484,
                    54.0033003
                ],
                [
                    79.6216649,
                    54.0096319
                ]
            ],
            "longitude": 79.647827,
            "latitude": 54.016838
        },
        "3414": {
            "name": "Пешково",
            "population": 207,
            "type": "village",
            "poly": [
                [
                    79.6687685,
                    55.6387564
                ],
                [
                    79.6693632,
                    55.6391592
                ],
                [
                    79.6720196,
                    55.6402109
                ],
                [
                    79.683121,
                    55.6426499
                ],
                [
                    79.684469,
                    55.6432764
                ],
                [
                    79.6898214,
                    55.6445741
                ],
                [
                    79.6937069,
                    55.6448426
                ],
                [
                    79.7009228,
                    55.6444399
                ],
                [
                    79.701914,
                    55.6430974
                ],
                [
                    79.6980285,
                    55.6401885
                ],
                [
                    79.695729,
                    55.6397186
                ],
                [
                    79.6910505,
                    55.6396739
                ],
                [
                    79.6874426,
                    55.6403675
                ],
                [
                    79.6817333,
                    55.6382641
                ],
                [
                    79.6708698,
                    55.63672
                ],
                [
                    79.6687685,
                    55.6387564
                ]
            ],
            "longitude": 79.68457,
            "latitude": 55.641239
        },
        "3415": {
            "name": "Ярки",
            "population": 587,
            "type": "village",
            "poly": [
                [
                    79.7072814,
                    54.7954886
                ],
                [
                    79.7082526,
                    54.7955609
                ],
                [
                    79.7076887,
                    54.7968613
                ],
                [
                    79.713704,
                    54.7971502
                ],
                [
                    79.7186541,
                    54.7972947
                ],
                [
                    79.7214737,
                    54.7971683
                ],
                [
                    79.7225703,
                    54.7989563
                ],
                [
                    79.7226956,
                    54.8017013
                ],
                [
                    79.7284289,
                    54.8012137
                ],
                [
                    79.7262672,
                    54.799173
                ],
                [
                    79.7273324,
                    54.798866
                ],
                [
                    79.7256719,
                    54.7967348
                ],
                [
                    79.7267684,
                    54.7964278
                ],
                [
                    79.7261105,
                    54.7952357
                ],
                [
                    79.73034,
                    54.7942423
                ],
                [
                    79.7302459,
                    54.7927432
                ],
                [
                    79.733097,
                    54.7918762
                ],
                [
                    79.7335356,
                    54.7926529
                ],
                [
                    79.7343815,
                    54.7928154
                ],
                [
                    79.7353214,
                    54.7940075
                ],
                [
                    79.7372952,
                    54.7937727
                ],
                [
                    79.7361987,
                    54.7888234
                ],
                [
                    79.7376084,
                    54.7888595
                ],
                [
                    79.7375145,
                    54.789275
                ],
                [
                    79.7389557,
                    54.7892027
                ],
                [
                    79.7394256,
                    54.7885524
                ],
                [
                    79.741556,
                    54.7892208
                ],
                [
                    79.7424019,
                    54.7885163
                ],
                [
                    79.7423393,
                    54.7881731
                ],
                [
                    79.7452529,
                    54.7884982
                ],
                [
                    79.7460675,
                    54.7874143
                ],
                [
                    79.7473834,
                    54.7877756
                ],
                [
                    79.7470701,
                    54.7886427
                ],
                [
                    79.7481039,
                    54.7886427
                ],
                [
                    79.7481978,
                    54.7874685
                ],
                [
                    79.7421826,
                    54.7863846
                ],
                [
                    79.7429345,
                    54.7854813
                ],
                [
                    79.7414934,
                    54.7851019
                ],
                [
                    79.7406788,
                    54.7862582
                ],
                [
                    79.7400209,
                    54.7874505
                ],
                [
                    79.73623,
                    54.787053
                ],
                [
                    79.7362613,
                    54.7857343
                ],
                [
                    79.7312486,
                    54.7854633
                ],
                [
                    79.7268311,
                    54.7823558
                ],
                [
                    79.7248573,
                    54.7831327
                ],
                [
                    79.7230402,
                    54.7833314
                ],
                [
                    79.7215364,
                    54.7833134
                ],
                [
                    79.7196565,
                    54.782952
                ],
                [
                    79.7181841,
                    54.7825365
                ],
                [
                    79.7168996,
                    54.7820848
                ],
                [
                    79.7163983,
                    54.782139
                ],
                [
                    79.7160537,
                    54.7824281
                ],
                [
                    79.7160224,
                    54.782681
                ],
                [
                    79.7168056,
                    54.7831146
                ],
                [
                    79.7176515,
                    54.7835663
                ],
                [
                    79.7185913,
                    54.7846684
                ],
                [
                    79.7193746,
                    54.7857884
                ],
                [
                    79.719312,
                    54.7865833
                ],
                [
                    79.7189674,
                    54.7871614
                ],
                [
                    79.7181528,
                    54.7877576
                ],
                [
                    79.7165863,
                    54.7880105
                ],
                [
                    79.7153018,
                    54.788155
                ],
                [
                    79.7152705,
                    54.7888053
                ],
                [
                    79.7163357,
                    54.7898892
                ],
                [
                    79.7101324,
                    54.792418
                ],
                [
                    79.7114796,
                    54.7936102
                ],
                [
                    79.7072814,
                    54.7954886
                ]
            ],
            "longitude": 79.721565,
            "latitude": 54.791409
        },
        "3416": {
            "name": "Орловское",
            "population": 239,
            "type": "village",
            "poly": [
                [
                    79.7159336,
                    55.5071913
                ],
                [
                    79.7161502,
                    55.5080852
                ],
                [
                    79.7183786,
                    55.5092069
                ],
                [
                    79.7222783,
                    55.5107491
                ],
                [
                    79.7259614,
                    55.5120986
                ],
                [
                    79.736082,
                    55.51492
                ],
                [
                    79.7398579,
                    55.515288
                ],
                [
                    79.741034,
                    55.5145345
                ],
                [
                    79.7414982,
                    55.5135005
                ],
                [
                    79.7377223,
                    55.5129222
                ],
                [
                    79.7383104,
                    55.5123614
                ],
                [
                    79.73732,
                    55.5115903
                ],
                [
                    79.7357725,
                    55.5108718
                ],
                [
                    79.735463,
                    55.5093295
                ],
                [
                    79.7322442,
                    55.507314
                ],
                [
                    79.7284064,
                    55.5058943
                ],
                [
                    79.7236711,
                    55.5061572
                ],
                [
                    79.7202047,
                    55.5061046
                ],
                [
                    79.716893,
                    55.505719
                ],
                [
                    79.7159336,
                    55.5071913
                ]
            ],
            "longitude": 79.729774,
            "latitude": 55.50901
        },
        "3417": {
            "name": "Майское",
            "population": 892,
            "type": "village",
            "poly": [
                [
                    79.7456427,
                    54.0781023
                ],
                [
                    79.7534575,
                    54.0804306
                ],
                [
                    79.7630469,
                    54.0813681
                ],
                [
                    79.7646075,
                    54.0803856
                ],
                [
                    79.7670815,
                    54.0806982
                ],
                [
                    79.7685279,
                    54.0824175
                ],
                [
                    79.7765782,
                    54.0837558
                ],
                [
                    79.7768012,
                    54.0767865
                ],
                [
                    79.7736083,
                    54.0741843
                ],
                [
                    79.7667651,
                    54.0713778
                ],
                [
                    79.7612111,
                    54.0722587
                ],
                [
                    79.7590337,
                    54.0718576
                ],
                [
                    79.7587205,
                    54.068483
                ],
                [
                    79.7504797,
                    54.0631373
                ],
                [
                    79.7478866,
                    54.065193
                ],
                [
                    79.7495583,
                    54.0672264
                ],
                [
                    79.7487072,
                    54.0713108
                ],
                [
                    79.7456427,
                    54.0781023
                ]
            ],
            "longitude": 79.757904,
            "latitude": 54.075275
        },
        "3418": {
            "name": "Утянка",
            "population": 1107,
            "type": "village",
            "poly": [
                [
                    79.7434363,
                    54.7037658
                ],
                [
                    79.7461899,
                    54.7065942
                ],
                [
                    79.7470067,
                    54.7089322
                ],
                [
                    79.7441706,
                    54.7088568
                ],
                [
                    79.7442957,
                    54.7110207
                ],
                [
                    79.745272,
                    54.7110485
                ],
                [
                    79.7453292,
                    54.7132414
                ],
                [
                    79.7457883,
                    54.7153439
                ],
                [
                    79.7462239,
                    54.7156288
                ],
                [
                    79.7466074,
                    54.7160964
                ],
                [
                    79.7466505,
                    54.7165059
                ],
                [
                    79.7485845,
                    54.7163998
                ],
                [
                    79.7488615,
                    54.7167517
                ],
                [
                    79.7500373,
                    54.7167855
                ],
                [
                    79.7551289,
                    54.717007
                ],
                [
                    79.7565737,
                    54.7172283
                ],
                [
                    79.7611204,
                    54.7197083
                ],
                [
                    79.763733,
                    54.7205151
                ],
                [
                    79.7665184,
                    54.7183991
                ],
                [
                    79.7498033,
                    54.7110222
                ],
                [
                    79.7543092,
                    54.7078358
                ],
                [
                    79.7565449,
                    54.7083273
                ],
                [
                    79.7573984,
                    54.7074672
                ],
                [
                    79.7610584,
                    54.7086164
                ],
                [
                    79.7613247,
                    54.7083703
                ],
                [
                    79.7665441,
                    54.7100257
                ],
                [
                    79.7668104,
                    54.7096318
                ],
                [
                    79.767833,
                    54.7099518
                ],
                [
                    79.7674709,
                    54.7103949
                ],
                [
                    79.7698036,
                    54.7111272
                ],
                [
                    79.7705067,
                    54.7112687
                ],
                [
                    79.7704854,
                    54.7114472
                ],
                [
                    79.772313,
                    54.7119465
                ],
                [
                    79.774205,
                    54.7126115
                ],
                [
                    79.7744958,
                    54.7124009
                ],
                [
                    79.776987,
                    54.7133391
                ],
                [
                    79.7767309,
                    54.7135289
                ],
                [
                    79.7771527,
                    54.7137481
                ],
                [
                    79.7788549,
                    54.7143311
                ],
                [
                    79.7794984,
                    54.7144211
                ],
                [
                    79.7834625,
                    54.7155808
                ],
                [
                    79.7835887,
                    54.7153809
                ],
                [
                    79.7899373,
                    54.7173774
                ],
                [
                    79.7895208,
                    54.7175278
                ],
                [
                    79.7905868,
                    54.7181121
                ],
                [
                    79.7944748,
                    54.7197794
                ],
                [
                    79.7947943,
                    54.7195887
                ],
                [
                    79.7955932,
                    54.7203577
                ],
                [
                    79.7956145,
                    54.7208622
                ],
                [
                    79.7959447,
                    54.7209545
                ],
                [
                    79.7965732,
                    54.7203946
                ],
                [
                    79.797649,
                    54.7208868
                ],
                [
                    79.7970845,
                    54.7213113
                ],
                [
                    79.797851,
                    54.7217273
                ],
                [
                    79.7984905,
                    54.7212252
                ],
                [
                    79.799119,
                    54.7214774
                ],
                [
                    79.7986823,
                    54.7218404
                ],
                [
                    79.79907,
                    54.7221363
                ],
                [
                    79.8010283,
                    54.7227975
                ],
                [
                    79.8016309,
                    54.7223973
                ],
                [
                    79.8030469,
                    54.7229715
                ],
                [
                    79.8026854,
                    54.7232673
                ],
                [
                    79.8041585,
                    54.7238257
                ],
                [
                    79.8046739,
                    54.7235283
                ],
                [
                    79.8070841,
                    54.7243983
                ],
                [
                    79.8074758,
                    54.7242069
                ],
                [
                    79.8089219,
                    54.7246767
                ],
                [
                    79.8086809,
                    54.7249377
                ],
                [
                    79.8100668,
                    54.7254075
                ],
                [
                    79.8105187,
                    54.7250943
                ],
                [
                    79.8118444,
                    54.7256858
                ],
                [
                    79.8112418,
                    54.726173
                ],
                [
                    79.812883,
                    54.726684
                ],
                [
                    79.8135918,
                    54.7262426
                ],
                [
                    79.8160623,
                    54.7270603
                ],
                [
                    79.8154296,
                    54.7274431
                ],
                [
                    79.8205978,
                    54.729815
                ],
                [
                    79.8220664,
                    54.7283663
                ],
                [
                    79.8166204,
                    54.7262108
                ],
                [
                    79.8173547,
                    54.7255394
                ],
                [
                    79.8147847,
                    54.7244086
                ],
                [
                    79.8162724,
                    54.72344
                ],
                [
                    79.8148809,
                    54.7226197
                ],
                [
                    79.8143187,
                    54.7228053
                ],
                [
                    79.8131937,
                    54.7220408
                ],
                [
                    79.8114804,
                    54.7226063
                ],
                [
                    79.8095835,
                    54.7215107
                ],
                [
                    79.8109297,
                    54.7207332
                ],
                [
                    79.8082373,
                    54.7188954
                ],
                [
                    79.8061568,
                    54.7192842
                ],
                [
                    79.8053613,
                    54.7188954
                ],
                [
                    79.8056061,
                    54.7180825
                ],
                [
                    79.7989975,
                    54.7157498
                ],
                [
                    79.7917158,
                    54.7125685
                ],
                [
                    79.7781927,
                    54.7071245
                ],
                [
                    79.7543283,
                    54.6992399
                ],
                [
                    79.746863,
                    54.6959867
                ],
                [
                    79.7444154,
                    54.6962342
                ],
                [
                    79.7442318,
                    54.6969061
                ],
                [
                    79.7448437,
                    54.6973304
                ],
                [
                    79.7448437,
                    54.7027758
                ],
                [
                    79.7439258,
                    54.7028819
                ],
                [
                    79.7445378,
                    54.703589
                ],
                [
                    79.7434363,
                    54.7037658
                ]
            ],
            "longitude": 79.778992,
            "latitude": 54.712242
        },
        "3419": {
            "name": "Чернаки",
            "population": 323,
            "type": "village",
            "poly": [
                [
                    79.797603,
                    54.0763827
                ],
                [
                    79.8008712,
                    54.078365
                ],
                [
                    79.8042333,
                    54.079308
                ],
                [
                    79.8060172,
                    54.0792323
                ],
                [
                    79.8079248,
                    54.0792872
                ],
                [
                    79.8096312,
                    54.0792463
                ],
                [
                    79.8105037,
                    54.0798679
                ],
                [
                    79.8143676,
                    54.0807088
                ],
                [
                    79.814872,
                    54.0795286
                ],
                [
                    79.8154675,
                    54.0784241
                ],
                [
                    79.8165591,
                    54.0774293
                ],
                [
                    79.8183089,
                    54.0773273
                ],
                [
                    79.8197273,
                    54.077466
                ],
                [
                    79.8214171,
                    54.0778706
                ],
                [
                    79.8221493,
                    54.0781817
                ],
                [
                    79.8227471,
                    54.0785669
                ],
                [
                    79.8231593,
                    54.0790927
                ],
                [
                    79.8236,
                    54.0797622
                ],
                [
                    79.8234176,
                    54.0812867
                ],
                [
                    79.823129,
                    54.0847814
                ],
                [
                    79.827445,
                    54.0853697
                ],
                [
                    79.8298747,
                    54.0821394
                ],
                [
                    79.8316243,
                    54.0810906
                ],
                [
                    79.8279009,
                    54.0779523
                ],
                [
                    79.8267768,
                    54.0761798
                ],
                [
                    79.8235422,
                    54.0755304
                ],
                [
                    79.8201368,
                    54.0751208
                ],
                [
                    79.814262,
                    54.0710841
                ],
                [
                    79.8084437,
                    54.0696903
                ],
                [
                    79.8060121,
                    54.0684953
                ],
                [
                    79.802639,
                    54.0685746
                ],
                [
                    79.8013618,
                    54.0711706
                ],
                [
                    79.8002675,
                    54.0725261
                ],
                [
                    79.7981618,
                    54.0734887
                ],
                [
                    79.797603,
                    54.0763827
                ]
            ],
            "longitude": 79.816261,
            "latitude": 54.075924
        },
        "3420": {
            "name": "Курьинский",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 79.852211,
            "latitude": 53.956211
        },
        "3421": {
            "name": "Маршанское",
            "population": 764,
            "type": "village",
            "poly": [
                [
                    79.8083606,
                    55.0195329
                ],
                [
                    79.8124187,
                    55.0216699
                ],
                [
                    79.8130321,
                    55.0218052
                ],
                [
                    79.8158633,
                    55.0217781
                ],
                [
                    79.8162408,
                    55.0212371
                ],
                [
                    79.8213842,
                    55.0216699
                ],
                [
                    79.8217617,
                    55.0229142
                ],
                [
                    79.8229413,
                    55.0229954
                ],
                [
                    79.8231773,
                    55.023888
                ],
                [
                    79.8254894,
                    55.0257814
                ],
                [
                    79.8260085,
                    55.0257543
                ],
                [
                    79.8275185,
                    55.0268092
                ],
                [
                    79.8291227,
                    55.0273231
                ],
                [
                    79.8299722,
                    55.0279181
                ],
                [
                    79.8308687,
                    55.0286483
                ],
                [
                    79.8301137,
                    55.0289999
                ],
                [
                    79.8309158,
                    55.0295138
                ],
                [
                    79.8317653,
                    55.0291081
                ],
                [
                    79.8332752,
                    55.0300277
                ],
                [
                    79.8347852,
                    55.0304874
                ],
                [
                    79.8351155,
                    55.0302981
                ],
                [
                    79.8366727,
                    55.0309201
                ],
                [
                    79.8384658,
                    55.0319478
                ],
                [
                    79.8426182,
                    55.0338138
                ],
                [
                    79.8444113,
                    55.0338949
                ],
                [
                    79.8475256,
                    55.0346521
                ],
                [
                    79.8473369,
                    55.0353552
                ],
                [
                    79.8484222,
                    55.0356797
                ],
                [
                    79.8491772,
                    55.0356256
                ],
                [
                    79.8496018,
                    55.0354633
                ],
                [
                    79.8504984,
                    55.0358419
                ],
                [
                    79.8497434,
                    55.0363827
                ],
                [
                    79.8523859,
                    55.0377888
                ],
                [
                    79.8542261,
                    55.0389515
                ],
                [
                    79.8560664,
                    55.0393571
                ],
                [
                    79.8570102,
                    55.0400871
                ],
                [
                    79.8579067,
                    55.040709
                ],
                [
                    79.8593223,
                    55.0398167
                ],
                [
                    79.8630501,
                    55.0411145
                ],
                [
                    79.8650319,
                    55.0424934
                ],
                [
                    79.8663531,
                    55.0443319
                ],
                [
                    79.8677687,
                    55.0460351
                ],
                [
                    79.8689012,
                    55.0469272
                ],
                [
                    79.8715908,
                    55.048441
                ],
                [
                    79.8740916,
                    55.0464946
                ],
                [
                    79.8774892,
                    55.0473056
                ],
                [
                    79.8790463,
                    55.0466028
                ],
                [
                    79.8790463,
                    55.0463595
                ],
                [
                    79.8771589,
                    55.0455214
                ],
                [
                    79.8782914,
                    55.0446022
                ],
                [
                    79.8770645,
                    55.0441156
                ],
                [
                    79.8767342,
                    55.0443859
                ],
                [
                    79.8741389,
                    55.0431964
                ],
                [
                    79.877442,
                    55.0407901
                ],
                [
                    79.8773948,
                    55.0401141
                ],
                [
                    79.8781498,
                    55.03933
                ],
                [
                    79.8748467,
                    55.0381944
                ],
                [
                    79.8670609,
                    55.0353552
                ],
                [
                    79.8702224,
                    55.0340572
                ],
                [
                    79.8666362,
                    55.0321101
                ],
                [
                    79.8645128,
                    55.0331377
                ],
                [
                    79.8643713,
                    55.0346521
                ],
                [
                    79.8607379,
                    55.033354
                ],
                [
                    79.858992,
                    55.0332459
                ],
                [
                    79.8561136,
                    55.0330566
                ],
                [
                    79.8553114,
                    55.0331107
                ],
                [
                    79.8545093,
                    55.0335704
                ],
                [
                    79.853424,
                    55.0331107
                ],
                [
                    79.8524802,
                    55.0336245
                ],
                [
                    79.8508759,
                    55.0328943
                ],
                [
                    79.8527162,
                    55.0317855
                ],
                [
                    79.8515365,
                    55.0312988
                ],
                [
                    79.8504512,
                    55.0311365
                ],
                [
                    79.8491772,
                    55.0305145
                ],
                [
                    79.8513477,
                    55.0287565
                ],
                [
                    79.8514421,
                    55.0280804
                ],
                [
                    79.8474312,
                    55.0264035
                ],
                [
                    79.8464403,
                    55.0268903
                ],
                [
                    79.8469122,
                    55.0273231
                ],
                [
                    79.8454022,
                    55.0281615
                ],
                [
                    79.8407307,
                    55.0269715
                ],
                [
                    79.8393623,
                    55.0279181
                ],
                [
                    79.8406363,
                    55.0285943
                ],
                [
                    79.8400228,
                    55.0292434
                ],
                [
                    79.8411081,
                    55.0298113
                ],
                [
                    79.8418632,
                    55.0294327
                ],
                [
                    79.8429013,
                    55.0298924
                ],
                [
                    79.8400228,
                    55.030839
                ],
                [
                    79.8326146,
                    55.0275935
                ],
                [
                    79.8276128,
                    55.0247265
                ],
                [
                    79.8312934,
                    55.0234011
                ],
                [
                    79.8293115,
                    55.0218322
                ],
                [
                    79.8281319,
                    55.0222921
                ],
                [
                    79.8259141,
                    55.0226167
                ],
                [
                    79.824876,
                    55.0228331
                ],
                [
                    79.8236963,
                    55.0215888
                ],
                [
                    79.8251119,
                    55.0200739
                ],
                [
                    79.822611,
                    55.0186131
                ],
                [
                    79.8239323,
                    55.0176933
                ],
                [
                    79.8203461,
                    55.0161783
                ],
                [
                    79.8187889,
                    55.0179638
                ],
                [
                    79.8175621,
                    55.0176662
                ],
                [
                    79.8162408,
                    55.0176933
                ],
                [
                    79.8154858,
                    55.0178015
                ],
                [
                    79.8152971,
                    55.0183696
                ],
                [
                    79.8166655,
                    55.0185319
                ],
                [
                    79.8143062,
                    55.0197763
                ],
                [
                    79.8093516,
                    55.018045
                ],
                [
                    79.8083606,
                    55.0195329
                ]
            ],
            "longitude": 79.863052,
            "latitude": 55.038452
        },
        "3422": {
            "name": "Ермолаевка",
            "population": 267,
            "type": "village",
            "poly": [
                [
                    79.8910793,
                    55.3138109
                ],
                [
                    79.8936671,
                    55.3164243
                ],
                [
                    79.8980043,
                    55.3184775
                ],
                [
                    79.9045649,
                    55.3199499
                ],
                [
                    79.905877,
                    55.3214431
                ],
                [
                    79.9071891,
                    55.3221896
                ],
                [
                    79.9086105,
                    55.3225422
                ],
                [
                    79.9108703,
                    55.3225422
                ],
                [
                    79.9132029,
                    55.3213601
                ],
                [
                    79.9180139,
                    55.3221689
                ],
                [
                    79.9189616,
                    55.3210905
                ],
                [
                    79.9183055,
                    55.3199085
                ],
                [
                    79.9090843,
                    55.3158643
                ],
                [
                    79.8945418,
                    55.3135205
                ],
                [
                    79.8910793,
                    55.3138109
                ]
            ],
            "longitude": 79.907204,
            "latitude": 55.318672
        },
        "3423": {
            "name": "Троицкий",
            "population": 514,
            "type": "village",
            "poly": [
                [
                    79.9133486,
                    54.0113744
                ],
                [
                    79.9241672,
                    54.0177312
                ],
                [
                    79.9342735,
                    54.0120242
                ],
                [
                    79.9412022,
                    54.0079158
                ],
                [
                    79.9437383,
                    54.005937
                ],
                [
                    79.9368443,
                    54.0001769
                ],
                [
                    79.9291539,
                    53.995811
                ],
                [
                    79.9133486,
                    54.0113744
                ]
            ],
            "longitude": 79.92907,
            "latitude": 54.00798
        },
        "3424": {
            "name": "Букреево Плёсо",
            "population": 601,
            "type": "village",
            "poly": [
                [
                    79.9183581,
                    54.1324272
                ],
                [
                    79.9321633,
                    54.1441869
                ],
                [
                    79.9499982,
                    54.1493007
                ],
                [
                    79.9485804,
                    54.1345695
                ],
                [
                    79.9737284,
                    54.1313341
                ],
                [
                    79.9693256,
                    54.1211889
                ],
                [
                    79.9599231,
                    54.1148469
                ],
                [
                    79.9433568,
                    54.1211014
                ],
                [
                    79.9453716,
                    54.1294539
                ],
                [
                    79.9263427,
                    54.1266991
                ],
                [
                    79.9183581,
                    54.1324272
                ]
            ],
            "longitude": 79.939095,
            "latitude": 54.136028
        },
        "3425": {
            "name": "Красная Грива",
            "population": 314,
            "type": "village",
            "poly": [
                [
                    79.9347683,
                    54.768778
                ],
                [
                    79.9451549,
                    54.77205
                ],
                [
                    79.9537705,
                    54.7745349
                ],
                [
                    79.954013,
                    54.7743285
                ],
                [
                    79.955337,
                    54.7750431
                ],
                [
                    79.9574332,
                    54.7748845
                ],
                [
                    79.9581763,
                    54.7741678
                ],
                [
                    79.9570503,
                    54.7722477
                ],
                [
                    79.9559388,
                    54.7716832
                ],
                [
                    79.9539861,
                    54.7710118
                ],
                [
                    79.949922,
                    54.7694768
                ],
                [
                    79.9459062,
                    54.7677393
                ],
                [
                    79.938475,
                    54.7652941
                ],
                [
                    79.9347683,
                    54.768778
                ]
            ],
            "longitude": 79.941467,
            "latitude": 54.768711
        },
        "3426": {
            "name": "Согорное",
            "population": 866,
            "type": "village",
            "poly": [
                [
                    79.9145271,
                    54.278206
                ],
                [
                    79.9158347,
                    54.2780969
                ],
                [
                    79.9176405,
                    54.2784847
                ],
                [
                    79.9176405,
                    54.2803145
                ],
                [
                    79.9195708,
                    54.2802297
                ],
                [
                    79.9195501,
                    54.277903
                ],
                [
                    79.9205049,
                    54.2779394
                ],
                [
                    79.9205464,
                    54.2788361
                ],
                [
                    79.9230994,
                    54.2787634
                ],
                [
                    79.9242201,
                    54.2803994
                ],
                [
                    79.9249602,
                    54.2808611
                ],
                [
                    79.9265864,
                    54.2810416
                ],
                [
                    79.9248222,
                    54.281696
                ],
                [
                    79.9250297,
                    54.2818777
                ],
                [
                    79.9245316,
                    54.2820837
                ],
                [
                    79.9248637,
                    54.2824472
                ],
                [
                    79.9234315,
                    54.2827744
                ],
                [
                    79.9234938,
                    54.2830652
                ],
                [
                    79.9217087,
                    54.2835014
                ],
                [
                    79.9220823,
                    54.2837316
                ],
                [
                    79.9211691,
                    54.2847858
                ],
                [
                    79.9314641,
                    54.2885902
                ],
                [
                    79.9318793,
                    54.2897412
                ],
                [
                    79.9337472,
                    54.2912555
                ],
                [
                    79.9357607,
                    54.2921157
                ],
                [
                    79.9369438,
                    54.292261
                ],
                [
                    79.9363626,
                    54.2931575
                ],
                [
                    79.9386873,
                    54.2942962
                ],
                [
                    79.9372759,
                    54.2952895
                ],
                [
                    79.9383759,
                    54.2958467
                ],
                [
                    79.9391439,
                    54.2953622
                ],
                [
                    79.9408874,
                    54.2958346
                ],
                [
                    79.9430253,
                    54.2991414
                ],
                [
                    79.9441669,
                    54.2999893
                ],
                [
                    79.9465746,
                    54.3008613
                ],
                [
                    79.946969,
                    54.300607
                ],
                [
                    79.9497088,
                    54.3020241
                ],
                [
                    79.9486087,
                    54.3027265
                ],
                [
                    79.9501032,
                    54.3037923
                ],
                [
                    79.9514731,
                    54.3031383
                ],
                [
                    79.9542544,
                    54.3023874
                ],
                [
                    79.9609379,
                    54.3029203
                ],
                [
                    79.967061,
                    54.2999529
                ],
                [
                    79.9675384,
                    54.3009582
                ],
                [
                    79.9781033,
                    54.2923579
                ],
                [
                    79.9773145,
                    54.2917038
                ],
                [
                    79.9746577,
                    54.2916553
                ],
                [
                    79.9746162,
                    54.2908679
                ],
                [
                    79.9742426,
                    54.290674
                ],
                [
                    79.9743049,
                    54.2896321
                ],
                [
                    79.9751144,
                    54.2895473
                ],
                [
                    79.9753012,
                    54.2885902
                ],
                [
                    79.9744917,
                    54.2884691
                ],
                [
                    79.9751974,
                    54.2862276
                ],
                [
                    79.970631,
                    54.2855855
                ],
                [
                    79.9714405,
                    54.2833075
                ],
                [
                    79.9661476,
                    54.2831258
                ],
                [
                    79.964591,
                    54.2871969
                ],
                [
                    79.9598171,
                    54.2902985
                ],
                [
                    79.9455782,
                    54.2923458
                ],
                [
                    79.9364197,
                    54.2920563
                ],
                [
                    79.9323601,
                    54.2885703
                ],
                [
                    79.9320578,
                    54.2852029
                ],
                [
                    79.9305651,
                    54.2813043
                ],
                [
                    79.9275821,
                    54.2740437
                ],
                [
                    79.927019,
                    54.2735922
                ],
                [
                    79.9268348,
                    54.2729771
                ],
                [
                    79.9254234,
                    54.2726741
                ],
                [
                    79.9192173,
                    54.2734135
                ],
                [
                    79.9190928,
                    54.2728923
                ],
                [
                    79.9174323,
                    54.2733165
                ],
                [
                    79.9178267,
                    54.2738134
                ],
                [
                    79.9164567,
                    54.27408
                ],
                [
                    79.9170172,
                    54.2749769
                ],
                [
                    79.9185324,
                    54.2750133
                ],
                [
                    79.9184493,
                    54.2764918
                ],
                [
                    79.9172662,
                    54.2762979
                ],
                [
                    79.917204,
                    54.2757162
                ],
                [
                    79.9166642,
                    54.2757162
                ],
                [
                    79.9165398,
                    54.2760192
                ],
                [
                    79.9150667,
                    54.2758428
                ],
                [
                    79.9148799,
                    54.2766305
                ],
                [
                    79.9153158,
                    54.2767517
                ],
                [
                    79.9145271,
                    54.278206
                ]
            ],
            "longitude": 79.947029,
            "latitude": 54.297451
        },
        "3427": {
            "name": "Индерь",
            "population": 511,
            "type": "village",
            "poly": [
                [
                    79.9636596,
                    54.537668
                ],
                [
                    79.9667559,
                    54.5438551
                ],
                [
                    79.9685907,
                    54.5453186
                ],
                [
                    79.9665839,
                    54.5463496
                ],
                [
                    79.9718591,
                    54.550407
                ],
                [
                    79.971515,
                    54.5511387
                ],
                [
                    79.9716297,
                    54.5521031
                ],
                [
                    79.9725472,
                    54.5527682
                ],
                [
                    79.9737513,
                    54.5524024
                ],
                [
                    79.9743384,
                    54.5525904
                ],
                [
                    79.9735164,
                    54.5532374
                ],
                [
                    79.9745439,
                    54.5540717
                ],
                [
                    79.9756008,
                    54.5537312
                ],
                [
                    79.9764522,
                    54.5541738
                ],
                [
                    79.9778026,
                    54.5536801
                ],
                [
                    79.9785659,
                    54.5541738
                ],
                [
                    79.9856999,
                    54.5502918
                ],
                [
                    79.9857292,
                    54.5496618
                ],
                [
                    79.9656779,
                    54.5363953
                ],
                [
                    79.9667269,
                    54.5360464
                ],
                [
                    79.9670577,
                    54.5349305
                ],
                [
                    79.96741,
                    54.5339936
                ],
                [
                    79.9942136,
                    54.5293942
                ],
                [
                    80.0018466,
                    54.525135
                ],
                [
                    80.0009365,
                    54.5240616
                ],
                [
                    79.9983824,
                    54.5247602
                ],
                [
                    79.9886357,
                    54.525152
                ],
                [
                    79.9843788,
                    54.5251861
                ],
                [
                    79.9777146,
                    54.5289853
                ],
                [
                    79.9676742,
                    54.533193
                ],
                [
                    79.9652669,
                    54.5358673
                ],
                [
                    79.9639164,
                    54.5368041
                ],
                [
                    79.9636596,
                    54.537668
                ]
            ],
            "longitude": 79.974983,
            "latitude": 54.546394
        },
        "3428": {
            "name": "Новодубровское",
            "population": 127,
            "type": "village",
            "poly": [
                [
                    79.9646798,
                    55.6995295
                ],
                [
                    79.966241,
                    55.7012491
                ],
                [
                    79.9688578,
                    55.7028859
                ],
                [
                    79.9751117,
                    55.7039083
                ],
                [
                    79.981534,
                    55.704908
                ],
                [
                    79.9841952,
                    55.7083666
                ],
                [
                    79.9867145,
                    55.709646
                ],
                [
                    79.9929949,
                    55.7084666
                ],
                [
                    79.9971109,
                    55.7067273
                ],
                [
                    79.9961884,
                    55.7040883
                ],
                [
                    79.9926756,
                    55.7025288
                ],
                [
                    79.9875306,
                    55.7013291
                ],
                [
                    79.9864306,
                    55.6985098
                ],
                [
                    79.9848339,
                    55.6979898
                ],
                [
                    79.9810373,
                    55.7010692
                ],
                [
                    79.9763181,
                    55.6977699
                ],
                [
                    79.974544,
                    55.6975299
                ],
                [
                    79.9710667,
                    55.6983898
                ],
                [
                    79.9667023,
                    55.69709
                ],
                [
                    79.9646798,
                    55.6995295
                ]
            ],
            "longitude": 79.976006,
            "latitude": 55.70137
        },
        "3429": {
            "name": "Черновка",
            "population": 1198,
            "type": "village",
            "poly": [
                [
                    79.9616676,
                    54.1519307
                ],
                [
                    80.0182878,
                    54.1648208
                ],
                [
                    80.051052,
                    54.1524769
                ],
                [
                    80.0517516,
                    54.1448285
                ],
                [
                    80.0154078,
                    54.1400543
                ],
                [
                    80.012625,
                    54.1498394
                ],
                [
                    79.965766,
                    54.1469012
                ],
                [
                    79.9616676,
                    54.1519307
                ]
            ],
            "longitude": 79.99936156594485,
            "latitude": 54.15413500110771
        },
        "3430": {
            "name": "Карган",
            "population": 302,
            "type": "village",
            "poly": null,
            "longitude": 80.04892,
            "latitude": 55.348675
        },
        "3431": {
            "name": "Крещенское",
            "population": 301,
            "type": "village",
            "poly": [
                [
                    80.0260394,
                    55.8556535
                ],
                [
                    80.0273294,
                    55.8573802
                ],
                [
                    80.0340774,
                    55.8604433
                ],
                [
                    80.0374513,
                    55.8606382
                ],
                [
                    80.0465313,
                    55.8594687
                ],
                [
                    80.0493594,
                    55.8596358
                ],
                [
                    80.0528822,
                    55.8606661
                ],
                [
                    80.0570005,
                    55.8618912
                ],
                [
                    80.0639469,
                    55.862643
                ],
                [
                    80.0655842,
                    55.8602762
                ],
                [
                    80.0581913,
                    55.8581877
                ],
                [
                    80.0536761,
                    55.8560434
                ],
                [
                    80.0492106,
                    55.8551523
                ],
                [
                    80.0437527,
                    55.854094
                ],
                [
                    80.033482,
                    55.8548459
                ],
                [
                    80.0275775,
                    55.8548738
                ],
                [
                    80.0260394,
                    55.8556535
                ]
            ],
            "longitude": 80.050156,
            "latitude": 55.857986
        },
        "3432": {
            "name": "Чёрный Мыс",
            "population": 370,
            "type": "village",
            "poly": [
                [
                    80.0508179,
                    55.5385583
                ],
                [
                    80.0515841,
                    55.5401483
                ],
                [
                    80.0545219,
                    55.5421236
                ],
                [
                    80.0798113,
                    55.5447733
                ],
                [
                    80.0869213,
                    55.5455681
                ],
                [
                    80.0946273,
                    55.5447492
                ],
                [
                    80.097565,
                    55.5425572
                ],
                [
                    80.0764905,
                    55.5379801
                ],
                [
                    80.0618448,
                    55.5366791
                ],
                [
                    80.0575873,
                    55.5361973
                ],
                [
                    80.0514991,
                    55.5360527
                ],
                [
                    80.0508179,
                    55.5385583
                ]
            ],
            "longitude": 80.073952,
            "latitude": 55.540298
        },
        "3433": {
            "name": "Гавриловка",
            "population": 292,
            "type": "village",
            "poly": null,
            "longitude": 80.1456975,
            "latitude": 55.1635131
        },
        "3434": {
            "name": "Набережное",
            "population": 1021,
            "type": "village",
            "poly": null,
            "longitude": 80.1802045,
            "latitude": 55.1749389
        },
        "3435": {
            "name": "Комарье",
            "population": 1131,
            "type": "village",
            "poly": [
                [
                    80.1957803,
                    54.4181348
                ],
                [
                    80.2071483,
                    54.4269969
                ],
                [
                    80.2225677,
                    54.4318087
                ],
                [
                    80.2236527,
                    54.4320656
                ],
                [
                    80.225345,
                    54.4316892
                ],
                [
                    80.2325614,
                    54.4294996
                ],
                [
                    80.2363813,
                    54.4299217
                ],
                [
                    80.2393446,
                    54.429907
                ],
                [
                    80.2469341,
                    54.4274019
                ],
                [
                    80.245746,
                    54.4253723
                ],
                [
                    80.2316686,
                    54.4169267
                ],
                [
                    80.2287068,
                    54.4151662
                ],
                [
                    80.2311092,
                    54.4138023
                ],
                [
                    80.2288382,
                    54.4121534
                ],
                [
                    80.215933,
                    54.4109039
                ],
                [
                    80.2079641,
                    54.4090965
                ],
                [
                    80.2067074,
                    54.4102758
                ],
                [
                    80.2026319,
                    54.4083462
                ],
                [
                    80.2000537,
                    54.4101877
                ],
                [
                    80.1990852,
                    54.4130156
                ],
                [
                    80.1957803,
                    54.4181348
                ]
            ],
            "longitude": 80.217545,
            "latitude": 54.420795
        },
        "3436": {
            "name": "Решёты",
            "population": 1948,
            "type": "village",
            "poly": [
                [
                    80.1667685,
                    54.215466
                ],
                [
                    80.2547668,
                    54.2424934
                ],
                [
                    80.2635294,
                    54.2183004
                ],
                [
                    80.2051746,
                    54.1926752
                ],
                [
                    80.1725481,
                    54.2015095
                ],
                [
                    80.1667685,
                    54.215466
                ]
            ],
            "longitude": 80.2208511545641,
            "latitude": 54.2156685265184
        },
        "3437": {
            "name": "Кольцовка",
            "population": 374,
            "type": "village",
            "poly": [
                [
                    80.2073345,
                    54.9803382
                ],
                [
                    80.2088373,
                    54.9822642
                ],
                [
                    80.2117428,
                    54.983414
                ],
                [
                    80.2138968,
                    54.9838739
                ],
                [
                    80.2146984,
                    54.9833278
                ],
                [
                    80.2161511,
                    54.9837302
                ],
                [
                    80.2150991,
                    54.9853973
                ],
                [
                    80.2153997,
                    54.9861447
                ],
                [
                    80.212895,
                    54.9864608
                ],
                [
                    80.2131955,
                    54.986892
                ],
                [
                    80.2106908,
                    54.9872369
                ],
                [
                    80.2104403,
                    54.9893637
                ],
                [
                    80.2117428,
                    54.98945
                ],
                [
                    80.211342,
                    54.9900822
                ],
                [
                    80.2184053,
                    54.9904846
                ],
                [
                    80.2192068,
                    54.9905133
                ],
                [
                    80.2200584,
                    54.9916916
                ],
                [
                    80.218756,
                    54.9918928
                ],
                [
                    80.2188562,
                    54.9927262
                ],
                [
                    80.2202588,
                    54.9926113
                ],
                [
                    80.2201085,
                    54.993186
                ],
                [
                    80.2196577,
                    54.9936458
                ],
                [
                    80.2240659,
                    54.9937895
                ],
                [
                    80.2244167,
                    54.993186
                ],
                [
                    80.2227134,
                    54.9929561
                ],
                [
                    80.2226634,
                    54.9923814
                ],
                [
                    80.2242163,
                    54.9921227
                ],
                [
                    80.2240159,
                    54.9910019
                ],
                [
                    80.2233146,
                    54.9910019
                ],
                [
                    80.2228136,
                    54.9883003
                ],
                [
                    80.2241161,
                    54.9876393
                ],
                [
                    80.2257692,
                    54.9875818
                ],
                [
                    80.2248675,
                    54.9888751
                ],
                [
                    80.2281737,
                    54.9895649
                ],
                [
                    80.229376,
                    54.9878692
                ],
                [
                    80.2299771,
                    54.9878979
                ],
                [
                    80.2298268,
                    54.9885302
                ],
                [
                    80.23148,
                    54.9885015
                ],
                [
                    80.2316802,
                    54.9877542
                ],
                [
                    80.2333334,
                    54.9864608
                ],
                [
                    80.2337843,
                    54.9866045
                ],
                [
                    80.2336841,
                    54.9870357
                ],
                [
                    80.2345858,
                    54.9871219
                ],
                [
                    80.2355877,
                    54.9869207
                ],
                [
                    80.2358382,
                    54.9862884
                ],
                [
                    80.2326822,
                    54.9854548
                ],
                [
                    80.2317805,
                    54.9849374
                ],
                [
                    80.2324818,
                    54.9838452
                ],
                [
                    80.2319809,
                    54.9834715
                ],
                [
                    80.2298268,
                    54.9831265
                ],
                [
                    80.2310792,
                    54.9813443
                ],
                [
                    80.2300773,
                    54.9810856
                ],
                [
                    80.2306784,
                    54.9798782
                ],
                [
                    80.2289751,
                    54.9796483
                ],
                [
                    80.2283741,
                    54.9803669
                ],
                [
                    80.2276227,
                    54.9805394
                ],
                [
                    80.2263703,
                    54.9803094
                ],
                [
                    80.2265707,
                    54.979332
                ],
                [
                    80.2247673,
                    54.9782971
                ],
                [
                    80.2244167,
                    54.9777796
                ],
                [
                    80.2232144,
                    54.9781534
                ],
                [
                    80.2233146,
                    54.9787571
                ],
                [
                    80.2219119,
                    54.9786708
                ],
                [
                    80.2209601,
                    54.9794758
                ],
                [
                    80.2200584,
                    54.9793608
                ],
                [
                    80.2185556,
                    54.9795045
                ],
                [
                    80.218255,
                    54.9799357
                ],
                [
                    80.209188,
                    54.9796195
                ],
                [
                    80.2073345,
                    54.9803382
                ]
            ],
            "longitude": 80.22242,
            "latitude": 54.985043
        },
        "3438": {
            "name": "Озерки 6-е",
            "population": 266,
            "type": "village",
            "poly": [
                [
                    80.2328819,
                    54.625007
                ],
                [
                    80.2354024,
                    54.6263283
                ],
                [
                    80.2375164,
                    54.625489
                ],
                [
                    80.2395555,
                    54.6268048
                ],
                [
                    80.2379279,
                    54.6275575
                ],
                [
                    80.2391159,
                    54.6284672
                ],
                [
                    80.2397706,
                    54.6287488
                ],
                [
                    80.2402851,
                    54.6286405
                ],
                [
                    80.2406312,
                    54.6288517
                ],
                [
                    80.2404815,
                    54.6290303
                ],
                [
                    80.2410054,
                    54.6293552
                ],
                [
                    80.2417817,
                    54.6307305
                ],
                [
                    80.2422494,
                    54.6307305
                ],
                [
                    80.2424459,
                    54.6310879
                ],
                [
                    80.2422027,
                    54.6314831
                ],
                [
                    80.2409492,
                    54.6318513
                ],
                [
                    80.2415105,
                    54.6325984
                ],
                [
                    80.2411939,
                    54.6328029
                ],
                [
                    80.2419501,
                    54.6341631
                ],
                [
                    80.242343,
                    54.6341415
                ],
                [
                    80.2428294,
                    54.634829
                ],
                [
                    80.2429323,
                    54.6352188
                ],
                [
                    80.2433906,
                    54.6355761
                ],
                [
                    80.2434093,
                    54.6360904
                ],
                [
                    80.2442325,
                    54.6369404
                ],
                [
                    80.2441857,
                    54.6372273
                ],
                [
                    80.2444195,
                    54.6373897
                ],
                [
                    80.2451954,
                    54.6373328
                ],
                [
                    80.2454578,
                    54.6375251
                ],
                [
                    80.2455326,
                    54.6378769
                ],
                [
                    80.2463932,
                    54.6381801
                ],
                [
                    80.2473847,
                    54.6379419
                ],
                [
                    80.2487504,
                    54.6388189
                ],
                [
                    80.2504715,
                    54.6396363
                ],
                [
                    80.2528287,
                    54.6405078
                ],
                [
                    80.2526229,
                    54.6407189
                ],
                [
                    80.2516313,
                    54.6412061
                ],
                [
                    80.2531185,
                    54.6421534
                ],
                [
                    80.2537641,
                    54.6423103
                ],
                [
                    80.2543908,
                    54.6422995
                ],
                [
                    80.2557097,
                    54.6426514
                ],
                [
                    80.25556,
                    54.6428841
                ],
                [
                    80.2563364,
                    54.6433009
                ],
                [
                    80.2569537,
                    54.6432792
                ],
                [
                    80.2577488,
                    54.6436527
                ],
                [
                    80.2571034,
                    54.6440641
                ],
                [
                    80.2570286,
                    54.6443347
                ],
                [
                    80.2585251,
                    54.6447731
                ],
                [
                    80.2592345,
                    54.6447703
                ],
                [
                    80.2597786,
                    54.644535
                ],
                [
                    80.2606375,
                    54.6436794
                ],
                [
                    80.2611394,
                    54.6438508
                ],
                [
                    80.264652,
                    54.6432143
                ],
                [
                    80.2684942,
                    54.6427271
                ],
                [
                    80.2688122,
                    54.6432197
                ],
                [
                    80.270047,
                    54.642673
                ],
                [
                    80.2704585,
                    54.6438692
                ],
                [
                    80.270814,
                    54.6442481
                ],
                [
                    80.2715903,
                    54.6441507
                ],
                [
                    80.2724509,
                    54.6435823
                ],
                [
                    80.272246,
                    54.6432527
                ],
                [
                    80.2709169,
                    54.64342
                ],
                [
                    80.2698879,
                    54.6417907
                ],
                [
                    80.269467,
                    54.6415092
                ],
                [
                    80.270224,
                    54.640956
                ],
                [
                    80.2690929,
                    54.6403183
                ],
                [
                    80.2680639,
                    54.6396308
                ],
                [
                    80.2687748,
                    54.6393602
                ],
                [
                    80.2695231,
                    54.6396308
                ],
                [
                    80.2708322,
                    54.6390755
                ],
                [
                    80.2704879,
                    54.6383408
                ],
                [
                    80.271189,
                    54.6380537
                ],
                [
                    80.2719429,
                    54.6375445
                ],
                [
                    80.2717115,
                    54.6373072
                ],
                [
                    80.2720378,
                    54.6369796
                ],
                [
                    80.2710172,
                    54.6363892
                ],
                [
                    80.2679943,
                    54.6385053
                ],
                [
                    80.2671279,
                    54.6387924
                ],
                [
                    80.2660961,
                    54.63947
                ],
                [
                    80.2656065,
                    54.6400251
                ],
                [
                    80.264125,
                    54.639336
                ],
                [
                    80.2629996,
                    54.6400572
                ],
                [
                    80.2634305,
                    54.6402738
                ],
                [
                    80.2632542,
                    54.6404586
                ],
                [
                    80.2654552,
                    54.6415366
                ],
                [
                    80.2625752,
                    54.6425433
                ],
                [
                    80.2614734,
                    54.6419556
                ],
                [
                    80.2611295,
                    54.6421125
                ],
                [
                    80.2596677,
                    54.6416188
                ],
                [
                    80.2593569,
                    54.6412475
                ],
                [
                    80.2593172,
                    54.6408418
                ],
                [
                    80.2589865,
                    54.6408418
                ],
                [
                    80.2583052,
                    54.6413011
                ],
                [
                    80.257366,
                    54.6408532
                ],
                [
                    80.2560035,
                    54.6399844
                ],
                [
                    80.255686,
                    54.6399423
                ],
                [
                    80.2553475,
                    54.6400733
                ],
                [
                    80.2548448,
                    54.6398973
                ],
                [
                    80.2539321,
                    54.6391623
                ],
                [
                    80.2546442,
                    54.6383386
                ],
                [
                    80.252543,
                    54.6373397
                ],
                [
                    80.2506161,
                    54.6369282
                ],
                [
                    80.2501764,
                    54.6369391
                ],
                [
                    80.2497812,
                    54.6370254
                ],
                [
                    80.2494538,
                    54.6365598
                ],
                [
                    80.250246,
                    54.6363632
                ],
                [
                    80.249538,
                    54.6351468
                ],
                [
                    80.2497718,
                    54.6349519
                ],
                [
                    80.2493322,
                    54.6332952
                ],
                [
                    80.2492106,
                    54.632521
                ],
                [
                    80.2490703,
                    54.6318117
                ],
                [
                    80.2489462,
                    54.6298305
                ],
                [
                    80.2460958,
                    54.6282327
                ],
                [
                    80.2464418,
                    54.6278374
                ],
                [
                    80.2466102,
                    54.6274801
                ],
                [
                    80.2460048,
                    54.627381
                ],
                [
                    80.2458432,
                    54.6268465
                ],
                [
                    80.245441,
                    54.6268194
                ],
                [
                    80.2453194,
                    54.6266841
                ],
                [
                    80.2446293,
                    54.6266642
                ],
                [
                    80.2444067,
                    54.6260749
                ],
                [
                    80.2432427,
                    54.6260137
                ],
                [
                    80.2431633,
                    54.626902
                ],
                [
                    80.2406764,
                    54.6258605
                ],
                [
                    80.2408351,
                    54.6255848
                ],
                [
                    80.2404118,
                    54.625401
                ],
                [
                    80.240544,
                    54.6249569
                ],
                [
                    80.2397239,
                    54.6246965
                ],
                [
                    80.2400288,
                    54.6241392
                ],
                [
                    80.2392057,
                    54.6239844
                ],
                [
                    80.2385444,
                    54.6246584
                ],
                [
                    80.2381211,
                    54.6245894
                ],
                [
                    80.2377242,
                    54.6248422
                ],
                [
                    80.2344803,
                    54.6238174
                ],
                [
                    80.2342799,
                    54.6240106
                ],
                [
                    80.2328819,
                    54.625007
                ]
            ],
            "longitude": 80.250786,
            "latitude": 54.63929
        },
        "3439": {
            "name": "Ермаковский",
            "population": 359,
            "type": "village",
            "poly": [
                [
                    80.2984629,
                    54.1332328
                ],
                [
                    80.3131154,
                    54.1367239
                ],
                [
                    80.3198555,
                    54.1293408
                ],
                [
                    80.3189764,
                    54.1176053
                ],
                [
                    80.3133108,
                    54.1158876
                ],
                [
                    80.2984629,
                    54.1332328
                ]
            ],
            "longitude": 80.311142,
            "latitude": 54.12743
        },
        "3440": {
            "name": "Мамонтовое",
            "population": 275,
            "type": "village",
            "poly": [
                [
                    80.3192833,
                    54.661456
                ],
                [
                    80.3223989,
                    54.6626034
                ],
                [
                    80.3213536,
                    54.663597
                ],
                [
                    80.3218025,
                    54.6637376
                ],
                [
                    80.3209107,
                    54.6644359
                ],
                [
                    80.3221954,
                    54.6648629
                ],
                [
                    80.3235423,
                    54.6651875
                ],
                [
                    80.3235985,
                    54.6650036
                ],
                [
                    80.3258434,
                    54.6658799
                ],
                [
                    80.3259744,
                    54.6660747
                ],
                [
                    80.3278193,
                    54.6666934
                ],
                [
                    80.328293,
                    54.6662738
                ],
                [
                    80.3381081,
                    54.6694548
                ],
                [
                    80.3376135,
                    54.6700353
                ],
                [
                    80.3390237,
                    54.6703682
                ],
                [
                    80.3395297,
                    54.6698713
                ],
                [
                    80.34008,
                    54.6699803
                ],
                [
                    80.3411145,
                    54.6700107
                ],
                [
                    80.3439681,
                    54.6695912
                ],
                [
                    80.3452203,
                    54.6702101
                ],
                [
                    80.3462107,
                    54.6698466
                ],
                [
                    80.3446799,
                    54.6689747
                ],
                [
                    80.3451871,
                    54.6686376
                ],
                [
                    80.3442145,
                    54.6681844
                ],
                [
                    80.3445814,
                    54.6677871
                ],
                [
                    80.3434474,
                    54.6673946
                ],
                [
                    80.342667,
                    54.6680972
                ],
                [
                    80.3396638,
                    54.6669085
                ],
                [
                    80.3401106,
                    54.6664487
                ],
                [
                    80.3353844,
                    54.6644193
                ],
                [
                    80.3348419,
                    54.664073
                ],
                [
                    80.3289673,
                    54.6615977
                ],
                [
                    80.3287431,
                    54.6617359
                ],
                [
                    80.3223562,
                    54.659259
                ],
                [
                    80.3209959,
                    54.6603243
                ],
                [
                    80.3205117,
                    54.6601668
                ],
                [
                    80.3195015,
                    54.6610974
                ],
                [
                    80.3192833,
                    54.661456
                ]
            ],
            "longitude": 80.326759,
            "latitude": 54.663334
        },
        "3441": {
            "name": "Первотроицк",
            "population": 708,
            "type": "village",
            "poly": [
                [
                    80.3588579,
                    55.090202
                ],
                [
                    80.3588579,
                    55.0906188
                ],
                [
                    80.360861,
                    55.0913483
                ],
                [
                    80.3682357,
                    55.0923383
                ],
                [
                    80.3686,
                    55.0919214
                ],
                [
                    80.3749732,
                    55.0934845
                ],
                [
                    80.3734255,
                    55.095829
                ],
                [
                    80.378069,
                    55.0968709
                ],
                [
                    80.3845333,
                    55.0983817
                ],
                [
                    80.3881752,
                    55.0984338
                ],
                [
                    80.3906335,
                    55.0977565
                ],
                [
                    80.3914529,
                    55.0958811
                ],
                [
                    80.3891768,
                    55.0953601
                ],
                [
                    80.3893588,
                    55.0928072
                ],
                [
                    80.3879931,
                    55.0924425
                ],
                [
                    80.3870826,
                    55.093224
                ],
                [
                    80.3848974,
                    55.0919214
                ],
                [
                    80.3811646,
                    55.0913483
                ],
                [
                    80.3816198,
                    55.0905146
                ],
                [
                    80.3814377,
                    55.0880656
                ],
                [
                    80.3787063,
                    55.0870756
                ],
                [
                    80.376248,
                    55.0867108
                ],
                [
                    80.3736076,
                    55.0862418
                ],
                [
                    80.3680537,
                    55.0881698
                ],
                [
                    80.3677806,
                    55.088743
                ],
                [
                    80.3715135,
                    55.0894725
                ],
                [
                    80.3709673,
                    55.0903583
                ],
                [
                    80.3684179,
                    55.0895767
                ],
                [
                    80.3649581,
                    55.0884825
                ],
                [
                    80.3611341,
                    55.0890557
                ],
                [
                    80.3588579,
                    55.090202
                ]
            ],
            "longitude": 80.377411,
            "latitude": 55.092178
        },
        "3442": {
            "name": "Новые Решеты",
            "population": 558,
            "type": "village",
            "poly": null,
            "longitude": 80.389839,
            "latitude": 54.126144
        },
        "3443": {
            "name": "Мусы",
            "population": 325,
            "type": "village",
            "poly": null,
            "longitude": 80.4282,
            "latitude": 55.453838
        },
        "3444": {
            "name": "Сумы",
            "population": 484,
            "type": "village",
            "poly": [
                [
                    80.4272744,
                    54.8093805
                ],
                [
                    80.4283773,
                    54.8167155
                ],
                [
                    80.4301733,
                    54.8170116
                ],
                [
                    80.4334777,
                    54.8175563
                ],
                [
                    80.4382117,
                    54.8181747
                ],
                [
                    80.4448342,
                    54.8190398
                ],
                [
                    80.4728677,
                    54.8289854
                ],
                [
                    80.4759705,
                    54.829387
                ],
                [
                    80.4778079,
                    54.827517
                ],
                [
                    80.4670883,
                    54.8201369
                ],
                [
                    80.4518965,
                    54.8172708
                ],
                [
                    80.4482054,
                    54.8117857
                ],
                [
                    80.4646209,
                    54.8074755
                ],
                [
                    80.4700618,
                    54.8053979
                ],
                [
                    80.468324,
                    54.8030151
                ],
                [
                    80.4619983,
                    54.8035567
                ],
                [
                    80.4578099,
                    54.8044793
                ],
                [
                    80.4547763,
                    54.80339
                ],
                [
                    80.4537816,
                    54.8007815
                ],
                [
                    80.4502506,
                    54.794933
                ],
                [
                    80.4480624,
                    54.7953344
                ],
                [
                    80.4483608,
                    54.7988034
                ],
                [
                    80.4441888,
                    54.8037935
                ],
                [
                    80.4399561,
                    54.8060271
                ],
                [
                    80.4307427,
                    54.8029502
                ],
                [
                    80.4278214,
                    54.8063997
                ],
                [
                    80.4272744,
                    54.8093805
                ]
            ],
            "longitude": 80.442612,
            "latitude": 54.81551
        },
        "3445": {
            "name": "Форпост-Каргат",
            "population": 287,
            "type": "village",
            "poly": [
                [
                    80.4304613,
                    55.269056
                ],
                [
                    80.4336122,
                    55.2724989
                ],
                [
                    80.4351542,
                    55.2740362
                ],
                [
                    80.4341263,
                    55.2770742
                ],
                [
                    80.4352186,
                    55.2790505
                ],
                [
                    80.436825,
                    55.2811731
                ],
                [
                    80.440359,
                    55.2842105
                ],
                [
                    80.4415156,
                    55.2834055
                ],
                [
                    80.4430577,
                    55.2827468
                ],
                [
                    80.4447283,
                    55.2823442
                ],
                [
                    80.4453066,
                    55.2817587
                ],
                [
                    80.4454351,
                    55.2811365
                ],
                [
                    80.4455636,
                    55.2801484
                ],
                [
                    80.4463347,
                    55.2800752
                ],
                [
                    80.4470415,
                    55.2805876
                ],
                [
                    80.4510895,
                    55.2811365
                ],
                [
                    80.4518606,
                    55.2797825
                ],
                [
                    80.4519891,
                    55.2788675
                ],
                [
                    80.452893,
                    55.2792003
                ],
                [
                    80.4535312,
                    55.2776598
                ],
                [
                    80.4576435,
                    55.2783917
                ],
                [
                    80.4581575,
                    55.2781721
                ],
                [
                    80.4588643,
                    55.2757199
                ],
                [
                    80.4566154,
                    55.2751343
                ],
                [
                    80.4570652,
                    55.2743657
                ],
                [
                    80.4565511,
                    55.2738532
                ],
                [
                    80.4549448,
                    55.2734506
                ],
                [
                    80.4549448,
                    55.2715106
                ],
                [
                    80.4536597,
                    55.2697901
                ],
                [
                    80.4541737,
                    55.2688383
                ],
                [
                    80.4522461,
                    55.2680695
                ],
                [
                    80.4483908,
                    55.268399
                ],
                [
                    80.4435717,
                    55.268399
                ],
                [
                    80.4422866,
                    55.2689481
                ],
                [
                    80.4381101,
                    55.2690213
                ],
                [
                    80.4304613,
                    55.269056
                ]
            ],
            "longitude": 80.443481,
            "latitude": 55.274643
        },
        "3446": {
            "name": "Алабуга",
            "population": 376,
            "type": "village",
            "poly": [
                [
                    80.4567595,
                    54.6688832
                ],
                [
                    80.4582041,
                    54.6733812
                ],
                [
                    80.4639823,
                    54.6772363
                ],
                [
                    80.4662047,
                    54.6758228
                ],
                [
                    80.4682049,
                    54.6767865
                ],
                [
                    80.4734275,
                    54.673831
                ],
                [
                    80.4752055,
                    54.6740237
                ],
                [
                    80.4757611,
                    54.673317
                ],
                [
                    80.4754277,
                    54.6715178
                ],
                [
                    80.4733164,
                    54.6689474
                ],
                [
                    80.4727608,
                    54.6667625
                ],
                [
                    80.4706496,
                    54.6653487
                ],
                [
                    80.470094,
                    54.6656057
                ],
                [
                    80.4662047,
                    54.663035
                ],
                [
                    80.4614265,
                    54.6619424
                ],
                [
                    80.4575373,
                    54.6651559
                ],
                [
                    80.4567595,
                    54.6688832
                ]
            ],
            "longitude": 80.465996,
            "latitude": 54.670513
        },
        "3447": {
            "name": "Красная Сибирь",
            "population": 1091,
            "type": "village",
            "poly": null,
            "longitude": 80.492607,
            "latitude": 54.32272
        },
        "3448": {
            "name": "Новоцелинное",
            "population": 1261,
            "type": "village",
            "poly": null,
            "longitude": 80.516174,
            "latitude": 54.355244
        },
        "3449": {
            "name": "Жуланка",
            "population": 1222,
            "type": "village",
            "poly": [
                [
                    80.5794851,
                    54.3520732
                ],
                [
                    80.5794851,
                    54.3539571
                ],
                [
                    80.5808162,
                    54.3556746
                ],
                [
                    80.5832881,
                    54.3587771
                ],
                [
                    80.584524,
                    54.3617131
                ],
                [
                    80.5876138,
                    54.3619901
                ],
                [
                    80.5879941,
                    54.3637073
                ],
                [
                    80.5905135,
                    54.3647597
                ],
                [
                    80.5927002,
                    54.364095
                ],
                [
                    80.5952671,
                    54.3658121
                ],
                [
                    80.5948868,
                    54.3667261
                ],
                [
                    80.5988323,
                    54.3670584
                ],
                [
                    80.5995453,
                    54.3664768
                ],
                [
                    80.6012091,
                    54.3667537
                ],
                [
                    80.6010665,
                    54.3671692
                ],
                [
                    80.6037285,
                    54.3674738
                ],
                [
                    80.6059151,
                    54.3671415
                ],
                [
                    80.6052021,
                    54.3683323
                ],
                [
                    80.6086246,
                    54.3684154
                ],
                [
                    80.6103835,
                    54.3699938
                ],
                [
                    80.6113342,
                    54.3699384
                ],
                [
                    80.6112391,
                    54.3709907
                ],
                [
                    80.6140913,
                    54.3732337
                ],
                [
                    80.6152322,
                    54.3736767
                ],
                [
                    80.6170385,
                    54.373289
                ],
                [
                    80.6198907,
                    54.3739813
                ],
                [
                    80.6218872,
                    54.3737598
                ],
                [
                    80.6222199,
                    54.3735382
                ],
                [
                    80.6250245,
                    54.3735936
                ],
                [
                    80.624977,
                    54.3741751
                ],
                [
                    80.6294929,
                    54.3745074
                ],
                [
                    80.6301109,
                    54.3748673
                ],
                [
                    80.6314894,
                    54.3748396
                ],
                [
                    80.6324401,
                    54.3741197
                ],
                [
                    80.6337236,
                    54.374092
                ],
                [
                    80.6341039,
                    54.373649
                ],
                [
                    80.6338662,
                    54.3729291
                ],
                [
                    80.6370036,
                    54.3718768
                ],
                [
                    80.6369085,
                    54.37052
                ],
                [
                    80.6372412,
                    54.3701877
                ],
                [
                    80.6373363,
                    54.3693292
                ],
                [
                    80.6333908,
                    54.3678615
                ],
                [
                    80.6323451,
                    54.3680277
                ],
                [
                    80.6291602,
                    54.3673907
                ],
                [
                    80.6275915,
                    54.367363
                ],
                [
                    80.6249294,
                    54.366006
                ],
                [
                    80.6273063,
                    54.3644551
                ],
                [
                    80.6267358,
                    54.3635965
                ],
                [
                    80.6258802,
                    54.3635134
                ],
                [
                    80.624977,
                    54.3636796
                ],
                [
                    80.620984,
                    54.3625717
                ],
                [
                    80.6200808,
                    54.3619347
                ],
                [
                    80.6177516,
                    54.3612699
                ],
                [
                    80.6187498,
                    54.3603282
                ],
                [
                    80.6178465,
                    54.3598019
                ],
                [
                    80.6154698,
                    54.3587494
                ],
                [
                    80.612998,
                    54.3567273
                ],
                [
                    80.611049,
                    54.3553422
                ],
                [
                    80.6042514,
                    54.3575583
                ],
                [
                    80.6032531,
                    54.3571151
                ],
                [
                    80.5980717,
                    54.3567273
                ],
                [
                    80.6010189,
                    54.3547604
                ],
                [
                    80.5992126,
                    54.3539571
                ],
                [
                    80.5908463,
                    54.3525442
                ],
                [
                    80.5885646,
                    54.3534307
                ],
                [
                    80.5828602,
                    54.3519901
                ],
                [
                    80.5815293,
                    54.3529044
                ],
                [
                    80.5794851,
                    54.3520732
                ]
            ],
            "longitude": 80.604317,
            "latitude": 54.366016
        },
        "3450": {
            "name": "Кокошино",
            "population": 881,
            "type": "village",
            "poly": [
                [
                    80.6073353,
                    55.1521318
                ],
                [
                    80.608619,
                    55.1557992
                ],
                [
                    80.610611,
                    55.1585812
                ],
                [
                    80.6111422,
                    55.1614136
                ],
                [
                    80.6125586,
                    55.16154
                ],
                [
                    80.615436,
                    55.1607308
                ],
                [
                    80.6136211,
                    55.1591629
                ],
                [
                    80.6141523,
                    55.1581766
                ],
                [
                    80.6156131,
                    55.1587077
                ],
                [
                    80.6203939,
                    55.1584295
                ],
                [
                    80.6214563,
                    55.1597698
                ],
                [
                    80.6233139,
                    55.1594045
                ],
                [
                    80.6272109,
                    55.1598457
                ],
                [
                    80.6277864,
                    55.1605285
                ],
                [
                    80.6332312,
                    55.1600986
                ],
                [
                    80.6351347,
                    55.1608067
                ],
                [
                    80.6382776,
                    55.1587835
                ],
                [
                    80.6397384,
                    55.1595169
                ],
                [
                    80.6413762,
                    55.1582019
                ],
                [
                    80.6380562,
                    55.156735
                ],
                [
                    80.6361971,
                    55.1577719
                ],
                [
                    80.6347805,
                    55.1549646
                ],
                [
                    80.6349132,
                    55.1544588
                ],
                [
                    80.6365512,
                    55.1541047
                ],
                [
                    80.6365512,
                    55.1546864
                ],
                [
                    80.6392514,
                    55.1555969
                ],
                [
                    80.6423058,
                    55.1556728
                ],
                [
                    80.6441208,
                    55.155344
                ],
                [
                    80.644165,
                    55.1531941
                ],
                [
                    80.6415533,
                    55.152233
                ],
                [
                    80.6402696,
                    55.1503612
                ],
                [
                    80.6378349,
                    55.1498806
                ],
                [
                    80.6404024,
                    55.1480087
                ],
                [
                    80.6401367,
                    55.1472751
                ],
                [
                    80.633364,
                    55.1491723
                ],
                [
                    80.6321688,
                    55.1485146
                ],
                [
                    80.6307965,
                    55.1487676
                ],
                [
                    80.6302653,
                    55.149577
                ],
                [
                    80.6249091,
                    55.1503612
                ],
                [
                    80.6222973,
                    55.1495264
                ],
                [
                    80.6204824,
                    55.1503865
                ],
                [
                    80.6198627,
                    55.1494
                ],
                [
                    80.6078222,
                    55.1500829
                ],
                [
                    80.6073353,
                    55.1521318
                ]
            ],
            "longitude": 80.622002,
            "latitude": 55.154854
        },
        "3451": {
            "name": "Верх-Каргат",
            "population": 420,
            "type": "village",
            "poly": [
                [
                    80.6405887,
                    55.3644165
                ],
                [
                    80.6421449,
                    55.3658906
                ],
                [
                    80.6459302,
                    55.3703066
                ],
                [
                    80.6501633,
                    55.3734135
                ],
                [
                    80.6589174,
                    55.3763179
                ],
                [
                    80.6612864,
                    55.3757832
                ],
                [
                    80.6639787,
                    55.374776
                ],
                [
                    80.6603002,
                    55.3707251
                ],
                [
                    80.661776,
                    55.3698991
                ],
                [
                    80.6595939,
                    55.3654924
                ],
                [
                    80.6614413,
                    55.3665981
                ],
                [
                    80.6625825,
                    55.3659495
                ],
                [
                    80.6613376,
                    55.3649472
                ],
                [
                    80.6637237,
                    55.3631193
                ],
                [
                    80.6603002,
                    55.3607606
                ],
                [
                    80.6552424,
                    55.3622837
                ],
                [
                    80.6488883,
                    55.3607016
                ],
                [
                    80.6466059,
                    55.3614682
                ],
                [
                    80.6457759,
                    55.3643575
                ],
                [
                    80.6418336,
                    55.3641806
                ],
                [
                    80.6405887,
                    55.3644165
                ]
            ],
            "longitude": 80.65448,
            "latitude": 55.370548
        },
        "3452": {
            "name": "Золотая Грива",
            "population": 556,
            "type": "village",
            "poly": [
                [
                    80.6732848,
                    54.9952241
                ],
                [
                    80.6799973,
                    54.9996874
                ],
                [
                    80.6891895,
                    55.002064
                ],
                [
                    80.690887,
                    55.0009847
                ],
                [
                    80.6934464,
                    55.0012851
                ],
                [
                    80.7007851,
                    54.9971906
                ],
                [
                    80.696162,
                    54.9953089
                ],
                [
                    80.694992,
                    54.9957926
                ],
                [
                    80.6911568,
                    54.9940863
                ],
                [
                    80.6874768,
                    54.9938675
                ],
                [
                    80.6898307,
                    54.9925362
                ],
                [
                    80.6920541,
                    54.9932966
                ],
                [
                    80.6950834,
                    54.9903821
                ],
                [
                    80.6937758,
                    54.9900887
                ],
                [
                    80.6923512,
                    54.9908833
                ],
                [
                    80.6916389,
                    54.9899298
                ],
                [
                    80.6889284,
                    54.9903143
                ],
                [
                    80.68507,
                    54.987614
                ],
                [
                    80.6807962,
                    54.986615
                ],
                [
                    80.6785159,
                    54.9853359
                ],
                [
                    80.6760476,
                    54.9869102
                ],
                [
                    80.6829726,
                    54.9912693
                ],
                [
                    80.6763246,
                    54.9940389
                ],
                [
                    80.6732848,
                    54.9952241
                ]
            ],
            "longitude": 80.687691,
            "latitude": 54.998051
        },
        "3453": {
            "name": "Серебрянское",
            "population": 773,
            "type": "village",
            "poly": [
                [
                    80.6832668,
                    54.8709655
                ],
                [
                    80.6834608,
                    54.8716354
                ],
                [
                    80.6887969,
                    54.8757663
                ],
                [
                    80.6924514,
                    54.8775898
                ],
                [
                    80.6931952,
                    54.8783154
                ],
                [
                    80.6932922,
                    54.8795062
                ],
                [
                    80.7018947,
                    54.8824829
                ],
                [
                    80.7038998,
                    54.8802318
                ],
                [
                    80.7088802,
                    54.8818131
                ],
                [
                    80.7132138,
                    54.8819062
                ],
                [
                    80.717224,
                    54.8776084
                ],
                [
                    80.7134401,
                    54.8759338
                ],
                [
                    80.7029612,
                    54.8712916
                ],
                [
                    80.6934215,
                    54.8674854
                ],
                [
                    80.6892174,
                    54.867839
                ],
                [
                    80.6875357,
                    54.868602
                ],
                [
                    80.684334,
                    54.8702583
                ],
                [
                    80.6832668,
                    54.8709655
                ]
            ],
            "longitude": 80.6987,
            "latitude": 54.875412
        },
        "3454": {
            "name": "Воздвиженский",
            "population": 680,
            "type": "village",
            "poly": [
                [
                    80.7200718,
                    54.6453637
                ],
                [
                    80.7231399,
                    54.6489141
                ],
                [
                    80.7269928,
                    54.6517624
                ],
                [
                    80.7322012,
                    54.6532897
                ],
                [
                    80.7316304,
                    54.6544454
                ],
                [
                    80.7371243,
                    54.6593156
                ],
                [
                    80.7416906,
                    54.6612141
                ],
                [
                    80.743403,
                    54.659976
                ],
                [
                    80.7413339,
                    54.6571282
                ],
                [
                    80.7391934,
                    54.6536199
                ],
                [
                    80.7351979,
                    54.6527943
                ],
                [
                    80.7375524,
                    54.6512258
                ],
                [
                    80.7434743,
                    54.6517624
                ],
                [
                    80.7473272,
                    54.6491618
                ],
                [
                    80.7451154,
                    54.647593
                ],
                [
                    80.7461141,
                    54.6466435
                ],
                [
                    80.747898,
                    54.6464784
                ],
                [
                    80.7472228,
                    54.6441223
                ],
                [
                    80.7451867,
                    54.642804
                ],
                [
                    80.7293473,
                    54.6366104
                ],
                [
                    80.7200718,
                    54.6453637
                ]
            ],
            "longitude": 80.732483,
            "latitude": 54.647243
        },
        "3455": {
            "name": "Республиканский",
            "population": 334,
            "type": "village",
            "poly": [
                [
                    80.7702475,
                    54.2696928
                ],
                [
                    80.7798974,
                    54.2769189
                ],
                [
                    80.7939009,
                    54.2707438
                ],
                [
                    80.7897873,
                    54.2633364
                ],
                [
                    80.7799317,
                    54.2587812
                ],
                [
                    80.770676,
                    54.2617346
                ],
                [
                    80.7702475,
                    54.2696928
                ]
            ],
            "longitude": 80.785522,
            "latitude": 54.26918
        },
        "3456": {
            "name": "Чулым-3",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.7928204,
            "latitude": 55.1091523
        },
        "3457": {
            "name": "Быструха",
            "population": 1134,
            "type": "village",
            "poly": [
                [
                    80.846857,
                    54.4243209
                ],
                [
                    80.8488093,
                    54.4318903
                ],
                [
                    80.856505,
                    54.4369565
                ],
                [
                    80.8545776,
                    54.4390223
                ],
                [
                    80.8603757,
                    54.4411564
                ],
                [
                    80.861531,
                    54.4401484
                ],
                [
                    80.8647086,
                    54.4412907
                ],
                [
                    80.866384,
                    54.440182
                ],
                [
                    80.8771874,
                    54.4441464
                ],
                [
                    80.8855299,
                    54.4457376
                ],
                [
                    80.8881641,
                    54.4450534
                ],
                [
                    80.8874709,
                    54.4438776
                ],
                [
                    80.8887418,
                    54.4401148
                ],
                [
                    80.8931903,
                    54.4418619
                ],
                [
                    80.8948657,
                    54.4409212
                ],
                [
                    80.9064559,
                    54.444657
                ],
                [
                    80.9075177,
                    54.4432393
                ],
                [
                    80.9048603,
                    54.442601
                ],
                [
                    80.9062468,
                    54.440854
                ],
                [
                    80.8952123,
                    54.4380989
                ],
                [
                    80.9030693,
                    54.4352429
                ],
                [
                    80.9039937,
                    54.4337644
                ],
                [
                    80.893248,
                    54.4276818
                ],
                [
                    80.8851092,
                    54.426038
                ],
                [
                    80.878884,
                    54.4251702
                ],
                [
                    80.8730856,
                    54.425262
                ],
                [
                    80.846857,
                    54.4243209
                ]
            ],
            "longitude": 80.879433,
            "latitude": 54.436958
        },
        "3458": {
            "name": "Михайловский",
            "population": 379,
            "type": "village",
            "poly": [
                [
                    80.9443922,
                    54.5862303
                ],
                [
                    80.9451679,
                    54.5876196
                ],
                [
                    80.9488348,
                    54.5875788
                ],
                [
                    80.9489758,
                    54.5894992
                ],
                [
                    80.9513734,
                    54.590439
                ],
                [
                    80.959906,
                    54.5881917
                ],
                [
                    80.9615984,
                    54.5894175
                ],
                [
                    80.9661116,
                    54.5882734
                ],
                [
                    80.9678744,
                    54.5899487
                ],
                [
                    80.971233,
                    54.5918635
                ],
                [
                    80.9749968,
                    54.5904799
                ],
                [
                    80.9769007,
                    54.5891723
                ],
                [
                    80.9732338,
                    54.5849226
                ],
                [
                    80.9707657,
                    54.5837376
                ],
                [
                    80.9704131,
                    54.5768715
                ],
                [
                    80.968227,
                    54.5761358
                ],
                [
                    80.9587777,
                    54.5797734
                ],
                [
                    80.9563833,
                    54.5807108
                ],
                [
                    80.9552518,
                    54.5828794
                ],
                [
                    80.9468603,
                    54.5852496
                ],
                [
                    80.9443922,
                    54.5862303
                ]
            ],
            "longitude": 80.956017,
            "latitude": 54.586369
        },
        "3459": {
            "name": "Иткуль",
            "population": 431,
            "type": "village",
            "poly": [
                [
                    81.0095663,
                    55.0726564
                ],
                [
                    81.0148694,
                    55.0754574
                ],
                [
                    81.0149188,
                    55.0763339
                ],
                [
                    81.0183759,
                    55.0789067
                ],
                [
                    81.01966,
                    55.0825819
                ],
                [
                    81.0191661,
                    55.0856349
                ],
                [
                    81.0199563,
                    55.0866242
                ],
                [
                    81.023611,
                    55.0871613
                ],
                [
                    81.0327478,
                    55.0854936
                ],
                [
                    81.0407486,
                    55.0882919
                ],
                [
                    81.043218,
                    55.0880093
                ],
                [
                    81.0498853,
                    55.0858893
                ],
                [
                    81.0492036,
                    55.0848659
                ],
                [
                    81.044749,
                    55.0846173
                ],
                [
                    81.0367976,
                    55.0848717
                ],
                [
                    81.0151163,
                    55.0722905
                ],
                [
                    81.0108978,
                    55.0716415
                ],
                [
                    81.0095663,
                    55.0726564
                ]
            ],
            "longitude": 81.024162,
            "latitude": 55.080929
        },
        "3460": {
            "name": "Ужаниха",
            "population": 1303,
            "type": "village",
            "poly": [
                [
                    81.0168989,
                    54.6673648
                ],
                [
                    81.0176748,
                    54.6713034
                ],
                [
                    81.0216406,
                    54.6733473
                ],
                [
                    81.0204336,
                    54.6781826
                ],
                [
                    81.0199163,
                    54.6810236
                ],
                [
                    81.0268995,
                    54.687951
                ],
                [
                    81.0497456,
                    54.6870042
                ],
                [
                    81.054401,
                    54.6749425
                ],
                [
                    81.0550045,
                    54.6684118
                ],
                [
                    81.0481076,
                    54.6663178
                ],
                [
                    81.0448315,
                    54.6676141
                ],
                [
                    81.0424175,
                    54.6649715
                ],
                [
                    81.0431935,
                    54.6626779
                ],
                [
                    81.0412968,
                    54.6618302
                ],
                [
                    81.0417279,
                    54.6608329
                ],
                [
                    81.0380208,
                    54.6603841
                ],
                [
                    81.0350896,
                    54.6636751
                ],
                [
                    81.0265546,
                    54.6635255
                ],
                [
                    81.0225889,
                    54.6669161
                ],
                [
                    81.0168989,
                    54.6673648
                ]
            ],
            "longitude": 81.035873,
            "latitude": 54.676704
        },
        "3461": {
            "name": "Новоиткульское",
            "population": 640,
            "type": "village",
            "poly": [
                [
                    81.0501016,
                    55.0492748
                ],
                [
                    81.0575717,
                    55.0511484
                ],
                [
                    81.0614077,
                    55.0533689
                ],
                [
                    81.0717042,
                    55.0572776
                ],
                [
                    81.072754,
                    55.0561906
                ],
                [
                    81.0686758,
                    55.0534614
                ],
                [
                    81.069766,
                    55.0525131
                ],
                [
                    81.0702506,
                    55.0530913
                ],
                [
                    81.0722291,
                    55.0529757
                ],
                [
                    81.0742884,
                    55.0520505
                ],
                [
                    81.07126,
                    55.0507783
                ],
                [
                    81.0704928,
                    55.0492285
                ],
                [
                    81.0726733,
                    55.0476555
                ],
                [
                    81.0721484,
                    55.0474242
                ],
                [
                    81.0740865,
                    55.0461518
                ],
                [
                    81.0700083,
                    55.0454578
                ],
                [
                    81.0689181,
                    55.0459668
                ],
                [
                    81.0680701,
                    55.045134
                ],
                [
                    81.0588234,
                    55.0440698
                ],
                [
                    81.055149,
                    55.0467533
                ],
                [
                    81.0528877,
                    55.0455041
                ],
                [
                    81.0501419,
                    55.0479794
                ],
                [
                    81.0507881,
                    55.0482801
                ],
                [
                    81.0501016,
                    55.0492748
                ]
            ],
            "longitude": 81.06308,
            "latitude": 55.049568
        },
        "3462": {
            "name": "Куликовское",
            "population": 474,
            "type": "village",
            "poly": [
                [
                    81.0495191,
                    55.2947806
                ],
                [
                    81.0585446,
                    55.2963244
                ],
                [
                    81.0585834,
                    55.2966773
                ],
                [
                    81.060249,
                    55.2970301
                ],
                [
                    81.0608301,
                    55.2965008
                ],
                [
                    81.0614886,
                    55.2967875
                ],
                [
                    81.0611787,
                    55.2975153
                ],
                [
                    81.063193,
                    55.2981989
                ],
                [
                    81.0635029,
                    55.2975153
                ],
                [
                    81.0681125,
                    55.2979563
                ],
                [
                    81.0677251,
                    55.3002718
                ],
                [
                    81.0688097,
                    55.3009554
                ],
                [
                    81.0699331,
                    55.3001395
                ],
                [
                    81.072296,
                    55.2999852
                ],
                [
                    81.0735356,
                    55.3007129
                ],
                [
                    81.0710564,
                    55.3022785
                ],
                [
                    81.0690809,
                    55.3040866
                ],
                [
                    81.0669504,
                    55.3046378
                ],
                [
                    81.0660595,
                    55.3051449
                ],
                [
                    81.065982,
                    55.3054536
                ],
                [
                    81.0691971,
                    55.3067986
                ],
                [
                    81.068035,
                    55.3090694
                ],
                [
                    81.0713662,
                    55.3099954
                ],
                [
                    81.0755886,
                    55.3073277
                ],
                [
                    81.0779127,
                    55.3075482
                ],
                [
                    81.07861,
                    55.3060048
                ],
                [
                    81.079927,
                    55.3063576
                ],
                [
                    81.0820963,
                    55.3059607
                ],
                [
                    81.0824449,
                    55.3050126
                ],
                [
                    81.0850402,
                    55.3035133
                ],
                [
                    81.0898048,
                    55.3034471
                ],
                [
                    81.0908894,
                    55.3039763
                ],
                [
                    81.0927875,
                    55.3039984
                ],
                [
                    81.0937946,
                    55.3027856
                ],
                [
                    81.0925163,
                    55.3023446
                ],
                [
                    81.0921289,
                    55.3015949
                ],
                [
                    81.0848465,
                    55.299081
                ],
                [
                    81.0835682,
                    55.2995441
                ],
                [
                    81.08198,
                    55.2985297
                ],
                [
                    81.0807018,
                    55.2985518
                ],
                [
                    81.0788811,
                    55.2967655
                ],
                [
                    81.0779127,
                    55.2973168
                ],
                [
                    81.0762083,
                    55.296567
                ],
                [
                    81.073613,
                    55.2972065
                ],
                [
                    81.0691971,
                    55.2958172
                ],
                [
                    81.0659433,
                    55.2950894
                ],
                [
                    81.0582735,
                    55.2935896
                ],
                [
                    81.0552521,
                    55.2932368
                ],
                [
                    81.0526955,
                    55.2933911
                ],
                [
                    81.0525018,
                    55.2937661
                ],
                [
                    81.0502551,
                    55.2934353
                ],
                [
                    81.0495191,
                    55.2947806
                ]
            ],
            "longitude": 81.078217,
            "latitude": 55.300179
        },
        "3463": {
            "name": "Алексеевка",
            "population": 465,
            "type": "village",
            "poly": [
                [
                    81.1247675,
                    54.52001
                ],
                [
                    81.1292737,
                    54.5215269
                ],
                [
                    81.1384665,
                    54.5177606
                ],
                [
                    81.1448654,
                    54.5142554
                ],
                [
                    81.1536977,
                    54.5143077
                ],
                [
                    81.1591954,
                    54.5173944
                ],
                [
                    81.1634505,
                    54.518312
                ],
                [
                    81.1688388,
                    54.5094419
                ],
                [
                    81.1591052,
                    54.5083954
                ],
                [
                    81.156762,
                    54.5001272
                ],
                [
                    81.1499125,
                    54.497929
                ],
                [
                    81.1451358,
                    54.5004412
                ],
                [
                    81.1372949,
                    54.4998131
                ],
                [
                    81.1319775,
                    54.5010692
                ],
                [
                    81.1259391,
                    54.5058837
                ],
                [
                    81.129454,
                    54.5097035
                ],
                [
                    81.1299046,
                    54.5151448
                ],
                [
                    81.1247675,
                    54.52001
                ]
            ],
            "longitude": 81.145386,
            "latitude": 54.509335
        },
        "3464": {
            "name": "Пролетарский",
            "population": 1436,
            "type": "village",
            "poly": [
                [
                    81.1438962,
                    54.379953
                ],
                [
                    81.1465666,
                    54.3818138
                ],
                [
                    81.1514784,
                    54.3837022
                ],
                [
                    81.15062,
                    54.3880897
                ],
                [
                    81.156104,
                    54.3895336
                ],
                [
                    81.158536,
                    54.3894781
                ],
                [
                    81.1575346,
                    54.3903666
                ],
                [
                    81.1634955,
                    54.3920881
                ],
                [
                    81.1659275,
                    54.3923102
                ],
                [
                    81.1735574,
                    54.3863403
                ],
                [
                    81.1774676,
                    54.3830357
                ],
                [
                    81.1675012,
                    54.3817027
                ],
                [
                    81.1726514,
                    54.3773145
                ],
                [
                    81.1601574,
                    54.3731758
                ],
                [
                    81.1571054,
                    54.3758424
                ],
                [
                    81.149237,
                    54.3729258
                ],
                [
                    81.1475681,
                    54.3758979
                ],
                [
                    81.1438962,
                    54.379953
                ]
            ],
            "longitude": 81.159912,
            "latitude": 54.382755
        },
        "3465": {
            "name": "Базово",
            "population": 726,
            "type": "village",
            "poly": [
                [
                    81.2085818,
                    54.5293169
                ],
                [
                    81.2107012,
                    54.5337014
                ],
                [
                    81.2115306,
                    54.5369092
                ],
                [
                    81.213558,
                    54.5391545
                ],
                [
                    81.2315268,
                    54.544714
                ],
                [
                    81.2369636,
                    54.5454624
                ],
                [
                    81.2446119,
                    54.5439122
                ],
                [
                    81.2475606,
                    54.5425759
                ],
                [
                    81.2494035,
                    54.5408118
                ],
                [
                    81.2610143,
                    54.5398496
                ],
                [
                    81.2615672,
                    54.5353588
                ],
                [
                    81.2609222,
                    54.5306002
                ],
                [
                    81.2577891,
                    54.5271244
                ],
                [
                    81.2542875,
                    54.5286752
                ],
                [
                    81.2416631,
                    54.526964
                ],
                [
                    81.2402809,
                    54.5275522
                ],
                [
                    81.2326326,
                    54.524504
                ],
                [
                    81.2131892,
                    54.526857
                ],
                [
                    81.2085818,
                    54.5293169
                ]
            ],
            "longitude": 81.230156,
            "latitude": 54.536777
        },
        "3466": {
            "name": "Верх-Алеус",
            "population": 679,
            "type": "village",
            "poly": [
                [
                    81.2524908,
                    54.1747653
                ],
                [
                    81.2644232,
                    54.1839276
                ],
                [
                    81.2807467,
                    54.1819165
                ],
                [
                    81.2838969,
                    54.1763297
                ],
                [
                    81.2774057,
                    54.1695129
                ],
                [
                    81.2675734,
                    54.1671658
                ],
                [
                    81.2550682,
                    54.1704628
                ],
                [
                    81.2524908,
                    54.1747653
                ]
            ],
            "longitude": 81.268394,
            "latitude": 54.175667
        },
        "3467": {
            "name": "Кабинетное",
            "population": 1090,
            "type": "village",
            "poly": [
                [
                    81.2692933,
                    55.090233
                ],
                [
                    81.2727366,
                    55.0916849
                ],
                [
                    81.2758173,
                    55.0913393
                ],
                [
                    81.2793814,
                    55.0917195
                ],
                [
                    81.2784753,
                    55.0940356
                ],
                [
                    81.2799854,
                    55.0956256
                ],
                [
                    81.2855429,
                    55.0971119
                ],
                [
                    81.2876572,
                    55.0986673
                ],
                [
                    81.269837,
                    55.0963169
                ],
                [
                    81.269837,
                    55.0983562
                ],
                [
                    81.2824621,
                    55.100188
                ],
                [
                    81.2883821,
                    55.1001189
                ],
                [
                    81.2927313,
                    55.1002571
                ],
                [
                    81.2967787,
                    55.10278
                ],
                [
                    81.2996177,
                    55.1017087
                ],
                [
                    81.3085581,
                    55.104819
                ],
                [
                    81.3172567,
                    55.1062013
                ],
                [
                    81.3206396,
                    55.1048536
                ],
                [
                    81.3155653,
                    55.1032984
                ],
                [
                    81.3081352,
                    55.1024345
                ],
                [
                    81.3124242,
                    55.1021925
                ],
                [
                    81.3160486,
                    55.0969045
                ],
                [
                    81.3034234,
                    55.0955565
                ],
                [
                    81.3055377,
                    55.0944158
                ],
                [
                    81.3040879,
                    55.0917887
                ],
                [
                    81.3004031,
                    55.0930331
                ],
                [
                    81.3021549,
                    55.0910281
                ],
                [
                    81.3001615,
                    55.0904404
                ],
                [
                    81.3014904,
                    55.0889885
                ],
                [
                    81.2997386,
                    55.0862227
                ],
                [
                    81.3042691,
                    55.0873636
                ],
                [
                    81.3063834,
                    55.0889885
                ],
                [
                    81.307954,
                    55.0895416
                ],
                [
                    81.3072291,
                    55.0906133
                ],
                [
                    81.3094038,
                    55.0909936
                ],
                [
                    81.3127866,
                    55.0874673
                ],
                [
                    81.3054773,
                    55.0845977
                ],
                [
                    81.2968391,
                    55.0819353
                ],
                [
                    81.2944832,
                    55.0842519
                ],
                [
                    81.2909796,
                    55.0831801
                ],
                [
                    81.2840327,
                    55.0883316
                ],
                [
                    81.2804687,
                    55.0887465
                ],
                [
                    81.2789859,
                    55.0905175
                ],
                [
                    81.2769047,
                    55.0881933
                ],
                [
                    81.27473,
                    55.0878476
                ],
                [
                    81.2735823,
                    55.0884008
                ],
                [
                    81.2712264,
                    55.0880205
                ],
                [
                    81.2692933,
                    55.090233
                ]
            ],
            "longitude": 81.292206,
            "latitude": 55.097595
        },
        "3468": {
            "name": "Шайдуровский",
            "population": 489,
            "type": "village",
            "poly": [
                [
                    81.3036429,
                    54.4200106
                ],
                [
                    81.3122166,
                    54.4230372
                ],
                [
                    81.3185745,
                    54.4169838
                ],
                [
                    81.3246434,
                    54.4144053
                ],
                [
                    81.3263773,
                    54.4101447
                ],
                [
                    81.3250287,
                    54.4092477
                ],
                [
                    81.3302305,
                    54.4035848
                ],
                [
                    81.3235837,
                    54.400725
                ],
                [
                    81.3128909,
                    54.4094159
                ],
                [
                    81.3036429,
                    54.4200106
                ]
            ],
            "longitude": 81.318024,
            "latitude": 54.411098
        },
        "3469": {
            "name": "Устюжанино",
            "population": 426,
            "type": "village",
            "poly": [
                [
                    81.3100855,
                    54.1799173
                ],
                [
                    81.3135889,
                    54.185861
                ],
                [
                    81.3161551,
                    54.1870493
                ],
                [
                    81.3247206,
                    54.1873153
                ],
                [
                    81.3419386,
                    54.1834971
                ],
                [
                    81.3512443,
                    54.1838708
                ],
                [
                    81.3524303,
                    54.1834971
                ],
                [
                    81.3531601,
                    54.1822425
                ],
                [
                    81.3553041,
                    54.1825094
                ],
                [
                    81.3537987,
                    54.1865935
                ],
                [
                    81.358406,
                    54.1875011
                ],
                [
                    81.3666625,
                    54.1840577
                ],
                [
                    81.3664344,
                    54.1825628
                ],
                [
                    81.3622377,
                    54.1804539
                ],
                [
                    81.3632869,
                    54.179653
                ],
                [
                    81.3581323,
                    54.1776774
                ],
                [
                    81.3423491,
                    54.1793326
                ],
                [
                    81.3279801,
                    54.1792526
                ],
                [
                    81.3234641,
                    54.1771701
                ],
                [
                    81.3201655,
                    54.17622
                ],
                [
                    81.3100855,
                    54.1799173
                ]
            ],
            "longitude": 81.318047,
            "latitude": 54.185104
        },
        "3470": {
            "name": "Чикман",
            "population": 610,
            "type": "village",
            "poly": [
                [
                    81.3183768,
                    54.7708713
                ],
                [
                    81.3203587,
                    54.7722918
                ],
                [
                    81.3216801,
                    54.7745437
                ],
                [
                    81.3261247,
                    54.7767261
                ],
                [
                    81.3251037,
                    54.7782157
                ],
                [
                    81.3276262,
                    54.7788739
                ],
                [
                    81.3321309,
                    54.7774882
                ],
                [
                    81.3308696,
                    54.7793934
                ],
                [
                    81.3307495,
                    54.7819567
                ],
                [
                    81.3308628,
                    54.782883
                ],
                [
                    81.3317705,
                    54.7833075
                ],
                [
                    81.3339327,
                    54.7827879
                ],
                [
                    81.3358547,
                    54.7789778
                ],
                [
                    81.3368756,
                    54.7780771
                ],
                [
                    81.3387377,
                    54.7796013
                ],
                [
                    81.3402392,
                    54.7798437
                ],
                [
                    81.3418609,
                    54.7797745
                ],
                [
                    81.3430621,
                    54.778285
                ],
                [
                    81.3451642,
                    54.7787353
                ],
                [
                    81.3448039,
                    54.7792895
                ],
                [
                    81.3462454,
                    54.7797052
                ],
                [
                    81.3476268,
                    54.7793242
                ],
                [
                    81.3500892,
                    54.7777654
                ],
                [
                    81.3531524,
                    54.7736776
                ],
                [
                    81.3508701,
                    54.7732965
                ],
                [
                    81.3479872,
                    54.7742319
                ],
                [
                    81.3476268,
                    54.773539
                ],
                [
                    81.344924,
                    54.77198
                ],
                [
                    81.3437828,
                    54.7729847
                ],
                [
                    81.3433023,
                    54.7724997
                ],
                [
                    81.3463456,
                    54.7677105
                ],
                [
                    81.3457649,
                    54.764184
                ],
                [
                    81.3411401,
                    54.7635256
                ],
                [
                    81.339999,
                    54.7620355
                ],
                [
                    81.3326714,
                    54.7608226
                ],
                [
                    81.3311097,
                    54.7612731
                ],
                [
                    81.3298485,
                    54.7629018
                ],
                [
                    81.3231817,
                    54.7668868
                ],
                [
                    81.3228213,
                    54.767857
                ],
                [
                    81.3193377,
                    54.7679956
                ],
                [
                    81.3183768,
                    54.7708713
                ]
            ],
            "longitude": 81.339096,
            "latitude": 54.775677
        },
        "3471": {
            "name": "Большеникольское",
            "population": 567,
            "type": "village",
            "poly": [
                [
                    81.4503655,
                    54.6066194
                ],
                [
                    81.4552999,
                    54.6106497
                ],
                [
                    81.4604452,
                    54.6120663
                ],
                [
                    81.4656749,
                    54.6106741
                ],
                [
                    81.4682054,
                    54.6083049
                ],
                [
                    81.4730976,
                    54.6118953
                ],
                [
                    81.4819543,
                    54.613434
                ],
                [
                    81.4863845,
                    54.6063016
                ],
                [
                    81.4800142,
                    54.601465
                ],
                [
                    81.4599391,
                    54.5958457
                ],
                [
                    81.4542877,
                    54.6038347
                ],
                [
                    81.4506607,
                    54.6052027
                ],
                [
                    81.4503655,
                    54.6066194
                ]
            ],
            "longitude": 81.468613,
            "latitude": 54.602081
        },
        "3472": {
            "name": "Осиновский",
            "population": 384,
            "type": "village",
            "poly": [
                [
                    81.4637932,
                    54.8197216
                ],
                [
                    81.4640928,
                    54.8203988
                ],
                [
                    81.4673425,
                    54.8216868
                ],
                [
                    81.4694399,
                    54.8217798
                ],
                [
                    81.4694399,
                    54.8254046
                ],
                [
                    81.469482,
                    54.8260217
                ],
                [
                    81.4711799,
                    54.8263843
                ],
                [
                    81.4727127,
                    54.8266394
                ],
                [
                    81.4730815,
                    54.8263738
                ],
                [
                    81.4766078,
                    54.8269713
                ],
                [
                    81.478636,
                    54.8280069
                ],
                [
                    81.4811943,
                    54.8262809
                ],
                [
                    81.4788894,
                    54.8253382
                ],
                [
                    81.4767922,
                    54.8264402
                ],
                [
                    81.4787743,
                    54.8239308
                ],
                [
                    81.4818626,
                    54.8220586
                ],
                [
                    81.482024,
                    54.8212619
                ],
                [
                    81.4818166,
                    54.8201067
                ],
                [
                    81.4826001,
                    54.8198278
                ],
                [
                    81.482946,
                    54.8198809
                ],
                [
                    81.4849281,
                    54.8189381
                ],
                [
                    81.4861496,
                    54.81765
                ],
                [
                    81.4846515,
                    54.8171454
                ],
                [
                    81.4856195,
                    54.816229
                ],
                [
                    81.4835681,
                    54.8158439
                ],
                [
                    81.4826463,
                    54.8145291
                ],
                [
                    81.4802493,
                    54.8148346
                ],
                [
                    81.4781749,
                    54.8147151
                ],
                [
                    81.4762851,
                    54.8147815
                ],
                [
                    81.4751327,
                    54.8145291
                ],
                [
                    81.4738651,
                    54.8139049
                ],
                [
                    81.4725053,
                    54.8135065
                ],
                [
                    81.4700108,
                    54.8143461
                ],
                [
                    81.4697165,
                    54.8144893
                ],
                [
                    81.469002,
                    54.8182609
                ],
                [
                    81.4663284,
                    54.8183007
                ],
                [
                    81.466628,
                    54.8196021
                ],
                [
                    81.4649686,
                    54.8188452
                ],
                [
                    81.4645537,
                    54.8192834
                ],
                [
                    81.4644615,
                    54.8195224
                ],
                [
                    81.4637932,
                    54.8197216
                ]
            ],
            "longitude": 81.477379,
            "latitude": 54.821667
        },
        "3473": {
            "name": "Филиппово",
            "population": 799,
            "type": "village",
            "poly": [
                [
                    81.5044084,
                    54.323605
                ],
                [
                    81.5129435,
                    54.3255634
                ],
                [
                    81.5177941,
                    54.3216737
                ],
                [
                    81.5409275,
                    54.3282833
                ],
                [
                    81.5444721,
                    54.3244211
                ],
                [
                    81.5360303,
                    54.3210753
                ],
                [
                    81.5371963,
                    54.3201504
                ],
                [
                    81.5358904,
                    54.3182189
                ],
                [
                    81.5320659,
                    54.3168315
                ],
                [
                    81.5287545,
                    54.3153624
                ],
                [
                    81.5253964,
                    54.3147366
                ],
                [
                    81.5244169,
                    54.3154984
                ],
                [
                    81.51327,
                    54.3087508
                ],
                [
                    81.5105649,
                    54.3096487
                ],
                [
                    81.5102384,
                    54.3153352
                ],
                [
                    81.5121506,
                    54.318355
                ],
                [
                    81.512104,
                    54.3208577
                ],
                [
                    81.5071602,
                    54.3206945
                ],
                [
                    81.5044084,
                    54.323605
                ]
            ],
            "longitude": 81.523811,
            "latitude": 54.319366
        },
        "3474": {
            "name": "Пенек",
            "population": 251,
            "type": "village",
            "poly": [
                [
                    81.5405272,
                    55.4936299
                ],
                [
                    81.5417202,
                    55.4943057
                ],
                [
                    81.5447025,
                    55.49449
                ],
                [
                    81.5423709,
                    55.4963022
                ],
                [
                    81.5451905,
                    55.4979915
                ],
                [
                    81.5477933,
                    55.4967629
                ],
                [
                    81.5509925,
                    55.4978072
                ],
                [
                    81.5521854,
                    55.4987594
                ],
                [
                    81.5521854,
                    55.5000493
                ],
                [
                    81.5534866,
                    55.5004178
                ],
                [
                    81.5558726,
                    55.50008
                ],
                [
                    81.5557641,
                    55.5011856
                ],
                [
                    81.5563606,
                    55.5016463
                ],
                [
                    81.5559268,
                    55.5031204
                ],
                [
                    81.5593429,
                    55.5062834
                ],
                [
                    81.5512636,
                    55.50874
                ],
                [
                    81.5507213,
                    55.5098761
                ],
                [
                    81.5522395,
                    55.5107665
                ],
                [
                    81.5563606,
                    55.5112578
                ],
                [
                    81.5627589,
                    55.5145736
                ],
                [
                    81.5668257,
                    55.5129464
                ],
                [
                    81.5626505,
                    55.5080951
                ],
                [
                    81.5628131,
                    55.5064677
                ],
                [
                    81.5655243,
                    55.5072968
                ],
                [
                    81.570296,
                    55.5053315
                ],
                [
                    81.5734952,
                    55.5034889
                ],
                [
                    81.5726276,
                    55.5025369
                ],
                [
                    81.573441,
                    55.5018613
                ],
                [
                    81.574905,
                    55.5021377
                ],
                [
                    81.5759352,
                    55.5013392
                ],
                [
                    81.575176,
                    55.5007864
                ],
                [
                    81.5755557,
                    55.4994043
                ],
                [
                    81.5673678,
                    55.4960872
                ],
                [
                    81.5654701,
                    55.4966401
                ],
                [
                    81.563735,
                    55.49578
                ],
                [
                    81.5654701,
                    55.4945821
                ],
                [
                    81.5644941,
                    55.4931077
                ],
                [
                    81.5634096,
                    55.4923397
                ],
                [
                    81.5624336,
                    55.4924319
                ],
                [
                    81.5603189,
                    55.4930462
                ],
                [
                    81.5582584,
                    55.4921554
                ],
                [
                    81.5567401,
                    55.4923704
                ],
                [
                    81.5554388,
                    55.4920018
                ],
                [
                    81.5564148,
                    55.4909574
                ],
                [
                    81.5571197,
                    55.491326
                ],
                [
                    81.5608069,
                    55.4912338
                ],
                [
                    81.5607527,
                    55.4908959
                ],
                [
                    81.558909,
                    55.4905273
                ],
                [
                    81.5619998,
                    55.4888684
                ],
                [
                    81.5641145,
                    55.4877317
                ],
                [
                    81.5606442,
                    55.4866257
                ],
                [
                    81.5590718,
                    55.4869022
                ],
                [
                    81.5585837,
                    55.4865028
                ],
                [
                    81.5588006,
                    55.4861341
                ],
                [
                    81.5571739,
                    55.484475
                ],
                [
                    81.5553846,
                    55.485028
                ],
                [
                    81.5541374,
                    55.4870558
                ],
                [
                    81.5533783,
                    55.4867793
                ],
                [
                    81.5508298,
                    55.487701
                ],
                [
                    81.5475222,
                    55.4871787
                ],
                [
                    81.5475222,
                    55.4877317
                ],
                [
                    81.5505044,
                    55.4890527
                ],
                [
                    81.5496911,
                    55.4898207
                ],
                [
                    81.5405272,
                    55.4936299
                ]
            ],
            "longitude": 81.559555,
            "latitude": 55.497463
        },
        "3475": {
            "name": "Спирино",
            "population": 577,
            "type": "village",
            "poly": [
                [
                    81.5321524,
                    54.1237197
                ],
                [
                    81.5343409,
                    54.126538
                ],
                [
                    81.5420836,
                    54.1295254
                ],
                [
                    81.5427208,
                    54.1304402
                ],
                [
                    81.5447919,
                    54.1311123
                ],
                [
                    81.5433581,
                    54.1338006
                ],
                [
                    81.5442821,
                    54.1340806
                ],
                [
                    81.5492845,
                    54.1347527
                ],
                [
                    81.5523434,
                    54.1345473
                ],
                [
                    81.5579194,
                    54.1358167
                ],
                [
                    81.5555616,
                    54.1393447
                ],
                [
                    81.5603728,
                    54.140502
                ],
                [
                    81.5719072,
                    54.1448134
                ],
                [
                    81.5727675,
                    54.1437869
                ],
                [
                    81.5740101,
                    54.1429097
                ],
                [
                    81.5782387,
                    54.1455984
                ],
                [
                    81.57987,
                    54.1449266
                ],
                [
                    81.5817564,
                    54.1462703
                ],
                [
                    81.5877211,
                    54.148674
                ],
                [
                    81.5917994,
                    54.1439561
                ],
                [
                    81.5924368,
                    54.1430751
                ],
                [
                    81.5867525,
                    54.1416118
                ],
                [
                    81.5863446,
                    54.1427466
                ],
                [
                    81.5839995,
                    54.1425376
                ],
                [
                    81.5830054,
                    54.1416417
                ],
                [
                    81.5836426,
                    54.14091
                ],
                [
                    81.5786466,
                    54.1400888
                ],
                [
                    81.5726054,
                    54.1377891
                ],
                [
                    81.5686799,
                    54.1368782
                ],
                [
                    81.5632504,
                    54.1342648
                ],
                [
                    81.5619758,
                    54.1341602
                ],
                [
                    81.5569797,
                    54.1316512
                ],
                [
                    81.557974,
                    54.130994
                ],
                [
                    81.5566994,
                    54.1302472
                ],
                [
                    81.5540484,
                    54.1303219
                ],
                [
                    81.5528504,
                    54.1297244
                ],
                [
                    81.5524426,
                    54.1286938
                ],
                [
                    81.5530798,
                    54.1283503
                ],
                [
                    81.5500464,
                    54.1272151
                ],
                [
                    81.539468,
                    54.1247355
                ],
                [
                    81.5366131,
                    54.1236301
                ],
                [
                    81.5332994,
                    54.1223603
                ],
                [
                    81.5321524,
                    54.1237197
                ]
            ],
            "longitude": 81.561874,
            "latitude": 54.135445
        },
        "3476": {
            "name": "Рогалёво",
            "population": 677,
            "type": "village",
            "poly": [
                [
                    [
                        81.5785893,
                        54.3518692
                    ],
                    [
                        81.581367,
                        54.3524775
                    ],
                    [
                        81.5878819,
                        54.3546752
                    ],
                    [
                        81.5923432,
                        54.3579616
                    ],
                    [
                        81.5991444,
                        54.3563822
                    ],
                    [
                        81.5986956,
                        54.3544894
                    ],
                    [
                        81.5981302,
                        54.3531505
                    ],
                    [
                        81.6010884,
                        54.3519156
                    ],
                    [
                        81.6033887,
                        54.3510268
                    ],
                    [
                        81.6007222,
                        54.3491813
                    ],
                    [
                        81.6015198,
                        54.3476254
                    ],
                    [
                        81.5969606,
                        54.3465395
                    ],
                    [
                        81.594556,
                        54.3464528
                    ],
                    [
                        81.5851133,
                        54.3442328
                    ],
                    [
                        81.584399,
                        54.3455732
                    ],
                    [
                        81.5855656,
                        54.3459063
                    ],
                    [
                        81.5850418,
                        54.3474258
                    ],
                    [
                        81.5842121,
                        54.3489748
                    ],
                    [
                        81.5798855,
                        54.3484057
                    ],
                    [
                        81.5785893,
                        54.3518692
                    ]
                ],
                [
                    [
                        81.5754119,
                        54.3389405
                    ],
                    [
                        81.5807711,
                        54.3402134
                    ],
                    [
                        81.580426,
                        54.3408415
                    ],
                    [
                        81.582261,
                        54.3414206
                    ],
                    [
                        81.5817812,
                        54.3418818
                    ],
                    [
                        81.5826864,
                        54.342161
                    ],
                    [
                        81.5851089,
                        54.3427404
                    ],
                    [
                        81.585966,
                        54.3432088
                    ],
                    [
                        81.5874956,
                        54.34358
                    ],
                    [
                        81.5931619,
                        54.3444023
                    ],
                    [
                        81.5939415,
                        54.3440866
                    ],
                    [
                        81.5963045,
                        54.3441456
                    ],
                    [
                        81.5984948,
                        54.3444266
                    ],
                    [
                        81.5979725,
                        54.3452344
                    ],
                    [
                        81.5985828,
                        54.345308
                    ],
                    [
                        81.5995297,
                        54.3451779
                    ],
                    [
                        81.6002241,
                        54.3451338
                    ],
                    [
                        81.6007965,
                        54.3451608
                    ],
                    [
                        81.6012846,
                        54.3453693
                    ],
                    [
                        81.6017224,
                        54.3456612
                    ],
                    [
                        81.603029,
                        54.3460343
                    ],
                    [
                        81.6059917,
                        54.3464855
                    ],
                    [
                        81.6063916,
                        54.3460341
                    ],
                    [
                        81.6140996,
                        54.3464001
                    ],
                    [
                        81.6144209,
                        54.3447903
                    ],
                    [
                        81.6038147,
                        54.3434997
                    ],
                    [
                        81.6045764,
                        54.3424866
                    ],
                    [
                        81.6016839,
                        54.3417718
                    ],
                    [
                        81.6030052,
                        54.3397385
                    ],
                    [
                        81.5985769,
                        54.3384755
                    ],
                    [
                        81.5924464,
                        54.3371152
                    ],
                    [
                        81.5916249,
                        54.339343
                    ],
                    [
                        81.5883634,
                        54.3384755
                    ],
                    [
                        81.5809829,
                        54.3365531
                    ],
                    [
                        81.5768285,
                        54.3358035
                    ],
                    [
                        81.5760229,
                        54.3375875
                    ],
                    [
                        81.5754119,
                        54.3389405
                    ]
                ]
            ],
            "longitude": 81.591957,
            "latitude": 54.342033
        },
        "3477": {
            "name": "Чингис",
            "population": 540,
            "type": "village",
            "poly": [
                [
                    81.5809574,
                    54.1235315
                ],
                [
                    81.600131,
                    54.1309059
                ],
                [
                    81.6059384,
                    54.1316795
                ],
                [
                    81.6030163,
                    54.1278992
                ],
                [
                    81.6133305,
                    54.1239727
                ],
                [
                    81.6189394,
                    54.128583
                ],
                [
                    81.6240588,
                    54.1310093
                ],
                [
                    81.6265809,
                    54.1320459
                ],
                [
                    81.629216,
                    54.1328179
                ],
                [
                    81.6325757,
                    54.1338015
                ],
                [
                    81.6343354,
                    54.1325973
                ],
                [
                    81.6305335,
                    54.1298623
                ],
                [
                    81.6415253,
                    54.1286492
                ],
                [
                    81.6411488,
                    54.1265536
                ],
                [
                    81.6290654,
                    54.1272595
                ],
                [
                    81.6268444,
                    54.1256713
                ],
                [
                    81.6307593,
                    54.1225829
                ],
                [
                    81.6253387,
                    54.1202443
                ],
                [
                    81.6210097,
                    54.1210386
                ],
                [
                    81.6143845,
                    54.1213474
                ],
                [
                    81.6091521,
                    54.1185014
                ],
                [
                    81.6082758,
                    54.1198509
                ],
                [
                    81.6128412,
                    54.1232226
                ],
                [
                    81.6019999,
                    54.1271713
                ],
                [
                    81.6024516,
                    54.1260022
                ],
                [
                    81.5997037,
                    54.1242153
                ],
                [
                    81.5958264,
                    54.1227814
                ],
                [
                    81.5834418,
                    54.1211489
                ],
                [
                    81.5809574,
                    54.1235315
                ]
            ],
            "longitude": 81.622541,
            "latitude": 54.1259518
        },
        "3478": {
            "name": "Дупленская",
            "population": 1025,
            "type": "village",
            "poly": null,
            "longitude": 81.623779,
            "latitude": 55.090389
        },
        "3479": {
            "name": "Кирза",
            "population": 1697,
            "type": "village",
            "poly": null,
            "longitude": 81.654251,
            "latitude": 54.240887
        },
        "3480": {
            "name": "Овчинниково",
            "population": 502,
            "type": "village",
            "poly": null,
            "longitude": 81.684494,
            "latitude": 55.197777
        },
        "3481": {
            "name": "Сушиха",
            "population": 359,
            "type": "village",
            "poly": [
                [
                    81.7011456,
                    54.3785068
                ],
                [
                    81.701341,
                    54.3789541
                ],
                [
                    81.7032192,
                    54.3810686
                ],
                [
                    81.7025071,
                    54.3814142
                ],
                [
                    81.7034706,
                    54.3825121
                ],
                [
                    81.7058025,
                    54.3832521
                ],
                [
                    81.7070523,
                    54.3826829
                ],
                [
                    81.7082462,
                    54.3828658
                ],
                [
                    81.7191797,
                    54.3847731
                ],
                [
                    81.7214698,
                    54.3862205
                ],
                [
                    81.7257846,
                    54.3877573
                ],
                [
                    81.7353916,
                    54.3890908
                ],
                [
                    81.736439,
                    54.3904323
                ],
                [
                    81.7354196,
                    54.3918307
                ],
                [
                    81.7355592,
                    54.3930909
                ],
                [
                    81.7368579,
                    54.3933186
                ],
                [
                    81.7405443,
                    54.3957493
                ],
                [
                    81.743756,
                    54.3974646
                ],
                [
                    81.746814,
                    54.3960664
                ],
                [
                    81.7455433,
                    54.3949201
                ],
                [
                    81.7472888,
                    54.3938633
                ],
                [
                    81.7534887,
                    54.3959201
                ],
                [
                    81.7546756,
                    54.3955055
                ],
                [
                    81.7563373,
                    54.394351
                ],
                [
                    81.7573288,
                    54.3923186
                ],
                [
                    81.7577616,
                    54.389668
                ],
                [
                    81.7584459,
                    54.3880337
                ],
                [
                    81.7586414,
                    54.386253
                ],
                [
                    81.7569378,
                    54.3858952
                ],
                [
                    81.7530558,
                    54.3848137
                ],
                [
                    81.7513383,
                    54.3846186
                ],
                [
                    81.748378,
                    54.3850008
                ],
                [
                    81.7467582,
                    54.3853586
                ],
                [
                    81.7453758,
                    54.3853423
                ],
                [
                    81.7443006,
                    54.38483
                ],
                [
                    81.7404186,
                    54.3837729
                ],
                [
                    81.7325989,
                    54.3817236
                ],
                [
                    81.7323476,
                    54.3803818
                ],
                [
                    81.7284098,
                    54.3795441
                ],
                [
                    81.7249468,
                    54.3786007
                ],
                [
                    81.7195567,
                    54.3773482
                ],
                [
                    81.7142086,
                    54.3752335
                ],
                [
                    81.7123794,
                    54.3756158
                ],
                [
                    81.7106758,
                    54.3764942
                ],
                [
                    81.70826,
                    54.3773075
                ],
                [
                    81.7061655,
                    54.3780721
                ],
                [
                    81.7046295,
                    54.3780964
                ],
                [
                    81.7031353,
                    54.3773645
                ],
                [
                    81.7015993,
                    54.3780395
                ],
                [
                    81.7011456,
                    54.3785068
                ]
            ],
            "longitude": 81.713242,
            "latitude": 54.379593
        },
        "3482": {
            "name": "Усть-Луковка",
            "population": 805,
            "type": "village",
            "poly": [
                [
                    81.7196912,
                    54.3849372
                ],
                [
                    81.7214698,
                    54.3862205
                ],
                [
                    81.7257846,
                    54.3877573
                ],
                [
                    81.7353916,
                    54.3890908
                ],
                [
                    81.736439,
                    54.3904323
                ],
                [
                    81.7354196,
                    54.3918307
                ],
                [
                    81.7355592,
                    54.3930909
                ],
                [
                    81.7368579,
                    54.3933186
                ],
                [
                    81.7405443,
                    54.3957493
                ],
                [
                    81.743756,
                    54.3974646
                ],
                [
                    81.746814,
                    54.3960664
                ],
                [
                    81.7455433,
                    54.3949201
                ],
                [
                    81.7472888,
                    54.3938633
                ],
                [
                    81.7534887,
                    54.3959201
                ],
                [
                    81.7546756,
                    54.3955055
                ],
                [
                    81.7563373,
                    54.394351
                ],
                [
                    81.7573288,
                    54.3923186
                ],
                [
                    81.7577616,
                    54.389668
                ],
                [
                    81.7584459,
                    54.3880337
                ],
                [
                    81.7586414,
                    54.386253
                ],
                [
                    81.7569378,
                    54.3858952
                ],
                [
                    81.7530558,
                    54.3848137
                ],
                [
                    81.7513383,
                    54.3846186
                ],
                [
                    81.748378,
                    54.3850008
                ],
                [
                    81.7467582,
                    54.3853586
                ],
                [
                    81.7453758,
                    54.3853423
                ],
                [
                    81.7443006,
                    54.38483
                ],
                [
                    81.7404186,
                    54.3837729
                ],
                [
                    81.7325989,
                    54.3817236
                ],
                [
                    81.7323476,
                    54.3803818
                ],
                [
                    81.7284098,
                    54.3795441
                ],
                [
                    81.7258654,
                    54.3789655
                ],
                [
                    81.7241855,
                    54.3805922
                ],
                [
                    81.7233545,
                    54.381494
                ],
                [
                    81.7231925,
                    54.3817406
                ],
                [
                    81.723163,
                    54.3819469
                ],
                [
                    81.7233512,
                    54.3822521
                ],
                [
                    81.7234103,
                    54.3824241
                ],
                [
                    81.7227879,
                    54.3831061
                ],
                [
                    81.7224761,
                    54.3832466
                ],
                [
                    81.7212182,
                    54.3835475
                ],
                [
                    81.7201487,
                    54.3844542
                ],
                [
                    81.7196912,
                    54.3849372
                ]
            ],
            "longitude": 81.731529,
            "latitude": 54.385818
        },
        "3483": {
            "name": "Петровский",
            "population": 1251,
            "type": "village",
            "poly": [
                [
                    81.7280412,
                    54.5275687
                ],
                [
                    81.7310137,
                    54.531875
                ],
                [
                    81.7339736,
                    54.534824
                ],
                [
                    81.7443639,
                    54.5379547
                ],
                [
                    81.7542735,
                    54.5384842
                ],
                [
                    81.7644438,
                    54.5217631
                ],
                [
                    81.7542735,
                    54.5136648
                ],
                [
                    81.7280412,
                    54.5275687
                ]
            ],
            "longitude": 81.748001,
            "latitude": 54.524258
        },
        "3484": {
            "name": "Усть-Хмелёвка",
            "population": 290,
            "type": "village",
            "poly": [
                [
                    81.7570158,
                    54.2668132
                ],
                [
                    81.7587475,
                    54.2690262
                ],
                [
                    81.76058,
                    54.2707454
                ],
                [
                    81.7631098,
                    54.2722929
                ],
                [
                    81.7657899,
                    54.2735421
                ],
                [
                    81.7702424,
                    54.2758537
                ],
                [
                    81.7743365,
                    54.2776114
                ],
                [
                    81.7806107,
                    54.2771817
                ],
                [
                    81.7835676,
                    54.27426
                ],
                [
                    81.7872561,
                    54.2732589
                ],
                [
                    81.7856897,
                    54.2709697
                ],
                [
                    81.7800528,
                    54.2678783
                ],
                [
                    81.7750811,
                    54.2649986
                ],
                [
                    81.770876,
                    54.2629397
                ],
                [
                    81.7698926,
                    54.2624582
                ],
                [
                    81.766189,
                    54.262739
                ],
                [
                    81.7612537,
                    54.2649672
                ],
                [
                    81.7570158,
                    54.2668132
                ]
            ],
            "longitude": 81.773415,
            "latitude": 54.271305
        },
        "3485": {
            "name": "Шайдурово",
            "population": 1050,
            "type": "village",
            "poly": [
                [
                    81.7714729,
                    54.008462
                ],
                [
                    81.7745595,
                    54.0112449
                ],
                [
                    81.7760817,
                    54.0140028
                ],
                [
                    81.778069,
                    54.0150959
                ],
                [
                    81.7861028,
                    54.0184249
                ],
                [
                    81.7905848,
                    54.0167853
                ],
                [
                    81.793756,
                    54.016835
                ],
                [
                    81.799126,
                    54.0156674
                ],
                [
                    81.8052993,
                    54.0132823
                ],
                [
                    81.8090202,
                    54.0111952
                ],
                [
                    81.8108384,
                    54.0097789
                ],
                [
                    81.8106406,
                    54.0088905
                ],
                [
                    81.8066946,
                    54.0056292
                ],
                [
                    81.8027623,
                    54.0056789
                ],
                [
                    81.7986609,
                    54.0064492
                ],
                [
                    81.794052,
                    54.0088844
                ],
                [
                    81.7932486,
                    54.0100522
                ],
                [
                    81.7883015,
                    54.0084371
                ],
                [
                    81.7868639,
                    54.0077911
                ],
                [
                    81.7851303,
                    54.0057037
                ],
                [
                    81.7833121,
                    54.0045855
                ],
                [
                    81.7798872,
                    54.0035914
                ],
                [
                    81.7783227,
                    54.0044115
                ],
                [
                    81.778957,
                    54.0049582
                ],
                [
                    81.7729105,
                    54.0072195
                ],
                [
                    81.7714729,
                    54.008462
                ]
            ],
            "longitude": 81.797646,
            "latitude": 54.011723
        },
        "3486": {
            "name": "Тараданово",
            "population": 221,
            "type": "village",
            "poly": [
                [
                    81.8392874,
                    53.7691124
                ],
                [
                    81.8393236,
                    53.7700966
                ],
                [
                    81.8443551,
                    53.7742682
                ],
                [
                    81.8465269,
                    53.7736906
                ],
                [
                    81.8471785,
                    53.7727921
                ],
                [
                    81.8489522,
                    53.769797
                ],
                [
                    81.8504725,
                    53.7702249
                ],
                [
                    81.8543457,
                    53.7700752
                ],
                [
                    81.8545628,
                    53.7670799
                ],
                [
                    81.8524988,
                    53.7659887
                ],
                [
                    81.851667,
                    53.764598
                ],
                [
                    81.8497485,
                    53.7645124
                ],
                [
                    81.8463097,
                    53.7652399
                ],
                [
                    81.8434501,
                    53.7665664
                ],
                [
                    81.8404095,
                    53.765839
                ],
                [
                    81.8392874,
                    53.7691124
                ]
            ],
            "longitude": 81.845871,
            "latitude": 53.769127
        },
        "3487": {
            "name": "Вагайцево",
            "population": 2067,
            "type": "village",
            "poly": [
                [
                    81.8374624,
                    54.3690304
                ],
                [
                    81.8408268,
                    54.3691341
                ],
                [
                    81.8588916,
                    54.3703553
                ],
                [
                    81.8625311,
                    54.3709721
                ],
                [
                    81.8704058,
                    54.3741137
                ],
                [
                    81.8741777,
                    54.3719936
                ],
                [
                    81.8710686,
                    54.3589667
                ],
                [
                    81.849542,
                    54.36279
                ],
                [
                    81.8374624,
                    54.3690304
                ]
            ],
            "longitude": 81.862457,
            "latitude": 54.364994
        },
        "3488": {
            "name": "Малоирменка",
            "population": 301,
            "type": "village",
            "poly": [
                [
                    81.879998,
                    54.5386116
                ],
                [
                    81.8822342,
                    54.5436741
                ],
                [
                    81.8943423,
                    54.5416175
                ],
                [
                    81.907214,
                    54.5352258
                ],
                [
                    81.8966876,
                    54.5319346
                ],
                [
                    81.879998,
                    54.5386116
                ]
            ],
            "longitude": 81.893097,
            "latitude": 54.537918
        },
        "3489": {
            "name": "Федосиха",
            "population": 672,
            "type": "village",
            "poly": [
                [
                    81.8767806,
                    54.7822532
                ],
                [
                    81.8782496,
                    54.7853593
                ],
                [
                    81.8933205,
                    54.793892
                ],
                [
                    81.9111661,
                    54.7896886
                ],
                [
                    81.9133423,
                    54.7853907
                ],
                [
                    81.9011551,
                    54.7817198
                ],
                [
                    81.8958776,
                    54.7820022
                ],
                [
                    81.8919602,
                    54.7808413
                ],
                [
                    81.8834727,
                    54.7786762
                ],
                [
                    81.8793922,
                    54.7789586
                ],
                [
                    81.8767806,
                    54.7822532
                ]
            ],
            "longitude": 81.894478,
            "latitude": 54.786552
        },
        "3490": {
            "name": "Ключики",
            "population": 810,
            "type": "village",
            "poly": [
                [
                    81.8859462,
                    53.9045669
                ],
                [
                    81.8922915,
                    53.906869
                ],
                [
                    81.8927171,
                    53.906208
                ],
                [
                    81.8947677,
                    53.9067322
                ],
                [
                    81.8953867,
                    53.9060484
                ],
                [
                    81.8974373,
                    53.9065499
                ],
                [
                    81.8985206,
                    53.9058433
                ],
                [
                    81.8996427,
                    53.9061168
                ],
                [
                    81.9007647,
                    53.9049771
                ],
                [
                    81.9015385,
                    53.9029029
                ],
                [
                    81.9047498,
                    53.9008285
                ],
                [
                    81.9108241,
                    53.9011477
                ],
                [
                    81.9146159,
                    53.9001218
                ],
                [
                    81.9144305,
                    53.8990093
                ],
                [
                    81.9120236,
                    53.896953
                ],
                [
                    81.9034343,
                    53.893442
                ],
                [
                    81.8978242,
                    53.8959955
                ],
                [
                    81.8961218,
                    53.8973862
                ],
                [
                    81.8944195,
                    53.8992784
                ],
                [
                    81.8930653,
                    53.8992784
                ],
                [
                    81.8894671,
                    53.901558
                ],
                [
                    81.8867587,
                    53.9034727
                ],
                [
                    81.8859462,
                    53.9045669
                ]
            ],
            "longitude": 81.899345,
            "latitude": 53.899864
        },
        "3491": {
            "name": "Нижнекаменка",
            "population": 1085,
            "type": "village",
            "poly": [
                [
                    81.893983,
                    54.3114294
                ],
                [
                    81.8941023,
                    54.3139822
                ],
                [
                    81.9039009,
                    54.3180486
                ],
                [
                    81.9111644,
                    54.3201242
                ],
                [
                    81.9133581,
                    54.3219439
                ],
                [
                    81.919793,
                    54.3233086
                ],
                [
                    81.927229,
                    54.3235277
                ],
                [
                    81.9283771,
                    54.3231637
                ],
                [
                    81.9303489,
                    54.3216644
                ],
                [
                    81.932315,
                    54.3243685
                ],
                [
                    81.9380142,
                    54.325725
                ],
                [
                    81.9419581,
                    54.3263707
                ],
                [
                    81.9452068,
                    54.3267085
                ],
                [
                    81.9458934,
                    54.3251268
                ],
                [
                    81.940117,
                    54.3220683
                ],
                [
                    81.9294182,
                    54.3188945
                ],
                [
                    81.9239594,
                    54.316957
                ],
                [
                    81.9180585,
                    54.315072
                ],
                [
                    81.9141752,
                    54.3141959
                ],
                [
                    81.9153732,
                    54.3132349
                ],
                [
                    81.9091334,
                    54.3106285
                ],
                [
                    81.9108306,
                    54.308852
                ],
                [
                    81.9080851,
                    54.3082259
                ],
                [
                    81.9040167,
                    54.3076288
                ],
                [
                    81.9009966,
                    54.3086336
                ],
                [
                    81.8982511,
                    54.3091724
                ],
                [
                    81.893983,
                    54.3114294
                ]
            ],
            "longitude": 81.907921,
            "latitude": 54.314812
        },
        "3492": {
            "name": "Каргаполово",
            "population": 606,
            "type": "village",
            "poly": [
                [
                    81.9192353,
                    53.7509667
                ],
                [
                    81.9229456,
                    53.7528127
                ],
                [
                    81.9253437,
                    53.7544982
                ],
                [
                    81.9313616,
                    53.7555682
                ],
                [
                    81.9361578,
                    53.7568523
                ],
                [
                    81.9403205,
                    53.7551135
                ],
                [
                    81.9432164,
                    53.7529732
                ],
                [
                    81.9468361,
                    53.7472744
                ],
                [
                    81.9460217,
                    53.7462844
                ],
                [
                    81.9449358,
                    53.7458295
                ],
                [
                    81.940954,
                    53.7454549
                ],
                [
                    81.9345741,
                    53.7464182
                ],
                [
                    81.9293255,
                    53.7474617
                ],
                [
                    81.924846,
                    53.7473814
                ],
                [
                    81.9193711,
                    53.7500303
                ],
                [
                    81.9192353,
                    53.7509667
                ]
            ],
            "longitude": 81.936028,
            "latitude": 53.752834
        },
        "3493": {
            "name": "Лесная Поляна",
            "population": 961,
            "type": "village",
            "poly": [
                [
                    81.9196119,
                    55.0436858
                ],
                [
                    81.9197001,
                    55.0457278
                ],
                [
                    81.9196133,
                    55.0466843
                ],
                [
                    81.9200795,
                    55.0480569
                ],
                [
                    81.921401,
                    55.0478662
                ],
                [
                    81.9214676,
                    55.0480443
                ],
                [
                    81.921557,
                    55.0488722
                ],
                [
                    81.9225327,
                    55.0506856
                ],
                [
                    81.9236492,
                    55.050462
                ],
                [
                    81.9246792,
                    55.0518842
                ],
                [
                    81.9298613,
                    55.0518594
                ],
                [
                    81.9311947,
                    55.053654
                ],
                [
                    81.9373875,
                    55.0517793
                ],
                [
                    81.9390246,
                    55.052127
                ],
                [
                    81.9404881,
                    55.04991
                ],
                [
                    81.940152,
                    55.0494131
                ],
                [
                    81.9421793,
                    55.048761
                ],
                [
                    81.9429599,
                    55.0497982
                ],
                [
                    81.9535083,
                    55.0478667
                ],
                [
                    81.9538227,
                    55.0474692
                ],
                [
                    81.9539311,
                    55.0455873
                ],
                [
                    81.9534107,
                    55.0445686
                ],
                [
                    81.9551778,
                    55.0443636
                ],
                [
                    81.9547225,
                    55.0431462
                ],
                [
                    81.9479034,
                    55.0440469
                ],
                [
                    81.9475889,
                    55.0430903
                ],
                [
                    81.9481419,
                    55.0428108
                ],
                [
                    81.9449113,
                    55.039065
                ],
                [
                    81.944636,
                    55.0383824
                ],
                [
                    81.942832,
                    55.0381687
                ],
                [
                    81.9425805,
                    55.0385911
                ],
                [
                    81.9411408,
                    55.0389638
                ],
                [
                    81.9406196,
                    55.0378631
                ],
                [
                    81.9404753,
                    55.0362886
                ],
                [
                    81.9407459,
                    55.0354242
                ],
                [
                    81.9370617,
                    55.0351499
                ],
                [
                    81.9281945,
                    55.0359013
                ],
                [
                    81.9291035,
                    55.0382829
                ],
                [
                    81.9250792,
                    55.0387521
                ],
                [
                    81.925877,
                    55.0401595
                ],
                [
                    81.9306854,
                    55.0398613
                ],
                [
                    81.9334538,
                    55.0422347
                ],
                [
                    81.9319759,
                    55.0430298
                ],
                [
                    81.929721,
                    55.0415629
                ],
                [
                    81.9250723,
                    55.0430974
                ],
                [
                    81.9234141,
                    55.0433439
                ],
                [
                    81.9235875,
                    55.0440793
                ],
                [
                    81.9220333,
                    55.0440793
                ],
                [
                    81.9214575,
                    55.0433677
                ],
                [
                    81.9196119,
                    55.0436858
                ]
            ],
            "longitude": 81.940422,
            "latitude": 55.042
        },
        "3494": {
            "name": "Чернаково",
            "population": 1286,
            "type": "village",
            "poly": [
                [
                    81.9219215,
                    54.3747582
                ],
                [
                    81.939288,
                    54.3863219
                ],
                [
                    81.9450036,
                    54.3860074
                ],
                [
                    81.9452447,
                    54.3839801
                ],
                [
                    81.9440368,
                    54.3826962
                ],
                [
                    81.94651,
                    54.3765103
                ],
                [
                    81.9465062,
                    54.3706209
                ],
                [
                    81.9506308,
                    54.3666733
                ],
                [
                    81.9585364,
                    54.3666161
                ],
                [
                    81.958928,
                    54.3651171
                ],
                [
                    81.9543422,
                    54.3654171
                ],
                [
                    81.9527654,
                    54.3634765
                ],
                [
                    81.9484855,
                    54.364564
                ],
                [
                    81.9488877,
                    54.3656983
                ],
                [
                    81.9421459,
                    54.3667388
                ],
                [
                    81.9388069,
                    54.3708581
                ],
                [
                    81.939015,
                    54.3726488
                ],
                [
                    81.9343327,
                    54.3755566
                ],
                [
                    81.9286498,
                    54.3721349
                ],
                [
                    81.9219215,
                    54.3747582
                ]
            ],
            "longitude": 81.940468,
            "latitude": 54.377594
        },
        "3495": {
            "name": "Верх-Чик",
            "population": 650,
            "type": "village",
            "poly": [
                [
                    81.9208655,
                    54.6422459
                ],
                [
                    81.9317738,
                    54.6476702
                ],
                [
                    81.93612,
                    54.6526008
                ],
                [
                    81.9364609,
                    54.6591082
                ],
                [
                    81.9390175,
                    54.6633966
                ],
                [
                    81.9460337,
                    54.6619212
                ],
                [
                    81.9454116,
                    54.6601808
                ],
                [
                    81.945215,
                    54.6592748
                ],
                [
                    81.9453657,
                    54.6582719
                ],
                [
                    81.9482443,
                    54.6551324
                ],
                [
                    81.9498015,
                    54.653919
                ],
                [
                    81.959089,
                    54.6534632
                ],
                [
                    81.9556099,
                    54.6498483
                ],
                [
                    81.9564096,
                    54.6492328
                ],
                [
                    81.9469308,
                    54.6417828
                ],
                [
                    81.935787,
                    54.6365909
                ],
                [
                    81.9208655,
                    54.6422459
                ]
            ],
            "longitude": 81.942657,
            "latitude": 54.649696
        },
        "3496": {
            "name": "Новомихайловка",
            "population": 1147,
            "type": "village",
            "poly": null,
            "longitude": 81.954414,
            "latitude": 55.205528
        },
        "3497": {
            "name": "Целинное",
            "population": 736,
            "type": "village",
            "poly": [
                [
                    81.9857931,
                    54.8050098
                ],
                [
                    81.9864774,
                    54.8126999
                ],
                [
                    81.98796,
                    54.8149344
                ],
                [
                    81.9918377,
                    54.8169716
                ],
                [
                    81.9951451,
                    54.8169059
                ],
                [
                    81.9967987,
                    54.8202243
                ],
                [
                    81.999764,
                    54.8200601
                ],
                [
                    81.9999352,
                    54.815953
                ],
                [
                    82.0043832,
                    54.8149344
                ],
                [
                    82.0086029,
                    54.8129957
                ],
                [
                    82.0075195,
                    54.8103996
                ],
                [
                    82.0043832,
                    54.8067517
                ],
                [
                    81.9974261,
                    54.805963
                ],
                [
                    81.9898417,
                    54.8049441
                ],
                [
                    81.9857931,
                    54.8050098
                ]
            ],
            "longitude": 81.99662,
            "latitude": 54.811588
        },
        "3498": {
            "name": "Новый Шарап",
            "population": 1351,
            "type": "village",
            "poly": [
                [
                    82.0196305,
                    54.4084577
                ],
                [
                    82.025467,
                    54.414152
                ],
                [
                    82.0318184,
                    54.4156504
                ],
                [
                    82.0330201,
                    54.4215435
                ],
                [
                    82.0424241,
                    54.4240055
                ],
                [
                    82.0501862,
                    54.4260376
                ],
                [
                    82.0501862,
                    54.4146515
                ],
                [
                    82.057029,
                    54.4125678
                ],
                [
                    82.0645113,
                    54.4102894
                ],
                [
                    82.0649491,
                    54.4101561
                ],
                [
                    82.0613441,
                    54.4061598
                ],
                [
                    82.0534478,
                    54.4053605
                ],
                [
                    82.0488129,
                    54.4078583
                ],
                [
                    82.0436631,
                    54.4080581
                ],
                [
                    82.0362816,
                    54.402263
                ],
                [
                    82.0196305,
                    54.4084577
                ]
            ],
            "longitude": 82.036324,
            "latitude": 54.410988
        },
        "3499": {
            "name": "Земледелец",
            "population": 433,
            "type": "village",
            "poly": [
                [
                    82.0317343,
                    53.8666845
                ],
                [
                    82.0319242,
                    53.8675243
                ],
                [
                    82.0337598,
                    53.867431
                ],
                [
                    82.03607,
                    53.8678602
                ],
                [
                    82.0389436,
                    53.8672744
                ],
                [
                    82.040912,
                    53.8658075
                ],
                [
                    82.0448996,
                    53.8667405
                ],
                [
                    82.0560731,
                    53.8671712
                ],
                [
                    82.0568305,
                    53.8656022
                ],
                [
                    82.0541722,
                    53.8653782
                ],
                [
                    82.054457,
                    53.8634747
                ],
                [
                    82.046925,
                    53.8625975
                ],
                [
                    82.0471149,
                    53.8612164
                ],
                [
                    82.0436337,
                    53.8608618
                ],
                [
                    82.0437919,
                    53.8602459
                ],
                [
                    82.0422728,
                    53.8598913
                ],
                [
                    82.0411968,
                    53.8611231
                ],
                [
                    82.0401208,
                    53.8609178
                ],
                [
                    82.0396145,
                    53.8615337
                ],
                [
                    82.0406272,
                    53.8617204
                ],
                [
                    82.0402474,
                    53.8625415
                ],
                [
                    82.0365447,
                    53.8623176
                ],
                [
                    82.0364766,
                    53.8646368
                ],
                [
                    82.0335699,
                    53.8652476
                ],
                [
                    82.0340446,
                    53.866274
                ],
                [
                    82.0317343,
                    53.8666845
                ]
            ],
            "longitude": 82.042282,
            "latitude": 53.864155
        },
        "3500": {
            "name": "Малышево",
            "population": 624,
            "type": "village",
            "poly": [
                [
                    82.0331159,
                    53.7378942
                ],
                [
                    82.0341131,
                    53.7391593
                ],
                [
                    82.0374321,
                    53.7408344
                ],
                [
                    82.0390695,
                    53.7421954
                ],
                [
                    82.0410762,
                    53.7426482
                ],
                [
                    82.0432497,
                    53.7431095
                ],
                [
                    82.0464225,
                    53.7442089
                ],
                [
                    82.0497774,
                    53.7451573
                ],
                [
                    82.0528705,
                    53.7459509
                ],
                [
                    82.0544416,
                    53.746338
                ],
                [
                    82.05598,
                    53.7466059
                ],
                [
                    82.0568146,
                    53.7467445
                ],
                [
                    82.057731,
                    53.7468123
                ],
                [
                    82.0595802,
                    53.746909
                ],
                [
                    82.0621497,
                    53.7470058
                ],
                [
                    82.0699896,
                    53.74732
                ],
                [
                    82.072614,
                    53.7457024
                ],
                [
                    82.0795617,
                    53.7462781
                ],
                [
                    82.0801076,
                    53.7436133
                ],
                [
                    82.0772053,
                    53.7432262
                ],
                [
                    82.0734748,
                    53.7422525
                ],
                [
                    82.0717918,
                    53.741695
                ],
                [
                    82.0700659,
                    53.7411382
                ],
                [
                    82.0670847,
                    53.7400014
                ],
                [
                    82.0605497,
                    53.737869
                ],
                [
                    82.0562245,
                    53.7369755
                ],
                [
                    82.0560005,
                    53.7369292
                ],
                [
                    82.0559344,
                    53.7369156
                ],
                [
                    82.0552949,
                    53.7367835
                ],
                [
                    82.0549687,
                    53.7367161
                ],
                [
                    82.0547744,
                    53.736676
                ],
                [
                    82.0543105,
                    53.7365801
                ],
                [
                    82.0517311,
                    53.7360473
                ],
                [
                    82.0469023,
                    53.7350497
                ],
                [
                    82.0447598,
                    53.7349879
                ],
                [
                    82.0417808,
                    53.7349021
                ],
                [
                    82.0404012,
                    53.7348623
                ],
                [
                    82.0402579,
                    53.7360238
                ],
                [
                    82.0387492,
                    53.7368708
                ],
                [
                    82.0362688,
                    53.7374002
                ],
                [
                    82.0331159,
                    53.7378942
                ]
            ],
            "longitude": 82.052925,
            "latitude": 53.742188
        },
        "3501": {
            "name": "Белобородово",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 82.054642,
            "latitude": 55.065739
        },
        "3502": {
            "name": "Берёзовка",
            "population": 689,
            "type": "village",
            "poly": [
                [
                    82.0434749,
                    54.6087186
                ],
                [
                    82.0546975,
                    54.6120803
                ],
                [
                    82.054001,
                    54.6163382
                ],
                [
                    82.0587222,
                    54.6173241
                ],
                [
                    82.0657654,
                    54.6143214
                ],
                [
                    82.0690934,
                    54.6073738
                ],
                [
                    82.0559359,
                    54.6036082
                ],
                [
                    82.0459516,
                    54.6060738
                ],
                [
                    82.0434749,
                    54.6087186
                ]
            ],
            "longitude": 82.057228,
            "latitude": 54.609203
        },
        "3503": {
            "name": "Мирный",
            "population": 362,
            "type": "village",
            "poly": [
                [
                    82.07517,
                    54.9451649
                ],
                [
                    82.0756191,
                    54.9480726
                ],
                [
                    82.0779055,
                    54.9480022
                ],
                [
                    82.082274,
                    54.9474395
                ],
                [
                    82.0874999,
                    54.945587
                ],
                [
                    82.0829681,
                    54.9415301
                ],
                [
                    82.0757416,
                    54.9437814
                ],
                [
                    82.07517,
                    54.9451649
                ]
            ],
            "longitude": 82.080734,
            "latitude": 54.945011
        },
        "3504": {
            "name": "Мышланка",
            "population": 902,
            "type": "village",
            "poly": [
                [
                    82.0718973,
                    54.0148297
                ],
                [
                    82.0751807,
                    54.0188138
                ],
                [
                    82.092383,
                    54.0207848
                ],
                [
                    82.0978792,
                    54.022546
                ],
                [
                    82.0888141,
                    54.0274519
                ],
                [
                    82.0940961,
                    54.0291709
                ],
                [
                    82.1026616,
                    54.0271584
                ],
                [
                    82.1087288,
                    54.0225879
                ],
                [
                    82.1023761,
                    54.0150813
                ],
                [
                    82.1000206,
                    54.0099643
                ],
                [
                    82.0952382,
                    54.0096707
                ],
                [
                    82.0888855,
                    54.0117259
                ],
                [
                    82.0814621,
                    54.0121034
                ],
                [
                    82.0728252,
                    54.0134456
                ],
                [
                    82.0718973,
                    54.0148297
                ]
            ],
            "longitude": 82.088959,
            "latitude": 54.016327
        },
        "3505": {
            "name": "Крутологово",
            "population": 577,
            "type": "village",
            "poly": [
                [
                    82.0714594,
                    55.3049209
                ],
                [
                    82.0729127,
                    55.3050374
                ],
                [
                    82.0736666,
                    55.3056077
                ],
                [
                    82.0749759,
                    55.305523
                ],
                [
                    82.0749363,
                    55.3052971
                ],
                [
                    82.0769003,
                    55.3053875
                ],
                [
                    82.0769995,
                    55.3051221
                ],
                [
                    82.0796182,
                    55.3051165
                ],
                [
                    82.0817451,
                    55.3039146
                ],
                [
                    82.0838207,
                    55.3043655
                ],
                [
                    82.0823129,
                    55.3054157
                ],
                [
                    82.0824319,
                    55.3059464
                ],
                [
                    82.0830073,
                    55.306432
                ],
                [
                    82.0817376,
                    55.3079903
                ],
                [
                    82.0824121,
                    55.308329
                ],
                [
                    82.0819558,
                    55.3086903
                ],
                [
                    82.0828882,
                    55.3090968
                ],
                [
                    82.0841182,
                    55.3094243
                ],
                [
                    82.088086,
                    55.3107679
                ],
                [
                    82.0879273,
                    55.311005
                ],
                [
                    82.0893755,
                    55.3113663
                ],
                [
                    82.089931,
                    55.3118405
                ],
                [
                    82.0912999,
                    55.3122131
                ],
                [
                    82.0945337,
                    55.3119308
                ],
                [
                    82.0971722,
                    55.3122695
                ],
                [
                    82.0977079,
                    55.3112082
                ],
                [
                    82.0987197,
                    55.3095598
                ],
                [
                    82.0975095,
                    55.3093678
                ],
                [
                    82.0976087,
                    55.3084645
                ],
                [
                    82.0968945,
                    55.3077757
                ],
                [
                    82.099295,
                    55.3062287
                ],
                [
                    82.0988784,
                    55.3055286
                ],
                [
                    82.088086,
                    55.3034282
                ],
                [
                    82.0853483,
                    55.3038347
                ],
                [
                    82.083781,
                    55.303575
                ],
                [
                    82.0824518,
                    55.303575
                ],
                [
                    82.0816384,
                    55.3027055
                ],
                [
                    82.0805869,
                    55.3028297
                ],
                [
                    82.0793371,
                    55.3028523
                ],
                [
                    82.0793768,
                    55.3020166
                ],
                [
                    82.0811424,
                    55.3018923
                ],
                [
                    82.0816582,
                    55.3021408
                ],
                [
                    82.0835242,
                    55.3022046
                ],
                [
                    82.0839802,
                    55.3020169
                ],
                [
                    82.0844229,
                    55.3010883
                ],
                [
                    82.0863154,
                    55.3006235
                ],
                [
                    82.0859646,
                    55.2996105
                ],
                [
                    82.0838042,
                    55.2994108
                ],
                [
                    82.0808724,
                    55.2994588
                ],
                [
                    82.0770567,
                    55.3003532
                ],
                [
                    82.0763523,
                    55.3003898
                ],
                [
                    82.0761732,
                    55.3024994
                ],
                [
                    82.0756819,
                    55.3025173
                ],
                [
                    82.07571,
                    55.3027569
                ],
                [
                    82.0742931,
                    55.3029485
                ],
                [
                    82.0742651,
                    55.3024135
                ],
                [
                    82.0736619,
                    55.3024055
                ],
                [
                    82.0736338,
                    55.3028687
                ],
                [
                    82.0720562,
                    55.30287
                ],
                [
                    82.0719224,
                    55.3038828
                ],
                [
                    82.0716418,
                    55.3039626
                ],
                [
                    82.0714594,
                    55.3049209
                ]
            ],
            "longitude": 82.091835,
            "latitude": 55.30724
        },
        "3506": {
            "name": "Поваренка",
            "population": 1110,
            "type": "village",
            "poly": [
                [
                    82.098195,
                    54.8164039
                ],
                [
                    82.1024089,
                    54.8211496
                ],
                [
                    82.1046999,
                    54.8237718
                ],
                [
                    82.1049727,
                    54.8292158
                ],
                [
                    82.1063773,
                    54.8373687
                ],
                [
                    82.1155517,
                    54.8385506
                ],
                [
                    82.1188825,
                    54.8310931
                ],
                [
                    82.1211189,
                    54.8271969
                ],
                [
                    82.1200826,
                    54.8239289
                ],
                [
                    82.1245011,
                    54.8197177
                ],
                [
                    82.1246647,
                    54.8159776
                ],
                [
                    82.1221555,
                    54.8148775
                ],
                [
                    82.1201883,
                    54.8126261
                ],
                [
                    82.1140686,
                    54.8124061
                ],
                [
                    82.1053545,
                    54.8138992
                ],
                [
                    82.098195,
                    54.8164039
                ]
            ],
            "longitude": 82.1128325,
            "latitude": 54.8241485
        },
        "3507": {
            "name": "Козиха",
            "population": 960,
            "type": "village",
            "poly": [
                [
                    82.0958369,
                    54.5661348
                ],
                [
                    82.0997209,
                    54.5672417
                ],
                [
                    82.1007019,
                    54.5668
                ],
                [
                    82.101137,
                    54.5667964
                ],
                [
                    82.1019388,
                    54.5670018
                ],
                [
                    82.1025106,
                    54.5670558
                ],
                [
                    82.10284,
                    54.5670018
                ],
                [
                    82.1030016,
                    54.5668973
                ],
                [
                    82.1030575,
                    54.5666775
                ],
                [
                    82.1027219,
                    54.5663423
                ],
                [
                    82.1033683,
                    54.5656252
                ],
                [
                    82.1040644,
                    54.5657009
                ],
                [
                    82.1056991,
                    54.5657982
                ],
                [
                    82.1059334,
                    54.5659573
                ],
                [
                    82.1056056,
                    54.5664992
                ],
                [
                    82.1116268,
                    54.568132
                ],
                [
                    82.1145069,
                    54.5686616
                ],
                [
                    82.1167497,
                    54.5683431
                ],
                [
                    82.1190152,
                    54.565346
                ],
                [
                    82.1321768,
                    54.5676013
                ],
                [
                    82.138393,
                    54.5664024
                ],
                [
                    82.1390272,
                    54.5665556
                ],
                [
                    82.1458196,
                    54.5581818
                ],
                [
                    82.1279596,
                    54.5565011
                ],
                [
                    82.1244088,
                    54.5580498
                ],
                [
                    82.1207821,
                    54.5579002
                ],
                [
                    82.1177623,
                    54.5564483
                ],
                [
                    82.1160021,
                    54.5563691
                ],
                [
                    82.1122237,
                    54.5588505
                ],
                [
                    82.1115408,
                    54.5598008
                ],
                [
                    82.1044296,
                    54.5579533
                ],
                [
                    82.0958369,
                    54.5661348
                ]
            ],
            "longitude": 82.12133,
            "latitude": 54.561604
        },
        "3508": {
            "name": "Бобровка",
            "population": 1700,
            "type": "village",
            "poly": [
                [
                    82.1065916,
                    53.9360523
                ],
                [
                    82.1080988,
                    53.9371216
                ],
                [
                    82.1070554,
                    53.9378723
                ],
                [
                    82.1097992,
                    53.9401244
                ],
                [
                    82.1076737,
                    53.9411253
                ],
                [
                    82.1099538,
                    53.9428768
                ],
                [
                    82.1169487,
                    53.9391917
                ],
                [
                    82.1217794,
                    53.9381453
                ],
                [
                    82.1264169,
                    53.9340503
                ],
                [
                    82.1257212,
                    53.9315703
                ],
                [
                    82.1305133,
                    53.9313655
                ],
                [
                    82.1337209,
                    53.9314338
                ],
                [
                    82.1387448,
                    53.9307967
                ],
                [
                    82.1407157,
                    53.9315703
                ],
                [
                    82.1430345,
                    53.9313655
                ],
                [
                    82.1468218,
                    53.9299321
                ],
                [
                    82.1480971,
                    53.9287944
                ],
                [
                    82.1423002,
                    53.9251536
                ],
                [
                    82.1466672,
                    53.9259273
                ],
                [
                    82.1491791,
                    53.9259955
                ],
                [
                    82.1496815,
                    53.9254721
                ],
                [
                    82.1484449,
                    53.9243116
                ],
                [
                    82.1497202,
                    53.9236971
                ],
                [
                    82.1492178,
                    53.9220586
                ],
                [
                    82.1520003,
                    53.9224455
                ],
                [
                    82.1517684,
                    53.9230372
                ],
                [
                    82.1549373,
                    53.9239475
                ],
                [
                    82.1604637,
                    53.9243798
                ],
                [
                    82.1615071,
                    53.9230599
                ],
                [
                    82.156174,
                    53.92174
                ],
                [
                    82.1532369,
                    53.9214441
                ],
                [
                    82.1496429,
                    53.9207841
                ],
                [
                    82.1513047,
                    53.9197372
                ],
                [
                    82.1514979,
                    53.9181896
                ],
                [
                    82.1496815,
                    53.9171426
                ],
                [
                    82.1486767,
                    53.9178027
                ],
                [
                    82.147672,
                    53.9191
                ],
                [
                    82.1453919,
                    53.9181441
                ],
                [
                    82.144503,
                    53.9187131
                ],
                [
                    82.1416895,
                    53.91763
                ],
                [
                    82.1387486,
                    53.9158702
                ],
                [
                    82.1385129,
                    53.9154355
                ],
                [
                    82.1349962,
                    53.9165736
                ],
                [
                    82.1312089,
                    53.9216945
                ],
                [
                    82.132832,
                    53.9223317
                ],
                [
                    82.1304747,
                    53.9253356
                ],
                [
                    82.1308611,
                    53.926041
                ],
                [
                    82.1328707,
                    53.9272243
                ],
                [
                    82.1214349,
                    53.9290659
                ],
                [
                    82.119184,
                    53.930125
                ],
                [
                    82.1163769,
                    53.9320408
                ],
                [
                    82.1130841,
                    53.9330037
                ],
                [
                    82.1109046,
                    53.9337088
                ],
                [
                    82.1065916,
                    53.9360523
                ]
            ],
            "longitude": 82.135208,
            "latitude": 53.92474
        },
        "3509": {
            "name": "Красный Яр",
            "population": 1415,
            "type": "village",
            "poly": [
                [
                    82.135175,
                    54.4496462
                ],
                [
                    82.147298,
                    54.4568006
                ],
                [
                    82.1560103,
                    54.4615388
                ],
                [
                    82.1557736,
                    54.4616796
                ],
                [
                    82.1550452,
                    54.4621127
                ],
                [
                    82.1654529,
                    54.4678563
                ],
                [
                    82.1774103,
                    54.4564895
                ],
                [
                    82.1915688,
                    54.4581404
                ],
                [
                    82.1931137,
                    54.4560521
                ],
                [
                    82.171224,
                    54.4521716
                ],
                [
                    82.1651067,
                    54.4476696
                ],
                [
                    82.1641604,
                    54.4466686
                ],
                [
                    82.1602959,
                    54.4448638
                ],
                [
                    82.1599704,
                    54.4442119
                ],
                [
                    82.1588886,
                    54.4435658
                ],
                [
                    82.1576605,
                    54.4429679
                ],
                [
                    82.1572756,
                    54.4428573
                ],
                [
                    82.1567103,
                    54.4431237
                ],
                [
                    82.1558332,
                    54.4434779
                ],
                [
                    82.1550096,
                    54.4438803
                ],
                [
                    82.1535083,
                    54.4434104
                ],
                [
                    82.1501547,
                    54.4427076
                ],
                [
                    82.1460238,
                    54.442283
                ],
                [
                    82.1451005,
                    54.4421388
                ],
                [
                    82.1416436,
                    54.4448257
                ],
                [
                    82.1385355,
                    54.446928
                ],
                [
                    82.1362934,
                    54.4485025
                ],
                [
                    82.1353807,
                    54.4491637
                ],
                [
                    82.135175,
                    54.4496462
                ]
            ],
            "longitude": 82.15686,
            "latitude": 54.453373
        },
        "3510": {
            "name": "Дружный",
            "population": 260,
            "type": "village",
            "poly": null,
            "longitude": 82.15918,
            "latitude": 54.97438
        },
        "3511": {
            "name": "Кумысный",
            "population": 408,
            "type": "village",
            "poly": null,
            "longitude": 82.174484,
            "latitude": 55.044643
        },
        "3512": {
            "name": "Плотниково",
            "population": 394,
            "type": "village",
            "poly": [
                [
                    82.198009,
                    54.6000158
                ],
                [
                    82.2071373,
                    54.6037926
                ],
                [
                    82.2167544,
                    54.6022819
                ],
                [
                    82.2249046,
                    54.6055865
                ],
                [
                    82.2283603,
                    54.6015832
                ],
                [
                    82.2217098,
                    54.5989394
                ],
                [
                    82.2327288,
                    54.5953887
                ],
                [
                    82.2332178,
                    54.58925
                ],
                [
                    82.2064853,
                    54.5940666
                ],
                [
                    82.198009,
                    54.6000158
                ]
            ],
            "longitude": 82.217896,
            "latitude": 54.597088
        },
        "3513": {
            "name": "Шагалово",
            "population": 739,
            "type": "village",
            "poly": [
                [
                    82.2034669,
                    54.909624
                ],
                [
                    82.2077763,
                    54.9117563
                ],
                [
                    82.2073398,
                    54.9146723
                ],
                [
                    82.2156313,
                    54.9182152
                ],
                [
                    82.223759,
                    54.9189363
                ],
                [
                    82.2252606,
                    54.91776
                ],
                [
                    82.230523,
                    54.9136376
                ],
                [
                    82.2295957,
                    54.9099062
                ],
                [
                    82.2223407,
                    54.9061117
                ],
                [
                    82.2177041,
                    54.9085578
                ],
                [
                    82.2139403,
                    54.9093731
                ],
                [
                    82.2073398,
                    54.9065194
                ],
                [
                    82.2034669,
                    54.909624
                ]
            ],
            "longitude": 82.218918,
            "latitude": 54.91256
        },
        "3514": {
            "name": "Верх-Ирмень",
            "population": 3123,
            "type": "village",
            "poly": [
                [
                    82.2121554,
                    54.5766152
                ],
                [
                    82.2331251,
                    54.5870684
                ],
                [
                    82.260891,
                    54.5825185
                ],
                [
                    82.2730254,
                    54.568639
                ],
                [
                    82.2426482,
                    54.5555695
                ],
                [
                    82.2121554,
                    54.5766152
                ]
            ],
            "longitude": 82.244164,
            "latitude": 54.566437
        },
        "3515": {
            "name": "Троицк",
            "population": 278,
            "type": "village",
            "poly": null,
            "longitude": 82.245804,
            "latitude": 55.129101
        },
        "3516": {
            "name": "Болтово",
            "population": 995,
            "type": "village",
            "poly": [
                [
                    82.2532175,
                    54.0358252
                ],
                [
                    82.2561642,
                    54.0377543
                ],
                [
                    82.2637967,
                    54.038577
                ],
                [
                    82.266985,
                    54.0386905
                ],
                [
                    82.2723953,
                    54.0368749
                ],
                [
                    82.2749556,
                    54.0301225
                ],
                [
                    82.2700283,
                    54.0296402
                ],
                [
                    82.2665985,
                    54.0290159
                ],
                [
                    82.2714292,
                    54.0264622
                ],
                [
                    82.2703182,
                    54.0233407
                ],
                [
                    82.2693037,
                    54.0223758
                ],
                [
                    82.2653908,
                    54.0225177
                ],
                [
                    82.2632653,
                    54.0176079
                ],
                [
                    82.2606568,
                    54.0178633
                ],
                [
                    82.2606568,
                    54.0204176
                ],
                [
                    82.2584346,
                    54.0205879
                ],
                [
                    82.2588694,
                    54.0265473
                ],
                [
                    82.2611881,
                    54.0274269
                ],
                [
                    82.2637484,
                    54.0292146
                ],
                [
                    82.2653425,
                    54.0294132
                ],
                [
                    82.2623957,
                    54.0319384
                ],
                [
                    82.2605601,
                    54.0342081
                ],
                [
                    82.2533141,
                    54.0344635
                ],
                [
                    82.2532175,
                    54.0358252
                ]
            ],
            "longitude": 82.265205,
            "latitude": 54.026859
        },
        "3517": {
            "name": "Бедрино",
            "population": 299,
            "type": "village",
            "poly": [
                [
                    82.2456649,
                    53.9841688
                ],
                [
                    82.2459064,
                    53.9848505
                ],
                [
                    82.2516549,
                    53.9858162
                ],
                [
                    82.2547948,
                    53.9860435
                ],
                [
                    82.2551331,
                    53.9870944
                ],
                [
                    82.2531525,
                    53.9882873
                ],
                [
                    82.2543601,
                    53.9891394
                ],
                [
                    82.2568238,
                    53.9892814
                ],
                [
                    82.2575484,
                    53.9905594
                ],
                [
                    82.260157,
                    53.990815
                ],
                [
                    82.2611231,
                    53.9903038
                ],
                [
                    82.2615579,
                    53.9891962
                ],
                [
                    82.2659055,
                    53.9914114
                ],
                [
                    82.2681171,
                    53.9928326
                ],
                [
                    82.2740211,
                    53.9931722
                ],
                [
                    82.2817502,
                    53.991099
                ],
                [
                    82.2817984,
                    53.9903038
                ],
                [
                    82.2771128,
                    53.9882589
                ],
                [
                    82.2720888,
                    53.98735
                ],
                [
                    82.2713159,
                    53.9847937
                ],
                [
                    82.2695358,
                    53.9841693
                ],
                [
                    82.2679827,
                    53.9816691
                ],
                [
                    82.2640216,
                    53.9797374
                ],
                [
                    82.2597705,
                    53.9787999
                ],
                [
                    82.2532973,
                    53.9783454
                ],
                [
                    82.252138,
                    53.9803623
                ],
                [
                    82.2482251,
                    53.9814418
                ],
                [
                    82.2456649,
                    53.9841688
                ]
            ],
            "longitude": 82.267639,
            "latitude": 53.987228
        },
        "3518": {
            "name": "Битки",
            "population": 1184,
            "type": "village",
            "poly": [
                [
                    82.2513164,
                    54.2012106
                ],
                [
                    82.2563782,
                    54.2045414
                ],
                [
                    82.2614852,
                    54.208242
                ],
                [
                    82.2671345,
                    54.2130787
                ],
                [
                    82.2722416,
                    54.2153251
                ],
                [
                    82.2769418,
                    54.2152723
                ],
                [
                    82.2785236,
                    54.2146644
                ],
                [
                    82.2791112,
                    54.213528
                ],
                [
                    82.2794727,
                    54.211863
                ],
                [
                    82.2814161,
                    54.2088235
                ],
                [
                    82.280693,
                    54.2053609
                ],
                [
                    82.2798364,
                    54.204232
                ],
                [
                    82.2795179,
                    54.2025324
                ],
                [
                    82.2783429,
                    54.1998887
                ],
                [
                    82.2761283,
                    54.1987784
                ],
                [
                    82.2765803,
                    54.1963989
                ],
                [
                    82.2741849,
                    54.1928559
                ],
                [
                    82.2671797,
                    54.1917453
                ],
                [
                    82.2614852,
                    54.1906876
                ],
                [
                    82.2587283,
                    54.1923535
                ],
                [
                    82.2565138,
                    54.1948125
                ],
                [
                    82.2573725,
                    54.1953413
                ],
                [
                    82.2557907,
                    54.1969012
                ],
                [
                    82.2542992,
                    54.1963196
                ],
                [
                    82.2529886,
                    54.1976151
                ],
                [
                    82.2525818,
                    54.1985669
                ],
                [
                    82.2513164,
                    54.2012106
                ]
            ],
            "longitude": 82.27327,
            "latitude": 54.204201
        },
        "3519": {
            "name": "Светлый",
            "population": 559,
            "type": "village",
            "poly": [
                [
                    82.2733337,
                    55.0164377
                ],
                [
                    82.2776252,
                    55.0185045
                ],
                [
                    82.284835,
                    55.016733
                ],
                [
                    82.2887832,
                    55.0151582
                ],
                [
                    82.2961646,
                    55.012107
                ],
                [
                    82.2963362,
                    55.0080711
                ],
                [
                    82.2901565,
                    55.0075789
                ],
                [
                    82.2815734,
                    55.0095477
                ],
                [
                    82.2748785,
                    55.0125007
                ],
                [
                    82.2733337,
                    55.0164377
                ]
            ],
            "longitude": 82.285179,
            "latitude": 55.012493
        },
        "3520": {
            "name": "Верх-Сузун",
            "population": 829,
            "type": "village",
            "poly": [
                [
                    82.2686884,
                    53.6790876
                ],
                [
                    82.2756487,
                    53.6803843
                ],
                [
                    82.2876046,
                    53.6839082
                ],
                [
                    82.2917021,
                    53.6885288
                ],
                [
                    82.3000095,
                    53.6906473
                ],
                [
                    82.3091589,
                    53.6918193
                ],
                [
                    82.3134248,
                    53.6913208
                ],
                [
                    82.3137055,
                    53.6887614
                ],
                [
                    82.3108428,
                    53.6789879
                ],
                [
                    82.3096079,
                    53.6762617
                ],
                [
                    82.2939473,
                    53.6718393
                ],
                [
                    82.283956,
                    53.6727039
                ],
                [
                    82.2734034,
                    53.6751312
                ],
                [
                    82.2697549,
                    53.6761618
                ],
                [
                    82.2686884,
                    53.6790876
                ]
            ],
            "longitude": 82.294952,
            "latitude": 53.681107
        },
        "3521": {
            "name": "Новокремлёвское",
            "population": 1242,
            "type": "village",
            "poly": null,
            "longitude": 82.314896,
            "latitude": 55.197346
        },
        "3522": {
            "name": "Новопичугово",
            "population": 979,
            "type": "village",
            "poly": [
                [
                    82.3312262,
                    54.6092141
                ],
                [
                    82.3397353,
                    54.6128026
                ],
                [
                    82.3489665,
                    54.6173619
                ],
                [
                    82.3667067,
                    54.6168306
                ],
                [
                    82.3718045,
                    54.6128749
                ],
                [
                    82.3415237,
                    54.5997064
                ],
                [
                    82.3312262,
                    54.6092141
                ]
            ],
            "longitude": 82.349693,
            "latitude": 54.61031
        },
        "3523": {
            "name": "Лесниковский",
            "population": 322,
            "type": "village",
            "poly": [
                [
                    82.3499698,
                    53.5968412
                ],
                [
                    82.3516977,
                    53.5975704
                ],
                [
                    82.3539632,
                    53.5960437
                ],
                [
                    82.3619882,
                    53.598049
                ],
                [
                    82.3647912,
                    53.5955879
                ],
                [
                    82.3734692,
                    53.5910072
                ],
                [
                    82.372586,
                    53.5902095
                ],
                [
                    82.3704742,
                    53.5906881
                ],
                [
                    82.3624875,
                    53.5912123
                ],
                [
                    82.3561135,
                    53.5906881
                ],
                [
                    82.35404,
                    53.5915542
                ],
                [
                    82.3499698,
                    53.5968412
                ]
            ],
            "longitude": 82.36042,
            "latitude": 53.593983
        },
        "3524": {
            "name": "Пономаревка",
            "population": 227,
            "type": "village",
            "poly": null,
            "longitude": 82.365372,
            "latitude": 56.137455
        },
        "3525": {
            "name": "Мереть",
            "population": 694,
            "type": "village",
            "poly": [
                [
                    82.3827921,
                    53.5664044
                ],
                [
                    82.3830221,
                    53.5680892
                ],
                [
                    82.3853224,
                    53.5711402
                ],
                [
                    82.3901532,
                    53.5740998
                ],
                [
                    82.3893097,
                    53.5802459
                ],
                [
                    82.3969776,
                    53.5852987
                ],
                [
                    82.3987412,
                    53.5852533
                ],
                [
                    82.3998146,
                    53.5842063
                ],
                [
                    82.4106264,
                    53.5810654
                ],
                [
                    82.4113932,
                    53.5783338
                ],
                [
                    82.4075593,
                    53.576877
                ],
                [
                    82.4056423,
                    53.5742363
                ],
                [
                    82.4050289,
                    53.5703661
                ],
                [
                    82.4026518,
                    53.5654936
                ],
                [
                    82.4011182,
                    53.5649927
                ],
                [
                    82.3898465,
                    53.5661767
                ],
                [
                    82.3847857,
                    53.5645827
                ],
                [
                    82.3827921,
                    53.5664044
                ]
            ],
            "longitude": 82.397125,
            "latitude": 53.574917
        },
        "3526": {
            "name": "Сидоровка",
            "population": 490,
            "type": "village",
            "poly": null,
            "longitude": 82.408691,
            "latitude": 55.444237
        },
        "3527": {
            "name": "Новотырышкино",
            "population": 1106,
            "type": "village",
            "poly": null,
            "longitude": 82.410477,
            "latitude": 55.284389
        },
        "3528": {
            "name": "Заковряжино",
            "population": 1212,
            "type": "village",
            "poly": [
                [
                    82.3952438,
                    54.0258142
                ],
                [
                    82.3962131,
                    54.026685
                ],
                [
                    82.4007745,
                    54.0284266
                ],
                [
                    82.4029982,
                    54.0276898
                ],
                [
                    82.4039675,
                    54.0301011
                ],
                [
                    82.4028272,
                    54.0319765
                ],
                [
                    82.4049938,
                    54.0341197
                ],
                [
                    82.4101824,
                    54.035794
                ],
                [
                    82.4117789,
                    54.0373678
                ],
                [
                    82.4129192,
                    54.0369994
                ],
                [
                    82.4141166,
                    54.0361288
                ],
                [
                    82.4164543,
                    54.0387741
                ],
                [
                    82.4190201,
                    54.0382718
                ],
                [
                    82.415428,
                    54.0422561
                ],
                [
                    82.4173096,
                    54.0429257
                ],
                [
                    82.4198184,
                    54.0435283
                ],
                [
                    82.4213008,
                    54.0418544
                ],
                [
                    82.4249499,
                    54.0422226
                ],
                [
                    82.425235,
                    54.0438966
                ],
                [
                    82.4286561,
                    54.0438966
                ],
                [
                    82.4299104,
                    54.0389415
                ],
                [
                    82.431678,
                    54.0351243
                ],
                [
                    82.4333315,
                    54.0363967
                ],
                [
                    82.4386911,
                    54.0361288
                ],
                [
                    82.4421692,
                    54.0350908
                ],
                [
                    82.4487262,
                    54.032077
                ],
                [
                    82.4494674,
                    54.0304695
                ],
                [
                    82.4525464,
                    54.0267855
                ],
                [
                    82.4509499,
                    54.0259147
                ],
                [
                    82.4467876,
                    54.0240725
                ],
                [
                    82.441428,
                    54.0245079
                ],
                [
                    82.4358403,
                    54.0222638
                ],
                [
                    82.4334455,
                    54.0225317
                ],
                [
                    82.4287131,
                    54.0249099
                ],
                [
                    82.4264324,
                    54.0257807
                ],
                [
                    82.4211298,
                    54.0264506
                ],
                [
                    82.4144017,
                    54.024039
                ],
                [
                    82.4126912,
                    54.0236371
                ],
                [
                    82.4107526,
                    54.0269864
                ],
                [
                    82.4087,
                    54.0269864
                ],
                [
                    82.3954719,
                    54.0246754
                ],
                [
                    82.3952438,
                    54.0258142
                ]
            ],
            "longitude": 82.424141,
            "latitude": 54.03175
        },
        "3529": {
            "name": "Маюрово",
            "population": 482,
            "type": "village",
            "poly": [
                [
                    82.4189902,
                    54.3119569
                ],
                [
                    82.4205312,
                    54.3146307
                ],
                [
                    82.4247986,
                    54.3169125
                ],
                [
                    82.4232181,
                    54.3173504
                ],
                [
                    82.4223488,
                    54.3182032
                ],
                [
                    82.4249962,
                    54.3201621
                ],
                [
                    82.4264582,
                    54.3217062
                ],
                [
                    82.4322666,
                    54.3254855
                ],
                [
                    82.4366131,
                    54.328458
                ],
                [
                    82.4387863,
                    54.3280662
                ],
                [
                    82.4404458,
                    54.3253703
                ],
                [
                    82.4405644,
                    54.3230889
                ],
                [
                    82.4398927,
                    54.322121
                ],
                [
                    82.4378775,
                    54.3217523
                ],
                [
                    82.4362574,
                    54.3192864
                ],
                [
                    82.4334915,
                    54.3199317
                ],
                [
                    82.4301724,
                    54.3165898
                ],
                [
                    82.4263397,
                    54.3145154
                ],
                [
                    82.4336496,
                    54.3118416
                ],
                [
                    82.4386677,
                    54.3123026
                ],
                [
                    82.4416707,
                    54.3143541
                ],
                [
                    82.4449898,
                    54.314769
                ],
                [
                    82.4486646,
                    54.3123026
                ],
                [
                    82.443923,
                    54.3097209
                ],
                [
                    82.4402877,
                    54.3117955
                ],
                [
                    82.4332545,
                    54.3105738
                ],
                [
                    82.4309232,
                    54.3093981
                ],
                [
                    82.4266163,
                    54.3091907
                ],
                [
                    82.4225069,
                    54.3103433
                ],
                [
                    82.4189902,
                    54.3119569
                ]
            ],
            "longitude": 82.426704,
            "latitude": 54.31744
        },
        "3530": {
            "name": "Новошилово",
            "population": 772,
            "type": "village",
            "poly": [
                [
                    82.420466,
                    54.7088844
                ],
                [
                    82.4235465,
                    54.7110587
                ],
                [
                    82.4229332,
                    54.7114291
                ],
                [
                    82.4224313,
                    54.7118237
                ],
                [
                    82.4210235,
                    54.7142796
                ],
                [
                    82.4206053,
                    54.7163167
                ],
                [
                    82.422515,
                    54.7164535
                ],
                [
                    82.4223338,
                    54.7184905
                ],
                [
                    82.4229053,
                    54.7188206
                ],
                [
                    82.4228495,
                    54.7191346
                ],
                [
                    82.4232677,
                    54.7195774
                ],
                [
                    82.4272264,
                    54.7181041
                ],
                [
                    82.4283992,
                    54.7182321
                ],
                [
                    82.4308087,
                    54.7187079
                ],
                [
                    82.4325511,
                    54.7183134
                ],
                [
                    82.4321329,
                    54.7192071
                ],
                [
                    82.4309812,
                    54.7203556
                ],
                [
                    82.4324953,
                    54.7219523
                ],
                [
                    82.4329414,
                    54.7220811
                ],
                [
                    82.4347116,
                    54.7220328
                ],
                [
                    82.4350601,
                    54.7216545
                ],
                [
                    82.4340983,
                    54.7208011
                ],
                [
                    82.4349346,
                    54.7190782
                ],
                [
                    82.43782,
                    54.7158658
                ],
                [
                    82.4354503,
                    54.7135952
                ],
                [
                    82.4349765,
                    54.7114855
                ],
                [
                    82.4317008,
                    54.7099555
                ],
                [
                    82.429819,
                    54.7101648
                ],
                [
                    82.4285785,
                    54.7101809
                ],
                [
                    82.4285366,
                    54.7099555
                ],
                [
                    82.4263342,
                    54.7097944
                ],
                [
                    82.4253028,
                    54.709577
                ],
                [
                    82.4242852,
                    54.7090535
                ],
                [
                    82.4227798,
                    54.7079342
                ],
                [
                    82.4224313,
                    54.7080469
                ],
                [
                    82.4211908,
                    54.7080711
                ],
                [
                    82.4208284,
                    54.7087395
                ],
                [
                    82.420466,
                    54.7088844
                ]
            ],
            "longitude": 82.432091,
            "latitude": 54.715679
        },
        "3531": {
            "name": "Факел Революции",
            "population": 272,
            "type": "village",
            "poly": [
                [
                    82.4338269,
                    54.4725214
                ],
                [
                    82.4340772,
                    54.4784893
                ],
                [
                    82.4342552,
                    54.4818052
                ],
                [
                    82.4348759,
                    54.4839688
                ],
                [
                    82.4362584,
                    54.485534
                ],
                [
                    82.4366816,
                    54.4854767
                ],
                [
                    82.4369073,
                    54.4847063
                ],
                [
                    82.4367661,
                    54.4839032
                ],
                [
                    82.4373023,
                    54.4834771
                ],
                [
                    82.4384026,
                    54.4832312
                ],
                [
                    82.4391595,
                    54.4828822
                ],
                [
                    82.4409559,
                    54.4832476
                ],
                [
                    82.4433682,
                    54.4839442
                ],
                [
                    82.4406315,
                    54.4821576
                ],
                [
                    82.4406738,
                    54.4813381
                ],
                [
                    82.4421789,
                    54.480365
                ],
                [
                    82.4481649,
                    54.4825488
                ],
                [
                    82.4493631,
                    54.4822594
                ],
                [
                    82.4499275,
                    54.4821283
                ],
                [
                    82.4511548,
                    54.4812924
                ],
                [
                    82.4525373,
                    54.481907
                ],
                [
                    82.4514602,
                    54.4825867
                ],
                [
                    82.4514345,
                    54.4828911
                ],
                [
                    82.4536094,
                    54.4837592
                ],
                [
                    82.4578837,
                    54.4857669
                ],
                [
                    82.4579825,
                    54.4846606
                ],
                [
                    82.4558241,
                    54.483079
                ],
                [
                    82.4553163,
                    54.482579
                ],
                [
                    82.4538658,
                    54.4824863
                ],
                [
                    82.4511635,
                    54.4784522
                ],
                [
                    82.4492882,
                    54.4760905
                ],
                [
                    82.4480815,
                    54.4753551
                ],
                [
                    82.4450408,
                    54.472398
                ],
                [
                    82.4445991,
                    54.4717999
                ],
                [
                    82.4465895,
                    54.4711567
                ],
                [
                    82.4453568,
                    54.4706391
                ],
                [
                    82.4338269,
                    54.4725214
                ]
            ],
            "longitude": 82.442276,
            "latitude": 54.478268
        },
        "3532": {
            "name": "Чик",
            "population": 5149,
            "type": "village",
            "poly": [
                [
                    82.4191751,
                    54.99732
                ],
                [
                    82.4332042,
                    55.0009688
                ],
                [
                    82.4369554,
                    55.0006847
                ],
                [
                    82.4407286,
                    55.0005021
                ],
                [
                    82.4432033,
                    55.0002434
                ],
                [
                    82.4503247,
                    55.000062
                ],
                [
                    82.4602875,
                    54.9995085
                ],
                [
                    82.459663,
                    54.9963399
                ],
                [
                    82.4513761,
                    54.990983
                ],
                [
                    82.4471187,
                    54.9880177
                ],
                [
                    82.4461584,
                    54.9854403
                ],
                [
                    82.421877,
                    54.9891595
                ],
                [
                    82.419459,
                    54.9940331
                ],
                [
                    82.4191751,
                    54.99732
                ]
            ],
            "longitude": 82.4427018,
            "latitude": 54.9944056
        },
        "3533": {
            "name": "Завьялово",
            "population": 1124,
            "type": "village",
            "poly": [
                [
                    82.434776,
                    54.511145
                ],
                [
                    82.4360319,
                    54.5114453
                ],
                [
                    82.4410641,
                    54.5098293
                ],
                [
                    82.4425959,
                    54.5087816
                ],
                [
                    82.4440405,
                    54.5088956
                ],
                [
                    82.4448588,
                    54.5086745
                ],
                [
                    82.445677,
                    54.5089612
                ],
                [
                    82.4466927,
                    54.509772
                ],
                [
                    82.447412,
                    54.509559
                ],
                [
                    82.4479764,
                    54.5089775
                ],
                [
                    82.4505579,
                    54.508912
                ],
                [
                    82.4522931,
                    54.5098784
                ],
                [
                    82.4551517,
                    54.5097379
                ],
                [
                    82.4562571,
                    54.5096737
                ],
                [
                    82.4565674,
                    54.5092069
                ],
                [
                    82.4557915,
                    54.5089366
                ],
                [
                    82.4556646,
                    54.5067662
                ],
                [
                    82.4553683,
                    54.5057505
                ],
                [
                    82.4552978,
                    54.5046939
                ],
                [
                    82.4564687,
                    54.5021629
                ],
                [
                    82.4577946,
                    54.4992138
                ],
                [
                    82.4577101,
                    54.4954372
                ],
                [
                    82.4570753,
                    54.4946588
                ],
                [
                    82.4573856,
                    54.4946015
                ],
                [
                    82.4572304,
                    54.4941099
                ],
                [
                    82.4569482,
                    54.4935856
                ],
                [
                    82.4563276,
                    54.4933234
                ],
                [
                    82.4566803,
                    54.492504
                ],
                [
                    82.457174,
                    54.4908981
                ],
                [
                    82.457583,
                    54.4909309
                ],
                [
                    82.4583166,
                    54.489497
                ],
                [
                    82.458627,
                    54.4885874
                ],
                [
                    82.4582743,
                    54.488317
                ],
                [
                    82.4589373,
                    54.4875959
                ],
                [
                    82.4598825,
                    54.4875877
                ],
                [
                    82.4603339,
                    54.4872026
                ],
                [
                    82.4606866,
                    54.4870879
                ],
                [
                    82.4642697,
                    54.4873747
                ],
                [
                    82.4654829,
                    54.4877025
                ],
                [
                    82.4653277,
                    54.4882515
                ],
                [
                    82.4659202,
                    54.488399
                ],
                [
                    82.4676271,
                    54.4877926
                ],
                [
                    82.4685298,
                    54.4867273
                ],
                [
                    82.4606302,
                    54.4852277
                ],
                [
                    82.4585847,
                    54.4863586
                ],
                [
                    82.4578229,
                    54.4863012
                ],
                [
                    82.4532805,
                    54.484064
                ],
                [
                    82.4529561,
                    54.4845393
                ],
                [
                    82.45242,
                    54.4848262
                ],
                [
                    82.4512351,
                    54.4854572
                ],
                [
                    82.4524059,
                    54.4858669
                ],
                [
                    82.4539436,
                    54.4862029
                ],
                [
                    82.4547194,
                    54.4872108
                ],
                [
                    82.455326,
                    54.4872928
                ],
                [
                    82.4550862,
                    54.4882023
                ],
                [
                    82.4537318,
                    54.4890873
                ],
                [
                    82.4512774,
                    54.4913815
                ],
                [
                    82.4522679,
                    54.4918819
                ],
                [
                    82.4497102,
                    54.4956432
                ],
                [
                    82.4509589,
                    54.5015575
                ],
                [
                    82.450396,
                    54.5022003
                ],
                [
                    82.4458678,
                    54.5036756
                ],
                [
                    82.4462947,
                    54.5041849
                ],
                [
                    82.4460743,
                    54.5047224
                ],
                [
                    82.4453752,
                    54.5050228
                ],
                [
                    82.4437269,
                    54.5048482
                ],
                [
                    82.443782,
                    54.5062838
                ],
                [
                    82.4439363,
                    54.5071412
                ],
                [
                    82.4429223,
                    54.5073332
                ],
                [
                    82.4414015,
                    54.5076787
                ],
                [
                    82.4426529,
                    54.5078735
                ],
                [
                    82.4401862,
                    54.5095061
                ],
                [
                    82.4376984,
                    54.5094831
                ],
                [
                    82.4372355,
                    54.5102381
                ],
                [
                    82.4360231,
                    54.5109419
                ],
                [
                    82.4353302,
                    54.5107576
                ],
                [
                    82.434776,
                    54.511145
                ]
            ],
            "longitude": 82.448395,
            "latitude": 54.505348
        },
        "3534": {
            "name": "Сенчанка",
            "population": 529,
            "type": "village",
            "poly": [
                [
                    82.4389126,
                    54.8406528
                ],
                [
                    82.4476959,
                    54.843515
                ],
                [
                    82.4547089,
                    54.8436326
                ],
                [
                    82.4630157,
                    54.8446519
                ],
                [
                    82.464718,
                    54.8448871
                ],
                [
                    82.4683266,
                    54.8415938
                ],
                [
                    82.4627433,
                    54.8404568
                ],
                [
                    82.4592028,
                    54.8384963
                ],
                [
                    82.4489897,
                    54.837516
                ],
                [
                    82.4409553,
                    54.8369671
                ],
                [
                    82.4389126,
                    54.8406528
                ]
            ],
            "longitude": 82.4537988,
            "latitude": 54.8408864
        },
        "3535": {
            "name": "Прокудское",
            "population": 5991,
            "type": "village",
            "poly": null,
            "longitude": 82.4593467,
            "latitude": 55.0101158
        },
        "3536": {
            "name": "Буньково",
            "population": 300,
            "type": "village",
            "poly": [
                [
                    82.4691247,
                    55.0559614
                ],
                [
                    82.4730519,
                    55.0598899
                ],
                [
                    82.4849444,
                    55.0669854
                ],
                [
                    82.4906417,
                    55.066637
                ],
                [
                    82.4957859,
                    55.0686007
                ],
                [
                    82.4981643,
                    55.066827
                ],
                [
                    82.495465,
                    55.0642744
                ],
                [
                    82.4931846,
                    55.0644905
                ],
                [
                    82.4930202,
                    55.064293
                ],
                [
                    82.4931308,
                    55.0622974
                ],
                [
                    82.4923011,
                    55.0617589
                ],
                [
                    82.4900289,
                    55.0603319
                ],
                [
                    82.4899702,
                    55.0593716
                ],
                [
                    82.4889637,
                    55.0590313
                ],
                [
                    82.4861303,
                    55.0595156
                ],
                [
                    82.4839936,
                    55.0592378
                ],
                [
                    82.4833804,
                    55.0586561
                ],
                [
                    82.4818964,
                    55.0582191
                ],
                [
                    82.4811089,
                    55.0584267
                ],
                [
                    82.4759283,
                    55.0575772
                ],
                [
                    82.4722222,
                    55.0545991
                ],
                [
                    82.4691247,
                    55.0559614
                ]
            ],
            "longitude": 82.4844871,
            "latitude": 55.0629392
        },
        "3537": {
            "name": "Чистополье",
            "population": 683,
            "type": "village",
            "poly": [
                [
                    82.4899532,
                    54.9671084
                ],
                [
                    82.491856,
                    54.9679216
                ],
                [
                    82.4942556,
                    54.9691368
                ],
                [
                    82.4948149,
                    54.9695758
                ],
                [
                    82.4965271,
                    54.9698116
                ],
                [
                    82.498182,
                    54.9692678
                ],
                [
                    82.499392,
                    54.9691171
                ],
                [
                    82.5000769,
                    54.9686716
                ],
                [
                    82.5013324,
                    54.969353
                ],
                [
                    82.5024282,
                    54.9688485
                ],
                [
                    82.5023825,
                    54.9682195
                ],
                [
                    82.5032614,
                    54.967846
                ],
                [
                    82.5051562,
                    54.9665946
                ],
                [
                    82.5051904,
                    54.9652841
                ],
                [
                    82.5041745,
                    54.9646485
                ],
                [
                    82.5004079,
                    54.9658869
                ],
                [
                    82.4995746,
                    54.9657362
                ],
                [
                    82.4988327,
                    54.9653037
                ],
                [
                    82.4985245,
                    54.9642815
                ],
                [
                    82.4983191,
                    54.9631151
                ],
                [
                    82.4971434,
                    54.9626695
                ],
                [
                    82.4959791,
                    54.9610968
                ],
                [
                    82.4931028,
                    54.9609264
                ],
                [
                    82.4922991,
                    54.961147
                ],
                [
                    82.4918334,
                    54.9617918
                ],
                [
                    82.4907376,
                    54.9644077
                ],
                [
                    82.4900374,
                    54.9665556
                ],
                [
                    82.4899532,
                    54.9671084
                ]
            ],
            "longitude": 82.4972386,
            "latitude": 54.9656824
        },
        "3538": {
            "name": "Речник",
            "population": 656,
            "type": "village",
            "poly": [
                [
                    82.4990703,
                    54.8992962
                ],
                [
                    82.5055575,
                    54.9016121
                ],
                [
                    82.5173554,
                    54.9036
                ],
                [
                    82.5210625,
                    54.8990502
                ],
                [
                    82.5206348,
                    54.8981279
                ],
                [
                    82.5148961,
                    54.8968776
                ],
                [
                    82.5130783,
                    54.8948689
                ],
                [
                    82.5140051,
                    54.8914046
                ],
                [
                    82.5104762,
                    54.8898261
                ],
                [
                    82.5047021,
                    54.8911381
                ],
                [
                    82.503811,
                    54.8923885
                ],
                [
                    82.5064843,
                    54.8929625
                ],
                [
                    82.5048447,
                    54.8944589
                ],
                [
                    82.5025634,
                    54.8944589
                ],
                [
                    82.5014229,
                    54.8951558
                ],
                [
                    82.4990703,
                    54.8992962
                ]
            ],
            "longitude": 82.5098853,
            "latitude": 54.8970649
        },
        "3539": {
            "name": "Береговое",
            "population": 438,
            "type": "village",
            "poly": [
                [
                    82.4937251,
                    54.6565143
                ],
                [
                    82.4942055,
                    54.6577449
                ],
                [
                    82.4983915,
                    54.658896
                ],
                [
                    82.5143121,
                    54.6608013
                ],
                [
                    82.5227527,
                    54.6612776
                ],
                [
                    82.5245369,
                    54.6581418
                ],
                [
                    82.5247428,
                    54.6536957
                ],
                [
                    82.4989405,
                    54.6512342
                ],
                [
                    82.4937251,
                    54.6565143
                ]
            ],
            "longitude": 82.509918,
            "latitude": 54.655838
        },
        "3540": {
            "name": "Красномайский",
            "population": 368,
            "type": "village",
            "poly": [
                [
                    82.5088818,
                    54.9967159
                ],
                [
                    82.5094007,
                    54.997813
                ],
                [
                    82.5114354,
                    54.9981398
                ],
                [
                    82.5146402,
                    54.9982332
                ],
                [
                    82.5181399,
                    54.9982507
                ],
                [
                    82.5215481,
                    54.998134
                ],
                [
                    82.521599,
                    54.9974804
                ],
                [
                    82.5212734,
                    54.996179
                ],
                [
                    82.5226055,
                    54.9958382
                ],
                [
                    82.5249462,
                    54.9952394
                ],
                [
                    82.5233082,
                    54.993722
                ],
                [
                    82.5222907,
                    54.992864
                ],
                [
                    82.5141315,
                    54.9943348
                ],
                [
                    82.5116795,
                    54.9950351
                ],
                [
                    82.5118627,
                    54.9962023
                ],
                [
                    82.5088818,
                    54.9967159
                ]
            ],
            "longitude": 82.5179361,
            "latitude": 54.9959079
        },
        "3541": {
            "name": "Южино",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 82.519745,
            "latitude": 55.487583
        },
        "3542": {
            "name": "Шарчино",
            "population": 731,
            "type": "village",
            "poly": [
                [
                    82.5146117,
                    54.2736168
                ],
                [
                    82.5161428,
                    54.2741648
                ],
                [
                    82.5206868,
                    54.2737322
                ],
                [
                    82.5281449,
                    54.2725785
                ],
                [
                    82.5306145,
                    54.2715114
                ],
                [
                    82.5357018,
                    54.2729246
                ],
                [
                    82.5428142,
                    54.2750588
                ],
                [
                    82.5437526,
                    54.273934
                ],
                [
                    82.5445922,
                    54.2710211
                ],
                [
                    82.5439995,
                    54.2694636
                ],
                [
                    82.5434562,
                    54.2666657
                ],
                [
                    82.5412336,
                    54.2647618
                ],
                [
                    82.5377268,
                    54.2639541
                ],
                [
                    82.535603,
                    54.2643291
                ],
                [
                    82.5300712,
                    54.2582709
                ],
                [
                    82.5245393,
                    54.2595114
                ],
                [
                    82.52286,
                    54.2619925
                ],
                [
                    82.5250333,
                    54.2632041
                ],
                [
                    82.529034,
                    54.265858
                ],
                [
                    82.5289352,
                    54.2678195
                ],
                [
                    82.5265571,
                    54.2687946
                ],
                [
                    82.5150068,
                    54.2712807
                ],
                [
                    82.5146117,
                    54.2736168
                ]
            ],
            "longitude": 82.53228,
            "latitude": 54.267941
        },
        "3543": {
            "name": "Катково",
            "population": 471,
            "type": "village",
            "poly": null,
            "longitude": 82.5393992,
            "latitude": 55.1251275
        },
        "3544": {
            "name": "Пайвино",
            "population": 305,
            "type": "village",
            "poly": [
                [
                    82.534392,
                    54.8413739
                ],
                [
                    82.5412689,
                    54.8445888
                ],
                [
                    82.5564525,
                    54.8466274
                ],
                [
                    82.5611506,
                    54.8467058
                ],
                [
                    82.5672103,
                    54.8440007
                ],
                [
                    82.5686403,
                    54.8403153
                ],
                [
                    82.5682317,
                    54.8389037
                ],
                [
                    82.5606059,
                    54.8386685
                ],
                [
                    82.5527758,
                    54.8362373
                ],
                [
                    82.5468521,
                    54.8358844
                ],
                [
                    82.534392,
                    54.8413739
                ]
            ],
            "longitude": 82.5528655,
            "latitude": 54.8416541
        },
        "3545": {
            "name": "Соколово",
            "population": 810,
            "type": "village",
            "poly": null,
            "longitude": 82.5611107,
            "latitude": 55.2012537
        },
        "3546": {
            "name": "Воробьево",
            "population": 460,
            "type": "village",
            "poly": null,
            "longitude": 82.568306,
            "latitude": 55.311062
        },
        "3547": {
            "name": "Быстровка",
            "population": 1029,
            "type": "village",
            "poly": [
                [
                    82.5553982,
                    54.5375936
                ],
                [
                    82.5979292,
                    54.5456033
                ],
                [
                    82.604208,
                    54.5428572
                ],
                [
                    82.5920763,
                    54.5276064
                ],
                [
                    82.5733733,
                    54.5252597
                ],
                [
                    82.5563553,
                    54.5360146
                ],
                [
                    82.5553982,
                    54.5375936
                ]
            ],
            "longitude": 82.578629,
            "latitude": 54.536373
        },
        "3548": {
            "name": "Холодное",
            "population": 417,
            "type": "village",
            "poly": [
                [
                    82.5744667,
                    54.1196925
                ],
                [
                    82.587061,
                    54.1193815
                ],
                [
                    82.5951034,
                    54.1153387
                ],
                [
                    82.5880942,
                    54.109462
                ],
                [
                    82.583162,
                    54.1091673
                ],
                [
                    82.581448,
                    54.1129161
                ],
                [
                    82.5781249,
                    54.1164517
                ],
                [
                    82.5757513,
                    54.1177939
                ],
                [
                    82.5744667,
                    54.1196925
                ]
            ],
            "longitude": 82.583435,
            "latitude": 54.115444
        },
        "3549": {
            "name": "Алексеевка",
            "population": 343,
            "type": "village",
            "poly": [
                [
                    82.5717415,
                    54.939157
                ],
                [
                    82.5724468,
                    54.939869
                ],
                [
                    82.5727317,
                    54.9399795
                ],
                [
                    82.5749541,
                    54.9408429
                ],
                [
                    82.576671,
                    54.9408101
                ],
                [
                    82.577889,
                    54.9408306
                ],
                [
                    82.5788081,
                    54.9409042
                ],
                [
                    82.5808454,
                    54.939603
                ],
                [
                    82.583246,
                    54.9387723
                ],
                [
                    82.5865727,
                    54.9376388
                ],
                [
                    82.5896928,
                    54.9365871
                ],
                [
                    82.5943658,
                    54.9346554
                ],
                [
                    82.595071,
                    54.9330307
                ],
                [
                    82.5955483,
                    54.9315654
                ],
                [
                    82.593974,
                    54.9302639
                ],
                [
                    82.5947932,
                    54.9287003
                ],
                [
                    82.5933258,
                    54.9279922
                ],
                [
                    82.5918013,
                    54.9283442
                ],
                [
                    82.5897212,
                    54.9272514
                ],
                [
                    82.5873064,
                    54.9278449
                ],
                [
                    82.5851907,
                    54.9279472
                ],
                [
                    82.5839085,
                    54.9288027
                ],
                [
                    82.5831391,
                    54.9299201
                ],
                [
                    82.5834098,
                    54.9304972
                ],
                [
                    82.5830822,
                    54.9317619
                ],
                [
                    82.5827117,
                    54.9326296
                ],
                [
                    82.5826548,
                    54.9331534
                ],
                [
                    82.5821561,
                    54.9335177
                ],
                [
                    82.5812585,
                    54.9337714
                ],
                [
                    82.5798481,
                    54.9339638
                ],
                [
                    82.5788508,
                    54.9337551
                ],
                [
                    82.5778535,
                    54.9332107
                ],
                [
                    82.5771625,
                    54.9326214
                ],
                [
                    82.575111,
                    54.9324822
                ],
                [
                    82.573323,
                    54.9344181
                ],
                [
                    82.5722758,
                    54.9350401
                ],
                [
                    82.5732802,
                    54.9357399
                ],
                [
                    82.5728101,
                    54.9375078
                ],
                [
                    82.5736221,
                    54.9380275
                ],
                [
                    82.5717415,
                    54.939157
                ]
            ],
            "longitude": 82.5847296,
            "latitude": 54.9343119
        },
        "3550": {
            "name": "Шипуново",
            "population": 1379,
            "type": "village",
            "poly": [
                [
                    82.5724769,
                    54.0128316
                ],
                [
                    82.5751136,
                    54.0154653
                ],
                [
                    82.5916804,
                    54.0073098
                ],
                [
                    82.5954207,
                    54.007846
                ],
                [
                    82.602947,
                    54.0069613
                ],
                [
                    82.6042242,
                    54.0046023
                ],
                [
                    82.6108839,
                    54.0027793
                ],
                [
                    82.6198242,
                    54.0066933
                ],
                [
                    82.6238382,
                    54.0070686
                ],
                [
                    82.6247961,
                    54.0045755
                ],
                [
                    82.6078733,
                    53.9988649
                ],
                [
                    82.6084207,
                    53.9981142
                ],
                [
                    82.6199154,
                    53.9987309
                ],
                [
                    82.622561,
                    53.9953524
                ],
                [
                    82.6204628,
                    53.9946284
                ],
                [
                    82.6076909,
                    53.9935022
                ],
                [
                    82.6079189,
                    53.9913569
                ],
                [
                    82.6080102,
                    53.9871733
                ],
                [
                    82.6134402,
                    53.9868362
                ],
                [
                    82.6203259,
                    53.9876609
                ],
                [
                    82.6148428,
                    53.9860865
                ],
                [
                    82.6110812,
                    53.9856741
                ],
                [
                    82.606682,
                    53.9854867
                ],
                [
                    82.604726,
                    53.9876024
                ],
                [
                    82.6057751,
                    53.9912228
                ],
                [
                    82.602719,
                    53.9889701
                ],
                [
                    82.6009856,
                    53.9893724
                ],
                [
                    82.5979751,
                    53.9877633
                ],
                [
                    82.5962418,
                    53.9891042
                ],
                [
                    82.6002102,
                    53.9933413
                ],
                [
                    82.6014874,
                    53.9941458
                ],
                [
                    82.6052277,
                    53.9955133
                ],
                [
                    82.6037681,
                    53.9967467
                ],
                [
                    82.5992067,
                    53.9948429
                ],
                [
                    82.5954663,
                    53.9926173
                ],
                [
                    82.5930944,
                    53.9934486
                ],
                [
                    82.5933225,
                    53.9955937
                ],
                [
                    82.5954207,
                    53.9980069
                ],
                [
                    82.5913611,
                    53.9986236
                ],
                [
                    82.5899471,
                    54.00042
                ],
                [
                    82.587119,
                    54.0026184
                ],
                [
                    82.5878488,
                    54.0031278
                ],
                [
                    82.5843365,
                    54.0053529
                ],
                [
                    82.5848839,
                    54.0064788
                ],
                [
                    82.5841541,
                    54.0072562
                ],
                [
                    82.5832874,
                    54.0065592
                ],
                [
                    82.5825576,
                    54.0068005
                ],
                [
                    82.5778594,
                    54.0075243
                ],
                [
                    82.5764453,
                    54.0084625
                ],
                [
                    82.5780418,
                    54.0105265
                ],
                [
                    82.5724769,
                    54.0128316
                ]
            ],
            "longitude": 82.597343,
            "latitude": 54.003105
        },
        "3551": {
            "name": "Ярково",
            "population": 5379,
            "type": "village",
            "poly": [
                [
                    82.5794186,
                    54.7996137
                ],
                [
                    82.5908183,
                    54.8130354
                ],
                [
                    82.6048236,
                    54.8152876
                ],
                [
                    82.6214345,
                    54.8062782
                ],
                [
                    82.6160483,
                    54.8031501
                ],
                [
                    82.6001009,
                    54.793887
                ],
                [
                    82.5794186,
                    54.7996137
                ]
            ],
            "longitude": 82.6035041,
            "latitude": 54.8062688
        },
        "3552": {
            "name": "Боровое",
            "population": 1694,
            "type": "village",
            "poly": [
                [
                    82.6152318,
                    54.6870934
                ],
                [
                    82.6223253,
                    54.6989372
                ],
                [
                    82.6262742,
                    54.6995684
                ],
                [
                    82.6444745,
                    54.702476
                ],
                [
                    82.6475372,
                    54.7010633
                ],
                [
                    82.6522803,
                    54.6972587
                ],
                [
                    82.6409582,
                    54.6874678
                ],
                [
                    82.6248586,
                    54.6825203
                ],
                [
                    82.6240257,
                    54.6822643
                ],
                [
                    82.6207809,
                    54.6840461
                ],
                [
                    82.6152318,
                    54.6870934
                ]
            ],
            "longitude": 82.634216,
            "latitude": 54.692944
        },
        "3553": {
            "name": "Советский",
            "population": 374,
            "type": "village",
            "poly": [
                [
                    82.6684209,
                    54.4509787
                ],
                [
                    82.6702393,
                    54.4517797
                ],
                [
                    82.6703771,
                    54.4521161
                ],
                [
                    82.6723884,
                    54.4531412
                ],
                [
                    82.6723608,
                    54.4533975
                ],
                [
                    82.6721129,
                    54.4534936
                ],
                [
                    82.673766,
                    54.4550153
                ],
                [
                    82.6750334,
                    54.4554478
                ],
                [
                    82.6759151,
                    54.4555599
                ],
                [
                    82.6763284,
                    54.456585
                ],
                [
                    82.6770447,
                    54.456617
                ],
                [
                    82.6784877,
                    54.4561093
                ],
                [
                    82.6796897,
                    54.4565209
                ],
                [
                    82.6788356,
                    54.4570174
                ],
                [
                    82.6786152,
                    54.4579303
                ],
                [
                    82.6796071,
                    54.4577542
                ],
                [
                    82.6806541,
                    54.4572416
                ],
                [
                    82.6802959,
                    54.4570174
                ],
                [
                    82.6812051,
                    54.4566651
                ],
                [
                    82.6820041,
                    54.456649
                ],
                [
                    82.681949,
                    54.4555439
                ],
                [
                    82.6810673,
                    54.4557361
                ],
                [
                    82.6805714,
                    54.4551114
                ],
                [
                    82.6809847,
                    54.4550153
                ],
                [
                    82.6805714,
                    54.454695
                ],
                [
                    82.6815357,
                    54.4543586
                ],
                [
                    82.6804887,
                    54.4532213
                ],
                [
                    82.686936,
                    54.4511229
                ],
                [
                    82.6867982,
                    54.4509307
                ],
                [
                    82.6877901,
                    54.4505302
                ],
                [
                    82.6873493,
                    54.4502098
                ],
                [
                    82.687983,
                    54.4500336
                ],
                [
                    82.6847593,
                    54.4490725
                ],
                [
                    82.6841807,
                    54.4486079
                ],
                [
                    82.684291,
                    54.4483035
                ],
                [
                    82.6829409,
                    54.4475025
                ],
                [
                    82.6825552,
                    54.4475185
                ],
                [
                    82.6815908,
                    54.4467015
                ],
                [
                    82.6811776,
                    54.4467335
                ],
                [
                    82.6770723,
                    54.4444105
                ],
                [
                    82.6758324,
                    54.4449071
                ],
                [
                    82.6789734,
                    54.4480472
                ],
                [
                    82.674813,
                    54.4497132
                ],
                [
                    82.6734905,
                    54.4486239
                ],
                [
                    82.6726915,
                    54.448736
                ],
                [
                    82.6723884,
                    54.4483836
                ],
                [
                    82.6697434,
                    54.4489763
                ],
                [
                    82.6691372,
                    54.4495691
                ],
                [
                    82.6704046,
                    54.4506904
                ],
                [
                    82.6684209,
                    54.4509787
                ]
            ],
            "longitude": 82.678215,
            "latitude": 54.451546
        },
        "3554": {
            "name": "Красноглинное",
            "population": 1382,
            "type": "village",
            "poly": [
                [
                    82.6863714,
                    54.9657991
                ],
                [
                    82.6900473,
                    54.9684317
                ],
                [
                    82.6956445,
                    54.9702879
                ],
                [
                    82.6954841,
                    54.9730167
                ],
                [
                    82.6952521,
                    54.9758567
                ],
                [
                    82.6996335,
                    54.9762857
                ],
                [
                    82.7037572,
                    54.9764484
                ],
                [
                    82.7079839,
                    54.9761822
                ],
                [
                    82.7082417,
                    54.9734456
                ],
                [
                    82.7096592,
                    54.9719664
                ],
                [
                    82.7113615,
                    54.9702117
                ],
                [
                    82.7094817,
                    54.9691991
                ],
                [
                    82.7099169,
                    54.9686082
                ],
                [
                    82.7079582,
                    54.9657676
                ],
                [
                    82.7024502,
                    54.9659093
                ],
                [
                    82.6984826,
                    54.967727
                ],
                [
                    82.6947823,
                    54.966265
                ],
                [
                    82.6914819,
                    54.9638983
                ],
                [
                    82.6863714,
                    54.9657991
                ]
            ],
            "longitude": 82.7041201,
            "latitude": 54.9716723
        },
        "3555": {
            "name": "Пихтовка",
            "population": 673,
            "type": "village",
            "poly": null,
            "longitude": 82.711868,
            "latitude": 55.989109
        },
        "3556": {
            "name": "Большой Оёш",
            "population": 669,
            "type": "village",
            "poly": null,
            "longitude": 82.715936,
            "latitude": 55.2894615
        },
        "3557": {
            "name": "Преображенка",
            "population": 585,
            "type": "village",
            "poly": [
                [
                    82.6963726,
                    54.3695796
                ],
                [
                    82.6970466,
                    54.3696425
                ],
                [
                    82.6970196,
                    54.3700194
                ],
                [
                    82.6986913,
                    54.3700508
                ],
                [
                    82.6994192,
                    54.3701608
                ],
                [
                    82.6990957,
                    54.3716529
                ],
                [
                    82.7028703,
                    54.3715586
                ],
                [
                    82.7027625,
                    54.370255
                ],
                [
                    82.7020884,
                    54.3678205
                ],
                [
                    82.7002281,
                    54.3676163
                ],
                [
                    82.7007673,
                    54.3669723
                ],
                [
                    82.7023153,
                    54.3671057
                ],
                [
                    82.7051351,
                    54.3671922
                ],
                [
                    82.7043263,
                    54.3697053
                ],
                [
                    82.7049464,
                    54.3697524
                ],
                [
                    82.7050812,
                    54.370522
                ],
                [
                    82.7071303,
                    54.3705063
                ],
                [
                    82.7070169,
                    54.3719643
                ],
                [
                    82.7074808,
                    54.3720493
                ],
                [
                    82.7078522,
                    54.3717388
                ],
                [
                    82.7081682,
                    54.3717053
                ],
                [
                    82.7090176,
                    54.3717471
                ],
                [
                    82.7095299,
                    54.371967
                ],
                [
                    82.7098036,
                    54.3720237
                ],
                [
                    82.7110228,
                    54.3711437
                ],
                [
                    82.7110935,
                    54.3693629
                ],
                [
                    82.7131296,
                    54.3679455
                ],
                [
                    82.7131469,
                    54.3672519
                ],
                [
                    82.7158732,
                    54.3672921
                ],
                [
                    82.7158905,
                    54.3685185
                ],
                [
                    82.7152693,
                    54.3685788
                ],
                [
                    82.7153211,
                    54.3697047
                ],
                [
                    82.7170967,
                    54.3702063
                ],
                [
                    82.7181922,
                    54.3696134
                ],
                [
                    82.7183185,
                    54.367232
                ],
                [
                    82.7186636,
                    54.3672823
                ],
                [
                    82.7187343,
                    54.3682272
                ],
                [
                    82.7213663,
                    54.3682048
                ],
                [
                    82.7213884,
                    54.3680489
                ],
                [
                    82.7265678,
                    54.3679717
                ],
                [
                    82.7265347,
                    54.3681711
                ],
                [
                    82.7263248,
                    54.3681969
                ],
                [
                    82.7260488,
                    54.3685121
                ],
                [
                    82.7260488,
                    54.3687051
                ],
                [
                    82.7266009,
                    54.368718
                ],
                [
                    82.726623,
                    54.3692649
                ],
                [
                    82.7292624,
                    54.3691748
                ],
                [
                    82.7295827,
                    54.3689689
                ],
                [
                    82.7295385,
                    54.3686794
                ],
                [
                    82.7292072,
                    54.3686408
                ],
                [
                    82.7291188,
                    54.3682805
                ],
                [
                    82.7293508,
                    54.368287
                ],
                [
                    82.7293736,
                    54.3680561
                ],
                [
                    82.7290231,
                    54.3666424
                ],
                [
                    82.7287535,
                    54.3666424
                ],
                [
                    82.7282682,
                    54.3641448
                ],
                [
                    82.7283761,
                    54.363375
                ],
                [
                    82.7207189,
                    54.3629666
                ],
                [
                    82.7210964,
                    54.3619455
                ],
                [
                    82.7180767,
                    54.3614114
                ],
                [
                    82.7166747,
                    54.3640191
                ],
                [
                    82.7160007,
                    54.3642076
                ],
                [
                    82.7145178,
                    54.3636107
                ],
                [
                    82.713655,
                    54.3637206
                ],
                [
                    82.7160815,
                    54.3670979
                ],
                [
                    82.7130888,
                    54.3670665
                ],
                [
                    82.7099882,
                    54.3605002
                ],
                [
                    82.7086132,
                    54.3604216
                ],
                [
                    82.7089367,
                    54.3571695
                ],
                [
                    82.7065371,
                    54.3571067
                ],
                [
                    82.7060788,
                    54.362244
                ],
                [
                    82.7055126,
                    54.3622597
                ],
                [
                    82.7059709,
                    54.3661712
                ],
                [
                    82.7062945,
                    54.3664068
                ],
                [
                    82.7061327,
                    54.3667209
                ],
                [
                    82.705189,
                    54.3664539
                ],
                [
                    82.7050273,
                    54.3667681
                ],
                [
                    82.7028703,
                    54.3666738
                ],
                [
                    82.7032478,
                    54.3660612
                ],
                [
                    82.7006595,
                    54.3646789
                ],
                [
                    82.6976667,
                    54.3639249
                ],
                [
                    82.6971275,
                    54.3654957
                ],
                [
                    82.6993383,
                    54.3660455
                ],
                [
                    82.6991496,
                    54.3667523
                ],
                [
                    82.6999874,
                    54.3668936
                ],
                [
                    82.6998776,
                    54.3676634
                ],
                [
                    82.6965074,
                    54.3676163
                ],
                [
                    82.6963726,
                    54.3695796
                ]
            ],
            "longitude": 82.718483,
            "latitude": 54.365505
        },
        "3558": {
            "name": "Толмачёво",
            "population": 4608,
            "type": "village",
            "poly": [
                [
                    82.7094478,
                    54.9794498
                ],
                [
                    82.7110838,
                    54.9802152
                ],
                [
                    82.7134457,
                    54.9816158
                ],
                [
                    82.7180238,
                    54.983713
                ],
                [
                    82.7212994,
                    54.9846255
                ],
                [
                    82.7228641,
                    54.9850342
                ],
                [
                    82.7267758,
                    54.9857313
                ],
                [
                    82.7310055,
                    54.9870086
                ],
                [
                    82.7340586,
                    54.9885231
                ],
                [
                    82.7357559,
                    54.9898307
                ],
                [
                    82.7379937,
                    54.9907554
                ],
                [
                    82.7405576,
                    54.9899588
                ],
                [
                    82.7521094,
                    54.9874003
                ],
                [
                    82.7556328,
                    54.9863162
                ],
                [
                    82.7562362,
                    54.9856583
                ],
                [
                    82.7558139,
                    54.9848632
                ],
                [
                    82.7534436,
                    54.9853705
                ],
                [
                    82.7532873,
                    54.9848021
                ],
                [
                    82.7511562,
                    54.9831115
                ],
                [
                    82.7489428,
                    54.9809686
                ],
                [
                    82.7448338,
                    54.9770868
                ],
                [
                    82.7391222,
                    54.9731708
                ],
                [
                    82.7381343,
                    54.9725029
                ],
                [
                    82.7343668,
                    54.9729631
                ],
                [
                    82.7332515,
                    54.9725301
                ],
                [
                    82.7336624,
                    54.9718328
                ],
                [
                    82.7321617,
                    54.9710432
                ],
                [
                    82.7324565,
                    54.9706536
                ],
                [
                    82.7305807,
                    54.9687822
                ],
                [
                    82.7299108,
                    54.9684899
                ],
                [
                    82.728035,
                    54.9700178
                ],
                [
                    82.7221822,
                    54.9742417
                ],
                [
                    82.7205213,
                    54.9753792
                ],
                [
                    82.7183581,
                    54.9765727
                ],
                [
                    82.7168368,
                    54.9777581
                ],
                [
                    82.7156784,
                    54.9775419
                ],
                [
                    82.7153574,
                    54.9777742
                ],
                [
                    82.7106261,
                    54.9775339
                ],
                [
                    82.7102352,
                    54.9782627
                ],
                [
                    82.7101097,
                    54.9787033
                ],
                [
                    82.7094478,
                    54.9794498
                ]
            ],
            "longitude": 82.7365758,
            "latitude": 54.9828438
        },
        "3559": {
            "name": "Крупской",
            "population": 586,
            "type": "village",
            "poly": [
                [
                    82.7307888,
                    54.8298279
                ],
                [
                    82.7384495,
                    54.8342588
                ],
                [
                    82.7465949,
                    54.8313918
                ],
                [
                    82.7333101,
                    54.8269792
                ],
                [
                    82.7307888,
                    54.8298279
                ]
            ],
            "longitude": 82.7382445,
            "latitude": 54.8303568
        },
        "3560": {
            "name": "Боярка",
            "population": 596,
            "type": "village",
            "poly": null,
            "longitude": 82.74057,
            "latitude": 55.617168
        },
        "3561": {
            "name": "Марусино",
            "population": 1933,
            "type": "village",
            "poly": [
                [
                    82.7468959,
                    55.0320052
                ],
                [
                    82.7470885,
                    55.0328421
                ],
                [
                    82.7477772,
                    55.0337292
                ],
                [
                    82.7496096,
                    55.0360894
                ],
                [
                    82.750642,
                    55.0363783
                ],
                [
                    82.7512778,
                    55.0372732
                ],
                [
                    82.7530726,
                    55.0378297
                ],
                [
                    82.7526669,
                    55.0380833
                ],
                [
                    82.750995,
                    55.0384637
                ],
                [
                    82.7513024,
                    55.0391963
                ],
                [
                    82.7502698,
                    55.0396612
                ],
                [
                    82.750726,
                    55.0433555
                ],
                [
                    82.7523791,
                    55.0443431
                ],
                [
                    82.7515261,
                    55.0445597
                ],
                [
                    82.7517684,
                    55.0449263
                ],
                [
                    82.7501009,
                    55.0453818
                ],
                [
                    82.7514388,
                    55.0468648
                ],
                [
                    82.7558683,
                    55.0457216
                ],
                [
                    82.7595882,
                    55.0445833
                ],
                [
                    82.7637731,
                    55.0429848
                ],
                [
                    82.7719314,
                    55.0395454
                ],
                [
                    82.7688879,
                    55.0371959
                ],
                [
                    82.76111,
                    55.0338529
                ],
                [
                    82.7580665,
                    55.0305339
                ],
                [
                    82.7566292,
                    55.0303158
                ],
                [
                    82.7551497,
                    55.0294194
                ],
                [
                    82.7478368,
                    55.0304854
                ],
                [
                    82.7474905,
                    55.0311395
                ],
                [
                    82.7468959,
                    55.0320052
                ]
            ],
            "longitude": 82.7567523,
            "latitude": 55.0384524
        },
        "3562": {
            "name": "Куриловка",
            "population": 376,
            "type": "village",
            "poly": [
                [
                    82.7446236,
                    54.213278
                ],
                [
                    82.7457117,
                    54.2156019
                ],
                [
                    82.7464262,
                    54.2169826
                ],
                [
                    82.7474505,
                    54.2172516
                ],
                [
                    82.7558637,
                    54.216849
                ],
                [
                    82.7568358,
                    54.2184899
                ],
                [
                    82.7629703,
                    54.2180798
                ],
                [
                    82.7675499,
                    54.2177127
                ],
                [
                    82.7709526,
                    54.2143902
                ],
                [
                    82.7675758,
                    54.2134028
                ],
                [
                    82.7601283,
                    54.2134333
                ],
                [
                    82.7569328,
                    54.2125105
                ],
                [
                    82.7515325,
                    54.2120768
                ],
                [
                    82.7507193,
                    54.2118434
                ],
                [
                    82.7455032,
                    54.2128321
                ],
                [
                    82.7446236,
                    54.213278
                ]
            ],
            "longitude": 82.764656,
            "latitude": 54.214832
        },
        "3563": {
            "name": "Приобский",
            "population": 963,
            "type": "village",
            "poly": null,
            "longitude": 82.7710683,
            "latitude": 55.0691851
        },
        "3564": {
            "name": "Кудряшовский",
            "population": 4559,
            "type": "village",
            "poly": null,
            "longitude": 82.7722973,
            "latitude": 55.0978396
        },
        "3565": {
            "name": "Амба",
            "population": 385,
            "type": "village",
            "poly": null,
            "longitude": 82.772499,
            "latitude": 55.437855
        },
        "3566": {
            "name": "Скала",
            "population": 1773,
            "type": "village",
            "poly": null,
            "longitude": 82.772743,
            "latitude": 55.379478
        },
        "3567": {
            "name": "Верх-Тула",
            "population": 6020,
            "type": "village",
            "poly": [
                [
                    82.7563255,
                    54.8688175
                ],
                [
                    82.7579519,
                    54.8736343
                ],
                [
                    82.7569734,
                    54.874818
                ],
                [
                    82.7566729,
                    54.8801684
                ],
                [
                    82.7571612,
                    54.8812065
                ],
                [
                    82.7651868,
                    54.8855403
                ],
                [
                    82.769158,
                    54.887181
                ],
                [
                    82.7702886,
                    54.8886629
                ],
                [
                    82.7710972,
                    54.8890282
                ],
                [
                    82.7717877,
                    54.8889624
                ],
                [
                    82.7729225,
                    54.889829
                ],
                [
                    82.7739061,
                    54.8902149
                ],
                [
                    82.774703,
                    54.8907843
                ],
                [
                    82.775488,
                    54.8910475
                ],
                [
                    82.7784901,
                    54.8919528
                ],
                [
                    82.7797209,
                    54.89252
                ],
                [
                    82.7809793,
                    54.8931915
                ],
                [
                    82.7818236,
                    54.8937769
                ],
                [
                    82.7832635,
                    54.8940355
                ],
                [
                    82.7838146,
                    54.8941914
                ],
                [
                    82.7936222,
                    54.8996219
                ],
                [
                    82.7951142,
                    54.8990565
                ],
                [
                    82.7950838,
                    54.8987268
                ],
                [
                    82.7957874,
                    54.8985488
                ],
                [
                    82.7960282,
                    54.8981127
                ],
                [
                    82.7959133,
                    54.89731
                ],
                [
                    82.7952944,
                    54.8970605
                ],
                [
                    82.7948476,
                    54.8967947
                ],
                [
                    82.7946626,
                    54.896613
                ],
                [
                    82.7942003,
                    54.8956781
                ],
                [
                    82.793923,
                    54.895266
                ],
                [
                    82.7932218,
                    54.8949603
                ],
                [
                    82.7921585,
                    54.8940564
                ],
                [
                    82.7920815,
                    54.8937551
                ],
                [
                    82.7921354,
                    54.8935468
                ],
                [
                    82.79212,
                    54.8933341
                ],
                [
                    82.7918658,
                    54.8930816
                ],
                [
                    82.7914882,
                    54.892891
                ],
                [
                    82.7909643,
                    54.892922
                ],
                [
                    82.790633,
                    54.89286
                ],
                [
                    82.7903325,
                    54.892634
                ],
                [
                    82.7903111,
                    54.8926029
                ],
                [
                    82.7901553,
                    54.892377
                ],
                [
                    82.7899935,
                    54.8918231
                ],
                [
                    82.7897777,
                    54.8915129
                ],
                [
                    82.789354,
                    54.8913268
                ],
                [
                    82.7890213,
                    54.8911162
                ],
                [
                    82.7888763,
                    54.8908659
                ],
                [
                    82.7884987,
                    54.8906488
                ],
                [
                    82.7884217,
                    54.8904804
                ],
                [
                    82.7888069,
                    54.8898733
                ],
                [
                    82.7886913,
                    54.8895719
                ],
                [
                    82.7883831,
                    54.8894877
                ],
                [
                    82.7877436,
                    54.8893193
                ],
                [
                    82.7872274,
                    54.8889205
                ],
                [
                    82.7870733,
                    54.8886236
                ],
                [
                    82.787104,
                    54.888114
                ],
                [
                    82.7870662,
                    54.8880434
                ],
                [
                    82.7869731,
                    54.8878702
                ],
                [
                    82.7867074,
                    54.8875061
                ],
                [
                    82.7867651,
                    54.8871478
                ],
                [
                    82.7870733,
                    54.8867357
                ],
                [
                    82.7873815,
                    54.8863147
                ],
                [
                    82.7874585,
                    54.8859468
                ],
                [
                    82.7873044,
                    54.885805
                ],
                [
                    82.7872428,
                    54.8855701
                ],
                [
                    82.7873276,
                    54.8853972
                ],
                [
                    82.7873122,
                    54.8851092
                ],
                [
                    82.7870887,
                    54.884954
                ],
                [
                    82.7867728,
                    54.8848388
                ],
                [
                    82.786248,
                    54.8848329
                ],
                [
                    82.7858635,
                    54.8847669
                ],
                [
                    82.7855525,
                    54.8846774
                ],
                [
                    82.785234,
                    54.8843728
                ],
                [
                    82.7851027,
                    54.8843101
                ],
                [
                    82.7842477,
                    54.8839019
                ],
                [
                    82.7842263,
                    54.8838779
                ],
                [
                    82.7838778,
                    54.8834878
                ],
                [
                    82.784016,
                    54.8827673
                ],
                [
                    82.78394,
                    54.8826381
                ],
                [
                    82.7835623,
                    54.8819957
                ],
                [
                    82.7815257,
                    54.8805688
                ],
                [
                    82.7809006,
                    54.8803552
                ],
                [
                    82.7792901,
                    54.8791019
                ],
                [
                    82.7778897,
                    54.8778248
                ],
                [
                    82.7768983,
                    54.8768189
                ],
                [
                    82.7773538,
                    54.8747733
                ],
                [
                    82.7773057,
                    54.8744519
                ],
                [
                    82.7780644,
                    54.8732089
                ],
                [
                    82.7781243,
                    54.8731108
                ],
                [
                    82.77855,
                    54.872795
                ],
                [
                    82.7794245,
                    54.8723904
                ],
                [
                    82.7789141,
                    54.8716478
                ],
                [
                    82.7780569,
                    54.8698411
                ],
                [
                    82.7775657,
                    54.8694864
                ],
                [
                    82.7768627,
                    54.8693368
                ],
                [
                    82.7764004,
                    54.8691206
                ],
                [
                    82.7759284,
                    54.8683946
                ],
                [
                    82.7753698,
                    54.8683613
                ],
                [
                    82.7747631,
                    54.8683503
                ],
                [
                    82.7741865,
                    54.8679771
                ],
                [
                    82.7741902,
                    54.8670498
                ],
                [
                    82.7703949,
                    54.8622419
                ],
                [
                    82.7672109,
                    54.8640587
                ],
                [
                    82.7653794,
                    54.8651038
                ],
                [
                    82.7584527,
                    54.8690944
                ],
                [
                    82.7573278,
                    54.8683761
                ],
                [
                    82.7563255,
                    54.8688175
                ]
            ],
            "longitude": 82.7739688,
            "latitude": 54.8824491
        },
        "3568": {
            "name": "8 Марта",
            "population": 334,
            "type": "village",
            "poly": [
                [
                    82.8009661,
                    54.9113654
                ],
                [
                    82.8064586,
                    54.9197496
                ],
                [
                    82.8091811,
                    54.9189413
                ],
                [
                    82.8107143,
                    54.9185732
                ],
                [
                    82.8114827,
                    54.9183887
                ],
                [
                    82.8101376,
                    54.9159405
                ],
                [
                    82.8088564,
                    54.9148415
                ],
                [
                    82.8066594,
                    54.9107077
                ],
                [
                    82.801159,
                    54.9112828
                ],
                [
                    82.8009661,
                    54.9113654
                ]
            ],
            "longitude": 82.8067234,
            "latitude": 54.9150847
        },
        "3569": {
            "name": "Горевка",
            "population": 284,
            "type": "village",
            "poly": [
                [
                    82.8005735,
                    54.4271707
                ],
                [
                    82.8009941,
                    54.4273273
                ],
                [
                    82.802026,
                    54.4277502
                ],
                [
                    82.8028703,
                    54.4278867
                ],
                [
                    82.8034097,
                    54.4281868
                ],
                [
                    82.8048872,
                    54.4283232
                ],
                [
                    82.8062709,
                    54.4285415
                ],
                [
                    82.8066461,
                    54.427682
                ],
                [
                    82.8076076,
                    54.4277775
                ],
                [
                    82.8084519,
                    54.4280504
                ],
                [
                    82.8099832,
                    54.4291115
                ],
                [
                    82.8101849,
                    54.4292065
                ],
                [
                    82.8101273,
                    54.4292959
                ],
                [
                    82.810281,
                    54.4294356
                ],
                [
                    82.8102233,
                    54.4296033
                ],
                [
                    82.8105307,
                    54.4297597
                ],
                [
                    82.8105747,
                    54.4298618
                ],
                [
                    82.8107547,
                    54.4299637
                ],
                [
                    82.8108669,
                    54.4300279
                ],
                [
                    82.8116834,
                    54.4304526
                ],
                [
                    82.811597,
                    54.4305811
                ],
                [
                    82.8138448,
                    54.432073
                ],
                [
                    82.8137583,
                    54.4321624
                ],
                [
                    82.8139409,
                    54.4322574
                ],
                [
                    82.814229,
                    54.4322127
                ],
                [
                    82.8143827,
                    54.43233
                ],
                [
                    82.8146997,
                    54.4322127
                ],
                [
                    82.8151224,
                    54.4325759
                ],
                [
                    82.8153529,
                    54.4324809
                ],
                [
                    82.8155835,
                    54.4326038
                ],
                [
                    82.8162079,
                    54.4322295
                ],
                [
                    82.8160542,
                    54.4317266
                ],
                [
                    82.8156219,
                    54.431112
                ],
                [
                    82.8157372,
                    54.4309499
                ],
                [
                    82.815084,
                    54.4304079
                ],
                [
                    82.8152665,
                    54.4302403
                ],
                [
                    82.814498,
                    54.42962
                ],
                [
                    82.8158525,
                    54.4288154
                ],
                [
                    82.8153625,
                    54.4283125
                ],
                [
                    82.8146421,
                    54.4286422
                ],
                [
                    82.8145364,
                    54.4282789
                ],
                [
                    82.8149879,
                    54.4280442
                ],
                [
                    82.8146421,
                    54.4277648
                ],
                [
                    82.8150263,
                    54.4275469
                ],
                [
                    82.8151704,
                    54.427614
                ],
                [
                    82.8157948,
                    54.4272395
                ],
                [
                    82.8154202,
                    54.4269322
                ],
                [
                    82.8154874,
                    54.426759
                ],
                [
                    82.8159371,
                    54.42657
                ],
                [
                    82.8163505,
                    54.4265251
                ],
                [
                    82.8169647,
                    54.4267239
                ],
                [
                    82.8176104,
                    54.427111
                ],
                [
                    82.818619,
                    54.4276922
                ],
                [
                    82.8192626,
                    54.4278095
                ],
                [
                    82.8198101,
                    54.4283907
                ],
                [
                    82.8196468,
                    54.4285136
                ],
                [
                    82.8200695,
                    54.4289495
                ],
                [
                    82.8210877,
                    54.4286142
                ],
                [
                    82.8208737,
                    54.4284474
                ],
                [
                    82.8213494,
                    54.4281299
                ],
                [
                    82.8207899,
                    54.4275078
                ],
                [
                    82.8198005,
                    54.4269266
                ],
                [
                    82.81957,
                    54.4266807
                ],
                [
                    82.8207803,
                    54.4258984
                ],
                [
                    82.8200017,
                    54.4254913
                ],
                [
                    82.8191497,
                    54.4249677
                ],
                [
                    82.8173894,
                    54.423853
                ],
                [
                    82.8163616,
                    54.4232103
                ],
                [
                    82.8145833,
                    54.4217288
                ],
                [
                    82.8137423,
                    54.4210842
                ],
                [
                    82.8124625,
                    54.4207874
                ],
                [
                    82.8105211,
                    54.4203152
                ],
                [
                    82.8076297,
                    54.420019
                ],
                [
                    82.8072755,
                    54.4201868
                ],
                [
                    82.8033274,
                    54.4218871
                ],
                [
                    82.8036314,
                    54.4221453
                ],
                [
                    82.8024521,
                    54.4227688
                ],
                [
                    82.8023464,
                    54.4230147
                ],
                [
                    82.8044501,
                    54.4244118
                ],
                [
                    82.8036816,
                    54.425876
                ],
                [
                    82.8026634,
                    54.4257139
                ],
                [
                    82.8018373,
                    54.4269769
                ],
                [
                    82.8007656,
                    54.4268048
                ],
                [
                    82.8005735,
                    54.4271707
                ]
            ],
            "longitude": 82.811096,
            "latitude": 54.424938
        },
        "3570": {
            "name": "Тулинский",
            "population": 2277,
            "type": "village",
            "poly": [
                [
                    82.8245519,
                    54.9162983
                ],
                [
                    82.8246008,
                    54.9167135
                ],
                [
                    82.8252375,
                    54.9171885
                ],
                [
                    82.8259721,
                    54.9177408
                ],
                [
                    82.8269515,
                    54.9180082
                ],
                [
                    82.8277534,
                    54.9181208
                ],
                [
                    82.8296694,
                    54.9183987
                ],
                [
                    82.8303549,
                    54.9184374
                ],
                [
                    82.8323321,
                    54.9183284
                ],
                [
                    82.8335747,
                    54.9181912
                ],
                [
                    82.8345174,
                    54.9180082
                ],
                [
                    82.835405,
                    54.9179836
                ],
                [
                    82.836262,
                    54.9179977
                ],
                [
                    82.836767,
                    54.9175236
                ],
                [
                    82.8365528,
                    54.9168463
                ],
                [
                    82.8373332,
                    54.9167891
                ],
                [
                    82.8454516,
                    54.9165297
                ],
                [
                    82.8454134,
                    54.9156325
                ],
                [
                    82.8434316,
                    54.915694
                ],
                [
                    82.8419624,
                    54.915694
                ],
                [
                    82.8409426,
                    54.9157401
                ],
                [
                    82.8408912,
                    54.9157424
                ],
                [
                    82.8406234,
                    54.9152322
                ],
                [
                    82.8404551,
                    54.9145066
                ],
                [
                    82.8402715,
                    54.9136313
                ],
                [
                    82.8388483,
                    54.9136753
                ],
                [
                    82.8386187,
                    54.9129144
                ],
                [
                    82.8375169,
                    54.912998
                ],
                [
                    82.8371955,
                    54.9128
                ],
                [
                    82.8368971,
                    54.911828
                ],
                [
                    82.8363997,
                    54.9104117
                ],
                [
                    82.8376928,
                    54.9102709
                ],
                [
                    82.8374863,
                    54.9097501
                ],
                [
                    82.8365742,
                    54.9081595
                ],
                [
                    82.8358825,
                    54.9072727
                ],
                [
                    82.8352275,
                    54.907139
                ],
                [
                    82.8342297,
                    54.9072938
                ],
                [
                    82.8325341,
                    54.9075859
                ],
                [
                    82.8312058,
                    54.9078358
                ],
                [
                    82.8293388,
                    54.9082088
                ],
                [
                    82.8279553,
                    54.9082475
                ],
                [
                    82.8272882,
                    54.9086487
                ],
                [
                    82.8268903,
                    54.9093032
                ],
                [
                    82.826119,
                    54.9129698
                ],
                [
                    82.8254518,
                    54.9140958
                ],
                [
                    82.8251518,
                    54.914613
                ],
                [
                    82.8249376,
                    54.9156967
                ],
                [
                    82.8245519,
                    54.9162983
                ]
            ],
            "longitude": 82.83269,
            "latitude": 54.9133924
        },
        "3571": {
            "name": "Бурмистрово",
            "population": 1499,
            "type": "village",
            "poly": [
                [
                    82.8152693,
                    54.6259727
                ],
                [
                    82.8200357,
                    54.6357823
                ],
                [
                    82.8238695,
                    54.6391451
                ],
                [
                    82.8222237,
                    54.6406642
                ],
                [
                    82.8197286,
                    54.6435942
                ],
                [
                    82.8219883,
                    54.6441722
                ],
                [
                    82.823752,
                    54.6446093
                ],
                [
                    82.8261533,
                    54.6440731
                ],
                [
                    82.8306739,
                    54.646354
                ],
                [
                    82.8359487,
                    54.6456661
                ],
                [
                    82.8376212,
                    54.6460305
                ],
                [
                    82.8413573,
                    54.64823
                ],
                [
                    82.849367,
                    54.6510922
                ],
                [
                    82.8516532,
                    54.649914
                ],
                [
                    82.8462011,
                    54.6394818
                ],
                [
                    82.8496297,
                    54.6380076
                ],
                [
                    82.8507867,
                    54.6362409
                ],
                [
                    82.8501646,
                    54.6349741
                ],
                [
                    82.8501429,
                    54.6337709
                ],
                [
                    82.8507817,
                    54.6321951
                ],
                [
                    82.8509396,
                    54.631566
                ],
                [
                    82.8485144,
                    54.6309063
                ],
                [
                    82.844634,
                    54.6292919
                ],
                [
                    82.8422005,
                    54.6281779
                ],
                [
                    82.8390805,
                    54.6279301
                ],
                [
                    82.8340361,
                    54.6239709
                ],
                [
                    82.8325082,
                    54.6235778
                ],
                [
                    82.8266743,
                    54.623205
                ],
                [
                    82.8214727,
                    54.6250884
                ],
                [
                    82.8176584,
                    54.6255961
                ],
                [
                    82.8152693,
                    54.6259727
                ]
            ],
            "longitude": 82.8328767,
            "latitude": 54.6345591
        },
        "3572": {
            "name": "Мочище",
            "population": 3036,
            "type": "village",
            "poly": [
                [
                    82.8296872,
                    55.1347556
                ],
                [
                    82.8310925,
                    55.1363333
                ],
                [
                    82.834067,
                    55.1395171
                ],
                [
                    82.8384812,
                    55.1430146
                ],
                [
                    82.8408465,
                    55.1454777
                ],
                [
                    82.8419305,
                    55.1449666
                ],
                [
                    82.845457,
                    55.1469748
                ],
                [
                    82.8478298,
                    55.1484658
                ],
                [
                    82.8475601,
                    55.1486317
                ],
                [
                    82.8475549,
                    55.148691
                ],
                [
                    82.8472647,
                    55.1488272
                ],
                [
                    82.8475135,
                    55.1490048
                ],
                [
                    82.8472596,
                    55.1491263
                ],
                [
                    82.8478644,
                    55.1494956
                ],
                [
                    82.847529,
                    55.1496859
                ],
                [
                    82.8476067,
                    55.1497777
                ],
                [
                    82.8472491,
                    55.1499909
                ],
                [
                    82.8462284,
                    55.1505209
                ],
                [
                    82.8460315,
                    55.1508733
                ],
                [
                    82.8472958,
                    55.1519333
                ],
                [
                    82.8471507,
                    55.1520014
                ],
                [
                    82.8475808,
                    55.1523744
                ],
                [
                    82.8468243,
                    55.1528067
                ],
                [
                    82.8479591,
                    55.1537542
                ],
                [
                    82.8492696,
                    55.1545102
                ],
                [
                    82.8514717,
                    55.1562324
                ],
                [
                    82.8533382,
                    55.1581285
                ],
                [
                    82.8555229,
                    55.1573447
                ],
                [
                    82.8611488,
                    55.1538131
                ],
                [
                    82.8440685,
                    55.1364977
                ],
                [
                    82.8425235,
                    55.1368902
                ],
                [
                    82.8371012,
                    55.1328653
                ],
                [
                    82.8296872,
                    55.1347556
                ]
            ],
            "longitude": 82.8482862,
            "latitude": 55.1472168
        },
        "3573": {
            "name": "Ленинское",
            "population": 2453,
            "type": "village",
            "poly": null,
            "longitude": 82.8513507,
            "latitude": 54.8176197
        },
        "3574": {
            "name": "Шурыгино",
            "population": 978,
            "type": "village",
            "poly": [
                [
                    82.8406916,
                    54.0749296
                ],
                [
                    82.8419984,
                    54.0758577
                ],
                [
                    82.8417233,
                    54.0770683
                ],
                [
                    82.8774187,
                    54.086227
                ],
                [
                    82.8776251,
                    54.0848957
                ],
                [
                    82.8782441,
                    54.083645
                ],
                [
                    82.8801011,
                    54.0840485
                ],
                [
                    82.8812015,
                    54.083524
                ],
                [
                    82.8827833,
                    54.0844116
                ],
                [
                    82.8870476,
                    54.0831206
                ],
                [
                    82.8889733,
                    54.0812646
                ],
                [
                    82.8894548,
                    54.0802559
                ],
                [
                    82.8851217,
                    54.0776736
                ],
                [
                    82.8817517,
                    54.0764227
                ],
                [
                    82.8779002,
                    54.0694815
                ],
                [
                    82.8737048,
                    54.0675443
                ],
                [
                    82.871779,
                    54.0662931
                ],
                [
                    82.869303,
                    54.0655665
                ],
                [
                    82.8679961,
                    54.0646382
                ],
                [
                    82.8606371,
                    54.0639116
                ],
                [
                    82.853553,
                    54.0701676
                ],
                [
                    82.8500454,
                    54.0685936
                ],
                [
                    82.8452997,
                    54.0714994
                ],
                [
                    82.8438554,
                    54.0710151
                ],
                [
                    82.8406916,
                    54.0749296
                ]
            ],
            "longitude": 82.86483,
            "latitude": 54.075077
        },
        "3575": {
            "name": "Красный Яр",
            "population": 1952,
            "type": "village",
            "poly": [
                [
                    82.8904502,
                    55.217703
                ],
                [
                    82.892818,
                    55.2195646
                ],
                [
                    82.8940171,
                    55.2206036
                ],
                [
                    82.895535,
                    55.2211923
                ],
                [
                    82.9017582,
                    55.2222745
                ],
                [
                    82.9120746,
                    55.2238994
                ],
                [
                    82.9147877,
                    55.221616
                ],
                [
                    82.9168464,
                    55.2185592
                ],
                [
                    82.9065007,
                    55.2161486
                ],
                [
                    82.9047425,
                    55.2160987
                ],
                [
                    82.8953323,
                    55.2140003
                ],
                [
                    82.8945008,
                    55.2147053
                ],
                [
                    82.8932107,
                    55.215091
                ],
                [
                    82.8921305,
                    55.2157161
                ],
                [
                    82.8904502,
                    55.217703
                ]
            ],
            "longitude": 82.9044631,
            "latitude": 55.2187277
        },
        "3576": {
            "name": "Новолокти",
            "population": 633,
            "type": "village",
            "poly": [
                [
                    82.8981379,
                    54.3940727
                ],
                [
                    82.8984133,
                    54.3945507
                ],
                [
                    82.8988704,
                    54.3956868
                ],
                [
                    82.8989432,
                    54.3966328
                ],
                [
                    82.9008635,
                    54.3981498
                ],
                [
                    82.9017068,
                    54.3986961
                ],
                [
                    82.9034025,
                    54.3979483
                ],
                [
                    82.9041455,
                    54.3979473
                ],
                [
                    82.9046143,
                    54.3978664
                ],
                [
                    82.9049653,
                    54.3977466
                ],
                [
                    82.905236,
                    54.3977219
                ],
                [
                    82.9055213,
                    54.3974949
                ],
                [
                    82.9058165,
                    54.3974771
                ],
                [
                    82.9059368,
                    54.3974954
                ],
                [
                    82.9061852,
                    54.3973829
                ],
                [
                    82.9060981,
                    54.3975678
                ],
                [
                    82.9066521,
                    54.397778
                ],
                [
                    82.9068197,
                    54.3979711
                ],
                [
                    82.9070756,
                    54.3981875
                ],
                [
                    82.9076295,
                    54.3986441
                ],
                [
                    82.9086934,
                    54.3985855
                ],
                [
                    82.9096071,
                    54.3981458
                ],
                [
                    82.9095082,
                    54.3976452
                ],
                [
                    82.9088947,
                    54.3972472
                ],
                [
                    82.9091322,
                    54.3971504
                ],
                [
                    82.9096071,
                    54.3973302
                ],
                [
                    82.9101533,
                    54.3971366
                ],
                [
                    82.9090609,
                    54.3961274
                ],
                [
                    82.9118632,
                    54.3951181
                ],
                [
                    82.9128368,
                    54.3944683
                ],
                [
                    82.9133593,
                    54.3942609
                ],
                [
                    82.9133355,
                    54.3939982
                ],
                [
                    82.9149741,
                    54.3935004
                ],
                [
                    82.9151641,
                    54.3937355
                ],
                [
                    82.9163752,
                    54.3934313
                ],
                [
                    82.9165698,
                    54.3935944
                ],
                [
                    82.9167955,
                    54.3937349
                ],
                [
                    82.9171768,
                    54.3936986
                ],
                [
                    82.9174258,
                    54.3939387
                ],
                [
                    82.9182506,
                    54.3940293
                ],
                [
                    82.9184841,
                    54.3938798
                ],
                [
                    82.9168892,
                    54.3911544
                ],
                [
                    82.9167426,
                    54.3909281
                ],
                [
                    82.9147426,
                    54.3880707
                ],
                [
                    82.9134338,
                    54.3884926
                ],
                [
                    82.9131696,
                    54.3888427
                ],
                [
                    82.9124244,
                    54.3891232
                ],
                [
                    82.9121809,
                    54.3889548
                ],
                [
                    82.9119553,
                    54.3889186
                ],
                [
                    82.911286,
                    54.3891315
                ],
                [
                    82.9111226,
                    54.3890454
                ],
                [
                    82.9106295,
                    54.3889169
                ],
                [
                    82.9092706,
                    54.3883658
                ],
                [
                    82.9089318,
                    54.3882628
                ],
                [
                    82.9085125,
                    54.3884522
                ],
                [
                    82.9083335,
                    54.3885136
                ],
                [
                    82.9080193,
                    54.3882185
                ],
                [
                    82.9073096,
                    54.3879172
                ],
                [
                    82.9053486,
                    54.3871967
                ],
                [
                    82.9044174,
                    54.3866035
                ],
                [
                    82.9040146,
                    54.3866001
                ],
                [
                    82.9032367,
                    54.3868199
                ],
                [
                    82.903412,
                    54.3869406
                ],
                [
                    82.9029856,
                    54.3872399
                ],
                [
                    82.9027625,
                    54.3871563
                ],
                [
                    82.9019657,
                    54.3876807
                ],
                [
                    82.90189,
                    54.3876459
                ],
                [
                    82.9006469,
                    54.3885507
                ],
                [
                    82.9003202,
                    54.3890054
                ],
                [
                    82.899352,
                    54.3894044
                ],
                [
                    82.8991488,
                    54.3897245
                ],
                [
                    82.899619,
                    54.3901839
                ],
                [
                    82.8988062,
                    54.3905156
                ],
                [
                    82.8987225,
                    54.3909216
                ],
                [
                    82.8987978,
                    54.3913652
                ],
                [
                    82.8984852,
                    54.3915677
                ],
                [
                    82.8991195,
                    54.3921131
                ],
                [
                    82.8993396,
                    54.3925915
                ],
                [
                    82.8992253,
                    54.3930772
                ],
                [
                    82.8990742,
                    54.3932733
                ],
                [
                    82.8985225,
                    54.3936971
                ],
                [
                    82.8981379,
                    54.3940727
                ]
            ],
            "longitude": 82.908226,
            "latitude": 54.392899
        },
        "3577": {
            "name": "Верх-Мильтюши",
            "population": 995,
            "type": "village",
            "poly": [
                [
                    82.9004476,
                    54.2996404
                ],
                [
                    82.9008526,
                    54.3022666
                ],
                [
                    82.9047681,
                    54.3058905
                ],
                [
                    82.9080985,
                    54.3070458
                ],
                [
                    82.9102138,
                    54.3082799
                ],
                [
                    82.9134992,
                    54.310538
                ],
                [
                    82.9178197,
                    54.3110631
                ],
                [
                    82.9204751,
                    54.3093565
                ],
                [
                    82.9216452,
                    54.3065994
                ],
                [
                    82.9211051,
                    54.3030281
                ],
                [
                    82.9173697,
                    54.3014787
                ],
                [
                    82.9147144,
                    54.302608
                ],
                [
                    82.9108889,
                    54.2995616
                ],
                [
                    82.9062083,
                    54.299404
                ],
                [
                    82.9051282,
                    54.2981434
                ],
                [
                    82.9013477,
                    54.2982222
                ],
                [
                    82.9004476,
                    54.2996404
                ]
            ],
            "longitude": 82.909431,
            "latitude": 54.303646
        },
        "3578": {
            "name": "Кубовая",
            "population": 535,
            "type": "village",
            "poly": [
                [
                    82.8987525,
                    55.2725725
                ],
                [
                    82.8991858,
                    55.273154
                ],
                [
                    82.8999054,
                    55.2738024
                ],
                [
                    82.9004121,
                    55.2741328
                ],
                [
                    82.9008248,
                    55.2742419
                ],
                [
                    82.902847,
                    55.269258
                ],
                [
                    82.9043099,
                    55.2666759
                ],
                [
                    82.904525,
                    55.265965
                ],
                [
                    82.9049266,
                    55.2655319
                ],
                [
                    82.9055003,
                    55.2650743
                ],
                [
                    82.9063177,
                    55.2650498
                ],
                [
                    82.9065902,
                    55.265344
                ],
                [
                    82.9065329,
                    55.265679
                ],
                [
                    82.9069488,
                    55.2660712
                ],
                [
                    82.9097168,
                    55.2668394
                ],
                [
                    82.9102474,
                    55.2668067
                ],
                [
                    82.910692,
                    55.266488
                ],
                [
                    82.911868,
                    55.2665534
                ],
                [
                    82.9120975,
                    55.2662674
                ],
                [
                    82.9128576,
                    55.2661366
                ],
                [
                    82.9176335,
                    55.2668067
                ],
                [
                    82.9180781,
                    55.266823
                ],
                [
                    82.9203584,
                    55.2671907
                ],
                [
                    82.92185,
                    55.2675911
                ],
                [
                    82.9234276,
                    55.2678117
                ],
                [
                    82.9243455,
                    55.2681304
                ],
                [
                    82.9254355,
                    55.2686942
                ],
                [
                    82.9259948,
                    55.2691191
                ],
                [
                    82.9264107,
                    55.2692498
                ],
                [
                    82.9265709,
                    55.2691827
                ],
                [
                    82.9265635,
                    55.2688146
                ],
                [
                    82.9261083,
                    55.2682372
                ],
                [
                    82.9267985,
                    55.2676975
                ],
                [
                    82.9267765,
                    55.2674298
                ],
                [
                    82.9264314,
                    55.2673879
                ],
                [
                    82.9256163,
                    55.2676808
                ],
                [
                    82.9250362,
                    55.2675093
                ],
                [
                    82.9245222,
                    55.2669445
                ],
                [
                    82.9250656,
                    55.2664675
                ],
                [
                    82.9253666,
                    55.266091
                ],
                [
                    82.9255208,
                    55.2655387
                ],
                [
                    82.9259981,
                    55.2651287
                ],
                [
                    82.9263653,
                    55.2647521
                ],
                [
                    82.92638,
                    55.2641999
                ],
                [
                    82.9259614,
                    55.2637522
                ],
                [
                    82.9262625,
                    55.2629655
                ],
                [
                    82.9262405,
                    55.2628358
                ],
                [
                    82.925898,
                    55.2628547
                ],
                [
                    82.9250972,
                    55.263024
                ],
                [
                    82.9245333,
                    55.2627562
                ],
                [
                    82.924068,
                    55.2622313
                ],
                [
                    82.9233725,
                    55.2618671
                ],
                [
                    82.9224702,
                    55.2617948
                ],
                [
                    82.9217371,
                    55.2619367
                ],
                [
                    82.9210274,
                    55.2616529
                ],
                [
                    82.9205716,
                    55.2610851
                ],
                [
                    82.9198713,
                    55.2605388
                ],
                [
                    82.9193262,
                    55.2600836
                ],
                [
                    82.9197068,
                    55.2596819
                ],
                [
                    82.9199559,
                    55.259331
                ],
                [
                    82.9196505,
                    55.2589534
                ],
                [
                    82.9199418,
                    55.2585222
                ],
                [
                    82.9205857,
                    55.2580268
                ],
                [
                    82.9204635,
                    55.2576866
                ],
                [
                    82.9199653,
                    55.2577081
                ],
                [
                    82.9190113,
                    55.2574992
                ],
                [
                    82.9188562,
                    55.2570251
                ],
                [
                    82.9188938,
                    55.2563288
                ],
                [
                    82.9196552,
                    55.2559886
                ],
                [
                    82.919876,
                    55.2557235
                ],
                [
                    82.9194108,
                    55.2553485
                ],
                [
                    82.9187282,
                    55.2543608
                ],
                [
                    82.9185731,
                    55.2540863
                ],
                [
                    82.9181936,
                    55.2520566
                ],
                [
                    82.9177565,
                    55.2513334
                ],
                [
                    82.9186729,
                    55.2505057
                ],
                [
                    82.9183696,
                    55.2501964
                ],
                [
                    82.9176412,
                    55.2505929
                ],
                [
                    82.9169832,
                    55.2507857
                ],
                [
                    82.9161749,
                    55.2508661
                ],
                [
                    82.9153196,
                    55.2506491
                ],
                [
                    82.9149859,
                    55.2504938
                ],
                [
                    82.9148919,
                    55.2502875
                ],
                [
                    82.9146992,
                    55.2502152
                ],
                [
                    82.9144502,
                    55.2502339
                ],
                [
                    82.9139379,
                    55.2506973
                ],
                [
                    82.9131656,
                    55.2513306
                ],
                [
                    82.9127301,
                    55.2516027
                ],
                [
                    82.91148,
                    55.2516456
                ],
                [
                    82.91109,
                    55.2515572
                ],
                [
                    82.9105965,
                    55.2519429
                ],
                [
                    82.9101642,
                    55.2525509
                ],
                [
                    82.9096472,
                    55.2526849
                ],
                [
                    82.9090457,
                    55.2526661
                ],
                [
                    82.9087308,
                    55.2526849
                ],
                [
                    82.9081058,
                    55.2526152
                ],
                [
                    82.9066348,
                    55.2528108
                ],
                [
                    82.9053424,
                    55.2527009
                ],
                [
                    82.9045341,
                    55.2526206
                ],
                [
                    82.903848,
                    55.2523742
                ],
                [
                    82.9030538,
                    55.2521947
                ],
                [
                    82.9028188,
                    55.2523688
                ],
                [
                    82.9032182,
                    55.2524679
                ],
                [
                    82.9025399,
                    55.2542295
                ],
                [
                    82.9024539,
                    55.2548099
                ],
                [
                    82.9029559,
                    55.2554229
                ],
                [
                    82.9058959,
                    55.2557744
                ],
                [
                    82.9072297,
                    55.2560604
                ],
                [
                    82.907029,
                    55.2591908
                ],
                [
                    82.9067134,
                    55.2613402
                ],
                [
                    82.9054513,
                    55.2619532
                ],
                [
                    82.9040028,
                    55.2630155
                ],
                [
                    82.9027264,
                    55.2630074
                ],
                [
                    82.9006755,
                    55.2648951
                ],
                [
                    82.8989258,
                    55.2672648
                ],
                [
                    82.9002165,
                    55.2690543
                ],
                [
                    82.8997659,
                    55.2699371
                ],
                [
                    82.8993179,
                    55.2701212
                ],
                [
                    82.8989067,
                    55.2704307
                ],
                [
                    82.8991344,
                    55.2708867
                ],
                [
                    82.8987599,
                    55.2717694
                ],
                [
                    82.8987525,
                    55.2725725
                ]
            ],
            "longitude": 82.9160306,
            "latitude": 55.2607219
        },
        "3579": {
            "name": "Вьюны",
            "population": 1025,
            "type": "village",
            "poly": null,
            "longitude": 82.917862,
            "latitude": 55.516602
        },
        "3580": {
            "name": "Улыбино",
            "population": 1500,
            "type": "village",
            "poly": [
                [
                    82.9151662,
                    54.5908458
                ],
                [
                    82.9152031,
                    54.5919574
                ],
                [
                    82.9174537,
                    54.5950783
                ],
                [
                    82.9192984,
                    54.5958905
                ],
                [
                    82.9237996,
                    54.5964676
                ],
                [
                    82.9245697,
                    54.5950569
                ],
                [
                    82.9248726,
                    54.5945856
                ],
                [
                    82.9255723,
                    54.5942883
                ],
                [
                    82.9268406,
                    54.5943062
                ],
                [
                    82.9278636,
                    54.5943628
                ],
                [
                    82.9278985,
                    54.5941034
                ],
                [
                    82.9262183,
                    54.5939141
                ],
                [
                    82.9272762,
                    54.5929497
                ],
                [
                    82.9278265,
                    54.5924925
                ],
                [
                    82.9267512,
                    54.5918078
                ],
                [
                    82.927526,
                    54.5907603
                ],
                [
                    82.9279188,
                    54.5906329
                ],
                [
                    82.9284325,
                    54.5905079
                ],
                [
                    82.9287804,
                    54.59029
                ],
                [
                    82.9302562,
                    54.5884087
                ],
                [
                    82.9347573,
                    54.5875536
                ],
                [
                    82.935938,
                    54.5866556
                ],
                [
                    82.9350286,
                    54.5863156
                ],
                [
                    82.9340341,
                    54.58573
                ],
                [
                    82.9325618,
                    54.5860544
                ],
                [
                    82.9316293,
                    54.5866401
                ],
                [
                    82.9292278,
                    54.5875294
                ],
                [
                    82.9288911,
                    54.5875951
                ],
                [
                    82.9267881,
                    54.5868053
                ],
                [
                    82.926124,
                    54.5868053
                ],
                [
                    82.9240948,
                    54.5873611
                ],
                [
                    82.9232831,
                    54.5868908
                ],
                [
                    82.9242054,
                    54.5864418
                ],
                [
                    82.9235913,
                    54.5858021
                ],
                [
                    82.9239082,
                    54.5854962
                ],
                [
                    82.9228245,
                    54.5849442
                ],
                [
                    82.9235163,
                    54.5847059
                ],
                [
                    82.9225821,
                    54.5827644
                ],
                [
                    82.9232831,
                    54.5822298
                ],
                [
                    82.9227666,
                    54.5815884
                ],
                [
                    82.9221393,
                    54.5812677
                ],
                [
                    82.9234307,
                    54.5809897
                ],
                [
                    82.9260502,
                    54.5790652
                ],
                [
                    82.9286697,
                    54.5784665
                ],
                [
                    82.9293368,
                    54.5794093
                ],
                [
                    82.9298255,
                    54.5794155
                ],
                [
                    82.9328309,
                    54.5826498
                ],
                [
                    82.9343515,
                    54.5827002
                ],
                [
                    82.935503,
                    54.5836972
                ],
                [
                    82.93682,
                    54.5834713
                ],
                [
                    82.9365283,
                    54.5828285
                ],
                [
                    82.9352739,
                    54.5810966
                ],
                [
                    82.9337981,
                    54.5801558
                ],
                [
                    82.9333922,
                    54.5802841
                ],
                [
                    82.9329898,
                    54.5801439
                ],
                [
                    82.9329012,
                    54.5795792
                ],
                [
                    82.9330233,
                    54.5788086
                ],
                [
                    82.9339677,
                    54.578475
                ],
                [
                    82.9340563,
                    54.5767771
                ],
                [
                    82.9361225,
                    54.5765633
                ],
                [
                    82.9366021,
                    54.5754727
                ],
                [
                    82.9371924,
                    54.5751091
                ],
                [
                    82.9398488,
                    54.5746814
                ],
                [
                    82.9397381,
                    54.5714306
                ],
                [
                    82.938373,
                    54.570789
                ],
                [
                    82.93627,
                    54.5707676
                ],
                [
                    82.9353846,
                    54.5704254
                ],
                [
                    82.9349787,
                    54.5705751
                ],
                [
                    82.9345729,
                    54.5699763
                ],
                [
                    82.9356428,
                    54.569634
                ],
                [
                    82.9373769,
                    54.570143
                ],
                [
                    82.9370788,
                    54.5695593
                ],
                [
                    82.9382255,
                    54.5690993
                ],
                [
                    82.9392216,
                    54.5675807
                ],
                [
                    82.9384468,
                    54.566062
                ],
                [
                    82.9349418,
                    54.5659765
                ],
                [
                    82.9320927,
                    54.568664
                ],
                [
                    82.9315475,
                    54.5690566
                ],
                [
                    82.9302751,
                    54.5695098
                ],
                [
                    82.9298754,
                    54.5698298
                ],
                [
                    82.929716,
                    54.5699067
                ],
                [
                    82.9293936,
                    54.5702187
                ],
                [
                    82.9289386,
                    54.5704195
                ],
                [
                    82.9287851,
                    54.5705323
                ],
                [
                    82.9281901,
                    54.570789
                ],
                [
                    82.9272308,
                    54.5702971
                ],
                [
                    82.9266686,
                    54.5697575
                ],
                [
                    82.924981,
                    54.5702222
                ],
                [
                    82.9242792,
                    54.5706607
                ],
                [
                    82.9223976,
                    54.5712809
                ],
                [
                    82.9217648,
                    54.5717895
                ],
                [
                    82.9222128,
                    54.5723019
                ],
                [
                    82.9222884,
                    54.5729216
                ],
                [
                    82.9215541,
                    54.5744046
                ],
                [
                    82.9214383,
                    54.574938
                ],
                [
                    82.9211432,
                    54.5763067
                ],
                [
                    82.9230248,
                    54.5761142
                ],
                [
                    82.921918,
                    54.5766061
                ],
                [
                    82.921217,
                    54.5778464
                ],
                [
                    82.9208111,
                    54.5778677
                ],
                [
                    82.9204561,
                    54.5785931
                ],
                [
                    82.9208851,
                    54.5792577
                ],
                [
                    82.9216228,
                    54.5795998
                ],
                [
                    82.9208111,
                    54.5810538
                ],
                [
                    82.9200227,
                    54.5811277
                ],
                [
                    82.9194091,
                    54.5813318
                ],
                [
                    82.9181547,
                    54.5843893
                ],
                [
                    82.9176674,
                    54.5849528
                ],
                [
                    82.9172054,
                    54.5854508
                ],
                [
                    82.9161993,
                    54.5863991
                ],
                [
                    82.9153876,
                    54.5876605
                ],
                [
                    82.9162362,
                    54.5898197
                ],
                [
                    82.9151662,
                    54.5908458
                ]
            ],
            "longitude": 82.9267798,
            "latitude": 54.5756546
        },
        "3581": {
            "name": "Озёрный",
            "population": 893,
            "type": "village",
            "poly": [
                [
                    82.9187913,
                    55.138851
                ],
                [
                    82.9241002,
                    55.1412436
                ],
                [
                    82.9277947,
                    55.1441483
                ],
                [
                    82.9278412,
                    55.1442748
                ],
                [
                    82.928264,
                    55.1445242
                ],
                [
                    82.9443447,
                    55.1331014
                ],
                [
                    82.944853,
                    55.1319822
                ],
                [
                    82.9460013,
                    55.1293079
                ],
                [
                    82.9457694,
                    55.1291684
                ],
                [
                    82.9453716,
                    55.1289474
                ],
                [
                    82.943314,
                    55.1284665
                ],
                [
                    82.9419522,
                    55.1282355
                ],
                [
                    82.9394741,
                    55.1278325
                ],
                [
                    82.9374052,
                    55.1274816
                ],
                [
                    82.9354386,
                    55.1270201
                ],
                [
                    82.9335289,
                    55.1263507
                ],
                [
                    82.9296788,
                    55.1247446
                ],
                [
                    82.9269788,
                    55.1236182
                ],
                [
                    82.9254579,
                    55.1229837
                ],
                [
                    82.9253329,
                    55.1229259
                ],
                [
                    82.9227703,
                    55.1217043
                ],
                [
                    82.9211965,
                    55.1229428
                ],
                [
                    82.9231167,
                    55.123795
                ],
                [
                    82.9203331,
                    55.1260688
                ],
                [
                    82.92159,
                    55.1266123
                ],
                [
                    82.921607,
                    55.1274313
                ],
                [
                    82.921405,
                    55.1282089
                ],
                [
                    82.9212585,
                    55.1286573
                ],
                [
                    82.9209876,
                    55.1289658
                ],
                [
                    82.9207506,
                    55.1292356
                ],
                [
                    82.9202088,
                    55.1303369
                ],
                [
                    82.9200344,
                    55.1305796
                ],
                [
                    82.9199388,
                    55.1307127
                ],
                [
                    82.9197794,
                    55.1309959
                ],
                [
                    82.918931,
                    55.1325029
                ],
                [
                    82.9190802,
                    55.1328361
                ],
                [
                    82.9194212,
                    55.133148
                ],
                [
                    82.9239296,
                    55.1363049
                ],
                [
                    82.9237537,
                    55.1366268
                ],
                [
                    82.9187913,
                    55.138851
                ]
            ],
            "longitude": 82.9377299,
            "latitude": 55.1324517
        },
        "3582": {
            "name": "Степной",
            "population": 759,
            "type": "village",
            "poly": [
                [
                    82.9278592,
                    54.5032183
                ],
                [
                    82.9279156,
                    54.5039063
                ],
                [
                    82.9285363,
                    54.5044698
                ],
                [
                    82.9287733,
                    54.5044698
                ],
                [
                    82.9293827,
                    54.5041029
                ],
                [
                    82.930026,
                    54.5039063
                ],
                [
                    82.9304435,
                    54.5040898
                ],
                [
                    82.9310868,
                    54.5036966
                ],
                [
                    82.9320009,
                    54.5037097
                ],
                [
                    82.9322605,
                    54.5040898
                ],
                [
                    82.9311884,
                    54.5045157
                ],
                [
                    82.9334216,
                    54.5064152
                ],
                [
                    82.931757,
                    54.5070295
                ],
                [
                    82.9302193,
                    54.5073244
                ],
                [
                    82.9306849,
                    54.507955
                ],
                [
                    82.9306849,
                    54.5080943
                ],
                [
                    82.9309952,
                    54.5081434
                ],
                [
                    82.9308932,
                    54.5082246
                ],
                [
                    82.9307257,
                    54.5082615
                ],
                [
                    82.9307257,
                    54.5083554
                ],
                [
                    82.9313012,
                    54.508801
                ],
                [
                    82.9307708,
                    54.508991
                ],
                [
                    82.9305564,
                    54.50924
                ],
                [
                    82.9307257,
                    54.5093645
                ],
                [
                    82.9310755,
                    54.5093645
                ],
                [
                    82.9314254,
                    54.5095414
                ],
                [
                    82.9320348,
                    54.5096003
                ],
                [
                    82.9327006,
                    54.5099803
                ],
                [
                    82.9330392,
                    54.5103145
                ],
                [
                    82.9340854,
                    54.5109245
                ],
                [
                    82.9345966,
                    54.5111793
                ],
                [
                    82.9350818,
                    54.5111924
                ],
                [
                    82.9356123,
                    54.5114348
                ],
                [
                    82.935838,
                    54.5113628
                ],
                [
                    82.936233,
                    54.5112579
                ],
                [
                    82.9364135,
                    54.5109107
                ],
                [
                    82.9366618,
                    54.5108321
                ],
                [
                    82.9393816,
                    54.509312
                ],
                [
                    82.940386,
                    54.5090369
                ],
                [
                    82.9406907,
                    54.5089124
                ],
                [
                    82.9405327,
                    54.5086568
                ],
                [
                    82.9410067,
                    54.5084406
                ],
                [
                    82.9412098,
                    54.5087289
                ],
                [
                    82.9416838,
                    54.5085455
                ],
                [
                    82.9414807,
                    54.5082703
                ],
                [
                    82.9421127,
                    54.5080934
                ],
                [
                    82.9425189,
                    54.5083751
                ],
                [
                    82.9429703,
                    54.5082047
                ],
                [
                    82.9428801,
                    54.5080475
                ],
                [
                    82.9436249,
                    54.5077657
                ],
                [
                    82.943433,
                    54.5074054
                ],
                [
                    82.9437716,
                    54.5073071
                ],
                [
                    82.9441102,
                    54.5074054
                ],
                [
                    82.9453629,
                    54.5070253
                ],
                [
                    82.9450581,
                    54.5068877
                ],
                [
                    82.945724,
                    54.5066977
                ],
                [
                    82.9463221,
                    54.5071629
                ],
                [
                    82.9478118,
                    54.5066256
                ],
                [
                    82.9483136,
                    54.5068867
                ],
                [
                    82.9508224,
                    54.5089072
                ],
                [
                    82.9560926,
                    54.5071775
                ],
                [
                    82.9517823,
                    54.5059802
                ],
                [
                    82.9494445,
                    54.5043353
                ],
                [
                    82.94683,
                    54.5049482
                ],
                [
                    82.9463603,
                    54.5047803
                ],
                [
                    82.9455799,
                    54.5049747
                ],
                [
                    82.9448324,
                    54.5048171
                ],
                [
                    82.9451198,
                    54.5043701
                ],
                [
                    82.9456676,
                    54.5039784
                ],
                [
                    82.9455696,
                    54.5037494
                ],
                [
                    82.9466294,
                    54.5033352
                ],
                [
                    82.9482953,
                    54.5028538
                ],
                [
                    82.9485588,
                    54.5026575
                ],
                [
                    82.9505898,
                    54.5023376
                ],
                [
                    82.9457804,
                    54.5006035
                ],
                [
                    82.9432056,
                    54.499802
                ],
                [
                    82.9417906,
                    54.4996135
                ],
                [
                    82.9399459,
                    54.4996271
                ],
                [
                    82.9396863,
                    54.4993649
                ],
                [
                    82.9382643,
                    54.4991683
                ],
                [
                    82.9378806,
                    54.4988275
                ],
                [
                    82.9366957,
                    54.4992011
                ],
                [
                    82.9362104,
                    54.4987948
                ],
                [
                    82.935048,
                    54.4993453
                ],
                [
                    82.9346981,
                    54.4995091
                ],
                [
                    82.9331818,
                    54.4983544
                ],
                [
                    82.9320229,
                    54.4988729
                ],
                [
                    82.9320439,
                    54.4994436
                ],
                [
                    82.9324072,
                    54.499745
                ],
                [
                    82.9332649,
                    54.5006298
                ],
                [
                    82.9327006,
                    54.5007674
                ],
                [
                    82.9328361,
                    54.5009378
                ],
                [
                    82.9326329,
                    54.5010688
                ],
                [
                    82.9327458,
                    54.5011933
                ],
                [
                    82.9321476,
                    54.5019535
                ],
                [
                    82.9324523,
                    54.5022025
                ],
                [
                    82.9323959,
                    54.502386
                ],
                [
                    82.9319671,
                    54.5022418
                ],
                [
                    82.9316962,
                    54.5024515
                ],
                [
                    82.9322041,
                    54.5029168
                ],
                [
                    82.9319037,
                    54.5034919
                ],
                [
                    82.9307408,
                    54.503589
                ],
                [
                    82.9301953,
                    54.5030282
                ],
                [
                    82.9284573,
                    54.5029627
                ],
                [
                    82.9278592,
                    54.5032183
                ]
            ],
            "longitude": 82.942383,
            "latitude": 54.503788
        },
        "3583": {
            "name": "Сосновка",
            "population": 1127,
            "type": "village",
            "poly": [
                [
                    82.9359144,
                    55.2363127
                ],
                [
                    82.9359718,
                    55.2369015
                ],
                [
                    82.9363447,
                    55.2376129
                ],
                [
                    82.9372625,
                    55.2377028
                ],
                [
                    82.9384386,
                    55.2381771
                ],
                [
                    82.9392991,
                    55.2383816
                ],
                [
                    82.9404177,
                    55.2382671
                ],
                [
                    82.9417659,
                    55.2384879
                ],
                [
                    82.9423826,
                    55.239093
                ],
                [
                    82.9429419,
                    55.2395591
                ],
                [
                    82.9440032,
                    55.2398289
                ],
                [
                    82.9455665,
                    55.2403359
                ],
                [
                    82.9465704,
                    55.2406956
                ],
                [
                    82.9464844,
                    55.2413007
                ],
                [
                    82.9474596,
                    55.2417014
                ],
                [
                    82.9494675,
                    55.2414234
                ],
                [
                    82.9501272,
                    55.2410391
                ],
                [
                    82.950959,
                    55.2409655
                ],
                [
                    82.9515327,
                    55.2412435
                ],
                [
                    82.951963,
                    55.242241
                ],
                [
                    82.9525283,
                    55.2429912
                ],
                [
                    82.9532283,
                    55.243029
                ],
                [
                    82.9542075,
                    55.2426546
                ],
                [
                    82.9554194,
                    55.2428379
                ],
                [
                    82.9570257,
                    55.2427234
                ],
                [
                    82.9573555,
                    55.2424045
                ],
                [
                    82.9571691,
                    55.2421265
                ],
                [
                    82.956409,
                    55.2417996
                ],
                [
                    82.9562369,
                    55.2414137
                ],
                [
                    82.9564434,
                    55.2410539
                ],
                [
                    82.9562828,
                    55.240511
                ],
                [
                    82.9555026,
                    55.2401577
                ],
                [
                    82.9553707,
                    55.2395794
                ],
                [
                    82.9563208,
                    55.2383631
                ],
                [
                    82.9544564,
                    55.2369218
                ],
                [
                    82.9542771,
                    55.235777
                ],
                [
                    82.956034,
                    55.2350103
                ],
                [
                    82.9586334,
                    55.2343663
                ],
                [
                    82.9608385,
                    55.2335893
                ],
                [
                    82.9584032,
                    55.2293763
                ],
                [
                    82.9580934,
                    55.2289445
                ],
                [
                    82.9581852,
                    55.2276947
                ],
                [
                    82.9578984,
                    55.2273479
                ],
                [
                    82.9560626,
                    55.2271123
                ],
                [
                    82.955137,
                    55.2278105
                ],
                [
                    82.9541824,
                    55.2290459
                ],
                [
                    82.9541182,
                    55.2299881
                ],
                [
                    82.9556201,
                    55.2313976
                ],
                [
                    82.9540425,
                    55.2317247
                ],
                [
                    82.9526944,
                    55.2320355
                ],
                [
                    82.9513749,
                    55.2322564
                ],
                [
                    82.9504284,
                    55.2321909
                ],
                [
                    82.9496252,
                    55.2319047
                ],
                [
                    82.9481193,
                    55.2307597
                ],
                [
                    82.9466708,
                    55.229999
                ],
                [
                    82.9449928,
                    55.2296719
                ],
                [
                    82.9422679,
                    55.2291321
                ],
                [
                    82.9402743,
                    55.2289766
                ],
                [
                    82.9389405,
                    55.2294674
                ],
                [
                    82.9390983,
                    55.2300972
                ],
                [
                    82.939758,
                    55.2300399
                ],
                [
                    82.9401739,
                    55.2303098
                ],
                [
                    82.9397867,
                    55.2309478
                ],
                [
                    82.9408193,
                    55.2312422
                ],
                [
                    82.9412066,
                    55.2315694
                ],
                [
                    82.9413787,
                    55.2319946
                ],
                [
                    82.9416942,
                    55.2323054
                ],
                [
                    82.9422535,
                    55.2324445
                ],
                [
                    82.9426694,
                    55.2328043
                ],
                [
                    82.9428128,
                    55.2331887
                ],
                [
                    82.94244,
                    55.2336876
                ],
                [
                    82.9411329,
                    55.2341575
                ],
                [
                    82.9407189,
                    55.2342764
                ],
                [
                    82.94026,
                    55.2339493
                ],
                [
                    82.9398441,
                    55.2334586
                ],
                [
                    82.9381661,
                    55.2333523
                ],
                [
                    82.9377071,
                    55.2336712
                ],
                [
                    82.9379509,
                    55.2340883
                ],
                [
                    82.9377502,
                    55.2345135
                ],
                [
                    82.937535,
                    55.2348488
                ],
                [
                    82.9360865,
                    55.2350942
                ],
                [
                    82.9359144,
                    55.2363127
                ]
            ],
            "longitude": 82.9460448,
            "latitude": 55.2350512
        },
        "3584": {
            "name": "Элитный",
            "population": 1572,
            "type": "village",
            "poly": [
                [
                    82.9367472,
                    54.9167747
                ],
                [
                    82.9368988,
                    54.9186645
                ],
                [
                    82.9380767,
                    54.9186012
                ],
                [
                    82.9411578,
                    54.9185812
                ],
                [
                    82.9419528,
                    54.9185645
                ],
                [
                    82.9439373,
                    54.9186078
                ],
                [
                    82.9442216,
                    54.9185311
                ],
                [
                    82.9474536,
                    54.9187112
                ],
                [
                    82.9480106,
                    54.9187379
                ],
                [
                    82.9482776,
                    54.9187112
                ],
                [
                    82.9484691,
                    54.9186379
                ],
                [
                    82.9486663,
                    54.9185378
                ],
                [
                    82.9488404,
                    54.9184178
                ],
                [
                    82.9501518,
                    54.9171404
                ],
                [
                    82.9505057,
                    54.9169103
                ],
                [
                    82.9504883,
                    54.9166669
                ],
                [
                    82.9504187,
                    54.9165401
                ],
                [
                    82.9504899,
                    54.916353
                ],
                [
                    82.9504767,
                    54.9159565
                ],
                [
                    82.9507378,
                    54.9159665
                ],
                [
                    82.9574571,
                    54.9162666
                ],
                [
                    82.9575907,
                    54.911864
                ],
                [
                    82.9577589,
                    54.9115671
                ],
                [
                    82.9580141,
                    54.9111969
                ],
                [
                    82.9581477,
                    54.9108767
                ],
                [
                    82.9581535,
                    54.9107266
                ],
                [
                    82.9580258,
                    54.9105465
                ],
                [
                    82.9550259,
                    54.9104097
                ],
                [
                    82.9544573,
                    54.9104164
                ],
                [
                    82.9534766,
                    54.9104197
                ],
                [
                    82.953465,
                    54.9105565
                ],
                [
                    82.952908,
                    54.9105531
                ],
                [
                    82.9528268,
                    54.9110635
                ],
                [
                    82.9509351,
                    54.9110134
                ],
                [
                    82.9508191,
                    54.9114471
                ],
                [
                    82.9502214,
                    54.9115538
                ],
                [
                    82.9491073,
                    54.911794
                ],
                [
                    82.9482137,
                    54.9118306
                ],
                [
                    82.9467515,
                    54.9118607
                ],
                [
                    82.9456896,
                    54.911864
                ],
                [
                    82.9457128,
                    54.9116939
                ],
                [
                    82.9460726,
                    54.9083549
                ],
                [
                    82.9377692,
                    54.9081214
                ],
                [
                    82.9377575,
                    54.9093123
                ],
                [
                    82.9372585,
                    54.9126979
                ],
                [
                    82.9370961,
                    54.9146057
                ],
                [
                    82.9367472,
                    54.9167747
                ]
            ],
            "longitude": 82.9473911,
            "latitude": 54.913334
        },
        "3585": {
            "name": "Сосновка",
            "population": 681,
            "type": "village",
            "poly": [
                [
                    82.9427383,
                    54.683065
                ],
                [
                    82.9525483,
                    54.6861913
                ],
                [
                    82.9588996,
                    54.6881178
                ],
                [
                    82.9604084,
                    54.6880202
                ],
                [
                    82.9616884,
                    54.6871322
                ],
                [
                    82.9650474,
                    54.6843108
                ],
                [
                    82.9657113,
                    54.6838165
                ],
                [
                    82.9659094,
                    54.6834808
                ],
                [
                    82.9668859,
                    54.6815018
                ],
                [
                    82.9685838,
                    54.6821562
                ],
                [
                    82.9719796,
                    54.6805929
                ],
                [
                    82.9682694,
                    54.6780116
                ],
                [
                    82.9639304,
                    54.6799748
                ],
                [
                    82.9541081,
                    54.6751585
                ],
                [
                    82.9539946,
                    54.6751028
                ],
                [
                    82.9527258,
                    54.6760003
                ],
                [
                    82.9498882,
                    54.6764443
                ],
                [
                    82.9480829,
                    54.6780693
                ],
                [
                    82.9441815,
                    54.6809404
                ],
                [
                    82.9427383,
                    54.683065
                ]
            ],
            "longitude": 82.9559289,
            "latitude": 54.6818979
        },
        "3586": {
            "name": "Садовый",
            "population": 2486,
            "type": "village",
            "poly": [
                [
                    82.9491764,
                    55.1385494
                ],
                [
                    82.9494649,
                    55.1395632
                ],
                [
                    82.952259,
                    55.1411468
                ],
                [
                    82.9529842,
                    55.1420383
                ],
                [
                    82.9539101,
                    55.1427057
                ],
                [
                    82.9539901,
                    55.1433722
                ],
                [
                    82.9540234,
                    55.1434192
                ],
                [
                    82.9548408,
                    55.1445725
                ],
                [
                    82.9542699,
                    55.1452497
                ],
                [
                    82.9532375,
                    55.1459308
                ],
                [
                    82.951239,
                    55.1462105
                ],
                [
                    82.950475,
                    55.1473167
                ],
                [
                    82.9500998,
                    55.1478599
                ],
                [
                    82.9531332,
                    55.1483395
                ],
                [
                    82.9552093,
                    55.1482656
                ],
                [
                    82.9561803,
                    55.1486579
                ],
                [
                    82.9638137,
                    55.1494782
                ],
                [
                    82.9675709,
                    55.146288
                ],
                [
                    82.973484,
                    55.1440421
                ],
                [
                    82.9752345,
                    55.1403811
                ],
                [
                    82.9737956,
                    55.1391444
                ],
                [
                    82.9800951,
                    55.1346154
                ],
                [
                    82.9855647,
                    55.1341059
                ],
                [
                    82.9874457,
                    55.1332762
                ],
                [
                    82.9883488,
                    55.1325221
                ],
                [
                    82.9711652,
                    55.1228913
                ],
                [
                    82.9660811,
                    55.1268862
                ],
                [
                    82.9638006,
                    55.1314513
                ],
                [
                    82.9624149,
                    55.1313562
                ],
                [
                    82.9615066,
                    55.1312519
                ],
                [
                    82.9605408,
                    55.1336971
                ],
                [
                    82.9603388,
                    55.1338732
                ],
                [
                    82.960165,
                    55.133957
                ],
                [
                    82.9598323,
                    55.1337815
                ],
                [
                    82.9590381,
                    55.1331723
                ],
                [
                    82.957655,
                    55.1330452
                ],
                [
                    82.9568611,
                    55.133337
                ],
                [
                    82.9556567,
                    55.1339116
                ],
                [
                    82.9525453,
                    55.1346737
                ],
                [
                    82.951298,
                    55.1363211
                ],
                [
                    82.950804,
                    55.1369736
                ],
                [
                    82.950281,
                    55.1374642
                ],
                [
                    82.9502782,
                    55.137527
                ],
                [
                    82.9502677,
                    55.1377643
                ],
                [
                    82.9491764,
                    55.1385494
                ]
            ],
            "longitude": 82.9661333,
            "latitude": 55.1372818
        },
        "3587": {
            "name": "Карасево",
            "population": 948,
            "type": "village",
            "poly": [
                [
                    82.9804771,
                    54.1699884
                ],
                [
                    82.9855424,
                    54.1722418
                ],
                [
                    82.986758,
                    54.1750485
                ],
                [
                    82.9953352,
                    54.1773807
                ],
                [
                    82.9991848,
                    54.1784875
                ],
                [
                    83.003102,
                    54.1769855
                ],
                [
                    83.0028994,
                    54.1731115
                ],
                [
                    83.0155288,
                    54.1733092
                ],
                [
                    83.0163299,
                    54.1701468
                ],
                [
                    83.0056684,
                    54.1672999
                ],
                [
                    82.9938494,
                    54.1669441
                ],
                [
                    82.9841241,
                    54.1676557
                ],
                [
                    82.9804771,
                    54.1699884
                ]
            ],
            "longitude": 82.999095,
            "latitude": 54.1713361
        },
        "3588": {
            "name": "Мичуринский",
            "population": 1208,
            "type": "village",
            "poly": null,
            "longitude": 83.0063581,
            "latitude": 54.8830941
        },
        "3589": {
            "name": "Первомайский",
            "population": 365,
            "type": "village",
            "poly": [
                [
                    83.0010019,
                    54.5735219
                ],
                [
                    83.0029613,
                    54.5757506
                ],
                [
                    83.0043362,
                    54.5770674
                ],
                [
                    83.0048859,
                    54.5775938
                ],
                [
                    83.0076935,
                    54.5802826
                ],
                [
                    83.0097083,
                    54.5800683
                ],
                [
                    83.0107251,
                    54.5797255
                ],
                [
                    83.0116678,
                    54.5797255
                ],
                [
                    83.0122039,
                    54.5798754
                ],
                [
                    83.0129063,
                    54.5797897
                ],
                [
                    83.0141633,
                    54.5794148
                ],
                [
                    83.0160118,
                    54.5796719
                ],
                [
                    83.0162706,
                    54.5799504
                ],
                [
                    83.0168252,
                    54.5798969
                ],
                [
                    83.0171949,
                    54.5796826
                ],
                [
                    83.0166588,
                    54.5793076
                ],
                [
                    83.0167697,
                    54.5787719
                ],
                [
                    83.0157161,
                    54.5785255
                ],
                [
                    83.0149582,
                    54.5782148
                ],
                [
                    83.0141448,
                    54.5775399
                ],
                [
                    83.0139045,
                    54.5771649
                ],
                [
                    83.0130727,
                    54.5767149
                ],
                [
                    83.0130727,
                    54.5764577
                ],
                [
                    83.0131466,
                    54.5762542
                ],
                [
                    83.0122593,
                    54.5760934
                ],
                [
                    83.011372,
                    54.5751184
                ],
                [
                    83.0103369,
                    54.574722
                ],
                [
                    83.0094311,
                    54.5747113
                ],
                [
                    83.0086177,
                    54.5744005
                ],
                [
                    83.0084186,
                    54.5742625
                ],
                [
                    83.0079656,
                    54.5739483
                ],
                [
                    83.0074553,
                    54.5735944
                ],
                [
                    83.0055122,
                    54.5722468
                ],
                [
                    83.0010019,
                    54.5735219
                ]
            ],
            "longitude": 83.0081115,
            "latitude": 54.5752931
        },
        "3590": {
            "name": "Иня-Восточная",
            "population": 788,
            "type": "village",
            "poly": [
                [
                    82.9997738,
                    55.1007336
                ],
                [
                    83.0014371,
                    55.104426
                ],
                [
                    83.0029298,
                    55.106909
                ],
                [
                    83.0062569,
                    55.1132524
                ],
                [
                    83.0073874,
                    55.1154799
                ],
                [
                    83.0111095,
                    55.1202164
                ],
                [
                    83.0121441,
                    55.1204556
                ],
                [
                    83.0132433,
                    55.1214578
                ],
                [
                    83.0157696,
                    55.1206602
                ],
                [
                    83.0150799,
                    55.119827
                ],
                [
                    83.0160832,
                    55.119435
                ],
                [
                    83.0146152,
                    55.1182622
                ],
                [
                    83.015163,
                    55.1172246
                ],
                [
                    83.014548,
                    55.1158922
                ],
                [
                    83.0136807,
                    55.1143015
                ],
                [
                    83.0132476,
                    55.1130236
                ],
                [
                    83.0127782,
                    55.1120945
                ],
                [
                    83.0087575,
                    55.1115876
                ],
                [
                    83.0079073,
                    55.1098803
                ],
                [
                    83.0030713,
                    55.0999313
                ],
                [
                    82.9997738,
                    55.1007336
                ]
            ],
            "longitude": 83.0088654,
            "latitude": 55.1128321
        },
        "3591": {
            "name": "Юный Ленинец",
            "population": 1359,
            "type": "village",
            "poly": [
                [
                    83.00376,
                    54.8878573
                ],
                [
                    83.0053404,
                    54.8951215
                ],
                [
                    83.0061165,
                    54.8957839
                ],
                [
                    83.0063035,
                    54.8958581
                ],
                [
                    83.0084728,
                    54.8957199
                ],
                [
                    83.0087618,
                    54.8956986
                ],
                [
                    83.010518,
                    54.8957157
                ],
                [
                    83.0127928,
                    54.8955452
                ],
                [
                    83.0130522,
                    54.8955495
                ],
                [
                    83.0137413,
                    54.8957924
                ],
                [
                    83.0144749,
                    54.8960779
                ],
                [
                    83.0149861,
                    54.896129
                ],
                [
                    83.0153566,
                    54.8961844
                ],
                [
                    83.0160458,
                    54.89621
                ],
                [
                    83.0175277,
                    54.8960395
                ],
                [
                    83.0194173,
                    54.895852
                ],
                [
                    83.0207585,
                    54.8956944
                ],
                [
                    83.0216995,
                    54.8956091
                ],
                [
                    83.0217514,
                    54.89546
                ],
                [
                    83.0214772,
                    54.8946674
                ],
                [
                    83.0215143,
                    54.8944799
                ],
                [
                    83.0210178,
                    54.8931333
                ],
                [
                    83.0205806,
                    54.8922043
                ],
                [
                    83.0202768,
                    54.8916375
                ],
                [
                    83.0200007,
                    54.891062
                ],
                [
                    83.0197063,
                    54.8904485
                ],
                [
                    83.019143,
                    54.8892211
                ],
                [
                    83.0185429,
                    54.8881172
                ],
                [
                    83.0185429,
                    54.8878189
                ],
                [
                    83.0182686,
                    54.8871668
                ],
                [
                    83.0182169,
                    54.8866767
                ],
                [
                    83.0179205,
                    54.8856964
                ],
                [
                    83.0170683,
                    54.8845882
                ],
                [
                    83.0162828,
                    54.8842131
                ],
                [
                    83.0152751,
                    54.8844219
                ],
                [
                    83.0145712,
                    54.8845668
                ],
                [
                    83.0142303,
                    54.884537
                ],
                [
                    83.013356,
                    54.8845498
                ],
                [
                    83.0127706,
                    54.8846649
                ],
                [
                    83.0124668,
                    54.8853127
                ],
                [
                    83.0124863,
                    54.8857097
                ],
                [
                    83.0129262,
                    54.8858711
                ],
                [
                    83.0137783,
                    54.8860885
                ],
                [
                    83.0144305,
                    54.8876203
                ],
                [
                    83.0118369,
                    54.8878232
                ],
                [
                    83.0104347,
                    54.8877961
                ],
                [
                    83.0101878,
                    54.8871496
                ],
                [
                    83.0087567,
                    54.8873803
                ],
                [
                    83.0088558,
                    54.8880153
                ],
                [
                    83.0079932,
                    54.8881634
                ],
                [
                    83.007564,
                    54.8870773
                ],
                [
                    83.0057288,
                    54.8868634
                ],
                [
                    83.0039305,
                    54.8869026
                ],
                [
                    83.0037749,
                    54.8870986
                ],
                [
                    83.00376,
                    54.8878573
                ]
            ],
            "longitude": 83.0127337,
            "latitude": 54.8919262
        },
        "3592": {
            "name": "Королёвка",
            "population": 284,
            "type": "village",
            "poly": null,
            "longitude": 83.025383,
            "latitude": 56.035179
        },
        "3593": {
            "name": "Каменка",
            "population": 2153,
            "type": "village",
            "poly": [
                [
                    83.027117,
                    55.0939675
                ],
                [
                    83.03216,
                    55.0957253
                ],
                [
                    83.0394221,
                    55.0991318
                ],
                [
                    83.0397212,
                    55.0997327
                ],
                [
                    83.0387946,
                    55.099768
                ],
                [
                    83.0382563,
                    55.1004193
                ],
                [
                    83.0382916,
                    55.1010302
                ],
                [
                    83.0405771,
                    55.1017572
                ],
                [
                    83.0434538,
                    55.1023277
                ],
                [
                    83.045254,
                    55.1026003
                ],
                [
                    83.0467806,
                    55.1022368
                ],
                [
                    83.0475042,
                    55.102984
                ],
                [
                    83.0469218,
                    55.1036302
                ],
                [
                    83.0466306,
                    55.1042006
                ],
                [
                    83.0461099,
                    55.1066136
                ],
                [
                    83.0445657,
                    55.1079311
                ],
                [
                    83.0438333,
                    55.1095463
                ],
                [
                    83.0436656,
                    55.1105205
                ],
                [
                    83.046004,
                    55.1107022
                ],
                [
                    83.0474953,
                    55.109516
                ],
                [
                    83.0484131,
                    55.1081784
                ],
                [
                    83.0518104,
                    55.1068054
                ],
                [
                    83.0529399,
                    55.1073203
                ],
                [
                    83.0560372,
                    55.1057908
                ],
                [
                    83.0577138,
                    55.1066792
                ],
                [
                    83.0605271,
                    55.1072966
                ],
                [
                    83.0633364,
                    55.1050388
                ],
                [
                    83.065439,
                    55.1061825
                ],
                [
                    83.0678096,
                    55.1074423
                ],
                [
                    83.0685155,
                    55.1072242
                ],
                [
                    83.0697721,
                    55.1060167
                ],
                [
                    83.0724335,
                    55.1065619
                ],
                [
                    83.0733088,
                    55.1056856
                ],
                [
                    83.074635,
                    55.1046618
                ],
                [
                    83.0736561,
                    55.1042832
                ],
                [
                    83.0725255,
                    55.1046066
                ],
                [
                    83.0676997,
                    55.1038651
                ],
                [
                    83.0675756,
                    55.1033918
                ],
                [
                    83.0682374,
                    55.1020429
                ],
                [
                    83.0703746,
                    55.1019483
                ],
                [
                    83.0708709,
                    55.1005757
                ],
                [
                    83.0682099,
                    55.0999446
                ],
                [
                    83.0655212,
                    55.0994949
                ],
                [
                    83.0601991,
                    55.0965444
                ],
                [
                    83.0606817,
                    55.0959291
                ],
                [
                    83.0647215,
                    55.095077
                ],
                [
                    83.0665139,
                    55.0953926
                ],
                [
                    83.0703332,
                    55.0938067
                ],
                [
                    83.0703746,
                    55.093144
                ],
                [
                    83.0693129,
                    55.0924654
                ],
                [
                    83.0673688,
                    55.0923313
                ],
                [
                    83.0642389,
                    55.0922287
                ],
                [
                    83.0605212,
                    55.0926029
                ],
                [
                    83.056988,
                    55.0924796
                ],
                [
                    83.0532394,
                    55.0916289
                ],
                [
                    83.0491154,
                    55.0927803
                ],
                [
                    83.0457622,
                    55.0950869
                ],
                [
                    83.0385035,
                    55.0913005
                ],
                [
                    83.035372,
                    55.0900899
                ],
                [
                    83.0323083,
                    55.0902878
                ],
                [
                    83.0303063,
                    55.0915301
                ],
                [
                    83.0278849,
                    55.0928794
                ],
                [
                    83.027117,
                    55.0939675
                ]
            ],
            "longitude": 83.0508282,
            "latitude": 55.1002573
        },
        "3594": {
            "name": "Восход",
            "population": 1794,
            "type": "village",
            "poly": [
                [
                    83.0363126,
                    55.0815379
                ],
                [
                    83.0363748,
                    55.0820778
                ],
                [
                    83.0370286,
                    55.0829148
                ],
                [
                    83.0388952,
                    55.084235
                ],
                [
                    83.0424025,
                    55.0861879
                ],
                [
                    83.0432228,
                    55.0871338
                ],
                [
                    83.0442809,
                    55.0890049
                ],
                [
                    83.0448754,
                    55.0897125
                ],
                [
                    83.0455768,
                    55.0901684
                ],
                [
                    83.0463139,
                    55.0905426
                ],
                [
                    83.0473977,
                    55.0909769
                ],
                [
                    83.0484508,
                    55.0912277
                ],
                [
                    83.0491143,
                    55.0911511
                ],
                [
                    83.050143,
                    55.0900503
                ],
                [
                    83.050757,
                    55.0900306
                ],
                [
                    83.0509952,
                    55.0900224
                ],
                [
                    83.0537814,
                    55.0887251
                ],
                [
                    83.0578802,
                    55.0874157
                ],
                [
                    83.0612733,
                    55.0862816
                ],
                [
                    83.0625126,
                    55.0854057
                ],
                [
                    83.0600732,
                    55.0837865
                ],
                [
                    83.058622,
                    55.0830646
                ],
                [
                    83.0577324,
                    55.0820783
                ],
                [
                    83.0579027,
                    55.0817605
                ],
                [
                    83.0602646,
                    55.0804504
                ],
                [
                    83.0637931,
                    55.0789708
                ],
                [
                    83.0667539,
                    55.0773484
                ],
                [
                    83.064538,
                    55.0751794
                ],
                [
                    83.0629792,
                    55.0740067
                ],
                [
                    83.0604278,
                    55.0753033
                ],
                [
                    83.0589126,
                    55.0761718
                ],
                [
                    83.0545565,
                    55.0767381
                ],
                [
                    83.0505237,
                    55.0777127
                ],
                [
                    83.0500725,
                    55.0777994
                ],
                [
                    83.0375406,
                    55.0802071
                ],
                [
                    83.0371993,
                    55.080458
                ],
                [
                    83.0368704,
                    55.0808579
                ],
                [
                    83.036458,
                    55.0813607
                ],
                [
                    83.0363126,
                    55.0815379
                ]
            ],
            "longitude": 83.0531315,
            "latitude": 55.0817897
        },
        "3595": {
            "name": "Нововоскресенка",
            "population": 530,
            "type": "village",
            "poly": [
                [
                    83.0496835,
                    54.0905615
                ],
                [
                    83.0514153,
                    54.0925252
                ],
                [
                    83.0544173,
                    54.0933378
                ],
                [
                    83.0544173,
                    54.097468
                ],
                [
                    83.057881,
                    54.0991607
                ],
                [
                    83.0642313,
                    54.0967233
                ],
                [
                    83.0735834,
                    54.0952337
                ],
                [
                    83.0698887,
                    54.0909678
                ],
                [
                    83.0600748,
                    54.0883944
                ],
                [
                    83.0532627,
                    54.0879881
                ],
                [
                    83.0496835,
                    54.0905615
                ]
            ],
            "longitude": 83.059692,
            "latitude": 54.095501
        },
        "3596": {
            "name": "Степной",
            "population": 378,
            "type": "village",
            "poly": [
                [
                    83.056897,
                    55.2361505
                ],
                [
                    83.0576183,
                    55.2370152
                ],
                [
                    83.0581639,
                    55.2372841
                ],
                [
                    83.0594585,
                    55.2375636
                ],
                [
                    83.0606698,
                    55.2372841
                ],
                [
                    83.0634434,
                    55.2375527
                ],
                [
                    83.065784,
                    55.2380305
                ],
                [
                    83.070841,
                    55.2392415
                ],
                [
                    83.073777,
                    55.2363164
                ],
                [
                    83.0730979,
                    55.232543
                ],
                [
                    83.0714941,
                    55.2313565
                ],
                [
                    83.0704249,
                    55.2297498
                ],
                [
                    83.0643979,
                    55.2301822
                ],
                [
                    83.0610423,
                    55.2301282
                ],
                [
                    83.0596989,
                    55.2309889
                ],
                [
                    83.0584984,
                    55.2327229
                ],
                [
                    83.056897,
                    55.2361505
                ]
            ],
            "longitude": 83.0650964,
            "latitude": 55.2332836
        },
        "3597": {
            "name": "Витаминка",
            "population": 371,
            "type": "village",
            "poly": [
                [
                    83.0989318,
                    55.137473
                ],
                [
                    83.1009205,
                    55.1381291
                ],
                [
                    83.102223,
                    55.1371975
                ],
                [
                    83.1035062,
                    55.137711
                ],
                [
                    83.1063934,
                    55.1360349
                ],
                [
                    83.1093896,
                    55.1366804
                ],
                [
                    83.1105124,
                    55.136464
                ],
                [
                    83.1108782,
                    55.1360533
                ],
                [
                    83.1120395,
                    55.134843
                ],
                [
                    83.1130596,
                    55.1341644
                ],
                [
                    83.1134959,
                    55.1335262
                ],
                [
                    83.1134766,
                    55.1329944
                ],
                [
                    83.1118855,
                    55.1324222
                ],
                [
                    83.1107755,
                    55.1318097
                ],
                [
                    83.1091587,
                    55.1313548
                ],
                [
                    83.108416,
                    55.1312443
                ],
                [
                    83.106386,
                    55.1324407
                ],
                [
                    83.1033647,
                    55.1339849
                ],
                [
                    83.1004206,
                    55.1361397
                ],
                [
                    83.0989318,
                    55.137473
                ]
            ],
            "longitude": 83.1066378,
            "latitude": 55.1347155
        },
        "3598": {
            "name": "Советский",
            "population": 247,
            "type": "village",
            "poly": [
                [
                    83.1080799,
                    55.1287559
                ],
                [
                    83.1092127,
                    55.1296042
                ],
                [
                    83.1118794,
                    55.1302977
                ],
                [
                    83.1178743,
                    55.1315414
                ],
                [
                    83.1186663,
                    55.1312376
                ],
                [
                    83.1196487,
                    55.1316216
                ],
                [
                    83.1201099,
                    55.1316789
                ],
                [
                    83.1218543,
                    55.1293634
                ],
                [
                    83.1216538,
                    55.1285954
                ],
                [
                    83.1203004,
                    55.1282515
                ],
                [
                    83.1127816,
                    55.1267154
                ],
                [
                    83.1110072,
                    55.1267211
                ],
                [
                    83.1099746,
                    55.1268357
                ],
                [
                    83.1091626,
                    55.1271281
                ],
                [
                    83.1080799,
                    55.1287559
                ]
            ],
            "longitude": 83.1149972,
            "latitude": 55.1290482
        },
        "3599": {
            "name": "Мочище",
            "population": 3698,
            "type": "village",
            "poly": [
                [
                    83.0973608,
                    55.1522847
                ],
                [
                    83.0978823,
                    55.1530819
                ],
                [
                    83.0989305,
                    55.1535266
                ],
                [
                    83.1002925,
                    55.1539749
                ],
                [
                    83.1015603,
                    55.1549001
                ],
                [
                    83.1019683,
                    55.1549037
                ],
                [
                    83.102552,
                    55.1551009
                ],
                [
                    83.1032613,
                    55.1558074
                ],
                [
                    83.1064874,
                    55.1572275
                ],
                [
                    83.1074172,
                    55.1576966
                ],
                [
                    83.1077358,
                    55.1577808
                ],
                [
                    83.1084903,
                    55.1576534
                ],
                [
                    83.1089943,
                    55.1574418
                ],
                [
                    83.1089675,
                    55.156758
                ],
                [
                    83.1089922,
                    55.1567368
                ],
                [
                    83.1091804,
                    55.1565962
                ],
                [
                    83.1097328,
                    55.1560225
                ],
                [
                    83.1113194,
                    55.1564155
                ],
                [
                    83.1110884,
                    55.1569835
                ],
                [
                    83.1109881,
                    55.1575343
                ],
                [
                    83.1112844,
                    55.1581941
                ],
                [
                    83.1117313,
                    55.1585814
                ],
                [
                    83.1121329,
                    55.1586961
                ],
                [
                    83.111661,
                    55.159944
                ],
                [
                    83.1110032,
                    55.16001
                ],
                [
                    83.1109028,
                    55.1605378
                ],
                [
                    83.1100994,
                    55.1615675
                ],
                [
                    83.1101596,
                    55.1621154
                ],
                [
                    83.1107973,
                    55.1623191
                ],
                [
                    83.1111086,
                    55.1626231
                ],
                [
                    83.1104457,
                    55.1632599
                ],
                [
                    83.110496,
                    55.1635496
                ],
                [
                    83.1112743,
                    55.1638823
                ],
                [
                    83.1103002,
                    55.1648174
                ],
                [
                    83.1112704,
                    55.1656129
                ],
                [
                    83.1128003,
                    55.1661013
                ],
                [
                    83.1129023,
                    55.1671814
                ],
                [
                    83.1139536,
                    55.1676519
                ],
                [
                    83.1155148,
                    55.1679342
                ],
                [
                    83.117139,
                    55.1679477
                ],
                [
                    83.1185512,
                    55.1675309
                ],
                [
                    83.1194848,
                    55.1668318
                ],
                [
                    83.1208029,
                    55.1645552
                ],
                [
                    83.1222779,
                    55.1648645
                ],
                [
                    83.1224526,
                    55.1649189
                ],
                [
                    83.1230546,
                    55.1651065
                ],
                [
                    83.1229448,
                    55.1653036
                ],
                [
                    83.1239139,
                    55.1655519
                ],
                [
                    83.1240118,
                    55.165577
                ],
                [
                    83.1241844,
                    55.1658504
                ],
                [
                    83.1265176,
                    55.1664106
                ],
                [
                    83.1280862,
                    55.1647968
                ],
                [
                    83.1333273,
                    55.1651703
                ],
                [
                    83.1331198,
                    55.1643061
                ],
                [
                    83.1341974,
                    55.1643368
                ],
                [
                    83.1341405,
                    55.1633048
                ],
                [
                    83.1363608,
                    55.160544
                ],
                [
                    83.135278,
                    55.1600285
                ],
                [
                    83.1336541,
                    55.1596072
                ],
                [
                    83.1334579,
                    55.1588453
                ],
                [
                    83.1344229,
                    55.1566399
                ],
                [
                    83.1329637,
                    55.1562275
                ],
                [
                    83.1325053,
                    55.1560898
                ],
                [
                    83.1313385,
                    55.1557393
                ],
                [
                    83.1294723,
                    55.1551786
                ],
                [
                    83.1254004,
                    55.1551517
                ],
                [
                    83.1254698,
                    55.1549676
                ],
                [
                    83.1257064,
                    55.1543403
                ],
                [
                    83.1257691,
                    55.1509333
                ],
                [
                    83.1246507,
                    55.150601
                ],
                [
                    83.1240039,
                    55.1504088
                ],
                [
                    83.123216,
                    55.1504364
                ],
                [
                    83.1227059,
                    55.1509833
                ],
                [
                    83.1212624,
                    55.1527675
                ],
                [
                    83.1205877,
                    55.1538569
                ],
                [
                    83.1163824,
                    55.1532338
                ],
                [
                    83.1151742,
                    55.1533996
                ],
                [
                    83.1146956,
                    55.1527048
                ],
                [
                    83.1152605,
                    55.1520323
                ],
                [
                    83.1151428,
                    55.1518575
                ],
                [
                    83.1124282,
                    55.1508174
                ],
                [
                    83.1093486,
                    55.1498552
                ],
                [
                    83.1066146,
                    55.1507309
                ],
                [
                    83.1043399,
                    55.1499562
                ],
                [
                    83.1035316,
                    55.1498041
                ],
                [
                    83.1020353,
                    55.1498328
                ],
                [
                    83.1007252,
                    55.1494495
                ],
                [
                    83.0993818,
                    55.1500898
                ],
                [
                    83.0980073,
                    55.1514061
                ],
                [
                    83.0973608,
                    55.1522847
                ]
            ],
            "longitude": 83.1180475,
            "latitude": 55.1563637
        },
        "3600": {
            "name": "Мичуринский",
            "population": 552,
            "type": "village",
            "poly": [
                [
                    83.1122308,
                    54.7450578
                ],
                [
                    83.1148861,
                    54.7457986
                ],
                [
                    83.1174667,
                    54.7464128
                ],
                [
                    83.1196246,
                    54.7467446
                ],
                [
                    83.1204869,
                    54.7460349
                ],
                [
                    83.1209261,
                    54.7458597
                ],
                [
                    83.1214451,
                    54.7455233
                ],
                [
                    83.1215329,
                    54.7451684
                ],
                [
                    83.1214587,
                    54.7449786
                ],
                [
                    83.12087,
                    54.7447747
                ],
                [
                    83.1207392,
                    54.744686
                ],
                [
                    83.1204972,
                    54.7445067
                ],
                [
                    83.1204481,
                    54.744316
                ],
                [
                    83.119951,
                    54.7439516
                ],
                [
                    83.119776,
                    54.7439703
                ],
                [
                    83.1195714,
                    54.7437399
                ],
                [
                    83.1187142,
                    54.7434078
                ],
                [
                    83.1181714,
                    54.7430897
                ],
                [
                    83.1180738,
                    54.7424205
                ],
                [
                    83.117443,
                    54.7416369
                ],
                [
                    83.116892,
                    54.7413096
                ],
                [
                    83.1162692,
                    54.7412082
                ],
                [
                    83.116413,
                    54.7408579
                ],
                [
                    83.116381,
                    54.7405445
                ],
                [
                    83.1174909,
                    54.7400282
                ],
                [
                    83.1183852,
                    54.7396779
                ],
                [
                    83.1186364,
                    54.7399321
                ],
                [
                    83.1185804,
                    54.7404553
                ],
                [
                    83.119064,
                    54.74071
                ],
                [
                    83.1188919,
                    54.7409676
                ],
                [
                    83.1206462,
                    54.7418126
                ],
                [
                    83.119741,
                    54.7421941
                ],
                [
                    83.1195849,
                    54.7424164
                ],
                [
                    83.1203653,
                    54.7428548
                ],
                [
                    83.1208439,
                    54.7425425
                ],
                [
                    83.1208127,
                    54.7422662
                ],
                [
                    83.120773,
                    54.7421427
                ],
                [
                    83.121259,
                    54.7419311
                ],
                [
                    83.1218641,
                    54.7422559
                ],
                [
                    83.1222648,
                    54.742337
                ],
                [
                    83.122529,
                    54.7424773
                ],
                [
                    83.1225581,
                    54.7424462
                ],
                [
                    83.1227833,
                    54.7422055
                ],
                [
                    83.1228444,
                    54.7421402
                ],
                [
                    83.1239894,
                    54.7424953
                ],
                [
                    83.1243283,
                    54.7419875
                ],
                [
                    83.1240044,
                    54.7417553
                ],
                [
                    83.1242601,
                    54.7415821
                ],
                [
                    83.1240987,
                    54.7410986
                ],
                [
                    83.1241189,
                    54.7406532
                ],
                [
                    83.1238362,
                    54.7405839
                ],
                [
                    83.123467,
                    54.7404933
                ],
                [
                    83.1233732,
                    54.7401538
                ],
                [
                    83.1232581,
                    54.7400554
                ],
                [
                    83.1235394,
                    54.7395756
                ],
                [
                    83.1233775,
                    54.7394083
                ],
                [
                    83.1238943,
                    54.7390513
                ],
                [
                    83.1241456,
                    54.7386768
                ],
                [
                    83.1241101,
                    54.7385445
                ],
                [
                    83.1211846,
                    54.7373906
                ],
                [
                    83.1196377,
                    54.7368955
                ],
                [
                    83.1189888,
                    54.7373626
                ],
                [
                    83.1194033,
                    54.7378117
                ],
                [
                    83.1196367,
                    54.7379241
                ],
                [
                    83.1192994,
                    54.7379625
                ],
                [
                    83.1185686,
                    54.7377235
                ],
                [
                    83.1182825,
                    54.7376763
                ],
                [
                    83.1181752,
                    54.7378032
                ],
                [
                    83.1179554,
                    54.7377117
                ],
                [
                    83.1179759,
                    54.7376025
                ],
                [
                    83.1176913,
                    54.7375758
                ],
                [
                    83.1173801,
                    54.7377309
                ],
                [
                    83.1166932,
                    54.7387207
                ],
                [
                    83.1160272,
                    54.7384497
                ],
                [
                    83.1160063,
                    54.738498
                ],
                [
                    83.1158909,
                    54.7387531
                ],
                [
                    83.1161402,
                    54.7387493
                ],
                [
                    83.1159665,
                    54.7389825
                ],
                [
                    83.1161361,
                    54.7391674
                ],
                [
                    83.1159561,
                    54.7393499
                ],
                [
                    83.1157391,
                    54.7393542
                ],
                [
                    83.1155527,
                    54.7397865
                ],
                [
                    83.1154643,
                    54.739813
                ],
                [
                    83.1152191,
                    54.7401679
                ],
                [
                    83.1150571,
                    54.7403189
                ],
                [
                    83.1135644,
                    54.7428358
                ],
                [
                    83.1122308,
                    54.7450578
                ]
            ],
            "longitude": 83.1196885,
            "latitude": 54.741153
        },
        "3601": {
            "name": "Новолуговое",
            "population": 4104,
            "type": "village",
            "poly": [
                [
                    83.096817,
                    54.9834751
                ],
                [
                    83.0999916,
                    54.9846011
                ],
                [
                    83.1009284,
                    54.9858426
                ],
                [
                    83.0989503,
                    54.9873162
                ],
                [
                    83.1013813,
                    54.9890227
                ],
                [
                    83.1031064,
                    54.9897954
                ],
                [
                    83.1063975,
                    54.9903657
                ],
                [
                    83.1104882,
                    54.9907417
                ],
                [
                    83.111948,
                    54.9913196
                ],
                [
                    83.1124369,
                    54.9912136
                ],
                [
                    83.1117505,
                    54.9898208
                ],
                [
                    83.1121905,
                    54.9888191
                ],
                [
                    83.1123755,
                    54.9874876
                ],
                [
                    83.1126194,
                    54.9861577
                ],
                [
                    83.1142203,
                    54.9857219
                ],
                [
                    83.1160385,
                    54.9853072
                ],
                [
                    83.1164896,
                    54.9860281
                ],
                [
                    83.1184825,
                    54.9872469
                ],
                [
                    83.1188879,
                    54.9873878
                ],
                [
                    83.1209969,
                    54.9875798
                ],
                [
                    83.1270031,
                    54.9856916
                ],
                [
                    83.1275241,
                    54.9847332
                ],
                [
                    83.1278867,
                    54.9832996
                ],
                [
                    83.1296641,
                    54.9808996
                ],
                [
                    83.1307206,
                    54.9797223
                ],
                [
                    83.1313657,
                    54.9791996
                ],
                [
                    83.1318621,
                    54.9789398
                ],
                [
                    83.1359869,
                    54.9778897
                ],
                [
                    83.1385802,
                    54.977203
                ],
                [
                    83.1424581,
                    54.9761358
                ],
                [
                    83.1411766,
                    54.9746461
                ],
                [
                    83.1420682,
                    54.9739795
                ],
                [
                    83.1392989,
                    54.9722445
                ],
                [
                    83.1396218,
                    54.9719974
                ],
                [
                    83.1377674,
                    54.971173
                ],
                [
                    83.1370766,
                    54.9709474
                ],
                [
                    83.1369095,
                    54.9712557
                ],
                [
                    83.1364521,
                    54.9711189
                ],
                [
                    83.1360407,
                    54.9714962
                ],
                [
                    83.1356723,
                    54.9713304
                ],
                [
                    83.1359282,
                    54.9708164
                ],
                [
                    83.1355887,
                    54.9703433
                ],
                [
                    83.1355701,
                    54.9701034
                ],
                [
                    83.1355982,
                    54.9700379
                ],
                [
                    83.1340522,
                    54.969882
                ],
                [
                    83.1326032,
                    54.9696362
                ],
                [
                    83.1313322,
                    54.9691819
                ],
                [
                    83.1292464,
                    54.9689258
                ],
                [
                    83.1242946,
                    54.9689002
                ],
                [
                    83.1219302,
                    54.9692459
                ],
                [
                    83.117692,
                    54.9707056
                ],
                [
                    83.1145245,
                    54.9723956
                ],
                [
                    83.1117251,
                    54.9738103
                ],
                [
                    83.1041411,
                    54.9778749
                ],
                [
                    83.1015536,
                    54.9792958
                ],
                [
                    83.1007206,
                    54.9803051
                ],
                [
                    83.0995181,
                    54.9814251
                ],
                [
                    83.096817,
                    54.9834751
                ]
            ],
            "longitude": 83.1208214,
            "latitude": 54.9785707
        },
        "3602": {
            "name": "Раздольное",
            "population": 4861,
            "type": "village",
            "poly": null,
            "longitude": 83.1222097,
            "latitude": 55.0562063
        },
        "3603": {
            "name": "Агролес",
            "population": 1378,
            "type": "village",
            "poly": [
                [
                    83.1260099,
                    54.7557702
                ],
                [
                    83.1279503,
                    54.7566432
                ],
                [
                    83.1307683,
                    54.7579824
                ],
                [
                    83.1313437,
                    54.7593272
                ],
                [
                    83.1310247,
                    54.7624861
                ],
                [
                    83.1338653,
                    54.771299
                ],
                [
                    83.1466968,
                    54.7673702
                ],
                [
                    83.1559859,
                    54.7660648
                ],
                [
                    83.1550965,
                    54.7622822
                ],
                [
                    83.1508243,
                    54.7566556
                ],
                [
                    83.1475527,
                    54.7555263
                ],
                [
                    83.1469529,
                    54.754935
                ],
                [
                    83.1473501,
                    54.754161
                ],
                [
                    83.1433699,
                    54.7532953
                ],
                [
                    83.1417375,
                    54.7529954
                ],
                [
                    83.1411389,
                    54.7529245
                ],
                [
                    83.1405465,
                    54.7528864
                ],
                [
                    83.1396518,
                    54.7528541
                ],
                [
                    83.1387914,
                    54.7528666
                ],
                [
                    83.1367505,
                    54.753047
                ],
                [
                    83.1310212,
                    54.7537061
                ],
                [
                    83.1305622,
                    54.7537815
                ],
                [
                    83.1301307,
                    54.7538633
                ],
                [
                    83.1293675,
                    54.7540225
                ],
                [
                    83.1285951,
                    54.7542527
                ],
                [
                    83.1278495,
                    54.7545182
                ],
                [
                    83.1271299,
                    54.7548468
                ],
                [
                    83.1260099,
                    54.7557702
                ]
            ],
            "longitude": 83.1344161,
            "latitude": 54.7566809
        },
        "3604": {
            "name": "Маяк",
            "population": 502,
            "type": "village",
            "poly": [
                [
                    83.1300089,
                    54.6987862
                ],
                [
                    83.1341758,
                    54.7018277
                ],
                [
                    83.1398913,
                    54.6979618
                ],
                [
                    83.1416707,
                    54.6964981
                ],
                [
                    83.1426792,
                    54.6970362
                ],
                [
                    83.1433258,
                    54.6960199
                ],
                [
                    83.1413345,
                    54.6945851
                ],
                [
                    83.1425499,
                    54.6911922
                ],
                [
                    83.1442567,
                    54.6928065
                ],
                [
                    83.1450325,
                    54.6924328
                ],
                [
                    83.1456274,
                    54.6917453
                ],
                [
                    83.1481876,
                    54.6914762
                ],
                [
                    83.1479549,
                    54.6907438
                ],
                [
                    83.1422106,
                    54.6897155
                ],
                [
                    83.1387638,
                    54.6893711
                ],
                [
                    83.1368346,
                    54.6891959
                ],
                [
                    83.1360628,
                    54.6891013
                ],
                [
                    83.1325859,
                    54.6959704
                ],
                [
                    83.1300089,
                    54.6987862
                ]
            ],
            "longitude": 83.1373471,
            "latitude": 54.6952608
        },
        "3605": {
            "name": "Каинская Заимка",
            "population": 303,
            "type": "village",
            "poly": [
                [
                    83.1295897,
                    54.8705239
                ],
                [
                    83.1305763,
                    54.8709239
                ],
                [
                    83.1313452,
                    54.8720279
                ],
                [
                    83.1345439,
                    54.8719675
                ],
                [
                    83.1354106,
                    54.8724593
                ],
                [
                    83.1331867,
                    54.8747851
                ],
                [
                    83.1341919,
                    54.8753793
                ],
                [
                    83.1366965,
                    54.8767892
                ],
                [
                    83.1452196,
                    54.8766544
                ],
                [
                    83.1542785,
                    54.8764204
                ],
                [
                    83.1567272,
                    54.874133
                ],
                [
                    83.155957,
                    54.8680756
                ],
                [
                    83.1522753,
                    54.8647323
                ],
                [
                    83.1453463,
                    54.867961
                ],
                [
                    83.1400593,
                    54.8683218
                ],
                [
                    83.1352926,
                    54.8688145
                ],
                [
                    83.1344369,
                    54.868903
                ],
                [
                    83.1312242,
                    54.8692974
                ],
                [
                    83.1295897,
                    54.8705239
                ]
            ],
            "longitude": 83.1448232,
            "latitude": 54.871989
        },
        "3606": {
            "name": "Ленинский",
            "population": 689,
            "type": "village",
            "poly": [
                [
                    83.1312162,
                    55.1388106
                ],
                [
                    83.1316794,
                    55.1389063
                ],
                [
                    83.1334673,
                    55.1393072
                ],
                [
                    83.1337904,
                    55.1393559
                ],
                [
                    83.1339834,
                    55.1398746
                ],
                [
                    83.1353056,
                    55.140175
                ],
                [
                    83.1360123,
                    55.1401376
                ],
                [
                    83.1360912,
                    55.1403133
                ],
                [
                    83.1367414,
                    55.140519
                ],
                [
                    83.1370302,
                    55.1408197
                ],
                [
                    83.1384288,
                    55.1413111
                ],
                [
                    83.1420759,
                    55.1426302
                ],
                [
                    83.1466123,
                    55.1435254
                ],
                [
                    83.1489807,
                    55.1434108
                ],
                [
                    83.151725,
                    55.1439265
                ],
                [
                    83.1542605,
                    55.1448718
                ],
                [
                    83.1550497,
                    55.1454439
                ],
                [
                    83.1580716,
                    55.1460379
                ],
                [
                    83.1586298,
                    55.1457079
                ],
                [
                    83.1598489,
                    55.1437498
                ],
                [
                    83.1622741,
                    55.1437608
                ],
                [
                    83.1635701,
                    55.1435995
                ],
                [
                    83.1630889,
                    55.1426534
                ],
                [
                    83.1632164,
                    55.1423635
                ],
                [
                    83.1634608,
                    55.1420376
                ],
                [
                    83.162889,
                    55.1416841
                ],
                [
                    83.160207,
                    55.1411084
                ],
                [
                    83.1599889,
                    55.1406903
                ],
                [
                    83.1547663,
                    55.1397369
                ],
                [
                    83.1536627,
                    55.1404813
                ],
                [
                    83.1463164,
                    55.1387027
                ],
                [
                    83.1449736,
                    55.138196
                ],
                [
                    83.1418591,
                    55.138133
                ],
                [
                    83.1410571,
                    55.1388779
                ],
                [
                    83.138611,
                    55.1388034
                ],
                [
                    83.1318441,
                    55.1381043
                ],
                [
                    83.1313128,
                    55.1384195
                ],
                [
                    83.1312162,
                    55.1388106
                ]
            ],
            "longitude": 83.1489895,
            "latitude": 55.1414482
        },
        "3607": {
            "name": "Крутишка",
            "population": 565,
            "type": "village",
            "poly": [
                [
                    83.1364677,
                    54.1768442
                ],
                [
                    83.1378397,
                    54.1778566
                ],
                [
                    83.1435661,
                    54.1805448
                ],
                [
                    83.1466083,
                    54.1818713
                ],
                [
                    83.1514699,
                    54.1831629
                ],
                [
                    83.1499786,
                    54.1860776
                ],
                [
                    83.1514997,
                    54.1871247
                ],
                [
                    83.1540945,
                    54.1861125
                ],
                [
                    83.1535875,
                    54.1877704
                ],
                [
                    83.1557647,
                    54.188835
                ],
                [
                    83.1569279,
                    54.1901787
                ],
                [
                    83.1597613,
                    54.1888699
                ],
                [
                    83.1625053,
                    54.1901787
                ],
                [
                    83.1636088,
                    54.1891316
                ],
                [
                    83.1600894,
                    54.1876308
                ],
                [
                    83.1594034,
                    54.186636
                ],
                [
                    83.157584,
                    54.1864964
                ],
                [
                    83.1565402,
                    54.1872469
                ],
                [
                    83.1559437,
                    54.1855889
                ],
                [
                    83.1577332,
                    54.1849431
                ],
                [
                    83.1566595,
                    54.1833898
                ],
                [
                    83.1571367,
                    54.1822728
                ],
                [
                    83.1566297,
                    54.1809113
                ],
                [
                    83.1548401,
                    54.1808066
                ],
                [
                    83.156063,
                    54.1800909
                ],
                [
                    83.1554665,
                    54.1795847
                ],
                [
                    83.1500084,
                    54.1775948
                ],
                [
                    83.1488154,
                    54.1779439
                ],
                [
                    83.1455048,
                    54.1762158
                ],
                [
                    83.143596,
                    54.1758142
                ],
                [
                    83.1408819,
                    54.1744875
                ],
                [
                    83.1401362,
                    54.1751683
                ],
                [
                    83.1394502,
                    54.1748541
                ],
                [
                    83.1364677,
                    54.1768442
                ]
            ],
            "longitude": 83.150841,
            "latitude": 54.180782
        },
        "3608": {
            "name": "Александровский",
            "population": 316,
            "type": "village",
            "poly": [
                [
                    83.1586182,
                    54.5801341
                ],
                [
                    83.1604989,
                    54.5821345
                ],
                [
                    83.160853,
                    54.5820191
                ],
                [
                    83.1637958,
                    54.5840323
                ],
                [
                    83.1648357,
                    54.5836989
                ],
                [
                    83.166451,
                    54.5853914
                ],
                [
                    83.1654774,
                    54.5868916
                ],
                [
                    83.1655659,
                    54.5880712
                ],
                [
                    83.1668935,
                    54.588802
                ],
                [
                    83.1708541,
                    54.5869172
                ],
                [
                    83.1700133,
                    54.5866608
                ],
                [
                    83.174151,
                    54.5846734
                ],
                [
                    83.1652119,
                    54.5791594
                ],
                [
                    83.1635745,
                    54.5798006
                ],
                [
                    83.163132,
                    54.5802751
                ],
                [
                    83.1613619,
                    54.5795955
                ],
                [
                    83.1595254,
                    54.5796339
                ],
                [
                    83.1586182,
                    54.5801341
                ]
            ],
            "longitude": 83.166752,
            "latitude": 54.5830618
        },
        "3609": {
            "name": "Октябрьский",
            "population": 1760,
            "type": "village",
            "poly": [
                [
                    83.1576694,
                    55.1680136
                ],
                [
                    83.1597996,
                    55.1694729
                ],
                [
                    83.1619648,
                    55.1700275
                ],
                [
                    83.1626751,
                    55.1707601
                ],
                [
                    83.1636824,
                    55.1716314
                ],
                [
                    83.1637475,
                    55.1721033
                ],
                [
                    83.1645683,
                    55.1727041
                ],
                [
                    83.1653881,
                    55.1736793
                ],
                [
                    83.1658456,
                    55.1736328
                ],
                [
                    83.1673811,
                    55.1746468
                ],
                [
                    83.1677163,
                    55.1749313
                ],
                [
                    83.1715028,
                    55.1762686
                ],
                [
                    83.1734098,
                    55.1764496
                ],
                [
                    83.1733464,
                    55.1770549
                ],
                [
                    83.1736317,
                    55.1773032
                ],
                [
                    83.1751309,
                    55.1777429
                ],
                [
                    83.1758512,
                    55.1779679
                ],
                [
                    83.1759508,
                    55.1781205
                ],
                [
                    83.1762899,
                    55.1789467
                ],
                [
                    83.1763543,
                    55.1791037
                ],
                [
                    83.1764237,
                    55.1791325
                ],
                [
                    83.1788668,
                    55.1801464
                ],
                [
                    83.1821435,
                    55.181193
                ],
                [
                    83.1868305,
                    55.1799825
                ],
                [
                    83.1870409,
                    55.1799281
                ],
                [
                    83.1865173,
                    55.1793543
                ],
                [
                    83.1855336,
                    55.1774872
                ],
                [
                    83.1846135,
                    55.1754463
                ],
                [
                    83.1846631,
                    55.1740761
                ],
                [
                    83.1837218,
                    55.1719622
                ],
                [
                    83.1785312,
                    55.1710999
                ],
                [
                    83.1762904,
                    55.1707407
                ],
                [
                    83.1733306,
                    55.1702572
                ],
                [
                    83.1699471,
                    55.1696355
                ],
                [
                    83.1679541,
                    55.1691051
                ],
                [
                    83.1667991,
                    55.1685974
                ],
                [
                    83.1622002,
                    55.1665264
                ],
                [
                    83.1606602,
                    55.1659598
                ],
                [
                    83.1581546,
                    55.1651818
                ],
                [
                    83.1576694,
                    55.1680136
                ]
            ],
            "longitude": 83.1757585,
            "latitude": 55.1730637
        },
        "3610": {
            "name": "Дорогина Заимка",
            "population": 366,
            "type": "village",
            "poly": [
                [
                    83.1780447,
                    54.346992
                ],
                [
                    83.1789261,
                    54.3484048
                ],
                [
                    83.1803426,
                    54.3485332
                ],
                [
                    83.1811296,
                    54.347836
                ],
                [
                    83.1820739,
                    54.3485699
                ],
                [
                    83.1843404,
                    54.3476342
                ],
                [
                    83.1863864,
                    54.3493405
                ],
                [
                    83.1867012,
                    54.350056
                ],
                [
                    83.1878974,
                    54.3508082
                ],
                [
                    83.1873623,
                    54.3513586
                ],
                [
                    83.1885584,
                    54.3522759
                ],
                [
                    83.1909193,
                    54.3512485
                ],
                [
                    83.1906045,
                    54.3506614
                ],
                [
                    83.1918636,
                    54.350001
                ],
                [
                    83.1869845,
                    54.3475608
                ],
                [
                    83.1876456,
                    54.3472122
                ],
                [
                    83.1837108,
                    54.3439462
                ],
                [
                    83.183396,
                    54.3415607
                ],
                [
                    83.1852532,
                    54.3414139
                ],
                [
                    83.1881177,
                    54.3392118
                ],
                [
                    83.1855995,
                    54.3373216
                ],
                [
                    83.1804371,
                    54.338019
                ],
                [
                    83.1794612,
                    54.3399091
                ],
                [
                    83.1801538,
                    54.3420378
                ],
                [
                    83.1801222,
                    54.3439278
                ],
                [
                    83.1814129,
                    54.3451022
                ],
                [
                    83.1788631,
                    54.3457994
                ],
                [
                    83.1780447,
                    54.346992
                ]
            ],
            "longitude": 83.181229,
            "latitude": 54.344009
        },
        "3611": {
            "name": "Бердь",
            "population": 535,
            "type": "village",
            "poly": [
                [
                    83.1723454,
                    54.7481695
                ],
                [
                    83.1772225,
                    54.7496895
                ],
                [
                    83.1853771,
                    54.7446077
                ],
                [
                    83.1879559,
                    54.7418397
                ],
                [
                    83.1871324,
                    54.7415257
                ],
                [
                    83.1874325,
                    54.7411544
                ],
                [
                    83.1865878,
                    54.740906
                ],
                [
                    83.1906206,
                    54.7366452
                ],
                [
                    83.1915212,
                    54.7368938
                ],
                [
                    83.1926782,
                    54.735736
                ],
                [
                    83.1953662,
                    54.7330651
                ],
                [
                    83.1926962,
                    54.7322342
                ],
                [
                    83.186707,
                    54.7372852
                ],
                [
                    83.1834802,
                    54.7357502
                ],
                [
                    83.1723454,
                    54.7481695
                ]
            ],
            "longitude": 83.1826883,
            "latitude": 54.742159
        },
        "3612": {
            "name": "Барышево",
            "population": 5195,
            "type": "village",
            "poly": [
                [
                    83.1491377,
                    54.9456461
                ],
                [
                    83.1501121,
                    54.9487845
                ],
                [
                    83.1508154,
                    54.9490826
                ],
                [
                    83.152057,
                    54.9491092
                ],
                [
                    83.1535918,
                    54.9497824
                ],
                [
                    83.1566304,
                    54.9512528
                ],
                [
                    83.1579723,
                    54.9515185
                ],
                [
                    83.1589749,
                    54.9520367
                ],
                [
                    83.1607101,
                    54.9530553
                ],
                [
                    83.1609985,
                    54.9537251
                ],
                [
                    83.1640003,
                    54.9555033
                ],
                [
                    83.1678946,
                    54.9562487
                ],
                [
                    83.1726347,
                    54.9580644
                ],
                [
                    83.1734524,
                    54.9585138
                ],
                [
                    83.1738075,
                    54.9587089
                ],
                [
                    83.1755132,
                    54.9592433
                ],
                [
                    83.180687,
                    54.9608452
                ],
                [
                    83.191615,
                    54.9701468
                ],
                [
                    83.1948899,
                    54.971645
                ],
                [
                    83.1960349,
                    54.9728392
                ],
                [
                    83.1965643,
                    54.9744927
                ],
                [
                    83.196675,
                    54.9755385
                ],
                [
                    83.1964273,
                    54.9762762
                ],
                [
                    83.1977287,
                    54.9769992
                ],
                [
                    83.1991495,
                    54.9769696
                ],
                [
                    83.1991989,
                    54.9758
                ],
                [
                    83.2005532,
                    54.9758989
                ],
                [
                    83.2008118,
                    54.9744504
                ],
                [
                    83.2047118,
                    54.9716884
                ],
                [
                    83.2024293,
                    54.9693412
                ],
                [
                    83.208433,
                    54.9646587
                ],
                [
                    83.203002,
                    54.9641468
                ],
                [
                    83.201742,
                    54.9641029
                ],
                [
                    83.1998735,
                    54.9637871
                ],
                [
                    83.1979319,
                    54.9630728
                ],
                [
                    83.1970098,
                    54.9626427
                ],
                [
                    83.1962481,
                    54.9621866
                ],
                [
                    83.1956714,
                    54.961726
                ],
                [
                    83.1952553,
                    54.9610891
                ],
                [
                    83.1947493,
                    54.9603146
                ],
                [
                    83.1937745,
                    54.9592712
                ],
                [
                    83.1926837,
                    54.9584638
                ],
                [
                    83.1924634,
                    54.9583007
                ],
                [
                    83.1911856,
                    54.9576469
                ],
                [
                    83.1897881,
                    54.9570812
                ],
                [
                    83.1878434,
                    54.9563363
                ],
                [
                    83.1873202,
                    54.9561382
                ],
                [
                    83.1849199,
                    54.9551639
                ],
                [
                    83.1836915,
                    54.954691
                ],
                [
                    83.1820642,
                    54.9540764
                ],
                [
                    83.1800287,
                    54.9534686
                ],
                [
                    83.1769592,
                    54.952897
                ],
                [
                    83.177679,
                    54.9495294
                ],
                [
                    83.164968,
                    54.9457289
                ],
                [
                    83.1496923,
                    54.9450636
                ],
                [
                    83.1491377,
                    54.9456461
                ]
            ],
            "longitude": 83.1882987,
            "latitude": 54.9622004
        },
        "3613": {
            "name": "Кандаурово",
            "population": 628,
            "type": "village",
            "poly": null,
            "longitude": 83.194389,
            "latitude": 55.675274
        },
        "3614": {
            "name": "Белоярка",
            "population": 975,
            "type": "village",
            "poly": [
                [
                    83.1829142,
                    55.4185449
                ],
                [
                    83.198122,
                    55.4243087
                ],
                [
                    83.2073059,
                    55.4265005
                ],
                [
                    83.2101383,
                    55.4245523
                ],
                [
                    83.2028427,
                    55.4211426
                ],
                [
                    83.2043718,
                    55.4180578
                ],
                [
                    83.220508,
                    55.4121139
                ],
                [
                    83.2064318,
                    55.4045123
                ],
                [
                    83.1829142,
                    55.4185449
                ]
            ],
            "longitude": 83.199577,
            "latitude": 55.415203
        },
        "3615": {
            "name": "Двуречье",
            "population": 2957,
            "type": "village",
            "poly": [
                [
                    83.1957365,
                    54.95766
                ],
                [
                    83.19843,
                    54.9577332
                ],
                [
                    83.1989571,
                    54.9583552
                ],
                [
                    83.2002025,
                    54.9588308
                ],
                [
                    83.201718,
                    54.9581408
                ],
                [
                    83.203014,
                    54.9581408
                ],
                [
                    83.2081764,
                    54.9591469
                ],
                [
                    83.2088128,
                    54.9586605
                ],
                [
                    83.2104511,
                    54.960107
                ],
                [
                    83.2115624,
                    54.9616467
                ],
                [
                    83.2103422,
                    54.9620507
                ],
                [
                    83.2063164,
                    54.9624457
                ],
                [
                    83.2059162,
                    54.9625925
                ],
                [
                    83.2092541,
                    54.9638521
                ],
                [
                    83.2113828,
                    54.9645088
                ],
                [
                    83.2138881,
                    54.9650866
                ],
                [
                    83.2147787,
                    54.9646502
                ],
                [
                    83.2152638,
                    54.9643592
                ],
                [
                    83.2166297,
                    54.9622975
                ],
                [
                    83.2177483,
                    54.9609116
                ],
                [
                    83.2163364,
                    54.9603816
                ],
                [
                    83.2161825,
                    54.960075
                ],
                [
                    83.2159924,
                    54.9588564
                ],
                [
                    83.2208148,
                    54.9560956
                ],
                [
                    83.2179157,
                    54.9536189
                ],
                [
                    83.2139985,
                    54.9502893
                ],
                [
                    83.2120469,
                    54.9493066
                ],
                [
                    83.2089062,
                    54.9513122
                ],
                [
                    83.2085661,
                    54.9515385
                ],
                [
                    83.2058501,
                    54.9533461
                ],
                [
                    83.2054447,
                    54.953386
                ],
                [
                    83.2032088,
                    54.9532829
                ],
                [
                    83.2028033,
                    54.9534093
                ],
                [
                    83.1963737,
                    54.9569915
                ],
                [
                    83.1959508,
                    54.9571745
                ],
                [
                    83.1957365,
                    54.95766
                ]
            ],
            "longitude": 83.2069002,
            "latitude": 54.9576118
        },
        "3616": {
            "name": "Издревая",
            "population": 697,
            "type": "village",
            "poly": [
                [
                    83.2035238,
                    54.9758665
                ],
                [
                    83.2036046,
                    54.9764916
                ],
                [
                    83.2051336,
                    54.9770936
                ],
                [
                    83.2052465,
                    54.9767463
                ],
                [
                    83.205654,
                    54.9766653
                ],
                [
                    83.2062793,
                    54.9770867
                ],
                [
                    83.2064165,
                    54.97739
                ],
                [
                    83.2070095,
                    54.9771885
                ],
                [
                    83.2082319,
                    54.9780406
                ],
                [
                    83.2084901,
                    54.9783763
                ],
                [
                    83.2080262,
                    54.9788147
                ],
                [
                    83.2087543,
                    54.9798349
                ],
                [
                    83.2093547,
                    54.9803508
                ],
                [
                    83.2087007,
                    54.9805317
                ],
                [
                    83.2099535,
                    54.9821233
                ],
                [
                    83.2103317,
                    54.9830276
                ],
                [
                    83.2110645,
                    54.9839002
                ],
                [
                    83.2118009,
                    54.9852835
                ],
                [
                    83.2124879,
                    54.9859345
                ],
                [
                    83.2129153,
                    54.9862518
                ],
                [
                    83.2132922,
                    54.9864977
                ],
                [
                    83.213695,
                    54.9867081
                ],
                [
                    83.2140358,
                    54.9867763
                ],
                [
                    83.2145419,
                    54.98672
                ],
                [
                    83.2149008,
                    54.9865748
                ],
                [
                    83.2149782,
                    54.9862459
                ],
                [
                    83.2145755,
                    54.9860029
                ],
                [
                    83.2142068,
                    54.9857645
                ],
                [
                    83.2142663,
                    54.9857136
                ],
                [
                    83.2150829,
                    54.9857376
                ],
                [
                    83.2151668,
                    54.985345
                ],
                [
                    83.2158467,
                    54.9852026
                ],
                [
                    83.2135908,
                    54.9824699
                ],
                [
                    83.2135971,
                    54.9821986
                ],
                [
                    83.2130865,
                    54.9814209
                ],
                [
                    83.2102957,
                    54.9786107
                ],
                [
                    83.2090812,
                    54.977246
                ],
                [
                    83.2087464,
                    54.9768729
                ],
                [
                    83.2088267,
                    54.9766323
                ],
                [
                    83.2060209,
                    54.9734202
                ],
                [
                    83.2052795,
                    54.9734291
                ],
                [
                    83.2047322,
                    54.9735981
                ],
                [
                    83.2053114,
                    54.9744243
                ],
                [
                    83.204688,
                    54.9750998
                ],
                [
                    83.2051616,
                    54.9756167
                ],
                [
                    83.2046886,
                    54.9757915
                ],
                [
                    83.2044921,
                    54.9756049
                ],
                [
                    83.2039677,
                    54.9754937
                ],
                [
                    83.2035238,
                    54.9758665
                ]
            ],
            "longitude": 83.209215,
            "latitude": 54.9785507
        },
        "3617": {
            "name": "Морозово",
            "population": 594,
            "type": "village",
            "poly": [
                [
                    83.2082065,
                    54.7641903
                ],
                [
                    83.2084858,
                    54.7644833
                ],
                [
                    83.2089766,
                    54.7646151
                ],
                [
                    83.2092899,
                    54.7649228
                ],
                [
                    83.2088835,
                    54.7653085
                ],
                [
                    83.2087143,
                    54.7655185
                ],
                [
                    83.209273,
                    54.7657138
                ],
                [
                    83.2086297,
                    54.7664512
                ],
                [
                    83.2085704,
                    54.766754
                ],
                [
                    83.2096538,
                    54.7670909
                ],
                [
                    83.2101397,
                    54.7669167
                ],
                [
                    83.2108422,
                    54.7674294
                ],
                [
                    83.2120695,
                    54.7677712
                ],
                [
                    83.2124504,
                    54.7677516
                ],
                [
                    83.212662,
                    54.7674147
                ],
                [
                    83.2128567,
                    54.7673757
                ],
                [
                    83.2135337,
                    54.7679958
                ],
                [
                    83.213847,
                    54.767947
                ],
                [
                    83.2140502,
                    54.7682839
                ],
                [
                    83.2147865,
                    54.7690114
                ],
                [
                    83.2153536,
                    54.7692604
                ],
                [
                    83.2171227,
                    54.7697194
                ],
                [
                    83.2183608,
                    54.7700116
                ],
                [
                    83.2179112,
                    54.7707522
                ],
                [
                    83.2186478,
                    54.7710178
                ],
                [
                    83.219558,
                    54.7709147
                ],
                [
                    83.2202621,
                    54.7703053
                ],
                [
                    83.2212751,
                    54.7705835
                ],
                [
                    83.2209935,
                    54.7709209
                ],
                [
                    83.2224345,
                    54.7713615
                ],
                [
                    83.2220444,
                    54.7717334
                ],
                [
                    83.2230412,
                    54.7720615
                ],
                [
                    83.224065,
                    54.7712647
                ],
                [
                    83.2245688,
                    54.7712928
                ],
                [
                    83.2251809,
                    54.7708147
                ],
                [
                    83.2251972,
                    54.7706741
                ],
                [
                    83.2252026,
                    54.7703335
                ],
                [
                    83.2248072,
                    54.7701897
                ],
                [
                    83.2251322,
                    54.7698897
                ],
                [
                    83.2250834,
                    54.7696054
                ],
                [
                    83.2249697,
                    54.769471
                ],
                [
                    83.2249642,
                    54.7691522
                ],
                [
                    83.2245959,
                    54.7689991
                ],
                [
                    83.2253868,
                    54.7681304
                ],
                [
                    83.2253922,
                    54.7679554
                ],
                [
                    83.2260477,
                    54.7673835
                ],
                [
                    83.2266381,
                    54.7667366
                ],
                [
                    83.2271961,
                    54.7662397
                ],
                [
                    83.227689,
                    54.7665116
                ],
                [
                    83.2278624,
                    54.7666147
                ],
                [
                    83.2262806,
                    54.7680804
                ],
                [
                    83.2272286,
                    54.7683554
                ],
                [
                    83.2281928,
                    54.767771
                ],
                [
                    83.2285395,
                    54.7674803
                ],
                [
                    83.2293142,
                    54.7677397
                ],
                [
                    83.2295309,
                    54.7674085
                ],
                [
                    83.2292274,
                    54.7666491
                ],
                [
                    83.2294821,
                    54.7665866
                ],
                [
                    83.2298342,
                    54.7663553
                ],
                [
                    83.2301159,
                    54.766374
                ],
                [
                    83.2307226,
                    54.7660865
                ],
                [
                    83.2306522,
                    54.7658553
                ],
                [
                    83.2304409,
                    54.7656427
                ],
                [
                    83.2311722,
                    54.765524
                ],
                [
                    83.2308201,
                    54.7649271
                ],
                [
                    83.2301051,
                    54.7651583
                ],
                [
                    83.2291408,
                    54.7645364
                ],
                [
                    83.2284854,
                    54.7647989
                ],
                [
                    83.2279328,
                    54.7651583
                ],
                [
                    83.227597,
                    54.7649614
                ],
                [
                    83.2268548,
                    54.7648521
                ],
                [
                    83.2268277,
                    54.764202
                ],
                [
                    83.2261225,
                    54.7641401
                ],
                [
                    83.2260548,
                    54.7637153
                ],
                [
                    83.225404,
                    54.7636765
                ],
                [
                    83.2253089,
                    54.7640022
                ],
                [
                    83.2249402,
                    54.7640975
                ],
                [
                    83.2246186,
                    54.7640633
                ],
                [
                    83.2245932,
                    54.7637508
                ],
                [
                    83.2241192,
                    54.7637996
                ],
                [
                    83.2237891,
                    54.7639998
                ],
                [
                    83.2231797,
                    54.7640145
                ],
                [
                    83.2232135,
                    54.7643319
                ],
                [
                    83.2238145,
                    54.7644296
                ],
                [
                    83.2235521,
                    54.764786
                ],
                [
                    83.2224941,
                    54.764493
                ],
                [
                    83.2212667,
                    54.7642098
                ],
                [
                    83.2211398,
                    54.7640193
                ],
                [
                    83.2203018,
                    54.763868
                ],
                [
                    83.2199209,
                    54.7646151
                ],
                [
                    83.2193369,
                    54.7650351
                ],
                [
                    83.2188375,
                    54.7650937
                ],
                [
                    83.218135,
                    54.7652744
                ],
                [
                    83.2176948,
                    54.7646005
                ],
                [
                    83.2188883,
                    54.7644003
                ],
                [
                    83.2187275,
                    54.7640584
                ],
                [
                    83.2175002,
                    54.7642489
                ],
                [
                    83.2165437,
                    54.7644003
                ],
                [
                    83.2159343,
                    54.7646493
                ],
                [
                    83.2164252,
                    54.7657676
                ],
                [
                    83.2147154,
                    54.7661289
                ],
                [
                    83.2139706,
                    54.7648739
                ],
                [
                    83.2126079,
                    54.7649765
                ],
                [
                    83.2120154,
                    54.7648056
                ],
                [
                    83.2119053,
                    54.7643905
                ],
                [
                    83.2105849,
                    54.7640242
                ],
                [
                    83.2099415,
                    54.7638728
                ],
                [
                    83.2093745,
                    54.7636629
                ],
                [
                    83.2082065,
                    54.7641903
                ]
            ],
            "longitude": 83.2178159,
            "latitude": 54.7661423
        },
        "3618": {
            "name": "Рощинский",
            "population": 533,
            "type": "village",
            "poly": [
                [
                    83.2097484,
                    54.6338233
                ],
                [
                    83.2153517,
                    54.6347568
                ],
                [
                    83.2147427,
                    54.6353696
                ],
                [
                    83.2144186,
                    54.6359265
                ],
                [
                    83.2148476,
                    54.6365134
                ],
                [
                    83.2185903,
                    54.6371572
                ],
                [
                    83.2211147,
                    54.6365488
                ],
                [
                    83.2209129,
                    54.6372923
                ],
                [
                    83.2223428,
                    54.6373475
                ],
                [
                    83.2232164,
                    54.6368317
                ],
                [
                    83.2240048,
                    54.637204
                ],
                [
                    83.2262305,
                    54.6369096
                ],
                [
                    83.2296174,
                    54.6362491
                ],
                [
                    83.2243894,
                    54.6349647
                ],
                [
                    83.224356,
                    54.6347121
                ],
                [
                    83.2207439,
                    54.6330677
                ],
                [
                    83.2105458,
                    54.631893
                ],
                [
                    83.2097484,
                    54.6338233
                ]
            ],
            "longitude": 83.2179023,
            "latitude": 54.6362689
        },
        "3619": {
            "name": "Барлак",
            "population": 387,
            "type": "village",
            "poly": [
                [
                    83.2147199,
                    55.2144152
                ],
                [
                    83.2151134,
                    55.2156098
                ],
                [
                    83.2164345,
                    55.2164437
                ],
                [
                    83.2165188,
                    55.2168445
                ],
                [
                    83.2156896,
                    55.2172855
                ],
                [
                    83.215802,
                    55.2178226
                ],
                [
                    83.2160691,
                    55.2182716
                ],
                [
                    83.2167155,
                    55.2185281
                ],
                [
                    83.2176993,
                    55.2187767
                ],
                [
                    83.2184723,
                    55.2188167
                ],
                [
                    83.2190625,
                    55.2185843
                ],
                [
                    83.2201025,
                    55.218007
                ],
                [
                    83.2208614,
                    55.2173977
                ],
                [
                    83.2221685,
                    55.2162272
                ],
                [
                    83.2227728,
                    55.2151368
                ],
                [
                    83.2234614,
                    55.2142949
                ],
                [
                    83.2238689,
                    55.2132847
                ],
                [
                    83.223377,
                    55.212098
                ],
                [
                    83.2232787,
                    55.2115527
                ],
                [
                    83.224909,
                    55.2102617
                ],
                [
                    83.2258084,
                    55.209075
                ],
                [
                    83.2269889,
                    55.208241
                ],
                [
                    83.2297856,
                    55.2094037
                ],
                [
                    83.2311629,
                    55.2100533
                ],
                [
                    83.2328072,
                    55.2087783
                ],
                [
                    83.2335381,
                    55.2085457
                ],
                [
                    83.2342266,
                    55.2086018
                ],
                [
                    83.2354634,
                    55.2090028
                ],
                [
                    83.2358429,
                    55.2086259
                ],
                [
                    83.2355759,
                    55.2077679
                ],
                [
                    83.2341705,
                    55.2056588
                ],
                [
                    83.2333694,
                    55.2047766
                ],
                [
                    83.2325402,
                    55.2044157
                ],
                [
                    83.2259771,
                    55.2022984
                ],
                [
                    83.2261176,
                    55.204119
                ],
                [
                    83.2257944,
                    55.2044317
                ],
                [
                    83.2248668,
                    55.2043676
                ],
                [
                    83.2238268,
                    55.2043997
                ],
                [
                    83.2229555,
                    55.2045921
                ],
                [
                    83.2222949,
                    55.2049209
                ],
                [
                    83.2213674,
                    55.2050172
                ],
                [
                    83.2204258,
                    55.2054422
                ],
                [
                    83.2199198,
                    55.2061961
                ],
                [
                    83.2185426,
                    55.207824
                ],
                [
                    83.217882,
                    55.2085938
                ],
                [
                    83.2175588,
                    55.2090589
                ],
                [
                    83.2167577,
                    55.2092834
                ],
                [
                    83.2158582,
                    55.209941
                ],
                [
                    83.2156475,
                    55.2106306
                ],
                [
                    83.2158723,
                    55.2114806
                ],
                [
                    83.2159285,
                    55.2123946
                ],
                [
                    83.2152258,
                    55.2131484
                ],
                [
                    83.2147199,
                    55.2144152
                ]
            ],
            "longitude": 83.2197282,
            "latitude": 55.212267
        },
        "3620": {
            "name": "Крахаль",
            "population": 636,
            "type": "village",
            "poly": [
                [
                    83.2140125,
                    54.9664643
                ],
                [
                    83.2176023,
                    54.9677586
                ],
                [
                    83.2177782,
                    54.9679827
                ],
                [
                    83.2182315,
                    54.9689453
                ],
                [
                    83.2185034,
                    54.9691936
                ],
                [
                    83.2211979,
                    54.9701538
                ],
                [
                    83.228441,
                    54.9720386
                ],
                [
                    83.2337213,
                    54.972854
                ],
                [
                    83.234829,
                    54.9718625
                ],
                [
                    83.2313094,
                    54.9707142
                ],
                [
                    83.2282668,
                    54.969864
                ],
                [
                    83.2261289,
                    54.9692483
                ],
                [
                    83.2238977,
                    54.9686131
                ],
                [
                    83.2209857,
                    54.9677418
                ],
                [
                    83.2214693,
                    54.9670777
                ],
                [
                    83.2241422,
                    54.9675211
                ],
                [
                    83.22424,
                    54.9675004
                ],
                [
                    83.2248271,
                    54.9669683
                ],
                [
                    83.223586,
                    54.9660636
                ],
                [
                    83.22271,
                    54.9659818
                ],
                [
                    83.2219766,
                    54.9655466
                ],
                [
                    83.2166081,
                    54.9636828
                ],
                [
                    83.2161302,
                    54.9635835
                ],
                [
                    83.2149148,
                    54.9649955
                ],
                [
                    83.2140125,
                    54.9664643
                ]
            ],
            "longitude": 83.2229782,
            "latitude": 54.9686792
        },
        "3621": {
            "name": "Лебедевка",
            "population": 4392,
            "type": "village",
            "poly": [
                [
                    83.2176634,
                    54.6736914
                ],
                [
                    83.2272079,
                    54.6770491
                ],
                [
                    83.2325769,
                    54.6803124
                ],
                [
                    83.2395291,
                    54.6764085
                ],
                [
                    83.2461322,
                    54.6726712
                ],
                [
                    83.2468341,
                    54.6722841
                ],
                [
                    83.247124,
                    54.6712833
                ],
                [
                    83.2478114,
                    54.6703124
                ],
                [
                    83.2474598,
                    54.6693556
                ],
                [
                    83.2444201,
                    54.6676748
                ],
                [
                    83.2425307,
                    54.6667236
                ],
                [
                    83.241394,
                    54.665494
                ],
                [
                    83.2390511,
                    54.6639924
                ],
                [
                    83.2418879,
                    54.6619033
                ],
                [
                    83.2380865,
                    54.6599046
                ],
                [
                    83.2336232,
                    54.6630472
                ],
                [
                    83.2321719,
                    54.6640297
                ],
                [
                    83.2309745,
                    54.6651185
                ],
                [
                    83.2274833,
                    54.6681467
                ],
                [
                    83.2229883,
                    54.6705837
                ],
                [
                    83.2194119,
                    54.6721369
                ],
                [
                    83.2176634,
                    54.6736914
                ]
            ],
            "longitude": 83.2315641,
            "latitude": 54.6733786
        },
        "3622": {
            "name": "Гусиный Брод",
            "population": 571,
            "type": "village",
            "poly": null,
            "longitude": 83.2388845,
            "latitude": 55.0658463
        },
        "3623": {
            "name": "Успенка",
            "population": 421,
            "type": "village",
            "poly": [
                [
                    83.232181,
                    55.4348126
                ],
                [
                    83.2440256,
                    55.4412398
                ],
                [
                    83.2556986,
                    55.4363708
                ],
                [
                    83.2507204,
                    55.4323777
                ],
                [
                    83.2479035,
                    55.4329336
                ],
                [
                    83.2467722,
                    55.4331569
                ],
                [
                    83.2419657,
                    55.4322803
                ],
                [
                    83.232181,
                    55.4348126
                ]
            ],
            "longitude": 83.239403,
            "latitude": 55.437393
        },
        "3624": {
            "name": "Барлакский",
            "population": 419,
            "type": "village",
            "poly": null,
            "longitude": 83.2407183,
            "latitude": 55.168276
        },
        "3625": {
            "name": "Издревая",
            "population": 757,
            "type": "village",
            "poly": [
                [
                    83.230793,
                    54.9916393
                ],
                [
                    83.2397339,
                    54.9951668
                ],
                [
                    83.2443221,
                    54.9919645
                ],
                [
                    83.2439858,
                    54.9904423
                ],
                [
                    83.2454338,
                    54.9895472
                ],
                [
                    83.2480105,
                    54.9903386
                ],
                [
                    83.2508373,
                    54.989026
                ],
                [
                    83.2545598,
                    54.9847192
                ],
                [
                    83.2486296,
                    54.9790232
                ],
                [
                    83.2379497,
                    54.9875245
                ],
                [
                    83.230793,
                    54.9916393
                ]
            ],
            "longitude": 83.2459288,
            "latitude": 54.9864402
        },
        "3626": {
            "name": "Грибной",
            "population": 332,
            "type": "village",
            "poly": [
                [
                    83.2385048,
                    54.2846651
                ],
                [
                    83.2390569,
                    54.2866574
                ],
                [
                    83.2419929,
                    54.287302
                ],
                [
                    83.244904,
                    54.2871555
                ],
                [
                    83.2459329,
                    54.2869504
                ],
                [
                    83.246987,
                    54.2878879
                ],
                [
                    83.2488189,
                    54.2874485
                ],
                [
                    83.2533611,
                    54.2871994
                ],
                [
                    83.2534866,
                    54.2866867
                ],
                [
                    83.2546159,
                    54.2867014
                ],
                [
                    83.2547879,
                    54.2863078
                ],
                [
                    83.2547163,
                    54.285339
                ],
                [
                    83.2524326,
                    54.2843575
                ],
                [
                    83.2509269,
                    54.2841963
                ],
                [
                    83.2454812,
                    54.2843721
                ],
                [
                    83.2445276,
                    54.2838008
                ],
                [
                    83.2441763,
                    54.2822186
                ],
                [
                    83.2424698,
                    54.2823358
                ],
                [
                    83.2424446,
                    54.2837276
                ],
                [
                    83.2424446,
                    54.2846798
                ],
                [
                    83.2392074,
                    54.2844454
                ],
                [
                    83.2385048,
                    54.2846651
                ]
            ],
            "longitude": 83.248863,
            "latitude": 54.286129
        },
        "3627": {
            "name": "Койниха",
            "population": 335,
            "type": "village",
            "poly": [
                [
                    83.2446717,
                    54.5666485
                ],
                [
                    83.2446717,
                    54.5688401
                ],
                [
                    83.2463322,
                    54.5698027
                ],
                [
                    83.2475688,
                    54.5704172
                ],
                [
                    83.2513844,
                    54.5712364
                ],
                [
                    83.2520909,
                    54.5713183
                ],
                [
                    83.2522676,
                    54.572117
                ],
                [
                    83.2528682,
                    54.5720966
                ],
                [
                    83.2564012,
                    54.5702124
                ],
                [
                    83.2575318,
                    54.5708473
                ],
                [
                    83.2573905,
                    54.571687
                ],
                [
                    83.2567192,
                    54.5717484
                ],
                [
                    83.2569312,
                    54.5727314
                ],
                [
                    83.2599696,
                    54.5728543
                ],
                [
                    83.259157,
                    54.5714412
                ],
                [
                    83.2617714,
                    54.5710725
                ],
                [
                    83.2596869,
                    54.5691883
                ],
                [
                    83.2592983,
                    54.567775
                ],
                [
                    83.2583797,
                    54.5672015
                ],
                [
                    83.2570372,
                    54.5667919
                ],
                [
                    83.2569312,
                    54.5657882
                ],
                [
                    83.2572492,
                    54.5650713
                ],
                [
                    83.2561185,
                    54.5649689
                ],
                [
                    83.2558713,
                    54.5643749
                ],
                [
                    83.2545641,
                    54.5646616
                ],
                [
                    83.2535042,
                    54.5655015
                ],
                [
                    83.251455,
                    54.565481
                ],
                [
                    83.2503598,
                    54.5644568
                ],
                [
                    83.2473921,
                    54.5645183
                ],
                [
                    83.245343,
                    54.565481
                ],
                [
                    83.2446717,
                    54.5666485
                ]
            ],
            "longitude": 83.2528105,
            "latitude": 54.5678406
        },
        "3628": {
            "name": "Новотроицк",
            "population": 473,
            "type": "village",
            "poly": null,
            "longitude": 83.270737,
            "latitude": 55.599991
        },
        "3629": {
            "name": "Тальменка",
            "population": 1655,
            "type": "village",
            "poly": [
                [
                    83.2595728,
                    54.7107347
                ],
                [
                    83.2598314,
                    54.7131727
                ],
                [
                    83.2815508,
                    54.715449
                ],
                [
                    83.2822652,
                    54.7140396
                ],
                [
                    83.2831698,
                    54.712255
                ],
                [
                    83.28653,
                    54.7134197
                ],
                [
                    83.2835364,
                    54.7147432
                ],
                [
                    83.2835975,
                    54.7150255
                ],
                [
                    83.2864995,
                    54.7160313
                ],
                [
                    83.287813,
                    54.7153608
                ],
                [
                    83.2916315,
                    54.7171782
                ],
                [
                    83.2934644,
                    54.7162077
                ],
                [
                    83.2952971,
                    54.7170194
                ],
                [
                    83.2958776,
                    54.7165606
                ],
                [
                    83.2933727,
                    54.7154314
                ],
                [
                    83.2940448,
                    54.7149902
                ],
                [
                    83.2956027,
                    54.7149549
                ],
                [
                    83.2960915,
                    54.7145314
                ],
                [
                    83.2948085,
                    54.714055
                ],
                [
                    83.295511,
                    54.7131021
                ],
                [
                    83.2966719,
                    54.7129433
                ],
                [
                    83.2985963,
                    54.7132256
                ],
                [
                    83.300307,
                    54.7123609
                ],
                [
                    83.2987186,
                    54.7109139
                ],
                [
                    83.299635,
                    54.7096785
                ],
                [
                    83.2977716,
                    54.7088843
                ],
                [
                    83.2791375,
                    54.7058311
                ],
                [
                    83.2798401,
                    54.7031482
                ],
                [
                    83.2736389,
                    54.7017185
                ],
                [
                    83.2726002,
                    54.7023363
                ],
                [
                    83.2672884,
                    54.7013896
                ],
                [
                    83.2664942,
                    54.7027311
                ],
                [
                    83.267319,
                    54.7030488
                ],
                [
                    83.2668913,
                    54.7053787
                ],
                [
                    83.2623702,
                    54.7051139
                ],
                [
                    83.2612705,
                    54.708432
                ],
                [
                    83.2602624,
                    54.7082908
                ],
                [
                    83.2600733,
                    54.7092619
                ],
                [
                    83.2597292,
                    54.7092077
                ],
                [
                    83.2595728,
                    54.7107347
                ]
            ],
            "longitude": 83.2747819,
            "latitude": 54.70626
        },
        "3630": {
            "name": "Чернореченский",
            "population": 1854,
            "type": "village",
            "poly": [
                [
                    83.2616193,
                    54.6436402
                ],
                [
                    83.2711285,
                    54.6473877
                ],
                [
                    83.2697722,
                    54.6496076
                ],
                [
                    83.2682618,
                    54.655101
                ],
                [
                    83.2710218,
                    54.6555872
                ],
                [
                    83.278935,
                    54.6567476
                ],
                [
                    83.2884647,
                    54.6523908
                ],
                [
                    83.286405,
                    54.6513144
                ],
                [
                    83.2855358,
                    54.651317
                ],
                [
                    83.2847715,
                    54.6507388
                ],
                [
                    83.2830071,
                    54.6504749
                ],
                [
                    83.2848571,
                    54.6489355
                ],
                [
                    83.2846885,
                    54.6483649
                ],
                [
                    83.284557,
                    54.6478799
                ],
                [
                    83.2839018,
                    54.6450858
                ],
                [
                    83.2826363,
                    54.6424924
                ],
                [
                    83.2778506,
                    54.6392756
                ],
                [
                    83.2715105,
                    54.6432747
                ],
                [
                    83.2666691,
                    54.6405263
                ],
                [
                    83.2616193,
                    54.6436402
                ]
            ],
            "longitude": 83.2749944,
            "latitude": 54.6520319
        },
        "3631": {
            "name": "Ярки",
            "population": 704,
            "type": "village",
            "poly": [
                [
                    83.2525413,
                    54.1386394
                ],
                [
                    83.254143,
                    54.1389772
                ],
                [
                    83.2542712,
                    54.1404598
                ],
                [
                    83.258564,
                    54.1421675
                ],
                [
                    83.2590125,
                    54.143087
                ],
                [
                    83.2653877,
                    54.1432184
                ],
                [
                    83.2660604,
                    54.1441378
                ],
                [
                    83.2681107,
                    54.1472902
                ],
                [
                    83.2711221,
                    54.1496731
                ],
                [
                    83.2787786,
                    54.1529001
                ],
                [
                    83.2794514,
                    54.1550201
                ],
                [
                    83.282655,
                    54.1560518
                ],
                [
                    83.2870759,
                    54.1561832
                ],
                [
                    83.295245,
                    54.1568397
                ],
                [
                    83.2984166,
                    54.1551139
                ],
                [
                    83.297936,
                    54.1545323
                ],
                [
                    83.2977118,
                    54.1551326
                ],
                [
                    83.2957896,
                    54.1545135
                ],
                [
                    83.2937394,
                    54.1534067
                ],
                [
                    83.2922977,
                    54.1520559
                ],
                [
                    83.2905358,
                    54.1508364
                ],
                [
                    83.2873002,
                    54.1497294
                ],
                [
                    83.2837442,
                    54.1480408
                ],
                [
                    83.2801561,
                    54.1461832
                ],
                [
                    83.2768133,
                    54.1454236
                ],
                [
                    83.2721793,
                    54.1458079
                ],
                [
                    83.2724035,
                    54.1451887
                ],
                [
                    83.2796756,
                    54.1436875
                ],
                [
                    83.2806047,
                    54.1433309
                ],
                [
                    83.2816298,
                    54.1408163
                ],
                [
                    83.279131,
                    54.1376822
                ],
                [
                    83.2772409,
                    54.1357303
                ],
                [
                    83.2776574,
                    54.1350546
                ],
                [
                    83.2786505,
                    54.1350546
                ],
                [
                    83.2786184,
                    54.1313945
                ],
                [
                    83.2676941,
                    54.1346605
                ],
                [
                    83.2633053,
                    54.1360869
                ],
                [
                    83.2622482,
                    54.134942
                ],
                [
                    83.2616074,
                    54.1349983
                ],
                [
                    83.2557129,
                    54.1352611
                ],
                [
                    83.2525413,
                    54.1386394
                ]
            ],
            "longitude": 83.276329,
            "latitude": 54.14872
        },
        "3632": {
            "name": "Жеребцово",
            "population": 330,
            "type": "village",
            "poly": [
                [
                    83.2673845,
                    55.1188405
                ],
                [
                    83.2686125,
                    55.1199326
                ],
                [
                    83.2702859,
                    55.1205371
                ],
                [
                    83.2714023,
                    55.1206338
                ],
                [
                    83.2708385,
                    55.1219943
                ],
                [
                    83.2710028,
                    55.1229592
                ],
                [
                    83.270583,
                    55.1258399
                ],
                [
                    83.2725422,
                    55.1264
                ],
                [
                    83.2748256,
                    55.1261389
                ],
                [
                    83.2774403,
                    55.1258399
                ],
                [
                    83.2789796,
                    55.1217588
                ],
                [
                    83.2798193,
                    55.1174372
                ],
                [
                    83.2816385,
                    55.1148761
                ],
                [
                    83.2858369,
                    55.1154363
                ],
                [
                    83.2936737,
                    55.1117544
                ],
                [
                    83.2960529,
                    55.1123147
                ],
                [
                    83.3009509,
                    55.1099934
                ],
                [
                    83.2967526,
                    55.1075919
                ],
                [
                    83.2938138,
                    55.1058307
                ],
                [
                    83.2889157,
                    55.1082323
                ],
                [
                    83.2854171,
                    55.1081522
                ],
                [
                    83.2816385,
                    55.1104737
                ],
                [
                    83.2775802,
                    55.1105537
                ],
                [
                    83.2778601,
                    55.1124748
                ],
                [
                    83.2759009,
                    55.1141557
                ],
                [
                    83.2723632,
                    55.1153115
                ],
                [
                    83.2696227,
                    55.1161592
                ],
                [
                    83.2683203,
                    55.1170543
                ],
                [
                    83.2673845,
                    55.1188405
                ]
            ],
            "longitude": 83.2770201,
            "latitude": 55.1145037
        },
        "3633": {
            "name": "Железнодорожный",
            "population": 1338,
            "type": "village",
            "poly": [
                [
                    83.2705811,
                    54.9807744
                ],
                [
                    83.2724511,
                    54.9821147
                ],
                [
                    83.2747698,
                    54.9863358
                ],
                [
                    83.2771087,
                    54.9896131
                ],
                [
                    83.2780874,
                    54.9893579
                ],
                [
                    83.2802853,
                    54.9897906
                ],
                [
                    83.2812334,
                    54.9894197
                ],
                [
                    83.2848103,
                    54.9908908
                ],
                [
                    83.2845087,
                    54.9910145
                ],
                [
                    83.2858877,
                    54.9916449
                ],
                [
                    83.2881934,
                    54.9900996
                ],
                [
                    83.2908653,
                    54.9909032
                ],
                [
                    83.2923825,
                    54.9895723
                ],
                [
                    83.2896586,
                    54.9878496
                ],
                [
                    83.2926538,
                    54.9856489
                ],
                [
                    83.2908653,
                    54.9844373
                ],
                [
                    83.2891943,
                    54.9848132
                ],
                [
                    83.2859093,
                    54.9832997
                ],
                [
                    83.2829572,
                    54.9828821
                ],
                [
                    83.2779526,
                    54.9814494
                ],
                [
                    83.2739056,
                    54.9793447
                ],
                [
                    83.2705811,
                    54.9807744
                ]
            ],
            "longitude": 83.2837292,
            "latitude": 54.9865994
        },
        "3634": {
            "name": "Шибково",
            "population": 905,
            "type": "village",
            "poly": [
                [
                    83.278252,
                    54.488962
                ],
                [
                    83.2784855,
                    54.4891491
                ],
                [
                    83.2787271,
                    54.4895327
                ],
                [
                    83.278864,
                    54.4896917
                ],
                [
                    83.278788,
                    54.4897434
                ],
                [
                    83.2790497,
                    54.4899305
                ],
                [
                    83.2800965,
                    54.4908543
                ],
                [
                    83.2806604,
                    54.4914098
                ],
                [
                    83.2807107,
                    54.4914273
                ],
                [
                    83.2814757,
                    54.4922517
                ],
                [
                    83.2824924,
                    54.4930235
                ],
                [
                    83.2828649,
                    54.4932632
                ],
                [
                    83.2832977,
                    54.4931346
                ],
                [
                    83.2834084,
                    54.4931638
                ],
                [
                    83.2836298,
                    54.4931112
                ],
                [
                    83.284093,
                    54.4936081
                ],
                [
                    83.2837004,
                    54.4937484
                ],
                [
                    83.2847874,
                    54.4949703
                ],
                [
                    83.2850895,
                    54.4954322
                ],
                [
                    83.2863981,
                    54.4952509
                ],
                [
                    83.2887335,
                    54.4979167
                ],
                [
                    83.288955,
                    54.4979226
                ],
                [
                    83.2893275,
                    54.4978992
                ],
                [
                    83.2896194,
                    54.497905
                ],
                [
                    83.2899113,
                    54.4979693
                ],
                [
                    83.2901126,
                    54.497981
                ],
                [
                    83.2908676,
                    54.4979752
                ],
                [
                    83.2912803,
                    54.4980921
                ],
                [
                    83.291834,
                    54.4984429
                ],
                [
                    83.2919548,
                    54.4985656
                ],
                [
                    83.2919548,
                    54.4986884
                ],
                [
                    83.2918239,
                    54.4987994
                ],
                [
                    83.2920051,
                    54.4990391
                ],
                [
                    83.2921561,
                    54.4991443
                ],
                [
                    83.2923272,
                    54.4992028
                ],
                [
                    83.2927701,
                    54.4992905
                ],
                [
                    83.2929714,
                    54.4994015
                ],
                [
                    83.2940687,
                    54.5002024
                ],
                [
                    83.2942096,
                    54.5003485
                ],
                [
                    83.2942096,
                    54.5004362
                ],
                [
                    83.29427,
                    54.5005356
                ],
                [
                    83.2943707,
                    54.5006583
                ],
                [
                    83.2947532,
                    54.5007577
                ],
                [
                    83.2949143,
                    54.5007519
                ],
                [
                    83.2951055,
                    54.5004128
                ],
                [
                    83.2953975,
                    54.500407
                ],
                [
                    83.2960618,
                    54.5002959
                ],
                [
                    83.2966859,
                    54.5000504
                ],
                [
                    83.2971388,
                    54.5000387
                ],
                [
                    83.2977127,
                    54.5000738
                ],
                [
                    83.2981758,
                    54.5001439
                ],
                [
                    83.2991623,
                    54.5004713
                ],
                [
                    83.2993938,
                    54.5005999
                ],
                [
                    83.2995347,
                    54.5006466
                ],
                [
                    83.2996354,
                    54.5006408
                ],
                [
                    83.3001186,
                    54.5003193
                ],
                [
                    83.3006118,
                    54.5000796
                ],
                [
                    83.3011252,
                    54.5003719
                ],
                [
                    83.3013567,
                    54.5002024
                ],
                [
                    83.3008735,
                    54.4999101
                ],
                [
                    83.3017191,
                    54.4995243
                ],
                [
                    83.3020513,
                    54.4996938
                ],
                [
                    83.3022023,
                    54.4996061
                ],
                [
                    83.3019607,
                    54.4994132
                ],
                [
                    83.3023532,
                    54.499308
                ],
                [
                    83.3027156,
                    54.4995126
                ],
                [
                    83.3031989,
                    54.4992554
                ],
                [
                    83.3036317,
                    54.4994658
                ],
                [
                    83.3037525,
                    54.4993197
                ],
                [
                    83.3028767,
                    54.4989105
                ],
                [
                    83.3028868,
                    54.4988754
                ],
                [
                    83.3034102,
                    54.4986124
                ],
                [
                    83.3036518,
                    54.4987878
                ],
                [
                    83.303823,
                    54.4988404
                ],
                [
                    83.3040444,
                    54.4988637
                ],
                [
                    83.3046081,
                    54.4985948
                ],
                [
                    83.3046585,
                    54.4984662
                ],
                [
                    83.3046382,
                    54.4983435
                ],
                [
                    83.3047088,
                    54.4982441
                ],
                [
                    83.3050006,
                    54.4981213
                ],
                [
                    83.3057255,
                    54.4978875
                ],
                [
                    83.3059268,
                    54.4978933
                ],
                [
                    83.3060879,
                    54.4978466
                ],
                [
                    83.3061688,
                    54.4977527
                ],
                [
                    83.3061048,
                    54.4967619
                ],
                [
                    83.3060451,
                    54.4963789
                ],
                [
                    83.306442,
                    54.4964178
                ],
                [
                    83.3070811,
                    54.4965315
                ],
                [
                    83.3085551,
                    54.4966991
                ],
                [
                    83.3092251,
                    54.4967201
                ],
                [
                    83.3092327,
                    54.4965698
                ],
                [
                    83.3092422,
                    54.4963813
                ],
                [
                    83.3093523,
                    54.4941938
                ],
                [
                    83.3106205,
                    54.4946966
                ],
                [
                    83.311134,
                    54.4944102
                ],
                [
                    83.3101979,
                    54.4937963
                ],
                [
                    83.3101777,
                    54.4936794
                ],
                [
                    83.3100771,
                    54.493615
                ],
                [
                    83.3099764,
                    54.4936092
                ],
                [
                    83.3098355,
                    54.4936443
                ],
                [
                    83.3096845,
                    54.4936092
                ],
                [
                    83.3097247,
                    54.4934396
                ],
                [
                    83.309614,
                    54.4933929
                ],
                [
                    83.3094328,
                    54.4934046
                ],
                [
                    83.3100423,
                    54.492812
                ],
                [
                    83.3088911,
                    54.4920212
                ],
                [
                    83.3082493,
                    54.4914365
                ],
                [
                    83.3074189,
                    54.4910053
                ],
                [
                    83.3073183,
                    54.4910565
                ],
                [
                    83.30265,
                    54.4891489
                ],
                [
                    83.3025619,
                    54.4892366
                ],
                [
                    83.3024235,
                    54.4892512
                ],
                [
                    83.3022222,
                    54.4891854
                ],
                [
                    83.3016811,
                    54.4891928
                ],
                [
                    83.3013917,
                    54.4894559
                ],
                [
                    83.3012282,
                    54.4894705
                ],
                [
                    83.3005235,
                    54.4892805
                ],
                [
                    83.3002467,
                    54.4892366
                ],
                [
                    83.299995,
                    54.489317
                ],
                [
                    83.2998439,
                    54.489412
                ],
                [
                    83.2991771,
                    54.4891781
                ],
                [
                    83.2990513,
                    54.4892585
                ],
                [
                    83.2988626,
                    54.4891416
                ],
                [
                    83.2986109,
                    54.4890758
                ],
                [
                    83.2985263,
                    54.4891849
                ],
                [
                    83.2986086,
                    54.489366
                ],
                [
                    83.2986021,
                    54.4894558
                ],
                [
                    83.2984088,
                    54.4894147
                ],
                [
                    83.2981769,
                    54.4892799
                ],
                [
                    83.2980481,
                    54.4891565
                ],
                [
                    83.2977581,
                    54.4890891
                ],
                [
                    83.2976164,
                    54.4891714
                ],
                [
                    83.2975455,
                    54.4893136
                ],
                [
                    83.2974296,
                    54.4894147
                ],
                [
                    83.2972041,
                    54.4894072
                ],
                [
                    83.2970559,
                    54.4892425
                ],
                [
                    83.29694,
                    54.4890479
                ],
                [
                    83.2969335,
                    54.4888346
                ],
                [
                    83.2969722,
                    54.4887149
                ],
                [
                    83.296882,
                    54.488524
                ],
                [
                    83.29665,
                    54.4884492
                ],
                [
                    83.2960896,
                    54.4884492
                ],
                [
                    83.2958963,
                    54.4885353
                ],
                [
                    83.2956837,
                    54.4885315
                ],
                [
                    83.2954518,
                    54.4884267
                ],
                [
                    83.2953744,
                    54.4883257
                ],
                [
                    83.2953551,
                    54.4881348
                ],
                [
                    83.2947624,
                    54.4877644
                ],
                [
                    83.2944145,
                    54.487682
                ],
                [
                    83.2942728,
                    54.4876783
                ],
                [
                    83.2941375,
                    54.4876147
                ],
                [
                    83.2940731,
                    54.4876596
                ],
                [
                    83.2938734,
                    54.487581
                ],
                [
                    83.293912,
                    54.4874238
                ],
                [
                    83.2937509,
                    54.4873003
                ],
                [
                    83.2937252,
                    54.4871282
                ],
                [
                    83.293693,
                    54.4869186
                ],
                [
                    83.2935641,
                    54.4867726
                ],
                [
                    83.293184,
                    54.4867203
                ],
                [
                    83.2929005,
                    54.4866117
                ],
                [
                    83.292849,
                    54.4864695
                ],
                [
                    83.2926622,
                    54.4862113
                ],
                [
                    83.2924174,
                    54.4860055
                ],
                [
                    83.290504,
                    54.4853356
                ],
                [
                    83.2905296,
                    54.4841192
                ],
                [
                    83.2906328,
                    54.4836327
                ],
                [
                    83.2848604,
                    54.4831012
                ],
                [
                    83.2846478,
                    54.4835578
                ],
                [
                    83.2845382,
                    54.4836439
                ],
                [
                    83.2844996,
                    54.4837375
                ],
                [
                    83.2846929,
                    54.4841267
                ],
                [
                    83.2847895,
                    54.4842352
                ],
                [
                    83.2849184,
                    54.4842876
                ],
                [
                    83.2850601,
                    54.4843026
                ],
                [
                    83.2852791,
                    54.4842839
                ],
                [
                    83.2854531,
                    54.4843251
                ],
                [
                    83.2855626,
                    54.4844448
                ],
                [
                    83.2859427,
                    54.4850062
                ],
                [
                    83.2864001,
                    54.4854853
                ],
                [
                    83.286864,
                    54.4857547
                ],
                [
                    83.2873794,
                    54.4859306
                ],
                [
                    83.287811,
                    54.4861851
                ],
                [
                    83.2884316,
                    54.486699
                ],
                [
                    83.2889117,
                    54.4869366
                ],
                [
                    83.2898446,
                    54.4876577
                ],
                [
                    83.290368,
                    54.4878565
                ],
                [
                    83.2907405,
                    54.4879091
                ],
                [
                    83.2912237,
                    54.4879208
                ],
                [
                    83.2914652,
                    54.4879501
                ],
                [
                    83.291737,
                    54.4880787
                ],
                [
                    83.2919082,
                    54.48826
                ],
                [
                    83.2919988,
                    54.4884939
                ],
                [
                    83.2919384,
                    54.4889266
                ],
                [
                    83.292029,
                    54.4894762
                ],
                [
                    83.2922102,
                    54.4897101
                ],
                [
                    83.2927234,
                    54.4900375
                ],
                [
                    83.2927537,
                    54.4903766
                ],
                [
                    83.2930657,
                    54.4907859
                ],
                [
                    83.2934886,
                    54.4910373
                ],
                [
                    83.2942433,
                    54.491192
                ],
                [
                    83.2944804,
                    54.4912998
                ],
                [
                    83.2945886,
                    54.4914225
                ],
                [
                    83.2946402,
                    54.4915662
                ],
                [
                    83.2947536,
                    54.4916979
                ],
                [
                    83.2950113,
                    54.4918446
                ],
                [
                    83.2955936,
                    54.4920033
                ],
                [
                    83.2958977,
                    54.492129
                ],
                [
                    83.2960317,
                    54.4922128
                ],
                [
                    83.2962224,
                    54.4922667
                ],
                [
                    83.2964801,
                    54.4922937
                ],
                [
                    83.2968976,
                    54.4922966
                ],
                [
                    83.297078,
                    54.4923445
                ],
                [
                    83.297212,
                    54.4924673
                ],
                [
                    83.2974078,
                    54.4927606
                ],
                [
                    83.2977119,
                    54.4929462
                ],
                [
                    83.2977119,
                    54.4930091
                ],
                [
                    83.2975882,
                    54.493069
                ],
                [
                    83.2975934,
                    54.4931228
                ],
                [
                    83.2976862,
                    54.4931767
                ],
                [
                    83.2978511,
                    54.4932336
                ],
                [
                    83.2982169,
                    54.4932725
                ],
                [
                    83.2983188,
                    54.4933479
                ],
                [
                    83.2982713,
                    54.4934337
                ],
                [
                    83.298113,
                    54.4935165
                ],
                [
                    83.2980655,
                    54.4936146
                ],
                [
                    83.2981367,
                    54.4937112
                ],
                [
                    83.2983926,
                    54.4937985
                ],
                [
                    83.2986487,
                    54.4939303
                ],
                [
                    83.2987701,
                    54.4941587
                ],
                [
                    83.2987595,
                    54.4943472
                ],
                [
                    83.2986038,
                    54.4945571
                ],
                [
                    83.2979151,
                    54.4952606
                ],
                [
                    83.2979256,
                    54.4954016
                ],
                [
                    83.2980523,
                    54.4956637
                ],
                [
                    83.2979362,
                    54.4958552
                ],
                [
                    83.297575,
                    54.496309
                ],
                [
                    83.2974348,
                    54.4966802
                ],
                [
                    83.2971874,
                    54.4968909
                ],
                [
                    83.2962151,
                    54.4974867
                ],
                [
                    83.2958672,
                    54.4977897
                ],
                [
                    83.295603,
                    54.4979132
                ],
                [
                    83.2953859,
                    54.4978668
                ],
                [
                    83.291583,
                    54.4951894
                ],
                [
                    83.2917167,
                    54.4948227
                ],
                [
                    83.2916764,
                    54.4945936
                ],
                [
                    83.2911208,
                    54.4937423
                ],
                [
                    83.2908147,
                    54.4934383
                ],
                [
                    83.2906698,
                    54.4933682
                ],
                [
                    83.2903799,
                    54.4935178
                ],
                [
                    83.2902268,
                    54.4935178
                ],
                [
                    83.2901544,
                    54.493429
                ],
                [
                    83.2902108,
                    54.4933074
                ],
                [
                    83.2904524,
                    54.4930267
                ],
                [
                    83.2901222,
                    54.4923906
                ],
                [
                    83.2898806,
                    54.4921334
                ],
                [
                    83.2897195,
                    54.4921147
                ],
                [
                    83.2895987,
                    54.4921708
                ],
                [
                    83.289494,
                    54.4921474
                ],
                [
                    83.2886243,
                    54.4911839
                ],
                [
                    83.288576,
                    54.4909079
                ],
                [
                    83.2875694,
                    54.4898133
                ],
                [
                    83.2872311,
                    54.4893315
                ],
                [
                    83.2865225,
                    54.4885691
                ],
                [
                    83.2862889,
                    54.4883726
                ],
                [
                    83.2860715,
                    54.488265
                ],
                [
                    83.2859104,
                    54.488265
                ],
                [
                    83.2856769,
                    54.4883024
                ],
                [
                    83.2854756,
                    54.4883071
                ],
                [
                    83.2852098,
                    54.4882463
                ],
                [
                    83.2848877,
                    54.4880031
                ],
                [
                    83.2845495,
                    54.4875119
                ],
                [
                    83.2845897,
                    54.4869318
                ],
                [
                    83.2841387,
                    54.4863331
                ],
                [
                    83.2837763,
                    54.4861085
                ],
                [
                    83.2835911,
                    54.4861927
                ],
                [
                    83.2831965,
                    54.486043
                ],
                [
                    83.2825362,
                    54.4864173
                ],
                [
                    83.2820772,
                    54.4862161
                ],
                [
                    83.2821658,
                    54.4861272
                ],
                [
                    83.2819081,
                    54.4859962
                ],
                [
                    83.2816262,
                    54.4861693
                ],
                [
                    83.2807404,
                    54.4858091
                ],
                [
                    83.2802813,
                    54.4860758
                ],
                [
                    83.2796371,
                    54.4857483
                ],
                [
                    83.2783164,
                    54.4866231
                ],
                [
                    83.2796769,
                    54.4872773
                ],
                [
                    83.2792183,
                    54.487713
                ],
                [
                    83.279009,
                    54.4878253
                ],
                [
                    83.2785418,
                    54.4883258
                ],
                [
                    83.278252,
                    54.488962
                ]
            ],
            "longitude": 83.288345,
            "latitude": 54.49353
        },
        "3635": {
            "name": "Дубровино",
            "population": 1062,
            "type": "village",
            "poly": [
                [
                    83.2719924,
                    55.4672586
                ],
                [
                    83.2792775,
                    55.473397
                ],
                [
                    83.2851535,
                    55.4777183
                ],
                [
                    83.293492,
                    55.4802066
                ],
                [
                    83.2970209,
                    55.4805914
                ],
                [
                    83.297403,
                    55.4778856
                ],
                [
                    83.3004653,
                    55.4777811
                ],
                [
                    83.3010189,
                    55.4765683
                ],
                [
                    83.3037492,
                    55.4766728
                ],
                [
                    83.3040302,
                    55.4738571
                ],
                [
                    83.3019044,
                    55.473578
                ],
                [
                    83.3025685,
                    55.4710057
                ],
                [
                    83.3017937,
                    55.4678058
                ],
                [
                    83.3002989,
                    55.4646793
                ],
                [
                    83.2959859,
                    55.4624774
                ],
                [
                    83.2902025,
                    55.4649922
                ],
                [
                    83.2735682,
                    55.4666763
                ],
                [
                    83.2719924,
                    55.4672586
                ]
            ],
            "longitude": 83.292892,
            "latitude": 55.471161
        },
        "3636": {
            "name": "Быково",
            "population": 325,
            "type": "village",
            "poly": [
                [
                    83.2786962,
                    54.9362034
                ],
                [
                    83.2789764,
                    54.9375901
                ],
                [
                    83.2814764,
                    54.9378377
                ],
                [
                    83.2832017,
                    54.9384461
                ],
                [
                    83.2846013,
                    54.9389396
                ],
                [
                    83.2885026,
                    54.9395631
                ],
                [
                    83.2917996,
                    54.9377387
                ],
                [
                    83.2969073,
                    54.9366368
                ],
                [
                    83.3003692,
                    54.9361462
                ],
                [
                    83.3008297,
                    54.9350644
                ],
                [
                    83.3001185,
                    54.93395
                ],
                [
                    83.3003124,
                    54.9333557
                ],
                [
                    83.3016271,
                    54.9331823
                ],
                [
                    83.3021653,
                    54.9308124
                ],
                [
                    83.3009374,
                    54.9298886
                ],
                [
                    83.3016702,
                    54.9296533
                ],
                [
                    83.3017779,
                    54.9286998
                ],
                [
                    83.3026615,
                    54.9281549
                ],
                [
                    83.3035667,
                    54.9282911
                ],
                [
                    83.3040192,
                    54.9260001
                ],
                [
                    83.3020093,
                    54.9257802
                ],
                [
                    83.2989331,
                    54.9279444
                ],
                [
                    83.2970581,
                    54.9282168
                ],
                [
                    83.2914332,
                    54.9320556
                ],
                [
                    83.2906789,
                    54.9319317
                ],
                [
                    83.2909591,
                    54.931325
                ],
                [
                    83.2893642,
                    54.9312878
                ],
                [
                    83.2887608,
                    54.9321918
                ],
                [
                    83.288693,
                    54.932184
                ],
                [
                    83.2842565,
                    54.9316717
                ],
                [
                    83.2837824,
                    54.9319193
                ],
                [
                    83.284041,
                    54.9341853
                ],
                [
                    83.2813321,
                    54.9344409
                ],
                [
                    83.2801402,
                    54.9339376
                ],
                [
                    83.2788686,
                    54.9352377
                ],
                [
                    83.2801402,
                    54.9363396
                ],
                [
                    83.2786962,
                    54.9362034
                ]
            ],
            "longitude": 83.2943001,
            "latitude": 54.9336508
        },
        "3637": {
            "name": "Дорогино",
            "population": 3876,
            "type": "village",
            "poly": [
                [
                    83.3067375,
                    54.3568659
                ],
                [
                    83.3132063,
                    54.3629087
                ],
                [
                    83.3204966,
                    54.3749918
                ],
                [
                    83.3341529,
                    54.3759487
                ],
                [
                    83.3374386,
                    54.3717022
                ],
                [
                    83.3435764,
                    54.3681488
                ],
                [
                    83.341157,
                    54.3615037
                ],
                [
                    83.3307645,
                    54.362131
                ],
                [
                    83.3313806,
                    54.3528567
                ],
                [
                    83.3220368,
                    54.3504032
                ],
                [
                    83.3170055,
                    54.3516599
                ],
                [
                    83.3067375,
                    54.3568659
                ]
            ],
            "longitude": 83.317009,
            "latitude": 54.362015
        },
        "3638": {
            "name": "Сокур",
            "population": 5770,
            "type": "village",
            "poly": [
                [
                    83.2991933,
                    55.2086
                ],
                [
                    83.3009098,
                    55.2143786
                ],
                [
                    83.3072612,
                    55.2164351
                ],
                [
                    83.3149861,
                    55.2189812
                ],
                [
                    83.3201359,
                    55.2213313
                ],
                [
                    83.3266591,
                    55.2222125
                ],
                [
                    83.3314656,
                    55.2224083
                ],
                [
                    83.3378171,
                    55.2197646
                ],
                [
                    83.3451985,
                    55.2193729
                ],
                [
                    83.3465718,
                    55.2170227
                ],
                [
                    83.3465718,
                    55.2134971
                ],
                [
                    83.3383321,
                    55.2087959
                ],
                [
                    83.3348988,
                    55.2101672
                ],
                [
                    83.327174,
                    55.2075226
                ],
                [
                    83.327689,
                    55.2051717
                ],
                [
                    83.3129262,
                    55.1995878
                ],
                [
                    83.3093212,
                    55.2024288
                ],
                [
                    83.3048581,
                    55.1998817
                ],
                [
                    83.3022832,
                    55.2012532
                ],
                [
                    83.3027981,
                    55.2041921
                ],
                [
                    83.2991933,
                    55.2086
                ]
            ],
            "longitude": 83.3208502,
            "latitude": 55.2138096
        },
        "3639": {
            "name": "Евсино",
            "population": 602,
            "type": "village",
            "poly": [
                [
                    83.304976,
                    54.4131457
                ],
                [
                    83.305518,
                    54.4134713
                ],
                [
                    83.3055354,
                    54.4139087
                ],
                [
                    83.3058676,
                    54.4141732
                ],
                [
                    83.3066543,
                    54.4142648
                ],
                [
                    83.3076157,
                    54.4146514
                ],
                [
                    83.3086297,
                    54.416045
                ],
                [
                    83.3096437,
                    54.4159331
                ],
                [
                    83.3114443,
                    54.4148548
                ],
                [
                    83.3124408,
                    54.4155669
                ],
                [
                    83.3122485,
                    54.4159331
                ],
                [
                    83.3164791,
                    54.4178456
                ],
                [
                    83.3187867,
                    54.4200529
                ],
                [
                    83.3190839,
                    54.4214057
                ],
                [
                    83.3181223,
                    54.4219854
                ],
                [
                    83.3178487,
                    54.4219504
                ],
                [
                    83.3146905,
                    54.4236141
                ],
                [
                    83.3146698,
                    54.4244019
                ],
                [
                    83.3152911,
                    54.4248024
                ],
                [
                    83.3193876,
                    54.426414
                ],
                [
                    83.3193037,
                    54.4266972
                ],
                [
                    83.3193876,
                    54.4274298
                ],
                [
                    83.3211841,
                    54.4286897
                ],
                [
                    83.3246092,
                    54.4285823
                ],
                [
                    83.3273878,
                    54.4261961
                ],
                [
                    83.3289087,
                    54.4244162
                ],
                [
                    83.3288912,
                    54.4237653
                ],
                [
                    83.3300974,
                    54.4243044
                ],
                [
                    83.3283668,
                    54.4208971
                ],
                [
                    83.3282288,
                    54.4194736
                ],
                [
                    83.3278673,
                    54.4160022
                ],
                [
                    83.3276941,
                    54.413955
                ],
                [
                    83.3274402,
                    54.4113348
                ],
                [
                    83.3248529,
                    54.4097579
                ],
                [
                    83.3241012,
                    54.4098291
                ],
                [
                    83.3235942,
                    54.4096765
                ],
                [
                    83.3231047,
                    54.4099512
                ],
                [
                    83.3224053,
                    54.4100428
                ],
                [
                    83.3220908,
                    54.4096968
                ],
                [
                    83.3227026,
                    54.409239
                ],
                [
                    83.315098,
                    54.4098596
                ],
                [
                    83.3151505,
                    54.4096256
                ],
                [
                    83.3148183,
                    54.4093611
                ],
                [
                    83.3144337,
                    54.4093611
                ],
                [
                    83.3142064,
                    54.4091678
                ],
                [
                    83.3139442,
                    54.4094832
                ],
                [
                    83.3132275,
                    54.4095035
                ],
                [
                    83.3118814,
                    54.4093204
                ],
                [
                    83.3111471,
                    54.4094425
                ],
                [
                    83.3090843,
                    54.4101954
                ],
                [
                    83.3081577,
                    54.4096053
                ],
                [
                    83.305448,
                    54.4098494
                ],
                [
                    83.3054655,
                    54.4116095
                ],
                [
                    83.3050634,
                    54.4120267
                ],
                [
                    83.304976,
                    54.4131457
                ]
            ],
            "longitude": 83.322159,
            "latitude": 54.417175
        },
        "3640": {
            "name": "Пятилетка",
            "population": 665,
            "type": "village",
            "poly": [
                [
                    83.3202301,
                    54.2394525
                ],
                [
                    83.3251045,
                    54.2412907
                ],
                [
                    83.3259715,
                    54.2421072
                ],
                [
                    83.3267602,
                    54.2447801
                ],
                [
                    83.3284322,
                    54.2453699
                ],
                [
                    83.3335427,
                    54.2453331
                ],
                [
                    83.3346153,
                    54.2450197
                ],
                [
                    83.3389371,
                    54.2392682
                ],
                [
                    83.3323439,
                    54.2366686
                ],
                [
                    83.3316814,
                    54.2350646
                ],
                [
                    83.3295994,
                    54.2348618
                ],
                [
                    83.3273911,
                    54.2356546
                ],
                [
                    83.3235425,
                    54.2350646
                ],
                [
                    83.3206402,
                    54.237443
                ],
                [
                    83.3202301,
                    54.2394525
                ]
            ],
            "longitude": 83.3288565,
            "latitude": 54.2412141
        },
        "3641": {
            "name": "Шелковичиха",
            "population": 347,
            "type": "village",
            "poly": [
                [
                    83.3313612,
                    54.9823914
                ],
                [
                    83.3437219,
                    54.987018
                ],
                [
                    83.3486461,
                    54.9890279
                ],
                [
                    83.3681203,
                    54.9951487
                ],
                [
                    83.3695198,
                    54.9917292
                ],
                [
                    83.3748064,
                    54.9897535
                ],
                [
                    83.3688187,
                    54.9871655
                ],
                [
                    83.3622539,
                    54.985066
                ],
                [
                    83.3507386,
                    54.9846338
                ],
                [
                    83.3374466,
                    54.9801676
                ],
                [
                    83.3313612,
                    54.9823914
                ]
            ],
            "longitude": 83.3377663,
            "latitude": 54.9840713
        },
        "3642": {
            "name": "Емельяновский",
            "population": 446,
            "type": "village",
            "poly": [
                [
                    83.3340562,
                    55.2537441
                ],
                [
                    83.3354437,
                    55.2559007
                ],
                [
                    83.3356959,
                    55.2575539
                ],
                [
                    83.3375879,
                    55.259279
                ],
                [
                    83.3392275,
                    55.2593509
                ],
                [
                    83.3397321,
                    55.2599978
                ],
                [
                    83.3428859,
                    55.2600396
                ],
                [
                    83.3451556,
                    55.2600696
                ],
                [
                    83.3446778,
                    55.2574518
                ],
                [
                    83.347879,
                    55.2564034
                ],
                [
                    83.3557505,
                    55.2564757
                ],
                [
                    83.3553721,
                    55.25511
                ],
                [
                    83.3546153,
                    55.2551818
                ],
                [
                    83.3546992,
                    55.253508
                ],
                [
                    83.3547415,
                    55.2526658
                ],
                [
                    83.3561289,
                    55.2518031
                ],
                [
                    83.3576424,
                    55.2515875
                ],
                [
                    83.3610479,
                    55.2515156
                ],
                [
                    83.3578947,
                    55.2491431
                ],
                [
                    83.3583991,
                    55.2466267
                ],
                [
                    83.3568857,
                    55.2463391
                ],
                [
                    83.3567595,
                    55.2457639
                ],
                [
                    83.3549937,
                    55.2460515
                ],
                [
                    83.3539847,
                    55.2450449
                ],
                [
                    83.3509576,
                    55.2453325
                ],
                [
                    83.3502008,
                    55.2443259
                ],
                [
                    83.3475521,
                    55.2449011
                ],
                [
                    83.3443987,
                    55.2448292
                ],
                [
                    83.3440205,
                    55.2441821
                ],
                [
                    83.3431376,
                    55.2447573
                ],
                [
                    83.342633,
                    55.2443259
                ],
                [
                    83.3420024,
                    55.2451168
                ],
                [
                    83.3346869,
                    55.2451168
                ],
                [
                    83.3355698,
                    55.2533128
                ],
                [
                    83.3340562,
                    55.2537441
                ]
            ],
            "longitude": 83.3402358,
            "latitude": 55.2517228
        },
        "3643": {
            "name": "Березовка",
            "population": 1465,
            "type": "village",
            "poly": [
                [
                    83.3190284,
                    54.9920939
                ],
                [
                    83.3190842,
                    54.9936505
                ],
                [
                    83.3278604,
                    54.9959948
                ],
                [
                    83.3302358,
                    54.9971056
                ],
                [
                    83.3288947,
                    54.9993629
                ],
                [
                    83.3315983,
                    55.0000405
                ],
                [
                    83.3403894,
                    54.9992052
                ],
                [
                    83.3468201,
                    54.9986667
                ],
                [
                    83.3505293,
                    54.9988874
                ],
                [
                    83.3523027,
                    54.9988972
                ],
                [
                    83.3544453,
                    54.9985182
                ],
                [
                    83.3558116,
                    54.9982735
                ],
                [
                    83.3543461,
                    54.9979987
                ],
                [
                    83.3528682,
                    54.9974566
                ],
                [
                    83.350408,
                    54.9960848
                ],
                [
                    83.3533992,
                    54.99486
                ],
                [
                    83.3531455,
                    54.9945788
                ],
                [
                    83.3569821,
                    54.9929828
                ],
                [
                    83.3443539,
                    54.9892046
                ],
                [
                    83.342913,
                    54.9901224
                ],
                [
                    83.3423111,
                    54.9897642
                ],
                [
                    83.3402275,
                    54.9900122
                ],
                [
                    83.3393124,
                    54.9908229
                ],
                [
                    83.336628,
                    54.989606
                ],
                [
                    83.3344404,
                    54.9898873
                ],
                [
                    83.3338648,
                    54.9903192
                ],
                [
                    83.3288475,
                    54.9901101
                ],
                [
                    83.3271993,
                    54.9893498
                ],
                [
                    83.3234441,
                    54.9911271
                ],
                [
                    83.3258691,
                    54.9923419
                ],
                [
                    83.3251149,
                    54.9931864
                ],
                [
                    83.3212795,
                    54.9922448
                ],
                [
                    83.3190284,
                    54.9920939
                ]
            ],
            "longitude": 83.3433466,
            "latitude": 54.9941162
        },
        "3644": {
            "name": "Керамкомбинат",
            "population": 1854,
            "type": "village",
            "poly": [
                [
                    83.3341908,
                    54.4278023
                ],
                [
                    83.3402584,
                    54.4339234
                ],
                [
                    83.3444599,
                    54.4382054
                ],
                [
                    83.3468536,
                    54.4369836
                ],
                [
                    83.3477769,
                    54.4375802
                ],
                [
                    83.3502245,
                    54.4369921
                ],
                [
                    83.3468243,
                    54.432406
                ],
                [
                    83.3459889,
                    54.43088
                ],
                [
                    83.3457251,
                    54.4302576
                ],
                [
                    83.3453148,
                    54.4297888
                ],
                [
                    83.3451828,
                    54.4290215
                ],
                [
                    83.3442888,
                    54.4288509
                ],
                [
                    83.3434681,
                    54.4284417
                ],
                [
                    83.3381187,
                    54.4266172
                ],
                [
                    83.3378695,
                    54.42689
                ],
                [
                    83.3363306,
                    54.4266598
                ],
                [
                    83.3341908,
                    54.4278023
                ]
            ],
            "longitude": 83.343796,
            "latitude": 54.433292
        },
        "3645": {
            "name": "Евсино",
            "population": 5369,
            "type": "village",
            "poly": [
                [
                    83.3317756,
                    54.5127967
                ],
                [
                    83.331891,
                    54.5139217
                ],
                [
                    83.3319469,
                    54.5144671
                ],
                [
                    83.3364342,
                    54.5158392
                ],
                [
                    83.3371535,
                    54.5168334
                ],
                [
                    83.3399283,
                    54.5189609
                ],
                [
                    83.3423262,
                    54.5197761
                ],
                [
                    83.3438677,
                    54.5200743
                ],
                [
                    83.3443472,
                    54.5205714
                ],
                [
                    83.3471719,
                    54.521982
                ],
                [
                    83.3472932,
                    54.5220426
                ],
                [
                    83.3533564,
                    54.5244283
                ],
                [
                    83.3541724,
                    54.5245033
                ],
                [
                    83.3548293,
                    54.5245874
                ],
                [
                    83.3558227,
                    54.5234939
                ],
                [
                    83.354521,
                    54.5205714
                ],
                [
                    83.3593168,
                    54.5204322
                ],
                [
                    83.3602073,
                    54.520134
                ],
                [
                    83.3593899,
                    54.5174772
                ],
                [
                    83.3596926,
                    54.5163395
                ],
                [
                    83.3599334,
                    54.5155011
                ],
                [
                    83.3607212,
                    54.5154614
                ],
                [
                    83.3608329,
                    54.5155079
                ],
                [
                    83.3612343,
                    54.5157142
                ],
                [
                    83.3620572,
                    54.5160181
                ],
                [
                    83.3649346,
                    54.5149642
                ],
                [
                    83.3619202,
                    54.5123195
                ],
                [
                    83.3597621,
                    54.5114644
                ],
                [
                    83.3607897,
                    54.5111263
                ],
                [
                    83.3600704,
                    54.5097342
                ],
                [
                    83.3575957,
                    54.5097385
                ],
                [
                    83.355857,
                    54.5087
                ],
                [
                    83.3517464,
                    54.5069101
                ],
                [
                    83.3492115,
                    54.5070294
                ],
                [
                    83.3484236,
                    54.5065521
                ],
                [
                    83.3474987,
                    54.5051996
                ],
                [
                    83.3402708,
                    54.4998689
                ],
                [
                    83.3394487,
                    54.5003861
                ],
                [
                    83.3383525,
                    54.4999882
                ],
                [
                    83.3362425,
                    54.5021112
                ],
                [
                    83.3361945,
                    54.5021564
                ],
                [
                    83.3356364,
                    54.5020372
                ],
                [
                    83.3354042,
                    54.5019876
                ],
                [
                    83.3328151,
                    54.5080759
                ],
                [
                    83.3326385,
                    54.5081901
                ],
                [
                    83.3344129,
                    54.508528
                ],
                [
                    83.33324,
                    54.5097579
                ],
                [
                    83.332012,
                    54.5114532
                ],
                [
                    83.3319178,
                    54.5123057
                ],
                [
                    83.3317756,
                    54.5127967
                ]
            ],
            "longitude": 83.3479109,
            "latitude": 54.5129689
        },
        "3646": {
            "name": "Майский",
            "population": 1072,
            "type": "village",
            "poly": [
                [
                    83.3452554,
                    54.1891423
                ],
                [
                    83.3459743,
                    54.1904765
                ],
                [
                    83.3468418,
                    54.1907376
                ],
                [
                    83.3487007,
                    54.190607
                ],
                [
                    83.34994,
                    54.1902155
                ],
                [
                    83.3499152,
                    54.1896209
                ],
                [
                    83.3506588,
                    54.1894759
                ],
                [
                    83.3520716,
                    54.1897224
                ],
                [
                    83.3538066,
                    54.1895339
                ],
                [
                    83.3545997,
                    54.1888088
                ],
                [
                    83.3553433,
                    54.187663
                ],
                [
                    83.3562604,
                    54.1872425
                ],
                [
                    83.3575491,
                    54.1871119
                ],
                [
                    83.3583176,
                    54.1877356
                ],
                [
                    83.3575244,
                    54.1882287
                ],
                [
                    83.3576484,
                    54.1890988
                ],
                [
                    83.3590116,
                    54.1905345
                ],
                [
                    83.3602261,
                    54.1908536
                ],
                [
                    83.3601517,
                    54.1914046
                ],
                [
                    83.3606722,
                    54.1918977
                ],
                [
                    83.3615149,
                    54.1921152
                ],
                [
                    83.361738,
                    54.1927098
                ],
                [
                    83.3632252,
                    54.1925792
                ],
                [
                    83.3645884,
                    54.1933768
                ],
                [
                    83.3671165,
                    54.1947979
                ],
                [
                    83.3704874,
                    54.1931013
                ],
                [
                    83.3703635,
                    54.19023
                ],
                [
                    83.3698677,
                    54.1857196
                ],
                [
                    83.3650097,
                    54.1853135
                ],
                [
                    83.3632995,
                    54.1856761
                ],
                [
                    83.3618124,
                    54.1860677
                ],
                [
                    83.3620602,
                    54.1849654
                ],
                [
                    83.3608705,
                    54.1838631
                ],
                [
                    83.3584167,
                    54.1827027
                ],
                [
                    83.35688,
                    54.1826012
                ],
                [
                    83.3558638,
                    54.1835585
                ],
                [
                    83.3545997,
                    54.1857341
                ],
                [
                    83.3537322,
                    54.1865463
                ],
                [
                    83.3518237,
                    54.1865318
                ],
                [
                    83.3497169,
                    54.1873875
                ],
                [
                    83.3452554,
                    54.1891423
                ]
            ],
            "longitude": 83.36319,
            "latitude": 54.188618
        },
        "3647": {
            "name": "Смоленский",
            "population": 715,
            "type": "village",
            "poly": [
                [
                    83.3507601,
                    55.1957867
                ],
                [
                    83.3512829,
                    55.1972218
                ],
                [
                    83.3549521,
                    55.1980394
                ],
                [
                    83.3543193,
                    55.1995737
                ],
                [
                    83.3561583,
                    55.1999613
                ],
                [
                    83.3575154,
                    55.2010227
                ],
                [
                    83.3593249,
                    55.2004633
                ],
                [
                    83.3607573,
                    55.2016386
                ],
                [
                    83.3637528,
                    55.2013778
                ],
                [
                    83.3676994,
                    55.2022578
                ],
                [
                    83.3681261,
                    55.2015848
                ],
                [
                    83.3686988,
                    55.2022131
                ],
                [
                    83.3699553,
                    55.2021127
                ],
                [
                    83.370081,
                    55.2006354
                ],
                [
                    83.3722171,
                    55.2005207
                ],
                [
                    83.3712369,
                    55.1987278
                ],
                [
                    83.3685731,
                    55.1986991
                ],
                [
                    83.3677668,
                    55.1948621
                ],
                [
                    83.3623154,
                    55.1954718
                ],
                [
                    83.3596264,
                    55.1960599
                ],
                [
                    83.3598526,
                    55.1949554
                ],
                [
                    83.3620138,
                    55.1948693
                ],
                [
                    83.3623154,
                    55.193148
                ],
                [
                    83.3586966,
                    55.1925742
                ],
                [
                    83.3584128,
                    55.1920439
                ],
                [
                    83.356862,
                    55.1922155
                ],
                [
                    83.3550777,
                    55.1945107
                ],
                [
                    83.3554547,
                    55.1950271
                ],
                [
                    83.356485,
                    55.1951419
                ],
                [
                    83.3562589,
                    55.1957874
                ],
                [
                    83.351685,
                    55.1953427
                ],
                [
                    83.3507601,
                    55.1957867
                ]
            ],
            "longitude": 83.3635663,
            "latitude": 55.1974324
        },
        "3648": {
            "name": "Привольный",
            "population": 290,
            "type": "village",
            "poly": [
                [
                    83.3613175,
                    54.1231366
                ],
                [
                    83.3627006,
                    54.1249177
                ],
                [
                    83.3662983,
                    54.1253119
                ],
                [
                    83.3689304,
                    54.1254068
                ],
                [
                    83.3700823,
                    54.1250112
                ],
                [
                    83.3708451,
                    54.1215384
                ],
                [
                    83.3691091,
                    54.1204137
                ],
                [
                    83.3616113,
                    54.1194659
                ],
                [
                    83.3613424,
                    54.1214042
                ],
                [
                    83.3613175,
                    54.1231366
                ]
            ],
            "longitude": 83.364906,
            "latitude": 54.121769
        },
        "3649": {
            "name": "Безменово",
            "population": 2114,
            "type": "village",
            "poly": [
                [
                    83.3612543,
                    54.0665837
                ],
                [
                    83.3785921,
                    54.0776634
                ],
                [
                    83.3758455,
                    54.084914
                ],
                [
                    83.3890634,
                    54.0956869
                ],
                [
                    83.3990198,
                    54.0857196
                ],
                [
                    83.4010797,
                    54.0794762
                ],
                [
                    83.3924967,
                    54.0747427
                ],
                [
                    83.3974748,
                    54.0641659
                ],
                [
                    83.3730989,
                    54.0535864
                ],
                [
                    83.3674341,
                    54.0566093
                ],
                [
                    83.3612543,
                    54.0665837
                ]
            ],
            "longitude": 83.388893,
            "latitude": 54.076656
        },
        "3650": {
            "name": "Старый Искитим",
            "population": 706,
            "type": "village",
            "poly": [
                [
                    83.3815238,
                    54.6118006
                ],
                [
                    83.3873645,
                    54.6134989
                ],
                [
                    83.3870223,
                    54.6138951
                ],
                [
                    83.3905659,
                    54.6146452
                ],
                [
                    83.3939139,
                    54.6150131
                ],
                [
                    83.3969441,
                    54.6147159
                ],
                [
                    83.3994626,
                    54.6153196
                ],
                [
                    83.399316,
                    54.6156309
                ],
                [
                    83.402404,
                    54.6163928
                ],
                [
                    83.4032017,
                    54.6162389
                ],
                [
                    83.4065487,
                    54.6173166
                ],
                [
                    83.409755,
                    54.6185573
                ],
                [
                    83.4106152,
                    54.6187927
                ],
                [
                    83.4110062,
                    54.6183037
                ],
                [
                    83.4128831,
                    54.6184033
                ],
                [
                    83.4129926,
                    54.6187656
                ],
                [
                    83.4155732,
                    54.6187022
                ],
                [
                    83.417888,
                    54.6180864
                ],
                [
                    83.4185293,
                    54.6176426
                ],
                [
                    83.417106,
                    54.6172894
                ],
                [
                    83.4140405,
                    54.6161936
                ],
                [
                    83.4104588,
                    54.6159672
                ],
                [
                    83.4092232,
                    54.6158856
                ],
                [
                    83.4084099,
                    54.6156049
                ],
                [
                    83.4070648,
                    54.6143007
                ],
                [
                    83.4082222,
                    54.6129965
                ],
                [
                    83.4051411,
                    54.6125345
                ],
                [
                    83.40536,
                    54.6117828
                ],
                [
                    83.4045155,
                    54.6112937
                ],
                [
                    83.4024353,
                    54.6108317
                ],
                [
                    83.3996826,
                    54.6104603
                ],
                [
                    83.3962358,
                    54.6096196
                ],
                [
                    83.3951211,
                    54.6093483
                ],
                [
                    83.3926969,
                    54.6090585
                ],
                [
                    83.3878639,
                    54.6076363
                ],
                [
                    83.3853771,
                    54.6073283
                ],
                [
                    83.3849392,
                    54.607591
                ],
                [
                    83.3842511,
                    54.6087777
                ],
                [
                    83.3832188,
                    54.6087414
                ],
                [
                    83.3815238,
                    54.6118006
                ]
            ],
            "longitude": 83.3917519,
            "latitude": 54.6115673
        },
        "3651": {
            "name": "Нижний Коён",
            "population": 115,
            "type": "village",
            "poly": [
                [
                    83.3845859,
                    54.8128738
                ],
                [
                    83.3846815,
                    54.8135907
                ],
                [
                    83.3863086,
                    54.8150796
                ],
                [
                    83.3872975,
                    54.8155759
                ],
                [
                    83.3872656,
                    54.8164215
                ],
                [
                    83.3892434,
                    54.8177633
                ],
                [
                    83.3901048,
                    54.8177633
                ],
                [
                    83.3907428,
                    54.8183882
                ],
                [
                    83.3910937,
                    54.8195645
                ],
                [
                    83.3923059,
                    54.8199137
                ],
                [
                    83.3923697,
                    54.819344
                ],
                [
                    83.3960383,
                    54.8212738
                ],
                [
                    83.3979204,
                    54.8234424
                ],
                [
                    83.399356,
                    54.8255191
                ],
                [
                    83.4002034,
                    54.8270032
                ],
                [
                    83.4006403,
                    54.8279562
                ],
                [
                    83.4019718,
                    54.8282388
                ],
                [
                    83.4018761,
                    54.8275589
                ],
                [
                    83.4024822,
                    54.8267503
                ],
                [
                    83.402546,
                    54.8255742
                ],
                [
                    83.4018225,
                    54.8251013
                ],
                [
                    83.4019858,
                    54.8247061
                ],
                [
                    83.4027045,
                    54.824245
                ],
                [
                    83.4021492,
                    54.8229936
                ],
                [
                    83.4016265,
                    54.8220808
                ],
                [
                    83.4017735,
                    54.8213092
                ],
                [
                    83.4011039,
                    54.8196342
                ],
                [
                    83.3981639,
                    54.8183826
                ],
                [
                    83.4006464,
                    54.8145711
                ],
                [
                    83.3999115,
                    54.8130558
                ],
                [
                    83.4024595,
                    54.8114087
                ],
                [
                    83.4025248,
                    54.810091
                ],
                [
                    83.4018552,
                    54.8100062
                ],
                [
                    83.4034885,
                    54.808905
                ],
                [
                    83.4030312,
                    54.8087732
                ],
                [
                    83.4028188,
                    54.8088202
                ],
                [
                    83.4021328,
                    54.8085661
                ],
                [
                    83.4009079,
                    54.8086414
                ],
                [
                    83.3998789,
                    54.809545
                ],
                [
                    83.3999279,
                    54.8096862
                ],
                [
                    83.3996339,
                    54.8099215
                ],
                [
                    83.3991275,
                    54.8097709
                ],
                [
                    83.3981639,
                    54.8107028
                ],
                [
                    83.3981149,
                    54.8109193
                ],
                [
                    83.3963509,
                    54.8126982
                ],
                [
                    83.3955179,
                    54.8130841
                ],
                [
                    83.3945706,
                    54.8126135
                ],
                [
                    83.3937376,
                    54.8131405
                ],
                [
                    83.390765,
                    54.8123687
                ],
                [
                    83.3898013,
                    54.8124346
                ],
                [
                    83.3870737,
                    54.8124629
                ],
                [
                    83.3858977,
                    54.8122276
                ],
                [
                    83.3845859,
                    54.8128738
                ]
            ],
            "longitude": 83.396286,
            "latitude": 54.815178
        },
        "3652": {
            "name": "Плотниково",
            "population": 1725,
            "type": "village",
            "poly": [
                [
                    83.3842908,
                    55.0296647
                ],
                [
                    83.3880314,
                    55.0322202
                ],
                [
                    83.3898193,
                    55.0329968
                ],
                [
                    83.3921559,
                    55.0335029
                ],
                [
                    83.3919228,
                    55.0341196
                ],
                [
                    83.39191,
                    55.0350111
                ],
                [
                    83.389118,
                    55.0364062
                ],
                [
                    83.3926426,
                    55.0380981
                ],
                [
                    83.3911359,
                    55.0389575
                ],
                [
                    83.39231,
                    55.0410998
                ],
                [
                    83.3944259,
                    55.0455449
                ],
                [
                    83.3993629,
                    55.0456712
                ],
                [
                    83.4016551,
                    55.0446357
                ],
                [
                    83.4076501,
                    55.0454692
                ],
                [
                    83.4103831,
                    55.0470854
                ],
                [
                    83.4118818,
                    55.0469592
                ],
                [
                    83.4122785,
                    55.0466056
                ],
                [
                    83.4107515,
                    55.0445354
                ],
                [
                    83.4094573,
                    55.0431961
                ],
                [
                    83.4089725,
                    55.04014
                ],
                [
                    83.4050052,
                    55.0375636
                ],
                [
                    83.4008616,
                    55.0320313
                ],
                [
                    83.3983491,
                    55.0302628
                ],
                [
                    83.3965349,
                    55.0298385
                ],
                [
                    83.3938282,
                    55.0290755
                ],
                [
                    83.3911774,
                    55.0290587
                ],
                [
                    83.3898414,
                    55.0282435
                ],
                [
                    83.3887809,
                    55.0277278
                ],
                [
                    83.3842908,
                    55.0296647
                ]
            ],
            "longitude": 83.397324,
            "latitude": 55.036011
        },
        "3653": {
            "name": "Пушной",
            "population": 1315,
            "type": "village",
            "poly": null,
            "longitude": 83.406944,
            "latitude": 54.237465
        },
        "3654": {
            "name": "Искра",
            "population": 885,
            "type": "village",
            "poly": [
                [
                    83.3978696,
                    54.1885246
                ],
                [
                    83.404413,
                    54.1920167
                ],
                [
                    83.4102426,
                    54.1880141
                ],
                [
                    83.4105599,
                    54.1867726
                ],
                [
                    83.4112539,
                    54.1857864
                ],
                [
                    83.4117694,
                    54.1853571
                ],
                [
                    83.4132764,
                    54.1851482
                ],
                [
                    83.4140695,
                    54.1847305
                ],
                [
                    83.4152593,
                    54.1827115
                ],
                [
                    83.4158738,
                    54.1823634
                ],
                [
                    83.4197405,
                    54.1837907
                ],
                [
                    83.4207716,
                    54.1836282
                ],
                [
                    83.4219217,
                    54.1825375
                ],
                [
                    83.4165608,
                    54.1800481
                ],
                [
                    83.4124633,
                    54.1788125
                ],
                [
                    83.4095932,
                    54.181438
                ],
                [
                    83.4032729,
                    54.1853542
                ],
                [
                    83.4014387,
                    54.1865
                ],
                [
                    83.3978696,
                    54.1885246
                ]
            ],
            "longitude": 83.409195,
            "latitude": 54.186043
        },
        "3655": {
            "name": "Шадрино",
            "population": 436,
            "type": "village",
            "poly": [
                [
                    83.3997749,
                    54.4562227
                ],
                [
                    83.4009056,
                    54.4572938
                ],
                [
                    83.4027483,
                    54.4581216
                ],
                [
                    83.4009475,
                    54.4585192
                ],
                [
                    83.4010732,
                    54.4588194
                ],
                [
                    83.4013663,
                    54.4587707
                ],
                [
                    83.4019526,
                    54.4597851
                ],
                [
                    83.403558,
                    54.4608318
                ],
                [
                    83.4040325,
                    54.4612538
                ],
                [
                    83.4045073,
                    54.4613674
                ],
                [
                    83.4051494,
                    54.4611645
                ],
                [
                    83.4054146,
                    54.4611158
                ],
                [
                    83.4061378,
                    54.4608335
                ],
                [
                    83.4063499,
                    54.4607507
                ],
                [
                    83.4077738,
                    54.4611239
                ],
                [
                    83.4082066,
                    54.4614728
                ],
                [
                    83.4061685,
                    54.4622112
                ],
                [
                    83.4065268,
                    54.462746
                ],
                [
                    83.408299,
                    54.4623498
                ],
                [
                    83.4089807,
                    54.4633482
                ],
                [
                    83.4094442,
                    54.4634908
                ],
                [
                    83.4096622,
                    54.4638077
                ],
                [
                    83.4093352,
                    54.4642198
                ],
                [
                    83.4099623,
                    54.4644258
                ],
                [
                    83.4104258,
                    54.4639979
                ],
                [
                    83.4112661,
                    54.4640416
                ],
                [
                    83.4120076,
                    54.4644305
                ],
                [
                    83.4128733,
                    54.4646414
                ],
                [
                    83.4133151,
                    54.4639972
                ],
                [
                    83.4134249,
                    54.4642831
                ],
                [
                    83.413534,
                    54.4649962
                ],
                [
                    83.4163151,
                    54.4653766
                ],
                [
                    83.4172421,
                    54.4659629
                ],
                [
                    83.41806,
                    54.465947
                ],
                [
                    83.4181146,
                    54.4654241
                ],
                [
                    83.4184963,
                    54.4654399
                ],
                [
                    83.4182856,
                    54.4657082
                ],
                [
                    83.4187323,
                    54.4663086
                ],
                [
                    83.419849,
                    54.4660733
                ],
                [
                    83.419514,
                    54.4650104
                ],
                [
                    83.4205889,
                    54.4648238
                ],
                [
                    83.4203795,
                    54.4639151
                ],
                [
                    83.4210077,
                    54.4639638
                ],
                [
                    83.4219151,
                    54.4634526
                ],
                [
                    83.4217197,
                    54.4630226
                ],
                [
                    83.4220408,
                    54.4628198
                ],
                [
                    83.4223442,
                    54.4616258
                ],
                [
                    83.421462,
                    54.46128
                ],
                [
                    83.4202818,
                    54.4620165
                ],
                [
                    83.4203656,
                    54.4599636
                ],
                [
                    83.4200724,
                    54.4595254
                ],
                [
                    83.4202958,
                    54.4594605
                ],
                [
                    83.4193605,
                    54.4584786
                ],
                [
                    83.419528,
                    54.4581784
                ],
                [
                    83.4184391,
                    54.4582676
                ],
                [
                    83.4169454,
                    54.4565635
                ],
                [
                    83.4162754,
                    54.4562795
                ],
                [
                    83.4160864,
                    54.4563178
                ],
                [
                    83.4156751,
                    54.4564012
                ],
                [
                    83.4144745,
                    54.4561821
                ],
                [
                    83.4140697,
                    54.45632
                ],
                [
                    83.4137068,
                    54.4559549
                ],
                [
                    83.413637,
                    54.4555897
                ],
                [
                    83.4131344,
                    54.4553137
                ],
                [
                    83.4130088,
                    54.4550378
                ],
                [
                    83.4126598,
                    54.454908
                ],
                [
                    83.4131623,
                    54.4539585
                ],
                [
                    83.4143768,
                    54.453504
                ],
                [
                    83.4144745,
                    54.453642
                ],
                [
                    83.4157029,
                    54.4534959
                ],
                [
                    83.4157309,
                    54.4532199
                ],
                [
                    83.4172386,
                    54.4531063
                ],
                [
                    83.4178249,
                    54.4532767
                ],
                [
                    83.4185229,
                    54.4533254
                ],
                [
                    83.4186206,
                    54.453853
                ],
                [
                    83.4193744,
                    54.4539017
                ],
                [
                    83.4198351,
                    54.4529521
                ],
                [
                    83.4194861,
                    54.4528304
                ],
                [
                    83.4194581,
                    54.4525788
                ],
                [
                    83.4184391,
                    54.4526275
                ],
                [
                    83.4175317,
                    54.4520999
                ],
                [
                    83.4146281,
                    54.4520918
                ],
                [
                    83.4138882,
                    54.4522623
                ],
                [
                    83.4141954,
                    54.4530495
                ],
                [
                    83.410482,
                    54.4543805
                ],
                [
                    83.4097003,
                    54.4543805
                ],
                [
                    83.4089883,
                    54.4538448
                ],
                [
                    83.4095607,
                    54.4533336
                ],
                [
                    83.4097422,
                    54.4526356
                ],
                [
                    83.4093234,
                    54.4524814
                ],
                [
                    83.4078855,
                    54.4526437
                ],
                [
                    83.4074667,
                    54.4521892
                ],
                [
                    83.4054146,
                    54.4528385
                ],
                [
                    83.4056938,
                    54.4531956
                ],
                [
                    83.4047446,
                    54.4531063
                ],
                [
                    83.4045352,
                    54.4532767
                ],
                [
                    83.4044375,
                    54.4538692
                ],
                [
                    83.4039934,
                    54.4540973
                ],
                [
                    83.4038372,
                    54.4541776
                ],
                [
                    83.4029996,
                    54.4540072
                ],
                [
                    83.402511,
                    54.4539528
                ],
                [
                    83.4018409,
                    54.4539422
                ],
                [
                    83.4014082,
                    54.4541127
                ],
                [
                    83.4016734,
                    54.4546402
                ],
                [
                    83.400766,
                    54.4559711
                ],
                [
                    83.4004729,
                    54.4558494
                ],
                [
                    83.3997749,
                    54.4562227
                ]
            ],
            "longitude": 83.414215,
            "latitude": 54.459206
        },
        "3656": {
            "name": "Южный",
            "population": 366,
            "type": "village",
            "poly": null,
            "longitude": 83.42205,
            "latitude": 54.01062
        },
        "3657": {
            "name": "Барабка",
            "population": 294,
            "type": "village",
            "poly": [
                [
                    83.4229617,
                    54.6603006
                ],
                [
                    83.4246724,
                    54.6613325
                ],
                [
                    83.4280938,
                    54.6626894
                ],
                [
                    83.4268963,
                    54.6641877
                ],
                [
                    83.4278249,
                    54.6644704
                ],
                [
                    83.4292179,
                    54.6654456
                ],
                [
                    83.4314662,
                    54.6645411
                ],
                [
                    83.4324193,
                    54.6635234
                ],
                [
                    83.4332502,
                    54.663693
                ],
                [
                    83.4332502,
                    54.6640322
                ],
                [
                    83.4350342,
                    54.6643856
                ],
                [
                    83.4361828,
                    54.6643149
                ],
                [
                    83.436256,
                    54.6640433
                ],
                [
                    83.436476,
                    54.6632266
                ],
                [
                    83.4361828,
                    54.6620816
                ],
                [
                    83.4367448,
                    54.6617848
                ],
                [
                    83.4371603,
                    54.6619686
                ],
                [
                    83.4377224,
                    54.6617141
                ],
                [
                    83.4382845,
                    54.6615728
                ],
                [
                    83.439042,
                    54.6621241
                ],
                [
                    83.4393842,
                    54.6620958
                ],
                [
                    83.4403128,
                    54.6613325
                ],
                [
                    83.4399463,
                    54.6606681
                ],
                [
                    83.4395552,
                    54.6604278
                ],
                [
                    83.4392376,
                    54.6605692
                ],
                [
                    83.4377224,
                    54.6592546
                ],
                [
                    83.4367448,
                    54.6593111
                ],
                [
                    83.4362316,
                    54.6584488
                ],
                [
                    83.4339588,
                    54.6588446
                ],
                [
                    83.4318572,
                    54.6584629
                ],
                [
                    83.4324193,
                    54.6575723
                ],
                [
                    83.4333968,
                    54.6569221
                ],
                [
                    83.4328103,
                    54.6565404
                ],
                [
                    83.433128,
                    54.6555649
                ],
                [
                    83.4315151,
                    54.654236
                ],
                [
                    83.432126,
                    54.6538401
                ],
                [
                    83.4310263,
                    54.653105
                ],
                [
                    83.4303421,
                    54.6534301
                ],
                [
                    83.4299266,
                    54.6532322
                ],
                [
                    83.4280204,
                    54.654236
                ],
                [
                    83.4276294,
                    54.6541512
                ],
                [
                    83.4269696,
                    54.6545046
                ],
                [
                    83.4271407,
                    54.6547025
                ],
                [
                    83.4256499,
                    54.6553953
                ],
                [
                    83.4266763,
                    54.6562576
                ],
                [
                    83.4261387,
                    54.6565828
                ],
                [
                    83.4252834,
                    54.6563424
                ],
                [
                    83.4249412,
                    54.6566252
                ],
                [
                    83.4254056,
                    54.6572189
                ],
                [
                    83.4258943,
                    54.6578268
                ],
                [
                    83.4255522,
                    54.6583498
                ],
                [
                    83.4256751,
                    54.6590415
                ],
                [
                    83.4256255,
                    54.6590708
                ],
                [
                    83.4245258,
                    54.6588587
                ],
                [
                    83.4238904,
                    54.6592828
                ],
                [
                    83.4239881,
                    54.659608
                ],
                [
                    83.4229617,
                    54.6603006
                ]
            ],
            "longitude": 83.430481,
            "latitude": 54.659492
        },
        "3658": {
            "name": "Восточная",
            "population": 278,
            "type": "village",
            "poly": [
                [
                    83.4213822,
                    55.0314482
                ],
                [
                    83.4220883,
                    55.0318403
                ],
                [
                    83.4218235,
                    55.0322702
                ],
                [
                    83.4233681,
                    55.0331934
                ],
                [
                    83.4284209,
                    55.0352419
                ],
                [
                    83.4289505,
                    55.0360638
                ],
                [
                    83.4283989,
                    55.036519
                ],
                [
                    83.4318189,
                    55.038365
                ],
                [
                    83.4355038,
                    55.0405776
                ],
                [
                    83.4351066,
                    55.0408052
                ],
                [
                    83.437269,
                    55.0420948
                ],
                [
                    83.4400712,
                    55.0441175
                ],
                [
                    83.4414834,
                    55.0443577
                ],
                [
                    83.4421233,
                    55.0441049
                ],
                [
                    83.4426528,
                    55.0430303
                ],
                [
                    83.4419688,
                    55.0424614
                ],
                [
                    83.4394755,
                    55.040742
                ],
                [
                    83.4385046,
                    55.0393386
                ],
                [
                    83.4374676,
                    55.0390857
                ],
                [
                    83.4365849,
                    55.0390225
                ],
                [
                    83.4368939,
                    55.0387064
                ],
                [
                    83.4363202,
                    55.0382259
                ],
                [
                    83.4355259,
                    55.0380236
                ],
                [
                    83.4355038,
                    55.0372018
                ],
                [
                    83.4333434,
                    55.0359682
                ],
                [
                    83.4293697,
                    55.0336992
                ],
                [
                    83.4291491,
                    55.0338762
                ],
                [
                    83.4281562,
                    55.033421
                ],
                [
                    83.4279796,
                    55.0331428
                ],
                [
                    83.4282224,
                    55.0330163
                ],
                [
                    83.4278252,
                    55.032814
                ],
                [
                    83.4281562,
                    55.0325358
                ],
                [
                    83.4278031,
                    55.0324093
                ],
                [
                    83.4274501,
                    55.0326875
                ],
                [
                    83.4271632,
                    55.032207
                ],
                [
                    83.4272955,
                    55.0318782
                ],
                [
                    83.427075,
                    55.0318529
                ],
                [
                    83.4264351,
                    55.0323335
                ],
                [
                    83.42606,
                    55.0321564
                ],
                [
                    83.4261924,
                    55.0319541
                ],
                [
                    83.4247582,
                    55.0315368
                ],
                [
                    83.4237123,
                    55.0313526
                ],
                [
                    83.4230118,
                    55.0313397
                ],
                [
                    83.4221759,
                    55.0311778
                ],
                [
                    83.4218595,
                    55.0310224
                ],
                [
                    83.4213822,
                    55.0314482
                ]
            ],
            "longitude": 83.430832,
            "latitude": 55.035954
        },
        "3659": {
            "name": "Ургун",
            "population": 891,
            "type": "village",
            "poly": [
                [
                    83.4107049,
                    54.4980253
                ],
                [
                    83.4200776,
                    54.4996708
                ],
                [
                    83.417026,
                    54.5006201
                ],
                [
                    83.4151733,
                    54.5036578
                ],
                [
                    83.4186608,
                    54.5049234
                ],
                [
                    83.4182248,
                    54.5060624
                ],
                [
                    83.4162631,
                    54.5061257
                ],
                [
                    83.4152823,
                    54.5081506
                ],
                [
                    83.417244,
                    54.5121367
                ],
                [
                    83.4193147,
                    54.5132755
                ],
                [
                    83.4214676,
                    54.5138096
                ],
                [
                    83.4218213,
                    54.5139714
                ],
                [
                    83.42411,
                    54.514098
                ],
                [
                    83.4245459,
                    54.5153
                ],
                [
                    83.4257448,
                    54.5147939
                ],
                [
                    83.4266166,
                    54.5134653
                ],
                [
                    83.4286873,
                    54.514098
                ],
                [
                    83.4317389,
                    54.5137184
                ],
                [
                    83.4321748,
                    54.5125796
                ],
                [
                    83.4305401,
                    54.5116938
                ],
                [
                    83.4326108,
                    54.5102386
                ],
                [
                    83.4362072,
                    54.5105549
                ],
                [
                    83.4405666,
                    54.5092895
                ],
                [
                    83.4398037,
                    54.508024
                ],
                [
                    83.4431822,
                    54.5072014
                ],
                [
                    83.4434002,
                    54.5056828
                ],
                [
                    83.4382779,
                    54.5049234
                ],
                [
                    83.4351087,
                    54.5054135
                ],
                [
                    83.4339186,
                    54.5051132
                ],
                [
                    83.4350084,
                    54.5039109
                ],
                [
                    83.4299951,
                    54.5023921
                ],
                [
                    83.4305401,
                    54.501253
                ],
                [
                    83.4280334,
                    54.5011897
                ],
                [
                    83.4280334,
                    54.4982785
                ],
                [
                    83.4255492,
                    54.4944113
                ],
                [
                    83.4253427,
                    54.4938144
                ],
                [
                    83.4195754,
                    54.4878829
                ],
                [
                    83.4167854,
                    54.488207
                ],
                [
                    83.4167296,
                    54.4890173
                ],
                [
                    83.4181804,
                    54.4895359
                ],
                [
                    83.4183478,
                    54.4900869
                ],
                [
                    83.4170086,
                    54.4905082
                ],
                [
                    83.417455,
                    54.4924204
                ],
                [
                    83.415223,
                    54.4939112
                ],
                [
                    83.4131026,
                    54.4939112
                ],
                [
                    83.4107049,
                    54.4980253
                ]
            ],
            "longitude": 83.42754094346262,
            "latitude": 54.50424927528644
        },
        "3660": {
            "name": "Обской",
            "population": 543,
            "type": "village",
            "poly": [
                [
                    83.4285918,
                    55.4708918
                ],
                [
                    83.4301669,
                    55.4756517
                ],
                [
                    83.4290574,
                    55.477993
                ],
                [
                    83.43409,
                    55.480535
                ],
                [
                    83.4399722,
                    55.4786333
                ],
                [
                    83.4461245,
                    55.4773729
                ],
                [
                    83.4505174,
                    55.4795089
                ],
                [
                    83.4543298,
                    55.480535
                ],
                [
                    83.4622979,
                    55.4809852
                ],
                [
                    83.4625506,
                    55.4779332
                ],
                [
                    83.4544825,
                    55.4754037
                ],
                [
                    83.4542407,
                    55.4708384
                ],
                [
                    83.4489501,
                    55.4690094
                ],
                [
                    83.4452493,
                    55.4711101
                ],
                [
                    83.4421228,
                    55.4714146
                ],
                [
                    83.4285918,
                    55.4708918
                ]
            ],
            "longitude": 83.445213,
            "latitude": 55.47443
        },
        "3661": {
            "name": "Бочкарево",
            "population": 641,
            "type": "village",
            "poly": [
                [
                    83.4520795,
                    54.2515362
                ],
                [
                    83.452787,
                    54.2520097
                ],
                [
                    83.4553535,
                    54.2523823
                ],
                [
                    83.457977,
                    54.2529708
                ],
                [
                    83.4603066,
                    54.2529218
                ],
                [
                    83.463035,
                    54.2528114
                ],
                [
                    83.4647978,
                    54.2526643
                ],
                [
                    83.4656164,
                    54.2529953
                ],
                [
                    83.4667708,
                    54.2531179
                ],
                [
                    83.4670226,
                    54.2528237
                ],
                [
                    83.4681979,
                    54.2529463
                ],
                [
                    83.4688695,
                    54.2532406
                ],
                [
                    83.469499,
                    54.2530076
                ],
                [
                    83.4704646,
                    54.2527378
                ],
                [
                    83.4746621,
                    54.2540498
                ],
                [
                    83.4770391,
                    54.2529429
                ],
                [
                    83.4785868,
                    54.2542827
                ],
                [
                    83.4799719,
                    54.2551532
                ],
                [
                    83.4827633,
                    54.2556559
                ],
                [
                    83.4829102,
                    54.2552636
                ],
                [
                    83.4850509,
                    54.2541969
                ],
                [
                    83.4857645,
                    54.2529585
                ],
                [
                    83.4849459,
                    54.2524681
                ],
                [
                    83.4829732,
                    54.2519899
                ],
                [
                    83.4810003,
                    54.2490961
                ],
                [
                    83.4773695,
                    54.2478821
                ],
                [
                    83.4726893,
                    54.2477963
                ],
                [
                    83.4707374,
                    54.2478821
                ],
                [
                    83.4672115,
                    54.2475878
                ],
                [
                    83.4659731,
                    54.2471954
                ],
                [
                    83.4575887,
                    54.2445811
                ],
                [
                    83.4561458,
                    54.2457691
                ],
                [
                    83.4561786,
                    54.2483749
                ],
                [
                    83.4589332,
                    54.2495245
                ],
                [
                    83.4586053,
                    54.250904
                ],
                [
                    83.4528337,
                    54.2509615
                ],
                [
                    83.4520795,
                    54.2515362
                ]
            ],
            "longitude": 83.4617279,
            "latitude": 54.2492351
        },
        "3662": {
            "name": "Репьево",
            "population": 618,
            "type": "village",
            "poly": [
                [
                    83.4441819,
                    55.0639007
                ],
                [
                    83.4461794,
                    55.0655573
                ],
                [
                    83.449141,
                    55.0670166
                ],
                [
                    83.4541689,
                    55.0695801
                ],
                [
                    83.461952,
                    55.0709998
                ],
                [
                    83.4695972,
                    55.0716702
                ],
                [
                    83.4742808,
                    55.0716308
                ],
                [
                    83.4779692,
                    55.0689915
                ],
                [
                    83.477437,
                    55.0670895
                ],
                [
                    83.4753139,
                    55.0661884
                ],
                [
                    83.470286,
                    55.0645713
                ],
                [
                    83.4629851,
                    55.0597196
                ],
                [
                    83.4611943,
                    55.0556169
                ],
                [
                    83.4737298,
                    55.0511982
                ],
                [
                    83.4731788,
                    55.0488702
                ],
                [
                    83.4698727,
                    55.0471735
                ],
                [
                    83.4614698,
                    55.0498961
                ],
                [
                    83.4567174,
                    55.0538021
                ],
                [
                    83.4544444,
                    55.0551829
                ],
                [
                    83.4512072,
                    55.0551435
                ],
                [
                    83.4495543,
                    55.0581022
                ],
                [
                    83.4441819,
                    55.0639007
                ]
            ],
            "longitude": 83.463028,
            "latitude": 55.064449
        },
        "3663": {
            "name": "Листвянский",
            "population": 2678,
            "type": "village",
            "poly": [
                [
                    83.459153,
                    54.4433296
                ],
                [
                    83.460579,
                    54.4446479
                ],
                [
                    83.4629923,
                    54.4458598
                ],
                [
                    83.4643818,
                    54.4459662
                ],
                [
                    83.4662466,
                    54.4454559
                ],
                [
                    83.4671242,
                    54.4456047
                ],
                [
                    83.4680018,
                    54.448071
                ],
                [
                    83.4651862,
                    54.4523654
                ],
                [
                    83.4703419,
                    54.4534495
                ],
                [
                    83.4751685,
                    54.4518764
                ],
                [
                    83.4848217,
                    54.4567443
                ],
                [
                    83.5085525,
                    54.4618242
                ],
                [
                    83.5079674,
                    54.4626105
                ],
                [
                    83.5149879,
                    54.4586786
                ],
                [
                    83.512209,
                    54.4577008
                ],
                [
                    83.5172184,
                    54.4541723
                ],
                [
                    83.5126112,
                    54.4522166
                ],
                [
                    83.5135619,
                    54.4523016
                ],
                [
                    83.5144029,
                    54.4517914
                ],
                [
                    83.5153901,
                    54.4518552
                ],
                [
                    83.5168893,
                    54.4514087
                ],
                [
                    83.5172915,
                    54.4516213
                ],
                [
                    83.5168162,
                    54.4518339
                ],
                [
                    83.5166699,
                    54.452174
                ],
                [
                    83.5157192,
                    54.4523016
                ],
                [
                    83.5184616,
                    54.4533858
                ],
                [
                    83.5202533,
                    54.4516001
                ],
                [
                    83.5193757,
                    54.4510686
                ],
                [
                    83.5198876,
                    54.4505371
                ],
                [
                    83.5189004,
                    54.4500269
                ],
                [
                    83.5170721,
                    54.4506647
                ],
                [
                    83.5171453,
                    54.4501119
                ],
                [
                    83.5140372,
                    54.449793
                ],
                [
                    83.51422,
                    54.4490702
                ],
                [
                    83.5157558,
                    54.448645
                ],
                [
                    83.515573,
                    54.4482411
                ],
                [
                    83.5121724,
                    54.4473269
                ],
                [
                    83.5130134,
                    54.4463914
                ],
                [
                    83.5145857,
                    54.4464126
                ],
                [
                    83.515317,
                    54.4456685
                ],
                [
                    83.5093935,
                    54.4430957
                ],
                [
                    83.5085159,
                    54.4436061
                ],
                [
                    83.5074921,
                    54.4431808
                ],
                [
                    83.5107829,
                    54.4408843
                ],
                [
                    83.5037063,
                    54.4380519
                ],
                [
                    83.5028483,
                    54.4377158
                ],
                [
                    83.5000694,
                    54.4351426
                ],
                [
                    83.4968882,
                    54.4339942
                ],
                [
                    83.4965225,
                    54.4331647
                ],
                [
                    83.4942921,
                    54.4321013
                ],
                [
                    83.4915578,
                    54.4322857
                ],
                [
                    83.4888932,
                    54.4331026
                ],
                [
                    83.4866681,
                    54.4336887
                ],
                [
                    83.4859918,
                    54.4336539
                ],
                [
                    83.4851508,
                    54.4342068
                ],
                [
                    83.4835054,
                    54.4337177
                ],
                [
                    83.4827741,
                    54.4340792
                ],
                [
                    83.4833591,
                    54.4351851
                ],
                [
                    83.4831476,
                    54.4353343
                ],
                [
                    83.4818599,
                    54.4361847
                ],
                [
                    83.4846389,
                    54.4389918
                ],
                [
                    83.4807264,
                    54.4409269
                ],
                [
                    83.4749857,
                    54.4372055
                ],
                [
                    83.4666488,
                    54.4399487
                ],
                [
                    83.4633214,
                    54.4390768
                ],
                [
                    83.460262,
                    54.4403805
                ],
                [
                    83.459153,
                    54.4433296
                ]
            ],
            "longitude": 83.48613,
            "latitude": 54.442276
        },
        "3664": {
            "name": "Ташара",
            "population": 3058,
            "type": "village",
            "poly": [
                [
                    83.4653727,
                    55.5145093
                ],
                [
                    83.4893896,
                    55.5253272
                ],
                [
                    83.5017511,
                    55.5320028
                ],
                [
                    83.5031492,
                    55.5312115
                ],
                [
                    83.5068708,
                    55.5323301
                ],
                [
                    83.5095305,
                    55.5333419
                ],
                [
                    83.5093512,
                    55.5312927
                ],
                [
                    83.5072719,
                    55.5301159
                ],
                [
                    83.5088493,
                    55.5282492
                ],
                [
                    83.5120041,
                    55.5297913
                ],
                [
                    83.5141551,
                    55.5301768
                ],
                [
                    83.5128873,
                    55.5311296
                ],
                [
                    83.521735,
                    55.5339936
                ],
                [
                    83.5240137,
                    55.5339708
                ],
                [
                    83.5244798,
                    55.5333622
                ],
                [
                    83.5232474,
                    55.5326939
                ],
                [
                    83.5303408,
                    55.5328175
                ],
                [
                    83.5333302,
                    55.5315209
                ],
                [
                    83.5343504,
                    55.5300421
                ],
                [
                    83.5312016,
                    55.5289847
                ],
                [
                    83.5256001,
                    55.5293018
                ],
                [
                    83.5229674,
                    55.5286677
                ],
                [
                    83.5245918,
                    55.5268922
                ],
                [
                    83.5213565,
                    55.5258417
                ],
                [
                    83.5154053,
                    55.5179185
                ],
                [
                    83.5101399,
                    55.5147154
                ],
                [
                    83.5088908,
                    55.5134847
                ],
                [
                    83.5049865,
                    55.5089427
                ],
                [
                    83.50297,
                    55.5063099
                ],
                [
                    83.5018497,
                    55.5066588
                ],
                [
                    83.5006734,
                    55.5064685
                ],
                [
                    83.4999371,
                    55.507469
                ],
                [
                    83.5032192,
                    55.5127349
                ],
                [
                    83.5003261,
                    55.5130407
                ],
                [
                    83.4967381,
                    55.5115123
                ],
                [
                    83.4959599,
                    55.510201
                ],
                [
                    83.4866992,
                    55.504433
                ],
                [
                    83.4842923,
                    55.504433
                ],
                [
                    83.4804934,
                    55.5029915
                ],
                [
                    83.4867263,
                    55.5067101
                ],
                [
                    83.4905283,
                    55.5111862
                ],
                [
                    83.4884496,
                    55.5124251
                ],
                [
                    83.4868329,
                    55.5113696
                ],
                [
                    83.4836305,
                    55.5134272
                ],
                [
                    83.4760869,
                    55.5118676
                ],
                [
                    83.4709449,
                    55.5102569
                ],
                [
                    83.4653727,
                    55.5145093
                ]
            ],
            "longitude": 83.495399,
            "latitude": 55.517941
        },
        "3665": {
            "name": "Верхний Коён",
            "population": 596,
            "type": "village",
            "poly": [
                [
                    83.4819962,
                    54.8684772
                ],
                [
                    83.4946137,
                    54.8767197
                ],
                [
                    83.4944888,
                    54.8786363
                ],
                [
                    83.5017761,
                    54.8787801
                ],
                [
                    83.5042747,
                    54.8799779
                ],
                [
                    83.505982,
                    54.8789957
                ],
                [
                    83.5038998,
                    54.8769833
                ],
                [
                    83.5075664,
                    54.8756644
                ],
                [
                    83.5093573,
                    54.8770971
                ],
                [
                    83.5109678,
                    54.8766606
                ],
                [
                    83.5123593,
                    54.8781766
                ],
                [
                    83.5133826,
                    54.8777742
                ],
                [
                    83.5137166,
                    54.8748063
                ],
                [
                    83.5181926,
                    54.8745064
                ],
                [
                    83.5178856,
                    54.873417
                ],
                [
                    83.5097326,
                    54.8737703
                ],
                [
                    83.507464,
                    54.8725926
                ],
                [
                    83.5101939,
                    54.8703969
                ],
                [
                    83.5129922,
                    54.8685566
                ],
                [
                    83.5153242,
                    54.8674255
                ],
                [
                    83.5165568,
                    54.8624024
                ],
                [
                    83.5087883,
                    54.8599962
                ],
                [
                    83.5072191,
                    54.8625094
                ],
                [
                    83.5050222,
                    54.8620774
                ],
                [
                    83.5026616,
                    54.8651245
                ],
                [
                    83.4959618,
                    54.8641821
                ],
                [
                    83.4875699,
                    54.8651323
                ],
                [
                    83.4819962,
                    54.8684772
                ]
            ],
            "longitude": 83.507347,
            "latitude": 54.868355
        },
        "3666": {
            "name": "Зимовье",
            "population": 495,
            "type": "village",
            "poly": [
                [
                    83.5309867,
                    54.2285166
                ],
                [
                    83.5329678,
                    54.2304895
                ],
                [
                    83.5339583,
                    54.233663
                ],
                [
                    83.5369297,
                    54.2346707
                ],
                [
                    83.5395343,
                    54.235464
                ],
                [
                    83.5474584,
                    54.2379511
                ],
                [
                    83.5563361,
                    54.2412098
                ],
                [
                    83.5601881,
                    54.2450255
                ],
                [
                    83.5616555,
                    54.2451756
                ],
                [
                    83.5613987,
                    54.2426246
                ],
                [
                    83.5597479,
                    54.241124
                ],
                [
                    83.560665,
                    54.2405452
                ],
                [
                    83.5597112,
                    54.2400307
                ],
                [
                    83.5587574,
                    54.2406309
                ],
                [
                    83.5534013,
                    54.2382298
                ],
                [
                    83.5495861,
                    54.2359572
                ],
                [
                    83.5451472,
                    54.2344778
                ],
                [
                    83.5422491,
                    54.2337487
                ],
                [
                    83.5488157,
                    54.2314973
                ],
                [
                    83.5463578,
                    54.229739
                ],
                [
                    83.5455507,
                    54.228002
                ],
                [
                    83.5484489,
                    54.2267367
                ],
                [
                    83.5502097,
                    54.2231766
                ],
                [
                    83.5464312,
                    54.2227262
                ],
                [
                    83.5441934,
                    54.2245278
                ],
                [
                    83.5415521,
                    54.2263293
                ],
                [
                    83.5396811,
                    54.2278304
                ],
                [
                    83.5341784,
                    54.2266509
                ],
                [
                    83.5323808,
                    54.22723
                ],
                [
                    83.5309867,
                    54.2285166
                ]
            ],
            "longitude": 83.54393,
            "latitude": 54.23177
        },
        "3667": {
            "name": "Горный",
            "population": 309,
            "type": "village",
            "poly": [
                [
                    83.5308224,
                    55.3254469
                ],
                [
                    83.5354198,
                    55.3268273
                ],
                [
                    83.5358988,
                    55.3278989
                ],
                [
                    83.5341428,
                    55.3294609
                ],
                [
                    83.5360584,
                    55.330714
                ],
                [
                    83.5396981,
                    55.328807
                ],
                [
                    83.5404324,
                    55.3292248
                ],
                [
                    83.5393788,
                    55.3310046
                ],
                [
                    83.5414859,
                    55.3316765
                ],
                [
                    83.5463388,
                    55.3339102
                ],
                [
                    83.5511597,
                    55.3303145
                ],
                [
                    83.5554699,
                    55.3316584
                ],
                [
                    83.5554726,
                    55.3313445
                ],
                [
                    83.5555026,
                    55.327863
                ],
                [
                    83.5533874,
                    55.326569
                ],
                [
                    83.5489177,
                    55.3260014
                ],
                [
                    83.5472015,
                    55.3245028
                ],
                [
                    83.544887,
                    55.3239352
                ],
                [
                    83.5427319,
                    55.3244347
                ],
                [
                    83.5415346,
                    55.3250024
                ],
                [
                    83.5402975,
                    55.3251159
                ],
                [
                    83.5318121,
                    55.323685
                ],
                [
                    83.5308224,
                    55.3254469
                ]
            ],
            "longitude": 83.543968,
            "latitude": 55.327282
        },
        "3668": {
            "name": "Медведское",
            "population": 1548,
            "type": "village",
            "poly": [
                [
                    83.5465605,
                    54.3978319
                ],
                [
                    83.5467076,
                    54.3989793
                ],
                [
                    83.5471194,
                    54.4007088
                ],
                [
                    83.5469723,
                    54.4033628
                ],
                [
                    83.5483549,
                    54.4033971
                ],
                [
                    83.5485902,
                    54.4028492
                ],
                [
                    83.5496744,
                    54.4036345
                ],
                [
                    83.5493697,
                    54.4042379
                ],
                [
                    83.5492355,
                    54.4048535
                ],
                [
                    83.5497074,
                    54.4050031
                ],
                [
                    83.5494433,
                    54.4057085
                ],
                [
                    83.5482078,
                    54.4058626
                ],
                [
                    83.5485015,
                    54.4072655
                ],
                [
                    83.5492036,
                    54.4077528
                ],
                [
                    83.550643,
                    54.4081936
                ],
                [
                    83.5512888,
                    54.4089939
                ],
                [
                    83.5540028,
                    54.4095264
                ],
                [
                    83.5551239,
                    54.4102577
                ],
                [
                    83.5570789,
                    54.4116413
                ],
                [
                    83.559181,
                    54.4129389
                ],
                [
                    83.5624158,
                    54.4139773
                ],
                [
                    83.5633958,
                    54.4167071
                ],
                [
                    83.5663596,
                    54.416352
                ],
                [
                    83.5650632,
                    54.4133611
                ],
                [
                    83.5671223,
                    54.4117006
                ],
                [
                    83.566887,
                    54.4109131
                ],
                [
                    83.5617686,
                    54.410605
                ],
                [
                    83.5623275,
                    54.4100058
                ],
                [
                    83.56321,
                    54.4100743
                ],
                [
                    83.5630629,
                    54.40903
                ],
                [
                    83.5606214,
                    54.4078829
                ],
                [
                    83.5595918,
                    54.4078487
                ],
                [
                    83.5585917,
                    54.408756
                ],
                [
                    83.5579739,
                    54.4073179
                ],
                [
                    83.5552382,
                    54.4065646
                ],
                [
                    83.5561207,
                    54.4061879
                ],
                [
                    83.5574444,
                    54.4065646
                ],
                [
                    83.5583269,
                    54.4058284
                ],
                [
                    83.5576209,
                    54.4042361
                ],
                [
                    83.5570326,
                    54.4034313
                ],
                [
                    83.5549735,
                    54.4032944
                ],
                [
                    83.5549735,
                    54.4017704
                ],
                [
                    83.5552888,
                    54.4010852
                ],
                [
                    83.5554147,
                    54.4008115
                ],
                [
                    83.5543558,
                    54.4001608
                ],
                [
                    83.5551794,
                    54.3990478
                ],
                [
                    83.5590623,
                    54.3986197
                ],
                [
                    83.5635924,
                    54.3973182
                ],
                [
                    83.5642396,
                    54.3978319
                ],
                [
                    83.5746823,
                    54.4031574
                ],
                [
                    83.5759472,
                    54.4024211
                ],
                [
                    83.5750058,
                    54.401428
                ],
                [
                    83.5763002,
                    54.4004691
                ],
                [
                    83.5751235,
                    54.4000238
                ],
                [
                    83.5734468,
                    54.4006403
                ],
                [
                    83.5715347,
                    54.3996129
                ],
                [
                    83.5727114,
                    54.3992019
                ],
                [
                    83.5713582,
                    54.3985341
                ],
                [
                    83.570211,
                    54.3988937
                ],
                [
                    83.569358,
                    54.3985341
                ],
                [
                    83.5701228,
                    54.3976949
                ],
                [
                    83.5716818,
                    54.3980546
                ],
                [
                    83.5721231,
                    54.3965989
                ],
                [
                    83.5707405,
                    54.3961708
                ],
                [
                    83.5667399,
                    54.3959653
                ],
                [
                    83.5666223,
                    54.3957256
                ],
                [
                    83.571623,
                    54.39415
                ],
                [
                    83.5707699,
                    54.3925058
                ],
                [
                    83.5684461,
                    54.3928826
                ],
                [
                    83.5671223,
                    54.3938074
                ],
                [
                    83.5648867,
                    54.395246
                ],
                [
                    83.5627688,
                    54.3952632
                ],
                [
                    83.5594153,
                    54.3957084
                ],
                [
                    83.5587976,
                    54.3951433
                ],
                [
                    83.5608273,
                    54.3943726
                ],
                [
                    83.5601801,
                    54.393876
                ],
                [
                    83.5550029,
                    54.388909
                ],
                [
                    83.5531497,
                    54.3894057
                ],
                [
                    83.5501572,
                    54.389577
                ],
                [
                    83.5490733,
                    54.39269
                ],
                [
                    83.5551206,
                    54.394698
                ],
                [
                    83.5562972,
                    54.3955372
                ],
                [
                    83.5521201,
                    54.3948864
                ],
                [
                    83.5508645,
                    54.3950973
                ],
                [
                    83.5493103,
                    54.395765
                ],
                [
                    83.5496529,
                    54.3967823
                ],
                [
                    83.5488255,
                    54.3973011
                ],
                [
                    83.5465605,
                    54.3978319
                ]
            ],
            "longitude": 83.553047,
            "latitude": 54.402504
        },
        "3669": {
            "name": "Новомошковское",
            "population": 902,
            "type": "village",
            "poly": [
                [
                    83.5766997,
                    55.3297857
                ],
                [
                    83.5809374,
                    55.3311559
                ],
                [
                    83.579733,
                    55.3313843
                ],
                [
                    83.5785731,
                    55.3322724
                ],
                [
                    83.5796884,
                    55.3327799
                ],
                [
                    83.584283,
                    55.3322217
                ],
                [
                    83.5850859,
                    55.3319933
                ],
                [
                    83.5866918,
                    55.3331858
                ],
                [
                    83.5882977,
                    55.3340231
                ],
                [
                    83.5863795,
                    55.3351141
                ],
                [
                    83.5874055,
                    55.3354693
                ],
                [
                    83.5883422,
                    55.3349112
                ],
                [
                    83.5886545,
                    55.3349873
                ],
                [
                    83.589056,
                    55.3348097
                ],
                [
                    83.589279,
                    55.334835
                ],
                [
                    83.5895467,
                    55.3347336
                ],
                [
                    83.5895021,
                    55.3345052
                ],
                [
                    83.5899928,
                    55.3341246
                ],
                [
                    83.5910187,
                    55.3346067
                ],
                [
                    83.5897251,
                    55.3357738
                ],
                [
                    83.5918663,
                    55.3365603
                ],
                [
                    83.5914648,
                    55.3369155
                ],
                [
                    83.5945874,
                    55.3382347
                ],
                [
                    83.5954349,
                    55.3371692
                ],
                [
                    83.5966839,
                    55.3362305
                ],
                [
                    83.5988697,
                    55.3364588
                ],
                [
                    83.599628,
                    55.3366364
                ],
                [
                    83.5993158,
                    55.3361036
                ],
                [
                    83.5975761,
                    55.3354693
                ],
                [
                    83.5996726,
                    55.3340739
                ],
                [
                    83.5963717,
                    55.3335157
                ],
                [
                    83.5955687,
                    55.333262
                ],
                [
                    83.595658,
                    55.3330389
                ],
                [
                    83.5958364,
                    55.3329067
                ],
                [
                    83.5965501,
                    55.3329575
                ],
                [
                    83.5972637,
                    55.3327037
                ],
                [
                    83.6006986,
                    55.333262
                ],
                [
                    83.6022153,
                    55.3310798
                ],
                [
                    83.6008324,
                    55.3310037
                ],
                [
                    83.600431,
                    55.3310291
                ],
                [
                    83.5993604,
                    55.3308007
                ],
                [
                    83.5986913,
                    55.3303947
                ],
                [
                    83.5981113,
                    55.3302425
                ],
                [
                    83.5984682,
                    55.3299126
                ],
                [
                    83.5988697,
                    55.3300902
                ],
                [
                    83.5996726,
                    55.3304201
                ],
                [
                    83.6015016,
                    55.3308261
                ],
                [
                    83.6027952,
                    55.33075
                ],
                [
                    83.6035535,
                    55.3306992
                ],
                [
                    83.6035089,
                    55.3305216
                ],
                [
                    83.6027952,
                    55.3303947
                ],
                [
                    83.6021707,
                    55.329938
                ],
                [
                    83.6019922,
                    55.329329
                ],
                [
                    83.5968624,
                    55.3278825
                ],
                [
                    83.5963717,
                    55.3283393
                ],
                [
                    83.5949888,
                    55.3283139
                ],
                [
                    83.5936952,
                    55.3282632
                ],
                [
                    83.5927583,
                    55.3289229
                ],
                [
                    83.5915986,
                    55.3285169
                ],
                [
                    83.5907957,
                    55.3287707
                ],
                [
                    83.5897251,
                    55.3284408
                ],
                [
                    83.5899036,
                    55.3281109
                ],
                [
                    83.5885207,
                    55.3277049
                ],
                [
                    83.5875393,
                    55.3284662
                ],
                [
                    83.5828109,
                    55.3259793
                ],
                [
                    83.5824987,
                    55.3261061
                ],
                [
                    83.5812051,
                    55.3260046
                ],
                [
                    83.5808036,
                    55.326233
                ],
                [
                    83.579733,
                    55.3257509
                ],
                [
                    83.578484,
                    55.3260046
                ],
                [
                    83.5775026,
                    55.3267659
                ],
                [
                    83.5777257,
                    55.3268421
                ],
                [
                    83.5773688,
                    55.3270959
                ],
                [
                    83.5786624,
                    55.3276541
                ],
                [
                    83.5775472,
                    55.3285677
                ],
                [
                    83.5775026,
                    55.3287199
                ],
                [
                    83.5779041,
                    55.3288468
                ],
                [
                    83.5766997,
                    55.3297857
                ]
            ],
            "longitude": 83.589935,
            "latitude": 55.331535
        },
        "3670": {
            "name": "Мотково",
            "population": 293,
            "type": "village",
            "poly": [
                [
                    83.5816313,
                    55.1263496
                ],
                [
                    83.5816313,
                    55.1297205
                ],
                [
                    83.5824578,
                    55.1333746
                ],
                [
                    83.5902694,
                    55.1336502
                ],
                [
                    83.5958473,
                    55.1338471
                ],
                [
                    83.5982717,
                    55.1317681
                ],
                [
                    83.5985656,
                    55.1317549
                ],
                [
                    83.6027977,
                    55.1315644
                ],
                [
                    83.6078326,
                    55.1313379
                ],
                [
                    83.6101735,
                    55.1312326
                ],
                [
                    83.6111731,
                    55.1309849
                ],
                [
                    83.6167856,
                    55.1295945
                ],
                [
                    83.6252161,
                    55.1289644
                ],
                [
                    83.6294037,
                    55.1274838
                ],
                [
                    83.6252712,
                    55.1263181
                ],
                [
                    83.6195407,
                    55.1248058
                ],
                [
                    83.6154081,
                    55.1250579
                ],
                [
                    83.6112203,
                    55.12594
                ],
                [
                    83.6071981,
                    55.1276098
                ],
                [
                    83.6051042,
                    55.1285549
                ],
                [
                    83.6026798,
                    55.1289959
                ],
                [
                    83.5965636,
                    55.1284604
                ],
                [
                    83.5916596,
                    55.1277673
                ],
                [
                    83.5884638,
                    55.1267592
                ],
                [
                    83.5865353,
                    55.1255305
                ],
                [
                    83.5817966,
                    55.1247113
                ],
                [
                    83.5816313,
                    55.1263496
                ]
            ],
            "longitude": 83.605278,
            "latitude": 55.129715
        },
        "3671": {
            "name": "Красногорский",
            "population": 292,
            "type": "village",
            "poly": null,
            "longitude": 83.614517,
            "latitude": 55.391056
        },
        "3672": {
            "name": "Мошнино",
            "population": 373,
            "type": "village",
            "poly": [
                [
                    83.6149954,
                    55.2240312
                ],
                [
                    83.6175442,
                    55.2285668
                ],
                [
                    83.6192774,
                    55.2318809
                ],
                [
                    83.6198892,
                    55.231939
                ],
                [
                    83.6220302,
                    55.234032
                ],
                [
                    83.6270259,
                    55.2376362
                ],
                [
                    83.6417071,
                    55.231532
                ],
                [
                    83.6389544,
                    55.2293808
                ],
                [
                    83.6322255,
                    55.2279853
                ],
                [
                    83.6291669,
                    55.2253106
                ],
                [
                    83.6346724,
                    55.2237405
                ],
                [
                    83.6317157,
                    55.2212399
                ],
                [
                    83.6149954,
                    55.2240312
                ]
            ],
            "longitude": 83.630013,
            "latitude": 55.232655
        },
        "3673": {
            "name": "Белово",
            "population": 746,
            "type": "village",
            "poly": [
                [
                    83.6198011,
                    54.5330204
                ],
                [
                    83.6206041,
                    54.5341455
                ],
                [
                    83.6225721,
                    54.5346582
                ],
                [
                    83.622972,
                    54.5341418
                ],
                [
                    83.625291,
                    54.5350201
                ],
                [
                    83.6252095,
                    54.5357379
                ],
                [
                    83.6257048,
                    54.5356991
                ],
                [
                    83.6261065,
                    54.5350233
                ],
                [
                    83.6266018,
                    54.5347436
                ],
                [
                    83.6267759,
                    54.5349534
                ],
                [
                    83.6265483,
                    54.5351476
                ],
                [
                    83.6268294,
                    54.5353262
                ],
                [
                    83.6267491,
                    54.5356835
                ],
                [
                    83.6287974,
                    54.5372836
                ],
                [
                    83.6287841,
                    54.5376021
                ],
                [
                    83.6279808,
                    54.5380526
                ],
                [
                    83.6285431,
                    54.5386817
                ],
                [
                    83.6288644,
                    54.538573
                ],
                [
                    83.6317562,
                    54.5406234
                ],
                [
                    83.6323185,
                    54.5412059
                ],
                [
                    83.6324389,
                    54.5418971
                ],
                [
                    83.6308726,
                    54.5426116
                ],
                [
                    83.6316016,
                    54.5429436
                ],
                [
                    83.6320804,
                    54.5431561
                ],
                [
                    83.6327389,
                    54.5433246
                ],
                [
                    83.6328522,
                    54.5440987
                ],
                [
                    83.6325728,
                    54.5445454
                ],
                [
                    83.6333092,
                    54.5451278
                ],
                [
                    83.6346067,
                    54.5447145
                ],
                [
                    83.6347952,
                    54.5448948
                ],
                [
                    83.6358142,
                    54.5449255
                ],
                [
                    83.6364674,
                    54.5454472
                ],
                [
                    83.6371263,
                    54.5456188
                ],
                [
                    83.6381342,
                    54.5459073
                ],
                [
                    83.6386252,
                    54.5462113
                ],
                [
                    83.6382286,
                    54.5464742
                ],
                [
                    83.6384364,
                    54.5465893
                ],
                [
                    83.6387244,
                    54.5464003
                ],
                [
                    83.6391304,
                    54.5464551
                ],
                [
                    83.6391174,
                    54.5468679
                ],
                [
                    83.6395837,
                    54.5469261
                ],
                [
                    83.6397487,
                    54.5472711
                ],
                [
                    83.6402039,
                    54.5473022
                ],
                [
                    83.6410913,
                    54.5470472
                ],
                [
                    83.6415497,
                    54.5469438
                ],
                [
                    83.6414075,
                    54.5467142
                ],
                [
                    83.6417167,
                    54.5463878
                ],
                [
                    83.6421557,
                    54.5463197
                ],
                [
                    83.6424587,
                    54.5463663
                ],
                [
                    83.6430014,
                    54.5461796
                ],
                [
                    83.6449298,
                    54.5459898
                ],
                [
                    83.6446099,
                    54.5456411
                ],
                [
                    83.6441928,
                    54.5455342
                ],
                [
                    83.643507,
                    54.5455351
                ],
                [
                    83.6430418,
                    54.5451837
                ],
                [
                    83.6437785,
                    54.5447939
                ],
                [
                    83.6435275,
                    54.5443764
                ],
                [
                    83.643037,
                    54.5440873
                ],
                [
                    83.6425869,
                    54.5431009
                ],
                [
                    83.6427208,
                    54.5429456
                ],
                [
                    83.6431894,
                    54.5429145
                ],
                [
                    83.6446708,
                    54.5423329
                ],
                [
                    83.6447826,
                    54.5419981
                ],
                [
                    83.6468362,
                    54.5415322
                ],
                [
                    83.6469796,
                    54.5403187
                ],
                [
                    83.6458402,
                    54.5399399
                ],
                [
                    83.6456393,
                    54.5396603
                ],
                [
                    83.6433501,
                    54.5379361
                ],
                [
                    83.6434304,
                    54.5373613
                ],
                [
                    83.6422348,
                    54.5372007
                ],
                [
                    83.6407423,
                    54.5366702
                ],
                [
                    83.6414087,
                    54.5360952
                ],
                [
                    83.6422693,
                    54.5346331
                ],
                [
                    83.6428587,
                    54.5341394
                ],
                [
                    83.6407126,
                    54.533392
                ],
                [
                    83.6388127,
                    54.5352982
                ],
                [
                    83.6381868,
                    54.5351166
                ],
                [
                    83.6384247,
                    54.5348697
                ],
                [
                    83.6377238,
                    54.5346156
                ],
                [
                    83.6376862,
                    54.5349641
                ],
                [
                    83.6372291,
                    54.5348357
                ],
                [
                    83.6363591,
                    54.5351837
                ],
                [
                    83.6368889,
                    54.535642
                ],
                [
                    83.6376925,
                    54.536097
                ],
                [
                    83.6383731,
                    54.5365898
                ],
                [
                    83.6382493,
                    54.5370428
                ],
                [
                    83.6377437,
                    54.5367607
                ],
                [
                    83.6375673,
                    54.5364819
                ],
                [
                    83.637536,
                    54.536264
                ],
                [
                    83.6373045,
                    54.5361442
                ],
                [
                    83.6358276,
                    54.5363729
                ],
                [
                    83.6357355,
                    54.5361428
                ],
                [
                    83.636322,
                    54.5354434
                ],
                [
                    83.6361347,
                    54.5352691
                ],
                [
                    83.6349767,
                    54.535018
                ],
                [
                    83.6343645,
                    54.5354258
                ],
                [
                    83.6333741,
                    54.5353168
                ],
                [
                    83.6314949,
                    54.5344769
                ],
                [
                    83.6310182,
                    54.5340784
                ],
                [
                    83.6284983,
                    54.5326115
                ],
                [
                    83.6274804,
                    54.5323901
                ],
                [
                    83.626717,
                    54.5322553
                ],
                [
                    83.625964,
                    54.5323233
                ],
                [
                    83.6256463,
                    54.532418
                ],
                [
                    83.6252614,
                    54.5323694
                ],
                [
                    83.6248598,
                    54.5324957
                ],
                [
                    83.6240231,
                    54.5324277
                ],
                [
                    83.623839,
                    54.5323112
                ],
                [
                    83.6234039,
                    54.5323306
                ],
                [
                    83.6228864,
                    54.5326558
                ],
                [
                    83.6225504,
                    54.5314955
                ],
                [
                    83.6228851,
                    54.5306507
                ],
                [
                    83.6235545,
                    54.5308643
                ],
                [
                    83.624341,
                    54.5307963
                ],
                [
                    83.6250235,
                    54.5304595
                ],
                [
                    83.6261317,
                    54.5299127
                ],
                [
                    83.6275541,
                    54.5298835
                ],
                [
                    83.6287256,
                    54.5289804
                ],
                [
                    83.6308843,
                    54.5294271
                ],
                [
                    83.6309513,
                    54.5283492
                ],
                [
                    83.6305831,
                    54.52765
                ],
                [
                    83.6313027,
                    54.5266303
                ],
                [
                    83.6307839,
                    54.5240663
                ],
                [
                    83.6322566,
                    54.5231048
                ],
                [
                    83.6308761,
                    54.5222888
                ],
                [
                    83.6295662,
                    54.5237016
                ],
                [
                    83.6282875,
                    54.5237305
                ],
                [
                    83.6281013,
                    54.5260584
                ],
                [
                    83.6291054,
                    54.5264624
                ],
                [
                    83.6302032,
                    54.5278297
                ],
                [
                    83.6294534,
                    54.528762
                ],
                [
                    83.6286636,
                    54.5286144
                ],
                [
                    83.6277398,
                    54.5291039
                ],
                [
                    83.6264813,
                    54.5291039
                ],
                [
                    83.6252497,
                    54.5293058
                ],
                [
                    83.6245944,
                    54.5292359
                ],
                [
                    83.6243484,
                    54.5292444
                ],
                [
                    83.621568,
                    54.529469
                ],
                [
                    83.620497,
                    54.5302614
                ],
                [
                    83.6203978,
                    54.5312229
                ],
                [
                    83.6206646,
                    54.5319315
                ],
                [
                    83.6202828,
                    54.5324987
                ],
                [
                    83.6198011,
                    54.5330204
                ]
            ],
            "longitude": 83.632385,
            "latitude": 54.538097
        },
        "3674": {
            "name": "Льниха",
            "population": 589,
            "type": "village",
            "poly": [
                [
                    83.6191771,
                    55.119237
                ],
                [
                    83.6200752,
                    55.1197672
                ],
                [
                    83.6216266,
                    55.1197302
                ],
                [
                    83.6221438,
                    55.1207837
                ],
                [
                    83.6355981,
                    55.1236914
                ],
                [
                    83.6365678,
                    55.1235384
                ],
                [
                    83.640105,
                    55.1233685
                ],
                [
                    83.6392915,
                    55.1205586
                ],
                [
                    83.6402432,
                    55.1180482
                ],
                [
                    83.6379161,
                    55.1177155
                ],
                [
                    83.6372697,
                    55.1181406
                ],
                [
                    83.633262,
                    55.1178449
                ],
                [
                    83.6314844,
                    55.1174382
                ],
                [
                    83.6271211,
                    55.1173458
                ],
                [
                    83.6257959,
                    55.1177155
                ],
                [
                    83.6226609,
                    55.1170871
                ],
                [
                    83.6218852,
                    55.1154974
                ],
                [
                    83.6200223,
                    55.1153947
                ],
                [
                    83.6201399,
                    55.1168468
                ],
                [
                    83.619849,
                    55.1177155
                ],
                [
                    83.6200429,
                    55.1185842
                ],
                [
                    83.6194935,
                    55.1185658
                ],
                [
                    83.6191771,
                    55.119237
                ]
            ],
            "longitude": 83.632507,
            "latitude": 55.119781
        },
        "3675": {
            "name": "Лекарственное",
            "population": 728,
            "type": "village",
            "poly": [
                [
                    83.6334153,
                    54.9980453
                ],
                [
                    83.6390127,
                    55.0014163
                ],
                [
                    83.6453793,
                    55.0034236
                ],
                [
                    83.6507604,
                    55.0044782
                ],
                [
                    83.6507095,
                    55.0055151
                ],
                [
                    83.6517536,
                    55.0058072
                ],
                [
                    83.6525176,
                    55.0053399
                ],
                [
                    83.6555324,
                    55.0061822
                ],
                [
                    83.6603571,
                    55.0067208
                ],
                [
                    83.6614594,
                    55.0059037
                ],
                [
                    83.6568931,
                    55.0032642
                ],
                [
                    83.6554869,
                    55.0027107
                ],
                [
                    83.6545632,
                    55.0021256
                ],
                [
                    83.6551147,
                    55.0017223
                ],
                [
                    83.6544943,
                    55.0015484
                ],
                [
                    83.6542048,
                    55.0010897
                ],
                [
                    83.6529227,
                    55.0005758
                ],
                [
                    83.6526608,
                    55.0007497
                ],
                [
                    83.6518887,
                    55.0004255
                ],
                [
                    83.6516405,
                    55.0007734
                ],
                [
                    83.6514889,
                    55.0005441
                ],
                [
                    83.6497932,
                    55.0001409
                ],
                [
                    83.6497105,
                    55.0003069
                ],
                [
                    83.648511,
                    54.9999669
                ],
                [
                    83.6484973,
                    54.9998008
                ],
                [
                    83.6476701,
                    54.9995873
                ],
                [
                    83.6464156,
                    54.9996269
                ],
                [
                    83.6445958,
                    54.9992157
                ],
                [
                    83.6437825,
                    54.9992394
                ],
                [
                    83.6435067,
                    54.9996743
                ],
                [
                    83.6406254,
                    54.9982589
                ],
                [
                    83.6407495,
                    54.9981165
                ],
                [
                    83.6369445,
                    54.9962423
                ],
                [
                    83.6359795,
                    54.9969224
                ],
                [
                    83.635428,
                    54.9966535
                ],
                [
                    83.6350972,
                    54.9968354
                ],
                [
                    83.6344354,
                    54.9970885
                ],
                [
                    83.634463,
                    54.9973415
                ],
                [
                    83.6334153,
                    54.9980453
                ]
            ],
            "longitude": 83.649857,
            "latitude": 55.002598
        },
        "3676": {
            "name": "Гусельниково",
            "population": 864,
            "type": "village",
            "poly": [
                [
                    83.678058,
                    54.5165385
                ],
                [
                    83.6799278,
                    54.5174173
                ],
                [
                    83.6790783,
                    54.5179903
                ],
                [
                    83.6805518,
                    54.5187025
                ],
                [
                    83.6848307,
                    54.5193177
                ],
                [
                    83.6828469,
                    54.521508
                ],
                [
                    83.6908268,
                    54.5240057
                ],
                [
                    83.6943049,
                    54.5250502
                ],
                [
                    83.6976878,
                    54.526713
                ],
                [
                    83.698805,
                    54.5277915
                ],
                [
                    83.7028813,
                    54.5281987
                ],
                [
                    83.707386,
                    54.5268669
                ],
                [
                    83.7082245,
                    54.5259261
                ],
                [
                    83.7064357,
                    54.524158
                ],
                [
                    83.7042834,
                    54.5256179
                ],
                [
                    83.7032492,
                    54.5246284
                ],
                [
                    83.7014045,
                    54.5238173
                ],
                [
                    83.7001187,
                    54.5210433
                ],
                [
                    83.7020753,
                    54.519859
                ],
                [
                    83.7038642,
                    54.5197617
                ],
                [
                    83.7046468,
                    54.5182042
                ],
                [
                    83.7024386,
                    54.5168893
                ],
                [
                    83.6985255,
                    54.5189829
                ],
                [
                    83.6972677,
                    54.5184638
                ],
                [
                    83.6988329,
                    54.517539
                ],
                [
                    83.6996994,
                    54.5166791
                ],
                [
                    83.6988609,
                    54.5152026
                ],
                [
                    83.697072,
                    54.5140019
                ],
                [
                    83.6983857,
                    54.5136612
                ],
                [
                    83.7046733,
                    54.5145222
                ],
                [
                    83.705681,
                    54.5128174
                ],
                [
                    83.705189,
                    54.5112734
                ],
                [
                    83.7023625,
                    54.5109049
                ],
                [
                    83.70443,
                    54.5085401
                ],
                [
                    83.7116681,
                    54.5048395
                ],
                [
                    83.7102929,
                    54.5037135
                ],
                [
                    83.7038642,
                    54.5065374
                ],
                [
                    83.7031654,
                    54.5060505
                ],
                [
                    83.7021032,
                    54.5061966
                ],
                [
                    83.7003982,
                    54.506651
                ],
                [
                    83.6974899,
                    54.505695
                ],
                [
                    83.6912582,
                    54.5091663
                ],
                [
                    83.6914259,
                    54.5108864
                ],
                [
                    83.690748,
                    54.5118069
                ],
                [
                    83.6905099,
                    54.5132499
                ],
                [
                    83.6887672,
                    54.5133473
                ],
                [
                    83.6891059,
                    54.5147321
                ],
                [
                    83.6883233,
                    54.5148132
                ],
                [
                    83.6834318,
                    54.5145374
                ],
                [
                    83.684472,
                    54.5122143
                ],
                [
                    83.685081,
                    54.510854
                ],
                [
                    83.6839629,
                    54.5099128
                ],
                [
                    83.6804814,
                    54.5090379
                ],
                [
                    83.678058,
                    54.5165385
                ]
            ],
            "longitude": 83.692986,
            "latitude": 54.519867
        },
        "3677": {
            "name": "Карпысак",
            "population": 685,
            "type": "village",
            "poly": [
                [
                    83.6925283,
                    55.0318524
                ],
                [
                    83.6930199,
                    55.0331202
                ],
                [
                    83.6938956,
                    55.033895
                ],
                [
                    83.6975518,
                    55.0354885
                ],
                [
                    83.6993338,
                    55.0348898
                ],
                [
                    83.6997793,
                    55.0351099
                ],
                [
                    83.6989344,
                    55.0355677
                ],
                [
                    83.69981,
                    55.0362368
                ],
                [
                    83.6989958,
                    55.0366153
                ],
                [
                    83.6980895,
                    55.0361487
                ],
                [
                    83.6970404,
                    55.0369091
                ],
                [
                    83.697644,
                    55.0372932
                ],
                [
                    83.6974135,
                    55.0374428
                ],
                [
                    83.6988729,
                    55.0382439
                ],
                [
                    83.6990986,
                    55.0388216
                ],
                [
                    83.7030402,
                    55.0399701
                ],
                [
                    83.7041574,
                    55.0391858
                ],
                [
                    83.7052022,
                    55.0396348
                ],
                [
                    83.7048028,
                    55.0400309
                ],
                [
                    83.7092271,
                    55.0416593
                ],
                [
                    83.7114239,
                    55.0404446
                ],
                [
                    83.7124224,
                    55.0407439
                ],
                [
                    83.7117619,
                    55.0415889
                ],
                [
                    83.7123841,
                    55.041898
                ],
                [
                    83.7099952,
                    55.0434462
                ],
                [
                    83.7118079,
                    55.0449601
                ],
                [
                    83.7120384,
                    55.0451625
                ],
                [
                    83.7126529,
                    55.0449953
                ],
                [
                    83.7131136,
                    55.0453561
                ],
                [
                    83.7135285,
                    55.0453209
                ],
                [
                    83.7149111,
                    55.0462715
                ],
                [
                    83.7136821,
                    55.046914
                ],
                [
                    83.7125761,
                    55.0464739
                ],
                [
                    83.7103137,
                    55.0482766
                ],
                [
                    83.7117563,
                    55.0491761
                ],
                [
                    83.7131008,
                    55.0499021
                ],
                [
                    83.714512,
                    55.0496153
                ],
                [
                    83.7165707,
                    55.0496769
                ],
                [
                    83.7179122,
                    55.0491351
                ],
                [
                    83.719887,
                    55.0503474
                ],
                [
                    83.7211971,
                    55.0511515
                ],
                [
                    83.7221779,
                    55.0508738
                ],
                [
                    83.723753,
                    55.0518002
                ],
                [
                    83.7258807,
                    55.0511426
                ],
                [
                    83.7268605,
                    55.05041
                ],
                [
                    83.7263433,
                    55.0501592
                ],
                [
                    83.72788,
                    55.0491922
                ],
                [
                    83.7287718,
                    55.0485823
                ],
                [
                    83.7276745,
                    55.0479079
                ],
                [
                    83.7248843,
                    55.0495901
                ],
                [
                    83.7241662,
                    55.0476489
                ],
                [
                    83.7227069,
                    55.0467864
                ],
                [
                    83.7240621,
                    55.0463644
                ],
                [
                    83.722205,
                    55.0447794
                ],
                [
                    83.7238344,
                    55.043041
                ],
                [
                    83.7257464,
                    55.0418156
                ],
                [
                    83.7261841,
                    55.0412912
                ],
                [
                    83.7236801,
                    55.0402845
                ],
                [
                    83.7226784,
                    55.0409411
                ],
                [
                    83.7210511,
                    55.0411088
                ],
                [
                    83.7195138,
                    55.03992
                ],
                [
                    83.7175013,
                    55.0376928
                ],
                [
                    83.7165435,
                    55.0357293
                ],
                [
                    83.7145787,
                    55.0345026
                ],
                [
                    83.7138451,
                    55.0350166
                ],
                [
                    83.7165335,
                    55.0376576
                ],
                [
                    83.7134457,
                    55.0385996
                ],
                [
                    83.7127544,
                    55.0380274
                ],
                [
                    83.7122628,
                    55.0381946
                ],
                [
                    83.7120477,
                    55.038758
                ],
                [
                    83.7120477,
                    55.0397351
                ],
                [
                    83.7103425,
                    55.0389693
                ],
                [
                    83.7096666,
                    55.0393566
                ],
                [
                    83.7087141,
                    55.0389957
                ],
                [
                    83.7093132,
                    55.038758
                ],
                [
                    83.7072393,
                    55.0376224
                ],
                [
                    83.7073592,
                    55.0371393
                ],
                [
                    83.7042744,
                    55.0357825
                ],
                [
                    83.7037521,
                    55.0350694
                ],
                [
                    83.703153,
                    55.0346732
                ],
                [
                    83.7032277,
                    55.034505
                ],
                [
                    83.702318,
                    55.0338522
                ],
                [
                    83.7005693,
                    55.033087
                ],
                [
                    83.7005729,
                    55.0327685
                ],
                [
                    83.6979794,
                    55.0317123
                ],
                [
                    83.6984176,
                    55.0313763
                ],
                [
                    83.6981609,
                    55.0312193
                ],
                [
                    83.6975039,
                    55.0315186
                ],
                [
                    83.6945364,
                    55.0302362
                ],
                [
                    83.6925283,
                    55.0318524
                ]
            ],
            "longitude": 83.712883,
            "latitude": 55.039745
        },
        "3678": {
            "name": "Листвянка",
            "population": 538,
            "type": "village",
            "poly": [
                [
                    83.7094654,
                    54.1505832
                ],
                [
                    83.7103382,
                    54.1506815
                ],
                [
                    83.7095326,
                    54.1523525
                ],
                [
                    83.7134936,
                    54.1533747
                ],
                [
                    83.7159388,
                    54.1538169
                ],
                [
                    83.7182939,
                    54.1551242
                ],
                [
                    83.7185624,
                    54.156166
                ],
                [
                    83.7164476,
                    54.1571685
                ],
                [
                    83.716649,
                    54.1588393
                ],
                [
                    83.718126,
                    54.1591734
                ],
                [
                    83.720308,
                    54.1583282
                ],
                [
                    83.7201066,
                    54.1599007
                ],
                [
                    83.7214493,
                    54.159881
                ],
                [
                    83.722792,
                    54.1619054
                ],
                [
                    83.7242019,
                    54.1622592
                ],
                [
                    83.7271559,
                    54.1596648
                ],
                [
                    83.7226912,
                    54.1579744
                ],
                [
                    83.7276928,
                    54.1556746
                ],
                [
                    83.7293713,
                    54.1539055
                ],
                [
                    83.7291699,
                    54.150996
                ],
                [
                    83.7257124,
                    54.1505045
                ],
                [
                    83.7250075,
                    54.1509567
                ],
                [
                    83.7241346,
                    54.1522345
                ],
                [
                    83.7232955,
                    54.1522935
                ],
                [
                    83.7224899,
                    54.1514875
                ],
                [
                    83.7229598,
                    54.1501703
                ],
                [
                    83.7231277,
                    54.1485779
                ],
                [
                    83.7225235,
                    54.148106
                ],
                [
                    83.7230941,
                    54.1470443
                ],
                [
                    83.7237319,
                    54.1471623
                ],
                [
                    83.7273237,
                    54.1440754
                ],
                [
                    83.7230605,
                    54.1439574
                ],
                [
                    83.7141314,
                    54.1437215
                ],
                [
                    83.7110096,
                    54.1480274
                ],
                [
                    83.709969,
                    54.1483223
                ],
                [
                    83.7094654,
                    54.1505832
                ]
            ],
            "longitude": 83.716469,
            "latitude": 54.151337
        },
        "3679": {
            "name": "Усть-Чем",
            "population": 526,
            "type": "village",
            "poly": [
                [
                    83.7104324,
                    54.6619608
                ],
                [
                    83.7134448,
                    54.6628966
                ],
                [
                    83.7182961,
                    54.6630682
                ],
                [
                    83.7228433,
                    54.6639581
                ],
                [
                    83.7247238,
                    54.6634241
                ],
                [
                    83.7298523,
                    54.6659948
                ],
                [
                    83.7319721,
                    54.6668648
                ],
                [
                    83.7349808,
                    54.6697911
                ],
                [
                    83.7363484,
                    54.6731522
                ],
                [
                    83.7420239,
                    54.6712344
                ],
                [
                    83.7438702,
                    54.6728556
                ],
                [
                    83.7475969,
                    54.6717089
                ],
                [
                    83.744725,
                    54.6700481
                ],
                [
                    83.7437676,
                    54.6705029
                ],
                [
                    83.7425954,
                    54.6700329
                ],
                [
                    83.7375792,
                    54.6674382
                ],
                [
                    83.7369797,
                    54.6669444
                ],
                [
                    83.7358697,
                    54.6653027
                ],
                [
                    83.7360407,
                    54.6635823
                ],
                [
                    83.7336132,
                    54.661585
                ],
                [
                    83.7405196,
                    54.6611895
                ],
                [
                    83.7413401,
                    54.6603392
                ],
                [
                    83.7407247,
                    54.6596074
                ],
                [
                    83.7421949,
                    54.658935
                ],
                [
                    83.7442805,
                    54.6594888
                ],
                [
                    83.7467232,
                    54.6578302
                ],
                [
                    83.7470157,
                    54.6568782
                ],
                [
                    83.7428787,
                    54.6549003
                ],
                [
                    83.7373057,
                    54.655909
                ],
                [
                    83.7327243,
                    54.6567199
                ],
                [
                    83.7333397,
                    54.6577484
                ],
                [
                    83.7307855,
                    54.6588167
                ],
                [
                    83.7291313,
                    54.6581606
                ],
                [
                    83.7267005,
                    54.6584513
                ],
                [
                    83.7245703,
                    54.6584803
                ],
                [
                    83.7223974,
                    54.6578527
                ],
                [
                    83.72069,
                    54.6569063
                ],
                [
                    83.717683,
                    54.6578414
                ],
                [
                    83.7158002,
                    54.6584801
                ],
                [
                    83.7104324,
                    54.6619608
                ]
            ],
            "longitude": 83.729034,
            "latitude": 54.662395
        },
        "3680": {
            "name": "Радуга",
            "population": 630,
            "type": "village",
            "poly": [
                [
                    83.7205612,
                    55.5001016
                ],
                [
                    83.7241805,
                    55.5044723
                ],
                [
                    83.7278341,
                    55.5054824
                ],
                [
                    83.7311101,
                    55.5061503
                ],
                [
                    83.7391037,
                    55.5064472
                ],
                [
                    83.744673,
                    55.5038126
                ],
                [
                    83.7443454,
                    55.50192
                ],
                [
                    83.7377933,
                    55.5006212
                ],
                [
                    83.7390382,
                    55.4963903
                ],
                [
                    83.7365484,
                    55.4951284
                ],
                [
                    83.7269823,
                    55.4969099
                ],
                [
                    83.7220027,
                    55.497912
                ],
                [
                    83.7205612,
                    55.5001016
                ]
            ],
            "longitude": 83.734474,
            "latitude": 55.497631
        },
        "3681": {
            "name": "Огнева Заимка",
            "population": 927,
            "type": "village",
            "poly": [
                [
                    83.7229175,
                    54.2959223
                ],
                [
                    83.7230522,
                    54.2994597
                ],
                [
                    83.7331102,
                    54.2987522
                ],
                [
                    83.7385882,
                    54.2978351
                ],
                [
                    83.7387678,
                    54.2967084
                ],
                [
                    83.7468052,
                    54.2960795
                ],
                [
                    83.7525526,
                    54.2982282
                ],
                [
                    83.7546629,
                    54.2947692
                ],
                [
                    83.7548875,
                    54.2925417
                ],
                [
                    83.7508912,
                    54.2912576
                ],
                [
                    83.7513852,
                    54.2890299
                ],
                [
                    83.7536751,
                    54.2885843
                ],
                [
                    83.7497687,
                    54.284312
                ],
                [
                    83.7449642,
                    54.2808781
                ],
                [
                    83.7414619,
                    54.2809567
                ],
                [
                    83.738169,
                    54.2843454
                ],
                [
                    83.7367472,
                    54.2853605
                ],
                [
                    83.7351307,
                    54.2864089
                ],
                [
                    83.7339633,
                    54.2907334
                ],
                [
                    83.7309998,
                    54.2906548
                ],
                [
                    83.7296528,
                    54.2910479
                ],
                [
                    83.7292936,
                    54.2934852
                ],
                [
                    83.7268689,
                    54.2941403
                ],
                [
                    83.7234564,
                    54.2950837
                ],
                [
                    83.7229175,
                    54.2959223
                ]
            ],
            "longitude": 83.740364,
            "latitude": 54.287239
        },
        "3682": {
            "name": "Сарапулка",
            "population": 941,
            "type": "village",
            "poly": [
                [
                    83.7308337,
                    55.1528803
                ],
                [
                    83.7310876,
                    55.1534105
                ],
                [
                    83.7318089,
                    55.1538946
                ],
                [
                    83.7337669,
                    55.1543437
                ],
                [
                    83.7330014,
                    55.1552589
                ],
                [
                    83.734189,
                    55.1556019
                ],
                [
                    83.7359936,
                    55.1557522
                ],
                [
                    83.7379396,
                    55.1557482
                ],
                [
                    83.7370411,
                    55.1565833
                ],
                [
                    83.7378974,
                    55.156849
                ],
                [
                    83.7365517,
                    55.158149
                ],
                [
                    83.7356876,
                    55.1585235
                ],
                [
                    83.7391105,
                    55.1621637
                ],
                [
                    83.7434029,
                    55.1641317
                ],
                [
                    83.7472152,
                    55.1649156
                ],
                [
                    83.7516671,
                    55.1619585
                ],
                [
                    83.7536949,
                    55.1618965
                ],
                [
                    83.7579136,
                    55.1635687
                ],
                [
                    83.7608409,
                    55.1640113
                ],
                [
                    83.7671258,
                    55.1624867
                ],
                [
                    83.770914,
                    55.1580109
                ],
                [
                    83.7671258,
                    55.1556498
                ],
                [
                    83.7633376,
                    55.1562401
                ],
                [
                    83.7574832,
                    55.1561417
                ],
                [
                    83.7539511,
                    55.1556372
                ],
                [
                    83.7526618,
                    55.1554531
                ],
                [
                    83.7477544,
                    55.1544692
                ],
                [
                    83.7429331,
                    55.1526491
                ],
                [
                    83.7385016,
                    55.1516279
                ],
                [
                    83.7369669,
                    55.1521457
                ],
                [
                    83.7328366,
                    55.151267
                ],
                [
                    83.7319199,
                    55.1524116
                ],
                [
                    83.7308337,
                    55.1528803
                ]
            ],
            "longitude": 83.750015,
            "latitude": 55.158222
        },
        "3683": {
            "name": "Новобибеево",
            "population": 493,
            "type": "village",
            "poly": [
                [
                    83.7378348,
                    55.6889582
                ],
                [
                    83.7434558,
                    55.6948504
                ],
                [
                    83.7460166,
                    55.6972722
                ],
                [
                    83.7497101,
                    55.7001291
                ],
                [
                    83.7501252,
                    55.7016862
                ],
                [
                    83.7460303,
                    55.7015236
                ],
                [
                    83.7449296,
                    55.7029054
                ],
                [
                    83.744281,
                    55.7028233
                ],
                [
                    83.7452849,
                    55.703548
                ],
                [
                    83.7471488,
                    55.7030076
                ],
                [
                    83.7484925,
                    55.7039535
                ],
                [
                    83.7459104,
                    55.7053988
                ],
                [
                    83.7487541,
                    55.706311
                ],
                [
                    83.7504728,
                    55.7061413
                ],
                [
                    83.7513518,
                    55.7066261
                ],
                [
                    83.7527769,
                    55.70687
                ],
                [
                    83.7496447,
                    55.7034203
                ],
                [
                    83.7579631,
                    55.7019627
                ],
                [
                    83.7578187,
                    55.6979302
                ],
                [
                    83.749171,
                    55.6892131
                ],
                [
                    83.7433944,
                    55.6875933
                ],
                [
                    83.7378348,
                    55.6889582
                ]
            ],
            "longitude": 83.7505327,
            "latitude": 55.6966012
        },
        "3684": {
            "name": "Буготак",
            "population": 522,
            "type": "village",
            "poly": [
                [
                    83.7518422,
                    55.1424875
                ],
                [
                    83.7545652,
                    55.1440057
                ],
                [
                    83.7567399,
                    55.1446391
                ],
                [
                    83.7579663,
                    55.1447943
                ],
                [
                    83.7582529,
                    55.1448315
                ],
                [
                    83.7586561,
                    55.1448379
                ],
                [
                    83.7594122,
                    55.144688
                ],
                [
                    83.7601739,
                    55.1448327
                ],
                [
                    83.7598364,
                    55.1455113
                ],
                [
                    83.7607716,
                    55.1467912
                ],
                [
                    83.760747,
                    55.1471147
                ],
                [
                    83.7618545,
                    55.1474382
                ],
                [
                    83.7619282,
                    55.1472413
                ],
                [
                    83.7653985,
                    55.1475648
                ],
                [
                    83.7661122,
                    55.1475789
                ],
                [
                    83.766826,
                    55.1472132
                ],
                [
                    83.7693363,
                    55.1470585
                ],
                [
                    83.7693855,
                    55.1467069
                ],
                [
                    83.7712314,
                    55.1466365
                ],
                [
                    83.7729049,
                    55.1460177
                ],
                [
                    83.7736925,
                    55.1464818
                ],
                [
                    83.7744958,
                    55.1464644
                ],
                [
                    83.7812373,
                    55.1448171
                ],
                [
                    83.7855531,
                    55.144484
                ],
                [
                    83.7901525,
                    55.1439709
                ],
                [
                    83.7910503,
                    55.1436288
                ],
                [
                    83.7907353,
                    55.1432687
                ],
                [
                    83.7892203,
                    55.143189
                ],
                [
                    83.7866901,
                    55.1427125
                ],
                [
                    83.7861011,
                    55.1425581
                ],
                [
                    83.7852696,
                    55.1418643
                ],
                [
                    83.7816626,
                    55.1422244
                ],
                [
                    83.780875,
                    55.1424045
                ],
                [
                    83.7807963,
                    55.1426386
                ],
                [
                    83.7800402,
                    55.1428546
                ],
                [
                    83.7771578,
                    55.1428366
                ],
                [
                    83.7758977,
                    55.1434308
                ],
                [
                    83.7751889,
                    55.1429176
                ],
                [
                    83.7744643,
                    55.1430437
                ],
                [
                    83.7743383,
                    55.1427736
                ],
                [
                    83.7734877,
                    55.1429626
                ],
                [
                    83.7726057,
                    55.1427106
                ],
                [
                    83.7714086,
                    55.1430437
                ],
                [
                    83.7725112,
                    55.1440069
                ],
                [
                    83.7720858,
                    55.1440069
                ],
                [
                    83.7718339,
                    55.1436648
                ],
                [
                    83.7711093,
                    55.1436648
                ],
                [
                    83.7710148,
                    55.1435478
                ],
                [
                    83.7696444,
                    55.1435928
                ],
                [
                    83.7696759,
                    55.1431517
                ],
                [
                    83.7678977,
                    55.1428204
                ],
                [
                    83.766825,
                    55.1426206
                ],
                [
                    83.767077,
                    55.1422425
                ],
                [
                    83.7667904,
                    55.1421855
                ],
                [
                    83.7659902,
                    55.1420264
                ],
                [
                    83.7649506,
                    55.1429716
                ],
                [
                    83.7641315,
                    55.1427376
                ],
                [
                    83.763281,
                    55.1435208
                ],
                [
                    83.7621311,
                    55.1431787
                ],
                [
                    83.7617372,
                    55.1427196
                ],
                [
                    83.76043,
                    55.1423865
                ],
                [
                    83.7603512,
                    55.1425485
                ],
                [
                    83.7586029,
                    55.1421344
                ],
                [
                    83.7582247,
                    55.1423775
                ],
                [
                    83.7575948,
                    55.1423055
                ],
                [
                    83.7572955,
                    55.1425305
                ],
                [
                    83.756949,
                    55.1424495
                ],
                [
                    83.757075,
                    55.1421884
                ],
                [
                    83.7564607,
                    55.1419634
                ],
                [
                    83.7561142,
                    55.1420984
                ],
                [
                    83.7542555,
                    55.1410991
                ],
                [
                    83.7536642,
                    55.1416646
                ],
                [
                    83.7534837,
                    55.1418373
                ],
                [
                    83.7527907,
                    55.1416123
                ],
                [
                    83.7518422,
                    55.1424875
                ]
            ],
            "longitude": 83.7693546,
            "latitude": 55.1450361
        },
        "3685": {
            "name": "Буготак",
            "population": 799,
            "type": "village",
            "poly": [
                [
                    83.7902162,
                    55.1361743
                ],
                [
                    83.7939066,
                    55.1422659
                ],
                [
                    83.7933732,
                    55.1439428
                ],
                [
                    83.7959812,
                    55.1445695
                ],
                [
                    83.7956255,
                    55.1450776
                ],
                [
                    83.7965147,
                    55.1451284
                ],
                [
                    83.7959812,
                    55.1456027
                ],
                [
                    83.797728,
                    55.1466584
                ],
                [
                    83.801584,
                    55.1489112
                ],
                [
                    83.8083993,
                    55.1551373
                ],
                [
                    83.8135568,
                    55.1597428
                ],
                [
                    83.8136667,
                    55.1597184
                ],
                [
                    83.8140462,
                    55.159964
                ],
                [
                    83.8148664,
                    55.160161
                ],
                [
                    83.8152943,
                    55.1601779
                ],
                [
                    83.8163046,
                    55.160969
                ],
                [
                    83.8169643,
                    55.1607178
                ],
                [
                    83.8168455,
                    55.1605616
                ],
                [
                    83.8177964,
                    55.1601508
                ],
                [
                    83.8182421,
                    55.1605141
                ],
                [
                    83.8193594,
                    55.1599708
                ],
                [
                    83.8190979,
                    55.1597162
                ],
                [
                    83.8192168,
                    55.1596313
                ],
                [
                    83.8187948,
                    55.1590813
                ],
                [
                    83.8166731,
                    55.1596381
                ],
                [
                    83.8151398,
                    55.1600557
                ],
                [
                    83.8143731,
                    55.1599403
                ],
                [
                    83.8138739,
                    55.15974
                ],
                [
                    83.8138206,
                    55.1596842
                ],
                [
                    83.8140896,
                    55.1596244
                ],
                [
                    83.8158086,
                    55.1589133
                ],
                [
                    83.8144748,
                    55.1574741
                ],
                [
                    83.8126077,
                    55.1561194
                ],
                [
                    83.8133783,
                    55.1558824
                ],
                [
                    83.8132004,
                    55.1555607
                ],
                [
                    83.8120743,
                    55.1558655
                ],
                [
                    83.8118668,
                    55.1556453
                ],
                [
                    83.812341,
                    55.1554591
                ],
                [
                    83.8118965,
                    55.1548833
                ],
                [
                    83.8162394,
                    55.153772
                ],
                [
                    83.811723,
                    55.1463212
                ],
                [
                    83.8131412,
                    55.1448574
                ],
                [
                    83.8124965,
                    55.1434631
                ],
                [
                    83.8060876,
                    55.1424014
                ],
                [
                    83.803924,
                    55.1422489
                ],
                [
                    83.8022051,
                    55.1426724
                ],
                [
                    83.7985894,
                    55.1432822
                ],
                [
                    83.7974039,
                    55.1432144
                ],
                [
                    83.8011678,
                    55.1415883
                ],
                [
                    83.8020273,
                    55.1402331
                ],
                [
                    83.8007529,
                    55.1404703
                ],
                [
                    83.7994487,
                    55.1397758
                ],
                [
                    83.7956553,
                    55.137726
                ],
                [
                    83.7913752,
                    55.1354873
                ],
                [
                    83.7902162,
                    55.1361743
                ]
            ],
            "longitude": 83.808083,
            "latitude": 55.147881
        },
        "3686": {
            "name": "Легостаево",
            "population": 1196,
            "type": "village",
            "poly": [
                [
                    83.7713932,
                    54.6455835
                ],
                [
                    83.7731454,
                    54.6492928
                ],
                [
                    83.7796842,
                    54.6491939
                ],
                [
                    83.7849182,
                    54.650531
                ],
                [
                    83.7897703,
                    54.6424923
                ],
                [
                    83.7923773,
                    54.6408847
                ],
                [
                    83.7975485,
                    54.6408847
                ],
                [
                    83.7991897,
                    54.6419481
                ],
                [
                    83.8015875,
                    54.6426379
                ],
                [
                    83.8038545,
                    54.6464557
                ],
                [
                    83.8099611,
                    54.649962
                ],
                [
                    83.8097334,
                    54.6508806
                ],
                [
                    83.8088597,
                    54.6544075
                ],
                [
                    83.8093518,
                    54.6564435
                ],
                [
                    83.8123838,
                    54.6569107
                ],
                [
                    83.8128712,
                    54.6579915
                ],
                [
                    83.8127376,
                    54.6586651
                ],
                [
                    83.812483,
                    54.6625859
                ],
                [
                    83.8219695,
                    54.6613266
                ],
                [
                    83.8224537,
                    54.66048
                ],
                [
                    83.821007,
                    54.6594859
                ],
                [
                    83.8199166,
                    54.6574211
                ],
                [
                    83.8209245,
                    54.655764
                ],
                [
                    83.8203339,
                    54.6522775
                ],
                [
                    83.8228659,
                    54.6502928
                ],
                [
                    83.8213957,
                    54.6463705
                ],
                [
                    83.8232094,
                    54.6453615
                ],
                [
                    83.8263982,
                    54.64518
                ],
                [
                    83.8295349,
                    54.644091
                ],
                [
                    83.8330299,
                    54.6452093
                ],
                [
                    83.8360694,
                    54.6450892
                ],
                [
                    83.8383457,
                    54.6451667
                ],
                [
                    83.8408639,
                    54.6446938
                ],
                [
                    83.8415514,
                    54.6439264
                ],
                [
                    83.8419968,
                    54.6421946
                ],
                [
                    83.8425286,
                    54.6412567
                ],
                [
                    83.8418123,
                    54.6408182
                ],
                [
                    83.8407461,
                    54.6413284
                ],
                [
                    83.8385285,
                    54.6397151
                ],
                [
                    83.8411807,
                    54.6380287
                ],
                [
                    83.8366209,
                    54.6356816
                ],
                [
                    83.836519,
                    54.6356353
                ],
                [
                    83.834473,
                    54.6347054
                ],
                [
                    83.8316556,
                    54.6356605
                ],
                [
                    83.8310913,
                    54.6358505
                ],
                [
                    83.8329088,
                    54.6374016
                ],
                [
                    83.8286075,
                    54.6370684
                ],
                [
                    83.8293456,
                    54.6363801
                ],
                [
                    83.8289765,
                    54.6352883
                ],
                [
                    83.8291569,
                    54.6346973
                ],
                [
                    83.828956,
                    54.6342914
                ],
                [
                    83.8270317,
                    54.6342266
                ],
                [
                    83.8262146,
                    54.6355466
                ],
                [
                    83.8193176,
                    54.6338693
                ],
                [
                    83.8165252,
                    54.6342278
                ],
                [
                    83.8146436,
                    54.6334261
                ],
                [
                    83.8140175,
                    54.6340806
                ],
                [
                    83.8131272,
                    54.6338381
                ],
                [
                    83.8121721,
                    54.6318494
                ],
                [
                    83.8110648,
                    54.6306506
                ],
                [
                    83.8102652,
                    54.6302708
                ],
                [
                    83.8100191,
                    54.6298317
                ],
                [
                    83.8111469,
                    54.6293688
                ],
                [
                    83.811762,
                    54.6298435
                ],
                [
                    83.8125412,
                    54.6298198
                ],
                [
                    83.8130948,
                    54.6294637
                ],
                [
                    83.8122746,
                    54.628989
                ],
                [
                    83.8126847,
                    54.6283361
                ],
                [
                    83.812008,
                    54.6272797
                ],
                [
                    83.8079482,
                    54.6275409
                ],
                [
                    83.8086453,
                    54.6305438
                ],
                [
                    83.8077841,
                    54.631339
                ],
                [
                    83.8075996,
                    54.6322292
                ],
                [
                    83.8102936,
                    54.6361649
                ],
                [
                    83.81168,
                    54.6368457
                ],
                [
                    83.8119875,
                    54.6395988
                ],
                [
                    83.8090964,
                    54.6404413
                ],
                [
                    83.806111,
                    54.6402609
                ],
                [
                    83.8061228,
                    54.6384547
                ],
                [
                    83.7997372,
                    54.6404911
                ],
                [
                    83.799894,
                    54.6391902
                ],
                [
                    83.79643,
                    54.6388766
                ],
                [
                    83.7959672,
                    54.6400438
                ],
                [
                    83.7931549,
                    54.639996
                ],
                [
                    83.7887019,
                    54.6417998
                ],
                [
                    83.7836588,
                    54.6424675
                ],
                [
                    83.7810091,
                    54.6412557
                ],
                [
                    83.7750258,
                    54.6423933
                ],
                [
                    83.7713932,
                    54.6455835
                ]
            ],
            "longitude": 83.819496,
            "latitude": 54.642929
        },
        "3687": {
            "name": "Томилово",
            "population": 314,
            "type": "village",
            "poly": [
                [
                    83.8211876,
                    55.2151561
                ],
                [
                    83.8274134,
                    55.2185582
                ],
                [
                    83.8367635,
                    55.2225185
                ],
                [
                    83.8495274,
                    55.2206493
                ],
                [
                    83.8562651,
                    55.218593
                ],
                [
                    83.8504676,
                    55.2176185
                ],
                [
                    83.8511652,
                    55.2154372
                ],
                [
                    83.8499007,
                    55.2139507
                ],
                [
                    83.8498762,
                    55.2125926
                ],
                [
                    83.8487966,
                    55.2106218
                ],
                [
                    83.8467497,
                    55.208121
                ],
                [
                    83.8417128,
                    55.2074943
                ],
                [
                    83.8222119,
                    55.2099734
                ],
                [
                    83.8211876,
                    55.2151561
                ]
            ],
            "longitude": 83.838936,
            "latitude": 55.216259
        },
        "3688": {
            "name": "Ояш",
            "population": 778,
            "type": "village",
            "poly": [
                [
                    83.8264889,
                    55.5528734
                ],
                [
                    83.8283562,
                    55.5563263
                ],
                [
                    83.8392727,
                    55.5573418
                ],
                [
                    83.8358074,
                    55.5613223
                ],
                [
                    83.8403859,
                    55.5625916
                ],
                [
                    83.8505304,
                    55.5520304
                ],
                [
                    83.8529183,
                    55.5432036
                ],
                [
                    83.8504047,
                    55.5382053
                ],
                [
                    83.8450183,
                    55.5380021
                ],
                [
                    83.8428637,
                    55.5410906
                ],
                [
                    83.8445155,
                    55.5464136
                ],
                [
                    83.8264889,
                    55.5528734
                ]
            ],
            "longitude": 83.846123,
            "latitude": 55.550598
        },
        "3689": {
            "name": "Усть-Каменка",
            "population": 723,
            "type": "village",
            "poly": [
                [
                    83.8314774,
                    54.9984048
                ],
                [
                    83.8319555,
                    54.9989059
                ],
                [
                    83.8330183,
                    54.9997056
                ],
                [
                    83.8356496,
                    55.0008964
                ],
                [
                    83.8361486,
                    55.0010609
                ],
                [
                    83.8365516,
                    55.0011561
                ],
                [
                    83.8367279,
                    55.0010248
                ],
                [
                    83.8378235,
                    55.0013011
                ],
                [
                    83.8388389,
                    55.0016235
                ],
                [
                    83.8392117,
                    55.0018275
                ],
                [
                    83.8402111,
                    55.0021297
                ],
                [
                    83.8406457,
                    55.0020282
                ],
                [
                    83.841139,
                    55.0021269
                ],
                [
                    83.8415635,
                    55.0021006
                ],
                [
                    83.8434851,
                    55.0034264
                ],
                [
                    83.8434507,
                    55.003535
                ],
                [
                    83.8439588,
                    55.0038889
                ],
                [
                    83.8448216,
                    55.0034001
                ],
                [
                    83.8456304,
                    55.002673
                ],
                [
                    83.8453322,
                    55.002502
                ],
                [
                    83.8459517,
                    55.0022749
                ],
                [
                    83.8462213,
                    55.0026171
                ],
                [
                    83.8461523,
                    55.0029099
                ],
                [
                    83.8466687,
                    55.0025974
                ],
                [
                    83.8474086,
                    55.0024
                ],
                [
                    83.8477471,
                    55.0027783
                ],
                [
                    83.846313,
                    55.0032948
                ],
                [
                    83.8458025,
                    55.003637
                ],
                [
                    83.8459861,
                    55.0037982
                ],
                [
                    83.8455673,
                    55.0039988
                ],
                [
                    83.8459172,
                    55.0042291
                ],
                [
                    83.8482953,
                    55.003405
                ],
                [
                    83.8485387,
                    55.0038376
                ],
                [
                    83.8487165,
                    55.0045482
                ],
                [
                    83.8471468,
                    55.0047519
                ],
                [
                    83.8470702,
                    55.00517
                ],
                [
                    83.8465132,
                    55.0052834
                ],
                [
                    83.8465903,
                    55.0056817
                ],
                [
                    83.8470817,
                    55.005943
                ],
                [
                    83.8474057,
                    55.0063801
                ],
                [
                    83.8473513,
                    55.0065056
                ],
                [
                    83.8475692,
                    55.0067095
                ],
                [
                    83.847661,
                    55.0069332
                ],
                [
                    83.84742,
                    55.0070878
                ],
                [
                    83.8476036,
                    55.0072589
                ],
                [
                    83.8470551,
                    55.0074111
                ],
                [
                    83.8475179,
                    55.0082961
                ],
                [
                    83.8477774,
                    55.0084078
                ],
                [
                    83.8479154,
                    55.008766
                ],
                [
                    83.8475828,
                    55.0088125
                ],
                [
                    83.8478018,
                    55.0093521
                ],
                [
                    83.8478261,
                    55.0095289
                ],
                [
                    83.847526,
                    55.0095335
                ],
                [
                    83.8475503,
                    55.0099196
                ],
                [
                    83.8472502,
                    55.0099476
                ],
                [
                    83.8472502,
                    55.0101243
                ],
                [
                    83.8475503,
                    55.0105755
                ],
                [
                    83.8475584,
                    55.0116733
                ],
                [
                    83.8476757,
                    55.0118229
                ],
                [
                    83.8486853,
                    55.0118569
                ],
                [
                    83.8487368,
                    55.0123022
                ],
                [
                    83.8485238,
                    55.0124083
                ],
                [
                    83.8480776,
                    55.0123618
                ],
                [
                    83.8470473,
                    55.0125339
                ],
                [
                    83.8493158,
                    55.0148883
                ],
                [
                    83.8506947,
                    55.0145805
                ],
                [
                    83.8506548,
                    55.0135525
                ],
                [
                    83.8512858,
                    55.0137186
                ],
                [
                    83.8518578,
                    55.0137372
                ],
                [
                    83.8522206,
                    55.0134907
                ],
                [
                    83.8523567,
                    55.012372
                ],
                [
                    83.8525879,
                    55.0118301
                ],
                [
                    83.8523486,
                    55.0117883
                ],
                [
                    83.8524824,
                    55.0113557
                ],
                [
                    83.8525459,
                    55.0101266
                ],
                [
                    83.8521418,
                    55.0101183
                ],
                [
                    83.8520329,
                    55.00939
                ],
                [
                    83.8529848,
                    55.0093615
                ],
                [
                    83.8528921,
                    55.0089693
                ],
                [
                    83.8530965,
                    55.0089647
                ],
                [
                    83.8530828,
                    55.0087832
                ],
                [
                    83.8524419,
                    55.0077156
                ],
                [
                    83.8519471,
                    55.00729
                ],
                [
                    83.8520728,
                    55.0072341
                ],
                [
                    83.8516064,
                    55.0069015
                ],
                [
                    83.8510791,
                    55.006648
                ],
                [
                    83.8501462,
                    55.006834
                ],
                [
                    83.8501502,
                    55.0066456
                ],
                [
                    83.8508722,
                    55.0064968
                ],
                [
                    83.8507231,
                    55.006253
                ],
                [
                    83.8507019,
                    55.0060269
                ],
                [
                    83.8508073,
                    55.0058966
                ],
                [
                    83.8503044,
                    55.0054291
                ],
                [
                    83.8501047,
                    55.0051257
                ],
                [
                    83.8500758,
                    55.0048291
                ],
                [
                    83.8499421,
                    55.0046826
                ],
                [
                    83.8498527,
                    55.0044825
                ],
                [
                    83.8495243,
                    55.0042336
                ],
                [
                    83.8498407,
                    55.0042313
                ],
                [
                    83.8502463,
                    55.0046174
                ],
                [
                    83.8503071,
                    55.0047547
                ],
                [
                    83.8503071,
                    55.0049524
                ],
                [
                    83.8505059,
                    55.0051618
                ],
                [
                    83.8505528,
                    55.0054093
                ],
                [
                    83.8507465,
                    55.0055384
                ],
                [
                    83.85086,
                    55.0056989
                ],
                [
                    83.8510912,
                    55.0058059
                ],
                [
                    83.8513265,
                    55.0061269
                ],
                [
                    83.8515983,
                    55.006251
                ],
                [
                    83.8518213,
                    55.0062665
                ],
                [
                    83.8519552,
                    55.0061804
                ],
                [
                    83.8523243,
                    55.0061118
                ],
                [
                    83.8526853,
                    55.0058722
                ],
                [
                    83.8536313,
                    55.0057982
                ],
                [
                    83.8540207,
                    55.005676
                ],
                [
                    83.854377,
                    55.005673
                ],
                [
                    83.8547204,
                    55.0058226
                ],
                [
                    83.8550063,
                    55.0061354
                ],
                [
                    83.8556553,
                    55.0062762
                ],
                [
                    83.8560041,
                    55.0064204
                ],
                [
                    83.8564564,
                    55.0061796
                ],
                [
                    83.8571885,
                    55.0065088
                ],
                [
                    83.8578562,
                    55.0066841
                ],
                [
                    83.858103,
                    55.0066251
                ],
                [
                    83.8587886,
                    55.0056505
                ],
                [
                    83.8590157,
                    55.0052527
                ],
                [
                    83.8590969,
                    55.0048642
                ],
                [
                    83.8590231,
                    55.004784
                ],
                [
                    83.8590188,
                    55.004653
                ],
                [
                    83.8590025,
                    55.004153
                ],
                [
                    83.8589265,
                    55.0036639
                ],
                [
                    83.8585736,
                    55.0034638
                ],
                [
                    83.8580178,
                    55.003394
                ],
                [
                    83.8574177,
                    55.0036453
                ],
                [
                    83.8568336,
                    55.0035988
                ],
                [
                    83.8568417,
                    55.0034801
                ],
                [
                    83.8561196,
                    55.0034359
                ],
                [
                    83.8560629,
                    55.0035848
                ],
                [
                    83.854619,
                    55.0033475
                ],
                [
                    83.8533048,
                    55.0029869
                ],
                [
                    83.8528302,
                    55.0029404
                ],
                [
                    83.8523797,
                    55.0028036
                ],
                [
                    83.8509969,
                    55.0033638
                ],
                [
                    83.8504575,
                    55.0030335
                ],
                [
                    83.8494578,
                    55.0030645
                ],
                [
                    83.8496665,
                    55.0034917
                ],
                [
                    83.8496828,
                    55.0036639
                ],
                [
                    83.8492731,
                    55.0036918
                ],
                [
                    83.8488918,
                    55.0031172
                ],
                [
                    83.848517,
                    55.0031846
                ],
                [
                    83.8476663,
                    55.0022041
                ],
                [
                    83.8479224,
                    55.0022681
                ],
                [
                    83.8481536,
                    55.0021983
                ],
                [
                    83.8487417,
                    55.0021192
                ],
                [
                    83.8492335,
                    55.0020101
                ],
                [
                    83.849131,
                    55.0016935
                ],
                [
                    83.8489527,
                    55.0015376
                ],
                [
                    83.8485471,
                    55.0015097
                ],
                [
                    83.8483524,
                    55.0013888
                ],
                [
                    83.8481847,
                    55.0011762
                ],
                [
                    83.8481455,
                    55.0010258
                ],
                [
                    83.8482266,
                    55.0009002
                ],
                [
                    83.8478332,
                    55.0007397
                ],
                [
                    83.8475736,
                    55.0007211
                ],
                [
                    83.8471761,
                    55.0002325
                ],
                [
                    83.8470184,
                    54.9997584
                ],
                [
                    83.847769,
                    54.9996115
                ],
                [
                    83.8476872,
                    54.9994206
                ],
                [
                    83.8471802,
                    54.9994671
                ],
                [
                    83.8472045,
                    54.9987413
                ],
                [
                    83.8476526,
                    54.9987552
                ],
                [
                    83.847894,
                    54.9985319
                ],
                [
                    83.8480319,
                    54.9980456
                ],
                [
                    83.848616,
                    54.9974733
                ],
                [
                    83.8494149,
                    54.9970715
                ],
                [
                    83.8505791,
                    54.9970708
                ],
                [
                    83.8513944,
                    54.9968567
                ],
                [
                    83.8519825,
                    54.9964123
                ],
                [
                    83.8520596,
                    54.9962448
                ],
                [
                    83.8526072,
                    54.9966101
                ],
                [
                    83.8527451,
                    54.9966264
                ],
                [
                    83.8529664,
                    54.9965148
                ],
                [
                    83.8529884,
                    54.9963542
                ],
                [
                    83.8535685,
                    54.9960819
                ],
                [
                    83.8542134,
                    54.9959144
                ],
                [
                    83.8542336,
                    54.9957958
                ],
                [
                    83.8547934,
                    54.9955352
                ],
                [
                    83.8546514,
                    54.9953607
                ],
                [
                    83.8544405,
                    54.9952327
                ],
                [
                    83.8547204,
                    54.9950605
                ],
                [
                    83.8552112,
                    54.9953514
                ],
                [
                    83.8556817,
                    54.9950884
                ],
                [
                    83.8558804,
                    54.9951931
                ],
                [
                    83.8565699,
                    54.994779
                ],
                [
                    83.8568174,
                    54.9948511
                ],
                [
                    83.8570648,
                    54.994758
                ],
                [
                    83.8575596,
                    54.9944602
                ],
                [
                    83.858168,
                    54.9942857
                ],
                [
                    83.8584073,
                    54.9941717
                ],
                [
                    83.8589771,
                    54.9935269
                ],
                [
                    83.8596809,
                    54.9935434
                ],
                [
                    83.8600825,
                    54.9934806
                ],
                [
                    83.8602975,
                    54.9935016
                ],
                [
                    83.8606422,
                    54.9934992
                ],
                [
                    83.8608895,
                    54.9935877
                ],
                [
                    83.8613196,
                    54.9935783
                ],
                [
                    83.8614413,
                    54.9936202
                ],
                [
                    83.862289,
                    54.9936132
                ],
                [
                    83.8625851,
                    54.9935597
                ],
                [
                    83.8629258,
                    54.9936249
                ],
                [
                    83.8635991,
                    54.9936482
                ],
                [
                    83.8649619,
                    54.9933364
                ],
                [
                    83.8666405,
                    54.9932509
                ],
                [
                    83.8681072,
                    54.9932096
                ],
                [
                    83.8682982,
                    54.9929646
                ],
                [
                    83.8681974,
                    54.9925004
                ],
                [
                    83.8686031,
                    54.9917139
                ],
                [
                    83.868717,
                    54.9910345
                ],
                [
                    83.8688884,
                    54.9901916
                ],
                [
                    83.8664497,
                    54.9898234
                ],
                [
                    83.8617519,
                    54.9896575
                ],
                [
                    83.8621705,
                    54.9908335
                ],
                [
                    83.8599857,
                    54.9909651
                ],
                [
                    83.8581899,
                    54.9909847
                ],
                [
                    83.8581929,
                    54.9907976
                ],
                [
                    83.8577713,
                    54.9907787
                ],
                [
                    83.8576007,
                    54.9913584
                ],
                [
                    83.8573898,
                    54.9919727
                ],
                [
                    83.8572519,
                    54.9919611
                ],
                [
                    83.8571343,
                    54.9917609
                ],
                [
                    83.8565908,
                    54.9914235
                ],
                [
                    83.8562987,
                    54.9913979
                ],
                [
                    83.8547843,
                    54.9919937
                ],
                [
                    83.8544104,
                    54.9916787
                ],
                [
                    83.8534378,
                    54.9921265
                ],
                [
                    83.8526307,
                    54.9926003
                ],
                [
                    83.8528502,
                    54.992771
                ],
                [
                    83.8506687,
                    54.9940946
                ],
                [
                    83.8504034,
                    54.9940926
                ],
                [
                    83.8506243,
                    54.9936007
                ],
                [
                    83.8509283,
                    54.9936221
                ],
                [
                    83.8515665,
                    54.9926383
                ],
                [
                    83.8511835,
                    54.9925164
                ],
                [
                    83.851238,
                    54.9923256
                ],
                [
                    83.8509508,
                    54.9922228
                ],
                [
                    83.8510086,
                    54.991725
                ],
                [
                    83.8511032,
                    54.9914091
                ],
                [
                    83.8513183,
                    54.9914025
                ],
                [
                    83.8515811,
                    54.9901901
                ],
                [
                    83.8488566,
                    54.9894815
                ],
                [
                    83.848781,
                    54.9895932
                ],
                [
                    83.8486462,
                    54.9896935
                ],
                [
                    83.8486319,
                    54.9898531
                ],
                [
                    83.8484598,
                    54.9900193
                ],
                [
                    83.8484567,
                    54.9901867
                ],
                [
                    83.8483135,
                    54.9903889
                ],
                [
                    83.8483999,
                    54.9910535
                ],
                [
                    83.8497141,
                    54.99105
                ],
                [
                    83.8495904,
                    54.9914584
                ],
                [
                    83.8484168,
                    54.9913761
                ],
                [
                    83.8480754,
                    54.992267
                ],
                [
                    83.8493734,
                    54.9924101
                ],
                [
                    83.8492598,
                    54.9927662
                ],
                [
                    83.8490428,
                    54.9927638
                ],
                [
                    83.8490266,
                    54.9929337
                ],
                [
                    83.8492294,
                    54.9929465
                ],
                [
                    83.8491546,
                    54.9930632
                ],
                [
                    83.8491422,
                    54.9930826
                ],
                [
                    83.8484323,
                    54.9927313
                ],
                [
                    83.8471669,
                    54.9941879
                ],
                [
                    83.8472358,
                    54.9943717
                ],
                [
                    83.8471182,
                    54.9944554
                ],
                [
                    83.8461488,
                    54.9946695
                ],
                [
                    83.845585,
                    54.9948929
                ],
                [
                    83.8445751,
                    54.995435
                ],
                [
                    83.8442952,
                    54.9956723
                ],
                [
                    83.8439058,
                    54.9958096
                ],
                [
                    83.8434232,
                    54.9958189
                ],
                [
                    83.843269,
                    54.9957328
                ],
                [
                    83.8436016,
                    54.9951628
                ],
                [
                    83.845005,
                    54.99426
                ],
                [
                    83.8454796,
                    54.9944136
                ],
                [
                    83.8455606,
                    54.9943251
                ],
                [
                    83.8470046,
                    54.9933665
                ],
                [
                    83.8472156,
                    54.9932874
                ],
                [
                    83.8474711,
                    54.9930221
                ],
                [
                    83.8476516,
                    54.9924811
                ],
                [
                    83.8474995,
                    54.9923718
                ],
                [
                    83.8475786,
                    54.9913281
                ],
                [
                    83.8475364,
                    54.9912699
                ],
                [
                    83.8476354,
                    54.9906428
                ],
                [
                    83.8479563,
                    54.9900228
                ],
                [
                    83.8481479,
                    54.9896527
                ],
                [
                    83.8477743,
                    54.9896458
                ],
                [
                    83.8477615,
                    54.9893829
                ],
                [
                    83.8473129,
                    54.9893652
                ],
                [
                    83.8472967,
                    54.9896305
                ],
                [
                    83.8460196,
                    54.9896096
                ],
                [
                    83.8458892,
                    54.9912059
                ],
                [
                    83.8461853,
                    54.9912873
                ],
                [
                    83.8456262,
                    54.9925017
                ],
                [
                    83.8455952,
                    54.992637
                ],
                [
                    83.8454715,
                    54.9926986
                ],
                [
                    83.8450983,
                    54.9925765
                ],
                [
                    83.8439143,
                    54.9937433
                ],
                [
                    83.8436949,
                    54.9937864
                ],
                [
                    83.8422473,
                    54.9950719
                ],
                [
                    83.8416795,
                    54.9947043
                ],
                [
                    83.8421256,
                    54.9945251
                ],
                [
                    83.8431356,
                    54.9940667
                ],
                [
                    83.8418132,
                    54.9933041
                ],
                [
                    83.8410879,
                    54.9931557
                ],
                [
                    83.8400367,
                    54.9936159
                ],
                [
                    83.8394648,
                    54.9933553
                ],
                [
                    83.838066,
                    54.9940985
                ],
                [
                    83.8388351,
                    54.9945273
                ],
                [
                    83.8395958,
                    54.9950868
                ],
                [
                    83.8410703,
                    54.99461
                ],
                [
                    83.8413995,
                    54.9948421
                ],
                [
                    83.8396273,
                    54.9956357
                ],
                [
                    83.8398339,
                    54.9958705
                ],
                [
                    83.8402142,
                    54.9961221
                ],
                [
                    83.8405959,
                    54.9962822
                ],
                [
                    83.8409114,
                    54.9966061
                ],
                [
                    83.8407658,
                    54.9966638
                ],
                [
                    83.8416179,
                    54.9974649
                ],
                [
                    83.8420063,
                    54.9973275
                ],
                [
                    83.8422013,
                    54.9970807
                ],
                [
                    83.8423935,
                    54.9967287
                ],
                [
                    83.8429843,
                    54.9963404
                ],
                [
                    83.8434604,
                    54.9958781
                ],
                [
                    83.8439135,
                    54.9958913
                ],
                [
                    83.8439881,
                    54.9963651
                ],
                [
                    83.8443466,
                    54.9965
                ],
                [
                    83.8430962,
                    54.9972305
                ],
                [
                    83.8439451,
                    54.9983162
                ],
                [
                    83.8435493,
                    54.9984084
                ],
                [
                    83.8425484,
                    54.9978869
                ],
                [
                    83.8421812,
                    54.9981238
                ],
                [
                    83.8431042,
                    54.9985441
                ],
                [
                    83.8447029,
                    54.9995735
                ],
                [
                    83.8449243,
                    54.9999811
                ],
                [
                    83.8450763,
                    55.0009615
                ],
                [
                    83.8464186,
                    55.0007098
                ],
                [
                    83.8466079,
                    55.0010701
                ],
                [
                    83.8466222,
                    55.0013514
                ],
                [
                    83.8462924,
                    55.0014781
                ],
                [
                    83.8458536,
                    55.001557
                ],
                [
                    83.8449415,
                    55.0016245
                ],
                [
                    83.8440295,
                    55.0008217
                ],
                [
                    83.8442237,
                    55.0007004
                ],
                [
                    83.8440287,
                    55.0002151
                ],
                [
                    83.8439771,
                    54.9999108
                ],
                [
                    83.8437083,
                    54.9997129
                ],
                [
                    83.8433904,
                    54.9997488
                ],
                [
                    83.8423423,
                    54.999021
                ],
                [
                    83.8421171,
                    54.9989454
                ],
                [
                    83.841857,
                    54.9987398
                ],
                [
                    83.8414352,
                    54.9989582
                ],
                [
                    83.8410968,
                    54.999172
                ],
                [
                    83.8418425,
                    54.9996919
                ],
                [
                    83.8411484,
                    55.0001689
                ],
                [
                    83.8404773,
                    54.9996919
                ],
                [
                    83.8398866,
                    54.9993742
                ],
                [
                    83.8390547,
                    54.9997379
                ],
                [
                    83.8398002,
                    55.0005277
                ],
                [
                    83.8397832,
                    55.0005736
                ],
                [
                    83.837632,
                    54.9999452
                ],
                [
                    83.8384482,
                    54.999263
                ],
                [
                    83.8380853,
                    54.9990569
                ],
                [
                    83.8377067,
                    54.9988759
                ],
                [
                    83.8368807,
                    54.9984778
                ],
                [
                    83.8358023,
                    54.9978855
                ],
                [
                    83.83407,
                    54.997109
                ],
                [
                    83.8327676,
                    54.9981125
                ],
                [
                    83.8321111,
                    54.9980699
                ],
                [
                    83.8314774,
                    54.9984048
                ]
            ],
            "longitude": 83.847878,
            "latitude": 54.99646
        },
        "3690": {
            "name": "Кругликово",
            "population": 280,
            "type": "village",
            "poly": [
                [
                    83.8379262,
                    55.8354187
                ],
                [
                    83.8438142,
                    55.8404342
                ],
                [
                    83.8516559,
                    55.8476626
                ],
                [
                    83.857046,
                    55.8467242
                ],
                [
                    83.8567896,
                    55.8458183
                ],
                [
                    83.8568218,
                    55.8453551
                ],
                [
                    83.8560664,
                    55.8450217
                ],
                [
                    83.8553562,
                    55.8442374
                ],
                [
                    83.8552027,
                    55.8439621
                ],
                [
                    83.856326,
                    55.843467
                ],
                [
                    83.8600983,
                    55.8421315
                ],
                [
                    83.8603912,
                    55.8411321
                ],
                [
                    83.859961,
                    55.8406718
                ],
                [
                    83.8606959,
                    55.8388886
                ],
                [
                    83.8612549,
                    55.8378349
                ],
                [
                    83.8611026,
                    55.8370361
                ],
                [
                    83.8630899,
                    55.8372478
                ],
                [
                    83.8645974,
                    55.83719
                ],
                [
                    83.865657,
                    55.8372231
                ],
                [
                    83.8668245,
                    55.837748
                ],
                [
                    83.8699082,
                    55.8381328
                ],
                [
                    83.8704564,
                    55.8369976
                ],
                [
                    83.8717927,
                    55.8372862
                ],
                [
                    83.8718269,
                    55.8368437
                ],
                [
                    83.8764524,
                    55.8364012
                ],
                [
                    83.8764182,
                    55.8359586
                ],
                [
                    83.8743624,
                    55.8358432
                ],
                [
                    83.8716213,
                    55.8360548
                ],
                [
                    83.8683664,
                    55.8353814
                ],
                [
                    83.8671672,
                    55.8354199
                ],
                [
                    83.8668245,
                    55.8358047
                ],
                [
                    83.8649058,
                    55.8357277
                ],
                [
                    83.8652142,
                    55.8354199
                ],
                [
                    83.8620192,
                    55.8352619
                ],
                [
                    83.8610554,
                    55.8352693
                ],
                [
                    83.8596938,
                    55.8349008
                ],
                [
                    83.8582583,
                    55.8351732
                ],
                [
                    83.8570213,
                    55.8349291
                ],
                [
                    83.8544109,
                    55.8342995
                ],
                [
                    83.8505926,
                    55.8342025
                ],
                [
                    83.8488792,
                    55.8340091
                ],
                [
                    83.8484146,
                    55.8341977
                ],
                [
                    83.8477966,
                    55.8340302
                ],
                [
                    83.8472763,
                    55.8340212
                ],
                [
                    83.8466293,
                    55.8339157
                ],
                [
                    83.8457324,
                    55.8339627
                ],
                [
                    83.8446702,
                    55.8341163
                ],
                [
                    83.8433452,
                    55.8340374
                ],
                [
                    83.8436392,
                    55.8346713
                ],
                [
                    83.8439815,
                    55.8350132
                ],
                [
                    83.8445534,
                    55.8352976
                ],
                [
                    83.8444686,
                    55.8358941
                ],
                [
                    83.8435449,
                    55.8355543
                ],
                [
                    83.8408701,
                    55.8344206
                ],
                [
                    83.8379262,
                    55.8354187
                ]
            ],
            "longitude": 83.855682,
            "latitude": 55.838856
        },
        "3691": {
            "name": "Мосты",
            "population": 332,
            "type": "village",
            "poly": [
                [
                    83.8429489,
                    54.7761289
                ],
                [
                    83.8435526,
                    54.7774993
                ],
                [
                    83.8440006,
                    54.7774094
                ],
                [
                    83.8451107,
                    54.7770388
                ],
                [
                    83.8449549,
                    54.7767467
                ],
                [
                    83.8483047,
                    54.7762188
                ],
                [
                    83.8491228,
                    54.7758481
                ],
                [
                    83.8495123,
                    54.7763648
                ],
                [
                    83.8514014,
                    54.776376
                ],
                [
                    83.8536801,
                    54.776039
                ],
                [
                    83.8529985,
                    54.7753426
                ],
                [
                    83.8535827,
                    54.7751741
                ],
                [
                    83.8543813,
                    54.77541
                ],
                [
                    83.8559199,
                    54.7762075
                ],
                [
                    83.8546734,
                    54.776859
                ],
                [
                    83.8578059,
                    54.7794591
                ],
                [
                    83.8598791,
                    54.7807408
                ],
                [
                    83.860995,
                    54.780834
                ],
                [
                    83.8604784,
                    54.7790899
                ],
                [
                    83.8608021,
                    54.7789151
                ],
                [
                    83.8609017,
                    54.7796124
                ],
                [
                    83.8611885,
                    54.7796699
                ],
                [
                    83.8615748,
                    54.7801299
                ],
                [
                    83.8622106,
                    54.7799646
                ],
                [
                    83.8616372,
                    54.778304
                ],
                [
                    83.8615873,
                    54.7775923
                ],
                [
                    83.8621109,
                    54.7769165
                ],
                [
                    83.8627466,
                    54.7765355
                ],
                [
                    83.8633947,
                    54.7763342
                ],
                [
                    83.8655385,
                    54.776629
                ],
                [
                    83.8656399,
                    54.7766312
                ],
                [
                    83.8678196,
                    54.7766793
                ],
                [
                    83.869465,
                    54.7772976
                ],
                [
                    83.8721324,
                    54.7777864
                ],
                [
                    83.8732043,
                    54.7767224
                ],
                [
                    83.8752485,
                    54.7772616
                ],
                [
                    83.876495,
                    54.776212
                ],
                [
                    83.8754106,
                    54.7758957
                ],
                [
                    83.8742638,
                    54.7753277
                ],
                [
                    83.8732293,
                    54.7752486
                ],
                [
                    83.8702004,
                    54.7741415
                ],
                [
                    83.8693028,
                    54.7743859
                ],
                [
                    83.8690412,
                    54.774997
                ],
                [
                    83.8684429,
                    54.7753493
                ],
                [
                    83.8677572,
                    54.7751696
                ],
                [
                    83.8663737,
                    54.7745081
                ],
                [
                    83.8655636,
                    54.7738826
                ],
                [
                    83.8646287,
                    54.7740839
                ],
                [
                    83.8638808,
                    54.7736526
                ],
                [
                    83.8643046,
                    54.7735016
                ],
                [
                    83.8642548,
                    54.7731996
                ],
                [
                    83.8648405,
                    54.7729911
                ],
                [
                    83.8639929,
                    54.7722937
                ],
                [
                    83.8634072,
                    54.772042
                ],
                [
                    83.8634321,
                    54.7715819
                ],
                [
                    83.8625471,
                    54.7708773
                ],
                [
                    83.8614752,
                    54.7711361
                ],
                [
                    83.8614876,
                    54.7716826
                ],
                [
                    83.8613381,
                    54.7716897
                ],
                [
                    83.8607272,
                    54.7711721
                ],
                [
                    83.863133,
                    54.7699785
                ],
                [
                    83.8626842,
                    54.7696477
                ],
                [
                    83.8639805,
                    54.7685691
                ],
                [
                    83.8634321,
                    54.7683678
                ],
                [
                    83.8639432,
                    54.7678357
                ],
                [
                    83.8625097,
                    54.767282
                ],
                [
                    83.8631204,
                    54.7668721
                ],
                [
                    83.8626967,
                    54.7666133
                ],
                [
                    83.8628587,
                    54.7664623
                ],
                [
                    83.8623352,
                    54.7662897
                ],
                [
                    83.8620111,
                    54.7664263
                ],
                [
                    83.8615748,
                    54.7661243
                ],
                [
                    83.8609766,
                    54.7663903
                ],
                [
                    83.8592689,
                    54.7654483
                ],
                [
                    83.8563398,
                    54.765247
                ],
                [
                    83.8548066,
                    54.7624279
                ],
                [
                    83.8528031,
                    54.7627449
                ],
                [
                    83.8530524,
                    54.7638438
                ],
                [
                    83.8527831,
                    54.7638898
                ],
                [
                    83.8525139,
                    54.7636367
                ],
                [
                    83.852135,
                    54.7637057
                ],
                [
                    83.8519754,
                    54.7639243
                ],
                [
                    83.8516165,
                    54.765213
                ],
                [
                    83.8518756,
                    54.7671689
                ],
                [
                    83.8525239,
                    54.7677212
                ],
                [
                    83.8523045,
                    54.7695217
                ],
                [
                    83.8519256,
                    54.770189
                ],
                [
                    83.8523145,
                    54.7706722
                ],
                [
                    83.8528131,
                    54.7711151
                ],
                [
                    83.8524337,
                    54.7712085
                ],
                [
                    83.8522389,
                    54.7710849
                ],
                [
                    83.8515573,
                    54.7713096
                ],
                [
                    83.8516546,
                    54.7714893
                ],
                [
                    83.8508561,
                    54.7717702
                ],
                [
                    83.8514208,
                    54.772433
                ],
                [
                    83.848889,
                    54.7728262
                ],
                [
                    83.8480321,
                    54.7720398
                ],
                [
                    83.8445653,
                    54.7732082
                ],
                [
                    83.8442927,
                    54.7736013
                ],
                [
                    83.8450328,
                    54.7744776
                ],
                [
                    83.8466883,
                    54.7744439
                ],
                [
                    83.8466493,
                    54.7748033
                ],
                [
                    83.8462988,
                    54.7751516
                ],
                [
                    83.8447991,
                    54.7756346
                ],
                [
                    83.8437669,
                    54.7757807
                ],
                [
                    83.8429489,
                    54.7761289
                ]
            ],
            "longitude": 83.85585,
            "latitude": 54.770237
        },
        "3692": {
            "name": "Балта",
            "population": 626,
            "type": "village",
            "poly": [
                [
                    83.8621044,
                    55.5160741
                ],
                [
                    83.8623372,
                    55.5175347
                ],
                [
                    83.8668527,
                    55.5184781
                ],
                [
                    83.866546,
                    55.5211283
                ],
                [
                    83.8654303,
                    55.5218358
                ],
                [
                    83.8652518,
                    55.5238064
                ],
                [
                    83.8675725,
                    55.5238316
                ],
                [
                    83.8671262,
                    55.5255242
                ],
                [
                    83.8667246,
                    55.5263074
                ],
                [
                    83.8689148,
                    55.5285406
                ],
                [
                    83.8720634,
                    55.5287837
                ],
                [
                    83.8746708,
                    55.5255758
                ],
                [
                    83.8724121,
                    55.5225175
                ],
                [
                    83.8719763,
                    55.5206917
                ],
                [
                    83.8744055,
                    55.5194517
                ],
                [
                    83.8783173,
                    55.5176611
                ],
                [
                    83.8802515,
                    55.5158674
                ],
                [
                    83.8783841,
                    55.5138437
                ],
                [
                    83.8759256,
                    55.5107341
                ],
                [
                    83.8749884,
                    55.5093063
                ],
                [
                    83.8763859,
                    55.5082798
                ],
                [
                    83.8749215,
                    55.5077822
                ],
                [
                    83.867102,
                    55.5070903
                ],
                [
                    83.8681875,
                    55.5089661
                ],
                [
                    83.8655504,
                    55.5107009
                ],
                [
                    83.8669561,
                    55.5130556
                ],
                [
                    83.8629732,
                    55.5141831
                ],
                [
                    83.8621044,
                    55.5160741
                ]
            ],
            "longitude": 83.87484,
            "latitude": 55.513691
        },
        "3693": {
            "name": "Широкий Яр",
            "population": 830,
            "type": "village",
            "poly": [
                [
                    83.8558806,
                    55.4687704
                ],
                [
                    83.8634151,
                    55.4691975
                ],
                [
                    83.8628671,
                    55.4723035
                ],
                [
                    83.8663604,
                    55.4724588
                ],
                [
                    83.865333,
                    55.4770009
                ],
                [
                    83.8827993,
                    55.4775832
                ],
                [
                    83.8910188,
                    55.4696246
                ],
                [
                    83.8912243,
                    55.4656253
                ],
                [
                    83.8852652,
                    55.4603829
                ],
                [
                    83.8817719,
                    55.4598003
                ],
                [
                    83.8758813,
                    55.4655476
                ],
                [
                    83.8560176,
                    55.4626353
                ],
                [
                    83.8560207,
                    55.4678349
                ],
                [
                    83.8558806,
                    55.4687704
                ]
            ],
            "longitude": 83.875763,
            "latitude": 55.470303
        },
        "3694": {
            "name": "Горный",
            "population": 9266,
            "type": "village",
            "poly": [
                [
                    [
                        83.8508333,
                        55.1171707
                    ],
                    [
                        83.8579545,
                        55.121264
                    ],
                    [
                        83.8615865,
                        55.1201549
                    ],
                    [
                        83.8630273,
                        55.1199239
                    ],
                    [
                        83.8672001,
                        55.1184798
                    ],
                    [
                        83.869227,
                        55.1169689
                    ],
                    [
                        83.8694793,
                        55.1170699
                    ],
                    [
                        83.8696496,
                        55.1170158
                    ],
                    [
                        83.8701479,
                        55.1172719
                    ],
                    [
                        83.8703497,
                        55.1172611
                    ],
                    [
                        83.8705767,
                        55.1173765
                    ],
                    [
                        83.87052,
                        55.1174811
                    ],
                    [
                        83.8712957,
                        55.1178526
                    ],
                    [
                        83.8714849,
                        55.1177552
                    ],
                    [
                        83.8719579,
                        55.1180401
                    ],
                    [
                        83.8737302,
                        55.1190104
                    ],
                    [
                        83.873686,
                        55.1190861
                    ],
                    [
                        83.874979,
                        55.1197642
                    ],
                    [
                        83.8759313,
                        55.1202475
                    ],
                    [
                        83.8755907,
                        55.1205757
                    ],
                    [
                        83.8756223,
                        55.1207163
                    ],
                    [
                        83.8762467,
                        55.12094
                    ],
                    [
                        83.8771107,
                        55.120756
                    ],
                    [
                        83.8776101,
                        55.1215083
                    ],
                    [
                        83.8776279,
                        55.121535
                    ],
                    [
                        83.8782333,
                        55.1226639
                    ],
                    [
                        83.8783784,
                        55.122534
                    ],
                    [
                        83.878883,
                        55.1218091
                    ],
                    [
                        83.8793434,
                        55.1212141
                    ],
                    [
                        83.8800813,
                        55.1205613
                    ],
                    [
                        83.8807813,
                        55.119894
                    ],
                    [
                        83.8815003,
                        55.119353
                    ],
                    [
                        83.881924,
                        55.1190988
                    ],
                    [
                        83.8831652,
                        55.1185664
                    ],
                    [
                        83.884288,
                        55.1182456
                    ],
                    [
                        83.8861195,
                        55.1182513
                    ],
                    [
                        83.8906126,
                        55.1187116
                    ],
                    [
                        83.8937109,
                        55.1190456
                    ],
                    [
                        83.8968469,
                        55.1193569
                    ],
                    [
                        83.8976574,
                        55.1194347
                    ],
                    [
                        83.9121533,
                        55.1206741
                    ],
                    [
                        83.9180584,
                        55.1210981
                    ],
                    [
                        83.9211858,
                        55.1216996
                    ],
                    [
                        83.9235754,
                        55.1224095
                    ],
                    [
                        83.9247673,
                        55.1229954
                    ],
                    [
                        83.9284701,
                        55.124906
                    ],
                    [
                        83.9282444,
                        55.125406
                    ],
                    [
                        83.9276238,
                        55.1256803
                    ],
                    [
                        83.9274263,
                        55.1268738
                    ],
                    [
                        83.9277775,
                        55.1277404
                    ],
                    [
                        83.9301825,
                        55.1290873
                    ],
                    [
                        83.9364816,
                        55.1319058
                    ],
                    [
                        83.9391824,
                        55.1291069
                    ],
                    [
                        83.9376519,
                        55.1276003
                    ],
                    [
                        83.9356184,
                        55.1268383
                    ],
                    [
                        83.9354661,
                        55.1260512
                    ],
                    [
                        83.9352686,
                        55.1257125
                    ],
                    [
                        83.9359457,
                        55.125406
                    ],
                    [
                        83.9354661,
                        55.1248415
                    ],
                    [
                        83.9357764,
                        55.1233252
                    ],
                    [
                        83.9362842,
                        55.1231801
                    ],
                    [
                        83.9362277,
                        55.1227445
                    ],
                    [
                        83.9357482,
                        55.1226639
                    ],
                    [
                        83.9357764,
                        55.1217444
                    ],
                    [
                        83.936397,
                        55.121567
                    ],
                    [
                        83.9361149,
                        55.120712
                    ],
                    [
                        83.9354661,
                        55.1201151
                    ],
                    [
                        83.9365381,
                        55.119131
                    ],
                    [
                        83.9358892,
                        55.1184696
                    ],
                    [
                        83.9344787,
                        55.1189859
                    ],
                    [
                        83.9341966,
                        55.1183406
                    ],
                    [
                        83.931686,
                        55.1157915
                    ],
                    [
                        83.9282154,
                        55.1153584
                    ],
                    [
                        83.921877,
                        55.1144791
                    ],
                    [
                        83.9183845,
                        55.1140643
                    ],
                    [
                        83.9125585,
                        55.1133654
                    ],
                    [
                        83.911698,
                        55.1133585
                    ],
                    [
                        83.9106677,
                        55.1132158
                    ],
                    [
                        83.9093735,
                        55.1130407
                    ],
                    [
                        83.9013243,
                        55.1121569
                    ],
                    [
                        83.8984351,
                        55.1118777
                    ],
                    [
                        83.8956443,
                        55.1118777
                    ],
                    [
                        83.8941952,
                        55.1119838
                    ],
                    [
                        83.8859298,
                        55.1124033
                    ],
                    [
                        83.8768261,
                        55.112764
                    ],
                    [
                        83.8649043,
                        55.1132363
                    ],
                    [
                        83.862595,
                        55.1133302
                    ],
                    [
                        83.8605396,
                        55.1139071
                    ],
                    [
                        83.8508333,
                        55.1171707
                    ]
                ],
                [
                    [
                        83.8768648,
                        55.1305404
                    ],
                    [
                        83.8778676,
                        55.1312182
                    ],
                    [
                        83.8782524,
                        55.1313372
                    ],
                    [
                        83.8783413,
                        55.131293
                    ],
                    [
                        83.8793851,
                        55.1311962
                    ],
                    [
                        83.879639,
                        55.1301963
                    ],
                    [
                        83.8799775,
                        55.1300189
                    ],
                    [
                        83.8800057,
                        55.1295028
                    ],
                    [
                        83.8810495,
                        55.129148
                    ],
                    [
                        83.8814444,
                        55.1287287
                    ],
                    [
                        83.8822907,
                        55.1291802
                    ],
                    [
                        83.8827703,
                        55.129277
                    ],
                    [
                        83.8837294,
                        55.1282448
                    ],
                    [
                        83.8833909,
                        55.1275351
                    ],
                    [
                        83.882601,
                        55.1270029
                    ],
                    [
                        83.88246,
                        55.126519
                    ],
                    [
                        83.8827703,
                        55.1263738
                    ],
                    [
                        83.8834473,
                        55.1265835
                    ],
                    [
                        83.8833062,
                        55.1261158
                    ],
                    [
                        83.8837576,
                        55.1258899
                    ],
                    [
                        83.8835319,
                        55.1250028
                    ],
                    [
                        83.8835883,
                        55.1244544
                    ],
                    [
                        83.8838704,
                        55.1242447
                    ],
                    [
                        83.8835319,
                        55.1232768
                    ],
                    [
                        83.8837294,
                        55.1226639
                    ],
                    [
                        83.883278,
                        55.1215024
                    ],
                    [
                        83.8823471,
                        55.1217605
                    ],
                    [
                        83.8808238,
                        55.1215347
                    ],
                    [
                        83.8802159,
                        55.1211111
                    ],
                    [
                        83.880086,
                        55.1210674
                    ],
                    [
                        83.8798163,
                        55.1213426
                    ],
                    [
                        83.8792303,
                        55.1220007
                    ],
                    [
                        83.8787823,
                        55.1226084
                    ],
                    [
                        83.8790154,
                        55.1228288
                    ],
                    [
                        83.8792543,
                        55.1232701
                    ],
                    [
                        83.8793738,
                        55.1237982
                    ],
                    [
                        83.8793512,
                        55.1242875
                    ],
                    [
                        83.8790767,
                        55.1251147
                    ],
                    [
                        83.878883,
                        55.1256908
                    ],
                    [
                        83.8784857,
                        55.1269741
                    ],
                    [
                        83.8778866,
                        55.1284706
                    ],
                    [
                        83.8774955,
                        55.1293252
                    ],
                    [
                        83.8768648,
                        55.1305404
                    ]
                ]
            ],
            "longitude": 83.878761,
            "latitude": 55.118286
        },
        "3695": {
            "name": "Байкал",
            "population": 546,
            "type": "village",
            "poly": [
                [
                    83.8753263,
                    55.6398306
                ],
                [
                    83.8772818,
                    55.6409767
                ],
                [
                    83.8808919,
                    55.6394061
                ],
                [
                    83.8798465,
                    55.6412399
                ],
                [
                    83.8781747,
                    55.642596
                ],
                [
                    83.8762196,
                    55.6442305
                ],
                [
                    83.8770741,
                    55.6448972
                ],
                [
                    83.8776467,
                    55.6458531
                ],
                [
                    83.8812111,
                    55.6467
                ],
                [
                    83.8829985,
                    55.6472388
                ],
                [
                    83.8841949,
                    55.6467769
                ],
                [
                    83.8828517,
                    55.6454386
                ],
                [
                    83.884048,
                    55.6444556
                ],
                [
                    83.8859369,
                    55.6425013
                ],
                [
                    83.8903442,
                    55.641376
                ],
                [
                    83.9018756,
                    55.6342695
                ],
                [
                    83.8927751,
                    55.6317221
                ],
                [
                    83.8838702,
                    55.6351746
                ],
                [
                    83.8753263,
                    55.6398306
                ]
            ],
            "longitude": 83.887138,
            "latitude": 55.637905
        },
        "3696": {
            "name": "Бураново",
            "population": 312,
            "type": "village",
            "poly": [
                [
                    83.8825748,
                    54.2039879
                ],
                [
                    83.8845282,
                    54.2061086
                ],
                [
                    83.8868499,
                    54.2073843
                ],
                [
                    83.8882705,
                    54.208552
                ],
                [
                    83.8909582,
                    54.2082825
                ],
                [
                    83.8938378,
                    54.2093155
                ],
                [
                    83.9002881,
                    54.20707
                ],
                [
                    83.9019391,
                    54.2113138
                ],
                [
                    83.9036669,
                    54.2114037
                ],
                [
                    83.9055866,
                    54.2078784
                ],
                [
                    83.9102324,
                    54.2104157
                ],
                [
                    83.9113842,
                    54.2094951
                ],
                [
                    83.9086582,
                    54.2070475
                ],
                [
                    83.9130736,
                    54.2048019
                ],
                [
                    83.9067385,
                    54.2012536
                ],
                [
                    83.8990979,
                    54.1984237
                ],
                [
                    83.8925323,
                    54.1995467
                ],
                [
                    83.8877714,
                    54.1954364
                ],
                [
                    83.8839703,
                    54.1965819
                ],
                [
                    83.8825748,
                    54.2039879
                ]
            ],
            "longitude": 83.894394,
            "latitude": 54.204353
        },
        "3697": {
            "name": "Участок-Балта",
            "population": 411,
            "type": "village",
            "poly": [
                [
                    83.9258983,
                    55.4207895
                ],
                [
                    83.9266346,
                    55.4250171
                ],
                [
                    83.9285431,
                    55.4299325
                ],
                [
                    83.925972,
                    55.4305064
                ],
                [
                    83.9281752,
                    55.4322936
                ],
                [
                    83.9286215,
                    55.4323993
                ],
                [
                    83.9297198,
                    55.4319914
                ],
                [
                    83.9335153,
                    55.4313369
                ],
                [
                    83.9383643,
                    55.4315925
                ],
                [
                    83.939939,
                    55.4306332
                ],
                [
                    83.9399307,
                    55.4296551
                ],
                [
                    83.9398146,
                    55.4296127
                ],
                [
                    83.9408589,
                    55.4290296
                ],
                [
                    83.9429059,
                    55.4283289
                ],
                [
                    83.9430055,
                    55.4284559
                ],
                [
                    83.9438789,
                    55.4290474
                ],
                [
                    83.9444435,
                    55.4295166
                ],
                [
                    83.9449464,
                    55.4295933
                ],
                [
                    83.9457778,
                    55.4302705
                ],
                [
                    83.9546942,
                    55.4284894
                ],
                [
                    83.9552451,
                    55.4282732
                ],
                [
                    83.9555386,
                    55.4280624
                ],
                [
                    83.9556377,
                    55.4271658
                ],
                [
                    83.9552978,
                    55.4265772
                ],
                [
                    83.9547235,
                    55.4261149
                ],
                [
                    83.9538911,
                    55.4257049
                ],
                [
                    83.9533716,
                    55.4256185
                ],
                [
                    83.952812,
                    55.4256285
                ],
                [
                    83.9515154,
                    55.4258673
                ],
                [
                    83.950839,
                    55.4247307
                ],
                [
                    83.9486686,
                    55.4262885
                ],
                [
                    83.947335,
                    55.4268775
                ],
                [
                    83.9432698,
                    55.4281323
                ],
                [
                    83.9423676,
                    55.428449
                ],
                [
                    83.9409265,
                    55.4289309
                ],
                [
                    83.9400957,
                    55.4293207
                ],
                [
                    83.939746,
                    55.4295414
                ],
                [
                    83.9393524,
                    55.4293906
                ],
                [
                    83.9391963,
                    55.4292462
                ],
                [
                    83.9389121,
                    55.4290777
                ],
                [
                    83.9382236,
                    55.4285712
                ],
                [
                    83.9372519,
                    55.4278514
                ],
                [
                    83.9357455,
                    55.4268594
                ],
                [
                    83.9349888,
                    55.4256977
                ],
                [
                    83.9344858,
                    55.4251239
                ],
                [
                    83.9342371,
                    55.4239387
                ],
                [
                    83.9349657,
                    55.4221442
                ],
                [
                    83.9344443,
                    55.4212342
                ],
                [
                    83.9342774,
                    55.4201968
                ],
                [
                    83.9345355,
                    55.419268
                ],
                [
                    83.9361682,
                    55.4185671
                ],
                [
                    83.9376185,
                    55.4182237
                ],
                [
                    83.938025,
                    55.4175547
                ],
                [
                    83.9381945,
                    55.4159118
                ],
                [
                    83.9380374,
                    55.415562
                ],
                [
                    83.9315136,
                    55.4151866
                ],
                [
                    83.931472,
                    55.4159329
                ],
                [
                    83.9310214,
                    55.4159384
                ],
                [
                    83.9309628,
                    55.4163708
                ],
                [
                    83.9303298,
                    55.417708
                ],
                [
                    83.928138,
                    55.4174286
                ],
                [
                    83.9261008,
                    55.4184286
                ],
                [
                    83.9258983,
                    55.4207895
                ]
            ],
            "longitude": 83.931267,
            "latitude": 55.430286
        },
        "3698": {
            "name": "Чемское",
            "population": 510,
            "type": "village",
            "poly": [
                [
                    83.9375365,
                    54.8535625
                ],
                [
                    83.9381412,
                    54.8546416
                ],
                [
                    83.9389273,
                    54.8543109
                ],
                [
                    83.9386854,
                    54.8539628
                ],
                [
                    83.9419508,
                    54.8534406
                ],
                [
                    83.9421322,
                    54.8538583
                ],
                [
                    83.9433114,
                    54.8536321
                ],
                [
                    83.9440975,
                    54.8541542
                ],
                [
                    83.943765,
                    54.8543283
                ],
                [
                    83.9442185,
                    54.8554248
                ],
                [
                    83.9450651,
                    54.8554422
                ],
                [
                    83.9466676,
                    54.8570434
                ],
                [
                    83.9482398,
                    54.8564865
                ],
                [
                    83.9483988,
                    54.8565807
                ],
                [
                    83.9495829,
                    54.8572045
                ],
                [
                    83.950447,
                    54.856939
                ],
                [
                    83.9512633,
                    54.8565039
                ],
                [
                    83.9516564,
                    54.8560688
                ],
                [
                    83.953924,
                    54.8552159
                ],
                [
                    83.9538333,
                    54.8548156
                ],
                [
                    83.9557684,
                    54.8535973
                ],
                [
                    83.9563429,
                    54.8521178
                ],
                [
                    83.9577942,
                    54.8515782
                ],
                [
                    83.9585501,
                    54.8522396
                ],
                [
                    83.9591548,
                    54.852083
                ],
                [
                    83.9596083,
                    54.8516478
                ],
                [
                    83.9612712,
                    54.8526399
                ],
                [
                    83.9621783,
                    54.8531273
                ],
                [
                    83.9619364,
                    54.8535276
                ],
                [
                    83.9616341,
                    54.8535625
                ],
                [
                    83.9624504,
                    54.8554596
                ],
                [
                    83.9634784,
                    54.8550245
                ],
                [
                    83.9627225,
                    54.8538757
                ],
                [
                    83.9634179,
                    54.8532317
                ],
                [
                    83.9642948,
                    54.8531447
                ],
                [
                    83.9640831,
                    54.8514737
                ],
                [
                    83.9630249,
                    54.8514389
                ],
                [
                    83.9623295,
                    54.8491064
                ],
                [
                    83.9635389,
                    54.8488105
                ],
                [
                    83.9629947,
                    54.8483927
                ],
                [
                    83.9645669,
                    54.8479227
                ],
                [
                    83.9652925,
                    54.8448239
                ],
                [
                    83.9637203,
                    54.844232
                ],
                [
                    83.9648995,
                    54.8427696
                ],
                [
                    83.9629342,
                    54.8423343
                ],
                [
                    83.9627225,
                    54.8418642
                ],
                [
                    83.9617248,
                    54.841516
                ],
                [
                    83.9622388,
                    54.8407325
                ],
                [
                    83.9633575,
                    54.8407325
                ],
                [
                    83.9621481,
                    54.8402276
                ],
                [
                    83.9581268,
                    54.8377551
                ],
                [
                    83.9552846,
                    54.8387999
                ],
                [
                    83.9522309,
                    54.839653
                ],
                [
                    83.9509307,
                    54.8403669
                ],
                [
                    83.9497516,
                    54.8412549
                ],
                [
                    83.9490259,
                    54.8409066
                ],
                [
                    83.9477863,
                    54.8414464
                ],
                [
                    83.9483003,
                    54.8422995
                ],
                [
                    83.9474537,
                    54.8427348
                ],
                [
                    83.9483003,
                    54.8437271
                ],
                [
                    83.9488445,
                    54.8434834
                ],
                [
                    83.9498423,
                    54.8436923
                ],
                [
                    83.9534403,
                    54.8454507
                ],
                [
                    83.9506586,
                    54.8465126
                ],
                [
                    83.9502353,
                    54.8461296
                ],
                [
                    83.9495701,
                    54.8463211
                ],
                [
                    83.9486329,
                    54.8467737
                ],
                [
                    83.9438557,
                    54.8475397
                ],
                [
                    83.9441278,
                    54.8484623
                ],
                [
                    83.9407112,
                    54.8480097
                ],
                [
                    83.9403786,
                    54.8470871
                ],
                [
                    83.9400158,
                    54.8471915
                ],
                [
                    83.9395018,
                    54.8480793
                ],
                [
                    83.9382319,
                    54.8479749
                ],
                [
                    83.9377481,
                    54.8485842
                ],
                [
                    83.9386552,
                    54.8498027
                ],
                [
                    83.9403181,
                    54.8499071
                ],
                [
                    83.9408019,
                    54.8512474
                ],
                [
                    83.9416485,
                    54.851143
                ],
                [
                    83.9420415,
                    54.8522396
                ],
                [
                    83.9375365,
                    54.8535625
                ]
            ],
            "longitude": 83.953316,
            "latitude": 54.849239
        },
        "3699": {
            "name": "Никоново",
            "population": 460,
            "type": "village",
            "poly": [
                [
                    83.9602362,
                    54.4257737
                ],
                [
                    83.960607,
                    54.4281679
                ],
                [
                    83.9624609,
                    54.4298503
                ],
                [
                    83.9668732,
                    54.4333011
                ],
                [
                    83.9678001,
                    54.4353714
                ],
                [
                    83.9687641,
                    54.4373769
                ],
                [
                    83.9700619,
                    54.4378729
                ],
                [
                    83.9633879,
                    54.4399861
                ],
                [
                    83.9627204,
                    54.441668
                ],
                [
                    83.9669844,
                    54.4434791
                ],
                [
                    83.9703214,
                    54.4415817
                ],
                [
                    83.9727315,
                    54.4398783
                ],
                [
                    83.9773292,
                    54.4423148
                ],
                [
                    83.9760685,
                    54.4434791
                ],
                [
                    83.9798504,
                    54.445204
                ],
                [
                    83.9841144,
                    54.4452255
                ],
                [
                    83.9876368,
                    54.4431126
                ],
                [
                    83.9854121,
                    54.4404174
                ],
                [
                    83.9823717,
                    54.4387139
                ],
                [
                    83.9835582,
                    54.4386707
                ],
                [
                    83.983447,
                    54.4367084
                ],
                [
                    83.9785898,
                    54.4337324
                ],
                [
                    83.9720641,
                    54.4310365
                ],
                [
                    83.9738438,
                    54.4293758
                ],
                [
                    83.9697282,
                    54.426464
                ],
                [
                    83.9621272,
                    54.4251697
                ],
                [
                    83.9602362,
                    54.4257737
                ]
            ],
            "longitude": 83.973312,
            "latitude": 54.436977
        },
        "3700": {
            "name": "Берёзово",
            "population": 502,
            "type": "village",
            "poly": [
                [
                    83.9723405,
                    54.5169165
                ],
                [
                    83.9725629,
                    54.5181863
                ],
                [
                    83.9751584,
                    54.5183585
                ],
                [
                    83.9757146,
                    54.5193269
                ],
                [
                    83.9764584,
                    54.5193421
                ],
                [
                    83.977828,
                    54.51937
                ],
                [
                    83.9780134,
                    54.5222537
                ],
                [
                    83.9797561,
                    54.524255
                ],
                [
                    83.9820549,
                    54.524836
                ],
                [
                    83.9835751,
                    54.5233082
                ],
                [
                    83.9829077,
                    54.5210486
                ],
                [
                    83.9807942,
                    54.5195852
                ],
                [
                    83.9810909,
                    54.5182724
                ],
                [
                    83.9842425,
                    54.5184876
                ],
                [
                    83.9862818,
                    54.5182078
                ],
                [
                    83.9859967,
                    54.5171323
                ],
                [
                    83.985911,
                    54.5168089
                ],
                [
                    83.9831302,
                    54.5151516
                ],
                [
                    83.9849099,
                    54.5145059
                ],
                [
                    83.9850211,
                    54.5135589
                ],
                [
                    83.9868379,
                    54.5128055
                ],
                [
                    83.9886918,
                    54.5113634
                ],
                [
                    83.9866891,
                    54.5104946
                ],
                [
                    83.9848196,
                    54.5101173
                ],
                [
                    83.9762671,
                    54.5083911
                ],
                [
                    83.9757705,
                    54.5101368
                ],
                [
                    83.9758926,
                    54.5109302
                ],
                [
                    83.975262,
                    54.5129277
                ],
                [
                    83.9753438,
                    54.515001
                ],
                [
                    83.974795,
                    54.5164576
                ],
                [
                    83.9723405,
                    54.5169165
                ]
            ],
            "longitude": 83.98011,
            "latitude": 54.513268
        },
        "3701": {
            "name": "Новососедово",
            "population": 156,
            "type": "village",
            "poly": [
                [
                    83.9657478,
                    54.6353451
                ],
                [
                    83.968557,
                    54.6379089
                ],
                [
                    83.9700696,
                    54.6395112
                ],
                [
                    83.971096,
                    54.6396285
                ],
                [
                    83.970604,
                    54.6411145
                ],
                [
                    83.972994,
                    54.6425971
                ],
                [
                    83.9755568,
                    54.6426351
                ],
                [
                    83.9757775,
                    54.6429064
                ],
                [
                    83.976506,
                    54.6435841
                ],
                [
                    83.9769052,
                    54.6435946
                ],
                [
                    83.9764788,
                    54.6448741
                ],
                [
                    83.977576,
                    54.6447081
                ],
                [
                    83.9788085,
                    54.6451086
                ],
                [
                    83.9795682,
                    54.6456654
                ],
                [
                    83.9809695,
                    54.6469548
                ],
                [
                    83.9776605,
                    54.6488498
                ],
                [
                    83.9794163,
                    54.6498266
                ],
                [
                    83.9784135,
                    54.6505852
                ],
                [
                    83.9798215,
                    54.6511159
                ],
                [
                    83.9794838,
                    54.6513308
                ],
                [
                    83.9797033,
                    54.6515847
                ],
                [
                    83.9802604,
                    54.6513405
                ],
                [
                    83.9806656,
                    54.6524247
                ],
                [
                    83.9824706,
                    54.653571
                ],
                [
                    83.9835083,
                    54.652675
                ],
                [
                    83.9837244,
                    54.6520421
                ],
                [
                    83.9836434,
                    54.6514639
                ],
                [
                    83.9841296,
                    54.6508935
                ],
                [
                    83.9849535,
                    54.6497917
                ],
                [
                    83.9864121,
                    54.6491587
                ],
                [
                    83.9890997,
                    54.6496198
                ],
                [
                    83.9915713,
                    54.6499714
                ],
                [
                    83.9928812,
                    54.6505184
                ],
                [
                    83.9932624,
                    54.6497707
                ],
                [
                    83.9925656,
                    54.6487937
                ],
                [
                    83.9900861,
                    54.648
                ],
                [
                    83.9897168,
                    54.6463516
                ],
                [
                    83.9893185,
                    54.6440987
                ],
                [
                    83.9896376,
                    54.6429784
                ],
                [
                    83.9910304,
                    54.6426742
                ],
                [
                    83.9930404,
                    54.6414366
                ],
                [
                    83.9920117,
                    54.6402459
                ],
                [
                    83.9898838,
                    54.6400134
                ],
                [
                    83.9862974,
                    54.6426174
                ],
                [
                    83.9830561,
                    54.6413383
                ],
                [
                    83.9848854,
                    54.6403163
                ],
                [
                    83.9861415,
                    54.638542
                ],
                [
                    83.9883013,
                    54.6354726
                ],
                [
                    83.9818806,
                    54.6357931
                ],
                [
                    83.9771466,
                    54.6364003
                ],
                [
                    83.9765254,
                    54.6361033
                ],
                [
                    83.9755124,
                    54.6360329
                ],
                [
                    83.9740133,
                    54.636416
                ],
                [
                    83.9724601,
                    54.6362205
                ],
                [
                    83.9702722,
                    54.6356421
                ],
                [
                    83.9699751,
                    54.6357984
                ],
                [
                    83.9678276,
                    54.6346884
                ],
                [
                    83.9657478,
                    54.6353451
                ]
            ],
            "longitude": 83.984161,
            "latitude": 54.644833
        },
        "3702": {
            "name": "Пеньково",
            "population": 474,
            "type": "village",
            "poly": [
                [
                    83.975234,
                    54.3365426
                ],
                [
                    83.9789207,
                    54.3386597
                ],
                [
                    83.9774793,
                    54.3399363
                ],
                [
                    83.9872234,
                    54.3422364
                ],
                [
                    83.987486,
                    54.3416492
                ],
                [
                    83.9868761,
                    54.3412937
                ],
                [
                    83.988567,
                    54.3405665
                ],
                [
                    83.9907568,
                    54.3412937
                ],
                [
                    83.9920042,
                    54.3403403
                ],
                [
                    83.9919765,
                    54.3393384
                ],
                [
                    83.9912558,
                    54.3375608
                ],
                [
                    83.9918102,
                    54.3353144
                ],
                [
                    83.9938891,
                    54.3342316
                ],
                [
                    83.9920597,
                    54.3332942
                ],
                [
                    83.9904519,
                    54.3327931
                ],
                [
                    83.9890105,
                    54.3325184
                ],
                [
                    83.9870702,
                    54.3331487
                ],
                [
                    83.9863495,
                    54.3318234
                ],
                [
                    83.98768,
                    54.3315486
                ],
                [
                    83.9911172,
                    54.32872
                ],
                [
                    83.9896204,
                    54.3281381
                ],
                [
                    83.9853239,
                    54.3306596
                ],
                [
                    83.9860723,
                    54.3329386
                ],
                [
                    83.9820807,
                    54.3339245
                ],
                [
                    83.9784495,
                    54.3348134
                ],
                [
                    83.9779228,
                    54.335573
                ],
                [
                    83.9837716,
                    54.3376577
                ],
                [
                    83.9830786,
                    54.3380617
                ],
                [
                    83.9879849,
                    54.3400656
                ],
                [
                    83.9857951,
                    54.3407604
                ],
                [
                    83.9856842,
                    54.3403403
                ],
                [
                    83.9830509,
                    54.3390475
                ],
                [
                    83.9791702,
                    54.3376901
                ],
                [
                    83.9758716,
                    54.3360578
                ],
                [
                    83.975234,
                    54.3365426
                ]
            ],
            "longitude": 83.988861,
            "latitude": 54.336498
        },
        "3703": {
            "name": "Владимировка",
            "population": 515,
            "type": "village",
            "poly": [
                [
                    83.9823106,
                    54.9539844
                ],
                [
                    83.9869006,
                    54.9578215
                ],
                [
                    83.9877106,
                    54.9580153
                ],
                [
                    83.9898031,
                    54.9611545
                ],
                [
                    83.9890606,
                    54.9615033
                ],
                [
                    83.9901406,
                    54.9621233
                ],
                [
                    83.9867153,
                    54.9654364
                ],
                [
                    83.9894068,
                    54.9657028
                ],
                [
                    83.9925705,
                    54.9640609
                ],
                [
                    83.9950681,
                    54.9652234
                ],
                [
                    83.9966881,
                    54.9656109
                ],
                [
                    83.9974981,
                    54.9653397
                ],
                [
                    83.9992531,
                    54.9663472
                ],
                [
                    83.9989156,
                    54.9666572
                ],
                [
                    84.0038431,
                    54.9671221
                ],
                [
                    84.0060031,
                    54.9667734
                ],
                [
                    84.0082306,
                    54.9645647
                ],
                [
                    84.0108631,
                    54.9654947
                ],
                [
                    84.0114706,
                    54.9648747
                ],
                [
                    84.0098505,
                    54.9642547
                ],
                [
                    84.0061381,
                    54.9632471
                ],
                [
                    84.0014805,
                    54.9625496
                ],
                [
                    84.0024256,
                    54.9611545
                ],
                [
                    84.0055981,
                    54.959333
                ],
                [
                    84.0066781,
                    54.9582091
                ],
                [
                    84.0062056,
                    54.9573564
                ],
                [
                    84.0043156,
                    54.95631
                ],
                [
                    84.0028306,
                    54.9560386
                ],
                [
                    84.0024748,
                    54.9560488
                ],
                [
                    84.0013455,
                    54.9556511
                ],
                [
                    84.0005356,
                    54.9557286
                ],
                [
                    83.9999281,
                    54.9568913
                ],
                [
                    83.9991181,
                    54.9568138
                ],
                [
                    83.9964856,
                    54.9550697
                ],
                [
                    83.9939881,
                    54.9544883
                ],
                [
                    83.9912206,
                    54.9546045
                ],
                [
                    83.9846056,
                    54.9528603
                ],
                [
                    83.9823106,
                    54.9539844
                ]
            ],
            "longitude": 83.999741,
            "latitude": 54.963802
        },
        "3704": {
            "name": "Светлая Поляна",
            "population": 867,
            "type": "village",
            "poly": [
                [
                    84.0181299,
                    55.492583
                ],
                [
                    84.0184597,
                    55.4935224
                ],
                [
                    84.0286175,
                    55.495421
                ],
                [
                    84.0321916,
                    55.4958666
                ],
                [
                    84.0341165,
                    55.4958179
                ],
                [
                    84.0340522,
                    55.4951369
                ],
                [
                    84.036724,
                    55.4952231
                ],
                [
                    84.0371651,
                    55.4935762
                ],
                [
                    84.0414946,
                    55.4925222
                ],
                [
                    84.0410652,
                    55.4914276
                ],
                [
                    84.0400276,
                    55.4905762
                ],
                [
                    84.0383038,
                    55.4906457
                ],
                [
                    84.0369147,
                    55.4895829
                ],
                [
                    84.0366813,
                    55.4842256
                ],
                [
                    84.0338375,
                    55.4844538
                ],
                [
                    84.0335155,
                    55.4836834
                ],
                [
                    84.0326568,
                    55.4836023
                ],
                [
                    84.0321295,
                    55.4815147
                ],
                [
                    84.0270842,
                    55.4817439
                ],
                [
                    84.0270822,
                    55.4822885
                ],
                [
                    84.028084,
                    55.4827751
                ],
                [
                    84.0257792,
                    55.4832252
                ],
                [
                    84.0258227,
                    55.4834888
                ],
                [
                    84.0277692,
                    55.4834563
                ],
                [
                    84.028313,
                    55.4840078
                ],
                [
                    84.0255365,
                    55.4842673
                ],
                [
                    84.0242126,
                    55.4847985
                ],
                [
                    84.0259658,
                    55.4899681
                ],
                [
                    84.0209208,
                    55.4904951
                ],
                [
                    84.0211569,
                    55.4914681
                ],
                [
                    84.0221302,
                    55.4917762
                ],
                [
                    84.0205272,
                    55.4918087
                ],
                [
                    84.0207562,
                    55.4922789
                ],
                [
                    84.0221731,
                    55.4930492
                ],
                [
                    84.0181299,
                    55.492583
                ]
            ],
            "longitude": 84.030617,
            "latitude": 55.488674
        },
        "3705": {
            "name": "Борково",
            "population": 640,
            "type": "village",
            "poly": [
                [
                    84.0418732,
                    54.2261191
                ],
                [
                    84.0432158,
                    54.2269039
                ],
                [
                    84.0532615,
                    54.2279864
                ],
                [
                    84.0576595,
                    54.2285818
                ],
                [
                    84.0571039,
                    54.2290959
                ],
                [
                    84.0549744,
                    54.2285547
                ],
                [
                    84.0466415,
                    54.2289336
                ],
                [
                    84.046086,
                    54.2302054
                ],
                [
                    84.0567336,
                    54.2312878
                ],
                [
                    84.0604834,
                    54.2338854
                ],
                [
                    84.0626129,
                    54.2368346
                ],
                [
                    84.0627055,
                    54.2381603
                ],
                [
                    84.0647425,
                    54.2383497
                ],
                [
                    84.0652054,
                    54.2348866
                ],
                [
                    84.0640018,
                    54.233236
                ],
                [
                    84.0623352,
                    54.2306925
                ],
                [
                    84.0633536,
                    54.2283382
                ],
                [
                    84.0670109,
                    54.225226
                ],
                [
                    84.0658998,
                    54.2230068
                ],
                [
                    84.0661313,
                    54.2196776
                ],
                [
                    84.0635851,
                    54.2169438
                ],
                [
                    84.0622426,
                    54.2151842
                ],
                [
                    84.0601131,
                    54.2109611
                ],
                [
                    84.0573354,
                    54.2115026
                ],
                [
                    84.0574743,
                    54.2133434
                ],
                [
                    84.0573816,
                    54.2156986
                ],
                [
                    84.0593261,
                    54.2191904
                ],
                [
                    84.0524283,
                    54.2196776
                ],
                [
                    84.0538171,
                    54.2211122
                ],
                [
                    84.0476137,
                    54.2206791
                ],
                [
                    84.0469193,
                    54.2234939
                ],
                [
                    84.0486321,
                    54.2237916
                ],
                [
                    84.0482155,
                    54.2251448
                ],
                [
                    84.0424751,
                    54.2250366
                ],
                [
                    84.0418732,
                    54.2261191
                ]
            ],
            "longitude": 84.058327,
            "latitude": 54.224659
        },
        "3706": {
            "name": "Новая Чебула",
            "population": 277,
            "type": "village",
            "poly": [
                [
                    84.0569147,
                    55.5574933
                ],
                [
                    84.0590391,
                    55.5583786
                ],
                [
                    84.0598777,
                    55.55743
                ],
                [
                    84.0608767,
                    55.557801
                ],
                [
                    84.0611698,
                    55.557496
                ],
                [
                    84.0634913,
                    55.5584907
                ],
                [
                    84.062225,
                    55.5590543
                ],
                [
                    84.0659065,
                    55.5608976
                ],
                [
                    84.0663387,
                    55.5604639
                ],
                [
                    84.069881,
                    55.5621637
                ],
                [
                    84.0710617,
                    55.5612936
                ],
                [
                    84.0718131,
                    55.5616376
                ],
                [
                    84.0726003,
                    55.5614554
                ],
                [
                    84.074282,
                    55.5623255
                ],
                [
                    84.0753554,
                    55.5625076
                ],
                [
                    84.0748545,
                    55.5628111
                ],
                [
                    84.076715,
                    55.5643691
                ],
                [
                    84.0785398,
                    55.563924
                ],
                [
                    84.0803647,
                    55.5625279
                ],
                [
                    84.0795417,
                    55.562022
                ],
                [
                    84.0795775,
                    55.5616376
                ],
                [
                    84.0791481,
                    55.5614757
                ],
                [
                    84.0794701,
                    55.5612126
                ],
                [
                    84.0746398,
                    55.559351
                ],
                [
                    84.0741031,
                    55.5595938
                ],
                [
                    84.0719562,
                    55.5587034
                ],
                [
                    84.0723856,
                    55.5582785
                ],
                [
                    84.0722425,
                    55.5579142
                ],
                [
                    84.0705608,
                    55.5570036
                ],
                [
                    84.0694874,
                    55.5571655
                ],
                [
                    84.067591,
                    55.5560727
                ],
                [
                    84.067913,
                    55.5558703
                ],
                [
                    84.0653011,
                    55.5539881
                ],
                [
                    84.0647286,
                    55.5542108
                ],
                [
                    84.0620808,
                    55.5547774
                ],
                [
                    84.061401,
                    55.5555667
                ],
                [
                    84.0608643,
                    55.555081
                ],
                [
                    84.0598982,
                    55.5550203
                ],
                [
                    84.0597193,
                    55.5552632
                ],
                [
                    84.0587174,
                    55.5547977
                ],
                [
                    84.0580734,
                    55.5549798
                ],
                [
                    84.0570715,
                    55.5565179
                ],
                [
                    84.0569147,
                    55.5574933
                ]
            ],
            "longitude": 84.06855,
            "latitude": 55.559055
        },
        "3707": {
            "name": "Кайлы",
            "population": 514,
            "type": "village",
            "poly": [
                [
                    84.0760518,
                    55.286927
                ],
                [
                    84.0782928,
                    55.2888668
                ],
                [
                    84.0775889,
                    55.2906644
                ],
                [
                    84.0762551,
                    55.2930675
                ],
                [
                    84.0789636,
                    55.2940368
                ],
                [
                    84.0820956,
                    55.2963258
                ],
                [
                    84.0811111,
                    55.2969651
                ],
                [
                    84.0807747,
                    55.2984637
                ],
                [
                    84.0812909,
                    55.2993709
                ],
                [
                    84.0860314,
                    55.3007922
                ],
                [
                    84.0908809,
                    55.3014676
                ],
                [
                    84.0950081,
                    55.3011152
                ],
                [
                    84.0960657,
                    55.3030975
                ],
                [
                    84.0936117,
                    55.3031974
                ],
                [
                    84.0933314,
                    55.3039932
                ],
                [
                    84.0957035,
                    55.3047981
                ],
                [
                    84.0979745,
                    55.3037876
                ],
                [
                    84.0996253,
                    55.3044337
                ],
                [
                    84.1014567,
                    55.3043897
                ],
                [
                    84.1034946,
                    55.3049329
                ],
                [
                    84.1047495,
                    55.3044225
                ],
                [
                    84.1058162,
                    55.3047714
                ],
                [
                    84.1063735,
                    55.304477
                ],
                [
                    84.1071058,
                    55.3047127
                ],
                [
                    84.1078621,
                    55.3042935
                ],
                [
                    84.1005798,
                    55.3018494
                ],
                [
                    84.098382,
                    55.3001195
                ],
                [
                    84.0977939,
                    55.3001314
                ],
                [
                    84.0952918,
                    55.2981636
                ],
                [
                    84.0953434,
                    55.2969153
                ],
                [
                    84.0945147,
                    55.2961472
                ],
                [
                    84.0937957,
                    55.2962985
                ],
                [
                    84.0919127,
                    55.2952411
                ],
                [
                    84.0924802,
                    55.2948152
                ],
                [
                    84.0900296,
                    55.2933172
                ],
                [
                    84.089983,
                    55.2926773
                ],
                [
                    84.0905197,
                    55.2907762
                ],
                [
                    84.0875791,
                    55.2884408
                ],
                [
                    84.0861346,
                    55.2889402
                ],
                [
                    84.0846643,
                    55.2878239
                ],
                [
                    84.0853563,
                    55.2873754
                ],
                [
                    84.0826781,
                    55.2862227
                ],
                [
                    84.0808724,
                    55.2860318
                ],
                [
                    84.0795052,
                    55.2854588
                ],
                [
                    84.0771064,
                    55.2849006
                ],
                [
                    84.0763067,
                    55.2856057
                ],
                [
                    84.0771842,
                    55.2861913
                ],
                [
                    84.0760518,
                    55.286927
                ]
            ],
            "longitude": 84.082893,
            "latitude": 55.29488
        },
        "3708": {
            "name": "Борцово",
            "population": 776,
            "type": "village",
            "poly": [
                [
                    84.0788035,
                    55.1446007
                ],
                [
                    84.0801505,
                    55.1468245
                ],
                [
                    84.0797015,
                    55.1469956
                ],
                [
                    84.0802004,
                    55.1478793
                ],
                [
                    84.0820462,
                    55.1493618
                ],
                [
                    84.0820462,
                    55.150217
                ],
                [
                    84.0828943,
                    55.1511292
                ],
                [
                    84.0836123,
                    55.1514143
                ],
                [
                    84.0859374,
                    55.1523549
                ],
                [
                    84.0877334,
                    55.152811
                ],
                [
                    84.0893297,
                    55.1531816
                ],
                [
                    84.0899783,
                    55.1540082
                ],
                [
                    84.0936201,
                    55.1536662
                ],
                [
                    84.0961144,
                    55.1564025
                ],
                [
                    84.0976609,
                    55.1572861
                ],
                [
                    84.0978605,
                    55.1589677
                ],
                [
                    84.0992573,
                    55.1593667
                ],
                [
                    84.1008537,
                    55.1583976
                ],
                [
                    84.1002301,
                    55.1560961
                ],
                [
                    84.0971745,
                    55.1529607
                ],
                [
                    84.0957403,
                    55.1522837
                ],
                [
                    84.0949296,
                    55.1523906
                ],
                [
                    84.0941813,
                    55.1532457
                ],
                [
                    84.0933083,
                    55.1529251
                ],
                [
                    84.0948049,
                    55.1513929
                ],
                [
                    84.0931212,
                    55.1500745
                ],
                [
                    84.0901903,
                    55.1493261
                ],
                [
                    84.0908763,
                    55.148756
                ],
                [
                    84.0931212,
                    55.1485422
                ],
                [
                    84.0959273,
                    55.1493261
                ],
                [
                    84.096526,
                    55.1479577
                ],
                [
                    84.0915871,
                    55.1472165
                ],
                [
                    84.0904397,
                    55.1479007
                ],
                [
                    84.0924851,
                    55.1483854
                ],
                [
                    84.0906892,
                    55.1486134
                ],
                [
                    84.0896914,
                    55.1493261
                ],
                [
                    84.0855508,
                    55.1474161
                ],
                [
                    84.0849022,
                    55.1474161
                ],
                [
                    84.0838546,
                    55.1444796
                ],
                [
                    84.0843535,
                    55.1431395
                ],
                [
                    84.0835054,
                    55.1430825
                ],
                [
                    84.083705,
                    55.1425122
                ],
                [
                    84.0838546,
                    55.1405733
                ],
                [
                    84.083256,
                    55.1396324
                ],
                [
                    84.0815089,
                    55.1396222
                ],
                [
                    84.0796017,
                    55.139611
                ],
                [
                    84.0790031,
                    55.1412648
                ],
                [
                    84.0788035,
                    55.1446007
                ]
            ],
            "longitude": 84.087227,
            "latitude": 55.150513
        },
        "3709": {
            "name": "Пайвино",
            "population": 536,
            "type": "village",
            "poly": [
                [
                    84.1128686,
                    54.3978177
                ],
                [
                    84.1149612,
                    54.3991391
                ],
                [
                    84.1148193,
                    54.3999237
                ],
                [
                    84.1152449,
                    54.4004192
                ],
                [
                    84.1138262,
                    54.4018231
                ],
                [
                    84.1158833,
                    54.4017406
                ],
                [
                    84.1165572,
                    54.4028348
                ],
                [
                    84.1177631,
                    54.4039496
                ],
                [
                    84.1206715,
                    54.4046928
                ],
                [
                    84.1197493,
                    54.4058901
                ],
                [
                    84.1202459,
                    54.4066746
                ],
                [
                    84.1263818,
                    54.4086976
                ],
                [
                    84.1291128,
                    54.4086976
                ],
                [
                    84.1328724,
                    54.4081402
                ],
                [
                    84.1335108,
                    54.40717
                ],
                [
                    84.1320921,
                    54.4053534
                ],
                [
                    84.1295384,
                    54.4049612
                ],
                [
                    84.1259207,
                    54.4035986
                ],
                [
                    84.1263463,
                    54.403227
                ],
                [
                    84.1289,
                    54.4037638
                ],
                [
                    84.1319857,
                    54.4008528
                ],
                [
                    84.1291128,
                    54.3992836
                ],
                [
                    84.1263818,
                    54.400254
                ],
                [
                    84.1259562,
                    54.3992423
                ],
                [
                    84.1249631,
                    54.3986023
                ],
                [
                    84.1226577,
                    54.3976112
                ],
                [
                    84.1207424,
                    54.3971982
                ],
                [
                    84.1173375,
                    54.3957322
                ],
                [
                    84.1160607,
                    54.3964549
                ],
                [
                    84.1159188,
                    54.3971776
                ],
                [
                    84.1142873,
                    54.3967853
                ],
                [
                    84.1128686,
                    54.3978177
                ]
            ],
            "longitude": 84.12188,
            "latitude": 54.40274
        },
        "3710": {
            "name": "Верх-Ики",
            "population": 211,
            "type": "village",
            "poly": [
                [
                    84.1226614,
                    54.6035389
                ],
                [
                    84.1288043,
                    54.6053753
                ],
                [
                    84.1303895,
                    54.6056048
                ],
                [
                    84.1338771,
                    54.6067755
                ],
                [
                    84.1339959,
                    54.6097593
                ],
                [
                    84.1393858,
                    54.6105627
                ],
                [
                    84.1431111,
                    54.6098052
                ],
                [
                    84.1443793,
                    54.6083363
                ],
                [
                    84.1463212,
                    54.6061787
                ],
                [
                    84.1494917,
                    54.6072116
                ],
                [
                    84.1517903,
                    54.6051457
                ],
                [
                    84.1487305,
                    54.6048835
                ],
                [
                    84.1431111,
                    54.6043193
                ],
                [
                    84.140654,
                    54.6048932
                ],
                [
                    84.1325296,
                    54.6021615
                ],
                [
                    84.129795,
                    54.6011973
                ],
                [
                    84.1227803,
                    54.6028272
                ],
                [
                    84.1226614,
                    54.6035389
                ]
            ],
            "longitude": 84.1332887,
            "latitude": 54.603889
        },
        "3711": {
            "name": "Златоуст",
            "population": 460,
            "type": "village",
            "poly": [
                [
                    84.1201426,
                    55.254056
                ],
                [
                    84.1303765,
                    55.2608739
                ],
                [
                    84.1347006,
                    55.2590669
                ],
                [
                    84.143493,
                    55.262763
                ],
                [
                    84.1453668,
                    55.2621059
                ],
                [
                    84.1504117,
                    55.2635843
                ],
                [
                    84.1540151,
                    55.26342
                ],
                [
                    84.15488,
                    55.2602168
                ],
                [
                    84.1460211,
                    55.256165
                ],
                [
                    84.129944,
                    55.2501948
                ],
                [
                    84.1254758,
                    55.2507699
                ],
                [
                    84.1201426,
                    55.254056
                ]
            ],
            "longitude": 84.142738,
            "latitude": 55.259163
        },
        "3712": {
            "name": "Карасево",
            "population": 539,
            "type": "village",
            "poly": [
                [
                    84.1514673,
                    55.722275
                ],
                [
                    84.1524031,
                    55.7229098
                ],
                [
                    84.1529723,
                    55.7236312
                ],
                [
                    84.154377,
                    55.723716
                ],
                [
                    84.1548786,
                    55.724394
                ],
                [
                    84.1560325,
                    55.7256089
                ],
                [
                    84.1570358,
                    55.7257501
                ],
                [
                    84.1582398,
                    55.7254111
                ],
                [
                    84.1582899,
                    55.7258914
                ],
                [
                    84.1590424,
                    55.7256371
                ],
                [
                    84.1607577,
                    55.7269543
                ],
                [
                    84.1612497,
                    55.7273322
                ],
                [
                    84.1613501,
                    55.7279537
                ],
                [
                    84.1649119,
                    55.7276712
                ],
                [
                    84.1662615,
                    55.7272182
                ],
                [
                    84.1641917,
                    55.7241416
                ],
                [
                    84.1654068,
                    55.7229292
                ],
                [
                    84.1639086,
                    55.7219238
                ],
                [
                    84.1652129,
                    55.7215122
                ],
                [
                    84.1655139,
                    55.7212579
                ],
                [
                    84.1669185,
                    55.7209753
                ],
                [
                    84.1686242,
                    55.7214557
                ],
                [
                    84.1703298,
                    55.7209188
                ],
                [
                    84.1709318,
                    55.7210036
                ],
                [
                    84.1734402,
                    55.7201277
                ],
                [
                    84.1727378,
                    55.7195626
                ],
                [
                    84.1750455,
                    55.7189692
                ],
                [
                    84.1775036,
                    55.7178107
                ],
                [
                    84.1771382,
                    55.7166815
                ],
                [
                    84.176099,
                    55.7158044
                ],
                [
                    84.1710322,
                    55.7154653
                ],
                [
                    84.1705807,
                    55.7159739
                ],
                [
                    84.1681225,
                    55.7158609
                ],
                [
                    84.1666175,
                    55.7162
                ],
                [
                    84.1659654,
                    55.7166521
                ],
                [
                    84.1659654,
                    55.7174433
                ],
                [
                    84.1642096,
                    55.7176976
                ],
                [
                    84.1627046,
                    55.7179802
                ],
                [
                    84.1620022,
                    55.7175281
                ],
                [
                    84.1601963,
                    55.7180367
                ],
                [
                    84.1598953,
                    55.7177542
                ],
                [
                    84.1569856,
                    55.7182628
                ],
                [
                    84.1565843,
                    55.7178107
                ],
                [
                    84.1560325,
                    55.7177824
                ],
                [
                    84.1555308,
                    55.717189
                ],
                [
                    84.153173,
                    55.7176411
                ],
                [
                    84.1528218,
                    55.7183193
                ],
                [
                    84.1531228,
                    55.7194496
                ],
                [
                    84.1541261,
                    55.7204385
                ],
                [
                    84.1533235,
                    55.7208341
                ],
                [
                    84.1538251,
                    55.7213144
                ],
                [
                    84.1520192,
                    55.7216535
                ],
                [
                    84.1514673,
                    55.722275
                ]
            ],
            "longitude": 84.159157,
            "latitude": 55.721443
        },
        "3713": {
            "name": "Чупино",
            "population": 579,
            "type": "village",
            "poly": [
                [
                    84.1367865,
                    54.4063021
                ],
                [
                    84.1407721,
                    54.4084362
                ],
                [
                    84.1674889,
                    54.4013003
                ],
                [
                    84.1736619,
                    54.4041808
                ],
                [
                    84.1765188,
                    54.4032009
                ],
                [
                    84.1726925,
                    54.3972019
                ],
                [
                    84.164887,
                    54.394707
                ],
                [
                    84.1642254,
                    54.3915175
                ],
                [
                    84.1705849,
                    54.3907101
                ],
                [
                    84.1678747,
                    54.387461
                ],
                [
                    84.1640484,
                    54.388575
                ],
                [
                    84.1594251,
                    54.3862078
                ],
                [
                    84.1531277,
                    54.3917776
                ],
                [
                    84.154164,
                    54.395212
                ],
                [
                    84.1523306,
                    54.3982284
                ],
                [
                    84.1481058,
                    54.3989245
                ],
                [
                    84.139417,
                    54.3979036
                ],
                [
                    84.1374242,
                    54.4014766
                ],
                [
                    84.1367865,
                    54.4063021
                ]
            ],
            "longitude": 84.161758,
            "latitude": 54.399105
        },
        "3714": {
            "name": "Кривояш",
            "population": 426,
            "type": "village",
            "poly": [
                [
                    84.1678883,
                    55.5081833
                ],
                [
                    84.1696396,
                    55.5102699
                ],
                [
                    84.1733955,
                    55.5089798
                ],
                [
                    84.1846633,
                    55.5109672
                ],
                [
                    84.185685,
                    55.5110988
                ],
                [
                    84.1865192,
                    55.5112062
                ],
                [
                    84.1884808,
                    55.5105837
                ],
                [
                    84.1819082,
                    55.4991929
                ],
                [
                    84.1793028,
                    55.4975346
                ],
                [
                    84.1708601,
                    55.4956125
                ],
                [
                    84.1700118,
                    55.4966193
                ],
                [
                    84.1717488,
                    55.4980609
                ],
                [
                    84.1724759,
                    55.4987931
                ],
                [
                    84.1718445,
                    55.5022067
                ],
                [
                    84.1704134,
                    55.5051685
                ],
                [
                    84.1678883,
                    55.5081833
                ]
            ],
            "longitude": 84.180214,
            "latitude": 55.506416
        },
        "3715": {
            "name": "Дергаусово",
            "population": 469,
            "type": "village",
            "poly": [
                [
                    84.1590623,
                    54.8703197
                ],
                [
                    84.16307,
                    54.8727227
                ],
                [
                    84.1647313,
                    54.8734138
                ],
                [
                    84.17003,
                    54.8738336
                ],
                [
                    84.1712076,
                    54.8740807
                ],
                [
                    84.1725412,
                    54.8738477
                ],
                [
                    84.176125,
                    54.8760126
                ],
                [
                    84.1766685,
                    54.8764369
                ],
                [
                    84.1768908,
                    54.8766105
                ],
                [
                    84.1798644,
                    54.8784755
                ],
                [
                    84.181896,
                    54.8787035
                ],
                [
                    84.183047,
                    54.8777262
                ],
                [
                    84.1862459,
                    54.8747851
                ],
                [
                    84.1889209,
                    54.8733601
                ],
                [
                    84.1916278,
                    54.8718894
                ],
                [
                    84.191985,
                    54.8708251
                ],
                [
                    84.1942394,
                    54.8703638
                ],
                [
                    84.1987084,
                    54.8706013
                ],
                [
                    84.1995895,
                    54.8700212
                ],
                [
                    84.198819,
                    54.8694063
                ],
                [
                    84.1978347,
                    54.869235
                ],
                [
                    84.1967591,
                    54.8692259
                ],
                [
                    84.1960447,
                    54.8690272
                ],
                [
                    84.1958224,
                    54.86868
                ],
                [
                    84.19544,
                    54.8684943
                ],
                [
                    84.1951397,
                    54.8683344
                ],
                [
                    84.1949881,
                    54.8677756
                ],
                [
                    84.1948225,
                    54.8674171
                ],
                [
                    84.19599,
                    54.8642902
                ],
                [
                    84.1946878,
                    54.8609822
                ],
                [
                    84.1938571,
                    54.8586238
                ],
                [
                    84.1875594,
                    54.8601681
                ],
                [
                    84.1868185,
                    54.8606269
                ],
                [
                    84.1834283,
                    54.860362
                ],
                [
                    84.1796515,
                    54.8608295
                ],
                [
                    84.1761827,
                    54.8624577
                ],
                [
                    84.1754081,
                    54.8629875
                ],
                [
                    84.175258,
                    54.8678328
                ],
                [
                    84.1734481,
                    54.8688012
                ],
                [
                    84.1661929,
                    54.8675404
                ],
                [
                    84.1626366,
                    54.8684906
                ],
                [
                    84.1590623,
                    54.8703197
                ]
            ],
            "longitude": 84.182976,
            "latitude": 54.872314
        },
        "3716": {
            "name": "Егоровка",
            "population": 675,
            "type": "village",
            "poly": [
                [
                    84.2024025,
                    55.6211558
                ],
                [
                    84.204475,
                    55.6214483
                ],
                [
                    84.204475,
                    55.621975
                ],
                [
                    84.204924,
                    55.621975
                ],
                [
                    84.2052694,
                    55.6233012
                ],
                [
                    84.2062712,
                    55.6233012
                ],
                [
                    84.2063402,
                    55.6231062
                ],
                [
                    84.2071692,
                    55.6230867
                ],
                [
                    84.2069274,
                    55.6235547
                ],
                [
                    84.2087236,
                    55.6239253
                ],
                [
                    84.2099671,
                    55.6239643
                ],
                [
                    84.2102434,
                    55.6244519
                ],
                [
                    84.2122469,
                    55.625115
                ],
                [
                    84.2122123,
                    55.6241008
                ],
                [
                    84.2130068,
                    55.6240813
                ],
                [
                    84.2130068,
                    55.6244519
                ],
                [
                    84.2136976,
                    55.6244519
                ],
                [
                    84.2136631,
                    55.625349
                ],
                [
                    84.2150102,
                    55.62531
                ],
                [
                    84.2163228,
                    55.6246079
                ],
                [
                    84.2168755,
                    55.6246469
                ],
                [
                    84.2179462,
                    55.6241593
                ],
                [
                    84.2178426,
                    55.6238083
                ],
                [
                    84.2208823,
                    55.6239058
                ],
                [
                    84.2209168,
                    55.6243544
                ],
                [
                    84.2230584,
                    55.6245299
                ],
                [
                    84.223093,
                    55.6238668
                ],
                [
                    84.223542,
                    55.6238083
                ],
                [
                    84.2238183,
                    55.6241008
                ],
                [
                    84.2243365,
                    55.6241008
                ],
                [
                    84.2246473,
                    55.6224821
                ],
                [
                    84.2291187,
                    55.6222283
                ],
                [
                    84.2296542,
                    55.6221999
                ],
                [
                    84.2311757,
                    55.6221115
                ],
                [
                    84.2302085,
                    55.6217019
                ],
                [
                    84.2299322,
                    55.621936
                ],
                [
                    84.2281015,
                    55.6211753
                ],
                [
                    84.2270652,
                    55.6209607
                ],
                [
                    84.2265471,
                    55.6211363
                ],
                [
                    84.2256145,
                    55.6211363
                ],
                [
                    84.2249237,
                    55.6204536
                ],
                [
                    84.2242328,
                    55.6204731
                ],
                [
                    84.2250964,
                    55.6196149
                ],
                [
                    84.2223735,
                    55.6171904
                ],
                [
                    84.2213659,
                    55.616728
                ],
                [
                    84.2208132,
                    55.6168841
                ],
                [
                    84.2204332,
                    55.6166305
                ],
                [
                    84.2209859,
                    55.6162209
                ],
                [
                    84.220675,
                    55.6158307
                ],
                [
                    84.2171172,
                    55.6132947
                ],
                [
                    84.2161846,
                    55.6134313
                ],
                [
                    84.2159774,
                    55.6128265
                ],
                [
                    84.2145612,
                    55.6119096
                ],
                [
                    84.2124541,
                    55.6129436
                ],
                [
                    84.2127001,
                    55.6130535
                ],
                [
                    84.2147684,
                    55.6139775
                ],
                [
                    84.214043,
                    55.6144652
                ],
                [
                    84.2141467,
                    55.6149139
                ],
                [
                    84.2136631,
                    55.6150309
                ],
                [
                    84.2132831,
                    55.6153235
                ],
                [
                    84.212385,
                    55.6150114
                ],
                [
                    84.2116942,
                    55.6153235
                ],
                [
                    84.2121087,
                    55.6157722
                ],
                [
                    84.2133867,
                    55.6164745
                ],
                [
                    84.2149066,
                    55.6160258
                ],
                [
                    84.2154247,
                    55.6162014
                ],
                [
                    84.2159428,
                    55.6161428
                ],
                [
                    84.2167373,
                    55.6162989
                ],
                [
                    84.2167718,
                    55.6168256
                ],
                [
                    84.2172705,
                    55.6170955
                ],
                [
                    84.2176008,
                    55.6172742
                ],
                [
                    84.2174627,
                    55.6174888
                ],
                [
                    84.2168064,
                    55.6174498
                ],
                [
                    84.2167266,
                    55.6175624
                ],
                [
                    84.2161846,
                    55.6183275
                ],
                [
                    84.2153902,
                    55.6183275
                ],
                [
                    84.2149757,
                    55.6192833
                ],
                [
                    84.2144921,
                    55.6195954
                ],
                [
                    84.2139739,
                    55.6195759
                ],
                [
                    84.2134213,
                    55.6190102
                ],
                [
                    84.2130372,
                    55.6190391
                ],
                [
                    84.2118043,
                    55.619132
                ],
                [
                    84.2113488,
                    55.6191663
                ],
                [
                    84.2115215,
                    55.619849
                ],
                [
                    84.210314,
                    55.6197764
                ],
                [
                    84.209898,
                    55.6197514
                ],
                [
                    84.2093799,
                    55.6202001
                ],
                [
                    84.2067547,
                    55.6202196
                ],
                [
                    84.2070311,
                    55.6195369
                ],
                [
                    84.2085854,
                    55.6195759
                ],
                [
                    84.2086675,
                    55.6193094
                ],
                [
                    84.2088618,
                    55.6186786
                ],
                [
                    84.2074592,
                    55.6185101
                ],
                [
                    84.2060678,
                    55.6183429
                ],
                [
                    84.2056149,
                    55.6182885
                ],
                [
                    84.2054422,
                    55.6191663
                ],
                [
                    84.2047859,
                    55.6191663
                ],
                [
                    84.2038532,
                    55.6201025
                ],
                [
                    84.2027479,
                    55.620005
                ],
                [
                    84.2024025,
                    55.6211558
                ]
            ],
            "longitude": 84.217545,
            "latitude": 55.62146
        },
        "3717": {
            "name": "Кудельный Ключ",
            "population": 544,
            "type": "village",
            "poly": null,
            "longitude": 84.255737,
            "latitude": 55.157078
        },
        "3718": {
            "name": "Зудово",
            "population": 314,
            "type": "village",
            "poly": [
                [
                    84.2475094,
                    55.8273098
                ],
                [
                    84.2480717,
                    55.82783
                ],
                [
                    84.2491632,
                    55.8279973
                ],
                [
                    84.2491632,
                    55.8283688
                ],
                [
                    84.2500894,
                    55.8285174
                ],
                [
                    84.2535624,
                    55.8250246
                ],
                [
                    84.2550509,
                    55.8253962
                ],
                [
                    84.2560762,
                    55.8248388
                ],
                [
                    84.2548193,
                    55.8239098
                ],
                [
                    84.2562085,
                    55.8232409
                ],
                [
                    84.2568039,
                    55.8237797
                ],
                [
                    84.2565393,
                    55.8243185
                ],
                [
                    84.2577962,
                    55.8249874
                ],
                [
                    84.2584908,
                    55.8249131
                ],
                [
                    84.2592185,
                    55.8260836
                ],
                [
                    84.2602439,
                    55.8283317
                ],
                [
                    84.2609716,
                    55.8284431
                ],
                [
                    84.2606584,
                    55.8293563
                ],
                [
                    84.2605948,
                    55.8295416
                ],
                [
                    84.260277,
                    55.8304681
                ],
                [
                    84.260736,
                    55.8311098
                ],
                [
                    84.2616385,
                    55.8323717
                ],
                [
                    84.2618316,
                    55.8326416
                ],
                [
                    84.2643454,
                    55.832493
                ],
                [
                    84.2650731,
                    55.831044
                ],
                [
                    84.2643785,
                    55.8309883
                ],
                [
                    84.2643785,
                    55.8305982
                ],
                [
                    84.2649077,
                    55.8304681
                ],
                [
                    84.2644116,
                    55.8296507
                ],
                [
                    84.2650069,
                    55.8294463
                ],
                [
                    84.2650364,
                    55.8276213
                ],
                [
                    84.26504,
                    55.8274027
                ],
                [
                    84.2638823,
                    55.8263252
                ],
                [
                    84.2640477,
                    55.8253776
                ],
                [
                    84.2603431,
                    55.8230365
                ],
                [
                    84.259417,
                    55.8230179
                ],
                [
                    84.2597147,
                    55.8226277
                ],
                [
                    84.259417,
                    55.8214571
                ],
                [
                    84.2583585,
                    55.8210669
                ],
                [
                    84.2591524,
                    55.8202864
                ],
                [
                    84.2582262,
                    55.8201935
                ],
                [
                    84.2588216,
                    55.8196546
                ],
                [
                    84.2582593,
                    55.8195246
                ],
                [
                    84.2595162,
                    55.8189671
                ],
                [
                    84.2599793,
                    55.8186512
                ],
                [
                    84.2595706,
                    55.8181882
                ],
                [
                    84.2595058,
                    55.8181148
                ],
                [
                    84.2598139,
                    55.817945
                ],
                [
                    84.2593511,
                    55.817792
                ],
                [
                    84.258127,
                    55.8173875
                ],
                [
                    84.2578956,
                    55.8175356
                ],
                [
                    84.257366,
                    55.8178744
                ],
                [
                    84.2569362,
                    55.8181494
                ],
                [
                    84.2581601,
                    55.8186512
                ],
                [
                    84.257267,
                    55.8193387
                ],
                [
                    84.2563408,
                    55.8188927
                ],
                [
                    84.2551832,
                    55.8191343
                ],
                [
                    84.2543232,
                    55.8195803
                ],
                [
                    84.2539263,
                    55.8193387
                ],
                [
                    84.2534963,
                    55.8185211
                ],
                [
                    84.251677,
                    55.8182052
                ],
                [
                    84.2506186,
                    55.8187255
                ],
                [
                    84.2514455,
                    55.8193016
                ],
                [
                    84.2511478,
                    55.8194502
                ],
                [
                    84.2519086,
                    55.8200449
                ],
                [
                    84.2511478,
                    55.8205466
                ],
                [
                    84.2517432,
                    55.820974
                ],
                [
                    84.2530993,
                    55.8204165
                ],
                [
                    84.2535293,
                    55.8206209
                ],
                [
                    84.2528347,
                    55.8211226
                ],
                [
                    84.2537609,
                    55.8216615
                ],
                [
                    84.2534301,
                    55.8219216
                ],
                [
                    84.2539263,
                    55.8225162
                ],
                [
                    84.254257,
                    55.8223676
                ],
                [
                    84.2545462,
                    55.8225084
                ],
                [
                    84.2544886,
                    55.8230922
                ],
                [
                    84.2530993,
                    55.8231666
                ],
                [
                    84.252614,
                    55.8236924
                ],
                [
                    84.2517101,
                    55.8246716
                ],
                [
                    84.252074,
                    55.8254891
                ],
                [
                    84.2510486,
                    55.8268825
                ],
                [
                    84.2496594,
                    55.8263066
                ],
                [
                    84.2480055,
                    55.8266596
                ],
                [
                    84.2475094,
                    55.8273098
                ]
            ],
            "longitude": 84.260231,
            "latitude": 55.824898
        },
        "3719": {
            "name": "Янченково",
            "population": 788,
            "type": "village",
            "poly": [
                [
                    84.2421088,
                    55.2826443
                ],
                [
                    84.2453768,
                    55.2830146
                ],
                [
                    84.2492811,
                    55.2819921
                ],
                [
                    84.2499431,
                    55.2826111
                ],
                [
                    84.248137,
                    55.2832673
                ],
                [
                    84.2485779,
                    55.2839141
                ],
                [
                    84.2520182,
                    55.2827944
                ],
                [
                    84.2531603,
                    55.2833148
                ],
                [
                    84.2509058,
                    55.2840634
                ],
                [
                    84.2515399,
                    55.2845161
                ],
                [
                    84.2537066,
                    55.2843618
                ],
                [
                    84.2558042,
                    55.2859249
                ],
                [
                    84.2563963,
                    55.2864616
                ],
                [
                    84.2566932,
                    55.2867447
                ],
                [
                    84.2569729,
                    55.2869969
                ],
                [
                    84.2569202,
                    55.2879575
                ],
                [
                    84.2563932,
                    55.2891661
                ],
                [
                    84.2567945,
                    55.2894146
                ],
                [
                    84.2567911,
                    55.2899597
                ],
                [
                    84.2585886,
                    55.2902165
                ],
                [
                    84.2604694,
                    55.2912991
                ],
                [
                    84.2623142,
                    55.2899785
                ],
                [
                    84.263616,
                    55.290902
                ],
                [
                    84.2645936,
                    55.2906689
                ],
                [
                    84.2659606,
                    55.2897882
                ],
                [
                    84.2669632,
                    55.2902099
                ],
                [
                    84.2689732,
                    55.2904787
                ],
                [
                    84.2703788,
                    55.2903286
                ],
                [
                    84.2718723,
                    55.289088
                ],
                [
                    84.2712749,
                    55.2886578
                ],
                [
                    84.2726805,
                    55.2867668
                ],
                [
                    84.2728035,
                    55.2860264
                ],
                [
                    84.2721534,
                    55.283775
                ],
                [
                    84.269799,
                    55.2826343
                ],
                [
                    84.26878,
                    55.282234
                ],
                [
                    84.2669702,
                    55.2823041
                ],
                [
                    84.2658633,
                    55.2826843
                ],
                [
                    84.262826,
                    55.2848198
                ],
                [
                    84.2610622,
                    55.2831568
                ],
                [
                    84.2606626,
                    55.2814735
                ],
                [
                    84.26126,
                    55.2797223
                ],
                [
                    84.2576055,
                    55.2788917
                ],
                [
                    84.2535292,
                    55.2794721
                ],
                [
                    84.2525277,
                    55.2790318
                ],
                [
                    84.2503315,
                    55.2795822
                ],
                [
                    84.2454998,
                    55.2806329
                ],
                [
                    84.2461199,
                    55.2817323
                ],
                [
                    84.2421088,
                    55.2826443
                ]
            ],
            "longitude": 84.261627,
            "latitude": 55.286083
        },
        "3720": {
            "name": "Киряково",
            "population": 321,
            "type": "village",
            "poly": [
                [
                    84.2564907,
                    55.8097701
                ],
                [
                    84.2571192,
                    55.8107924
                ],
                [
                    84.2586407,
                    55.8104578
                ],
                [
                    84.2578138,
                    55.8125767
                ],
                [
                    84.2600299,
                    55.8120377
                ],
                [
                    84.2601622,
                    55.8123351
                ],
                [
                    84.2588061,
                    55.8127625
                ],
                [
                    84.2610222,
                    55.8146211
                ],
                [
                    84.2591699,
                    55.8141564
                ],
                [
                    84.2587852,
                    55.8144854
                ],
                [
                    84.2568876,
                    55.8161078
                ],
                [
                    84.2602615,
                    55.817706
                ],
                [
                    84.2618039,
                    55.8173286
                ],
                [
                    84.2628822,
                    55.8177094
                ],
                [
                    84.2637676,
                    55.818022
                ],
                [
                    84.2631061,
                    55.8187467
                ],
                [
                    84.2648218,
                    55.8192153
                ],
                [
                    84.2654876,
                    55.8193971
                ],
                [
                    84.2674391,
                    55.8190254
                ],
                [
                    84.2679022,
                    55.818598
                ],
                [
                    84.2679352,
                    55.818022
                ],
                [
                    84.2674722,
                    55.8178175
                ],
                [
                    84.2676706,
                    55.8167769
                ],
                [
                    84.2672737,
                    55.8164052
                ],
                [
                    84.2679683,
                    55.8164052
                ],
                [
                    84.2679352,
                    55.8160149
                ],
                [
                    84.266976,
                    55.8158105
                ],
                [
                    84.2672406,
                    55.8151786
                ],
                [
                    84.2679683,
                    55.814937
                ],
                [
                    84.2679683,
                    55.8136546
                ],
                [
                    84.267406,
                    55.8136546
                ],
                [
                    84.2673729,
                    55.8133945
                ],
                [
                    84.2653553,
                    55.8133573
                ],
                [
                    84.2644953,
                    55.8129298
                ],
                [
                    84.2651899,
                    55.8124094
                ],
                [
                    84.2641645,
                    55.8113872
                ],
                [
                    84.2631391,
                    55.8115359
                ],
                [
                    84.262213,
                    55.8103463
                ],
                [
                    84.2630399,
                    55.8100303
                ],
                [
                    84.2626708,
                    55.8091098
                ],
                [
                    84.2625107,
                    55.8087106
                ],
                [
                    84.2611545,
                    55.8088779
                ],
                [
                    84.2612538,
                    55.8081716
                ],
                [
                    84.2632714,
                    55.8079857
                ],
                [
                    84.2638668,
                    55.8059967
                ],
                [
                    84.2641976,
                    55.8057551
                ],
                [
                    84.2645614,
                    55.8050859
                ],
                [
                    84.2640653,
                    55.8046025
                ],
                [
                    84.2646937,
                    55.8045468
                ],
                [
                    84.2647599,
                    55.8042865
                ],
                [
                    84.2640653,
                    55.8039705
                ],
                [
                    84.264793,
                    55.8038961
                ],
                [
                    84.2655868,
                    55.8041378
                ],
                [
                    84.265946,
                    55.8036666
                ],
                [
                    84.266083,
                    55.8034871
                ],
                [
                    84.2660469,
                    55.8032036
                ],
                [
                    84.2660168,
                    55.8029666
                ],
                [
                    84.2652914,
                    55.8027485
                ],
                [
                    84.2645945,
                    55.802539
                ],
                [
                    84.2649253,
                    55.8019441
                ],
                [
                    84.264363,
                    55.8016281
                ],
                [
                    84.2636353,
                    55.8015537
                ],
                [
                    84.2633376,
                    55.8012749
                ],
                [
                    84.2635361,
                    55.8009402
                ],
                [
                    84.2632014,
                    55.8006268
                ],
                [
                    84.2630399,
                    55.8004754
                ],
                [
                    84.2620476,
                    55.8006056
                ],
                [
                    84.2621138,
                    55.8039147
                ],
                [
                    84.2571523,
                    55.8029109
                ],
                [
                    84.2566892,
                    55.804082
                ],
                [
                    84.2576416,
                    55.8043008
                ],
                [
                    84.2595415,
                    55.8045247
                ],
                [
                    84.2591655,
                    55.8051485
                ],
                [
                    84.2595812,
                    55.8056026
                ],
                [
                    84.2588601,
                    55.8073909
                ],
                [
                    84.2591699,
                    55.8083017
                ],
                [
                    84.2586076,
                    55.8083389
                ],
                [
                    84.2583832,
                    55.8091272
                ],
                [
                    84.25659,
                    55.8093798
                ],
                [
                    84.2564907,
                    55.8097701
                ]
            ],
            "longitude": 84.261978,
            "latitude": 55.812714
        },
        "3721": {
            "name": "Мамоново",
            "population": 1582,
            "type": "village",
            "poly": [
                [
                    84.2404518,
                    54.3079442
                ],
                [
                    84.2429906,
                    54.3091785
                ],
                [
                    84.2404942,
                    54.3114495
                ],
                [
                    84.2476872,
                    54.3161886
                ],
                [
                    84.2482796,
                    54.3153247
                ],
                [
                    84.2510722,
                    54.3159911
                ],
                [
                    84.2548803,
                    54.3132514
                ],
                [
                    84.2549649,
                    54.3113508
                ],
                [
                    84.2523839,
                    54.3106349
                ],
                [
                    84.2530609,
                    54.3102153
                ],
                [
                    84.2550919,
                    54.3106843
                ],
                [
                    84.2572498,
                    54.3119185
                ],
                [
                    84.257419,
                    54.3124369
                ],
                [
                    84.2554304,
                    54.3137204
                ],
                [
                    84.2559804,
                    54.3147077
                ],
                [
                    84.2522993,
                    54.317398
                ],
                [
                    84.254838,
                    54.3183852
                ],
                [
                    84.2605925,
                    54.3145102
                ],
                [
                    84.2615232,
                    54.3142881
                ],
                [
                    84.2690549,
                    54.3145843
                ],
                [
                    84.2715936,
                    54.3148311
                ],
                [
                    84.2743016,
                    54.3132514
                ],
                [
                    84.2759095,
                    54.3125356
                ],
                [
                    84.2841604,
                    54.3120666
                ],
                [
                    84.28818,
                    54.3124122
                ],
                [
                    84.2906342,
                    54.314609
                ],
                [
                    84.2941884,
                    54.3157937
                ],
                [
                    84.3025239,
                    54.3166575
                ],
                [
                    84.30172,
                    54.3129059
                ],
                [
                    84.2950345,
                    54.3125603
                ],
                [
                    84.2884762,
                    54.3105609
                ],
                [
                    84.2868684,
                    54.3106103
                ],
                [
                    84.2818755,
                    54.3101166
                ],
                [
                    84.2756979,
                    54.3091045
                ],
                [
                    84.2692242,
                    54.3080183
                ],
                [
                    84.2651622,
                    54.3061915
                ],
                [
                    84.2613964,
                    54.3040436
                ],
                [
                    84.2592808,
                    54.302982
                ],
                [
                    84.2573344,
                    54.3014019
                ],
                [
                    84.2536533,
                    54.3006612
                ],
                [
                    84.2505222,
                    54.3003649
                ],
                [
                    84.248068,
                    54.3007352
                ],
                [
                    84.2462486,
                    54.3020932
                ],
                [
                    84.2479411,
                    54.3039943
                ],
                [
                    84.248872,
                    54.3043893
                ],
                [
                    84.2499298,
                    54.3035499
                ],
                [
                    84.2506913,
                    54.3041424
                ],
                [
                    84.2496336,
                    54.3067099
                ],
                [
                    84.2478988,
                    54.3064384
                ],
                [
                    84.2476449,
                    54.3068827
                ],
                [
                    84.2524262,
                    54.3094994
                ],
                [
                    84.2517069,
                    54.3098203
                ],
                [
                    84.2433291,
                    54.3058952
                ],
                [
                    84.2404518,
                    54.3079442
                ]
            ],
            "longitude": 84.263512,
            "latitude": 54.309383
        },
        "3722": {
            "name": "Большой Изырак",
            "population": 594,
            "type": "village",
            "poly": [
                [
                    84.2518673,
                    54.5127219
                ],
                [
                    84.2575468,
                    54.5147001
                ],
                [
                    84.2572872,
                    54.5174318
                ],
                [
                    84.2592669,
                    54.5179969
                ],
                [
                    84.2629699,
                    54.5167785
                ],
                [
                    84.2633763,
                    54.5193996
                ],
                [
                    84.2678538,
                    54.5190013
                ],
                [
                    84.2685955,
                    54.5176542
                ],
                [
                    84.271616,
                    54.5179633
                ],
                [
                    84.2732222,
                    54.5162261
                ],
                [
                    84.2761431,
                    54.5174883
                ],
                [
                    84.2786745,
                    54.517055
                ],
                [
                    84.2825366,
                    54.5166971
                ],
                [
                    84.281206,
                    54.5148132
                ],
                [
                    84.27835,
                    54.5139465
                ],
                [
                    84.2777658,
                    54.5126466
                ],
                [
                    84.2720863,
                    54.5111016
                ],
                [
                    84.2727029,
                    54.5106117
                ],
                [
                    84.2756887,
                    54.5111016
                ],
                [
                    84.2770194,
                    54.5092175
                ],
                [
                    84.274423,
                    54.507597
                ],
                [
                    84.2736117,
                    54.5075028
                ],
                [
                    84.2720214,
                    54.5091609
                ],
                [
                    84.2718267,
                    54.5079362
                ],
                [
                    84.2676401,
                    54.5072202
                ],
                [
                    84.2605975,
                    54.5072578
                ],
                [
                    84.2563136,
                    54.5080116
                ],
                [
                    84.2560539,
                    54.5090856
                ],
                [
                    84.2583582,
                    54.5095755
                ],
                [
                    84.2625772,
                    54.509387
                ],
                [
                    84.2654332,
                    54.5084638
                ],
                [
                    84.2674454,
                    54.5092363
                ],
                [
                    84.2669585,
                    54.5096697
                ],
                [
                    84.2692303,
                    54.5102349
                ],
                [
                    84.2690356,
                    54.510706
                ],
                [
                    84.2675103,
                    54.5106306
                ],
                [
                    84.266634,
                    54.5101407
                ],
                [
                    84.263421,
                    54.5108002
                ],
                [
                    84.2637456,
                    54.5114973
                ],
                [
                    84.2592344,
                    54.5114031
                ],
                [
                    84.2548531,
                    54.5109886
                ],
                [
                    84.2521594,
                    54.5119306
                ],
                [
                    84.2518673,
                    54.5127219
                ]
            ],
            "longitude": 84.270218,
            "latitude": 54.514095
        },
        "3723": {
            "name": "Бажинск",
            "population": 538,
            "type": "village",
            "poly": [
                [
                    84.2580565,
                    54.3663776
                ],
                [
                    84.2609235,
                    54.3680325
                ],
                [
                    84.2630207,
                    54.3689604
                ],
                [
                    84.2654895,
                    54.369115
                ],
                [
                    84.265516,
                    54.3685119
                ],
                [
                    84.2739842,
                    54.3685583
                ],
                [
                    84.2675285,
                    54.3724485
                ],
                [
                    84.2633094,
                    54.3755623
                ],
                [
                    84.2634272,
                    54.3797418
                ],
                [
                    84.267054,
                    54.3802636
                ],
                [
                    84.276798,
                    54.3757798
                ],
                [
                    84.2802491,
                    54.3778053
                ],
                [
                    84.2829303,
                    54.3784392
                ],
                [
                    84.2842842,
                    54.3776352
                ],
                [
                    84.2873369,
                    54.3818715
                ],
                [
                    84.2880803,
                    54.3822734
                ],
                [
                    84.2912393,
                    54.3813149
                ],
                [
                    84.2910002,
                    54.3807583
                ],
                [
                    84.2858504,
                    54.3777434
                ],
                [
                    84.2883723,
                    54.3758726
                ],
                [
                    84.2874166,
                    54.3735686
                ],
                [
                    84.2933099,
                    54.3724243
                ],
                [
                    84.292832,
                    54.3714192
                ],
                [
                    84.2908145,
                    54.3703212
                ],
                [
                    84.2881068,
                    54.3706924
                ],
                [
                    84.2851336,
                    54.3683108
                ],
                [
                    84.2811782,
                    54.3660683
                ],
                [
                    84.2580565,
                    54.3663776
                ]
            ],
            "longitude": 84.276398,
            "latitude": 54.372646
        },
        "3724": {
            "name": "Кудрино",
            "population": 599,
            "type": "village",
            "poly": [
                [
                    84.2719645,
                    55.2549448
                ],
                [
                    84.2730929,
                    55.2574367
                ],
                [
                    84.2874798,
                    55.2551859
                ],
                [
                    84.3031362,
                    55.2481113
                ],
                [
                    84.2938379,
                    55.2466178
                ],
                [
                    84.291006,
                    55.2485937
                ],
                [
                    84.2862104,
                    55.2497193
                ],
                [
                    84.2719645,
                    55.2549448
                ]
            ],
            "longitude": 84.29525,
            "latitude": 55.248798
        },
        "3725": {
            "name": "Кунчурук",
            "population": 465,
            "type": "village",
            "poly": [
                [
                    84.2856679,
                    55.9277234
                ],
                [
                    84.2866163,
                    55.927989
                ],
                [
                    84.2901909,
                    55.9275757
                ],
                [
                    84.2909381,
                    55.9260762
                ],
                [
                    84.2921304,
                    55.9264254
                ],
                [
                    84.2920897,
                    55.9270478
                ],
                [
                    84.2925504,
                    55.926934
                ],
                [
                    84.2929568,
                    55.9271541
                ],
                [
                    84.2940813,
                    55.9270402
                ],
                [
                    84.2941761,
                    55.9272224
                ],
                [
                    84.2953413,
                    55.9269264
                ],
                [
                    84.2958832,
                    55.9270858
                ],
                [
                    84.2971432,
                    55.9270478
                ],
                [
                    84.2979597,
                    55.9266025
                ],
                [
                    84.2993159,
                    55.925991
                ],
                [
                    84.3001097,
                    55.9243787
                ],
                [
                    84.3000105,
                    55.9230444
                ],
                [
                    84.3007051,
                    55.9221177
                ],
                [
                    84.3007713,
                    55.9212095
                ],
                [
                    84.3013336,
                    55.9208574
                ],
                [
                    84.3026897,
                    55.9207647
                ],
                [
                    84.3042443,
                    55.9193005
                ],
                [
                    84.3022597,
                    55.9183923
                ],
                [
                    84.3021605,
                    55.9176509
                ],
                [
                    84.3006059,
                    55.9171875
                ],
                [
                    84.3004736,
                    55.9162792
                ],
                [
                    84.3015405,
                    55.9157905
                ],
                [
                    84.3041782,
                    55.9175767
                ],
                [
                    84.3051705,
                    55.9171319
                ],
                [
                    84.3048728,
                    55.9166499
                ],
                [
                    84.3076843,
                    55.9145924
                ],
                [
                    84.3041782,
                    55.9128128
                ],
                [
                    84.3032851,
                    55.9132206
                ],
                [
                    84.3037812,
                    55.9134801
                ],
                [
                    84.3020282,
                    55.9141845
                ],
                [
                    84.3014989,
                    55.9155748
                ],
                [
                    84.3013336,
                    55.9129425
                ],
                [
                    84.2997128,
                    55.9119229
                ],
                [
                    84.298059,
                    55.9123122
                ],
                [
                    84.3008374,
                    55.9148148
                ],
                [
                    84.301102,
                    55.9157416
                ],
                [
                    84.3000436,
                    55.9161865
                ],
                [
                    84.2994151,
                    55.9158343
                ],
                [
                    84.2961075,
                    55.9123864
                ],
                [
                    84.2967359,
                    55.9118117
                ],
                [
                    84.2954459,
                    55.9106994
                ],
                [
                    84.2947182,
                    55.910996
                ],
                [
                    84.2941559,
                    55.9105696
                ],
                [
                    84.2925411,
                    55.9112147
                ],
                [
                    84.2941949,
                    55.9122343
                ],
                [
                    84.2936574,
                    55.9128136
                ],
                [
                    84.2942776,
                    55.9133929
                ],
                [
                    84.2937815,
                    55.9138332
                ],
                [
                    84.2962622,
                    55.9153161
                ],
                [
                    84.2959314,
                    55.9159649
                ],
                [
                    84.2944016,
                    55.9154552
                ],
                [
                    84.2940709,
                    55.9156637
                ],
                [
                    84.2948565,
                    55.9160576
                ],
                [
                    84.2942363,
                    55.9166137
                ],
                [
                    84.293368,
                    55.9167759
                ],
                [
                    84.2932853,
                    55.9177027
                ],
                [
                    84.2937401,
                    55.9178417
                ],
                [
                    84.2908459,
                    55.9207378
                ],
                [
                    84.2919622,
                    55.9211548
                ],
                [
                    84.2925824,
                    55.9223826
                ],
                [
                    84.2911767,
                    55.9221741
                ],
                [
                    84.2910113,
                    55.9224521
                ],
                [
                    84.2917142,
                    55.9227301
                ],
                [
                    84.2914248,
                    55.9230545
                ],
                [
                    84.2908459,
                    55.9228228
                ],
                [
                    84.2896055,
                    55.9239116
                ],
                [
                    84.2887786,
                    55.9238884
                ],
                [
                    84.2883652,
                    55.9241896
                ],
                [
                    84.2908459,
                    55.9258343
                ],
                [
                    84.2891921,
                    55.9267377
                ],
                [
                    84.2881171,
                    55.9257417
                ],
                [
                    84.2885305,
                    55.9254405
                ],
                [
                    84.2876209,
                    55.9250235
                ],
                [
                    84.2872075,
                    55.925232
                ],
                [
                    84.2865046,
                    55.9251162
                ],
                [
                    84.2858844,
                    55.925371
                ],
                [
                    84.2860911,
                    55.9260891
                ],
                [
                    84.2867527,
                    55.9265987
                ],
                [
                    84.2863806,
                    55.9267841
                ],
                [
                    84.2870007,
                    55.9270852
                ],
                [
                    84.2864633,
                    55.9275948
                ],
                [
                    84.2860084,
                    55.927479
                ],
                [
                    84.2856679,
                    55.9277234
                ]
            ],
            "longitude": 84.295929,
            "latitude": 55.919682
        },
        "3726": {
            "name": "Гутово",
            "population": 273,
            "type": "village",
            "poly": [
                [
                    84.287858,
                    55.2748351
                ],
                [
                    84.2883247,
                    55.2763833
                ],
                [
                    84.2905484,
                    55.277603
                ],
                [
                    84.2920308,
                    55.2767429
                ],
                [
                    84.2940624,
                    55.2771964
                ],
                [
                    84.2959017,
                    55.2768993
                ],
                [
                    84.3004315,
                    55.2789009
                ],
                [
                    84.3000196,
                    55.2793543
                ],
                [
                    84.3016669,
                    55.2801049
                ],
                [
                    84.301557,
                    55.2808867
                ],
                [
                    84.3022708,
                    55.281387
                ],
                [
                    84.3019688,
                    55.2815747
                ],
                [
                    84.3028748,
                    55.2821532
                ],
                [
                    84.3040553,
                    55.2824346
                ],
                [
                    84.3046043,
                    55.2821063
                ],
                [
                    84.3054827,
                    55.2808241
                ],
                [
                    84.3068555,
                    55.2790885
                ],
                [
                    84.3077889,
                    55.2790572
                ],
                [
                    84.3082007,
                    55.2774153
                ],
                [
                    84.3069653,
                    55.2757108
                ],
                [
                    84.3032866,
                    55.2741626
                ],
                [
                    84.2981254,
                    55.2722547
                ],
                [
                    84.2969724,
                    55.2732556
                ],
                [
                    84.2960115,
                    55.2731461
                ],
                [
                    84.2945291,
                    55.2716291
                ],
                [
                    84.2924701,
                    55.2708471
                ],
                [
                    84.2909327,
                    55.271895
                ],
                [
                    84.2916739,
                    55.2731461
                ],
                [
                    84.290768,
                    55.2739124
                ],
                [
                    84.2891208,
                    55.2744441
                ],
                [
                    84.2885168,
                    55.274319
                ],
                [
                    84.287858,
                    55.2748351
                ]
            ],
            "longitude": 84.296738,
            "latitude": 55.273827
        },
        "3727": {
            "name": "Бор",
            "population": 663,
            "type": "village",
            "poly": [
                [
                    84.2996039,
                    55.6683807
                ],
                [
                    84.2996039,
                    55.6693355
                ],
                [
                    84.3011089,
                    55.670255
                ],
                [
                    84.3039307,
                    55.670927
                ],
                [
                    84.3039934,
                    55.6705026
                ],
                [
                    84.3081321,
                    55.6723061
                ],
                [
                    84.3025511,
                    55.6742156
                ],
                [
                    84.3034917,
                    55.6753825
                ],
                [
                    84.3076305,
                    55.6742156
                ],
                [
                    84.3088219,
                    55.6750997
                ],
                [
                    84.3112675,
                    55.6730487
                ],
                [
                    84.3115184,
                    55.6735791
                ],
                [
                    84.3129606,
                    55.6730487
                ],
                [
                    84.3162842,
                    55.673367
                ],
                [
                    84.3167858,
                    55.6731194
                ],
                [
                    84.3178721,
                    55.6719491
                ],
                [
                    84.3160333,
                    55.6715281
                ],
                [
                    84.3148419,
                    55.6709623
                ],
                [
                    84.317601,
                    55.6690173
                ],
                [
                    84.3144656,
                    55.6674611
                ],
                [
                    84.3058119,
                    55.6655513
                ],
                [
                    84.3063763,
                    55.6650561
                ],
                [
                    84.305373,
                    55.6644548
                ],
                [
                    84.3028647,
                    55.6665062
                ],
                [
                    84.3036799,
                    55.6670721
                ],
                [
                    84.3024257,
                    55.667638
                ],
                [
                    84.3006072,
                    55.6674258
                ],
                [
                    84.2996039,
                    55.6683807
                ]
            ],
            "longitude": 84.309021,
            "latitude": 55.669182
        },
        "3728": {
            "name": "Лебедево",
            "population": 895,
            "type": "village",
            "poly": null,
            "longitude": 84.344116,
            "latitude": 54.917683
        },
        "3729": {
            "name": "Варламово",
            "population": 436,
            "type": "village",
            "poly": [
                [
                    84.3392509,
                    55.7999583
                ],
                [
                    84.3511604,
                    55.803574
                ],
                [
                    84.3517882,
                    55.8041073
                ],
                [
                    84.3524853,
                    55.8047099
                ],
                [
                    84.3529784,
                    55.8051163
                ],
                [
                    84.3532162,
                    55.8053709
                ],
                [
                    84.3553693,
                    55.8071458
                ],
                [
                    84.3555647,
                    55.8073175
                ],
                [
                    84.3560161,
                    55.8076204
                ],
                [
                    84.3552791,
                    55.8077731
                ],
                [
                    84.3566849,
                    55.8100996
                ],
                [
                    84.3598848,
                    55.8117471
                ],
                [
                    84.3589267,
                    55.8121716
                ],
                [
                    84.3576186,
                    55.8112657
                ],
                [
                    84.3548272,
                    55.8123269
                ],
                [
                    84.3524228,
                    55.8134294
                ],
                [
                    84.3537678,
                    55.8144189
                ],
                [
                    84.3521499,
                    55.8151328
                ],
                [
                    84.3524631,
                    55.8153347
                ],
                [
                    84.3526566,
                    55.8153916
                ],
                [
                    84.3530712,
                    55.8157436
                ],
                [
                    84.3542872,
                    55.8164941
                ],
                [
                    84.3554498,
                    55.8160199
                ],
                [
                    84.3642238,
                    55.812134
                ],
                [
                    84.3692667,
                    55.810745
                ],
                [
                    84.3708392,
                    55.8079752
                ],
                [
                    84.3666632,
                    55.8000048
                ],
                [
                    84.3612088,
                    55.8004486
                ],
                [
                    84.3614022,
                    55.8005107
                ],
                [
                    84.3622866,
                    55.8004537
                ],
                [
                    84.3630236,
                    55.8004537
                ],
                [
                    84.3631618,
                    55.8005573
                ],
                [
                    84.3631802,
                    55.8007644
                ],
                [
                    84.3629315,
                    55.8008887
                ],
                [
                    84.3627012,
                    55.8009405
                ],
                [
                    84.3624801,
                    55.8010803
                ],
                [
                    84.3623695,
                    55.8011062
                ],
                [
                    84.3618905,
                    55.8011165
                ],
                [
                    84.3614391,
                    55.8011579
                ],
                [
                    84.3608034,
                    55.8013081
                ],
                [
                    84.3607389,
                    55.8013651
                ],
                [
                    84.3597901,
                    55.8007437
                ],
                [
                    84.3590253,
                    55.8010803
                ],
                [
                    84.3586477,
                    55.8008266
                ],
                [
                    84.3579752,
                    55.800723
                ],
                [
                    84.3564003,
                    55.8008885
                ],
                [
                    84.3559722,
                    55.8010148
                ],
                [
                    84.3556822,
                    55.8014574
                ],
                [
                    84.3556207,
                    55.802207
                ],
                [
                    84.3550437,
                    55.8020886
                ],
                [
                    84.3548873,
                    55.8020717
                ],
                [
                    84.3547244,
                    55.8020424
                ],
                [
                    84.3545551,
                    55.8020204
                ],
                [
                    84.3543987,
                    55.8020314
                ],
                [
                    84.3543531,
                    55.8020607
                ],
                [
                    84.3542163,
                    55.8021046
                ],
                [
                    84.3541642,
                    55.8021412
                ],
                [
                    84.351955,
                    55.8024069
                ],
                [
                    84.3510345,
                    55.8017477
                ],
                [
                    84.3519441,
                    55.8007484
                ],
                [
                    84.3495874,
                    55.7998188
                ],
                [
                    84.3478922,
                    55.8010041
                ],
                [
                    84.3400779,
                    55.7987498
                ],
                [
                    84.3392509,
                    55.7999583
                ]
            ],
            "longitude": 84.361465,
            "latitude": 55.808899
        },
        "3730": {
            "name": "Александровка",
            "population": 381,
            "type": "village",
            "poly": [
                [
                    84.357242,
                    54.4261824
                ],
                [
                    84.3579057,
                    54.4274613
                ],
                [
                    84.3586938,
                    54.4284506
                ],
                [
                    84.3575324,
                    54.4289332
                ],
                [
                    84.3578227,
                    54.4293434
                ],
                [
                    84.3614728,
                    54.4332278
                ],
                [
                    84.3624268,
                    54.4341687
                ],
                [
                    84.3608845,
                    54.4354346
                ],
                [
                    84.3619291,
                    54.4360505
                ],
                [
                    84.3631733,
                    54.4368466
                ],
                [
                    84.3616387,
                    54.4381975
                ],
                [
                    84.3647081,
                    54.438101
                ],
                [
                    84.3641689,
                    54.4398861
                ],
                [
                    84.3652059,
                    54.4413334
                ],
                [
                    84.367819,
                    54.4415263
                ],
                [
                    84.3682752,
                    54.4400308
                ],
                [
                    84.3676116,
                    54.437908
                ],
                [
                    84.3691048,
                    54.4364123
                ],
                [
                    84.3691048,
                    54.4346995
                ],
                [
                    84.3675701,
                    54.4338551
                ],
                [
                    84.3670309,
                    54.4341205
                ],
                [
                    84.3645006,
                    54.4326006
                ],
                [
                    84.3635467,
                    54.4288367
                ],
                [
                    84.3622609,
                    54.427582
                ],
                [
                    84.35915,
                    54.4255068
                ],
                [
                    84.357242,
                    54.4261824
                ]
            ],
            "longitude": 84.364975,
            "latitude": 54.435261
        },
        "3731": {
            "name": "Вассино",
            "population": 477,
            "type": "village",
            "poly": [
                [
                    84.3594876,
                    55.05449
                ],
                [
                    84.3615717,
                    55.0550724
                ],
                [
                    84.3632696,
                    55.054985
                ],
                [
                    84.3650284,
                    55.0554509
                ],
                [
                    84.3653131,
                    55.0551364
                ],
                [
                    84.3661467,
                    55.0554043
                ],
                [
                    84.3665432,
                    55.0551306
                ],
                [
                    84.3673261,
                    55.055381
                ],
                [
                    84.3679665,
                    55.0548744
                ],
                [
                    84.3677225,
                    55.0547288
                ],
                [
                    84.3706301,
                    55.0551597
                ],
                [
                    84.3704879,
                    55.055579
                ],
                [
                    84.3726838,
                    55.0559051
                ],
                [
                    84.37428,
                    55.0565398
                ],
                [
                    84.3754796,
                    55.0571803
                ],
                [
                    84.3729645,
                    55.0592308
                ],
                [
                    84.372688,
                    55.059147
                ],
                [
                    84.372932,
                    55.0588675
                ],
                [
                    84.3724359,
                    55.0586718
                ],
                [
                    84.3722243,
                    55.0588442
                ],
                [
                    84.371346,
                    55.0587184
                ],
                [
                    84.3710776,
                    55.0588768
                ],
                [
                    84.3697356,
                    55.0587976
                ],
                [
                    84.3693045,
                    55.0584995
                ],
                [
                    84.3684018,
                    55.0582293
                ],
                [
                    84.367808,
                    55.0581641
                ],
                [
                    84.3675478,
                    55.0580989
                ],
                [
                    84.3669947,
                    55.0584249
                ],
                [
                    84.367377,
                    55.0590538
                ],
                [
                    84.368418,
                    55.0595895
                ],
                [
                    84.3682065,
                    55.0598177
                ],
                [
                    84.3679463,
                    55.0598177
                ],
                [
                    84.3674664,
                    55.0604931
                ],
                [
                    84.3687515,
                    55.0609217
                ],
                [
                    84.3689223,
                    55.0610987
                ],
                [
                    84.368597,
                    55.0612943
                ],
                [
                    84.3685644,
                    55.0613642
                ],
                [
                    84.3689874,
                    55.0615552
                ],
                [
                    84.3688816,
                    55.0617042
                ],
                [
                    84.3693371,
                    55.0620768
                ],
                [
                    84.368841,
                    55.0627056
                ],
                [
                    84.3692639,
                    55.0629059
                ],
                [
                    84.3699795,
                    55.0629478
                ],
                [
                    84.3702805,
                    55.0627382
                ],
                [
                    84.3705489,
                    55.0632506
                ],
                [
                    84.3701504,
                    55.0633717
                ],
                [
                    84.3700691,
                    55.0635394
                ],
                [
                    84.3704757,
                    55.063558
                ],
                [
                    84.3707766,
                    55.063707
                ],
                [
                    84.3709393,
                    55.0648249
                ],
                [
                    84.3711996,
                    55.065067
                ],
                [
                    84.3714192,
                    55.0655188
                ],
                [
                    84.3723301,
                    55.0654629
                ],
                [
                    84.3726399,
                    55.0688009
                ],
                [
                    84.375494,
                    55.0698779
                ],
                [
                    84.3774622,
                    55.0684249
                ],
                [
                    84.3760064,
                    55.0678987
                ],
                [
                    84.3763805,
                    55.0675727
                ],
                [
                    84.3756404,
                    55.0673305
                ],
                [
                    84.3753638,
                    55.0671861
                ],
                [
                    84.3753476,
                    55.0669346
                ],
                [
                    84.3758761,
                    55.0669114
                ],
                [
                    84.3740544,
                    55.0663432
                ],
                [
                    84.3729156,
                    55.0673771
                ],
                [
                    84.3727368,
                    55.0673678
                ],
                [
                    84.3726961,
                    55.0655048
                ],
                [
                    84.373729,
                    55.0655095
                ],
                [
                    84.3741357,
                    55.0656539
                ],
                [
                    84.3742333,
                    55.0659426
                ],
                [
                    84.3752337,
                    55.066073
                ],
                [
                    84.3752825,
                    55.0657051
                ],
                [
                    84.3755428,
                    55.0657843
                ],
                [
                    84.3761039,
                    55.0656632
                ],
                [
                    84.3769498,
                    55.0658774
                ],
                [
                    84.3771775,
                    55.0657005
                ],
                [
                    84.37782,
                    55.065775
                ],
                [
                    84.3778363,
                    55.0656772
                ],
                [
                    84.3784138,
                    55.0657098
                ],
                [
                    84.3784789,
                    55.06557
                ],
                [
                    84.3791783,
                    55.0655747
                ],
                [
                    84.3792759,
                    55.0652533
                ],
                [
                    84.3804064,
                    55.0653279
                ],
                [
                    84.380992,
                    55.0656492
                ],
                [
                    84.3816752,
                    55.0655421
                ],
                [
                    84.3816996,
                    55.0652999
                ],
                [
                    84.382147,
                    55.0653465
                ],
                [
                    84.3823991,
                    55.0652766
                ],
                [
                    84.3826675,
                    55.0652906
                ],
                [
                    84.3826268,
                    55.0656632
                ],
                [
                    84.3835052,
                    55.0657563
                ],
                [
                    84.3837004,
                    55.0652953
                ],
                [
                    84.3849773,
                    55.0655654
                ],
                [
                    84.3849041,
                    55.0657331
                ],
                [
                    84.3854003,
                    55.0658169
                ],
                [
                    84.3855303,
                    55.0656166
                ],
                [
                    84.3870676,
                    55.0658169
                ],
                [
                    84.3870757,
                    55.0660125
                ],
                [
                    84.3873766,
                    55.0660404
                ],
                [
                    84.3874661,
                    55.0662687
                ],
                [
                    84.3884908,
                    55.0663571
                ],
                [
                    84.388556,
                    55.0660404
                ],
                [
                    84.3902965,
                    55.0662966
                ],
                [
                    84.3914595,
                    55.0664549
                ],
                [
                    84.3914189,
                    55.0666506
                ],
                [
                    84.3921426,
                    55.0668508
                ],
                [
                    84.3923217,
                    55.0666273
                ],
                [
                    84.3938751,
                    55.0668042
                ],
                [
                    84.3944281,
                    55.0660591
                ],
                [
                    84.3947127,
                    55.0660265
                ],
                [
                    84.3948348,
                    55.0658774
                ],
                [
                    84.3956482,
                    55.0658448
                ],
                [
                    84.3971691,
                    55.0659473
                ],
                [
                    84.3971203,
                    55.0657657
                ],
                [
                    84.3975595,
                    55.0649506
                ],
                [
                    84.3970959,
                    55.0647829
                ],
                [
                    84.39686,
                    55.0650577
                ],
                [
                    84.3961199,
                    55.0649832
                ],
                [
                    84.3939971,
                    55.0643125
                ],
                [
                    84.3938019,
                    55.0645873
                ],
                [
                    84.3929886,
                    55.0641728
                ],
                [
                    84.3912155,
                    55.0639306
                ],
                [
                    84.3907113,
                    55.0639632
                ],
                [
                    84.3897272,
                    55.0638002
                ],
                [
                    84.3897678,
                    55.0636325
                ],
                [
                    84.3888161,
                    55.0635068
                ],
                [
                    84.388987,
                    55.063218
                ],
                [
                    84.3882632,
                    55.0628128
                ],
                [
                    84.3877344,
                    55.0626684
                ],
                [
                    84.3872465,
                    55.0627802
                ],
                [
                    84.3869212,
                    55.0632972
                ],
                [
                    84.3866772,
                    55.0635114
                ],
                [
                    84.3870188,
                    55.0635673
                ],
                [
                    84.3870188,
                    55.0636651
                ],
                [
                    84.3873033,
                    55.0638048
                ],
                [
                    84.3872465,
                    55.0639632
                ],
                [
                    84.3864738,
                    55.063898
                ],
                [
                    84.3863844,
                    55.0640051
                ],
                [
                    84.3854979,
                    55.0639353
                ],
                [
                    84.3855141,
                    55.0635487
                ],
                [
                    84.3841965,
                    55.0635161
                ],
                [
                    84.3833669,
                    55.063367
                ],
                [
                    84.3828708,
                    55.063749
                ],
                [
                    84.3818623,
                    55.0636744
                ],
                [
                    84.38148,
                    55.0637536
                ],
                [
                    84.379959,
                    55.0636698
                ],
                [
                    84.3797558,
                    55.0639772
                ],
                [
                    84.3792353,
                    55.0637955
                ],
                [
                    84.3783813,
                    55.064089
                ],
                [
                    84.3775598,
                    55.0638048
                ],
                [
                    84.3770393,
                    55.0633298
                ],
                [
                    84.3767383,
                    55.0634555
                ],
                [
                    84.3765025,
                    55.0632692
                ],
                [
                    84.3769254,
                    55.063041
                ],
                [
                    84.3772345,
                    55.0627708
                ],
                [
                    84.3769905,
                    55.0626497
                ],
                [
                    84.3768685,
                    55.0622957
                ],
                [
                    84.3771857,
                    55.0621746
                ],
                [
                    84.3772019,
                    55.0620256
                ],
                [
                    84.3768685,
                    55.0618765
                ],
                [
                    84.376535,
                    55.0619511
                ],
                [
                    84.3762014,
                    55.0615319
                ],
                [
                    84.3763154,
                    55.0614434
                ],
                [
                    84.3757298,
                    55.0611173
                ],
                [
                    84.3748677,
                    55.0615738
                ],
                [
                    84.374705,
                    55.0614154
                ],
                [
                    84.3749572,
                    55.0612431
                ],
                [
                    84.3747701,
                    55.0611406
                ],
                [
                    84.3758518,
                    55.0602835
                ],
                [
                    84.3756322,
                    55.0601345
                ],
                [
                    84.3757949,
                    55.0599714
                ],
                [
                    84.3756404,
                    55.0597805
                ],
                [
                    84.3753557,
                    55.0599435
                ],
                [
                    84.3746481,
                    55.059487
                ],
                [
                    84.3735664,
                    55.0591237
                ],
                [
                    84.3732492,
                    55.0593473
                ],
                [
                    84.373119,
                    55.0593146
                ],
                [
                    84.3756487,
                    55.0572507
                ],
                [
                    84.3765674,
                    55.0573026
                ],
                [
                    84.3775536,
                    55.0575821
                ],
                [
                    84.3779298,
                    55.0578092
                ],
                [
                    84.3787939,
                    55.0581469
                ],
                [
                    84.3790379,
                    55.0579955
                ],
                [
                    84.3807561,
                    55.0583624
                ],
                [
                    84.3806646,
                    55.0584497
                ],
                [
                    84.3818337,
                    55.0591543
                ],
                [
                    84.382098,
                    55.0593057
                ],
                [
                    84.3827081,
                    55.0593581
                ],
                [
                    84.3831554,
                    55.0592009
                ],
                [
                    84.3836332,
                    55.0592241
                ],
                [
                    84.3838061,
                    55.059032
                ],
                [
                    84.3857072,
                    55.0594454
                ],
                [
                    84.386307,
                    55.0597657
                ],
                [
                    84.3874355,
                    55.0592009
                ],
                [
                    84.3881065,
                    55.059393
                ],
                [
                    84.3895603,
                    55.0578849
                ],
                [
                    84.3863274,
                    55.0565282
                ],
                [
                    84.3853107,
                    55.0574773
                ],
                [
                    84.3846803,
                    55.0574598
                ],
                [
                    84.3841517,
                    55.0581469
                ],
                [
                    84.387222,
                    55.0591252
                ],
                [
                    84.3871305,
                    55.0592358
                ],
                [
                    84.3822709,
                    55.0581644
                ],
                [
                    84.3834299,
                    55.0563709
                ],
                [
                    84.3829114,
                    55.056237
                ],
                [
                    84.3830842,
                    55.0559284
                ],
                [
                    84.3831452,
                    55.0555615
                ],
                [
                    84.3824132,
                    55.0554217
                ],
                [
                    84.3819761,
                    55.0556896
                ],
                [
                    84.3810204,
                    55.0560798
                ],
                [
                    84.3782144,
                    55.0567902
                ],
                [
                    84.3771196,
                    55.0564314
                ],
                [
                    84.3782348,
                    55.0557479
                ],
                [
                    84.3800749,
                    55.0552005
                ],
                [
                    84.3801461,
                    55.0548744
                ],
                [
                    84.3780314,
                    55.0547812
                ],
                [
                    84.377218,
                    55.0539717
                ],
                [
                    84.3770046,
                    55.0540474
                ],
                [
                    84.376232,
                    55.0536398
                ],
                [
                    84.3754186,
                    55.0534884
                ],
                [
                    84.3731515,
                    55.0522712
                ],
                [
                    84.3731515,
                    55.0521198
                ],
                [
                    84.3741377,
                    55.0518054
                ],
                [
                    84.373304,
                    55.0509551
                ],
                [
                    84.3724703,
                    55.049866
                ],
                [
                    84.3718603,
                    55.0495282
                ],
                [
                    84.3708844,
                    55.0497495
                ],
                [
                    84.3706912,
                    55.0495923
                ],
                [
                    84.3700099,
                    55.0497845
                ],
                [
                    84.3701422,
                    55.0500232
                ],
                [
                    84.3699185,
                    55.0501688
                ],
                [
                    84.3700609,
                    55.0505532
                ],
                [
                    84.3697762,
                    55.0508502
                ],
                [
                    84.3709047,
                    55.051916
                ],
                [
                    84.3694,
                    55.0523062
                ],
                [
                    84.3689222,
                    55.0520616
                ],
                [
                    84.368302,
                    55.0525857
                ],
                [
                    84.3680377,
                    55.0524052
                ],
                [
                    84.3656587,
                    55.0533544
                ],
                [
                    84.3646624,
                    55.0532729
                ],
                [
                    84.3644184,
                    55.0538553
                ],
                [
                    84.3607076,
                    55.053337
                ],
                [
                    84.3606108,
                    55.0534285
                ],
                [
                    84.3594876,
                    55.05449
                ]
            ],
            "longitude": 84.375412,
            "latitude": 55.056667
        },
        "3732": {
            "name": "Нечаевский",
            "population": 924,
            "type": "village",
            "poly": [
                [
                    84.3701865,
                    55.2044142
                ],
                [
                    84.3772384,
                    55.2099239
                ],
                [
                    84.3799144,
                    55.21393
                ],
                [
                    84.3826735,
                    55.2145403
                ],
                [
                    84.3841629,
                    55.2156785
                ],
                [
                    84.3859614,
                    55.214218
                ],
                [
                    84.3873337,
                    55.2131036
                ],
                [
                    84.389143,
                    55.2104161
                ],
                [
                    84.3839671,
                    55.2071675
                ],
                [
                    84.3744369,
                    55.2021346
                ],
                [
                    84.3701865,
                    55.2044142
                ]
            ],
            "longitude": 84.380035,
            "latitude": 55.209885
        },
        "3733": {
            "name": "Малая Томка",
            "population": 491,
            "type": "village",
            "poly": [
                [
                    84.4062223,
                    54.2902782
                ],
                [
                    84.4071741,
                    54.2908337
                ],
                [
                    84.4104186,
                    54.2896469
                ],
                [
                    84.4107648,
                    54.2904297
                ],
                [
                    84.4082989,
                    54.2916417
                ],
                [
                    84.4084287,
                    54.293283
                ],
                [
                    84.4104186,
                    54.2944949
                ],
                [
                    84.4289347,
                    54.2871722
                ],
                [
                    84.4282426,
                    54.286061
                ],
                [
                    84.425517,
                    54.2870207
                ],
                [
                    84.4242193,
                    54.2859348
                ],
                [
                    84.4220129,
                    54.2864903
                ],
                [
                    84.4208881,
                    54.2860863
                ],
                [
                    84.4181626,
                    54.286162
                ],
                [
                    84.4142258,
                    54.2885358
                ],
                [
                    84.4114137,
                    54.2896974
                ],
                [
                    84.4108946,
                    54.2893439
                ],
                [
                    84.4145719,
                    54.2878035
                ],
                [
                    84.4138363,
                    54.2853792
                ],
                [
                    84.4134038,
                    54.2849751
                ],
                [
                    84.4120627,
                    54.2851014
                ],
                [
                    84.4124953,
                    54.2866924
                ],
                [
                    84.4086017,
                    54.2884348
                ],
                [
                    84.4062223,
                    54.2902782
                ]
            ],
            "longitude": 84.417191,
            "latitude": 54.28994
        },
        "3734": {
            "name": "Пойменное",
            "population": 644,
            "type": "village",
            "poly": [
                [
                    84.4128309,
                    55.0575594
                ],
                [
                    84.4154146,
                    55.058474
                ],
                [
                    84.4152099,
                    55.0587764
                ],
                [
                    84.4148744,
                    55.0587181
                ],
                [
                    84.4136443,
                    55.0598943
                ],
                [
                    84.4138984,
                    55.0602495
                ],
                [
                    84.4144068,
                    55.0606513
                ],
                [
                    84.4160639,
                    55.0610821
                ],
                [
                    84.4164807,
                    55.0606687
                ],
                [
                    84.4166536,
                    55.0606862
                ],
                [
                    84.4167349,
                    55.0606163
                ],
                [
                    84.4170399,
                    55.060692
                ],
                [
                    84.4180972,
                    55.0607852
                ],
                [
                    84.421015,
                    55.0607561
                ],
                [
                    84.4216657,
                    55.0610064
                ],
                [
                    84.4220113,
                    55.0614024
                ],
                [
                    84.4234347,
                    55.0618099
                ],
                [
                    84.4241768,
                    55.0620836
                ],
                [
                    84.4247767,
                    55.0615654
                ],
                [
                    84.4251427,
                    55.0614722
                ],
                [
                    84.4260576,
                    55.0605697
                ],
                [
                    84.4264745,
                    55.0606804
                ],
                [
                    84.4263016,
                    55.0609249
                ],
                [
                    84.4266066,
                    55.0609948
                ],
                [
                    84.4265253,
                    55.0610996
                ],
                [
                    84.4266371,
                    55.0611229
                ],
                [
                    84.4265456,
                    55.0612219
                ],
                [
                    84.4278571,
                    55.0616702
                ],
                [
                    84.428091,
                    55.0614839
                ],
                [
                    84.4283451,
                    55.0615712
                ],
                [
                    84.4287823,
                    55.0612219
                ],
                [
                    84.4292499,
                    55.0606513
                ],
                [
                    84.4295753,
                    55.0606513
                ],
                [
                    84.4301243,
                    55.0607794
                ],
                [
                    84.4306489,
                    55.0601809
                ],
                [
                    84.43189,
                    55.0607211
                ],
                [
                    84.432709,
                    55.059854
                ],
                [
                    84.4313439,
                    55.0587878
                ],
                [
                    84.430227,
                    55.0584466
                ],
                [
                    84.4305248,
                    55.0581339
                ],
                [
                    84.4302518,
                    55.0580059
                ],
                [
                    84.4310709,
                    55.0571387
                ],
                [
                    84.4312446,
                    55.0567833
                ],
                [
                    84.4318403,
                    55.0563142
                ],
                [
                    84.4312943,
                    55.0560156
                ],
                [
                    84.4302766,
                    55.056499
                ],
                [
                    84.4296561,
                    55.0562858
                ],
                [
                    84.4286384,
                    55.0565274
                ],
                [
                    84.4275215,
                    55.05775
                ],
                [
                    84.4264294,
                    55.0574799
                ],
                [
                    84.4261812,
                    55.0577074
                ],
                [
                    84.4257096,
                    55.0575652
                ],
                [
                    84.425834,
                    55.0573032
                ],
                [
                    84.4257425,
                    55.0572275
                ],
                [
                    84.4262508,
                    55.0568665
                ],
                [
                    84.4264948,
                    55.0565986
                ],
                [
                    84.4263118,
                    55.0563424
                ],
                [
                    84.4265456,
                    55.0561328
                ],
                [
                    84.4267286,
                    55.0562201
                ],
                [
                    84.4272675,
                    55.0557775
                ],
                [
                    84.4270235,
                    55.0556844
                ],
                [
                    84.4272166,
                    55.0555039
                ],
                [
                    84.4273996,
                    55.0555388
                ],
                [
                    84.4276436,
                    55.0552535
                ],
                [
                    84.425712,
                    55.0543916
                ],
                [
                    84.4244615,
                    55.0542227
                ],
                [
                    84.4240142,
                    55.054083
                ],
                [
                    84.4241362,
                    55.0539548
                ],
                [
                    84.423882,
                    55.0538617
                ],
                [
                    84.423699,
                    55.0539898
                ],
                [
                    84.4228653,
                    55.053687
                ],
                [
                    84.42376,
                    55.0524116
                ],
                [
                    84.4235465,
                    55.0523126
                ],
                [
                    84.4237397,
                    55.0518991
                ],
                [
                    84.4235465,
                    55.051835
                ],
                [
                    84.4233127,
                    55.0519923
                ],
                [
                    84.422479,
                    55.0517943
                ],
                [
                    84.4221333,
                    55.0518234
                ],
                [
                    84.4220215,
                    55.0517826
                ],
                [
                    84.4220113,
                    55.0516429
                ],
                [
                    84.4220622,
                    55.0515147
                ],
                [
                    84.4215132,
                    55.0513284
                ],
                [
                    84.4211574,
                    55.0513808
                ],
                [
                    84.4204355,
                    55.0512818
                ],
                [
                    84.4201407,
                    55.0511711
                ],
                [
                    84.419551,
                    55.0516079
                ],
                [
                    84.4196222,
                    55.0518001
                ],
                [
                    84.4191647,
                    55.0522485
                ],
                [
                    84.418819,
                    55.0524058
                ],
                [
                    84.4183311,
                    55.0523417
                ],
                [
                    84.4176804,
                    55.0527843
                ],
                [
                    84.4177719,
                    55.0530347
                ],
                [
                    84.4173246,
                    55.0533026
                ],
                [
                    84.4180464,
                    55.0536637
                ],
                [
                    84.4180464,
                    55.053885
                ],
                [
                    84.4178227,
                    55.0540014
                ],
                [
                    84.4174669,
                    55.0539141
                ],
                [
                    84.4169281,
                    55.0542053
                ],
                [
                    84.4171212,
                    55.0543159
                ],
                [
                    84.4164401,
                    55.0546886
                ],
                [
                    84.4144474,
                    55.0555446
                ],
                [
                    84.4138781,
                    55.0563133
                ],
                [
                    84.4128309,
                    55.0575594
                ]
            ],
            "longitude": 84.42067,
            "latitude": 55.057507
        },
        "3735": {
            "name": "Большая Чёрная",
            "population": 350,
            "type": "village",
            "poly": [
                [
                    84.4105036,
                    55.9580295
                ],
                [
                    84.4123874,
                    55.9589774
                ],
                [
                    84.4110806,
                    55.959807
                ],
                [
                    84.4115336,
                    55.9600039
                ],
                [
                    84.4131337,
                    55.9609954
                ],
                [
                    84.4129133,
                    55.9611629
                ],
                [
                    84.4141994,
                    55.9619827
                ],
                [
                    84.4147535,
                    55.9617714
                ],
                [
                    84.4158886,
                    55.9629612
                ],
                [
                    84.4179915,
                    55.9640494
                ],
                [
                    84.4195389,
                    55.9657372
                ],
                [
                    84.4213243,
                    55.9669807
                ],
                [
                    84.4210863,
                    55.9684463
                ],
                [
                    84.4232685,
                    55.9688904
                ],
                [
                    84.424062,
                    55.968735
                ],
                [
                    84.4253714,
                    55.966581
                ],
                [
                    84.4264823,
                    55.9666032
                ],
                [
                    84.4308865,
                    55.9683575
                ],
                [
                    84.4297358,
                    55.9696676
                ],
                [
                    84.4332274,
                    55.9703115
                ],
                [
                    84.4336242,
                    55.9697786
                ],
                [
                    84.4345764,
                    55.9697342
                ],
                [
                    84.4345764,
                    55.9701783
                ],
                [
                    84.4397344,
                    55.9703781
                ],
                [
                    84.4399725,
                    55.9693345
                ],
                [
                    84.4406866,
                    55.9695565
                ],
                [
                    84.4406073,
                    55.9707112
                ],
                [
                    84.4434244,
                    55.9708
                ],
                [
                    84.4439402,
                    55.9703781
                ],
                [
                    84.4447337,
                    55.969712
                ],
                [
                    84.4450908,
                    55.9686684
                ],
                [
                    84.4442576,
                    55.9685573
                ],
                [
                    84.4435037,
                    55.9690236
                ],
                [
                    84.4431466,
                    55.9694233
                ],
                [
                    84.441996,
                    55.9693789
                ],
                [
                    84.4424721,
                    55.9685351
                ],
                [
                    84.4430673,
                    55.9676913
                ],
                [
                    84.4405676,
                    55.9673582
                ],
                [
                    84.4334655,
                    55.9670029
                ],
                [
                    84.4336242,
                    55.9659815
                ],
                [
                    84.4343383,
                    55.9660259
                ],
                [
                    84.4358064,
                    55.964649
                ],
                [
                    84.4348938,
                    55.9643159
                ],
                [
                    84.4351319,
                    55.9636941
                ],
                [
                    84.4333861,
                    55.9632277
                ],
                [
                    84.4313626,
                    55.9650044
                ],
                [
                    84.4329893,
                    55.9655595
                ],
                [
                    84.43291,
                    55.9680244
                ],
                [
                    84.4302913,
                    55.9678246
                ],
                [
                    84.4269188,
                    55.9664478
                ],
                [
                    84.4271568,
                    55.9661591
                ],
                [
                    84.4278313,
                    55.9660925
                ],
                [
                    84.4280297,
                    55.9652486
                ],
                [
                    84.4275933,
                    55.9650266
                ],
                [
                    84.4263633,
                    55.9646712
                ],
                [
                    84.4269585,
                    55.9644714
                ],
                [
                    84.4259665,
                    55.9633832
                ],
                [
                    84.4232288,
                    55.9626059
                ],
                [
                    84.423824,
                    55.9621839
                ],
                [
                    84.4222311,
                    55.9611577
                ],
                [
                    84.4214843,
                    55.9615577
                ],
                [
                    84.4212239,
                    55.9617128
                ],
                [
                    84.4207312,
                    55.9622124
                ],
                [
                    84.420294,
                    55.9620644
                ],
                [
                    84.4196862,
                    55.9614127
                ],
                [
                    84.4186504,
                    55.960708
                ],
                [
                    84.4183795,
                    55.9607794
                ],
                [
                    84.4173595,
                    55.9599319
                ],
                [
                    84.4172161,
                    55.9596018
                ],
                [
                    84.4153654,
                    55.9584576
                ],
                [
                    84.4148894,
                    55.9584332
                ],
                [
                    84.4143954,
                    55.9580853
                ],
                [
                    84.415167,
                    55.9577114
                ],
                [
                    84.4137138,
                    55.9568084
                ],
                [
                    84.4130726,
                    55.9571753
                ],
                [
                    84.4135029,
                    55.9574429
                ],
                [
                    84.4131842,
                    55.9576303
                ],
                [
                    84.412254,
                    55.9571277
                ],
                [
                    84.4105036,
                    55.9580295
                ]
            ],
            "longitude": 84.421837,
            "latitude": 55.964317
        },
        "3736": {
            "name": "Баратаевка",
            "population": 520,
            "type": "village",
            "poly": [
                [
                    84.4403464,
                    55.6193233
                ],
                [
                    84.4409548,
                    55.6202585
                ],
                [
                    84.4413942,
                    55.6215755
                ],
                [
                    84.4429153,
                    55.6219191
                ],
                [
                    84.4450109,
                    55.6215564
                ],
                [
                    84.4448757,
                    55.6212701
                ],
                [
                    84.4459236,
                    55.6211174
                ],
                [
                    84.446194,
                    55.6214992
                ],
                [
                    84.4475798,
                    55.621461
                ],
                [
                    84.4476378,
                    55.621248
                ],
                [
                    84.447715,
                    55.6209647
                ],
                [
                    84.4481425,
                    55.6209527
                ],
                [
                    84.4515151,
                    55.6208581
                ],
                [
                    84.453157,
                    55.6208121
                ],
                [
                    84.4530894,
                    55.6205258
                ],
                [
                    84.4558611,
                    55.6202776
                ],
                [
                    84.4556583,
                    55.6197432
                ],
                [
                    84.456571,
                    55.6198959
                ],
                [
                    84.4576188,
                    55.6194951
                ],
                [
                    84.4573146,
                    55.6184262
                ],
                [
                    84.4595117,
                    55.6173191
                ],
                [
                    84.4601539,
                    55.617739
                ],
                [
                    84.4609651,
                    55.6189415
                ],
                [
                    84.4617087,
                    55.6190942
                ],
                [
                    84.4627904,
                    55.6204685
                ],
                [
                    84.4645818,
                    55.6201249
                ],
                [
                    84.4641086,
                    55.619037
                ],
                [
                    84.4665761,
                    55.6187316
                ],
                [
                    84.4665231,
                    55.6173152
                ],
                [
                    84.4664747,
                    55.6160211
                ],
                [
                    84.4658643,
                    55.6160316
                ],
                [
                    84.4653593,
                    55.6160402
                ],
                [
                    84.4641086,
                    55.6166892
                ],
                [
                    84.4612693,
                    55.6167273
                ],
                [
                    84.4614383,
                    55.6161356
                ],
                [
                    84.4624862,
                    55.6158684
                ],
                [
                    84.4620806,
                    55.6151048
                ],
                [
                    84.4606609,
                    55.6144176
                ],
                [
                    84.4545429,
                    55.6154866
                ],
                [
                    84.4544753,
                    55.6157538
                ],
                [
                    84.4469376,
                    55.616651
                ],
                [
                    84.44687,
                    55.6170518
                ],
                [
                    84.4444025,
                    55.6172236
                ],
                [
                    84.4427298,
                    55.6170199
                ],
                [
                    84.4423559,
                    55.6170199
                ],
                [
                    84.4425082,
                    55.6175437
                ],
                [
                    84.4418437,
                    55.6175672
                ],
                [
                    84.4410142,
                    55.6178592
                ],
                [
                    84.440833,
                    55.6183021
                ],
                [
                    84.4414699,
                    55.6192246
                ],
                [
                    84.4406115,
                    55.6191386
                ],
                [
                    84.4403464,
                    55.6193233
                ]
            ],
            "longitude": 84.449059,
            "latitude": 55.618763
        },
        "3737": {
            "name": "Каменная Гора",
            "population": 349,
            "type": "village",
            "poly": [
                [
                    84.441946,
                    55.0673682
                ],
                [
                    84.4454822,
                    55.0688035
                ],
                [
                    84.4470937,
                    55.0699825
                ],
                [
                    84.4468251,
                    55.0710077
                ],
                [
                    84.4490632,
                    55.0713665
                ],
                [
                    84.4493766,
                    55.0710333
                ],
                [
                    84.4554642,
                    55.0740062
                ],
                [
                    84.4570757,
                    55.0744419
                ],
                [
                    84.4576576,
                    55.0739549
                ],
                [
                    84.4574785,
                    55.0731861
                ],
                [
                    84.4601195,
                    55.0716228
                ],
                [
                    84.460791,
                    55.0705207
                ],
                [
                    84.4588662,
                    55.0689317
                ],
                [
                    84.4548823,
                    55.0676758
                ],
                [
                    84.4551509,
                    55.0673169
                ],
                [
                    84.453629,
                    55.0659328
                ],
                [
                    84.4494661,
                    55.0661122
                ],
                [
                    84.4482127,
                    55.065779
                ],
                [
                    84.4476308,
                    55.0664454
                ],
                [
                    84.4457508,
                    55.0653945
                ],
                [
                    84.4441841,
                    55.0651638
                ],
                [
                    84.4432788,
                    55.0660554
                ],
                [
                    84.441946,
                    55.0673682
                ]
            ],
            "longitude": 84.449203,
            "latitude": 55.069672
        },
        "3738": {
            "name": "Дивинка",
            "population": 763,
            "type": "village",
            "poly": null,
            "longitude": 84.473923,
            "latitude": 55.696388
        },
        "3739": {
            "name": "Русско-Семеновский",
            "population": 325,
            "type": "village",
            "poly": [
                [
                    84.4657282,
                    55.274177
                ],
                [
                    84.4687737,
                    55.2754476
                ],
                [
                    84.4730204,
                    55.2760829
                ],
                [
                    84.474213,
                    55.2776007
                ],
                [
                    84.4773957,
                    55.2793325
                ],
                [
                    84.4790526,
                    55.2799888
                ],
                [
                    84.4879028,
                    55.2841354
                ],
                [
                    84.4909078,
                    55.2850248
                ],
                [
                    84.4940391,
                    55.2827529
                ],
                [
                    84.4929615,
                    55.2819226
                ],
                [
                    84.4891545,
                    55.2799474
                ],
                [
                    84.4787255,
                    55.2754965
                ],
                [
                    84.4750794,
                    55.2750567
                ],
                [
                    84.473192,
                    55.2742992
                ],
                [
                    84.4689024,
                    55.274568
                ],
                [
                    84.4667148,
                    55.2734684
                ],
                [
                    84.4657282,
                    55.274177
                ]
            ],
            "longitude": 84.484245,
            "latitude": 55.279877
        },
        "3740": {
            "name": "Турнаево",
            "population": 271,
            "type": "village",
            "poly": [
                [
                    84.5022176,
                    55.7763474
                ],
                [
                    84.5054426,
                    55.777324
                ],
                [
                    84.5048638,
                    55.7783937
                ],
                [
                    84.5031686,
                    55.7795098
                ],
                [
                    84.503582,
                    55.7800446
                ],
                [
                    84.5163579,
                    55.7788355
                ],
                [
                    84.5197069,
                    55.7772543
                ],
                [
                    84.5196656,
                    55.7759753
                ],
                [
                    84.5238828,
                    55.7751614
                ],
                [
                    84.5326895,
                    55.7745568
                ],
                [
                    84.5331029,
                    55.7751847
                ],
                [
                    84.5339299,
                    55.7751382
                ],
                [
                    84.5341366,
                    55.7754637
                ],
                [
                    84.535501,
                    55.7751614
                ],
                [
                    84.5350049,
                    55.7742777
                ],
                [
                    84.5357904,
                    55.7741149
                ],
                [
                    84.535625,
                    55.7730684
                ],
                [
                    84.5325241,
                    55.7730684
                ],
                [
                    84.5323174,
                    55.7721615
                ],
                [
                    84.5258674,
                    55.7700916
                ],
                [
                    84.5213194,
                    55.7717893
                ],
                [
                    84.5206924,
                    55.7727553
                ],
                [
                    84.5203684,
                    55.7732545
                ],
                [
                    84.516606,
                    55.7718126
                ],
                [
                    84.5175156,
                    55.7710451
                ],
                [
                    84.5161925,
                    55.7703474
                ],
                [
                    84.5148694,
                    55.771394
                ],
                [
                    84.508006,
                    55.7735801
                ],
                [
                    84.5062695,
                    55.7751382
                ],
                [
                    84.5024657,
                    55.7749289
                ],
                [
                    84.5022176,
                    55.7763474
                ]
            ],
            "longitude": 84.51368,
            "latitude": 55.775116
        },
        "3741": {
            "name": "Сурково",
            "population": 681,
            "type": "village",
            "poly": [
                [
                    84.5033138,
                    55.2998719
                ],
                [
                    84.5059435,
                    55.3044751
                ],
                [
                    84.5045629,
                    55.3077681
                ],
                [
                    84.5047919,
                    55.3079948
                ],
                [
                    84.506075,
                    55.3092648
                ],
                [
                    84.5098223,
                    55.3104248
                ],
                [
                    84.5116631,
                    55.3131186
                ],
                [
                    84.5131752,
                    55.3168973
                ],
                [
                    84.5167253,
                    55.3173836
                ],
                [
                    84.5194865,
                    55.3122955
                ],
                [
                    84.5292165,
                    55.3106118
                ],
                [
                    84.5321091,
                    55.3069449
                ],
                [
                    84.5294794,
                    55.3041009
                ],
                [
                    84.5254692,
                    55.3017058
                ],
                [
                    84.5225765,
                    55.303315
                ],
                [
                    84.5158706,
                    55.3008076
                ],
                [
                    84.506075,
                    55.2994603
                ],
                [
                    84.5033138,
                    55.2998719
                ]
            ],
            "longitude": 84.516861,
            "latitude": 55.308056
        },
        "3742": {
            "name": "Большеречка",
            "population": 283,
            "type": "village",
            "poly": [
                [
                    84.5190044,
                    55.5621493
                ],
                [
                    84.5198917,
                    55.5625555
                ],
                [
                    84.5194269,
                    55.5628184
                ],
                [
                    84.5200185,
                    55.5630573
                ],
                [
                    84.5191734,
                    55.5636546
                ],
                [
                    84.5203565,
                    55.5644431
                ],
                [
                    84.5225113,
                    55.5651837
                ],
                [
                    84.5247929,
                    55.5660677
                ],
                [
                    84.5256379,
                    55.5660438
                ],
                [
                    84.5253422,
                    55.5674056
                ],
                [
                    84.5234831,
                    55.5684329
                ],
                [
                    84.5256802,
                    55.5697229
                ],
                [
                    84.5266097,
                    55.5690062
                ],
                [
                    84.5277928,
                    55.5698424
                ],
                [
                    84.5318489,
                    55.5682179
                ],
                [
                    84.5334545,
                    55.569054
                ],
                [
                    84.5282575,
                    55.5723029
                ],
                [
                    84.5316799,
                    55.5741661
                ],
                [
                    84.533117,
                    55.5735678
                ],
                [
                    84.5336884,
                    55.5733299
                ],
                [
                    84.5352823,
                    55.5723416
                ],
                [
                    84.535567,
                    55.5719684
                ],
                [
                    84.5362431,
                    55.5723745
                ],
                [
                    84.5372994,
                    55.5717773
                ],
                [
                    84.5377641,
                    55.572709
                ],
                [
                    84.5384824,
                    55.5730195
                ],
                [
                    84.5391162,
                    55.5725895
                ],
                [
                    84.5400035,
                    55.5730195
                ],
                [
                    84.5392852,
                    55.5734495
                ],
                [
                    84.5416935,
                    55.5747871
                ],
                [
                    84.5447779,
                    55.5743333
                ],
                [
                    84.5463412,
                    55.5733539
                ],
                [
                    84.5446934,
                    55.5721595
                ],
                [
                    84.542623,
                    55.5715624
                ],
                [
                    84.5427921,
                    55.5711563
                ],
                [
                    84.541947,
                    55.5709174
                ],
                [
                    84.5401725,
                    55.5710368
                ],
                [
                    84.5394119,
                    55.570774
                ],
                [
                    84.5401725,
                    55.5700096
                ],
                [
                    84.5372994,
                    55.5687912
                ],
                [
                    84.5370458,
                    55.5690301
                ],
                [
                    84.5326939,
                    55.5673101
                ],
                [
                    84.533201,
                    55.56688
                ],
                [
                    84.5225113,
                    55.5619821
                ],
                [
                    84.5210325,
                    55.5627945
                ],
                [
                    84.5205255,
                    55.56246
                ],
                [
                    84.5211593,
                    55.5620777
                ],
                [
                    84.5198072,
                    55.5614564
                ],
                [
                    84.5190044,
                    55.5621493
                ]
            ],
            "longitude": 84.530533,
            "latitude": 55.56694
        },
        "3743": {
            "name": "Суенга",
            "population": 408,
            "type": "village",
            "poly": [
                [
                    84.5274209,
                    54.4083524
                ],
                [
                    84.5274691,
                    54.4097855
                ],
                [
                    84.5315733,
                    54.4092797
                ],
                [
                    84.5341324,
                    54.4090268
                ],
                [
                    84.5372709,
                    54.4135509
                ],
                [
                    84.5383331,
                    54.4138038
                ],
                [
                    84.5396368,
                    54.412736
                ],
                [
                    84.5392505,
                    54.4111344
                ],
                [
                    84.5375123,
                    54.4091954
                ],
                [
                    84.5356292,
                    54.4075374
                ],
                [
                    84.5362569,
                    54.4064133
                ],
                [
                    84.53814,
                    54.4056826
                ],
                [
                    84.5408439,
                    54.4048395
                ],
                [
                    84.5429202,
                    54.4046147
                ],
                [
                    84.5440306,
                    54.4038277
                ],
                [
                    84.5465898,
                    54.4048957
                ],
                [
                    84.549342,
                    54.4047833
                ],
                [
                    84.5513699,
                    54.4035186
                ],
                [
                    84.5590472,
                    54.4017198
                ],
                [
                    84.5628616,
                    54.4023382
                ],
                [
                    84.5649861,
                    54.401495
                ],
                [
                    84.5601094,
                    54.3998367
                ],
                [
                    84.5570192,
                    54.399668
                ],
                [
                    84.5547981,
                    54.400961
                ],
                [
                    84.549004,
                    54.4008204
                ],
                [
                    84.549004,
                    54.3993869
                ],
                [
                    84.5482797,
                    54.3971382
                ],
                [
                    84.5437893,
                    54.3949175
                ],
                [
                    84.5464932,
                    54.3939055
                ],
                [
                    84.5452378,
                    54.3917971
                ],
                [
                    84.542389,
                    54.3910099
                ],
                [
                    84.542727,
                    54.3932871
                ],
                [
                    84.5398782,
                    54.3939336
                ],
                [
                    84.533891,
                    54.3929778
                ],
                [
                    84.5364017,
                    54.3987967
                ],
                [
                    84.5343738,
                    54.3978972
                ],
                [
                    84.5339875,
                    54.3996399
                ],
                [
                    84.5335314,
                    54.4037084
                ],
                [
                    84.5296902,
                    54.4061885
                ],
                [
                    84.5299316,
                    54.4083524
                ],
                [
                    84.5274209,
                    54.4083524
                ]
            ],
            "longitude": 84.539413,
            "latitude": 54.403503
        },
        "3744": {
            "name": "Елбань",
            "population": 839,
            "type": "village",
            "poly": [
                [
                    84.5676149,
                    54.3093073
                ],
                [
                    84.5678317,
                    54.3107405
                ],
                [
                    84.5763574,
                    54.3139438
                ],
                [
                    84.5805479,
                    54.3156297
                ],
                [
                    84.5816318,
                    54.3150397
                ],
                [
                    84.5853166,
                    54.3169783
                ],
                [
                    84.5845218,
                    54.3183269
                ],
                [
                    84.5895795,
                    54.3223303
                ],
                [
                    84.5852443,
                    54.3235524
                ],
                [
                    84.5871229,
                    54.3312207
                ],
                [
                    84.5942036,
                    54.3320212
                ],
                [
                    84.5979607,
                    54.3318948
                ],
                [
                    84.5981774,
                    54.3307994
                ],
                [
                    84.5963711,
                    54.32844
                ],
                [
                    84.5936978,
                    54.3263334
                ],
                [
                    84.5968046,
                    54.3246901
                ],
                [
                    84.5920359,
                    54.3214033
                ],
                [
                    84.5978162,
                    54.3220775
                ],
                [
                    84.6007785,
                    54.3208555
                ],
                [
                    84.6064864,
                    54.3187484
                ],
                [
                    84.6132779,
                    54.3208133
                ],
                [
                    84.6142895,
                    54.3200126
                ],
                [
                    84.612122,
                    54.316599
                ],
                [
                    84.6030183,
                    54.3152504
                ],
                [
                    84.5993334,
                    54.3162197
                ],
                [
                    84.5972381,
                    54.3143232
                ],
                [
                    84.6007785,
                    54.3106983
                ],
                [
                    84.5955041,
                    54.3099396
                ],
                [
                    84.5911689,
                    54.3149554
                ],
                [
                    84.5849553,
                    54.3119207
                ],
                [
                    84.5839438,
                    54.3099396
                ],
                [
                    84.5723113,
                    54.3079163
                ],
                [
                    84.5676149,
                    54.3093073
                ]
            ],
            "longitude": 84.593826,
            "latitude": 54.318886
        },
        "3745": {
            "name": "Егорьевское",
            "population": 584,
            "type": "village",
            "poly": [
                [
                    84.5754278,
                    54.4971056
                ],
                [
                    84.5760913,
                    54.4976377
                ],
                [
                    84.5797563,
                    54.5001881
                ],
                [
                    84.5787453,
                    54.5016742
                ],
                [
                    84.5819681,
                    54.5028668
                ],
                [
                    84.5792192,
                    54.5058204
                ],
                [
                    84.583453,
                    54.5079117
                ],
                [
                    84.5851908,
                    54.5063157
                ],
                [
                    84.5875289,
                    54.5070679
                ],
                [
                    84.5875605,
                    54.5085171
                ],
                [
                    84.5885715,
                    54.5092875
                ],
                [
                    84.5922998,
                    54.5070862
                ],
                [
                    84.5900275,
                    54.5054952
                ],
                [
                    84.5890771,
                    54.5048298
                ],
                [
                    84.5863598,
                    54.5035089
                ],
                [
                    84.5859806,
                    54.5006468
                ],
                [
                    84.5873709,
                    54.5001147
                ],
                [
                    84.5892982,
                    54.4980964
                ],
                [
                    84.5941956,
                    54.4962615
                ],
                [
                    84.5960869,
                    54.4973141
                ],
                [
                    84.5917311,
                    54.5001698
                ],
                [
                    84.5945431,
                    54.500922
                ],
                [
                    84.6018733,
                    54.5018394
                ],
                [
                    84.6089822,
                    54.500867
                ],
                [
                    84.6091719,
                    54.4998945
                ],
                [
                    84.6016837,
                    54.4979863
                ],
                [
                    84.5989665,
                    54.4959679
                ],
                [
                    84.5965968,
                    54.4969221
                ],
                [
                    84.5951118,
                    54.4960964
                ],
                [
                    84.5957122,
                    54.4953074
                ],
                [
                    84.5950802,
                    54.4946101
                ],
                [
                    84.592679,
                    54.4940045
                ],
                [
                    84.5890455,
                    54.494243
                ],
                [
                    84.5852856,
                    54.494922
                ],
                [
                    84.5847169,
                    54.4962065
                ],
                [
                    84.5865494,
                    54.4975093
                ],
                [
                    84.5754278,
                    54.4971056
                ]
            ],
            "longitude": 84.597885,
            "latitude": 54.498913
        },
        "3746": {
            "name": "Корнилово",
            "population": 379,
            "type": "village",
            "poly": [
                [
                    84.5845153,
                    55.5175281
                ],
                [
                    84.5897707,
                    55.5220499
                ],
                [
                    84.594476,
                    55.5246183
                ],
                [
                    84.6001896,
                    55.5238098
                ],
                [
                    84.6067434,
                    55.5222877
                ],
                [
                    84.6054342,
                    55.5209135
                ],
                [
                    84.6048949,
                    55.5198143
                ],
                [
                    84.6048108,
                    55.5180543
                ],
                [
                    84.6066594,
                    55.5145815
                ],
                [
                    84.6101883,
                    55.5125358
                ],
                [
                    84.612457,
                    55.5093005
                ],
                [
                    84.6108605,
                    55.5084441
                ],
                [
                    84.6083398,
                    55.5094908
                ],
                [
                    84.6038026,
                    55.5092529
                ],
                [
                    84.5975008,
                    55.5109658
                ],
                [
                    84.5953162,
                    55.5102045
                ],
                [
                    84.5932996,
                    55.5110134
                ],
                [
                    84.5929367,
                    55.5117013
                ],
                [
                    84.5913671,
                    55.5146767
                ],
                [
                    84.5877342,
                    55.5141227
                ],
                [
                    84.5845153,
                    55.5175281
                ]
            ],
            "longitude": 84.60041,
            "latitude": 55.515568
        },
        "3747": {
            "name": "Ача",
            "population": 492,
            "type": "village",
            "poly": [
                [
                    84.6044926,
                    55.6373437
                ],
                [
                    84.604763,
                    55.6376299
                ],
                [
                    84.6065883,
                    55.6370194
                ],
                [
                    84.60936,
                    55.6370194
                ],
                [
                    84.6103402,
                    55.636695
                ],
                [
                    84.6128415,
                    55.637897
                ],
                [
                    84.6141598,
                    55.6381831
                ],
                [
                    84.6151738,
                    55.6376871
                ],
                [
                    84.6143626,
                    55.6405297
                ],
                [
                    84.6119965,
                    55.6399001
                ],
                [
                    84.6114219,
                    55.6402817
                ],
                [
                    84.6103402,
                    55.6400146
                ],
                [
                    84.6106444,
                    55.6395758
                ],
                [
                    84.6093938,
                    55.6392706
                ],
                [
                    84.6087854,
                    55.6399383
                ],
                [
                    84.609867,
                    55.6414072
                ],
                [
                    84.6110501,
                    55.642113
                ],
                [
                    84.6128077,
                    55.6428761
                ],
                [
                    84.6122816,
                    55.6430943
                ],
                [
                    84.6114893,
                    55.6434666
                ],
                [
                    84.6087854,
                    55.6424945
                ],
                [
                    84.6076361,
                    55.6426662
                ],
                [
                    84.6063179,
                    55.6436581
                ],
                [
                    84.6080756,
                    55.6442495
                ],
                [
                    84.6081432,
                    55.6451651
                ],
                [
                    84.6108473,
                    55.6456038
                ],
                [
                    84.6113543,
                    55.6441541
                ],
                [
                    84.6126725,
                    55.6436009
                ],
                [
                    84.6139908,
                    55.6448408
                ],
                [
                    84.6137542,
                    55.6453749
                ],
                [
                    84.6143288,
                    55.6456229
                ],
                [
                    84.6139908,
                    55.6460616
                ],
                [
                    84.6147344,
                    55.646958
                ],
                [
                    84.6155794,
                    55.6462142
                ],
                [
                    84.6164245,
                    55.6460616
                ],
                [
                    84.6176751,
                    55.6477019
                ],
                [
                    84.6183056,
                    55.6481623
                ],
                [
                    84.619399,
                    55.6489607
                ],
                [
                    84.6208186,
                    55.6483504
                ],
                [
                    84.6214946,
                    55.6488463
                ],
                [
                    84.6225763,
                    55.6485221
                ],
                [
                    84.6228467,
                    55.6481406
                ],
                [
                    84.6260578,
                    55.6469199
                ],
                [
                    84.6247396,
                    55.646176
                ],
                [
                    84.6253818,
                    55.6460043
                ],
                [
                    84.6259226,
                    55.6451841
                ],
                [
                    84.6256522,
                    55.6448599
                ],
                [
                    84.6249762,
                    55.6449171
                ],
                [
                    84.6247058,
                    55.644631
                ],
                [
                    84.6249424,
                    55.6438107
                ],
                [
                    84.6243677,
                    55.64362
                ],
                [
                    84.6246382,
                    55.6432766
                ],
                [
                    84.6232861,
                    55.6424373
                ],
                [
                    84.6211904,
                    55.643124
                ],
                [
                    84.6206496,
                    55.6425136
                ],
                [
                    84.6212242,
                    55.6422084
                ],
                [
                    84.6209876,
                    55.6415868
                ],
                [
                    84.6230477,
                    55.6418864
                ],
                [
                    84.6235565,
                    55.6419604
                ],
                [
                    84.6235227,
                    55.6414835
                ],
                [
                    84.6225425,
                    55.6415789
                ],
                [
                    84.6222721,
                    55.6406441
                ],
                [
                    84.6217989,
                    55.6406823
                ],
                [
                    84.6216975,
                    55.6398811
                ],
                [
                    84.6222383,
                    55.6395758
                ],
                [
                    84.6217961,
                    55.6392015
                ],
                [
                    84.6209538,
                    55.6384884
                ],
                [
                    84.6163231,
                    55.640358
                ],
                [
                    84.6149372,
                    55.6404915
                ],
                [
                    84.615647,
                    55.6379351
                ],
                [
                    84.6161202,
                    55.6384121
                ],
                [
                    84.6174047,
                    55.6377253
                ],
                [
                    84.6169991,
                    55.6371529
                ],
                [
                    84.6179793,
                    55.6366378
                ],
                [
                    84.6171681,
                    55.636199
                ],
                [
                    84.6176413,
                    55.6354931
                ],
                [
                    84.6163569,
                    55.6340621
                ],
                [
                    84.6137542,
                    55.6335278
                ],
                [
                    84.6123345,
                    55.6341956
                ],
                [
                    84.6117261,
                    55.634043
                ],
                [
                    84.6068587,
                    55.6356838
                ],
                [
                    84.6072643,
                    55.6363707
                ],
                [
                    84.6044926,
                    55.6373437
                ]
            ],
            "longitude": 84.617424,
            "latitude": 55.642166
        },
        "3748": {
            "name": "Заречное",
            "population": 452,
            "type": "village",
            "poly": [
                [
                    84.6016029,
                    55.1498794
                ],
                [
                    84.6022053,
                    55.1505414
                ],
                [
                    84.6035492,
                    55.1508856
                ],
                [
                    84.607349,
                    55.1512828
                ],
                [
                    84.6083686,
                    55.1506473
                ],
                [
                    84.6101759,
                    55.150356
                ],
                [
                    84.6105003,
                    55.1508327
                ],
                [
                    84.6117515,
                    55.1513358
                ],
                [
                    84.6119369,
                    55.1520242
                ],
                [
                    84.6131417,
                    55.1523949
                ],
                [
                    84.6131881,
                    55.1530304
                ],
                [
                    84.6158295,
                    55.1541955
                ],
                [
                    84.6154124,
                    55.1548045
                ],
                [
                    84.6170343,
                    55.1557047
                ],
                [
                    84.6170343,
                    55.1561548
                ],
                [
                    84.6217147,
                    55.1584582
                ],
                [
                    84.6235684,
                    55.1589612
                ],
                [
                    84.6228269,
                    55.1593848
                ],
                [
                    84.6251903,
                    55.1602584
                ],
                [
                    84.6265342,
                    55.1614232
                ],
                [
                    84.627322,
                    55.1612379
                ],
                [
                    84.6308439,
                    55.1629057
                ],
                [
                    84.6314,
                    55.1628527
                ],
                [
                    84.6321414,
                    55.1625615
                ],
                [
                    84.6333463,
                    55.1630645
                ],
                [
                    84.6342731,
                    55.1623498
                ],
                [
                    84.6351071,
                    55.1624292
                ],
                [
                    84.6368218,
                    55.1617674
                ],
                [
                    84.6373316,
                    55.1603113
                ],
                [
                    84.6350609,
                    55.1594907
                ],
                [
                    84.6326975,
                    55.161635
                ],
                [
                    84.6303805,
                    55.1607879
                ],
                [
                    84.6322341,
                    55.1596495
                ],
                [
                    84.6309365,
                    55.1589347
                ],
                [
                    84.6321877,
                    55.1580346
                ],
                [
                    84.6276927,
                    55.1558635
                ],
                [
                    84.6271828,
                    55.1540366
                ],
                [
                    84.6252365,
                    55.1531099
                ],
                [
                    84.6217556,
                    55.1502509
                ],
                [
                    84.6211624,
                    55.1508157
                ],
                [
                    84.6203319,
                    55.1503683
                ],
                [
                    84.6193354,
                    55.1506395
                ],
                [
                    84.6183626,
                    55.1511818
                ],
                [
                    84.6140207,
                    55.1493108
                ],
                [
                    84.6116243,
                    55.1494057
                ],
                [
                    84.6109363,
                    55.149826
                ],
                [
                    84.6081365,
                    55.15007
                ],
                [
                    84.6064994,
                    55.1504768
                ],
                [
                    84.6050047,
                    55.1500565
                ],
                [
                    84.6055741,
                    55.1495548
                ],
                [
                    84.6032726,
                    55.14866
                ],
                [
                    84.6027744,
                    55.149121
                ],
                [
                    84.6030116,
                    55.1493379
                ],
                [
                    84.6016029,
                    55.1498794
                ]
            ],
            "longitude": 84.621788,
            "latitude": 55.155621
        },
        "3749": {
            "name": "Коурак",
            "population": 861,
            "type": "village",
            "poly": [
                [
                    84.6541435,
                    54.814782
                ],
                [
                    84.6555844,
                    54.8192446
                ],
                [
                    84.6606277,
                    54.8227729
                ],
                [
                    84.66014,
                    54.8248262
                ],
                [
                    84.6676523,
                    54.8311771
                ],
                [
                    84.6743166,
                    54.8365715
                ],
                [
                    84.6874652,
                    54.8407205
                ],
                [
                    84.6989927,
                    54.8394758
                ],
                [
                    84.7031353,
                    54.8343931
                ],
                [
                    84.6968755,
                    54.8310558
                ],
                [
                    84.6882925,
                    54.8273972
                ],
                [
                    84.6850309,
                    54.8277928
                ],
                [
                    84.6830875,
                    54.8255093
                ],
                [
                    84.6827993,
                    54.8237384
                ],
                [
                    84.6783361,
                    54.8233428
                ],
                [
                    84.6764876,
                    54.822075
                ],
                [
                    84.6747312,
                    54.8208704
                ],
                [
                    84.6737013,
                    54.8178044
                ],
                [
                    84.6670065,
                    54.8152327
                ],
                [
                    84.6620283,
                    54.812463
                ],
                [
                    84.6541435,
                    54.814782
                ]
            ],
            "longitude": 84.676628,
            "latitude": 54.828789
        },
        "3750": {
            "name": "Киик",
            "population": 822,
            "type": "village",
            "poly": [
                [
                    84.6738879,
                    55.2381814
                ],
                [
                    84.6738942,
                    55.2382564
                ],
                [
                    84.6740634,
                    55.2383136
                ],
                [
                    84.6748281,
                    55.2391856
                ],
                [
                    84.6750224,
                    55.2391606
                ],
                [
                    84.6753672,
                    55.2389855
                ],
                [
                    84.6764766,
                    55.2396681
                ],
                [
                    84.6766082,
                    55.2397503
                ],
                [
                    84.6768715,
                    55.2397931
                ],
                [
                    84.6771347,
                    55.239761
                ],
                [
                    84.6773917,
                    55.2396752
                ],
                [
                    84.6784448,
                    55.239082
                ],
                [
                    84.67852,
                    55.2389676
                ],
                [
                    84.6815662,
                    55.2383887
                ],
                [
                    84.6822745,
                    55.2383744
                ],
                [
                    84.6829766,
                    55.2388533
                ],
                [
                    84.6838165,
                    55.2396931
                ],
                [
                    84.6842364,
                    55.2402577
                ],
                [
                    84.6841862,
                    55.2403149
                ],
                [
                    84.6835093,
                    55.2404686
                ],
                [
                    84.6823874,
                    55.2408402
                ],
                [
                    84.6820301,
                    55.2409045
                ],
                [
                    84.6815725,
                    55.2409188
                ],
                [
                    84.6813155,
                    55.2409581
                ],
                [
                    84.6806636,
                    55.241194
                ],
                [
                    84.6803941,
                    55.2412262
                ],
                [
                    84.6800933,
                    55.2411475
                ],
                [
                    84.6799303,
                    55.2411047
                ],
                [
                    84.67808,
                    55.2420337
                ],
                [
                    84.6796348,
                    55.2433389
                ],
                [
                    84.6807855,
                    55.2442043
                ],
                [
                    84.6845929,
                    55.2426968
                ],
                [
                    84.6853029,
                    55.2430737
                ],
                [
                    84.6859518,
                    55.2437157
                ],
                [
                    84.6880085,
                    55.2429969
                ],
                [
                    84.6881799,
                    55.243283
                ],
                [
                    84.6891593,
                    55.2441694
                ],
                [
                    84.6893085,
                    55.2442164
                ],
                [
                    84.689815,
                    55.2439648
                ],
                [
                    84.6899052,
                    55.2441735
                ],
                [
                    84.6899604,
                    55.2444394
                ],
                [
                    84.6898651,
                    55.2446195
                ],
                [
                    84.6897498,
                    55.2447052
                ],
                [
                    84.6895392,
                    55.2446623
                ],
                [
                    84.6895241,
                    55.2447738
                ],
                [
                    84.6894539,
                    55.244831
                ],
                [
                    84.6895191,
                    55.2450682
                ],
                [
                    84.6895993,
                    55.2452426
                ],
                [
                    84.6886968,
                    55.2464975
                ],
                [
                    84.688421,
                    55.2464346
                ],
                [
                    84.6880048,
                    55.2470606
                ],
                [
                    84.6893938,
                    55.2474722
                ],
                [
                    84.6894489,
                    55.2478209
                ],
                [
                    84.6899102,
                    55.2478238
                ],
                [
                    84.6899654,
                    55.2477466
                ],
                [
                    84.6903666,
                    55.2478181
                ],
                [
                    84.6904969,
                    55.2478238
                ],
                [
                    84.6905772,
                    55.2476923
                ],
                [
                    84.6906925,
                    55.2476094
                ],
                [
                    84.6909432,
                    55.247598
                ],
                [
                    84.6912742,
                    55.2477038
                ],
                [
                    84.6913243,
                    55.2477924
                ],
                [
                    84.6917957,
                    55.2479096
                ],
                [
                    84.6919209,
                    55.2478152
                ],
                [
                    84.6924274,
                    55.2479124
                ],
                [
                    84.6926882,
                    55.2480182
                ],
                [
                    84.6921517,
                    55.2487299
                ],
                [
                    84.6924475,
                    55.2487842
                ],
                [
                    84.692623,
                    55.2488499
                ],
                [
                    84.6932398,
                    55.2485727
                ],
                [
                    84.6950099,
                    55.2490157
                ],
                [
                    84.6945536,
                    55.2497131
                ],
                [
                    84.6945987,
                    55.2500047
                ],
                [
                    84.6948394,
                    55.2501219
                ],
                [
                    84.6949297,
                    55.2500818
                ],
                [
                    84.6951002,
                    55.2500818
                ],
                [
                    84.6961432,
                    55.2502905
                ],
                [
                    84.6975923,
                    55.248687
                ],
                [
                    84.6977729,
                    55.2486784
                ],
                [
                    84.6979233,
                    55.2482668
                ],
                [
                    84.6986754,
                    55.2484269
                ],
                [
                    84.6988108,
                    55.2484726
                ],
                [
                    84.6990064,
                    55.2484869
                ],
                [
                    84.6991167,
                    55.2483354
                ],
                [
                    84.6996132,
                    55.2484498
                ],
                [
                    84.6999291,
                    55.2480096
                ],
                [
                    84.6999993,
                    55.2476066
                ],
                [
                    84.7014835,
                    55.2471121
                ],
                [
                    84.7018195,
                    55.2467633
                ],
                [
                    84.7017794,
                    55.2466919
                ],
                [
                    84.7024262,
                    55.2466633
                ],
                [
                    84.7031734,
                    55.2473808
                ],
                [
                    84.7032135,
                    55.2482668
                ],
                [
                    84.7033288,
                    55.2485384
                ],
                [
                    84.7035545,
                    55.2488185
                ],
                [
                    84.704066,
                    55.2492044
                ],
                [
                    84.7041111,
                    55.2493073
                ],
                [
                    84.7038955,
                    55.2494845
                ],
                [
                    84.7050187,
                    55.2500247
                ],
                [
                    84.7052243,
                    55.2502848
                ],
                [
                    84.7050538,
                    55.2504906
                ],
                [
                    84.7051591,
                    55.2505477
                ],
                [
                    84.7051941,
                    55.2506849
                ],
                [
                    84.7052794,
                    55.2507821
                ],
                [
                    84.705475,
                    55.2509279
                ],
                [
                    84.7058962,
                    55.2511794
                ],
                [
                    84.7071849,
                    55.2517539
                ],
                [
                    84.7071298,
                    55.2518482
                ],
                [
                    84.7066233,
                    55.252194
                ],
                [
                    84.7066183,
                    55.2522912
                ],
                [
                    84.7066835,
                    55.2524141
                ],
                [
                    84.7066033,
                    55.2524312
                ],
                [
                    84.7067487,
                    55.2527627
                ],
                [
                    84.7069643,
                    55.2527999
                ],
                [
                    84.7071147,
                    55.2528942
                ],
                [
                    84.7071849,
                    55.2531629
                ],
                [
                    84.7071448,
                    55.2534144
                ],
                [
                    84.7071899,
                    55.2535315
                ],
                [
                    84.7073454,
                    55.253743
                ],
                [
                    84.7069643,
                    55.2537516
                ],
                [
                    84.7068388,
                    55.2536687
                ],
                [
                    84.7066083,
                    55.2537059
                ],
                [
                    84.7064227,
                    55.253763
                ],
                [
                    84.7054349,
                    55.2537459
                ],
                [
                    84.7051892,
                    55.2538002
                ],
                [
                    84.7054148,
                    55.254286
                ],
                [
                    84.706177,
                    55.2541288
                ],
                [
                    84.7069944,
                    55.2551434
                ],
                [
                    84.7075008,
                    55.2551805
                ],
                [
                    84.707907,
                    55.2555635
                ],
                [
                    84.7083483,
                    55.2555578
                ],
                [
                    84.7086692,
                    55.2557893
                ],
                [
                    84.7089149,
                    55.2561065
                ],
                [
                    84.7099729,
                    55.2567237
                ],
                [
                    84.7102036,
                    55.2569666
                ],
                [
                    84.7108806,
                    55.2574839
                ],
                [
                    84.7116177,
                    55.2572296
                ],
                [
                    84.7125001,
                    55.256698
                ],
                [
                    84.7125704,
                    55.2564866
                ],
                [
                    84.7123047,
                    55.2563494
                ],
                [
                    84.7128412,
                    55.2560293
                ],
                [
                    84.7118584,
                    55.2552406
                ],
                [
                    84.7114522,
                    55.2548005
                ],
                [
                    84.7113168,
                    55.2548233
                ],
                [
                    84.7109909,
                    55.2544804
                ],
                [
                    84.7107452,
                    55.2545375
                ],
                [
                    84.7102989,
                    55.2541088
                ],
                [
                    84.7104042,
                    55.2538945
                ],
                [
                    84.7093762,
                    55.2524627
                ],
                [
                    84.7093662,
                    55.2521911
                ],
                [
                    84.7091906,
                    55.2516538
                ],
                [
                    84.7087244,
                    55.250805
                ],
                [
                    84.7091606,
                    55.2506592
                ],
                [
                    84.7096069,
                    55.2504591
                ],
                [
                    84.7091757,
                    55.2496703
                ],
                [
                    84.7092308,
                    55.2496388
                ],
                [
                    84.7090704,
                    55.2493701
                ],
                [
                    84.7091255,
                    55.2490129
                ],
                [
                    84.7092759,
                    55.2487499
                ],
                [
                    84.7096069,
                    55.2483669
                ],
                [
                    84.7103139,
                    55.2481354
                ],
                [
                    84.7107151,
                    55.2482411
                ],
                [
                    84.711046,
                    55.2482297
                ],
                [
                    84.7116628,
                    55.2483583
                ],
                [
                    84.7117932,
                    55.2481268
                ],
                [
                    84.7125153,
                    55.2475808
                ],
                [
                    84.7118282,
                    55.2472521
                ],
                [
                    84.7114622,
                    55.2471864
                ],
                [
                    84.7113168,
                    55.246992
                ],
                [
                    84.7100732,
                    55.2473407
                ],
                [
                    84.710324,
                    55.2468291
                ],
                [
                    84.7103089,
                    55.2467462
                ],
                [
                    84.7099679,
                    55.2466719
                ],
                [
                    84.7094615,
                    55.246729
                ],
                [
                    84.7091055,
                    55.2469377
                ],
                [
                    84.7087695,
                    55.2470006
                ],
                [
                    84.7085238,
                    55.2469977
                ],
                [
                    84.7084285,
                    55.2468834
                ],
                [
                    84.708263,
                    55.2467862
                ],
                [
                    84.7070345,
                    55.2464318
                ],
                [
                    84.7066985,
                    55.2463946
                ],
                [
                    84.706187,
                    55.2461431
                ],
                [
                    84.7059213,
                    55.2459458
                ],
                [
                    84.7057607,
                    55.2456828
                ],
                [
                    84.7056355,
                    55.2455828
                ],
                [
                    84.7053647,
                    55.2454827
                ],
                [
                    84.7052393,
                    55.2453798
                ],
                [
                    84.7052143,
                    55.2450911
                ],
                [
                    84.7053246,
                    55.2449682
                ],
                [
                    84.7054499,
                    55.2444479
                ],
                [
                    84.7050037,
                    55.2443479
                ],
                [
                    84.7049885,
                    55.2442135
                ],
                [
                    84.7045875,
                    55.2441821
                ],
                [
                    84.7028475,
                    55.2441878
                ],
                [
                    84.7023509,
                    55.2441707
                ],
                [
                    84.7018195,
                    55.2444994
                ],
                [
                    84.7014936,
                    55.2444822
                ],
                [
                    84.7012378,
                    55.2447024
                ],
                [
                    84.7009169,
                    55.2447138
                ],
                [
                    84.6999742,
                    55.2448596
                ],
                [
                    84.7000444,
                    55.2450654
                ],
                [
                    84.6999692,
                    55.2452483
                ],
                [
                    84.6993524,
                    55.2452283
                ],
                [
                    84.6989161,
                    55.2452598
                ],
                [
                    84.6977578,
                    55.2456542
                ],
                [
                    84.6978782,
                    55.2457486
                ],
                [
                    84.6976876,
                    55.2459658
                ],
                [
                    84.6973115,
                    55.2457143
                ],
                [
                    84.6955214,
                    55.245234
                ],
                [
                    84.6945235,
                    55.2448624
                ],
                [
                    84.6937613,
                    55.2442078
                ],
                [
                    84.693982,
                    55.243942
                ],
                [
                    84.6938616,
                    55.2438476
                ],
                [
                    84.6941775,
                    55.2434446
                ],
                [
                    84.6937212,
                    55.2432216
                ],
                [
                    84.692949,
                    55.2432959
                ],
                [
                    84.6928236,
                    55.2430558
                ],
                [
                    84.6926782,
                    55.2430015
                ],
                [
                    84.6921868,
                    55.2423754
                ],
                [
                    84.6918057,
                    55.2424583
                ],
                [
                    84.6914998,
                    55.2421924
                ],
                [
                    84.6921768,
                    55.2419694
                ],
                [
                    84.6921416,
                    55.2418094
                ],
                [
                    84.6920063,
                    55.2416921
                ],
                [
                    84.6917104,
                    55.2415721
                ],
                [
                    84.6914497,
                    55.2412748
                ],
                [
                    84.6914497,
                    55.2412204
                ],
                [
                    84.691575,
                    55.2412119
                ],
                [
                    84.6918508,
                    55.2413805
                ],
                [
                    84.6921316,
                    55.2413777
                ],
                [
                    84.6922369,
                    55.2413262
                ],
                [
                    84.6922871,
                    55.241149
                ],
                [
                    84.6922871,
                    55.2408917
                ],
                [
                    84.6921968,
                    55.24048
                ],
                [
                    84.6920364,
                    55.240034
                ],
                [
                    84.6922119,
                    55.2399597
                ],
                [
                    84.692593,
                    55.2399139
                ],
                [
                    84.69157,
                    55.2378154
                ],
                [
                    84.6914396,
                    55.237641
                ],
                [
                    84.6912591,
                    55.2375238
                ],
                [
                    84.6911789,
                    55.2372122
                ],
                [
                    84.6900306,
                    55.2369348
                ],
                [
                    84.6895392,
                    55.2364545
                ],
                [
                    84.6889374,
                    55.2361342
                ],
                [
                    84.6875986,
                    55.2355939
                ],
                [
                    84.6872727,
                    55.2356253
                ],
                [
                    84.6861595,
                    55.2352536
                ],
                [
                    84.685668,
                    55.235225
                ],
                [
                    84.683992,
                    55.2354116
                ],
                [
                    84.6830894,
                    55.2350399
                ],
                [
                    84.6830894,
                    55.2347182
                ],
                [
                    84.6831646,
                    55.2346074
                ],
                [
                    84.6827509,
                    55.234082
                ],
                [
                    84.6823121,
                    55.2337853
                ],
                [
                    84.6818608,
                    55.2336495
                ],
                [
                    84.6807451,
                    55.2336495
                ],
                [
                    84.6804255,
                    55.2337496
                ],
                [
                    84.6800995,
                    55.2341392
                ],
                [
                    84.6797673,
                    55.2343393
                ],
                [
                    84.6794288,
                    55.2344001
                ],
                [
                    84.6791217,
                    55.2346038
                ],
                [
                    84.6792408,
                    55.2347039
                ],
                [
                    84.6785388,
                    55.2350935
                ],
                [
                    84.6769843,
                    55.2363337
                ],
                [
                    84.6762572,
                    55.2367518
                ],
                [
                    84.6750851,
                    55.2375381
                ],
                [
                    84.6744144,
                    55.2379169
                ],
                [
                    84.6739694,
                    55.238067
                ],
                [
                    84.6738879,
                    55.2381814
                ]
            ],
            "longitude": 84.691559,
            "latitude": 55.244522
        },
        "3751": {
            "name": "Дубровка",
            "population": 626,
            "type": "village",
            "poly": [
                [
                    84.7035219,
                    54.4619883
                ],
                [
                    84.7065443,
                    54.4637999
                ],
                [
                    84.7062801,
                    54.4664976
                ],
                [
                    84.7062137,
                    54.4671758
                ],
                [
                    84.7141002,
                    54.4676698
                ],
                [
                    84.716792,
                    54.4673954
                ],
                [
                    84.7258119,
                    54.4671209
                ],
                [
                    84.7290703,
                    54.4662152
                ],
                [
                    84.7303454,
                    54.4644312
                ],
                [
                    84.729212,
                    54.4636901
                ],
                [
                    84.7209005,
                    54.4618236
                ],
                [
                    84.7162725,
                    54.4604512
                ],
                [
                    84.7110306,
                    54.4606982
                ],
                [
                    84.7039469,
                    54.4614119
                ],
                [
                    84.7035219,
                    54.4619883
                ]
            ],
            "longitude": 84.721375,
            "latitude": 54.464409
        },
        "3752": {
            "name": "Завьялово",
            "population": 764,
            "type": "village",
            "poly": [
                [
                    84.703917,
                    55.0741069
                ],
                [
                    84.7050191,
                    55.0745657
                ],
                [
                    84.7064885,
                    55.0733421
                ],
                [
                    84.7122994,
                    55.0757511
                ],
                [
                    84.7151714,
                    55.0759232
                ],
                [
                    84.7155722,
                    55.0762482
                ],
                [
                    84.7161065,
                    55.076057
                ],
                [
                    84.7158059,
                    55.0757702
                ],
                [
                    84.7171417,
                    55.0750628
                ],
                [
                    84.7177429,
                    55.0751775
                ],
                [
                    84.7178765,
                    55.0750055
                ],
                [
                    84.7150044,
                    55.0736671
                ],
                [
                    84.7168412,
                    55.0725199
                ],
                [
                    84.7146037,
                    55.071277
                ],
                [
                    84.7190321,
                    55.0692663
                ],
                [
                    84.725253,
                    55.0712431
                ],
                [
                    84.7239364,
                    55.0729563
                ],
                [
                    84.7298012,
                    55.0774788
                ],
                [
                    84.7293566,
                    55.0795735
                ],
                [
                    84.7358028,
                    55.0802391
                ],
                [
                    84.7367946,
                    55.0791135
                ],
                [
                    84.7362474,
                    55.0780759
                ],
                [
                    84.7365894,
                    55.0774886
                ],
                [
                    84.7373588,
                    55.0771558
                ],
                [
                    84.7375981,
                    55.0765881
                ],
                [
                    84.7362303,
                    55.0753155
                ],
                [
                    84.7352386,
                    55.0744932
                ],
                [
                    84.7331355,
                    55.0738961
                ],
                [
                    84.7329645,
                    55.073387
                ],
                [
                    84.7361448,
                    55.0727018
                ],
                [
                    84.7369998,
                    55.0723689
                ],
                [
                    84.74636,
                    55.0739184
                ],
                [
                    84.7529767,
                    55.0697883
                ],
                [
                    84.7476124,
                    55.0681522
                ],
                [
                    84.7510042,
                    55.0659411
                ],
                [
                    84.7480298,
                    55.0649252
                ],
                [
                    84.7488647,
                    55.0626541
                ],
                [
                    84.7465688,
                    55.0622955
                ],
                [
                    84.7443895,
                    55.0681644
                ],
                [
                    84.7424465,
                    55.06869
                ],
                [
                    84.734482,
                    55.0661732
                ],
                [
                    84.7334101,
                    55.0662142
                ],
                [
                    84.7320881,
                    55.065539
                ],
                [
                    84.7303016,
                    55.0650275
                ],
                [
                    84.7261137,
                    55.0647459
                ],
                [
                    84.7266877,
                    55.0627438
                ],
                [
                    84.7254355,
                    55.0628334
                ],
                [
                    84.7226699,
                    55.0645367
                ],
                [
                    84.7177127,
                    55.0616978
                ],
                [
                    84.7154167,
                    55.0635805
                ],
                [
                    84.7191257,
                    55.0668421
                ],
                [
                    84.7193992,
                    55.0689471
                ],
                [
                    84.7189377,
                    55.069171
                ],
                [
                    84.7157401,
                    55.0705135
                ],
                [
                    84.7130898,
                    55.0695541
                ],
                [
                    84.7122349,
                    55.0697009
                ],
                [
                    84.7114484,
                    55.0692212
                ],
                [
                    84.7109696,
                    55.0695835
                ],
                [
                    84.712081,
                    55.0701317
                ],
                [
                    84.7103882,
                    55.0708562
                ],
                [
                    84.709328,
                    55.0705233
                ],
                [
                    84.7052928,
                    55.0725401
                ],
                [
                    84.7046431,
                    55.072775
                ],
                [
                    84.7045747,
                    55.0734994
                ],
                [
                    84.703917,
                    55.0741069
                ]
            ],
            "longitude": 84.728462,
            "latitude": 55.068684
        },
        "3753": {
            "name": "Мирный",
            "population": 283,
            "type": "village",
            "poly": [
                [
                    84.737078,
                    54.7265946
                ],
                [
                    84.7397578,
                    54.7288703
                ],
                [
                    84.7449597,
                    54.7285973
                ],
                [
                    84.7477972,
                    54.7292345
                ],
                [
                    84.7503194,
                    54.7291434
                ],
                [
                    84.7528415,
                    54.7283242
                ],
                [
                    84.7545755,
                    54.7268677
                ],
                [
                    84.753945,
                    54.7254112
                ],
                [
                    84.7531568,
                    54.7240457
                ],
                [
                    84.7564672,
                    54.7241367
                ],
                [
                    84.7582012,
                    54.724774
                ],
                [
                    84.7600928,
                    54.7231353
                ],
                [
                    84.757413,
                    54.7221339
                ],
                [
                    84.7561519,
                    54.7211324
                ],
                [
                    84.7575706,
                    54.7201309
                ],
                [
                    84.7609351,
                    54.7180741
                ],
                [
                    84.7609033,
                    54.7178703
                ],
                [
                    84.7589893,
                    54.7167621
                ],
                [
                    84.7558366,
                    54.7148499
                ],
                [
                    84.7511075,
                    54.7168531
                ],
                [
                    84.7489006,
                    54.7192204
                ],
                [
                    84.7433834,
                    54.7220428
                ],
                [
                    84.7381814,
                    54.7245919
                ],
                [
                    84.737078,
                    54.7265946
                ]
            ],
            "longitude": 84.749237,
            "latitude": 54.725227
        },
        "3754": {
            "name": "Шахта",
            "population": 1750,
            "type": "village",
            "poly": [
                [
                    84.7426637,
                    55.0979161
                ],
                [
                    84.7461648,
                    55.1001101
                ],
                [
                    84.7545258,
                    55.1005461
                ],
                [
                    84.7596691,
                    55.0986792
                ],
                [
                    84.7626426,
                    55.0959881
                ],
                [
                    84.7631702,
                    55.0923829
                ],
                [
                    84.7568348,
                    55.0908564
                ],
                [
                    84.7538339,
                    55.0925737
                ],
                [
                    84.7469984,
                    55.0909518
                ],
                [
                    84.7434973,
                    55.0925737
                ],
                [
                    84.7426637,
                    55.0979161
                ]
            ],
            "longitude": 84.754791,
            "latitude": 55.094715
        },
        "3755": {
            "name": "Курундус",
            "population": 874,
            "type": "village",
            "poly": [
                [
                    84.7847242,
                    55.0599675
                ],
                [
                    84.796698,
                    55.0597463
                ],
                [
                    84.7999812,
                    55.0551005
                ],
                [
                    84.788973,
                    55.0551005
                ],
                [
                    84.7847242,
                    55.0599675
                ]
            ],
            "longitude": 84.790718,
            "latitude": 55.057735
        },
        "3756": {
            "name": "Юрты",
            "population": 576,
            "type": "village",
            "poly": [
                [
                    84.777365,
                    54.8501637
                ],
                [
                    84.7836174,
                    54.8513773
                ],
                [
                    84.7894682,
                    54.8528716
                ],
                [
                    84.7878334,
                    54.8553894
                ],
                [
                    84.7850944,
                    54.8543988
                ],
                [
                    84.786256,
                    54.853177
                ],
                [
                    84.7844491,
                    54.8526734
                ],
                [
                    84.782083,
                    54.8554802
                ],
                [
                    84.788321,
                    54.8573127
                ],
                [
                    84.7892674,
                    54.8561406
                ],
                [
                    84.7878908,
                    54.8557031
                ],
                [
                    84.7896832,
                    54.8529376
                ],
                [
                    84.8031202,
                    54.8566936
                ],
                [
                    84.8083257,
                    54.8575521
                ],
                [
                    84.8108783,
                    54.8576924
                ],
                [
                    84.8267674,
                    54.8571807
                ],
                [
                    84.8270542,
                    54.8546134
                ],
                [
                    84.8258639,
                    54.8543988
                ],
                [
                    84.8260217,
                    54.8539035
                ],
                [
                    84.8246163,
                    54.8536558
                ],
                [
                    84.8249605,
                    54.8532348
                ],
                [
                    84.8243295,
                    54.8529046
                ],
                [
                    84.8245877,
                    54.8525661
                ],
                [
                    84.8242292,
                    54.8524588
                ],
                [
                    84.8243152,
                    54.8522442
                ],
                [
                    84.8228955,
                    54.8517241
                ],
                [
                    84.8230389,
                    54.8515507
                ],
                [
                    84.822451,
                    54.8512617
                ],
                [
                    84.8222215,
                    54.8507416
                ],
                [
                    84.8224223,
                    54.8501555
                ],
                [
                    84.8236842,
                    54.8499078
                ],
                [
                    84.8226661,
                    54.8495693
                ],
                [
                    84.8184069,
                    54.8494785
                ],
                [
                    84.8125561,
                    54.8499821
                ],
                [
                    84.8125561,
                    54.8488675
                ],
                [
                    84.8110217,
                    54.8488015
                ],
                [
                    84.8101183,
                    54.8490739
                ],
                [
                    84.8090858,
                    54.8489996
                ],
                [
                    84.8088994,
                    54.8485703
                ],
                [
                    84.8095877,
                    54.8477116
                ],
                [
                    84.80943,
                    54.847241
                ],
                [
                    84.8082971,
                    54.8471337
                ],
                [
                    84.8072646,
                    54.8477199
                ],
                [
                    84.8069061,
                    54.8476869
                ],
                [
                    84.8059596,
                    54.8474722
                ],
                [
                    84.8047837,
                    54.8477859
                ],
                [
                    84.8036651,
                    54.8476951
                ],
                [
                    84.8030055,
                    54.8472575
                ],
                [
                    84.8016001,
                    54.8473318
                ],
                [
                    84.8010265,
                    54.8476208
                ],
                [
                    84.798603,
                    54.8481162
                ],
                [
                    84.795864,
                    54.8475795
                ],
                [
                    84.7952044,
                    54.8474804
                ],
                [
                    84.7950036,
                    54.8464814
                ],
                [
                    84.7932254,
                    54.8459282
                ],
                [
                    84.792365,
                    54.8462997
                ],
                [
                    84.7894826,
                    54.8467291
                ],
                [
                    84.7880629,
                    54.8467043
                ],
                [
                    84.7859692,
                    54.8463658
                ],
                [
                    84.7816958,
                    54.8466135
                ],
                [
                    84.7816384,
                    54.8464896
                ],
                [
                    84.7810648,
                    54.8464896
                ],
                [
                    84.7811222,
                    54.8467291
                ],
                [
                    84.7800323,
                    54.8467043
                ],
                [
                    84.7798315,
                    54.846275
                ],
                [
                    84.7775084,
                    54.846564
                ],
                [
                    84.777365,
                    54.8501637
                ]
            ],
            "longitude": 84.809662,
            "latitude": 54.853699
        },
        "3757": {
            "name": "Березиково",
            "population": 983,
            "type": "village",
            "poly": [
                [
                    84.7969826,
                    55.047281
                ],
                [
                    84.8039351,
                    55.0499363
                ],
                [
                    84.8164883,
                    55.0483874
                ],
                [
                    84.8247928,
                    55.0425231
                ],
                [
                    84.8188059,
                    55.0361045
                ],
                [
                    84.8027764,
                    55.0362152
                ],
                [
                    84.7969826,
                    55.047281
                ]
            ],
            "longitude": 84.814629,
            "latitude": 55.041721
        },
        "3758": {
            "name": "Гремячинский",
            "population": 285,
            "type": "village",
            "poly": [
                [
                    84.8281226,
                    54.9621316
                ],
                [
                    84.8368736,
                    54.9636908
                ],
                [
                    84.8423053,
                    54.9616119
                ],
                [
                    84.8368736,
                    54.957627
                ],
                [
                    84.8322,
                    54.9582313
                ],
                [
                    84.8281226,
                    54.9621316
                ]
            ],
            "longitude": 84.833778,
            "latitude": 54.960495
        },
        "3759": {
            "name": "Степногутово",
            "population": 589,
            "type": "village",
            "poly": [
                [
                    84.9519752,
                    54.84354
                ],
                [
                    84.9618729,
                    54.8500728
                ],
                [
                    84.9691151,
                    54.8534082
                ],
                [
                    84.9804613,
                    54.8488219
                ],
                [
                    84.9811855,
                    54.8410379
                ],
                [
                    84.9519752,
                    54.84354
                ]
            ],
            "longitude": 84.967766,
            "latitude": 54.846779
        },
        "3760": {
            "name": "Верхняя Гутара",
            "population": 403,
            "type": "village",
            "poly": null,
            "longitude": 96.975929,
            "latitude": 54.217838
        },
        "3761": {
            "name": "Венгерка",
            "population": 547,
            "type": "village",
            "poly": null,
            "longitude": 97.268463,
            "latitude": 55.803421
        },
        "3762": {
            "name": "Еланка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 97.40757,
            "latitude": 55.7624396
        },
        "3763": {
            "name": "Половино-Черемхово",
            "population": 776,
            "type": "village",
            "poly": null,
            "longitude": 97.623337,
            "latitude": 56.068188
        },
        "3764": {
            "name": "Юрты",
            "population": 5311,
            "type": "village",
            "poly": [
                [
                    97.6097469,
                    56.0483651
                ],
                [
                    97.6176227,
                    56.0592699
                ],
                [
                    97.6188202,
                    56.0600157
                ],
                [
                    97.6149924,
                    56.0620813
                ],
                [
                    97.6201508,
                    56.0635212
                ],
                [
                    97.6238353,
                    56.061567
                ],
                [
                    97.6365471,
                    56.0615156
                ],
                [
                    97.6478771,
                    56.0589441
                ],
                [
                    97.6425345,
                    56.0553952
                ],
                [
                    97.6488904,
                    56.053492
                ],
                [
                    97.6612337,
                    56.0537492
                ],
                [
                    97.6610494,
                    56.0503542
                ],
                [
                    97.6482456,
                    56.0454154
                ],
                [
                    97.6468639,
                    56.0422769
                ],
                [
                    97.655062,
                    56.0404245
                ],
                [
                    97.6494431,
                    56.0363078
                ],
                [
                    97.6383894,
                    56.0383662
                ],
                [
                    97.6359944,
                    56.0369253
                ],
                [
                    97.6288095,
                    56.0378516
                ],
                [
                    97.6254934,
                    56.0358447
                ],
                [
                    97.6195329,
                    56.0371177
                ],
                [
                    97.6188816,
                    56.0387005
                ],
                [
                    97.6221057,
                    56.0403015
                ],
                [
                    97.6206891,
                    56.0407927
                ],
                [
                    97.6175952,
                    56.0406744
                ],
                [
                    97.6165204,
                    56.0407563
                ],
                [
                    97.6149973,
                    56.0448538
                ],
                [
                    97.6158725,
                    56.0457284
                ],
                [
                    97.6108062,
                    56.0470404
                ],
                [
                    97.6097469,
                    56.0483651
                ]
            ],
            "longitude": 97.635185,
            "latitude": 56.048733
        },
        "3765": {
            "name": "Рождественка",
            "population": 444,
            "type": "village",
            "poly": null,
            "longitude": 97.640671,
            "latitude": 55.793201
        },
        "3766": {
            "name": "Заречное",
            "population": 333,
            "type": "village",
            "poly": null,
            "longitude": 97.654861,
            "latitude": 55.9681149
        },
        "3767": {
            "name": "Шелаево",
            "population": 667,
            "type": "village",
            "poly": [
                [
                    97.6833557,
                    56.9280573
                ],
                [
                    97.689461,
                    56.9322348
                ],
                [
                    97.6951787,
                    56.933028
                ],
                [
                    97.704482,
                    56.9303841
                ],
                [
                    97.7026407,
                    56.9272112
                ],
                [
                    97.7033191,
                    56.9245669
                ],
                [
                    97.6998303,
                    56.9201241
                ],
                [
                    97.6833557,
                    56.9280573
                ]
            ],
            "longitude": 97.694885,
            "latitude": 56.928532
        },
        "3768": {
            "name": "Шелехово",
            "population": 952,
            "type": "village",
            "poly": null,
            "longitude": 97.702019,
            "latitude": 55.72134
        },
        "3769": {
            "name": "Мирный",
            "population": 995,
            "type": "village",
            "poly": [
                [
                    97.6882332,
                    56.886158
                ],
                [
                    97.6885806,
                    56.8889769
                ],
                [
                    97.6929965,
                    56.8912807
                ],
                [
                    97.6980764,
                    56.8883809
                ],
                [
                    97.7014688,
                    56.886959
                ],
                [
                    97.7063586,
                    56.8854667
                ],
                [
                    97.7127361,
                    56.8846628
                ],
                [
                    97.7179637,
                    56.8815958
                ],
                [
                    97.7182093,
                    56.8796789
                ],
                [
                    97.7137535,
                    56.8794872
                ],
                [
                    97.7087877,
                    56.8770318
                ],
                [
                    97.7119729,
                    56.8756316
                ],
                [
                    97.7130299,
                    56.8761096
                ],
                [
                    97.7155745,
                    56.8753578
                ],
                [
                    97.7168937,
                    56.8747661
                ],
                [
                    97.7119718,
                    56.8714391
                ],
                [
                    97.7061936,
                    56.8738016
                ],
                [
                    97.7054567,
                    56.8760256
                ],
                [
                    97.6982,
                    56.8779342
                ],
                [
                    97.6985653,
                    56.8809857
                ],
                [
                    97.6974575,
                    56.8843121
                ],
                [
                    97.692335,
                    56.8859989
                ],
                [
                    97.6882332,
                    56.886158
                ]
            ],
            "longitude": 97.705086,
            "latitude": 56.880692
        },
        "3770": {
            "name": "Новобирюсинский",
            "population": 4519,
            "type": "village",
            "poly": [
                [
                    97.6878131,
                    56.9609063
                ],
                [
                    97.6904104,
                    56.9657804
                ],
                [
                    97.7003998,
                    56.9698372
                ],
                [
                    97.7168338,
                    56.9659975
                ],
                [
                    97.7170018,
                    56.9676301
                ],
                [
                    97.7323245,
                    56.9687567
                ],
                [
                    97.7352643,
                    56.9597073
                ],
                [
                    97.7491496,
                    56.9575286
                ],
                [
                    97.7500486,
                    56.9501202
                ],
                [
                    97.7401591,
                    56.94113
                ],
                [
                    97.7066946,
                    56.9499295
                ],
                [
                    97.6942308,
                    56.9566542
                ],
                [
                    97.6878131,
                    56.9609063
                ]
            ],
            "longitude": 97.709785,
            "latitude": 56.957432
        },
        "3771": {
            "name": "Тамтачет",
            "population": 1784,
            "type": "village",
            "poly": [
                [
                    97.7120797,
                    57.280501
                ],
                [
                    97.7165367,
                    57.2852309
                ],
                [
                    97.7339801,
                    57.2803161
                ],
                [
                    97.7380411,
                    57.2773127
                ],
                [
                    97.7385304,
                    57.27175
                ],
                [
                    97.7370924,
                    57.262918
                ],
                [
                    97.728595,
                    57.260754
                ],
                [
                    97.7194092,
                    57.2632588
                ],
                [
                    97.7207468,
                    57.277868
                ],
                [
                    97.7120797,
                    57.280501
                ]
            ],
            "longitude": 97.730148,
            "latitude": 57.270702
        },
        "3772": {
            "name": "Талая",
            "population": 390,
            "type": "village",
            "poly": null,
            "longitude": 97.75074,
            "latitude": 55.590462
        },
        "3773": {
            "name": "Тимирязева",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 97.753441,
            "latitude": 55.943954
        },
        "3774": {
            "name": "Горевая",
            "population": 284,
            "type": "village",
            "poly": [
                [
                    97.7467379,
                    57.175374
                ],
                [
                    97.7471443,
                    57.1772281
                ],
                [
                    97.7555433,
                    57.1803121
                ],
                [
                    97.7664824,
                    57.1807893
                ],
                [
                    97.7685144,
                    57.1794126
                ],
                [
                    97.7778052,
                    57.1784529
                ],
                [
                    97.7791454,
                    57.1765317
                ],
                [
                    97.7781665,
                    57.1734647
                ],
                [
                    97.7744411,
                    57.1735932
                ],
                [
                    97.7705464,
                    57.1720694
                ],
                [
                    97.7525291,
                    57.1724366
                ],
                [
                    97.7467379,
                    57.175374
                ]
            ],
            "longitude": 97.763092,
            "latitude": 57.17701
        },
        "3775": {
            "name": "Сергина",
            "population": 610,
            "type": "village",
            "poly": null,
            "longitude": 97.807602,
            "latitude": 55.666451
        },
        "3776": {
            "name": "Соляная",
            "population": 894,
            "type": "village",
            "poly": null,
            "longitude": 97.81839,
            "latitude": 55.53397
        },
        "3777": {
            "name": "Пея",
            "population": 241,
            "type": "village",
            "poly": null,
            "longitude": 97.836357,
            "latitude": 56.897892
        },
        "3778": {
            "name": "Черчет",
            "population": 341,
            "type": "village",
            "poly": null,
            "longitude": 97.859726,
            "latitude": 56.724964
        },
        "3779": {
            "name": "Бирюса",
            "population": 561,
            "type": "village",
            "poly": [
                [
                    97.8862544,
                    55.9821611
                ],
                [
                    97.886287,
                    55.9832388
                ],
                [
                    97.887136,
                    55.9850105
                ],
                [
                    97.8877563,
                    55.9857411
                ],
                [
                    97.8878706,
                    55.9870288
                ],
                [
                    97.8875408,
                    55.9887632
                ],
                [
                    97.8878869,
                    55.9902157
                ],
                [
                    97.8889154,
                    55.9938544
                ],
                [
                    97.8894052,
                    55.9949911
                ],
                [
                    97.8879196,
                    55.9988348
                ],
                [
                    97.8866952,
                    56.0001494
                ],
                [
                    97.8870707,
                    56.0020664
                ],
                [
                    97.8879196,
                    56.0023311
                ],
                [
                    97.8884257,
                    56.0032896
                ],
                [
                    97.8914418,
                    56.00119
                ],
                [
                    97.8933845,
                    55.9957946
                ],
                [
                    97.8930873,
                    55.9945346
                ],
                [
                    97.8947115,
                    55.9946396
                ],
                [
                    97.8950626,
                    55.9939411
                ],
                [
                    97.8965402,
                    55.9940186
                ],
                [
                    97.8979255,
                    55.9933601
                ],
                [
                    97.8994261,
                    55.9943931
                ],
                [
                    97.90095,
                    55.9955035
                ],
                [
                    97.9034896,
                    55.9949612
                ],
                [
                    97.9032125,
                    55.9943285
                ],
                [
                    97.9022429,
                    55.9945738
                ],
                [
                    97.9001419,
                    55.9919655
                ],
                [
                    97.8995878,
                    55.9912294
                ],
                [
                    97.8965864,
                    55.9905192
                ],
                [
                    97.8955706,
                    55.9887758
                ],
                [
                    97.8951319,
                    55.9868645
                ],
                [
                    97.8955937,
                    55.9867612
                ],
                [
                    97.89594,
                    55.9863221
                ],
                [
                    97.8930078,
                    55.9861283
                ],
                [
                    97.8928923,
                    55.9855601
                ],
                [
                    97.8943238,
                    55.9853276
                ],
                [
                    97.894093,
                    55.9845656
                ],
                [
                    97.8923383,
                    55.9845139
                ],
                [
                    97.8915072,
                    55.9826669
                ],
                [
                    97.8914379,
                    55.9818403
                ],
                [
                    97.889106,
                    55.9814916
                ],
                [
                    97.8876977,
                    55.9814528
                ],
                [
                    97.8866819,
                    55.9817757
                ],
                [
                    97.8862544,
                    55.9821611
                ]
            ],
            "longitude": 97.891251,
            "latitude": 55.989468
        },
        "3780": {
            "name": "Березовка",
            "population": 777,
            "type": "village",
            "poly": null,
            "longitude": 98.027908,
            "latitude": 55.862331
        },
        "3781": {
            "name": "Тремина",
            "population": 423,
            "type": "village",
            "poly": null,
            "longitude": 98.056694,
            "latitude": 56.720852
        },
        "3782": {
            "name": "Старый Акульшет",
            "population": 843,
            "type": "village",
            "poly": null,
            "longitude": 98.069771,
            "latitude": 56.015911
        },
        "3783": {
            "name": "Полинчет",
            "population": 331,
            "type": "village",
            "poly": [
                [
                    98.0961476,
                    57.3528323
                ],
                [
                    98.0963486,
                    57.3534585
                ],
                [
                    98.0992993,
                    57.3534148
                ],
                [
                    98.1035838,
                    57.3520193
                ],
                [
                    98.1054558,
                    57.3511645
                ],
                [
                    98.1103742,
                    57.3477889
                ],
                [
                    98.1138099,
                    57.3467639
                ],
                [
                    98.1157096,
                    57.3464149
                ],
                [
                    98.1225809,
                    57.3464149
                ],
                [
                    98.1270684,
                    57.3474025
                ],
                [
                    98.1256133,
                    57.3434987
                ],
                [
                    98.1187016,
                    57.3426917
                ],
                [
                    98.1159935,
                    57.3429752
                ],
                [
                    98.1138512,
                    57.3412521
                ],
                [
                    98.1114665,
                    57.3415575
                ],
                [
                    98.1077075,
                    57.3436077
                ],
                [
                    98.1081926,
                    57.3452653
                ],
                [
                    98.0991386,
                    57.3483184
                ],
                [
                    98.0996641,
                    57.3514804
                ],
                [
                    98.0961476,
                    57.3528323
                ]
            ],
            "longitude": 98.109406,
            "latitude": 57.346577
        },
        "3784": {
            "name": "Джогино",
            "population": 608,
            "type": "village",
            "poly": null,
            "longitude": 98.162132,
            "latitude": 56.647503
        },
        "3785": {
            "name": "Николаевка",
            "population": 1063,
            "type": "village",
            "poly": null,
            "longitude": 98.179672,
            "latitude": 55.792164
        },
        "3786": {
            "name": "Еланка",
            "population": 10,
            "type": "village",
            "poly": null,
            "longitude": 98.206055,
            "latitude": 55.411625
        },
        "3787": {
            "name": "Алыгджер",
            "population": 508,
            "type": "village",
            "poly": null,
            "longitude": 98.216751,
            "latitude": 53.638992
        },
        "3788": {
            "name": "Нижняя Заимка",
            "population": 373,
            "type": "village",
            "poly": null,
            "longitude": 98.230812,
            "latitude": 56.144611
        },
        "3789": {
            "name": "Нерха",
            "population": 220,
            "type": "village",
            "poly": null,
            "longitude": 98.272202,
            "latitude": 53.849503
        },
        "3790": {
            "name": "Борисово",
            "population": 246,
            "type": "village",
            "poly": null,
            "longitude": 98.295174,
            "latitude": 56.163815
        },
        "3791": {
            "name": "Шиткино",
            "population": 1850,
            "type": "village",
            "poly": null,
            "longitude": 98.351799,
            "latitude": 56.370895
        },
        "3792": {
            "name": "Бузыканово",
            "population": 346,
            "type": "village",
            "poly": null,
            "longitude": 98.38266,
            "latitude": 56.575027
        },
        "3793": {
            "name": "Разгон",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 98.3882542,
            "latitude": 55.7164029
        },
        "3794": {
            "name": "Пуляева",
            "population": 532,
            "type": "village",
            "poly": null,
            "longitude": 98.411445,
            "latitude": 56.1672518
        },
        "3795": {
            "name": "Квиток",
            "population": 2768,
            "type": "village",
            "poly": [
                [
                    98.4503929,
                    56.0728311
                ],
                [
                    98.4510796,
                    56.074843
                ],
                [
                    98.4551994,
                    56.0765675
                ],
                [
                    98.4605209,
                    56.0786751
                ],
                [
                    98.4622375,
                    56.0811657
                ],
                [
                    98.4615509,
                    56.0828899
                ],
                [
                    98.469619,
                    56.0835604
                ],
                [
                    98.4824936,
                    56.0859549
                ],
                [
                    98.4867851,
                    56.0828899
                ],
                [
                    98.4907333,
                    56.0774297
                ],
                [
                    98.4915916,
                    56.0728311
                ],
                [
                    98.4917633,
                    56.068136
                ],
                [
                    98.4938232,
                    56.0628654
                ],
                [
                    98.4886734,
                    56.0597027
                ],
                [
                    98.4806052,
                    56.0581692
                ],
                [
                    98.479232,
                    56.0560605
                ],
                [
                    98.4718506,
                    56.0597027
                ],
                [
                    98.4697906,
                    56.0649738
                ],
                [
                    98.4721938,
                    56.067082
                ],
                [
                    98.4728805,
                    56.0689026
                ],
                [
                    98.4718506,
                    56.0735975
                ],
                [
                    98.4620659,
                    56.0720646
                ],
                [
                    98.4603493,
                    56.0704357
                ],
                [
                    98.457431,
                    56.0700524
                ],
                [
                    98.4522812,
                    56.0707232
                ],
                [
                    98.4503929,
                    56.0728311
                ]
            ],
            "longitude": 98.4766571,
            "latitude": 56.0757053
        },
        "3796": {
            "name": "Невельская",
            "population": 527,
            "type": "village",
            "poly": null,
            "longitude": 98.5353653,
            "latitude": 56.1186971
        },
        "3797": {
            "name": "Брусово",
            "population": 0,
            "type": "village",
            "poly": null,
            "longitude": 98.54277,
            "latitude": 57.206364
        },
        "3798": {
            "name": "Старый Алзамай",
            "population": 271,
            "type": "village",
            "poly": null,
            "longitude": 98.607155,
            "latitude": 55.592758
        },
        "3799": {
            "name": "Первомайский",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 98.607964,
            "latitude": 55.4478
        },
        "3800": {
            "name": "Замзор",
            "population": 1118,
            "type": "village",
            "poly": null,
            "longitude": 98.649635,
            "latitude": 55.37077
        },
        "3801": {
            "name": "Екунчет",
            "population": 47,
            "type": "village",
            "poly": null,
            "longitude": 98.65696,
            "latitude": 57.077816
        },
        "3802": {
            "name": "Камышет",
            "population": 595,
            "type": "village",
            "poly": null,
            "longitude": 98.79557,
            "latitude": 55.2057
        },
        "3803": {
            "name": "Каменка",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 98.829536,
            "latitude": 54.931534
        },
        "3804": {
            "name": "Ук",
            "population": 1667,
            "type": "village",
            "poly": null,
            "longitude": 98.8598725,
            "latitude": 55.0796891
        },
        "3805": {
            "name": "Куряты",
            "population": 524,
            "type": "village",
            "poly": null,
            "longitude": 98.943245,
            "latitude": 54.93972
        },
        "3806": {
            "name": "Подгорный",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 98.993065,
            "latitude": 54.855701
        },
        "3807": {
            "name": "Бунбуй",
            "population": 405,
            "type": "village",
            "poly": null,
            "longitude": 99.022583,
            "latitude": 56.39061
        },
        "3808": {
            "name": "Парчум",
            "population": 725,
            "type": "village",
            "poly": null,
            "longitude": 99.031776,
            "latitude": 56.167034
        },
        "3809": {
            "name": "Мельница",
            "population": 1420,
            "type": "village",
            "poly": null,
            "longitude": 99.078537,
            "latitude": 54.846825
        },
        "3810": {
            "name": "Рубахина",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 99.087715,
            "latitude": 54.870121
        },
        "3811": {
            "name": "Вознесенский",
            "population": 650,
            "type": "village",
            "poly": null,
            "longitude": 99.104095,
            "latitude": 54.897758
        },
        "3812": {
            "name": "Катарма",
            "population": 43,
            "type": "village",
            "poly": null,
            "longitude": 99.1052688,
            "latitude": 55.6666398
        },
        "3813": {
            "name": "Каменск",
            "population": 671,
            "type": "village",
            "poly": null,
            "longitude": 99.117363,
            "latitude": 56.17572
        },
        "3814": {
            "name": "Шумский",
            "population": 2624,
            "type": "village",
            "poly": null,
            "longitude": 99.131134,
            "latitude": 54.831242
        },
        "3815": {
            "name": "Заводской",
            "population": 270,
            "type": "village",
            "poly": null,
            "longitude": 99.1790124,
            "latitude": 56.1550689
        },
        "3816": {
            "name": "Солонцы",
            "population": 316,
            "type": "village",
            "poly": null,
            "longitude": 99.190849,
            "latitude": 54.66901
        },
        "3817": {
            "name": "Новобалтурина",
            "population": 432,
            "type": "village",
            "poly": null,
            "longitude": 99.206848,
            "latitude": 56.181107
        },
        "3818": {
            "name": "Порог",
            "population": 552,
            "type": "village",
            "poly": null,
            "longitude": 99.251122,
            "latitude": 54.555862
        },
        "3819": {
            "name": "Новочунка",
            "population": 1797,
            "type": "village",
            "poly": [
                [
                    99.2395867,
                    56.1235355
                ],
                [
                    99.2627383,
                    56.1249335
                ],
                [
                    99.2621595,
                    56.1225676
                ],
                [
                    99.3070326,
                    56.102974
                ],
                [
                    99.3059545,
                    56.1020216
                ],
                [
                    99.2974656,
                    56.0968564
                ],
                [
                    99.2855039,
                    56.1035279
                ],
                [
                    99.2793302,
                    56.0999771
                ],
                [
                    99.2702625,
                    56.1040659
                ],
                [
                    99.2617736,
                    56.1075088
                ],
                [
                    99.2583009,
                    56.1099831
                ],
                [
                    99.2631241,
                    56.1123498
                ],
                [
                    99.2621595,
                    56.1146087
                ],
                [
                    99.2586868,
                    56.1174053
                ],
                [
                    99.2555999,
                    56.1177279
                ],
                [
                    99.2528989,
                    56.1186959
                ],
                [
                    99.2457605,
                    56.1182657
                ],
                [
                    99.2395867,
                    56.1235355
                ]
            ],
            "longitude": 99.271118,
            "latitude": 56.11293
        },
        "3820": {
            "name": "Пионерский",
            "population": 409,
            "type": "village",
            "poly": null,
            "longitude": 99.3559594,
            "latitude": 56.0916508
        },
        "3821": {
            "name": "Хоняки",
            "population": 309,
            "type": "village",
            "poly": null,
            "longitude": 99.366508,
            "latitude": 56.067703
        },
        "3822": {
            "name": "Чехово",
            "population": 199,
            "type": "village",
            "poly": null,
            "longitude": 99.382545,
            "latitude": 54.470417
        },
        "3823": {
            "name": "Атагай",
            "population": 1625,
            "type": "village",
            "poly": null,
            "longitude": 99.388611,
            "latitude": 55.101635
        },
        "3824": {
            "name": "Широково",
            "population": 266,
            "type": "village",
            "poly": null,
            "longitude": 99.396248,
            "latitude": 55.433296
        },
        "3825": {
            "name": "Заречье",
            "population": 366,
            "type": "village",
            "poly": null,
            "longitude": 99.407772,
            "latitude": 55.5323281
        },
        "3826": {
            "name": "Бидога",
            "population": 453,
            "type": "village",
            "poly": null,
            "longitude": 99.452141,
            "latitude": 56.053963
        },
        "3827": {
            "name": "Мухино",
            "population": 156,
            "type": "village",
            "poly": null,
            "longitude": 99.501274,
            "latitude": 55.820286
        },
        "3828": {
            "name": "Костино",
            "population": 1020,
            "type": "village",
            "poly": null,
            "longitude": 99.52066,
            "latitude": 55.616886
        },
        "3829": {
            "name": "Червянка",
            "population": 261,
            "type": "village",
            "poly": null,
            "longitude": 99.546501,
            "latitude": 57.656265
        },
        "3830": {
            "name": "Паренда",
            "population": 354,
            "type": "village",
            "poly": null,
            "longitude": 99.576599,
            "latitude": 55.927601
        },
        "3831": {
            "name": "Весёлый",
            "population": 1438,
            "type": "village",
            "poly": null,
            "longitude": 99.589111,
            "latitude": 55.934856
        },
        "3832": {
            "name": "Худоеланское",
            "population": 1880,
            "type": "village",
            "poly": null,
            "longitude": 99.640022,
            "latitude": 54.703819
        },
        "3833": {
            "name": "Катарбей",
            "population": 456,
            "type": "village",
            "poly": null,
            "longitude": 99.68351,
            "latitude": 54.368462
        },
        "3834": {
            "name": "Ишидей",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 99.717751,
            "latitude": 54.121017
        },
        "3835": {
            "name": "Изыкан",
            "population": 586,
            "type": "village",
            "poly": [
                [
                    99.7544263,
                    56.1272566
                ],
                [
                    99.7561429,
                    56.1273522
                ],
                [
                    99.7576878,
                    56.1284047
                ],
                [
                    99.7585461,
                    56.1295527
                ],
                [
                    99.7604344,
                    56.1303181
                ],
                [
                    99.7624944,
                    56.1307964
                ],
                [
                    99.7650692,
                    56.1303181
                ],
                [
                    99.7671292,
                    56.1303181
                ],
                [
                    99.7686742,
                    56.1308921
                ],
                [
                    99.7719357,
                    56.1314661
                ],
                [
                    99.7739957,
                    56.1314661
                ],
                [
                    99.7757123,
                    56.1314661
                ],
                [
                    99.7772571,
                    56.1316574
                ],
                [
                    99.7793172,
                    56.1324227
                ],
                [
                    99.7805188,
                    56.1332836
                ],
                [
                    99.7824071,
                    56.132327
                ],
                [
                    99.784982,
                    56.131753
                ],
                [
                    99.7879002,
                    56.1313704
                ],
                [
                    99.7880719,
                    56.1303181
                ],
                [
                    99.7866985,
                    56.129457
                ],
                [
                    99.7836087,
                    56.128596
                ],
                [
                    99.7813771,
                    56.1277349
                ],
                [
                    99.7789738,
                    56.1270652
                ],
                [
                    99.7769139,
                    56.1263955
                ],
                [
                    99.774854,
                    56.1257257
                ],
                [
                    99.7765706,
                    56.1240991
                ],
                [
                    99.7770856,
                    56.1228552
                ],
                [
                    99.7781155,
                    56.1216113
                ],
                [
                    99.7770856,
                    56.1210372
                ],
                [
                    99.7746823,
                    56.1205587
                ],
                [
                    99.772794,
                    56.1212285
                ],
                [
                    99.7717641,
                    56.1224725
                ],
                [
                    99.7717641,
                    56.1240991
                ],
                [
                    99.7710774,
                    56.1248646
                ],
                [
                    99.7690175,
                    56.1246732
                ],
                [
                    99.7664426,
                    56.1249603
                ],
                [
                    99.7650692,
                    56.1249603
                ],
                [
                    99.7624944,
                    56.1258214
                ],
                [
                    99.7600911,
                    56.1259171
                ],
                [
                    99.7564862,
                    56.1262041
                ],
                [
                    99.7545978,
                    56.1262998
                ],
                [
                    99.7544263,
                    56.1272566
                ]
            ],
            "longitude": 99.769447,
            "latitude": 56.127575
        },
        "3836": {
            "name": "Вершина",
            "population": 553,
            "type": "village",
            "poly": null,
            "longitude": 99.816895,
            "latitude": 54.628647
        },
        "3837": {
            "name": "Шеберта",
            "population": 338,
            "type": "village",
            "poly": null,
            "longitude": 99.848778,
            "latitude": 54.622334
        },
        "3838": {
            "name": "Шеберта",
            "population": 623,
            "type": "village",
            "poly": [
                [
                    99.8663489,
                    54.6516529
                ],
                [
                    99.8694388,
                    54.6566183
                ],
                [
                    99.8721854,
                    54.6567176
                ],
                [
                    99.8776785,
                    54.6536391
                ],
                [
                    99.8833434,
                    54.6524474
                ],
                [
                    99.8869483,
                    54.6493686
                ],
                [
                    99.8871199,
                    54.6480774
                ],
                [
                    99.8879782,
                    54.6478788
                ],
                [
                    99.8910681,
                    54.6494679
                ],
                [
                    99.8927847,
                    54.648276
                ],
                [
                    99.895188,
                    54.6470842
                ],
                [
                    99.8982779,
                    54.6479781
                ],
                [
                    99.9018828,
                    54.6479781
                ],
                [
                    99.9034277,
                    54.6467862
                ],
                [
                    99.9030844,
                    54.6455943
                ],
                [
                    99.9013678,
                    54.6451969
                ],
                [
                    99.896218,
                    54.6445016
                ],
                [
                    99.8927847,
                    54.6427136
                ],
                [
                    99.8883215,
                    54.6394354
                ],
                [
                    99.8842017,
                    54.6407269
                ],
                [
                    99.8795668,
                    54.6373491
                ],
                [
                    99.8730437,
                    54.6357595
                ],
                [
                    99.8708121,
                    54.6370511
                ],
                [
                    99.8757903,
                    54.6403295
                ],
                [
                    99.8783652,
                    54.643111
                ],
                [
                    99.8759618,
                    54.6452963
                ],
                [
                    99.8711554,
                    54.6478788
                ],
                [
                    99.8663489,
                    54.6516529
                ]
            ],
            "longitude": 99.88401,
            "latitude": 54.64365
        },
        "3839": {
            "name": "Даур",
            "population": 346,
            "type": "village",
            "poly": null,
            "longitude": 99.890221,
            "latitude": 54.753757
        },
        "3840": {
            "name": "Аршан",
            "population": 289,
            "type": "village",
            "poly": null,
            "longitude": 99.91507,
            "latitude": 53.931004
        },
        "3841": {
            "name": "Таргиз",
            "population": 470,
            "type": "village",
            "poly": [
                [
                    99.947202,
                    56.1645519
                ],
                [
                    99.947202,
                    56.1659856
                ],
                [
                    99.9473737,
                    56.1675149
                ],
                [
                    99.9473737,
                    56.1685662
                ],
                [
                    99.9489186,
                    56.1700953
                ],
                [
                    99.9509785,
                    56.170382
                ],
                [
                    99.9514935,
                    56.1713377
                ],
                [
                    99.9497769,
                    56.1719111
                ],
                [
                    99.9492619,
                    56.1728667
                ],
                [
                    99.9525235,
                    56.1737268
                ],
                [
                    99.9550984,
                    56.1738223
                ],
                [
                    99.9575017,
                    56.1743957
                ],
                [
                    99.9587033,
                    56.1751601
                ],
                [
                    99.9607632,
                    56.1756379
                ],
                [
                    99.9623082,
                    56.1754468
                ],
                [
                    99.9636815,
                    56.1762112
                ],
                [
                    99.9647115,
                    56.1769757
                ],
                [
                    99.9667714,
                    56.1769757
                ],
                [
                    99.9683163,
                    56.1762112
                ],
                [
                    99.9683163,
                    56.1751601
                ],
                [
                    99.9683163,
                    56.1738223
                ],
                [
                    99.9667714,
                    56.1727711
                ],
                [
                    99.9645398,
                    56.1728667
                ],
                [
                    99.9635098,
                    56.1718155
                ],
                [
                    99.9638531,
                    56.1708599
                ],
                [
                    99.9660847,
                    56.1704776
                ],
                [
                    99.9686597,
                    56.1698086
                ],
                [
                    99.9688313,
                    56.1689485
                ],
                [
                    99.9672864,
                    56.1679927
                ],
                [
                    99.9662564,
                    56.1671326
                ],
                [
                    99.9669431,
                    56.1664635
                ],
                [
                    99.9676297,
                    56.1653166
                ],
                [
                    99.9693463,
                    56.1642652
                ],
                [
                    99.9710629,
                    56.164074
                ],
                [
                    99.9731229,
                    56.1628314
                ],
                [
                    99.9720929,
                    56.1619711
                ],
                [
                    99.9707196,
                    56.1618755
                ],
                [
                    99.9686597,
                    56.1627358
                ],
                [
                    99.9669431,
                    56.162927
                ],
                [
                    99.9648831,
                    56.1626402
                ],
                [
                    99.9633382,
                    56.162449
                ],
                [
                    99.9619649,
                    56.1630226
                ],
                [
                    99.9600765,
                    56.1628314
                ],
                [
                    99.9590465,
                    56.1620667
                ],
                [
                    99.9571584,
                    56.1619711
                ],
                [
                    99.9535535,
                    56.1619711
                ],
                [
                    99.9509785,
                    56.1622579
                ],
                [
                    99.9484036,
                    56.162927
                ],
                [
                    99.947202,
                    56.1645519
                ]
            ],
            "longitude": 99.957504,
            "latitude": 56.168278
        },
        "3842": {
            "name": "Нижний Бурбук",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 99.980865,
            "latitude": 54.258102
        },
        "3843": {
            "name": "Иргей",
            "population": 282,
            "type": "village",
            "poly": null,
            "longitude": 99.995773,
            "latitude": 54.558327
        },
        "3844": {
            "name": "Икей",
            "population": 1207,
            "type": "village",
            "poly": null,
            "longitude": 100.078819,
            "latitude": 54.191528
        },
        "3845": {
            "name": "Изегол",
            "population": 297,
            "type": "village",
            "poly": null,
            "longitude": 100.122345,
            "latitude": 54.310204
        },
        "3846": {
            "name": "Будагово",
            "population": 1276,
            "type": "village",
            "poly": [
                [
                    100.1164595,
                    54.6336731
                ],
                [
                    100.1166312,
                    54.6362563
                ],
                [
                    100.1291625,
                    54.6306922
                ],
                [
                    100.134484,
                    54.6277111
                ],
                [
                    100.1411788,
                    54.6267174
                ],
                [
                    100.1415221,
                    54.6225434
                ],
                [
                    100.1391188,
                    54.6196612
                ],
                [
                    100.1422087,
                    54.6174745
                ],
                [
                    100.1348273,
                    54.6159835
                ],
                [
                    100.1276175,
                    54.6195618
                ],
                [
                    100.1245275,
                    54.6208539
                ],
                [
                    100.1240126,
                    54.6221459
                ],
                [
                    100.121781,
                    54.6251274
                ],
                [
                    100.1221243,
                    54.626618
                ],
                [
                    100.1192061,
                    54.6293011
                ],
                [
                    100.1171461,
                    54.6306922
                ],
                [
                    100.1164595,
                    54.6336731
                ]
            ],
            "longitude": 100.131393,
            "latitude": 54.626862
        },
        "3847": {
            "name": "Алгатуй",
            "population": 1259,
            "type": "village",
            "poly": null,
            "longitude": 100.195076,
            "latitude": 54.394363
        },
        "3848": {
            "name": "Умыган",
            "population": 633,
            "type": "village",
            "poly": null,
            "longitude": 100.226196,
            "latitude": 54.752075
        },
        "3849": {
            "name": "Едогон",
            "population": 756,
            "type": "village",
            "poly": null,
            "longitude": 100.237511,
            "latitude": 54.253338
        },
        "3850": {
            "name": "Сосновка",
            "population": 629,
            "type": "village",
            "poly": [
                [
                    100.223405,
                    56.120463
                ],
                [
                    100.223405,
                    56.1215156
                ],
                [
                    100.2242635,
                    56.1228552
                ],
                [
                    100.226495,
                    56.1236207
                ],
                [
                    100.2263234,
                    56.1247689
                ],
                [
                    100.2268384,
                    56.1258214
                ],
                [
                    100.229585,
                    56.1254387
                ],
                [
                    100.2318166,
                    56.1252473
                ],
                [
                    100.2331898,
                    56.1259171
                ],
                [
                    100.2354214,
                    56.1269695
                ],
                [
                    100.2374813,
                    56.1279263
                ],
                [
                    100.239713,
                    56.1287873
                ],
                [
                    100.2414296,
                    56.1287873
                ],
                [
                    100.2422878,
                    56.1301267
                ],
                [
                    100.2390263,
                    56.1309877
                ],
                [
                    100.2371381,
                    56.1313704
                ],
                [
                    100.2357648,
                    56.132614
                ],
                [
                    100.2357648,
                    56.1336663
                ],
                [
                    100.2366231,
                    56.1349098
                ],
                [
                    100.2393697,
                    56.1348142
                ],
                [
                    100.2441762,
                    56.1333793
                ],
                [
                    100.2452061,
                    56.1338576
                ],
                [
                    100.2419446,
                    56.1353881
                ],
                [
                    100.238683,
                    56.136249
                ],
                [
                    100.2366231,
                    56.1370142
                ],
                [
                    100.2369664,
                    56.1380664
                ],
                [
                    100.237653,
                    56.1392141
                ],
                [
                    100.2400563,
                    56.1392141
                ],
                [
                    100.2417729,
                    56.1401706
                ],
                [
                    100.2431462,
                    56.1410314
                ],
                [
                    100.2457211,
                    56.1401706
                ],
                [
                    100.2481244,
                    56.1395011
                ],
                [
                    100.2489827,
                    56.1387359
                ],
                [
                    100.2479527,
                    56.1376838
                ],
                [
                    100.2462361,
                    56.1372055
                ],
                [
                    100.2494977,
                    56.136249
                ],
                [
                    100.2527592,
                    56.1353881
                ],
                [
                    100.2577374,
                    56.1342402
                ],
                [
                    100.2556775,
                    56.133475
                ],
                [
                    100.2536176,
                    56.132614
                ],
                [
                    100.251386,
                    56.1319444
                ],
                [
                    100.2511938,
                    56.131848
                ],
                [
                    100.2496692,
                    56.1310834
                ],
                [
                    100.2479527,
                    56.1305094
                ],
                [
                    100.2465794,
                    56.12917
                ],
                [
                    100.2450345,
                    56.1279263
                ],
                [
                    100.2434895,
                    56.1267782
                ],
                [
                    100.2417729,
                    56.1258214
                ],
                [
                    100.239713,
                    56.1242905
                ],
                [
                    100.237653,
                    56.1231423
                ],
                [
                    100.2355931,
                    56.1223768
                ],
                [
                    100.2338764,
                    56.1221854
                ],
                [
                    100.2319882,
                    56.121707
                ],
                [
                    100.2299283,
                    56.1206544
                ],
                [
                    100.2283833,
                    56.1203673
                ],
                [
                    100.2256367,
                    56.1199845
                ],
                [
                    100.223405,
                    56.120463
                ]
            ],
            "longitude": 100.24057,
            "latitude": 56.126873
        },
        "3851": {
            "name": "Мугун",
            "population": 828,
            "type": "village",
            "poly": null,
            "longitude": 100.249489,
            "latitude": 54.471943
        },
        "3852": {
            "name": "Владимировка",
            "population": 605,
            "type": "village",
            "poly": [
                [
                    100.2850791,
                    54.1771137
                ],
                [
                    100.2870532,
                    54.1807305
                ],
                [
                    100.2928039,
                    54.1801277
                ],
                [
                    100.2970954,
                    54.1798766
                ],
                [
                    100.3018161,
                    54.1798766
                ],
                [
                    100.3087684,
                    54.1784701
                ],
                [
                    100.3166648,
                    54.1761593
                ],
                [
                    100.3218147,
                    54.1747024
                ],
                [
                    100.3268787,
                    54.1729943
                ],
                [
                    100.3268787,
                    54.1712861
                ],
                [
                    100.3200122,
                    54.1703314
                ],
                [
                    100.3148624,
                    54.1696783
                ],
                [
                    100.3090259,
                    54.1695778
                ],
                [
                    100.3029319,
                    54.1714368
                ],
                [
                    100.2988979,
                    54.1735469
                ],
                [
                    100.2850791,
                    54.1771137
                ]
            ],
            "longitude": 100.3069,
            "latitude": 54.174667
        },
        "3853": {
            "name": "Утай",
            "population": 486,
            "type": "village",
            "poly": null,
            "longitude": 100.317459,
            "latitude": 54.637779
        },
        "3854": {
            "name": "Булюшкина",
            "population": 429,
            "type": "village",
            "poly": [
                [
                    100.3871695,
                    54.5818746
                ],
                [
                    100.3892294,
                    54.5839637
                ],
                [
                    100.3895728,
                    54.5907278
                ],
                [
                    100.4045073,
                    54.5928164
                ],
                [
                    100.4033057,
                    54.5847596
                ],
                [
                    100.4110304,
                    54.5813772
                ],
                [
                    100.4038207,
                    54.5803823
                ],
                [
                    100.3988425,
                    54.5790889
                ],
                [
                    100.390946,
                    54.5803823
                ],
                [
                    100.3871695,
                    54.5818746
                ]
            ],
            "longitude": 100.399368,
            "latitude": 54.582111
        },
        "3855": {
            "name": "Красная Дубрава",
            "population": 87,
            "type": "village",
            "poly": null,
            "longitude": 100.409599,
            "latitude": 54.666004
        },
        "3856": {
            "name": "Котик",
            "population": 1115,
            "type": "village",
            "poly": null,
            "longitude": 100.45549,
            "latitude": 54.649178
        },
        "3857": {
            "name": "Перфилово",
            "population": 550,
            "type": "village",
            "poly": null,
            "longitude": 100.485413,
            "latitude": 54.408112
        },
        "3858": {
            "name": "Сибиряк",
            "population": 622,
            "type": "village",
            "poly": null,
            "longitude": 100.509789,
            "latitude": 54.721199
        },
        "3859": {
            "name": "Нижний Манут",
            "population": 405,
            "type": "village",
            "poly": null,
            "longitude": 100.527519,
            "latitude": 54.466053
        },
        "3860": {
            "name": "Усть-Кульск",
            "population": 308,
            "type": "village",
            "poly": null,
            "longitude": 100.572281,
            "latitude": 54.881248
        },
        "3861": {
            "name": "Кардой",
            "population": 363,
            "type": "village",
            "poly": null,
            "longitude": 100.581085,
            "latitude": 55.212307
        },
        "3862": {
            "name": "Уйгат",
            "population": 439,
            "type": "village",
            "poly": null,
            "longitude": 100.592644,
            "latitude": 54.081966
        },
        "3863": {
            "name": "Бадар",
            "population": 612,
            "type": "village",
            "poly": null,
            "longitude": 100.600601,
            "latitude": 54.396923
        },
        "3864": {
            "name": "Афанасьева",
            "population": 475,
            "type": "village",
            "poly": null,
            "longitude": 100.61718,
            "latitude": 54.639477
        },
        "3865": {
            "name": "Целинные Земли",
            "population": 549,
            "type": "village",
            "poly": null,
            "longitude": 100.62854,
            "latitude": 54.69915
        },
        "3866": {
            "name": "Гуран",
            "population": 1062,
            "type": "village",
            "poly": [
                [
                    100.6206954,
                    54.7668024
                ],
                [
                    100.623559,
                    54.7694644
                ],
                [
                    100.630566,
                    54.7690306
                ],
                [
                    100.6381191,
                    54.76705
                ],
                [
                    100.6426681,
                    54.7660101
                ],
                [
                    100.6470454,
                    54.7690306
                ],
                [
                    100.652367,
                    54.7683374
                ],
                [
                    100.6526243,
                    54.764376
                ],
                [
                    100.6551135,
                    54.7616029
                ],
                [
                    100.6565727,
                    54.7590276
                ],
                [
                    100.655886,
                    54.7558578
                ],
                [
                    100.6532253,
                    54.753728
                ],
                [
                    100.6437839,
                    54.7538766
                ],
                [
                    100.639149,
                    54.7542233
                ],
                [
                    100.636145,
                    54.756997
                ],
                [
                    100.6346858,
                    54.7585323
                ],
                [
                    100.6279052,
                    54.7606124
                ],
                [
                    100.6230987,
                    54.7634847
                ],
                [
                    100.6206954,
                    54.7668024
                ]
            ],
            "longitude": 100.64447,
            "latitude": 54.760704
        },
        "3867": {
            "name": "Ермаки",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 100.655853,
            "latitude": 54.636894
        },
        "3868": {
            "name": "Евдокимова",
            "population": 485,
            "type": "village",
            "poly": null,
            "longitude": 100.656883,
            "latitude": 54.275639
        },
        "3869": {
            "name": "Илир",
            "population": 1160,
            "type": "village",
            "poly": null,
            "longitude": 100.679825,
            "latitude": 55.223484
        },
        "3870": {
            "name": "Прибрежный",
            "population": 2557,
            "type": "village",
            "poly": [
                [
                    100.6655593,
                    55.205185
                ],
                [
                    100.6667609,
                    55.2057727
                ],
                [
                    100.6684776,
                    55.2041074
                ],
                [
                    100.6696792,
                    55.202736
                ],
                [
                    100.6700225,
                    55.2037156
                ],
                [
                    100.6700225,
                    55.2052829
                ],
                [
                    100.6722541,
                    55.2045972
                ],
                [
                    100.6731123,
                    55.205185
                ],
                [
                    100.6731123,
                    55.2060666
                ],
                [
                    100.6689926,
                    55.2069481
                ],
                [
                    100.667276,
                    55.207144
                ],
                [
                    100.6677909,
                    55.2079277
                ],
                [
                    100.6698509,
                    55.2079277
                ],
                [
                    100.6712242,
                    55.2087112
                ],
                [
                    100.6737991,
                    55.2087112
                ],
                [
                    100.6762023,
                    55.209201
                ],
                [
                    100.677919,
                    55.209201
                ],
                [
                    100.6798072,
                    55.2095928
                ],
                [
                    100.6798072,
                    55.2101804
                ],
                [
                    100.6808372,
                    55.2107681
                ],
                [
                    100.6815239,
                    55.2113558
                ],
                [
                    100.6827255,
                    55.2115516
                ],
                [
                    100.6849571,
                    55.2113558
                ],
                [
                    100.686502,
                    55.2113558
                ],
                [
                    100.688047,
                    55.2114537
                ],
                [
                    100.6887336,
                    55.210964
                ],
                [
                    100.6901069,
                    55.2107681
                ],
                [
                    100.6914802,
                    55.2104743
                ],
                [
                    100.6926818,
                    55.2102784
                ],
                [
                    100.6940551,
                    55.2107681
                ],
                [
                    100.6954284,
                    55.2110619
                ],
                [
                    100.69663,
                    55.2118455
                ],
                [
                    100.6985183,
                    55.2120413
                ],
                [
                    100.6998916,
                    55.2117475
                ],
                [
                    100.7009216,
                    55.2115516
                ],
                [
                    100.7028099,
                    55.2106702
                ],
                [
                    100.7045265,
                    55.2102784
                ],
                [
                    100.7016082,
                    55.2119434
                ],
                [
                    100.7010933,
                    55.2130207
                ],
                [
                    100.7029815,
                    55.2137063
                ],
                [
                    100.7048698,
                    55.2145877
                ],
                [
                    100.7065864,
                    55.2152732
                ],
                [
                    100.7076164,
                    55.215665
                ],
                [
                    100.7086464,
                    55.2159587
                ],
                [
                    100.7098479,
                    55.2171339
                ],
                [
                    100.7112213,
                    55.2173297
                ],
                [
                    100.7127662,
                    55.2172318
                ],
                [
                    100.7139679,
                    55.2177214
                ],
                [
                    100.7153411,
                    55.2182111
                ],
                [
                    100.7167144,
                    55.2181131
                ],
                [
                    100.7172293,
                    55.2189945
                ],
                [
                    100.7191177,
                    55.2190924
                ],
                [
                    100.7206626,
                    55.218309
                ],
                [
                    100.7201477,
                    55.2168401
                ],
                [
                    100.7187744,
                    55.215665
                ],
                [
                    100.7182593,
                    55.2143918
                ],
                [
                    100.7186027,
                    55.2132166
                ],
                [
                    100.7198043,
                    55.2123352
                ],
                [
                    100.7211776,
                    55.2113558
                ],
                [
                    100.7213493,
                    55.2100825
                ],
                [
                    100.7211776,
                    55.2090051
                ],
                [
                    100.719976,
                    55.2080256
                ],
                [
                    100.7177444,
                    55.2079277
                ],
                [
                    100.7149978,
                    55.2085154
                ],
                [
                    100.7134528,
                    55.2084174
                ],
                [
                    100.7120796,
                    55.2075359
                ],
                [
                    100.7098479,
                    55.2069481
                ],
                [
                    100.7089897,
                    55.2058707
                ],
                [
                    100.7091613,
                    55.2044993
                ],
                [
                    100.7101913,
                    55.2030299
                ],
                [
                    100.7110496,
                    55.2013645
                ],
                [
                    100.7112213,
                    55.199797
                ],
                [
                    100.7110496,
                    55.1979355
                ],
                [
                    100.709333,
                    55.1966618
                ],
                [
                    100.7072731,
                    55.19578
                ],
                [
                    100.7064148,
                    55.1975436
                ],
                [
                    100.7048698,
                    55.1987193
                ],
                [
                    100.7038398,
                    55.199797
                ],
                [
                    100.7038398,
                    55.2006787
                ],
                [
                    100.7007499,
                    55.2007767
                ],
                [
                    100.6983467,
                    55.2003848
                ],
                [
                    100.6952568,
                    55.2000909
                ],
                [
                    100.6916519,
                    55.1999929
                ],
                [
                    100.688562,
                    55.199601
                ],
                [
                    100.6853004,
                    55.1994051
                ],
                [
                    100.6822105,
                    55.1989152
                ],
                [
                    100.6787772,
                    55.1979355
                ],
                [
                    100.6744857,
                    55.1977396
                ],
                [
                    100.6724258,
                    55.1976416
                ],
                [
                    100.6710525,
                    55.1984254
                ],
                [
                    100.6700225,
                    55.1982294
                ],
                [
                    100.6681343,
                    55.1968578
                ],
                [
                    100.6679626,
                    55.1984254
                ],
                [
                    100.6683058,
                    55.1994051
                ],
                [
                    100.667276,
                    55.2012665
                ],
                [
                    100.6667609,
                    55.202736
                ],
                [
                    100.6655593,
                    55.205185
                ]
            ],
            "longitude": 100.682037,
            "latitude": 55.207047
        },
        "3871": {
            "name": "Никитаево",
            "population": 336,
            "type": "village",
            "poly": null,
            "longitude": 100.693245,
            "latitude": 54.63261
        },
        "3872": {
            "name": "Тэмь",
            "population": 669,
            "type": "village",
            "poly": null,
            "longitude": 100.732552,
            "latitude": 55.33279
        },
        "3873": {
            "name": "Гадалей",
            "population": 1101,
            "type": "village",
            "poly": [
                [
                    100.7105038,
                    54.4114723
                ],
                [
                    100.7150219,
                    54.4155888
                ],
                [
                    100.7442404,
                    54.4099908
                ],
                [
                    100.7539512,
                    54.4066089
                ],
                [
                    100.7559445,
                    54.4001069
                ],
                [
                    100.7520944,
                    54.396985
                ],
                [
                    100.7548443,
                    54.394016
                ],
                [
                    100.7660546,
                    54.387367
                ],
                [
                    100.7582041,
                    54.3804037
                ],
                [
                    100.7545287,
                    54.3822312
                ],
                [
                    100.7505461,
                    54.3842114
                ],
                [
                    100.7501851,
                    54.38732
                ],
                [
                    100.7451865,
                    54.3932212
                ],
                [
                    100.743467,
                    54.3940662
                ],
                [
                    100.7419649,
                    54.3951906
                ],
                [
                    100.7407403,
                    54.3963223
                ],
                [
                    100.7372425,
                    54.3975323
                ],
                [
                    100.731592,
                    54.3972831
                ],
                [
                    100.7232909,
                    54.401634
                ],
                [
                    100.723466,
                    54.4046419
                ],
                [
                    100.7215392,
                    54.4080572
                ],
                [
                    100.7162032,
                    54.409685
                ],
                [
                    100.7105038,
                    54.4114723
                ]
            ],
            "longitude": 100.737839,
            "latitude": 54.405487
        },
        "3874": {
            "name": "Азей",
            "population": 677,
            "type": "village",
            "poly": null,
            "longitude": 100.7681115,
            "latitude": 54.5094862
        },
        "3875": {
            "name": "Барчим",
            "population": 187,
            "type": "village",
            "poly": null,
            "longitude": 100.798897,
            "latitude": 55.368851
        },
        "3876": {
            "name": "Бурхун",
            "population": 586,
            "type": "village",
            "poly": null,
            "longitude": 100.825851,
            "latitude": 54.823437
        },
        "3877": {
            "name": "Худобок",
            "population": 439,
            "type": "village",
            "poly": null,
            "longitude": 100.866714,
            "latitude": 55.470188
        },
        "3878": {
            "name": "Турма",
            "population": 2016,
            "type": "village",
            "poly": [
                [
                    100.8432607,
                    56.2064353
                ],
                [
                    100.8437757,
                    56.2070082
                ],
                [
                    100.846179,
                    56.2073901
                ],
                [
                    100.8482389,
                    56.2068173
                ],
                [
                    100.8504705,
                    56.2071992
                ],
                [
                    100.8501272,
                    56.2085358
                ],
                [
                    100.8470373,
                    56.209586
                ],
                [
                    100.8473805,
                    56.2102543
                ],
                [
                    100.8513288,
                    56.2098724
                ],
                [
                    100.8533888,
                    56.2111135
                ],
                [
                    100.8566503,
                    56.211209
                ],
                [
                    100.8604268,
                    56.2108271
                ],
                [
                    100.8635168,
                    56.2108271
                ],
                [
                    100.8645467,
                    56.2097769
                ],
                [
                    100.8612852,
                    56.2092041
                ],
                [
                    100.8595686,
                    56.207772
                ],
                [
                    100.8587103,
                    56.205576
                ],
                [
                    100.8590536,
                    56.202807
                ],
                [
                    100.8611135,
                    56.2014701
                ],
                [
                    100.8657484,
                    56.2006107
                ],
                [
                    100.8698682,
                    56.1993693
                ],
                [
                    100.8739881,
                    56.1991783
                ],
                [
                    100.8779363,
                    56.1996558
                ],
                [
                    100.8782796,
                    56.2011837
                ],
                [
                    100.878623,
                    56.202998
                ],
                [
                    100.8853178,
                    56.2022341
                ],
                [
                    100.8889227,
                    56.2009927
                ],
                [
                    100.8925275,
                    56.2000378
                ],
                [
                    100.898364,
                    56.1996558
                ],
                [
                    100.9009389,
                    56.1987008
                ],
                [
                    100.9064321,
                    56.1946897
                ],
                [
                    100.9102087,
                    56.1923974
                ],
                [
                    100.9145002,
                    56.190105
                ],
                [
                    100.9145002,
                    56.1892454
                ],
                [
                    100.9124403,
                    56.1878125
                ],
                [
                    100.9102087,
                    56.1888633
                ],
                [
                    100.9079771,
                    56.1888633
                ],
                [
                    100.9081487,
                    56.1874304
                ],
                [
                    100.9040289,
                    56.1845645
                ],
                [
                    100.8992223,
                    56.1855199
                ],
                [
                    100.8957891,
                    56.1863796
                ],
                [
                    100.8939008,
                    56.1870483
                ],
                [
                    100.8904675,
                    56.1883857
                ],
                [
                    100.887721,
                    56.1892454
                ],
                [
                    100.8842878,
                    56.1902006
                ],
                [
                    100.8822279,
                    56.1912513
                ],
                [
                    100.878108,
                    56.1923974
                ],
                [
                    100.8751898,
                    56.1934481
                ],
                [
                    100.8724432,
                    56.1943077
                ],
                [
                    100.868495,
                    56.1955493
                ],
                [
                    100.866435,
                    56.1962178
                ],
                [
                    100.8626585,
                    56.1974593
                ],
                [
                    100.8609419,
                    56.1987008
                ],
                [
                    100.8583668,
                    56.1993693
                ],
                [
                    100.8559637,
                    56.2003242
                ],
                [
                    100.8542471,
                    56.2008017
                ],
                [
                    100.8518438,
                    56.2017566
                ],
                [
                    100.8489256,
                    56.202998
                ],
                [
                    100.8453207,
                    56.2044302
                ],
                [
                    100.8439474,
                    56.2053851
                ],
                [
                    100.8432607,
                    56.2064353
                ]
            ],
            "longitude": 100.886108,
            "latitude": 56.193722
        },
        "3879": {
            "name": "Шуба",
            "population": 740,
            "type": "village",
            "poly": null,
            "longitude": 100.898682,
            "latitude": 54.447048
        },
        "3880": {
            "name": "Шерагул",
            "population": 1227,
            "type": "village",
            "poly": null,
            "longitude": 100.910881,
            "latitude": 54.461205
        },
        "3881": {
            "name": "Александровка",
            "population": 596,
            "type": "village",
            "poly": null,
            "longitude": 100.922203,
            "latitude": 55.424618
        },
        "3882": {
            "name": "Альбин",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 100.949966,
            "latitude": 54.963291
        },
        "3883": {
            "name": "Октябрьский-2",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 100.975662,
            "latitude": 54.901703
        },
        "3884": {
            "name": "Тангуй",
            "population": 1882,
            "type": "village",
            "poly": [
                [
                    101.0120099,
                    55.3839661
                ],
                [
                    101.0224813,
                    55.389963
                ],
                [
                    101.0272019,
                    55.3894754
                ],
                [
                    101.0320085,
                    55.3909867
                ],
                [
                    101.0402481,
                    55.3902555
                ],
                [
                    101.0466855,
                    55.386989
                ],
                [
                    101.0507195,
                    55.3839174
                ],
                [
                    101.0515779,
                    55.3784561
                ],
                [
                    101.042394,
                    55.3724575
                ],
                [
                    101.0289186,
                    55.3788462
                ],
                [
                    101.0182756,
                    55.3799678
                ],
                [
                    101.0120099,
                    55.3839661
                ]
            ],
            "longitude": 101.034973,
            "latitude": 55.382172
        },
        "3885": {
            "name": "Покосное",
            "population": 2997,
            "type": "village",
            "poly": [
                [
                    101.0275932,
                    55.5206212
                ],
                [
                    101.0275932,
                    55.5220789
                ],
                [
                    101.0301681,
                    55.5230506
                ],
                [
                    101.0329147,
                    55.521593
                ],
                [
                    101.0346313,
                    55.5210099
                ],
                [
                    101.0365196,
                    55.5220789
                ],
                [
                    101.0389228,
                    55.5221761
                ],
                [
                    101.0402961,
                    55.5231478
                ],
                [
                    101.0421844,
                    55.5233421
                ],
                [
                    101.043901,
                    55.5239252
                ],
                [
                    101.0456176,
                    55.5248969
                ],
                [
                    101.0475059,
                    55.5257714
                ],
                [
                    101.0505958,
                    55.5258686
                ],
                [
                    101.0504242,
                    55.5268402
                ],
                [
                    101.0468193,
                    55.5269374
                ],
                [
                    101.0418411,
                    55.5272289
                ],
                [
                    101.0392662,
                    55.5276175
                ],
                [
                    101.0389228,
                    55.5283948
                ],
                [
                    101.0399528,
                    55.5306294
                ],
                [
                    101.0413261,
                    55.5328639
                ],
                [
                    101.043386,
                    55.5336411
                ],
                [
                    101.0451027,
                    55.534904
                ],
                [
                    101.0468193,
                    55.5352925
                ],
                [
                    101.0488792,
                    55.5361668
                ],
                [
                    101.0512825,
                    55.5371382
                ],
                [
                    101.054544,
                    55.5366525
                ],
                [
                    101.0536857,
                    55.537721
                ],
                [
                    101.0572906,
                    55.5392752
                ],
                [
                    101.0622688,
                    55.5411207
                ],
                [
                    101.0631271,
                    55.539858
                ],
                [
                    101.0629554,
                    55.5386924
                ],
                [
                    101.0602089,
                    55.5390809
                ],
                [
                    101.0576339,
                    55.537721
                ],
                [
                    101.0566039,
                    55.5360697
                ],
                [
                    101.0562606,
                    55.5346125
                ],
                [
                    101.0555739,
                    55.5324753
                ],
                [
                    101.0554023,
                    55.5309209
                ],
                [
                    101.0554023,
                    55.5294635
                ],
                [
                    101.0555739,
                    55.527909
                ],
                [
                    101.0571189,
                    55.5262572
                ],
                [
                    101.0595222,
                    55.5252855
                ],
                [
                    101.0617538,
                    55.5250912
                ],
                [
                    101.0632988,
                    55.5242167
                ],
                [
                    101.0658737,
                    55.5223704
                ],
                [
                    101.066217,
                    55.5212043
                ],
                [
                    101.0675903,
                    55.5191635
                ],
                [
                    101.0691352,
                    55.5179001
                ],
                [
                    101.0696502,
                    55.5164423
                ],
                [
                    101.0686203,
                    55.5146929
                ],
                [
                    101.066732,
                    55.5145957
                ],
                [
                    101.0645004,
                    55.5146929
                ],
                [
                    101.0627838,
                    55.5142069
                ],
                [
                    101.0598655,
                    55.5142069
                ],
                [
                    101.0572906,
                    55.5137209
                ],
                [
                    101.0555739,
                    55.5127489
                ],
                [
                    101.0528274,
                    55.5114853
                ],
                [
                    101.0512825,
                    55.5119713
                ],
                [
                    101.0481925,
                    55.5118741
                ],
                [
                    101.0487075,
                    55.5098329
                ],
                [
                    101.0469909,
                    55.5096385
                ],
                [
                    101.043901,
                    55.5095412
                ],
                [
                    101.0435576,
                    55.5106105
                ],
                [
                    101.043386,
                    55.5118741
                ],
                [
                    101.0425276,
                    55.5140125
                ],
                [
                    101.0409828,
                    55.5148872
                ],
                [
                    101.0402961,
                    55.5163451
                ],
                [
                    101.0373779,
                    55.5167339
                ],
                [
                    101.035318,
                    55.5165395
                ],
                [
                    101.0336013,
                    55.5166367
                ],
                [
                    101.0311981,
                    55.5178029
                ],
                [
                    101.0305114,
                    55.518386
                ],
                [
                    101.0293097,
                    55.5194551
                ],
                [
                    101.0275932,
                    55.5206212
                ]
            ],
            "longitude": 101.051109,
            "latitude": 55.522079
        },
        "3886": {
            "name": "Новое Приречье",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 101.060829,
            "latitude": 55.078537
        },
        "3887": {
            "name": "Сосновый",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 101.093002,
            "latitude": 55.543449
        },
        "3888": {
            "name": "Каразей",
            "population": 1181,
            "type": "village",
            "poly": null,
            "longitude": 101.112846,
            "latitude": 54.360008
        },
        "3889": {
            "name": "Амур",
            "population": 298,
            "type": "village",
            "poly": null,
            "longitude": 101.118279,
            "latitude": 54.215088
        },
        "3890": {
            "name": "Уховский",
            "population": 1160,
            "type": "village",
            "poly": null,
            "longitude": 101.125244,
            "latitude": 54.406502
        },
        "3891": {
            "name": "Добчур",
            "population": 1070,
            "type": "village",
            "poly": null,
            "longitude": 101.149712,
            "latitude": 55.342484
        },
        "3892": {
            "name": "Тулюшка",
            "population": 1259,
            "type": "village",
            "poly": null,
            "longitude": 101.157021,
            "latitude": 54.464375
        },
        "3893": {
            "name": "Тулюшка",
            "population": 311,
            "type": "village",
            "poly": null,
            "longitude": 101.178055,
            "latitude": 54.454567
        },
        "3894": {
            "name": "Бамбуй",
            "population": 22,
            "type": "village",
            "poly": null,
            "longitude": 101.205025,
            "latitude": 56.097321
        },
        "3895": {
            "name": "Кузнецовка",
            "population": 1115,
            "type": "village",
            "poly": [
                [
                    101.2268684,
                    56.0879212
                ],
                [
                    101.2281474,
                    56.0910222
                ],
                [
                    101.2296149,
                    56.0934707
                ],
                [
                    101.2310088,
                    56.0933023
                ],
                [
                    101.2359515,
                    56.0927054
                ],
                [
                    101.2372236,
                    56.0925518
                ],
                [
                    101.2398779,
                    56.0917656
                ],
                [
                    101.2416543,
                    56.09137
                ],
                [
                    101.2436726,
                    56.0912815
                ],
                [
                    101.2453171,
                    56.0911292
                ],
                [
                    101.2467071,
                    56.0901555
                ],
                [
                    101.2479506,
                    56.0897555
                ],
                [
                    101.2491052,
                    56.0895961
                ],
                [
                    101.2500992,
                    56.0897556
                ],
                [
                    101.250919,
                    56.0902045
                ],
                [
                    101.2518372,
                    56.0906549
                ],
                [
                    101.2519285,
                    56.0906997
                ],
                [
                    101.2534518,
                    56.0907725
                ],
                [
                    101.2546269,
                    56.0907968
                ],
                [
                    101.2563895,
                    56.0914402
                ],
                [
                    101.2580433,
                    56.0918287
                ],
                [
                    101.2601323,
                    56.0919986
                ],
                [
                    101.2621779,
                    56.0923385
                ],
                [
                    101.2628307,
                    56.0923992
                ],
                [
                    101.2633529,
                    56.0909668
                ],
                [
                    101.2647276,
                    56.0905666
                ],
                [
                    101.2648398,
                    56.0900228
                ],
                [
                    101.2651072,
                    56.0893391
                ],
                [
                    101.2656772,
                    56.088626
                ],
                [
                    101.2626833,
                    56.0883713
                ],
                [
                    101.2618346,
                    56.0866594
                ],
                [
                    101.2576489,
                    56.0865534
                ],
                [
                    101.2555358,
                    56.081145
                ],
                [
                    101.2473684,
                    56.0820827
                ],
                [
                    101.2469068,
                    56.0817252
                ],
                [
                    101.2439304,
                    56.0821083
                ],
                [
                    101.2418854,
                    56.0806782
                ],
                [
                    101.2373389,
                    56.0812087
                ],
                [
                    101.2373039,
                    56.082729
                ],
                [
                    101.2344955,
                    56.0825679
                ],
                [
                    101.2335299,
                    56.0848988
                ],
                [
                    101.2316386,
                    56.0851532
                ],
                [
                    101.2286073,
                    56.0856228
                ],
                [
                    101.2290425,
                    56.0868491
                ],
                [
                    101.2280633,
                    56.0869826
                ],
                [
                    101.2285196,
                    56.0877163
                ],
                [
                    101.2268684,
                    56.0879212
                ]
            ],
            "longitude": 101.239784,
            "latitude": 56.086643
        },
        "3896": {
            "name": "Чеботариха",
            "population": 779,
            "type": "village",
            "poly": null,
            "longitude": 101.240768,
            "latitude": 54.381275
        },
        "3897": {
            "name": "Кундуй",
            "population": 932,
            "type": "village",
            "poly": null,
            "longitude": 101.266533,
            "latitude": 54.339046
        },
        "3898": {
            "name": "Тарма",
            "population": 1037,
            "type": "village",
            "poly": [
                [
                    101.2801071,
                    55.9850903
                ],
                [
                    101.2806221,
                    55.9861466
                ],
                [
                    101.2818237,
                    55.9872029
                ],
                [
                    101.2833686,
                    55.9872029
                ],
                [
                    101.2842268,
                    55.9867228
                ],
                [
                    101.2854286,
                    55.9866268
                ],
                [
                    101.2868019,
                    55.987395
                ],
                [
                    101.2881752,
                    55.987587
                ],
                [
                    101.2895485,
                    55.987587
                ],
                [
                    101.2907501,
                    55.987587
                ],
                [
                    101.2916084,
                    55.9868188
                ],
                [
                    101.2931533,
                    55.9864347
                ],
                [
                    101.29487,
                    55.9857625
                ],
                [
                    101.2969299,
                    55.9845142
                ],
                [
                    101.2998481,
                    55.9831697
                ],
                [
                    101.3025947,
                    55.9822094
                ],
                [
                    101.3056846,
                    55.9806727
                ],
                [
                    101.3082595,
                    55.9796163
                ],
                [
                    101.3092895,
                    55.978944
                ],
                [
                    101.3079161,
                    55.9776954
                ],
                [
                    101.3058248,
                    55.9776633
                ],
                [
                    101.3023658,
                    55.9783219
                ],
                [
                    101.3015647,
                    55.9772152
                ],
                [
                    101.3012214,
                    55.9761586
                ],
                [
                    101.2996765,
                    55.9752941
                ],
                [
                    101.2976165,
                    55.9757744
                ],
                [
                    101.2957282,
                    55.9762547
                ],
                [
                    101.2946982,
                    55.9765428
                ],
                [
                    101.2931533,
                    55.9775033
                ],
                [
                    101.29178,
                    55.9782717
                ],
                [
                    101.2905784,
                    55.978944
                ],
                [
                    101.2897201,
                    55.9795203
                ],
                [
                    101.2878318,
                    55.9800965
                ],
                [
                    101.2854286,
                    55.9808648
                ],
                [
                    101.2850853,
                    55.9796163
                ],
                [
                    101.2838836,
                    55.9797123
                ],
                [
                    101.2819954,
                    55.9797123
                ],
                [
                    101.282167,
                    55.9805767
                ],
                [
                    101.2830253,
                    55.9809609
                ],
                [
                    101.2843986,
                    55.9818252
                ],
                [
                    101.2843986,
                    55.9825935
                ],
                [
                    101.2833686,
                    55.9828816
                ],
                [
                    101.2818237,
                    55.9828816
                ],
                [
                    101.281137,
                    55.9832657
                ],
                [
                    101.2802787,
                    55.9843221
                ],
                [
                    101.2801071,
                    55.9850903
                ]
            ],
            "longitude": 101.293152,
            "latitude": 55.980961
        },
        "3899": {
            "name": "Седаново",
            "population": 1525,
            "type": "village",
            "poly": null,
            "longitude": 101.309441,
            "latitude": 56.980728
        },
        "3900": {
            "name": "Зулумай",
            "population": 302,
            "type": "village",
            "poly": null,
            "longitude": 101.319046,
            "latitude": 53.688736
        },
        "3901": {
            "name": "Лермонтовский",
            "population": 597,
            "type": "village",
            "poly": null,
            "longitude": 101.363464,
            "latitude": 54.303246
        },
        "3902": {
            "name": "Кобь",
            "population": 472,
            "type": "village",
            "poly": null,
            "longitude": 101.373009,
            "latitude": 55.432377
        },
        "3903": {
            "name": "Кобляково",
            "population": 772,
            "type": "village",
            "poly": null,
            "longitude": 101.434746,
            "latitude": 56.587486
        },
        "3904": {
            "name": "Алкин",
            "population": 268,
            "type": "village",
            "poly": null,
            "longitude": 101.443024,
            "latitude": 54.48835
        },
        "3905": {
            "name": "Сахарово",
            "population": 275,
            "type": "village",
            "poly": null,
            "longitude": 101.484322,
            "latitude": 56.500397
        },
        "3906": {
            "name": "Леонова",
            "population": 473,
            "type": "village",
            "poly": null,
            "longitude": 101.525055,
            "latitude": 55.570152
        },
        "3907": {
            "name": "Стениха",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 101.5302195,
            "latitude": 56.1995493
        },
        "3908": {
            "name": "Басалаевка",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 101.546066,
            "latitude": 53.78334
        },
        "3909": {
            "name": "Хор-Тагна",
            "population": 660,
            "type": "village",
            "poly": null,
            "longitude": 101.549599,
            "latitude": 53.418232
        },
        "3910": {
            "name": "Новодолоново",
            "population": 505,
            "type": "village",
            "poly": null,
            "longitude": 101.556442,
            "latitude": 55.848602
        },
        "3911": {
            "name": "Бурук",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 101.559204,
            "latitude": 54.511364
        },
        "3912": {
            "name": "Большой Кашелак",
            "population": 269,
            "type": "village",
            "poly": null,
            "longitude": 101.560181,
            "latitude": 54.07011
        },
        "3913": {
            "name": "Мингатуй",
            "population": 187,
            "type": "village",
            "poly": null,
            "longitude": 101.564636,
            "latitude": 54.735386
        },
        "3914": {
            "name": "Бурнинская Вихоря",
            "population": 290,
            "type": "village",
            "poly": null,
            "longitude": 101.595863,
            "latitude": 56.364792
        },
        "3915": {
            "name": "Харик",
            "population": 748,
            "type": "village",
            "poly": null,
            "longitude": 101.617957,
            "latitude": 54.1801438
        },
        "3916": {
            "name": "Батама",
            "population": 982,
            "type": "village",
            "poly": null,
            "longitude": 101.624802,
            "latitude": 53.8717
        },
        "3917": {
            "name": "Андрюшино",
            "population": 668,
            "type": "village",
            "poly": [
                [
                    [
                        101.6112015,
                        54.3692824
                    ],
                    [
                        101.6141863,
                        54.3714649
                    ],
                    [
                        101.616114,
                        54.3707676
                    ],
                    [
                        101.6177902,
                        54.3725305
                    ],
                    [
                        101.6220342,
                        54.3713352
                    ],
                    [
                        101.6232778,
                        54.3711178
                    ],
                    [
                        101.6266202,
                        54.3695421
                    ],
                    [
                        101.6306154,
                        54.3671874
                    ],
                    [
                        101.6322944,
                        54.3659647
                    ],
                    [
                        101.6402072,
                        54.3641079
                    ],
                    [
                        101.6413576,
                        54.3643706
                    ],
                    [
                        101.6422437,
                        54.3652129
                    ],
                    [
                        101.6434796,
                        54.3648959
                    ],
                    [
                        101.6441247,
                        54.3648959
                    ],
                    [
                        101.6459281,
                        54.3656115
                    ],
                    [
                        101.6480578,
                        54.3649684
                    ],
                    [
                        101.6492471,
                        54.3636687
                    ],
                    [
                        101.6494442,
                        54.3621251
                    ],
                    [
                        101.650136,
                        54.3613506
                    ],
                    [
                        101.6507422,
                        54.3607528
                    ],
                    [
                        101.6504546,
                        54.3596748
                    ],
                    [
                        101.6519859,
                        54.3591811
                    ],
                    [
                        101.6510376,
                        54.3574373
                    ],
                    [
                        101.6479984,
                        54.356776
                    ],
                    [
                        101.6452693,
                        54.3572455
                    ],
                    [
                        101.6437614,
                        54.3578751
                    ],
                    [
                        101.6383204,
                        54.3595963
                    ],
                    [
                        101.62953,
                        54.3619914
                    ],
                    [
                        101.6253948,
                        54.3630149
                    ],
                    [
                        101.6203113,
                        54.3634497
                    ],
                    [
                        101.6156165,
                        54.3644098
                    ],
                    [
                        101.6169845,
                        54.3664205
                    ],
                    [
                        101.6129115,
                        54.3683858
                    ],
                    [
                        101.6112015,
                        54.3692824
                    ]
                ],
                [
                    [
                        101.6540798,
                        54.3634415
                    ],
                    [
                        101.6549372,
                        54.3647385
                    ],
                    [
                        101.6542886,
                        54.3659233
                    ],
                    [
                        101.6547975,
                        54.3675918
                    ],
                    [
                        101.6554461,
                        54.3683026
                    ],
                    [
                        101.6574577,
                        54.3688021
                    ],
                    [
                        101.659942,
                        54.3701725
                    ],
                    [
                        101.664576,
                        54.3699259
                    ],
                    [
                        101.6678795,
                        54.3696723
                    ],
                    [
                        101.6730718,
                        54.3686399
                    ],
                    [
                        101.6717412,
                        54.3666565
                    ],
                    [
                        101.6675896,
                        54.3610857
                    ],
                    [
                        101.6633025,
                        54.3619248
                    ],
                    [
                        101.6599607,
                        54.3629111
                    ],
                    [
                        101.6563222,
                        54.3624884
                    ],
                    [
                        101.6545359,
                        54.3623976
                    ],
                    [
                        101.6541622,
                        54.3627402
                    ],
                    [
                        101.6540798,
                        54.3634415
                    ]
                ]
            ],
            "longitude": 101.633698,
            "latitude": 54.363422
        },
        "3918": {
            "name": "Черемшанка",
            "population": 309,
            "type": "village",
            "poly": null,
            "longitude": 101.649506,
            "latitude": 53.285324
        },
        "3919": {
            "name": "Подъеланка",
            "population": 594,
            "type": "village",
            "poly": null,
            "longitude": 101.651772,
            "latitude": 57.087006
        },
        "3920": {
            "name": "Харик",
            "population": 1812,
            "type": "village",
            "poly": null,
            "longitude": 101.6640015,
            "latitude": 54.242396
        },
        "3921": {
            "name": "Порожский",
            "population": null,
            "type": "village",
            "poly": [
                [
                    101.6312008,
                    56.0847566
                ],
                [
                    101.6314111,
                    56.0877042
                ],
                [
                    101.6328059,
                    56.0898519
                ],
                [
                    101.6354237,
                    56.089397
                ],
                [
                    101.6385994,
                    56.0890139
                ],
                [
                    101.6409169,
                    56.0885111
                ],
                [
                    101.6460828,
                    56.0884118
                ],
                [
                    101.6476546,
                    56.0885829
                ],
                [
                    101.6507016,
                    56.0887744
                ],
                [
                    101.6521607,
                    56.0891575
                ],
                [
                    101.6529332,
                    56.0886787
                ],
                [
                    101.653534,
                    56.0889899
                ],
                [
                    101.6549502,
                    56.0894927
                ],
                [
                    101.6554652,
                    56.089373
                ],
                [
                    101.6601429,
                    56.0888702
                ],
                [
                    101.6670952,
                    56.0896364
                ],
                [
                    101.6739617,
                    56.0894927
                ],
                [
                    101.680399,
                    56.0896124
                ],
                [
                    101.6831885,
                    56.0896364
                ],
                [
                    101.6928874,
                    56.0894448
                ],
                [
                    101.6977368,
                    56.0884632
                ],
                [
                    101.7115555,
                    56.0866674
                ],
                [
                    101.7110835,
                    56.0843927
                ],
                [
                    101.7085944,
                    56.0846561
                ],
                [
                    101.7083605,
                    56.0842478
                ],
                [
                    101.7076073,
                    56.0842011
                ],
                [
                    101.7071921,
                    56.0834378
                ],
                [
                    101.706234,
                    56.0835546
                ],
                [
                    101.7035733,
                    56.0839377
                ],
                [
                    101.7006979,
                    56.0842729
                ],
                [
                    101.6991766,
                    56.0841041
                ],
                [
                    101.6952284,
                    56.0837928
                ],
                [
                    101.6914282,
                    56.0836503
                ],
                [
                    101.6907845,
                    56.0822615
                ],
                [
                    101.6898211,
                    56.0820447
                ],
                [
                    101.6820298,
                    56.0820938
                ],
                [
                    101.6765173,
                    56.0819729
                ],
                [
                    101.6655074,
                    56.0815909
                ],
                [
                    101.6592224,
                    56.0813263
                ],
                [
                    101.652356,
                    56.0811587
                ],
                [
                    101.6475258,
                    56.0809444
                ],
                [
                    101.6403397,
                    56.0809911
                ],
                [
                    101.6385136,
                    56.0813754
                ],
                [
                    101.6375695,
                    56.0819262
                ],
                [
                    101.636282,
                    56.0832912
                ],
                [
                    101.6315442,
                    56.0840119
                ],
                [
                    101.6312008,
                    56.0847566
                ]
            ],
            "longitude": 101.672607,
            "latitude": 56.085613
        },
        "3922": {
            "name": "Ленинский",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 101.680862,
            "latitude": 54.088623
        },
        "3923": {
            "name": "Ключи-Булак",
            "population": 1388,
            "type": "village",
            "poly": null,
            "longitude": 101.682663,
            "latitude": 55.523014
        },
        "3924": {
            "name": "Масляногорск",
            "population": 508,
            "type": "village",
            "poly": null,
            "longitude": 101.693863,
            "latitude": 53.570919
        },
        "3925": {
            "name": "Садовый",
            "population": 139,
            "type": "village",
            "poly": null,
            "longitude": 101.70694,
            "latitude": 54.197208
        },
        "3926": {
            "name": "Барлук",
            "population": 1112,
            "type": "village",
            "poly": null,
            "longitude": 101.723244,
            "latitude": 54.536263
        },
        "3927": {
            "name": "Калтук",
            "population": 1786,
            "type": "village",
            "poly": null,
            "longitude": 101.736954,
            "latitude": 55.677616
        },
        "3928": {
            "name": "Большеокинское",
            "population": 1105,
            "type": "village",
            "poly": [
                [
                    101.7240564,
                    55.7460965
                ],
                [
                    101.7326394,
                    55.7488985
                ],
                [
                    101.7345275,
                    55.749185
                ],
                [
                    101.7479173,
                    55.7512171
                ],
                [
                    101.7607919,
                    55.7439708
                ],
                [
                    101.7606191,
                    55.743734
                ],
                [
                    101.7556421,
                    55.7369164
                ],
                [
                    101.7595903,
                    55.73566
                ],
                [
                    101.7575303,
                    55.7332437
                ],
                [
                    101.7506639,
                    55.7330504
                ],
                [
                    101.7468873,
                    55.7341136
                ],
                [
                    101.7468873,
                    55.7351768
                ],
                [
                    101.7334977,
                    55.7385593
                ],
                [
                    101.7328111,
                    55.7374963
                ],
                [
                    101.7302362,
                    55.7384627
                ],
                [
                    101.7240564,
                    55.7460965
                ]
            ],
            "longitude": 101.742897,
            "latitude": 55.74287
        },
        "3929": {
            "name": "Игнино",
            "population": 563,
            "type": "village",
            "poly": null,
            "longitude": 101.754646,
            "latitude": 54.088028
        },
        "3930": {
            "name": "Кумейка",
            "population": 438,
            "type": "village",
            "poly": null,
            "longitude": 101.77755,
            "latitude": 55.536179
        },
        "3931": {
            "name": "Новостройка",
            "population": 493,
            "type": "village",
            "poly": null,
            "longitude": 101.8260917,
            "latitude": 52.9797658
        },
        "3932": {
            "name": "Новолетники",
            "population": 403,
            "type": "village",
            "poly": null,
            "longitude": 101.843872,
            "latitude": 53.616024
        },
        "3933": {
            "name": "Центральный Хазан",
            "population": 1339,
            "type": "village",
            "poly": [
                [
                    101.8406302,
                    53.90257
                ],
                [
                    101.8447501,
                    53.9057051
                ],
                [
                    101.8492991,
                    53.9054522
                ],
                [
                    101.8565089,
                    53.9024182
                ],
                [
                    101.8634611,
                    53.8975128
                ],
                [
                    101.8674951,
                    53.8911906
                ],
                [
                    101.8672377,
                    53.8821861
                ],
                [
                    101.8585688,
                    53.8799093
                ],
                [
                    101.8522173,
                    53.8884085
                ],
                [
                    101.8481833,
                    53.8941242
                ],
                [
                    101.8436343,
                    53.89903
                ],
                [
                    101.8406302,
                    53.90257
                ]
            ],
            "longitude": 101.8577188,
            "latitude": 53.8936522
        },
        "3934": {
            "name": "Карымск",
            "population": 1809,
            "type": "village",
            "poly": null,
            "longitude": 101.858429,
            "latitude": 54.104836
        },
        "3935": {
            "name": "Харанжино",
            "population": 1294,
            "type": "village",
            "poly": null,
            "longitude": 101.888435,
            "latitude": 55.400692
        },
        "3936": {
            "name": "Тагна",
            "population": 575,
            "type": "village",
            "poly": null,
            "longitude": 101.888924,
            "latitude": 53.589287
        },
        "3937": {
            "name": "Куватка",
            "population": 824,
            "type": "village",
            "poly": null,
            "longitude": 101.961838,
            "latitude": 55.499912
        },
        "3938": {
            "name": "Кимильтей",
            "population": 1854,
            "type": "village",
            "poly": null,
            "longitude": 101.9636,
            "latitude": 54.13253
        },
        "3939": {
            "name": "Сухой",
            "population": null,
            "type": "village",
            "poly": [
                [
                    101.9509953,
                    56.2628632
                ],
                [
                    101.9511554,
                    56.2637945
                ],
                [
                    101.9535587,
                    56.2638898
                ],
                [
                    101.9557903,
                    56.2641758
                ],
                [
                    101.9593952,
                    56.2646525
                ],
                [
                    101.9621418,
                    56.2650338
                ],
                [
                    101.9643734,
                    56.2650338
                ],
                [
                    101.9669483,
                    56.2647478
                ],
                [
                    101.9688366,
                    56.2643665
                ],
                [
                    101.9729564,
                    56.2633178
                ],
                [
                    101.974673,
                    56.2627458
                ],
                [
                    101.9785006,
                    56.2616631
                ],
                [
                    101.9814832,
                    56.2609445
                ],
                [
                    101.9837426,
                    56.2603164
                ],
                [
                    101.9858413,
                    56.2595703
                ],
                [
                    101.9875321,
                    56.257972
                ],
                [
                    101.9878175,
                    56.2566884
                ],
                [
                    101.9886265,
                    56.2556669
                ],
                [
                    101.9895748,
                    56.2546382
                ],
                [
                    101.9917657,
                    56.2535559
                ],
                [
                    101.9937275,
                    56.2528293
                ],
                [
                    101.9954441,
                    56.25302
                ],
                [
                    101.9963024,
                    56.2526386
                ],
                [
                    101.996474,
                    56.2520664
                ],
                [
                    101.996474,
                    56.2512081
                ],
                [
                    101.9966457,
                    56.2499683
                ],
                [
                    101.9961307,
                    56.2493961
                ],
                [
                    101.9961307,
                    56.2485377
                ],
                [
                    101.9961307,
                    56.2476794
                ],
                [
                    101.9963024,
                    56.246821
                ],
                [
                    101.9957874,
                    56.2458672
                ],
                [
                    101.9957874,
                    56.2451041
                ],
                [
                    101.9956157,
                    56.2436734
                ],
                [
                    101.9951008,
                    56.2429103
                ],
                [
                    101.9932125,
                    56.2433872
                ],
                [
                    101.9911525,
                    56.2441503
                ],
                [
                    101.9889209,
                    56.2451995
                ],
                [
                    101.9870327,
                    56.2460579
                ],
                [
                    101.9854876,
                    56.2472025
                ],
                [
                    101.9837711,
                    56.2486331
                ],
                [
                    101.9817112,
                    56.2499683
                ],
                [
                    101.9798229,
                    56.2511127
                ],
                [
                    101.9793079,
                    56.251971
                ],
                [
                    101.9781062,
                    56.2528293
                ],
                [
                    101.9763897,
                    56.2534015
                ],
                [
                    101.9745014,
                    56.2538783
                ],
                [
                    101.9724415,
                    56.2538783
                ],
                [
                    101.9702099,
                    56.2537829
                ],
                [
                    101.9688366,
                    56.254069
                ],
                [
                    101.9667766,
                    56.254069
                ],
                [
                    101.9679783,
                    56.2534015
                ],
                [
                    101.9669483,
                    56.2525432
                ],
                [
                    101.9659183,
                    56.2518757
                ],
                [
                    101.9650599,
                    56.2513988
                ],
                [
                    101.9633434,
                    56.250922
                ],
                [
                    101.9611118,
                    56.2521618
                ],
                [
                    101.9588027,
                    56.2543634
                ],
                [
                    101.9580219,
                    56.2549272
                ],
                [
                    101.95632,
                    56.2559988
                ],
                [
                    101.955039,
                    56.2570721
                ],
                [
                    101.9536818,
                    56.2586412
                ],
                [
                    101.9527004,
                    56.2598855
                ],
                [
                    101.9509963,
                    56.2614309
                ],
                [
                    101.9509953,
                    56.2628632
                ]
            ],
            "longitude": 101.9693515,
            "latitude": 56.2578832
        },
        "3940": {
            "name": "Услон",
            "population": 722,
            "type": "village",
            "poly": null,
            "longitude": 101.970596,
            "latitude": 53.931408
        },
        "3941": {
            "name": "Новая Тельба",
            "population": 175,
            "type": "village",
            "poly": null,
            "longitude": 101.991493,
            "latitude": 54.77993
        },
        "3942": {
            "name": "Уян",
            "population": 1121,
            "type": "village",
            "poly": null,
            "longitude": 101.996315,
            "latitude": 54.344711
        },
        "3943": {
            "name": "Самара",
            "population": 508,
            "type": "village",
            "poly": null,
            "longitude": 102.010262,
            "latitude": 53.850513
        },
        "3944": {
            "name": "Моисеевка",
            "population": 624,
            "type": "village",
            "poly": null,
            "longitude": 102.011177,
            "latitude": 53.526173
        },
        "3945": {
            "name": "Усть-Када",
            "population": 422,
            "type": "village",
            "poly": null,
            "longitude": 102.014137,
            "latitude": 54.50058
        },
        "3946": {
            "name": "Перевоз",
            "population": 411,
            "type": "village",
            "poly": null,
            "longitude": 102.041805,
            "latitude": 54.1069614
        },
        "3947": {
            "name": "Онот",
            "population": 872,
            "type": "village",
            "poly": null,
            "longitude": 102.051758,
            "latitude": 52.738377
        },
        "3948": {
            "name": "Красный Яр",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 102.052689,
            "latitude": 54.385429
        },
        "3949": {
            "name": "Баргадай",
            "population": 386,
            "type": "village",
            "poly": null,
            "longitude": 102.056564,
            "latitude": 54.199245
        },
        "3950": {
            "name": "Наратай",
            "population": 253,
            "type": "village",
            "poly": null,
            "longitude": 102.057121,
            "latitude": 55.025089
        },
        "3951": {
            "name": "Ухтуй",
            "population": 724,
            "type": "village",
            "poly": null,
            "longitude": 102.075218,
            "latitude": 53.953384
        },
        "3952": {
            "name": "Покровка",
            "population": 618,
            "type": "village",
            "poly": null,
            "longitude": 102.080872,
            "latitude": 53.877644
        },
        "3953": {
            "name": "Мордино",
            "population": 313,
            "type": "village",
            "poly": null,
            "longitude": 102.084167,
            "latitude": 53.980991
        },
        "3954": {
            "name": "Озёрный",
            "population": 682,
            "type": "village",
            "poly": [
                [
                    102.0731127,
                    55.8835947
                ],
                [
                    102.0762026,
                    55.884365
                ],
                [
                    102.0787775,
                    55.8819579
                ],
                [
                    102.0813525,
                    55.8817653
                ],
                [
                    102.0847857,
                    55.882343
                ],
                [
                    102.0935404,
                    55.8777211
                ],
                [
                    102.0936184,
                    55.8772397
                ],
                [
                    102.0938837,
                    55.8756026
                ],
                [
                    102.0901072,
                    55.8751211
                ],
                [
                    102.096802,
                    55.8733876
                ],
                [
                    102.1000635,
                    55.8717504
                ],
                [
                    102.0945704,
                    55.8705946
                ],
                [
                    102.0907938,
                    55.8726172
                ],
                [
                    102.0880472,
                    55.8715578
                ],
                [
                    102.0890772,
                    55.8680904
                ],
                [
                    102.0834124,
                    55.8675125
                ],
                [
                    102.0799792,
                    55.8690536
                ],
                [
                    102.084099,
                    55.8712688
                ],
                [
                    102.0756876,
                    55.8808988
                ],
                [
                    102.0731127,
                    55.8835947
                ]
            ],
            "longitude": 102.085129,
            "latitude": 55.876957
        },
        "3955": {
            "name": "Бабагай",
            "population": 427,
            "type": "village",
            "poly": null,
            "longitude": 102.101654,
            "latitude": 53.27319
        },
        "3956": {
            "name": "Зяба",
            "population": 437,
            "type": "village",
            "poly": null,
            "longitude": 102.1248752,
            "latitude": 56.3784046
        },
        "3957": {
            "name": "Норы",
            "population": 341,
            "type": "village",
            "poly": null,
            "longitude": 102.13018,
            "latitude": 53.961788
        },
        "3958": {
            "name": "Эдучанка",
            "population": 1799,
            "type": "village",
            "poly": null,
            "longitude": 102.149864,
            "latitude": 57.364388
        },
        "3959": {
            "name": "Большая Заимка",
            "population": 297,
            "type": "village",
            "poly": null,
            "longitude": 102.152016,
            "latitude": 53.546452
        },
        "3960": {
            "name": "Троицк",
            "population": 914,
            "type": "village",
            "poly": null,
            "longitude": 102.16494,
            "latitude": 53.466053
        },
        "3961": {
            "name": "Боровской",
            "population": 481,
            "type": "village",
            "poly": null,
            "longitude": 102.168732,
            "latitude": 56.489738
        },
        "3962": {
            "name": "Панагино",
            "population": 292,
            "type": "village",
            "poly": null,
            "longitude": 102.194244,
            "latitude": 54.633091
        },
        "3963": {
            "name": "Веренка",
            "population": 769,
            "type": "village",
            "poly": null,
            "longitude": 102.220886,
            "latitude": 53.687454
        },
        "3964": {
            "name": "Аляты",
            "population": 738,
            "type": "village",
            "poly": null,
            "longitude": 102.224495,
            "latitude": 53.212936
        },
        "3965": {
            "name": "Харайгун",
            "population": 333,
            "type": "village",
            "poly": null,
            "longitude": 102.225105,
            "latitude": 54.066307
        },
        "3966": {
            "name": "Сорты",
            "population": 611,
            "type": "village",
            "poly": null,
            "longitude": 102.227203,
            "latitude": 53.473728
        },
        "3967": {
            "name": "Ершово",
            "population": 934,
            "type": "village",
            "poly": null,
            "longitude": 102.236855,
            "latitude": 57.149803
        },
        "3968": {
            "name": "Ханжиново",
            "population": 1129,
            "type": "village",
            "poly": null,
            "longitude": 102.240112,
            "latitude": 53.619801
        },
        "3969": {
            "name": "Мойган",
            "population": 524,
            "type": "village",
            "poly": null,
            "longitude": 102.241623,
            "latitude": 53.341774
        },
        "3970": {
            "name": "Саянское",
            "population": 497,
            "type": "village",
            "poly": null,
            "longitude": 102.255501,
            "latitude": 53.075642
        },
        "3971": {
            "name": "Буря",
            "population": 218,
            "type": "village",
            "poly": null,
            "longitude": 102.295441,
            "latitude": 54.274807
        },
        "3972": {
            "name": "Холмогой",
            "population": 673,
            "type": "village",
            "poly": null,
            "longitude": 102.303017,
            "latitude": 53.489853
        },
        "3973": {
            "name": "Тыреть 1-я",
            "population": 3868,
            "type": "village",
            "poly": [
                [
                    102.2886166,
                    53.6740948
                ],
                [
                    102.2953071,
                    53.6816395
                ],
                [
                    102.3088166,
                    53.687583
                ],
                [
                    102.3299173,
                    53.6845352
                ],
                [
                    102.3384091,
                    53.6787438
                ],
                [
                    102.3390524,
                    53.6692167
                ],
                [
                    102.3326192,
                    53.6660913
                ],
                [
                    102.3218116,
                    53.6562563
                ],
                [
                    102.3144778,
                    53.6532062
                ],
                [
                    102.2942778,
                    53.66632
                ],
                [
                    102.2886166,
                    53.6740948
                ]
            ],
            "longitude": 102.308937,
            "latitude": 53.673069
        },
        "3974": {
            "name": "Тынкобь",
            "population": 220,
            "type": "village",
            "poly": null,
            "longitude": 102.316589,
            "latitude": 55.413361
        },
        "3975": {
            "name": "Тыреть 2-я",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 102.319092,
            "latitude": 53.721817
        },
        "3976": {
            "name": "Филипповск",
            "population": 306,
            "type": "village",
            "poly": null,
            "longitude": 102.322441,
            "latitude": 53.951824
        },
        "3977": {
            "name": "Наратай",
            "population": 449,
            "type": "village",
            "poly": null,
            "longitude": 102.32666,
            "latitude": 56.126045
        },
        "3978": {
            "name": "Иваническое",
            "population": 652,
            "type": "village",
            "poly": null,
            "longitude": 102.3380041,
            "latitude": 53.1992856
        },
        "3979": {
            "name": "Отрадная",
            "population": 298,
            "type": "village",
            "poly": null,
            "longitude": 102.3515091,
            "latitude": 53.2407884
        },
        "3980": {
            "name": "Романенкина",
            "population": 275,
            "type": "village",
            "poly": null,
            "longitude": 102.353104,
            "latitude": 53.394627
        },
        "3981": {
            "name": "Голуметь",
            "population": 1918,
            "type": "village",
            "poly": null,
            "longitude": 102.365631,
            "latitude": 53.043526
        },
        "3982": {
            "name": "Бадарминск",
            "population": 805,
            "type": "village",
            "poly": null,
            "longitude": 102.383209,
            "latitude": 57.767334
        },
        "3983": {
            "name": "Сплавная",
            "population": 176,
            "type": "village",
            "poly": null,
            "longitude": 102.4115868,
            "latitude": 52.7714993
        },
        "3984": {
            "name": "Тальники",
            "population": 571,
            "type": "village",
            "poly": null,
            "longitude": 102.412865,
            "latitude": 52.780735
        },
        "3985": {
            "name": "Бурятская",
            "population": 222,
            "type": "village",
            "poly": null,
            "longitude": 102.4375,
            "latitude": 53.354591
        },
        "3986": {
            "name": "Кежемский",
            "population": 1652,
            "type": "village",
            "poly": null,
            "longitude": 102.43856,
            "latitude": 56.55991
        },
        "3987": {
            "name": "Новочеремхово",
            "population": 329,
            "type": "village",
            "poly": null,
            "longitude": 102.46447,
            "latitude": 53.400261
        },
        "3988": {
            "name": "Куйта",
            "population": 449,
            "type": "village",
            "poly": null,
            "longitude": 102.472908,
            "latitude": 53.815445
        },
        "3989": {
            "name": "Нижняя Иреть",
            "population": 805,
            "type": "village",
            "poly": null,
            "longitude": 102.488068,
            "latitude": 52.987518
        },
        "3990": {
            "name": "Семеновское",
            "population": 570,
            "type": "village",
            "poly": null,
            "longitude": 102.503681,
            "latitude": 53.7281151
        },
        "3991": {
            "name": "Зоны",
            "population": 603,
            "type": "village",
            "poly": null,
            "longitude": 102.539146,
            "latitude": 53.316158
        },
        "3992": {
            "name": "Аларь",
            "population": 1161,
            "type": "village",
            "poly": [
                [
                    102.5231222,
                    53.0650413
                ],
                [
                    102.524409,
                    53.0750065
                ],
                [
                    102.5368036,
                    53.0751039
                ],
                [
                    102.545549,
                    53.0751342
                ],
                [
                    102.5673025,
                    53.0689074
                ],
                [
                    102.5550064,
                    53.0591986
                ],
                [
                    102.5401366,
                    53.0577378
                ],
                [
                    102.5231222,
                    53.0650413
                ]
            ],
            "longitude": 102.5419388,
            "latitude": 53.0692156
        },
        "3993": {
            "name": "Бажир",
            "population": 485,
            "type": "village",
            "poly": [
                [
                    102.5343263,
                    53.5882135
                ],
                [
                    102.5393324,
                    53.5951249
                ],
                [
                    102.5445924,
                    53.5960952
                ],
                [
                    102.5661037,
                    53.5901514
                ],
                [
                    102.5665391,
                    53.5817532
                ],
                [
                    102.5605536,
                    53.5789104
                ],
                [
                    102.5414001,
                    53.5820763
                ],
                [
                    102.5343263,
                    53.5882135
                ]
            ],
            "longitude": 102.547386,
            "latitude": 53.589699
        },
        "3994": {
            "name": "Шараты",
            "population": 328,
            "type": "village",
            "poly": null,
            "longitude": 102.571022,
            "latitude": 53.825382
        },
        "3995": {
            "name": "Большебаяновская",
            "population": 311,
            "type": "village",
            "poly": null,
            "longitude": 102.581902,
            "latitude": 53.903168
        },
        "3996": {
            "name": "Тангуты",
            "population": 451,
            "type": "village",
            "poly": null,
            "longitude": 102.590889,
            "latitude": 53.771774
        },
        "3997": {
            "name": "Целинный",
            "population": 480,
            "type": "village",
            "poly": null,
            "longitude": 102.59343,
            "latitude": 53.641693
        },
        "3998": {
            "name": "Иркутск-45",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 102.6183964,
            "latitude": 53.4223441
        },
        "3999": {
            "name": "Владимир",
            "population": 899,
            "type": "village",
            "poly": null,
            "longitude": 102.654579,
            "latitude": 53.47488
        },
        "4000": {
            "name": "Александровск",
            "population": 497,
            "type": "village",
            "poly": null,
            "longitude": 102.659027,
            "latitude": 53.341831
        },
        "4001": {
            "name": "Мамырь",
            "population": 565,
            "type": "village",
            "poly": null,
            "longitude": 102.659042,
            "latitude": 56.581013
        },
        "4002": {
            "name": "Заречный",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 102.674767,
            "latitude": 53.682514
        },
        "4003": {
            "name": "Ныгда",
            "population": 665,
            "type": "village",
            "poly": null,
            "longitude": 102.6843834,
            "latitude": 53.0170964
        },
        "4004": {
            "name": "Идеал",
            "population": 502,
            "type": "village",
            "poly": null,
            "longitude": 102.693001,
            "latitude": 53.160336
        },
        "4005": {
            "name": "Харёты",
            "population": 990,
            "type": "village",
            "poly": null,
            "longitude": 102.71949,
            "latitude": 53.820587
        },
        "4006": {
            "name": "Невон",
            "population": 2597,
            "type": "village",
            "poly": null,
            "longitude": 102.724205,
            "latitude": 58.054462
        },
        "4007": {
            "name": "Татхал-Онгой",
            "population": 722,
            "type": "village",
            "poly": null,
            "longitude": 102.728485,
            "latitude": 53.695568
        },
        "4008": {
            "name": "Маниловская",
            "population": 400,
            "type": "village",
            "poly": null,
            "longitude": 102.7361196,
            "latitude": 53.4995983
        },
        "4009": {
            "name": "Тарнополь",
            "population": 530,
            "type": "village",
            "poly": null,
            "longitude": 102.768257,
            "latitude": 54.047421
        },
        "4010": {
            "name": "Дальний",
            "population": 627,
            "type": "village",
            "poly": null,
            "longitude": 102.789879,
            "latitude": 57.356705
        },
        "4011": {
            "name": "Тунгуска",
            "population": 332,
            "type": "village",
            "poly": null,
            "longitude": 102.794365,
            "latitude": 52.646187
        },
        "4012": {
            "name": "Нукуты",
            "population": 712,
            "type": "village",
            "poly": [
                [
                    102.7936461,
                    53.7217626
                ],
                [
                    102.7940324,
                    53.723794
                ],
                [
                    102.7948907,
                    53.7253175
                ],
                [
                    102.7995255,
                    53.7262062
                ],
                [
                    102.8042033,
                    53.7277296
                ],
                [
                    102.8061774,
                    53.7268917
                ],
                [
                    102.809911,
                    53.7235909
                ],
                [
                    102.8112843,
                    53.7212547
                ],
                [
                    102.811971,
                    53.7179026
                ],
                [
                    102.8115418,
                    53.7157186
                ],
                [
                    102.8059628,
                    53.7144487
                ],
                [
                    102.8009846,
                    53.7154138
                ],
                [
                    102.7961781,
                    53.7184359
                ],
                [
                    102.7936461,
                    53.7217626
                ]
            ],
            "longitude": 102.804146,
            "latitude": 53.718685
        },
        "4013": {
            "name": "Нены",
            "population": 297,
            "type": "village",
            "poly": null,
            "longitude": 102.808151,
            "latitude": 53.093803
        },
        "4014": {
            "name": "Кеуль",
            "population": 915,
            "type": "village",
            "poly": null,
            "longitude": 102.809959,
            "latitude": 58.434563
        },
        "4015": {
            "name": "Шарагул",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 102.8197244,
            "latitude": 53.947887
        },
        "4016": {
            "name": "Забитуй",
            "population": 1447,
            "type": "village",
            "poly": null,
            "longitude": 102.830383,
            "latitude": 53.277187
        },
        "4017": {
            "name": "Ворот-Онгой",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 102.83075,
            "latitude": 53.66222
        },
        "4018": {
            "name": "Новоленино",
            "population": 927,
            "type": "village",
            "poly": null,
            "longitude": 102.841759,
            "latitude": 53.813335
        },
        "4019": {
            "name": "Парфеново",
            "population": 842,
            "type": "village",
            "poly": null,
            "longitude": 102.846817,
            "latitude": 52.991405
        },
        "4020": {
            "name": "Метляева",
            "population": 242,
            "type": "village",
            "poly": null,
            "longitude": 102.852898,
            "latitude": 54.123158
        },
        "4021": {
            "name": "Могоёнок",
            "population": 495,
            "type": "village",
            "poly": null,
            "longitude": 102.8656509,
            "latitude": 53.3926133
        },
        "4022": {
            "name": "Речушка",
            "population": 1194,
            "type": "village",
            "poly": null,
            "longitude": 102.870552,
            "latitude": 56.530998
        },
        "4023": {
            "name": "Малиновка",
            "population": 492,
            "type": "village",
            "poly": null,
            "longitude": 102.872719,
            "latitude": 53.219189
        },
        "4024": {
            "name": "Лохово",
            "population": 914,
            "type": "village",
            "poly": null,
            "longitude": 102.890854,
            "latitude": 53.053963
        },
        "4025": {
            "name": "Бирит",
            "population": 565,
            "type": "village",
            "poly": null,
            "longitude": 102.902298,
            "latitude": 54.06955
        },
        "4026": {
            "name": "Табарсук",
            "population": 555,
            "type": "village",
            "poly": null,
            "longitude": 102.9099651,
            "latitude": 53.4377725
        },
        "4027": {
            "name": "Алтарик",
            "population": 741,
            "type": "village",
            "poly": null,
            "longitude": 102.923538,
            "latitude": 53.485115
        },
        "4028": {
            "name": "Жмурова",
            "population": 287,
            "type": "village",
            "poly": null,
            "longitude": 102.924294,
            "latitude": 53.133961
        },
        "4029": {
            "name": "Козлова",
            "population": 257,
            "type": "village",
            "poly": null,
            "longitude": 102.934654,
            "latitude": 53.033672
        },
        "4030": {
            "name": "Малая Сухая",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 102.9462133,
            "latitude": 53.4731383
        },
        "4031": {
            "name": "Новогромово",
            "population": 661,
            "type": "village",
            "poly": null,
            "longitude": 102.959656,
            "latitude": 53.180691
        },
        "4032": {
            "name": "Заславская",
            "population": 891,
            "type": "village",
            "poly": null,
            "longitude": 102.968651,
            "latitude": 54.218609
        },
        "4033": {
            "name": "Октябрьский",
            "population": 207,
            "type": "village",
            "poly": null,
            "longitude": 102.981071,
            "latitude": 52.413078
        },
        "4034": {
            "name": "Кумарейка",
            "population": 1072,
            "type": "village",
            "poly": null,
            "longitude": 102.985222,
            "latitude": 54.477516
        },
        "4035": {
            "name": "Шумилово",
            "population": 648,
            "type": "village",
            "poly": null,
            "longitude": 103.010559,
            "latitude": 55.948437
        },
        "4036": {
            "name": "Егоровская",
            "population": 350,
            "type": "village",
            "poly": null,
            "longitude": 103.016266,
            "latitude": 53.303528
        },
        "4037": {
            "name": "Рысево",
            "population": 587,
            "type": "village",
            "poly": null,
            "longitude": 103.018036,
            "latitude": 53.20351
        },
        "4038": {
            "name": "Закулей",
            "population": 796,
            "type": "village",
            "poly": null,
            "longitude": 103.031242,
            "latitude": 53.690289
        },
        "4039": {
            "name": "Верхний Булай",
            "population": 635,
            "type": "village",
            "poly": null,
            "longitude": 103.039993,
            "latitude": 53.032913
        },
        "4040": {
            "name": "Шарагай",
            "population": 551,
            "type": "village",
            "poly": null,
            "longitude": 103.067802,
            "latitude": 54.327625
        },
        "4041": {
            "name": "Коновалово",
            "population": 757,
            "type": "village",
            "poly": null,
            "longitude": 103.070488,
            "latitude": 53.983513
        },
        "4042": {
            "name": "Белобородова",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 103.075027,
            "latitude": 53.220524
        },
        "4043": {
            "name": "Бельск",
            "population": 1175,
            "type": "village",
            "poly": null,
            "longitude": 103.080444,
            "latitude": 52.868198
        },
        "4044": {
            "name": "Аталанка",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 103.085815,
            "latitude": 54.832138
        },
        "4045": {
            "name": "Апхульта",
            "population": 511,
            "type": "village",
            "poly": null,
            "longitude": 103.0910395,
            "latitude": 53.3436653
        },
        "4046": {
            "name": "Каймоновский",
            "population": 432,
            "type": "village",
            "poly": null,
            "longitude": 103.097481,
            "latitude": 56.381199
        },
        "4047": {
            "name": "Бахтай",
            "population": 696,
            "type": "village",
            "poly": null,
            "longitude": 103.107544,
            "latitude": 53.503895
        },
        "4048": {
            "name": "Видим",
            "population": 1116,
            "type": "village",
            "poly": null,
            "longitude": 103.108955,
            "latitude": 56.40934
        },
        "4049": {
            "name": "Чистополянский",
            "population": 545,
            "type": "village",
            "poly": null,
            "longitude": 103.114693,
            "latitude": 56.384834
        },
        "4050": {
            "name": "Мельхитуй",
            "population": 310,
            "type": "village",
            "poly": null,
            "longitude": 103.1258376,
            "latitude": 53.6525542
        },
        "4051": {
            "name": "Нельхай",
            "population": 298,
            "type": "village",
            "poly": null,
            "longitude": 103.1303437,
            "latitude": 53.3576861
        },
        "4052": {
            "name": "Светлолобово",
            "population": 598,
            "type": "village",
            "poly": null,
            "longitude": 103.131607,
            "latitude": 54.283699
        },
        "4053": {
            "name": "Алехино",
            "population": 1186,
            "type": "village",
            "poly": null,
            "longitude": 103.131927,
            "latitude": 53.074924
        },
        "4054": {
            "name": "Игжей",
            "population": 601,
            "type": "village",
            "poly": null,
            "longitude": 103.143242,
            "latitude": 54.021702
        },
        "4055": {
            "name": "Карахун",
            "population": 649,
            "type": "village",
            "poly": null,
            "longitude": 103.158012,
            "latitude": 55.590092
        },
        "4056": {
            "name": "Шахтерский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.1693695,
            "latitude": 53.1523166
        },
        "4057": {
            "name": "Раздолье",
            "population": 1217,
            "type": "village",
            "poly": null,
            "longitude": 103.202187,
            "latitude": 52.44846
        },
        "4058": {
            "name": "Хайта",
            "population": 714,
            "type": "village",
            "poly": null,
            "longitude": 103.2028416,
            "latitude": 52.8111827
        },
        "4059": {
            "name": "Петровка",
            "population": 357,
            "type": "village",
            "poly": null,
            "longitude": 103.203522,
            "latitude": 53.057293
        },
        "4060": {
            "name": "Заморский",
            "population": 416,
            "type": "village",
            "poly": null,
            "longitude": 103.212479,
            "latitude": 57.082741
        },
        "4061": {
            "name": "Худорожкина",
            "population": 282,
            "type": "village",
            "poly": null,
            "longitude": 103.2320823,
            "latitude": 52.9668996
        },
        "4062": {
            "name": "Прибойный",
            "population": 674,
            "type": "village",
            "poly": null,
            "longitude": 103.233376,
            "latitude": 55.634979
        },
        "4063": {
            "name": "Первомайское",
            "population": 760,
            "type": "village",
            "poly": null,
            "longitude": 103.242035,
            "latitude": 53.762451
        },
        "4064": {
            "name": "Тибельти",
            "population": 217,
            "type": "village",
            "poly": [
                [
                    103.2343038,
                    51.7778754
                ],
                [
                    103.2363754,
                    51.7790956
                ],
                [
                    103.2377819,
                    51.7799306
                ],
                [
                    103.2492359,
                    51.7698
                ],
                [
                    103.2511772,
                    51.7685278
                ],
                [
                    103.2554534,
                    51.7661348
                ],
                [
                    103.2592699,
                    51.7627947
                ],
                [
                    103.2607565,
                    51.7603042
                ],
                [
                    103.2608161,
                    51.7586723
                ],
                [
                    103.2614892,
                    51.7576394
                ],
                [
                    103.2628489,
                    51.7559476
                ],
                [
                    103.2649373,
                    51.7549237
                ],
                [
                    103.2670679,
                    51.7547242
                ],
                [
                    103.2689741,
                    51.7548803
                ],
                [
                    103.2708363,
                    51.7555691
                ],
                [
                    103.2719455,
                    51.7567646
                ],
                [
                    103.272104,
                    51.7583217
                ],
                [
                    103.2697964,
                    51.7598053
                ],
                [
                    103.2722922,
                    51.7611661
                ],
                [
                    103.2740848,
                    51.7598666
                ],
                [
                    103.2764023,
                    51.7575861
                ],
                [
                    103.2767886,
                    51.7557959
                ],
                [
                    103.2752931,
                    51.7540854
                ],
                [
                    103.275402,
                    51.751167
                ],
                [
                    103.2738966,
                    51.7474206
                ],
                [
                    103.2735332,
                    51.7466448
                ],
                [
                    103.2661605,
                    51.7492742
                ],
                [
                    103.2597409,
                    51.7529621
                ],
                [
                    103.256461,
                    51.7553569
                ],
                [
                    103.2538259,
                    51.7597643
                ],
                [
                    103.2516434,
                    51.7625731
                ],
                [
                    103.2482657,
                    51.7651212
                ],
                [
                    103.2422608,
                    51.7681618
                ],
                [
                    103.2343038,
                    51.7778754
                ]
            ],
            "longitude": 103.245132,
            "latitude": 51.769886
        },
        "4065": {
            "name": "Аносово",
            "population": 616,
            "type": "village",
            "poly": null,
            "longitude": 103.246239,
            "latitude": 54.651222
        },
        "4066": {
            "name": "Узкий Луг",
            "population": 595,
            "type": "village",
            "poly": null,
            "longitude": 103.250519,
            "latitude": 52.90337
        },
        "4067": {
            "name": "Ключи",
            "population": 139,
            "type": "village",
            "poly": null,
            "longitude": 103.262756,
            "latitude": 54.536774
        },
        "4068": {
            "name": "Тальяны",
            "population": 1161,
            "type": "village",
            "poly": null,
            "longitude": 103.263046,
            "latitude": 52.195301
        },
        "4069": {
            "name": "Мельхитуй",
            "population": 413,
            "type": "village",
            "poly": null,
            "longitude": 103.2647912,
            "latitude": 53.6595148
        },
        "4070": {
            "name": "Зерновое",
            "population": 613,
            "type": "village",
            "poly": null,
            "longitude": 103.267532,
            "latitude": 53.055489
        },
        "4071": {
            "name": "Брусничный",
            "population": 490,
            "type": "village",
            "poly": null,
            "longitude": 103.272614,
            "latitude": 57.271759
        },
        "4072": {
            "name": "Тыргетуй",
            "population": 464,
            "type": "village",
            "poly": null,
            "longitude": 103.2727096,
            "latitude": 53.3515033
        },
        "4073": {
            "name": "Тубинский",
            "population": 1989,
            "type": "village",
            "poly": null,
            "longitude": 103.281677,
            "latitude": 57.640209
        },
        "4074": {
            "name": "Усолье-7",
            "population": null,
            "type": "village",
            "poly": [
                [
                    103.2761119,
                    52.8955015
                ],
                [
                    103.2846269,
                    52.9038202
                ],
                [
                    103.2856075,
                    52.9061557
                ],
                [
                    103.2868482,
                    52.90586
                ],
                [
                    103.2875286,
                    52.9053651
                ],
                [
                    103.2929487,
                    52.8995889
                ],
                [
                    103.2913066,
                    52.8923782
                ],
                [
                    103.2783608,
                    52.8946129
                ],
                [
                    103.2761119,
                    52.8955015
                ]
            ],
            "longitude": 103.2853181,
            "latitude": 52.8971039
        },
        "4075": {
            "name": "Ивановка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.288483,
            "latitude": 52.3385461
        },
        "4076": {
            "name": "Юголок",
            "population": 687,
            "type": "village",
            "poly": null,
            "longitude": 103.2942691,
            "latitude": 54.1850351
        },
        "4077": {
            "name": "Хадахан",
            "population": 1001,
            "type": "village",
            "poly": null,
            "longitude": 103.295738,
            "latitude": 53.552933
        },
        "4078": {
            "name": "Холмушино",
            "population": 446,
            "type": "village",
            "poly": null,
            "longitude": 103.308968,
            "latitude": 52.876358
        },
        "4079": {
            "name": "Лобагай",
            "population": 271,
            "type": "village",
            "poly": null,
            "longitude": 103.328682,
            "latitude": 53.950272
        },
        "4080": {
            "name": "Молька",
            "population": 612,
            "type": "village",
            "poly": [
                [
                    103.3159258,
                    53.8851499
                ],
                [
                    103.3224202,
                    53.8862966
                ],
                [
                    103.3340115,
                    53.889672
                ],
                [
                    103.339629,
                    53.8870234
                ],
                [
                    103.3436846,
                    53.8878632
                ],
                [
                    103.3453013,
                    53.8848753
                ],
                [
                    103.3424515,
                    53.8840839
                ],
                [
                    103.346096,
                    53.8773804
                ],
                [
                    103.341739,
                    53.8735678
                ],
                [
                    103.3391632,
                    53.8731316
                ],
                [
                    103.3301203,
                    53.8748926
                ],
                [
                    103.3237355,
                    53.8772996
                ],
                [
                    103.3197622,
                    53.878495
                ],
                [
                    103.3159258,
                    53.8851499
                ]
            ],
            "longitude": 103.334816,
            "latitude": 53.882797
        },
        "4081": {
            "name": "Балаганка",
            "population": 451,
            "type": "village",
            "poly": null,
            "longitude": 103.338448,
            "latitude": 54.06382
        },
        "4082": {
            "name": "Могой",
            "population": null,
            "type": "village",
            "poly": [
                [
                    103.3402407,
                    52.8265956
                ],
                [
                    103.3404567,
                    52.826706
                ],
                [
                    103.3425828,
                    52.8253636
                ],
                [
                    103.3429606,
                    52.8252457
                ],
                [
                    103.3431517,
                    52.8252005
                ],
                [
                    103.3434672,
                    52.8250249
                ],
                [
                    103.3437828,
                    52.8249144
                ],
                [
                    103.3439988,
                    52.8249044
                ],
                [
                    103.3449871,
                    52.8245732
                ],
                [
                    103.3451615,
                    52.8245546
                ],
                [
                    103.3455549,
                    52.8244446
                ],
                [
                    103.3456959,
                    52.8243701
                ],
                [
                    103.3460877,
                    52.8243338
                ],
                [
                    103.3463419,
                    52.8242138
                ],
                [
                    103.3466648,
                    52.8241394
                ],
                [
                    103.346841,
                    52.8240791
                ],
                [
                    103.3476867,
                    52.8239123
                ],
                [
                    103.3486733,
                    52.8237917
                ],
                [
                    103.3494426,
                    52.8237207
                ],
                [
                    103.3501297,
                    52.8236852
                ],
                [
                    103.3514275,
                    52.8236249
                ],
                [
                    103.3523906,
                    52.8237242
                ],
                [
                    103.353154,
                    52.8237704
                ],
                [
                    103.3533772,
                    52.8237526
                ],
                [
                    103.3536121,
                    52.8237988
                ],
                [
                    103.3538529,
                    52.8238697
                ],
                [
                    103.3547396,
                    52.8239123
                ],
                [
                    103.3555031,
                    52.824001
                ],
                [
                    103.3560316,
                    52.8241252
                ],
                [
                    103.3569007,
                    52.8243168
                ],
                [
                    103.3570945,
                    52.8243026
                ],
                [
                    103.3574939,
                    52.8244694
                ],
                [
                    103.3575865,
                    52.8243488
                ],
                [
                    103.3619384,
                    52.8253927
                ],
                [
                    103.3626858,
                    52.8256135
                ],
                [
                    103.3631011,
                    52.8251719
                ],
                [
                    103.3620962,
                    52.8248307
                ],
                [
                    103.3601279,
                    52.8242886
                ],
                [
                    103.3580599,
                    52.8237969
                ],
                [
                    103.3577398,
                    52.8236908
                ],
                [
                    103.3580676,
                    52.8229952
                ],
                [
                    103.3583483,
                    52.8226026
                ],
                [
                    103.3582343,
                    52.8225924
                ],
                [
                    103.3582426,
                    52.8225121
                ],
                [
                    103.3562494,
                    52.822216
                ],
                [
                    103.3560252,
                    52.8225573
                ],
                [
                    103.3557345,
                    52.822487
                ],
                [
                    103.3555018,
                    52.8229387
                ],
                [
                    103.3553608,
                    52.8229538
                ],
                [
                    103.3552528,
                    52.8230441
                ],
                [
                    103.3544651,
                    52.8229442
                ],
                [
                    103.3537315,
                    52.8229558
                ],
                [
                    103.3534513,
                    52.8229603
                ],
                [
                    103.3531433,
                    52.8230893
                ],
                [
                    103.3529088,
                    52.8229689
                ],
                [
                    103.3493801,
                    52.8230318
                ],
                [
                    103.3489825,
                    52.8230943
                ],
                [
                    103.3486669,
                    52.8231746
                ],
                [
                    103.3480149,
                    52.8231068
                ],
                [
                    103.3471305,
                    52.8228986
                ],
                [
                    103.3465761,
                    52.8228229
                ],
                [
                    103.3469727,
                    52.8223766
                ],
                [
                    103.3464744,
                    52.8221859
                ],
                [
                    103.3459799,
                    52.8226502
                ],
                [
                    103.3456678,
                    52.8225512
                ],
                [
                    103.3449316,
                    52.8223288
                ],
                [
                    103.3443621,
                    52.8220952
                ],
                [
                    103.3438793,
                    52.8222171
                ],
                [
                    103.3435377,
                    52.822744
                ],
                [
                    103.3437662,
                    52.8228669
                ],
                [
                    103.3436167,
                    52.823168
                ],
                [
                    103.34414,
                    52.8232533
                ],
                [
                    103.3440485,
                    52.8233887
                ],
                [
                    103.34414,
                    52.8234088
                ],
                [
                    103.3442562,
                    52.8232784
                ],
                [
                    103.3445303,
                    52.8233286
                ],
                [
                    103.3447961,
                    52.8231429
                ],
                [
                    103.3450369,
                    52.8232282
                ],
                [
                    103.3450867,
                    52.8232985
                ],
                [
                    103.3449705,
                    52.8234139
                ],
                [
                    103.3443683,
                    52.8240663
                ],
                [
                    103.3437538,
                    52.8242545
                ],
                [
                    103.3434548,
                    52.8244578
                ],
                [
                    103.3431849,
                    52.8247012
                ],
                [
                    103.342645,
                    52.8250675
                ],
                [
                    103.3422214,
                    52.8248768
                ],
                [
                    103.3418395,
                    52.8251102
                ],
                [
                    103.3417232,
                    52.8251779
                ],
                [
                    103.3413204,
                    52.8252306
                ],
                [
                    103.3405356,
                    52.8258554
                ],
                [
                    103.3407183,
                    52.8259608
                ],
                [
                    103.3405314,
                    52.8261916
                ],
                [
                    103.3405396,
                    52.8263321
                ],
                [
                    103.3402407,
                    52.8265956
                ]
            ],
            "longitude": 103.3507302,
            "latitude": 52.8232972
        },
        "4083": {
            "name": "Ангарский",
            "population": 564,
            "type": "village",
            "poly": null,
            "longitude": 103.360718,
            "latitude": 53.462643
        },
        "4084": {
            "name": "Кижа",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 103.364227,
            "latitude": 54.126362
        },
        "4085": {
            "name": "Подволочное",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 103.367096,
            "latitude": 55.206703
        },
        "4086": {
            "name": "Податовская",
            "population": 194,
            "type": "village",
            "poly": [
                [
                    103.3550229,
                    53.8751864
                ],
                [
                    103.3559272,
                    53.8769796
                ],
                [
                    103.3577357,
                    53.8778842
                ],
                [
                    103.356119,
                    53.8802265
                ],
                [
                    103.3609965,
                    53.8813088
                ],
                [
                    103.3627778,
                    53.8835055
                ],
                [
                    103.3667786,
                    53.8837639
                ],
                [
                    103.3704505,
                    53.8807434
                ],
                [
                    103.371848,
                    53.8805011
                ],
                [
                    103.3754378,
                    53.8817449
                ],
                [
                    103.3753556,
                    53.8830209
                ],
                [
                    103.3761503,
                    53.8834409
                ],
                [
                    103.3769997,
                    53.8831017
                ],
                [
                    103.3848095,
                    53.8861381
                ],
                [
                    103.3858234,
                    53.885589
                ],
                [
                    103.3826173,
                    53.8832955
                ],
                [
                    103.3778492,
                    53.8812926
                ],
                [
                    103.3765613,
                    53.8802911
                ],
                [
                    103.3757392,
                    53.8790473
                ],
                [
                    103.3711356,
                    53.8774481
                ],
                [
                    103.3674362,
                    53.8763819
                ],
                [
                    103.3659017,
                    53.8763173
                ],
                [
                    103.3590785,
                    53.8747018
                ],
                [
                    103.3565574,
                    53.8745725
                ],
                [
                    103.3550229,
                    53.8751864
                ]
            ],
            "longitude": 103.367653,
            "latitude": 53.878651
        },
        "4087": {
            "name": "Каменно-Ангарск",
            "population": 341,
            "type": "village",
            "poly": null,
            "longitude": 103.371658,
            "latitude": 53.283585
        },
        "4088": {
            "name": "Каменка",
            "population": 855,
            "type": "village",
            "poly": null,
            "longitude": 103.372589,
            "latitude": 53.167347
        },
        "4089": {
            "name": "Малышевка",
            "population": 772,
            "type": "village",
            "poly": null,
            "longitude": 103.38813,
            "latitude": 53.734394
        },
        "4090": {
            "name": "Сосновка",
            "population": 1718,
            "type": "village",
            "poly": null,
            "longitude": 103.391724,
            "latitude": 52.820263
        },
        "4091": {
            "name": "Березовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.3951641,
            "latitude": 52.9850576
        },
        "4092": {
            "name": "Середкина",
            "population": 834,
            "type": "village",
            "poly": null,
            "longitude": 103.404587,
            "latitude": 53.439339
        },
        "4093": {
            "name": "Кочерикова",
            "population": 347,
            "type": "village",
            "poly": null,
            "longitude": 103.411964,
            "latitude": 52.940857
        },
        "4094": {
            "name": "Казачье",
            "population": 1123,
            "type": "village",
            "poly": null,
            "longitude": 103.432106,
            "latitude": 53.334488
        },
        "4095": {
            "name": "Быстрая",
            "population": 426,
            "type": "village",
            "poly": [
                [
                    103.4230295,
                    51.742505
                ],
                [
                    103.4250886,
                    51.7428406
                ],
                [
                    103.4266058,
                    51.7415656
                ],
                [
                    103.4332166,
                    51.7440483
                ],
                [
                    103.4406943,
                    51.7436458
                ],
                [
                    103.4451376,
                    51.7443839
                ],
                [
                    103.4488223,
                    51.7429748
                ],
                [
                    103.4492558,
                    51.7416326
                ],
                [
                    103.4450291,
                    51.7415656
                ],
                [
                    103.4470997,
                    51.7403769
                ],
                [
                    103.4431059,
                    51.7367544
                ],
                [
                    103.4390687,
                    51.7358612
                ],
                [
                    103.4366845,
                    51.7377404
                ],
                [
                    103.4380934,
                    51.7387469
                ],
                [
                    103.4339752,
                    51.7388813
                ],
                [
                    103.4318076,
                    51.7380088
                ],
                [
                    103.4305073,
                    51.7356599
                ],
                [
                    103.4328915,
                    51.7336464
                ],
                [
                    103.4326747,
                    51.7316999
                ],
                [
                    103.4300738,
                    51.7310288
                ],
                [
                    103.4279063,
                    51.7326396
                ],
                [
                    103.425197,
                    51.7358612
                ],
                [
                    103.4247281,
                    51.7371441
                ],
                [
                    103.4230295,
                    51.742505
                ]
            ],
            "longitude": 103.437126,
            "latitude": 51.741268
        },
        "4096": {
            "name": "Рассвет",
            "population": 339,
            "type": "village",
            "poly": null,
            "longitude": 103.4412724,
            "latitude": 53.5617815
        },
        "4097": {
            "name": "Соцгородок",
            "population": 644,
            "type": "village",
            "poly": null,
            "longitude": 103.457893,
            "latitude": 56.462746
        },
        "4098": {
            "name": "Тайтурка",
            "population": 4951,
            "type": "village",
            "poly": null,
            "longitude": 103.465416,
            "latitude": 52.870564
        },
        "4099": {
            "name": "Култук",
            "population": 572,
            "type": "village",
            "poly": null,
            "longitude": 103.473274,
            "latitude": 52.567574
        },
        "4100": {
            "name": "Радищев",
            "population": 1004,
            "type": "village",
            "poly": null,
            "longitude": 103.48951,
            "latitude": 57.2262
        },
        "4101": {
            "name": "Буреть",
            "population": 688,
            "type": "village",
            "poly": null,
            "longitude": 103.506523,
            "latitude": 52.968006
        },
        "4102": {
            "name": "Буреть",
            "population": 1075,
            "type": "village",
            "poly": null,
            "longitude": 103.5085272,
            "latitude": 52.9911848
        },
        "4103": {
            "name": "Мальта",
            "population": 2817,
            "type": "village",
            "poly": null,
            "longitude": 103.516983,
            "latitude": 52.83741
        },
        "4104": {
            "name": "Средняя Муя",
            "population": 1036,
            "type": "village",
            "poly": null,
            "longitude": 103.520622,
            "latitude": 54.333561
        },
        "4105": {
            "name": "Морозова",
            "population": 273,
            "type": "village",
            "poly": null,
            "longitude": 103.521011,
            "latitude": 53.197083
        },
        "4106": {
            "name": "Новожилкино",
            "population": 1596,
            "type": "village",
            "poly": null,
            "longitude": 103.553528,
            "latitude": 52.556091
        },
        "4107": {
            "name": "Новомальтинск",
            "population": 1445,
            "type": "village",
            "poly": null,
            "longitude": 103.55442,
            "latitude": 52.869415
        },
        "4108": {
            "name": "Унгин",
            "population": 1080,
            "type": "village",
            "poly": null,
            "longitude": 103.5767845,
            "latitude": 53.6953138
        },
        "4109": {
            "name": "Большежилкина",
            "population": 768,
            "type": "village",
            "poly": null,
            "longitude": 103.589752,
            "latitude": 52.540329
        },
        "4110": {
            "name": "Березняки",
            "population": 1149,
            "type": "village",
            "poly": null,
            "longitude": 103.595596,
            "latitude": 56.940708
        },
        "4111": {
            "name": "Новая Уда",
            "population": 1058,
            "type": "village",
            "poly": null,
            "longitude": 103.6126523,
            "latitude": 54.0290334
        },
        "4112": {
            "name": "Усть-Алтан",
            "population": 801,
            "type": "village",
            "poly": null,
            "longitude": 103.6216023,
            "latitude": 53.5236376
        },
        "4113": {
            "name": "Хандагай",
            "population": 229,
            "type": "village",
            "poly": null,
            "longitude": 103.6241356,
            "latitude": 53.166532
        },
        "4114": {
            "name": "Игирма",
            "population": 834,
            "type": "village",
            "poly": null,
            "longitude": 103.632339,
            "latitude": 56.982262
        },
        "4115": {
            "name": "Савватеевка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    103.6274683,
                    52.3384219
                ],
                [
                    103.6275273,
                    52.3389149
                ],
                [
                    103.629948,
                    52.338482
                ],
                [
                    103.6320538,
                    52.339456
                ],
                [
                    103.631365,
                    52.3402856
                ],
                [
                    103.6318373,
                    52.3413317
                ],
                [
                    103.6354224,
                    52.3420562
                ],
                [
                    103.6491158,
                    52.3402878
                ],
                [
                    103.6605718,
                    52.3350721
                ],
                [
                    103.656557,
                    52.3216015
                ],
                [
                    103.6435681,
                    52.3187626
                ],
                [
                    103.6306578,
                    52.3224195
                ],
                [
                    103.6302463,
                    52.3299327
                ],
                [
                    103.6361234,
                    52.332483
                ],
                [
                    103.6366007,
                    52.333321
                ],
                [
                    103.6365914,
                    52.333466
                ],
                [
                    103.636461,
                    52.3337576
                ],
                [
                    103.636432,
                    52.3346461
                ],
                [
                    103.6367701,
                    52.3357488
                ],
                [
                    103.637702,
                    52.3383257
                ],
                [
                    103.6366196,
                    52.3393959
                ],
                [
                    103.6355569,
                    52.3396123
                ],
                [
                    103.631424,
                    52.3382776
                ],
                [
                    103.6298299,
                    52.3377725
                ],
                [
                    103.6294953,
                    52.3369669
                ],
                [
                    103.6285507,
                    52.337027
                ],
                [
                    103.6274683,
                    52.3384219
                ]
            ],
            "longitude": 103.641243,
            "latitude": 52.331409
        },
        "4116": {
            "name": "Янгель",
            "population": 1037,
            "type": "village",
            "poly": null,
            "longitude": 103.649101,
            "latitude": 57.079296
        },
        "4117": {
            "name": "Воробьевка",
            "population": 203,
            "type": "village",
            "poly": null,
            "longitude": 103.671509,
            "latitude": 53.003517
        },
        "4118": {
            "name": "Большая Елань",
            "population": 1542,
            "type": "village",
            "poly": null,
            "longitude": 103.673737,
            "latitude": 52.575985
        },
        "4119": {
            "name": "Новоилимск",
            "population": 863,
            "type": "village",
            "poly": null,
            "longitude": 103.683479,
            "latitude": 57.296459
        },
        "4120": {
            "name": "Новая Ида",
            "population": 250,
            "type": "village",
            "poly": null,
            "longitude": 103.688416,
            "latitude": 53.176395
        },
        "4121": {
            "name": "Олонки",
            "population": 2277,
            "type": "village",
            "poly": null,
            "longitude": 103.703964,
            "latitude": 52.899155
        },
        "4122": {
            "name": "Чичкова",
            "population": 279,
            "type": "village",
            "poly": null,
            "longitude": 103.708954,
            "latitude": 54.187416
        },
        "4123": {
            "name": "Култук",
            "population": 3683,
            "type": "village",
            "poly": [
                [
                    103.6499412,
                    51.7276262
                ],
                [
                    103.6512426,
                    51.7309847
                ],
                [
                    103.6680522,
                    51.7284322
                ],
                [
                    103.6908265,
                    51.7274918
                ],
                [
                    103.698201,
                    51.7309847
                ],
                [
                    103.696032,
                    51.7371638
                ],
                [
                    103.6971165,
                    51.7430734
                ],
                [
                    103.7051417,
                    51.7437449
                ],
                [
                    103.7101304,
                    51.7350146
                ],
                [
                    103.7166373,
                    51.7350818
                ],
                [
                    103.732037,
                    51.732328
                ],
                [
                    103.7319286,
                    51.730313
                ],
                [
                    103.7195653,
                    51.7269543
                ],
                [
                    103.7178302,
                    51.7243345
                ],
                [
                    103.7090459,
                    51.7178178
                ],
                [
                    103.7012375,
                    51.7181537
                ],
                [
                    103.6905011,
                    51.7080073
                ],
                [
                    103.6757521,
                    51.7074025
                ],
                [
                    103.6587256,
                    51.7224535
                ],
                [
                    103.6499412,
                    51.7276262
                ]
            ],
            "longitude": 103.7115374,
            "latitude": 51.725563
        },
        "4124": {
            "name": "Бильчир",
            "population": 1167,
            "type": "village",
            "poly": null,
            "longitude": 103.7136642,
            "latitude": 53.5632542
        },
        "4125": {
            "name": "Усть-Тараса",
            "population": 733,
            "type": "village",
            "poly": null,
            "longitude": 103.721252,
            "latitude": 53.17857
        },
        "4126": {
            "name": "Приморский",
            "population": 1704,
            "type": "village",
            "poly": null,
            "longitude": 103.7232724,
            "latitude": 53.5855437
        },
        "4127": {
            "name": "Новоодинск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.723587,
            "latitude": 52.308372
        },
        "4128": {
            "name": "Одинск",
            "population": null,
            "type": "village",
            "poly": [
                [
                    103.7091515,
                    52.4530089
                ],
                [
                    103.7106615,
                    52.4539439
                ],
                [
                    103.7119135,
                    52.4551378
                ],
                [
                    103.7129815,
                    52.4558469
                ],
                [
                    103.7154455,
                    52.4568429
                ],
                [
                    103.7165285,
                    52.4570369
                ],
                [
                    103.7178795,
                    52.4576549
                ],
                [
                    103.7189165,
                    52.4575289
                ],
                [
                    103.7204354,
                    52.4586619
                ],
                [
                    103.7201525,
                    52.4593609
                ],
                [
                    103.7202065,
                    52.4599898
                ],
                [
                    103.7196265,
                    52.4611459
                ],
                [
                    103.7199234,
                    52.4621989
                ],
                [
                    103.7205805,
                    52.4629269
                ],
                [
                    103.7206715,
                    52.4637468
                ],
                [
                    103.7209084,
                    52.4640139
                ],
                [
                    103.7210375,
                    52.4645709
                ],
                [
                    103.7215415,
                    52.4646519
                ],
                [
                    103.7239525,
                    52.4642509
                ],
                [
                    103.7245935,
                    52.4644869
                ],
                [
                    103.7249055,
                    52.4646359
                ],
                [
                    103.7250055,
                    52.4652239
                ],
                [
                    103.7263555,
                    52.4654979
                ],
                [
                    103.7258135,
                    52.4658459
                ],
                [
                    103.7263705,
                    52.4660899
                ],
                [
                    103.7251575,
                    52.4664899
                ],
                [
                    103.7237844,
                    52.4654069
                ],
                [
                    103.7231665,
                    52.4654298
                ],
                [
                    103.7229145,
                    52.4657199
                ],
                [
                    103.7217395,
                    52.4663409
                ],
                [
                    103.7212745,
                    52.4670739
                ],
                [
                    103.7223884,
                    52.4673559
                ],
                [
                    103.7231055,
                    52.4679589
                ],
                [
                    103.7234565,
                    52.4680309
                ],
                [
                    103.7254785,
                    52.4667649
                ],
                [
                    103.7273325,
                    52.4670239
                ],
                [
                    103.7278055,
                    52.4662539
                ],
                [
                    103.7291095,
                    52.4664099
                ],
                [
                    103.7310705,
                    52.4653109
                ],
                [
                    103.7299035,
                    52.4650059
                ],
                [
                    103.7306665,
                    52.4646099
                ],
                [
                    103.7317035,
                    52.4647929
                ],
                [
                    103.7327335,
                    52.4640069
                ],
                [
                    103.7310855,
                    52.4633129
                ],
                [
                    103.7299874,
                    52.4641939
                ],
                [
                    103.7304525,
                    52.4645179
                ],
                [
                    103.7296135,
                    52.4648799
                ],
                [
                    103.7290795,
                    52.4647429
                ],
                [
                    103.7273395,
                    52.4642509
                ],
                [
                    103.7275305,
                    52.4638809
                ],
                [
                    103.7271035,
                    52.4637549
                ],
                [
                    103.7297585,
                    52.4616879
                ],
                [
                    103.7285605,
                    52.4608709
                ],
                [
                    103.7289035,
                    52.4602189
                ],
                [
                    103.7262025,
                    52.4587229
                ],
                [
                    103.7241355,
                    52.4585819
                ],
                [
                    103.7241735,
                    52.4574649
                ],
                [
                    103.7222895,
                    52.4562249
                ],
                [
                    103.7214805,
                    52.4565829
                ],
                [
                    103.7204885,
                    52.4565759
                ],
                [
                    103.7191765,
                    52.4571289
                ],
                [
                    103.7186425,
                    52.4567439
                ],
                [
                    103.7145755,
                    52.4551219
                ],
                [
                    103.7138815,
                    52.4557059
                ],
                [
                    103.7127595,
                    52.4550189
                ],
                [
                    103.7119205,
                    52.4540619
                ],
                [
                    103.7149345,
                    52.4522309
                ],
                [
                    103.7150485,
                    52.4518229
                ],
                [
                    103.7142554,
                    52.4516469
                ],
                [
                    103.7138435,
                    52.4518229
                ],
                [
                    103.7132945,
                    52.4519098
                ],
                [
                    103.7131415,
                    52.4517349
                ],
                [
                    103.7134385,
                    52.4511698
                ],
                [
                    103.7125384,
                    52.4508159
                ],
                [
                    103.7120884,
                    52.4512159
                ],
                [
                    103.7122794,
                    52.4513339
                ],
                [
                    103.7091515,
                    52.4530089
                ]
            ],
            "longitude": 103.725082,
            "latitude": 52.463116
        },
        "4129": {
            "name": "Тельма",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 103.7300028,
            "latitude": 52.6688942
        },
        "4130": {
            "name": "Ново-Ленино",
            "population": 1044,
            "type": "village",
            "poly": null,
            "longitude": 103.739332,
            "latitude": 53.6545382
        },
        "4131": {
            "name": "Железнодорожный",
            "population": 1480,
            "type": "village",
            "poly": null,
            "longitude": 103.7504844,
            "latitude": 52.6739651
        },
        "4132": {
            "name": "Рудногорск",
            "population": 3317,
            "type": "village",
            "poly": null,
            "longitude": 103.750557,
            "latitude": 57.268295
        },
        "4133": {
            "name": "Ангасолка",
            "population": 663,
            "type": "village",
            "poly": null,
            "longitude": 103.751709,
            "latitude": 51.750439
        },
        "4134": {
            "name": "Сухой Ручей",
            "population": 296,
            "type": "village",
            "poly": null,
            "longitude": 103.755997,
            "latitude": 51.642773
        },
        "4135": {
            "name": "Тараса",
            "population": 1222,
            "type": "village",
            "poly": null,
            "longitude": 103.776764,
            "latitude": 53.08847
        },
        "4136": {
            "name": "Ирхидей",
            "population": 730,
            "type": "village",
            "poly": null,
            "longitude": 103.802948,
            "latitude": 53.433506
        },
        "4137": {
            "name": "Майская",
            "population": 945,
            "type": "village",
            "poly": null,
            "longitude": 103.8058811,
            "latitude": 53.4136424
        },
        "4138": {
            "name": "Шаманка",
            "population": 984,
            "type": "village",
            "poly": null,
            "longitude": 103.8238712,
            "latitude": 52.0714259
        },
        "4139": {
            "name": "Биликтуй",
            "population": 769,
            "type": "village",
            "poly": null,
            "longitude": 103.8259013,
            "latitude": 52.6025688
        },
        "4140": {
            "name": "Кутанка",
            "population": 348,
            "type": "village",
            "poly": null,
            "longitude": 103.8362937,
            "latitude": 53.6354737
        },
        "4141": {
            "name": "Обуса",
            "population": 821,
            "type": "village",
            "poly": null,
            "longitude": 103.8375534,
            "latitude": 53.7216452
        },
        "4142": {
            "name": "Александровское",
            "population": 1088,
            "type": "village",
            "poly": null,
            "longitude": 103.838371,
            "latitude": 52.793709
        },
        "4143": {
            "name": "Заглик",
            "population": 262,
            "type": "village",
            "poly": null,
            "longitude": 103.865021,
            "latitude": 53.40028
        },
        "4144": {
            "name": "Харатирген",
            "population": 517,
            "type": "village",
            "poly": null,
            "longitude": 103.874062,
            "latitude": 53.153706
        },
        "4145": {
            "name": "Харай",
            "population": 427,
            "type": "village",
            "poly": null,
            "longitude": 103.8794668,
            "latitude": 53.4010203
        },
        "4146": {
            "name": "Мороза",
            "population": 190,
            "type": "village",
            "poly": null,
            "longitude": 103.8871853,
            "latitude": 53.3774094
        },
        "4147": {
            "name": "Моты",
            "population": 441,
            "type": "village",
            "poly": [
                [
                    103.876868,
                    52.0765038
                ],
                [
                    103.8788246,
                    52.0765224
                ],
                [
                    103.8844773,
                    52.0760188
                ],
                [
                    103.8890103,
                    52.0760901
                ],
                [
                    103.892006,
                    52.0765534
                ],
                [
                    103.8952287,
                    52.0777828
                ],
                [
                    103.896838,
                    52.0786459
                ],
                [
                    103.8975731,
                    52.0785363
                ],
                [
                    103.8993583,
                    52.0817614
                ],
                [
                    103.9012015,
                    52.0873659
                ],
                [
                    103.9004982,
                    52.0880921
                ],
                [
                    103.8995733,
                    52.0912109
                ],
                [
                    103.8982888,
                    52.0922655
                ],
                [
                    103.9010186,
                    52.0967616
                ],
                [
                    103.9085797,
                    52.0993041
                ],
                [
                    103.9107286,
                    52.0883999
                ],
                [
                    103.910649,
                    52.0747537
                ],
                [
                    103.9069083,
                    52.072161
                ],
                [
                    103.9010982,
                    52.0726502
                ],
                [
                    103.8904636,
                    52.0743317
                ],
                [
                    103.8788433,
                    52.0723016
                ],
                [
                    103.8775393,
                    52.0740007
                ],
                [
                    103.876868,
                    52.0765038
                ]
            ],
            "longitude": 103.8999355,
            "latitude": 52.0771095
        },
        "4148": {
            "name": "Подкаменная",
            "population": 691,
            "type": "village",
            "poly": null,
            "longitude": 103.907631,
            "latitude": 51.966953
        },
        "4149": {
            "name": "Лузгина",
            "population": 778,
            "type": "village",
            "poly": null,
            "longitude": 103.9115977,
            "latitude": 53.370158
        },
        "4150": {
            "name": "Хохорск",
            "population": 524,
            "type": "village",
            "poly": null,
            "longitude": 103.933266,
            "latitude": 53.162514
        },
        "4151": {
            "name": "Суворовский",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 103.942688,
            "latitude": 56.497715
        },
        "4152": {
            "name": "Введенщина",
            "population": 1275,
            "type": "village",
            "poly": null,
            "longitude": 103.944534,
            "latitude": 52.206264
        },
        "4153": {
            "name": "Чистые Ключи",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.9486557,
            "latitude": 52.1797733
        },
        "4154": {
            "name": "Мольта",
            "population": 506,
            "type": "village",
            "poly": null,
            "longitude": 103.953751,
            "latitude": 53.437878
        },
        "4155": {
            "name": "Зорино-Быково",
            "population": 226,
            "type": "village",
            "poly": null,
            "longitude": 103.957123,
            "latitude": 52.718857
        },
        "4156": {
            "name": "Шестаково",
            "population": 673,
            "type": "village",
            "poly": null,
            "longitude": 103.962311,
            "latitude": 56.49424
        },
        "4157": {
            "name": "Ижилха",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 103.962669,
            "latitude": 53.156338
        },
        "4158": {
            "name": "Хокта",
            "population": 378,
            "type": "village",
            "poly": null,
            "longitude": 103.9766248,
            "latitude": 53.4664392
        },
        "4159": {
            "name": "Усть-Балей",
            "population": 306,
            "type": "village",
            "poly": null,
            "longitude": 103.99173,
            "latitude": 52.630695
        },
        "4160": {
            "name": "Русские Янгуты",
            "population": 740,
            "type": "village",
            "poly": null,
            "longitude": 103.9925271,
            "latitude": 53.3462093
        },
        "4161": {
            "name": "Горохово",
            "population": 736,
            "type": "village",
            "poly": [
                [
                    103.9962805,
                    52.7933908
                ],
                [
                    104.0001325,
                    52.8012662
                ],
                [
                    104.0012316,
                    52.8033303
                ],
                [
                    104.0055481,
                    52.8045568
                ],
                [
                    104.0135619,
                    52.7998441
                ],
                [
                    104.0130696,
                    52.790897
                ],
                [
                    104.0027856,
                    52.7839331
                ],
                [
                    103.9968231,
                    52.7846775
                ],
                [
                    103.9962805,
                    52.7933908
                ]
            ],
            "longitude": 104.009148,
            "latitude": 52.794445
        },
        "4162": {
            "name": "Онгой",
            "population": 388,
            "type": "village",
            "poly": null,
            "longitude": 104.031771,
            "latitude": 53.5125128
        },
        "4163": {
            "name": "Баруй",
            "population": 271,
            "type": "village",
            "poly": null,
            "longitude": 104.052505,
            "latitude": 52.826271
        },
        "4164": {
            "name": "Зуй",
            "population": 310,
            "type": "village",
            "poly": [
                [
                    104.0413272,
                    52.4574156
                ],
                [
                    104.0432965,
                    52.4595489
                ],
                [
                    104.0493866,
                    52.4605266
                ],
                [
                    104.0550027,
                    52.4574823
                ],
                [
                    104.0572272,
                    52.4541711
                ],
                [
                    104.0648126,
                    52.4509263
                ],
                [
                    104.0627704,
                    52.4492594
                ],
                [
                    104.0576284,
                    52.449615
                ],
                [
                    104.0484749,
                    52.4517931
                ],
                [
                    104.0423483,
                    52.4555934
                ],
                [
                    104.0413272,
                    52.4574156
                ]
            ],
            "longitude": 104.052849,
            "latitude": 52.454632
        },
        "4165": {
            "name": "Малая Еланка",
            "population": 774,
            "type": "village",
            "poly": null,
            "longitude": 104.055283,
            "latitude": 52.36591
        },
        "4166": {
            "name": "Грязнушка",
            "population": 395,
            "type": "village",
            "poly": null,
            "longitude": 104.0554461,
            "latitude": 53.3215754
        },
        "4167": {
            "name": "Утулик",
            "population": 964,
            "type": "village",
            "poly": [
                [
                    104.0474094,
                    51.5343666
                ],
                [
                    104.0474094,
                    51.5375699
                ],
                [
                    104.0477527,
                    51.5412001
                ],
                [
                    104.0489543,
                    51.545257
                ],
                [
                    104.0492976,
                    51.5474988
                ],
                [
                    104.050156,
                    51.5492067
                ],
                [
                    104.0523876,
                    51.5517686
                ],
                [
                    104.0575374,
                    51.5488865
                ],
                [
                    104.0601123,
                    51.5498472
                ],
                [
                    104.0635455,
                    51.5498472
                ],
                [
                    104.0669788,
                    51.5483528
                ],
                [
                    104.0695537,
                    51.5483528
                ],
                [
                    104.0738452,
                    51.5474988
                ],
                [
                    104.0729869,
                    51.546111
                ],
                [
                    104.0757335,
                    51.5447232
                ],
                [
                    104.0721286,
                    51.5441894
                ],
                [
                    104.0685237,
                    51.5444029
                ],
                [
                    104.0649188,
                    51.5442962
                ],
                [
                    104.0633739,
                    51.5421609
                ],
                [
                    104.0599407,
                    51.5405595
                ],
                [
                    104.0573657,
                    51.5403459
                ],
                [
                    104.0558208,
                    51.5406662
                ],
                [
                    104.0559924,
                    51.5384241
                ],
                [
                    104.0625156,
                    51.5402392
                ],
                [
                    104.0657771,
                    51.5382105
                ],
                [
                    104.0570224,
                    51.5355412
                ],
                [
                    104.0535892,
                    51.5368225
                ],
                [
                    104.0513576,
                    51.5372496
                ],
                [
                    104.0504993,
                    51.5356479
                ],
                [
                    104.0503276,
                    51.5338327
                ],
                [
                    104.0474094,
                    51.5343666
                ]
            ],
            "longitude": 104.056648,
            "latitude": 51.545807
        },
        "4168": {
            "name": "Баклаши",
            "population": 3730,
            "type": "village",
            "poly": null,
            "longitude": 104.057533,
            "latitude": 52.232819
        },
        "4169": {
            "name": "Олха",
            "population": 1744,
            "type": "village",
            "poly": null,
            "longitude": 104.111282,
            "latitude": 52.162579
        },
        "4170": {
            "name": "Максимовщина",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.121521,
            "latitude": 52.274918
        },
        "4171": {
            "name": "Укыр",
            "population": 562,
            "type": "village",
            "poly": null,
            "longitude": 104.140984,
            "latitude": 53.142639
        },
        "4172": {
            "name": "Смоленщина",
            "population": 3214,
            "type": "village",
            "poly": [
                [
                    104.0950365,
                    52.253303
                ],
                [
                    104.1074349,
                    52.2635801
                ],
                [
                    104.1320766,
                    52.264569
                ],
                [
                    104.1659085,
                    52.2603041
                ],
                [
                    104.1695442,
                    52.2553587
                ],
                [
                    104.1558094,
                    52.233345
                ],
                [
                    104.139572,
                    52.2196444
                ],
                [
                    104.1346446,
                    52.2181568
                ],
                [
                    104.1331512,
                    52.2187147
                ],
                [
                    104.1352322,
                    52.21937
                ],
                [
                    104.1368953,
                    52.2201277
                ],
                [
                    104.1375581,
                    52.2210341
                ],
                [
                    104.1366881,
                    52.221132
                ],
                [
                    104.1369308,
                    52.2215272
                ],
                [
                    104.1369012,
                    52.2235793
                ],
                [
                    104.1365934,
                    52.2255115
                ],
                [
                    104.1364277,
                    52.2270631
                ],
                [
                    104.1361792,
                    52.2272299
                ],
                [
                    104.1339894,
                    52.227422
                ],
                [
                    104.1329656,
                    52.2274619
                ],
                [
                    104.1318056,
                    52.2278606
                ],
                [
                    104.1303216,
                    52.2280953
                ],
                [
                    104.1300472,
                    52.2281575
                ],
                [
                    104.1297817,
                    52.2281377
                ],
                [
                    104.1294915,
                    52.2281393
                ],
                [
                    104.1288639,
                    52.2283368
                ],
                [
                    104.1285439,
                    52.2285434
                ],
                [
                    104.1285463,
                    52.2286361
                ],
                [
                    104.1286208,
                    52.2288002
                ],
                [
                    104.1289408,
                    52.2289112
                ],
                [
                    104.1291268,
                    52.2289871
                ],
                [
                    104.1291665,
                    52.2291224
                ],
                [
                    104.1290474,
                    52.2293715
                ],
                [
                    104.1285042,
                    52.230075
                ],
                [
                    104.125944,
                    52.2302313
                ],
                [
                    104.1243202,
                    52.2304105
                ],
                [
                    104.1240411,
                    52.2304086
                ],
                [
                    104.1230861,
                    52.2305397
                ],
                [
                    104.1237373,
                    52.2315022
                ],
                [
                    104.123811,
                    52.2317017
                ],
                [
                    104.1238071,
                    52.2318417
                ],
                [
                    104.1236947,
                    52.2319723
                ],
                [
                    104.1235009,
                    52.2320459
                ],
                [
                    104.122528,
                    52.2323308
                ],
                [
                    104.1219853,
                    52.2325302
                ],
                [
                    104.1211869,
                    52.2325729
                ],
                [
                    104.1205163,
                    52.2327604
                ],
                [
                    104.1202992,
                    52.2326963
                ],
                [
                    104.1172449,
                    52.2331284
                ],
                [
                    104.1175174,
                    52.2344563
                ],
                [
                    104.1176531,
                    52.2347916
                ],
                [
                    104.1176627,
                    52.2352071
                ],
                [
                    104.1175077,
                    52.2359993
                ],
                [
                    104.117624,
                    52.236842
                ],
                [
                    104.1172703,
                    52.2379932
                ],
                [
                    104.1166792,
                    52.2389368
                ],
                [
                    104.1158458,
                    52.2402422
                ],
                [
                    104.1103514,
                    52.2471991
                ],
                [
                    104.1088931,
                    52.2469974
                ],
                [
                    104.1088688,
                    52.2467897
                ],
                [
                    104.1092661,
                    52.2467126
                ],
                [
                    104.1094406,
                    52.2460155
                ],
                [
                    104.1088058,
                    52.2446123
                ],
                [
                    104.1080016,
                    52.2445441
                ],
                [
                    104.1082002,
                    52.2451285
                ],
                [
                    104.1056468,
                    52.244731
                ],
                [
                    104.1055112,
                    52.2448051
                ],
                [
                    104.1047698,
                    52.2446805
                ],
                [
                    104.1042369,
                    52.2451107
                ],
                [
                    104.1040237,
                    52.2451255
                ],
                [
                    104.1038008,
                    52.2450781
                ],
                [
                    104.1035392,
                    52.2448645
                ],
                [
                    104.1031564,
                    52.2443898
                ],
                [
                    104.1020905,
                    52.2438024
                ],
                [
                    104.1012862,
                    52.2457841
                ],
                [
                    104.1006418,
                    52.2484628
                ],
                [
                    104.1006563,
                    52.2485933
                ],
                [
                    104.1004383,
                    52.2492726
                ],
                [
                    104.1018289,
                    52.2497947
                ],
                [
                    104.102105,
                    52.249857
                ],
                [
                    104.1020566,
                    52.2503138
                ],
                [
                    104.1004092,
                    52.2501121
                ],
                [
                    104.0999247,
                    52.2501002
                ],
                [
                    104.0999393,
                    52.2503138
                ],
                [
                    104.0950365,
                    52.253303
                ]
            ],
            "longitude": 104.142426,
            "latitude": 52.250034
        },
        "4173": {
            "name": "Енисей",
            "population": 1019,
            "type": "village",
            "poly": null,
            "longitude": 104.1517935,
            "latitude": 53.3574974
        },
        "4174": {
            "name": "Усть-Куда",
            "population": 2010,
            "type": "village",
            "poly": null,
            "longitude": 104.155693,
            "latitude": 52.438747
        },
        "4175": {
            "name": "Мамоны",
            "population": 3154,
            "type": "village",
            "poly": [
                [
                    104.1203043,
                    52.3025787
                ],
                [
                    104.1224615,
                    52.3067486
                ],
                [
                    104.1292113,
                    52.309897
                ],
                [
                    104.1516182,
                    52.3141938
                ],
                [
                    104.1769477,
                    52.3151297
                ],
                [
                    104.1801487,
                    52.3143638
                ],
                [
                    104.1802183,
                    52.3101522
                ],
                [
                    104.1658139,
                    52.3010894
                ],
                [
                    104.1532187,
                    52.2911734
                ],
                [
                    104.1354741,
                    52.2911734
                ],
                [
                    104.121696,
                    52.2927908
                ],
                [
                    104.1203043,
                    52.3025787
                ]
            ],
            "longitude": 104.155769,
            "latitude": 52.303055
        },
        "4176": {
            "name": "Сайгуты",
            "population": 271,
            "type": "village",
            "poly": null,
            "longitude": 104.16967,
            "latitude": 52.841663
        },
        "4177": {
            "name": "Московщина",
            "population": 863,
            "type": "village",
            "poly": null,
            "longitude": 104.172409,
            "latitude": 52.51482
        },
        "4178": {
            "name": "Коршуновский",
            "population": 872,
            "type": "village",
            "poly": null,
            "longitude": 104.194206,
            "latitude": 56.491352
        },
        "4179": {
            "name": "Маритуй",
            "population": 55,
            "type": "village",
            "poly": [
                [
                    104.2042307,
                    51.7939567
                ],
                [
                    104.2062059,
                    51.7948964
                ],
                [
                    104.213043,
                    51.7911845
                ],
                [
                    104.2217033,
                    51.7890699
                ],
                [
                    104.2316551,
                    51.7872373
                ],
                [
                    104.2325667,
                    51.7856656
                ],
                [
                    104.2298271,
                    51.7856489
                ],
                [
                    104.2269801,
                    51.7861308
                ],
                [
                    104.2217964,
                    51.7870446
                ],
                [
                    104.2190299,
                    51.7873436
                ],
                [
                    104.2148668,
                    51.7865794
                ],
                [
                    104.2116707,
                    51.7851006
                ],
                [
                    104.2078566,
                    51.7828742
                ],
                [
                    104.2065944,
                    51.7841203
                ],
                [
                    104.2077224,
                    51.7856323
                ],
                [
                    104.2113215,
                    51.7866791
                ],
                [
                    104.2115236,
                    51.7887879
                ],
                [
                    104.205978,
                    51.7921242
                ],
                [
                    104.2042307,
                    51.7939567
                ]
            ],
            "longitude": 104.216431,
            "latitude": 51.788239
        },
        "4180": {
            "name": "Столбова",
            "population": 459,
            "type": "village",
            "poly": null,
            "longitude": 104.22036,
            "latitude": 52.428207
        },
        "4181": {
            "name": "Тихоновка",
            "population": 1485,
            "type": "village",
            "poly": null,
            "longitude": 104.224136,
            "latitude": 53.175423
        },
        "4182": {
            "name": "Ширяева",
            "population": 933,
            "type": "village",
            "poly": null,
            "longitude": 104.227882,
            "latitude": 52.555904
        },
        "4183": {
            "name": "Солзан",
            "population": 596,
            "type": "village",
            "poly": [
                [
                    104.220336,
                    51.4987088
                ],
                [
                    104.2228241,
                    51.5007674
                ],
                [
                    104.2329967,
                    51.4994342
                ],
                [
                    104.2401144,
                    51.4979441
                ],
                [
                    104.2394846,
                    51.4944933
                ],
                [
                    104.228682,
                    51.4961794
                ],
                [
                    104.2282624,
                    51.4960113
                ],
                [
                    104.2268239,
                    51.4954344
                ],
                [
                    104.2223202,
                    51.4959441
                ],
                [
                    104.220336,
                    51.4987088
                ]
            ],
            "longitude": 104.229004,
            "latitude": 51.497353
        },
        "4184": {
            "name": "Урик",
            "population": 2079,
            "type": "village",
            "poly": null,
            "longitude": 104.232002,
            "latitude": 52.460522
        },
        "4185": {
            "name": "Сергиев Посад",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.2349241,
            "latitude": 52.245746
        },
        "4186": {
            "name": "Лыловщина",
            "population": 387,
            "type": "village",
            "poly": null,
            "longitude": 104.239113,
            "latitude": 52.516556
        },
        "4187": {
            "name": "Хребтовая",
            "population": 1377,
            "type": "village",
            "poly": null,
            "longitude": 104.247116,
            "latitude": 56.709171
        },
        "4188": {
            "name": "Николов Посад",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.2485961,
            "latitude": 52.226718
        },
        "4189": {
            "name": "Ново-Иркутский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.2495261,
            "latitude": 52.24443
        },
        "4190": {
            "name": "Поселок Березовый",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.2545887,
            "latitude": 52.2240007
        },
        "4191": {
            "name": "Горяшина",
            "population": 419,
            "type": "village",
            "poly": null,
            "longitude": 104.258148,
            "latitude": 52.578304
        },
        "4192": {
            "name": "Грановщина",
            "population": 1279,
            "type": "village",
            "poly": null,
            "longitude": 104.287514,
            "latitude": 52.462086
        },
        "4193": {
            "name": "Карлук",
            "population": 2572,
            "type": "village",
            "poly": null,
            "longitude": 104.299187,
            "latitude": 52.422604
        },
        "4194": {
            "name": "Малая Топка",
            "population": 1864,
            "type": "village",
            "poly": null,
            "longitude": 104.314789,
            "latitude": 52.345726
        },
        "4195": {
            "name": "Дундай",
            "population": 623,
            "type": "village",
            "poly": null,
            "longitude": 104.347702,
            "latitude": 53.218575
        },
        "4196": {
            "name": "Хомутово",
            "population": 7528,
            "type": "village",
            "poly": [
                [
                    104.3177129,
                    52.467805
                ],
                [
                    104.3318627,
                    52.4686929
                ],
                [
                    104.3298317,
                    52.4724877
                ],
                [
                    104.3520758,
                    52.4746415
                ],
                [
                    104.3595464,
                    52.4705119
                ],
                [
                    104.3627592,
                    52.470382
                ],
                [
                    104.3627753,
                    52.4706327
                ],
                [
                    104.3638052,
                    52.4724626
                ],
                [
                    104.3656827,
                    52.4746482
                ],
                [
                    104.3699729,
                    52.4741776
                ],
                [
                    104.3756331,
                    52.4719091
                ],
                [
                    104.3738899,
                    52.4702286
                ],
                [
                    104.37521,
                    52.4698883
                ],
                [
                    104.3766655,
                    52.4698677
                ],
                [
                    104.3782973,
                    52.4693203
                ],
                [
                    104.3789166,
                    52.4684346
                ],
                [
                    104.3788195,
                    52.4672517
                ],
                [
                    104.3840751,
                    52.4653434
                ],
                [
                    104.3904128,
                    52.4671294
                ],
                [
                    104.4027724,
                    52.4736651
                ],
                [
                    104.4019999,
                    52.4784225
                ],
                [
                    104.4021716,
                    52.4814544
                ],
                [
                    104.4033732,
                    52.4819248
                ],
                [
                    104.4067206,
                    52.4818203
                ],
                [
                    104.4098963,
                    52.4851133
                ],
                [
                    104.4133296,
                    52.4871517
                ],
                [
                    104.4206252,
                    52.4953044
                ],
                [
                    104.4216551,
                    52.495827
                ],
                [
                    104.4248309,
                    52.4949386
                ],
                [
                    104.4262042,
                    52.4966108
                ],
                [
                    104.4310107,
                    52.4949909
                ],
                [
                    104.431869,
                    52.4944683
                ],
                [
                    104.4312682,
                    52.493998
                ],
                [
                    104.4298949,
                    52.4938935
                ],
                [
                    104.4282641,
                    52.4915941
                ],
                [
                    104.4242984,
                    52.492586
                ],
                [
                    104.4233666,
                    52.491397
                ],
                [
                    104.4239299,
                    52.4901504
                ],
                [
                    104.4235941,
                    52.4898141
                ],
                [
                    104.4216769,
                    52.4891413
                ],
                [
                    104.4214444,
                    52.4878201
                ],
                [
                    104.4224893,
                    52.4871428
                ],
                [
                    104.4262985,
                    52.4841507
                ],
                [
                    104.4255866,
                    52.4832637
                ],
                [
                    104.4248346,
                    52.4813944
                ],
                [
                    104.4239951,
                    52.4803059
                ],
                [
                    104.4258772,
                    52.4791184
                ],
                [
                    104.4271499,
                    52.479003
                ],
                [
                    104.4285399,
                    52.4785758
                ],
                [
                    104.4282102,
                    52.4768478
                ],
                [
                    104.4277457,
                    52.4745744
                ],
                [
                    104.4272341,
                    52.4736651
                ],
                [
                    104.4260325,
                    52.4725149
                ],
                [
                    104.4250884,
                    52.472358
                ],
                [
                    104.4216121,
                    52.4727022
                ],
                [
                    104.4204883,
                    52.4725785
                ],
                [
                    104.4189176,
                    52.4715392
                ],
                [
                    104.4184708,
                    52.4708052
                ],
                [
                    104.4169388,
                    52.4697051
                ],
                [
                    104.4149369,
                    52.4694607
                ],
                [
                    104.4137183,
                    52.4702196
                ],
                [
                    104.412691,
                    52.4698206
                ],
                [
                    104.411594,
                    52.4692104
                ],
                [
                    104.4100654,
                    52.4679413
                ],
                [
                    104.4097334,
                    52.4666007
                ],
                [
                    104.4098314,
                    52.4651855
                ],
                [
                    104.4094614,
                    52.4643686
                ],
                [
                    104.4090082,
                    52.4638498
                ],
                [
                    104.4084381,
                    52.4635736
                ],
                [
                    104.405438,
                    52.4634703
                ],
                [
                    104.4010185,
                    52.4638201
                ],
                [
                    104.4016143,
                    52.464513
                ],
                [
                    104.3996862,
                    52.4648232
                ],
                [
                    104.398473,
                    52.4648496
                ],
                [
                    104.3976498,
                    52.4644602
                ],
                [
                    104.397379,
                    52.4638927
                ],
                [
                    104.3975848,
                    52.4627378
                ],
                [
                    104.3951585,
                    52.4620844
                ],
                [
                    104.3938922,
                    52.4619129
                ],
                [
                    104.3928296,
                    52.462223
                ],
                [
                    104.3913456,
                    52.4620712
                ],
                [
                    104.3904791,
                    52.461794
                ],
                [
                    104.3902949,
                    52.4614442
                ],
                [
                    104.3901301,
                    52.4594422
                ],
                [
                    104.3876705,
                    52.4590796
                ],
                [
                    104.3840545,
                    52.4610383
                ],
                [
                    104.3854322,
                    52.4619479
                ],
                [
                    104.382329,
                    52.4633707
                ],
                [
                    104.3792015,
                    52.4630269
                ],
                [
                    104.3782028,
                    52.4620255
                ],
                [
                    104.3776668,
                    52.4622403
                ],
                [
                    104.3774772,
                    52.4628555
                ],
                [
                    104.3727773,
                    52.4639631
                ],
                [
                    104.3712116,
                    52.4601549
                ],
                [
                    104.3703466,
                    52.4593394
                ],
                [
                    104.3685192,
                    52.4606447
                ],
                [
                    104.36665,
                    52.4611091
                ],
                [
                    104.3666259,
                    52.4617046
                ],
                [
                    104.3632623,
                    52.4611801
                ],
                [
                    104.3629017,
                    52.4655778
                ],
                [
                    104.3628708,
                    52.4658252
                ],
                [
                    104.3621193,
                    52.4657294
                ],
                [
                    104.3575115,
                    52.4651005
                ],
                [
                    104.3529203,
                    52.4645887
                ],
                [
                    104.3539781,
                    52.4580275
                ],
                [
                    104.3524477,
                    52.4573731
                ],
                [
                    104.3502588,
                    52.4570091
                ],
                [
                    104.3503152,
                    52.4561046
                ],
                [
                    104.3446154,
                    52.4562467
                ],
                [
                    104.3438175,
                    52.4541405
                ],
                [
                    104.3423476,
                    52.4543166
                ],
                [
                    104.3407338,
                    52.4549818
                ],
                [
                    104.3391617,
                    52.4550835
                ],
                [
                    104.3371434,
                    52.4569838
                ],
                [
                    104.3378167,
                    52.4586452
                ],
                [
                    104.336039,
                    52.4628723
                ],
                [
                    104.3291936,
                    52.4623408
                ],
                [
                    104.3203624,
                    52.461805
                ],
                [
                    104.3178822,
                    52.4618528
                ],
                [
                    104.3177129,
                    52.467805
                ]
            ],
            "longitude": 104.368851,
            "latitude": 52.467205
        },
        "4197": {
            "name": "Горный",
            "population": 394,
            "type": "village",
            "poly": [
                [
                    104.3645563,
                    52.4002533
                ],
                [
                    104.3704592,
                    52.4020522
                ],
                [
                    104.3753946,
                    52.4008739
                ],
                [
                    104.3787184,
                    52.3974253
                ],
                [
                    104.3879022,
                    52.3904854
                ],
                [
                    104.3860998,
                    52.3890711
                ],
                [
                    104.3757572,
                    52.3911402
                ],
                [
                    104.3683329,
                    52.3949376
                ],
                [
                    104.3645563,
                    52.4002533
                ]
            ],
            "longitude": 104.371986,
            "latitude": 52.397247
        },
        "4198": {
            "name": "Падь Мельничная",
            "population": 1139,
            "type": "village",
            "poly": null,
            "longitude": 104.379089,
            "latitude": 52.160809
        },
        "4199": {
            "name": "Новая Разводная",
            "population": 1313,
            "type": "village",
            "poly": null,
            "longitude": 104.393051,
            "latitude": 52.246651
        },
        "4200": {
            "name": "Дзержинск",
            "population": 2277,
            "type": "village",
            "poly": [
                [
                    104.3728575,
                    52.2756654
                ],
                [
                    104.3737154,
                    52.2771685
                ],
                [
                    104.3738431,
                    52.2773922
                ],
                [
                    104.3747589,
                    52.27733
                ],
                [
                    104.3757256,
                    52.27954
                ],
                [
                    104.3746063,
                    52.2796023
                ],
                [
                    104.375115,
                    52.2812209
                ],
                [
                    104.3743567,
                    52.2819607
                ],
                [
                    104.3756884,
                    52.2824556
                ],
                [
                    104.381482,
                    52.2822981
                ],
                [
                    104.3839282,
                    52.2819306
                ],
                [
                    104.387061,
                    52.2813792
                ],
                [
                    104.3890351,
                    52.2811692
                ],
                [
                    104.3930262,
                    52.2818255
                ],
                [
                    104.3934125,
                    52.2825607
                ],
                [
                    104.3964595,
                    52.2825607
                ],
                [
                    104.3980473,
                    52.2825607
                ],
                [
                    104.3995064,
                    52.2819568
                ],
                [
                    104.4049138,
                    52.2807753
                ],
                [
                    104.4064587,
                    52.2795938
                ],
                [
                    104.4099349,
                    52.2792788
                ],
                [
                    104.409849,
                    52.2768369
                ],
                [
                    104.4098061,
                    52.272688
                ],
                [
                    104.390108,
                    52.2741848
                ],
                [
                    104.3825978,
                    52.2755765
                ],
                [
                    104.3816782,
                    52.2729963
                ],
                [
                    104.3749515,
                    52.2748831
                ],
                [
                    104.3750018,
                    52.2754189
                ],
                [
                    104.3730706,
                    52.2755502
                ],
                [
                    104.3728575,
                    52.2756654
                ]
            ],
            "longitude": 104.3955895,
            "latitude": 52.2791595
        },
        "4201": {
            "name": "Куда",
            "population": 2399,
            "type": "village",
            "poly": null,
            "longitude": 104.400177,
            "latitude": 52.441486
        },
        "4202": {
            "name": "Мурино",
            "population": 149,
            "type": "village",
            "poly": [
                [
                    104.3984947,
                    51.4782437
                ],
                [
                    104.4029609,
                    51.4809891
                ],
                [
                    104.4002928,
                    51.4856126
                ],
                [
                    104.4023809,
                    51.4864073
                ],
                [
                    104.4081522,
                    51.4809168
                ],
                [
                    104.4104433,
                    51.4815309
                ],
                [
                    104.4124734,
                    51.4800319
                ],
                [
                    104.4113424,
                    51.4771238
                ],
                [
                    104.4118064,
                    51.4758775
                ],
                [
                    104.4089062,
                    51.4746491
                ],
                [
                    104.4098343,
                    51.4702774
                ],
                [
                    104.406847,
                    51.4693922
                ],
                [
                    104.3984947,
                    51.4782437
                ]
            ],
            "longitude": 104.40567,
            "latitude": 51.476582
        },
        "4203": {
            "name": "Миловиды",
            "population": null,
            "type": "village",
            "poly": [
                [
                    104.4155187,
                    52.2785839
                ],
                [
                    104.4182085,
                    52.27902
                ],
                [
                    104.4234908,
                    52.2788615
                ],
                [
                    104.426699,
                    52.2768787
                ],
                [
                    104.4260186,
                    52.274182
                ],
                [
                    104.422227,
                    52.2737854
                ],
                [
                    104.4158427,
                    52.2750148
                ],
                [
                    104.4155187,
                    52.2785839
                ]
            ],
            "longitude": 104.4202952,
            "latitude": 52.2767476
        },
        "4204": {
            "name": "Молодежный",
            "population": 6640,
            "type": "village",
            "poly": null,
            "longitude": 104.4210811,
            "latitude": 52.234554
        },
        "4205": {
            "name": "Вершина",
            "population": 327,
            "type": "village",
            "poly": null,
            "longitude": 104.421989,
            "latitude": 53.249458
        },
        "4206": {
            "name": "Позднякова",
            "population": 305,
            "type": "village",
            "poly": null,
            "longitude": 104.440132,
            "latitude": 52.488602
        },
        "4207": {
            "name": "Галки",
            "population": 560,
            "type": "village",
            "poly": null,
            "longitude": 104.444382,
            "latitude": 52.62265
        },
        "4208": {
            "name": "Егоровщина",
            "population": 382,
            "type": "village",
            "poly": null,
            "longitude": 104.44883,
            "latitude": 52.663048
        },
        "4209": {
            "name": "Пивовариха",
            "population": 3506,
            "type": "village",
            "poly": [
                [
                    104.4331608,
                    52.2774107
                ],
                [
                    104.4356203,
                    52.28118
                ],
                [
                    104.434247,
                    52.2825976
                ],
                [
                    104.4354487,
                    52.2831228
                ],
                [
                    104.4375086,
                    52.2822827
                ],
                [
                    104.4393969,
                    52.2824927
                ],
                [
                    104.4435168,
                    52.278922
                ],
                [
                    104.4513769,
                    52.2795133
                ],
                [
                    104.4539881,
                    52.2797097
                ],
                [
                    104.4554472,
                    52.2744582
                ],
                [
                    104.4623995,
                    52.2677354
                ],
                [
                    104.468236,
                    52.2627976
                ],
                [
                    104.4667769,
                    52.2622197
                ],
                [
                    104.4660044,
                    52.262535
                ],
                [
                    104.4629145,
                    52.262535
                ],
                [
                    104.4599962,
                    52.2622723
                ],
                [
                    104.4571638,
                    52.262535
                ],
                [
                    104.4522915,
                    52.2636461
                ],
                [
                    104.4505319,
                    52.2650381
                ],
                [
                    104.4492552,
                    52.2656422
                ],
                [
                    104.4456074,
                    52.2652285
                ],
                [
                    104.4440383,
                    52.2659615
                ],
                [
                    104.4411656,
                    52.2673034
                ],
                [
                    104.4387409,
                    52.2646836
                ],
                [
                    104.4379899,
                    52.2645522
                ],
                [
                    104.4377539,
                    52.2647819
                ],
                [
                    104.4377753,
                    52.2655503
                ],
                [
                    104.438462,
                    52.2675989
                ],
                [
                    104.4395992,
                    52.2699231
                ],
                [
                    104.4398353,
                    52.2704549
                ],
                [
                    104.4331608,
                    52.2774107
                ]
            ],
            "longitude": 104.4531348,
            "latitude": 52.2699526
        },
        "4210": {
            "name": "Никольск",
            "population": 1079,
            "type": "village",
            "poly": null,
            "longitude": 104.454811,
            "latitude": 52.754917
        },
        "4211": {
            "name": "Новолисиха",
            "population": 528,
            "type": "village",
            "poly": null,
            "longitude": 104.455139,
            "latitude": 52.23579
        },
        "4212": {
            "name": "Оёк",
            "population": 3678,
            "type": "village",
            "poly": null,
            "longitude": 104.460915,
            "latitude": 52.589935
        },
        "4213": {
            "name": "Патроны",
            "population": 468,
            "type": "village",
            "poly": null,
            "longitude": 104.472176,
            "latitude": 52.160618
        },
        "4214": {
            "name": "Плишкино",
            "population": 2023,
            "type": "village",
            "poly": null,
            "longitude": 104.488022,
            "latitude": 52.346455
        },
        "4215": {
            "name": "Бутырки",
            "population": 587,
            "type": "village",
            "poly": null,
            "longitude": 104.500084,
            "latitude": 52.564507
        },
        "4216": {
            "name": "Коты",
            "population": 577,
            "type": "village",
            "poly": null,
            "longitude": 104.503273,
            "latitude": 52.551437
        },
        "4217": {
            "name": "Сосновый Бор",
            "population": 1778,
            "type": "village",
            "poly": null,
            "longitude": 104.504318,
            "latitude": 52.657845
        },
        "4218": {
            "name": "Жердовка",
            "population": 284,
            "type": "village",
            "poly": null,
            "longitude": 104.537582,
            "latitude": 52.653606
        },
        "4219": {
            "name": "Кыцигировка",
            "population": 476,
            "type": "village",
            "poly": null,
            "longitude": 104.549751,
            "latitude": 52.727467
        },
        "4220": {
            "name": "Черемушка",
            "population": 494,
            "type": "village",
            "poly": null,
            "longitude": 104.567924,
            "latitude": 52.643532
        },
        "4221": {
            "name": "Бурдаковка",
            "population": 410,
            "type": "village",
            "poly": null,
            "longitude": 104.577599,
            "latitude": 52.096851
        },
        "4222": {
            "name": "Худякова",
            "population": 530,
            "type": "village",
            "poly": null,
            "longitude": 104.581711,
            "latitude": 52.272141
        },
        "4223": {
            "name": "Булуса",
            "population": 394,
            "type": "village",
            "poly": null,
            "longitude": 104.602234,
            "latitude": 52.796963
        },
        "4224": {
            "name": "Нижняя Идыга",
            "population": 299,
            "type": "village",
            "poly": null,
            "longitude": 104.625572,
            "latitude": 52.904926
        },
        "4225": {
            "name": "Ревякина",
            "population": 691,
            "type": "village",
            "poly": null,
            "longitude": 104.625786,
            "latitude": 52.588421
        },
        "4226": {
            "name": "Новоснежная",
            "population": 454,
            "type": "village",
            "poly": [
                [
                    104.6174284,
                    51.475795
                ],
                [
                    104.61882,
                    51.4765857
                ],
                [
                    104.621285,
                    51.4772424
                ],
                [
                    104.6217396,
                    51.4769248
                ],
                [
                    104.622114,
                    51.4767505
                ],
                [
                    104.6249717,
                    51.4743669
                ],
                [
                    104.6263048,
                    51.473529
                ],
                [
                    104.6268854,
                    51.4733469
                ],
                [
                    104.6269176,
                    51.473371
                ],
                [
                    104.6275228,
                    51.47327
                ],
                [
                    104.6275385,
                    51.4732241
                ],
                [
                    104.6282967,
                    51.4731508
                ],
                [
                    104.6291559,
                    51.472992
                ],
                [
                    104.6291547,
                    51.4728476
                ],
                [
                    104.6292931,
                    51.4727758
                ],
                [
                    104.6293084,
                    51.472661
                ],
                [
                    104.6296055,
                    51.4724472
                ],
                [
                    104.6295697,
                    51.4722174
                ],
                [
                    104.6296209,
                    51.472085
                ],
                [
                    104.6298333,
                    51.4718211
                ],
                [
                    104.6299724,
                    51.4715207
                ],
                [
                    104.6300375,
                    51.4711468
                ],
                [
                    104.6301726,
                    51.4710658
                ],
                [
                    104.6304727,
                    51.4705485
                ],
                [
                    104.6304799,
                    51.4703248
                ],
                [
                    104.6307129,
                    51.4696385
                ],
                [
                    104.6309517,
                    51.4694789
                ],
                [
                    104.6312781,
                    51.4693643
                ],
                [
                    104.6316133,
                    51.4687224
                ],
                [
                    104.6316483,
                    51.4683359
                ],
                [
                    104.6317852,
                    51.4680873
                ],
                [
                    104.6317234,
                    51.4677875
                ],
                [
                    104.6317484,
                    51.467052
                ],
                [
                    104.6312063,
                    51.4661365
                ],
                [
                    104.6320044,
                    51.4646478
                ],
                [
                    104.632186,
                    51.4641885
                ],
                [
                    104.6322821,
                    51.463638
                ],
                [
                    104.6325702,
                    51.4628281
                ],
                [
                    104.6325062,
                    51.4622277
                ],
                [
                    104.6326375,
                    51.462096
                ],
                [
                    104.6331785,
                    51.4618128
                ],
                [
                    104.6335787,
                    51.4614119
                ],
                [
                    104.6350456,
                    51.4603243
                ],
                [
                    104.6352387,
                    51.4600676
                ],
                [
                    104.6355978,
                    51.4597583
                ],
                [
                    104.6361622,
                    51.4594416
                ],
                [
                    104.6372346,
                    51.4584567
                ],
                [
                    104.6374188,
                    51.45813
                ],
                [
                    104.6377366,
                    51.4564896
                ],
                [
                    104.6373313,
                    51.4552111
                ],
                [
                    104.6369057,
                    51.4546463
                ],
                [
                    104.6363758,
                    51.4540889
                ],
                [
                    104.6352302,
                    51.4533064
                ],
                [
                    104.6352701,
                    51.4532503
                ],
                [
                    104.63507,
                    51.4531724
                ],
                [
                    104.6344898,
                    51.4527952
                ],
                [
                    104.6344748,
                    51.4526705
                ],
                [
                    104.6342247,
                    51.4526299
                ],
                [
                    104.6332091,
                    51.4518634
                ],
                [
                    104.629976,
                    51.4527186
                ],
                [
                    104.6307458,
                    51.4538708
                ],
                [
                    104.6312787,
                    51.455143
                ],
                [
                    104.6312626,
                    51.4563425
                ],
                [
                    104.631613,
                    51.4572536
                ],
                [
                    104.6318302,
                    51.4580357
                ],
                [
                    104.6317509,
                    51.4586042
                ],
                [
                    104.6311867,
                    51.4585792
                ],
                [
                    104.6303222,
                    51.4586167
                ],
                [
                    104.6289415,
                    51.4585718
                ],
                [
                    104.6287054,
                    51.4582801
                ],
                [
                    104.6283458,
                    51.4580066
                ],
                [
                    104.6283927,
                    51.4579742
                ],
                [
                    104.6278702,
                    51.4576088
                ],
                [
                    104.628101,
                    51.4574045
                ],
                [
                    104.6278708,
                    51.457178
                ],
                [
                    104.6276086,
                    51.4541662
                ],
                [
                    104.6222777,
                    51.4543547
                ],
                [
                    104.622985,
                    51.4557795
                ],
                [
                    104.6241242,
                    51.4563457
                ],
                [
                    104.6234145,
                    51.4569209
                ],
                [
                    104.6250613,
                    51.457593
                ],
                [
                    104.6270208,
                    51.4576115
                ],
                [
                    104.6273323,
                    51.4578641
                ],
                [
                    104.6269942,
                    51.4579535
                ],
                [
                    104.6262771,
                    51.4582615
                ],
                [
                    104.6267892,
                    51.4587422
                ],
                [
                    104.6277498,
                    51.4584706
                ],
                [
                    104.6285752,
                    51.4599442
                ],
                [
                    104.6286181,
                    51.4601382
                ],
                [
                    104.6285413,
                    51.4604367
                ],
                [
                    104.6287231,
                    51.4607638
                ],
                [
                    104.6288256,
                    51.4611373
                ],
                [
                    104.6285797,
                    51.4612953
                ],
                [
                    104.6282867,
                    51.4616366
                ],
                [
                    104.628098,
                    51.4623429
                ],
                [
                    104.6280699,
                    51.4629772
                ],
                [
                    104.6279917,
                    51.4632078
                ],
                [
                    104.6278441,
                    51.4633312
                ],
                [
                    104.6275727,
                    51.4633714
                ],
                [
                    104.6274726,
                    51.4634688
                ],
                [
                    104.6271912,
                    51.4635545
                ],
                [
                    104.6268027,
                    51.4634778
                ],
                [
                    104.6262783,
                    51.4638935
                ],
                [
                    104.6258718,
                    51.4644194
                ],
                [
                    104.6256404,
                    51.4646142
                ],
                [
                    104.6256404,
                    51.4646921
                ],
                [
                    104.6252249,
                    51.465071
                ],
                [
                    104.6245774,
                    51.4662582
                ],
                [
                    104.6242585,
                    51.4670568
                ],
                [
                    104.6240146,
                    51.4674035
                ],
                [
                    104.6236644,
                    51.4682215
                ],
                [
                    104.6245024,
                    51.4685058
                ],
                [
                    104.6244023,
                    51.4687786
                ],
                [
                    104.62469,
                    51.4693473
                ],
                [
                    104.6247336,
                    51.469546
                ],
                [
                    104.6246462,
                    51.4698147
                ],
                [
                    104.624054,
                    51.4704558
                ],
                [
                    104.6237909,
                    51.4709781
                ],
                [
                    104.6233646,
                    51.4714462
                ],
                [
                    104.6217622,
                    51.4724394
                ],
                [
                    104.6208761,
                    51.4728671
                ],
                [
                    104.6198159,
                    51.4736566
                ],
                [
                    104.6189013,
                    51.4742311
                ],
                [
                    104.6191906,
                    51.4744113
                ],
                [
                    104.6174284,
                    51.475795
                ]
            ],
            "longitude": 104.627136,
            "latitude": 51.468632
        },
        "4227": {
            "name": "Капсал",
            "population": 464,
            "type": "village",
            "poly": null,
            "longitude": 104.641083,
            "latitude": 52.686939
        },
        "4228": {
            "name": "Семигорск",
            "population": 849,
            "type": "village",
            "poly": null,
            "longitude": 104.644386,
            "latitude": 56.67691
        },
        "4229": {
            "name": "Харазаргай",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 104.671829,
            "latitude": 52.960999
        },
        "4230": {
            "name": "Куяда",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 104.676498,
            "latitude": 52.613335
        },
        "4231": {
            "name": "Кулункун",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 104.683456,
            "latitude": 52.838436
        },
        "4232": {
            "name": "Лукиново",
            "population": 121,
            "type": "village",
            "poly": null,
            "longitude": 104.701721,
            "latitude": 54.190529
        },
        "4233": {
            "name": "Кукунут",
            "population": 468,
            "type": "village",
            "poly": null,
            "longitude": 104.7182837,
            "latitude": 52.9897258
        },
        "4234": {
            "name": "Тимошино",
            "population": 159,
            "type": "village",
            "poly": null,
            "longitude": 104.727089,
            "latitude": 54.395344
        },
        "4235": {
            "name": "Захал",
            "population": 375,
            "type": "village",
            "poly": null,
            "longitude": 104.733131,
            "latitude": 52.602913
        },
        "4236": {
            "name": "Большая Речка",
            "population": 2893,
            "type": "village",
            "poly": null,
            "longitude": 104.735489,
            "latitude": 51.950333
        },
        "4237": {
            "name": "Дальняя Закора",
            "population": 349,
            "type": "village",
            "poly": null,
            "longitude": 104.737274,
            "latitude": 54.657925
        },
        "4238": {
            "name": "Еловка",
            "population": 331,
            "type": "village",
            "poly": null,
            "longitude": 104.782265,
            "latitude": 52.61272
        },
        "4239": {
            "name": "Алужино",
            "population": 522,
            "type": "village",
            "poly": null,
            "longitude": 104.784767,
            "latitude": 52.707413
        },
        "4240": {
            "name": "Свердлово",
            "population": 498,
            "type": "village",
            "poly": null,
            "longitude": 104.79287,
            "latitude": 52.587147
        },
        "4241": {
            "name": "Байкал",
            "population": 425,
            "type": "village",
            "poly": [
                [
                    104.7936982,
                    51.8731764
                ],
                [
                    104.7960411,
                    51.8783772
                ],
                [
                    104.8098773,
                    51.8811024
                ],
                [
                    104.8126484,
                    51.8758536
                ],
                [
                    104.8137506,
                    51.8740261
                ],
                [
                    104.8113258,
                    51.8705847
                ],
                [
                    104.8107086,
                    51.8688853
                ],
                [
                    104.8054434,
                    51.870332
                ],
                [
                    104.7984605,
                    51.8719811
                ],
                [
                    104.7957207,
                    51.8728514
                ],
                [
                    104.7936982,
                    51.8731764
                ]
            ],
            "longitude": 104.808372,
            "latitude": 51.870476
        },
        "4242": {
            "name": "Тугутуй",
            "population": 1010,
            "type": "village",
            "poly": null,
            "longitude": 104.812332,
            "latitude": 52.683163
        },
        "4243": {
            "name": "Знаменка",
            "population": 589,
            "type": "village",
            "poly": null,
            "longitude": 104.837624,
            "latitude": 54.700729
        },
        "4244": {
            "name": "Бозой",
            "population": 2677,
            "type": "village",
            "poly": null,
            "longitude": 104.852341,
            "latitude": 52.931728
        },
        "4245": {
            "name": "Листвянка",
            "population": 2002,
            "type": "village",
            "poly": [
                [
                    104.8286675,
                    51.8707619
                ],
                [
                    104.828748,
                    51.8725566
                ],
                [
                    104.8291357,
                    51.8746306
                ],
                [
                    104.8299408,
                    51.8743685
                ],
                [
                    104.8297034,
                    51.8703501
                ],
                [
                    104.8314721,
                    51.8695005
                ],
                [
                    104.8334044,
                    51.8697936
                ],
                [
                    104.8364554,
                    51.8685377
                ],
                [
                    104.8441845,
                    51.8665491
                ],
                [
                    104.8537735,
                    51.8627922
                ],
                [
                    104.8597182,
                    51.8598907
                ],
                [
                    104.8660465,
                    51.8634139
                ],
                [
                    104.8707447,
                    51.8631178
                ],
                [
                    104.8658547,
                    51.8540279
                ],
                [
                    104.86969,
                    51.8518366
                ],
                [
                    104.8801892,
                    51.8633843
                ],
                [
                    104.8839286,
                    51.863858
                ],
                [
                    104.8834012,
                    51.8624369
                ],
                [
                    104.87132,
                    51.8499413
                ],
                [
                    104.8765456,
                    51.847276
                ],
                [
                    104.8949071,
                    51.8595354
                ],
                [
                    104.8932771,
                    51.8565153
                ],
                [
                    104.8792303,
                    51.8453212
                ],
                [
                    104.8785429,
                    51.843027
                ],
                [
                    104.8780344,
                    51.8432155
                ],
                [
                    104.8730087,
                    51.84687
                ],
                [
                    104.8691527,
                    51.8496395
                ],
                [
                    104.8660424,
                    51.8517126
                ],
                [
                    104.862305,
                    51.8539322
                ],
                [
                    104.8585506,
                    51.8562929
                ],
                [
                    104.8537792,
                    51.8594649
                ],
                [
                    104.8495163,
                    51.8618724
                ],
                [
                    104.8438297,
                    51.8638927
                ],
                [
                    104.8357955,
                    51.8663262
                ],
                [
                    104.8338097,
                    51.8669901
                ],
                [
                    104.8327884,
                    51.8673186
                ],
                [
                    104.8310553,
                    51.868097
                ],
                [
                    104.8299048,
                    51.8686543
                ],
                [
                    104.8294239,
                    51.8689577
                ],
                [
                    104.8289218,
                    51.8699482
                ],
                [
                    104.8286675,
                    51.8707619
                ]
            ],
            "longitude": 104.86058,
            "latitude": 51.85693
        },
        "4246": {
            "name": "Гаханы",
            "population": 757,
            "type": "village",
            "poly": null,
            "longitude": 104.8718906,
            "latitude": 53.0476648
        },
        "4247": {
            "name": "Байтог",
            "population": 301,
            "type": "village",
            "poly": null,
            "longitude": 104.87397,
            "latitude": 53.143944
        },
        "4248": {
            "name": "Горячий Ключ",
            "population": 864,
            "type": "village",
            "poly": null,
            "longitude": 104.908379,
            "latitude": 52.27615
        },
        "4249": {
            "name": "Харанут",
            "population": 295,
            "type": "village",
            "poly": null,
            "longitude": 104.939827,
            "latitude": 52.763023
        },
        "4250": {
            "name": "Ахины",
            "population": 327,
            "type": "village",
            "poly": null,
            "longitude": 104.978508,
            "latitude": 53.261059
        },
        "4251": {
            "name": "Хабаровская",
            "population": 282,
            "type": "village",
            "poly": null,
            "longitude": 105.003227,
            "latitude": 53.099957
        },
        "4252": {
            "name": "Корсук",
            "population": 528,
            "type": "village",
            "poly": null,
            "longitude": 105.007935,
            "latitude": 52.791546
        },
        "4253": {
            "name": "Олой",
            "population": 672,
            "type": "village",
            "poly": null,
            "longitude": 105.038986,
            "latitude": 52.905327
        },
        "4254": {
            "name": "Ручей",
            "population": 1288,
            "type": "village",
            "poly": null,
            "longitude": 105.054573,
            "latitude": 56.854488
        },
        "4255": {
            "name": "Харат",
            "population": 877,
            "type": "village",
            "poly": null,
            "longitude": 105.064949,
            "latitude": 52.753265
        },
        "4256": {
            "name": "Верхний Кукут",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 105.071518,
            "latitude": 52.734234
        },
        "4257": {
            "name": "Старый Олой",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.0769673,
            "latitude": 52.9135905
        },
        "4258": {
            "name": "Новониколаевск",
            "population": 460,
            "type": "village",
            "poly": null,
            "longitude": 105.086311,
            "latitude": 53.151459
        },
        "4259": {
            "name": "Усть-Илга",
            "population": 198,
            "type": "village",
            "poly": null,
            "longitude": 105.08744,
            "latitude": 55.007313
        },
        "4260": {
            "name": "Отонхой",
            "population": 273,
            "type": "village",
            "poly": null,
            "longitude": 105.121262,
            "latitude": 52.95163
        },
        "4261": {
            "name": "Рудовка",
            "population": 321,
            "type": "village",
            "poly": null,
            "longitude": 105.209496,
            "latitude": 54.747204
        },
        "4262": {
            "name": "Ользоны",
            "population": 663,
            "type": "village",
            "poly": null,
            "longitude": 105.2176846,
            "latitude": 52.9481971
        },
        "4263": {
            "name": "Петрово",
            "population": 196,
            "type": "village",
            "poly": null,
            "longitude": 105.226715,
            "latitude": 54.496094
        },
        "4264": {
            "name": "Хатар-Хадай",
            "population": 310,
            "type": "village",
            "poly": [
                [
                    105.2195403,
                    52.8426728
                ],
                [
                    105.2234026,
                    52.8438652
                ],
                [
                    105.2218577,
                    52.8460425
                ],
                [
                    105.2249047,
                    52.8470274
                ],
                [
                    105.2236601,
                    52.8489971
                ],
                [
                    105.2233597,
                    52.8502671
                ],
                [
                    105.2247588,
                    52.8501712
                ],
                [
                    105.2264067,
                    52.8491008
                ],
                [
                    105.2260634,
                    52.8481937
                ],
                [
                    105.2272221,
                    52.8469237
                ],
                [
                    105.2281662,
                    52.8460943
                ],
                [
                    105.2294365,
                    52.8457133
                ],
                [
                    105.2304837,
                    52.8457055
                ],
                [
                    105.2318398,
                    52.8451431
                ],
                [
                    105.2332732,
                    52.844902
                ],
                [
                    105.2341315,
                    52.844254
                ],
                [
                    105.2322003,
                    52.8427247
                ],
                [
                    105.2327153,
                    52.8418693
                ],
                [
                    105.2370926,
                    52.8415323
                ],
                [
                    105.2441136,
                    52.8363813
                ],
                [
                    105.2349469,
                    52.8333662
                ],
                [
                    105.231814,
                    52.8343514
                ],
                [
                    105.2325007,
                    52.8353884
                ],
                [
                    105.2294966,
                    52.8368921
                ],
                [
                    105.228295,
                    52.8363736
                ],
                [
                    105.2264496,
                    52.838603
                ],
                [
                    105.2269646,
                    52.8391993
                ],
                [
                    105.2255484,
                    52.8407806
                ],
                [
                    105.2239605,
                    52.8405473
                ],
                [
                    105.2223297,
                    52.8418952
                ],
                [
                    105.2204844,
                    52.8415841
                ],
                [
                    105.2195403,
                    52.8426728
                ]
            ],
            "longitude": 105.229935,
            "latitude": 52.842155
        },
        "4265": {
            "name": "Тутура",
            "population": 234,
            "type": "village",
            "poly": [
                [
                    105.2195862,
                    54.7854575
                ],
                [
                    105.2208628,
                    54.7864393
                ],
                [
                    105.2223618,
                    54.7872897
                ],
                [
                    105.2237041,
                    54.787871
                ],
                [
                    105.2248396,
                    54.7883819
                ],
                [
                    105.2274075,
                    54.7890152
                ],
                [
                    105.2288002,
                    54.7893384
                ],
                [
                    105.2293469,
                    54.7895028
                ],
                [
                    105.2302841,
                    54.7896007
                ],
                [
                    105.2329769,
                    54.7892498
                ],
                [
                    105.2335073,
                    54.7890319
                ],
                [
                    105.2335227,
                    54.7888293
                ],
                [
                    105.2327927,
                    54.7883065
                ],
                [
                    105.2317298,
                    54.7873922
                ],
                [
                    105.2315329,
                    54.7870769
                ],
                [
                    105.2314887,
                    54.7864386
                ],
                [
                    105.2316619,
                    54.7861704
                ],
                [
                    105.2323818,
                    54.7857905
                ],
                [
                    105.2330168,
                    54.7852501
                ],
                [
                    105.2334684,
                    54.7847919
                ],
                [
                    105.2339913,
                    54.7843846
                ],
                [
                    105.2352681,
                    54.7836405
                ],
                [
                    105.2368912,
                    54.7829923
                ],
                [
                    105.2383684,
                    54.7826692
                ],
                [
                    105.2398353,
                    54.782446
                ],
                [
                    105.2407164,
                    54.7822029
                ],
                [
                    105.2423506,
                    54.7815114
                ],
                [
                    105.242653,
                    54.7808841
                ],
                [
                    105.2425734,
                    54.7806332
                ],
                [
                    105.2411568,
                    54.7801589
                ],
                [
                    105.2412364,
                    54.7797856
                ],
                [
                    105.2405201,
                    54.7783229
                ],
                [
                    105.2395598,
                    54.7781332
                ],
                [
                    105.2358365,
                    54.7788485
                ],
                [
                    105.2339596,
                    54.7789977
                ],
                [
                    105.2310679,
                    54.7804779
                ],
                [
                    105.2302389,
                    54.7804702
                ],
                [
                    105.2280437,
                    54.7811511
                ],
                [
                    105.227963,
                    54.7815136
                ],
                [
                    105.2274412,
                    54.7831389
                ],
                [
                    105.227638,
                    54.7847165
                ],
                [
                    105.2246121,
                    54.7860969
                ],
                [
                    105.2229541,
                    54.7852005
                ],
                [
                    105.2205396,
                    54.7850212
                ],
                [
                    105.2195862,
                    54.7854575
                ]
            ],
            "longitude": 105.230515,
            "latitude": 54.785072
        },
        "4266": {
            "name": "Янталь",
            "population": 1613,
            "type": "village",
            "poly": null,
            "longitude": 105.249344,
            "latitude": 56.846062
        },
        "4267": {
            "name": "Бадагуй",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 105.291603,
            "latitude": 53.022617
        },
        "4268": {
            "name": "Нагалык",
            "population": 440,
            "type": "village",
            "poly": null,
            "longitude": 105.309425,
            "latitude": 53.106422
        },
        "4269": {
            "name": "Малое Голоустное",
            "population": 1262,
            "type": "village",
            "poly": null,
            "longitude": 105.332695,
            "latitude": 52.298336
        },
        "4270": {
            "name": "Загатуй",
            "population": 672,
            "type": "village",
            "poly": null,
            "longitude": 105.339348,
            "latitude": 52.889641
        },
        "4271": {
            "name": "Большое Голоустное",
            "population": 583,
            "type": "village",
            "poly": null,
            "longitude": 105.408424,
            "latitude": 52.037273
        },
        "4272": {
            "name": "Белоусово",
            "population": 110,
            "type": "village",
            "poly": null,
            "longitude": 105.463806,
            "latitude": 54.024658
        },
        "4273": {
            "name": "Люры",
            "population": 585,
            "type": "village",
            "poly": null,
            "longitude": 105.466766,
            "latitude": 53.000267
        },
        "4274": {
            "name": "Покровка",
            "population": 637,
            "type": "village",
            "poly": [
                [
                    105.4928684,
                    53.050241
                ],
                [
                    105.4938984,
                    53.0559159
                ],
                [
                    105.495615,
                    53.0613838
                ],
                [
                    105.4980183,
                    53.0660259
                ],
                [
                    105.5019665,
                    53.0701517
                ],
                [
                    105.506258,
                    53.0729364
                ],
                [
                    105.5126095,
                    53.0768553
                ],
                [
                    105.5156994,
                    53.0775771
                ],
                [
                    105.5203342,
                    53.076649
                ],
                [
                    105.5227375,
                    53.0770615
                ],
                [
                    105.5249691,
                    53.0804645
                ],
                [
                    105.5268574,
                    53.0837641
                ],
                [
                    105.5299473,
                    53.0875789
                ],
                [
                    105.5337238,
                    53.0897439
                ],
                [
                    105.5362988,
                    53.0892284
                ],
                [
                    105.5385426,
                    53.0883141
                ],
                [
                    105.5416498,
                    53.0865877
                ],
                [
                    105.5431561,
                    53.0864132
                ],
                [
                    105.5441357,
                    53.0857179
                ],
                [
                    105.5427892,
                    53.084268
                ],
                [
                    105.5442022,
                    53.0833407
                ],
                [
                    105.5413247,
                    53.0813358
                ],
                [
                    105.5434587,
                    53.0801551
                ],
                [
                    105.5415661,
                    53.0768791
                ],
                [
                    105.5364704,
                    53.073452
                ],
                [
                    105.5308056,
                    53.0692234
                ],
                [
                    105.5241108,
                    53.0663353
                ],
                [
                    105.5187893,
                    53.0631376
                ],
                [
                    105.5186176,
                    53.0610744
                ],
                [
                    105.5223942,
                    53.0599396
                ],
                [
                    105.5246258,
                    53.0583921
                ],
                [
                    105.5246258,
                    53.0567413
                ],
                [
                    105.5196476,
                    53.0508601
                ],
                [
                    105.517931,
                    53.0527174
                ],
                [
                    105.5148411,
                    53.0490027
                ],
                [
                    105.5119228,
                    53.0452876
                ],
                [
                    105.5064297,
                    53.0435332
                ],
                [
                    105.4997349,
                    53.0451844
                ],
                [
                    105.4935551,
                    53.046526
                ],
                [
                    105.4928684,
                    53.050241
                ]
            ],
            "longitude": 105.534851,
            "latitude": 53.082943
        },
        "4275": {
            "name": "Верхоленск",
            "population": 537,
            "type": "village",
            "poly": null,
            "longitude": 105.570412,
            "latitude": 54.101086
        },
        "4276": {
            "name": "Колонково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.5718337,
            "latitude": 56.7861546
        },
        "4277": {
            "name": "Байша",
            "population": 259,
            "type": "village",
            "poly": null,
            "longitude": 105.626816,
            "latitude": 53.373363
        },
        "4278": {
            "name": "Чикан",
            "population": 386,
            "type": "village",
            "poly": null,
            "longitude": 105.650169,
            "latitude": 54.900478
        },
        "4279": {
            "name": "Половинка",
            "population": 410,
            "type": "village",
            "poly": null,
            "longitude": 105.653152,
            "latitude": 53.130608
        },
        "4280": {
            "name": "Тургеневка",
            "population": 505,
            "type": "village",
            "poly": [
                [
                    105.6459216,
                    53.0273801
                ],
                [
                    105.6487336,
                    53.0280186
                ],
                [
                    105.6578661,
                    53.0293791
                ],
                [
                    105.6574991,
                    53.0303902
                ],
                [
                    105.6585248,
                    53.0306783
                ],
                [
                    105.659043,
                    53.0296217
                ],
                [
                    105.6762028,
                    53.032076
                ],
                [
                    105.6778463,
                    53.0320763
                ],
                [
                    105.6808987,
                    53.0320768
                ],
                [
                    105.681646,
                    53.0303308
                ],
                [
                    105.685901,
                    53.0294136
                ],
                [
                    105.6865775,
                    53.028579
                ],
                [
                    105.6893606,
                    53.0278383
                ],
                [
                    105.6879497,
                    53.0260559
                ],
                [
                    105.6878832,
                    53.025069
                ],
                [
                    105.686526,
                    53.0245741
                ],
                [
                    105.6804717,
                    53.0251136
                ],
                [
                    105.6678616,
                    53.0238888
                ],
                [
                    105.6639788,
                    53.0232496
                ],
                [
                    105.6501102,
                    53.0215451
                ],
                [
                    105.6459216,
                    53.0273801
                ]
            ],
            "longitude": 105.668358,
            "latitude": 53.026764
        },
        "4281": {
            "name": "Васильевка",
            "population": 349,
            "type": "village",
            "poly": null,
            "longitude": 105.750882,
            "latitude": 53.0774708
        },
        "4282": {
            "name": "Хогот",
            "population": 862,
            "type": "village",
            "poly": null,
            "longitude": 105.869621,
            "latitude": 53.242523
        },
        "4283": {
            "name": "Краснояр",
            "population": 585,
            "type": "village",
            "poly": null,
            "longitude": 105.929581,
            "latitude": 53.945835
        },
        "4284": {
            "name": "Аргун",
            "population": 345,
            "type": "village",
            "poly": null,
            "longitude": 105.931244,
            "latitude": 53.368996
        },
        "4285": {
            "name": "Никилей",
            "population": 292,
            "type": "village",
            "poly": null,
            "longitude": 105.962364,
            "latitude": 53.674522
        },
        "4286": {
            "name": "Карлук",
            "population": 218,
            "type": "village",
            "poly": null,
            "longitude": 105.987892,
            "latitude": 53.424271
        },
        "4287": {
            "name": "Большие Голы",
            "population": 157,
            "type": "village",
            "poly": null,
            "longitude": 106.001862,
            "latitude": 53.872181
        },
        "4288": {
            "name": "Харбатово",
            "population": 460,
            "type": "village",
            "poly": null,
            "longitude": 106.00219,
            "latitude": 53.745239
        },
        "4289": {
            "name": "Толстый Мыс",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.020079,
            "latitude": 56.8179312
        },
        "4290": {
            "name": "Манзурка",
            "population": 856,
            "type": "village",
            "poly": null,
            "longitude": 106.060333,
            "latitude": 53.487743
        },
        "4291": {
            "name": "Бугульдейка",
            "population": 992,
            "type": "village",
            "poly": [
                [
                    106.0565664,
                    52.5379637
                ],
                [
                    106.0623095,
                    52.5453319
                ],
                [
                    106.0638995,
                    52.5504397
                ],
                [
                    106.0645283,
                    52.5521803
                ],
                [
                    106.0646237,
                    52.5532198
                ],
                [
                    106.0645432,
                    52.5552559
                ],
                [
                    106.0656977,
                    52.5561639
                ],
                [
                    106.0698798,
                    52.5544816
                ],
                [
                    106.0745372,
                    52.5548926
                ],
                [
                    106.0753204,
                    52.5541294
                ],
                [
                    106.0746562,
                    52.5537993
                ],
                [
                    106.0764406,
                    52.5512366
                ],
                [
                    106.0779378,
                    52.5515292
                ],
                [
                    106.0781249,
                    52.5506676
                ],
                [
                    106.0770019,
                    52.5474975
                ],
                [
                    106.0760396,
                    52.5456766
                ],
                [
                    106.0749996,
                    52.5446031
                ],
                [
                    106.0731756,
                    52.5433242
                ],
                [
                    106.0724139,
                    52.5423736
                ],
                [
                    106.0700107,
                    52.5401726
                ],
                [
                    106.0668446,
                    52.5394391
                ],
                [
                    106.0588344,
                    52.5342697
                ],
                [
                    106.0569601,
                    52.5346287
                ],
                [
                    106.0565664,
                    52.5379637
                ]
            ],
            "longitude": 106.072304,
            "latitude": 52.549667
        },
        "4292": {
            "name": "Заречное",
            "population": 228,
            "type": "village",
            "poly": null,
            "longitude": 106.1059961,
            "latitude": 53.4103563
        },
        "4293": {
            "name": "Бутаково",
            "population": 512,
            "type": "village",
            "poly": null,
            "longitude": 106.113258,
            "latitude": 54.052864
        },
        "4294": {
            "name": "Подымахино",
            "population": 79,
            "type": "village",
            "poly": null,
            "longitude": 106.178253,
            "latitude": 56.975853
        },
        "4295": {
            "name": "Анга",
            "population": 863,
            "type": "village",
            "poly": null,
            "longitude": 106.190826,
            "latitude": 53.981197
        },
        "4296": {
            "name": "Казарки",
            "population": 750,
            "type": "village",
            "poly": null,
            "longitude": 106.19738,
            "latitude": 56.999363
        },
        "4297": {
            "name": "Куреть",
            "population": 511,
            "type": "village",
            "poly": [
                [
                    [
                        106.1892721,
                        52.8185469
                    ],
                    [
                        106.1895466,
                        52.8191443
                    ],
                    [
                        106.1937204,
                        52.8191111
                    ],
                    [
                        106.193995,
                        52.82087
                    ],
                    [
                        106.1919081,
                        52.8214342
                    ],
                    [
                        106.1914139,
                        52.8245867
                    ],
                    [
                        106.1900959,
                        52.8247858
                    ],
                    [
                        106.1908647,
                        52.8267104
                    ],
                    [
                        106.2000907,
                        52.8237571
                    ],
                    [
                        106.2035505,
                        52.8246863
                    ],
                    [
                        106.2087674,
                        52.8243544
                    ],
                    [
                        106.2107445,
                        52.8237239
                    ],
                    [
                        106.2121175,
                        52.8251509
                    ],
                    [
                        106.2142043,
                        52.8247527
                    ],
                    [
                        106.2114035,
                        52.8210691
                    ],
                    [
                        106.2176091,
                        52.8196089
                    ],
                    [
                        106.2210689,
                        52.8176508
                    ],
                    [
                        106.2184878,
                        52.8148628
                    ],
                    [
                        106.216346,
                        52.8154934
                    ],
                    [
                        106.2159067,
                        52.8143316
                    ],
                    [
                        106.2140395,
                        52.8146305
                    ],
                    [
                        106.2099757,
                        52.8165223
                    ],
                    [
                        106.209097,
                        52.8156261
                    ],
                    [
                        106.2080536,
                        52.8161904
                    ],
                    [
                        106.2088225,
                        52.8172857
                    ],
                    [
                        106.207834,
                        52.8175511
                    ],
                    [
                        106.2070651,
                        52.816821
                    ],
                    [
                        106.2028366,
                        52.8174516
                    ],
                    [
                        106.202562,
                        52.8186464
                    ],
                    [
                        106.2016833,
                        52.8186796
                    ],
                    [
                        106.201244,
                        52.8166219
                    ],
                    [
                        106.2006947,
                        52.8161904
                    ],
                    [
                        106.1997063,
                        52.8166219
                    ],
                    [
                        106.1995965,
                        52.8174848
                    ],
                    [
                        106.1989375,
                        52.8174848
                    ],
                    [
                        106.1987178,
                        52.8148628
                    ],
                    [
                        106.1920729,
                        52.8165886
                    ],
                    [
                        106.1927867,
                        52.8177503
                    ],
                    [
                        106.1892721,
                        52.8185469
                    ]
                ],
                [
                    [
                        106.2220574,
                        52.8114772
                    ],
                    [
                        106.223259,
                        52.8119994
                    ],
                    [
                        106.2229978,
                        52.8125833
                    ],
                    [
                        106.2239795,
                        52.8133691
                    ],
                    [
                        106.225572,
                        52.8136015
                    ],
                    [
                        106.2278235,
                        52.8105477
                    ],
                    [
                        106.2245835,
                        52.8098506
                    ],
                    [
                        106.2240893,
                        52.8105144
                    ],
                    [
                        106.222936,
                        52.8103154
                    ],
                    [
                        106.2220574,
                        52.8114772
                    ]
                ]
            ],
            "longitude": 106.204536,
            "latitude": 52.820736
        },
        "4298": {
            "name": "Вершина Тутуры",
            "population": 183,
            "type": "village",
            "poly": null,
            "longitude": 106.206078,
            "latitude": 54.434906
        },
        "4299": {
            "name": "Бирюлька",
            "population": 606,
            "type": "village",
            "poly": null,
            "longitude": 106.325554,
            "latitude": 53.865189
        },
        "4300": {
            "name": "Залог",
            "population": 191,
            "type": "village",
            "poly": null,
            "longitude": 106.3872811,
            "latitude": 53.9364477
        },
        "4301": {
            "name": "Звёздный",
            "population": 902,
            "type": "village",
            "poly": [
                [
                    106.4688585,
                    56.7531623
                ],
                [
                    106.4708026,
                    56.7547704
                ],
                [
                    106.4745341,
                    56.7555045
                ],
                [
                    106.4801195,
                    56.7567255
                ],
                [
                    106.4824412,
                    56.7589204
                ],
                [
                    106.4822266,
                    56.761087
                ],
                [
                    106.4840162,
                    56.7629229
                ],
                [
                    106.4901123,
                    56.762209
                ],
                [
                    106.4896553,
                    56.7610117
                ],
                [
                    106.484705,
                    56.7560879
                ],
                [
                    106.4826579,
                    56.7536199
                ],
                [
                    106.4851277,
                    56.7505906
                ],
                [
                    106.4914227,
                    56.7497319
                ],
                [
                    106.4974308,
                    56.7489789
                ],
                [
                    106.5001774,
                    56.7497319
                ],
                [
                    106.5036106,
                    56.7503908
                ],
                [
                    106.5077304,
                    56.7508614
                ],
                [
                    106.5079021,
                    56.7517084
                ],
                [
                    106.5084171,
                    56.7534966
                ],
                [
                    106.5097904,
                    56.7552847
                ],
                [
                    106.511507,
                    56.7566022
                ],
                [
                    106.5128803,
                    56.7566022
                ],
                [
                    106.5147686,
                    56.756414
                ],
                [
                    106.5149403,
                    56.7567904
                ],
                [
                    106.5171718,
                    56.7583901
                ],
                [
                    106.5204334,
                    56.7580137
                ],
                [
                    106.5207767,
                    56.7571668
                ],
                [
                    106.5207767,
                    56.7553788
                ],
                [
                    106.5195751,
                    56.7529319
                ],
                [
                    106.5195751,
                    56.7506731
                ],
                [
                    106.524725,
                    56.7500143
                ],
                [
                    106.5281581,
                    56.7520849
                ],
                [
                    106.5303898,
                    56.7519908
                ],
                [
                    106.5240383,
                    56.7476612
                ],
                [
                    106.5238266,
                    56.745116
                ],
                [
                    106.5222838,
                    56.7423613
                ],
                [
                    106.5108211,
                    56.7422213
                ],
                [
                    106.5056862,
                    56.743178
                ],
                [
                    106.4927216,
                    56.7466338
                ],
                [
                    106.4829905,
                    56.7481164
                ],
                [
                    106.4768314,
                    56.7496378
                ],
                [
                    106.4700365,
                    56.7515377
                ],
                [
                    106.4688585,
                    56.7531623
                ]
            ],
            "longitude": 106.505241,
            "latitude": 56.747498
        },
        "4302": {
            "name": "Большая Тарель",
            "population": 198,
            "type": "village",
            "poly": null,
            "longitude": 106.622009,
            "latitude": 53.756737
        },
        "4303": {
            "name": "Шара-Тогот",
            "population": 375,
            "type": "village",
            "poly": [
                [
                    106.7056497,
                    52.9987848
                ],
                [
                    106.7064511,
                    53.0000355
                ],
                [
                    106.707804,
                    53.0008139
                ],
                [
                    106.7072752,
                    53.0024845
                ],
                [
                    106.7077001,
                    53.0038761
                ],
                [
                    106.7089455,
                    53.0047091
                ],
                [
                    106.7097914,
                    53.004156
                ],
                [
                    106.7128319,
                    53.0065078
                ],
                [
                    106.7141466,
                    53.0061995
                ],
                [
                    106.7168437,
                    53.0073235
                ],
                [
                    106.7185931,
                    53.0080905
                ],
                [
                    106.7208896,
                    53.0090367
                ],
                [
                    106.7228463,
                    53.00866
                ],
                [
                    106.7232459,
                    53.0071662
                ],
                [
                    106.7196401,
                    53.0059604
                ],
                [
                    106.7181895,
                    53.0049976
                ],
                [
                    106.7166039,
                    53.0018845
                ],
                [
                    106.7133498,
                    53.0010016
                ],
                [
                    106.7109967,
                    52.9995596
                ],
                [
                    106.7091088,
                    52.9989413
                ],
                [
                    106.7079756,
                    52.9989285
                ],
                [
                    106.7068169,
                    52.9984378
                ],
                [
                    106.7056497,
                    52.9987848
                ]
            ],
            "longitude": 106.713257,
            "latitude": 53.004662
        },
        "4304": {
            "name": "Ния",
            "population": 1062,
            "type": "village",
            "poly": null,
            "longitude": 106.803078,
            "latitude": 56.553173
        },
        "4305": {
            "name": "Лесоучасток Ханда",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.0085822,
            "latitude": 55.1248774
        },
        "4306": {
            "name": "Верхнемарково",
            "population": 1619,
            "type": "village",
            "poly": null,
            "longitude": 107.025002,
            "latitude": 57.324944
        },
        "4307": {
            "name": "Небель",
            "population": 138,
            "type": "village",
            "poly": null,
            "longitude": 107.068428,
            "latitude": 56.372726
        },
        "4308": {
            "name": "Заярново",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 107.09066,
            "latitude": 57.335533
        },
        "4309": {
            "name": "Небель",
            "population": 299,
            "type": "village",
            "poly": null,
            "longitude": 107.1061814,
            "latitude": 56.3552687
        },
        "4310": {
            "name": "Типуй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.2326754,
            "latitude": 55.41435
        },
        "4311": {
            "name": "Хужир",
            "population": 1251,
            "type": "village",
            "poly": [
                [
                    107.3305948,
                    53.1920448
                ],
                [
                    107.3309121,
                    53.194983
                ],
                [
                    107.3358676,
                    53.1980311
                ],
                [
                    107.342356,
                    53.2022833
                ],
                [
                    107.3498223,
                    53.2000569
                ],
                [
                    107.3529716,
                    53.1999211
                ],
                [
                    107.3545639,
                    53.1994889
                ],
                [
                    107.3574088,
                    53.193808
                ],
                [
                    107.3569183,
                    53.1910848
                ],
                [
                    107.3553814,
                    53.1881654
                ],
                [
                    107.3394892,
                    53.1863628
                ],
                [
                    107.3334163,
                    53.1871682
                ],
                [
                    107.3305948,
                    53.1920448
                ]
            ],
            "longitude": 107.345734,
            "latitude": 53.192001
        },
        "4312": {
            "name": "Ключи",
            "population": 1076,
            "type": "village",
            "poly": null,
            "longitude": 107.492271,
            "latitude": 56.198742
        },
        "4313": {
            "name": "Казачинское",
            "population": 2624,
            "type": "village",
            "poly": null,
            "longitude": 107.567009,
            "latitude": 56.271587
        },
        "4314": {
            "name": "Онгурен",
            "population": 423,
            "type": "village",
            "poly": [
                [
                    107.5786413,
                    53.6292106
                ],
                [
                    107.583494,
                    53.6300984
                ],
                [
                    107.5847845,
                    53.6309862
                ],
                [
                    107.5828228,
                    53.6317515
                ],
                [
                    107.5882433,
                    53.6351798
                ],
                [
                    107.5905664,
                    53.6386996
                ],
                [
                    107.5954707,
                    53.6417296
                ],
                [
                    107.6000652,
                    53.642709
                ],
                [
                    107.6012009,
                    53.6425559
                ],
                [
                    107.5998071,
                    53.6388527
                ],
                [
                    107.6008395,
                    53.6382406
                ],
                [
                    107.6025947,
                    53.6360063
                ],
                [
                    107.6007879,
                    53.6304658
                ],
                [
                    107.5967613,
                    53.6305576
                ],
                [
                    107.5951609,
                    53.6312005
                ],
                [
                    107.5938187,
                    53.6295474
                ],
                [
                    107.5976389,
                    53.6281086
                ],
                [
                    107.595006,
                    53.6262411
                ],
                [
                    107.5925281,
                    53.6265472
                ],
                [
                    107.5892758,
                    53.6244041
                ],
                [
                    107.5883466,
                    53.624802
                ],
                [
                    107.5851459,
                    53.6226283
                ],
                [
                    107.58019,
                    53.6256594
                ],
                [
                    107.5786413,
                    53.6292106
                ]
            ],
            "longitude": 107.591805,
            "latitude": 53.632732
        },
        "4315": {
            "name": "Карам",
            "population": 352,
            "type": "village",
            "poly": null,
            "longitude": 107.602669,
            "latitude": 55.144192
        },
        "4316": {
            "name": "Окунайский",
            "population": 945,
            "type": "village",
            "poly": [
                [
                    107.680993,
                    56.0259944
                ],
                [
                    107.6825809,
                    56.0266659
                ],
                [
                    107.6839756,
                    56.0264261
                ],
                [
                    107.6876449,
                    56.0285484
                ],
                [
                    107.691121,
                    56.0287762
                ],
                [
                    107.6932453,
                    56.0276731
                ],
                [
                    107.694404,
                    56.025155
                ],
                [
                    107.6950049,
                    56.0243996
                ],
                [
                    107.6950049,
                    56.023716
                ],
                [
                    107.6939749,
                    56.0230445
                ],
                [
                    107.6944684,
                    56.0220612
                ],
                [
                    107.6954769,
                    56.0220252
                ],
                [
                    107.6956271,
                    56.0212457
                ],
                [
                    107.6965284,
                    56.01736
                ],
                [
                    107.6967,
                    56.0155129
                ],
                [
                    107.6939105,
                    56.015405
                ],
                [
                    107.6931166,
                    56.0181156
                ],
                [
                    107.6899623,
                    56.0179476
                ],
                [
                    107.6902413,
                    56.0168442
                ],
                [
                    107.6878595,
                    56.0166883
                ],
                [
                    107.6872157,
                    56.0182835
                ],
                [
                    107.6847266,
                    56.0181995
                ],
                [
                    107.6830315,
                    56.0227207
                ],
                [
                    107.681744,
                    56.0236681
                ],
                [
                    107.680993,
                    56.0259944
                ]
            ],
            "longitude": 107.692711,
            "latitude": 56.022797
        },
        "4317": {
            "name": "Улькан",
            "population": 4948,
            "type": "village",
            "poly": null,
            "longitude": 107.796234,
            "latitude": 55.898624
        },
        "4318": {
            "name": "Макарово",
            "population": 721,
            "type": "village",
            "poly": null,
            "longitude": 107.8226456,
            "latitude": 57.483761
        },
        "4319": {
            "name": "Кривая Лука",
            "population": 388,
            "type": "village",
            "poly": null,
            "longitude": 107.828651,
            "latitude": 57.598648
        },
        "4320": {
            "name": "Кривошапкино",
            "population": 404,
            "type": "village",
            "poly": null,
            "longitude": 108.00312,
            "latitude": 57.749043
        },
        "4321": {
            "name": "Ербогачён",
            "population": 1965,
            "type": "village",
            "poly": null,
            "longitude": 108.009712,
            "latitude": 61.275021
        },
        "4322": {
            "name": "Преображенка",
            "population": 440,
            "type": "village",
            "poly": null,
            "longitude": 108.093475,
            "latitude": 60.023071
        },
        "4323": {
            "name": "Верхнемартыново",
            "population": 89,
            "type": "village",
            "poly": null,
            "longitude": 108.173943,
            "latitude": 56.887745
        },
        "4324": {
            "name": "Непа",
            "population": 297,
            "type": "village",
            "poly": null,
            "longitude": 108.230072,
            "latitude": 59.244469
        },
        "4325": {
            "name": "Бубновка",
            "population": 569,
            "type": "village",
            "poly": null,
            "longitude": 108.237206,
            "latitude": 57.754318
        },
        "4326": {
            "name": "Алексеевск",
            "population": 2253,
            "type": "village",
            "poly": null,
            "longitude": 108.349243,
            "latitude": 57.840553
        },
        "4327": {
            "name": "Подволошино",
            "population": 467,
            "type": "village",
            "poly": null,
            "longitude": 108.42588,
            "latitude": 58.248753
        },
        "4328": {
            "name": "Кунерма",
            "population": 36,
            "type": "village",
            "poly": null,
            "longitude": 108.450508,
            "latitude": 55.76088
        },
        "4329": {
            "name": "Алымовка",
            "population": 305,
            "type": "village",
            "poly": null,
            "longitude": 108.577133,
            "latitude": 57.962002
        },
        "4330": {
            "name": "Юбилейный",
            "population": 471,
            "type": "village",
            "poly": null,
            "longitude": 108.844482,
            "latitude": 58.129013
        },
        "4331": {
            "name": "Петропавловское",
            "population": 366,
            "type": "village",
            "poly": null,
            "longitude": 108.969841,
            "latitude": 58.208157
        },
        "4332": {
            "name": "Коршуново",
            "population": 153,
            "type": "village",
            "poly": null,
            "longitude": 110.14315,
            "latitude": 58.595627
        },
        "4333": {
            "name": "Визирный",
            "population": 128,
            "type": "village",
            "poly": null,
            "longitude": 111.254478,
            "latitude": 58.893734
        },
        "4334": {
            "name": "Горно-Чуйский",
            "population": 197,
            "type": "village",
            "poly": null,
            "longitude": 111.756447,
            "latitude": 57.64352
        },
        "4335": {
            "name": "Согдиондон",
            "population": 202,
            "type": "village",
            "poly": [
                [
                    112.1551573,
                    57.6921159
                ],
                [
                    112.155291,
                    57.6948508
                ],
                [
                    112.1581339,
                    57.694672
                ],
                [
                    112.1594049,
                    57.6947793
                ],
                [
                    112.1597059,
                    57.6951725
                ],
                [
                    112.1598397,
                    57.6957802
                ],
                [
                    112.160542,
                    57.6967811
                ],
                [
                    112.1665623,
                    57.6962986
                ],
                [
                    112.1665957,
                    57.6945111
                ],
                [
                    112.1674653,
                    57.6936174
                ],
                [
                    112.1790376,
                    57.6930096
                ],
                [
                    112.1789372,
                    57.6920086
                ],
                [
                    112.1783687,
                    57.6915617
                ],
                [
                    112.1766295,
                    57.691383
                ],
                [
                    112.1711109,
                    57.691383
                ],
                [
                    112.1709102,
                    57.690364
                ],
                [
                    112.1687028,
                    57.690364
                ],
                [
                    112.165793,
                    57.6899171
                ],
                [
                    112.16489,
                    57.6902925
                ],
                [
                    112.1637863,
                    57.690364
                ],
                [
                    112.1626826,
                    57.6903461
                ],
                [
                    112.1607762,
                    57.6901316
                ],
                [
                    112.1592042,
                    57.6900601
                ],
                [
                    112.157465,
                    57.6903104
                ],
                [
                    112.1564951,
                    57.6906322
                ],
                [
                    112.1560603,
                    57.6913651
                ],
                [
                    112.1559265,
                    57.6917047
                ],
                [
                    112.1551573,
                    57.6921159
                ]
            ],
            "longitude": 112.162773,
            "latitude": 57.691994
        },
        "4336": {
            "name": "Луговский",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 112.8805867,
            "latitude": 58.0642429
        },
        "4337": {
            "name": "Витимский",
            "population": 300,
            "type": "village",
            "poly": null,
            "longitude": 113.262604,
            "latitude": 58.219967
        },
        "4338": {
            "name": "Мамакан",
            "population": 1724,
            "type": "village",
            "poly": null,
            "longitude": 114.018379,
            "latitude": 57.817467
        },
        "4339": {
            "name": "Балахнинский",
            "population": 1092,
            "type": "village",
            "poly": null,
            "longitude": 114.277977,
            "latitude": 58.010555
        },
        "4340": {
            "name": "Маракан",
            "population": 386,
            "type": "village",
            "poly": null,
            "longitude": 114.589676,
            "latitude": 58.699581
        },
        "4341": {
            "name": "Артёмовский",
            "population": 1341,
            "type": "village",
            "poly": null,
            "longitude": 114.628464,
            "latitude": 58.205444
        },
        "4342": {
            "name": "Кропоткин",
            "population": 1454,
            "type": "village",
            "poly": null,
            "longitude": 115.300003,
            "latitude": 58.503822
        },
        "4343": {
            "name": "",
            "population": 873,
            "type": "village",
            "poly": null,
            "longitude": 116.9185714,
            "latitude": 59.0030481
        },
        "4344": {
            "name": "Новосельское",
            "population": 827,
            "type": "village",
            "poly": null,
            "longitude": 78.148651,
            "latitude": 53.51746
        },
        "4345": {
            "name": "Михайловка",
            "population": 858,
            "type": "village",
            "poly": null,
            "longitude": 78.1601485,
            "latitude": 53.2450884
        },
        "4346": {
            "name": "Орехово",
            "population": 540,
            "type": "village",
            "poly": null,
            "longitude": 78.2079218,
            "latitude": 53.1309923
        },
        "4347": {
            "name": "Притыка",
            "population": 277,
            "type": "village",
            "poly": null,
            "longitude": 78.2388944,
            "latitude": 53.2645649
        },
        "4348": {
            "name": "Бурла",
            "population": 4026,
            "type": "village",
            "poly": [
                [
                    78.3100216,
                    53.326412
                ],
                [
                    78.3108433,
                    53.3364126
                ],
                [
                    78.333011,
                    53.3488023
                ],
                [
                    78.342265,
                    53.354629
                ],
                [
                    78.3493603,
                    53.3506635
                ],
                [
                    78.3554117,
                    53.3512572
                ],
                [
                    78.362917,
                    53.3506884
                ],
                [
                    78.3647791,
                    53.3447265
                ],
                [
                    78.3645786,
                    53.3400664
                ],
                [
                    78.3622602,
                    53.3326767
                ],
                [
                    78.352068,
                    53.3234486
                ],
                [
                    78.3292776,
                    53.313227
                ],
                [
                    78.3126881,
                    53.3201493
                ],
                [
                    78.3100216,
                    53.326412
                ]
            ],
            "longitude": 78.3306842,
            "latitude": 53.3364288
        },
        "4349": {
            "name": "Партизанское",
            "population": 542,
            "type": "village",
            "poly": null,
            "longitude": 78.3515271,
            "latitude": 53.3459537
        },
        "4350": {
            "name": "Новоандреевка",
            "population": 281,
            "type": "village",
            "poly": null,
            "longitude": 78.3803152,
            "latitude": 53.0404751
        },
        "4351": {
            "name": "Гусиная Ляга",
            "population": 275,
            "type": "village",
            "poly": null,
            "longitude": 78.39662,
            "latitude": 53.4073133
        },
        "4352": {
            "name": "Покровка",
            "population": 507,
            "type": "village",
            "poly": null,
            "longitude": 78.4038821,
            "latitude": 52.9645039
        },
        "4353": {
            "name": "Граничное",
            "population": 260,
            "type": "village",
            "poly": null,
            "longitude": 78.4323929,
            "latitude": 52.8020678
        },
        "4354": {
            "name": "Камышенка",
            "population": 401,
            "type": "village",
            "poly": null,
            "longitude": 78.4438877,
            "latitude": 52.7594817
        },
        "4355": {
            "name": "Бурсоль",
            "population": 654,
            "type": "village",
            "poly": null,
            "longitude": 78.447762,
            "latitude": 53.167122
        },
        "4356": {
            "name": "Новопесчаное",
            "population": 774,
            "type": "village",
            "poly": [
                [
                    78.5166653,
                    53.411727
                ],
                [
                    78.5192046,
                    53.421984
                ],
                [
                    78.5247062,
                    53.4233289
                ],
                [
                    78.5306253,
                    53.4221723
                ],
                [
                    78.5294064,
                    53.4174914
                ],
                [
                    78.5315732,
                    53.4106305
                ],
                [
                    78.5374415,
                    53.4037685
                ],
                [
                    78.5411403,
                    53.4015937
                ],
                [
                    78.539325,
                    53.394024
                ],
                [
                    78.530772,
                    53.3906167
                ],
                [
                    78.5195573,
                    53.4024347
                ],
                [
                    78.5166653,
                    53.411727
                ]
            ],
            "longitude": 78.525757,
            "latitude": 53.407501
        },
        "4357": {
            "name": "Селекционное",
            "population": 1214,
            "type": "village",
            "poly": null,
            "longitude": 78.5954156,
            "latitude": 52.9807137
        },
        "4358": {
            "name": "Архангельское",
            "population": 282,
            "type": "village",
            "poly": null,
            "longitude": 78.6461432,
            "latitude": 53.0865182
        },
        "4359": {
            "name": "Славгородское",
            "population": 3557,
            "type": "village",
            "poly": null,
            "longitude": 78.6484845,
            "latitude": 53.0225426
        },
        "4360": {
            "name": "Пригородное",
            "population": 524,
            "type": "village",
            "poly": null,
            "longitude": 78.687943,
            "latitude": 53.0024302
        },
        "4361": {
            "name": "Александровка",
            "population": 278,
            "type": "village",
            "poly": null,
            "longitude": 78.6949385,
            "latitude": 52.7136103
        },
        "4362": {
            "name": "Лесное",
            "population": 594,
            "type": "village",
            "poly": null,
            "longitude": 78.7106722,
            "latitude": 53.5264264
        },
        "4363": {
            "name": "Пионер Труда",
            "population": 321,
            "type": "village",
            "poly": null,
            "longitude": 79.0868506,
            "latitude": 53.5470713
        },
        "4364": {
            "name": "Николаевка",
            "population": 1077,
            "type": "village",
            "poly": null,
            "longitude": 78.721214,
            "latitude": 53.221813
        },
        "4365": {
            "name": "Устьянка",
            "population": 982,
            "type": "village",
            "poly": null,
            "longitude": 78.7421093,
            "latitude": 53.451325
        },
        "4366": {
            "name": "Гришковка",
            "population": 1330,
            "type": "village",
            "poly": null,
            "longitude": 78.750702,
            "latitude": 53.14864
        },
        "4367": {
            "name": "Алтайское",
            "population": 1499,
            "type": "village",
            "poly": [
                [
                    78.7428341,
                    52.7961887
                ],
                [
                    78.751176,
                    52.803864
                ],
                [
                    78.7625307,
                    52.8039613
                ],
                [
                    78.7667568,
                    52.7994781
                ],
                [
                    78.7739749,
                    52.7855743
                ],
                [
                    78.7804753,
                    52.7722059
                ],
                [
                    78.7687513,
                    52.7704115
                ],
                [
                    78.7626655,
                    52.7778348
                ],
                [
                    78.7501515,
                    52.7758619
                ],
                [
                    78.7471827,
                    52.7856066
                ],
                [
                    78.7428341,
                    52.7961887
                ]
            ],
            "longitude": 78.761589,
            "latitude": 52.785633
        },
        "4368": {
            "name": "Камыши",
            "population": 580,
            "type": "village",
            "poly": null,
            "longitude": 78.780266,
            "latitude": 53.336258
        },
        "4369": {
            "name": "Забавное",
            "population": 322,
            "type": "village",
            "poly": null,
            "longitude": 78.79203,
            "latitude": 52.831821
        },
        "4370": {
            "name": "Табуны",
            "population": 3876,
            "type": "village",
            "poly": [
                [
                    78.7773281,
                    52.7838635
                ],
                [
                    78.780153,
                    52.7866352
                ],
                [
                    78.7969773,
                    52.7899002
                ],
                [
                    78.8102233,
                    52.779269
                ],
                [
                    78.8023134,
                    52.7768766
                ],
                [
                    78.8059544,
                    52.769129
                ],
                [
                    78.7928968,
                    52.7564032
                ],
                [
                    78.7773281,
                    52.7838635
                ]
            ],
            "longitude": 78.792534,
            "latitude": 52.769409
        },
        "4371": {
            "name": "Большеромановка",
            "population": 868,
            "type": "village",
            "poly": [
                [
                    78.838755,
                    52.9899932
                ],
                [
                    78.8401283,
                    52.9919565
                ],
                [
                    78.8463081,
                    52.9905098
                ],
                [
                    78.8528313,
                    52.9915431
                ],
                [
                    78.8557495,
                    52.9941263
                ],
                [
                    78.8567795,
                    52.9984656
                ],
                [
                    78.8573206,
                    53.0016145
                ],
                [
                    78.8607254,
                    53.0011512
                ],
                [
                    78.8619146,
                    53.0026041
                ],
                [
                    78.8627029,
                    53.0024105
                ],
                [
                    78.8667101,
                    53.0082723
                ],
                [
                    78.8716899,
                    53.0074789
                ],
                [
                    78.8724007,
                    52.9972258
                ],
                [
                    78.8748039,
                    52.9939196
                ],
                [
                    78.8754906,
                    52.9896832
                ],
                [
                    78.8663925,
                    52.9842062
                ],
                [
                    78.8612427,
                    52.9833793
                ],
                [
                    78.8531746,
                    52.9828627
                ],
                [
                    78.8445486,
                    52.985157
                ],
                [
                    78.8394417,
                    52.9868931
                ],
                [
                    78.838755,
                    52.9899932
                ]
            ],
            "longitude": 78.8637759,
            "latitude": 52.9923021
        },
        "4372": {
            "name": "Удальное",
            "population": 239,
            "type": "village",
            "poly": null,
            "longitude": 78.8646412,
            "latitude": 52.8189717
        },
        "4373": {
            "name": "Октябрьский",
            "population": 1263,
            "type": "village",
            "poly": null,
            "longitude": 78.877045,
            "latitude": 52.564869
        },
        "4374": {
            "name": "Топольное",
            "population": 433,
            "type": "village",
            "poly": null,
            "longitude": 78.8881758,
            "latitude": 53.5442171
        },
        "4375": {
            "name": "Самбор",
            "population": 327,
            "type": "village",
            "poly": null,
            "longitude": 78.8970184,
            "latitude": 52.7740262
        },
        "4376": {
            "name": "Новопетровка",
            "population": 378,
            "type": "village",
            "poly": null,
            "longitude": 78.9144959,
            "latitude": 52.5336642
        },
        "4377": {
            "name": "Подсосново",
            "population": 2093,
            "type": "village",
            "poly": [
                [
                    78.9037902,
                    53.3793887
                ],
                [
                    78.9214407,
                    53.3868352
                ],
                [
                    78.9377996,
                    53.3715556
                ],
                [
                    78.9246694,
                    53.3652624
                ],
                [
                    78.9121849,
                    53.368088
                ],
                [
                    78.9055122,
                    53.372583
                ],
                [
                    78.9037902,
                    53.3793887
                ]
            ],
            "longitude": 78.916634,
            "latitude": 53.371777
        },
        "4378": {
            "name": "Курск",
            "population": 825,
            "type": "village",
            "poly": null,
            "longitude": 78.9225201,
            "latitude": 52.4431763
        },
        "4379": {
            "name": "Шумановка",
            "population": 1222,
            "type": "village",
            "poly": [
                [
                    78.9074419,
                    53.2613276
                ],
                [
                    78.9322655,
                    53.266455
                ],
                [
                    78.9349133,
                    53.2636637
                ],
                [
                    78.9362703,
                    53.2606544
                ],
                [
                    78.938598,
                    53.2590422
                ],
                [
                    78.9403745,
                    53.257348
                ],
                [
                    78.93819,
                    53.2563975
                ],
                [
                    78.9366073,
                    53.2555289
                ],
                [
                    78.9280217,
                    53.2533403
                ],
                [
                    78.9167425,
                    53.2506946
                ],
                [
                    78.9074419,
                    53.2613276
                ]
            ],
            "longitude": 78.92395,
            "latitude": 53.258389
        },
        "4380": {
            "name": "Кусак",
            "population": 1538,
            "type": "village",
            "poly": null,
            "longitude": 78.936996,
            "latitude": 53.222637
        },
        "4381": {
            "name": "Васильчуки",
            "population": 1154,
            "type": "village",
            "poly": [
                [
                    78.9229909,
                    52.2795562
                ],
                [
                    78.9288775,
                    52.283692
                ],
                [
                    78.95645,
                    52.2880977
                ],
                [
                    78.9688973,
                    52.2829869
                ],
                [
                    78.9776794,
                    52.2856204
                ],
                [
                    78.9833345,
                    52.2675531
                ],
                [
                    78.9801783,
                    52.2594347
                ],
                [
                    78.9551076,
                    52.2613277
                ],
                [
                    78.9430674,
                    52.2657069
                ],
                [
                    78.9250077,
                    52.2621173
                ],
                [
                    78.9229909,
                    52.2795562
                ]
            ],
            "longitude": 78.952232,
            "latitude": 52.27457
        },
        "4382": {
            "name": "Мышкино",
            "population": 374,
            "type": "village",
            "poly": null,
            "longitude": 78.965624,
            "latitude": 52.5823042
        },
        "4383": {
            "name": "Семёновка",
            "population": 705,
            "type": "village",
            "poly": [
                [
                    78.9655699,
                    53.088068
                ],
                [
                    78.9662994,
                    53.0952585
                ],
                [
                    78.9714493,
                    53.0980415
                ],
                [
                    78.981234,
                    53.0988661
                ],
                [
                    78.9867271,
                    53.0975262
                ],
                [
                    78.9932503,
                    53.0935112
                ],
                [
                    78.9939369,
                    53.0919649
                ],
                [
                    78.9927353,
                    53.0863978
                ],
                [
                    78.9871992,
                    53.083119
                ],
                [
                    78.9798607,
                    53.0805206
                ],
                [
                    78.9724792,
                    53.0827891
                ],
                [
                    78.9674582,
                    53.0848719
                ],
                [
                    78.9655699,
                    53.088068
                ]
            ],
            "longitude": 78.9803302,
            "latitude": 53.0909677
        },
        "4384": {
            "name": "Гальбштадт",
            "population": 1750,
            "type": "village",
            "poly": [
                [
                    78.9746786,
                    53.2185864
                ],
                [
                    78.9772866,
                    53.2273505
                ],
                [
                    78.9748468,
                    53.230624
                ],
                [
                    78.9804835,
                    53.2362135
                ],
                [
                    78.9891488,
                    53.2388821
                ],
                [
                    78.9920092,
                    53.2362638
                ],
                [
                    79.0090033,
                    53.222062
                ],
                [
                    78.9936917,
                    53.2172767
                ],
                [
                    78.9752675,
                    53.2140525
                ],
                [
                    78.9746786,
                    53.2185864
                ]
            ],
            "longitude": 78.988144,
            "latitude": 53.225803
        },
        "4385": {
            "name": "Мирабилит",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 79.0237651,
            "latitude": 52.5635322
        },
        "4386": {
            "name": "Редкая Дубрава",
            "population": 1275,
            "type": "village",
            "poly": null,
            "longitude": 79.041542,
            "latitude": 53.280098
        },
        "4387": {
            "name": "Богатское",
            "population": 325,
            "type": "village",
            "poly": null,
            "longitude": 79.051984,
            "latitude": 53.4683252
        },
        "4388": {
            "name": "Воздвиженка",
            "population": 233,
            "type": "village",
            "poly": null,
            "longitude": 79.0662673,
            "latitude": 52.7576699
        },
        "4389": {
            "name": "Константиновка",
            "population": 344,
            "type": "village",
            "poly": null,
            "longitude": 79.0721965,
            "latitude": 52.6179794
        },
        "4390": {
            "name": "Виноградовка",
            "population": 236,
            "type": "village",
            "poly": null,
            "longitude": 79.0831102,
            "latitude": 52.4622941
        },
        "4391": {
            "name": "Новофёдоровка",
            "population": 82,
            "type": "village",
            "poly": null,
            "longitude": 79.1156426,
            "latitude": 53.6642724
        },
        "4392": {
            "name": "Саратовка",
            "population": 183,
            "type": "village",
            "poly": null,
            "longitude": 79.1224039,
            "latitude": 52.8799005
        },
        "4393": {
            "name": "Протасово",
            "population": 1174,
            "type": "village",
            "poly": null,
            "longitude": 79.171829,
            "latitude": 53.423397
        },
        "4394": {
            "name": "Нововознесенка",
            "population": 932,
            "type": "village",
            "poly": [
                [
                    79.1685739,
                    53.1366427
                ],
                [
                    79.1687482,
                    53.1410085
                ],
                [
                    79.1728531,
                    53.1422307
                ],
                [
                    79.1910555,
                    53.1365639
                ],
                [
                    79.1954811,
                    53.1327787
                ],
                [
                    79.1948031,
                    53.1301601
                ],
                [
                    79.1837012,
                    53.1334142
                ],
                [
                    79.182091,
                    53.1321431
                ],
                [
                    79.1685739,
                    53.1366427
                ]
            ],
            "longitude": 79.180575,
            "latitude": 53.1366425
        },
        "4395": {
            "name": "Сереброполь",
            "population": 1105,
            "type": "village",
            "poly": null,
            "longitude": 79.20443,
            "latitude": 52.883896
        },
        "4396": {
            "name": "Хорошее",
            "population": 329,
            "type": "village",
            "poly": null,
            "longitude": 79.213791,
            "latitude": 52.939808
        },
        "4397": {
            "name": "Полевое",
            "population": 1134,
            "type": "village",
            "poly": null,
            "longitude": 79.2287848,
            "latitude": 53.3835077
        },
        "4398": {
            "name": "Целинный",
            "population": 1189,
            "type": "village",
            "poly": null,
            "longitude": 79.2330146,
            "latitude": 52.2564531
        },
        "4399": {
            "name": "Орлово",
            "population": 1439,
            "type": "village",
            "poly": null,
            "longitude": 79.2379171,
            "latitude": 53.3184179
        },
        "4400": {
            "name": "Смирненькое",
            "population": 316,
            "type": "village",
            "poly": null,
            "longitude": 79.24379,
            "latitude": 52.527794
        },
        "4401": {
            "name": "Новоильинка",
            "population": 1757,
            "type": "village",
            "poly": null,
            "longitude": 79.260155,
            "latitude": 53.560623
        },
        "4402": {
            "name": "Златополь",
            "population": 700,
            "type": "village",
            "poly": null,
            "longitude": 79.263321,
            "latitude": 52.627815
        },
        "4403": {
            "name": "Северка",
            "population": 1562,
            "type": "village",
            "poly": null,
            "longitude": 79.271057,
            "latitude": 52.126987
        },
        "4404": {
            "name": "Истимис",
            "population": 604,
            "type": "village",
            "poly": null,
            "longitude": 79.2914701,
            "latitude": 52.3682809
        },
        "4405": {
            "name": "Лебедино",
            "population": 564,
            "type": "village",
            "poly": null,
            "longitude": 79.2989979,
            "latitude": 52.7862204
        },
        "4406": {
            "name": "Семёновка",
            "population": 404,
            "type": "village",
            "poly": null,
            "longitude": 79.322151,
            "latitude": 52.55624
        },
        "4407": {
            "name": "Рассвет",
            "population": 363,
            "type": "village",
            "poly": null,
            "longitude": 79.3256078,
            "latitude": 53.5016467
        },
        "4408": {
            "name": "Новополтава",
            "population": 810,
            "type": "village",
            "poly": null,
            "longitude": 79.3382532,
            "latitude": 52.4132456
        },
        "4409": {
            "name": "Успенка",
            "population": 239,
            "type": "village",
            "poly": null,
            "longitude": 79.3487449,
            "latitude": 52.9253833
        },
        "4410": {
            "name": "Дегтярка",
            "population": 1303,
            "type": "village",
            "poly": null,
            "longitude": 79.357559,
            "latitude": 53.344326
        },
        "4411": {
            "name": "Покровка",
            "population": 481,
            "type": "village",
            "poly": null,
            "longitude": 79.3641106,
            "latitude": 52.0468272
        },
        "4412": {
            "name": "Елизаветград",
            "population": 308,
            "type": "village",
            "poly": null,
            "longitude": 79.366707,
            "latitude": 52.784294
        },
        "4413": {
            "name": "Николаевка",
            "population": 925,
            "type": "village",
            "poly": null,
            "longitude": 79.4148067,
            "latitude": 51.9260024
        },
        "4414": {
            "name": "Утянка",
            "population": 1131,
            "type": "village",
            "poly": null,
            "longitude": 79.4569075,
            "latitude": 53.596362
        },
        "4415": {
            "name": "Бастан",
            "population": 903,
            "type": "village",
            "poly": [
                [
                    79.45366,
                    51.8675662
                ],
                [
                    79.4564808,
                    51.8694514
                ],
                [
                    79.4572711,
                    51.8701548
                ],
                [
                    79.4746745,
                    51.8763385
                ],
                [
                    79.4814404,
                    51.8685011
                ],
                [
                    79.482013,
                    51.8679736
                ],
                [
                    79.4796324,
                    51.8630193
                ],
                [
                    79.4962077,
                    51.8541436
                ],
                [
                    79.4962077,
                    51.8527277
                ],
                [
                    79.4866272,
                    51.8492334
                ],
                [
                    79.468986,
                    51.8556608
                ],
                [
                    79.4666519,
                    51.8555789
                ],
                [
                    79.4599149,
                    51.8587406
                ],
                [
                    79.4576792,
                    51.8608958
                ],
                [
                    79.4563754,
                    51.8634217
                ],
                [
                    79.45366,
                    51.8675662
                ]
            ],
            "longitude": 79.4707278,
            "latitude": 51.8623659
        },
        "4416": {
            "name": "Знаменка",
            "population": 1435,
            "type": "village",
            "poly": [
                [
                    79.4322046,
                    53.1701002
                ],
                [
                    79.4457051,
                    53.1864477
                ],
                [
                    79.4625116,
                    53.1770363
                ],
                [
                    79.4759175,
                    53.1862155
                ],
                [
                    79.4940587,
                    53.1672924
                ],
                [
                    79.4834512,
                    53.1539943
                ],
                [
                    79.4700885,
                    53.1585376
                ],
                [
                    79.4587922,
                    53.1551508
                ],
                [
                    79.4322046,
                    53.1701002
                ]
            ],
            "longitude": 79.4826029,
            "latitude": 53.1612894
        },
        "4417": {
            "name": "Мартовка",
            "population": 1220,
            "type": "village",
            "poly": null,
            "longitude": 79.5209468,
            "latitude": 53.4421711
        },
        "4418": {
            "name": "Хабары",
            "population": 5141,
            "type": "village",
            "poly": [
                [
                    79.5050245,
                    53.6040988
                ],
                [
                    79.5071513,
                    53.6446415
                ],
                [
                    79.5533322,
                    53.6442813
                ],
                [
                    79.576271,
                    53.6341042
                ],
                [
                    79.5856895,
                    53.6246453
                ],
                [
                    79.5765748,
                    53.6116697
                ],
                [
                    79.5502941,
                    53.602386
                ],
                [
                    79.5240134,
                    53.602386
                ],
                [
                    79.5173293,
                    53.6027467
                ],
                [
                    79.5050245,
                    53.6040988
                ]
            ],
            "longitude": 79.537766,
            "latitude": 53.624283
        },
        "4419": {
            "name": "Тельманский",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 79.5463261,
            "latitude": 52.7967706
        },
        "4420": {
            "name": "Петухи",
            "population": 874,
            "type": "village",
            "poly": null,
            "longitude": 79.5470709,
            "latitude": 52.2388349
        },
        "4421": {
            "name": "Ананьевка",
            "population": 633,
            "type": "village",
            "poly": null,
            "longitude": 79.578979,
            "latitude": 52.57793
        },
        "4422": {
            "name": "Орлеан",
            "population": 525,
            "type": "village",
            "poly": null,
            "longitude": 79.5979979,
            "latitude": 52.6851948
        },
        "4423": {
            "name": "Яготино",
            "population": 600,
            "type": "village",
            "poly": null,
            "longitude": 79.6304808,
            "latitude": 52.7457026
        },
        "4424": {
            "name": "Малопавловка",
            "population": 296,
            "type": "village",
            "poly": null,
            "longitude": 79.6311707,
            "latitude": 53.4331163
        },
        "4425": {
            "name": "Ясная Поляна",
            "population": 125,
            "type": "village",
            "poly": null,
            "longitude": 79.6323698,
            "latitude": 53.5192928
        },
        "4426": {
            "name": "Зелёная Поляна",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 79.6339451,
            "latitude": 52.4022801
        },
        "4427": {
            "name": "Нововасильевка",
            "population": 67,
            "type": "village",
            "poly": null,
            "longitude": 79.6405938,
            "latitude": 53.3935986
        },
        "4428": {
            "name": "Назаровка",
            "population": 540,
            "type": "village",
            "poly": null,
            "longitude": 79.6424053,
            "latitude": 52.0273027
        },
        "4429": {
            "name": "Добровольщина",
            "population": 67,
            "type": "village",
            "poly": null,
            "longitude": 79.6460996,
            "latitude": 53.292923
        },
        "4430": {
            "name": "Свердловское",
            "population": 1011,
            "type": "village",
            "poly": null,
            "longitude": 79.6741434,
            "latitude": 53.3274952
        },
        "4431": {
            "name": "Федотовка",
            "population": 100,
            "type": "village",
            "poly": null,
            "longitude": 79.67543,
            "latitude": 52.350822
        },
        "4432": {
            "name": "Коротояк",
            "population": 1220,
            "type": "village",
            "poly": [
                [
                    79.6555831,
                    53.7594292
                ],
                [
                    79.6645785,
                    53.7611789
                ],
                [
                    79.6978057,
                    53.7612412
                ],
                [
                    79.7008664,
                    53.7604845
                ],
                [
                    79.6983105,
                    53.7493914
                ],
                [
                    79.6915839,
                    53.7479594
                ],
                [
                    79.6860392,
                    53.7485676
                ],
                [
                    79.6722115,
                    53.7492323
                ],
                [
                    79.6555831,
                    53.7594292
                ]
            ],
            "longitude": 79.688622,
            "latitude": 53.759254
        },
        "4433": {
            "name": "Полуямки",
            "population": 841,
            "type": "village",
            "poly": null,
            "longitude": 79.699286,
            "latitude": 52.0751853
        },
        "4434": {
            "name": "Целинный",
            "population": 635,
            "type": "village",
            "poly": null,
            "longitude": 79.7040901,
            "latitude": 53.767878
        },
        "4435": {
            "name": "имени Владимира Ильича",
            "population": 128,
            "type": "village",
            "poly": null,
            "longitude": 79.7107358,
            "latitude": 53.2383392
        },
        "4436": {
            "name": "Алексеевка",
            "population": 236,
            "type": "village",
            "poly": null,
            "longitude": 79.7155613,
            "latitude": 51.3753705
        },
        "4437": {
            "name": "Разумовка",
            "population": 592,
            "type": "village",
            "poly": [
                [
                    79.6844261,
                    52.5587686
                ],
                [
                    79.6972102,
                    52.5591706
                ],
                [
                    79.7011777,
                    52.5668749
                ],
                [
                    79.7215661,
                    52.5607116
                ],
                [
                    79.7261948,
                    52.5568926
                ],
                [
                    79.7291705,
                    52.551532
                ],
                [
                    79.706688,
                    52.5379935
                ],
                [
                    79.6860793,
                    52.5448303
                ],
                [
                    79.6844261,
                    52.5587686
                ]
            ],
            "longitude": 79.7251321,
            "latitude": 52.5541752
        },
        "4438": {
            "name": "Мичуринское",
            "population": 877,
            "type": "village",
            "poly": null,
            "longitude": 79.7359757,
            "latitude": 53.477089
        },
        "4439": {
            "name": "Усть-Курья",
            "population": 213,
            "type": "village",
            "poly": null,
            "longitude": 79.7383732,
            "latitude": 53.6649952
        },
        "4440": {
            "name": "Новоплотава",
            "population": 360,
            "type": "village",
            "poly": null,
            "longitude": 79.75116,
            "latitude": 53.517361
        },
        "4441": {
            "name": "Марковка",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 79.7686117,
            "latitude": 52.4284275
        },
        "4442": {
            "name": "Малиновое Озеро",
            "population": 3180,
            "type": "village",
            "poly": [
                [
                    79.764957,
                    51.6766837
                ],
                [
                    79.7753082,
                    51.6771839
                ],
                [
                    79.8022075,
                    51.6778919
                ],
                [
                    79.7998129,
                    51.6638976
                ],
                [
                    79.7736728,
                    51.6689281
                ],
                [
                    79.7662339,
                    51.6701243
                ],
                [
                    79.7654074,
                    51.6752502
                ],
                [
                    79.764957,
                    51.6766837
                ]
            ],
            "longitude": 79.770782,
            "latitude": 51.675251
        },
        "4443": {
            "name": "Ащегуль",
            "population": 359,
            "type": "village",
            "poly": null,
            "longitude": 79.7789191,
            "latitude": 52.128604
        },
        "4444": {
            "name": "Каип",
            "population": 467,
            "type": "village",
            "poly": null,
            "longitude": 79.7841574,
            "latitude": 52.2478896
        },
        "4445": {
            "name": "Павловка",
            "population": 1232,
            "type": "village",
            "poly": null,
            "longitude": 79.7945565,
            "latitude": 51.3946384
        },
        "4446": {
            "name": "Нечаевка",
            "population": 118,
            "type": "village",
            "poly": null,
            "longitude": 79.795676,
            "latitude": 53.3501366
        },
        "4447": {
            "name": "Смирновский",
            "population": 106,
            "type": "village",
            "poly": null,
            "longitude": 79.8104526,
            "latitude": 53.8040653
        },
        "4448": {
            "name": "Васильевка",
            "population": 289,
            "type": "village",
            "poly": null,
            "longitude": 79.8306973,
            "latitude": 53.5779805
        },
        "4449": {
            "name": "Поперечное",
            "population": 170,
            "type": "village",
            "poly": null,
            "longitude": 79.8372034,
            "latitude": 53.4675005
        },
        "4450": {
            "name": "Серп и Молот",
            "population": 111,
            "type": "village",
            "poly": null,
            "longitude": 79.8568742,
            "latitude": 53.6687951
        },
        "4451": {
            "name": "Ракиты",
            "population": 2185,
            "type": "village",
            "poly": null,
            "longitude": 79.8837791,
            "latitude": 51.8467565
        },
        "4452": {
            "name": "Нижняя Суетка",
            "population": 1143,
            "type": "village",
            "poly": null,
            "longitude": 79.89518,
            "latitude": 53.225769
        },
        "4453": {
            "name": "Плёсо-Курья",
            "population": 574,
            "type": "village",
            "poly": null,
            "longitude": 79.9101083,
            "latitude": 53.6298396
        },
        "4454": {
            "name": "Октябрьский",
            "population": 279,
            "type": "village",
            "poly": null,
            "longitude": 79.9234545,
            "latitude": 53.3211078
        },
        "4455": {
            "name": "Урываево",
            "population": 362,
            "type": "village",
            "poly": null,
            "longitude": 79.9405078,
            "latitude": 53.7977019
        },
        "4456": {
            "name": "Нижний Кучук",
            "population": 464,
            "type": "village",
            "poly": [
                [
                    79.9103327,
                    52.7179647
                ],
                [
                    79.9177373,
                    52.72829
                ],
                [
                    79.941673,
                    52.7254742
                ],
                [
                    79.9477,
                    52.7231797
                ],
                [
                    79.9523494,
                    52.7202594
                ],
                [
                    79.9621648,
                    52.7040896
                ],
                [
                    79.9521772,
                    52.6958458
                ],
                [
                    79.9123942,
                    52.7162615
                ],
                [
                    79.9103327,
                    52.7179647
                ]
            ],
            "longitude": 79.9411564,
            "latitude": 52.7141051
        },
        "4457": {
            "name": "Зятькова Речка",
            "population": 1020,
            "type": "village",
            "poly": null,
            "longitude": 79.9461837,
            "latitude": 53.4738395
        },
        "4458": {
            "name": "Раздольное",
            "population": 1039,
            "type": "village",
            "poly": null,
            "longitude": 79.950834,
            "latitude": 52.4957597
        },
        "4459": {
            "name": "Шаталовка",
            "population": 558,
            "type": "village",
            "poly": null,
            "longitude": 79.9588978,
            "latitude": 52.3975712
        },
        "4460": {
            "name": "Мельниковка",
            "population": 323,
            "type": "village",
            "poly": null,
            "longitude": 79.9631118,
            "latitude": 53.1513832
        },
        "4461": {
            "name": "Мирный",
            "population": 842,
            "type": "village",
            "poly": null,
            "longitude": 79.9644874,
            "latitude": 51.4229018
        },
        "4462": {
            "name": "Шадруха",
            "population": 525,
            "type": "village",
            "poly": null,
            "longitude": 79.9644932,
            "latitude": 51.1652597
        },
        "4463": {
            "name": "Шимолино",
            "population": 828,
            "type": "village",
            "poly": null,
            "longitude": 79.979637,
            "latitude": 53.000111
        },
        "4464": {
            "name": "Осиновский",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 80.0253253,
            "latitude": 53.2529573
        },
        "4465": {
            "name": "Верх-Суетка",
            "population": 2224,
            "type": "village",
            "poly": [
                [
                    80.0122085,
                    53.2825133
                ],
                [
                    80.0185219,
                    53.2863524
                ],
                [
                    80.0282764,
                    53.2888307
                ],
                [
                    80.032151,
                    53.2904666
                ],
                [
                    80.0319614,
                    53.2936572
                ],
                [
                    80.0265422,
                    53.2975116
                ],
                [
                    80.0229927,
                    53.304183
                ],
                [
                    80.0376515,
                    53.3087326
                ],
                [
                    80.0373534,
                    53.3123104
                ],
                [
                    80.0400088,
                    53.3184292
                ],
                [
                    80.0455906,
                    53.3214073
                ],
                [
                    80.0527167,
                    53.3224432
                ],
                [
                    80.0580275,
                    53.3221195
                ],
                [
                    80.0619022,
                    53.3152728
                ],
                [
                    80.0684323,
                    53.3128608
                ],
                [
                    80.0678091,
                    53.3094773
                ],
                [
                    80.0626067,
                    53.305786
                ],
                [
                    80.0575127,
                    53.3021752
                ],
                [
                    80.0582985,
                    53.2984347
                ],
                [
                    80.0583256,
                    53.2946775
                ],
                [
                    80.0598971,
                    53.2898187
                ],
                [
                    80.0504407,
                    53.2871785
                ],
                [
                    80.0484356,
                    53.2894138
                ],
                [
                    80.0420139,
                    53.2937868
                ],
                [
                    80.0393585,
                    53.2855425
                ],
                [
                    80.0303627,
                    53.2838416
                ],
                [
                    80.0205541,
                    53.2816223
                ],
                [
                    80.0154601,
                    53.278771
                ],
                [
                    80.0122085,
                    53.2825133
                ]
            ],
            "longitude": 80.05072,
            "latitude": 53.303879
        },
        "4466": {
            "name": "Зыково",
            "population": 363,
            "type": "village",
            "poly": [
                [
                    80.0594323,
                    53.8245028
                ],
                [
                    80.0660448,
                    53.8275926
                ],
                [
                    80.0643917,
                    53.8323895
                ],
                [
                    80.0787187,
                    53.8384865
                ],
                [
                    80.0835403,
                    53.8351536
                ],
                [
                    80.093459,
                    53.8219007
                ],
                [
                    80.0761013,
                    53.8192984
                ],
                [
                    80.0628763,
                    53.8200303
                ],
                [
                    80.0594323,
                    53.8245028
                ]
            ],
            "longitude": 80.0769278,
            "latitude": 53.8273487
        },
        "4467": {
            "name": "Новокормиха",
            "population": 434,
            "type": "village",
            "poly": [
                [
                    80.0585935,
                    52.1882002
                ],
                [
                    80.0720802,
                    52.1929378
                ],
                [
                    80.0901129,
                    52.1731475
                ],
                [
                    80.103145,
                    52.1666417
                ],
                [
                    80.1228445,
                    52.1606927
                ],
                [
                    80.1252692,
                    52.1581827
                ],
                [
                    80.1066303,
                    52.1541851
                ],
                [
                    80.0726863,
                    52.1603209
                ],
                [
                    80.0638972,
                    52.1676641
                ],
                [
                    80.0701102,
                    52.1702664
                ],
                [
                    80.0585935,
                    52.1882002
                ]
            ],
            "longitude": 80.0837484,
            "latitude": 52.1676641
        },
        "4468": {
            "name": "Боронский",
            "population": 503,
            "type": "village",
            "poly": null,
            "longitude": 80.090034,
            "latitude": 53.17149
        },
        "4469": {
            "name": "Ярославцев Лог",
            "population": 651,
            "type": "village",
            "poly": [
                [
                    80.0713433,
                    52.270189
                ],
                [
                    80.0764349,
                    52.2848009
                ],
                [
                    80.0977711,
                    52.2799803
                ],
                [
                    80.1089241,
                    52.2744173
                ],
                [
                    80.1131671,
                    52.2698923
                ],
                [
                    80.1142582,
                    52.2679634
                ],
                [
                    80.1137733,
                    52.2648474
                ],
                [
                    80.1111063,
                    52.2625474
                ],
                [
                    80.1058934,
                    52.2621022
                ],
                [
                    80.0926795,
                    52.266628
                ],
                [
                    80.0850421,
                    52.2629925
                ],
                [
                    80.0757074,
                    52.2658861
                ],
                [
                    80.0748589,
                    52.2689279
                ],
                [
                    80.0713433,
                    52.270189
                ]
            ],
            "longitude": 80.0918309,
            "latitude": 52.2731563
        },
        "4470": {
            "name": "Преградинка",
            "population": 336,
            "type": "village",
            "poly": null,
            "longitude": 80.0956612,
            "latitude": 52.8080526
        },
        "4471": {
            "name": "Топольное",
            "population": 873,
            "type": "village",
            "poly": null,
            "longitude": 80.105412,
            "latitude": 50.9360575
        },
        "4472": {
            "name": "Берёзовский",
            "population": 519,
            "type": "village",
            "poly": null,
            "longitude": 80.1103783,
            "latitude": 52.0743214
        },
        "4473": {
            "name": "Долинка",
            "population": 357,
            "type": "village",
            "poly": null,
            "longitude": 80.114754,
            "latitude": 53.029842
        },
        "4474": {
            "name": "Бор-Форпост",
            "population": 843,
            "type": "village",
            "poly": null,
            "longitude": 80.1181888,
            "latitude": 51.8763927
        },
        "4475": {
            "name": "Суворовка",
            "population": 555,
            "type": "village",
            "poly": null,
            "longitude": 80.12183,
            "latitude": 52.802063
        },
        "4476": {
            "name": "Беленькое",
            "population": 367,
            "type": "village",
            "poly": null,
            "longitude": 80.130067,
            "latitude": 50.9908536
        },
        "4477": {
            "name": "Зелёный Луг",
            "population": 519,
            "type": "village",
            "poly": [
                [
                    80.1240089,
                    52.3893548
                ],
                [
                    80.1303734,
                    52.3935162
                ],
                [
                    80.1482546,
                    52.3852854
                ],
                [
                    80.1468908,
                    52.3628047
                ],
                [
                    80.1320403,
                    52.3644704
                ],
                [
                    80.1261303,
                    52.3719649
                ],
                [
                    80.1261303,
                    52.376498
                ],
                [
                    80.1329495,
                    52.3789957
                ],
                [
                    80.1240089,
                    52.3893548
                ]
            ],
            "longitude": 80.139314,
            "latitude": 52.3748329
        },
        "4478": {
            "name": "Береговое",
            "population": 283,
            "type": "village",
            "poly": null,
            "longitude": 80.1394249,
            "latitude": 53.761292
        },
        "4479": {
            "name": "Новотроицк",
            "population": 518,
            "type": "village",
            "poly": null,
            "longitude": 80.1488182,
            "latitude": 52.6536596
        },
        "4480": {
            "name": "Кривое",
            "population": 337,
            "type": "village",
            "poly": null,
            "longitude": 80.1557585,
            "latitude": 53.6834223
        },
        "4481": {
            "name": "Велижанка",
            "population": 758,
            "type": "village",
            "poly": null,
            "longitude": 80.1592086,
            "latitude": 53.8651376
        },
        "4482": {
            "name": "Новокулундинка",
            "population": 490,
            "type": "village",
            "poly": null,
            "longitude": 80.1608862,
            "latitude": 53.0458179
        },
        "4483": {
            "name": "Мирный",
            "population": 1932,
            "type": "village",
            "poly": null,
            "longitude": 80.1648179,
            "latitude": 52.5587813
        },
        "4484": {
            "name": "Николаевка",
            "population": 618,
            "type": "village",
            "poly": null,
            "longitude": 80.173584,
            "latitude": 52.957729
        },
        "4485": {
            "name": "Борисовский",
            "population": 307,
            "type": "village",
            "poly": null,
            "longitude": 80.1816475,
            "latitude": 53.5570418
        },
        "4486": {
            "name": "Лаптев Лог",
            "population": 975,
            "type": "village",
            "poly": null,
            "longitude": 80.1859039,
            "latitude": 51.062905
        },
        "4487": {
            "name": "Угловское",
            "population": 4368,
            "type": "village",
            "poly": [
                [
                    80.1713871,
                    51.3562804
                ],
                [
                    80.1715212,
                    51.3601737
                ],
                [
                    80.1769729,
                    51.3636198
                ],
                [
                    80.1823816,
                    51.3670384
                ],
                [
                    80.1958565,
                    51.3759945
                ],
                [
                    80.21027,
                    51.3762037
                ],
                [
                    80.2178455,
                    51.3733133
                ],
                [
                    80.2039728,
                    51.3576727
                ],
                [
                    80.1960576,
                    51.351717
                ],
                [
                    80.1843257,
                    51.3523869
                ],
                [
                    80.1713871,
                    51.3562804
                ]
            ],
            "longitude": 80.188408,
            "latitude": 51.363693
        },
        "4488": {
            "name": "Александровка",
            "population": 643,
            "type": "village",
            "poly": null,
            "longitude": 80.1995712,
            "latitude": 53.2303601
        },
        "4489": {
            "name": "Михайловка",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 80.2131564,
            "latitude": 53.1823476
        },
        "4490": {
            "name": "Коминтерн",
            "population": 401,
            "type": "village",
            "poly": null,
            "longitude": 80.2149654,
            "latitude": 52.1755193
        },
        "4491": {
            "name": "Борисовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 80.230732,
            "latitude": 51.1318917
        },
        "4492": {
            "name": "Татьяновка",
            "population": 348,
            "type": "village",
            "poly": null,
            "longitude": 80.23439,
            "latitude": 52.980358
        },
        "4493": {
            "name": "Усть-Волчиха",
            "population": 941,
            "type": "village",
            "poly": null,
            "longitude": 80.2510172,
            "latitude": 51.8989539
        },
        "4494": {
            "name": "Глядень",
            "population": 684,
            "type": "village",
            "poly": [
                [
                    80.243324,
                    52.7561664
                ],
                [
                    80.2443968,
                    52.7674112
                ],
                [
                    80.251568,
                    52.7703777
                ],
                [
                    80.2516495,
                    52.771955
                ],
                [
                    80.2602369,
                    52.775051
                ],
                [
                    80.2624685,
                    52.7741943
                ],
                [
                    80.2678286,
                    52.7705788
                ],
                [
                    80.2666699,
                    52.7654117
                ],
                [
                    80.2640521,
                    52.7648145
                ],
                [
                    80.2624213,
                    52.7573871
                ],
                [
                    80.2579403,
                    52.7575153
                ],
                [
                    80.2506195,
                    52.7577248
                ],
                [
                    80.243324,
                    52.7561664
                ]
            ],
            "longitude": 80.257599,
            "latitude": 52.763313
        },
        "4495": {
            "name": "Глядень-3",
            "population": 296,
            "type": "village",
            "poly": [
                [
                    80.2523834,
                    52.7362993
                ],
                [
                    80.2547394,
                    52.7366825
                ],
                [
                    80.2594732,
                    52.7371219
                ],
                [
                    80.2604086,
                    52.7372086
                ],
                [
                    80.2628976,
                    52.7397291
                ],
                [
                    80.2657258,
                    52.7400863
                ],
                [
                    80.268129,
                    52.7306537
                ],
                [
                    80.2706223,
                    52.7295168
                ],
                [
                    80.2723776,
                    52.7237924
                ],
                [
                    80.2571427,
                    52.7225448
                ],
                [
                    80.2550398,
                    52.7293024
                ],
                [
                    80.2539713,
                    52.7294648
                ],
                [
                    80.2523834,
                    52.7362993
                ]
            ],
            "longitude": 80.2611076,
            "latitude": 52.7298925
        },
        "4496": {
            "name": "Берёзовский",
            "population": 420,
            "type": "village",
            "poly": null,
            "longitude": 80.266343,
            "latitude": 53.7481589
        },
        "4497": {
            "name": "Озёрно-Кузнецовский Лесхоз",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 80.2668106,
            "latitude": 51.548166
        },
        "4498": {
            "name": "Луковка",
            "population": 699,
            "type": "village",
            "poly": null,
            "longitude": 80.2725621,
            "latitude": 53.9171105
        },
        "4499": {
            "name": "Глядень-2",
            "population": 278,
            "type": "village",
            "poly": [
                [
                    80.2678758,
                    52.7822158
                ],
                [
                    80.2691539,
                    52.7909297
                ],
                [
                    80.269252,
                    52.7930645
                ],
                [
                    80.2719326,
                    52.7935123
                ],
                [
                    80.2717267,
                    52.7944457
                ],
                [
                    80.2696354,
                    52.7944457
                ],
                [
                    80.2702319,
                    52.7977795
                ],
                [
                    80.2793771,
                    52.7960488
                ],
                [
                    80.2809607,
                    52.7926156
                ],
                [
                    80.2804886,
                    52.7891898
                ],
                [
                    80.2830207,
                    52.7889563
                ],
                [
                    80.282982,
                    52.7852267
                ],
                [
                    80.2815615,
                    52.7845441
                ],
                [
                    80.2796346,
                    52.7796718
                ],
                [
                    80.2685153,
                    52.7810931
                ],
                [
                    80.2678758,
                    52.7822158
                ]
            ],
            "longitude": 80.278282,
            "latitude": 52.78878
        },
        "4500": {
            "name": "Пятков Лог",
            "population": 350,
            "type": "village",
            "poly": null,
            "longitude": 80.2809581,
            "latitude": 52.2227193
        },
        "4501": {
            "name": "Новоугловский",
            "population": 311,
            "type": "village",
            "poly": null,
            "longitude": 80.2871945,
            "latitude": 51.4468609
        },
        "4502": {
            "name": "Красный Алтай",
            "population": 454,
            "type": "village",
            "poly": null,
            "longitude": 80.298961,
            "latitude": 52.2878506
        },
        "4503": {
            "name": "Верх-Пайва",
            "population": 645,
            "type": "village",
            "poly": null,
            "longitude": 80.3104533,
            "latitude": 53.4035438
        },
        "4504": {
            "name": "Зятьково",
            "population": 753,
            "type": "village",
            "poly": [
                [
                    80.3207055,
                    53.595846
                ],
                [
                    80.3301764,
                    53.604915
                ],
                [
                    80.3370645,
                    53.6116835
                ],
                [
                    80.3439524,
                    53.6133436
                ],
                [
                    80.3504099,
                    53.606703
                ],
                [
                    80.3579437,
                    53.6046596
                ],
                [
                    80.3594504,
                    53.601211
                ],
                [
                    80.3510557,
                    53.5889472
                ],
                [
                    80.327163,
                    53.5846029
                ],
                [
                    80.321136,
                    53.5876694
                ],
                [
                    80.3226428,
                    53.5938021
                ],
                [
                    80.3207055,
                    53.595846
                ]
            ],
            "longitude": 80.3409389,
            "latitude": 53.5972512
        },
        "4505": {
            "name": "Нижнепайва",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 80.351873,
            "latitude": 53.3207334
        },
        "4506": {
            "name": "Степной Кучук",
            "population": 954,
            "type": "village",
            "poly": [
                [
                    80.331714,
                    52.6095248
                ],
                [
                    80.3377754,
                    52.6127453
                ],
                [
                    80.3485344,
                    52.610813
                ],
                [
                    80.3620211,
                    52.6109971
                ],
                [
                    80.3768716,
                    52.6041874
                ],
                [
                    80.3785384,
                    52.5989413
                ],
                [
                    80.3665671,
                    52.5988493
                ],
                [
                    80.3515651,
                    52.5859616
                ],
                [
                    80.3368662,
                    52.5921297
                ],
                [
                    80.331714,
                    52.6095248
                ]
            ],
            "longitude": 80.3535351,
            "latitude": 52.6006901
        },
        "4507": {
            "name": "Валовой Кордон",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 80.3561622,
            "latitude": 51.7861562
        },
        "4508": {
            "name": "Озёрно-Кузнецово",
            "population": 1350,
            "type": "village",
            "poly": null,
            "longitude": 80.3583254,
            "latitude": 51.5144008
        },
        "4509": {
            "name": "Симоново",
            "population": 757,
            "type": "village",
            "poly": null,
            "longitude": 80.382612,
            "latitude": 51.6866245
        },
        "4510": {
            "name": "Покровка",
            "population": 1094,
            "type": "village",
            "poly": null,
            "longitude": 80.3883307,
            "latitude": 52.766777
        },
        "4511": {
            "name": "Центральное",
            "population": 840,
            "type": "village",
            "poly": null,
            "longitude": 80.4112056,
            "latitude": 52.300648
        },
        "4512": {
            "name": "Леньки",
            "population": 3232,
            "type": "village",
            "poly": null,
            "longitude": 80.429916,
            "latitude": 52.938488
        },
        "4513": {
            "name": "Вячеславка",
            "population": 381,
            "type": "village",
            "poly": null,
            "longitude": 80.4387734,
            "latitude": 52.8179921
        },
        "4514": {
            "name": "Наумовка",
            "population": 508,
            "type": "village",
            "poly": null,
            "longitude": 80.4390241,
            "latitude": 51.0282993
        },
        "4515": {
            "name": "Круглое",
            "population": 815,
            "type": "village",
            "poly": null,
            "longitude": 80.4461259,
            "latitude": 51.291007
        },
        "4516": {
            "name": "Каяушка",
            "population": 619,
            "type": "village",
            "poly": [
                [
                    80.4326112,
                    52.480987
                ],
                [
                    80.4578267,
                    52.5126491
                ],
                [
                    80.4783142,
                    52.509329
                ],
                [
                    80.4584328,
                    52.4750801
                ],
                [
                    80.4339447,
                    52.4786981
                ],
                [
                    80.4326112,
                    52.480987
                ]
            ],
            "longitude": 80.4569781,
            "latitude": 52.4914697
        },
        "4517": {
            "name": "Вознесенка",
            "population": 631,
            "type": "village",
            "poly": null,
            "longitude": 80.4575129,
            "latitude": 52.3405099
        },
        "4518": {
            "name": "Подойниково",
            "population": 1087,
            "type": "village",
            "poly": [
                [
                    80.4568134,
                    53.8750727
                ],
                [
                    80.4610839,
                    53.8825439
                ],
                [
                    80.4737358,
                    53.881196
                ],
                [
                    80.4732068,
                    53.8747511
                ],
                [
                    80.4833459,
                    53.8743353
                ],
                [
                    80.4848447,
                    53.8707486
                ],
                [
                    80.4944548,
                    53.8677854
                ],
                [
                    80.4877542,
                    53.8630543
                ],
                [
                    80.4981578,
                    53.8636262
                ],
                [
                    80.4956009,
                    53.8612345
                ],
                [
                    80.474689,
                    53.8564117
                ],
                [
                    80.4653545,
                    53.8617512
                ],
                [
                    80.4573644,
                    53.8699558
                ],
                [
                    80.4568134,
                    53.8750727
                ]
            ],
            "longitude": 80.4682618,
            "latitude": 53.8671827
        },
        "4519": {
            "name": "Степное",
            "population": 1353,
            "type": "village",
            "poly": null,
            "longitude": 80.4814275,
            "latitude": 52.6333028
        },
        "4520": {
            "name": "Правда",
            "population": 612,
            "type": "village",
            "poly": [
                [
                    80.4834673,
                    52.0836898
                ],
                [
                    80.4844973,
                    52.0862215
                ],
                [
                    80.4870722,
                    52.0897022
                ],
                [
                    80.4930804,
                    52.0929718
                ],
                [
                    80.4999468,
                    52.0958193
                ],
                [
                    80.5062983,
                    52.0951864
                ],
                [
                    80.5159113,
                    52.096452
                ],
                [
                    80.5186578,
                    52.0944483
                ],
                [
                    80.5164263,
                    52.092128
                ],
                [
                    80.5105898,
                    52.0866434
                ],
                [
                    80.4882738,
                    52.0812636
                ],
                [
                    80.4839822,
                    52.081791
                ],
                [
                    80.4834673,
                    52.0836898
                ]
            ],
            "longitude": 80.5007859,
            "latitude": 52.0893585
        },
        "4521": {
            "name": "Романово",
            "population": 456,
            "type": "village",
            "poly": null,
            "longitude": 80.5050291,
            "latitude": 53.9663265
        },
        "4522": {
            "name": "Алексеевка",
            "population": 347,
            "type": "village",
            "poly": null,
            "longitude": 80.539665,
            "latitude": 52.895592
        },
        "4523": {
            "name": "Куйбышево",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 80.5727482,
            "latitude": 51.3536119
        },
        "4524": {
            "name": "Верх-Чуманка",
            "population": 847,
            "type": "village",
            "poly": [
                [
                    80.5754297,
                    53.4071998
                ],
                [
                    80.5793006,
                    53.4109081
                ],
                [
                    80.5960282,
                    53.4111553
                ],
                [
                    80.6054288,
                    53.4114025
                ],
                [
                    80.6145529,
                    53.4075294
                ],
                [
                    80.6022492,
                    53.3947539
                ],
                [
                    80.5906366,
                    53.3956607
                ],
                [
                    80.5860746,
                    53.4009361
                ],
                [
                    80.5779181,
                    53.4038208
                ],
                [
                    80.5754297,
                    53.4071998
                ]
            ],
            "longitude": 80.5932998,
            "latitude": 53.4034175
        },
        "4525": {
            "name": "Нижнечуманка",
            "population": 861,
            "type": "village",
            "poly": [
                [
                    80.5762553,
                    53.2299903
                ],
                [
                    80.5843773,
                    53.2339209
                ],
                [
                    80.5883518,
                    53.2324729
                ],
                [
                    80.5947139,
                    53.2347245
                ],
                [
                    80.5990173,
                    53.2327926
                ],
                [
                    80.6059053,
                    53.2262533
                ],
                [
                    80.6046887,
                    53.2192346
                ],
                [
                    80.5918079,
                    53.2142642
                ],
                [
                    80.5807484,
                    53.2193344
                ],
                [
                    80.5788475,
                    53.2265766
                ],
                [
                    80.5762553,
                    53.2299903
                ]
            ],
            "longitude": 80.594182,
            "latitude": 53.2247968
        },
        "4526": {
            "name": "Камышенка",
            "population": 877,
            "type": "village",
            "poly": null,
            "longitude": 80.6041963,
            "latitude": 52.7023047
        },
        "4527": {
            "name": "Чернавка",
            "population": 385,
            "type": "village",
            "poly": null,
            "longitude": 80.609512,
            "latitude": 52.664013
        },
        "4528": {
            "name": "Вторые Коростели",
            "population": 307,
            "type": "village",
            "poly": null,
            "longitude": 80.6198483,
            "latitude": 51.4014774
        },
        "4529": {
            "name": "Высокая Грива",
            "population": 541,
            "type": "village",
            "poly": null,
            "longitude": 80.6453315,
            "latitude": 53.9176684
        },
        "4530": {
            "name": "Вострово",
            "population": 1252,
            "type": "village",
            "poly": [
                [
                    80.5989766,
                    52.137484
                ],
                [
                    80.618546,
                    52.146228
                ],
                [
                    80.6269909,
                    52.1490826
                ],
                [
                    80.6322789,
                    52.152864
                ],
                [
                    80.6425785,
                    52.1573927
                ],
                [
                    80.6604313,
                    52.15655
                ],
                [
                    80.6627235,
                    52.1574994
                ],
                [
                    80.6660254,
                    52.1554888
                ],
                [
                    80.6689403,
                    52.1537014
                ],
                [
                    80.6689684,
                    52.1504277
                ],
                [
                    80.6673549,
                    52.1491174
                ],
                [
                    80.6611108,
                    52.1437783
                ],
                [
                    80.6530499,
                    52.139591
                ],
                [
                    80.6384587,
                    52.1333747
                ],
                [
                    80.629704,
                    52.1300028
                ],
                [
                    80.619061,
                    52.1248389
                ],
                [
                    80.6164861,
                    52.1283167
                ],
                [
                    80.607388,
                    52.1252605
                ],
                [
                    80.5993534,
                    52.1355979
                ],
                [
                    80.5989766,
                    52.137484
                ]
            ],
            "longitude": 80.6455227,
            "latitude": 52.1478176
        },
        "4531": {
            "name": "Большая Шелковка",
            "population": 424,
            "type": "village",
            "poly": null,
            "longitude": 80.6506472,
            "latitude": 51.4191969
        },
        "4532": {
            "name": "Кочки",
            "population": 885,
            "type": "village",
            "poly": null,
            "longitude": 80.6550895,
            "latitude": 52.3896372
        },
        "4533": {
            "name": "Приборовое",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 80.679415,
            "latitude": 52.1572564
        },
        "4534": {
            "name": "Филипповский",
            "population": 315,
            "type": "village",
            "poly": null,
            "longitude": 80.6850888,
            "latitude": 53.6336928
        },
        "4535": {
            "name": "Глубокое",
            "population": 1508,
            "type": "village",
            "poly": null,
            "longitude": 80.68885,
            "latitude": 52.990131
        },
        "4536": {
            "name": "Тумановский",
            "population": 317,
            "type": "village",
            "poly": [
                [
                    80.6746475,
                    52.8535993
                ],
                [
                    80.6759134,
                    52.8606216
                ],
                [
                    80.6776934,
                    52.8613833
                ],
                [
                    80.6840663,
                    52.8622124
                ],
                [
                    80.6912547,
                    52.8608392
                ],
                [
                    80.6979924,
                    52.8591939
                ],
                [
                    80.7011681,
                    52.8562269
                ],
                [
                    80.7011681,
                    52.8537781
                ],
                [
                    80.6943456,
                    52.850917
                ],
                [
                    80.6952672,
                    52.847623
                ],
                [
                    80.6903974,
                    52.8491416
                ],
                [
                    80.6798177,
                    52.851653
                ],
                [
                    80.6746475,
                    52.8535993
                ]
            ],
            "longitude": 80.6891083,
            "latitude": 52.8559552
        },
        "4537": {
            "name": "Ракиты",
            "population": 1029,
            "type": "village",
            "poly": null,
            "longitude": 80.7033331,
            "latitude": 51.4509886
        },
        "4538": {
            "name": "Плотава",
            "population": 717,
            "type": "village",
            "poly": null,
            "longitude": 80.7377931,
            "latitude": 53.460623
        },
        "4539": {
            "name": "Сидоровка",
            "population": 1263,
            "type": "village",
            "poly": null,
            "longitude": 80.7499973,
            "latitude": 52.5479257
        },
        "4540": {
            "name": "Малая Шелковка",
            "population": 708,
            "type": "village",
            "poly": null,
            "longitude": 80.7516965,
            "latitude": 51.4966826
        },
        "4541": {
            "name": "Волчно-Бурлинское",
            "population": 1266,
            "type": "village",
            "poly": null,
            "longitude": 80.7696,
            "latitude": 54.051731
        },
        "4542": {
            "name": "Поперечное",
            "population": 783,
            "type": "village",
            "poly": null,
            "longitude": 80.7702245,
            "latitude": 53.56418
        },
        "4543": {
            "name": "Чистоозёрка",
            "population": 1281,
            "type": "village",
            "poly": [
                [
                    80.7548808,
                    52.7719073
                ],
                [
                    80.7602791,
                    52.7784342
                ],
                [
                    80.7756752,
                    52.7796075
                ],
                [
                    80.7894952,
                    52.7847403
                ],
                [
                    80.8056002,
                    52.773684
                ],
                [
                    80.7928455,
                    52.7656727
                ],
                [
                    80.7825043,
                    52.7617638
                ],
                [
                    80.7752619,
                    52.7584247
                ],
                [
                    80.7716746,
                    52.7606112
                ],
                [
                    80.7548808,
                    52.7719073
                ]
            ],
            "longitude": 80.775673,
            "latitude": 52.77
        },
        "4544": {
            "name": "Прыганка",
            "population": 903,
            "type": "village",
            "poly": [
                [
                    80.7748793,
                    53.9601953
                ],
                [
                    80.8084119,
                    53.9757048
                ],
                [
                    80.8165518,
                    53.966025
                ],
                [
                    80.808235,
                    53.9616007
                ],
                [
                    80.8050498,
                    53.9591542
                ],
                [
                    80.8068193,
                    53.954573
                ],
                [
                    80.787266,
                    53.9504078
                ],
                [
                    80.7796571,
                    53.9551977
                ],
                [
                    80.7752332,
                    53.9542085
                ],
                [
                    80.7748793,
                    53.9601953
                ]
            ],
            "longitude": 80.7943442,
            "latitude": 53.960872
        },
        "4545": {
            "name": "Шубинка",
            "population": 540,
            "type": "village",
            "poly": null,
            "longitude": 80.7955189,
            "latitude": 51.6061945
        },
        "4546": {
            "name": "Солоновка",
            "population": 830,
            "type": "village",
            "poly": [
                [
                    80.7797549,
                    52.2262916
                ],
                [
                    80.787308,
                    52.2300768
                ],
                [
                    80.7960626,
                    52.2334412
                ],
                [
                    80.8051607,
                    52.2267122
                ],
                [
                    80.8187219,
                    52.2290254
                ],
                [
                    80.8221552,
                    52.227974
                ],
                [
                    80.8259318,
                    52.2222956
                ],
                [
                    80.8152888,
                    52.2151443
                ],
                [
                    80.8161471,
                    52.2098851
                ],
                [
                    80.808079,
                    52.2070449
                ],
                [
                    80.7982943,
                    52.2110422
                ],
                [
                    80.7928011,
                    52.2168271
                ],
                [
                    80.7826731,
                    52.2201925
                ],
                [
                    80.7797549,
                    52.2262916
                ]
            ],
            "longitude": 80.8031108,
            "latitude": 52.2203046
        },
        "4547": {
            "name": "Малиновский",
            "population": 1266,
            "type": "village",
            "poly": [
                [
                    80.7837493,
                    52.9628147
                ],
                [
                    80.8020401,
                    52.9712585
                ],
                [
                    80.807518,
                    52.9710876
                ],
                [
                    80.8081325,
                    52.9695253
                ],
                [
                    80.8066305,
                    52.9675106
                ],
                [
                    80.8096343,
                    52.9657014
                ],
                [
                    80.815574,
                    52.9657836
                ],
                [
                    80.8298379,
                    52.9669414
                ],
                [
                    80.8280149,
                    52.9632253
                ],
                [
                    80.7868512,
                    52.951671
                ],
                [
                    80.7846615,
                    52.9570296
                ],
                [
                    80.7837493,
                    52.9628147
                ]
            ],
            "longitude": 80.8051217,
            "latitude": 52.9665559
        },
        "4548": {
            "name": "Перешеечный",
            "population": 639,
            "type": "village",
            "poly": [
                [
                    80.8270711,
                    51.7161535
                ],
                [
                    80.8284594,
                    51.7208292
                ],
                [
                    80.8319211,
                    51.7244681
                ],
                [
                    80.8313797,
                    51.7285451
                ],
                [
                    80.8380606,
                    51.7388999
                ],
                [
                    80.8441449,
                    51.7362257
                ],
                [
                    80.8435495,
                    51.7285384
                ],
                [
                    80.8537221,
                    51.7234048
                ],
                [
                    80.853964,
                    51.72102
                ],
                [
                    80.8507796,
                    51.7152213
                ],
                [
                    80.8415341,
                    51.7152161
                ],
                [
                    80.8396458,
                    51.7154289
                ],
                [
                    80.8362126,
                    51.7130889
                ],
                [
                    80.8288312,
                    51.7139398
                ],
                [
                    80.8270711,
                    51.7161535
                ]
            ],
            "longitude": 80.8410474,
            "latitude": 51.7219135
        },
        "4549": {
            "name": "Лебяжье",
            "population": 1291,
            "type": "village",
            "poly": [
                [
                    80.8271146,
                    51.6693533
                ],
                [
                    80.8298611,
                    51.6730794
                ],
                [
                    80.8307194,
                    51.6754214
                ],
                [
                    80.8332944,
                    51.6822337
                ],
                [
                    80.8358693,
                    51.6876615
                ],
                [
                    80.8398175,
                    51.6954295
                ],
                [
                    80.8429074,
                    51.6993663
                ],
                [
                    80.8471989,
                    51.7048984
                ],
                [
                    80.8490872,
                    51.7115999
                ],
                [
                    80.8453107,
                    51.7139398
                ],
                [
                    80.8479403,
                    51.7151121
                ],
                [
                    80.8521771,
                    51.7140462
                ],
                [
                    80.8537221,
                    51.7131953
                ],
                [
                    80.8629918,
                    51.7127699
                ],
                [
                    80.8633351,
                    51.7053239
                ],
                [
                    80.8597302,
                    51.7002174
                ],
                [
                    80.8611035,
                    51.6961744
                ],
                [
                    80.8580136,
                    51.6883
                ],
                [
                    80.8525204,
                    51.6837237
                ],
                [
                    80.8571553,
                    51.6819144
                ],
                [
                    80.856297,
                    51.6768052
                ],
                [
                    80.8526921,
                    51.6752085
                ],
                [
                    80.8477139,
                    51.6705244
                ],
                [
                    80.8420491,
                    51.6713761
                ],
                [
                    80.8393025,
                    51.6677563
                ],
                [
                    80.8271146,
                    51.6693533
                ]
            ],
            "longitude": 80.84909,
            "latitude": 51.6910713
        },
        "4550": {
            "name": "Дубровино",
            "population": 447,
            "type": "village",
            "poly": [
                [
                    80.858441,
                    52.6633164
                ],
                [
                    80.8669271,
                    52.6896855
                ],
                [
                    80.8626841,
                    52.6999714
                ],
                [
                    80.8811714,
                    52.7016244
                ],
                [
                    80.8834445,
                    52.7005225
                ],
                [
                    80.8910213,
                    52.6875729
                ],
                [
                    80.8823837,
                    52.6722303
                ],
                [
                    80.8743523,
                    52.6728736
                ],
                [
                    80.8660179,
                    52.6616621
                ],
                [
                    80.858441,
                    52.6633164
                ]
            ],
            "longitude": 80.8754131,
            "latitude": 52.6836229
        },
        "4551": {
            "name": "Новоярки",
            "population": 1100,
            "type": "village",
            "poly": [
                [
                    80.8384254,
                    53.5953709
                ],
                [
                    80.8481025,
                    53.607676
                ],
                [
                    80.8683208,
                    53.6078811
                ],
                [
                    80.8790347,
                    53.6108542
                ],
                [
                    80.8881934,
                    53.6070608
                ],
                [
                    80.887675,
                    53.6018315
                ],
                [
                    80.8968337,
                    53.593012
                ],
                [
                    80.8835277,
                    53.589217
                ],
                [
                    80.8679752,
                    53.5874733
                ],
                [
                    80.8570884,
                    53.5947556
                ],
                [
                    80.8384254,
                    53.5953709
                ]
            ],
            "longitude": 80.8756283,
            "latitude": 53.59529
        },
        "4552": {
            "name": "Кругло-Семенцы",
            "population": 368,
            "type": "village",
            "poly": null,
            "longitude": 80.8965192,
            "latitude": 51.5305565
        },
        "4553": {
            "name": "Маловолчанка",
            "population": 582,
            "type": "village",
            "poly": [
                [
                    80.8782487,
                    54.0628539
                ],
                [
                    80.8794583,
                    54.0682288
                ],
                [
                    80.8920731,
                    54.0707639
                ],
                [
                    80.8936284,
                    54.0760363
                ],
                [
                    80.9359658,
                    54.0900254
                ],
                [
                    80.9335465,
                    54.0790778
                ],
                [
                    80.9022686,
                    54.0644766
                ],
                [
                    80.8804952,
                    54.0623468
                ],
                [
                    80.8782487,
                    54.0628539
                ]
            ],
            "longitude": 80.9036511,
            "latitude": 54.072589
        },
        "4554": {
            "name": "Малышев Лог",
            "population": 1053,
            "type": "village",
            "poly": [
                [
                    80.8913348,
                    52.1815803
                ],
                [
                    80.9000895,
                    52.1858955
                ],
                [
                    80.9033511,
                    52.1841063
                ],
                [
                    80.9109042,
                    52.1798961
                ],
                [
                    80.9213755,
                    52.1784225
                ],
                [
                    80.9327051,
                    52.1777909
                ],
                [
                    80.9356234,
                    52.170527
                ],
                [
                    80.9347651,
                    52.1645255
                ],
                [
                    80.9296152,
                    52.1548372
                ],
                [
                    80.9330485,
                    52.1452521
                ],
                [
                    80.9134791,
                    52.1436719
                ],
                [
                    80.9030077,
                    52.1465162
                ],
                [
                    80.9011194,
                    52.1552584
                ],
                [
                    80.9071276,
                    52.1622089
                ],
                [
                    80.9119341,
                    52.1702111
                ],
                [
                    80.9048959,
                    52.1777909
                ],
                [
                    80.9004328,
                    52.1804224
                ],
                [
                    80.8913348,
                    52.1815803
                ]
            ],
            "longitude": 80.9174807,
            "latitude": 52.1553854
        },
        "4555": {
            "name": "Завьялово",
            "population": 6763,
            "type": "village",
            "poly": [
                [
                    80.8734984,
                    52.8390066
                ],
                [
                    80.8752982,
                    52.8424131
                ],
                [
                    80.8851687,
                    52.8482605
                ],
                [
                    80.8988587,
                    52.8530913
                ],
                [
                    80.9115616,
                    52.856201
                ],
                [
                    80.9212176,
                    52.8539206
                ],
                [
                    80.9310431,
                    52.8549312
                ],
                [
                    80.9358067,
                    52.8541279
                ],
                [
                    80.9472651,
                    52.8555273
                ],
                [
                    80.9480805,
                    52.8532468
                ],
                [
                    80.9446043,
                    52.8485042
                ],
                [
                    80.9431044,
                    52.8404586
                ],
                [
                    80.9425444,
                    52.8387062
                ],
                [
                    80.9403128,
                    52.8372545
                ],
                [
                    80.9393257,
                    52.8350262
                ],
                [
                    80.9391112,
                    52.8340669
                ],
                [
                    80.9324593,
                    52.830852
                ],
                [
                    80.9243075,
                    52.8283109
                ],
                [
                    80.9193722,
                    52.8253808
                ],
                [
                    80.9113042,
                    52.824136
                ],
                [
                    80.9038798,
                    52.8209463
                ],
                [
                    80.8995024,
                    52.8190529
                ],
                [
                    80.8973996,
                    52.8199089
                ],
                [
                    80.8901039,
                    52.8218021
                ],
                [
                    80.8868424,
                    52.8235395
                ],
                [
                    80.8828084,
                    52.8268587
                ],
                [
                    80.8844392,
                    52.8320187
                ],
                [
                    80.8830659,
                    52.8378144
                ],
                [
                    80.8734984,
                    52.8390066
                ]
            ],
            "longitude": 80.920074,
            "latitude": 52.838428
        },
        "4556": {
            "name": "Толстовский",
            "population": 615,
            "type": "village",
            "poly": null,
            "longitude": 80.936771,
            "latitude": 53.6803275
        },
        "4557": {
            "name": "Ситниково",
            "population": 676,
            "type": "village",
            "poly": null,
            "longitude": 80.9407571,
            "latitude": 53.1328107
        },
        "4558": {
            "name": "Харитоново",
            "population": 1048,
            "type": "village",
            "poly": null,
            "longitude": 80.9420525,
            "latitude": 53.0288735
        },
        "4559": {
            "name": "Селивёрстово",
            "population": 659,
            "type": "village",
            "poly": [
                [
                    80.9365634,
                    52.289808
                ],
                [
                    80.9421277,
                    52.2918847
                ],
                [
                    80.9474546,
                    52.2959502
                ],
                [
                    80.9532899,
                    52.2975763
                ],
                [
                    80.9530256,
                    52.2981821
                ],
                [
                    80.9547484,
                    52.2993596
                ],
                [
                    80.9564131,
                    52.297874
                ],
                [
                    80.9563817,
                    52.2971753
                ],
                [
                    80.9622334,
                    52.2991523
                ],
                [
                    80.964044,
                    52.2998103
                ],
                [
                    80.9649168,
                    52.3021166
                ],
                [
                    80.9635277,
                    52.3044689
                ],
                [
                    80.9556781,
                    52.3072112
                ],
                [
                    80.9872746,
                    52.3171812
                ],
                [
                    80.9798932,
                    52.2989187
                ],
                [
                    80.9589505,
                    52.2858995
                ],
                [
                    80.9430988,
                    52.2844869
                ],
                [
                    80.9408002,
                    52.2858067
                ],
                [
                    80.9401949,
                    52.2868813
                ],
                [
                    80.9365634,
                    52.289808
                ]
            ],
            "longitude": 80.9549348,
            "latitude": 52.2959412
        },
        "4560": {
            "name": "Грановка",
            "population": 371,
            "type": "village",
            "poly": null,
            "longitude": 80.9700793,
            "latitude": 52.4106365
        },
        "4561": {
            "name": "Прослауха",
            "population": 457,
            "type": "village",
            "poly": null,
            "longitude": 80.9707663,
            "latitude": 53.3380692
        },
        "4562": {
            "name": "Тамбовский",
            "population": 895,
            "type": "village",
            "poly": null,
            "longitude": 80.9843796,
            "latitude": 52.6526919
        },
        "4563": {
            "name": "Закладное",
            "population": 748,
            "type": "village",
            "poly": null,
            "longitude": 80.9969935,
            "latitude": 52.5831383
        },
        "4564": {
            "name": "Подборный",
            "population": 396,
            "type": "village",
            "poly": null,
            "longitude": 81.0037093,
            "latitude": 53.998866
        },
        "4565": {
            "name": "Буян",
            "population": 628,
            "type": "village",
            "poly": null,
            "longitude": 81.004657,
            "latitude": 53.8215683
        },
        "4566": {
            "name": "Сросты",
            "population": 1948,
            "type": "village",
            "poly": [
                [
                    80.9860442,
                    51.8814147
                ],
                [
                    80.9906509,
                    51.8846325
                ],
                [
                    80.9893173,
                    51.8889723
                ],
                [
                    80.9986519,
                    51.8960797
                ],
                [
                    80.9951363,
                    51.8998199
                ],
                [
                    80.9951363,
                    51.9023632
                ],
                [
                    81.0072591,
                    51.9100667
                ],
                [
                    81.0152602,
                    51.9084962
                ],
                [
                    81.0230189,
                    51.9164978
                ],
                [
                    81.0241099,
                    51.9127589
                ],
                [
                    81.0323534,
                    51.910665
                ],
                [
                    81.0299289,
                    51.9089449
                ],
                [
                    81.0399908,
                    51.9042331
                ],
                [
                    81.0215641,
                    51.8874009
                ],
                [
                    81.0185334,
                    51.8822379
                ],
                [
                    81.012472,
                    51.8809657
                ],
                [
                    81.006653,
                    51.8790948
                ],
                [
                    81.0007128,
                    51.8746792
                ],
                [
                    80.9956212,
                    51.8783465
                ],
                [
                    80.9862866,
                    51.8778974
                ],
                [
                    80.9860442,
                    51.8814147
                ]
            ],
            "longitude": 81.0121083,
            "latitude": 51.8940598
        },
        "4567": {
            "name": "Долганка",
            "population": 1288,
            "type": "village",
            "poly": [
                [
                    81.0256241,
                    54.1497479
                ],
                [
                    81.0279743,
                    54.1516911
                ],
                [
                    81.0435959,
                    54.1501528
                ],
                [
                    81.0510611,
                    54.1414076
                ],
                [
                    81.0599088,
                    54.1405168
                ],
                [
                    81.0612912,
                    54.1329037
                ],
                [
                    81.0416605,
                    54.1313647
                ],
                [
                    81.0405545,
                    54.1219675
                ],
                [
                    81.0322599,
                    54.1213193
                ],
                [
                    81.0256241,
                    54.1497479
                ]
            ],
            "longitude": 81.0401398,
            "latitude": 54.1363865
        },
        "4568": {
            "name": "Светлое",
            "population": 525,
            "type": "village",
            "poly": [
                [
                    81.0436326,
                    52.9010949
                ],
                [
                    81.0444265,
                    52.9050734
                ],
                [
                    81.0482031,
                    52.9083347
                ],
                [
                    81.0555845,
                    52.9112334
                ],
                [
                    81.0625368,
                    52.9090594
                ],
                [
                    81.0687166,
                    52.9103534
                ],
                [
                    81.0723215,
                    52.9096805
                ],
                [
                    81.0691243,
                    52.9079801
                ],
                [
                    81.0538679,
                    52.9050734
                ],
                [
                    81.0522157,
                    52.9004736
                ],
                [
                    81.0436326,
                    52.9010949
                ]
            ],
            "longitude": 81.0549843,
            "latitude": 52.9081232
        },
        "4569": {
            "name": "Корнилово",
            "population": 1238,
            "type": "village",
            "poly": [
                [
                    81.0458012,
                    53.5154279
                ],
                [
                    81.0499485,
                    53.5287424
                ],
                [
                    81.0583815,
                    53.5358089
                ],
                [
                    81.0618376,
                    53.5386023
                ],
                [
                    81.0650172,
                    53.5404097
                ],
                [
                    81.0666761,
                    53.5396703
                ],
                [
                    81.0697175,
                    53.540574
                ],
                [
                    81.0791181,
                    53.5317006
                ],
                [
                    81.0746943,
                    53.5255374
                ],
                [
                    81.0807771,
                    53.5210172
                ],
                [
                    81.0787034,
                    53.5114821
                ],
                [
                    81.0860304,
                    53.5065493
                ],
                [
                    81.0843714,
                    53.5004647
                ],
                [
                    81.0817448,
                    53.4975043
                ],
                [
                    81.0795329,
                    53.4989845
                ],
                [
                    81.0583815,
                    53.5101667
                ],
                [
                    81.0458012,
                    53.5154279
                ]
            ],
            "longitude": 81.0653599,
            "latitude": 53.5219297
        },
        "4570": {
            "name": "Гилёв-Лог",
            "population": 1167,
            "type": "village",
            "poly": null,
            "longitude": 81.0839156,
            "latitude": 52.7740079
        },
        "4571": {
            "name": "Гилёвка",
            "population": 1232,
            "type": "village",
            "poly": null,
            "longitude": 81.105789,
            "latitude": 52.860867
        },
        "4572": {
            "name": "Веселоярск",
            "population": 4799,
            "type": "village",
            "poly": [
                [
                    81.0821872,
                    51.2733893
                ],
                [
                    81.0821872,
                    51.2846641
                ],
                [
                    81.0873371,
                    51.2963655
                ],
                [
                    81.0883439,
                    51.2968701
                ],
                [
                    81.0962635,
                    51.3003369
                ],
                [
                    81.1021,
                    51.3058103
                ],
                [
                    81.1103397,
                    51.3048445
                ],
                [
                    81.1158329,
                    51.3116051
                ],
                [
                    81.123386,
                    51.3087078
                ],
                [
                    81.1333423,
                    51.3131073
                ],
                [
                    81.1360889,
                    51.3103174
                ],
                [
                    81.1273342,
                    51.3045225
                ],
                [
                    81.1194378,
                    51.2945407
                ],
                [
                    81.1245876,
                    51.2914277
                ],
                [
                    81.1105114,
                    51.2704897
                ],
                [
                    81.1055332,
                    51.2666231
                ],
                [
                    81.1024969,
                    51.2675031
                ],
                [
                    81.0821872,
                    51.2733893
                ]
            ],
            "longitude": 81.1067348,
            "latitude": 51.2858452
        },
        "4573": {
            "name": "Паклино",
            "population": 306,
            "type": "village",
            "poly": [
                [
                    81.082844,
                    53.1394143
                ],
                [
                    81.0882356,
                    53.1462968
                ],
                [
                    81.1053778,
                    53.1457164
                ],
                [
                    81.1135343,
                    53.1535098
                ],
                [
                    81.1262528,
                    53.1501107
                ],
                [
                    81.128603,
                    53.1473747
                ],
                [
                    81.1139491,
                    53.1318671
                ],
                [
                    81.1107694,
                    53.1315352
                ],
                [
                    81.082844,
                    53.1394143
                ]
            ],
            "longitude": 81.1075008,
            "latitude": 53.1416739
        },
        "4574": {
            "name": "Пушкино",
            "population": 353,
            "type": "village",
            "poly": null,
            "longitude": 81.1175374,
            "latitude": 51.5284304
        },
        "4575": {
            "name": "Октябрьский",
            "population": 443,
            "type": "village",
            "poly": null,
            "longitude": 81.1237407,
            "latitude": 53.7140063
        },
        "4576": {
            "name": "Куйбышево",
            "population": 941,
            "type": "village",
            "poly": [
                [
                    81.1191106,
                    51.5768481
                ],
                [
                    81.1203122,
                    51.5770615
                ],
                [
                    81.1258054,
                    51.578555
                ],
                [
                    81.1299252,
                    51.5815419
                ],
                [
                    81.1338734,
                    51.5851685
                ],
                [
                    81.1391949,
                    51.5846352
                ],
                [
                    81.1452031,
                    51.5863418
                ],
                [
                    81.1484647,
                    51.5830352
                ],
                [
                    81.1479497,
                    51.5796218
                ],
                [
                    81.1429715,
                    51.5772749
                ],
                [
                    81.137135,
                    51.5756746
                ],
                [
                    81.1258054,
                    51.5732208
                ],
                [
                    81.1240887,
                    51.5673525
                ],
                [
                    81.1191106,
                    51.5768481
                ]
            ],
            "longitude": 81.1326084,
            "latitude": 51.5785555
        },
        "4577": {
            "name": "Колос",
            "population": 462,
            "type": "village",
            "poly": null,
            "longitude": 81.137423,
            "latitude": 51.424238
        },
        "4578": {
            "name": "Титовка",
            "population": 933,
            "type": "village",
            "poly": [
                [
                    81.1114203,
                    51.9859652
                ],
                [
                    81.1199063,
                    51.9994765
                ],
                [
                    81.1309381,
                    52.0079842
                ],
                [
                    81.131423,
                    52.0114168
                ],
                [
                    81.1652457,
                    52.034169
                ],
                [
                    81.1744591,
                    52.0324537
                ],
                [
                    81.1742167,
                    52.0298433
                ],
                [
                    81.1700949,
                    52.0271581
                ],
                [
                    81.173853,
                    52.0250695
                ],
                [
                    81.1739742,
                    52.0218619
                ],
                [
                    81.1487587,
                    52.0032082
                ],
                [
                    81.1412425,
                    52.0056709
                ],
                [
                    81.1300895,
                    51.9974613
                ],
                [
                    81.1367571,
                    51.9943263
                ],
                [
                    81.135666,
                    51.9920122
                ],
                [
                    81.1173605,
                    51.9837254
                ],
                [
                    81.1114203,
                    51.9859652
                ]
            ],
            "longitude": 81.1413638,
            "latitude": 52.0085812
        },
        "4579": {
            "name": "Мичуринский",
            "population": 426,
            "type": "village",
            "poly": null,
            "longitude": 81.154625,
            "latitude": 51.463699
        },
        "4580": {
            "name": "Бурановка",
            "population": 357,
            "type": "village",
            "poly": [
                [
                    81.1415982,
                    52.4344475
                ],
                [
                    81.1460613,
                    52.436122
                ],
                [
                    81.1458897,
                    52.438215
                ],
                [
                    81.1591077,
                    52.4453305
                ],
                [
                    81.1702657,
                    52.439994
                ],
                [
                    81.1742139,
                    52.4338196
                ],
                [
                    81.1567044,
                    52.4246087
                ],
                [
                    81.1417699,
                    52.433087
                ],
                [
                    81.1415982,
                    52.4344475
                ]
            ],
            "longitude": 81.15769,
            "latitude": 52.4375426
        },
        "4581": {
            "name": "Новенькое",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 81.1581611,
            "latitude": 51.0596632
        },
        "4582": {
            "name": "Новоалександровка",
            "population": 1021,
            "type": "village",
            "poly": [
                [
                    81.1492232,
                    51.3674271
                ],
                [
                    81.1497081,
                    51.3756005
                ],
                [
                    81.1518902,
                    51.3780975
                ],
                [
                    81.1568606,
                    51.3786273
                ],
                [
                    81.1693471,
                    51.3926992
                ],
                [
                    81.1786817,
                    51.3892951
                ],
                [
                    81.168256,
                    51.3784759
                ],
                [
                    81.1728627,
                    51.3762815
                ],
                [
                    81.1693471,
                    51.3600093
                ],
                [
                    81.1527388,
                    51.3628858
                ],
                [
                    81.1531025,
                    51.3662161
                ],
                [
                    81.1492232,
                    51.3674271
                ]
            ],
            "longitude": 81.1635281,
            "latitude": 51.3746167
        },
        "4583": {
            "name": "Ветренно-Телеутское",
            "population": 282,
            "type": "village",
            "poly": null,
            "longitude": 81.171779,
            "latitude": 53.4602729
        },
        "4584": {
            "name": "Кулундинский",
            "population": 273,
            "type": "village",
            "poly": null,
            "longitude": 81.1774654,
            "latitude": 53.2275868
        },
        "4585": {
            "name": "Зелёная Дубрава",
            "population": 1001,
            "type": "village",
            "poly": null,
            "longitude": 81.184067,
            "latitude": 51.459007
        },
        "4586": {
            "name": "Андроново",
            "population": 444,
            "type": "village",
            "poly": null,
            "longitude": 81.1860556,
            "latitude": 53.31869
        },
        "4587": {
            "name": "Боровое",
            "population": 388,
            "type": "village",
            "poly": null,
            "longitude": 81.1873738,
            "latitude": 54.031538
        },
        "4588": {
            "name": "Долгово",
            "population": 549,
            "type": "village",
            "poly": [
                [
                    81.1694073,
                    52.3460288
                ],
                [
                    81.1860585,
                    52.3558852
                ],
                [
                    81.1886334,
                    52.3555707
                ],
                [
                    81.1932683,
                    52.3587159
                ],
                [
                    81.1965297,
                    52.3581917
                ],
                [
                    81.1948132,
                    52.3500135
                ],
                [
                    81.1999631,
                    52.3534737
                ],
                [
                    81.211636,
                    52.3564093
                ],
                [
                    81.2138676,
                    52.353998
                ],
                [
                    81.2032246,
                    52.3441412
                ],
                [
                    81.2080311,
                    52.3402608
                ],
                [
                    81.2070011,
                    52.3369045
                ],
                [
                    81.1992764,
                    52.3375338
                ],
                [
                    81.1951566,
                    52.3330235
                ],
                [
                    81.1838269,
                    52.3358556
                ],
                [
                    81.1872111,
                    52.3401137
                ],
                [
                    81.1810803,
                    52.3439314
                ],
                [
                    81.1745572,
                    52.3414145
                ],
                [
                    81.1694073,
                    52.3460288
                ]
            ],
            "longitude": 81.1889273,
            "latitude": 52.3467592
        },
        "4589": {
            "name": "Первомайское",
            "population": 797,
            "type": "village",
            "poly": [
                [
                    81.181252,
                    51.735313
                ],
                [
                    81.1817669,
                    51.7371202
                ],
                [
                    81.1836552,
                    51.7395652
                ],
                [
                    81.189835,
                    51.7417974
                ],
                [
                    81.1958432,
                    51.7426478
                ],
                [
                    81.1985897,
                    51.740203
                ],
                [
                    81.2016797,
                    51.7404156
                ],
                [
                    81.2052846,
                    51.73914
                ],
                [
                    81.2032246,
                    51.7363761
                ],
                [
                    81.2037396,
                    51.7328678
                ],
                [
                    81.1970448,
                    51.7299973
                ],
                [
                    81.190865,
                    51.7303162
                ],
                [
                    81.1829686,
                    51.7304225
                ],
                [
                    81.181252,
                    51.735313
                ]
            ],
            "longitude": 81.1927471,
            "latitude": 51.7376971
        },
        "4590": {
            "name": "Заковряшино",
            "population": 736,
            "type": "village",
            "poly": null,
            "longitude": 81.1959431,
            "latitude": 53.8946914
        },
        "4591": {
            "name": "Приозёрный",
            "population": 388,
            "type": "village",
            "poly": null,
            "longitude": 81.2023519,
            "latitude": 51.5730507
        },
        "4592": {
            "name": "Локоть",
            "population": 1066,
            "type": "village",
            "poly": null,
            "longitude": 81.20356,
            "latitude": 51.18935
        },
        "4593": {
            "name": "Мельниково",
            "population": 947,
            "type": "village",
            "poly": [
                [
                    81.1855624,
                    52.1935778
                ],
                [
                    81.1859057,
                    52.1988389
                ],
                [
                    81.1948321,
                    52.2086228
                ],
                [
                    81.206505,
                    52.2107266
                ],
                [
                    81.218178,
                    52.2130407
                ],
                [
                    81.2234995,
                    52.2093592
                ],
                [
                    81.2214396,
                    52.2062034
                ],
                [
                    81.1967203,
                    52.1933674
                ],
                [
                    81.1855624,
                    52.1935778
                ]
            ],
            "longitude": 81.208969,
            "latitude": 52.204197
        },
        "4594": {
            "name": "Овечкино",
            "population": 618,
            "type": "village",
            "poly": [
                [
                    81.192433,
                    52.9954302
                ],
                [
                    81.1943942,
                    52.9976644
                ],
                [
                    81.2072087,
                    53.003775
                ],
                [
                    81.2152554,
                    53.0068532
                ],
                [
                    81.2237787,
                    53.0073588
                ],
                [
                    81.2232257,
                    53.0019515
                ],
                [
                    81.2262671,
                    52.9990396
                ],
                [
                    81.2259906,
                    52.9972924
                ],
                [
                    81.2239222,
                    52.9946754
                ],
                [
                    81.2138928,
                    52.9907283
                ],
                [
                    81.2082953,
                    52.989221
                ],
                [
                    81.1988947,
                    52.9903028
                ],
                [
                    81.192433,
                    52.9954302
                ]
            ],
            "longitude": 81.210309,
            "latitude": 52.9973187
        },
        "4595": {
            "name": "Мормыши",
            "population": 241,
            "type": "village",
            "poly": [
                [
                    81.1896634,
                    52.4479461
                ],
                [
                    81.2190175,
                    52.4665654
                ],
                [
                    81.2284589,
                    52.4636371
                ],
                [
                    81.1992764,
                    52.4425054
                ],
                [
                    81.1896634,
                    52.4479461
                ]
            ],
            "longitude": 81.2110603,
            "latitude": 52.4529541
        },
        "4596": {
            "name": "Крутиха",
            "population": 3684,
            "type": "village",
            "poly": null,
            "longitude": 81.2120244,
            "latitude": 53.96353
        },
        "4597": {
            "name": "Токарёво",
            "population": 749,
            "type": "village",
            "poly": null,
            "longitude": 81.2149102,
            "latitude": 52.0594419
        },
        "4598": {
            "name": "Ремовский",
            "population": 864,
            "type": "village",
            "poly": null,
            "longitude": 81.2229439,
            "latitude": 51.1299502
        },
        "4599": {
            "name": "Половинкино",
            "population": 1103,
            "type": "village",
            "poly": [
                [
                    81.2294888,
                    51.4278908
                ],
                [
                    81.2328284,
                    51.4305623
                ],
                [
                    81.2341165,
                    51.4287117
                ],
                [
                    81.2372081,
                    51.4246924
                ],
                [
                    81.2384244,
                    51.4225939
                ],
                [
                    81.2407185,
                    51.4222722
                ],
                [
                    81.2410339,
                    51.4211993
                ],
                [
                    81.2465682,
                    51.4210205
                ],
                [
                    81.2480019,
                    51.4182487
                ],
                [
                    81.2440793,
                    51.4164744
                ],
                [
                    81.2433934,
                    51.4057301
                ],
                [
                    81.2337804,
                    51.405623
                ],
                [
                    81.2294888,
                    51.4278908
                ]
            ],
            "longitude": 81.237383,
            "latitude": 51.4171649
        },
        "4600": {
            "name": "Черемшанка",
            "population": 650,
            "type": "village",
            "poly": null,
            "longitude": 81.2525154,
            "latitude": 53.2590329
        },
        "4601": {
            "name": "Грязново",
            "population": 453,
            "type": "village",
            "poly": null,
            "longitude": 81.2686009,
            "latitude": 53.3794723
        },
        "4602": {
            "name": "Самарка",
            "population": 921,
            "type": "village",
            "poly": null,
            "longitude": 81.2692096,
            "latitude": 51.3708958
        },
        "4603": {
            "name": "Советский Путь",
            "population": 652,
            "type": "village",
            "poly": [
                [
                    81.2634389,
                    51.1387927
                ],
                [
                    81.2854102,
                    51.1391185
                ],
                [
                    81.2855997,
                    51.1366524
                ],
                [
                    81.2857782,
                    51.1343294
                ],
                [
                    81.2924837,
                    51.1343092
                ],
                [
                    81.2940045,
                    51.132892
                ],
                [
                    81.2939616,
                    51.1313907
                ],
                [
                    81.2932857,
                    51.1284282
                ],
                [
                    81.2898444,
                    51.1278659
                ],
                [
                    81.2838336,
                    51.1238224
                ],
                [
                    81.2790056,
                    51.1210682
                ],
                [
                    81.277922,
                    51.1209534
                ],
                [
                    81.2763556,
                    51.1221319
                ],
                [
                    81.2752318,
                    51.1240076
                ],
                [
                    81.2738799,
                    51.1268223
                ],
                [
                    81.2675263,
                    51.1271484
                ],
                [
                    81.2634735,
                    51.1300586
                ],
                [
                    81.2634389,
                    51.1387927
                ]
            ],
            "longitude": 81.2784805,
            "latitude": 51.1313517
        },
        "4604": {
            "name": "Безрукавка",
            "population": 1729,
            "type": "village",
            "poly": [
                [
                    81.2636494,
                    51.5708736
                ],
                [
                    81.2828755,
                    51.5959401
                ],
                [
                    81.2852886,
                    51.6006142
                ],
                [
                    81.2938567,
                    51.6001363
                ],
                [
                    81.2918019,
                    51.5809019
                ],
                [
                    81.2873387,
                    51.5736476
                ],
                [
                    81.2799573,
                    51.5739677
                ],
                [
                    81.2701726,
                    51.5671391
                ],
                [
                    81.2662244,
                    51.5682061
                ],
                [
                    81.2662244,
                    51.57002
                ],
                [
                    81.2636494,
                    51.5708736
                ]
            ],
            "longitude": 81.2812285,
            "latitude": 51.5824483
        },
        "4605": {
            "name": "Вымпел",
            "population": 158,
            "type": "village",
            "poly": null,
            "longitude": 81.2820095,
            "latitude": 51.5033849
        },
        "4606": {
            "name": "Зарница",
            "population": 257,
            "type": "village",
            "poly": null,
            "longitude": 81.2846748,
            "latitude": 51.6345953
        },
        "4607": {
            "name": "Гонохово",
            "population": 1787,
            "type": "village",
            "poly": null,
            "longitude": 81.292145,
            "latitude": 52.940624
        },
        "4608": {
            "name": "Берёзовка",
            "population": 415,
            "type": "village",
            "poly": [
                [
                    81.2839055,
                    51.556254
                ],
                [
                    81.2863087,
                    51.5587086
                ],
                [
                    81.3024449,
                    51.5674592
                ],
                [
                    81.3042425,
                    51.5663672
                ],
                [
                    81.3099979,
                    51.5628707
                ],
                [
                    81.3077664,
                    51.5603095
                ],
                [
                    81.2924886,
                    51.5525183
                ],
                [
                    81.2869954,
                    51.5524115
                ],
                [
                    81.2839055,
                    51.556254
                ]
            ],
            "longitude": 81.297073,
            "latitude": 51.561043
        },
        "4609": {
            "name": "Захарово",
            "population": 256,
            "type": "village",
            "poly": null,
            "longitude": 81.324776,
            "latitude": 51.6544923
        },
        "4610": {
            "name": "Тишинка",
            "population": 530,
            "type": "village",
            "poly": [
                [
                    81.3089679,
                    51.7972487
                ],
                [
                    81.3098264,
                    51.800752
                ],
                [
                    81.3165211,
                    51.8080761
                ],
                [
                    81.321671,
                    51.8148684
                ],
                [
                    81.3297391,
                    51.813701
                ],
                [
                    81.3350606,
                    51.8104111
                ],
                [
                    81.3417554,
                    51.808819
                ],
                [
                    81.3436435,
                    51.8073331
                ],
                [
                    81.3405537,
                    51.8051041
                ],
                [
                    81.3309407,
                    51.7990535
                ],
                [
                    81.322186,
                    51.7927896
                ],
                [
                    81.3089679,
                    51.7972487
                ]
            ],
            "longitude": 81.3258239,
            "latitude": 51.8042523
        },
        "4611": {
            "name": "Калиновка",
            "population": 236,
            "type": "village",
            "poly": [
                [
                    81.3209843,
                    51.4939879
                ],
                [
                    81.3218467,
                    51.4951604
                ],
                [
                    81.3293957,
                    51.5054222
                ],
                [
                    81.3362621,
                    51.504888
                ],
                [
                    81.3517117,
                    51.5083071
                ],
                [
                    81.3656163,
                    51.5040332
                ],
                [
                    81.3630414,
                    51.4997589
                ],
                [
                    81.3388371,
                    51.4967666
                ],
                [
                    81.3367772,
                    51.4894989
                ],
                [
                    81.3363727,
                    51.4895323
                ],
                [
                    81.3314384,
                    51.4899401
                ],
                [
                    81.3261234,
                    51.4902487
                ],
                [
                    81.3209843,
                    51.4939879
                ]
            ],
            "longitude": 81.332676,
            "latitude": 51.4973758
        },
        "4612": {
            "name": "Дресвянка",
            "population": 411,
            "type": "village",
            "poly": [
                [
                    81.3183433,
                    53.8886018
                ],
                [
                    81.3228123,
                    53.8987958
                ],
                [
                    81.3262098,
                    53.8991628
                ],
                [
                    81.327682,
                    53.8942246
                ],
                [
                    81.3356095,
                    53.8903538
                ],
                [
                    81.3366854,
                    53.8856482
                ],
                [
                    81.3515211,
                    53.8840462
                ],
                [
                    81.3560511,
                    53.8815763
                ],
                [
                    81.356167,
                    53.8782368
                ],
                [
                    81.3397989,
                    53.8694344
                ],
                [
                    81.3362598,
                    53.8688475
                ],
                [
                    81.3320572,
                    53.8754333
                ],
                [
                    81.3232095,
                    53.8818225
                ],
                [
                    81.3183433,
                    53.8886018
                ]
            ],
            "longitude": 81.3335607,
            "latitude": 53.8814468
        },
        "4613": {
            "name": "Майский",
            "population": 441,
            "type": "village",
            "poly": null,
            "longitude": 81.3545182,
            "latitude": 52.7679378
        },
        "4614": {
            "name": "Аксёновка",
            "population": 60,
            "type": "village",
            "poly": [
                [
                    81.3522267,
                    51.8562369
                ],
                [
                    81.3587498,
                    51.8590995
                ],
                [
                    81.3628697,
                    51.8607957
                ],
                [
                    81.3659596,
                    51.8609017
                ],
                [
                    81.3692212,
                    51.8585694
                ],
                [
                    81.3723111,
                    51.8553887
                ],
                [
                    81.3683628,
                    51.8537983
                ],
                [
                    81.3664746,
                    51.8534802
                ],
                [
                    81.3628697,
                    51.8513595
                ],
                [
                    81.3558316,
                    51.8505112
                ],
                [
                    81.3522267,
                    51.8562369
                ]
            ],
            "longitude": 81.3610916,
            "latitude": 51.8552458
        },
        "4615": {
            "name": "Самарка",
            "population": 590,
            "type": "village",
            "poly": null,
            "longitude": 81.535645,
            "latitude": 50.907642
        },
        "4616": {
            "name": "Гуселетово",
            "population": 842,
            "type": "village",
            "poly": [
                [
                    81.3354039,
                    52.5356387
                ],
                [
                    81.3402104,
                    52.5407548
                ],
                [
                    81.3453603,
                    52.5432604
                ],
                [
                    81.3532567,
                    52.54848
                ],
                [
                    81.3599514,
                    52.5541165
                ],
                [
                    81.3766026,
                    52.5672653
                ],
                [
                    81.3851856,
                    52.5688305
                ],
                [
                    81.3896489,
                    52.5692478
                ],
                [
                    81.3958287,
                    52.5713345
                ],
                [
                    81.3987469,
                    52.5685174
                ],
                [
                    81.3917088,
                    52.5627785
                ],
                [
                    81.3853381,
                    52.5577464
                ],
                [
                    81.3752293,
                    52.5507763
                ],
                [
                    81.3762593,
                    52.5493151
                ],
                [
                    81.3692212,
                    52.5432604
                ],
                [
                    81.3584065,
                    52.5401284
                ],
                [
                    81.3493085,
                    52.5402328
                ],
                [
                    81.3469052,
                    52.5385622
                ],
                [
                    81.3448453,
                    52.5325061
                ],
                [
                    81.3402104,
                    52.5310441
                ],
                [
                    81.3354039,
                    52.5356387
                ]
            ],
            "longitude": 81.3757541,
            "latitude": 52.55972
        },
        "4617": {
            "name": "Новороссийский",
            "population": 667,
            "type": "village",
            "poly": [
                [
                    81.365788,
                    51.8396941
                ],
                [
                    81.3683628,
                    51.8419213
                ],
                [
                    81.3736844,
                    51.8439363
                ],
                [
                    81.3767742,
                    51.8445727
                ],
                [
                    81.3815808,
                    51.8456332
                ],
                [
                    81.3858723,
                    51.8469058
                ],
                [
                    81.3898205,
                    51.8449969
                ],
                [
                    81.3932538,
                    51.8428758
                ],
                [
                    81.3939404,
                    51.8410729
                ],
                [
                    81.392567,
                    51.8381031
                ],
                [
                    81.3853574,
                    51.8361937
                ],
                [
                    81.3778042,
                    51.8314204
                ],
                [
                    81.3731694,
                    51.8324811
                ],
                [
                    81.3668179,
                    51.8366181
                ],
                [
                    81.365788,
                    51.8396941
                ]
            ],
            "longitude": 81.3804312,
            "latitude": 51.8397511
        },
        "4618": {
            "name": "Солоновка",
            "population": 776,
            "type": "village",
            "poly": null,
            "longitude": 81.394409,
            "latitude": 51.982964
        },
        "4619": {
            "name": "Бобково",
            "population": 893,
            "type": "village",
            "poly": [
                [
                    81.3626981,
                    51.6643491
                ],
                [
                    81.3707661,
                    51.6685016
                ],
                [
                    81.3798642,
                    51.6646687
                ],
                [
                    81.3819241,
                    51.6643491
                ],
                [
                    81.3886189,
                    51.6666916
                ],
                [
                    81.3899922,
                    51.6695663
                ],
                [
                    81.3869023,
                    51.6740375
                ],
                [
                    81.3932538,
                    51.6775503
                ],
                [
                    81.3996053,
                    51.6758472
                ],
                [
                    81.3996053,
                    51.670418
                ],
                [
                    81.4069867,
                    51.6691404
                ],
                [
                    81.40939,
                    51.6655205
                ],
                [
                    81.4104198,
                    51.6645622
                ],
                [
                    81.4152264,
                    51.6583862
                ],
                [
                    81.4140248,
                    51.6562563
                ],
                [
                    81.397717,
                    51.6548719
                ],
                [
                    81.3941121,
                    51.6570018
                ],
                [
                    81.3917088,
                    51.6593446
                ],
                [
                    81.386559,
                    51.6593446
                ],
                [
                    81.3857007,
                    51.6583862
                ],
                [
                    81.3778042,
                    51.6559369
                ],
                [
                    81.3714528,
                    51.6604095
                ],
                [
                    81.3626981,
                    51.6643491
                ]
            ],
            "longitude": 81.3969389,
            "latitude": 51.6673817
        },
        "4620": {
            "name": "Новосклюиха",
            "population": 713,
            "type": "village",
            "poly": [
                [
                    81.3920522,
                    51.5337284
                ],
                [
                    81.3934254,
                    51.544085
                ],
                [
                    81.4040684,
                    51.5468608
                ],
                [
                    81.4087033,
                    51.5436581
                ],
                [
                    81.4083231,
                    51.5428305
                ],
                [
                    81.4052701,
                    51.5361843
                ],
                [
                    81.4004636,
                    51.5341555
                ],
                [
                    81.3999486,
                    51.5316995
                ],
                [
                    81.3920522,
                    51.5337284
                ]
            ],
            "longitude": 81.3983315,
            "latitude": 51.5387626
        },
        "4621": {
            "name": "Мамонтово",
            "population": 438,
            "type": "village",
            "poly": [
                [
                    81.3831258,
                    51.7494499
                ],
                [
                    81.3884473,
                    51.753807
                ],
                [
                    81.3930821,
                    51.7534882
                ],
                [
                    81.394627,
                    51.7555071
                ],
                [
                    81.3999486,
                    51.7556135
                ],
                [
                    81.4023518,
                    51.7568886
                ],
                [
                    81.4111066,
                    51.7568886
                ],
                [
                    81.4152264,
                    51.7556135
                ],
                [
                    81.4138531,
                    51.7525318
                ],
                [
                    81.4167714,
                    51.7467929
                ],
                [
                    81.4066433,
                    51.7369076
                ],
                [
                    81.3951421,
                    51.7403093
                ],
                [
                    81.3831258,
                    51.7494499
                ]
            ],
            "longitude": 81.4032339,
            "latitude": 51.7484248
        },
        "4622": {
            "name": "Рыбное",
            "population": 811,
            "type": "village",
            "poly": null,
            "longitude": 81.409435,
            "latitude": 53.5684235
        },
        "4623": {
            "name": "Николаевка",
            "population": 458,
            "type": "village",
            "poly": [
                [
                    81.3925037,
                    51.091326
                ],
                [
                    81.402975,
                    51.0857192
                ],
                [
                    81.4060649,
                    51.0833468
                ],
                [
                    81.4093265,
                    51.0836703
                ],
                [
                    81.4093265,
                    51.0855035
                ],
                [
                    81.410528,
                    51.085827
                ],
                [
                    81.414133,
                    51.083886
                ],
                [
                    81.4216861,
                    51.0797881
                ],
                [
                    81.4244327,
                    51.079896
                ],
                [
                    81.425291,
                    51.0800038
                ],
                [
                    81.4294108,
                    51.0774155
                ],
                [
                    81.4292392,
                    51.0762291
                ],
                [
                    81.426836,
                    51.0742877
                ],
                [
                    81.4249477,
                    51.0726699
                ],
                [
                    81.4249477,
                    51.0705126
                ],
                [
                    81.4266643,
                    51.0667371
                ],
                [
                    81.4275226,
                    51.0635008
                ],
                [
                    81.4261493,
                    51.0603721
                ],
                [
                    81.4239177,
                    51.0609115
                ],
                [
                    81.4204845,
                    51.0625298
                ],
                [
                    81.416708,
                    51.064256
                ],
                [
                    81.4127597,
                    51.0649032
                ],
                [
                    81.4084682,
                    51.066845
                ],
                [
                    81.405035,
                    51.0694339
                ],
                [
                    81.404005,
                    51.0726699
                ],
                [
                    81.4038333,
                    51.0751506
                ],
                [
                    81.4024601,
                    51.0801117
                ],
                [
                    81.3930187,
                    51.0881992
                ],
                [
                    81.3925037,
                    51.091326
                ]
            ],
            "longitude": 81.4136401,
            "latitude": 51.0737042
        },
        "4624": {
            "name": "Шмидта",
            "population": 91,
            "type": "village",
            "poly": [
                [
                    81.4054417,
                    51.7921526
                ],
                [
                    81.417458,
                    51.804255
                ],
                [
                    81.428101,
                    51.801495
                ],
                [
                    81.4214062,
                    51.7965056
                ],
                [
                    81.4238095,
                    51.7943822
                ],
                [
                    81.4160847,
                    51.7875868
                ],
                [
                    81.4054417,
                    51.7921526
                ]
            ],
            "longitude": 81.4190615,
            "latitude": 51.797588
        },
        "4625": {
            "name": "Ключи",
            "population": 480,
            "type": "village",
            "poly": null,
            "longitude": 81.4197216,
            "latitude": 53.4469433
        },
        "4626": {
            "name": "Плотинная",
            "population": 746,
            "type": "village",
            "poly": null,
            "longitude": 81.423851,
            "latitude": 53.792915
        },
        "4627": {
            "name": "Вылково",
            "population": 1883,
            "type": "village",
            "poly": [
                [
                    81.4007199,
                    53.0778052
                ],
                [
                    81.4037612,
                    53.0900115
                ],
                [
                    81.4271246,
                    53.0971509
                ],
                [
                    81.4319631,
                    53.1020483
                ],
                [
                    81.4373547,
                    53.1021313
                ],
                [
                    81.449581,
                    53.0956667
                ],
                [
                    81.4398486,
                    53.0875373
                ],
                [
                    81.4424144,
                    53.085199
                ],
                [
                    81.4323281,
                    53.076111
                ],
                [
                    81.4275502,
                    53.072018
                ],
                [
                    81.4249844,
                    53.0714865
                ],
                [
                    81.4140134,
                    53.0714865
                ],
                [
                    81.4090145,
                    53.0709117
                ],
                [
                    81.4007199,
                    53.0778052
                ]
            ],
            "longitude": 81.4240998,
            "latitude": 53.0866339
        },
        "4628": {
            "name": "Казанцево",
            "population": 283,
            "type": "village",
            "poly": [
                [
                    81.4087033,
                    52.65472
                ],
                [
                    81.4105916,
                    52.6599263
                ],
                [
                    81.4159131,
                    52.6619046
                ],
                [
                    81.4227795,
                    52.6566985
                ],
                [
                    81.428101,
                    52.6612798
                ],
                [
                    81.4250111,
                    52.6646115
                ],
                [
                    81.4284444,
                    52.666069
                ],
                [
                    81.4270711,
                    52.6705453
                ],
                [
                    81.439774,
                    52.6716903
                ],
                [
                    81.4399457,
                    52.6703371
                ],
                [
                    81.4380574,
                    52.6683593
                ],
                [
                    81.4490437,
                    52.6665895
                ],
                [
                    81.4531636,
                    52.6545117
                ],
                [
                    81.4471554,
                    52.6513876
                ],
                [
                    81.4244961,
                    52.6543035
                ],
                [
                    81.417458,
                    52.6515958
                ],
                [
                    81.4087033,
                    52.65472
                ]
            ],
            "longitude": 81.437065,
            "latitude": 52.660732
        },
        "4629": {
            "name": "Рассвет",
            "population": 288,
            "type": "village",
            "poly": [
                [
                    81.4260411,
                    52.7299431
                ],
                [
                    81.4432072,
                    52.7443903
                ],
                [
                    81.4555668,
                    52.740753
                ],
                [
                    81.4548802,
                    52.7382586
                ],
                [
                    81.4505887,
                    52.7386744
                ],
                [
                    81.4483571,
                    52.7373232
                ],
                [
                    81.4502454,
                    52.7355563
                ],
                [
                    81.440804,
                    52.725265
                ],
                [
                    81.4260411,
                    52.7299431
                ]
            ],
            "longitude": 81.4425123,
            "latitude": 52.7349976
        },
        "4630": {
            "name": "Бугры",
            "population": 263,
            "type": "village",
            "poly": [
                [
                    81.4309903,
                    51.2998922
                ],
                [
                    81.4433909,
                    51.299005
                ],
                [
                    81.4507326,
                    51.2953402
                ],
                [
                    81.4519651,
                    51.2944862
                ],
                [
                    81.4478293,
                    51.289338
                ],
                [
                    81.445081,
                    51.2902247
                ],
                [
                    81.4333964,
                    51.2948001
                ],
                [
                    81.4309903,
                    51.2998922
                ]
            ],
            "longitude": 81.4436902,
            "latitude": 51.2941392
        },
        "4631": {
            "name": "Покровка",
            "population": 852,
            "type": "village",
            "poly": null,
            "longitude": 81.4459615,
            "latitude": 51.1833006
        },
        "4632": {
            "name": "имени Калинина",
            "population": 144,
            "type": "village",
            "poly": null,
            "longitude": 81.4464182,
            "latitude": 51.6456131
        },
        "4633": {
            "name": "Гришенское",
            "population": 895,
            "type": "village",
            "poly": null,
            "longitude": 81.4476558,
            "latitude": 53.0081958
        },
        "4634": {
            "name": "Королёвский",
            "population": 657,
            "type": "village",
            "poly": null,
            "longitude": 81.4557956,
            "latitude": 53.1765435
        },
        "4635": {
            "name": "Катково",
            "population": 385,
            "type": "village",
            "poly": [
                [
                    81.4451619,
                    51.6577241
                ],
                [
                    81.4624532,
                    51.6586962
                ],
                [
                    81.4903205,
                    51.6553334
                ],
                [
                    81.4873504,
                    51.6485611
                ],
                [
                    81.4785157,
                    51.6498526
                ],
                [
                    81.4637566,
                    51.6510918
                ],
                [
                    81.448042,
                    51.6525074
                ],
                [
                    81.4451619,
                    51.6577241
                ]
            ],
            "longitude": 81.4581278,
            "latitude": 51.6542298
        },
        "4636": {
            "name": "Столбово",
            "population": 841,
            "type": "village",
            "poly": null,
            "longitude": 81.471969,
            "latitude": 53.9219355
        },
        "4637": {
            "name": "Новониколаевка",
            "population": 1074,
            "type": "village",
            "poly": [
                [
                    81.4679959,
                    51.3517975
                ],
                [
                    81.4688684,
                    51.3584449
                ],
                [
                    81.4753249,
                    51.3641107
                ],
                [
                    81.4888486,
                    51.3622585
                ],
                [
                    81.4923386,
                    51.3531052
                ],
                [
                    81.4866672,
                    51.3446586
                ],
                [
                    81.4698282,
                    51.3459121
                ],
                [
                    81.4679959,
                    51.3517975
                ]
            ],
            "longitude": 81.4726134,
            "latitude": 51.3523167
        },
        "4638": {
            "name": "Украинка",
            "population": 383,
            "type": "village",
            "poly": null,
            "longitude": 81.4748512,
            "latitude": 52.8460349
        },
        "4639": {
            "name": "Потеряевка",
            "population": 211,
            "type": "village",
            "poly": null,
            "longitude": 81.4840404,
            "latitude": 51.4520414
        },
        "4640": {
            "name": "10 лет Октября",
            "population": 384,
            "type": "village",
            "poly": null,
            "longitude": 81.4865646,
            "latitude": 52.0151382
        },
        "4641": {
            "name": "Поломошное",
            "population": 589,
            "type": "village",
            "poly": null,
            "longitude": 81.4901292,
            "latitude": 52.2803848
        },
        "4642": {
            "name": "Чёрная Курья",
            "population": 967,
            "type": "village",
            "poly": [
                [
                    81.4782262,
                    52.5441999
                ],
                [
                    81.4895558,
                    52.5504632
                ],
                [
                    81.4888692,
                    52.5553689
                ],
                [
                    81.492989,
                    52.5565169
                ],
                [
                    81.495049,
                    52.5577692
                ],
                [
                    81.4936757,
                    52.5588129
                ],
                [
                    81.4976238,
                    52.5619437
                ],
                [
                    81.5038037,
                    52.5609001
                ],
                [
                    81.5072369,
                    52.5612132
                ],
                [
                    81.505177,
                    52.5635089
                ],
                [
                    81.5101552,
                    52.566848
                ],
                [
                    81.5146184,
                    52.5666393
                ],
                [
                    81.5206265,
                    52.5651785
                ],
                [
                    81.5178799,
                    52.5625698
                ],
                [
                    81.523888,
                    52.5570388
                ],
                [
                    81.5103268,
                    52.543678
                ],
                [
                    81.505692,
                    52.5433648
                ],
                [
                    81.5017438,
                    52.5445132
                ],
                [
                    81.4974522,
                    52.541068
                ],
                [
                    81.4974522,
                    52.5376226
                ],
                [
                    81.495564,
                    52.5363696
                ],
                [
                    81.4782262,
                    52.5441999
                ]
            ],
            "longitude": 81.5011248,
            "latitude": 52.5524233
        },
        "4643": {
            "name": "Кировский",
            "population": 1062,
            "type": "village",
            "poly": null,
            "longitude": 81.5014986,
            "latitude": 51.0124234
        },
        "4644": {
            "name": "Романовка",
            "population": 465,
            "type": "village",
            "poly": [
                [
                    81.5018912,
                    51.3753456
                ],
                [
                    81.5044869,
                    51.3837865
                ],
                [
                    81.5085876,
                    51.3899392
                ],
                [
                    81.5140842,
                    51.3910281
                ],
                [
                    81.5174871,
                    51.3860735
                ],
                [
                    81.5125137,
                    51.376816
                ],
                [
                    81.5069276,
                    51.3721269
                ],
                [
                    81.5018912,
                    51.3753456
                ]
            ],
            "longitude": 81.508347,
            "latitude": 51.379841
        },
        "4645": {
            "name": "Георгиевка",
            "population": 532,
            "type": "village",
            "poly": null,
            "longitude": 81.5109242,
            "latitude": 51.1391777
        },
        "4646": {
            "name": "Павловка",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 81.5124826,
            "latitude": 52.079937
        },
        "4647": {
            "name": "Успенка",
            "population": 1002,
            "type": "village",
            "poly": [
                [
                    81.518276,
                    50.9758447
                ],
                [
                    81.5188699,
                    50.976023
                ],
                [
                    81.5233073,
                    50.9761311
                ],
                [
                    81.5236624,
                    50.9761113
                ],
                [
                    81.5241822,
                    50.9759895
                ],
                [
                    81.5265363,
                    50.9750623
                ],
                [
                    81.5280923,
                    50.9745349
                ],
                [
                    81.5294718,
                    50.9742386
                ],
                [
                    81.5309589,
                    50.974033
                ],
                [
                    81.5376356,
                    50.9730642
                ],
                [
                    81.5381417,
                    50.9718897
                ],
                [
                    81.5379155,
                    50.9711324
                ],
                [
                    81.5360758,
                    50.9711324
                ],
                [
                    81.5352124,
                    50.9709383
                ],
                [
                    81.5349247,
                    50.9706923
                ],
                [
                    81.5348733,
                    50.9704464
                ],
                [
                    81.5343799,
                    50.9689513
                ],
                [
                    81.5322113,
                    50.9665499
                ],
                [
                    81.5304846,
                    50.9637277
                ],
                [
                    81.5254175,
                    50.9645563
                ],
                [
                    81.5245234,
                    50.9651971
                ],
                [
                    81.5241298,
                    50.9691632
                ],
                [
                    81.5240986,
                    50.9694779
                ],
                [
                    81.518276,
                    50.9758447
                ]
            ],
            "longitude": 81.527756,
            "latitude": 50.971458
        },
        "4648": {
            "name": "Аллак",
            "population": 974,
            "type": "village",
            "poly": null,
            "longitude": 81.5309582,
            "latitude": 53.8046828
        },
        "4649": {
            "name": "Золотуха",
            "population": 902,
            "type": "village",
            "poly": null,
            "longitude": 81.5323198,
            "latitude": 50.8107284
        },
        "4650": {
            "name": "Вишнёвка",
            "population": 483,
            "type": "village",
            "poly": [
                [
                    81.5302794,
                    51.355896
                ],
                [
                    81.5364489,
                    51.3555108
                ],
                [
                    81.5358567,
                    51.3623816
                ],
                [
                    81.5343299,
                    51.3636074
                ],
                [
                    81.5331956,
                    51.367693
                ],
                [
                    81.5504656,
                    51.365785
                ],
                [
                    81.5485461,
                    51.3633882
                ],
                [
                    81.5426733,
                    51.362774
                ],
                [
                    81.5420752,
                    51.3527246
                ],
                [
                    81.5384995,
                    51.3473259
                ],
                [
                    81.5375718,
                    51.3465493
                ],
                [
                    81.5304644,
                    51.3485366
                ],
                [
                    81.5302794,
                    51.355896
                ]
            ],
            "longitude": 81.5394357,
            "latitude": 51.3569983
        },
        "4651": {
            "name": "Озимая",
            "population": 705,
            "type": "village",
            "poly": null,
            "longitude": 81.5401075,
            "latitude": 51.8470265
        },
        "4652": {
            "name": "Гонохово",
            "population": 731,
            "type": "village",
            "poly": null,
            "longitude": 81.5429875,
            "latitude": 53.6450153
        },
        "4653": {
            "name": "Крестьянка",
            "population": 1204,
            "type": "village",
            "poly": null,
            "longitude": 81.5639671,
            "latitude": 52.4249011
        },
        "4654": {
            "name": "Красноярское",
            "population": 1029,
            "type": "village",
            "poly": null,
            "longitude": 81.598297,
            "latitude": 51.749565
        },
        "4655": {
            "name": "Устьянка",
            "population": 841,
            "type": "village",
            "poly": null,
            "longitude": 81.5997697,
            "latitude": 51.1450936
        },
        "4656": {
            "name": "Трубачево",
            "population": 222,
            "type": "village",
            "poly": null,
            "longitude": 81.6123324,
            "latitude": 53.099216
        },
        "4657": {
            "name": "Свободный",
            "population": 314,
            "type": "village",
            "poly": null,
            "longitude": 81.6130173,
            "latitude": 53.2926006
        },
        "4658": {
            "name": "Комсомольский",
            "population": 971,
            "type": "village",
            "poly": null,
            "longitude": 81.6192728,
            "latitude": 52.9708166
        },
        "4659": {
            "name": "Карповский",
            "population": 356,
            "type": "village",
            "poly": null,
            "longitude": 81.6194442,
            "latitude": 53.2111084
        },
        "4660": {
            "name": "Луговое",
            "population": 769,
            "type": "village",
            "poly": [
                [
                    81.6043261,
                    53.5160636
                ],
                [
                    81.6152087,
                    53.5232178
                ],
                [
                    81.6203403,
                    53.5211664
                ],
                [
                    81.6395397,
                    53.5175894
                ],
                [
                    81.6321077,
                    53.5132754
                ],
                [
                    81.6334348,
                    53.5085928
                ],
                [
                    81.6280378,
                    53.507593
                ],
                [
                    81.6093692,
                    53.5094873
                ],
                [
                    81.6043261,
                    53.5160636
                ]
            ],
            "longitude": 81.6229817,
            "latitude": 53.5133383
        },
        "4661": {
            "name": "Троинка",
            "population": 183,
            "type": "village",
            "poly": null,
            "longitude": 81.6277986,
            "latitude": 51.505275
        },
        "4662": {
            "name": "Ермачиха",
            "population": 394,
            "type": "village",
            "poly": null,
            "longitude": 81.633485,
            "latitude": 53.0352483
        },
        "4663": {
            "name": "Суслово",
            "population": 681,
            "type": "village",
            "poly": [
                [
                    81.622765,
                    52.6100243
                ],
                [
                    81.6473126,
                    52.6214891
                ],
                [
                    81.6538358,
                    52.6197174
                ],
                [
                    81.6553807,
                    52.6203427
                ],
                [
                    81.6792416,
                    52.6162782
                ],
                [
                    81.6752934,
                    52.6113793
                ],
                [
                    81.6476559,
                    52.6104411
                ],
                [
                    81.655209,
                    52.6033525
                ],
                [
                    81.6454243,
                    52.598765
                ],
                [
                    81.6442227,
                    52.5912572
                ],
                [
                    81.6340947,
                    52.5892758
                ],
                [
                    81.622765,
                    52.6100243
                ]
            ],
            "longitude": 81.6398124,
            "latitude": 52.6101229
        },
        "4664": {
            "name": "Заводской",
            "population": 596,
            "type": "village",
            "poly": null,
            "longitude": 81.640499,
            "latitude": 53.3003261
        },
        "4665": {
            "name": "Саратовка",
            "population": 530,
            "type": "village",
            "poly": [
                [
                    81.6320726,
                    51.3820155
                ],
                [
                    81.6348646,
                    51.3870625
                ],
                [
                    81.636353,
                    51.390668
                ],
                [
                    81.6381448,
                    51.3923952
                ],
                [
                    81.6412452,
                    51.3932338
                ],
                [
                    81.6442037,
                    51.3935568
                ],
                [
                    81.6501205,
                    51.3917474
                ],
                [
                    81.6541169,
                    51.3896536
                ],
                [
                    81.6554582,
                    51.3879715
                ],
                [
                    81.658068,
                    51.3843425
                ],
                [
                    81.6534608,
                    51.3769025
                ],
                [
                    81.6408451,
                    51.3753795
                ],
                [
                    81.6364387,
                    51.3778071
                ],
                [
                    81.6320726,
                    51.3820155
                ]
            ],
            "longitude": 81.643456,
            "latitude": 51.381512
        },
        "4666": {
            "name": "Первомайский",
            "population": 666,
            "type": "village",
            "poly": null,
            "longitude": 81.658798,
            "latitude": 52.916584
        },
        "4667": {
            "name": "Верх-Аллак",
            "population": 483,
            "type": "village",
            "poly": null,
            "longitude": 81.6594357,
            "latitude": 53.8926576
        },
        "4668": {
            "name": "Поломошное",
            "population": 171,
            "type": "village",
            "poly": null,
            "longitude": 81.6626797,
            "latitude": 51.8137896
        },
        "4669": {
            "name": "Малые Бутырки",
            "population": 934,
            "type": "village",
            "poly": [
                [
                    81.6479993,
                    52.7244333
                ],
                [
                    81.6481709,
                    52.7281758
                ],
                [
                    81.6533208,
                    52.7290075
                ],
                [
                    81.6500592,
                    52.7325419
                ],
                [
                    81.6675687,
                    52.7428315
                ],
                [
                    81.6727185,
                    52.7413765
                ],
                [
                    81.6752934,
                    52.7433511
                ],
                [
                    81.6826749,
                    52.7400255
                ],
                [
                    81.6749501,
                    52.7330616
                ],
                [
                    81.6653371,
                    52.7242253
                ],
                [
                    81.6479993,
                    52.7244333
                ]
            ],
            "longitude": 81.664546,
            "latitude": 52.7288285
        },
        "4670": {
            "name": "Корчино",
            "population": 1055,
            "type": "village",
            "poly": [
                [
                    81.666325,
                    52.9844881
                ],
                [
                    81.6701958,
                    52.9916782
                ],
                [
                    81.6820296,
                    53.0019289
                ],
                [
                    81.6991719,
                    52.9963381
                ],
                [
                    81.6926467,
                    52.9897477
                ],
                [
                    81.69696,
                    52.9848876
                ],
                [
                    81.691762,
                    52.9827569
                ],
                [
                    81.6903242,
                    52.9808259
                ],
                [
                    81.6783799,
                    52.9776296
                ],
                [
                    81.6768316,
                    52.9800269
                ],
                [
                    81.666325,
                    52.9844881
                ]
            ],
            "longitude": 81.6825825,
            "latitude": 52.9892817
        },
        "4671": {
            "name": "Обское",
            "population": 296,
            "type": "village",
            "poly": null,
            "longitude": 81.6837499,
            "latitude": 53.6584453
        },
        "4672": {
            "name": "Дальний",
            "population": 842,
            "type": "village",
            "poly": [
                [
                    81.6776185,
                    51.4874537
                ],
                [
                    81.6855206,
                    51.4911014
                ],
                [
                    81.6991314,
                    51.4795287
                ],
                [
                    81.6941583,
                    51.4730076
                ],
                [
                    81.6857823,
                    51.4731163
                ],
                [
                    81.6821284,
                    51.4767182
                ],
                [
                    81.6814793,
                    51.4834603
                ],
                [
                    81.6796253,
                    51.4842889
                ],
                [
                    81.6776185,
                    51.4874537
                ]
            ],
            "longitude": 81.6868876,
            "latitude": 51.4792669
        },
        "4673": {
            "name": "Ермошиха",
            "population": 150,
            "type": "village",
            "poly": null,
            "longitude": 81.6921109,
            "latitude": 50.7819754
        },
        "4674": {
            "name": "Александровка",
            "population": 394,
            "type": "village",
            "poly": null,
            "longitude": 81.6958159,
            "latitude": 51.1352145
        },
        "4675": {
            "name": "Мезенцево",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 81.6961644,
            "latitude": 53.3579747
        },
        "4676": {
            "name": "Лобаниха",
            "population": 367,
            "type": "village",
            "poly": null,
            "longitude": 81.7011391,
            "latitude": 52.2291618
        },
        "4677": {
            "name": "Коробейниково",
            "population": 371,
            "type": "village",
            "poly": null,
            "longitude": 81.702759,
            "latitude": 52.413185
        },
        "4678": {
            "name": "Нововознесенка",
            "population": 90,
            "type": "village",
            "poly": null,
            "longitude": 81.7044689,
            "latitude": 51.5371066
        },
        "4679": {
            "name": "Подгорный",
            "population": 373,
            "type": "village",
            "poly": null,
            "longitude": 81.7060124,
            "latitude": 53.4958497
        },
        "4680": {
            "name": "Клепечиха",
            "population": 1445,
            "type": "village",
            "poly": [
                [
                    81.6617672,
                    52.1466389
                ],
                [
                    81.6907932,
                    52.157859
                ],
                [
                    81.70238,
                    52.1603286
                ],
                [
                    81.711404,
                    52.1641801
                ],
                [
                    81.7204768,
                    52.1672329
                ],
                [
                    81.7278149,
                    52.1659114
                ],
                [
                    81.7356156,
                    52.1720607
                ],
                [
                    81.7381243,
                    52.1719882
                ],
                [
                    81.7411317,
                    52.1666509
                ],
                [
                    81.7406814,
                    52.1639648
                ],
                [
                    81.7403387,
                    52.1589414
                ],
                [
                    81.7277735,
                    52.1535261
                ],
                [
                    81.7095425,
                    52.14748
                ],
                [
                    81.6675377,
                    52.1414473
                ],
                [
                    81.6617672,
                    52.1466389
                ]
            ],
            "longitude": 81.706398,
            "latitude": 52.154049
        },
        "4681": {
            "name": "Октябрьский",
            "population": 745,
            "type": "village",
            "poly": null,
            "longitude": 81.7113784,
            "latitude": 51.282503
        },
        "4682": {
            "name": "Вознесенский",
            "population": 144,
            "type": "village",
            "poly": null,
            "longitude": 81.7163925,
            "latitude": 53.2136192
        },
        "4683": {
            "name": "имени Мамонтова",
            "population": 1499,
            "type": "village",
            "poly": [
                [
                    81.701344,
                    51.9374795
                ],
                [
                    81.7068317,
                    51.942327
                ],
                [
                    81.7203873,
                    51.9469215
                ],
                [
                    81.7271855,
                    51.9441446
                ],
                [
                    81.7344342,
                    51.937328
                ],
                [
                    81.73468,
                    51.9339193
                ],
                [
                    81.7395944,
                    51.9292225
                ],
                [
                    81.7202644,
                    51.9205093
                ],
                [
                    81.7033916,
                    51.9326567
                ],
                [
                    81.701344,
                    51.9374795
                ]
            ],
            "longitude": 81.7189229,
            "latitude": 51.9290359
        },
        "4684": {
            "name": "Островное",
            "population": 1159,
            "type": "village",
            "poly": [
                [
                    81.6903996,
                    52.6743967
                ],
                [
                    81.7037892,
                    52.6842837
                ],
                [
                    81.7022443,
                    52.6857405
                ],
                [
                    81.7353749,
                    52.7049872
                ],
                [
                    81.7336583,
                    52.7070674
                ],
                [
                    81.7492795,
                    52.7138274
                ],
                [
                    81.7477345,
                    52.7156992
                ],
                [
                    81.7544293,
                    52.7181948
                ],
                [
                    81.7564893,
                    52.717363
                ],
                [
                    81.7624974,
                    52.7188187
                ],
                [
                    81.7619823,
                    52.7200664
                ],
                [
                    81.7666172,
                    52.721834
                ],
                [
                    81.7796635,
                    52.7167391
                ],
                [
                    81.7649007,
                    52.7071714
                ],
                [
                    81.7396664,
                    52.6983298
                ],
                [
                    81.7396664,
                    52.6966653
                ],
                [
                    81.7264485,
                    52.6871973
                ],
                [
                    81.7285085,
                    52.6837633
                ],
                [
                    81.6986394,
                    52.670233
                ],
                [
                    81.6903996,
                    52.6743967
                ]
            ],
            "longitude": 81.7190696,
            "latitude": 52.6866439
        },
        "4685": {
            "name": "Хлебороб",
            "population": 787,
            "type": "village",
            "poly": null,
            "longitude": 81.7225897,
            "latitude": 52.0058684
        },
        "4686": {
            "name": "Маханово",
            "population": 83,
            "type": "village",
            "poly": null,
            "longitude": 81.7269298,
            "latitude": 51.8081214
        },
        "4687": {
            "name": "Андреевка",
            "population": 304,
            "type": "village",
            "poly": null,
            "longitude": 81.7360282,
            "latitude": 52.4313749
        },
        "4688": {
            "name": "Крутой Яр",
            "population": 349,
            "type": "village",
            "poly": [
                [
                    81.7267704,
                    51.9148106
                ],
                [
                    81.7270104,
                    51.9170801
                ],
                [
                    81.7430077,
                    51.9278341
                ],
                [
                    81.753886,
                    51.9241839
                ],
                [
                    81.7531661,
                    51.9168828
                ],
                [
                    81.7406881,
                    51.9138238
                ],
                [
                    81.7267704,
                    51.9148106
                ]
            ],
            "longitude": 81.7402546,
            "latitude": 51.9177325
        },
        "4689": {
            "name": "Большевик",
            "population": 126,
            "type": "village",
            "poly": null,
            "longitude": 81.7416824,
            "latitude": 51.8438902
        },
        "4690": {
            "name": "Шарчино",
            "population": 1811,
            "type": "village",
            "poly": [
                [
                    81.7241365,
                    53.1377894
                ],
                [
                    81.7262102,
                    53.1462477
                ],
                [
                    81.7412788,
                    53.1494813
                ],
                [
                    81.743076,
                    53.1552846
                ],
                [
                    81.7472233,
                    53.1542898
                ],
                [
                    81.7632597,
                    53.1569425
                ],
                [
                    81.7710014,
                    53.1448382
                ],
                [
                    81.7513707,
                    53.1374578
                ],
                [
                    81.7427995,
                    53.1334769
                ],
                [
                    81.7358873,
                    53.131652
                ],
                [
                    81.7241365,
                    53.1377894
                ]
            ],
            "longitude": 81.7462556,
            "latitude": 53.1426822
        },
        "4691": {
            "name": "Вторая Каменка",
            "population": 707,
            "type": "village",
            "poly": null,
            "longitude": 81.7533824,
            "latitude": 51.0506382
        },
        "4692": {
            "name": "Урывки",
            "population": 339,
            "type": "village",
            "poly": null,
            "longitude": 81.7680631,
            "latitude": 53.0411409
        },
        "4693": {
            "name": "Масальский",
            "population": 1669,
            "type": "village",
            "poly": null,
            "longitude": 81.7961438,
            "latitude": 50.9572081
        },
        "4694": {
            "name": "Крючки",
            "population": 207,
            "type": "village",
            "poly": null,
            "longitude": 81.7989755,
            "latitude": 50.8483243
        },
        "4695": {
            "name": "Буканское",
            "population": 1003,
            "type": "village",
            "poly": null,
            "longitude": 81.7998955,
            "latitude": 52.7977829
        },
        "4696": {
            "name": "Гилёво",
            "population": 935,
            "type": "village",
            "poly": null,
            "longitude": 81.8036723,
            "latitude": 51.1264001
        },
        "4697": {
            "name": "Берёзовка",
            "population": 813,
            "type": "village",
            "poly": null,
            "longitude": 81.811844,
            "latitude": 53.242908
        },
        "4698": {
            "name": "12 лет Октября",
            "population": 975,
            "type": "village",
            "poly": null,
            "longitude": 81.8239722,
            "latitude": 51.7180673
        },
        "4699": {
            "name": "Крутишка",
            "population": 1325,
            "type": "village",
            "poly": [
                [
                    81.8146794,
                    53.4566702
                ],
                [
                    81.8203441,
                    53.4619849
                ],
                [
                    81.8179409,
                    53.464642
                ],
                [
                    81.8351071,
                    53.474758
                ],
                [
                    81.8395703,
                    53.4745536
                ],
                [
                    81.848325,
                    53.4696492
                ],
                [
                    81.8431751,
                    53.4662771
                ],
                [
                    81.8476383,
                    53.4635179
                ],
                [
                    81.8440335,
                    53.4583056
                ],
                [
                    81.826009,
                    53.4504347
                ],
                [
                    81.8146794,
                    53.4566702
                ]
            ],
            "longitude": 81.8303487,
            "latitude": 53.4630871
        },
        "4700": {
            "name": "Зеркалы",
            "population": 830,
            "type": "village",
            "poly": null,
            "longitude": 81.8356823,
            "latitude": 52.4847683
        },
        "4701": {
            "name": "Сосновка",
            "population": 412,
            "type": "village",
            "poly": null,
            "longitude": 81.8497086,
            "latitude": 53.2509358
        },
        "4702": {
            "name": "Котляровка",
            "population": 553,
            "type": "village",
            "poly": null,
            "longitude": 81.8506574,
            "latitude": 52.1114429
        },
        "4703": {
            "name": "Поспелихинский",
            "population": 1211,
            "type": "village",
            "poly": null,
            "longitude": 81.8535884,
            "latitude": 51.8732192
        },
        "4704": {
            "name": "Баталово",
            "population": 554,
            "type": "village",
            "poly": null,
            "longitude": 81.8697167,
            "latitude": 52.2137362
        },
        "4705": {
            "name": "Покровка",
            "population": 990,
            "type": "village",
            "poly": [
                [
                    81.8507314,
                    52.7676619
                ],
                [
                    81.850903,
                    52.7704661
                ],
                [
                    81.8624043,
                    52.7732702
                ],
                [
                    81.8713307,
                    52.7788777
                ],
                [
                    81.8756223,
                    52.77867
                ],
                [
                    81.8785405,
                    52.7796046
                ],
                [
                    81.8780255,
                    52.7818889
                ],
                [
                    81.8874669,
                    52.7872877
                ],
                [
                    81.8948483,
                    52.7856266
                ],
                [
                    81.8902135,
                    52.7802276
                ],
                [
                    81.8926167,
                    52.7779432
                ],
                [
                    81.872189,
                    52.7663117
                ],
                [
                    81.863091,
                    52.7651691
                ],
                [
                    81.8507314,
                    52.7676619
                ]
            ],
            "longitude": 81.8706766,
            "latitude": 52.7718513
        },
        "4706": {
            "name": "Чайкино",
            "population": 332,
            "type": "village",
            "poly": [
                [
                    81.8648045,
                    53.4974334
                ],
                [
                    81.8778507,
                    53.5040703
                ],
                [
                    81.8862622,
                    53.5019262
                ],
                [
                    81.8900387,
                    53.4989651
                ],
                [
                    81.8883221,
                    53.4960037
                ],
                [
                    81.8828289,
                    53.4994755
                ],
                [
                    81.8781941,
                    53.4998841
                ],
                [
                    81.8745892,
                    53.4986588
                ],
                [
                    81.871156,
                    53.4969228
                ],
                [
                    81.868066,
                    53.4955953
                ],
                [
                    81.8648045,
                    53.4974334
                ]
            ],
            "longitude": 81.8759625,
            "latitude": 53.500803
        },
        "4707": {
            "name": "Травное",
            "population": 403,
            "type": "village",
            "poly": [
                [
                    81.8448949,
                    52.5757162
                ],
                [
                    81.8495297,
                    52.5788457
                ],
                [
                    81.8471265,
                    52.5827051
                ],
                [
                    81.8814587,
                    52.5948027
                ],
                [
                    81.8826604,
                    52.5928214
                ],
                [
                    81.89296,
                    52.5953241
                ],
                [
                    81.8974232,
                    52.5910486
                ],
                [
                    81.8816332,
                    52.582475
                ],
                [
                    81.8511814,
                    52.5732535
                ],
                [
                    81.8448949,
                    52.5757162
                ]
            ],
            "longitude": 81.876678,
            "latitude": 52.586426
        },
        "4708": {
            "name": "Степной",
            "population": 299,
            "type": "village",
            "poly": null,
            "longitude": 81.8887044,
            "latitude": 50.9727843
        },
        "4709": {
            "name": "Факел Социализма",
            "population": 619,
            "type": "village",
            "poly": [
                [
                    81.8790324,
                    51.99244
                ],
                [
                    81.8793758,
                    51.9961393
                ],
                [
                    81.8841823,
                    51.9988874
                ],
                [
                    81.8895038,
                    52.0012125
                ],
                [
                    81.8961986,
                    52.0017409
                ],
                [
                    81.9064983,
                    52.0017409
                ],
                [
                    81.9101032,
                    51.9989931
                ],
                [
                    81.9085582,
                    51.9966679
                ],
                [
                    81.9039234,
                    51.9960337
                ],
                [
                    81.9016918,
                    51.9939198
                ],
                [
                    81.8975719,
                    51.9925457
                ],
                [
                    81.8925937,
                    51.9927571
                ],
                [
                    81.8891605,
                    51.9933913
                ],
                [
                    81.8855556,
                    51.9914885
                ],
                [
                    81.8810924,
                    51.9897973
                ],
                [
                    81.8790324,
                    51.99244
                ]
            ],
            "longitude": 81.8917648,
            "latitude": 51.9969607
        },
        "4710": {
            "name": "Третьяково",
            "population": 1074,
            "type": "village",
            "poly": null,
            "longitude": 81.89695,
            "latitude": 50.867939
        },
        "4711": {
            "name": "Куликово",
            "population": 291,
            "type": "village",
            "poly": [
                [
                    81.8728789,
                    53.1954427
                ],
                [
                    81.8761278,
                    53.1960606
                ],
                [
                    81.8770045,
                    53.1966012
                ],
                [
                    81.8769529,
                    53.1970801
                ],
                [
                    81.8811817,
                    53.1986247
                ],
                [
                    81.8798151,
                    53.2005555
                ],
                [
                    81.881981,
                    53.2029649
                ],
                [
                    81.8833992,
                    53.2031348
                ],
                [
                    81.8866481,
                    53.2045711
                ],
                [
                    81.8873185,
                    53.2055286
                ],
                [
                    81.8889687,
                    53.2066715
                ],
                [
                    81.8907737,
                    53.2075363
                ],
                [
                    81.8929654,
                    53.2082003
                ],
                [
                    81.8950282,
                    53.2083548
                ],
                [
                    81.8949766,
                    53.2072429
                ],
                [
                    81.8995663,
                    53.2068413
                ],
                [
                    81.8992311,
                    53.2077216
                ],
                [
                    81.9053679,
                    53.2096365
                ],
                [
                    81.9099061,
                    53.2101615
                ],
                [
                    81.9128971,
                    53.2090342
                ],
                [
                    81.9160171,
                    53.2071193
                ],
                [
                    81.9146504,
                    53.2065016
                ],
                [
                    81.916146,
                    53.2052352
                ],
                [
                    81.909674,
                    53.202795
                ],
                [
                    81.9030731,
                    53.2010343
                ],
                [
                    81.9077917,
                    53.1958597
                ],
                [
                    81.9094162,
                    53.196215
                ],
                [
                    81.9107828,
                    53.1942995
                ],
                [
                    81.9092098,
                    53.1934345
                ],
                [
                    81.9093388,
                    53.1926311
                ],
                [
                    81.9062445,
                    53.1927393
                ],
                [
                    81.9050327,
                    53.1928782
                ],
                [
                    81.9039755,
                    53.1946548
                ],
                [
                    81.9035888,
                    53.1947939
                ],
                [
                    81.9017322,
                    53.1932491
                ],
                [
                    81.898406,
                    53.191318
                ],
                [
                    81.8981997,
                    53.191766
                ],
                [
                    81.8984576,
                    53.192523
                ],
                [
                    81.894925,
                    53.1922913
                ],
                [
                    81.8939452,
                    53.1932953
                ],
                [
                    81.8910831,
                    53.1930946
                ],
                [
                    81.8902064,
                    53.194006
                ],
                [
                    81.8871122,
                    53.1949483
                ],
                [
                    81.8847916,
                    53.1945313
                ],
                [
                    81.8844048,
                    53.1940678
                ],
                [
                    81.8851268,
                    53.1935889
                ],
                [
                    81.8838633,
                    53.1932645
                ],
                [
                    81.8826514,
                    53.1921368
                ],
                [
                    81.8807691,
                    53.1915652
                ],
                [
                    81.8788868,
                    53.1918433
                ],
                [
                    81.8774686,
                    53.1921522
                ],
                [
                    81.87587,
                    53.1928629
                ],
                [
                    81.8755089,
                    53.1938824
                ],
                [
                    81.8739619,
                    53.1946239
                ],
                [
                    81.8740392,
                    53.1949947
                ],
                [
                    81.8731368,
                    53.1951337
                ],
                [
                    81.8728789,
                    53.1954427
                ]
            ],
            "longitude": 81.8970726,
            "latitude": 53.2014546
        },
        "4712": {
            "name": "Никольск",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 81.9095449,
            "latitude": 51.3592308
        },
        "4713": {
            "name": "Таловка",
            "population": 814,
            "type": "village",
            "poly": null,
            "longitude": 81.9130063,
            "latitude": 51.4466851
        },
        "4714": {
            "name": "Вавилонский",
            "population": 414,
            "type": "village",
            "poly": [
                [
                    81.8975088,
                    51.9579722
                ],
                [
                    81.9126342,
                    51.9666611
                ],
                [
                    81.919803,
                    51.9687967
                ],
                [
                    81.9290988,
                    51.9642828
                ],
                [
                    81.9138159,
                    51.9532145
                ],
                [
                    81.8975088,
                    51.9579722
                ]
            ],
            "longitude": 81.913322,
            "latitude": 51.959633
        },
        "4715": {
            "name": "Кадниково",
            "population": 747,
            "type": "village",
            "poly": null,
            "longitude": 81.9189895,
            "latitude": 52.8648055
        },
        "4716": {
            "name": "Садовый",
            "population": 1044,
            "type": "village",
            "poly": null,
            "longitude": 81.9212601,
            "latitude": 50.9837412
        },
        "4717": {
            "name": "Первомайский",
            "population": 795,
            "type": "village",
            "poly": null,
            "longitude": 81.9217251,
            "latitude": 50.8771351
        },
        "4718": {
            "name": "Порожнее",
            "population": 849,
            "type": "village",
            "poly": null,
            "longitude": 81.9263305,
            "latitude": 52.2699041
        },
        "4719": {
            "name": "Быково",
            "population": 120,
            "type": "village",
            "poly": [
                [
                    81.9192211,
                    53.5324441
                ],
                [
                    81.9274609,
                    53.5390755
                ],
                [
                    81.9365589,
                    53.5400957
                ],
                [
                    81.9357006,
                    53.531832
                ],
                [
                    81.9264309,
                    53.5269342
                ],
                [
                    81.9192211,
                    53.5324441
                ]
            ],
            "longitude": 81.9286625,
            "latitude": 53.5342806
        },
        "4720": {
            "name": "Шумилиха",
            "population": 698,
            "type": "village",
            "poly": [
                [
                    81.9366924,
                    53.1251781
                ],
                [
                    81.9377515,
                    53.1257802
                ],
                [
                    81.9385318,
                    53.1311648
                ],
                [
                    81.9403155,
                    53.1319675
                ],
                [
                    81.9448862,
                    53.1337064
                ],
                [
                    81.9466698,
                    53.1338737
                ],
                [
                    81.9488437,
                    53.1326698
                ],
                [
                    81.9484535,
                    53.130496
                ],
                [
                    81.9505716,
                    53.1276196
                ],
                [
                    81.9512405,
                    53.1256798
                ],
                [
                    81.9487879,
                    53.1254457
                ],
                [
                    81.951352,
                    53.1211977
                ],
                [
                    81.9558669,
                    53.1165477
                ],
                [
                    81.9516864,
                    53.1138713
                ],
                [
                    81.9510175,
                    53.1097224
                ],
                [
                    81.9473387,
                    53.1096221
                ],
                [
                    81.9465026,
                    53.1109938
                ],
                [
                    81.9466141,
                    53.1139048
                ],
                [
                    81.9403712,
                    53.1155106
                ],
                [
                    81.937417,
                    53.1194581
                ],
                [
                    81.9368596,
                    53.1207962
                ],
                [
                    81.9378629,
                    53.1210304
                ],
                [
                    81.9366924,
                    53.1251781
                ]
            ],
            "longitude": 81.943306,
            "latitude": 53.12096
        },
        "4721": {
            "name": "Юдиха",
            "population": 482,
            "type": "village",
            "poly": [
                [
                    81.9260876,
                    53.4317231
                ],
                [
                    81.9332974,
                    53.4401086
                ],
                [
                    81.9453137,
                    53.4365296
                ],
                [
                    81.956815,
                    53.4365296
                ],
                [
                    81.9604199,
                    53.4267114
                ],
                [
                    81.9645397,
                    53.423029
                ],
                [
                    81.954755,
                    53.4167887
                ],
                [
                    81.9463436,
                    53.4221084
                ],
                [
                    81.9425671,
                    53.4210854
                ],
                [
                    81.9367306,
                    53.424768
                ],
                [
                    81.9374172,
                    53.4286547
                ],
                [
                    81.9423954,
                    53.4311093
                ],
                [
                    81.9418804,
                    53.4327458
                ],
                [
                    81.9310658,
                    53.4287571
                ],
                [
                    81.9260876,
                    53.4317231
                ]
            ],
            "longitude": 81.9446752,
            "latitude": 53.4322124
        },
        "4722": {
            "name": "Кузьминка",
            "population": 644,
            "type": "village",
            "poly": null,
            "longitude": 81.9496398,
            "latitude": 51.3101102
        },
        "4723": {
            "name": "Михайловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 81.962182,
            "latitude": 50.8158838
        },
        "4724": {
            "name": "Корболиха",
            "population": 1648,
            "type": "village",
            "poly": null,
            "longitude": 81.964317,
            "latitude": 51.101025
        },
        "4725": {
            "name": "Макарово",
            "population": 427,
            "type": "village",
            "poly": null,
            "longitude": 81.997636,
            "latitude": 53.2936144
        },
        "4726": {
            "name": "Родино",
            "population": 1530,
            "type": "village",
            "poly": null,
            "longitude": 81.9988797,
            "latitude": 52.3760139
        },
        "4727": {
            "name": "Староалейское",
            "population": 4769,
            "type": "village",
            "poly": null,
            "longitude": 81.999641,
            "latitude": 51.006229
        },
        "4728": {
            "name": "Новоивановка",
            "population": 562,
            "type": "village",
            "poly": null,
            "longitude": 82.0040907,
            "latitude": 52.3202251
        },
        "4729": {
            "name": "Урлапово",
            "population": 840,
            "type": "village",
            "poly": [
                [
                    81.9845832,
                    52.5632875
                ],
                [
                    82.0026632,
                    52.569228
                ],
                [
                    82.0261623,
                    52.5797887
                ],
                [
                    82.0275426,
                    52.5795759
                ],
                [
                    82.0330357,
                    52.576968
                ],
                [
                    82.0055699,
                    52.5636133
                ],
                [
                    82.0105481,
                    52.5601696
                ],
                [
                    82.0005917,
                    52.5584999
                ],
                [
                    81.9987035,
                    52.5611088
                ],
                [
                    81.9944119,
                    52.5594391
                ],
                [
                    81.9882321,
                    52.560587
                ],
                [
                    81.9845832,
                    52.5632875
                ]
            ],
            "longitude": 82.0053968,
            "latitude": 52.568065
        },
        "4730": {
            "name": "Кузнецово",
            "population": 523,
            "type": "village",
            "poly": null,
            "longitude": 82.0154199,
            "latitude": 51.6795806
        },
        "4731": {
            "name": "Екатерининское",
            "population": 1233,
            "type": "village",
            "poly": null,
            "longitude": 82.015732,
            "latitude": 50.909134
        },
        "4732": {
            "name": "Усть-Мосиха",
            "population": 1075,
            "type": "village",
            "poly": [
                [
                    81.9969664,
                    53.2442626
                ],
                [
                    82.001799,
                    53.2506344
                ],
                [
                    82.0065033,
                    53.2548051
                ],
                [
                    82.0119609,
                    53.2591697
                ],
                [
                    82.0230112,
                    53.2626591
                ],
                [
                    82.0340878,
                    53.2651659
                ],
                [
                    82.043753,
                    53.2673401
                ],
                [
                    82.0456775,
                    53.2652938
                ],
                [
                    82.0438813,
                    53.263759
                ],
                [
                    82.0401179,
                    53.2633497
                ],
                [
                    82.0343016,
                    53.258873
                ],
                [
                    82.0381078,
                    53.2571589
                ],
                [
                    82.0490133,
                    53.2508647
                ],
                [
                    82.045036,
                    53.2475638
                ],
                [
                    82.0360978,
                    53.2509927
                ],
                [
                    82.033489,
                    53.2493806
                ],
                [
                    82.0375946,
                    53.2433413
                ],
                [
                    82.0430688,
                    53.2402701
                ],
                [
                    82.0433681,
                    53.2373778
                ],
                [
                    82.0419568,
                    53.23597
                ],
                [
                    82.0354991,
                    53.2347158
                ],
                [
                    82.028913,
                    53.2345366
                ],
                [
                    82.0254062,
                    53.2330263
                ],
                [
                    82.021771,
                    53.2344086
                ],
                [
                    82.0213433,
                    53.2369683
                ],
                [
                    82.017366,
                    53.2422152
                ],
                [
                    82.0156554,
                    53.2431109
                ],
                [
                    82.0080002,
                    53.2442882
                ],
                [
                    81.9969664,
                    53.2442626
                ]
            ],
            "longitude": 82.017128,
            "latitude": 53.251949
        },
        "4733": {
            "name": "Хлопуново",
            "population": 1171,
            "type": "village",
            "poly": null,
            "longitude": 82.0266789,
            "latitude": 52.0717768
        },
        "4734": {
            "name": "Ивановка",
            "population": 796,
            "type": "village",
            "poly": null,
            "longitude": 82.027911,
            "latitude": 51.5741767
        },
        "4735": {
            "name": "Костин Лог",
            "population": 1209,
            "type": "village",
            "poly": [
                [
                    82.0078015,
                    52.6528456
                ],
                [
                    82.0131229,
                    52.6574274
                ],
                [
                    82.0139813,
                    52.6633622
                ],
                [
                    82.0234227,
                    52.6652362
                ],
                [
                    82.0199895,
                    52.6721067
                ],
                [
                    82.0222211,
                    52.6772069
                ],
                [
                    82.0299457,
                    52.6827227
                ],
                [
                    82.0323491,
                    52.6826187
                ],
                [
                    82.0416188,
                    52.6807454
                ],
                [
                    82.0532918,
                    52.6859487
                ],
                [
                    82.0630764,
                    52.6794966
                ],
                [
                    82.0548367,
                    52.6754375
                ],
                [
                    82.0613599,
                    52.6708576
                ],
                [
                    82.0102744,
                    52.6485744
                ],
                [
                    82.0078015,
                    52.6528456
                ]
            ],
            "longitude": 82.029297,
            "latitude": 52.662003
        },
        "4736": {
            "name": "Новогальцовка",
            "population": 124,
            "type": "village",
            "poly": null,
            "longitude": 82.0409438,
            "latitude": 50.9740719
        },
        "4737": {
            "name": "Георгиевка",
            "population": 522,
            "type": "village",
            "poly": [
                [
                    82.0166284,
                    52.8451203
                ],
                [
                    82.0209773,
                    52.84631
                ],
                [
                    82.0203889,
                    52.847546
                ],
                [
                    82.0212331,
                    52.8479786
                ],
                [
                    82.0223587,
                    52.8477314
                ],
                [
                    82.022947,
                    52.8483339
                ],
                [
                    82.0248657,
                    52.8496162
                ],
                [
                    82.0293425,
                    52.8513156
                ],
                [
                    82.0419542,
                    52.8575098
                ],
                [
                    82.0455868,
                    52.8589619
                ],
                [
                    82.0492962,
                    52.8643212
                ],
                [
                    82.0511125,
                    52.866406
                ],
                [
                    82.054924,
                    52.8683055
                ],
                [
                    82.058659,
                    52.8685526
                ],
                [
                    82.0628289,
                    52.8684907
                ],
                [
                    82.0633661,
                    52.8679658
                ],
                [
                    82.065208,
                    52.868429
                ],
                [
                    82.0657707,
                    52.8693401
                ],
                [
                    82.0673824,
                    52.8704828
                ],
                [
                    82.0688404,
                    52.8698806
                ],
                [
                    82.0658475,
                    52.8669157
                ],
                [
                    82.0643382,
                    52.8623289
                ],
                [
                    82.0652847,
                    52.8614176
                ],
                [
                    82.0641591,
                    52.8605836
                ],
                [
                    82.0642358,
                    52.8601203
                ],
                [
                    82.0615754,
                    52.8592399
                ],
                [
                    82.0636986,
                    52.8562123
                ],
                [
                    82.0609614,
                    52.8553165
                ],
                [
                    82.0582497,
                    52.8544052
                ],
                [
                    82.0562544,
                    52.8540344
                ],
                [
                    82.0571241,
                    52.8530457
                ],
                [
                    82.054837,
                    52.8525589
                ],
                [
                    82.0546132,
                    52.8534508
                ],
                [
                    82.0534986,
                    52.855164
                ],
                [
                    82.0517761,
                    52.8564488
                ],
                [
                    82.0523635,
                    52.857296
                ],
                [
                    82.0487708,
                    52.8563181
                ],
                [
                    82.0498478,
                    52.8552524
                ],
                [
                    82.050652,
                    52.8539108
                ],
                [
                    82.0501148,
                    52.8534783
                ],
                [
                    82.0514962,
                    52.8525514
                ],
                [
                    82.0520334,
                    52.8517172
                ],
                [
                    82.0501659,
                    52.8483957
                ],
                [
                    82.0487845,
                    52.8475306
                ],
                [
                    82.0467892,
                    52.8485657
                ],
                [
                    82.0457403,
                    52.8482411
                ],
                [
                    82.0448705,
                    52.848921
                ],
                [
                    82.0452798,
                    52.8493381
                ],
                [
                    82.043617,
                    52.8505895
                ],
                [
                    82.042824,
                    52.8504505
                ],
                [
                    82.0376821,
                    52.8477623
                ],
                [
                    82.0346379,
                    52.8468508
                ],
                [
                    82.0327192,
                    52.8469744
                ],
                [
                    82.0322843,
                    52.847546
                ],
                [
                    82.0301867,
                    52.8472988
                ],
                [
                    82.0260424,
                    52.8455375
                ],
                [
                    82.0257099,
                    52.843807
                ],
                [
                    82.022768,
                    52.8430808
                ],
                [
                    82.0196726,
                    52.8416593
                ],
                [
                    82.0166284,
                    52.8451203
                ]
            ],
            "longitude": 82.050636,
            "latitude": 52.860229
        },
        "4738": {
            "name": "Николаевка",
            "population": 1610,
            "type": "village",
            "poly": [
                [
                    82.0445088,
                    51.8751856
                ],
                [
                    82.0526635,
                    51.8886724
                ],
                [
                    82.0715887,
                    51.8954143
                ],
                [
                    82.0820514,
                    51.8936102
                ],
                [
                    82.0840516,
                    51.8807898
                ],
                [
                    82.058818,
                    51.8591292
                ],
                [
                    82.0482015,
                    51.8615998
                ],
                [
                    82.0445088,
                    51.8751856
                ]
            ],
            "longitude": 82.0623647,
            "latitude": 51.8783542
        },
        "4739": {
            "name": "Киприно",
            "population": 1388,
            "type": "village",
            "poly": [
                [
                    82.053117,
                    53.5247912
                ],
                [
                    82.0536744,
                    53.5254406
                ],
                [
                    82.0574084,
                    53.5297913
                ],
                [
                    82.0750897,
                    53.5376473
                ],
                [
                    82.0876209,
                    53.5347908
                ],
                [
                    82.0709698,
                    53.5185658
                ],
                [
                    82.0572369,
                    53.5219338
                ],
                [
                    82.0570652,
                    53.5230563
                ],
                [
                    82.053117,
                    53.5247912
                ]
            ],
            "longitude": 82.0709698,
            "latitude": 53.528975
        },
        "4740": {
            "name": "Подстепное",
            "population": 871,
            "type": "village",
            "poly": null,
            "longitude": 82.0793586,
            "latitude": 52.9652233
        },
        "4741": {
            "name": "Карамышево",
            "population": 1126,
            "type": "village",
            "poly": null,
            "longitude": 82.0852951,
            "latitude": 51.1720333
        },
        "4742": {
            "name": "Лопатинка",
            "population": 130,
            "type": "village",
            "poly": null,
            "longitude": 82.1020604,
            "latitude": 50.9164323
        },
        "4743": {
            "name": "Сакмарино",
            "population": 0,
            "type": "village",
            "poly": [
                [
                    82.1118393,
                    53.5322848
                ],
                [
                    82.1119969,
                    53.5344847
                ],
                [
                    82.1178334,
                    53.536015
                ],
                [
                    82.1197216,
                    53.5342806
                ],
                [
                    82.1160919,
                    53.5333616
                ],
                [
                    82.1118393,
                    53.5322848
                ]
            ],
            "longitude": 82.1147434,
            "latitude": 53.5341786
        },
        "4744": {
            "name": "Новокамышенка",
            "population": 339,
            "type": "village",
            "poly": null,
            "longitude": 82.12328,
            "latitude": 50.9339887
        },
        "4745": {
            "name": "Горьковское",
            "population": 1279,
            "type": "village",
            "poly": null,
            "longitude": 82.133429,
            "latitude": 52.0773475
        },
        "4746": {
            "name": "Молодёжный",
            "population": 420,
            "type": "village",
            "poly": [
                [
                    82.1246213,
                    52.9978766
                ],
                [
                    82.1246576,
                    52.9992534
                ],
                [
                    82.1250933,
                    52.9996467
                ],
                [
                    82.1273627,
                    53.000488
                ],
                [
                    82.1271086,
                    53.0012856
                ],
                [
                    82.1317926,
                    53.0014167
                ],
                [
                    82.1376023,
                    53.002116
                ],
                [
                    82.1438659,
                    53.0023782
                ],
                [
                    82.144229,
                    53.0015588
                ],
                [
                    82.1434845,
                    53.0010015
                ],
                [
                    82.1435027,
                    53.0005536
                ],
                [
                    82.1420141,
                    52.9998871
                ],
                [
                    82.1421955,
                    52.9990239
                ],
                [
                    82.140489,
                    52.998412
                ],
                [
                    82.1403438,
                    52.9977674
                ],
                [
                    82.1414694,
                    52.9965108
                ],
                [
                    82.1425224,
                    52.9958879
                ],
                [
                    82.1308122,
                    52.9947078
                ],
                [
                    82.1275806,
                    52.9980187
                ],
                [
                    82.125638,
                    52.9974942
                ],
                [
                    82.1246213,
                    52.9978766
                ]
            ],
            "longitude": 82.1366103,
            "latitude": 52.9986763
        },
        "4747": {
            "name": "Бобровка",
            "population": 942,
            "type": "village",
            "poly": null,
            "longitude": 82.1380849,
            "latitude": 52.4153432
        },
        "4748": {
            "name": "Гавриловский",
            "population": 463,
            "type": "village",
            "poly": null,
            "longitude": 82.1461567,
            "latitude": 51.9704392
        },
        "4749": {
            "name": "Саввушка",
            "population": 1172,
            "type": "village",
            "poly": [
                [
                    82.1344622,
                    51.3477121
                ],
                [
                    82.1348654,
                    51.349686
                ],
                [
                    82.1346703,
                    51.3539178
                ],
                [
                    82.1352946,
                    51.3552741
                ],
                [
                    82.1360359,
                    51.3591156
                ],
                [
                    82.1354636,
                    51.3614869
                ],
                [
                    82.1385459,
                    51.3619173
                ],
                [
                    82.1392352,
                    51.3622015
                ],
                [
                    82.1394563,
                    51.3659369
                ],
                [
                    82.1400806,
                    51.3664809
                ],
                [
                    82.1399245,
                    51.3678044
                ],
                [
                    82.1397293,
                    51.3680724
                ],
                [
                    82.138728,
                    51.3682104
                ],
                [
                    82.138767,
                    51.3690223
                ],
                [
                    82.1437221,
                    51.3694202
                ],
                [
                    82.1437872,
                    51.3705325
                ],
                [
                    82.1459201,
                    51.3705406
                ],
                [
                    82.145686,
                    51.3683322
                ],
                [
                    82.1492235,
                    51.367983
                ],
                [
                    82.1507971,
                    51.3678937
                ],
                [
                    82.1548289,
                    51.3679018
                ],
                [
                    82.1564415,
                    51.3710602
                ],
                [
                    82.162164,
                    51.366359
                ],
                [
                    82.16022,
                    51.3628774
                ],
                [
                    82.1591439,
                    51.3609582
                ],
                [
                    82.1579826,
                    51.3589158
                ],
                [
                    82.1568639,
                    51.35685
                ],
                [
                    82.1555268,
                    51.3545114
                ],
                [
                    82.1539765,
                    51.3516836
                ],
                [
                    82.1532894,
                    51.3515971
                ],
                [
                    82.1534279,
                    51.3514507
                ],
                [
                    82.153348,
                    51.3511379
                ],
                [
                    82.152778,
                    51.3505857
                ],
                [
                    82.152565,
                    51.349684
                ],
                [
                    82.1522027,
                    51.3489853
                ],
                [
                    82.1511213,
                    51.3482966
                ],
                [
                    82.1512279,
                    51.3463402
                ],
                [
                    82.1503223,
                    51.3460241
                ],
                [
                    82.150205,
                    51.3454285
                ],
                [
                    82.1500643,
                    51.3452922
                ],
                [
                    82.1501456,
                    51.3440864
                ],
                [
                    82.1503081,
                    51.3439849
                ],
                [
                    82.1503488,
                    51.343642
                ],
                [
                    82.1501049,
                    51.3429567
                ],
                [
                    82.1479102,
                    51.3425251
                ],
                [
                    82.1444353,
                    51.3387422
                ],
                [
                    82.1424235,
                    51.3367744
                ],
                [
                    82.140629,
                    51.3378396
                ],
                [
                    82.1428219,
                    51.3405282
                ],
                [
                    82.1422135,
                    51.3408313
                ],
                [
                    82.1416803,
                    51.3408882
                ],
                [
                    82.1414852,
                    51.3411238
                ],
                [
                    82.1414202,
                    51.3415381
                ],
                [
                    82.1416543,
                    51.3420093
                ],
                [
                    82.1416933,
                    51.3422124
                ],
                [
                    82.1418754,
                    51.3423668
                ],
                [
                    82.1424216,
                    51.3423262
                ],
                [
                    82.1424346,
                    51.3424805
                ],
                [
                    82.141368,
                    51.3426105
                ],
                [
                    82.1413941,
                    51.3432929
                ],
                [
                    82.1412511,
                    51.3434066
                ],
                [
                    82.1406138,
                    51.3435204
                ],
                [
                    82.1400546,
                    51.3434229
                ],
                [
                    82.1372324,
                    51.3433903
                ],
                [
                    82.1372064,
                    51.3447227
                ],
                [
                    82.1372454,
                    51.345202
                ],
                [
                    82.1369723,
                    51.3459737
                ],
                [
                    82.1375705,
                    51.3463799
                ],
                [
                    82.1376486,
                    51.3470298
                ],
                [
                    82.1367382,
                    51.3479802
                ],
                [
                    82.1367382,
                    51.3480227
                ],
                [
                    82.1356235,
                    51.3481996
                ],
                [
                    82.1356197,
                    51.3481995
                ],
                [
                    82.1353986,
                    51.3476228
                ],
                [
                    82.1344622,
                    51.3477121
                ]
            ],
            "longitude": 82.146446,
            "latitude": 51.352718
        },
        "4750": {
            "name": "Плоское",
            "population": 894,
            "type": "village",
            "poly": null,
            "longitude": 82.147416,
            "latitude": 50.8517614
        },
        "4751": {
            "name": "Паново",
            "population": 1203,
            "type": "village",
            "poly": [
                [
                    82.1079195,
                    52.9756941
                ],
                [
                    82.1098425,
                    52.9756613
                ],
                [
                    82.1145778,
                    52.9782832
                ],
                [
                    82.1165916,
                    52.9794192
                ],
                [
                    82.120728,
                    52.9808174
                ],
                [
                    82.1220343,
                    52.980741
                ],
                [
                    82.1230865,
                    52.9800637
                ],
                [
                    82.1267513,
                    52.9819643
                ],
                [
                    82.127096,
                    52.9824122
                ],
                [
                    82.1259531,
                    52.9827071
                ],
                [
                    82.1238484,
                    52.9840177
                ],
                [
                    82.1213267,
                    52.9860275
                ],
                [
                    82.1214537,
                    52.9865627
                ],
                [
                    82.1224334,
                    52.9869668
                ],
                [
                    82.1258079,
                    52.987764
                ],
                [
                    82.1278399,
                    52.9883538
                ],
                [
                    82.1296904,
                    52.988321
                ],
                [
                    82.1307789,
                    52.9888452
                ],
                [
                    82.1320308,
                    52.9903087
                ],
                [
                    82.133337,
                    52.9907892
                ],
                [
                    82.1387979,
                    52.9918048
                ],
                [
                    82.139705,
                    52.9913898
                ],
                [
                    82.1451477,
                    52.9929733
                ],
                [
                    82.1493023,
                    52.9936503
                ],
                [
                    82.1503365,
                    52.9932244
                ],
                [
                    82.1546906,
                    52.9945457
                ],
                [
                    82.1578474,
                    52.9951572
                ],
                [
                    82.1634716,
                    52.9958669
                ],
                [
                    82.1661747,
                    52.9964894
                ],
                [
                    82.1667009,
                    52.9969917
                ],
                [
                    82.1699303,
                    52.9979962
                ],
                [
                    82.1706015,
                    52.9978106
                ],
                [
                    82.1709824,
                    52.997079
                ],
                [
                    82.1688599,
                    52.9962819
                ],
                [
                    82.1698396,
                    52.9952009
                ],
                [
                    82.1706197,
                    52.9953866
                ],
                [
                    82.1716538,
                    52.9942509
                ],
                [
                    82.1708555,
                    52.9938687
                ],
                [
                    82.171164,
                    52.9935193
                ],
                [
                    82.1727786,
                    52.9940762
                ],
                [
                    82.1747017,
                    52.9924819
                ],
                [
                    82.1754456,
                    52.991368
                ],
                [
                    82.171436,
                    52.9895988
                ],
                [
                    82.168878,
                    52.9868575
                ],
                [
                    82.1699484,
                    52.9854159
                ],
                [
                    82.1659934,
                    52.984269
                ],
                [
                    82.1612763,
                    52.981724
                ],
                [
                    82.1605505,
                    52.9825542
                ],
                [
                    82.1584098,
                    52.9822046
                ],
                [
                    82.1569765,
                    52.9812762
                ],
                [
                    82.1520418,
                    52.981309
                ],
                [
                    82.1504997,
                    52.9804242
                ],
                [
                    82.1482501,
                    52.9793537
                ],
                [
                    82.1427529,
                    52.9774857
                ],
                [
                    82.1408843,
                    52.9767975
                ],
                [
                    82.1366389,
                    52.9767319
                ],
                [
                    82.1350061,
                    52.9779882
                ],
                [
                    82.1320308,
                    52.9782722
                ],
                [
                    82.1294908,
                    52.9788075
                ],
                [
                    82.129128,
                    52.9793864
                ],
                [
                    82.1293094,
                    52.9804679
                ],
                [
                    82.1280576,
                    52.9807847
                ],
                [
                    82.1271142,
                    52.9817459
                ],
                [
                    82.1232861,
                    52.9797032
                ],
                [
                    82.1235945,
                    52.9794629
                ],
                [
                    82.1230321,
                    52.9789932
                ],
                [
                    82.1223246,
                    52.9786983
                ],
                [
                    82.1215081,
                    52.9791352
                ],
                [
                    82.116773,
                    52.976721
                ],
                [
                    82.11817,
                    52.975705
                ],
                [
                    82.1150676,
                    52.9751916
                ],
                [
                    82.115757,
                    52.9745033
                ],
                [
                    82.1148318,
                    52.9739025
                ],
                [
                    82.1153942,
                    52.9731377
                ],
                [
                    82.1134165,
                    52.9729192
                ],
                [
                    82.1099514,
                    52.9742411
                ],
                [
                    82.1079195,
                    52.9756941
                ]
            ],
            "longitude": 82.152328,
            "latitude": 52.987579
        },
        "4752": {
            "name": "Первомайский",
            "population": 731,
            "type": "village",
            "poly": null,
            "longitude": 82.1577436,
            "latitude": 52.3081846
        },
        "4753": {
            "name": "Селезнёво",
            "population": 568,
            "type": "village",
            "poly": [
                [
                    82.150449,
                    53.4979439
                ],
                [
                    82.151256,
                    53.4994528
                ],
                [
                    82.1590321,
                    53.5053976
                ],
                [
                    82.1739666,
                    53.5000883
                ],
                [
                    82.17328,
                    53.4953911
                ],
                [
                    82.1662419,
                    53.4925316
                ],
                [
                    82.1597187,
                    53.4926338
                ],
                [
                    82.150449,
                    53.4979439
                ]
            ],
            "longitude": 82.1630333,
            "latitude": 53.4973671
        },
        "4754": {
            "name": "Ивановка",
            "population": 363,
            "type": "village",
            "poly": null,
            "longitude": 82.1749286,
            "latitude": 53.3768161
        },
        "4755": {
            "name": "Боровское",
            "population": 992,
            "type": "village",
            "poly": [
                [
                    82.1494221,
                    52.642743
                ],
                [
                    82.1894192,
                    52.6662772
                ],
                [
                    82.1914792,
                    52.6644032
                ],
                [
                    82.2009206,
                    52.6677346
                ],
                [
                    82.2064137,
                    52.6647156
                ],
                [
                    82.1997188,
                    52.661384
                ],
                [
                    82.2026372,
                    52.6598222
                ],
                [
                    82.1980023,
                    52.6551365
                ],
                [
                    82.2005772,
                    52.6528456
                ],
                [
                    82.1968007,
                    52.6503462
                ],
                [
                    82.1993756,
                    52.6482633
                ],
                [
                    82.1918225,
                    52.6429514
                ],
                [
                    82.1796345,
                    52.6421181
                ],
                [
                    82.1746564,
                    52.6392015
                ],
                [
                    82.1679616,
                    52.6412848
                ],
                [
                    82.1593785,
                    52.6361805
                ],
                [
                    82.1494221,
                    52.642743
                ]
            ],
            "longitude": 82.1791916,
            "latitude": 52.6477195
        },
        "4756": {
            "name": "Быково",
            "population": 676,
            "type": "village",
            "poly": null,
            "longitude": 82.1797866,
            "latitude": 52.1400649
        },
        "4757": {
            "name": "Новофирсово",
            "population": 464,
            "type": "village",
            "poly": null,
            "longitude": 82.1867384,
            "latitude": 51.7507678
        },
        "4758": {
            "name": "Верх-Боровлянка",
            "population": 278,
            "type": "village",
            "poly": null,
            "longitude": 82.200424,
            "latitude": 53.183949
        },
        "4759": {
            "name": "Омутское",
            "population": 553,
            "type": "village",
            "poly": [
                [
                    82.2000592,
                    53.4750645
                ],
                [
                    82.2100155,
                    53.485995
                ],
                [
                    82.2026341,
                    53.491204
                ],
                [
                    82.2053807,
                    53.4933486
                ],
                [
                    82.238683,
                    53.4792532
                ],
                [
                    82.2359364,
                    53.4766991
                ],
                [
                    82.2232334,
                    53.4800704
                ],
                [
                    82.2124188,
                    53.4710797
                ],
                [
                    82.2000592,
                    53.4750645
                ]
            ],
            "longitude": 82.2082622,
            "latitude": 53.474999
        },
        "4760": {
            "name": "Барановка",
            "population": 1917,
            "type": "village",
            "poly": [
                [
                    82.1895426,
                    51.0487028
                ],
                [
                    82.1897357,
                    51.0492289
                ],
                [
                    82.1928686,
                    51.0492694
                ],
                [
                    82.1928278,
                    51.0476675
                ],
                [
                    82.196731,
                    51.0475832
                ],
                [
                    82.1967095,
                    51.0476506
                ],
                [
                    82.1974819,
                    51.0499034
                ],
                [
                    82.198469,
                    51.0507666
                ],
                [
                    82.1997779,
                    51.0507262
                ],
                [
                    82.1996276,
                    51.0516165
                ],
                [
                    82.200601,
                    51.0552625
                ],
                [
                    82.2012156,
                    51.0575646
                ],
                [
                    82.2017735,
                    51.0574163
                ],
                [
                    82.2033185,
                    51.0582255
                ],
                [
                    82.2039193,
                    51.0609902
                ],
                [
                    82.2054213,
                    51.061206
                ],
                [
                    82.2054428,
                    51.0621634
                ],
                [
                    82.2069233,
                    51.0626085
                ],
                [
                    82.2090906,
                    51.0622713
                ],
                [
                    82.2125667,
                    51.067018
                ],
                [
                    82.2132963,
                    51.0668967
                ],
                [
                    82.2142758,
                    51.0674394
                ],
                [
                    82.2145762,
                    51.0685451
                ],
                [
                    82.215177,
                    51.0687743
                ],
                [
                    82.2158068,
                    51.0686496
                ],
                [
                    82.2183603,
                    51.0707126
                ],
                [
                    82.219251,
                    51.0704179
                ],
                [
                    82.2205415,
                    51.0711339
                ],
                [
                    82.2213,
                    51.071198
                ],
                [
                    82.2216433,
                    51.0708069
                ],
                [
                    82.2195619,
                    51.0698227
                ],
                [
                    82.2192186,
                    51.069526
                ],
                [
                    82.2180384,
                    51.0680833
                ],
                [
                    82.216751,
                    51.0659797
                ],
                [
                    82.2150987,
                    51.0636468
                ],
                [
                    82.2147125,
                    51.0637008
                ],
                [
                    82.2144979,
                    51.0633367
                ],
                [
                    82.214619,
                    51.0631647
                ],
                [
                    82.2160429,
                    51.0631479
                ],
                [
                    82.217001,
                    51.0632726
                ],
                [
                    82.2165289,
                    51.0615734
                ],
                [
                    82.215692,
                    51.0611419
                ],
                [
                    82.2159066,
                    51.0604676
                ],
                [
                    82.2160783,
                    51.0597798
                ],
                [
                    82.2172016,
                    51.0594123
                ],
                [
                    82.2185244,
                    51.0593482
                ],
                [
                    82.2191896,
                    51.0584177
                ],
                [
                    82.21924,
                    51.0579962
                ],
                [
                    82.2187894,
                    51.0572139
                ],
                [
                    82.218267,
                    51.0558416
                ],
                [
                    82.2182745,
                    51.0549346
                ],
                [
                    82.2176951,
                    51.0541793
                ],
                [
                    82.2173089,
                    51.0534509
                ],
                [
                    82.2171372,
                    51.0528035
                ],
                [
                    82.2168722,
                    51.0523347
                ],
                [
                    82.2168797,
                    51.0516839
                ],
                [
                    82.2159924,
                    51.0511612
                ],
                [
                    82.2159999,
                    51.0507262
                ],
                [
                    82.2174516,
                    51.0505003
                ],
                [
                    82.2188324,
                    51.0502001
                ],
                [
                    82.220284,
                    51.0498663
                ],
                [
                    82.2207775,
                    51.049529
                ],
                [
                    82.2203913,
                    51.0487062
                ],
                [
                    82.220005,
                    51.0467906
                ],
                [
                    82.2198838,
                    51.0458294
                ],
                [
                    82.217752,
                    51.0455495
                ],
                [
                    82.2148766,
                    51.0449964
                ],
                [
                    82.2151127,
                    51.0443219
                ],
                [
                    82.2154131,
                    51.0442409
                ],
                [
                    82.2164001,
                    51.0441735
                ],
                [
                    82.2169441,
                    51.0426996
                ],
                [
                    82.2176232,
                    51.042433
                ],
                [
                    82.2179022,
                    51.0398562
                ],
                [
                    82.2177734,
                    51.0394514
                ],
                [
                    82.2174591,
                    51.0389488
                ],
                [
                    82.2157135,
                    51.0394514
                ],
                [
                    82.2148766,
                    51.042622
                ],
                [
                    82.2132319,
                    51.0434686
                ],
                [
                    82.2102922,
                    51.0427805
                ],
                [
                    82.2089833,
                    51.04274
                ],
                [
                    82.2075885,
                    51.0390568
                ],
                [
                    82.2047776,
                    51.0397583
                ],
                [
                    82.2024816,
                    51.0378694
                ],
                [
                    82.2019023,
                    51.0380448
                ],
                [
                    82.2010654,
                    51.0376131
                ],
                [
                    82.2004002,
                    51.037775
                ],
                [
                    82.2031897,
                    51.040352
                ],
                [
                    82.2025031,
                    51.0415392
                ],
                [
                    82.2047132,
                    51.0422004
                ],
                [
                    82.2052636,
                    51.0432156
                ],
                [
                    82.2046488,
                    51.043509
                ],
                [
                    82.2038549,
                    51.0433471
                ],
                [
                    82.2029108,
                    51.0433471
                ],
                [
                    82.2017306,
                    51.0435225
                ],
                [
                    82.2012585,
                    51.0425916
                ],
                [
                    82.2004431,
                    51.0422948
                ],
                [
                    82.200958,
                    51.0410941
                ],
                [
                    82.1992844,
                    51.0407433
                ],
                [
                    82.1988767,
                    51.0416742
                ],
                [
                    82.1982115,
                    51.041998
                ],
                [
                    82.1987265,
                    51.0436035
                ],
                [
                    82.1968812,
                    51.0429289
                ],
                [
                    82.1958941,
                    51.0430908
                ],
                [
                    82.1948212,
                    51.0427535
                ],
                [
                    82.1900791,
                    51.0423218
                ],
                [
                    82.1900791,
                    51.0427535
                ],
                [
                    82.1913665,
                    51.0429829
                ],
                [
                    82.1925467,
                    51.0434146
                ],
                [
                    82.1922248,
                    51.0440622
                ],
                [
                    82.1930832,
                    51.0443185
                ],
                [
                    82.1932548,
                    51.0448986
                ],
                [
                    82.1920532,
                    51.0466119
                ],
                [
                    82.1921605,
                    51.0489456
                ],
                [
                    82.1895426,
                    51.0487028
                ]
            ],
            "longitude": 82.2092659,
            "latitude": 51.0485627
        },
        "4761": {
            "name": "Шипуново",
            "population": 1119,
            "type": "village",
            "poly": null,
            "longitude": 82.223137,
            "latitude": 52.15966
        },
        "4762": {
            "name": "Ясная Поляна",
            "population": 463,
            "type": "village",
            "poly": null,
            "longitude": 82.2235976,
            "latitude": 53.2231442
        },
        "4763": {
            "name": "Ворониха",
            "population": 874,
            "type": "village",
            "poly": [
                [
                    82.1913569,
                    52.7634184
                ],
                [
                    82.1953795,
                    52.76525
                ],
                [
                    82.1971717,
                    52.7648403
                ],
                [
                    82.2009553,
                    52.761635
                ],
                [
                    82.2041813,
                    52.7619001
                ],
                [
                    82.2061328,
                    52.7609361
                ],
                [
                    82.2066506,
                    52.7592731
                ],
                [
                    82.2205104,
                    52.7594418
                ],
                [
                    82.2199927,
                    52.7584054
                ],
                [
                    82.2203411,
                    52.7583898
                ],
                [
                    82.2221433,
                    52.7583089
                ],
                [
                    82.2235373,
                    52.7588634
                ],
                [
                    82.2260066,
                    52.7585982
                ],
                [
                    82.2276794,
                    52.7591044
                ],
                [
                    82.2306265,
                    52.7591285
                ],
                [
                    82.235605,
                    52.7591767
                ],
                [
                    82.2371184,
                    52.7586946
                ],
                [
                    82.2488276,
                    52.75855
                ],
                [
                    82.2479912,
                    52.7553202
                ],
                [
                    82.2483497,
                    52.7495107
                ],
                [
                    82.2459202,
                    52.7515355
                ],
                [
                    82.2424154,
                    52.750716
                ],
                [
                    82.2403444,
                    52.7513187
                ],
                [
                    82.233295,
                    52.7479195
                ],
                [
                    82.227998,
                    52.746473
                ],
                [
                    82.2240152,
                    52.7460149
                ],
                [
                    82.2235373,
                    52.7482812
                ],
                [
                    82.2175234,
                    52.7481123
                ],
                [
                    82.2121866,
                    52.7488115
                ],
                [
                    82.2068895,
                    52.7486669
                ],
                [
                    82.2043008,
                    52.7491732
                ],
                [
                    82.1999994,
                    52.7519937
                ],
                [
                    82.1970522,
                    52.7535364
                ],
                [
                    82.1940652,
                    52.7538498
                ],
                [
                    82.1933881,
                    52.7556576
                ],
                [
                    82.1951803,
                    52.7567182
                ],
                [
                    82.1954989,
                    52.7581162
                ],
                [
                    82.1931093,
                    52.7592972
                ],
                [
                    82.19295,
                    52.7601408
                ],
                [
                    82.1939855,
                    52.7608879
                ],
                [
                    82.1927907,
                    52.7632016
                ],
                [
                    82.1913569,
                    52.7634184
                ]
            ],
            "longitude": 82.2265079,
            "latitude": 52.7543167
        },
        "4764": {
            "name": "Верх-Кучук",
            "population": 1219,
            "type": "village",
            "poly": [
                [
                    82.222167,
                    53.3522667
                ],
                [
                    82.2296233,
                    53.3580656
                ],
                [
                    82.2389436,
                    53.3616389
                ],
                [
                    82.2414856,
                    53.3607962
                ],
                [
                    82.2436604,
                    53.3563716
                ],
                [
                    82.2502977,
                    53.3494597
                ],
                [
                    82.2503542,
                    53.346838
                ],
                [
                    82.251258,
                    53.3429936
                ],
                [
                    82.249055,
                    53.3413747
                ],
                [
                    82.2408078,
                    53.3420155
                ],
                [
                    82.2336904,
                    53.3427575
                ],
                [
                    82.2346507,
                    53.3466356
                ],
                [
                    82.2258386,
                    53.3493333
                ],
                [
                    82.222167,
                    53.3522667
                ]
            ],
            "longitude": 82.2405149,
            "latitude": 53.3503343
        },
        "4765": {
            "name": "Касмалинка",
            "population": 126,
            "type": "village",
            "poly": [
                [
                    82.458467,
                    53.1220568
                ],
                [
                    82.4606667,
                    53.1234407
                ],
                [
                    82.4737226,
                    53.1281456
                ],
                [
                    82.4760286,
                    53.1273792
                ],
                [
                    82.4793991,
                    53.1230575
                ],
                [
                    82.4776605,
                    53.1220355
                ],
                [
                    82.4744321,
                    53.1222696
                ],
                [
                    82.4715759,
                    53.1204114
                ],
                [
                    82.469247,
                    53.1195049
                ],
                [
                    82.4630792,
                    53.1170532
                ],
                [
                    82.4596378,
                    53.1197147
                ],
                [
                    82.458467,
                    53.1220568
                ]
            ],
            "longitude": 82.4697671,
            "latitude": 53.1225411
        },
        "4766": {
            "name": "Новосёловка",
            "population": 76,
            "type": "village",
            "poly": [
                [
                    82.2345631,
                    53.470671
                ],
                [
                    82.2417729,
                    53.4748601
                ],
                [
                    82.249841,
                    53.472408
                ],
                [
                    82.2450344,
                    53.4692405
                ],
                [
                    82.2440045,
                    53.4692405
                ],
                [
                    82.2403996,
                    53.4675034
                ],
                [
                    82.2362797,
                    53.4676056
                ],
                [
                    82.2345631,
                    53.470671
                ]
            ],
            "longitude": 82.2414295,
            "latitude": 53.4710797
        },
        "4767": {
            "name": "Беспаловский",
            "population": 703,
            "type": "village",
            "poly": [
                [
                    82.2337606,
                    51.1979698
                ],
                [
                    82.2342541,
                    51.1998321
                ],
                [
                    82.2418318,
                    51.2021168
                ],
                [
                    82.2491597,
                    51.2007756
                ],
                [
                    82.2588435,
                    51.1933847
                ],
                [
                    82.2600666,
                    51.1918384
                ],
                [
                    82.2562901,
                    51.1887722
                ],
                [
                    82.2427513,
                    51.1890815
                ],
                [
                    82.2367003,
                    51.1937883
                ],
                [
                    82.2355625,
                    51.1956907
                ],
                [
                    82.2356354,
                    51.1961457
                ],
                [
                    82.2350513,
                    51.1968014
                ],
                [
                    82.2337606,
                    51.1979698
                ]
            ],
            "longitude": 82.2450757,
            "latitude": 51.1945706
        },
        "4768": {
            "name": "Малиновка",
            "population": 262,
            "type": "village",
            "poly": null,
            "longitude": 82.254697,
            "latitude": 52.4772939
        },
        "4769": {
            "name": "Белово",
            "population": 1471,
            "type": "village",
            "poly": [
                [
                    82.2308635,
                    52.9369164
                ],
                [
                    82.2324964,
                    52.9375405
                ],
                [
                    82.2346471,
                    52.9379726
                ],
                [
                    82.2348064,
                    52.9389807
                ],
                [
                    82.2364791,
                    52.9391007
                ],
                [
                    82.2373553,
                    52.9386687
                ],
                [
                    82.2403025,
                    52.9387406
                ],
                [
                    82.2422143,
                    52.9377806
                ],
                [
                    82.2434887,
                    52.9385246
                ],
                [
                    82.240661,
                    52.9391727
                ],
                [
                    82.237634,
                    52.9409729
                ],
                [
                    82.2348064,
                    52.9411889
                ],
                [
                    82.2335717,
                    52.9418129
                ],
                [
                    82.2357224,
                    52.9429169
                ],
                [
                    82.2416168,
                    52.9436129
                ],
                [
                    82.2469935,
                    52.9451009
                ],
                [
                    82.2481485,
                    52.9469008
                ],
                [
                    82.2458385,
                    52.9489165
                ],
                [
                    82.2433692,
                    52.9507403
                ],
                [
                    82.2476706,
                    52.9533078
                ],
                [
                    82.2495425,
                    52.9552513
                ],
                [
                    82.2573088,
                    52.9613451
                ],
                [
                    82.2607737,
                    52.9665508
                ],
                [
                    82.2652344,
                    52.9666467
                ],
                [
                    82.2721245,
                    52.9655192
                ],
                [
                    82.2795323,
                    52.9675582
                ],
                [
                    82.2811653,
                    52.9681099
                ],
                [
                    82.2823601,
                    52.9677981
                ],
                [
                    82.2830372,
                    52.9671504
                ],
                [
                    82.2841922,
                    52.9668626
                ],
                [
                    82.2855065,
                    52.9654473
                ],
                [
                    82.2855065,
                    52.9643679
                ],
                [
                    82.2839532,
                    52.9634083
                ],
                [
                    82.2857056,
                    52.9624248
                ],
                [
                    82.285387,
                    52.961873
                ],
                [
                    82.2874978,
                    52.9594499
                ],
                [
                    82.2866614,
                    52.9538597
                ],
                [
                    82.2835948,
                    52.952252
                ],
                [
                    82.2819618,
                    52.9516761
                ],
                [
                    82.2804881,
                    52.9495885
                ],
                [
                    82.2798509,
                    52.9485566
                ],
                [
                    82.2801298,
                    52.9476447
                ],
                [
                    82.2791739,
                    52.9462528
                ],
                [
                    82.2755895,
                    52.9480047
                ],
                [
                    82.2739566,
                    52.9480527
                ],
                [
                    82.2721643,
                    52.9474047
                ],
                [
                    82.2711687,
                    52.9471168
                ],
                [
                    82.274554,
                    52.9454129
                ],
                [
                    82.2726024,
                    52.9450049
                ],
                [
                    82.2708899,
                    52.9444529
                ],
                [
                    82.2726821,
                    52.9435409
                ],
                [
                    82.2725228,
                    52.9423889
                ],
                [
                    82.2751514,
                    52.9411169
                ],
                [
                    82.2763462,
                    52.9401328
                ],
                [
                    82.2768241,
                    52.9381166
                ],
                [
                    82.2786164,
                    52.9355962
                ],
                [
                    82.2761869,
                    52.9298588
                ],
                [
                    82.2730007,
                    52.9311072
                ],
                [
                    82.2711687,
                    52.92777
                ],
                [
                    82.2683808,
                    52.9282983
                ],
                [
                    82.2635218,
                    52.9272179
                ],
                [
                    82.2598577,
                    52.927602
                ],
                [
                    82.2583443,
                    52.9280822
                ],
                [
                    82.2597976,
                    52.9320285
                ],
                [
                    82.2551979,
                    52.9318034
                ],
                [
                    82.2538836,
                    52.9325235
                ],
                [
                    82.2530473,
                    52.9342039
                ],
                [
                    82.2539633,
                    52.9340839
                ],
                [
                    82.2554369,
                    52.9336998
                ],
                [
                    82.2573088,
                    52.93466
                ],
                [
                    82.2573486,
                    52.9357642
                ],
                [
                    82.2549988,
                    52.9371085
                ],
                [
                    82.2546005,
                    52.9379246
                ],
                [
                    82.2534057,
                    52.9388127
                ],
                [
                    82.2493832,
                    52.9400608
                ],
                [
                    82.2464758,
                    52.9389807
                ],
                [
                    82.2426524,
                    52.9374205
                ],
                [
                    82.2447234,
                    52.9363883
                ],
                [
                    82.2381519,
                    52.9319474
                ],
                [
                    82.2313812,
                    52.9353082
                ],
                [
                    82.2317397,
                    52.9360763
                ],
                [
                    82.2308635,
                    52.9369164
                ]
            ],
            "longitude": 82.260605,
            "latitude": 52.952583
        },
        "4770": {
            "name": "Краснознаменка",
            "population": 904,
            "type": "village",
            "poly": null,
            "longitude": 82.2667977,
            "latitude": 51.6852511
        },
        "4771": {
            "name": "Калмыцкие Мысы",
            "population": 1151,
            "type": "village",
            "poly": [
                [
                    82.2573587,
                    51.8975524
                ],
                [
                    82.2607485,
                    51.9007287
                ],
                [
                    82.2650172,
                    51.9003413
                ],
                [
                    82.2740566,
                    51.9065383
                ],
                [
                    82.2785764,
                    51.9077001
                ],
                [
                    82.2838493,
                    51.9049891
                ],
                [
                    82.280083,
                    51.899954
                ],
                [
                    82.2908802,
                    51.899954
                ],
                [
                    82.2921356,
                    51.8984046
                ],
                [
                    82.2879925,
                    51.8950732
                ],
                [
                    82.2815896,
                    51.8917416
                ],
                [
                    82.2716712,
                    51.8894171
                ],
                [
                    82.2694114,
                    51.885775
                ],
                [
                    82.2603719,
                    51.886705
                ],
                [
                    82.2573587,
                    51.8975524
                ]
            ],
            "longitude": 82.268517,
            "latitude": 51.89164
        },
        "4772": {
            "name": "Первокаменка",
            "population": 575,
            "type": "village",
            "poly": [
                [
                    82.2654122,
                    50.9596984
                ],
                [
                    82.2657985,
                    50.962023
                ],
                [
                    82.2688412,
                    50.9654381
                ],
                [
                    82.27009,
                    50.968834
                ],
                [
                    82.2732228,
                    50.9738333
                ],
                [
                    82.2770423,
                    50.9761844
                ],
                [
                    82.2808618,
                    50.9758871
                ],
                [
                    82.2853228,
                    50.9715202
                ],
                [
                    82.288286,
                    50.9701041
                ],
                [
                    82.2879856,
                    50.9633474
                ],
                [
                    82.2857112,
                    50.9591848
                ],
                [
                    82.2704289,
                    50.9604917
                ],
                [
                    82.2654122,
                    50.9596984
                ]
            ],
            "longitude": 82.2791488,
            "latitude": 50.9687436
        },
        "4773": {
            "name": "Усть-Таловка",
            "population": 948,
            "type": "village",
            "poly": null,
            "longitude": 82.2877047,
            "latitude": 51.4896309
        },
        "4774": {
            "name": "Ребриха",
            "population": 2594,
            "type": "village",
            "poly": [
                [
                    82.2678647,
                    53.0059153
                ],
                [
                    82.2679285,
                    53.0096458
                ],
                [
                    82.2772363,
                    53.0146225
                ],
                [
                    82.283994,
                    53.0158019
                ],
                [
                    82.2893492,
                    53.0144212
                ],
                [
                    82.2902872,
                    53.0170507
                ],
                [
                    82.2991085,
                    53.0160314
                ],
                [
                    82.3031276,
                    53.0130897
                ],
                [
                    82.303751,
                    53.0114624
                ],
                [
                    82.3085665,
                    53.0118128
                ],
                [
                    82.3144812,
                    53.0127029
                ],
                [
                    82.3157337,
                    53.0117496
                ],
                [
                    82.3064157,
                    53.0064847
                ],
                [
                    82.3045614,
                    53.0055773
                ],
                [
                    82.3020567,
                    53.0048978
                ],
                [
                    82.3002166,
                    53.0052806
                ],
                [
                    82.2977037,
                    53.0065973
                ],
                [
                    82.2952782,
                    53.0033737
                ],
                [
                    82.2911981,
                    53.0015322
                ],
                [
                    82.2872086,
                    53.0012102
                ],
                [
                    82.2815703,
                    53.0061222
                ],
                [
                    82.2812875,
                    53.0033148
                ],
                [
                    82.2752256,
                    53.0031915
                ],
                [
                    82.2678647,
                    53.0059153
                ]
            ],
            "longitude": 82.291664,
            "latitude": 53.01086
        },
        "4775": {
            "name": "Черепановский",
            "population": 365,
            "type": "village",
            "poly": null,
            "longitude": 82.3045154,
            "latitude": 51.1951922
        },
        "4776": {
            "name": "Ильинка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    82.3092358,
                    53.451866
                ],
                [
                    82.3123257,
                    53.4552392
                ],
                [
                    82.312669,
                    53.4572835
                ],
                [
                    82.3262303,
                    53.4600431
                ],
                [
                    82.3353283,
                    53.4552392
                ],
                [
                    82.3293202,
                    53.4508437
                ],
                [
                    82.3205654,
                    53.4506393
                ],
                [
                    82.3145573,
                    53.4477768
                ],
                [
                    82.3092358,
                    53.451866
                ]
            ],
            "longitude": 82.3221877,
            "latitude": 53.454866
        },
        "4777": {
            "name": "Гальцовка",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 82.3303973,
            "latitude": 51.0683733
        },
        "4778": {
            "name": "Ребриха",
            "population": 8207,
            "type": "village",
            "poly": [
                [
                    82.2997238,
                    53.0661946
                ],
                [
                    82.3059684,
                    53.0679455
                ],
                [
                    82.3040146,
                    53.0709715
                ],
                [
                    82.304927,
                    53.0721535
                ],
                [
                    82.3074288,
                    53.0730111
                ],
                [
                    82.3093602,
                    53.0754608
                ],
                [
                    82.3083945,
                    53.0761054
                ],
                [
                    82.3123647,
                    53.0793283
                ],
                [
                    82.315116,
                    53.0799429
                ],
                [
                    82.3254478,
                    53.0851452
                ],
                [
                    82.3290498,
                    53.0875728
                ],
                [
                    82.3339918,
                    53.0886442
                ],
                [
                    82.3414097,
                    53.0885913
                ],
                [
                    82.3461932,
                    53.0883952
                ],
                [
                    82.3489935,
                    53.088263
                ],
                [
                    82.3530169,
                    53.0874431
                ],
                [
                    82.3550028,
                    53.0874031
                ],
                [
                    82.3561196,
                    53.0875107
                ],
                [
                    82.3576579,
                    53.0878255
                ],
                [
                    82.3638567,
                    53.0888366
                ],
                [
                    82.3677352,
                    53.0915792
                ],
                [
                    82.371416,
                    53.0903255
                ],
                [
                    82.3695022,
                    53.0869268
                ],
                [
                    82.368545,
                    53.0864307
                ],
                [
                    82.3690997,
                    53.0862555
                ],
                [
                    82.384851,
                    53.0930768
                ],
                [
                    82.3860574,
                    53.0920935
                ],
                [
                    82.3876369,
                    53.0907304
                ],
                [
                    82.3838319,
                    53.0891377
                ],
                [
                    82.3698948,
                    53.0825509
                ],
                [
                    82.3668894,
                    53.0829429
                ],
                [
                    82.365909,
                    53.0817843
                ],
                [
                    82.3679986,
                    53.0804244
                ],
                [
                    82.3690537,
                    53.0802969
                ],
                [
                    82.3700271,
                    53.080345
                ],
                [
                    82.3705454,
                    53.0804728
                ],
                [
                    82.3707007,
                    53.0809106
                ],
                [
                    82.370872,
                    53.0812966
                ],
                [
                    82.3716428,
                    53.0816053
                ],
                [
                    82.3726492,
                    53.0816439
                ],
                [
                    82.3734841,
                    53.0815281
                ],
                [
                    82.3740624,
                    53.0813609
                ],
                [
                    82.3745474,
                    53.0809874
                ],
                [
                    82.3746405,
                    53.0802162
                ],
                [
                    82.3743826,
                    53.0794694
                ],
                [
                    82.3745977,
                    53.0785955
                ],
                [
                    82.3732977,
                    53.077905
                ],
                [
                    82.3716244,
                    53.0771968
                ],
                [
                    82.3701614,
                    53.0766782
                ],
                [
                    82.36779,
                    53.0762351
                ],
                [
                    82.3662518,
                    53.0760371
                ],
                [
                    82.3639444,
                    53.0762021
                ],
                [
                    82.3616693,
                    53.0757682
                ],
                [
                    82.3602224,
                    53.0755281
                ],
                [
                    82.3591394,
                    53.0757086
                ],
                [
                    82.3562532,
                    53.075476
                ],
                [
                    82.3540007,
                    53.0746179
                ],
                [
                    82.352902,
                    53.0735617
                ],
                [
                    82.3503199,
                    53.0728686
                ],
                [
                    82.3474338,
                    53.0724554
                ],
                [
                    82.3468823,
                    53.0721743
                ],
                [
                    82.3472434,
                    53.070492
                ],
                [
                    82.3517923,
                    53.0711633
                ],
                [
                    82.3555769,
                    53.0721502
                ],
                [
                    82.3569837,
                    53.0721327
                ],
                [
                    82.3570623,
                    53.0709742
                ],
                [
                    82.3548632,
                    53.0686285
                ],
                [
                    82.3540699,
                    53.068044
                ],
                [
                    82.3537771,
                    53.0679361
                ],
                [
                    82.3533142,
                    53.0680837
                ],
                [
                    82.3519352,
                    53.0672664
                ],
                [
                    82.3525096,
                    53.0667367
                ],
                [
                    82.3525969,
                    53.065882
                ],
                [
                    82.3519944,
                    53.0648519
                ],
                [
                    82.3517435,
                    53.0646524
                ],
                [
                    82.3521435,
                    53.0641986
                ],
                [
                    82.3555209,
                    53.062109
                ],
                [
                    82.3550926,
                    53.0618045
                ],
                [
                    82.3547067,
                    53.0614428
                ],
                [
                    82.3538006,
                    53.060543
                ],
                [
                    82.3526516,
                    53.0597121
                ],
                [
                    82.351704,
                    53.0595805
                ],
                [
                    82.3495507,
                    53.0604893
                ],
                [
                    82.3466623,
                    53.0635839
                ],
                [
                    82.3453368,
                    53.0629997
                ],
                [
                    82.3441468,
                    53.0624102
                ],
                [
                    82.3423992,
                    53.0610444
                ],
                [
                    82.3410773,
                    53.0604665
                ],
                [
                    82.3413159,
                    53.0601319
                ],
                [
                    82.3409536,
                    53.059962
                ],
                [
                    82.3407168,
                    53.0601325
                ],
                [
                    82.339902,
                    53.0600682
                ],
                [
                    82.3374922,
                    53.0588122
                ],
                [
                    82.3359543,
                    53.0579424
                ],
                [
                    82.332945,
                    53.0573371
                ],
                [
                    82.3301028,
                    53.0573197
                ],
                [
                    82.3231033,
                    53.0556778
                ],
                [
                    82.3188566,
                    53.0546816
                ],
                [
                    82.3132233,
                    53.0558908
                ],
                [
                    82.3137598,
                    53.0577449
                ],
                [
                    82.3151011,
                    53.0584704
                ],
                [
                    82.3130891,
                    53.0614528
                ],
                [
                    82.3186738,
                    53.0638443
                ],
                [
                    82.3252787,
                    53.0649501
                ],
                [
                    82.3240725,
                    53.0654147
                ],
                [
                    82.3234,
                    53.0671855
                ],
                [
                    82.31604,
                    53.0661276
                ],
                [
                    82.3070982,
                    53.0647498
                ],
                [
                    82.3003366,
                    53.0656071
                ],
                [
                    82.2997238,
                    53.0661946
                ]
            ],
            "longitude": 82.344826,
            "latitude": 53.07626
        },
        "4779": {
            "name": "Барчиха",
            "population": 236,
            "type": "village",
            "poly": null,
            "longitude": 82.3532381,
            "latitude": 52.2418149
        },
        "4780": {
            "name": "Красный Яр",
            "population": 1114,
            "type": "village",
            "poly": null,
            "longitude": 82.3631945,
            "latitude": 52.1903429
        },
        "4781": {
            "name": "Ильинка",
            "population": 470,
            "type": "village",
            "poly": null,
            "longitude": 82.3641495,
            "latitude": 51.9498576
        },
        "4782": {
            "name": "Казанцево",
            "population": 250,
            "type": "village",
            "poly": null,
            "longitude": 82.367813,
            "latitude": 51.364876
        },
        "4783": {
            "name": "Шипуниха",
            "population": 694,
            "type": "village",
            "poly": null,
            "longitude": 82.3770396,
            "latitude": 50.9337827
        },
        "4784": {
            "name": "Ельцовка",
            "population": 778,
            "type": "village",
            "poly": null,
            "longitude": 82.3920581,
            "latitude": 51.9061704
        },
        "4785": {
            "name": "Батурово",
            "population": 443,
            "type": "village",
            "poly": [
                [
                    82.3835652,
                    53.4195509
                ],
                [
                    82.3871701,
                    53.4310072
                ],
                [
                    82.3966114,
                    53.4336662
                ],
                [
                    82.4160092,
                    53.4290639
                ],
                [
                    82.4002163,
                    53.4236428
                ],
                [
                    82.3936932,
                    53.4250748
                ],
                [
                    82.39026,
                    53.4181187
                ],
                [
                    82.3835652,
                    53.4195509
                ]
            ],
            "longitude": 82.395454,
            "latitude": 53.426689
        },
        "4786": {
            "name": "Пеньки",
            "population": 135,
            "type": "village",
            "poly": null,
            "longitude": 82.3962501,
            "latitude": 52.9360957
        },
        "4787": {
            "name": "Нечунаево",
            "population": 935,
            "type": "village",
            "poly": [
                [
                    82.3794264,
                    52.2606218
                ],
                [
                    82.3820015,
                    52.2634586
                ],
                [
                    82.3861213,
                    52.2657699
                ],
                [
                    82.3904129,
                    52.2697619
                ],
                [
                    82.3945327,
                    52.2756442
                ],
                [
                    82.3972792,
                    52.2779548
                ],
                [
                    82.4022575,
                    52.2755391
                ],
                [
                    82.4038025,
                    52.2707073
                ],
                [
                    82.4089523,
                    52.2676609
                ],
                [
                    82.4056906,
                    52.2631434
                ],
                [
                    82.4020858,
                    52.25789
                ],
                [
                    82.3948761,
                    52.2566289
                ],
                [
                    82.3869796,
                    52.2575747
                ],
                [
                    82.3794264,
                    52.2606218
                ]
            ],
            "longitude": 82.3978725,
            "latitude": 52.2660452
        },
        "4788": {
            "name": "Озёрки",
            "population": 188,
            "type": "village",
            "poly": null,
            "longitude": 82.4055742,
            "latitude": 51.8005673
        },
        "4789": {
            "name": "Новоалейское",
            "population": 726,
            "type": "village",
            "poly": null,
            "longitude": 82.4115526,
            "latitude": 50.8423649
        },
        "4790": {
            "name": "Ключевка",
            "population": 189,
            "type": "village",
            "poly": [
                [
                    82.4151013,
                    53.0277412
                ],
                [
                    82.4158202,
                    53.028745
                ],
                [
                    82.4193637,
                    53.0310922
                ],
                [
                    82.4220342,
                    53.0341033
                ],
                [
                    82.4246275,
                    53.0322349
                ],
                [
                    82.4248587,
                    53.0313084
                ],
                [
                    82.4270669,
                    53.0317099
                ],
                [
                    82.4280427,
                    53.0309377
                ],
                [
                    82.4270156,
                    53.029656
                ],
                [
                    82.4252439,
                    53.0289303
                ],
                [
                    82.4284792,
                    53.0252393
                ],
                [
                    82.4276319,
                    53.0241428
                ],
                [
                    82.4262453,
                    53.0231698
                ],
                [
                    82.4268359,
                    53.0224748
                ],
                [
                    82.4276319,
                    53.0214863
                ],
                [
                    82.4265588,
                    53.0209119
                ],
                [
                    82.4253753,
                    53.020773
                ],
                [
                    82.4213885,
                    53.0208436
                ],
                [
                    82.4206219,
                    53.020992
                ],
                [
                    82.4172839,
                    53.0242046
                ],
                [
                    82.4152553,
                    53.026969
                ],
                [
                    82.4151013,
                    53.0277412
                ]
            ],
            "longitude": 82.4226622,
            "latitude": 53.0244139
        },
        "4791": {
            "name": "Верх-Алейка",
            "population": 352,
            "type": "village",
            "poly": null,
            "longitude": 82.4431297,
            "latitude": 50.8548956
        },
        "4792": {
            "name": "Новый Путь",
            "population": 168,
            "type": "village",
            "poly": null,
            "longitude": 82.447202,
            "latitude": 52.171896
        },
        "4793": {
            "name": "Качусово",
            "population": 227,
            "type": "village",
            "poly": null,
            "longitude": 82.4557165,
            "latitude": 51.949508
        },
        "4794": {
            "name": "Боровлянка",
            "population": 869,
            "type": "village",
            "poly": [
                [
                    82.4379754,
                    53.1939848
                ],
                [
                    82.4390224,
                    53.1958667
                ],
                [
                    82.4402938,
                    53.1962251
                ],
                [
                    82.4402938,
                    53.1973452
                ],
                [
                    82.4420139,
                    53.1983308
                ],
                [
                    82.4488195,
                    53.1985547
                ],
                [
                    82.4488944,
                    53.1966283
                ],
                [
                    82.4530824,
                    53.1977932
                ],
                [
                    82.4604863,
                    53.198062
                ],
                [
                    82.4632536,
                    53.1975691
                ],
                [
                    82.4659459,
                    53.199854
                ],
                [
                    82.4677408,
                    53.2001676
                ],
                [
                    82.4700592,
                    53.1984204
                ],
                [
                    82.4743221,
                    53.1980172
                ],
                [
                    82.4748456,
                    53.1969868
                ],
                [
                    82.4732751,
                    53.196942
                ],
                [
                    82.4731255,
                    53.1954635
                ],
                [
                    82.4702836,
                    53.1952842
                ],
                [
                    82.4708819,
                    53.1945226
                ],
                [
                    82.4700592,
                    53.1933576
                ],
                [
                    82.4674416,
                    53.1938057
                ],
                [
                    82.4675163,
                    53.1930888
                ],
                [
                    82.4645249,
                    53.191162
                ],
                [
                    82.4665442,
                    53.1899074
                ],
                [
                    82.4693861,
                    53.1853365
                ],
                [
                    82.4703584,
                    53.1823786
                ],
                [
                    82.4699844,
                    53.1802273
                ],
                [
                    82.4682643,
                    53.1801377
                ],
                [
                    82.4682643,
                    53.177807
                ],
                [
                    82.4622813,
                    53.176283
                ],
                [
                    82.4556252,
                    53.1759244
                ],
                [
                    82.4538303,
                    53.175252
                ],
                [
                    82.4482213,
                    53.1742658
                ],
                [
                    82.4476252,
                    53.1746767
                ],
                [
                    82.4467255,
                    53.1752968
                ],
                [
                    82.445155,
                    53.1741762
                ],
                [
                    82.4428366,
                    53.1744003
                ],
                [
                    82.4417148,
                    53.1746693
                ],
                [
                    82.4407425,
                    53.1760588
                ],
                [
                    82.4431357,
                    53.1766416
                ],
                [
                    82.4428366,
                    53.1774484
                ],
                [
                    82.4444819,
                    53.1778965
                ],
                [
                    82.4431308,
                    53.1809056
                ],
                [
                    82.4424068,
                    53.1825657
                ],
                [
                    82.4400694,
                    53.1843058
                ],
                [
                    82.4415652,
                    53.1857398
                ],
                [
                    82.4455344,
                    53.1850667
                ],
                [
                    82.4467255,
                    53.188339
                ],
                [
                    82.4480717,
                    53.1894593
                ],
                [
                    82.4479969,
                    53.1904899
                ],
                [
                    82.4405182,
                    53.1933128
                ],
                [
                    82.4379754,
                    53.1939848
                ]
            ],
            "longitude": 82.459816,
            "latitude": 53.181347
        },
        "4795": {
            "name": "Кучук",
            "population": 1184,
            "type": "village",
            "poly": [
                [
                    82.4486248,
                    53.4493103
                ],
                [
                    82.4570362,
                    53.4529904
                ],
                [
                    82.4631548,
                    53.4508829
                ],
                [
                    82.4671642,
                    53.4523771
                ],
                [
                    82.4745456,
                    53.4469589
                ],
                [
                    82.4812405,
                    53.4460387
                ],
                [
                    82.4836437,
                    53.4396996
                ],
                [
                    82.476434,
                    53.4365296
                ],
                [
                    82.4716275,
                    53.4346889
                ],
                [
                    82.4596112,
                    53.438677
                ],
                [
                    82.4508564,
                    53.4416423
                ],
                [
                    82.4486248,
                    53.4493103
                ]
            ],
            "longitude": 82.4664732,
            "latitude": 53.4439858
        },
        "4796": {
            "name": "Бестужево",
            "population": 381,
            "type": "village",
            "poly": null,
            "longitude": 82.4688999,
            "latitude": 52.042702
        },
        "4797": {
            "name": "Семеновка",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 82.4741786,
            "latitude": 50.9550829
        },
        "4798": {
            "name": "Моховское",
            "population": 854,
            "type": "village",
            "poly": [
                [
                    82.4522328,
                    52.6293043
                ],
                [
                    82.4639058,
                    52.633576
                ],
                [
                    82.4712872,
                    52.6311796
                ],
                [
                    82.4778104,
                    52.6332634
                ],
                [
                    82.4850201,
                    52.6280539
                ],
                [
                    82.4898267,
                    52.6266993
                ],
                [
                    82.4975514,
                    52.6210722
                ],
                [
                    82.4985814,
                    52.6142978
                ],
                [
                    82.4927449,
                    52.6091903
                ],
                [
                    82.4738621,
                    52.6150274
                ],
                [
                    82.4730038,
                    52.6180499
                ],
                [
                    82.467339,
                    52.6197174
                ],
                [
                    82.4651073,
                    52.6180499
                ],
                [
                    82.4578976,
                    52.6211764
                ],
                [
                    82.4590993,
                    52.6222185
                ],
                [
                    82.4522328,
                    52.6293043
                ]
            ],
            "longitude": 82.4763739,
            "latitude": 52.622707
        },
        "4799": {
            "name": "Метели",
            "population": 369,
            "type": "village",
            "poly": null,
            "longitude": 82.481713,
            "latitude": 52.0767465
        },
        "4800": {
            "name": "Рожнев Лог",
            "population": 1170,
            "type": "village",
            "poly": null,
            "longitude": 82.4835431,
            "latitude": 52.8599497
        },
        "4801": {
            "name": "Кабаково",
            "population": 579,
            "type": "village",
            "poly": [
                [
                    82.4652572,
                    52.3032593
                ],
                [
                    82.4673172,
                    52.3051486
                ],
                [
                    82.4668022,
                    52.3080876
                ],
                [
                    82.4710937,
                    52.3113411
                ],
                [
                    82.4760718,
                    52.3137548
                ],
                [
                    82.4827667,
                    52.3157487
                ],
                [
                    82.4875732,
                    52.3176376
                ],
                [
                    82.4944397,
                    52.3194214
                ],
                [
                    82.4949546,
                    52.3231987
                ],
                [
                    82.5030227,
                    52.3245627
                ],
                [
                    82.5086876,
                    52.3266609
                ],
                [
                    82.5133224,
                    52.3228839
                ],
                [
                    82.5164123,
                    52.3201559
                ],
                [
                    82.5124641,
                    52.316903
                ],
                [
                    82.5080009,
                    52.3122856
                ],
                [
                    82.503366,
                    52.3097668
                ],
                [
                    82.4982162,
                    52.3086123
                ],
                [
                    82.4963279,
                    52.3066181
                ],
                [
                    82.4911781,
                    52.3037841
                ],
                [
                    82.4839683,
                    52.3018947
                ],
                [
                    82.4767585,
                    52.2993753
                ],
                [
                    82.472467,
                    52.3004251
                ],
                [
                    82.4664589,
                    52.3000052
                ],
                [
                    82.4652572,
                    52.3032593
                ]
            ],
            "longitude": 82.4838676,
            "latitude": 52.3060229
        },
        "4802": {
            "name": "Трусово",
            "population": 607,
            "type": "village",
            "poly": null,
            "longitude": 82.484271,
            "latitude": 51.7050215
        },
        "4803": {
            "name": "Кузнечиха",
            "population": 393,
            "type": "village",
            "poly": null,
            "longitude": 82.4913411,
            "latitude": 51.9923021
        },
        "4804": {
            "name": "Плоскосеминский",
            "population": 325,
            "type": "village",
            "poly": [
                [
                    82.4792513,
                    52.9951481
                ],
                [
                    82.4823906,
                    52.996546
                ],
                [
                    82.4834793,
                    52.9974634
                ],
                [
                    82.4819006,
                    52.9995602
                ],
                [
                    82.4810296,
                    53.0017115
                ],
                [
                    82.4812655,
                    53.0020719
                ],
                [
                    82.4817555,
                    53.0024869
                ],
                [
                    82.4828079,
                    53.0027162
                ],
                [
                    82.4838423,
                    53.0028581
                ],
                [
                    82.4871448,
                    53.0027271
                ],
                [
                    82.4863826,
                    53.003557
                ],
                [
                    82.4863644,
                    53.0042122
                ],
                [
                    82.4864734,
                    53.0056317
                ],
                [
                    82.4850762,
                    53.0070511
                ],
                [
                    82.4872719,
                    53.0079683
                ],
                [
                    82.4869271,
                    53.0083068
                ],
                [
                    82.4890683,
                    53.0090274
                ],
                [
                    82.4901752,
                    53.0073896
                ],
                [
                    82.4931693,
                    53.0086562
                ],
                [
                    82.4954556,
                    53.0066908
                ],
                [
                    82.4944031,
                    53.0050857
                ],
                [
                    82.492897,
                    53.003699
                ],
                [
                    82.4934596,
                    53.0034806
                ],
                [
                    82.4947662,
                    53.0037645
                ],
                [
                    82.4967622,
                    53.0038082
                ],
                [
                    82.4981776,
                    53.0020064
                ],
                [
                    82.4999196,
                    52.9993091
                ],
                [
                    82.5004821,
                    52.9980095
                ],
                [
                    82.5022242,
                    52.9985883
                ],
                [
                    82.5029318,
                    52.9985555
                ],
                [
                    82.5038029,
                    52.9972559
                ],
                [
                    82.501335,
                    52.9947221
                ],
                [
                    82.50021,
                    52.9942306
                ],
                [
                    82.4986857,
                    52.9927998
                ],
                [
                    82.4963992,
                    52.9926032
                ],
                [
                    82.4964356,
                    52.9917949
                ],
                [
                    82.4955101,
                    52.9904514
                ],
                [
                    82.4952017,
                    52.9904842
                ],
                [
                    82.4939495,
                    52.9912379
                ],
                [
                    82.4929697,
                    52.9894247
                ],
                [
                    82.4925886,
                    52.9893482
                ],
                [
                    82.4870541,
                    52.9891953
                ],
                [
                    82.4854028,
                    52.9894137
                ],
                [
                    82.4849854,
                    52.990801
                ],
                [
                    82.4839511,
                    52.9912051
                ],
                [
                    82.482318,
                    52.99233
                ],
                [
                    82.4808663,
                    52.9923738
                ],
                [
                    82.4794509,
                    52.9941322
                ],
                [
                    82.4792513,
                    52.9951481
                ]
            ],
            "longitude": 82.4918552,
            "latitude": 52.9963237
        },
        "4805": {
            "name": "Зелёная Роща",
            "population": 598,
            "type": "village",
            "poly": [
                [
                    82.4934489,
                    53.058881
                ],
                [
                    82.4970788,
                    53.0604781
                ],
                [
                    82.4951386,
                    53.0625915
                ],
                [
                    82.4950044,
                    53.0627374
                ],
                [
                    82.4935785,
                    53.0635944
                ],
                [
                    82.4993474,
                    53.0657756
                ],
                [
                    82.4986344,
                    53.0664767
                ],
                [
                    82.5060886,
                    53.0693589
                ],
                [
                    82.5086166,
                    53.0708776
                ],
                [
                    82.5125057,
                    53.0709556
                ],
                [
                    82.5150337,
                    53.0732533
                ],
                [
                    82.5214508,
                    53.0752004
                ],
                [
                    82.5241732,
                    53.0764076
                ],
                [
                    82.5248862,
                    53.0770306
                ],
                [
                    82.5247566,
                    53.0787439
                ],
                [
                    82.5263771,
                    53.0801457
                ],
                [
                    82.529618,
                    53.0803014
                ],
                [
                    82.5304607,
                    53.0798731
                ],
                [
                    82.529618,
                    53.0785493
                ],
                [
                    82.5282568,
                    53.076797
                ],
                [
                    82.5330535,
                    53.0746942
                ],
                [
                    82.5303311,
                    53.0729418
                ],
                [
                    82.5267012,
                    53.0738375
                ],
                [
                    82.5252751,
                    53.0718124
                ],
                [
                    82.5180802,
                    53.0649187
                ],
                [
                    82.5171727,
                    53.0636723
                ],
                [
                    82.5138021,
                    53.0615298
                ],
                [
                    82.5156171,
                    53.0600107
                ],
                [
                    82.5132188,
                    53.058881
                ],
                [
                    82.512052,
                    53.057011
                ],
                [
                    82.5076443,
                    53.0546346
                ],
                [
                    82.5029124,
                    53.0579071
                ],
                [
                    82.501292,
                    53.0573617
                ],
                [
                    82.5001252,
                    53.0580629
                ],
                [
                    82.4987641,
                    53.0593484
                ],
                [
                    82.4940323,
                    53.0582187
                ],
                [
                    82.4934489,
                    53.058881
                ]
            ],
            "longitude": 82.505602,
            "latitude": 53.0632977
        },
        "4806": {
            "name": "Песчаное",
            "population": 504,
            "type": "village",
            "poly": null,
            "longitude": 82.506943,
            "latitude": 52.789574
        },
        "4807": {
            "name": "Дружба",
            "population": 1068,
            "type": "village",
            "poly": [
                [
                    82.4877667,
                    52.5796802
                ],
                [
                    82.5033879,
                    52.5813491
                ],
                [
                    82.5057912,
                    52.5846868
                ],
                [
                    82.5064778,
                    52.5846868
                ],
                [
                    82.5143742,
                    52.5836438
                ],
                [
                    82.5202107,
                    52.5796802
                ],
                [
                    82.5171208,
                    52.5709171
                ],
                [
                    82.4973798,
                    52.5703954
                ],
                [
                    82.48811,
                    52.5751946
                ],
                [
                    82.4877667,
                    52.5796802
                ]
            ],
            "longitude": 82.506958,
            "latitude": 52.57605
        },
        "4808": {
            "name": "Ясная Поляна",
            "population": 407,
            "type": "village",
            "poly": null,
            "longitude": 82.5353063,
            "latitude": 52.1078187
        },
        "4809": {
            "name": "Белоглазово",
            "population": 681,
            "type": "village",
            "poly": null,
            "longitude": 82.5619848,
            "latitude": 52.1172881
        },
        "4810": {
            "name": "Кашино",
            "population": 677,
            "type": "village",
            "poly": null,
            "longitude": 82.564339,
            "latitude": 52.370152
        },
        "4811": {
            "name": "Новосельское",
            "population": 252,
            "type": "village",
            "poly": null,
            "longitude": 82.5654853,
            "latitude": 52.0437991
        },
        "4812": {
            "name": "Колывань",
            "population": 1148,
            "type": "village",
            "poly": null,
            "longitude": 82.569427,
            "latitude": 51.317177
        },
        "4813": {
            "name": "Клочки",
            "population": 1094,
            "type": "village",
            "poly": [
                [
                    82.5506848,
                    53.1724082
                ],
                [
                    82.5529786,
                    53.175266
                ],
                [
                    82.5543703,
                    53.1813209
                ],
                [
                    82.5577723,
                    53.1825874
                ],
                [
                    82.5739317,
                    53.1854445
                ],
                [
                    82.5875911,
                    53.1892744
                ],
                [
                    82.5891375,
                    53.1884868
                ],
                [
                    82.5913539,
                    53.1879772
                ],
                [
                    82.594627,
                    53.1879
                ],
                [
                    82.598828,
                    53.1862167
                ],
                [
                    82.6038278,
                    53.1856916
                ],
                [
                    82.6070752,
                    53.1850739
                ],
                [
                    82.608003,
                    53.1843017
                ],
                [
                    82.608441,
                    53.1831588
                ],
                [
                    82.5974105,
                    53.1840083
                ],
                [
                    82.5932096,
                    53.182263
                ],
                [
                    82.5920258,
                    53.182249
                ],
                [
                    82.5913841,
                    53.1815811
                ],
                [
                    82.5899656,
                    53.1808727
                ],
                [
                    82.5888788,
                    53.1807611
                ],
                [
                    82.5878548,
                    53.1809637
                ],
                [
                    82.5870441,
                    53.1807512
                ],
                [
                    82.5860648,
                    53.1802857
                ],
                [
                    82.5858959,
                    53.1797898
                ],
                [
                    82.5853169,
                    53.1795138
                ],
                [
                    82.584086,
                    53.1782627
                ],
                [
                    82.5849623,
                    53.1766099
                ],
                [
                    82.5888025,
                    53.1750187
                ],
                [
                    82.5932611,
                    53.1736131
                ],
                [
                    82.5985702,
                    53.1730414
                ],
                [
                    82.600529,
                    53.1726862
                ],
                [
                    82.6046268,
                    53.1708942
                ],
                [
                    82.6037763,
                    53.1691021
                ],
                [
                    82.6014825,
                    53.1694574
                ],
                [
                    82.5993468,
                    53.169297
                ],
                [
                    82.5982386,
                    53.170343
                ],
                [
                    82.5925079,
                    53.1681249
                ],
                [
                    82.5910921,
                    53.1680228
                ],
                [
                    82.5879777,
                    53.1694729
                ],
                [
                    82.5778749,
                    53.1714813
                ],
                [
                    82.5744472,
                    53.1720838
                ],
                [
                    82.5715606,
                    53.1718057
                ],
                [
                    82.5645247,
                    53.1695656
                ],
                [
                    82.5544992,
                    53.1634781
                ],
                [
                    82.5539322,
                    53.1635708
                ],
                [
                    82.5524632,
                    53.1652705
                ],
                [
                    82.5509426,
                    53.1661821
                ],
                [
                    82.5507106,
                    53.1684378
                ],
                [
                    82.5516642,
                    53.1697973
                ],
                [
                    82.5506848,
                    53.1724082
                ]
            ],
            "longitude": 82.579018,
            "latitude": 53.180782
        },
        "4814": {
            "name": "Акимовка",
            "population": 480,
            "type": "village",
            "poly": [
                [
                    82.5694673,
                    51.5820538
                ],
                [
                    82.5708135,
                    51.5954372
                ],
                [
                    82.5879309,
                    51.5975877
                ],
                [
                    82.6037018,
                    51.589463
                ],
                [
                    82.6037018,
                    51.5828903
                ],
                [
                    82.5888925,
                    51.5797831
                ],
                [
                    82.5694673,
                    51.5820538
                ]
            ],
            "longitude": 82.5882543,
            "latitude": 51.5862894
        },
        "4815": {
            "name": "Тугозвоново",
            "population": 1441,
            "type": "village",
            "poly": [
                [
                    82.5764926,
                    52.0848347
                ],
                [
                    82.5869684,
                    52.0880436
                ],
                [
                    82.5915184,
                    52.0869951
                ],
                [
                    82.5957187,
                    52.0861005
                ],
                [
                    82.6041301,
                    52.0844128
                ],
                [
                    82.618378,
                    52.0845183
                ],
                [
                    82.6223262,
                    52.0717527
                ],
                [
                    82.5974353,
                    52.0666876
                ],
                [
                    82.5771793,
                    52.0747069
                ],
                [
                    82.5764926,
                    52.0848347
                ]
            ],
            "longitude": 82.600723,
            "latitude": 52.074799
        },
        "4816": {
            "name": "Шелаболиха",
            "population": 3780,
            "type": "village",
            "poly": [
                [
                    82.5830357,
                    53.4154586
                ],
                [
                    82.5883572,
                    53.4187325
                ],
                [
                    82.594022,
                    53.4241541
                ],
                [
                    82.5964253,
                    53.4246657
                ],
                [
                    82.5990002,
                    53.4250748
                ],
                [
                    82.6113598,
                    53.4199601
                ],
                [
                    82.6177113,
                    53.4204716
                ],
                [
                    82.6194279,
                    53.4195509
                ],
                [
                    82.6347058,
                    53.4197555
                ],
                [
                    82.6434605,
                    53.4200624
                ],
                [
                    82.6446621,
                    53.4151517
                ],
                [
                    82.6359073,
                    53.4063519
                ],
                [
                    82.6278393,
                    53.4029748
                ],
                [
                    82.6254359,
                    53.4028725
                ],
                [
                    82.6233761,
                    53.4009279
                ],
                [
                    82.606725,
                    53.4034865
                ],
                [
                    82.5993435,
                    53.4065566
                ],
                [
                    82.6022617,
                    53.4090125
                ],
                [
                    82.5964253,
                    53.4120822
                ],
                [
                    82.5892155,
                    53.4112637
                ],
                [
                    82.5830357,
                    53.4154586
                ]
            ],
            "longitude": 82.612091,
            "latitude": 53.414413
        },
        "4817": {
            "name": "Красный Яр",
            "population": 510,
            "type": "village",
            "poly": null,
            "longitude": 82.6167233,
            "latitude": 52.3859952
        },
        "4818": {
            "name": "Савинка",
            "population": 418,
            "type": "village",
            "poly": [
                [
                    82.5995183,
                    52.6506587
                ],
                [
                    82.6044965,
                    52.6564902
                ],
                [
                    82.6129079,
                    52.6586769
                ],
                [
                    82.6153111,
                    52.6620087
                ],
                [
                    82.6237225,
                    52.6618005
                ],
                [
                    82.6201176,
                    52.6550324
                ],
                [
                    82.6226925,
                    52.6534704
                ],
                [
                    82.6245808,
                    52.65472
                ],
                [
                    82.6259541,
                    52.6527413
                ],
                [
                    82.6333356,
                    52.653158
                ],
                [
                    82.6493001,
                    52.6499296
                ],
                [
                    82.6486134,
                    52.6460761
                ],
                [
                    82.6360822,
                    52.6477426
                ],
                [
                    82.6362538,
                    52.6494089
                ],
                [
                    82.6321339,
                    52.6496172
                ],
                [
                    82.6290439,
                    52.6481592
                ],
                [
                    82.6357388,
                    52.6422223
                ],
                [
                    82.6177144,
                    52.6346178
                ],
                [
                    82.6039815,
                    52.6462845
                ],
                [
                    82.6075864,
                    52.6493048
                ],
                [
                    82.6074147,
                    52.6498255
                ],
                [
                    82.6014066,
                    52.6486799
                ],
                [
                    82.5995183,
                    52.6506587
                ]
            ],
            "longitude": 82.6183513,
            "latitude": 52.6478576
        },
        "4819": {
            "name": "Орёл",
            "population": 196,
            "type": "village",
            "poly": [
                [
                    82.6100363,
                    53.1160257
                ],
                [
                    82.6144507,
                    53.1240186
                ],
                [
                    82.6156045,
                    53.1246809
                ],
                [
                    82.6171094,
                    53.1248615
                ],
                [
                    82.6190407,
                    53.1236875
                ],
                [
                    82.6202948,
                    53.1235069
                ],
                [
                    82.6208967,
                    53.1227242
                ],
                [
                    82.622828,
                    53.1222726
                ],
                [
                    82.6231792,
                    53.1217609
                ],
                [
                    82.6248595,
                    53.1220469
                ],
                [
                    82.6269414,
                    53.1221522
                ],
                [
                    82.6292991,
                    53.121505
                ],
                [
                    82.6314561,
                    53.1201804
                ],
                [
                    82.6326099,
                    53.1191869
                ],
                [
                    82.6337637,
                    53.1175762
                ],
                [
                    82.6343406,
                    53.1175612
                ],
                [
                    82.6354441,
                    53.1168687
                ],
                [
                    82.6342653,
                    53.1162665
                ],
                [
                    82.6341398,
                    53.1155138
                ],
                [
                    82.6322086,
                    53.1160407
                ],
                [
                    82.629249,
                    53.115875
                ],
                [
                    82.6281704,
                    53.115559
                ],
                [
                    82.6278193,
                    53.114731
                ],
                [
                    82.6267659,
                    53.1141439
                ],
                [
                    82.6282206,
                    53.1137826
                ],
                [
                    82.627443,
                    53.113346
                ],
                [
                    82.6285717,
                    53.1120362
                ],
                [
                    82.6270167,
                    53.1117351
                ],
                [
                    82.625587,
                    53.1117953
                ],
                [
                    82.6235805,
                    53.1110124
                ],
                [
                    82.6244583,
                    53.1101693
                ],
                [
                    82.6244082,
                    53.109567
                ],
                [
                    82.6236808,
                    53.109567
                ],
                [
                    82.6222511,
                    53.1081817
                ],
                [
                    82.6208215,
                    53.1085582
                ],
                [
                    82.61884,
                    53.1086034
                ],
                [
                    82.6190156,
                    53.1094917
                ],
                [
                    82.6183384,
                    53.1098983
                ],
                [
                    82.6178869,
                    53.1096574
                ],
                [
                    82.6166077,
                    53.1104101
                ],
                [
                    82.6150025,
                    53.1098832
                ],
                [
                    82.613021,
                    53.1107113
                ],
                [
                    82.6103373,
                    53.1121717
                ],
                [
                    82.6132719,
                    53.1136772
                ],
                [
                    82.6140243,
                    53.114445
                ],
                [
                    82.6132719,
                    53.1151074
                ],
                [
                    82.6123438,
                    53.1153633
                ],
                [
                    82.6110647,
                    53.1155741
                ],
                [
                    82.6100363,
                    53.1160257
                ]
            ],
            "longitude": 82.6213752,
            "latitude": 53.1139577
        },
        "4820": {
            "name": "Майский",
            "population": 85,
            "type": "village",
            "poly": [
                [
                    82.6224285,
                    53.0338421
                ],
                [
                    82.6225787,
                    53.035483
                ],
                [
                    82.6281614,
                    53.0376958
                ],
                [
                    82.6312156,
                    53.0383732
                ],
                [
                    82.6312156,
                    53.0388097
                ],
                [
                    82.6337441,
                    53.0395473
                ],
                [
                    82.6348206,
                    53.0395925
                ],
                [
                    82.6354715,
                    53.0386592
                ],
                [
                    82.63805,
                    53.0372141
                ],
                [
                    82.6400778,
                    53.0352271
                ],
                [
                    82.6407537,
                    53.0341432
                ],
                [
                    82.6407037,
                    53.0333002
                ],
                [
                    82.6396272,
                    53.0322915
                ],
                [
                    82.6366481,
                    53.0310871
                ],
                [
                    82.6351961,
                    53.0300332
                ],
                [
                    82.627135,
                    53.025953
                ],
                [
                    82.6263589,
                    53.025953
                ],
                [
                    82.625683,
                    53.0264197
                ],
                [
                    82.6265592,
                    53.0296869
                ],
                [
                    82.6243312,
                    53.0315086
                ],
                [
                    82.6233548,
                    53.0333604
                ],
                [
                    82.6224285,
                    53.0338421
                ]
            ],
            "longitude": 82.6315072,
            "latitude": 53.0325904
        },
        "4821": {
            "name": "Комариха",
            "population": 127,
            "type": "village",
            "poly": null,
            "longitude": 82.6499884,
            "latitude": 52.7227644
        },
        "4822": {
            "name": "Бориха",
            "population": 528,
            "type": "village",
            "poly": null,
            "longitude": 82.6525938,
            "latitude": 52.285835
        },
        "4823": {
            "name": "Иня",
            "population": 575,
            "type": "village",
            "poly": [
                [
                    82.6414741,
                    53.5052687
                ],
                [
                    82.6423588,
                    53.5062553
                ],
                [
                    82.6602753,
                    53.5112539
                ],
                [
                    82.6646992,
                    53.5154628
                ],
                [
                    82.6735468,
                    53.5157259
                ],
                [
                    82.6811779,
                    53.5068472
                ],
                [
                    82.6744316,
                    53.4986247
                ],
                [
                    82.6454555,
                    53.5014534
                ],
                [
                    82.6414741,
                    53.5052687
                ]
            ],
            "longitude": 82.6713317,
            "latitude": 53.5068885
        },
        "4824": {
            "name": "Урюпино",
            "population": 628,
            "type": "village",
            "poly": null,
            "longitude": 82.6846418,
            "latitude": 52.4180832
        },
        "4825": {
            "name": "Суетка",
            "population": 627,
            "type": "village",
            "poly": [
                [
                    82.672623,
                    51.4553454
                ],
                [
                    82.6772579,
                    51.4588752
                ],
                [
                    82.6861842,
                    51.4653992
                ],
                [
                    82.6956256,
                    51.4665755
                ],
                [
                    82.7031787,
                    51.4640089
                ],
                [
                    82.6966556,
                    51.461656
                ],
                [
                    82.6937047,
                    51.4604025
                ],
                [
                    82.6891025,
                    51.4584474
                ],
                [
                    82.6908191,
                    51.4547036
                ],
                [
                    82.6841242,
                    51.4496759
                ],
                [
                    82.6800044,
                    51.4504247
                ],
                [
                    82.672623,
                    51.4553454
                ]
            ],
            "longitude": 82.6846714,
            "latitude": 51.4597953
        },
        "4826": {
            "name": "Карпово Второе",
            "population": 1191,
            "type": "village",
            "poly": [
                [
                    82.6651763,
                    51.7212224
                ],
                [
                    82.6796074,
                    51.7289476
                ],
                [
                    82.6978454,
                    51.7211817
                ],
                [
                    82.7061463,
                    51.7163783
                ],
                [
                    82.7107985,
                    51.7082959
                ],
                [
                    82.6892709,
                    51.6977245
                ],
                [
                    82.6836153,
                    51.6998164
                ],
                [
                    82.6786896,
                    51.6977245
                ],
                [
                    82.6757706,
                    51.7001556
                ],
                [
                    82.6772914,
                    51.710405
                ],
                [
                    82.6651763,
                    51.7212224
                ]
            ],
            "longitude": 82.6858061,
            "latitude": 51.7162838
        },
        "4827": {
            "name": "Заветы Ильича",
            "population": 600,
            "type": "village",
            "poly": [
                [
                    82.6777959,
                    52.5075418
                ],
                [
                    82.6808858,
                    52.5110941
                ],
                [
                    82.6918721,
                    52.5165263
                ],
                [
                    82.7021718,
                    52.5083776
                ],
                [
                    82.6903271,
                    52.5032578
                ],
                [
                    82.6855206,
                    52.5059745
                ],
                [
                    82.683289,
                    52.5051386
                ],
                [
                    82.6777959,
                    52.5075418
                ]
            ],
            "longitude": 82.6893785,
            "latitude": 52.5092985
        },
        "4828": {
            "name": "Новообинцево",
            "population": 1021,
            "type": "village",
            "poly": [
                [
                    82.6814008,
                    53.4105474
                ],
                [
                    82.6851773,
                    53.4139239
                ],
                [
                    82.684834,
                    53.4150494
                ],
                [
                    82.6932454,
                    53.4196532
                ],
                [
                    82.6887822,
                    53.4208808
                ],
                [
                    82.6887822,
                    53.4222107
                ],
                [
                    82.7064633,
                    53.4219038
                ],
                [
                    82.7068065,
                    53.4210854
                ],
                [
                    82.7110982,
                    53.4204716
                ],
                [
                    82.7164197,
                    53.4155609
                ],
                [
                    82.7112698,
                    53.4091148
                ],
                [
                    82.7088665,
                    53.4083986
                ],
                [
                    82.7073216,
                    53.4098311
                ],
                [
                    82.6947902,
                    53.4051239
                ],
                [
                    82.6817441,
                    53.4096265
                ],
                [
                    82.6814008,
                    53.4105474
                ]
            ],
            "longitude": 82.697626,
            "latitude": 53.4135952
        },
        "4829": {
            "name": "Зимино",
            "population": 1076,
            "type": "village",
            "poly": [
                [
                    82.6814073,
                    52.9412737
                ],
                [
                    82.6823318,
                    52.9415898
                ],
                [
                    82.6829815,
                    52.942659
                ],
                [
                    82.6848055,
                    52.9432161
                ],
                [
                    82.6861297,
                    52.9440442
                ],
                [
                    82.6869543,
                    52.9449023
                ],
                [
                    82.6877538,
                    52.9454294
                ],
                [
                    82.6916517,
                    52.9471457
                ],
                [
                    82.6919266,
                    52.9486061
                ],
                [
                    82.6908272,
                    52.9509847
                ],
                [
                    82.6935507,
                    52.9523546
                ],
                [
                    82.6946001,
                    52.9534084
                ],
                [
                    82.6950498,
                    52.9547933
                ],
                [
                    82.6952497,
                    52.9586617
                ],
                [
                    82.6969488,
                    52.9594444
                ],
                [
                    82.6964241,
                    52.9607689
                ],
                [
                    82.6959743,
                    52.9625599
                ],
                [
                    82.694725,
                    52.963493
                ],
                [
                    82.6972986,
                    52.9648324
                ],
                [
                    82.6987478,
                    52.965314
                ],
                [
                    82.7013464,
                    52.9668489
                ],
                [
                    82.7029705,
                    52.9673455
                ],
                [
                    82.7044197,
                    52.9667286
                ],
                [
                    82.7050194,
                    52.9664878
                ],
                [
                    82.7113159,
                    52.9693169
                ],
                [
                    82.7113909,
                    52.9677067
                ],
                [
                    82.7131148,
                    52.9663824
                ],
                [
                    82.714764,
                    52.9649227
                ],
                [
                    82.7145641,
                    52.9636134
                ],
                [
                    82.7158135,
                    52.9616868
                ],
                [
                    82.7131399,
                    52.9597002
                ],
                [
                    82.71299,
                    52.9588574
                ],
                [
                    82.7126402,
                    52.957593
                ],
                [
                    82.7130899,
                    52.9565995
                ],
                [
                    82.7139645,
                    52.9554856
                ],
                [
                    82.7143892,
                    52.9542213
                ],
                [
                    82.7174126,
                    52.9539503
                ],
                [
                    82.7181372,
                    52.9529416
                ],
                [
                    82.7157635,
                    52.9517525
                ],
                [
                    82.7144642,
                    52.9507288
                ],
                [
                    82.7123154,
                    52.9506234
                ],
                [
                    82.7091171,
                    52.9495245
                ],
                [
                    82.7077678,
                    52.9478383
                ],
                [
                    82.7056191,
                    52.9478533
                ],
                [
                    82.7014214,
                    52.9454444
                ],
                [
                    82.6997223,
                    52.943472
                ],
                [
                    82.6932758,
                    52.9412135
                ],
                [
                    82.6921015,
                    52.9417254
                ],
                [
                    82.6917017,
                    52.941605
                ],
                [
                    82.6917517,
                    52.9406413
                ],
                [
                    82.6815572,
                    52.9404305
                ],
                [
                    82.6814073,
                    52.9412737
                ]
            ],
            "longitude": 82.70195,
            "latitude": 52.949436
        },
        "4830": {
            "name": "Самсоново",
            "population": 820,
            "type": "village",
            "poly": null,
            "longitude": 82.7028682,
            "latitude": 52.1286028
        },
        "4831": {
            "name": "Комариха",
            "population": 1002,
            "type": "village",
            "poly": [
                [
                    82.6830608,
                    51.9224151
                ],
                [
                    82.6926003,
                    51.9285826
                ],
                [
                    82.7084482,
                    51.9352236
                ],
                [
                    82.7227575,
                    51.9392078
                ],
                [
                    82.7453754,
                    51.9430018
                ],
                [
                    82.7509144,
                    51.9375003
                ],
                [
                    82.7466063,
                    51.9317135
                ],
                [
                    82.7144488,
                    51.9210866
                ],
                [
                    82.7144488,
                    51.9155822
                ],
                [
                    82.7082944,
                    51.9093181
                ],
                [
                    82.6978317,
                    51.9083689
                ],
                [
                    82.6856765,
                    51.9127351
                ],
                [
                    82.6830608,
                    51.9224151
                ]
            ],
            "longitude": 82.713547,
            "latitude": 51.929661
        },
        "4832": {
            "name": "Алейский",
            "population": 569,
            "type": "village",
            "poly": null,
            "longitude": 82.7281715,
            "latitude": 52.4700092
        },
        "4833": {
            "name": "Кировское",
            "population": 482,
            "type": "village",
            "poly": null,
            "longitude": 82.734802,
            "latitude": 52.73074
        },
        "4834": {
            "name": "Бурановка",
            "population": 827,
            "type": "village",
            "poly": [
                [
                    82.7211903,
                    53.2352687
                ],
                [
                    82.7216034,
                    53.235964
                ],
                [
                    82.7218829,
                    53.2365389
                ],
                [
                    82.7253875,
                    53.2376204
                ],
                [
                    82.7252597,
                    53.2385927
                ],
                [
                    82.7359926,
                    53.2433991
                ],
                [
                    82.7384203,
                    53.2450047
                ],
                [
                    82.7432391,
                    53.2508697
                ],
                [
                    82.7500293,
                    53.2534799
                ],
                [
                    82.7608717,
                    53.2570616
                ],
                [
                    82.7689944,
                    53.2561881
                ],
                [
                    82.7671509,
                    53.2555329
                ],
                [
                    82.7672056,
                    53.2550852
                ],
                [
                    82.7664025,
                    53.2549541
                ],
                [
                    82.7664207,
                    53.2544846
                ],
                [
                    82.7652343,
                    53.2531632
                ],
                [
                    82.7627883,
                    53.2529557
                ],
                [
                    82.7618939,
                    53.2509244
                ],
                [
                    82.7609813,
                    53.2509681
                ],
                [
                    82.7599226,
                    53.2509026
                ],
                [
                    82.7598678,
                    53.2505748
                ],
                [
                    82.759448,
                    53.2497231
                ],
                [
                    82.7575679,
                    53.2496357
                ],
                [
                    82.7549577,
                    53.2490787
                ],
                [
                    82.7467985,
                    53.2463155
                ],
                [
                    82.7461597,
                    53.2456929
                ],
                [
                    82.7418701,
                    53.2439125
                ],
                [
                    82.7429836,
                    53.2435084
                ],
                [
                    82.743878,
                    53.2428093
                ],
                [
                    82.7451922,
                    53.2432462
                ],
                [
                    82.7457398,
                    53.2426673
                ],
                [
                    82.7465795,
                    53.2428748
                ],
                [
                    82.747839,
                    53.2429076
                ],
                [
                    82.7486603,
                    53.2433445
                ],
                [
                    82.7490802,
                    53.2433882
                ],
                [
                    82.7502666,
                    53.2418588
                ],
                [
                    82.7486786,
                    53.2415968
                ],
                [
                    82.7486421,
                    53.2409304
                ],
                [
                    82.7437867,
                    53.2401112
                ],
                [
                    82.7427098,
                    53.238844
                ],
                [
                    82.7437137,
                    53.2381339
                ],
                [
                    82.7438598,
                    53.237544
                ],
                [
                    82.7417971,
                    53.2371616
                ],
                [
                    82.7414868,
                    53.2374457
                ],
                [
                    82.7334007,
                    53.2303987
                ],
                [
                    82.7263531,
                    53.2295362
                ],
                [
                    82.724701,
                    53.2308806
                ],
                [
                    82.7224294,
                    53.2334301
                ],
                [
                    82.7211903,
                    53.2352687
                ]
            ],
            "longitude": 82.7363862,
            "latitude": 53.2370229
        },
        "4835": {
            "name": "Парфёново",
            "population": 1763,
            "type": "village",
            "poly": null,
            "longitude": 82.737732,
            "latitude": 52.806805
        },
        "4836": {
            "name": "Малиновка",
            "population": 37,
            "type": "village",
            "poly": [
                [
                    82.7256893,
                    53.4186302
                ],
                [
                    82.7291226,
                    53.4205739
                ],
                [
                    82.7347874,
                    53.4190394
                ],
                [
                    82.7359891,
                    53.4194486
                ],
                [
                    82.7423405,
                    53.4177094
                ],
                [
                    82.7418256,
                    53.4164817
                ],
                [
                    82.7495503,
                    53.4114683
                ],
                [
                    82.7526402,
                    53.4111613
                ],
                [
                    82.7529835,
                    53.4081939
                ],
                [
                    82.7516103,
                    53.4079892
                ],
                [
                    82.7464604,
                    53.4042029
                ],
                [
                    82.7392506,
                    53.4045099
                ],
                [
                    82.7318692,
                    53.4138216
                ],
                [
                    82.726376,
                    53.4155609
                ],
                [
                    82.7256893,
                    53.4186302
                ]
            ],
            "longitude": 82.7430208,
            "latitude": 53.4099734
        },
        "4837": {
            "name": "Плотава",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 82.7620872,
            "latitude": 52.2880994
        },
        "4838": {
            "name": "Солнечный",
            "population": 839,
            "type": "village",
            "poly": null,
            "longitude": 82.7668712,
            "latitude": 52.5130899
        },
        "4839": {
            "name": "Лебяжье",
            "population": 1019,
            "type": "village",
            "poly": [
                [
                    82.7626081,
                    53.1852383
                ],
                [
                    82.7673262,
                    53.1874024
                ],
                [
                    82.7748821,
                    53.1905249
                ],
                [
                    82.7897274,
                    53.1970437
                ],
                [
                    82.7835381,
                    53.1882736
                ],
                [
                    82.7918879,
                    53.1828531
                ],
                [
                    82.7935022,
                    53.1807183
                ],
                [
                    82.8009335,
                    53.1697415
                ],
                [
                    82.8034663,
                    53.1690241
                ],
                [
                    82.8050805,
                    53.1662544
                ],
                [
                    82.8050527,
                    53.163885
                ],
                [
                    82.807001,
                    53.1605809
                ],
                [
                    82.8003212,
                    53.1554742
                ],
                [
                    82.8085596,
                    53.146344
                ],
                [
                    82.806834,
                    53.1458599
                ],
                [
                    82.8072515,
                    53.1453757
                ],
                [
                    82.806834,
                    53.1445912
                ],
                [
                    82.8077525,
                    53.1428049
                ],
                [
                    82.8072236,
                    53.1413023
                ],
                [
                    82.8081143,
                    53.1402505
                ],
                [
                    82.8078638,
                    53.1390651
                ],
                [
                    82.8083369,
                    53.1384641
                ],
                [
                    82.8082256,
                    53.1368779
                ],
                [
                    82.8072515,
                    53.1350579
                ],
                [
                    82.8058042,
                    53.1310002
                ],
                [
                    82.8054702,
                    53.1310503
                ],
                [
                    82.8049692,
                    53.1332879
                ],
                [
                    82.8059433,
                    53.1343065
                ],
                [
                    82.8055815,
                    53.1350913
                ],
                [
                    82.8045796,
                    53.1368779
                ],
                [
                    82.8043012,
                    53.1387479
                ],
                [
                    82.8038002,
                    53.1385475
                ],
                [
                    82.8024921,
                    53.139182
                ],
                [
                    82.8018241,
                    53.1389483
                ],
                [
                    82.8007108,
                    53.1378296
                ],
                [
                    82.7991244,
                    53.1388648
                ],
                [
                    82.7941702,
                    53.134106
                ],
                [
                    82.7934187,
                    53.1354084
                ],
                [
                    82.7939475,
                    53.1359094
                ],
                [
                    82.7955896,
                    53.136761
                ],
                [
                    82.7958123,
                    53.1377461
                ],
                [
                    82.7955896,
                    53.1383806
                ],
                [
                    82.7979554,
                    53.1415862
                ],
                [
                    82.7974823,
                    53.1421037
                ],
                [
                    82.7985677,
                    53.1436897
                ],
                [
                    82.7968421,
                    53.1443573
                ],
                [
                    82.7958401,
                    53.1439234
                ],
                [
                    82.7951721,
                    53.1429384
                ],
                [
                    82.795367,
                    53.1420535
                ],
                [
                    82.7951721,
                    53.1417531
                ],
                [
                    82.7943372,
                    53.1417197
                ],
                [
                    82.7927229,
                    53.1420869
                ],
                [
                    82.7916652,
                    53.1411354
                ],
                [
                    82.7909694,
                    53.1409851
                ],
                [
                    82.7894943,
                    53.1393156
                ],
                [
                    82.788381,
                    53.1383305
                ],
                [
                    82.7859596,
                    53.1371283
                ],
                [
                    82.7830372,
                    53.1377961
                ],
                [
                    82.777582,
                    53.1407848
                ],
                [
                    82.7718206,
                    53.1443241
                ],
                [
                    82.7748265,
                    53.1460769
                ],
                [
                    82.776747,
                    53.1481301
                ],
                [
                    82.7793911,
                    53.149983
                ],
                [
                    82.7788901,
                    53.1507174
                ],
                [
                    82.7794468,
                    53.1514685
                ],
                [
                    82.781228,
                    53.152253
                ],
                [
                    82.7812559,
                    53.153221
                ],
                [
                    82.7793633,
                    53.1555243
                ],
                [
                    82.7788066,
                    53.1561084
                ],
                [
                    82.7786674,
                    53.1579442
                ],
                [
                    82.7794746,
                    53.1591124
                ],
                [
                    82.7789736,
                    53.1612151
                ],
                [
                    82.7786396,
                    53.1617824
                ],
                [
                    82.7793633,
                    53.1656203
                ],
                [
                    82.7777768,
                    53.1714599
                ],
                [
                    82.7770253,
                    53.1727611
                ],
                [
                    82.7762182,
                    53.175814
                ],
                [
                    82.7750492,
                    53.1783497
                ],
                [
                    82.7745761,
                    53.1817357
                ],
                [
                    82.7727391,
                    53.182086
                ],
                [
                    82.7713475,
                    53.1819692
                ],
                [
                    82.7692044,
                    53.1827198
                ],
                [
                    82.7685364,
                    53.18312
                ],
                [
                    82.765586,
                    53.1837872
                ],
                [
                    82.764779,
                    53.1846045
                ],
                [
                    82.7626081,
                    53.1852383
                ]
            ],
            "longitude": 82.7818277,
            "latitude": 53.1840949
        },
        "4840": {
            "name": "Рогозиха",
            "population": 915,
            "type": "village",
            "poly": [
                [
                    82.7365558,
                    53.2141943
                ],
                [
                    82.7375215,
                    53.2156816
                ],
                [
                    82.7375728,
                    53.2187038
                ],
                [
                    82.7412468,
                    53.2201783
                ],
                [
                    82.7434348,
                    53.2228099
                ],
                [
                    82.7454256,
                    53.2244383
                ],
                [
                    82.7500182,
                    53.2257129
                ],
                [
                    82.7536844,
                    53.2276244
                ],
                [
                    82.7549656,
                    53.2275772
                ],
                [
                    82.7564438,
                    53.228828
                ],
                [
                    82.7572914,
                    53.2298309
                ],
                [
                    82.7594399,
                    53.2330283
                ],
                [
                    82.765294,
                    53.2361901
                ],
                [
                    82.7671074,
                    53.2367209
                ],
                [
                    82.7694333,
                    53.2385495
                ],
                [
                    82.7720548,
                    53.2394106
                ],
                [
                    82.7747946,
                    53.2405902
                ],
                [
                    82.7766671,
                    53.2435391
                ],
                [
                    82.7763517,
                    53.2451668
                ],
                [
                    82.7731979,
                    53.2479503
                ],
                [
                    82.7706553,
                    53.2482451
                ],
                [
                    82.7698078,
                    53.2487404
                ],
                [
                    82.7657671,
                    53.2495896
                ],
                [
                    82.7629681,
                    53.2500024
                ],
                [
                    82.759448,
                    53.2497231
                ],
                [
                    82.7598678,
                    53.2505748
                ],
                [
                    82.7599226,
                    53.2509026
                ],
                [
                    82.7609813,
                    53.2509681
                ],
                [
                    82.7618939,
                    53.2509244
                ],
                [
                    82.7627883,
                    53.2529557
                ],
                [
                    82.7652343,
                    53.2531632
                ],
                [
                    82.7664207,
                    53.2544846
                ],
                [
                    82.7664025,
                    53.2549541
                ],
                [
                    82.7672056,
                    53.2550852
                ],
                [
                    82.7671509,
                    53.2555329
                ],
                [
                    82.7689944,
                    53.2561881
                ],
                [
                    82.7608717,
                    53.2570616
                ],
                [
                    82.7683886,
                    53.2595067
                ],
                [
                    82.7745185,
                    53.2625959
                ],
                [
                    82.7887301,
                    53.2702351
                ],
                [
                    82.8147285,
                    53.2830348
                ],
                [
                    82.8140781,
                    53.2817267
                ],
                [
                    82.8150636,
                    53.2809371
                ],
                [
                    82.8176654,
                    53.2779908
                ],
                [
                    82.8190452,
                    53.2768476
                ],
                [
                    82.8177837,
                    53.2765411
                ],
                [
                    82.8180202,
                    53.2758811
                ],
                [
                    82.8190649,
                    53.2757632
                ],
                [
                    82.8201293,
                    53.2747614
                ],
                [
                    82.8213315,
                    53.2750678
                ],
                [
                    82.8219821,
                    53.2750207
                ],
                [
                    82.8227705,
                    53.2743606
                ],
                [
                    82.8208258,
                    53.273832
                ],
                [
                    82.8073764,
                    53.2701762
                ],
                [
                    82.8071793,
                    53.2676181
                ],
                [
                    82.8112275,
                    53.2684086
                ],
                [
                    82.811358,
                    53.2662035
                ],
                [
                    82.805563,
                    53.2646945
                ],
                [
                    82.8053531,
                    53.2634398
                ],
                [
                    82.8038876,
                    53.2634566
                ],
                [
                    82.8031977,
                    53.2620889
                ],
                [
                    82.803454,
                    53.2606504
                ],
                [
                    82.8058193,
                    53.2585871
                ],
                [
                    82.8097614,
                    53.2588701
                ],
                [
                    82.8149256,
                    53.2588701
                ],
                [
                    82.8169755,
                    53.2549435
                ],
                [
                    82.804952,
                    53.2503562
                ],
                [
                    82.8013251,
                    53.2489528
                ],
                [
                    82.7953923,
                    53.2459806
                ],
                [
                    82.792278,
                    53.2436807
                ],
                [
                    82.7893214,
                    53.2428196
                ],
                [
                    82.7876657,
                    53.2409677
                ],
                [
                    82.7864358,
                    53.2393892
                ],
                [
                    82.7800573,
                    53.2365204
                ],
                [
                    82.780095,
                    53.2354158
                ],
                [
                    82.7698669,
                    53.2306804
                ],
                [
                    82.7640917,
                    53.2270345
                ],
                [
                    82.759775,
                    53.2254651
                ],
                [
                    82.756503,
                    53.2234118
                ],
                [
                    82.7564636,
                    53.2229634
                ],
                [
                    82.7538618,
                    53.2214882
                ],
                [
                    82.7524229,
                    53.2200838
                ],
                [
                    82.7501365,
                    53.218526
                ],
                [
                    82.7472587,
                    53.2167674
                ],
                [
                    82.7448146,
                    53.2156698
                ],
                [
                    82.7404388,
                    53.2131203
                ],
                [
                    82.7365558,
                    53.2141943
                ]
            ],
            "longitude": 82.784126,
            "latitude": 53.254662
        },
        "4841": {
            "name": "Бугрышиха",
            "population": 74,
            "type": "village",
            "poly": null,
            "longitude": 82.7889648,
            "latitude": 51.2811463
        },
        "4842": {
            "name": "Ульяновский",
            "population": 248,
            "type": "village",
            "poly": null,
            "longitude": 82.8080126,
            "latitude": 52.8412213
        },
        "4843": {
            "name": "Усть-Порозиха",
            "population": 527,
            "type": "village",
            "poly": null,
            "longitude": 82.8243471,
            "latitude": 52.1287714
        },
        "4844": {
            "name": "Совхозный",
            "population": 549,
            "type": "village",
            "poly": [
                [
                    82.8176235,
                    52.3776718
                ],
                [
                    82.8215189,
                    52.3804832
                ],
                [
                    82.8261538,
                    52.3825789
                ],
                [
                    82.8227206,
                    52.3861413
                ],
                [
                    82.8246087,
                    52.3868747
                ],
                [
                    82.8266687,
                    52.3858269
                ],
                [
                    82.8325052,
                    52.3868747
                ],
                [
                    82.8364535,
                    52.3837315
                ],
                [
                    82.8398866,
                    52.3841506
                ],
                [
                    82.8408892,
                    52.3831481
                ],
                [
                    82.841775,
                    52.381531
                ],
                [
                    82.8346081,
                    52.3781203
                ],
                [
                    82.8315273,
                    52.3781491
                ],
                [
                    82.8306084,
                    52.3792782
                ],
                [
                    82.8210449,
                    52.3755572
                ],
                [
                    82.8176235,
                    52.3776718
                ]
            ],
            "longitude": 82.8306365,
            "latitude": 52.381906
        },
        "4845": {
            "name": "Вавилон",
            "population": 561,
            "type": "village",
            "poly": null,
            "longitude": 82.8479095,
            "latitude": 52.4762329
        },
        "4846": {
            "name": "Боровиково",
            "population": 350,
            "type": "village",
            "poly": [
                [
                    82.8310895,
                    53.4149471
                ],
                [
                    82.8360677,
                    53.415254
                ],
                [
                    82.8395009,
                    53.4167887
                ],
                [
                    82.8520322,
                    53.416891
                ],
                [
                    82.8544354,
                    53.4178117
                ],
                [
                    82.8626752,
                    53.4153563
                ],
                [
                    82.8638768,
                    53.4141286
                ],
                [
                    82.8504872,
                    53.4065566
                ],
                [
                    82.8427624,
                    53.4077846
                ],
                [
                    82.8420758,
                    53.4096265
                ],
                [
                    82.8401875,
                    53.4106497
                ],
                [
                    82.8379559,
                    53.4099335
                ],
                [
                    82.8312611,
                    53.4109567
                ],
                [
                    82.8310895,
                    53.4149471
                ]
            ],
            "longitude": 82.850487,
            "latitude": 53.412075
        },
        "4847": {
            "name": "Харлово",
            "population": 1254,
            "type": "village",
            "poly": [
                [
                    82.8424195,
                    51.6889163
                ],
                [
                    82.8437858,
                    51.6907578
                ],
                [
                    82.846183,
                    51.6942442
                ],
                [
                    82.8566017,
                    51.7006447
                ],
                [
                    82.8645126,
                    51.6971012
                ],
                [
                    82.8654648,
                    51.6972562
                ],
                [
                    82.8655063,
                    51.6972602
                ],
                [
                    82.8654763,
                    51.6972553
                ],
                [
                    82.8736404,
                    51.698587
                ],
                [
                    82.8841513,
                    51.6916147
                ],
                [
                    82.8694914,
                    51.6790389
                ],
                [
                    82.865619,
                    51.677095
                ],
                [
                    82.8658956,
                    51.6835551
                ],
                [
                    82.8634984,
                    51.6877851
                ],
                [
                    82.8575975,
                    51.6879566
                ],
                [
                    82.8528805,
                    51.6850532
                ],
                [
                    82.845705,
                    51.6886588
                ],
                [
                    82.8424195,
                    51.6889163
                ]
            ],
            "longitude": 82.8557954,
            "latitude": 51.6898971
        },
        "4848": {
            "name": "Кособоково",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 82.8574893,
            "latitude": 52.0558793
        },
        "4849": {
            "name": "Комсомольский",
            "population": 147,
            "type": "village",
            "poly": null,
            "longitude": 82.8586966,
            "latitude": 52.8086483
        },
        "4850": {
            "name": "Большепанюшево",
            "population": 507,
            "type": "village",
            "poly": null,
            "longitude": 82.8667916,
            "latitude": 52.5139286
        },
        "4851": {
            "name": "Ветёлки",
            "population": 286,
            "type": "village",
            "poly": null,
            "longitude": 82.8976825,
            "latitude": 52.2198367
        },
        "4852": {
            "name": "Колыванское",
            "population": 1449,
            "type": "village",
            "poly": [
                [
                    82.8612257,
                    53.0354116
                ],
                [
                    82.8634721,
                    53.0410224
                ],
                [
                    82.8712484,
                    53.0515149
                ],
                [
                    82.8833448,
                    53.0435159
                ],
                [
                    82.8961324,
                    53.0409184
                ],
                [
                    82.913413,
                    53.03936
                ],
                [
                    82.9156594,
                    53.0325019
                ],
                [
                    82.8980333,
                    53.0286568
                ],
                [
                    82.8855913,
                    53.0301118
                ],
                [
                    82.878679,
                    53.0316706
                ],
                [
                    82.8700388,
                    53.0303196
                ],
                [
                    82.8612257,
                    53.0354116
                ]
            ],
            "longitude": 82.900505,
            "latitude": 53.031132
        },
        "4853": {
            "name": "Лаврентьевка",
            "population": 174,
            "type": "village",
            "poly": null,
            "longitude": 82.9209787,
            "latitude": 52.8567057
        },
        "4854": {
            "name": "Арбузовка",
            "population": 868,
            "type": "village",
            "poly": [
                [
                    82.9048225,
                    53.099626
                ],
                [
                    82.9283241,
                    53.102946
                ],
                [
                    82.936204,
                    53.0942304
                ],
                [
                    82.928877,
                    53.0902455
                ],
                [
                    82.910214,
                    53.0894982
                ],
                [
                    82.9048225,
                    53.099626
                ]
            ],
            "longitude": 82.921051,
            "latitude": 53.095905
        },
        "4855": {
            "name": "Александровский",
            "population": 348,
            "type": "village",
            "poly": null,
            "longitude": 82.9307234,
            "latitude": 52.3869324
        },
        "4856": {
            "name": "Ракиты",
            "population": 192,
            "type": "village",
            "poly": null,
            "longitude": 82.9343749,
            "latitude": 52.9745295
        },
        "4857": {
            "name": "Усть-Белое",
            "population": 268,
            "type": "village",
            "poly": [
                [
                    82.9199057,
                    51.4654814
                ],
                [
                    82.9310607,
                    51.4705135
                ],
                [
                    82.9372153,
                    51.4678777
                ],
                [
                    82.9491397,
                    51.4624858
                ],
                [
                    82.9518323,
                    51.4597296
                ],
                [
                    82.9518323,
                    51.4562544
                ],
                [
                    82.9418312,
                    51.4537377
                ],
                [
                    82.9322147,
                    51.4542171
                ],
                [
                    82.9210596,
                    51.4614074
                ],
                [
                    82.9199057,
                    51.4654814
                ]
            ],
            "longitude": 82.9357501,
            "latitude": 51.4635336
        },
        "4858": {
            "name": "Бураново",
            "population": 308,
            "type": "village",
            "poly": null,
            "longitude": 82.9398326,
            "latitude": 52.0201353
        },
        "4859": {
            "name": "Маралиха",
            "population": 1677,
            "type": "village",
            "poly": [
                [
                    82.9210979,
                    51.6268493
                ],
                [
                    82.9261267,
                    51.6311903
                ],
                [
                    82.9304484,
                    51.6299222
                ],
                [
                    82.9353986,
                    51.6263615
                ],
                [
                    82.9369808,
                    51.6272965
                ],
                [
                    82.9407815,
                    51.6289529
                ],
                [
                    82.9473465,
                    51.6316076
                ],
                [
                    82.9501112,
                    51.6295536
                ],
                [
                    82.9493497,
                    51.6248183
                ],
                [
                    82.9635537,
                    51.6207638
                ],
                [
                    82.9698565,
                    51.6172977
                ],
                [
                    82.9478867,
                    51.6071215
                ],
                [
                    82.9432046,
                    51.6000751
                ],
                [
                    82.9361815,
                    51.5979498
                ],
                [
                    82.9323998,
                    51.5925802
                ],
                [
                    82.9343807,
                    51.5877693
                ],
                [
                    82.9325798,
                    51.5874337
                ],
                [
                    82.9269974,
                    51.587098
                ],
                [
                    82.9223154,
                    51.5893357
                ],
                [
                    82.9224954,
                    51.5942583
                ],
                [
                    82.9251966,
                    51.5963836
                ],
                [
                    82.9296986,
                    51.5968311
                ],
                [
                    82.9298787,
                    51.5989566
                ],
                [
                    82.9275377,
                    51.6011937
                ],
                [
                    82.9271775,
                    51.6044373
                ],
                [
                    82.9311393,
                    51.6164032
                ],
                [
                    82.9337126,
                    51.6200507
                ],
                [
                    82.9378021,
                    51.6210992
                ],
                [
                    82.9309983,
                    51.6215809
                ],
                [
                    82.9314699,
                    51.6236298
                ],
                [
                    82.9210979,
                    51.6268493
                ]
            ],
            "longitude": 82.942712,
            "latitude": 51.6109164
        },
        "4860": {
            "name": "Берёзовка",
            "population": 1318,
            "type": "village",
            "poly": [
                [
                    82.9247706,
                    51.8234606
                ],
                [
                    82.9336947,
                    51.830022
                ],
                [
                    82.9438497,
                    51.8395297
                ],
                [
                    82.9407724,
                    51.8420014
                ],
                [
                    82.9436958,
                    51.8499859
                ],
                [
                    82.9321561,
                    51.8516016
                ],
                [
                    82.9375413,
                    51.8571136
                ],
                [
                    82.9476963,
                    51.8613898
                ],
                [
                    82.9669291,
                    51.8654755
                ],
                [
                    82.9678523,
                    51.8578739
                ],
                [
                    82.9787766,
                    51.8547378
                ],
                [
                    82.9766225,
                    51.8487503
                ],
                [
                    82.9613901,
                    51.8395297
                ],
                [
                    82.9593899,
                    51.8323991
                ],
                [
                    82.9589283,
                    51.822985
                ],
                [
                    82.9420033,
                    51.8165177
                ],
                [
                    82.9247706,
                    51.8234606
                ]
            ],
            "longitude": 82.9573971,
            "latitude": 51.8458744
        },
        "4861": {
            "name": "Безголосово",
            "population": 592,
            "type": "village",
            "poly": null,
            "longitude": 82.9631537,
            "latitude": 52.5123801
        },
        "4862": {
            "name": "Крутиха",
            "population": 130,
            "type": "village",
            "poly": null,
            "longitude": 82.9678509,
            "latitude": 52.7103949
        },
        "4863": {
            "name": "Зелёный",
            "population": 366,
            "type": "village",
            "poly": null,
            "longitude": 82.979857,
            "latitude": 52.6842483
        },
        "4864": {
            "name": "Воробьёво",
            "population": 281,
            "type": "village",
            "poly": [
                [
                    82.9650839,
                    52.0717413
                ],
                [
                    82.9701198,
                    52.073471
                ],
                [
                    82.9718971,
                    52.0777496
                ],
                [
                    82.9853754,
                    52.0814815
                ],
                [
                    83.0007792,
                    52.0802983
                ],
                [
                    83.0021122,
                    52.0777496
                ],
                [
                    82.9901151,
                    52.0716502
                ],
                [
                    82.9870047,
                    52.0669157
                ],
                [
                    82.9798952,
                    52.0652769
                ],
                [
                    82.9681942,
                    52.0655501
                ],
                [
                    82.9656764,
                    52.0669157
                ],
                [
                    82.9650839,
                    52.0717413
                ]
            ],
            "longitude": 82.9808324,
            "latitude": 52.0676227
        },
        "4865": {
            "name": "Жуковка",
            "population": 278,
            "type": "village",
            "poly": [
                [
                    82.9724473,
                    53.1985897
                ],
                [
                    82.9732892,
                    53.2033188
                ],
                [
                    82.9743742,
                    53.2074871
                ],
                [
                    82.9755342,
                    53.2084507
                ],
                [
                    82.9836909,
                    53.2116998
                ],
                [
                    82.9840651,
                    53.2108708
                ],
                [
                    82.9856179,
                    53.2107587
                ],
                [
                    82.9858424,
                    53.2100977
                ],
                [
                    82.9862352,
                    53.2096832
                ],
                [
                    82.9871145,
                    53.2095151
                ],
                [
                    82.9871706,
                    53.209179
                ],
                [
                    82.9867404,
                    53.2090557
                ],
                [
                    82.9860482,
                    53.2089773
                ],
                [
                    82.9865346,
                    53.2079128
                ],
                [
                    82.988106,
                    53.2065794
                ],
                [
                    82.9881248,
                    53.2061201
                ],
                [
                    82.9877693,
                    53.2059072
                ],
                [
                    82.9866655,
                    53.2054366
                ],
                [
                    82.9865346,
                    53.2047419
                ],
                [
                    82.9858985,
                    53.2041816
                ],
                [
                    82.9856179,
                    53.2036886
                ],
                [
                    82.986497,
                    53.2031059
                ],
                [
                    82.9869648,
                    53.2019965
                ],
                [
                    82.9872829,
                    53.1999009
                ],
                [
                    82.9870958,
                    53.1991837
                ],
                [
                    82.9882557,
                    53.1983543
                ],
                [
                    82.9860856,
                    53.1980181
                ],
                [
                    82.9843457,
                    53.1981526
                ],
                [
                    82.9819511,
                    53.1972
                ],
                [
                    82.9797248,
                    53.1962025
                ],
                [
                    82.9765444,
                    53.195362
                ],
                [
                    82.9759832,
                    53.1956757
                ],
                [
                    82.9750104,
                    53.1967293
                ],
                [
                    82.9744117,
                    53.1969086
                ],
                [
                    82.973046,
                    53.1969422
                ],
                [
                    82.9724473,
                    53.1985897
                ]
            ],
            "longitude": 82.980927,
            "latitude": 53.204048
        },
        "4866": {
            "name": "Сидоровка",
            "population": 519,
            "type": "village",
            "poly": null,
            "longitude": 82.9896745,
            "latitude": 52.9963524
        },
        "4867": {
            "name": "Куйбышево",
            "population": 631,
            "type": "village",
            "poly": [
                [
                    82.9773828,
                    51.5618629
                ],
                [
                    82.9874013,
                    51.5673849
                ],
                [
                    82.997613,
                    51.5639394
                ],
                [
                    83.0029069,
                    51.5557114
                ],
                [
                    83.0085789,
                    51.5529684
                ],
                [
                    83.0112258,
                    51.5477955
                ],
                [
                    83.0039152,
                    51.5453655
                ],
                [
                    82.9983692,
                    51.5490495
                ],
                [
                    82.9942097,
                    51.5482658
                ],
                [
                    82.9899873,
                    51.5508523
                ],
                [
                    82.9915629,
                    51.5524982
                ],
                [
                    82.9773828,
                    51.5618629
                ]
            ],
            "longitude": 82.9961447,
            "latitude": 51.5544363
        },
        "4868": {
            "name": "Елунино",
            "population": 676,
            "type": "village",
            "poly": [
                [
                    82.9858519,
                    53.4411657
                ],
                [
                    82.9903151,
                    53.441728
                ],
                [
                    82.9910018,
                    53.442546
                ],
                [
                    82.9986407,
                    53.4432106
                ],
                [
                    83.0024173,
                    53.4446931
                ],
                [
                    83.0112578,
                    53.4428527
                ],
                [
                    83.0121161,
                    53.4350302
                ],
                [
                    83.0112578,
                    53.4293542
                ],
                [
                    83.0028464,
                    53.4288939
                ],
                [
                    83.0018165,
                    53.4320645
                ],
                [
                    82.9937484,
                    53.431144
                ],
                [
                    82.9929712,
                    53.4314605
                ],
                [
                    82.9869676,
                    53.4339053
                ],
                [
                    82.9860236,
                    53.4347746
                ],
                [
                    82.9858519,
                    53.4411657
                ]
            ],
            "longitude": 82.99897,
            "latitude": 53.439423
        },
        "4869": {
            "name": "Победим",
            "population": 814,
            "type": "village",
            "poly": null,
            "longitude": 83.003659,
            "latitude": 52.6632
        },
        "4870": {
            "name": "Сибирские Огни",
            "population": 1097,
            "type": "village",
            "poly": [
                [
                    83.0190685,
                    53.3063391
                ],
                [
                    83.0222679,
                    53.3080646
                ],
                [
                    83.0283967,
                    53.3136256
                ],
                [
                    83.0330505,
                    53.3164431
                ],
                [
                    83.0460353,
                    53.3238892
                ],
                [
                    83.0515201,
                    53.3208737
                ],
                [
                    83.0530575,
                    53.3218292
                ],
                [
                    83.0576073,
                    53.3190121
                ],
                [
                    83.0573788,
                    53.3186646
                ],
                [
                    83.0566516,
                    53.3182179
                ],
                [
                    83.0541378,
                    53.3180813
                ],
                [
                    83.0533068,
                    53.3184413
                ],
                [
                    83.0467001,
                    53.3174856
                ],
                [
                    83.0451419,
                    53.3165548
                ],
                [
                    83.0437707,
                    53.3151523
                ],
                [
                    83.0487984,
                    53.3054453
                ],
                [
                    83.0497749,
                    53.3052218
                ],
                [
                    83.0605367,
                    53.3075681
                ],
                [
                    83.0624273,
                    53.3046632
                ],
                [
                    83.0652735,
                    53.3045266
                ],
                [
                    83.0665824,
                    53.3038065
                ],
                [
                    83.0701974,
                    53.3030491
                ],
                [
                    83.076534,
                    53.3019567
                ],
                [
                    83.0769495,
                    53.3012241
                ],
                [
                    83.0763884,
                    53.3008268
                ],
                [
                    83.0762223,
                    53.3005039
                ],
                [
                    83.0717348,
                    53.3010503
                ],
                [
                    83.0683068,
                    53.3009262
                ],
                [
                    83.0473441,
                    53.3036699
                ],
                [
                    83.0469078,
                    53.3029871
                ],
                [
                    83.0450173,
                    53.302863
                ],
                [
                    83.0445187,
                    53.3020187
                ],
                [
                    83.0439577,
                    53.3018946
                ],
                [
                    83.0416307,
                    53.3001812
                ],
                [
                    83.0259037,
                    53.3036451
                ],
                [
                    83.0251765,
                    53.3029375
                ],
                [
                    83.0238884,
                    53.3034837
                ],
                [
                    83.0190685,
                    53.3063391
                ]
            ],
            "longitude": 83.027946,
            "latitude": 53.308922
        },
        "4871": {
            "name": "Фунтики",
            "population": 1225,
            "type": "village",
            "poly": null,
            "longitude": 83.0305231,
            "latitude": 52.7828241
        },
        "4872": {
            "name": "Колпаково",
            "population": 238,
            "type": "village",
            "poly": [
                [
                    83.0099948,
                    52.6111601
                ],
                [
                    83.0229017,
                    52.6304624
                ],
                [
                    83.0322408,
                    52.6340288
                ],
                [
                    83.0344444,
                    52.6368947
                ],
                [
                    83.0485056,
                    52.6320547
                ],
                [
                    83.0388517,
                    52.6193152
                ],
                [
                    83.0238461,
                    52.6153016
                ],
                [
                    83.0200684,
                    52.6058712
                ],
                [
                    83.0099948,
                    52.6111601
                ]
            ],
            "longitude": 83.031283,
            "latitude": 52.6230928
        },
        "4873": {
            "name": "Новобураново",
            "population": 738,
            "type": "village",
            "poly": [
                [
                    83.0237578,
                    51.944409
                ],
                [
                    83.0435508,
                    51.958004
                ],
                [
                    83.048179,
                    51.9569724
                ],
                [
                    83.05005,
                    51.9521174
                ],
                [
                    83.0505423,
                    51.9464121
                ],
                [
                    83.049853,
                    51.9404026
                ],
                [
                    83.0359684,
                    51.9366386
                ],
                [
                    83.0237578,
                    51.944409
                ]
            ],
            "longitude": 83.0375363,
            "latitude": 51.9442748
        },
        "4874": {
            "name": "Чаячье",
            "population": 116,
            "type": "village",
            "poly": null,
            "longitude": 83.0385643,
            "latitude": 53.0151296
        },
        "4875": {
            "name": "Макарьевка",
            "population": 560,
            "type": "village",
            "poly": null,
            "longitude": 83.041637,
            "latitude": 52.8698966
        },
        "4876": {
            "name": "Ларичиха",
            "population": 1960,
            "type": "village",
            "poly": [
                [
                    83.0176875,
                    53.7757859
                ],
                [
                    83.0188254,
                    53.7791316
                ],
                [
                    83.0337034,
                    53.7795106
                ],
                [
                    83.05384,
                    53.7801926
                ],
                [
                    83.065255,
                    53.7792074
                ],
                [
                    83.0608942,
                    53.7747357
                ],
                [
                    83.0515724,
                    53.7636765
                ],
                [
                    83.0370597,
                    53.7648022
                ],
                [
                    83.025108,
                    53.7671699
                ],
                [
                    83.02235,
                    53.7726424
                ],
                [
                    83.0176875,
                    53.7757859
                ]
            ],
            "longitude": 83.0422036,
            "latitude": 53.7748996
        },
        "4877": {
            "name": "Чинета",
            "population": 524,
            "type": "village",
            "poly": null,
            "longitude": 83.049416,
            "latitude": 51.335373
        },
        "4878": {
            "name": "Михайловка",
            "population": 175,
            "type": "village",
            "poly": null,
            "longitude": 83.0500522,
            "latitude": 52.8522329
        },
        "4879": {
            "name": "Дружба",
            "population": 489,
            "type": "village",
            "poly": null,
            "longitude": 83.0555404,
            "latitude": 52.6917649
        },
        "4880": {
            "name": "Переясловка",
            "population": 765,
            "type": "village",
            "poly": null,
            "longitude": 83.1030406,
            "latitude": 52.881204
        },
        "4881": {
            "name": "Кабаново",
            "population": 745,
            "type": "village",
            "poly": [
                [
                    83.097688,
                    52.0426118
                ],
                [
                    83.0978897,
                    52.0436661
                ],
                [
                    83.1005114,
                    52.0464259
                ],
                [
                    83.104444,
                    52.0489375
                ],
                [
                    83.1091833,
                    52.0497127
                ],
                [
                    83.1121579,
                    52.0491856
                ],
                [
                    83.1178048,
                    52.0489375
                ],
                [
                    83.1214853,
                    52.0494957
                ],
                [
                    83.1250857,
                    52.0480289
                ],
                [
                    83.1279169,
                    52.0457577
                ],
                [
                    83.1189313,
                    52.0411396
                ],
                [
                    83.1132691,
                    52.0384896
                ],
                [
                    83.1051434,
                    52.0333296
                ],
                [
                    83.1020744,
                    52.0370915
                ],
                [
                    83.1017719,
                    52.0393866
                ],
                [
                    83.1021752,
                    52.0409992
                ],
                [
                    83.1012676,
                    52.0414954
                ],
                [
                    83.0981922,
                    52.0415884
                ],
                [
                    83.097688,
                    52.0426118
                ]
            ],
            "longitude": 83.1095165,
            "latitude": 52.0449188
        },
        "4882": {
            "name": "Верх-Камышенка",
            "population": 1322,
            "type": "village",
            "poly": [
                [
                    83.0840233,
                    51.7875444
                ],
                [
                    83.1010054,
                    51.8022474
                ],
                [
                    83.1316934,
                    51.8177848
                ],
                [
                    83.1351266,
                    51.8194827
                ],
                [
                    83.1407914,
                    51.8226658
                ],
                [
                    83.1471429,
                    51.8237268
                ],
                [
                    83.1492552,
                    51.8225036
                ],
                [
                    83.1528601,
                    51.8201692
                ],
                [
                    83.1562409,
                    51.8185276
                ],
                [
                    83.1556067,
                    51.8167736
                ],
                [
                    83.1543527,
                    51.812691
                ],
                [
                    83.0915797,
                    51.7763754
                ],
                [
                    83.0840233,
                    51.7875444
                ]
            ],
            "longitude": 83.1103115,
            "latitude": 51.7897999
        },
        "4883": {
            "name": "Шипицино",
            "population": 293,
            "type": "village",
            "poly": null,
            "longitude": 83.1247709,
            "latitude": 53.6082804
        },
        "4884": {
            "name": "Усть-Козлуха",
            "population": 863,
            "type": "village",
            "poly": [
                [
                    83.1029781,
                    51.6330972
                ],
                [
                    83.1038364,
                    51.6420465
                ],
                [
                    83.1113895,
                    51.6491833
                ],
                [
                    83.1299289,
                    51.6495028
                ],
                [
                    83.1474384,
                    51.6505679
                ],
                [
                    83.1424602,
                    51.6444965
                ],
                [
                    83.1464084,
                    51.6383178
                ],
                [
                    83.1469234,
                    51.6297941
                ],
                [
                    83.1424602,
                    51.6192437
                ],
                [
                    83.1294139,
                    51.6166855
                ],
                [
                    83.1155093,
                    51.620949
                ],
                [
                    83.1029781,
                    51.6330972
                ]
            ],
            "longitude": 83.1274099,
            "latitude": 51.6304835
        },
        "4885": {
            "name": "Пономарёво",
            "population": 695,
            "type": "village",
            "poly": null,
            "longitude": 83.1573287,
            "latitude": 52.0728866
        },
        "4886": {
            "name": "Урожайный",
            "population": 463,
            "type": "village",
            "poly": [
                [
                    83.1537891,
                    53.2753159
                ],
                [
                    83.1548119,
                    53.2753378
                ],
                [
                    83.1559991,
                    53.2755453
                ],
                [
                    83.1555973,
                    53.2761132
                ],
                [
                    83.1554694,
                    53.2765501
                ],
                [
                    83.1559078,
                    53.2769651
                ],
                [
                    83.1566201,
                    53.2771507
                ],
                [
                    83.1568575,
                    53.2778386
                ],
                [
                    83.1574967,
                    53.2778933
                ],
                [
                    83.1582456,
                    53.2779152
                ],
                [
                    83.1587751,
                    53.2777186
                ],
                [
                    83.1594875,
                    53.2778278
                ],
                [
                    83.1604007,
                    53.277806
                ],
                [
                    83.1607843,
                    53.2777732
                ],
                [
                    83.1611496,
                    53.2779807
                ],
                [
                    83.1607112,
                    53.2782756
                ],
                [
                    83.159725,
                    53.2784612
                ],
                [
                    83.1580081,
                    53.2790728
                ],
                [
                    83.1579716,
                    53.2794441
                ],
                [
                    83.1583004,
                    53.2797498
                ],
                [
                    83.1598893,
                    53.2796297
                ],
                [
                    83.1605286,
                    53.2798372
                ],
                [
                    83.161113,
                    53.2797934
                ],
                [
                    83.1615879,
                    53.2801757
                ],
                [
                    83.163323,
                    53.2800119
                ],
                [
                    83.1644554,
                    53.2797498
                ],
                [
                    83.1661722,
                    53.2800447
                ],
                [
                    83.1674507,
                    53.2798153
                ],
                [
                    83.1684917,
                    53.2797826
                ],
                [
                    83.1706103,
                    53.2789963
                ],
                [
                    83.1703181,
                    53.2786141
                ],
                [
                    83.1690214,
                    53.2776312
                ],
                [
                    83.169624,
                    53.2773036
                ],
                [
                    83.1696606,
                    53.2759385
                ],
                [
                    83.1693684,
                    53.2755344
                ],
                [
                    83.1676698,
                    53.2751085
                ],
                [
                    83.1682359,
                    53.2741692
                ],
                [
                    83.1709208,
                    53.2734484
                ],
                [
                    83.1724002,
                    53.2727821
                ],
                [
                    83.1742997,
                    53.2721814
                ],
                [
                    83.1765279,
                    53.271122
                ],
                [
                    83.1785187,
                    53.2705103
                ],
                [
                    83.1791945,
                    53.2699532
                ],
                [
                    83.1741718,
                    53.2670805
                ],
                [
                    83.1671036,
                    53.2630604
                ],
                [
                    83.1663,
                    53.2635411
                ],
                [
                    83.1650763,
                    53.2638033
                ],
                [
                    83.1641083,
                    53.2648193
                ],
                [
                    83.1633595,
                    53.2650705
                ],
                [
                    83.1612409,
                    53.2644478
                ],
                [
                    83.158757,
                    53.2657696
                ],
                [
                    83.1577707,
                    53.2693634
                ],
                [
                    83.1552868,
                    53.2710455
                ],
                [
                    83.1560174,
                    53.2717227
                ],
                [
                    83.1556521,
                    53.2721159
                ],
                [
                    83.1539535,
                    53.2731753
                ],
                [
                    83.1538257,
                    53.2742348
                ],
                [
                    83.1540083,
                    53.2749337
                ],
                [
                    83.1537891,
                    53.2753159
                ]
            ],
            "longitude": 83.161057,
            "latitude": 53.275291
        },
        "4887": {
            "name": "Осколково",
            "population": 728,
            "type": "village",
            "poly": [
                [
                    83.1429983,
                    52.3175741
                ],
                [
                    83.1464048,
                    52.3301573
                ],
                [
                    83.1529219,
                    52.3391171
                ],
                [
                    83.1555879,
                    52.3399316
                ],
                [
                    83.1800266,
                    52.3333251
                ],
                [
                    83.1840256,
                    52.3221914
                ],
                [
                    83.1572171,
                    52.3125036
                ],
                [
                    83.1496634,
                    52.3110548
                ],
                [
                    83.1453681,
                    52.3123225
                ],
                [
                    83.1429983,
                    52.3175741
                ]
            ],
            "longitude": 83.1611173,
            "latitude": 52.3256929
        },
        "4888": {
            "name": "Толстая Дуброва",
            "population": 448,
            "type": "village",
            "poly": null,
            "longitude": 83.1630709,
            "latitude": 52.2601938
        },
        "4889": {
            "name": "Белояровка",
            "population": 733,
            "type": "village",
            "poly": null,
            "longitude": 83.1683219,
            "latitude": 52.7697566
        },
        "4890": {
            "name": "Кировский",
            "population": 1136,
            "type": "village",
            "poly": [
                [
                    83.1509778,
                    52.5442863
                ],
                [
                    83.1660044,
                    52.565774
                ],
                [
                    83.1864036,
                    52.5664374
                ],
                [
                    83.1850604,
                    52.5583745
                ],
                [
                    83.1795199,
                    52.5565882
                ],
                [
                    83.1626885,
                    52.5358235
                ],
                [
                    83.1509778,
                    52.5442863
                ]
            ],
            "longitude": 83.170204,
            "latitude": 52.554291
        },
        "4891": {
            "name": "Чернопятово",
            "population": 620,
            "type": "village",
            "poly": [
                [
                    83.1514095,
                    53.3796345
                ],
                [
                    83.1677174,
                    53.3970386
                ],
                [
                    83.1711507,
                    53.3989833
                ],
                [
                    83.1823086,
                    53.4039981
                ],
                [
                    83.1864285,
                    53.4056355
                ],
                [
                    83.1910634,
                    53.4023607
                ],
                [
                    83.1675458,
                    53.3863922
                ],
                [
                    83.1591344,
                    53.3770745
                ],
                [
                    83.1514095,
                    53.3796345
                ]
            ],
            "longitude": 83.1733655,
            "latitude": 53.3979724
        },
        "4892": {
            "name": "Зимино",
            "population": 448,
            "type": "village",
            "poly": null,
            "longitude": 83.1787498,
            "latitude": 52.6321005
        },
        "4893": {
            "name": "Язово",
            "population": 294,
            "type": "village",
            "poly": [
                [
                    83.1543607,
                    53.583577
                ],
                [
                    83.1706183,
                    53.5925708
                ],
                [
                    83.1661945,
                    53.5975592
                ],
                [
                    83.1745997,
                    53.6014971
                ],
                [
                    83.1853275,
                    53.5981499
                ],
                [
                    83.193401,
                    53.6007752
                ],
                [
                    83.2002579,
                    53.5960497
                ],
                [
                    83.198599,
                    53.5927677
                ],
                [
                    83.1682958,
                    53.574647
                ],
                [
                    83.1543607,
                    53.583577
                ]
            ],
            "longitude": 83.1807098,
            "latitude": 53.592181
        },
        "4894": {
            "name": "Степной",
            "population": 164,
            "type": "village",
            "poly": null,
            "longitude": 83.1928737,
            "latitude": 52.158815
        },
        "4895": {
            "name": "Усть-Камышенка",
            "population": 430,
            "type": "village",
            "poly": null,
            "longitude": 83.1973426,
            "latitude": 52.0545191
        },
        "4896": {
            "name": "Усть-Чумыш",
            "population": 71,
            "type": "village",
            "poly": null,
            "longitude": 83.1975719,
            "latitude": 53.5627525
        },
        "4897": {
            "name": "Ельцовка",
            "population": 242,
            "type": "village",
            "poly": null,
            "longitude": 83.1990277,
            "latitude": 51.9613553
        },
        "4898": {
            "name": "Усть-Пустынка",
            "population": 369,
            "type": "village",
            "poly": [
                [
                    83.1942612,
                    51.4648343
                ],
                [
                    83.1946552,
                    51.4679261
                ],
                [
                    83.1964671,
                    51.4717538
                ],
                [
                    83.2029269,
                    51.4772984
                ],
                [
                    83.1988305,
                    51.4803894
                ],
                [
                    83.2036359,
                    51.4826462
                ],
                [
                    83.2064719,
                    51.4835292
                ],
                [
                    83.2087565,
                    51.4831858
                ],
                [
                    83.2122227,
                    51.4787704
                ],
                [
                    83.2056054,
                    51.4718519
                ],
                [
                    83.2017452,
                    51.4655704
                ],
                [
                    83.1942612,
                    51.4648343
                ]
            ],
            "longitude": 83.2023475,
            "latitude": 51.4727383
        },
        "4899": {
            "name": "Чистюнька",
            "population": 1226,
            "type": "village",
            "poly": [
                [
                    83.1837965,
                    52.6834018
                ],
                [
                    83.1932826,
                    52.6864551
                ],
                [
                    83.2008379,
                    52.6843687
                ],
                [
                    83.2146052,
                    52.6891521
                ],
                [
                    83.2193063,
                    52.6866587
                ],
                [
                    83.2238394,
                    52.6876255
                ],
                [
                    83.2282047,
                    52.6862516
                ],
                [
                    83.2321502,
                    52.6808572
                ],
                [
                    83.2189705,
                    52.6737825
                ],
                [
                    83.206966,
                    52.6738843
                ],
                [
                    83.2026847,
                    52.6755131
                ],
                [
                    83.1871545,
                    52.6766838
                ],
                [
                    83.1837965,
                    52.6834018
                ]
            ],
            "longitude": 83.2108276,
            "latitude": 52.680959
        },
        "4900": {
            "name": "Труд",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 83.2197864,
            "latitude": 52.8773322
        },
        "4901": {
            "name": "Шишкино",
            "population": 531,
            "type": "village",
            "poly": [
                [
                    83.2104369,
                    53.634534
                ],
                [
                    83.2159283,
                    53.6403699
                ],
                [
                    83.2185106,
                    53.6431139
                ],
                [
                    83.2212526,
                    53.6440168
                ],
                [
                    83.2281584,
                    53.6417592
                ],
                [
                    83.2301387,
                    53.6428129
                ],
                [
                    83.2385957,
                    53.6422468
                ],
                [
                    83.2309225,
                    53.638057
                ],
                [
                    83.2301387,
                    53.6352867
                ],
                [
                    83.2300372,
                    53.6311618
                ],
                [
                    83.2297325,
                    53.6285421
                ],
                [
                    83.2257209,
                    53.6259524
                ],
                [
                    83.2233853,
                    53.6245369
                ],
                [
                    83.2234868,
                    53.6222783
                ],
                [
                    83.2214049,
                    53.6198087
                ],
                [
                    83.2147022,
                    53.623754
                ],
                [
                    83.212925,
                    53.6276689
                ],
                [
                    83.2154131,
                    53.6300477
                ],
                [
                    83.2104369,
                    53.634534
                ]
            ],
            "longitude": 83.2215519,
            "latitude": 53.6368682
        },
        "4902": {
            "name": "Черёмное",
            "population": 4624,
            "type": "village",
            "poly": [
                [
                    83.1528871,
                    53.1481547
                ],
                [
                    83.1904206,
                    53.1611272
                ],
                [
                    83.2113882,
                    53.1683724
                ],
                [
                    83.2085896,
                    53.1689516
                ],
                [
                    83.2073902,
                    53.1699302
                ],
                [
                    83.2069238,
                    53.1709887
                ],
                [
                    83.2086229,
                    53.1716478
                ],
                [
                    83.2113882,
                    53.1729059
                ],
                [
                    83.2094225,
                    53.1753621
                ],
                [
                    83.2121545,
                    53.1776385
                ],
                [
                    83.2196175,
                    53.1816719
                ],
                [
                    83.2189845,
                    53.1824505
                ],
                [
                    83.2293793,
                    53.1853854
                ],
                [
                    83.2345767,
                    53.1853854
                ],
                [
                    83.2370754,
                    53.1838282
                ],
                [
                    83.2384747,
                    53.182211
                ],
                [
                    83.2395409,
                    53.182191
                ],
                [
                    83.2416065,
                    53.1757016
                ],
                [
                    83.2430724,
                    53.1712483
                ],
                [
                    83.2391411,
                    53.1663152
                ],
                [
                    83.2334772,
                    53.1611618
                ],
                [
                    83.2329167,
                    53.1609351
                ],
                [
                    83.2259366,
                    53.1580913
                ],
                [
                    83.2149276,
                    53.1533236
                ],
                [
                    83.1963273,
                    53.1473685
                ],
                [
                    83.1892398,
                    53.1479943
                ],
                [
                    83.1869373,
                    53.1476706
                ],
                [
                    83.1856781,
                    53.1495047
                ],
                [
                    83.171575,
                    53.1487495
                ],
                [
                    83.1685529,
                    53.1478433
                ],
                [
                    83.1666821,
                    53.1482748
                ],
                [
                    83.1658186,
                    53.1477569
                ],
                [
                    83.1584793,
                    53.1470233
                ],
                [
                    83.1572201,
                    53.147347
                ],
                [
                    83.1563206,
                    53.1471312
                ],
                [
                    83.1558695,
                    53.147507
                ],
                [
                    83.1528871,
                    53.1481547
                ]
            ],
            "longitude": 83.231209,
            "latitude": 53.172653
        },
        "4903": {
            "name": "Прутской",
            "population": 2534,
            "type": "village",
            "poly": [
                [
                    83.2150511,
                    53.3169987
                ],
                [
                    83.2188438,
                    53.3182979
                ],
                [
                    83.2253683,
                    53.3199615
                ],
                [
                    83.226774,
                    53.3198031
                ],
                [
                    83.233272,
                    53.3220686
                ],
                [
                    83.2349165,
                    53.3222112
                ],
                [
                    83.2362956,
                    53.3227973
                ],
                [
                    83.2388682,
                    53.3219735
                ],
                [
                    83.2392662,
                    53.3209913
                ],
                [
                    83.2342534,
                    53.3180127
                ],
                [
                    83.2345717,
                    53.3175533
                ],
                [
                    83.2353143,
                    53.3172681
                ],
                [
                    83.2383113,
                    53.3177434
                ],
                [
                    83.2406453,
                    53.3169591
                ],
                [
                    83.2418588,
                    53.3163725
                ],
                [
                    83.2431384,
                    53.3150023
                ],
                [
                    83.2439076,
                    53.3143685
                ],
                [
                    83.2457509,
                    53.3143685
                ],
                [
                    83.2491591,
                    53.3128156
                ],
                [
                    83.2486684,
                    53.3118094
                ],
                [
                    83.252429,
                    53.3103364
                ],
                [
                    83.2501393,
                    53.3099684
                ],
                [
                    83.2473687,
                    53.308497
                ],
                [
                    83.2412693,
                    53.3079682
                ],
                [
                    83.2366516,
                    53.3067495
                ],
                [
                    83.23061,
                    53.3059792
                ],
                [
                    83.2386334,
                    53.296424
                ],
                [
                    83.2377675,
                    53.2963894
                ],
                [
                    83.2364207,
                    53.2959641
                ],
                [
                    83.2351893,
                    53.2961481
                ],
                [
                    83.2348814,
                    53.296539
                ],
                [
                    83.2344197,
                    53.2969645
                ],
                [
                    83.2268965,
                    53.301886
                ],
                [
                    83.2227982,
                    53.3038522
                ],
                [
                    83.2156985,
                    53.3059447
                ],
                [
                    83.2176032,
                    53.3070139
                ],
                [
                    83.2170645,
                    53.3078531
                ],
                [
                    83.2157194,
                    53.3099958
                ],
                [
                    83.2150511,
                    53.3169987
                ]
            ],
            "longitude": 83.231331,
            "latitude": 53.312016
        },
        "4904": {
            "name": "Шилово",
            "population": 418,
            "type": "village",
            "poly": null,
            "longitude": 83.2559123,
            "latitude": 52.9301492
        },
        "4905": {
            "name": "Новошипуново",
            "population": 1177,
            "type": "village",
            "poly": [
                [
                    83.2358772,
                    51.6817994
                ],
                [
                    83.2406481,
                    51.6892717
                ],
                [
                    83.2473021,
                    51.6881043
                ],
                [
                    83.2513197,
                    51.6907505
                ],
                [
                    83.247208,
                    51.6965629
                ],
                [
                    83.2511314,
                    51.6989947
                ],
                [
                    83.2501348,
                    51.7022384
                ],
                [
                    83.2697675,
                    51.7141902
                ],
                [
                    83.2766334,
                    51.7073832
                ],
                [
                    83.263749,
                    51.7011005
                ],
                [
                    83.2725374,
                    51.6990774
                ],
                [
                    83.2809492,
                    51.681488
                ],
                [
                    83.271533,
                    51.680476
                ],
                [
                    83.2629957,
                    51.6879486
                ],
                [
                    83.249562,
                    51.677362
                ],
                [
                    83.2358772,
                    51.6817994
                ]
            ],
            "longitude": 83.257103,
            "latitude": 51.694641
        },
        "4906": {
            "name": "Топольный",
            "population": 340,
            "type": "village",
            "poly": null,
            "longitude": 83.2598933,
            "latitude": 52.4660004
        },
        "4907": {
            "name": "Сараи",
            "population": 410,
            "type": "village",
            "poly": [
                [
                    83.2447051,
                    53.1810464
                ],
                [
                    83.2530636,
                    53.1848719
                ],
                [
                    83.2520073,
                    53.18567
                ],
                [
                    83.2568524,
                    53.1893162
                ],
                [
                    83.2727886,
                    53.1958924
                ],
                [
                    83.2763427,
                    53.1959819
                ],
                [
                    83.2805944,
                    53.1955683
                ],
                [
                    83.2824288,
                    53.195244
                ],
                [
                    83.2825792,
                    53.1936766
                ],
                [
                    83.2860676,
                    53.1899469
                ],
                [
                    83.288714,
                    53.1896946
                ],
                [
                    83.2927738,
                    53.1894965
                ],
                [
                    83.2815834,
                    53.1884356
                ],
                [
                    83.2735234,
                    53.1877477
                ],
                [
                    83.2716863,
                    53.1835234
                ],
                [
                    83.2647516,
                    53.1818721
                ],
                [
                    83.2627308,
                    53.1825602
                ],
                [
                    83.2605265,
                    53.1842527
                ],
                [
                    83.2464043,
                    53.1781427
                ],
                [
                    83.2459221,
                    53.1784455
                ],
                [
                    83.2464962,
                    53.1798905
                ],
                [
                    83.2447051,
                    53.1810464
                ]
            ],
            "longitude": 83.262833,
            "latitude": 53.187981
        },
        "4908": {
            "name": "Барсуково",
            "population": 49,
            "type": "village",
            "poly": null,
            "longitude": 83.2770707,
            "latitude": 53.4999006
        },
        "4909": {
            "name": "Казанцево",
            "population": 307,
            "type": "village",
            "poly": null,
            "longitude": 83.287827,
            "latitude": 54.024975
        },
        "4910": {
            "name": "Чарышское",
            "population": 1481,
            "type": "village",
            "poly": null,
            "longitude": 83.3047963,
            "latitude": 52.1561477
        },
        "4911": {
            "name": "Усть-Калманка",
            "population": 6371,
            "type": "village",
            "poly": [
                [
                    83.2797731,
                    52.1339066
                ],
                [
                    83.2902892,
                    52.141361
                ],
                [
                    83.3019901,
                    52.1401793
                ],
                [
                    83.3099882,
                    52.1362703
                ],
                [
                    83.3175349,
                    52.1359533
                ],
                [
                    83.3282275,
                    52.1260844
                ],
                [
                    83.3286066,
                    52.1232909
                ],
                [
                    83.3271658,
                    52.1206835
                ],
                [
                    83.3170041,
                    52.1059209
                ],
                [
                    83.2966581,
                    52.1148105
                ],
                [
                    83.2880675,
                    52.1302699
                ],
                [
                    83.2805137,
                    52.131361
                ],
                [
                    83.2797731,
                    52.1339066
                ]
            ],
            "longitude": 83.307526,
            "latitude": 52.124252
        },
        "4912": {
            "name": "Новотроенка",
            "population": 140,
            "type": "village",
            "poly": null,
            "longitude": 83.3232296,
            "latitude": 51.8407806
        },
        "4913": {
            "name": "Курочкино",
            "population": 740,
            "type": "village",
            "poly": [
                [
                    83.3101325,
                    53.857334
                ],
                [
                    83.3185824,
                    53.8678247
                ],
                [
                    83.3136904,
                    53.8746422
                ],
                [
                    83.3187306,
                    53.8811965
                ],
                [
                    83.3326655,
                    53.8818082
                ],
                [
                    83.3458591,
                    53.8655519
                ],
                [
                    83.3176929,
                    53.8499015
                ],
                [
                    83.3101325,
                    53.857334
                ]
            ],
            "longitude": 83.3271122,
            "latitude": 53.8728968
        },
        "4914": {
            "name": "Зайцево",
            "population": 732,
            "type": "village",
            "poly": [
                [
                    83.2998582,
                    53.6848724
                ],
                [
                    83.3088441,
                    53.6942866
                ],
                [
                    83.3247422,
                    53.6994431
                ],
                [
                    83.3345575,
                    53.6949415
                ],
                [
                    83.329166,
                    53.6793866
                ],
                [
                    83.3082911,
                    53.6720165
                ],
                [
                    83.2998582,
                    53.6848724
                ]
            ],
            "longitude": 83.3286164,
            "latitude": 53.6888581
        },
        "4915": {
            "name": "Новоеловка",
            "population": 449,
            "type": "village",
            "poly": null,
            "longitude": 83.3311876,
            "latitude": 53.9072009
        },
        "4916": {
            "name": "Стуково",
            "population": 1222,
            "type": "village",
            "poly": [
                [
                    83.2763427,
                    53.1959819
                ],
                [
                    83.2947927,
                    53.2002882
                ],
                [
                    83.316359,
                    53.2052226
                ],
                [
                    83.3289589,
                    53.2102163
                ],
                [
                    83.3275017,
                    53.2112258
                ],
                [
                    83.3265875,
                    53.21203
                ],
                [
                    83.3308732,
                    53.2140318
                ],
                [
                    83.3313589,
                    53.2146135
                ],
                [
                    83.3313875,
                    53.2154347
                ],
                [
                    83.3375874,
                    53.2184458
                ],
                [
                    83.3354731,
                    53.2204472
                ],
                [
                    83.3331302,
                    53.2199511
                ],
                [
                    83.3323017,
                    53.2201565
                ],
                [
                    83.3298446,
                    53.2239882
                ],
                [
                    83.3285589,
                    53.223954
                ],
                [
                    83.3280161,
                    53.2241763
                ],
                [
                    83.3282161,
                    53.2248262
                ],
                [
                    83.3299589,
                    53.224946
                ],
                [
                    83.3332731,
                    53.2255447
                ],
                [
                    83.335016,
                    53.2260064
                ],
                [
                    83.336073,
                    53.2267933
                ],
                [
                    83.3373302,
                    53.2268618
                ],
                [
                    83.3362445,
                    53.2276656
                ],
                [
                    83.3381588,
                    53.2287774
                ],
                [
                    83.3405016,
                    53.2288971
                ],
                [
                    83.3419016,
                    53.2284182
                ],
                [
                    83.3416445,
                    53.227734
                ],
                [
                    83.3428159,
                    53.2262973
                ],
                [
                    83.3434444,
                    53.2243645
                ],
                [
                    83.343473,
                    53.2232698
                ],
                [
                    83.3438444,
                    53.2221065
                ],
                [
                    83.343473,
                    53.2206868
                ],
                [
                    83.3437016,
                    53.2194209
                ],
                [
                    83.3653694,
                    53.2238443
                ],
                [
                    83.3736093,
                    53.2155616
                ],
                [
                    83.3497615,
                    53.2071331
                ],
                [
                    83.3457319,
                    53.2047376
                ],
                [
                    83.3428148,
                    53.2019456
                ],
                [
                    83.3401985,
                    53.1987571
                ],
                [
                    83.3344546,
                    53.1982525
                ],
                [
                    83.32841,
                    53.1987931
                ],
                [
                    83.3197791,
                    53.1948116
                ],
                [
                    83.3082011,
                    53.1918208
                ],
                [
                    83.2927738,
                    53.1894965
                ],
                [
                    83.288714,
                    53.1896946
                ],
                [
                    83.2860676,
                    53.1899469
                ],
                [
                    83.2825792,
                    53.1936766
                ],
                [
                    83.2824288,
                    53.195244
                ],
                [
                    83.2805944,
                    53.1955683
                ],
                [
                    83.2763427,
                    53.1959819
                ]
            ],
            "longitude": 83.337654,
            "latitude": 53.208199
        },
        "4917": {
            "name": "Речкуново",
            "population": 294,
            "type": "village",
            "poly": null,
            "longitude": 83.3396013,
            "latitude": 53.4975939
        },
        "4918": {
            "name": "Кубанка",
            "population": 474,
            "type": "village",
            "poly": [
                [
                    83.3403869,
                    52.8228147
                ],
                [
                    83.3446785,
                    52.8237483
                ],
                [
                    83.3487983,
                    52.8258228
                ],
                [
                    83.3462234,
                    52.8281047
                ],
                [
                    83.3508583,
                    52.8314236
                ],
                [
                    83.3561798,
                    52.8314236
                ],
                [
                    83.3604713,
                    52.8296605
                ],
                [
                    83.3645912,
                    52.829453
                ],
                [
                    83.3666511,
                    52.8310088
                ],
                [
                    83.3723159,
                    52.8299716
                ],
                [
                    83.3748909,
                    52.827275
                ],
                [
                    83.3726593,
                    52.8247856
                ],
                [
                    83.3668228,
                    52.8226073
                ],
                [
                    83.3597847,
                    52.8182503
                ],
                [
                    83.3491417,
                    52.8162791
                ],
                [
                    83.3427902,
                    52.8192876
                ],
                [
                    83.3403869,
                    52.8228147
                ]
            ],
            "longitude": 83.35717,
            "latitude": 52.824207
        },
        "4919": {
            "name": "Панфилово",
            "population": 329,
            "type": "village",
            "poly": null,
            "longitude": 83.3621789,
            "latitude": 53.1510434
        },
        "4920": {
            "name": "Новокалманка",
            "population": 840,
            "type": "village",
            "poly": null,
            "longitude": 83.3641674,
            "latitude": 51.9552251
        },
        "4921": {
            "name": "Шахи",
            "population": 1745,
            "type": "village",
            "poly": [
                [
                    83.3481417,
                    53.3358582
                ],
                [
                    83.3494609,
                    53.3368162
                ],
                [
                    83.3519567,
                    53.3358582
                ],
                [
                    83.3534899,
                    53.3359966
                ],
                [
                    83.3547734,
                    53.3374549
                ],
                [
                    83.3553261,
                    53.3390622
                ],
                [
                    83.3548804,
                    53.340265
                ],
                [
                    83.355433,
                    53.3411378
                ],
                [
                    83.3574297,
                    53.3436178
                ],
                [
                    83.3589807,
                    53.3437561
                ],
                [
                    83.3617974,
                    53.3447885
                ],
                [
                    83.3635267,
                    53.3458741
                ],
                [
                    83.3653985,
                    53.347662
                ],
                [
                    83.3676448,
                    53.3488007
                ],
                [
                    83.3676804,
                    53.3480451
                ],
                [
                    83.3687501,
                    53.3473214
                ],
                [
                    83.3714242,
                    53.3460869
                ],
                [
                    83.3740091,
                    53.3452781
                ],
                [
                    83.3753462,
                    53.3435858
                ],
                [
                    83.3765584,
                    53.3420532
                ],
                [
                    83.3781273,
                    53.3423406
                ],
                [
                    83.3783412,
                    53.3418829
                ],
                [
                    83.3796069,
                    53.342
                ],
                [
                    83.3812649,
                    53.3385407
                ],
                [
                    83.3797317,
                    53.3380829
                ],
                [
                    83.38073,
                    53.336944
                ],
                [
                    83.378769,
                    53.3346872
                ],
                [
                    83.3787334,
                    53.3344743
                ],
                [
                    83.3739378,
                    53.3330584
                ],
                [
                    83.375988,
                    53.3318874
                ],
                [
                    83.3555757,
                    53.3266385
                ],
                [
                    83.3549695,
                    53.3273625
                ],
                [
                    83.3525094,
                    53.3320577
                ],
                [
                    83.3500314,
                    53.33292
                ],
                [
                    83.3481417,
                    53.3358582
                ]
            ],
            "longitude": 83.36454,
            "latitude": 53.335144
        },
        "4922": {
            "name": "Романово",
            "population": 266,
            "type": "village",
            "poly": null,
            "longitude": 83.3648374,
            "latitude": 52.4166674
        },
        "4923": {
            "name": "Маралиха",
            "population": 1124,
            "type": "village",
            "poly": null,
            "longitude": 83.3654831,
            "latitude": 51.6980393
        },
        "4924": {
            "name": "Новый Чарыш",
            "population": 315,
            "type": "village",
            "poly": null,
            "longitude": 83.3664342,
            "latitude": 52.1749125
        },
        "4925": {
            "name": "Новороманово",
            "population": 3144,
            "type": "village",
            "poly": [
                [
                    83.3555162,
                    53.0838058
                ],
                [
                    83.3566705,
                    53.0955905
                ],
                [
                    83.3597135,
                    53.1015131
                ],
                [
                    83.3575099,
                    53.1044741
                ],
                [
                    83.3631764,
                    53.1103955
                ],
                [
                    83.371848,
                    53.1143309
                ],
                [
                    83.3780266,
                    53.1075986
                ],
                [
                    83.3776237,
                    53.1031234
                ],
                [
                    83.3820561,
                    53.098567
                ],
                [
                    83.3809144,
                    53.0896141
                ],
                [
                    83.3753487,
                    53.0791415
                ],
                [
                    83.3584543,
                    53.0819149
                ],
                [
                    83.3555162,
                    53.0838058
                ]
            ],
            "longitude": 83.3682817,
            "latitude": 53.0990513
        },
        "4926": {
            "name": "Алтай",
            "population": 883,
            "type": "village",
            "poly": null,
            "longitude": 83.3759309,
            "latitude": 53.0067101
        },
        "4927": {
            "name": "Нижняя Гусиха",
            "population": 775,
            "type": "village",
            "poly": null,
            "longitude": 83.3781003,
            "latitude": 52.2981915
        },
        "4928": {
            "name": "Хабазино",
            "population": 675,
            "type": "village",
            "poly": [
                [
                    83.3642479,
                    52.7395421
                ],
                [
                    83.3657928,
                    52.742556
                ],
                [
                    83.3678527,
                    52.743907
                ],
                [
                    83.3721443,
                    52.7453618
                ],
                [
                    83.369741,
                    52.7477518
                ],
                [
                    83.3742042,
                    52.7502456
                ],
                [
                    83.3781524,
                    52.7491027
                ],
                [
                    83.3833023,
                    52.7508691
                ],
                [
                    83.3863922,
                    52.7526354
                ],
                [
                    83.3898254,
                    52.7510769
                ],
                [
                    83.3942886,
                    52.7482714
                ],
                [
                    83.3924003,
                    52.745154
                ],
                [
                    83.3850189,
                    52.7416207
                ],
                [
                    83.3772941,
                    52.738191
                ],
                [
                    83.3700843,
                    52.7364241
                ],
                [
                    83.3656211,
                    52.7359044
                ],
                [
                    83.3642479,
                    52.7395421
                ]
            ],
            "longitude": 83.3799099,
            "latitude": 52.7432968
        },
        "4929": {
            "name": "Комсомольский",
            "population": 1892,
            "type": "village",
            "poly": [
                [
                    83.3681475,
                    53.2729436
                ],
                [
                    83.3706899,
                    53.2742682
                ],
                [
                    83.3724519,
                    53.2750209
                ],
                [
                    83.3729553,
                    53.2747499
                ],
                [
                    83.3743146,
                    53.2735758
                ],
                [
                    83.3753467,
                    53.27335
                ],
                [
                    83.3756991,
                    53.2728232
                ],
                [
                    83.376857,
                    53.273079
                ],
                [
                    83.3796762,
                    53.273079
                ],
                [
                    83.3819417,
                    53.2724469
                ],
                [
                    83.3838548,
                    53.2715437
                ],
                [
                    83.3856167,
                    53.2702942
                ],
                [
                    83.3864223,
                    53.2698878
                ],
                [
                    83.3887093,
                    53.270959
                ],
                [
                    83.3909029,
                    53.2700383
                ],
                [
                    83.3911295,
                    53.2684726
                ],
                [
                    83.3928915,
                    53.2679307
                ],
                [
                    83.3909281,
                    53.2661392
                ],
                [
                    83.3928663,
                    53.2655369
                ],
                [
                    83.3943011,
                    53.2672081
                ],
                [
                    83.3973218,
                    53.2660788
                ],
                [
                    83.3971204,
                    53.265838
                ],
                [
                    83.3960883,
                    53.2659133
                ],
                [
                    83.3937725,
                    53.2644529
                ],
                [
                    83.3924384,
                    53.2646035
                ],
                [
                    83.3807083,
                    53.2607942
                ],
                [
                    83.380809,
                    53.260478
                ],
                [
                    83.3738364,
                    53.2581742
                ],
                [
                    83.3698591,
                    53.2619385
                ],
                [
                    83.3746922,
                    53.2636098
                ],
                [
                    83.3747929,
                    53.2638507
                ],
                [
                    83.3733078,
                    53.2652509
                ],
                [
                    83.3726785,
                    53.2662144
                ],
                [
                    83.3723763,
                    53.267193
                ],
                [
                    83.3695068,
                    53.270505
                ],
                [
                    83.3699347,
                    53.2705952
                ],
                [
                    83.3694564,
                    53.2717093
                ],
                [
                    83.3681475,
                    53.2729436
                ]
            ],
            "longitude": 83.381635,
            "latitude": 53.267728
        },
        "4930": {
            "name": "Покровка",
            "population": 420,
            "type": "village",
            "poly": null,
            "longitude": 83.3853201,
            "latitude": 52.7146376
        },
        "4931": {
            "name": "Ключи",
            "population": 495,
            "type": "village",
            "poly": null,
            "longitude": 83.3902246,
            "latitude": 52.6172966
        },
        "4932": {
            "name": "Усть-Журавлиха",
            "population": 518,
            "type": "village",
            "poly": null,
            "longitude": 83.3908843,
            "latitude": 52.221937
        },
        "4933": {
            "name": "Красный Май",
            "population": 165,
            "type": "village",
            "poly": null,
            "longitude": 83.3951371,
            "latitude": 51.7259681
        },
        "4934": {
            "name": "Усть-Тулатинка",
            "population": 411,
            "type": "village",
            "poly": null,
            "longitude": 83.3958466,
            "latitude": 51.416413
        },
        "4935": {
            "name": "Алексеевка",
            "population": 765,
            "type": "village",
            "poly": null,
            "longitude": 83.4013782,
            "latitude": 51.5722856
        },
        "4936": {
            "name": "Куликово",
            "population": 113,
            "type": "village",
            "poly": null,
            "longitude": 83.4073399,
            "latitude": 53.7107905
        },
        "4937": {
            "name": "Берёзовка",
            "population": 537,
            "type": "village",
            "poly": null,
            "longitude": 83.4085353,
            "latitude": 53.3819288
        },
        "4938": {
            "name": "Щебнюха",
            "population": 184,
            "type": "village",
            "poly": null,
            "longitude": 83.4178337,
            "latitude": 51.4708474
        },
        "4939": {
            "name": "Тулата",
            "population": 999,
            "type": "village",
            "poly": [
                [
                    83.4069259,
                    51.311614
                ],
                [
                    83.4170463,
                    51.3176826
                ],
                [
                    83.4192678,
                    51.3214621
                ],
                [
                    83.4193147,
                    51.3276643
                ],
                [
                    83.4268761,
                    51.3271181
                ],
                [
                    83.4311366,
                    51.3123518
                ],
                [
                    83.4114924,
                    51.3068564
                ],
                [
                    83.4069259,
                    51.311614
                ]
            ],
            "longitude": 83.4244949,
            "latitude": 51.3133521
        },
        "4940": {
            "name": "Долинское",
            "population": 217,
            "type": "village",
            "poly": null,
            "longitude": 83.4281373,
            "latitude": 51.3852294
        },
        "4941": {
            "name": "Новые Зори",
            "population": 3299,
            "type": "village",
            "poly": [
                [
                    83.4086937,
                    53.259193
                ],
                [
                    83.4186255,
                    53.2584477
                ],
                [
                    83.4220998,
                    53.2618066
                ],
                [
                    83.4289784,
                    53.262048
                ],
                [
                    83.4355762,
                    53.2626358
                ],
                [
                    83.4371017,
                    53.2588571
                ],
                [
                    83.4395215,
                    53.2563563
                ],
                [
                    83.4538605,
                    53.2530519
                ],
                [
                    83.4545987,
                    53.2524331
                ],
                [
                    83.4513237,
                    53.2502842
                ],
                [
                    83.4535616,
                    53.247358
                ],
                [
                    83.454293,
                    53.2467571
                ],
                [
                    83.4524481,
                    53.2454376
                ],
                [
                    83.4533542,
                    53.2442813
                ],
                [
                    83.4505596,
                    53.2439612
                ],
                [
                    83.4488427,
                    53.2436956
                ],
                [
                    83.4463263,
                    53.2428826
                ],
                [
                    83.43853,
                    53.2399169
                ],
                [
                    83.4320768,
                    53.237145
                ],
                [
                    83.427013,
                    53.2350475
                ],
                [
                    83.4239646,
                    53.2340963
                ],
                [
                    83.4241502,
                    53.2343512
                ],
                [
                    83.4246415,
                    53.2344688
                ],
                [
                    83.424183,
                    53.2348674
                ],
                [
                    83.4238991,
                    53.2347824
                ],
                [
                    83.4235935,
                    53.2350895
                ],
                [
                    83.4236808,
                    53.235194
                ],
                [
                    83.4233315,
                    53.2354946
                ],
                [
                    83.4229385,
                    53.2353509
                ],
                [
                    83.4225783,
                    53.2357037
                ],
                [
                    83.4228293,
                    53.2357952
                ],
                [
                    83.4224799,
                    53.2361218
                ],
                [
                    83.4222508,
                    53.2360564
                ],
                [
                    83.4218687,
                    53.2363963
                ],
                [
                    83.4221743,
                    53.2364942
                ],
                [
                    83.4214648,
                    53.2371738
                ],
                [
                    83.4211045,
                    53.2370039
                ],
                [
                    83.420893,
                    53.2372064
                ],
                [
                    83.420646,
                    53.2374547
                ],
                [
                    83.4153079,
                    53.235952
                ],
                [
                    83.4156225,
                    53.2370077
                ],
                [
                    83.4157882,
                    53.2376834
                ],
                [
                    83.4163013,
                    53.2379577
                ],
                [
                    83.4166506,
                    53.2384608
                ],
                [
                    83.4173384,
                    53.2399504
                ],
                [
                    83.4207334,
                    53.2420801
                ],
                [
                    83.4231241,
                    53.2438832
                ],
                [
                    83.4179938,
                    53.2465321
                ],
                [
                    83.4092728,
                    53.2534194
                ],
                [
                    83.4153089,
                    53.2555819
                ],
                [
                    83.4110977,
                    53.2569781
                ],
                [
                    83.4086937,
                    53.259193
                ]
            ],
            "longitude": 83.4363429,
            "latitude": 53.2419264
        },
        "4942": {
            "name": "Маяк",
            "population": 596,
            "type": "village",
            "poly": null,
            "longitude": 83.4379413,
            "latitude": 51.6138164
        },
        "4943": {
            "name": "Первомайский",
            "population": 170,
            "type": "village",
            "poly": null,
            "longitude": 83.4429987,
            "latitude": 51.6056681
        },
        "4944": {
            "name": "Брусенцево",
            "population": 869,
            "type": "village",
            "poly": [
                [
                    83.4271813,
                    52.43829
                ],
                [
                    83.4353137,
                    52.4429276
                ],
                [
                    83.430854,
                    52.4476445
                ],
                [
                    83.4498732,
                    52.455958
                ],
                [
                    83.4603667,
                    52.4545991
                ],
                [
                    83.4660069,
                    52.4557981
                ],
                [
                    83.4728277,
                    52.4507623
                ],
                [
                    83.4687615,
                    52.4492434
                ],
                [
                    83.4631213,
                    52.4328523
                ],
                [
                    83.4507914,
                    52.426934
                ],
                [
                    83.4287553,
                    52.4353313
                ],
                [
                    83.4271813,
                    52.43829
                ]
            ],
            "longitude": 83.448824,
            "latitude": 52.4406888
        },
        "4945": {
            "name": "Староперуново",
            "population": 431,
            "type": "village",
            "poly": null,
            "longitude": 83.4631188,
            "latitude": 53.7730278
        },
        "4946": {
            "name": "Зимари",
            "population": 775,
            "type": "village",
            "poly": null,
            "longitude": 83.465675,
            "latitude": 53.186638
        },
        "4947": {
            "name": "Красноярка",
            "population": 492,
            "type": "village",
            "poly": null,
            "longitude": 83.466691,
            "latitude": 52.7542685
        },
        "4948": {
            "name": "Красноярка",
            "population": 978,
            "type": "village",
            "poly": null,
            "longitude": 83.474901,
            "latitude": 52.2262419
        },
        "4949": {
            "name": "Новомихайловка",
            "population": 1304,
            "type": "village",
            "poly": null,
            "longitude": 83.4763746,
            "latitude": 53.3483871
        },
        "4950": {
            "name": "Карасево",
            "population": 61,
            "type": "village",
            "poly": null,
            "longitude": 83.4894363,
            "latitude": 52.7891732
        },
        "4951": {
            "name": "Кашкарагаиха",
            "population": 891,
            "type": "village",
            "poly": null,
            "longitude": 83.4929678,
            "latitude": 53.732774
        },
        "4952": {
            "name": "Приозёрный",
            "population": 495,
            "type": "village",
            "poly": [
                [
                    83.4775029,
                    52.1645695
                ],
                [
                    83.4799861,
                    52.1674614
                ],
                [
                    83.4853169,
                    52.1678505
                ],
                [
                    83.5064781,
                    52.1659308
                ],
                [
                    83.504254,
                    52.1607843
                ],
                [
                    83.5001069,
                    52.1595123
                ],
                [
                    83.4885541,
                    52.1623289
                ],
                [
                    83.4775029,
                    52.1645695
                ]
            ],
            "longitude": 83.4935749,
            "latitude": 52.1640357
        },
        "4953": {
            "name": "Новоперуново",
            "population": 1806,
            "type": "village",
            "poly": null,
            "longitude": 83.4949377,
            "latitude": 53.8808575
        },
        "4954": {
            "name": "Маральи Рожки",
            "population": 343,
            "type": "village",
            "poly": null,
            "longitude": 83.4993221,
            "latitude": 51.7297675
        },
        "4955": {
            "name": "Красные Орлы",
            "population": 240,
            "type": "village",
            "poly": null,
            "longitude": 83.4998462,
            "latitude": 51.5950606
        },
        "4956": {
            "name": "Восточный",
            "population": 305,
            "type": "village",
            "poly": null,
            "longitude": 83.5072186,
            "latitude": 52.0510125
        },
        "4957": {
            "name": "Лесной",
            "population": 1639,
            "type": "village",
            "poly": null,
            "longitude": 83.5112895,
            "latitude": 53.2671617
        },
        "4958": {
            "name": "Лушниково",
            "population": 534,
            "type": "village",
            "poly": null,
            "longitude": 83.5169974,
            "latitude": 54.0132748
        },
        "4959": {
            "name": "Троицкое",
            "population": 458,
            "type": "village",
            "poly": null,
            "longitude": 83.5179509,
            "latitude": 52.3754857
        },
        "4960": {
            "name": "Научный Городок",
            "population": 3005,
            "type": "village",
            "poly": [
                [
                    83.5108251,
                    53.4215266
                ],
                [
                    83.5110328,
                    53.4223681
                ],
                [
                    83.5112143,
                    53.4231037
                ],
                [
                    83.5203994,
                    53.4243792
                ],
                [
                    83.5277356,
                    53.4243677
                ],
                [
                    83.530246,
                    53.421515
                ],
                [
                    83.5267113,
                    53.4194818
                ],
                [
                    83.5226014,
                    53.4185466
                ],
                [
                    83.5203721,
                    53.4170176
                ],
                [
                    83.5146198,
                    53.4173284
                ],
                [
                    83.5108251,
                    53.4215266
                ]
            ],
            "longitude": 83.519699,
            "latitude": 53.420643
        },
        "4961": {
            "name": "Кошелево",
            "population": 305,
            "type": "village",
            "poly": null,
            "longitude": 83.5303497,
            "latitude": 53.9654841
        },
        "4962": {
            "name": "Огни",
            "population": 1124,
            "type": "village",
            "poly": [
                [
                    83.5195281,
                    51.9043557
                ],
                [
                    83.5199106,
                    51.9082588
                ],
                [
                    83.5325243,
                    51.9234142
                ],
                [
                    83.5423328,
                    51.9377783
                ],
                [
                    83.5494439,
                    51.9356618
                ],
                [
                    83.5504248,
                    51.933394
                ],
                [
                    83.5460109,
                    51.9277995
                ],
                [
                    83.5580264,
                    51.9200871
                ],
                [
                    83.5582716,
                    51.9179697
                ],
                [
                    83.5533673,
                    51.916306
                ],
                [
                    83.5528769,
                    51.9113145
                ],
                [
                    83.5465014,
                    51.9061711
                ],
                [
                    83.531004,
                    51.9061832
                ],
                [
                    83.5295916,
                    51.901826
                ],
                [
                    83.5195281,
                    51.9043557
                ]
            ],
            "longitude": 83.530942,
            "latitude": 51.9088514
        },
        "4963": {
            "name": "Калманка",
            "population": 3203,
            "type": "village",
            "poly": [
                [
                    83.5035409,
                    52.9032424
                ],
                [
                    83.5048474,
                    52.904848
                ],
                [
                    83.5036321,
                    52.9058629
                ],
                [
                    83.5127049,
                    52.9134804
                ],
                [
                    83.5155437,
                    52.9119588
                ],
                [
                    83.5217332,
                    52.9110491
                ],
                [
                    83.5235746,
                    52.9127749
                ],
                [
                    83.524462,
                    52.9127883
                ],
                [
                    83.5260149,
                    52.9111561
                ],
                [
                    83.5270798,
                    52.9108216
                ],
                [
                    83.5282112,
                    52.9120525
                ],
                [
                    83.5292094,
                    52.91232
                ],
                [
                    83.5293427,
                    52.91133
                ],
                [
                    83.5285717,
                    52.9105818
                ],
                [
                    83.5321379,
                    52.9075036
                ],
                [
                    83.5332472,
                    52.9073965
                ],
                [
                    83.53886,
                    52.9098716
                ],
                [
                    83.5360144,
                    52.9124726
                ],
                [
                    83.5382893,
                    52.9124071
                ],
                [
                    83.5463595,
                    52.9143669
                ],
                [
                    83.5509633,
                    52.9151508
                ],
                [
                    83.5552394,
                    52.915207
                ],
                [
                    83.5594126,
                    52.9127012
                ],
                [
                    83.5575711,
                    52.9074097
                ],
                [
                    83.5583294,
                    52.9070831
                ],
                [
                    83.5632581,
                    52.9103167
                ],
                [
                    83.5609833,
                    52.9113947
                ],
                [
                    83.562582,
                    52.9128595
                ],
                [
                    83.5620575,
                    52.9131262
                ],
                [
                    83.5627717,
                    52.9138062
                ],
                [
                    83.5638994,
                    52.9132231
                ],
                [
                    83.5633854,
                    52.912708
                ],
                [
                    83.5663414,
                    52.9116395
                ],
                [
                    83.5661992,
                    52.9114648
                ],
                [
                    83.5695273,
                    52.9103757
                ],
                [
                    83.5702202,
                    52.9109716
                ],
                [
                    83.5766496,
                    52.9090863
                ],
                [
                    83.5780011,
                    52.9066792
                ],
                [
                    83.5785557,
                    52.9047524
                ],
                [
                    83.5719673,
                    52.9013872
                ],
                [
                    83.5635668,
                    52.8962974
                ],
                [
                    83.5612903,
                    52.8957351
                ],
                [
                    83.5575984,
                    52.8969359
                ],
                [
                    83.5530301,
                    52.8970022
                ],
                [
                    83.5473508,
                    52.8959208
                ],
                [
                    83.5454163,
                    52.8945504
                ],
                [
                    83.54515,
                    52.8931905
                ],
                [
                    83.5406876,
                    52.8911548
                ],
                [
                    83.5361743,
                    52.8899177
                ],
                [
                    83.5356678,
                    52.8889257
                ],
                [
                    83.53442,
                    52.8883017
                ],
                [
                    83.5324057,
                    52.8880787
                ],
                [
                    83.5310215,
                    52.8883291
                ],
                [
                    83.5301401,
                    52.8889048
                ],
                [
                    83.5295426,
                    52.8908569
                ],
                [
                    83.5282394,
                    52.8924297
                ],
                [
                    83.5272348,
                    52.892209
                ],
                [
                    83.527019,
                    52.8902696
                ],
                [
                    83.5257014,
                    52.8902833
                ],
                [
                    83.5243609,
                    52.8906209
                ],
                [
                    83.5230549,
                    52.8910509
                ],
                [
                    83.5220553,
                    52.8917293
                ],
                [
                    83.5192838,
                    52.8916402
                ],
                [
                    83.5163855,
                    52.8911766
                ],
                [
                    83.5142153,
                    52.8935939
                ],
                [
                    83.5167111,
                    52.8951623
                ],
                [
                    83.5196922,
                    52.8953087
                ],
                [
                    83.5230893,
                    52.8966052
                ],
                [
                    83.5207621,
                    52.8987568
                ],
                [
                    83.5200007,
                    52.8990655
                ],
                [
                    83.5192036,
                    52.8989427
                ],
                [
                    83.5190872,
                    52.8986019
                ],
                [
                    83.5196325,
                    52.8968972
                ],
                [
                    83.5191375,
                    52.8966052
                ],
                [
                    83.5127151,
                    52.8975413
                ],
                [
                    83.5106066,
                    52.8966173
                ],
                [
                    83.5083918,
                    52.8966052
                ],
                [
                    83.5096049,
                    52.9003482
                ],
                [
                    83.509293,
                    52.9014353
                ],
                [
                    83.5035409,
                    52.9032424
                ]
            ],
            "longitude": 83.533943,
            "latitude": 52.899948
        },
        "4964": {
            "name": "Черницк",
            "population": 822,
            "type": "village",
            "poly": null,
            "longitude": 83.553078,
            "latitude": 53.215336
        },
        "4965": {
            "name": "Чарышское",
            "population": 3097,
            "type": "village",
            "poly": [
                [
                    83.5328746,
                    51.4050441
                ],
                [
                    83.5416269,
                    51.4064808
                ],
                [
                    83.5560221,
                    51.4038228
                ],
                [
                    83.5663866,
                    51.3961352
                ],
                [
                    83.5753692,
                    51.3882307
                ],
                [
                    83.5752741,
                    51.3861279
                ],
                [
                    83.5707508,
                    51.3837989
                ],
                [
                    83.5682291,
                    51.3750056
                ],
                [
                    83.5513004,
                    51.3810436
                ],
                [
                    83.5513004,
                    51.3891649
                ],
                [
                    83.5405904,
                    51.3977878
                ],
                [
                    83.5328746,
                    51.4050441
                ]
            ],
            "longitude": 83.5541995,
            "latitude": 51.3975548
        },
        "4966": {
            "name": "Троицк",
            "population": 605,
            "type": "village",
            "poly": [
                [
                    83.5302899,
                    52.8821327
                ],
                [
                    83.5320426,
                    52.883177
                ],
                [
                    83.5309555,
                    52.8842747
                ],
                [
                    83.5358806,
                    52.8870992
                ],
                [
                    83.5418172,
                    52.8871844
                ],
                [
                    83.5461155,
                    52.8876696
                ],
                [
                    83.5479368,
                    52.8884722
                ],
                [
                    83.5492203,
                    52.8886368
                ],
                [
                    83.5502085,
                    52.8891714
                ],
                [
                    83.5509241,
                    52.8900212
                ],
                [
                    83.5510718,
                    52.8914878
                ],
                [
                    83.5526734,
                    52.8923855
                ],
                [
                    83.5537865,
                    52.892269
                ],
                [
                    83.5546725,
                    52.8915906
                ],
                [
                    83.5566374,
                    52.8919949
                ],
                [
                    83.5575348,
                    52.8925157
                ],
                [
                    83.5595794,
                    52.8927144
                ],
                [
                    83.5587047,
                    52.8949266
                ],
                [
                    83.5605239,
                    52.8953415
                ],
                [
                    83.5618992,
                    52.8952478
                ],
                [
                    83.5648469,
                    52.8961523
                ],
                [
                    83.5679024,
                    52.8981942
                ],
                [
                    83.5684476,
                    52.8981737
                ],
                [
                    83.5681182,
                    52.8947887
                ],
                [
                    83.5671527,
                    52.8938019
                ],
                [
                    83.5680387,
                    52.8936032
                ],
                [
                    83.5670504,
                    52.8908895
                ],
                [
                    83.5646084,
                    52.8877644
                ],
                [
                    83.5651081,
                    52.8865513
                ],
                [
                    83.5651649,
                    52.8826239
                ],
                [
                    83.562064,
                    52.8824183
                ],
                [
                    83.5620981,
                    52.8822812
                ],
                [
                    83.5635066,
                    52.8816026
                ],
                [
                    83.5604852,
                    52.8792171
                ],
                [
                    83.5594061,
                    52.8791417
                ],
                [
                    83.5577591,
                    52.877236
                ],
                [
                    83.5547263,
                    52.8775375
                ],
                [
                    83.5555404,
                    52.8819594
                ],
                [
                    83.5556464,
                    52.8825348
                ],
                [
                    83.5507894,
                    52.8827513
                ],
                [
                    83.5501093,
                    52.8827816
                ],
                [
                    83.5498129,
                    52.8827566
                ],
                [
                    83.5449806,
                    52.8823497
                ],
                [
                    83.543663,
                    52.8836863
                ],
                [
                    83.5432086,
                    52.8835424
                ],
                [
                    83.5424022,
                    52.8836451
                ],
                [
                    83.5411384,
                    52.8851582
                ],
                [
                    83.5374335,
                    52.885011
                ],
                [
                    83.5375001,
                    52.8838731
                ],
                [
                    83.5357696,
                    52.8820122
                ],
                [
                    83.534128,
                    52.8812491
                ],
                [
                    83.533174,
                    52.8819721
                ],
                [
                    83.5315545,
                    52.8811956
                ],
                [
                    83.5302899,
                    52.8821327
                ]
            ],
            "longitude": 83.55793,
            "latitude": 52.8831253
        },
        "4967": {
            "name": "Наумово",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 83.5769524,
            "latitude": 53.7790176
        },
        "4968": {
            "name": "Гоньба",
            "population": 2293,
            "type": "village",
            "poly": [
                [
                    83.5527351,
                    53.4149595
                ],
                [
                    83.5563457,
                    53.4159969
                ],
                [
                    83.5571491,
                    53.4162533
                ],
                [
                    83.557676,
                    53.4167137
                ],
                [
                    83.5582531,
                    53.4168331
                ],
                [
                    83.561235,
                    53.4171401
                ],
                [
                    83.5665759,
                    53.4184119
                ],
                [
                    83.5709177,
                    53.4206536
                ],
                [
                    83.5730656,
                    53.4216577
                ],
                [
                    83.5739241,
                    53.4220038
                ],
                [
                    83.5740643,
                    53.4220317
                ],
                [
                    83.5756947,
                    53.4218894
                ],
                [
                    83.5775022,
                    53.4215919
                ],
                [
                    83.5790461,
                    53.4213377
                ],
                [
                    83.5819532,
                    53.4203777
                ],
                [
                    83.5843788,
                    53.4195943
                ],
                [
                    83.5867303,
                    53.4187336
                ],
                [
                    83.5911186,
                    53.4173101
                ],
                [
                    83.5920444,
                    53.4165155
                ],
                [
                    83.5925628,
                    53.4145733
                ],
                [
                    83.5930628,
                    53.4131386
                ],
                [
                    83.5923407,
                    53.4121232
                ],
                [
                    83.5844899,
                    53.4088232
                ],
                [
                    83.5802498,
                    53.4103573
                ],
                [
                    83.577639,
                    53.4111961
                ],
                [
                    83.5743247,
                    53.4112844
                ],
                [
                    83.5720034,
                    53.4130008
                ],
                [
                    83.571328,
                    53.4131068
                ],
                [
                    83.5684129,
                    53.4129231
                ],
                [
                    83.5603822,
                    53.4122998
                ],
                [
                    83.559123,
                    53.4148492
                ],
                [
                    83.553772,
                    53.413569
                ],
                [
                    83.5527351,
                    53.4149595
                ]
            ],
            "longitude": 83.577713,
            "latitude": 53.415703
        },
        "4969": {
            "name": "Власиха",
            "population": 9992,
            "type": "village",
            "poly": null,
            "longitude": 83.5778361,
            "latitude": 53.2982076
        },
        "4970": {
            "name": "Мохнатушка",
            "population": 262,
            "type": "village",
            "poly": null,
            "longitude": 83.580376,
            "latitude": 53.229877
        },
        "4971": {
            "name": "Красный Партизан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.5805919,
            "latitude": 51.3758587
        },
        "4972": {
            "name": "Усть-Алейка",
            "population": 532,
            "type": "village",
            "poly": [
                [
                    83.5644929,
                    52.8220703
                ],
                [
                    83.5661312,
                    52.8227774
                ],
                [
                    83.5662,
                    52.8232183
                ],
                [
                    83.5684715,
                    52.8241168
                ],
                [
                    83.5678107,
                    52.8249985
                ],
                [
                    83.5700288,
                    52.8258836
                ],
                [
                    83.5688256,
                    52.8261913
                ],
                [
                    83.5685881,
                    52.8268682
                ],
                [
                    83.5733036,
                    52.8297149
                ],
                [
                    83.5730145,
                    52.8302971
                ],
                [
                    83.5747628,
                    52.8312204
                ],
                [
                    83.5742259,
                    52.8317277
                ],
                [
                    83.5748592,
                    52.8318941
                ],
                [
                    83.5747078,
                    52.8320687
                ],
                [
                    83.5755062,
                    52.8323182
                ],
                [
                    83.575699,
                    52.8320355
                ],
                [
                    83.5767752,
                    52.8321911
                ],
                [
                    83.5819162,
                    52.8288383
                ],
                [
                    83.5803674,
                    52.8276946
                ],
                [
                    83.5823033,
                    52.8264728
                ],
                [
                    83.5841963,
                    52.8271357
                ],
                [
                    83.5878616,
                    52.8246698
                ],
                [
                    83.5905736,
                    52.8239544
                ],
                [
                    83.5914509,
                    52.8234051
                ],
                [
                    83.5921117,
                    52.8227562
                ],
                [
                    83.5923088,
                    52.8219893
                ],
                [
                    83.5922807,
                    52.8212258
                ],
                [
                    83.5929784,
                    52.8203707
                ],
                [
                    83.5938251,
                    52.8195649
                ],
                [
                    83.5937189,
                    52.8190852
                ],
                [
                    83.5934989,
                    52.8189148
                ],
                [
                    83.5937583,
                    52.818499
                ],
                [
                    83.5935335,
                    52.8181392
                ],
                [
                    83.5950891,
                    52.8175236
                ],
                [
                    83.5950203,
                    52.8172157
                ],
                [
                    83.5969063,
                    52.8150441
                ],
                [
                    83.5951855,
                    52.8138959
                ],
                [
                    83.5954058,
                    52.8135548
                ],
                [
                    83.5952248,
                    52.8129961
                ],
                [
                    83.5946073,
                    52.8126395
                ],
                [
                    83.5935419,
                    52.813486
                ],
                [
                    83.5919208,
                    52.8140984
                ],
                [
                    83.5890572,
                    52.8151794
                ],
                [
                    83.5876036,
                    52.8163882
                ],
                [
                    83.5867137,
                    52.8169207
                ],
                [
                    83.5859229,
                    52.817089
                ],
                [
                    83.5842049,
                    52.8171023
                ],
                [
                    83.5810551,
                    52.8161371
                ],
                [
                    83.5799231,
                    52.8162834
                ],
                [
                    83.5766057,
                    52.8175016
                ],
                [
                    83.5771453,
                    52.8178477
                ],
                [
                    83.5780264,
                    52.8178145
                ],
                [
                    83.5803172,
                    52.8170557
                ],
                [
                    83.5834615,
                    52.8214551
                ],
                [
                    83.5803472,
                    52.8224386
                ],
                [
                    83.5786947,
                    52.8235141
                ],
                [
                    83.5766126,
                    52.8226198
                ],
                [
                    83.5752875,
                    52.8225989
                ],
                [
                    83.574169,
                    52.8234933
                ],
                [
                    83.572844,
                    52.82393
                ],
                [
                    83.5710543,
                    52.823878
                ],
                [
                    83.5692149,
                    52.8228856
                ],
                [
                    83.5684026,
                    52.8220121
                ],
                [
                    83.5671774,
                    52.8217292
                ],
                [
                    83.5662825,
                    52.8214714
                ],
                [
                    83.5658008,
                    52.8217792
                ],
                [
                    83.5646718,
                    52.8216211
                ],
                [
                    83.5644929,
                    52.8220703
                ]
            ],
            "longitude": 83.583595,
            "latitude": 52.82312
        },
        "4973": {
            "name": "Калистратиха",
            "population": 607,
            "type": "village",
            "poly": [
                [
                    83.5648842,
                    52.9927104
                ],
                [
                    83.57528,
                    53.0053898
                ],
                [
                    83.5795332,
                    53.004341
                ],
                [
                    83.5805089,
                    53.0045804
                ],
                [
                    83.581925,
                    53.0036447
                ],
                [
                    83.5819543,
                    53.0032074
                ],
                [
                    83.5824231,
                    53.0031476
                ],
                [
                    83.5830673,
                    53.0026288
                ],
                [
                    83.5826268,
                    53.0008046
                ],
                [
                    83.5827582,
                    52.9998701
                ],
                [
                    83.582363,
                    52.998947
                ],
                [
                    83.5829917,
                    52.9972861
                ],
                [
                    83.5839502,
                    52.9965593
                ],
                [
                    83.5852216,
                    52.9965529
                ],
                [
                    83.5851587,
                    52.9962698
                ],
                [
                    83.5846377,
                    52.9962926
                ],
                [
                    83.5845335,
                    52.9956255
                ],
                [
                    83.5853861,
                    52.9946449
                ],
                [
                    83.5844861,
                    52.9939151
                ],
                [
                    83.5858597,
                    52.9924098
                ],
                [
                    83.5853955,
                    52.9923243
                ],
                [
                    83.5856229,
                    52.9919594
                ],
                [
                    83.5844388,
                    52.9913778
                ],
                [
                    83.5846661,
                    52.9907677
                ],
                [
                    83.5863996,
                    52.9908361
                ],
                [
                    83.5872332,
                    52.9903914
                ],
                [
                    83.5874606,
                    52.9887206
                ],
                [
                    83.5894688,
                    52.989097
                ],
                [
                    83.590596,
                    52.9886408
                ],
                [
                    83.5923674,
                    52.9888404
                ],
                [
                    83.5939872,
                    52.9899067
                ],
                [
                    83.5962228,
                    52.9895931
                ],
                [
                    83.5961091,
                    52.9876258
                ],
                [
                    83.5977289,
                    52.9871639
                ],
                [
                    83.59735,
                    52.9857725
                ],
                [
                    83.6018874,
                    52.9837651
                ],
                [
                    83.604265,
                    52.985915
                ],
                [
                    83.6050418,
                    52.9859835
                ],
                [
                    83.6050418,
                    52.9854816
                ],
                [
                    83.6054965,
                    52.9854816
                ],
                [
                    83.6052387,
                    52.989382
                ],
                [
                    83.6076768,
                    52.9888498
                ],
                [
                    83.6078376,
                    52.9875433
                ],
                [
                    83.6082663,
                    52.9876401
                ],
                [
                    83.6110795,
                    52.9825754
                ],
                [
                    83.6128746,
                    52.9805106
                ],
                [
                    83.6126067,
                    52.9799782
                ],
                [
                    83.6132765,
                    52.9791394
                ],
                [
                    83.6132229,
                    52.9782682
                ],
                [
                    83.6124467,
                    52.9787773
                ],
                [
                    83.6074468,
                    52.977645
                ],
                [
                    83.6065626,
                    52.9783549
                ],
                [
                    83.6037226,
                    52.9772095
                ],
                [
                    83.5990071,
                    52.9762576
                ],
                [
                    83.5968101,
                    52.9769836
                ],
                [
                    83.5967297,
                    52.9773547
                ],
                [
                    83.595524,
                    52.9771772
                ],
                [
                    83.5954169,
                    52.9787421
                ],
                [
                    83.5940772,
                    52.9787582
                ],
                [
                    83.5934342,
                    52.9794035
                ],
                [
                    83.5926304,
                    52.9793873
                ],
                [
                    83.590487,
                    52.9774676
                ],
                [
                    83.5890938,
                    52.9779838
                ],
                [
                    83.589067,
                    52.9786291
                ],
                [
                    83.5874327,
                    52.9775644
                ],
                [
                    83.5841104,
                    52.9785485
                ],
                [
                    83.5850749,
                    52.9805811
                ],
                [
                    83.5843783,
                    52.9815006
                ],
                [
                    83.5857715,
                    52.9827104
                ],
                [
                    83.581699,
                    52.9820813
                ],
                [
                    83.5811632,
                    52.9828878
                ],
                [
                    83.5822617,
                    52.9840008
                ],
                [
                    83.5802522,
                    52.9840815
                ],
                [
                    83.5777337,
                    52.9832911
                ],
                [
                    83.5770103,
                    52.9838879
                ],
                [
                    83.5791537,
                    52.984888
                ],
                [
                    83.5799843,
                    52.9855977
                ],
                [
                    83.5807345,
                    52.9872429
                ],
                [
                    83.5794752,
                    52.9874203
                ],
                [
                    83.5807345,
                    52.987888
                ],
                [
                    83.5764208,
                    52.9880171
                ],
                [
                    83.5767959,
                    52.9889848
                ],
                [
                    83.5733397,
                    52.989388
                ],
                [
                    83.5724555,
                    52.98813
                ],
                [
                    83.5702317,
                    52.9880655
                ],
                [
                    83.5657574,
                    52.9905815
                ],
                [
                    83.5674556,
                    52.9925096
                ],
                [
                    83.5648842,
                    52.9927104
                ]
            ],
            "longitude": 83.5875263,
            "latitude": 52.986416
        },
        "4974": {
            "name": "Бураново",
            "population": 1039,
            "type": "village",
            "poly": [
                [
                    83.5715325,
                    53.0514242
                ],
                [
                    83.5794882,
                    53.0535101
                ],
                [
                    83.5804801,
                    53.0551965
                ],
                [
                    83.576314,
                    53.0563378
                ],
                [
                    83.577391,
                    53.0580752
                ],
                [
                    83.581683,
                    53.0587285
                ],
                [
                    83.5832505,
                    53.0618898
                ],
                [
                    83.5891226,
                    53.0597778
                ],
                [
                    83.5940555,
                    53.0567975
                ],
                [
                    83.6002094,
                    53.060391
                ],
                [
                    83.6036103,
                    53.0587559
                ],
                [
                    83.6005103,
                    53.0563909
                ],
                [
                    83.5998835,
                    53.0558676
                ],
                [
                    83.5993959,
                    53.054828
                ],
                [
                    83.598985,
                    53.0530084
                ],
                [
                    83.6008713,
                    53.0528003
                ],
                [
                    83.6044665,
                    53.0544462
                ],
                [
                    83.611495,
                    53.0525895
                ],
                [
                    83.6137905,
                    53.0539182
                ],
                [
                    83.6163979,
                    53.0536627
                ],
                [
                    83.6148994,
                    53.0511098
                ],
                [
                    83.6175598,
                    53.0501023
                ],
                [
                    83.6192603,
                    53.0508519
                ],
                [
                    83.6217707,
                    53.0493844
                ],
                [
                    83.6201749,
                    53.0447202
                ],
                [
                    83.6212234,
                    53.0399673
                ],
                [
                    83.6218516,
                    53.0365767
                ],
                [
                    83.6189314,
                    53.0360532
                ],
                [
                    83.6168203,
                    53.0381011
                ],
                [
                    83.615093,
                    53.0392961
                ],
                [
                    83.6137743,
                    53.0397316
                ],
                [
                    83.6123442,
                    53.0387712
                ],
                [
                    83.6090296,
                    53.0393851
                ],
                [
                    83.6056022,
                    53.0420315
                ],
                [
                    83.588951,
                    53.0461596
                ],
                [
                    83.5727062,
                    53.0496164
                ],
                [
                    83.572514,
                    53.0500449
                ],
                [
                    83.5717595,
                    53.0507846
                ],
                [
                    83.5715325,
                    53.0514242
                ]
            ],
            "longitude": 83.596123,
            "latitude": 53.048225
        },
        "4975": {
            "name": "Комендантка",
            "population": 97,
            "type": "village",
            "poly": null,
            "longitude": 83.5978512,
            "latitude": 51.3340902
        },
        "4976": {
            "name": "Елбанка",
            "population": 812,
            "type": "village",
            "poly": null,
            "longitude": 83.6046782,
            "latitude": 52.2290516
        },
        "4977": {
            "name": "Пригородный",
            "population": 3025,
            "type": "village",
            "poly": null,
            "longitude": 83.604713,
            "latitude": 53.299572
        },
        "4978": {
            "name": "Малая Маралиха",
            "population": 106,
            "type": "village",
            "poly": null,
            "longitude": 83.6056785,
            "latitude": 51.7741881
        },
        "4979": {
            "name": "Казённая Заимка",
            "population": 2769,
            "type": "village",
            "poly": [
                [
                    83.593067,
                    53.401085
                ],
                [
                    83.5950248,
                    53.4025555
                ],
                [
                    83.5964146,
                    53.4033506
                ],
                [
                    83.5979478,
                    53.403954
                ],
                [
                    83.5983849,
                    53.404228
                ],
                [
                    83.5990308,
                    53.4052824
                ],
                [
                    83.6002041,
                    53.4072137
                ],
                [
                    83.6016926,
                    53.4069527
                ],
                [
                    83.6036189,
                    53.4070571
                ],
                [
                    83.6047396,
                    53.4107733
                ],
                [
                    83.6039691,
                    53.411504
                ],
                [
                    83.6046346,
                    53.4117754
                ],
                [
                    83.6043574,
                    53.4127011
                ],
                [
                    83.6032652,
                    53.4132574
                ],
                [
                    83.5997053,
                    53.4125898
                ],
                [
                    83.5983813,
                    53.4136168
                ],
                [
                    83.5976003,
                    53.4156902
                ],
                [
                    83.5980149,
                    53.4164085
                ],
                [
                    83.601195,
                    53.4158073
                ],
                [
                    83.6049215,
                    53.4149222
                ],
                [
                    83.6079336,
                    53.4146384
                ],
                [
                    83.6097968,
                    53.4138534
                ],
                [
                    83.6127529,
                    53.4130101
                ],
                [
                    83.6123606,
                    53.4115655
                ],
                [
                    83.613019,
                    53.4102461
                ],
                [
                    83.6140137,
                    53.4089851
                ],
                [
                    83.614392,
                    53.4071561
                ],
                [
                    83.615877,
                    53.4046339
                ],
                [
                    83.6172639,
                    53.4032809
                ],
                [
                    83.6179224,
                    53.4022703
                ],
                [
                    83.6198425,
                    53.4012314
                ],
                [
                    83.6220315,
                    53.4018448
                ],
                [
                    83.6239803,
                    53.4003994
                ],
                [
                    83.6222723,
                    53.3996131
                ],
                [
                    83.6222285,
                    53.3989866
                ],
                [
                    83.6218783,
                    53.3975901
                ],
                [
                    83.6196202,
                    53.3964217
                ],
                [
                    83.6182534,
                    53.39532
                ],
                [
                    83.6144795,
                    53.3968592
                ],
                [
                    83.6144597,
                    53.396917
                ],
                [
                    83.6103966,
                    53.39765
                ],
                [
                    83.6085963,
                    53.3961728
                ],
                [
                    83.6073763,
                    53.3940504
                ],
                [
                    83.6057345,
                    53.39197
                ],
                [
                    83.6022802,
                    53.3893123
                ],
                [
                    83.6007374,
                    53.3911998
                ],
                [
                    83.6003592,
                    53.3924529
                ],
                [
                    83.5995467,
                    53.3943243
                ],
                [
                    83.5988322,
                    53.3959198
                ],
                [
                    83.5971931,
                    53.3974318
                ],
                [
                    83.5956801,
                    53.399044
                ],
                [
                    83.5945593,
                    53.4002468
                ],
                [
                    83.5936409,
                    53.4007401
                ],
                [
                    83.593067,
                    53.401085
                ]
            ],
            "longitude": 83.606987,
            "latitude": 53.403141
        },
        "4980": {
            "name": "Берёзовка",
            "population": 789,
            "type": "village",
            "poly": null,
            "longitude": 83.612995,
            "latitude": 51.2728704
        },
        "4981": {
            "name": "Центральный",
            "population": 2154,
            "type": "village",
            "poly": null,
            "longitude": 83.6146953,
            "latitude": 53.2202173
        },
        "4982": {
            "name": "Ягодное",
            "population": 1188,
            "type": "village",
            "poly": null,
            "longitude": 83.6148297,
            "latitude": 53.2277295
        },
        "4983": {
            "name": "Анисимово",
            "population": 1724,
            "type": "village",
            "poly": null,
            "longitude": 83.6210242,
            "latitude": 54.0225536
        },
        "4984": {
            "name": "Вяткино",
            "population": 692,
            "type": "village",
            "poly": [
                [
                    83.6058857,
                    52.5105269
                ],
                [
                    83.6163382,
                    52.5191328
                ],
                [
                    83.6280203,
                    52.5226246
                ],
                [
                    83.6308896,
                    52.5252432
                ],
                [
                    83.6384727,
                    52.5172621
                ],
                [
                    83.6243312,
                    52.5092795
                ],
                [
                    83.6175679,
                    52.505662
                ],
                [
                    83.6058857,
                    52.5105269
                ]
            ],
            "longitude": 83.6183814472223,
            "latitude": 52.51924260075863
        },
        "4985": {
            "name": "Луговое",
            "population": 1198,
            "type": "village",
            "poly": null,
            "longitude": 83.6229418,
            "latitude": 53.7972912
        },
        "4986": {
            "name": "Володарка",
            "population": 736,
            "type": "village",
            "poly": [
                [
                    83.5957095,
                    52.7262679
                ],
                [
                    83.6133208,
                    52.7368642
                ],
                [
                    83.6274868,
                    52.7268563
                ],
                [
                    83.6312908,
                    52.7286038
                ],
                [
                    83.6390051,
                    52.7028336
                ],
                [
                    83.6349061,
                    52.6981762
                ],
                [
                    83.6131302,
                    52.698021
                ],
                [
                    83.6138988,
                    52.7116811
                ],
                [
                    83.5957095,
                    52.7262679
                ]
            ],
            "longitude": 83.62368,
            "latitude": 52.715099
        },
        "4987": {
            "name": "Белово",
            "population": 171,
            "type": "village",
            "poly": null,
            "longitude": 83.62694467798536,
            "latitude": 52.621850105788866
        },
        "4988": {
            "name": "Шадрино",
            "population": 659,
            "type": "village",
            "poly": [
                [
                    83.6081771,
                    53.116174
                ],
                [
                    83.6085204,
                    53.1217373
                ],
                [
                    83.6094515,
                    53.1257244
                ],
                [
                    83.6203651,
                    53.1254457
                ],
                [
                    83.6401061,
                    53.1225614
                ],
                [
                    83.6552123,
                    53.1166892
                ],
                [
                    83.6656837,
                    53.1089613
                ],
                [
                    83.6742667,
                    53.1002014
                ],
                [
                    83.6668853,
                    53.0980368
                ],
                [
                    83.6526374,
                    53.0987584
                ],
                [
                    83.632553,
                    53.1043239
                ],
                [
                    83.6134986,
                    53.1114344
                ],
                [
                    83.6081771,
                    53.116174
                ]
            ],
            "longitude": 83.6334795,
            "latitude": 53.1131307
        },
        "4989": {
            "name": "Среднесибирский",
            "population": 2010,
            "type": "village",
            "poly": [
                [
                    83.6298719,
                    53.7474274
                ],
                [
                    83.6335652,
                    53.7459942
                ],
                [
                    83.6341829,
                    53.7463595
                ],
                [
                    83.6354869,
                    53.7468161
                ],
                [
                    83.6345861,
                    53.747775
                ],
                [
                    83.6341057,
                    53.7482214
                ],
                [
                    83.6342085,
                    53.7493172
                ],
                [
                    83.6326901,
                    53.7510825
                ],
                [
                    83.6322698,
                    53.7519297
                ],
                [
                    83.6342001,
                    53.7525181
                ],
                [
                    83.6353668,
                    53.7515898
                ],
                [
                    83.6362076,
                    53.7518181
                ],
                [
                    83.6365164,
                    53.7512956
                ],
                [
                    83.640317,
                    53.7520971
                ],
                [
                    83.6392703,
                    53.7534616
                ],
                [
                    83.6368682,
                    53.75475
                ],
                [
                    83.637666,
                    53.7552522
                ],
                [
                    83.6387384,
                    53.7554551
                ],
                [
                    83.6416038,
                    53.7556579
                ],
                [
                    83.6502602,
                    53.7456036
                ],
                [
                    83.6601948,
                    53.7342121
                ],
                [
                    83.6600161,
                    53.7340167
                ],
                [
                    83.6583469,
                    53.73478
                ],
                [
                    83.6477665,
                    53.7339517
                ],
                [
                    83.6461413,
                    53.7336822
                ],
                [
                    83.6436693,
                    53.7350152
                ],
                [
                    83.6385111,
                    53.7397053
                ],
                [
                    83.6371726,
                    53.7417197
                ],
                [
                    83.6346676,
                    53.7421002
                ],
                [
                    83.6298719,
                    53.7474274
                ]
            ],
            "longitude": 83.6441486,
            "latitude": 53.7434119
        },
        "4990": {
            "name": "Борзовая Заимка",
            "population": 2229,
            "type": "village",
            "poly": null,
            "longitude": 83.656456,
            "latitude": 53.290306
        },
        "4991": {
            "name": "Лебяжье",
            "population": 5484,
            "type": "village",
            "poly": null,
            "longitude": 83.6566112,
            "latitude": 53.2422958
        },
        "4992": {
            "name": "Коловый Мыс",
            "population": 210,
            "type": "village",
            "poly": null,
            "longitude": 83.656787,
            "latitude": 52.2499636
        },
        "4993": {
            "name": "Усть-Чарышская Пристань",
            "population": 5023,
            "type": "village",
            "poly": [
                [
                    83.6433681,
                    52.401949
                ],
                [
                    83.6583026,
                    52.4076042
                ],
                [
                    83.6665424,
                    52.4108504
                ],
                [
                    83.6720355,
                    52.4102222
                ],
                [
                    83.6735805,
                    52.4062429
                ],
                [
                    83.6735805,
                    52.401949
                ],
                [
                    83.6752971,
                    52.3951408
                ],
                [
                    83.6789019,
                    52.3911601
                ],
                [
                    83.6806186,
                    52.3838263
                ],
                [
                    83.6629375,
                    52.3836168
                ],
                [
                    83.6493762,
                    52.3872838
                ],
                [
                    83.6437114,
                    52.3955598
                ],
                [
                    83.6433681,
                    52.401949
                ]
            ],
            "longitude": 83.667618,
            "latitude": 52.391582
        },
        "4994": {
            "name": "Забродино",
            "population": 347,
            "type": "village",
            "poly": null,
            "longitude": 83.6691513,
            "latitude": 53.8015976
        },
        "4995": {
            "name": "Литвиновка",
            "population": 177,
            "type": "village",
            "poly": null,
            "longitude": 83.6748238,
            "latitude": 53.6947037
        },
        "4996": {
            "name": "Сваловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.6757097,
            "latitude": 51.4910457
        },
        "4997": {
            "name": "Таскаево",
            "population": 376,
            "type": "village",
            "poly": null,
            "longitude": 83.6832385,
            "latitude": 53.8557819
        },
        "4998": {
            "name": "Ползуново",
            "population": 332,
            "type": "village",
            "poly": [
                [
                    83.6836351,
                    53.2949897
                ],
                [
                    83.6847625,
                    53.2960258
                ],
                [
                    83.6848189,
                    53.2976851
                ],
                [
                    83.6880886,
                    53.2986285
                ],
                [
                    83.6910623,
                    53.2995382
                ],
                [
                    83.6943966,
                    53.3002191
                ],
                [
                    83.6951298,
                    53.3003019
                ],
                [
                    83.6961862,
                    53.3011264
                ],
                [
                    83.6972803,
                    53.3016449
                ],
                [
                    83.6985445,
                    53.3025763
                ],
                [
                    83.698787,
                    53.3030282
                ],
                [
                    83.6987812,
                    53.3034698
                ],
                [
                    83.699116,
                    53.3045495
                ],
                [
                    83.6998708,
                    53.3044483
                ],
                [
                    83.7005473,
                    53.3033703
                ],
                [
                    83.7009419,
                    53.3011553
                ],
                [
                    83.699603,
                    53.3002878
                ],
                [
                    83.6975876,
                    53.2997319
                ],
                [
                    83.6965729,
                    53.2984516
                ],
                [
                    83.6945011,
                    53.2980473
                ],
                [
                    83.691612,
                    53.297643
                ],
                [
                    83.6881168,
                    53.2971039
                ],
                [
                    83.6865665,
                    53.296388
                ],
                [
                    83.6836351,
                    53.2949897
                ]
            ],
            "longitude": 83.6909529,
            "latitude": 53.2984507
        },
        "4999": {
            "name": "Сибирская долина",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.6941296,
            "latitude": 53.2223271
        },
        "5000": {
            "name": "Озёрки",
            "population": 4209,
            "type": "village",
            "poly": null,
            "longitude": 83.6959955,
            "latitude": 53.6669984
        },
        "5001": {
            "name": "Бельмесёво",
            "population": 1778,
            "type": "village",
            "poly": null,
            "longitude": 83.6993759,
            "latitude": 53.1983475
        },
        "5002": {
            "name": "Садоводов",
            "population": 1774,
            "type": "village",
            "poly": null,
            "longitude": 83.7060846,
            "latitude": 53.2432055
        },
        "5003": {
            "name": "Коробейниково",
            "population": 1060,
            "type": "village",
            "poly": null,
            "longitude": 83.7075659,
            "latitude": 52.187144
        },
        "5004": {
            "name": "Озёрки",
            "population": 5304,
            "type": "village",
            "poly": [
                [
                    83.6828217,
                    53.624431
                ],
                [
                    83.6905443,
                    53.6267144
                ],
                [
                    83.6976246,
                    53.6276833
                ],
                [
                    83.7030429,
                    53.6323572
                ],
                [
                    83.6954368,
                    53.6375298
                ],
                [
                    83.6997859,
                    53.6398493
                ],
                [
                    83.7104571,
                    53.6381436
                ],
                [
                    83.714759,
                    53.636032
                ],
                [
                    83.718984,
                    53.6369937
                ],
                [
                    83.7229372,
                    53.6276688
                ],
                [
                    83.7232324,
                    53.6236419
                ],
                [
                    83.7277911,
                    53.6204831
                ],
                [
                    83.726893,
                    53.6197426
                ],
                [
                    83.7231641,
                    53.618024
                ],
                [
                    83.7198464,
                    53.6176109
                ],
                [
                    83.7170813,
                    53.6168939
                ],
                [
                    83.7136153,
                    53.6165671
                ],
                [
                    83.7111286,
                    53.6142919
                ],
                [
                    83.7054864,
                    53.6166442
                ],
                [
                    83.7042393,
                    53.6171917
                ],
                [
                    83.7034692,
                    53.6177781
                ],
                [
                    83.7016014,
                    53.6205927
                ],
                [
                    83.6994227,
                    53.6220865
                ],
                [
                    83.6965727,
                    53.6226907
                ],
                [
                    83.6955536,
                    53.6223403
                ],
                [
                    83.6947435,
                    53.6226601
                ],
                [
                    83.6947278,
                    53.6230819
                ],
                [
                    83.693383,
                    53.6242733
                ],
                [
                    83.6913479,
                    53.6240441
                ],
                [
                    83.6904929,
                    53.6245828
                ],
                [
                    83.6838265,
                    53.6225793
                ],
                [
                    83.6828217,
                    53.624431
                ]
            ],
            "longitude": 83.714438,
            "latitude": 53.6285789
        },
        "5005": {
            "name": "Лесная Поляна",
            "population": 351,
            "type": "village",
            "poly": [
                [
                    83.7069817,
                    53.5709258
                ],
                [
                    83.7072821,
                    53.5713081
                ],
                [
                    83.7110158,
                    53.5722
                ],
                [
                    83.7137495,
                    53.5724867
                ],
                [
                    83.7151356,
                    53.5722255
                ],
                [
                    83.7170969,
                    53.5732257
                ],
                [
                    83.7165819,
                    53.5738118
                ],
                [
                    83.7168823,
                    53.5740921
                ],
                [
                    83.7179659,
                    53.5733965
                ],
                [
                    83.720455,
                    53.574747
                ],
                [
                    83.7219141,
                    53.5740845
                ],
                [
                    83.7228583,
                    53.5743393
                ],
                [
                    83.7254332,
                    53.5727351
                ],
                [
                    83.7247895,
                    53.5719197
                ],
                [
                    83.7228046,
                    53.5710596
                ],
                [
                    83.721088,
                    53.5711616
                ],
                [
                    83.7198863,
                    53.5709067
                ],
                [
                    83.718438,
                    53.5713591
                ],
                [
                    83.717408,
                    53.5708494
                ],
                [
                    83.7170969,
                    53.5699893
                ],
                [
                    83.7147065,
                    53.5692693
                ],
                [
                    83.7135049,
                    53.5692438
                ],
                [
                    83.7105866,
                    53.5685048
                ],
                [
                    83.7101574,
                    53.5685811
                ],
                [
                    83.7076984,
                    53.5699637
                ],
                [
                    83.7069817,
                    53.5709258
                ]
            ],
            "longitude": 83.7162729,
            "latitude": 53.5716493
        },
        "5006": {
            "name": "Плодопитомник",
            "population": 683,
            "type": "village",
            "poly": null,
            "longitude": 83.7341544,
            "latitude": 53.2591324
        },
        "5007": {
            "name": "Новотроицк",
            "population": 672,
            "type": "village",
            "poly": null,
            "longitude": 83.73568,
            "latitude": 53.901283
        },
        "5008": {
            "name": "Выползово",
            "population": 561,
            "type": "village",
            "poly": null,
            "longitude": 83.7409019,
            "latitude": 53.8420895
        },
        "5009": {
            "name": "Сентелек",
            "population": 978,
            "type": "village",
            "poly": null,
            "longitude": 83.7525877,
            "latitude": 51.20391
        },
        "5010": {
            "name": "Нижнеозерное",
            "population": 631,
            "type": "village",
            "poly": [
                [
                    83.7189116,
                    52.2251487
                ],
                [
                    83.7372406,
                    52.2319528
                ],
                [
                    83.7459422,
                    52.2287777
                ],
                [
                    83.7661226,
                    52.231159
                ],
                [
                    83.7868584,
                    52.220612
                ],
                [
                    83.7868584,
                    52.2186838
                ],
                [
                    83.773158,
                    52.2077935
                ],
                [
                    83.7694552,
                    52.2077935
                ],
                [
                    83.7505707,
                    52.2182301
                ],
                [
                    83.7442759,
                    52.2134659
                ],
                [
                    83.7244658,
                    52.2178898
                ],
                [
                    83.7189116,
                    52.2251487
                ]
            ],
            "longitude": 83.7540829,
            "latitude": 52.220515
        },
        "5011": {
            "name": "Клепиково",
            "population": 521,
            "type": "village",
            "poly": null,
            "longitude": 83.758202,
            "latitude": 52.539997
        },
        "5012": {
            "name": "Рогуличный",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 83.760287,
            "latitude": 53.6522058
        },
        "5013": {
            "name": "Камышенка",
            "population": 0,
            "type": "village",
            "poly": null,
            "longitude": 83.7604487,
            "latitude": 52.6057424
        },
        "5014": {
            "name": "Сибирский",
            "population": 1679,
            "type": "village",
            "poly": [
                [
                    83.7584808,
                    53.582528
                ],
                [
                    83.7670499,
                    53.5852103
                ],
                [
                    83.7707891,
                    53.5818189
                ],
                [
                    83.7743206,
                    53.5793215
                ],
                [
                    83.7765018,
                    53.5780265
                ],
                [
                    83.7725303,
                    53.5763185
                ],
                [
                    83.7733858,
                    53.5758063
                ],
                [
                    83.7721394,
                    53.5748196
                ],
                [
                    83.7689517,
                    53.576108
                ],
                [
                    83.7675173,
                    53.5756521
                ],
                [
                    83.7646791,
                    53.5747951
                ],
                [
                    83.7584808,
                    53.582528
                ]
            ],
            "longitude": 83.766159,
            "latitude": 53.579979
        },
        "5015": {
            "name": "Чаузово",
            "population": 320,
            "type": "village",
            "poly": [
                [
                    83.7441687,
                    52.7343686
                ],
                [
                    83.744681,
                    52.737471
                ],
                [
                    83.7549285,
                    52.7433649
                ],
                [
                    83.7754235,
                    52.7483275
                ],
                [
                    83.7890014,
                    52.741969
                ],
                [
                    83.7674817,
                    52.7259911
                ],
                [
                    83.7441687,
                    52.7343686
                ]
            ],
            "longitude": 83.7664569,
            "latitude": 52.7370057
        },
        "5016": {
            "name": "Повалиха",
            "population": 3089,
            "type": "village",
            "poly": [
                [
                    83.7494346,
                    53.4946347
                ],
                [
                    83.7502394,
                    53.4975071
                ],
                [
                    83.7526536,
                    53.4989432
                ],
                [
                    83.7521171,
                    53.5002197
                ],
                [
                    83.7545314,
                    53.5008579
                ],
                [
                    83.7561409,
                    53.5003792
                ],
                [
                    83.7643226,
                    53.5022142
                ],
                [
                    83.7643226,
                    53.5054051
                ],
                [
                    83.7633837,
                    53.5072398
                ],
                [
                    83.7628472,
                    53.5121851
                ],
                [
                    83.760567,
                    53.5123446
                ],
                [
                    83.7604329,
                    53.5133814
                ],
                [
                    83.7647249,
                    53.5175285
                ],
                [
                    83.7602988,
                    53.5197614
                ],
                [
                    83.7622084,
                    53.5205871
                ],
                [
                    83.7610383,
                    53.5214567
                ],
                [
                    83.7633111,
                    53.5220588
                ],
                [
                    83.7650213,
                    53.5204667
                ],
                [
                    83.7679241,
                    53.5214434
                ],
                [
                    83.7667765,
                    53.5222995
                ],
                [
                    83.7705344,
                    53.5244132
                ],
                [
                    83.7681041,
                    53.5257509
                ],
                [
                    83.7697018,
                    53.5266606
                ],
                [
                    83.7736847,
                    53.5245069
                ],
                [
                    83.7754174,
                    53.5273695
                ],
                [
                    83.7770826,
                    53.5292154
                ],
                [
                    83.7795579,
                    53.5302453
                ],
                [
                    83.7823482,
                    53.530874
                ],
                [
                    83.7837434,
                    53.5290281
                ],
                [
                    83.7796029,
                    53.527637
                ],
                [
                    83.7819432,
                    53.5257376
                ],
                [
                    83.7778702,
                    53.5226741
                ],
                [
                    83.780278,
                    53.5219116
                ],
                [
                    83.7841709,
                    53.5242527
                ],
                [
                    83.7838334,
                    53.5255503
                ],
                [
                    83.785026,
                    53.5261389
                ],
                [
                    83.789684,
                    53.5244266
                ],
                [
                    83.7956472,
                    53.5239183
                ],
                [
                    83.7992701,
                    53.5247477
                ],
                [
                    83.8001252,
                    53.5241591
                ],
                [
                    83.8008228,
                    53.5223129
                ],
                [
                    83.8002827,
                    53.5207878
                ],
                [
                    83.8032755,
                    53.520159
                ],
                [
                    83.802713,
                    53.5189416
                ],
                [
                    83.7977624,
                    53.5192225
                ],
                [
                    83.7973349,
                    53.5217778
                ],
                [
                    83.7950846,
                    53.5219517
                ],
                [
                    83.7897515,
                    53.5188078
                ],
                [
                    83.7814256,
                    53.5189817
                ],
                [
                    83.7820107,
                    53.5182325
                ],
                [
                    83.7818531,
                    53.5165065
                ],
                [
                    83.7860611,
                    53.5151284
                ],
                [
                    83.7842834,
                    53.5120642
                ],
                [
                    83.7868149,
                    53.5104151
                ],
                [
                    83.7820244,
                    53.5038806
                ],
                [
                    83.7827276,
                    53.502652
                ],
                [
                    83.7783326,
                    53.4991489
                ],
                [
                    83.7789918,
                    53.4984431
                ],
                [
                    83.7791675,
                    53.4964561
                ],
                [
                    83.7768822,
                    53.4945475
                ],
                [
                    83.7705973,
                    53.4922466
                ],
                [
                    83.7694986,
                    53.4940769
                ],
                [
                    83.7647959,
                    53.4930833
                ],
                [
                    83.7633016,
                    53.4950704
                ],
                [
                    83.7676965,
                    53.4959593
                ],
                [
                    83.7672131,
                    53.4969528
                ],
                [
                    83.762071,
                    53.4985215
                ],
                [
                    83.7576759,
                    53.498077
                ],
                [
                    83.7572804,
                    53.4986784
                ],
                [
                    83.7557861,
                    53.4982339
                ],
                [
                    83.7534128,
                    53.4972404
                ],
                [
                    83.75091,
                    53.4941559
                ],
                [
                    83.7494346,
                    53.4946347
                ]
            ],
            "longitude": 83.768364,
            "latitude": 53.512199
        },
        "5017": {
            "name": "Верх-Слюдянка",
            "population": 183,
            "type": "village",
            "poly": null,
            "longitude": 83.77862,
            "latitude": 51.7906901
        },
        "5018": {
            "name": "Краснодарское",
            "population": 441,
            "type": "village",
            "poly": null,
            "longitude": 83.7981911,
            "latitude": 52.1157976
        },
        "5019": {
            "name": "Михайловка",
            "population": 1892,
            "type": "village",
            "poly": [
                [
                    83.7648236,
                    51.9560521
                ],
                [
                    83.8288084,
                    51.9706063
                ],
                [
                    83.8392733,
                    51.9706063
                ],
                [
                    83.8395723,
                    51.9674748
                ],
                [
                    83.8183437,
                    51.9608426
                ],
                [
                    83.7746905,
                    51.9457324
                ],
                [
                    83.7648236,
                    51.9560521
                ]
            ],
            "longitude": 83.79861,
            "latitude": 51.9573419
        },
        "5020": {
            "name": "Загайново",
            "population": 544,
            "type": "village",
            "poly": null,
            "longitude": 83.8184074,
            "latitude": 54.067081
        },
        "5021": {
            "name": "Восточный",
            "population": 306,
            "type": "village",
            "poly": null,
            "longitude": 83.8245548,
            "latitude": 53.7311898
        },
        "5022": {
            "name": "Малый Бащелак",
            "population": 1135,
            "type": "village",
            "poly": [
                [
                    83.8011012,
                    51.4907779
                ],
                [
                    83.8336916,
                    51.5010158
                ],
                [
                    83.8396715,
                    51.4961764
                ],
                [
                    83.8399705,
                    51.4913364
                ],
                [
                    83.8307016,
                    51.4835167
                ],
                [
                    83.8011012,
                    51.4907779
                ]
            ],
            "longitude": 83.8271137,
            "latitude": 51.4911502
        },
        "5023": {
            "name": "Казачий",
            "population": 919,
            "type": "village",
            "poly": null,
            "longitude": 83.840508,
            "latitude": 53.5316437
        },
        "5024": {
            "name": "Рассказиха",
            "population": 516,
            "type": "village",
            "poly": [
                [
                    83.814962,
                    53.0873031
                ],
                [
                    83.8226448,
                    53.0946918
                ],
                [
                    83.8368285,
                    53.101434
                ],
                [
                    83.8409117,
                    53.1078205
                ],
                [
                    83.8446189,
                    53.1086912
                ],
                [
                    83.8503138,
                    53.1040146
                ],
                [
                    83.8556865,
                    53.0967242
                ],
                [
                    83.8601994,
                    53.0891745
                ],
                [
                    83.8509048,
                    53.0832694
                ],
                [
                    83.8429533,
                    53.0776216
                ],
                [
                    83.8395165,
                    53.0768062
                ],
                [
                    83.814962,
                    53.0873031
                ]
            ],
            "longitude": 83.841705,
            "latitude": 53.08984
        },
        "5025": {
            "name": "Боровиха",
            "population": 7507,
            "type": "village",
            "poly": [
                [
                    83.8119424,
                    53.4988122
                ],
                [
                    83.813187,
                    53.5104359
                ],
                [
                    83.8202766,
                    53.5170453
                ],
                [
                    83.8243793,
                    53.5213268
                ],
                [
                    83.8338293,
                    53.5243782
                ],
                [
                    83.8506864,
                    53.5224494
                ],
                [
                    83.8640417,
                    53.5124418
                ],
                [
                    83.8717664,
                    53.5005377
                ],
                [
                    83.8623508,
                    53.4918681
                ],
                [
                    83.8492959,
                    53.4906834
                ],
                [
                    83.8359836,
                    53.4930323
                ],
                [
                    83.8241733,
                    53.494028
                ],
                [
                    83.8119424,
                    53.4988122
                ]
            ],
            "longitude": 83.842514,
            "latitude": 53.506401
        },
        "5026": {
            "name": "Октябрьское",
            "population": 392,
            "type": "village",
            "poly": null,
            "longitude": 83.8449403,
            "latitude": 53.5699706
        },
        "5027": {
            "name": "Чеканиха",
            "population": 165,
            "type": "village",
            "poly": null,
            "longitude": 83.8505582,
            "latitude": 52.3663201
        },
        "5028": {
            "name": "Подсобное",
            "population": 365,
            "type": "village",
            "poly": [
                [
                    83.8552117,
                    53.5760466
                ],
                [
                    83.8613057,
                    53.579382
                ],
                [
                    83.8667903,
                    53.5792024
                ],
                [
                    83.8697021,
                    53.5783985
                ],
                [
                    83.8736996,
                    53.5756275
                ],
                [
                    83.8677086,
                    53.5703155
                ],
                [
                    83.8552117,
                    53.5760466
                ]
            ],
            "longitude": 83.8642454,
            "latitude": 53.5756989
        },
        "5029": {
            "name": "Зудилово",
            "population": 4326,
            "type": "village",
            "poly": [
                [
                    83.864853,
                    53.4782719
                ],
                [
                    83.8698333,
                    53.4916737
                ],
                [
                    83.8760131,
                    53.4956565
                ],
                [
                    83.9141219,
                    53.5092361
                ],
                [
                    83.9247649,
                    53.5030084
                ],
                [
                    83.901419,
                    53.4892224
                ],
                [
                    83.8957542,
                    53.4782928
                ],
                [
                    83.8900893,
                    53.4762349
                ],
                [
                    83.8828795,
                    53.4710388
                ],
                [
                    83.8736291,
                    53.4708876
                ],
                [
                    83.864853,
                    53.4782719
                ]
            ],
            "longitude": 83.882668,
            "latitude": 53.47662
        },
        "5030": {
            "name": "Бобровка",
            "population": 3251,
            "type": "village",
            "poly": [
                [
                    83.8560685,
                    53.1859838
                ],
                [
                    83.8588666,
                    53.1936054
                ],
                [
                    83.8819894,
                    53.2014054
                ],
                [
                    83.9010953,
                    53.1906228
                ],
                [
                    83.9100217,
                    53.1874343
                ],
                [
                    83.9347409,
                    53.1784846
                ],
                [
                    83.9386891,
                    53.161403
                ],
                [
                    83.9196347,
                    53.1560507
                ],
                [
                    83.8616131,
                    53.1506978
                ],
                [
                    83.8560685,
                    53.1859838
                ]
            ],
            "longitude": 83.884911,
            "latitude": 53.172817
        },
        "5031": {
            "name": "Инюшово",
            "population": 51,
            "type": "village",
            "poly": null,
            "longitude": 83.8989675,
            "latitude": 53.9288552
        },
        "5032": {
            "name": "Белоярск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 83.904831,
            "latitude": 53.453388
        },
        "5033": {
            "name": "Чистые Пруды",
            "population": null,
            "type": "village",
            "poly": [
                [
                    83.9174575,
                    53.3150191
                ],
                [
                    83.9199251,
                    53.3171982
                ],
                [
                    83.9246029,
                    53.3181596
                ],
                [
                    83.9282293,
                    53.3181596
                ],
                [
                    83.9284438,
                    53.317006
                ],
                [
                    83.9322418,
                    53.3162753
                ],
                [
                    83.9337867,
                    53.31566
                ],
                [
                    83.9353532,
                    53.3146601
                ],
                [
                    83.9283365,
                    53.3129551
                ],
                [
                    83.9234657,
                    53.3114295
                ],
                [
                    83.9230365,
                    53.3116731
                ],
                [
                    83.920762,
                    53.313391
                ],
                [
                    83.9174575,
                    53.3150191
                ]
            ],
            "longitude": 83.9284142,
            "latitude": 53.3154707
        },
        "5034": {
            "name": "Новокраюшкино",
            "population": 327,
            "type": "village",
            "poly": null,
            "longitude": 83.9409639,
            "latitude": 53.771522
        },
        "5035": {
            "name": "Фирсово",
            "population": 807,
            "type": "village",
            "poly": [
                [
                    83.9282293,
                    53.3181596
                ],
                [
                    83.9287243,
                    53.3183889
                ],
                [
                    83.9379919,
                    53.3215946
                ],
                [
                    83.9409531,
                    53.3285666
                ],
                [
                    83.9504803,
                    53.3318202
                ],
                [
                    83.980006,
                    53.3207487
                ],
                [
                    83.9982451,
                    53.3194925
                ],
                [
                    84.0024937,
                    53.3187222
                ],
                [
                    84.0024728,
                    53.3133606
                ],
                [
                    83.9879883,
                    53.3053906
                ],
                [
                    83.9682471,
                    53.302262
                ],
                [
                    83.9569176,
                    53.3153394
                ],
                [
                    83.9444314,
                    53.3155701
                ],
                [
                    83.9356765,
                    53.3146472
                ],
                [
                    83.9353532,
                    53.3146601
                ],
                [
                    83.9337867,
                    53.31566
                ],
                [
                    83.9322418,
                    53.3162753
                ],
                [
                    83.9284438,
                    53.317006
                ],
                [
                    83.9282293,
                    53.3181596
                ]
            ],
            "longitude": 83.955177,
            "latitude": 53.317245
        },
        "5036": {
            "name": "Шадринцево",
            "population": 689,
            "type": "village",
            "poly": null,
            "longitude": 83.9626408,
            "latitude": 53.9455536
        },
        "5037": {
            "name": "Александровка",
            "population": 110,
            "type": "village",
            "poly": null,
            "longitude": 83.9648558,
            "latitude": 51.6747271
        },
        "5038": {
            "name": "Большой Бащелак",
            "population": 279,
            "type": "village",
            "poly": null,
            "longitude": 83.972635,
            "latitude": 51.5362606
        },
        "5039": {
            "name": "Санниково",
            "population": 2720,
            "type": "village",
            "poly": [
                [
                    83.9424964,
                    53.3314121
                ],
                [
                    83.9448996,
                    53.3441219
                ],
                [
                    83.9585554,
                    53.3670412
                ],
                [
                    84.0119335,
                    53.3663242
                ],
                [
                    84.0224048,
                    53.3662216
                ],
                [
                    84.0083705,
                    53.3448143
                ],
                [
                    84.0029212,
                    53.3397149
                ],
                [
                    83.9909049,
                    53.3347949
                ],
                [
                    83.9642202,
                    53.3288235
                ],
                [
                    83.9524528,
                    53.3332573
                ],
                [
                    83.9424964,
                    53.3314121
                ]
            ],
            "longitude": 83.972717,
            "latitude": 53.354343
        },
        "5040": {
            "name": "Листвянка",
            "population": 204,
            "type": "village",
            "poly": [
                [
                    83.9503648,
                    52.7561769
                ],
                [
                    83.9516764,
                    52.7593521
                ],
                [
                    83.9600384,
                    52.7624279
                ],
                [
                    83.9741389,
                    52.7631224
                ],
                [
                    83.9856161,
                    52.7560776
                ],
                [
                    83.9787298,
                    52.7533984
                ],
                [
                    83.957251,
                    52.7485355
                ],
                [
                    83.9503648,
                    52.7561769
                ]
            ],
            "longitude": 83.9732993,
            "latitude": 52.755417
        },
        "5041": {
            "name": "Антоньевка",
            "population": 1456,
            "type": "village",
            "poly": null,
            "longitude": 83.9736616,
            "latitude": 51.9959625
        },
        "5042": {
            "name": "Лесной",
            "population": 808,
            "type": "village",
            "poly": [
                [
                    83.9576577,
                    53.2346721
                ],
                [
                    83.9593742,
                    53.2375489
                ],
                [
                    83.9635799,
                    53.242326
                ],
                [
                    83.970677,
                    53.2471193
                ],
                [
                    83.978373,
                    53.2504767
                ],
                [
                    83.9848103,
                    53.2528902
                ],
                [
                    83.986956,
                    53.2513497
                ],
                [
                    83.9866985,
                    53.2458032
                ],
                [
                    83.9717339,
                    53.2367784
                ],
                [
                    83.9649533,
                    53.2325658
                ],
                [
                    83.9599751,
                    53.2325658
                ],
                [
                    83.9576577,
                    53.2346721
                ]
            ],
            "longitude": 83.9737015,
            "latitude": 53.2437117
        },
        "5043": {
            "name": "Северный",
            "population": 1306,
            "type": "village",
            "poly": null,
            "longitude": 83.9875447,
            "latitude": 53.8308719
        },
        "5044": {
            "name": "Солнечное",
            "population": 525,
            "type": "village",
            "poly": [
                [
                    83.9912757,
                    53.3897429
                ],
                [
                    83.9913821,
                    53.3910053
                ],
                [
                    83.9914672,
                    53.3923565
                ],
                [
                    83.9925522,
                    53.3934031
                ],
                [
                    83.9924245,
                    53.394399
                ],
                [
                    83.993967,
                    53.3942341
                ],
                [
                    83.9946903,
                    53.3942658
                ],
                [
                    83.9948392,
                    53.3934285
                ],
                [
                    83.9961795,
                    53.3933841
                ],
                [
                    83.9962221,
                    53.393771
                ],
                [
                    83.9962924,
                    53.3942956
                ],
                [
                    84.0025579,
                    53.3941548
                ],
                [
                    84.006164,
                    53.3941158
                ],
                [
                    84.005928,
                    53.3913007
                ],
                [
                    83.9995091,
                    53.3897429
                ],
                [
                    83.997924,
                    53.3891636
                ],
                [
                    83.9922969,
                    53.387789
                ],
                [
                    83.9919139,
                    53.3882013
                ],
                [
                    83.9913502,
                    53.38862
                ],
                [
                    83.9912757,
                    53.3897429
                ]
            ],
            "longitude": 83.9953458,
            "latitude": 53.393218
        },
        "5045": {
            "name": "Бажево",
            "population": 973,
            "type": "village",
            "poly": [
                [
                    83.9824846,
                    53.4153277
                ],
                [
                    83.982837,
                    53.4174052
                ],
                [
                    83.9863553,
                    53.4177478
                ],
                [
                    83.9895667,
                    53.4176808
                ],
                [
                    83.9902442,
                    53.4180747
                ],
                [
                    83.9906197,
                    53.4185929
                ],
                [
                    83.9913873,
                    53.4191843
                ],
                [
                    83.99186,
                    53.4226871
                ],
                [
                    84.000855,
                    53.4286901
                ],
                [
                    84.008951,
                    53.4259054
                ],
                [
                    84.003298,
                    53.4192601
                ],
                [
                    84.0002424,
                    53.4190168
                ],
                [
                    84.0008909,
                    53.4183953
                ],
                [
                    84.0003856,
                    53.4174311
                ],
                [
                    84.0002928,
                    53.416862
                ],
                [
                    84.0005519,
                    53.4160109
                ],
                [
                    84.001738,
                    53.4149434
                ],
                [
                    84.0010964,
                    53.4139522
                ],
                [
                    84.0000466,
                    53.4124433
                ],
                [
                    83.9985939,
                    53.4120133
                ],
                [
                    83.997506,
                    53.4113546
                ],
                [
                    83.9965411,
                    53.4111093
                ],
                [
                    83.9937928,
                    53.4097449
                ],
                [
                    83.9921019,
                    53.4100062
                ],
                [
                    83.9917264,
                    53.4105942
                ],
                [
                    83.9908353,
                    53.4111125
                ],
                [
                    83.9899218,
                    53.4117261
                ],
                [
                    83.9882657,
                    53.4125271
                ],
                [
                    83.9886118,
                    53.4138115
                ],
                [
                    83.9867797,
                    53.414028
                ],
                [
                    83.9858041,
                    53.4145459
                ],
                [
                    83.9845026,
                    53.415052
                ],
                [
                    83.9834834,
                    53.4149245
                ],
                [
                    83.9824846,
                    53.4153277
                ]
            ],
            "longitude": 83.9958345,
            "latitude": 53.416476
        },
        "5046": {
            "name": "Новый",
            "population": 400,
            "type": "village",
            "poly": null,
            "longitude": 83.9989541,
            "latitude": 53.3848473
        },
        "5047": {
            "name": "Берёзовка",
            "population": 4836,
            "type": "village",
            "poly": [
                [
                    83.9879076,
                    53.4078922
                ],
                [
                    83.9891951,
                    53.4085574
                ],
                [
                    83.9944821,
                    53.4089002
                ],
                [
                    83.9979498,
                    53.4105016
                ],
                [
                    84.0014689,
                    53.4130595
                ],
                [
                    84.0025804,
                    53.4150036
                ],
                [
                    84.0082452,
                    53.4185332
                ],
                [
                    84.0142532,
                    53.4167428
                ],
                [
                    84.0174291,
                    53.4145943
                ],
                [
                    84.0200897,
                    53.4132642
                ],
                [
                    84.0252397,
                    53.4129061
                ],
                [
                    84.031162,
                    53.4115248
                ],
                [
                    84.0315911,
                    53.4091201
                ],
                [
                    84.0320203,
                    53.4056921
                ],
                [
                    84.030132,
                    53.4034406
                ],
                [
                    84.0285011,
                    53.4024172
                ],
                [
                    84.0305065,
                    53.39663
                ],
                [
                    84.0257536,
                    53.3947677
                ],
                [
                    84.0196886,
                    53.3942041
                ],
                [
                    84.0137652,
                    53.3941522
                ],
                [
                    84.0079018,
                    53.3943825
                ],
                [
                    84.004812,
                    53.3944849
                ],
                [
                    84.0017221,
                    53.3945873
                ],
                [
                    83.9971773,
                    53.3947408
                ],
                [
                    83.9906596,
                    53.3948873
                ],
                [
                    83.9903109,
                    53.4019055
                ],
                [
                    83.9896242,
                    53.4046175
                ],
                [
                    83.9879076,
                    53.4078922
                ]
            ],
            "longitude": 83.999664,
            "latitude": 53.406292
        },
        "5048": {
            "name": "Ильича",
            "population": 505,
            "type": "village",
            "poly": [
                [
                    83.9799658,
                    53.5485189
                ],
                [
                    84.0009943,
                    53.555325
                ],
                [
                    84.0147723,
                    53.5590189
                ],
                [
                    84.0172142,
                    53.5583586
                ],
                [
                    84.024896,
                    53.5575174
                ],
                [
                    84.0246386,
                    53.5509156
                ],
                [
                    84.0293635,
                    53.5425227
                ],
                [
                    84.0224542,
                    53.5362999
                ],
                [
                    84.0057129,
                    53.5312534
                ],
                [
                    83.9799658,
                    53.5485189
                ]
            ],
            "longitude": 84.0151156,
            "latitude": 53.5523141
        },
        "5049": {
            "name": "Акулово",
            "population": 731,
            "type": "village",
            "poly": null,
            "longitude": 84.0219641,
            "latitude": 53.9175092
        },
        "5050": {
            "name": "Первомайское",
            "population": 4821,
            "type": "village",
            "poly": null,
            "longitude": 84.0307415,
            "latitude": 53.7274811
        },
        "5051": {
            "name": "Сосновка",
            "population": 645,
            "type": "village",
            "poly": null,
            "longitude": 84.0310129,
            "latitude": 53.121701
        },
        "5052": {
            "name": "Сибирячиха",
            "population": 919,
            "type": "village",
            "poly": [
                [
                    84.0326146,
                    51.7611043
                ],
                [
                    84.0475644,
                    51.763325
                ],
                [
                    84.0574312,
                    51.7507396
                ],
                [
                    84.0454714,
                    51.7470375
                ],
                [
                    84.0326146,
                    51.7611043
                ]
            ],
            "longitude": 84.044876,
            "latitude": 51.756664
        },
        "5053": {
            "name": "Березовка",
            "population": 721,
            "type": "village",
            "poly": null,
            "longitude": 84.0510571,
            "latitude": 51.838031
        },
        "5054": {
            "name": "Новообинка",
            "population": 806,
            "type": "village",
            "poly": null,
            "longitude": 84.0567358,
            "latitude": 52.2318401
        },
        "5055": {
            "name": "Червянка",
            "population": 143,
            "type": "village",
            "poly": null,
            "longitude": 84.073459,
            "latitude": 52.6007019
        },
        "5056": {
            "name": "имени Калинина",
            "population": 269,
            "type": "village",
            "poly": null,
            "longitude": 84.0808026,
            "latitude": 52.1306152
        },
        "5057": {
            "name": "Красные Орлы",
            "population": 159,
            "type": "village",
            "poly": null,
            "longitude": 84.0825267,
            "latitude": 52.1470143
        },
        "5058": {
            "name": "Новоповалиха",
            "population": 342,
            "type": "village",
            "poly": [
                [
                    84.0694625,
                    53.7210937
                ],
                [
                    84.0776604,
                    53.7392806
                ],
                [
                    84.097643,
                    53.7383714
                ],
                [
                    84.1043039,
                    53.7232159
                ],
                [
                    84.0945688,
                    53.7162426
                ],
                [
                    84.0694625,
                    53.7210937
                ]
            ],
            "longitude": 84.0899574,
            "latitude": 53.7280663
        },
        "5059": {
            "name": "Тальменка",
            "population": 182,
            "type": "village",
            "poly": null,
            "longitude": 84.1144491,
            "latitude": 51.6335404
        },
        "5060": {
            "name": "Алексеевка",
            "population": 1354,
            "type": "village",
            "poly": null,
            "longitude": 84.1174863,
            "latitude": 52.0547069
        },
        "5061": {
            "name": "Николаевка",
            "population": 864,
            "type": "village",
            "poly": null,
            "longitude": 84.1253012,
            "latitude": 52.1906713
        },
        "5062": {
            "name": "Соловьиха",
            "population": 663,
            "type": "village",
            "poly": null,
            "longitude": 84.1266397,
            "latitude": 51.9641471
        },
        "5063": {
            "name": "Правда",
            "population": 447,
            "type": "village",
            "poly": [
                [
                    84.119738,
                    53.4386584
                ],
                [
                    84.1217551,
                    53.439323
                ],
                [
                    84.1241153,
                    53.4391441
                ],
                [
                    84.1287073,
                    53.4394253
                ],
                [
                    84.1310677,
                    53.4400132
                ],
                [
                    84.1321041,
                    53.4410319
                ],
                [
                    84.1358805,
                    53.4407507
                ],
                [
                    84.1372539,
                    53.4389613
                ],
                [
                    84.1362604,
                    53.4376102
                ],
                [
                    84.1375973,
                    53.4363282
                ],
                [
                    84.1381122,
                    53.4348198
                ],
                [
                    84.1269049,
                    53.431372
                ],
                [
                    84.1257462,
                    53.431551
                ],
                [
                    84.1260037,
                    53.4328294
                ],
                [
                    84.1251883,
                    53.4340822
                ],
                [
                    84.1229631,
                    53.4361492
                ],
                [
                    84.1259178,
                    53.4376102
                ],
                [
                    84.1249801,
                    53.4376575
                ],
                [
                    84.1228709,
                    53.4374824
                ],
                [
                    84.1201672,
                    53.43715
                ],
                [
                    84.119738,
                    53.4386584
                ]
            ],
            "longitude": 84.128471,
            "latitude": 53.4356
        },
        "5064": {
            "name": "Зеленый Дол",
            "population": 1374,
            "type": "village",
            "poly": null,
            "longitude": 84.1333214,
            "latitude": 52.1183842
        },
        "5065": {
            "name": "Сорочий Лог",
            "population": 1195,
            "type": "village",
            "poly": null,
            "longitude": 84.1450397,
            "latitude": 53.5747164
        },
        "5066": {
            "name": "Ануйский",
            "population": 149,
            "type": "village",
            "poly": null,
            "longitude": 84.1663489,
            "latitude": 51.7400107
        },
        "5067": {
            "name": "Баюновские Ключи",
            "population": 1569,
            "type": "village",
            "poly": null,
            "longitude": 84.1962172,
            "latitude": 53.3324596
        },
        "5068": {
            "name": "Логовское",
            "population": 1417,
            "type": "village",
            "poly": null,
            "longitude": 84.1980171,
            "latitude": 53.498537
        },
        "5069": {
            "name": "Юртное",
            "population": 261,
            "type": "village",
            "poly": null,
            "longitude": 84.2268113,
            "latitude": 51.8154246
        },
        "5070": {
            "name": "Журавлиха",
            "population": 880,
            "type": "village",
            "poly": [
                [
                    84.2129669,
                    53.7822788
                ],
                [
                    84.2308601,
                    53.7862269
                ],
                [
                    84.2382642,
                    53.7885092
                ],
                [
                    84.2411552,
                    53.7924455
                ],
                [
                    84.2487932,
                    53.7959125
                ],
                [
                    84.257186,
                    53.7880585
                ],
                [
                    84.2152787,
                    53.7755627
                ],
                [
                    84.2129669,
                    53.7822788
                ]
            ],
            "longitude": 84.2354715,
            "latitude": 53.7838051
        },
        "5071": {
            "name": "Большой Калтай",
            "population": 388,
            "type": "village",
            "poly": [
                [
                    84.2260328,
                    54.125799
                ],
                [
                    84.2279549,
                    54.1258322
                ],
                [
                    84.2351345,
                    54.128383
                ],
                [
                    84.2396006,
                    54.1293767
                ],
                [
                    84.2431056,
                    54.1313642
                ],
                [
                    84.2500024,
                    54.1301055
                ],
                [
                    84.2497199,
                    54.133716
                ],
                [
                    84.2436144,
                    54.1358026
                ],
                [
                    84.2391483,
                    54.1390152
                ],
                [
                    84.239544,
                    54.140373
                ],
                [
                    84.24825,
                    54.1397769
                ],
                [
                    84.2554296,
                    54.136465
                ],
                [
                    84.258652,
                    54.1349083
                ],
                [
                    84.2618178,
                    54.1316955
                ],
                [
                    84.2653228,
                    54.1324904
                ],
                [
                    84.267584,
                    54.1329541
                ],
                [
                    84.2707499,
                    54.1324573
                ],
                [
                    84.270015,
                    54.1303374
                ],
                [
                    84.273407,
                    54.1296749
                ],
                [
                    84.27352,
                    54.1262628
                ],
                [
                    84.2649271,
                    54.1207301
                ],
                [
                    84.2627789,
                    54.1220885
                ],
                [
                    84.2642487,
                    54.1243413
                ],
                [
                    84.2592173,
                    54.124507
                ],
                [
                    84.2563342,
                    54.1256334
                ],
                [
                    84.2536206,
                    54.1244076
                ],
                [
                    84.2530553,
                    54.1229167
                ],
                [
                    84.2484761,
                    54.1210283
                ],
                [
                    84.2411835,
                    54.1234137
                ],
                [
                    84.2390918,
                    54.121227
                ],
                [
                    84.2396571,
                    54.1190734
                ],
                [
                    84.2315729,
                    54.1171847
                ],
                [
                    84.2288029,
                    54.1175161
                ],
                [
                    84.2276157,
                    54.1187421
                ],
                [
                    84.236039,
                    54.1230824
                ],
                [
                    84.2326471,
                    54.1252027
                ],
                [
                    84.2295943,
                    54.1235794
                ],
                [
                    84.2261458,
                    54.1239769
                ],
                [
                    84.2260328,
                    54.125799
                ]
            ],
            "longitude": 84.259311,
            "latitude": 54.1293822
        },
        "5072": {
            "name": "Паутово",
            "population": 959,
            "type": "village",
            "poly": null,
            "longitude": 84.2655419,
            "latitude": 52.2140019
        },
        "5073": {
            "name": "Верх-Озёрное",
            "population": 454,
            "type": "village",
            "poly": [
                [
                    84.26215,
                    52.3272865
                ],
                [
                    84.2693025,
                    52.3298204
                ],
                [
                    84.2831928,
                    52.3369782
                ],
                [
                    84.29076,
                    52.3338112
                ],
                [
                    84.2783209,
                    52.3250691
                ],
                [
                    84.2695098,
                    52.3221547
                ],
                [
                    84.26215,
                    52.3272865
                ]
            ],
            "longitude": 84.2778026,
            "latitude": 52.329377
        },
        "5074": {
            "name": "Тележиха",
            "population": 263,
            "type": "village",
            "poly": null,
            "longitude": 84.280411,
            "latitude": 51.530369
        },
        "5075": {
            "name": "Куличье",
            "population": 46,
            "type": "village",
            "poly": [
                [
                    84.2734684,
                    53.0497716
                ],
                [
                    84.2760433,
                    53.0532799
                ],
                [
                    84.2825663,
                    53.0550339
                ],
                [
                    84.2878879,
                    53.0557561
                ],
                [
                    84.2978443,
                    53.0554466
                ],
                [
                    84.2988742,
                    53.054518
                ],
                [
                    84.2911495,
                    53.0501843
                ],
                [
                    84.2815363,
                    53.047295
                ],
                [
                    84.2775882,
                    53.0471918
                ],
                [
                    84.2734684,
                    53.0497716
                ]
            ],
            "longitude": 84.2898495,
            "latitude": 53.0515584
        },
        "5076": {
            "name": "Черёмушкино",
            "population": 1060,
            "type": "village",
            "poly": null,
            "longitude": 84.2902284,
            "latitude": 54.0102841
        },
        "5077": {
            "name": "Думчево",
            "population": 612,
            "type": "village",
            "poly": null,
            "longitude": 84.2911325,
            "latitude": 53.9571112
        },
        "5078": {
            "name": "Черемшанка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.2918917,
            "latitude": 51.7508364
        },
        "5079": {
            "name": "Озеро-Петровское",
            "population": 501,
            "type": "village",
            "poly": [
                [
                    84.2784874,
                    52.9485637
                ],
                [
                    84.288886,
                    52.9514898
                ],
                [
                    84.2968546,
                    52.9540355
                ],
                [
                    84.3091631,
                    52.9570523
                ],
                [
                    84.319176,
                    52.9603161
                ],
                [
                    84.3276661,
                    52.9603443
                ],
                [
                    84.3098061,
                    52.9487679
                ],
                [
                    84.3048003,
                    52.9439763
                ],
                [
                    84.2974923,
                    52.9401407
                ],
                [
                    84.2960511,
                    52.9396862
                ],
                [
                    84.2944581,
                    52.939175
                ],
                [
                    84.2914584,
                    52.939188
                ],
                [
                    84.2877697,
                    52.9393743
                ],
                [
                    84.2865971,
                    52.9397435
                ],
                [
                    84.288243,
                    52.940738
                ],
                [
                    84.2841094,
                    52.9398385
                ],
                [
                    84.2799759,
                    52.9387866
                ],
                [
                    84.2814915,
                    52.940392
                ],
                [
                    84.2868652,
                    52.9412639
                ],
                [
                    84.2837899,
                    52.9434279
                ],
                [
                    84.281813,
                    52.9433536
                ],
                [
                    84.2784874,
                    52.9485637
                ]
            ],
            "longitude": 84.2969052,
            "latitude": 52.9442087
        },
        "5080": {
            "name": "Новоберёзовка",
            "population": 421,
            "type": "village",
            "poly": [
                [
                    84.2905156,
                    53.7480941
                ],
                [
                    84.2990935,
                    53.7533228
                ],
                [
                    84.310319,
                    53.7544812
                ],
                [
                    84.3108485,
                    53.7499728
                ],
                [
                    84.308201,
                    53.7448689
                ],
                [
                    84.3026941,
                    53.7438982
                ],
                [
                    84.2946986,
                    53.7453073
                ],
                [
                    84.2905156,
                    53.7480941
                ]
            ],
            "longitude": 84.3020943,
            "latitude": 53.748849
        },
        "5081": {
            "name": "Жилино",
            "population": 937,
            "type": "village",
            "poly": [
                [
                    84.2863194,
                    53.4022791
                ],
                [
                    84.2915939,
                    53.4064165
                ],
                [
                    84.2997237,
                    53.4071258
                ],
                [
                    84.3058178,
                    53.4099835
                ],
                [
                    84.3089904,
                    53.4087721
                ],
                [
                    84.3136998,
                    53.4104564
                ],
                [
                    84.31831,
                    53.4111655
                ],
                [
                    84.3253493,
                    53.4104269
                ],
                [
                    84.3257458,
                    53.407324
                ],
                [
                    84.319004,
                    53.4069695
                ],
                [
                    84.3175665,
                    53.4051078
                ],
                [
                    84.314493,
                    53.4029504
                ],
                [
                    84.3128076,
                    53.4009998
                ],
                [
                    84.3097119,
                    53.4018332
                ],
                [
                    84.3087922,
                    53.4016499
                ],
                [
                    84.3063874,
                    53.4005357
                ],
                [
                    84.3024204,
                    53.3994655
                ],
                [
                    84.2988908,
                    53.3988743
                ],
                [
                    84.2969476,
                    53.4001512
                ],
                [
                    84.2940526,
                    53.4001512
                ],
                [
                    84.2903247,
                    53.3983305
                ],
                [
                    84.2863194,
                    53.4022791
                ]
            ],
            "longitude": 84.3105087,
            "latitude": 53.405993
        },
        "5082": {
            "name": "Солонешное",
            "population": 4441,
            "type": "village",
            "poly": [
                [
                    84.2680945,
                    51.6673655
                ],
                [
                    84.2684247,
                    51.6679253
                ],
                [
                    84.269888,
                    51.6685345
                ],
                [
                    84.2704774,
                    51.6685645
                ],
                [
                    84.2707621,
                    51.6687199
                ],
                [
                    84.2720711,
                    51.6679693
                ],
                [
                    84.2721266,
                    51.668137
                ],
                [
                    84.2728043,
                    51.6722483
                ],
                [
                    84.2717964,
                    51.672647
                ],
                [
                    84.2726739,
                    51.6743602
                ],
                [
                    84.2700154,
                    51.6752062
                ],
                [
                    84.2700935,
                    51.675481
                ],
                [
                    84.2697285,
                    51.6756372
                ],
                [
                    84.2699198,
                    51.675885
                ],
                [
                    84.2705627,
                    51.6758689
                ],
                [
                    84.2712838,
                    51.6757665
                ],
                [
                    84.2723438,
                    51.6753193
                ],
                [
                    84.2730388,
                    51.6753624
                ],
                [
                    84.2739685,
                    51.6743657
                ],
                [
                    84.274568,
                    51.6734821
                ],
                [
                    84.2750024,
                    51.6724638
                ],
                [
                    84.2751153,
                    51.6716125
                ],
                [
                    84.2751327,
                    51.6702169
                ],
                [
                    84.2761492,
                    51.6696242
                ],
                [
                    84.2778173,
                    51.6688968
                ],
                [
                    84.2790771,
                    51.6684495
                ],
                [
                    84.2810928,
                    51.66804
                ],
                [
                    84.2814837,
                    51.6680453
                ],
                [
                    84.2829607,
                    51.6677975
                ],
                [
                    84.28376,
                    51.6674688
                ],
                [
                    84.2843594,
                    51.666946
                ],
                [
                    84.2846723,
                    51.6663102
                ],
                [
                    84.2848808,
                    51.6657983
                ],
                [
                    84.2852718,
                    51.6655127
                ],
                [
                    84.2858713,
                    51.6652325
                ],
                [
                    84.2867488,
                    51.6650924
                ],
                [
                    84.2876958,
                    51.6651301
                ],
                [
                    84.2899199,
                    51.6659115
                ],
                [
                    84.2914143,
                    51.6663965
                ],
                [
                    84.292648,
                    51.6670269
                ],
                [
                    84.2938557,
                    51.667582
                ],
                [
                    84.2944639,
                    51.6674904
                ],
                [
                    84.2952458,
                    51.6671831
                ],
                [
                    84.2959495,
                    51.6669892
                ],
                [
                    84.2968792,
                    51.6666174
                ],
                [
                    84.2975916,
                    51.6661324
                ],
                [
                    84.2980173,
                    51.666057
                ],
                [
                    84.2985039,
                    51.6657498
                ],
                [
                    84.2990511,
                    51.6654696
                ],
                [
                    84.299642,
                    51.665297
                ],
                [
                    84.3004586,
                    51.6652864
                ],
                [
                    84.3007367,
                    51.6652648
                ],
                [
                    84.3011277,
                    51.6651786
                ],
                [
                    84.3014318,
                    51.6651247
                ],
                [
                    84.3016229,
                    51.6651355
                ],
                [
                    84.3021095,
                    51.6652379
                ],
                [
                    84.3025699,
                    51.6652593
                ],
                [
                    84.3030912,
                    51.6652486
                ],
                [
                    84.3034214,
                    51.665297
                ],
                [
                    84.303934,
                    51.6654319
                ],
                [
                    84.3043771,
                    51.6655828
                ],
                [
                    84.3049852,
                    51.665572
                ],
                [
                    84.3054457,
                    51.665297
                ],
                [
                    84.3058367,
                    51.6652271
                ],
                [
                    84.306358,
                    51.6648014
                ],
                [
                    84.3068549,
                    51.6645634
                ],
                [
                    84.3072933,
                    51.6645334
                ],
                [
                    84.3078455,
                    51.6646199
                ],
                [
                    84.3074776,
                    51.6652238
                ],
                [
                    84.3067339,
                    51.666418
                ],
                [
                    84.306157,
                    51.6670301
                ],
                [
                    84.3058025,
                    51.6676379
                ],
                [
                    84.3053855,
                    51.6688536
                ],
                [
                    84.3051909,
                    51.6690864
                ],
                [
                    84.3045654,
                    51.6692459
                ],
                [
                    84.3055176,
                    51.6693838
                ],
                [
                    84.3067547,
                    51.6694355
                ],
                [
                    84.3073595,
                    51.6692933
                ],
                [
                    84.3083464,
                    51.6687674
                ],
                [
                    84.3095697,
                    51.6682932
                ],
                [
                    84.3107026,
                    51.6681552
                ],
                [
                    84.3125376,
                    51.6679569
                ],
                [
                    84.3150468,
                    51.6679052
                ],
                [
                    84.3164577,
                    51.6673836
                ],
                [
                    84.3187097,
                    51.6673233
                ],
                [
                    84.3199608,
                    51.6680216
                ],
                [
                    84.32092,
                    51.6674224
                ],
                [
                    84.3198565,
                    51.6667283
                ],
                [
                    84.3189808,
                    51.6670991
                ],
                [
                    84.3188209,
                    51.6669611
                ],
                [
                    84.3187236,
                    51.6666163
                ],
                [
                    84.3187444,
                    51.6662929
                ],
                [
                    84.3190086,
                    51.666155
                ],
                [
                    84.3194743,
                    51.6660558
                ],
                [
                    84.3199399,
                    51.666142
                ],
                [
                    84.3213022,
                    51.6668016
                ],
                [
                    84.3219278,
                    51.6670258
                ],
                [
                    84.3226645,
                    51.6671767
                ],
                [
                    84.3231511,
                    51.6672241
                ],
                [
                    84.3253822,
                    51.6681164
                ],
                [
                    84.3275855,
                    51.6686079
                ],
                [
                    84.3319713,
                    51.668707
                ],
                [
                    84.3359887,
                    51.6692804
                ],
                [
                    84.337615,
                    51.6696209
                ],
                [
                    84.3410348,
                    51.6714658
                ],
                [
                    84.3421817,
                    51.6708279
                ],
                [
                    84.3427516,
                    51.6709356
                ],
                [
                    84.3429948,
                    51.6708106
                ],
                [
                    84.3433076,
                    51.6708667
                ],
                [
                    84.3435509,
                    51.6709744
                ],
                [
                    84.3440791,
                    51.6712632
                ],
                [
                    84.344663,
                    51.6712762
                ],
                [
                    84.3453441,
                    51.6709788
                ],
                [
                    84.3452885,
                    51.6701511
                ],
                [
                    84.3459627,
                    51.6701339
                ],
                [
                    84.3464979,
                    51.6703235
                ],
                [
                    84.3467899,
                    51.6708279
                ],
                [
                    84.347325,
                    51.6710348
                ],
                [
                    84.3489237,
                    51.6709141
                ],
                [
                    84.3495562,
                    51.6694873
                ],
                [
                    84.3458515,
                    51.6692502
                ],
                [
                    84.3444128,
                    51.6688967
                ],
                [
                    84.3427724,
                    51.6681294
                ],
                [
                    84.3432033,
                    51.6674828
                ],
                [
                    84.341146,
                    51.666987
                ],
                [
                    84.3403675,
                    51.6668835
                ],
                [
                    84.3400409,
                    51.667444
                ],
                [
                    84.3386924,
                    51.6670732
                ],
                [
                    84.3370313,
                    51.6668232
                ],
                [
                    84.3345863,
                    51.666315
                ],
                [
                    84.3319729,
                    51.6656683
                ],
                [
                    84.3296862,
                    51.6644827
                ],
                [
                    84.3276288,
                    51.6634825
                ],
                [
                    84.325495,
                    51.6624651
                ],
                [
                    84.3240702,
                    51.6617881
                ],
                [
                    84.323243,
                    51.6612837
                ],
                [
                    84.3229372,
                    51.6608785
                ],
                [
                    84.3232848,
                    51.6603654
                ],
                [
                    84.3234446,
                    51.6588132
                ],
                [
                    84.3236809,
                    51.6587485
                ],
                [
                    84.3255715,
                    51.6588865
                ],
                [
                    84.3262318,
                    51.6584424
                ],
                [
                    84.3269198,
                    51.6583044
                ],
                [
                    84.3279208,
                    51.6583087
                ],
                [
                    84.328456,
                    51.6581276
                ],
                [
                    84.329012,
                    51.6573644
                ],
                [
                    84.3302283,
                    51.6564676
                ],
                [
                    84.3303743,
                    51.6557345
                ],
                [
                    84.3312918,
                    51.6549713
                ],
                [
                    84.3319382,
                    51.6537553
                ],
                [
                    84.3328695,
                    51.6514482
                ],
                [
                    84.3290467,
                    51.6507841
                ],
                [
                    84.3299502,
                    51.6488607
                ],
                [
                    84.3278165,
                    51.6485156
                ],
                [
                    84.3283308,
                    51.647459
                ],
                [
                    84.3288938,
                    51.6459495
                ],
                [
                    84.3304789,
                    51.6421702
                ],
                [
                    84.3307437,
                    51.6413664
                ],
                [
                    84.3306024,
                    51.6409094
                ],
                [
                    84.3327473,
                    51.6409009
                ],
                [
                    84.3327337,
                    51.6401764
                ],
                [
                    84.336752,
                    51.6403533
                ],
                [
                    84.3366977,
                    51.639831
                ],
                [
                    84.333874,
                    51.6387694
                ],
                [
                    84.3309282,
                    51.6390222
                ],
                [
                    84.3302494,
                    51.6379691
                ],
                [
                    84.3294485,
                    51.6375478
                ],
                [
                    84.3289055,
                    51.6375984
                ],
                [
                    84.3284688,
                    51.6369102
                ],
                [
                    84.3280566,
                    51.6369117
                ],
                [
                    84.327929,
                    51.636547
                ],
                [
                    84.3275478,
                    51.6360471
                ],
                [
                    84.326869,
                    51.6360977
                ],
                [
                    84.3273442,
                    51.6368476
                ],
                [
                    84.3271406,
                    51.6372099
                ],
                [
                    84.3222535,
                    51.6368644
                ],
                [
                    84.3190225,
                    51.6365274
                ],
                [
                    84.3175654,
                    51.6405869
                ],
                [
                    84.317559,
                    51.6405869
                ],
                [
                    84.3175428,
                    51.64058
                ],
                [
                    84.3175383,
                    51.6405868
                ],
                [
                    84.3159474,
                    51.6405766
                ],
                [
                    84.314774,
                    51.6408596
                ],
                [
                    84.3127446,
                    51.6428265
                ],
                [
                    84.3116992,
                    51.6433372
                ],
                [
                    84.3101252,
                    51.6452462
                ],
                [
                    84.3102987,
                    51.6462097
                ],
                [
                    84.3105478,
                    51.6466071
                ],
                [
                    84.3108058,
                    51.6474269
                ],
                [
                    84.3108147,
                    51.6490195
                ],
                [
                    84.3108859,
                    51.6494667
                ],
                [
                    84.3115174,
                    51.6506066
                ],
                [
                    84.3113885,
                    51.6518403
                ],
                [
                    84.3109626,
                    51.6529262
                ],
                [
                    84.3119509,
                    51.6553046
                ],
                [
                    84.3118966,
                    51.6566251
                ],
                [
                    84.311864,
                    51.6576627
                ],
                [
                    84.3116577,
                    51.6581141
                ],
                [
                    84.3106151,
                    51.6587406
                ],
                [
                    84.3091814,
                    51.6593672
                ],
                [
                    84.3087906,
                    51.6596703
                ],
                [
                    84.3084648,
                    51.6603373
                ],
                [
                    84.3084853,
                    51.6614278
                ],
                [
                    84.3067637,
                    51.6618969
                ],
                [
                    84.3055316,
                    51.6621177
                ],
                [
                    84.3032362,
                    51.6625012
                ],
                [
                    84.3003129,
                    51.6628149
                ],
                [
                    84.2966552,
                    51.6630089
                ],
                [
                    84.2962903,
                    51.6627664
                ],
                [
                    84.2952216,
                    51.6626533
                ],
                [
                    84.2943528,
                    51.6623892
                ],
                [
                    84.2931308,
                    51.6623572
                ],
                [
                    84.2923337,
                    51.6623638
                ],
                [
                    84.2913835,
                    51.6621144
                ],
                [
                    84.2903977,
                    51.6620371
                ],
                [
                    84.2891172,
                    51.6614493
                ],
                [
                    84.287171,
                    51.6612823
                ],
                [
                    84.2858243,
                    51.6610343
                ],
                [
                    84.2843647,
                    51.6605385
                ],
                [
                    84.2837652,
                    51.6602637
                ],
                [
                    84.28327,
                    51.6598702
                ],
                [
                    84.2833395,
                    51.6594714
                ],
                [
                    84.2829919,
                    51.659148
                ],
                [
                    84.2825402,
                    51.6592343
                ],
                [
                    84.2816019,
                    51.6584312
                ],
                [
                    84.2784165,
                    51.6586854
                ],
                [
                    84.2769681,
                    51.6589525
                ],
                [
                    84.2786656,
                    51.66116
                ],
                [
                    84.2787266,
                    51.6619906
                ],
                [
                    84.2782287,
                    51.6623748
                ],
                [
                    84.2783819,
                    51.6635583
                ],
                [
                    84.2740353,
                    51.6650982
                ],
                [
                    84.2734796,
                    51.6653597
                ],
                [
                    84.2725117,
                    51.665734
                ],
                [
                    84.2696101,
                    51.6664841
                ],
                [
                    84.2690133,
                    51.6667102
                ],
                [
                    84.268387,
                    51.6666565
                ],
                [
                    84.26816,
                    51.6667653
                ],
                [
                    84.2680945,
                    51.6673655
                ]
            ],
            "longitude": 84.318352,
            "latitude": 51.655628
        },
        "5083": {
            "name": "Украинский",
            "population": 883,
            "type": "village",
            "poly": [
                [
                    84.3203972,
                    53.3084095
                ],
                [
                    84.3257505,
                    53.3128492
                ],
                [
                    84.3314235,
                    53.3138517
                ],
                [
                    84.3412513,
                    53.3120854
                ],
                [
                    84.3496408,
                    53.3061656
                ],
                [
                    84.3413312,
                    53.3021072
                ],
                [
                    84.3351788,
                    53.3062134
                ],
                [
                    84.3322225,
                    53.3041126
                ],
                [
                    84.327828,
                    53.3067385
                ],
                [
                    84.3232736,
                    53.3080276
                ],
                [
                    84.3203972,
                    53.3084095
                ]
            ],
            "longitude": 84.336355,
            "latitude": 53.308261
        },
        "5084": {
            "name": "Озеро-Красилово",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 84.3676913,
            "latitude": 53.1755051
        },
        "5085": {
            "name": "Многоозёрный",
            "population": 714,
            "type": "village",
            "poly": null,
            "longitude": 84.376038,
            "latitude": 52.736439
        },
        "5086": {
            "name": "Камышенка",
            "population": 1425,
            "type": "village",
            "poly": null,
            "longitude": 84.3883498,
            "latitude": 52.0071568
        },
        "5087": {
            "name": "Искра",
            "population": 249,
            "type": "village",
            "poly": null,
            "longitude": 84.4014019,
            "latitude": 51.5627569
        },
        "5088": {
            "name": "Малахово",
            "population": 675,
            "type": "village",
            "poly": null,
            "longitude": 84.4031928,
            "latitude": 53.3545832
        },
        "5089": {
            "name": "Первомайский",
            "population": 177,
            "type": "village",
            "poly": null,
            "longitude": 84.4100027,
            "latitude": 51.7945264
        },
        "5090": {
            "name": "Лютаево",
            "population": 466,
            "type": "village",
            "poly": null,
            "longitude": 84.4213128,
            "latitude": 51.8829064
        },
        "5091": {
            "name": "Заводское",
            "population": 1331,
            "type": "village",
            "poly": [
                [
                    84.4037593,
                    53.0658661
                ],
                [
                    84.4164623,
                    53.0760768
                ],
                [
                    84.4458164,
                    53.0806141
                ],
                [
                    84.446503,
                    53.0641125
                ],
                [
                    84.4348301,
                    53.0608114
                ],
                [
                    84.4307101,
                    53.0630809
                ],
                [
                    84.425217,
                    53.0634936
                ],
                [
                    84.4250454,
                    53.0600893
                ],
                [
                    84.4181789,
                    53.0585418
                ],
                [
                    84.4059909,
                    53.0608114
                ],
                [
                    84.4061626,
                    53.064422
                ],
                [
                    84.4037593,
                    53.0658661
                ]
            ],
            "longitude": 84.422505,
            "latitude": 53.0694874
        },
        "5092": {
            "name": "Контошино",
            "population": 762,
            "type": "village",
            "poly": null,
            "longitude": 84.4272891,
            "latitude": 53.2219828
        },
        "5093": {
            "name": "Новопокровка",
            "population": 928,
            "type": "village",
            "poly": null,
            "longitude": 84.4459053,
            "latitude": 52.2204665
        },
        "5094": {
            "name": "Боровлянка",
            "population": 2029,
            "type": "village",
            "poly": null,
            "longitude": 84.4459172,
            "latitude": 52.6340372
        },
        "5095": {
            "name": "Приобское",
            "population": 782,
            "type": "village",
            "poly": [
                [
                    84.4448882,
                    52.3443544
                ],
                [
                    84.4475725,
                    52.3455423
                ],
                [
                    84.449643,
                    52.3457342
                ],
                [
                    84.4519545,
                    52.347168
                ],
                [
                    84.4530569,
                    52.3492317
                ],
                [
                    84.4517767,
                    52.3498617
                ],
                [
                    84.4516975,
                    52.3520938
                ],
                [
                    84.4541157,
                    52.352841
                ],
                [
                    84.4559084,
                    52.3522773
                ],
                [
                    84.4574727,
                    52.351642
                ],
                [
                    84.4623577,
                    52.3506989
                ],
                [
                    84.4642791,
                    52.3493352
                ],
                [
                    84.4682904,
                    52.3488312
                ],
                [
                    84.4726431,
                    52.3493699
                ],
                [
                    84.4761707,
                    52.3513683
                ],
                [
                    84.4812915,
                    52.3506797
                ],
                [
                    84.4839372,
                    52.3473019
                ],
                [
                    84.4868675,
                    52.3451817
                ],
                [
                    84.4798122,
                    52.3448688
                ],
                [
                    84.4730129,
                    52.342818
                ],
                [
                    84.4662349,
                    52.3423834
                ],
                [
                    84.4593005,
                    52.3425399
                ],
                [
                    84.4582467,
                    52.3395797
                ],
                [
                    84.4553106,
                    52.3397372
                ],
                [
                    84.4511001,
                    52.341006
                ],
                [
                    84.4473733,
                    52.3425182
                ],
                [
                    84.4458655,
                    52.3436479
                ],
                [
                    84.4448882,
                    52.3443544
                ]
            ],
            "longitude": 84.4555196,
            "latitude": 52.3464203
        },
        "5096": {
            "name": "Медведевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.4654674,
            "latitude": 51.733429
        },
        "5097": {
            "name": "Акутиха",
            "population": 1063,
            "type": "village",
            "poly": [
                [
                    84.4338944,
                    52.4286736
                ],
                [
                    84.4450138,
                    52.4309187
                ],
                [
                    84.4632872,
                    52.4341737
                ],
                [
                    84.4655896,
                    52.4376036
                ],
                [
                    84.4791787,
                    52.4468249
                ],
                [
                    84.4916456,
                    52.4452686
                ],
                [
                    84.5000656,
                    52.4436638
                ],
                [
                    84.4847642,
                    52.4332946
                ],
                [
                    84.4758743,
                    52.4266194
                ],
                [
                    84.4347678,
                    52.4249459
                ],
                [
                    84.4338944,
                    52.4286736
                ]
            ],
            "longitude": 84.4664873,
            "latitude": 52.433505
        },
        "5098": {
            "name": "Топольное",
            "population": 1090,
            "type": "village",
            "poly": null,
            "longitude": 84.499418,
            "latitude": 51.5081241
        },
        "5099": {
            "name": "Новомоношкино",
            "population": 1045,
            "type": "village",
            "poly": null,
            "longitude": 84.5013926,
            "latitude": 53.6138983
        },
        "5100": {
            "name": "Глушинка",
            "population": 514,
            "type": "village",
            "poly": null,
            "longitude": 84.5074242,
            "latitude": 53.4553304
        },
        "5101": {
            "name": "Шпагино",
            "population": 559,
            "type": "village",
            "poly": null,
            "longitude": 84.5221955,
            "latitude": 53.5473335
        },
        "5102": {
            "name": "Загайново",
            "population": 616,
            "type": "village",
            "poly": null,
            "longitude": 84.5353287,
            "latitude": 52.8667786
        },
        "5103": {
            "name": "Шатуново",
            "population": 836,
            "type": "village",
            "poly": null,
            "longitude": 84.5355409,
            "latitude": 53.8994153
        },
        "5104": {
            "name": "Тундриха",
            "population": 441,
            "type": "village",
            "poly": null,
            "longitude": 84.5450531,
            "latitude": 53.9947846
        },
        "5105": {
            "name": "Песьянка",
            "population": 220,
            "type": "village",
            "poly": [
                [
                    84.5407451,
                    53.109992
                ],
                [
                    84.544865,
                    53.1198831
                ],
                [
                    84.5551647,
                    53.1209134
                ],
                [
                    84.5637476,
                    53.1156591
                ],
                [
                    84.5407451,
                    53.109992
                ]
            ],
            "longitude": 84.5493628,
            "latitude": 53.1164945
        },
        "5106": {
            "name": "Карпово",
            "population": 393,
            "type": "village",
            "poly": null,
            "longitude": 84.5591623,
            "latitude": 51.8513549
        },
        "5107": {
            "name": "Шпагино",
            "population": 118,
            "type": "village",
            "poly": null,
            "longitude": 84.5596349,
            "latitude": 53.5870526
        },
        "5108": {
            "name": "Матвеевка",
            "population": 96,
            "type": "village",
            "poly": null,
            "longitude": 84.5699149,
            "latitude": 51.7286606
        },
        "5109": {
            "name": "Косиха",
            "population": 5118,
            "type": "village",
            "poly": [
                [
                    84.5511558,
                    53.3666387
                ],
                [
                    84.5516748,
                    53.3697481
                ],
                [
                    84.551913,
                    53.3710464
                ],
                [
                    84.5534558,
                    53.3723061
                ],
                [
                    84.5544214,
                    53.3730524
                ],
                [
                    84.5541016,
                    53.3746779
                ],
                [
                    84.5538056,
                    53.376182
                ],
                [
                    84.5561934,
                    53.3766331
                ],
                [
                    84.56148,
                    53.3748561
                ],
                [
                    84.5781783,
                    53.3808407
                ],
                [
                    84.5809016,
                    53.3783612
                ],
                [
                    84.5822557,
                    53.3771283
                ],
                [
                    84.5808984,
                    53.3764743
                ],
                [
                    84.5794659,
                    53.375784
                ],
                [
                    84.5813973,
                    53.3732875
                ],
                [
                    84.5919128,
                    53.3741197
                ],
                [
                    84.5970631,
                    53.3732875
                ],
                [
                    84.5982435,
                    53.3693824
                ],
                [
                    84.6056732,
                    53.3694742
                ],
                [
                    84.6003895,
                    53.3625315
                ],
                [
                    84.5967078,
                    53.3601183
                ],
                [
                    84.5988135,
                    53.3555716
                ],
                [
                    84.6014524,
                    53.3514493
                ],
                [
                    84.610863,
                    53.3528487
                ],
                [
                    84.6140434,
                    53.3514237
                ],
                [
                    84.6039864,
                    53.3466875
                ],
                [
                    84.6010937,
                    53.3471125
                ],
                [
                    84.5979216,
                    53.3484423
                ],
                [
                    84.5948869,
                    53.3483949
                ],
                [
                    84.5916912,
                    53.3482492
                ],
                [
                    84.5906252,
                    53.3494031
                ],
                [
                    84.5852601,
                    53.3491469
                ],
                [
                    84.5860211,
                    53.3479284
                ],
                [
                    84.5875006,
                    53.3481894
                ],
                [
                    84.5894449,
                    53.3442786
                ],
                [
                    84.5760659,
                    53.345648
                ],
                [
                    84.5774272,
                    53.3533101
                ],
                [
                    84.5744227,
                    53.3534382
                ],
                [
                    84.5713469,
                    53.3539437
                ],
                [
                    84.5667627,
                    53.3554316
                ],
                [
                    84.5571692,
                    53.3593162
                ],
                [
                    84.5586497,
                    53.3633
                ],
                [
                    84.560581,
                    53.3649647
                ],
                [
                    84.553351,
                    53.3628639
                ],
                [
                    84.5511558,
                    53.3666387
                ]
            ],
            "longitude": 84.5795068,
            "latitude": 53.3619517
        },
        "5110": {
            "name": "Верх-Ануйское",
            "population": 1148,
            "type": "village",
            "poly": [
                [
                    84.5633838,
                    52.2018776
                ],
                [
                    84.578501,
                    52.2216933
                ],
                [
                    84.5903651,
                    52.2180592
                ],
                [
                    84.6006983,
                    52.2264994
                ],
                [
                    84.609118,
                    52.2234517
                ],
                [
                    84.6058649,
                    52.2041059
                ],
                [
                    84.5895996,
                    52.1942539
                ],
                [
                    84.5735257,
                    52.1957787
                ],
                [
                    84.5633838,
                    52.2018776
                ]
            ],
            "longitude": 84.5895996,
            "latitude": 52.2098519
        },
        "5111": {
            "name": "Налобиха",
            "population": 4216,
            "type": "village",
            "poly": [
                [
                    84.5756086,
                    53.1990951
                ],
                [
                    84.5914069,
                    53.211345
                ],
                [
                    84.587243,
                    53.2136185
                ],
                [
                    84.5956932,
                    53.2164053
                ],
                [
                    84.6163905,
                    53.2045236
                ],
                [
                    84.6161455,
                    53.1965273
                ],
                [
                    84.6122265,
                    53.1925653
                ],
                [
                    84.6018167,
                    53.1892634
                ],
                [
                    84.5944686,
                    53.1894101
                ],
                [
                    84.5756086,
                    53.1990951
                ]
            ],
            "longitude": 84.5956933,
            "latitude": 53.1995353
        },
        "5112": {
            "name": "Тюмень",
            "population": 273,
            "type": "village",
            "poly": [
                [
                    84.5835621,
                    52.9288793
                ],
                [
                    84.5870014,
                    52.929478
                ],
                [
                    84.5895556,
                    52.9321876
                ],
                [
                    84.5922424,
                    52.9379731
                ],
                [
                    84.5890734,
                    52.9390111
                ],
                [
                    84.5916148,
                    52.9418007
                ],
                [
                    84.6059764,
                    52.9382864
                ],
                [
                    84.5917495,
                    52.9279518
                ],
                [
                    84.5849169,
                    52.9265399
                ],
                [
                    84.5835621,
                    52.9288793
                ]
            ],
            "longitude": 84.5957319,
            "latitude": 52.9370532
        },
        "5113": {
            "name": "Уткуль",
            "population": 158,
            "type": "village",
            "poly": null,
            "longitude": 84.6026186,
            "latitude": 52.7188925
        },
        "5114": {
            "name": "Среднекрасилово",
            "population": 383,
            "type": "village",
            "poly": null,
            "longitude": 84.6029693,
            "latitude": 53.794963
        },
        "5115": {
            "name": "Вершинино",
            "population": 64,
            "type": "village",
            "poly": null,
            "longitude": 84.6091259,
            "latitude": 52.7287726
        },
        "5116": {
            "name": "Степное",
            "population": 454,
            "type": "village",
            "poly": null,
            "longitude": 84.6180307,
            "latitude": 51.5034851
        },
        "5117": {
            "name": "Полковниково",
            "population": 690,
            "type": "village",
            "poly": [
                [
                    84.615584,
                    53.2178982
                ],
                [
                    84.6253687,
                    53.2233455
                ],
                [
                    84.6511179,
                    53.2361902
                ],
                [
                    84.6689707,
                    53.2335189
                ],
                [
                    84.6820168,
                    53.2229344
                ],
                [
                    84.6511179,
                    53.2119361
                ],
                [
                    84.6250253,
                    53.2075155
                ],
                [
                    84.6191889,
                    53.2124502
                ],
                [
                    84.615584,
                    53.2178982
                ]
            ],
            "longitude": 84.627693,
            "latitude": 53.215885
        },
        "5118": {
            "name": "Петровка",
            "population": 959,
            "type": "village",
            "poly": [
                [
                    84.6167911,
                    53.0727766
                ],
                [
                    84.6269191,
                    53.0799954
                ],
                [
                    84.652325,
                    53.0742205
                ],
                [
                    84.6442569,
                    53.0642156
                ],
                [
                    84.617306,
                    53.0656598
                ],
                [
                    84.6167911,
                    53.0727766
                ]
            ],
            "longitude": 84.6309019,
            "latitude": 53.0737161
        },
        "5119": {
            "name": "Хлеборобное",
            "population": 797,
            "type": "village",
            "poly": null,
            "longitude": 84.63549,
            "latitude": 52.213215
        },
        "5120": {
            "name": "Солоновка",
            "population": 1536,
            "type": "village",
            "poly": [
                [
                    84.5804814,
                    51.9841427
                ],
                [
                    84.5845841,
                    51.988567
                ],
                [
                    84.5864723,
                    51.9936409
                ],
                [
                    84.5947121,
                    51.9949093
                ],
                [
                    84.5996903,
                    51.9964947
                ],
                [
                    84.6022824,
                    51.9978846
                ],
                [
                    84.6076039,
                    52.000421
                ],
                [
                    84.6112088,
                    52.0044369
                ],
                [
                    84.6081017,
                    52.0080138
                ],
                [
                    84.6084473,
                    52.0086734
                ],
                [
                    84.6098183,
                    52.0112894
                ],
                [
                    84.6160153,
                    52.0118335
                ],
                [
                    84.6211479,
                    52.0105497
                ],
                [
                    84.6235684,
                    52.0134183
                ],
                [
                    84.6276882,
                    52.0150031
                ],
                [
                    84.6336964,
                    52.0142635
                ],
                [
                    84.6400479,
                    52.0126787
                ],
                [
                    84.6463822,
                    52.0132968
                ],
                [
                    84.6489743,
                    52.0124674
                ],
                [
                    84.6481158,
                    52.0057049
                ],
                [
                    84.6506909,
                    52.0034858
                ],
                [
                    84.6436528,
                    52.000104
                ],
                [
                    84.6391896,
                    51.9988358
                ],
                [
                    84.6304348,
                    51.9992585
                ],
                [
                    84.6203068,
                    51.9965106
                ],
                [
                    84.6137837,
                    51.9945023
                ],
                [
                    84.6134404,
                    51.9922826
                ],
                [
                    84.6108483,
                    51.9901526
                ],
                [
                    84.601939,
                    51.9876314
                ],
                [
                    84.5897511,
                    51.9849885
                ],
                [
                    84.5828846,
                    51.9832969
                ],
                [
                    84.5804814,
                    51.9841427
                ]
            ],
            "longitude": 84.6359506,
            "latitude": 52.0064471
        },
        "5121": {
            "name": "Беловский",
            "population": 1597,
            "type": "village",
            "poly": null,
            "longitude": 84.6385405,
            "latitude": 52.892681
        },
        "5122": {
            "name": "Туманово",
            "population": 674,
            "type": "village",
            "poly": null,
            "longitude": 84.645287,
            "latitude": 51.595627
        },
        "5123": {
            "name": "Верх-Жилино",
            "population": 410,
            "type": "village",
            "poly": [
                [
                    84.6167462,
                    53.5041687
                ],
                [
                    84.6197631,
                    53.5056509
                ],
                [
                    84.6252721,
                    53.5050268
                ],
                [
                    84.6316992,
                    53.4967567
                ],
                [
                    84.6382577,
                    53.497693
                ],
                [
                    84.642455,
                    53.4971469
                ],
                [
                    84.6461276,
                    53.4942598
                ],
                [
                    84.6622615,
                    53.4965669
                ],
                [
                    84.6689509,
                    53.4912164
                ],
                [
                    84.6665705,
                    53.488922
                ],
                [
                    84.6494069,
                    53.4819289
                ],
                [
                    84.6408809,
                    53.4812264
                ],
                [
                    84.6375968,
                    53.4797151
                ],
                [
                    84.6334885,
                    53.4831641
                ],
                [
                    84.6287782,
                    53.4897441
                ],
                [
                    84.6167462,
                    53.5041687
                ]
            ],
            "longitude": 84.6505573,
            "latitude": 53.4914841
        },
        "5124": {
            "name": "Красный Городок",
            "population": 280,
            "type": "village",
            "poly": null,
            "longitude": 84.6609982,
            "latitude": 51.9814093
        },
        "5125": {
            "name": "Смоленский",
            "population": 351,
            "type": "village",
            "poly": null,
            "longitude": 84.6680511,
            "latitude": 52.2133804
        },
        "5126": {
            "name": "Гордеевский",
            "population": 1483,
            "type": "village",
            "poly": [
                [
                    84.6636547,
                    53.1149379
                ],
                [
                    84.6796192,
                    53.1197801
                ],
                [
                    84.6821941,
                    53.1155561
                ],
                [
                    84.6912922,
                    53.1091676
                ],
                [
                    84.6921505,
                    53.1046333
                ],
                [
                    84.6883739,
                    53.1015415
                ],
                [
                    84.6734394,
                    53.1010261
                ],
                [
                    84.6720661,
                    53.1101981
                ],
                [
                    84.6665729,
                    53.1116407
                ],
                [
                    84.6636547,
                    53.1149379
                ]
            ],
            "longitude": 84.6798254,
            "latitude": 53.1116519
        },
        "5127": {
            "name": "Вершинино",
            "population": 370,
            "type": "village",
            "poly": null,
            "longitude": 84.6831899,
            "latitude": 52.7242835
        },
        "5128": {
            "name": "Октябрьский",
            "population": 519,
            "type": "village",
            "poly": null,
            "longitude": 84.6839452,
            "latitude": 53.1215487
        },
        "5129": {
            "name": "Новая Жизнь",
            "population": 194,
            "type": "village",
            "poly": null,
            "longitude": 84.6915018,
            "latitude": 51.7008443
        },
        "5130": {
            "name": "Боровлянский",
            "population": 224,
            "type": "village",
            "poly": [
                [
                    84.6868103,
                    52.8628667
                ],
                [
                    84.7005463,
                    52.8691989
                ],
                [
                    84.7050418,
                    52.8662842
                ],
                [
                    84.6911392,
                    52.8575891
                ],
                [
                    84.6868103,
                    52.8628667
                ]
            ],
            "longitude": 84.6983117,
            "latitude": 52.8643528
        },
        "5131": {
            "name": "Белое",
            "population": 531,
            "type": "village",
            "poly": null,
            "longitude": 84.716931,
            "latitude": 52.9204275
        },
        "5132": {
            "name": "Комарово",
            "population": 427,
            "type": "village",
            "poly": [
                [
                    84.7174131,
                    52.5625797
                ],
                [
                    84.7221517,
                    52.5657963
                ],
                [
                    84.7251529,
                    52.5670924
                ],
                [
                    84.7335245,
                    52.5690126
                ],
                [
                    84.7377892,
                    52.5668524
                ],
                [
                    84.7372364,
                    52.5617635
                ],
                [
                    84.7328137,
                    52.5584507
                ],
                [
                    84.7246,
                    52.5573463
                ],
                [
                    84.7190716,
                    52.5572503
                ],
                [
                    84.7174131,
                    52.5625797
                ]
            ],
            "longitude": 84.7310761,
            "latitude": 52.5629158
        },
        "5133": {
            "name": "Зелёная Поляна",
            "population": 849,
            "type": "village",
            "poly": [
                [
                    84.7291404,
                    52.8798753
                ],
                [
                    84.7298896,
                    52.887059
                ],
                [
                    84.7420439,
                    52.8867576
                ],
                [
                    84.7491201,
                    52.8883148
                ],
                [
                    84.7480379,
                    52.8814327
                ],
                [
                    84.7402125,
                    52.8793227
                ],
                [
                    84.7291404,
                    52.8798753
                ]
            ],
            "longitude": 84.7380842,
            "latitude": 52.8827405
        },
        "5134": {
            "name": "Новокопылово",
            "population": 840,
            "type": "village",
            "poly": null,
            "longitude": 84.742401,
            "latitude": 53.67725
        },
        "5135": {
            "name": "Плотниково",
            "population": 363,
            "type": "village",
            "poly": null,
            "longitude": 84.745853,
            "latitude": 53.4146649
        },
        "5136": {
            "name": "Черновая",
            "population": 366,
            "type": "village",
            "poly": null,
            "longitude": 84.753891,
            "latitude": 51.96505
        },
        "5137": {
            "name": "Усть-Ануй",
            "population": 262,
            "type": "village",
            "poly": [
                [
                    84.74165,
                    52.4003045
                ],
                [
                    84.7590637,
                    52.4038205
                ],
                [
                    84.7761015,
                    52.3786674
                ],
                [
                    84.7611934,
                    52.3755318
                ],
                [
                    84.74165,
                    52.4003045
                ]
            ],
            "longitude": 84.7576856,
            "latitude": 52.3893726
        },
        "5138": {
            "name": "Степной",
            "population": 307,
            "type": "village",
            "poly": [
                [
                    84.7521147,
                    52.864201
                ],
                [
                    84.7661804,
                    52.8721451
                ],
                [
                    84.7678321,
                    52.8715339
                ],
                [
                    84.7671395,
                    52.867932
                ],
                [
                    84.7711887,
                    52.8653268
                ],
                [
                    84.7629304,
                    52.8651981
                ],
                [
                    84.7564303,
                    52.8603732
                ],
                [
                    84.7521147,
                    52.864201
                ]
            ],
            "longitude": 84.7619452,
            "latitude": 52.8668763
        },
        "5139": {
            "name": "Пещерка",
            "population": 1198,
            "type": "village",
            "poly": null,
            "longitude": 84.7711542,
            "latitude": 54.0943477
        },
        "5140": {
            "name": "Сычёвка",
            "population": 2130,
            "type": "village",
            "poly": [
                [
                    84.7324331,
                    52.0508058
                ],
                [
                    84.7472632,
                    52.0586012
                ],
                [
                    84.7826642,
                    52.0641896
                ],
                [
                    84.7965375,
                    52.0672775
                ],
                [
                    84.8006038,
                    52.0583071
                ],
                [
                    84.7927104,
                    52.0515412
                ],
                [
                    84.7903184,
                    52.0440388
                ],
                [
                    84.7695084,
                    52.0375652
                ],
                [
                    84.7599405,
                    52.0459513
                ],
                [
                    84.7403266,
                    52.0433031
                ],
                [
                    84.7324331,
                    52.0508058
                ]
            ],
            "longitude": 84.771422,
            "latitude": 52.052718
        },
        "5141": {
            "name": "Каркавино",
            "population": 424,
            "type": "village",
            "poly": null,
            "longitude": 84.7819764,
            "latitude": 53.3429378
        },
        "5142": {
            "name": "Большая Речка",
            "population": 225,
            "type": "village",
            "poly": null,
            "longitude": 84.790115,
            "latitude": 53.027809
        },
        "5143": {
            "name": "Соколово",
            "population": 3224,
            "type": "village",
            "poly": [
                [
                    84.7532619,
                    52.5351467
                ],
                [
                    84.7613067,
                    52.5407831
                ],
                [
                    84.7741377,
                    52.5425172
                ],
                [
                    84.7908383,
                    52.5453041
                ],
                [
                    84.8063169,
                    52.5368811
                ],
                [
                    84.8009198,
                    52.5333503
                ],
                [
                    84.8068261,
                    52.5292618
                ],
                [
                    84.8052986,
                    52.5243054
                ],
                [
                    84.8002069,
                    52.518481
                ],
                [
                    84.7902273,
                    52.5220749
                ],
                [
                    84.7809605,
                    52.5251109
                ],
                [
                    84.780044,
                    52.5323592
                ],
                [
                    84.775767,
                    52.5332263
                ],
                [
                    84.7680277,
                    52.5347131
                ],
                [
                    84.7620194,
                    52.5352705
                ],
                [
                    84.7545857,
                    52.5333503
                ],
                [
                    84.7532619,
                    52.5351467
                ]
            ],
            "longitude": 84.790535,
            "latitude": 52.534126
        },
        "5144": {
            "name": "Южный",
            "population": 103,
            "type": "village",
            "poly": null,
            "longitude": 84.7997973,
            "latitude": 52.1436155
        },
        "5145": {
            "name": "Плешково",
            "population": 1280,
            "type": "village",
            "poly": null,
            "longitude": 84.7998068,
            "latitude": 52.7458412
        },
        "5146": {
            "name": "Гоношиха",
            "population": 593,
            "type": "village",
            "poly": null,
            "longitude": 84.8076355,
            "latitude": 53.7680774
        },
        "5147": {
            "name": "Кипешино",
            "population": 154,
            "type": "village",
            "poly": null,
            "longitude": 84.811057,
            "latitude": 52.9411874
        },
        "5148": {
            "name": "Верх-Камышенка",
            "population": 705,
            "type": "village",
            "poly": null,
            "longitude": 84.816528,
            "latitude": 53.597847
        },
        "5149": {
            "name": "Батунный",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 84.8194827,
            "latitude": 53.6645569
        },
        "5150": {
            "name": "Старотырышкино",
            "population": 405,
            "type": "village",
            "poly": [
                [
                    84.812808,
                    52.357272
                ],
                [
                    84.8316945,
                    52.3571775
                ],
                [
                    84.8354099,
                    52.3415745
                ],
                [
                    84.8258118,
                    52.3393046
                ],
                [
                    84.812808,
                    52.357272
                ]
            ],
            "longitude": 84.826584,
            "latitude": 52.349709
        },
        "5151": {
            "name": "Новая Михайловка",
            "population": 304,
            "type": "village",
            "poly": null,
            "longitude": 84.85994,
            "latitude": 52.658848
        },
        "5152": {
            "name": "Ануйское",
            "population": 844,
            "type": "village",
            "poly": [
                [
                    84.8417796,
                    52.3147773
                ],
                [
                    84.8480943,
                    52.3139586
                ],
                [
                    84.8526869,
                    52.3105659
                ],
                [
                    84.864551,
                    52.3115019
                ],
                [
                    84.8722053,
                    52.3033119
                ],
                [
                    84.8771346,
                    52.2977231
                ],
                [
                    84.8658905,
                    52.2793181
                ],
                [
                    84.8448413,
                    52.307056
                ],
                [
                    84.8417796,
                    52.3147773
                ]
            ],
            "longitude": 84.860649,
            "latitude": 52.302773
        },
        "5153": {
            "name": "Савиново",
            "population": 539,
            "type": "village",
            "poly": [
                [
                    84.845765,
                    52.5167042
                ],
                [
                    84.8588022,
                    52.5215401
                ],
                [
                    84.8673746,
                    52.523985
                ],
                [
                    84.8763935,
                    52.5181169
                ],
                [
                    84.877465,
                    52.5135524
                ],
                [
                    84.8696963,
                    52.5094765
                ],
                [
                    84.8657671,
                    52.5036064
                ],
                [
                    84.8533551,
                    52.5052915
                ],
                [
                    84.847015,
                    52.510183
                ],
                [
                    84.845765,
                    52.5167042
                ]
            ],
            "longitude": 84.8607536,
            "latitude": 52.5177145
        },
        "5154": {
            "name": "Белокуриха-2",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 84.8744003,
            "latitude": 51.9499271
        },
        "5155": {
            "name": "Песчаное",
            "population": 266,
            "type": "village",
            "poly": [
                [
                    84.8709994,
                    52.3998695
                ],
                [
                    84.8881413,
                    52.3957802
                ],
                [
                    84.8886275,
                    52.3859686
                ],
                [
                    84.8879949,
                    52.3838064
                ],
                [
                    84.8717426,
                    52.3889895
                ],
                [
                    84.8710105,
                    52.39444
                ],
                [
                    84.8716235,
                    52.3968453
                ],
                [
                    84.8709994,
                    52.3998695
                ]
            ],
            "longitude": 84.8799229,
            "latitude": 52.3925431
        },
        "5156": {
            "name": "Степное",
            "population": 196,
            "type": "village",
            "poly": null,
            "longitude": 84.8982616,
            "latitude": 52.1891467
        },
        "5157": {
            "name": "Новотырышкино",
            "population": 1747,
            "type": "village",
            "poly": [
                [
                    84.8771495,
                    52.074865
                ],
                [
                    84.8881358,
                    52.089001
                ],
                [
                    84.9238414,
                    52.0940635
                ],
                [
                    84.9246997,
                    52.0778192
                ],
                [
                    84.8771495,
                    52.074865
                ]
            ],
            "longitude": 84.8991221,
            "latitude": 52.0821446
        },
        "5158": {
            "name": "Заречный",
            "population": 212,
            "type": "village",
            "poly": null,
            "longitude": 84.900893,
            "latitude": 52.356392
        },
        "5159": {
            "name": "Новозыряново",
            "population": 538,
            "type": "village",
            "poly": null,
            "longitude": 84.9012604,
            "latitude": 53.8102564
        },
        "5160": {
            "name": "Фоминское",
            "population": 1273,
            "type": "village",
            "poly": null,
            "longitude": 84.906876,
            "latitude": 52.453457
        },
        "5161": {
            "name": "Куяган",
            "population": 779,
            "type": "village",
            "poly": [
                [
                    84.9053713,
                    51.6932528
                ],
                [
                    84.9056105,
                    51.7190445
                ],
                [
                    84.922115,
                    51.7057059
                ],
                [
                    84.9163743,
                    51.6959216
                ],
                [
                    84.9206798,
                    51.6879148
                ],
                [
                    84.9108728,
                    51.6855421
                ],
                [
                    84.9053713,
                    51.6932528
                ]
            ],
            "longitude": 84.9081276,
            "latitude": 51.6995982
        },
        "5162": {
            "name": "Хайрюзовка",
            "population": 716,
            "type": "village",
            "poly": null,
            "longitude": 84.9187259,
            "latitude": 52.9579917
        },
        "5163": {
            "name": "Гришино",
            "population": 476,
            "type": "village",
            "poly": null,
            "longitude": 84.919289,
            "latitude": 53.586498
        },
        "5164": {
            "name": "Буланиха",
            "population": 2463,
            "type": "village",
            "poly": [
                [
                    84.9028753,
                    52.78392
                ],
                [
                    84.9089987,
                    52.7911044
                ],
                [
                    84.909611,
                    52.8073203
                ],
                [
                    84.9256544,
                    52.8102075
                ],
                [
                    84.9372888,
                    52.8244923
                ],
                [
                    84.9566387,
                    52.8220501
                ],
                [
                    84.9518625,
                    52.8085788
                ],
                [
                    84.9151221,
                    52.7796237
                ],
                [
                    84.9028753,
                    52.78392
                ]
            ],
            "longitude": 84.928841,
            "latitude": 52.802433
        },
        "5165": {
            "name": "Зональное",
            "population": 3385,
            "type": "village",
            "poly": [
                [
                    84.9104155,
                    52.6703351
                ],
                [
                    84.9289083,
                    52.6736768
                ],
                [
                    84.943482,
                    52.6730828
                ],
                [
                    84.9449516,
                    52.6668445
                ],
                [
                    84.9542592,
                    52.6645421
                ],
                [
                    84.9520463,
                    52.6592702
                ],
                [
                    84.9399304,
                    52.6588968
                ],
                [
                    84.9460538,
                    52.6522108
                ],
                [
                    84.9329497,
                    52.6488673
                ],
                [
                    84.9260915,
                    52.6554054
                ],
                [
                    84.9198456,
                    52.6565196
                ],
                [
                    84.9104155,
                    52.6703351
                ]
            ],
            "longitude": 84.934296,
            "latitude": 52.664467
        },
        "5166": {
            "name": "Клюквенный",
            "population": 167,
            "type": "village",
            "poly": null,
            "longitude": 84.9449897,
            "latitude": 53.1749153
        },
        "5167": {
            "name": "Набережный",
            "population": 257,
            "type": "village",
            "poly": [
                [
                    84.9389363,
                    52.3621275
                ],
                [
                    84.941279,
                    52.3658469
                ],
                [
                    84.9562721,
                    52.3623421
                ],
                [
                    84.9504154,
                    52.3573347
                ],
                [
                    84.9389363,
                    52.3621275
                ]
            ],
            "longitude": 84.9501998,
            "latitude": 52.3631023
        },
        "5168": {
            "name": "Новоеловка",
            "population": 668,
            "type": "village",
            "poly": null,
            "longitude": 84.9502285,
            "latitude": 53.0557983
        },
        "5169": {
            "name": "Гордеевка",
            "population": 258,
            "type": "village",
            "poly": null,
            "longitude": 84.9505954,
            "latitude": 53.0816435
        },
        "5170": {
            "name": "Одинцовка",
            "population": 401,
            "type": "village",
            "poly": null,
            "longitude": 84.955467,
            "latitude": 52.438225
        },
        "5171": {
            "name": "Кордон",
            "population": 567,
            "type": "village",
            "poly": null,
            "longitude": 84.9644754,
            "latitude": 54.1856606
        },
        "5172": {
            "name": "Линевский",
            "population": 1256,
            "type": "village",
            "poly": [
                [
                    84.9645101,
                    52.3706284
                ],
                [
                    84.9819701,
                    52.3727715
                ],
                [
                    84.9829157,
                    52.361808
                ],
                [
                    84.9748676,
                    52.3605102
                ],
                [
                    84.9677561,
                    52.3593509
                ],
                [
                    84.9645101,
                    52.3706284
                ]
            ],
            "longitude": 84.9735449,
            "latitude": 52.365333
        },
        "5173": {
            "name": "Лосиха",
            "population": 763,
            "type": "village",
            "poly": null,
            "longitude": 84.9739661,
            "latitude": 53.3884958
        },
        "5174": {
            "name": "Воскресенка",
            "population": 399,
            "type": "village",
            "poly": null,
            "longitude": 84.999397,
            "latitude": 53.908535
        },
        "5175": {
            "name": "Борисово",
            "population": 699,
            "type": "village",
            "poly": null,
            "longitude": 85.0041641,
            "latitude": 54.0322008
        },
        "5176": {
            "name": "Октябрьский",
            "population": 1137,
            "type": "village",
            "poly": null,
            "longitude": 85.0069522,
            "latitude": 52.7348139
        },
        "5177": {
            "name": "Червово",
            "population": 533,
            "type": "village",
            "poly": null,
            "longitude": 85.0084582,
            "latitude": 53.4835458
        },
        "5178": {
            "name": "Тоурак",
            "population": 378,
            "type": "village",
            "poly": null,
            "longitude": 85.0099786,
            "latitude": 51.578559
        },
        "5179": {
            "name": "Сафоновка",
            "population": 403,
            "type": "village",
            "poly": null,
            "longitude": 85.0174946,
            "latitude": 52.5456986
        },
        "5180": {
            "name": "Верх-Обский",
            "population": 1042,
            "type": "village",
            "poly": [
                [
                    85.0032546,
                    52.4220467
                ],
                [
                    85.0042195,
                    52.4234105
                ],
                [
                    85.0069762,
                    52.4226363
                ],
                [
                    85.0096637,
                    52.4224807
                ],
                [
                    85.0108208,
                    52.4223786
                ],
                [
                    85.0152931,
                    52.4220896
                ],
                [
                    85.0185983,
                    52.4216647
                ],
                [
                    85.0199124,
                    52.4214097
                ],
                [
                    85.0214801,
                    52.4213543
                ],
                [
                    85.0248894,
                    52.4208643
                ],
                [
                    85.0282701,
                    52.4205574
                ],
                [
                    85.0297965,
                    52.4202864
                ],
                [
                    85.0317699,
                    52.4199443
                ],
                [
                    85.0347791,
                    52.4195597
                ],
                [
                    85.0374367,
                    52.4183645
                ],
                [
                    85.0368696,
                    52.4167119
                ],
                [
                    85.0328998,
                    52.4168657
                ],
                [
                    85.0292415,
                    52.4148815
                ],
                [
                    85.029464,
                    52.4136678
                ],
                [
                    85.0257508,
                    52.4134386
                ],
                [
                    85.0220676,
                    52.4131176
                ],
                [
                    85.0202335,
                    52.4122556
                ],
                [
                    85.0183543,
                    52.4122373
                ],
                [
                    85.0172869,
                    52.4131176
                ],
                [
                    85.0147462,
                    52.4129617
                ],
                [
                    85.0098453,
                    52.4132643
                ],
                [
                    85.0086421,
                    52.4137298
                ],
                [
                    85.0082296,
                    52.4159136
                ],
                [
                    85.00908,
                    52.4167824
                ],
                [
                    85.0103131,
                    52.4194017
                ],
                [
                    85.0054657,
                    52.4205686
                ],
                [
                    85.0054657,
                    52.4209835
                ],
                [
                    85.0032546,
                    52.4220467
                ]
            ],
            "longitude": 85.0186052,
            "latitude": 52.4180192
        },
        "5181": {
            "name": "Мирный",
            "population": 1487,
            "type": "village",
            "poly": [
                [
                    85.010766,
                    52.5720028
                ],
                [
                    85.0180759,
                    52.5756376
                ],
                [
                    85.0269048,
                    52.569464
                ],
                [
                    85.0215884,
                    52.5661173
                ],
                [
                    85.010766,
                    52.5720028
                ]
            ],
            "longitude": 85.0207341,
            "latitude": 52.5712527
        },
        "5182": {
            "name": "Кировский",
            "population": 1271,
            "type": "village",
            "poly": [
                [
                    85.0148534,
                    52.2861512
                ],
                [
                    85.0153547,
                    52.2965759
                ],
                [
                    85.0278869,
                    52.2952474
                ],
                [
                    85.0352391,
                    52.2892176
                ],
                [
                    85.0307275,
                    52.2848224
                ],
                [
                    85.0148534,
                    52.2861512
                ]
            ],
            "longitude": 85.0257146,
            "latitude": 52.2903418
        },
        "5183": {
            "name": "Точильное",
            "population": 1245,
            "type": "village",
            "poly": [
                [
                    85.0081271,
                    52.1461318
                ],
                [
                    85.0124186,
                    52.1557167
                ],
                [
                    85.0268382,
                    52.1639307
                ],
                [
                    85.0416011,
                    52.1622459
                ],
                [
                    85.0527591,
                    52.1621406
                ],
                [
                    85.0498408,
                    52.1539263
                ],
                [
                    85.040571,
                    52.153821
                ],
                [
                    85.0282115,
                    52.1543476
                ],
                [
                    85.0287265,
                    52.139811
                ],
                [
                    85.0081271,
                    52.1461318
                ]
            ],
            "longitude": 85.0306148,
            "latitude": 52.1585602
        },
        "5184": {
            "name": "Усть-Гавриловка",
            "population": 514,
            "type": "village",
            "poly": null,
            "longitude": 85.0316433,
            "latitude": 52.9397518
        },
        "5185": {
            "name": "Александровка",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 85.045222,
            "latitude": 52.225389
        },
        "5186": {
            "name": "Усть-Катунь",
            "population": 491,
            "type": "village",
            "poly": [
                [
                    85.0378147,
                    52.4166352
                ],
                [
                    85.0384536,
                    52.4184424
                ],
                [
                    85.0532044,
                    52.4196867
                ],
                [
                    85.0550127,
                    52.419187
                ],
                [
                    85.056789,
                    52.4194407
                ],
                [
                    85.0575446,
                    52.4193025
                ],
                [
                    85.0597101,
                    52.4196408
                ],
                [
                    85.0608802,
                    52.4195309
                ],
                [
                    85.0619953,
                    52.4189985
                ],
                [
                    85.0626807,
                    52.418944
                ],
                [
                    85.0651592,
                    52.4194974
                ],
                [
                    85.0667017,
                    52.417791
                ],
                [
                    85.0502875,
                    52.4139983
                ],
                [
                    85.0442419,
                    52.4164814
                ],
                [
                    85.0378147,
                    52.4166352
                ]
            ],
            "longitude": 85.0537861,
            "latitude": 52.4171009
        },
        "5187": {
            "name": "Новая Чемровка",
            "population": 2079,
            "type": "village",
            "poly": null,
            "longitude": 85.0571429,
            "latitude": 52.5993871
        },
        "5188": {
            "name": "Куяча",
            "population": 465,
            "type": "village",
            "poly": null,
            "longitude": 85.073143,
            "latitude": 51.671593
        },
        "5189": {
            "name": "Старобелокуриха",
            "population": 1517,
            "type": "village",
            "poly": [
                [
                    85.0494975,
                    52.0522806
                ],
                [
                    85.064432,
                    52.0644185
                ],
                [
                    85.07662,
                    52.0586138
                ],
                [
                    85.0848597,
                    52.0553418
                ],
                [
                    85.0953311,
                    52.0594582
                ],
                [
                    85.12932,
                    52.0481635
                ],
                [
                    85.0898379,
                    52.0465799
                ],
                [
                    85.0573938,
                    52.049008
                ],
                [
                    85.0494975,
                    52.0522806
                ]
            ],
            "longitude": 85.0778216,
            "latitude": 52.0528084
        },
        "5190": {
            "name": "Стародраченино",
            "population": 572,
            "type": "village",
            "poly": null,
            "longitude": 85.0817241,
            "latitude": 53.6836544
        },
        "5191": {
            "name": "Комарское",
            "population": 633,
            "type": "village",
            "poly": null,
            "longitude": 85.0831402,
            "latitude": 53.6422837
        },
        "5192": {
            "name": "Шубёнка",
            "population": 1248,
            "type": "village",
            "poly": null,
            "longitude": 85.1042589,
            "latitude": 52.6557267
        },
        "5193": {
            "name": "Катунское",
            "population": 475,
            "type": "village",
            "poly": [
                [
                    85.1012158,
                    52.4140334
                ],
                [
                    85.1055947,
                    52.4168772
                ],
                [
                    85.1075056,
                    52.4163513
                ],
                [
                    85.1115252,
                    52.4156047
                ],
                [
                    85.1131812,
                    52.4151355
                ],
                [
                    85.1152131,
                    52.4147425
                ],
                [
                    85.1168636,
                    52.4145354
                ],
                [
                    85.1184923,
                    52.414601
                ],
                [
                    85.1262934,
                    52.4104846
                ],
                [
                    85.1270696,
                    52.40996
                ],
                [
                    85.1289235,
                    52.4088836
                ],
                [
                    85.1308511,
                    52.4080009
                ],
                [
                    85.132968,
                    52.4068977
                ],
                [
                    85.1341736,
                    52.4063287
                ],
                [
                    85.1340143,
                    52.4054406
                ],
                [
                    85.1322401,
                    52.4024431
                ],
                [
                    85.1302839,
                    52.4027346
                ],
                [
                    85.1272132,
                    52.4027346
                ],
                [
                    85.1264699,
                    52.4055679
                ],
                [
                    85.1275564,
                    52.4060393
                ],
                [
                    85.1272295,
                    52.40674
                ],
                [
                    85.1261007,
                    52.4061295
                ],
                [
                    85.1231201,
                    52.4058775
                ],
                [
                    85.1190029,
                    52.4056659
                ],
                [
                    85.1128205,
                    52.4060599
                ],
                [
                    85.1084331,
                    52.4083449
                ],
                [
                    85.1035864,
                    52.4115463
                ],
                [
                    85.1014243,
                    52.4125336
                ],
                [
                    85.1012158,
                    52.4140334
                ]
            ],
            "longitude": 85.115991,
            "latitude": 52.4123953
        },
        "5194": {
            "name": "Новодрачёнино",
            "population": 728,
            "type": "village",
            "poly": null,
            "longitude": 85.122269,
            "latitude": 53.796196
        },
        "5195": {
            "name": "Ельцовка",
            "population": 717,
            "type": "village",
            "poly": null,
            "longitude": 85.127296,
            "latitude": 53.058872
        },
        "5196": {
            "name": "Порошино",
            "population": 454,
            "type": "village",
            "poly": null,
            "longitude": 85.1439035,
            "latitude": 53.2300429
        },
        "5197": {
            "name": "Усть-Катунь",
            "population": 449,
            "type": "village",
            "poly": [
                [
                    85.1591185,
                    52.4557612
                ],
                [
                    85.163478,
                    52.460504
                ],
                [
                    85.165514,
                    52.4605281
                ],
                [
                    85.1674749,
                    52.4605088
                ],
                [
                    85.1702053,
                    52.458892
                ],
                [
                    85.1731237,
                    52.4572466
                ],
                [
                    85.1737371,
                    52.4558435
                ],
                [
                    85.173395,
                    52.4553046
                ],
                [
                    85.1709434,
                    52.4542556
                ],
                [
                    85.165327,
                    52.4518524
                ],
                [
                    85.1609572,
                    52.454422
                ],
                [
                    85.1591185,
                    52.4557612
                ]
            ],
            "longitude": 85.1667003,
            "latitude": 52.4556184
        },
        "5198": {
            "name": "Луговское",
            "population": 1163,
            "type": "village",
            "poly": null,
            "longitude": 85.1690395,
            "latitude": 52.7631736
        },
        "5199": {
            "name": "Заря",
            "population": 970,
            "type": "village",
            "poly": null,
            "longitude": 85.175362,
            "latitude": 52.59655
        },
        "5200": {
            "name": "Хмелёвка",
            "population": 1072,
            "type": "village",
            "poly": null,
            "longitude": 85.183655,
            "latitude": 53.952503
        },
        "5201": {
            "name": "Старая Чемровка",
            "population": 569,
            "type": "village",
            "poly": null,
            "longitude": 85.1876155,
            "latitude": 52.659671
        },
        "5202": {
            "name": "Нагорный",
            "population": 7777,
            "type": "village",
            "poly": null,
            "longitude": 85.1944974,
            "latitude": 52.5527565
        },
        "5203": {
            "name": "Смазнево",
            "population": 1193,
            "type": "village",
            "poly": null,
            "longitude": 85.202171,
            "latitude": 53.840645
        },
        "5204": {
            "name": "Озёрное",
            "population": 307,
            "type": "village",
            "poly": null,
            "longitude": 85.2041512,
            "latitude": 53.6760851
        },
        "5205": {
            "name": "Первомайское",
            "population": 513,
            "type": "village",
            "poly": [
                [
                    85.1926393,
                    52.2820951
                ],
                [
                    85.1981527,
                    52.2937456
                ],
                [
                    85.2219607,
                    52.2925194
                ],
                [
                    85.2184522,
                    52.2794886
                ],
                [
                    85.1926393,
                    52.2820951
                ]
            ],
            "longitude": 85.2142057,
            "latitude": 52.2885488
        },
        "5206": {
            "name": "Яново",
            "population": 452,
            "type": "village",
            "poly": null,
            "longitude": 85.21788,
            "latitude": 53.901333
        },
        "5207": {
            "name": "Макарьевка",
            "population": 444,
            "type": "village",
            "poly": null,
            "longitude": 85.2295768,
            "latitude": 51.9865166
        },
        "5208": {
            "name": "Еремино",
            "population": 255,
            "type": "village",
            "poly": null,
            "longitude": 85.2354865,
            "latitude": 53.1619308
        },
        "5209": {
            "name": "Россоши",
            "population": 1018,
            "type": "village",
            "poly": [
                [
                    85.2235621,
                    52.0899503
                ],
                [
                    85.2251071,
                    52.0957509
                ],
                [
                    85.248968,
                    52.1023943
                ],
                [
                    85.250513,
                    52.0881572
                ],
                [
                    85.2450198,
                    52.0785577
                ],
                [
                    85.228712,
                    52.0808787
                ],
                [
                    85.2302569,
                    52.0880517
                ],
                [
                    85.2235621,
                    52.0899503
                ]
            ],
            "longitude": 85.2390117,
            "latitude": 52.0921651
        },
        "5210": {
            "name": "Дмитро-Титово",
            "population": 1028,
            "type": "village",
            "poly": null,
            "longitude": 85.2418208,
            "latitude": 53.5833694
        },
        "5211": {
            "name": "Пригородный",
            "population": 541,
            "type": "village",
            "poly": null,
            "longitude": 85.243912,
            "latitude": 52.573414
        },
        "5212": {
            "name": "Первомайское",
            "population": 5454,
            "type": "village",
            "poly": [
                [
                    85.2363276,
                    52.5887471
                ],
                [
                    85.2445267,
                    52.5914758
                ],
                [
                    85.2383259,
                    52.6028808
                ],
                [
                    85.2513299,
                    52.6025094
                ],
                [
                    85.2709986,
                    52.6040993
                ],
                [
                    85.2718476,
                    52.5979544
                ],
                [
                    85.2579097,
                    52.5804173
                ],
                [
                    85.2431935,
                    52.5780205
                ],
                [
                    85.2363276,
                    52.5887471
                ]
            ],
            "longitude": 85.2527815,
            "latitude": 52.5901124
        },
        "5213": {
            "name": "Колбаны",
            "population": 293,
            "type": "village",
            "poly": [
                [
                    85.2441615,
                    52.1657208
                ],
                [
                    85.2566928,
                    52.1701429
                ],
                [
                    85.261671,
                    52.1659314
                ],
                [
                    85.2584094,
                    52.1582443
                ],
                [
                    85.2457065,
                    52.1599292
                ],
                [
                    85.2441615,
                    52.1657208
                ]
            ],
            "longitude": 85.2532596,
            "latitude": 52.1641413
        },
        "5214": {
            "name": "Лесное",
            "population": 2008,
            "type": "village",
            "poly": [
                [
                    85.2391851,
                    52.4699393
                ],
                [
                    85.2497062,
                    52.4744722
                ],
                [
                    85.2543604,
                    52.4740263
                ],
                [
                    85.2549478,
                    52.4754821
                ],
                [
                    85.2611333,
                    52.4770491
                ],
                [
                    85.2611165,
                    52.4754902
                ],
                [
                    85.2631511,
                    52.4720036
                ],
                [
                    85.265784,
                    52.468701
                ],
                [
                    85.2589759,
                    52.4645377
                ],
                [
                    85.2507362,
                    52.4617138
                ],
                [
                    85.2483513,
                    52.4616467
                ],
                [
                    85.2411231,
                    52.4638056
                ],
                [
                    85.243041,
                    52.4664361
                ],
                [
                    85.2391851,
                    52.4699393
                ]
            ],
            "longitude": 85.256966,
            "latitude": 52.465542
        },
        "5215": {
            "name": "Никольское",
            "population": 861,
            "type": "village",
            "poly": [
                [
                    85.2515429,
                    52.2043467
                ],
                [
                    85.2561778,
                    52.2204398
                ],
                [
                    85.2700824,
                    52.2211759
                ],
                [
                    85.2802104,
                    52.2154967
                ],
                [
                    85.2673358,
                    52.2130777
                ],
                [
                    85.2642459,
                    52.2031895
                ],
                [
                    85.2515429,
                    52.2043467
                ]
            ],
            "longitude": 85.261841,
            "latitude": 52.215286
        },
        "5216": {
            "name": "Новая Тараба",
            "population": 663,
            "type": "village",
            "poly": null,
            "longitude": 85.2810988,
            "latitude": 53.383929
        },
        "5217": {
            "name": "Краснояры",
            "population": 881,
            "type": "village",
            "poly": null,
            "longitude": 85.2916557,
            "latitude": 53.1627055
        },
        "5218": {
            "name": "Амурский",
            "population": 306,
            "type": "village",
            "poly": null,
            "longitude": 85.3036363,
            "latitude": 52.4776113
        },
        "5219": {
            "name": "Шульгинка",
            "population": 1639,
            "type": "village",
            "poly": [
                [
                    85.3008612,
                    52.4419416
                ],
                [
                    85.3204307,
                    52.4423601
                ],
                [
                    85.3262672,
                    52.4398487
                ],
                [
                    85.331932,
                    52.4305344
                ],
                [
                    85.320774,
                    52.4269757
                ],
                [
                    85.310131,
                    52.4340929
                ],
                [
                    85.3017196,
                    52.4357674
                ],
                [
                    85.3008612,
                    52.4419416
                ]
            ],
            "longitude": 85.3097876,
            "latitude": 52.4370233
        },
        "5220": {
            "name": "Верх-Шубинка",
            "population": 194,
            "type": "village",
            "poly": null,
            "longitude": 85.3116742,
            "latitude": 52.9421007
        },
        "5221": {
            "name": "Боровой",
            "population": 551,
            "type": "village",
            "poly": null,
            "longitude": 85.3119923,
            "latitude": 52.5737754
        },
        "5222": {
            "name": "Октябрьский",
            "population": 966,
            "type": "village",
            "poly": null,
            "longitude": 85.3303997,
            "latitude": 53.2862648
        },
        "5223": {
            "name": "Глинка",
            "population": 180,
            "type": "village",
            "poly": null,
            "longitude": 85.3355535,
            "latitude": 52.1992842
        },
        "5224": {
            "name": "Горновое",
            "population": 729,
            "type": "village",
            "poly": null,
            "longitude": 85.3376954,
            "latitude": 53.0742569
        },
        "5225": {
            "name": "Красный Яр",
            "population": 1203,
            "type": "village",
            "poly": [
                [
                    85.3167358,
                    52.3530316
                ],
                [
                    85.3311554,
                    52.3685466
                ],
                [
                    85.3510681,
                    52.3736821
                ],
                [
                    85.3467766,
                    52.3646684
                ],
                [
                    85.3625694,
                    52.3586931
                ],
                [
                    85.3514114,
                    52.3474742
                ],
                [
                    85.3224007,
                    52.344433
                ],
                [
                    85.3167358,
                    52.3530316
                ]
            ],
            "longitude": 85.3411494,
            "latitude": 52.3558394
        },
        "5226": {
            "name": "Малоугренево",
            "population": 2413,
            "type": "village",
            "poly": null,
            "longitude": 85.347351,
            "latitude": 52.562
        },
        "5227": {
            "name": "Восточный",
            "population": 335,
            "type": "village",
            "poly": null,
            "longitude": 85.3537656,
            "latitude": 52.6369072
        },
        "5228": {
            "name": "Сараса",
            "population": 1023,
            "type": "village",
            "poly": [
                [
                    85.3502951,
                    51.8649107
                ],
                [
                    85.3509389,
                    51.8768082
                ],
                [
                    85.3517543,
                    51.8801727
                ],
                [
                    85.3655301,
                    51.8881992
                ],
                [
                    85.3688346,
                    51.8876694
                ],
                [
                    85.3635131,
                    51.881153
                ],
                [
                    85.3552304,
                    51.8691772
                ],
                [
                    85.3535996,
                    51.8659443
                ],
                [
                    85.3526126,
                    51.8646193
                ],
                [
                    85.3502951,
                    51.8649107
                ]
            ],
            "longitude": 85.3554246,
            "latitude": 51.8715471
        },
        "5229": {
            "name": "Белое",
            "population": 228,
            "type": "village",
            "poly": [
                [
                    85.3288689,
                    51.6330494
                ],
                [
                    85.329717,
                    51.633722
                ],
                [
                    85.3344265,
                    51.6319773
                ],
                [
                    85.3366473,
                    51.6314245
                ],
                [
                    85.3391584,
                    51.6295598
                ],
                [
                    85.3406813,
                    51.6297197
                ],
                [
                    85.3427097,
                    51.6286739
                ],
                [
                    85.3442546,
                    51.6272155
                ],
                [
                    85.3455737,
                    51.6267759
                ],
                [
                    85.3480848,
                    51.6250574
                ],
                [
                    85.3536855,
                    51.6236652
                ],
                [
                    85.3571616,
                    51.623119
                ],
                [
                    85.3600884,
                    51.6220206
                ],
                [
                    85.3587709,
                    51.621094
                ],
                [
                    85.3609167,
                    51.6197618
                ],
                [
                    85.3613888,
                    51.6186294
                ],
                [
                    85.3597794,
                    51.6182963
                ],
                [
                    85.3589855,
                    51.6191889
                ],
                [
                    85.3569685,
                    51.6204146
                ],
                [
                    85.3565177,
                    51.620255
                ],
                [
                    85.3477844,
                    51.6234656
                ],
                [
                    85.3448662,
                    51.6220136
                ],
                [
                    85.3401669,
                    51.6232592
                ],
                [
                    85.3350385,
                    51.6256104
                ],
                [
                    85.3308972,
                    51.6264163
                ],
                [
                    85.331026,
                    51.6271822
                ],
                [
                    85.332807,
                    51.6289804
                ],
                [
                    85.3324851,
                    51.6297396
                ],
                [
                    85.3322378,
                    51.6312181
                ],
                [
                    85.3288689,
                    51.6330494
                ]
            ],
            "longitude": 85.3567283,
            "latitude": 51.6223327
        },
        "5230": {
            "name": "Угреневка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.3572874,
            "latitude": 52.5499509
        },
        "5231": {
            "name": "Сверчково",
            "population": 349,
            "type": "village",
            "poly": null,
            "longitude": 85.3622374,
            "latitude": 52.7766406
        },
        "5232": {
            "name": "Сосновка",
            "population": 441,
            "type": "village",
            "poly": null,
            "longitude": 85.372711,
            "latitude": 53.88018
        },
        "5233": {
            "name": "Нижнекаменка",
            "population": 2045,
            "type": "village",
            "poly": [
                [
                    85.3535131,
                    52.0460076
                ],
                [
                    85.3743231,
                    52.0592457
                ],
                [
                    85.3819773,
                    52.0704215
                ],
                [
                    85.4099632,
                    52.0618928
                ],
                [
                    85.4001562,
                    52.0449778
                ],
                [
                    85.3910668,
                    52.0455663
                ],
                [
                    85.3920236,
                    52.0326183
                ],
                [
                    85.3826949,
                    52.0255543
                ],
                [
                    85.383562,
                    52.0140798
                ],
                [
                    85.3664296,
                    52.0148089
                ],
                [
                    85.3535131,
                    52.0460076
                ]
            ],
            "longitude": 85.3786286,
            "latitude": 52.0399756
        },
        "5234": {
            "name": "Сухая Чемровка",
            "population": 725,
            "type": "village",
            "poly": [
                [
                    85.3758626,
                    52.721217
                ],
                [
                    85.3774564,
                    52.7258156
                ],
                [
                    85.3859764,
                    52.7251661
                ],
                [
                    85.3787895,
                    52.7191984
                ],
                [
                    85.3758626,
                    52.721217
                ]
            ],
            "longitude": 85.3797748,
            "latitude": 52.7229723
        },
        "5235": {
            "name": "Хомутино",
            "population": 438,
            "type": "village",
            "poly": null,
            "longitude": 85.4075141,
            "latitude": 53.1620947
        },
        "5236": {
            "name": "Семеновод",
            "population": 611,
            "type": "village",
            "poly": null,
            "longitude": 85.4201525,
            "latitude": 52.5489707
        },
        "5237": {
            "name": "Зыряновка",
            "population": 355,
            "type": "village",
            "poly": null,
            "longitude": 85.4207556,
            "latitude": 53.7813738
        },
        "5238": {
            "name": "Верх-Катунское",
            "population": 2723,
            "type": "village",
            "poly": [
                [
                    85.3830244,
                    52.4630007
                ],
                [
                    85.3850141,
                    52.4730566
                ],
                [
                    85.414106,
                    52.4649023
                ],
                [
                    85.441827,
                    52.4543417
                ],
                [
                    85.4679397,
                    52.4472782
                ],
                [
                    85.4633637,
                    52.4378233
                ],
                [
                    85.4177921,
                    52.4497275
                ],
                [
                    85.411678,
                    52.4563262
                ],
                [
                    85.3890332,
                    52.4612266
                ],
                [
                    85.3858055,
                    52.4614412
                ],
                [
                    85.3830244,
                    52.4630007
                ]
            ],
            "longitude": 85.4243749,
            "latitude": 52.4515934
        },
        "5239": {
            "name": "Голуха",
            "population": 1660,
            "type": "village",
            "poly": null,
            "longitude": 85.429787,
            "latitude": 53.845795
        },
        "5240": {
            "name": "Ясная Поляна",
            "population": 374,
            "type": "village",
            "poly": null,
            "longitude": 85.4319163,
            "latitude": 52.6814216
        },
        "5241": {
            "name": "Сосновый Лог",
            "population": 514,
            "type": "village",
            "poly": null,
            "longitude": 85.4385701,
            "latitude": 53.3293616
        },
        "5242": {
            "name": "Ложкино",
            "population": 613,
            "type": "village",
            "poly": null,
            "longitude": 85.441424,
            "latitude": 52.8349374
        },
        "5243": {
            "name": "Кытманово",
            "population": 3798,
            "type": "village",
            "poly": [
                [
                    85.4248144,
                    53.44782
                ],
                [
                    85.4249152,
                    53.4533678
                ],
                [
                    85.4264259,
                    53.4600381
                ],
                [
                    85.4291589,
                    53.4632454
                ],
                [
                    85.4345509,
                    53.4698002
                ],
                [
                    85.4445755,
                    53.4681468
                ],
                [
                    85.4507164,
                    53.467537
                ],
                [
                    85.4577918,
                    53.4625308
                ],
                [
                    85.4620805,
                    53.4590153
                ],
                [
                    85.4761814,
                    53.4567314
                ],
                [
                    85.4822829,
                    53.4523914
                ],
                [
                    85.4668228,
                    53.4459524
                ],
                [
                    85.4521558,
                    53.4471658
                ],
                [
                    85.4427877,
                    53.4482729
                ],
                [
                    85.4248144,
                    53.44782
                ]
            ],
            "longitude": 85.450447,
            "latitude": 53.459545
        },
        "5244": {
            "name": "Сетовка",
            "population": 1004,
            "type": "village",
            "poly": [
                [
                    85.4504985,
                    52.1975081
                ],
                [
                    85.4506701,
                    52.2032947
                ],
                [
                    85.4779643,
                    52.2051883
                ],
                [
                    85.4853457,
                    52.2017166
                ],
                [
                    85.5045718,
                    52.198455
                ],
                [
                    85.5042285,
                    52.1958245
                ],
                [
                    85.4884356,
                    52.1974029
                ],
                [
                    85.4721278,
                    52.1948775
                ],
                [
                    85.4616565,
                    52.1963507
                ],
                [
                    85.4504985,
                    52.1975081
                ]
            ],
            "longitude": 85.467493,
            "latitude": 52.1998228
        },
        "5245": {
            "name": "Тяхта",
            "population": 525,
            "type": "village",
            "poly": null,
            "longitude": 85.4735413,
            "latitude": 53.576144
        },
        "5246": {
            "name": "Тягун",
            "population": 630,
            "type": "village",
            "poly": null,
            "longitude": 85.4756995,
            "latitude": 53.4703207
        },
        "5247": {
            "name": "Старая Тараба",
            "population": 377,
            "type": "village",
            "poly": null,
            "longitude": 85.4864064,
            "latitude": 53.3996706
        },
        "5248": {
            "name": "Чуйский",
            "population": 379,
            "type": "village",
            "poly": null,
            "longitude": 85.4903889,
            "latitude": 52.4414288
        },
        "5249": {
            "name": "Енисейское",
            "population": 1457,
            "type": "village",
            "poly": [
                [
                    85.4639955,
                    52.5727967
                ],
                [
                    85.4804552,
                    52.5797033
                ],
                [
                    85.4990703,
                    52.5836325
                ],
                [
                    85.5132767,
                    52.5836325
                ],
                [
                    85.5209187,
                    52.5782745
                ],
                [
                    85.5117091,
                    52.5771433
                ],
                [
                    85.5064185,
                    52.5770837
                ],
                [
                    85.4876074,
                    52.5735708
                ],
                [
                    85.4756545,
                    52.5711295
                ],
                [
                    85.4639955,
                    52.5727967
                ]
            ],
            "longitude": 85.4940737,
            "latitude": 52.5780959
        },
        "5250": {
            "name": "Марушка",
            "population": 1252,
            "type": "village",
            "poly": null,
            "longitude": 85.5028394,
            "latitude": 52.8786482
        },
        "5251": {
            "name": "Малоенисейское",
            "population": 2181,
            "type": "village",
            "poly": null,
            "longitude": 85.502853,
            "latitude": 52.567955
        },
        "5252": {
            "name": "Жуланиха",
            "population": 695,
            "type": "village",
            "poly": null,
            "longitude": 85.508255,
            "latitude": 53.786808
        },
        "5253": {
            "name": "Дружба",
            "population": 698,
            "type": "village",
            "poly": null,
            "longitude": 85.521656,
            "latitude": 52.8996201
        },
        "5254": {
            "name": "Светлоозёрское",
            "population": 1141,
            "type": "village",
            "poly": null,
            "longitude": 85.5224499,
            "latitude": 52.527213
        },
        "5255": {
            "name": "Кокши",
            "population": 1045,
            "type": "village",
            "poly": [
                [
                    85.5256854,
                    52.3826236
                ],
                [
                    85.5340968,
                    52.3873384
                ],
                [
                    85.5442249,
                    52.3830427
                ],
                [
                    85.5328952,
                    52.3660653
                ],
                [
                    85.528432,
                    52.3768604
                ],
                [
                    85.5256854,
                    52.3826236
                ]
            ],
            "longitude": 85.5342685,
            "latitude": 52.3809471
        },
        "5256": {
            "name": "Сунгай",
            "population": 626,
            "type": "village",
            "poly": null,
            "longitude": 85.5417848,
            "latitude": 53.6499586
        },
        "5257": {
            "name": "Рупосово",
            "population": 53,
            "type": "village",
            "poly": null,
            "longitude": 85.5595586,
            "latitude": 52.9560771
        },
        "5258": {
            "name": "Воеводское",
            "population": 1495,
            "type": "village",
            "poly": [
                [
                    85.5863187,
                    52.7877084
                ],
                [
                    85.6199556,
                    52.8116608
                ],
                [
                    85.6229455,
                    52.8053351
                ],
                [
                    85.6229455,
                    52.8001382
                ],
                [
                    85.6098645,
                    52.7877084
                ],
                [
                    85.6087433,
                    52.7843177
                ],
                [
                    85.5956623,
                    52.7795706
                ],
                [
                    85.5863187,
                    52.7877084
                ]
            ],
            "longitude": 85.6031371,
            "latitude": 52.7929067
        },
        "5259": {
            "name": "Семёно-Красилово",
            "population": 493,
            "type": "village",
            "poly": null,
            "longitude": 85.6093153,
            "latitude": 53.5593876
        },
        "5260": {
            "name": "Семилетка",
            "population": 494,
            "type": "village",
            "poly": null,
            "longitude": 85.6154787,
            "latitude": 52.302418
        },
        "5261": {
            "name": "Половинка",
            "population": 629,
            "type": "village",
            "poly": [
                [
                    85.5976123,
                    52.186985
                ],
                [
                    85.6353778,
                    52.1959298
                ],
                [
                    85.6353778,
                    52.1922468
                ],
                [
                    85.6257647,
                    52.1857221
                ],
                [
                    85.6159799,
                    52.1834066
                ],
                [
                    85.6067103,
                    52.1837223
                ],
                [
                    85.5976123,
                    52.186985
                ]
            ],
            "longitude": 85.6183833,
            "latitude": 52.1883531
        },
        "5262": {
            "name": "Колово",
            "population": 391,
            "type": "village",
            "poly": [
                [
                    85.6118602,
                    52.0856257
                ],
                [
                    85.6127185,
                    52.091005
                ],
                [
                    85.6252498,
                    52.0954345
                ],
                [
                    85.6365794,
                    52.0875243
                ],
                [
                    85.6283397,
                    52.0823556
                ],
                [
                    85.6118602,
                    52.0856257
                ]
            ],
            "longitude": 85.6225032,
            "latitude": 52.0883681
        },
        "5263": {
            "name": "Стан-Бехтемир",
            "population": 1038,
            "type": "village",
            "poly": null,
            "longitude": 85.62426,
            "latitude": 52.600708
        },
        "5264": {
            "name": "Верх-Марушка",
            "population": 713,
            "type": "village",
            "poly": [
                [
                    85.6120419,
                    52.9159859
                ],
                [
                    85.6190604,
                    52.9218898
                ],
                [
                    85.6255695,
                    52.9247563
                ],
                [
                    85.6399461,
                    52.9223676
                ],
                [
                    85.6387009,
                    52.910559
                ],
                [
                    85.6295315,
                    52.9092619
                ],
                [
                    85.6278335,
                    52.913392
                ],
                [
                    85.6221735,
                    52.9152692
                ],
                [
                    85.615155,
                    52.9136309
                ],
                [
                    85.6120419,
                    52.9159859
                ]
            ],
            "longitude": 85.6260223,
            "latitude": 52.9181019
        },
        "5265": {
            "name": "Урожайное",
            "population": 1318,
            "type": "village",
            "poly": [
                [
                    85.6363777,
                    52.3045989
                ],
                [
                    85.6364317,
                    52.3074347
                ],
                [
                    85.6376087,
                    52.3098467
                ],
                [
                    85.6492816,
                    52.3107912
                ],
                [
                    85.6566631,
                    52.3094269
                ],
                [
                    85.6588947,
                    52.3023944
                ],
                [
                    85.6506549,
                    52.2998751
                ],
                [
                    85.6400932,
                    52.298037
                ],
                [
                    85.6363777,
                    52.3045989
                ]
            ],
            "longitude": 85.647911,
            "latitude": 52.305332
        },
        "5266": {
            "name": "Тягун",
            "population": 1926,
            "type": "village",
            "poly": [
                [
                    85.6299362,
                    53.9541806
                ],
                [
                    85.6344675,
                    53.958645
                ],
                [
                    85.6459539,
                    53.957653
                ],
                [
                    85.6510122,
                    53.959761
                ],
                [
                    85.6494315,
                    53.9671385
                ],
                [
                    85.6638685,
                    53.9658367
                ],
                [
                    85.6734581,
                    53.961559
                ],
                [
                    85.676198,
                    53.959327
                ],
                [
                    85.673142,
                    53.9535605
                ],
                [
                    85.6776733,
                    53.950832
                ],
                [
                    85.6752496,
                    53.9439479
                ],
                [
                    85.6759872,
                    53.9374969
                ],
                [
                    85.657335,
                    53.932658
                ],
                [
                    85.6433194,
                    53.9374348
                ],
                [
                    85.6383666,
                    53.9461187
                ],
                [
                    85.6299362,
                    53.9541806
                ]
            ],
            "longitude": 85.658531,
            "latitude": 53.950409
        },
        "5267": {
            "name": "Верх-Ая",
            "population": 306,
            "type": "village",
            "poly": null,
            "longitude": 85.6644348,
            "latitude": 51.9581062
        },
        "5268": {
            "name": "Талица",
            "population": 447,
            "type": "village",
            "poly": [
                [
                    85.6599246,
                    52.3877575
                ],
                [
                    85.6599246,
                    52.3914242
                ],
                [
                    85.6764041,
                    52.3962429
                ],
                [
                    85.6848155,
                    52.3900622
                ],
                [
                    85.6755458,
                    52.380528
                ],
                [
                    85.6664478,
                    52.3796897
                ],
                [
                    85.6599246,
                    52.3877575
                ]
            ],
            "longitude": 85.6712543,
            "latitude": 52.3907957
        },
        "5269": {
            "name": "Сростки",
            "population": 2769,
            "type": "village",
            "poly": [
                [
                    85.6761727,
                    52.4238121
                ],
                [
                    85.6864665,
                    52.4293642
                ],
                [
                    85.7043252,
                    52.4321859
                ],
                [
                    85.7135949,
                    52.4312439
                ],
                [
                    85.7260698,
                    52.4199124
                ],
                [
                    85.7194568,
                    52.4110501
                ],
                [
                    85.717332,
                    52.4056501
                ],
                [
                    85.7146627,
                    52.4034486
                ],
                [
                    85.7131257,
                    52.4036184
                ],
                [
                    85.7114052,
                    52.4039491
                ],
                [
                    85.7093405,
                    52.4049521
                ],
                [
                    85.707549,
                    52.4061768
                ],
                [
                    85.7058349,
                    52.4081876
                ],
                [
                    85.7049557,
                    52.409767
                ],
                [
                    85.7038822,
                    52.4108756
                ],
                [
                    85.6996177,
                    52.4120544
                ],
                [
                    85.6952983,
                    52.4138162
                ],
                [
                    85.6930017,
                    52.4149058
                ],
                [
                    85.6876609,
                    52.4157247
                ],
                [
                    85.6761727,
                    52.4238121
                ]
            ],
            "longitude": 85.7060495,
            "latitude": 52.4209605
        },
        "5270": {
            "name": "Нижнекаянча",
            "population": 414,
            "type": "village",
            "poly": null,
            "longitude": 85.7109847,
            "latitude": 51.8675348
        },
        "5271": {
            "name": "Еланда",
            "population": 761,
            "type": "village",
            "poly": null,
            "longitude": 85.7225775,
            "latitude": 53.1886923
        },
        "5272": {
            "name": "Усятское",
            "population": 1006,
            "type": "village",
            "poly": null,
            "longitude": 85.7541038,
            "latitude": 52.5661635
        },
        "5273": {
            "name": "Большеугренево",
            "population": 799,
            "type": "village",
            "poly": null,
            "longitude": 85.7565173,
            "latitude": 52.6073922
        },
        "5274": {
            "name": "Устюба",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 85.7587216,
            "latitude": 51.8764414
        },
        "5275": {
            "name": "Титово",
            "population": 186,
            "type": "village",
            "poly": null,
            "longitude": 85.7596169,
            "latitude": 53.4154868
        },
        "5276": {
            "name": "Бочкари",
            "population": 1309,
            "type": "village",
            "poly": null,
            "longitude": 85.7727873,
            "latitude": 52.8875901
        },
        "5277": {
            "name": "Верх-Яминское",
            "population": 270,
            "type": "village",
            "poly": null,
            "longitude": 85.8010174,
            "latitude": 52.993801
        },
        "5278": {
            "name": "Шебалино",
            "population": 1105,
            "type": "village",
            "poly": null,
            "longitude": 85.8048173,
            "latitude": 52.7171509
        },
        "5279": {
            "name": "Ая",
            "population": 2233,
            "type": "village",
            "poly": [
                [
                    85.7972544,
                    51.937705
                ],
                [
                    85.7998293,
                    51.9553755
                ],
                [
                    85.8006877,
                    51.9756827
                ],
                [
                    85.8081093,
                    51.9760079
                ],
                [
                    85.8115384,
                    51.9741974
                ],
                [
                    85.8097434,
                    51.9702878
                ],
                [
                    85.8083915,
                    51.964709
                ],
                [
                    85.8072465,
                    51.9642386
                ],
                [
                    85.8067193,
                    51.9632417
                ],
                [
                    85.8067011,
                    51.9624689
                ],
                [
                    85.8071556,
                    51.96164
                ],
                [
                    85.8079735,
                    51.9609232
                ],
                [
                    85.8094246,
                    51.9586143
                ],
                [
                    85.8112637,
                    51.9568795
                ],
                [
                    85.8148205,
                    51.9546299
                ],
                [
                    85.8151922,
                    51.9537209
                ],
                [
                    85.8137743,
                    51.9514579
                ],
                [
                    85.8138834,
                    51.9494636
                ],
                [
                    85.8166521,
                    51.9411973
                ],
                [
                    85.812704,
                    51.9330481
                ],
                [
                    85.8060092,
                    51.9336832
                ],
                [
                    85.8022377,
                    51.9354158
                ],
                [
                    85.7972544,
                    51.937705
                ]
            ],
            "longitude": 85.80687,
            "latitude": 51.953049
        },
        "5280": {
            "name": "Новоиушино",
            "population": 357,
            "type": "village",
            "poly": null,
            "longitude": 85.8086075,
            "latitude": 53.6359177
        },
        "5281": {
            "name": "Берёзовка",
            "population": 1243,
            "type": "village",
            "poly": [
                [
                    85.810051,
                    52.3539322
                ],
                [
                    85.8138276,
                    52.358126
                ],
                [
                    85.8230973,
                    52.3599082
                ],
                [
                    85.8272172,
                    52.3596985
                ],
                [
                    85.8349419,
                    52.3497382
                ],
                [
                    85.8309936,
                    52.3474312
                ],
                [
                    85.8321953,
                    52.3443901
                ],
                [
                    85.8272172,
                    52.3474312
                ],
                [
                    85.8225822,
                    52.3466972
                ],
                [
                    85.8174325,
                    52.350577
                ],
                [
                    85.810051,
                    52.3539322
                ]
            ],
            "longitude": 85.822594,
            "latitude": 52.353035
        },
        "5282": {
            "name": "Быстрянка",
            "population": 1838,
            "type": "village",
            "poly": [
                [
                    85.8164201,
                    52.2924506
                ],
                [
                    85.8256898,
                    52.3037884
                ],
                [
                    85.8303247,
                    52.3020039
                ],
                [
                    85.8370195,
                    52.2836303
                ],
                [
                    85.8450875,
                    52.2711318
                ],
                [
                    85.8430276,
                    52.2678753
                ],
                [
                    85.8313546,
                    52.2679804
                ],
                [
                    85.8349595,
                    52.2730226
                ],
                [
                    85.8325562,
                    52.2791144
                ],
                [
                    85.8184799,
                    52.2863606
                ],
                [
                    85.8164201,
                    52.2924506
                ]
            ],
            "longitude": 85.8313865,
            "latitude": 52.2853349
        },
        "5283": {
            "name": "Антипино",
            "population": 1582,
            "type": "village",
            "poly": null,
            "longitude": 85.843048,
            "latitude": 53.297543
        },
        "5284": {
            "name": "Шалап",
            "population": 956,
            "type": "village",
            "poly": [
                [
                    85.8177471,
                    53.1194276
                ],
                [
                    85.8664832,
                    53.1266047
                ],
                [
                    85.8703701,
                    53.119966
                ],
                [
                    85.8368827,
                    53.1068649
                ],
                [
                    85.8177471,
                    53.1194276
                ]
            ],
            "longitude": 85.8458525,
            "latitude": 53.1170948
        },
        "5285": {
            "name": "Катунь",
            "population": 272,
            "type": "village",
            "poly": null,
            "longitude": 85.8511328,
            "latitude": 51.9162409
        },
        "5286": {
            "name": "Шульгин Лог",
            "population": 824,
            "type": "village",
            "poly": [
                [
                    85.843259,
                    52.1867769
                ],
                [
                    85.8508121,
                    52.1883556
                ],
                [
                    85.8578502,
                    52.1698295
                ],
                [
                    85.8616268,
                    52.1534022
                ],
                [
                    85.8542453,
                    52.1572989
                ],
                [
                    85.843259,
                    52.1867769
                ]
            ],
            "longitude": 85.853218,
            "latitude": 52.170986
        },
        "5287": {
            "name": "Колонково",
            "population": 336,
            "type": "village",
            "poly": null,
            "longitude": 85.8683419,
            "latitude": 53.3303324
        },
        "5288": {
            "name": "Старая Суртайка",
            "population": 320,
            "type": "village",
            "poly": [
                [
                    85.8699783,
                    52.2349819
                ],
                [
                    85.8751283,
                    52.2388716
                ],
                [
                    85.8806214,
                    52.2382408
                ],
                [
                    85.8826814,
                    52.2339306
                ],
                [
                    85.8842263,
                    52.2308817
                ],
                [
                    85.8816514,
                    52.2258347
                ],
                [
                    85.8746132,
                    52.2250986
                ],
                [
                    85.8708424,
                    52.2327895
                ],
                [
                    85.8699783,
                    52.2349819
                ]
            ],
            "longitude": 85.8761243,
            "latitude": 52.2305674
        },
        "5289": {
            "name": "Аламбай",
            "population": 502,
            "type": "village",
            "poly": [
                [
                    85.8577702,
                    54.0236709
                ],
                [
                    85.8593493,
                    54.0291483
                ],
                [
                    85.8663873,
                    54.0322739
                ],
                [
                    85.8775454,
                    54.0350968
                ],
                [
                    85.888772,
                    54.0355353
                ],
                [
                    85.8996897,
                    54.0388268
                ],
                [
                    85.9043245,
                    54.0374155
                ],
                [
                    85.9075861,
                    54.0357017
                ],
                [
                    85.9091997,
                    54.0338214
                ],
                [
                    85.9079294,
                    54.0307615
                ],
                [
                    85.9088564,
                    54.0286794
                ],
                [
                    85.9044962,
                    54.0276358
                ],
                [
                    85.901578,
                    54.0271316
                ],
                [
                    85.8964281,
                    54.0264258
                ],
                [
                    85.8935785,
                    54.0262594
                ],
                [
                    85.8904886,
                    54.0244443
                ],
                [
                    85.889802,
                    54.0224274
                ],
                [
                    85.889802,
                    54.0195028
                ],
                [
                    85.8881884,
                    54.0181564
                ],
                [
                    85.8832788,
                    54.0182926
                ],
                [
                    85.8803606,
                    54.0195028
                ],
                [
                    85.8774424,
                    54.0190994
                ],
                [
                    85.8743525,
                    54.0178891
                ],
                [
                    85.8694773,
                    54.0198709
                ],
                [
                    85.8682756,
                    54.0229972
                ],
                [
                    85.8577702,
                    54.0236709
                ]
            ],
            "longitude": 85.889252,
            "latitude": 54.032581
        },
        "5290": {
            "name": "Шадрино",
            "population": 132,
            "type": "village",
            "poly": null,
            "longitude": 85.8923742,
            "latitude": 52.8556009
        },
        "5291": {
            "name": "Старый Тогул",
            "population": 1272,
            "type": "village",
            "poly": null,
            "longitude": 85.903373,
            "latitude": 53.4251161
        },
        "5292": {
            "name": "Платово",
            "population": 691,
            "type": "village",
            "poly": [
                [
                    85.8944813,
                    52.0959499
                ],
                [
                    85.895794,
                    52.0957067
                ],
                [
                    85.897322,
                    52.0926549
                ],
                [
                    85.8988531,
                    52.0909118
                ],
                [
                    85.9027492,
                    52.0887626
                ],
                [
                    85.904077,
                    52.0835374
                ],
                [
                    85.9058679,
                    52.0788836
                ],
                [
                    85.9081075,
                    52.075608
                ],
                [
                    85.9103365,
                    52.0710328
                ],
                [
                    85.910556,
                    52.0684659
                ],
                [
                    85.909436,
                    52.0638707
                ],
                [
                    85.9096162,
                    52.0609499
                ],
                [
                    85.9090178,
                    52.0608774
                ],
                [
                    85.904122,
                    52.0602854
                ],
                [
                    85.90231,
                    52.0692756
                ],
                [
                    85.9011789,
                    52.072299
                ],
                [
                    85.8992206,
                    52.0728628
                ],
                [
                    85.8982634,
                    52.0828715
                ],
                [
                    85.8951179,
                    52.0916268
                ],
                [
                    85.8944813,
                    52.0959499
                ]
            ],
            "longitude": 85.905228,
            "latitude": 52.072865
        },
        "5293": {
            "name": "Мартыново",
            "population": 1252,
            "type": "village",
            "poly": [
                [
                    85.8850298,
                    53.2585001
                ],
                [
                    85.8994263,
                    53.2715729
                ],
                [
                    85.9007885,
                    53.2783721
                ],
                [
                    85.9092351,
                    53.2820111
                ],
                [
                    85.9345364,
                    53.272792
                ],
                [
                    85.9425419,
                    53.2665858
                ],
                [
                    85.930682,
                    53.2512732
                ],
                [
                    85.900439,
                    53.2503862
                ],
                [
                    85.8858116,
                    53.2557671
                ],
                [
                    85.8850298,
                    53.2585001
                ]
            ],
            "longitude": 85.9106275,
            "latitude": 53.2615329
        },
        "5294": {
            "name": "Верх-Бехтемир",
            "population": 979,
            "type": "village",
            "poly": null,
            "longitude": 85.9111242,
            "latitude": 52.7690288
        },
        "5295": {
            "name": "Тогул",
            "population": 4349,
            "type": "village",
            "poly": [
                [
                    85.8969311,
                    53.4508242
                ],
                [
                    85.9032271,
                    53.467693
                ],
                [
                    85.9145075,
                    53.4772178
                ],
                [
                    85.9231646,
                    53.4731584
                ],
                [
                    85.9163439,
                    53.4480121
                ],
                [
                    85.9019153,
                    53.448637
                ],
                [
                    85.8969311,
                    53.4508242
                ]
            ],
            "longitude": 85.913284,
            "latitude": 53.462803
        },
        "5296": {
            "name": "Льнозавод",
            "population": 177,
            "type": "village",
            "poly": null,
            "longitude": 85.9531665,
            "latitude": 53.4557892
        },
        "5297": {
            "name": "Новиково",
            "population": 1157,
            "type": "village",
            "poly": [
                [
                    85.9475427,
                    52.6215314
                ],
                [
                    85.948796,
                    52.6235791
                ],
                [
                    85.9513709,
                    52.6230581
                ],
                [
                    85.9565207,
                    52.6246212
                ],
                [
                    85.9625203,
                    52.6253506
                ],
                [
                    85.9702021,
                    52.6248661
                ],
                [
                    85.9757382,
                    52.6246212
                ],
                [
                    85.9806735,
                    52.6247619
                ],
                [
                    85.983463,
                    52.625559
                ],
                [
                    85.9853512,
                    52.6242044
                ],
                [
                    85.9899861,
                    52.6243086
                ],
                [
                    85.9944493,
                    52.6249338
                ],
                [
                    85.9970242,
                    52.6253506
                ],
                [
                    85.9966809,
                    52.6241002
                ],
                [
                    85.9911877,
                    52.6226413
                ],
                [
                    85.9874112,
                    52.6217034
                ],
                [
                    85.9808879,
                    52.6223286
                ],
                [
                    85.971275,
                    52.6211823
                ],
                [
                    85.9669835,
                    52.6202444
                ],
                [
                    85.9653955,
                    52.6173628
                ],
                [
                    85.9662968,
                    52.6137878
                ],
                [
                    85.9678418,
                    52.6110777
                ],
                [
                    85.9637219,
                    52.6068038
                ],
                [
                    85.9630353,
                    52.6036762
                ],
                [
                    85.9584004,
                    52.6053444
                ],
                [
                    85.9590871,
                    52.6097226
                ],
                [
                    85.9554907,
                    52.6115989
                ],
                [
                    85.9547526,
                    52.6167374
                ],
                [
                    85.9530875,
                    52.6201402
                ],
                [
                    85.9475427,
                    52.6215314
                ]
            ],
            "longitude": 85.9595767,
            "latitude": 52.6211277
        },
        "5298": {
            "name": "Соусканиха",
            "population": 720,
            "type": "village",
            "poly": null,
            "longitude": 85.962456,
            "latitude": 52.564526
        },
        "5299": {
            "name": "Усть-Иша",
            "population": 1362,
            "type": "village",
            "poly": [
                [
                    85.9512347,
                    52.1800842
                ],
                [
                    85.9556979,
                    52.1839786
                ],
                [
                    85.9663409,
                    52.1880832
                ],
                [
                    85.9752673,
                    52.1903984
                ],
                [
                    85.9797305,
                    52.1880832
                ],
                [
                    85.9742373,
                    52.1754525
                ],
                [
                    85.9598178,
                    52.1726101
                ],
                [
                    85.9579295,
                    52.1635554
                ],
                [
                    85.9565562,
                    52.1632395
                ],
                [
                    85.9543246,
                    52.1733471
                ],
                [
                    85.9512347,
                    52.1800842
                ]
            ],
            "longitude": 85.9647982,
            "latitude": 52.1787095
        },
        "5300": {
            "name": "Уксунай",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 86.0114414,
            "latitude": 53.4959336
        },
        "5301": {
            "name": "Степь-Чумыш",
            "population": 206,
            "type": "village",
            "poly": null,
            "longitude": 86.0212658,
            "latitude": 53.1190597
        },
        "5302": {
            "name": "Талый",
            "population": 323,
            "type": "village",
            "poly": null,
            "longitude": 86.0454337,
            "latitude": 52.3198117
        },
        "5303": {
            "name": "Победа",
            "population": 735,
            "type": "village",
            "poly": null,
            "longitude": 86.0476091,
            "latitude": 53.1229493
        },
        "5304": {
            "name": "Карагуж",
            "population": 347,
            "type": "village",
            "poly": null,
            "longitude": 86.07766,
            "latitude": 52.140865
        },
        "5305": {
            "name": "Овсянниково",
            "population": 646,
            "type": "village",
            "poly": null,
            "longitude": 86.0844161,
            "latitude": 52.9276128
        },
        "5306": {
            "name": "Топтушка",
            "population": 186,
            "type": "village",
            "poly": null,
            "longitude": 86.098,
            "latitude": 53.373035
        },
        "5307": {
            "name": "Лебяжье",
            "population": 295,
            "type": "village",
            "poly": null,
            "longitude": 86.1302149,
            "latitude": 52.5955507
        },
        "5308": {
            "name": "Черемшанка",
            "population": 305,
            "type": "village",
            "poly": null,
            "longitude": 86.1552611,
            "latitude": 53.198321
        },
        "5309": {
            "name": "Новозыково",
            "population": 726,
            "type": "village",
            "poly": null,
            "longitude": 86.1869638,
            "latitude": 52.1583942
        },
        "5310": {
            "name": "Верх-Коптелка",
            "population": 208,
            "type": "village",
            "poly": null,
            "longitude": 86.1934193,
            "latitude": 53.4670083
        },
        "5311": {
            "name": "Ненинка",
            "population": 1211,
            "type": "village",
            "poly": null,
            "longitude": 86.197098,
            "latitude": 52.672928
        },
        "5312": {
            "name": "Локоть",
            "population": 175,
            "type": "village",
            "poly": null,
            "longitude": 86.2141011,
            "latitude": 53.0507518
        },
        "5313": {
            "name": "Карабинка",
            "population": 1387,
            "type": "village",
            "poly": null,
            "longitude": 86.246065,
            "latitude": 52.683705
        },
        "5314": {
            "name": "Поповичи",
            "population": 594,
            "type": "village",
            "poly": null,
            "longitude": 86.2637561,
            "latitude": 53.0053669
        },
        "5315": {
            "name": "Новокаменка",
            "population": 379,
            "type": "village",
            "poly": null,
            "longitude": 86.3162656,
            "latitude": 53.3576556
        },
        "5316": {
            "name": "Березово",
            "population": 439,
            "type": "village",
            "poly": null,
            "longitude": 86.3219666,
            "latitude": 52.8825536
        },
        "5317": {
            "name": "Новая Ажинка",
            "population": 193,
            "type": "village",
            "poly": null,
            "longitude": 86.3243973,
            "latitude": 52.5509036
        },
        "5318": {
            "name": "Усть-Кажа",
            "population": 697,
            "type": "village",
            "poly": null,
            "longitude": 86.338402,
            "latitude": 52.544403
        },
        "5319": {
            "name": "имени Фрунзе",
            "population": 273,
            "type": "village",
            "poly": null,
            "longitude": 86.3405155,
            "latitude": 52.5853639
        },
        "5320": {
            "name": "Караган",
            "population": 244,
            "type": "village",
            "poly": null,
            "longitude": 86.3442311,
            "latitude": 52.8029444
        },
        "5321": {
            "name": "Нижняя Ненинка",
            "population": 906,
            "type": "village",
            "poly": null,
            "longitude": 86.4002447,
            "latitude": 52.7330084
        },
        "5322": {
            "name": "Верх-Неня",
            "population": 226,
            "type": "village",
            "poly": null,
            "longitude": 86.4273893,
            "latitude": 53.0744334
        },
        "5323": {
            "name": "Пуштулим",
            "population": 705,
            "type": "village",
            "poly": null,
            "longitude": 86.4304676,
            "latitude": 53.2034
        },
        "5324": {
            "name": "Акатьево",
            "population": 129,
            "type": "village",
            "poly": null,
            "longitude": 86.4641104,
            "latitude": 52.774131
        },
        "5325": {
            "name": "Солтон",
            "population": 2770,
            "type": "village",
            "poly": [
                [
                    86.4553622,
                    52.8444537
                ],
                [
                    86.4612384,
                    52.8495236
                ],
                [
                    86.4715221,
                    52.8471155
                ],
                [
                    86.4818056,
                    52.8533257
                ],
                [
                    86.4927188,
                    52.8450875
                ],
                [
                    86.4752996,
                    52.8292403
                ],
                [
                    86.4553622,
                    52.8444537
                ]
            ],
            "longitude": 86.4763899,
            "latitude": 52.8376309
        },
        "5326": {
            "name": "Тосток",
            "population": 241,
            "type": "village",
            "poly": null,
            "longitude": 86.5254175,
            "latitude": 52.7466842
        },
        "5327": {
            "name": "Урунск",
            "population": 267,
            "type": "village",
            "poly": null,
            "longitude": 86.5337088,
            "latitude": 52.8867566
        },
        "5328": {
            "name": "Макарьевка",
            "population": 692,
            "type": "village",
            "poly": null,
            "longitude": 86.5430727,
            "latitude": 52.992604
        },
        "5329": {
            "name": "Шатобал",
            "population": 184,
            "type": "village",
            "poly": null,
            "longitude": 86.558702,
            "latitude": 52.8575743
        },
        "5330": {
            "name": "Сайдып",
            "population": 330,
            "type": "village",
            "poly": null,
            "longitude": 86.5738065,
            "latitude": 52.5738353
        },
        "5331": {
            "name": "Излап",
            "population": 271,
            "type": "village",
            "poly": null,
            "longitude": 86.619682,
            "latitude": 52.907101
        },
        "5332": {
            "name": "Сузоп",
            "population": 923,
            "type": "village",
            "poly": null,
            "longitude": 86.6338219,
            "latitude": 52.7775882
        },
        "5333": {
            "name": "Усть-Куют",
            "population": 92,
            "type": "village",
            "poly": null,
            "longitude": 86.6420624,
            "latitude": 52.5268445
        },
        "5334": {
            "name": "Саяны",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 99.674812,
            "latitude": 52.689281
        },
        "5335": {
            "name": "Орлик",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 99.826981,
            "latitude": 52.513195
        },
        "5336": {
            "name": "Хужир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 99.858368,
            "latitude": 52.795006
        },
        "5337": {
            "name": "Сорок",
            "population": 739,
            "type": "village",
            "poly": null,
            "longitude": 100.1711285,
            "latitude": 52.3252047
        },
        "5338": {
            "name": "Монды",
            "population": 2164,
            "type": "village",
            "poly": [
                [
                    100.9745131,
                    51.677957
                ],
                [
                    100.9785324,
                    51.683172
                ],
                [
                    101.0008618,
                    51.6780954
                ],
                [
                    101.0147805,
                    51.6755108
                ],
                [
                    101.013664,
                    51.671772
                ],
                [
                    101.0001175,
                    51.6708949
                ],
                [
                    100.9818818,
                    51.6733414
                ],
                [
                    100.9745131,
                    51.677957
                ]
            ],
            "longitude": 100.996269,
            "latitude": 51.675842
        },
        "5339": {
            "name": "Хойто-Гол",
            "population": 609,
            "type": "village",
            "poly": null,
            "longitude": 101.5208392,
            "latitude": 51.7038673
        },
        "5340": {
            "name": "Туран",
            "population": null,
            "type": "village",
            "poly": [
                [
                    101.6452618,
                    51.6317262
                ],
                [
                    101.6491677,
                    51.6399438
                ],
                [
                    101.6605542,
                    51.6386702
                ],
                [
                    101.6663799,
                    51.6392454
                ],
                [
                    101.6743902,
                    51.6411763
                ],
                [
                    101.6775016,
                    51.6387934
                ],
                [
                    101.6790243,
                    51.6343559
                ],
                [
                    101.6671743,
                    51.6332055
                ],
                [
                    101.6539341,
                    51.6302058
                ],
                [
                    101.6519481,
                    51.6313564
                ],
                [
                    101.6452618,
                    51.6317262
                ]
            ],
            "longitude": 101.65976,
            "latitude": 51.635654
        },
        "5341": {
            "name": "Ниловка",
            "population": 175,
            "type": "village",
            "poly": null,
            "longitude": 101.679334,
            "latitude": 51.6916828
        },
        "5342": {
            "name": "Шимки",
            "population": null,
            "type": "village",
            "poly": [
                [
                    101.9876996,
                    51.6660128
                ],
                [
                    101.9952853,
                    51.6687894
                ],
                [
                    102.0016273,
                    51.6711031
                ],
                [
                    102.0110781,
                    51.6757301
                ],
                [
                    102.0143113,
                    51.6830552
                ],
                [
                    102.0228917,
                    51.6847514
                ],
                [
                    102.0181663,
                    51.6751903
                ],
                [
                    102.0222699,
                    51.6714115
                ],
                [
                    102.0222699,
                    51.6678639
                ],
                [
                    101.9898137,
                    51.660922
                ],
                [
                    101.9876996,
                    51.6660128
                ]
            ],
            "longitude": 102.0074832,
            "latitude": 51.670117
        },
        "5343": {
            "name": "Хужиры",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 102.092522,
            "latitude": 51.678772
        },
        "5344": {
            "name": "Харбяты",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.2721469,
                    51.6672339
                ],
                [
                    102.2738046,
                    51.6753505
                ],
                [
                    102.2890735,
                    51.675621
                ],
                [
                    102.2950938,
                    51.6675586
                ],
                [
                    102.2918655,
                    51.6654481
                ],
                [
                    102.2745026,
                    51.6605232
                ],
                [
                    102.2721469,
                    51.6672339
                ]
            ],
            "longitude": 102.282265,
            "latitude": 51.668316
        },
        "5345": {
            "name": "Тагархай",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.3769381,
                    51.8788096
                ],
                [
                    102.3842419,
                    51.8847014
                ],
                [
                    102.3921266,
                    51.8839329
                ],
                [
                    102.407647,
                    51.8824985
                ],
                [
                    102.4126268,
                    51.8807565
                ],
                [
                    102.4135398,
                    51.8752229
                ],
                [
                    102.3971064,
                    51.8753766
                ],
                [
                    102.380507,
                    51.8758378
                ],
                [
                    102.3769381,
                    51.8788096
                ]
            ],
            "longitude": 102.395447,
            "latitude": 51.879887
        },
        "5346": {
            "name": "Охор-Шибирь",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.3938029,
                    51.678679
                ],
                [
                    102.4165254,
                    51.6878608
                ],
                [
                    102.4210477,
                    51.6878205
                ],
                [
                    102.4263504,
                    51.6784985
                ],
                [
                    102.4403836,
                    51.6758625
                ],
                [
                    102.4404514,
                    51.6723281
                ],
                [
                    102.4228967,
                    51.6709652
                ],
                [
                    102.4144797,
                    51.6705302
                ],
                [
                    102.408146,
                    51.6707334
                ],
                [
                    102.4040131,
                    51.6679255
                ],
                [
                    102.4018989,
                    51.668627
                ],
                [
                    102.3938029,
                    51.678679
                ]
            ],
            "longitude": 102.4158631,
            "latitude": 51.6734181
        },
        "5347": {
            "name": "Вышка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 102.4259123,
            "latitude": 51.7133087
        },
        "5348": {
            "name": "Аршан",
            "population": 2604,
            "type": "village",
            "poly": [
                [
                    102.4107475,
                    51.9118217
                ],
                [
                    102.4166461,
                    51.9229747
                ],
                [
                    102.4294099,
                    51.9239884
                ],
                [
                    102.4428505,
                    51.9219012
                ],
                [
                    102.4501994,
                    51.9177862
                ],
                [
                    102.4586118,
                    51.9075864
                ],
                [
                    102.4569681,
                    51.8969667
                ],
                [
                    102.4452679,
                    51.8930284
                ],
                [
                    102.4279594,
                    51.896012
                ],
                [
                    102.4173229,
                    51.9046036
                ],
                [
                    102.4107475,
                    51.9118217
                ]
            ],
            "longitude": 102.4359887,
            "latitude": 51.9077929
        },
        "5349": {
            "name": "Жемчуг",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.4386214,
                    51.6878598
                ],
                [
                    102.4390498,
                    51.6979764
                ],
                [
                    102.4606316,
                    51.6977097
                ],
                [
                    102.4655945,
                    51.6948257
                ],
                [
                    102.469782,
                    51.6949219
                ],
                [
                    102.4741246,
                    51.6916532
                ],
                [
                    102.4700922,
                    51.6867498
                ],
                [
                    102.4714881,
                    51.6800187
                ],
                [
                    102.4621825,
                    51.6745369
                ],
                [
                    102.4457427,
                    51.6732866
                ],
                [
                    102.4386214,
                    51.6878598
                ]
            ],
            "longitude": 102.45755,
            "latitude": 51.691154
        },
        "5350": {
            "name": "Хурай-Хобок",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.4652386,
                    51.8575841
                ],
                [
                    102.4770017,
                    51.8709343
                ],
                [
                    102.48442,
                    51.8682514
                ],
                [
                    102.4891888,
                    51.8560132
                ],
                [
                    102.4874517,
                    51.8517443
                ],
                [
                    102.4861156,
                    51.844099
                ],
                [
                    102.4696895,
                    51.8442299
                ],
                [
                    102.4652386,
                    51.8575841
                ]
            ],
            "longitude": 102.477531,
            "latitude": 51.855469
        },
        "5351": {
            "name": "Талое",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.4673664,
                    51.820476
                ],
                [
                    102.4678624,
                    51.8226174
                ],
                [
                    102.4740956,
                    51.8232878
                ],
                [
                    102.4763133,
                    51.8254085
                ],
                [
                    102.4795456,
                    51.8266525
                ],
                [
                    102.4894104,
                    51.8189688
                ],
                [
                    102.4911766,
                    51.8181079
                ],
                [
                    102.4942072,
                    51.8133281
                ],
                [
                    102.4962828,
                    51.8100399
                ],
                [
                    102.4842265,
                    51.8124009
                ],
                [
                    102.4808816,
                    51.8187653
                ],
                [
                    102.4708352,
                    51.8198433
                ],
                [
                    102.4673664,
                    51.820476
                ]
            ],
            "longitude": 102.478821,
            "latitude": 51.821896
        },
        "5352": {
            "name": "Табалангут",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.4931799,
                    51.785145
                ],
                [
                    102.4955057,
                    51.7896596
                ],
                [
                    102.5002376,
                    51.7931817
                ],
                [
                    102.5072151,
                    51.7934297
                ],
                [
                    102.5068943,
                    51.7862365
                ],
                [
                    102.4983127,
                    51.7839047
                ],
                [
                    102.4931799,
                    51.785145
                ]
            ],
            "longitude": 102.500481,
            "latitude": 51.789162
        },
        "5353": {
            "name": "Галбай",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.5325588,
                    51.7844008
                ],
                [
                    102.5336816,
                    51.79214
                ],
                [
                    102.5404185,
                    51.8019113
                ],
                [
                    102.5424235,
                    51.7992331
                ],
                [
                    102.543787,
                    51.7935785
                ],
                [
                    102.546193,
                    51.7924376
                ],
                [
                    102.5477168,
                    51.783607
                ],
                [
                    102.5483644,
                    51.7824285
                ],
                [
                    102.5382594,
                    51.7811654
                ],
                [
                    102.5325588,
                    51.7844008
                ]
            ],
            "longitude": 102.54026,
            "latitude": 51.792042
        },
        "5354": {
            "name": "Тунка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.5170317,
                    51.7731248
                ],
                [
                    102.5258985,
                    51.7755044
                ],
                [
                    102.5414957,
                    51.7638694
                ],
                [
                    102.5475849,
                    51.7534216
                ],
                [
                    102.5585884,
                    51.7407224
                ],
                [
                    102.5655691,
                    51.7373619
                ],
                [
                    102.5686304,
                    51.7343738
                ],
                [
                    102.5659596,
                    51.7339745
                ],
                [
                    102.5456619,
                    51.7339083
                ],
                [
                    102.5355132,
                    51.7357608
                ],
                [
                    102.5324906,
                    51.7431435
                ],
                [
                    102.5316673,
                    51.7451543
                ],
                [
                    102.5319878,
                    51.751636
                ],
                [
                    102.5170317,
                    51.7731248
                ]
            ],
            "longitude": 102.540329,
            "latitude": 51.751225
        },
        "5355": {
            "name": "Зактуй",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.6214662,
                    51.6939073
                ],
                [
                    102.6359504,
                    51.6967481
                ],
                [
                    102.6495797,
                    51.7054345
                ],
                [
                    102.654032,
                    51.7046475
                ],
                [
                    102.6440439,
                    51.6879544
                ],
                [
                    102.6284105,
                    51.6837666
                ],
                [
                    102.6230715,
                    51.6896982
                ],
                [
                    102.6214662,
                    51.6939073
                ]
            ],
            "longitude": 102.639572,
            "latitude": 51.69466
        },
        "5356": {
            "name": "Утата",
            "population": 597,
            "type": "village",
            "poly": null,
            "longitude": 102.787628,
            "latitude": 50.829422
        },
        "5357": {
            "name": "Санага",
            "population": 1628,
            "type": "village",
            "poly": null,
            "longitude": 102.808083,
            "latitude": 50.73077
        },
        "5358": {
            "name": "Зун-Мурино",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.8521249,
                    51.7332307
                ],
                [
                    102.8562518,
                    51.7468069
                ],
                [
                    102.8597339,
                    51.7517572
                ],
                [
                    102.8734043,
                    51.7524757
                ],
                [
                    102.8994553,
                    51.759022
                ],
                [
                    102.9035836,
                    51.7554181
                ],
                [
                    102.9070644,
                    51.7514378
                ],
                [
                    102.8824319,
                    51.7425748
                ],
                [
                    102.866956,
                    51.7288376
                ],
                [
                    102.8555657,
                    51.7268957
                ],
                [
                    102.8521249,
                    51.7332307
                ]
            ],
            "longitude": 102.882423,
            "latitude": 51.748123
        },
        "5359": {
            "name": "Далахай",
            "population": 373,
            "type": "village",
            "poly": null,
            "longitude": 102.895653,
            "latitude": 50.899265
        },
        "5360": {
            "name": "Енгорбой",
            "population": 675,
            "type": "village",
            "poly": null,
            "longitude": 102.919342,
            "latitude": 50.509827
        },
        "5361": {
            "name": "Далахай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.0077858,
            "latitude": 51.8109178
        },
        "5362": {
            "name": "Торы",
            "population": null,
            "type": "village",
            "poly": [
                [
                    102.989631,
                    51.7884133
                ],
                [
                    103.0016114,
                    51.7920749
                ],
                [
                    103.0024571,
                    51.7961721
                ],
                [
                    103.0078835,
                    51.7978718
                ],
                [
                    103.0207801,
                    51.7966515
                ],
                [
                    103.0368479,
                    51.7963464
                ],
                [
                    103.0373412,
                    51.7912467
                ],
                [
                    103.0169745,
                    51.7841846
                ],
                [
                    103.0033028,
                    51.7827459
                ],
                [
                    102.9897718,
                    51.7823972
                ],
                [
                    102.989631,
                    51.7884133
                ]
            ],
            "longitude": 103.012886,
            "latitude": 51.789459
        },
        "5363": {
            "name": "Хонгодоры",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.044014,
            "latitude": 51.832207
        },
        "5364": {
            "name": "Шара-Азарга",
            "population": 588,
            "type": "village",
            "poly": null,
            "longitude": 103.049568,
            "latitude": 50.484043
        },
        "5365": {
            "name": "Нурта",
            "population": 240,
            "type": "village",
            "poly": null,
            "longitude": 103.131111,
            "latitude": 50.390629
        },
        "5366": {
            "name": "Шулута",
            "population": null,
            "type": "village",
            "poly": [
                [
                    103.125221,
                    51.8044173
                ],
                [
                    103.1305973,
                    51.8057469
                ],
                [
                    103.1378851,
                    51.8035307
                ],
                [
                    103.139259,
                    51.8012405
                ],
                [
                    103.1402148,
                    51.7971399
                ],
                [
                    103.142664,
                    51.7941104
                ],
                [
                    103.131553,
                    51.7958099
                ],
                [
                    103.127491,
                    51.7968074
                ],
                [
                    103.1268339,
                    51.7983959
                ],
                [
                    103.127491,
                    51.8025334
                ],
                [
                    103.125221,
                    51.8044173
                ]
            ],
            "longitude": 103.135857,
            "latitude": 51.798878
        },
        "5367": {
            "name": "Цаган-Морин",
            "population": 476,
            "type": "village",
            "poly": null,
            "longitude": 103.20594,
            "latitude": 50.733791
        },
        "5368": {
            "name": "Хужир",
            "population": 325,
            "type": "village",
            "poly": null,
            "longitude": 103.2696602,
            "latitude": 50.4241054
        },
        "5369": {
            "name": "Дархинтуй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.312462,
            "latitude": 50.586243
        },
        "5370": {
            "name": "Холтосон",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.314537,
            "latitude": 50.295387
        },
        "5371": {
            "name": "Дутулур",
            "population": 913,
            "type": "village",
            "poly": null,
            "longitude": 103.377121,
            "latitude": 50.440159
        },
        "5372": {
            "name": "Бортой",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 103.386574,
            "latitude": 50.682362
        },
        "5373": {
            "name": "Улентуй",
            "population": 333,
            "type": "village",
            "poly": null,
            "longitude": 103.424103,
            "latitude": 50.497402
        },
        "5374": {
            "name": "Мыла",
            "population": 628,
            "type": "village",
            "poly": null,
            "longitude": 103.435387,
            "latitude": 50.736561
        },
        "5375": {
            "name": "Баянгол",
            "population": 1151,
            "type": "village",
            "poly": null,
            "longitude": 103.4718804,
            "latitude": 50.6994187
        },
        "5376": {
            "name": "Ехэ-Цакир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 103.51519,
            "latitude": 50.474442
        },
        "5377": {
            "name": "Цакир",
            "population": 693,
            "type": "village",
            "poly": null,
            "longitude": 103.585991,
            "latitude": 50.442059
        },
        "5378": {
            "name": "Бургуй",
            "population": 496,
            "type": "village",
            "poly": null,
            "longitude": 103.785416,
            "latitude": 50.459564
        },
        "5379": {
            "name": "Хамней",
            "population": 744,
            "type": "village",
            "poly": null,
            "longitude": 103.868935,
            "latitude": 50.403336
        },
        "5380": {
            "name": "Хуртага",
            "population": 824,
            "type": "village",
            "poly": null,
            "longitude": 103.939133,
            "latitude": 50.446724
        },
        "5381": {
            "name": "Усть-Бургалтай",
            "population": 331,
            "type": "village",
            "poly": null,
            "longitude": 104.10231,
            "latitude": 50.416595
        },
        "5382": {
            "name": "Михайловка",
            "population": 984,
            "type": "village",
            "poly": null,
            "longitude": 104.1530024,
            "latitude": 50.4085862
        },
        "5383": {
            "name": "Улекчин",
            "population": 1097,
            "type": "village",
            "poly": null,
            "longitude": 104.2928897,
            "latitude": 50.4737275
        },
        "5384": {
            "name": "Харацай",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 104.479805,
            "latitude": 50.481766
        },
        "5385": {
            "name": "Нарын",
            "population": 368,
            "type": "village",
            "poly": null,
            "longitude": 104.560135,
            "latitude": 50.533981
        },
        "5386": {
            "name": "Армак",
            "population": 481,
            "type": "village",
            "poly": null,
            "longitude": 104.595497,
            "latitude": 50.60461
        },
        "5387": {
            "name": "Алцак",
            "population": 372,
            "type": "village",
            "poly": null,
            "longitude": 104.616661,
            "latitude": 50.670326
        },
        "5388": {
            "name": "Выдрино",
            "population": 5300,
            "type": "village",
            "poly": null,
            "longitude": 104.642586,
            "latitude": 51.463425
        },
        "5389": {
            "name": "Верхний Торей",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.814331,
            "latitude": 50.651093
        },
        "5390": {
            "name": "Улзар",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.817039,
            "latitude": 50.757633
        },
        "5391": {
            "name": "Нижний Торей",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.823601,
            "latitude": 50.531189
        },
        "5392": {
            "name": "Оёр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 104.992043,
            "latitude": 50.540775
        },
        "5393": {
            "name": "Верхний Бургалтай",
            "population": 214,
            "type": "village",
            "poly": null,
            "longitude": 105.062981,
            "latitude": 50.615269
        },
        "5394": {
            "name": "Желтура",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.09848,
            "latitude": 50.472591
        },
        "5395": {
            "name": "Танхой",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.115158,
            "latitude": 51.554321
        },
        "5396": {
            "name": "Нижний Бургалтай",
            "population": 700,
            "type": "village",
            "poly": null,
            "longitude": 105.127441,
            "latitude": 50.564514
        },
        "5397": {
            "name": "Малый Нарын",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.134415,
            "latitude": 50.660587
        },
        "5398": {
            "name": "Гэгэтуй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.220314,
            "latitude": 50.646439
        },
        "5399": {
            "name": "Переёмная",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.248184,
            "latitude": 51.580219
        },
        "5400": {
            "name": "Булык",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.264618,
            "latitude": 50.599087
        },
        "5401": {
            "name": "Цагатуй",
            "population": 702,
            "type": "village",
            "poly": null,
            "longitude": 105.305283,
            "latitude": 50.730831
        },
        "5402": {
            "name": "Дэдэ-Ичётуй",
            "population": 1082,
            "type": "village",
            "poly": null,
            "longitude": 105.431458,
            "latitude": 50.73431
        },
        "5403": {
            "name": "Додо-Ичётуй",
            "population": 364,
            "type": "village",
            "poly": null,
            "longitude": 105.457726,
            "latitude": 50.634872
        },
        "5404": {
            "name": "Тасархай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.562477,
            "latitude": 50.527126
        },
        "5405": {
            "name": "Мишиха",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.5924,
            "latitude": 51.652851
        },
        "5406": {
            "name": "Боций",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.652,
            "latitude": 50.474224
        },
        "5407": {
            "name": "Белоозёрск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.70797,
            "latitude": 50.650749
        },
        "5408": {
            "name": "Таёжный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.7172738,
            "latitude": 51.2008844
        },
        "5409": {
            "name": "Инзагатуй",
            "population": 523,
            "type": "village",
            "poly": null,
            "longitude": 105.749313,
            "latitude": 50.833057
        },
        "5410": {
            "name": "Клюевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.7630645,
            "latitude": 51.6871559
        },
        "5411": {
            "name": "Ташир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 105.8189209,
            "latitude": 50.9816995
        },
        "5412": {
            "name": "Ёнхор",
            "population": 797,
            "type": "village",
            "poly": null,
            "longitude": 105.8269197,
            "latitude": 50.5165393
        },
        "5413": {
            "name": "Боргой",
            "population": 550,
            "type": "village",
            "poly": null,
            "longitude": 105.8382808,
            "latitude": 50.7508942
        },
        "5414": {
            "name": "Цаган-Усун",
            "population": 276,
            "type": "village",
            "poly": null,
            "longitude": 106.03179989666407,
            "latitude": 50.43663787148324
        },
        "5415": {
            "name": "Боярский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.0636577,
            "latitude": 51.8421252
        },
        "5416": {
            "name": "Дырестуй",
            "population": 1095,
            "type": "village",
            "poly": null,
            "longitude": 106.070374,
            "latitude": 50.654648
        },
        "5417": {
            "name": "Хоронхой",
            "population": 1868,
            "type": "village",
            "poly": null,
            "longitude": 106.15006746009506,
            "latitude": 50.47351837953504
        },
        "5418": {
            "name": "Джида",
            "population": 3215,
            "type": "village",
            "poly": null,
            "longitude": 106.1779843,
            "latitude": 50.6850918
        },
        "5419": {
            "name": "Посольское",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.1824899,
            "latitude": 52.0195317
        },
        "5420": {
            "name": "Темник",
            "population": 598,
            "type": "village",
            "poly": null,
            "longitude": 106.1876899,
            "latitude": 51.0047803
        },
        "5421": {
            "name": "Зарубино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.191193,
            "latitude": 50.580193
        },
        "5422": {
            "name": "Селендума",
            "population": 2504,
            "type": "village",
            "poly": null,
            "longitude": 106.237724,
            "latitude": 50.918308
        },
        "5423": {
            "name": "Билютай",
            "population": 212,
            "type": "village",
            "poly": null,
            "longitude": 106.2411748,
            "latitude": 50.8784884
        },
        "5424": {
            "name": "Гусиное Озеро",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.2693474,
            "latitude": 51.1226088
        },
        "5425": {
            "name": "Усть-Кяхта",
            "population": 1925,
            "type": "village",
            "poly": null,
            "longitude": 106.27425823493292,
            "latitude": 50.517904491753214
        },
        "5426": {
            "name": "Истомино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.299133,
            "latitude": 52.132286
        },
        "5427": {
            "name": "Большая Речка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.308098,
            "latitude": 51.972809
        },
        "5428": {
            "name": "Ехэ-Цаган",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.3402723,
            "latitude": 51.0021428
        },
        "5429": {
            "name": "Посольская",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.344971,
            "latitude": 51.966225
        },
        "5430": {
            "name": "Бараты",
            "population": 515,
            "type": "village",
            "poly": null,
            "longitude": 106.370672,
            "latitude": 51.2456563
        },
        "5431": {
            "name": "Степной Дворец",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.395073,
            "latitude": 52.174042
        },
        "5432": {
            "name": "Горный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.406624,
            "latitude": 51.974152
        },
        "5433": {
            "name": "Ранжурово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.422646,
            "latitude": 52.175598
        },
        "5434": {
            "name": "Субуктуй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.423889,
            "latitude": 50.563324
        },
        "5435": {
            "name": "Нур-Тухум",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.4406535,
            "latitude": 50.8087719
        },
        "5436": {
            "name": "Шигаево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.473465,
            "latitude": 52.181915
        },
        "5437": {
            "name": "Творогово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.486511,
            "latitude": 52.170654
        },
        "5438": {
            "name": "Ягодное",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 106.5069446,
            "latitude": 51.402058
        },
        "5439": {
            "name": "Большое Колёсово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.5513902,
            "latitude": 52.1085971
        },
        "5440": {
            "name": "Красный Яр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.584106,
            "latitude": 52.174881
        },
        "5441": {
            "name": "Тохой",
            "population": 2819,
            "type": "village",
            "poly": null,
            "longitude": 106.6108694,
            "latitude": 51.3666249
        },
        "5442": {
            "name": "Тимлюй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.6149232,
            "latitude": 52.0058461
        },
        "5443": {
            "name": "Корсаково",
            "population": 585,
            "type": "village",
            "poly": null,
            "longitude": 106.623436,
            "latitude": 52.250771
        },
        "5444": {
            "name": "Новоселенгинск",
            "population": 2067,
            "type": "village",
            "poly": null,
            "longitude": 106.635719,
            "latitude": 51.091698
        },
        "5445": {
            "name": "Кудара",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.654633,
            "latitude": 52.227524
        },
        "5446": {
            "name": "Жаргаланта",
            "population": 894,
            "type": "village",
            "poly": null,
            "longitude": 106.6662628,
            "latitude": 51.4096655
        },
        "5447": {
            "name": "Елань",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.6864843,
            "latitude": 52.0011917
        },
        "5448": {
            "name": "Нюки",
            "population": 254,
            "type": "village",
            "poly": null,
            "longitude": 106.704414,
            "latitude": 52.030079
        },
        "5449": {
            "name": "Киран",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.709686,
            "latitude": 50.340645
        },
        "5450": {
            "name": "Шергино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.734932,
            "latitude": 52.115253
        },
        "5451": {
            "name": "Береговая",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.735741,
            "latitude": 52.02375
        },
        "5452": {
            "name": "Большой Луг",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.777397,
            "latitude": 50.611816
        },
        "5453": {
            "name": "Усть-Киран",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.81411,
            "latitude": 50.418205
        },
        "5454": {
            "name": "Оймур",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.837959,
            "latitude": 52.327579
        },
        "5455": {
            "name": "Харгана",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.846489,
            "latitude": 51.503948
        },
        "5456": {
            "name": "Брянск",
            "population": 1075,
            "type": "village",
            "poly": null,
            "longitude": 106.8535062,
            "latitude": 52.0298571
        },
        "5457": {
            "name": "Дэдэ-Сутой",
            "population": 334,
            "type": "village",
            "poly": null,
            "longitude": 106.8557738,
            "latitude": 51.2649773
        },
        "5458": {
            "name": "Дурены",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.88298,
            "latitude": 50.317299
        },
        "5459": {
            "name": "Нижний Убукун",
            "population": null,
            "type": "village",
            "poly": [
                [
                    106.8889881,
                    51.5168875
                ],
                [
                    106.9121624,
                    51.5231896
                ],
                [
                    106.913364,
                    51.5220147
                ],
                [
                    106.8903614,
                    51.5149647
                ],
                [
                    106.8889881,
                    51.5168875
                ]
            ],
            "longitude": 106.89843,
            "latitude": 51.518169
        },
        "5460": {
            "name": "Тресково",
            "population": 1380,
            "type": "village",
            "poly": null,
            "longitude": 106.8989549,
            "latitude": 52.0589343
        },
        "5461": {
            "name": "Подгорное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.916374,
            "latitude": 50.548458
        },
        "5462": {
            "name": "Чикой",
            "population": 706,
            "type": "village",
            "poly": null,
            "longitude": 106.9166254,
            "latitude": 50.2702533
        },
        "5463": {
            "name": "Средний Харлун",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.918648,
            "latitude": 50.63747
        },
        "5464": {
            "name": "Мурочи",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.932709,
            "latitude": 50.359058
        },
        "5465": {
            "name": "Хурамша",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.993614,
            "latitude": 51.632217
        },
        "5466": {
            "name": "Харитоново",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.997392,
            "latitude": 51.2238722
        },
        "5467": {
            "name": "Кокорино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 106.998001,
            "latitude": 51.613701
        },
        "5468": {
            "name": "Зурган-Дэбэ",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.0191072,
            "latitude": 51.0726835
        },
        "5469": {
            "name": "Мостовка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.029778,
            "latitude": 52.092648
        },
        "5470": {
            "name": "Большая Кудара",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.048866,
            "latitude": 50.201969
        },
        "5471": {
            "name": "Оронгой",
            "population": 1061,
            "type": "village",
            "poly": null,
            "longitude": 107.0489826,
            "latitude": 51.5295656
        },
        "5472": {
            "name": "Оронгой",
            "population": 1760,
            "type": "village",
            "poly": null,
            "longitude": 107.066025,
            "latitude": 51.519352
        },
        "5473": {
            "name": "Усть-Алташа",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.0668291,
            "latitude": 51.0354026
        },
        "5474": {
            "name": "Таловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.074493,
            "latitude": 52.112545
        },
        "5475": {
            "name": "Октябрьский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.074997,
            "latitude": 50.219467
        },
        "5476": {
            "name": "Подлопатки",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.093254,
            "latitude": 50.916386
        },
        "5477": {
            "name": "Топка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.100426,
            "latitude": 50.459927
        },
        "5478": {
            "name": "Билютай",
            "population": 448,
            "type": "village",
            "poly": null,
            "longitude": 107.10125,
            "latitude": 50.777397
        },
        "5479": {
            "name": "Окино-Ключи",
            "population": 1205,
            "type": "village",
            "poly": null,
            "longitude": 107.103737,
            "latitude": 50.598442
        },
        "5480": {
            "name": "Сухая",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.10936,
            "latitude": 52.543064
        },
        "5481": {
            "name": "Калёново",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.114639,
            "latitude": 51.757214
        },
        "5482": {
            "name": "Холой",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.117599,
            "latitude": 50.221127
        },
        "5483": {
            "name": "Таловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.1384982,
            "latitude": 52.116731
        },
        "5484": {
            "name": "Балта",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.14219,
                    51.0758663
                ],
                [
                    107.1479837,
                    51.0787783
                ],
                [
                    107.1509878,
                    51.0771606
                ],
                [
                    107.1580259,
                    51.0774032
                ],
                [
                    107.1585838,
                    51.0787783
                ],
                [
                    107.162017,
                    51.0787783
                ],
                [
                    107.1634332,
                    51.0766483
                ],
                [
                    107.1582405,
                    51.0762438
                ],
                [
                    107.1586696,
                    51.0743024
                ],
                [
                    107.1450226,
                    51.0709857
                ],
                [
                    107.1426622,
                    51.0736283
                ],
                [
                    107.1439496,
                    51.0744642
                ],
                [
                    107.14219,
                    51.0758663
                ]
            ],
            "longitude": 107.1483292,
            "latitude": 51.0745494
        },
        "5485": {
            "name": "Унгуркуй",
            "population": 444,
            "type": "village",
            "poly": null,
            "longitude": 107.151711,
            "latitude": 50.302639
        },
        "5486": {
            "name": "Заречье",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.151871,
            "latitude": 52.549824
        },
        "5487": {
            "name": "Энхэ-Тала",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.157898,
            "latitude": 50.218628
        },
        "5488": {
            "name": "Ключи",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.1685529,
                    51.6836342
                ],
                [
                    107.1694598,
                    51.6849501
                ],
                [
                    107.1712285,
                    51.6868886
                ],
                [
                    107.1729813,
                    51.6877403
                ],
                [
                    107.1755663,
                    51.6885442
                ],
                [
                    107.1758789,
                    51.6883435
                ],
                [
                    107.178101,
                    51.689098
                ],
                [
                    107.1777505,
                    51.6894672
                ],
                [
                    107.1808915,
                    51.6907835
                ],
                [
                    107.1829759,
                    51.6911995
                ],
                [
                    107.1853998,
                    51.6916694
                ],
                [
                    107.1857157,
                    51.6911506
                ],
                [
                    107.1738157,
                    51.6868522
                ],
                [
                    107.1707759,
                    51.6837976
                ],
                [
                    107.1691893,
                    51.6829072
                ],
                [
                    107.1687649,
                    51.6831738
                ],
                [
                    107.1690889,
                    51.6833573
                ],
                [
                    107.1685529,
                    51.6836342
                ]
            ],
            "longitude": 107.175659,
            "latitude": 51.687954
        },
        "5489": {
            "name": "Барыкино",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.1822715,
                    51.2246263
                ],
                [
                    107.1823573,
                    51.226615
                ],
                [
                    107.1851039,
                    51.229195
                ],
                [
                    107.1880221,
                    51.2319361
                ],
                [
                    107.1911978,
                    51.2364504
                ],
                [
                    107.1932578,
                    51.2411255
                ],
                [
                    107.1938586,
                    51.2446718
                ],
                [
                    107.193172,
                    51.2469284
                ],
                [
                    107.1942019,
                    51.248164
                ],
                [
                    107.2005534,
                    51.2467672
                ],
                [
                    107.2026133,
                    51.2455852
                ],
                [
                    107.1990943,
                    51.2396209
                ],
                [
                    107.1966051,
                    51.2326885
                ],
                [
                    107.1937728,
                    51.2250563
                ],
                [
                    107.192142,
                    51.2249488
                ],
                [
                    107.1822715,
                    51.2246263
                ]
            ],
            "longitude": 107.1955151,
            "latitude": 51.2373824
        },
        "5490": {
            "name": "Верхняя Иволга",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.1843276,
                    51.7524444
                ],
                [
                    107.1926098,
                    51.7612847
                ],
                [
                    107.2065003,
                    51.7605178
                ],
                [
                    107.2030439,
                    51.7478015
                ],
                [
                    107.2033048,
                    51.7448135
                ],
                [
                    107.1905229,
                    51.7420274
                ],
                [
                    107.1891534,
                    51.7464286
                ],
                [
                    107.1843276,
                    51.7524444
                ]
            ],
            "longitude": 107.1989046,
            "latitude": 51.7550808
        },
        "5491": {
            "name": "Нижний Жирим",
            "population": 442,
            "type": "village",
            "poly": [
                [
                    107.1793554,
                    51.4326624
                ],
                [
                    107.181544,
                    51.4344269
                ],
                [
                    107.1877239,
                    51.4314048
                ],
                [
                    107.194762,
                    51.4283547
                ],
                [
                    107.2014997,
                    51.4264281
                ],
                [
                    107.2027871,
                    51.4273379
                ],
                [
                    107.1993539,
                    51.4306825
                ],
                [
                    107.1950195,
                    51.4319935
                ],
                [
                    107.1919296,
                    51.4325822
                ],
                [
                    107.1893117,
                    51.4339185
                ],
                [
                    107.1928308,
                    51.4367009
                ],
                [
                    107.194247,
                    51.4368614
                ],
                [
                    107.1978519,
                    51.4348817
                ],
                [
                    107.200813,
                    51.4337313
                ],
                [
                    107.2024867,
                    51.4327427
                ],
                [
                    107.2041604,
                    51.4324751
                ],
                [
                    107.20386,
                    51.4315118
                ],
                [
                    107.2058341,
                    51.4300671
                ],
                [
                    107.208924,
                    51.4275519
                ],
                [
                    107.2111556,
                    51.4266422
                ],
                [
                    107.212486,
                    51.4254113
                ],
                [
                    107.2137735,
                    51.4253578
                ],
                [
                    107.2145459,
                    51.4244212
                ],
                [
                    107.2159192,
                    51.424314
                ],
                [
                    107.2176788,
                    51.4212367
                ],
                [
                    107.2142025,
                    51.4204338
                ],
                [
                    107.2127435,
                    51.4191224
                ],
                [
                    107.2136447,
                    51.4176505
                ],
                [
                    107.2127006,
                    51.4156967
                ],
                [
                    107.2116276,
                    51.4148937
                ],
                [
                    107.2106406,
                    51.4149205
                ],
                [
                    107.2086665,
                    51.4173561
                ],
                [
                    107.2076366,
                    51.4175969
                ],
                [
                    107.2067354,
                    51.4171955
                ],
                [
                    107.2051904,
                    51.417704
                ],
                [
                    107.2031305,
                    51.4174631
                ],
                [
                    107.2004268,
                    51.417811
                ],
                [
                    107.1989677,
                    51.4198183
                ],
                [
                    107.1961782,
                    51.4217184
                ],
                [
                    107.1940753,
                    51.4228691
                ],
                [
                    107.1945044,
                    51.424207
                ],
                [
                    107.1924444,
                    51.4250099
                ],
                [
                    107.1907279,
                    51.4254648
                ],
                [
                    107.1890113,
                    51.4253578
                ],
                [
                    107.1869514,
                    51.4260535
                ],
                [
                    107.185621,
                    51.4266689
                ],
                [
                    107.1846339,
                    51.4278463
                ],
                [
                    107.1834752,
                    51.4293714
                ],
                [
                    107.1814153,
                    51.4308162
                ],
                [
                    107.1805999,
                    51.4315655
                ],
                [
                    107.1793554,
                    51.4326624
                ]
            ],
            "longitude": 107.20505,
            "latitude": 51.4247011
        },
        "5492": {
            "name": "Верхний Жирим",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.197809,
                    51.3188394
                ],
                [
                    107.1988389,
                    51.3190808
                ],
                [
                    107.2031305,
                    51.3185176
                ],
                [
                    107.2070787,
                    51.3176593
                ],
                [
                    107.2095248,
                    51.3228088
                ],
                [
                    107.2130439,
                    51.3281187
                ],
                [
                    107.2195241,
                    51.32954
                ],
                [
                    107.2234294,
                    51.3299422
                ],
                [
                    107.226691,
                    51.3254102
                ],
                [
                    107.2300384,
                    51.320261
                ],
                [
                    107.2237298,
                    51.3169351
                ],
                [
                    107.2188375,
                    51.3146551
                ],
                [
                    107.2188804,
                    51.3128579
                ],
                [
                    107.2217557,
                    51.3102826
                ],
                [
                    107.2236439,
                    51.3082437
                ],
                [
                    107.2240731,
                    51.3065804
                ],
                [
                    107.2220132,
                    51.3058828
                ],
                [
                    107.2252319,
                    51.3001947
                ],
                [
                    107.2243736,
                    51.2993361
                ],
                [
                    107.2222707,
                    51.2985311
                ],
                [
                    107.2207686,
                    51.2982627
                ],
                [
                    107.211456,
                    51.3038973
                ],
                [
                    107.2067783,
                    51.3157549
                ],
                [
                    107.1989248,
                    51.3164523
                ],
                [
                    107.197809,
                    51.3188394
                ]
            ],
            "longitude": 107.216187,
            "latitude": 51.31813
        },
        "5493": {
            "name": "Ивановка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.236664,
            "latitude": 50.183418
        },
        "5494": {
            "name": "Ганзурино",
            "population": 429,
            "type": "village",
            "poly": null,
            "longitude": 107.242538,
            "latitude": 51.518803
        },
        "5495": {
            "name": "Цолга",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.2301666,
                    51.079695
                ],
                [
                    107.2310249,
                    51.0808273
                ],
                [
                    107.2331707,
                    51.0835502
                ],
                [
                    107.2386638,
                    51.0842512
                ],
                [
                    107.2562162,
                    51.0830919
                ],
                [
                    107.2553579,
                    51.0797219
                ],
                [
                    107.2529547,
                    51.0779964
                ],
                [
                    107.2576753,
                    51.0778346
                ],
                [
                    107.2581903,
                    51.0740328
                ],
                [
                    107.2519247,
                    51.0742755
                ],
                [
                    107.2518818,
                    51.0715519
                ],
                [
                    107.2493927,
                    51.071525
                ],
                [
                    107.2388784,
                    51.0760551
                ],
                [
                    107.2301666,
                    51.079695
                ]
            ],
            "longitude": 107.244598,
            "latitude": 51.080124
        },
        "5496": {
            "name": "Верхний Мангиртуй",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.2388502,
                    50.6742576
                ],
                [
                    107.2426101,
                    50.6761688
                ],
                [
                    107.2522449,
                    50.6783032
                ],
                [
                    107.2551432,
                    50.6777572
                ],
                [
                    107.2547907,
                    50.6739101
                ],
                [
                    107.2599605,
                    50.672818
                ],
                [
                    107.261958,
                    50.6682011
                ],
                [
                    107.256279,
                    50.6668854
                ],
                [
                    107.2479367,
                    50.6670592
                ],
                [
                    107.2453126,
                    50.66835
                ],
                [
                    107.2421402,
                    50.6684245
                ],
                [
                    107.240926,
                    50.6697153
                ],
                [
                    107.2388502,
                    50.6742576
                ]
            ],
            "longitude": 107.251854,
            "latitude": 50.670444
        },
        "5497": {
            "name": "Убур-Киреть",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.258438,
            "latitude": 50.288216
        },
        "5498": {
            "name": "Барыкино-Ключи",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.2508094,
                    51.2561148
                ],
                [
                    107.2508523,
                    51.2580485
                ],
                [
                    107.2521827,
                    51.2602776
                ],
                [
                    107.253556,
                    51.2595256
                ],
                [
                    107.2563455,
                    51.2594988
                ],
                [
                    107.2624395,
                    51.2612981
                ],
                [
                    107.268748,
                    51.2602507
                ],
                [
                    107.2694776,
                    51.2640641
                ],
                [
                    107.2720525,
                    51.2647086
                ],
                [
                    107.2735545,
                    51.2636076
                ],
                [
                    107.2741554,
                    51.2617278
                ],
                [
                    107.2737691,
                    51.2599822
                ],
                [
                    107.2729537,
                    51.2567594
                ],
                [
                    107.2720096,
                    51.2540198
                ],
                [
                    107.269778,
                    51.2535095
                ],
                [
                    107.2669027,
                    51.25359
                ],
                [
                    107.2665164,
                    51.2551479
                ],
                [
                    107.2670743,
                    51.2580217
                ],
                [
                    107.2645852,
                    51.2590959
                ],
                [
                    107.2609803,
                    51.258344
                ],
                [
                    107.2578903,
                    51.2563565
                ],
                [
                    107.2533842,
                    51.2558999
                ],
                [
                    107.2508094,
                    51.2561148
                ]
            ],
            "longitude": 107.2672961,
            "latitude": 51.2595249
        },
        "5499": {
            "name": "Ильинка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.2212923,
                    52.1222491
                ],
                [
                    107.2236609,
                    52.1263266
                ],
                [
                    107.2312775,
                    52.1280658
                ],
                [
                    107.2358753,
                    52.1268398
                ],
                [
                    107.2459999,
                    52.1282083
                ],
                [
                    107.2544542,
                    52.1262384
                ],
                [
                    107.2650893,
                    52.1249869
                ],
                [
                    107.2721323,
                    52.1243882
                ],
                [
                    107.2741151,
                    52.1246003
                ],
                [
                    107.2993386,
                    52.1238769
                ],
                [
                    107.3052981,
                    52.1244495
                ],
                [
                    107.3065895,
                    52.1224277
                ],
                [
                    107.2982041,
                    52.1181214
                ],
                [
                    107.293775,
                    52.1169248
                ],
                [
                    107.2778301,
                    52.1152929
                ],
                [
                    107.2524955,
                    52.1140962
                ],
                [
                    107.2526412,
                    52.1171732
                ],
                [
                    107.2545453,
                    52.1206808
                ],
                [
                    107.2350857,
                    52.1197968
                ],
                [
                    107.2306737,
                    52.1190839
                ],
                [
                    107.2251935,
                    52.1190268
                ],
                [
                    107.2224533,
                    52.1205097
                ],
                [
                    107.2212923,
                    52.1222491
                ]
            ],
            "longitude": 107.272003,
            "latitude": 52.119793
        },
        "5500": {
            "name": "Красноярово",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.2694448,
                    51.7861103
                ],
                [
                    107.2704638,
                    51.7937366
                ],
                [
                    107.2718903,
                    51.7958793
                ],
                [
                    107.2749472,
                    51.7954382
                ],
                [
                    107.2755586,
                    51.7960684
                ],
                [
                    107.2895184,
                    51.7960053
                ],
                [
                    107.290843,
                    51.79506
                ],
                [
                    107.2933904,
                    51.79506
                ],
                [
                    107.2962435,
                    51.7959423
                ],
                [
                    107.308573,
                    51.7958793
                ],
                [
                    107.3079616,
                    51.7877491
                ],
                [
                    107.282997,
                    51.7843454
                ],
                [
                    107.2694448,
                    51.7861103
                ]
            ],
            "longitude": 107.285545,
            "latitude": 51.790604
        },
        "5501": {
            "name": "Покровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.291466,
            "latitude": 52.15263
        },
        "5502": {
            "name": "Хандагатай",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.3011491,
                    51.2676623
                ],
                [
                    107.3020503,
                    51.2678234
                ],
                [
                    107.3074577,
                    51.2686827
                ],
                [
                    107.3073289,
                    51.2694882
                ],
                [
                    107.3105476,
                    51.271126
                ],
                [
                    107.3091314,
                    51.2731397
                ],
                [
                    107.3122213,
                    51.274321
                ],
                [
                    107.3164699,
                    51.2753949
                ],
                [
                    107.3181436,
                    51.2760661
                ],
                [
                    107.3220489,
                    51.27765
                ],
                [
                    107.3255679,
                    51.2790191
                ],
                [
                    107.3274562,
                    51.2782137
                ],
                [
                    107.3291728,
                    51.2767909
                ],
                [
                    107.3284433,
                    51.2757439
                ],
                [
                    107.3263833,
                    51.2745358
                ],
                [
                    107.3238513,
                    51.2731128
                ],
                [
                    107.3166844,
                    51.2706964
                ],
                [
                    107.3150108,
                    51.2694345
                ],
                [
                    107.3135087,
                    51.2676355
                ],
                [
                    107.3105905,
                    51.2663734
                ],
                [
                    107.3066422,
                    51.2660244
                ],
                [
                    107.3014495,
                    51.2672327
                ],
                [
                    107.3011491,
                    51.2676623
                ]
            ],
            "longitude": 107.318031,
            "latitude": 51.274067
        },
        "5503": {
            "name": "Хутор",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.321449,
            "latitude": 50.022892
        },
        "5504": {
            "name": "Шазагай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.334991,
            "latitude": 50.268673
        },
        "5505": {
            "name": "Шарагол",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.344147,
            "latitude": 50.019894
        },
        "5506": {
            "name": "Елань",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.346626,
            "latitude": 50.539051
        },
        "5507": {
            "name": "Шалута",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.355385,
            "latitude": 51.611179
        },
        "5508": {
            "name": "Колобки",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.363037,
                    51.6493761
                ],
                [
                    107.3644883,
                    51.6523587
                ],
                [
                    107.3678896,
                    51.6524713
                ],
                [
                    107.3704293,
                    51.651599
                ],
                [
                    107.374148,
                    51.6535405
                ],
                [
                    107.3766877,
                    51.6582672
                ],
                [
                    107.3789511,
                    51.6581255
                ],
                [
                    107.3755958,
                    51.6535663
                ],
                [
                    107.3749573,
                    51.6519312
                ],
                [
                    107.375503,
                    51.6496765
                ],
                [
                    107.3754913,
                    51.6474073
                ],
                [
                    107.3747831,
                    51.6461754
                ],
                [
                    107.3735293,
                    51.6463411
                ],
                [
                    107.3690424,
                    51.6454361
                ],
                [
                    107.363037,
                    51.6493761
                ]
            ],
            "longitude": 107.371475,
            "latitude": 51.649315
        },
        "5509": {
            "name": "Солонцы",
            "population": 642,
            "type": "village",
            "poly": null,
            "longitude": 107.3922194,
            "latitude": 51.6181698
        },
        "5510": {
            "name": "Кудара-Сомон",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.396545,
            "latitude": 50.160885
        },
        "5511": {
            "name": "Тамир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.407196,
            "latitude": 50.260761
        },
        "5512": {
            "name": "Гурульба",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.3954003,
                    51.8236063
                ],
                [
                    107.3970289,
                    51.8283732
                ],
                [
                    107.3988419,
                    51.8345068
                ],
                [
                    107.4075994,
                    51.8350384
                ],
                [
                    107.4118399,
                    51.8334813
                ],
                [
                    107.4177704,
                    51.8337093
                ],
                [
                    107.4253603,
                    51.8258094
                ],
                [
                    107.424377,
                    51.8224477
                ],
                [
                    107.4220724,
                    51.8209852
                ],
                [
                    107.4265587,
                    51.8157427
                ],
                [
                    107.4189688,
                    51.8123043
                ],
                [
                    107.4020376,
                    51.8115824
                ],
                [
                    107.4005319,
                    51.8164076
                ],
                [
                    107.3969675,
                    51.8174713
                ],
                [
                    107.3954003,
                    51.8236063
                ]
            ],
            "longitude": 107.412086,
            "latitude": 51.82708
        },
        "5513": {
            "name": "Нижняя Иволга",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.3690276,
                    51.7783846
                ],
                [
                    107.3783664,
                    51.7788563
                ],
                [
                    107.3837029,
                    51.7759083
                ],
                [
                    107.4112428,
                    51.7750828
                ],
                [
                    107.4152452,
                    51.7783256
                ],
                [
                    107.4195334,
                    51.7786794
                ],
                [
                    107.4212487,
                    51.774611
                ],
                [
                    107.4281099,
                    51.7740803
                ],
                [
                    107.4361155,
                    51.7731992
                ],
                [
                    107.4450841,
                    51.7732349
                ],
                [
                    107.4468126,
                    51.7762058
                ],
                [
                    107.4557721,
                    51.7760629
                ],
                [
                    107.4568495,
                    51.7779102
                ],
                [
                    107.4618505,
                    51.7794049
                ],
                [
                    107.4669047,
                    51.7822764
                ],
                [
                    107.4701496,
                    51.7819601
                ],
                [
                    107.4655866,
                    51.776795
                ],
                [
                    107.4589903,
                    51.7669306
                ],
                [
                    107.4539942,
                    51.7659644
                ],
                [
                    107.443651,
                    51.7670167
                ],
                [
                    107.4258119,
                    51.7684321
                ],
                [
                    107.4117433,
                    51.768987
                ],
                [
                    107.4008549,
                    51.7678512
                ],
                [
                    107.4006075,
                    51.7721566
                ],
                [
                    107.3823685,
                    51.7739726
                ],
                [
                    107.374928,
                    51.77001
                ],
                [
                    107.369561,
                    51.7725763
                ],
                [
                    107.3690276,
                    51.7783846
                ]
            ],
            "longitude": 107.419205,
            "latitude": 51.772587
        },
        "5514": {
            "name": "Судутуй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.419655,
            "latitude": 50.681767
        },
        "5515": {
            "name": "Хойтобэе",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.434479,
            "latitude": 51.789959
        },
        "5516": {
            "name": "Татаурово",
            "population": 1810,
            "type": "village",
            "poly": [
                [
                    107.4223133,
                    52.1400511
                ],
                [
                    107.4267346,
                    52.1425821
                ],
                [
                    107.4324935,
                    52.1425365
                ],
                [
                    107.4344627,
                    52.1450674
                ],
                [
                    107.4315647,
                    52.146139
                ],
                [
                    107.4308216,
                    52.1471878
                ],
                [
                    107.4337351,
                    52.1472203
                ],
                [
                    107.436151,
                    52.1459829
                ],
                [
                    107.437825,
                    52.1466366
                ],
                [
                    107.4426977,
                    52.1438027
                ],
                [
                    107.4460336,
                    52.144378
                ],
                [
                    107.4487894,
                    52.1430494
                ],
                [
                    107.4488192,
                    52.1421556
                ],
                [
                    107.4514348,
                    52.1407692
                ],
                [
                    107.4523265,
                    52.1394011
                ],
                [
                    107.4556853,
                    52.1372849
                ],
                [
                    107.4543477,
                    52.1350956
                ],
                [
                    107.4528913,
                    52.1351686
                ],
                [
                    107.4502746,
                    52.133529
                ],
                [
                    107.4493229,
                    52.1335865
                ],
                [
                    107.441904,
                    52.1373083
                ],
                [
                    107.4261773,
                    52.1400739
                ],
                [
                    107.4223133,
                    52.1400511
                ]
            ],
            "longitude": 107.439743,
            "latitude": 52.142399
        },
        "5517": {
            "name": "Ара-Алцагат",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.440125,
            "latitude": 50.129166
        },
        "5518": {
            "name": "Дунда-Киреть",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.453964,
            "latitude": 50.58305
        },
        "5519": {
            "name": "Десятниково",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.4488748,
                    51.4191281
                ],
                [
                    107.4515497,
                    51.4216466
                ],
                [
                    107.4568471,
                    51.421385
                ],
                [
                    107.4663406,
                    51.420371
                ],
                [
                    107.464295,
                    51.4186702
                ],
                [
                    107.4629902,
                    51.4170053
                ],
                [
                    107.461148,
                    51.415301
                ],
                [
                    107.4529134,
                    51.4169693
                ],
                [
                    107.4488748,
                    51.4191281
                ]
            ],
            "longitude": 107.457198,
            "latitude": 51.4187896
        },
        "5520": {
            "name": "Нур-Селение",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.457397,
            "latitude": 51.773335
        },
        "5521": {
            "name": "Пестерево",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.459862,
            "latitude": 51.500313
        },
        "5522": {
            "name": "Покровка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.46434,
            "latitude": 50.708485
        },
        "5523": {
            "name": "Сужа",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.469131,
            "latitude": 51.775017
        },
        "5524": {
            "name": "Вознесеновка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.471817,
            "latitude": 51.711491
        },
        "5525": {
            "name": "Ошурково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.475189,
            "latitude": 51.960983
        },
        "5526": {
            "name": "Еловка",
            "population": 320,
            "type": "village",
            "poly": null,
            "longitude": 107.478363,
            "latitude": 52.063599
        },
        "5527": {
            "name": "Сотниково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.478722,
            "latitude": 51.877777
        },
        "5528": {
            "name": "Кома",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.4714262,
                    52.1590773
                ],
                [
                    107.484242,
                    52.1641074
                ],
                [
                    107.4869029,
                    52.1638408
                ],
                [
                    107.4880976,
                    52.1621754
                ],
                [
                    107.4740871,
                    52.1557124
                ],
                [
                    107.4721322,
                    52.1575447
                ],
                [
                    107.4714262,
                    52.1590773
                ]
            ],
            "longitude": 107.479446,
            "latitude": 52.160664
        },
        "5529": {
            "name": "Старое Татаурово",
            "population": 992,
            "type": "village",
            "poly": [
                [
                    107.4596767,
                    52.0929085
                ],
                [
                    107.4596767,
                    52.0955758
                ],
                [
                    107.4714701,
                    52.0948194
                ],
                [
                    107.4736733,
                    52.0925502
                ],
                [
                    107.4747749,
                    52.0926298
                ],
                [
                    107.4703038,
                    52.0992779
                ],
                [
                    107.4697854,
                    52.1036563
                ],
                [
                    107.4762005,
                    52.1118945
                ],
                [
                    107.4787924,
                    52.1124914
                ],
                [
                    107.477176,
                    52.1053017
                ],
                [
                    107.4814227,
                    52.1012586
                ],
                [
                    107.4852447,
                    52.0971661
                ],
                [
                    107.4860675,
                    52.0918015
                ],
                [
                    107.4855589,
                    52.0834412
                ],
                [
                    107.4816436,
                    52.0841492
                ],
                [
                    107.4784036,
                    52.0874142
                ],
                [
                    107.4725717,
                    52.08833
                ],
                [
                    107.4711461,
                    52.0927095
                ],
                [
                    107.4688134,
                    52.0928289
                ],
                [
                    107.4671934,
                    52.0916744
                ],
                [
                    107.4641479,
                    52.0917142
                ],
                [
                    107.4596767,
                    52.0929085
                ]
            ],
            "longitude": 107.47963,
            "latitude": 52.094852
        },
        "5530": {
            "name": "Итанца",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.4887703,
                    52.1644157
                ],
                [
                    107.4976903,
                    52.1653615
                ],
                [
                    107.5067614,
                    52.1690582
                ],
                [
                    107.5043413,
                    52.1728125
                ],
                [
                    107.5057471,
                    52.1734345
                ],
                [
                    107.5113883,
                    52.1691535
                ],
                [
                    107.5126781,
                    52.1691973
                ],
                [
                    107.5155628,
                    52.1673427
                ],
                [
                    107.5152847,
                    52.165211
                ],
                [
                    107.5131647,
                    52.1643156
                ],
                [
                    107.5138598,
                    52.1610964
                ],
                [
                    107.5111837,
                    52.1605489
                ],
                [
                    107.5094487,
                    52.1642874
                ],
                [
                    107.507002,
                    52.1664977
                ],
                [
                    107.5008407,
                    52.1643011
                ],
                [
                    107.500273,
                    52.1618593
                ],
                [
                    107.5057796,
                    52.1597408
                ],
                [
                    107.5046935,
                    52.1586414
                ],
                [
                    107.5004035,
                    52.1583749
                ],
                [
                    107.4986114,
                    52.1571422
                ],
                [
                    107.4985571,
                    52.1553099
                ],
                [
                    107.499969,
                    52.1547435
                ],
                [
                    107.4995346,
                    52.152811
                ],
                [
                    107.4959505,
                    52.1516449
                ],
                [
                    107.4966022,
                    52.1496123
                ],
                [
                    107.4975253,
                    52.1482128
                ],
                [
                    107.5017068,
                    52.1492791
                ],
                [
                    107.5033359,
                    52.148646
                ],
                [
                    107.5045849,
                    52.1468466
                ],
                [
                    107.4945929,
                    52.1436474
                ],
                [
                    107.4931479,
                    52.1439834
                ],
                [
                    107.4916274,
                    52.1459496
                ],
                [
                    107.4937996,
                    52.1479156
                ],
                [
                    107.4891614,
                    52.1530558
                ],
                [
                    107.4917772,
                    52.1542021
                ],
                [
                    107.4904429,
                    52.159329
                ],
                [
                    107.4927206,
                    52.1602459
                ],
                [
                    107.4959058,
                    52.1599512
                ],
                [
                    107.4973472,
                    52.1606717
                ],
                [
                    107.4893397,
                    52.1627347
                ],
                [
                    107.4887703,
                    52.1644157
                ]
            ],
            "longitude": 107.508362,
            "latitude": 52.167706
        },
        "5531": {
            "name": "Нижний Саянтуй",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.4922512,
                    51.7280162
                ],
                [
                    107.4932178,
                    51.7296222
                ],
                [
                    107.4955959,
                    51.7308481
                ],
                [
                    107.4979587,
                    51.7321879
                ],
                [
                    107.4980047,
                    51.7336703
                ],
                [
                    107.4995851,
                    51.7342879
                ],
                [
                    107.4989186,
                    51.735543
                ],
                [
                    107.4965433,
                    51.736979
                ],
                [
                    107.4977189,
                    51.7382985
                ],
                [
                    107.4990753,
                    51.7384218
                ],
                [
                    107.5056395,
                    51.7392239
                ],
                [
                    107.5096072,
                    51.7392836
                ],
                [
                    107.5124385,
                    51.7405239
                ],
                [
                    107.5136711,
                    51.7419551
                ],
                [
                    107.513629,
                    51.7424838
                ],
                [
                    107.5172627,
                    51.7448498
                ],
                [
                    107.521873,
                    51.7427372
                ],
                [
                    107.524459,
                    51.744948
                ],
                [
                    107.522589,
                    51.7461427
                ],
                [
                    107.5280432,
                    51.7482986
                ],
                [
                    107.5269264,
                    51.7495452
                ],
                [
                    107.5293938,
                    51.7502205
                ],
                [
                    107.5339909,
                    51.7497011
                ],
                [
                    107.5371336,
                    51.7511555
                ],
                [
                    107.5426138,
                    51.7510776
                ],
                [
                    107.5444059,
                    51.7528957
                ],
                [
                    107.5446656,
                    51.7548696
                ],
                [
                    107.5388997,
                    51.7577266
                ],
                [
                    107.5402243,
                    51.7590251
                ],
                [
                    107.5426138,
                    51.7581681
                ],
                [
                    107.5445877,
                    51.7595186
                ],
                [
                    107.5544273,
                    51.7555216
                ],
                [
                    107.5497927,
                    51.7521001
                ],
                [
                    107.5469791,
                    51.7501352
                ],
                [
                    107.5458228,
                    51.7495631
                ],
                [
                    107.5440286,
                    51.7490774
                ],
                [
                    107.5393153,
                    51.7483245
                ],
                [
                    107.5373154,
                    51.7481947
                ],
                [
                    107.5349,
                    51.747779
                ],
                [
                    107.5325105,
                    51.7466102
                ],
                [
                    107.5261583,
                    51.7390695
                ],
                [
                    107.5260272,
                    51.7382402
                ],
                [
                    107.5244942,
                    51.7367902
                ],
                [
                    107.5231235,
                    51.7376835
                ],
                [
                    107.5197783,
                    51.7352656
                ],
                [
                    107.5170701,
                    51.7347883
                ],
                [
                    107.512558,
                    51.7347786
                ],
                [
                    107.5126807,
                    51.7325432
                ],
                [
                    107.5078675,
                    51.7306163
                ],
                [
                    107.5018155,
                    51.7305275
                ],
                [
                    107.497968,
                    51.7253661
                ],
                [
                    107.4922512,
                    51.7280162
                ]
            ],
            "longitude": 107.519447,
            "latitude": 51.74041
        },
        "5532": {
            "name": "Сахарный Завод",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.5196487,
            "latitude": 50.6282153
        },
        "5533": {
            "name": "Петропавловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.530609,
            "latitude": 50.691586
        },
        "5534": {
            "name": "Поселье",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.5409769,
            "latitude": 51.8120495
        },
        "5535": {
            "name": "Верхний Саянтуй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.543956,
            "latitude": 51.6370309
        },
        "5536": {
            "name": "Бар",
            "population": 424,
            "type": "village",
            "poly": null,
            "longitude": 107.559753,
            "latitude": 51.299713
        },
        "5537": {
            "name": "Дунгуй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.569557,
            "latitude": 50.146259
        },
        "5538": {
            "name": "Хошун-Узур",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.5795817,
                    51.2516369
                ],
                [
                    107.5861151,
                    51.2521862
                ],
                [
                    107.5926485,
                    51.2518506
                ],
                [
                    107.5910395,
                    51.2453806
                ],
                [
                    107.5922584,
                    51.239978
                ],
                [
                    107.5845061,
                    51.2398254
                ],
                [
                    107.5795817,
                    51.2516369
                ]
            ],
            "longitude": 107.58638,
            "latitude": 51.245445
        },
        "5539": {
            "name": "Большой Куналей",
            "population": 1035,
            "type": "village",
            "poly": null,
            "longitude": 107.6114178,
            "latitude": 51.4315795
        },
        "5540": {
            "name": "Уладый",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.641151,
            "latitude": 50.176033
        },
        "5541": {
            "name": "Шаралдай",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.6220055,
                    51.0422444
                ],
                [
                    107.6405214,
                    51.0441948
                ],
                [
                    107.6550628,
                    51.0398672
                ],
                [
                    107.661461,
                    51.0231623
                ],
                [
                    107.6532209,
                    51.0098674
                ],
                [
                    107.6456594,
                    51.0085865
                ],
                [
                    107.6353835,
                    51.0145638
                ],
                [
                    107.6238474,
                    51.0342589
                ],
                [
                    107.6220055,
                    51.0422444
                ]
            ],
            "longitude": 107.645836,
            "latitude": 51.026192
        },
        "5542": {
            "name": "Надеино",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.6670075,
            "latitude": 51.5482014
        },
        "5543": {
            "name": "Усть-Дунгуй",
            "population": 640,
            "type": "village",
            "poly": null,
            "longitude": 107.674736,
            "latitude": 49.990116
        },
        "5544": {
            "name": "Иркилик",
            "population": 438,
            "type": "village",
            "poly": null,
            "longitude": 107.678703,
            "latitude": 52.193424
        },
        "5545": {
            "name": "Новосретенка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.683357,
            "latitude": 50.723751
        },
        "5546": {
            "name": "Малая Кудара",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.687492,
            "latitude": 50.187901
        },
        "5547": {
            "name": "Мотня",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.707466,
            "latitude": 50.673435
        },
        "5548": {
            "name": "Карымск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.708984,
            "latitude": 52.254539
        },
        "5549": {
            "name": "Гутай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.752548,
            "latitude": 50.73877
        },
        "5550": {
            "name": "Куйтун",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.7578035,
            "latitude": 51.5278511
        },
        "5551": {
            "name": "Новый Заган",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.761734,
            "latitude": 51.026928
        },
        "5552": {
            "name": "Старый Заган",
            "population": 312,
            "type": "village",
            "poly": null,
            "longitude": 107.780502,
            "latitude": 51.029869
        },
        "5553": {
            "name": "Калиновка",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.7743299,
                    51.283513
                ],
                [
                    107.7757096,
                    51.2857332
                ],
                [
                    107.7775493,
                    51.285158
                ],
                [
                    107.7812717,
                    51.285194
                ],
                [
                    107.7824933,
                    51.2865603
                ],
                [
                    107.7869918,
                    51.2903444
                ],
                [
                    107.7905705,
                    51.2886456
                ],
                [
                    107.7878398,
                    51.2855356
                ],
                [
                    107.7845773,
                    51.281832
                ],
                [
                    107.7813579,
                    51.2804206
                ],
                [
                    107.7827376,
                    51.2775257
                ],
                [
                    107.785454,
                    51.2774808
                ],
                [
                    107.7878829,
                    51.2757905
                ],
                [
                    107.7856179,
                    51.2728717
                ],
                [
                    107.7830969,
                    51.2728684
                ],
                [
                    107.7802369,
                    51.2745228
                ],
                [
                    107.7743299,
                    51.283513
                ]
            ],
            "longitude": 107.781303,
            "latitude": 51.282265
        },
        "5554": {
            "name": "Зырянск",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.7646653,
                    52.2600997
                ],
                [
                    107.7755079,
                    52.263035
                ],
                [
                    107.7785996,
                    52.2640924
                ],
                [
                    107.7737801,
                    52.264649
                ],
                [
                    107.7695971,
                    52.2668194
                ],
                [
                    107.7709611,
                    52.2680437
                ],
                [
                    107.7758716,
                    52.2653169
                ],
                [
                    107.7790543,
                    52.2653725
                ],
                [
                    107.7799636,
                    52.2663186
                ],
                [
                    107.78642,
                    52.2675429
                ],
                [
                    107.7862381,
                    52.2694349
                ],
                [
                    107.787784,
                    52.27116
                ],
                [
                    107.7867837,
                    52.273497
                ],
                [
                    107.7890571,
                    52.274109
                ],
                [
                    107.7903301,
                    52.2712712
                ],
                [
                    107.7925126,
                    52.2688785
                ],
                [
                    107.7877396,
                    52.2659869
                ],
                [
                    107.7885777,
                    52.2643057
                ],
                [
                    107.7921626,
                    52.2651891
                ],
                [
                    107.7968185,
                    52.2631375
                ],
                [
                    107.7898813,
                    52.2608863
                ],
                [
                    107.780849,
                    52.2595184
                ],
                [
                    107.7751316,
                    52.2607837
                ],
                [
                    107.7685389,
                    52.2590966
                ],
                [
                    107.7646653,
                    52.2600997
                ]
            ],
            "longitude": 107.783318,
            "latitude": 52.263954
        },
        "5555": {
            "name": "Галтай",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.7809172,
                    51.2343858
                ],
                [
                    107.7837761,
                    51.2426061
                ],
                [
                    107.7898646,
                    51.2422581
                ],
                [
                    107.7913734,
                    51.2339714
                ],
                [
                    107.7979384,
                    51.2335571
                ],
                [
                    107.7975942,
                    51.2276394
                ],
                [
                    107.7861056,
                    51.227026
                ],
                [
                    107.7849673,
                    51.2309879
                ],
                [
                    107.7809172,
                    51.2343858
                ]
            ],
            "longitude": 107.790413,
            "latitude": 51.232864
        },
        "5556": {
            "name": "Николаевский",
            "population": 1295,
            "type": "village",
            "poly": null,
            "longitude": 107.7985166,
            "latitude": 51.6542558
        },
        "5557": {
            "name": "Эрхирик",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.818504,
            "latitude": 51.89085
        },
        "5558": {
            "name": "Малый Куналей",
            "population": 1884,
            "type": "village",
            "poly": [
                [
                    107.8043667,
                    50.61693
                ],
                [
                    107.8111037,
                    50.6201188
                ],
                [
                    107.8160994,
                    50.6133778
                ],
                [
                    107.8196069,
                    50.6114315
                ],
                [
                    107.8295096,
                    50.6110071
                ],
                [
                    107.8366062,
                    50.6073317
                ],
                [
                    107.8385244,
                    50.6049395
                ],
                [
                    107.8383013,
                    50.6012589
                ],
                [
                    107.8362939,
                    50.5989533
                ],
                [
                    107.8323429,
                    50.5993173
                ],
                [
                    107.8271491,
                    50.5939977
                ],
                [
                    107.8219554,
                    50.5844496
                ],
                [
                    107.8192788,
                    50.5838425
                ],
                [
                    107.8156464,
                    50.5859467
                ],
                [
                    107.8234529,
                    50.5960205
                ],
                [
                    107.821796,
                    50.5992565
                ],
                [
                    107.8127787,
                    50.6045755
                ],
                [
                    107.8053863,
                    50.6106015
                ],
                [
                    107.8043667,
                    50.61693
                ]
            ],
            "longitude": 107.823738,
            "latitude": 50.605015
        },
        "5559": {
            "name": "Шибертуй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.867897,
            "latitude": 50.795963
        },
        "5560": {
            "name": "Нестерово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.8828993,
            "latitude": 52.3693299
        },
        "5561": {
            "name": "Поселье",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.888093,
                    50.6086912
                ],
                [
                    107.8905065,
                    50.6196472
                ],
                [
                    107.8947766,
                    50.6226703
                ],
                [
                    107.903719,
                    50.615799
                ],
                [
                    107.9025741,
                    50.622317
                ],
                [
                    107.9029454,
                    50.6265768
                ],
                [
                    107.9080509,
                    50.6375678
                ],
                [
                    107.9121044,
                    50.6366062
                ],
                [
                    107.9118259,
                    50.6354287
                ],
                [
                    107.9154153,
                    50.634624
                ],
                [
                    107.9149511,
                    50.633152
                ],
                [
                    107.9125067,
                    50.6331324
                ],
                [
                    107.9084841,
                    50.6256149
                ],
                [
                    107.904802,
                    50.621787
                ],
                [
                    107.9061944,
                    50.615799
                ],
                [
                    107.9144561,
                    50.6079843
                ],
                [
                    107.9145489,
                    50.6016019
                ],
                [
                    107.9021409,
                    50.59679
                ],
                [
                    107.8898567,
                    50.5979292
                ],
                [
                    107.8909397,
                    50.6023089
                ],
                [
                    107.9035643,
                    50.6017786
                ],
                [
                    107.9035643,
                    50.6066883
                ],
                [
                    107.8937245,
                    50.6073167
                ],
                [
                    107.888093,
                    50.6086912
                ]
            ],
            "longitude": 107.894424,
            "latitude": 50.614098
        },
        "5562": {
            "name": "Слобода",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.904434,
            "latitude": 50.617062
        },
        "5563": {
            "name": "Верхний Сутай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 107.904495,
            "latitude": 51.313541
        },
        "5564": {
            "name": "Нарсата",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.899952,
                    51.2640326
                ],
                [
                    107.9010701,
                    51.2686696
                ],
                [
                    107.9050486,
                    51.2678561
                ],
                [
                    107.9071028,
                    51.2664081
                ],
                [
                    107.9075969,
                    51.2645858
                ],
                [
                    107.9058547,
                    51.2606969
                ],
                [
                    107.9030983,
                    51.257003
                ],
                [
                    107.900342,
                    51.2572795
                ],
                [
                    107.9019542,
                    51.2632515
                ],
                [
                    107.899952,
                    51.2640326
                ]
            ],
            "longitude": 107.904854,
            "latitude": 51.26424
        },
        "5565": {
            "name": "Нижние Тальцы",
            "population": 2683,
            "type": "village",
            "poly": null,
            "longitude": 107.910263,
            "latitude": 51.886768
        },
        "5566": {
            "name": "Буй",
            "population": null,
            "type": "village",
            "poly": [
                [
                    107.9408536,
                    50.6470629
                ],
                [
                    107.94381,
                    50.6512942
                ],
                [
                    107.9544534,
                    50.6498749
                ],
                [
                    107.9775561,
                    50.644599
                ],
                [
                    107.9795412,
                    50.646929
                ],
                [
                    107.9819909,
                    50.6463398
                ],
                [
                    107.9786205,
                    50.6405921
                ],
                [
                    107.9843645,
                    50.637935
                ],
                [
                    107.9896693,
                    50.6328774
                ],
                [
                    107.9884867,
                    50.6313986
                ],
                [
                    107.9784178,
                    50.6346562
                ],
                [
                    107.9709505,
                    50.6376135
                ],
                [
                    107.9646321,
                    50.6339704
                ],
                [
                    107.9588881,
                    50.6338204
                ],
                [
                    107.9507113,
                    50.6331131
                ],
                [
                    107.9500017,
                    50.6354277
                ],
                [
                    107.9620304,
                    50.6377635
                ],
                [
                    107.9675041,
                    50.6390278
                ],
                [
                    107.9663891,
                    50.6420705
                ],
                [
                    107.9606113,
                    50.6442989
                ],
                [
                    107.9548673,
                    50.6459488
                ],
                [
                    107.9462512,
                    50.6466987
                ],
                [
                    107.9408536,
                    50.6470629
                ]
            ],
            "longitude": 107.970512,
            "latitude": 50.642532
        },
        "5567": {
            "name": "Гремячинск",
            "population": 1001,
            "type": "village",
            "poly": null,
            "longitude": 107.971176,
            "latitude": 52.799362
        },
        "5568": {
            "name": "Харашибирь",
            "population": 864,
            "type": "village",
            "poly": [
                [
                    107.9657892,
                    51.1004541
                ],
                [
                    107.9691968,
                    51.1033441
                ],
                [
                    107.9738877,
                    51.1067063
                ],
                [
                    107.9799505,
                    51.104928
                ],
                [
                    107.9922973,
                    51.105317
                ],
                [
                    108.0010153,
                    51.1072897
                ],
                [
                    108.0046441,
                    51.1056782
                ],
                [
                    108.0069895,
                    51.1020659
                ],
                [
                    108.0128753,
                    51.1011766
                ],
                [
                    108.0126983,
                    51.0976195
                ],
                [
                    108.0044228,
                    51.0955629
                ],
                [
                    107.9993779,
                    51.093812
                ],
                [
                    107.9988574,
                    51.0931298
                ],
                [
                    107.9960384,
                    51.0918693
                ],
                [
                    107.9925814,
                    51.0900695
                ],
                [
                    107.989111,
                    51.08892
                ],
                [
                    107.9829155,
                    51.0883641
                ],
                [
                    107.9793752,
                    51.089198
                ],
                [
                    107.9790654,
                    51.0919219
                ],
                [
                    107.985969,
                    51.0942289
                ],
                [
                    107.9814108,
                    51.0968691
                ],
                [
                    107.9706572,
                    51.099009
                ],
                [
                    107.9657892,
                    51.1004541
                ]
            ],
            "longitude": 107.991783,
            "latitude": 51.099144
        },
        "5569": {
            "name": "Узкий Луг",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.0219133,
            "latitude": 50.7033223
        },
        "5570": {
            "name": "Бом",
            "population": 338,
            "type": "village",
            "poly": null,
            "longitude": 108.02552,
            "latitude": 51.224827
        },
        "5571": {
            "name": "Кика",
            "population": null,
            "type": "village",
            "poly": [
                [
                    108.0168745,
                    52.4969917
                ],
                [
                    108.0215973,
                    52.5010809
                ],
                [
                    108.0254806,
                    52.5008892
                ],
                [
                    108.0274747,
                    52.5024864
                ],
                [
                    108.031148,
                    52.5035086
                ],
                [
                    108.031148,
                    52.4988447
                ],
                [
                    108.0342966,
                    52.4964167
                ],
                [
                    108.0360422,
                    52.496182
                ],
                [
                    108.0309868,
                    52.4901934
                ],
                [
                    108.0278572,
                    52.4910311
                ],
                [
                    108.0240742,
                    52.4933344
                ],
                [
                    108.0214605,
                    52.4925597
                ],
                [
                    108.0172648,
                    52.495512
                ],
                [
                    108.0168745,
                    52.4969917
                ]
            ],
            "longitude": 108.027718,
            "latitude": 52.497925
        },
        "5572": {
            "name": "Котокель",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.072578,
            "latitude": 52.758728
        },
        "5573": {
            "name": "Хаим",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.0842612,
            "latitude": 52.6025516
        },
        "5574": {
            "name": "Тугнуй",
            "population": null,
            "type": "village",
            "poly": [
                [
                    108.0953311,
                    51.2157297
                ],
                [
                    108.128486,
                    51.223633
                ],
                [
                    108.1313213,
                    51.2225931
                ],
                [
                    108.1253442,
                    51.2142257
                ],
                [
                    108.1255338,
                    51.2127993
                ],
                [
                    108.0958998,
                    51.2062672
                ],
                [
                    108.095893,
                    51.2076009
                ],
                [
                    108.0953311,
                    51.2157297
                ]
            ],
            "longitude": 108.1105296,
            "latitude": 51.2144688
        },
        "5575": {
            "name": "Старая Брянь",
            "population": null,
            "type": "village",
            "poly": [
                [
                    108.1098716,
                    51.5672033
                ],
                [
                    108.1184749,
                    51.5757009
                ],
                [
                    108.12453,
                    51.5798215
                ],
                [
                    108.1255986,
                    51.5921128
                ],
                [
                    108.1274617,
                    51.5955851
                ],
                [
                    108.1421201,
                    51.5945468
                ],
                [
                    108.1360375,
                    51.577625
                ],
                [
                    108.1339552,
                    51.5736064
                ],
                [
                    108.1277631,
                    51.5734532
                ],
                [
                    108.1211599,
                    51.57158
                ],
                [
                    108.114091,
                    51.5660622
                ],
                [
                    108.1098716,
                    51.5672033
                ]
            ],
            "longitude": 108.130577,
            "latitude": 51.581264
        },
        "5576": {
            "name": "Усть-Брянь",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.138893,
            "latitude": 51.940559
        },
        "5577": {
            "name": "Ярцы",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.1405871,
            "latitude": 52.8775842
        },
        "5578": {
            "name": "Шанага",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.149254,
            "latitude": 50.829391
        },
        "5579": {
            "name": "Потанино",
            "population": 875,
            "type": "village",
            "poly": null,
            "longitude": 108.152191,
            "latitude": 50.807877
        },
        "5580": {
            "name": "Исток",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.207367,
            "latitude": 52.866684
        },
        "5581": {
            "name": "Хонхолой",
            "population": 1535,
            "type": "village",
            "poly": null,
            "longitude": 108.232208,
            "latitude": 51.128002
        },
        "5582": {
            "name": "Новая Брянь",
            "population": 4301,
            "type": "village",
            "poly": null,
            "longitude": 108.25206,
            "latitude": 51.708385
        },
        "5583": {
            "name": "Хонхолой",
            "population": 398,
            "type": "village",
            "poly": null,
            "longitude": 108.253525,
            "latitude": 50.868675
        },
        "5584": {
            "name": "Нарын-Ацагат",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.289345,
            "latitude": 52.004139
        },
        "5585": {
            "name": "Горячинск",
            "population": null,
            "type": "village",
            "poly": [
                [
                    108.284545,
                    52.9841533
                ],
                [
                    108.2846476,
                    52.9872597
                ],
                [
                    108.2951044,
                    52.9877123
                ],
                [
                    108.2940109,
                    52.9892346
                ],
                [
                    108.2961296,
                    52.9911064
                ],
                [
                    108.3066872,
                    52.9891109
                ],
                [
                    108.3111313,
                    52.9870129
                ],
                [
                    108.311063,
                    52.9830423
                ],
                [
                    108.3058004,
                    52.9808408
                ],
                [
                    108.3008454,
                    52.9795035
                ],
                [
                    108.2950019,
                    52.9764994
                ],
                [
                    108.2910378,
                    52.9763759
                ],
                [
                    108.2906961,
                    52.979627
                ],
                [
                    108.2893976,
                    52.9813347
                ],
                [
                    108.2907645,
                    52.9827543
                ],
                [
                    108.284545,
                    52.9841533
                ]
            ],
            "longitude": 108.299103,
            "latitude": 52.984402
        },
        "5586": {
            "name": "Безымянка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.3113876,
            "latitude": 53.0721731
        },
        "5587": {
            "name": "Шабур",
            "population": 1155,
            "type": "village",
            "poly": null,
            "longitude": 108.317177,
            "latitude": 51.480755
        },
        "5588": {
            "name": "Никольск",
            "population": 1282,
            "type": "village",
            "poly": null,
            "longitude": 108.323303,
            "latitude": 51.189163
        },
        "5589": {
            "name": "Кусоты",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.347549,
            "latitude": 51.351307
        },
        "5590": {
            "name": "Челутай (3 км)",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.364433,
            "latitude": 51.75695
        },
        "5591": {
            "name": "Челутай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.387619,
            "latitude": 51.759365
        },
        "5592": {
            "name": "Татарский Ключ",
            "population": 1752,
            "type": "village",
            "poly": null,
            "longitude": 108.395462,
            "latitude": 51.686924
        },
        "5593": {
            "name": "Соболиха",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.3957087,
            "latitude": 52.9238976
        },
        "5594": {
            "name": "Первомаевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.402435,
            "latitude": 52.033733
        },
        "5595": {
            "name": "Челутай (24 км)",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.415993,
            "latitude": 51.586323
        },
        "5596": {
            "name": "Катково",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.4271016,
            "latitude": 53.1674947
        },
        "5597": {
            "name": "Саган-Нур",
            "population": 3997,
            "type": "village",
            "poly": null,
            "longitude": 108.433006,
            "latitude": 51.346027
        },
        "5598": {
            "name": "Новая Курба",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.511749,
            "latitude": 52.040569
        },
        "5599": {
            "name": "Старая Курба",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.518158,
            "latitude": 52.004593
        },
        "5600": {
            "name": "Илька",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.524963,
            "latitude": 51.721405
        },
        "5601": {
            "name": "Унэгэтэй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.563324,
            "latitude": 52.09647
        },
        "5602": {
            "name": "Ангир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.599022,
            "latitude": 52.218689
        },
        "5603": {
            "name": "Золотой Ключ",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.6553756,
            "latitude": 52.9873668
        },
        "5604": {
            "name": "Новоильинск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.705711,
            "latitude": 51.686081
        },
        "5605": {
            "name": "Дархита",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.7327897,
            "latitude": 51.6736648
        },
        "5606": {
            "name": "Максимиха",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.7455709,
            "latitude": 53.265578
        },
        "5607": {
            "name": "Горхон",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.785286,
            "latitude": 51.556644
        },
        "5608": {
            "name": "Хасурта",
            "population": 545,
            "type": "village",
            "poly": null,
            "longitude": 108.871712,
            "latitude": 52.291492
        },
        "5609": {
            "name": "Ташелан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.895187,
            "latitude": 51.686447
        },
        "5610": {
            "name": "Тэгда",
            "population": 1756,
            "type": "village",
            "poly": null,
            "longitude": 108.9238466,
            "latitude": 52.397002
        },
        "5611": {
            "name": "Верхние Тальцы",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 108.9404978,
            "latitude": 52.0386567
        },
        "5612": {
            "name": "Барун-Хасурта",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.0243799,
            "latitude": 52.148094
        },
        "5613": {
            "name": "Нарын",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.077393,
            "latitude": 51.71299
        },
        "5614": {
            "name": "Макаринино",
            "population": 293,
            "type": "village",
            "poly": [
                [
                    109.0767758,
                    53.4418254
                ],
                [
                    109.0768656,
                    53.4442345
                ],
                [
                    109.0867974,
                    53.445894
                ],
                [
                    109.0954259,
                    53.4438597
                ],
                [
                    109.1073349,
                    53.4433779
                ],
                [
                    109.1201428,
                    53.4444754
                ],
                [
                    109.1253559,
                    53.4439133
                ],
                [
                    109.1244571,
                    53.4400855
                ],
                [
                    109.1141209,
                    53.4395501
                ],
                [
                    109.1067058,
                    53.4388808
                ],
                [
                    109.0941226,
                    53.4403531
                ],
                [
                    109.0841459,
                    53.4412098
                ],
                [
                    109.0767758,
                    53.4418254
                ]
            ],
            "longitude": 109.115707,
            "latitude": 53.442318
        },
        "5615": {
            "name": "Байкальское",
            "population": 655,
            "type": "village",
            "poly": null,
            "longitude": 109.191711,
            "latitude": 55.355587
        },
        "5616": {
            "name": "Удинск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.2071355,
            "latitude": 52.1390784
        },
        "5617": {
            "name": "Тохорюкта",
            "population": 247,
            "type": "village",
            "poly": null,
            "longitude": 109.2921163,
            "latitude": 52.5616106
        },
        "5618": {
            "name": "Адамово",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.298813,
            "latitude": 53.479801
        },
        "5619": {
            "name": "Хара-Кутул",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.31263,
            "latitude": 51.763203
        },
        "5620": {
            "name": "Баян-Гол",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.3354524,
            "latitude": 52.1703649
        },
        "5621": {
            "name": "Санномыск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.4056114,
            "latitude": 52.120736
        },
        "5622": {
            "name": "Новокижингинск",
            "population": 1594,
            "type": "village",
            "poly": null,
            "longitude": 109.601974,
            "latitude": 51.617409
        },
        "5623": {
            "name": "Кульский Станок",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.6166795,
            "latitude": 52.1673407
        },
        "5624": {
            "name": "Кульск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.6218134,
            "latitude": 52.1320702
        },
        "5625": {
            "name": "Эдэрмэг",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.663696,
            "latitude": 51.693615
        },
        "5626": {
            "name": "Душкачан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.6713241,
            "latitude": 55.8483247
        },
        "5627": {
            "name": "Худанай Уртоо",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.75296,
            "latitude": 52.047531
        },
        "5628": {
            "name": "Холодная",
            "population": null,
            "type": "village",
            "poly": [
                [
                    109.7549746,
                    55.8814194
                ],
                [
                    109.762944,
                    55.8843151
                ],
                [
                    109.7643173,
                    55.8814747
                ],
                [
                    109.7680939,
                    55.8809451
                ],
                [
                    109.7660897,
                    55.879614
                ],
                [
                    109.7638882,
                    55.8794286
                ],
                [
                    109.7615707,
                    55.8772861
                ],
                [
                    109.7594808,
                    55.8775196
                ],
                [
                    109.756378,
                    55.8786101
                ],
                [
                    109.7549746,
                    55.8814194
                ]
            ],
            "longitude": 109.759132,
            "latitude": 55.880745
        },
        "5629": {
            "name": "Усть-Орот",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.776495,
            "latitude": 51.9799302
        },
        "5630": {
            "name": "Читкан",
            "population": 967,
            "type": "village",
            "poly": [
                [
                    109.7642183,
                    53.5010818
                ],
                [
                    109.7653241,
                    53.5082503
                ],
                [
                    109.7741702,
                    53.510223
                ],
                [
                    109.7831269,
                    53.512919
                ],
                [
                    109.7908672,
                    53.5064089
                ],
                [
                    109.788324,
                    53.4941752
                ],
                [
                    109.7879922,
                    53.4877938
                ],
                [
                    109.7852278,
                    53.4848331
                ],
                [
                    109.7793673,
                    53.4859516
                ],
                [
                    109.776824,
                    53.4899649
                ],
                [
                    109.7642183,
                    53.5010818
                ]
            ],
            "longitude": 109.779701,
            "latitude": 53.497463
        },
        "5631": {
            "name": "Сухая",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.8138449,
            "latitude": 53.7480335
        },
        "5632": {
            "name": "Уро",
            "population": null,
            "type": "village",
            "poly": [
                [
                    109.8204156,
                    53.5517058
                ],
                [
                    109.8367809,
                    53.556961
                ],
                [
                    109.8509347,
                    53.5514431
                ],
                [
                    109.858675,
                    53.5478298
                ],
                [
                    109.8555789,
                    53.5403394
                ],
                [
                    109.8664153,
                    53.5289042
                ],
                [
                    109.8658625,
                    53.5277211
                ],
                [
                    109.8597808,
                    53.5283784
                ],
                [
                    109.8382184,
                    53.5394195
                ],
                [
                    109.8204156,
                    53.5517058
                ]
            ],
            "longitude": 109.842751,
            "latitude": 53.545662
        },
        "5633": {
            "name": "Алан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.8662294,
            "latitude": 52.3143357
        },
        "5634": {
            "name": "Душелан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.88784,
            "latitude": 53.59811
        },
        "5635": {
            "name": "Улюн",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.916534,
            "latitude": 53.82806
        },
        "5636": {
            "name": "Улюкчикан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 109.954613,
            "latitude": 53.870804
        },
        "5637": {
            "name": "Суво",
            "population": null,
            "type": "village",
            "poly": [
                [
                    110.0001346,
                    53.6588413
                ],
                [
                    110.0070358,
                    53.6680931
                ],
                [
                    110.0166976,
                    53.6723861
                ],
                [
                    110.025583,
                    53.6678887
                ],
                [
                    110.0232538,
                    53.6618062
                ],
                [
                    110.0253242,
                    53.6529621
                ],
                [
                    110.0131607,
                    53.6534222
                ],
                [
                    110.0049654,
                    53.6552116
                ],
                [
                    110.0001346,
                    53.6588413
                ]
            ],
            "longitude": 110.009094,
            "latitude": 53.658157
        },
        "5638": {
            "name": "Ониноборск",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.0258474,
            "latitude": 52.2555016
        },
        "5639": {
            "name": "Иннокентьевка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.032654,
            "latitude": 51.919857
        },
        "5640": {
            "name": "Зун-Хурай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.0547948,
            "latitude": 52.166575
        },
        "5641": {
            "name": "Бодон",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.087944,
            "latitude": 53.708672
        },
        "5642": {
            "name": "Элэсун",
            "population": 510,
            "type": "village",
            "poly": null,
            "longitude": 110.095154,
            "latitude": 54.031956
        },
        "5643": {
            "name": "Хилгана",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.095589,
            "latitude": 53.915867
        },
        "5644": {
            "name": "Кичера",
            "population": 1141,
            "type": "village",
            "poly": null,
            "longitude": 110.0967229,
            "latitude": 55.9291144
        },
        "5645": {
            "name": "Булум",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.1112136,
            "latitude": 52.2840875
        },
        "5646": {
            "name": "Улзытэ",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.124809,
            "latitude": 51.914886
        },
        "5647": {
            "name": "Верхняя Заимка",
            "population": 599,
            "type": "village",
            "poly": null,
            "longitude": 110.1432245,
            "latitude": 55.8483447
        },
        "5648": {
            "name": "Барагхан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.161133,
            "latitude": 54.153732
        },
        "5649": {
            "name": "Сулхара",
            "population": 556,
            "type": "village",
            "poly": null,
            "longitude": 110.164162,
            "latitude": 51.748878
        },
        "5650": {
            "name": "Борогол",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.171616,
            "latitude": 53.902241
        },
        "5651": {
            "name": "Ина",
            "population": null,
            "type": "village",
            "poly": [
                [
                    110.2110747,
                    53.747565
                ],
                [
                    110.2146915,
                    53.7494148
                ],
                [
                    110.2186342,
                    53.7481623
                ],
                [
                    110.2234893,
                    53.7478926
                ],
                [
                    110.2331994,
                    53.7428247
                ],
                [
                    110.2393253,
                    53.7424393
                ],
                [
                    110.2427466,
                    53.7367732
                ],
                [
                    110.2418994,
                    53.734152
                ],
                [
                    110.2363927,
                    53.7371394
                ],
                [
                    110.2290612,
                    53.7386235
                ],
                [
                    110.2247275,
                    53.7415143
                ],
                [
                    110.2151151,
                    53.7454069
                ],
                [
                    110.2110747,
                    53.747565
                ]
            ],
            "longitude": 110.229416,
            "latitude": 53.741516
        },
        "5652": {
            "name": "Юбилейный",
            "population": 796,
            "type": "village",
            "poly": null,
            "longitude": 110.233978,
            "latitude": 53.726833
        },
        "5653": {
            "name": "Ашанга",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.263364,
            "latitude": 52.3685037
        },
        "5654": {
            "name": "Баянгол",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.27079,
            "latitude": 53.772358
        },
        "5655": {
            "name": "Могсохон",
            "population": 994,
            "type": "village",
            "poly": null,
            "longitude": 110.32296,
            "latitude": 51.885738
        },
        "5656": {
            "name": "Амгаланта",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.384671,
            "latitude": 52.398587
        },
        "5657": {
            "name": "Сахули",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.406509,
            "latitude": 54.42178
        },
        "5658": {
            "name": "Могойто",
            "population": 937,
            "type": "village",
            "poly": null,
            "longitude": 110.459793,
            "latitude": 54.380943
        },
        "5659": {
            "name": "Георгиевское",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.4602188,
            "latitude": 52.3420625
        },
        "5660": {
            "name": "Михайловка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.4729268,
            "latitude": 51.8926342
        },
        "5661": {
            "name": "Шаманка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.479706,
            "latitude": 54.468693
        },
        "5662": {
            "name": "Чесан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.512238,
            "latitude": 51.965553
        },
        "5663": {
            "name": "Ульдурга",
            "population": 1236,
            "type": "village",
            "poly": null,
            "longitude": 110.538643,
            "latitude": 52.224075
        },
        "5664": {
            "name": "Тужинка",
            "population": 522,
            "type": "village",
            "poly": null,
            "longitude": 110.551155,
            "latitude": 52.306725
        },
        "5665": {
            "name": "Булак",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.559837,
            "latitude": 51.96843
        },
        "5666": {
            "name": "Усть-Эгита",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.613312,
            "latitude": 52.331894
        },
        "5667": {
            "name": "Аргада",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.686356,
            "latitude": 54.24345
        },
        "5668": {
            "name": "Поперечное",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.714485,
            "latitude": 52.385723
        },
        "5669": {
            "name": "Загустай",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.7296494,
            "latitude": 51.9768394
        },
        "5670": {
            "name": "Арзгун",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.7388008,
            "latitude": 54.3787096
        },
        "5671": {
            "name": "Эгита",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.739716,
            "latitude": 52.425529
        },
        "5672": {
            "name": "Можайка",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.788643,
            "latitude": 52.411976
        },
        "5673": {
            "name": "Майский",
            "population": 971,
            "type": "village",
            "poly": null,
            "longitude": 110.79847,
            "latitude": 54.59771
        },
        "5674": {
            "name": "Алла",
            "population": 959,
            "type": "village",
            "poly": null,
            "longitude": 110.819496,
            "latitude": 54.688992
        },
        "5675": {
            "name": "Хуртэй",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.83062,
            "latitude": 51.944
        },
        "5676": {
            "name": "Улзытэ",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.863312,
            "latitude": 52.463268
        },
        "5677": {
            "name": "Хангир",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 110.895836,
            "latitude": 52.362011
        },
        "5678": {
            "name": "Ангоя",
            "population": 651,
            "type": "village",
            "poly": null,
            "longitude": 110.9086188,
            "latitude": 56.0096307
        },
        "5679": {
            "name": "Улюнхан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 111.068787,
            "latitude": 54.864628
        },
        "5680": {
            "name": "Комсомольское",
            "population": 683,
            "type": "village",
            "poly": null,
            "longitude": 111.092712,
            "latitude": 52.480686
        },
        "5681": {
            "name": "Кумора",
            "population": 462,
            "type": "village",
            "poly": null,
            "longitude": 111.2080512,
            "latitude": 55.8855127
        },
        "5682": {
            "name": "Гонда",
            "population": 522,
            "type": "village",
            "poly": null,
            "longitude": 111.2427782,
            "latitude": 52.5316763
        },
        "5683": {
            "name": "Укыр",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 111.409233,
            "latitude": 52.527592
        },
        "5684": {
            "name": "Гарам",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 111.443138,
            "latitude": 52.574688
        },
        "5685": {
            "name": "Тулдун",
            "population": 475,
            "type": "village",
            "poly": null,
            "longitude": 111.580276,
            "latitude": 52.686157
        },
        "5686": {
            "name": "Уоян",
            "population": 285,
            "type": "village",
            "poly": null,
            "longitude": 111.6170654,
            "latitude": 56.1304568
        },
        "5687": {
            "name": "Озёрный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 111.697098,
            "latitude": 52.929913
        },
        "5688": {
            "name": "Ширинга",
            "population": 548,
            "type": "village",
            "poly": null,
            "longitude": 111.704887,
            "latitude": 52.679123
        },
        "5689": {
            "name": "Домна",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 111.709663,
            "latitude": 52.562286
        },
        "5690": {
            "name": "Гунда",
            "population": 1134,
            "type": "village",
            "poly": null,
            "longitude": 111.727547,
            "latitude": 52.780231
        },
        "5691": {
            "name": "Усть-Джилинда",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 111.945831,
            "latitude": 53.666039
        },
        "5692": {
            "name": "Исинга",
            "population": 923,
            "type": "village",
            "poly": null,
            "longitude": 111.9981977,
            "latitude": 52.9116499
        },
        "5693": {
            "name": "Варваринский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 112.3606879,
            "latitude": 54.3198077
        },
        "5694": {
            "name": "Романовка",
            "population": 1200,
            "type": "village",
            "poly": [
                [
                    112.7681445,
                    53.2147697
                ],
                [
                    112.7688858,
                    53.2149766
                ],
                [
                    112.7699802,
                    53.2148867
                ],
                [
                    112.7695725,
                    53.2143341
                ],
                [
                    112.7687453,
                    53.2141787
                ],
                [
                    112.7681445,
                    53.2147697
                ]
            ],
            "longitude": 112.769127,
            "latitude": 53.214626
        },
        "5695": {
            "name": "Янчукан",
            "population": 286,
            "type": "village",
            "poly": null,
            "longitude": 112.813866,
            "latitude": 56.257603
        },
        "5696": {
            "name": "Целинный",
            "population": 426,
            "type": "village",
            "poly": null,
            "longitude": 112.863136,
            "latitude": 52.603809
        },
        "5697": {
            "name": "Северный",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.275597,
            "latitude": 54.352127
        },
        "5698": {
            "name": "Телемба",
            "population": 1291,
            "type": "village",
            "poly": null,
            "longitude": 113.285942,
            "latitude": 52.740528
        },
        "5699": {
            "name": "Ципикан",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.351906,
            "latitude": 54.920952
        },
        "5700": {
            "name": "Малый Амалат",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.443184,
            "latitude": 54.297546
        },
        "5701": {
            "name": "Маловский",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.550804,
            "latitude": 54.399708
        },
        "5702": {
            "name": "Северомуйск",
            "population": 992,
            "type": "village",
            "poly": null,
            "longitude": 113.574615,
            "latitude": 56.172134
        },
        "5703": {
            "name": "Уакит",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.636932,
            "latitude": 55.482956
        },
        "5704": {
            "name": "Монгой",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 113.822762,
            "latitude": 53.968586
        },
        "5705": {
            "name": "Россошино",
            "population": 259,
            "type": "village",
            "poly": null,
            "longitude": 114.29586,
            "latitude": 54.291264
        },
        "5706": {
            "name": "Усть-Муя",
            "population": null,
            "type": "village",
            "poly": null,
            "longitude": 115.629074,
            "latitude": 56.4149883
        },
        "5707": {
            "name": "Краснодарка",
            "population": 326,
            "type": "village",
            "poly": null,
            "longitude": 74.024382021174,
            "latitude": 54.25023292418337
        },
        "5708": {
            "name": "УСТЬ-КАН",
            "population": 4542,
            "type": "town",
            "poly": [
                [
                    84.7500567,
                    50.9294673
                ],
                [
                    84.7555859,
                    50.9327781
                ],
                [
                    84.7637576,
                    50.9337557
                ],
                [
                    84.7678195,
                    50.9380581
                ],
                [
                    84.7683147,
                    50.9385825
                ],
                [
                    84.770981,
                    50.9414065
                ],
                [
                    84.7861332,
                    50.9435244
                ],
                [
                    84.7893743,
                    50.9401955
                ],
                [
                    84.7767242,
                    50.9372717
                ],
                [
                    84.7652355,
                    50.9338465
                ],
                [
                    84.7689803,
                    50.9319716
                ],
                [
                    84.7737136,
                    50.9282621
                ],
                [
                    84.7813062,
                    50.9230092
                ],
                [
                    84.7762585,
                    50.9194844
                ],
                [
                    84.7500567,
                    50.9294673
                ]
            ],
            "longitude": 84.765213,
            "latitude": 50.932003
        },
        "5709": {
            "name": "УСТЬ-КОКСА",
            "population": 4745,
            "type": "town",
            "poly": null,
            "longitude": 85.6155842,
            "latitude": 50.2695927
        },
        "5710": {
            "name": "ШЕБАЛИНО",
            "population": 5011,
            "type": "town",
            "poly": null,
            "longitude": 85.6794538,
            "latitude": 51.291774
        },
        "5711": {
            "name": "МАЙМА",
            "population": 15344,
            "type": "town",
            "poly": [
                [
                    85.8591257,
                    51.9760114
                ],
                [
                    85.8679198,
                    51.9820583
                ],
                [
                    85.8621552,
                    51.9863853
                ],
                [
                    85.8661774,
                    51.987272
                ],
                [
                    85.864064,
                    51.9896383
                ],
                [
                    85.867138,
                    51.9924185
                ],
                [
                    85.8709324,
                    51.9891355
                ],
                [
                    85.8744147,
                    51.9913538
                ],
                [
                    85.8784896,
                    51.9916521
                ],
                [
                    85.8809026,
                    51.9927121
                ],
                [
                    85.8818095,
                    51.9933556
                ],
                [
                    85.8764956,
                    52.0021122
                ],
                [
                    85.8766878,
                    52.0055717
                ],
                [
                    85.8792011,
                    52.0097171
                ],
                [
                    85.8927568,
                    52.0140477
                ],
                [
                    85.8992765,
                    52.0146828
                ],
                [
                    85.9027945,
                    52.0218415
                ],
                [
                    85.9073443,
                    52.032289
                ],
                [
                    85.9095958,
                    52.0372232
                ],
                [
                    85.9276543,
                    52.034684
                ],
                [
                    85.9274667,
                    52.02594
                ],
                [
                    85.931782,
                    52.0176561
                ],
                [
                    85.9265755,
                    52.0136435
                ],
                [
                    85.9205716,
                    52.0082447
                ],
                [
                    85.9160218,
                    52.0008238
                ],
                [
                    85.9096427,
                    51.993315
                ],
                [
                    85.9062655,
                    51.988636
                ],
                [
                    85.8986669,
                    51.9802007
                ],
                [
                    85.8923411,
                    51.9823921
                ],
                [
                    85.8816963,
                    51.9804061
                ],
                [
                    85.8776533,
                    51.9770226
                ],
                [
                    85.8660208,
                    51.9759535
                ],
                [
                    85.8591257,
                    51.9760114
                ]
            ],
            "longitude": 85.898743,
            "latitude": 52.004684
        },
        "5712": {
            "name": "ГОРНО-АЛТАЙСК",
            "population": 62861,
            "type": "town",
            "poly": [
                [
                    85.8818937,
                    51.9803533
                ],
                [
                    85.8876805,
                    51.981501
                ],
                [
                    85.8922836,
                    51.982325
                ],
                [
                    85.8927652,
                    51.9818389
                ],
                [
                    85.898517,
                    51.9800192
                ],
                [
                    85.9030269,
                    51.9787454
                ],
                [
                    85.9029261,
                    51.9769601
                ],
                [
                    85.9030611,
                    51.9758685
                ],
                [
                    85.9030657,
                    51.9741957
                ],
                [
                    85.9098555,
                    51.9741918
                ],
                [
                    85.9137453,
                    51.9746292
                ],
                [
                    85.9213745,
                    51.9742533
                ],
                [
                    85.9350168,
                    51.9761618
                ],
                [
                    85.9401309,
                    51.9783045
                ],
                [
                    85.9401879,
                    51.9789519
                ],
                [
                    85.9426894,
                    51.9812382
                ],
                [
                    85.934727,
                    51.9918055
                ],
                [
                    85.9486737,
                    51.9917635
                ],
                [
                    85.9551409,
                    51.9925348
                ],
                [
                    85.9570157,
                    51.9903655
                ],
                [
                    85.9618476,
                    51.9860814
                ],
                [
                    85.9695138,
                    51.9881003
                ],
                [
                    85.9841827,
                    51.9888188
                ],
                [
                    85.9894646,
                    51.9924998
                ],
                [
                    85.9974414,
                    51.9936497
                ],
                [
                    86.0030666,
                    51.9933406
                ],
                [
                    86.0040808,
                    51.9924124
                ],
                [
                    86.0036159,
                    51.9921966
                ],
                [
                    86.0037671,
                    51.9910826
                ],
                [
                    86.0045355,
                    51.9906431
                ],
                [
                    86.0045041,
                    51.9888027
                ],
                [
                    86.0044439,
                    51.9882558
                ],
                [
                    86.003961,
                    51.9872257
                ],
                [
                    86.0041659,
                    51.9861345
                ],
                [
                    86.0046104,
                    51.9856364
                ],
                [
                    86.0042361,
                    51.9845961
                ],
                [
                    86.0015803,
                    51.9846294
                ],
                [
                    85.9965703,
                    51.9833267
                ],
                [
                    85.9898888,
                    51.9808718
                ],
                [
                    85.9910456,
                    51.980023
                ],
                [
                    85.9913305,
                    51.9777951
                ],
                [
                    85.9912504,
                    51.9765343
                ],
                [
                    85.989045,
                    51.9750321
                ],
                [
                    85.9930564,
                    51.9725015
                ],
                [
                    85.9925583,
                    51.9713598
                ],
                [
                    85.9934737,
                    51.9707988
                ],
                [
                    85.9934609,
                    51.9705645
                ],
                [
                    85.9937693,
                    51.9705003
                ],
                [
                    85.9942314,
                    51.9708276
                ],
                [
                    85.9945198,
                    51.9708524
                ],
                [
                    85.995363,
                    51.9710938
                ],
                [
                    85.9954663,
                    51.9713177
                ],
                [
                    85.9960581,
                    51.9715012
                ],
                [
                    85.9964397,
                    51.9713929
                ],
                [
                    85.9968403,
                    51.9712401
                ],
                [
                    85.9970241,
                    51.9710968
                ],
                [
                    85.9971673,
                    51.9711538
                ],
                [
                    85.9975238,
                    51.9713575
                ],
                [
                    85.9982284,
                    51.9713412
                ],
                [
                    85.9982022,
                    51.9708949
                ],
                [
                    85.9976535,
                    51.9703996
                ],
                [
                    85.9975673,
                    51.9702204
                ],
                [
                    85.9977317,
                    51.9701326
                ],
                [
                    85.9979464,
                    51.9702236
                ],
                [
                    85.998047,
                    51.9705702
                ],
                [
                    85.9988601,
                    51.9705436
                ],
                [
                    86.0000033,
                    51.9702857
                ],
                [
                    85.9998016,
                    51.9696149
                ],
                [
                    85.9993515,
                    51.9695553
                ],
                [
                    85.9993884,
                    51.9695222
                ],
                [
                    85.9995348,
                    51.9694342
                ],
                [
                    85.9998605,
                    51.9694035
                ],
                [
                    86.0000706,
                    51.9696951
                ],
                [
                    86.0011588,
                    51.9696822
                ],
                [
                    86.0017045,
                    51.9694972
                ],
                [
                    86.0022884,
                    51.9696304
                ],
                [
                    86.0028215,
                    51.9692
                ],
                [
                    86.002589,
                    51.9686961
                ],
                [
                    86.0026712,
                    51.9686523
                ],
                [
                    86.0031086,
                    51.9688734
                ],
                [
                    86.0040292,
                    51.9688868
                ],
                [
                    86.0043043,
                    51.968694
                ],
                [
                    86.0051287,
                    51.9689685
                ],
                [
                    86.0048034,
                    51.9693896
                ],
                [
                    86.0060202,
                    51.9694779
                ],
                [
                    86.0070224,
                    51.9686556
                ],
                [
                    86.0066852,
                    51.9683907
                ],
                [
                    86.0068686,
                    51.9678513
                ],
                [
                    86.0073925,
                    51.967839
                ],
                [
                    86.0074065,
                    51.9680232
                ],
                [
                    86.008989,
                    51.9683097
                ],
                [
                    86.0096909,
                    51.9680034
                ],
                [
                    86.0108302,
                    51.9679181
                ],
                [
                    86.011365,
                    51.9674096
                ],
                [
                    86.0109202,
                    51.9671104
                ],
                [
                    86.0107901,
                    51.9668695
                ],
                [
                    86.0108903,
                    51.9668257
                ],
                [
                    86.0124493,
                    51.9669504
                ],
                [
                    86.0120902,
                    51.9664511
                ],
                [
                    86.0120505,
                    51.9661998
                ],
                [
                    86.0124197,
                    51.9662419
                ],
                [
                    86.0127319,
                    51.9664118
                ],
                [
                    86.0133542,
                    51.9664394
                ],
                [
                    86.0138851,
                    51.9665163
                ],
                [
                    86.0150548,
                    51.9662807
                ],
                [
                    86.0158401,
                    51.9662817
                ],
                [
                    86.016161,
                    51.9660558
                ],
                [
                    86.0166719,
                    51.9662218
                ],
                [
                    86.0196565,
                    51.9655496
                ],
                [
                    86.0212489,
                    51.9628919
                ],
                [
                    86.0221655,
                    51.9593421
                ],
                [
                    86.0256098,
                    51.9565938
                ],
                [
                    86.0297964,
                    51.9587305
                ],
                [
                    86.0365579,
                    51.9529814
                ],
                [
                    86.0369911,
                    51.9521374
                ],
                [
                    86.0375976,
                    51.9516294
                ],
                [
                    86.0363837,
                    51.9510061
                ],
                [
                    86.0362634,
                    51.9507263
                ],
                [
                    86.0369094,
                    51.9508989
                ],
                [
                    86.0375787,
                    51.9508263
                ],
                [
                    86.0375902,
                    51.9502911
                ],
                [
                    86.0368166,
                    51.9501732
                ],
                [
                    86.0369658,
                    51.9499514
                ],
                [
                    86.0376748,
                    51.9497118
                ],
                [
                    86.0372724,
                    51.9491175
                ],
                [
                    86.0377107,
                    51.9488758
                ],
                [
                    86.0386305,
                    51.9489056
                ],
                [
                    86.0387115,
                    51.9484936
                ],
                [
                    86.0393247,
                    51.9485097
                ],
                [
                    86.040679,
                    51.9476287
                ],
                [
                    86.0413259,
                    51.9477566
                ],
                [
                    86.0419577,
                    51.9477506
                ],
                [
                    86.043111,
                    51.9478269
                ],
                [
                    86.0621521,
                    51.9442776
                ],
                [
                    86.0652546,
                    51.9382579
                ],
                [
                    86.061925,
                    51.9335364
                ],
                [
                    86.0653842,
                    51.9259471
                ],
                [
                    86.0522079,
                    51.9169312
                ],
                [
                    86.0507513,
                    51.9141761
                ],
                [
                    86.0480049,
                    51.9135739
                ],
                [
                    86.0435576,
                    51.9115528
                ],
                [
                    86.0332837,
                    51.9155506
                ],
                [
                    86.0322436,
                    51.9169584
                ],
                [
                    86.0138992,
                    51.9220587
                ],
                [
                    86.0103901,
                    51.9233341
                ],
                [
                    86.0056229,
                    51.9195021
                ],
                [
                    86.0008484,
                    51.9184691
                ],
                [
                    86.0013092,
                    51.9172129
                ],
                [
                    86.0013321,
                    51.916176
                ],
                [
                    86.0023009,
                    51.9155931
                ],
                [
                    85.9979181,
                    51.9131917
                ],
                [
                    85.9913931,
                    51.9122549
                ],
                [
                    85.9898051,
                    51.9131112
                ],
                [
                    85.9868381,
                    51.9143347
                ],
                [
                    85.9867398,
                    51.9155048
                ],
                [
                    85.9856104,
                    51.9152051
                ],
                [
                    85.9855786,
                    51.9150153
                ],
                [
                    85.984575,
                    51.914739
                ],
                [
                    85.9853373,
                    51.9137195
                ],
                [
                    85.98452,
                    51.9131772
                ],
                [
                    85.9836686,
                    51.9133483
                ],
                [
                    85.9819548,
                    51.9133781
                ],
                [
                    85.9813263,
                    51.9132611
                ],
                [
                    85.9788407,
                    51.9115445
                ],
                [
                    85.9775825,
                    51.9113662
                ],
                [
                    85.9765577,
                    51.9120265
                ],
                [
                    85.9727448,
                    51.9108
                ],
                [
                    85.9676585,
                    51.9108558
                ],
                [
                    85.9626832,
                    51.9068753
                ],
                [
                    85.9547309,
                    51.9069165
                ],
                [
                    85.9546558,
                    51.9085998
                ],
                [
                    85.9507533,
                    51.9089331
                ],
                [
                    85.9507433,
                    51.9085873
                ],
                [
                    85.954696,
                    51.9064813
                ],
                [
                    85.9583379,
                    51.90493
                ],
                [
                    85.956626,
                    51.9041118
                ],
                [
                    85.9641141,
                    51.9015015
                ],
                [
                    85.9604587,
                    51.9005325
                ],
                [
                    85.9631323,
                    51.8987271
                ],
                [
                    85.9698425,
                    51.9001243
                ],
                [
                    85.9795249,
                    51.8928928
                ],
                [
                    85.9500592,
                    51.8702622
                ],
                [
                    85.9465205,
                    51.8705875
                ],
                [
                    85.9460073,
                    51.8709621
                ],
                [
                    85.9218897,
                    51.8775018
                ],
                [
                    85.9193729,
                    51.8772557
                ],
                [
                    85.9189081,
                    51.8756009
                ],
                [
                    85.9184171,
                    51.8750387
                ],
                [
                    85.9099117,
                    51.879555
                ],
                [
                    85.9090017,
                    51.8799257
                ],
                [
                    85.9071886,
                    51.8818717
                ],
                [
                    85.9058864,
                    51.8865212
                ],
                [
                    85.9059452,
                    51.8885515
                ],
                [
                    85.9050538,
                    51.8926025
                ],
                [
                    85.9013875,
                    51.8936391
                ],
                [
                    85.9020234,
                    51.9052656
                ],
                [
                    85.9054577,
                    51.91529
                ],
                [
                    85.8886926,
                    51.9194153
                ],
                [
                    85.8907355,
                    51.9243416
                ],
                [
                    85.8910913,
                    51.9274676
                ],
                [
                    85.894687,
                    51.9338358
                ],
                [
                    85.8948671,
                    51.9382538
                ],
                [
                    85.8936764,
                    51.9397147
                ],
                [
                    85.8936759,
                    51.945603
                ],
                [
                    85.8923296,
                    51.9475085
                ],
                [
                    85.8939956,
                    51.9531449
                ],
                [
                    85.8892538,
                    51.9580518
                ],
                [
                    85.8878591,
                    51.9589754
                ],
                [
                    85.8880536,
                    51.9598694
                ],
                [
                    85.88657,
                    51.9614613
                ],
                [
                    85.8854329,
                    51.9636363
                ],
                [
                    85.8839637,
                    51.967548
                ],
                [
                    85.8836963,
                    51.9674116
                ],
                [
                    85.8826328,
                    51.9695204
                ],
                [
                    85.8830932,
                    51.9698817
                ],
                [
                    85.8824805,
                    51.971281
                ],
                [
                    85.8818937,
                    51.9803533
                ]
            ],
            "longitude": 85.96418,
            "latitude": 51.957775
        },
        "5713": {
            "name": "ЧЕМАЛ",
            "population": 4011,
            "type": "town",
            "poly": null,
            "longitude": 86.003571,
            "latitude": 51.406906
        },
        "5714": {
            "name": "ОНГУДАЙ",
            "population": 5586,
            "type": "town",
            "poly": null,
            "longitude": 86.1415132,
            "latitude": 50.7454021
        },
        "5715": {
            "name": "ЧОЯ",
            "population": 1916,
            "type": "town",
            "poly": [
                [
                    86.5313053,
                    52.0188371
                ],
                [
                    86.5363448,
                    52.0199817
                ],
                [
                    86.5427556,
                    52.0208511
                ],
                [
                    86.5593202,
                    52.0217436
                ],
                [
                    86.5635949,
                    52.0139923
                ],
                [
                    86.5583278,
                    52.0092469
                ],
                [
                    86.5557325,
                    52.0041251
                ],
                [
                    86.5540531,
                    52.0015405
                ],
                [
                    86.547412,
                    51.9957597
                ],
                [
                    86.5407709,
                    51.9951956
                ],
                [
                    86.5390915,
                    52.0008825
                ],
                [
                    86.5347404,
                    52.0068975
                ],
                [
                    86.5355038,
                    52.01216
                ],
                [
                    86.5313817,
                    52.0163883
                ],
                [
                    86.5313053,
                    52.0188371
                ]
            ],
            "longitude": 86.545723,
            "latitude": 52.005322
        },
        "5716": {
            "name": "ТУРОЧАК",
            "population": 5582,
            "type": "town",
            "poly": null,
            "longitude": 87.117538,
            "latitude": 52.259956
        },
        "5717": {
            "name": "УЛАГАН",
            "population": 3516,
            "type": "town",
            "poly": null,
            "longitude": 87.956268,
            "latitude": 50.632076
        },
        "5718": {
            "name": "КОШ-АГАЧ",
            "population": 9212,
            "type": "town",
            "poly": null,
            "longitude": 88.6628218,
            "latitude": 49.9947055
        },
        "5719": {
            "name": "ДУДИНКА",
            "population": 22204,
            "type": "town",
            "poly": null,
            "longitude": 86.175072,
            "latitude": 69.406067
        },
        "5720": {
            "name": "ИГАРКА",
            "population": 5117,
            "type": "town",
            "poly": null,
            "longitude": 86.569756,
            "latitude": 67.467216
        },
        "5721": {
            "name": "ТУРУХАНСК",
            "population": 4662,
            "type": "town",
            "poly": null,
            "longitude": 87.960815,
            "latitude": 65.795441
        },
        "5722": {
            "name": "ДУБИНИНО",
            "population": 9038,
            "type": "town",
            "poly": [
                [
                    89.0458908,
                    55.6143097
                ],
                [
                    89.0462953,
                    55.6143928
                ],
                [
                    89.0473038,
                    55.6147132
                ],
                [
                    89.048005,
                    55.6151396
                ],
                [
                    89.0470464,
                    55.6163966
                ],
                [
                    89.0470596,
                    55.6165783
                ],
                [
                    89.0480838,
                    55.6170751
                ],
                [
                    89.0483202,
                    55.6170714
                ],
                [
                    89.0492525,
                    55.6174496
                ],
                [
                    89.0508873,
                    55.6179057
                ],
                [
                    89.052542,
                    55.6185286
                ],
                [
                    89.0525551,
                    55.6186472
                ],
                [
                    89.0521086,
                    55.6192071
                ],
                [
                    89.0519182,
                    55.619448
                ],
                [
                    89.0516622,
                    55.6194629
                ],
                [
                    89.0511763,
                    55.6192553
                ],
                [
                    89.0500798,
                    55.6189327
                ],
                [
                    89.049712,
                    55.6191737
                ],
                [
                    89.0492197,
                    55.6192108
                ],
                [
                    89.0488586,
                    55.6191144
                ],
                [
                    89.048609,
                    55.6191329
                ],
                [
                    89.0483858,
                    55.6192812
                ],
                [
                    89.0483399,
                    55.6195
                ],
                [
                    89.048248,
                    55.6196149
                ],
                [
                    89.0476833,
                    55.6196075
                ],
                [
                    89.0474535,
                    55.6200932
                ],
                [
                    89.0474535,
                    55.6203082
                ],
                [
                    89.0480313,
                    55.6205158
                ],
                [
                    89.0479985,
                    55.6207197
                ],
                [
                    89.0474863,
                    55.62102
                ],
                [
                    89.0489307,
                    55.6217504
                ],
                [
                    89.0490162,
                    55.6219321
                ],
                [
                    89.0512222,
                    55.6230554
                ],
                [
                    89.0538222,
                    55.6238376
                ],
                [
                    89.0544854,
                    55.6239525
                ],
                [
                    89.0550304,
                    55.624212
                ],
                [
                    89.0550041,
                    55.6245568
                ],
                [
                    89.0551157,
                    55.6247088
                ],
                [
                    89.0555031,
                    55.6247088
                ],
                [
                    89.0559102,
                    55.6243418
                ],
                [
                    89.0561137,
                    55.6243251
                ],
                [
                    89.0574089,
                    55.624412
                ],
                [
                    89.0578577,
                    55.6243903
                ],
                [
                    89.0581142,
                    55.6247161
                ],
                [
                    89.0577936,
                    55.6251143
                ],
                [
                    89.0570258,
                    55.6254549
                ],
                [
                    89.0570258,
                    55.6257098
                ],
                [
                    89.0571572,
                    55.6258256
                ],
                [
                    89.0575429,
                    55.6262982
                ],
                [
                    89.057625,
                    55.6267106
                ],
                [
                    89.057592,
                    55.6270257
                ],
                [
                    89.0582569,
                    55.6272111
                ],
                [
                    89.0582897,
                    55.6264975
                ],
                [
                    89.0584046,
                    55.6262473
                ],
                [
                    89.0587165,
                    55.6260758
                ],
                [
                    89.0589709,
                    55.6260434
                ],
                [
                    89.0593567,
                    55.6261361
                ],
                [
                    89.0597096,
                    55.626289
                ],
                [
                    89.060046,
                    55.6265114
                ],
                [
                    89.0600297,
                    55.6271508
                ],
                [
                    89.0600625,
                    55.6279663
                ],
                [
                    89.0602102,
                    55.6281146
                ],
                [
                    89.0610145,
                    55.6284529
                ],
                [
                    89.0616137,
                    55.6287587
                ],
                [
                    89.061589,
                    55.6289069
                ],
                [
                    89.0609735,
                    55.6291247
                ],
                [
                    89.0604975,
                    55.6294629
                ],
                [
                    89.0609407,
                    55.6308714
                ],
                [
                    89.0611623,
                    55.6320204
                ],
                [
                    89.0613015,
                    55.6322891
                ],
                [
                    89.0623439,
                    55.6323633
                ],
                [
                    89.0628117,
                    55.6324374
                ],
                [
                    89.0639196,
                    55.632669
                ],
                [
                    89.0642808,
                    55.6327385
                ],
                [
                    89.0645762,
                    55.632581
                ],
                [
                    89.0645926,
                    55.6323262
                ],
                [
                    89.0643957,
                    55.6321085
                ],
                [
                    89.0644941,
                    55.6318768
                ],
                [
                    89.0670384,
                    55.630422
                ],
                [
                    89.0681956,
                    55.6299262
                ],
                [
                    89.0687619,
                    55.6299262
                ],
                [
                    89.0705018,
                    55.6311726
                ],
                [
                    89.0721022,
                    55.6322289
                ],
                [
                    89.0749337,
                    55.633174
                ],
                [
                    89.0757543,
                    55.6337531
                ],
                [
                    89.0764849,
                    55.6340033
                ],
                [
                    89.0778062,
                    55.6342952
                ],
                [
                    89.0787337,
                    55.6345917
                ],
                [
                    89.0803012,
                    55.6352912
                ],
                [
                    89.0810317,
                    55.6352588
                ],
                [
                    89.0814166,
                    55.6350645
                ],
                [
                    89.0822505,
                    55.6359984
                ],
                [
                    89.0846076,
                    55.6369101
                ],
                [
                    89.0846339,
                    55.6370583
                ],
                [
                    89.0840889,
                    55.6373251
                ],
                [
                    89.0838066,
                    55.6373659
                ],
                [
                    89.0835111,
                    55.6374178
                ],
                [
                    89.0833995,
                    55.637503
                ],
                [
                    89.0843055,
                    55.6380923
                ],
                [
                    89.0845025,
                    55.6379589
                ],
                [
                    89.0851329,
                    55.6383331
                ],
                [
                    89.0861177,
                    55.6377847
                ],
                [
                    89.0857106,
                    55.6374511
                ],
                [
                    89.0887966,
                    55.6360651
                ],
                [
                    89.0894991,
                    55.6363616
                ],
                [
                    89.0908187,
                    55.6365765
                ],
                [
                    89.0923421,
                    55.6367396
                ],
                [
                    89.0929461,
                    55.6362727
                ],
                [
                    89.0932941,
                    55.6360725
                ],
                [
                    89.093629,
                    55.6357501
                ],
                [
                    89.0936881,
                    55.6354573
                ],
                [
                    89.0935108,
                    55.6350311
                ],
                [
                    89.0928214,
                    55.634301
                ],
                [
                    89.1035845,
                    55.6295671
                ],
                [
                    89.106526,
                    55.6296598
                ],
                [
                    89.1108857,
                    55.6325323
                ],
                [
                    89.1132953,
                    55.6333255
                ],
                [
                    89.1136039,
                    55.6334779
                ],
                [
                    89.1138797,
                    55.633596
                ],
                [
                    89.1162827,
                    55.6350377
                ],
                [
                    89.1211564,
                    55.6320558
                ],
                [
                    89.1200524,
                    55.6302278
                ],
                [
                    89.1117964,
                    55.624057
                ],
                [
                    89.111345,
                    55.6240477
                ],
                [
                    89.1106719,
                    55.6238345
                ],
                [
                    89.1104997,
                    55.6236492
                ],
                [
                    89.1103766,
                    55.6233202
                ],
                [
                    89.1106228,
                    55.6231163
                ],
                [
                    89.1110496,
                    55.6230653
                ],
                [
                    89.1112548,
                    55.6229494
                ],
                [
                    89.1112219,
                    55.6227687
                ],
                [
                    89.1108772,
                    55.6224536
                ],
                [
                    89.1098759,
                    55.6221385
                ],
                [
                    89.1082919,
                    55.6208826
                ],
                [
                    89.1082263,
                    55.6203589
                ],
                [
                    89.101067,
                    55.6151487
                ],
                [
                    89.1001314,
                    55.6134615
                ],
                [
                    89.0987525,
                    55.6131231
                ],
                [
                    89.0975297,
                    55.6116259
                ],
                [
                    89.0968731,
                    55.6112597
                ],
                [
                    89.0939595,
                    55.6121822
                ],
                [
                    89.0924822,
                    55.6128079
                ],
                [
                    89.0918092,
                    55.6131834
                ],
                [
                    89.0912265,
                    55.6133224
                ],
                [
                    89.0888136,
                    55.6114729
                ],
                [
                    89.0804409,
                    55.6100056
                ],
                [
                    89.0795957,
                    55.6101447
                ],
                [
                    89.0787011,
                    55.609505
                ],
                [
                    89.0776588,
                    55.6101725
                ],
                [
                    89.0766247,
                    55.6100937
                ],
                [
                    89.0704903,
                    55.6085954
                ],
                [
                    89.0641504,
                    55.6069814
                ],
                [
                    89.0638773,
                    55.6076994
                ],
                [
                    89.0700115,
                    55.6095616
                ],
                [
                    89.0699101,
                    55.6096947
                ],
                [
                    89.0721799,
                    55.6102886
                ],
                [
                    89.0742445,
                    55.610687
                ],
                [
                    89.0747831,
                    55.6109695
                ],
                [
                    89.0742702,
                    55.611672
                ],
                [
                    89.0765528,
                    55.6118314
                ],
                [
                    89.0790535,
                    55.6121356
                ],
                [
                    89.0778737,
                    55.6129323
                ],
                [
                    89.0777454,
                    55.6133234
                ],
                [
                    89.0770273,
                    55.6137579
                ],
                [
                    89.0786616,
                    55.6145835
                ],
                [
                    89.079758,
                    55.6149135
                ],
                [
                    89.0813732,
                    55.615555
                ],
                [
                    89.0786746,
                    55.6162447
                ],
                [
                    89.0779344,
                    55.6168732
                ],
                [
                    89.077337,
                    55.6167248
                ],
                [
                    89.0689866,
                    55.6138736
                ],
                [
                    89.0684298,
                    55.6138232
                ],
                [
                    89.0679676,
                    55.6140457
                ],
                [
                    89.0676419,
                    55.614019
                ],
                [
                    89.067206,
                    55.6140576
                ],
                [
                    89.0665861,
                    55.6137995
                ],
                [
                    89.0656144,
                    55.6135681
                ],
                [
                    89.0653098,
                    55.6134287
                ],
                [
                    89.0650576,
                    55.6135592
                ],
                [
                    89.0646112,
                    55.6135266
                ],
                [
                    89.0633453,
                    55.6130994
                ],
                [
                    89.062321,
                    55.6132358
                ],
                [
                    89.0611497,
                    55.6128176
                ],
                [
                    89.0587598,
                    55.6120759
                ],
                [
                    89.0555872,
                    55.6111088
                ],
                [
                    89.054232,
                    55.6107261
                ],
                [
                    89.0537172,
                    55.6107201
                ],
                [
                    89.0535964,
                    55.6107943
                ],
                [
                    89.0535807,
                    55.6110494
                ],
                [
                    89.0533653,
                    55.6111147
                ],
                [
                    89.0523673,
                    55.6111206
                ],
                [
                    89.051779,
                    55.6108714
                ],
                [
                    89.0505919,
                    55.6104086
                ],
                [
                    89.0498356,
                    55.6100734
                ],
                [
                    89.0492,
                    55.6098954
                ],
                [
                    89.0489426,
                    55.6098687
                ],
                [
                    89.0487798,
                    55.6099369
                ],
                [
                    89.0483753,
                    55.6099369
                ],
                [
                    89.0478973,
                    55.6098598
                ],
                [
                    89.0477293,
                    55.6098805
                ],
                [
                    89.0475663,
                    55.610014
                ],
                [
                    89.0480024,
                    55.6102781
                ],
                [
                    89.0482545,
                    55.6102721
                ],
                [
                    89.050177,
                    55.6109782
                ],
                [
                    89.050198,
                    55.611088
                ],
                [
                    89.0495729,
                    55.6115597
                ],
                [
                    89.0493417,
                    55.6117733
                ],
                [
                    89.0493208,
                    55.6119394
                ],
                [
                    89.0498198,
                    55.6122331
                ],
                [
                    89.0489216,
                    55.6125417
                ],
                [
                    89.0458908,
                    55.6143097
                ]
            ],
            "longitude": 89.082672,
            "latitude": 55.622734
        },
        "5723": {
            "name": "ШАРЫПОВО",
            "population": 37230,
            "type": "town",
            "poly": [
                [
                    89.1324409,
                    55.536921
                ],
                [
                    89.1325504,
                    55.5376188
                ],
                [
                    89.1329341,
                    55.5380841
                ],
                [
                    89.1335371,
                    55.5382547
                ],
                [
                    89.1350169,
                    55.5381151
                ],
                [
                    89.138242,
                    55.5455858
                ],
                [
                    89.1486602,
                    55.5440874
                ],
                [
                    89.1452752,
                    55.5474215
                ],
                [
                    89.1453103,
                    55.5482649
                ],
                [
                    89.1454791,
                    55.5482267
                ],
                [
                    89.148099,
                    55.547739
                ],
                [
                    89.1482042,
                    55.5480367
                ],
                [
                    89.145854,
                    55.549902
                ],
                [
                    89.1457137,
                    55.5504973
                ],
                [
                    89.1445385,
                    55.5510628
                ],
                [
                    89.1446788,
                    55.551668
                ],
                [
                    89.1450471,
                    55.5517672
                ],
                [
                    89.1441176,
                    55.5521442
                ],
                [
                    89.1444333,
                    55.5524022
                ],
                [
                    89.1454155,
                    55.5519359
                ],
                [
                    89.1455558,
                    55.5532256
                ],
                [
                    89.1446438,
                    55.5538407
                ],
                [
                    89.1417498,
                    55.5573525
                ],
                [
                    89.140066,
                    55.5582254
                ],
                [
                    89.1384875,
                    55.5585329
                ],
                [
                    89.1374,
                    55.558652
                ],
                [
                    89.1357163,
                    55.5586916
                ],
                [
                    89.1357865,
                    55.5589396
                ],
                [
                    89.1396451,
                    55.5623617
                ],
                [
                    89.1686326,
                    55.5618979
                ],
                [
                    89.1686289,
                    55.5621583
                ],
                [
                    89.1698403,
                    55.5619833
                ],
                [
                    89.1698241,
                    55.5618822
                ],
                [
                    89.1758279,
                    55.5616956
                ],
                [
                    89.1768628,
                    55.5616326
                ],
                [
                    89.178547,
                    55.5612919
                ],
                [
                    89.1803303,
                    55.5607449
                ],
                [
                    89.1814936,
                    55.5600407
                ],
                [
                    89.1822059,
                    55.5595026
                ],
                [
                    89.1831676,
                    55.5583788
                ],
                [
                    89.1835422,
                    55.5575166
                ],
                [
                    89.1841485,
                    55.5565487
                ],
                [
                    89.1855987,
                    55.553998
                ],
                [
                    89.1861028,
                    55.5534842
                ],
                [
                    89.1865151,
                    55.5531984
                ],
                [
                    89.1871821,
                    55.5529711
                ],
                [
                    89.1883164,
                    55.5528089
                ],
                [
                    89.1889586,
                    55.5527608
                ],
                [
                    89.1912492,
                    55.5528847
                ],
                [
                    89.1932624,
                    55.5530669
                ],
                [
                    89.197554,
                    55.5534911
                ],
                [
                    89.197584,
                    55.5532623
                ],
                [
                    89.1981177,
                    55.5533414
                ],
                [
                    89.1981029,
                    55.5528222
                ],
                [
                    89.1980155,
                    55.5496115
                ],
                [
                    89.1981383,
                    55.5492075
                ],
                [
                    89.1979509,
                    55.5490788
                ],
                [
                    89.1975484,
                    55.5490224
                ],
                [
                    89.197793,
                    55.5488557
                ],
                [
                    89.1979166,
                    55.5487798
                ],
                [
                    89.1979878,
                    55.5483881
                ],
                [
                    89.1980081,
                    55.5480445
                ],
                [
                    89.1980719,
                    55.547932
                ],
                [
                    89.1983596,
                    55.5478361
                ],
                [
                    89.1987926,
                    55.5477654
                ],
                [
                    89.1998396,
                    55.5476497
                ],
                [
                    89.2007029,
                    55.5472877
                ],
                [
                    89.2015864,
                    55.5469262
                ],
                [
                    89.2021788,
                    55.5467523
                ],
                [
                    89.2028246,
                    55.5464175
                ],
                [
                    89.2035228,
                    55.5461514
                ],
                [
                    89.202687,
                    55.5446909
                ],
                [
                    89.2027563,
                    55.5445817
                ],
                [
                    89.202764,
                    55.5445524
                ],
                [
                    89.2036426,
                    55.5446484
                ],
                [
                    89.204511,
                    55.544535
                ],
                [
                    89.2056362,
                    55.5444914
                ],
                [
                    89.2061824,
                    55.5445488
                ],
                [
                    89.2066734,
                    55.5441047
                ],
                [
                    89.2081664,
                    55.5442785
                ],
                [
                    89.2084571,
                    55.544474
                ],
                [
                    89.2087679,
                    55.5445215
                ],
                [
                    89.2092489,
                    55.5444283
                ],
                [
                    89.2096566,
                    55.5443919
                ],
                [
                    89.2098128,
                    55.5444171
                ],
                [
                    89.2099015,
                    55.5448642
                ],
                [
                    89.2110778,
                    55.545298
                ],
                [
                    89.2118752,
                    55.545153
                ],
                [
                    89.2126375,
                    55.5449095
                ],
                [
                    89.2142012,
                    55.5446413
                ],
                [
                    89.2152507,
                    55.5445867
                ],
                [
                    89.2169173,
                    55.544657
                ],
                [
                    89.2173119,
                    55.5448266
                ],
                [
                    89.2178085,
                    55.5442437
                ],
                [
                    89.2204017,
                    55.5426525
                ],
                [
                    89.2208706,
                    55.5426113
                ],
                [
                    89.2214984,
                    55.5424329
                ],
                [
                    89.2219163,
                    55.5420316
                ],
                [
                    89.2222774,
                    55.5419593
                ],
                [
                    89.2232457,
                    55.5417629
                ],
                [
                    89.2212067,
                    55.5385375
                ],
                [
                    89.222939,
                    55.5382277
                ],
                [
                    89.2221495,
                    55.5368627
                ],
                [
                    89.2229826,
                    55.5367014
                ],
                [
                    89.2228811,
                    55.5365645
                ],
                [
                    89.2260376,
                    55.5358043
                ],
                [
                    89.2252627,
                    55.5344558
                ],
                [
                    89.2206413,
                    55.5354082
                ],
                [
                    89.2207703,
                    55.5356774
                ],
                [
                    89.2206679,
                    55.5357419
                ],
                [
                    89.2209252,
                    55.5359521
                ],
                [
                    89.2208593,
                    55.5360085
                ],
                [
                    89.2211796,
                    55.5361457
                ],
                [
                    89.2218298,
                    55.5365362
                ],
                [
                    89.2212392,
                    55.5366661
                ],
                [
                    89.221346,
                    55.5368124
                ],
                [
                    89.2209514,
                    55.5368968
                ],
                [
                    89.2204778,
                    55.5362789
                ],
                [
                    89.2203711,
                    55.5359242
                ],
                [
                    89.2197777,
                    55.5355776
                ],
                [
                    89.2195436,
                    55.5344275
                ],
                [
                    89.2179267,
                    55.5315957
                ],
                [
                    89.2209029,
                    55.5309782
                ],
                [
                    89.2208571,
                    55.5309037
                ],
                [
                    89.2195217,
                    55.5287323
                ],
                [
                    89.2177205,
                    55.527747
                ],
                [
                    89.2162467,
                    55.5272829
                ],
                [
                    89.2158817,
                    55.5270931
                ],
                [
                    89.2153342,
                    55.5264242
                ],
                [
                    89.2146172,
                    55.5251895
                ],
                [
                    89.2140771,
                    55.5247507
                ],
                [
                    89.2132948,
                    55.5243602
                ],
                [
                    89.2127498,
                    55.5238648
                ],
                [
                    89.2126879,
                    55.5236606
                ],
                [
                    89.2110849,
                    55.5212931
                ],
                [
                    89.2103377,
                    55.5206124
                ],
                [
                    89.2093108,
                    55.5196372
                ],
                [
                    89.2074793,
                    55.5185891
                ],
                [
                    89.2012363,
                    55.5129587
                ],
                [
                    89.1818028,
                    55.5173526
                ],
                [
                    89.1816797,
                    55.5173858
                ],
                [
                    89.182254,
                    55.518474
                ],
                [
                    89.1725443,
                    55.5213734
                ],
                [
                    89.1702992,
                    55.5237483
                ],
                [
                    89.1686015,
                    55.524479
                ],
                [
                    89.167072,
                    55.5250827
                ],
                [
                    89.165725,
                    55.5261072
                ],
                [
                    89.1651356,
                    55.5266235
                ],
                [
                    89.1651497,
                    55.526957
                ],
                [
                    89.164799,
                    55.5267744
                ],
                [
                    89.1646306,
                    55.5264408
                ],
                [
                    89.1592986,
                    55.5250509
                ],
                [
                    89.1586953,
                    55.5257498
                ],
                [
                    89.1571237,
                    55.5260516
                ],
                [
                    89.1492674,
                    55.534083
                ],
                [
                    89.1479521,
                    55.5348739
                ],
                [
                    89.1464722,
                    55.5363472
                ],
                [
                    89.1427725,
                    55.5363162
                ],
                [
                    89.1411282,
                    55.5359905
                ],
                [
                    89.1409912,
                    55.5350135
                ],
                [
                    89.1345785,
                    55.534176
                ],
                [
                    89.1339481,
                    55.5365953
                ],
                [
                    89.1335371,
                    55.5369055
                ],
                [
                    89.1324409,
                    55.536921
                ]
            ],
            "longitude": 89.186432,
            "latitude": 55.535503
        },
        "5724": {
            "name": "ТЮХТЕТ",
            "population": 4791,
            "type": "town",
            "poly": null,
            "longitude": 89.311485,
            "latitude": 56.539837
        },
        "5725": {
            "name": "БОГОТОЛ",
            "population": 20545,
            "type": "town",
            "poly": [
                [
                    89.4027367,
                    56.1733838
                ],
                [
                    89.4083355,
                    56.1740912
                ],
                [
                    89.4102417,
                    56.1748778
                ],
                [
                    89.4098691,
                    56.1822018
                ],
                [
                    89.4142798,
                    56.2345958
                ],
                [
                    89.4111883,
                    56.2369518
                ],
                [
                    89.4100887,
                    56.2386377
                ],
                [
                    89.4105816,
                    56.2391645
                ],
                [
                    89.4111125,
                    56.2385323
                ],
                [
                    89.4179348,
                    56.2352775
                ],
                [
                    89.4209093,
                    56.2295464
                ],
                [
                    89.4196769,
                    56.22649
                ],
                [
                    89.4204353,
                    56.2228273
                ],
                [
                    89.4237531,
                    56.2209563
                ],
                [
                    89.4299622,
                    56.2189271
                ],
                [
                    89.4323321,
                    56.216687
                ],
                [
                    89.4349864,
                    56.2151583
                ],
                [
                    89.4413238,
                    56.2152493
                ],
                [
                    89.4436128,
                    56.2165815
                ],
                [
                    89.450912,
                    56.2180574
                ],
                [
                    89.4599176,
                    56.2211408
                ],
                [
                    89.4626667,
                    56.2230909
                ],
                [
                    89.4679639,
                    56.2243894
                ],
                [
                    89.4698748,
                    56.2255362
                ],
                [
                    89.4719984,
                    56.2261095
                ],
                [
                    89.4724837,
                    56.2268515
                ],
                [
                    89.4736205,
                    56.2265174
                ],
                [
                    89.5159551,
                    56.2378787
                ],
                [
                    89.5161028,
                    56.2383456
                ],
                [
                    89.521368,
                    56.2392605
                ],
                [
                    89.5241636,
                    56.239882
                ],
                [
                    89.5299403,
                    56.2405656
                ],
                [
                    89.5339396,
                    56.2413747
                ],
                [
                    89.5352583,
                    56.2418451
                ],
                [
                    89.5412712,
                    56.2505828
                ],
                [
                    89.5408565,
                    56.2555198
                ],
                [
                    89.5415082,
                    56.2566059
                ],
                [
                    89.5410366,
                    56.25763
                ],
                [
                    89.5413778,
                    56.2586831
                ],
                [
                    89.5404299,
                    56.2607471
                ],
                [
                    89.5418411,
                    56.2607936
                ],
                [
                    89.5434672,
                    56.2616967
                ],
                [
                    89.5444864,
                    56.2621819
                ],
                [
                    89.5445107,
                    56.2632871
                ],
                [
                    89.5440011,
                    56.263907
                ],
                [
                    89.543176,
                    56.2649583
                ],
                [
                    89.544268,
                    56.2658882
                ],
                [
                    89.5440011,
                    56.2663868
                ],
                [
                    89.5428848,
                    56.2666429
                ],
                [
                    89.5434633,
                    56.2683281
                ],
                [
                    89.5420604,
                    56.2704126
                ],
                [
                    89.5423509,
                    56.2708048
                ],
                [
                    89.5501084,
                    56.2754185
                ],
                [
                    89.5522225,
                    56.2767132
                ],
                [
                    89.5532463,
                    56.2779552
                ],
                [
                    89.5546113,
                    56.278734
                ],
                [
                    89.5555214,
                    56.2806075
                ],
                [
                    89.5555593,
                    56.2821441
                ],
                [
                    89.5573794,
                    56.2831123
                ],
                [
                    89.5582515,
                    56.2851328
                ],
                [
                    89.5580741,
                    56.2864494
                ],
                [
                    89.5563449,
                    56.2875943
                ],
                [
                    89.5541183,
                    56.2881424
                ],
                [
                    89.5523105,
                    56.2900692
                ],
                [
                    89.5517038,
                    56.2917695
                ],
                [
                    89.5514004,
                    56.2925776
                ],
                [
                    89.5506724,
                    56.2934024
                ],
                [
                    89.5519802,
                    56.2953464
                ],
                [
                    89.5588627,
                    56.2938233
                ],
                [
                    89.5782182,
                    56.2907496
                ],
                [
                    89.5802092,
                    56.2879417
                ],
                [
                    89.581817,
                    56.2842808
                ],
                [
                    89.5620559,
                    56.2835482
                ],
                [
                    89.5702083,
                    56.264232
                ],
                [
                    89.5668381,
                    56.2634342
                ],
                [
                    89.5640474,
                    56.2623155
                ],
                [
                    89.5641687,
                    56.2614394
                ],
                [
                    89.5645083,
                    56.2606173
                ],
                [
                    89.5655277,
                    56.259849
                ],
                [
                    89.5667838,
                    56.2594014
                ],
                [
                    89.577405,
                    56.2491631
                ],
                [
                    89.5577637,
                    56.2433136
                ],
                [
                    89.5559524,
                    56.2431006
                ],
                [
                    89.5537531,
                    56.2409303
                ],
                [
                    89.5514781,
                    56.2395396
                ],
                [
                    89.5475725,
                    56.2346085
                ],
                [
                    89.5463732,
                    56.2341496
                ],
                [
                    89.5457519,
                    56.2334504
                ],
                [
                    89.5446687,
                    56.2334351
                ],
                [
                    89.5441678,
                    56.2309814
                ],
                [
                    89.5446027,
                    56.2303858
                ],
                [
                    89.5447424,
                    56.2293498
                ],
                [
                    89.5450997,
                    56.2285728
                ],
                [
                    89.5411639,
                    56.2273497
                ],
                [
                    89.5414343,
                    56.2268546
                ],
                [
                    89.5413722,
                    56.2263366
                ],
                [
                    89.5416362,
                    56.2260344
                ],
                [
                    89.5431272,
                    56.226138
                ],
                [
                    89.5436018,
                    56.2256763
                ],
                [
                    89.5484631,
                    56.2268487
                ],
                [
                    89.5513449,
                    56.2269836
                ],
                [
                    89.55333,
                    56.2266463
                ],
                [
                    89.5555292,
                    56.2265841
                ],
                [
                    89.556312,
                    56.2262802
                ],
                [
                    89.5584365,
                    56.2265841
                ],
                [
                    89.5594555,
                    56.2264874
                ],
                [
                    89.5602507,
                    56.2267844
                ],
                [
                    89.5605363,
                    56.2272197
                ],
                [
                    89.562361,
                    56.2280951
                ],
                [
                    89.5640839,
                    56.2289585
                ],
                [
                    89.5653945,
                    56.2293767
                ],
                [
                    89.5670932,
                    56.2297949
                ],
                [
                    89.567894,
                    56.2306582
                ],
                [
                    89.5691802,
                    56.2311815
                ],
                [
                    89.5711996,
                    56.2316893
                ],
                [
                    89.5732747,
                    56.2315235
                ],
                [
                    89.5753745,
                    56.2315788
                ],
                [
                    89.5769773,
                    56.2319448
                ],
                [
                    89.5775613,
                    56.2318274
                ],
                [
                    89.5780335,
                    56.2320139
                ],
                [
                    89.5787044,
                    56.2318757
                ],
                [
                    89.5799469,
                    56.2319655
                ],
                [
                    89.5812413,
                    56.2322229
                ],
                [
                    89.582369,
                    56.2321576
                ],
                [
                    89.5824063,
                    56.2323648
                ],
                [
                    89.5837978,
                    56.2325098
                ],
                [
                    89.5844364,
                    56.2327492
                ],
                [
                    89.585612,
                    56.2329104
                ],
                [
                    89.5868669,
                    56.2335941
                ],
                [
                    89.5874508,
                    56.2337322
                ],
                [
                    89.5881591,
                    56.2342501
                ],
                [
                    89.5882222,
                    56.234597
                ],
                [
                    89.5911566,
                    56.2360318
                ],
                [
                    89.5916536,
                    56.2365411
                ],
                [
                    89.5920201,
                    56.2366859
                ],
                [
                    89.5921793,
                    56.2371555
                ],
                [
                    89.5931236,
                    56.2373212
                ],
                [
                    89.5937101,
                    56.2375643
                ],
                [
                    89.5941515,
                    56.2378583
                ],
                [
                    89.5990772,
                    56.2358244
                ],
                [
                    89.598464,
                    56.2352206
                ],
                [
                    89.598367,
                    56.2335076
                ],
                [
                    89.5984398,
                    56.2319025
                ],
                [
                    89.5992163,
                    56.2305266
                ],
                [
                    89.5988209,
                    56.2283322
                ],
                [
                    89.6361697,
                    56.2340421
                ],
                [
                    89.6405755,
                    56.2319581
                ],
                [
                    89.6387911,
                    56.2279481
                ],
                [
                    89.6166171,
                    56.224426
                ],
                [
                    89.615397,
                    56.2257641
                ],
                [
                    89.6082175,
                    56.2251824
                ],
                [
                    89.5724589,
                    56.2200244
                ],
                [
                    89.5706543,
                    56.2146886
                ],
                [
                    89.5709272,
                    56.214503
                ],
                [
                    89.5706543,
                    56.2135921
                ],
                [
                    89.5724172,
                    56.212809
                ],
                [
                    89.572171,
                    56.2124281
                ],
                [
                    89.572839,
                    56.211369
                ],
                [
                    89.5717767,
                    56.2111292
                ],
                [
                    89.5672568,
                    56.2084299
                ],
                [
                    89.5685915,
                    56.2077381
                ],
                [
                    89.56029,
                    56.2018364
                ],
                [
                    89.559622,
                    56.2020304
                ],
                [
                    89.5591405,
                    56.2024537
                ],
                [
                    89.5589697,
                    56.2030067
                ],
                [
                    89.5582708,
                    56.2031363
                ],
                [
                    89.5580172,
                    56.2034712
                ],
                [
                    89.5559317,
                    56.2035555
                ],
                [
                    89.556273,
                    56.2021424
                ],
                [
                    89.5543012,
                    56.2012143
                ],
                [
                    89.5535808,
                    56.2003916
                ],
                [
                    89.5539221,
                    56.199801
                ],
                [
                    89.5529591,
                    56.1991965
                ],
                [
                    89.5516389,
                    56.198609
                ],
                [
                    89.5488899,
                    56.198056
                ],
                [
                    89.5475852,
                    56.1972265
                ],
                [
                    89.5460533,
                    56.1967702
                ],
                [
                    89.5502499,
                    56.1918359
                ],
                [
                    89.5552388,
                    56.1921118
                ],
                [
                    89.5555864,
                    56.1909174
                ],
                [
                    89.5567755,
                    56.1898641
                ],
                [
                    89.5572185,
                    56.1888812
                ],
                [
                    89.5528027,
                    56.188424
                ],
                [
                    89.5545427,
                    56.1863431
                ],
                [
                    89.5543485,
                    56.185884
                ],
                [
                    89.5561686,
                    56.1851142
                ],
                [
                    89.5615435,
                    56.1833884
                ],
                [
                    89.5568966,
                    56.1797117
                ],
                [
                    89.5508782,
                    56.175943
                ],
                [
                    89.5452239,
                    56.1718362
                ],
                [
                    89.53989,
                    56.1685161
                ],
                [
                    89.5365487,
                    56.1692437
                ],
                [
                    89.5344908,
                    56.1699678
                ],
                [
                    89.5332871,
                    56.1707028
                ],
                [
                    89.532627,
                    56.1711892
                ],
                [
                    89.5312398,
                    56.1715997
                ],
                [
                    89.530308,
                    56.1724781
                ],
                [
                    89.529227,
                    56.1727133
                ],
                [
                    89.5266279,
                    56.1729964
                ],
                [
                    89.5253139,
                    56.173079
                ],
                [
                    89.5236831,
                    56.1735437
                ],
                [
                    89.5234501,
                    56.1743003
                ],
                [
                    89.5250226,
                    56.1760294
                ],
                [
                    89.5263234,
                    56.1788282
                ],
                [
                    89.5260322,
                    56.1808813
                ],
                [
                    89.5262145,
                    56.1817546
                ],
                [
                    89.5256127,
                    56.1827055
                ],
                [
                    89.5233218,
                    56.1837427
                ],
                [
                    89.5194972,
                    56.1846827
                ],
                [
                    89.5137056,
                    56.1853361
                ],
                [
                    89.5061015,
                    56.1877402
                ],
                [
                    89.5057908,
                    56.1883452
                ],
                [
                    89.5046066,
                    56.1884424
                ],
                [
                    89.5036359,
                    56.1892959
                ],
                [
                    89.5008474,
                    56.1897
                ],
                [
                    89.5003526,
                    56.1908653
                ],
                [
                    89.473547,
                    56.1900784
                ],
                [
                    89.4442296,
                    56.1786778
                ],
                [
                    89.4424213,
                    56.1773814
                ],
                [
                    89.4502173,
                    56.1673167
                ],
                [
                    89.436415,
                    56.160138
                ],
                [
                    89.4332906,
                    56.1596819
                ],
                [
                    89.4281853,
                    56.173398
                ],
                [
                    89.4221563,
                    56.1712076
                ],
                [
                    89.417644,
                    56.170131
                ],
                [
                    89.4133592,
                    56.1695821
                ],
                [
                    89.4044106,
                    56.1687799
                ],
                [
                    89.4040693,
                    56.1703421
                ],
                [
                    89.4027367,
                    56.1733838
                ]
            ],
            "longitude": 89.531639,
            "latitude": 56.211464
        },
        "5726": {
            "name": "СОЛНЕЧНЫЙ",
            "population": 9958,
            "type": "town",
            "poly": [
                [
                    89.8083633,
                    55.2885624
                ],
                [
                    89.8100514,
                    55.2884301
                ],
                [
                    89.8115025,
                    55.2887498
                ],
                [
                    89.8124529,
                    55.2889169
                ],
                [
                    89.8159219,
                    55.289349
                ],
                [
                    89.8203665,
                    55.2904601
                ],
                [
                    89.8214816,
                    55.2904866
                ],
                [
                    89.8258325,
                    55.2912954
                ],
                [
                    89.8263194,
                    55.290208
                ],
                [
                    89.8280785,
                    55.2905654
                ],
                [
                    89.8278071,
                    55.2910069
                ],
                [
                    89.828504,
                    55.2911383
                ],
                [
                    89.8289062,
                    55.290723
                ],
                [
                    89.8326697,
                    55.2914192
                ],
                [
                    89.8331391,
                    55.290573
                ],
                [
                    89.8349859,
                    55.2908217
                ],
                [
                    89.8351253,
                    55.2906012
                ],
                [
                    89.8360855,
                    55.2907423
                ],
                [
                    89.8375541,
                    55.2873869
                ],
                [
                    89.8455575,
                    55.2689673
                ],
                [
                    89.8447393,
                    55.2686276
                ],
                [
                    89.844097,
                    55.2685902
                ],
                [
                    89.8430959,
                    55.2684736
                ],
                [
                    89.8421517,
                    55.2684087
                ],
                [
                    89.8414578,
                    55.2684476
                ],
                [
                    89.8410483,
                    55.2689078
                ],
                [
                    89.8399676,
                    55.2717594
                ],
                [
                    89.8397401,
                    55.2721158
                ],
                [
                    89.8395126,
                    55.2722389
                ],
                [
                    89.838284,
                    55.2723037
                ],
                [
                    89.8355993,
                    55.2721417
                ],
                [
                    89.8353318,
                    55.2721386
                ],
                [
                    89.8348872,
                    55.272725
                ],
                [
                    89.8342569,
                    55.273603
                ],
                [
                    89.833836,
                    55.2742155
                ],
                [
                    89.8328463,
                    55.2754726
                ],
                [
                    89.8325361,
                    55.2759591
                ],
                [
                    89.832223,
                    55.2765651
                ],
                [
                    89.8297386,
                    55.2762525
                ],
                [
                    89.827955,
                    55.2757509
                ],
                [
                    89.8228135,
                    55.2743395
                ],
                [
                    89.8195923,
                    55.2736249
                ],
                [
                    89.8151011,
                    55.2773741
                ],
                [
                    89.8084098,
                    55.2806864
                ],
                [
                    89.8093545,
                    55.2810128
                ],
                [
                    89.8109961,
                    55.2812333
                ],
                [
                    89.8105469,
                    55.2819301
                ],
                [
                    89.8104076,
                    55.2828827
                ],
                [
                    89.8098191,
                    55.2840998
                ],
                [
                    89.810516,
                    55.2860313
                ],
                [
                    89.8101907,
                    55.2864635
                ],
                [
                    89.8092151,
                    55.2865958
                ],
                [
                    89.8084717,
                    55.2868956
                ],
                [
                    89.8083633,
                    55.2885624
                ]
            ],
            "longitude": 89.825737,
            "latitude": 55.283451
        },
        "5727": {
            "name": "УЖУР",
            "population": 15538,
            "type": "town",
            "poly": [
                [
                    89.7713226,
                    55.3108081
                ],
                [
                    89.7741028,
                    55.314079
                ],
                [
                    89.7752872,
                    55.3150084
                ],
                [
                    89.7762472,
                    55.3154199
                ],
                [
                    89.777469,
                    55.3145756
                ],
                [
                    89.7779926,
                    55.3143415
                ],
                [
                    89.7800747,
                    55.3142918
                ],
                [
                    89.7890761,
                    55.313412
                ],
                [
                    89.7973273,
                    55.3200468
                ],
                [
                    89.7976963,
                    55.3207278
                ],
                [
                    89.8022843,
                    55.3235879
                ],
                [
                    89.8033016,
                    55.3252505
                ],
                [
                    89.8043788,
                    55.326652
                ],
                [
                    89.8051567,
                    55.3272421
                ],
                [
                    89.8044885,
                    55.3274747
                ],
                [
                    89.802835,
                    55.3284742
                ],
                [
                    89.7998669,
                    55.3303589
                ],
                [
                    89.7993785,
                    55.3306351
                ],
                [
                    89.8013686,
                    55.3327496
                ],
                [
                    89.8020197,
                    55.3333741
                ],
                [
                    89.8022613,
                    55.3340045
                ],
                [
                    89.8027443,
                    55.3343077
                ],
                [
                    89.8031257,
                    55.3344203
                ],
                [
                    89.804522,
                    55.3346548
                ],
                [
                    89.8058114,
                    55.3348446
                ],
                [
                    89.8119202,
                    55.3379051
                ],
                [
                    89.8121627,
                    55.3377853
                ],
                [
                    89.8125521,
                    55.3376945
                ],
                [
                    89.8129032,
                    55.3378252
                ],
                [
                    89.8131266,
                    55.3378107
                ],
                [
                    89.8132798,
                    55.3376038
                ],
                [
                    89.8140139,
                    55.3372371
                ],
                [
                    89.8142501,
                    55.3369394
                ],
                [
                    89.8150926,
                    55.3368813
                ],
                [
                    89.8154501,
                    55.336609
                ],
                [
                    89.816082,
                    55.3365873
                ],
                [
                    89.8164778,
                    55.336275
                ],
                [
                    89.8166948,
                    55.3361153
                ],
                [
                    89.8165544,
                    55.3358321
                ],
                [
                    89.8167076,
                    55.3356978
                ],
                [
                    89.8181032,
                    55.3360683
                ],
                [
                    89.8187265,
                    55.3361835
                ],
                [
                    89.8191317,
                    55.3355099
                ],
                [
                    89.8194746,
                    55.3353946
                ],
                [
                    89.8196148,
                    55.3357492
                ],
                [
                    89.8198741,
                    55.3357774
                ],
                [
                    89.8202315,
                    55.3356976
                ],
                [
                    89.82034,
                    55.3357738
                ],
                [
                    89.8204422,
                    55.3361332
                ],
                [
                    89.8207677,
                    55.3363148
                ],
                [
                    89.8208699,
                    55.3362567
                ],
                [
                    89.8209,
                    55.33613
                ],
                [
                    89.8209337,
                    55.3359735
                ],
                [
                    89.8211762,
                    55.3359009
                ],
                [
                    89.821438,
                    55.3360461
                ],
                [
                    89.8218337,
                    55.3360207
                ],
                [
                    89.8223572,
                    55.3355269
                ],
                [
                    89.8226891,
                    55.3356249
                ],
                [
                    89.8233338,
                    55.3354797
                ],
                [
                    89.8236449,
                    55.3353515
                ],
                [
                    89.8239744,
                    55.3353352
                ],
                [
                    89.8242541,
                    55.335182
                ],
                [
                    89.8246394,
                    55.3347613
                ],
                [
                    89.8246655,
                    55.3344713
                ],
                [
                    89.8242432,
                    55.334084
                ],
                [
                    89.8240511,
                    55.3340103
                ],
                [
                    89.8238615,
                    55.3341051
                ],
                [
                    89.823879,
                    55.3343061
                ],
                [
                    89.8235955,
                    55.3343911
                ],
                [
                    89.8232438,
                    55.3345252
                ],
                [
                    89.8229134,
                    55.3344849
                ],
                [
                    89.8226074,
                    55.3343438
                ],
                [
                    89.8225804,
                    55.3341219
                ],
                [
                    89.822734,
                    55.333869
                ],
                [
                    89.8225314,
                    55.333514
                ],
                [
                    89.8224987,
                    55.3331812
                ],
                [
                    89.8223026,
                    55.3330939
                ],
                [
                    89.8223876,
                    55.3329674
                ],
                [
                    89.8227928,
                    55.3328336
                ],
                [
                    89.8229105,
                    55.3326626
                ],
                [
                    89.8227634,
                    55.3323837
                ],
                [
                    89.8228092,
                    55.3322554
                ],
                [
                    89.8230412,
                    55.3321997
                ],
                [
                    89.8234072,
                    55.3322052
                ],
                [
                    89.8235968,
                    55.3321327
                ],
                [
                    89.8235972,
                    55.3318673
                ],
                [
                    89.8241786,
                    55.3315527
                ],
                [
                    89.8245021,
                    55.3315267
                ],
                [
                    89.8251296,
                    55.3316475
                ],
                [
                    89.8250969,
                    55.3318743
                ],
                [
                    89.8252538,
                    55.3323967
                ],
                [
                    89.8253486,
                    55.3328336
                ],
                [
                    89.8260088,
                    55.3329172
                ],
                [
                    89.8262851,
                    55.3331034
                ],
                [
                    89.8261469,
                    55.3332717
                ],
                [
                    89.8257534,
                    55.3334344
                ],
                [
                    89.8256746,
                    55.3335867
                ],
                [
                    89.825744,
                    55.3338449
                ],
                [
                    89.8263389,
                    55.3340178
                ],
                [
                    89.8270179,
                    55.3339754
                ],
                [
                    89.8273153,
                    55.3338229
                ],
                [
                    89.8277663,
                    55.3338638
                ],
                [
                    89.8285188,
                    55.3342036
                ],
                [
                    89.8285939,
                    55.334317
                ],
                [
                    89.828839,
                    55.3343635
                ],
                [
                    89.8291218,
                    55.3342616
                ],
                [
                    89.8298114,
                    55.3339995
                ],
                [
                    89.8300859,
                    55.3338211
                ],
                [
                    89.8302265,
                    55.3335292
                ],
                [
                    89.8305304,
                    55.3332262
                ],
                [
                    89.8306775,
                    55.3326964
                ],
                [
                    89.8307265,
                    55.3323841
                ],
                [
                    89.8305467,
                    55.3322168
                ],
                [
                    89.8303964,
                    55.3320903
                ],
                [
                    89.8303506,
                    55.3317799
                ],
                [
                    89.8305304,
                    55.3316795
                ],
                [
                    89.8310697,
                    55.3315791
                ],
                [
                    89.8313475,
                    55.3314099
                ],
                [
                    89.8311856,
                    55.3310511
                ],
                [
                    89.831171,
                    55.3308373
                ],
                [
                    89.830769,
                    55.3307778
                ],
                [
                    89.8299794,
                    55.3306015
                ],
                [
                    89.8299827,
                    55.3304676
                ],
                [
                    89.8301984,
                    55.3303244
                ],
                [
                    89.8309081,
                    55.3301109
                ],
                [
                    89.8315303,
                    55.3298615
                ],
                [
                    89.8318867,
                    55.3298185
                ],
                [
                    89.8322495,
                    55.3299022
                ],
                [
                    89.8327142,
                    55.3297646
                ],
                [
                    89.8329568,
                    55.32983
                ],
                [
                    89.8333079,
                    55.329692
                ],
                [
                    89.8333909,
                    55.329387
                ],
                [
                    89.8331547,
                    55.3289331
                ],
                [
                    89.8332313,
                    55.3286244
                ],
                [
                    89.833627,
                    55.3285736
                ],
                [
                    89.8335951,
                    55.3284247
                ],
                [
                    89.833244,
                    55.3283194
                ],
                [
                    89.8328132,
                    55.3282486
                ],
                [
                    89.8324185,
                    55.328096
                ],
                [
                    89.8321622,
                    55.327851
                ],
                [
                    89.8314759,
                    55.3278764
                ],
                [
                    89.830761,
                    55.3279309
                ],
                [
                    89.8301801,
                    55.3277747
                ],
                [
                    89.8299056,
                    55.3276367
                ],
                [
                    89.8299503,
                    55.327437
                ],
                [
                    89.8305056,
                    55.3271029
                ],
                [
                    89.8308886,
                    55.3270303
                ],
                [
                    89.8312716,
                    55.3267652
                ],
                [
                    89.8320759,
                    55.3268161
                ],
                [
                    89.8324206,
                    55.3267325
                ],
                [
                    89.8325578,
                    55.326747
                ],
                [
                    89.8335504,
                    55.3263948
                ],
                [
                    89.8352734,
                    55.3278893
                ],
                [
                    89.8359308,
                    55.3286627
                ],
                [
                    89.8365117,
                    55.3285611
                ],
                [
                    89.8366777,
                    55.3297884
                ],
                [
                    89.8365245,
                    55.3311101
                ],
                [
                    89.8358479,
                    55.3321086
                ],
                [
                    89.8349478,
                    55.3330236
                ],
                [
                    89.8349223,
                    55.3333359
                ],
                [
                    89.8341244,
                    55.333797
                ],
                [
                    89.833952,
                    55.3341274
                ],
                [
                    89.8341308,
                    55.334534
                ],
                [
                    89.8332882,
                    55.3354017
                ],
                [
                    89.8362372,
                    55.3349479
                ],
                [
                    89.8438333,
                    55.3336663
                ],
                [
                    89.8459909,
                    55.3332741
                ],
                [
                    89.8514996,
                    55.3326823
                ],
                [
                    89.8551062,
                    55.3323446
                ],
                [
                    89.8591085,
                    55.3319924
                ],
                [
                    89.8604553,
                    55.3319162
                ],
                [
                    89.8615277,
                    55.3317673
                ],
                [
                    89.8619299,
                    55.3318036
                ],
                [
                    89.8624597,
                    55.3319416
                ],
                [
                    89.8636725,
                    55.3325407
                ],
                [
                    89.8643236,
                    55.3327876
                ],
                [
                    89.8649311,
                    55.3332393
                ],
                [
                    89.8657098,
                    55.3335951
                ],
                [
                    89.8665269,
                    55.3338928
                ],
                [
                    89.8669227,
                    55.3339183
                ],
                [
                    89.8673184,
                    55.3337186
                ],
                [
                    89.8681993,
                    55.3332102
                ],
                [
                    89.8686525,
                    55.3327092
                ],
                [
                    89.8692589,
                    55.3316889
                ],
                [
                    89.8701079,
                    55.331678
                ],
                [
                    89.871608,
                    55.3318995
                ],
                [
                    89.8723612,
                    55.3319068
                ],
                [
                    89.8728463,
                    55.3318305
                ],
                [
                    89.872407,
                    55.3287277
                ],
                [
                    89.8721787,
                    55.3270949
                ],
                [
                    89.8718389,
                    55.3246642
                ],
                [
                    89.8712772,
                    55.3209089
                ],
                [
                    89.8711802,
                    55.3208062
                ],
                [
                    89.8712798,
                    55.3207808
                ],
                [
                    89.8715764,
                    55.3207295
                ],
                [
                    89.8734516,
                    55.3200926
                ],
                [
                    89.8739663,
                    55.3203343
                ],
                [
                    89.8744239,
                    55.3201391
                ],
                [
                    89.8752941,
                    55.3201856
                ],
                [
                    89.8781252,
                    55.3209364
                ],
                [
                    89.8787584,
                    55.3211735
                ],
                [
                    89.8795959,
                    55.3206133
                ],
                [
                    89.8800575,
                    55.320504
                ],
                [
                    89.8812831,
                    55.3204552
                ],
                [
                    89.8823698,
                    55.3202646
                ],
                [
                    89.8825577,
                    55.3204738
                ],
                [
                    89.8854297,
                    55.3205087
                ],
                [
                    89.8874274,
                    55.3191163
                ],
                [
                    89.8882077,
                    55.3185421
                ],
                [
                    89.888514,
                    55.3179284
                ],
                [
                    89.888367,
                    55.3165546
                ],
                [
                    89.8878155,
                    55.3161477
                ],
                [
                    89.8875377,
                    55.3156526
                ],
                [
                    89.8874076,
                    55.3155692
                ],
                [
                    89.886884,
                    55.3152667
                ],
                [
                    89.8855604,
                    55.314167
                ],
                [
                    89.8850007,
                    55.3137602
                ],
                [
                    89.8768546,
                    55.3101867
                ],
                [
                    89.8674544,
                    55.306285
                ],
                [
                    89.8662411,
                    55.3056246
                ],
                [
                    89.8656078,
                    55.3049456
                ],
                [
                    89.8655506,
                    55.3031574
                ],
                [
                    89.8655385,
                    55.3018403
                ],
                [
                    89.8653853,
                    55.3011499
                ],
                [
                    89.8642874,
                    55.3006702
                ],
                [
                    89.8617915,
                    55.299849
                ],
                [
                    89.8625599,
                    55.29854
                ],
                [
                    89.8626158,
                    55.2978177
                ],
                [
                    89.8627355,
                    55.2975179
                ],
                [
                    89.8630467,
                    55.2973771
                ],
                [
                    89.8632736,
                    55.2940179
                ],
                [
                    89.863521,
                    55.2939906
                ],
                [
                    89.8640955,
                    55.2938816
                ],
                [
                    89.8656993,
                    55.2939316
                ],
                [
                    89.8659626,
                    55.2940633
                ],
                [
                    89.8666488,
                    55.2939406
                ],
                [
                    89.8670133,
                    55.2939528
                ],
                [
                    89.8672414,
                    55.2940657
                ],
                [
                    89.8677978,
                    55.2941224
                ],
                [
                    89.8683164,
                    55.2941224
                ],
                [
                    89.8692101,
                    55.2940451
                ],
                [
                    89.8653562,
                    55.2911547
                ],
                [
                    89.8660583,
                    55.2910684
                ],
                [
                    89.866194,
                    55.2906867
                ],
                [
                    89.8660743,
                    55.2904777
                ],
                [
                    89.8652684,
                    55.2900279
                ],
                [
                    89.8648535,
                    55.2899825
                ],
                [
                    89.8644625,
                    55.2895827
                ],
                [
                    89.8640476,
                    55.28941
                ],
                [
                    89.863146,
                    55.2894873
                ],
                [
                    89.8612868,
                    55.2894191
                ],
                [
                    89.860832,
                    55.2893101
                ],
                [
                    89.8607682,
                    55.2892601
                ],
                [
                    89.8610953,
                    55.2880697
                ],
                [
                    89.860457,
                    55.2875744
                ],
                [
                    89.8542972,
                    55.2863021
                ],
                [
                    89.8423746,
                    55.2823756
                ],
                [
                    89.8420315,
                    55.2821257
                ],
                [
                    89.8408985,
                    55.2820121
                ],
                [
                    89.8386467,
                    55.2874694
                ],
                [
                    89.8375541,
                    55.2873869
                ],
                [
                    89.8360855,
                    55.2907423
                ],
                [
                    89.8351253,
                    55.2906012
                ],
                [
                    89.8349859,
                    55.2908217
                ],
                [
                    89.8331391,
                    55.290573
                ],
                [
                    89.8326697,
                    55.2914192
                ],
                [
                    89.8289062,
                    55.290723
                ],
                [
                    89.828504,
                    55.2911383
                ],
                [
                    89.8278071,
                    55.2910069
                ],
                [
                    89.8280785,
                    55.2905654
                ],
                [
                    89.8263194,
                    55.290208
                ],
                [
                    89.8259108,
                    55.2913331
                ],
                [
                    89.8214816,
                    55.2904866
                ],
                [
                    89.8203665,
                    55.2904601
                ],
                [
                    89.8159219,
                    55.289349
                ],
                [
                    89.8124529,
                    55.2889169
                ],
                [
                    89.8115025,
                    55.2887498
                ],
                [
                    89.8113491,
                    55.2892535
                ],
                [
                    89.8095777,
                    55.2891094
                ],
                [
                    89.811412,
                    55.2910642
                ],
                [
                    89.810367,
                    55.2927186
                ],
                [
                    89.8099,
                    55.2941704
                ],
                [
                    89.8092037,
                    55.2940622
                ],
                [
                    89.8088143,
                    55.2944595
                ],
                [
                    89.8073722,
                    55.2947874
                ],
                [
                    89.8066818,
                    55.2954364
                ],
                [
                    89.8059342,
                    55.2952038
                ],
                [
                    89.8033466,
                    55.2944321
                ],
                [
                    89.8025986,
                    55.2946096
                ],
                [
                    89.8018131,
                    55.2945031
                ],
                [
                    89.8012147,
                    55.2945599
                ],
                [
                    89.7983971,
                    55.2953123
                ],
                [
                    89.7973872,
                    55.2958944
                ],
                [
                    89.7918767,
                    55.2973707
                ],
                [
                    89.7876253,
                    55.2999117
                ],
                [
                    89.7713226,
                    55.3108081
                ]
            ],
            "longitude": 89.831192,
            "latitude": 55.30901
        },
        "5728": {
            "name": "НАЗАРОВО",
            "population": 51069,
            "type": "town",
            "poly": [
                [
                    90.2634482,
                    56.0559693
                ],
                [
                    90.2714404,
                    56.0591445
                ],
                [
                    90.2706929,
                    56.0606551
                ],
                [
                    90.2747197,
                    56.0622946
                ],
                [
                    90.2729176,
                    56.0643666
                ],
                [
                    90.2718627,
                    56.0641031
                ],
                [
                    90.2641178,
                    56.0674194
                ],
                [
                    90.2712388,
                    56.068714
                ],
                [
                    90.2827749,
                    56.0688192
                ],
                [
                    90.2988422,
                    56.0689345
                ],
                [
                    90.3029628,
                    56.067966
                ],
                [
                    90.3127654,
                    56.067506
                ],
                [
                    90.3159533,
                    56.0677934
                ],
                [
                    90.3204701,
                    56.0679647
                ],
                [
                    90.3236812,
                    56.0677538
                ],
                [
                    90.3271946,
                    56.0671844
                ],
                [
                    90.3316651,
                    56.065665
                ],
                [
                    90.3329458,
                    56.0656416
                ],
                [
                    90.334075,
                    56.0654163
                ],
                [
                    90.3384902,
                    56.0653708
                ],
                [
                    90.3512532,
                    56.0658129
                ],
                [
                    90.3542405,
                    56.0664628
                ],
                [
                    90.3667529,
                    56.0610847
                ],
                [
                    90.3759528,
                    56.0630586
                ],
                [
                    90.3857887,
                    56.0698062
                ],
                [
                    90.3880995,
                    56.0725182
                ],
                [
                    90.3953283,
                    56.0744032
                ],
                [
                    90.4061714,
                    56.0759574
                ],
                [
                    90.40866,
                    56.0800577
                ],
                [
                    90.4101413,
                    56.0819093
                ],
                [
                    90.4118004,
                    56.0809174
                ],
                [
                    90.429102,
                    56.0786689
                ],
                [
                    90.4276207,
                    56.077214
                ],
                [
                    90.4298723,
                    56.0763873
                ],
                [
                    90.4309389,
                    56.0751969
                ],
                [
                    90.4298723,
                    56.0739402
                ],
                [
                    90.4190884,
                    56.0748331
                ],
                [
                    90.4112671,
                    56.0744363
                ],
                [
                    90.4069417,
                    56.071063
                ],
                [
                    90.4032681,
                    56.0729481
                ],
                [
                    90.4031032,
                    56.0720094
                ],
                [
                    90.4030665,
                    56.0711811
                ],
                [
                    90.404522,
                    56.0675349
                ],
                [
                    90.4137703,
                    56.0596651
                ],
                [
                    90.4261692,
                    56.0594228
                ],
                [
                    90.4226866,
                    56.0550533
                ],
                [
                    90.4279007,
                    56.0467593
                ],
                [
                    90.4317737,
                    56.0459766
                ],
                [
                    90.4338436,
                    56.0434969
                ],
                [
                    90.4450982,
                    56.0388437
                ],
                [
                    90.4438672,
                    56.0418603
                ],
                [
                    90.450238,
                    56.0462999
                ],
                [
                    90.4586414,
                    56.0459441
                ],
                [
                    90.4599156,
                    56.0428432
                ],
                [
                    90.4593392,
                    56.0389964
                ],
                [
                    90.4618268,
                    56.0336237
                ],
                [
                    90.4652033,
                    56.0306632
                ],
                [
                    90.461769,
                    56.0276058
                ],
                [
                    90.4614908,
                    56.0262068
                ],
                [
                    90.4576892,
                    56.0216727
                ],
                [
                    90.4524967,
                    56.0191334
                ],
                [
                    90.4555523,
                    56.0169427
                ],
                [
                    90.4601463,
                    56.0182006
                ],
                [
                    90.463438,
                    56.0187189
                ],
                [
                    90.4669151,
                    56.0185116
                ],
                [
                    90.4680741,
                    56.019574
                ],
                [
                    90.4696504,
                    56.0206881
                ],
                [
                    90.4713194,
                    56.0207141
                ],
                [
                    90.472942,
                    56.0194703
                ],
                [
                    90.4741474,
                    56.0184856
                ],
                [
                    90.4735447,
                    56.0175787
                ],
                [
                    90.4770218,
                    56.0157907
                ],
                [
                    90.4870358,
                    56.0138989
                ],
                [
                    90.4968644,
                    56.0137693
                ],
                [
                    90.5007124,
                    56.0122662
                ],
                [
                    90.5057658,
                    56.0108407
                ],
                [
                    90.5085474,
                    56.0093893
                ],
                [
                    90.5096137,
                    56.0073676
                ],
                [
                    90.5115516,
                    56.0049872
                ],
                [
                    90.5030305,
                    56.0064863
                ],
                [
                    90.5005733,
                    56.0057864
                ],
                [
                    90.4995534,
                    56.0043089
                ],
                [
                    90.496818,
                    56.0027536
                ],
                [
                    90.4899102,
                    56.0010685
                ],
                [
                    90.4828633,
                    56.0009908
                ],
                [
                    90.4800816,
                    56.00125
                ],
                [
                    90.4785517,
                    56.0007834
                ],
                [
                    90.477949,
                    55.9998501
                ],
                [
                    90.4776245,
                    55.9986057
                ],
                [
                    90.4773,
                    55.9900492
                ],
                [
                    90.4614721,
                    55.9900018
                ],
                [
                    90.4697116,
                    55.9688316
                ],
                [
                    90.4789253,
                    55.9705368
                ],
                [
                    90.4788281,
                    55.9716144
                ],
                [
                    90.4803081,
                    55.972199
                ],
                [
                    90.4814109,
                    55.9715169
                ],
                [
                    90.4998094,
                    55.9759501
                ],
                [
                    90.5009702,
                    55.97608
                ],
                [
                    90.5022181,
                    55.9754467
                ],
                [
                    90.5029435,
                    55.975463
                ],
                [
                    90.5052651,
                    55.9762099
                ],
                [
                    90.5066291,
                    55.974375
                ],
                [
                    90.5101985,
                    55.9755442
                ],
                [
                    90.5107789,
                    55.9750083
                ],
                [
                    90.5117365,
                    55.9750895
                ],
                [
                    90.5116785,
                    55.9745374
                ],
                [
                    90.5088346,
                    55.9744075
                ],
                [
                    90.5090087,
                    55.9737255
                ],
                [
                    90.5110981,
                    55.9738067
                ],
                [
                    90.5121428,
                    55.9733682
                ],
                [
                    90.5122299,
                    55.9721503
                ],
                [
                    90.5130424,
                    55.971793
                ],
                [
                    90.5129554,
                    55.971111
                ],
                [
                    90.5116205,
                    55.9705588
                ],
                [
                    90.5118816,
                    55.9689185
                ],
                [
                    90.5132456,
                    55.9689672
                ],
                [
                    90.5133036,
                    55.9683501
                ],
                [
                    90.4995192,
                    55.9675543
                ],
                [
                    90.4872729,
                    55.9690647
                ],
                [
                    90.4858799,
                    55.9687561
                ],
                [
                    90.4855317,
                    55.9690972
                ],
                [
                    90.4825426,
                    55.9688373
                ],
                [
                    90.4811381,
                    55.9680804
                ],
                [
                    90.4691312,
                    55.967715
                ],
                [
                    90.4674625,
                    55.9669638
                ],
                [
                    90.4591556,
                    55.9668217
                ],
                [
                    90.4575233,
                    55.9654412
                ],
                [
                    90.4587929,
                    55.9651366
                ],
                [
                    90.4606429,
                    55.9639387
                ],
                [
                    90.4609331,
                    55.9627611
                ],
                [
                    90.4603527,
                    55.9616647
                ],
                [
                    90.4586115,
                    55.9607104
                ],
                [
                    90.4480918,
                    55.9575223
                ],
                [
                    90.4439202,
                    55.9552885
                ],
                [
                    90.4389506,
                    55.9531358
                ],
                [
                    90.4316594,
                    55.9578878
                ],
                [
                    90.448636,
                    55.9647509
                ],
                [
                    90.4516105,
                    55.9686692
                ],
                [
                    90.4515017,
                    55.9698872
                ],
                [
                    90.4503046,
                    55.9715924
                ],
                [
                    90.4504134,
                    55.9725668
                ],
                [
                    90.4488536,
                    55.9754288
                ],
                [
                    90.4490713,
                    55.9785139
                ],
                [
                    90.4483458,
                    55.9791025
                ],
                [
                    90.4474026,
                    55.982512
                ],
                [
                    90.4479426,
                    55.9840535
                ],
                [
                    90.424141,
                    55.9847029
                ],
                [
                    90.4158533,
                    55.9896881
                ],
                [
                    90.4075083,
                    55.9942746
                ],
                [
                    90.4003847,
                    55.9926568
                ],
                [
                    90.3928633,
                    55.9914344
                ],
                [
                    90.3896234,
                    55.9931868
                ],
                [
                    90.3859663,
                    55.9951648
                ],
                [
                    90.3846039,
                    55.9956728
                ],
                [
                    90.383128,
                    55.9956093
                ],
                [
                    90.376004,
                    55.9922758
                ],
                [
                    90.3715763,
                    55.9904819
                ],
                [
                    90.3703842,
                    55.9903867
                ],
                [
                    90.3582824,
                    55.9852281
                ],
                [
                    90.3559658,
                    55.9847188
                ],
                [
                    90.353752,
                    55.9849252
                ],
                [
                    90.3523612,
                    55.985592
                ],
                [
                    90.3513962,
                    55.9870051
                ],
                [
                    90.3514246,
                    55.9879894
                ],
                [
                    90.3528154,
                    55.989069
                ],
                [
                    90.3472516,
                    55.9930106
                ],
                [
                    90.3487824,
                    55.9977892
                ],
                [
                    90.3546119,
                    55.9991476
                ],
                [
                    90.3531545,
                    56.0021745
                ],
                [
                    90.3514195,
                    56.0035715
                ],
                [
                    90.3541608,
                    56.0110793
                ],
                [
                    90.3646198,
                    56.0190049
                ],
                [
                    90.3411594,
                    56.0260958
                ],
                [
                    90.3210167,
                    56.0218521
                ],
                [
                    90.3120605,
                    56.0211092
                ],
                [
                    90.3161033,
                    56.0226791
                ],
                [
                    90.3124968,
                    56.0242776
                ],
                [
                    90.3124612,
                    56.0260945
                ],
                [
                    90.3092278,
                    56.0264718
                ],
                [
                    90.3091745,
                    56.0273454
                ],
                [
                    90.3100915,
                    56.0280536
                ],
                [
                    90.3027385,
                    56.0322564
                ],
                [
                    90.3022943,
                    56.0328613
                ],
                [
                    90.3047693,
                    56.0325369
                ],
                [
                    90.3042176,
                    56.0329374
                ],
                [
                    90.3046063,
                    56.0339145
                ],
                [
                    90.3052379,
                    56.0349778
                ],
                [
                    90.3026353,
                    56.0343488
                ],
                [
                    90.2999427,
                    56.0348141
                ],
                [
                    90.2967503,
                    56.0369387
                ],
                [
                    90.2932804,
                    56.0407846
                ],
                [
                    90.2920312,
                    56.0409396
                ],
                [
                    90.2909957,
                    56.0419325
                ],
                [
                    90.2903934,
                    56.0426143
                ],
                [
                    90.2864793,
                    56.0426453
                ],
                [
                    90.2867013,
                    56.0423352
                ],
                [
                    90.2825566,
                    56.0426681
                ],
                [
                    90.280511,
                    56.0441494
                ],
                [
                    90.2774852,
                    56.0478704
                ],
                [
                    90.2767274,
                    56.0504017
                ],
                [
                    90.2761701,
                    56.0510483
                ],
                [
                    90.2758814,
                    56.0517056
                ],
                [
                    90.2753484,
                    56.0520405
                ],
                [
                    90.274238,
                    56.0521893
                ],
                [
                    90.2706404,
                    56.0525117
                ],
                [
                    90.269419,
                    56.0529706
                ],
                [
                    90.2634482,
                    56.0559693
                ]
            ],
            "longitude": 90.418503,
            "latitude": 56.011593
        },
        "5729": {
            "name": "НОВОБИРИЛЮССЫ",
            "population": 4141,
            "type": "town",
            "poly": null,
            "longitude": 90.685806,
            "latitude": 56.95171
        },
        "5730": {
            "name": "НОВОСЕЛОВО",
            "population": 5751,
            "type": "town",
            "poly": null,
            "longitude": 90.967201,
            "latitude": 55.005177
        },
        "5731": {
            "name": "КОЗУЛЬКА",
            "population": 7905,
            "type": "town",
            "poly": null,
            "longitude": 91.391975,
            "latitude": 56.165138
        },
        "5732": {
            "name": "КРАСНОТУРАНСК",
            "population": 5543,
            "type": "town",
            "poly": null,
            "longitude": 91.567825,
            "latitude": 54.316296
        },
        "5733": {
            "name": "БАЛАХТА",
            "population": 6699,
            "type": "town",
            "poly": [
                [
                    91.5723536,
                    55.4064482
                ],
                [
                    91.5731069,
                    55.4070482
                ],
                [
                    91.5742266,
                    55.4073571
                ],
                [
                    91.5762668,
                    55.4074877
                ],
                [
                    91.5770202,
                    55.4074402
                ],
                [
                    91.5787989,
                    55.4069888
                ],
                [
                    91.5793534,
                    55.407268
                ],
                [
                    91.5797061,
                    55.4075115
                ],
                [
                    91.5798882,
                    55.4082475
                ],
                [
                    91.5807882,
                    55.4084938
                ],
                [
                    91.5806489,
                    55.4087827
                ],
                [
                    91.5810453,
                    55.4088801
                ],
                [
                    91.5811364,
                    55.4089531
                ],
                [
                    91.5815489,
                    55.409023
                ],
                [
                    91.581656,
                    55.4090625
                ],
                [
                    91.581956,
                    55.4090473
                ],
                [
                    91.5820578,
                    55.4089014
                ],
                [
                    91.5821221,
                    55.408804
                ],
                [
                    91.5825774,
                    55.4089135
                ],
                [
                    91.5828292,
                    55.408725
                ],
                [
                    91.5835846,
                    55.4091477
                ],
                [
                    91.5840185,
                    55.4089622
                ],
                [
                    91.584131,
                    55.4087949
                ],
                [
                    91.5847524,
                    55.4088922
                ],
                [
                    91.5848702,
                    55.4088192
                ],
                [
                    91.5855933,
                    55.4085668
                ],
                [
                    91.5861345,
                    55.4083326
                ],
                [
                    91.5869113,
                    55.4082809
                ],
                [
                    91.5872327,
                    55.4080528
                ],
                [
                    91.5871898,
                    55.4083661
                ],
                [
                    91.5878005,
                    55.4080741
                ],
                [
                    91.5885827,
                    55.4076088
                ],
                [
                    91.5888559,
                    55.4075875
                ],
                [
                    91.5900451,
                    55.4068606
                ],
                [
                    91.5913201,
                    55.4061003
                ],
                [
                    91.5932004,
                    55.4045977
                ],
                [
                    91.5941432,
                    55.4035027
                ],
                [
                    91.5948236,
                    55.4017203
                ],
                [
                    91.5952307,
                    55.4004883
                ],
                [
                    91.5952949,
                    55.3996579
                ],
                [
                    91.5986178,
                    55.3989707
                ],
                [
                    91.5988662,
                    55.3989707
                ],
                [
                    91.5988924,
                    55.3998991
                ],
                [
                    91.6002787,
                    55.3998397
                ],
                [
                    91.5998341,
                    55.4007903
                ],
                [
                    91.6007888,
                    55.4008794
                ],
                [
                    91.6019005,
                    55.3998471
                ],
                [
                    91.6023713,
                    55.3991861
                ],
                [
                    91.6019005,
                    55.3988222
                ],
                [
                    91.601992,
                    55.3985845
                ],
                [
                    91.6026067,
                    55.3986217
                ],
                [
                    91.6030776,
                    55.3980721
                ],
                [
                    91.6029075,
                    55.3978047
                ],
                [
                    91.6038361,
                    55.39727
                ],
                [
                    91.6046992,
                    55.3974779
                ],
                [
                    91.6058241,
                    55.3969283
                ],
                [
                    91.6055637,
                    55.3967638
                ],
                [
                    91.606003,
                    55.3965478
                ],
                [
                    91.6062012,
                    55.396633
                ],
                [
                    91.6064154,
                    55.3964018
                ],
                [
                    91.6066994,
                    55.3964565
                ],
                [
                    91.6074815,
                    55.3952548
                ],
                [
                    91.6081083,
                    55.3953552
                ],
                [
                    91.6085636,
                    55.394692
                ],
                [
                    91.6089011,
                    55.3945794
                ],
                [
                    91.6092546,
                    55.3940288
                ],
                [
                    91.6101446,
                    55.3939025
                ],
                [
                    91.610391,
                    55.3937839
                ],
                [
                    91.6111303,
                    55.393723
                ],
                [
                    91.6113766,
                    55.394079
                ],
                [
                    91.6123785,
                    55.3938904
                ],
                [
                    91.6123785,
                    55.3935192
                ],
                [
                    91.6124982,
                    55.3932989
                ],
                [
                    91.6127773,
                    55.3933696
                ],
                [
                    91.6131354,
                    55.3934773
                ],
                [
                    91.6140658,
                    55.3934384
                ],
                [
                    91.6144256,
                    55.3933926
                ],
                [
                    91.6145678,
                    55.3932909
                ],
                [
                    91.6145924,
                    55.3929529
                ],
                [
                    91.6145081,
                    55.3928931
                ],
                [
                    91.6146643,
                    55.3927675
                ],
                [
                    91.6153086,
                    55.3927685
                ],
                [
                    91.615319,
                    55.392909
                ],
                [
                    91.6154648,
                    55.3929639
                ],
                [
                    91.6165409,
                    55.392929
                ],
                [
                    91.6168445,
                    55.3929858
                ],
                [
                    91.6168691,
                    55.3930426
                ],
                [
                    91.6172816,
                    55.3930875
                ],
                [
                    91.6174115,
                    55.3931354
                ],
                [
                    91.6179223,
                    55.3931383
                ],
                [
                    91.6179329,
                    55.3932161
                ],
                [
                    91.6182787,
                    55.393257
                ],
                [
                    91.6183384,
                    55.3930287
                ],
                [
                    91.6186491,
                    55.3930337
                ],
                [
                    91.6186893,
                    55.3929419
                ],
                [
                    91.6189106,
                    55.3929569
                ],
                [
                    91.6190019,
                    55.3928592
                ],
                [
                    91.6191388,
                    55.3928542
                ],
                [
                    91.6192757,
                    55.3928113
                ],
                [
                    91.6196672,
                    55.3928303
                ],
                [
                    91.6208749,
                    55.3929988
                ],
                [
                    91.6207942,
                    55.3931174
                ],
                [
                    91.6214507,
                    55.3932061
                ],
                [
                    91.6214612,
                    55.3933786
                ],
                [
                    91.6217596,
                    55.3933906
                ],
                [
                    91.6217631,
                    55.393243
                ],
                [
                    91.6218878,
                    55.393243
                ],
                [
                    91.6218878,
                    55.3932051
                ],
                [
                    91.6219861,
                    55.3932061
                ],
                [
                    91.6219861,
                    55.3932969
                ],
                [
                    91.62236,
                    55.3933816
                ],
                [
                    91.6223863,
                    55.3935521
                ],
                [
                    91.622632,
                    55.3936129
                ],
                [
                    91.6226935,
                    55.3934494
                ],
                [
                    91.6231376,
                    55.3935112
                ],
                [
                    91.6231095,
                    55.393573
                ],
                [
                    91.6232096,
                    55.3937026
                ],
                [
                    91.6234237,
                    55.3938033
                ],
                [
                    91.6233869,
                    55.3938621
                ],
                [
                    91.6238099,
                    55.3939788
                ],
                [
                    91.6236396,
                    55.394245
                ],
                [
                    91.624089,
                    55.3943118
                ],
                [
                    91.6241733,
                    55.3944114
                ],
                [
                    91.6246595,
                    55.3946238
                ],
                [
                    91.6247051,
                    55.3947554
                ],
                [
                    91.6245788,
                    55.3948152
                ],
                [
                    91.624405,
                    55.3949518
                ],
                [
                    91.6244629,
                    55.3950475
                ],
                [
                    91.6247596,
                    55.3951432
                ],
                [
                    91.6249385,
                    55.3951262
                ],
                [
                    91.625065,
                    55.3950654
                ],
                [
                    91.6254828,
                    55.3949956
                ],
                [
                    91.6256478,
                    55.3949119
                ],
                [
                    91.6257758,
                    55.3950794
                ],
                [
                    91.6263096,
                    55.3951143
                ],
                [
                    91.6267081,
                    55.3950993
                ],
                [
                    91.6268485,
                    55.3951771
                ],
                [
                    91.6272487,
                    55.3953326
                ],
                [
                    91.6271206,
                    55.3955539
                ],
                [
                    91.6273013,
                    55.3956616
                ],
                [
                    91.6271469,
                    55.3957314
                ],
                [
                    91.6272715,
                    55.3957722
                ],
                [
                    91.6274418,
                    55.3957722
                ],
                [
                    91.6274067,
                    55.3958241
                ],
                [
                    91.627584,
                    55.3959257
                ],
                [
                    91.6276753,
                    55.3959317
                ],
                [
                    91.6277981,
                    55.3959028
                ],
                [
                    91.6279421,
                    55.3958998
                ],
                [
                    91.6279965,
                    55.3959866
                ],
                [
                    91.6281527,
                    55.3960204
                ],
                [
                    91.6281692,
                    55.3961008
                ],
                [
                    91.6283601,
                    55.3961895
                ],
                [
                    91.6285444,
                    55.3961945
                ],
                [
                    91.6287068,
                    55.3962792
                ],
                [
                    91.6289196,
                    55.3962655
                ],
                [
                    91.6291544,
                    55.3964562
                ],
                [
                    91.6288253,
                    55.3966344
                ],
                [
                    91.6290381,
                    55.3968512
                ],
                [
                    91.6292115,
                    55.3967727
                ],
                [
                    91.6298851,
                    55.3969259
                ],
                [
                    91.6298566,
                    55.3971477
                ],
                [
                    91.6302405,
                    55.3971714
                ],
                [
                    91.6305236,
                    55.3972449
                ],
                [
                    91.6306465,
                    55.3973334
                ],
                [
                    91.6307847,
                    55.3975814
                ],
                [
                    91.6309054,
                    55.3976985
                ],
                [
                    91.6309537,
                    55.3978381
                ],
                [
                    91.6310744,
                    55.3979676
                ],
                [
                    91.6311248,
                    55.3981097
                ],
                [
                    91.6313859,
                    55.39839
                ],
                [
                    91.632064,
                    55.3988673
                ],
                [
                    91.6319586,
                    55.3989807
                ],
                [
                    91.6320068,
                    55.3990367
                ],
                [
                    91.6317326,
                    55.3992486
                ],
                [
                    91.6321276,
                    55.399408
                ],
                [
                    91.6324962,
                    55.3991028
                ],
                [
                    91.6326037,
                    55.3990816
                ],
                [
                    91.6330272,
                    55.3993283
                ],
                [
                    91.6327551,
                    55.3994417
                ],
                [
                    91.6329942,
                    55.3996124
                ],
                [
                    91.6331808,
                    55.3997656
                ],
                [
                    91.6332379,
                    55.3999002
                ],
                [
                    91.6332401,
                    55.39997
                ],
                [
                    91.6334813,
                    55.4000074
                ],
                [
                    91.6337053,
                    55.3999177
                ],
                [
                    91.6337579,
                    55.3997532
                ],
                [
                    91.6337711,
                    55.3995476
                ],
                [
                    91.6337426,
                    55.3994105
                ],
                [
                    91.6338676,
                    55.3993345
                ],
                [
                    91.6342143,
                    55.399281
                ],
                [
                    91.6343152,
                    55.3993208
                ],
                [
                    91.6344425,
                    55.3993308
                ],
                [
                    91.6345171,
                    55.3993445
                ],
                [
                    91.6344292,
                    55.3994741
                ],
                [
                    91.6346334,
                    55.3996398
                ],
                [
                    91.6347651,
                    55.3996685
                ],
                [
                    91.6349955,
                    55.3995376
                ],
                [
                    91.6351622,
                    55.3994616
                ],
                [
                    91.6353773,
                    55.3995364
                ],
                [
                    91.6356756,
                    55.3996062
                ],
                [
                    91.6357964,
                    55.3995439
                ],
                [
                    91.6359653,
                    55.3996186
                ],
                [
                    91.6362045,
                    55.3997818
                ],
                [
                    91.6360575,
                    55.3998454
                ],
                [
                    91.6360926,
                    55.400117
                ],
                [
                    91.6362769,
                    55.400183
                ],
                [
                    91.6363734,
                    55.4002615
                ],
                [
                    91.6365172,
                    55.4002516
                ],
                [
                    91.6368155,
                    55.4000764
                ],
                [
                    91.6369561,
                    55.4000647
                ],
                [
                    91.6370863,
                    55.4001562
                ],
                [
                    91.6371343,
                    55.4002672
                ],
                [
                    91.6370761,
                    55.4003451
                ],
                [
                    91.6370863,
                    55.4004268
                ],
                [
                    91.6371926,
                    55.4004366
                ],
                [
                    91.6372372,
                    55.4005105
                ],
                [
                    91.6371446,
                    55.4005144
                ],
                [
                    91.6371412,
                    55.4006001
                ],
                [
                    91.6371103,
                    55.4006994
                ],
                [
                    91.6371481,
                    55.4007734
                ],
                [
                    91.6372818,
                    55.4007714
                ],
                [
                    91.6373572,
                    55.4008415
                ],
                [
                    91.6375698,
                    55.4008298
                ],
                [
                    91.6376589,
                    55.4007461
                ],
                [
                    91.6376932,
                    55.4006429
                ],
                [
                    91.6378715,
                    55.400861
                ],
                [
                    91.6378543,
                    55.4010362
                ],
                [
                    91.6379915,
                    55.401079
                ],
                [
                    91.6382349,
                    55.4011063
                ],
                [
                    91.6383343,
                    55.4010576
                ],
                [
                    91.6383582,
                    55.4009641
                ],
                [
                    91.638516,
                    55.4007656
                ],
                [
                    91.6390509,
                    55.4007111
                ],
                [
                    91.6391263,
                    55.4007987
                ],
                [
                    91.6392874,
                    55.400824
                ],
                [
                    91.639404,
                    55.4009505
                ],
                [
                    91.6392806,
                    55.4010556
                ],
                [
                    91.6390303,
                    55.401153
                ],
                [
                    91.6389206,
                    55.4012951
                ],
                [
                    91.638948,
                    55.4014723
                ],
                [
                    91.6391777,
                    55.4015385
                ],
                [
                    91.6394451,
                    55.4015657
                ],
                [
                    91.6396474,
                    55.4015443
                ],
                [
                    91.6399697,
                    55.401299
                ],
                [
                    91.6400862,
                    55.4010907
                ],
                [
                    91.6399834,
                    55.4009213
                ],
                [
                    91.6400314,
                    55.4006643
                ],
                [
                    91.6397983,
                    55.4005981
                ],
                [
                    91.6398051,
                    55.4005281
                ],
                [
                    91.6394451,
                    55.4000589
                ],
                [
                    91.6394349,
                    55.3997532
                ],
                [
                    91.6394758,
                    55.3996496
                ],
                [
                    91.6399833,
                    55.3995468
                ],
                [
                    91.6403151,
                    55.3992602
                ],
                [
                    91.640455,
                    55.3992244
                ],
                [
                    91.6404221,
                    55.3991917
                ],
                [
                    91.6404248,
                    55.3990749
                ],
                [
                    91.6405291,
                    55.3989113
                ],
                [
                    91.6406936,
                    55.3988989
                ],
                [
                    91.6408006,
                    55.3989331
                ],
                [
                    91.6409843,
                    55.3989253
                ],
                [
                    91.6410721,
                    55.3988256
                ],
                [
                    91.6410433,
                    55.3987649
                ],
                [
                    91.6414067,
                    55.3987968
                ],
                [
                    91.6421826,
                    55.3985337
                ],
                [
                    91.6422264,
                    55.398437
                ],
                [
                    91.6423844,
                    55.3984459
                ],
                [
                    91.6424687,
                    55.398423
                ],
                [
                    91.642781,
                    55.3984031
                ],
                [
                    91.6429549,
                    55.3984758
                ],
                [
                    91.6430692,
                    55.3985671
                ],
                [
                    91.6433136,
                    55.3986085
                ],
                [
                    91.6438337,
                    55.3982617
                ],
                [
                    91.6439489,
                    55.3984595
                ],
                [
                    91.6441354,
                    55.3986355
                ],
                [
                    91.6444152,
                    55.3987508
                ],
                [
                    91.6446867,
                    55.3988084
                ],
                [
                    91.6448842,
                    55.3988661
                ],
                [
                    91.6450927,
                    55.3990031
                ],
                [
                    91.6451474,
                    55.3990935
                ],
                [
                    91.6450514,
                    55.3992212
                ],
                [
                    91.6448156,
                    55.3993084
                ],
                [
                    91.6446511,
                    55.3993193
                ],
                [
                    91.6444399,
                    55.399405
                ],
                [
                    91.6445193,
                    55.3994486
                ],
                [
                    91.6447279,
                    55.3995046
                ],
                [
                    91.6451694,
                    55.3995763
                ],
                [
                    91.6455232,
                    55.3995732
                ],
                [
                    91.6458579,
                    55.3994657
                ],
                [
                    91.6460691,
                    55.3994673
                ],
                [
                    91.6468124,
                    55.3997585
                ],
                [
                    91.6481289,
                    55.4002273
                ],
                [
                    91.6482824,
                    55.4002569
                ],
                [
                    91.6485047,
                    55.400232
                ],
                [
                    91.648864,
                    55.399757
                ],
                [
                    91.6492425,
                    55.3998566
                ],
                [
                    91.6492233,
                    55.3999002
                ],
                [
                    91.6495744,
                    55.3999952
                ],
                [
                    91.6495276,
                    55.4000669
                ],
                [
                    91.6502464,
                    55.4003644
                ],
                [
                    91.6503204,
                    55.4003083
                ],
                [
                    91.6508991,
                    55.4005559
                ],
                [
                    91.6506879,
                    55.4006914
                ],
                [
                    91.6508251,
                    55.4007537
                ],
                [
                    91.651135,
                    55.4008409
                ],
                [
                    91.6512666,
                    55.400897
                ],
                [
                    91.6516808,
                    55.4007444
                ],
                [
                    91.651999,
                    55.4005591
                ],
                [
                    91.6523033,
                    55.4003613
                ],
                [
                    91.6523748,
                    55.4001557
                ],
                [
                    91.6522925,
                    55.399961
                ],
                [
                    91.6527039,
                    55.3999454
                ],
                [
                    91.6533485,
                    55.3998644
                ],
                [
                    91.6541411,
                    55.3996246
                ],
                [
                    91.6547609,
                    55.3995482
                ],
                [
                    91.6549201,
                    55.3994969
                ],
                [
                    91.6551642,
                    55.3995296
                ],
                [
                    91.6554823,
                    55.3995405
                ],
                [
                    91.6554933,
                    55.3994346
                ],
                [
                    91.6553397,
                    55.3992321
                ],
                [
                    91.6552465,
                    55.3988489
                ],
                [
                    91.6550627,
                    55.3985561
                ],
                [
                    91.6550709,
                    55.3978428
                ],
                [
                    91.6551587,
                    55.3971356
                ],
                [
                    91.6551185,
                    55.3969252
                ],
                [
                    91.6567955,
                    55.3966505
                ],
                [
                    91.6575418,
                    55.3952689
                ],
                [
                    91.6587848,
                    55.3946815
                ],
                [
                    91.658982,
                    55.3946226
                ],
                [
                    91.6593989,
                    55.3946488
                ],
                [
                    91.6599277,
                    55.3945341
                ],
                [
                    91.6602941,
                    55.3942998
                ],
                [
                    91.6603709,
                    55.3941416
                ],
                [
                    91.6602349,
                    55.3941092
                ],
                [
                    91.6605399,
                    55.3936954
                ],
                [
                    91.6606145,
                    55.3934674
                ],
                [
                    91.6604696,
                    55.3932468
                ],
                [
                    91.6601273,
                    55.3929315
                ],
                [
                    91.6597345,
                    55.3927234
                ],
                [
                    91.6589468,
                    55.3923446
                ],
                [
                    91.6585781,
                    55.3920542
                ],
                [
                    91.6581394,
                    55.3919146
                ],
                [
                    91.6577971,
                    55.3917676
                ],
                [
                    91.657363,
                    55.391558
                ],
                [
                    91.6572453,
                    55.3914673
                ],
                [
                    91.6568645,
                    55.3913586
                ],
                [
                    91.6565292,
                    55.3913157
                ],
                [
                    91.6563098,
                    55.3913456
                ],
                [
                    91.6566239,
                    55.3909049
                ],
                [
                    91.6567451,
                    55.3905899
                ],
                [
                    91.6567487,
                    55.3904144
                ],
                [
                    91.6566855,
                    55.3900924
                ],
                [
                    91.6566855,
                    55.3898212
                ],
                [
                    91.6565836,
                    55.3894752
                ],
                [
                    91.6565696,
                    55.3893426
                ],
                [
                    91.6567487,
                    55.3890405
                ],
                [
                    91.6570365,
                    55.3886955
                ],
                [
                    91.6571629,
                    55.3886137
                ],
                [
                    91.6572507,
                    55.3884472
                ],
                [
                    91.6570313,
                    55.388506
                ],
                [
                    91.6564151,
                    55.3886726
                ],
                [
                    91.6561185,
                    55.3887782
                ],
                [
                    91.655706,
                    55.3888849
                ],
                [
                    91.6555813,
                    55.388867
                ],
                [
                    91.6563764,
                    55.3884662
                ],
                [
                    91.6563993,
                    55.388181
                ],
                [
                    91.6561501,
                    55.3880733
                ],
                [
                    91.6556444,
                    55.3879168
                ],
                [
                    91.655325,
                    55.3877842
                ],
                [
                    91.6552478,
                    55.387831
                ],
                [
                    91.6551214,
                    55.387836
                ],
                [
                    91.6550635,
                    55.3879098
                ],
                [
                    91.6550793,
                    55.3879906
                ],
                [
                    91.6550459,
                    55.3881501
                ],
                [
                    91.6549968,
                    55.3882309
                ],
                [
                    91.6550178,
                    55.3884093
                ],
                [
                    91.6549933,
                    55.3885599
                ],
                [
                    91.6549459,
                    55.3886058
                ],
                [
                    91.65483,
                    55.3886107
                ],
                [
                    91.6546633,
                    55.3886686
                ],
                [
                    91.654572,
                    55.3887713
                ],
                [
                    91.654428,
                    55.388852
                ],
                [
                    91.6543385,
                    55.3889577
                ],
                [
                    91.6542069,
                    55.3890325
                ],
                [
                    91.6537136,
                    55.3889069
                ],
                [
                    91.6539699,
                    55.3886706
                ],
                [
                    91.6536802,
                    55.3885798
                ],
                [
                    91.653438,
                    55.3887733
                ],
                [
                    91.6531606,
                    55.3887244
                ],
                [
                    91.6531027,
                    55.3887882
                ],
                [
                    91.6523233,
                    55.3890993
                ],
                [
                    91.6513866,
                    55.3895788
                ],
                [
                    91.6513122,
                    55.3895007
                ],
                [
                    91.6506522,
                    55.3889862
                ],
                [
                    91.6500791,
                    55.3892422
                ],
                [
                    91.6487241,
                    55.3896913
                ],
                [
                    91.6484966,
                    55.3896682
                ],
                [
                    91.6486734,
                    55.3876658
                ],
                [
                    91.6475271,
                    55.3875232
                ],
                [
                    91.6475306,
                    55.3874773
                ],
                [
                    91.6469618,
                    55.3874105
                ],
                [
                    91.646946,
                    55.3874484
                ],
                [
                    91.646681,
                    55.3874245
                ],
                [
                    91.6467617,
                    55.387242
                ],
                [
                    91.6470688,
                    55.3868392
                ],
                [
                    91.6472445,
                    55.3865141
                ],
                [
                    91.6475043,
                    55.3851476
                ],
                [
                    91.6500628,
                    55.3853171
                ],
                [
                    91.650054,
                    55.3851588
                ],
                [
                    91.6498938,
                    55.3850778
                ],
                [
                    91.6496283,
                    55.3849918
                ],
                [
                    91.649466,
                    55.3848821
                ],
                [
                    91.6493277,
                    55.3848285
                ],
                [
                    91.6493299,
                    55.3847687
                ],
                [
                    91.6494308,
                    55.3847362
                ],
                [
                    91.649771,
                    55.38472
                ],
                [
                    91.6498083,
                    55.3845941
                ],
                [
                    91.6494989,
                    55.3845755
                ],
                [
                    91.6495208,
                    55.3844757
                ],
                [
                    91.6496108,
                    55.3843972
                ],
                [
                    91.6495274,
                    55.3843224
                ],
                [
                    91.649523,
                    55.384219
                ],
                [
                    91.6487594,
                    55.3841517
                ],
                [
                    91.6488033,
                    55.3839011
                ],
                [
                    91.6485641,
                    55.3838238
                ],
                [
                    91.6484939,
                    55.3837042
                ],
                [
                    91.6484391,
                    55.3835321
                ],
                [
                    91.6485685,
                    55.3831769
                ],
                [
                    91.648551,
                    55.3829762
                ],
                [
                    91.6483052,
                    55.3829388
                ],
                [
                    91.6481648,
                    55.3829774
                ],
                [
                    91.6479535,
                    55.3829725
                ],
                [
                    91.6481565,
                    55.3828961
                ],
                [
                    91.6485432,
                    55.3826032
                ],
                [
                    91.648631,
                    55.3824707
                ],
                [
                    91.6486475,
                    55.3822401
                ],
                [
                    91.64845,
                    55.3822323
                ],
                [
                    91.6476628,
                    55.3821498
                ],
                [
                    91.6475915,
                    55.3821124
                ],
                [
                    91.6455426,
                    55.3819285
                ],
                [
                    91.6455234,
                    55.3820033
                ],
                [
                    91.6453588,
                    55.3819971
                ],
                [
                    91.6454,
                    55.3817555
                ],
                [
                    91.6450133,
                    55.3817244
                ],
                [
                    91.6449693,
                    55.3819519
                ],
                [
                    91.6436583,
                    55.3819176
                ],
                [
                    91.6434471,
                    55.3817431
                ],
                [
                    91.643395,
                    55.3816589
                ],
                [
                    91.6432688,
                    55.3816013
                ],
                [
                    91.6432798,
                    55.3814969
                ],
                [
                    91.6430576,
                    55.3813177
                ],
                [
                    91.6429754,
                    55.381098
                ],
                [
                    91.6429452,
                    55.380964
                ],
                [
                    91.6429816,
                    55.3808685
                ],
                [
                    91.6432765,
                    55.3807751
                ],
                [
                    91.6435165,
                    55.3806679
                ],
                [
                    91.6437016,
                    55.3803641
                ],
                [
                    91.6439827,
                    55.3803894
                ],
                [
                    91.6443393,
                    55.3803485
                ],
                [
                    91.6445347,
                    55.3803056
                ],
                [
                    91.6447644,
                    55.3801498
                ],
                [
                    91.6447953,
                    55.3800154
                ],
                [
                    91.6447576,
                    55.3797232
                ],
                [
                    91.6453061,
                    55.3793005
                ],
                [
                    91.6455256,
                    55.3791506
                ],
                [
                    91.645841,
                    55.378724
                ],
                [
                    91.6457861,
                    55.3784824
                ],
                [
                    91.6456387,
                    55.3782954
                ],
                [
                    91.6454569,
                    55.3781922
                ],
                [
                    91.6452581,
                    55.3780208
                ],
                [
                    91.645162,
                    55.3778805
                ],
                [
                    91.6449976,
                    55.3770643
                ],
                [
                    91.6450353,
                    55.3767488
                ],
                [
                    91.6447816,
                    55.3765189
                ],
                [
                    91.644593,
                    55.3761663
                ],
                [
                    91.6444798,
                    55.3745007
                ],
                [
                    91.6439319,
                    55.3723976
                ],
                [
                    91.6439233,
                    55.37174
                ],
                [
                    91.6445919,
                    55.3704323
                ],
                [
                    91.6474267,
                    55.3667614
                ],
                [
                    91.6475193,
                    55.365943
                ],
                [
                    91.6474542,
                    55.3653195
                ],
                [
                    91.6477285,
                    55.3646268
                ],
                [
                    91.6483389,
                    55.3641221
                ],
                [
                    91.6494909,
                    55.3633875
                ],
                [
                    91.6496243,
                    55.3632546
                ],
                [
                    91.6497514,
                    55.3631283
                ],
                [
                    91.6471698,
                    55.3638026
                ],
                [
                    91.6471423,
                    55.3637558
                ],
                [
                    91.6470018,
                    55.3637948
                ],
                [
                    91.6470086,
                    55.3638435
                ],
                [
                    91.6462784,
                    55.3640754
                ],
                [
                    91.6454521,
                    55.3642956
                ],
                [
                    91.6456921,
                    55.3639546
                ],
                [
                    91.6485997,
                    55.3548787
                ],
                [
                    91.6486319,
                    55.3543519
                ],
                [
                    91.6485836,
                    55.3539651
                ],
                [
                    91.6484818,
                    55.3537184
                ],
                [
                    91.6482622,
                    55.3532707
                ],
                [
                    91.6477694,
                    55.3534778
                ],
                [
                    91.647523,
                    55.3543671
                ],
                [
                    91.6477694,
                    55.354827
                ],
                [
                    91.6477103,
                    55.3555487
                ],
                [
                    91.6471677,
                    55.3567896
                ],
                [
                    91.6449557,
                    55.3591813
                ],
                [
                    91.641737,
                    55.3624062
                ],
                [
                    91.6404856,
                    55.3634195
                ],
                [
                    91.6398205,
                    55.3636592
                ],
                [
                    91.6392479,
                    55.364347
                ],
                [
                    91.6384079,
                    55.3650115
                ],
                [
                    91.6378457,
                    55.3646315
                ],
                [
                    91.6369612,
                    55.3655281
                ],
                [
                    91.6359241,
                    55.3659885
                ],
                [
                    91.6347368,
                    55.3666583
                ],
                [
                    91.634124,
                    55.3669018
                ],
                [
                    91.633697,
                    55.36735
                ],
                [
                    91.633223,
                    55.3675919
                ],
                [
                    91.6325165,
                    55.3681219
                ],
                [
                    91.6317375,
                    55.369208
                ],
                [
                    91.6307304,
                    55.3699599
                ],
                [
                    91.6298461,
                    55.3703589
                ],
                [
                    91.6286678,
                    55.3710921
                ],
                [
                    91.6284659,
                    55.3711644
                ],
                [
                    91.6277989,
                    55.3715385
                ],
                [
                    91.6270331,
                    55.3716207
                ],
                [
                    91.6269321,
                    55.3716719
                ],
                [
                    91.6267917,
                    55.3716681
                ],
                [
                    91.6266315,
                    55.3715771
                ],
                [
                    91.6260062,
                    55.3716582
                ],
                [
                    91.6259381,
                    55.371617
                ],
                [
                    91.6255563,
                    55.3716594
                ],
                [
                    91.6253523,
                    55.3717928
                ],
                [
                    91.6249002,
                    55.3718676
                ],
                [
                    91.6245602,
                    55.3718788
                ],
                [
                    91.6240292,
                    55.3718976
                ],
                [
                    91.6239985,
                    55.3718639
                ],
                [
                    91.623869,
                    55.3718115
                ],
                [
                    91.6235508,
                    55.371809
                ],
                [
                    91.6234718,
                    55.3717766
                ],
                [
                    91.6231603,
                    55.3717267
                ],
                [
                    91.6221707,
                    55.3717779
                ],
                [
                    91.6221685,
                    55.3718265
                ],
                [
                    91.6218765,
                    55.3718302
                ],
                [
                    91.6215958,
                    55.3718739
                ],
                [
                    91.6215804,
                    55.3717242
                ],
                [
                    91.620841,
                    55.3717517
                ],
                [
                    91.6208453,
                    55.3718776
                ],
                [
                    91.6206917,
                    55.3718951
                ],
                [
                    91.6202397,
                    55.3718726
                ],
                [
                    91.6193906,
                    55.37193
                ],
                [
                    91.6194146,
                    55.3720347
                ],
                [
                    91.6191733,
                    55.3720397
                ],
                [
                    91.6187498,
                    55.3720846
                ],
                [
                    91.6180344,
                    55.3720995
                ],
                [
                    91.6180214,
                    55.3720584
                ],
                [
                    91.6171678,
                    55.3720422
                ],
                [
                    91.6171283,
                    55.3721058
                ],
                [
                    91.6167399,
                    55.3721008
                ],
                [
                    91.6167399,
                    55.3720696
                ],
                [
                    91.6164174,
                    55.3720821
                ],
                [
                    91.6164086,
                    55.3721656
                ],
                [
                    91.6161628,
                    55.3721644
                ],
                [
                    91.6161716,
                    55.3720896
                ],
                [
                    91.6156757,
                    55.3720833
                ],
                [
                    91.6149669,
                    55.372112
                ],
                [
                    91.6142868,
                    55.3721781
                ],
                [
                    91.6134091,
                    55.372198
                ],
                [
                    91.6132072,
                    55.3722479
                ],
                [
                    91.6131173,
                    55.3723153
                ],
                [
                    91.6131194,
                    55.3726955
                ],
                [
                    91.612968,
                    55.3728215
                ],
                [
                    91.6126872,
                    55.3724349
                ],
                [
                    91.6124239,
                    55.3719836
                ],
                [
                    91.6123624,
                    55.3718028
                ],
                [
                    91.6122834,
                    55.371738
                ],
                [
                    91.6119653,
                    55.3719287
                ],
                [
                    91.6108747,
                    55.3722791
                ],
                [
                    91.6106224,
                    55.3723165
                ],
                [
                    91.6107804,
                    55.3721594
                ],
                [
                    91.6108462,
                    55.3719848
                ],
                [
                    91.6108265,
                    55.3717242
                ],
                [
                    91.6106049,
                    55.3711482
                ],
                [
                    91.6104929,
                    55.3710958
                ],
                [
                    91.6104337,
                    55.3707978
                ],
                [
                    91.6096789,
                    55.3707629
                ],
                [
                    91.6096635,
                    55.3711257
                ],
                [
                    91.6086081,
                    55.3710921
                ],
                [
                    91.6060716,
                    55.3712018
                ],
                [
                    91.6061052,
                    55.3722418
                ],
                [
                    91.6061754,
                    55.3723485
                ],
                [
                    91.6057593,
                    55.3724054
                ],
                [
                    91.6040579,
                    55.3724468
                ],
                [
                    91.6042379,
                    55.3730605
                ],
                [
                    91.6024259,
                    55.3811646
                ],
                [
                    91.6014138,
                    55.3811116
                ],
                [
                    91.600292,
                    55.3812518
                ],
                [
                    91.6002838,
                    55.3813173
                ],
                [
                    91.5999382,
                    55.3817551
                ],
                [
                    91.5997572,
                    55.3817614
                ],
                [
                    91.5995597,
                    55.381925
                ],
                [
                    91.5991099,
                    55.3822771
                ],
                [
                    91.5988768,
                    55.3825249
                ],
                [
                    91.598778,
                    55.3828459
                ],
                [
                    91.5986244,
                    55.3830796
                ],
                [
                    91.5985503,
                    55.3833071
                ],
                [
                    91.5978235,
                    55.3836779
                ],
                [
                    91.5974944,
                    55.3835548
                ],
                [
                    91.5973545,
                    55.383653
                ],
                [
                    91.5972256,
                    55.3836125
                ],
                [
                    91.5971186,
                    55.3836374
                ],
                [
                    91.5967538,
                    55.3839132
                ],
                [
                    91.5963918,
                    55.3841485
                ],
                [
                    91.59575,
                    55.3840472
                ],
                [
                    91.5956786,
                    55.3840815
                ],
                [
                    91.595333,
                    55.3841375
                ],
                [
                    91.5950888,
                    55.3840908
                ],
                [
                    91.595056,
                    55.3842342
                ],
                [
                    91.5949573,
                    55.3842949
                ],
                [
                    91.5935173,
                    55.3840238
                ],
                [
                    91.5931388,
                    55.384647
                ],
                [
                    91.5932814,
                    55.3846751
                ],
                [
                    91.5934678,
                    55.3847468
                ],
                [
                    91.5936407,
                    55.384767
                ],
                [
                    91.5936325,
                    55.3848512
                ],
                [
                    91.5934871,
                    55.3849026
                ],
                [
                    91.5936051,
                    55.3850319
                ],
                [
                    91.5937066,
                    55.3850911
                ],
                [
                    91.5937834,
                    55.3851051
                ],
                [
                    91.5939041,
                    55.3850412
                ],
                [
                    91.5940028,
                    55.3850958
                ],
                [
                    91.5942798,
                    55.3851285
                ],
                [
                    91.5946665,
                    55.3850973
                ],
                [
                    91.5948668,
                    55.3850927
                ],
                [
                    91.5950012,
                    55.38513
                ],
                [
                    91.5950752,
                    55.3851986
                ],
                [
                    91.5951904,
                    55.3852142
                ],
                [
                    91.5953028,
                    55.3851643
                ],
                [
                    91.5956512,
                    55.38525
                ],
                [
                    91.5956869,
                    55.385222
                ],
                [
                    91.5961394,
                    55.3852874
                ],
                [
                    91.5961147,
                    55.3853482
                ],
                [
                    91.5962793,
                    55.3854058
                ],
                [
                    91.5962299,
                    55.3858234
                ],
                [
                    91.5968745,
                    55.3859028
                ],
                [
                    91.596965,
                    55.3864326
                ],
                [
                    91.5965426,
                    55.3868439
                ],
                [
                    91.595621,
                    55.3870153
                ],
                [
                    91.5935498,
                    55.3867894
                ],
                [
                    91.5935502,
                    55.3868517
                ],
                [
                    91.5935169,
                    55.3870449
                ],
                [
                    91.5931987,
                    55.3871259
                ],
                [
                    91.5929573,
                    55.3871509
                ],
                [
                    91.5928092,
                    55.3873144
                ],
                [
                    91.5930725,
                    55.3874001
                ],
                [
                    91.5929683,
                    55.3876821
                ],
                [
                    91.593185,
                    55.3876619
                ],
                [
                    91.5933166,
                    55.3875575
                ],
                [
                    91.5934291,
                    55.3875419
                ],
                [
                    91.5934263,
                    55.387785
                ],
                [
                    91.5935415,
                    55.3878099
                ],
                [
                    91.5942601,
                    55.3878597
                ],
                [
                    91.5942821,
                    55.3878239
                ],
                [
                    91.5949102,
                    55.3879439
                ],
                [
                    91.5955108,
                    55.3879579
                ],
                [
                    91.5960018,
                    55.3879828
                ],
                [
                    91.5960759,
                    55.3879034
                ],
                [
                    91.5960567,
                    55.3877008
                ],
                [
                    91.5963611,
                    55.387866
                ],
                [
                    91.5963886,
                    55.3881885
                ],
                [
                    91.5959991,
                    55.388701
                ],
                [
                    91.5958565,
                    55.3887961
                ],
                [
                    91.5961033,
                    55.3889846
                ],
                [
                    91.5961006,
                    55.3895532
                ],
                [
                    91.5964242,
                    55.389547
                ],
                [
                    91.5963912,
                    55.3898476
                ],
                [
                    91.5964462,
                    55.3899255
                ],
                [
                    91.5969618,
                    55.3899582
                ],
                [
                    91.596885,
                    55.3901187
                ],
                [
                    91.5972141,
                    55.3901499
                ],
                [
                    91.596885,
                    55.3909194
                ],
                [
                    91.5963118,
                    55.3927421
                ],
                [
                    91.5959717,
                    55.392753
                ],
                [
                    91.5951653,
                    55.3929913
                ],
                [
                    91.5952475,
                    55.3933496
                ],
                [
                    91.5950254,
                    55.3934119
                ],
                [
                    91.5950446,
                    55.3934649
                ],
                [
                    91.5952805,
                    55.3936238
                ],
                [
                    91.5955218,
                    55.3937172
                ],
                [
                    91.5959909,
                    55.3937468
                ],
                [
                    91.5958345,
                    55.3943372
                ],
                [
                    91.5959662,
                    55.3949057
                ],
                [
                    91.5964078,
                    55.39544
                ],
                [
                    91.5966162,
                    55.3956285
                ],
                [
                    91.5967259,
                    55.3958481
                ],
                [
                    91.596586,
                    55.3958902
                ],
                [
                    91.5962459,
                    55.3958855
                ],
                [
                    91.594603,
                    55.3963139
                ],
                [
                    91.593761,
                    55.3968294
                ],
                [
                    91.5932398,
                    55.3969244
                ],
                [
                    91.5924883,
                    55.3970709
                ],
                [
                    91.5911553,
                    55.3976035
                ],
                [
                    91.5909194,
                    55.3981674
                ],
                [
                    91.5914322,
                    55.3981627
                ],
                [
                    91.59166,
                    55.3982608
                ],
                [
                    91.5918775,
                    55.3983032
                ],
                [
                    91.5915532,
                    55.3998895
                ],
                [
                    91.5918775,
                    55.3999371
                ],
                [
                    91.5913962,
                    55.4008936
                ],
                [
                    91.590894,
                    55.4013748
                ],
                [
                    91.5905278,
                    55.4013629
                ],
                [
                    91.5900988,
                    55.402462
                ],
                [
                    91.5903081,
                    55.402569
                ],
                [
                    91.5884038,
                    55.4035908
                ],
                [
                    91.5872738,
                    55.4040423
                ],
                [
                    91.5868344,
                    55.4038522
                ],
                [
                    91.5855474,
                    55.4040245
                ],
                [
                    91.5848883,
                    55.4042562
                ],
                [
                    91.5849719,
                    55.4039769
                ],
                [
                    91.5817494,
                    55.4034423
                ],
                [
                    91.5809124,
                    55.4034244
                ],
                [
                    91.5802114,
                    55.4036621
                ],
                [
                    91.5799289,
                    55.4041433
                ],
                [
                    91.5796987,
                    55.4042859
                ],
                [
                    91.5797196,
                    55.4046601
                ],
                [
                    91.5793534,
                    55.4052779
                ],
                [
                    91.5761622,
                    55.4048799
                ],
                [
                    91.5742266,
                    55.4050641
                ],
                [
                    91.5726781,
                    55.4061215
                ],
                [
                    91.5723536,
                    55.4064482
                ]
            ],
            "longitude": 91.615273,
            "latitude": 55.383221
        },
        "5734": {
            "name": "МИНУСИНСК",
            "population": 68270,
            "type": "town",
            "poly": [
                [
                    91.6201355,
                    53.7339557
                ],
                [
                    91.6510595,
                    53.7614911
                ],
                [
                    91.6568195,
                    53.7642217
                ],
                [
                    91.6836507,
                    53.76797
                ],
                [
                    91.6784313,
                    53.757213
                ],
                [
                    91.6794464,
                    53.7565337
                ],
                [
                    91.6838636,
                    53.747643
                ],
                [
                    91.6928862,
                    53.7474839
                ],
                [
                    91.6930824,
                    53.7473586
                ],
                [
                    91.7022449,
                    53.7414611
                ],
                [
                    91.7057475,
                    53.7419361
                ],
                [
                    91.7191664,
                    53.7328905
                ],
                [
                    91.7220442,
                    53.7328311
                ],
                [
                    91.7223678,
                    53.7326332
                ],
                [
                    91.7231932,
                    53.7325144
                ],
                [
                    91.7240075,
                    53.7321383
                ],
                [
                    91.724911,
                    53.7320855
                ],
                [
                    91.7252568,
                    53.7291226
                ],
                [
                    91.7292167,
                    53.729182
                ],
                [
                    91.7292278,
                    53.7329037
                ],
                [
                    91.7313918,
                    53.7330687
                ],
                [
                    91.735084,
                    53.7331083
                ],
                [
                    91.7364449,
                    53.7335174
                ],
                [
                    91.7377722,
                    53.730416
                ],
                [
                    91.7388989,
                    53.7263575
                ],
                [
                    91.7390662,
                    53.7257108
                ],
                [
                    91.7391108,
                    53.7240872
                ],
                [
                    91.7360991,
                    53.7222524
                ],
                [
                    91.7341693,
                    53.7201733
                ],
                [
                    91.7341359,
                    53.7160874
                ],
                [
                    91.7361325,
                    53.7160676
                ],
                [
                    91.7400812,
                    53.7165231
                ],
                [
                    91.7451899,
                    53.7147606
                ],
                [
                    91.7479787,
                    53.7133016
                ],
                [
                    91.7503769,
                    53.7118163
                ],
                [
                    91.7485364,
                    53.7114465
                ],
                [
                    91.7340466,
                    53.7098753
                ],
                [
                    91.7326523,
                    53.7049894
                ],
                [
                    91.7398024,
                    53.704415
                ],
                [
                    91.7408286,
                    53.7044216
                ],
                [
                    91.7461159,
                    53.7047187
                ],
                [
                    91.751682,
                    53.7044216
                ],
                [
                    91.7513697,
                    53.702784
                ],
                [
                    91.7527194,
                    53.6979106
                ],
                [
                    91.7680458,
                    53.6962793
                ],
                [
                    91.7710687,
                    53.6940272
                ],
                [
                    91.7788323,
                    53.690989
                ],
                [
                    91.7744385,
                    53.6863921
                ],
                [
                    91.774337,
                    53.6862859
                ],
                [
                    91.7659822,
                    53.686537
                ],
                [
                    91.7610407,
                    53.6865766
                ],
                [
                    91.7496965,
                    53.6835312
                ],
                [
                    91.7499133,
                    53.6790028
                ],
                [
                    91.7485747,
                    53.678679
                ],
                [
                    91.7444029,
                    53.6790094
                ],
                [
                    91.7416366,
                    53.6794059
                ],
                [
                    91.7409115,
                    53.6787584
                ],
                [
                    91.7356577,
                    53.6781439
                ],
                [
                    91.733661,
                    53.6798089
                ],
                [
                    91.7262581,
                    53.6781924
                ],
                [
                    91.7252963,
                    53.6777131
                ],
                [
                    91.7209931,
                    53.6763821
                ],
                [
                    91.7199111,
                    53.6738646
                ],
                [
                    91.7223925,
                    53.6698861
                ],
                [
                    91.7176657,
                    53.6688866
                ],
                [
                    91.7100272,
                    53.6676855
                ],
                [
                    91.7088397,
                    53.6674988
                ],
                [
                    91.6881171,
                    53.6654368
                ],
                [
                    91.681911,
                    53.6659604
                ],
                [
                    91.6799573,
                    53.6691918
                ],
                [
                    91.6802255,
                    53.6717538
                ],
                [
                    91.683841,
                    53.6726845
                ],
                [
                    91.6863886,
                    53.6743927
                ],
                [
                    91.6864689,
                    53.6752315
                ],
                [
                    91.6857973,
                    53.6775276
                ],
                [
                    91.6857608,
                    53.6782367
                ],
                [
                    91.6880456,
                    53.6828023
                ],
                [
                    91.6856805,
                    53.6836324
                ],
                [
                    91.6812788,
                    53.6853962
                ],
                [
                    91.6742053,
                    53.6870217
                ],
                [
                    91.6714387,
                    53.6861398
                ],
                [
                    91.665723,
                    53.682798
                ],
                [
                    91.6644237,
                    53.6835157
                ],
                [
                    91.6643475,
                    53.6835008
                ],
                [
                    91.6637813,
                    53.6833903
                ],
                [
                    91.6620439,
                    53.6839966
                ],
                [
                    91.6544522,
                    53.6866456
                ],
                [
                    91.6528316,
                    53.6869524
                ],
                [
                    91.6501162,
                    53.6883704
                ],
                [
                    91.6501965,
                    53.6890404
                ],
                [
                    91.6494519,
                    53.6892998
                ],
                [
                    91.6476416,
                    53.6888978
                ],
                [
                    91.6463568,
                    53.6891182
                ],
                [
                    91.646386,
                    53.6896153
                ],
                [
                    91.6468897,
                    53.690294
                ],
                [
                    91.6471087,
                    53.6902507
                ],
                [
                    91.6487512,
                    53.6916339
                ],
                [
                    91.6483497,
                    53.6918673
                ],
                [
                    91.648649,
                    53.6920618
                ],
                [
                    91.6489045,
                    53.6919754
                ],
                [
                    91.6521309,
                    53.6943526
                ],
                [
                    91.6518608,
                    53.6950442
                ],
                [
                    91.654861,
                    53.6969847
                ],
                [
                    91.6545325,
                    53.698385
                ],
                [
                    91.6580802,
                    53.6994135
                ],
                [
                    91.6601752,
                    53.7002778
                ],
                [
                    91.662117,
                    53.7019977
                ],
                [
                    91.662825,
                    53.7034713
                ],
                [
                    91.6608176,
                    53.7047806
                ],
                [
                    91.6619053,
                    53.7051436
                ],
                [
                    91.6624017,
                    53.7050485
                ],
                [
                    91.6630659,
                    53.7047763
                ],
                [
                    91.6626352,
                    53.7045905
                ],
                [
                    91.6632046,
                    53.7041454
                ],
                [
                    91.6640295,
                    53.7047071
                ],
                [
                    91.6643069,
                    53.7045905
                ],
                [
                    91.6650661,
                    53.7051522
                ],
                [
                    91.6646865,
                    53.7053855
                ],
                [
                    91.665796,
                    53.7062152
                ],
                [
                    91.6635258,
                    53.7065176
                ],
                [
                    91.6613359,
                    53.7065263
                ],
                [
                    91.658343,
                    53.7076799
                ],
                [
                    91.6574451,
                    53.7070232
                ],
                [
                    91.656175,
                    53.7077577
                ],
                [
                    91.6519922,
                    53.7078441
                ],
                [
                    91.6507075,
                    53.7081898
                ],
                [
                    91.6506491,
                    53.7085613
                ],
                [
                    91.6532405,
                    53.70857
                ],
                [
                    91.6547953,
                    53.7087298
                ],
                [
                    91.6544522,
                    53.7101988
                ],
                [
                    91.6566203,
                    53.7108901
                ],
                [
                    91.6574305,
                    53.7126658
                ],
                [
                    91.6551749,
                    53.7135989
                ],
                [
                    91.6559341,
                    53.7143895
                ],
                [
                    91.6553647,
                    53.7146357
                ],
                [
                    91.6530288,
                    53.7150418
                ],
                [
                    91.649795,
                    53.7153097
                ],
                [
                    91.648503,
                    53.7153226
                ],
                [
                    91.6465611,
                    53.7150505
                ],
                [
                    91.6442018,
                    53.7146888
                ],
                [
                    91.6370019,
                    53.7128578
                ],
                [
                    91.6291889,
                    53.7106048
                ],
                [
                    91.6280198,
                    53.7125034
                ],
                [
                    91.624484,
                    53.7126384
                ],
                [
                    91.6230725,
                    53.7160472
                ],
                [
                    91.6221458,
                    53.722982
                ],
                [
                    91.6201355,
                    53.7339557
                ]
            ],
            "longitude": 91.67984438607313,
            "latitude": 53.69819970055898
        },
        "5735": {
            "name": "ШУШЕНСКОЕ",
            "population": 16943,
            "type": "town",
            "poly": [
                [
                    91.8917689,
                    53.3190219
                ],
                [
                    91.8919449,
                    53.3203141
                ],
                [
                    91.8919759,
                    53.3210126
                ],
                [
                    91.8922347,
                    53.3218719
                ],
                [
                    91.892452,
                    53.3222304
                ],
                [
                    91.8926693,
                    53.3229846
                ],
                [
                    91.8935697,
                    53.324703
                ],
                [
                    91.893311,
                    53.3253026
                ],
                [
                    91.8934041,
                    53.325828
                ],
                [
                    91.8935179,
                    53.3264461
                ],
                [
                    91.8943148,
                    53.3274597
                ],
                [
                    91.8956941,
                    53.3284368
                ],
                [
                    91.8969015,
                    53.3288345
                ],
                [
                    91.8979114,
                    53.329289
                ],
                [
                    91.8985993,
                    53.3293808
                ],
                [
                    91.8991774,
                    53.3294289
                ],
                [
                    91.8995506,
                    53.329477
                ],
                [
                    91.9009044,
                    53.3298179
                ],
                [
                    91.9015704,
                    53.3298834
                ],
                [
                    91.9021777,
                    53.3300932
                ],
                [
                    91.9024339,
                    53.3303685
                ],
                [
                    91.90299,
                    53.3305215
                ],
                [
                    91.9036047,
                    53.3308361
                ],
                [
                    91.9045414,
                    53.3315484
                ],
                [
                    91.9053537,
                    53.331933
                ],
                [
                    91.9058,
                    53.3321777
                ],
                [
                    91.9073954,
                    53.3326716
                ],
                [
                    91.9084931,
                    53.333126
                ],
                [
                    91.90902,
                    53.3334407
                ],
                [
                    91.9095469,
                    53.3336155
                ],
                [
                    91.910425,
                    53.3336984
                ],
                [
                    91.9115666,
                    53.3339389
                ],
                [
                    91.9125399,
                    53.3340568
                ],
                [
                    91.9137034,
                    53.3344458
                ],
                [
                    91.9139303,
                    53.3344632
                ],
                [
                    91.9140913,
                    53.3343889
                ],
                [
                    91.9142669,
                    53.3341617
                ],
                [
                    91.9155256,
                    53.3333096
                ],
                [
                    91.9173451,
                    53.3330659
                ],
                [
                    91.9183489,
                    53.3330875
                ],
                [
                    91.9190527,
                    53.3333068
                ],
                [
                    91.9201497,
                    53.3338446
                ],
                [
                    91.9203567,
                    53.3343174
                ],
                [
                    91.9206878,
                    53.3347067
                ],
                [
                    91.921226,
                    53.3348518
                ],
                [
                    91.9221522,
                    53.3348334
                ],
                [
                    91.9230319,
                    53.3349971
                ],
                [
                    91.9241526,
                    53.3354699
                ],
                [
                    91.9252134,
                    53.3357418
                ],
                [
                    91.9256688,
                    53.3359612
                ],
                [
                    91.9260413,
                    53.3363505
                ],
                [
                    91.9263156,
                    53.3367583
                ],
                [
                    91.9266002,
                    53.3374041
                ],
                [
                    91.9268744,
                    53.337778
                ],
                [
                    91.9277955,
                    53.3385751
                ],
                [
                    91.9280439,
                    53.3387327
                ],
                [
                    91.928877,
                    53.3393877
                ],
                [
                    91.9309882,
                    53.3403082
                ],
                [
                    91.9319092,
                    53.3405462
                ],
                [
                    91.9349414,
                    53.3418654
                ],
                [
                    91.9362899,
                    53.3431295
                ],
                [
                    91.9369833,
                    53.3434817
                ],
                [
                    91.9379043,
                    53.343803
                ],
                [
                    91.9389858,
                    53.3438091
                ],
                [
                    91.9396171,
                    53.3439296
                ],
                [
                    91.9404761,
                    53.3439821
                ],
                [
                    91.9409055,
                    53.3441026
                ],
                [
                    91.9426235,
                    53.3448224
                ],
                [
                    91.9445588,
                    53.3451993
                ],
                [
                    91.9463906,
                    53.3453939
                ],
                [
                    91.9472496,
                    53.3455329
                ],
                [
                    91.9474596,
                    53.3455854
                ],
                [
                    91.9481012,
                    53.3459746
                ],
                [
                    91.9480184,
                    53.3463948
                ],
                [
                    91.9502952,
                    53.3468211
                ],
                [
                    91.9575085,
                    53.3488041
                ],
                [
                    91.9599809,
                    53.3528991
                ],
                [
                    91.9636618,
                    53.3565437
                ],
                [
                    91.962769,
                    53.3588235
                ],
                [
                    91.9599004,
                    53.3613302
                ],
                [
                    91.959432,
                    53.363601
                ],
                [
                    91.9589491,
                    53.3644395
                ],
                [
                    91.9549974,
                    53.365732
                ],
                [
                    91.9530956,
                    53.3671046
                ],
                [
                    91.953582,
                    53.3674196
                ],
                [
                    91.954441,
                    53.3676913
                ],
                [
                    91.9559209,
                    53.3679012
                ],
                [
                    91.9611782,
                    53.3695067
                ],
                [
                    91.9617992,
                    53.3699573
                ],
                [
                    91.9622856,
                    53.3705501
                ],
                [
                    91.9625029,
                    53.3704699
                ],
                [
                    91.963869,
                    53.3711245
                ],
                [
                    91.9654835,
                    53.3714702
                ],
                [
                    91.9659388,
                    53.3716616
                ],
                [
                    91.9661147,
                    53.3718592
                ],
                [
                    91.9698508,
                    53.3738473
                ],
                [
                    91.9704096,
                    53.375076
                ],
                [
                    91.9705855,
                    53.3761996
                ],
                [
                    91.9734212,
                    53.3790704
                ],
                [
                    91.9743319,
                    53.3807186
                ],
                [
                    91.9736489,
                    53.383589
                ],
                [
                    91.9725312,
                    53.3853544
                ],
                [
                    91.9741353,
                    53.3854285
                ],
                [
                    91.9760395,
                    53.3860519
                ],
                [
                    91.9773745,
                    53.3857927
                ],
                [
                    91.9806895,
                    53.38532
                ],
                [
                    91.9829156,
                    53.3852839
                ],
                [
                    91.9837215,
                    53.3848814
                ],
                [
                    91.9850411,
                    53.3844307
                ],
                [
                    91.986542,
                    53.3841664
                ],
                [
                    91.9790669,
                    53.3710338
                ],
                [
                    91.9722159,
                    53.3590693
                ],
                [
                    91.979257,
                    53.357374
                ],
                [
                    91.9808889,
                    53.3562979
                ],
                [
                    91.9818357,
                    53.3554622
                ],
                [
                    91.982148,
                    53.3550353
                ],
                [
                    91.9824703,
                    53.3548429
                ],
                [
                    91.9826517,
                    53.3545363
                ],
                [
                    91.9827322,
                    53.3543078
                ],
                [
                    91.9827725,
                    53.3541515
                ],
                [
                    91.982692,
                    53.3538568
                ],
                [
                    91.9819566,
                    53.3525582
                ],
                [
                    91.9819566,
                    53.3523779
                ],
                [
                    91.9806572,
                    53.3520712
                ],
                [
                    91.9801737,
                    53.3518067
                ],
                [
                    91.9799521,
                    53.351482
                ],
                [
                    91.9800427,
                    53.3512475
                ],
                [
                    91.9799521,
                    53.3511393
                ],
                [
                    91.9800628,
                    53.3509829
                ],
                [
                    91.9808184,
                    53.3508866
                ],
                [
                    91.9823092,
                    53.3500208
                ],
                [
                    91.982017,
                    53.3494557
                ],
                [
                    91.9816746,
                    53.3491731
                ],
                [
                    91.9814127,
                    53.3488303
                ],
                [
                    91.9810198,
                    53.3480666
                ],
                [
                    91.9810648,
                    53.3478744
                ],
                [
                    91.9789897,
                    53.3474835
                ],
                [
                    91.9780126,
                    53.3474114
                ],
                [
                    91.9769549,
                    53.3473393
                ],
                [
                    91.9766628,
                    53.3473633
                ],
                [
                    91.9756454,
                    53.3475376
                ],
                [
                    91.974074,
                    53.3474415
                ],
                [
                    91.9732984,
                    53.3473212
                ],
                [
                    91.9718076,
                    53.3468041
                ],
                [
                    91.9715255,
                    53.3466237
                ],
                [
                    91.9694303,
                    53.3459021
                ],
                [
                    91.9694807,
                    53.3456074
                ],
                [
                    91.9689367,
                    53.3455652
                ],
                [
                    91.9683827,
                    53.3454571
                ],
                [
                    91.9676474,
                    53.3453669
                ],
                [
                    91.9668415,
                    53.3453548
                ],
                [
                    91.9661767,
                    53.3455652
                ],
                [
                    91.9652802,
                    53.3452045
                ],
                [
                    91.9651492,
                    53.3450722
                ],
                [
                    91.9645449,
                    53.3445971
                ],
                [
                    91.9641319,
                    53.3443446
                ],
                [
                    91.9635376,
                    53.3435447
                ],
                [
                    91.9613801,
                    53.3386279
                ],
                [
                    91.9629259,
                    53.3380537
                ],
                [
                    91.9632962,
                    53.3375136
                ],
                [
                    91.963517,
                    53.3374285
                ],
                [
                    91.9635883,
                    53.337335
                ],
                [
                    91.963517,
                    53.3369734
                ],
                [
                    91.9635811,
                    53.3367991
                ],
                [
                    91.9635028,
                    53.3366204
                ],
                [
                    91.9645996,
                    53.3346703
                ],
                [
                    91.965194,
                    53.3346974
                ],
                [
                    91.9654105,
                    53.3342794
                ],
                [
                    91.9649019,
                    53.3342162
                ],
                [
                    91.9652997,
                    53.3336628
                ],
                [
                    91.9663434,
                    53.331893
                ],
                [
                    91.9664788,
                    53.3315825
                ],
                [
                    91.966607,
                    53.3303573
                ],
                [
                    91.9640921,
                    53.3302328
                ],
                [
                    91.9614177,
                    53.3296553
                ],
                [
                    91.9600831,
                    53.3283946
                ],
                [
                    91.9592773,
                    53.3280757
                ],
                [
                    91.9577764,
                    53.3257776
                ],
                [
                    91.9576958,
                    53.3244239
                ],
                [
                    91.9569302,
                    53.3232506
                ],
                [
                    91.958552,
                    53.3212892
                ],
                [
                    91.9583908,
                    53.3209763
                ],
                [
                    91.9559632,
                    53.3209462
                ],
                [
                    91.9555804,
                    53.3209342
                ],
                [
                    91.9551876,
                    53.3208198
                ],
                [
                    91.9547041,
                    53.3202903
                ],
                [
                    91.9538882,
                    53.3197007
                ],
                [
                    91.952629,
                    53.3189846
                ],
                [
                    91.9527297,
                    53.3184069
                ],
                [
                    91.9516217,
                    53.3178955
                ],
                [
                    91.9499999,
                    53.316012
                ],
                [
                    91.9496977,
                    53.3153741
                ],
                [
                    91.9486804,
                    53.3146219
                ],
                [
                    91.9487307,
                    53.3138154
                ],
                [
                    91.9478947,
                    53.3120461
                ],
                [
                    91.9499899,
                    53.3073216
                ],
                [
                    91.9474414,
                    53.3072674
                ],
                [
                    91.9437546,
                    53.3068581
                ],
                [
                    91.9406521,
                    53.3066896
                ],
                [
                    91.9402693,
                    53.3084651
                ],
                [
                    91.9399369,
                    53.3087962
                ],
                [
                    91.9393829,
                    53.3098555
                ],
                [
                    91.9383713,
                    53.3107956
                ],
                [
                    91.9328939,
                    53.3105403
                ],
                [
                    91.9314836,
                    53.310387
                ],
                [
                    91.9309494,
                    53.3103998
                ],
                [
                    91.9303012,
                    53.3106083
                ],
                [
                    91.9295747,
                    53.3107828
                ],
                [
                    91.9292114,
                    53.3107658
                ],
                [
                    91.9282972,
                    53.3106
                ],
                [
                    91.9275208,
                    53.3103446
                ],
                [
                    91.926659,
                    53.3103318
                ],
                [
                    91.9264382,
                    53.3102425
                ],
                [
                    91.9263384,
                    53.3100637
                ],
                [
                    91.9263099,
                    53.3098467
                ],
                [
                    91.9265236,
                    53.3096254
                ],
                [
                    91.9267159,
                    53.3092296
                ],
                [
                    91.9265236,
                    53.3086627
                ],
                [
                    91.9268762,
                    53.3080608
                ],
                [
                    91.9268258,
                    53.3077599
                ],
                [
                    91.927259,
                    53.3073144
                ],
                [
                    91.9274907,
                    53.3068149
                ],
                [
                    91.9273496,
                    53.3061408
                ],
                [
                    91.9269063,
                    53.3051777
                ],
                [
                    91.9260905,
                    53.3043892
                ],
                [
                    91.9239248,
                    53.3031673
                ],
                [
                    91.9233506,
                    53.302776
                ],
                [
                    91.9224079,
                    53.3017527
                ],
                [
                    91.9215416,
                    53.301241
                ],
                [
                    91.9210783,
                    53.3011447
                ],
                [
                    91.9197587,
                    53.3010002
                ],
                [
                    91.9177139,
                    53.3007052
                ],
                [
                    91.9168174,
                    53.3007112
                ],
                [
                    91.9153165,
                    53.3002658
                ],
                [
                    91.9147725,
                    53.3002116
                ],
                [
                    91.9135436,
                    53.3000009
                ],
                [
                    91.911398,
                    53.2994049
                ],
                [
                    91.9104512,
                    53.2990617
                ],
                [
                    91.9092524,
                    53.2987186
                ],
                [
                    91.9063661,
                    53.2982552
                ],
                [
                    91.905832,
                    53.2982382
                ],
                [
                    91.9047351,
                    53.2983063
                ],
                [
                    91.9031603,
                    53.2984889
                ],
                [
                    91.9048092,
                    53.3015096
                ],
                [
                    91.9050112,
                    53.3019164
                ],
                [
                    91.9051814,
                    53.3026089
                ],
                [
                    91.9049368,
                    53.3035684
                ],
                [
                    91.9047029,
                    53.304172
                ],
                [
                    91.9046285,
                    53.3048136
                ],
                [
                    91.9037352,
                    53.3089056
                ],
                [
                    91.9034482,
                    53.3106083
                ],
                [
                    91.9032143,
                    53.311342
                ],
                [
                    91.9024328,
                    53.3120472
                ],
                [
                    91.9021883,
                    53.3123934
                ],
                [
                    91.9018587,
                    53.3132414
                ],
                [
                    91.9017524,
                    53.3139338
                ],
                [
                    91.9017949,
                    53.3142355
                ],
                [
                    91.9019437,
                    53.314461
                ],
                [
                    91.902284,
                    53.3147405
                ],
                [
                    91.9046032,
                    53.3159388
                ],
                [
                    91.9049433,
                    53.3163263
                ],
                [
                    91.9054005,
                    53.3169297
                ],
                [
                    91.9032103,
                    53.3171965
                ],
                [
                    91.9008604,
                    53.3172981
                ],
                [
                    91.8998079,
                    53.3175776
                ],
                [
                    91.8996484,
                    53.3178126
                ],
                [
                    91.8981598,
                    53.3189749
                ],
                [
                    91.8978515,
                    53.3189686
                ],
                [
                    91.8974262,
                    53.3190321
                ],
                [
                    91.8964161,
                    53.3193369
                ],
                [
                    91.8958631,
                    53.3194195
                ],
                [
                    91.8937473,
                    53.3194322
                ],
                [
                    91.8917689,
                    53.3190219
                ]
            ],
            "longitude": 91.945374,
            "latitude": 53.32782
        },
        "5736": {
            "name": "ИДРИНСКОЕ",
            "population": 5135,
            "type": "town",
            "poly": null,
            "longitude": 92.133156,
            "latitude": 54.370876
        },
        "5737": {
            "name": "ЕНИСЕЙСК",
            "population": 18359,
            "type": "town",
            "poly": [
                [
                    92.0882658,
                    58.4663312
                ],
                [
                    92.0884454,
                    58.4691596
                ],
                [
                    92.1044053,
                    58.4690855
                ],
                [
                    92.1027918,
                    58.4749017
                ],
                [
                    92.1022756,
                    58.4777241
                ],
                [
                    92.1012656,
                    58.4806694
                ],
                [
                    92.1001096,
                    58.4829516
                ],
                [
                    92.1075166,
                    58.4837436
                ],
                [
                    92.1100304,
                    58.4838551
                ],
                [
                    92.1268828,
                    58.4840511
                ],
                [
                    92.1302807,
                    58.477107
                ],
                [
                    92.143327,
                    58.4670534
                ],
                [
                    92.1632397,
                    58.4623847
                ],
                [
                    92.184869,
                    58.4623847
                ],
                [
                    92.2010052,
                    58.4686694
                ],
                [
                    92.2216046,
                    58.4744144
                ],
                [
                    92.2463238,
                    58.4742349
                ],
                [
                    92.253677,
                    58.4731234
                ],
                [
                    92.2539181,
                    58.4727796
                ],
                [
                    92.2540497,
                    58.4685271
                ],
                [
                    92.251244,
                    58.4683322
                ],
                [
                    92.2506741,
                    58.4677934
                ],
                [
                    92.2503892,
                    58.4675642
                ],
                [
                    92.2498631,
                    58.4673693
                ],
                [
                    92.249885,
                    58.4671171
                ],
                [
                    92.2480657,
                    58.4665783
                ],
                [
                    92.2473205,
                    58.4662115
                ],
                [
                    92.2459177,
                    58.4657414
                ],
                [
                    92.2454328,
                    58.465171
                ],
                [
                    92.2458458,
                    58.4651335
                ],
                [
                    92.2462677,
                    58.4648658
                ],
                [
                    92.2467615,
                    58.4645277
                ],
                [
                    92.246977,
                    58.4639783
                ],
                [
                    92.2474528,
                    58.4635134
                ],
                [
                    92.2477581,
                    58.4630297
                ],
                [
                    92.2486379,
                    58.4624099
                ],
                [
                    92.2492215,
                    58.46179
                ],
                [
                    92.2499847,
                    58.4611231
                ],
                [
                    92.2499667,
                    58.4606958
                ],
                [
                    92.2496345,
                    58.4601275
                ],
                [
                    92.2499039,
                    58.4598833
                ],
                [
                    92.2505862,
                    58.4596907
                ],
                [
                    92.2508466,
                    58.4590098
                ],
                [
                    92.2516636,
                    58.4582348
                ],
                [
                    92.2521663,
                    58.458061
                ],
                [
                    92.2531719,
                    58.4580423
                ],
                [
                    92.2546084,
                    58.4582583
                ],
                [
                    92.2553176,
                    58.4581644
                ],
                [
                    92.2553356,
                    58.4579155
                ],
                [
                    92.2552009,
                    58.4577323
                ],
                [
                    92.2553895,
                    58.4574974
                ],
                [
                    92.255578,
                    58.4572579
                ],
                [
                    92.2553895,
                    58.4569902
                ],
                [
                    92.2550752,
                    58.4567648
                ],
                [
                    92.2551381,
                    58.4565205
                ],
                [
                    92.255596,
                    58.4562622
                ],
                [
                    92.2565925,
                    58.4558911
                ],
                [
                    92.2568619,
                    58.4555623
                ],
                [
                    92.2569157,
                    58.455257
                ],
                [
                    92.2574006,
                    58.4548296
                ],
                [
                    92.2574006,
                    58.4544304
                ],
                [
                    92.257616,
                    58.4542847
                ],
                [
                    92.2583432,
                    58.4542378
                ],
                [
                    92.2653551,
                    58.4542754
                ],
                [
                    92.2694042,
                    58.4540593
                ],
                [
                    92.2719091,
                    58.4538009
                ],
                [
                    92.2734444,
                    58.4534721
                ],
                [
                    92.2747283,
                    58.4530447
                ],
                [
                    92.2766316,
                    58.4525703
                ],
                [
                    92.2791455,
                    58.4519173
                ],
                [
                    92.2791365,
                    58.4517294
                ],
                [
                    92.27893,
                    58.451471
                ],
                [
                    92.2783195,
                    58.4510765
                ],
                [
                    92.2779963,
                    58.4507993
                ],
                [
                    92.2776012,
                    58.4505879
                ],
                [
                    92.2763982,
                    58.4503201
                ],
                [
                    92.2758056,
                    58.4501886
                ],
                [
                    92.2753388,
                    58.4502826
                ],
                [
                    92.2738035,
                    58.450804
                ],
                [
                    92.2733097,
                    58.4507382
                ],
                [
                    92.2729237,
                    58.4504846
                ],
                [
                    92.2729506,
                    58.4503295
                ],
                [
                    92.273184,
                    58.4501322
                ],
                [
                    92.2761647,
                    58.4486336
                ],
                [
                    92.2762455,
                    58.4484175
                ],
                [
                    92.2760301,
                    58.448131
                ],
                [
                    92.2755273,
                    58.4477128
                ],
                [
                    92.2747552,
                    58.4472054
                ],
                [
                    92.2745756,
                    58.4469424
                ],
                [
                    92.2750245,
                    58.4465618
                ],
                [
                    92.277269,
                    58.4454812
                ],
                [
                    92.2775474,
                    58.4451805
                ],
                [
                    92.2775294,
                    58.4448845
                ],
                [
                    92.277718,
                    58.4447342
                ],
                [
                    92.2785709,
                    58.4443959
                ],
                [
                    92.2786517,
                    58.4442925
                ],
                [
                    92.2784811,
                    58.4441187
                ],
                [
                    92.2784452,
                    58.4439824
                ],
                [
                    92.2786966,
                    58.443818
                ],
                [
                    92.2802408,
                    58.4432306
                ],
                [
                    92.2801241,
                    58.443038
                ],
                [
                    92.2784811,
                    58.4418539
                ],
                [
                    92.2783374,
                    58.4414733
                ],
                [
                    92.2776461,
                    58.4412337
                ],
                [
                    92.2767842,
                    58.4398898
                ],
                [
                    92.2768381,
                    58.4394105
                ],
                [
                    92.2772242,
                    58.4388325
                ],
                [
                    92.2774127,
                    58.4382873
                ],
                [
                    92.2774486,
                    58.4378127
                ],
                [
                    92.2770626,
                    58.4374979
                ],
                [
                    92.2764341,
                    58.4371313
                ],
                [
                    92.2761917,
                    58.4368869
                ],
                [
                    92.2749168,
                    58.4365016
                ],
                [
                    92.2692965,
                    58.4387291
                ],
                [
                    92.2685244,
                    58.4388372
                ],
                [
                    92.2681383,
                    58.4389499
                ],
                [
                    92.2679139,
                    58.4391003
                ],
                [
                    92.2674829,
                    58.4390862
                ],
                [
                    92.2668186,
                    58.4390815
                ],
                [
                    92.2663786,
                    58.4390768
                ],
                [
                    92.2661632,
                    58.438917
                ],
                [
                    92.2656694,
                    58.4380195
                ],
                [
                    92.2636762,
                    58.4371924
                ],
                [
                    92.2623654,
                    58.4367131
                ],
                [
                    92.2598148,
                    58.4348469
                ],
                [
                    92.2588503,
                    58.4345371
                ],
                [
                    92.2593326,
                    58.4342731
                ],
                [
                    92.2588942,
                    58.4338945
                ],
                [
                    92.2449317,
                    58.4259649
                ],
                [
                    92.2439234,
                    58.4172414
                ],
                [
                    92.244033,
                    58.415175
                ],
                [
                    92.2434412,
                    58.4091587
                ],
                [
                    92.2432877,
                    58.4087109
                ],
                [
                    92.243748,
                    58.4081827
                ],
                [
                    92.243747,
                    58.4079576
                ],
                [
                    92.2423712,
                    58.4079781
                ],
                [
                    92.2417961,
                    58.4063907
                ],
                [
                    92.2391307,
                    58.4058542
                ],
                [
                    92.2383171,
                    58.4058321
                ],
                [
                    92.2366056,
                    58.4062731
                ],
                [
                    92.231007,
                    58.4045537
                ],
                [
                    92.230039,
                    58.4050608
                ],
                [
                    92.2295621,
                    58.4049653
                ],
                [
                    92.2279488,
                    58.4041862
                ],
                [
                    92.2287765,
                    58.4037452
                ],
                [
                    92.2280189,
                    58.4032822
                ],
                [
                    92.2257183,
                    58.4029
                ],
                [
                    92.2175398,
                    58.4010036
                ],
                [
                    92.2059525,
                    58.4009301
                ],
                [
                    92.2057701,
                    58.4015623
                ],
                [
                    92.197774,
                    58.4040245
                ],
                [
                    92.1971147,
                    58.4042965
                ],
                [
                    92.1872949,
                    58.4070966
                ],
                [
                    92.1854151,
                    58.4073905
                ],
                [
                    92.18087,
                    58.4086619
                ],
                [
                    92.1802527,
                    58.408706
                ],
                [
                    92.1797337,
                    58.4084855
                ],
                [
                    92.1764791,
                    58.4065748
                ],
                [
                    92.175399,
                    58.4062073
                ],
                [
                    92.1738278,
                    58.4060824
                ],
                [
                    92.1713448,
                    58.4059868
                ],
                [
                    92.1690442,
                    58.4061706
                ],
                [
                    92.1678097,
                    58.4064499
                ],
                [
                    92.1647094,
                    58.4072215
                ],
                [
                    92.1612725,
                    58.4078682
                ],
                [
                    92.1607815,
                    58.4124243
                ],
                [
                    92.1610621,
                    58.4129607
                ],
                [
                    92.1616372,
                    58.4132767
                ],
                [
                    92.1615024,
                    58.4137447
                ],
                [
                    92.1613481,
                    58.4142003
                ],
                [
                    92.1609273,
                    58.4144721
                ],
                [
                    92.1610395,
                    58.4147293
                ],
                [
                    92.1606888,
                    58.414766
                ],
                [
                    92.1600715,
                    58.4146558
                ],
                [
                    92.1602399,
                    58.4148469
                ],
                [
                    92.16031,
                    58.4151481
                ],
                [
                    92.1599313,
                    58.415633
                ],
                [
                    92.1593982,
                    58.4156404
                ],
                [
                    92.1586266,
                    58.4156477
                ],
                [
                    92.1583741,
                    58.4154126
                ],
                [
                    92.1577849,
                    58.4153832
                ],
                [
                    92.1575044,
                    58.4155302
                ],
                [
                    92.1571116,
                    58.4155302
                ],
                [
                    92.1569853,
                    58.4153171
                ],
                [
                    92.1564663,
                    58.415251
                ],
                [
                    92.1558631,
                    58.4152069
                ],
                [
                    92.1559613,
                    58.4149277
                ],
                [
                    92.1559472,
                    58.4147073
                ],
                [
                    92.1558911,
                    58.4144575
                ],
                [
                    92.1554422,
                    58.4144575
                ],
                [
                    92.1551757,
                    58.4146926
                ],
                [
                    92.1551476,
                    58.4148616
                ],
                [
                    92.1545164,
                    58.4150453
                ],
                [
                    92.1541516,
                    58.4153098
                ],
                [
                    92.1544041,
                    58.4154641
                ],
                [
                    92.1545023,
                    58.415611
                ],
                [
                    92.1539693,
                    58.415589
                ],
                [
                    92.1538149,
                    58.4154714
                ],
                [
                    92.1537729,
                    58.4152436
                ],
                [
                    92.153338,
                    58.4154567
                ],
                [
                    92.1519632,
                    58.4157286
                ],
                [
                    92.1514582,
                    58.4157726
                ],
                [
                    92.1514582,
                    58.4158461
                ],
                [
                    92.1521933,
                    58.4161047
                ],
                [
                    92.1523841,
                    58.4163457
                ],
                [
                    92.1522157,
                    58.4164515
                ],
                [
                    92.1515199,
                    58.4162752
                ],
                [
                    92.1513516,
                    58.4164045
                ],
                [
                    92.1513516,
                    58.4166044
                ],
                [
                    92.1508578,
                    58.4167454
                ],
                [
                    92.1500834,
                    58.4166984
                ],
                [
                    92.1493652,
                    58.4163986
                ],
                [
                    92.1485572,
                    58.4160048
                ],
                [
                    92.1475928,
                    58.4161319
                ],
                [
                    92.1474411,
                    58.4164328
                ],
                [
                    92.1472527,
                    58.4164256
                ],
                [
                    92.1468206,
                    58.4162739
                ],
                [
                    92.1466965,
                    58.4164882
                ],
                [
                    92.1462276,
                    58.416558
                ],
                [
                    92.1455243,
                    58.4165243
                ],
                [
                    92.1448256,
                    58.4163727
                ],
                [
                    92.1436396,
                    58.4163293
                ],
                [
                    92.142849,
                    58.4162499
                ],
                [
                    92.1422284,
                    58.4162764
                ],
                [
                    92.1419066,
                    58.4158815
                ],
                [
                    92.1404979,
                    58.4147427
                ],
                [
                    92.1384918,
                    58.4135083
                ],
                [
                    92.1373555,
                    58.4126707
                ],
                [
                    92.131127,
                    58.4127662
                ],
                [
                    92.1299907,
                    58.413016
                ],
                [
                    92.1295278,
                    58.4132805
                ],
                [
                    92.1256419,
                    58.4138463
                ],
                [
                    92.1198342,
                    58.4135598
                ],
                [
                    92.1171408,
                    58.4131556
                ],
                [
                    92.1109824,
                    58.4128103
                ],
                [
                    92.1074333,
                    58.4124429
                ],
                [
                    92.1071106,
                    58.4126413
                ],
                [
                    92.1065635,
                    58.4125898
                ],
                [
                    92.106325,
                    58.4122224
                ],
                [
                    92.099339,
                    58.4112598
                ],
                [
                    92.0917751,
                    58.4454404
                ],
                [
                    92.0908071,
                    58.4463213
                ],
                [
                    92.0974426,
                    58.4547458
                ],
                [
                    92.0938251,
                    58.4598695
                ],
                [
                    92.0915051,
                    58.4592533
                ],
                [
                    92.0905355,
                    58.4612784
                ],
                [
                    92.0898891,
                    58.4621913
                ],
                [
                    92.0902123,
                    58.4623416
                ],
                [
                    92.0898316,
                    58.462954
                ],
                [
                    92.09032,
                    58.463078
                ],
                [
                    92.0891995,
                    58.4644754
                ],
                [
                    92.0882658,
                    58.4663312
                ]
            ],
            "longitude": 92.1748169,
            "latitude": 58.4532212
        },
        "5738": {
            "name": "КЕДРОВЫЙ",
            "population": 5370,
            "type": "town",
            "poly": null,
            "longitude": 92.323425,
            "latitude": 56.23724
        },
        "5739": {
            "name": "ДИВНОГОРСК",
            "population": 29115,
            "type": "town",
            "poly": [
                [
                    92.300382,
                    55.9514678
                ],
                [
                    92.3009935,
                    55.9529491
                ],
                [
                    92.3107246,
                    55.9519244
                ],
                [
                    92.3163465,
                    55.957042
                ],
                [
                    92.3225692,
                    55.9613181
                ],
                [
                    92.3306047,
                    55.9636271
                ],
                [
                    92.346516,
                    55.9672751
                ],
                [
                    92.3542836,
                    55.9683799
                ],
                [
                    92.3650983,
                    55.9692686
                ],
                [
                    92.3725656,
                    55.9693646
                ],
                [
                    92.3839381,
                    55.9687882
                ],
                [
                    92.3933366,
                    55.9680917
                ],
                [
                    92.403293,
                    55.9660261
                ],
                [
                    92.410889,
                    55.964609
                ],
                [
                    92.4138072,
                    55.9635761
                ],
                [
                    92.4162191,
                    55.9614526
                ],
                [
                    92.4170259,
                    55.9605494
                ],
                [
                    92.416845,
                    55.95923
                ],
                [
                    92.414202,
                    55.9580414
                ],
                [
                    92.4118417,
                    55.95672
                ],
                [
                    92.4114898,
                    55.9554563
                ],
                [
                    92.4133351,
                    55.9544232
                ],
                [
                    92.4139137,
                    55.9532569
                ],
                [
                    92.4122623,
                    55.9520205
                ],
                [
                    92.4091294,
                    55.9452441
                ],
                [
                    92.3900321,
                    55.9458208
                ],
                [
                    92.3826936,
                    55.9464457
                ],
                [
                    92.371321,
                    55.9454363
                ],
                [
                    92.3633388,
                    55.949065
                ],
                [
                    92.352052,
                    55.9502184
                ],
                [
                    92.339907,
                    55.9504106
                ],
                [
                    92.3340276,
                    55.9500502
                ],
                [
                    92.3274701,
                    55.9489604
                ],
                [
                    92.3201745,
                    55.945476
                ],
                [
                    92.308965,
                    55.9489688
                ],
                [
                    92.300382,
                    55.9514678
                ]
            ],
            "longitude": 92.37542,
            "latitude": 55.959644
        },
        "5740": {
            "name": "ЕРМАКОВСКОЕ",
            "population": 8557,
            "type": "town",
            "poly": [
                [
                    92.3165757,
                    53.2696812
                ],
                [
                    92.3201755,
                    53.2768932
                ],
                [
                    92.3202099,
                    53.2773319
                ],
                [
                    92.3636246,
                    53.2765368
                ],
                [
                    92.363166,
                    53.2769343
                ],
                [
                    92.3628794,
                    53.2773525
                ],
                [
                    92.3628221,
                    53.2779283
                ],
                [
                    92.3624667,
                    53.2795733
                ],
                [
                    92.3622947,
                    53.2798475
                ],
                [
                    92.3642665,
                    53.2805536
                ],
                [
                    92.3681185,
                    53.2805468
                ],
                [
                    92.3679236,
                    53.2813898
                ],
                [
                    92.3681758,
                    53.282082
                ],
                [
                    92.3694216,
                    53.2820087
                ],
                [
                    92.3699871,
                    53.2802931
                ],
                [
                    92.3700427,
                    53.280373
                ],
                [
                    92.3719475,
                    53.278415
                ],
                [
                    92.3734035,
                    53.2780243
                ],
                [
                    92.383916,
                    53.2820341
                ],
                [
                    92.3879973,
                    53.2835077
                ],
                [
                    92.3969852,
                    53.2869003
                ],
                [
                    92.4150297,
                    53.293664
                ],
                [
                    92.4160959,
                    53.2939312
                ],
                [
                    92.4170016,
                    53.2939655
                ],
                [
                    92.4180791,
                    53.2940066
                ],
                [
                    92.4190473,
                    53.2939172
                ],
                [
                    92.4201822,
                    53.2937138
                ],
                [
                    92.4212036,
                    53.2932923
                ],
                [
                    92.4221682,
                    53.2927738
                ],
                [
                    92.4227924,
                    53.2922311
                ],
                [
                    92.4232707,
                    53.2916497
                ],
                [
                    92.4236841,
                    53.2908162
                ],
                [
                    92.4246569,
                    53.2887277
                ],
                [
                    92.4250865,
                    53.2879621
                ],
                [
                    92.4255648,
                    53.2872546
                ],
                [
                    92.4280372,
                    53.2875211
                ],
                [
                    92.4308339,
                    53.2874678
                ],
                [
                    92.4318959,
                    53.2871237
                ],
                [
                    92.4313527,
                    53.2865955
                ],
                [
                    92.4312311,
                    53.2861981
                ],
                [
                    92.4311987,
                    53.2857038
                ],
                [
                    92.4314957,
                    53.2851513
                ],
                [
                    92.4333764,
                    53.2842645
                ],
                [
                    92.4341871,
                    53.2836708
                ],
                [
                    92.4342681,
                    53.2827403
                ],
                [
                    92.4337209,
                    53.2820012
                ],
                [
                    92.4327968,
                    53.281657
                ],
                [
                    92.4318747,
                    53.2814473
                ],
                [
                    92.4344325,
                    53.2784391
                ],
                [
                    92.4289361,
                    53.2793513
                ],
                [
                    92.4231353,
                    53.2805856
                ],
                [
                    92.4222193,
                    53.2806583
                ],
                [
                    92.4206466,
                    53.2816761
                ],
                [
                    92.4190092,
                    53.2821462
                ],
                [
                    92.4171852,
                    53.2819281
                ],
                [
                    92.4161638,
                    53.2813611
                ],
                [
                    92.4155179,
                    53.2804671
                ],
                [
                    92.4162115,
                    53.2796617
                ],
                [
                    92.4183668,
                    53.2783456
                ],
                [
                    92.4185674,
                    53.2780063
                ],
                [
                    92.4186668,
                    53.2772014
                ],
                [
                    92.417314,
                    53.2756385
                ],
                [
                    92.416139,
                    53.2747233
                ],
                [
                    92.413336,
                    53.2743531
                ],
                [
                    92.4123959,
                    53.2736436
                ],
                [
                    92.4121781,
                    53.2727284
                ],
                [
                    92.4123415,
                    53.2720702
                ],
                [
                    92.4135047,
                    53.2712436
                ],
                [
                    92.4139019,
                    53.2703225
                ],
                [
                    92.4130589,
                    53.2694402
                ],
                [
                    92.4107242,
                    53.2688875
                ],
                [
                    92.4098974,
                    53.2678161
                ],
                [
                    92.4094597,
                    53.266604
                ],
                [
                    92.4095812,
                    53.2663275
                ],
                [
                    92.4103676,
                    53.2659446
                ],
                [
                    92.4092165,
                    53.2656828
                ],
                [
                    92.4052119,
                    53.2652173
                ],
                [
                    92.3986214,
                    53.258875
                ],
                [
                    92.3937126,
                    53.2599922
                ],
                [
                    92.3853039,
                    53.2618379
                ],
                [
                    92.3838435,
                    53.2623029
                ],
                [
                    92.3773352,
                    53.2705851
                ],
                [
                    92.3766773,
                    53.2716807
                ],
                [
                    92.3759529,
                    53.2717604
                ],
                [
                    92.375778,
                    53.2709485
                ],
                [
                    92.3753116,
                    53.2701617
                ],
                [
                    92.3702529,
                    53.2671609
                ],
                [
                    92.3689221,
                    53.2679639
                ],
                [
                    92.3688161,
                    53.2689007
                ],
                [
                    92.3689221,
                    53.2697458
                ],
                [
                    92.3683214,
                    53.2698374
                ],
                [
                    92.3673911,
                    53.2697529
                ],
                [
                    92.3662841,
                    53.2698092
                ],
                [
                    92.3642231,
                    53.2697881
                ],
                [
                    92.3630337,
                    53.2702248
                ],
                [
                    92.3629983,
                    53.2704009
                ],
                [
                    92.3614909,
                    53.2704642
                ],
                [
                    92.3598303,
                    53.2704783
                ],
                [
                    92.3574396,
                    53.2704079
                ],
                [
                    92.3551784,
                    53.2703304
                ],
                [
                    92.3551784,
                    53.271084
                ],
                [
                    92.3554847,
                    53.2711756
                ],
                [
                    92.35552,
                    53.2723447
                ],
                [
                    92.354201,
                    53.2725137
                ],
                [
                    92.3496669,
                    53.2725419
                ],
                [
                    92.349502,
                    53.2719926
                ],
                [
                    92.3491251,
                    53.2719644
                ],
                [
                    92.3486068,
                    53.2720489
                ],
                [
                    92.347865,
                    53.2720277
                ],
                [
                    92.3471701,
                    53.2719221
                ],
                [
                    92.3460631,
                    53.2718658
                ],
                [
                    92.3453801,
                    53.2719151
                ],
                [
                    92.3413523,
                    53.2718306
                ],
                [
                    92.3374895,
                    53.271908
                ],
                [
                    92.3329201,
                    53.2718306
                ],
                [
                    92.3312477,
                    53.2713939
                ],
                [
                    92.3299994,
                    53.2712671
                ],
                [
                    92.3298815,
                    53.2705276
                ],
                [
                    92.3286333,
                    53.2704642
                ],
                [
                    92.3272789,
                    53.2697951
                ],
                [
                    92.3264663,
                    53.2697318
                ],
                [
                    92.3255178,
                    53.2695098
                ],
                [
                    92.3229269,
                    53.2697154
                ],
                [
                    92.3221817,
                    53.2694755
                ],
                [
                    92.3204277,
                    53.2694138
                ],
                [
                    92.3191896,
                    53.2696195
                ],
                [
                    92.3165757,
                    53.2696812
                ]
            ],
            "longitude": 92.396088,
            "latitude": 53.278046
        },
        "5741": {
            "name": "ЛЕСОСИБИРСК",
            "population": 59903,
            "type": "town",
            "poly": [
                [
                    92.4369491,
                    58.250787
                ],
                [
                    92.4489496,
                    58.2559213
                ],
                [
                    92.4521105,
                    58.2564651
                ],
                [
                    92.456739,
                    58.2549882
                ],
                [
                    92.4678389,
                    58.2515832
                ],
                [
                    92.4712674,
                    58.2507713
                ],
                [
                    92.4817888,
                    58.2498354
                ],
                [
                    92.4862244,
                    58.2482004
                ],
                [
                    92.4875316,
                    58.2482117
                ],
                [
                    92.489803,
                    58.2485725
                ],
                [
                    92.4992314,
                    58.2460916
                ],
                [
                    92.5048242,
                    58.2430918
                ],
                [
                    92.5088956,
                    58.2398774
                ],
                [
                    92.5157313,
                    58.2339215
                ],
                [
                    92.5222026,
                    58.2250422
                ],
                [
                    92.5261455,
                    58.2183841
                ],
                [
                    92.528074,
                    58.2138695
                ],
                [
                    92.5283953,
                    58.211928
                ],
                [
                    92.5287597,
                    58.210596
                ],
                [
                    92.5305811,
                    58.2064981
                ],
                [
                    92.5307954,
                    58.2037658
                ],
                [
                    92.5308596,
                    58.2029981
                ],
                [
                    92.531824,
                    58.1987976
                ],
                [
                    92.5317811,
                    58.1967988
                ],
                [
                    92.5345025,
                    58.1909261
                ],
                [
                    92.5363842,
                    58.1869745
                ],
                [
                    92.541445,
                    58.1816385
                ],
                [
                    92.5494755,
                    58.1752311
                ],
                [
                    92.5582335,
                    58.1700851
                ],
                [
                    92.5659005,
                    58.1662811
                ],
                [
                    92.5762646,
                    58.162045
                ],
                [
                    92.5869923,
                    58.1581602
                ],
                [
                    92.600223,
                    58.1543669
                ],
                [
                    92.6047686,
                    58.1532076
                ],
                [
                    92.6109204,
                    58.1517765
                ],
                [
                    92.6186783,
                    58.1505771
                ],
                [
                    92.6255968,
                    58.1492815
                ],
                [
                    92.6233846,
                    58.1479861
                ],
                [
                    92.6085355,
                    58.1437159
                ],
                [
                    92.5918556,
                    58.1419206
                ],
                [
                    92.5480356,
                    58.1527316
                ],
                [
                    92.5325307,
                    58.1583379
                ],
                [
                    92.5133676,
                    58.1652658
                ],
                [
                    92.5102712,
                    58.1770233
                ],
                [
                    92.4707573,
                    58.2141101
                ],
                [
                    92.4378433,
                    58.2435804
                ],
                [
                    92.4369491,
                    58.250787
                ]
            ],
            "longitude": 92.48597,
            "latitude": 58.223511
        },
        "5742": {
            "name": "КУРАГИНО",
            "population": 13291,
            "type": "town",
            "poly": [
                [
                    92.6053012,
                    53.8669774
                ],
                [
                    92.607805,
                    53.8725201
                ],
                [
                    92.6096501,
                    53.8796936
                ],
                [
                    92.6193142,
                    53.8862962
                ],
                [
                    92.6476037,
                    53.8923542
                ],
                [
                    92.6660974,
                    53.8959005
                ],
                [
                    92.6799347,
                    53.8979195
                ],
                [
                    92.6849424,
                    53.9042863
                ],
                [
                    92.6966272,
                    53.9043899
                ],
                [
                    92.7039632,
                    53.9047522
                ],
                [
                    92.7151209,
                    53.9022677
                ],
                [
                    92.7102888,
                    53.8974536
                ],
                [
                    92.7073896,
                    53.8920953
                ],
                [
                    92.7219297,
                    53.8876166
                ],
                [
                    92.7290899,
                    53.8916811
                ],
                [
                    92.7383587,
                    53.8952534
                ],
                [
                    92.7475836,
                    53.8972465
                ],
                [
                    92.7653744,
                    53.9003007
                ],
                [
                    92.7708214,
                    53.8959264
                ],
                [
                    92.7615086,
                    53.8917329
                ],
                [
                    92.757599,
                    53.8889888
                ],
                [
                    92.7513613,
                    53.8869694
                ],
                [
                    92.7450797,
                    53.8846392
                ],
                [
                    92.7415654,
                    53.8849499
                ],
                [
                    92.7370409,
                    53.8865551
                ],
                [
                    92.7305396,
                    53.8843285
                ],
                [
                    92.7243018,
                    53.8857525
                ],
                [
                    92.7171855,
                    53.8837589
                ],
                [
                    92.7157359,
                    53.8820499
                ],
                [
                    92.7097617,
                    53.8769228
                ],
                [
                    92.700449,
                    53.8809365
                ],
                [
                    92.695573,
                    53.8805222
                ],
                [
                    92.6944961,
                    53.8792125
                ],
                [
                    92.6925275,
                    53.8773691
                ],
                [
                    92.6895109,
                    53.8773371
                ],
                [
                    92.685451,
                    53.8785481
                ],
                [
                    92.6825166,
                    53.8798457
                ],
                [
                    92.680573,
                    53.8807052
                ],
                [
                    92.680419,
                    53.8807361
                ],
                [
                    92.676069,
                    53.8816098
                ],
                [
                    92.6721988,
                    53.8827297
                ],
                [
                    92.6691774,
                    53.8833086
                ],
                [
                    92.6661501,
                    53.8837485
                ],
                [
                    92.6625234,
                    53.8839326
                ],
                [
                    92.6585594,
                    53.8835183
                ],
                [
                    92.654511,
                    53.8825738
                ],
                [
                    92.6502658,
                    53.8815132
                ],
                [
                    92.6494224,
                    53.8808835
                ],
                [
                    92.6472576,
                    53.8801211
                ],
                [
                    92.6447273,
                    53.8786462
                ],
                [
                    92.6390817,
                    53.8767415
                ],
                [
                    92.6317458,
                    53.8759905
                ],
                [
                    92.6271334,
                    53.8744366
                ],
                [
                    92.6238388,
                    53.8715878
                ],
                [
                    92.6234434,
                    53.8684797
                ],
                [
                    92.6178646,
                    53.8658635
                ],
                [
                    92.6095183,
                    53.8631954
                ],
                [
                    92.6053012,
                    53.8669774
                ]
            ],
            "longitude": 92.680222,
            "latitude": 53.888092
        },
        "5743": {
            "name": "ЕМЕЛЬЯНОВО",
            "population": 11689,
            "type": "town",
            "poly": null,
            "longitude": 92.688454,
            "latitude": 56.167255
        },
        "5744": {
            "name": "КАРАТУЗСКОЕ",
            "population": 7456,
            "type": "town",
            "poly": null,
            "longitude": 92.868996,
            "latitude": 53.600666
        },
        "5745": {
            "name": "СТРЕЛКА",
            "population": 4886,
            "type": "town",
            "poly": [
                [
                    92.9564791,
                    58.0567016
                ],
                [
                    92.9568224,
                    58.0591537
                ],
                [
                    92.9580241,
                    58.0611516
                ],
                [
                    92.959569,
                    58.0636034
                ],
                [
                    92.9626589,
                    58.0654195
                ],
                [
                    92.9660922,
                    58.0669631
                ],
                [
                    92.9684954,
                    58.0682342
                ],
                [
                    92.96898,
                    58.0684625
                ],
                [
                    92.9710027,
                    58.0694152
                ],
                [
                    92.9715644,
                    58.0696798
                ],
                [
                    92.9755012,
                    58.0713764
                ],
                [
                    92.9794494,
                    58.0732828
                ],
                [
                    92.9840842,
                    58.0751891
                ],
                [
                    92.9855903,
                    58.0759523
                ],
                [
                    92.9862912,
                    58.0763075
                ],
                [
                    92.9882041,
                    58.0772769
                ],
                [
                    92.990264,
                    58.0790923
                ],
                [
                    92.9928389,
                    58.0809075
                ],
                [
                    92.9954139,
                    58.0822689
                ],
                [
                    92.9991904,
                    58.0839933
                ],
                [
                    93.001937,
                    58.0857175
                ],
                [
                    93.0041686,
                    58.0867158
                ],
                [
                    93.0058852,
                    58.0859898
                ],
                [
                    93.0076018,
                    58.0850823
                ],
                [
                    93.0088035,
                    58.0849915
                ],
                [
                    93.0096618,
                    58.0853545
                ],
                [
                    93.0086318,
                    58.0860805
                ],
                [
                    93.0076018,
                    58.0860805
                ],
                [
                    93.0062285,
                    58.0864435
                ],
                [
                    93.0050269,
                    58.0870787
                ],
                [
                    93.0048552,
                    58.0881677
                ],
                [
                    93.0043879,
                    58.0894854
                ],
                [
                    93.0043403,
                    58.0899825
                ],
                [
                    93.0045119,
                    58.0925231
                ],
                [
                    93.0055419,
                    58.0945191
                ],
                [
                    93.0070868,
                    58.0952449
                ],
                [
                    93.0098334,
                    58.0944284
                ],
                [
                    93.0124083,
                    58.0935211
                ],
                [
                    93.0154983,
                    58.0920694
                ],
                [
                    93.0175355,
                    58.0910863
                ],
                [
                    93.0194465,
                    58.090164
                ],
                [
                    93.0218284,
                    58.0886398
                ],
                [
                    93.022708,
                    58.0880769
                ],
                [
                    93.0259696,
                    58.0865343
                ],
                [
                    93.0300895,
                    58.0849915
                ],
                [
                    93.0395308,
                    58.0809983
                ],
                [
                    93.043994,
                    58.0790015
                ],
                [
                    93.0467406,
                    58.0780938
                ],
                [
                    93.0505172,
                    58.0763692
                ],
                [
                    93.0534354,
                    58.0751891
                ],
                [
                    93.056697,
                    58.0736459
                ],
                [
                    93.0607007,
                    58.0722948
                ],
                [
                    93.064091,
                    58.0714323
                ],
                [
                    93.0692837,
                    58.0702748
                ],
                [
                    93.0720283,
                    58.0696742
                ],
                [
                    93.0740277,
                    58.0694256
                ],
                [
                    93.074128,
                    58.0693201
                ],
                [
                    93.0744912,
                    58.0692452
                ],
                [
                    93.0752034,
                    58.0678868
                ],
                [
                    93.0752484,
                    58.067324
                ],
                [
                    93.074454,
                    58.066452
                ],
                [
                    93.0739295,
                    58.0657781
                ],
                [
                    93.0742592,
                    58.0644622
                ],
                [
                    93.0739894,
                    58.0635742
                ],
                [
                    93.074529,
                    58.0628369
                ],
                [
                    93.0739744,
                    58.0619728
                ],
                [
                    93.0740344,
                    58.0612592
                ],
                [
                    93.0746039,
                    58.0602206
                ],
                [
                    93.0747238,
                    58.0594673
                ],
                [
                    93.0742892,
                    58.0585476
                ],
                [
                    93.074469,
                    58.0576357
                ],
                [
                    93.0751435,
                    58.0567556
                ],
                [
                    93.0813781,
                    58.0538929
                ],
                [
                    93.0833463,
                    58.0517346
                ],
                [
                    93.0591616,
                    58.0484854
                ],
                [
                    93.0382271,
                    58.0602768
                ],
                [
                    93.002552,
                    58.060262
                ],
                [
                    93.0006809,
                    58.0621066
                ],
                [
                    92.9980535,
                    58.062808
                ],
                [
                    92.9971646,
                    58.0630964
                ],
                [
                    92.9961431,
                    58.0636263
                ],
                [
                    92.9956422,
                    58.0633406
                ],
                [
                    92.9955375,
                    58.0633943
                ],
                [
                    92.993889,
                    58.0641667
                ],
                [
                    92.9935206,
                    58.0640212
                ],
                [
                    92.9925041,
                    58.0639329
                ],
                [
                    92.9918214,
                    58.0639329
                ],
                [
                    92.9900829,
                    58.0648551
                ],
                [
                    92.9886145,
                    58.0640316
                ],
                [
                    92.9874113,
                    58.0636211
                ],
                [
                    92.9866992,
                    58.0630314
                ],
                [
                    92.9860559,
                    58.0627301
                ],
                [
                    92.9831142,
                    58.0640835
                ],
                [
                    92.9839392,
                    58.0647667
                ],
                [
                    92.9843321,
                    58.0654759
                ],
                [
                    92.9842928,
                    58.0658812
                ],
                [
                    92.9838508,
                    58.0664994
                ],
                [
                    92.9827508,
                    58.0676527
                ],
                [
                    92.982353,
                    58.0684216
                ],
                [
                    92.9824365,
                    58.06898
                ],
                [
                    92.9828294,
                    58.0695047
                ],
                [
                    92.9838705,
                    58.0703177
                ],
                [
                    92.9844942,
                    58.070767
                ],
                [
                    92.9847103,
                    58.0710969
                ],
                [
                    92.9847005,
                    58.0715826
                ],
                [
                    92.9812529,
                    58.0713462
                ],
                [
                    92.9795291,
                    58.0711566
                ],
                [
                    92.97755,
                    58.0706917
                ],
                [
                    92.9768625,
                    58.0703359
                ],
                [
                    92.9766218,
                    58.069806
                ],
                [
                    92.9758361,
                    58.0690787
                ],
                [
                    92.9750552,
                    58.0685411
                ],
                [
                    92.9742744,
                    58.0681826
                ],
                [
                    92.9732725,
                    58.0679826
                ],
                [
                    92.9720742,
                    58.0676164
                ],
                [
                    92.9705322,
                    58.0666553
                ],
                [
                    92.9701589,
                    58.0665721
                ],
                [
                    92.9668882,
                    58.0650499
                ],
                [
                    92.9663136,
                    58.0643407
                ],
                [
                    92.9663332,
                    58.0635198
                ],
                [
                    92.9665886,
                    58.0627742
                ],
                [
                    92.9665788,
                    58.0624079
                ],
                [
                    92.9661663,
                    58.0616104
                ],
                [
                    92.9661221,
                    58.0610544
                ],
                [
                    92.9666327,
                    58.0604198
                ],
                [
                    92.9677567,
                    58.0597459
                ],
                [
                    92.9678916,
                    58.0592781
                ],
                [
                    92.9673671,
                    58.0589213
                ],
                [
                    92.9665278,
                    58.0586993
                ],
                [
                    92.9647143,
                    58.0586517
                ],
                [
                    92.9641298,
                    58.0587548
                ],
                [
                    92.9629159,
                    58.0585645
                ],
                [
                    92.9598884,
                    58.0575416
                ],
                [
                    92.9599484,
                    58.0573196
                ],
                [
                    92.960413,
                    58.0570659
                ],
                [
                    92.9594388,
                    58.0558209
                ],
                [
                    92.9586895,
                    58.0548694
                ],
                [
                    92.9584946,
                    58.0539971
                ],
                [
                    92.9582698,
                    58.0536402
                ],
                [
                    92.9569153,
                    58.0536639
                ],
                [
                    92.9568224,
                    58.0547943
                ],
                [
                    92.9567858,
                    58.0549977
                ],
                [
                    92.9566591,
                    58.0557017
                ],
                [
                    92.9564791,
                    58.0567016
                ]
            ],
            "longitude": 93.031731,
            "latitude": 58.080124
        },
        "5746": {
            "name": "СЕВЕРО-ЕНИСЕЙСКИЙ",
            "population": 6994,
            "type": "town",
            "poly": null,
            "longitude": 93.032997,
            "latitude": 60.374702
        },
        "5747": {
            "name": "БЕРЁЗОВКА",
            "population": 20859,
            "type": "town",
            "poly": null,
            "longitude": 93.133194,
            "latitude": 56.038422
        },
        "5748": {
            "name": "БОЛЬШАЯ МУРТА",
            "population": 7843,
            "type": "town",
            "poly": null,
            "longitude": 93.138016,
            "latitude": 56.909847
        },
        "5749": {
            "name": "КРАСНОКАМЕНСК",
            "population": 4329,
            "type": "town",
            "poly": null,
            "longitude": 93.253105,
            "latitude": 54.338135
        },
        "5750": {
            "name": "СУХОБУЗИМСКОЕ",
            "population": 4293,
            "type": "town",
            "poly": null,
            "longitude": 93.27816,
            "latitude": 56.499783
        },
        "5751": {
            "name": "КАЗАЧИНСКОЕ",
            "population": 3627,
            "type": "town",
            "poly": null,
            "longitude": 93.281029,
            "latitude": 57.694408
        },
        "5752": {
            "name": "СОСНОВОБОРСК",
            "population": 37093,
            "type": "town",
            "poly": [
                [
                    93.3106347,
                    56.1157802
                ],
                [
                    93.3152022,
                    56.1179615
                ],
                [
                    93.3217909,
                    56.1197088
                ],
                [
                    93.3393162,
                    56.1348883
                ],
                [
                    93.3397831,
                    56.1347768
                ],
                [
                    93.3409146,
                    56.1360946
                ],
                [
                    93.3414103,
                    56.1366719
                ],
                [
                    93.3481476,
                    56.1529268
                ],
                [
                    93.3550831,
                    56.1523882
                ],
                [
                    93.3562668,
                    56.1523139
                ],
                [
                    93.3579673,
                    56.1517753
                ],
                [
                    93.4057702,
                    56.1301681
                ],
                [
                    93.3974592,
                    56.1242597
                ],
                [
                    93.3933103,
                    56.1213102
                ],
                [
                    93.3931231,
                    56.1213857
                ],
                [
                    93.3928268,
                    56.1215053
                ],
                [
                    93.3955277,
                    56.1234569
                ],
                [
                    93.3953609,
                    56.1253062
                ],
                [
                    93.3899426,
                    56.1279266
                ],
                [
                    93.3720565,
                    56.116081
                ],
                [
                    93.364318,
                    56.1109558
                ],
                [
                    93.365335,
                    56.110426
                ],
                [
                    93.362034,
                    56.1082413
                ],
                [
                    93.3601334,
                    56.1081112
                ],
                [
                    93.353448,
                    56.1037694
                ],
                [
                    93.3533312,
                    56.1023189
                ],
                [
                    93.3471293,
                    56.1023189
                ],
                [
                    93.3470293,
                    56.1032022
                ],
                [
                    93.3485465,
                    56.1042064
                ],
                [
                    93.3485965,
                    56.1050803
                ],
                [
                    93.3451954,
                    56.1066423
                ],
                [
                    93.3402605,
                    56.1064377
                ],
                [
                    93.3257227,
                    56.1130474
                ],
                [
                    93.3215714,
                    56.1104167
                ],
                [
                    93.3106347,
                    56.1157802
                ]
            ],
            "longitude": 93.33873,
            "latitude": 56.121494
        },
        "5753": {
            "name": "ЖЕЛЕЗНОГОРСК",
            "population": 84860,
            "type": "town",
            "poly": [
                [
                    93.3838367,
                    56.1794634
                ],
                [
                    93.3882483,
                    56.1825148
                ],
                [
                    93.3924548,
                    56.1850127
                ],
                [
                    93.3952886,
                    56.1865071
                ],
                [
                    93.40313,
                    56.1903056
                ],
                [
                    93.4044421,
                    56.1911842
                ],
                [
                    93.4069437,
                    56.1928881
                ],
                [
                    93.41075,
                    56.1955
                ],
                [
                    93.4174272,
                    56.2015691
                ],
                [
                    93.418,
                    56.20225
                ],
                [
                    93.42,
                    56.20375
                ],
                [
                    93.42,
                    56.20425
                ],
                [
                    93.4205,
                    56.2045
                ],
                [
                    93.421,
                    56.2045
                ],
                [
                    93.42125,
                    56.20475
                ],
                [
                    93.42125,
                    56.20525
                ],
                [
                    93.42175,
                    56.20525
                ],
                [
                    93.4232372,
                    56.2069818
                ],
                [
                    93.4239463,
                    56.2076274
                ],
                [
                    93.424607,
                    56.2083777
                ],
                [
                    93.4261817,
                    56.2098681
                ],
                [
                    93.4270914,
                    56.2105993
                ],
                [
                    93.4278887,
                    56.2111026
                ],
                [
                    93.428527,
                    56.2116993
                ],
                [
                    93.4289828,
                    56.2127542
                ],
                [
                    93.4292157,
                    56.2136393
                ],
                [
                    93.4290059,
                    56.2145953
                ],
                [
                    93.429306,
                    56.2151523
                ],
                [
                    93.4294038,
                    56.2157867
                ],
                [
                    93.4295,
                    56.216
                ],
                [
                    93.42925,
                    56.21625
                ],
                [
                    93.4301593,
                    56.2212011
                ],
                [
                    93.43025,
                    56.22225
                ],
                [
                    93.4294625,
                    56.2271953
                ],
                [
                    93.4291328,
                    56.227679
                ],
                [
                    93.4288937,
                    56.2282367
                ],
                [
                    93.4287819,
                    56.2285828
                ],
                [
                    93.4280926,
                    56.2298685
                ],
                [
                    93.4279543,
                    56.2311643
                ],
                [
                    93.4275924,
                    56.2313743
                ],
                [
                    93.4272145,
                    56.2323742
                ],
                [
                    93.4268526,
                    56.2325872
                ],
                [
                    93.4269204,
                    56.2331598
                ],
                [
                    93.4258032,
                    56.2348076
                ],
                [
                    93.4227657,
                    56.2392441
                ],
                [
                    93.4738494,
                    56.2546694
                ],
                [
                    93.507795,
                    56.2790446
                ],
                [
                    93.5203255,
                    56.2997372
                ],
                [
                    93.5218274,
                    56.3001749
                ],
                [
                    93.5237577,
                    56.3011558
                ],
                [
                    93.5256609,
                    56.3020968
                ],
                [
                    93.5272523,
                    56.3027824
                ],
                [
                    93.53,
                    56.3035
                ],
                [
                    93.5313015,
                    56.3038804
                ],
                [
                    93.5320615,
                    56.3041354
                ],
                [
                    93.5329595,
                    56.3045059
                ],
                [
                    93.5345094,
                    56.3051532
                ],
                [
                    93.5366066,
                    56.3056377
                ],
                [
                    93.5370842,
                    56.3056558
                ],
                [
                    93.5383171,
                    56.3055145
                ],
                [
                    93.5405787,
                    56.3051196
                ],
                [
                    93.542181,
                    56.3049891
                ],
                [
                    93.5448494,
                    56.3050208
                ],
                [
                    93.5460992,
                    56.3049424
                ],
                [
                    93.5490393,
                    56.3051555
                ],
                [
                    93.5497952,
                    56.3051505
                ],
                [
                    93.5505539,
                    56.3050737
                ],
                [
                    93.5510531,
                    56.3050787
                ],
                [
                    93.553816,
                    56.3051806
                ],
                [
                    93.5558541,
                    56.3053738
                ],
                [
                    93.5569751,
                    56.3054189
                ],
                [
                    93.5574033,
                    56.3054255
                ],
                [
                    93.5598096,
                    56.3069876
                ],
                [
                    93.5880141,
                    56.2907746
                ],
                [
                    93.5780092,
                    56.219001
                ],
                [
                    93.521982,
                    56.2142325
                ],
                [
                    93.4250011,
                    56.1745513
                ],
                [
                    93.4225279,
                    56.1776765
                ],
                [
                    93.417085,
                    56.1793897
                ],
                [
                    93.413664,
                    56.1761089
                ],
                [
                    93.4129509,
                    56.1756567
                ],
                [
                    93.4087357,
                    56.1723103
                ],
                [
                    93.4045023,
                    56.1736117
                ],
                [
                    93.4015871,
                    56.1736431
                ],
                [
                    93.3838367,
                    56.1794634
                ]
            ],
            "longitude": 93.53286,
            "latitude": 56.250938
        },
        "5754": {
            "name": "УЯР",
            "population": 12295,
            "type": "town",
            "poly": null,
            "longitude": 94.327774,
            "latitude": 55.809986
        },
        "5755": {
            "name": "ЗЕЛЕНОГОРСК",
            "population": 63388,
            "type": "town",
            "poly": [
                [
                    94.418966,
                    56.1092339
                ],
                [
                    94.4206406,
                    56.1112348
                ],
                [
                    94.4259276,
                    56.1123686
                ],
                [
                    94.4237744,
                    56.1130622
                ],
                [
                    94.4274108,
                    56.117597
                ],
                [
                    94.4281046,
                    56.1193041
                ],
                [
                    94.4278893,
                    56.1305315
                ],
                [
                    94.4308079,
                    56.1333845
                ],
                [
                    94.4343724,
                    56.1380235
                ],
                [
                    94.4347791,
                    56.1388766
                ],
                [
                    94.4338939,
                    56.1425021
                ],
                [
                    94.4338461,
                    56.1436216
                ],
                [
                    94.4345877,
                    56.1486991
                ],
                [
                    94.4345398,
                    56.1504581
                ],
                [
                    94.4312863,
                    56.1542557
                ],
                [
                    94.4268367,
                    56.1566806
                ],
                [
                    94.426982,
                    56.1631645
                ],
                [
                    94.4333359,
                    56.1632284
                ],
                [
                    94.433202,
                    56.1639424
                ],
                [
                    94.4333933,
                    56.16504
                ],
                [
                    94.4340249,
                    56.1657646
                ],
                [
                    94.4343885,
                    56.1659351
                ],
                [
                    94.4332976,
                    56.166372
                ],
                [
                    94.4312881,
                    56.166777
                ],
                [
                    94.4310967,
                    56.1670007
                ],
                [
                    94.4311542,
                    56.1676827
                ],
                [
                    94.4344109,
                    56.1695454
                ],
                [
                    94.4346565,
                    56.1696859
                ],
                [
                    94.4344842,
                    56.1722323
                ],
                [
                    94.4361493,
                    56.1732019
                ],
                [
                    94.4372209,
                    56.1734895
                ],
                [
                    94.4421203,
                    56.173351
                ],
                [
                    94.443039,
                    56.1728716
                ],
                [
                    94.4466179,
                    56.1679384
                ],
                [
                    94.4485892,
                    56.1663294
                ],
                [
                    94.4494121,
                    56.1638252
                ],
                [
                    94.4495652,
                    56.16147
                ],
                [
                    94.4528379,
                    56.1616192
                ],
                [
                    94.4533546,
                    56.1612888
                ],
                [
                    94.4565506,
                    56.1616725
                ],
                [
                    94.4559,
                    56.1627382
                ],
                [
                    94.4573927,
                    56.1642088
                ],
                [
                    94.457699,
                    56.164326
                ],
                [
                    94.4589813,
                    56.1640383
                ],
                [
                    94.4603975,
                    56.1634735
                ],
                [
                    94.4613736,
                    56.1630259
                ],
                [
                    94.4623114,
                    56.1627382
                ],
                [
                    94.4638233,
                    56.162557
                ],
                [
                    94.4657945,
                    56.1620881
                ],
                [
                    94.4679572,
                    56.1619283
                ],
                [
                    94.468627,
                    56.1608872
                ],
                [
                    94.4711987,
                    56.1608039
                ],
                [
                    94.4731425,
                    56.1605042
                ],
                [
                    94.4747572,
                    56.1597715
                ],
                [
                    94.4750862,
                    56.1594384
                ],
                [
                    94.4789737,
                    56.1584559
                ],
                [
                    94.4848049,
                    56.1562076
                ],
                [
                    94.4878249,
                    56.1549095
                ],
                [
                    94.4915186,
                    56.1532893
                ],
                [
                    94.4952506,
                    56.1509548
                ],
                [
                    94.497394,
                    56.1496329
                ],
                [
                    94.5003222,
                    56.147021
                ],
                [
                    94.501394,
                    56.1465412
                ],
                [
                    94.5019681,
                    56.1456777
                ],
                [
                    94.508456,
                    56.1418393
                ],
                [
                    94.5098149,
                    56.1413701
                ],
                [
                    94.5153076,
                    56.1397493
                ],
                [
                    94.5198245,
                    56.1386175
                ],
                [
                    94.520873,
                    56.1383548
                ],
                [
                    94.5212829,
                    56.1382521
                ],
                [
                    94.5217763,
                    56.1381285
                ],
                [
                    94.5222786,
                    56.1380043
                ],
                [
                    94.5223151,
                    56.1379952
                ],
                [
                    94.525374,
                    56.1372387
                ],
                [
                    94.525718,
                    56.1371108
                ],
                [
                    94.5264569,
                    56.1368359
                ],
                [
                    94.5274299,
                    56.1368013
                ],
                [
                    94.5274775,
                    56.1367898
                ],
                [
                    94.5321738,
                    56.1356536
                ],
                [
                    94.5325711,
                    56.1355575
                ],
                [
                    94.5521971,
                    56.1308092
                ],
                [
                    94.5675671,
                    56.1270907
                ],
                [
                    94.5678279,
                    56.1270276
                ],
                [
                    94.5837901,
                    56.1231658
                ],
                [
                    94.5849639,
                    56.1228818
                ],
                [
                    94.585144,
                    56.1228382
                ],
                [
                    94.5867976,
                    56.1240953
                ],
                [
                    94.5875133,
                    56.1250479
                ],
                [
                    94.5876618,
                    56.1252456
                ],
                [
                    94.5882953,
                    56.1260889
                ],
                [
                    94.5883957,
                    56.1269591
                ],
                [
                    94.5884231,
                    56.1271961
                ],
                [
                    94.5884358,
                    56.1273223
                ],
                [
                    94.5884985,
                    56.1279394
                ],
                [
                    94.5885394,
                    56.1283073
                ],
                [
                    94.5885796,
                    56.1286686
                ],
                [
                    94.5888979,
                    56.1293481
                ],
                [
                    94.5890671,
                    56.1296318
                ],
                [
                    94.5893496,
                    56.1300471
                ],
                [
                    94.5900102,
                    56.1306208
                ],
                [
                    94.5908397,
                    56.1320095
                ],
                [
                    94.591572,
                    56.1331718
                ],
                [
                    94.5920211,
                    56.1344187
                ],
                [
                    94.5925707,
                    56.1374405
                ],
                [
                    94.5927011,
                    56.1387258
                ],
                [
                    94.5933128,
                    56.1398687
                ],
                [
                    94.5934743,
                    56.1415391
                ],
                [
                    94.5944857,
                    56.1435712
                ],
                [
                    94.5951407,
                    56.1446859
                ],
                [
                    94.5950363,
                    56.1455325
                ],
                [
                    94.5951965,
                    56.1463921
                ],
                [
                    94.5957709,
                    56.1476777
                ],
                [
                    94.5967744,
                    56.1483529
                ],
                [
                    94.5990598,
                    56.1511619
                ],
                [
                    94.6000478,
                    56.1533777
                ],
                [
                    94.6003872,
                    56.1540823
                ],
                [
                    94.6011373,
                    56.1546293
                ],
                [
                    94.6033263,
                    56.1552019
                ],
                [
                    94.6038792,
                    56.1552943
                ],
                [
                    94.6075647,
                    56.1559114
                ],
                [
                    94.6081303,
                    56.1547285
                ],
                [
                    94.6083323,
                    56.1535251
                ],
                [
                    94.6028778,
                    56.1391721
                ],
                [
                    94.6001028,
                    56.1338533
                ],
                [
                    94.6019209,
                    56.1271205
                ],
                [
                    94.6018251,
                    56.1258538
                ],
                [
                    94.6171358,
                    56.1227602
                ],
                [
                    94.6182995,
                    56.1228842
                ],
                [
                    94.6187627,
                    56.1229336
                ],
                [
                    94.6198631,
                    56.1242004
                ],
                [
                    94.6259635,
                    56.1260671
                ],
                [
                    94.631394,
                    56.1254138
                ],
                [
                    94.6326619,
                    56.1255071
                ],
                [
                    94.6339251,
                    56.1267375
                ],
                [
                    94.6371772,
                    56.1279875
                ],
                [
                    94.6390088,
                    56.1283625
                ],
                [
                    94.640504,
                    56.1291124
                ],
                [
                    94.6404666,
                    56.1306957
                ],
                [
                    94.6390462,
                    56.1318622
                ],
                [
                    94.6369902,
                    56.1315498
                ],
                [
                    94.6360185,
                    56.1323622
                ],
                [
                    94.6385177,
                    56.139837
                ],
                [
                    94.6430391,
                    56.1392894
                ],
                [
                    94.6472323,
                    56.1379444
                ],
                [
                    94.6477557,
                    56.1369655
                ],
                [
                    94.6624084,
                    56.1341952
                ],
                [
                    94.6677163,
                    56.1344035
                ],
                [
                    94.6803133,
                    56.1338828
                ],
                [
                    94.6858454,
                    56.1335912
                ],
                [
                    94.6879012,
                    56.1330704
                ],
                [
                    94.6889853,
                    56.1331537
                ],
                [
                    94.6893216,
                    56.1314456
                ],
                [
                    94.6858081,
                    56.1308832
                ],
                [
                    94.6938447,
                    56.1196533
                ],
                [
                    94.6989283,
                    56.119945
                ],
                [
                    94.6999601,
                    56.1131655
                ],
                [
                    94.7059407,
                    56.1114648
                ],
                [
                    94.7133868,
                    56.1104144
                ],
                [
                    94.7116823,
                    56.1095973
                ],
                [
                    94.7077649,
                    56.1095473
                ],
                [
                    94.7063894,
                    56.108897
                ],
                [
                    94.7050138,
                    56.1069126
                ],
                [
                    94.7068977,
                    56.105812
                ],
                [
                    94.7097685,
                    56.1052117
                ],
                [
                    94.7113235,
                    56.104628
                ],
                [
                    94.7118318,
                    56.1030437
                ],
                [
                    94.7193376,
                    56.1005253
                ],
                [
                    94.722029,
                    56.1013593
                ],
                [
                    94.7234045,
                    56.1024933
                ],
                [
                    94.7250791,
                    56.1032272
                ],
                [
                    94.7265743,
                    56.1046947
                ],
                [
                    94.7277406,
                    56.1042278
                ],
                [
                    94.7289068,
                    56.1027769
                ],
                [
                    94.7310599,
                    56.1020764
                ],
                [
                    94.7337213,
                    56.1008089
                ],
                [
                    94.734409,
                    56.0999082
                ],
                [
                    94.7342895,
                    56.0990409
                ],
                [
                    94.7330697,
                    56.0956637
                ],
                [
                    94.7325801,
                    56.0904743
                ],
                [
                    94.7351199,
                    56.0853183
                ],
                [
                    94.7360991,
                    56.0819205
                ],
                [
                    94.7375068,
                    56.0754654
                ],
                [
                    94.738027,
                    56.072989
                ],
                [
                    94.7379352,
                    56.0709736
                ],
                [
                    94.7377822,
                    56.0704954
                ],
                [
                    94.7375986,
                    56.0687531
                ],
                [
                    94.7373232,
                    56.0684627
                ],
                [
                    94.7347833,
                    56.0697096
                ],
                [
                    94.7353647,
                    56.0702562
                ],
                [
                    94.7321642,
                    56.0718778
                ],
                [
                    94.728865,
                    56.0725183
                ],
                [
                    94.7227927,
                    56.0738259
                ],
                [
                    94.7041932,
                    56.0770281
                ],
                [
                    94.6876976,
                    56.0778553
                ],
                [
                    94.677848,
                    56.0780688
                ],
                [
                    94.6675202,
                    56.0771615
                ],
                [
                    94.656045,
                    56.073986
                ],
                [
                    94.6575272,
                    56.0722514
                ],
                [
                    94.6579097,
                    56.0705434
                ],
                [
                    94.6596788,
                    56.0696093
                ],
                [
                    94.6606829,
                    56.0686218
                ],
                [
                    94.6618027,
                    56.0683003
                ],
                [
                    94.6646816,
                    56.068344
                ],
                [
                    94.6659938,
                    56.0680816
                ],
                [
                    94.6686377,
                    56.0680051
                ],
                [
                    94.6709682,
                    56.0672398
                ],
                [
                    94.6722216,
                    56.0667479
                ],
                [
                    94.6752709,
                    56.0666133
                ],
                [
                    94.6764734,
                    56.0665573
                ],
                [
                    94.677275,
                    56.0662357
                ],
                [
                    94.67725,
                    56.0657323
                ],
                [
                    94.6772249,
                    56.0638023
                ],
                [
                    94.6778262,
                    56.0630891
                ],
                [
                    94.6790286,
                    56.0625716
                ],
                [
                    94.6794294,
                    56.0623618
                ],
                [
                    94.6794294,
                    56.0619282
                ],
                [
                    94.6790537,
                    56.0616485
                ],
                [
                    94.674344,
                    56.0593687
                ],
                [
                    94.6717637,
                    56.0587953
                ],
                [
                    94.6695593,
                    56.0587533
                ],
                [
                    94.6675552,
                    56.0588932
                ],
                [
                    94.6671293,
                    56.0588232
                ],
                [
                    94.6646242,
                    56.0572427
                ],
                [
                    94.6646993,
                    56.056809
                ],
                [
                    94.6653256,
                    56.0564453
                ],
                [
                    94.6661272,
                    56.0560956
                ],
                [
                    94.6651753,
                    56.0559418
                ],
                [
                    94.665025,
                    56.055704
                ],
                [
                    94.6656012,
                    56.0555641
                ],
                [
                    94.6653757,
                    56.0554102
                ],
                [
                    94.6647744,
                    56.0551304
                ],
                [
                    94.6648747,
                    56.0546129
                ],
                [
                    94.6654258,
                    56.0537596
                ],
                [
                    94.6661272,
                    56.0537036
                ],
                [
                    94.667004,
                    56.0542492
                ],
                [
                    94.6674048,
                    56.0543191
                ],
                [
                    94.6684319,
                    56.0541652
                ],
                [
                    94.669935,
                    56.0542212
                ],
                [
                    94.6703609,
                    56.0537596
                ],
                [
                    94.6708869,
                    56.0531161
                ],
                [
                    94.6707868,
                    56.0525565
                ],
                [
                    94.6703859,
                    56.0519689
                ],
                [
                    94.6697597,
                    56.051885
                ],
                [
                    94.6680061,
                    56.0520389
                ],
                [
                    94.6668287,
                    56.051815
                ],
                [
                    94.6657014,
                    56.0517311
                ],
                [
                    94.6645741,
                    56.0510596
                ],
                [
                    94.6640981,
                    56.0500383
                ],
                [
                    94.6641482,
                    56.0493528
                ],
                [
                    94.665025,
                    56.0498984
                ],
                [
                    94.6653506,
                    56.0493947
                ],
                [
                    94.6658016,
                    56.0493388
                ],
                [
                    94.6659519,
                    56.0488071
                ],
                [
                    94.6655511,
                    56.0484434
                ],
                [
                    94.6641482,
                    56.0484853
                ],
                [
                    94.6646743,
                    56.0481496
                ],
                [
                    94.6650751,
                    56.0478418
                ],
                [
                    94.6652003,
                    56.0470443
                ],
                [
                    94.6656763,
                    56.0468344
                ],
                [
                    94.6653005,
                    56.0464426
                ],
                [
                    94.6658016,
                    56.0457011
                ],
                [
                    94.6662274,
                    56.0450714
                ],
                [
                    94.6658767,
                    56.0443158
                ],
                [
                    94.6661272,
                    56.0437282
                ],
                [
                    94.6669038,
                    56.0432804
                ],
                [
                    94.6663276,
                    56.0418951
                ],
                [
                    94.6541277,
                    56.0412654
                ],
                [
                    94.6551798,
                    56.0406916
                ],
                [
                    94.6550795,
                    56.0359335
                ],
                [
                    94.6389654,
                    56.0360944
                ],
                [
                    94.6074009,
                    56.0394007
                ],
                [
                    94.6032361,
                    56.0400654
                ],
                [
                    94.5992279,
                    56.0403803
                ],
                [
                    94.5921823,
                    56.0437561
                ],
                [
                    94.5894579,
                    56.0446482
                ],
                [
                    94.5866084,
                    56.0461698
                ],
                [
                    94.5730494,
                    56.0506819
                ],
                [
                    94.5722039,
                    56.0515387
                ],
                [
                    94.556359,
                    56.0545115
                ],
                [
                    94.5521629,
                    56.0562775
                ],
                [
                    94.5363494,
                    56.0594596
                ],
                [
                    94.5313077,
                    56.059582
                ],
                [
                    94.5284269,
                    56.0623443
                ],
                [
                    94.5279572,
                    56.0634107
                ],
                [
                    94.5278633,
                    56.0650016
                ],
                [
                    94.5268299,
                    56.0655959
                ],
                [
                    94.5247945,
                    56.0660854
                ],
                [
                    94.5238551,
                    56.0665923
                ],
                [
                    94.5225399,
                    56.0672915
                ],
                [
                    94.5211621,
                    56.0678509
                ],
                [
                    94.5190327,
                    56.0698435
                ],
                [
                    94.5179367,
                    56.0712418
                ],
                [
                    94.5170599,
                    56.0714341
                ],
                [
                    94.515369,
                    56.0714515
                ],
                [
                    94.5137406,
                    56.0724827
                ],
                [
                    94.5120497,
                    56.0731119
                ],
                [
                    94.5079475,
                    56.0745451
                ],
                [
                    94.5066949,
                    56.0755412
                ],
                [
                    94.5037201,
                    56.0767646
                ],
                [
                    94.5005574,
                    56.0787917
                ],
                [
                    94.4995554,
                    56.0797703
                ],
                [
                    94.4974572,
                    56.0807488
                ],
                [
                    94.4962361,
                    56.081972
                ],
                [
                    94.4940127,
                    56.0827059
                ],
                [
                    94.4921026,
                    56.084855
                ],
                [
                    94.491038,
                    56.0858858
                ],
                [
                    94.490944,
                    56.0874583
                ],
                [
                    94.4818003,
                    56.0796654
                ],
                [
                    94.4772246,
                    56.0799233
                ],
                [
                    94.4745793,
                    56.0803036
                ],
                [
                    94.4732766,
                    56.0809299
                ],
                [
                    94.4701903,
                    56.0807621
                ],
                [
                    94.4648193,
                    56.0815897
                ],
                [
                    94.4630799,
                    56.081731
                ],
                [
                    94.4604962,
                    56.0848412
                ],
                [
                    94.4557116,
                    56.0842539
                ],
                [
                    94.4536543,
                    56.0842139
                ],
                [
                    94.4421234,
                    56.0829858
                ],
                [
                    94.4379847,
                    56.0833862
                ],
                [
                    94.4332002,
                    56.0834797
                ],
                [
                    94.4342288,
                    56.0855487
                ],
                [
                    94.4387981,
                    56.0860158
                ],
                [
                    94.4439655,
                    56.0882982
                ],
                [
                    94.4425779,
                    56.092529
                ],
                [
                    94.4418603,
                    56.092876
                ],
                [
                    94.4408555,
                    56.0931162
                ],
                [
                    94.4404727,
                    56.0935432
                ],
                [
                    94.440066,
                    56.0962922
                ],
                [
                    94.4405923,
                    56.0977601
                ],
                [
                    94.4439894,
                    56.1014961
                ],
                [
                    94.4437741,
                    56.1017896
                ],
                [
                    94.4362623,
                    56.1034707
                ],
                [
                    94.4348987,
                    56.1036575
                ],
                [
                    94.4324,
                    56.1039435
                ],
                [
                    94.4275544,
                    56.104498
                ],
                [
                    94.4229133,
                    56.1052451
                ],
                [
                    94.4195402,
                    56.1058988
                ],
                [
                    94.418966,
                    56.1092339
                ]
            ],
            "longitude": 94.589279,
            "latitude": 56.11356
        },
        "5756": {
            "name": "МОТЫГИНО",
            "population": 5531,
            "type": "town",
            "poly": null,
            "longitude": 94.694298,
            "latitude": 58.184208
        },
        "5757": {
            "name": "ЗАОЗЁРНЫЙ",
            "population": 10271,
            "type": "town",
            "poly": [
                [
                    94.6661851,
                    55.9574016
                ],
                [
                    94.6672399,
                    55.958296
                ],
                [
                    94.6697528,
                    55.9597027
                ],
                [
                    94.6706551,
                    55.9601265
                ],
                [
                    94.67126,
                    55.960387
                ],
                [
                    94.6726405,
                    55.9608558
                ],
                [
                    94.6862805,
                    55.9651787
                ],
                [
                    94.6866698,
                    55.9653782
                ],
                [
                    94.6871273,
                    55.965718
                ],
                [
                    94.6880486,
                    55.9668046
                ],
                [
                    94.6899098,
                    55.9696133
                ],
                [
                    94.6899482,
                    55.9698189
                ],
                [
                    94.6898056,
                    55.9700399
                ],
                [
                    94.6900693,
                    55.9700825
                ],
                [
                    94.6854448,
                    55.9768876
                ],
                [
                    94.6837229,
                    55.9807845
                ],
                [
                    94.6835035,
                    55.9834906
                ],
                [
                    94.685598,
                    55.9837216
                ],
                [
                    94.6866186,
                    55.9838342
                ],
                [
                    94.6920699,
                    55.9837667
                ],
                [
                    94.6926512,
                    55.9838833
                ],
                [
                    94.6991211,
                    55.9877519
                ],
                [
                    94.7004242,
                    55.9894568
                ],
                [
                    94.7038135,
                    55.9898343
                ],
                [
                    94.706497,
                    55.9900208
                ],
                [
                    94.70818,
                    55.9906759
                ],
                [
                    94.7093456,
                    55.9908764
                ],
                [
                    94.7108513,
                    55.9909876
                ],
                [
                    94.7148438,
                    55.9918342
                ],
                [
                    94.7188802,
                    55.9938096
                ],
                [
                    94.7232895,
                    55.994558
                ],
                [
                    94.7285543,
                    55.9928526
                ],
                [
                    94.7266897,
                    55.9918465
                ],
                [
                    94.7233991,
                    55.9880305
                ],
                [
                    94.717443,
                    55.9832378
                ],
                [
                    94.7169535,
                    55.9827069
                ],
                [
                    94.7166146,
                    55.9820075
                ],
                [
                    94.7167953,
                    55.9812027
                ],
                [
                    94.7169158,
                    55.9798502
                ],
                [
                    94.7159669,
                    55.9780003
                ],
                [
                    94.7143401,
                    55.975632
                ],
                [
                    94.7156506,
                    55.9749957
                ],
                [
                    94.7133987,
                    55.9740011
                ],
                [
                    94.713587,
                    55.9737525
                ],
                [
                    94.714551,
                    55.9738199
                ],
                [
                    94.7162472,
                    55.9741495
                ],
                [
                    94.7166945,
                    55.9739826
                ],
                [
                    94.7179139,
                    55.973622
                ],
                [
                    94.718404,
                    55.973324
                ],
                [
                    94.7191072,
                    55.9736563
                ],
                [
                    94.722052,
                    55.9722234
                ],
                [
                    94.7279039,
                    55.9702762
                ],
                [
                    94.7345541,
                    55.9729736
                ],
                [
                    94.7325281,
                    55.9734498
                ],
                [
                    94.7345164,
                    55.9745708
                ],
                [
                    94.7337181,
                    55.9750007
                ],
                [
                    94.733816,
                    55.9754389
                ],
                [
                    94.7345315,
                    55.9770445
                ],
                [
                    94.738154,
                    55.9764882
                ],
                [
                    94.7401649,
                    55.9758519
                ],
                [
                    94.7432527,
                    55.9773016
                ],
                [
                    94.7437649,
                    55.9772636
                ],
                [
                    94.7452411,
                    55.9762101
                ],
                [
                    94.7455966,
                    55.9728655
                ],
                [
                    94.7461163,
                    55.969415
                ],
                [
                    94.7457906,
                    55.9683386
                ],
                [
                    94.7444333,
                    55.9667283
                ],
                [
                    94.7440843,
                    55.9657516
                ],
                [
                    94.7477373,
                    55.9667673
                ],
                [
                    94.7499322,
                    55.9675834
                ],
                [
                    94.7498391,
                    55.9679696
                ],
                [
                    94.7505449,
                    55.968204
                ],
                [
                    94.7537093,
                    55.9685078
                ],
                [
                    94.7508784,
                    55.9668889
                ],
                [
                    94.7499089,
                    55.965986
                ],
                [
                    94.7495754,
                    55.9654477
                ],
                [
                    94.7494824,
                    55.9644754
                ],
                [
                    94.7481251,
                    55.9627997
                ],
                [
                    94.7479855,
                    55.9618012
                ],
                [
                    94.7485362,
                    55.9611804
                ],
                [
                    94.7500486,
                    55.9604597
                ],
                [
                    94.7517161,
                    55.9600777
                ],
                [
                    94.7553225,
                    55.9595002
                ],
                [
                    94.759247,
                    55.9593526
                ],
                [
                    94.762644,
                    55.9595176
                ],
                [
                    94.7668787,
                    55.9595914
                ],
                [
                    94.7706015,
                    55.9593483
                ],
                [
                    94.7659093,
                    55.9528093
                ],
                [
                    94.7639082,
                    55.9532435
                ],
                [
                    94.7628302,
                    55.9536604
                ],
                [
                    94.757595,
                    55.9565218
                ],
                [
                    94.756261,
                    55.9569734
                ],
                [
                    94.7537093,
                    55.9573902
                ],
                [
                    94.7442394,
                    55.9576984
                ],
                [
                    94.7343119,
                    55.9584278
                ],
                [
                    94.732117,
                    55.9584539
                ],
                [
                    94.7289837,
                    55.9583193
                ],
                [
                    94.7231978,
                    55.9577332
                ],
                [
                    94.7202351,
                    55.9572903
                ],
                [
                    94.7204988,
                    55.9570472
                ],
                [
                    94.7221818,
                    55.956474
                ],
                [
                    94.7219724,
                    55.9558054
                ],
                [
                    94.7223446,
                    55.9547763
                ],
                [
                    94.7226627,
                    55.9547546
                ],
                [
                    94.7228566,
                    55.9543725
                ],
                [
                    94.7230582,
                    55.954455
                ],
                [
                    94.7237097,
                    55.95429
                ],
                [
                    94.7237097,
                    55.9540468
                ],
                [
                    94.7252686,
                    55.9535952
                ],
                [
                    94.7255013,
                    55.9535822
                ],
                [
                    94.7262691,
                    55.9533738
                ],
                [
                    94.7267965,
                    55.9531219
                ],
                [
                    94.7277505,
                    55.9523012
                ],
                [
                    94.7281228,
                    55.9515847
                ],
                [
                    94.7282546,
                    55.9514675
                ],
                [
                    94.728433,
                    55.9509507
                ],
                [
                    94.7288131,
                    55.9508509
                ],
                [
                    94.7287355,
                    55.9502299
                ],
                [
                    94.7282314,
                    55.9499433
                ],
                [
                    94.7274325,
                    55.9499302
                ],
                [
                    94.726114,
                    55.9499823
                ],
                [
                    94.7255944,
                    55.9502082
                ],
                [
                    94.7270757,
                    55.947216
                ],
                [
                    94.7301393,
                    55.9423907
                ],
                [
                    94.730752,
                    55.9425861
                ],
                [
                    94.7341413,
                    55.9429379
                ],
                [
                    94.7337613,
                    55.9439152
                ],
                [
                    94.7348936,
                    55.9439499
                ],
                [
                    94.7348549,
                    55.9435981
                ],
                [
                    94.7350565,
                    55.9430205
                ],
                [
                    94.7353822,
                    55.9423993
                ],
                [
                    94.736437,
                    55.9424384
                ],
                [
                    94.7365689,
                    55.9425427
                ],
                [
                    94.7375074,
                    55.9425383
                ],
                [
                    94.7398574,
                    55.94266
                ],
                [
                    94.7401133,
                    55.9426035
                ],
                [
                    94.7409586,
                    55.9425991
                ],
                [
                    94.7409586,
                    55.9432116
                ],
                [
                    94.7414007,
                    55.9432376
                ],
                [
                    94.7414861,
                    55.9435634
                ],
                [
                    94.7441307,
                    55.9435243
                ],
                [
                    94.7440455,
                    55.9430074
                ],
                [
                    94.7450383,
                    55.9429119
                ],
                [
                    94.7460155,
                    55.9427468
                ],
                [
                    94.7462482,
                    55.9433332
                ],
                [
                    94.7482414,
                    55.9431768
                ],
                [
                    94.7487515,
                    55.9425493
                ],
                [
                    94.7518227,
                    55.939011
                ],
                [
                    94.7523711,
                    55.9385932
                ],
                [
                    94.753786,
                    55.9381509
                ],
                [
                    94.7555519,
                    55.9378438
                ],
                [
                    94.7607839,
                    55.936351
                ],
                [
                    94.762111,
                    55.935411
                ],
                [
                    94.766119,
                    55.9319366
                ],
                [
                    94.766029,
                    55.9318291
                ],
                [
                    94.7590092,
                    55.9306371
                ],
                [
                    94.7550605,
                    55.9302561
                ],
                [
                    94.7525926,
                    55.9302008
                ],
                [
                    94.7496532,
                    55.9303483
                ],
                [
                    94.7472072,
                    55.9306432
                ],
                [
                    94.7449258,
                    55.9309934
                ],
                [
                    94.7374892,
                    55.9324865
                ],
                [
                    94.7357646,
                    55.9328338
                ],
                [
                    94.7346349,
                    55.9329628
                ],
                [
                    94.7334722,
                    55.9329567
                ],
                [
                    94.7322657,
                    55.9328584
                ],
                [
                    94.7311469,
                    55.9326372
                ],
                [
                    94.7236007,
                    55.9303699
                ],
                [
                    94.7222406,
                    55.9300811
                ],
                [
                    94.7211328,
                    55.9299705
                ],
                [
                    94.7081681,
                    55.9300135
                ],
                [
                    94.6977158,
                    55.9307696
                ],
                [
                    94.6975529,
                    55.9301483
                ],
                [
                    94.6977002,
                    55.9298442
                ],
                [
                    94.6973978,
                    55.9296617
                ],
                [
                    94.6974211,
                    55.9294923
                ],
                [
                    94.6969247,
                    55.9293402
                ],
                [
                    94.6880753,
                    55.9294314
                ],
                [
                    94.680428,
                    55.9261552
                ],
                [
                    94.6802651,
                    55.9273632
                ],
                [
                    94.6790708,
                    55.9304525
                ],
                [
                    94.6790475,
                    55.930661
                ],
                [
                    94.677411,
                    55.932829
                ],
                [
                    94.6758133,
                    55.9353184
                ],
                [
                    94.675759,
                    55.9355399
                ],
                [
                    94.6766432,
                    55.935553
                ],
                [
                    94.6767052,
                    55.9363175
                ],
                [
                    94.6774576,
                    55.9363957
                ],
                [
                    94.6760615,
                    55.9398795
                ],
                [
                    94.6759917,
                    55.9418472
                ],
                [
                    94.6742699,
                    55.9417864
                ],
                [
                    94.673409,
                    55.9467942
                ],
                [
                    94.6719199,
                    55.948527
                ],
                [
                    94.6691588,
                    55.9509806
                ],
                [
                    94.668864,
                    55.952127
                ],
                [
                    94.66753,
                    55.9546629
                ],
                [
                    94.666452,
                    55.957242
                ],
                [
                    94.6661851,
                    55.9574016
                ]
            ],
            "longitude": 94.708107,
            "latitude": 55.965401
        },
        "5758": {
            "name": "САЯНСКИЙ",
            "population": 4039,
            "type": "town",
            "poly": [
                [
                    94.6897044,
                    55.54245
                ],
                [
                    94.6927514,
                    55.5455093
                ],
                [
                    94.6923223,
                    55.5483256
                ],
                [
                    94.6933951,
                    55.5517243
                ],
                [
                    94.69803,
                    55.5532051
                ],
                [
                    94.7053685,
                    55.5557539
                ],
                [
                    94.7121491,
                    55.557186
                ],
                [
                    94.7153678,
                    55.557817
                ],
                [
                    94.7193868,
                    55.5577042
                ],
                [
                    94.7249658,
                    55.555908
                ],
                [
                    94.7263391,
                    55.5531651
                ],
                [
                    94.728399,
                    55.5514658
                ],
                [
                    94.7241224,
                    55.5473059
                ],
                [
                    94.7188439,
                    55.5455093
                ],
                [
                    94.7019353,
                    55.5420615
                ],
                [
                    94.692451,
                    55.5407988
                ],
                [
                    94.6897044,
                    55.54245
                ]
            ],
            "longitude": 94.708382,
            "latitude": 55.551285
        },
        "5759": {
            "name": "БОРОДИНО",
            "population": 16339,
            "type": "town",
            "poly": [
                [
                    94.8311926,
                    55.898931
                ],
                [
                    94.8374318,
                    55.9020839
                ],
                [
                    94.8388324,
                    55.9050818
                ],
                [
                    94.8400421,
                    55.9095783
                ],
                [
                    94.8383443,
                    55.9095307
                ],
                [
                    94.8356402,
                    55.9174005
                ],
                [
                    94.8351627,
                    55.9204478
                ],
                [
                    94.8395662,
                    55.9229597
                ],
                [
                    94.8562783,
                    55.9255459
                ],
                [
                    94.8601247,
                    55.9242528
                ],
                [
                    94.8620082,
                    55.9233165
                ],
                [
                    94.8586127,
                    55.9224247
                ],
                [
                    94.862181,
                    55.914716
                ],
                [
                    94.8639053,
                    55.9141362
                ],
                [
                    94.8652581,
                    55.9156377
                ],
                [
                    94.8664253,
                    55.9153404
                ],
                [
                    94.8739856,
                    55.9179716
                ],
                [
                    94.8789196,
                    55.921227
                ],
                [
                    94.8789992,
                    55.9220742
                ],
                [
                    94.8812275,
                    55.9220148
                ],
                [
                    94.8926959,
                    55.9314022
                ],
                [
                    94.8962612,
                    55.9306414
                ],
                [
                    94.9006328,
                    55.9301539
                ],
                [
                    94.9036251,
                    55.9313071
                ],
                [
                    94.9078906,
                    55.930463
                ],
                [
                    94.9118379,
                    55.9285371
                ],
                [
                    94.9107768,
                    55.9268131
                ],
                [
                    94.9078057,
                    55.9251248
                ],
                [
                    94.9116681,
                    55.9250535
                ],
                [
                    94.9131961,
                    55.9256717
                ],
                [
                    94.9146816,
                    55.924673
                ],
                [
                    94.9187137,
                    55.9239952
                ],
                [
                    94.9175253,
                    55.9256955
                ],
                [
                    94.9215574,
                    55.9282042
                ],
                [
                    94.9229368,
                    55.9292861
                ],
                [
                    94.9258017,
                    55.9291434
                ],
                [
                    94.9276056,
                    55.9280734
                ],
                [
                    94.9286666,
                    55.9258858
                ],
                [
                    94.9323592,
                    55.9262068
                ],
                [
                    94.9337386,
                    55.9247324
                ],
                [
                    94.9380678,
                    55.9232461
                ],
                [
                    94.9431398,
                    55.918561
                ],
                [
                    94.9416119,
                    55.9179664
                ],
                [
                    94.9454742,
                    55.9164204
                ],
                [
                    94.9471067,
                    55.9172902
                ],
                [
                    94.9480633,
                    55.9177999
                ],
                [
                    94.9522439,
                    55.9185253
                ],
                [
                    94.9544298,
                    55.9183231
                ],
                [
                    94.9543725,
                    55.917512
                ],
                [
                    94.9543449,
                    55.917122
                ],
                [
                    94.9527957,
                    55.9170863
                ],
                [
                    94.9555545,
                    55.9163014
                ],
                [
                    94.9597988,
                    55.916349
                ],
                [
                    94.9633216,
                    55.9171696
                ],
                [
                    94.965083,
                    55.9166344
                ],
                [
                    94.9691576,
                    55.9161706
                ],
                [
                    94.9669081,
                    55.9133995
                ],
                [
                    94.9693061,
                    55.9127929
                ],
                [
                    94.9699852,
                    55.9116749
                ],
                [
                    94.9696436,
                    55.9104097
                ],
                [
                    94.9694971,
                    55.9098669
                ],
                [
                    94.9710251,
                    55.9088559
                ],
                [
                    94.9690515,
                    55.9061556
                ],
                [
                    94.9678419,
                    55.9030269
                ],
                [
                    94.9646374,
                    55.9022179
                ],
                [
                    94.9630245,
                    55.8987319
                ],
                [
                    94.9595017,
                    55.895555
                ],
                [
                    94.9556606,
                    55.8954836
                ],
                [
                    94.9557243,
                    55.8960786
                ],
                [
                    94.9541751,
                    55.8958168
                ],
                [
                    94.9539417,
                    55.8955193
                ],
                [
                    94.9524774,
                    55.8952099
                ],
                [
                    94.951289,
                    55.896495
                ],
                [
                    94.9498883,
                    55.8960905
                ],
                [
                    94.9508009,
                    55.8947102
                ],
                [
                    94.9492304,
                    55.8941271
                ],
                [
                    94.9496973,
                    55.8932822
                ],
                [
                    94.9478298,
                    55.891997
                ],
                [
                    94.9451134,
                    55.8920208
                ],
                [
                    94.9443707,
                    55.8914853
                ],
                [
                    94.9446985,
                    55.8908996
                ],
                [
                    94.9468748,
                    55.8870106
                ],
                [
                    94.9502491,
                    55.8848801
                ],
                [
                    94.9518619,
                    55.8818687
                ],
                [
                    94.9557455,
                    55.8769404
                ],
                [
                    94.9544085,
                    55.8756309
                ],
                [
                    94.9526259,
                    55.8656888
                ],
                [
                    94.9469385,
                    55.8655102
                ],
                [
                    94.9451134,
                    55.8666176
                ],
                [
                    94.9450073,
                    55.8744165
                ],
                [
                    94.9455581,
                    55.8767155
                ],
                [
                    94.9458774,
                    55.8780476
                ],
                [
                    94.9496973,
                    55.8793451
                ],
                [
                    94.9503976,
                    55.8804165
                ],
                [
                    94.9491456,
                    55.8823567
                ],
                [
                    94.9436491,
                    55.8842731
                ],
                [
                    94.9376646,
                    55.8838684
                ],
                [
                    94.9264172,
                    55.8848682
                ],
                [
                    94.9206449,
                    55.8851419
                ],
                [
                    94.9111163,
                    55.8861417
                ],
                [
                    94.9106282,
                    55.8846182
                ],
                [
                    94.9111588,
                    55.8841778
                ],
                [
                    94.9143845,
                    55.884285
                ],
                [
                    94.9183741,
                    55.8832018
                ],
                [
                    94.9209207,
                    55.8829162
                ],
                [
                    94.9204751,
                    55.8838684
                ],
                [
                    94.9213027,
                    55.8838446
                ],
                [
                    94.9241464,
                    55.8827614
                ],
                [
                    94.9233612,
                    55.8822139
                ],
                [
                    94.9232763,
                    55.8818211
                ],
                [
                    94.9243162,
                    55.8808688
                ],
                [
                    94.9269901,
                    55.880345
                ],
                [
                    94.9269477,
                    55.8800117
                ],
                [
                    94.9245284,
                    55.8801903
                ],
                [
                    94.9245921,
                    55.8800236
                ],
                [
                    94.9266506,
                    55.8797975
                ],
                [
                    94.9266294,
                    55.8795713
                ],
                [
                    94.9335689,
                    55.8785475
                ],
                [
                    94.9338023,
                    55.8788451
                ],
                [
                    94.9362216,
                    55.8789166
                ],
                [
                    94.9361367,
                    55.8782142
                ],
                [
                    94.9352878,
                    55.8774166
                ],
                [
                    94.9350119,
                    55.8764166
                ],
                [
                    94.9358396,
                    55.873976
                ],
                [
                    94.9361155,
                    55.8727854
                ],
                [
                    94.9367309,
                    55.8727735
                ],
                [
                    94.9380466,
                    55.8730236
                ],
                [
                    94.9389592,
                    55.8725354
                ],
                [
                    94.9400839,
                    55.8724997
                ],
                [
                    94.9393836,
                    55.870547
                ],
                [
                    94.9384074,
                    55.8693802
                ],
                [
                    94.9342904,
                    55.8672249
                ],
                [
                    94.9309798,
                    55.8664747
                ],
                [
                    94.9254648,
                    55.8666404
                ],
                [
                    94.9108418,
                    55.8681474
                ],
                [
                    94.9063322,
                    55.8697475
                ],
                [
                    94.90421,
                    55.8725381
                ],
                [
                    94.9066306,
                    55.8758307
                ],
                [
                    94.9056358,
                    55.8760167
                ],
                [
                    94.9039447,
                    55.8751424
                ],
                [
                    94.8991367,
                    55.876519
                ],
                [
                    94.8977772,
                    55.8743425
                ],
                [
                    94.8949255,
                    55.8754587
                ],
                [
                    94.893566,
                    55.8765004
                ],
                [
                    94.8927039,
                    55.877914
                ],
                [
                    94.8931349,
                    55.8782116
                ],
                [
                    94.8910459,
                    55.8783977
                ],
                [
                    94.890217,
                    55.8801461
                ],
                [
                    94.8877632,
                    55.8801461
                ],
                [
                    94.8860721,
                    55.8816526
                ],
                [
                    94.8826899,
                    55.8826569
                ],
                [
                    94.8830546,
                    55.8832707
                ],
                [
                    94.8847789,
                    55.8836798
                ],
                [
                    94.8860058,
                    55.8834381
                ],
                [
                    94.8880948,
                    55.8836984
                ],
                [
                    94.8898191,
                    55.8844981
                ],
                [
                    94.8897859,
                    55.8849445
                ],
                [
                    94.8883601,
                    55.8846841
                ],
                [
                    94.8790756,
                    55.8847771
                ],
                [
                    94.8782135,
                    55.885149
                ],
                [
                    94.8742675,
                    55.8850189
                ],
                [
                    94.8711506,
                    55.8841634
                ],
                [
                    94.8704874,
                    55.8841634
                ],
                [
                    94.8707527,
                    55.8837914
                ],
                [
                    94.8723443,
                    55.8828243
                ],
                [
                    94.8697911,
                    55.8819502
                ],
                [
                    94.8682658,
                    55.8803321
                ],
                [
                    94.8677021,
                    55.8773188
                ],
                [
                    94.8679342,
                    55.8761655
                ],
                [
                    94.8690948,
                    55.8754773
                ],
                [
                    94.8686969,
                    55.8752912
                ],
                [
                    94.8667073,
                    55.8755889
                ],
                [
                    94.8648173,
                    55.8749936
                ],
                [
                    94.8637893,
                    55.8739147
                ],
                [
                    94.8649831,
                    55.8725008
                ],
                [
                    94.8652152,
                    55.8710312
                ],
                [
                    94.8640878,
                    55.8699335
                ],
                [
                    94.8620651,
                    55.869487
                ],
                [
                    94.8607056,
                    55.869673
                ],
                [
                    94.8601419,
                    55.8691149
                ],
                [
                    94.8615345,
                    55.8683893
                ],
                [
                    94.8586497,
                    55.8686684
                ],
                [
                    94.856826,
                    55.8678869
                ],
                [
                    94.856196,
                    55.8788627
                ],
                [
                    94.8532117,
                    55.8812434
                ],
                [
                    94.8499289,
                    55.8826569
                ],
                [
                    94.8499289,
                    55.8837542
                ],
                [
                    94.8452204,
                    55.8850933
                ],
                [
                    94.8417719,
                    55.8858743
                ],
                [
                    94.8436288,
                    55.8879199
                ],
                [
                    94.8450214,
                    55.8898725
                ],
                [
                    94.8454857,
                    55.8925129
                ],
                [
                    94.8498958,
                    55.8911183
                ],
                [
                    94.8594787,
                    55.8893332
                ],
                [
                    94.8663757,
                    55.8895564
                ],
                [
                    94.8691898,
                    55.890056
                ],
                [
                    94.8745991,
                    55.8890915
                ],
                [
                    94.8713827,
                    55.8942235
                ],
                [
                    94.8666742,
                    55.8943722
                ],
                [
                    94.8686735,
                    55.8962819
                ],
                [
                    94.8705538,
                    55.8981092
                ],
                [
                    94.8673705,
                    55.8999682
                ],
                [
                    94.8606061,
                    55.9014368
                ],
                [
                    94.8522501,
                    55.9000798
                ],
                [
                    94.8400144,
                    55.9009721
                ],
                [
                    94.8395834,
                    55.9017157
                ],
                [
                    94.8326569,
                    55.898586
                ],
                [
                    94.8323598,
                    55.8989786
                ],
                [
                    94.8311926,
                    55.898931
                ]
            ],
            "longitude": 94.8945997,
            "latitude": 55.8992103
        },
        "5760": {
            "name": "ТАСЕЕВО",
            "population": 8038,
            "type": "town",
            "poly": [
                [
                    94.8605439,
                    57.2190342
                ],
                [
                    94.8626039,
                    57.2265618
                ],
                [
                    94.8694703,
                    57.2247962
                ],
                [
                    94.8739335,
                    57.2277698
                ],
                [
                    94.8777101,
                    57.2302785
                ],
                [
                    94.8838899,
                    57.231858
                ],
                [
                    94.8886964,
                    57.2326013
                ],
                [
                    94.8940179,
                    57.226283
                ],
                [
                    94.900541,
                    57.2283273
                ],
                [
                    94.9024293,
                    57.2272122
                ],
                [
                    94.9012277,
                    57.2256325
                ],
                [
                    94.9032876,
                    57.2247033
                ],
                [
                    94.9118707,
                    57.2271193
                ],
                [
                    94.9086091,
                    57.2354814
                ],
                [
                    94.9125573,
                    57.2371535
                ],
                [
                    94.9144455,
                    57.2340878
                ],
                [
                    94.9178788,
                    57.2338091
                ],
                [
                    94.9166772,
                    57.2315793
                ],
                [
                    94.9173638,
                    57.228606
                ],
                [
                    94.9195954,
                    57.226283
                ],
                [
                    94.9218269,
                    57.2244245
                ],
                [
                    94.9245736,
                    57.2244245
                ],
                [
                    94.9247453,
                    57.2231235
                ],
                [
                    94.9237153,
                    57.2198707
                ],
                [
                    94.9154755,
                    57.2196848
                ],
                [
                    94.9235436,
                    57.2178259
                ],
                [
                    94.9204537,
                    57.2157811
                ],
                [
                    94.9259469,
                    57.2143868
                ],
                [
                    94.9242303,
                    57.2105755
                ],
                [
                    94.9204537,
                    57.2095529
                ],
                [
                    94.9209687,
                    57.2081583
                ],
                [
                    94.9178788,
                    57.2074146
                ],
                [
                    94.9125573,
                    57.209088
                ],
                [
                    94.9108407,
                    57.209088
                ],
                [
                    94.9099824,
                    57.2081583
                ],
                [
                    94.9091241,
                    57.2072286
                ],
                [
                    94.912729,
                    57.2048113
                ],
                [
                    94.9151322,
                    57.2013709
                ],
                [
                    94.9163339,
                    57.1983952
                ],
                [
                    94.9163339,
                    57.1956983
                ],
                [
                    94.9187371,
                    57.1935592
                ],
                [
                    94.9185655,
                    57.1925361
                ],
                [
                    94.9166772,
                    57.191513
                ],
                [
                    94.9153039,
                    57.1902108
                ],
                [
                    94.9170205,
                    57.1881644
                ],
                [
                    94.9101541,
                    57.186583
                ],
                [
                    94.9080941,
                    57.1891876
                ],
                [
                    94.9003694,
                    57.1910479
                ],
                [
                    94.8969361,
                    57.1926291
                ],
                [
                    94.9012277,
                    57.1957913
                ],
                [
                    94.9001977,
                    57.1974653
                ],
                [
                    94.8941895,
                    57.1966283
                ],
                [
                    94.8928163,
                    57.1945823
                ],
                [
                    94.8857781,
                    57.1948613
                ],
                [
                    94.8674104,
                    57.2026727
                ],
                [
                    94.8660371,
                    57.2054621
                ],
                [
                    94.8722169,
                    57.2102966
                ],
                [
                    94.8674104,
                    57.2168035
                ],
                [
                    94.8605439,
                    57.2190342
                ]
            ],
            "longitude": 94.898598,
            "latitude": 57.216042
        },
        "5761": {
            "name": "АГИНСКОЕ",
            "population": 5584,
            "type": "town",
            "poly": null,
            "longitude": 94.906372,
            "latitude": 55.258972
        },
        "5762": {
            "name": "ДЗЕРЖИНСКОЕ",
            "population": 7374,
            "type": "town",
            "poly": null,
            "longitude": 95.22139,
            "latitude": 56.838005
        },
        "5763": {
            "name": "ИРБЕЙСКОЕ",
            "population": 4687,
            "type": "town",
            "poly": null,
            "longitude": 95.456528,
            "latitude": 55.644501
        },
        "5764": {
            "name": "ИЛАНСКИЙ",
            "population": 15357,
            "type": "town",
            "poly": [
                [
                    96.011916,
                    56.2553202
                ],
                [
                    96.0150406,
                    56.2559286
                ],
                [
                    96.0164901,
                    56.2554276
                ],
                [
                    96.0170377,
                    56.2559822
                ],
                [
                    96.018906,
                    56.2554276
                ],
                [
                    96.021966,
                    56.2565906
                ],
                [
                    96.0241886,
                    56.2563401
                ],
                [
                    96.0262501,
                    56.2570379
                ],
                [
                    96.0268943,
                    56.2566085
                ],
                [
                    96.0280217,
                    56.2567695
                ],
                [
                    96.0285371,
                    56.2573063
                ],
                [
                    96.0304053,
                    56.2578609
                ],
                [
                    96.0315649,
                    56.2574315
                ],
                [
                    96.0325957,
                    56.2577178
                ],
                [
                    96.0330789,
                    56.2571631
                ],
                [
                    96.0337553,
                    56.257521
                ],
                [
                    96.0343351,
                    56.2569127
                ],
                [
                    96.0357202,
                    56.2574315
                ],
                [
                    96.0400365,
                    56.2566622
                ],
                [
                    96.0410672,
                    56.2575747
                ],
                [
                    96.0419692,
                    56.2567695
                ],
                [
                    96.0442884,
                    56.2569842
                ],
                [
                    96.0461888,
                    56.2566801
                ],
                [
                    96.0472196,
                    56.2569663
                ],
                [
                    96.0500086,
                    56.2566115
                ],
                [
                    96.0535652,
                    56.25702
                ],
                [
                    96.0564641,
                    56.2537277
                ],
                [
                    96.0634218,
                    56.2522961
                ],
                [
                    96.0647747,
                    56.2522246
                ],
                [
                    96.0685756,
                    56.2504709
                ],
                [
                    96.0701862,
                    56.2540498
                ],
                [
                    96.0807834,
                    56.2584928
                ],
                [
                    96.0983324,
                    56.2556531
                ],
                [
                    96.1022894,
                    56.2550243
                ],
                [
                    96.104612,
                    56.2544731
                ],
                [
                    96.1101027,
                    56.2536401
                ],
                [
                    96.1167886,
                    56.2528197
                ],
                [
                    96.1200084,
                    56.2522626
                ],
                [
                    96.127909,
                    56.251111
                ],
                [
                    96.128204,
                    56.2504263
                ],
                [
                    96.1281082,
                    56.2502713
                ],
                [
                    96.128212,
                    56.2493368
                ],
                [
                    96.1289534,
                    56.2452085
                ],
                [
                    96.1290411,
                    56.2442826
                ],
                [
                    96.1298144,
                    56.2444731
                ],
                [
                    96.1305638,
                    56.2444554
                ],
                [
                    96.1316799,
                    56.2443225
                ],
                [
                    96.1327084,
                    56.2440478
                ],
                [
                    96.1333063,
                    56.2439681
                ],
                [
                    96.1343188,
                    56.2439725
                ],
                [
                    96.1371489,
                    56.2440611
                ],
                [
                    96.1383289,
                    56.24407
                ],
                [
                    96.1386956,
                    56.2440301
                ],
                [
                    96.1390942,
                    56.2439238
                ],
                [
                    96.1394689,
                    56.2438928
                ],
                [
                    96.140019,
                    56.2439592
                ],
                [
                    96.1406329,
                    56.2440833
                ],
                [
                    96.141167,
                    56.2442649
                ],
                [
                    96.1418367,
                    56.2443402
                ],
                [
                    96.1449459,
                    56.2444997
                ],
                [
                    96.145488,
                    56.244451
                ],
                [
                    96.1459184,
                    56.2444997
                ],
                [
                    96.1463331,
                    56.2446149
                ],
                [
                    96.1469948,
                    56.2448674
                ],
                [
                    96.1474652,
                    56.2449692
                ],
                [
                    96.148103,
                    56.245018
                ],
                [
                    96.1487567,
                    56.2450977
                ],
                [
                    96.1493467,
                    56.2450977
                ],
                [
                    96.1496973,
                    56.245111
                ],
                [
                    96.1499843,
                    56.245204
                ],
                [
                    96.1514912,
                    56.2456736
                ],
                [
                    96.1530139,
                    56.2460235
                ],
                [
                    96.1544968,
                    56.2460279
                ],
                [
                    96.155302,
                    56.2461653
                ],
                [
                    96.1555173,
                    56.246276
                ],
                [
                    96.15645,
                    56.2461741
                ],
                [
                    96.1571277,
                    56.2461608
                ],
                [
                    96.1577017,
                    56.2462096
                ],
                [
                    96.1581003,
                    56.246307
                ],
                [
                    96.1584892,
                    56.2463177
                ],
                [
                    96.1588241,
                    56.2462513
                ],
                [
                    96.1594778,
                    56.2461361
                ],
                [
                    96.1606099,
                    56.2459811
                ],
                [
                    96.1612875,
                    56.2459368
                ],
                [
                    96.164325,
                    56.2464152
                ],
                [
                    96.1654571,
                    56.2465658
                ],
                [
                    96.1704478,
                    56.2474783
                ],
                [
                    96.1723611,
                    56.2479212
                ],
                [
                    96.1727518,
                    56.2482268
                ],
                [
                    96.173565,
                    56.2483464
                ],
                [
                    96.1742584,
                    56.2483641
                ],
                [
                    96.1749362,
                    56.2483066
                ],
                [
                    96.1758152,
                    56.2482128
                ],
                [
                    96.1773618,
                    56.2482216
                ],
                [
                    96.1774415,
                    56.248638
                ],
                [
                    96.1785456,
                    56.2486233
                ],
                [
                    96.178893,
                    56.2485579
                ],
                [
                    96.1791128,
                    56.2484984
                ],
                [
                    96.1792143,
                    56.2484013
                ],
                [
                    96.1809562,
                    56.248417
                ],
                [
                    96.1816552,
                    56.2484733
                ],
                [
                    96.182157,
                    56.2484608
                ],
                [
                    96.1840397,
                    56.2482604
                ],
                [
                    96.1843611,
                    56.2482698
                ],
                [
                    96.1848347,
                    56.2483637
                ],
                [
                    96.1853308,
                    56.2483606
                ],
                [
                    96.1866048,
                    56.2482604
                ],
                [
                    96.1870332,
                    56.2482729
                ],
                [
                    96.1876082,
                    56.2483856
                ],
                [
                    96.1881945,
                    56.2483418
                ],
                [
                    96.1893953,
                    56.2482228
                ],
                [
                    96.1897335,
                    56.2482353
                ],
                [
                    96.1911372,
                    56.2483575
                ],
                [
                    96.1918531,
                    56.2483481
                ],
                [
                    96.1928791,
                    56.2482228
                ],
                [
                    96.1935725,
                    56.2482979
                ],
                [
                    96.1949875,
                    56.2485235
                ],
                [
                    96.1958724,
                    56.2485454
                ],
                [
                    96.196425,
                    56.2485141
                ],
                [
                    96.1970113,
                    56.248417
                ],
                [
                    96.1972988,
                    56.2483355
                ],
                [
                    96.1978174,
                    56.248442
                ],
                [
                    96.1983135,
                    56.2486143
                ],
                [
                    96.1989561,
                    56.2488711
                ],
                [
                    96.1992211,
                    56.2489369
                ],
                [
                    96.2002526,
                    56.2489463
                ],
                [
                    96.2013182,
                    56.2489463
                ],
                [
                    96.2020115,
                    56.2489901
                ],
                [
                    96.2025978,
                    56.2490778
                ],
                [
                    96.2032743,
                    56.2491561
                ],
                [
                    96.2036351,
                    56.2492908
                ],
                [
                    96.2038888,
                    56.249272
                ],
                [
                    96.2049598,
                    56.2489244
                ],
                [
                    96.2052643,
                    56.2489118
                ],
                [
                    96.2057603,
                    56.2489839
                ],
                [
                    96.207454,
                    56.2490709
                ],
                [
                    96.2083788,
                    56.2493101
                ],
                [
                    96.2096703,
                    56.2493278
                ],
                [
                    96.2101965,
                    56.2494696
                ],
                [
                    96.2105313,
                    56.2496556
                ],
                [
                    96.2109778,
                    56.2495936
                ],
                [
                    96.2122853,
                    56.249319
                ],
                [
                    96.2137682,
                    56.2491595
                ],
                [
                    96.2149321,
                    56.2492924
                ],
                [
                    96.2163034,
                    56.2496379
                ],
                [
                    96.2167658,
                    56.2500099
                ],
                [
                    96.2172919,
                    56.250382
                ],
                [
                    96.2176587,
                    56.2505149
                ],
                [
                    96.2179776,
                    56.2505503
                ],
                [
                    96.2174673,
                    56.2483534
                ],
                [
                    96.2168774,
                    56.2466879
                ],
                [
                    96.2162236,
                    56.2445705
                ],
                [
                    96.2156496,
                    56.2425593
                ],
                [
                    96.2144857,
                    56.2392986
                ],
                [
                    96.2139595,
                    56.2374289
                ],
                [
                    96.2138319,
                    56.2360022
                ],
                [
                    96.2141987,
                    56.235568
                ],
                [
                    96.2153945,
                    56.2332373
                ],
                [
                    96.2156018,
                    56.2310837
                ],
                [
                    96.2167658,
                    56.2282475
                ],
                [
                    96.2168455,
                    56.2276537
                ],
                [
                    96.217276,
                    56.2268116
                ],
                [
                    96.2175949,
                    56.2258632
                ],
                [
                    96.2171484,
                    56.2259696
                ],
                [
                    96.2163671,
                    56.2265634
                ],
                [
                    96.2157453,
                    56.226918
                ],
                [
                    96.215267,
                    56.2269623
                ],
                [
                    96.214374,
                    56.2269003
                ],
                [
                    96.2136246,
                    56.2269978
                ],
                [
                    96.2130825,
                    56.2272016
                ],
                [
                    96.2122215,
                    56.2271219
                ],
                [
                    96.2110576,
                    56.2270775
                ],
                [
                    96.2098458,
                    56.2271573
                ],
                [
                    96.2083788,
                    56.2270332
                ],
                [
                    96.2075497,
                    56.2269889
                ],
                [
                    96.2068163,
                    56.2271662
                ],
                [
                    96.2062901,
                    56.2272105
                ],
                [
                    96.205732,
                    56.2270332
                ],
                [
                    96.2050145,
                    56.2268116
                ],
                [
                    96.2044405,
                    56.2267584
                ],
                [
                    96.2035954,
                    56.2269889
                ],
                [
                    96.2030374,
                    56.2269003
                ],
                [
                    96.2016502,
                    56.2268028
                ],
                [
                    96.2005978,
                    56.2268825
                ],
                [
                    96.1997368,
                    56.2270953
                ],
                [
                    96.1986526,
                    56.2270066
                ],
                [
                    96.1975205,
                    56.2269978
                ],
                [
                    96.1962669,
                    56.2267873
                ],
                [
                    96.1952145,
                    56.2265569
                ],
                [
                    96.1942738,
                    56.2265392
                ],
                [
                    96.1933808,
                    56.2265923
                ],
                [
                    96.191898,
                    56.226743
                ],
                [
                    96.1908935,
                    56.2267696
                ],
                [
                    96.19016,
                    56.2266544
                ],
                [
                    96.1892034,
                    56.2266987
                ],
                [
                    96.1882945,
                    56.2265746
                ],
                [
                    96.1866682,
                    56.2263885
                ],
                [
                    96.1860782,
                    56.2264682
                ],
                [
                    96.1850259,
                    56.2266367
                ],
                [
                    96.1843402,
                    56.2266101
                ],
                [
                    96.1825704,
                    56.2264416
                ],
                [
                    96.180673,
                    56.2261757
                ],
                [
                    96.1795568,
                    56.2262112
                ],
                [
                    96.1789669,
                    56.2263619
                ],
                [
                    96.178648,
                    56.2267962
                ],
                [
                    96.1785045,
                    56.2274521
                ],
                [
                    96.1784407,
                    56.2286487
                ],
                [
                    96.1782175,
                    56.2292425
                ],
                [
                    96.1775636,
                    56.2298275
                ],
                [
                    96.1763679,
                    56.2310063
                ],
                [
                    96.1747734,
                    56.2305543
                ],
                [
                    96.1701973,
                    56.2290918
                ],
                [
                    96.1625598,
                    56.2268582
                ],
                [
                    96.1592591,
                    56.2225325
                ],
                [
                    96.1624035,
                    56.2202449
                ],
                [
                    96.1623359,
                    56.2201195
                ],
                [
                    96.1629222,
                    56.2187215
                ],
                [
                    96.1631251,
                    56.2186526
                ],
                [
                    96.168582,
                    56.2181385
                ],
                [
                    96.1692585,
                    56.2179881
                ],
                [
                    96.1710736,
                    56.2168408
                ],
                [
                    96.1741066,
                    56.2161198
                ],
                [
                    96.1812998,
                    56.2155744
                ],
                [
                    96.1871625,
                    56.2117185
                ],
                [
                    96.1860013,
                    56.2110727
                ],
                [
                    96.1857645,
                    56.2108281
                ],
                [
                    96.1839971,
                    56.208173
                ],
                [
                    96.1776157,
                    56.2013624
                ],
                [
                    96.1772549,
                    56.2012871
                ],
                [
                    96.1760147,
                    56.2017513
                ],
                [
                    96.1751127,
                    56.2019018
                ],
                [
                    96.1738048,
                    56.2018767
                ],
                [
                    96.1731735,
                    56.2017763
                ],
                [
                    96.1723843,
                    56.2018265
                ],
                [
                    96.1716176,
                    56.2020523
                ],
                [
                    96.1684382,
                    56.202253
                ],
                [
                    96.1653264,
                    56.2033568
                ],
                [
                    96.1650107,
                    56.2033442
                ],
                [
                    96.164199,
                    56.2030307
                ],
                [
                    96.1613803,
                    56.2028551
                ],
                [
                    96.1569607,
                    56.2027547
                ],
                [
                    96.153443,
                    56.2028927
                ],
                [
                    96.146137,
                    56.2028927
                ],
                [
                    96.1439046,
                    56.2031059
                ],
                [
                    96.1423037,
                    56.2035951
                ],
                [
                    96.1413792,
                    56.2036076
                ],
                [
                    96.1393272,
                    56.2034697
                ],
                [
                    96.138335,
                    56.2036954
                ],
                [
                    96.134682,
                    56.2039714
                ],
                [
                    96.1343213,
                    56.2036954
                ],
                [
                    96.1338477,
                    56.2035449
                ],
                [
                    96.1323144,
                    56.2036954
                ],
                [
                    96.12918,
                    56.2036453
                ],
                [
                    96.126429,
                    56.2038209
                ],
                [
                    96.1247153,
                    56.2041595
                ],
                [
                    96.1234525,
                    56.2044982
                ],
                [
                    96.1223927,
                    56.2050375
                ],
                [
                    96.1209045,
                    56.2055392
                ],
                [
                    96.119326,
                    56.2056772
                ],
                [
                    96.117928,
                    56.2057022
                ],
                [
                    96.1174179,
                    56.2058536
                ],
                [
                    96.1169894,
                    56.206142
                ],
                [
                    96.1169443,
                    56.2066061
                ],
                [
                    96.1157041,
                    56.206581
                ],
                [
                    96.1135618,
                    56.2063553
                ],
                [
                    96.1106305,
                    56.2059414
                ],
                [
                    96.1086688,
                    56.20554
                ],
                [
                    96.1015207,
                    56.2047248
                ],
                [
                    96.1002579,
                    56.2047373
                ],
                [
                    96.093642,
                    56.2041713
                ],
                [
                    96.0895187,
                    56.2038234
                ],
                [
                    96.0872023,
                    56.2034498
                ],
                [
                    96.0862757,
                    56.2031792
                ],
                [
                    96.0854649,
                    56.2031276
                ],
                [
                    96.0847005,
                    56.2032694
                ],
                [
                    96.0804151,
                    56.203089
                ],
                [
                    96.0781913,
                    56.2033724
                ],
                [
                    96.0753189,
                    56.2031534
                ],
                [
                    96.0748325,
                    56.2032049
                ],
                [
                    96.0738596,
                    56.2036301
                ],
                [
                    96.0724465,
                    56.2036946
                ],
                [
                    96.0702459,
                    56.2033724
                ],
                [
                    96.068995,
                    56.203424
                ],
                [
                    96.0679295,
                    56.2034884
                ],
                [
                    96.0660531,
                    56.2035013
                ],
                [
                    96.0653279,
                    56.2034658
                ],
                [
                    96.0650615,
                    56.2064583
                ],
                [
                    96.0650615,
                    56.2069575
                ],
                [
                    96.0651194,
                    56.2072346
                ],
                [
                    96.0654032,
                    56.2075824
                ],
                [
                    96.0679803,
                    56.2103201
                ],
                [
                    96.0709784,
                    56.2134891
                ],
                [
                    96.0712447,
                    56.2139336
                ],
                [
                    96.0722756,
                    56.215943
                ],
                [
                    96.0755825,
                    56.2212893
                ],
                [
                    96.0759762,
                    56.2219397
                ],
                [
                    96.0760921,
                    56.2225644
                ],
                [
                    96.0759415,
                    56.2234658
                ],
                [
                    96.075161,
                    56.2261437
                ],
                [
                    96.0747597,
                    56.2261392
                ],
                [
                    96.0743748,
                    56.2261346
                ],
                [
                    96.074211,
                    56.226039
                ],
                [
                    96.0740718,
                    56.2259297
                ],
                [
                    96.0740472,
                    56.2256839
                ],
                [
                    96.07408,
                    56.2254835
                ],
                [
                    96.0738998,
                    56.225265
                ],
                [
                    96.0717459,
                    56.2250191
                ],
                [
                    96.0714592,
                    56.225051
                ],
                [
                    96.0713118,
                    56.2252969
                ],
                [
                    96.0710661,
                    56.2253697
                ],
                [
                    96.0710907,
                    56.2255837
                ],
                [
                    96.0703453,
                    56.2257977
                ],
                [
                    96.068732,
                    56.2256384
                ],
                [
                    96.0684535,
                    56.225693
                ],
                [
                    96.0680768,
                    56.2265945
                ],
                [
                    96.0555373,
                    56.2245993
                ],
                [
                    96.0553558,
                    56.2250877
                ],
                [
                    96.0542108,
                    56.2251421
                ],
                [
                    96.0533354,
                    56.2252849
                ],
                [
                    96.0518617,
                    56.225639
                ],
                [
                    96.0514107,
                    56.2254913
                ],
                [
                    96.0506538,
                    56.2253749
                ],
                [
                    96.0499051,
                    56.2254554
                ],
                [
                    96.0492445,
                    56.2262523
                ],
                [
                    96.0468931,
                    56.226118
                ],
                [
                    96.0454758,
                    56.2258629
                ],
                [
                    96.0430463,
                    56.2259286
                ],
                [
                    96.0426815,
                    56.2264583
                ],
                [
                    96.0411756,
                    56.226691
                ],
                [
                    96.041385,
                    56.2286338
                ],
                [
                    96.04062,
                    56.2286652
                ],
                [
                    96.0408213,
                    56.2301961
                ],
                [
                    96.0400966,
                    56.2301647
                ],
                [
                    96.0399919,
                    56.2303438
                ],
                [
                    96.0392891,
                    56.2314134
                ],
                [
                    96.0383169,
                    56.2333427
                ],
                [
                    96.0395973,
                    56.2348108
                ],
                [
                    96.0353689,
                    56.2367016
                ],
                [
                    96.0348627,
                    56.2379931
                ],
                [
                    96.0348747,
                    56.240239
                ],
                [
                    96.0349447,
                    56.2433832
                ],
                [
                    96.0358067,
                    56.2447465
                ],
                [
                    96.0363098,
                    56.2478503
                ],
                [
                    96.0366757,
                    56.2482544
                ],
                [
                    96.0366453,
                    56.2499434
                ],
                [
                    96.0228679,
                    56.2509898
                ],
                [
                    96.0175531,
                    56.2518488
                ],
                [
                    96.0144401,
                    56.2527872
                ],
                [
                    96.0133978,
                    56.2534951
                ],
                [
                    96.011916,
                    56.2553202
                ]
            ],
            "longitude": 96.06694,
            "latitude": 56.23806
        },
        "5765": {
            "name": "АБАН",
            "population": 9187,
            "type": "town",
            "poly": null,
            "longitude": 96.067764,
            "latitude": 56.67667
        },
        "5766": {
            "name": "НИЖНИЙ ИНГАШ",
            "population": 7062,
            "type": "town",
            "poly": null,
            "longitude": 96.544518,
            "latitude": 56.203602
        },
        "5767": {
            "name": "НИЖНЯЯ ПОЙМА",
            "population": 8321,
            "type": "town",
            "poly": [
                [
                    97.1631515,
                    56.1601311
                ],
                [
                    97.1632927,
                    56.1619807
                ],
                [
                    97.1720783,
                    56.1615524
                ],
                [
                    97.1776271,
                    56.1615921
                ],
                [
                    97.1729637,
                    56.1648146
                ],
                [
                    97.1758549,
                    56.1703457
                ],
                [
                    97.1928267,
                    56.1723442
                ],
                [
                    97.1954543,
                    56.1759188
                ],
                [
                    97.2026079,
                    56.1772692
                ],
                [
                    97.2006404,
                    56.1807316
                ],
                [
                    97.2081531,
                    56.180931
                ],
                [
                    97.2085366,
                    56.1831275
                ],
                [
                    97.2282116,
                    56.1817167
                ],
                [
                    97.2314732,
                    56.1799014
                ],
                [
                    97.2357647,
                    56.1795192
                ],
                [
                    97.2352497,
                    56.1783726
                ],
                [
                    97.2298338,
                    56.1787003
                ],
                [
                    97.2294772,
                    56.1767316
                ],
                [
                    97.236704,
                    56.175545
                ],
                [
                    97.2364513,
                    56.1692944
                ],
                [
                    97.2314732,
                    56.1685299
                ],
                [
                    97.2282116,
                    56.1646112
                ],
                [
                    97.2172253,
                    56.161648
                ],
                [
                    97.2129461,
                    56.1586958
                ],
                [
                    97.215852,
                    56.1583978
                ],
                [
                    97.2220059,
                    56.1610067
                ],
                [
                    97.2266585,
                    56.1611893
                ],
                [
                    97.2337048,
                    56.1583022
                ],
                [
                    97.2318165,
                    56.1573462
                ],
                [
                    97.2255361,
                    56.1597502
                ],
                [
                    97.2231912,
                    56.1568197
                ],
                [
                    97.2206815,
                    56.1568944
                ],
                [
                    97.2180311,
                    56.1562268
                ],
                [
                    97.2167593,
                    56.1544007
                ],
                [
                    97.2198723,
                    56.1538553
                ],
                [
                    97.2194569,
                    56.1501755
                ],
                [
                    97.2172253,
                    56.1500799
                ],
                [
                    97.204694,
                    56.1499843
                ],
                [
                    97.193536,
                    56.1473068
                ],
                [
                    97.1906254,
                    56.1474894
                ],
                [
                    97.1957754,
                    56.1546585
                ],
                [
                    97.1898374,
                    56.1565543
                ],
                [
                    97.1886908,
                    56.1539624
                ],
                [
                    97.1811529,
                    56.1533389
                ],
                [
                    97.1804051,
                    56.1504951
                ],
                [
                    97.1658433,
                    56.1493192
                ],
                [
                    97.1653881,
                    56.1530056
                ],
                [
                    97.165204,
                    56.1552465
                ],
                [
                    97.1745634,
                    56.156466
                ],
                [
                    97.1734355,
                    56.1584936
                ],
                [
                    97.1631515,
                    56.1601311
                ]
            ],
            "longitude": 97.20192,
            "latitude": 56.163059
        },
        "5768": {
            "name": "БОГУЧАНЫ",
            "population": 11232,
            "type": "town",
            "poly": [
                [
                    97.3496277,
                    58.3943245
                ],
                [
                    97.3498164,
                    58.3945436
                ],
                [
                    97.3504568,
                    58.3946142
                ],
                [
                    97.3514072,
                    58.3944835
                ],
                [
                    97.3524407,
                    58.3947527
                ],
                [
                    97.3559773,
                    58.3935037
                ],
                [
                    97.364328,
                    58.3913504
                ],
                [
                    97.3817919,
                    58.3884625
                ],
                [
                    97.3983787,
                    58.3870234
                ],
                [
                    97.4077779,
                    58.3864638
                ],
                [
                    97.4238245,
                    58.3860745
                ],
                [
                    97.42493,
                    58.3861628
                ],
                [
                    97.4265477,
                    58.3861769
                ],
                [
                    97.4321966,
                    58.3861587
                ],
                [
                    97.4374015,
                    58.3861287
                ],
                [
                    97.4381164,
                    58.3859139
                ],
                [
                    97.4427684,
                    58.3859888
                ],
                [
                    97.4432831,
                    58.3861487
                ],
                [
                    97.4475442,
                    58.3862337
                ],
                [
                    97.4502897,
                    58.3860538
                ],
                [
                    97.4539311,
                    58.3861337
                ],
                [
                    97.4577252,
                    58.3861287
                ],
                [
                    97.4629109,
                    58.3861787
                ],
                [
                    97.4731872,
                    58.3866534
                ],
                [
                    97.4761328,
                    58.3867783
                ],
                [
                    97.4808419,
                    58.3869432
                ],
                [
                    97.4826436,
                    58.3869882
                ],
                [
                    97.4867421,
                    58.387083
                ],
                [
                    97.488043,
                    58.3871007
                ],
                [
                    97.4884576,
                    58.3871661
                ],
                [
                    97.4891047,
                    58.3871431
                ],
                [
                    97.4895866,
                    58.3872102
                ],
                [
                    97.4900383,
                    58.3871961
                ],
                [
                    97.4903146,
                    58.3872509
                ],
                [
                    97.4906517,
                    58.3872491
                ],
                [
                    97.4909988,
                    58.3873109
                ],
                [
                    97.4911336,
                    58.3873551
                ],
                [
                    97.4912482,
                    58.3873622
                ],
                [
                    97.4913426,
                    58.3872933
                ],
                [
                    97.4915279,
                    58.3872986
                ],
                [
                    97.4916055,
                    58.387341
                ],
                [
                    97.4917066,
                    58.3873392
                ],
                [
                    97.491838,
                    58.3873427
                ],
                [
                    97.4919053,
                    58.3874099
                ],
                [
                    97.4919897,
                    58.3874134
                ],
                [
                    97.4920503,
                    58.3873639
                ],
                [
                    97.4927311,
                    58.3874417
                ],
                [
                    97.49293,
                    58.3874134
                ],
                [
                    97.4931052,
                    58.3873533
                ],
                [
                    97.4933041,
                    58.3874152
                ],
                [
                    97.4935164,
                    58.3874046
                ],
                [
                    97.4937355,
                    58.3873533
                ],
                [
                    97.4941298,
                    58.3872933
                ],
                [
                    97.4946791,
                    58.3873127
                ],
                [
                    97.4947702,
                    58.3873957
                ],
                [
                    97.4948881,
                    58.387424
                ],
                [
                    97.4951746,
                    58.3873834
                ],
                [
                    97.4953364,
                    58.3873869
                ],
                [
                    97.4956532,
                    58.387454
                ],
                [
                    97.4959902,
                    58.387447
                ],
                [
                    97.4960442,
                    58.3873834
                ],
                [
                    97.4962464,
                    58.3873198
                ],
                [
                    97.4968193,
                    58.387394
                ],
                [
                    97.4971159,
                    58.3873622
                ],
                [
                    97.4973249,
                    58.387401
                ],
                [
                    97.4979113,
                    58.3873657
                ],
                [
                    97.498491,
                    58.387394
                ],
                [
                    97.4991112,
                    58.3873445
                ],
                [
                    97.4998188,
                    58.3873127
                ],
                [
                    97.5000885,
                    58.3873728
                ],
                [
                    97.5005132,
                    58.3873657
                ],
                [
                    97.5007423,
                    58.3873162
                ],
                [
                    97.5011064,
                    58.3873586
                ],
                [
                    97.5023736,
                    58.3873021
                ],
                [
                    97.5041397,
                    58.3871572
                ],
                [
                    97.5051103,
                    58.3871431
                ],
                [
                    97.5069842,
                    58.3870124
                ],
                [
                    97.5074223,
                    58.3870336
                ],
                [
                    97.5081436,
                    58.3869417
                ],
                [
                    97.5096333,
                    58.3868993
                ],
                [
                    97.5116487,
                    58.386864
                ],
                [
                    97.5126733,
                    58.3866908
                ],
                [
                    97.5142034,
                    58.3866237
                ],
                [
                    97.5178636,
                    58.3864188
                ],
                [
                    97.5183287,
                    58.3864329
                ],
                [
                    97.5188342,
                    58.3863446
                ],
                [
                    97.5197577,
                    58.3862916
                ],
                [
                    97.520634,
                    58.3862845
                ],
                [
                    97.5212743,
                    58.3863516
                ],
                [
                    97.5217866,
                    58.3862739
                ],
                [
                    97.5225888,
                    58.3862668
                ],
                [
                    97.5231954,
                    58.3862845
                ],
                [
                    97.5246649,
                    58.3865212
                ],
                [
                    97.5252378,
                    58.3855672
                ],
                [
                    97.5348028,
                    58.3864329
                ],
                [
                    97.5350724,
                    58.3855637
                ],
                [
                    97.5201891,
                    58.3828004
                ],
                [
                    97.5202295,
                    58.3827086
                ],
                [
                    97.5191713,
                    58.3826132
                ],
                [
                    97.5170412,
                    58.3822103
                ],
                [
                    97.5039363,
                    58.3794397
                ],
                [
                    97.5032285,
                    58.3790298
                ],
                [
                    97.503451,
                    58.3789944
                ],
                [
                    97.5030196,
                    58.3780367
                ],
                [
                    97.5022916,
                    58.3781356
                ],
                [
                    97.5015029,
                    58.3787117
                ],
                [
                    97.4980449,
                    58.3762078
                ],
                [
                    97.4964243,
                    58.3761728
                ],
                [
                    97.4969486,
                    58.3786744
                ],
                [
                    97.4942652,
                    58.378272
                ],
                [
                    97.4940544,
                    58.378095
                ],
                [
                    97.4930868,
                    58.3779451
                ],
                [
                    97.4927341,
                    58.3778176
                ],
                [
                    97.4919333,
                    58.3773578
                ],
                [
                    97.4912851,
                    58.3768005
                ],
                [
                    97.4910373,
                    58.376698
                ],
                [
                    97.4908275,
                    58.3765781
                ],
                [
                    97.4904033,
                    58.3761457
                ],
                [
                    97.4890259,
                    58.3756578
                ],
                [
                    97.4884396,
                    58.3755604
                ],
                [
                    97.4881012,
                    58.3754004
                ],
                [
                    97.487534,
                    58.3753979
                ],
                [
                    97.4874816,
                    58.3752405
                ],
                [
                    97.4870812,
                    58.375293
                ],
                [
                    97.4866951,
                    58.3752955
                ],
                [
                    97.4867523,
                    58.3757828
                ],
                [
                    97.4863519,
                    58.3760127
                ],
                [
                    97.4860707,
                    58.3763826
                ],
                [
                    97.4857493,
                    58.3770343
                ],
                [
                    97.4849866,
                    58.3769518
                ],
                [
                    97.4841573,
                    58.3768219
                ],
                [
                    97.4833327,
                    58.3767444
                ],
                [
                    97.481879,
                    58.3764795
                ],
                [
                    97.4811879,
                    58.376397
                ],
                [
                    97.4800249,
                    58.3763945
                ],
                [
                    97.4790764,
                    58.3763121
                ],
                [
                    97.4778657,
                    58.3762946
                ],
                [
                    97.4769363,
                    58.3763221
                ],
                [
                    97.4763928,
                    58.3763895
                ],
                [
                    97.4759687,
                    58.376537
                ],
                [
                    97.4756303,
                    58.3765445
                ],
                [
                    97.474739,
                    58.3764945
                ],
                [
                    97.4741909,
                    58.3765495
                ],
                [
                    97.4724369,
                    58.3763171
                ],
                [
                    97.4712453,
                    58.376352
                ],
                [
                    97.4707257,
                    58.3763495
                ],
                [
                    97.4706018,
                    58.3763071
                ],
                [
                    97.4705399,
                    58.3756148
                ],
                [
                    97.4702539,
                    58.3753224
                ],
                [
                    97.4702062,
                    58.3744976
                ],
                [
                    97.4690193,
                    58.3740427
                ],
                [
                    97.4683426,
                    58.3739827
                ],
                [
                    97.4676229,
                    58.3738453
                ],
                [
                    97.466741,
                    58.3737353
                ],
                [
                    97.4647631,
                    58.3736178
                ],
                [
                    97.4640718,
                    58.3736328
                ],
                [
                    97.4638336,
                    58.3735729
                ],
                [
                    97.463538,
                    58.3733779
                ],
                [
                    97.4629518,
                    58.373083
                ],
                [
                    97.4625896,
                    58.373028
                ],
                [
                    97.4624752,
                    58.3730255
                ],
                [
                    97.4619223,
                    58.3732029
                ],
                [
                    97.4611788,
                    58.3733129
                ],
                [
                    97.4601159,
                    58.3733754
                ],
                [
                    97.4578042,
                    58.3734454
                ],
                [
                    97.4568128,
                    58.3734429
                ],
                [
                    97.4560692,
                    58.3734754
                ],
                [
                    97.4544182,
                    58.3736603
                ],
                [
                    97.4514253,
                    58.3736603
                ],
                [
                    97.4498278,
                    58.3737628
                ],
                [
                    97.4468854,
                    58.3738406
                ],
                [
                    97.4441825,
                    58.3737664
                ],
                [
                    97.4423894,
                    58.373676
                ],
                [
                    97.4383028,
                    58.3741789
                ],
                [
                    97.4355208,
                    58.3755372
                ],
                [
                    97.43291,
                    58.3732129
                ],
                [
                    97.4326467,
                    58.3730991
                ],
                [
                    97.4318841,
                    58.3733188
                ],
                [
                    97.4287578,
                    58.3713994
                ],
                [
                    97.4279442,
                    58.3708903
                ],
                [
                    97.4275566,
                    58.3705916
                ],
                [
                    97.4272442,
                    58.3703006
                ],
                [
                    97.4250309,
                    58.3677847
                ],
                [
                    97.4247824,
                    58.3674034
                ],
                [
                    97.4243388,
                    58.365999
                ],
                [
                    97.4234382,
                    58.3660793
                ],
                [
                    97.4228423,
                    58.3662268
                ],
                [
                    97.4226565,
                    58.3665218
                ],
                [
                    97.4225469,
                    58.3668793
                ],
                [
                    97.4207595,
                    58.3670467
                ],
                [
                    97.4192247,
                    58.3672142
                ],
                [
                    97.4155737,
                    58.3676117
                ],
                [
                    97.4140532,
                    58.3677342
                ],
                [
                    97.4129808,
                    58.3678592
                ],
                [
                    97.4121086,
                    58.3675067
                ],
                [
                    97.4115843,
                    58.3673067
                ],
                [
                    97.4111458,
                    58.3672667
                ],
                [
                    97.4099494,
                    58.3672667
                ],
                [
                    97.4095252,
                    58.3672242
                ],
                [
                    97.4062174,
                    58.3666268
                ],
                [
                    97.4057455,
                    58.3665068
                ],
                [
                    97.4046588,
                    58.3663393
                ],
                [
                    97.4037627,
                    58.3661368
                ],
                [
                    97.4035482,
                    58.3660993
                ],
                [
                    97.4032479,
                    58.3661068
                ],
                [
                    97.4019753,
                    58.3659143
                ],
                [
                    97.4017513,
                    58.3658618
                ],
                [
                    97.4015177,
                    58.3658618
                ],
                [
                    97.3993443,
                    58.3655443
                ],
                [
                    97.3988009,
                    58.3654293
                ],
                [
                    97.3985531,
                    58.3653393
                ],
                [
                    97.3980717,
                    58.3651793
                ],
                [
                    97.3976284,
                    58.3651193
                ],
                [
                    97.3973472,
                    58.3650793
                ],
                [
                    97.3969802,
                    58.3651018
                ],
                [
                    97.3967419,
                    58.3650943
                ],
                [
                    97.3962652,
                    58.3650118
                ],
                [
                    97.3941919,
                    58.3646143
                ],
                [
                    97.3934436,
                    58.3645293
                ],
                [
                    97.3928239,
                    58.3644118
                ],
                [
                    97.3921995,
                    58.3642343
                ],
                [
                    97.3908793,
                    58.3640668
                ],
                [
                    97.3901548,
                    58.3639018
                ],
                [
                    97.3902263,
                    58.3642743
                ],
                [
                    97.3902453,
                    58.3648618
                ],
                [
                    97.3900118,
                    58.3652268
                ],
                [
                    97.3896829,
                    58.3655643
                ],
                [
                    97.3884245,
                    58.3661268
                ],
                [
                    97.3876259,
                    58.3663898
                ],
                [
                    97.3870125,
                    58.366464
                ],
                [
                    97.3862642,
                    58.3665171
                ],
                [
                    97.3851116,
                    58.3664605
                ],
                [
                    97.382139,
                    58.3652337
                ],
                [
                    97.3759781,
                    58.3648377
                ],
                [
                    97.3740907,
                    58.366411
                ],
                [
                    97.3755669,
                    58.3675246
                ],
                [
                    97.3758635,
                    58.3678958
                ],
                [
                    97.3765173,
                    58.3686205
                ],
                [
                    97.3767355,
                    58.3687745
                ],
                [
                    97.376551,
                    58.3689242
                ],
                [
                    97.3763531,
                    58.3690605
                ],
                [
                    97.3762808,
                    58.3692311
                ],
                [
                    97.3763668,
                    58.3694156
                ],
                [
                    97.3714715,
                    58.3696948
                ],
                [
                    97.3714326,
                    58.3710998
                ],
                [
                    97.3718823,
                    58.3724031
                ],
                [
                    97.3733265,
                    58.3724181
                ],
                [
                    97.3728828,
                    58.3732762
                ],
                [
                    97.3721615,
                    58.3735025
                ],
                [
                    97.3702349,
                    58.373833
                ],
                [
                    97.3698584,
                    58.3745253
                ],
                [
                    97.3693913,
                    58.3746728
                ],
                [
                    97.3677088,
                    58.3748377
                ],
                [
                    97.3674513,
                    58.3763998
                ],
                [
                    97.375294,
                    58.3768261
                ],
                [
                    97.3752654,
                    58.3768811
                ],
                [
                    97.3752463,
                    58.3769335
                ],
                [
                    97.3751558,
                    58.376981
                ],
                [
                    97.3749603,
                    58.3770385
                ],
                [
                    97.3746124,
                    58.377146
                ],
                [
                    97.3739928,
                    58.3773709
                ],
                [
                    97.3735924,
                    58.3776333
                ],
                [
                    97.3734971,
                    58.3778107
                ],
                [
                    97.3735686,
                    58.378318
                ],
                [
                    97.3739308,
                    58.3788278
                ],
                [
                    97.3740881,
                    58.3793151
                ],
                [
                    97.3739213,
                    58.379615
                ],
                [
                    97.3735972,
                    58.3797849
                ],
                [
                    97.3723484,
                    58.3802497
                ],
                [
                    97.3714904,
                    58.3803447
                ],
                [
                    97.3710043,
                    58.3805546
                ],
                [
                    97.3700032,
                    58.3824537
                ],
                [
                    97.3693551,
                    58.3828335
                ],
                [
                    97.3687164,
                    58.3830684
                ],
                [
                    97.3670196,
                    58.383848
                ],
                [
                    97.3661903,
                    58.3849024
                ],
                [
                    97.3654849,
                    58.3851772
                ],
                [
                    97.362463,
                    58.3879955
                ],
                [
                    97.3619864,
                    58.3889298
                ],
                [
                    97.3592886,
                    58.3896643
                ],
                [
                    97.358768,
                    58.3900569
                ],
                [
                    97.3581816,
                    58.3908907
                ],
                [
                    97.3568065,
                    58.3915054
                ],
                [
                    97.3533216,
                    58.3928444
                ],
                [
                    97.352452,
                    58.3932542
                ],
                [
                    97.350504,
                    58.3937381
                ],
                [
                    97.3496277,
                    58.3943245
                ]
            ],
            "longitude": 97.461578,
            "latitude": 58.382816
        },
        "5769": {
            "name": "КОДИНСК",
            "population": 16075,
            "type": "town",
            "poly": [
                [
                    99.1626845,
                    58.5771259
                ],
                [
                    99.1629677,
                    58.5800928
                ],
                [
                    99.1645822,
                    58.5801229
                ],
                [
                    99.1646787,
                    58.5817231
                ],
                [
                    99.164847,
                    58.5843893
                ],
                [
                    99.165594,
                    58.5879812
                ],
                [
                    99.1655959,
                    58.5880456
                ],
                [
                    99.1656855,
                    58.5909923
                ],
                [
                    99.1662714,
                    58.5909637
                ],
                [
                    99.1667568,
                    58.5910496
                ],
                [
                    99.1675626,
                    58.5910639
                ],
                [
                    99.1683318,
                    58.5911546
                ],
                [
                    99.1691009,
                    58.5913264
                ],
                [
                    99.1699342,
                    58.5915507
                ],
                [
                    99.1711428,
                    58.5916938
                ],
                [
                    99.171335,
                    58.5916938
                ],
                [
                    99.1715365,
                    58.5916365
                ],
                [
                    99.1731846,
                    58.5920755
                ],
                [
                    99.172031,
                    58.5933305
                ],
                [
                    99.1706209,
                    58.5945997
                ],
                [
                    99.1682584,
                    58.5946569
                ],
                [
                    99.1669583,
                    58.5973765
                ],
                [
                    99.1665553,
                    58.5987124
                ],
                [
                    99.165887,
                    58.6025908
                ],
                [
                    99.1639824,
                    58.6028723
                ],
                [
                    99.1638634,
                    58.6031442
                ],
                [
                    99.1639275,
                    58.6037166
                ],
                [
                    99.1642663,
                    58.6040505
                ],
                [
                    99.1643395,
                    58.6043081
                ],
                [
                    99.1646051,
                    58.6045561
                ],
                [
                    99.165301,
                    58.6047803
                ],
                [
                    99.1657771,
                    58.6048042
                ],
                [
                    99.1661434,
                    58.6046801
                ],
                [
                    99.1667019,
                    58.6046134
                ],
                [
                    99.1670041,
                    58.6043796
                ],
                [
                    99.1676267,
                    58.6043844
                ],
                [
                    99.1678098,
                    58.6044464
                ],
                [
                    99.1713534,
                    58.6044703
                ],
                [
                    99.1723881,
                    58.6046086
                ],
                [
                    99.1733404,
                    58.6046992
                ],
                [
                    99.173789,
                    58.6045752
                ],
                [
                    99.174137,
                    58.6045657
                ],
                [
                    99.1743293,
                    58.6046706
                ],
                [
                    99.1746131,
                    58.6047946
                ],
                [
                    99.1749061,
                    58.6048137
                ],
                [
                    99.175364,
                    58.6047088
                ],
                [
                    99.1759225,
                    58.6045514
                ],
                [
                    99.1774333,
                    58.6045323
                ],
                [
                    99.1776714,
                    58.6045704
                ],
                [
                    99.1777447,
                    58.6050617
                ],
                [
                    99.1777076,
                    58.6052181
                ],
                [
                    99.1772673,
                    58.6053327
                ],
                [
                    99.1768271,
                    58.6054744
                ],
                [
                    99.1766846,
                    58.6056228
                ],
                [
                    99.1764774,
                    58.6059601
                ],
                [
                    99.1762573,
                    58.6063041
                ],
                [
                    99.1759206,
                    58.6063243
                ],
                [
                    99.1757911,
                    58.6063648
                ],
                [
                    99.1748588,
                    58.6074845
                ],
                [
                    99.1728257,
                    58.6084154
                ],
                [
                    99.171712,
                    58.6090292
                ],
                [
                    99.1706632,
                    58.6093799
                ],
                [
                    99.1696791,
                    58.6103039
                ],
                [
                    99.1692258,
                    58.6104658
                ],
                [
                    99.1683323,
                    58.6106007
                ],
                [
                    99.1687856,
                    58.6114168
                ],
                [
                    99.1689151,
                    58.6129545
                ],
                [
                    99.169174,
                    58.6161781
                ],
                [
                    99.1730199,
                    58.6159218
                ],
                [
                    99.1740171,
                    58.6158072
                ],
                [
                    99.175286,
                    58.6155779
                ],
                [
                    99.1755401,
                    58.6159125
                ],
                [
                    99.1763559,
                    58.6165532
                ],
                [
                    99.1763948,
                    58.6167218
                ],
                [
                    99.1768609,
                    58.6170252
                ],
                [
                    99.1770681,
                    58.6170927
                ],
                [
                    99.1777026,
                    58.6174231
                ],
                [
                    99.178117,
                    58.6177468
                ],
                [
                    99.1781714,
                    58.6180513
                ],
                [
                    99.182429,
                    58.6173152
                ],
                [
                    99.1837888,
                    58.6166071
                ],
                [
                    99.1868399,
                    58.6154751
                ],
                [
                    99.1882757,
                    58.6154742
                ],
                [
                    99.1898291,
                    58.6147022
                ],
                [
                    99.1947957,
                    58.6121561
                ],
                [
                    99.1949571,
                    58.6115447
                ],
                [
                    99.2025852,
                    58.6068866
                ],
                [
                    99.2058069,
                    58.6068006
                ],
                [
                    99.2059823,
                    58.606796
                ],
                [
                    99.2066233,
                    58.6066576
                ],
                [
                    99.20807,
                    58.6065002
                ],
                [
                    99.2094709,
                    58.6062713
                ],
                [
                    99.2102218,
                    58.6062713
                ],
                [
                    99.2104782,
                    58.6063333
                ],
                [
                    99.2109273,
                    58.6075838
                ],
                [
                    99.217662,
                    58.6068251
                ],
                [
                    99.2223736,
                    58.6066126
                ],
                [
                    99.230224,
                    58.6094153
                ],
                [
                    99.2357912,
                    58.6090719
                ],
                [
                    99.238355,
                    58.6080035
                ],
                [
                    99.2376774,
                    58.6068111
                ],
                [
                    99.2367067,
                    58.606315
                ],
                [
                    99.2338866,
                    58.6064677
                ],
                [
                    99.2268543,
                    58.6037488
                ],
                [
                    99.2266163,
                    58.6032623
                ],
                [
                    99.229052,
                    58.6030237
                ],
                [
                    99.2293999,
                    58.6035866
                ],
                [
                    99.2316608,
                    58.6037347
                ],
                [
                    99.2379141,
                    58.6025877
                ],
                [
                    99.2357521,
                    58.596341
                ],
                [
                    99.234371,
                    58.5966367
                ],
                [
                    99.2287879,
                    58.595665
                ],
                [
                    99.2265322,
                    58.5961526
                ],
                [
                    99.2120556,
                    58.5966245
                ],
                [
                    99.2081709,
                    58.5972588
                ],
                [
                    99.2044544,
                    58.5998226
                ],
                [
                    99.2016703,
                    58.5997214
                ],
                [
                    99.200725,
                    58.5995123
                ],
                [
                    99.20022,
                    58.5989051
                ],
                [
                    99.1990028,
                    58.5986487
                ],
                [
                    99.1952865,
                    58.5975123
                ],
                [
                    99.1939405,
                    58.5972213
                ],
                [
                    99.1911305,
                    58.5968041
                ],
                [
                    99.1910929,
                    58.5947307
                ],
                [
                    99.1916056,
                    58.5943228
                ],
                [
                    99.1919719,
                    58.5941057
                ],
                [
                    99.1922466,
                    58.5940627
                ],
                [
                    99.1924526,
                    58.5940007
                ],
                [
                    99.1925671,
                    58.5938838
                ],
                [
                    99.1928143,
                    58.5938122
                ],
                [
                    99.1930478,
                    58.5937693
                ],
                [
                    99.1934232,
                    58.5937526
                ],
                [
                    99.1938032,
                    58.5937168
                ],
                [
                    99.1941191,
                    58.59365
                ],
                [
                    99.1946868,
                    58.5932182
                ],
                [
                    99.195195,
                    58.5929175
                ],
                [
                    99.1957063,
                    58.5927664
                ],
                [
                    99.203082,
                    58.5927261
                ],
                [
                    99.2050493,
                    58.5917987
                ],
                [
                    99.2053406,
                    58.5913803
                ],
                [
                    99.2040998,
                    58.5883547
                ],
                [
                    99.2058171,
                    58.5881134
                ],
                [
                    99.2067004,
                    58.5881556
                ],
                [
                    99.2072773,
                    58.5882582
                ],
                [
                    99.2077122,
                    58.5882701
                ],
                [
                    99.208344,
                    58.5882725
                ],
                [
                    99.2105705,
                    58.5884641
                ],
                [
                    99.2109399,
                    58.5884562
                ],
                [
                    99.2113977,
                    58.5883871
                ],
                [
                    99.2119059,
                    58.5881842
                ],
                [
                    99.2121028,
                    58.58801
                ],
                [
                    99.2124187,
                    58.5878287
                ],
                [
                    99.2132428,
                    58.5874803
                ],
                [
                    99.2138517,
                    58.5870627
                ],
                [
                    99.2141447,
                    58.586805
                ],
                [
                    99.2145017,
                    58.5863707
                ],
                [
                    99.2146666,
                    58.5860056
                ],
                [
                    99.2149825,
                    58.5856787
                ],
                [
                    99.2163056,
                    58.5849986
                ],
                [
                    99.2173007,
                    58.5842991
                ],
                [
                    99.2247283,
                    58.5795729
                ],
                [
                    99.2091225,
                    58.5733969
                ],
                [
                    99.2074965,
                    58.5742177
                ],
                [
                    99.2068102,
                    58.5746161
                ],
                [
                    99.2064929,
                    58.5751224
                ],
                [
                    99.2064179,
                    58.5753065
                ],
                [
                    99.2062301,
                    58.5752993
                ],
                [
                    99.2060562,
                    58.5753065
                ],
                [
                    99.2057495,
                    58.5754354
                ],
                [
                    99.2052642,
                    58.5756955
                ],
                [
                    99.2049895,
                    58.5760798
                ],
                [
                    99.2044035,
                    58.5765047
                ],
                [
                    99.2041869,
                    58.5768063
                ],
                [
                    99.2028515,
                    58.5784786
                ],
                [
                    99.20113,
                    58.5794023
                ],
                [
                    99.2007317,
                    58.579746
                ],
                [
                    99.1990927,
                    58.5820157
                ],
                [
                    99.1984701,
                    58.5824476
                ],
                [
                    99.1983075,
                    58.5826479
                ],
                [
                    99.1983449,
                    58.5818459
                ],
                [
                    99.1980099,
                    58.5775977
                ],
                [
                    99.1920342,
                    58.5774793
                ],
                [
                    99.1849212,
                    58.5772999
                ],
                [
                    99.1780632,
                    58.5771685
                ],
                [
                    99.1700266,
                    58.5771192
                ],
                [
                    99.1626845,
                    58.5771259
                ]
            ],
            "longitude": 99.182915,
            "latitude": 58.596329
        },
        "5770": {
            "name": "ТУРА",
            "population": 5562,
            "type": "town",
            "poly": null,
            "longitude": 100.2169635,
            "latitude": 64.2741955
        },
        "5771": {
            "name": "ВАНАВАРА",
            "population": 2943,
            "type": "town",
            "poly": null,
            "longitude": 102.28093,
            "latitude": 60.345203
        },
        "5772": {
            "name": "ХАТАНГА",
            "population": 2645,
            "type": "town",
            "poly": null,
            "longitude": 102.474266,
            "latitude": 71.980072
        },
        "5773": {
            "name": "МУГУР-АКСЫ",
            "population": 4270,
            "type": "town",
            "poly": null,
            "longitude": 90.441721,
            "latitude": 50.3800035
        },
        "5774": {
            "name": "КЫЗЫЛ-МАЖАЛЫК",
            "population": 5070,
            "type": "town",
            "poly": null,
            "longitude": 90.5814803,
            "latitude": 51.1454611
        },
        "5775": {
            "name": "АК-ДОВУРАК",
            "population": 13700,
            "type": "town",
            "poly": null,
            "longitude": 90.5999914,
            "latitude": 51.174081
        },
        "5776": {
            "name": "ЧАДАН",
            "population": 8912,
            "type": "town",
            "poly": [
                [
                    91.551305,
                    51.2977588
                ],
                [
                    91.5525066,
                    51.3008715
                ],
                [
                    91.5638363,
                    51.2987249
                ],
                [
                    91.5743076,
                    51.2941093
                ],
                [
                    91.5830624,
                    51.2979735
                ],
                [
                    91.5931904,
                    51.2929285
                ],
                [
                    91.6021168,
                    51.2813336
                ],
                [
                    91.594392,
                    51.279723
                ],
                [
                    91.5868389,
                    51.2754277
                ],
                [
                    91.5779125,
                    51.2753203
                ],
                [
                    91.572076,
                    51.2765015
                ],
                [
                    91.5633213,
                    51.2815484
                ],
                [
                    91.5538799,
                    51.2886344
                ],
                [
                    91.5598881,
                    51.2932505
                ],
                [
                    91.551305,
                    51.2977588
                ]
            ],
            "longitude": 91.582817,
            "latitude": 51.286018
        },
        "5777": {
            "name": "ШАГОНАР",
            "population": 10935,
            "type": "town",
            "poly": null,
            "longitude": 92.9194074,
            "latitude": 51.538721
        },
        "5778": {
            "name": "ХОВУ-АКСЫ",
            "population": 3713,
            "type": "town",
            "poly": null,
            "longitude": 93.715744,
            "latitude": 51.131943
        },
        "5779": {
            "name": "ТУРАН",
            "population": 4874,
            "type": "town",
            "poly": null,
            "longitude": 93.9186434,
            "latitude": 52.1458093
        },
        "5780": {
            "name": "КАА-ХЕМ",
            "population": 16628,
            "type": "town",
            "poly": null,
            "longitude": 94.563721,
            "latitude": 51.696541
        },
        "5781": {
            "name": "САРЫГ-СЕП",
            "population": 4418,
            "type": "town",
            "poly": [
                [
                    95.5223044,
                    51.5085095
                ],
                [
                    95.5241883,
                    51.5093972
                ],
                [
                    95.5291268,
                    51.5058796
                ],
                [
                    95.5316919,
                    51.5049057
                ],
                [
                    95.5355766,
                    51.5052502
                ],
                [
                    95.5361089,
                    51.5053496
                ],
                [
                    95.5365985,
                    51.5055417
                ],
                [
                    95.5389614,
                    51.5062373
                ],
                [
                    95.5491578,
                    51.5016395
                ],
                [
                    95.5537344,
                    51.5044751
                ],
                [
                    95.5585878,
                    51.502673
                ],
                [
                    95.5547988,
                    51.4980748
                ],
                [
                    95.5594392,
                    51.4949074
                ],
                [
                    95.5616957,
                    51.4958485
                ],
                [
                    95.5662085,
                    51.4922635
                ],
                [
                    95.5746325,
                    51.4878987
                ],
                [
                    95.572142,
                    51.4860032
                ],
                [
                    95.5715034,
                    51.4853802
                ],
                [
                    95.5874898,
                    51.4790303
                ],
                [
                    95.584735,
                    51.4777277
                ],
                [
                    95.5831395,
                    51.4762746
                ],
                [
                    95.5819955,
                    51.4746621
                ],
                [
                    95.5813784,
                    51.4729651
                ],
                [
                    95.5698184,
                    51.4778777
                ],
                [
                    95.5669585,
                    51.4782433
                ],
                [
                    95.5657393,
                    51.4787121
                ],
                [
                    95.5647007,
                    51.4794433
                ],
                [
                    95.5642792,
                    51.4800807
                ],
                [
                    95.5618408,
                    51.4810463
                ],
                [
                    95.5608925,
                    51.4812994
                ],
                [
                    95.5600646,
                    51.4819555
                ],
                [
                    95.5591916,
                    51.4824055
                ],
                [
                    95.5586648,
                    51.4830804
                ],
                [
                    95.5585745,
                    51.4840927
                ],
                [
                    95.5561059,
                    51.4854237
                ],
                [
                    95.5547964,
                    51.4863142
                ],
                [
                    95.5534116,
                    51.4868953
                ],
                [
                    95.5521773,
                    51.4878981
                ],
                [
                    95.5511387,
                    51.4884324
                ],
                [
                    95.549468,
                    51.4895477
                ],
                [
                    95.5472101,
                    51.4908973
                ],
                [
                    95.5451932,
                    51.4922562
                ],
                [
                    95.5441094,
                    51.4929216
                ],
                [
                    95.5428902,
                    51.4936057
                ],
                [
                    95.5420322,
                    51.4941492
                ],
                [
                    95.5413699,
                    51.4946553
                ],
                [
                    95.5404968,
                    51.4955361
                ],
                [
                    95.537336,
                    51.4985161
                ],
                [
                    95.5359361,
                    51.4995281
                ],
                [
                    95.5332569,
                    51.5009055
                ],
                [
                    95.5223044,
                    51.5085095
                ]
            ],
            "longitude": 95.554681,
            "latitude": 51.492626
        },
        "5782": {
            "name": "ЮРГА",
            "population": 81396,
            "type": "town",
            "poly": [
                [
                    84.7995507,
                    55.7316023
                ],
                [
                    84.8051983,
                    55.7420255
                ],
                [
                    84.8299762,
                    55.7510608
                ],
                [
                    84.8434376,
                    55.7392524
                ],
                [
                    84.8453497,
                    55.7397547
                ],
                [
                    84.8480903,
                    55.7402211
                ],
                [
                    84.8545532,
                    55.7410887
                ],
                [
                    84.8577553,
                    55.7406065
                ],
                [
                    84.8595297,
                    55.7410313
                ],
                [
                    84.860835,
                    55.7408935
                ],
                [
                    84.8615284,
                    55.7412954
                ],
                [
                    84.8662602,
                    55.7420302
                ],
                [
                    84.8713999,
                    55.7434882
                ],
                [
                    84.8755431,
                    55.7469808
                ],
                [
                    84.8762136,
                    55.7471995
                ],
                [
                    84.8769784,
                    55.7481143
                ],
                [
                    84.8815674,
                    55.7497285
                ],
                [
                    84.8855152,
                    55.7505241
                ],
                [
                    84.8868613,
                    55.7512473
                ],
                [
                    84.8906957,
                    55.7524869
                ],
                [
                    84.8927964,
                    55.7534052
                ],
                [
                    84.8982103,
                    55.7538212
                ],
                [
                    84.9026352,
                    55.7553624
                ],
                [
                    84.9048869,
                    55.7553991
                ],
                [
                    84.9061922,
                    55.7560418
                ],
                [
                    84.9064571,
                    55.7566295
                ],
                [
                    84.9064605,
                    55.7566371
                ],
                [
                    84.9229826,
                    55.7621667
                ],
                [
                    84.930791,
                    55.7544841
                ],
                [
                    84.9365499,
                    55.7482144
                ],
                [
                    84.9489095,
                    55.7350723
                ],
                [
                    84.9616125,
                    55.7255996
                ],
                [
                    84.9731138,
                    55.7177684
                ],
                [
                    84.9779203,
                    55.7123532
                ],
                [
                    84.9844434,
                    55.7076144
                ],
                [
                    84.993368,
                    55.704148
                ],
                [
                    84.9909628,
                    55.7011497
                ],
                [
                    84.9908863,
                    55.6994401
                ],
                [
                    84.9922222,
                    55.6989414
                ],
                [
                    84.9912432,
                    55.6961499
                ],
                [
                    84.9817848,
                    55.6939659
                ],
                [
                    84.9816573,
                    55.6935204
                ],
                [
                    84.9791078,
                    55.6921697
                ],
                [
                    84.9821092,
                    55.689345
                ],
                [
                    84.9732441,
                    55.6834607
                ],
                [
                    84.9632503,
                    55.6880023
                ],
                [
                    84.9604969,
                    55.6877292
                ],
                [
                    84.946577,
                    55.6778693
                ],
                [
                    84.9456337,
                    55.6785305
                ],
                [
                    84.9449963,
                    55.6797811
                ],
                [
                    84.9504011,
                    55.6841362
                ],
                [
                    84.9504521,
                    55.6860765
                ],
                [
                    84.951064,
                    55.6868526
                ],
                [
                    84.9537409,
                    55.6878873
                ],
                [
                    84.9546587,
                    55.6947705
                ],
                [
                    84.9540978,
                    55.6953022
                ],
                [
                    84.95318,
                    55.6950866
                ],
                [
                    84.9477752,
                    55.6968396
                ],
                [
                    84.9501207,
                    55.6941814
                ],
                [
                    84.9493049,
                    55.6939802
                ],
                [
                    84.9495598,
                    55.6934486
                ],
                [
                    84.948846,
                    55.6932618
                ],
                [
                    84.9496363,
                    55.6922272
                ],
                [
                    84.9472908,
                    55.6915518
                ],
                [
                    84.9474948,
                    55.6909914
                ],
                [
                    84.9450218,
                    55.6903878
                ],
                [
                    84.9409427,
                    55.6946843
                ],
                [
                    84.9431097,
                    55.6958338
                ],
                [
                    84.9428803,
                    55.6963223
                ],
                [
                    84.9453022,
                    55.6970263
                ],
                [
                    84.9443844,
                    55.6978884
                ],
                [
                    84.939362,
                    55.6969689
                ],
                [
                    84.9359458,
                    55.6950148
                ],
                [
                    84.9383168,
                    55.6930031
                ],
                [
                    84.9382658,
                    55.6906752
                ],
                [
                    84.9371185,
                    55.6903878
                ],
                [
                    84.9356144,
                    55.690474
                ],
                [
                    84.9291133,
                    55.6883184
                ],
                [
                    84.9125847,
                    55.6962298
                ],
                [
                    84.9075266,
                    55.6956137
                ],
                [
                    84.9046549,
                    55.6957884
                ],
                [
                    84.8956952,
                    55.693317
                ],
                [
                    84.8899008,
                    55.69218
                ],
                [
                    84.8867191,
                    55.6910489
                ],
                [
                    84.9066466,
                    55.6791378
                ],
                [
                    84.9101139,
                    55.6785915
                ],
                [
                    84.9144224,
                    55.676119
                ],
                [
                    84.9018792,
                    55.6744371
                ],
                [
                    84.8878286,
                    55.6800419
                ],
                [
                    84.8796091,
                    55.6777535
                ],
                [
                    84.8616377,
                    55.6843107
                ],
                [
                    84.8657933,
                    55.6876019
                ],
                [
                    84.8588333,
                    55.6892977
                ],
                [
                    84.8694645,
                    55.6974738
                ],
                [
                    84.8796623,
                    55.6937524
                ],
                [
                    84.8928939,
                    55.7029475
                ],
                [
                    84.8836387,
                    55.7059598
                ],
                [
                    84.8815992,
                    55.7072813
                ],
                [
                    84.8771632,
                    55.7084017
                ],
                [
                    84.8657671,
                    55.7084304
                ],
                [
                    84.8521531,
                    55.7055863
                ],
                [
                    84.8522296,
                    55.7079852
                ],
                [
                    84.8499861,
                    55.7080283
                ],
                [
                    84.8407316,
                    55.7041642
                ],
                [
                    84.8386921,
                    55.7046095
                ],
                [
                    84.8361171,
                    55.7029575
                ],
                [
                    84.833503,
                    55.7038626
                ],
                [
                    84.8327166,
                    55.7038705
                ],
                [
                    84.832366,
                    55.7037407
                ],
                [
                    84.8315828,
                    55.7041967
                ],
                [
                    84.8317394,
                    55.7044027
                ],
                [
                    84.8312434,
                    55.7046601
                ],
                [
                    84.8293507,
                    55.7043218
                ],
                [
                    84.8274449,
                    55.707168
                ],
                [
                    84.827535,
                    55.7075074
                ],
                [
                    84.823418,
                    55.7101937
                ],
                [
                    84.8233919,
                    55.709826
                ],
                [
                    84.8227262,
                    55.7097966
                ],
                [
                    84.8226479,
                    55.7101937
                ],
                [
                    84.8228959,
                    55.7104291
                ],
                [
                    84.8218777,
                    55.7104217
                ],
                [
                    84.8152128,
                    55.7167754
                ],
                [
                    84.8080744,
                    55.7183033
                ],
                [
                    84.8056688,
                    55.7258128
                ],
                [
                    84.7995507,
                    55.7316023
                ]
            ],
            "longitude": 84.934799,
            "latitude": 55.7136
        },
        "5783": {
            "name": "ЯШКИНО",
            "population": 14040,
            "type": "town",
            "poly": null,
            "longitude": 85.427689,
            "latitude": 55.873089
        },
        "5784": {
            "name": "ТОПКИ",
            "population": 28144,
            "type": "town",
            "poly": [
                [
                    85.5443483,
                    55.2641029
                ],
                [
                    85.5483208,
                    55.2680124
                ],
                [
                    85.5466356,
                    55.2803558
                ],
                [
                    85.5538583,
                    55.2807672
                ],
                [
                    85.5581023,
                    55.2861367
                ],
                [
                    85.5671001,
                    55.2907761
                ],
                [
                    85.577212,
                    55.293792
                ],
                [
                    85.5858793,
                    55.2990007
                ],
                [
                    85.5848266,
                    55.3024491
                ],
                [
                    85.5810948,
                    55.3066974
                ],
                [
                    85.5634592,
                    55.3200048
                ],
                [
                    85.5644216,
                    55.3221918
                ],
                [
                    85.5798001,
                    55.3102896
                ],
                [
                    85.5937642,
                    55.3088851
                ],
                [
                    85.5962921,
                    55.3109919
                ],
                [
                    85.6099552,
                    55.3079773
                ],
                [
                    85.6149516,
                    55.3102431
                ],
                [
                    85.6174795,
                    55.3134802
                ],
                [
                    85.6193447,
                    55.3136637
                ],
                [
                    85.6277714,
                    55.3083884
                ],
                [
                    85.6315934,
                    55.307806
                ],
                [
                    85.6389968,
                    55.3026156
                ],
                [
                    85.6416457,
                    55.3024148
                ],
                [
                    85.6473036,
                    55.303083
                ],
                [
                    85.6541646,
                    55.3053222
                ],
                [
                    85.6576186,
                    55.3081858
                ],
                [
                    85.6720001,
                    55.3026547
                ],
                [
                    85.6754183,
                    55.2998418
                ],
                [
                    85.6778992,
                    55.2946886
                ],
                [
                    85.6804977,
                    55.2932436
                ],
                [
                    85.6820931,
                    55.2927341
                ],
                [
                    85.6836281,
                    55.2924774
                ],
                [
                    85.6877505,
                    55.2925239
                ],
                [
                    85.682635,
                    55.2897699
                ],
                [
                    85.6814005,
                    55.2883084
                ],
                [
                    85.6848319,
                    55.2868051
                ],
                [
                    85.6876001,
                    55.2847436
                ],
                [
                    85.689165,
                    55.276516
                ],
                [
                    85.6907906,
                    55.2726636
                ],
                [
                    85.6943413,
                    55.269727
                ],
                [
                    85.7033698,
                    55.2636227
                ],
                [
                    85.6971101,
                    55.2578606
                ],
                [
                    85.6248823,
                    55.2420789
                ],
                [
                    85.6170576,
                    55.2439318
                ],
                [
                    85.6128443,
                    55.2411867
                ],
                [
                    85.5780546,
                    55.2580664
                ],
                [
                    85.5716745,
                    55.2564885
                ],
                [
                    85.557229,
                    55.257792
                ],
                [
                    85.5516915,
                    55.2571059
                ],
                [
                    85.5443483,
                    55.2641029
                ]
            ],
            "longitude": 85.6228741,
            "latitude": 55.2751962
        },
        "5785": {
            "name": "ТАЙГА",
            "population": 24532,
            "type": "town",
            "poly": [
                [
                    [
                        85.5610535,
                        56.0738915
                    ],
                    [
                        85.5703052,
                        56.0741017
                    ],
                    [
                        85.5716578,
                        56.0974914
                    ],
                    [
                        85.6568536,
                        56.0963745
                    ],
                    [
                        85.6565819,
                        56.0779314
                    ],
                    [
                        85.6780817,
                        56.0775216
                    ],
                    [
                        85.6901503,
                        56.0772862
                    ],
                    [
                        85.689228,
                        56.0387415
                    ],
                    [
                        85.6494338,
                        56.0399137
                    ],
                    [
                        85.6232883,
                        56.0220669
                    ],
                    [
                        85.6146219,
                        56.0299394
                    ],
                    [
                        85.5803588,
                        56.0421077
                    ],
                    [
                        85.5670702,
                        56.0500124
                    ],
                    [
                        85.5680542,
                        56.0565657
                    ],
                    [
                        85.5686334,
                        56.0602299
                    ],
                    [
                        85.5692107,
                        56.0634681
                    ],
                    [
                        85.5695312,
                        56.0665823
                    ],
                    [
                        85.5630356,
                        56.0666272
                    ],
                    [
                        85.5610535,
                        56.0738915
                    ]
                ],
                [
                    [
                        85.4105411,
                        56.1737558
                    ],
                    [
                        85.4244879,
                        56.1805316
                    ],
                    [
                        85.4347129,
                        56.183971
                    ],
                    [
                        85.4374189,
                        56.1844729
                    ],
                    [
                        85.4482571,
                        56.1762486
                    ],
                    [
                        85.4467869,
                        56.1614894
                    ],
                    [
                        85.4223267,
                        56.1617859
                    ],
                    [
                        85.4163631,
                        56.1663179
                    ],
                    [
                        85.4105411,
                        56.1737558
                    ]
                ],
                [
                    [
                        85.4835797,
                        56.1091729
                    ],
                    [
                        85.4842612,
                        56.1098211
                    ],
                    [
                        85.4858046,
                        56.1089829
                    ],
                    [
                        85.487348,
                        56.1074069
                    ],
                    [
                        85.489132,
                        56.1080328
                    ],
                    [
                        85.4898535,
                        56.1085581
                    ],
                    [
                        85.4880897,
                        56.1102682
                    ],
                    [
                        85.4861654,
                        56.1112853
                    ],
                    [
                        85.4870273,
                        56.1120341
                    ],
                    [
                        85.4995139,
                        56.1086058
                    ],
                    [
                        85.5040639,
                        56.1081587
                    ],
                    [
                        85.5049659,
                        56.107924
                    ],
                    [
                        85.5081529,
                        56.1075999
                    ],
                    [
                        85.5123989,
                        56.1068297
                    ],
                    [
                        85.5118777,
                        56.1044935
                    ],
                    [
                        85.5125191,
                        56.1042811
                    ],
                    [
                        85.512459,
                        56.103834
                    ],
                    [
                        85.5117574,
                        56.1035657
                    ],
                    [
                        85.5113766,
                        56.1034316
                    ],
                    [
                        85.5151451,
                        56.1026566
                    ],
                    [
                        85.5148945,
                        56.10193
                    ],
                    [
                        85.5125143,
                        56.1021256
                    ],
                    [
                        85.5098083,
                        56.1029361
                    ],
                    [
                        85.5094325,
                        56.1016086
                    ],
                    [
                        85.5114377,
                        56.1004217
                    ],
                    [
                        85.5136887,
                        56.100176
                    ],
                    [
                        85.5114377,
                        56.0981016
                    ],
                    [
                        85.5085505,
                        56.096846
                    ],
                    [
                        85.5078164,
                        56.0972828
                    ],
                    [
                        85.5040483,
                        56.0958361
                    ],
                    [
                        85.504293,
                        56.0940617
                    ],
                    [
                        85.5069356,
                        56.094635
                    ],
                    [
                        85.5070334,
                        56.089803
                    ],
                    [
                        85.5061526,
                        56.0893662
                    ],
                    [
                        85.5020909,
                        56.0902671
                    ],
                    [
                        85.5031675,
                        56.0913318
                    ],
                    [
                        85.5029228,
                        56.0951809
                    ],
                    [
                        85.4999377,
                        56.0963274
                    ],
                    [
                        85.4942122,
                        56.0939253
                    ],
                    [
                        85.4914718,
                        56.0955904
                    ],
                    [
                        85.4974157,
                        56.099139
                    ],
                    [
                        85.4976963,
                        56.1002123
                    ],
                    [
                        85.4967542,
                        56.1011401
                    ],
                    [
                        85.4865262,
                        56.1061997
                    ],
                    [
                        85.4835797,
                        56.1091729
                    ]
                ],
                [
                    [
                        85.831508,
                        56.0488864
                    ],
                    [
                        85.8316283,
                        56.0498268
                    ],
                    [
                        85.832831,
                        56.050588
                    ],
                    [
                        85.8331717,
                        56.051517
                    ],
                    [
                        85.8325103,
                        56.0519088
                    ],
                    [
                        85.8326105,
                        56.0520543
                    ],
                    [
                        85.8333722,
                        56.0522222
                    ],
                    [
                        85.8339848,
                        56.0528841
                    ],
                    [
                        85.8342694,
                        56.0535773
                    ],
                    [
                        85.8351213,
                        56.0534654
                    ],
                    [
                        85.8371758,
                        56.0539411
                    ],
                    [
                        85.8372009,
                        56.0542489
                    ],
                    [
                        85.8368752,
                        56.0544867
                    ],
                    [
                        85.8369754,
                        56.0550464
                    ],
                    [
                        85.8374411,
                        56.0556808
                    ],
                    [
                        85.8371605,
                        56.0590384
                    ],
                    [
                        85.8375614,
                        56.0592734
                    ],
                    [
                        85.8387039,
                        56.0584788
                    ],
                    [
                        85.8391449,
                        56.0585572
                    ],
                    [
                        85.8397462,
                        56.0581878
                    ],
                    [
                        85.8391449,
                        56.0578185
                    ],
                    [
                        85.8393052,
                        56.0576171
                    ],
                    [
                        85.8444365,
                        56.0585348
                    ],
                    [
                        85.8453586,
                        56.0584341
                    ],
                    [
                        85.8457595,
                        56.0580759
                    ],
                    [
                        85.8457995,
                        56.0575611
                    ],
                    [
                        85.8453987,
                        56.0572813
                    ],
                    [
                        85.8455189,
                        56.057091
                    ],
                    [
                        85.8458998,
                        56.0570687
                    ],
                    [
                        85.8455991,
                        56.0558039
                    ],
                    [
                        85.8461603,
                        56.0548638
                    ],
                    [
                        85.847804,
                        56.0547183
                    ],
                    [
                        85.8491469,
                        56.054237
                    ],
                    [
                        85.8491068,
                        56.0536773
                    ],
                    [
                        85.8502093,
                        56.0537781
                    ],
                    [
                        85.8505099,
                        56.0539124
                    ],
                    [
                        85.8546591,
                        56.0537221
                    ],
                    [
                        85.8549998,
                        56.0534871
                    ],
                    [
                        85.8549597,
                        56.0530729
                    ],
                    [
                        85.8528551,
                        56.0523789
                    ],
                    [
                        85.8538974,
                        56.0502857
                    ],
                    [
                        85.852354,
                        56.0503529
                    ],
                    [
                        85.8525544,
                        56.050073
                    ],
                    [
                        85.8540778,
                        56.0495693
                    ],
                    [
                        85.8540978,
                        56.0489872
                    ],
                    [
                        85.8535967,
                        56.0487521
                    ],
                    [
                        85.850069,
                        56.0502633
                    ],
                    [
                        85.8485656,
                        56.0488417
                    ],
                    [
                        85.8487661,
                        56.0475543
                    ],
                    [
                        85.8484654,
                        56.0473304
                    ],
                    [
                        85.8459399,
                        56.0472744
                    ],
                    [
                        85.8448174,
                        56.0462333
                    ],
                    [
                        85.8433341,
                        56.0460094
                    ],
                    [
                        85.8425524,
                        56.0456063
                    ],
                    [
                        85.8387039,
                        56.0474088
                    ],
                    [
                        85.8353565,
                        56.0484387
                    ],
                    [
                        85.831508,
                        56.0488864
                    ]
                ],
                [
                    [
                        85.7230688,
                        56.0756389
                    ],
                    [
                        85.7247131,
                        56.0765783
                    ],
                    [
                        85.7265139,
                        56.076491
                    ],
                    [
                        85.7303113,
                        56.0742624
                    ],
                    [
                        85.7331301,
                        56.0745027
                    ],
                    [
                        85.7341797,
                        56.073318
                    ],
                    [
                        85.7370767,
                        56.0719633
                    ],
                    [
                        85.738447,
                        56.0698437
                    ],
                    [
                        85.7380555,
                        56.0676366
                    ],
                    [
                        85.7336708,
                        56.0655823
                    ],
                    [
                        85.7310478,
                        56.0652763
                    ],
                    [
                        85.7271403,
                        56.0708755
                    ],
                    [
                        85.727062,
                        56.0715311
                    ],
                    [
                        85.7255743,
                        56.0734321
                    ],
                    [
                        85.7230688,
                        56.0756389
                    ]
                ],
                [
                    [
                        85.6718856,
                        56.1125961
                    ],
                    [
                        85.6720949,
                        56.1164082
                    ],
                    [
                        85.6745368,
                        56.1164082
                    ],
                    [
                        85.6765602,
                        56.1160193
                    ],
                    [
                        85.67663,
                        56.1122849
                    ],
                    [
                        85.6733507,
                        56.1120904
                    ],
                    [
                        85.6718856,
                        56.1125961
                    ]
                ]
            ],
            "longitude": 85.631325,
            "latitude": 56.065071
        },
        "5786": {
            "name": "ПРОМЫШЛЕННАЯ",
            "population": 18069,
            "type": "town",
            "poly": [
                [
                    85.6033535,
                    54.9091978
                ],
                [
                    85.618906,
                    54.9121681
                ],
                [
                    85.6154757,
                    54.9207924
                ],
                [
                    85.620184,
                    54.9245974
                ],
                [
                    85.6215082,
                    54.9288247
                ],
                [
                    85.6290121,
                    54.9310228
                ],
                [
                    85.6347504,
                    54.9333052
                ],
                [
                    85.6347504,
                    54.9382924
                ],
                [
                    85.6322491,
                    54.9472508
                ],
                [
                    85.6375459,
                    54.9517292
                ],
                [
                    85.6456383,
                    54.9513912
                ],
                [
                    85.6527008,
                    54.9462367
                ],
                [
                    85.650788,
                    54.9418422
                ],
                [
                    85.6469625,
                    54.9377852
                ],
                [
                    85.6501995,
                    54.932798
                ],
                [
                    85.6493167,
                    54.9280638
                ],
                [
                    85.6566734,
                    54.9212997
                ],
                [
                    85.6581447,
                    54.9170716
                ],
                [
                    85.6543192,
                    54.9142808
                ],
                [
                    85.6565772,
                    54.9118117
                ],
                [
                    85.6632945,
                    54.9095444
                ],
                [
                    85.6705906,
                    54.9058092
                ],
                [
                    85.6685653,
                    54.9044144
                ],
                [
                    85.6624116,
                    54.9011698
                ],
                [
                    85.6591747,
                    54.8966011
                ],
                [
                    85.648581,
                    54.8937242
                ],
                [
                    85.6410771,
                    54.896178
                ],
                [
                    85.6265621,
                    54.8853093
                ],
                [
                    85.6139407,
                    54.894242
                ],
                [
                    85.6187129,
                    54.897892
                ],
                [
                    85.6033535,
                    54.9091978
                ]
            ],
            "longitude": 85.637863,
            "latitude": 54.918507
        },
        "5787": {
            "name": "САЛАИР",
            "population": 7724,
            "type": "town",
            "poly": [
                [
                    85.7687574,
                    54.2348727
                ],
                [
                    85.7735602,
                    54.2391655
                ],
                [
                    85.7779391,
                    54.2433754
                ],
                [
                    85.7875446,
                    54.2472547
                ],
                [
                    85.8012465,
                    54.2478325
                ],
                [
                    85.8131121,
                    54.241642
                ],
                [
                    85.8196099,
                    54.2338819
                ],
                [
                    85.8203161,
                    54.2253772
                ],
                [
                    85.8269552,
                    54.220257
                ],
                [
                    85.8157959,
                    54.2143102
                ],
                [
                    85.8005176,
                    54.2121465
                ],
                [
                    85.7946216,
                    54.2159092
                ],
                [
                    85.7852845,
                    54.2157144
                ],
                [
                    85.780623,
                    54.2193486
                ],
                [
                    85.7809055,
                    54.2252946
                ],
                [
                    85.7717238,
                    54.2285977
                ],
                [
                    85.7687574,
                    54.2348727
                ]
            ],
            "longitude": 85.798386,
            "latitude": 54.232521
        },
        "5788": {
            "name": "ГУРЬЕВСК",
            "population": 23359,
            "type": "town",
            "poly": [
                [
                    85.9057838,
                    54.2843428
                ],
                [
                    85.9178273,
                    54.2906129
                ],
                [
                    85.9201873,
                    54.2970245
                ],
                [
                    85.9266161,
                    54.2974519
                ],
                [
                    85.9294642,
                    54.2982592
                ],
                [
                    85.9293014,
                    54.302248
                ],
                [
                    85.949971,
                    54.302343
                ],
                [
                    85.9533888,
                    54.299019
                ],
                [
                    85.9568879,
                    54.2991615
                ],
                [
                    85.9573762,
                    54.3029128
                ],
                [
                    85.965351,
                    54.3018681
                ],
                [
                    85.9764182,
                    54.2987341
                ],
                [
                    85.9813008,
                    54.2843903
                ],
                [
                    85.9816263,
                    54.2756486
                ],
                [
                    85.9764996,
                    54.2684258
                ],
                [
                    85.9751044,
                    54.2640134
                ],
                [
                    85.9644258,
                    54.2669142
                ],
                [
                    85.9616941,
                    54.2701048
                ],
                [
                    85.9557339,
                    54.2686546
                ],
                [
                    85.9522571,
                    54.2725701
                ],
                [
                    85.9492771,
                    54.2740202
                ],
                [
                    85.9326382,
                    54.2740202
                ],
                [
                    85.9259331,
                    54.27199
                ],
                [
                    85.9162477,
                    54.2741652
                ],
                [
                    85.9088761,
                    54.273938
                ],
                [
                    85.9088761,
                    54.2784518
                ],
                [
                    85.9061093,
                    54.2820625
                ],
                [
                    85.9057838,
                    54.2843428
                ]
            ],
            "longitude": 85.931091,
            "latitude": 54.284954
        },
        "5789": {
            "name": "АНЖЕРО-СУДЖЕНСК",
            "population": 72827,
            "type": "town",
            "poly": [
                [
                    85.9257778,
                    56.0943887
                ],
                [
                    85.9351524,
                    56.0952801
                ],
                [
                    85.9389874,
                    56.0963497
                ],
                [
                    85.9430356,
                    56.0965874
                ],
                [
                    85.9438878,
                    56.0985482
                ],
                [
                    85.9478994,
                    56.1002429
                ],
                [
                    85.9504902,
                    56.1012315
                ],
                [
                    85.9522628,
                    56.1028286
                ],
                [
                    85.9568308,
                    56.103551
                ],
                [
                    85.9678153,
                    56.1105335
                ],
                [
                    85.9680945,
                    56.1127524
                ],
                [
                    85.9650925,
                    56.1136282
                ],
                [
                    85.9684436,
                    56.1147765
                ],
                [
                    85.9685134,
                    56.1166253
                ],
                [
                    85.9820576,
                    56.1214709
                ],
                [
                    85.9806554,
                    56.1241141
                ],
                [
                    85.9783864,
                    56.1261084
                ],
                [
                    85.9792155,
                    56.1276406
                ],
                [
                    85.9828371,
                    56.1274703
                ],
                [
                    85.9860224,
                    56.1260598
                ],
                [
                    85.9924367,
                    56.1266191
                ],
                [
                    85.9974547,
                    56.1297563
                ],
                [
                    85.993847,
                    56.1428817
                ],
                [
                    85.9786218,
                    56.1549155
                ],
                [
                    86.0050752,
                    56.1563129
                ],
                [
                    86.0050752,
                    56.160049
                ],
                [
                    86.0256823,
                    56.1600794
                ],
                [
                    86.0258459,
                    56.1483534
                ],
                [
                    86.0317434,
                    56.1451269
                ],
                [
                    86.0575969,
                    56.150839
                ],
                [
                    86.0620149,
                    56.14537
                ],
                [
                    86.0488742,
                    56.1360347
                ],
                [
                    86.0470714,
                    56.1326794
                ],
                [
                    86.0470469,
                    56.1282884
                ],
                [
                    86.0470314,
                    56.125498
                ],
                [
                    86.0427357,
                    56.1228289
                ],
                [
                    86.0377358,
                    56.1226718
                ],
                [
                    86.0380174,
                    56.1209839
                ],
                [
                    86.0347781,
                    56.1190996
                ],
                [
                    86.039285,
                    56.1139957
                ],
                [
                    86.0362569,
                    56.1137601
                ],
                [
                    86.0362569,
                    56.1083022
                ],
                [
                    86.0381977,
                    56.1071759
                ],
                [
                    86.0403952,
                    56.1074561
                ],
                [
                    86.0422396,
                    56.1064403
                ],
                [
                    86.0441067,
                    56.1066815
                ],
                [
                    86.0460579,
                    56.1062913
                ],
                [
                    86.049143,
                    56.1077675
                ],
                [
                    86.0509829,
                    56.1079199
                ],
                [
                    86.0528409,
                    56.1090068
                ],
                [
                    86.053187,
                    56.1099616
                ],
                [
                    86.0536455,
                    56.1099735
                ],
                [
                    86.0540614,
                    56.1093013
                ],
                [
                    86.0549617,
                    56.1090576
                ],
                [
                    86.056393,
                    56.1095553
                ],
                [
                    86.0600475,
                    56.1124836
                ],
                [
                    86.0608047,
                    56.111981
                ],
                [
                    86.059723,
                    56.1099304
                ],
                [
                    86.0635449,
                    56.1085632
                ],
                [
                    86.0698186,
                    56.1101113
                ],
                [
                    86.07072,
                    56.1095283
                ],
                [
                    86.0691696,
                    56.1083622
                ],
                [
                    86.0868778,
                    56.0911796
                ],
                [
                    86.0910911,
                    56.0922633
                ],
                [
                    86.1236236,
                    56.1005562
                ],
                [
                    86.1285741,
                    56.0951057
                ],
                [
                    86.1255995,
                    56.0941504
                ],
                [
                    86.1269065,
                    56.0908567
                ],
                [
                    86.1320895,
                    56.0916613
                ],
                [
                    86.1341627,
                    56.0900773
                ],
                [
                    86.1376331,
                    56.0738561
                ],
                [
                    86.1363261,
                    56.073026
                ],
                [
                    86.1364951,
                    56.0692462
                ],
                [
                    86.1389739,
                    56.0651894
                ],
                [
                    86.1380725,
                    56.0622959
                ],
                [
                    86.1332839,
                    56.0631765
                ],
                [
                    86.1340163,
                    56.0651265
                ],
                [
                    86.1293403,
                    56.0726109
                ],
                [
                    86.1210587,
                    56.0722336
                ],
                [
                    86.1203263,
                    56.0678311
                ],
                [
                    86.1151997,
                    56.066699
                ],
                [
                    86.1066364,
                    56.065095
                ],
                [
                    86.1056787,
                    56.062516
                ],
                [
                    86.1085519,
                    56.0598425
                ],
                [
                    86.1111997,
                    56.0603143
                ],
                [
                    86.1141856,
                    56.0589618
                ],
                [
                    86.1033125,
                    56.0543376
                ],
                [
                    86.0980169,
                    56.052859
                ],
                [
                    86.0975098,
                    56.0502162
                ],
                [
                    86.0913691,
                    56.0496499
                ],
                [
                    86.0884396,
                    56.05245
                ],
                [
                    86.0870875,
                    56.0524185
                ],
                [
                    86.0815101,
                    56.0491779
                ],
                [
                    86.0820735,
                    56.0454022
                ],
                [
                    86.0943549,
                    56.0409966
                ],
                [
                    86.1021295,
                    56.0410281
                ],
                [
                    86.1020168,
                    56.0382587
                ],
                [
                    86.0749187,
                    56.0383216
                ],
                [
                    86.0730032,
                    56.037346
                ],
                [
                    86.0745806,
                    56.0356464
                ],
                [
                    86.0729469,
                    56.0346707
                ],
                [
                    86.0739609,
                    56.032908
                ],
                [
                    86.0687216,
                    56.0303269
                ],
                [
                    86.0670878,
                    56.0312083
                ],
                [
                    86.0668467,
                    56.0345058
                ],
                [
                    86.0643228,
                    56.0372251
                ],
                [
                    86.0569674,
                    56.0334784
                ],
                [
                    86.0530306,
                    56.0347563
                ],
                [
                    86.0502137,
                    56.0321438
                ],
                [
                    86.0508334,
                    56.0304755
                ],
                [
                    86.0495377,
                    56.0291848
                ],
                [
                    86.0482983,
                    56.0300662
                ],
                [
                    86.0483546,
                    56.0315772
                ],
                [
                    86.0435096,
                    56.0314513
                ],
                [
                    86.0417068,
                    56.0372427
                ],
                [
                    86.0253691,
                    56.0371798
                ],
                [
                    86.0250874,
                    56.0342212
                ],
                [
                    86.0204677,
                    56.034473
                ],
                [
                    86.0204677,
                    56.0374001
                ],
                [
                    86.0152847,
                    56.0361097
                ],
                [
                    86.0138763,
                    56.0376519
                ],
                [
                    86.0113411,
                    56.0369595
                ],
                [
                    86.0083553,
                    56.0383757
                ],
                [
                    85.9302067,
                    56.039305
                ],
                [
                    85.9292561,
                    56.0465227
                ],
                [
                    85.9290459,
                    56.0481188
                ],
                [
                    85.9285316,
                    56.0601103
                ],
                [
                    85.9285195,
                    56.0603925
                ],
                [
                    85.9257778,
                    56.0943887
                ]
            ],
            "longitude": 86.019356,
            "latitude": 56.077808
        },
        "5790": {
            "name": "БАЧАТСКИЙ",
            "population": 14054,
            "type": "town",
            "poly": [
                [
                    86.0507599,
                    54.2707636
                ],
                [
                    86.0511889,
                    54.2711145
                ],
                [
                    86.0511461,
                    54.2733949
                ],
                [
                    86.0526052,
                    54.2738585
                ],
                [
                    86.0521332,
                    54.2756627
                ],
                [
                    86.0562959,
                    54.2764019
                ],
                [
                    86.0597292,
                    54.2777424
                ],
                [
                    86.0612312,
                    54.276878
                ],
                [
                    86.0574546,
                    54.2751991
                ],
                [
                    86.0573259,
                    54.2741467
                ],
                [
                    86.0600725,
                    54.2745977
                ],
                [
                    86.0608879,
                    54.2700369
                ],
                [
                    86.0680977,
                    54.2701246
                ],
                [
                    86.0715309,
                    54.2716658
                ],
                [
                    86.0698572,
                    54.2729438
                ],
                [
                    86.0686127,
                    54.2724427
                ],
                [
                    86.0677973,
                    54.2730441
                ],
                [
                    86.0673252,
                    54.2747731
                ],
                [
                    86.0723034,
                    54.2771536
                ],
                [
                    86.073505,
                    54.2771411
                ],
                [
                    86.0777965,
                    54.2794838
                ],
                [
                    86.0769382,
                    54.2806739
                ],
                [
                    86.0763803,
                    54.2831793
                ],
                [
                    86.0777536,
                    54.2836428
                ],
                [
                    86.0823456,
                    54.2821646
                ],
                [
                    86.0820881,
                    54.2854453
                ],
                [
                    86.0865083,
                    54.2875997
                ],
                [
                    86.0847917,
                    54.2890664
                ],
                [
                    86.0857359,
                    54.2901798
                ],
                [
                    86.0891691,
                    54.2919332
                ],
                [
                    86.0891691,
                    54.2933358
                ],
                [
                    86.0924307,
                    54.295064
                ],
                [
                    86.0982242,
                    54.2943377
                ],
                [
                    86.0995116,
                    54.2998475
                ],
                [
                    86.1038641,
                    54.3025102
                ],
                [
                    86.1046186,
                    54.3033784
                ],
                [
                    86.1066356,
                    54.3058073
                ],
                [
                    86.1101118,
                    54.3066474
                ],
                [
                    86.1134141,
                    54.3027524
                ],
                [
                    86.1140579,
                    54.2941624
                ],
                [
                    86.1166757,
                    54.2941373
                ],
                [
                    86.1181348,
                    54.2930353
                ],
                [
                    86.1219114,
                    54.2915575
                ],
                [
                    86.1274904,
                    54.2904303
                ],
                [
                    86.1297241,
                    54.2880894
                ],
                [
                    86.1226937,
                    54.2856971
                ],
                [
                    86.1213985,
                    54.2844319
                ],
                [
                    86.1187378,
                    54.2837305
                ],
                [
                    86.1211839,
                    54.280273
                ],
                [
                    86.1227289,
                    54.2775921
                ],
                [
                    86.1164611,
                    54.2761513
                ],
                [
                    86.1151737,
                    54.2767276
                ],
                [
                    86.108953,
                    54.275362
                ],
                [
                    86.1001554,
                    54.2734826
                ],
                [
                    86.099383,
                    54.2747481
                ],
                [
                    86.0986105,
                    54.281626
                ],
                [
                    86.0880962,
                    54.2810122
                ],
                [
                    86.0822168,
                    54.27669
                ],
                [
                    86.068956,
                    54.2695106
                ],
                [
                    86.0513178,
                    54.2695607
                ],
                [
                    86.0509315,
                    54.2697236
                ],
                [
                    86.0507599,
                    54.2707636
                ]
            ],
            "longitude": 86.104759,
            "latitude": 54.283138
        },
        "5791": {
            "name": "РУДНИЧНЫЙ",
            "population": 3799,
            "type": "town",
            "poly": [
                [
                    86.223666,
                    56.0732558
                ],
                [
                    86.2325959,
                    56.0766789
                ],
                [
                    86.2324504,
                    56.0771254
                ],
                [
                    86.2302683,
                    56.0774096
                ],
                [
                    86.2321595,
                    56.0778561
                ],
                [
                    86.2330323,
                    56.0841068
                ],
                [
                    86.230632,
                    56.0852027
                ],
                [
                    86.230632,
                    56.0862578
                ],
                [
                    86.2248129,
                    56.091087
                ],
                [
                    86.2263404,
                    56.0983499
                ],
                [
                    86.2288135,
                    56.098431
                ],
                [
                    86.2280134,
                    56.1057736
                ],
                [
                    86.2347053,
                    56.1066255
                ],
                [
                    86.2379057,
                    56.1081262
                ],
                [
                    86.2440157,
                    56.1075989
                ],
                [
                    86.2499075,
                    56.1097486
                ],
                [
                    86.2536171,
                    56.1096269
                ],
                [
                    86.2617638,
                    56.1070716
                ],
                [
                    86.2686739,
                    56.1039888
                ],
                [
                    86.2712197,
                    56.1065443
                ],
                [
                    86.2745656,
                    56.1078423
                ],
                [
                    86.2763114,
                    56.1064632
                ],
                [
                    86.2829305,
                    56.1063821
                ],
                [
                    86.2890405,
                    56.1084102
                ],
                [
                    86.2912954,
                    56.1055708
                ],
                [
                    86.2910044,
                    56.1045162
                ],
                [
                    86.3139896,
                    56.0968487
                ],
                [
                    86.3192895,
                    56.0984076
                ],
                [
                    86.3357661,
                    56.0983424
                ],
                [
                    86.3369299,
                    56.0975716
                ],
                [
                    86.3363801,
                    56.0929799
                ],
                [
                    86.3406535,
                    56.0685247
                ],
                [
                    86.3461997,
                    56.0658347
                ],
                [
                    86.3478363,
                    56.064312
                ],
                [
                    86.351746,
                    56.0647688
                ],
                [
                    86.3521097,
                    56.063246
                ],
                [
                    86.3503822,
                    56.0621801
                ],
                [
                    86.3490183,
                    56.0590835
                ],
                [
                    86.3498366,
                    56.0580682
                ],
                [
                    86.3457451,
                    56.0574082
                ],
                [
                    86.3436539,
                    56.0518742
                ],
                [
                    86.3475636,
                    56.0504524
                ],
                [
                    86.3494729,
                    56.0508079
                ],
                [
                    86.3504731,
                    56.0498939
                ],
                [
                    86.3460179,
                    56.0475073
                ],
                [
                    86.3409262,
                    56.04964
                ],
                [
                    86.3360164,
                    56.0439525
                ],
                [
                    86.3371075,
                    56.0424797
                ],
                [
                    86.347109,
                    56.0428352
                ],
                [
                    86.3508368,
                    56.0409052
                ],
                [
                    86.3523825,
                    56.040956
                ],
                [
                    86.3447792,
                    56.0357314
                ],
                [
                    86.3455005,
                    56.0339181
                ],
                [
                    86.3427356,
                    56.0326756
                ],
                [
                    86.2871991,
                    56.0554708
                ],
                [
                    86.2767408,
                    56.0554037
                ],
                [
                    86.2649248,
                    56.0541921
                ],
                [
                    86.2562559,
                    56.0519874
                ],
                [
                    86.2498186,
                    56.0521072
                ],
                [
                    86.2467716,
                    56.0544078
                ],
                [
                    86.2428641,
                    56.0558217
                ],
                [
                    86.2363861,
                    56.057523
                ],
                [
                    86.2300346,
                    56.0583857
                ],
                [
                    86.2273288,
                    56.0598473
                ],
                [
                    86.2250135,
                    56.0631058
                ],
                [
                    86.223726,
                    56.0661964
                ],
                [
                    86.2239835,
                    56.0689274
                ],
                [
                    86.223666,
                    56.0732558
                ]
            ],
            "longitude": 86.246651,
            "latitude": 56.083324
        },
        "5792": {
            "name": "БЕРЁЗОВСКИЙ",
            "population": 47140,
            "type": "town",
            "poly": [
                [
                    86.1623183,
                    55.5849575
                ],
                [
                    86.1732083,
                    55.597843
                ],
                [
                    86.1832408,
                    55.6156204
                ],
                [
                    86.1854397,
                    55.611041
                ],
                [
                    86.1964342,
                    55.6067716
                ],
                [
                    86.2044239,
                    55.6064485
                ],
                [
                    86.2037483,
                    55.6104866
                ],
                [
                    86.2075762,
                    55.6108045
                ],
                [
                    86.2127965,
                    55.6164927
                ],
                [
                    86.2202901,
                    55.6169199
                ],
                [
                    86.2177394,
                    55.6224826
                ],
                [
                    86.2172116,
                    55.6254127
                ],
                [
                    86.2203781,
                    55.6292363
                ],
                [
                    86.2240722,
                    55.6319672
                ],
                [
                    86.2273266,
                    55.6333078
                ],
                [
                    86.2412236,
                    55.6367335
                ],
                [
                    86.2453575,
                    55.6416978
                ],
                [
                    86.2395524,
                    55.6484978
                ],
                [
                    86.2398163,
                    55.6506318
                ],
                [
                    86.2414874,
                    55.6530635
                ],
                [
                    86.246413,
                    55.6543537
                ],
                [
                    86.247946,
                    55.6564255
                ],
                [
                    86.2430838,
                    55.6622022
                ],
                [
                    86.2331202,
                    55.6609321
                ],
                [
                    86.2264215,
                    55.662488
                ],
                [
                    86.2240262,
                    55.6654012
                ],
                [
                    86.2293881,
                    55.6679832
                ],
                [
                    86.2305006,
                    55.6683441
                ],
                [
                    86.2314651,
                    55.6685232
                ],
                [
                    86.2325552,
                    55.6686574
                ],
                [
                    86.2336909,
                    55.6686978
                ],
                [
                    86.2347791,
                    55.66868
                ],
                [
                    86.2390394,
                    55.6684044
                ],
                [
                    86.2402997,
                    55.6683621
                ],
                [
                    86.2461799,
                    55.6731871
                ],
                [
                    86.2425216,
                    55.6753179
                ],
                [
                    86.2425259,
                    55.6895543
                ],
                [
                    86.2380401,
                    55.6889593
                ],
                [
                    86.236193,
                    55.687819
                ],
                [
                    86.2303879,
                    55.6895543
                ],
                [
                    86.2293325,
                    55.6912895
                ],
                [
                    86.2259902,
                    55.6919836
                ],
                [
                    86.2273095,
                    55.695999
                ],
                [
                    86.23417,
                    55.6956024
                ],
                [
                    86.2352255,
                    55.6974861
                ],
                [
                    86.2399751,
                    55.6948588
                ],
                [
                    86.2457802,
                    55.6945614
                ],
                [
                    86.2494436,
                    55.6976571
                ],
                [
                    86.2519382,
                    55.6969959
                ],
                [
                    86.2565259,
                    55.6954607
                ],
                [
                    86.2646979,
                    55.688188
                ],
                [
                    86.2641244,
                    55.6916629
                ],
                [
                    86.2679953,
                    55.6938446
                ],
                [
                    86.272153,
                    55.6919861
                ],
                [
                    86.2761673,
                    55.6941679
                ],
                [
                    86.2800382,
                    55.6910972
                ],
                [
                    86.2819082,
                    55.6906549
                ],
                [
                    86.2774736,
                    55.6839528
                ],
                [
                    86.2860964,
                    55.6772047
                ],
                [
                    86.2892037,
                    55.6765191
                ],
                [
                    86.2905097,
                    55.6743352
                ],
                [
                    86.2933468,
                    55.6770777
                ],
                [
                    86.2951481,
                    55.6756557
                ],
                [
                    86.2933017,
                    55.6734972
                ],
                [
                    86.2911852,
                    55.6730655
                ],
                [
                    86.2964541,
                    55.6677068
                ],
                [
                    86.2948779,
                    55.6665384
                ],
                [
                    86.2991561,
                    55.6655225
                ],
                [
                    86.2902845,
                    55.6660051
                ],
                [
                    86.3078187,
                    55.6496507
                ],
                [
                    86.2996676,
                    55.6435264
                ],
                [
                    86.2896196,
                    55.645939
                ],
                [
                    86.2810182,
                    55.649954
                ],
                [
                    86.2738579,
                    55.6505702
                ],
                [
                    86.2634439,
                    55.648728
                ],
                [
                    86.2648719,
                    55.6423202
                ],
                [
                    86.2558089,
                    55.6413671
                ],
                [
                    86.2562317,
                    55.640412
                ],
                [
                    86.2557532,
                    55.6393512
                ],
                [
                    86.2546475,
                    55.6382343
                ],
                [
                    86.2595804,
                    55.6370144
                ],
                [
                    86.2636985,
                    55.6273458
                ],
                [
                    86.2692151,
                    55.6248033
                ],
                [
                    86.2706787,
                    55.6231505
                ],
                [
                    86.2775463,
                    55.6227691
                ],
                [
                    86.2794039,
                    55.6232777
                ],
                [
                    86.2832318,
                    55.6214659
                ],
                [
                    86.2820611,
                    55.6164271
                ],
                [
                    86.2842424,
                    55.6141223
                ],
                [
                    86.2907863,
                    55.6136057
                ],
                [
                    86.2908566,
                    55.6127314
                ],
                [
                    86.2770652,
                    55.6079622
                ],
                [
                    86.2611821,
                    55.5953429
                ],
                [
                    86.2753676,
                    55.5906352
                ],
                [
                    86.2749173,
                    55.5892674
                ],
                [
                    86.278914,
                    55.5877722
                ],
                [
                    86.2555705,
                    55.5775967
                ],
                [
                    86.2450158,
                    55.5676911
                ],
                [
                    86.2451566,
                    55.5655426
                ],
                [
                    86.2421686,
                    55.5646431
                ],
                [
                    86.2293071,
                    55.5533756
                ],
                [
                    86.2256234,
                    55.5560747
                ],
                [
                    86.210177,
                    55.5514388
                ],
                [
                    86.2036922,
                    55.551235
                ],
                [
                    86.2004948,
                    55.5518718
                ],
                [
                    86.1998643,
                    55.5500122
                ],
                [
                    86.195316,
                    55.550751
                ],
                [
                    86.1944603,
                    55.5523049
                ],
                [
                    86.1787946,
                    55.5501342
                ],
                [
                    86.179507,
                    55.559856
                ],
                [
                    86.1752288,
                    55.56062
                ],
                [
                    86.1751508,
                    55.566587
                ],
                [
                    86.1736872,
                    55.5680193
                ],
                [
                    86.1740812,
                    55.5697062
                ],
                [
                    86.1712666,
                    55.5723478
                ],
                [
                    86.1739686,
                    55.5742891
                ],
                [
                    86.1623183,
                    55.5849575
                ]
            ],
            "longitude": 86.274529,
            "latitude": 55.669926
        },
        "5793": {
            "name": "ПОЛЫСАЕВО",
            "population": 26738,
            "type": "town",
            "poly": [
                [
                    86.2288158,
                    54.5987966
                ],
                [
                    86.2326353,
                    54.6016058
                ],
                [
                    86.2342661,
                    54.60306
                ],
                [
                    86.2379139,
                    54.6045763
                ],
                [
                    86.237356,
                    54.6052226
                ],
                [
                    86.2373989,
                    54.6068992
                ],
                [
                    86.234309,
                    54.6061784
                ],
                [
                    86.2316911,
                    54.6075951
                ],
                [
                    86.2290505,
                    54.6094145
                ],
                [
                    86.2322279,
                    54.6136058
                ],
                [
                    86.2403171,
                    54.6091361
                ],
                [
                    86.2456815,
                    54.6080674
                ],
                [
                    86.2528054,
                    54.612392
                ],
                [
                    86.254565,
                    54.6116464
                ],
                [
                    86.2549942,
                    54.6106274
                ],
                [
                    86.2649505,
                    54.6129275
                ],
                [
                    86.2632339,
                    54.6153244
                ],
                [
                    86.2671821,
                    54.6160451
                ],
                [
                    86.2685125,
                    54.6163433
                ],
                [
                    86.2652397,
                    54.6221749
                ],
                [
                    86.2698276,
                    54.6233669
                ],
                [
                    86.2894218,
                    54.6134525
                ],
                [
                    86.2941234,
                    54.6174839
                ],
                [
                    86.3073086,
                    54.604793
                ],
                [
                    86.3205174,
                    54.6043198
                ],
                [
                    86.3233771,
                    54.6028211
                ],
                [
                    86.3172494,
                    54.6015591
                ],
                [
                    86.3104407,
                    54.6012436
                ],
                [
                    86.3076491,
                    54.6017549
                ],
                [
                    86.3049884,
                    54.600686
                ],
                [
                    86.3031001,
                    54.6018792
                ],
                [
                    86.2978644,
                    54.6000894
                ],
                [
                    86.2986798,
                    54.5991695
                ],
                [
                    86.2991948,
                    54.5985977
                ],
                [
                    86.2994952,
                    54.5980011
                ],
                [
                    86.3023727,
                    54.5983864
                ],
                [
                    86.3025851,
                    54.5980011
                ],
                [
                    86.3009973,
                    54.5967828
                ],
                [
                    86.301126,
                    54.5965094
                ],
                [
                    86.3049884,
                    54.5977773
                ],
                [
                    86.3062329,
                    54.596758
                ],
                [
                    86.3063291,
                    54.5963905
                ],
                [
                    86.3149858,
                    54.5898192
                ],
                [
                    86.3104407,
                    54.5869638
                ],
                [
                    86.3125662,
                    54.5852235
                ],
                [
                    86.3090989,
                    54.5837467
                ],
                [
                    86.3070054,
                    54.5849219
                ],
                [
                    86.3051171,
                    54.5841012
                ],
                [
                    86.30619,
                    54.5832557
                ],
                [
                    86.2974782,
                    54.5801468
                ],
                [
                    86.2947316,
                    54.5801965
                ],
                [
                    86.2903543,
                    54.5821365
                ],
                [
                    86.2877364,
                    54.582808
                ],
                [
                    86.2815157,
                    54.5828329
                ],
                [
                    86.2756794,
                    54.5819873
                ],
                [
                    86.2725465,
                    54.5799229
                ],
                [
                    86.2770526,
                    54.5778709
                ],
                [
                    86.2732761,
                    54.5749233
                ],
                [
                    86.2663667,
                    54.571963
                ],
                [
                    86.2655943,
                    54.5720127
                ],
                [
                    86.2625902,
                    54.573381
                ],
                [
                    86.2592428,
                    54.5712664
                ],
                [
                    86.2632339,
                    54.569525
                ],
                [
                    86.2610023,
                    54.567037
                ],
                [
                    86.2548654,
                    54.5689776
                ],
                [
                    86.2483423,
                    54.5713411
                ],
                [
                    86.2505739,
                    54.5760924
                ],
                [
                    86.251475,
                    54.5772242
                ],
                [
                    86.2479131,
                    54.5769879
                ],
                [
                    86.2447803,
                    54.5757939
                ],
                [
                    86.2442224,
                    54.5764904
                ],
                [
                    86.2451236,
                    54.5786793
                ],
                [
                    86.2393301,
                    54.5821365
                ],
                [
                    86.2372701,
                    54.5842007
                ],
                [
                    86.2341802,
                    54.5891246
                ],
                [
                    86.2355106,
                    54.5927053
                ],
                [
                    86.2342231,
                    54.5936998
                ],
                [
                    86.2306612,
                    54.5937496
                ],
                [
                    86.2288158,
                    54.5987966
                ]
            ],
            "longitude": 86.276024,
            "latitude": 54.603142
        },
        "5794": {
            "name": "НОВЫЙ ГОРОДОК",
            "population": 15037,
            "type": "town",
            "poly": null,
            "longitude": 86.296219,
            "latitude": 54.306171
        },
        "5795": {
            "name": "БЕЛОВО",
            "population": 73400,
            "type": "town",
            "poly": [
                [
                    86.2348375,
                    54.4156064
                ],
                [
                    86.2709673,
                    54.4309403
                ],
                [
                    86.2814189,
                    54.431937
                ],
                [
                    86.2859396,
                    54.4379647
                ],
                [
                    86.2775717,
                    54.4396602
                ],
                [
                    86.281177,
                    54.4479515
                ],
                [
                    86.2844933,
                    54.4469434
                ],
                [
                    86.2851924,
                    54.4427118
                ],
                [
                    86.2990803,
                    54.4397289
                ],
                [
                    86.3144112,
                    54.4617186
                ],
                [
                    86.332724,
                    54.4577769
                ],
                [
                    86.3254238,
                    54.4451383
                ],
                [
                    86.3184938,
                    54.4376194
                ],
                [
                    86.3114754,
                    54.4390107
                ],
                [
                    86.3068943,
                    54.433279
                ],
                [
                    86.3113675,
                    54.4324697
                ],
                [
                    86.309208,
                    54.4286385
                ],
                [
                    86.3133111,
                    54.4241787
                ],
                [
                    86.3131491,
                    54.422514
                ],
                [
                    86.3128263,
                    54.4190274
                ],
                [
                    86.3239465,
                    54.4190902
                ],
                [
                    86.3271116,
                    54.4142127
                ],
                [
                    86.3316837,
                    54.4095475
                ],
                [
                    86.3236934,
                    54.4070457
                ],
                [
                    86.3215879,
                    54.3999438
                ],
                [
                    86.3176621,
                    54.4009059
                ],
                [
                    86.3147316,
                    54.401955
                ],
                [
                    86.3100934,
                    54.3986678
                ],
                [
                    86.2978876,
                    54.3977752
                ],
                [
                    86.2870363,
                    54.396078
                ],
                [
                    86.2845308,
                    54.3958211
                ],
                [
                    86.2812898,
                    54.3959755
                ],
                [
                    86.2738269,
                    54.395607
                ],
                [
                    86.2542367,
                    54.3989693
                ],
                [
                    86.2348375,
                    54.4156064
                ]
            ],
            "longitude": 86.303429,
            "latitude": 54.419323
        },
        "5796": {
            "name": "ГРАМОТЕИНО",
            "population": 12447,
            "type": "town",
            "poly": [
                [
                    86.3520591,
                    54.5154925
                ],
                [
                    86.3560521,
                    54.5143772
                ],
                [
                    86.3576086,
                    54.5151976
                ],
                [
                    86.3588251,
                    54.5151457
                ],
                [
                    86.3596838,
                    54.5144914
                ],
                [
                    86.3598626,
                    54.5133698
                ],
                [
                    86.361777,
                    54.5131517
                ],
                [
                    86.3620632,
                    54.5135256
                ],
                [
                    86.3638737,
                    54.5134439
                ],
                [
                    86.3644416,
                    54.5147732
                ],
                [
                    86.3628661,
                    54.5150018
                ],
                [
                    86.3608968,
                    54.5156611
                ],
                [
                    86.3596609,
                    54.5169535
                ],
                [
                    86.3614499,
                    54.5179297
                ],
                [
                    86.3611637,
                    54.5182723
                ],
                [
                    86.3611995,
                    54.519425
                ],
                [
                    86.3595605,
                    54.5206491
                ],
                [
                    86.3594031,
                    54.5227091
                ],
                [
                    86.3633277,
                    54.5277951
                ],
                [
                    86.3654208,
                    54.528719
                ],
                [
                    86.3637585,
                    54.5338076
                ],
                [
                    86.3633154,
                    54.5359601
                ],
                [
                    86.362755,
                    54.5357907
                ],
                [
                    86.3615551,
                    54.537297
                ],
                [
                    86.3605573,
                    54.5377121
                ],
                [
                    86.3595535,
                    54.5381296
                ],
                [
                    86.3636155,
                    54.5412209
                ],
                [
                    86.3654935,
                    54.5419304
                ],
                [
                    86.3682452,
                    54.5447174
                ],
                [
                    86.3740979,
                    54.54492
                ],
                [
                    86.3922237,
                    54.5423358
                ],
                [
                    86.4080691,
                    54.5422128
                ],
                [
                    86.4083493,
                    54.5337338
                ],
                [
                    86.4095286,
                    54.5335311
                ],
                [
                    86.4042001,
                    54.5309207
                ],
                [
                    86.4077379,
                    54.5291466
                ],
                [
                    86.4122802,
                    54.5309714
                ],
                [
                    86.4152939,
                    54.5274231
                ],
                [
                    86.4120514,
                    54.5266868
                ],
                [
                    86.4095244,
                    54.5265441
                ],
                [
                    86.4090995,
                    54.5261548
                ],
                [
                    86.4116041,
                    54.5239225
                ],
                [
                    86.4158619,
                    54.5188781
                ],
                [
                    86.3924277,
                    54.5055731
                ],
                [
                    86.3921749,
                    54.5050212
                ],
                [
                    86.3916024,
                    54.5049631
                ],
                [
                    86.3910156,
                    54.504639
                ],
                [
                    86.3904718,
                    54.5049381
                ],
                [
                    86.3897705,
                    54.504988
                ],
                [
                    86.388554,
                    54.5045808
                ],
                [
                    86.3885683,
                    54.5043814
                ],
                [
                    86.3895415,
                    54.502952
                ],
                [
                    86.3889826,
                    54.5017512
                ],
                [
                    86.3895907,
                    54.5004942
                ],
                [
                    86.3889647,
                    54.4998708
                ],
                [
                    86.387283,
                    54.4999124
                ],
                [
                    86.3858697,
                    54.5002241
                ],
                [
                    86.3805564,
                    54.5002552
                ],
                [
                    86.3785281,
                    54.5007688
                ],
                [
                    86.3782765,
                    54.5005578
                ],
                [
                    86.3780809,
                    54.4991618
                ],
                [
                    86.378612,
                    54.497019
                ],
                [
                    86.3804289,
                    54.4963534
                ],
                [
                    86.380401,
                    54.4939832
                ],
                [
                    86.3847057,
                    54.4939995
                ],
                [
                    86.3806922,
                    54.490028
                ],
                [
                    86.3747357,
                    54.4922306
                ],
                [
                    86.3669118,
                    54.4945945
                ],
                [
                    86.3641953,
                    54.495693
                ],
                [
                    86.3597762,
                    54.4981084
                ],
                [
                    86.3571031,
                    54.5003585
                ],
                [
                    86.3549872,
                    54.5027679
                ],
                [
                    86.3531953,
                    54.5056669
                ],
                [
                    86.3522112,
                    54.5087346
                ],
                [
                    86.3520591,
                    54.5154925
                ]
            ],
            "longitude": 86.380737,
            "latitude": 54.53487
        },
        "5797": {
            "name": "ИНСКОЙ",
            "population": 12156,
            "type": "town",
            "poly": [
                [
                    86.4043791,
                    54.4646398
                ],
                [
                    86.4119884,
                    54.4681679
                ],
                [
                    86.4165387,
                    54.4643573
                ],
                [
                    86.4205233,
                    54.4623358
                ],
                [
                    86.4268795,
                    54.4586361
                ],
                [
                    86.4353676,
                    54.4562737
                ],
                [
                    86.4326681,
                    54.4551704
                ],
                [
                    86.4283192,
                    54.4517976
                ],
                [
                    86.4334254,
                    54.450176
                ],
                [
                    86.438872,
                    54.4455247
                ],
                [
                    86.4373555,
                    54.4441096
                ],
                [
                    86.4330056,
                    54.4404117
                ],
                [
                    86.4369882,
                    54.4386373
                ],
                [
                    86.4390545,
                    54.4394077
                ],
                [
                    86.4402999,
                    54.4395617
                ],
                [
                    86.4586398,
                    54.4368886
                ],
                [
                    86.460554,
                    54.4373898
                ],
                [
                    86.461676,
                    54.4352596
                ],
                [
                    86.4611033,
                    54.43298
                ],
                [
                    86.4545912,
                    54.4306687
                ],
                [
                    86.4518004,
                    54.4296167
                ],
                [
                    86.4510932,
                    54.4290727
                ],
                [
                    86.4503729,
                    54.4268819
                ],
                [
                    86.4508943,
                    54.4243412
                ],
                [
                    86.4514815,
                    54.4213009
                ],
                [
                    86.4553213,
                    54.4219533
                ],
                [
                    86.464889,
                    54.4198001
                ],
                [
                    86.4632722,
                    54.4136296
                ],
                [
                    86.4600911,
                    54.4113196
                ],
                [
                    86.4451646,
                    54.4183668
                ],
                [
                    86.4303493,
                    54.4111481
                ],
                [
                    86.42144,
                    54.4097726
                ],
                [
                    86.4166482,
                    54.4256447
                ],
                [
                    86.4194692,
                    54.4265268
                ],
                [
                    86.4185403,
                    54.4278889
                ],
                [
                    86.4162752,
                    54.4314791
                ],
                [
                    86.4123089,
                    54.4391172
                ],
                [
                    86.4071971,
                    54.4475226
                ],
                [
                    86.4046065,
                    54.4532563
                ],
                [
                    86.4043791,
                    54.4646398
                ]
            ],
            "longitude": 86.441681,
            "latitude": 54.432644
        },
        "5798": {
            "name": "КРАСНОБРОДСКИЙ",
            "population": 11828,
            "type": "town",
            "poly": [
                [
                    86.4185825,
                    54.1578167
                ],
                [
                    86.4237388,
                    54.1626262
                ],
                [
                    86.4426153,
                    54.1686809
                ],
                [
                    86.4499783,
                    54.1674953
                ],
                [
                    86.4530538,
                    54.1659199
                ],
                [
                    86.4589485,
                    54.1668951
                ],
                [
                    86.465484,
                    54.1677954
                ],
                [
                    86.4706098,
                    54.1659199
                ],
                [
                    86.4715068,
                    54.1630689
                ],
                [
                    86.4705391,
                    54.158439
                ],
                [
                    86.4635121,
                    54.1550215
                ],
                [
                    86.454976,
                    54.1505376
                ],
                [
                    86.4341368,
                    54.1451743
                ],
                [
                    86.4306231,
                    54.1459465
                ],
                [
                    86.4278063,
                    54.1469081
                ],
                [
                    86.4199416,
                    54.1500664
                ],
                [
                    86.4185825,
                    54.1578167
                ]
            ],
            "longitude": 86.448097,
            "latitude": 54.157387
        },
        "5799": {
            "name": "ЯЯ",
            "population": 10968,
            "type": "town",
            "poly": [
                [
                    86.3583485,
                    56.2109663
                ],
                [
                    86.3590221,
                    56.2138338
                ],
                [
                    86.3649207,
                    56.2131931
                ],
                [
                    86.368201,
                    56.2138324
                ],
                [
                    86.377301,
                    56.2169533
                ],
                [
                    86.3792032,
                    56.2157032
                ],
                [
                    86.3813027,
                    56.2159951
                ],
                [
                    86.3847106,
                    56.2169061
                ],
                [
                    86.3912652,
                    56.2169103
                ],
                [
                    86.391895,
                    56.2185947
                ],
                [
                    86.3947394,
                    56.2166372
                ],
                [
                    86.3972512,
                    56.2169687
                ],
                [
                    86.3977685,
                    56.2198811
                ],
                [
                    86.398972,
                    56.2214401
                ],
                [
                    86.4012201,
                    56.222945
                ],
                [
                    86.4050118,
                    56.2237349
                ],
                [
                    86.4069298,
                    56.2238176
                ],
                [
                    86.4095181,
                    56.2222988
                ],
                [
                    86.4115051,
                    56.2313972
                ],
                [
                    86.4140983,
                    56.2338689
                ],
                [
                    86.414086,
                    56.2356725
                ],
                [
                    86.4122176,
                    56.2386004
                ],
                [
                    86.4122439,
                    56.2428735
                ],
                [
                    86.4140022,
                    56.2445796
                ],
                [
                    86.4149627,
                    56.2457654
                ],
                [
                    86.4182788,
                    56.2447359
                ],
                [
                    86.4216506,
                    56.2447406
                ],
                [
                    86.4289651,
                    56.2470737
                ],
                [
                    86.4344365,
                    56.2473233
                ],
                [
                    86.4400043,
                    56.24695
                ],
                [
                    86.4447744,
                    56.2460868
                ],
                [
                    86.4484359,
                    56.2458278
                ],
                [
                    86.4527986,
                    56.2461358
                ],
                [
                    86.4580675,
                    56.2456822
                ],
                [
                    86.4612839,
                    56.2444476
                ],
                [
                    86.4621748,
                    56.2435
                ],
                [
                    86.4638545,
                    56.240924
                ],
                [
                    86.464056,
                    56.2388333
                ],
                [
                    86.4630483,
                    56.2338672
                ],
                [
                    86.4625108,
                    56.2318508
                ],
                [
                    86.4637873,
                    56.2297595
                ],
                [
                    86.4647279,
                    56.2216175
                ],
                [
                    86.4662731,
                    56.2189653
                ],
                [
                    86.4703041,
                    56.2178446
                ],
                [
                    86.5061801,
                    56.2177326
                ],
                [
                    86.5188757,
                    56.2154851
                ],
                [
                    86.5139666,
                    56.2085246
                ],
                [
                    86.5082526,
                    56.2076563
                ],
                [
                    86.502233,
                    56.205773
                ],
                [
                    86.4984169,
                    56.2024844
                ],
                [
                    86.4934185,
                    56.1994348
                ],
                [
                    86.4867,
                    56.1975511
                ],
                [
                    86.4777244,
                    56.1926171
                ],
                [
                    86.4741233,
                    56.189148
                ],
                [
                    86.4698236,
                    56.1870544
                ],
                [
                    86.4632127,
                    56.1870245
                ],
                [
                    86.4574618,
                    56.1884302
                ],
                [
                    86.4518721,
                    56.1846316
                ],
                [
                    86.444885,
                    56.1842129
                ],
                [
                    86.4402091,
                    56.1849008
                ],
                [
                    86.4374142,
                    56.1850504
                ],
                [
                    86.4334906,
                    56.1817601
                ],
                [
                    86.4312833,
                    56.1806715
                ],
                [
                    86.4287841,
                    56.181008
                ],
                [
                    86.4242828,
                    56.1820924
                ],
                [
                    86.4201846,
                    56.1823168
                ],
                [
                    86.4117195,
                    56.1823915
                ],
                [
                    86.4096368,
                    56.1821298
                ],
                [
                    86.4080916,
                    56.1826907
                ],
                [
                    86.4066807,
                    56.1840741
                ],
                [
                    86.4049339,
                    56.1846349
                ],
                [
                    86.4012388,
                    56.1845976
                ],
                [
                    86.3981484,
                    56.1840367
                ],
                [
                    86.396536,
                    56.1831394
                ],
                [
                    86.395797,
                    56.1802303
                ],
                [
                    86.3960926,
                    56.1775379
                ],
                [
                    86.3904894,
                    56.174576
                ],
                [
                    86.3877349,
                    56.1731324
                ],
                [
                    86.3852491,
                    56.171397
                ],
                [
                    86.3814868,
                    56.1745386
                ],
                [
                    86.3810837,
                    56.1768573
                ],
                [
                    86.3773114,
                    56.1767047
                ],
                [
                    86.3696797,
                    56.1781914
                ],
                [
                    86.3688836,
                    56.1795011
                ],
                [
                    86.3737586,
                    56.1798746
                ],
                [
                    86.373856,
                    56.1810487
                ],
                [
                    86.369946,
                    56.1848789
                ],
                [
                    86.3716716,
                    56.1849944
                ],
                [
                    86.3714517,
                    56.1861314
                ],
                [
                    86.3729726,
                    56.1863352
                ],
                [
                    86.3727114,
                    56.1875334
                ],
                [
                    86.3696697,
                    56.1873054
                ],
                [
                    86.3712317,
                    56.1890522
                ],
                [
                    86.3718615,
                    56.1909214
                ],
                [
                    86.3733312,
                    56.1920312
                ],
                [
                    86.3755356,
                    56.1927321
                ],
                [
                    86.37816,
                    56.191856
                ],
                [
                    86.3793082,
                    56.1928142
                ],
                [
                    86.3733246,
                    56.1964353
                ],
                [
                    86.3583485,
                    56.2109663
                ]
            ],
            "longitude": 86.451111,
            "latitude": 56.202641
        },
        "5800": {
            "name": "ИЖМОРСКИЙ",
            "population": 4963,
            "type": "town",
            "poly": [
                [
                    86.6059213,
                    56.19569
                ],
                [
                    86.6075952,
                    56.1965189
                ],
                [
                    86.6119018,
                    56.1986515
                ],
                [
                    86.6209711,
                    56.1983591
                ],
                [
                    86.6287918,
                    56.2006258
                ],
                [
                    86.6324063,
                    56.2004064
                ],
                [
                    86.6366781,
                    56.2027096
                ],
                [
                    86.6412785,
                    56.2026365
                ],
                [
                    86.6512022,
                    56.2122863
                ],
                [
                    86.6548825,
                    56.2114091
                ],
                [
                    86.6527137,
                    56.2076445
                ],
                [
                    86.6617173,
                    56.204647
                ],
                [
                    86.6574455,
                    56.2018688
                ],
                [
                    86.6609287,
                    56.198944
                ],
                [
                    86.6669749,
                    56.196531
                ],
                [
                    86.6667777,
                    56.1905707
                ],
                [
                    86.6738237,
                    56.1904085
                ],
                [
                    86.6725914,
                    56.1873914
                ],
                [
                    86.6480287,
                    56.181951
                ],
                [
                    86.6173048,
                    56.1869343
                ],
                [
                    86.6164833,
                    56.1893571
                ],
                [
                    86.6059213,
                    56.19569
                ]
            ],
            "longitude": 86.637169,
            "latitude": 56.192169
        },
        "5801": {
            "name": "КРАПИВИНСКИЙ",
            "population": 7274,
            "type": "town",
            "poly": [
                [
                    86.765892,
                    55.0049171
                ],
                [
                    86.7694168,
                    55.007
                ],
                [
                    86.7828458,
                    55.0108217
                ],
                [
                    86.7956603,
                    55.0162091
                ],
                [
                    86.80336,
                    55.0193329
                ],
                [
                    86.8092804,
                    55.0206375
                ],
                [
                    86.8133087,
                    55.0215263
                ],
                [
                    86.8149185,
                    55.0209999
                ],
                [
                    86.8156804,
                    55.0209295
                ],
                [
                    86.8129058,
                    55.0135433
                ],
                [
                    86.8124057,
                    55.0110158
                ],
                [
                    86.8120877,
                    55.0094079
                ],
                [
                    86.8117583,
                    55.0077428
                ],
                [
                    86.8139127,
                    55.0039093
                ],
                [
                    86.8185729,
                    54.9999197
                ],
                [
                    86.8262458,
                    54.9976204
                ],
                [
                    86.8299179,
                    54.9969407
                ],
                [
                    86.8333881,
                    54.9965588
                ],
                [
                    86.8311386,
                    54.9948883
                ],
                [
                    86.8362998,
                    54.9920752
                ],
                [
                    86.8356867,
                    54.9873876
                ],
                [
                    86.8376806,
                    54.9822635
                ],
                [
                    86.8285407,
                    54.9820413
                ],
                [
                    86.8240801,
                    54.9832718
                ],
                [
                    86.820346,
                    54.9821324
                ],
                [
                    86.8166768,
                    54.9830251
                ],
                [
                    86.8189391,
                    54.985541
                ],
                [
                    86.8092499,
                    54.9878349
                ],
                [
                    86.7900935,
                    54.9919919
                ],
                [
                    86.790248,
                    54.9975507
                ],
                [
                    86.7773895,
                    55
                ],
                [
                    86.7699432,
                    55.0005569
                ],
                [
                    86.7665863,
                    55.0041656
                ],
                [
                    86.765892,
                    55.0049171
                ]
            ],
            "longitude": 86.805855,
            "latitude": 55.003925
        },
        "5802": {
            "name": "ЗЕЛЕНОГОРСКИЙ",
            "population": 4930,
            "type": "town",
            "poly": [
                [
                    86.9370867,
                    55.0056693
                ],
                [
                    86.937864,
                    55.0063685
                ],
                [
                    86.9379748,
                    55.0066415
                ],
                [
                    86.9384172,
                    55.0077316
                ],
                [
                    86.9388859,
                    55.0088865
                ],
                [
                    86.9412073,
                    55.0090064
                ],
                [
                    86.941836,
                    55.0094309
                ],
                [
                    86.9426015,
                    55.0095755
                ],
                [
                    86.9444549,
                    55.0089255
                ],
                [
                    86.9438482,
                    55.0081608
                ],
                [
                    86.9463528,
                    55.0074569
                ],
                [
                    86.9541789,
                    55.0066182
                ],
                [
                    86.9578314,
                    55.0060769
                ],
                [
                    86.9661187,
                    55.0054521
                ],
                [
                    86.9688562,
                    55.0043267
                ],
                [
                    86.9710814,
                    55.0026656
                ],
                [
                    86.977172,
                    54.999016
                ],
                [
                    86.9787665,
                    54.9979938
                ],
                [
                    86.9780713,
                    54.9962312
                ],
                [
                    86.9746624,
                    54.9976791
                ],
                [
                    86.9741173,
                    54.9980979
                ],
                [
                    86.9672471,
                    54.9959273
                ],
                [
                    86.9649288,
                    54.9966277
                ],
                [
                    86.9648617,
                    54.99796
                ],
                [
                    86.9644712,
                    54.9990798
                ],
                [
                    86.9620905,
                    54.9986502
                ],
                [
                    86.9609001,
                    54.9990263
                ],
                [
                    86.9568199,
                    55.0002035
                ],
                [
                    86.9557553,
                    55.0001699
                ],
                [
                    86.9520365,
                    54.9993986
                ],
                [
                    86.9498081,
                    55.0005235
                ],
                [
                    86.9442339,
                    55.0017379
                ],
                [
                    86.9408538,
                    55.0037267
                ],
                [
                    86.9412393,
                    55.0063547
                ],
                [
                    86.9398353,
                    55.0063604
                ],
                [
                    86.9388714,
                    55.0056551
                ],
                [
                    86.9370867,
                    55.0056693
                ]
            ],
            "longitude": 86.952477,
            "latitude": 55.004623
        },
        "5803": {
            "name": "МУНДЫБАШ",
            "population": 4667,
            "type": "town",
            "poly": [
                [
                    87.2475433,
                    53.2151413
                ],
                [
                    87.2642316,
                    53.2164936
                ],
                [
                    87.2648672,
                    53.2168077
                ],
                [
                    87.2645242,
                    53.2170977
                ],
                [
                    87.2649681,
                    53.2169648
                ],
                [
                    87.2653717,
                    53.2170554
                ],
                [
                    87.265866,
                    53.2172789
                ],
                [
                    87.2658862,
                    53.21743
                ],
                [
                    87.2660476,
                    53.2174179
                ],
                [
                    87.2661889,
                    53.2173212
                ],
                [
                    87.2663907,
                    53.2173816
                ],
                [
                    87.2664209,
                    53.217726
                ],
                [
                    87.2671473,
                    53.2179616
                ],
                [
                    87.2675509,
                    53.2180582
                ],
                [
                    87.2673491,
                    53.2181488
                ],
                [
                    87.2676114,
                    53.2182697
                ],
                [
                    87.2679544,
                    53.2182878
                ],
                [
                    87.2683681,
                    53.2182092
                ],
                [
                    87.268812,
                    53.2182757
                ],
                [
                    87.2690844,
                    53.2182334
                ],
                [
                    87.2693669,
                    53.2182878
                ],
                [
                    87.2693669,
                    53.2184328
                ],
                [
                    87.2691954,
                    53.2185173
                ],
                [
                    87.2692256,
                    53.2185959
                ],
                [
                    87.2691449,
                    53.2187831
                ],
                [
                    87.268923,
                    53.2188375
                ],
                [
                    87.2677022,
                    53.2187771
                ],
                [
                    87.2674903,
                    53.2188073
                ],
                [
                    87.2671675,
                    53.2187529
                ],
                [
                    87.267107,
                    53.2188073
                ],
                [
                    87.2675307,
                    53.2191456
                ],
                [
                    87.2671271,
                    53.2195624
                ],
                [
                    87.2664886,
                    53.2201415
                ],
                [
                    87.2663597,
                    53.2201929
                ],
                [
                    87.266396,
                    53.2203869
                ],
                [
                    87.2667035,
                    53.2202464
                ],
                [
                    87.2671729,
                    53.2197872
                ],
                [
                    87.2682573,
                    53.2191597
                ],
                [
                    87.2686375,
                    53.2189736
                ],
                [
                    87.2690209,
                    53.2188746
                ],
                [
                    87.2697482,
                    53.2186628
                ],
                [
                    87.2700623,
                    53.2184788
                ],
                [
                    87.2704788,
                    53.2181957
                ],
                [
                    87.2713417,
                    53.2177087
                ],
                [
                    87.2716657,
                    53.2175741
                ],
                [
                    87.2719037,
                    53.2175326
                ],
                [
                    87.2727632,
                    53.2175207
                ],
                [
                    87.2739137,
                    53.2176256
                ],
                [
                    87.2745914,
                    53.2177582
                ],
                [
                    87.2752757,
                    53.2176553
                ],
                [
                    87.2755799,
                    53.2173861
                ],
                [
                    87.2762741,
                    53.2168476
                ],
                [
                    87.2767469,
                    53.2171406
                ],
                [
                    87.277008,
                    53.2173425
                ],
                [
                    87.2778147,
                    53.2170535
                ],
                [
                    87.2800429,
                    53.2161588
                ],
                [
                    87.2802776,
                    53.2162637
                ],
                [
                    87.2805057,
                    53.2161548
                ],
                [
                    87.2803668,
                    53.2159707
                ],
                [
                    87.2810379,
                    53.2157193
                ],
                [
                    87.2825587,
                    53.2152105
                ],
                [
                    87.2827074,
                    53.2149552
                ],
                [
                    87.2826545,
                    53.214779
                ],
                [
                    87.2835802,
                    53.214488
                ],
                [
                    87.2836992,
                    53.2145018
                ],
                [
                    87.2858658,
                    53.2157179
                ],
                [
                    87.2861411,
                    53.2160107
                ],
                [
                    87.2865115,
                    53.2162559
                ],
                [
                    87.287524,
                    53.2166447
                ],
                [
                    87.2884687,
                    53.2168352
                ],
                [
                    87.2894558,
                    53.2170387
                ],
                [
                    87.2902875,
                    53.2171809
                ],
                [
                    87.290241,
                    53.2172954
                ],
                [
                    87.2897606,
                    53.2176263
                ],
                [
                    87.2884809,
                    53.2185041
                ],
                [
                    87.2838315,
                    53.2207354
                ],
                [
                    87.2837641,
                    53.220785
                ],
                [
                    87.2839088,
                    53.2209953
                ],
                [
                    87.2845286,
                    53.2220715
                ],
                [
                    87.2859667,
                    53.2219824
                ],
                [
                    87.2874874,
                    53.2219231
                ],
                [
                    87.2879709,
                    53.2223288
                ],
                [
                    87.2877271,
                    53.2224649
                ],
                [
                    87.2853427,
                    53.2233828
                ],
                [
                    87.2844832,
                    53.2237291
                ],
                [
                    87.2846237,
                    53.2239122
                ],
                [
                    87.2849708,
                    53.2242215
                ],
                [
                    87.2854419,
                    53.2246297
                ],
                [
                    87.2857064,
                    53.2249884
                ],
                [
                    87.2858882,
                    53.2256687
                ],
                [
                    87.2860122,
                    53.2262056
                ],
                [
                    87.2860452,
                    53.2272965
                ],
                [
                    87.2868304,
                    53.2275934
                ],
                [
                    87.2874461,
                    53.2275637
                ],
                [
                    87.2899049,
                    53.2275241
                ],
                [
                    87.2905908,
                    53.2274301
                ],
                [
                    87.2912727,
                    53.2274004
                ],
                [
                    87.2918884,
                    53.227257
                ],
                [
                    87.2923678,
                    53.2269923
                ],
                [
                    87.2931777,
                    53.2274376
                ],
                [
                    87.2942026,
                    53.2277963
                ],
                [
                    87.2948637,
                    53.228014
                ],
                [
                    87.2950952,
                    53.2280906
                ],
                [
                    87.2952604,
                    53.2282341
                ],
                [
                    87.2947852,
                    53.2284963
                ],
                [
                    87.2948348,
                    53.2285928
                ],
                [
                    87.2953762,
                    53.2292187
                ],
                [
                    87.2963555,
                    53.2303862
                ],
                [
                    87.2974134,
                    53.2305347
                ],
                [
                    87.2981862,
                    53.2307004
                ],
                [
                    87.299368,
                    53.2304184
                ],
                [
                    87.2994961,
                    53.2305619
                ],
                [
                    87.2995953,
                    53.230834
                ],
                [
                    87.3003516,
                    53.2311209
                ],
                [
                    87.3009631,
                    53.2312199
                ],
                [
                    87.3016574,
                    53.2313015
                ],
                [
                    87.3019715,
                    53.2313831
                ],
                [
                    87.3021202,
                    53.2311506
                ],
                [
                    87.3024425,
                    53.2304778
                ],
                [
                    87.306733,
                    53.2301457
                ],
                [
                    87.3065135,
                    53.2298906
                ],
                [
                    87.3058032,
                    53.2292915
                ],
                [
                    87.3049057,
                    53.2285068
                ],
                [
                    87.3039759,
                    53.2277415
                ],
                [
                    87.3032979,
                    53.2271811
                ],
                [
                    87.3033883,
                    53.2269607
                ],
                [
                    87.3035627,
                    53.2266863
                ],
                [
                    87.3048863,
                    53.226667
                ],
                [
                    87.308457,
                    53.2265819
                ],
                [
                    87.308683,
                    53.2262456
                ],
                [
                    87.3104134,
                    53.2233503
                ],
                [
                    87.3114142,
                    53.2233542
                ],
                [
                    87.3111301,
                    53.2227705
                ],
                [
                    87.3102197,
                    53.2212589
                ],
                [
                    87.310168,
                    53.22117
                ],
                [
                    87.310323,
                    53.2203466
                ],
                [
                    87.3104263,
                    53.2200218
                ],
                [
                    87.3113432,
                    53.2185759
                ],
                [
                    87.3123763,
                    53.216867
                ],
                [
                    87.3140163,
                    53.2140484
                ],
                [
                    87.3141842,
                    53.2140368
                ],
                [
                    87.3153271,
                    53.2141605
                ],
                [
                    87.3158501,
                    53.2142031
                ],
                [
                    87.3162956,
                    53.2145588
                ],
                [
                    87.3159884,
                    53.2152601
                ],
                [
                    87.3161741,
                    53.2153809
                ],
                [
                    87.3167529,
                    53.2159321
                ],
                [
                    87.3175434,
                    53.216869
                ],
                [
                    87.3176234,
                    53.2173904
                ],
                [
                    87.3181128,
                    53.2173525
                ],
                [
                    87.3193342,
                    53.2162382
                ],
                [
                    87.3198444,
                    53.2141808
                ],
                [
                    87.3199999,
                    53.2139646
                ],
                [
                    87.3189708,
                    53.2138559
                ],
                [
                    87.3185197,
                    53.2138643
                ],
                [
                    87.3184205,
                    53.2140004
                ],
                [
                    87.3179494,
                    53.2139757
                ],
                [
                    87.3161187,
                    53.213795
                ],
                [
                    87.3154245,
                    53.2137208
                ],
                [
                    87.3143666,
                    53.2130378
                ],
                [
                    87.3143377,
                    53.2121642
                ],
                [
                    87.3143377,
                    53.2090906
                ],
                [
                    87.3142344,
                    53.2086253
                ],
                [
                    87.3121434,
                    53.2085263
                ],
                [
                    87.3091805,
                    53.2084025
                ],
                [
                    87.3084201,
                    53.2077863
                ],
                [
                    87.3077259,
                    53.2071552
                ],
                [
                    87.307825,
                    53.2067146
                ],
                [
                    87.3088953,
                    53.2065067
                ],
                [
                    87.3095978,
                    53.2063706
                ],
                [
                    87.3103375,
                    53.2062369
                ],
                [
                    87.3111144,
                    53.206128
                ],
                [
                    87.3123335,
                    53.2061454
                ],
                [
                    87.3149369,
                    53.2062369
                ],
                [
                    87.3159989,
                    53.2062889
                ],
                [
                    87.3158873,
                    53.2067146
                ],
                [
                    87.3158253,
                    53.2069596
                ],
                [
                    87.3162138,
                    53.2071428
                ],
                [
                    87.316375,
                    53.2071948
                ],
                [
                    87.3202883,
                    53.2061132
                ],
                [
                    87.3234742,
                    53.2025634
                ],
                [
                    87.3243818,
                    53.2015772
                ],
                [
                    87.3244545,
                    53.2014782
                ],
                [
                    87.3245239,
                    53.2012525
                ],
                [
                    87.3244644,
                    53.2011515
                ],
                [
                    87.3229591,
                    53.1993931
                ],
                [
                    87.3210478,
                    53.1971768
                ],
                [
                    87.3199695,
                    53.1959351
                ],
                [
                    87.3196661,
                    53.1957069
                ],
                [
                    87.3192012,
                    53.1954593
                ],
                [
                    87.3184199,
                    53.1949758
                ],
                [
                    87.3187815,
                    53.194528
                ],
                [
                    87.3188299,
                    53.1943781
                ],
                [
                    87.3184505,
                    53.1938559
                ],
                [
                    87.316683,
                    53.1937689
                ],
                [
                    87.3156983,
                    53.1935803
                ],
                [
                    87.3152786,
                    53.1937108
                ],
                [
                    87.3141083,
                    53.1943975
                ],
                [
                    87.313093,
                    53.1944071
                ],
                [
                    87.312963,
                    53.1943493
                ],
                [
                    87.3128556,
                    53.1941124
                ],
                [
                    87.3126627,
                    53.1936412
                ],
                [
                    87.3122107,
                    53.1934202
                ],
                [
                    87.3120101,
                    53.1932674
                ],
                [
                    87.3119372,
                    53.1929226
                ],
                [
                    87.3117112,
                    53.1928211
                ],
                [
                    87.3120396,
                    53.1922751
                ],
                [
                    87.312018,
                    53.191717
                ],
                [
                    87.3120883,
                    53.1906495
                ],
                [
                    87.3121795,
                    53.1866282
                ],
                [
                    87.3124868,
                    53.1851341
                ],
                [
                    87.3076472,
                    53.1853949
                ],
                [
                    87.3021148,
                    53.1855273
                ],
                [
                    87.2945027,
                    53.1896245
                ],
                [
                    87.2923365,
                    53.1915074
                ],
                [
                    87.2919664,
                    53.1932963
                ],
                [
                    87.2919334,
                    53.1977418
                ],
                [
                    87.2920522,
                    53.1982152
                ],
                [
                    87.2922226,
                    53.198701
                ],
                [
                    87.2924964,
                    53.1991745
                ],
                [
                    87.2927908,
                    53.1996324
                ],
                [
                    87.2921348,
                    53.1999821
                ],
                [
                    87.2913548,
                    53.200112
                ],
                [
                    87.2908021,
                    53.2002141
                ],
                [
                    87.2908228,
                    53.2003348
                ],
                [
                    87.2911844,
                    53.2005669
                ],
                [
                    87.2911792,
                    53.2006783
                ],
                [
                    87.2910449,
                    53.2008299
                ],
                [
                    87.291112,
                    53.2009567
                ],
                [
                    87.2909932,
                    53.2011022
                ],
                [
                    87.2910242,
                    53.2011857
                ],
                [
                    87.2914168,
                    53.2012197
                ],
                [
                    87.2916441,
                    53.2013188
                ],
                [
                    87.2916286,
                    53.2015353
                ],
                [
                    87.2914685,
                    53.2016839
                ],
                [
                    87.2915614,
                    53.2018014
                ],
                [
                    87.2916441,
                    53.2019314
                ],
                [
                    87.2916389,
                    53.2021139
                ],
                [
                    87.2914478,
                    53.2022068
                ],
                [
                    87.2911999,
                    53.2021542
                ],
                [
                    87.2905129,
                    53.2018386
                ],
                [
                    87.2901823,
                    53.2017179
                ],
                [
                    87.2897794,
                    53.2015384
                ],
                [
                    87.2895314,
                    53.2014858
                ],
                [
                    87.2893145,
                    53.2010681
                ],
                [
                    87.2888806,
                    53.2009846
                ],
                [
                    87.2885655,
                    53.2011331
                ],
                [
                    87.288364,
                    53.2011733
                ],
                [
                    87.2882297,
                    53.2010898
                ],
                [
                    87.2883537,
                    53.2009815
                ],
                [
                    87.2881006,
                    53.20057
                ],
                [
                    87.2880592,
                    53.2003008
                ],
                [
                    87.2875065,
                    53.1998676
                ],
                [
                    87.2873619,
                    53.1995241
                ],
                [
                    87.2872121,
                    53.1991342
                ],
                [
                    87.2871656,
                    53.1989764
                ],
                [
                    87.2871553,
                    53.1985834
                ],
                [
                    87.2869125,
                    53.1981843
                ],
                [
                    87.2864218,
                    53.197324
                ],
                [
                    87.2856831,
                    53.1965504
                ],
                [
                    87.2855901,
                    53.1963307
                ],
                [
                    87.2848102,
                    53.1961326
                ],
                [
                    87.2840818,
                    53.1960646
                ],
                [
                    87.2837306,
                    53.1961017
                ],
                [
                    87.2830487,
                    53.196405
                ],
                [
                    87.2825322,
                    53.1966247
                ],
                [
                    87.2827181,
                    53.1970362
                ],
                [
                    87.2827956,
                    53.1971476
                ],
                [
                    87.2826871,
                    53.1972528
                ],
                [
                    87.2828163,
                    53.197584
                ],
                [
                    87.2830281,
                    53.1981162
                ],
                [
                    87.2835549,
                    53.1994127
                ],
                [
                    87.2845209,
                    53.2017488
                ],
                [
                    87.2844331,
                    53.2018324
                ],
                [
                    87.2835911,
                    53.20182
                ],
                [
                    87.2829144,
                    53.2019345
                ],
                [
                    87.282372,
                    53.2012012
                ],
                [
                    87.2821138,
                    53.2012507
                ],
                [
                    87.2818968,
                    53.2013961
                ],
                [
                    87.281933,
                    53.2011795
                ],
                [
                    87.2817883,
                    53.2010248
                ],
                [
                    87.2815766,
                    53.2011548
                ],
                [
                    87.2814991,
                    53.2007216
                ],
                [
                    87.2812201,
                    53.2004833
                ],
                [
                    87.2809774,
                    53.2004276
                ],
                [
                    87.2809669,
                    53.2001623
                ],
                [
                    87.2810599,
                    53.200023
                ],
                [
                    87.2809049,
                    53.1999457
                ],
                [
                    87.281034,
                    53.199859
                ],
                [
                    87.2810805,
                    53.1995372
                ],
                [
                    87.2807551,
                    53.1996827
                ],
                [
                    87.2807293,
                    53.1994908
                ],
                [
                    87.2809049,
                    53.1993732
                ],
                [
                    87.2813698,
                    53.1994073
                ],
                [
                    87.2812768,
                    53.199234
                ],
                [
                    87.2807241,
                    53.1992618
                ],
                [
                    87.2806724,
                    53.1991597
                ],
                [
                    87.2808584,
                    53.1988193
                ],
                [
                    87.2812613,
                    53.1987915
                ],
                [
                    87.2807913,
                    53.198711
                ],
                [
                    87.2807344,
                    53.1986027
                ],
                [
                    87.2803057,
                    53.1988132
                ],
                [
                    87.2804297,
                    53.1988967
                ],
                [
                    87.2802902,
                    53.19907
                ],
                [
                    87.280347,
                    53.1992742
                ],
                [
                    87.2797685,
                    53.1992928
                ],
                [
                    87.2789937,
                    53.1996455
                ],
                [
                    87.2791073,
                    53.1997291
                ],
                [
                    87.2789885,
                    53.1998281
                ],
                [
                    87.2791073,
                    53.1999983
                ],
                [
                    87.278849,
                    53.2000447
                ],
                [
                    87.2788955,
                    53.2001623
                ],
                [
                    87.279097,
                    53.200218
                ],
                [
                    87.2790402,
                    53.2003108
                ],
                [
                    87.2789937,
                    53.200416
                ],
                [
                    87.2787406,
                    53.2001715
                ],
                [
                    87.2783841,
                    53.2001437
                ],
                [
                    87.2782757,
                    53.2000385
                ],
                [
                    87.2779399,
                    53.2000911
                ],
                [
                    87.2780226,
                    53.2002303
                ],
                [
                    87.2776248,
                    53.2002953
                ],
                [
                    87.2775732,
                    53.2003727
                ],
                [
                    87.27763,
                    53.20045
                ],
                [
                    87.2770979,
                    53.2004036
                ],
                [
                    87.2768397,
                    53.2002706
                ],
                [
                    87.2763748,
                    53.1998745
                ],
                [
                    87.2764781,
                    53.1996455
                ],
                [
                    87.2767467,
                    53.1995001
                ],
                [
                    87.2769636,
                    53.199463
                ],
                [
                    87.2770308,
                    53.1993175
                ],
                [
                    87.2774853,
                    53.1990483
                ],
                [
                    87.2774027,
                    53.1988503
                ],
                [
                    87.2772477,
                    53.1987048
                ],
                [
                    87.276819,
                    53.1985501
                ],
                [
                    87.2765142,
                    53.1987946
                ],
                [
                    87.2765969,
                    53.1991319
                ],
                [
                    87.2766072,
                    53.1993144
                ],
                [
                    87.2763593,
                    53.1994444
                ],
                [
                    87.2759977,
                    53.1994908
                ],
                [
                    87.2757497,
                    53.1996424
                ],
                [
                    87.2747993,
                    53.1996331
                ],
                [
                    87.2746805,
                    53.1993856
                ],
                [
                    87.2744377,
                    53.1992309
                ],
                [
                    87.2744377,
                    53.1990947
                ],
                [
                    87.2745978,
                    53.1991195
                ],
                [
                    87.2746805,
                    53.1992649
                ],
                [
                    87.2748613,
                    53.1992742
                ],
                [
                    87.2748613,
                    53.198971
                ],
                [
                    87.274696,
                    53.1988039
                ],
                [
                    87.2741381,
                    53.1984821
                ],
                [
                    87.2738643,
                    53.1986027
                ],
                [
                    87.2739418,
                    53.1986708
                ],
                [
                    87.2737662,
                    53.1988348
                ],
                [
                    87.2733633,
                    53.1988658
                ],
                [
                    87.2732083,
                    53.1987358
                ],
                [
                    87.2733116,
                    53.1985532
                ],
                [
                    87.2731515,
                    53.1983088
                ],
                [
                    87.273105,
                    53.1981757
                ],
                [
                    87.273291,
                    53.1979993
                ],
                [
                    87.2733788,
                    53.1975971
                ],
                [
                    87.2735906,
                    53.1972041
                ],
                [
                    87.2735337,
                    53.1970401
                ],
                [
                    87.2735234,
                    53.196777
                ],
                [
                    87.2738437,
                    53.1966749
                ],
                [
                    87.2735854,
                    53.1964676
                ],
                [
                    87.2733065,
                    53.1961086
                ],
                [
                    87.2724335,
                    53.1960962
                ],
                [
                    87.2716742,
                    53.1958332
                ],
                [
                    87.2686524,
                    53.1948553
                ],
                [
                    87.2690036,
                    53.1941435
                ],
                [
                    87.2690191,
                    53.193506
                ],
                [
                    87.2684819,
                    53.1926333
                ],
                [
                    87.2680842,
                    53.1922372
                ],
                [
                    87.2672783,
                    53.1915625
                ],
                [
                    87.265144,
                    53.1914283
                ],
                [
                    87.2640373,
                    53.1916527
                ],
                [
                    87.2633066,
                    53.1918647
                ],
                [
                    87.2618977,
                    53.1920405
                ],
                [
                    87.2599811,
                    53.1921915
                ],
                [
                    87.2578233,
                    53.1929401
                ],
                [
                    87.2544385,
                    53.1962152
                ],
                [
                    87.2525321,
                    53.1978973
                ],
                [
                    87.2561295,
                    53.199326
                ],
                [
                    87.2575893,
                    53.1998537
                ],
                [
                    87.2586145,
                    53.200272
                ],
                [
                    87.2586468,
                    53.2010987
                ],
                [
                    87.2589212,
                    53.2018674
                ],
                [
                    87.2592602,
                    53.2025539
                ],
                [
                    87.2598494,
                    53.2033323
                ],
                [
                    87.2613748,
                    53.2051113
                ],
                [
                    87.2626177,
                    53.2061264
                ],
                [
                    87.2635065,
                    53.2067478
                ],
                [
                    87.2638686,
                    53.207012
                ],
                [
                    87.2660631,
                    53.2088324
                ],
                [
                    87.2636627,
                    53.2096871
                ],
                [
                    87.2475734,
                    53.2122285
                ],
                [
                    87.2475433,
                    53.2151413
                ]
            ],
            "longitude": 87.276199,
            "latitude": 53.210381
        },
        "5804": {
            "name": "КАЛТАН",
            "population": 21186,
            "type": "town",
            "poly": [
                [
                    87.2633031,
                    53.5074197
                ],
                [
                    87.2634319,
                    53.5145144
                ],
                [
                    87.2657236,
                    53.5146624
                ],
                [
                    87.2677749,
                    53.521812
                ],
                [
                    87.2694743,
                    53.5299807
                ],
                [
                    87.2766871,
                    53.5305635
                ],
                [
                    87.2767063,
                    53.5334847
                ],
                [
                    87.2783823,
                    53.5334816
                ],
                [
                    87.2813168,
                    53.529331
                ],
                [
                    87.2908697,
                    53.5246452
                ],
                [
                    87.2992748,
                    53.5268685
                ],
                [
                    87.3038238,
                    53.5269348
                ],
                [
                    87.3088277,
                    53.5194442
                ],
                [
                    87.3086475,
                    53.5181327
                ],
                [
                    87.3014892,
                    53.5163465
                ],
                [
                    87.2902196,
                    53.5112479
                ],
                [
                    87.282283,
                    53.5018513
                ],
                [
                    87.280472,
                    53.5012181
                ],
                [
                    87.277822,
                    53.4996892
                ],
                [
                    87.277631,
                    53.498557
                ],
                [
                    87.2746097,
                    53.4985366
                ],
                [
                    87.2740111,
                    53.50094
                ],
                [
                    87.2714126,
                    53.5028136
                ],
                [
                    87.2667943,
                    53.503089
                ],
                [
                    87.2668651,
                    53.506506
                ],
                [
                    87.2633031,
                    53.5074197
                ]
            ],
            "longitude": 87.286179,
            "latitude": 53.519459
        },
        "5805": {
            "name": "ОСИННИКИ",
            "population": 43445,
            "type": "town",
            "poly": [
                [
                    87.2928959,
                    53.6267246
                ],
                [
                    87.2967582,
                    53.6326287
                ],
                [
                    87.3088535,
                    53.6327945
                ],
                [
                    87.3228439,
                    53.6299342
                ],
                [
                    87.3302166,
                    53.6314357
                ],
                [
                    87.3494686,
                    53.6390235
                ],
                [
                    87.3687204,
                    53.6406315
                ],
                [
                    87.3802045,
                    53.6365504
                ],
                [
                    87.4108118,
                    53.6472612
                ],
                [
                    87.4352047,
                    53.6501204
                ],
                [
                    87.4378913,
                    53.6423717
                ],
                [
                    87.3850625,
                    53.627318
                ],
                [
                    87.3910793,
                    53.627939
                ],
                [
                    87.3921007,
                    53.6245693
                ],
                [
                    87.3818954,
                    53.6203746
                ],
                [
                    87.3750719,
                    53.6228232
                ],
                [
                    87.3755353,
                    53.6166072
                ],
                [
                    87.3713897,
                    53.6201557
                ],
                [
                    87.366094,
                    53.6158129
                ],
                [
                    87.3603261,
                    53.6152986
                ],
                [
                    87.3506702,
                    53.6108179
                ],
                [
                    87.3535198,
                    53.6062195
                ],
                [
                    87.3630041,
                    53.6072024
                ],
                [
                    87.3655447,
                    53.6014983
                ],
                [
                    87.3523438,
                    53.5991606
                ],
                [
                    87.3531878,
                    53.5917181
                ],
                [
                    87.3485368,
                    53.5876029
                ],
                [
                    87.3471378,
                    53.5862184
                ],
                [
                    87.3449695,
                    53.5856025
                ],
                [
                    87.3427561,
                    53.5882786
                ],
                [
                    87.3392971,
                    53.5887976
                ],
                [
                    87.3307537,
                    53.5871544
                ],
                [
                    87.3257155,
                    53.588652
                ],
                [
                    87.3212824,
                    53.5887683
                ],
                [
                    87.3174435,
                    53.5891937
                ],
                [
                    87.3189906,
                    53.5905182
                ],
                [
                    87.3210269,
                    53.5920415
                ],
                [
                    87.3222092,
                    53.5930399
                ],
                [
                    87.322529,
                    53.5943338
                ],
                [
                    87.3232585,
                    53.5961677
                ],
                [
                    87.3240546,
                    53.5975481
                ],
                [
                    87.323797,
                    53.5988724
                ],
                [
                    87.3234109,
                    53.6004259
                ],
                [
                    87.3219088,
                    53.6026669
                ],
                [
                    87.3211364,
                    53.603991
                ],
                [
                    87.3202351,
                    53.6045767
                ],
                [
                    87.3179177,
                    53.6060281
                ],
                [
                    87.316716,
                    53.6065883
                ],
                [
                    87.3157054,
                    53.6068633
                ],
                [
                    87.3139695,
                    53.6074286
                ],
                [
                    87.3121671,
                    53.608498
                ],
                [
                    87.3101499,
                    53.6097455
                ],
                [
                    87.3087338,
                    53.6108149
                ],
                [
                    87.3077897,
                    53.6119861
                ],
                [
                    87.307103,
                    53.6131572
                ],
                [
                    87.3063306,
                    53.6147102
                ],
                [
                    87.3057298,
                    53.6161613
                ],
                [
                    87.3055152,
                    53.6170777
                ],
                [
                    87.3058156,
                    53.617434
                ],
                [
                    87.3055581,
                    53.6183505
                ],
                [
                    87.3055152,
                    53.6195978
                ],
                [
                    87.3054723,
                    53.6213542
                ],
                [
                    87.3052148,
                    53.6223978
                ],
                [
                    87.3044423,
                    53.6240267
                ],
                [
                    87.3037106,
                    53.6251975
                ],
                [
                    87.302745,
                    53.6262359
                ],
                [
                    87.3012859,
                    53.6269486
                ],
                [
                    87.3015434,
                    53.6274067
                ],
                [
                    87.2997409,
                    53.627712
                ],
                [
                    87.2975952,
                    53.6276612
                ],
                [
                    87.2945267,
                    53.6269791
                ],
                [
                    87.2928959,
                    53.6267246
                ]
            ],
            "longitude": 87.332893,
            "latitude": 53.606995
        },
        "5806": {
            "name": "ТЕМИРТАУ",
            "population": 3950,
            "type": "town",
            "poly": [
                [
                    87.4100923,
                    53.1336568
                ],
                [
                    87.4109666,
                    53.1337237
                ],
                [
                    87.4116525,
                    53.1336935
                ],
                [
                    87.4118801,
                    53.1338588
                ],
                [
                    87.4122992,
                    53.1339234
                ],
                [
                    87.4133099,
                    53.1342829
                ],
                [
                    87.4143537,
                    53.1349656
                ],
                [
                    87.4151856,
                    53.1351704
                ],
                [
                    87.4166767,
                    53.1353469
                ],
                [
                    87.4182558,
                    53.1354096
                ],
                [
                    87.4186299,
                    53.1356565
                ],
                [
                    87.4183306,
                    53.135881
                ],
                [
                    87.4182745,
                    53.1362851
                ],
                [
                    87.4158982,
                    53.1375199
                ],
                [
                    87.414429,
                    53.1381009
                ],
                [
                    87.415971,
                    53.1395983
                ],
                [
                    87.4168241,
                    53.1387004
                ],
                [
                    87.4178571,
                    53.1388261
                ],
                [
                    87.4200725,
                    53.1401282
                ],
                [
                    87.4224675,
                    53.1401192
                ],
                [
                    87.4228267,
                    53.1400474
                ],
                [
                    87.4247727,
                    53.1408555
                ],
                [
                    87.4257157,
                    53.141475
                ],
                [
                    87.4280958,
                    53.1427321
                ],
                [
                    87.4283951,
                    53.1432079
                ],
                [
                    87.4282454,
                    53.1438812
                ],
                [
                    87.4277365,
                    53.1449318
                ],
                [
                    87.4277365,
                    53.1458206
                ],
                [
                    87.4286197,
                    53.14688
                ],
                [
                    87.4296525,
                    53.1473289
                ],
                [
                    87.4304608,
                    53.1474456
                ],
                [
                    87.4312841,
                    53.1472301
                ],
                [
                    87.433275,
                    53.1476072
                ],
                [
                    87.4347719,
                    53.1481458
                ],
                [
                    87.4353845,
                    53.1485147
                ],
                [
                    87.4357774,
                    53.1489636
                ],
                [
                    87.4375176,
                    53.1502428
                ],
                [
                    87.4408107,
                    53.1526217
                ],
                [
                    87.4449084,
                    53.1554941
                ],
                [
                    87.4475654,
                    53.1573453
                ],
                [
                    87.4522472,
                    53.1604818
                ],
                [
                    87.4573694,
                    53.1596404
                ],
                [
                    87.4634504,
                    53.1589953
                ],
                [
                    87.4680815,
                    53.1585185
                ],
                [
                    87.471847,
                    53.1578313
                ],
                [
                    87.4779749,
                    53.1568496
                ],
                [
                    87.4794016,
                    53.1549702
                ],
                [
                    87.4787467,
                    53.1543391
                ],
                [
                    87.474911,
                    53.1516742
                ],
                [
                    87.4756126,
                    53.1509869
                ],
                [
                    87.4761271,
                    53.1506643
                ],
                [
                    87.4784427,
                    53.1507064
                ],
                [
                    87.4786045,
                    53.150593
                ],
                [
                    87.4781854,
                    53.1495966
                ],
                [
                    87.4789488,
                    53.1482769
                ],
                [
                    87.4797721,
                    53.1452424
                ],
                [
                    87.4793679,
                    53.144174
                ],
                [
                    87.4785896,
                    53.1428451
                ],
                [
                    87.4786045,
                    53.1423603
                ],
                [
                    87.4801911,
                    53.1398013
                ],
                [
                    87.4801014,
                    53.1380503
                ],
                [
                    87.4802361,
                    53.1365597
                ],
                [
                    87.480713,
                    53.1359452
                ],
                [
                    87.480644,
                    53.1356417
                ],
                [
                    87.4800309,
                    53.1352647
                ],
                [
                    87.478797,
                    53.135375
                ],
                [
                    87.4781761,
                    53.1352601
                ],
                [
                    87.4719836,
                    53.1341842
                ],
                [
                    87.4731376,
                    53.1292479
                ],
                [
                    87.470563,
                    53.1290827
                ],
                [
                    87.4708384,
                    53.1278038
                ],
                [
                    87.46909,
                    53.1276457
                ],
                [
                    87.466719,
                    53.1276457
                ],
                [
                    87.4660963,
                    53.1277247
                ],
                [
                    87.4649586,
                    53.1271858
                ],
                [
                    87.461905,
                    53.1274517
                ],
                [
                    87.4597854,
                    53.1269128
                ],
                [
                    87.4478618,
                    53.1227265
                ],
                [
                    87.44571,
                    53.1226984
                ],
                [
                    87.4386466,
                    53.1228107
                ],
                [
                    87.4298758,
                    53.122923
                ],
                [
                    87.4192573,
                    53.1230633
                ],
                [
                    87.4167079,
                    53.124509
                ],
                [
                    87.4169886,
                    53.1248458
                ],
                [
                    87.4182983,
                    53.1262633
                ],
                [
                    87.4180176,
                    53.1263616
                ],
                [
                    87.4171289,
                    53.1264598
                ],
                [
                    87.4165675,
                    53.1265895
                ],
                [
                    87.4150408,
                    53.1271733
                ],
                [
                    87.4121518,
                    53.1289607
                ],
                [
                    87.4112087,
                    53.1296702
                ],
                [
                    87.4107147,
                    53.1302809
                ],
                [
                    87.4104004,
                    53.1311252
                ],
                [
                    87.4102208,
                    53.1328405
                ],
                [
                    87.4100923,
                    53.1336568
                ]
            ],
            "longitude": 87.458092,
            "latitude": 53.138775
        },
        "5807": {
            "name": "КАЗ",
            "population": 4281,
            "type": "town",
            "poly": [
                [
                    87.5215535,
                    53.1101534
                ],
                [
                    87.5285575,
                    53.1136753
                ],
                [
                    87.5329503,
                    53.1150949
                ],
                [
                    87.5378961,
                    53.1170494
                ],
                [
                    87.539862,
                    53.11834
                ],
                [
                    87.5415517,
                    53.1199439
                ],
                [
                    87.5438249,
                    53.1217321
                ],
                [
                    87.5446543,
                    53.121935
                ],
                [
                    87.5466511,
                    53.1220456
                ],
                [
                    87.550706,
                    53.1220823
                ],
                [
                    87.5534707,
                    53.1200361
                ],
                [
                    87.5574335,
                    53.1197043
                ],
                [
                    87.5611813,
                    53.1204048
                ],
                [
                    87.5638846,
                    53.1204048
                ],
                [
                    87.5652362,
                    53.1242761
                ],
                [
                    87.5661885,
                    53.1247001
                ],
                [
                    87.5685232,
                    53.1248476
                ],
                [
                    87.5685846,
                    53.1253637
                ],
                [
                    87.5716258,
                    53.125972
                ],
                [
                    87.5720251,
                    53.125714
                ],
                [
                    87.5697212,
                    53.1246633
                ],
                [
                    87.568646,
                    53.124442
                ],
                [
                    87.5687996,
                    53.1240918
                ],
                [
                    87.5679088,
                    53.1237047
                ],
                [
                    87.5673251,
                    53.1240918
                ],
                [
                    87.5665877,
                    53.1238522
                ],
                [
                    87.5658813,
                    53.1222668
                ],
                [
                    87.5653898,
                    53.1206998
                ],
                [
                    87.5657584,
                    53.1200361
                ],
                [
                    87.573684,
                    53.1178237
                ],
                [
                    87.573899,
                    53.1193355
                ],
                [
                    87.5747899,
                    53.1197964
                ],
                [
                    87.5753428,
                    53.1199808
                ],
                [
                    87.5755886,
                    53.1201836
                ],
                [
                    87.5899344,
                    53.1202388
                ],
                [
                    87.5905181,
                    53.1190406
                ],
                [
                    87.5908253,
                    53.1186534
                ],
                [
                    87.591624,
                    53.1191143
                ],
                [
                    87.596109,
                    53.120497
                ],
                [
                    87.5979521,
                    53.1195199
                ],
                [
                    87.5995495,
                    53.1223221
                ],
                [
                    87.6016692,
                    53.1241287
                ],
                [
                    87.6023143,
                    53.1242946
                ],
                [
                    87.6034509,
                    53.1242024
                ],
                [
                    87.6040653,
                    53.124737
                ],
                [
                    87.6055398,
                    53.1243314
                ],
                [
                    87.6051712,
                    53.1232623
                ],
                [
                    87.6103934,
                    53.1221746
                ],
                [
                    87.6133732,
                    53.1256771
                ],
                [
                    87.6179195,
                    53.1254928
                ],
                [
                    87.6175817,
                    53.1219165
                ],
                [
                    87.6183497,
                    53.1218059
                ],
                [
                    87.6215138,
                    53.1216216
                ],
                [
                    87.6258759,
                    53.1210316
                ],
                [
                    87.6267975,
                    53.1169019
                ],
                [
                    87.6270432,
                    53.116441
                ],
                [
                    87.6274426,
                    53.1135831
                ],
                [
                    87.6306067,
                    53.1132512
                ],
                [
                    87.6322953,
                    53.1130445
                ],
                [
                    87.6338415,
                    53.1123871
                ],
                [
                    87.6336804,
                    53.1121503
                ],
                [
                    87.6338657,
                    53.1118989
                ],
                [
                    87.63331,
                    53.1116041
                ],
                [
                    87.6319813,
                    53.1121358
                ],
                [
                    87.6316994,
                    53.1110917
                ],
                [
                    87.6315946,
                    53.1100717
                ],
                [
                    87.6287355,
                    53.109518
                ],
                [
                    87.6242813,
                    53.1087342
                ],
                [
                    87.6223997,
                    53.1081349
                ],
                [
                    87.6207869,
                    53.1073973
                ],
                [
                    87.6197811,
                    53.1069266
                ],
                [
                    87.6176169,
                    53.1056394
                ],
                [
                    87.6158553,
                    53.1045879
                ],
                [
                    87.6145568,
                    53.1041588
                ],
                [
                    87.6134294,
                    53.1038506
                ],
                [
                    87.6125738,
                    53.1038567
                ],
                [
                    87.6109129,
                    53.1048296
                ],
                [
                    87.6075709,
                    53.1064915
                ],
                [
                    87.6051551,
                    53.1077242
                ],
                [
                    87.6047927,
                    53.107839
                ],
                [
                    87.6039774,
                    53.1085823
                ],
                [
                    87.6023467,
                    53.1081049
                ],
                [
                    87.5992967,
                    53.1071985
                ],
                [
                    87.596448,
                    53.1074281
                ],
                [
                    87.5923209,
                    53.1077423
                ],
                [
                    87.5873481,
                    53.1082862
                ],
                [
                    87.5840969,
                    53.1063102
                ],
                [
                    87.5835634,
                    53.1061652
                ],
                [
                    87.5831004,
                    53.1062195
                ],
                [
                    87.5825568,
                    53.1073194
                ],
                [
                    87.5825266,
                    53.1075913
                ],
                [
                    87.5826071,
                    53.1078572
                ],
                [
                    87.5827682,
                    53.1090414
                ],
                [
                    87.5831405,
                    53.1110657
                ],
                [
                    87.5824058,
                    53.1113377
                ],
                [
                    87.5820434,
                    53.1113316
                ],
                [
                    87.5805436,
                    53.1108241
                ],
                [
                    87.577715,
                    53.1114102
                ],
                [
                    87.5754401,
                    53.1119177
                ],
                [
                    87.5754201,
                    53.1139741
                ],
                [
                    87.5719304,
                    53.1140478
                ],
                [
                    87.5691779,
                    53.1140625
                ],
                [
                    87.5676297,
                    53.1138708
                ],
                [
                    87.5654203,
                    53.1136301
                ],
                [
                    87.5642501,
                    53.1135243
                ],
                [
                    87.5653196,
                    53.1122177
                ],
                [
                    87.5634826,
                    53.1117721
                ],
                [
                    87.5618468,
                    53.1128975
                ],
                [
                    87.5561595,
                    53.1116815
                ],
                [
                    87.5557569,
                    53.111115
                ],
                [
                    87.55509,
                    53.1097328
                ],
                [
                    87.55509,
                    53.1081542
                ],
                [
                    87.5544105,
                    53.1073158
                ],
                [
                    87.5544986,
                    53.1070438
                ],
                [
                    87.5555178,
                    53.1059334
                ],
                [
                    87.5554549,
                    53.1048306
                ],
                [
                    87.5552662,
                    53.1033046
                ],
                [
                    87.5536556,
                    53.102179
                ],
                [
                    87.5542595,
                    53.1013706
                ],
                [
                    87.5536429,
                    53.1010534
                ],
                [
                    87.5532278,
                    53.1007739
                ],
                [
                    87.5525861,
                    53.1001771
                ],
                [
                    87.5530642,
                    53.0997691
                ],
                [
                    87.5528377,
                    53.0993914
                ],
                [
                    87.5524602,
                    53.0990363
                ],
                [
                    87.5450113,
                    53.1005246
                ],
                [
                    87.5382168,
                    53.1008645
                ],
                [
                    87.5380154,
                    53.1006455
                ],
                [
                    87.5379022,
                    53.1001695
                ],
                [
                    87.5351466,
                    53.1003206
                ],
                [
                    87.5298116,
                    53.1006227
                ],
                [
                    87.5270686,
                    53.1007437
                ],
                [
                    87.5265359,
                    53.1015718
                ],
                [
                    87.5244471,
                    53.1032539
                ],
                [
                    87.522045,
                    53.1040124
                ],
                [
                    87.5223215,
                    53.1061148
                ],
                [
                    87.5215535,
                    53.1101534
                ]
            ],
            "longitude": 87.554047,
            "latitude": 53.112923
        },
        "5808": {
            "name": "МАРИИНСК",
            "population": 39332,
            "type": "town",
            "poly": [
                [
                    87.6719759,
                    56.17059
                ],
                [
                    87.6759497,
                    56.1719404
                ],
                [
                    87.6780767,
                    56.172692
                ],
                [
                    87.6779717,
                    56.1735058
                ],
                [
                    87.6829948,
                    56.1747832
                ],
                [
                    87.6846325,
                    56.1761554
                ],
                [
                    87.6864108,
                    56.1766761
                ],
                [
                    87.6847562,
                    56.1807221
                ],
                [
                    87.6827868,
                    56.1835175
                ],
                [
                    87.6829914,
                    56.1835771
                ],
                [
                    87.6827868,
                    56.1838184
                ],
                [
                    87.6825919,
                    56.1837723
                ],
                [
                    87.6814062,
                    56.1854641
                ],
                [
                    87.6815035,
                    56.1857946
                ],
                [
                    87.6828374,
                    56.1866344
                ],
                [
                    87.6828179,
                    56.1880701
                ],
                [
                    87.6793909,
                    56.1927128
                ],
                [
                    87.6789917,
                    56.1937745
                ],
                [
                    87.6788456,
                    56.1946358
                ],
                [
                    87.678242,
                    56.1957625
                ],
                [
                    87.6756912,
                    56.1994727
                ],
                [
                    87.6839454,
                    56.2013092
                ],
                [
                    87.6838121,
                    56.2014889
                ],
                [
                    87.6835416,
                    56.2019617
                ],
                [
                    87.6833831,
                    56.2022165
                ],
                [
                    87.6914629,
                    56.2040001
                ],
                [
                    87.6981106,
                    56.2054655
                ],
                [
                    87.6948024,
                    56.2103655
                ],
                [
                    87.6945712,
                    56.2108934
                ],
                [
                    87.6937558,
                    56.2121387
                ],
                [
                    87.6943299,
                    56.2122787
                ],
                [
                    87.694006,
                    56.2130216
                ],
                [
                    87.6925555,
                    56.2143134
                ],
                [
                    87.6925928,
                    56.2173347
                ],
                [
                    87.6934464,
                    56.217844
                ],
                [
                    87.692948,
                    56.218821
                ],
                [
                    87.6928483,
                    56.2194308
                ],
                [
                    87.6932907,
                    56.2194551
                ],
                [
                    87.6934091,
                    56.2203316
                ],
                [
                    87.7023069,
                    56.2220776
                ],
                [
                    87.7056716,
                    56.2176569
                ],
                [
                    87.7095971,
                    56.2184573
                ],
                [
                    87.7159465,
                    56.2195451
                ],
                [
                    87.7148935,
                    56.2217017
                ],
                [
                    87.711384,
                    56.2316734
                ],
                [
                    87.7104182,
                    56.2328639
                ],
                [
                    87.7108714,
                    56.2336266
                ],
                [
                    87.7116871,
                    56.2377195
                ],
                [
                    87.7324619,
                    56.2374455
                ],
                [
                    87.7467192,
                    56.2372553
                ],
                [
                    87.7516252,
                    56.2407493
                ],
                [
                    87.7511081,
                    56.2407871
                ],
                [
                    87.7510999,
                    56.240871
                ],
                [
                    87.7470559,
                    56.2413721
                ],
                [
                    87.7444747,
                    56.2431244
                ],
                [
                    87.7445019,
                    56.2432045
                ],
                [
                    87.7448696,
                    56.2431488
                ],
                [
                    87.7451914,
                    56.2438663
                ],
                [
                    87.7446481,
                    56.2439406
                ],
                [
                    87.7446271,
                    56.2442981
                ],
                [
                    87.744602,
                    56.2449019
                ],
                [
                    87.7446913,
                    56.2454632
                ],
                [
                    87.7467603,
                    56.2469924
                ],
                [
                    87.7509161,
                    56.2468909
                ],
                [
                    87.7516542,
                    56.2493499
                ],
                [
                    87.7563351,
                    56.249198
                ],
                [
                    87.7568322,
                    56.2511814
                ],
                [
                    87.7589999,
                    56.2516765
                ],
                [
                    87.7625027,
                    56.2528789
                ],
                [
                    87.7629076,
                    56.2529913
                ],
                [
                    87.7629141,
                    56.2531346
                ],
                [
                    87.763443,
                    56.2531401
                ],
                [
                    87.7639262,
                    56.2532743
                ],
                [
                    87.7656727,
                    56.2527429
                ],
                [
                    87.7663028,
                    56.2525126
                ],
                [
                    87.7669362,
                    56.2522097
                ],
                [
                    87.7674944,
                    56.2520301
                ],
                [
                    87.7678666,
                    56.2520265
                ],
                [
                    87.768415,
                    56.252197
                ],
                [
                    87.768908,
                    56.2525325
                ],
                [
                    87.7755303,
                    56.2525784
                ],
                [
                    87.7755473,
                    56.2528865
                ],
                [
                    87.77534,
                    56.2539668
                ],
                [
                    87.7755154,
                    56.2573361
                ],
                [
                    87.7759857,
                    56.2623385
                ],
                [
                    87.7747901,
                    56.2624093
                ],
                [
                    87.7747343,
                    56.262967
                ],
                [
                    87.774288,
                    56.262998
                ],
                [
                    87.7743756,
                    56.2637195
                ],
                [
                    87.772415,
                    56.2638125
                ],
                [
                    87.7724309,
                    56.2643392
                ],
                [
                    87.774822,
                    56.2641843
                ],
                [
                    87.7748619,
                    56.2650165
                ],
                [
                    87.7738815,
                    56.2662647
                ],
                [
                    87.7738178,
                    56.2673756
                ],
                [
                    87.7716339,
                    56.2671455
                ],
                [
                    87.7712354,
                    56.2677872
                ],
                [
                    87.7719525,
                    56.2679
                ],
                [
                    87.7722667,
                    56.2680496
                ],
                [
                    87.7729238,
                    56.2681629
                ],
                [
                    87.7729768,
                    56.2680677
                ],
                [
                    87.773797,
                    56.2681946
                ],
                [
                    87.7738694,
                    56.2702934
                ],
                [
                    87.773599,
                    56.2707437
                ],
                [
                    87.7745121,
                    56.2712111
                ],
                [
                    87.7781389,
                    56.2711884
                ],
                [
                    87.781276,
                    56.2709703
                ],
                [
                    87.7803359,
                    56.2664855
                ],
                [
                    87.7793396,
                    56.266543
                ],
                [
                    87.7791244,
                    56.2656578
                ],
                [
                    87.7803438,
                    56.2656046
                ],
                [
                    87.7818501,
                    56.2658215
                ],
                [
                    87.7828863,
                    56.2648035
                ],
                [
                    87.7831652,
                    56.2639935
                ],
                [
                    87.7817546,
                    56.2635066
                ],
                [
                    87.7812365,
                    56.2635641
                ],
                [
                    87.7798397,
                    56.2631789
                ],
                [
                    87.7783604,
                    56.2632391
                ],
                [
                    87.7780573,
                    56.2612668
                ],
                [
                    87.7779457,
                    56.2608905
                ],
                [
                    87.7787746,
                    56.2608861
                ],
                [
                    87.7787347,
                    56.2598059
                ],
                [
                    87.7800259,
                    56.2597528
                ],
                [
                    87.7812693,
                    56.2597484
                ],
                [
                    87.7825286,
                    56.2573489
                ],
                [
                    87.7831901,
                    56.2567424
                ],
                [
                    87.7859558,
                    56.2551663
                ],
                [
                    87.7878607,
                    56.2524344
                ],
                [
                    87.7884903,
                    56.251788
                ],
                [
                    87.7878579,
                    56.2475355
                ],
                [
                    87.7878643,
                    56.2471352
                ],
                [
                    87.7833372,
                    56.2443718
                ],
                [
                    87.7822149,
                    56.2410235
                ],
                [
                    87.7764318,
                    56.2393546
                ],
                [
                    87.7760938,
                    56.2392944
                ],
                [
                    87.776492,
                    56.2360199
                ],
                [
                    87.7811865,
                    56.2334683
                ],
                [
                    87.7862795,
                    56.2331183
                ],
                [
                    87.7885351,
                    56.2331981
                ],
                [
                    87.7894357,
                    56.2321437
                ],
                [
                    87.7883597,
                    56.2313507
                ],
                [
                    87.7837746,
                    56.2212755
                ],
                [
                    87.7832767,
                    56.2208376
                ],
                [
                    87.7867821,
                    56.2207604
                ],
                [
                    87.7860312,
                    56.2200888
                ],
                [
                    87.7872187,
                    56.2195329
                ],
                [
                    87.7875289,
                    56.2186322
                ],
                [
                    87.7912913,
                    56.2169304
                ],
                [
                    87.7931726,
                    56.216413
                ],
                [
                    87.7931522,
                    56.2149539
                ],
                [
                    87.7956333,
                    56.2141324
                ],
                [
                    87.796531,
                    56.2132973
                ],
                [
                    87.7969595,
                    56.212646
                ],
                [
                    87.7968453,
                    56.2117927
                ],
                [
                    87.7957965,
                    56.2106104
                ],
                [
                    87.7939702,
                    56.2091292
                ],
                [
                    87.793939,
                    56.2078362
                ],
                [
                    87.7954496,
                    56.2056755
                ],
                [
                    87.7987346,
                    56.2065371
                ],
                [
                    87.8027975,
                    56.2072541
                ],
                [
                    87.8046601,
                    56.2074346
                ],
                [
                    87.8077762,
                    56.2073851
                ],
                [
                    87.8101588,
                    56.2069747
                ],
                [
                    87.8113768,
                    56.2065791
                ],
                [
                    87.8132261,
                    56.2062132
                ],
                [
                    87.8152575,
                    56.2056643
                ],
                [
                    87.8165644,
                    56.2052094
                ],
                [
                    87.816969,
                    56.2049374
                ],
                [
                    87.8177024,
                    56.2046506
                ],
                [
                    87.8185737,
                    56.2042451
                ],
                [
                    87.8206229,
                    56.2030755
                ],
                [
                    87.821961,
                    56.201713
                ],
                [
                    87.8229745,
                    56.1999722
                ],
                [
                    87.8232901,
                    56.1984167
                ],
                [
                    87.821512,
                    56.1962207
                ],
                [
                    87.8193472,
                    56.1949445
                ],
                [
                    87.8169245,
                    56.194111
                ],
                [
                    87.8129371,
                    56.1961588
                ],
                [
                    87.8081585,
                    56.1989237
                ],
                [
                    87.7994814,
                    56.199307
                ],
                [
                    87.7994102,
                    56.1991759
                ],
                [
                    87.7978411,
                    56.1992724
                ],
                [
                    87.7949986,
                    56.1941002
                ],
                [
                    87.794568,
                    56.1919245
                ],
                [
                    87.793151,
                    56.1898336
                ],
                [
                    87.7931792,
                    56.1897737
                ],
                [
                    87.7939509,
                    56.1896946
                ],
                [
                    87.7939331,
                    56.1894611
                ],
                [
                    87.7932574,
                    56.1894749
                ],
                [
                    87.7931329,
                    56.1892691
                ],
                [
                    87.7925924,
                    56.1886616
                ],
                [
                    87.7923399,
                    56.1878958
                ],
                [
                    87.7927169,
                    56.1874386
                ],
                [
                    87.7928769,
                    56.1874089
                ],
                [
                    87.7930156,
                    56.187494
                ],
                [
                    87.7935775,
                    56.1872506
                ],
                [
                    87.7943491,
                    56.1870725
                ],
                [
                    87.7948684,
                    56.1868509
                ],
                [
                    87.7950177,
                    56.1867104
                ],
                [
                    87.7949893,
                    56.1865936
                ],
                [
                    87.7951315,
                    56.1864947
                ],
                [
                    87.7948079,
                    56.1862512
                ],
                [
                    87.7943669,
                    56.1857684
                ],
                [
                    87.794278,
                    56.1857031
                ],
                [
                    87.7945766,
                    56.1855645
                ],
                [
                    87.794591,
                    56.1853251
                ],
                [
                    87.7959352,
                    56.1853646
                ],
                [
                    87.7958214,
                    56.1851944
                ],
                [
                    87.7948968,
                    56.1851588
                ],
                [
                    87.7947368,
                    56.1848402
                ],
                [
                    87.7942745,
                    56.1846324
                ],
                [
                    87.7932432,
                    56.184484
                ],
                [
                    87.7928698,
                    56.1844068
                ],
                [
                    87.7927595,
                    56.184478
                ],
                [
                    87.7908391,
                    56.1843989
                ],
                [
                    87.7900568,
                    56.1843434
                ],
                [
                    87.7898506,
                    56.1843098
                ],
                [
                    87.7897581,
                    56.1841574
                ],
                [
                    87.7892673,
                    56.1839516
                ],
                [
                    87.7873399,
                    56.1837893
                ],
                [
                    87.7853342,
                    56.1837893
                ],
                [
                    87.7816622,
                    56.1836785
                ],
                [
                    87.7809776,
                    56.1836503
                ],
                [
                    87.7808639,
                    56.1830887
                ],
                [
                    87.7801137,
                    56.1817191
                ],
                [
                    87.7774857,
                    56.1820377
                ],
                [
                    87.7778128,
                    56.1827027
                ],
                [
                    87.778549,
                    56.1841574
                ],
                [
                    87.778965,
                    56.1849411
                ],
                [
                    87.7804017,
                    56.1857961
                ],
                [
                    87.7815966,
                    56.186085
                ],
                [
                    87.781906,
                    56.1861246
                ],
                [
                    87.7819842,
                    56.1863047
                ],
                [
                    87.7814615,
                    56.1866035
                ],
                [
                    87.7805867,
                    56.1862611
                ],
                [
                    87.7801101,
                    56.186176
                ],
                [
                    87.7795767,
                    56.186176
                ],
                [
                    87.7801244,
                    56.1872605
                ],
                [
                    87.7783889,
                    56.1878871
                ],
                [
                    87.774879,
                    56.1880343
                ],
                [
                    87.7682111,
                    56.1895462
                ],
                [
                    87.7571798,
                    56.1880521
                ],
                [
                    87.7556115,
                    56.1880303
                ],
                [
                    87.754253,
                    56.1878601
                ],
                [
                    87.749662,
                    56.186934
                ],
                [
                    87.7444237,
                    56.1849292
                ],
                [
                    87.7434714,
                    56.1837179
                ],
                [
                    87.742293,
                    56.1766381
                ],
                [
                    87.7362239,
                    56.1740628
                ],
                [
                    87.7263385,
                    56.1782362
                ],
                [
                    87.7229913,
                    56.1781531
                ],
                [
                    87.7192105,
                    56.177002
                ],
                [
                    87.7142145,
                    56.1739322
                ],
                [
                    87.7135181,
                    56.1720135
                ],
                [
                    87.7127928,
                    56.1699248
                ],
                [
                    87.7123668,
                    56.1686979
                ],
                [
                    87.7159237,
                    56.1678126
                ],
                [
                    87.7187424,
                    56.1653167
                ],
                [
                    87.7088677,
                    56.1590164
                ],
                [
                    87.7061265,
                    56.156773
                ],
                [
                    87.7019019,
                    56.1542905
                ],
                [
                    87.6975827,
                    56.1542419
                ],
                [
                    87.6945608,
                    56.1548831
                ],
                [
                    87.6937942,
                    56.1551207
                ],
                [
                    87.6907476,
                    56.1557484
                ],
                [
                    87.6884646,
                    56.1572299
                ],
                [
                    87.6878322,
                    56.1575147
                ],
                [
                    87.6872556,
                    56.1583589
                ],
                [
                    87.6868463,
                    56.159229
                ],
                [
                    87.6867255,
                    56.1606946
                ],
                [
                    87.6868092,
                    56.1612591
                ],
                [
                    87.6853306,
                    56.1611555
                ],
                [
                    87.6778664,
                    56.1664288
                ],
                [
                    87.6719759,
                    56.17059
                ]
            ],
            "longitude": 87.751259,
            "latitude": 56.206299
        },
        "5809": {
            "name": "МЫСКИ",
            "population": 41938,
            "type": "town",
            "poly": [
                [
                    87.7728057,
                    53.702154
                ],
                [
                    87.7766184,
                    53.7069544
                ],
                [
                    87.7904771,
                    53.7141898
                ],
                [
                    87.7955001,
                    53.7178428
                ],
                [
                    87.8053949,
                    53.7243244
                ],
                [
                    87.8099338,
                    53.7315926
                ],
                [
                    87.8163185,
                    53.7303753
                ],
                [
                    87.8144424,
                    53.7211016
                ],
                [
                    87.8195865,
                    53.7085305
                ],
                [
                    87.8265461,
                    53.6929099
                ],
                [
                    87.8241859,
                    53.6927308
                ],
                [
                    87.8160764,
                    53.6971739
                ],
                [
                    87.8082695,
                    53.7094977
                ],
                [
                    87.8002206,
                    53.7070619
                ],
                [
                    87.7905981,
                    53.7001119
                ],
                [
                    87.7799469,
                    53.6972814
                ],
                [
                    87.7728057,
                    53.702154
                ]
            ],
            "longitude": 87.800316,
            "latitude": 53.71386
        },
        "5810": {
            "name": "ТАШТАГОЛ",
            "population": 23079,
            "type": "town",
            "poly": [
                [
                    87.8131209,
                    52.765191
                ],
                [
                    87.8133203,
                    52.7659517
                ],
                [
                    87.8141434,
                    52.7664075
                ],
                [
                    87.815098,
                    52.7666925
                ],
                [
                    87.8155871,
                    52.7668806
                ],
                [
                    87.8158094,
                    52.7672759
                ],
                [
                    87.8159636,
                    52.7702213
                ],
                [
                    87.8162547,
                    52.7721582
                ],
                [
                    87.8169426,
                    52.773935
                ],
                [
                    87.8178422,
                    52.7756315
                ],
                [
                    87.8191915,
                    52.7772481
                ],
                [
                    87.8205938,
                    52.7787366
                ],
                [
                    87.8221284,
                    52.7797928
                ],
                [
                    87.8264676,
                    52.7797928
                ],
                [
                    87.827163,
                    52.7799465
                ],
                [
                    87.8270053,
                    52.7933947
                ],
                [
                    87.8303171,
                    52.7966368
                ],
                [
                    87.8317364,
                    52.7987346
                ],
                [
                    87.835679,
                    52.8022623
                ],
                [
                    87.8391484,
                    52.80579
                ],
                [
                    87.8429334,
                    52.8127489
                ],
                [
                    87.844377,
                    52.8130061
                ],
                [
                    87.8463249,
                    52.8143397
                ],
                [
                    87.8478222,
                    52.8154177
                ],
                [
                    87.853815,
                    52.8249481
                ],
                [
                    87.8535071,
                    52.8257448
                ],
                [
                    87.855834,
                    52.8271381
                ],
                [
                    87.855834,
                    52.8276844
                ],
                [
                    87.8595805,
                    52.8293237
                ],
                [
                    87.8612064,
                    52.8318005
                ],
                [
                    87.8625732,
                    52.833494
                ],
                [
                    87.8620925,
                    52.8373855
                ],
                [
                    87.8630342,
                    52.8385263
                ],
                [
                    87.8639621,
                    52.8393678
                ],
                [
                    87.8654515,
                    52.840351
                ],
                [
                    87.8662468,
                    52.8410189
                ],
                [
                    87.8672254,
                    52.8415319
                ],
                [
                    87.868242,
                    52.8419741
                ],
                [
                    87.8695007,
                    52.8421002
                ],
                [
                    87.8724795,
                    52.8443775
                ],
                [
                    87.873383,
                    52.8450559
                ],
                [
                    87.8750632,
                    52.8458756
                ],
                [
                    87.8772484,
                    52.8470717
                ],
                [
                    87.8789907,
                    52.8485285
                ],
                [
                    87.8806961,
                    52.8500889
                ],
                [
                    87.8817653,
                    52.8506981
                ],
                [
                    87.883067,
                    52.8513002
                ],
                [
                    87.8851919,
                    52.852367
                ],
                [
                    87.8860027,
                    52.8528611
                ],
                [
                    87.8866396,
                    52.8532569
                ],
                [
                    87.8879413,
                    52.8544387
                ],
                [
                    87.8891931,
                    52.8555967
                ],
                [
                    87.8898575,
                    52.8561594
                ],
                [
                    87.8888093,
                    52.8571412
                ],
                [
                    87.8905262,
                    52.8583351
                ],
                [
                    87.8922199,
                    52.8593877
                ],
                [
                    87.8950307,
                    52.8610659
                ],
                [
                    87.9002378,
                    52.8640035
                ],
                [
                    87.9025089,
                    52.8653689
                ],
                [
                    87.9048806,
                    52.8666569
                ],
                [
                    87.9054076,
                    52.8664277
                ],
                [
                    87.9063904,
                    52.8669166
                ],
                [
                    87.9073186,
                    52.8674755
                ],
                [
                    87.9086586,
                    52.8679181
                ],
                [
                    87.9109268,
                    52.8686222
                ],
                [
                    87.914186,
                    52.8695836
                ],
                [
                    87.919652,
                    52.8728752
                ],
                [
                    87.922237,
                    52.8744409
                ],
                [
                    87.9245009,
                    52.8757138
                ],
                [
                    87.9286518,
                    52.8766695
                ],
                [
                    87.9316615,
                    52.877721
                ],
                [
                    87.9338711,
                    52.8783849
                ],
                [
                    87.9353181,
                    52.8790086
                ],
                [
                    87.9361583,
                    52.8785416
                ],
                [
                    87.9371184,
                    52.8779566
                ],
                [
                    87.9377554,
                    52.8775442
                ],
                [
                    87.9381214,
                    52.8771062
                ],
                [
                    87.9374323,
                    52.8765805
                ],
                [
                    87.936463,
                    52.8759899
                ],
                [
                    87.9348309,
                    52.8750021
                ],
                [
                    87.9338849,
                    52.8742358
                ],
                [
                    87.9331976,
                    52.8728903
                ],
                [
                    87.9335366,
                    52.8726021
                ],
                [
                    87.9352226,
                    52.8718069
                ],
                [
                    87.9348567,
                    52.8714097
                ],
                [
                    87.9338966,
                    52.8706518
                ],
                [
                    87.9328903,
                    52.8698383
                ],
                [
                    87.9325767,
                    52.8694751
                ],
                [
                    87.9322328,
                    52.8687405
                ],
                [
                    87.9354829,
                    52.8682836
                ],
                [
                    87.9400097,
                    52.8675036
                ],
                [
                    87.9422759,
                    52.8669286
                ],
                [
                    87.944878,
                    52.8659435
                ],
                [
                    87.945945,
                    52.8656397
                ],
                [
                    87.9493966,
                    52.8659541
                ],
                [
                    87.9513941,
                    52.8662415
                ],
                [
                    87.9516675,
                    52.8661491
                ],
                [
                    87.9520275,
                    52.8658537
                ],
                [
                    87.9531084,
                    52.8648113
                ],
                [
                    87.9537699,
                    52.8646037
                ],
                [
                    87.9546694,
                    52.865003
                ],
                [
                    87.9547224,
                    52.8665683
                ],
                [
                    87.9555726,
                    52.8661491
                ],
                [
                    87.9565295,
                    52.8653841
                ],
                [
                    87.9581089,
                    52.8639168
                ],
                [
                    87.9613105,
                    52.8634217
                ],
                [
                    87.9652792,
                    52.8627348
                ],
                [
                    87.9663111,
                    52.8625112
                ],
                [
                    87.9675553,
                    52.861763
                ],
                [
                    87.9681553,
                    52.8613951
                ],
                [
                    87.9692744,
                    52.8609457
                ],
                [
                    87.9697772,
                    52.8607381
                ],
                [
                    87.9701125,
                    52.8597397
                ],
                [
                    87.9704651,
                    52.8591566
                ],
                [
                    87.9691247,
                    52.8582236
                ],
                [
                    87.9678191,
                    52.8574313
                ],
                [
                    87.9616544,
                    52.8550988
                ],
                [
                    87.9554103,
                    52.8533094
                ],
                [
                    87.952738,
                    52.8529099
                ],
                [
                    87.949854,
                    52.8525105
                ],
                [
                    87.9475522,
                    52.852175
                ],
                [
                    87.9458588,
                    52.8523507
                ],
                [
                    87.9427103,
                    52.8527182
                ],
                [
                    87.9398417,
                    52.8531407
                ],
                [
                    87.9376303,
                    52.853549
                ],
                [
                    87.9355135,
                    52.8542999
                ],
                [
                    87.9344553,
                    52.8541402
                ],
                [
                    87.9326296,
                    52.8545396
                ],
                [
                    87.9313595,
                    52.8547313
                ],
                [
                    87.9306982,
                    52.8546035
                ],
                [
                    87.9290407,
                    52.8538255
                ],
                [
                    87.9265178,
                    52.8529738
                ],
                [
                    87.9257505,
                    52.8529579
                ],
                [
                    87.9250096,
                    52.8531176
                ],
                [
                    87.9229724,
                    52.8531336
                ],
                [
                    87.9222051,
                    52.8533094
                ],
                [
                    87.9209086,
                    52.8533253
                ],
                [
                    87.9201942,
                    52.8535011
                ],
                [
                    87.9178924,
                    52.8535011
                ],
                [
                    87.9172838,
                    52.8537407
                ],
                [
                    87.9153788,
                    52.8537727
                ],
                [
                    87.9147174,
                    52.8539164
                ],
                [
                    87.9106022,
                    52.8539173
                ],
                [
                    87.9087406,
                    52.8531596
                ],
                [
                    87.9063158,
                    52.852848
                ],
                [
                    87.9042129,
                    52.8530792
                ],
                [
                    87.9032372,
                    52.8532808
                ],
                [
                    87.902451,
                    52.8534552
                ],
                [
                    87.9003868,
                    52.8536496
                ],
                [
                    87.8983505,
                    52.8533345
                ],
                [
                    87.8976513,
                    52.8531637
                ],
                [
                    87.8964861,
                    52.8524433
                ],
                [
                    87.8951932,
                    52.851542
                ],
                [
                    87.8941057,
                    52.8508316
                ],
                [
                    87.8929405,
                    52.8504195
                ],
                [
                    87.8919084,
                    52.8502117
                ],
                [
                    87.8903104,
                    52.8498029
                ],
                [
                    87.8879965,
                    52.8492131
                ],
                [
                    87.8872475,
                    52.8490724
                ],
                [
                    87.8865983,
                    52.8486502
                ],
                [
                    87.8858159,
                    52.8479096
                ],
                [
                    87.884967,
                    52.8472126
                ],
                [
                    87.8845064,
                    52.8468439
                ],
                [
                    87.8827197,
                    52.8453996
                ],
                [
                    87.881549,
                    52.8444277
                ],
                [
                    87.8806278,
                    52.8437407
                ],
                [
                    87.8796624,
                    52.8430436
                ],
                [
                    87.8786692,
                    52.8427721
                ],
                [
                    87.8781142,
                    52.8425543
                ],
                [
                    87.877737,
                    52.8422292
                ],
                [
                    87.8764829,
                    52.84115
                ],
                [
                    87.8757505,
                    52.8401311
                ],
                [
                    87.874835,
                    52.8391893
                ],
                [
                    87.8712988,
                    52.8347408
                ],
                [
                    87.8707697,
                    52.8338841
                ],
                [
                    87.8707697,
                    52.8334621
                ],
                [
                    87.872463,
                    52.8315823
                ],
                [
                    87.87259,
                    52.8312754
                ],
                [
                    87.8725477,
                    52.8303163
                ],
                [
                    87.8716375,
                    52.8289607
                ],
                [
                    87.8712776,
                    52.8286282
                ],
                [
                    87.8705368,
                    52.8283468
                ],
                [
                    87.8695208,
                    52.8281678
                ],
                [
                    87.8677428,
                    52.8281806
                ],
                [
                    87.8664291,
                    52.8278693
                ],
                [
                    87.864992,
                    52.8277989
                ],
                [
                    87.8634952,
                    52.8271022
                ],
                [
                    87.86142,
                    52.8260125
                ],
                [
                    87.8601493,
                    52.8253721
                ],
                [
                    87.8596111,
                    52.8252246
                ],
                [
                    87.8589009,
                    52.8245004
                ],
                [
                    87.8587122,
                    52.8241853
                ],
                [
                    87.8587067,
                    52.8236823
                ],
                [
                    87.8594724,
                    52.8228038
                ],
                [
                    87.8607763,
                    52.8210938
                ],
                [
                    87.8610649,
                    52.8204835
                ],
                [
                    87.8617584,
                    52.8204768
                ],
                [
                    87.862735,
                    52.8208088
                ],
                [
                    87.8631333,
                    52.8209069
                ],
                [
                    87.864234,
                    52.8206204
                ],
                [
                    87.8656395,
                    52.8202111
                ],
                [
                    87.8663662,
                    52.8199708
                ],
                [
                    87.8670619,
                    52.8195868
                ],
                [
                    87.8688737,
                    52.8185533
                ],
                [
                    87.8703469,
                    52.8178574
                ],
                [
                    87.8737844,
                    52.8163735
                ],
                [
                    87.8779839,
                    52.8145722
                ],
                [
                    87.8833009,
                    52.8121671
                ],
                [
                    87.8864336,
                    52.8107137
                ],
                [
                    87.8894477,
                    52.8092704
                ],
                [
                    87.8943584,
                    52.8070288
                ],
                [
                    87.8978805,
                    52.8051146
                ],
                [
                    87.8984055,
                    52.8047051
                ],
                [
                    87.8990659,
                    52.8040192
                ],
                [
                    87.903367,
                    52.8025042
                ],
                [
                    87.9071431,
                    52.8010914
                ],
                [
                    87.9109023,
                    52.7998117
                ],
                [
                    87.9194028,
                    52.7968323
                ],
                [
                    87.9259899,
                    52.7944159
                ],
                [
                    87.9397736,
                    52.7895111
                ],
                [
                    87.9428216,
                    52.7883949
                ],
                [
                    87.9435328,
                    52.7883437
                ],
                [
                    87.9439223,
                    52.7888455
                ],
                [
                    87.9443456,
                    52.7888045
                ],
                [
                    87.945023,
                    52.7883846
                ],
                [
                    87.9458696,
                    52.7880262
                ],
                [
                    87.9467671,
                    52.7872581
                ],
                [
                    87.9473767,
                    52.7868383
                ],
                [
                    87.951627,
                    52.7855889
                ],
                [
                    87.9601952,
                    52.7830694
                ],
                [
                    87.9620748,
                    52.7821169
                ],
                [
                    87.9656647,
                    52.7805908
                ],
                [
                    87.9698642,
                    52.7794128
                ],
                [
                    87.9736233,
                    52.7782861
                ],
                [
                    87.9750288,
                    52.777938
                ],
                [
                    87.9753675,
                    52.7781633
                ],
                [
                    87.9746732,
                    52.7797202
                ],
                [
                    87.9746055,
                    52.7803757
                ],
                [
                    87.9764174,
                    52.7824242
                ],
                [
                    87.977518,
                    52.7820452
                ],
                [
                    87.9784494,
                    52.7816663
                ],
                [
                    87.9796008,
                    52.7807035
                ],
                [
                    87.9821408,
                    52.7792388
                ],
                [
                    87.9828012,
                    52.7779277
                ],
                [
                    87.9803967,
                    52.7764424
                ],
                [
                    87.9796008,
                    52.7767088
                ],
                [
                    87.9789066,
                    52.7758995
                ],
                [
                    87.9778736,
                    52.7743937
                ],
                [
                    87.9763158,
                    52.7696915
                ],
                [
                    87.9746394,
                    52.7678269
                ],
                [
                    87.9744023,
                    52.7658802
                ],
                [
                    87.9745039,
                    52.7654805
                ],
                [
                    87.9769931,
                    52.7646712
                ],
                [
                    87.9792452,
                    52.7660749
                ],
                [
                    87.9820054,
                    52.7673248
                ],
                [
                    87.9835463,
                    52.7666179
                ],
                [
                    87.9835294,
                    52.766331
                ],
                [
                    87.9798718,
                    52.7640154
                ],
                [
                    87.9766036,
                    52.7619661
                ],
                [
                    87.9764174,
                    52.7612693
                ],
                [
                    87.9750119,
                    52.7610848
                ],
                [
                    87.9720655,
                    52.759435
                ],
                [
                    87.9700335,
                    52.7588509
                ],
                [
                    87.9692385,
                    52.7587892
                ],
                [
                    87.9687101,
                    52.7589868
                ],
                [
                    87.9683571,
                    52.7591891
                ],
                [
                    87.9685602,
                    52.7607057
                ],
                [
                    87.9677814,
                    52.7611155
                ],
                [
                    87.9665114,
                    52.7615972
                ],
                [
                    87.96431,
                    52.76296
                ],
                [
                    87.9600428,
                    52.7655523
                ],
                [
                    87.9591961,
                    52.7655626
                ],
                [
                    87.9584172,
                    52.7637592
                ],
                [
                    87.9582818,
                    52.7635133
                ],
                [
                    87.9576043,
                    52.7629395
                ],
                [
                    87.9530663,
                    52.7592608
                ],
                [
                    87.9488499,
                    52.7559815
                ],
                [
                    87.9477662,
                    52.7559405
                ],
                [
                    87.9454971,
                    52.7545467
                ],
                [
                    87.9420088,
                    52.7528557
                ],
                [
                    87.9393164,
                    52.7514106
                ],
                [
                    87.9352016,
                    52.7491557
                ],
                [
                    87.9353371,
                    52.7454449
                ],
                [
                    87.9332711,
                    52.7448608
                ],
                [
                    87.9311376,
                    52.7443072
                ],
                [
                    87.929275,
                    52.7437536
                ],
                [
                    87.928005,
                    52.7420212
                ],
                [
                    87.9266672,
                    52.7401861
                ],
                [
                    87.9253634,
                    52.7384125
                ],
                [
                    87.9240255,
                    52.7369976
                ],
                [
                    87.9224678,
                    52.7354905
                ],
                [
                    87.9212146,
                    52.7343831
                ],
                [
                    87.918336,
                    52.7341781
                ],
                [
                    87.914543,
                    52.7339012
                ],
                [
                    87.9118505,
                    52.7337064
                ],
                [
                    87.9089042,
                    52.7334911
                ],
                [
                    87.9006914,
                    52.7332963
                ],
                [
                    87.8985071,
                    52.732722
                ],
                [
                    87.9009963,
                    52.7323324
                ],
                [
                    87.9005729,
                    52.7315326
                ],
                [
                    87.9009624,
                    52.7310199
                ],
                [
                    87.9000988,
                    52.7303738
                ],
                [
                    87.8995061,
                    52.7304457
                ],
                [
                    87.8976096,
                    52.7316659
                ],
                [
                    87.8934271,
                    52.7316351
                ],
                [
                    87.8891768,
                    52.7302919
                ],
                [
                    87.8854176,
                    52.7281588
                ],
                [
                    87.8845709,
                    52.7280461
                ],
                [
                    87.8839444,
                    52.7274717
                ],
                [
                    87.883284,
                    52.7275026
                ],
                [
                    87.8827929,
                    52.7271129
                ],
                [
                    87.8816753,
                    52.7273488
                ],
                [
                    87.8797111,
                    52.7268976
                ],
                [
                    87.8764768,
                    52.7248157
                ],
                [
                    87.8737167,
                    52.7244875
                ],
                [
                    87.8730224,
                    52.7240773
                ],
                [
                    87.873378,
                    52.723585
                ],
                [
                    87.8725991,
                    52.7234312
                ],
                [
                    87.8716169,
                    52.7236568
                ],
                [
                    87.8707533,
                    52.7244465
                ],
                [
                    87.8676207,
                    52.7257695
                ],
                [
                    87.8671635,
                    52.7270616
                ],
                [
                    87.8675699,
                    52.7280666
                ],
                [
                    87.8651484,
                    52.7291535
                ],
                [
                    87.8575284,
                    52.7324452
                ],
                [
                    87.8546497,
                    52.7326298
                ],
                [
                    87.8523129,
                    52.7326298
                ],
                [
                    87.8499423,
                    52.7335731
                ],
                [
                    87.8466572,
                    52.7354802
                ],
                [
                    87.8419497,
                    52.7381254
                ],
                [
                    87.8405273,
                    52.7389968
                ],
                [
                    87.8389186,
                    52.7405347
                ],
                [
                    87.8366327,
                    52.742667
                ],
                [
                    87.8350555,
                    52.7441936
                ],
                [
                    87.8330936,
                    52.7459575
                ],
                [
                    87.8295376,
                    52.7490634
                ],
                [
                    87.8275903,
                    52.7507648
                ],
                [
                    87.8263203,
                    52.7530607
                ],
                [
                    87.8240342,
                    52.7545467
                ],
                [
                    87.8223917,
                    52.7567091
                ],
                [
                    87.8204952,
                    52.7604495
                ],
                [
                    87.8195131,
                    52.76213
                ],
                [
                    87.8178536,
                    52.7633904
                ],
                [
                    87.817244,
                    52.763831
                ],
                [
                    87.8164312,
                    52.7640461
                ],
                [
                    87.8152624,
                    52.7644041
                ],
                [
                    87.8131209,
                    52.765191
                ]
            ],
            "longitude": 87.848267,
            "latitude": 52.759403
        },
        "5811": {
            "name": "ШЕРЕГЕШ",
            "population": 10101,
            "type": "town",
            "poly": [
                [
                    87.9567231,
                    52.9037843
                ],
                [
                    87.9616951,
                    52.9064112
                ],
                [
                    87.9644595,
                    52.9079705
                ],
                [
                    87.9634452,
                    52.9154543
                ],
                [
                    87.962769,
                    52.9199512
                ],
                [
                    87.9621127,
                    52.9244117
                ],
                [
                    87.961536,
                    52.9285
                ],
                [
                    87.9616951,
                    52.9294231
                ],
                [
                    87.9619934,
                    52.9310056
                ],
                [
                    87.9632264,
                    52.9368913
                ],
                [
                    87.9649169,
                    52.9381618
                ],
                [
                    87.9659312,
                    52.9389409
                ],
                [
                    87.9662892,
                    52.9393604
                ],
                [
                    87.9666074,
                    52.9394683
                ],
                [
                    87.9678603,
                    52.9403672
                ],
                [
                    87.9683575,
                    52.9422249
                ],
                [
                    87.9691729,
                    52.9449453
                ],
                [
                    87.9692043,
                    52.945299
                ],
                [
                    87.969088,
                    52.9456841
                ],
                [
                    87.9691933,
                    52.9456917
                ],
                [
                    87.9691342,
                    52.9459023
                ],
                [
                    87.9690704,
                    52.9459415
                ],
                [
                    87.9684565,
                    52.9463989
                ],
                [
                    87.9690011,
                    52.9466989
                ],
                [
                    87.9697497,
                    52.9461437
                ],
                [
                    87.9704788,
                    52.9461183
                ],
                [
                    87.9707649,
                    52.9456623
                ],
                [
                    87.9717393,
                    52.9458224
                ],
                [
                    87.9715347,
                    52.9458769
                ],
                [
                    87.9714381,
                    52.945968
                ],
                [
                    87.9716189,
                    52.9461919
                ],
                [
                    87.9718211,
                    52.9461028
                ],
                [
                    87.9722497,
                    52.9464476
                ],
                [
                    87.9723221,
                    52.9464199
                ],
                [
                    87.9733778,
                    52.9475301
                ],
                [
                    87.9701646,
                    52.9504136
                ],
                [
                    87.9704986,
                    52.9509365
                ],
                [
                    87.972606,
                    52.9513634
                ],
                [
                    87.9750091,
                    52.9494247
                ],
                [
                    87.980304,
                    52.9462649
                ],
                [
                    87.9829821,
                    52.9483265
                ],
                [
                    87.9853241,
                    52.9468908
                ],
                [
                    87.9851408,
                    52.9464858
                ],
                [
                    87.9822285,
                    52.943651
                ],
                [
                    87.9947734,
                    52.9404295
                ],
                [
                    87.9972683,
                    52.9412518
                ],
                [
                    87.9976858,
                    52.9411781
                ],
                [
                    87.9977422,
                    52.9403308
                ],
                [
                    87.9974651,
                    52.9395748
                ],
                [
                    87.996227,
                    52.9358239
                ],
                [
                    87.9963818,
                    52.9356521
                ],
                [
                    87.9978562,
                    52.9349107
                ],
                [
                    87.9978644,
                    52.9344737
                ],
                [
                    87.996838,
                    52.9325734
                ],
                [
                    87.9958848,
                    52.931675
                ],
                [
                    87.9945785,
                    52.9305005
                ],
                [
                    87.9955968,
                    52.9305864
                ],
                [
                    88.0002095,
                    52.9310775
                ],
                [
                    88.0008612,
                    52.9310652
                ],
                [
                    88.0063497,
                    52.9306724
                ],
                [
                    88.0112679,
                    52.9276033
                ],
                [
                    88.0101375,
                    52.9255838
                ],
                [
                    88.0114817,
                    52.9230238
                ],
                [
                    88.0138645,
                    52.9196534
                ],
                [
                    88.0148853,
                    52.919856
                ],
                [
                    88.0204552,
                    52.9213233
                ],
                [
                    88.0208625,
                    52.9211821
                ],
                [
                    88.0251087,
                    52.9186834
                ],
                [
                    88.0271044,
                    52.9182475
                ],
                [
                    88.0275729,
                    52.9180265
                ],
                [
                    88.0291103,
                    52.9177379
                ],
                [
                    88.0294363,
                    52.9170687
                ],
                [
                    88.0283874,
                    52.916117
                ],
                [
                    88.0275932,
                    52.9154231
                ],
                [
                    88.0269143,
                    52.9150017
                ],
                [
                    88.0268521,
                    52.9124345
                ],
                [
                    88.0252362,
                    52.9106167
                ],
                [
                    88.01147,
                    52.9092861
                ],
                [
                    88.0055969,
                    52.9086489
                ],
                [
                    88.0013707,
                    52.9080305
                ],
                [
                    87.9976106,
                    52.9076932
                ],
                [
                    87.9913024,
                    52.9070747
                ],
                [
                    87.9822906,
                    52.9065687
                ],
                [
                    87.9777536,
                    52.9056691
                ],
                [
                    87.9758014,
                    52.9076926
                ],
                [
                    87.9753829,
                    52.9071448
                ],
                [
                    87.9744149,
                    52.9063367
                ],
                [
                    87.9733355,
                    52.9053479
                ],
                [
                    87.9723047,
                    52.9044975
                ],
                [
                    87.9696197,
                    52.9022649
                ],
                [
                    87.9689733,
                    52.9018214
                ],
                [
                    87.9674561,
                    52.9007963
                ],
                [
                    87.9667054,
                    52.9001799
                ],
                [
                    87.9660798,
                    52.8996987
                ],
                [
                    87.9600046,
                    52.9019609
                ],
                [
                    87.9567231,
                    52.9037843
                ]
            ],
            "longitude": 87.977333,
            "latitude": 52.926311
        },
        "5812": {
            "name": "ТИСУЛЬ",
            "population": 8010,
            "type": "town",
            "poly": null,
            "longitude": 88.3130216,
            "latitude": 55.763851
        },
        "5813": {
            "name": "ТЯЖИНСКИЙ",
            "population": 10313,
            "type": "town",
            "poly": null,
            "longitude": 88.517235,
            "latitude": 56.113953
        },
        "5814": {
            "name": "КОПЬЁВО",
            "population": 4401,
            "type": "town",
            "poly": null,
            "longitude": 89.826622,
            "latitude": 54.992966
        },
        "5815": {
            "name": "ТАШТЫП",
            "population": 6423,
            "type": "town",
            "poly": null,
            "longitude": 89.891724,
            "latitude": 52.79586
        },
        "5816": {
            "name": "ШИРА",
            "population": 9448,
            "type": "town",
            "poly": null,
            "longitude": 89.962891,
            "latitude": 54.48764
        },
        "5817": {
            "name": "АБАЗА",
            "population": 16009,
            "type": "town",
            "poly": null,
            "longitude": 90.101159,
            "latitude": 52.6510546
        },
        "5818": {
            "name": "СОРСК",
            "population": 11485,
            "type": "town",
            "poly": null,
            "longitude": 90.246948,
            "latitude": 53.995647
        },
        "5819": {
            "name": "АСКИЗ",
            "population": 4808,
            "type": "town",
            "poly": [
                [
                    90.3924267,
                    53.1418157
                ],
                [
                    90.3935945,
                    53.148496
                ],
                [
                    90.4216941,
                    53.1466111
                ],
                [
                    90.4237277,
                    53.1443935
                ],
                [
                    90.4465138,
                    53.1427385
                ],
                [
                    90.4531214,
                    53.1401798
                ],
                [
                    90.4590371,
                    53.1421757
                ],
                [
                    90.4577867,
                    53.1341767
                ],
                [
                    90.4539959,
                    53.1314318
                ],
                [
                    90.4585057,
                    53.1261699
                ],
                [
                    90.4303355,
                    53.1282485
                ],
                [
                    90.4149106,
                    53.1290329
                ],
                [
                    90.4098125,
                    53.1277779
                ],
                [
                    90.3953025,
                    53.1284446
                ],
                [
                    90.3972634,
                    53.1415805
                ],
                [
                    90.3924267,
                    53.1418157
                ]
            ],
            "longitude": 90.436188,
            "latitude": 53.135597
        },
        "5820": {
            "name": "АСКИЗ",
            "population": 7267,
            "type": "town",
            "poly": null,
            "longitude": 90.530022,
            "latitude": 53.132652
        },
        "5821": {
            "name": "БОГРАД",
            "population": 4670,
            "type": "town",
            "poly": null,
            "longitude": 90.856026,
            "latitude": 54.21806
        },
        "5822": {
            "name": "БЕЯ",
            "population": 5247,
            "type": "town",
            "poly": null,
            "longitude": 90.921989,
            "latitude": 53.046246
        },
        "5823": {
            "name": "ЧЕРНОГОРСК",
            "population": 73825,
            "type": "town",
            "poly": [
                [
                    91.1933203,
                    53.8103906
                ],
                [
                    91.1970926,
                    53.8165721
                ],
                [
                    91.2078652,
                    53.8213417
                ],
                [
                    91.2414615,
                    53.8261646
                ],
                [
                    91.2569824,
                    53.8309062
                ],
                [
                    91.2469664,
                    53.8438453
                ],
                [
                    91.2530703,
                    53.8459084
                ],
                [
                    91.2660327,
                    53.836885
                ],
                [
                    91.2785562,
                    53.8428791
                ],
                [
                    91.293667,
                    53.8487361
                ],
                [
                    91.3002649,
                    53.8534371
                ],
                [
                    91.3329109,
                    53.8439498
                ],
                [
                    91.3443754,
                    53.8411932
                ],
                [
                    91.3695192,
                    53.8131712
                ],
                [
                    91.347267,
                    53.7933854
                ],
                [
                    91.3400617,
                    53.7930061
                ],
                [
                    91.3183007,
                    53.8034566
                ],
                [
                    91.2789202,
                    53.7939843
                ],
                [
                    91.2736264,
                    53.8056987
                ],
                [
                    91.2707621,
                    53.8090177
                ],
                [
                    91.2654971,
                    53.8102491
                ],
                [
                    91.2636138,
                    53.8114218
                ],
                [
                    91.2293423,
                    53.8090807
                ],
                [
                    91.1933203,
                    53.8103906
                ]
            ],
            "longitude": 91.31321,
            "latitude": 53.828236
        },
        "5824": {
            "name": "УСТЬ-АБАКАН",
            "population": 15554,
            "type": "town",
            "poly": null,
            "longitude": 91.381294,
            "latitude": 53.844601
        },
        "5825": {
            "name": "БЕЛЫЙ ЯР",
            "population": 10112,
            "type": "town",
            "poly": [
                [
                    91.3457222,
                    53.5799837
                ],
                [
                    91.3464203,
                    53.5809821
                ],
                [
                    91.345902,
                    53.5829238
                ],
                [
                    91.3459735,
                    53.5845577
                ],
                [
                    91.3507276,
                    53.5884195
                ],
                [
                    91.3524433,
                    53.5890454
                ],
                [
                    91.353748,
                    53.5907852
                ],
                [
                    91.3539797,
                    53.5908845
                ],
                [
                    91.3552219,
                    53.5910762
                ],
                [
                    91.3563275,
                    53.591349
                ],
                [
                    91.3564765,
                    53.591526
                ],
                [
                    91.3572094,
                    53.5917841
                ],
                [
                    91.3574827,
                    53.5916587
                ],
                [
                    91.3582405,
                    53.5921158
                ],
                [
                    91.3593957,
                    53.5925656
                ],
                [
                    91.3599672,
                    53.592831
                ],
                [
                    91.3611721,
                    53.5932439
                ],
                [
                    91.3620541,
                    53.593642
                ],
                [
                    91.3630851,
                    53.5943719
                ],
                [
                    91.3635944,
                    53.5944825
                ],
                [
                    91.3636441,
                    53.594195
                ],
                [
                    91.3642155,
                    53.5946078
                ],
                [
                    91.369643,
                    53.5957408
                ],
                [
                    91.3726041,
                    53.5964539
                ],
                [
                    91.3735912,
                    53.5968614
                ],
                [
                    91.3737628,
                    53.5981858
                ],
                [
                    91.3725183,
                    53.5991268
                ],
                [
                    91.3733122,
                    53.5995776
                ],
                [
                    91.3762907,
                    53.6016859
                ],
                [
                    91.3793846,
                    53.6023137
                ],
                [
                    91.3797714,
                    53.6023137
                ],
                [
                    91.3803902,
                    53.6024616
                ],
                [
                    91.3810864,
                    53.602737
                ],
                [
                    91.3819975,
                    53.6030685
                ],
                [
                    91.3826765,
                    53.6034
                ],
                [
                    91.3840233,
                    53.6041467
                ],
                [
                    91.384631,
                    53.6045867
                ],
                [
                    91.3851659,
                    53.6049184
                ],
                [
                    91.3857249,
                    53.605618
                ],
                [
                    91.3860897,
                    53.6063753
                ],
                [
                    91.3867947,
                    53.6072191
                ],
                [
                    91.3894471,
                    53.6081525
                ],
                [
                    91.3925287,
                    53.6102573
                ],
                [
                    91.3933136,
                    53.6104793
                ],
                [
                    91.3950883,
                    53.6116331
                ],
                [
                    91.3967414,
                    53.6131041
                ],
                [
                    91.3968386,
                    53.6139839
                ],
                [
                    91.3965955,
                    53.6148203
                ],
                [
                    91.3966928,
                    53.6153755
                ],
                [
                    91.3965348,
                    53.6160605
                ],
                [
                    91.3962667,
                    53.616528
                ],
                [
                    91.4016128,
                    53.6186097
                ],
                [
                    91.4054196,
                    53.6194578
                ],
                [
                    91.4055268,
                    53.6198819
                ],
                [
                    91.4106741,
                    53.6208889
                ],
                [
                    91.4136963,
                    53.6186722
                ],
                [
                    91.4122678,
                    53.6178942
                ],
                [
                    91.4119674,
                    53.6176803
                ],
                [
                    91.4115898,
                    53.6170745
                ],
                [
                    91.4115211,
                    53.6166875
                ],
                [
                    91.4115383,
                    53.6162598
                ],
                [
                    91.4116499,
                    53.6157863
                ],
                [
                    91.4122845,
                    53.613599
                ],
                [
                    91.4123708,
                    53.6133016
                ],
                [
                    91.4128601,
                    53.6115602
                ],
                [
                    91.4130322,
                    53.6109616
                ],
                [
                    91.4128887,
                    53.6106716
                ],
                [
                    91.4122965,
                    53.6100911
                ],
                [
                    91.4090349,
                    53.606725
                ],
                [
                    91.4061219,
                    53.6036189
                ],
                [
                    91.4049751,
                    53.6023961
                ],
                [
                    91.4034131,
                    53.6007261
                ],
                [
                    91.4020311,
                    53.5992485
                ],
                [
                    91.3994152,
                    53.5964583
                ],
                [
                    91.3984938,
                    53.5954754
                ],
                [
                    91.3968212,
                    53.5936912
                ],
                [
                    91.3940231,
                    53.5906856
                ],
                [
                    91.3937873,
                    53.5903988
                ],
                [
                    91.3934909,
                    53.5900386
                ],
                [
                    91.3930275,
                    53.589524
                ],
                [
                    91.3926155,
                    53.5891623
                ],
                [
                    91.3921606,
                    53.5888617
                ],
                [
                    91.3913881,
                    53.588449
                ],
                [
                    91.3905727,
                    53.5880975
                ],
                [
                    91.389522,
                    53.5877672
                ],
                [
                    91.3879635,
                    53.5872772
                ],
                [
                    91.3851676,
                    53.5864165
                ],
                [
                    91.3828994,
                    53.5857182
                ],
                [
                    91.3792168,
                    53.5845694
                ],
                [
                    91.3780157,
                    53.5841947
                ],
                [
                    91.37593,
                    53.5835425
                ],
                [
                    91.3742992,
                    53.583089
                ],
                [
                    91.3735476,
                    53.5829317
                ],
                [
                    91.3726684,
                    53.5827476
                ],
                [
                    91.3712179,
                    53.5825387
                ],
                [
                    91.3690841,
                    53.5823887
                ],
                [
                    91.3689691,
                    53.5823807
                ],
                [
                    91.367502,
                    53.5822919
                ],
                [
                    91.3661256,
                    53.5822086
                ],
                [
                    91.3660254,
                    53.5822025
                ],
                [
                    91.3624056,
                    53.5819833
                ],
                [
                    91.3608066,
                    53.5818865
                ],
                [
                    91.3540861,
                    53.5814329
                ],
                [
                    91.3511593,
                    53.5812546
                ],
                [
                    91.3504125,
                    53.5811833
                ],
                [
                    91.3499576,
                    53.5811069
                ],
                [
                    91.3495542,
                    53.5809897
                ],
                [
                    91.3490307,
                    53.5807604
                ],
                [
                    91.3489105,
                    53.5806533
                ],
                [
                    91.3483561,
                    53.5801688
                ],
                [
                    91.3476686,
                    53.5800967
                ],
                [
                    91.3466386,
                    53.5799183
                ],
                [
                    91.3457222,
                    53.5799837
                ]
            ],
            "longitude": 91.382362,
            "latitude": 53.596436
        },
        "5826": {
            "name": "САЯНОГОРСК",
            "population": 48740,
            "type": "town",
            "poly": null,
            "longitude": 91.4114,
            "latitude": 53.089386
        },
        "5827": {
            "name": "ЧЕРЁМУШКИ",
            "population": 8271,
            "type": "town",
            "poly": null,
            "longitude": 91.42038,
            "latitude": 52.848377
        },
        "5828": {
            "name": "МАЙНА",
            "population": 4966,
            "type": "town",
            "poly": null,
            "longitude": 91.487083,
            "latitude": 52.998306
        },
        "5829": {
            "name": "ПЕТРОВСК-ЗАБАЙКАЛЬСКИЙ",
            "population": 17144,
            "type": "town",
            "poly": [
                [
                    108.7972396,
                    51.2739385
                ],
                [
                    108.8195742,
                    51.2965354
                ],
                [
                    108.8320552,
                    51.2914418
                ],
                [
                    108.8349456,
                    51.3054068
                ],
                [
                    108.8662139,
                    51.3152619
                ],
                [
                    108.8800088,
                    51.3372639
                ],
                [
                    108.8978764,
                    51.330533
                ],
                [
                    108.8754105,
                    51.306803
                ],
                [
                    108.8830962,
                    51.3042569
                ],
                [
                    108.8837531,
                    51.2935779
                ],
                [
                    108.8709436,
                    51.2871282
                ],
                [
                    108.8769214,
                    51.2746781
                ],
                [
                    108.8656227,
                    51.261896
                ],
                [
                    108.8715348,
                    51.2558119
                ],
                [
                    108.8565575,
                    51.2521528
                ],
                [
                    108.8409234,
                    51.2543318
                ],
                [
                    108.8377046,
                    51.2516594
                ],
                [
                    108.8403322,
                    51.2483701
                ],
                [
                    108.8520906,
                    51.2505904
                ],
                [
                    108.8744909,
                    51.2427365
                ],
                [
                    108.8784322,
                    51.2385006
                ],
                [
                    108.8675934,
                    51.2335651
                ],
                [
                    108.864137,
                    51.2230791
                ],
                [
                    108.8531749,
                    51.2182789
                ],
                [
                    108.8410515,
                    51.2188899
                ],
                [
                    108.821264,
                    51.2271226
                ],
                [
                    108.8289282,
                    51.232271
                ],
                [
                    108.829114,
                    51.2374478
                ],
                [
                    108.8090477,
                    51.2460844
                ],
                [
                    108.8014438,
                    51.2463141
                ],
                [
                    108.7972396,
                    51.2739385
                ]
            ],
            "longitude": 108.854485,
            "latitude": 51.275215
        },
        "5830": {
            "name": "БАЛЯГА",
            "population": 3029,
            "type": "town",
            "poly": null,
            "longitude": 108.908714,
            "latitude": 51.158348
        },
        "5831": {
            "name": "ТАРБАГАТАЙ",
            "population": 2132,
            "type": "town",
            "poly": null,
            "longitude": 109.09938,
            "latitude": 51.178032
        },
        "5832": {
            "name": "НОВОПАВЛОВКА",
            "population": 3759,
            "type": "town",
            "poly": null,
            "longitude": 109.224709,
            "latitude": 51.214764
        },
        "5833": {
            "name": "ХИЛОК",
            "population": 10969,
            "type": "town",
            "poly": [
                [
                    110.4060571,
                    51.3535629
                ],
                [
                    110.4115333,
                    51.3614991
                ],
                [
                    110.4273419,
                    51.372143
                ],
                [
                    110.44904,
                    51.3710465
                ],
                [
                    110.4541029,
                    51.3703369
                ],
                [
                    110.4500732,
                    51.3812368
                ],
                [
                    110.4523463,
                    51.3846545
                ],
                [
                    110.456066,
                    51.3815592
                ],
                [
                    110.4623688,
                    51.37124
                ],
                [
                    110.4671217,
                    51.37124
                ],
                [
                    110.471358,
                    51.3782057
                ],
                [
                    110.4734245,
                    51.3913603
                ],
                [
                    110.4812771,
                    51.3896195
                ],
                [
                    110.4807605,
                    51.3814301
                ],
                [
                    110.4767308,
                    51.371369
                ],
                [
                    110.4835502,
                    51.3671117
                ],
                [
                    110.4792106,
                    51.3619507
                ],
                [
                    110.4795206,
                    51.3509172
                ],
                [
                    110.4963624,
                    51.3484004
                ],
                [
                    110.4994621,
                    51.3438183
                ],
                [
                    110.4951225,
                    51.3400102
                ],
                [
                    110.4767308,
                    51.3408493
                ],
                [
                    110.4632987,
                    51.3394938
                ],
                [
                    110.4465602,
                    51.3382674
                ],
                [
                    110.4305449,
                    51.3448509
                ],
                [
                    110.4153563,
                    51.3448509
                ],
                [
                    110.4086402,
                    51.3487231
                ],
                [
                    110.4060571,
                    51.3535629
                ]
            ],
            "longitude": 110.4579749,
            "latitude": 51.3628436
        },
        "5834": {
            "name": "МОГЗОН",
            "population": 3593,
            "type": "town",
            "poly": null,
            "longitude": 111.97103,
            "latitude": 51.7411577
        },
        "5835": {
            "name": "ГОРНЫЙ",
            "population": 11547,
            "type": "town",
            "poly": null,
            "longitude": 113.033165,
            "latitude": 51.55468
        },
        "5836": {
            "name": "ДРОВЯНАЯ",
            "population": 2964,
            "type": "town",
            "poly": [
                [
                    113.0235252,
                    51.5817842
                ],
                [
                    113.0252489,
                    51.5825067
                ],
                [
                    113.0294465,
                    51.5820609
                ],
                [
                    113.0285291,
                    51.5831852
                ],
                [
                    113.0303129,
                    51.5839611
                ],
                [
                    113.03174,
                    51.5847845
                ],
                [
                    113.033098,
                    51.5844606
                ],
                [
                    113.033363,
                    51.5850433
                ],
                [
                    113.0372162,
                    51.5847138
                ],
                [
                    113.0375627,
                    51.5838272
                ],
                [
                    113.0384313,
                    51.5841999
                ],
                [
                    113.0394534,
                    51.5846386
                ],
                [
                    113.0402677,
                    51.584988
                ],
                [
                    113.0436177,
                    51.585854
                ],
                [
                    113.0448409,
                    51.5877667
                ],
                [
                    113.0468444,
                    51.5877266
                ],
                [
                    113.0496733,
                    51.5876699
                ],
                [
                    113.0504693,
                    51.5866231
                ],
                [
                    113.0511478,
                    51.5865745
                ],
                [
                    113.051748,
                    51.5860151
                ],
                [
                    113.0532876,
                    51.586007
                ],
                [
                    113.0557014,
                    51.5860232
                ],
                [
                    113.0559493,
                    51.5849612
                ],
                [
                    113.0584153,
                    51.585172
                ],
                [
                    113.0588459,
                    51.5842395
                ],
                [
                    113.059646,
                    51.5842528
                ],
                [
                    113.0606016,
                    51.5823328
                ],
                [
                    113.0580851,
                    51.5812442
                ],
                [
                    113.0568427,
                    51.5810264
                ],
                [
                    113.0561811,
                    51.5802766
                ],
                [
                    113.060952,
                    51.5779383
                ],
                [
                    113.0614298,
                    51.5784134
                ],
                [
                    113.0610476,
                    51.5795022
                ],
                [
                    113.0618439,
                    51.5796012
                ],
                [
                    113.0626403,
                    51.5785718
                ],
                [
                    113.0625129,
                    51.5779383
                ],
                [
                    113.0606972,
                    51.5754043
                ],
                [
                    113.0614108,
                    51.5733552
                ],
                [
                    113.058147,
                    51.5731361
                ],
                [
                    113.0563681,
                    51.5739174
                ],
                [
                    113.0567061,
                    51.5746941
                ],
                [
                    113.0556641,
                    51.5755034
                ],
                [
                    113.0530521,
                    51.5750282
                ],
                [
                    113.049837,
                    51.575651
                ],
                [
                    113.0486921,
                    51.5742034
                ],
                [
                    113.0399873,
                    51.5754179
                ],
                [
                    113.0369319,
                    51.5756575
                ],
                [
                    113.0365,
                    51.5758549
                ],
                [
                    113.0345285,
                    51.5767559
                ],
                [
                    113.0235252,
                    51.5817842
                ]
            ],
            "longitude": 113.047455,
            "latitude": 51.580357
        },
        "5837": {
            "name": "АТАМАНОВКА",
            "population": 10619,
            "type": "town",
            "poly": [
                [
                    113.6002845,
                    51.9497211
                ],
                [
                    113.6028022,
                    51.9529091
                ],
                [
                    113.6058166,
                    51.9535648
                ],
                [
                    113.6090676,
                    51.9518527
                ],
                [
                    113.6146828,
                    51.9490475
                ],
                [
                    113.6220121,
                    51.9493754
                ],
                [
                    113.6295779,
                    51.947736
                ],
                [
                    113.6275682,
                    51.9460235
                ],
                [
                    113.6309374,
                    51.9444569
                ],
                [
                    113.6304054,
                    51.9405946
                ],
                [
                    113.6333017,
                    51.9407039
                ],
                [
                    113.6341883,
                    51.9396107
                ],
                [
                    113.6320013,
                    51.937643
                ],
                [
                    113.6327106,
                    51.935092
                ],
                [
                    113.6361388,
                    51.934436
                ],
                [
                    113.6366117,
                    51.9361124
                ],
                [
                    113.6378651,
                    51.9358385
                ],
                [
                    113.6387395,
                    51.9356387
                ],
                [
                    113.6456551,
                    51.9381531
                ],
                [
                    113.6501473,
                    51.9292243
                ],
                [
                    113.6599592,
                    51.9289327
                ],
                [
                    113.6664019,
                    51.924012
                ],
                [
                    113.6673476,
                    51.9155179
                ],
                [
                    113.6555852,
                    51.9094288
                ],
                [
                    113.6538711,
                    51.906621
                ],
                [
                    113.6448276,
                    51.9070586
                ],
                [
                    113.6447094,
                    51.9097205
                ],
                [
                    113.6466009,
                    51.9122729
                ],
                [
                    113.6464826,
                    51.9165021
                ],
                [
                    113.6451823,
                    51.9201479
                ],
                [
                    113.6416949,
                    51.9226268
                ],
                [
                    113.6370845,
                    51.9221164
                ],
                [
                    113.6325333,
                    51.919674
                ],
                [
                    113.6301098,
                    51.9181064
                ],
                [
                    113.6272136,
                    51.9179605
                ],
                [
                    113.6244946,
                    51.9189449
                ],
                [
                    113.6217166,
                    51.9212415
                ],
                [
                    113.6198842,
                    51.9257252
                ],
                [
                    113.6209447,
                    51.9338697
                ],
                [
                    113.6200864,
                    51.9359071
                ],
                [
                    113.6179406,
                    51.9396773
                ],
                [
                    113.6147649,
                    51.9411854
                ],
                [
                    113.6100228,
                    51.9424552
                ],
                [
                    113.6044572,
                    51.9448577
                ],
                [
                    113.6011773,
                    51.9474884
                ],
                [
                    113.6003108,
                    51.94886
                ],
                [
                    113.6002845,
                    51.9497211
                ]
            ],
            "longitude": 113.649384,
            "latitude": 51.918083
        },
        "5838": {
            "name": "КУРОРТ-ДАРАСУН",
            "population": 2989,
            "type": "town",
            "poly": null,
            "longitude": 113.714195,
            "latitude": 51.204155
        },
        "5839": {
            "name": "НОВОКРУЧИНИНСКИЙ",
            "population": 10360,
            "type": "town",
            "poly": null,
            "longitude": 113.792671,
            "latitude": 51.774662
        },
        "5840": {
            "name": "ДАРАСУН",
            "population": 6976,
            "type": "town",
            "poly": null,
            "longitude": 113.984253,
            "latitude": 51.663696
        },
        "5841": {
            "name": "КАРЫМСКОЕ",
            "population": 12811,
            "type": "town",
            "poly": [
                [
                    114.2978601,
                    51.6278251
                ],
                [
                    114.3154011,
                    51.6373775
                ],
                [
                    114.3490765,
                    51.643796
                ],
                [
                    114.357516,
                    51.6318825
                ],
                [
                    114.3647144,
                    51.6320623
                ],
                [
                    114.3668657,
                    51.6211475
                ],
                [
                    114.3524688,
                    51.6106154
                ],
                [
                    114.3265711,
                    51.6115402
                ],
                [
                    114.3154838,
                    51.6159588
                ],
                [
                    114.2978601,
                    51.6278251
                ]
            ],
            "longitude": 114.34063,
            "latitude": 51.623402
        },
        "5842": {
            "name": "АГИНСКОЕ",
            "population": 17496,
            "type": "town",
            "poly": [
                [
                    114.4838601,
                    51.1184194
                ],
                [
                    114.4870841,
                    51.121352
                ],
                [
                    114.4919748,
                    51.1191911
                ],
                [
                    114.4944612,
                    51.121232
                ],
                [
                    114.5061279,
                    51.1135655
                ],
                [
                    114.5078492,
                    51.1142687
                ],
                [
                    114.5099804,
                    51.1123476
                ],
                [
                    114.5111279,
                    51.1095516
                ],
                [
                    114.509788,
                    51.1075783
                ],
                [
                    114.5095908,
                    51.1056984
                ],
                [
                    114.5129779,
                    51.1037632
                ],
                [
                    114.5177275,
                    51.104361
                ],
                [
                    114.5180853,
                    51.104008
                ],
                [
                    114.5213057,
                    51.1048906
                ],
                [
                    114.5209224,
                    51.1054684
                ],
                [
                    114.525523,
                    51.1064794
                ],
                [
                    114.52836,
                    51.1065757
                ],
                [
                    114.5275166,
                    51.1080039
                ],
                [
                    114.5236572,
                    51.1091914
                ],
                [
                    114.5221232,
                    51.1108475
                ],
                [
                    114.523617,
                    51.1114772
                ],
                [
                    114.5197401,
                    51.115065
                ],
                [
                    114.5187477,
                    51.1165972
                ],
                [
                    114.5185914,
                    51.119039
                ],
                [
                    114.517835,
                    51.1196619
                ],
                [
                    114.5191976,
                    51.1223422
                ],
                [
                    114.522987,
                    51.1237478
                ],
                [
                    114.5253391,
                    51.1259229
                ],
                [
                    114.5264818,
                    51.1269151
                ],
                [
                    114.5272878,
                    51.1277926
                ],
                [
                    114.5269203,
                    51.1304598
                ],
                [
                    114.5283967,
                    51.1319903
                ],
                [
                    114.5293853,
                    51.134145
                ],
                [
                    114.5363016,
                    51.1348949
                ],
                [
                    114.5489739,
                    51.1334902
                ],
                [
                    114.5500383,
                    51.1301122
                ],
                [
                    114.5535729,
                    51.1275306
                ],
                [
                    114.5525429,
                    51.1149408
                ],
                [
                    114.5495387,
                    51.1147757
                ],
                [
                    114.5496833,
                    51.1132781
                ],
                [
                    114.5475145,
                    51.113142
                ],
                [
                    114.5482374,
                    51.1109181
                ],
                [
                    114.5535778,
                    51.1108062
                ],
                [
                    114.5594426,
                    51.1138681
                ],
                [
                    114.5620451,
                    51.111735
                ],
                [
                    114.5647458,
                    51.1074657
                ],
                [
                    114.5637801,
                    51.1042459
                ],
                [
                    114.5682994,
                    51.1067774
                ],
                [
                    114.5696357,
                    51.1064247
                ],
                [
                    114.5708646,
                    51.1021125
                ],
                [
                    114.5751298,
                    51.1003874
                ],
                [
                    114.5758591,
                    51.0986631
                ],
                [
                    114.5642861,
                    51.0964832
                ],
                [
                    114.5646476,
                    51.095893
                ],
                [
                    114.5593814,
                    51.094965
                ],
                [
                    114.5606716,
                    51.0930327
                ],
                [
                    114.560437,
                    51.0885146
                ],
                [
                    114.559298,
                    51.0882197
                ],
                [
                    114.558792,
                    51.0891733
                ],
                [
                    114.5497556,
                    51.086585
                ],
                [
                    114.5468639,
                    51.0885376
                ],
                [
                    114.5432837,
                    51.082842
                ],
                [
                    114.5412975,
                    51.082725
                ],
                [
                    114.5350081,
                    51.0886738
                ],
                [
                    114.5320442,
                    51.0900814
                ],
                [
                    114.5308123,
                    51.0917792
                ],
                [
                    114.5299432,
                    51.092608
                ],
                [
                    114.5222881,
                    51.0947461
                ],
                [
                    114.5199805,
                    51.0974269
                ],
                [
                    114.5183361,
                    51.0970937
                ],
                [
                    114.4950833,
                    51.0912958
                ],
                [
                    114.4946447,
                    51.0921026
                ],
                [
                    114.5086721,
                    51.0976821
                ],
                [
                    114.5094103,
                    51.0981366
                ],
                [
                    114.5094207,
                    51.0985064
                ],
                [
                    114.5087801,
                    51.0985389
                ],
                [
                    114.5077675,
                    51.0988308
                ],
                [
                    114.5065793,
                    51.0985908
                ],
                [
                    114.5057941,
                    51.0988438
                ],
                [
                    114.5059284,
                    51.0994343
                ],
                [
                    114.506631,
                    51.099869
                ],
                [
                    114.506383,
                    51.1001934
                ],
                [
                    114.5053808,
                    51.1002907
                ],
                [
                    114.5051845,
                    51.1006151
                ],
                [
                    114.5064553,
                    51.1009914
                ],
                [
                    114.506352,
                    51.1014651
                ],
                [
                    114.5053911,
                    51.1015105
                ],
                [
                    114.5048022,
                    51.1018803
                ],
                [
                    114.5041306,
                    51.1018478
                ],
                [
                    114.5041209,
                    51.1011868
                ],
                [
                    114.5026597,
                    51.1000858
                ],
                [
                    114.5021629,
                    51.1001592
                ],
                [
                    114.5027181,
                    51.1008932
                ],
                [
                    114.502309,
                    51.1012052
                ],
                [
                    114.5015492,
                    51.1012052
                ],
                [
                    114.5004679,
                    51.1010584
                ],
                [
                    114.4990359,
                    51.1013703
                ],
                [
                    114.4988656,
                    51.1023062
                ],
                [
                    114.5010459,
                    51.1037704
                ],
                [
                    114.5038875,
                    51.1036503
                ],
                [
                    114.5057727,
                    51.1047654
                ],
                [
                    114.5047071,
                    51.1060349
                ],
                [
                    114.5061825,
                    51.106927
                ],
                [
                    114.4947617,
                    51.1143545
                ],
                [
                    114.4923027,
                    51.1143202
                ],
                [
                    114.4838601,
                    51.1184194
                ]
            ],
            "longitude": 114.544266,
            "latitude": 51.107189
        },
        "5843": {
            "name": "МОГОЙТУЙ",
            "population": 10900,
            "type": "town",
            "poly": null,
            "longitude": 114.930435,
            "latitude": 51.282913
        },
        "5844": {
            "name": "ВЕРШИНО-ДАРАСУНСКИЙ",
            "population": 5598,
            "type": "town",
            "poly": null,
            "longitude": 115.550949,
            "latitude": 52.365974
        },
        "5845": {
            "name": "ОЛОВЯННАЯ",
            "population": 7755,
            "type": "town",
            "poly": null,
            "longitude": 115.586937,
            "latitude": 50.943687
        },
        "5846": {
            "name": "ПЕРВОМАЙСКИЙ",
            "population": 11398,
            "type": "town",
            "poly": [
                [
                    115.5883131,
                    51.6642456
                ],
                [
                    115.5935859,
                    51.667464
                ],
                [
                    115.6068095,
                    51.671928
                ],
                [
                    115.6229625,
                    51.6731217
                ],
                [
                    115.637609,
                    51.6734851
                ],
                [
                    115.6504142,
                    51.6781561
                ],
                [
                    115.6566075,
                    51.6813217
                ],
                [
                    115.663052,
                    51.6772219
                ],
                [
                    115.6654791,
                    51.6768586
                ],
                [
                    115.6621313,
                    51.6709938
                ],
                [
                    115.6596118,
                    51.6694208
                ],
                [
                    115.6643615,
                    51.6682789
                ],
                [
                    115.6627504,
                    51.6663063
                ],
                [
                    115.6592771,
                    51.6671239
                ],
                [
                    115.6593398,
                    51.6633733
                ],
                [
                    115.6503636,
                    51.6651513
                ],
                [
                    115.6492756,
                    51.6650085
                ],
                [
                    115.6490664,
                    51.6631525
                ],
                [
                    115.6500498,
                    51.6631397
                ],
                [
                    115.6498196,
                    51.6607905
                ],
                [
                    115.6397136,
                    51.6606996
                ],
                [
                    115.6394625,
                    51.6587397
                ],
                [
                    115.6310303,
                    51.6586229
                ],
                [
                    115.6278081,
                    51.6549235
                ],
                [
                    115.6239582,
                    51.6529114
                ],
                [
                    115.6227864,
                    51.6530932
                ],
                [
                    115.6230584,
                    51.6551052
                ],
                [
                    115.6211126,
                    51.6569615
                ],
                [
                    115.6159654,
                    51.6542096
                ],
                [
                    115.6107345,
                    51.6542745
                ],
                [
                    115.5988708,
                    51.659194
                ],
                [
                    115.5883131,
                    51.6642456
                ]
            ],
            "longitude": 115.638283,
            "latitude": 51.669296
        },
        "5847": {
            "name": "ЯСНОГОРСК",
            "population": 7558,
            "type": "town",
            "poly": null,
            "longitude": 115.699043,
            "latitude": 50.876667
        },
        "5848": {
            "name": "ШИЛКА",
            "population": 13162,
            "type": "town",
            "poly": [
                [
                    115.9818549,
                    51.8648818
                ],
                [
                    115.9845308,
                    51.8699073
                ],
                [
                    115.9961283,
                    51.876283
                ],
                [
                    115.9865243,
                    51.8845639
                ],
                [
                    115.99516,
                    51.8899535
                ],
                [
                    116.0020229,
                    51.8843229
                ],
                [
                    116.0088446,
                    51.8964424
                ],
                [
                    116.0306422,
                    51.9067091
                ],
                [
                    116.0818319,
                    51.8685057
                ],
                [
                    116.0851562,
                    51.8665756
                ],
                [
                    116.0748637,
                    51.8628913
                ],
                [
                    116.06821,
                    51.8581115
                ],
                [
                    116.0569657,
                    51.8540176
                ],
                [
                    116.0597109,
                    51.8503964
                ],
                [
                    116.0415787,
                    51.84539
                ],
                [
                    116.0249481,
                    51.8366755
                ],
                [
                    116.0065424,
                    51.8466467
                ],
                [
                    116.0000979,
                    51.8542982
                ],
                [
                    115.9882971,
                    51.852282
                ],
                [
                    115.9818549,
                    51.8648818
                ]
            ],
            "longitude": 116.025894,
            "latitude": 51.851639
        },
        "5849": {
            "name": "ХОЛБОН",
            "population": 2478,
            "type": "town",
            "poly": null,
            "longitude": 116.251968,
            "latitude": 51.900475
        },
        "5850": {
            "name": "ШЕРЛОВАЯ ГОРА",
            "population": 12349,
            "type": "town",
            "poly": null,
            "longitude": 116.312912,
            "latitude": 50.52816
        },
        "5851": {
            "name": "БОРЗЯ",
            "population": 29405,
            "type": "town",
            "poly": [
                [
                    116.4567138,
                    50.3572353
                ],
                [
                    116.4699265,
                    50.3615014
                ],
                [
                    116.4638036,
                    50.3849835
                ],
                [
                    116.4878926,
                    50.3878601
                ],
                [
                    116.5186684,
                    50.4054758
                ],
                [
                    116.5405016,
                    50.4021381
                ],
                [
                    116.5456578,
                    50.4030624
                ],
                [
                    116.5496055,
                    50.3990569
                ],
                [
                    116.5617708,
                    50.4030624
                ],
                [
                    116.5633821,
                    50.3994677
                ],
                [
                    116.5610457,
                    50.3933561
                ],
                [
                    116.5541171,
                    50.3959755
                ],
                [
                    116.5498472,
                    50.3945374
                ],
                [
                    116.5501694,
                    50.3930479
                ],
                [
                    116.562657,
                    50.3908907
                ],
                [
                    116.5690217,
                    50.3806682
                ],
                [
                    116.5546811,
                    50.3738348
                ],
                [
                    116.5387292,
                    50.3693643
                ],
                [
                    116.5338953,
                    50.3732181
                ],
                [
                    116.5315589,
                    50.3655615
                ],
                [
                    116.4944183,
                    50.3515809
                ],
                [
                    116.4682347,
                    50.3429953
                ],
                [
                    116.4567138,
                    50.3572353
                ]
            ],
            "longitude": 116.533562,
            "latitude": 50.385109
        },
        "5852": {
            "name": "НЕРЧИНСК",
            "population": 14746,
            "type": "town",
            "poly": [
                [
                    116.5135234,
                    51.9916527
                ],
                [
                    116.5481067,
                    51.9944004
                ],
                [
                    116.5590485,
                    52.0004291
                ],
                [
                    116.5698313,
                    51.9917611
                ],
                [
                    116.5804001,
                    51.9895194
                ],
                [
                    116.5936697,
                    51.9904956
                ],
                [
                    116.60371,
                    51.986012
                ],
                [
                    116.5990715,
                    51.9821428
                ],
                [
                    116.6004807,
                    51.9805515
                ],
                [
                    116.6028293,
                    51.9757776
                ],
                [
                    116.6082898,
                    51.9772966
                ],
                [
                    116.6112256,
                    51.9721968
                ],
                [
                    116.6082311,
                    51.9714734
                ],
                [
                    116.6108733,
                    51.9692668
                ],
                [
                    116.610521,
                    51.9663729
                ],
                [
                    116.5940807,
                    51.9651428
                ],
                [
                    116.5949027,
                    51.9610185
                ],
                [
                    116.5980734,
                    51.9591009
                ],
                [
                    116.5996,
                    51.960512
                ],
                [
                    116.6034752,
                    51.9581602
                ],
                [
                    116.6053541,
                    51.9572194
                ],
                [
                    116.6055889,
                    51.9549036
                ],
                [
                    116.5954312,
                    51.9530582
                ],
                [
                    116.5937284,
                    51.9560614
                ],
                [
                    116.5873285,
                    51.9551569
                ],
                [
                    116.5929064,
                    51.951285
                ],
                [
                    116.5887964,
                    51.9484622
                ],
                [
                    116.5816918,
                    51.9526239
                ],
                [
                    116.5786973,
                    51.9514659
                ],
                [
                    116.573824,
                    51.9587753
                ],
                [
                    116.5756441,
                    51.961923
                ],
                [
                    116.5860367,
                    51.9701712
                ],
                [
                    116.5849212,
                    51.9742223
                ],
                [
                    116.5811634,
                    51.9775136
                ],
                [
                    116.5700075,
                    51.9781284
                ],
                [
                    116.5621396,
                    51.9802622
                ],
                [
                    116.5538021,
                    51.9804431
                ],
                [
                    116.542059,
                    51.9850719
                ],
                [
                    116.5328994,
                    51.9874946
                ],
                [
                    116.5209802,
                    51.9888686
                ],
                [
                    116.5135234,
                    51.9916527
                ]
            ],
            "longitude": 116.588341,
            "latitude": 51.97694
        },
        "5853": {
            "name": "ПРИИСКОВЫЙ",
            "population": 1424,
            "type": "town",
            "poly": null,
            "longitude": 116.617645,
            "latitude": 51.917625
        },
        "5854": {
            "name": "БАЛЕЙ",
            "population": 11696,
            "type": "town",
            "poly": [
                [
                    116.6099938,
                    51.5850631
                ],
                [
                    116.6142854,
                    51.5877296
                ],
                [
                    116.6169315,
                    51.5883689
                ],
                [
                    116.6204652,
                    51.5892227
                ],
                [
                    116.6265023,
                    51.5897801
                ],
                [
                    116.6327279,
                    51.5923109
                ],
                [
                    116.6381158,
                    51.5929711
                ],
                [
                    116.6451844,
                    51.5941285
                ],
                [
                    116.6522225,
                    51.5948749
                ],
                [
                    116.6582307,
                    51.5931687
                ],
                [
                    116.6630372,
                    51.5907158
                ],
                [
                    116.6631828,
                    51.5894944
                ],
                [
                    116.6596939,
                    51.5864831
                ],
                [
                    116.6565423,
                    51.5842629
                ],
                [
                    116.6560808,
                    51.5824413
                ],
                [
                    116.6533933,
                    51.578698
                ],
                [
                    116.6524796,
                    51.5768603
                ],
                [
                    116.6514479,
                    51.5749825
                ],
                [
                    116.6499446,
                    51.5735288
                ],
                [
                    116.6475391,
                    51.5721086
                ],
                [
                    116.6457606,
                    51.572065
                ],
                [
                    116.6426095,
                    51.5723685
                ],
                [
                    116.637288,
                    51.5731153
                ],
                [
                    116.6354437,
                    51.5731117
                ],
                [
                    116.6341276,
                    51.572042
                ],
                [
                    116.6326672,
                    51.5715764
                ],
                [
                    116.6321159,
                    51.5716652
                ],
                [
                    116.6315647,
                    51.5718682
                ],
                [
                    116.6307073,
                    51.5725661
                ],
                [
                    116.6293748,
                    51.5736027
                ],
                [
                    116.6257867,
                    51.5750357
                ],
                [
                    116.6220101,
                    51.5756758
                ],
                [
                    116.6204652,
                    51.5772761
                ],
                [
                    116.6201218,
                    51.579943
                ],
                [
                    116.6194352,
                    51.5821831
                ],
                [
                    116.616002,
                    51.5820764
                ],
                [
                    116.6129121,
                    51.5820764
                ],
                [
                    116.6099938,
                    51.5850631
                ]
            ],
            "longitude": 116.646042,
            "latitude": 51.578789
        },
        "5855": {
            "name": "БУКАЧАЧА",
            "population": 2038,
            "type": "town",
            "poly": null,
            "longitude": 116.91169,
            "latitude": 52.988396
        },
        "5856": {
            "name": "ЧЕРНЫШЕВСК",
            "population": 13020,
            "type": "town",
            "poly": [
                [
                    116.9884416,
                    52.5236092
                ],
                [
                    116.9983595,
                    52.5310039
                ],
                [
                    117.0044368,
                    52.5339049
                ],
                [
                    117.0121601,
                    52.5363437
                ],
                [
                    117.0118224,
                    52.5468675
                ],
                [
                    117.0276488,
                    52.5505887
                ],
                [
                    117.0509875,
                    52.5312863
                ],
                [
                    117.0302233,
                    52.516316
                ],
                [
                    117.0141859,
                    52.4998247
                ],
                [
                    116.9961227,
                    52.4916796
                ],
                [
                    116.9932528,
                    52.4931443
                ],
                [
                    116.9992879,
                    52.4975381
                ],
                [
                    116.9944767,
                    52.5021627
                ],
                [
                    116.9921977,
                    52.5094325
                ],
                [
                    116.997431,
                    52.5152116
                ],
                [
                    116.9916069,
                    52.5169837
                ],
                [
                    116.9884416,
                    52.5236092
                ]
            ],
            "longitude": 117.01371,
            "latitude": 52.514069
        },
        "5857": {
            "name": "ЖИРЕКЕН",
            "population": 4566,
            "type": "town",
            "poly": [
                [
                    117.2655343,
                    52.821043
                ],
                [
                    117.2692949,
                    52.8256372
                ],
                [
                    117.2694584,
                    52.8327006
                ],
                [
                    117.2881796,
                    52.8294407
                ],
                [
                    117.2971723,
                    52.8292431
                ],
                [
                    117.3072278,
                    52.8306755
                ],
                [
                    117.3163022,
                    52.828354
                ],
                [
                    117.3113154,
                    52.8203513
                ],
                [
                    117.2960278,
                    52.8139283
                ],
                [
                    117.2846642,
                    52.8113589
                ],
                [
                    117.2773883,
                    52.8152624
                ],
                [
                    117.2655343,
                    52.821043
                ]
            ],
            "longitude": 117.286469,
            "latitude": 52.821419
        },
        "5858": {
            "name": "ЗАБАЙКАЛЬСК",
            "population": 12917,
            "type": "town",
            "poly": [
                [
                    117.2960695,
                    49.655552
                ],
                [
                    117.299954,
                    49.6558048
                ],
                [
                    117.299435,
                    49.6608823
                ],
                [
                    117.2975398,
                    49.6645624
                ],
                [
                    117.2991409,
                    49.6656833
                ],
                [
                    117.3027351,
                    49.6664657
                ],
                [
                    117.3009053,
                    49.6707375
                ],
                [
                    117.3087917,
                    49.6746179
                ],
                [
                    117.3153149,
                    49.6687074
                ],
                [
                    117.3176021,
                    49.6654506
                ],
                [
                    117.3195299,
                    49.6661485
                ],
                [
                    117.3275352,
                    49.6650699
                ],
                [
                    117.3275679,
                    49.6665715
                ],
                [
                    117.3287441,
                    49.6660216
                ],
                [
                    117.3286788,
                    49.6625532
                ],
                [
                    117.3278946,
                    49.6616226
                ],
                [
                    117.3352137,
                    49.654854
                ],
                [
                    117.341912,
                    49.66084
                ],
                [
                    117.3524659,
                    49.6586614
                ],
                [
                    117.3615168,
                    49.6575827
                ],
                [
                    117.3587982,
                    49.6510129
                ],
                [
                    117.3561255,
                    49.6440646
                ],
                [
                    117.371842,
                    49.6418218
                ],
                [
                    117.3719727,
                    49.638267
                ],
                [
                    117.3649803,
                    49.6365953
                ],
                [
                    117.3477167,
                    49.635108
                ],
                [
                    117.3407684,
                    49.6342887
                ],
                [
                    117.340507,
                    49.6318761
                ],
                [
                    117.3388079,
                    49.63031
                ],
                [
                    117.3314216,
                    49.6345973
                ],
                [
                    117.3274372,
                    49.6343097
                ],
                [
                    117.3182556,
                    49.6343097
                ],
                [
                    117.3185496,
                    49.6391346
                ],
                [
                    117.3169813,
                    49.6384998
                ],
                [
                    117.3152822,
                    49.6388172
                ],
                [
                    117.3133217,
                    49.6386056
                ],
                [
                    117.3118513,
                    49.6435145
                ],
                [
                    117.2999904,
                    49.6437684
                ],
                [
                    117.2978012,
                    49.6461804
                ],
                [
                    117.2981934,
                    49.6481667
                ],
                [
                    117.2960695,
                    49.655552
                ]
            ],
            "longitude": 117.329025,
            "latitude": 49.644653
        },
        "5859": {
            "name": "АКСЁНОВО-ЗИЛОВСКОЕ",
            "population": 3148,
            "type": "town",
            "poly": [
                [
                    117.4759018,
                    53.0664149
                ],
                [
                    117.4850277,
                    53.0718433
                ],
                [
                    117.5008155,
                    53.0786417
                ],
                [
                    117.5090288,
                    53.0874669
                ],
                [
                    117.5204362,
                    53.0875765
                ],
                [
                    117.5208924,
                    53.0800122
                ],
                [
                    117.5302008,
                    53.0803411
                ],
                [
                    117.5246341,
                    53.0711854
                ],
                [
                    117.5340337,
                    53.0667987
                ],
                [
                    117.5232652,
                    53.0638375
                ],
                [
                    117.5050134,
                    53.0604372
                ],
                [
                    117.4976214,
                    53.0616987
                ],
                [
                    117.4874917,
                    53.0606567
                ],
                [
                    117.4836588,
                    53.0604372
                ],
                [
                    117.4759018,
                    53.0664149
                ]
            ],
            "longitude": 117.509735,
            "latitude": 53.068661
        },
        "5860": {
            "name": "КОКУЙ",
            "population": 7128,
            "type": "town",
            "poly": null,
            "longitude": 117.550705,
            "latitude": 52.204762
        },
        "5861": {
            "name": "СРЕТЕНСК",
            "population": 6608,
            "type": "town",
            "poly": [
                [
                    117.6146854,
                    52.2131566
                ],
                [
                    117.6179572,
                    52.2172686
                ],
                [
                    117.6509265,
                    52.2166518
                ],
                [
                    117.6720671,
                    52.2286774
                ],
                [
                    117.6803723,
                    52.2455797
                ],
                [
                    117.6977378,
                    52.2596
                ],
                [
                    117.7082242,
                    52.2535405
                ],
                [
                    117.7218985,
                    52.2592919
                ],
                [
                    117.7332238,
                    52.2595487
                ],
                [
                    117.7482403,
                    52.2512808
                ],
                [
                    117.7417807,
                    52.2482505
                ],
                [
                    117.7333916,
                    52.2516403
                ],
                [
                    117.6800367,
                    52.2207121
                ],
                [
                    117.6853219,
                    52.2062168
                ],
                [
                    117.6732415,
                    52.2027721
                ],
                [
                    117.6407756,
                    52.2103294
                ],
                [
                    117.6146854,
                    52.2131566
                ]
            ],
            "longitude": 117.695541,
            "latitude": 52.243191
        },
        "5862": {
            "name": "КРАСНОКАМЕНСК",
            "population": 53795,
            "type": "town",
            "poly": [
                [
                    117.9570768,
                    50.1105268
                ],
                [
                    117.9857442,
                    50.1223048
                ],
                [
                    117.9997346,
                    50.1199384
                ],
                [
                    117.9999063,
                    50.1152603
                ],
                [
                    118.0256555,
                    50.1132239
                ],
                [
                    118.0336377,
                    50.1364455
                ],
                [
                    118.0591294,
                    50.1360054
                ],
                [
                    118.0654809,
                    50.1283027
                ],
                [
                    118.0593011,
                    50.1234604
                ],
                [
                    118.0582711,
                    50.0860259
                ],
                [
                    118.0554387,
                    50.0756713
                ],
                [
                    118.0155275,
                    50.0681242
                ],
                [
                    118.004627,
                    50.0713195
                ],
                [
                    118.0057428,
                    50.0846492
                ],
                [
                    117.9745004,
                    50.0974245
                ],
                [
                    117.9570768,
                    50.1105268
                ]
            ],
            "longitude": 118.041344,
            "latitude": 50.096992
        },
        "5863": {
            "name": "НОВАЯ ЧАРА",
            "population": 4009,
            "type": "town",
            "poly": null,
            "longitude": 118.26881495406487,
            "latitude": 56.78914811883326
        },
        "5864": {
            "name": "КСЕНЬЕВКА",
            "population": 2793,
            "type": "town",
            "poly": [
                [
                    118.6941258,
                    53.5554452
                ],
                [
                    118.6981187,
                    53.5612669
                ],
                [
                    118.706286,
                    53.5667105
                ],
                [
                    118.7177202,
                    53.5701057
                ],
                [
                    118.7277025,
                    53.5717762
                ],
                [
                    118.7424944,
                    53.5685428
                ],
                [
                    118.7546546,
                    53.5655248
                ],
                [
                    118.7558343,
                    53.5612669
                ],
                [
                    118.7523859,
                    53.5581944
                ],
                [
                    118.7490282,
                    53.5536122
                ],
                [
                    118.7101881,
                    53.5470346
                ],
                [
                    118.6941258,
                    53.5554452
                ]
            ],
            "longitude": 118.734123,
            "latitude": 53.559807
        },
        "5865": {
            "name": "ПРИАРГУНСК",
            "population": 7383,
            "type": "town",
            "poly": null,
            "longitude": 119.090134,
            "latitude": 50.365902
        },
        "5866": {
            "name": "МОГОЧА",
            "population": 13640,
            "type": "town",
            "poly": [
                [
                    119.7128343,
                    53.7653902
                ],
                [
                    119.7162049,
                    53.7686899
                ],
                [
                    119.732742,
                    53.7595372
                ],
                [
                    119.7577058,
                    53.7528115
                ],
                [
                    119.766659,
                    53.7563613
                ],
                [
                    119.7787722,
                    53.765826
                ],
                [
                    119.7791935,
                    53.782384
                ],
                [
                    119.794256,
                    53.7921539
                ],
                [
                    119.8064746,
                    53.7817617
                ],
                [
                    119.8016293,
                    53.7650789
                ],
                [
                    119.7925707,
                    53.7639581
                ],
                [
                    119.7792989,
                    53.7548667
                ],
                [
                    119.7919387,
                    53.7469568
                ],
                [
                    119.8034199,
                    53.7303225
                ],
                [
                    119.7991013,
                    53.7233429
                ],
                [
                    119.8059479,
                    53.7164244
                ],
                [
                    119.7926761,
                    53.7169231
                ],
                [
                    119.7895161,
                    53.7210368
                ],
                [
                    119.7846708,
                    53.7125595
                ],
                [
                    119.7758229,
                    53.714492
                ],
                [
                    119.7774029,
                    53.7197903
                ],
                [
                    119.7642364,
                    53.7172347
                ],
                [
                    119.7503325,
                    53.7235922
                ],
                [
                    119.7522285,
                    53.7255865
                ],
                [
                    119.73843,
                    53.730821
                ],
                [
                    119.7191542,
                    53.7311326
                ],
                [
                    119.7211555,
                    53.7361796
                ],
                [
                    119.7262114,
                    53.7451504
                ],
                [
                    119.7196809,
                    53.7555518
                ],
                [
                    119.7128343,
                    53.7653902
                ]
            ],
            "longitude": 119.7648554,
            "latitude": 53.7335417
        },
        "5867": {
            "name": "АМАЗАР",
            "population": 2351,
            "type": "town",
            "poly": [
                [
                    120.8465224,
                    53.8577627
                ],
                [
                    120.8532048,
                    53.861958
                ],
                [
                    120.8559455,
                    53.8611953
                ],
                [
                    120.8714351,
                    53.8656081
                ],
                [
                    120.8728516,
                    53.8686405
                ],
                [
                    120.8776863,
                    53.8737606
                ],
                [
                    120.8826918,
                    53.8764553
                ],
                [
                    120.8861273,
                    53.8743178
                ],
                [
                    120.8814457,
                    53.8712881
                ],
                [
                    120.8812933,
                    53.8676418
                ],
                [
                    120.8836014,
                    53.8654718
                ],
                [
                    120.8868677,
                    53.8655745
                ],
                [
                    120.8909613,
                    53.8635842
                ],
                [
                    120.8919848,
                    53.8620433
                ],
                [
                    120.8917888,
                    53.8612086
                ],
                [
                    120.889546,
                    53.859963
                ],
                [
                    120.8864975,
                    53.857677
                ],
                [
                    120.8785061,
                    53.8551598
                ],
                [
                    120.8767423,
                    53.8530663
                ],
                [
                    120.8770254,
                    53.8518332
                ],
                [
                    120.8798126,
                    53.8479925
                ],
                [
                    120.8800304,
                    53.8467979
                ],
                [
                    120.8693824,
                    53.8490587
                ],
                [
                    120.8623491,
                    53.8484807
                ],
                [
                    120.860912,
                    53.8509341
                ],
                [
                    120.8510184,
                    53.8522592
                ],
                [
                    120.8465224,
                    53.8577627
                ]
            ],
            "longitude": 120.878082,
            "latitude": 53.860237
        },
        "5868": {
            "name": "УСТЬ-ИШИМ",
            "population": 4802,
            "type": "town",
            "poly": [
                [
                    71.1411901,
                    57.6865389
                ],
                [
                    71.1435169,
                    57.688805
                ],
                [
                    71.1475047,
                    57.6926885
                ],
                [
                    71.1455883,
                    57.6948422
                ],
                [
                    71.1456866,
                    57.6962472
                ],
                [
                    71.1475785,
                    57.6989258
                ],
                [
                    71.1476277,
                    57.70016
                ],
                [
                    71.1493722,
                    57.6998055
                ],
                [
                    71.1494459,
                    57.6993853
                ],
                [
                    71.1473082,
                    57.6968249
                ],
                [
                    71.1503305,
                    57.6959846
                ],
                [
                    71.1540161,
                    57.6995692
                ],
                [
                    71.1561047,
                    57.7023526
                ],
                [
                    71.1586355,
                    57.703521
                ],
                [
                    71.159004,
                    57.704033
                ],
                [
                    71.160208,
                    57.7038886
                ],
                [
                    71.1632302,
                    57.7139827
                ],
                [
                    71.1616331,
                    57.7152295
                ],
                [
                    71.1636234,
                    57.7172112
                ],
                [
                    71.1640657,
                    57.7184317
                ],
                [
                    71.1650485,
                    57.7190878
                ],
                [
                    71.1675793,
                    57.7192321
                ],
                [
                    71.1673582,
                    57.7197308
                ],
                [
                    71.1677267,
                    57.7211217
                ],
                [
                    71.1688324,
                    57.721581
                ],
                [
                    71.1721249,
                    57.7216597
                ],
                [
                    71.1724444,
                    57.7221584
                ],
                [
                    71.1737466,
                    57.722014
                ],
                [
                    71.1745575,
                    57.7223158
                ],
                [
                    71.1777763,
                    57.7222896
                ],
                [
                    71.1809214,
                    57.7216335
                ],
                [
                    71.1711572,
                    57.7141877
                ],
                [
                    71.1667627,
                    57.7083921
                ],
                [
                    71.1664891,
                    57.7049922
                ],
                [
                    71.1682031,
                    57.7019719
                ],
                [
                    71.1742205,
                    57.6986494
                ],
                [
                    71.1830825,
                    57.6979283
                ],
                [
                    71.1861276,
                    57.6983571
                ],
                [
                    71.1951172,
                    57.6999648
                ],
                [
                    71.1979434,
                    57.6972072
                ],
                [
                    71.1980528,
                    57.6962133
                ],
                [
                    71.1972689,
                    57.6945469
                ],
                [
                    71.195883,
                    57.6937868
                ],
                [
                    71.1919262,
                    57.6920131
                ],
                [
                    71.193827,
                    57.6910569
                ],
                [
                    71.1930429,
                    57.6904331
                ],
                [
                    71.1921677,
                    57.6894585
                ],
                [
                    71.1911283,
                    57.6877528
                ],
                [
                    71.1840898,
                    57.689439
                ],
                [
                    71.1855486,
                    57.6906378
                ],
                [
                    71.1843087,
                    57.6912908
                ],
                [
                    71.1831052,
                    57.6921094
                ],
                [
                    71.1825764,
                    57.6927039
                ],
                [
                    71.1823029,
                    57.6928014
                ],
                [
                    71.181537,
                    57.6928014
                ],
                [
                    71.1761579,
                    57.691934
                ],
                [
                    71.1714716,
                    57.689975
                ],
                [
                    71.1698827,
                    57.6890775
                ],
                [
                    71.1686062,
                    57.6878713
                ],
                [
                    71.1676262,
                    57.6862021
                ],
                [
                    71.1674666,
                    57.6844232
                ],
                [
                    71.1676946,
                    57.6834606
                ],
                [
                    71.1688342,
                    57.6819496
                ],
                [
                    71.1695636,
                    57.681316
                ],
                [
                    71.1704753,
                    57.6806945
                ],
                [
                    71.1704525,
                    57.6805361
                ],
                [
                    71.1708856,
                    57.6802314
                ],
                [
                    71.1715238,
                    57.6799511
                ],
                [
                    71.172048,
                    57.6794515
                ],
                [
                    71.1732333,
                    57.6789397
                ],
                [
                    71.1734384,
                    57.6787447
                ],
                [
                    71.1731649,
                    57.6783425
                ],
                [
                    71.1732333,
                    57.6780622
                ],
                [
                    71.1730053,
                    57.6779281
                ],
                [
                    71.1728914,
                    57.6782572
                ],
                [
                    71.172709,
                    57.6780256
                ],
                [
                    71.1725723,
                    57.6775138
                ],
                [
                    71.1727774,
                    57.6773919
                ],
                [
                    71.1722532,
                    57.6769288
                ],
                [
                    71.1720251,
                    57.6765388
                ],
                [
                    71.1726862,
                    57.6764291
                ],
                [
                    71.1732105,
                    57.675771
                ],
                [
                    71.1736891,
                    57.6752469
                ],
                [
                    71.1740766,
                    57.675125
                ],
                [
                    71.1741222,
                    57.6748325
                ],
                [
                    71.1737574,
                    57.6747594
                ],
                [
                    71.1735524,
                    57.6746132
                ],
                [
                    71.1735232,
                    57.6744483
                ],
                [
                    71.1733502,
                    57.6742969
                ],
                [
                    71.1756933,
                    57.6744146
                ],
                [
                    71.1767154,
                    57.6739353
                ],
                [
                    71.1772344,
                    57.6739774
                ],
                [
                    71.1773916,
                    57.6738681
                ],
                [
                    71.176967,
                    57.673784
                ],
                [
                    71.1769985,
                    57.6735822
                ],
                [
                    71.1779892,
                    57.6727076
                ],
                [
                    71.1776589,
                    57.6725815
                ],
                [
                    71.1780364,
                    57.672161
                ],
                [
                    71.1779576,
                    57.6720685
                ],
                [
                    71.178115,
                    57.6719844
                ],
                [
                    71.1782722,
                    57.6720433
                ],
                [
                    71.1786025,
                    57.6717742
                ],
                [
                    71.1785553,
                    57.6714967
                ],
                [
                    71.1790428,
                    57.671278
                ],
                [
                    71.1789955,
                    57.6711098
                ],
                [
                    71.1781622,
                    57.6707482
                ],
                [
                    71.1791529,
                    57.6702184
                ],
                [
                    71.1795303,
                    57.6701343
                ],
                [
                    71.1800334,
                    57.6698063
                ],
                [
                    71.1808984,
                    57.6696549
                ],
                [
                    71.1792787,
                    57.6694783
                ],
                [
                    71.1774545,
                    57.6694783
                ],
                [
                    71.176173,
                    57.6696736
                ],
                [
                    71.1653618,
                    57.6734677
                ],
                [
                    71.1666518,
                    57.6786737
                ],
                [
                    71.1411901,
                    57.6865389
                ]
            ],
            "longitude": 71.169968,
            "latitude": 57.693462
        },
        "5869": {
            "name": "ИСИЛЬКУЛЬ",
            "population": 23865,
            "type": "town",
            "poly": [
                [
                    71.1886532,
                    54.9356498
                ],
                [
                    71.1888394,
                    54.9416773
                ],
                [
                    71.1946756,
                    54.937772
                ],
                [
                    71.2000461,
                    54.9393592
                ],
                [
                    71.2072482,
                    54.9417308
                ],
                [
                    71.2089555,
                    54.9322968
                ],
                [
                    71.2172766,
                    54.9323285
                ],
                [
                    71.2370187,
                    54.9324038
                ],
                [
                    71.2372981,
                    54.9369695
                ],
                [
                    71.2373913,
                    54.937237
                ],
                [
                    71.2376086,
                    54.9375759
                ],
                [
                    71.2381363,
                    54.937879
                ],
                [
                    71.237919,
                    54.9390738
                ],
                [
                    71.2468285,
                    54.9391273
                ],
                [
                    71.2275505,
                    54.9476327
                ],
                [
                    71.2309653,
                    54.9486667
                ],
                [
                    71.2341938,
                    54.949469
                ],
                [
                    71.239347,
                    54.9505743
                ],
                [
                    71.2476666,
                    54.9518401
                ],
                [
                    71.2565761,
                    54.9528206
                ],
                [
                    71.2560794,
                    54.9463133
                ],
                [
                    71.257259,
                    54.9385032
                ],
                [
                    71.2740768,
                    54.9381941
                ],
                [
                    71.2768598,
                    54.9432001
                ],
                [
                    71.292307,
                    54.9431431
                ],
                [
                    71.2893765,
                    54.9391915
                ],
                [
                    71.2892027,
                    54.9389205
                ],
                [
                    71.2892772,
                    54.9387635
                ],
                [
                    71.2898732,
                    54.9385495
                ],
                [
                    71.2912639,
                    54.938307
                ],
                [
                    71.2907424,
                    54.937394
                ],
                [
                    71.2901712,
                    54.9374938
                ],
                [
                    71.2900222,
                    54.9372085
                ],
                [
                    71.289749,
                    54.937237
                ],
                [
                    71.2893765,
                    54.937394
                ],
                [
                    71.2893765,
                    54.9377078
                ],
                [
                    71.288855,
                    54.9378648
                ],
                [
                    71.2861728,
                    54.9327427
                ],
                [
                    71.2903699,
                    54.9321862
                ],
                [
                    71.2974726,
                    54.9317296
                ],
                [
                    71.2985653,
                    54.9309163
                ],
                [
                    71.2935736,
                    54.9288758
                ],
                [
                    71.2935487,
                    54.9283906
                ],
                [
                    71.2979941,
                    54.9233815
                ],
                [
                    71.2984412,
                    54.9235385
                ],
                [
                    71.2985405,
                    54.9236955
                ],
                [
                    71.2993849,
                    54.9242093
                ],
                [
                    71.2996581,
                    54.9244519
                ],
                [
                    71.301322,
                    54.9255507
                ],
                [
                    71.3025886,
                    54.926036
                ],
                [
                    71.3062144,
                    54.9283335
                ],
                [
                    71.3068353,
                    54.9280053
                ],
                [
                    71.30763,
                    54.9273489
                ],
                [
                    71.3125224,
                    54.9236812
                ],
                [
                    71.3103121,
                    54.9176153
                ],
                [
                    71.3254365,
                    54.9183718
                ],
                [
                    71.3255358,
                    54.9167588
                ],
                [
                    71.3261567,
                    54.9167588
                ],
                [
                    71.3268769,
                    54.9168159
                ],
                [
                    71.3277213,
                    54.9170443
                ],
                [
                    71.3287147,
                    54.91703
                ],
                [
                    71.3290872,
                    54.9172299
                ],
                [
                    71.3291865,
                    54.9175296
                ],
                [
                    71.3300309,
                    54.9181006
                ],
                [
                    71.3306269,
                    54.9182576
                ],
                [
                    71.3314216,
                    54.9182148
                ],
                [
                    71.3321418,
                    54.9182576
                ],
                [
                    71.3328372,
                    54.9183718
                ],
                [
                    71.3332097,
                    54.9185573
                ],
                [
                    71.3334581,
                    54.9184717
                ],
                [
                    71.3337313,
                    54.9183147
                ],
                [
                    71.3340541,
                    54.9182576
                ],
                [
                    71.3348488,
                    54.9182576
                ],
                [
                    71.3356435,
                    54.9182719
                ],
                [
                    71.3361899,
                    54.9184289
                ],
                [
                    71.3365128,
                    54.9186144
                ],
                [
                    71.3371088,
                    54.9187143
                ],
                [
                    71.3380525,
                    54.9189427
                ],
                [
                    71.3389466,
                    54.9192996
                ],
                [
                    71.3419019,
                    54.9193852
                ],
                [
                    71.3437148,
                    54.9195422
                ],
                [
                    71.3453539,
                    54.9195137
                ],
                [
                    71.3453291,
                    54.919271
                ],
                [
                    71.3474897,
                    54.9193852
                ],
                [
                    71.3478374,
                    54.9193852
                ],
                [
                    71.3479119,
                    54.918957
                ],
                [
                    71.3480112,
                    54.9187429
                ],
                [
                    71.3485576,
                    54.918643
                ],
                [
                    71.3512894,
                    54.9187429
                ],
                [
                    71.3515377,
                    54.9188
                ],
                [
                    71.3515129,
                    54.9190712
                ],
                [
                    71.3515626,
                    54.9193709
                ],
                [
                    71.3518109,
                    54.9195707
                ],
                [
                    71.3526056,
                    54.9196564
                ],
                [
                    71.3545676,
                    54.9195707
                ],
                [
                    71.3562563,
                    54.9195993
                ],
                [
                    71.3573739,
                    54.9192853
                ],
                [
                    71.3583673,
                    54.919114
                ],
                [
                    71.358864,
                    54.9189427
                ],
                [
                    71.3596835,
                    54.9188856
                ],
                [
                    71.3604037,
                    54.9190569
                ],
                [
                    71.361869,
                    54.9187001
                ],
                [
                    71.362614,
                    54.9183575
                ],
                [
                    71.3631604,
                    54.9181006
                ],
                [
                    71.3633591,
                    54.9178437
                ],
                [
                    71.3633342,
                    54.9175296
                ],
                [
                    71.3631604,
                    54.9172299
                ],
                [
                    71.3628127,
                    54.91703
                ],
                [
                    71.3621422,
                    54.9169301
                ],
                [
                    71.3613723,
                    54.9168017
                ],
                [
                    71.3612978,
                    54.9165733
                ],
                [
                    71.3610246,
                    54.9164305
                ],
                [
                    71.3557348,
                    54.9159024
                ],
                [
                    71.3552133,
                    54.915831
                ],
                [
                    71.3554616,
                    54.9145035
                ],
                [
                    71.3197493,
                    54.9115627
                ],
                [
                    71.3195507,
                    54.8931996
                ],
                [
                    71.3176384,
                    54.8931853
                ],
                [
                    71.31739,
                    54.8932425
                ],
                [
                    71.317241,
                    54.8935424
                ],
                [
                    71.3171665,
                    54.8942279
                ],
                [
                    71.3166202,
                    54.8946564
                ],
                [
                    71.3162228,
                    54.8946993
                ],
                [
                    71.3157261,
                    54.8947564
                ],
                [
                    71.3155274,
                    54.8950277
                ],
                [
                    71.3156516,
                    54.8959703
                ],
                [
                    71.3103867,
                    54.896156
                ],
                [
                    71.3074065,
                    54.8942422
                ],
                [
                    71.2976216,
                    54.8935138
                ],
                [
                    71.2979196,
                    54.8915143
                ],
                [
                    71.2944179,
                    54.8916714
                ],
                [
                    71.2954113,
                    54.8888575
                ],
                [
                    71.2954113,
                    54.8878719
                ],
                [
                    71.2936481,
                    54.8702268
                ],
                [
                    71.2800883,
                    54.8699982
                ],
                [
                    71.2795999,
                    54.8669511
                ],
                [
                    71.2670551,
                    54.8663164
                ],
                [
                    71.2633746,
                    54.8733421
                ],
                [
                    71.2623501,
                    54.8732706
                ],
                [
                    71.2576936,
                    54.8747174
                ],
                [
                    71.2563588,
                    54.8738243
                ],
                [
                    71.2483806,
                    54.8751104
                ],
                [
                    71.2481012,
                    54.8768964
                ],
                [
                    71.2496844,
                    54.8768786
                ],
                [
                    71.2490636,
                    54.8789503
                ],
                [
                    71.2446554,
                    54.8788967
                ],
                [
                    71.2442208,
                    54.8835042
                ],
                [
                    71.2463938,
                    54.8836828
                ],
                [
                    71.2447796,
                    54.8935031
                ],
                [
                    71.2103835,
                    54.8935924
                ],
                [
                    71.2104456,
                    54.9038744
                ],
                [
                    71.2091108,
                    54.9038208
                ],
                [
                    71.2089555,
                    54.906141
                ],
                [
                    71.2090487,
                    54.9084968
                ],
                [
                    71.2434137,
                    54.9093356
                ],
                [
                    71.242917,
                    54.9119053
                ],
                [
                    71.2425755,
                    54.9118875
                ],
                [
                    71.2425755,
                    54.9123693
                ],
                [
                    71.2428549,
                    54.9123693
                ],
                [
                    71.2428239,
                    54.9127619
                ],
                [
                    71.2435068,
                    54.9127976
                ],
                [
                    71.2434758,
                    54.9144214
                ],
                [
                    71.2440966,
                    54.9144392
                ],
                [
                    71.2440966,
                    54.9164377
                ],
                [
                    71.2451521,
                    54.9164198
                ],
                [
                    71.2446244,
                    54.9233422
                ],
                [
                    71.2227698,
                    54.9219329
                ],
                [
                    71.2205037,
                    54.9218437
                ],
                [
                    71.2180823,
                    54.9218437
                ],
                [
                    71.2176477,
                    54.9220221
                ],
                [
                    71.1997046,
                    54.9340447
                ],
                [
                    71.1886532,
                    54.9356498
                ]
            ],
            "longitude": 71.259987,
            "latitude": 54.904892
        },
        "5870": {
            "name": "НАЗЫВАЕВСК",
            "population": 11382,
            "type": "town",
            "poly": [
                [
                    71.2669289,
                    55.6265329
                ],
                [
                    71.2842601,
                    55.6279046
                ],
                [
                    71.3166819,
                    55.629139
                ],
                [
                    71.3427328,
                    55.6309526
                ],
                [
                    71.4071175,
                    55.6245667
                ],
                [
                    71.391541,
                    55.6107396
                ],
                [
                    71.379231,
                    55.6037404
                ],
                [
                    71.3765044,
                    55.5923163
                ],
                [
                    71.3840902,
                    55.5888839
                ],
                [
                    71.3884635,
                    55.5852833
                ],
                [
                    71.3878696,
                    55.5748611
                ],
                [
                    71.397912,
                    55.5651994
                ],
                [
                    71.397669,
                    55.5649704
                ],
                [
                    71.3971291,
                    55.5626042
                ],
                [
                    71.3954014,
                    55.5585279
                ],
                [
                    71.3942946,
                    55.5566042
                ],
                [
                    71.3929718,
                    55.5537336
                ],
                [
                    71.3905152,
                    55.5524967
                ],
                [
                    71.3848461,
                    55.5487248
                ],
                [
                    71.3756675,
                    55.553138
                ],
                [
                    71.3677308,
                    55.5523135
                ],
                [
                    71.3441707,
                    55.5517266
                ],
                [
                    71.3561637,
                    55.5343023
                ],
                [
                    71.3611708,
                    55.5300279
                ],
                [
                    71.3319885,
                    55.5237172
                ],
                [
                    71.3158181,
                    55.539683
                ],
                [
                    71.3029141,
                    55.5400648
                ],
                [
                    71.2982169,
                    55.5486637
                ],
                [
                    71.2927907,
                    55.5527105
                ],
                [
                    71.2883095,
                    55.5613677
                ],
                [
                    71.2892813,
                    55.5682523
                ],
                [
                    71.291306,
                    55.5730297
                ],
                [
                    71.291171,
                    55.5733807
                ],
                [
                    71.2856639,
                    55.5878312
                ],
                [
                    71.2669289,
                    55.6265329
                ]
            ],
            "longitude": 71.349365,
            "latitude": 55.564896
        },
        "5871": {
            "name": "КРУТИНКА",
            "population": 6857,
            "type": "town",
            "poly": [
                [
                    71.4728356,
                    56.0148871
                ],
                [
                    71.4735606,
                    56.0150852
                ],
                [
                    71.4737539,
                    56.0148421
                ],
                [
                    71.474656,
                    56.0150582
                ],
                [
                    71.4751393,
                    56.0143919
                ],
                [
                    71.4754937,
                    56.0140857
                ],
                [
                    71.476122,
                    56.0136625
                ],
                [
                    71.4769435,
                    56.0132842
                ],
                [
                    71.4778779,
                    56.0130231
                ],
                [
                    71.4783612,
                    56.0137165
                ],
                [
                    71.4787478,
                    56.0141667
                ],
                [
                    71.4791022,
                    56.014635
                ],
                [
                    71.479215,
                    56.014617
                ],
                [
                    71.4795049,
                    56.0149412
                ],
                [
                    71.4776846,
                    56.0155355
                ],
                [
                    71.477604,
                    56.0159947
                ],
                [
                    71.4777329,
                    56.0159317
                ],
                [
                    71.47878,
                    56.0164269
                ],
                [
                    71.4796982,
                    56.0170752
                ],
                [
                    71.4815347,
                    56.0162378
                ],
                [
                    71.4837095,
                    56.0155175
                ],
                [
                    71.4855782,
                    56.0153104
                ],
                [
                    71.4873019,
                    56.014725
                ],
                [
                    71.4936329,
                    56.0141127
                ],
                [
                    71.4941484,
                    56.0141397
                ],
                [
                    71.4968709,
                    56.0137345
                ],
                [
                    71.5048934,
                    56.0131852
                ],
                [
                    71.5105801,
                    56.0132572
                ],
                [
                    71.5108539,
                    56.0133653
                ],
                [
                    71.5126904,
                    56.0132032
                ],
                [
                    71.5136086,
                    56.0133293
                ],
                [
                    71.5135925,
                    56.0134643
                ],
                [
                    71.5136409,
                    56.0136084
                ],
                [
                    71.5139791,
                    56.0137615
                ],
                [
                    71.5143497,
                    56.0137885
                ],
                [
                    71.5148813,
                    56.0137435
                ],
                [
                    71.5155418,
                    56.0137075
                ],
                [
                    71.51617,
                    56.0137435
                ],
                [
                    71.5167178,
                    56.0138336
                ],
                [
                    71.516895,
                    56.0137795
                ],
                [
                    71.5168466,
                    56.0136445
                ],
                [
                    71.5193436,
                    56.0139056
                ],
                [
                    71.5240314,
                    56.0147971
                ],
                [
                    71.5255779,
                    56.0150042
                ],
                [
                    71.5260129,
                    56.0151033
                ],
                [
                    71.5291704,
                    56.0156796
                ],
                [
                    71.5369351,
                    56.0171113
                ],
                [
                    71.5400765,
                    56.0177145
                ],
                [
                    71.5412524,
                    56.0160938
                ],
                [
                    71.5408658,
                    56.0157336
                ],
                [
                    71.5412847,
                    56.0143198
                ],
                [
                    71.5437172,
                    56.014599
                ],
                [
                    71.5405758,
                    56.0097631
                ],
                [
                    71.5372734,
                    56.0049175
                ],
                [
                    71.535743,
                    56.0049445
                ],
                [
                    71.535598,
                    56.0046473
                ],
                [
                    71.5315868,
                    56.0046563
                ],
                [
                    71.5298147,
                    56.0031971
                ],
                [
                    71.531329,
                    56.0024585
                ],
                [
                    71.5308296,
                    56.0021162
                ],
                [
                    71.5355979,
                    55.9997651
                ],
                [
                    71.5344865,
                    55.9990534
                ],
                [
                    71.5342287,
                    55.9990444
                ],
                [
                    71.5335843,
                    55.9991525
                ],
                [
                    71.5336005,
                    55.9990444
                ],
                [
                    71.53265,
                    55.9988913
                ],
                [
                    71.5311035,
                    55.9991976
                ],
                [
                    71.530298,
                    55.9995399
                ],
                [
                    71.5295248,
                    56.0000083
                ],
                [
                    71.5286871,
                    56.0009181
                ],
                [
                    71.5289932,
                    56.0012244
                ],
                [
                    71.5290415,
                    56.0016298
                ],
                [
                    71.5286871,
                    56.0019721
                ],
                [
                    71.5283004,
                    56.0021883
                ],
                [
                    71.5277205,
                    56.0023324
                ],
                [
                    71.5270117,
                    56.0024405
                ],
                [
                    71.526319,
                    56.0021162
                ],
                [
                    71.5260773,
                    56.0022333
                ],
                [
                    71.5208418,
                    56.0000804
                ],
                [
                    71.5228232,
                    55.9991886
                ],
                [
                    71.5218728,
                    55.998567
                ],
                [
                    71.5217761,
                    55.998576
                ],
                [
                    71.513222,
                    55.9954949
                ],
                [
                    71.5125453,
                    55.9951706
                ],
                [
                    71.5118205,
                    55.9948913
                ],
                [
                    71.5109667,
                    55.9947561
                ],
                [
                    71.5093234,
                    55.995558
                ],
                [
                    71.508808,
                    55.9952607
                ],
                [
                    71.5081636,
                    55.9942966
                ],
                [
                    71.5068266,
                    55.9927379
                ],
                [
                    71.5031374,
                    55.994684
                ],
                [
                    71.5044746,
                    55.9953147
                ],
                [
                    71.5013977,
                    55.9970625
                ],
                [
                    71.4992873,
                    55.9981436
                ],
                [
                    71.4975314,
                    55.9991075
                ],
                [
                    71.4967259,
                    55.999621
                ],
                [
                    71.4950344,
                    56.000765
                ],
                [
                    71.4937618,
                    56.0016027
                ],
                [
                    71.4918448,
                    56.0027377
                ],
                [
                    71.4923924,
                    56.0032782
                ],
                [
                    71.4913454,
                    56.0038817
                ],
                [
                    71.4914259,
                    56.0039357
                ],
                [
                    71.4913293,
                    56.0040078
                ],
                [
                    71.4909749,
                    56.0038006
                ],
                [
                    71.4900405,
                    56.004296
                ],
                [
                    71.4888001,
                    56.0045572
                ],
                [
                    71.4881235,
                    56.0053318
                ],
                [
                    71.4879302,
                    56.0052598
                ],
                [
                    71.4867703,
                    56.0058542
                ],
                [
                    71.4863031,
                    56.0064577
                ],
                [
                    71.4859648,
                    56.0066649
                ],
                [
                    71.4859004,
                    56.0066198
                ],
                [
                    71.4855943,
                    56.0067819
                ],
                [
                    71.4855138,
                    56.0067279
                ],
                [
                    71.4852721,
                    56.006845
                ],
                [
                    71.4851916,
                    56.006791
                ],
                [
                    71.4835806,
                    56.0075115
                ],
                [
                    71.4836612,
                    56.0075745
                ],
                [
                    71.4833873,
                    56.0077186
                ],
                [
                    71.4834679,
                    56.0078087
                ],
                [
                    71.483339,
                    56.0078537
                ],
                [
                    71.4832101,
                    56.0077817
                ],
                [
                    71.4825979,
                    56.0080158
                ],
                [
                    71.4825013,
                    56.0079438
                ],
                [
                    71.4821791,
                    56.0081059
                ],
                [
                    71.481873,
                    56.0083311
                ],
                [
                    71.4820986,
                    56.0084842
                ],
                [
                    71.4820019,
                    56.0085562
                ],
                [
                    71.4818891,
                    56.0084932
                ],
                [
                    71.4816153,
                    56.0086643
                ],
                [
                    71.4814059,
                    56.0088534
                ],
                [
                    71.481422,
                    56.0089795
                ],
                [
                    71.4810837,
                    56.0091777
                ],
                [
                    71.480987,
                    56.0091777
                ],
                [
                    71.4807937,
                    56.0093128
                ],
                [
                    71.4806165,
                    56.0092227
                ],
                [
                    71.4804071,
                    56.0094298
                ],
                [
                    71.4799399,
                    56.0094298
                ],
                [
                    71.4799238,
                    56.0091056
                ],
                [
                    71.4794405,
                    56.0089705
                ],
                [
                    71.4791022,
                    56.0095019
                ],
                [
                    71.4786995,
                    56.0092317
                ],
                [
                    71.4786189,
                    56.0090246
                ],
                [
                    71.4781034,
                    56.0084482
                ],
                [
                    71.4773624,
                    56.0088444
                ],
                [
                    71.4766697,
                    56.0084482
                ],
                [
                    71.4751071,
                    56.0093488
                ],
                [
                    71.4776846,
                    56.0103935
                ],
                [
                    71.476122,
                    56.0111139
                ],
                [
                    71.4756064,
                    56.0114922
                ],
                [
                    71.4761542,
                    56.0119424
                ],
                [
                    71.4766697,
                    56.0122666
                ],
                [
                    71.4764441,
                    56.0123297
                ],
                [
                    71.4752198,
                    56.0127529
                ],
                [
                    71.4751232,
                    56.012888
                ],
                [
                    71.4748654,
                    56.0130321
                ],
                [
                    71.4747043,
                    56.0132572
                ],
                [
                    71.4744144,
                    56.0134553
                ],
                [
                    71.4740761,
                    56.0135724
                ],
                [
                    71.4735444,
                    56.0140407
                ],
                [
                    71.4728356,
                    56.0148871
                ]
            ],
            "longitude": 71.511307,
            "latitude": 56.006351
        },
        "5872": {
            "name": "ПОЛТАВКА",
            "population": 6952,
            "type": "town",
            "poly": [
                [
                    71.7252233,
                    54.3232929
                ],
                [
                    71.7285097,
                    54.3263286
                ],
                [
                    71.7321798,
                    54.3291962
                ],
                [
                    71.7351781,
                    54.3318957
                ],
                [
                    71.7380328,
                    54.3341336
                ],
                [
                    71.7345546,
                    54.342091
                ],
                [
                    71.7324916,
                    54.3495575
                ],
                [
                    71.733715,
                    54.349865
                ],
                [
                    71.7383291,
                    54.3512777
                ],
                [
                    71.7384191,
                    54.3522563
                ],
                [
                    71.7419272,
                    54.3679983
                ],
                [
                    71.7420772,
                    54.3683476
                ],
                [
                    71.7433664,
                    54.3697451
                ],
                [
                    71.746395,
                    54.3716665
                ],
                [
                    71.740518,
                    54.3740593
                ],
                [
                    71.7429767,
                    54.3764172
                ],
                [
                    71.7482764,
                    54.3744134
                ],
                [
                    71.7498506,
                    54.3758979
                ],
                [
                    71.7513123,
                    54.375243
                ],
                [
                    71.753936,
                    54.3770986
                ],
                [
                    71.7572718,
                    54.3782775
                ],
                [
                    71.7639434,
                    54.3779718
                ],
                [
                    71.76563,
                    54.3785176
                ],
                [
                    71.7693406,
                    54.3756141
                ],
                [
                    71.7700526,
                    54.3757669
                ],
                [
                    71.7707274,
                    54.3762909
                ],
                [
                    71.7712521,
                    54.3758106
                ],
                [
                    71.7735759,
                    54.3745225
                ],
                [
                    71.7748876,
                    54.375243
                ],
                [
                    71.7731636,
                    54.3765092
                ],
                [
                    71.7727139,
                    54.3770986
                ],
                [
                    71.7744005,
                    54.3777099
                ],
                [
                    71.7755248,
                    54.3763127
                ],
                [
                    71.7766493,
                    54.3745225
                ],
                [
                    71.7769867,
                    54.3744352
                ],
                [
                    71.7773989,
                    54.3736274
                ],
                [
                    71.7777738,
                    54.3733436
                ],
                [
                    71.7784484,
                    54.3731908
                ],
                [
                    71.7791231,
                    54.3708109
                ],
                [
                    71.7807677,
                    54.366609
                ],
                [
                    71.7823989,
                    54.3668047
                ],
                [
                    71.7884198,
                    54.3661199
                ],
                [
                    71.7895951,
                    54.3630592
                ],
                [
                    71.788012,
                    54.3609347
                ],
                [
                    71.7854453,
                    54.3597886
                ],
                [
                    71.7783689,
                    54.3587263
                ],
                [
                    71.7759222,
                    54.3563919
                ],
                [
                    71.7746029,
                    54.3540015
                ],
                [
                    71.7728278,
                    54.3495698
                ],
                [
                    71.7731395,
                    54.3485631
                ],
                [
                    71.7731395,
                    54.3480039
                ],
                [
                    71.7733075,
                    54.3476544
                ],
                [
                    71.7734035,
                    54.3467595
                ],
                [
                    71.7675615,
                    54.3505361
                ],
                [
                    71.7660983,
                    54.3379377
                ],
                [
                    71.7715675,
                    54.3325671
                ],
                [
                    71.768569,
                    54.3318398
                ],
                [
                    71.7640593,
                    54.3316859
                ],
                [
                    71.7577746,
                    54.3316999
                ],
                [
                    71.7625242,
                    54.3259509
                ],
                [
                    71.7430222,
                    54.3247058
                ],
                [
                    71.7252233,
                    54.3232929
                ]
            ],
            "longitude": 71.760139,
            "latitude": 54.363895
        },
        "5873": {
            "name": "МОСКАЛЕНКИ",
            "population": 9259,
            "type": "town",
            "poly": [
                [
                    71.8974809,
                    54.9474055
                ],
                [
                    71.9155249,
                    54.9477683
                ],
                [
                    71.9245723,
                    54.9478806
                ],
                [
                    71.9311497,
                    54.947936
                ],
                [
                    71.934246,
                    54.9479514
                ],
                [
                    71.9352699,
                    54.9476401
                ],
                [
                    71.9364119,
                    54.9480595
                ],
                [
                    71.9430873,
                    54.9482008
                ],
                [
                    71.9487027,
                    54.9482479
                ],
                [
                    71.9485576,
                    54.945936
                ],
                [
                    71.9500317,
                    54.9450435
                ],
                [
                    71.9518699,
                    54.9438032
                ],
                [
                    71.9523874,
                    54.9431728
                ],
                [
                    71.9528871,
                    54.9424758
                ],
                [
                    71.9534135,
                    54.9417839
                ],
                [
                    71.9535403,
                    54.941756
                ],
                [
                    71.9644241,
                    54.9419807
                ],
                [
                    71.964727,
                    54.9418104
                ],
                [
                    71.9649099,
                    54.9406397
                ],
                [
                    71.9652569,
                    54.940357
                ],
                [
                    71.9757022,
                    54.9404497
                ],
                [
                    71.975769,
                    54.9388889
                ],
                [
                    71.9661799,
                    54.9384464
                ],
                [
                    71.9657635,
                    54.9384537
                ],
                [
                    71.9652461,
                    54.937852
                ],
                [
                    71.9596874,
                    54.9376671
                ],
                [
                    71.9595676,
                    54.937504
                ],
                [
                    71.9595865,
                    54.9372938
                ],
                [
                    71.959592,
                    54.9362108
                ],
                [
                    71.9594939,
                    54.9345909
                ],
                [
                    71.9553536,
                    54.9345396
                ],
                [
                    71.9545862,
                    54.934473
                ],
                [
                    71.9522573,
                    54.9341398
                ],
                [
                    71.9513651,
                    54.9341398
                ],
                [
                    71.9499552,
                    54.9344012
                ],
                [
                    71.9458685,
                    54.9345499
                ],
                [
                    71.9454614,
                    54.9337512
                ],
                [
                    71.9460545,
                    54.9332364
                ],
                [
                    71.9452974,
                    54.9327362
                ],
                [
                    71.9454741,
                    54.9323157
                ],
                [
                    71.9456886,
                    54.9313151
                ],
                [
                    71.9458021,
                    54.9302638
                ],
                [
                    71.9461429,
                    54.9271967
                ],
                [
                    71.9457012,
                    54.9269284
                ],
                [
                    71.9458147,
                    54.9264716
                ],
                [
                    71.9460293,
                    54.9264136
                ],
                [
                    71.9463448,
                    54.9261816
                ],
                [
                    71.9462564,
                    54.9260075
                ],
                [
                    71.9460924,
                    54.9258625
                ],
                [
                    71.9462564,
                    54.9255072
                ],
                [
                    71.9445529,
                    54.9252679
                ],
                [
                    71.9449845,
                    54.924126
                ],
                [
                    71.9445113,
                    54.9240499
                ],
                [
                    71.943975,
                    54.9239846
                ],
                [
                    71.9443283,
                    54.9237562
                ],
                [
                    71.9428367,
                    54.9231783
                ],
                [
                    71.9422562,
                    54.9228701
                ],
                [
                    71.9401678,
                    54.922696
                ],
                [
                    71.9395241,
                    54.9219055
                ],
                [
                    71.9338267,
                    54.9235553
                ],
                [
                    71.9321232,
                    54.9234901
                ],
                [
                    71.930369,
                    54.9234973
                ],
                [
                    71.9269367,
                    54.9235626
                ],
                [
                    71.9264446,
                    54.9247301
                ],
                [
                    71.9253215,
                    54.9259483
                ],
                [
                    71.9211765,
                    54.925605
                ],
                [
                    71.920778,
                    54.9360754
                ],
                [
                    71.9198442,
                    54.9360319
                ],
                [
                    71.9168909,
                    54.9359328
                ],
                [
                    71.9131872,
                    54.9357987
                ],
                [
                    71.9087832,
                    54.9356465
                ],
                [
                    71.8997042,
                    54.9353017
                ],
                [
                    71.8974809,
                    54.9474055
                ]
            ],
            "longitude": 71.92588,
            "latitude": 54.939468
        },
        "5874": {
            "name": "ТЮКАЛИНСК",
            "population": 10546,
            "type": "town",
            "poly": [
                [
                    72.1304222,
                    55.8784452
                ],
                [
                    72.1311677,
                    55.8877528
                ],
                [
                    72.1340057,
                    55.8956154
                ],
                [
                    72.1333082,
                    55.8978134
                ],
                [
                    72.1338373,
                    55.8989865
                ],
                [
                    72.1340538,
                    55.8990674
                ],
                [
                    72.1376853,
                    55.8993506
                ],
                [
                    72.1382866,
                    55.9000787
                ],
                [
                    72.1391284,
                    55.9006315
                ],
                [
                    72.1502155,
                    55.9001866
                ],
                [
                    72.1584647,
                    55.899809
                ],
                [
                    72.1641887,
                    55.8993101
                ],
                [
                    72.1718367,
                    55.8983932
                ],
                [
                    72.1949008,
                    55.8948737
                ],
                [
                    72.195454,
                    55.895521
                ],
                [
                    72.1960792,
                    55.8957772
                ],
                [
                    72.1966325,
                    55.8960739
                ],
                [
                    72.1974983,
                    55.8959121
                ],
                [
                    72.1981476,
                    55.8959525
                ],
                [
                    72.1987729,
                    55.8960334
                ],
                [
                    72.1996147,
                    55.8960874
                ],
                [
                    72.200745,
                    55.8961683
                ],
                [
                    72.201659,
                    55.8963301
                ],
                [
                    72.2032463,
                    55.8967481
                ],
                [
                    72.2037512,
                    55.8969504
                ],
                [
                    72.2039918,
                    55.8971796
                ],
                [
                    72.204064,
                    55.8974898
                ],
                [
                    72.2039918,
                    55.8978269
                ],
                [
                    72.2036311,
                    55.8982853
                ],
                [
                    72.2030058,
                    55.8986899
                ],
                [
                    72.2026209,
                    55.8990809
                ],
                [
                    72.2013944,
                    55.906321
                ],
                [
                    72.2021881,
                    55.9060649
                ],
                [
                    72.202645,
                    55.9060379
                ],
                [
                    72.2035589,
                    55.9059705
                ],
                [
                    72.2043045,
                    55.9058896
                ],
                [
                    72.2051462,
                    55.905647
                ],
                [
                    72.2057715,
                    55.9054043
                ],
                [
                    72.2060361,
                    55.9053234
                ],
                [
                    72.2064209,
                    55.9053504
                ],
                [
                    72.2067816,
                    55.905256
                ],
                [
                    72.2070461,
                    55.9049864
                ],
                [
                    72.2070461,
                    55.9042044
                ],
                [
                    72.2074551,
                    55.9035438
                ],
                [
                    72.2082487,
                    55.9028022
                ],
                [
                    72.2086576,
                    55.9026539
                ],
                [
                    72.2091867,
                    55.9026944
                ],
                [
                    72.2094993,
                    55.9026405
                ],
                [
                    72.2095234,
                    55.9023843
                ],
                [
                    72.2094512,
                    55.9016697
                ],
                [
                    72.2096436,
                    55.9015349
                ],
                [
                    72.2100765,
                    55.9015484
                ],
                [
                    72.2102929,
                    55.9013866
                ],
                [
                    72.210317,
                    55.9010225
                ],
                [
                    72.210341,
                    55.900645
                ],
                [
                    72.2108942,
                    55.9002809
                ],
                [
                    72.2114233,
                    55.8999438
                ],
                [
                    72.2120006,
                    55.8992832
                ],
                [
                    72.212674,
                    55.8988786
                ],
                [
                    72.2133955,
                    55.8987438
                ],
                [
                    72.215079,
                    55.8987842
                ],
                [
                    72.219408,
                    55.8993371
                ],
                [
                    72.2202979,
                    55.8993101
                ],
                [
                    72.2210194,
                    55.8987708
                ],
                [
                    72.221332,
                    55.8986764
                ],
                [
                    72.2220055,
                    55.8987842
                ],
                [
                    72.2200814,
                    55.8962627
                ],
                [
                    72.2135157,
                    55.8956828
                ],
                [
                    72.2162333,
                    55.8863366
                ],
                [
                    72.2318901,
                    55.8858375
                ],
                [
                    72.2387685,
                    55.8919743
                ],
                [
                    72.2394178,
                    55.8917855
                ],
                [
                    72.2404279,
                    55.8919068
                ],
                [
                    72.2417266,
                    55.891799
                ],
                [
                    72.2423519,
                    55.8915562
                ],
                [
                    72.2431937,
                    55.8913
                ],
                [
                    72.2438911,
                    55.8911786
                ],
                [
                    72.2448532,
                    55.8910707
                ],
                [
                    72.2458633,
                    55.8912325
                ],
                [
                    72.2487734,
                    55.8911921
                ],
                [
                    72.2497354,
                    55.8909223
                ],
                [
                    72.2510099,
                    55.8911111
                ],
                [
                    72.2518518,
                    55.8910572
                ],
                [
                    72.2525733,
                    55.8910842
                ],
                [
                    72.2534632,
                    55.8915157
                ],
                [
                    72.2545695,
                    55.8916776
                ],
                [
                    72.2559163,
                    55.8917045
                ],
                [
                    72.2563251,
                    55.8918934
                ],
                [
                    72.256734,
                    55.8919203
                ],
                [
                    72.2571188,
                    55.8919878
                ],
                [
                    72.2574074,
                    55.8921901
                ],
                [
                    72.2578643,
                    55.8923114
                ],
                [
                    72.2585137,
                    55.892244
                ],
                [
                    72.2588985,
                    55.892271
                ],
                [
                    72.2595719,
                    55.8925407
                ],
                [
                    72.260558,
                    55.8925946
                ],
                [
                    72.2610629,
                    55.8922575
                ],
                [
                    72.2629389,
                    55.8916236
                ],
                [
                    72.2638288,
                    55.8916236
                ],
                [
                    72.2640453,
                    55.8915157
                ],
                [
                    72.2620491,
                    55.890747
                ],
                [
                    72.2610149,
                    55.890221
                ],
                [
                    72.2592352,
                    55.8890072
                ],
                [
                    72.2559163,
                    55.8873077
                ],
                [
                    72.2559644,
                    55.8871054
                ],
                [
                    72.2566618,
                    55.8867412
                ],
                [
                    72.2572631,
                    55.8862557
                ],
                [
                    72.2578403,
                    55.8861343
                ],
                [
                    72.2582732,
                    55.8854733
                ],
                [
                    72.3047142,
                    55.8850957
                ],
                [
                    72.3039686,
                    55.884637
                ],
                [
                    72.2855702,
                    55.8712808
                ],
                [
                    72.282588,
                    55.8592427
                ],
                [
                    72.2831652,
                    55.8590673
                ],
                [
                    72.2838145,
                    55.8586353
                ],
                [
                    72.2840791,
                    55.8579469
                ],
                [
                    72.2839107,
                    55.8570696
                ],
                [
                    72.2843196,
                    55.8567861
                ],
                [
                    72.2844158,
                    55.8566241
                ],
                [
                    72.2843196,
                    55.8563811
                ],
                [
                    72.2842715,
                    55.8559492
                ],
                [
                    72.283574,
                    55.8555577
                ],
                [
                    72.2831171,
                    55.8555442
                ],
                [
                    72.2828525,
                    55.8552607
                ],
                [
                    72.2815538,
                    55.8551122
                ],
                [
                    72.2805918,
                    55.8550717
                ],
                [
                    72.2799184,
                    55.8552742
                ],
                [
                    72.2793412,
                    55.8553012
                ],
                [
                    72.2783792,
                    55.8554902
                ],
                [
                    72.2779222,
                    55.8560167
                ],
                [
                    72.2771767,
                    55.8562596
                ],
                [
                    72.2767438,
                    55.8566106
                ],
                [
                    72.2767438,
                    55.8570426
                ],
                [
                    72.2775615,
                    55.8581224
                ],
                [
                    72.2783311,
                    55.8586623
                ],
                [
                    72.272535,
                    55.8592023
                ],
                [
                    72.2717654,
                    55.8588513
                ],
                [
                    72.2709236,
                    55.8581224
                ],
                [
                    72.269673,
                    55.857488
                ],
                [
                    72.2678452,
                    55.8569886
                ],
                [
                    72.2623136,
                    55.8545183
                ],
                [
                    72.264887,
                    55.8420969
                ],
                [
                    72.2665224,
                    55.8420834
                ],
                [
                    72.2683983,
                    55.8417728
                ],
                [
                    72.2696249,
                    55.8408411
                ],
                [
                    72.27013,
                    55.8406655
                ],
                [
                    72.2706591,
                    55.8403144
                ],
                [
                    72.2709717,
                    55.8398283
                ],
                [
                    72.2714527,
                    55.8393691
                ],
                [
                    72.2717894,
                    55.8376945
                ],
                [
                    72.2714287,
                    55.8369247
                ],
                [
                    72.2705869,
                    55.8357497
                ],
                [
                    72.269673,
                    55.8350204
                ],
                [
                    72.2681819,
                    55.8344937
                ],
                [
                    72.2671958,
                    55.8343181
                ],
                [
                    72.2660895,
                    55.8340209
                ],
                [
                    72.2651997,
                    55.8340074
                ],
                [
                    72.2641896,
                    55.8338994
                ],
                [
                    72.2621212,
                    55.8343991
                ],
                [
                    72.2602452,
                    55.8351555
                ],
                [
                    72.2598605,
                    55.8355201
                ],
                [
                    72.2597162,
                    55.8362899
                ],
                [
                    72.2515391,
                    55.8367626
                ],
                [
                    72.249062,
                    55.8483891
                ],
                [
                    72.2450695,
                    55.8490372
                ],
                [
                    72.2415342,
                    55.8446625
                ],
                [
                    72.2317217,
                    55.8466609
                ],
                [
                    72.2326116,
                    55.8419079
                ],
                [
                    72.2263104,
                    55.8492802
                ],
                [
                    72.2121689,
                    55.8490777
                ],
                [
                    72.2042564,
                    55.8488077
                ],
                [
                    72.1960311,
                    55.8488752
                ],
                [
                    72.1935781,
                    55.8488347
                ],
                [
                    72.1821783,
                    55.8480246
                ],
                [
                    72.1823947,
                    55.8464449
                ],
                [
                    72.1824909,
                    55.8415433
                ],
                [
                    72.1608284,
                    55.832799
                ],
                [
                    72.1477189,
                    55.8417902
                ],
                [
                    72.1473295,
                    55.8420159
                ],
                [
                    72.147594,
                    55.8421239
                ],
                [
                    72.147594,
                    55.8422995
                ],
                [
                    72.1472333,
                    55.8424615
                ],
                [
                    72.1471611,
                    55.8427046
                ],
                [
                    72.1472814,
                    55.8432447
                ],
                [
                    72.1472333,
                    55.8435688
                ],
                [
                    72.1471852,
                    55.8438389
                ],
                [
                    72.1474738,
                    55.8440144
                ],
                [
                    72.1479788,
                    55.8442575
                ],
                [
                    72.1486041,
                    55.844649
                ],
                [
                    72.1494218,
                    55.8449191
                ],
                [
                    72.1497586,
                    55.8450541
                ],
                [
                    72.1502155,
                    55.8454862
                ],
                [
                    72.1506965,
                    55.8456347
                ],
                [
                    72.151394,
                    55.8456887
                ],
                [
                    72.1523079,
                    55.8455267
                ],
                [
                    72.1527648,
                    55.8454052
                ],
                [
                    72.1531256,
                    55.8450946
                ],
                [
                    72.1532939,
                    55.8447841
                ],
                [
                    72.1539673,
                    55.8445815
                ],
                [
                    72.1542319,
                    55.8443925
                ],
                [
                    72.1549534,
                    55.8439874
                ],
                [
                    72.1554103,
                    55.8439739
                ],
                [
                    72.1558914,
                    55.8441764
                ],
                [
                    72.1563724,
                    55.84446
                ],
                [
                    72.1569255,
                    55.844406
                ],
                [
                    72.1575268,
                    55.844379
                ],
                [
                    72.1579597,
                    55.8446355
                ],
                [
                    72.1585128,
                    55.8449731
                ],
                [
                    72.1594027,
                    55.8454457
                ],
                [
                    72.1602926,
                    55.8456887
                ],
                [
                    72.1613507,
                    55.8459453
                ],
                [
                    72.1625052,
                    55.8464854
                ],
                [
                    72.1630583,
                    55.8466069
                ],
                [
                    72.1636115,
                    55.8464989
                ],
                [
                    72.1640684,
                    55.8463368
                ],
                [
                    72.1645735,
                    55.8465529
                ],
                [
                    72.1651507,
                    55.8467959
                ],
                [
                    72.1653431,
                    55.8469714
                ],
                [
                    72.1649824,
                    55.8472145
                ],
                [
                    72.1644292,
                    55.8474305
                ],
                [
                    72.1641887,
                    55.8479301
                ],
                [
                    72.1639001,
                    55.8481461
                ],
                [
                    72.1634672,
                    55.8483756
                ],
                [
                    72.1634912,
                    55.8486186
                ],
                [
                    72.163876,
                    55.8486996
                ],
                [
                    72.1643811,
                    55.8486321
                ],
                [
                    72.1646216,
                    55.8489022
                ],
                [
                    72.1643089,
                    55.8493072
                ],
                [
                    72.1634672,
                    55.8495367
                ],
                [
                    72.1628178,
                    55.8497257
                ],
                [
                    72.1625773,
                    55.8499957
                ],
                [
                    72.1621925,
                    55.8500497
                ],
                [
                    72.1617596,
                    55.8501173
                ],
                [
                    72.1612305,
                    55.8504008
                ],
                [
                    72.1610381,
                    55.8504143
                ],
                [
                    72.1599799,
                    55.8505088
                ],
                [
                    72.1591381,
                    55.8509138
                ],
                [
                    72.1589457,
                    55.8512783
                ],
                [
                    72.1594508,
                    55.8515618
                ],
                [
                    72.1594508,
                    55.8519263
                ],
                [
                    72.1590179,
                    55.8524258
                ],
                [
                    72.1589457,
                    55.8528038
                ],
                [
                    72.1597394,
                    55.8533978
                ],
                [
                    72.1605331,
                    55.8539108
                ],
                [
                    72.1609419,
                    55.8546533
                ],
                [
                    72.1610141,
                    55.8553012
                ],
                [
                    72.1612546,
                    55.8558412
                ],
                [
                    72.1612305,
                    55.8562326
                ],
                [
                    72.1606293,
                    55.8568266
                ],
                [
                    72.1594748,
                    55.8575825
                ],
                [
                    72.1586571,
                    55.8579334
                ],
                [
                    72.1599559,
                    55.8584329
                ],
                [
                    72.160966,
                    55.8589593
                ],
                [
                    72.1617115,
                    55.8597287
                ],
                [
                    72.1644532,
                    55.8610649
                ],
                [
                    72.1647659,
                    55.8612673
                ],
                [
                    72.164814,
                    55.8615373
                ],
                [
                    72.163371,
                    55.8633728
                ],
                [
                    72.1627457,
                    55.8639127
                ],
                [
                    72.1618077,
                    55.8651678
                ],
                [
                    72.1505522,
                    55.8747215
                ],
                [
                    72.1446359,
                    55.8753556
                ],
                [
                    72.1417498,
                    55.8785396
                ],
                [
                    72.1304222,
                    55.8784452
                ]
            ],
            "longitude": 72.196617,
            "latitude": 55.870556
        },
        "5875": {
            "name": "ШЕРБАКУЛЬ",
            "population": 6673,
            "type": "town",
            "poly": [
                [
                    72.3560501,
                    54.6307594
                ],
                [
                    72.3644224,
                    54.6302526
                ],
                [
                    72.3644224,
                    54.6318258
                ],
                [
                    72.3666112,
                    54.6318364
                ],
                [
                    72.3667754,
                    54.6325332
                ],
                [
                    72.3677422,
                    54.6325069
                ],
                [
                    72.3732597,
                    54.6347721
                ],
                [
                    72.3800088,
                    54.6377195
                ],
                [
                    72.3811488,
                    54.6374688
                ],
                [
                    72.3813312,
                    54.6374556
                ],
                [
                    72.382152,
                    54.6372313
                ],
                [
                    72.3826308,
                    54.6374028
                ],
                [
                    72.3837252,
                    54.6365055
                ],
                [
                    72.3909712,
                    54.6389651
                ],
                [
                    72.3994529,
                    54.6417413
                ],
                [
                    72.4007662,
                    54.6421635
                ],
                [
                    72.4019335,
                    54.6424063
                ],
                [
                    72.4031921,
                    54.6425435
                ],
                [
                    72.4044142,
                    54.6426385
                ],
                [
                    72.4055633,
                    54.6426596
                ],
                [
                    72.4068219,
                    54.6425541
                ],
                [
                    72.4075698,
                    54.6425013
                ],
                [
                    72.4125311,
                    54.6421424
                ],
                [
                    72.4190976,
                    54.6415302
                ],
                [
                    72.4250986,
                    54.6409707
                ],
                [
                    72.4240772,
                    54.6370544
                ],
                [
                    72.4282177,
                    54.636421
                ],
                [
                    72.4293851,
                    54.6356926
                ],
                [
                    72.4278347,
                    54.6347953
                ],
                [
                    72.4240535,
                    54.6334885
                ],
                [
                    72.4242433,
                    54.6314868
                ],
                [
                    72.4246665,
                    54.6291724
                ],
                [
                    72.4246811,
                    54.62875
                ],
                [
                    72.4241558,
                    54.6277617
                ],
                [
                    72.4275265,
                    54.6271788
                ],
                [
                    72.427045,
                    54.6259202
                ],
                [
                    72.4234262,
                    54.6264693
                ],
                [
                    72.4231927,
                    54.6257681
                ],
                [
                    72.4067569,
                    54.6119965
                ],
                [
                    72.4059347,
                    54.6112954
                ],
                [
                    72.4050227,
                    54.610651
                ],
                [
                    72.4040012,
                    54.6101017
                ],
                [
                    72.4026697,
                    54.6095841
                ],
                [
                    72.4011922,
                    54.6092355
                ],
                [
                    72.3998607,
                    54.6090136
                ],
                [
                    72.3985109,
                    54.6089186
                ],
                [
                    72.3974712,
                    54.6089397
                ],
                [
                    72.3910688,
                    54.6095524
                ],
                [
                    72.3771516,
                    54.6110735
                ],
                [
                    72.365715,
                    54.6122777
                ],
                [
                    72.3621034,
                    54.6125629
                ],
                [
                    72.3609543,
                    54.6126263
                ],
                [
                    72.3594245,
                    54.6148239
                ],
                [
                    72.3611209,
                    54.6251421
                ],
                [
                    72.3570168,
                    54.6278136
                ],
                [
                    72.3565061,
                    54.6282148
                ],
                [
                    72.3562325,
                    54.6286688
                ],
                [
                    72.3561595,
                    54.6293657
                ],
                [
                    72.3560501,
                    54.6307594
                ]
            ],
            "longitude": 72.392822,
            "latitude": 54.631046
        },
        "5876": {
            "name": "ТЕВРИЗ",
            "population": 6651,
            "type": "town",
            "poly": [
                [
                    72.3529296,
                    57.5162268
                ],
                [
                    72.3536906,
                    57.5182811
                ],
                [
                    72.3562139,
                    57.5181843
                ],
                [
                    72.356274,
                    57.5188833
                ],
                [
                    72.3548721,
                    57.5192167
                ],
                [
                    72.3553528,
                    57.5196469
                ],
                [
                    72.3564542,
                    57.5194641
                ],
                [
                    72.3567747,
                    57.5192705
                ],
                [
                    72.3567747,
                    57.5190231
                ],
                [
                    72.3566145,
                    57.5188188
                ],
                [
                    72.3573955,
                    57.5180875
                ],
                [
                    72.3599789,
                    57.5176035
                ],
                [
                    72.3613407,
                    57.5175927
                ],
                [
                    72.361561,
                    57.5177111
                ],
                [
                    72.363844,
                    57.5182596
                ],
                [
                    72.3641244,
                    57.5184316
                ],
                [
                    72.3641044,
                    57.5186037
                ],
                [
                    72.3647452,
                    57.5188511
                ],
                [
                    72.3655463,
                    57.5190124
                ],
                [
                    72.3666878,
                    57.5190984
                ],
                [
                    72.3680896,
                    57.5195394
                ],
                [
                    72.3715141,
                    57.5201739
                ],
                [
                    72.3737572,
                    57.5203567
                ],
                [
                    72.3769013,
                    57.5211848
                ],
                [
                    72.3787237,
                    57.5222816
                ],
                [
                    72.3808265,
                    57.522486
                ],
                [
                    72.3821282,
                    57.5225935
                ],
                [
                    72.3825288,
                    57.5225182
                ],
                [
                    72.3830294,
                    57.522529
                ],
                [
                    72.3833899,
                    57.5226688
                ],
                [
                    72.3867143,
                    57.5225182
                ],
                [
                    72.387976,
                    57.5247872
                ],
                [
                    72.3873752,
                    57.5263248
                ],
                [
                    72.3867304,
                    57.5277115
                ],
                [
                    72.3833339,
                    57.5344963
                ],
                [
                    72.3829134,
                    57.5344533
                ],
                [
                    72.3825329,
                    57.5351091
                ],
                [
                    72.382593,
                    57.5352918
                ],
                [
                    72.3828934,
                    57.5354208
                ],
                [
                    72.3847358,
                    57.5357756
                ],
                [
                    72.3828532,
                    57.5396882
                ],
                [
                    72.3855569,
                    57.5400644
                ],
                [
                    72.3889614,
                    57.5351951
                ],
                [
                    72.3916249,
                    57.5338943
                ],
                [
                    72.3934674,
                    57.5327118
                ],
                [
                    72.3936276,
                    57.5324215
                ],
                [
                    72.3963912,
                    57.5299273
                ],
                [
                    72.4017583,
                    57.5261533
                ],
                [
                    72.4097289,
                    57.5213036
                ],
                [
                    72.4115513,
                    57.5203895
                ],
                [
                    72.4127128,
                    57.5196475
                ],
                [
                    72.4139945,
                    57.518529
                ],
                [
                    72.4141547,
                    57.5181526
                ],
                [
                    72.4164378,
                    57.5163565
                ],
                [
                    72.4170986,
                    57.5153885
                ],
                [
                    72.4176193,
                    57.5145495
                ],
                [
                    72.4198423,
                    57.5123122
                ],
                [
                    72.4193799,
                    57.5121735
                ],
                [
                    72.4191912,
                    57.5119488
                ],
                [
                    72.4172717,
                    57.5111205
                ],
                [
                    72.4166319,
                    57.5106843
                ],
                [
                    72.4162136,
                    57.5100939
                ],
                [
                    72.4157727,
                    57.508125
                ],
                [
                    72.4159169,
                    57.5076861
                ],
                [
                    72.4161573,
                    57.5074279
                ],
                [
                    72.4167981,
                    57.5070234
                ],
                [
                    72.4171986,
                    57.5068943
                ],
                [
                    72.4173428,
                    57.5066791
                ],
                [
                    72.4177754,
                    57.5065242
                ],
                [
                    72.4183361,
                    57.506025
                ],
                [
                    72.4185444,
                    57.5060853
                ],
                [
                    72.4189289,
                    57.505543
                ],
                [
                    72.4175671,
                    57.5049922
                ],
                [
                    72.4175351,
                    57.5049061
                ],
                [
                    72.4162534,
                    57.5040798
                ],
                [
                    72.4160932,
                    57.5038044
                ],
                [
                    72.4160451,
                    57.5030986
                ],
                [
                    72.4155164,
                    57.5026854
                ],
                [
                    72.4150037,
                    57.501928
                ],
                [
                    72.4150518,
                    57.5001978
                ],
                [
                    72.4153562,
                    57.4990873
                ],
                [
                    72.4158849,
                    57.498743
                ],
                [
                    72.4157888,
                    57.4982695
                ],
                [
                    72.4155324,
                    57.4976755
                ],
                [
                    72.4157888,
                    57.49641
                ],
                [
                    72.4164937,
                    57.4955835
                ],
                [
                    72.4169743,
                    57.49511
                ],
                [
                    72.4165418,
                    57.4945676
                ],
                [
                    72.4164617,
                    57.4942232
                ],
                [
                    72.4161091,
                    57.4938358
                ],
                [
                    72.415879,
                    57.4935387
                ],
                [
                    72.4151901,
                    57.4931082
                ],
                [
                    72.4149337,
                    57.4930738
                ],
                [
                    72.4137482,
                    57.4932374
                ],
                [
                    72.413604,
                    57.4931599
                ],
                [
                    72.4122582,
                    57.4929102
                ],
                [
                    72.4122422,
                    57.4920578
                ],
                [
                    72.4120659,
                    57.4917392
                ],
                [
                    72.4122422,
                    57.4914551
                ],
                [
                    72.4127388,
                    57.4914379
                ],
                [
                    72.4130272,
                    57.4913173
                ],
                [
                    72.4142128,
                    57.4906371
                ],
                [
                    72.4145172,
                    57.4906285
                ],
                [
                    72.4152381,
                    57.490396
                ],
                [
                    72.4157508,
                    57.4899913
                ],
                [
                    72.4164878,
                    57.489423
                ],
                [
                    72.4168403,
                    57.489225
                ],
                [
                    72.4185545,
                    57.4884586
                ],
                [
                    72.4182181,
                    57.4876147
                ],
                [
                    72.4172087,
                    57.4877181
                ],
                [
                    72.4170165,
                    57.4876406
                ],
                [
                    72.4164397,
                    57.487632
                ],
                [
                    72.4160072,
                    57.4875372
                ],
                [
                    72.4157829,
                    57.487365
                ],
                [
                    72.4156226,
                    57.4871842
                ],
                [
                    72.4107202,
                    57.4871842
                ],
                [
                    72.4108003,
                    57.4870033
                ],
                [
                    72.4107842,
                    57.4864436
                ],
                [
                    72.4110566,
                    57.4863231
                ],
                [
                    72.411329,
                    57.4866331
                ],
                [
                    72.4117135,
                    57.4869172
                ],
                [
                    72.4122422,
                    57.4867622
                ],
                [
                    72.4124184,
                    57.4868311
                ],
                [
                    72.4133476,
                    57.4864178
                ],
                [
                    72.4139564,
                    57.4859269
                ],
                [
                    72.4141807,
                    57.4858322
                ],
                [
                    72.4140686,
                    57.4856083
                ],
                [
                    72.4142769,
                    57.4853155
                ],
                [
                    72.4145492,
                    57.4850572
                ],
                [
                    72.4147255,
                    57.4847385
                ],
                [
                    72.4153343,
                    57.4844716
                ],
                [
                    72.4163917,
                    57.4845146
                ],
                [
                    72.4174651,
                    57.4846524
                ],
                [
                    72.4183783,
                    57.4848935
                ],
                [
                    72.4188269,
                    57.4850055
                ],
                [
                    72.4190832,
                    57.4849452
                ],
                [
                    72.41966,
                    57.4847299
                ],
                [
                    72.4205732,
                    57.4845835
                ],
                [
                    72.4214704,
                    57.4846007
                ],
                [
                    72.4225919,
                    57.4847471
                ],
                [
                    72.4235531,
                    57.4849624
                ],
                [
                    72.4244343,
                    57.4852036
                ],
                [
                    72.4247868,
                    57.4851433
                ],
                [
                    72.4275264,
                    57.4825683
                ],
                [
                    72.4232327,
                    57.4815606
                ],
                [
                    72.4211179,
                    57.4830075
                ],
                [
                    72.4187308,
                    57.4833175
                ],
                [
                    72.4184103,
                    57.4819137
                ],
                [
                    72.4141006,
                    57.4824649
                ],
                [
                    72.4140205,
                    57.4837309
                ],
                [
                    72.4125145,
                    57.4845577
                ],
                [
                    72.4102555,
                    57.4865211
                ],
                [
                    72.4122663,
                    57.4831162
                ],
                [
                    72.4114333,
                    57.4825047
                ],
                [
                    72.4109366,
                    57.4819621
                ],
                [
                    72.4096709,
                    57.4825477
                ],
                [
                    72.4089019,
                    57.4823841
                ],
                [
                    72.4080207,
                    57.4820741
                ],
                [
                    72.4075561,
                    57.4829784
                ],
                [
                    72.406675,
                    57.4832884
                ],
                [
                    72.40291,
                    57.4851744
                ],
                [
                    72.402157,
                    57.4849419
                ],
                [
                    72.4016123,
                    57.4852864
                ],
                [
                    72.4016283,
                    57.4856308
                ],
                [
                    72.4007631,
                    57.4860269
                ],
                [
                    72.4009554,
                    57.4864747
                ],
                [
                    72.3984881,
                    57.4881711
                ],
                [
                    72.3969341,
                    57.4875339
                ],
                [
                    72.396165,
                    57.4878956
                ],
                [
                    72.3966456,
                    57.4881281
                ],
                [
                    72.3950596,
                    57.4894025
                ],
                [
                    72.3957645,
                    57.4901086
                ],
                [
                    72.3951876,
                    57.4910471
                ],
                [
                    72.3948032,
                    57.4913571
                ],
                [
                    72.3952999,
                    57.4913054
                ],
                [
                    72.3951557,
                    57.4915723
                ],
                [
                    72.3950115,
                    57.4917617
                ],
                [
                    72.3943226,
                    57.4921062
                ],
                [
                    72.3942585,
                    57.4924678
                ],
                [
                    72.3945629,
                    57.4927605
                ],
                [
                    72.3949635,
                    57.4929413
                ],
                [
                    72.3954281,
                    57.4929585
                ],
                [
                    72.3957325,
                    57.4929499
                ],
                [
                    72.3925282,
                    57.4949904
                ],
                [
                    72.392368,
                    57.495352
                ],
                [
                    72.3924641,
                    57.4956447
                ],
                [
                    72.3927525,
                    57.4960407
                ],
                [
                    72.3933933,
                    57.4970824
                ],
                [
                    72.3939701,
                    57.4985029
                ],
                [
                    72.3945469,
                    57.4990538
                ],
                [
                    72.394611,
                    57.4992174
                ],
                [
                    72.3956363,
                    57.4991829
                ],
                [
                    72.3960209,
                    57.4991657
                ],
                [
                    72.3964214,
                    57.4990796
                ],
                [
                    72.3999621,
                    57.4986148
                ],
                [
                    72.4007311,
                    57.4986406
                ],
                [
                    72.4015321,
                    57.4985029
                ],
                [
                    72.4043037,
                    57.49883
                ],
                [
                    72.4045281,
                    57.5000093
                ],
                [
                    72.4041596,
                    57.5011542
                ],
                [
                    72.4040708,
                    57.5011415
                ],
                [
                    72.4037674,
                    57.5016219
                ],
                [
                    72.4036772,
                    57.5016175
                ],
                [
                    72.4035213,
                    57.5020847
                ],
                [
                    72.4032342,
                    57.5020847
                ],
                [
                    72.4031686,
                    57.502305
                ],
                [
                    72.4037346,
                    57.5023359
                ],
                [
                    72.403546,
                    57.5027942
                ],
                [
                    72.4033901,
                    57.5027766
                ],
                [
                    72.4030128,
                    57.503517
                ],
                [
                    72.403103,
                    57.503539
                ],
                [
                    72.4029718,
                    57.5037549
                ],
                [
                    72.4023729,
                    57.5037285
                ],
                [
                    72.4023483,
                    57.5038387
                ],
                [
                    72.4018808,
                    57.5038475
                ],
                [
                    72.4010112,
                    57.5039532
                ],
                [
                    72.4010031,
                    57.504037
                ],
                [
                    72.4006011,
                    57.5042617
                ],
                [
                    72.4004207,
                    57.5043014
                ],
                [
                    72.4006011,
                    57.5055177
                ],
                [
                    72.3989704,
                    57.504672
                ],
                [
                    72.3883707,
                    57.5003407
                ],
                [
                    72.3738555,
                    57.4945607
                ],
                [
                    72.3743682,
                    57.4957402
                ],
                [
                    72.3750571,
                    57.4959727
                ],
                [
                    72.3748649,
                    57.4962482
                ],
                [
                    72.3744804,
                    57.4963256
                ],
                [
                    72.3732948,
                    57.4958521
                ],
                [
                    72.3728782,
                    57.4958694
                ],
                [
                    72.3716766,
                    57.496274
                ],
                [
                    72.3714684,
                    57.4972382
                ],
                [
                    72.3643909,
                    57.4953116
                ],
                [
                    72.3622481,
                    57.4969258
                ],
                [
                    72.3624684,
                    57.4972486
                ],
                [
                    72.3630491,
                    57.4975822
                ],
                [
                    72.3635298,
                    57.4976683
                ],
                [
                    72.366694,
                    57.4985291
                ],
                [
                    72.367475,
                    57.4988197
                ],
                [
                    72.3681759,
                    57.4989596
                ],
                [
                    72.3677044,
                    57.5039601
                ],
                [
                    72.3686913,
                    57.5040772
                ],
                [
                    72.3696013,
                    57.5041116
                ],
                [
                    72.3702806,
                    57.5042424
                ],
                [
                    72.371165,
                    57.504449
                ],
                [
                    72.371793,
                    57.5044559
                ],
                [
                    72.3723954,
                    57.5044421
                ],
                [
                    72.3726261,
                    57.5045385
                ],
                [
                    72.3725748,
                    57.5046487
                ],
                [
                    72.3716776,
                    57.5052133
                ],
                [
                    72.371088,
                    57.5053717
                ],
                [
                    72.3689348,
                    57.5054956
                ],
                [
                    72.3669097,
                    57.5054061
                ],
                [
                    72.3623469,
                    57.5063494
                ],
                [
                    72.3628724,
                    57.507155
                ],
                [
                    72.360937,
                    57.5159739
                ],
                [
                    72.3529296,
                    57.5162268
                ]
            ],
            "longitude": 72.398911,
            "latitude": 57.513668
        },
        "5877": {
            "name": "БОЛЬШИЕ УКИ",
            "population": 4157,
            "type": "town",
            "poly": [
                [
                    72.5853323,
                    56.9461246
                ],
                [
                    72.6013381,
                    56.950961
                ],
                [
                    72.5967328,
                    56.9547503
                ],
                [
                    72.6066506,
                    56.9575955
                ],
                [
                    72.6116504,
                    56.9538112
                ],
                [
                    72.6201326,
                    56.9596841
                ],
                [
                    72.6245105,
                    56.965963
                ],
                [
                    72.6382176,
                    56.970019
                ],
                [
                    72.6596787,
                    56.9642596
                ],
                [
                    72.6600269,
                    56.963568
                ],
                [
                    72.6639322,
                    56.9517817
                ],
                [
                    72.6671627,
                    56.9254544
                ],
                [
                    72.6666459,
                    56.9258347
                ],
                [
                    72.6652957,
                    56.9267104
                ],
                [
                    72.6642955,
                    56.9272941
                ],
                [
                    72.6629488,
                    56.9280146
                ],
                [
                    72.6624886,
                    56.9282265
                ],
                [
                    72.6620746,
                    56.9283978
                ],
                [
                    72.6603748,
                    56.9290571
                ],
                [
                    72.6576665,
                    56.9301071
                ],
                [
                    72.6534602,
                    56.9317204
                ],
                [
                    72.6496678,
                    56.9331803
                ],
                [
                    72.6444567,
                    56.9350886
                ],
                [
                    72.6436132,
                    56.935437
                ],
                [
                    72.6430878,
                    56.9354043
                ],
                [
                    72.6425816,
                    56.9354292
                ],
                [
                    72.6407671,
                    56.9356326
                ],
                [
                    72.6388149,
                    56.9357787
                ],
                [
                    72.6368638,
                    56.9359116
                ],
                [
                    72.6351363,
                    56.9359339
                ],
                [
                    72.6342474,
                    56.9359218
                ],
                [
                    72.6324975,
                    56.9358076
                ],
                [
                    72.6292705,
                    56.9355125
                ],
                [
                    72.6257452,
                    56.9352151
                ],
                [
                    72.62246,
                    56.9349291
                ],
                [
                    72.6199667,
                    56.9346997
                ],
                [
                    72.6180938,
                    56.9345527
                ],
                [
                    72.6176092,
                    56.9345318
                ],
                [
                    72.6171339,
                    56.934531
                ],
                [
                    72.6163036,
                    56.9345852
                ],
                [
                    72.6153832,
                    56.9347698
                ],
                [
                    72.6145298,
                    56.9350701
                ],
                [
                    72.614139,
                    56.9352364
                ],
                [
                    72.6138235,
                    56.9354037
                ],
                [
                    72.6135177,
                    56.935608
                ],
                [
                    72.6124226,
                    56.9363986
                ],
                [
                    72.6113124,
                    56.9371378
                ],
                [
                    72.6107538,
                    56.9375097
                ],
                [
                    72.610664,
                    56.9375694
                ],
                [
                    72.6096553,
                    56.9369544
                ],
                [
                    72.6100081,
                    56.9364563
                ],
                [
                    72.6105268,
                    56.9358223
                ],
                [
                    72.6092195,
                    56.9352902
                ],
                [
                    72.6083895,
                    56.9347921
                ],
                [
                    72.607767,
                    56.9335128
                ],
                [
                    72.607518,
                    56.9329353
                ],
                [
                    72.6062349,
                    56.9326635
                ],
                [
                    72.5853323,
                    56.9461246
                ]
            ],
            "longitude": 72.625717,
            "latitude": 56.949043
        },
        "5878": {
            "name": "МАРЬЯНОВКА",
            "population": 8640,
            "type": "town",
            "poly": [
                [
                    72.6178535,
                    54.9580583
                ],
                [
                    72.6180895,
                    54.9592706
                ],
                [
                    72.6235011,
                    54.9631241
                ],
                [
                    72.6247071,
                    54.9630625
                ],
                [
                    72.6262069,
                    54.966859
                ],
                [
                    72.6269236,
                    54.9668024
                ],
                [
                    72.6281811,
                    54.9710851
                ],
                [
                    72.6334897,
                    54.9702771
                ],
                [
                    72.6324533,
                    54.9669219
                ],
                [
                    72.6356354,
                    54.9669046
                ],
                [
                    72.6394013,
                    54.9677385
                ],
                [
                    72.6434235,
                    54.9680428
                ],
                [
                    72.6435737,
                    54.9677835
                ],
                [
                    72.6444546,
                    54.9681758
                ],
                [
                    72.6451165,
                    54.9682331
                ],
                [
                    72.6488727,
                    54.9681265
                ],
                [
                    72.6498265,
                    54.9680797
                ],
                [
                    72.652866,
                    54.9676948
                ],
                [
                    72.6549495,
                    54.967603
                ],
                [
                    72.6553089,
                    54.969333
                ],
                [
                    72.6666289,
                    54.9698411
                ],
                [
                    72.6666632,
                    54.9601237
                ],
                [
                    72.664835,
                    54.9600991
                ],
                [
                    72.6653254,
                    54.9594831
                ],
                [
                    72.6653425,
                    54.9587199
                ],
                [
                    72.6583881,
                    54.9585523
                ],
                [
                    72.6585512,
                    54.9565693
                ],
                [
                    72.6565792,
                    54.9565748
                ],
                [
                    72.6565502,
                    54.9559551
                ],
                [
                    72.6554988,
                    54.9558849
                ],
                [
                    72.6559172,
                    54.9544063
                ],
                [
                    72.65082,
                    54.9523103
                ],
                [
                    72.6403529,
                    54.951701
                ],
                [
                    72.6403926,
                    54.9513122
                ],
                [
                    72.6401866,
                    54.9502623
                ],
                [
                    72.6301702,
                    54.95034
                ],
                [
                    72.6313289,
                    54.9515587
                ],
                [
                    72.6287497,
                    54.9537188
                ],
                [
                    72.6286102,
                    54.9554241
                ],
                [
                    72.6222738,
                    54.9553144
                ],
                [
                    72.6222286,
                    54.9580952
                ],
                [
                    72.6178535,
                    54.9580583
                ]
            ],
            "longitude": 72.637947,
            "latitude": 54.960659
        },
        "5879": {
            "name": "ЛЮБИНСКИЙ",
            "population": 10385,
            "type": "town",
            "poly": [
                [
                    72.6640441,
                    55.150627
                ],
                [
                    72.6646179,
                    55.1575397
                ],
                [
                    72.6649422,
                    55.1598912
                ],
                [
                    72.6655159,
                    55.1658477
                ],
                [
                    72.6709216,
                    55.1662865
                ],
                [
                    72.6814091,
                    55.1665636
                ],
                [
                    72.6885135,
                    55.1667278
                ],
                [
                    72.699242,
                    55.1660894
                ],
                [
                    72.6999445,
                    55.1660165
                ],
                [
                    72.700647,
                    55.1658067
                ],
                [
                    72.701541,
                    55.1653325
                ],
                [
                    72.7016208,
                    55.1654511
                ],
                [
                    72.7018124,
                    55.166591
                ],
                [
                    72.7041114,
                    55.1650589
                ],
                [
                    72.7096353,
                    55.1613107
                ],
                [
                    72.7098269,
                    55.1612377
                ],
                [
                    72.7062592,
                    55.1599991
                ],
                [
                    72.7066296,
                    55.1596124
                ],
                [
                    72.709797,
                    55.1576422
                ],
                [
                    72.7131305,
                    55.1554239
                ],
                [
                    72.7173708,
                    55.15241
                ],
                [
                    72.7201679,
                    55.1503738
                ],
                [
                    72.720385,
                    55.1502206
                ],
                [
                    72.7205255,
                    55.1500308
                ],
                [
                    72.7205255,
                    55.1498922
                ],
                [
                    72.7205128,
                    55.1496732
                ],
                [
                    72.7192739,
                    55.1479434
                ],
                [
                    72.7167393,
                    55.1461408
                ],
                [
                    72.7177983,
                    55.1458097
                ],
                [
                    72.7184054,
                    55.1456808
                ],
                [
                    72.7232226,
                    55.1449295
                ],
                [
                    72.7243087,
                    55.1447068
                ],
                [
                    72.7296831,
                    55.1432355
                ],
                [
                    72.7300279,
                    55.1431333
                ],
                [
                    72.7299513,
                    55.1430749
                ],
                [
                    72.7302706,
                    55.1429727
                ],
                [
                    72.7303217,
                    55.1430457
                ],
                [
                    72.7306154,
                    55.1429727
                ],
                [
                    72.7305133,
                    55.1429143
                ],
                [
                    72.7308581,
                    55.1428121
                ],
                [
                    72.730922,
                    55.1428851
                ],
                [
                    72.7312157,
                    55.1427975
                ],
                [
                    72.7311263,
                    55.1427099
                ],
                [
                    72.7314456,
                    55.1426296
                ],
                [
                    72.7315861,
                    55.1427318
                ],
                [
                    72.7322758,
                    55.142469
                ],
                [
                    72.7331188,
                    55.142396
                ],
                [
                    72.7331188,
                    55.1422282
                ],
                [
                    72.739492,
                    55.1422501
                ],
                [
                    72.7395176,
                    55.1420165
                ],
                [
                    72.7334636,
                    55.1420311
                ],
                [
                    72.7359914,
                    55.141254
                ],
                [
                    72.736071,
                    55.1411385
                ],
                [
                    72.7373572,
                    55.1404904
                ],
                [
                    72.7363964,
                    55.1392836
                ],
                [
                    72.7373359,
                    55.1390127
                ],
                [
                    72.7369655,
                    55.1385455
                ],
                [
                    72.7223664,
                    55.1428149
                ],
                [
                    72.7214933,
                    55.142102
                ],
                [
                    72.70705,
                    55.1421875
                ],
                [
                    72.6979199,
                    55.1423016
                ],
                [
                    72.697421,
                    55.1423586
                ],
                [
                    72.6968722,
                    55.1423871
                ],
                [
                    72.695176,
                    55.1420877
                ],
                [
                    72.6868941,
                    55.1420165
                ],
                [
                    72.6772153,
                    55.1457517
                ],
                [
                    72.6640441,
                    55.150627
                ]
            ],
            "longitude": 72.699005,
            "latitude": 55.156715
        },
        "5880": {
            "name": "ОДЕССКОЕ",
            "population": 6148,
            "type": "town",
            "poly": [
                [
                    72.9277905,
                    54.2038549
                ],
                [
                    72.9389142,
                    54.2247605
                ],
                [
                    72.9467397,
                    54.2235973
                ],
                [
                    72.9537025,
                    54.2227417
                ],
                [
                    72.9615434,
                    54.2215336
                ],
                [
                    72.9665407,
                    54.2208857
                ],
                [
                    72.9726461,
                    54.2212402
                ],
                [
                    72.973148,
                    54.2216069
                ],
                [
                    72.9776225,
                    54.2216925
                ],
                [
                    72.9804452,
                    54.2208001
                ],
                [
                    72.9871153,
                    54.2082555
                ],
                [
                    72.9882025,
                    54.2079375
                ],
                [
                    72.9886834,
                    54.2079498
                ],
                [
                    72.9922798,
                    54.2074851
                ],
                [
                    72.9892898,
                    54.2038163
                ],
                [
                    72.9869271,
                    54.2002185
                ],
                [
                    72.9846005,
                    54.1938476
                ],
                [
                    72.9647843,
                    54.1962066
                ],
                [
                    72.9657043,
                    54.1989342
                ],
                [
                    72.9506706,
                    54.1981025
                ],
                [
                    72.9464261,
                    54.1980536
                ],
                [
                    72.9402788,
                    54.198286
                ],
                [
                    72.9379788,
                    54.1985061
                ],
                [
                    72.9314342,
                    54.1994602
                ],
                [
                    72.9333161,
                    54.2048558
                ],
                [
                    72.9277905,
                    54.2038549
                ]
            ],
            "longitude": 72.965538,
            "latitude": 54.20969
        },
        "5881": {
            "name": "АЗОВО",
            "population": 5997,
            "type": "town",
            "poly": [
                [
                    72.9974072,
                    54.7031277
                ],
                [
                    72.9977318,
                    54.7036122
                ],
                [
                    72.9986786,
                    54.7058786
                ],
                [
                    72.9998127,
                    54.7095472
                ],
                [
                    73.0007983,
                    54.7105469
                ],
                [
                    73.0015714,
                    54.7111982
                ],
                [
                    73.0026984,
                    54.7119792
                ],
                [
                    73.0030732,
                    54.7125934
                ],
                [
                    73.0039827,
                    54.7146108
                ],
                [
                    73.0054618,
                    54.7173536
                ],
                [
                    73.007197,
                    54.7199413
                ],
                [
                    73.0071988,
                    54.720272
                ],
                [
                    73.0032082,
                    54.7209042
                ],
                [
                    73.0053625,
                    54.7247729
                ],
                [
                    73.0100176,
                    54.7239088
                ],
                [
                    73.0126912,
                    54.7291627
                ],
                [
                    73.0300783,
                    54.7259225
                ],
                [
                    73.0271803,
                    54.7208161
                ],
                [
                    73.0277593,
                    54.7202137
                ],
                [
                    73.0395714,
                    54.7240309
                ],
                [
                    73.0421084,
                    54.7214045
                ],
                [
                    73.0425623,
                    54.7215592
                ],
                [
                    73.0484305,
                    54.7211015
                ],
                [
                    73.0469089,
                    54.7150177
                ],
                [
                    73.0479941,
                    54.7149828
                ],
                [
                    73.0480531,
                    54.7149705
                ],
                [
                    73.0481414,
                    54.7149181
                ],
                [
                    73.0481457,
                    54.7148394
                ],
                [
                    73.0498547,
                    54.714778
                ],
                [
                    73.0495994,
                    54.7137703
                ],
                [
                    73.0496916,
                    54.7137416
                ],
                [
                    73.0495071,
                    54.7117753
                ],
                [
                    73.0596762,
                    54.713463
                ],
                [
                    73.0595415,
                    54.7105217
                ],
                [
                    73.0575693,
                    54.7068096
                ],
                [
                    73.0473352,
                    54.7052488
                ],
                [
                    73.0424774,
                    54.6915791
                ],
                [
                    73.0423533,
                    54.691574
                ],
                [
                    73.0420254,
                    54.6918711
                ],
                [
                    73.0409351,
                    54.6931826
                ],
                [
                    73.0401107,
                    54.6940946
                ],
                [
                    73.0394193,
                    54.694653
                ],
                [
                    73.0377351,
                    54.6955648
                ],
                [
                    73.0364586,
                    54.6961693
                ],
                [
                    73.0312621,
                    54.6983239
                ],
                [
                    73.0305868,
                    54.6985547
                ],
                [
                    73.0303543,
                    54.6986072
                ],
                [
                    73.0301765,
                    54.6985925
                ],
                [
                    73.029995,
                    54.6985106
                ],
                [
                    73.0298207,
                    54.6982799
                ],
                [
                    73.0295338,
                    54.6979232
                ],
                [
                    73.0291272,
                    54.6976798
                ],
                [
                    73.0114233,
                    54.6897635
                ],
                [
                    73.0037454,
                    54.6935989
                ],
                [
                    73.0034334,
                    54.6937096
                ],
                [
                    73.0034121,
                    54.6939227
                ],
                [
                    73.0028519,
                    54.6942219
                ],
                [
                    73.0024477,
                    54.6945087
                ],
                [
                    73.0024322,
                    54.6946518
                ],
                [
                    73.0016813,
                    54.6957024
                ],
                [
                    73.0021682,
                    54.697297
                ],
                [
                    73.0012756,
                    54.6990948
                ],
                [
                    73.0010592,
                    54.6995012
                ],
                [
                    73.0003017,
                    54.6999545
                ],
                [
                    72.9985704,
                    54.700783
                ],
                [
                    72.9974884,
                    54.7020492
                ],
                [
                    72.9974072,
                    54.7031277
                ]
            ],
            "longitude": 73.026871,
            "latitude": 54.70385
        },
        "5882": {
            "name": "САРГАТСКОЕ",
            "population": 8066,
            "type": "town",
            "poly": [
                [
                    73.4702068,
                    55.615154
                ],
                [
                    73.4940678,
                    55.625332
                ],
                [
                    73.5189587,
                    55.6263012
                ],
                [
                    73.5253101,
                    55.6209218
                ],
                [
                    73.5361248,
                    55.613312
                ],
                [
                    73.4881453,
                    55.5872723
                ],
                [
                    73.4705502,
                    55.5979424
                ],
                [
                    73.4702068,
                    55.615154
                ]
            ],
            "longitude": 73.490257,
            "latitude": 55.603386
        },
        "5883": {
            "name": "ПАВЛОГРАДКА",
            "population": 7208,
            "type": "town",
            "poly": [
                [
                    73.5421929,
                    54.1922967
                ],
                [
                    73.5421929,
                    54.1927585
                ],
                [
                    73.5426691,
                    54.1998085
                ],
                [
                    73.542854,
                    54.2002319
                ],
                [
                    73.5431004,
                    54.2006374
                ],
                [
                    73.5473364,
                    54.2077369
                ],
                [
                    73.5500782,
                    54.2119977
                ],
                [
                    73.5522192,
                    54.2148801
                ],
                [
                    73.5551921,
                    54.2174471
                ],
                [
                    73.5565014,
                    54.2176182
                ],
                [
                    73.5574872,
                    54.2176993
                ],
                [
                    73.558242,
                    54.2176722
                ],
                [
                    73.5620312,
                    54.217321
                ],
                [
                    73.5630479,
                    54.2193204
                ],
                [
                    73.5716584,
                    54.2186539
                ],
                [
                    73.5770188,
                    54.2175551
                ],
                [
                    73.5791445,
                    54.2127724
                ],
                [
                    73.5917149,
                    54.1940427
                ],
                [
                    73.5913106,
                    54.1940202
                ],
                [
                    73.5896548,
                    54.1943356
                ],
                [
                    73.5872095,
                    54.1947073
                ],
                [
                    73.5843791,
                    54.1951129
                ],
                [
                    73.5819916,
                    54.1953719
                ],
                [
                    73.5776208,
                    54.1958
                ],
                [
                    73.577409,
                    54.1950791
                ],
                [
                    73.5730576,
                    54.1955409
                ],
                [
                    73.5729228,
                    54.19482
                ],
                [
                    73.5725377,
                    54.1948312
                ],
                [
                    73.5714017,
                    54.1899084
                ],
                [
                    73.5678589,
                    54.1903253
                ],
                [
                    73.567185,
                    54.1904041
                ],
                [
                    73.5666844,
                    54.1904041
                ],
                [
                    73.564913,
                    54.1898859
                ],
                [
                    73.5643161,
                    54.1881847
                ],
                [
                    73.5601957,
                    54.1888156
                ],
                [
                    73.5600609,
                    54.1889621
                ],
                [
                    73.5597336,
                    54.1881397
                ],
                [
                    73.5592907,
                    54.1875989
                ],
                [
                    73.5591752,
                    54.186168
                ],
                [
                    73.5566721,
                    54.186461
                ],
                [
                    73.5538803,
                    54.1864722
                ],
                [
                    73.5508188,
                    54.1868328
                ],
                [
                    73.5500486,
                    54.1868778
                ],
                [
                    73.5497021,
                    54.1869454
                ],
                [
                    73.549471,
                    54.1870919
                ],
                [
                    73.5436755,
                    54.1912603
                ],
                [
                    73.5424624,
                    54.1919587
                ],
                [
                    73.5421929,
                    54.1922967
                ]
            ],
            "longitude": 73.556488,
            "latitude": 54.205006
        },
        "5884": {
            "name": "КОЛОСОВКА",
            "population": 5313,
            "type": "town",
            "poly": [
                [
                    73.5639305,
                    56.4628013
                ],
                [
                    73.5695171,
                    56.4647886
                ],
                [
                    73.5702256,
                    56.464608
                ],
                [
                    73.5711522,
                    56.4650145
                ],
                [
                    73.5710977,
                    56.4653758
                ],
                [
                    73.5714247,
                    56.4655564
                ],
                [
                    73.572106,
                    56.4655263
                ],
                [
                    73.5724603,
                    56.4656618
                ],
                [
                    73.572433,
                    56.4660984
                ],
                [
                    73.5718062,
                    56.4664447
                ],
                [
                    73.5717245,
                    56.4667458
                ],
                [
                    73.5718607,
                    56.467077
                ],
                [
                    73.5719425,
                    56.4672727
                ],
                [
                    73.5716154,
                    56.467649
                ],
                [
                    73.5715337,
                    56.4680404
                ],
                [
                    73.5715337,
                    56.4683716
                ],
                [
                    73.571779,
                    56.4686125
                ],
                [
                    73.5738501,
                    56.4691243
                ],
                [
                    73.5736048,
                    56.469621
                ],
                [
                    73.5789361,
                    56.4686978
                ],
                [
                    73.5833618,
                    56.4695167
                ],
                [
                    73.5827513,
                    56.467361
                ],
                [
                    73.5836233,
                    56.4665661
                ],
                [
                    73.5866974,
                    56.4680475
                ],
                [
                    73.6007593,
                    56.4730209
                ],
                [
                    73.5987317,
                    56.4746104
                ],
                [
                    73.5923003,
                    56.4773195
                ],
                [
                    73.5928454,
                    56.4782827
                ],
                [
                    73.5927364,
                    56.4788606
                ],
                [
                    73.5970094,
                    56.4794746
                ],
                [
                    73.5980341,
                    56.478969
                ],
                [
                    73.6032446,
                    56.4782346
                ],
                [
                    73.6042257,
                    56.478668
                ],
                [
                    73.6045091,
                    56.478668
                ],
                [
                    73.6056428,
                    56.4784392
                ],
                [
                    73.6053594,
                    56.4780178
                ],
                [
                    73.6050105,
                    56.4778613
                ],
                [
                    73.604073,
                    56.4778132
                ],
                [
                    73.6045309,
                    56.4776928
                ],
                [
                    73.6044655,
                    56.4775242
                ],
                [
                    73.6046617,
                    56.4773075
                ],
                [
                    73.6038551,
                    56.4766814
                ],
                [
                    73.6035498,
                    56.4765489
                ],
                [
                    73.6042693,
                    56.4757302
                ],
                [
                    73.6041821,
                    56.4754412
                ],
                [
                    73.6043782,
                    56.4753328
                ],
                [
                    73.6048143,
                    56.4755014
                ],
                [
                    73.6047271,
                    56.475682
                ],
                [
                    73.6047707,
                    56.4757904
                ],
                [
                    73.6045745,
                    56.475959
                ],
                [
                    73.6047925,
                    56.4760192
                ],
                [
                    73.6049887,
                    56.4760312
                ],
                [
                    73.6050105,
                    56.4758747
                ],
                [
                    73.6053594,
                    56.4758265
                ],
                [
                    73.6056646,
                    56.4756459
                ],
                [
                    73.6062096,
                    56.4756941
                ],
                [
                    73.6068637,
                    56.4758506
                ],
                [
                    73.6072561,
                    56.4760432
                ],
                [
                    73.6074086,
                    56.4763563
                ],
                [
                    73.6077357,
                    56.4764406
                ],
                [
                    73.6082589,
                    56.4764526
                ],
                [
                    73.6084769,
                    56.4764767
                ],
                [
                    73.6089348,
                    56.4766453
                ],
                [
                    73.60924,
                    56.4768861
                ],
                [
                    73.60924,
                    56.4772834
                ],
                [
                    73.6124666,
                    56.4782948
                ],
                [
                    73.612859,
                    56.4783188
                ],
                [
                    73.6138183,
                    56.47868
                ],
                [
                    73.6144505,
                    56.4787764
                ],
                [
                    73.6147994,
                    56.4785356
                ],
                [
                    73.6152572,
                    56.4783911
                ],
                [
                    73.6166307,
                    56.4784754
                ],
                [
                    73.6175027,
                    56.47868
                ],
                [
                    73.6244574,
                    56.480823
                ],
                [
                    73.6267465,
                    56.480799
                ],
                [
                    73.6278802,
                    56.480486
                ],
                [
                    73.6360113,
                    56.4774178
                ],
                [
                    73.6434782,
                    56.4778844
                ],
                [
                    73.643342,
                    56.4774479
                ],
                [
                    73.6427697,
                    56.4771469
                ],
                [
                    73.6422246,
                    56.4770265
                ],
                [
                    73.6421701,
                    56.4764396
                ],
                [
                    73.6417886,
                    56.4755064
                ],
                [
                    73.6412981,
                    56.4750549
                ],
                [
                    73.6417069,
                    56.4743174
                ],
                [
                    73.6420884,
                    56.4743023
                ],
                [
                    73.6424154,
                    56.4746034
                ],
                [
                    73.6427424,
                    56.4747238
                ],
                [
                    73.6435055,
                    56.4746184
                ],
                [
                    73.6441595,
                    56.4747388
                ],
                [
                    73.6453041,
                    56.4752957
                ],
                [
                    73.6454676,
                    56.4751753
                ],
                [
                    73.6460671,
                    56.4752204
                ],
                [
                    73.6465032,
                    56.4755967
                ],
                [
                    73.6467757,
                    56.475672
                ],
                [
                    73.6474025,
                    56.4755817
                ],
                [
                    73.6477295,
                    56.4758225
                ],
                [
                    73.6483835,
                    56.4757623
                ],
                [
                    73.6488741,
                    56.4758375
                ],
                [
                    73.6489013,
                    56.4757171
                ],
                [
                    73.648438,
                    56.4755215
                ],
                [
                    73.6480293,
                    56.4755064
                ],
                [
                    73.6481383,
                    56.4752807
                ],
                [
                    73.6477295,
                    56.4753108
                ],
                [
                    73.6483835,
                    56.4749194
                ],
                [
                    73.648111,
                    56.4749044
                ],
                [
                    73.6486015,
                    56.4744528
                ],
                [
                    73.648329,
                    56.4741819
                ],
                [
                    73.6483835,
                    56.4737605
                ],
                [
                    73.6486561,
                    56.4738056
                ],
                [
                    73.6482473,
                    56.4731584
                ],
                [
                    73.6480293,
                    56.4722101
                ],
                [
                    73.6482473,
                    56.471894
                ],
                [
                    73.6487106,
                    56.4717887
                ],
                [
                    73.6496099,
                    56.4719542
                ],
                [
                    73.6499914,
                    56.4718639
                ],
                [
                    73.6501821,
                    56.4716231
                ],
                [
                    73.6500459,
                    56.4715177
                ],
                [
                    73.6497189,
                    56.4715027
                ],
                [
                    73.6493918,
                    56.471307
                ],
                [
                    73.6492283,
                    56.4710059
                ],
                [
                    73.6492828,
                    56.4706898
                ],
                [
                    73.6496371,
                    56.4703737
                ],
                [
                    73.6501821,
                    56.4700877
                ],
                [
                    73.6511359,
                    56.4698017
                ],
                [
                    73.6515175,
                    56.469606
                ],
                [
                    73.65179,
                    56.4692899
                ],
                [
                    73.6517082,
                    56.4690189
                ],
                [
                    73.651354,
                    56.4688834
                ],
                [
                    73.6508089,
                    56.4688383
                ],
                [
                    73.6501276,
                    56.4688985
                ],
                [
                    73.64931,
                    56.469034
                ],
                [
                    73.6486015,
                    56.4692899
                ],
                [
                    73.6479475,
                    56.4694103
                ],
                [
                    73.647239,
                    56.4695006
                ],
                [
                    73.6466122,
                    56.4694705
                ],
                [
                    73.6459036,
                    56.4693802
                ],
                [
                    73.6449771,
                    56.4692447
                ],
                [
                    73.6445683,
                    56.4693501
                ],
                [
                    73.6442958,
                    56.4695608
                ],
                [
                    73.6442413,
                    56.4698769
                ],
                [
                    73.6446501,
                    56.4701329
                ],
                [
                    73.6452496,
                    56.4703436
                ],
                [
                    73.6455766,
                    56.4706145
                ],
                [
                    73.6454949,
                    56.4709608
                ],
                [
                    73.6452223,
                    56.4711113
                ],
                [
                    73.6433692,
                    56.471307
                ],
                [
                    73.6420339,
                    56.4714123
                ],
                [
                    73.640644,
                    56.4716983
                ],
                [
                    73.6402353,
                    56.4716231
                ],
                [
                    73.6395267,
                    56.4712167
                ],
                [
                    73.6394722,
                    56.4709307
                ],
                [
                    73.6394995,
                    56.4706748
                ],
                [
                    73.6392542,
                    56.4705242
                ],
                [
                    73.6394722,
                    56.470178
                ],
                [
                    73.6394722,
                    56.4695608
                ],
                [
                    73.6399628,
                    56.469621
                ],
                [
                    73.640535,
                    56.4698017
                ],
                [
                    73.6411618,
                    56.4699372
                ],
                [
                    73.6416251,
                    56.4698468
                ],
                [
                    73.6418704,
                    56.4696662
                ],
                [
                    73.6421701,
                    56.4694254
                ],
                [
                    73.6423337,
                    56.4691092
                ],
                [
                    73.6421429,
                    56.4688533
                ],
                [
                    73.6418975,
                    56.4685372
                ],
                [
                    73.6418975,
                    56.4682963
                ],
                [
                    73.6425517,
                    56.4687479
                ],
                [
                    73.6452223,
                    56.4664296
                ],
                [
                    73.6430967,
                    56.4657823
                ],
                [
                    73.6424699,
                    56.4662038
                ],
                [
                    73.6427697,
                    56.4652704
                ],
                [
                    73.6423882,
                    56.4652252
                ],
                [
                    73.6426062,
                    56.4649844
                ],
                [
                    73.6425789,
                    56.4642165
                ],
                [
                    73.6414889,
                    56.4638401
                ],
                [
                    73.6415161,
                    56.4622593
                ],
                [
                    73.6408621,
                    56.4619883
                ],
                [
                    73.6400718,
                    56.4612505
                ],
                [
                    73.6402353,
                    56.4600309
                ],
                [
                    73.6383277,
                    56.4597749
                ],
                [
                    73.6372648,
                    56.4594738
                ],
                [
                    73.6359839,
                    56.4598201
                ],
                [
                    73.6348667,
                    56.4625453
                ],
                [
                    73.632414,
                    56.4642015
                ],
                [
                    73.6320053,
                    56.4645779
                ],
                [
                    73.6302611,
                    56.4632379
                ],
                [
                    73.6251923,
                    56.46515
                ],
                [
                    73.625383,
                    56.4645478
                ],
                [
                    73.6257101,
                    56.4639756
                ],
                [
                    73.6258191,
                    56.4636444
                ],
                [
                    73.6255466,
                    56.4630121
                ],
                [
                    73.6256556,
                    56.4626959
                ],
                [
                    73.6259281,
                    56.4625002
                ],
                [
                    73.6270454,
                    56.4623346
                ],
                [
                    73.6272907,
                    56.4621689
                ],
                [
                    73.6275087,
                    56.4617925
                ],
                [
                    73.6274815,
                    56.4613408
                ],
                [
                    73.6270454,
                    56.4610247
                ],
                [
                    73.6267729,
                    56.4606633
                ],
                [
                    73.6268547,
                    56.4601062
                ],
                [
                    73.6269092,
                    56.4596093
                ],
                [
                    73.6267457,
                    56.4593834
                ],
                [
                    73.6264187,
                    56.4592027
                ],
                [
                    73.625383,
                    56.4590823
                ],
                [
                    73.6238025,
                    56.4579228
                ],
                [
                    73.6223854,
                    56.4576669
                ],
                [
                    73.6204505,
                    56.457441
                ],
                [
                    73.6193605,
                    56.4573356
                ],
                [
                    73.6182431,
                    56.4570495
                ],
                [
                    73.6198237,
                    56.4553027
                ],
                [
                    73.6226307,
                    56.4536913
                ],
                [
                    73.6237207,
                    56.4532395
                ],
                [
                    73.6259554,
                    56.4521251
                ],
                [
                    73.6168533,
                    56.448887
                ],
                [
                    73.6151364,
                    56.4487213
                ],
                [
                    73.6150819,
                    56.4494443
                ],
                [
                    73.6146459,
                    56.4500467
                ],
                [
                    73.6141009,
                    56.4503931
                ],
                [
                    73.612602,
                    56.4495497
                ],
                [
                    73.6107762,
                    56.4502727
                ],
                [
                    73.610231,
                    56.4504082
                ],
                [
                    73.6100675,
                    56.4507245
                ],
                [
                    73.6096589,
                    56.4539624
                ],
                [
                    73.6058981,
                    56.4558297
                ],
                [
                    73.6070699,
                    56.4581487
                ],
                [
                    73.6066067,
                    56.4593684
                ],
                [
                    73.6035272,
                    56.4596093
                ],
                [
                    73.6020556,
                    56.4595641
                ],
                [
                    73.6014016,
                    56.4594888
                ],
                [
                    73.600148,
                    56.4590823
                ],
                [
                    73.599712,
                    56.4590221
                ],
                [
                    73.5992487,
                    56.4591726
                ],
                [
                    73.5810173,
                    56.4612957
                ],
                [
                    73.5789189,
                    56.4604224
                ],
                [
                    73.576766,
                    56.4588715
                ],
                [
                    73.5760847,
                    56.4580584
                ],
                [
                    73.57167,
                    56.4601815
                ],
                [
                    73.568972,
                    56.4617323
                ],
                [
                    73.5680182,
                    56.4614613
                ],
                [
                    73.5649387,
                    56.4614914
                ],
                [
                    73.5639577,
                    56.4623044
                ],
                [
                    73.5639305,
                    56.4628013
                ]
            ],
            "longitude": 73.606575,
            "latitude": 56.467625
        },
        "5885": {
            "name": "ТАВРИЧЕСКОЕ",
            "population": 12787,
            "type": "town",
            "poly": [
                [
                    73.595111,
                    54.5860578
                ],
                [
                    73.5956859,
                    54.5859626
                ],
                [
                    73.596343,
                    54.5862799
                ],
                [
                    73.5979036,
                    54.5867242
                ],
                [
                    73.5989987,
                    54.5880727
                ],
                [
                    73.6005867,
                    54.588501
                ],
                [
                    73.604584,
                    54.5903412
                ],
                [
                    73.604584,
                    54.5907695
                ],
                [
                    73.6052684,
                    54.5910868
                ],
                [
                    73.6084443,
                    54.5917213
                ],
                [
                    73.6095669,
                    54.5920386
                ],
                [
                    73.6077325,
                    54.5940214
                ],
                [
                    73.6083622,
                    54.5941959
                ],
                [
                    73.6089098,
                    54.594529
                ],
                [
                    73.60943,
                    54.5951476
                ],
                [
                    73.6105799,
                    54.5956235
                ],
                [
                    73.6080884,
                    54.5978758
                ],
                [
                    73.6328934,
                    54.5994142
                ],
                [
                    73.6354123,
                    54.5927048
                ],
                [
                    73.6372193,
                    54.5929269
                ],
                [
                    73.6410523,
                    54.593149
                ],
                [
                    73.643927,
                    54.5933076
                ],
                [
                    73.6518942,
                    54.5922607
                ],
                [
                    73.6540024,
                    54.5919593
                ],
                [
                    73.6551523,
                    54.591991
                ],
                [
                    73.6566581,
                    54.5920386
                ],
                [
                    73.6576437,
                    54.5917055
                ],
                [
                    73.6738026,
                    54.5828115
                ],
                [
                    73.6766718,
                    54.581009
                ],
                [
                    73.6760367,
                    54.5807933
                ],
                [
                    73.6798916,
                    54.5786479
                ],
                [
                    73.680921,
                    54.5792826
                ],
                [
                    73.6951579,
                    54.5716907
                ],
                [
                    73.6950046,
                    54.5712209
                ],
                [
                    73.6952893,
                    54.5709289
                ],
                [
                    73.6952017,
                    54.570713
                ],
                [
                    73.6947855,
                    54.5704591
                ],
                [
                    73.6778546,
                    54.5725414
                ],
                [
                    73.6562583,
                    54.5753726
                ],
                [
                    73.6478038,
                    54.5765279
                ],
                [
                    73.6467744,
                    54.5766675
                ],
                [
                    73.6460078,
                    54.5766548
                ],
                [
                    73.6427412,
                    54.5761697
                ],
                [
                    73.6411235,
                    54.5759312
                ],
                [
                    73.6284023,
                    54.5740783
                ],
                [
                    73.6239866,
                    54.5732555
                ],
                [
                    73.6212882,
                    54.5719046
                ],
                [
                    73.6210429,
                    54.5719148
                ],
                [
                    73.620342,
                    54.5723516
                ],
                [
                    73.6196937,
                    54.5732555
                ],
                [
                    73.6170478,
                    54.5768916
                ],
                [
                    73.6166097,
                    54.5768916
                ],
                [
                    73.6162067,
                    54.5766986
                ],
                [
                    73.6151904,
                    54.5772775
                ],
                [
                    73.6207625,
                    54.5807913
                ],
                [
                    73.6209728,
                    54.5810046
                ],
                [
                    73.6212882,
                    54.5811265
                ],
                [
                    73.6226374,
                    54.581949
                ],
                [
                    73.6210254,
                    54.5842135
                ],
                [
                    73.6208501,
                    54.5841627
                ],
                [
                    73.6208677,
                    54.5840409
                ],
                [
                    73.6198689,
                    54.5839495
                ],
                [
                    73.6193783,
                    54.5844673
                ],
                [
                    73.6179405,
                    54.5848217
                ],
                [
                    73.6143302,
                    54.5847254
                ],
                [
                    73.6145947,
                    54.5839698
                ],
                [
                    73.6120539,
                    54.5835636
                ],
                [
                    73.6121065,
                    54.5830965
                ],
                [
                    73.6115984,
                    54.5830457
                ],
                [
                    73.6109851,
                    54.5828528
                ],
                [
                    73.6060158,
                    54.5820903
                ],
                [
                    73.6051767,
                    54.5846879
                ],
                [
                    73.5961121,
                    54.5835447
                ],
                [
                    73.595111,
                    54.5860578
                ]
            ],
            "longitude": 73.637436,
            "latitude": 54.586674
        },
        "5886": {
            "name": "ЗНАМЕНСКОЕ",
            "population": 5294,
            "type": "town",
            "poly": [
                [
                    73.7952608,
                    57.1265677
                ],
                [
                    73.7959231,
                    57.1272267
                ],
                [
                    73.7967234,
                    57.1275413
                ],
                [
                    73.7970545,
                    57.1278558
                ],
                [
                    73.7982411,
                    57.1282752
                ],
                [
                    73.798655,
                    57.128365
                ],
                [
                    73.7992897,
                    57.1287694
                ],
                [
                    73.800421,
                    57.1291139
                ],
                [
                    73.8009729,
                    57.1291438
                ],
                [
                    73.8021043,
                    57.1295632
                ],
                [
                    73.8020767,
                    57.1298627
                ],
                [
                    73.8016628,
                    57.1299825
                ],
                [
                    73.8017456,
                    57.1302222
                ],
                [
                    73.8021043,
                    57.1302821
                ],
                [
                    73.8026286,
                    57.1299825
                ],
                [
                    73.8030425,
                    57.1304917
                ],
                [
                    73.8024907,
                    57.1310908
                ],
                [
                    73.8024907,
                    57.1315251
                ],
                [
                    73.8034289,
                    57.1320942
                ],
                [
                    73.8034289,
                    57.1326183
                ],
                [
                    73.8052777,
                    57.1342356
                ],
                [
                    73.8053881,
                    57.1343704
                ],
                [
                    73.8058848,
                    57.1343255
                ],
                [
                    73.806685,
                    57.134041
                ],
                [
                    73.8075405,
                    57.1337864
                ],
                [
                    73.8079544,
                    57.1336816
                ],
                [
                    73.8095273,
                    57.1336666
                ],
                [
                    73.810162,
                    57.1334569
                ],
                [
                    73.8114865,
                    57.1333521
                ],
                [
                    73.8118729,
                    57.1334569
                ],
                [
                    73.8123144,
                    57.1332473
                ],
                [
                    73.812949,
                    57.1331724
                ],
                [
                    73.8140252,
                    57.1330975
                ],
                [
                    73.8149359,
                    57.1329628
                ],
                [
                    73.8160397,
                    57.1327082
                ],
                [
                    73.8170054,
                    57.1327381
                ],
                [
                    73.8187439,
                    57.1329478
                ],
                [
                    73.8194614,
                    57.1331574
                ],
                [
                    73.820234,
                    57.1335767
                ],
                [
                    73.8213654,
                    57.1345052
                ],
                [
                    73.8222209,
                    57.1354186
                ],
                [
                    73.8229659,
                    57.1360176
                ],
                [
                    73.8324309,
                    57.1329328
                ],
                [
                    73.8389985,
                    57.1319444
                ],
                [
                    73.8393296,
                    57.1327231
                ],
                [
                    73.840461,
                    57.1341009
                ],
                [
                    73.8419787,
                    57.1328579
                ],
                [
                    73.8421167,
                    57.1324686
                ],
                [
                    73.8441311,
                    57.1325135
                ],
                [
                    73.8455384,
                    57.1304019
                ],
                [
                    73.8464766,
                    57.1285747
                ],
                [
                    73.8468629,
                    57.1282152
                ],
                [
                    73.8472769,
                    57.1280205
                ],
                [
                    73.8471389,
                    57.1275113
                ],
                [
                    73.8469733,
                    57.1267924
                ],
                [
                    73.8470561,
                    57.1261333
                ],
                [
                    73.8468905,
                    57.1259087
                ],
                [
                    73.8467802,
                    57.1254593
                ],
                [
                    73.8465042,
                    57.1252496
                ],
                [
                    73.8465594,
                    57.1250699
                ],
                [
                    73.8463386,
                    57.1250249
                ],
                [
                    73.8460351,
                    57.1240963
                ],
                [
                    73.8455384,
                    57.1233173
                ],
                [
                    73.8451797,
                    57.1224485
                ],
                [
                    73.8446553,
                    57.1217744
                ],
                [
                    73.844545,
                    57.1210554
                ],
                [
                    73.8443242,
                    57.1208606
                ],
                [
                    73.8441311,
                    57.1203363
                ],
                [
                    73.8438275,
                    57.1200667
                ],
                [
                    73.8438827,
                    57.1198719
                ],
                [
                    73.8437171,
                    57.1197221
                ],
                [
                    73.8438551,
                    57.119048
                ],
                [
                    73.8436896,
                    57.1183589
                ],
                [
                    73.8442966,
                    57.1172802
                ],
                [
                    73.8445726,
                    57.1171154
                ],
                [
                    73.8443518,
                    57.1166809
                ],
                [
                    73.8443793,
                    57.1165311
                ],
                [
                    73.8449037,
                    57.1164712
                ],
                [
                    73.8451797,
                    57.1163213
                ],
                [
                    73.8437171,
                    57.1158869
                ],
                [
                    73.8413992,
                    57.1152726
                ],
                [
                    73.841344,
                    57.114943
                ],
                [
                    73.8403782,
                    57.1149729
                ],
                [
                    73.8398815,
                    57.1151227
                ],
                [
                    73.839164,
                    57.1147482
                ],
                [
                    73.8341418,
                    57.1113619
                ],
                [
                    73.8291747,
                    57.1129202
                ],
                [
                    73.8284297,
                    57.1145384
                ],
                [
                    73.8284021,
                    57.1153025
                ],
                [
                    73.8282365,
                    57.1155722
                ],
                [
                    73.8288988,
                    57.1167558
                ],
                [
                    73.8292575,
                    57.1171154
                ],
                [
                    73.8282917,
                    57.1185236
                ],
                [
                    73.8290368,
                    57.120606
                ],
                [
                    73.8274639,
                    57.1212501
                ],
                [
                    73.8252839,
                    57.1220441
                ],
                [
                    73.8234626,
                    57.1225983
                ],
                [
                    73.8203996,
                    57.1211603
                ],
                [
                    73.8197925,
                    57.1211902
                ],
                [
                    73.8089754,
                    57.1223437
                ],
                [
                    73.8085615,
                    57.1205161
                ],
                [
                    73.8045603,
                    57.1208756
                ],
                [
                    73.8041463,
                    57.1207708
                ],
                [
                    73.8034013,
                    57.1209056
                ],
                [
                    73.8031805,
                    57.1209355
                ],
                [
                    73.8024631,
                    57.121325
                ],
                [
                    73.8024631,
                    57.1214449
                ],
                [
                    73.799676,
                    57.1222089
                ],
                [
                    73.7976616,
                    57.1235121
                ],
                [
                    73.7971096,
                    57.1241262
                ],
                [
                    73.7973028,
                    57.1247703
                ],
                [
                    73.7974132,
                    57.124965
                ],
                [
                    73.7971925,
                    57.1251747
                ],
                [
                    73.7973304,
                    57.1255492
                ],
                [
                    73.7961715,
                    57.1257739
                ],
                [
                    73.7965578,
                    57.1264029
                ],
                [
                    73.7952608,
                    57.1265677
                ]
            ],
            "longitude": 73.821983,
            "latitude": 57.127403
        },
        "5887": {
            "name": "РУССКАЯ ПОЛЯНА",
            "population": 5940,
            "type": "town",
            "poly": [
                [
                    73.8554417,
                    53.7782625
                ],
                [
                    73.8637599,
                    53.7832617
                ],
                [
                    73.8647088,
                    53.7813649
                ],
                [
                    73.866907,
                    53.781748
                ],
                [
                    73.8672391,
                    53.7817013
                ],
                [
                    73.870481,
                    53.7824208
                ],
                [
                    73.8703861,
                    53.7825703
                ],
                [
                    73.8709712,
                    53.7826824
                ],
                [
                    73.8712401,
                    53.7822713
                ],
                [
                    73.8717936,
                    53.7824021
                ],
                [
                    73.8719043,
                    53.78229
                ],
                [
                    73.8726001,
                    53.7824208
                ],
                [
                    73.872774,
                    53.7822059
                ],
                [
                    73.8742606,
                    53.7824955
                ],
                [
                    73.8726159,
                    53.7852986
                ],
                [
                    73.8724894,
                    53.7852799
                ],
                [
                    73.8722205,
                    53.7858592
                ],
                [
                    73.8766327,
                    53.7866066
                ],
                [
                    73.8767118,
                    53.7865039
                ],
                [
                    73.8771546,
                    53.786616
                ],
                [
                    73.8755807,
                    53.789453
                ],
                [
                    73.8931938,
                    53.7922906
                ],
                [
                    73.8960799,
                    53.7923023
                ],
                [
                    73.8970288,
                    53.7906324
                ],
                [
                    73.897266,
                    53.7906324
                ],
                [
                    73.8977009,
                    53.7898033
                ],
                [
                    73.8960996,
                    53.7896515
                ],
                [
                    73.8958427,
                    53.7892078
                ],
                [
                    73.8985904,
                    53.7891961
                ],
                [
                    73.8991637,
                    53.789161
                ],
                [
                    73.8999149,
                    53.7889041
                ],
                [
                    73.9004684,
                    53.7886122
                ],
                [
                    73.9009823,
                    53.7882151
                ],
                [
                    73.90118,
                    53.7880049
                ],
                [
                    73.9013777,
                    53.7880283
                ],
                [
                    73.9022078,
                    53.7872925
                ],
                [
                    73.9020498,
                    53.7871874
                ],
                [
                    73.9025044,
                    53.7862531
                ],
                [
                    73.9028207,
                    53.783964
                ],
                [
                    73.9031568,
                    53.7813361
                ],
                [
                    73.9024254,
                    53.7809389
                ],
                [
                    73.9041847,
                    53.7799111
                ],
                [
                    73.9062603,
                    53.7799578
                ],
                [
                    73.9073278,
                    53.7782641
                ],
                [
                    73.9084144,
                    53.7784785
                ],
                [
                    73.9055085,
                    53.7704179
                ],
                [
                    73.8927188,
                    53.7703478
                ],
                [
                    73.8914536,
                    53.7659897
                ],
                [
                    73.8845547,
                    53.767053
                ],
                [
                    73.8823605,
                    53.7619117
                ],
                [
                    73.8736428,
                    53.7630802
                ],
                [
                    73.8725754,
                    53.7593174
                ],
                [
                    73.8591136,
                    53.7597381
                ],
                [
                    73.8631462,
                    53.7716563
                ],
                [
                    73.8639962,
                    53.7719016
                ],
                [
                    73.8650834,
                    53.7721937
                ],
                [
                    73.8660718,
                    53.772626
                ],
                [
                    73.8674185,
                    53.773283
                ],
                [
                    73.8647871,
                    53.7763932
                ],
                [
                    73.8643134,
                    53.7765337
                ],
                [
                    73.8554417,
                    53.7782625
                ]
            ],
            "longitude": 73.882103,
            "latitude": 53.780357
        },
        "5888": {
            "name": "КОРМИЛОВКА",
            "population": 9747,
            "type": "town",
            "poly": [
                [
                    74.0575377,
                    54.9924123
                ],
                [
                    74.0580759,
                    54.9936496
                ],
                [
                    74.0576052,
                    54.9945496
                ],
                [
                    74.0575529,
                    54.9947896
                ],
                [
                    74.0580236,
                    54.9953146
                ],
                [
                    74.0584158,
                    54.9957646
                ],
                [
                    74.0590695,
                    54.9960796
                ],
                [
                    74.0594617,
                    54.9963496
                ],
                [
                    74.0596185,
                    54.9968446
                ],
                [
                    74.0608475,
                    54.9976245
                ],
                [
                    74.0627825,
                    54.9985544
                ],
                [
                    74.0648743,
                    54.9994693
                ],
                [
                    74.065528,
                    54.9995143
                ],
                [
                    74.0664171,
                    54.9996943
                ],
                [
                    74.0671231,
                    54.9999792
                ],
                [
                    74.0675153,
                    55.0003392
                ],
                [
                    74.068169,
                    55.0007291
                ],
                [
                    74.0693979,
                    55.001359
                ],
                [
                    74.0701823,
                    55.001554
                ],
                [
                    74.071176,
                    55.001599
                ],
                [
                    74.0742876,
                    55.0022139
                ],
                [
                    74.0748252,
                    55.0022874
                ],
                [
                    74.0752854,
                    55.0023593
                ],
                [
                    74.0758502,
                    55.0024553
                ],
                [
                    74.0763522,
                    55.0026113
                ],
                [
                    74.0769379,
                    55.0028273
                ],
                [
                    74.0775655,
                    55.0031872
                ],
                [
                    74.0784441,
                    55.003907
                ],
                [
                    74.0804732,
                    55.0058025
                ],
                [
                    74.081289,
                    55.0065463
                ],
                [
                    74.0815818,
                    55.0067262
                ],
                [
                    74.0818747,
                    55.0068702
                ],
                [
                    74.0823975,
                    55.0069901
                ],
                [
                    74.0844058,
                    55.007314
                ],
                [
                    74.0921389,
                    55.0085373
                ],
                [
                    74.0906509,
                    55.0132261
                ],
                [
                    74.0838917,
                    55.0127341
                ],
                [
                    74.0850573,
                    55.0140707
                ],
                [
                    74.0850271,
                    55.0144106
                ],
                [
                    74.0901237,
                    55.0153528
                ],
                [
                    74.0963007,
                    55.0164443
                ],
                [
                    74.0966578,
                    55.0151987
                ],
                [
                    74.0969488,
                    55.0150732
                ],
                [
                    74.0976127,
                    55.0134302
                ],
                [
                    74.0959672,
                    55.0132059
                ],
                [
                    74.0960347,
                    55.0130063
                ],
                [
                    74.0967659,
                    55.0131
                ],
                [
                    74.0978075,
                    55.0101108
                ],
                [
                    74.0969973,
                    55.0099719
                ],
                [
                    74.0972419,
                    55.0094359
                ],
                [
                    74.1137961,
                    55.0121602
                ],
                [
                    74.1183982,
                    55.0128918
                ],
                [
                    74.1206992,
                    55.0132517
                ],
                [
                    74.1213895,
                    55.0133956
                ],
                [
                    74.122017,
                    55.0135995
                ],
                [
                    74.1229793,
                    55.0140193
                ],
                [
                    74.126368,
                    55.0155665
                ],
                [
                    74.1276859,
                    55.0104449
                ],
                [
                    74.1272885,
                    55.0104689
                ],
                [
                    74.1272048,
                    55.010217
                ],
                [
                    74.1279369,
                    55.0095333
                ],
                [
                    74.1282089,
                    55.0094493
                ],
                [
                    74.1299869,
                    55.0048068
                ],
                [
                    74.1309701,
                    55.0016035
                ],
                [
                    74.1298196,
                    55.0014355
                ],
                [
                    74.12869,
                    55.0011356
                ],
                [
                    74.127916,
                    55.0009436
                ],
                [
                    74.1271002,
                    55.0008236
                ],
                [
                    74.1189211,
                    54.9999358
                ],
                [
                    74.1125619,
                    54.9993838
                ],
                [
                    74.1089012,
                    54.9990599
                ],
                [
                    74.1069976,
                    54.9989999
                ],
                [
                    74.1078344,
                    54.998136
                ],
                [
                    74.1080017,
                    54.9972961
                ],
                [
                    74.1074997,
                    54.9970921
                ],
                [
                    74.1075834,
                    54.9959761
                ],
                [
                    74.1080436,
                    54.9959521
                ],
                [
                    74.108692,
                    54.9957121
                ],
                [
                    74.1095706,
                    54.9951362
                ],
                [
                    74.1157206,
                    54.991152
                ],
                [
                    74.1055543,
                    54.990288
                ],
                [
                    74.0977517,
                    54.9896399
                ],
                [
                    74.0896563,
                    54.9887758
                ],
                [
                    74.0798665,
                    54.9878517
                ],
                [
                    74.0828159,
                    54.990912
                ],
                [
                    74.0818956,
                    54.991188
                ],
                [
                    74.0834436,
                    54.9945362
                ],
                [
                    74.0834436,
                    54.9949562
                ],
                [
                    74.0808045,
                    54.9947451
                ],
                [
                    74.0754997,
                    54.9941691
                ],
                [
                    74.0682034,
                    54.9933723
                ],
                [
                    74.0650753,
                    54.9930134
                ],
                [
                    74.0575377,
                    54.9924123
                ]
            ],
            "longitude": 74.092224,
            "latitude": 55.002613
        },
        "5889": {
            "name": "ГОРЬКОВСКОЕ",
            "population": 5437,
            "type": "town",
            "poly": [
                [
                    74.3377136,
                    55.3678184
                ],
                [
                    74.3397736,
                    55.3730861
                ],
                [
                    74.3641495,
                    55.3809375
                ],
                [
                    74.3739341,
                    55.3829855
                ],
                [
                    74.3850922,
                    55.3750369
                ],
                [
                    74.3856072,
                    55.3694768
                ],
                [
                    74.3807148,
                    55.3620134
                ],
                [
                    74.3611454,
                    55.3546949
                ],
                [
                    74.3575405,
                    55.3551341
                ],
                [
                    74.3377136,
                    55.3678184
                ]
            ],
            "longitude": 74.362556,
            "latitude": 55.371033
        },
        "5890": {
            "name": "ТАРА",
            "population": 27922,
            "type": "town",
            "poly": [
                [
                    74.2420105,
                    56.9491036
                ],
                [
                    74.2437231,
                    56.9501813
                ],
                [
                    74.2466476,
                    56.9527676
                ],
                [
                    74.2580032,
                    56.9596635
                ],
                [
                    74.262087,
                    56.9622204
                ],
                [
                    74.2648271,
                    56.9641165
                ],
                [
                    74.2677516,
                    56.965323
                ],
                [
                    74.2683049,
                    56.9674917
                ],
                [
                    74.265354,
                    56.9734659
                ],
                [
                    74.2552631,
                    56.9752752
                ],
                [
                    74.2478332,
                    56.9769552
                ],
                [
                    74.2592942,
                    56.9836744
                ],
                [
                    74.2644582,
                    56.9860287
                ],
                [
                    74.2707288,
                    56.9878087
                ],
                [
                    74.2813467,
                    56.9895886
                ],
                [
                    74.3033201,
                    56.9898326
                ],
                [
                    74.3133847,
                    56.9909665
                ],
                [
                    74.3162566,
                    56.9908086
                ],
                [
                    74.3181799,
                    56.990134
                ],
                [
                    74.3209727,
                    56.9879666
                ],
                [
                    74.3214996,
                    56.9856124
                ],
                [
                    74.3160458,
                    56.9737818
                ],
                [
                    74.3164146,
                    56.9700337
                ],
                [
                    74.3188386,
                    56.9670465
                ],
                [
                    74.322211,
                    56.9647772
                ],
                [
                    74.3306684,
                    56.9611718
                ],
                [
                    74.3402851,
                    56.9575374
                ],
                [
                    74.3556981,
                    56.9544773
                ],
                [
                    74.3624166,
                    56.9540176
                ],
                [
                    74.3684501,
                    56.9543193
                ],
                [
                    74.3901074,
                    56.9586723
                ],
                [
                    74.395166,
                    56.9589884
                ],
                [
                    74.4026222,
                    56.9579253
                ],
                [
                    74.4139251,
                    56.9549802
                ],
                [
                    74.4219873,
                    56.9528107
                ],
                [
                    74.4272831,
                    56.9500951
                ],
                [
                    74.4301549,
                    56.9473649
                ],
                [
                    74.4311824,
                    56.9450225
                ],
                [
                    74.4298651,
                    56.9421482
                ],
                [
                    74.427125,
                    56.93936
                ],
                [
                    74.4192736,
                    56.9362409
                ],
                [
                    74.4136616,
                    56.9344872
                ],
                [
                    74.4070485,
                    56.933596
                ],
                [
                    74.3956929,
                    56.9331359
                ],
                [
                    74.3905553,
                    56.9158671
                ],
                [
                    74.4057312,
                    56.9140117
                ],
                [
                    74.4121599,
                    56.9126454
                ],
                [
                    74.4283106,
                    56.9091213
                ],
                [
                    74.4433548,
                    56.9078986
                ],
                [
                    74.4692803,
                    56.9086178
                ],
                [
                    74.4787916,
                    56.9070786
                ],
                [
                    74.4898837,
                    56.9036547
                ],
                [
                    74.491728,
                    56.9055825
                ],
                [
                    74.5218954,
                    56.8934963
                ],
                [
                    74.5292725,
                    56.8895962
                ],
                [
                    74.5235289,
                    56.8873221
                ],
                [
                    74.5172319,
                    56.8748989
                ],
                [
                    74.4796083,
                    56.8808735
                ],
                [
                    74.4577666,
                    56.8815933
                ],
                [
                    74.4298651,
                    56.8781814
                ],
                [
                    74.4410362,
                    56.8716016
                ],
                [
                    74.4422745,
                    56.8710112
                ],
                [
                    74.4418266,
                    56.8705073
                ],
                [
                    74.441247,
                    56.8701761
                ],
                [
                    74.440035,
                    56.8689953
                ],
                [
                    74.4292064,
                    56.8720624
                ],
                [
                    74.4214077,
                    56.8753884
                ],
                [
                    74.4200113,
                    56.8756763
                ],
                [
                    74.4116856,
                    56.8666048
                ],
                [
                    74.4293908,
                    56.8595044
                ],
                [
                    74.4270459,
                    56.8557736
                ],
                [
                    74.4322627,
                    56.8410198
                ],
                [
                    74.4094725,
                    56.8413368
                ],
                [
                    74.3799637,
                    56.8503857
                ],
                [
                    74.3864978,
                    56.8564939
                ],
                [
                    74.3911349,
                    56.8592739
                ],
                [
                    74.3912666,
                    56.85949
                ],
                [
                    74.3912403,
                    56.8597204
                ],
                [
                    74.391372,
                    56.8599509
                ],
                [
                    74.3916355,
                    56.8601526
                ],
                [
                    74.3922678,
                    56.860311
                ],
                [
                    74.3924786,
                    56.8608871
                ],
                [
                    74.3924259,
                    56.8612616
                ],
                [
                    74.3917936,
                    56.8617657
                ],
                [
                    74.3918199,
                    56.8619818
                ],
                [
                    74.392057,
                    56.862169
                ],
                [
                    74.3921097,
                    56.8625291
                ],
                [
                    74.3923469,
                    56.8628027
                ],
                [
                    74.3923996,
                    56.8629611
                ],
                [
                    74.3921624,
                    56.8631628
                ],
                [
                    74.3920307,
                    56.8634796
                ],
                [
                    74.3915828,
                    56.8634796
                ],
                [
                    74.3913193,
                    56.8635516
                ],
                [
                    74.3910973,
                    56.8636537
                ],
                [
                    74.3912052,
                    56.8637658
                ],
                [
                    74.3913779,
                    56.8638188
                ],
                [
                    74.3913347,
                    56.8638896
                ],
                [
                    74.3910541,
                    56.8639309
                ],
                [
                    74.3907196,
                    56.8638483
                ],
                [
                    74.390439,
                    56.8637835
                ],
                [
                    74.3902663,
                    56.863866
                ],
                [
                    74.39018,
                    56.8640135
                ],
                [
                    74.3901584,
                    56.8641551
                ],
                [
                    74.3903095,
                    56.8643144
                ],
                [
                    74.3903527,
                    56.8644088
                ],
                [
                    74.3903527,
                    56.8646034
                ],
                [
                    74.3903311,
                    56.8648453
                ],
                [
                    74.3905793,
                    56.8650753
                ],
                [
                    74.3906656,
                    56.8654706
                ],
                [
                    74.3907412,
                    56.8656711
                ],
                [
                    74.3903958,
                    56.8657891
                ],
                [
                    74.3902124,
                    56.8659779
                ],
                [
                    74.3901045,
                    56.8661725
                ],
                [
                    74.3902987,
                    56.8662551
                ],
                [
                    74.3902124,
                    56.8663672
                ],
                [
                    74.3901476,
                    56.8664969
                ],
                [
                    74.3901368,
                    56.8667919
                ],
                [
                    74.3902987,
                    56.8669275
                ],
                [
                    74.3906117,
                    56.8670219
                ],
                [
                    74.390644,
                    56.8671871
                ],
                [
                    74.3906117,
                    56.8674289
                ],
                [
                    74.3900721,
                    56.8677121
                ],
                [
                    74.3898994,
                    56.8679362
                ],
                [
                    74.3898994,
                    56.8680896
                ],
                [
                    74.389921,
                    56.8682311
                ],
                [
                    74.3896404,
                    56.8683019
                ],
                [
                    74.3894354,
                    56.8684553
                ],
                [
                    74.3894138,
                    56.8686027
                ],
                [
                    74.3895649,
                    56.8686617
                ],
                [
                    74.3898778,
                    56.8686676
                ],
                [
                    74.3899857,
                    56.8687443
                ],
                [
                    74.3899426,
                    56.8688328
                ],
                [
                    74.3898131,
                    56.8689094
                ],
                [
                    74.3898239,
                    56.8690746
                ],
                [
                    74.3899318,
                    56.8692279
                ],
                [
                    74.3899426,
                    56.8694993
                ],
                [
                    74.3895865,
                    56.8697411
                ],
                [
                    74.3894462,
                    56.8699298
                ],
                [
                    74.3895433,
                    56.8700596
                ],
                [
                    74.3899642,
                    56.8702601
                ],
                [
                    74.3901584,
                    56.8705019
                ],
                [
                    74.3902448,
                    56.8708263
                ],
                [
                    74.3900721,
                    56.8710505
                ],
                [
                    74.3897375,
                    56.8711684
                ],
                [
                    74.3892951,
                    56.8711625
                ],
                [
                    74.3889929,
                    56.8711035
                ],
                [
                    74.3888094,
                    56.8712215
                ],
                [
                    74.3887339,
                    56.8713218
                ],
                [
                    74.3887447,
                    56.8714397
                ],
                [
                    74.3891764,
                    56.8714338
                ],
                [
                    74.3895109,
                    56.8715459
                ],
                [
                    74.389716,
                    56.8716815
                ],
                [
                    74.3782635,
                    56.8714845
                ],
                [
                    74.3762611,
                    56.8715565
                ],
                [
                    74.3744695,
                    56.8717437
                ],
                [
                    74.3725199,
                    56.8721037
                ],
                [
                    74.3700432,
                    56.872766
                ],
                [
                    74.3672241,
                    56.8737019
                ],
                [
                    74.3652481,
                    56.8743786
                ],
                [
                    74.3636145,
                    56.8747674
                ],
                [
                    74.3614804,
                    56.8750265
                ],
                [
                    74.3519691,
                    56.8757896
                ],
                [
                    74.3509153,
                    56.8760344
                ],
                [
                    74.3501775,
                    56.8762791
                ],
                [
                    74.3496506,
                    56.8766535
                ],
                [
                    74.3493081,
                    56.8769846
                ],
                [
                    74.3490973,
                    56.8773733
                ],
                [
                    74.3416938,
                    56.8780068
                ],
                [
                    74.3409561,
                    56.8713549
                ],
                [
                    74.3400603,
                    56.8713261
                ],
                [
                    74.329337,
                    56.8663869
                ],
                [
                    74.3129491,
                    56.8685902
                ],
                [
                    74.3124749,
                    56.8686046
                ],
                [
                    74.3119216,
                    56.868475
                ],
                [
                    74.3073899,
                    56.8665741
                ],
                [
                    74.3058091,
                    56.8655084
                ],
                [
                    74.2866021,
                    56.8500524
                ],
                [
                    74.2756417,
                    56.8513923
                ],
                [
                    74.2754046,
                    56.8515075
                ],
                [
                    74.2751938,
                    56.8518101
                ],
                [
                    74.2644969,
                    56.869411
                ],
                [
                    74.2739028,
                    56.8711677
                ],
                [
                    74.2847051,
                    56.8812171
                ],
                [
                    74.2900799,
                    56.8866869
                ],
                [
                    74.2999074,
                    56.886615
                ],
                [
                    74.3017253,
                    56.8912925
                ],
                [
                    74.2999074,
                    56.8930338
                ],
                [
                    74.298669,
                    56.8945305
                ],
                [
                    74.2983265,
                    56.8946888
                ],
                [
                    74.2979313,
                    56.8947031
                ],
                [
                    74.2920032,
                    56.8935807
                ],
                [
                    74.2846261,
                    56.8971494
                ],
                [
                    74.2786385,
                    56.9005084
                ],
                [
                    74.2825113,
                    56.9038622
                ],
                [
                    74.2898305,
                    56.9080856
                ],
                [
                    74.2934927,
                    56.9075389
                ],
                [
                    74.2956268,
                    56.9063881
                ],
                [
                    74.2950472,
                    56.9035972
                ],
                [
                    74.2929921,
                    56.9028634
                ],
                [
                    74.2925179,
                    56.9025757
                ],
                [
                    74.2933873,
                    56.9024174
                ],
                [
                    74.2948627,
                    56.9021441
                ],
                [
                    74.3012651,
                    56.9012089
                ],
                [
                    74.304901,
                    56.9006477
                ],
                [
                    74.306956,
                    56.905453
                ],
                [
                    74.3124362,
                    56.9046761
                ],
                [
                    74.3178901,
                    56.9044747
                ],
                [
                    74.3220529,
                    56.9021009
                ],
                [
                    74.3294564,
                    56.9033957
                ],
                [
                    74.3288241,
                    56.9045467
                ],
                [
                    74.3286924,
                    56.9054674
                ],
                [
                    74.3290876,
                    56.9054962
                ],
                [
                    74.3292457,
                    56.9050502
                ],
                [
                    74.3301678,
                    56.9048919
                ],
                [
                    74.330563,
                    56.9046905
                ],
                [
                    74.3310899,
                    56.9038273
                ],
                [
                    74.3314852,
                    56.9038273
                ],
                [
                    74.3321965,
                    56.9039712
                ],
                [
                    74.3319067,
                    56.9044316
                ],
                [
                    74.3357797,
                    56.9050933
                ],
                [
                    74.3372025,
                    56.9056112
                ],
                [
                    74.3378348,
                    56.9063305
                ],
                [
                    74.3385725,
                    56.9071218
                ],
                [
                    74.3389414,
                    56.9077979
                ],
                [
                    74.3392575,
                    56.9088623
                ],
                [
                    74.3339618,
                    56.9093658
                ],
                [
                    74.3289295,
                    56.9103008
                ],
                [
                    74.3288241,
                    56.9105022
                ],
                [
                    74.3286133,
                    56.9105453
                ],
                [
                    74.3288241,
                    56.9114515
                ],
                [
                    74.3331977,
                    56.9115378
                ],
                [
                    74.3371498,
                    56.9114084
                ],
                [
                    74.34263,
                    56.9113508
                ],
                [
                    74.3419713,
                    56.9134508
                ],
                [
                    74.3389414,
                    56.9163129
                ],
                [
                    74.3294564,
                    56.9179524
                ],
                [
                    74.3064554,
                    56.9220365
                ],
                [
                    74.2924915,
                    56.9226979
                ],
                [
                    74.2864844,
                    56.9315259
                ],
                [
                    74.2420105,
                    56.9491036
                ]
            ],
            "longitude": 74.3698652,
            "latitude": 56.902587
        },
        "5891": {
            "name": "КАЛАЧИНСК",
            "population": 22656,
            "type": "town",
            "poly": [
                [
                    74.5208645,
                    55.0653781
                ],
                [
                    74.5218239,
                    55.0651999
                ],
                [
                    74.5232271,
                    55.0643327
                ],
                [
                    74.5390922,
                    55.0615253
                ],
                [
                    74.5428005,
                    55.0647544
                ],
                [
                    74.5433709,
                    55.0650514
                ],
                [
                    74.5441229,
                    55.0653187
                ],
                [
                    74.5450304,
                    55.0656008
                ],
                [
                    74.5454712,
                    55.0657938
                ],
                [
                    74.5467158,
                    55.066462
                ],
                [
                    74.5480122,
                    55.0680061
                ],
                [
                    74.5439154,
                    55.0692384
                ],
                [
                    74.5399483,
                    55.0705894
                ],
                [
                    74.5384444,
                    55.0713911
                ],
                [
                    74.5419707,
                    55.0742562
                ],
                [
                    74.5425671,
                    55.0745531
                ],
                [
                    74.5428783,
                    55.0754735
                ],
                [
                    74.5426449,
                    55.0759485
                ],
                [
                    74.5460935,
                    55.0759633
                ],
                [
                    74.5477788,
                    55.0758594
                ],
                [
                    74.5491012,
                    55.0758446
                ],
                [
                    74.5491531,
                    55.0765422
                ],
                [
                    74.5494902,
                    55.0773586
                ],
                [
                    74.5497495,
                    55.0776852
                ],
                [
                    74.5523164,
                    55.0782344
                ],
                [
                    74.5803976,
                    55.0782789
                ],
                [
                    74.580631,
                    55.0907305
                ],
                [
                    74.5862835,
                    55.0905821
                ],
                [
                    74.586465,
                    55.0911756
                ],
                [
                    74.5920916,
                    55.0902557
                ],
                [
                    74.5924027,
                    55.0881633
                ],
                [
                    74.6058858,
                    55.0874955
                ],
                [
                    74.6036041,
                    55.0786352
                ],
                [
                    74.6024891,
                    55.07865
                ],
                [
                    74.6020743,
                    55.076854
                ],
                [
                    74.6053932,
                    55.0766165
                ],
                [
                    74.6036559,
                    55.068793
                ],
                [
                    74.6053673,
                    55.0687039
                ],
                [
                    74.6052635,
                    55.0680506
                ],
                [
                    74.6086343,
                    55.0678576
                ],
                [
                    74.6108642,
                    55.0676201
                ],
                [
                    74.609853,
                    55.070144
                ],
                [
                    74.6106568,
                    55.07246
                ],
                [
                    74.6120829,
                    55.0742562
                ],
                [
                    74.6154277,
                    55.0728905
                ],
                [
                    74.6161797,
                    55.0717028
                ],
                [
                    74.6184355,
                    55.0722224
                ],
                [
                    74.6194727,
                    55.0709605
                ],
                [
                    74.6173465,
                    55.0702776
                ],
                [
                    74.6177354,
                    55.0696095
                ],
                [
                    74.6192652,
                    55.0691493
                ],
                [
                    74.6192652,
                    55.0683921
                ],
                [
                    74.6155574,
                    55.0649772
                ],
                [
                    74.6119273,
                    55.0637744
                ],
                [
                    74.6067156,
                    55.0615322
                ],
                [
                    74.6075712,
                    55.0597206
                ],
                [
                    74.6062488,
                    55.055488
                ],
                [
                    74.6065859,
                    55.0540771
                ],
                [
                    74.6059377,
                    55.0535424
                ],
                [
                    74.6059118,
                    55.0528444
                ],
                [
                    74.6011668,
                    55.0497846
                ],
                [
                    74.5993777,
                    55.0477347
                ],
                [
                    74.5987554,
                    55.0450014
                ],
                [
                    74.5987554,
                    55.0440654
                ],
                [
                    74.6041745,
                    55.0444963
                ],
                [
                    74.6039671,
                    55.0439615
                ],
                [
                    74.6061451,
                    55.0441249
                ],
                [
                    74.6084528,
                    55.0443774
                ],
                [
                    74.6116939,
                    55.0448528
                ],
                [
                    74.6366118,
                    55.0481803
                ],
                [
                    74.616076,
                    55.0379443
                ],
                [
                    74.6122125,
                    55.0363842
                ],
                [
                    74.6051858,
                    55.0374391
                ],
                [
                    74.6042264,
                    55.0360573
                ],
                [
                    74.6037337,
                    55.0346457
                ],
                [
                    74.5933103,
                    55.0340216
                ],
                [
                    74.5947104,
                    55.0314656
                ],
                [
                    74.5881504,
                    55.0315102
                ],
                [
                    74.5835609,
                    55.0317777
                ],
                [
                    74.5844425,
                    55.0351063
                ],
                [
                    74.5805532,
                    55.0349429
                ],
                [
                    74.5778825,
                    55.0349874
                ],
                [
                    74.5753414,
                    55.0350172
                ],
                [
                    74.5693777,
                    55.0348686
                ],
                [
                    74.5684962,
                    55.0342742
                ],
                [
                    74.5677183,
                    55.0343039
                ],
                [
                    74.5672256,
                    55.0321789
                ],
                [
                    74.5667589,
                    55.0321789
                ],
                [
                    74.5666552,
                    55.0319412
                ],
                [
                    74.565644,
                    55.0318966
                ],
                [
                    74.5650217,
                    55.0320155
                ],
                [
                    74.5649439,
                    55.0316737
                ],
                [
                    74.5590839,
                    55.031748
                ],
                [
                    74.5590839,
                    55.0310792
                ],
                [
                    74.5558169,
                    55.0310347
                ],
                [
                    74.5557131,
                    55.0284488
                ],
                [
                    74.5527053,
                    55.0284191
                ],
                [
                    74.5525239,
                    55.0374243
                ],
                [
                    74.5418152,
                    55.0366665
                ],
                [
                    74.5421004,
                    55.0350914
                ],
                [
                    74.5364479,
                    55.0347794
                ],
                [
                    74.5350995,
                    55.0376026
                ],
                [
                    74.5373035,
                    55.0378849
                ],
                [
                    74.5372517,
                    55.0392964
                ],
                [
                    74.5500347,
                    55.0404404
                ],
                [
                    74.5494902,
                    55.042149
                ],
                [
                    74.5307175,
                    55.0406336
                ],
                [
                    74.5237686,
                    55.057686
                ],
                [
                    74.5230944,
                    55.060671
                ],
                [
                    74.5225758,
                    55.0632993
                ],
                [
                    74.522161,
                    55.0640714
                ],
                [
                    74.5208645,
                    55.0653781
                ]
            ],
            "longitude": 74.582428,
            "latitude": 55.049091
        },
        "5892": {
            "name": "БОЛЬШЕРЕЧЬЕ",
            "population": 10389,
            "type": "town",
            "poly": [
                [
                    74.5979283,
                    56.0986475
                ],
                [
                    74.5979283,
                    56.0991541
                ],
                [
                    74.5981041,
                    56.0996444
                ],
                [
                    74.5982945,
                    56.099767
                ],
                [
                    74.5985582,
                    56.0998323
                ],
                [
                    74.5985582,
                    56.1001183
                ],
                [
                    74.5988512,
                    56.1008536
                ],
                [
                    74.5990123,
                    56.1008782
                ],
                [
                    74.5990123,
                    56.1012376
                ],
                [
                    74.600199,
                    56.1019811
                ],
                [
                    74.6003454,
                    56.1031495
                ],
                [
                    74.6017518,
                    56.103125
                ],
                [
                    74.601825,
                    56.1032475
                ],
                [
                    74.6026161,
                    56.1032557
                ],
                [
                    74.6028652,
                    56.1074385
                ],
                [
                    74.6038174,
                    56.1083289
                ],
                [
                    74.6005212,
                    56.1094562
                ],
                [
                    74.6023964,
                    56.1111634
                ],
                [
                    74.6053556,
                    56.1104854
                ],
                [
                    74.6051212,
                    56.1112369
                ],
                [
                    74.6051304,
                    56.111733
                ],
                [
                    74.6049253,
                    56.1121741
                ],
                [
                    74.6047642,
                    56.1133176
                ],
                [
                    74.6045884,
                    56.1138648
                ],
                [
                    74.6046177,
                    56.1140854
                ],
                [
                    74.6048374,
                    56.1147959
                ],
                [
                    74.6048374,
                    56.1157842
                ],
                [
                    74.604647,
                    56.1166173
                ],
                [
                    74.6043833,
                    56.1169276
                ],
                [
                    74.6039145,
                    56.1174013
                ],
                [
                    74.603768,
                    56.1178015
                ],
                [
                    74.6036655,
                    56.1182588
                ],
                [
                    74.6031528,
                    56.1190918
                ],
                [
                    74.6027572,
                    56.1193858
                ],
                [
                    74.6024056,
                    56.1196471
                ],
                [
                    74.6023324,
                    56.1199003
                ],
                [
                    74.6024203,
                    56.1202106
                ],
                [
                    74.60264,
                    56.1204964
                ],
                [
                    74.6030942,
                    56.1207986
                ],
                [
                    74.6039438,
                    56.1211742
                ],
                [
                    74.6039585,
                    56.1207088
                ],
                [
                    74.6041343,
                    56.1206189
                ],
                [
                    74.6046616,
                    56.1206271
                ],
                [
                    74.6047056,
                    56.1209538
                ],
                [
                    74.6099794,
                    56.1212069
                ],
                [
                    74.6099794,
                    56.1211416
                ],
                [
                    74.6107412,
                    56.1212069
                ],
                [
                    74.6104921,
                    56.121607
                ],
                [
                    74.6101845,
                    56.1218112
                ],
                [
                    74.6102284,
                    56.1219385
                ],
                [
                    74.6101112,
                    56.1220446
                ],
                [
                    74.6102577,
                    56.122159
                ],
                [
                    74.610331,
                    56.1223223
                ],
                [
                    74.6102284,
                    56.1223362
                ],
                [
                    74.6102138,
                    56.1235652
                ],
                [
                    74.610331,
                    56.1239367
                ],
                [
                    74.6102651,
                    56.1241939
                ],
                [
                    74.6100453,
                    56.1248227
                ],
                [
                    74.6108657,
                    56.1249533
                ],
                [
                    74.6115029,
                    56.1250064
                ],
                [
                    74.6116494,
                    56.125088
                ],
                [
                    74.611752,
                    56.1254187
                ],
                [
                    74.6117227,
                    56.1256065
                ],
                [
                    74.6114883,
                    56.1259209
                ],
                [
                    74.6099794,
                    56.1256106
                ],
                [
                    74.6086316,
                    56.1277539
                ],
                [
                    74.6122061,
                    56.1287827
                ],
                [
                    74.6133922,
                    56.1270626
                ],
                [
                    74.6136633,
                    56.1266381
                ],
                [
                    74.613905,
                    56.1260502
                ],
                [
                    74.6143298,
                    56.1261196
                ],
                [
                    74.6154065,
                    56.1264952
                ],
                [
                    74.6169667,
                    56.1271361
                ],
                [
                    74.6178457,
                    56.1276015
                ],
                [
                    74.6204093,
                    56.1275403
                ],
                [
                    74.6202482,
                    56.1264584
                ],
                [
                    74.6204208,
                    56.1218824
                ],
                [
                    74.621118,
                    56.1183785
                ],
                [
                    74.6214105,
                    56.1141379
                ],
                [
                    74.6225298,
                    56.1118548
                ],
                [
                    74.6262382,
                    56.1068065
                ],
                [
                    74.6321473,
                    56.1032207
                ],
                [
                    74.6384944,
                    56.1007057
                ],
                [
                    74.6450817,
                    56.0994806
                ],
                [
                    74.652464,
                    56.0998053
                ],
                [
                    74.6524277,
                    56.0994702
                ],
                [
                    74.652003,
                    56.0975594
                ],
                [
                    74.6521687,
                    56.0975479
                ],
                [
                    74.6514138,
                    56.0935149
                ],
                [
                    74.6486744,
                    56.0930409
                ],
                [
                    74.6487183,
                    56.0927386
                ],
                [
                    74.6485425,
                    56.0922237
                ],
                [
                    74.6480298,
                    56.0923054
                ],
                [
                    74.6478101,
                    56.0923054
                ],
                [
                    74.6476782,
                    56.0922401
                ],
                [
                    74.6475024,
                    56.0922401
                ],
                [
                    74.647312,
                    56.0922973
                ],
                [
                    74.6461107,
                    56.092093
                ],
                [
                    74.6452025,
                    56.0918968
                ],
                [
                    74.6451219,
                    56.0918028
                ],
                [
                    74.6449461,
                    56.091905
                ],
                [
                    74.6448362,
                    56.0918274
                ],
                [
                    74.6454222,
                    56.0914514
                ],
                [
                    74.6456346,
                    56.091145
                ],
                [
                    74.6436203,
                    56.0904993
                ],
                [
                    74.6423605,
                    56.0896371
                ],
                [
                    74.642485,
                    56.0895717
                ],
                [
                    74.6423678,
                    56.0894328
                ],
                [
                    74.6421993,
                    56.0893347
                ],
                [
                    74.6420968,
                    56.0892325
                ],
                [
                    74.6419869,
                    56.0891794
                ],
                [
                    74.6417159,
                    56.0890854
                ],
                [
                    74.641606,
                    56.0890527
                ],
                [
                    74.641335,
                    56.0889138
                ],
                [
                    74.6412105,
                    56.0888198
                ],
                [
                    74.6410493,
                    56.0887503
                ],
                [
                    74.6406685,
                    56.0886196
                ],
                [
                    74.6404267,
                    56.0885705
                ],
                [
                    74.6400532,
                    56.0884806
                ],
                [
                    74.6390497,
                    56.0882886
                ],
                [
                    74.6388959,
                    56.0882232
                ],
                [
                    74.6386981,
                    56.0882027
                ],
                [
                    74.6385296,
                    56.0881741
                ],
                [
                    74.6383612,
                    56.0880965
                ],
                [
                    74.637951,
                    56.0879575
                ],
                [
                    74.6377532,
                    56.0878595
                ],
                [
                    74.6376946,
                    56.0877696
                ],
                [
                    74.6375701,
                    56.0876837
                ],
                [
                    74.6374749,
                    56.087651
                ],
                [
                    74.6372771,
                    56.0873854
                ],
                [
                    74.6375115,
                    56.0869645
                ],
                [
                    74.6378118,
                    56.0867806
                ],
                [
                    74.6380389,
                    56.0866416
                ],
                [
                    74.6381927,
                    56.0865558
                ],
                [
                    74.6383978,
                    56.0865558
                ],
                [
                    74.6384198,
                    56.0864291
                ],
                [
                    74.6382293,
                    56.0861757
                ],
                [
                    74.637929,
                    56.0858079
                ],
                [
                    74.6377239,
                    56.0854769
                ],
                [
                    74.6373284,
                    56.0850845
                ],
                [
                    74.6370647,
                    56.0848557
                ],
                [
                    74.6369914,
                    56.0848516
                ],
                [
                    74.6369402,
                    56.0847494
                ],
                [
                    74.6368303,
                    56.0847126
                ],
                [
                    74.636779,
                    56.0846432
                ],
                [
                    74.6365813,
                    56.0845001
                ],
                [
                    74.6365153,
                    56.0844184
                ],
                [
                    74.635651,
                    56.083744
                ],
                [
                    74.6354972,
                    56.0837808
                ],
                [
                    74.6353434,
                    56.0836378
                ],
                [
                    74.635358,
                    56.0835478
                ],
                [
                    74.6350357,
                    56.0833721
                ],
                [
                    74.6349771,
                    56.0833108
                ],
                [
                    74.6348966,
                    56.0832086
                ],
                [
                    74.6349185,
                    56.0831677
                ],
                [
                    74.634523,
                    56.0828081
                ],
                [
                    74.6342593,
                    56.0827835
                ],
                [
                    74.6341275,
                    56.0828081
                ],
                [
                    74.6338491,
                    56.0825833
                ],
                [
                    74.6339297,
                    56.0825015
                ],
                [
                    74.6336514,
                    56.0822686
                ],
                [
                    74.6335195,
                    56.0823176
                ],
                [
                    74.6334097,
                    56.08224
                ],
                [
                    74.6334756,
                    56.0821827
                ],
                [
                    74.6334097,
                    56.0821623
                ],
                [
                    74.6334536,
                    56.0821337
                ],
                [
                    74.6333437,
                    56.0820356
                ],
                [
                    74.633373,
                    56.0819988
                ],
                [
                    74.6332412,
                    56.0818762
                ],
                [
                    74.6331386,
                    56.0819089
                ],
                [
                    74.6327211,
                    56.081492
                ],
                [
                    74.6327871,
                    56.0814675
                ],
                [
                    74.6326552,
                    56.0813081
                ],
                [
                    74.632538,
                    56.0813121
                ],
                [
                    74.6323036,
                    56.0810506
                ],
                [
                    74.6322304,
                    56.0810587
                ],
                [
                    74.6319667,
                    56.0807849
                ],
                [
                    74.6292798,
                    56.0760159
                ],
                [
                    74.6291333,
                    56.0732565
                ],
                [
                    74.6283276,
                    56.0732647
                ],
                [
                    74.6280785,
                    56.0733137
                ],
                [
                    74.6273607,
                    56.0734772
                ],
                [
                    74.6266575,
                    56.0730766
                ],
                [
                    74.6266575,
                    56.0728068
                ],
                [
                    74.6243429,
                    56.0715231
                ],
                [
                    74.6221748,
                    56.0728068
                ],
                [
                    74.6252805,
                    56.0745156
                ],
                [
                    74.6258958,
                    56.0750389
                ],
                [
                    74.6264671,
                    56.0756684
                ],
                [
                    74.6268187,
                    56.0762898
                ],
                [
                    74.6265257,
                    56.0764615
                ],
                [
                    74.6261741,
                    56.076298
                ],
                [
                    74.6255295,
                    56.076069
                ],
                [
                    74.6249143,
                    56.0759791
                ],
                [
                    74.6244748,
                    56.0758565
                ],
                [
                    74.6242404,
                    56.0758892
                ],
                [
                    74.6238595,
                    56.0760036
                ],
                [
                    74.6227901,
                    56.0760936
                ],
                [
                    74.6223946,
                    56.0761017
                ],
                [
                    74.6219551,
                    56.076159
                ],
                [
                    74.6208857,
                    56.0758156
                ],
                [
                    74.6206952,
                    56.0758074
                ],
                [
                    74.6195965,
                    56.0762571
                ],
                [
                    74.6188054,
                    56.0765514
                ],
                [
                    74.6181462,
                    56.076764
                ],
                [
                    74.6177653,
                    56.0769765
                ],
                [
                    74.6168131,
                    56.0773853
                ],
                [
                    74.6167545,
                    56.077557
                ],
                [
                    74.6173259,
                    56.0780393
                ],
                [
                    74.6170458,
                    56.0780594
                ],
                [
                    74.616621,
                    56.0782393
                ],
                [
                    74.6162254,
                    56.0783865
                ],
                [
                    74.6152879,
                    56.0784682
                ],
                [
                    74.6148777,
                    56.0785908
                ],
                [
                    74.6143357,
                    56.0785745
                ],
                [
                    74.6139987,
                    56.0786317
                ],
                [
                    74.6138083,
                    56.0788361
                ],
                [
                    74.6137204,
                    56.078926
                ],
                [
                    74.6138229,
                    56.0804139
                ],
                [
                    74.614072,
                    56.0871657
                ],
                [
                    74.6142478,
                    56.0923963
                ],
                [
                    74.614365,
                    56.0966293
                ],
                [
                    74.598983,
                    56.0970297
                ],
                [
                    74.598983,
                    56.0972503
                ],
                [
                    74.5986754,
                    56.0975608
                ],
                [
                    74.5979283,
                    56.0986475
                ]
            ],
            "longitude": 74.639519,
            "latitude": 56.094585
        },
        "5893": {
            "name": "НОВОВАРШАВКА",
            "population": 5959,
            "type": "town",
            "poly": [
                [
                    74.6705529,
                    54.1840824
                ],
                [
                    74.6723832,
                    54.1845379
                ],
                [
                    74.6736256,
                    54.1849172
                ],
                [
                    74.6759576,
                    54.1837292
                ],
                [
                    74.6925282,
                    54.1796511
                ],
                [
                    74.6973568,
                    54.1790731
                ],
                [
                    74.6954912,
                    54.1780776
                ],
                [
                    74.6978506,
                    54.1787199
                ],
                [
                    74.7029809,
                    54.1748982
                ],
                [
                    74.706328,
                    54.1729231
                ],
                [
                    74.7079741,
                    54.1716865
                ],
                [
                    74.7087697,
                    54.1706266
                ],
                [
                    74.7089343,
                    54.1694703
                ],
                [
                    74.7093733,
                    54.1684264
                ],
                [
                    74.7100591,
                    54.1666597
                ],
                [
                    74.7171648,
                    54.1597528
                ],
                [
                    74.7187286,
                    54.1561704
                ],
                [
                    74.7220482,
                    54.1525877
                ],
                [
                    74.7163142,
                    54.1508042
                ],
                [
                    74.7102687,
                    54.1567404
                ],
                [
                    74.7081827,
                    54.1560244
                ],
                [
                    74.7065367,
                    54.1555103
                ],
                [
                    74.7050552,
                    54.1550926
                ],
                [
                    74.7034365,
                    54.1545303
                ],
                [
                    74.7012692,
                    54.1563617
                ],
                [
                    74.6987451,
                    54.1587393
                ],
                [
                    74.6962432,
                    54.1612085
                ],
                [
                    74.6914161,
                    54.1600906
                ],
                [
                    74.6898473,
                    54.1598913
                ],
                [
                    74.6888576,
                    54.1599395
                ],
                [
                    74.6879583,
                    54.1602721
                ],
                [
                    74.6805976,
                    54.1662213
                ],
                [
                    74.6783885,
                    54.1649236
                ],
                [
                    74.6763857,
                    54.1647469
                ],
                [
                    74.6728466,
                    54.1693404
                ],
                [
                    74.6736697,
                    54.1698222
                ],
                [
                    74.674383,
                    54.1699346
                ],
                [
                    74.6754529,
                    54.1703521
                ],
                [
                    74.6757547,
                    54.1705609
                ],
                [
                    74.67559,
                    54.1708339
                ],
                [
                    74.6768795,
                    54.1727932
                ],
                [
                    74.6774831,
                    54.1739975
                ],
                [
                    74.6764131,
                    54.1758121
                ],
                [
                    74.6787285,
                    54.1771142
                ],
                [
                    74.6796064,
                    54.1786075
                ],
                [
                    74.6786462,
                    54.1799562
                ],
                [
                    74.6771098,
                    54.1809517
                ],
                [
                    74.6765611,
                    54.1817705
                ],
                [
                    74.674915,
                    54.1821719
                ],
                [
                    74.6743663,
                    54.1815457
                ],
                [
                    74.6727751,
                    54.1807751
                ],
                [
                    74.6705529,
                    54.1840824
                ]
            ],
            "longitude": 74.696037,
            "latitude": 54.170616
        },
        "5894": {
            "name": "ЧЕРЛАК",
            "population": 10636,
            "type": "town",
            "poly": [
                [
                    74.7608524,
                    54.1768703
                ],
                [
                    74.766488,
                    54.1788727
                ],
                [
                    74.7729313,
                    54.1730799
                ],
                [
                    74.7812554,
                    54.1712973
                ],
                [
                    74.8028208,
                    54.1709873
                ],
                [
                    74.8124541,
                    54.1696165
                ],
                [
                    74.8196258,
                    54.1666021
                ],
                [
                    74.8241764,
                    54.1613594
                ],
                [
                    74.8281547,
                    54.1572458
                ],
                [
                    74.8314014,
                    54.1545187
                ],
                [
                    74.8408285,
                    54.1473174
                ],
                [
                    74.8257638,
                    54.1311895
                ],
                [
                    74.811836,
                    54.1399203
                ],
                [
                    74.7957759,
                    54.1480662
                ],
                [
                    74.7608524,
                    54.1768703
                ]
            ],
            "longitude": 74.7974987,
            "latitude": 54.154067
        },
        "5895": {
            "name": "НИЖНЯЯ ОМКА",
            "population": 4821,
            "type": "town",
            "poly": [
                [
                    74.912167,
                    55.424777
                ],
                [
                    74.9219517,
                    55.4330565
                ],
                [
                    74.9294147,
                    55.4385103
                ],
                [
                    74.945465,
                    55.447758
                ],
                [
                    74.957562,
                    55.4349276
                ],
                [
                    74.9432334,
                    55.4153753
                ],
                [
                    74.9269256,
                    55.4181035
                ],
                [
                    74.912167,
                    55.424777
                ]
            ],
            "longitude": 74.938004,
            "latitude": 55.43359
        },
        "5896": {
            "name": "ОКОНЕШНИКОВО",
            "population": 4886,
            "type": "town",
            "poly": [
                [
                    75.0511909,
                    54.8384087
                ],
                [
                    75.0526471,
                    54.8407666
                ],
                [
                    75.0548322,
                    54.8401515
                ],
                [
                    75.0560073,
                    54.8409249
                ],
                [
                    75.0578352,
                    54.8431697
                ],
                [
                    75.0583948,
                    54.8432126
                ],
                [
                    75.0584881,
                    54.843363
                ],
                [
                    75.0582269,
                    54.8434597
                ],
                [
                    75.0582456,
                    54.8435348
                ],
                [
                    75.0574995,
                    54.8437389
                ],
                [
                    75.0572197,
                    54.8436423
                ],
                [
                    75.0557275,
                    54.8441041
                ],
                [
                    75.05597,
                    54.84419
                ],
                [
                    75.0563244,
                    54.8444585
                ],
                [
                    75.0570145,
                    54.8443726
                ],
                [
                    75.0575368,
                    54.8441793
                ],
                [
                    75.0582083,
                    54.8451674
                ],
                [
                    75.0586559,
                    54.8450707
                ],
                [
                    75.0601482,
                    54.8473797
                ],
                [
                    75.062946,
                    54.8467998
                ],
                [
                    75.0631885,
                    54.8470898
                ],
                [
                    75.0640466,
                    54.8468428
                ],
                [
                    75.0638973,
                    54.846585
                ],
                [
                    75.0666579,
                    54.8459728
                ],
                [
                    75.0672548,
                    54.8456506
                ],
                [
                    75.0679683,
                    54.8460143
                ],
                [
                    75.0690576,
                    54.8472
                ],
                [
                    75.0753398,
                    54.8503873
                ],
                [
                    75.0769364,
                    54.8517962
                ],
                [
                    75.0793389,
                    54.8513495
                ],
                [
                    75.0822039,
                    54.851736
                ],
                [
                    75.0848153,
                    54.8536173
                ],
                [
                    75.0876207,
                    54.8537376
                ],
                [
                    75.0916645,
                    54.8521054
                ],
                [
                    75.0833977,
                    54.8458081
                ],
                [
                    75.0808311,
                    54.8437718
                ],
                [
                    75.0847407,
                    54.8418643
                ],
                [
                    75.0868746,
                    54.8420791
                ],
                [
                    75.0888293,
                    54.8406441
                ],
                [
                    75.0941938,
                    54.8402977
                ],
                [
                    75.1015057,
                    54.8381172
                ],
                [
                    75.1121377,
                    54.8362266
                ],
                [
                    75.1099952,
                    54.8317866
                ],
                [
                    75.1096561,
                    54.8289787
                ],
                [
                    75.1096328,
                    54.8282452
                ],
                [
                    75.102401,
                    54.8282335
                ],
                [
                    75.1003533,
                    54.827485
                ],
                [
                    75.0857069,
                    54.8265036
                ],
                [
                    75.0815544,
                    54.8249017
                ],
                [
                    75.0811114,
                    54.8251435
                ],
                [
                    75.0808316,
                    54.824942
                ],
                [
                    75.0803419,
                    54.8251972
                ],
                [
                    75.0799689,
                    54.8249957
                ],
                [
                    75.0781269,
                    54.8258957
                ],
                [
                    75.0773342,
                    54.825345
                ],
                [
                    75.077171,
                    54.8254524
                ],
                [
                    75.0769845,
                    54.8253315
                ],
                [
                    75.0771244,
                    54.8252778
                ],
                [
                    75.0770311,
                    54.8252106
                ],
                [
                    75.0767979,
                    54.8252912
                ],
                [
                    75.0764482,
                    54.8250092
                ],
                [
                    75.0760285,
                    54.8251704
                ],
                [
                    75.0759586,
                    54.8251301
                ],
                [
                    75.0751658,
                    54.8255196
                ],
                [
                    75.0745596,
                    54.8258957
                ],
                [
                    75.0729508,
                    54.831429
                ],
                [
                    75.0735104,
                    54.8331614
                ],
                [
                    75.0720182,
                    54.8331076
                ],
                [
                    75.071855,
                    54.8330002
                ],
                [
                    75.0716685,
                    54.8333628
                ],
                [
                    75.0711322,
                    54.8332822
                ],
                [
                    75.0699198,
                    54.8333359
                ],
                [
                    75.0700364,
                    54.8344908
                ],
                [
                    75.0703628,
                    54.8344908
                ],
                [
                    75.0703628,
                    54.8346519
                ],
                [
                    75.0705726,
                    54.8346519
                ],
                [
                    75.070596,
                    54.8355651
                ],
                [
                    75.065723,
                    54.8356859
                ],
                [
                    75.0656996,
                    54.8352562
                ],
                [
                    75.0648136,
                    54.8353099
                ],
                [
                    75.0644406,
                    54.8352294
                ],
                [
                    75.0644406,
                    54.8348534
                ],
                [
                    75.0640909,
                    54.8347997
                ],
                [
                    75.0640442,
                    54.8344908
                ],
                [
                    75.0638344,
                    54.8342894
                ],
                [
                    75.0632282,
                    54.8343834
                ],
                [
                    75.0623888,
                    54.8343028
                ],
                [
                    75.0622722,
                    54.8344102
                ],
                [
                    75.0610831,
                    54.8343028
                ],
                [
                    75.0601971,
                    54.8345042
                ],
                [
                    75.0591246,
                    54.8342894
                ],
                [
                    75.0581453,
                    54.8340208
                ],
                [
                    75.0578889,
                    54.8338731
                ],
                [
                    75.0569562,
                    54.8336179
                ],
                [
                    75.0565832,
                    54.8336314
                ],
                [
                    75.0544148,
                    54.8330808
                ],
                [
                    75.0530858,
                    54.8344639
                ],
                [
                    75.0511909,
                    54.8384087
                ]
            ],
            "longitude": 75.082306,
            "latitude": 54.839363
        },
        "5897": {
            "name": "МУРОМЦЕВО",
            "population": 10456,
            "type": "town",
            "poly": [
                [
                    75.1963684,
                    56.3744225
                ],
                [
                    75.1989451,
                    56.3746918
                ],
                [
                    75.2015542,
                    56.3751135
                ],
                [
                    75.2058001,
                    56.3810359
                ],
                [
                    75.2058649,
                    56.3816909
                ],
                [
                    75.2051357,
                    56.3820588
                ],
                [
                    75.1999498,
                    56.3832251
                ],
                [
                    75.2034665,
                    56.3854053
                ],
                [
                    75.204293,
                    56.3852797
                ],
                [
                    75.2046495,
                    56.3856655
                ],
                [
                    75.2080203,
                    56.384221
                ],
                [
                    75.2088792,
                    56.3853963
                ],
                [
                    75.2095112,
                    56.3859884
                ],
                [
                    75.2115236,
                    56.3888504
                ],
                [
                    75.2121921,
                    56.3890073
                ],
                [
                    75.2136303,
                    56.3889064
                ],
                [
                    75.2153117,
                    56.3889401
                ],
                [
                    75.2173779,
                    56.3890858
                ],
                [
                    75.2195657,
                    56.3890522
                ],
                [
                    75.2231917,
                    56.3880766
                ],
                [
                    75.2254605,
                    56.3872468
                ],
                [
                    75.2269595,
                    56.3868543
                ],
                [
                    75.2288231,
                    56.3867197
                ],
                [
                    75.2304032,
                    56.386731
                ],
                [
                    75.2315782,
                    56.3872804
                ],
                [
                    75.2329354,
                    56.3881888
                ],
                [
                    75.2341711,
                    56.3885364
                ],
                [
                    75.2356904,
                    56.3885364
                ],
                [
                    75.2371894,
                    56.388413
                ],
                [
                    75.2384251,
                    56.387886
                ],
                [
                    75.2391341,
                    56.3867085
                ],
                [
                    75.2403698,
                    56.3853292
                ],
                [
                    75.2421727,
                    56.3845105
                ],
                [
                    75.2445427,
                    56.3839273
                ],
                [
                    75.2465077,
                    56.3829516
                ],
                [
                    75.2491209,
                    56.3815834
                ],
                [
                    75.2512681,
                    56.3808656
                ],
                [
                    75.2525443,
                    56.3809665
                ],
                [
                    75.253861,
                    56.3813254
                ],
                [
                    75.2549347,
                    56.3819983
                ],
                [
                    75.2564742,
                    56.383389
                ],
                [
                    75.2582163,
                    56.3838713
                ],
                [
                    75.2596343,
                    56.3839834
                ],
                [
                    75.2618423,
                    56.3838601
                ],
                [
                    75.2631591,
                    56.3832432
                ],
                [
                    75.2641718,
                    56.3813254
                ],
                [
                    75.2667041,
                    56.3754143
                ],
                [
                    75.2671239,
                    56.3754916
                ],
                [
                    75.267757,
                    56.3741175
                ],
                [
                    75.2677063,
                    56.3732621
                ],
                [
                    75.2673771,
                    56.3728414
                ],
                [
                    75.2665669,
                    56.3726311
                ],
                [
                    75.2636802,
                    56.3727994
                ],
                [
                    75.2621609,
                    56.3730097
                ],
                [
                    75.2612494,
                    56.3728414
                ],
                [
                    75.2602871,
                    56.3723787
                ],
                [
                    75.2597806,
                    56.3720702
                ],
                [
                    75.2591223,
                    56.3719019
                ],
                [
                    75.2570966,
                    56.3707941
                ],
                [
                    75.2563876,
                    56.3693636
                ],
                [
                    75.257122,
                    56.3668673
                ],
                [
                    75.2580842,
                    56.3662923
                ],
                [
                    75.2594009,
                    56.3662502
                ],
                [
                    75.2598567,
                    56.3663904
                ],
                [
                    75.2613,
                    56.3671618
                ],
                [
                    75.2638068,
                    56.3688167
                ],
                [
                    75.2665415,
                    56.3695179
                ],
                [
                    75.2687445,
                    56.3698124
                ],
                [
                    75.2697826,
                    56.3698404
                ],
                [
                    75.2710994,
                    56.3697984
                ],
                [
                    75.27234,
                    56.3694057
                ],
                [
                    75.2728466,
                    56.3690551
                ],
                [
                    75.2738594,
                    56.3677368
                ],
                [
                    75.2738594,
                    56.3671758
                ],
                [
                    75.2731757,
                    56.3666008
                ],
                [
                    75.2723908,
                    56.3663343
                ],
                [
                    75.2706436,
                    56.3662642
                ],
                [
                    75.2697826,
                    56.3661099
                ],
                [
                    75.269099,
                    56.3658855
                ],
                [
                    75.2677063,
                    56.3649318
                ],
                [
                    75.267605,
                    56.3646092
                ],
                [
                    75.2675291,
                    56.3637536
                ],
                [
                    75.268466,
                    56.3626035
                ],
                [
                    75.2710487,
                    56.3617058
                ],
                [
                    75.2720616,
                    56.3615375
                ],
                [
                    75.2718844,
                    56.3611728
                ],
                [
                    75.2716565,
                    56.3611587
                ],
                [
                    75.2710994,
                    56.3606678
                ],
                [
                    75.2703904,
                    56.3603031
                ],
                [
                    75.2696561,
                    56.3601488
                ],
                [
                    75.2692509,
                    56.3598823
                ],
                [
                    75.2685672,
                    56.359742
                ],
                [
                    75.2678582,
                    56.3593913
                ],
                [
                    75.2674025,
                    56.3590687
                ],
                [
                    75.2665922,
                    56.3589284
                ],
                [
                    75.2657818,
                    56.3586478
                ],
                [
                    75.2654021,
                    56.3586058
                ],
                [
                    75.2650222,
                    56.3585076
                ],
                [
                    75.2645918,
                    56.3581569
                ],
                [
                    75.2641107,
                    56.3581288
                ],
                [
                    75.2638321,
                    56.3578202
                ],
                [
                    75.263351,
                    56.3576518
                ],
                [
                    75.2624648,
                    56.357217
                ],
                [
                    75.261781,
                    56.3570907
                ],
                [
                    75.2613,
                    56.3568663
                ],
                [
                    75.2604391,
                    56.3566418
                ],
                [
                    75.2587678,
                    56.3556037
                ],
                [
                    75.257755,
                    56.3553371
                ],
                [
                    75.2576031,
                    56.3551688
                ],
                [
                    75.2578056,
                    56.3549162
                ],
                [
                    75.258388,
                    56.3546497
                ],
                [
                    75.2587678,
                    56.354341
                ],
                [
                    75.2587678,
                    56.3539622
                ],
                [
                    75.258464,
                    56.3536255
                ],
                [
                    75.2580082,
                    56.3534291
                ],
                [
                    75.2572739,
                    56.3540184
                ],
                [
                    75.2557546,
                    56.3554634
                ],
                [
                    75.2542606,
                    56.3572871
                ],
                [
                    75.2529186,
                    56.3570206
                ],
                [
                    75.2522096,
                    56.3565296
                ],
                [
                    75.251298,
                    56.3564594
                ],
                [
                    75.2505637,
                    56.3569925
                ],
                [
                    75.2492723,
                    56.3577921
                ],
                [
                    75.2477024,
                    56.3574835
                ],
                [
                    75.2471453,
                    56.3575116
                ],
                [
                    75.2468161,
                    56.3579605
                ],
                [
                    75.2440055,
                    56.3579184
                ],
                [
                    75.2412707,
                    56.3577641
                ],
                [
                    75.2409669,
                    56.3586058
                ],
                [
                    75.2418025,
                    56.3586759
                ],
                [
                    75.2432458,
                    56.358704
                ],
                [
                    75.2483861,
                    56.3591528
                ],
                [
                    75.2488672,
                    56.3598121
                ],
                [
                    75.2482847,
                    56.3599805
                ],
                [
                    75.2348897,
                    56.3640903
                ],
                [
                    75.2335983,
                    56.3644269
                ],
                [
                    75.2327627,
                    56.364511
                ],
                [
                    75.2317752,
                    56.3645391
                ],
                [
                    75.2292684,
                    56.3642305
                ],
                [
                    75.2271413,
                    56.3640201
                ],
                [
                    75.2270907,
                    56.3635292
                ],
                [
                    75.2273438,
                    56.3627297
                ],
                [
                    75.2266603,
                    56.3626877
                ],
                [
                    75.2267616,
                    56.3624212
                ],
                [
                    75.2262045,
                    56.3616076
                ],
                [
                    75.2261032,
                    56.3596859
                ],
                [
                    75.2290405,
                    56.3578202
                ],
                [
                    75.2294203,
                    56.3561227
                ],
                [
                    75.229395,
                    56.3556738
                ],
                [
                    75.2289392,
                    56.3549583
                ],
                [
                    75.2285087,
                    56.3548601
                ],
                [
                    75.2250903,
                    56.3547058
                ],
                [
                    75.2232925,
                    56.3545374
                ],
                [
                    75.2221277,
                    56.3594474
                ],
                [
                    75.2204565,
                    56.3631084
                ],
                [
                    75.2197982,
                    56.3630664
                ],
                [
                    75.2193424,
                    56.3632627
                ],
                [
                    75.2121511,
                    56.3625614
                ],
                [
                    75.2110116,
                    56.362351
                ],
                [
                    75.2099481,
                    56.3620424
                ],
                [
                    75.2091377,
                    56.3615655
                ],
                [
                    75.2087327,
                    56.3611307
                ],
                [
                    75.2084287,
                    56.3610746
                ],
                [
                    75.2053396,
                    56.3622248
                ],
                [
                    75.1971101,
                    56.3604574
                ],
                [
                    75.1970976,
                    56.3637688
                ],
                [
                    75.1966925,
                    56.3671977
                ],
                [
                    75.1968545,
                    56.3688941
                ],
                [
                    75.1963684,
                    56.3744225
                ]
            ],
            "longitude": 75.237198,
            "latitude": 56.369392
        },
        "5898": {
            "name": "СЕДЕЛЬНИКОВО",
            "population": 5316,
            "type": "town",
            "poly": [
                [
                    75.2744957,
                    56.9421629
                ],
                [
                    75.2754828,
                    56.9432529
                ],
                [
                    75.276831,
                    56.944054
                ],
                [
                    75.2776496,
                    56.9447237
                ],
                [
                    75.2778663,
                    56.9450257
                ],
                [
                    75.2800331,
                    56.9460632
                ],
                [
                    75.2805627,
                    56.9459844
                ],
                [
                    75.2801535,
                    56.9470743
                ],
                [
                    75.2796479,
                    56.9483348
                ],
                [
                    75.2790459,
                    56.9488207
                ],
                [
                    75.2789497,
                    56.9491621
                ],
                [
                    75.279383,
                    56.949661
                ],
                [
                    75.2798164,
                    56.9499893
                ],
                [
                    75.2796719,
                    56.9502781
                ],
                [
                    75.2794793,
                    56.9505801
                ],
                [
                    75.2794071,
                    56.9510265
                ],
                [
                    75.2799368,
                    56.9513154
                ],
                [
                    75.2802016,
                    56.951578
                ],
                [
                    75.2799849,
                    56.9517881
                ],
                [
                    75.2775532,
                    56.9525758
                ],
                [
                    75.278107,
                    56.9536918
                ],
                [
                    75.2791904,
                    56.9547158
                ],
                [
                    75.2786608,
                    56.9547946
                ],
                [
                    75.27777,
                    56.9553066
                ],
                [
                    75.2776255,
                    56.9556611
                ],
                [
                    75.277457,
                    56.9558974
                ],
                [
                    75.2765903,
                    56.955753
                ],
                [
                    75.2758197,
                    56.9557792
                ],
                [
                    75.2753624,
                    56.9559105
                ],
                [
                    75.2752179,
                    56.9560155
                ],
                [
                    75.2750735,
                    56.9569607
                ],
                [
                    75.2750013,
                    56.9577878
                ],
                [
                    75.2747364,
                    56.9578272
                ],
                [
                    75.2747124,
                    56.958221
                ],
                [
                    75.2749531,
                    56.958221
                ],
                [
                    75.2750735,
                    56.9587723
                ],
                [
                    75.2748087,
                    56.9588905
                ],
                [
                    75.2746882,
                    56.9600456
                ],
                [
                    75.2751457,
                    56.9601113
                ],
                [
                    75.2753142,
                    56.9610957
                ],
                [
                    75.2756272,
                    56.961122
                ],
                [
                    75.2755791,
                    56.9617127
                ],
                [
                    75.2763976,
                    56.9617258
                ],
                [
                    75.2763976,
                    56.9616077
                ],
                [
                    75.2768792,
                    56.9616208
                ],
                [
                    75.2770718,
                    56.9617914
                ],
                [
                    75.2775292,
                    56.9619489
                ],
                [
                    75.2783719,
                    56.9621458
                ],
                [
                    75.2795756,
                    56.9622377
                ],
                [
                    75.2811406,
                    56.9621983
                ],
                [
                    75.2820313,
                    56.9621327
                ],
                [
                    75.2825583,
                    56.962091
                ],
                [
                    75.2823272,
                    56.9617865
                ],
                [
                    75.2822309,
                    56.961461
                ],
                [
                    75.2822694,
                    56.961188
                ],
                [
                    75.282539,
                    56.9608729
                ],
                [
                    75.2829821,
                    56.9605264
                ],
                [
                    75.2833865,
                    56.9603689
                ],
                [
                    75.2841762,
                    56.9602534
                ],
                [
                    75.2848889,
                    56.9601483
                ],
                [
                    75.2852741,
                    56.9600118
                ],
                [
                    75.2853511,
                    56.9598333
                ],
                [
                    75.2852355,
                    56.9595708
                ],
                [
                    75.2849081,
                    56.9593607
                ],
                [
                    75.2841569,
                    56.9590667
                ],
                [
                    75.283714,
                    56.9588147
                ],
                [
                    75.2831939,
                    56.9583211
                ],
                [
                    75.2828858,
                    56.9576805
                ],
                [
                    75.2827509,
                    56.9570293
                ],
                [
                    75.282905,
                    56.9565462
                ],
                [
                    75.2834251,
                    56.9560001
                ],
                [
                    75.2844073,
                    56.955538
                ],
                [
                    75.2855244,
                    56.9551494
                ],
                [
                    75.2862756,
                    56.9549183
                ],
                [
                    75.2869112,
                    56.9547293
                ],
                [
                    75.2879513,
                    56.9546033
                ],
                [
                    75.2890299,
                    56.9545297
                ],
                [
                    75.2899929,
                    56.9543827
                ],
                [
                    75.2907441,
                    56.9541831
                ],
                [
                    75.2913796,
                    56.9540676
                ],
                [
                    75.2918226,
                    56.9541306
                ],
                [
                    75.2923234,
                    56.9543302
                ],
                [
                    75.2945191,
                    56.953784
                ],
                [
                    75.2946154,
                    56.953637
                ],
                [
                    75.2959251,
                    56.9528177
                ],
                [
                    75.2964259,
                    56.9525446
                ],
                [
                    75.2968304,
                    56.952135
                ],
                [
                    75.297909,
                    56.9512842
                ],
                [
                    75.2986601,
                    56.9509061
                ],
                [
                    75.299238,
                    56.95078
                ],
                [
                    75.3000084,
                    56.950717
                ],
                [
                    75.3009136,
                    56.9507065
                ],
                [
                    75.3018959,
                    56.9508851
                ],
                [
                    75.3031478,
                    56.9511477
                ],
                [
                    75.3039183,
                    56.9514523
                ],
                [
                    75.3060947,
                    56.9525552
                ],
                [
                    75.3069614,
                    56.9529228
                ],
                [
                    75.3076163,
                    56.9530698
                ],
                [
                    75.3082326,
                    56.9530488
                ],
                [
                    75.310255,
                    56.9529543
                ],
                [
                    75.3107943,
                    56.9530278
                ],
                [
                    75.3113913,
                    56.9532379
                ],
                [
                    75.3118921,
                    56.9534899
                ],
                [
                    75.3120077,
                    56.953679
                ],
                [
                    75.3120077,
                    56.9542357
                ],
                [
                    75.3117766,
                    56.9544352
                ],
                [
                    75.3114298,
                    56.9545402
                ],
                [
                    75.3111024,
                    56.9547503
                ],
                [
                    75.3107943,
                    56.9552859
                ],
                [
                    75.310698,
                    56.9556535
                ],
                [
                    75.3108135,
                    56.9558426
                ],
                [
                    75.311218,
                    56.9559896
                ],
                [
                    75.3116995,
                    56.9560001
                ],
                [
                    75.312104,
                    56.9558216
                ],
                [
                    75.3127588,
                    56.955622
                ],
                [
                    75.3139145,
                    56.9555905
                ],
                [
                    75.3143575,
                    56.955664
                ],
                [
                    75.3151086,
                    56.9558846
                ],
                [
                    75.3156671,
                    56.9561471
                ],
                [
                    75.3159946,
                    56.9563992
                ],
                [
                    75.3161102,
                    56.9566618
                ],
                [
                    75.3161294,
                    56.9570923
                ],
                [
                    75.315956,
                    56.9572709
                ],
                [
                    75.3200393,
                    56.957628
                ],
                [
                    75.3210216,
                    56.9556325
                ],
                [
                    75.3219654,
                    56.9550654
                ],
                [
                    75.3225625,
                    56.9545192
                ],
                [
                    75.3229091,
                    56.9543827
                ],
                [
                    75.3238144,
                    56.9543827
                ],
                [
                    75.3241611,
                    56.9542252
                ],
                [
                    75.3244306,
                    56.9539731
                ],
                [
                    75.3253167,
                    56.9541096
                ],
                [
                    75.3260485,
                    56.9532904
                ],
                [
                    75.3262797,
                    56.9533744
                ],
                [
                    75.3265109,
                    56.9531854
                ],
                [
                    75.3263568,
                    56.9530908
                ],
                [
                    75.3270887,
                    56.9526287
                ],
                [
                    75.3277628,
                    56.9524396
                ],
                [
                    75.3285332,
                    56.9523346
                ],
                [
                    75.3294962,
                    56.9523871
                ],
                [
                    75.3305556,
                    56.9525972
                ],
                [
                    75.3320193,
                    56.9530068
                ],
                [
                    75.3326935,
                    56.9531538
                ],
                [
                    75.3332135,
                    56.9537735
                ],
                [
                    75.3336565,
                    56.9539836
                ],
                [
                    75.3337143,
                    56.9542042
                ],
                [
                    75.3347736,
                    56.9550549
                ],
                [
                    75.3350625,
                    56.9551179
                ],
                [
                    75.3355055,
                    56.955475
                ],
                [
                    75.3358715,
                    56.9556115
                ],
                [
                    75.3360256,
                    56.9559056
                ],
                [
                    75.3365649,
                    56.9561997
                ],
                [
                    75.3369501,
                    56.9563572
                ],
                [
                    75.3373353,
                    56.9564202
                ],
                [
                    75.3383367,
                    56.9564832
                ],
                [
                    75.3388954,
                    56.9568088
                ],
                [
                    75.3389146,
                    56.9571029
                ],
                [
                    75.3387027,
                    56.9574704
                ],
                [
                    75.3390912,
                    56.9572501
                ],
                [
                    75.3395149,
                    56.9572396
                ],
                [
                    75.3403817,
                    56.9572607
                ],
                [
                    75.3407476,
                    56.9570821
                ],
                [
                    75.3411521,
                    56.956767
                ],
                [
                    75.3416143,
                    56.956683
                ],
                [
                    75.3419996,
                    56.9564835
                ],
                [
                    75.3425196,
                    56.9561159
                ],
                [
                    75.3430589,
                    56.9560004
                ],
                [
                    75.3436367,
                    56.9558743
                ],
                [
                    75.3437907,
                    56.9557378
                ],
                [
                    75.3435982,
                    56.9554437
                ],
                [
                    75.3435019,
                    56.954677
                ],
                [
                    75.3435404,
                    56.9541099
                ],
                [
                    75.3436752,
                    56.9537948
                ],
                [
                    75.3436367,
                    56.9534902
                ],
                [
                    75.3436945,
                    56.9533327
                ],
                [
                    75.3437523,
                    56.9530176
                ],
                [
                    75.3439256,
                    56.9527865
                ],
                [
                    75.3428513,
                    56.9528089
                ],
                [
                    75.3428031,
                    56.952415
                ],
                [
                    75.3424901,
                    56.9523493
                ],
                [
                    75.342442,
                    56.9519817
                ],
                [
                    75.3422253,
                    56.951811
                ],
                [
                    75.3416474,
                    56.9515353
                ],
                [
                    75.3411178,
                    56.951404
                ],
                [
                    75.3403955,
                    56.9513384
                ],
                [
                    75.3403955,
                    56.9506031
                ],
                [
                    75.3395288,
                    56.9506162
                ],
                [
                    75.3393362,
                    56.9510233
                ],
                [
                    75.3387824,
                    56.9511546
                ],
                [
                    75.338614,
                    56.9516797
                ],
                [
                    75.3374824,
                    56.9516929
                ],
                [
                    75.3378676,
                    56.9494083
                ],
                [
                    75.3369768,
                    56.9493426
                ],
                [
                    75.3371213,
                    56.94908
                ],
                [
                    75.3369768,
                    56.9489356
                ],
                [
                    75.3359656,
                    56.9485154
                ],
                [
                    75.3354841,
                    56.9484497
                ],
                [
                    75.3345451,
                    56.9484235
                ],
                [
                    75.3338711,
                    56.9483578
                ],
                [
                    75.3334377,
                    56.9484103
                ],
                [
                    75.3329803,
                    56.9485022
                ],
                [
                    75.3322339,
                    56.9483709
                ],
                [
                    75.3317043,
                    56.9482659
                ],
                [
                    75.3313913,
                    56.9483841
                ],
                [
                    75.3311024,
                    56.9485548
                ],
                [
                    75.3307171,
                    56.9487517
                ],
                [
                    75.3292245,
                    56.9456003
                ],
                [
                    75.3289837,
                    56.9454689
                ],
                [
                    75.3288633,
                    56.9452851
                ],
                [
                    75.3261428,
                    56.9421071
                ],
                [
                    75.3325469,
                    56.9394804
                ],
                [
                    75.3284781,
                    56.9364857
                ],
                [
                    75.3259742,
                    56.9353824
                ],
                [
                    75.3147068,
                    56.9309161
                ],
                [
                    75.3056544,
                    56.932637
                ],
                [
                    75.3008152,
                    56.9324005
                ],
                [
                    75.2986965,
                    56.9324137
                ],
                [
                    75.2984317,
                    56.9310606
                ],
                [
                    75.297252,
                    56.9311263
                ],
                [
                    75.2972279,
                    56.9314416
                ],
                [
                    75.2962888,
                    56.9316124
                ],
                [
                    75.2964334,
                    56.932151
                ],
                [
                    75.2960963,
                    56.9322429
                ],
                [
                    75.2965056,
                    56.9327684
                ],
                [
                    75.2955667,
                    56.9330968
                ],
                [
                    75.2956871,
                    56.9332675
                ],
                [
                    75.2950129,
                    56.9334777
                ],
                [
                    75.2946036,
                    56.9332544
                ],
                [
                    75.2919794,
                    56.9342002
                ],
                [
                    75.2921961,
                    56.9348438
                ],
                [
                    75.2929906,
                    56.935251
                ],
                [
                    75.293761,
                    56.9353561
                ],
                [
                    75.2939536,
                    56.9354875
                ],
                [
                    75.2938092,
                    56.9356582
                ],
                [
                    75.2930869,
                    56.9361311
                ],
                [
                    75.2912571,
                    56.9366959
                ],
                [
                    75.2899811,
                    56.9357239
                ],
                [
                    75.2888496,
                    56.9350146
                ],
                [
                    75.2883199,
                    56.9345417
                ],
                [
                    75.2873087,
                    56.9339637
                ],
                [
                    75.2864179,
                    56.9335697
                ],
                [
                    75.2862011,
                    56.9331493
                ],
                [
                    75.285479,
                    56.933793
                ],
                [
                    75.2849252,
                    56.9346862
                ],
                [
                    75.2836011,
                    56.9365908
                ],
                [
                    75.2830233,
                    56.9373264
                ],
                [
                    75.2828066,
                    56.9386792
                ],
                [
                    75.2840056,
                    56.9389977
                ],
                [
                    75.2850649,
                    56.9396675
                ],
                [
                    75.2852334,
                    56.9399959
                ],
                [
                    75.2850408,
                    56.9406
                ],
                [
                    75.2852334,
                    56.9408758
                ],
                [
                    75.2856186,
                    56.9413224
                ],
                [
                    75.2855705,
                    56.9415719
                ],
                [
                    75.2842945,
                    56.9417164
                ],
                [
                    75.2815739,
                    56.9419396
                ],
                [
                    75.2808757,
                    56.9420709
                ],
                [
                    75.2799608,
                    56.9412173
                ],
                [
                    75.2763495,
                    56.9421629
                ],
                [
                    75.2744957,
                    56.9421629
                ]
            ],
            "longitude": 75.306061,
            "latitude": 56.945618
        },
        "5899": {
            "name": "СТРЕЖЕВОЙ",
            "population": 41743,
            "type": "town",
            "poly": [
                [
                    77.5369147,
                    60.7285036
                ],
                [
                    77.5509186,
                    60.7376705
                ],
                [
                    77.5660499,
                    60.7461969
                ],
                [
                    77.563923,
                    60.7501325
                ],
                [
                    77.5656438,
                    60.7568874
                ],
                [
                    77.5729424,
                    60.7574962
                ],
                [
                    77.5839701,
                    60.7561125
                ],
                [
                    77.5905567,
                    60.7528657
                ],
                [
                    77.5913874,
                    60.7511841
                ],
                [
                    77.6134613,
                    60.7385407
                ],
                [
                    77.6196325,
                    60.7363073
                ],
                [
                    77.6241185,
                    60.7363421
                ],
                [
                    77.6279281,
                    60.7350217
                ],
                [
                    77.6277002,
                    60.7336664
                ],
                [
                    77.6434256,
                    60.7273789
                ],
                [
                    77.6394813,
                    60.7252088
                ],
                [
                    77.6296616,
                    60.7289621
                ],
                [
                    77.6108537,
                    60.7210591
                ],
                [
                    77.6062494,
                    60.722299
                ],
                [
                    77.6017189,
                    60.7232594
                ],
                [
                    77.5969746,
                    60.7237729
                ],
                [
                    77.5939222,
                    60.7238982
                ],
                [
                    77.5893527,
                    60.7235964
                ],
                [
                    77.5846872,
                    60.7225504
                ],
                [
                    77.5791221,
                    60.7206468
                ],
                [
                    77.5700468,
                    60.7178829
                ],
                [
                    77.5620431,
                    60.7153117
                ],
                [
                    77.5541488,
                    60.7117924
                ],
                [
                    77.5514756,
                    60.7092504
                ],
                [
                    77.5499699,
                    60.7073691
                ],
                [
                    77.5481779,
                    60.7038436
                ],
                [
                    77.5470953,
                    60.704002
                ],
                [
                    77.5450918,
                    60.7050615
                ],
                [
                    77.5442829,
                    60.7065471
                ],
                [
                    77.5449201,
                    60.7083239
                ],
                [
                    77.5466291,
                    60.7083425
                ],
                [
                    77.5479962,
                    60.7117425
                ],
                [
                    77.5454518,
                    60.7151421
                ],
                [
                    77.5369147,
                    60.7285036
                ]
            ],
            "longitude": 77.600807,
            "latitude": 60.732758
        },
        "5900": {
            "name": "АЛЕКСАНДРОВСКОЕ",
            "population": 8067,
            "type": "town",
            "poly": [
                [
                    77.8356099,
                    60.4288793
                ],
                [
                    77.8369918,
                    60.4330871
                ],
                [
                    77.8456685,
                    60.4328576
                ],
                [
                    77.848247,
                    60.438936
                ],
                [
                    77.8454089,
                    60.4423022
                ],
                [
                    77.8458512,
                    60.444225
                ],
                [
                    77.8544964,
                    60.4426525
                ],
                [
                    77.8644988,
                    60.4423911
                ],
                [
                    77.8666262,
                    60.4385753
                ],
                [
                    77.8686747,
                    60.4366743
                ],
                [
                    77.8710734,
                    60.4345341
                ],
                [
                    77.8728889,
                    60.4325421
                ],
                [
                    77.8731739,
                    60.4309641
                ],
                [
                    77.877152,
                    60.4265071
                ],
                [
                    77.8797269,
                    60.4248974
                ],
                [
                    77.8886533,
                    60.4165932
                ],
                [
                    77.8950289,
                    60.4117763
                ],
                [
                    77.8952267,
                    60.410556
                ],
                [
                    77.8888197,
                    60.4087088
                ],
                [
                    77.883543,
                    60.4133304
                ],
                [
                    77.8807781,
                    60.4126326
                ],
                [
                    77.8793107,
                    60.410518
                ],
                [
                    77.8752637,
                    60.4112537
                ],
                [
                    77.8697706,
                    60.414983
                ],
                [
                    77.8637624,
                    60.4126946
                ],
                [
                    77.8560377,
                    60.416
                ],
                [
                    77.8556943,
                    60.4187966
                ],
                [
                    77.8520894,
                    60.4207456
                ],
                [
                    77.8536344,
                    60.4227792
                ],
                [
                    77.8356099,
                    60.4288793
                ]
            ],
            "longitude": 77.865845,
            "latitude": 60.431446
        },
        "5901": {
            "name": "КЕДРОВЫЙ",
            "population": 2129,
            "type": "town",
            "poly": [
                [
                    79.5456895,
                    57.5653802
                ],
                [
                    79.5814761,
                    57.5721571
                ],
                [
                    79.5962367,
                    57.5555827
                ],
                [
                    79.5566272,
                    57.5482328
                ],
                [
                    79.5456895,
                    57.5653802
                ]
            ],
            "longitude": 79.570801,
            "latitude": 57.56192
        },
        "5902": {
            "name": "КАРГАСОК",
            "population": 8547,
            "type": "town",
            "poly": [
                [
                    80.8368411,
                    59.0634063
                ],
                [
                    80.8402743,
                    59.0662301
                ],
                [
                    80.8401027,
                    59.0717007
                ],
                [
                    80.8447374,
                    59.0715243
                ],
                [
                    80.8464542,
                    59.0686126
                ],
                [
                    80.8522906,
                    59.0657007
                ],
                [
                    80.8565822,
                    59.063671
                ],
                [
                    80.8634486,
                    59.062259
                ],
                [
                    80.8694568,
                    59.061553
                ],
                [
                    80.8742633,
                    59.0610235
                ],
                [
                    80.8811297,
                    59.0601409
                ],
                [
                    80.8871379,
                    59.0598761
                ],
                [
                    80.8876529,
                    59.0572283
                ],
                [
                    80.8821597,
                    59.0557277
                ],
                [
                    80.8792415,
                    59.0505195
                ],
                [
                    80.8782115,
                    59.0477826
                ],
                [
                    80.8807944,
                    59.0438661
                ],
                [
                    80.8854226,
                    59.0432249
                ],
                [
                    80.8843688,
                    59.0380232
                ],
                [
                    80.8867382,
                    59.0351187
                ],
                [
                    80.8970877,
                    59.0322832
                ],
                [
                    80.8917446,
                    59.0252898
                ],
                [
                    80.8695234,
                    59.0332888
                ],
                [
                    80.8513193,
                    59.0378914
                ],
                [
                    80.8492203,
                    59.0386172
                ],
                [
                    80.8690742,
                    59.043184
                ],
                [
                    80.8680835,
                    59.045487
                ],
                [
                    80.8629336,
                    59.0455753
                ],
                [
                    80.8619037,
                    59.0429264
                ],
                [
                    80.8465138,
                    59.0425934
                ],
                [
                    80.8421562,
                    59.0443282
                ],
                [
                    80.8494057,
                    59.0474238
                ],
                [
                    80.8444747,
                    59.0497531
                ],
                [
                    80.840446,
                    59.0523734
                ],
                [
                    80.8376994,
                    59.0579344
                ],
                [
                    80.8368411,
                    59.0634063
                ]
            ],
            "longitude": 80.867546,
            "latitude": 59.057003
        },
        "5903": {
            "name": "ПАРАБЕЛЬ",
            "population": 6209,
            "type": "town",
            "poly": null,
            "longitude": 81.501793,
            "latitude": 58.713741
        },
        "5904": {
            "name": "БАКЧАР",
            "population": 7200,
            "type": "town",
            "poly": [
                [
                    82.0534075,
                    57.0078624
                ],
                [
                    82.0540513,
                    57.0147882
                ],
                [
                    82.0543946,
                    57.02061
                ],
                [
                    82.0561112,
                    57.0250669
                ],
                [
                    82.0547379,
                    57.034194
                ],
                [
                    82.0822036,
                    57.0373977
                ],
                [
                    82.1034897,
                    57.0190449
                ],
                [
                    82.0852936,
                    57.0091663
                ],
                [
                    82.0653808,
                    57.0068949
                ],
                [
                    82.0534075,
                    57.0078624
                ]
            ],
            "longitude": 82.066872,
            "latitude": 57.020538
        },
        "5905": {
            "name": "ПОДГОРНОЕ",
            "population": 5009,
            "type": "town",
            "poly": [
                [
                    82.6300325,
                    57.8002341
                ],
                [
                    82.6357974,
                    57.8012117
                ],
                [
                    82.6399047,
                    57.7988528
                ],
                [
                    82.6435731,
                    57.7945326
                ],
                [
                    82.6498297,
                    57.7939913
                ],
                [
                    82.6700902,
                    57.800075
                ],
                [
                    82.6666025,
                    57.7899146
                ],
                [
                    82.6668003,
                    57.786624
                ],
                [
                    82.6792921,
                    57.7812556
                ],
                [
                    82.6758505,
                    57.7783332
                ],
                [
                    82.6636136,
                    57.7794886
                ],
                [
                    82.6497603,
                    57.775633
                ],
                [
                    82.6397772,
                    57.7789449
                ],
                [
                    82.642454,
                    57.787847
                ],
                [
                    82.6353123,
                    57.7949589
                ],
                [
                    82.6300325,
                    57.8002341
                ]
            ],
            "longitude": 82.641541,
            "latitude": 57.793751
        },
        "5906": {
            "name": "КОЛПАШЕВО",
            "population": 23085,
            "type": "town",
            "poly": [
                [
                    82.8377092,
                    58.320611
                ],
                [
                    82.8698658,
                    58.3263878
                ],
                [
                    82.8714172,
                    58.3322378
                ],
                [
                    82.8759304,
                    58.3339407
                ],
                [
                    82.8835464,
                    58.3420102
                ],
                [
                    82.9134464,
                    58.3470434
                ],
                [
                    82.9384101,
                    58.3453411
                ],
                [
                    82.9774775,
                    58.330979
                ],
                [
                    83.001595,
                    58.3351254
                ],
                [
                    83.0155577,
                    58.3242401
                ],
                [
                    83.0099162,
                    58.3132775
                ],
                [
                    82.9630917,
                    58.3123885
                ],
                [
                    82.9425002,
                    58.3117217
                ],
                [
                    82.923319,
                    58.3079431
                ],
                [
                    82.9000478,
                    58.3011257
                ],
                [
                    82.8784691,
                    58.3065352
                ],
                [
                    82.8463125,
                    58.3088322
                ],
                [
                    82.8377092,
                    58.320611
                ]
            ],
            "longitude": 82.903557,
            "latitude": 58.313667
        },
        "5907": {
            "name": "МОЛЧАНОВО",
            "population": 6091,
            "type": "town",
            "poly": [
                [
                    83.7337271,
                    57.574407
                ],
                [
                    83.7392966,
                    57.5854454
                ],
                [
                    83.7376247,
                    57.5885333
                ],
                [
                    83.7461668,
                    57.5922326
                ],
                [
                    83.7535674,
                    57.5925684
                ],
                [
                    83.7703542,
                    57.590993
                ],
                [
                    83.7864115,
                    57.5869817
                ],
                [
                    83.8001938,
                    57.576169
                ],
                [
                    83.7876577,
                    57.5726619
                ],
                [
                    83.7851541,
                    57.5743681
                ],
                [
                    83.7785901,
                    57.5752829
                ],
                [
                    83.7598749,
                    57.5717037
                ],
                [
                    83.7459969,
                    57.5688336
                ],
                [
                    83.7337271,
                    57.574407
                ]
            ],
            "longitude": 83.7605958,
            "latitude": 57.5812043
        },
        "5908": {
            "name": "КРИВОШЕИНО",
            "population": 5993,
            "type": "town",
            "poly": [
                [
                    83.897523,
                    57.3476199
                ],
                [
                    83.898038,
                    57.3499353
                ],
                [
                    83.9011279,
                    57.3536396
                ],
                [
                    83.9085093,
                    57.360399
                ],
                [
                    83.9131442,
                    57.3591953
                ],
                [
                    83.9153758,
                    57.355862
                ],
                [
                    83.9215556,
                    57.3532692
                ],
                [
                    83.9253321,
                    57.3521579
                ],
                [
                    83.9325419,
                    57.353547
                ],
                [
                    83.9337435,
                    57.3527135
                ],
                [
                    83.9339152,
                    57.3520653
                ],
                [
                    83.9371768,
                    57.3484534
                ],
                [
                    83.9382067,
                    57.3458601
                ],
                [
                    83.9404383,
                    57.3444707
                ],
                [
                    83.9455882,
                    57.342155
                ],
                [
                    83.9466181,
                    57.3405802
                ],
                [
                    83.9404383,
                    57.3379863
                ],
                [
                    83.9313403,
                    57.336226
                ],
                [
                    83.9256754,
                    57.332242
                ],
                [
                    83.9200106,
                    57.3304815
                ],
                [
                    83.9140025,
                    57.3301108
                ],
                [
                    83.9042178,
                    57.3356702
                ],
                [
                    83.9105692,
                    57.3382642
                ],
                [
                    83.9121142,
                    57.3387274
                ],
                [
                    83.907136,
                    57.342155
                ],
                [
                    83.8999262,
                    57.3467863
                ],
                [
                    83.897523,
                    57.3476199
                ]
            ],
            "longitude": 83.930153,
            "latitude": 57.343742
        },
        "5909": {
            "name": "КОЖЕВНИКОВО",
            "population": 8048,
            "type": "town",
            "poly": [
                [
                    83.9392498,
                    56.2533703
                ],
                [
                    83.9439699,
                    56.2687604
                ],
                [
                    83.9571692,
                    56.27672
                ],
                [
                    83.9596454,
                    56.2772237
                ],
                [
                    83.9714459,
                    56.2786795
                ],
                [
                    83.9809738,
                    56.2726617
                ],
                [
                    83.9825185,
                    56.262207
                ],
                [
                    83.9920027,
                    56.2466929
                ],
                [
                    83.9900359,
                    56.2443615
                ],
                [
                    83.9850971,
                    56.243803
                ],
                [
                    83.9805517,
                    56.2455758
                ],
                [
                    83.9736899,
                    56.2445558
                ],
                [
                    83.9721165,
                    56.2422244
                ],
                [
                    83.964031,
                    56.2380712
                ],
                [
                    83.9600974,
                    56.2385084
                ],
                [
                    83.9596167,
                    56.24033
                ],
                [
                    83.9538038,
                    56.2413743
                ],
                [
                    83.9541972,
                    56.2477856
                ],
                [
                    83.9507881,
                    56.2469357
                ],
                [
                    83.9491273,
                    56.2472999
                ],
                [
                    83.9484717,
                    56.2526662
                ],
                [
                    83.9392498,
                    56.2533703
                ]
            ],
            "longitude": 83.976387,
            "latitude": 56.260132
        },
        "5910": {
            "name": "МЕЛЬНИКОВО",
            "population": 8216,
            "type": "town",
            "poly": [
                [
                    84.0574924,
                    56.5544314
                ],
                [
                    84.0577229,
                    56.5551099
                ],
                [
                    84.0617704,
                    56.5551522
                ],
                [
                    84.0617094,
                    56.5569211
                ],
                [
                    84.0644718,
                    56.5569659
                ],
                [
                    84.0639568,
                    56.5578995
                ],
                [
                    84.0615265,
                    56.5585169
                ],
                [
                    84.0648467,
                    56.5687072
                ],
                [
                    84.0718396,
                    56.5680951
                ],
                [
                    84.0780149,
                    56.5688294
                ],
                [
                    84.0823065,
                    56.5691131
                ],
                [
                    84.0847097,
                    56.5688294
                ],
                [
                    84.0893446,
                    56.5656137
                ],
                [
                    84.0917477,
                    56.56533
                ],
                [
                    84.0922628,
                    56.5673162
                ],
                [
                    84.0938077,
                    56.5688294
                ],
                [
                    84.097756,
                    56.5708154
                ],
                [
                    84.0991293,
                    56.5704371
                ],
                [
                    84.0996443,
                    56.5689239
                ],
                [
                    84.0968977,
                    56.567127
                ],
                [
                    84.0955244,
                    56.5654245
                ],
                [
                    84.0953527,
                    56.563722
                ],
                [
                    84.098271,
                    56.5614519
                ],
                [
                    84.0991293,
                    56.5602221
                ],
                [
                    84.0984426,
                    56.5579518
                ],
                [
                    84.0963827,
                    56.5556813
                ],
                [
                    84.0946661,
                    56.5532214
                ],
                [
                    84.0931211,
                    56.5507614
                ],
                [
                    84.0896879,
                    56.5443267
                ],
                [
                    84.0874563,
                    56.5426232
                ],
                [
                    84.0833363,
                    56.54215
                ],
                [
                    84.0821348,
                    56.5438535
                ],
                [
                    84.0766416,
                    56.5446106
                ],
                [
                    84.0701185,
                    56.5442321
                ],
                [
                    84.0697752,
                    56.5484904
                ],
                [
                    84.0665135,
                    56.5485851
                ],
                [
                    84.065827,
                    56.5478281
                ],
                [
                    84.0611921,
                    56.5492474
                ],
                [
                    84.0595547,
                    56.55173
                ],
                [
                    84.0574924,
                    56.5544314
                ]
            ],
            "longitude": 84.090408,
            "latitude": 56.554417
        },
        "5911": {
            "name": "САМУСЬ",
            "population": 5799,
            "type": "town",
            "poly": [
                [
                    84.6918509,
                    56.7608595
                ],
                [
                    84.6940406,
                    56.7621771
                ],
                [
                    84.6958975,
                    56.7621167
                ],
                [
                    84.6995353,
                    56.7624288
                ],
                [
                    84.7008929,
                    56.76246
                ],
                [
                    84.7019277,
                    56.7616091
                ],
                [
                    84.7029283,
                    56.7615874
                ],
                [
                    84.703345,
                    56.7616039
                ],
                [
                    84.7031531,
                    56.7611212
                ],
                [
                    84.7032155,
                    56.7608444
                ],
                [
                    84.701977,
                    56.760858
                ],
                [
                    84.701873,
                    56.7604919
                ],
                [
                    84.701111,
                    56.7603941
                ],
                [
                    84.7004045,
                    56.7601732
                ],
                [
                    84.6965492,
                    56.7603815
                ],
                [
                    84.6964871,
                    56.7592853
                ],
                [
                    84.698077,
                    56.7586413
                ],
                [
                    84.7016963,
                    56.7585434
                ],
                [
                    84.7057068,
                    56.7577194
                ],
                [
                    84.7052417,
                    56.7564377
                ],
                [
                    84.7024274,
                    56.7520427
                ],
                [
                    84.7029291,
                    56.7516919
                ],
                [
                    84.7063096,
                    56.7491319
                ],
                [
                    84.7087718,
                    56.7489276
                ],
                [
                    84.71334,
                    56.7480687
                ],
                [
                    84.7189795,
                    56.7501338
                ],
                [
                    84.7209075,
                    56.7464803
                ],
                [
                    84.7210233,
                    56.744886
                ],
                [
                    84.7216178,
                    56.7432329
                ],
                [
                    84.7201085,
                    56.7416885
                ],
                [
                    84.7178769,
                    56.7407471
                ],
                [
                    84.717362,
                    56.7389583
                ],
                [
                    84.7166753,
                    56.736887
                ],
                [
                    84.7144437,
                    56.7355688
                ],
                [
                    84.7115255,
                    56.7348156
                ],
                [
                    84.7060323,
                    56.7346273
                ],
                [
                    84.7034574,
                    56.7345331
                ],
                [
                    84.7008825,
                    56.7354747
                ],
                [
                    84.6977926,
                    56.7374519
                ],
                [
                    84.6957326,
                    56.7388642
                ],
                [
                    84.6935456,
                    56.7391339
                ],
                [
                    84.6932522,
                    56.7406683
                ],
                [
                    84.6938444,
                    56.7430065
                ],
                [
                    84.6937612,
                    56.7443667
                ],
                [
                    84.6935296,
                    56.7454413
                ],
                [
                    84.6938384,
                    56.7460468
                ],
                [
                    84.694016,
                    56.7466318
                ],
                [
                    84.6934506,
                    56.7481845
                ],
                [
                    84.6928999,
                    56.748631
                ],
                [
                    84.6922341,
                    56.7509173
                ],
                [
                    84.6926478,
                    56.7533807
                ],
                [
                    84.6926457,
                    56.7567029
                ],
                [
                    84.6924885,
                    56.7592028
                ],
                [
                    84.6918509,
                    56.7608595
                ]
            ],
            "longitude": 84.69873,
            "latitude": 56.743713
        },
        "5912": {
            "name": "ЗОНАЛЬНАЯ СТАНЦИЯ",
            "population": 5831,
            "type": "town",
            "poly": [
                [
                    85.0044456,
                    56.4325187
                ],
                [
                    85.0052937,
                    56.4340757
                ],
                [
                    85.0104436,
                    56.4456531
                ],
                [
                    85.0112639,
                    56.446425
                ],
                [
                    85.0232956,
                    56.4406697
                ],
                [
                    85.0403727,
                    56.4324582
                ],
                [
                    85.0412345,
                    56.4184407
                ],
                [
                    85.03663,
                    56.4183937
                ],
                [
                    85.0337118,
                    56.4182751
                ],
                [
                    85.0314219,
                    56.4178966
                ],
                [
                    85.0116435,
                    56.4277031
                ],
                [
                    85.0087481,
                    56.4293931
                ],
                [
                    85.0075465,
                    56.4305321
                ],
                [
                    85.0068599,
                    56.4312915
                ],
                [
                    85.006573,
                    56.4317973
                ],
                [
                    85.0057772,
                    56.4321104
                ],
                [
                    85.0044456,
                    56.4325187
                ]
            ],
            "longitude": 85.022102,
            "latitude": 56.426922
        },
        "5913": {
            "name": "БЕЛЫЙ ЯР",
            "population": 8126,
            "type": "town",
            "poly": [
                [
                    84.9809392,
                    58.4479079
                ],
                [
                    84.9936421,
                    58.457967
                ],
                [
                    85.0046285,
                    58.4596732
                ],
                [
                    85.0097782,
                    58.4571588
                ],
                [
                    85.0193914,
                    58.4551831
                ],
                [
                    85.0224813,
                    58.4555423
                ],
                [
                    85.0284894,
                    58.4513211
                ],
                [
                    85.0356992,
                    58.4499738
                ],
                [
                    85.0441106,
                    58.4505128
                ],
                [
                    85.0449689,
                    58.4470995
                ],
                [
                    85.0499471,
                    58.4464706
                ],
                [
                    85.0552686,
                    58.4470096
                ],
                [
                    85.0700315,
                    58.4434163
                ],
                [
                    85.0731214,
                    58.44135
                ],
                [
                    85.0837644,
                    58.4454825
                ],
                [
                    85.0980122,
                    58.4426976
                ],
                [
                    85.085996,
                    58.4373966
                ],
                [
                    85.0714048,
                    58.4310165
                ],
                [
                    85.0731214,
                    58.4234667
                ],
                [
                    85.0729497,
                    58.4212194
                ],
                [
                    85.0695165,
                    58.4187022
                ],
                [
                    85.06265,
                    58.4151959
                ],
                [
                    85.0473722,
                    58.4100707
                ],
                [
                    85.0501187,
                    58.4088117
                ],
                [
                    85.0570024,
                    58.4061183
                ],
                [
                    85.0505221,
                    58.4035597
                ],
                [
                    85.0440248,
                    58.406532
                ],
                [
                    85.0378879,
                    58.4057676
                ],
                [
                    85.030721,
                    58.4017968
                ],
                [
                    85.0236829,
                    58.4046749
                ],
                [
                    85.0245412,
                    58.4071031
                ],
                [
                    85.0388406,
                    58.4142294
                ],
                [
                    85.0653966,
                    58.4204103
                ],
                [
                    85.069156,
                    58.42268
                ],
                [
                    85.0674565,
                    58.4307469
                ],
                [
                    85.0133832,
                    58.4348807
                ],
                [
                    85.0128682,
                    58.4415297
                ],
                [
                    85.0063451,
                    58.4443147
                ],
                [
                    84.9939854,
                    58.444135
                ],
                [
                    84.9845012,
                    58.4425538
                ],
                [
                    84.9809392,
                    58.4479079
                ]
            ],
            "longitude": 85.036476,
            "latitude": 58.444763
        },
        "5914": {
            "name": "СВЕТЛЫЙ",
            "population": 7534,
            "type": "town",
            "poly": [
                [
                    85.0972982,
                    56.5777927
                ],
                [
                    85.0977429,
                    56.5782643
                ],
                [
                    85.0994917,
                    56.5790944
                ],
                [
                    85.0994708,
                    56.5807149
                ],
                [
                    85.0985588,
                    56.5812408
                ],
                [
                    85.1010586,
                    56.5824787
                ],
                [
                    85.1016595,
                    56.5825289
                ],
                [
                    85.1039921,
                    56.5816472
                ],
                [
                    85.1039071,
                    56.5807326
                ],
                [
                    85.1063587,
                    56.5806469
                ],
                [
                    85.1068254,
                    56.5810103
                ],
                [
                    85.1071894,
                    56.5809972
                ],
                [
                    85.1084025,
                    56.5806321
                ],
                [
                    85.1108295,
                    56.5792567
                ],
                [
                    85.1111054,
                    56.5791003
                ],
                [
                    85.1081442,
                    56.5775375
                ],
                [
                    85.109775,
                    56.5764708
                ],
                [
                    85.1081389,
                    56.5752918
                ],
                [
                    85.1060736,
                    56.576453
                ],
                [
                    85.10138,
                    56.5739591
                ],
                [
                    85.0991913,
                    56.5747865
                ],
                [
                    85.0990142,
                    56.5749844
                ],
                [
                    85.0984086,
                    56.5772461
                ],
                [
                    85.0972982,
                    56.5777927
                ]
            ],
            "longitude": 85.103523,
            "latitude": 56.578079
        },
        "5915": {
            "name": "АСИНО",
            "population": 24615,
            "type": "town",
            "poly": [
                [
                    86.0831247,
                    57.0122678
                ],
                [
                    86.0875712,
                    57.0202942
                ],
                [
                    86.1697135,
                    57.0157079
                ],
                [
                    86.1714003,
                    57.0137244
                ],
                [
                    86.1733861,
                    57.0069217
                ],
                [
                    86.1779368,
                    57.0026863
                ],
                [
                    86.1825702,
                    57.0010191
                ],
                [
                    86.1885275,
                    57.0000277
                ],
                [
                    86.1957258,
                    56.9998024
                ],
                [
                    86.1980607,
                    56.9999115
                ],
                [
                    86.1984984,
                    56.9881783
                ],
                [
                    86.1512256,
                    56.9659869
                ],
                [
                    86.1268871,
                    56.9672626
                ],
                [
                    86.1137818,
                    56.9870308
                ],
                [
                    86.1081652,
                    56.9906007
                ],
                [
                    86.1053569,
                    57.004877
                ],
                [
                    86.0831247,
                    57.0122678
                ]
            ],
            "longitude": 86.14167,
            "latitude": 56.999187
        },
        "5916": {
            "name": "ПЕРВОМАЙСКОЕ",
            "population": 5800,
            "type": "town",
            "poly": [
                [
                    86.2237824,
                    57.0706927
                ],
                [
                    86.226529,
                    57.0727456
                ],
                [
                    86.226529,
                    57.0742385
                ],
                [
                    86.2258424,
                    57.0800231
                ],
                [
                    86.2292755,
                    57.0822621
                ],
                [
                    86.2323655,
                    57.0831949
                ],
                [
                    86.2340821,
                    57.084874
                ],
                [
                    86.2361421,
                    57.0878588
                ],
                [
                    86.2344254,
                    57.0925222
                ],
                [
                    86.239232,
                    57.0915896
                ],
                [
                    86.2385453,
                    57.0893512
                ],
                [
                    86.2416352,
                    57.088605
                ],
                [
                    86.2430085,
                    57.0900973
                ],
                [
                    86.248845,
                    57.088605
                ],
                [
                    86.2529649,
                    57.0858068
                ],
                [
                    86.2570846,
                    57.0820755
                ],
                [
                    86.2660111,
                    57.080956
                ],
                [
                    86.2708177,
                    57.072559
                ],
                [
                    86.2625779,
                    57.0703194
                ],
                [
                    86.2591446,
                    57.0712526
                ],
                [
                    86.2546815,
                    57.0721857
                ],
                [
                    86.2502183,
                    57.0723724
                ],
                [
                    86.2454118,
                    57.0712526
                ],
                [
                    86.2406052,
                    57.0695729
                ],
                [
                    86.2368287,
                    57.0680798
                ],
                [
                    86.2327088,
                    57.0660266
                ],
                [
                    86.2261857,
                    57.0645334
                ],
                [
                    86.2237824,
                    57.0706927
                ]
            ],
            "longitude": 86.226082,
            "latitude": 57.070614
        },
        "5917": {
            "name": "ЗЫРЯНСКОЕ",
            "population": 5567,
            "type": "town",
            "poly": null,
            "longitude": 86.621178,
            "latitude": 56.834206
        },
        "5918": {
            "name": "ТЕГУЛЬДЕТ",
            "population": 4821,
            "type": "town",
            "poly": null,
            "longitude": 88.167168,
            "latitude": 57.306404
        },
        "5919": {
            "name": "УСТЬ-ТАРКА",
            "population": 3819,
            "type": "town",
            "poly": [
                [
                    75.6669285,
                    55.5711244
                ],
                [
                    75.6768463,
                    55.5743704
                ],
                [
                    75.6711579,
                    55.5771054
                ],
                [
                    75.6789839,
                    55.5788825
                ],
                [
                    75.6852338,
                    55.5813813
                ],
                [
                    75.6921228,
                    55.5835303
                ],
                [
                    75.7137107,
                    55.5835303
                ],
                [
                    75.7154849,
                    55.5834972
                ],
                [
                    75.7207683,
                    55.5825246
                ],
                [
                    75.7200566,
                    55.5764567
                ],
                [
                    75.7235558,
                    55.5722992
                ],
                [
                    75.7263018,
                    55.570121
                ],
                [
                    75.7282189,
                    55.5676691
                ],
                [
                    75.7277565,
                    55.5674004
                ],
                [
                    75.7262538,
                    55.5669032
                ],
                [
                    75.7242076,
                    55.5662072
                ],
                [
                    75.720403,
                    55.5650049
                ],
                [
                    75.7133691,
                    55.562302
                ],
                [
                    75.7114348,
                    55.5615697
                ],
                [
                    75.7106355,
                    55.5611991
                ],
                [
                    75.7106515,
                    55.560955
                ],
                [
                    75.7122501,
                    55.5600148
                ],
                [
                    75.713513,
                    55.5605572
                ],
                [
                    75.7138487,
                    55.5598972
                ],
                [
                    75.7144882,
                    55.5602136
                ],
                [
                    75.7148878,
                    55.5603854
                ],
                [
                    75.7152555,
                    55.5603493
                ],
                [
                    75.7156391,
                    55.56006
                ],
                [
                    75.7156391,
                    55.5596893
                ],
                [
                    75.7164065,
                    55.559174
                ],
                [
                    75.7166782,
                    55.5592463
                ],
                [
                    75.7168701,
                    55.5595446
                ],
                [
                    75.7174136,
                    55.5594904
                ],
                [
                    75.7179767,
                    55.558715
                ],
                [
                    75.7173655,
                    55.5584868
                ],
                [
                    75.7166152,
                    55.5581147
                ],
                [
                    75.7159486,
                    55.5581815
                ],
                [
                    75.7153833,
                    55.5581431
                ],
                [
                    75.7150217,
                    55.5579385
                ],
                [
                    75.7149991,
                    55.5570819
                ],
                [
                    75.7178025,
                    55.5553045
                ],
                [
                    75.7174181,
                    55.5550232
                ],
                [
                    75.7196789,
                    55.5538212
                ],
                [
                    75.7198558,
                    55.5525287
                ],
                [
                    75.7172825,
                    55.5518774
                ],
                [
                    75.7169896,
                    55.5519828
                ],
                [
                    75.7163782,
                    55.5519413
                ],
                [
                    75.7159034,
                    55.5523506
                ],
                [
                    75.7146344,
                    55.5531887
                ],
                [
                    75.7125575,
                    55.553949
                ],
                [
                    75.7119366,
                    55.5538006
                ],
                [
                    75.7109553,
                    55.5546351
                ],
                [
                    75.7096438,
                    55.5551926
                ],
                [
                    75.7075838,
                    55.5556625
                ],
                [
                    75.7054135,
                    55.5558415
                ],
                [
                    75.7034693,
                    55.556174
                ],
                [
                    75.7021743,
                    55.5566425
                ],
                [
                    75.700932,
                    55.5568865
                ],
                [
                    75.6997331,
                    55.5574109
                ],
                [
                    75.698758,
                    55.5580348
                ],
                [
                    75.6982259,
                    55.5587329
                ],
                [
                    75.6958645,
                    55.5604035
                ],
                [
                    75.6932595,
                    55.5619785
                ],
                [
                    75.6916602,
                    55.5626907
                ],
                [
                    75.6906211,
                    55.5630162
                ],
                [
                    75.6894452,
                    55.56315
                ],
                [
                    75.687168,
                    55.5631156
                ],
                [
                    75.6848795,
                    55.562944
                ],
                [
                    75.6837951,
                    55.5625913
                ],
                [
                    75.6822125,
                    55.5616149
                ],
                [
                    75.6808864,
                    55.5614289
                ],
                [
                    75.6797915,
                    55.5618313
                ],
                [
                    75.6794311,
                    55.5636474
                ],
                [
                    75.676525,
                    55.5662633
                ],
                [
                    75.6751627,
                    55.5672196
                ],
                [
                    75.6732038,
                    55.5680406
                ],
                [
                    75.6718536,
                    55.5684308
                ],
                [
                    75.6702523,
                    55.5687451
                ],
                [
                    75.6683719,
                    55.5696058
                ],
                [
                    75.6669285,
                    55.5711244
                ]
            ],
            "longitude": 75.706017,
            "latitude": 55.563934
        },
        "5920": {
            "name": "ТАТАРСК",
            "population": 24073,
            "type": "town",
            "poly": [
                [
                    75.8905973,
                    55.2012728
                ],
                [
                    75.9026581,
                    55.2111776
                ],
                [
                    75.9290615,
                    55.2190346
                ],
                [
                    75.9276761,
                    55.2226604
                ],
                [
                    75.9216457,
                    55.2217307
                ],
                [
                    75.9205863,
                    55.2263788
                ],
                [
                    75.9233571,
                    55.2313051
                ],
                [
                    75.9258018,
                    55.2348368
                ],
                [
                    75.9383516,
                    55.238043
                ],
                [
                    75.9478862,
                    55.2386005
                ],
                [
                    75.9498102,
                    55.2336746
                ],
                [
                    75.970215,
                    55.2392046
                ],
                [
                    75.9782012,
                    55.2402267
                ],
                [
                    75.9784457,
                    55.2415741
                ],
                [
                    75.9825203,
                    55.242271
                ],
                [
                    75.9916474,
                    55.2414812
                ],
                [
                    76.0060715,
                    55.2440829
                ],
                [
                    76.0302746,
                    55.250447
                ],
                [
                    76.0696353,
                    55.2281913
                ],
                [
                    76.035811,
                    55.2235291
                ],
                [
                    76.0367124,
                    55.2156874
                ],
                [
                    76.0222069,
                    55.2043887
                ],
                [
                    75.9903435,
                    55.2031796
                ],
                [
                    75.9658959,
                    55.2002497
                ],
                [
                    75.9077921,
                    55.1908539
                ],
                [
                    75.8905973,
                    55.2012728
                ]
            ],
            "longitude": 75.962196,
            "latitude": 55.216961
        },
        "5921": {
            "name": "ЧИСТООЗЁРНОЕ",
            "population": 5768,
            "type": "town",
            "poly": [
                [
                    76.535167,
                    54.7072899
                ],
                [
                    76.535167,
                    54.7076616
                ],
                [
                    76.5363061,
                    54.7083817
                ],
                [
                    76.539402,
                    54.7090785
                ],
                [
                    76.5471619,
                    54.7105961
                ],
                [
                    76.5469742,
                    54.7100386
                ],
                [
                    76.5476175,
                    54.7099535
                ],
                [
                    76.5483279,
                    54.7107277
                ],
                [
                    76.5487927,
                    54.7112943
                ],
                [
                    76.5565065,
                    54.7138704
                ],
                [
                    76.5547616,
                    54.7160929
                ],
                [
                    76.5580978,
                    54.7166987
                ],
                [
                    76.5607162,
                    54.7171039
                ],
                [
                    76.5636938,
                    54.7175926
                ],
                [
                    76.5645633,
                    54.717741
                ],
                [
                    76.5654501,
                    54.717886
                ],
                [
                    76.5660052,
                    54.7179947
                ],
                [
                    76.5668231,
                    54.7183583
                ],
                [
                    76.5673223,
                    54.718511
                ],
                [
                    76.5678048,
                    54.7186473
                ],
                [
                    76.5675295,
                    54.7189034
                ],
                [
                    76.5664399,
                    54.7196204
                ],
                [
                    76.5650705,
                    54.7205762
                ],
                [
                    76.5658107,
                    54.7209854
                ],
                [
                    76.5666054,
                    54.7213524
                ],
                [
                    76.5677605,
                    54.7218097
                ],
                [
                    76.5690257,
                    54.7221775
                ],
                [
                    76.5699649,
                    54.7223954
                ],
                [
                    76.5709265,
                    54.7225931
                ],
                [
                    76.5741174,
                    54.7239847
                ],
                [
                    76.5775541,
                    54.7253174
                ],
                [
                    76.5808261,
                    54.7254686
                ],
                [
                    76.5858323,
                    54.7274715
                ],
                [
                    76.5911657,
                    54.722294
                ],
                [
                    76.5930183,
                    54.7207726
                ],
                [
                    76.5904334,
                    54.7199193
                ],
                [
                    76.5974923,
                    54.7139721
                ],
                [
                    76.6060477,
                    54.7072963
                ],
                [
                    76.607924,
                    54.7005399
                ],
                [
                    76.6073935,
                    54.6988932
                ],
                [
                    76.6052755,
                    54.6966014
                ],
                [
                    76.6042365,
                    54.6957964
                ],
                [
                    76.6026688,
                    54.6948685
                ],
                [
                    76.6011131,
                    54.6956451
                ],
                [
                    76.5994255,
                    54.6966682
                ],
                [
                    76.5957558,
                    54.6994498
                ],
                [
                    76.595782,
                    54.6994658
                ],
                [
                    76.5880315,
                    54.697376
                ],
                [
                    76.5814869,
                    54.6958669
                ],
                [
                    76.5793334,
                    54.6953646
                ],
                [
                    76.5758021,
                    54.6941102
                ],
                [
                    76.5647867,
                    54.70366
                ],
                [
                    76.56044,
                    54.7076534
                ],
                [
                    76.5528383,
                    54.7059647
                ],
                [
                    76.5518713,
                    54.7073294
                ],
                [
                    76.5442268,
                    54.7058806
                ],
                [
                    76.5437309,
                    54.706835
                ],
                [
                    76.5365453,
                    54.7054284
                ],
                [
                    76.5357835,
                    54.7063065
                ],
                [
                    76.535167,
                    54.7072899
                ]
            ],
            "longitude": 76.582344,
            "latitude": 54.712204
        },
        "5922": {
            "name": "КЫШТОВКА",
            "population": 5282,
            "type": "town",
            "poly": [
                [
                    76.5668129,
                    56.5800683
                ],
                [
                    76.6021851,
                    56.5873078
                ],
                [
                    76.684166,
                    56.5935704
                ],
                [
                    76.6878865,
                    56.5836979
                ],
                [
                    76.6905085,
                    56.5730226
                ],
                [
                    76.6694897,
                    56.5615126
                ],
                [
                    76.6805624,
                    56.5559064
                ],
                [
                    76.6804932,
                    56.5519396
                ],
                [
                    76.6796628,
                    56.5484683
                ],
                [
                    76.6765486,
                    56.5467898
                ],
                [
                    76.6689361,
                    56.5483539
                ],
                [
                    76.6645762,
                    56.5530076
                ],
                [
                    76.6575865,
                    56.5568217
                ],
                [
                    76.6544031,
                    56.5594151
                ],
                [
                    76.6519118,
                    56.5595677
                ],
                [
                    76.648936,
                    56.5559445
                ],
                [
                    76.6427076,
                    56.5586905
                ],
                [
                    76.6362023,
                    56.5504901
                ],
                [
                    76.6381401,
                    56.5384341
                ],
                [
                    76.6363408,
                    56.5328245
                ],
                [
                    76.6245068,
                    56.5318323
                ],
                [
                    76.6100052,
                    56.5305125
                ],
                [
                    76.6070077,
                    56.5303079
                ],
                [
                    76.6067229,
                    56.5328245
                ],
                [
                    76.6052875,
                    56.5341607
                ],
                [
                    76.6013899,
                    56.5343316
                ],
                [
                    76.5998398,
                    56.5348934
                ],
                [
                    76.5984224,
                    56.5363343
                ],
                [
                    76.596828,
                    56.5364076
                ],
                [
                    76.5941262,
                    56.5372623
                ],
                [
                    76.5871283,
                    56.5372623
                ],
                [
                    76.5858881,
                    56.5380682
                ],
                [
                    76.5849137,
                    56.543465
                ],
                [
                    76.5866854,
                    56.5456869
                ],
                [
                    76.5903615,
                    56.5459067
                ],
                [
                    76.5909816,
                    56.5430987
                ],
                [
                    76.5929036,
                    56.5409744
                ],
                [
                    76.5943048,
                    56.5397823
                ],
                [
                    76.5960917,
                    56.5389646
                ],
                [
                    76.5985624,
                    56.5391584
                ],
                [
                    76.6004333,
                    56.540565
                ],
                [
                    76.6029277,
                    56.5400492
                ],
                [
                    76.6045333,
                    56.5373019
                ],
                [
                    76.6065263,
                    56.5368135
                ],
                [
                    76.6106786,
                    56.5384314
                ],
                [
                    76.612561,
                    56.5413313
                ],
                [
                    76.6095713,
                    56.5417281
                ],
                [
                    76.6099589,
                    56.5437731
                ],
                [
                    76.6133361,
                    56.5440478
                ],
                [
                    76.6150723,
                    56.545608
                ],
                [
                    76.6144345,
                    56.5466823
                ],
                [
                    76.6096156,
                    56.5477957
                ],
                [
                    76.5942733,
                    56.5480691
                ],
                [
                    76.592289,
                    56.5602746
                ],
                [
                    76.5890292,
                    56.568572
                ],
                [
                    76.5668129,
                    56.5800683
                ]
            ],
            "longitude": 76.624588,
            "latitude": 56.55957
        },
        "5923": {
            "name": "ВЕНГЕРОВО",
            "population": 6616,
            "type": "town",
            "poly": null,
            "longitude": 76.739029,
            "latitude": 55.681034
        },
        "5924": {
            "name": "ЧАНЫ",
            "population": 8252,
            "type": "town",
            "poly": [
                [
                    76.7263361,
                    55.3132457
                ],
                [
                    76.7293224,
                    55.3143534
                ],
                [
                    76.7327432,
                    55.3150887
                ],
                [
                    76.7441743,
                    55.3175572
                ],
                [
                    76.7478415,
                    55.3183721
                ],
                [
                    76.7566276,
                    55.3203415
                ],
                [
                    76.756751,
                    55.3203664
                ],
                [
                    76.7602031,
                    55.321061
                ],
                [
                    76.7639156,
                    55.3218079
                ],
                [
                    76.7655109,
                    55.3221328
                ],
                [
                    76.7670696,
                    55.3224471
                ],
                [
                    76.771173,
                    55.3232931
                ],
                [
                    76.7734591,
                    55.3238434
                ],
                [
                    76.7774212,
                    55.3248269
                ],
                [
                    76.7783098,
                    55.324997
                ],
                [
                    76.7790962,
                    55.3250616
                ],
                [
                    76.78015,
                    55.3250529
                ],
                [
                    76.78083,
                    55.3249993
                ],
                [
                    76.7815047,
                    55.3248996
                ],
                [
                    76.791078,
                    55.3228405
                ],
                [
                    76.8062782,
                    55.3256219
                ],
                [
                    76.8121147,
                    55.3192735
                ],
                [
                    76.8110847,
                    55.3140963
                ],
                [
                    76.795443,
                    55.311724
                ],
                [
                    76.7967285,
                    55.3100467
                ],
                [
                    76.7955081,
                    55.3097115
                ],
                [
                    76.7870827,
                    55.3036192
                ],
                [
                    76.7775396,
                    55.3021542
                ],
                [
                    76.7706586,
                    55.2991317
                ],
                [
                    76.7620174,
                    55.2946081
                ],
                [
                    76.7528773,
                    55.2953291
                ],
                [
                    76.7505795,
                    55.2960931
                ],
                [
                    76.7492654,
                    55.2963903
                ],
                [
                    76.7476096,
                    55.2964029
                ],
                [
                    76.7473545,
                    55.2966423
                ],
                [
                    76.7456112,
                    55.2963844
                ],
                [
                    76.7455609,
                    55.2964739
                ],
                [
                    76.747172,
                    55.2967892
                ],
                [
                    76.7456185,
                    55.2986808
                ],
                [
                    76.7460209,
                    55.2987992
                ],
                [
                    76.7458259,
                    55.2990448
                ],
                [
                    76.7456115,
                    55.2993153
                ],
                [
                    76.7450608,
                    55.2998565
                ],
                [
                    76.7443761,
                    55.3018092
                ],
                [
                    76.7310812,
                    55.2998053
                ],
                [
                    76.7300906,
                    55.3012591
                ],
                [
                    76.7311101,
                    55.3014139
                ],
                [
                    76.7337268,
                    55.3040061
                ],
                [
                    76.731314,
                    55.3036483
                ],
                [
                    76.7308885,
                    55.3039079
                ],
                [
                    76.7301245,
                    55.3088711
                ],
                [
                    76.7286802,
                    55.3105345
                ],
                [
                    76.7271679,
                    55.3108439
                ],
                [
                    76.7263521,
                    55.3114435
                ],
                [
                    76.7263361,
                    55.3132457
                ]
            ],
            "longitude": 76.759605,
            "latitude": 55.308064
        },
        "5925": {
            "name": "КУПИНО",
            "population": 13897,
            "type": "town",
            "poly": [
                [
                    77.2351201,
                    54.3753989
                ],
                [
                    77.2701673,
                    54.3858209
                ],
                [
                    77.26511,
                    54.3914221
                ],
                [
                    77.2722539,
                    54.3967138
                ],
                [
                    77.2761794,
                    54.3976197
                ],
                [
                    77.2796453,
                    54.3957461
                ],
                [
                    77.289406,
                    54.3904543
                ],
                [
                    77.2935439,
                    54.3927606
                ],
                [
                    77.3081499,
                    54.393893
                ],
                [
                    77.3088925,
                    54.3913398
                ],
                [
                    77.3209521,
                    54.3935224
                ],
                [
                    77.3290509,
                    54.39309
                ],
                [
                    77.3278838,
                    54.3894659
                ],
                [
                    77.3326582,
                    54.3891982
                ],
                [
                    77.3324106,
                    54.3881068
                ],
                [
                    77.3339667,
                    54.388148
                ],
                [
                    77.3356289,
                    54.3888687
                ],
                [
                    77.3358057,
                    54.3896512
                ],
                [
                    77.3401557,
                    54.3890335
                ],
                [
                    77.3417117,
                    54.3894247
                ],
                [
                    77.3470519,
                    54.3892394
                ],
                [
                    77.3477946,
                    54.3880656
                ],
                [
                    77.3524629,
                    54.3884569
                ],
                [
                    77.3522507,
                    54.3860062
                ],
                [
                    77.3485019,
                    54.3743277
                ],
                [
                    77.3340374,
                    54.3674468
                ],
                [
                    77.3367252,
                    54.3650155
                ],
                [
                    77.3359825,
                    54.3634907
                ],
                [
                    77.3374678,
                    54.3618216
                ],
                [
                    77.3265399,
                    54.3596167
                ],
                [
                    77.3239106,
                    54.3563055
                ],
                [
                    77.3270338,
                    54.3542133
                ],
                [
                    77.3332948,
                    54.3528363
                ],
                [
                    77.3405092,
                    54.3538463
                ],
                [
                    77.3501287,
                    54.3568552
                ],
                [
                    77.3516494,
                    54.359967
                ],
                [
                    77.361375,
                    54.3644798
                ],
                [
                    77.3634262,
                    54.3674262
                ],
                [
                    77.3602432,
                    54.3675292
                ],
                [
                    77.360703,
                    54.3725149
                ],
                [
                    77.36767,
                    54.3722883
                ],
                [
                    77.3651237,
                    54.361595
                ],
                [
                    77.3719139,
                    54.363738
                ],
                [
                    77.3841857,
                    54.3543203
                ],
                [
                    77.3837614,
                    54.3539081
                ],
                [
                    77.3893845,
                    54.3510019
                ],
                [
                    77.3959625,
                    54.3517027
                ],
                [
                    77.4021513,
                    54.3547119
                ],
                [
                    77.4031417,
                    54.3532898
                ],
                [
                    77.4015856,
                    54.3524035
                ],
                [
                    77.3840089,
                    54.3451478
                ],
                [
                    77.3829833,
                    54.3457456
                ],
                [
                    77.389915,
                    54.3493118
                ],
                [
                    77.3823467,
                    54.3536195
                ],
                [
                    77.346769,
                    54.3399526
                ],
                [
                    77.3424898,
                    54.3433955
                ],
                [
                    77.3266107,
                    54.3374991
                ],
                [
                    77.3074794,
                    54.3304203
                ],
                [
                    77.3056389,
                    54.3311481
                ],
                [
                    77.2995207,
                    54.336262
                ],
                [
                    77.292872,
                    54.3346743
                ],
                [
                    77.2878147,
                    54.3378084
                ],
                [
                    77.2936146,
                    54.3410247
                ],
                [
                    77.2882037,
                    54.3451272
                ],
                [
                    77.2721831,
                    54.3458487
                ],
                [
                    77.2689295,
                    54.3504454
                ],
                [
                    77.2586381,
                    54.3476833
                ],
                [
                    77.2521309,
                    54.3565461
                ],
                [
                    77.2443505,
                    54.3673231
                ],
                [
                    77.2451992,
                    54.3678794
                ],
                [
                    77.2495138,
                    54.3702281
                ],
                [
                    77.2351201,
                    54.3753989
                ]
            ],
            "longitude": 77.30854,
            "latitude": 54.364929
        },
        "5926": {
            "name": "БАГАН",
            "population": 5510,
            "type": "town",
            "poly": [
                [
                    77.6308372,
                    54.1028684
                ],
                [
                    77.6371529,
                    54.103827
                ],
                [
                    77.6360023,
                    54.1051761
                ],
                [
                    77.6346096,
                    54.1075428
                ],
                [
                    77.6338426,
                    54.10746
                ],
                [
                    77.6332573,
                    54.1086315
                ],
                [
                    77.6354574,
                    54.1089747
                ],
                [
                    77.6389492,
                    54.1098858
                ],
                [
                    77.6396153,
                    54.1085605
                ],
                [
                    77.6386667,
                    54.1083357
                ],
                [
                    77.6394942,
                    54.1067382
                ],
                [
                    77.6403218,
                    54.1055666
                ],
                [
                    77.6416943,
                    54.1040518
                ],
                [
                    77.6434504,
                    54.1027619
                ],
                [
                    77.6451862,
                    54.1041347
                ],
                [
                    77.6486983,
                    54.1061465
                ],
                [
                    77.6511205,
                    54.1073062
                ],
                [
                    77.6545114,
                    54.1079452
                ],
                [
                    77.6569941,
                    54.1080872
                ],
                [
                    77.6615355,
                    54.1092468
                ],
                [
                    77.6674496,
                    54.1102171
                ],
                [
                    77.6734242,
                    54.111282
                ],
                [
                    77.6743325,
                    54.1119446
                ],
                [
                    77.6773063,
                    54.1098472
                ],
                [
                    77.6824381,
                    54.1088904
                ],
                [
                    77.6860535,
                    54.1079464
                ],
                [
                    77.6875674,
                    54.1073133
                ],
                [
                    77.6887482,
                    54.1065204
                ],
                [
                    77.6895253,
                    54.1058281
                ],
                [
                    77.6925648,
                    54.1027931
                ],
                [
                    77.6930572,
                    54.1023501
                ],
                [
                    77.6954711,
                    54.1001779
                ],
                [
                    77.6963774,
                    54.0992239
                ],
                [
                    77.6967485,
                    54.0984915
                ],
                [
                    77.6970839,
                    54.0977299
                ],
                [
                    77.6971124,
                    54.0961983
                ],
                [
                    77.6953354,
                    54.0930548
                ],
                [
                    77.6921866,
                    54.0886154
                ],
                [
                    77.6859194,
                    54.079984
                ],
                [
                    77.6938564,
                    54.073497
                ],
                [
                    77.6880433,
                    54.0743023
                ],
                [
                    77.6789603,
                    54.0806733
                ],
                [
                    77.6766593,
                    54.0807917
                ],
                [
                    77.6716967,
                    54.0789902
                ],
                [
                    77.6706443,
                    54.0811943
                ],
                [
                    77.6579685,
                    54.0877774
                ],
                [
                    77.6548197,
                    54.0877537
                ],
                [
                    77.6505003,
                    54.0865224
                ],
                [
                    77.6394796,
                    54.0915894
                ],
                [
                    77.6338344,
                    54.0965749
                ],
                [
                    77.6308372,
                    54.1028684
                ]
            ],
            "longitude": 77.671883,
            "latitude": 54.096813
        },
        "5927": {
            "name": "КАРАСУК",
            "population": 27332,
            "type": "town",
            "poly": [
                [
                    77.991056,
                    53.7351303
                ],
                [
                    77.9915207,
                    53.7358154
                ],
                [
                    77.9975221,
                    53.7390274
                ],
                [
                    77.9989073,
                    53.7398991
                ],
                [
                    77.997681,
                    53.7407618
                ],
                [
                    77.9994282,
                    53.7416815
                ],
                [
                    78.0007047,
                    53.7408896
                ],
                [
                    78.0036375,
                    53.7420623
                ],
                [
                    78.0044295,
                    53.7426063
                ],
                [
                    78.0078392,
                    53.7431932
                ],
                [
                    78.0097574,
                    53.7435703
                ],
                [
                    78.0111887,
                    53.7442319
                ],
                [
                    78.0125101,
                    53.7447171
                ],
                [
                    78.013181,
                    53.7454219
                ],
                [
                    78.0154211,
                    53.7469222
                ],
                [
                    78.0122749,
                    53.748549
                ],
                [
                    78.0124646,
                    53.748803
                ],
                [
                    78.0155439,
                    53.7509051
                ],
                [
                    78.0163445,
                    53.7507559
                ],
                [
                    78.0180413,
                    53.7508074
                ],
                [
                    78.0192968,
                    53.7505623
                ],
                [
                    78.0215016,
                    53.7496128
                ],
                [
                    78.0214637,
                    53.7503515
                ],
                [
                    78.0216178,
                    53.7510851
                ],
                [
                    78.022401,
                    53.7519727
                ],
                [
                    78.0235698,
                    53.7526461
                ],
                [
                    78.0244893,
                    53.7529281
                ],
                [
                    78.0253346,
                    53.7530599
                ],
                [
                    78.0290149,
                    53.7537761
                ],
                [
                    78.0314486,
                    53.7530654
                ],
                [
                    78.0336959,
                    53.7532335
                ],
                [
                    78.0378764,
                    53.7528554
                ],
                [
                    78.0399158,
                    53.7523248
                ],
                [
                    78.0406802,
                    53.7522799
                ],
                [
                    78.0440237,
                    53.7529472
                ],
                [
                    78.045645,
                    53.7537914
                ],
                [
                    78.0463735,
                    53.7536511
                ],
                [
                    78.0472539,
                    53.7535122
                ],
                [
                    78.048953,
                    53.7531853
                ],
                [
                    78.0524176,
                    53.7525441
                ],
                [
                    78.0665958,
                    53.750096
                ],
                [
                    78.0693022,
                    53.7505114
                ],
                [
                    78.0697914,
                    53.7496212
                ],
                [
                    78.0691441,
                    53.7485072
                ],
                [
                    78.0725166,
                    53.748056
                ],
                [
                    78.0678849,
                    53.7452364
                ],
                [
                    78.0697947,
                    53.7448341
                ],
                [
                    78.0700242,
                    53.7445022
                ],
                [
                    78.0698352,
                    53.7440909
                ],
                [
                    78.0668085,
                    53.743174
                ],
                [
                    78.065194,
                    53.741126
                ],
                [
                    78.0645779,
                    53.7402087
                ],
                [
                    78.0644493,
                    53.7394106
                ],
                [
                    78.0645779,
                    53.7387009
                ],
                [
                    78.0649815,
                    53.7382863
                ],
                [
                    78.0658313,
                    53.7378842
                ],
                [
                    78.0680171,
                    53.7367422
                ],
                [
                    78.0684756,
                    53.7361991
                ],
                [
                    78.0709037,
                    53.7368948
                ],
                [
                    78.0715437,
                    53.7361893
                ],
                [
                    78.0744348,
                    53.7370135
                ],
                [
                    78.0779807,
                    53.7326204
                ],
                [
                    78.0791173,
                    53.7327592
                ],
                [
                    78.079999,
                    53.729963
                ],
                [
                    78.0800999,
                    53.7271476
                ],
                [
                    78.0794626,
                    53.726802
                ],
                [
                    78.0798968,
                    53.7264129
                ],
                [
                    78.0802362,
                    53.7259084
                ],
                [
                    78.0803667,
                    53.7254193
                ],
                [
                    78.0804031,
                    53.7249216
                ],
                [
                    78.0802427,
                    53.7243987
                ],
                [
                    78.0799751,
                    53.7240137
                ],
                [
                    78.0795574,
                    53.7236173
                ],
                [
                    78.079044,
                    53.7232878
                ],
                [
                    78.078548,
                    53.7230097
                ],
                [
                    78.0786393,
                    53.7228583
                ],
                [
                    78.0649102,
                    53.71816
                ],
                [
                    78.0659724,
                    53.7158027
                ],
                [
                    78.0497205,
                    53.7080701
                ],
                [
                    78.0489238,
                    53.7082116
                ],
                [
                    78.0460824,
                    53.7146398
                ],
                [
                    78.0436658,
                    53.7143412
                ],
                [
                    78.0421522,
                    53.7178928
                ],
                [
                    78.0311051,
                    53.7184743
                ],
                [
                    78.0256316,
                    53.7186682
                ],
                [
                    78.0089793,
                    53.719323
                ],
                [
                    78.0095914,
                    53.72248
                ],
                [
                    78.0113905,
                    53.7254034
                ],
                [
                    78.0127169,
                    53.7267464
                ],
                [
                    78.0206442,
                    53.7282652
                ],
                [
                    78.0218738,
                    53.7286085
                ],
                [
                    78.0227965,
                    53.7292614
                ],
                [
                    78.0233353,
                    53.7299084
                ],
                [
                    78.0234165,
                    53.7307534
                ],
                [
                    78.0232465,
                    53.7312435
                ],
                [
                    78.0209054,
                    53.7335857
                ],
                [
                    78.0195675,
                    53.7344318
                ],
                [
                    78.0184112,
                    53.7348241
                ],
                [
                    78.0151346,
                    53.7345441
                ],
                [
                    78.0120607,
                    53.7338159
                ],
                [
                    78.0097676,
                    53.73277
                ],
                [
                    78.0077263,
                    53.7318114
                ],
                [
                    78.0041393,
                    53.7300905
                ],
                [
                    78.0005589,
                    53.7284545
                ],
                [
                    77.9946517,
                    53.7305267
                ],
                [
                    77.9950003,
                    53.7307571
                ],
                [
                    77.9950256,
                    53.7309691
                ],
                [
                    77.993462,
                    53.7317433
                ],
                [
                    77.9947583,
                    53.7327011
                ],
                [
                    77.991056,
                    53.7351303
                ]
            ],
            "longitude": 78.032372,
            "latitude": 53.73447
        },
        "5928": {
            "name": "КУЙБЫШЕВ",
            "population": 44616,
            "type": "town",
            "poly": [
                [
                    78.2558655,
                    55.4572198
                ],
                [
                    78.2641052,
                    55.4658818
                ],
                [
                    78.2836997,
                    55.4703396
                ],
                [
                    78.2999142,
                    55.4772151
                ],
                [
                    78.3014757,
                    55.4772639
                ],
                [
                    78.3038597,
                    55.4773384
                ],
                [
                    78.314293,
                    55.4777647
                ],
                [
                    78.3201808,
                    55.4779488
                ],
                [
                    78.3206104,
                    55.4779622
                ],
                [
                    78.3233284,
                    55.4779469
                ],
                [
                    78.344786,
                    55.4564412
                ],
                [
                    78.3636688,
                    55.4519634
                ],
                [
                    78.3700202,
                    55.4516713
                ],
                [
                    78.3743118,
                    55.4533262
                ],
                [
                    78.3913063,
                    55.4602371
                ],
                [
                    78.3952544,
                    55.4591665
                ],
                [
                    78.4045239,
                    55.4593483
                ],
                [
                    78.410622,
                    55.4577662
                ],
                [
                    78.4300334,
                    55.4548187
                ],
                [
                    78.4409595,
                    55.443288
                ],
                [
                    78.4077858,
                    55.4299564
                ],
                [
                    78.3947395,
                    55.4275213
                ],
                [
                    78.3600639,
                    55.4303461
                ],
                [
                    78.3146242,
                    55.4261165
                ],
                [
                    78.2940341,
                    55.4286895
                ],
                [
                    78.2841077,
                    55.4334986
                ],
                [
                    78.2642769,
                    55.4316123
                ],
                [
                    78.2577538,
                    55.4339498
                ],
                [
                    78.2674061,
                    55.4408036
                ],
                [
                    78.2598137,
                    55.4517687
                ],
                [
                    78.2558655,
                    55.4572198
                ]
            ],
            "longitude": 78.3222294,
            "latitude": 55.4454258
        },
        "5929": {
            "name": "БАРАБИНСК",
            "population": 29307,
            "type": "town",
            "poly": [
                [
                    78.2858276,
                    55.3440754
                ],
                [
                    78.2890892,
                    55.3499318
                ],
                [
                    78.3026505,
                    55.3504198
                ],
                [
                    78.3000755,
                    55.3549091
                ],
                [
                    78.3084869,
                    55.3577391
                ],
                [
                    78.3196449,
                    55.3565681
                ],
                [
                    78.3246231,
                    55.3611543
                ],
                [
                    78.3249258,
                    55.362769
                ],
                [
                    78.3239563,
                    55.363753
                ],
                [
                    78.3234691,
                    55.365057
                ],
                [
                    78.3242203,
                    55.3663956
                ],
                [
                    78.3254791,
                    55.3675034
                ],
                [
                    78.3332062,
                    55.3679838
                ],
                [
                    78.3493423,
                    55.3672033
                ],
                [
                    78.3514023,
                    55.3647643
                ],
                [
                    78.3589154,
                    55.3666174
                ],
                [
                    78.3804192,
                    55.3672668
                ],
                [
                    78.4041706,
                    55.3697819
                ],
                [
                    78.411671,
                    55.3586208
                ],
                [
                    78.4135347,
                    55.356011
                ],
                [
                    78.4158985,
                    55.3506356
                ],
                [
                    78.4060343,
                    55.3441739
                ],
                [
                    78.381533,
                    55.3395725
                ],
                [
                    78.3716583,
                    55.3405611
                ],
                [
                    78.3538055,
                    55.336656
                ],
                [
                    78.3529472,
                    55.3344103
                ],
                [
                    78.3452225,
                    55.3338245
                ],
                [
                    78.3419609,
                    55.3330434
                ],
                [
                    78.3340645,
                    55.3286493
                ],
                [
                    78.3321762,
                    55.3356796
                ],
                [
                    78.3323479,
                    55.3382181
                ],
                [
                    78.3256531,
                    55.3412445
                ],
                [
                    78.3155251,
                    55.3394872
                ],
                [
                    78.3107185,
                    55.3426111
                ],
                [
                    78.3156967,
                    55.3443682
                ],
                [
                    78.316555,
                    55.3464181
                ],
                [
                    78.307457,
                    55.3457348
                ],
                [
                    78.2866859,
                    55.3412445
                ],
                [
                    78.2858276,
                    55.3440754
                ]
            ],
            "longitude": 78.347816,
            "latitude": 55.351784
        },
        "5930": {
            "name": "СЕВЕРНОЕ",
            "population": 4988,
            "type": "town",
            "poly": [
                [
                    78.311071,
                    56.3520618
                ],
                [
                    78.311071,
                    56.3526292
                ],
                [
                    78.3131191,
                    56.3530021
                ],
                [
                    78.3180463,
                    56.360913
                ],
                [
                    78.3258174,
                    56.361665
                ],
                [
                    78.327292,
                    56.3617947
                ],
                [
                    78.3334219,
                    56.3630692
                ],
                [
                    78.3360228,
                    56.3636099
                ],
                [
                    78.3390189,
                    56.365062
                ],
                [
                    78.3452218,
                    56.3670456
                ],
                [
                    78.3451046,
                    56.3654121
                ],
                [
                    78.3426704,
                    56.3633636
                ],
                [
                    78.3443791,
                    56.3615094
                ],
                [
                    78.3453387,
                    56.3608481
                ],
                [
                    78.3467432,
                    56.3600442
                ],
                [
                    78.3474922,
                    56.3594088
                ],
                [
                    78.3478902,
                    56.358151
                ],
                [
                    78.3483583,
                    56.357736
                ],
                [
                    78.3496457,
                    56.3574118
                ],
                [
                    78.3525949,
                    56.3571136
                ],
                [
                    78.3543037,
                    56.3555833
                ],
                [
                    78.3556378,
                    56.3549608
                ],
                [
                    78.3565273,
                    56.3548571
                ],
                [
                    78.3577913,
                    56.3551165
                ],
                [
                    78.3585169,
                    56.3555444
                ],
                [
                    78.358751,
                    56.3560113
                ],
                [
                    78.3583062,
                    56.3568023
                ],
                [
                    78.3574168,
                    56.3577101
                ],
                [
                    78.3567614,
                    56.3586567
                ],
                [
                    78.3565039,
                    56.3597589
                ],
                [
                    78.3570891,
                    56.3602646
                ],
                [
                    78.3586105,
                    56.3600831
                ],
                [
                    78.3606001,
                    56.359331
                ],
                [
                    78.3628004,
                    56.3583974
                ],
                [
                    78.3650006,
                    56.3572432
                ],
                [
                    78.3669668,
                    56.3566727
                ],
                [
                    78.3690734,
                    56.355713
                ],
                [
                    78.3701502,
                    56.3554407
                ],
                [
                    78.3711332,
                    56.3555185
                ],
                [
                    78.37221,
                    56.3558686
                ],
                [
                    78.372842,
                    56.3568283
                ],
                [
                    78.3726781,
                    56.3597589
                ],
                [
                    78.3721397,
                    56.3616261
                ],
                [
                    78.3713673,
                    56.3627801
                ],
                [
                    78.3714141,
                    56.3638433
                ],
                [
                    78.3726781,
                    56.3645823
                ],
                [
                    78.3746209,
                    56.3648676
                ],
                [
                    78.3758789,
                    56.3650252
                ],
                [
                    78.3765871,
                    56.3651139
                ],
                [
                    78.3775467,
                    56.365451
                ],
                [
                    78.3780617,
                    56.3667993
                ],
                [
                    78.3788575,
                    56.3674605
                ],
                [
                    78.3804492,
                    56.3678754
                ],
                [
                    78.3823218,
                    56.3679402
                ],
                [
                    78.3835155,
                    56.3682124
                ],
                [
                    78.3846156,
                    56.3685754
                ],
                [
                    78.3870968,
                    56.3679013
                ],
                [
                    78.3888523,
                    56.3668901
                ],
                [
                    78.38918,
                    56.3661381
                ],
                [
                    78.3881556,
                    56.3655191
                ],
                [
                    78.3878926,
                    56.3653602
                ],
                [
                    78.3839837,
                    56.3639729
                ],
                [
                    78.3817131,
                    56.362806
                ],
                [
                    78.3794193,
                    56.3611075
                ],
                [
                    78.3779213,
                    56.3604591
                ],
                [
                    78.377336,
                    56.3598237
                ],
                [
                    78.3778042,
                    56.3586048
                ],
                [
                    78.3786937,
                    56.357334
                ],
                [
                    78.3797002,
                    56.356517
                ],
                [
                    78.3811513,
                    56.3558946
                ],
                [
                    78.3825792,
                    56.3555444
                ],
                [
                    78.3835857,
                    56.3552591
                ],
                [
                    78.3844517,
                    56.3547274
                ],
                [
                    78.3853179,
                    56.3532749
                ],
                [
                    78.3856908,
                    56.3528164
                ],
                [
                    78.3860978,
                    56.3525808
                ],
                [
                    78.3857316,
                    56.3524708
                ],
                [
                    78.3856689,
                    56.3507588
                ],
                [
                    78.3857397,
                    56.3494162
                ],
                [
                    78.3857626,
                    56.3489819
                ],
                [
                    78.384405,
                    56.3455834
                ],
                [
                    78.3859337,
                    56.3456437
                ],
                [
                    78.3861371,
                    56.3456223
                ],
                [
                    78.3862539,
                    56.3456073
                ],
                [
                    78.3874479,
                    56.3454537
                ],
                [
                    78.3890629,
                    56.3445847
                ],
                [
                    78.3888288,
                    56.3436247
                ],
                [
                    78.3878646,
                    56.342967
                ],
                [
                    78.3876116,
                    56.3427945
                ],
                [
                    78.3852196,
                    56.3416454
                ],
                [
                    78.3844517,
                    56.3412766
                ],
                [
                    78.3844016,
                    56.3412349
                ],
                [
                    78.3838899,
                    56.3408096
                ],
                [
                    78.3858094,
                    56.3399014
                ],
                [
                    78.3872839,
                    56.3388376
                ],
                [
                    78.3866521,
                    56.3380072
                ],
                [
                    78.3872933,
                    56.3375096
                ],
                [
                    78.3874626,
                    56.3373782
                ],
                [
                    78.38794,
                    56.3370077
                ],
                [
                    78.3882905,
                    56.3367357
                ],
                [
                    78.3888331,
                    56.3360589
                ],
                [
                    78.3896013,
                    56.3351009
                ],
                [
                    78.3900461,
                    56.3337774
                ],
                [
                    78.3893438,
                    56.3332064
                ],
                [
                    78.3883842,
                    56.3330377
                ],
                [
                    78.3888598,
                    56.3320761
                ],
                [
                    78.38918,
                    56.3314287
                ],
                [
                    78.3873777,
                    56.3310653
                ],
                [
                    78.3873379,
                    56.3311164
                ],
                [
                    78.386418,
                    56.3322981
                ],
                [
                    78.3857158,
                    56.3322073
                ],
                [
                    78.3844284,
                    56.3336217
                ],
                [
                    78.3825324,
                    56.3333362
                ],
                [
                    78.3813854,
                    56.3339201
                ],
                [
                    78.376236,
                    56.3339461
                ],
                [
                    78.3737314,
                    56.3341277
                ],
                [
                    78.3734037,
                    56.3343353
                ],
                [
                    78.3732399,
                    56.3355291
                ],
                [
                    78.3738953,
                    56.3356199
                ],
                [
                    78.3736143,
                    56.3373974
                ],
                [
                    78.3694714,
                    56.3374364
                ],
                [
                    78.3676222,
                    56.3373845
                ],
                [
                    78.3648602,
                    56.3382667
                ],
                [
                    78.364275,
                    56.3393306
                ],
                [
                    78.3630344,
                    56.3405242
                ],
                [
                    78.360732,
                    56.3407009
                ],
                [
                    78.3582952,
                    56.3398444
                ],
                [
                    78.3566209,
                    56.3372677
                ],
                [
                    78.3530062,
                    56.3369624
                ],
                [
                    78.3500191,
                    56.3367102
                ],
                [
                    78.3460518,
                    56.3378916
                ],
                [
                    78.3447704,
                    56.3387022
                ],
                [
                    78.343171,
                    56.3392967
                ],
                [
                    78.3341097,
                    56.3426649
                ],
                [
                    78.3310547,
                    56.3423497
                ],
                [
                    78.3293869,
                    56.3421064
                ],
                [
                    78.3201997,
                    56.3467601
                ],
                [
                    78.3173909,
                    56.3492894
                ],
                [
                    78.3173323,
                    56.3498731
                ],
                [
                    78.313558,
                    56.3499055
                ],
                [
                    78.311071,
                    56.3520618
                ]
            ],
            "longitude": 78.364952,
            "latitude": 56.350143
        },
        "5931": {
            "name": "ЗДВИНСК",
            "population": 4986,
            "type": "town",
            "poly": null,
            "longitude": 78.667595,
            "latitude": 54.703968
        },
        "5932": {
            "name": "КРАСНОЗЁРСКОЕ",
            "population": 9215,
            "type": "town",
            "poly": [
                [
                    79.2070941,
                    53.9755351
                ],
                [
                    79.2134701,
                    53.9928261
                ],
                [
                    79.2424515,
                    53.9957068
                ],
                [
                    79.2724115,
                    53.9976716
                ],
                [
                    79.2758344,
                    53.9936441
                ],
                [
                    79.2799355,
                    53.9943436
                ],
                [
                    79.2842941,
                    53.9931173
                ],
                [
                    79.2839152,
                    53.9909916
                ],
                [
                    79.2739106,
                    53.9884875
                ],
                [
                    79.2742105,
                    53.9871872
                ],
                [
                    79.2758971,
                    53.9798725
                ],
                [
                    79.2770341,
                    53.9780559
                ],
                [
                    79.2714436,
                    53.9765179
                ],
                [
                    79.2663648,
                    53.9765736
                ],
                [
                    79.2638633,
                    53.9797722
                ],
                [
                    79.2559164,
                    53.9788723
                ],
                [
                    79.2455325,
                    53.9649016
                ],
                [
                    79.2070941,
                    53.9755351
                ]
            ],
            "longitude": 79.228577,
            "latitude": 53.984768
        },
        "5933": {
            "name": "ДОВОЛЬНОЕ",
            "population": 6774,
            "type": "town",
            "poly": null,
            "longitude": 79.667091,
            "latitude": 54.495785
        },
        "5934": {
            "name": "УБИНСКОЕ",
            "population": 5841,
            "type": "town",
            "poly": [
                [
                    79.6181388,
                    55.3073002
                ],
                [
                    79.626784,
                    55.3130455
                ],
                [
                    79.6342904,
                    55.3179945
                ],
                [
                    79.6456792,
                    55.3211463
                ],
                [
                    79.6463522,
                    55.3166395
                ],
                [
                    79.6442297,
                    55.3104234
                ],
                [
                    79.6482676,
                    55.3089797
                ],
                [
                    79.6474393,
                    55.3078011
                ],
                [
                    79.6602777,
                    55.305326
                ],
                [
                    79.6613131,
                    55.3067993
                ],
                [
                    79.6625037,
                    55.3071529
                ],
                [
                    79.6628623,
                    55.3061216
                ],
                [
                    79.663914,
                    55.3057354
                ],
                [
                    79.6655934,
                    55.3060347
                ],
                [
                    79.666696,
                    55.3067589
                ],
                [
                    79.6682566,
                    55.3070196
                ],
                [
                    79.6708181,
                    55.3074347
                ],
                [
                    79.6729554,
                    55.3083616
                ],
                [
                    79.6734813,
                    55.3093947
                ],
                [
                    79.6752455,
                    55.3096457
                ],
                [
                    79.6758053,
                    55.309636
                ],
                [
                    79.6776034,
                    55.3103698
                ],
                [
                    79.6809621,
                    55.3117696
                ],
                [
                    79.681471,
                    55.3127833
                ],
                [
                    79.682845,
                    55.3137679
                ],
                [
                    79.6930826,
                    55.3178214
                ],
                [
                    79.694791,
                    55.3178274
                ],
                [
                    79.6986233,
                    55.3176947
                ],
                [
                    79.7015725,
                    55.3155355
                ],
                [
                    79.6952318,
                    55.2973687
                ],
                [
                    79.7008636,
                    55.2964262
                ],
                [
                    79.7247285,
                    55.2935378
                ],
                [
                    79.7234343,
                    55.2893521
                ],
                [
                    79.7200694,
                    55.285844
                ],
                [
                    79.7247285,
                    55.2854018
                ],
                [
                    79.7232272,
                    55.2815396
                ],
                [
                    79.7179987,
                    55.2791808
                ],
                [
                    79.7109653,
                    55.2804306
                ],
                [
                    79.7056859,
                    55.2817436
                ],
                [
                    79.694082,
                    55.2846943
                ],
                [
                    79.6877327,
                    55.2892213
                ],
                [
                    79.6744103,
                    55.2916808
                ],
                [
                    79.6724949,
                    55.2936557
                ],
                [
                    79.6767399,
                    55.296662
                ],
                [
                    79.6774128,
                    55.2985777
                ],
                [
                    79.670476,
                    55.3006996
                ],
                [
                    79.6649368,
                    55.3011711
                ],
                [
                    79.6557739,
                    55.2990198
                ],
                [
                    79.6474911,
                    55.2957189
                ],
                [
                    79.6445921,
                    55.2956304
                ],
                [
                    79.6434809,
                    55.2961019
                ],
                [
                    79.6427285,
                    55.2974283
                ],
                [
                    79.6484747,
                    55.3004343
                ],
                [
                    79.6497189,
                    55.3016302
                ],
                [
                    79.6456792,
                    55.3051198
                ],
                [
                    79.6349116,
                    55.3061806
                ],
                [
                    79.6259558,
                    55.3031455
                ],
                [
                    79.618553,
                    55.3039116
                ],
                [
                    79.6181388,
                    55.3073002
                ]
            ],
            "longitude": 79.679375,
            "latitude": 55.306721
        },
        "5935": {
            "name": "КАРГАТ",
            "population": 9584,
            "type": "town",
            "poly": [
                [
                    80.2225433,
                    55.1890158
                ],
                [
                    80.2303921,
                    55.19229
                ],
                [
                    80.2373353,
                    55.1925485
                ],
                [
                    80.2403541,
                    55.1933239
                ],
                [
                    80.2402031,
                    55.1959947
                ],
                [
                    80.2451841,
                    55.1987514
                ],
                [
                    80.2509198,
                    55.2004743
                ],
                [
                    80.255146,
                    55.2010773
                ],
                [
                    80.2580139,
                    55.2004743
                ],
                [
                    80.2611836,
                    55.2033169
                ],
                [
                    80.2613345,
                    55.207365
                ],
                [
                    80.266105,
                    55.208917
                ],
                [
                    80.2672426,
                    55.2088888
                ],
                [
                    80.2679845,
                    55.2085501
                ],
                [
                    80.2688253,
                    55.2073084
                ],
                [
                    80.2697156,
                    55.2065181
                ],
                [
                    80.2724359,
                    55.2053045
                ],
                [
                    80.2748098,
                    55.2034418
                ],
                [
                    80.2761948,
                    55.2038651
                ],
                [
                    80.2792118,
                    55.2071673
                ],
                [
                    80.2810913,
                    55.2087194
                ],
                [
                    80.282031,
                    55.2092556
                ],
                [
                    80.2834159,
                    55.2093967
                ],
                [
                    80.2843556,
                    55.2097354
                ],
                [
                    80.2839599,
                    55.2101305
                ],
                [
                    80.283317,
                    55.2101869
                ],
                [
                    80.2832674,
                    55.2107795
                ],
                [
                    80.2822289,
                    55.211231
                ],
                [
                    80.2821794,
                    55.2117954
                ],
                [
                    80.2836137,
                    55.2121623
                ],
                [
                    80.2852459,
                    55.2116825
                ],
                [
                    80.2859383,
                    55.2122469
                ],
                [
                    80.2897467,
                    55.2114286
                ],
                [
                    80.2892521,
                    55.2108924
                ],
                [
                    80.2869275,
                    55.2101022
                ],
                [
                    80.2859878,
                    55.2087477
                ],
                [
                    80.2863835,
                    55.2083243
                ],
                [
                    80.2873232,
                    55.2082115
                ],
                [
                    80.2883618,
                    55.2087477
                ],
                [
                    80.2900929,
                    55.2080986
                ],
                [
                    80.2904391,
                    55.2087759
                ],
                [
                    80.2902413,
                    55.2093121
                ],
                [
                    80.2908348,
                    55.2096225
                ],
                [
                    80.291725,
                    55.2094532
                ],
                [
                    80.2927637,
                    55.2070826
                ],
                [
                    80.2950883,
                    55.2052481
                ],
                [
                    80.2949894,
                    55.2043732
                ],
                [
                    80.2960775,
                    55.2040909
                ],
                [
                    80.2994408,
                    55.2053328
                ],
                [
                    80.2993419,
                    55.2059255
                ],
                [
                    80.2962259,
                    55.2079575
                ],
                [
                    80.2964237,
                    55.2088888
                ],
                [
                    80.2976602,
                    55.2109206
                ],
                [
                    80.2990451,
                    55.2109206
                ],
                [
                    80.3006278,
                    55.2095096
                ],
                [
                    80.3011719,
                    55.2093403
                ],
                [
                    80.3025073,
                    55.2097918
                ],
                [
                    80.3038427,
                    55.209425
                ],
                [
                    80.3086402,
                    55.2096225
                ],
                [
                    80.314427,
                    55.2136296
                ],
                [
                    80.3184332,
                    55.2118519
                ],
                [
                    80.3195213,
                    55.2110899
                ],
                [
                    80.3167516,
                    55.2108642
                ],
                [
                    80.3135367,
                    55.2087194
                ],
                [
                    80.3193235,
                    55.206377
                ],
                [
                    80.3158613,
                    55.2050505
                ],
                [
                    80.3146742,
                    55.2037805
                ],
                [
                    80.3126465,
                    55.2036111
                ],
                [
                    80.3075027,
                    55.1996595
                ],
                [
                    80.3078489,
                    55.1979375
                ],
                [
                    80.3067608,
                    55.1974294
                ],
                [
                    80.306365,
                    55.194917
                ],
                [
                    80.3059694,
                    55.1930537
                ],
                [
                    80.3097778,
                    55.1922067
                ],
                [
                    80.3115584,
                    55.1916985
                ],
                [
                    80.3118989,
                    55.190136
                ],
                [
                    80.3218609,
                    55.1882403
                ],
                [
                    80.3242759,
                    55.1853967
                ],
                [
                    80.316578,
                    55.1835008
                ],
                [
                    80.3067669,
                    55.1814324
                ],
                [
                    80.2963523,
                    55.1800535
                ],
                [
                    80.2948429,
                    55.1753992
                ],
                [
                    80.2832206,
                    55.1749682
                ],
                [
                    80.2799,
                    55.177985
                ],
                [
                    80.2791453,
                    55.180312
                ],
                [
                    80.2746171,
                    55.1818634
                ],
                [
                    80.2706927,
                    55.1844487
                ],
                [
                    80.2690324,
                    55.1869478
                ],
                [
                    80.2635986,
                    55.1872063
                ],
                [
                    80.2584667,
                    55.1891881
                ],
                [
                    80.2546932,
                    55.189102
                ],
                [
                    80.2492594,
                    55.188068
                ],
                [
                    80.2420144,
                    55.1871201
                ],
                [
                    80.2317506,
                    55.1871201
                ],
                [
                    80.2225433,
                    55.1890158
                ]
            ],
            "longitude": 80.2828252,
            "latitude": 55.1929899
        },
        "5936": {
            "name": "КОЧКИ",
            "population": 3972,
            "type": "town",
            "poly": null,
            "longitude": 80.487846,
            "latitude": 54.334766
        },
        "5937": {
            "name": "ЧУЛЫМ",
            "population": 11312,
            "type": "town",
            "poly": [
                [
                    80.9133466,
                    55.0977939
                ],
                [
                    80.9209276,
                    55.1029717
                ],
                [
                    80.9355374,
                    55.1102727
                ],
                [
                    80.9624618,
                    55.1123843
                ],
                [
                    80.9630896,
                    55.115713
                ],
                [
                    80.9659464,
                    55.1188321
                ],
                [
                    80.9734698,
                    55.1226339
                ],
                [
                    80.9851654,
                    55.11688
                ],
                [
                    80.9878367,
                    55.1178561
                ],
                [
                    80.9891724,
                    55.117559
                ],
                [
                    80.9884304,
                    55.1144398
                ],
                [
                    80.9859452,
                    55.1111624
                ],
                [
                    80.9893497,
                    55.1057495
                ],
                [
                    80.989395,
                    55.1025972
                ],
                [
                    80.993139,
                    55.0922061
                ],
                [
                    80.9937698,
                    55.0892028
                ],
                [
                    80.9922248,
                    55.0866485
                ],
                [
                    80.9864824,
                    55.079659
                ],
                [
                    80.9750197,
                    55.0711896
                ],
                [
                    80.9687548,
                    55.0674708
                ],
                [
                    80.9558205,
                    55.0663078
                ],
                [
                    80.9542952,
                    55.0595456
                ],
                [
                    80.9310105,
                    55.0585513
                ],
                [
                    80.9304177,
                    55.0631775
                ],
                [
                    80.938125,
                    55.0676334
                ],
                [
                    80.934716,
                    55.0699248
                ],
                [
                    80.9341972,
                    55.0729374
                ],
                [
                    80.93605,
                    55.0820587
                ],
                [
                    80.9325245,
                    55.0859075
                ],
                [
                    80.9133466,
                    55.0977939
                ]
            ],
            "longitude": 80.970459,
            "latitude": 55.09
        },
        "5938": {
            "name": "ОРДЫНСКОЕ",
            "population": 9616,
            "type": "town",
            "poly": [
                [
                    81.8432633,
                    54.3572095
                ],
                [
                    81.8714346,
                    54.3586877
                ],
                [
                    81.8749399,
                    54.3719324
                ],
                [
                    81.8948026,
                    54.3728672
                ],
                [
                    81.8978477,
                    54.3740691
                ],
                [
                    81.8988066,
                    54.3746735
                ],
                [
                    81.899712,
                    54.3744602
                ],
                [
                    81.9020923,
                    54.374472
                ],
                [
                    81.9030485,
                    54.3747861
                ],
                [
                    81.9052051,
                    54.3749638
                ],
                [
                    81.9063156,
                    54.3741795
                ],
                [
                    81.9064549,
                    54.3738416
                ],
                [
                    81.9066351,
                    54.3736245
                ],
                [
                    81.9073981,
                    54.3733287
                ],
                [
                    81.9080086,
                    54.3730671
                ],
                [
                    81.9101673,
                    54.3725197
                ],
                [
                    81.9106605,
                    54.372448
                ],
                [
                    81.9122272,
                    54.3724139
                ],
                [
                    81.9127268,
                    54.37204
                ],
                [
                    81.9130516,
                    54.3718684
                ],
                [
                    81.9142655,
                    54.3714679
                ],
                [
                    81.9145793,
                    54.3713035
                ],
                [
                    81.9158203,
                    54.3712625
                ],
                [
                    81.9161109,
                    54.3699423
                ],
                [
                    81.9182688,
                    54.368945
                ],
                [
                    81.9229141,
                    54.3662577
                ],
                [
                    81.9335584,
                    54.3609141
                ],
                [
                    81.9362717,
                    54.3613712
                ],
                [
                    81.9408507,
                    54.3629278
                ],
                [
                    81.9442539,
                    54.3600828
                ],
                [
                    81.9322592,
                    54.3589323
                ],
                [
                    81.9285952,
                    54.3591548
                ],
                [
                    81.9184168,
                    54.3597615
                ],
                [
                    81.9157856,
                    54.3609932
                ],
                [
                    81.9105246,
                    54.3617351
                ],
                [
                    81.8795273,
                    54.3548
                ],
                [
                    81.8704331,
                    54.3472934
                ],
                [
                    81.8654654,
                    54.3455265
                ],
                [
                    81.8609594,
                    54.3446705
                ],
                [
                    81.8500135,
                    54.3425511
                ],
                [
                    81.8432633,
                    54.3572095
                ]
            ],
            "longitude": 81.904022,
            "latitude": 54.366676
        },
        "5939": {
            "name": "КОЧЕНЁВО",
            "population": 16768,
            "type": "town",
            "poly": [
                [
                    82.1621789,
                    55.0104537
                ],
                [
                    82.1784184,
                    55.0261605
                ],
                [
                    82.209219,
                    55.0450539
                ],
                [
                    82.2335391,
                    55.0410371
                ],
                [
                    82.23044,
                    55.017661
                ],
                [
                    82.2485673,
                    55.0078004
                ],
                [
                    82.2436928,
                    55.000491
                ],
                [
                    82.2260201,
                    55.0045139
                ],
                [
                    82.1898232,
                    54.9884112
                ],
                [
                    82.1621789,
                    55.0104537
                ]
            ],
            "longitude": 82.207718,
            "latitude": 55.021442
        },
        "5940": {
            "name": "СУЗУН",
            "population": 15550,
            "type": "town",
            "poly": [
                [
                    82.22768,
                    53.753806
                ],
                [
                    82.2723003,
                    53.7790416
                ],
                [
                    82.262028,
                    53.787055
                ],
                [
                    82.2677259,
                    53.7898996
                ],
                [
                    82.2650776,
                    53.792507
                ],
                [
                    82.29766,
                    53.8052573
                ],
                [
                    82.2815293,
                    53.8096645
                ],
                [
                    82.2997465,
                    53.8171982
                ],
                [
                    82.3155562,
                    53.8260096
                ],
                [
                    82.3367394,
                    53.8170707
                ],
                [
                    82.3389898,
                    53.8153504
                ],
                [
                    82.3489411,
                    53.8059681
                ],
                [
                    82.3381873,
                    53.7932655
                ],
                [
                    82.3501449,
                    53.79227
                ],
                [
                    82.3600962,
                    53.7862964
                ],
                [
                    82.3135499,
                    53.7596419
                ],
                [
                    82.2880297,
                    53.7759117
                ],
                [
                    82.2783994,
                    53.7712638
                ],
                [
                    82.2716582,
                    53.7633423
                ],
                [
                    82.2410821,
                    53.7483964
                ],
                [
                    82.2381128,
                    53.7486811
                ],
                [
                    82.22768,
                    53.753806
                ]
            ],
            "longitude": 82.316231,
            "latitude": 53.783924
        },
        "5941": {
            "name": "КРИВОДАНОВКА",
            "population": 10051,
            "type": "town",
            "poly": null,
            "longitude": 82.6440062,
            "latitude": 55.0859006
        },
        "5942": {
            "name": "ОБЬ",
            "population": 28913,
            "type": "town",
            "poly": [
                [
                    82.6050146,
                    55.0111041
                ],
                [
                    82.6410079,
                    55.0156485
                ],
                [
                    82.6525458,
                    55.0178253
                ],
                [
                    82.6534728,
                    55.0153962
                ],
                [
                    82.676288,
                    55.0174394
                ],
                [
                    82.6718421,
                    55.0205803
                ],
                [
                    82.682701,
                    55.0221794
                ],
                [
                    82.6854761,
                    55.0215569
                ],
                [
                    82.6919154,
                    55.0192328
                ],
                [
                    82.6957873,
                    55.0164029
                ],
                [
                    82.7037856,
                    55.0104278
                ],
                [
                    82.7072407,
                    55.0078464
                ],
                [
                    82.7122468,
                    55.0037806
                ],
                [
                    82.7223083,
                    54.9983662
                ],
                [
                    82.7243359,
                    54.9966779
                ],
                [
                    82.7264785,
                    54.9947021
                ],
                [
                    82.7378377,
                    54.9958497
                ],
                [
                    82.7524563,
                    54.9928392
                ],
                [
                    82.7522001,
                    54.9921719
                ],
                [
                    82.751713,
                    54.9908711
                ],
                [
                    82.75184,
                    54.989138
                ],
                [
                    82.7521094,
                    54.9874003
                ],
                [
                    82.7405576,
                    54.9899588
                ],
                [
                    82.7379937,
                    54.9907554
                ],
                [
                    82.7357559,
                    54.9898307
                ],
                [
                    82.7340586,
                    54.9885231
                ],
                [
                    82.7310055,
                    54.9870086
                ],
                [
                    82.7267758,
                    54.9857313
                ],
                [
                    82.7228641,
                    54.9850342
                ],
                [
                    82.7212994,
                    54.9846255
                ],
                [
                    82.7180238,
                    54.983713
                ],
                [
                    82.7134457,
                    54.9816158
                ],
                [
                    82.7110838,
                    54.9802152
                ],
                [
                    82.7094478,
                    54.9794498
                ],
                [
                    82.7078812,
                    54.9787168
                ],
                [
                    82.7028461,
                    54.9768828
                ],
                [
                    82.699772,
                    54.9773754
                ],
                [
                    82.6989134,
                    54.9823575
                ],
                [
                    82.6835621,
                    54.9831981
                ],
                [
                    82.6669667,
                    54.9843142
                ],
                [
                    82.666196,
                    54.9851233
                ],
                [
                    82.6651072,
                    54.989838
                ],
                [
                    82.666873,
                    54.9903356
                ],
                [
                    82.6666506,
                    54.9913405
                ],
                [
                    82.6651903,
                    54.9920983
                ],
                [
                    82.6601155,
                    54.9915561
                ],
                [
                    82.6606446,
                    54.9934262
                ],
                [
                    82.6151585,
                    54.9949417
                ],
                [
                    82.6148949,
                    55.0028038
                ],
                [
                    82.6177337,
                    55.0076468
                ],
                [
                    82.6066741,
                    55.00714
                ],
                [
                    82.6050146,
                    55.0111041
                ]
            ],
            "longitude": 82.6933946,
            "latitude": 54.9951335
        },
        "5943": {
            "name": "КОЛЫВАНЬ",
            "population": 12513,
            "type": "town",
            "poly": [
                [
                    82.706699,
                    55.3075269
                ],
                [
                    82.7070836,
                    55.3107091
                ],
                [
                    82.7137325,
                    55.3180811
                ],
                [
                    82.7168646,
                    55.3213796
                ],
                [
                    82.7192549,
                    55.3216297
                ],
                [
                    82.72328,
                    55.3225755
                ],
                [
                    82.7239806,
                    55.3228803
                ],
                [
                    82.7289947,
                    55.326327
                ],
                [
                    82.7355337,
                    55.3247248
                ],
                [
                    82.7368388,
                    55.3241777
                ],
                [
                    82.7417567,
                    55.3252641
                ],
                [
                    82.7507272,
                    55.3250843
                ],
                [
                    82.7520598,
                    55.325647
                ],
                [
                    82.7538731,
                    55.3257721
                ],
                [
                    82.757802,
                    55.325225
                ],
                [
                    82.757802,
                    55.3256158
                ],
                [
                    82.7582141,
                    55.3270069
                ],
                [
                    82.7585987,
                    55.3276164
                ],
                [
                    82.7590246,
                    55.3280932
                ],
                [
                    82.7590521,
                    55.3287183
                ],
                [
                    82.7599587,
                    55.3286089
                ],
                [
                    82.7600686,
                    55.3290466
                ],
                [
                    82.7605357,
                    55.3290466
                ],
                [
                    82.761044,
                    55.3289293
                ],
                [
                    82.7611539,
                    55.3291481
                ],
                [
                    82.7617583,
                    55.3290466
                ],
                [
                    82.7621155,
                    55.3299765
                ],
                [
                    82.7625688,
                    55.3302656
                ],
                [
                    82.762926,
                    55.3302422
                ],
                [
                    82.7631458,
                    55.330164
                ],
                [
                    82.7640937,
                    55.3307892
                ],
                [
                    82.7644371,
                    55.3309142
                ],
                [
                    82.764808,
                    55.3308048
                ],
                [
                    82.7650828,
                    55.3308986
                ],
                [
                    82.7665115,
                    55.3302969
                ],
                [
                    82.7662092,
                    55.3288277
                ],
                [
                    82.7682836,
                    55.3267412
                ],
                [
                    82.7684759,
                    55.3264442
                ],
                [
                    82.7683523,
                    55.3262332
                ],
                [
                    82.7680913,
                    55.32603
                ],
                [
                    82.7669923,
                    55.325436
                ],
                [
                    82.7657971,
                    55.324631
                ],
                [
                    82.7656872,
                    55.3243966
                ],
                [
                    82.7658383,
                    55.3241074
                ],
                [
                    82.7661955,
                    55.3240448
                ],
                [
                    82.7662367,
                    55.3238026
                ],
                [
                    82.7661406,
                    55.3236306
                ],
                [
                    82.7658109,
                    55.3235368
                ],
                [
                    82.76544,
                    55.3232945
                ],
                [
                    82.7655636,
                    55.3230679
                ],
                [
                    82.766223,
                    55.3226927
                ],
                [
                    82.7675143,
                    55.3216923
                ],
                [
                    82.7676105,
                    55.3214265
                ],
                [
                    82.7684484,
                    55.3204651
                ],
                [
                    82.7712578,
                    55.3197199
                ],
                [
                    82.7716534,
                    55.3188394
                ],
                [
                    82.7717677,
                    55.318009
                ],
                [
                    82.7705632,
                    55.3170785
                ],
                [
                    82.7698852,
                    55.3162971
                ],
                [
                    82.7686214,
                    55.3141161
                ],
                [
                    82.7678658,
                    55.3131936
                ],
                [
                    82.7678933,
                    55.3117864
                ],
                [
                    82.7691846,
                    55.3106214
                ],
                [
                    82.7698715,
                    55.3087294
                ],
                [
                    82.7698715,
                    55.3072907
                ],
                [
                    82.7696929,
                    55.3063602
                ],
                [
                    82.7689648,
                    55.3050701
                ],
                [
                    82.7679757,
                    55.3040301
                ],
                [
                    82.7662036,
                    55.3029744
                ],
                [
                    82.76472,
                    55.3023019
                ],
                [
                    82.763882,
                    55.3018171
                ],
                [
                    82.7626868,
                    55.3010038
                ],
                [
                    82.762728,
                    55.3008552
                ],
                [
                    82.7622335,
                    55.3003625
                ],
                [
                    82.7603377,
                    55.299643
                ],
                [
                    82.7588953,
                    55.2992676
                ],
                [
                    82.757343,
                    55.2990643
                ],
                [
                    82.7564088,
                    55.2987671
                ],
                [
                    82.7562028,
                    55.2986029
                ],
                [
                    82.7551862,
                    55.2984465
                ],
                [
                    82.7549252,
                    55.2982431
                ],
                [
                    82.7544444,
                    55.2982431
                ],
                [
                    82.7524113,
                    55.2972577
                ],
                [
                    82.7509689,
                    55.2963739
                ],
                [
                    82.7503232,
                    55.2958108
                ],
                [
                    82.7502133,
                    55.295365
                ],
                [
                    82.7505018,
                    55.2952868
                ],
                [
                    82.7501996,
                    55.2943795
                ],
                [
                    82.7498836,
                    55.2941918
                ],
                [
                    82.7495814,
                    55.2938476
                ],
                [
                    82.7490181,
                    55.2934644
                ],
                [
                    82.7486747,
                    55.293394
                ],
                [
                    82.7482076,
                    55.2934565
                ],
                [
                    82.7477543,
                    55.293613
                ],
                [
                    82.7456388,
                    55.2945985
                ],
                [
                    82.7438804,
                    55.295365
                ],
                [
                    82.7433171,
                    55.2956935
                ],
                [
                    82.7424012,
                    55.2965868
                ],
                [
                    82.7414621,
                    55.2967549
                ],
                [
                    82.7402815,
                    55.296709
                ],
                [
                    82.7392351,
                    55.2964646
                ],
                [
                    82.7387254,
                    55.2961591
                ],
                [
                    82.7378668,
                    55.2955939
                ],
                [
                    82.7370082,
                    55.2939288
                ],
                [
                    82.7380009,
                    55.2938677
                ],
                [
                    82.7372228,
                    55.2930275
                ],
                [
                    82.7359081,
                    55.2923706
                ],
                [
                    82.7333055,
                    55.291897
                ],
                [
                    82.7283955,
                    55.2909803
                ],
                [
                    82.7272954,
                    55.2905831
                ],
                [
                    82.7247197,
                    55.2893761
                ],
                [
                    82.7223049,
                    55.2882608
                ],
                [
                    82.7214195,
                    55.2875427
                ],
                [
                    82.7207558,
                    55.2871338
                ],
                [
                    82.7198079,
                    55.2869226
                ],
                [
                    82.7174039,
                    55.2869226
                ],
                [
                    82.7162225,
                    55.2868991
                ],
                [
                    82.7152471,
                    55.2866097
                ],
                [
                    82.7149037,
                    55.2863672
                ],
                [
                    82.713249,
                    55.2875399
                ],
                [
                    82.7097542,
                    55.289968
                ],
                [
                    82.709919,
                    55.2900494
                ],
                [
                    82.7094464,
                    55.2904061
                ],
                [
                    82.7100729,
                    55.2910694
                ],
                [
                    82.711018,
                    55.2914073
                ],
                [
                    82.7123148,
                    55.2915199
                ],
                [
                    82.7130951,
                    55.2915324
                ],
                [
                    82.7151612,
                    55.2919251
                ],
                [
                    82.7166311,
                    55.2920424
                ],
                [
                    82.7179361,
                    55.2923553
                ],
                [
                    82.7192137,
                    55.2931453
                ],
                [
                    82.7198731,
                    55.2935364
                ],
                [
                    82.7209996,
                    55.2944515
                ],
                [
                    82.7213705,
                    55.2946862
                ],
                [
                    82.720244,
                    55.2946001
                ],
                [
                    82.7181972,
                    55.2954214
                ],
                [
                    82.717002,
                    55.2970716
                ],
                [
                    82.7142683,
                    55.2990268
                ],
                [
                    82.7105729,
                    55.2997698
                ],
                [
                    82.7096113,
                    55.3003094
                ],
                [
                    82.7089931,
                    55.3013339
                ],
                [
                    82.7084436,
                    55.3038284
                ],
                [
                    82.706699,
                    55.3075269
                ]
            ],
            "longitude": 82.7433464,
            "latitude": 55.3068791
        },
        "5944": {
            "name": "КРАСНООБСК",
            "population": 22913,
            "type": "town",
            "poly": [
                [
                    82.9645175,
                    54.9259775
                ],
                [
                    82.9653905,
                    54.9321824
                ],
                [
                    82.9918873,
                    54.9324018
                ],
                [
                    82.9971234,
                    54.9296689
                ],
                [
                    83.0002492,
                    54.9183763
                ],
                [
                    82.9966025,
                    54.9174425
                ],
                [
                    82.996747,
                    54.91119
                ],
                [
                    82.994611,
                    54.9078483
                ],
                [
                    82.9941787,
                    54.9071719
                ],
                [
                    82.9901724,
                    54.9071594
                ],
                [
                    82.9777366,
                    54.9111087
                ],
                [
                    82.9763386,
                    54.9228126
                ],
                [
                    82.9752435,
                    54.9225137
                ],
                [
                    82.9744586,
                    54.9235707
                ],
                [
                    82.9761592,
                    54.9243146
                ],
                [
                    82.9760207,
                    54.925474
                ],
                [
                    82.9651393,
                    54.9254903
                ],
                [
                    82.9645175,
                    54.9259775
                ]
            ],
            "longitude": 82.9905861,
            "latitude": 54.9211081
        },
        "5945": {
            "name": "КОЛЬЦОВО",
            "population": 15531,
            "type": "town",
            "poly": [
                [
                    83.1535461,
                    54.9146678
                ],
                [
                    83.1535878,
                    54.915387
                ],
                [
                    83.1539595,
                    54.9156891
                ],
                [
                    83.153823,
                    54.9162586
                ],
                [
                    83.1543867,
                    54.9190666
                ],
                [
                    83.1557368,
                    54.9235828
                ],
                [
                    83.1558411,
                    54.9313412
                ],
                [
                    83.1624618,
                    54.9438894
                ],
                [
                    83.1702231,
                    54.9446536
                ],
                [
                    83.1720156,
                    54.9450992
                ],
                [
                    83.1811778,
                    54.9455657
                ],
                [
                    83.191568,
                    54.9464265
                ],
                [
                    83.194971,
                    54.9467426
                ],
                [
                    83.1979759,
                    54.9472208
                ],
                [
                    83.1999212,
                    54.948326
                ],
                [
                    83.1982383,
                    54.9492924
                ],
                [
                    83.2004264,
                    54.9505628
                ],
                [
                    83.1995032,
                    54.9511709
                ],
                [
                    83.2017388,
                    54.9528029
                ],
                [
                    83.2032088,
                    54.9532829
                ],
                [
                    83.2054447,
                    54.953386
                ],
                [
                    83.2058501,
                    54.9533461
                ],
                [
                    83.2085661,
                    54.9515385
                ],
                [
                    83.2089062,
                    54.9513122
                ],
                [
                    83.2120469,
                    54.9493066
                ],
                [
                    83.2141192,
                    54.9475638
                ],
                [
                    83.209838,
                    54.9440791
                ],
                [
                    83.2158142,
                    54.9416867
                ],
                [
                    83.2187235,
                    54.9409968
                ],
                [
                    83.2247024,
                    54.9427446
                ],
                [
                    83.2233678,
                    54.9442011
                ],
                [
                    83.228279,
                    54.9455195
                ],
                [
                    83.2257167,
                    54.9490147
                ],
                [
                    83.2292933,
                    54.9499804
                ],
                [
                    83.230788,
                    54.9487541
                ],
                [
                    83.2318023,
                    54.9484628
                ],
                [
                    83.2340444,
                    54.9483095
                ],
                [
                    83.2381236,
                    54.9482373
                ],
                [
                    83.2388402,
                    54.9482663
                ],
                [
                    83.239687,
                    54.9482812
                ],
                [
                    83.2423765,
                    54.9486203
                ],
                [
                    83.2442106,
                    54.94914
                ],
                [
                    83.2447979,
                    54.949293
                ],
                [
                    83.2463013,
                    54.948231
                ],
                [
                    83.2480178,
                    54.9465985
                ],
                [
                    83.2487394,
                    54.945217
                ],
                [
                    83.2499201,
                    54.9443379
                ],
                [
                    83.2501716,
                    54.942184
                ],
                [
                    83.2495921,
                    54.9401995
                ],
                [
                    83.2482802,
                    54.9384348
                ],
                [
                    83.2474275,
                    54.9376497
                ],
                [
                    83.2436732,
                    54.934444
                ],
                [
                    83.2403785,
                    54.9322875
                ],
                [
                    83.236625,
                    54.9295558
                ],
                [
                    83.2226895,
                    54.9251329
                ],
                [
                    83.2173155,
                    54.9226943
                ],
                [
                    83.215689,
                    54.9217116
                ],
                [
                    83.2144378,
                    54.9218315
                ],
                [
                    83.2117686,
                    54.9201537
                ],
                [
                    83.2080986,
                    54.9180444
                ],
                [
                    83.2032608,
                    54.9139693
                ],
                [
                    83.2038029,
                    54.9129624
                ],
                [
                    83.1985481,
                    54.9093903
                ],
                [
                    83.2022839,
                    54.9014778
                ],
                [
                    83.2015749,
                    54.8998231
                ],
                [
                    83.2009032,
                    54.9000191
                ],
                [
                    83.2011854,
                    54.9004852
                ],
                [
                    83.2003826,
                    54.9009076
                ],
                [
                    83.1990672,
                    54.9007602
                ],
                [
                    83.1978885,
                    54.901713
                ],
                [
                    83.1966927,
                    54.9017032
                ],
                [
                    83.1953774,
                    54.9043157
                ],
                [
                    83.1919729,
                    54.9054263
                ],
                [
                    83.1910675,
                    54.9054361
                ],
                [
                    83.1892429,
                    54.9042765
                ],
                [
                    83.186897,
                    54.902628
                ],
                [
                    83.1543249,
                    54.9050714
                ],
                [
                    83.1542134,
                    54.9116233
                ],
                [
                    83.1548807,
                    54.9124384
                ],
                [
                    83.1539215,
                    54.9137329
                ],
                [
                    83.1535461,
                    54.9146678
                ]
            ],
            "longitude": 83.187139,
            "latitude": 54.9367736
        },
        "5946": {
            "name": "ИСКИТИМ",
            "population": 57416,
            "type": "town",
            "poly": [
                [
                    83.2205289,
                    54.6930904
                ],
                [
                    83.2227717,
                    54.6927258
                ],
                [
                    83.2264862,
                    54.6968978
                ],
                [
                    83.2311118,
                    54.6976268
                ],
                [
                    83.2550809,
                    54.6944271
                ],
                [
                    83.2615988,
                    54.6958852
                ],
                [
                    83.2681869,
                    54.6864874
                ],
                [
                    83.2777232,
                    54.6858536
                ],
                [
                    83.2811434,
                    54.6846544
                ],
                [
                    83.2815919,
                    54.681251
                ],
                [
                    83.2870866,
                    54.6797923
                ],
                [
                    83.2903385,
                    54.6743786
                ],
                [
                    83.298372,
                    54.6726019
                ],
                [
                    83.3025865,
                    54.6689644
                ],
                [
                    83.3124015,
                    54.6675173
                ],
                [
                    83.3211379,
                    54.6671304
                ],
                [
                    83.323189,
                    54.6722532
                ],
                [
                    83.3250113,
                    54.6723086
                ],
                [
                    83.3284163,
                    54.6704229
                ],
                [
                    83.3282244,
                    54.6680656
                ],
                [
                    83.3356495,
                    54.6672616
                ],
                [
                    83.3385831,
                    54.6676218
                ],
                [
                    83.3416043,
                    54.6676496
                ],
                [
                    83.3463605,
                    54.6664694
                ],
                [
                    83.3472199,
                    54.666512
                ],
                [
                    83.3514806,
                    54.6651738
                ],
                [
                    83.3519664,
                    54.6642585
                ],
                [
                    83.3520431,
                    54.655515
                ],
                [
                    83.3546006,
                    54.6493963
                ],
                [
                    83.3668295,
                    54.6449011
                ],
                [
                    83.3600024,
                    54.6409308
                ],
                [
                    83.3448327,
                    54.6433908
                ],
                [
                    83.3417482,
                    54.643891
                ],
                [
                    83.342669,
                    54.6456004
                ],
                [
                    83.3363393,
                    54.6472746
                ],
                [
                    83.3267059,
                    54.6421815
                ],
                [
                    83.325151,
                    54.6392758
                ],
                [
                    83.332809,
                    54.6384328
                ],
                [
                    83.3327141,
                    54.6380818
                ],
                [
                    83.3339446,
                    54.6377448
                ],
                [
                    83.3329596,
                    54.6291568
                ],
                [
                    83.3289574,
                    54.6282898
                ],
                [
                    83.32881,
                    54.6274938
                ],
                [
                    83.3253234,
                    54.6276928
                ],
                [
                    83.3259847,
                    54.6269408
                ],
                [
                    83.3235466,
                    54.6272465
                ],
                [
                    83.3254462,
                    54.6249352
                ],
                [
                    83.3252006,
                    54.6242955
                ],
                [
                    83.3232363,
                    54.6240254
                ],
                [
                    83.3231872,
                    54.6235137
                ],
                [
                    83.3222672,
                    54.6233236
                ],
                [
                    83.3223727,
                    54.6223138
                ],
                [
                    83.3227007,
                    54.6212987
                ],
                [
                    83.3244563,
                    54.6173655
                ],
                [
                    83.3247205,
                    54.6168099
                ],
                [
                    83.3247387,
                    54.6157262
                ],
                [
                    83.324129,
                    54.6134343
                ],
                [
                    83.324001,
                    54.6108928
                ],
                [
                    83.323791,
                    54.6085759
                ],
                [
                    83.3237624,
                    54.6075996
                ],
                [
                    83.3262635,
                    54.6071605
                ],
                [
                    83.3304551,
                    54.6078311
                ],
                [
                    83.3344329,
                    54.6078738
                ],
                [
                    83.3396594,
                    54.6073212
                ],
                [
                    83.3433041,
                    54.6078767
                ],
                [
                    83.3495384,
                    54.6115428
                ],
                [
                    83.3503057,
                    54.6019602
                ],
                [
                    83.3539504,
                    54.5748944
                ],
                [
                    83.3412899,
                    54.572476
                ],
                [
                    83.3402828,
                    54.5698906
                ],
                [
                    83.3337127,
                    54.567861
                ],
                [
                    83.3298762,
                    54.5656368
                ],
                [
                    83.3304517,
                    54.5625783
                ],
                [
                    83.3316986,
                    54.5616607
                ],
                [
                    83.3320822,
                    54.5599644
                ],
                [
                    83.3293786,
                    54.5558972
                ],
                [
                    83.2995989,
                    54.6068548
                ],
                [
                    83.2893711,
                    54.6046798
                ],
                [
                    83.2854658,
                    54.608607
                ],
                [
                    83.2734457,
                    54.6148312
                ],
                [
                    83.2706493,
                    54.6165876
                ],
                [
                    83.2679311,
                    54.6188758
                ],
                [
                    83.2638281,
                    54.623891
                ],
                [
                    83.2754434,
                    54.6376762
                ],
                [
                    83.2778506,
                    54.6392756
                ],
                [
                    83.2826363,
                    54.6424924
                ],
                [
                    83.2839018,
                    54.6450858
                ],
                [
                    83.284557,
                    54.6478799
                ],
                [
                    83.2846885,
                    54.6483649
                ],
                [
                    83.2848571,
                    54.6489355
                ],
                [
                    83.283919,
                    54.650101
                ],
                [
                    83.2831693,
                    54.6504266
                ],
                [
                    83.2847929,
                    54.6506634
                ],
                [
                    83.2870987,
                    54.6514436
                ],
                [
                    83.2891107,
                    54.6525251
                ],
                [
                    83.2790504,
                    54.6567751
                ],
                [
                    83.2677113,
                    54.6555606
                ],
                [
                    83.259054,
                    54.6560116
                ],
                [
                    83.2472651,
                    54.6712045
                ],
                [
                    83.2468218,
                    54.6726163
                ],
                [
                    83.2461753,
                    54.6729698
                ],
                [
                    83.2431743,
                    54.6747335
                ],
                [
                    83.2364134,
                    54.6785857
                ],
                [
                    83.2307826,
                    54.6819137
                ],
                [
                    83.2240474,
                    54.6854702
                ],
                [
                    83.2219571,
                    54.6870963
                ],
                [
                    83.2209495,
                    54.6885129
                ],
                [
                    83.2205289,
                    54.6930904
                ]
            ],
            "longitude": 83.3035676,
            "latitude": 54.6426269
        },
        "5947": {
            "name": "ПОСЕВНАЯ",
            "population": 4324,
            "type": "town",
            "poly": null,
            "longitude": 83.329704,
            "latitude": 54.300575
        },
        "5948": {
            "name": "ЧЕРЕПАНОВО",
            "population": 19570,
            "type": "town",
            "poly": [
                [
                    83.3142907,
                    54.2252198
                ],
                [
                    83.3301673,
                    54.2258065
                ],
                [
                    83.339292,
                    54.2338212
                ],
                [
                    83.3511984,
                    54.2481419
                ],
                [
                    83.3560492,
                    54.2578212
                ],
                [
                    83.3733019,
                    54.2594143
                ],
                [
                    83.3774741,
                    54.2508208
                ],
                [
                    83.4095886,
                    54.2300202
                ],
                [
                    83.4129599,
                    54.2140701
                ],
                [
                    83.405817,
                    54.2087757
                ],
                [
                    83.3875326,
                    54.1954384
                ],
                [
                    83.3853427,
                    54.1953672
                ],
                [
                    83.3811759,
                    54.2010785
                ],
                [
                    83.3744238,
                    54.1994239
                ],
                [
                    83.3692837,
                    54.2007583
                ],
                [
                    83.3518256,
                    54.2021282
                ],
                [
                    83.3253532,
                    54.2181277
                ],
                [
                    83.3197958,
                    54.2214857
                ],
                [
                    83.3142907,
                    54.2252198
                ]
            ],
            "longitude": 83.370468,
            "latitude": 54.226101
        },
        "5949": {
            "name": "ЛИНЁВО",
            "population": 18728,
            "type": "town",
            "poly": [
                [
                    83.3480993,
                    54.4326394
                ],
                [
                    83.3561084,
                    54.4422458
                ],
                [
                    83.3624276,
                    54.4508905
                ],
                [
                    83.3627395,
                    54.4532421
                ],
                [
                    83.3633463,
                    54.4576789
                ],
                [
                    83.3634568,
                    54.4598086
                ],
                [
                    83.3667259,
                    54.4594574
                ],
                [
                    83.3674343,
                    54.459468
                ],
                [
                    83.368059,
                    54.4592635
                ],
                [
                    83.3685516,
                    54.4592124
                ],
                [
                    83.3688683,
                    54.4594374
                ],
                [
                    83.3676652,
                    54.4612709
                ],
                [
                    83.3691065,
                    54.4616547
                ],
                [
                    83.3686341,
                    54.4624683
                ],
                [
                    83.371899,
                    54.4636883
                ],
                [
                    83.3728395,
                    54.4637805
                ],
                [
                    83.3756338,
                    54.4605075
                ],
                [
                    83.3922958,
                    54.4666202
                ],
                [
                    83.3949652,
                    54.4660766
                ],
                [
                    83.3958382,
                    54.466103
                ],
                [
                    83.396798,
                    54.4652815
                ],
                [
                    83.3988919,
                    54.4646122
                ],
                [
                    83.3986476,
                    54.4637095
                ],
                [
                    83.3993805,
                    54.4593482
                ],
                [
                    83.3964664,
                    54.4584353
                ],
                [
                    83.3955416,
                    54.4563051
                ],
                [
                    83.3927671,
                    54.4561022
                ],
                [
                    83.395402,
                    54.4554226
                ],
                [
                    83.394006,
                    54.4525415
                ],
                [
                    83.3928014,
                    54.4521263
                ],
                [
                    83.3877067,
                    54.4503705
                ],
                [
                    83.3862409,
                    54.4514864
                ],
                [
                    83.3809885,
                    54.4491226
                ],
                [
                    83.3787898,
                    54.4465962
                ],
                [
                    83.3654931,
                    54.4499444
                ],
                [
                    83.3596638,
                    54.4385575
                ],
                [
                    83.3589061,
                    54.4366257
                ],
                [
                    83.3554256,
                    54.4361258
                ],
                [
                    83.3542652,
                    54.4351509
                ],
                [
                    83.3507653,
                    54.4319062
                ],
                [
                    83.3480993,
                    54.4326394
                ]
            ],
            "longitude": 83.379074,
            "latitude": 54.456459
        },
        "5950": {
            "name": "МОШКОВО",
            "population": 9682,
            "type": "town",
            "poly": [
                [
                    83.5819206,
                    55.2985536
                ],
                [
                    83.5857831,
                    55.3062
                ],
                [
                    83.5906744,
                    55.3112477
                ],
                [
                    83.5930331,
                    55.3123685
                ],
                [
                    83.594437,
                    55.3134337
                ],
                [
                    83.5958412,
                    55.3144992
                ],
                [
                    83.5998733,
                    55.3156465
                ],
                [
                    83.6059936,
                    55.3163021
                ],
                [
                    83.6172504,
                    55.3208346
                ],
                [
                    83.6225953,
                    55.3180371
                ],
                [
                    83.6265144,
                    55.3162201
                ],
                [
                    83.6345008,
                    55.3150631
                ],
                [
                    83.6344176,
                    55.3114309
                ],
                [
                    83.6363449,
                    55.3104908
                ],
                [
                    83.6341422,
                    55.3092894
                ],
                [
                    83.6344347,
                    55.3067952
                ],
                [
                    83.6363908,
                    55.3048753
                ],
                [
                    83.6348667,
                    55.3038853
                ],
                [
                    83.6334998,
                    55.3029423
                ],
                [
                    83.6344635,
                    55.3022631
                ],
                [
                    83.6336426,
                    55.2999505
                ],
                [
                    83.6309215,
                    55.2968376
                ],
                [
                    83.6272344,
                    55.2931456
                ],
                [
                    83.6205381,
                    55.2915057
                ],
                [
                    83.616506,
                    55.2959743
                ],
                [
                    83.6127618,
                    55.2965072
                ],
                [
                    83.5995853,
                    55.2939246
                ],
                [
                    83.5887129,
                    55.2906038
                ],
                [
                    83.5869531,
                    55.2930069
                ],
                [
                    83.5860095,
                    55.2941118
                ],
                [
                    83.5855151,
                    55.2963229
                ],
                [
                    83.5819206,
                    55.2985536
                ]
            ],
            "longitude": 83.611855,
            "latitude": 55.304806
        },
        "5951": {
            "name": "СТАНЦИОННО-ОЯШИНСКИЙ",
            "population": 4856,
            "type": "town",
            "poly": [
                [
                    83.8027612,
                    55.4687243
                ],
                [
                    83.8028843,
                    55.46902
                ],
                [
                    83.8039626,
                    55.4697076
                ],
                [
                    83.8039684,
                    55.4700365
                ],
                [
                    83.8036873,
                    55.4703445
                ],
                [
                    83.8034719,
                    55.4709364
                ],
                [
                    83.8035547,
                    55.471378
                ],
                [
                    83.8036203,
                    55.4717535
                ],
                [
                    83.8041242,
                    55.4720425
                ],
                [
                    83.8041123,
                    55.4722052
                ],
                [
                    83.8039016,
                    55.4724378
                ],
                [
                    83.8036144,
                    55.4729427
                ],
                [
                    83.8033858,
                    55.4736569
                ],
                [
                    83.80338,
                    55.4740853
                ],
                [
                    83.8039067,
                    55.4742478
                ],
                [
                    83.8040239,
                    55.4743807
                ],
                [
                    83.805196,
                    55.4739024
                ],
                [
                    83.8065673,
                    55.4749254
                ],
                [
                    83.8078781,
                    55.4755036
                ],
                [
                    83.8121347,
                    55.475882
                ],
                [
                    83.8123808,
                    55.4749786
                ],
                [
                    83.8136935,
                    55.4746265
                ],
                [
                    83.8163073,
                    55.4750848
                ],
                [
                    83.8169989,
                    55.475138
                ],
                [
                    83.8179365,
                    55.4755631
                ],
                [
                    83.8194837,
                    55.4756495
                ],
                [
                    83.819847,
                    55.4755897
                ],
                [
                    83.8207495,
                    55.4760281
                ],
                [
                    83.8202103,
                    55.4763071
                ],
                [
                    83.8217458,
                    55.4780873
                ],
                [
                    83.8231054,
                    55.4774895
                ],
                [
                    83.8234336,
                    55.4771175
                ],
                [
                    83.8257074,
                    55.478353
                ],
                [
                    83.823293,
                    55.4793228
                ],
                [
                    83.8217106,
                    55.4797546
                ],
                [
                    83.8251244,
                    55.4821866
                ],
                [
                    83.8281015,
                    55.4810774
                ],
                [
                    83.8301242,
                    55.4802383
                ],
                [
                    83.829505,
                    55.4793494
                ],
                [
                    83.8363124,
                    55.4759764
                ],
                [
                    83.8396201,
                    55.4770312
                ],
                [
                    83.8391864,
                    55.4756628
                ],
                [
                    83.8390809,
                    55.4745534
                ],
                [
                    83.8384714,
                    55.4742345
                ],
                [
                    83.8395732,
                    55.4731716
                ],
                [
                    83.8419995,
                    55.4715073
                ],
                [
                    83.8374024,
                    55.4692998
                ],
                [
                    83.8385237,
                    55.4692239
                ],
                [
                    83.8439895,
                    55.4660906
                ],
                [
                    83.843676,
                    55.4654859
                ],
                [
                    83.8408043,
                    55.4629788
                ],
                [
                    83.833067,
                    55.4568207
                ],
                [
                    83.8277825,
                    55.451674
                ],
                [
                    83.823812,
                    55.4525204
                ],
                [
                    83.8233863,
                    55.4524479
                ],
                [
                    83.8215206,
                    55.4508085
                ],
                [
                    83.819416,
                    55.449202
                ],
                [
                    83.8168479,
                    55.4488714
                ],
                [
                    83.8125526,
                    55.4480343
                ],
                [
                    83.8036966,
                    55.4485895
                ],
                [
                    83.8036309,
                    55.4500376
                ],
                [
                    83.8031667,
                    55.4531443
                ],
                [
                    83.8028352,
                    55.4534592
                ],
                [
                    83.8029452,
                    55.4538683
                ],
                [
                    83.8042173,
                    55.4547359
                ],
                [
                    83.8052487,
                    55.45558
                ],
                [
                    83.805854,
                    55.4558602
                ],
                [
                    83.8080401,
                    55.4574144
                ],
                [
                    83.8091672,
                    55.458077
                ],
                [
                    83.8096705,
                    55.4582789
                ],
                [
                    83.809776,
                    55.4581792
                ],
                [
                    83.8106375,
                    55.4584417
                ],
                [
                    83.8110858,
                    55.4581875
                ],
                [
                    83.8113243,
                    55.4579732
                ],
                [
                    83.811751,
                    55.4582556
                ],
                [
                    83.8120528,
                    55.4584001
                ],
                [
                    83.8124337,
                    55.4585048
                ],
                [
                    83.812416,
                    55.458553
                ],
                [
                    83.8129172,
                    55.4587241
                ],
                [
                    83.8124044,
                    55.4594086
                ],
                [
                    83.8117334,
                    55.4593754
                ],
                [
                    83.8122707,
                    55.4599757
                ],
                [
                    83.8126888,
                    55.4606527
                ],
                [
                    83.8121189,
                    55.4607648
                ],
                [
                    83.811862,
                    55.461559
                ],
                [
                    83.8109628,
                    55.4618033
                ],
                [
                    83.8107431,
                    55.4616576
                ],
                [
                    83.8090488,
                    55.4621784
                ],
                [
                    83.8097527,
                    55.4626844
                ],
                [
                    83.8070452,
                    55.4634951
                ],
                [
                    83.8048534,
                    55.464555
                ],
                [
                    83.8051404,
                    55.4649404
                ],
                [
                    83.8051933,
                    55.4656646
                ],
                [
                    83.8050526,
                    55.4669038
                ],
                [
                    83.8032125,
                    55.4676491
                ],
                [
                    83.8027612,
                    55.4687243
                ]
            ],
            "longitude": 83.82135,
            "latitude": 55.465
        },
        "5952": {
            "name": "МАСЛЯНИНО",
            "population": 12799,
            "type": "town",
            "poly": [
                [
                    84.1383015,
                    54.3449199
                ],
                [
                    84.1427032,
                    54.3455687
                ],
                [
                    84.1438162,
                    54.3472791
                ],
                [
                    84.1484203,
                    54.34607
                ],
                [
                    84.1500898,
                    54.3481933
                ],
                [
                    84.1644079,
                    54.3482817
                ],
                [
                    84.1622828,
                    54.3494023
                ],
                [
                    84.1706309,
                    54.354356
                ],
                [
                    84.187372,
                    54.3591178
                ],
                [
                    84.186234,
                    54.3628252
                ],
                [
                    84.1995801,
                    54.3707814
                ],
                [
                    84.2139091,
                    54.3646637
                ],
                [
                    84.2241515,
                    54.3596303
                ],
                [
                    84.2364631,
                    54.3608359
                ],
                [
                    84.2499127,
                    54.3695158
                ],
                [
                    84.2561719,
                    54.3665323
                ],
                [
                    84.2331007,
                    54.3489585
                ],
                [
                    84.2365666,
                    54.3497122
                ],
                [
                    84.2371873,
                    54.3491092
                ],
                [
                    84.2357389,
                    54.3429883
                ],
                [
                    84.2395151,
                    54.3450991
                ],
                [
                    84.2431362,
                    54.3457021
                ],
                [
                    84.2469641,
                    54.3450388
                ],
                [
                    84.2481022,
                    54.3421741
                ],
                [
                    84.244895,
                    54.3412393
                ],
                [
                    84.24355,
                    54.3399727
                ],
                [
                    84.2374459,
                    54.3313771
                ],
                [
                    84.2409118,
                    54.3293863
                ],
                [
                    84.2376011,
                    54.3274859
                ],
                [
                    84.2379115,
                    54.3267016
                ],
                [
                    84.2468607,
                    54.3160212
                ],
                [
                    84.2412739,
                    54.3136374
                ],
                [
                    84.2364631,
                    54.3186463
                ],
                [
                    84.2338249,
                    54.3166851
                ],
                [
                    84.2289624,
                    54.3183144
                ],
                [
                    84.2316005,
                    54.320698
                ],
                [
                    84.2269449,
                    54.3225082
                ],
                [
                    84.2248757,
                    54.3211204
                ],
                [
                    84.2193924,
                    54.3192196
                ],
                [
                    84.2119952,
                    54.3185558
                ],
                [
                    84.2100812,
                    54.3218445
                ],
                [
                    84.2156679,
                    54.3223574
                ],
                [
                    84.2194442,
                    54.3258871
                ],
                [
                    84.2165991,
                    54.3277876
                ],
                [
                    84.2132884,
                    54.3263396
                ],
                [
                    84.2072361,
                    54.3337599
                ],
                [
                    84.2059946,
                    54.3363537
                ],
                [
                    84.2014424,
                    54.3387966
                ],
                [
                    84.1979765,
                    54.3381633
                ],
                [
                    84.1947693,
                    54.340606
                ],
                [
                    84.1875272,
                    54.3399426
                ],
                [
                    84.1864408,
                    54.3407568
                ],
                [
                    84.1804921,
                    54.3401235
                ],
                [
                    84.1782677,
                    54.3405155
                ],
                [
                    84.1726809,
                    54.3358109
                ],
                [
                    84.1703531,
                    54.3349965
                ],
                [
                    84.1684909,
                    54.3359013
                ],
                [
                    84.1708187,
                    54.3407266
                ],
                [
                    84.1571622,
                    54.340033
                ],
                [
                    84.1489372,
                    54.3404854
                ],
                [
                    84.1488855,
                    54.3398823
                ],
                [
                    84.1409709,
                    54.3383744
                ],
                [
                    84.1387466,
                    54.3416313
                ],
                [
                    84.1383015,
                    54.3449199
                ]
            ],
            "longitude": 84.21067,
            "latitude": 54.345501
        },
        "5953": {
            "name": "БОЛОТНОЕ",
            "population": 15739,
            "type": "town",
            "poly": [
                [
                    84.3456599,
                    55.652691
                ],
                [
                    84.3485826,
                    55.6530427
                ],
                [
                    84.3493426,
                    55.6532306
                ],
                [
                    84.3499066,
                    55.6542083
                ],
                [
                    84.3522977,
                    55.6552105
                ],
                [
                    84.3522715,
                    55.6556453
                ],
                [
                    84.3527788,
                    55.6558156
                ],
                [
                    84.3521266,
                    55.6563743
                ],
                [
                    84.3510517,
                    55.6559451
                ],
                [
                    84.3508096,
                    55.6561896
                ],
                [
                    84.3499312,
                    55.6569465
                ],
                [
                    84.3503403,
                    55.6570925
                ],
                [
                    84.351309,
                    55.6563729
                ],
                [
                    84.3532677,
                    55.6572371
                ],
                [
                    84.3539765,
                    55.6573575
                ],
                [
                    84.3559435,
                    55.6581761
                ],
                [
                    84.355807,
                    55.6586932
                ],
                [
                    84.3558678,
                    55.6593642
                ],
                [
                    84.3566248,
                    55.6609998
                ],
                [
                    84.3582266,
                    55.6646291
                ],
                [
                    84.3591322,
                    55.6656164
                ],
                [
                    84.3590442,
                    55.6673063
                ],
                [
                    84.359546,
                    55.6686468
                ],
                [
                    84.3613732,
                    55.6700151
                ],
                [
                    84.3631015,
                    55.6714955
                ],
                [
                    84.3627258,
                    55.6716352
                ],
                [
                    84.3631443,
                    55.6719964
                ],
                [
                    84.3638551,
                    55.6717548
                ],
                [
                    84.3640417,
                    55.6719249
                ],
                [
                    84.3639036,
                    55.672756
                ],
                [
                    84.3641597,
                    55.6732898
                ],
                [
                    84.3642641,
                    55.6740537
                ],
                [
                    84.3645161,
                    55.6741546
                ],
                [
                    84.3659019,
                    55.6741237
                ],
                [
                    84.366474,
                    55.6740129
                ],
                [
                    84.3666448,
                    55.6741959
                ],
                [
                    84.3667046,
                    55.6745089
                ],
                [
                    84.3688823,
                    55.6751976
                ],
                [
                    84.3695228,
                    55.6747738
                ],
                [
                    84.3700095,
                    55.6748364
                ],
                [
                    84.3707012,
                    55.6750675
                ],
                [
                    84.3711453,
                    55.6749183
                ],
                [
                    84.3719737,
                    55.6751735
                ],
                [
                    84.3731266,
                    55.6753131
                ],
                [
                    84.374253,
                    55.6756468
                ],
                [
                    84.3745112,
                    55.6754319
                ],
                [
                    84.3755559,
                    55.6758439
                ],
                [
                    84.376208,
                    55.6760856
                ],
                [
                    84.3759604,
                    55.6762899
                ],
                [
                    84.3759416,
                    55.6764434
                ],
                [
                    84.3759609,
                    55.6764976
                ],
                [
                    84.376837,
                    55.6769803
                ],
                [
                    84.3764886,
                    55.6772506
                ],
                [
                    84.3770135,
                    55.6776163
                ],
                [
                    84.3780855,
                    55.6784659
                ],
                [
                    84.3785491,
                    55.6785639
                ],
                [
                    84.3794474,
                    55.6792419
                ],
                [
                    84.3808236,
                    55.6795278
                ],
                [
                    84.3813163,
                    55.6795278
                ],
                [
                    84.3817944,
                    55.6796667
                ],
                [
                    84.3819752,
                    55.680166
                ],
                [
                    84.3791051,
                    55.6816898
                ],
                [
                    84.3779888,
                    55.6821379
                ],
                [
                    84.3804489,
                    55.6833006
                ],
                [
                    84.379475,
                    55.6839928
                ],
                [
                    84.3792147,
                    55.6841778
                ],
                [
                    84.3790054,
                    55.6843266
                ],
                [
                    84.3810536,
                    55.6852424
                ],
                [
                    84.3812751,
                    55.6853415
                ],
                [
                    84.3819097,
                    55.6856252
                ],
                [
                    84.3821453,
                    55.6854577
                ],
                [
                    84.3824859,
                    55.685565
                ],
                [
                    84.3822905,
                    55.6858026
                ],
                [
                    84.3819462,
                    55.68603
                ],
                [
                    84.3813559,
                    55.6859202
                ],
                [
                    84.3810604,
                    55.6857198
                ],
                [
                    84.3804638,
                    55.6856426
                ],
                [
                    84.379898,
                    55.6858357
                ],
                [
                    84.3792876,
                    55.6861919
                ],
                [
                    84.3772775,
                    55.6871325
                ],
                [
                    84.3789748,
                    55.6881079
                ],
                [
                    84.3814562,
                    55.6871024
                ],
                [
                    84.3818694,
                    55.6873753
                ],
                [
                    84.3823417,
                    55.6871756
                ],
                [
                    84.3827208,
                    55.6869729
                ],
                [
                    84.383045,
                    55.687134
                ],
                [
                    84.3832113,
                    55.6870644
                ],
                [
                    84.3835813,
                    55.6872289
                ],
                [
                    84.3843368,
                    55.6875716
                ],
                [
                    84.3841924,
                    55.6878594
                ],
                [
                    84.3839566,
                    55.6880919
                ],
                [
                    84.3854343,
                    55.6886127
                ],
                [
                    84.3859765,
                    55.688279
                ],
                [
                    84.3868653,
                    55.6885949
                ],
                [
                    84.3893197,
                    55.6895624
                ],
                [
                    84.3922574,
                    55.6870881
                ],
                [
                    84.3934479,
                    55.6875362
                ],
                [
                    84.399278,
                    55.6890913
                ],
                [
                    84.4014028,
                    55.6871667
                ],
                [
                    84.4035342,
                    55.6857311
                ],
                [
                    84.4058209,
                    55.6852569
                ],
                [
                    84.4064016,
                    55.6861138
                ],
                [
                    84.4082038,
                    55.6866751
                ],
                [
                    84.4098178,
                    55.6872287
                ],
                [
                    84.4103388,
                    55.6875223
                ],
                [
                    84.4109032,
                    55.687419
                ],
                [
                    84.4111328,
                    55.6877197
                ],
                [
                    84.412079,
                    55.6875711
                ],
                [
                    84.4133969,
                    55.6879254
                ],
                [
                    84.4145864,
                    55.6880283
                ],
                [
                    84.4149717,
                    55.686691
                ],
                [
                    84.4149379,
                    55.6862872
                ],
                [
                    84.4146524,
                    55.685805
                ],
                [
                    84.4173339,
                    55.6861613
                ],
                [
                    84.4194538,
                    55.6854488
                ],
                [
                    84.4189073,
                    55.684924
                ],
                [
                    84.4197194,
                    55.6841025
                ],
                [
                    84.4187025,
                    55.6831417
                ],
                [
                    84.4204338,
                    55.6825063
                ],
                [
                    84.4193693,
                    55.6812243
                ],
                [
                    84.4173259,
                    55.6794429
                ],
                [
                    84.4166598,
                    55.6794958
                ],
                [
                    84.4158144,
                    55.678605
                ],
                [
                    84.41701,
                    55.6781717
                ],
                [
                    84.4166513,
                    55.6776757
                ],
                [
                    84.4173088,
                    55.677435
                ],
                [
                    84.417992,
                    55.6775698
                ],
                [
                    84.4186196,
                    55.6783787
                ],
                [
                    84.4189784,
                    55.6784726
                ],
                [
                    84.419922,
                    55.6784991
                ],
                [
                    84.4212158,
                    55.678723
                ],
                [
                    84.4215019,
                    55.6783547
                ],
                [
                    84.4217069,
                    55.6786388
                ],
                [
                    84.4226548,
                    55.6788217
                ],
                [
                    84.4227628,
                    55.6786445
                ],
                [
                    84.4271347,
                    55.6792233
                ],
                [
                    84.4272706,
                    55.6792438
                ],
                [
                    84.4272347,
                    55.6793919
                ],
                [
                    84.4279931,
                    55.6794997
                ],
                [
                    84.4280399,
                    55.6793693
                ],
                [
                    84.4294723,
                    55.6795372
                ],
                [
                    84.4304059,
                    55.6791722
                ],
                [
                    84.4326775,
                    55.6794695
                ],
                [
                    84.4325453,
                    55.6797681
                ],
                [
                    84.4344656,
                    55.6802379
                ],
                [
                    84.4355163,
                    55.680129
                ],
                [
                    84.4381692,
                    55.6805017
                ],
                [
                    84.4391427,
                    55.6778246
                ],
                [
                    84.4326797,
                    55.6773065
                ],
                [
                    84.4327926,
                    55.6769039
                ],
                [
                    84.4266399,
                    55.6763351
                ],
                [
                    84.4254322,
                    55.6760286
                ],
                [
                    84.4220506,
                    55.6756064
                ],
                [
                    84.422533,
                    55.6745378
                ],
                [
                    84.423222,
                    55.6730117
                ],
                [
                    84.4234092,
                    55.6725094
                ],
                [
                    84.4235391,
                    55.6721399
                ],
                [
                    84.4235693,
                    55.6716291
                ],
                [
                    84.4234062,
                    55.6711166
                ],
                [
                    84.4232319,
                    55.6706764
                ],
                [
                    84.4242041,
                    55.670547
                ],
                [
                    84.4233483,
                    55.6682669
                ],
                [
                    84.4257584,
                    55.6682199
                ],
                [
                    84.4264613,
                    55.6647549
                ],
                [
                    84.4216424,
                    55.6644651
                ],
                [
                    84.4214783,
                    55.6657699
                ],
                [
                    84.4205705,
                    55.6657623
                ],
                [
                    84.4167958,
                    55.6657249
                ],
                [
                    84.4159746,
                    55.6655359
                ],
                [
                    84.415092,
                    55.6651077
                ],
                [
                    84.4143789,
                    55.6646304
                ],
                [
                    84.4133626,
                    55.6641632
                ],
                [
                    84.4121244,
                    55.6637923
                ],
                [
                    84.4103427,
                    55.6630999
                ],
                [
                    84.410095,
                    55.6628976
                ],
                [
                    84.4082961,
                    55.6621511
                ],
                [
                    84.4079701,
                    55.6620846
                ],
                [
                    84.4074236,
                    55.6617747
                ],
                [
                    84.4068529,
                    55.6616384
                ],
                [
                    84.4061142,
                    55.6612829
                ],
                [
                    84.4053061,
                    55.6612371
                ],
                [
                    84.4048492,
                    55.6610396
                ],
                [
                    84.4042258,
                    55.660989
                ],
                [
                    84.404045,
                    55.6613479
                ],
                [
                    84.4027143,
                    55.6620916
                ],
                [
                    84.4011842,
                    55.6613382
                ],
                [
                    84.402079,
                    55.6607335
                ],
                [
                    84.401925,
                    55.6605087
                ],
                [
                    84.4014623,
                    55.6602942
                ],
                [
                    84.400698,
                    55.660063
                ],
                [
                    84.399733,
                    55.6598799
                ],
                [
                    84.3989808,
                    55.6597732
                ],
                [
                    84.3986478,
                    55.660031
                ],
                [
                    84.3972643,
                    55.6600141
                ],
                [
                    84.396278,
                    55.6596865
                ],
                [
                    84.3960047,
                    55.6598696
                ],
                [
                    84.3955794,
                    55.6597764
                ],
                [
                    84.3947038,
                    55.6595755
                ],
                [
                    84.3941159,
                    55.6599314
                ],
                [
                    84.3919596,
                    55.6588764
                ],
                [
                    84.3907598,
                    55.658609
                ],
                [
                    84.3904096,
                    55.6586404
                ],
                [
                    84.390384,
                    55.6585127
                ],
                [
                    84.3901321,
                    55.6582935
                ],
                [
                    84.3895342,
                    55.6580382
                ],
                [
                    84.3907962,
                    55.6564838
                ],
                [
                    84.3958928,
                    55.6576829
                ],
                [
                    84.3968347,
                    55.6563612
                ],
                [
                    84.3975111,
                    55.6565111
                ],
                [
                    84.3988154,
                    55.6549303
                ],
                [
                    84.4005787,
                    55.655087
                ],
                [
                    84.4017864,
                    55.65538
                ],
                [
                    84.400313,
                    55.6571788
                ],
                [
                    84.4031149,
                    55.6581599
                ],
                [
                    84.4038637,
                    55.6572878
                ],
                [
                    84.402197,
                    55.6567427
                ],
                [
                    84.4029458,
                    55.6556934
                ],
                [
                    84.402796,
                    55.6545834
                ],
                [
                    84.4016657,
                    55.6542149
                ],
                [
                    84.3988588,
                    55.6539633
                ],
                [
                    84.3986705,
                    55.6542217
                ],
                [
                    84.3965449,
                    55.6537038
                ],
                [
                    84.3971246,
                    55.6530088
                ],
                [
                    84.3948541,
                    55.6524365
                ],
                [
                    84.3986705,
                    55.6477072
                ],
                [
                    84.4003613,
                    55.6475982
                ],
                [
                    84.4000956,
                    55.6466168
                ],
                [
                    84.3963759,
                    55.6468621
                ],
                [
                    84.3964283,
                    55.647573
                ],
                [
                    84.3954501,
                    55.6476207
                ],
                [
                    84.3951198,
                    55.6485114
                ],
                [
                    84.3962792,
                    55.6487703
                ],
                [
                    84.3940329,
                    55.6511349
                ],
                [
                    84.3928177,
                    55.6524238
                ],
                [
                    84.3919705,
                    55.652167
                ],
                [
                    84.3889298,
                    55.6556609
                ],
                [
                    84.3899234,
                    55.6560989
                ],
                [
                    84.3886523,
                    55.6577246
                ],
                [
                    84.3873287,
                    55.6572862
                ],
                [
                    84.3868631,
                    55.6572477
                ],
                [
                    84.3855737,
                    55.6567731
                ],
                [
                    84.3843995,
                    55.6563636
                ],
                [
                    84.3813806,
                    55.6562913
                ],
                [
                    84.3809948,
                    55.6562213
                ],
                [
                    84.380807,
                    55.6565143
                ],
                [
                    84.3792068,
                    55.656487
                ],
                [
                    84.3771236,
                    55.6564856
                ],
                [
                    84.376245,
                    55.6550443
                ],
                [
                    84.3769096,
                    55.6549185
                ],
                [
                    84.3774772,
                    55.6544143
                ],
                [
                    84.3769217,
                    55.6542644
                ],
                [
                    84.3734446,
                    55.6532297
                ],
                [
                    84.373133,
                    55.6535429
                ],
                [
                    84.3709853,
                    55.6529406
                ],
                [
                    84.3708654,
                    55.6530652
                ],
                [
                    84.3702194,
                    55.6528914
                ],
                [
                    84.3699779,
                    55.6531027
                ],
                [
                    84.3658407,
                    55.6519531
                ],
                [
                    84.3661225,
                    55.6516158
                ],
                [
                    84.3646198,
                    55.651252
                ],
                [
                    84.3613319,
                    55.6511171
                ],
                [
                    84.3592713,
                    55.6476488
                ],
                [
                    84.3602327,
                    55.6474853
                ],
                [
                    84.3607595,
                    55.6467644
                ],
                [
                    84.3627483,
                    55.6471658
                ],
                [
                    84.3632224,
                    55.6464374
                ],
                [
                    84.3583625,
                    55.6451591
                ],
                [
                    84.3571903,
                    55.6466975
                ],
                [
                    84.3578225,
                    55.6477603
                ],
                [
                    84.3584547,
                    55.6476786
                ],
                [
                    84.360581,
                    55.6512407
                ],
                [
                    84.3567414,
                    55.6498238
                ],
                [
                    84.3567755,
                    55.6500227
                ],
                [
                    84.3562752,
                    55.6500868
                ],
                [
                    84.355991,
                    55.6500419
                ],
                [
                    84.3558432,
                    55.6499008
                ],
                [
                    84.3554112,
                    55.6498879
                ],
                [
                    84.3551042,
                    55.6500804
                ],
                [
                    84.3548541,
                    55.6501253
                ],
                [
                    84.3547176,
                    55.649657
                ],
                [
                    84.3549336,
                    55.6495094
                ],
                [
                    84.3548086,
                    55.6493234
                ],
                [
                    84.3540809,
                    55.6491502
                ],
                [
                    84.353683,
                    55.6489385
                ],
                [
                    84.3529553,
                    55.6488037
                ],
                [
                    84.3524437,
                    55.648823
                ],
                [
                    84.3519662,
                    55.6487011
                ],
                [
                    84.3514576,
                    55.6484825
                ],
                [
                    84.351209,
                    55.6487606
                ],
                [
                    84.3509135,
                    55.6490752
                ],
                [
                    84.3498788,
                    55.6498515
                ],
                [
                    84.350129,
                    55.6505443
                ],
                [
                    84.3509817,
                    55.65091
                ],
                [
                    84.3515502,
                    55.65125
                ],
                [
                    84.3514855,
                    55.6513962
                ],
                [
                    84.3505633,
                    55.651996
                ],
                [
                    84.3488361,
                    55.6512055
                ],
                [
                    84.3466502,
                    55.6506944
                ],
                [
                    84.3456599,
                    55.652691
                ]
            ],
            "longitude": 84.38855,
            "latitude": 55.671566
        },
        "5954": {
            "name": "ТОГУЧИН",
            "population": 21357,
            "type": "town",
            "poly": [
                [
                    84.3212071,
                    55.247399
                ],
                [
                    84.3261987,
                    55.2534266
                ],
                [
                    84.333113,
                    55.252984
                ],
                [
                    84.3462391,
                    55.2492327
                ],
                [
                    84.3504598,
                    55.2466453
                ],
                [
                    84.3724414,
                    55.2476444
                ],
                [
                    84.3757367,
                    55.2561194
                ],
                [
                    84.3790321,
                    55.2626692
                ],
                [
                    84.3818452,
                    55.263173
                ],
                [
                    84.3886771,
                    55.2616158
                ],
                [
                    84.3903865,
                    55.2622144
                ],
                [
                    84.3939578,
                    55.2620292
                ],
                [
                    84.3941373,
                    55.2611099
                ],
                [
                    84.3954967,
                    55.2613251
                ],
                [
                    84.3960757,
                    55.2606939
                ],
                [
                    84.3954464,
                    55.2604213
                ],
                [
                    84.3956477,
                    55.2593741
                ],
                [
                    84.3962267,
                    55.2593167
                ],
                [
                    84.3962771,
                    55.2586425
                ],
                [
                    84.3997875,
                    55.2582713
                ],
                [
                    84.4029857,
                    55.2572138
                ],
                [
                    84.4051006,
                    55.2565838
                ],
                [
                    84.4080473,
                    55.255753
                ],
                [
                    84.4098156,
                    55.2591425
                ],
                [
                    84.4142362,
                    55.2590051
                ],
                [
                    84.4208269,
                    55.2554323
                ],
                [
                    84.4227182,
                    55.2553403
                ],
                [
                    84.4260158,
                    55.2552308
                ],
                [
                    84.4299683,
                    55.2568481
                ],
                [
                    84.4303366,
                    55.256626
                ],
                [
                    84.4308835,
                    55.2562963
                ],
                [
                    84.4298923,
                    55.2546099
                ],
                [
                    84.4287268,
                    55.2537291
                ],
                [
                    84.4272066,
                    55.2526027
                ],
                [
                    84.4262438,
                    55.2519095
                ],
                [
                    84.425053,
                    55.2521695
                ],
                [
                    84.4257118,
                    55.2509709
                ],
                [
                    84.4242676,
                    55.2511008
                ],
                [
                    84.422494,
                    55.2498733
                ],
                [
                    84.4211091,
                    55.249731
                ],
                [
                    84.4221396,
                    55.248998
                ],
                [
                    84.421966,
                    55.2485447
                ],
                [
                    84.4200871,
                    55.2468693
                ],
                [
                    84.4208034,
                    55.2463787
                ],
                [
                    84.4211646,
                    55.2434454
                ],
                [
                    84.4225142,
                    55.2408734
                ],
                [
                    84.4225325,
                    55.2395073
                ],
                [
                    84.4227229,
                    55.2389583
                ],
                [
                    84.4346446,
                    55.2393688
                ],
                [
                    84.4349342,
                    55.2383183
                ],
                [
                    84.4347847,
                    55.2379762
                ],
                [
                    84.4344906,
                    55.2373803
                ],
                [
                    84.4340728,
                    55.2361513
                ],
                [
                    84.4289548,
                    55.2357612
                ],
                [
                    84.4394738,
                    55.2292221
                ],
                [
                    84.4378663,
                    55.2235378
                ],
                [
                    84.4351336,
                    55.2198702
                ],
                [
                    84.4269354,
                    55.2196409
                ],
                [
                    84.416567,
                    55.2185406
                ],
                [
                    84.4136676,
                    55.2183315
                ],
                [
                    84.4095745,
                    55.2180362
                ],
                [
                    84.3951868,
                    55.2185349
                ],
                [
                    84.3903649,
                    55.2239963
                ],
                [
                    84.3808835,
                    55.2189097
                ],
                [
                    84.3808807,
                    55.2219791
                ],
                [
                    84.3797047,
                    55.2223774
                ],
                [
                    84.3761386,
                    55.2235837
                ],
                [
                    84.368503,
                    55.2210622
                ],
                [
                    84.3666014,
                    55.2217554
                ],
                [
                    84.3632072,
                    55.2230417
                ],
                [
                    84.3627262,
                    55.2236479
                ],
                [
                    84.3629979,
                    55.2243282
                ],
                [
                    84.3640396,
                    55.2246209
                ],
                [
                    84.3628168,
                    55.2250515
                ],
                [
                    84.3612424,
                    55.2263522
                ],
                [
                    84.3616485,
                    55.2271133
                ],
                [
                    84.3612316,
                    55.2299851
                ],
                [
                    84.3607608,
                    55.2327062
                ],
                [
                    84.3593143,
                    55.2325593
                ],
                [
                    84.3586357,
                    55.2326078
                ],
                [
                    84.3586643,
                    55.2330095
                ],
                [
                    84.3583382,
                    55.2332643
                ],
                [
                    84.3571305,
                    55.2330922
                ],
                [
                    84.3564058,
                    55.2337671
                ],
                [
                    84.3538607,
                    55.2322819
                ],
                [
                    84.3509652,
                    55.2346213
                ],
                [
                    84.3533949,
                    55.2351055
                ],
                [
                    84.3551405,
                    55.2356166
                ],
                [
                    84.3575938,
                    55.2360874
                ],
                [
                    84.3591506,
                    55.2366792
                ],
                [
                    84.3601414,
                    55.2373248
                ],
                [
                    84.3599411,
                    55.2376626
                ],
                [
                    84.3586789,
                    55.2373786
                ],
                [
                    84.3574522,
                    55.2378494
                ],
                [
                    84.3566974,
                    55.2375266
                ],
                [
                    84.3525221,
                    55.2386833
                ],
                [
                    84.3467408,
                    55.2373101
                ],
                [
                    84.3460048,
                    55.2381279
                ],
                [
                    84.3462124,
                    55.2391177
                ],
                [
                    84.3444758,
                    55.2406308
                ],
                [
                    84.344212,
                    55.2408607
                ],
                [
                    84.3385787,
                    55.2414672
                ],
                [
                    84.3226861,
                    55.2452702
                ],
                [
                    84.3212071,
                    55.247399
                ]
            ],
            "longitude": 84.402458,
            "latitude": 55.23769
        },
        "5955": {
            "name": "БИРЮСИНСК",
            "population": 8545,
            "type": "town",
            "poly": [
                [
                    97.7768566,
                    55.9432513
                ],
                [
                    97.7850827,
                    55.9559406
                ],
                [
                    97.8160053,
                    55.979011
                ],
                [
                    97.8261333,
                    55.9833696
                ],
                [
                    97.8535959,
                    55.9753057
                ],
                [
                    97.8617762,
                    55.9431423
                ],
                [
                    97.8524271,
                    55.9331062
                ],
                [
                    97.7768566,
                    55.9432513
                ]
            ],
            "longitude": 97.824509,
            "latitude": 55.964275
        },
        "5956": {
            "name": "ТАЙШЕТ",
            "population": 33638,
            "type": "town",
            "poly": [
                [
                    97.9600771,
                    55.9349763
                ],
                [
                    97.9619654,
                    55.9394952
                ],
                [
                    97.9736383,
                    55.9447827
                ],
                [
                    97.985483,
                    55.9518956
                ],
                [
                    97.9852417,
                    55.953404
                ],
                [
                    97.984453,
                    55.9583345
                ],
                [
                    97.995096,
                    55.9633311
                ],
                [
                    98.0007608,
                    55.9536255
                ],
                [
                    98.0136354,
                    55.9504539
                ],
                [
                    98.0253084,
                    55.9493966
                ],
                [
                    98.0338915,
                    55.9547788
                ],
                [
                    98.038202,
                    55.955851
                ],
                [
                    98.0411013,
                    55.9551632
                ],
                [
                    98.0423346,
                    55.9522196
                ],
                [
                    98.0340949,
                    55.9452598
                ],
                [
                    98.0465944,
                    55.9393991
                ],
                [
                    98.0374964,
                    55.9386299
                ],
                [
                    98.0246218,
                    55.9246865
                ],
                [
                    98.0253084,
                    55.9216087
                ],
                [
                    98.0194719,
                    55.9160294
                ],
                [
                    98.0134638,
                    55.9147788
                ],
                [
                    98.0091723,
                    55.9181458
                ],
                [
                    97.9944094,
                    55.913913
                ],
                [
                    97.9889162,
                    55.913913
                ],
                [
                    97.9617937,
                    55.929976
                ],
                [
                    97.9648836,
                    55.9320916
                ],
                [
                    97.9600771,
                    55.9349763
                ]
            ],
            "longitude": 98.005096,
            "latitude": 55.941296
        },
        "5957": {
            "name": "АЛЗАМАЙ",
            "population": 6189,
            "type": "town",
            "poly": [
                [
                    98.6294472,
                    55.5512601
                ],
                [
                    98.6400559,
                    55.5569937
                ],
                [
                    98.6458924,
                    55.56078
                ],
                [
                    98.6539605,
                    55.5648571
                ],
                [
                    98.6442101,
                    55.5711613
                ],
                [
                    98.6337044,
                    55.5749511
                ],
                [
                    98.6313355,
                    55.5773723
                ],
                [
                    98.6580803,
                    55.5738836
                ],
                [
                    98.6615479,
                    55.5719377
                ],
                [
                    98.668895,
                    55.5697103
                ],
                [
                    98.6730149,
                    55.5758245
                ],
                [
                    98.679744,
                    55.5738787
                ],
                [
                    98.6879494,
                    55.572719
                ],
                [
                    98.691417,
                    55.5715495
                ],
                [
                    98.6884644,
                    55.5669926
                ],
                [
                    98.6780274,
                    55.5553383
                ],
                [
                    98.6735299,
                    55.552236
                ],
                [
                    98.668586,
                    55.5486383
                ],
                [
                    98.6641228,
                    55.5445594
                ],
                [
                    98.6668694,
                    55.5422285
                ],
                [
                    98.6644661,
                    55.5379547
                ],
                [
                    98.6609986,
                    55.5327139
                ],
                [
                    98.6628869,
                    55.5289249
                ],
                [
                    98.6568787,
                    55.527176
                ],
                [
                    98.6485016,
                    55.5303773
                ],
                [
                    98.6513855,
                    55.5348511
                ],
                [
                    98.6479523,
                    55.538251
                ],
                [
                    98.6473,
                    55.5438796
                ],
                [
                    98.6549904,
                    55.54437
                ],
                [
                    98.6500122,
                    55.5469922
                ],
                [
                    98.6409485,
                    55.5481527
                ],
                [
                    98.6294472,
                    55.5512601
                ]
            ],
            "longitude": 98.665497,
            "latitude": 55.554932
        },
        "5958": {
            "name": "НИЖНЕУДИНСК",
            "population": 34235,
            "type": "town",
            "poly": [
                [
                    98.9895119,
                    54.9054495
                ],
                [
                    98.9979233,
                    54.9079661
                ],
                [
                    99.0037169,
                    54.9110499
                ],
                [
                    99.00921,
                    54.9135415
                ],
                [
                    99.0029873,
                    54.9190421
                ],
                [
                    99.0119995,
                    54.9259723
                ],
                [
                    99.0177502,
                    54.9244187
                ],
                [
                    99.0309681,
                    54.9202507
                ],
                [
                    99.0379034,
                    54.9165734
                ],
                [
                    99.0475481,
                    54.9142455
                ],
                [
                    99.0544074,
                    54.9057021
                ],
                [
                    99.0693773,
                    54.8958504
                ],
                [
                    99.0434135,
                    54.8834103
                ],
                [
                    99.0257754,
                    54.8731393
                ],
                [
                    99.0092959,
                    54.8782998
                ],
                [
                    99.0083024,
                    54.879361
                ],
                [
                    98.99552,
                    54.8930123
                ],
                [
                    98.9895119,
                    54.9054495
                ]
            ],
            "longitude": 99.0311721,
            "latitude": 54.9075638
        },
        "5959": {
            "name": "ОКТЯБРЬСКИЙ",
            "population": 5074,
            "type": "town",
            "poly": null,
            "longitude": 99.4161715,
            "latitude": 56.0724249
        },
        "5960": {
            "name": "ЛЕСОГОРСК",
            "population": 5095,
            "type": "town",
            "poly": [
                [
                    99.4609751,
                    56.0482728
                ],
                [
                    99.4812312,
                    56.0499026
                ],
                [
                    99.4807162,
                    56.0513406
                ],
                [
                    99.4894709,
                    56.0511488
                ],
                [
                    99.4944491,
                    56.051053
                ],
                [
                    99.4999423,
                    56.0522033
                ],
                [
                    99.5062937,
                    56.0539288
                ],
                [
                    99.5136752,
                    56.0557501
                ],
                [
                    99.519855,
                    56.0571878
                ],
                [
                    99.5256914,
                    56.0584339
                ],
                [
                    99.5313563,
                    56.0596799
                ],
                [
                    99.5373644,
                    56.0607341
                ],
                [
                    99.5423426,
                    56.0623634
                ],
                [
                    99.5464625,
                    56.0637051
                ],
                [
                    99.5521273,
                    56.066005
                ],
                [
                    99.5560755,
                    56.0686881
                ],
                [
                    99.5571055,
                    56.0659092
                ],
                [
                    99.5560755,
                    56.0625551
                ],
                [
                    99.5538439,
                    56.0594882
                ],
                [
                    99.5536723,
                    56.0565169
                ],
                [
                    99.5538439,
                    56.0531619
                ],
                [
                    99.5505824,
                    56.0522033
                ],
                [
                    99.5423426,
                    56.0529702
                ],
                [
                    99.5366778,
                    56.0522033
                ],
                [
                    99.5359912,
                    56.0500943
                ],
                [
                    99.5438876,
                    56.0469306
                ],
                [
                    99.5438876,
                    56.0456842
                ],
                [
                    99.5387377,
                    56.0428077
                ],
                [
                    99.5366778,
                    56.0408899
                ],
                [
                    99.5316996,
                    56.0385885
                ],
                [
                    99.5286097,
                    56.0369582
                ],
                [
                    99.5263781,
                    56.0362869
                ],
                [
                    99.5167651,
                    56.0367664
                ],
                [
                    99.508697,
                    56.03715
                ],
                [
                    99.4989123,
                    56.0387803
                ],
                [
                    99.4947924,
                    56.0396434
                ],
                [
                    99.4896426,
                    56.0384926
                ],
                [
                    99.4850077,
                    56.0383967
                ],
                [
                    99.4798579,
                    56.0412735
                ],
                [
                    99.4735064,
                    56.043383
                ],
                [
                    99.4609751,
                    56.0482728
                ]
            ],
            "longitude": 99.5145428,
            "latitude": 56.0508793
        },
        "5961": {
            "name": "ЧУНСКИЙ",
            "population": 14267,
            "type": "town",
            "poly": [
                [
                    99.6022984,
                    56.0853642
                ],
                [
                    99.6022984,
                    56.087184
                ],
                [
                    99.6110532,
                    56.0879502
                ],
                [
                    99.6096799,
                    56.0909191
                ],
                [
                    99.6115681,
                    56.0912064
                ],
                [
                    99.6115681,
                    56.0936004
                ],
                [
                    99.6069333,
                    56.0946538
                ],
                [
                    99.6120831,
                    56.1003987
                ],
                [
                    99.616203,
                    56.1020263
                ],
                [
                    99.6148297,
                    56.1058556
                ],
                [
                    99.6314809,
                    56.108536
                ],
                [
                    99.6340558,
                    56.1057599
                ],
                [
                    99.649677,
                    56.1029837
                ],
                [
                    99.6474454,
                    56.1059514
                ],
                [
                    99.6508786,
                    56.1067172
                ],
                [
                    99.6532819,
                    56.1050898
                ],
                [
                    99.6610065,
                    56.1058556
                ],
                [
                    99.6824643,
                    56.1070044
                ],
                [
                    99.6843526,
                    56.1040368
                ],
                [
                    99.6829793,
                    56.1035581
                ],
                [
                    99.6893307,
                    56.1013561
                ],
                [
                    99.692764,
                    56.0969518
                ],
                [
                    99.6907041,
                    56.094941
                ],
                [
                    99.6907041,
                    56.0931216
                ],
                [
                    99.6934506,
                    56.0917809
                ],
                [
                    99.6931073,
                    56.0876629
                ],
                [
                    99.6852109,
                    56.0876629
                ],
                [
                    99.6783444,
                    56.0868967
                ],
                [
                    99.6757695,
                    56.0842149
                ],
                [
                    99.6807477,
                    56.0831612
                ],
                [
                    99.6872707,
                    56.0799044
                ],
                [
                    99.682636,
                    56.0788507
                ],
                [
                    99.6846959,
                    56.0756893
                ],
                [
                    99.6713063,
                    56.0749228
                ],
                [
                    99.6616933,
                    56.0783717
                ],
                [
                    99.6546551,
                    56.0816287
                ],
                [
                    99.628906,
                    56.0791381
                ],
                [
                    99.6220395,
                    56.080096
                ],
                [
                    99.6146581,
                    56.080096
                ],
                [
                    99.6134564,
                    56.0820118
                ],
                [
                    99.6098515,
                    56.0812455
                ],
                [
                    99.60453,
                    56.081916
                ],
                [
                    99.6022984,
                    56.0853642
                ]
            ],
            "longitude": 99.633705,
            "latitude": 56.091248
        },
        "5962": {
            "name": "ТУЛУН",
            "population": 42029,
            "type": "town",
            "poly": [
                [
                    100.5301166,
                    54.5776541
                ],
                [
                    100.5388713,
                    54.5828275
                ],
                [
                    100.5388713,
                    54.5919788
                ],
                [
                    100.5359531,
                    54.6016252
                ],
                [
                    100.5357814,
                    54.6032162
                ],
                [
                    100.5447078,
                    54.6070939
                ],
                [
                    100.5548358,
                    54.6058014
                ],
                [
                    100.569942,
                    54.5981448
                ],
                [
                    100.6132006,
                    54.588796
                ],
                [
                    100.625732,
                    54.5880002
                ],
                [
                    100.6307101,
                    54.5820316
                ],
                [
                    100.6171489,
                    54.5742711
                ],
                [
                    100.6082225,
                    54.57248
                ],
                [
                    100.6123424,
                    54.5658125
                ],
                [
                    100.6543994,
                    54.5418202
                ],
                [
                    100.6574893,
                    54.5347493
                ],
                [
                    100.6538844,
                    54.5217993
                ],
                [
                    100.644443,
                    54.5230944
                ],
                [
                    100.6245303,
                    54.5294701
                ],
                [
                    100.6123424,
                    54.5301674
                ],
                [
                    100.5972362,
                    54.5300678
                ],
                [
                    100.5888248,
                    54.5337532
                ],
                [
                    100.5744052,
                    54.5318608
                ],
                [
                    100.5438494,
                    54.5495869
                ],
                [
                    100.5426479,
                    54.5542661
                ],
                [
                    100.5448794,
                    54.5547638
                ],
                [
                    100.5386996,
                    54.562329
                ],
                [
                    100.5311465,
                    54.5711864
                ],
                [
                    100.5301166,
                    54.5776541
                ]
            ],
            "longitude": 100.579216,
            "latitude": 54.562096
        },
        "5963": {
            "name": "ВИХОРЕВКА",
            "population": 21597,
            "type": "town",
            "poly": [
                [
                    101.1235838,
                    56.1256711
                ],
                [
                    101.1254779,
                    56.1256252
                ],
                [
                    101.127532,
                    56.1255755
                ],
                [
                    101.1314802,
                    56.1253841
                ],
                [
                    101.1330251,
                    56.1293068
                ],
                [
                    101.1350851,
                    56.1311245
                ],
                [
                    101.1395483,
                    56.1299765
                ],
                [
                    101.1426381,
                    56.1294981
                ],
                [
                    101.1443548,
                    56.1321768
                ],
                [
                    101.1515646,
                    56.1316028
                ],
                [
                    101.1531095,
                    56.1330378
                ],
                [
                    101.1527662,
                    56.1353336
                ],
                [
                    101.1567144,
                    56.142507
                ],
                [
                    101.1584309,
                    56.1445154
                ],
                [
                    101.1608343,
                    56.1455673
                ],
                [
                    101.1616926,
                    56.1434634
                ],
                [
                    101.1627226,
                    56.1405942
                ],
                [
                    101.1635809,
                    56.1382988
                ],
                [
                    101.1634092,
                    56.1370553
                ],
                [
                    101.1654691,
                    56.1369597
                ],
                [
                    101.1689023,
                    56.1394465
                ],
                [
                    101.169589,
                    56.1407855
                ],
                [
                    101.1728506,
                    56.1434634
                ],
                [
                    101.1757688,
                    56.147193
                ],
                [
                    101.1778288,
                    56.1461411
                ],
                [
                    101.1805753,
                    56.1453761
                ],
                [
                    101.1840086,
                    56.1447066
                ],
                [
                    101.1853819,
                    56.1431765
                ],
                [
                    101.1881284,
                    56.1413594
                ],
                [
                    101.1905316,
                    56.1412637
                ],
                [
                    101.1898451,
                    56.1400204
                ],
                [
                    101.1881284,
                    56.1382988
                ],
                [
                    101.1895016,
                    56.1366727
                ],
                [
                    101.1927633,
                    56.134377
                ],
                [
                    101.1925916,
                    56.1324638
                ],
                [
                    101.1941365,
                    56.1300721
                ],
                [
                    101.1968832,
                    56.1272977
                ],
                [
                    101.1968832,
                    56.1256711
                ],
                [
                    101.1955099,
                    56.12481
                ],
                [
                    101.1973982,
                    56.1218438
                ],
                [
                    101.197913,
                    56.1201213
                ],
                [
                    101.2004881,
                    56.11993
                ],
                [
                    101.203063,
                    56.1194515
                ],
                [
                    101.204093,
                    56.1179203
                ],
                [
                    101.2066679,
                    56.1160063
                ],
                [
                    101.2077498,
                    56.1154741
                ],
                [
                    101.2095861,
                    56.1145707
                ],
                [
                    101.2113027,
                    56.1135179
                ],
                [
                    101.214221,
                    56.1123694
                ],
                [
                    101.2173109,
                    56.1114123
                ],
                [
                    101.2171392,
                    56.1089236
                ],
                [
                    101.2166242,
                    56.1074878
                ],
                [
                    101.2161092,
                    56.1059561
                ],
                [
                    101.2125044,
                    56.1061476
                ],
                [
                    101.2075262,
                    56.1064348
                ],
                [
                    101.2032346,
                    56.107392
                ],
                [
                    101.1987715,
                    56.1088279
                ],
                [
                    101.1943083,
                    56.1086364
                ],
                [
                    101.1893301,
                    56.1098808
                ],
                [
                    101.1853819,
                    56.1109337
                ],
                [
                    101.1814337,
                    56.112178
                ],
                [
                    101.1764555,
                    56.1112208
                ],
                [
                    101.1721639,
                    56.1111251
                ],
                [
                    101.1680441,
                    56.1133265
                ],
                [
                    101.1639242,
                    56.1158149
                ],
                [
                    101.1604909,
                    56.1169633
                ],
                [
                    101.1563711,
                    56.117059
                ],
                [
                    101.1505346,
                    56.1171547
                ],
                [
                    101.1462431,
                    56.1187816
                ],
                [
                    101.1433248,
                    56.1206955
                ],
                [
                    101.1407499,
                    56.1218438
                ],
                [
                    101.1378317,
                    56.1216524
                ],
                [
                    101.1328535,
                    56.1221308
                ],
                [
                    101.1321667,
                    56.1208869
                ],
                [
                    101.1287336,
                    56.1204084
                ],
                [
                    101.1247853,
                    56.1206955
                ],
                [
                    101.1239271,
                    56.1224179
                ],
                [
                    101.1235838,
                    56.1256711
                ]
            ],
            "longitude": 101.171951,
            "latitude": 56.124722
        },
        "5964": {
            "name": "КУЙТУН",
            "population": 9588,
            "type": "town",
            "poly": [
                [
                    101.4045885,
                    54.3485258
                ],
                [
                    101.4278816,
                    54.4040871
                ],
                [
                    101.5942612,
                    54.4157067
                ],
                [
                    101.6752326,
                    54.3956931
                ],
                [
                    101.6741234,
                    54.3368872
                ],
                [
                    101.4833415,
                    54.2948313
                ],
                [
                    101.4045885,
                    54.3485258
                ]
            ],
            "longitude": 101.506195,
            "latitude": 54.344154
        },
        "5965": {
            "name": "ЗИМА",
            "population": 31440,
            "type": "town",
            "poly": [
                [
                    101.9903867,
                    53.9238273
                ],
                [
                    102.0062577,
                    53.9356837
                ],
                [
                    102.0237127,
                    53.9491202
                ],
                [
                    102.026639,
                    53.948076
                ],
                [
                    102.0312567,
                    53.9450346
                ],
                [
                    102.0350443,
                    53.946708
                ],
                [
                    102.0335396,
                    53.949108
                ],
                [
                    102.0380111,
                    53.9498829
                ],
                [
                    102.0340953,
                    53.9584363
                ],
                [
                    102.0347594,
                    53.9585584
                ],
                [
                    102.033704,
                    53.960654
                ],
                [
                    102.0332875,
                    53.9605915
                ],
                [
                    102.033177,
                    53.9615767
                ],
                [
                    102.0402496,
                    53.9599313
                ],
                [
                    102.0432376,
                    53.9592386
                ],
                [
                    102.0450781,
                    53.9601689
                ],
                [
                    102.0476113,
                    53.960659
                ],
                [
                    102.0507736,
                    53.9615692
                ],
                [
                    102.057876,
                    53.957373
                ],
                [
                    102.061204,
                    53.9554298
                ],
                [
                    102.0603412,
                    53.9551246
                ],
                [
                    102.0639455,
                    53.9526711
                ],
                [
                    102.0655437,
                    53.9512129
                ],
                [
                    102.0652291,
                    53.9509628
                ],
                [
                    102.0666658,
                    53.9500048
                ],
                [
                    102.06616,
                    53.9490668
                ],
                [
                    102.0659432,
                    53.9485865
                ],
                [
                    102.066313,
                    53.948564
                ],
                [
                    102.0678516,
                    53.9483514
                ],
                [
                    102.0688547,
                    53.9488792
                ],
                [
                    102.0702191,
                    53.9492544
                ],
                [
                    102.0717152,
                    53.9496296
                ],
                [
                    102.0732581,
                    53.9498172
                ],
                [
                    102.0748945,
                    53.9496971
                ],
                [
                    102.0772747,
                    53.9491443
                ],
                [
                    102.0799525,
                    53.9479812
                ],
                [
                    102.080352,
                    53.9478736
                ],
                [
                    102.0824772,
                    53.9481838
                ],
                [
                    102.0831998,
                    53.9481813
                ],
                [
                    102.0841519,
                    53.9480137
                ],
                [
                    102.0853547,
                    53.9480212
                ],
                [
                    102.0859115,
                    53.9482188
                ],
                [
                    102.0860305,
                    53.9483989
                ],
                [
                    102.0859838,
                    53.9487341
                ],
                [
                    102.0865193,
                    53.9493369
                ],
                [
                    102.0867658,
                    53.949587
                ],
                [
                    102.0877902,
                    53.9492269
                ],
                [
                    102.0882747,
                    53.9488591
                ],
                [
                    102.0884958,
                    53.9485915
                ],
                [
                    102.0889335,
                    53.9484214
                ],
                [
                    102.0893883,
                    53.9484389
                ],
                [
                    102.0897114,
                    53.9485465
                ],
                [
                    102.0902087,
                    53.9485665
                ],
                [
                    102.0933884,
                    53.9475949
                ],
                [
                    102.0930728,
                    53.9472258
                ],
                [
                    102.092519,
                    53.9458783
                ],
                [
                    102.0926907,
                    53.9445649
                ],
                [
                    102.0932056,
                    53.9437566
                ],
                [
                    102.0945789,
                    53.9428473
                ],
                [
                    102.0962955,
                    53.942039
                ],
                [
                    102.0981838,
                    53.9413317
                ],
                [
                    102.0993855,
                    53.9405233
                ],
                [
                    102.1011021,
                    53.9399171
                ],
                [
                    102.103162,
                    53.9393108
                ],
                [
                    102.104192,
                    53.9390076
                ],
                [
                    102.1064236,
                    53.9374919
                ],
                [
                    102.1065906,
                    53.936783
                ],
                [
                    102.106169,
                    53.935523
                ],
                [
                    102.1062339,
                    53.9348453
                ],
                [
                    102.1057799,
                    53.9335281
                ],
                [
                    102.1054718,
                    53.9330126
                ],
                [
                    102.105488,
                    53.9326881
                ],
                [
                    102.1048557,
                    53.9322108
                ],
                [
                    102.1040612,
                    53.9318098
                ],
                [
                    102.1036234,
                    53.9310462
                ],
                [
                    102.1033478,
                    53.9303493
                ],
                [
                    102.1026992,
                    53.9299102
                ],
                [
                    102.1003968,
                    53.9294615
                ],
                [
                    102.0993429,
                    53.9296715
                ],
                [
                    102.0976567,
                    53.9294424
                ],
                [
                    102.0963596,
                    53.9290032
                ],
                [
                    102.0960029,
                    53.9284495
                ],
                [
                    102.0955813,
                    53.9270843
                ],
                [
                    102.0953219,
                    53.9254422
                ],
                [
                    102.0954678,
                    53.9246211
                ],
                [
                    102.0967487,
                    53.9247835
                ],
                [
                    102.0991646,
                    53.9234468
                ],
                [
                    102.1042558,
                    53.9202004
                ],
                [
                    102.1081147,
                    53.9177272
                ],
                [
                    102.1054232,
                    53.9153972
                ],
                [
                    102.1028614,
                    53.9130574
                ],
                [
                    102.1002023,
                    53.9123221
                ],
                [
                    102.0974297,
                    53.9121024
                ],
                [
                    102.0957434,
                    53.9125226
                ],
                [
                    102.0948841,
                    53.9130574
                ],
                [
                    102.094576,
                    53.9138215
                ],
                [
                    102.0938477,
                    53.9141209
                ],
                [
                    102.0925402,
                    53.9142554
                ],
                [
                    102.0916063,
                    53.9141271
                ],
                [
                    102.0902573,
                    53.9134181
                ],
                [
                    102.0896866,
                    53.9127702
                ],
                [
                    102.089313,
                    53.9116883
                ],
                [
                    102.0896347,
                    53.9106431
                ],
                [
                    102.090195,
                    53.9099279
                ],
                [
                    102.0900082,
                    53.9094267
                ],
                [
                    102.0902262,
                    53.9085953
                ],
                [
                    102.0900186,
                    53.9081736
                ],
                [
                    102.0890639,
                    53.9076417
                ],
                [
                    102.0876423,
                    53.9065842
                ],
                [
                    102.0869989,
                    53.9061868
                ],
                [
                    102.085982,
                    53.9060462
                ],
                [
                    102.0853179,
                    53.9062052
                ],
                [
                    102.0848094,
                    53.906413
                ],
                [
                    102.0843113,
                    53.9069021
                ],
                [
                    102.0839585,
                    53.9071099
                ],
                [
                    102.0836472,
                    53.9070304
                ],
                [
                    102.0829831,
                    53.9067248
                ],
                [
                    102.0825092,
                    53.9068406
                ],
                [
                    102.082391,
                    53.9064575
                ],
                [
                    102.082391,
                    53.9047384
                ],
                [
                    102.0820477,
                    53.9038282
                ],
                [
                    102.081876,
                    53.902918
                ],
                [
                    102.0801594,
                    53.9008952
                ],
                [
                    102.0799877,
                    53.8996815
                ],
                [
                    102.0806744,
                    53.8984678
                ],
                [
                    102.0811893,
                    53.897962
                ],
                [
                    102.080331,
                    53.8973552
                ],
                [
                    102.0796444,
                    53.8980632
                ],
                [
                    102.0794727,
                    53.8987712
                ],
                [
                    102.0784428,
                    53.8989735
                ],
                [
                    102.0775845,
                    53.8982655
                ],
                [
                    102.0768978,
                    53.8973552
                ],
                [
                    102.0763828,
                    53.8964448
                ],
                [
                    102.0758678,
                    53.8955344
                ],
                [
                    102.0750095,
                    53.8947252
                ],
                [
                    102.0743229,
                    53.8929044
                ],
                [
                    102.0732929,
                    53.8916905
                ],
                [
                    102.0727135,
                    53.8897964
                ],
                [
                    102.0723088,
                    53.8883653
                ],
                [
                    102.0722258,
                    53.8860535
                ],
                [
                    102.0721013,
                    53.8840902
                ],
                [
                    102.0708145,
                    53.8835214
                ],
                [
                    102.0702853,
                    53.882873
                ],
                [
                    102.0702023,
                    53.8817231
                ],
                [
                    102.0723918,
                    53.880879
                ],
                [
                    102.0743012,
                    53.8799248
                ],
                [
                    102.0749445,
                    53.879833
                ],
                [
                    102.0754115,
                    53.8789888
                ],
                [
                    102.0741766,
                    53.8767622
                ],
                [
                    102.0736889,
                    53.875557
                ],
                [
                    102.0709287,
                    53.872596
                ],
                [
                    102.0703891,
                    53.8721616
                ],
                [
                    102.0693099,
                    53.8689739
                ],
                [
                    102.068542,
                    53.8674381
                ],
                [
                    102.069258,
                    53.8644765
                ],
                [
                    102.0713852,
                    53.862194
                ],
                [
                    102.072506,
                    53.8618758
                ],
                [
                    102.0747474,
                    53.861888
                ],
                [
                    102.0777359,
                    53.861325
                ],
                [
                    102.0792302,
                    53.8597277
                ],
                [
                    102.0794481,
                    53.8580141
                ],
                [
                    102.0780576,
                    53.8554068
                ],
                [
                    102.0776529,
                    53.8542133
                ],
                [
                    102.0760964,
                    53.8531972
                ],
                [
                    102.0740314,
                    53.8528545
                ],
                [
                    102.068625,
                    53.8529769
                ],
                [
                    102.0677118,
                    53.8539256
                ],
                [
                    102.0660723,
                    53.8546295
                ],
                [
                    102.0637167,
                    53.854807
                ],
                [
                    102.0618281,
                    53.8546234
                ],
                [
                    102.0608631,
                    53.8556945
                ],
                [
                    102.0597527,
                    53.8559026
                ],
                [
                    102.0362075,
                    53.8562943
                ],
                [
                    102.0331878,
                    53.8615269
                ],
                [
                    102.0354396,
                    53.8654556
                ],
                [
                    102.0353981,
                    53.8670526
                ],
                [
                    102.0372452,
                    53.8691758
                ],
                [
                    102.0370999,
                    53.8701303
                ],
                [
                    102.0366122,
                    53.8708829
                ],
                [
                    102.0363631,
                    53.8724736
                ],
                [
                    102.0343293,
                    53.872651
                ],
                [
                    102.0237344,
                    53.8802734
                ],
                [
                    102.0184573,
                    53.8800905
                ],
                [
                    102.0182182,
                    53.8810488
                ],
                [
                    102.0179099,
                    53.8844095
                ],
                [
                    101.9993741,
                    53.897634
                ],
                [
                    102.0061953,
                    53.901205
                ],
                [
                    101.9934066,
                    53.9112582
                ],
                [
                    102.0044928,
                    53.9169166
                ],
                [
                    101.9903867,
                    53.9238273
                ]
            ],
            "longitude": 102.052727,
            "latitude": 53.928402
        },
        "5966": {
            "name": "САЯНСК",
            "population": 38887,
            "type": "town",
            "poly": [
                [
                    101.9641038,
                    54.0351706
                ],
                [
                    101.9665964,
                    54.0367819
                ],
                [
                    101.966435,
                    54.0370662
                ],
                [
                    101.9677978,
                    54.0375717
                ],
                [
                    101.9736975,
                    54.0412678
                ],
                [
                    101.9937635,
                    54.0299468
                ],
                [
                    101.9956285,
                    54.0311369
                ],
                [
                    101.9899799,
                    54.0343702
                ],
                [
                    102.0015102,
                    54.0414468
                ],
                [
                    102.0079837,
                    54.0374032
                ],
                [
                    102.0210204,
                    54.0454164
                ],
                [
                    102.025611,
                    54.0428683
                ],
                [
                    102.0408712,
                    54.0522911
                ],
                [
                    102.0401719,
                    54.0527858
                ],
                [
                    102.0401001,
                    54.0530385
                ],
                [
                    102.0375179,
                    54.0544911
                ],
                [
                    102.031959,
                    54.0669947
                ],
                [
                    102.0151566,
                    54.0765276
                ],
                [
                    102.0225625,
                    54.081104
                ],
                [
                    102.0215942,
                    54.0825136
                ],
                [
                    102.0247502,
                    54.0844281
                ],
                [
                    102.028785,
                    54.082198
                ],
                [
                    102.026669,
                    54.080862
                ],
                [
                    102.0409609,
                    54.0728241
                ],
                [
                    102.034057,
                    54.0683627
                ],
                [
                    102.0331245,
                    54.0668579
                ],
                [
                    102.0353481,
                    54.0615959
                ],
                [
                    102.0385759,
                    54.0543227
                ],
                [
                    102.0420009,
                    54.0521331
                ],
                [
                    102.0267228,
                    54.0427209
                ],
                [
                    102.0320666,
                    54.0397094
                ],
                [
                    102.0337701,
                    54.0407203
                ],
                [
                    102.0410685,
                    54.0365818
                ],
                [
                    102.0396518,
                    54.0356656
                ],
                [
                    102.0511105,
                    54.0291884
                ],
                [
                    102.0505008,
                    54.0287566
                ],
                [
                    102.0557549,
                    54.0257967
                ],
                [
                    102.0724856,
                    54.0359921
                ],
                [
                    102.0727187,
                    54.0401727
                ],
                [
                    102.0693226,
                    54.044233
                ],
                [
                    102.0684733,
                    54.0410253
                ],
                [
                    102.062758,
                    54.041032
                ],
                [
                    102.0607725,
                    54.0453651
                ],
                [
                    102.0543801,
                    54.0434109
                ],
                [
                    102.0533242,
                    54.0440443
                ],
                [
                    102.0612201,
                    54.0482423
                ],
                [
                    102.0640089,
                    54.0467127
                ],
                [
                    102.0719163,
                    54.0502771
                ],
                [
                    102.0717785,
                    54.0514898
                ],
                [
                    102.0762659,
                    54.0532482
                ],
                [
                    102.083565,
                    54.0561384
                ],
                [
                    102.0863308,
                    54.0546293
                ],
                [
                    102.0907263,
                    54.0570074
                ],
                [
                    102.0956613,
                    54.0604563
                ],
                [
                    102.0986681,
                    54.0626455
                ],
                [
                    102.1006306,
                    54.0638848
                ],
                [
                    102.1016291,
                    54.0647469
                ],
                [
                    102.1054852,
                    54.0675285
                ],
                [
                    102.1079756,
                    54.069367
                ],
                [
                    102.1101217,
                    54.0708621
                ],
                [
                    102.1127384,
                    54.0726803
                ],
                [
                    102.113932,
                    54.0739126
                ],
                [
                    102.1162732,
                    54.0752391
                ],
                [
                    102.1198194,
                    54.0778113
                ],
                [
                    102.1246535,
                    54.0811198
                ],
                [
                    102.1259823,
                    54.0820125
                ],
                [
                    102.1261653,
                    54.0819488
                ],
                [
                    102.1413816,
                    54.093882
                ],
                [
                    102.1408614,
                    54.0946115
                ],
                [
                    102.1403077,
                    54.0952619
                ],
                [
                    102.1398973,
                    54.0950692
                ],
                [
                    102.1393124,
                    54.0948797
                ],
                [
                    102.1384555,
                    54.0957099
                ],
                [
                    102.1389103,
                    54.095796
                ],
                [
                    102.1392379,
                    54.0959284
                ],
                [
                    102.1392202,
                    54.0961595
                ],
                [
                    102.1390136,
                    54.096395
                ],
                [
                    102.138661,
                    54.096976
                ],
                [
                    102.1391399,
                    54.0971421
                ],
                [
                    102.1395025,
                    54.0973117
                ],
                [
                    102.1393694,
                    54.0980304
                ],
                [
                    102.1391743,
                    54.0991139
                ],
                [
                    102.1387219,
                    54.0999207
                ],
                [
                    102.138348,
                    54.1009309
                ],
                [
                    102.1382906,
                    54.1014087
                ],
                [
                    102.1381107,
                    54.1018841
                ],
                [
                    102.1367413,
                    54.1037638
                ],
                [
                    102.1364037,
                    54.1044156
                ],
                [
                    102.1353802,
                    54.1042653
                ],
                [
                    102.1349739,
                    54.1043156
                ],
                [
                    102.1346296,
                    54.1045915
                ],
                [
                    102.1343656,
                    54.1051836
                ],
                [
                    102.1331147,
                    54.1055806
                ],
                [
                    102.1325444,
                    54.106756
                ],
                [
                    102.1269686,
                    54.1068871
                ],
                [
                    102.1269438,
                    54.1074768
                ],
                [
                    102.1260745,
                    54.1074914
                ],
                [
                    102.1261614,
                    54.1091367
                ],
                [
                    102.1282624,
                    54.1091437
                ],
                [
                    102.1285107,
                    54.1105633
                ],
                [
                    102.1318541,
                    54.1106255
                ],
                [
                    102.1345873,
                    54.1097878
                ],
                [
                    102.1347866,
                    54.1104984
                ],
                [
                    102.1335017,
                    54.1116145
                ],
                [
                    102.1320665,
                    54.114603
                ],
                [
                    102.1296306,
                    54.1194212
                ],
                [
                    102.127133,
                    54.1209739
                ],
                [
                    102.1264512,
                    54.1240593
                ],
                [
                    102.1245775,
                    54.1251178
                ],
                [
                    102.1222785,
                    54.1264091
                ],
                [
                    102.1203236,
                    54.1274448
                ],
                [
                    102.120812,
                    54.1277751
                ],
                [
                    102.1219119,
                    54.1271446
                ],
                [
                    102.1248125,
                    54.1254708
                ],
                [
                    102.1270339,
                    54.1241866
                ],
                [
                    102.1276384,
                    54.1210935
                ],
                [
                    102.1301646,
                    54.1197477
                ],
                [
                    102.1320184,
                    54.1157687
                ],
                [
                    102.1328514,
                    54.1139976
                ],
                [
                    102.1338103,
                    54.1132151
                ],
                [
                    102.1349316,
                    54.1120954
                ],
                [
                    102.135372,
                    54.1116783
                ],
                [
                    102.1359664,
                    54.1112511
                ],
                [
                    102.1351138,
                    54.1222057
                ],
                [
                    102.1339958,
                    54.1331635
                ],
                [
                    102.1669827,
                    54.1477542
                ],
                [
                    102.1540779,
                    54.157813
                ],
                [
                    102.1869488,
                    54.1662482
                ],
                [
                    102.1894786,
                    54.1662548
                ],
                [
                    102.1910808,
                    54.165261
                ],
                [
                    102.1913924,
                    54.1645686
                ],
                [
                    102.1929183,
                    54.1642559
                ],
                [
                    102.1934914,
                    54.1636172
                ],
                [
                    102.1943903,
                    54.163359
                ],
                [
                    102.19571,
                    54.1624831
                ],
                [
                    102.1960408,
                    54.1617414
                ],
                [
                    102.1972353,
                    54.1603279
                ],
                [
                    102.197085,
                    54.1594584
                ],
                [
                    102.1976307,
                    54.1593962
                ],
                [
                    102.1981749,
                    54.1593478
                ],
                [
                    102.1987699,
                    54.1588069
                ],
                [
                    102.1986984,
                    54.1577086
                ],
                [
                    102.2047533,
                    54.1535816
                ],
                [
                    102.2062036,
                    54.1534604
                ],
                [
                    102.20734,
                    54.1538637
                ],
                [
                    102.208175,
                    54.1531274
                ],
                [
                    102.2087767,
                    54.1530221
                ],
                [
                    102.2094356,
                    54.1528365
                ],
                [
                    102.2106913,
                    54.1521555
                ],
                [
                    102.2112363,
                    54.150682
                ],
                [
                    102.2127265,
                    54.1496456
                ],
                [
                    102.2139488,
                    54.147976
                ],
                [
                    102.2140958,
                    54.1470376
                ],
                [
                    102.2153033,
                    54.146518
                ],
                [
                    102.2156946,
                    54.1447317
                ],
                [
                    102.2150973,
                    54.1441119
                ],
                [
                    102.2148229,
                    54.1428658
                ],
                [
                    102.2158163,
                    54.141385
                ],
                [
                    102.2168744,
                    54.1408528
                ],
                [
                    102.2169642,
                    54.1399804
                ],
                [
                    102.2190377,
                    54.1389283
                ],
                [
                    102.2207687,
                    54.1379716
                ],
                [
                    102.2207992,
                    54.1372815
                ],
                [
                    102.221817,
                    54.1360495
                ],
                [
                    102.2224471,
                    54.1357603
                ],
                [
                    102.222948,
                    54.1352065
                ],
                [
                    102.2232052,
                    54.134331
                ],
                [
                    102.2240116,
                    54.1339601
                ],
                [
                    102.2247854,
                    54.1329845
                ],
                [
                    102.2243785,
                    54.1315747
                ],
                [
                    102.2246636,
                    54.1298218
                ],
                [
                    102.2243866,
                    54.1279339
                ],
                [
                    102.2249154,
                    54.1268726
                ],
                [
                    102.227047,
                    54.1032254
                ],
                [
                    102.2285927,
                    54.0854824
                ],
                [
                    102.2273095,
                    54.0850056
                ],
                [
                    102.228469,
                    54.0840766
                ],
                [
                    102.2283428,
                    54.0838813
                ],
                [
                    102.2284458,
                    54.0837395
                ],
                [
                    102.2274361,
                    54.082683
                ],
                [
                    102.2264262,
                    54.082481
                ],
                [
                    102.2268394,
                    54.0819155
                ],
                [
                    102.2263535,
                    54.0812155
                ],
                [
                    102.2266348,
                    54.0769955
                ],
                [
                    102.223362,
                    54.0746573
                ],
                [
                    102.2198829,
                    54.0721132
                ],
                [
                    102.2187828,
                    54.0721388
                ],
                [
                    102.2179481,
                    54.0716445
                ],
                [
                    102.2176184,
                    54.0707435
                ],
                [
                    102.2169236,
                    54.0700579
                ],
                [
                    102.2169286,
                    54.0699032
                ],
                [
                    102.2174826,
                    54.0696961
                ],
                [
                    102.215489,
                    54.0674596
                ],
                [
                    102.2095835,
                    54.0672856
                ],
                [
                    102.208589,
                    54.0703674
                ],
                [
                    102.1774094,
                    54.0692387
                ],
                [
                    102.1493615,
                    54.085152
                ],
                [
                    102.146325,
                    54.082708
                ],
                [
                    102.1428476,
                    54.0799274
                ],
                [
                    102.1408736,
                    54.075827
                ],
                [
                    102.1394964,
                    54.0729584
                ],
                [
                    102.1384865,
                    54.0721571
                ],
                [
                    102.1396571,
                    54.0714163
                ],
                [
                    102.1426181,
                    54.0696721
                ],
                [
                    102.144374,
                    54.0686687
                ],
                [
                    102.146325,
                    54.0673015
                ],
                [
                    102.1479202,
                    54.0664664
                ],
                [
                    102.1499745,
                    54.0652541
                ],
                [
                    102.1552538,
                    54.0641495
                ],
                [
                    102.1575032,
                    54.063806
                ],
                [
                    102.1599018,
                    54.0633143
                ],
                [
                    102.1610724,
                    54.0629708
                ],
                [
                    102.1686125,
                    54.06062
                ],
                [
                    102.1765313,
                    54.0579188
                ],
                [
                    102.1838189,
                    54.055561
                ],
                [
                    102.1854142,
                    54.0549682
                ],
                [
                    102.1887997,
                    54.0536343
                ],
                [
                    102.1908541,
                    54.0525563
                ],
                [
                    102.1940331,
                    54.0507709
                ],
                [
                    102.1992778,
                    54.0477389
                ],
                [
                    102.1994156,
                    54.0476311
                ],
                [
                    102.1993697,
                    54.0471325
                ],
                [
                    102.2023421,
                    54.0450773
                ],
                [
                    102.2042816,
                    54.0438038
                ],
                [
                    102.2106167,
                    54.0395447
                ],
                [
                    102.2127284,
                    54.0395582
                ],
                [
                    102.2127399,
                    54.0400165
                ],
                [
                    102.2113168,
                    54.0419708
                ],
                [
                    102.2139564,
                    54.0426582
                ],
                [
                    102.2132104,
                    54.0437633
                ],
                [
                    102.2132333,
                    54.0438981
                ],
                [
                    102.2135891,
                    54.04439
                ],
                [
                    102.2140367,
                    54.0445854
                ],
                [
                    102.2143007,
                    54.0449156
                ],
                [
                    102.2154598,
                    54.0445248
                ],
                [
                    102.2186962,
                    54.0453671
                ],
                [
                    102.2218361,
                    54.0412441
                ],
                [
                    102.2241935,
                    54.0382103
                ],
                [
                    102.2258231,
                    54.0384462
                ],
                [
                    102.2274758,
                    54.0361884
                ],
                [
                    102.21927,
                    54.0340383
                ],
                [
                    102.2153909,
                    54.0333036
                ],
                [
                    102.2131301,
                    54.0324476
                ],
                [
                    102.2106626,
                    54.0346988
                ],
                [
                    102.2108692,
                    54.0352111
                ],
                [
                    102.2123611,
                    54.0357638
                ],
                [
                    102.2122005,
                    54.0370309
                ],
                [
                    102.211466,
                    54.0377722
                ],
                [
                    102.2106855,
                    54.0375835
                ],
                [
                    102.2100658,
                    54.0370039
                ],
                [
                    102.2096412,
                    54.0344427
                ],
                [
                    102.2094805,
                    54.0341933
                ],
                [
                    102.2092395,
                    54.0329936
                ],
                [
                    102.2092625,
                    54.0322858
                ],
                [
                    102.2095149,
                    54.0292794
                ],
                [
                    102.2119939,
                    54.0291109
                ],
                [
                    102.212189,
                    54.0289963
                ],
                [
                    102.2123841,
                    54.029003
                ],
                [
                    102.2129005,
                    54.0292188
                ],
                [
                    102.2134973,
                    54.0285244
                ],
                [
                    102.2124988,
                    54.0282009
                ],
                [
                    102.2117988,
                    54.0288952
                ],
                [
                    102.2095723,
                    54.0291311
                ],
                [
                    102.2098822,
                    54.0269942
                ],
                [
                    102.2103527,
                    54.023239
                ],
                [
                    102.2106396,
                    54.0207781
                ],
                [
                    102.21072,
                    54.0189914
                ],
                [
                    102.2130268,
                    54.0190386
                ],
                [
                    102.214886,
                    54.018897
                ],
                [
                    102.2187765,
                    54.0166583
                ],
                [
                    102.218788,
                    54.0147568
                ],
                [
                    102.2188224,
                    54.0135497
                ],
                [
                    102.2185929,
                    54.0131248
                ],
                [
                    102.2181683,
                    54.0126798
                ],
                [
                    102.2170665,
                    54.011331
                ],
                [
                    102.2170895,
                    54.0105892
                ],
                [
                    102.2173534,
                    54.0097934
                ],
                [
                    102.2173993,
                    54.0087885
                ],
                [
                    102.2166419,
                    54.0076824
                ],
                [
                    102.2153795,
                    54.0076689
                ],
                [
                    102.2153795,
                    54.0052003
                ],
                [
                    102.2155401,
                    54.0032308
                ],
                [
                    102.2142089,
                    54.003197
                ],
                [
                    102.2142318,
                    54.0026439
                ],
                [
                    102.2133711,
                    54.0026304
                ],
                [
                    102.2131874,
                    54.0047821
                ],
                [
                    102.2105364,
                    54.0051329
                ],
                [
                    102.2088493,
                    54.0036287
                ],
                [
                    102.2086198,
                    54.0026372
                ],
                [
                    102.2085509,
                    54.0014635
                ],
                [
                    102.2082525,
                    54.0009373
                ],
                [
                    102.203024,
                    54.0008448
                ],
                [
                    102.1990483,
                    54.0007552
                ],
                [
                    102.1987729,
                    54.0037299
                ],
                [
                    102.2013551,
                    54.0037636
                ],
                [
                    102.2013551,
                    54.0040402
                ],
                [
                    102.2022044,
                    54.0040402
                ],
                [
                    102.2022273,
                    54.004229
                ],
                [
                    102.2028815,
                    54.0042493
                ],
                [
                    102.2053346,
                    54.0085996
                ],
                [
                    102.2063818,
                    54.0099653
                ],
                [
                    102.206597,
                    54.0111624
                ],
                [
                    102.2052657,
                    54.0117491
                ],
                [
                    102.2051165,
                    54.0155794
                ],
                [
                    102.2099482,
                    54.0156469
                ],
                [
                    102.2096727,
                    54.0189442
                ],
                [
                    102.2090415,
                    54.0238526
                ],
                [
                    102.2087546,
                    54.0238458
                ],
                [
                    102.208571,
                    54.0242975
                ],
                [
                    102.2088579,
                    54.0244324
                ],
                [
                    102.2087776,
                    54.0263268
                ],
                [
                    102.2084103,
                    54.028848
                ],
                [
                    102.2079398,
                    54.0327105
                ],
                [
                    102.2081808,
                    54.0338091
                ],
                [
                    102.2091288,
                    54.0385824
                ],
                [
                    102.208512,
                    54.0398798
                ],
                [
                    102.2011096,
                    54.0447402
                ],
                [
                    102.1983122,
                    54.0467027
                ],
                [
                    102.1981113,
                    54.0469723
                ],
                [
                    102.1977527,
                    54.0474271
                ],
                [
                    102.1971215,
                    54.0481346
                ],
                [
                    102.1936785,
                    54.050198
                ],
                [
                    102.1892457,
                    54.0528846
                ],
                [
                    102.1851859,
                    54.054493
                ],
                [
                    102.1777835,
                    54.0567919
                ],
                [
                    102.1673828,
                    54.0604211
                ],
                [
                    102.164069,
                    54.0615325
                ],
                [
                    102.1596362,
                    54.0627786
                ],
                [
                    102.1574126,
                    54.0632417
                ],
                [
                    102.152822,
                    54.0642183
                ],
                [
                    102.1509857,
                    54.0646224
                ],
                [
                    102.1505984,
                    54.0645972
                ],
                [
                    102.1504693,
                    54.0646814
                ],
                [
                    102.1495655,
                    54.0649087
                ],
                [
                    102.1493646,
                    54.0650097
                ],
                [
                    102.1488626,
                    54.0652791
                ],
                [
                    102.1484178,
                    54.0655064
                ],
                [
                    102.1480735,
                    54.0657422
                ],
                [
                    102.1468828,
                    54.066382
                ],
                [
                    102.1464812,
                    54.0665251
                ],
                [
                    102.1463807,
                    54.066643
                ],
                [
                    102.1459073,
                    54.0668871
                ],
                [
                    102.1456061,
                    54.0670892
                ],
                [
                    102.1450896,
                    54.0674764
                ],
                [
                    102.1447453,
                    54.0677374
                ],
                [
                    102.144731,
                    54.06783
                ],
                [
                    102.1436264,
                    54.0686887
                ],
                [
                    102.1433825,
                    54.0687223
                ],
                [
                    102.143153,
                    54.0688907
                ],
                [
                    102.1430669,
                    54.0690506
                ],
                [
                    102.1416467,
                    54.069943
                ],
                [
                    102.1413597,
                    54.0699682
                ],
                [
                    102.140829,
                    54.069682
                ],
                [
                    102.1399969,
                    54.070246
                ],
                [
                    102.1405851,
                    54.0705911
                ],
                [
                    102.1400256,
                    54.0709952
                ],
                [
                    102.1397817,
                    54.0710205
                ],
                [
                    102.1395952,
                    54.0711467
                ],
                [
                    102.1395952,
                    54.0712477
                ],
                [
                    102.139294,
                    54.0714329
                ],
                [
                    102.1383758,
                    54.0720222
                ],
                [
                    102.1381893,
                    54.0720222
                ],
                [
                    102.1376191,
                    54.0723862
                ],
                [
                    102.1369915,
                    54.072039
                ],
                [
                    102.1362563,
                    54.0729334
                ],
                [
                    102.1304283,
                    54.076721
                ],
                [
                    102.1296214,
                    54.0763317
                ],
                [
                    102.1291551,
                    54.076721
                ],
                [
                    102.1279178,
                    54.0761529
                ],
                [
                    102.1345886,
                    54.0697767
                ],
                [
                    102.1304821,
                    54.0663988
                ],
                [
                    102.1197766,
                    54.0711972
                ],
                [
                    102.1153653,
                    54.0731859
                ],
                [
                    102.1127652,
                    54.071313
                ],
                [
                    102.113088,
                    54.0711025
                ],
                [
                    102.1126755,
                    54.0707553
                ],
                [
                    102.1121914,
                    54.0709552
                ],
                [
                    102.1045164,
                    54.0655043
                ],
                [
                    102.0983298,
                    54.0610736
                ],
                [
                    102.0918563,
                    54.0564951
                ],
                [
                    102.0880009,
                    54.0541372
                ],
                [
                    102.0841096,
                    54.0522529
                ],
                [
                    102.0744442,
                    54.048442
                ],
                [
                    102.0764167,
                    54.0463434
                ],
                [
                    102.077403,
                    54.045294
                ],
                [
                    102.0753408,
                    54.044199
                ],
                [
                    102.0728662,
                    54.0443675
                ],
                [
                    102.0786404,
                    54.036649
                ],
                [
                    102.0684011,
                    54.031004
                ],
                [
                    102.0608696,
                    54.0266329
                ],
                [
                    102.0668231,
                    54.0232515
                ],
                [
                    102.0711627,
                    54.0259271
                ],
                [
                    102.0749463,
                    54.0238308
                ],
                [
                    102.0746415,
                    54.0218714
                ],
                [
                    102.0634698,
                    54.0150444
                ],
                [
                    102.0671279,
                    54.0129792
                ],
                [
                    102.0617304,
                    54.009544
                ],
                [
                    102.0621428,
                    54.0068989
                ],
                [
                    102.0603675,
                    54.002188
                ],
                [
                    102.0534457,
                    53.9984567
                ],
                [
                    102.0562969,
                    53.996844
                ],
                [
                    102.0524953,
                    53.9944827
                ],
                [
                    102.0460935,
                    53.9981089
                ],
                [
                    102.04439,
                    53.9970864
                ],
                [
                    102.0333797,
                    54.0033262
                ],
                [
                    102.0236246,
                    53.9973605
                ],
                [
                    102.0379882,
                    53.9891905
                ],
                [
                    102.0502179,
                    53.9822632
                ],
                [
                    102.0389207,
                    53.9752715
                ],
                [
                    102.0254178,
                    53.9828959
                ],
                [
                    102.0239474,
                    53.9819785
                ],
                [
                    102.0129908,
                    53.9881995
                ],
                [
                    102.0144075,
                    53.9890956
                ],
                [
                    102.0079161,
                    53.992775
                ],
                [
                    102.0024826,
                    53.9980035
                ],
                [
                    102.0124887,
                    53.9991946
                ],
                [
                    102.0180298,
                    54.0026622
                ],
                [
                    102.027731,
                    54.0086061
                ],
                [
                    102.0218852,
                    54.0119044
                ],
                [
                    102.0077188,
                    54.0199646
                ],
                [
                    101.9962422,
                    54.0264538
                ],
                [
                    101.9922075,
                    54.0239994
                ],
                [
                    101.9864334,
                    54.0238625
                ],
                [
                    101.9751361,
                    54.0268646
                ],
                [
                    101.9733071,
                    54.0278337
                ],
                [
                    101.970402,
                    54.0301509
                ],
                [
                    101.9707069,
                    54.0303721
                ],
                [
                    101.9641038,
                    54.0351706
                ]
            ],
            "longitude": 102.169525,
            "latitude": 54.108418
        },
        "5967": {
            "name": "ЗАЛАРИ",
            "population": 9466,
            "type": "town",
            "poly": [
                [
                    102.4766323,
                    53.5446948
                ],
                [
                    102.479924,
                    53.5571804
                ],
                [
                    102.4858218,
                    53.5612273
                ],
                [
                    102.4880249,
                    53.5631197
                ],
                [
                    102.4919353,
                    53.56773
                ],
                [
                    102.4809828,
                    53.5761556
                ],
                [
                    102.5049505,
                    53.5813922
                ],
                [
                    102.529326,
                    53.5774491
                ],
                [
                    102.5488491,
                    53.574742
                ],
                [
                    102.551339,
                    53.5668286
                ],
                [
                    102.5333152,
                    53.5568066
                ],
                [
                    102.5223859,
                    53.5479215
                ],
                [
                    102.5247639,
                    53.5322863
                ],
                [
                    102.5197474,
                    53.5309164
                ],
                [
                    102.4981898,
                    53.5357515
                ],
                [
                    102.4766323,
                    53.5446948
                ]
            ],
            "longitude": 102.515991,
            "latitude": 53.566238
        },
        "5968": {
            "name": "НОВОНУКУТСКИЙ",
            "population": 3434,
            "type": "town",
            "poly": null,
            "longitude": 102.711548,
            "latitude": 53.700245
        },
        "5969": {
            "name": "УСТЬ-ИЛИМСК",
            "population": 83023,
            "type": "town",
            "poly": [
                [
                    102.6119575,
                    57.9824751
                ],
                [
                    102.6269216,
                    58.0098908
                ],
                [
                    102.6769236,
                    58.0385333
                ],
                [
                    102.7373465,
                    58.0280578
                ],
                [
                    102.752281,
                    58.0634895
                ],
                [
                    102.7742537,
                    58.093987
                ],
                [
                    102.7790123,
                    58.0980658
                ],
                [
                    102.8184204,
                    58.0985026
                ],
                [
                    102.8185219,
                    58.0980646
                ],
                [
                    102.8193508,
                    58.0979305
                ],
                [
                    102.8200105,
                    58.0978322
                ],
                [
                    102.8204165,
                    58.096965
                ],
                [
                    102.8201289,
                    58.0965538
                ],
                [
                    102.8194354,
                    58.0963035
                ],
                [
                    102.8198244,
                    58.0958654
                ],
                [
                    102.8194523,
                    58.0957313
                ],
                [
                    102.8189279,
                    58.0957492
                ],
                [
                    102.8175915,
                    58.0957224
                ],
                [
                    102.8165258,
                    58.0956687
                ],
                [
                    102.8160522,
                    58.0959369
                ],
                [
                    102.8150541,
                    58.0957224
                ],
                [
                    102.8138024,
                    58.0945512
                ],
                [
                    102.813481,
                    58.0932638
                ],
                [
                    102.8135317,
                    58.0914577
                ],
                [
                    102.814479,
                    58.0910553
                ],
                [
                    102.8163567,
                    58.0903221
                ],
                [
                    102.8158323,
                    58.0901433
                ],
                [
                    102.8151049,
                    58.0899913
                ],
                [
                    102.8149527,
                    58.0893386
                ],
                [
                    102.815697,
                    58.0873356
                ],
                [
                    102.815494,
                    58.0862893
                ],
                [
                    102.815494,
                    58.0850731
                ],
                [
                    102.8161706,
                    58.0842325
                ],
                [
                    102.8186911,
                    58.0832667
                ],
                [
                    102.8199767,
                    58.0828105
                ],
                [
                    102.8202981,
                    58.0822918
                ],
                [
                    102.8191647,
                    58.0818536
                ],
                [
                    102.8158661,
                    58.0811828
                ],
                [
                    102.8131427,
                    58.0809503
                ],
                [
                    102.8118232,
                    58.0803421
                ],
                [
                    102.8107575,
                    58.0786695
                ],
                [
                    102.8096072,
                    58.0778467
                ],
                [
                    102.8078987,
                    58.076988
                ],
                [
                    102.8052937,
                    58.0762545
                ],
                [
                    102.804431,
                    58.0757625
                ],
                [
                    102.8047693,
                    58.0751811
                ],
                [
                    102.805632,
                    58.0740987
                ],
                [
                    102.80844,
                    58.0733294
                ],
                [
                    102.8086769,
                    58.0729089
                ],
                [
                    102.8069683,
                    58.07273
                ],
                [
                    102.8062579,
                    58.0721038
                ],
                [
                    102.8086092,
                    58.0720859
                ],
                [
                    102.8086092,
                    58.070565
                ],
                [
                    102.8100809,
                    58.0706098
                ],
                [
                    102.8128873,
                    58.0690013
                ],
                [
                    102.8113933,
                    58.0679649
                ],
                [
                    102.811101,
                    58.0669628
                ],
                [
                    102.8114258,
                    58.0655942
                ],
                [
                    102.8114258,
                    58.0650559
                ],
                [
                    102.8107762,
                    58.0646722
                ],
                [
                    102.8106788,
                    58.0635612
                ],
                [
                    102.8115016,
                    58.063252
                ],
                [
                    102.8116748,
                    58.0625762
                ],
                [
                    102.8127141,
                    58.0624846
                ],
                [
                    102.813656,
                    58.062433
                ],
                [
                    102.8133096,
                    58.0619462
                ],
                [
                    102.8144355,
                    58.0617401
                ],
                [
                    102.815215,
                    58.0619405
                ],
                [
                    102.81515,
                    58.062393
                ],
                [
                    102.8155398,
                    58.0627194
                ],
                [
                    102.8170121,
                    58.0623357
                ],
                [
                    102.8181272,
                    58.0617229
                ],
                [
                    102.8182571,
                    58.0623815
                ],
                [
                    102.8191124,
                    58.0624617
                ],
                [
                    102.8195238,
                    58.0625819
                ],
                [
                    102.8204007,
                    58.0623586
                ],
                [
                    102.8218298,
                    58.0616885
                ],
                [
                    102.8231073,
                    58.0620322
                ],
                [
                    102.8241141,
                    58.062141
                ],
                [
                    102.8245796,
                    58.0613048
                ],
                [
                    102.8255431,
                    58.0612304
                ],
                [
                    102.8258896,
                    58.0622784
                ],
                [
                    102.8274594,
                    58.061385
                ],
                [
                    102.8275785,
                    58.0618718
                ],
                [
                    102.8281306,
                    58.0618775
                ],
                [
                    102.8282064,
                    58.0614423
                ],
                [
                    102.82904,
                    58.0611788
                ],
                [
                    102.83035,
                    58.0612017
                ],
                [
                    102.8301118,
                    58.0608008
                ],
                [
                    102.8296896,
                    58.0605316
                ],
                [
                    102.8293864,
                    58.0599589
                ],
                [
                    102.8300468,
                    58.0597756
                ],
                [
                    102.8312485,
                    58.0597298
                ],
                [
                    102.8321904,
                    58.0595522
                ],
                [
                    102.8321796,
                    58.0590883
                ],
                [
                    102.8328924,
                    58.0582352
                ],
                [
                    102.834027,
                    58.0577312
                ],
                [
                    102.8332648,
                    58.0570759
                ],
                [
                    102.8336112,
                    58.0568239
                ],
                [
                    102.8344773,
                    58.0567185
                ],
                [
                    102.8352135,
                    58.0564985
                ],
                [
                    102.8360883,
                    58.0564344
                ],
                [
                    102.8366339,
                    58.0560265
                ],
                [
                    102.8374653,
                    58.0560265
                ],
                [
                    102.8378291,
                    58.0556645
                ],
                [
                    102.8391109,
                    58.055605
                ],
                [
                    102.8395873,
                    58.0553483
                ],
                [
                    102.8405313,
                    58.0545693
                ],
                [
                    102.8413888,
                    58.054386
                ],
                [
                    102.8421076,
                    58.0541614
                ],
                [
                    102.841995,
                    58.0543677
                ],
                [
                    102.8421423,
                    58.0547159
                ],
                [
                    102.8427312,
                    58.0545051
                ],
                [
                    102.8440563,
                    58.0545968
                ],
                [
                    102.8444114,
                    58.0550367
                ],
                [
                    102.845113,
                    58.0550642
                ],
                [
                    102.8464814,
                    58.0548488
                ],
                [
                    102.8465247,
                    58.0545189
                ],
                [
                    102.8454334,
                    58.0546747
                ],
                [
                    102.8453122,
                    58.0541706
                ],
                [
                    102.8466459,
                    58.0542898
                ],
                [
                    102.8478671,
                    58.0544593
                ],
                [
                    102.8480663,
                    58.0542439
                ],
                [
                    102.8471743,
                    58.0540606
                ],
                [
                    102.8469664,
                    58.0538819
                ],
                [
                    102.8481789,
                    58.0535336
                ],
                [
                    102.8490883,
                    58.0534511
                ],
                [
                    102.8498332,
                    58.0536986
                ],
                [
                    102.8498245,
                    58.0542348
                ],
                [
                    102.8505347,
                    58.054496
                ],
                [
                    102.8512969,
                    58.054056
                ],
                [
                    102.8524141,
                    58.0540698
                ],
                [
                    102.8525614,
                    58.0537857
                ],
                [
                    102.8530204,
                    58.0538177
                ],
                [
                    102.8536007,
                    58.0534099
                ],
                [
                    102.8544754,
                    58.0531945
                ],
                [
                    102.8558699,
                    58.0528462
                ],
                [
                    102.8566493,
                    58.0530066
                ],
                [
                    102.8582603,
                    58.0529241
                ],
                [
                    102.8584508,
                    58.0536986
                ],
                [
                    102.8592649,
                    58.0535886
                ],
                [
                    102.8615168,
                    58.0533732
                ],
                [
                    102.8630325,
                    58.0529104
                ],
                [
                    102.8659772,
                    58.0527683
                ],
                [
                    102.8681338,
                    58.0527729
                ],
                [
                    102.8706454,
                    58.0535382
                ],
                [
                    102.8709139,
                    58.0532266
                ],
                [
                    102.87081,
                    58.0527179
                ],
                [
                    102.8711824,
                    58.0524567
                ],
                [
                    102.871728,
                    58.0526629
                ],
                [
                    102.8722737,
                    58.052255
                ],
                [
                    102.87288,
                    58.0524521
                ],
                [
                    102.8731311,
                    58.0529883
                ],
                [
                    102.8725422,
                    58.0534374
                ],
                [
                    102.8729059,
                    58.0537215
                ],
                [
                    102.874387,
                    58.0536848
                ],
                [
                    102.8750538,
                    58.0537123
                ],
                [
                    102.8757121,
                    58.0542256
                ],
                [
                    102.8757207,
                    58.0546014
                ],
                [
                    102.8759546,
                    58.0549634
                ],
                [
                    102.8767687,
                    58.0549909
                ],
                [
                    102.8781978,
                    58.0547159
                ],
                [
                    102.8789946,
                    58.0544731
                ],
                [
                    102.8802331,
                    58.0545143
                ],
                [
                    102.8811078,
                    58.0541981
                ],
                [
                    102.8816968,
                    58.0541477
                ],
                [
                    102.8823204,
                    58.0543768
                ],
                [
                    102.883351,
                    58.0542989
                ],
                [
                    102.8841825,
                    58.0543631
                ],
                [
                    102.884884,
                    58.0547068
                ],
                [
                    102.8853517,
                    58.0545968
                ],
                [
                    102.8858974,
                    58.0545143
                ],
                [
                    102.8861312,
                    58.0538315
                ],
                [
                    102.8865296,
                    58.0531395
                ],
                [
                    102.8874137,
                    58.0528869
                ],
                [
                    102.8877828,
                    58.0523117
                ],
                [
                    102.8866338,
                    58.0520417
                ],
                [
                    102.885086,
                    58.0516781
                ],
                [
                    102.8844581,
                    58.0513058
                ],
                [
                    102.8835704,
                    58.050773
                ],
                [
                    102.8819789,
                    58.0489798
                ],
                [
                    102.8812319,
                    58.0483496
                ],
                [
                    102.8694855,
                    58.0408549
                ],
                [
                    102.8628707,
                    58.0366314
                ],
                [
                    102.8592006,
                    58.0343388
                ],
                [
                    102.8571762,
                    58.0336854
                ],
                [
                    102.8552383,
                    58.0330435
                ],
                [
                    102.8537334,
                    58.032178
                ],
                [
                    102.8429505,
                    58.0273686
                ],
                [
                    102.8409044,
                    58.026096
                ],
                [
                    102.8402776,
                    58.0254567
                ],
                [
                    102.8399311,
                    58.0249357
                ],
                [
                    102.8399727,
                    58.0246642
                ],
                [
                    102.8380777,
                    58.0171222
                ],
                [
                    102.8380371,
                    58.0150363
                ],
                [
                    102.8374054,
                    58.013823
                ],
                [
                    102.836401,
                    58.0100986
                ],
                [
                    102.83217,
                    57.9989896
                ],
                [
                    102.832052,
                    57.9975075
                ],
                [
                    102.8307637,
                    57.9940133
                ],
                [
                    102.8266306,
                    57.9828742
                ],
                [
                    102.8263424,
                    57.9821148
                ],
                [
                    102.8259122,
                    57.9813601
                ],
                [
                    102.8257127,
                    57.9809886
                ],
                [
                    102.8253136,
                    57.980596
                ],
                [
                    102.8247637,
                    57.9800999
                ],
                [
                    102.8190684,
                    57.9756975
                ],
                [
                    102.8163303,
                    57.9737216
                ],
                [
                    102.8141685,
                    57.972013
                ],
                [
                    102.8136835,
                    57.9716786
                ],
                [
                    102.8131015,
                    57.9711127
                ],
                [
                    102.8127966,
                    57.9706827
                ],
                [
                    102.8119998,
                    57.9691063
                ],
                [
                    102.8114801,
                    57.9684264
                ],
                [
                    102.8109535,
                    57.9680405
                ],
                [
                    102.8105517,
                    57.9678347
                ],
                [
                    102.8100112,
                    57.9676069
                ],
                [
                    102.8027989,
                    57.9648551
                ],
                [
                    102.7914911,
                    57.9605364
                ],
                [
                    102.7905419,
                    57.9601467
                ],
                [
                    102.789946,
                    57.9597902
                ],
                [
                    102.7895511,
                    57.9593491
                ],
                [
                    102.7892601,
                    57.9589227
                ],
                [
                    102.7891284,
                    57.9583051
                ],
                [
                    102.7892476,
                    57.9509891
                ],
                [
                    102.7892033,
                    57.9506714
                ],
                [
                    102.789088,
                    57.9503184
                ],
                [
                    102.7885647,
                    57.9498361
                ],
                [
                    102.7860992,
                    57.9485559
                ],
                [
                    102.785536,
                    57.9482594
                ],
                [
                    102.7851192,
                    57.9479676
                ],
                [
                    102.7848886,
                    57.9476287
                ],
                [
                    102.7848176,
                    57.9472404
                ],
                [
                    102.7849684,
                    57.9463108
                ],
                [
                    102.7851946,
                    57.9450306
                ],
                [
                    102.785332,
                    57.9440539
                ],
                [
                    102.7852699,
                    57.9432395
                ],
                [
                    102.7851369,
                    57.9425546
                ],
                [
                    102.7849773,
                    57.9414343
                ],
                [
                    102.7847777,
                    57.9408835
                ],
                [
                    102.7842412,
                    57.9400408
                ],
                [
                    102.7839086,
                    57.9395253
                ],
                [
                    102.7832257,
                    57.9388168
                ],
                [
                    102.7809602,
                    57.9356355
                ],
                [
                    102.780101,
                    57.9346754
                ],
                [
                    102.7756345,
                    57.9326931
                ],
                [
                    102.7749091,
                    57.932193
                ],
                [
                    102.7740971,
                    57.9313538
                ],
                [
                    102.7727222,
                    57.9296926
                ],
                [
                    102.7717912,
                    57.928221
                ],
                [
                    102.7716829,
                    57.9270713
                ],
                [
                    102.7720077,
                    57.9260997
                ],
                [
                    102.7721376,
                    57.9253006
                ],
                [
                    102.7719644,
                    57.9247487
                ],
                [
                    102.7716071,
                    57.9241393
                ],
                [
                    102.7709576,
                    57.9234494
                ],
                [
                    102.7694635,
                    57.9225065
                ],
                [
                    102.7677963,
                    57.9214199
                ],
                [
                    102.7662806,
                    57.919534
                ],
                [
                    102.7537066,
                    57.9162218
                ],
                [
                    102.752702,
                    57.9159642
                ],
                [
                    102.7510131,
                    57.9158262
                ],
                [
                    102.7504934,
                    57.9159136
                ],
                [
                    102.7497226,
                    57.9161712
                ],
                [
                    102.7475834,
                    57.9165392
                ],
                [
                    102.7469858,
                    57.9170821
                ],
                [
                    102.7463562,
                    57.9185243
                ],
                [
                    102.7443898,
                    57.9201303
                ],
                [
                    102.7425925,
                    57.9203773
                ],
                [
                    102.7399493,
                    57.920018
                ],
                [
                    102.7372428,
                    57.9197821
                ],
                [
                    102.7340711,
                    57.9198046
                ],
                [
                    102.7311498,
                    57.9210925
                ],
                [
                    102.7288238,
                    57.9218225
                ],
                [
                    102.7269208,
                    57.9220134
                ],
                [
                    102.726,
                    57.922
                ],
                [
                    102.7223447,
                    57.9217078
                ],
                [
                    102.7157105,
                    57.918774
                ],
                [
                    102.710345,
                    57.9178615
                ],
                [
                    102.7062217,
                    57.9179317
                ],
                [
                    102.7000104,
                    57.9183528
                ],
                [
                    102.6795907,
                    57.9251762
                ],
                [
                    102.6930579,
                    57.9661956
                ],
                [
                    102.6119575,
                    57.9824751
                ]
            ],
            "longitude": 102.734192,
            "latitude": 57.959473
        },
        "5970": {
            "name": "ЖЕЛЕЗНОДОРОЖНЫЙ",
            "population": 6760,
            "type": "town",
            "poly": null,
            "longitude": 102.775116,
            "latitude": 57.908489
        },
        "5971": {
            "name": "КУТУЛИК",
            "population": 4882,
            "type": "town",
            "poly": null,
            "longitude": 102.7949052,
            "latitude": 53.3494147
        },
        "5972": {
            "name": "УСТЬ-УДА",
            "population": 5191,
            "type": "town",
            "poly": [
                [
                    103.0100426,
                    54.1603248
                ],
                [
                    103.0117592,
                    54.1859422
                ],
                [
                    103.0238527,
                    54.1874338
                ],
                [
                    103.05767,
                    54.1763834
                ],
                [
                    103.0535502,
                    54.1694502
                ],
                [
                    103.0431732,
                    54.162335
                ],
                [
                    103.0278954,
                    54.1588171
                ],
                [
                    103.0100426,
                    54.1603248
                ]
            ],
            "longitude": 103.028229,
            "latitude": 54.174809
        },
        "5973": {
            "name": "БАЛАГАНСК",
            "population": 3885,
            "type": "town",
            "poly": [
                [
                    103.0211632,
                    54.0122708
                ],
                [
                    103.0223869,
                    54.0150237
                ],
                [
                    103.0287035,
                    54.0178131
                ],
                [
                    103.0378994,
                    54.0212191
                ],
                [
                    103.0644846,
                    54.0185849
                ],
                [
                    103.0778219,
                    54.0111162
                ],
                [
                    103.080894,
                    54.0075018
                ],
                [
                    103.0809439,
                    54.0049465
                ],
                [
                    103.0650549,
                    54.0007649
                ],
                [
                    103.0509897,
                    53.9929125
                ],
                [
                    103.0317651,
                    53.9976491
                ],
                [
                    103.0211632,
                    54.0122708
                ]
            ],
            "longitude": 103.054024,
            "latitude": 54.006798
        },
        "5974": {
            "name": "ЧЕРЕМХОВО",
            "population": 51373,
            "type": "town",
            "poly": [
                [
                    103.0058259,
                    53.0896932
                ],
                [
                    103.0161263,
                    53.0997669
                ],
                [
                    103.0138252,
                    53.1063998
                ],
                [
                    103.0175917,
                    53.1064952
                ],
                [
                    103.0211358,
                    53.1039237
                ],
                [
                    103.0276205,
                    53.1028912
                ],
                [
                    103.0245377,
                    53.0988891
                ],
                [
                    103.033495,
                    53.099006
                ],
                [
                    103.037533,
                    53.0999801
                ],
                [
                    103.039387,
                    53.1090903
                ],
                [
                    103.0407912,
                    53.1129299
                ],
                [
                    103.0408111,
                    53.1138898
                ],
                [
                    103.0390122,
                    53.1151578
                ],
                [
                    103.0345722,
                    53.1190149
                ],
                [
                    103.0375458,
                    53.1202005
                ],
                [
                    103.0341129,
                    53.1213511
                ],
                [
                    103.0293274,
                    53.1188361
                ],
                [
                    103.0289866,
                    53.1203134
                ],
                [
                    103.0288592,
                    53.1214583
                ],
                [
                    103.0260493,
                    53.1272905
                ],
                [
                    103.0232581,
                    53.1326953
                ],
                [
                    103.024854,
                    53.1333303
                ],
                [
                    103.0262843,
                    53.1356186
                ],
                [
                    103.0278133,
                    53.1372366
                ],
                [
                    103.0263836,
                    53.1397834
                ],
                [
                    103.025164,
                    53.1427489
                ],
                [
                    103.0239621,
                    53.1438095
                ],
                [
                    103.0229688,
                    53.146127
                ],
                [
                    103.0188386,
                    53.1485025
                ],
                [
                    103.0166037,
                    53.1512368
                ],
                [
                    103.0251194,
                    53.1574632
                ],
                [
                    103.0302791,
                    53.1607907
                ],
                [
                    103.0275529,
                    53.1633883
                ],
                [
                    103.0325876,
                    53.1648333
                ],
                [
                    103.0368057,
                    53.1658856
                ],
                [
                    103.0371361,
                    53.1678803
                ],
                [
                    103.0373117,
                    53.1697121
                ],
                [
                    103.0354873,
                    53.1716377
                ],
                [
                    103.0309546,
                    53.1732846
                ],
                [
                    103.0276865,
                    53.1758774
                ],
                [
                    103.0198424,
                    53.1802994
                ],
                [
                    103.0216304,
                    53.1829416
                ],
                [
                    103.0208075,
                    53.1832643
                ],
                [
                    103.0211326,
                    53.1836965
                ],
                [
                    103.0225346,
                    53.1839644
                ],
                [
                    103.0227834,
                    53.1845839
                ],
                [
                    103.0226325,
                    53.1846992
                ],
                [
                    103.022362,
                    53.1846587
                ],
                [
                    103.018794,
                    53.1864204
                ],
                [
                    103.0178774,
                    53.1869619
                ],
                [
                    103.0184754,
                    53.1874177
                ],
                [
                    103.0189827,
                    53.1876942
                ],
                [
                    103.0216745,
                    53.1863658
                ],
                [
                    103.0226432,
                    53.1869541
                ],
                [
                    103.023495,
                    53.1866074
                ],
                [
                    103.0232154,
                    53.1862061
                ],
                [
                    103.0321352,
                    53.1838824
                ],
                [
                    103.0348453,
                    53.1838138
                ],
                [
                    103.039211,
                    53.1825495
                ],
                [
                    103.047058,
                    53.1836669
                ],
                [
                    103.053996,
                    53.1841092
                ],
                [
                    103.0672583,
                    53.1854268
                ],
                [
                    103.0807303,
                    53.1861903
                ],
                [
                    103.0826416,
                    53.1855711
                ],
                [
                    103.0878843,
                    53.1880253
                ],
                [
                    103.0938077,
                    53.1912653
                ],
                [
                    103.1039265,
                    53.1968024
                ],
                [
                    103.1108866,
                    53.2005712
                ],
                [
                    103.1164224,
                    53.1962075
                ],
                [
                    103.1128237,
                    53.1933589
                ],
                [
                    103.1046783,
                    53.1873659
                ],
                [
                    103.1021688,
                    53.1859786
                ],
                [
                    103.1012365,
                    53.1846331
                ],
                [
                    103.0997524,
                    53.1834273
                ],
                [
                    103.0972819,
                    53.1818535
                ],
                [
                    103.0940731,
                    53.1795861
                ],
                [
                    103.1009024,
                    53.1761124
                ],
                [
                    103.1259973,
                    53.1553388
                ],
                [
                    103.1413806,
                    53.1614881
                ],
                [
                    103.1461666,
                    53.1640082
                ],
                [
                    103.1634766,
                    53.1557955
                ],
                [
                    103.1867614,
                    53.1601884
                ],
                [
                    103.1912442,
                    53.1497292
                ],
                [
                    103.1971645,
                    53.1484525
                ],
                [
                    103.2182194,
                    53.1469055
                ],
                [
                    103.2169841,
                    53.1447992
                ],
                [
                    103.2135656,
                    53.1399106
                ],
                [
                    103.2163391,
                    53.1352357
                ],
                [
                    103.2210319,
                    53.1250689
                ],
                [
                    103.2207832,
                    53.1201454
                ],
                [
                    103.2207848,
                    53.1197364
                ],
                [
                    103.2207075,
                    53.1178904
                ],
                [
                    103.2120081,
                    53.1197818
                ],
                [
                    103.211048,
                    53.1189956
                ],
                [
                    103.2080454,
                    53.1176794
                ],
                [
                    103.2019157,
                    53.1121676
                ],
                [
                    103.2030947,
                    53.1088139
                ],
                [
                    103.2064425,
                    53.1033136
                ],
                [
                    103.2014435,
                    53.1009952
                ],
                [
                    103.1863508,
                    53.1069365
                ],
                [
                    103.1820217,
                    53.1067839
                ],
                [
                    103.1782364,
                    53.1074946
                ],
                [
                    103.1745219,
                    53.1018616
                ],
                [
                    103.1698943,
                    53.0996029
                ],
                [
                    103.1792976,
                    53.0854123
                ],
                [
                    103.1794653,
                    53.0816809
                ],
                [
                    103.1729366,
                    53.083025
                ],
                [
                    103.1680543,
                    53.0853694
                ],
                [
                    103.1585469,
                    53.0836539
                ],
                [
                    103.1553633,
                    53.0857462
                ],
                [
                    103.1491232,
                    53.085508
                ],
                [
                    103.1487824,
                    53.0856516
                ],
                [
                    103.1463865,
                    53.0852324
                ],
                [
                    103.14586,
                    53.0855129
                ],
                [
                    103.1420955,
                    53.0854772
                ],
                [
                    103.1421038,
                    53.0854077
                ],
                [
                    103.1397178,
                    53.0852172
                ],
                [
                    103.1211042,
                    53.0802007
                ],
                [
                    103.1194778,
                    53.0857435
                ],
                [
                    103.1117301,
                    53.097107
                ],
                [
                    103.0834924,
                    53.0978359
                ],
                [
                    103.075588,
                    53.0962555
                ],
                [
                    103.078353,
                    53.0802877
                ],
                [
                    103.0812534,
                    53.075242
                ],
                [
                    103.0734018,
                    53.0659158
                ],
                [
                    103.0734468,
                    53.0720785
                ],
                [
                    103.0705537,
                    53.0838046
                ],
                [
                    103.0690084,
                    53.0949256
                ],
                [
                    103.068909,
                    53.0968193
                ],
                [
                    103.0664755,
                    53.0966851
                ],
                [
                    103.0645703,
                    53.0957808
                ],
                [
                    103.0620129,
                    53.0918408
                ],
                [
                    103.0608289,
                    53.0912204
                ],
                [
                    103.0597562,
                    53.0955056
                ],
                [
                    103.0596151,
                    53.0990471
                ],
                [
                    103.0505127,
                    53.0988827
                ],
                [
                    103.0375962,
                    53.0980453
                ],
                [
                    103.0419802,
                    53.0737916
                ],
                [
                    103.0288073,
                    53.0806692
                ],
                [
                    103.0167806,
                    53.0800383
                ],
                [
                    103.0167727,
                    53.0788974
                ],
                [
                    103.0138246,
                    53.0789405
                ],
                [
                    103.013467,
                    53.0820479
                ],
                [
                    103.009034,
                    53.0855088
                ],
                [
                    103.0058259,
                    53.0896932
                ]
            ],
            "longitude": 103.070145,
            "latitude": 53.148434
        },
        "5975": {
            "name": "МИШЕЛЁВКА",
            "population": 5783,
            "type": "town",
            "poly": null,
            "longitude": 103.184097,
            "latitude": 52.865021
        },
        "5976": {
            "name": "МИХАЙЛОВКА",
            "population": 7615,
            "type": "town",
            "poly": null,
            "longitude": 103.288483,
            "latitude": 52.960114
        },
        "5977": {
            "name": "СВИРСК",
            "population": 13194,
            "type": "town",
            "poly": [
                [
                    103.2803157,
                    53.1060968
                ],
                [
                    103.2803289,
                    53.1070343
                ],
                [
                    103.2803819,
                    53.1074581
                ],
                [
                    103.2805278,
                    53.1084781
                ],
                [
                    103.2933404,
                    53.1119721
                ],
                [
                    103.2986554,
                    53.1120006
                ],
                [
                    103.2986284,
                    53.1127002
                ],
                [
                    103.299652,
                    53.1130753
                ],
                [
                    103.3026628,
                    53.1114646
                ],
                [
                    103.311865,
                    53.1126714
                ],
                [
                    103.3119024,
                    53.1106324
                ],
                [
                    103.3098554,
                    53.1105611
                ],
                [
                    103.3089299,
                    53.110516
                ],
                [
                    103.3082149,
                    53.1104544
                ],
                [
                    103.3080568,
                    53.1088235
                ],
                [
                    103.3135925,
                    53.1070514
                ],
                [
                    103.3211216,
                    53.1064963
                ],
                [
                    103.3300844,
                    53.1146951
                ],
                [
                    103.3310984,
                    53.116679
                ],
                [
                    103.326325,
                    53.1170256
                ],
                [
                    103.3232772,
                    53.1186011
                ],
                [
                    103.3193711,
                    53.1211303
                ],
                [
                    103.3168174,
                    53.1223823
                ],
                [
                    103.3161841,
                    53.1236051
                ],
                [
                    103.314224,
                    53.1237235
                ],
                [
                    103.3116854,
                    53.1241807
                ],
                [
                    103.3117405,
                    53.1251581
                ],
                [
                    103.3154363,
                    53.1249044
                ],
                [
                    103.3153049,
                    53.1267488
                ],
                [
                    103.3150657,
                    53.1286437
                ],
                [
                    103.3144865,
                    53.1313719
                ],
                [
                    103.3338746,
                    53.1300217
                ],
                [
                    103.3348885,
                    53.1268635
                ],
                [
                    103.3362165,
                    53.1235941
                ],
                [
                    103.336796,
                    53.1209229
                ],
                [
                    103.3401266,
                    53.1179277
                ],
                [
                    103.3364185,
                    53.1133851
                ],
                [
                    103.3363804,
                    53.1109154
                ],
                [
                    103.3409549,
                    53.1107688
                ],
                [
                    103.3418236,
                    53.1110731
                ],
                [
                    103.3422186,
                    53.1114939
                ],
                [
                    103.3425658,
                    53.1117256
                ],
                [
                    103.3429078,
                    53.112003
                ],
                [
                    103.3429995,
                    53.1121227
                ],
                [
                    103.3430371,
                    53.1123184
                ],
                [
                    103.3433836,
                    53.112651
                ],
                [
                    103.3437479,
                    53.1128545
                ],
                [
                    103.3445145,
                    53.1133212
                ],
                [
                    103.3445832,
                    53.1134122
                ],
                [
                    103.3447006,
                    53.1134888
                ],
                [
                    103.345118,
                    53.1134949
                ],
                [
                    103.3457124,
                    53.1137314
                ],
                [
                    103.3468035,
                    53.1140964
                ],
                [
                    103.3470426,
                    53.1141101
                ],
                [
                    103.3472673,
                    53.1141488
                ],
                [
                    103.3474158,
                    53.114132
                ],
                [
                    103.3475632,
                    53.114062
                ],
                [
                    103.3476999,
                    53.1138866
                ],
                [
                    103.3476394,
                    53.1131553
                ],
                [
                    103.3476849,
                    53.1128073
                ],
                [
                    103.347405,
                    53.1118515
                ],
                [
                    103.3472873,
                    53.11161
                ],
                [
                    103.3470115,
                    53.1108274
                ],
                [
                    103.3467147,
                    53.1104667
                ],
                [
                    103.3463342,
                    53.1098865
                ],
                [
                    103.3462522,
                    53.1097236
                ],
                [
                    103.3461683,
                    53.109511
                ],
                [
                    103.3460266,
                    53.1085374
                ],
                [
                    103.3459922,
                    53.1078216
                ],
                [
                    103.3456173,
                    53.1076069
                ],
                [
                    103.3453332,
                    53.1053122
                ],
                [
                    103.3463915,
                    53.1046501
                ],
                [
                    103.3465209,
                    53.1042695
                ],
                [
                    103.3477434,
                    53.1034098
                ],
                [
                    103.3481778,
                    53.1029412
                ],
                [
                    103.3487653,
                    53.1021843
                ],
                [
                    103.3488213,
                    53.1019706
                ],
                [
                    103.3502172,
                    53.1013787
                ],
                [
                    103.3507463,
                    53.1011929
                ],
                [
                    103.3513243,
                    53.1007692
                ],
                [
                    103.3524551,
                    53.1000715
                ],
                [
                    103.3527399,
                    53.1000681
                ],
                [
                    103.3530604,
                    53.1000134
                ],
                [
                    103.3532772,
                    53.0999224
                ],
                [
                    103.3536182,
                    53.0996246
                ],
                [
                    103.3537938,
                    53.0993857
                ],
                [
                    103.3538613,
                    53.0991263
                ],
                [
                    103.3539782,
                    53.0988526
                ],
                [
                    103.3542175,
                    53.0986474
                ],
                [
                    103.3543311,
                    53.0985109
                ],
                [
                    103.3547048,
                    53.0976242
                ],
                [
                    103.355027,
                    53.0969551
                ],
                [
                    103.3550131,
                    53.0967954
                ],
                [
                    103.3551009,
                    53.0965442
                ],
                [
                    103.3554574,
                    53.0965224
                ],
                [
                    103.3556692,
                    53.0959392
                ],
                [
                    103.3557571,
                    53.0958399
                ],
                [
                    103.3557829,
                    53.0957159
                ],
                [
                    103.355974,
                    53.0956073
                ],
                [
                    103.3559971,
                    53.0953712
                ],
                [
                    103.3561616,
                    53.0950762
                ],
                [
                    103.3567593,
                    53.0936528
                ],
                [
                    103.3569313,
                    53.0928626
                ],
                [
                    103.3570636,
                    53.0924676
                ],
                [
                    103.3572343,
                    53.0918956
                ],
                [
                    103.3575963,
                    53.0905006
                ],
                [
                    103.3575963,
                    53.0902617
                ],
                [
                    103.3576273,
                    53.0900817
                ],
                [
                    103.3577071,
                    53.0898406
                ],
                [
                    103.3577668,
                    53.0895046
                ],
                [
                    103.3580406,
                    53.0873544
                ],
                [
                    103.3580564,
                    53.0862447
                ],
                [
                    103.3579889,
                    53.0860294
                ],
                [
                    103.3580664,
                    53.0856415
                ],
                [
                    103.3581646,
                    53.083339
                ],
                [
                    103.3582576,
                    53.0827153
                ],
                [
                    103.3581544,
                    53.0823299
                ],
                [
                    103.3581511,
                    53.0819989
                ],
                [
                    103.3577668,
                    53.0807416
                ],
                [
                    103.3575578,
                    53.0805049
                ],
                [
                    103.3574681,
                    53.0802719
                ],
                [
                    103.3573415,
                    53.0800202
                ],
                [
                    103.356625,
                    53.0789602
                ],
                [
                    103.3563202,
                    53.0787026
                ],
                [
                    103.3561064,
                    53.0784673
                ],
                [
                    103.3556358,
                    53.0783031
                ],
                [
                    103.3554109,
                    53.0783364
                ],
                [
                    103.3547832,
                    53.0783488
                ],
                [
                    103.3537746,
                    53.0787657
                ],
                [
                    103.3532254,
                    53.0793146
                ],
                [
                    103.352956,
                    53.0798258
                ],
                [
                    103.3528628,
                    53.0801366
                ],
                [
                    103.3513596,
                    53.0831204
                ],
                [
                    103.3473594,
                    53.0801408
                ],
                [
                    103.3485957,
                    53.0782869
                ],
                [
                    103.3489238,
                    53.0775748
                ],
                [
                    103.3490259,
                    53.0770511
                ],
                [
                    103.3490878,
                    53.0761793
                ],
                [
                    103.3492687,
                    53.0754806
                ],
                [
                    103.3492901,
                    53.0747415
                ],
                [
                    103.3492377,
                    53.074357
                ],
                [
                    103.3492417,
                    53.0736503
                ],
                [
                    103.3493088,
                    53.0730496
                ],
                [
                    103.3492803,
                    53.0726117
                ],
                [
                    103.3493204,
                    53.071489
                ],
                [
                    103.3494614,
                    53.0707578
                ],
                [
                    103.3494811,
                    53.0703524
                ],
                [
                    103.3497285,
                    53.0696203
                ],
                [
                    103.3497802,
                    53.0692633
                ],
                [
                    103.349868,
                    53.0691268
                ],
                [
                    103.3498629,
                    53.0689964
                ],
                [
                    103.3498112,
                    53.0688381
                ],
                [
                    103.349806,
                    53.0687077
                ],
                [
                    103.3498876,
                    53.0685765
                ],
                [
                    103.3501987,
                    53.0682296
                ],
                [
                    103.3504002,
                    53.0679254
                ],
                [
                    103.3504683,
                    53.0677647
                ],
                [
                    103.350674,
                    53.0666526
                ],
                [
                    103.3505138,
                    53.0664415
                ],
                [
                    103.3504157,
                    53.0663608
                ],
                [
                    103.35055,
                    53.0662118
                ],
                [
                    103.3506947,
                    53.0661063
                ],
                [
                    103.3508091,
                    53.0657966
                ],
                [
                    103.3509919,
                    53.0650397
                ],
                [
                    103.3509941,
                    53.0648436
                ],
                [
                    103.3510526,
                    53.0647213
                ],
                [
                    103.351077,
                    53.0644298
                ],
                [
                    103.3511648,
                    53.0639797
                ],
                [
                    103.351232,
                    53.0638493
                ],
                [
                    103.351232,
                    53.0636878
                ],
                [
                    103.3511545,
                    53.0635419
                ],
                [
                    103.3511518,
                    53.0634622
                ],
                [
                    103.3512806,
                    53.0633446
                ],
                [
                    103.3512732,
                    53.0631553
                ],
                [
                    103.3510714,
                    53.0620338
                ],
                [
                    103.3510265,
                    53.0615919
                ],
                [
                    103.3510862,
                    53.0610853
                ],
                [
                    103.3508031,
                    53.0601438
                ],
                [
                    103.350639,
                    53.0593502
                ],
                [
                    103.3503342,
                    53.0588317
                ],
                [
                    103.3498899,
                    53.0579468
                ],
                [
                    103.3499364,
                    53.0577387
                ],
                [
                    103.3497452,
                    53.0573164
                ],
                [
                    103.3496264,
                    53.0571798
                ],
                [
                    103.3495799,
                    53.0569904
                ],
                [
                    103.3494456,
                    53.0567451
                ],
                [
                    103.3493939,
                    53.0565992
                ],
                [
                    103.3493629,
                    53.0564563
                ],
                [
                    103.3490839,
                    53.0561551
                ],
                [
                    103.3487791,
                    53.055649
                ],
                [
                    103.348619,
                    53.0552515
                ],
                [
                    103.3485673,
                    53.0550963
                ],
                [
                    103.348433,
                    53.0550217
                ],
                [
                    103.3484226,
                    53.0548975
                ],
                [
                    103.348309,
                    53.0546367
                ],
                [
                    103.3482573,
                    53.054441
                ],
                [
                    103.3481333,
                    53.0543479
                ],
                [
                    103.348154,
                    53.0542827
                ],
                [
                    103.3480713,
                    53.0539442
                ],
                [
                    103.3478285,
                    53.0536709
                ],
                [
                    103.3476425,
                    53.0532921
                ],
                [
                    103.3475185,
                    53.0531368
                ],
                [
                    103.3472551,
                    53.0526337
                ],
                [
                    103.3471672,
                    53.0524319
                ],
                [
                    103.3469916,
                    53.0522828
                ],
                [
                    103.3469554,
                    53.0521555
                ],
                [
                    103.3468727,
                    53.0520934
                ],
                [
                    103.3467332,
                    53.0520096
                ],
                [
                    103.3467178,
                    53.0519195
                ],
                [
                    103.3466351,
                    53.0518636
                ],
                [
                    103.3464749,
                    53.0516058
                ],
                [
                    103.3464388,
                    53.0514972
                ],
                [
                    103.3463096,
                    53.0514164
                ],
                [
                    103.3463509,
                    53.0512673
                ],
                [
                    103.3460306,
                    53.0509102
                ],
                [
                    103.3458343,
                    53.0505655
                ],
                [
                    103.3456896,
                    53.0503792
                ],
                [
                    103.3456328,
                    53.0501028
                ],
                [
                    103.345421,
                    53.0494195
                ],
                [
                    103.3453073,
                    53.0489785
                ],
                [
                    103.3451605,
                    53.0490381
                ],
                [
                    103.3450313,
                    53.0490443
                ],
                [
                    103.3441995,
                    53.0492182
                ],
                [
                    103.343812,
                    53.049243
                ],
                [
                    103.3436157,
                    53.049153
                ],
                [
                    103.3411565,
                    53.0492337
                ],
                [
                    103.3408724,
                    53.0491406
                ],
                [
                    103.3412805,
                    53.0483641
                ],
                [
                    103.341637,
                    53.048302
                ],
                [
                    103.3416577,
                    53.0481561
                ],
                [
                    103.3289203,
                    53.0484708
                ],
                [
                    103.3290702,
                    53.0533863
                ],
                [
                    103.3304897,
                    53.0530412
                ],
                [
                    103.3311959,
                    53.0529331
                ],
                [
                    103.3326169,
                    53.0529088
                ],
                [
                    103.3322882,
                    53.0536042
                ],
                [
                    103.330628,
                    53.0641942
                ],
                [
                    103.325517,
                    53.0676506
                ],
                [
                    103.317011,
                    53.0715506
                ],
                [
                    103.3007472,
                    53.0691584
                ],
                [
                    103.3001916,
                    53.069516
                ],
                [
                    103.3021163,
                    53.0750237
                ],
                [
                    103.3043845,
                    53.0849252
                ],
                [
                    103.3039781,
                    53.0863359
                ],
                [
                    103.3079849,
                    53.0857843
                ],
                [
                    103.3172437,
                    53.0856808
                ],
                [
                    103.3177171,
                    53.08634
                ],
                [
                    103.3186107,
                    53.0901253
                ],
                [
                    103.3180889,
                    53.0978847
                ],
                [
                    103.2888713,
                    53.0994855
                ],
                [
                    103.2867255,
                    53.0996365
                ],
                [
                    103.284728,
                    53.1000136
                ],
                [
                    103.2831061,
                    53.1027093
                ],
                [
                    103.2803157,
                    53.1060968
                ]
            ],
            "longitude": 103.342331,
            "latitude": 53.066269
        },
        "5978": {
            "name": "СРЕДНИЙ",
            "population": 5229,
            "type": "town",
            "poly": null,
            "longitude": 103.48864,
            "latitude": 52.882076
        },
        "5979": {
            "name": "БЕЛОРЕЧЕНСКИЙ",
            "population": 7882,
            "type": "town",
            "poly": null,
            "longitude": 103.525436,
            "latitude": 52.814842
        },
        "5980": {
            "name": "УСОЛЬЕ-СИБИРСКОЕ",
            "population": 79363,
            "type": "town",
            "poly": [
                [
                    103.5605218,
                    52.8033108
                ],
                [
                    103.5612667,
                    52.8039936
                ],
                [
                    103.5617665,
                    52.8037902
                ],
                [
                    103.5619155,
                    52.8053155
                ],
                [
                    103.5627181,
                    52.8066519
                ],
                [
                    103.5637033,
                    52.8073694
                ],
                [
                    103.5645347,
                    52.8078197
                ],
                [
                    103.5661591,
                    52.8086041
                ],
                [
                    103.5676008,
                    52.8091183
                ],
                [
                    103.5690474,
                    52.8093739
                ],
                [
                    103.5700326,
                    52.8094611
                ],
                [
                    103.5707535,
                    52.8094757
                ],
                [
                    103.5721952,
                    52.8093934
                ],
                [
                    103.5734397,
                    52.8104409
                ],
                [
                    103.5762575,
                    52.8082324
                ],
                [
                    103.5774456,
                    52.8071054
                ],
                [
                    103.5796669,
                    52.8057569
                ],
                [
                    103.5820573,
                    52.8053821
                ],
                [
                    103.5834192,
                    52.8052515
                ],
                [
                    103.5835601,
                    52.8051607
                ],
                [
                    103.5824565,
                    52.8043061
                ],
                [
                    103.5850911,
                    52.8022307
                ],
                [
                    103.5888105,
                    52.8028468
                ],
                [
                    103.5889561,
                    52.8024863
                ],
                [
                    103.5927365,
                    52.8029207
                ],
                [
                    103.5934832,
                    52.8032954
                ],
                [
                    103.5918909,
                    52.8077881
                ],
                [
                    103.5966341,
                    52.8094857
                ],
                [
                    103.593648,
                    52.8149294
                ],
                [
                    103.5847138,
                    52.8222551
                ],
                [
                    103.5995326,
                    52.8334674
                ],
                [
                    103.6232219,
                    52.8358526
                ],
                [
                    103.6649356,
                    52.8227843
                ],
                [
                    103.6783209,
                    52.8005281
                ],
                [
                    103.6826339,
                    52.7806331
                ],
                [
                    103.6812606,
                    52.7733643
                ],
                [
                    103.6862756,
                    52.7514816
                ],
                [
                    103.6869049,
                    52.7511551
                ],
                [
                    103.689128,
                    52.7491663
                ],
                [
                    103.6896347,
                    52.7480878
                ],
                [
                    103.6895122,
                    52.7473259
                ],
                [
                    103.6882044,
                    52.7474001
                ],
                [
                    103.6880492,
                    52.7462177
                ],
                [
                    103.6878939,
                    52.7457328
                ],
                [
                    103.6878612,
                    52.7450846
                ],
                [
                    103.6878612,
                    52.7448818
                ],
                [
                    103.6877631,
                    52.7444266
                ],
                [
                    103.6875261,
                    52.7442683
                ],
                [
                    103.6874525,
                    52.7437141
                ],
                [
                    103.6874934,
                    52.7426849
                ],
                [
                    103.6874035,
                    52.742586
                ],
                [
                    103.6875342,
                    52.7420268
                ],
                [
                    103.6879994,
                    52.7407558
                ],
                [
                    103.6878816,
                    52.7407716
                ],
                [
                    103.6828076,
                    52.7398482
                ],
                [
                    103.6831749,
                    52.7377447
                ],
                [
                    103.6835344,
                    52.7365648
                ],
                [
                    103.6848921,
                    52.7349835
                ],
                [
                    103.6821189,
                    52.7307816
                ],
                [
                    103.681561,
                    52.7307842
                ],
                [
                    103.6774004,
                    52.729145
                ],
                [
                    103.6759915,
                    52.7271926
                ],
                [
                    103.6720353,
                    52.7259819
                ],
                [
                    103.6695363,
                    52.7279074
                ],
                [
                    103.6686981,
                    52.7270715
                ],
                [
                    103.6665348,
                    52.7231518
                ],
                [
                    103.6664797,
                    52.7230479
                ],
                [
                    103.6662952,
                    52.7227522
                ],
                [
                    103.666003,
                    52.7224029
                ],
                [
                    103.6655455,
                    52.7220513
                ],
                [
                    103.6648573,
                    52.7216624
                ],
                [
                    103.6645285,
                    52.7215533
                ],
                [
                    103.6641883,
                    52.7214644
                ],
                [
                    103.6632579,
                    52.7212456
                ],
                [
                    103.6624236,
                    52.7211617
                ],
                [
                    103.6611126,
                    52.7212106
                ],
                [
                    103.6599323,
                    52.7214528
                ],
                [
                    103.6593748,
                    52.7216484
                ],
                [
                    103.6597823,
                    52.7212595
                ],
                [
                    103.6581714,
                    52.7213364
                ],
                [
                    103.65796,
                    52.721546
                ],
                [
                    103.6574332,
                    52.7215949
                ],
                [
                    103.6571949,
                    52.721865
                ],
                [
                    103.6568104,
                    52.7218254
                ],
                [
                    103.6552149,
                    52.7214039
                ],
                [
                    103.6532771,
                    52.7215203
                ],
                [
                    103.6501899,
                    52.7212269
                ],
                [
                    103.6495247,
                    52.721192
                ],
                [
                    103.6491826,
                    52.7211198
                ],
                [
                    103.6489288,
                    52.7211175
                ],
                [
                    103.6487943,
                    52.7211547
                ],
                [
                    103.6485367,
                    52.721348
                ],
                [
                    103.6457916,
                    52.7211338
                ],
                [
                    103.6370251,
                    52.7188111
                ],
                [
                    103.6416132,
                    52.7149584
                ],
                [
                    103.6432201,
                    52.712461
                ],
                [
                    103.6431525,
                    52.7121971
                ],
                [
                    103.6424091,
                    52.7114829
                ],
                [
                    103.6419361,
                    52.7108688
                ],
                [
                    103.6416057,
                    52.7101636
                ],
                [
                    103.6416057,
                    52.7096632
                ],
                [
                    103.6419661,
                    52.7082847
                ],
                [
                    103.6420187,
                    52.707948
                ],
                [
                    103.6418384,
                    52.707534
                ],
                [
                    103.6412978,
                    52.7071746
                ],
                [
                    103.6404493,
                    52.7067287
                ],
                [
                    103.6390901,
                    52.706806
                ],
                [
                    103.6360114,
                    52.7068242
                ],
                [
                    103.6342317,
                    52.7068879
                ],
                [
                    103.6220669,
                    52.7069334
                ],
                [
                    103.6215788,
                    52.7069926
                ],
                [
                    103.6163675,
                    52.7070108
                ],
                [
                    103.5976998,
                    52.7064602
                ],
                [
                    103.597865,
                    52.7079253
                ],
                [
                    103.599885,
                    52.7084848
                ],
                [
                    103.5992767,
                    52.7116558
                ],
                [
                    103.5980678,
                    52.7186292
                ],
                [
                    103.5978876,
                    52.7198254
                ],
                [
                    103.5977899,
                    52.7237277
                ],
                [
                    103.5976923,
                    52.7291759
                ],
                [
                    103.5956348,
                    52.729094
                ],
                [
                    103.595755,
                    52.7289667
                ],
                [
                    103.5895074,
                    52.7260881
                ],
                [
                    103.5802336,
                    52.7338594
                ],
                [
                    103.5744336,
                    52.7387535
                ],
                [
                    103.5773591,
                    52.7399173
                ],
                [
                    103.5803928,
                    52.7412957
                ],
                [
                    103.5806691,
                    52.7413757
                ],
                [
                    103.5809214,
                    52.741303
                ],
                [
                    103.5821922,
                    52.7403869
                ],
                [
                    103.5832665,
                    52.7394976
                ],
                [
                    103.5834415,
                    52.7392903
                ],
                [
                    103.5841999,
                    52.7386765
                ],
                [
                    103.5843802,
                    52.7385765
                ],
                [
                    103.5846955,
                    52.7385538
                ],
                [
                    103.5848307,
                    52.738481
                ],
                [
                    103.593331,
                    52.7414043
                ],
                [
                    103.5925125,
                    52.7420817
                ],
                [
                    103.5930907,
                    52.7423635
                ],
                [
                    103.5932484,
                    52.7424953
                ],
                [
                    103.5923924,
                    52.7435727
                ],
                [
                    103.5919118,
                    52.74395
                ],
                [
                    103.592092,
                    52.7443228
                ],
                [
                    103.5917842,
                    52.7443455
                ],
                [
                    103.5902598,
                    52.7464411
                ],
                [
                    103.5899745,
                    52.7464593
                ],
                [
                    103.5896891,
                    52.7466366
                ],
                [
                    103.5897642,
                    52.7470229
                ],
                [
                    103.5857717,
                    52.7523321
                ],
                [
                    103.5815089,
                    52.757684
                ],
                [
                    103.5813936,
                    52.758033
                ],
                [
                    103.5798125,
                    52.7599001
                ],
                [
                    103.5855603,
                    52.7637011
                ],
                [
                    103.5854737,
                    52.7639803
                ],
                [
                    103.5862811,
                    52.7644979
                ],
                [
                    103.5876508,
                    52.7671005
                ],
                [
                    103.5888715,
                    52.7674203
                ],
                [
                    103.5883909,
                    52.7676995
                ],
                [
                    103.5875931,
                    52.768502
                ],
                [
                    103.5857813,
                    52.769636
                ],
                [
                    103.5847192,
                    52.7704094
                ],
                [
                    103.5845558,
                    52.7705461
                ],
                [
                    103.5852767,
                    52.7707787
                ],
                [
                    103.5845702,
                    52.7712148
                ],
                [
                    103.5846327,
                    52.7712642
                ],
                [
                    103.5836716,
                    52.7720115
                ],
                [
                    103.5834265,
                    52.7722819
                ],
                [
                    103.5835706,
                    52.7723429
                ],
                [
                    103.5826047,
                    52.7735495
                ],
                [
                    103.5824076,
                    52.7738751
                ],
                [
                    103.5824989,
                    52.773942
                ],
                [
                    103.5823548,
                    52.7741978
                ],
                [
                    103.5820808,
                    52.7742589
                ],
                [
                    103.581533,
                    52.7747473
                ],
                [
                    103.5813792,
                    52.7749886
                ],
                [
                    103.5811533,
                    52.7751776
                ],
                [
                    103.5812879,
                    52.7752735
                ],
                [
                    103.5807256,
                    52.7755352
                ],
                [
                    103.5804901,
                    52.7754392
                ],
                [
                    103.5803075,
                    52.7755701
                ],
                [
                    103.5801152,
                    52.775573
                ],
                [
                    103.5799326,
                    52.7757794
                ],
                [
                    103.5794328,
                    52.7764626
                ],
                [
                    103.5804132,
                    52.7765585
                ],
                [
                    103.5829026,
                    52.7767359
                ],
                [
                    103.5838974,
                    52.7764393
                ],
                [
                    103.5816627,
                    52.7795877
                ],
                [
                    103.5759053,
                    52.7877787
                ],
                [
                    103.5760255,
                    52.7881217
                ],
                [
                    103.5752806,
                    52.7888774
                ],
                [
                    103.5747423,
                    52.7896592
                ],
                [
                    103.5738052,
                    52.7914465
                ],
                [
                    103.5729113,
                    52.7912808
                ],
                [
                    103.5719309,
                    52.7931001
                ],
                [
                    103.5733534,
                    52.7933849
                ],
                [
                    103.5732477,
                    52.7936261
                ],
                [
                    103.5718059,
                    52.7933151
                ],
                [
                    103.5715176,
                    52.7938004
                ],
                [
                    103.5724691,
                    52.7940184
                ],
                [
                    103.5717098,
                    52.7954336
                ],
                [
                    103.5701864,
                    52.7980982
                ],
                [
                    103.5694319,
                    52.7989699
                ],
                [
                    103.5686101,
                    52.7995859
                ],
                [
                    103.567596,
                    52.8001874
                ],
                [
                    103.5619636,
                    52.8025757
                ],
                [
                    103.5605218,
                    52.8033108
                ]
            ],
            "longitude": 103.662079,
            "latitude": 52.75116
        },
        "5981": {
            "name": "ТЕЛЬМА",
            "population": 5018,
            "type": "town",
            "poly": [
                [
                    103.7035188,
                    52.7051422
                ],
                [
                    103.7046928,
                    52.7054282
                ],
                [
                    103.7041057,
                    52.7064432
                ],
                [
                    103.7048918,
                    52.7065842
                ],
                [
                    103.7046168,
                    52.7075422
                ],
                [
                    103.7047848,
                    52.7084842
                ],
                [
                    103.7051128,
                    52.7088352
                ],
                [
                    103.7060898,
                    52.7089762
                ],
                [
                    103.7065548,
                    52.7083392
                ],
                [
                    103.7075318,
                    52.7086172
                ],
                [
                    103.7083098,
                    52.7081022
                ],
                [
                    103.7086678,
                    52.7078662
                ],
                [
                    103.7090647,
                    52.7078012
                ],
                [
                    103.7094158,
                    52.7075571
                ],
                [
                    103.7095688,
                    52.7073852
                ],
                [
                    103.7105988,
                    52.7080222
                ],
                [
                    103.7109648,
                    52.7085332
                ],
                [
                    103.7116128,
                    52.7083662
                ],
                [
                    103.7120018,
                    52.7081481
                ],
                [
                    103.7117658,
                    52.7080721
                ],
                [
                    103.7121698,
                    52.7074692
                ],
                [
                    103.7128648,
                    52.7076682
                ],
                [
                    103.7130548,
                    52.7079762
                ],
                [
                    103.7135438,
                    52.7078122
                ],
                [
                    103.7130168,
                    52.7075072
                ],
                [
                    103.7135358,
                    52.7069622
                ],
                [
                    103.7141228,
                    52.7068852
                ],
                [
                    103.7149237,
                    52.7069622
                ],
                [
                    103.7157328,
                    52.7068322
                ],
                [
                    103.7160768,
                    52.7066872
                ],
                [
                    103.7168778,
                    52.7064162
                ],
                [
                    103.7174348,
                    52.7059202
                ],
                [
                    103.7176558,
                    52.7055542
                ],
                [
                    103.7183808,
                    52.7057072
                ],
                [
                    103.7191438,
                    52.7064432
                ],
                [
                    103.7192658,
                    52.7064511
                ],
                [
                    103.7202348,
                    52.7061262
                ],
                [
                    103.7208298,
                    52.7059242
                ],
                [
                    103.7226838,
                    52.7051802
                ],
                [
                    103.7244228,
                    52.7043752
                ],
                [
                    103.7258798,
                    52.7036052
                ],
                [
                    103.7265438,
                    52.7030482
                ],
                [
                    103.7269708,
                    52.7026552
                ],
                [
                    103.7271618,
                    52.7026552
                ],
                [
                    103.7273988,
                    52.7024342
                ],
                [
                    103.7280548,
                    52.7015182
                ],
                [
                    103.7289018,
                    52.7001792
                ],
                [
                    103.7290308,
                    52.6998662
                ],
                [
                    103.7289698,
                    52.6996382
                ],
                [
                    103.7289018,
                    52.6995692
                ],
                [
                    103.7294808,
                    52.6997522
                ],
                [
                    103.7302668,
                    52.6990162
                ],
                [
                    103.7318458,
                    52.6975322
                ],
                [
                    103.7312438,
                    52.6973792
                ],
                [
                    103.7293818,
                    52.6988402
                ],
                [
                    103.7285507,
                    52.6988062
                ],
                [
                    103.7258728,
                    52.6992071
                ],
                [
                    103.7245068,
                    52.6995122
                ],
                [
                    103.7218518,
                    52.6996492
                ],
                [
                    103.7218138,
                    52.6990502
                ],
                [
                    103.7223248,
                    52.6990122
                ],
                [
                    103.7225388,
                    52.6980962
                ],
                [
                    103.7210808,
                    52.6978102
                ],
                [
                    103.7208448,
                    52.6982722
                ],
                [
                    103.7211958,
                    52.6983602
                ],
                [
                    103.7210968,
                    52.6987492
                ],
                [
                    103.7190978,
                    52.6984662
                ],
                [
                    103.7178688,
                    52.6981652
                ],
                [
                    103.7182508,
                    52.6973721
                ],
                [
                    103.7190438,
                    52.6964032
                ],
                [
                    103.7200898,
                    52.6954872
                ],
                [
                    103.7202498,
                    52.6952772
                ],
                [
                    103.7210197,
                    52.6954301
                ],
                [
                    103.7212948,
                    52.6949072
                ],
                [
                    103.7216768,
                    52.6939732
                ],
                [
                    103.7219968,
                    52.6932102
                ],
                [
                    103.7230118,
                    52.6917342
                ],
                [
                    103.7230568,
                    52.6916192
                ],
                [
                    103.7223098,
                    52.6914322
                ],
                [
                    103.7226378,
                    52.6906962
                ],
                [
                    103.7221268,
                    52.6905622
                ],
                [
                    103.7218518,
                    52.6908711
                ],
                [
                    103.7210428,
                    52.6906042
                ],
                [
                    103.7207378,
                    52.6908372
                ],
                [
                    103.7206308,
                    52.6907762
                ],
                [
                    103.7194328,
                    52.6903912
                ],
                [
                    103.7199368,
                    52.6898452
                ],
                [
                    103.7196088,
                    52.6896242
                ],
                [
                    103.7218748,
                    52.6870952
                ],
                [
                    103.7203408,
                    52.6866372
                ],
                [
                    103.7193418,
                    52.6864312
                ],
                [
                    103.7157708,
                    52.6854662
                ],
                [
                    103.7145048,
                    52.6868322
                ],
                [
                    103.7135208,
                    52.6869842
                ],
                [
                    103.7130858,
                    52.6870642
                ],
                [
                    103.7130478,
                    52.6874422
                ],
                [
                    103.7113688,
                    52.6872672
                ],
                [
                    103.7085688,
                    52.6860802
                ],
                [
                    103.7078138,
                    52.6866332
                ],
                [
                    103.7093858,
                    52.6874112
                ],
                [
                    103.7096068,
                    52.6874112
                ],
                [
                    103.7099118,
                    52.6873432
                ],
                [
                    103.7104228,
                    52.6873692
                ],
                [
                    103.7106438,
                    52.6874151
                ],
                [
                    103.7105378,
                    52.6876752
                ],
                [
                    103.7100568,
                    52.6881131
                ],
                [
                    103.7093398,
                    52.6888762
                ],
                [
                    103.7092478,
                    52.6890822
                ],
                [
                    103.7090568,
                    52.6895252
                ],
                [
                    103.7085158,
                    52.6896242
                ],
                [
                    103.7086148,
                    52.6904592
                ],
                [
                    103.7090418,
                    52.6905202
                ],
                [
                    103.7089348,
                    52.6914592
                ],
                [
                    103.7074547,
                    52.6914862
                ],
                [
                    103.7075318,
                    52.6916842
                ],
                [
                    103.7077988,
                    52.6918292
                ],
                [
                    103.7081648,
                    52.6920312
                ],
                [
                    103.7088668,
                    52.6939312
                ],
                [
                    103.7094918,
                    52.6939652
                ],
                [
                    103.7101408,
                    52.6940952
                ],
                [
                    103.7112468,
                    52.6945032
                ],
                [
                    103.7122848,
                    52.6948462
                ],
                [
                    103.7127648,
                    52.6950142
                ],
                [
                    103.7129707,
                    52.6955102
                ],
                [
                    103.7128868,
                    52.6962962
                ],
                [
                    103.7129707,
                    52.6963612
                ],
                [
                    103.7131618,
                    52.6963762
                ],
                [
                    103.7133987,
                    52.6962732
                ],
                [
                    103.7151838,
                    52.6963802
                ],
                [
                    103.7150307,
                    52.6971812
                ],
                [
                    103.7146418,
                    52.6980812
                ],
                [
                    103.7143217,
                    52.6987602
                ],
                [
                    103.7139557,
                    52.6995732
                ],
                [
                    103.7143138,
                    52.6996262
                ],
                [
                    103.7173738,
                    52.7002402
                ],
                [
                    103.7172058,
                    52.7012782
                ],
                [
                    103.7157177,
                    52.7011372
                ],
                [
                    103.7155878,
                    52.7012892
                ],
                [
                    103.7157328,
                    52.7014802
                ],
                [
                    103.7158478,
                    52.7017092
                ],
                [
                    103.7157328,
                    52.7023922
                ],
                [
                    103.7135507,
                    52.7022772
                ],
                [
                    103.7117658,
                    52.7021132
                ],
                [
                    103.7113228,
                    52.7021322
                ],
                [
                    103.7108657,
                    52.7021822
                ],
                [
                    103.7105378,
                    52.7023152
                ],
                [
                    103.7103848,
                    52.7023922
                ],
                [
                    103.7088358,
                    52.7015642
                ],
                [
                    103.7084548,
                    52.7016062
                ],
                [
                    103.7083938,
                    52.7016402
                ],
                [
                    103.7055858,
                    52.7034562
                ],
                [
                    103.7041208,
                    52.7041922
                ],
                [
                    103.7035188,
                    52.7051422
                ]
            ],
            "longitude": 103.715691,
            "latitude": 52.695877
        },
        "5982": {
            "name": "СЛЮДЯНКА",
            "population": 18425,
            "type": "town",
            "poly": [
                [
                    103.6727046,
                    51.6696283
                ],
                [
                    103.6810988,
                    51.6784182
                ],
                [
                    103.6991892,
                    51.677384
                ],
                [
                    103.7038722,
                    51.6762701
                ],
                [
                    103.7073278,
                    51.6753093
                ],
                [
                    103.7095692,
                    51.6720011
                ],
                [
                    103.7111617,
                    51.6696505
                ],
                [
                    103.7128486,
                    51.667558
                ],
                [
                    103.7142309,
                    51.6669862
                ],
                [
                    103.7238136,
                    51.6626118
                ],
                [
                    103.7294112,
                    51.660186
                ],
                [
                    103.732555,
                    51.6575698
                ],
                [
                    103.7338585,
                    51.6548108
                ],
                [
                    103.7352387,
                    51.6524797
                ],
                [
                    103.737079,
                    51.6514807
                ],
                [
                    103.7341162,
                    51.6498869
                ],
                [
                    103.7053269,
                    51.6325549
                ],
                [
                    103.6937609,
                    51.6357219
                ],
                [
                    103.6914846,
                    51.6378078
                ],
                [
                    103.6727046,
                    51.6696283
                ]
            ],
            "longitude": 103.719292,
            "latitude": 51.656769
        },
        "5983": {
            "name": "БОХАН",
            "population": 5170,
            "type": "town",
            "poly": [
                [
                    103.7622309,
                    53.1568909
                ],
                [
                    103.7651209,
                    53.1592014
                ],
                [
                    103.7742727,
                    53.1596635
                ],
                [
                    103.7860818,
                    53.1635007
                ],
                [
                    103.7946974,
                    53.1628992
                ],
                [
                    103.7966729,
                    53.1541177
                ],
                [
                    103.7868682,
                    53.1425782
                ],
                [
                    103.7690463,
                    53.1444272
                ],
                [
                    103.7623031,
                    53.153498
                ],
                [
                    103.7622309,
                    53.1568909
                ]
            ],
            "longitude": 103.766212,
            "latitude": 53.153561
        },
        "5984": {
            "name": "ОСА",
            "population": 4523,
            "type": "town",
            "poly": [
                [
                    103.8397159,
                    53.3894685
                ],
                [
                    103.8499381,
                    53.3985671
                ],
                [
                    103.8635428,
                    53.3986119
                ],
                [
                    103.8830721,
                    53.3945999
                ],
                [
                    103.8884932,
                    53.3857252
                ],
                [
                    103.8781811,
                    53.378984
                ],
                [
                    103.8682774,
                    53.375452
                ],
                [
                    103.8397159,
                    53.3894685
                ]
            ],
            "longitude": 103.877457,
            "latitude": 53.388348
        },
        "5985": {
            "name": "НОВАЯ ИГИРМА",
            "population": 9580,
            "type": "town",
            "poly": [
                [
                    103.8634802,
                    57.1169838
                ],
                [
                    103.8829881,
                    57.1338397
                ],
                [
                    103.9208097,
                    57.1422648
                ],
                [
                    103.9888885,
                    57.1480964
                ],
                [
                    104.0231269,
                    57.1271415
                ],
                [
                    103.9920734,
                    57.0996878
                ],
                [
                    103.9275778,
                    57.0895226
                ],
                [
                    103.8658689,
                    57.0949299
                ],
                [
                    103.8634802,
                    57.1169838
                ]
            ],
            "longitude": 103.936913,
            "latitude": 57.136955
        },
        "5986": {
            "name": "МЕГЕТ",
            "population": 8826,
            "type": "town",
            "poly": null,
            "longitude": 104.057907,
            "latitude": 52.420177
        },
        "5987": {
            "name": "БОЛЬШОЙ ЛУГ",
            "population": 5260,
            "type": "town",
            "poly": [
                [
                    104.0504547,
                    52.0509561
                ],
                [
                    104.0661617,
                    52.0586089
                ],
                [
                    104.0726848,
                    52.0611419
                ],
                [
                    104.0737148,
                    52.0675267
                ],
                [
                    104.0769764,
                    52.0713254
                ],
                [
                    104.0716549,
                    52.0742271
                ],
                [
                    104.0770622,
                    52.079344
                ],
                [
                    104.078693,
                    52.0805572
                ],
                [
                    104.0807529,
                    52.079766
                ],
                [
                    104.088306,
                    52.0845658
                ],
                [
                    104.0911384,
                    52.0911055
                ],
                [
                    104.0950866,
                    52.0970114
                ],
                [
                    104.101009,
                    52.0992786
                ],
                [
                    104.1075321,
                    52.0974332
                ],
                [
                    104.1082187,
                    52.0937421
                ],
                [
                    104.1129394,
                    52.0906836
                ],
                [
                    104.1088196,
                    52.0826671
                ],
                [
                    104.1010948,
                    52.0750711
                ],
                [
                    104.0946575,
                    52.0729082
                ],
                [
                    104.0913959,
                    52.0697954
                ],
                [
                    104.0918251,
                    52.0672629
                ],
                [
                    104.0924259,
                    52.0647302
                ],
                [
                    104.1001507,
                    52.059506
                ],
                [
                    104.0965458,
                    52.0572895
                ],
                [
                    104.0925117,
                    52.0610364
                ],
                [
                    104.0920826,
                    52.0553368
                ],
                [
                    104.0924259,
                    52.0523284
                ],
                [
                    104.0962024,
                    52.0456247
                ],
                [
                    104.0931125,
                    52.0392368
                ],
                [
                    104.0866752,
                    52.0401343
                ],
                [
                    104.0802379,
                    52.0426684
                ],
                [
                    104.083242,
                    52.0457303
                ],
                [
                    104.071569,
                    52.0525923
                ],
                [
                    104.0646168,
                    52.0528034
                ],
                [
                    104.0544887,
                    52.0484224
                ],
                [
                    104.0504547,
                    52.0509561
                ]
            ],
            "longitude": 104.091927,
            "latitude": 52.077904
        },
        "5988": {
            "name": "ШЕЛЕХОВ",
            "population": 47120,
            "type": "town",
            "poly": [
                [
                    104.0478708,
                    52.2088685
                ],
                [
                    104.063255,
                    52.2259481
                ],
                [
                    104.0728669,
                    52.2518476
                ],
                [
                    104.0736271,
                    52.2526032
                ],
                [
                    104.0753437,
                    52.2542846
                ],
                [
                    104.0789486,
                    52.2544948
                ],
                [
                    104.0851284,
                    52.2524981
                ],
                [
                    104.0892483,
                    52.2517625
                ],
                [
                    104.0923382,
                    52.2518676
                ],
                [
                    104.0950365,
                    52.2533031
                ],
                [
                    104.0999393,
                    52.2503138
                ],
                [
                    104.0999247,
                    52.2501002
                ],
                [
                    104.1004092,
                    52.2501121
                ],
                [
                    104.1020566,
                    52.2503138
                ],
                [
                    104.102105,
                    52.249857
                ],
                [
                    104.1018289,
                    52.2497947
                ],
                [
                    104.1004383,
                    52.2492726
                ],
                [
                    104.1006563,
                    52.2485933
                ],
                [
                    104.1006418,
                    52.2484628
                ],
                [
                    104.1012862,
                    52.2457841
                ],
                [
                    104.1020905,
                    52.2438024
                ],
                [
                    104.1031564,
                    52.2443898
                ],
                [
                    104.1035392,
                    52.2448645
                ],
                [
                    104.1038008,
                    52.2450781
                ],
                [
                    104.1040237,
                    52.2451255
                ],
                [
                    104.1042369,
                    52.2451107
                ],
                [
                    104.1047698,
                    52.2446805
                ],
                [
                    104.1055112,
                    52.2448051
                ],
                [
                    104.1056468,
                    52.244731
                ],
                [
                    104.1082002,
                    52.2451285
                ],
                [
                    104.1080016,
                    52.2445441
                ],
                [
                    104.1088058,
                    52.2446123
                ],
                [
                    104.1094406,
                    52.2460155
                ],
                [
                    104.1092661,
                    52.2467126
                ],
                [
                    104.1088688,
                    52.2467897
                ],
                [
                    104.1088931,
                    52.2469974
                ],
                [
                    104.1103514,
                    52.2471991
                ],
                [
                    104.1158458,
                    52.2402422
                ],
                [
                    104.1166792,
                    52.2389368
                ],
                [
                    104.1172703,
                    52.2379932
                ],
                [
                    104.117624,
                    52.236842
                ],
                [
                    104.1175077,
                    52.2359993
                ],
                [
                    104.1176627,
                    52.2352071
                ],
                [
                    104.1176531,
                    52.2347916
                ],
                [
                    104.1175174,
                    52.2344563
                ],
                [
                    104.1172449,
                    52.2331284
                ],
                [
                    104.1202992,
                    52.2326963
                ],
                [
                    104.1205163,
                    52.2327604
                ],
                [
                    104.1211869,
                    52.2325729
                ],
                [
                    104.1219853,
                    52.2325302
                ],
                [
                    104.122528,
                    52.2323308
                ],
                [
                    104.1235009,
                    52.2320459
                ],
                [
                    104.1236947,
                    52.2319723
                ],
                [
                    104.1238071,
                    52.2318417
                ],
                [
                    104.123811,
                    52.2317017
                ],
                [
                    104.1237373,
                    52.2315022
                ],
                [
                    104.1230861,
                    52.2305397
                ],
                [
                    104.1240411,
                    52.2304086
                ],
                [
                    104.1243202,
                    52.2304105
                ],
                [
                    104.125944,
                    52.2302313
                ],
                [
                    104.1285042,
                    52.230075
                ],
                [
                    104.1290474,
                    52.2293715
                ],
                [
                    104.1291665,
                    52.2291224
                ],
                [
                    104.1291268,
                    52.2289871
                ],
                [
                    104.1289408,
                    52.2289112
                ],
                [
                    104.1286208,
                    52.2288002
                ],
                [
                    104.1285463,
                    52.2286361
                ],
                [
                    104.1285439,
                    52.2285434
                ],
                [
                    104.1288639,
                    52.2283368
                ],
                [
                    104.1294915,
                    52.2281393
                ],
                [
                    104.1297817,
                    52.2281377
                ],
                [
                    104.1300472,
                    52.2281575
                ],
                [
                    104.1303216,
                    52.2280953
                ],
                [
                    104.1318056,
                    52.2278606
                ],
                [
                    104.1329656,
                    52.2274619
                ],
                [
                    104.1339894,
                    52.227422
                ],
                [
                    104.1361792,
                    52.2272299
                ],
                [
                    104.1364277,
                    52.2270631
                ],
                [
                    104.1365934,
                    52.2255115
                ],
                [
                    104.1369012,
                    52.2235793
                ],
                [
                    104.1369308,
                    52.2215272
                ],
                [
                    104.1366881,
                    52.221132
                ],
                [
                    104.1375581,
                    52.2210341
                ],
                [
                    104.1368953,
                    52.2201277
                ],
                [
                    104.1352322,
                    52.21937
                ],
                [
                    104.1331512,
                    52.2187147
                ],
                [
                    104.1338087,
                    52.2176474
                ],
                [
                    104.1341501,
                    52.2175311
                ],
                [
                    104.1347467,
                    52.2175038
                ],
                [
                    104.1351504,
                    52.2172765
                ],
                [
                    104.1352911,
                    52.2170847
                ],
                [
                    104.1355114,
                    52.2167303
                ],
                [
                    104.1359678,
                    52.2165598
                ],
                [
                    104.13658,
                    52.2165325
                ],
                [
                    104.1367803,
                    52.216337
                ],
                [
                    104.1368694,
                    52.2159983
                ],
                [
                    104.136669,
                    52.2158664
                ],
                [
                    104.1360049,
                    52.2159301
                ],
                [
                    104.1351293,
                    52.2153027
                ],
                [
                    104.1356248,
                    52.2147051
                ],
                [
                    104.1358973,
                    52.2137851
                ],
                [
                    104.1355437,
                    52.2135755
                ],
                [
                    104.134877,
                    52.2135222
                ],
                [
                    104.1347842,
                    52.2132736
                ],
                [
                    104.1350451,
                    52.2131528
                ],
                [
                    104.1356132,
                    52.2131812
                ],
                [
                    104.1358103,
                    52.2130462
                ],
                [
                    104.1357813,
                    52.2127834
                ],
                [
                    104.1354509,
                    52.2125418
                ],
                [
                    104.1348886,
                    52.212485
                ],
                [
                    104.1347436,
                    52.2123394
                ],
                [
                    104.1348364,
                    52.2121191
                ],
                [
                    104.1352538,
                    52.2117461
                ],
                [
                    104.1352596,
                    52.2111067
                ],
                [
                    104.1350973,
                    52.2109504
                ],
                [
                    104.1346972,
                    52.2108545
                ],
                [
                    104.1338335,
                    52.2108225
                ],
                [
                    104.1334218,
                    52.210716
                ],
                [
                    104.1331436,
                    52.2105064
                ],
                [
                    104.1327262,
                    52.2100623
                ],
                [
                    104.1318566,
                    52.2097106
                ],
                [
                    104.1315551,
                    52.2091316
                ],
                [
                    104.1315029,
                    52.2086307
                ],
                [
                    104.1316827,
                    52.2084033
                ],
                [
                    104.1319435,
                    52.2083785
                ],
                [
                    104.1324305,
                    52.2086769
                ],
                [
                    104.1326798,
                    52.2086094
                ],
                [
                    104.1328131,
                    52.2084317
                ],
                [
                    104.1323204,
                    52.2076218
                ],
                [
                    104.1324595,
                    52.20727
                ],
                [
                    104.1319957,
                    52.2071457
                ],
                [
                    104.1313522,
                    52.2073979
                ],
                [
                    104.1310044,
                    52.2073269
                ],
                [
                    104.1306565,
                    52.2070533
                ],
                [
                    104.129213,
                    52.2067904
                ],
                [
                    104.1288826,
                    52.2065595
                ],
                [
                    104.1287318,
                    52.2062398
                ],
                [
                    104.1281521,
                    52.2058916
                ],
                [
                    104.1281289,
                    52.2057033
                ],
                [
                    104.128326,
                    52.2056145
                ],
                [
                    104.1285463,
                    52.2056323
                ],
                [
                    104.1295434,
                    52.2062504
                ],
                [
                    104.1299956,
                    52.206286
                ],
                [
                    104.1304014,
                    52.2060977
                ],
                [
                    104.1306102,
                    52.2057211
                ],
                [
                    104.1306507,
                    52.2051278
                ],
                [
                    104.1308536,
                    52.2047298
                ],
                [
                    104.1307957,
                    52.2045167
                ],
                [
                    104.1304942,
                    52.2043817
                ],
                [
                    104.1301116,
                    52.2043142
                ],
                [
                    104.1297985,
                    52.2043532
                ],
                [
                    104.1296362,
                    52.2045629
                ],
                [
                    104.1293174,
                    52.2048045
                ],
                [
                    104.1289521,
                    52.2048293
                ],
                [
                    104.1284014,
                    52.2043781
                ],
                [
                    104.1280304,
                    52.2044065
                ],
                [
                    104.1277347,
                    52.2042111
                ],
                [
                    104.1276651,
                    52.2038381
                ],
                [
                    104.1279666,
                    52.2034828
                ],
                [
                    104.1284478,
                    52.2033016
                ],
                [
                    104.1288362,
                    52.2032732
                ],
                [
                    104.1299724,
                    52.2033336
                ],
                [
                    104.1303145,
                    52.2033975
                ],
                [
                    104.1305928,
                    52.2036
                ],
                [
                    104.1308073,
                    52.2039731
                ],
                [
                    104.1313638,
                    52.2041223
                ],
                [
                    104.1319783,
                    52.2040228
                ],
                [
                    104.1323841,
                    52.2040584
                ],
                [
                    104.1327783,
                    52.2042715
                ],
                [
                    104.1331726,
                    52.2048329
                ],
                [
                    104.133474,
                    52.2048187
                ],
                [
                    104.1338045,
                    52.2046552
                ],
                [
                    104.1341291,
                    52.2042822
                ],
                [
                    104.1341117,
                    52.204133
                ],
                [
                    104.1337407,
                    52.2038239
                ],
                [
                    104.1338335,
                    52.203664
                ],
                [
                    104.1340248,
                    52.2036036
                ],
                [
                    104.1341001,
                    52.2032163
                ],
                [
                    104.1339668,
                    52.202957
                ],
                [
                    104.133532,
                    52.2028681
                ],
                [
                    104.1333175,
                    52.2029534
                ],
                [
                    104.1326798,
                    52.2032376
                ],
                [
                    104.1321464,
                    52.2032341
                ],
                [
                    104.1306797,
                    52.2022677
                ],
                [
                    104.1298449,
                    52.2014824
                ],
                [
                    104.1297464,
                    52.2010703
                ],
                [
                    104.1300102,
                    52.2007959
                ],
                [
                    104.1303047,
                    52.2008282
                ],
                [
                    104.1307927,
                    52.201103
                ],
                [
                    104.1311224,
                    52.2013212
                ],
                [
                    104.1314652,
                    52.2013913
                ],
                [
                    104.1318037,
                    52.2012997
                ],
                [
                    104.1319444,
                    52.2010114
                ],
                [
                    104.1317158,
                    52.2008255
                ],
                [
                    104.1308718,
                    52.2007043
                ],
                [
                    104.1305201,
                    52.2005318
                ],
                [
                    104.1301729,
                    52.1998583
                ],
                [
                    104.1302608,
                    52.1996751
                ],
                [
                    104.1307487,
                    52.199446
                ],
                [
                    104.1312103,
                    52.1997128
                ],
                [
                    104.1313773,
                    52.1999148
                ],
                [
                    104.131984,
                    52.1999741
                ],
                [
                    104.1331884,
                    52.199702
                ],
                [
                    104.1341599,
                    52.1992682
                ],
                [
                    104.1342171,
                    52.1988236
                ],
                [
                    104.1352457,
                    52.1978025
                ],
                [
                    104.1353413,
                    52.1970554
                ],
                [
                    104.1356765,
                    52.1964862
                ],
                [
                    104.1356985,
                    52.1960989
                ],
                [
                    104.1359238,
                    52.1954691
                ],
                [
                    104.1364843,
                    52.1944148
                ],
                [
                    104.1366931,
                    52.1935828
                ],
                [
                    104.1366161,
                    52.1933201
                ],
                [
                    104.1363084,
                    52.1931955
                ],
                [
                    104.135182,
                    52.1932393
                ],
                [
                    104.1350226,
                    52.1930675
                ],
                [
                    104.135182,
                    52.1929092
                ],
                [
                    104.13516,
                    52.1926498
                ],
                [
                    104.1342588,
                    52.1921176
                ],
                [
                    104.1340171,
                    52.1917639
                ],
                [
                    104.1337094,
                    52.1916662
                ],
                [
                    104.1335335,
                    52.1918784
                ],
                [
                    104.1337478,
                    52.1920772
                ],
                [
                    104.1336269,
                    52.1923466
                ],
                [
                    104.1334731,
                    52.1924578
                ],
                [
                    104.1336379,
                    52.1930506
                ],
                [
                    104.1332478,
                    52.1931214
                ],
                [
                    104.1325005,
                    52.1929361
                ],
                [
                    104.132517,
                    52.1926936
                ],
                [
                    104.1329016,
                    52.1924915
                ],
                [
                    104.133006,
                    52.1921849
                ],
                [
                    104.1325994,
                    52.1917841
                ],
                [
                    104.1321049,
                    52.1915618
                ],
                [
                    104.1316378,
                    52.1917134
                ],
                [
                    104.1314125,
                    52.1915719
                ],
                [
                    104.13144,
                    52.1911677
                ],
                [
                    104.1317422,
                    52.1903558
                ],
                [
                    104.1315554,
                    52.1901537
                ],
                [
                    104.1312806,
                    52.1900897
                ],
                [
                    104.1308136,
                    52.1901133
                ],
                [
                    104.1299619,
                    52.1897293
                ],
                [
                    104.1299838,
                    52.1895541
                ],
                [
                    104.1308795,
                    52.1893958
                ],
                [
                    104.1312916,
                    52.1897394
                ],
                [
                    104.1316213,
                    52.1897057
                ],
                [
                    104.1318356,
                    52.1891633
                ],
                [
                    104.1317147,
                    52.1888837
                ],
                [
                    104.1311652,
                    52.1886715
                ],
                [
                    104.1299234,
                    52.1884121
                ],
                [
                    104.1299014,
                    52.1882471
                ],
                [
                    104.1305883,
                    52.1881932
                ],
                [
                    104.1312202,
                    52.1879708
                ],
                [
                    104.1312696,
                    52.1878226
                ],
                [
                    104.1311707,
                    52.1877249
                ],
                [
                    104.1306542,
                    52.1876373
                ],
                [
                    104.1305003,
                    52.1875127
                ],
                [
                    104.1305718,
                    52.1873813
                ],
                [
                    104.1308795,
                    52.1872162
                ],
                [
                    104.130874,
                    52.1870949
                ],
                [
                    104.1306927,
                    52.186977
                ],
                [
                    104.1304179,
                    52.1869635
                ],
                [
                    104.1301377,
                    52.1867614
                ],
                [
                    104.1301542,
                    52.1866065
                ],
                [
                    104.1299673,
                    52.1863538
                ],
                [
                    104.1296102,
                    52.1862123
                ],
                [
                    104.1291871,
                    52.1857945
                ],
                [
                    104.129764,
                    52.1851342
                ],
                [
                    104.1296541,
                    52.1847232
                ],
                [
                    104.1297989,
                    52.184117
                ],
                [
                    104.1135431,
                    52.1750068
                ],
                [
                    104.096082,
                    52.1678675
                ],
                [
                    104.063255,
                    52.1852853
                ],
                [
                    104.0478708,
                    52.2088685
                ]
            ],
            "longitude": 104.094986,
            "latitude": 52.211098
        },
        "5989": {
            "name": "ЖЕЛЕЗНОГОРСК-ИЛИМСКИЙ",
            "population": 24235,
            "type": "town",
            "poly": [
                [
                    104.0247087,
                    56.6135125
                ],
                [
                    104.0838107,
                    56.6187987
                ],
                [
                    104.1153074,
                    56.6081585
                ],
                [
                    104.1438706,
                    56.5951612
                ],
                [
                    104.1568551,
                    56.58375
                ],
                [
                    104.1541034,
                    56.5789667
                ],
                [
                    104.1414628,
                    56.5705826
                ],
                [
                    104.1229749,
                    56.560633
                ],
                [
                    104.103662,
                    56.5647026
                ],
                [
                    104.0895767,
                    56.5692251
                ],
                [
                    104.0400314,
                    56.5928957
                ],
                [
                    104.0247087,
                    56.6135125
                ]
            ],
            "longitude": 104.12294,
            "latitude": 56.577915
        },
        "5990": {
            "name": "БАЙКАЛЬСК",
            "population": 12974,
            "type": "town",
            "poly": [
                [
                    104.1192509,
                    51.5171131
                ],
                [
                    104.1233291,
                    51.5248752
                ],
                [
                    104.1445601,
                    51.5267782
                ],
                [
                    104.1650713,
                    51.5262558
                ],
                [
                    104.1828837,
                    51.5234199
                ],
                [
                    104.2011159,
                    51.5102082
                ],
                [
                    104.2021355,
                    51.5043476
                ],
                [
                    104.1994966,
                    51.501921
                ],
                [
                    104.1744225,
                    51.5075998
                ],
                [
                    104.1722116,
                    51.5058223
                ],
                [
                    104.1663159,
                    51.505784
                ],
                [
                    104.1527166,
                    51.5065127
                ],
                [
                    104.1384427,
                    51.5107681
                ],
                [
                    104.1192509,
                    51.5171131
                ]
            ],
            "longitude": 104.149071,
            "latitude": 51.522598
        },
        "5991": {
            "name": "МАРКОВА",
            "population": 17756,
            "type": "town",
            "poly": null,
            "longitude": 104.205444,
            "latitude": 52.213161
        },
        "5992": {
            "name": "УСТЬ-ОРДЫНСКИЙ",
            "population": null,
            "type": "town",
            "poly": [
                [
                    104.6997095,
                    52.8008979
                ],
                [
                    104.7079493,
                    52.8096149
                ],
                [
                    104.7043444,
                    52.8108601
                ],
                [
                    104.7174765,
                    52.8205554
                ],
                [
                    104.7120348,
                    52.8275934
                ],
                [
                    104.717219,
                    52.8322243
                ],
                [
                    104.7383248,
                    52.8263176
                ],
                [
                    104.7433029,
                    52.8309797
                ],
                [
                    104.7688805,
                    52.8338836
                ],
                [
                    104.7802101,
                    52.8297352
                ],
                [
                    104.7685372,
                    52.8185376
                ],
                [
                    104.7800385,
                    52.814699
                ],
                [
                    104.7845017,
                    52.8111713
                ],
                [
                    104.7755495,
                    52.8055991
                ],
                [
                    104.7446762,
                    52.7852237
                ],
                [
                    104.7341791,
                    52.7780906
                ],
                [
                    104.7240511,
                    52.7812056
                ],
                [
                    104.7027994,
                    52.7864695
                ],
                [
                    104.7117258,
                    52.7970577
                ],
                [
                    104.6997095,
                    52.8008979
                ]
            ],
            "longitude": 104.745331,
            "latitude": 52.80574
        },
        "5993": {
            "name": "ЖИГАЛОВО",
            "population": 5051,
            "type": "town",
            "poly": [
                [
                    105.1214813,
                    54.8142027
                ],
                [
                    105.1303115,
                    54.8171691
                ],
                [
                    105.1392185,
                    54.8160388
                ],
                [
                    105.1416555,
                    54.8161695
                ],
                [
                    105.1433691,
                    54.8166396
                ],
                [
                    105.1447953,
                    54.8165867
                ],
                [
                    105.1469114,
                    54.8155654
                ],
                [
                    105.1498186,
                    54.8157061
                ],
                [
                    105.1527191,
                    54.8162928
                ],
                [
                    105.156143,
                    54.8179239
                ],
                [
                    105.1698794,
                    54.8168971
                ],
                [
                    105.1707099,
                    54.8146942
                ],
                [
                    105.1708154,
                    54.8144143
                ],
                [
                    105.1711099,
                    54.813633
                ],
                [
                    105.1729514,
                    54.8098116
                ],
                [
                    105.176054,
                    54.8072829
                ],
                [
                    105.1779554,
                    54.8071181
                ],
                [
                    105.1794722,
                    54.8072616
                ],
                [
                    105.1800886,
                    54.8072507
                ],
                [
                    105.1814583,
                    54.8076095
                ],
                [
                    105.182918,
                    54.8077447
                ],
                [
                    105.1830935,
                    54.8079529
                ],
                [
                    105.1839915,
                    54.808298
                ],
                [
                    105.1845496,
                    54.8086722
                ],
                [
                    105.1905217,
                    54.8125696
                ],
                [
                    105.2034392,
                    54.8125201
                ],
                [
                    105.2090612,
                    54.8058919
                ],
                [
                    105.1983752,
                    54.7976298
                ],
                [
                    105.1915946,
                    54.7963681
                ],
                [
                    105.1871743,
                    54.7935229
                ],
                [
                    105.1779904,
                    54.7928549
                ],
                [
                    105.1677766,
                    54.794661
                ],
                [
                    105.1682057,
                    54.7985699
                ],
                [
                    105.1646867,
                    54.797803
                ],
                [
                    105.161574,
                    54.7994316
                ],
                [
                    105.1591693,
                    54.802296
                ],
                [
                    105.1579432,
                    54.802562
                ],
                [
                    105.1548318,
                    54.8006356
                ],
                [
                    105.1524339,
                    54.7988421
                ],
                [
                    105.1490329,
                    54.7960094
                ],
                [
                    105.1404981,
                    54.7986071
                ],
                [
                    105.1427132,
                    54.8011942
                ],
                [
                    105.1427887,
                    54.8012824
                ],
                [
                    105.1381324,
                    54.8049035
                ],
                [
                    105.1310943,
                    54.8091576
                ],
                [
                    105.1214813,
                    54.8142027
                ]
            ],
            "longitude": 105.15229,
            "latitude": 54.812668
        },
        "5994": {
            "name": "БАЯНДАЙ",
            "population": 2669,
            "type": "town",
            "poly": null,
            "longitude": 105.517876,
            "latitude": 53.067226
        },
        "5995": {
            "name": "УСТЬ-КУТ",
            "population": 42971,
            "type": "town",
            "poly": [
                [
                    105.5661906,
                    56.7989515
                ],
                [
                    105.5739153,
                    56.804638
                ],
                [
                    105.6168564,
                    56.8093933
                ],
                [
                    105.6392101,
                    56.7901748
                ],
                [
                    105.666901,
                    56.7729672
                ],
                [
                    105.6954803,
                    56.7843681
                ],
                [
                    105.7258989,
                    56.7928798
                ],
                [
                    105.7444145,
                    56.793423
                ],
                [
                    105.7596238,
                    56.8082683
                ],
                [
                    105.8267429,
                    56.8227459
                ],
                [
                    105.8852656,
                    56.8151458
                ],
                [
                    105.883943,
                    56.834143
                ],
                [
                    105.9466274,
                    56.8150216
                ],
                [
                    105.9724873,
                    56.8244492
                ],
                [
                    105.9922284,
                    56.8243553
                ],
                [
                    105.9942969,
                    56.8181833
                ],
                [
                    105.9754914,
                    56.813058
                ],
                [
                    105.9659006,
                    56.8043836
                ],
                [
                    105.9193211,
                    56.7856359
                ],
                [
                    105.8720401,
                    56.7926987
                ],
                [
                    105.840299,
                    56.7783907
                ],
                [
                    105.7959938,
                    56.7762169
                ],
                [
                    105.7563174,
                    56.7711441
                ],
                [
                    105.7235845,
                    56.7715064
                ],
                [
                    105.7024237,
                    56.7675202
                ],
                [
                    105.6898596,
                    56.7588216
                ],
                [
                    105.6647312,
                    56.749577
                ],
                [
                    105.6475381,
                    56.7435941
                ],
                [
                    105.6362965,
                    56.7310811
                ],
                [
                    105.6171196,
                    56.7348899
                ],
                [
                    105.6296838,
                    56.7477641
                ],
                [
                    105.6396029,
                    56.7561028
                ],
                [
                    105.6277,
                    56.7667954
                ],
                [
                    105.6154458,
                    56.7842889
                ],
                [
                    105.5810393,
                    56.7852629
                ],
                [
                    105.5686453,
                    56.7877077
                ],
                [
                    105.5661906,
                    56.7989515
                ]
            ],
            "longitude": 105.7464937,
            "latitude": 56.7803671
        },
        "5996": {
            "name": "КАЧУГ",
            "population": 6965,
            "type": "town",
            "poly": [
                [
                    105.8673399,
                    53.9614732
                ],
                [
                    105.8696882,
                    53.9675328
                ],
                [
                    105.886109,
                    53.974513
                ],
                [
                    105.9410288,
                    53.9629058
                ],
                [
                    105.9275058,
                    53.9493464
                ],
                [
                    105.9134921,
                    53.9444204
                ],
                [
                    105.8818783,
                    53.9517706
                ],
                [
                    105.8673399,
                    53.9614732
                ]
            ],
            "longitude": 105.885147,
            "latitude": 53.960819
        },
        "5997": {
            "name": "ЕЛАНЦЫ",
            "population": 4006,
            "type": "town",
            "poly": [
                [
                    106.3807714,
                    52.7881594
                ],
                [
                    106.3833045,
                    52.7895277
                ],
                [
                    106.3827626,
                    52.7915651
                ],
                [
                    106.385204,
                    52.7939154
                ],
                [
                    106.3902339,
                    52.7960724
                ],
                [
                    106.3924991,
                    52.7960045
                ],
                [
                    106.3953877,
                    52.7972281
                ],
                [
                    106.3941336,
                    52.8000545
                ],
                [
                    106.394823,
                    52.800837
                ],
                [
                    106.3903839,
                    52.8011987
                ],
                [
                    106.3882291,
                    52.802434
                ],
                [
                    106.3980696,
                    52.8027998
                ],
                [
                    106.3987493,
                    52.8041926
                ],
                [
                    106.3964665,
                    52.8082888
                ],
                [
                    106.4004029,
                    52.8124937
                ],
                [
                    106.4052177,
                    52.8119799
                ],
                [
                    106.4088378,
                    52.8107232
                ],
                [
                    106.4082362,
                    52.8084657
                ],
                [
                    106.4075485,
                    52.8071827
                ],
                [
                    106.408374,
                    52.8057499
                ],
                [
                    106.411095,
                    52.8056241
                ],
                [
                    106.4118963,
                    52.8044599
                ],
                [
                    106.4142017,
                    52.8044821
                ],
                [
                    106.4157342,
                    52.8034581
                ],
                [
                    106.4187297,
                    52.8033361
                ],
                [
                    106.4226046,
                    52.802601
                ],
                [
                    106.4270954,
                    52.802015
                ],
                [
                    106.4272402,
                    52.8009724
                ],
                [
                    106.4198399,
                    52.7994856
                ],
                [
                    106.4133167,
                    52.7974097
                ],
                [
                    106.405077,
                    52.7938807
                ],
                [
                    106.3994122,
                    52.7937769
                ],
                [
                    106.392889,
                    52.7922198
                ],
                [
                    106.392889,
                    52.7904551
                ],
                [
                    106.3915157,
                    52.7891056
                ],
                [
                    106.3903141,
                    52.788794
                ],
                [
                    106.3884656,
                    52.7891843
                ],
                [
                    106.3826912,
                    52.7871162
                ],
                [
                    106.3807714,
                    52.7881594
                ]
            ],
            "longitude": 106.404564,
            "latitude": 52.799557
        },
        "5998": {
            "name": "МАГИСТРАЛЬНЫЙ",
            "population": 6463,
            "type": "town",
            "poly": null,
            "longitude": 107.452629,
            "latitude": 56.176498
        },
        "5999": {
            "name": "КИРЕНСК",
            "population": 11568,
            "type": "town",
            "poly": [
                [
                    108.0480631,
                    57.7795217
                ],
                [
                    108.0674576,
                    57.7834758
                ],
                [
                    108.1038967,
                    57.8042208
                ],
                [
                    108.1134206,
                    57.8000286
                ],
                [
                    108.1322612,
                    57.7798332
                ],
                [
                    108.1701496,
                    57.7889943
                ],
                [
                    108.1732552,
                    57.7792812
                ],
                [
                    108.1268426,
                    57.766896
                ],
                [
                    108.1117642,
                    57.7567546
                ],
                [
                    108.0970644,
                    57.7531093
                ],
                [
                    108.0785159,
                    57.7664673
                ],
                [
                    108.0709773,
                    57.7546558
                ],
                [
                    108.0511687,
                    57.7674873
                ],
                [
                    108.0480631,
                    57.7795217
                ]
            ],
            "longitude": 108.116295,
            "latitude": 57.776356
        },
        "6000": {
            "name": "МАМА",
            "population": 3127,
            "type": "town",
            "poly": [
                [
                    112.8663439,
                    58.31604
                ],
                [
                    112.8667741,
                    58.3216887
                ],
                [
                    112.8733349,
                    58.3231572
                ],
                [
                    112.87839,
                    58.3219711
                ],
                [
                    112.9134527,
                    58.31056
                ],
                [
                    112.9211967,
                    58.302084
                ],
                [
                    112.903988,
                    58.2957539
                ],
                [
                    112.8769918,
                    58.3103905
                ],
                [
                    112.8663439,
                    58.31604
                ]
            ],
            "longitude": 112.903419,
            "latitude": 58.310555
        },
        "6001": {
            "name": "БОДАЙБО",
            "population": 13896,
            "type": "town",
            "poly": [
                [
                    114.1100193,
                    57.8353968
                ],
                [
                    114.1297021,
                    57.8529689
                ],
                [
                    114.1785917,
                    57.8735713
                ],
                [
                    114.2624024,
                    57.8774541
                ],
                [
                    114.2843075,
                    57.8637782
                ],
                [
                    114.2497038,
                    57.8463803
                ],
                [
                    114.1747821,
                    57.8189997
                ],
                [
                    114.1417658,
                    57.8161252
                ],
                [
                    114.1100193,
                    57.8353968
                ]
            ],
            "longitude": 114.2038284,
            "latitude": 57.8500317
        },
        "6002": {
            "name": "ЯРОВОЕ",
            "population": 18085,
            "type": "town",
            "poly": [
                [
                    78.4968164,
                    52.9188363
                ],
                [
                    78.5032047,
                    52.9208453
                ],
                [
                    78.4991086,
                    52.9255716
                ],
                [
                    78.5492883,
                    52.9414116
                ],
                [
                    78.5545677,
                    52.942876
                ],
                [
                    78.5583222,
                    52.944602
                ],
                [
                    78.5635281,
                    52.9465145
                ],
                [
                    78.5779749,
                    52.9513594
                ],
                [
                    78.5746366,
                    52.9560698
                ],
                [
                    78.5981501,
                    52.9626362
                ],
                [
                    78.5968977,
                    52.9561879
                ],
                [
                    78.5982439,
                    52.956043
                ],
                [
                    78.596374,
                    52.9485322
                ],
                [
                    78.6588212,
                    52.9498881
                ],
                [
                    78.6713866,
                    52.9435931
                ],
                [
                    78.6661755,
                    52.9390975
                ],
                [
                    78.6800192,
                    52.9324556
                ],
                [
                    78.6739658,
                    52.9304163
                ],
                [
                    78.6671995,
                    52.9286973
                ],
                [
                    78.6620924,
                    52.9268923
                ],
                [
                    78.6565315,
                    52.9253685
                ],
                [
                    78.6488061,
                    52.9251497
                ],
                [
                    78.6465507,
                    52.9247824
                ],
                [
                    78.6370753,
                    52.9241807
                ],
                [
                    78.6353679,
                    52.9204527
                ],
                [
                    78.6562631,
                    52.9148737
                ],
                [
                    78.6491501,
                    52.9088938
                ],
                [
                    78.648,
                    52.908
                ],
                [
                    78.646,
                    52.9095
                ],
                [
                    78.6465,
                    52.9095
                ],
                [
                    78.64675,
                    52.9099999
                ],
                [
                    78.64575,
                    52.91075
                ],
                [
                    78.64375,
                    52.91075
                ],
                [
                    78.64075,
                    52.91225
                ],
                [
                    78.63775,
                    52.91275
                ],
                [
                    78.63725,
                    52.91275
                ],
                [
                    78.63525,
                    52.91125
                ],
                [
                    78.6345,
                    52.9114999
                ],
                [
                    78.63175,
                    52.91125
                ],
                [
                    78.631,
                    52.912
                ],
                [
                    78.6305,
                    52.91175
                ],
                [
                    78.6294999,
                    52.91225
                ],
                [
                    78.6264999,
                    52.912
                ],
                [
                    78.62825,
                    52.91225
                ],
                [
                    78.6264999,
                    52.91375
                ],
                [
                    78.62625,
                    52.9135
                ],
                [
                    78.62625,
                    52.9129999
                ],
                [
                    78.6255,
                    52.91275
                ],
                [
                    78.626,
                    52.91325
                ],
                [
                    78.6264999,
                    52.914
                ],
                [
                    78.62625,
                    52.9144999
                ],
                [
                    78.62725,
                    52.915
                ],
                [
                    78.626,
                    52.915
                ],
                [
                    78.62625,
                    52.91525
                ],
                [
                    78.626,
                    52.9155
                ],
                [
                    78.62475,
                    52.9159999
                ],
                [
                    78.62425,
                    52.9159999
                ],
                [
                    78.6235,
                    52.91575
                ],
                [
                    78.622,
                    52.9159999
                ],
                [
                    78.62125,
                    52.9165
                ],
                [
                    78.62025,
                    52.91625
                ],
                [
                    78.6195,
                    52.91675
                ],
                [
                    78.619,
                    52.9159999
                ],
                [
                    78.618,
                    52.9165
                ],
                [
                    78.6175,
                    52.91625
                ],
                [
                    78.61725,
                    52.9159999
                ],
                [
                    78.617,
                    52.915
                ],
                [
                    78.61725,
                    52.91475
                ],
                [
                    78.6205,
                    52.91325
                ],
                [
                    78.62075,
                    52.9129999
                ],
                [
                    78.62,
                    52.91275
                ],
                [
                    78.6192499,
                    52.91325
                ],
                [
                    78.6175,
                    52.91375
                ],
                [
                    78.615,
                    52.91375
                ],
                [
                    78.61475,
                    52.914
                ],
                [
                    78.61425,
                    52.91425
                ],
                [
                    78.6042499,
                    52.91625
                ],
                [
                    78.60325,
                    52.91625
                ],
                [
                    78.59925,
                    52.9165
                ],
                [
                    78.5982499,
                    52.9159999
                ],
                [
                    78.595,
                    52.91675
                ],
                [
                    78.5865,
                    52.91675
                ],
                [
                    78.58575,
                    52.9165
                ],
                [
                    78.58175,
                    52.91625
                ],
                [
                    78.5789523,
                    52.9158015
                ],
                [
                    78.5763098,
                    52.9152476
                ],
                [
                    78.57325,
                    52.91425
                ],
                [
                    78.5723787,
                    52.9136845
                ],
                [
                    78.569661,
                    52.9125354
                ],
                [
                    78.5680917,
                    52.911975
                ],
                [
                    78.566,
                    52.911
                ],
                [
                    78.56575,
                    52.91075
                ],
                [
                    78.5642979,
                    52.9098801
                ],
                [
                    78.562777,
                    52.9087278
                ],
                [
                    78.5619785,
                    52.9080459
                ],
                [
                    78.5614605,
                    52.9076746
                ],
                [
                    78.5612805,
                    52.9073346
                ],
                [
                    78.5600319,
                    52.9065262
                ],
                [
                    78.5587099,
                    52.905373
                ],
                [
                    78.5575,
                    52.90375
                ],
                [
                    78.5558333,
                    52.9013981
                ],
                [
                    78.5550532,
                    52.9004193
                ],
                [
                    78.5542937,
                    52.8992387
                ],
                [
                    78.5527816,
                    52.8957175
                ],
                [
                    78.5516373,
                    52.8925113
                ],
                [
                    78.5514941,
                    52.8916461
                ],
                [
                    78.5505386,
                    52.8859544
                ],
                [
                    78.5505,
                    52.88375
                ],
                [
                    78.5508172,
                    52.8745959
                ],
                [
                    78.5504605,
                    52.8718069
                ],
                [
                    78.5503018,
                    52.8702391
                ],
                [
                    78.5501067,
                    52.8688654
                ],
                [
                    78.5499446,
                    52.8674571
                ],
                [
                    78.55,
                    52.866
                ],
                [
                    78.5504398,
                    52.863916
                ],
                [
                    78.551,
                    52.86225
                ],
                [
                    78.5492771,
                    52.8633848
                ],
                [
                    78.5355497,
                    52.8772101
                ],
                [
                    78.5188606,
                    52.8951774
                ],
                [
                    78.4968164,
                    52.9188363
                ]
            ],
            "longitude": 78.563568,
            "latitude": 52.919704
        },
        "6003": {
            "name": "СЛАВГОРОД",
            "population": 30370,
            "type": "town",
            "poly": [
                [
                    78.5616224,
                    53.0136139
                ],
                [
                    78.570802,
                    53.0166252
                ],
                [
                    78.5884825,
                    53.0224125
                ],
                [
                    78.6042333,
                    53.001042
                ],
                [
                    78.6084468,
                    53.0014446
                ],
                [
                    78.5982724,
                    53.0149119
                ],
                [
                    78.6202388,
                    53.0264133
                ],
                [
                    78.6261911,
                    53.0190212
                ],
                [
                    78.6292466,
                    53.0187371
                ],
                [
                    78.6332744,
                    53.0181717
                ],
                [
                    78.6317279,
                    53.0113921
                ],
                [
                    78.6402812,
                    53.0108141
                ],
                [
                    78.6406657,
                    53.0127916
                ],
                [
                    78.6454845,
                    53.0125393
                ],
                [
                    78.6456728,
                    53.0142967
                ],
                [
                    78.6838281,
                    53.0122756
                ],
                [
                    78.6843117,
                    53.0111709
                ],
                [
                    78.6879921,
                    53.0108334
                ],
                [
                    78.6882958,
                    53.0064027
                ],
                [
                    78.6818577,
                    53.0056382
                ],
                [
                    78.6810529,
                    52.9946519
                ],
                [
                    78.6957481,
                    52.9925769
                ],
                [
                    78.7067241,
                    52.9887147
                ],
                [
                    78.7031423,
                    52.9507029
                ],
                [
                    78.6870229,
                    52.9479169
                ],
                [
                    78.6894195,
                    52.9437634
                ],
                [
                    78.6850079,
                    52.9432777
                ],
                [
                    78.6736539,
                    52.9450087
                ],
                [
                    78.6713866,
                    52.9435931
                ],
                [
                    78.6588212,
                    52.9498881
                ],
                [
                    78.596374,
                    52.9485322
                ],
                [
                    78.5982439,
                    52.956043
                ],
                [
                    78.5968977,
                    52.9561879
                ],
                [
                    78.5981501,
                    52.9626362
                ],
                [
                    78.6016927,
                    52.9752384
                ],
                [
                    78.604431,
                    52.9757488
                ],
                [
                    78.6004278,
                    52.9938284
                ],
                [
                    78.5984547,
                    53.0010234
                ],
                [
                    78.5770819,
                    52.9975907
                ],
                [
                    78.5616224,
                    53.0136139
                ]
            ],
            "longitude": 78.646251,
            "latitude": 52.9892428
        },
        "6004": {
            "name": "КУЛУНДА",
            "population": 14498,
            "type": "town",
            "poly": [
                [
                    78.893685,
                    52.5640859
                ],
                [
                    78.8961616,
                    52.5744501
                ],
                [
                    78.9101765,
                    52.5743263
                ],
                [
                    78.919513,
                    52.5793449
                ],
                [
                    78.9518679,
                    52.5892715
                ],
                [
                    78.9590092,
                    52.573904
                ],
                [
                    78.9756311,
                    52.5777178
                ],
                [
                    78.9823411,
                    52.5675561
                ],
                [
                    78.9709261,
                    52.5557665
                ],
                [
                    78.9073251,
                    52.5473094
                ],
                [
                    78.8939082,
                    52.5593327
                ],
                [
                    78.893685,
                    52.5640859
                ]
            ],
            "longitude": 78.935448,
            "latitude": 52.566559
        },
        "6005": {
            "name": "КЛЮЧИ",
            "population": 8660,
            "type": "town",
            "poly": [
                [
                    79.1341575,
                    52.2468475
                ],
                [
                    79.1391792,
                    52.2491285
                ],
                [
                    79.1400971,
                    52.2503076
                ],
                [
                    79.1389632,
                    52.2511781
                ],
                [
                    79.1396831,
                    52.2519714
                ],
                [
                    79.1484845,
                    52.2546819
                ],
                [
                    79.1492583,
                    52.2531064
                ],
                [
                    79.1508783,
                    52.2531835
                ],
                [
                    79.1516703,
                    52.2546158
                ],
                [
                    79.1527322,
                    52.2564558
                ],
                [
                    79.1541541,
                    52.256566
                ],
                [
                    79.1534881,
                    52.2550235
                ],
                [
                    79.1521561,
                    52.25228
                ],
                [
                    79.1521202,
                    52.2507814
                ],
                [
                    79.1533442,
                    52.2499109
                ],
                [
                    79.155252,
                    52.249999
                ],
                [
                    79.1582938,
                    52.2506602
                ],
                [
                    79.1599137,
                    52.2514866
                ],
                [
                    79.1627035,
                    52.2535912
                ],
                [
                    79.1662671,
                    52.255343
                ],
                [
                    79.1678691,
                    52.2563126
                ],
                [
                    79.169741,
                    52.257183
                ],
                [
                    79.1677791,
                    52.2596287
                ],
                [
                    79.1618395,
                    52.2606312
                ],
                [
                    79.1596123,
                    52.2611374
                ],
                [
                    79.1595349,
                    52.262438
                ],
                [
                    79.1651595,
                    52.2608028
                ],
                [
                    79.1694624,
                    52.2598561
                ],
                [
                    79.1708123,
                    52.2623003
                ],
                [
                    79.1719957,
                    52.2631093
                ],
                [
                    79.1740295,
                    52.2640677
                ],
                [
                    79.1753614,
                    52.2648938
                ],
                [
                    79.1767112,
                    52.2663589
                ],
                [
                    79.1779353,
                    52.2680662
                ],
                [
                    79.1787092,
                    52.2689363
                ],
                [
                    79.180977,
                    52.2704673
                ],
                [
                    79.1835149,
                    52.2710731
                ],
                [
                    79.1848828,
                    52.2708308
                ],
                [
                    79.1856854,
                    52.2701536
                ],
                [
                    79.1841738,
                    52.2679378
                ],
                [
                    79.1896929,
                    52.2645601
                ],
                [
                    79.1916615,
                    52.2629465
                ],
                [
                    79.1938762,
                    52.2625162
                ],
                [
                    79.1957393,
                    52.2613543
                ],
                [
                    79.1986923,
                    52.2582343
                ],
                [
                    79.2004148,
                    52.2558673
                ],
                [
                    79.1964424,
                    52.2551787
                ],
                [
                    79.1951416,
                    52.2535647
                ],
                [
                    79.1936653,
                    52.2501644
                ],
                [
                    79.190853,
                    52.247345
                ],
                [
                    79.1872673,
                    52.2455586
                ],
                [
                    79.1846659,
                    52.2420716
                ],
                [
                    79.1835269,
                    52.2392086
                ],
                [
                    79.1806864,
                    52.2373142
                ],
                [
                    79.1786617,
                    52.2358675
                ],
                [
                    79.177143,
                    52.2387264
                ],
                [
                    79.1726715,
                    52.2378825
                ],
                [
                    79.1699287,
                    52.2380248
                ],
                [
                    79.1689495,
                    52.238598
                ],
                [
                    79.1669031,
                    52.2404152
                ],
                [
                    79.1662011,
                    52.2418369
                ],
                [
                    79.1652832,
                    52.2428839
                ],
                [
                    79.1635922,
                    52.2429285
                ],
                [
                    79.1597956,
                    52.2420245
                ],
                [
                    79.1558935,
                    52.242907
                ],
                [
                    79.1503041,
                    52.2390108
                ],
                [
                    79.1481245,
                    52.2394198
                ],
                [
                    79.1445388,
                    52.2413356
                ],
                [
                    79.1427812,
                    52.2431653
                ],
                [
                    79.1406011,
                    52.2450512
                ],
                [
                    79.1388372,
                    52.2451944
                ],
                [
                    79.1341575,
                    52.2468475
                ]
            ],
            "longitude": 79.171432,
            "latitude": 52.254906
        },
        "6006": {
            "name": "МИХАЙЛОВСКОЕ",
            "population": 10756,
            "type": "town",
            "poly": [
                [
                    79.6413138,
                    51.8150929
                ],
                [
                    79.6517249,
                    51.8185689
                ],
                [
                    79.6725369,
                    51.8150542
                ],
                [
                    79.6915782,
                    51.817265
                ],
                [
                    79.7082031,
                    51.82999
                ],
                [
                    79.7240547,
                    51.831543
                ],
                [
                    79.7469281,
                    51.8298913
                ],
                [
                    79.7599139,
                    51.827188
                ],
                [
                    79.7696191,
                    51.8281173
                ],
                [
                    79.7777344,
                    51.8248105
                ],
                [
                    79.777345,
                    51.8212402
                ],
                [
                    79.7540721,
                    51.8144576
                ],
                [
                    79.7471024,
                    51.812519
                ],
                [
                    79.7277371,
                    51.8105388
                ],
                [
                    79.7186898,
                    51.8095555
                ],
                [
                    79.7112467,
                    51.8078954
                ],
                [
                    79.670469,
                    51.8010925
                ],
                [
                    79.6512331,
                    51.8122432
                ],
                [
                    79.6413138,
                    51.8150929
                ]
            ],
            "longitude": 79.7193176,
            "latitude": 51.8212486
        },
        "6007": {
            "name": "СТЕПНОЕ ОЗЕРО",
            "population": 6352,
            "type": "town",
            "poly": null,
            "longitude": 79.855957,
            "latitude": 52.77866
        },
        "6008": {
            "name": "БЛАГОВЕЩЕНКА",
            "population": 11548,
            "type": "town",
            "poly": [
                [
                    79.8386641,
                    52.8344316
                ],
                [
                    79.8642059,
                    52.8549208
                ],
                [
                    79.9057799,
                    52.8426984
                ],
                [
                    79.9141922,
                    52.8242847
                ],
                [
                    79.9440621,
                    52.8284837
                ],
                [
                    79.9483292,
                    52.8200117
                ],
                [
                    79.935284,
                    52.8169908
                ],
                [
                    79.9328457,
                    52.8211168
                ],
                [
                    79.8837432,
                    52.8087191
                ],
                [
                    79.8386641,
                    52.8344316
                ]
            ],
            "longitude": 79.8705683,
            "latitude": 52.830602
        },
        "6009": {
            "name": "РОДИНО",
            "population": 8202,
            "type": "town",
            "poly": null,
            "longitude": 80.203499,
            "latitude": 52.499649
        },
        "6010": {
            "name": "ПАНКРУШИХА",
            "population": 4941,
            "type": "town",
            "poly": null,
            "longitude": 80.3462286,
            "latitude": 53.8327381
        },
        "6011": {
            "name": "ВОЛЧИХА",
            "population": 10011,
            "type": "town",
            "poly": null,
            "longitude": 80.3649718,
            "latitude": 52.0171227
        },
        "6012": {
            "name": "БАЕВО",
            "population": 4188,
            "type": "town",
            "poly": null,
            "longitude": 80.773415,
            "latitude": 53.274986
        },
        "6013": {
            "name": "НОВОЕГОРЬЕВСКОЕ",
            "population": 5596,
            "type": "town",
            "poly": [
                [
                    80.8635068,
                    51.729572
                ],
                [
                    80.8650517,
                    51.7331868
                ],
                [
                    80.8645367,
                    51.7345689
                ],
                [
                    80.8729481,
                    51.7505127
                ],
                [
                    80.8768964,
                    51.7507252
                ],
                [
                    80.8801579,
                    51.7542321
                ],
                [
                    80.8731198,
                    51.7552947
                ],
                [
                    80.8724332,
                    51.7578449
                ],
                [
                    80.8741498,
                    51.7579512
                ],
                [
                    80.8741498,
                    51.7605013
                ],
                [
                    80.8756947,
                    51.7622012
                ],
                [
                    80.8773094,
                    51.7624132
                ],
                [
                    80.8813596,
                    51.7629449
                ],
                [
                    80.8853078,
                    51.7671945
                ],
                [
                    80.8782697,
                    51.7701689
                ],
                [
                    80.8870244,
                    51.7751613
                ],
                [
                    80.8969807,
                    51.7728245
                ],
                [
                    80.8986974,
                    51.7771794
                ],
                [
                    80.9062505,
                    51.7786663
                ],
                [
                    80.9129452,
                    51.7757986
                ],
                [
                    80.9114003,
                    51.7744178
                ],
                [
                    80.9227298,
                    51.7665571
                ],
                [
                    80.9160352,
                    51.7592262
                ],
                [
                    80.9127736,
                    51.7561448
                ],
                [
                    80.9091687,
                    51.7489185
                ],
                [
                    80.8986974,
                    51.7416911
                ],
                [
                    80.8974956,
                    51.7416911
                ],
                [
                    80.8932042,
                    51.7386085
                ],
                [
                    80.887711,
                    51.7377581
                ],
                [
                    80.8806728,
                    51.7382896
                ],
                [
                    80.8748364,
                    51.7303162
                ],
                [
                    80.8635068,
                    51.729572
                ]
            ],
            "longitude": 80.892517,
            "latitude": 51.75893
        },
        "6014": {
            "name": "РОМАНОВО",
            "population": 5624,
            "type": "town",
            "poly": null,
            "longitude": 81.226359,
            "latitude": 52.6187229
        },
        "6015": {
            "name": "КАМЕНЬ-НА-ОБИ",
            "population": 41787,
            "type": "town",
            "poly": [
                [
                    81.2496106,
                    53.7825371
                ],
                [
                    81.25496,
                    53.7825021
                ],
                [
                    81.260566,
                    53.7827354
                ],
                [
                    81.2564799,
                    53.7860242
                ],
                [
                    81.2533413,
                    53.7872721
                ],
                [
                    81.2524531,
                    53.7887181
                ],
                [
                    81.2524926,
                    53.7893361
                ],
                [
                    81.2532624,
                    53.790339
                ],
                [
                    81.2538941,
                    53.7909104
                ],
                [
                    81.2668629,
                    53.793464
                ],
                [
                    81.2745216,
                    53.79456
                ],
                [
                    81.2832466,
                    53.7953296
                ],
                [
                    81.26935,
                    53.808934
                ],
                [
                    81.266547,
                    53.8113816
                ],
                [
                    81.2650271,
                    53.8135145
                ],
                [
                    81.2692316,
                    53.8173952
                ],
                [
                    81.2708502,
                    53.8178963
                ],
                [
                    81.2553153,
                    53.8251207
                ],
                [
                    81.258217,
                    53.8265188
                ],
                [
                    81.2694685,
                    53.8207629
                ],
                [
                    81.2761009,
                    53.8251789
                ],
                [
                    81.277305,
                    53.8270547
                ],
                [
                    81.2807791,
                    53.8270081
                ],
                [
                    81.289425,
                    53.82561
                ],
                [
                    81.2913003,
                    53.8254003
                ],
                [
                    81.2934123,
                    53.8240255
                ],
                [
                    81.2957811,
                    53.8229302
                ],
                [
                    81.301012,
                    53.8217067
                ],
                [
                    81.3024925,
                    53.8202851
                ],
                [
                    81.3056903,
                    53.8189218
                ],
                [
                    81.3118293,
                    53.8184207
                ],
                [
                    81.3127767,
                    53.8188402
                ],
                [
                    81.3193697,
                    53.8202152
                ],
                [
                    81.3236532,
                    53.8207746
                ],
                [
                    81.3334242,
                    53.8248877
                ],
                [
                    81.3283117,
                    53.8199822
                ],
                [
                    81.3260811,
                    53.8158802
                ],
                [
                    81.3295,
                    53.81525
                ],
                [
                    81.33225,
                    53.813
                ],
                [
                    81.33275,
                    53.813
                ],
                [
                    81.333,
                    53.81325
                ],
                [
                    81.33575,
                    53.81125
                ],
                [
                    81.3355,
                    53.811
                ],
                [
                    81.33475,
                    53.81075
                ],
                [
                    81.3349999,
                    53.8105
                ],
                [
                    81.3365,
                    53.81025
                ],
                [
                    81.3425,
                    53.80425
                ],
                [
                    81.343,
                    53.804
                ],
                [
                    81.3515,
                    53.7975
                ],
                [
                    81.35575,
                    53.795
                ],
                [
                    81.356,
                    53.794
                ],
                [
                    81.35675,
                    53.7935
                ],
                [
                    81.3572499,
                    53.792
                ],
                [
                    81.35775,
                    53.7915
                ],
                [
                    81.35825,
                    53.7915
                ],
                [
                    81.3585,
                    53.791
                ],
                [
                    81.35925,
                    53.78975
                ],
                [
                    81.36225,
                    53.787
                ],
                [
                    81.362,
                    53.7865
                ],
                [
                    81.36275,
                    53.7865
                ],
                [
                    81.363,
                    53.78675
                ],
                [
                    81.3635,
                    53.7865
                ],
                [
                    81.36375,
                    53.78625
                ],
                [
                    81.364,
                    53.7855
                ],
                [
                    81.368,
                    53.783
                ],
                [
                    81.3705,
                    53.78125
                ],
                [
                    81.36875,
                    53.77925
                ],
                [
                    81.36825,
                    53.7795
                ],
                [
                    81.3685,
                    53.77975
                ],
                [
                    81.36825,
                    53.78025
                ],
                [
                    81.366,
                    53.77925
                ],
                [
                    81.36125,
                    53.778
                ],
                [
                    81.36075,
                    53.778
                ],
                [
                    81.35925,
                    53.777
                ],
                [
                    81.35825,
                    53.77625
                ],
                [
                    81.35625,
                    53.773
                ],
                [
                    81.3565,
                    53.77275
                ],
                [
                    81.35675,
                    53.7725
                ],
                [
                    81.35575,
                    53.77175
                ],
                [
                    81.3555,
                    53.7715
                ],
                [
                    81.356,
                    53.77075
                ],
                [
                    81.356,
                    53.76975
                ],
                [
                    81.35575,
                    53.7695
                ],
                [
                    81.3555,
                    53.76925
                ],
                [
                    81.356,
                    53.769
                ],
                [
                    81.35575,
                    53.7685
                ],
                [
                    81.356,
                    53.76675
                ],
                [
                    81.35775,
                    53.7655
                ],
                [
                    81.3602499,
                    53.765
                ],
                [
                    81.36075,
                    53.76475
                ],
                [
                    81.36675,
                    53.765
                ],
                [
                    81.36725,
                    53.765
                ],
                [
                    81.36825,
                    53.764
                ],
                [
                    81.368,
                    53.76325
                ],
                [
                    81.368,
                    53.76275
                ],
                [
                    81.367,
                    53.7615
                ],
                [
                    81.36525,
                    53.761
                ],
                [
                    81.365,
                    53.76125
                ],
                [
                    81.36475,
                    53.761
                ],
                [
                    81.365,
                    53.76025
                ],
                [
                    81.36675,
                    53.75975
                ],
                [
                    81.37075,
                    53.7605
                ],
                [
                    81.37125,
                    53.7605
                ],
                [
                    81.37275,
                    53.7595
                ],
                [
                    81.3735,
                    53.759
                ],
                [
                    81.37325,
                    53.758
                ],
                [
                    81.37275,
                    53.75775
                ],
                [
                    81.369,
                    53.757
                ],
                [
                    81.3695,
                    53.75625
                ],
                [
                    81.37425,
                    53.75725
                ],
                [
                    81.37475,
                    53.757
                ],
                [
                    81.37575,
                    53.7575
                ],
                [
                    81.37625,
                    53.75675
                ],
                [
                    81.3754389,
                    53.7502762
                ],
                [
                    81.3736176,
                    53.7482183
                ],
                [
                    81.373289,
                    53.7474115
                ],
                [
                    81.373226,
                    53.7437059
                ],
                [
                    81.3723921,
                    53.7426076
                ],
                [
                    81.373289,
                    53.7417259
                ],
                [
                    81.3717984,
                    53.7406127
                ],
                [
                    81.372152,
                    53.7397459
                ],
                [
                    81.3736176,
                    53.7397086
                ],
                [
                    81.374224,
                    53.7394396
                ],
                [
                    81.3755505,
                    53.7376238
                ],
                [
                    81.3742998,
                    53.7363161
                ],
                [
                    81.3742998,
                    53.7353223
                ],
                [
                    81.3749945,
                    53.7348739
                ],
                [
                    81.3769528,
                    53.7348814
                ],
                [
                    81.3794036,
                    53.7333718
                ],
                [
                    81.3872488,
                    53.7296277
                ],
                [
                    81.3906724,
                    53.7266754
                ],
                [
                    81.3944624,
                    53.7221383
                ],
                [
                    81.3884111,
                    53.7199405
                ],
                [
                    81.3838505,
                    53.7197312
                ],
                [
                    81.365267,
                    53.715126
                ],
                [
                    81.3622603,
                    53.7166736
                ],
                [
                    81.3500691,
                    53.7292241
                ],
                [
                    81.3493744,
                    53.7315783
                ],
                [
                    81.3511178,
                    53.7399253
                ],
                [
                    81.3406575,
                    53.7424208
                ],
                [
                    81.3425146,
                    53.7443185
                ],
                [
                    81.341845,
                    53.7446398
                ],
                [
                    81.3418576,
                    53.7450357
                ],
                [
                    81.3420977,
                    53.7458351
                ],
                [
                    81.3415544,
                    53.746754
                ],
                [
                    81.3396974,
                    53.7463207
                ],
                [
                    81.3364506,
                    53.7501232
                ],
                [
                    81.3380424,
                    53.7508553
                ],
                [
                    81.3396089,
                    53.7523717
                ],
                [
                    81.342982,
                    53.7540598
                ],
                [
                    81.3300835,
                    53.7611775
                ],
                [
                    81.3285422,
                    53.7604307
                ],
                [
                    81.3255734,
                    53.7614763
                ],
                [
                    81.3230594,
                    53.7587279
                ],
                [
                    81.3200274,
                    53.7570325
                ],
                [
                    81.3115332,
                    53.7668124
                ],
                [
                    81.297459,
                    53.7707674
                ],
                [
                    81.2872141,
                    53.7717474
                ],
                [
                    81.2709883,
                    53.7672091
                ],
                [
                    81.2574669,
                    53.7795396
                ],
                [
                    81.2501633,
                    53.7805777
                ],
                [
                    81.2496106,
                    53.7825371
                ]
            ],
            "longitude": 81.348503,
            "latitude": 53.789753
        },
        "6016": {
            "name": "НОВИЧИХА",
            "population": 4140,
            "type": "town",
            "poly": [
                [
                    81.3657575,
                    52.1952776
                ],
                [
                    81.3737982,
                    52.2033421
                ],
                [
                    81.3820216,
                    52.2097254
                ],
                [
                    81.3858592,
                    52.2161078
                ],
                [
                    81.3933517,
                    52.2221535
                ],
                [
                    81.4024889,
                    52.2201384
                ],
                [
                    81.406692,
                    52.2124129
                ],
                [
                    81.40523,
                    52.2015501
                ],
                [
                    81.4008442,
                    52.1940454
                ],
                [
                    81.3825698,
                    52.1937094
                ],
                [
                    81.3657575,
                    52.1952776
                ]
            ],
            "longitude": 81.394028,
            "latitude": 52.210251
        },
        "6017": {
            "name": "ГОРНЯК",
            "population": 13040,
            "type": "town",
            "poly": [
                [
                    81.4200333,
                    50.9857214
                ],
                [
                    81.4338116,
                    51.0193712
                ],
                [
                    81.4461937,
                    51.0232621
                ],
                [
                    81.4761028,
                    51.0035583
                ],
                [
                    81.4815982,
                    50.9998777
                ],
                [
                    81.4871933,
                    51.0037897
                ],
                [
                    81.4911639,
                    51.0025003
                ],
                [
                    81.491205,
                    51.002487
                ],
                [
                    81.4921832,
                    51.0021693
                ],
                [
                    81.4961688,
                    51.0001076
                ],
                [
                    81.4981305,
                    51.0002188
                ],
                [
                    81.5025721,
                    51.0012481
                ],
                [
                    81.5103647,
                    51.0021297
                ],
                [
                    81.517548,
                    51.0019694
                ],
                [
                    81.5234541,
                    51.0004119
                ],
                [
                    81.5282185,
                    50.9956623
                ],
                [
                    81.5449684,
                    50.9850934
                ],
                [
                    81.5413848,
                    50.9787634
                ],
                [
                    81.5376356,
                    50.9730642
                ],
                [
                    81.5309589,
                    50.974033
                ],
                [
                    81.5294718,
                    50.9742386
                ],
                [
                    81.5280923,
                    50.9745349
                ],
                [
                    81.5265363,
                    50.9750623
                ],
                [
                    81.5241822,
                    50.9759895
                ],
                [
                    81.5236624,
                    50.9761113
                ],
                [
                    81.5233073,
                    50.9761311
                ],
                [
                    81.5188699,
                    50.976023
                ],
                [
                    81.518276,
                    50.9758447
                ],
                [
                    81.5154375,
                    50.9749926
                ],
                [
                    81.5122015,
                    50.9778878
                ],
                [
                    81.5091698,
                    50.9825894
                ],
                [
                    81.5014348,
                    50.983208
                ],
                [
                    81.4935477,
                    50.9832743
                ],
                [
                    81.484453,
                    50.9830197
                ],
                [
                    81.4677536,
                    50.9830069
                ],
                [
                    81.4563851,
                    50.9820555
                ],
                [
                    81.4547457,
                    50.9818729
                ],
                [
                    81.4200333,
                    50.9857214
                ]
            ],
            "longitude": 81.475204,
            "latitude": 50.993965
        },
        "6018": {
            "name": "ТЮМЕНЦЕВО",
            "population": 5255,
            "type": "town",
            "poly": null,
            "longitude": 81.497551,
            "latitude": 53.319839
        },
        "6019": {
            "name": "МАМОНТОВО",
            "population": 8652,
            "type": "town",
            "poly": [
                [
                    81.5645718,
                    52.6767905
                ],
                [
                    81.5760731,
                    52.6819943
                ],
                [
                    81.5839696,
                    52.6861568
                ],
                [
                    81.5898061,
                    52.6881338
                ],
                [
                    81.5925526,
                    52.6910472
                ],
                [
                    81.5992474,
                    52.6945846
                ],
                [
                    81.6069722,
                    52.6952089
                ],
                [
                    81.6186452,
                    52.703427
                ],
                [
                    81.6184734,
                    52.7074834
                ],
                [
                    81.6107487,
                    52.7139314
                ],
                [
                    81.6114354,
                    52.7180908
                ],
                [
                    81.6162419,
                    52.727552
                ],
                [
                    81.62534,
                    52.7296313
                ],
                [
                    81.6267133,
                    52.727552
                ],
                [
                    81.6286015,
                    52.7194426
                ],
                [
                    81.6347813,
                    52.7179869
                ],
                [
                    81.6387296,
                    52.7179869
                ],
                [
                    81.6452527,
                    52.7197545
                ],
                [
                    81.6507458,
                    52.7207943
                ],
                [
                    81.655724,
                    52.7195466
                ],
                [
                    81.6522908,
                    52.7167391
                ],
                [
                    81.6478276,
                    52.7120595
                ],
                [
                    81.6337514,
                    52.7033229
                ],
                [
                    81.6098904,
                    52.6912553
                ],
                [
                    81.6031956,
                    52.6873014
                ],
                [
                    81.5951276,
                    52.6828268
                ],
                [
                    81.5916943,
                    52.681578
                ],
                [
                    81.5683484,
                    52.672419
                ],
                [
                    81.5645718,
                    52.6767905
                ]
            ],
            "longitude": 81.631264,
            "latitude": 52.706684
        },
        "6020": {
            "name": "ПОСПЕЛИХА",
            "population": 11915,
            "type": "town",
            "poly": null,
            "longitude": 81.824982,
            "latitude": 51.991352
        },
        "6021": {
            "name": "ЗМЕИНОГОРСК",
            "population": 10569,
            "type": "town",
            "poly": [
                [
                    82.1458648,
                    51.1532031
                ],
                [
                    82.1505426,
                    51.1591409
                ],
                [
                    82.1544136,
                    51.1645182
                ],
                [
                    82.1589798,
                    51.1702338
                ],
                [
                    82.1638292,
                    51.1742053
                ],
                [
                    82.1680263,
                    51.1811466
                ],
                [
                    82.1713823,
                    51.1864513
                ],
                [
                    82.1827806,
                    51.18948
                ],
                [
                    82.1945137,
                    51.1845146
                ],
                [
                    82.1984962,
                    51.1755291
                ],
                [
                    82.203021,
                    51.1713868
                ],
                [
                    82.205653,
                    51.1725335
                ],
                [
                    82.208849,
                    51.1739182
                ],
                [
                    82.2137121,
                    51.1710089
                ],
                [
                    82.2125209,
                    51.1698048
                ],
                [
                    82.216664,
                    51.1682992
                ],
                [
                    82.2181821,
                    51.1635413
                ],
                [
                    82.2210387,
                    51.1651033
                ],
                [
                    82.2211448,
                    51.1622867
                ],
                [
                    82.2211845,
                    51.1613398
                ],
                [
                    82.2157396,
                    51.1493321
                ],
                [
                    82.212757,
                    51.1463142
                ],
                [
                    82.2111218,
                    51.1424143
                ],
                [
                    82.2109372,
                    51.1418865
                ],
                [
                    82.2092342,
                    51.1367551
                ],
                [
                    82.2055382,
                    51.1348024
                ],
                [
                    82.2001681,
                    51.1334037
                ],
                [
                    82.1969779,
                    51.133385
                ],
                [
                    82.193827,
                    51.1340549
                ],
                [
                    82.1902393,
                    51.1349813
                ],
                [
                    82.1866773,
                    51.1362954
                ],
                [
                    82.1833948,
                    51.1364774
                ],
                [
                    82.1765018,
                    51.1372867
                ],
                [
                    82.1720299,
                    51.1395576
                ],
                [
                    82.1703623,
                    51.1404661
                ],
                [
                    82.1686286,
                    51.1415691
                ],
                [
                    82.1650441,
                    51.1452185
                ],
                [
                    82.1597707,
                    51.1454282
                ],
                [
                    82.1461733,
                    51.1456363
                ],
                [
                    82.1458648,
                    51.1532031
                ]
            ],
            "longitude": 82.186234,
            "latitude": 51.158436
        },
        "6022": {
            "name": "ШИПУНОВО",
            "population": 13462,
            "type": "town",
            "poly": null,
            "longitude": 82.261627,
            "latitude": 52.218868
        },
        "6023": {
            "name": "КУРЬЯ",
            "population": 3375,
            "type": "town",
            "poly": null,
            "longitude": 82.2887814,
            "latitude": 51.6002902
        },
        "6024": {
            "name": "КРАСНОЩЁКОВО",
            "population": 4848,
            "type": "town",
            "poly": [
                [
                    82.7006947,
                    51.660268
                ],
                [
                    82.7013732,
                    51.6624998
                ],
                [
                    82.7052177,
                    51.663508
                ],
                [
                    82.7107315,
                    51.6646324
                ],
                [
                    82.7147724,
                    51.6640702
                ],
                [
                    82.7232671,
                    51.6702787
                ],
                [
                    82.7286838,
                    51.6727803
                ],
                [
                    82.7465479,
                    51.6797127
                ],
                [
                    82.7654491,
                    51.6841431
                ],
                [
                    82.7740929,
                    51.6807131
                ],
                [
                    82.7732861,
                    51.6767112
                ],
                [
                    82.7539239,
                    51.6672765
                ],
                [
                    82.7487376,
                    51.6590554
                ],
                [
                    82.738212,
                    51.6557899
                ],
                [
                    82.7339445,
                    51.6585545
                ],
                [
                    82.7094326,
                    51.6506014
                ],
                [
                    82.7006947,
                    51.660268
                ]
            ],
            "longitude": 82.730652,
            "latitude": 51.669357
        },
        "6025": {
            "name": "ПАВЛОВСК",
            "population": 14445,
            "type": "town",
            "poly": [
                [
                    82.9219775,
                    53.3354274
                ],
                [
                    82.9271201,
                    53.3459784
                ],
                [
                    82.9418932,
                    53.3513924
                ],
                [
                    82.9588167,
                    53.3522853
                ],
                [
                    82.9733094,
                    53.3473738
                ],
                [
                    83.0011726,
                    53.3327474
                ],
                [
                    83.0224907,
                    53.3182277
                ],
                [
                    83.0025751,
                    53.3049323
                ],
                [
                    82.9938795,
                    53.2949859
                ],
                [
                    82.986493,
                    53.2876643
                ],
                [
                    82.9684474,
                    53.2893411
                ],
                [
                    82.9715329,
                    53.2991212
                ],
                [
                    82.9604063,
                    53.3121391
                ],
                [
                    82.9537678,
                    53.3209645
                ],
                [
                    82.9465682,
                    53.3269401
                ],
                [
                    82.9219775,
                    53.3354274
                ]
            ],
            "longitude": 82.989059,
            "latitude": 53.316284
        },
        "6026": {
            "name": "ТОПЧИХА",
            "population": 8906,
            "type": "town",
            "poly": null,
            "longitude": 83.115343,
            "latitude": 52.8175669
        },
        "6027": {
            "name": "ТАЛЬМЕНКА",
            "population": 19044,
            "type": "town",
            "poly": [
                [
                    83.5243564,
                    53.8179018
                ],
                [
                    83.5269658,
                    53.827644
                ],
                [
                    83.5588535,
                    53.8444574
                ],
                [
                    83.5899975,
                    53.8421335
                ],
                [
                    83.6046381,
                    53.8348795
                ],
                [
                    83.6086546,
                    53.8312212
                ],
                [
                    83.61356,
                    53.8223272
                ],
                [
                    83.6127551,
                    53.8125691
                ],
                [
                    83.6049069,
                    53.8027489
                ],
                [
                    83.5520893,
                    53.7942394
                ],
                [
                    83.5428111,
                    53.7973012
                ],
                [
                    83.5393516,
                    53.7989465
                ],
                [
                    83.5372021,
                    53.8001545
                ],
                [
                    83.5318724,
                    53.8040251
                ],
                [
                    83.5273123,
                    53.8092299
                ],
                [
                    83.5243564,
                    53.8179018
                ]
            ],
            "longitude": 83.55323158247458,
            "latitude": 53.81320614277048
        },
        "6028": {
            "name": "ЮЖНЫЙ",
            "population": 20028,
            "type": "town",
            "poly": null,
            "longitude": 83.693886,
            "latitude": 53.254749
        },
        "6029": {
            "name": "СИБИРСКИЙ",
            "population": 11765,
            "type": "town",
            "poly": [
                [
                    83.7871933,
                    53.5606371
                ],
                [
                    83.7925805,
                    53.5616878
                ],
                [
                    83.7915031,
                    53.5630107
                ],
                [
                    83.795612,
                    53.5653458
                ],
                [
                    83.7988099,
                    53.5676508
                ],
                [
                    83.7997771,
                    53.5675999
                ],
                [
                    83.8028486,
                    53.5669122
                ],
                [
                    83.8044648,
                    53.5663916
                ],
                [
                    83.8067002,
                    53.5663822
                ],
                [
                    83.8101013,
                    53.5649496
                ],
                [
                    83.8129559,
                    53.5647156
                ],
                [
                    83.8133338,
                    53.565088
                ],
                [
                    83.8202488,
                    53.5698155
                ],
                [
                    83.818504,
                    53.5710331
                ],
                [
                    83.8197262,
                    53.5714246
                ],
                [
                    83.8213022,
                    53.571778
                ],
                [
                    83.8226852,
                    53.5715153
                ],
                [
                    83.8243657,
                    53.569868
                ],
                [
                    83.8253386,
                    53.5684069
                ],
                [
                    83.8314575,
                    53.5676285
                ],
                [
                    83.8337251,
                    53.5675808
                ],
                [
                    83.8361213,
                    53.5642237
                ],
                [
                    83.8371183,
                    53.5638464
                ],
                [
                    83.8369012,
                    53.5635837
                ],
                [
                    83.8392491,
                    53.5622035
                ],
                [
                    83.8396753,
                    53.561917
                ],
                [
                    83.8429559,
                    53.5603792
                ],
                [
                    83.8449018,
                    53.5586216
                ],
                [
                    83.8436876,
                    53.5577141
                ],
                [
                    83.8454566,
                    53.5568209
                ],
                [
                    83.8450569,
                    53.5563369
                ],
                [
                    83.8440576,
                    53.5555479
                ],
                [
                    83.8433164,
                    53.5552344
                ],
                [
                    83.8425374,
                    53.5552867
                ],
                [
                    83.84157,
                    53.5545403
                ],
                [
                    83.8410047,
                    53.5545926
                ],
                [
                    83.8399745,
                    53.5548389
                ],
                [
                    83.8380983,
                    53.5538511
                ],
                [
                    83.8356796,
                    53.5550778
                ],
                [
                    83.8356924,
                    53.5549173
                ],
                [
                    83.8353709,
                    53.555009
                ],
                [
                    83.8352082,
                    53.5549351
                ],
                [
                    83.8333864,
                    53.5559053
                ],
                [
                    83.828474,
                    53.5544649
                ],
                [
                    83.8211494,
                    53.5541173
                ],
                [
                    83.8172336,
                    53.5558083
                ],
                [
                    83.815344,
                    53.5559754
                ],
                [
                    83.8133016,
                    53.5554644
                ],
                [
                    83.8057112,
                    53.5553449
                ],
                [
                    83.8050357,
                    53.5544565
                ],
                [
                    83.7954029,
                    53.5548004
                ],
                [
                    83.7933445,
                    53.5554118
                ],
                [
                    83.7924117,
                    53.5560901
                ],
                [
                    83.7916238,
                    53.5570454
                ],
                [
                    83.7920338,
                    53.5580817
                ],
                [
                    83.7909403,
                    53.5581009
                ],
                [
                    83.7909564,
                    53.559018
                ],
                [
                    83.7886326,
                    53.5587457
                ],
                [
                    83.7871933,
                    53.5606371
                ]
            ],
            "longitude": 83.838425,
            "latitude": 53.557068
        },
        "6030": {
            "name": "НОВОАЛТАЙСК",
            "population": 73134,
            "type": "town",
            "poly": [
                [
                    83.8281584,
                    53.4524927
                ],
                [
                    83.8308401,
                    53.4533736
                ],
                [
                    83.8551385,
                    53.4561055
                ],
                [
                    83.8612965,
                    53.4559224
                ],
                [
                    83.8650514,
                    53.4556362
                ],
                [
                    83.8724781,
                    53.4539154
                ],
                [
                    83.8713055,
                    53.4519808
                ],
                [
                    83.87408,
                    53.4510078
                ],
                [
                    83.8757845,
                    53.4527631
                ],
                [
                    83.8787449,
                    53.4525227
                ],
                [
                    83.8813401,
                    53.4526142
                ],
                [
                    83.8836982,
                    53.4538505
                ],
                [
                    83.8839673,
                    53.4542664
                ],
                [
                    83.8847042,
                    53.4544877
                ],
                [
                    83.8845504,
                    53.4547854
                ],
                [
                    83.8859665,
                    53.4553386
                ],
                [
                    83.8843325,
                    53.4553119
                ],
                [
                    83.8840186,
                    53.4558232
                ],
                [
                    83.8854539,
                    53.4561055
                ],
                [
                    83.8853642,
                    53.4564337
                ],
                [
                    83.8859217,
                    53.4565863
                ],
                [
                    83.8875044,
                    53.4564298
                ],
                [
                    83.8880875,
                    53.4565977
                ],
                [
                    83.8891576,
                    53.4568915
                ],
                [
                    83.8900932,
                    53.4562238
                ],
                [
                    83.8936495,
                    53.457872
                ],
                [
                    83.8929831,
                    53.4583413
                ],
                [
                    83.8943736,
                    53.458822
                ],
                [
                    83.8944184,
                    53.4593753
                ],
                [
                    83.8942518,
                    53.4601306
                ],
                [
                    83.8932586,
                    53.461195
                ],
                [
                    83.8924961,
                    53.4627401
                ],
                [
                    83.891567,
                    53.463545
                ],
                [
                    83.889965,
                    53.4635526
                ],
                [
                    83.8892601,
                    53.4646551
                ],
                [
                    83.8904071,
                    53.464987
                ],
                [
                    83.8902726,
                    53.4651129
                ],
                [
                    83.8892794,
                    53.4650099
                ],
                [
                    83.8882926,
                    53.465418
                ],
                [
                    83.8871712,
                    53.4660551
                ],
                [
                    83.8855052,
                    53.466551
                ],
                [
                    83.8851335,
                    53.4673635
                ],
                [
                    83.8844863,
                    53.4680348
                ],
                [
                    83.8819552,
                    53.468626
                ],
                [
                    83.8796612,
                    53.4690151
                ],
                [
                    83.8790141,
                    53.4697894
                ],
                [
                    83.877976,
                    53.4694957
                ],
                [
                    83.8778542,
                    53.4699686
                ],
                [
                    83.8772519,
                    53.47072
                ],
                [
                    83.8773544,
                    53.4708879
                ],
                [
                    83.884403,
                    53.4693317
                ],
                [
                    83.886665,
                    53.4700907
                ],
                [
                    83.8868252,
                    53.4716659
                ],
                [
                    83.8873122,
                    53.4716812
                ],
                [
                    83.8879914,
                    53.4713494
                ],
                [
                    83.8888372,
                    53.4715324
                ],
                [
                    83.8892025,
                    53.4736339
                ],
                [
                    83.889478,
                    53.474145
                ],
                [
                    83.8900675,
                    53.4741755
                ],
                [
                    83.8913491,
                    53.4749955
                ],
                [
                    83.8915798,
                    53.4754531
                ],
                [
                    83.8910607,
                    53.4760366
                ],
                [
                    83.8905673,
                    53.4763417
                ],
                [
                    83.8922526,
                    53.4768146
                ],
                [
                    83.8937008,
                    53.4753158
                ],
                [
                    83.8943672,
                    53.4754989
                ],
                [
                    83.8963792,
                    53.4735157
                ],
                [
                    83.8976608,
                    53.4724364
                ],
                [
                    83.8983592,
                    53.4722495
                ],
                [
                    83.8989936,
                    53.4718376
                ],
                [
                    83.8988526,
                    53.4715706
                ],
                [
                    83.9006981,
                    53.4705408
                ],
                [
                    83.903761,
                    53.4698695
                ],
                [
                    83.9056834,
                    53.4691142
                ],
                [
                    83.9063562,
                    53.4691982
                ],
                [
                    83.9067599,
                    53.4691486
                ],
                [
                    83.9084017,
                    53.4699874
                ],
                [
                    83.9086395,
                    53.4697565
                ],
                [
                    83.9083016,
                    53.4694361
                ],
                [
                    83.9080137,
                    53.4679089
                ],
                [
                    83.9132451,
                    53.4647575
                ],
                [
                    83.9170497,
                    53.4675737
                ],
                [
                    83.91908,
                    53.4652083
                ],
                [
                    83.9217619,
                    53.4620834
                ],
                [
                    83.924413,
                    53.4599385
                ],
                [
                    83.9245332,
                    53.4597895
                ],
                [
                    83.924353,
                    53.4595213
                ],
                [
                    83.9295108,
                    53.457309
                ],
                [
                    83.9300394,
                    53.4577859
                ],
                [
                    83.93056,
                    53.4575856
                ],
                [
                    83.929991,
                    53.4569364
                ],
                [
                    83.9245287,
                    53.4507036
                ],
                [
                    83.9237978,
                    53.4495887
                ],
                [
                    83.9232271,
                    53.4482888
                ],
                [
                    83.9230369,
                    53.4474123
                ],
                [
                    83.9229868,
                    53.4461541
                ],
                [
                    83.924006,
                    53.4399108
                ],
                [
                    83.9248262,
                    53.4398917
                ],
                [
                    83.9263385,
                    53.4400558
                ],
                [
                    83.9274598,
                    53.4399413
                ],
                [
                    83.942388,
                    53.4428514
                ],
                [
                    83.942156,
                    53.4431165
                ],
                [
                    83.9409172,
                    53.4444324
                ],
                [
                    83.9399439,
                    53.4455389
                ],
                [
                    83.9350405,
                    53.4444529
                ],
                [
                    83.9324293,
                    53.4440522
                ],
                [
                    83.9314762,
                    53.4453498
                ],
                [
                    83.9302747,
                    53.44545
                ],
                [
                    83.9290572,
                    53.4458936
                ],
                [
                    83.929674,
                    53.4465711
                ],
                [
                    83.9303468,
                    53.4465186
                ],
                [
                    83.9312278,
                    53.4464995
                ],
                [
                    83.9326259,
                    53.4465585
                ],
                [
                    83.9350307,
                    53.446832
                ],
                [
                    83.9365759,
                    53.4471017
                ],
                [
                    83.9378948,
                    53.4473537
                ],
                [
                    83.9377898,
                    53.4477406
                ],
                [
                    83.9385871,
                    53.4479164
                ],
                [
                    83.9381485,
                    53.4488141
                ],
                [
                    83.9399483,
                    53.4491126
                ],
                [
                    83.941083,
                    53.4487689
                ],
                [
                    83.9415494,
                    53.4484245
                ],
                [
                    83.9420719,
                    53.4483483
                ],
                [
                    83.9424075,
                    53.4486689
                ],
                [
                    83.9417047,
                    53.4500566
                ],
                [
                    83.9415517,
                    53.4507984
                ],
                [
                    83.9422335,
                    53.4513378
                ],
                [
                    83.9440502,
                    53.4515497
                ],
                [
                    83.9454263,
                    53.4508212
                ],
                [
                    83.9460705,
                    53.4504233
                ],
                [
                    83.9469056,
                    53.4504802
                ],
                [
                    83.9473828,
                    53.4509349
                ],
                [
                    83.9466193,
                    53.4512048
                ],
                [
                    83.9456649,
                    53.4514606
                ],
                [
                    83.9462614,
                    53.4519437
                ],
                [
                    83.9474544,
                    53.4521852
                ],
                [
                    83.9489575,
                    53.4524836
                ],
                [
                    83.9496017,
                    53.4530093
                ],
                [
                    83.9491961,
                    53.4536486
                ],
                [
                    83.9484803,
                    53.4540606
                ],
                [
                    83.9470011,
                    53.4537623
                ],
                [
                    83.9462376,
                    53.4534213
                ],
                [
                    83.9455218,
                    53.4527961
                ],
                [
                    83.9448537,
                    53.4524694
                ],
                [
                    83.94378,
                    53.4524978
                ],
                [
                    83.9432313,
                    53.4529382
                ],
                [
                    83.9432313,
                    53.4534497
                ],
                [
                    83.9435892,
                    53.4536628
                ],
                [
                    83.9444004,
                    53.4541317
                ],
                [
                    83.9456649,
                    53.4541601
                ],
                [
                    83.9461898,
                    53.4543448
                ],
                [
                    83.9460467,
                    53.4547142
                ],
                [
                    83.9440902,
                    53.455524
                ],
                [
                    83.9439709,
                    53.4560638
                ],
                [
                    83.9444958,
                    53.4572714
                ],
                [
                    83.9454502,
                    53.4571861
                ],
                [
                    83.9463569,
                    53.4571861
                ],
                [
                    83.9470965,
                    53.4577118
                ],
                [
                    83.9474067,
                    53.4585073
                ],
                [
                    83.9469056,
                    53.4588625
                ],
                [
                    83.9460944,
                    53.4589335
                ],
                [
                    83.945307,
                    53.4583653
                ],
                [
                    83.9443527,
                    53.4584505
                ],
                [
                    83.9438516,
                    53.4590187
                ],
                [
                    83.9441379,
                    53.4595728
                ],
                [
                    83.9452116,
                    53.4599137
                ],
                [
                    83.9449014,
                    53.4606382
                ],
                [
                    83.9438755,
                    53.4610501
                ],
                [
                    83.9438516,
                    53.4615047
                ],
                [
                    83.9447106,
                    53.4616183
                ],
                [
                    83.9453786,
                    53.4619308
                ],
                [
                    83.9454025,
                    53.4626979
                ],
                [
                    83.945494,
                    53.4628093
                ],
                [
                    83.9475041,
                    53.4620108
                ],
                [
                    83.9481769,
                    53.4625258
                ],
                [
                    83.952334,
                    53.460709
                ],
                [
                    83.9709086,
                    53.4526203
                ],
                [
                    83.9703079,
                    53.4520956
                ],
                [
                    83.9706683,
                    53.4519096
                ],
                [
                    83.9716295,
                    53.4523341
                ],
                [
                    83.9726307,
                    53.4529446
                ],
                [
                    83.9756264,
                    53.453889
                ],
                [
                    83.9772523,
                    53.4541466
                ],
                [
                    83.9834199,
                    53.4541513
                ],
                [
                    83.9962755,
                    53.4565504
                ],
                [
                    84.0028691,
                    53.4580489
                ],
                [
                    84.0059914,
                    53.4587585
                ],
                [
                    84.0076174,
                    53.459016
                ],
                [
                    84.0079458,
                    53.4579382
                ],
                [
                    84.008162,
                    53.4575805
                ],
                [
                    84.030486,
                    53.462281
                ],
                [
                    84.0314224,
                    53.4624781
                ],
                [
                    84.0333928,
                    53.4618058
                ],
                [
                    84.0323916,
                    53.4598839
                ],
                [
                    84.0317107,
                    53.4590065
                ],
                [
                    84.0275777,
                    53.4574088
                ],
                [
                    84.0226277,
                    53.4561354
                ],
                [
                    84.021298,
                    53.45604
                ],
                [
                    84.0209776,
                    53.4547046
                ],
                [
                    84.022075,
                    53.4523484
                ],
                [
                    84.0216825,
                    53.4519191
                ],
                [
                    84.020409,
                    53.4515519
                ],
                [
                    84.0145378,
                    53.4505931
                ],
                [
                    84.0145797,
                    53.4502301
                ],
                [
                    84.014698,
                    53.449205
                ],
                [
                    84.0142014,
                    53.4484847
                ],
                [
                    84.0111497,
                    53.4465814
                ],
                [
                    84.0094163,
                    53.4479508
                ],
                [
                    84.0088095,
                    53.4484302
                ],
                [
                    84.0033722,
                    53.4527252
                ],
                [
                    83.9961073,
                    53.4511894
                ],
                [
                    83.9910932,
                    53.4495437
                ],
                [
                    83.9870723,
                    53.4475116
                ],
                [
                    83.9812572,
                    53.4462904
                ],
                [
                    83.9789905,
                    53.4471061
                ],
                [
                    83.9773645,
                    53.4468819
                ],
                [
                    83.9730588,
                    53.4466835
                ],
                [
                    83.9787746,
                    53.4419777
                ],
                [
                    83.9752439,
                    53.4412945
                ],
                [
                    83.9742699,
                    53.4409777
                ],
                [
                    83.9510031,
                    53.4361988
                ],
                [
                    83.9636117,
                    53.4287576
                ],
                [
                    83.9704761,
                    53.4246436
                ],
                [
                    83.9726067,
                    53.4234313
                ],
                [
                    83.9748414,
                    53.4219516
                ],
                [
                    83.9762271,
                    53.4208824
                ],
                [
                    83.9774766,
                    53.4197082
                ],
                [
                    83.9781094,
                    53.4190256
                ],
                [
                    83.9787261,
                    53.4182857
                ],
                [
                    83.9797674,
                    53.4168441
                ],
                [
                    83.9827711,
                    53.4126764
                ],
                [
                    83.9863354,
                    53.4080117
                ],
                [
                    83.9775167,
                    53.4070807
                ],
                [
                    83.971543,
                    53.4046922
                ],
                [
                    83.9721277,
                    53.4012082
                ],
                [
                    83.9816817,
                    53.4021747
                ],
                [
                    83.9889802,
                    53.4034354
                ],
                [
                    83.9892878,
                    53.4026026
                ],
                [
                    83.9894672,
                    53.4016055
                ],
                [
                    83.989621,
                    53.4006657
                ],
                [
                    83.9896531,
                    53.3994546
                ],
                [
                    83.9901275,
                    53.385083
                ],
                [
                    83.9897841,
                    53.3837683
                ],
                [
                    83.9905419,
                    53.3837251
                ],
                [
                    83.9905919,
                    53.3831697
                ],
                [
                    83.9919135,
                    53.3814199
                ],
                [
                    83.9925143,
                    53.3810377
                ],
                [
                    83.9941663,
                    53.3803986
                ],
                [
                    83.9958584,
                    53.3799029
                ],
                [
                    83.9966093,
                    53.3797596
                ],
                [
                    83.9964691,
                    53.379443
                ],
                [
                    83.9990122,
                    53.3789832
                ],
                [
                    83.9988871,
                    53.3786711
                ],
                [
                    84.0158527,
                    53.3755817
                ],
                [
                    84.0155152,
                    53.374884
                ],
                [
                    83.995791,
                    53.3786394
                ],
                [
                    83.9961196,
                    53.3792366
                ],
                [
                    83.9913325,
                    53.3800018
                ],
                [
                    83.9906443,
                    53.3744186
                ],
                [
                    83.9816221,
                    53.375266
                ],
                [
                    83.9806058,
                    53.3742443
                ],
                [
                    83.9785874,
                    53.372704
                ],
                [
                    83.9753394,
                    53.3716892
                ],
                [
                    83.9735669,
                    53.3714386
                ],
                [
                    83.9690894,
                    53.371622
                ],
                [
                    83.9690485,
                    53.3716953
                ],
                [
                    83.9680034,
                    53.3718482
                ],
                [
                    83.9674501,
                    53.3720254
                ],
                [
                    83.9666304,
                    53.3718848
                ],
                [
                    83.9564562,
                    53.3726123
                ],
                [
                    83.9558517,
                    53.3712919
                ],
                [
                    83.9548374,
                    53.3703627
                ],
                [
                    83.9509542,
                    53.3691767
                ],
                [
                    83.9465075,
                    53.3675322
                ],
                [
                    83.9448989,
                    53.3673977
                ],
                [
                    83.9435054,
                    53.3676667
                ],
                [
                    83.9361899,
                    53.3706806
                ],
                [
                    83.9275342,
                    53.3714083
                ],
                [
                    83.9248443,
                    53.3705498
                ],
                [
                    83.9221227,
                    53.3702453
                ],
                [
                    83.9200814,
                    53.369298
                ],
                [
                    83.9153185,
                    53.3714632
                ],
                [
                    83.9130505,
                    53.3727825
                ],
                [
                    83.9104422,
                    53.3732223
                ],
                [
                    83.9084577,
                    53.3724442
                ],
                [
                    83.9068133,
                    53.3720383
                ],
                [
                    83.9035813,
                    53.3724442
                ],
                [
                    83.9015968,
                    53.3732561
                ],
                [
                    83.9002927,
                    53.3716598
                ],
                [
                    83.9022205,
                    53.3707126
                ],
                [
                    83.9059628,
                    53.370036
                ],
                [
                    83.9062463,
                    53.3689195
                ],
                [
                    83.9076638,
                    53.369833
                ],
                [
                    83.9078906,
                    53.3691225
                ],
                [
                    83.9088546,
                    53.3694608
                ],
                [
                    83.9080252,
                    53.368046
                ],
                [
                    83.9076318,
                    53.3672341
                ],
                [
                    83.9076318,
                    53.3668575
                ],
                [
                    83.9081646,
                    53.3666374
                ],
                [
                    83.9086236,
                    53.3667156
                ],
                [
                    83.9091974,
                    53.3670531
                ],
                [
                    83.9093531,
                    53.3674591
                ],
                [
                    83.90964,
                    53.3678063
                ],
                [
                    83.9100088,
                    53.3678503
                ],
                [
                    83.9102138,
                    53.3675373
                ],
                [
                    83.9099843,
                    53.3672341
                ],
                [
                    83.9099351,
                    53.3668624
                ],
                [
                    83.9104269,
                    53.366745
                ],
                [
                    83.9111564,
                    53.366745
                ],
                [
                    83.9114023,
                    53.3666325
                ],
                [
                    83.9112302,
                    53.366251
                ],
                [
                    83.910681,
                    53.3658695
                ],
                [
                    83.9098285,
                    53.3656592
                ],
                [
                    83.9086646,
                    53.3657423
                ],
                [
                    83.9078941,
                    53.3659184
                ],
                [
                    83.9070006,
                    53.3663684
                ],
                [
                    83.9060007,
                    53.3667694
                ],
                [
                    83.9055334,
                    53.3669406
                ],
                [
                    83.9047875,
                    53.3668477
                ],
                [
                    83.9038449,
                    53.3665591
                ],
                [
                    83.903181,
                    53.366295
                ],
                [
                    83.9024925,
                    53.3659429
                ],
                [
                    83.9021646,
                    53.3656299
                ],
                [
                    83.902099,
                    53.3652483
                ],
                [
                    83.8972712,
                    53.3650038
                ],
                [
                    83.8937794,
                    53.3648522
                ],
                [
                    83.8911318,
                    53.3646419
                ],
                [
                    83.8887302,
                    53.3639326
                ],
                [
                    83.8863285,
                    53.3635707
                ],
                [
                    83.8838285,
                    53.3630669
                ],
                [
                    83.8810089,
                    53.362431
                ],
                [
                    83.8794515,
                    53.3618978
                ],
                [
                    83.8747056,
                    53.3599852
                ],
                [
                    83.8711728,
                    53.3587525
                ],
                [
                    83.8700499,
                    53.3588014
                ],
                [
                    83.8688449,
                    53.3582095
                ],
                [
                    83.8675171,
                    53.3595009
                ],
                [
                    83.8608368,
                    53.362837
                ],
                [
                    83.8585909,
                    53.3645587
                ],
                [
                    83.8599433,
                    53.3648962
                ],
                [
                    83.8603532,
                    53.3642946
                ],
                [
                    83.8614925,
                    53.3647348
                ],
                [
                    83.8590232,
                    53.3664388
                ],
                [
                    83.859336,
                    53.3685017
                ],
                [
                    83.8592422,
                    53.3752592
                ],
                [
                    83.8590007,
                    53.3784703
                ],
                [
                    83.8582211,
                    53.3797809
                ],
                [
                    83.8590716,
                    53.3812184
                ],
                [
                    83.8600639,
                    53.3828671
                ],
                [
                    83.8628281,
                    53.3835013
                ],
                [
                    83.8656631,
                    53.3850231
                ],
                [
                    83.8681438,
                    53.3865872
                ],
                [
                    83.869207,
                    53.3886162
                ],
                [
                    83.8682582,
                    53.3920596
                ],
                [
                    83.8691789,
                    53.3930834
                ],
                [
                    83.8698824,
                    53.4007085
                ],
                [
                    83.8696779,
                    53.4016573
                ],
                [
                    83.8661851,
                    53.4051387
                ],
                [
                    83.8654763,
                    53.4074626
                ],
                [
                    83.8667166,
                    53.4096279
                ],
                [
                    83.8671596,
                    53.4127437
                ],
                [
                    83.8668543,
                    53.4150205
                ],
                [
                    83.8670158,
                    53.4150398
                ],
                [
                    83.8672761,
                    53.4149502
                ],
                [
                    83.8680971,
                    53.4145504
                ],
                [
                    83.8692385,
                    53.4147593
                ],
                [
                    83.8707904,
                    53.4150636
                ],
                [
                    83.8724724,
                    53.4150457
                ],
                [
                    83.8740544,
                    53.4151591
                ],
                [
                    83.8774886,
                    53.4165913
                ],
                [
                    83.8794109,
                    53.4178145
                ],
                [
                    83.8824346,
                    53.4196881
                ],
                [
                    83.8841166,
                    53.4205951
                ],
                [
                    83.8851479,
                    53.4208934
                ],
                [
                    83.8854583,
                    53.4210426
                ],
                [
                    83.8857787,
                    53.4214244
                ],
                [
                    83.8857186,
                    53.421675
                ],
                [
                    83.8851179,
                    53.4217347
                ],
                [
                    83.8816536,
                    53.4211201
                ],
                [
                    83.8824947,
                    53.4223492
                ],
                [
                    83.8806324,
                    53.42328
                ],
                [
                    83.883576,
                    53.4257261
                ],
                [
                    83.8856886,
                    53.4283927
                ],
                [
                    83.8826849,
                    53.4339224
                ],
                [
                    83.8790004,
                    53.4385031
                ],
                [
                    83.8691584,
                    53.445892
                ],
                [
                    83.8658944,
                    53.4462379
                ],
                [
                    83.8630109,
                    53.4457668
                ],
                [
                    83.86224,
                    53.4465778
                ],
                [
                    83.8495445,
                    53.4489629
                ],
                [
                    83.8411543,
                    53.4474007
                ],
                [
                    83.8355574,
                    53.4508411
                ],
                [
                    83.8303511,
                    53.4523198
                ],
                [
                    83.8281584,
                    53.4524927
                ]
            ],
            "longitude": 83.939407,
            "latitude": 53.393341
        },
        "6031": {
            "name": "ПЕТРОПАВЛОВСКОЕ",
            "population": 2568,
            "type": "town",
            "poly": null,
            "longitude": 84.108116,
            "latitude": 52.069763
        },
        "6032": {
            "name": "БЫСТРЫЙ ИСТОК",
            "population": 3460,
            "type": "town",
            "poly": null,
            "longitude": 84.386986,
            "latitude": 52.372765
        },
        "6033": {
            "name": "ТРОИЦКОЕ",
            "population": 9634,
            "type": "town",
            "poly": null,
            "longitude": 84.677628,
            "latitude": 52.981388
        },
        "6034": {
            "name": "ЗАЛЕСОВО",
            "population": 7370,
            "type": "town",
            "poly": null,
            "longitude": 84.736046,
            "latitude": 53.995155
        },
        "6035": {
            "name": "ЗАРИНСК",
            "population": 47035,
            "type": "town",
            "poly": [
                [
                    84.885138,
                    53.7142574
                ],
                [
                    84.9039646,
                    53.7281447
                ],
                [
                    84.9712073,
                    53.7351779
                ],
                [
                    84.9742597,
                    53.725953
                ],
                [
                    84.9933262,
                    53.7195984
                ],
                [
                    84.9697244,
                    53.693413
                ],
                [
                    84.9336895,
                    53.6837897
                ],
                [
                    84.9227463,
                    53.6874614
                ],
                [
                    84.9161838,
                    53.6939865
                ],
                [
                    84.9147744,
                    53.6951854
                ],
                [
                    84.9112071,
                    53.6982197
                ],
                [
                    84.885138,
                    53.7142574
                ]
            ],
            "longitude": 84.926712,
            "latitude": 53.703606
        },
        "6036": {
            "name": "БЕЛОКУРИХА",
            "population": 15072,
            "type": "town",
            "poly": [
                [
                    84.9292092,
                    51.9956551
                ],
                [
                    84.9417716,
                    52.0044581
                ],
                [
                    84.9561723,
                    52.0068158
                ],
                [
                    84.9608704,
                    52.0050869
                ],
                [
                    84.9887526,
                    52.0104935
                ],
                [
                    85.0032044,
                    52.019388
                ],
                [
                    85.0046658,
                    52.0191828
                ],
                [
                    85.017503,
                    52.0174081
                ],
                [
                    85.0225075,
                    52.0144538
                ],
                [
                    85.0158689,
                    52.0083875
                ],
                [
                    85.0285334,
                    51.9993651
                ],
                [
                    85.0192393,
                    51.9921334
                ],
                [
                    85.0218437,
                    51.9884227
                ],
                [
                    85.0182179,
                    51.983202
                ],
                [
                    85.0067791,
                    51.9862527
                ],
                [
                    85.0033296,
                    51.977985
                ],
                [
                    85.0021244,
                    51.975233
                ],
                [
                    84.9999557,
                    51.9702798
                ],
                [
                    84.9978241,
                    51.9654112
                ],
                [
                    84.9709815,
                    51.9694242
                ],
                [
                    84.9402517,
                    51.97657
                ],
                [
                    84.9292092,
                    51.9956551
                ]
            ],
            "longitude": 84.99321,
            "latitude": 51.999195
        },
        "6037": {
            "name": "СМОЛЕНСКОЕ",
            "population": 8985,
            "type": "town",
            "poly": null,
            "longitude": 85.079384,
            "latitude": 52.305302
        },
        "6038": {
            "name": "АЛТАЙСКОЕ",
            "population": 14235,
            "type": "town",
            "poly": [
                [
                    85.2967784,
                    51.8837437
                ],
                [
                    85.3111207,
                    51.9132808
                ],
                [
                    85.3261404,
                    51.9413883
                ],
                [
                    85.3270749,
                    51.9431363
                ],
                [
                    85.3164748,
                    51.9472684
                ],
                [
                    85.3293848,
                    51.960231
                ],
                [
                    85.3255725,
                    51.964275
                ],
                [
                    85.3267742,
                    51.9698474
                ],
                [
                    85.3349788,
                    51.9716384
                ],
                [
                    85.3434582,
                    52.0002153
                ],
                [
                    85.3652984,
                    51.9981033
                ],
                [
                    85.3579802,
                    51.9847952
                ],
                [
                    85.356265,
                    51.9559124
                ],
                [
                    85.3579972,
                    51.9531599
                ],
                [
                    85.353755,
                    51.9415737
                ],
                [
                    85.3495898,
                    51.9415783
                ],
                [
                    85.3456308,
                    51.9330747
                ],
                [
                    85.3257345,
                    51.920241
                ],
                [
                    85.3111636,
                    51.8803794
                ],
                [
                    85.2967784,
                    51.8837437
                ]
            ],
            "longitude": 85.336746,
            "latitude": 51.945145
        },
        "6039": {
            "name": "СОВЕТСКОЕ",
            "population": 4824,
            "type": "town",
            "poly": null,
            "longitude": 85.409721,
            "latitude": 52.282604
        },
        "6040": {
            "name": "ЦЕЛИННОЕ",
            "population": 4836,
            "type": "town",
            "poly": null,
            "longitude": 85.661758,
            "latitude": 53.078262
        },
        "6041": {
            "name": "КРАСНОГОРСКОЕ",
            "population": 5850,
            "type": "town",
            "poly": [
                [
                    86.1671509,
                    52.2896434
                ],
                [
                    86.1701909,
                    52.2990489
                ],
                [
                    86.1728732,
                    52.3084526
                ],
                [
                    86.1931692,
                    52.3092179
                ],
                [
                    86.2078325,
                    52.3110765
                ],
                [
                    86.2220485,
                    52.3168158
                ],
                [
                    86.2275921,
                    52.3150667
                ],
                [
                    86.2214228,
                    52.300744
                ],
                [
                    86.2164157,
                    52.2936356
                ],
                [
                    86.2048819,
                    52.2891513
                ],
                [
                    86.2070278,
                    52.2825879
                ],
                [
                    86.1965668,
                    52.2840648
                ],
                [
                    86.1813671,
                    52.2829709
                ],
                [
                    86.1671509,
                    52.2896434
                ]
            ],
            "longitude": 86.195274,
            "latitude": 52.296341
        },
        "6042": {
            "name": "ЕЛЬЦОВКА",
            "population": 2896,
            "type": "town",
            "poly": [
                [
                    86.2410896,
                    53.2684738
                ],
                [
                    86.2523346,
                    53.2707655
                ],
                [
                    86.2643961,
                    53.2714418
                ],
                [
                    86.2752641,
                    53.2624996
                ],
                [
                    86.2754526,
                    53.2568252
                ],
                [
                    86.27495,
                    53.2531421
                ],
                [
                    86.2763949,
                    53.2501352
                ],
                [
                    86.2755782,
                    53.2443464
                ],
                [
                    86.2667833,
                    53.2431058
                ],
                [
                    86.2627,
                    53.2461508
                ],
                [
                    86.2491307,
                    53.2525031
                ],
                [
                    86.2484011,
                    53.258345
                ],
                [
                    86.248314,
                    53.2590424
                ],
                [
                    86.2513294,
                    53.261748
                ],
                [
                    86.2468692,
                    53.2649044
                ],
                [
                    86.2410896,
                    53.2684738
                ]
            ],
            "longitude": 86.26545,
            "latitude": 53.256676
        },
        "6043": {
            "name": "КЫРЕН",
            "population": 5275,
            "type": "town",
            "poly": [
                [
                    102.0792913,
                    51.6797903
                ],
                [
                    102.0935721,
                    51.6846854
                ],
                [
                    102.1082013,
                    51.68159
                ],
                [
                    102.1183024,
                    51.6839656
                ],
                [
                    102.1259653,
                    51.694762
                ],
                [
                    102.1403622,
                    51.6963452
                ],
                [
                    102.1515082,
                    51.6930347
                ],
                [
                    102.1605644,
                    51.6894361
                ],
                [
                    102.1671822,
                    51.686269
                ],
                [
                    102.1661374,
                    51.681662
                ],
                [
                    102.1655413,
                    51.6807749
                ],
                [
                    102.1643958,
                    51.6790703
                ],
                [
                    102.146748,
                    51.6791423
                ],
                [
                    102.1437293,
                    51.6743906
                ],
                [
                    102.1352536,
                    51.6747506
                ],
                [
                    102.1202762,
                    51.6693503
                ],
                [
                    102.1131938,
                    51.6662539
                ],
                [
                    102.1018156,
                    51.6695664
                ],
                [
                    102.0974036,
                    51.6748946
                ],
                [
                    102.0818456,
                    51.6738866
                ],
                [
                    102.0792913,
                    51.6797903
                ]
            ],
            "longitude": 102.132912,
            "latitude": 51.682404
        },
        "6044": {
            "name": "ЗАКАМЕНСК",
            "population": 11234,
            "type": "town",
            "poly": [
                [
                    103.2719751,
                    50.3617492
                ],
                [
                    103.2791848,
                    50.3787202
                ],
                [
                    103.2951665,
                    50.3939614
                ],
                [
                    103.3018441,
                    50.3922925
                ],
                [
                    103.2925916,
                    50.3698851
                ],
                [
                    103.2831502,
                    50.3592633
                ],
                [
                    103.2719751,
                    50.3617492
                ]
            ],
            "longitude": 103.291527,
            "latitude": 50.377804
        },
        "6045": {
            "name": "ПЕТРОПАВЛОВКА",
            "population": 7346,
            "type": "town",
            "poly": [
                [
                    105.2577787,
                    50.6036196
                ],
                [
                    105.2965656,
                    50.6096115
                ],
                [
                    105.2977673,
                    50.6165829
                ],
                [
                    105.3224865,
                    50.6172364
                ],
                [
                    105.3478666,
                    50.6168825
                ],
                [
                    105.3466908,
                    50.6080864
                ],
                [
                    105.3250614,
                    50.606888
                ],
                [
                    105.305492,
                    50.605036
                ],
                [
                    105.2855879,
                    50.6042733
                ],
                [
                    105.2622419,
                    50.5950118
                ],
                [
                    105.2577787,
                    50.6036196
                ]
            ],
            "longitude": 105.319412,
            "latitude": 50.61087
        },
        "6046": {
            "name": "БАБУШКИН",
            "population": 4623,
            "type": "town",
            "poly": [
                [
                    105.8402307,
                    51.7082836
                ],
                [
                    105.8448656,
                    51.712751
                ],
                [
                    105.8476899,
                    51.7161673
                ],
                [
                    105.8500047,
                    51.718091
                ],
                [
                    105.853763,
                    51.7192494
                ],
                [
                    105.8589976,
                    51.7210544
                ],
                [
                    105.8665099,
                    51.7200551
                ],
                [
                    105.8697093,
                    51.7174489
                ],
                [
                    105.8740528,
                    51.7168842
                ],
                [
                    105.892346,
                    51.7174489
                ],
                [
                    105.8927591,
                    51.7167926
                ],
                [
                    105.8925365,
                    51.7149801
                ],
                [
                    105.8913493,
                    51.7137201
                ],
                [
                    105.8836589,
                    51.712611
                ],
                [
                    105.8803995,
                    51.710411
                ],
                [
                    105.8769662,
                    51.7076453
                ],
                [
                    105.875593,
                    51.7060497
                ],
                [
                    105.8733614,
                    51.7048795
                ],
                [
                    105.8709903,
                    51.7044106
                ],
                [
                    105.8659799,
                    51.7056242
                ],
                [
                    105.8600399,
                    51.7081479
                ],
                [
                    105.8563508,
                    51.7081326
                ],
                [
                    105.8583984,
                    51.7065645
                ],
                [
                    105.8569747,
                    51.7056105
                ],
                [
                    105.8510454,
                    51.7064752
                ],
                [
                    105.8498437,
                    51.7058369
                ],
                [
                    105.8462389,
                    51.7046668
                ],
                [
                    105.8440073,
                    51.7057306
                ],
                [
                    105.8429773,
                    51.7067943
                ],
                [
                    105.8402307,
                    51.7082836
                ]
            ],
            "longitude": 105.8635328,
            "latitude": 51.7161749
        },
        "6047": {
            "name": "НАУШКИ",
            "population": 2973,
            "type": "town",
            "poly": [
                [
                    106.0866032,
                    50.386659
                ],
                [
                    106.0956545,
                    50.397119
                ],
                [
                    106.0967732,
                    50.4098563
                ],
                [
                    106.1052142,
                    50.4094673
                ],
                [
                    106.1303848,
                    50.409273
                ],
                [
                    106.1333849,
                    50.4069721
                ],
                [
                    106.1365376,
                    50.393143
                ],
                [
                    106.1365376,
                    50.3772558
                ],
                [
                    106.1205708,
                    50.3683047
                ],
                [
                    106.1025701,
                    50.3744668
                ],
                [
                    106.0916881,
                    50.3797202
                ],
                [
                    106.0866032,
                    50.386659
                ]
            ],
            "longitude": 106.10303316334138,
            "latitude": 50.38860642093917
        },
        "6048": {
            "name": "КЯХТА",
            "population": 19980,
            "type": "town",
            "poly": [
                [
                    106.3846461,
                    50.4102356
                ],
                [
                    106.4043614,
                    50.4054273
                ],
                [
                    106.4150387,
                    50.4086001
                ],
                [
                    106.4230725,
                    50.4069207
                ],
                [
                    106.4232441,
                    50.4026373
                ],
                [
                    106.4165408,
                    50.394715
                ],
                [
                    106.422094,
                    50.3866163
                ],
                [
                    106.4415644,
                    50.3763336
                ],
                [
                    106.443796,
                    50.3826826
                ],
                [
                    106.4508341,
                    50.3831206
                ],
                [
                    106.4496325,
                    50.3934087
                ],
                [
                    106.4498042,
                    50.3951597
                ],
                [
                    106.4530657,
                    50.3955974
                ],
                [
                    106.4595889,
                    50.378523
                ],
                [
                    106.4595889,
                    50.3752388
                ],
                [
                    106.4611338,
                    50.3738156
                ],
                [
                    106.4628503,
                    50.3625376
                ],
                [
                    106.4580439,
                    50.3578286
                ],
                [
                    106.4597605,
                    50.3521333
                ],
                [
                    106.4606188,
                    50.3500521
                ],
                [
                    106.4673136,
                    50.340412
                ],
                [
                    106.4625071,
                    50.3382207
                ],
                [
                    106.465082,
                    50.3335093
                ],
                [
                    106.4688586,
                    50.3294548
                ],
                [
                    106.4729785,
                    50.3279206
                ],
                [
                    106.4798449,
                    50.3273727
                ],
                [
                    106.4851839,
                    50.3235479
                ],
                [
                    106.4827442,
                    50.3232223
                ],
                [
                    106.4817584,
                    50.321874
                ],
                [
                    106.4772183,
                    50.3207028
                ],
                [
                    106.475725,
                    50.3207969
                ],
                [
                    106.4726351,
                    50.3213449
                ],
                [
                    106.4667986,
                    50.3251809
                ],
                [
                    106.4623354,
                    50.3279206
                ],
                [
                    106.4575289,
                    50.3284686
                ],
                [
                    106.4534091,
                    50.3293452
                ],
                [
                    106.4431094,
                    50.3370155
                ],
                [
                    106.4389895,
                    50.3394259
                ],
                [
                    106.4427661,
                    50.3419458
                ],
                [
                    106.442251,
                    50.3429317
                ],
                [
                    106.4367579,
                    50.3428222
                ],
                [
                    106.4297198,
                    50.3421649
                ],
                [
                    106.4304064,
                    50.3441368
                ],
                [
                    106.4343546,
                    50.3458896
                ],
                [
                    106.4329814,
                    50.3462182
                ],
                [
                    106.4300631,
                    50.3474232
                ],
                [
                    106.4297198,
                    50.3478614
                ],
                [
                    106.4305781,
                    50.3486281
                ],
                [
                    106.4317797,
                    50.3495044
                ],
                [
                    106.4309214,
                    50.3520236
                ],
                [
                    106.4293765,
                    50.3531191
                ],
                [
                    106.4280032,
                    50.3535572
                ],
                [
                    106.4209651,
                    50.3566239
                ],
                [
                    106.4245699,
                    50.3577191
                ],
                [
                    106.4264582,
                    50.3578286
                ],
                [
                    106.4276599,
                    50.3594713
                ],
                [
                    106.4288615,
                    50.361114
                ],
                [
                    106.4298914,
                    50.3623186
                ],
                [
                    106.4298914,
                    50.3658227
                ],
                [
                    106.4245699,
                    50.3664797
                ],
                [
                    106.4185618,
                    50.3696551
                ],
                [
                    106.4127253,
                    50.3740345
                ],
                [
                    106.409391,
                    50.3811762
                ],
                [
                    106.3861567,
                    50.4056407
                ],
                [
                    106.3846461,
                    50.4102356
                ]
            ],
            "longitude": 106.44915,
            "latitude": 50.353176
        },
        "6049": {
            "name": "ГУСИНООЗЁРСК",
            "population": 23359,
            "type": "town",
            "poly": [
                [
                    106.4240342,
                    51.3065923
                ],
                [
                    106.4250127,
                    51.3116572
                ],
                [
                    106.4259826,
                    51.3171133
                ],
                [
                    106.4256994,
                    51.3277445
                ],
                [
                    106.4406939,
                    51.3318472
                ],
                [
                    106.4498779,
                    51.3393652
                ],
                [
                    106.4649755,
                    51.3471929
                ],
                [
                    106.4750263,
                    51.3525482
                ],
                [
                    106.5258957,
                    51.3135008
                ],
                [
                    106.5365387,
                    51.3091014
                ],
                [
                    106.5331193,
                    51.3058792
                ],
                [
                    106.5326043,
                    51.3041621
                ],
                [
                    106.537912,
                    51.3009453
                ],
                [
                    106.5437763,
                    51.2989407
                ],
                [
                    106.5614128,
                    51.2971396
                ],
                [
                    106.5602784,
                    51.2952445
                ],
                [
                    106.559713,
                    51.2930023
                ],
                [
                    106.559713,
                    51.2881715
                ],
                [
                    106.5567947,
                    51.2819443
                ],
                [
                    106.5516449,
                    51.2728167
                ],
                [
                    106.5466667,
                    51.2708836
                ],
                [
                    106.5413562,
                    51.2692262
                ],
                [
                    106.5367471,
                    51.267395
                ],
                [
                    106.5367643,
                    51.2653757
                ],
                [
                    106.5357944,
                    51.2634208
                ],
                [
                    106.5246278,
                    51.2585922
                ],
                [
                    106.5153066,
                    51.2632328
                ],
                [
                    106.5017286,
                    51.2702595
                ],
                [
                    106.4986009,
                    51.2668107
                ],
                [
                    106.5013026,
                    51.2641617
                ],
                [
                    106.5013026,
                    51.2605095
                ],
                [
                    106.4942645,
                    51.2634098
                ],
                [
                    106.4901901,
                    51.2655134
                ],
                [
                    106.4859641,
                    51.2694108
                ],
                [
                    106.4882987,
                    51.2726596
                ],
                [
                    106.4956802,
                    51.2767887
                ],
                [
                    106.499139,
                    51.2813953
                ],
                [
                    106.4977058,
                    51.2869997
                ],
                [
                    106.4863074,
                    51.2913853
                ],
                [
                    106.4768888,
                    51.2938201
                ],
                [
                    106.4686147,
                    51.2969222
                ],
                [
                    106.4637996,
                    51.2969544
                ],
                [
                    106.4240342,
                    51.3065923
                ]
            ],
            "longitude": 106.527008,
            "latitude": 51.289516
        },
        "6050": {
            "name": "КАМЕНСК",
            "population": 6855,
            "type": "town",
            "poly": null,
            "longitude": 106.583969,
            "latitude": 51.983513
        },
        "6051": {
            "name": "КАБАНСК",
            "population": 6373,
            "type": "town",
            "poly": [
                [
                    106.6307836,
                    52.0654295
                ],
                [
                    106.6359334,
                    52.0679621
                ],
                [
                    106.6438299,
                    52.0659571
                ],
                [
                    106.6510396,
                    52.063741
                ],
                [
                    106.6572194,
                    52.0619468
                ],
                [
                    106.6621976,
                    52.0585694
                ],
                [
                    106.6659741,
                    52.0547696
                ],
                [
                    106.6683774,
                    52.0514972
                ],
                [
                    106.6714673,
                    52.0495971
                ],
                [
                    106.6724973,
                    52.0481191
                ],
                [
                    106.6761022,
                    52.0457964
                ],
                [
                    106.6769605,
                    52.0414676
                ],
                [
                    106.6767888,
                    52.0381942
                ],
                [
                    106.6676908,
                    52.0371383
                ],
                [
                    106.6455465,
                    52.0430514
                ],
                [
                    106.6367917,
                    52.0455853
                ],
                [
                    106.639195,
                    52.0547696
                ],
                [
                    106.6345601,
                    52.0590971
                ],
                [
                    106.6307836,
                    52.0654295
                ]
            ],
            "longitude": 106.65432,
            "latitude": 52.055408
        },
        "6052": {
            "name": "СЕЛЕНГИНСК",
            "population": 13793,
            "type": "town",
            "poly": [
                [
                    106.8339926,
                    52.0038934
                ],
                [
                    106.8361781,
                    52.0074216
                ],
                [
                    106.8406981,
                    52.0161073
                ],
                [
                    106.8497039,
                    52.0168224
                ],
                [
                    106.8493391,
                    52.0211926
                ],
                [
                    106.8633058,
                    52.0280837
                ],
                [
                    106.8744638,
                    52.0329419
                ],
                [
                    106.8839051,
                    52.0313578
                ],
                [
                    106.8797853,
                    52.028823
                ],
                [
                    106.8804719,
                    52.0256544
                ],
                [
                    106.8736099,
                    52.0147781
                ],
                [
                    106.8709728,
                    52.0118211
                ],
                [
                    106.8742921,
                    52.0107588
                ],
                [
                    106.8803326,
                    52.0132712
                ],
                [
                    106.8837937,
                    52.0125857
                ],
                [
                    106.888025,
                    52.0130833
                ],
                [
                    106.8902674,
                    52.0115543
                ],
                [
                    106.8920657,
                    52.0082009
                ],
                [
                    106.8820169,
                    52.0052642
                ],
                [
                    106.8772706,
                    52.0007059
                ],
                [
                    106.8863365,
                    52.0001537
                ],
                [
                    106.8875595,
                    51.9963436
                ],
                [
                    106.8949195,
                    51.9916188
                ],
                [
                    106.89366,
                    51.9906424
                ],
                [
                    106.8884865,
                    51.9929652
                ],
                [
                    106.8782233,
                    51.992697
                ],
                [
                    106.8811383,
                    51.9901323
                ],
                [
                    106.874745,
                    51.986645
                ],
                [
                    106.8689858,
                    51.9927968
                ],
                [
                    106.8672735,
                    51.9950198
                ],
                [
                    106.8639068,
                    51.9956018
                ],
                [
                    106.8619325,
                    51.9951184
                ],
                [
                    106.8564393,
                    51.993533
                ],
                [
                    106.8545426,
                    51.990723
                ],
                [
                    106.8521737,
                    51.9892648
                ],
                [
                    106.8499711,
                    51.9904461
                ],
                [
                    106.8467149,
                    51.9950475
                ],
                [
                    106.8496149,
                    51.9960899
                ],
                [
                    106.8543323,
                    51.9964572
                ],
                [
                    106.8541253,
                    51.9994601
                ],
                [
                    106.8509442,
                    52.0035963
                ],
                [
                    106.849101,
                    52.0061668
                ],
                [
                    106.8339926,
                    52.0038934
                ]
            ],
            "longitude": 106.867599,
            "latitude": 52.007378
        },
        "6053": {
            "name": "ИВОЛГИНСК",
            "population": 8251,
            "type": "town",
            "poly": [
                [
                    107.2394985,
                    51.7593867
                ],
                [
                    107.2459025,
                    51.7658165
                ],
                [
                    107.2985571,
                    51.7694272
                ],
                [
                    107.3167728,
                    51.7604437
                ],
                [
                    107.3043918,
                    51.7318078
                ],
                [
                    107.2743644,
                    51.7261665
                ],
                [
                    107.2473256,
                    51.7442072
                ],
                [
                    107.2399966,
                    51.7553346
                ],
                [
                    107.2394985,
                    51.7593867
                ]
            ],
            "longitude": 107.281174,
            "latitude": 51.745052
        },
        "6054": {
            "name": "ТАРБАГАТАЙ",
            "population": 5300,
            "type": "town",
            "poly": [
                [
                    107.3304356,
                    51.4829555
                ],
                [
                    107.334208,
                    51.4944574
                ],
                [
                    107.3626963,
                    51.4926756
                ],
                [
                    107.3859812,
                    51.4869248
                ],
                [
                    107.3928756,
                    51.4772035
                ],
                [
                    107.3483871,
                    51.475178
                ],
                [
                    107.3304356,
                    51.4829555
                ]
            ],
            "longitude": 107.357605,
            "latitude": 51.48373
        },
        "6055": {
            "name": "БИЧУРА",
            "population": 9700,
            "type": "town",
            "poly": [
                [
                    107.5653266,
                    50.6016094
                ],
                [
                    107.5679546,
                    50.6139094
                ],
                [
                    107.6323403,
                    50.6337076
                ],
                [
                    107.6950836,
                    50.634541
                ],
                [
                    107.7118371,
                    50.5988988
                ],
                [
                    107.6816152,
                    50.5223123
                ],
                [
                    107.6431808,
                    50.5035118
                ],
                [
                    107.579452,
                    50.5312921
                ],
                [
                    107.5653266,
                    50.6016094
                ]
            ],
            "longitude": 107.599274,
            "latitude": 50.588627
        },
        "6056": {
            "name": "ТУРУНТАЕВО",
            "population": 7800,
            "type": "town",
            "poly": [
                [
                    107.6177418,
                    52.200837
                ],
                [
                    107.6212037,
                    52.2009202
                ],
                [
                    107.6224256,
                    52.2033748
                ],
                [
                    107.6301639,
                    52.2020851
                ],
                [
                    107.632404,
                    52.208325
                ],
                [
                    107.6396672,
                    52.2068275
                ],
                [
                    107.6400066,
                    52.205122
                ],
                [
                    107.6444867,
                    52.205122
                ],
                [
                    107.6485595,
                    52.2069523
                ],
                [
                    107.6510032,
                    52.2068691
                ],
                [
                    107.651682,
                    52.205538
                ],
                [
                    107.6535827,
                    52.205538
                ],
                [
                    107.654533,
                    52.2094065
                ],
                [
                    107.6562979,
                    52.2104464
                ],
                [
                    107.65847,
                    52.2104048
                ],
                [
                    107.6588094,
                    52.2056628
                ],
                [
                    107.6567051,
                    52.2024595
                ],
                [
                    107.6542615,
                    52.2017939
                ],
                [
                    107.653379,
                    52.1995889
                ],
                [
                    107.6463195,
                    52.197259
                ],
                [
                    107.6469304,
                    52.1933894
                ],
                [
                    107.6529038,
                    52.1930149
                ],
                [
                    107.6610082,
                    52.1879157
                ],
                [
                    107.657915,
                    52.1874044
                ],
                [
                    107.6506166,
                    52.1893006
                ],
                [
                    107.6491569,
                    52.1909413
                ],
                [
                    107.638939,
                    52.19092
                ],
                [
                    107.6387999,
                    52.1901103
                ],
                [
                    107.6351855,
                    52.1901316
                ],
                [
                    107.6341428,
                    52.1888533
                ],
                [
                    107.6359501,
                    52.1865308
                ],
                [
                    107.6340331,
                    52.1850249
                ],
                [
                    107.6258875,
                    52.1881045
                ],
                [
                    107.625005,
                    52.1892281
                ],
                [
                    107.6230365,
                    52.1875635
                ],
                [
                    107.6206607,
                    52.1875219
                ],
                [
                    107.6188958,
                    52.1907262
                ],
                [
                    107.6177418,
                    52.200837
                ]
            ],
            "longitude": 107.635689,
            "latitude": 52.201256
        },
        "6057": {
            "name": "МУХОРШИБИРЬ",
            "population": 5162,
            "type": "town",
            "poly": [
                [
                    107.7331179,
                    51.0401053
                ],
                [
                    107.7367164,
                    51.042797
                ],
                [
                    107.7616577,
                    51.0385449
                ],
                [
                    107.7835589,
                    51.0454494
                ],
                [
                    107.7949748,
                    51.0417048
                ],
                [
                    107.8116644,
                    51.0470878
                ],
                [
                    107.8070112,
                    51.0551223
                ],
                [
                    107.8237628,
                    51.0605817
                ],
                [
                    107.8547223,
                    51.058476
                ],
                [
                    107.8583208,
                    51.0499741
                ],
                [
                    107.8502552,
                    51.0459176
                ],
                [
                    107.8375984,
                    51.0340581
                ],
                [
                    107.8191716,
                    51.0371014
                ],
                [
                    107.8006207,
                    51.0332389
                ],
                [
                    107.7856063,
                    51.0267225
                ],
                [
                    107.8004967,
                    51.0123601
                ],
                [
                    107.7972084,
                    51.0081051
                ],
                [
                    107.7597344,
                    51.0198151
                ],
                [
                    107.7498075,
                    51.0331609
                ],
                [
                    107.7331179,
                    51.0401053
                ]
            ],
            "longitude": 107.828537,
            "latitude": 51.046997
        },
        "6058": {
            "name": "ОНОХОЙ",
            "population": 10759,
            "type": "town",
            "poly": null,
            "longitude": 108.051399,
            "latitude": 51.923122
        },
        "6059": {
            "name": "ТУРКА",
            "population": 1460,
            "type": "town",
            "poly": [
                [
                    108.2129182,
                    52.9506619
                ],
                [
                    108.2211722,
                    52.9560905
                ],
                [
                    108.226279,
                    52.9591581
                ],
                [
                    108.2276401,
                    52.9571246
                ],
                [
                    108.2270078,
                    52.9442601
                ],
                [
                    108.2174263,
                    52.9440256
                ],
                [
                    108.2137785,
                    52.9486561
                ],
                [
                    108.2129182,
                    52.9506619
                ]
            ],
            "longitude": 108.222,
            "latitude": 52.950695
        },
        "6060": {
            "name": "ЗАИГРАЕВО",
            "population": 5360,
            "type": "town",
            "poly": [
                [
                    108.2405151,
                    51.8260942
                ],
                [
                    108.2473319,
                    51.8293164
                ],
                [
                    108.2497575,
                    51.8333135
                ],
                [
                    108.2563959,
                    51.8416487
                ],
                [
                    108.2624811,
                    51.8451453
                ],
                [
                    108.2666939,
                    51.8498508
                ],
                [
                    108.2741408,
                    51.850692
                ],
                [
                    108.2808217,
                    51.8347073
                ],
                [
                    108.2829494,
                    51.8230306
                ],
                [
                    108.2795026,
                    51.8236093
                ],
                [
                    108.2737578,
                    51.8278174
                ],
                [
                    108.2606087,
                    51.8234778
                ],
                [
                    108.2609491,
                    51.8201636
                ],
                [
                    108.2512894,
                    51.8168492
                ],
                [
                    108.2405151,
                    51.8260942
                ]
            ],
            "longitude": 108.270615,
            "latitude": 51.834293
        },
        "6061": {
            "name": "УСТЬ-БАРГУЗИН",
            "population": 7104,
            "type": "town",
            "poly": [
                [
                    109.0031544,
                    53.4169105
                ],
                [
                    109.0091393,
                    53.4221421
                ],
                [
                    109.0281249,
                    53.4230915
                ],
                [
                    109.0465795,
                    53.4233288
                ],
                [
                    109.0558067,
                    53.4226959
                ],
                [
                    109.0589267,
                    53.4121721
                ],
                [
                    109.0511599,
                    53.4005771
                ],
                [
                    109.0522884,
                    53.3952732
                ],
                [
                    109.0493012,
                    53.3923439
                ],
                [
                    109.0331701,
                    53.3981627
                ],
                [
                    109.0207564,
                    53.4010916
                ],
                [
                    109.0151802,
                    53.4010916
                ],
                [
                    109.0119938,
                    53.4092044
                ],
                [
                    109.0061521,
                    53.4136361
                ],
                [
                    109.0031544,
                    53.4169105
                ]
            ],
            "longitude": 109.032768,
            "latitude": 53.40831
        },
        "6062": {
            "name": "СЕВЕРОБАЙКАЛЬСК",
            "population": 23944,
            "type": "town",
            "poly": [
                [
                    109.2504305,
                    55.6058474
                ],
                [
                    109.2532248,
                    55.6059097
                ],
                [
                    109.2515495,
                    55.6109795
                ],
                [
                    109.250931,
                    55.6128509
                ],
                [
                    109.2544753,
                    55.6157205
                ],
                [
                    109.2538502,
                    55.6172196
                ],
                [
                    109.2542767,
                    55.618374
                ],
                [
                    109.2534313,
                    55.6202751
                ],
                [
                    109.2546824,
                    55.6238671
                ],
                [
                    109.2641139,
                    55.6240084
                ],
                [
                    109.2686877,
                    55.6274849
                ],
                [
                    109.2706003,
                    55.6289504
                ],
                [
                    109.2704853,
                    55.6296039
                ],
                [
                    109.2689897,
                    55.6314832
                ],
                [
                    109.2694714,
                    55.6327009
                ],
                [
                    109.2683406,
                    55.640725
                ],
                [
                    109.2668543,
                    55.6470468
                ],
                [
                    109.2651455,
                    55.6509906
                ],
                [
                    109.2665717,
                    55.6524572
                ],
                [
                    109.2679591,
                    55.6560744
                ],
                [
                    109.2836455,
                    55.6564288
                ],
                [
                    109.2821824,
                    55.6490743
                ],
                [
                    109.301469,
                    55.6491118
                ],
                [
                    109.3005379,
                    55.6577419
                ],
                [
                    109.3178958,
                    55.6582672
                ],
                [
                    109.3182284,
                    55.6672329
                ],
                [
                    109.3468922,
                    55.6670453
                ],
                [
                    109.3414388,
                    55.6604807
                ],
                [
                    109.3421038,
                    55.656879
                ],
                [
                    109.349752,
                    55.6518512
                ],
                [
                    109.3615234,
                    55.6521513
                ],
                [
                    109.3646024,
                    55.652201
                ],
                [
                    109.3646378,
                    55.6518676
                ],
                [
                    109.3659325,
                    55.6520042
                ],
                [
                    109.3665349,
                    55.6528809
                ],
                [
                    109.3668047,
                    55.6528359
                ],
                [
                    109.3667282,
                    55.652692
                ],
                [
                    109.3666383,
                    55.6527055
                ],
                [
                    109.3660903,
                    55.651908
                ],
                [
                    109.3645928,
                    55.6517524
                ],
                [
                    109.3644579,
                    55.6513433
                ],
                [
                    109.3649444,
                    55.650298
                ],
                [
                    109.3651963,
                    55.6500098
                ],
                [
                    109.3654518,
                    55.6498591
                ],
                [
                    109.366215,
                    55.6501795
                ],
                [
                    109.3666113,
                    55.6498822
                ],
                [
                    109.3665278,
                    55.6498425
                ],
                [
                    109.3661932,
                    55.650089
                ],
                [
                    109.3656403,
                    55.6498733
                ],
                [
                    109.3656279,
                    55.6497329
                ],
                [
                    109.3656942,
                    55.649581
                ],
                [
                    109.3659415,
                    55.6492618
                ],
                [
                    109.3663101,
                    55.6489067
                ],
                [
                    109.3669755,
                    55.6489426
                ],
                [
                    109.3671508,
                    55.6488168
                ],
                [
                    109.3682972,
                    55.6489606
                ],
                [
                    109.369084,
                    55.6480885
                ],
                [
                    109.3686483,
                    55.6472977
                ],
                [
                    109.3691087,
                    55.6471934
                ],
                [
                    109.3699157,
                    55.6486609
                ],
                [
                    109.3697057,
                    55.6501318
                ],
                [
                    109.369886,
                    55.6501378
                ],
                [
                    109.3701339,
                    55.648679
                ],
                [
                    109.3691206,
                    55.646811
                ],
                [
                    109.3681094,
                    55.646716
                ],
                [
                    109.3678836,
                    55.646533
                ],
                [
                    109.367443,
                    55.6464026
                ],
                [
                    109.3672947,
                    55.6462183
                ],
                [
                    109.3673262,
                    55.6458766
                ],
                [
                    109.3672407,
                    55.645481
                ],
                [
                    109.3676319,
                    55.644456
                ],
                [
                    109.3680859,
                    55.6438445
                ],
                [
                    109.3681534,
                    55.6435928
                ],
                [
                    109.3680278,
                    55.6434441
                ],
                [
                    109.3670025,
                    55.6429634
                ],
                [
                    109.36493,
                    55.6416821
                ],
                [
                    109.3604308,
                    55.6389894
                ],
                [
                    109.3599467,
                    55.637835
                ],
                [
                    109.3589157,
                    55.6372367
                ],
                [
                    109.3552714,
                    55.6347715
                ],
                [
                    109.3504208,
                    55.6310132
                ],
                [
                    109.3499752,
                    55.6288048
                ],
                [
                    109.350984,
                    55.6242941
                ],
                [
                    109.3519867,
                    55.6218716
                ],
                [
                    109.3515246,
                    55.6213722
                ],
                [
                    109.3517551,
                    55.6206807
                ],
                [
                    109.3525783,
                    55.6205271
                ],
                [
                    109.3532081,
                    55.619176
                ],
                [
                    109.3530479,
                    55.6189433
                ],
                [
                    109.351685,
                    55.6201797
                ],
                [
                    109.3513643,
                    55.6201185
                ],
                [
                    109.3519919,
                    55.619323
                ],
                [
                    109.351258,
                    55.6188559
                ],
                [
                    109.350197,
                    55.6196253
                ],
                [
                    109.3495286,
                    55.6206268
                ],
                [
                    109.3485587,
                    55.6221389
                ],
                [
                    109.3468946,
                    55.6223188
                ],
                [
                    109.3451147,
                    55.6218311
                ],
                [
                    109.3433316,
                    55.6199689
                ],
                [
                    109.341601,
                    55.6196811
                ],
                [
                    109.3437468,
                    55.6197889
                ],
                [
                    109.3449538,
                    55.6211908
                ],
                [
                    109.3462466,
                    55.6218202
                ],
                [
                    109.3471982,
                    55.6218445
                ],
                [
                    109.3482894,
                    55.6216615
                ],
                [
                    109.3489836,
                    55.6195784
                ],
                [
                    109.3499341,
                    55.6190734
                ],
                [
                    109.3497431,
                    55.6172995
                ],
                [
                    109.3470749,
                    55.616496
                ],
                [
                    109.3491681,
                    55.6144414
                ],
                [
                    109.3527375,
                    55.6128145
                ],
                [
                    109.3517044,
                    55.6123279
                ],
                [
                    109.3519893,
                    55.6118163
                ],
                [
                    109.3517151,
                    55.6114505
                ],
                [
                    109.3507366,
                    55.6115577
                ],
                [
                    109.3502806,
                    55.6120558
                ],
                [
                    109.3488151,
                    55.6115826
                ],
                [
                    109.3481477,
                    55.6106603
                ],
                [
                    109.3481942,
                    55.6081503
                ],
                [
                    109.3453959,
                    55.6054938
                ],
                [
                    109.3474579,
                    55.6037976
                ],
                [
                    109.3467197,
                    55.6022739
                ],
                [
                    109.3483866,
                    55.6006088
                ],
                [
                    109.3452632,
                    55.5989726
                ],
                [
                    109.3407905,
                    55.5989844
                ],
                [
                    109.3370652,
                    55.598424
                ],
                [
                    109.3292626,
                    55.5955142
                ],
                [
                    109.3209525,
                    55.5936213
                ],
                [
                    109.3152804,
                    55.593116
                ],
                [
                    109.3147981,
                    55.5926873
                ],
                [
                    109.313753,
                    55.5926605
                ],
                [
                    109.3135922,
                    55.5932768
                ],
                [
                    109.3125204,
                    55.5936787
                ],
                [
                    109.3072514,
                    55.593453
                ],
                [
                    109.3080219,
                    55.5945699
                ],
                [
                    109.3067324,
                    55.5950989
                ],
                [
                    109.3017483,
                    55.5949381
                ],
                [
                    109.2972733,
                    55.5944558
                ],
                [
                    109.2945351,
                    55.594035
                ],
                [
                    109.2918068,
                    55.59325
                ],
                [
                    109.2904152,
                    55.5929603
                ],
                [
                    109.2897981,
                    55.5924571
                ],
                [
                    109.2911717,
                    55.5915516
                ],
                [
                    109.2909201,
                    55.5913579
                ],
                [
                    109.2899432,
                    55.5920054
                ],
                [
                    109.2892078,
                    55.5918847
                ],
                [
                    109.2851325,
                    55.5896209
                ],
                [
                    109.282299,
                    55.5886101
                ],
                [
                    109.2773302,
                    55.5877524
                ],
                [
                    109.2755358,
                    55.5921704
                ],
                [
                    109.26766,
                    55.5954079
                ],
                [
                    109.2513522,
                    55.5973356
                ],
                [
                    109.2508381,
                    55.5972856
                ],
                [
                    109.2505937,
                    55.6016829
                ],
                [
                    109.2504305,
                    55.6058474
                ]
            ],
            "longitude": 109.335648,
            "latitude": 55.635967
        },
        "6063": {
            "name": "НИЖНЕАНГАРСК",
            "population": 4710,
            "type": "town",
            "poly": [
                [
                    109.5529725,
                    55.7853942
                ],
                [
                    109.5994208,
                    55.8164221
                ],
                [
                    109.6125528,
                    55.8095899
                ],
                [
                    109.6082971,
                    55.7993393
                ],
                [
                    109.579358,
                    55.7779411
                ],
                [
                    109.5529725,
                    55.7853942
                ]
            ],
            "longitude": 109.571762,
            "latitude": 55.783573
        },
        "6064": {
            "name": "БАРГУЗИН",
            "population": 6000,
            "type": "town",
            "poly": [
                [
                    109.5921616,
                    53.5832294
                ],
                [
                    109.6090205,
                    53.629909
                ],
                [
                    109.6933145,
                    53.6259516
                ],
                [
                    109.7365152,
                    53.5880247
                ],
                [
                    109.7235199,
                    53.5629994
                ],
                [
                    109.5921616,
                    53.5832294
                ]
            ],
            "longitude": 109.632744,
            "latitude": 53.617638
        },
        "6065": {
            "name": "ХОРИНСК",
            "population": 8241,
            "type": "town",
            "poly": [
                [
                    [
                        109.7410097,
                        52.1511921
                    ],
                    [
                        109.7420762,
                        52.1518133
                    ],
                    [
                        109.7435598,
                        52.1530224
                    ],
                    [
                        109.7432027,
                        52.1536655
                    ],
                    [
                        109.7429665,
                        52.1541404
                    ],
                    [
                        109.7434471,
                        52.1547916
                    ],
                    [
                        109.7439912,
                        52.1555178
                    ],
                    [
                        109.7436564,
                        52.156191
                    ],
                    [
                        109.7448023,
                        52.1565959
                    ],
                    [
                        109.7454793,
                        52.1573146
                    ],
                    [
                        109.7475283,
                        52.1576878
                    ],
                    [
                        109.7493995,
                        52.1568414
                    ],
                    [
                        109.7509303,
                        52.1571764
                    ],
                    [
                        109.7515208,
                        52.1575982
                    ],
                    [
                        109.7509753,
                        52.1579366
                    ],
                    [
                        109.7515915,
                        52.158781
                    ],
                    [
                        109.7499615,
                        52.1590976
                    ],
                    [
                        109.7502319,
                        52.1598439
                    ],
                    [
                        109.7509303,
                        52.1605763
                    ],
                    [
                        109.7507214,
                        52.1615782
                    ],
                    [
                        109.7505637,
                        52.1621436
                    ],
                    [
                        109.7515937,
                        52.1647761
                    ],
                    [
                        109.7531382,
                        52.1656898
                    ],
                    [
                        109.7546836,
                        52.1656184
                    ],
                    [
                        109.7553783,
                        52.1656802
                    ],
                    [
                        109.7571343,
                        52.1658434
                    ],
                    [
                        109.7592464,
                        52.1669144
                    ],
                    [
                        109.7594485,
                        52.1678896
                    ],
                    [
                        109.7615045,
                        52.1688544
                    ],
                    [
                        109.7640621,
                        52.1682099
                    ],
                    [
                        109.7674132,
                        52.1683297
                    ],
                    [
                        109.7697119,
                        52.1695313
                    ],
                    [
                        109.7689315,
                        52.1706722
                    ],
                    [
                        109.7748442,
                        52.1732959
                    ],
                    [
                        109.7776419,
                        52.1732812
                    ],
                    [
                        109.7803549,
                        52.1740477
                    ],
                    [
                        109.7835871,
                        52.1739894
                    ],
                    [
                        109.78858,
                        52.1751186
                    ],
                    [
                        109.7928943,
                        52.1761155
                    ],
                    [
                        109.7929305,
                        52.1760011
                    ],
                    [
                        109.7972556,
                        52.1734095
                    ],
                    [
                        109.8032638,
                        52.174778
                    ],
                    [
                        109.8034354,
                        52.1734095
                    ],
                    [
                        109.8044654,
                        52.1704617
                    ],
                    [
                        109.7988006,
                        52.1637231
                    ],
                    [
                        109.7965044,
                        52.157102
                    ],
                    [
                        109.7917624,
                        52.1503482
                    ],
                    [
                        109.7852393,
                        52.1475042
                    ],
                    [
                        109.7835656,
                        52.1481296
                    ],
                    [
                        109.7815859,
                        52.1493418
                    ],
                    [
                        109.7817906,
                        52.1501775
                    ],
                    [
                        109.7782782,
                        52.1515596
                    ],
                    [
                        109.7760607,
                        52.1517022
                    ],
                    [
                        109.7739976,
                        52.1515735
                    ],
                    [
                        109.7723647,
                        52.1526653
                    ],
                    [
                        109.7682448,
                        52.1537186
                    ],
                    [
                        109.7669306,
                        52.1551365
                    ],
                    [
                        109.7646028,
                        52.1564805
                    ],
                    [
                        109.7630258,
                        52.1570334
                    ],
                    [
                        109.7603673,
                        52.1571716
                    ],
                    [
                        109.7602321,
                        52.1561487
                    ],
                    [
                        109.7607278,
                        52.1561903
                    ],
                    [
                        109.760942,
                        52.1551013
                    ],
                    [
                        109.761446,
                        52.1542107
                    ],
                    [
                        109.7605625,
                        52.1532186
                    ],
                    [
                        109.7590803,
                        52.1528747
                    ],
                    [
                        109.7570722,
                        52.1528993
                    ],
                    [
                        109.7540972,
                        52.1522285
                    ],
                    [
                        109.7504516,
                        52.1522567
                    ],
                    [
                        109.7468467,
                        52.1506918
                    ],
                    [
                        109.741809,
                        52.1500322
                    ],
                    [
                        109.7410097,
                        52.1511921
                    ]
                ],
                [
                    [
                        109.729621,
                        52.14013
                    ],
                    [
                        109.730136,
                        52.1432905
                    ],
                    [
                        109.7327109,
                        52.1433959
                    ],
                    [
                        109.7356292,
                        52.1428691
                    ],
                    [
                        109.7378608,
                        52.1408675
                    ],
                    [
                        109.7380324,
                        52.138339
                    ],
                    [
                        109.741531,
                        52.1376496
                    ],
                    [
                        109.7436973,
                        52.1339137
                    ],
                    [
                        109.7455642,
                        52.1320497
                    ],
                    [
                        109.749905,
                        52.1324021
                    ],
                    [
                        109.750389,
                        52.1308895
                    ],
                    [
                        109.7491686,
                        52.130331
                    ],
                    [
                        109.749157,
                        52.1295119
                    ],
                    [
                        109.7517531,
                        52.1295119
                    ],
                    [
                        109.7514891,
                        52.1260542
                    ],
                    [
                        109.7432441,
                        52.125965
                    ],
                    [
                        109.7412365,
                        52.1279181
                    ],
                    [
                        109.7427326,
                        52.1291067
                    ],
                    [
                        109.7418525,
                        52.134779
                    ],
                    [
                        109.7406073,
                        52.1350727
                    ],
                    [
                        109.7358008,
                        52.1367585
                    ],
                    [
                        109.7323676,
                        52.1385497
                    ],
                    [
                        109.7303077,
                        52.1388656
                    ],
                    [
                        109.729621,
                        52.14013
                    ]
                ]
            ],
            "longitude": 109.77964,
            "latitude": 52.161251
        },
        "6066": {
            "name": "КИЖИНГА",
            "population": 8263,
            "type": "town",
            "poly": [
                [
                    109.8572308,
                    51.8668353
                ],
                [
                    109.9354493,
                    51.8874203
                ],
                [
                    109.9768958,
                    51.8418128
                ],
                [
                    109.9557051,
                    51.82217
                ],
                [
                    109.8952493,
                    51.8154278
                ],
                [
                    109.8572308,
                    51.8668353
                ]
            ],
            "longitude": 109.913147,
            "latitude": 51.84956
        },
        "6067": {
            "name": "КУРУМКАН",
            "population": 5968,
            "type": "town",
            "poly": [
                [
                    110.2841235,
                    54.3218958
                ],
                [
                    110.3088675,
                    54.3431503
                ],
                [
                    110.3194947,
                    54.3382332
                ],
                [
                    110.3386079,
                    54.3337127
                ],
                [
                    110.3321839,
                    54.322451
                ],
                [
                    110.3207637,
                    54.314203
                ],
                [
                    110.313388,
                    54.3180098
                ],
                [
                    110.290944,
                    54.3180891
                ],
                [
                    110.2841235,
                    54.3218958
                ]
            ],
            "longitude": 110.323257,
            "latitude": 54.326336
        },
        "6068": {
            "name": "СОСНОВО-ОЗЁРСКОЕ",
            "population": 7000,
            "type": "town",
            "poly": [
                [
                    111.5013973,
                    52.5167229
                ],
                [
                    111.5018282,
                    52.536519
                ],
                [
                    111.5107709,
                    52.5366501
                ],
                [
                    111.5137877,
                    52.5346184
                ],
                [
                    111.5308111,
                    52.5312759
                ],
                [
                    111.539215,
                    52.5313414
                ],
                [
                    111.5427705,
                    52.5326522
                ],
                [
                    111.5485886,
                    52.5327833
                ],
                [
                    111.5604403,
                    52.5399267
                ],
                [
                    111.5603326,
                    52.5418925
                ],
                [
                    111.5669049,
                    52.5451688
                ],
                [
                    111.5691675,
                    52.5487724
                ],
                [
                    111.5754166,
                    52.5485758
                ],
                [
                    111.5750934,
                    52.5342252
                ],
                [
                    111.5818812,
                    52.5304893
                ],
                [
                    111.5812347,
                    52.5291784
                ],
                [
                    111.5747701,
                    52.525311
                ],
                [
                    111.5750934,
                    52.5215089
                ],
                [
                    111.5450331,
                    52.5039359
                ],
                [
                    111.5305956,
                    52.5040015
                ],
                [
                    111.5304878,
                    52.5074117
                ],
                [
                    111.5162658,
                    52.5149526
                ],
                [
                    111.5162658,
                    52.5167884
                ],
                [
                    111.5013973,
                    52.5167229
                ]
            ],
            "longitude": 111.53992352668712,
            "latitude": 52.52346321236894
        },
        "6069": {
            "name": "НОВЫЙ УОЯН",
            "population": 3513,
            "type": "town",
            "poly": [
                [
                    111.6781837,
                    56.1516106
                ],
                [
                    111.7060007,
                    56.1586791
                ],
                [
                    111.7687629,
                    56.1550966
                ],
                [
                    111.7776296,
                    56.1521916
                ],
                [
                    111.7778034,
                    56.1317538
                ],
                [
                    111.7173014,
                    56.1241958
                ],
                [
                    111.6882673,
                    56.1317538
                ],
                [
                    111.6781837,
                    56.1516106
                ]
            ],
            "longitude": 111.730103,
            "latitude": 56.146828
        },
        "6070": {
            "name": "БАГДАРИН",
            "population": 4800,
            "type": "town",
            "poly": [
                [
                    113.5593327,
                    54.4523614
                ],
                [
                    113.5757363,
                    54.4668432
                ],
                [
                    113.6064468,
                    54.4564484
                ],
                [
                    113.6128603,
                    54.4351487
                ],
                [
                    113.5810398,
                    54.4318488
                ],
                [
                    113.5593327,
                    54.4523614
                ]
            ],
            "longitude": 113.590469,
            "latitude": 54.443378
        },
        "6071": {
            "name": "ТАКСИМО",
            "population": 8174,
            "type": "town",
            "poly": [
                [
                    114.7890356,
                    56.3641445
                ],
                [
                    114.7982214,
                    56.3740693
                ],
                [
                    114.8406872,
                    56.3686485
                ],
                [
                    114.8941459,
                    56.3484597
                ],
                [
                    114.8643295,
                    56.3390291
                ],
                [
                    114.7890356,
                    56.3641445
                ]
            ],
            "longitude": 114.837982,
            "latitude": 56.355515
        },
        "6072": {
            "name": "АЛЕЙСК",
            "population": null,
            "type": "",
            "poly": [
                [
                    82.69908,
                    52.444538
                ],
                [
                    82.7382265,
                    52.4662058
                ],
                [
                    82.7457404,
                    52.4706066
                ],
                [
                    82.7411263,
                    52.4714928
                ],
                [
                    82.7437049,
                    52.4773039
                ],
                [
                    82.7437506,
                    52.4805341
                ],
                [
                    82.7283235,
                    52.4746367
                ],
                [
                    82.722572,
                    52.4780402
                ],
                [
                    82.718604,
                    52.4784385
                ],
                [
                    82.7146955,
                    52.4807556
                ],
                [
                    82.7130162,
                    52.4837605
                ],
                [
                    82.7119313,
                    52.4849461
                ],
                [
                    82.7179934,
                    52.4873541
                ],
                [
                    82.7207612,
                    52.4885298
                ],
                [
                    82.7232817,
                    52.4896881
                ],
                [
                    82.7288887,
                    52.4932485
                ],
                [
                    82.7298323,
                    52.4936932
                ],
                [
                    82.7321227,
                    52.495347
                ],
                [
                    82.7320466,
                    52.5015775
                ],
                [
                    82.7185481,
                    52.5030551
                ],
                [
                    82.7121412,
                    52.5033097
                ],
                [
                    82.7120749,
                    52.5059458
                ],
                [
                    82.7193927,
                    52.5091084
                ],
                [
                    82.7268115,
                    52.5129428
                ],
                [
                    82.7371371,
                    52.5162398
                ],
                [
                    82.7391686,
                    52.5109747
                ],
                [
                    82.7458038,
                    52.5101504
                ],
                [
                    82.7480333,
                    52.5099466
                ],
                [
                    82.7555737,
                    52.5095715
                ],
                [
                    82.7644612,
                    52.5066955
                ],
                [
                    82.7742313,
                    52.5092103
                ],
                [
                    82.776044,
                    52.5104737
                ],
                [
                    82.7748991,
                    52.512037
                ],
                [
                    82.7740713,
                    52.5143062
                ],
                [
                    82.7734497,
                    52.5153589
                ],
                [
                    82.7820297,
                    52.518941
                ],
                [
                    82.7824046,
                    52.5173372
                ],
                [
                    82.785134,
                    52.5188853
                ],
                [
                    82.7873653,
                    52.5193747
                ],
                [
                    82.7874264,
                    52.5212695
                ],
                [
                    82.7889176,
                    52.5233644
                ],
                [
                    82.7890161,
                    52.5242071
                ],
                [
                    82.7890518,
                    52.5280857
                ],
                [
                    82.7883507,
                    52.5309204
                ],
                [
                    82.7940576,
                    52.5328263
                ],
                [
                    82.8000485,
                    52.534419
                ],
                [
                    82.7990389,
                    52.5354245
                ],
                [
                    82.7826183,
                    52.5475296
                ],
                [
                    82.7743144,
                    52.5527672
                ],
                [
                    82.77427,
                    52.553717
                ],
                [
                    82.7785835,
                    52.5556866
                ],
                [
                    82.7840621,
                    52.554571
                ],
                [
                    82.7956574,
                    52.5458973
                ],
                [
                    82.7954,
                    52.5457839
                ],
                [
                    82.8065912,
                    52.5365875
                ],
                [
                    82.8181162,
                    52.5405743
                ],
                [
                    82.8170147,
                    52.5351909
                ],
                [
                    82.8169428,
                    52.5332433
                ],
                [
                    82.8176198,
                    52.5287935
                ],
                [
                    82.8202732,
                    52.5253652
                ],
                [
                    82.8235583,
                    52.5229902
                ],
                [
                    82.8267304,
                    52.5204768
                ],
                [
                    82.8273269,
                    52.5208535
                ],
                [
                    82.829393,
                    52.5193639
                ],
                [
                    82.8312391,
                    52.5176772
                ],
                [
                    82.8295236,
                    52.5173591
                ],
                [
                    82.8327806,
                    52.5136881
                ],
                [
                    82.8254534,
                    52.5130977
                ],
                [
                    82.8234085,
                    52.5124477
                ],
                [
                    82.8187507,
                    52.5100555
                ],
                [
                    82.8193244,
                    52.5088524
                ],
                [
                    82.8229427,
                    52.5091255
                ],
                [
                    82.8240504,
                    52.5087763
                ],
                [
                    82.8240958,
                    52.5078428
                ],
                [
                    82.8239368,
                    52.5070752
                ],
                [
                    82.8247604,
                    52.5062039
                ],
                [
                    82.8260044,
                    52.5057373
                ],
                [
                    82.8263282,
                    52.5050458
                ],
                [
                    82.8247036,
                    52.5038218
                ],
                [
                    82.8236471,
                    52.5036143
                ],
                [
                    82.822494,
                    52.5028986
                ],
                [
                    82.8218748,
                    52.5022036
                ],
                [
                    82.8240674,
                    52.5013875
                ],
                [
                    82.8207274,
                    52.5003951
                ],
                [
                    82.8204604,
                    52.4996032
                ],
                [
                    82.8221873,
                    52.4996378
                ],
                [
                    82.82322,
                    52.5003096
                ],
                [
                    82.8247779,
                    52.5005785
                ],
                [
                    82.8262136,
                    52.5010208
                ],
                [
                    82.8272367,
                    52.5017108
                ],
                [
                    82.828562,
                    52.5014065
                ],
                [
                    82.8300791,
                    52.5009676
                ],
                [
                    82.8315265,
                    52.5007519
                ],
                [
                    82.834919,
                    52.5006713
                ],
                [
                    82.8317614,
                    52.4976127
                ],
                [
                    82.832661,
                    52.496728
                ],
                [
                    82.836709,
                    52.4956748
                ],
                [
                    82.8383698,
                    52.494432
                ],
                [
                    82.8387848,
                    52.4933998
                ],
                [
                    82.8345639,
                    52.4934208
                ],
                [
                    82.8310373,
                    52.4928578
                ],
                [
                    82.8298115,
                    52.4935535
                ],
                [
                    82.8297452,
                    52.4943155
                ],
                [
                    82.8290495,
                    52.4948456
                ],
                [
                    82.8273599,
                    52.4957733
                ],
                [
                    82.826134,
                    52.4964027
                ],
                [
                    82.8236824,
                    52.4963696
                ],
                [
                    82.8221584,
                    52.4952432
                ],
                [
                    82.8224235,
                    52.4940505
                ],
                [
                    82.8235499,
                    52.493156
                ],
                [
                    82.8258359,
                    52.4921952
                ],
                [
                    82.8262666,
                    52.4916982
                ],
                [
                    82.8257365,
                    52.4912676
                ],
                [
                    82.8252395,
                    52.4909031
                ],
                [
                    82.8209326,
                    52.4895117
                ],
                [
                    82.8182159,
                    52.4894454
                ],
                [
                    82.8170895,
                    52.4890147
                ],
                [
                    82.8163938,
                    52.4881863
                ],
                [
                    82.8158968,
                    52.4863643
                ],
                [
                    82.8150354,
                    52.4855692
                ],
                [
                    82.8137765,
                    52.4847409
                ],
                [
                    82.8111923,
                    52.4838795
                ],
                [
                    82.8074818,
                    52.482753
                ],
                [
                    82.804732,
                    52.4816929
                ],
                [
                    82.8031086,
                    52.4808978
                ],
                [
                    82.8019489,
                    52.4807653
                ],
                [
                    82.799895,
                    52.4796057
                ],
                [
                    82.8000937,
                    52.4790094
                ],
                [
                    82.8008557,
                    52.4783799
                ],
                [
                    82.8025785,
                    52.4777836
                ],
                [
                    82.8048644,
                    52.4777836
                ],
                [
                    82.8060902,
                    52.4777504
                ],
                [
                    82.8073824,
                    52.4770546
                ],
                [
                    82.8077468,
                    52.4765246
                ],
                [
                    82.807548,
                    52.4759614
                ],
                [
                    82.8064547,
                    52.4758289
                ],
                [
                    82.805262,
                    52.4758289
                ],
                [
                    82.8022803,
                    52.4760939
                ],
                [
                    82.7990004,
                    52.4759283
                ],
                [
                    82.7965819,
                    52.475862
                ],
                [
                    82.7933683,
                    52.4761602
                ],
                [
                    82.7914136,
                    52.4762927
                ],
                [
                    82.7890945,
                    52.4757626
                ],
                [
                    82.7878024,
                    52.4750669
                ],
                [
                    82.7875043,
                    52.4742386
                ],
                [
                    82.7875705,
                    52.473311
                ],
                [
                    82.7882331,
                    52.4725159
                ],
                [
                    82.7893926,
                    52.4724165
                ],
                [
                    82.7918775,
                    52.4723171
                ],
                [
                    82.7927057,
                    52.4719858
                ],
                [
                    82.7928051,
                    52.471522
                ],
                [
                    82.7926394,
                    52.471025
                ],
                [
                    82.7919437,
                    52.4704618
                ],
                [
                    82.7907893,
                    52.4698728
                ],
                [
                    82.7876694,
                    52.468694
                ],
                [
                    82.7862918,
                    52.4673992
                ],
                [
                    82.7859132,
                    52.4667109
                ],
                [
                    82.7858444,
                    52.4658505
                ],
                [
                    82.7864294,
                    52.4642674
                ],
                [
                    82.7867392,
                    52.4625466
                ],
                [
                    82.7879093,
                    52.4616518
                ],
                [
                    82.7880814,
                    52.4609635
                ],
                [
                    82.7885976,
                    52.4603785
                ],
                [
                    82.7884255,
                    52.4597934
                ],
                [
                    82.787221,
                    52.4590707
                ],
                [
                    82.7858444,
                    52.4591051
                ],
                [
                    82.7847431,
                    52.4590707
                ],
                [
                    82.7828158,
                    52.459518
                ],
                [
                    82.7819554,
                    52.4594492
                ],
                [
                    82.7810262,
                    52.4599655
                ],
                [
                    82.7805788,
                    52.4610668
                ],
                [
                    82.7805788,
                    52.4626155
                ],
                [
                    82.7800281,
                    52.4645772
                ],
                [
                    82.7795463,
                    52.465885
                ],
                [
                    82.7788924,
                    52.4668142
                ],
                [
                    82.7788924,
                    52.4677434
                ],
                [
                    82.7794775,
                    52.4683973
                ],
                [
                    82.7794431,
                    52.4693265
                ],
                [
                    82.7788924,
                    52.4698428
                ],
                [
                    82.7777222,
                    52.4701525
                ],
                [
                    82.7769307,
                    52.4701869
                ],
                [
                    82.775554,
                    52.4694298
                ],
                [
                    82.7744872,
                    52.4682941
                ],
                [
                    82.7742119,
                    52.4671583
                ],
                [
                    82.7744872,
                    52.465885
                ],
                [
                    82.7752098,
                    52.464233
                ],
                [
                    82.776621,
                    52.4628907
                ],
                [
                    82.7771716,
                    52.4620992
                ],
                [
                    82.7774469,
                    52.4609635
                ],
                [
                    82.7775846,
                    52.460172
                ],
                [
                    82.7771372,
                    52.4596557
                ],
                [
                    82.775795,
                    52.4597934
                ],
                [
                    82.7736268,
                    52.4601375
                ],
                [
                    82.7718371,
                    52.4601031
                ],
                [
                    82.7690839,
                    52.459518
                ],
                [
                    82.7673976,
                    52.4590018
                ],
                [
                    82.7676728,
                    52.4580038
                ],
                [
                    82.7687742,
                    52.4579005
                ],
                [
                    82.7702541,
                    52.4576596
                ],
                [
                    82.7707359,
                    52.4571777
                ],
                [
                    82.7707359,
                    52.4563862
                ],
                [
                    82.7706491,
                    52.4524174
                ],
                [
                    82.7758459,
                    52.4516256
                ],
                [
                    82.7769089,
                    52.4499701
                ],
                [
                    82.7710034,
                    52.4488903
                ],
                [
                    82.7689956,
                    52.4474506
                ],
                [
                    82.7650952,
                    52.4465609
                ],
                [
                    82.7643003,
                    52.4455898
                ],
                [
                    82.7634252,
                    52.4459658
                ],
                [
                    82.735013,
                    52.4562606
                ],
                [
                    82.7331464,
                    52.4551811
                ],
                [
                    82.7254779,
                    52.4515222
                ],
                [
                    82.7175835,
                    52.4484862
                ],
                [
                    82.703727,
                    52.4419856
                ],
                [
                    82.69908,
                    52.444538
                ]
            ],
            "longitude": 82.77372868639358,
            "latitude": 52.49349394782733
        },
        "6073": {
            "name": "Владимировка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.207543,
            "latitude": 51.0481225
        },
        "6074": {
            "name": "Санаровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3917584,
            "latitude": 51.0660173
        },
        "6075": {
            "name": "Курдюм",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5709274,
            "latitude": 50.4007987
        },
        "6076": {
            "name": "Каракол",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5811855,
            "latitude": 51.2905332
        },
        "6077": {
            "name": "Улужай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.605212,
            "latitude": 50.5468373
        },
        "6078": {
            "name": "Верх-Мута",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6755847,
            "latitude": 51.1943485
        },
        "6079": {
            "name": "Соузар",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.860115,
            "latitude": 50.4455779
        },
        "6080": {
            "name": "Мариинск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9642861,
            "latitude": 51.4059888
        },
        "6081": {
            "name": "Абай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.055294,
            "latitude": 50.433946
        },
        "6082": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.106805,
            "latitude": 51.0059285
        },
        "6083": {
            "name": "Верхний Ябоган",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2330852,
            "latitude": 50.9270464
        },
        "6084": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2416738,
            "latitude": 51.1441112
        },
        "6085": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.261827,
            "latitude": 51.2095054
        },
        "6086": {
            "name": "Красноярка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2707234,
            "latitude": 50.3103763
        },
        "6087": {
            "name": "Красноярка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2929634,
            "latitude": 50.3169886
        },
        "6088": {
            "name": "Кукуя",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.30198,
            "latitude": 51.4593876
        },
        "6089": {
            "name": "Могута",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4206984,
            "latitude": 51.540112
        },
        "6090": {
            "name": "Синий Яр",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4435145,
            "latitude": 50.3001317
        },
        "6091": {
            "name": "Мараловодка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4618614,
            "latitude": 50.1172602
        },
        "6092": {
            "name": "Власьево",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.514689,
            "latitude": 50.2847213
        },
        "6093": {
            "name": "Сахсабай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.516238,
            "latitude": 50.1969672
        },
        "6094": {
            "name": "Барлак",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    85.5504714,
                    51.4924575
                ],
                [
                    85.5515648,
                    51.4941054
                ],
                [
                    85.5552071,
                    51.495755
                ],
                [
                    85.5561121,
                    51.4957641
                ],
                [
                    85.5567456,
                    51.4954831
                ],
                [
                    85.5572272,
                    51.4961835
                ],
                [
                    85.5579604,
                    51.4962557
                ],
                [
                    85.5581514,
                    51.4947429
                ],
                [
                    85.5577089,
                    51.4937542
                ],
                [
                    85.5569115,
                    51.4928003
                ],
                [
                    85.5564155,
                    51.492904
                ],
                [
                    85.5568083,
                    51.4941342
                ],
                [
                    85.5558605,
                    51.494046
                ],
                [
                    85.5548538,
                    51.4939757
                ],
                [
                    85.5548972,
                    51.4935868
                ],
                [
                    85.5541422,
                    51.4933166
                ],
                [
                    85.5536909,
                    51.4939865
                ],
                [
                    85.5521202,
                    51.4936732
                ],
                [
                    85.5512003,
                    51.4923494
                ],
                [
                    85.5504714,
                    51.4924575
                ]
            ],
            "longitude": 85.5565031,
            "latitude": 51.4945224
        },
        "6095": {
            "name": "Топучая",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    85.5846834,
                    51.1284684
                ],
                [
                    85.5869022,
                    51.1297261
                ],
                [
                    85.5894256,
                    51.1296561
                ],
                [
                    85.5919147,
                    51.1262625
                ],
                [
                    85.5901079,
                    51.1250236
                ],
                [
                    85.5862456,
                    51.1249157
                ],
                [
                    85.5846834,
                    51.1284684
                ]
            ],
            "longitude": 85.587173,
            "latitude": 51.126633
        },
        "6096": {
            "name": "Арбайта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6109495,
            "latitude": 51.328116
        },
        "6097": {
            "name": "Киска",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.487228,
            "latitude": 52.05994
        },
        "6098": {
            "name": "Кумалыр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6207145,
            "latitude": 51.2062536
        },
        "6099": {
            "name": "Гагарка",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6830486,
            "latitude": 50.2288086
        },
        "6100": {
            "name": "Известковый",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    85.7257146,
                    51.7573425
                ],
                [
                    85.7262724,
                    51.7585379
                ],
                [
                    85.7275599,
                    51.7596801
                ],
                [
                    85.7304781,
                    51.7589895
                ],
                [
                    85.7316798,
                    51.7585645
                ],
                [
                    85.7306069,
                    51.7568378
                ],
                [
                    85.7288045,
                    51.7550314
                ],
                [
                    85.728032,
                    51.7539156
                ],
                [
                    85.7263154,
                    51.7541813
                ],
                [
                    85.7269591,
                    51.7561737
                ],
                [
                    85.7262296,
                    51.7567315
                ],
                [
                    85.7257146,
                    51.7573425
                ]
            ],
            "longitude": 85.728821,
            "latitude": 51.75573
        },
        "6101": {
            "name": "Кастахта",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.736462,
            "latitude": 50.3237086
        },
        "6102": {
            "name": "Камай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7536533,
            "latitude": 51.5069767
        },
        "6103": {
            "name": "Курунда",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7652532,
            "latitude": 50.3241124
        },
        "6104": {
            "name": "Турбаза «Юность»",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8001061,
            "latitude": 51.8760603
        },
        "6105": {
            "name": "Верх-Анос",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    85.8153357,
                    51.445738
                ],
                [
                    85.8159728,
                    51.4471145
                ],
                [
                    85.8215083,
                    51.4494181
                ],
                [
                    85.8212091,
                    51.4500363
                ],
                [
                    85.8239667,
                    51.4512438
                ],
                [
                    85.8255867,
                    51.4502719
                ],
                [
                    85.824743,
                    51.4486177
                ],
                [
                    85.8160404,
                    51.4446649
                ],
                [
                    85.8153357,
                    51.445738
                ]
            ],
            "longitude": 85.8199308,
            "latitude": 51.4475827
        },
        "6106": {
            "name": "Карым",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.830376,
            "latitude": 51.743603
        },
        "6107": {
            "name": "Нефтебаза",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8325074,
            "latitude": 50.85278
        },
        "6108": {
            "name": "Маральник 1",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8934441,
            "latitude": 50.1019742
        },
        "6109": {
            "name": "Турбаза \"Катунь\"",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    85.9051801,
                    51.5442918
                ],
                [
                    85.9059228,
                    51.5445621
                ],
                [
                    85.9080673,
                    51.5460003
                ],
                [
                    85.9102398,
                    51.5479091
                ],
                [
                    85.9116274,
                    51.546715
                ],
                [
                    85.9082215,
                    51.5436642
                ],
                [
                    85.9057407,
                    51.5432894
                ],
                [
                    85.9051801,
                    51.5442918
                ]
            ],
            "longitude": 85.909028,
            "latitude": 51.54534
        },
        "6110": {
            "name": "Нижний Уймон",
            "population": 165,
            "type": "hamlet",
            "poly": [
                [
                    85.9208107,
                    50.203762
                ],
                [
                    85.9247589,
                    50.2072779
                ],
                [
                    85.9307671,
                    50.2068384
                ],
                [
                    85.9367752,
                    50.2032127
                ],
                [
                    85.9366035,
                    50.2005756
                ],
                [
                    85.9278488,
                    50.2007953
                ],
                [
                    85.9208107,
                    50.203762
                ]
            ],
            "longitude": 85.9298658,
            "latitude": 50.2023886
        },
        "6111": {
            "name": "Полеводка",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9942581,
            "latitude": 50.2282213
        },
        "6112": {
            "name": "Маргала",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0014486,
            "latitude": 50.2570346
        },
        "6113": {
            "name": "Ак-Коба",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.022215,
            "latitude": 50.1618664
        },
        "6114": {
            "name": "Маральник 2",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0454774,
            "latitude": 50.222005
        },
        "6115": {
            "name": "Улалушка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.079437,
            "latitude": 51.941471
        },
        "6116": {
            "name": "Куташ",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1067766,
            "latitude": 51.8759471
        },
        "6117": {
            "name": "Уожан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1482109,
            "latitude": 51.32174
        },
        "6118": {
            "name": "Средний Сайдыс",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1523653,
            "latitude": 51.7634912
        },
        "6119": {
            "name": "Верхний Сайдыс",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2029697,
            "latitude": 51.7636832
        },
        "6120": {
            "name": "Урлу-Аспак",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.210564,
            "latitude": 51.686428
        },
        "6121": {
            "name": "Улита",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    86.2029424,
                    50.7034343
                ],
                [
                    86.2042019,
                    50.7054822
                ],
                [
                    86.2077425,
                    50.7087979
                ],
                [
                    86.2108538,
                    50.7110263
                ],
                [
                    86.2149158,
                    50.7186116
                ],
                [
                    86.2160702,
                    50.7184188
                ],
                [
                    86.2167461,
                    50.7158415
                ],
                [
                    86.2155595,
                    50.7121173
                ],
                [
                    86.2119052,
                    50.7079146
                ],
                [
                    86.2086865,
                    50.7063927
                ],
                [
                    86.2033864,
                    50.7027507
                ],
                [
                    86.2029424,
                    50.7034343
                ]
            ],
            "longitude": 86.2120155,
            "latitude": 50.7107956
        },
        "6122": {
            "name": "Каракол",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.247406,
            "latitude": 51.457432
        },
        "6123": {
            "name": "Салганда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3221929,
            "latitude": 51.853461
        },
        "6124": {
            "name": "Кара-Торбок",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3423488,
            "latitude": 51.8037834
        },
        "6125": {
            "name": "Каянча",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4216509,
            "latitude": 50.812738
        },
        "6126": {
            "name": "Туньжа",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4634131,
            "latitude": 52.0081419
        },
        "6127": {
            "name": "Гусевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5371024,
            "latitude": 52.0224955
        },
        "6128": {
            "name": "Бижельбик",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5590799,
            "latitude": 51.6256432
        },
        "6129": {
            "name": "Малый Яломан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5763746,
            "latitude": 50.4988477
        },
        "6130": {
            "name": "Никольское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6003674,
            "latitude": 51.7816078
        },
        "6131": {
            "name": "Советское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.615822,
            "latitude": 52.034634
        },
        "6132": {
            "name": "Малая Иня",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6675238,
            "latitude": 50.4522613
        },
        "6133": {
            "name": "Ишинск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6722707,
            "latitude": 52.0309842
        },
        "6134": {
            "name": "Чуйозы",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7042027,
            "latitude": 50.4067022
        },
        "6135": {
            "name": "Кузя",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7218501,
            "latitude": 51.760492
        },
        "6136": {
            "name": "Каначак",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7263845,
            "latitude": 52.4565328
        },
        "6137": {
            "name": "Приют «Альбаган»",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7979398,
            "latitude": 51.420006
        },
        "6138": {
            "name": "Шунарак",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.8125065,
            "latitude": 52.4569493
        },
        "6139": {
            "name": "Дайбово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.9016374,
            "latitude": 52.3738718
        },
        "6140": {
            "name": "Удаловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.9438431,
            "latitude": 52.3546698
        },
        "6141": {
            "name": "Усть-Лебедь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0284297,
            "latitude": 52.2805161
        },
        "6142": {
            "name": "Акбом",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    87.0298082,
                    50.3715387
                ],
                [
                    87.0298296,
                    50.3720862
                ],
                [
                    87.0304948,
                    50.3720588
                ],
                [
                    87.0311171,
                    50.3717166
                ],
                [
                    87.0318252,
                    50.3714292
                ],
                [
                    87.032469,
                    50.3708544
                ],
                [
                    87.0326835,
                    50.3704712
                ],
                [
                    87.0334775,
                    50.3698553
                ],
                [
                    87.0346362,
                    50.36913
                ],
                [
                    87.0350868,
                    50.3688562
                ],
                [
                    87.0340997,
                    50.3686372
                ],
                [
                    87.0330053,
                    50.3690205
                ],
                [
                    87.0320827,
                    50.3697732
                ],
                [
                    87.031203,
                    50.3701428
                ],
                [
                    87.0304305,
                    50.370786
                ],
                [
                    87.0298082,
                    50.3715387
                ]
            ],
            "longitude": 87.0319948,
            "latitude": 50.3705012
        },
        "6143": {
            "name": "Белый Бом",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0377744,
            "latitude": 50.3676723
        },
        "6144": {
            "name": "Сюря",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.051527,
            "latitude": 51.900651
        },
        "6145": {
            "name": "Аркыт",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0558572,
            "latitude": 49.8620325
        },
        "6146": {
            "name": "Огни",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0771525,
            "latitude": 52.1301522
        },
        "6147": {
            "name": "Санькин Аил",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.104103,
            "latitude": 52.187553
        },
        "6148": {
            "name": "Лебедское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.115508,
            "latitude": 52.2988835
        },
        "6149": {
            "name": "Тулой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.12291,
            "latitude": 52.004948
        },
        "6150": {
            "name": "Старый Кебезень",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.1255813,
            "latitude": 51.9128738
        },
        "6151": {
            "name": "Стретинка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.2364639,
            "latitude": 52.2508996
        },
        "6152": {
            "name": "Советский Байгол",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.4427856,
            "latitude": 52.2061453
        },
        "6153": {
            "name": "Ак-Алахинская застава",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.488345,
            "latitude": 49.2719567
        },
        "6154": {
            "name": "Чуйка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5092008,
            "latitude": 51.9688843
        },
        "6155": {
            "name": "Иткуч",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5308,
            "latitude": 52.090164
        },
        "6156": {
            "name": "Яйлю",
            "population": 187,
            "type": "hamlet",
            "poly": [
                [
                    87.5980476,
                    51.7707202
                ],
                [
                    87.5984408,
                    51.7711156
                ],
                [
                    87.6000271,
                    51.7705292
                ],
                [
                    87.6007588,
                    51.7707149
                ],
                [
                    87.6003198,
                    51.7717002
                ],
                [
                    87.6007848,
                    51.7717614
                ],
                [
                    87.6009529,
                    51.7716337
                ],
                [
                    87.6056937,
                    51.7719224
                ],
                [
                    87.6065714,
                    51.7728275
                ],
                [
                    87.610998,
                    51.7724878
                ],
                [
                    87.6122037,
                    51.7723953
                ],
                [
                    87.6176359,
                    51.7721121
                ],
                [
                    87.6179096,
                    51.7711356
                ],
                [
                    87.6116777,
                    51.7712053
                ],
                [
                    87.6117742,
                    51.7698899
                ],
                [
                    87.6098547,
                    51.7693698
                ],
                [
                    87.6081832,
                    51.7696508
                ],
                [
                    87.6064618,
                    51.7694318
                ],
                [
                    87.6046625,
                    51.7686352
                ],
                [
                    87.6028568,
                    51.7680245
                ],
                [
                    87.6017903,
                    51.7691526
                ],
                [
                    87.6008724,
                    51.7697505
                ],
                [
                    87.6001317,
                    51.7694914
                ],
                [
                    87.5980476,
                    51.7707202
                ]
            ],
            "longitude": 87.6068427,
            "latitude": 51.7704618
        },
        "6157": {
            "name": "Бийка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.65784,
            "latitude": 51.9275918
        },
        "6158": {
            "name": "Суранаш",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7592838,
            "latitude": 52.290952
        },
        "6159": {
            "name": "Кок-Паш",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7665863,
            "latitude": 51.1829991
        },
        "6160": {
            "name": "Беле",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7964299,
            "latitude": 51.4199827
        },
        "6161": {
            "name": "Кара-Кудюр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.828419,
            "latitude": 50.6692899
        },
        "6162": {
            "name": "Коо",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    87.8873671,
                    51.0973722
                ],
                [
                    87.8923367,
                    51.0997438
                ],
                [
                    87.9000614,
                    51.101253
                ],
                [
                    87.9025591,
                    51.0994851
                ],
                [
                    87.8976582,
                    51.0957605
                ],
                [
                    87.8935383,
                    51.094359
                ],
                [
                    87.8902853,
                    51.0951137
                ],
                [
                    87.8873671,
                    51.0973722
                ]
            ],
            "longitude": 87.8967958,
            "latitude": 51.0995575
        },
        "6163": {
            "name": "Тёплый Ключ",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    88.0528251,
                    49.4588468
                ],
                [
                    88.0531345,
                    49.4590805
                ],
                [
                    88.0544224,
                    49.4592273
                ],
                [
                    88.055476,
                    49.4590751
                ],
                [
                    88.0564628,
                    49.4600099
                ],
                [
                    88.0563039,
                    49.4591838
                ],
                [
                    88.0554426,
                    49.4588576
                ],
                [
                    88.0548572,
                    49.4584065
                ],
                [
                    88.054414,
                    49.4577759
                ],
                [
                    88.053929,
                    49.4575313
                ],
                [
                    88.053444,
                    49.457852
                ],
                [
                    88.0530091,
                    49.4584174
                ],
                [
                    88.0528251,
                    49.4588468
                ]
            ],
            "longitude": 88.0537572,
            "latitude": 49.4587445
        },
        "6164": {
            "name": "Талон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3632036,
            "latitude": 52.3400971
        },
        "6165": {
            "name": "Чодро",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5355959,
            "latitude": 50.8292563
        },
        "6166": {
            "name": "Актал",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.8693558,
            "latitude": 49.9216378
        },
        "6167": {
            "name": "Узунтал",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.1026822,
            "latitude": 49.9921542
        },
        "6168": {
            "name": "полярная станция Визе",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.018227,
            "latitude": 79.4886179
        },
        "6169": {
            "name": "Сосновая",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.6283438,
            "latitude": 72.3647613
        },
        "6170": {
            "name": "Лескино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.5,
            "latitude": 72.316667
        },
        "6171": {
            "name": "Моноучи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.6668738,
            "latitude": 71.4976695
        },
        "6172": {
            "name": "Яр-Пан-Ты-Я",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.833333,
            "latitude": 70.166667
        },
        "6173": {
            "name": "Рагозинка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.833333,
            "latitude": 72.7
        },
        "6174": {
            "name": "Зырянка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.3448144,
            "latitude": 72.3508982
        },
        "6175": {
            "name": "Дерябино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.3223539,
            "latitude": 70.6927412
        },
        "6176": {
            "name": "Мессояха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.4882521,
            "latitude": 69.1290921
        },
        "6177": {
            "name": "Поликарповск",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.670733,
            "latitude": 70.4059221
        },
        "6178": {
            "name": "Мироновская",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6763774,
            "latitude": 71.9217006
        },
        "6179": {
            "name": "Сопкарга",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6897219,
            "latitude": 71.885833
        },
        "6180": {
            "name": "Яковлевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.350625,
            "latitude": 71.03722
        },
        "6181": {
            "name": "Воронцово",
            "population": 253,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.562149,
            "latitude": 71.697632
        },
        "6182": {
            "name": "Байкаловск",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.622917,
            "latitude": 70.694962
        },
        "6183": {
            "name": "Ванкор",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6381227,
            "latitude": 67.8079514
        },
        "6184": {
            "name": "Советская Речка",
            "population": 143,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.716108,
            "latitude": 66.7451224
        },
        "6185": {
            "name": "Мунгуй",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.768608,
            "latitude": 70.431259
        },
        "6186": {
            "name": "Казанцево",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.771301,
            "latitude": 69.83802
        },
        "6187": {
            "name": "Янов Стан",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.325371,
            "latitude": 65.978188
        },
        "6188": {
            "name": "Верхняя Баиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8666669,
            "latitude": 65.6
        },
        "6189": {
            "name": "Макарова",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1331828,
            "latitude": 73.7043414
        },
        "6190": {
            "name": "Маковское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.502915,
            "latitude": 66.8823484
        },
        "6191": {
            "name": "Матылька",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.75,
            "latitude": 63.366667
        },
        "6192": {
            "name": "Фактория Налимье",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7752428,
            "latitude": 63.840465
        },
        "6193": {
            "name": "Левинские Пески",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.007385,
            "latitude": 69.469955
        },
        "6194": {
            "name": "Никольск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1171287,
            "latitude": 69.0189249
        },
        "6195": {
            "name": "Ермаково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.189491,
            "latitude": 66.585167
        },
        "6196": {
            "name": "Плахино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4106246,
            "latitude": 67.9353935
        },
        "6197": {
            "name": "Агапитово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.45,
            "latitude": 68.033333
        },
        "6198": {
            "name": "Кондыль",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.583333,
            "latitude": 64.666667
        },
        "6199": {
            "name": "Хантайка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6231273,
            "latitude": 68.2623341
        },
        "6200": {
            "name": "Пура",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6872649,
            "latitude": 73.1492856
        },
        "6201": {
            "name": "Нижняя Баиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7,
            "latitude": 64.716667
        },
        "6202": {
            "name": "Карасино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7107345,
            "latitude": 66.8842589
        },
        "6203": {
            "name": "Мыс Входной",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7455639,
            "latitude": 73.8332603
        },
        "6204": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.965589,
            "latitude": 61.4983818
        },
        "6205": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.997219,
            "latitude": 61.5166043
        },
        "6206": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0156804,
            "latitude": 61.4965382
        },
        "6207": {
            "name": "Сигово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.054173,
            "latitude": 62.7293394
        },
        "6208": {
            "name": "Курейка",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.1715206,
            "latitude": 66.4668701
        },
        "6209": {
            "name": "Ангутиха",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.236191,
            "latitude": 66.117599
        },
        "6210": {
            "name": "Канготово",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.2822415,
            "latitude": 63.4328263
        },
        "6211": {
            "name": "Сургутиха",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.343086,
            "latitude": 63.850521
        },
        "6212": {
            "name": "Горошиха",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5046351,
            "latitude": 66.3944162
        },
        "6213": {
            "name": "Брусово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5254773,
            "latitude": 60.5833658
        },
        "6214": {
            "name": "Бакланиха",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5478102,
            "latitude": 64.4452077
        },
        "6215": {
            "name": "Верещагино",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5747825,
            "latitude": 64.2390089
        },
        "6216": {
            "name": "Старотуруханск",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.575241,
            "latitude": 65.914963
        },
        "6217": {
            "name": "Алинское",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.6046181,
            "latitude": 63.301299
        },
        "6218": {
            "name": "Селиваниха",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8769,
            "latitude": 65.865379
        },
        "6219": {
            "name": "Объединённый",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.9161051,
            "latitude": 63.1063177
        },
        "6220": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.9354785,
            "latitude": 63.1082863
        },
        "6221": {
            "name": "Костино",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.9792056,
            "latitude": 65.3227606
        },
        "6222": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1337386,
            "latitude": 62.952491
        },
        "6223": {
            "name": "Становище Веденское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3999999,
            "latitude": 70.1
        },
        "6224": {
            "name": "Айдара",
            "population": 171,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4038577,
            "latitude": 58.5272946
        },
        "6225": {
            "name": "Мадуйка",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4297519,
            "latitude": 66.64955
        },
        "6226": {
            "name": "Чулково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4392355,
            "latitude": 62.7734764
        },
        "6227": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4479053,
            "latitude": 61.3268459
        },
        "6228": {
            "name": "Курья",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.55,
            "latitude": 70.25
        },
        "6229": {
            "name": "Киргисуль",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    88.5765178,
                    55.3920435
                ],
                [
                    88.5827882,
                    55.398164
                ],
                [
                    88.5875221,
                    55.3966887
                ],
                [
                    88.5889605,
                    55.3959941
                ],
                [
                    88.5864132,
                    55.3928226
                ],
                [
                    88.5896463,
                    55.3899846
                ],
                [
                    88.59092,
                    55.3854212
                ],
                [
                    88.5894138,
                    55.3846977
                ],
                [
                    88.5806327,
                    55.3851986
                ],
                [
                    88.5807307,
                    55.3873691
                ],
                [
                    88.5792611,
                    55.3899846
                ],
                [
                    88.5765178,
                    55.3920435
                ]
            ],
            "longitude": 88.583824,
            "latitude": 55.390541
        },
        "6230": {
            "name": "Юферовское",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.656441,
            "latitude": 55.293358
        },
        "6231": {
            "name": "Едет",
            "population": 266,
            "type": "hamlet",
            "poly": [
                [
                    88.6852931,
                    55.5199498
                ],
                [
                    88.6853035,
                    55.5200198
                ],
                [
                    88.685742,
                    55.5210106
                ],
                [
                    88.686548,
                    55.5216332
                ],
                [
                    88.6873089,
                    55.5227633
                ],
                [
                    88.6875952,
                    55.5230107
                ],
                [
                    88.6882882,
                    55.5233817
                ],
                [
                    88.6895237,
                    55.5233689
                ],
                [
                    88.6897723,
                    55.5229808
                ],
                [
                    88.6907064,
                    55.522516
                ],
                [
                    88.6916933,
                    55.5225075
                ],
                [
                    88.6929965,
                    55.5226567
                ],
                [
                    88.6937574,
                    55.5228358
                ],
                [
                    88.6943676,
                    55.5231429
                ],
                [
                    88.695264,
                    55.5233134
                ],
                [
                    88.6955804,
                    55.5236589
                ],
                [
                    88.695279,
                    55.5240128
                ],
                [
                    88.6946011,
                    55.5242175
                ],
                [
                    88.6943826,
                    55.524435
                ],
                [
                    88.6942094,
                    55.5247462
                ],
                [
                    88.6942244,
                    55.5249168
                ],
                [
                    88.695038,
                    55.5256886
                ],
                [
                    88.695475,
                    55.5261534
                ],
                [
                    88.6957085,
                    55.5265756
                ],
                [
                    88.6958968,
                    55.5270574
                ],
                [
                    88.696281,
                    55.5270744
                ],
                [
                    88.6965824,
                    55.5268996
                ],
                [
                    88.6965824,
                    55.5263965
                ],
                [
                    88.6968762,
                    55.5262685
                ],
                [
                    88.6973131,
                    55.5264391
                ],
                [
                    88.6973432,
                    55.5262685
                ],
                [
                    88.6975918,
                    55.5262899
                ],
                [
                    88.6977274,
                    55.5263837
                ],
                [
                    88.6976521,
                    55.5265073
                ],
                [
                    88.6977952,
                    55.5265798
                ],
                [
                    88.6979685,
                    55.5263879
                ],
                [
                    88.6980514,
                    55.5262003
                ],
                [
                    88.698428,
                    55.5261875
                ],
                [
                    88.6984431,
                    55.5265628
                ],
                [
                    88.6990231,
                    55.5275136
                ],
                [
                    88.699106,
                    55.5277524
                ],
                [
                    88.6989629,
                    55.5281532
                ],
                [
                    88.6989327,
                    55.528328
                ],
                [
                    88.6995429,
                    55.5286308
                ],
                [
                    88.7006051,
                    55.5285028
                ],
                [
                    88.7013811,
                    55.5283536
                ],
                [
                    88.7034,
                    55.5282129
                ],
                [
                    88.7044471,
                    55.5283451
                ],
                [
                    88.7056524,
                    55.5287374
                ],
                [
                    88.7071365,
                    55.5289889
                ],
                [
                    88.7086657,
                    55.5280594
                ],
                [
                    88.7075734,
                    55.5275136
                ],
                [
                    88.7070988,
                    55.5277183
                ],
                [
                    88.7065715,
                    55.5270489
                ],
                [
                    88.7058708,
                    55.5265201
                ],
                [
                    88.7072796,
                    55.5256503
                ],
                [
                    88.7093588,
                    55.5267376
                ],
                [
                    88.7099539,
                    55.5263496
                ],
                [
                    88.7113928,
                    55.5271299
                ],
                [
                    88.7119653,
                    55.5270275
                ],
                [
                    88.7129447,
                    55.5275222
                ],
                [
                    88.7132912,
                    55.527326
                ],
                [
                    88.7123268,
                    55.5266949
                ],
                [
                    88.7117017,
                    55.5257355
                ],
                [
                    88.7122893,
                    55.5252238
                ],
                [
                    88.7112798,
                    55.5247974
                ],
                [
                    88.7106545,
                    55.5240256
                ],
                [
                    88.7073585,
                    55.5216619
                ],
                [
                    88.7010023,
                    55.5175677
                ],
                [
                    88.7011435,
                    55.5174131
                ],
                [
                    88.7010023,
                    55.5172638
                ],
                [
                    88.6977528,
                    55.5157217
                ],
                [
                    88.696962,
                    55.5155759
                ],
                [
                    88.6984333,
                    55.5152531
                ],
                [
                    88.6987276,
                    55.5147949
                ],
                [
                    88.6992793,
                    55.5146387
                ],
                [
                    88.6992426,
                    55.5144096
                ],
                [
                    88.6994816,
                    55.5141701
                ],
                [
                    88.6980471,
                    55.513285
                ],
                [
                    88.6968148,
                    55.5136494
                ],
                [
                    88.6943871,
                    55.5137536
                ],
                [
                    88.6924008,
                    55.5142326
                ],
                [
                    88.6920514,
                    55.5145346
                ],
                [
                    88.6925295,
                    55.5153781
                ],
                [
                    88.6926498,
                    55.5159647
                ],
                [
                    88.6925085,
                    55.5162913
                ],
                [
                    88.6919788,
                    55.5168644
                ],
                [
                    88.6920495,
                    55.5170977
                ],
                [
                    88.6924026,
                    55.5176508
                ],
                [
                    88.6923084,
                    55.5182572
                ],
                [
                    88.6924144,
                    55.5184505
                ],
                [
                    88.6908253,
                    55.5192101
                ],
                [
                    88.6906252,
                    55.5193301
                ],
                [
                    88.6900014,
                    55.5193101
                ],
                [
                    88.6896481,
                    55.51951
                ],
                [
                    88.6892127,
                    55.5199032
                ],
                [
                    88.6891421,
                    55.5200564
                ],
                [
                    88.688118,
                    55.5199232
                ],
                [
                    88.6852931,
                    55.5199498
                ]
            ],
            "longitude": 88.70166,
            "latitude": 55.522533
        },
        "6232": {
            "name": "Рубино",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    88.7212511,
                    57.1310609
                ],
                [
                    88.7239105,
                    57.1342994
                ],
                [
                    88.7269589,
                    57.1334546
                ],
                [
                    88.7294887,
                    57.1333842
                ],
                [
                    88.7302021,
                    57.1341234
                ],
                [
                    88.7326669,
                    57.1346161
                ],
                [
                    88.7345479,
                    57.1343346
                ],
                [
                    88.7364938,
                    57.1351793
                ],
                [
                    88.7389586,
                    57.1342642
                ],
                [
                    88.7396721,
                    57.1321874
                ],
                [
                    88.7415401,
                    57.1304526
                ],
                [
                    88.7449026,
                    57.1295739
                ],
                [
                    88.7478914,
                    57.1300471
                ],
                [
                    88.7490952,
                    57.1307455
                ],
                [
                    88.7526653,
                    57.130768
                ],
                [
                    88.7569825,
                    57.1308131
                ],
                [
                    88.7595978,
                    57.1313313
                ],
                [
                    88.7617979,
                    57.1302048
                ],
                [
                    88.7619225,
                    57.1291008
                ],
                [
                    88.7542843,
                    57.1280869
                ],
                [
                    88.7366832,
                    57.127456
                ],
                [
                    88.732366,
                    57.1264646
                ],
                [
                    88.7263466,
                    57.1261492
                ],
                [
                    88.7246863,
                    57.1268251
                ],
                [
                    88.7226107,
                    57.1291909
                ],
                [
                    88.7223616,
                    57.1303174
                ],
                [
                    88.7212511,
                    57.1310609
                ]
            ],
            "longitude": 88.737961,
            "latitude": 57.129593
        },
        "6233": {
            "name": "Изотово",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.76973,
            "latitude": 56.670399
        },
        "6234": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.8230584,
            "latitude": 58.3962624
        },
        "6235": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.8307327,
            "latitude": 59.1236103
        },
        "6236": {
            "name": "Черкасск",
            "population": 22,
            "type": "hamlet",
            "poly": [
                [
                    88.8519916,
                    57.1224421
                ],
                [
                    88.8523954,
                    57.1240805
                ],
                [
                    88.8528843,
                    57.1244843
                ],
                [
                    88.8534369,
                    57.1252342
                ],
                [
                    88.8532031,
                    57.1269647
                ],
                [
                    88.856795,
                    57.1268695
                ],
                [
                    88.8621723,
                    57.1265118
                ],
                [
                    88.8612159,
                    57.126085
                ],
                [
                    88.8610245,
                    57.1254851
                ],
                [
                    88.8618535,
                    57.1247352
                ],
                [
                    88.8648929,
                    57.124216
                ],
                [
                    88.8673796,
                    57.1248275
                ],
                [
                    88.8692499,
                    57.1237661
                ],
                [
                    88.8714604,
                    57.1228546
                ],
                [
                    88.8712266,
                    57.1220124
                ],
                [
                    88.8682085,
                    57.1218508
                ],
                [
                    88.8689311,
                    57.1211586
                ],
                [
                    88.8691862,
                    57.120247
                ],
                [
                    88.8669545,
                    57.1195086
                ],
                [
                    88.8652754,
                    57.1194393
                ],
                [
                    88.8644039,
                    57.1197393
                ],
                [
                    88.8637664,
                    57.1193009
                ],
                [
                    88.8611521,
                    57.1192201
                ],
                [
                    88.8568801,
                    57.1197307
                ],
                [
                    88.8551796,
                    57.120573
                ],
                [
                    88.8549672,
                    57.1209768
                ],
                [
                    88.8523529,
                    57.1218191
                ],
                [
                    88.8519916,
                    57.1224421
                ]
            ],
            "longitude": 88.861946,
            "latitude": 57.122189
        },
        "6237": {
            "name": "Сорокино",
            "population": 114,
            "type": "hamlet",
            "poly": [
                [
                    88.8499777,
                    55.5173706
                ],
                [
                    88.8500603,
                    55.5177098
                ],
                [
                    88.8504197,
                    55.5176981
                ],
                [
                    88.8506428,
                    55.5175343
                ],
                [
                    88.8510931,
                    55.517525
                ],
                [
                    88.8520228,
                    55.5173098
                ],
                [
                    88.8524896,
                    55.5173987
                ],
                [
                    88.8528077,
                    55.5175109
                ],
                [
                    88.8531464,
                    55.517532
                ],
                [
                    88.8537249,
                    55.5176794
                ],
                [
                    88.8539604,
                    55.5176817
                ],
                [
                    88.8541133,
                    55.517815
                ],
                [
                    88.8545884,
                    55.5178548
                ],
                [
                    88.854952,
                    55.5178571
                ],
                [
                    88.8551048,
                    55.5179998
                ],
                [
                    88.8555014,
                    55.5179273
                ],
                [
                    88.8558567,
                    55.5181401
                ],
                [
                    88.8561005,
                    55.5181074
                ],
                [
                    88.8564722,
                    55.5180138
                ],
                [
                    88.8567533,
                    55.5180185
                ],
                [
                    88.8568896,
                    55.5180793
                ],
                [
                    88.8571953,
                    55.5179577
                ],
                [
                    88.8575878,
                    55.5179203
                ],
                [
                    88.8579473,
                    55.5180396
                ],
                [
                    88.8584389,
                    55.5181167
                ],
                [
                    88.858728,
                    55.5184419
                ],
                [
                    88.8589512,
                    55.5184489
                ],
                [
                    88.8593869,
                    55.5183379
                ],
                [
                    88.8600374,
                    55.5182615
                ],
                [
                    88.8603362,
                    55.5182151
                ],
                [
                    88.8605768,
                    55.5182451
                ],
                [
                    88.8609601,
                    55.5181208
                ],
                [
                    88.8614811,
                    55.517766
                ],
                [
                    88.8620681,
                    55.5179142
                ],
                [
                    88.8621897,
                    55.5180999
                ],
                [
                    88.8618592,
                    55.5182121
                ],
                [
                    88.8617852,
                    55.5183753
                ],
                [
                    88.8624382,
                    55.5186777
                ],
                [
                    88.8628032,
                    55.5186522
                ],
                [
                    88.8629988,
                    55.5184576
                ],
                [
                    88.8633107,
                    55.5184367
                ],
                [
                    88.8636281,
                    55.5186328
                ],
                [
                    88.8641041,
                    55.5187316
                ],
                [
                    88.8644901,
                    55.5186537
                ],
                [
                    88.8647783,
                    55.518522
                ],
                [
                    88.8653204,
                    55.5183693
                ],
                [
                    88.8656165,
                    55.5184157
                ],
                [
                    88.8659127,
                    55.5186702
                ],
                [
                    88.8661189,
                    55.5186597
                ],
                [
                    88.8663066,
                    55.5184846
                ],
                [
                    88.8662669,
                    55.5184067
                ],
                [
                    88.8663542,
                    55.5183064
                ],
                [
                    88.8665393,
                    55.5182945
                ],
                [
                    88.8667296,
                    55.5181283
                ],
                [
                    88.8671528,
                    55.5181148
                ],
                [
                    88.867946,
                    55.5183948
                ],
                [
                    88.868763,
                    55.5184008
                ],
                [
                    88.8694188,
                    55.5182406
                ],
                [
                    88.869945,
                    55.5181927
                ],
                [
                    88.8704051,
                    55.518019
                ],
                [
                    88.8706272,
                    55.5180175
                ],
                [
                    88.8708784,
                    55.5181747
                ],
                [
                    88.8708846,
                    55.5184388
                ],
                [
                    88.8712266,
                    55.5186216
                ],
                [
                    88.8717432,
                    55.5185631
                ],
                [
                    88.8720659,
                    55.5184863
                ],
                [
                    88.8723048,
                    55.5183292
                ],
                [
                    88.8723758,
                    55.5179052
                ],
                [
                    88.8726276,
                    55.5177773
                ],
                [
                    88.8729568,
                    55.5177262
                ],
                [
                    88.8734087,
                    55.5178687
                ],
                [
                    88.8741704,
                    55.5182451
                ],
                [
                    88.874448,
                    55.5183036
                ],
                [
                    88.8746933,
                    55.5182451
                ],
                [
                    88.8757648,
                    55.5176275
                ],
                [
                    88.8759521,
                    55.517686
                ],
                [
                    88.8760102,
                    55.5178029
                ],
                [
                    88.8758359,
                    55.5179929
                ],
                [
                    88.875965,
                    55.5180916
                ],
                [
                    88.8767913,
                    55.518077
                ],
                [
                    88.8770431,
                    55.5181866
                ],
                [
                    88.8772302,
                    55.5181464
                ],
                [
                    88.8773529,
                    55.5180587
                ],
                [
                    88.8773594,
                    55.5176275
                ],
                [
                    88.8774239,
                    55.5173095
                ],
                [
                    88.8779468,
                    55.517145
                ],
                [
                    88.8780888,
                    55.5172839
                ],
                [
                    88.8785407,
                    55.5171231
                ],
                [
                    88.8786246,
                    55.5168673
                ],
                [
                    88.8784826,
                    55.5167978
                ],
                [
                    88.8779662,
                    55.5166809
                ],
                [
                    88.8775853,
                    55.5166882
                ],
                [
                    88.8774756,
                    55.5165932
                ],
                [
                    88.8775208,
                    55.5163191
                ],
                [
                    88.8779404,
                    55.5160815
                ],
                [
                    88.8789539,
                    55.5158549
                ],
                [
                    88.8793024,
                    55.5159061
                ],
                [
                    88.8797156,
                    55.5157708
                ],
                [
                    88.879651,
                    55.5153944
                ],
                [
                    88.8797672,
                    55.5152701
                ],
                [
                    88.8801868,
                    55.5150654
                ],
                [
                    88.8802191,
                    55.5146999
                ],
                [
                    88.8800045,
                    55.5142827
                ],
                [
                    88.8784758,
                    55.5146217
                ],
                [
                    88.8746303,
                    55.5141845
                ],
                [
                    88.8724711,
                    55.5137651
                ],
                [
                    88.8685468,
                    55.5136402
                ],
                [
                    88.8673017,
                    55.5135777
                ],
                [
                    88.8670822,
                    55.5133216
                ],
                [
                    88.8669015,
                    55.5133099
                ],
                [
                    88.8667362,
                    55.513035
                ],
                [
                    88.8666794,
                    55.5129327
                ],
                [
                    88.8662456,
                    55.5128859
                ],
                [
                    88.8661785,
                    55.5127894
                ],
                [
                    88.8662611,
                    55.5126753
                ],
                [
                    88.8662611,
                    55.5124999
                ],
                [
                    88.8664419,
                    55.5122777
                ],
                [
                    88.8662353,
                    55.5119823
                ],
                [
                    88.8657625,
                    55.5117489
                ],
                [
                    88.8651007,
                    55.5117763
                ],
                [
                    88.8644311,
                    55.5116804
                ],
                [
                    88.864189,
                    55.5114611
                ],
                [
                    88.8641245,
                    55.5108534
                ],
                [
                    88.863019,
                    55.5103645
                ],
                [
                    88.8629141,
                    55.5100812
                ],
                [
                    88.8626397,
                    55.5095283
                ],
                [
                    88.862672,
                    55.5090622
                ],
                [
                    88.8633337,
                    55.5085321
                ],
                [
                    88.8636322,
                    55.5081666
                ],
                [
                    88.8635192,
                    55.5078513
                ],
                [
                    88.8636726,
                    55.5075771
                ],
                [
                    88.8636564,
                    55.5069556
                ],
                [
                    88.8614697,
                    55.5063798
                ],
                [
                    88.8610823,
                    55.5066266
                ],
                [
                    88.8607354,
                    55.5071567
                ],
                [
                    88.8604287,
                    55.5078695
                ],
                [
                    88.8603238,
                    55.508427
                ],
                [
                    88.8606708,
                    55.5085413
                ],
                [
                    88.8604772,
                    55.5085961
                ],
                [
                    88.8605901,
                    55.508916
                ],
                [
                    88.8602674,
                    55.5090668
                ],
                [
                    88.8601382,
                    55.5091627
                ],
                [
                    88.8600495,
                    55.5091125
                ],
                [
                    88.8598558,
                    55.5091581
                ],
                [
                    88.8598962,
                    55.509245
                ],
                [
                    88.859759,
                    55.5093318
                ],
                [
                    88.8587826,
                    55.5092358
                ],
                [
                    88.8581613,
                    55.5090987
                ],
                [
                    88.8579353,
                    55.5091399
                ],
                [
                    88.8580644,
                    55.5092907
                ],
                [
                    88.8597106,
                    55.5102457
                ],
                [
                    88.8596218,
                    55.5103188
                ],
                [
                    88.8593152,
                    55.5103142
                ],
                [
                    88.8591699,
                    55.5104878
                ],
                [
                    88.8585002,
                    55.510963
                ],
                [
                    88.8593636,
                    55.5117809
                ],
                [
                    88.8599526,
                    55.5126856
                ],
                [
                    88.8601946,
                    55.5130191
                ],
                [
                    88.860131,
                    55.5134954
                ],
                [
                    88.8604344,
                    55.513722
                ],
                [
                    88.8602214,
                    55.5138134
                ],
                [
                    88.8598341,
                    55.5137476
                ],
                [
                    88.8594016,
                    55.5137768
                ],
                [
                    88.8589238,
                    55.5138171
                ],
                [
                    88.8587043,
                    55.5139852
                ],
                [
                    88.8586915,
                    55.5142995
                ],
                [
                    88.8563933,
                    55.5144969
                ],
                [
                    88.856148,
                    55.5143836
                ],
                [
                    88.8550829,
                    55.5144567
                ],
                [
                    88.8548569,
                    55.5142557
                ],
                [
                    88.8537789,
                    55.5144348
                ],
                [
                    88.8514937,
                    55.5141789
                ],
                [
                    88.8512613,
                    55.5143068
                ],
                [
                    88.8513839,
                    55.5146102
                ],
                [
                    88.8513646,
                    55.5151219
                ],
                [
                    88.8510095,
                    55.5154728
                ],
                [
                    88.850435,
                    55.5155422
                ],
                [
                    88.8508223,
                    55.5161416
                ],
                [
                    88.8506997,
                    55.5167118
                ],
                [
                    88.8503991,
                    55.517125
                ],
                [
                    88.8499777,
                    55.5173706
                ]
            ],
            "longitude": 88.863472,
            "latitude": 55.515175
        },
        "6238": {
            "name": "Заостровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.8668823,
            "latitude": 70.5004551
        },
        "6239": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.9234538,
            "latitude": 59.3218102
        },
        "6240": {
            "name": "Базыр",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.951172,
            "latitude": 55.410969
        },
        "6241": {
            "name": "Николаевка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    88.9480999,
                    56.6910549
                ],
                [
                    88.9501834,
                    56.6937093
                ],
                [
                    88.9510169,
                    56.6940449
                ],
                [
                    88.952017,
                    56.6937093
                ],
                [
                    88.9528782,
                    56.6940906
                ],
                [
                    88.9601567,
                    56.6923211
                ],
                [
                    88.9571008,
                    56.6898954
                ],
                [
                    88.9549339,
                    56.6898039
                ],
                [
                    88.953906,
                    56.6894377
                ],
                [
                    88.9509613,
                    56.69017
                ],
                [
                    88.9515725,
                    56.6910396
                ],
                [
                    88.9498779,
                    56.6914668
                ],
                [
                    88.9491556,
                    56.690765
                ],
                [
                    88.9480999,
                    56.6910549
                ]
            ],
            "longitude": 88.954018,
            "latitude": 56.692223
        },
        "6242": {
            "name": "Чёрная",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.9681031,
            "latitude": 70.5171939
        },
        "6243": {
            "name": "Бахта",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.003975,
            "latitude": 62.464687
        },
        "6244": {
            "name": "Суханово",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.0121859,
            "latitude": 58.3606259
        },
        "6245": {
            "name": "Мирное",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.015572,
            "latitude": 62.297314
        },
        "6246": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.0256024,
            "latitude": 59.1323727
        },
        "6247": {
            "name": "Северная Речка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.0666669,
            "latitude": 65.933333
        },
        "6248": {
            "name": "Потанинский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.0712517,
            "latitude": 59.3635008
        },
        "6249": {
            "name": "Линево",
            "population": 158,
            "type": "hamlet",
            "poly": [
                [
                    89.0633906,
                    55.3821545
                ],
                [
                    89.064735,
                    55.3819299
                ],
                [
                    89.0668173,
                    55.3810089
                ],
                [
                    89.0694533,
                    55.3804174
                ],
                [
                    89.0714829,
                    55.3801703
                ],
                [
                    89.0739739,
                    55.3795413
                ],
                [
                    89.077506,
                    55.3790247
                ],
                [
                    89.079338,
                    55.3796686
                ],
                [
                    89.0812227,
                    55.3798184
                ],
                [
                    89.0831337,
                    55.3796611
                ],
                [
                    89.0830414,
                    55.3811362
                ],
                [
                    89.0823034,
                    55.3810988
                ],
                [
                    89.0818115,
                    55.3819846
                ],
                [
                    89.0817693,
                    55.3823584
                ],
                [
                    89.0825619,
                    55.3824018
                ],
                [
                    89.0815075,
                    55.3840265
                ],
                [
                    89.0806904,
                    55.3868864
                ],
                [
                    89.0801632,
                    55.3890948
                ],
                [
                    89.0797546,
                    55.389282
                ],
                [
                    89.079262,
                    55.3902413
                ],
                [
                    89.0791002,
                    55.3912148
                ],
                [
                    89.0785536,
                    55.3920503
                ],
                [
                    89.0785131,
                    55.3922036
                ],
                [
                    89.0780273,
                    55.3921423
                ],
                [
                    89.0776829,
                    55.3930166
                ],
                [
                    89.0778557,
                    55.393271
                ],
                [
                    89.079513,
                    55.3936206
                ],
                [
                    89.0799394,
                    55.393642
                ],
                [
                    89.0803227,
                    55.393409
                ],
                [
                    89.0807816,
                    55.3923053
                ],
                [
                    89.0804037,
                    55.3919404
                ],
                [
                    89.0809651,
                    55.3919895
                ],
                [
                    89.0851165,
                    55.3920661
                ],
                [
                    89.0850308,
                    55.392739
                ],
                [
                    89.0851995,
                    55.3927466
                ],
                [
                    89.0852198,
                    55.3937392
                ],
                [
                    89.0857596,
                    55.3939194
                ],
                [
                    89.0881484,
                    55.3939232
                ],
                [
                    89.088533,
                    55.3937392
                ],
                [
                    89.0890054,
                    55.3937431
                ],
                [
                    89.0891876,
                    55.3938619
                ],
                [
                    89.0899771,
                    55.3937891
                ],
                [
                    89.0906721,
                    55.3930647
                ],
                [
                    89.0907126,
                    55.3927121
                ],
                [
                    89.090996,
                    55.392578
                ],
                [
                    89.090996,
                    55.3922982
                ],
                [
                    89.0906265,
                    55.3920238
                ],
                [
                    89.090559,
                    55.3917938
                ],
                [
                    89.090677,
                    55.3916549
                ],
                [
                    89.0907445,
                    55.3907734
                ],
                [
                    89.0908964,
                    55.3902176
                ],
                [
                    89.0909048,
                    55.3899781
                ],
                [
                    89.089454,
                    55.3887324
                ],
                [
                    89.088931,
                    55.3880473
                ],
                [
                    89.0883406,
                    55.3877406
                ],
                [
                    89.0881634,
                    55.386974
                ],
                [
                    89.0886189,
                    55.3866291
                ],
                [
                    89.0888214,
                    55.3859103
                ],
                [
                    89.0891166,
                    55.3852635
                ],
                [
                    89.0896902,
                    55.3836487
                ],
                [
                    89.0896227,
                    55.3829108
                ],
                [
                    89.0892431,
                    55.3822783
                ],
                [
                    89.0892431,
                    55.381847
                ],
                [
                    89.0895974,
                    55.3815355
                ],
                [
                    89.090753,
                    55.3811186
                ],
                [
                    89.0909723,
                    55.3809317
                ],
                [
                    89.0909384,
                    55.3806346
                ],
                [
                    89.0907108,
                    55.3802848
                ],
                [
                    89.090812,
                    55.3801937
                ],
                [
                    89.0912253,
                    55.38005
                ],
                [
                    89.0912506,
                    55.3798774
                ],
                [
                    89.0905505,
                    55.3793695
                ],
                [
                    89.090542,
                    55.3791922
                ],
                [
                    89.0914362,
                    55.3788902
                ],
                [
                    89.0914278,
                    55.3785931
                ],
                [
                    89.0911747,
                    55.3783583
                ],
                [
                    89.090618,
                    55.3781043
                ],
                [
                    89.0903397,
                    55.3778168
                ],
                [
                    89.0903565,
                    55.377534
                ],
                [
                    89.0908795,
                    55.3775005
                ],
                [
                    89.0910819,
                    55.3773375
                ],
                [
                    89.0911326,
                    55.3770883
                ],
                [
                    89.090753,
                    55.3764749
                ],
                [
                    89.0901684,
                    55.3759328
                ],
                [
                    89.0882249,
                    55.3745688
                ],
                [
                    89.0861262,
                    55.3744461
                ],
                [
                    89.0851006,
                    55.3745573
                ],
                [
                    89.0839062,
                    55.3745726
                ],
                [
                    89.0839601,
                    55.3750251
                ],
                [
                    89.0838049,
                    55.3754315
                ],
                [
                    89.0834945,
                    55.3754775
                ],
                [
                    89.0834338,
                    55.3757804
                ],
                [
                    89.0832246,
                    55.3759414
                ],
                [
                    89.0825093,
                    55.3761025
                ],
                [
                    89.0814634,
                    55.3755733
                ],
                [
                    89.080269,
                    55.3750711
                ],
                [
                    89.0803296,
                    55.3753433
                ],
                [
                    89.0806805,
                    55.3755657
                ],
                [
                    89.0806941,
                    55.3757881
                ],
                [
                    89.0805592,
                    55.3760104
                ],
                [
                    89.0813217,
                    55.3764744
                ],
                [
                    89.0813765,
                    55.3768702
                ],
                [
                    89.08125,
                    55.3771051
                ],
                [
                    89.0810222,
                    55.3771482
                ],
                [
                    89.0803643,
                    55.3771434
                ],
                [
                    89.078905,
                    55.3769469
                ],
                [
                    89.0776735,
                    55.3769469
                ],
                [
                    89.0773361,
                    55.3771722
                ],
                [
                    89.0753455,
                    55.3773686
                ],
                [
                    89.075278,
                    55.3775556
                ],
                [
                    89.0739453,
                    55.3780683
                ],
                [
                    89.0726041,
                    55.3780635
                ],
                [
                    89.0724945,
                    55.3778287
                ],
                [
                    89.0722499,
                    55.3777329
                ],
                [
                    89.0705291,
                    55.3783703
                ],
                [
                    89.0693904,
                    55.3784086
                ],
                [
                    89.0679059,
                    55.3789837
                ],
                [
                    89.0674757,
                    55.3792281
                ],
                [
                    89.0666069,
                    55.3792712
                ],
                [
                    89.0665731,
                    55.3794294
                ],
                [
                    89.0667756,
                    55.3796546
                ],
                [
                    89.0667165,
                    55.379784
                ],
                [
                    89.0661056,
                    55.3799532
                ],
                [
                    89.0651963,
                    55.3798259
                ],
                [
                    89.0649195,
                    55.3802003
                ],
                [
                    89.0645505,
                    55.38035
                ],
                [
                    89.0641023,
                    55.3802302
                ],
                [
                    89.0636279,
                    55.3802602
                ],
                [
                    89.0636411,
                    55.3804773
                ],
                [
                    89.0640892,
                    55.3812111
                ],
                [
                    89.0641023,
                    55.3817277
                ],
                [
                    89.0633906,
                    55.3821545
                ]
            ],
            "longitude": 89.0850874,
            "latitude": 55.3843983
        },
        "6250": {
            "name": "Сплавной",
            "population": 150,
            "type": "hamlet",
            "poly": [
                [
                    89.0711309,
                    57.0132003
                ],
                [
                    89.0720002,
                    57.0139102
                ],
                [
                    89.0725797,
                    57.0142454
                ],
                [
                    89.0724348,
                    57.0146989
                ],
                [
                    89.0734489,
                    57.0149749
                ],
                [
                    89.0731954,
                    57.0158622
                ],
                [
                    89.0791352,
                    57.0174002
                ],
                [
                    89.0834814,
                    57.0175382
                ],
                [
                    89.0856545,
                    57.0174396
                ],
                [
                    89.0858355,
                    57.015251
                ],
                [
                    89.0859804,
                    57.0144228
                ],
                [
                    89.0850387,
                    57.0130031
                ],
                [
                    89.0871756,
                    57.0127073
                ],
                [
                    89.0872842,
                    57.0122538
                ],
                [
                    89.088733,
                    57.0122143
                ],
                [
                    89.0888779,
                    57.0119383
                ],
                [
                    89.0932603,
                    57.0125298
                ],
                [
                    89.093876,
                    57.0128453
                ],
                [
                    89.0973166,
                    57.0126284
                ],
                [
                    89.0976427,
                    57.0115241
                ],
                [
                    89.0992725,
                    57.0112283
                ],
                [
                    89.1004315,
                    57.0090591
                ],
                [
                    89.1002503,
                    57.008783
                ],
                [
                    89.1029668,
                    57.0086844
                ],
                [
                    89.1025322,
                    57.007935
                ],
                [
                    89.1010472,
                    57.0072842
                ],
                [
                    89.1002142,
                    57.0072644
                ],
                [
                    89.1000331,
                    57.0067911
                ],
                [
                    89.0949263,
                    57.0069489
                ],
                [
                    89.0932603,
                    57.0058247
                ],
                [
                    89.0913769,
                    57.005805
                ],
                [
                    89.0896022,
                    57.0048188
                ],
                [
                    89.0894936,
                    57.0042074
                ],
                [
                    89.0898196,
                    57.0041679
                ],
                [
                    89.0890228,
                    57.0030437
                ],
                [
                    89.0915943,
                    57.0032212
                ],
                [
                    89.0944555,
                    57.003024
                ],
                [
                    89.0939122,
                    57.0018799
                ],
                [
                    89.0914856,
                    57.001801
                ],
                [
                    89.0911958,
                    57.0004597
                ],
                [
                    89.0877551,
                    57.0001638
                ],
                [
                    89.0876102,
                    57.0012093
                ],
                [
                    89.0807288,
                    57.0009134
                ],
                [
                    89.0806201,
                    57.0014854
                ],
                [
                    89.0798595,
                    57.0015249
                ],
                [
                    89.0789903,
                    57.0007556
                ],
                [
                    89.0773605,
                    57.0008345
                ],
                [
                    89.0768896,
                    57.0011698
                ],
                [
                    89.0777589,
                    57.0030437
                ],
                [
                    89.0775416,
                    57.0038918
                ],
                [
                    89.0794973,
                    57.0052725
                ],
                [
                    89.0804028,
                    57.0070475
                ],
                [
                    89.0770345,
                    57.0077378
                ],
                [
                    89.0753322,
                    57.0084872
                ],
                [
                    89.0750787,
                    57.0090197
                ],
                [
                    89.0730143,
                    57.0090591
                ],
                [
                    89.0716379,
                    57.0112283
                ],
                [
                    89.0728694,
                    57.0117213
                ],
                [
                    89.0716379,
                    57.0121946
                ],
                [
                    89.0711309,
                    57.0132003
                ]
            ],
            "longitude": 89.086296,
            "latitude": 57.008183
        },
        "6251": {
            "name": "Луговатка",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.0960628,
            "latitude": 59.08965
        },
        "6252": {
            "name": "Ивановка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    89.0900269,
                    56.5674007
                ],
                [
                    89.102615,
                    56.5714661
                ],
                [
                    89.1052195,
                    56.5691047
                ],
                [
                    89.0923058,
                    56.565039
                ],
                [
                    89.0900269,
                    56.5674007
                ]
            ],
            "longitude": 89.09716,
            "latitude": 56.568264
        },
        "6253": {
            "name": "Усть-Парная",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    89.1171039,
                    55.4067033
                ],
                [
                    89.1197694,
                    55.4070681
                ],
                [
                    89.1217859,
                    55.4077416
                ],
                [
                    89.1217865,
                    55.4079506
                ],
                [
                    89.1222657,
                    55.4083606
                ],
                [
                    89.1222994,
                    55.4084755
                ],
                [
                    89.1219013,
                    55.4088816
                ],
                [
                    89.1218405,
                    55.4090923
                ],
                [
                    89.1218473,
                    55.4093145
                ],
                [
                    89.1220766,
                    55.4094256
                ],
                [
                    89.1222049,
                    55.409326
                ],
                [
                    89.1230687,
                    55.4093336
                ],
                [
                    89.1232373,
                    55.4092915
                ],
                [
                    89.1238379,
                    55.4094102
                ],
                [
                    89.1242091,
                    55.4095865
                ],
                [
                    89.1244114,
                    55.4095596
                ],
                [
                    89.1244114,
                    55.4096822
                ],
                [
                    89.1246139,
                    55.4097818
                ],
                [
                    89.1249648,
                    55.4098048
                ],
                [
                    89.1248096,
                    55.4099197
                ],
                [
                    89.1248366,
                    55.4099964
                ],
                [
                    89.1252618,
                    55.4100232
                ],
                [
                    89.1254575,
                    55.4098853
                ],
                [
                    89.1254979,
                    55.4098087
                ],
                [
                    89.1259433,
                    55.409847
                ],
                [
                    89.1260715,
                    55.4099887
                ],
                [
                    89.1263542,
                    55.4100433
                ],
                [
                    89.1264959,
                    55.4101429
                ],
                [
                    89.1267051,
                    55.410162
                ],
                [
                    89.1269952,
                    55.4103766
                ],
                [
                    89.1271842,
                    55.4106639
                ],
                [
                    89.1271167,
                    55.4108861
                ],
                [
                    89.1268805,
                    55.4110891
                ],
                [
                    89.1272517,
                    55.4114339
                ],
                [
                    89.127886,
                    55.411725
                ],
                [
                    89.1282571,
                    55.4129967
                ],
                [
                    89.1281154,
                    55.4131232
                ],
                [
                    89.1280884,
                    55.4132381
                ],
                [
                    89.1287025,
                    55.4135675
                ],
                [
                    89.1289454,
                    55.4138701
                ],
                [
                    89.1290196,
                    55.4145021
                ],
                [
                    89.1297484,
                    55.4145979
                ],
                [
                    89.1302815,
                    55.4144447
                ],
                [
                    89.1328525,
                    55.4143068
                ],
                [
                    89.1331156,
                    55.4143872
                ],
                [
                    89.1332977,
                    55.4146055
                ],
                [
                    89.1329334,
                    55.4148966
                ],
                [
                    89.132893,
                    55.4150767
                ],
                [
                    89.1315164,
                    55.4158887
                ],
                [
                    89.1313949,
                    55.4162104
                ],
                [
                    89.1313409,
                    55.4165398
                ],
                [
                    89.1331696,
                    55.4165437
                ],
                [
                    89.13375,
                    55.4164785
                ],
                [
                    89.1341817,
                    55.4161491
                ],
                [
                    89.1342696,
                    55.4161606
                ],
                [
                    89.1342696,
                    55.4163138
                ],
                [
                    89.1356664,
                    55.416153
                ],
                [
                    89.1357811,
                    55.4159959
                ],
                [
                    89.1362062,
                    55.4148277
                ],
                [
                    89.1365706,
                    55.4145366
                ],
                [
                    89.1370362,
                    55.4142302
                ],
                [
                    89.1374951,
                    55.4135407
                ],
                [
                    89.13846,
                    55.4124605
                ],
                [
                    89.1390674,
                    55.4117824
                ],
                [
                    89.1402212,
                    55.4107597
                ],
                [
                    89.1404709,
                    55.4101812
                ],
                [
                    89.1407341,
                    55.4090741
                ],
                [
                    89.1405654,
                    55.4088864
                ],
                [
                    89.1405114,
                    55.4086795
                ],
                [
                    89.1408421,
                    55.4086642
                ],
                [
                    89.14095,
                    55.408622
                ],
                [
                    89.1407544,
                    55.4084267
                ],
                [
                    89.1405587,
                    55.4084152
                ],
                [
                    89.14039,
                    55.4084918
                ],
                [
                    89.1400327,
                    55.4083419
                ],
                [
                    89.1398218,
                    55.4084556
                ],
                [
                    89.1399167,
                    55.4086711
                ],
                [
                    89.1392736,
                    55.4086831
                ],
                [
                    89.1392946,
                    55.4084317
                ],
                [
                    89.1389678,
                    55.4084077
                ],
                [
                    89.1387991,
                    55.4085394
                ],
                [
                    89.1379451,
                    55.4084915
                ],
                [
                    89.1377131,
                    55.4083359
                ],
                [
                    89.1366376,
                    55.4084018
                ],
                [
                    89.1361632,
                    55.4086412
                ],
                [
                    89.1357414,
                    55.4086831
                ],
                [
                    89.1356148,
                    55.4089944
                ],
                [
                    89.133854,
                    55.4088268
                ],
                [
                    89.1330422,
                    55.4085694
                ],
                [
                    89.1309019,
                    55.4079408
                ],
                [
                    89.1296261,
                    55.4073183
                ],
                [
                    89.1304696,
                    55.4065581
                ],
                [
                    89.1318402,
                    55.4058577
                ],
                [
                    89.1330186,
                    55.4056455
                ],
                [
                    89.134948,
                    55.4056934
                ],
                [
                    89.1373942,
                    55.4054899
                ],
                [
                    89.138923,
                    55.4057413
                ],
                [
                    89.1386911,
                    55.4063459
                ],
                [
                    89.1384591,
                    55.4063818
                ],
                [
                    89.1382588,
                    55.4065255
                ],
                [
                    89.1381428,
                    55.4071959
                ],
                [
                    89.1376789,
                    55.407172
                ],
                [
                    89.1375733,
                    55.4077766
                ],
                [
                    89.1382482,
                    55.4077885
                ],
                [
                    89.1424973,
                    55.4082794
                ],
                [
                    89.1434252,
                    55.407579
                ],
                [
                    89.1448591,
                    55.4069026
                ],
                [
                    89.1449857,
                    55.4065255
                ],
                [
                    89.1450911,
                    55.406286
                ],
                [
                    89.1446904,
                    55.405849
                ],
                [
                    89.1424657,
                    55.4057413
                ],
                [
                    89.1428875,
                    55.4048613
                ],
                [
                    89.1421599,
                    55.4048014
                ],
                [
                    89.1419702,
                    55.4050948
                ],
                [
                    89.1412637,
                    55.4051546
                ],
                [
                    89.1405573,
                    55.4051007
                ],
                [
                    89.1394291,
                    55.4050948
                ],
                [
                    89.1389863,
                    55.4053522
                ],
                [
                    89.1384591,
                    55.4053821
                ],
                [
                    89.1381112,
                    55.4052624
                ],
                [
                    89.1368354,
                    55.4043884
                ],
                [
                    89.1364974,
                    55.4039175
                ],
                [
                    89.1359407,
                    55.4037642
                ],
                [
                    89.1354768,
                    55.4037259
                ],
                [
                    89.1351647,
                    55.403793
                ],
                [
                    89.1349454,
                    55.403587
                ],
                [
                    89.1348779,
                    55.4033907
                ],
                [
                    89.134473,
                    55.4033954
                ],
                [
                    89.1341355,
                    55.4021167
                ],
                [
                    89.1341525,
                    55.4017479
                ],
                [
                    89.1343887,
                    55.4015611
                ],
                [
                    89.1343043,
                    55.4002918
                ],
                [
                    89.1344983,
                    55.4002727
                ],
                [
                    89.1346754,
                    55.4003733
                ],
                [
                    89.1348357,
                    55.4006798
                ],
                [
                    89.1348441,
                    55.4007947
                ],
                [
                    89.1365733,
                    55.4007804
                ],
                [
                    89.136354,
                    55.3982083
                ],
                [
                    89.1362359,
                    55.3980454
                ],
                [
                    89.1347935,
                    55.3980214
                ],
                [
                    89.1347176,
                    55.3981795
                ],
                [
                    89.134608,
                    55.3990848
                ],
                [
                    89.1341103,
                    55.3991998
                ],
                [
                    89.1336716,
                    55.3991902
                ],
                [
                    89.1333343,
                    55.3989842
                ],
                [
                    89.1328872,
                    55.3988645
                ],
                [
                    89.1321871,
                    55.3988884
                ],
                [
                    89.1319678,
                    55.3989363
                ],
                [
                    89.1317232,
                    55.3991519
                ],
                [
                    89.1315883,
                    55.3995063
                ],
                [
                    89.1314196,
                    55.4001529
                ],
                [
                    89.1310062,
                    55.4005601
                ],
                [
                    89.1307701,
                    55.401312
                ],
                [
                    89.1310737,
                    55.401427
                ],
                [
                    89.1311496,
                    55.402246
                ],
                [
                    89.1316219,
                    55.4044299
                ],
                [
                    89.1290915,
                    55.4053734
                ],
                [
                    89.12786,
                    55.4061348
                ],
                [
                    89.1262742,
                    55.4068005
                ],
                [
                    89.1254658,
                    55.4071899
                ],
                [
                    89.1250441,
                    55.4070103
                ],
                [
                    89.1235942,
                    55.4069205
                ],
                [
                    89.1226322,
                    55.4066137
                ],
                [
                    89.1210902,
                    55.4062994
                ],
                [
                    89.1192978,
                    55.4062321
                ],
                [
                    89.1174394,
                    55.4063817
                ],
                [
                    89.1171039,
                    55.4067033
                ]
            ],
            "longitude": 89.132088,
            "latitude": 55.410786
        },
        "6254": {
            "name": "Волынка",
            "population": 37,
            "type": "hamlet",
            "poly": [
                [
                    89.1474008,
                    56.3697245
                ],
                [
                    89.1519682,
                    56.3714609
                ],
                [
                    89.1522779,
                    56.3720397
                ],
                [
                    89.1542133,
                    56.3727256
                ],
                [
                    89.1556455,
                    56.372747
                ],
                [
                    89.1566906,
                    56.3734544
                ],
                [
                    89.1588194,
                    56.3741189
                ],
                [
                    89.1615677,
                    56.3745904
                ],
                [
                    89.1631158,
                    56.3743975
                ],
                [
                    89.1646255,
                    56.3741189
                ],
                [
                    89.1681866,
                    56.3739045
                ],
                [
                    89.1668705,
                    56.3748477
                ],
                [
                    89.1690381,
                    56.3754049
                ],
                [
                    89.169967,
                    56.3758765
                ],
                [
                    89.1711283,
                    56.3761123
                ],
                [
                    89.1712444,
                    56.3758122
                ],
                [
                    89.1719799,
                    56.3759622
                ],
                [
                    89.1729088,
                    56.3748048
                ],
                [
                    89.1728314,
                    56.3743118
                ],
                [
                    89.1683414,
                    56.3736473
                ],
                [
                    89.164446,
                    56.3738815
                ],
                [
                    89.1636215,
                    56.3738815
                ],
                [
                    89.1642399,
                    56.3730738
                ],
                [
                    89.1641765,
                    56.3726875
                ],
                [
                    89.16248,
                    56.3719938
                ],
                [
                    89.1629715,
                    56.3711685
                ],
                [
                    89.1633679,
                    56.3703256
                ],
                [
                    89.163241,
                    56.3696495
                ],
                [
                    89.1613861,
                    56.3687099
                ],
                [
                    89.1602445,
                    56.3680952
                ],
                [
                    89.1591189,
                    56.3678581
                ],
                [
                    89.1571371,
                    56.3671117
                ],
                [
                    89.1547906,
                    56.3666551
                ],
                [
                    89.1539811,
                    56.3667446
                ],
                [
                    89.1530134,
                    56.3671305
                ],
                [
                    89.1498007,
                    56.3679452
                ],
                [
                    89.1474008,
                    56.3697245
                ]
            ],
            "longitude": 89.157761,
            "latitude": 56.3713
        },
        "6255": {
            "name": "Романовка",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    89.142548,
                    56.4337514
                ],
                [
                    89.1433361,
                    56.4353887
                ],
                [
                    89.144269,
                    56.4357978
                ],
                [
                    89.1460704,
                    56.4362779
                ],
                [
                    89.1465207,
                    56.436687
                ],
                [
                    89.1474214,
                    56.436847
                ],
                [
                    89.1483221,
                    56.4373094
                ],
                [
                    89.1545626,
                    56.4381986
                ],
                [
                    89.1571682,
                    56.4387499
                ],
                [
                    89.1574899,
                    56.4385365
                ],
                [
                    89.1597095,
                    56.4393545
                ],
                [
                    89.1613178,
                    56.4400658
                ],
                [
                    89.1675262,
                    56.4417018
                ],
                [
                    89.167108,
                    56.4427509
                ],
                [
                    89.1722227,
                    56.4436222
                ],
                [
                    89.1731877,
                    56.4435688
                ],
                [
                    89.1739276,
                    56.4424664
                ],
                [
                    89.1688451,
                    56.4398168
                ],
                [
                    89.1628297,
                    56.4378963
                ],
                [
                    89.1614465,
                    56.437096
                ],
                [
                    89.1604815,
                    56.4371138
                ],
                [
                    89.1560424,
                    56.4352464
                ],
                [
                    89.1550452,
                    56.4352464
                ],
                [
                    89.150027,
                    56.4341615
                ],
                [
                    89.1472927,
                    56.4335746
                ],
                [
                    89.1455557,
                    56.4336458
                ],
                [
                    89.1445263,
                    56.4341082
                ],
                [
                    89.143883,
                    56.4340548
                ],
                [
                    89.1434005,
                    56.4337703
                ],
                [
                    89.142548,
                    56.4337514
                ]
            ],
            "longitude": 89.158012,
            "latitude": 56.437157
        },
        "6256": {
            "name": "Никольск",
            "population": 196,
            "type": "hamlet",
            "poly": [
                [
                    89.148257,
                    55.6867575
                ],
                [
                    89.1503643,
                    55.688275
                ],
                [
                    89.1498803,
                    55.6883603
                ],
                [
                    89.1493359,
                    55.6885649
                ],
                [
                    89.1491645,
                    55.6888548
                ],
                [
                    89.1491443,
                    55.6897585
                ],
                [
                    89.1493258,
                    55.6900597
                ],
                [
                    89.1495879,
                    55.690287
                ],
                [
                    89.1501123,
                    55.6906394
                ],
                [
                    89.1506971,
                    55.6915373
                ],
                [
                    89.1508685,
                    55.6915885
                ],
                [
                    89.1511608,
                    55.6915203
                ],
                [
                    89.1514533,
                    55.6918045
                ],
                [
                    89.1519473,
                    55.6916908
                ],
                [
                    89.1523203,
                    55.6920602
                ],
                [
                    89.1518768,
                    55.6921511
                ],
                [
                    89.1532177,
                    55.6930945
                ],
                [
                    89.1538631,
                    55.6927819
                ],
                [
                    89.1550731,
                    55.6937708
                ],
                [
                    89.1552646,
                    55.6937822
                ],
                [
                    89.1554764,
                    55.6944698
                ],
                [
                    89.1551336,
                    55.6944925
                ],
                [
                    89.155184,
                    55.6947312
                ],
                [
                    89.1555872,
                    55.6948903
                ],
                [
                    89.1559704,
                    55.6952597
                ],
                [
                    89.1560108,
                    55.695612
                ],
                [
                    89.1561923,
                    55.6957882
                ],
                [
                    89.1558999,
                    55.6959075
                ],
                [
                    89.1558192,
                    55.6964814
                ],
                [
                    89.1560209,
                    55.6969531
                ],
                [
                    89.1559906,
                    55.6973508
                ],
                [
                    89.1563132,
                    55.6977713
                ],
                [
                    89.1568477,
                    55.6979304
                ],
                [
                    89.1570896,
                    55.6977429
                ],
                [
                    89.1576644,
                    55.697993
                ],
                [
                    89.1576543,
                    55.6982543
                ],
                [
                    89.1578861,
                    55.6984703
                ],
                [
                    89.160054,
                    55.6991351
                ],
                [
                    89.1607195,
                    55.6992658
                ],
                [
                    89.1611127,
                    55.6992146
                ],
                [
                    89.1624538,
                    55.6989703
                ],
                [
                    89.1622521,
                    55.6996692
                ],
                [
                    89.1619597,
                    55.6996749
                ],
                [
                    89.161758,
                    55.7000101
                ],
                [
                    89.1619093,
                    55.700084
                ],
                [
                    89.1625546,
                    55.7001692
                ],
                [
                    89.1628873,
                    55.700101
                ],
                [
                    89.1628268,
                    55.7002828
                ],
                [
                    89.1622319,
                    55.7005044
                ],
                [
                    89.1620908,
                    55.7009533
                ],
                [
                    89.162605,
                    55.7010101
                ],
                [
                    89.1624032,
                    55.7017999
                ],
                [
                    89.1609514,
                    55.7018169
                ],
                [
                    89.1608707,
                    55.7025215
                ],
                [
                    89.1616673,
                    55.7027601
                ],
                [
                    89.1628772,
                    55.7025328
                ],
                [
                    89.1638956,
                    55.702584
                ],
                [
                    89.1644703,
                    55.702459
                ],
                [
                    89.1652568,
                    55.7019135
                ],
                [
                    89.1656097,
                    55.7015044
                ],
                [
                    89.1658517,
                    55.7014192
                ],
                [
                    89.1670716,
                    55.7015329
                ],
                [
                    89.1688463,
                    55.7015669
                ],
                [
                    89.1695521,
                    55.7015215
                ],
                [
                    89.1705504,
                    55.7016181
                ],
                [
                    89.1711049,
                    55.7015499
                ],
                [
                    89.1715385,
                    55.7012317
                ],
                [
                    89.1717502,
                    55.7005897
                ],
                [
                    89.1723552,
                    55.7006351
                ],
                [
                    89.1727283,
                    55.7003056
                ],
                [
                    89.1727585,
                    55.699351
                ],
                [
                    89.1721534,
                    55.6992544
                ],
                [
                    89.171357,
                    55.6988169
                ],
                [
                    89.1688262,
                    55.69751
                ],
                [
                    89.1679489,
                    55.6968678
                ],
                [
                    89.1680095,
                    55.6960382
                ],
                [
                    89.1681607,
                    55.6955097
                ],
                [
                    89.1683523,
                    55.6947482
                ],
                [
                    89.168211,
                    55.693606
                ],
                [
                    89.1686648,
                    55.6930263
                ],
                [
                    89.170016,
                    55.6932082
                ],
                [
                    89.1717502,
                    55.6935492
                ],
                [
                    89.1703588,
                    55.6927876
                ],
                [
                    89.1703991,
                    55.6926967
                ],
                [
                    89.1708831,
                    55.6927876
                ],
                [
                    89.1712158,
                    55.6924069
                ],
                [
                    89.1709234,
                    55.692117
                ],
                [
                    89.1705567,
                    55.6919661
                ],
                [
                    89.1702101,
                    55.691451
                ],
                [
                    89.169714,
                    55.6912011
                ],
                [
                    89.1678556,
                    55.6904373
                ],
                [
                    89.16601,
                    55.6896662
                ],
                [
                    89.1638224,
                    55.6886949
                ],
                [
                    89.1629706,
                    55.6881093
                ],
                [
                    89.1621446,
                    55.6873272
                ],
                [
                    89.1614218,
                    55.6867997
                ],
                [
                    89.1601829,
                    55.6864505
                ],
                [
                    89.1591246,
                    55.6864869
                ],
                [
                    89.1583889,
                    55.6869525
                ],
                [
                    89.1578906,
                    55.687084
                ],
                [
                    89.1507695,
                    55.6853344
                ],
                [
                    89.1496989,
                    55.6848817
                ],
                [
                    89.1485696,
                    55.685723
                ],
                [
                    89.1485393,
                    55.6866608
                ],
                [
                    89.148257,
                    55.6867575
                ]
            ],
            "longitude": 89.160515,
            "latitude": 55.696865
        },
        "6257": {
            "name": "Оскаровка",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    89.1654329,
                    56.430589
                ],
                [
                    89.166295,
                    56.4311107
                ],
                [
                    89.1667068,
                    56.4317595
                ],
                [
                    89.1673038,
                    56.4317709
                ],
                [
                    89.1678596,
                    56.4321352
                ],
                [
                    89.1681128,
                    56.4328941
                ],
                [
                    89.1688067,
                    56.43308
                ],
                [
                    89.1697331,
                    56.433319
                ],
                [
                    89.1702684,
                    56.4328865
                ],
                [
                    89.1709272,
                    56.4328865
                ],
                [
                    89.1714007,
                    56.4331938
                ],
                [
                    89.1716889,
                    56.4336947
                ],
                [
                    89.1723065,
                    56.4341158
                ],
                [
                    89.1723887,
                    56.4349695
                ],
                [
                    89.1735623,
                    56.4357549
                ],
                [
                    89.1747152,
                    56.4369386
                ],
                [
                    89.1791473,
                    56.4382532
                ],
                [
                    89.1833291,
                    56.4383421
                ],
                [
                    89.1851787,
                    56.4381865
                ],
                [
                    89.1863448,
                    56.4382309
                ],
                [
                    89.1883553,
                    56.4378975
                ],
                [
                    89.1892399,
                    56.4383199
                ],
                [
                    89.1893203,
                    56.4386088
                ],
                [
                    89.1905266,
                    56.43872
                ],
                [
                    89.1922154,
                    56.4395647
                ],
                [
                    89.1935423,
                    56.4399203
                ],
                [
                    89.1949898,
                    56.4396091
                ],
                [
                    89.1954903,
                    56.4384915
                ],
                [
                    89.1949962,
                    56.4375264
                ],
                [
                    89.1910764,
                    56.4358146
                ],
                [
                    89.1910105,
                    56.4352591
                ],
                [
                    89.1902529,
                    56.4353775
                ],
                [
                    89.1895118,
                    56.4354685
                ],
                [
                    89.1885565,
                    56.4352227
                ],
                [
                    89.1877495,
                    56.4345671
                ],
                [
                    89.1870907,
                    56.4342848
                ],
                [
                    89.1847849,
                    56.4338568
                ],
                [
                    89.1821662,
                    56.4338932
                ],
                [
                    89.1809968,
                    56.4332102
                ],
                [
                    89.1807004,
                    56.4324271
                ],
                [
                    89.1811945,
                    56.4310247
                ],
                [
                    89.1815074,
                    56.4298225
                ],
                [
                    89.1813921,
                    56.4285657
                ],
                [
                    89.1807663,
                    56.4273089
                ],
                [
                    89.1784276,
                    56.4264436
                ],
                [
                    89.1778182,
                    56.4266076
                ],
                [
                    89.1772911,
                    56.4273635
                ],
                [
                    89.1771593,
                    56.4280011
                ],
                [
                    89.1748536,
                    56.4297315
                ],
                [
                    89.1744913,
                    56.4297588
                ],
                [
                    89.172729,
                    56.429185
                ],
                [
                    89.1702256,
                    56.4288207
                ],
                [
                    89.1682821,
                    56.4294127
                ],
                [
                    89.1676444,
                    56.4291215
                ],
                [
                    89.1670412,
                    56.4296996
                ],
                [
                    89.1654329,
                    56.430589
                ]
            ],
            "longitude": 89.175179,
            "latitude": 56.432411
        },
        "6258": {
            "name": "Лебедь",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.184847,
            "latitude": 62.0900233
        },
        "6259": {
            "name": "Усть-Тойловка",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    89.1776148,
                    56.6804205
                ],
                [
                    89.1956556,
                    56.6844076
                ],
                [
                    89.198245,
                    56.6817962
                ],
                [
                    89.1796523,
                    56.678042
                ],
                [
                    89.1776148,
                    56.6804205
                ]
            ],
            "longitude": 89.187943,
            "latitude": 56.680962
        },
        "6260": {
            "name": "Тузлуковка",
            "population": 18,
            "type": "hamlet",
            "poly": [
                [
                    89.1932554,
                    56.2025774
                ],
                [
                    89.194248,
                    56.2036757
                ],
                [
                    89.1950484,
                    56.2057832
                ],
                [
                    89.1997872,
                    56.2102946
                ],
                [
                    89.2030317,
                    56.2092974
                ],
                [
                    89.1994883,
                    56.205617
                ],
                [
                    89.198976,
                    56.2047621
                ],
                [
                    89.1994883,
                    56.2045722
                ],
                [
                    89.1992322,
                    56.2039548
                ],
                [
                    89.1983784,
                    56.2040972
                ],
                [
                    89.1980368,
                    56.2035511
                ],
                [
                    89.1985918,
                    56.2024587
                ],
                [
                    89.200641,
                    56.2027199
                ],
                [
                    89.2037148,
                    56.2023875
                ],
                [
                    89.203544,
                    56.2005826
                ],
                [
                    89.2010252,
                    56.2006064
                ],
                [
                    89.1997018,
                    56.1997277
                ],
                [
                    89.200086,
                    56.1966401
                ],
                [
                    89.1998726,
                    56.1951913
                ],
                [
                    89.1984637,
                    56.1949775
                ],
                [
                    89.198421,
                    56.1942887
                ],
                [
                    89.1973965,
                    56.1939562
                ],
                [
                    89.1969695,
                    56.195025
                ],
                [
                    89.195945,
                    56.1954051
                ],
                [
                    89.1935969,
                    56.1993239
                ],
                [
                    89.1932554,
                    56.2025774
                ]
            ],
            "longitude": 89.1968,
            "latitude": 56.201591
        },
        "6261": {
            "name": "Дмитриевка",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    89.2126258,
                    56.1829833
                ],
                [
                    89.217828,
                    56.1834456
                ],
                [
                    89.2190083,
                    56.1819371
                ],
                [
                    89.2188116,
                    56.1805503
                ],
                [
                    89.2145274,
                    56.1804773
                ],
                [
                    89.2136313,
                    56.1809152
                ],
                [
                    89.2128007,
                    56.1818155
                ],
                [
                    89.2126258,
                    56.1829833
                ]
            ],
            "longitude": 89.215904,
            "latitude": 56.181992
        },
        "6262": {
            "name": "Берёзовка",
            "population": 110,
            "type": "hamlet",
            "poly": [
                [
                    89.1922216,
                    56.3858923
                ],
                [
                    89.1931856,
                    56.3866366
                ],
                [
                    89.1929446,
                    56.3867981
                ],
                [
                    89.1931999,
                    56.3870891
                ],
                [
                    89.1935565,
                    56.3870671
                ],
                [
                    89.1962122,
                    56.3888992
                ],
                [
                    89.1970446,
                    56.3891296
                ],
                [
                    89.2005722,
                    56.3910164
                ],
                [
                    89.2004334,
                    56.3912468
                ],
                [
                    89.2015433,
                    56.3918721
                ],
                [
                    89.2019396,
                    56.391883
                ],
                [
                    89.2024747,
                    56.3922779
                ],
                [
                    89.2031485,
                    56.3923986
                ],
                [
                    89.2041394,
                    56.391905
                ],
                [
                    89.2041791,
                    56.3914004
                ],
                [
                    89.2057447,
                    56.390797
                ],
                [
                    89.2090741,
                    56.3900401
                ],
                [
                    89.2129783,
                    56.3899414
                ],
                [
                    89.2149204,
                    56.3913455
                ],
                [
                    89.2140286,
                    56.3920914
                ],
                [
                    89.2146826,
                    56.39366
                ],
                [
                    89.2160698,
                    56.3946582
                ],
                [
                    89.2181508,
                    56.3968738
                ],
                [
                    89.2201721,
                    56.3973893
                ],
                [
                    89.2212424,
                    56.3967641
                ],
                [
                    89.2226891,
                    56.396479
                ],
                [
                    89.2228477,
                    56.3960512
                ],
                [
                    89.2216586,
                    56.3945595
                ],
                [
                    89.2216586,
                    56.3938904
                ],
                [
                    89.2207668,
                    56.3930019
                ],
                [
                    89.2225108,
                    56.3929251
                ],
                [
                    89.2230855,
                    56.392267
                ],
                [
                    89.2233828,
                    56.3916636
                ],
                [
                    89.2221772,
                    56.3914185
                ],
                [
                    89.2229699,
                    56.3903764
                ],
                [
                    89.2214587,
                    56.389444
                ],
                [
                    89.2170493,
                    56.3878395
                ],
                [
                    89.2142004,
                    56.3873184
                ],
                [
                    89.2090477,
                    56.3874418
                ],
                [
                    89.2077595,
                    56.3878258
                ],
                [
                    89.2058768,
                    56.3855082
                ],
                [
                    89.2054062,
                    56.3855356
                ],
                [
                    89.2029784,
                    56.3833139
                ],
                [
                    89.2009966,
                    56.3835882
                ],
                [
                    89.1990148,
                    56.384315
                ],
                [
                    89.2022353,
                    56.3874007
                ],
                [
                    89.200625,
                    56.3880452
                ],
                [
                    89.1974788,
                    56.3862899
                ],
                [
                    89.1949026,
                    56.384411
                ],
                [
                    89.1936549,
                    56.3847899
                ],
                [
                    89.1939212,
                    56.3851972
                ],
                [
                    89.1922216,
                    56.3858923
                ]
            ],
            "longitude": 89.217407,
            "latitude": 56.390244
        },
        "6263": {
            "name": "Косые Ложки",
            "population": 135,
            "type": "hamlet",
            "poly": [
                [
                    89.2030695,
                    55.3777818
                ],
                [
                    89.2035642,
                    55.3782843
                ],
                [
                    89.2069519,
                    55.380192
                ],
                [
                    89.2084697,
                    55.3809142
                ],
                [
                    89.2096389,
                    55.3801477
                ],
                [
                    89.2117224,
                    55.3807524
                ],
                [
                    89.2128168,
                    55.3812037
                ],
                [
                    89.2135063,
                    55.3815614
                ],
                [
                    89.2149753,
                    55.3820212
                ],
                [
                    89.2166842,
                    55.3823959
                ],
                [
                    89.2170128,
                    55.3821276
                ],
                [
                    89.2173339,
                    55.3821347
                ],
                [
                    89.2174579,
                    55.3821014
                ],
                [
                    89.2178193,
                    55.3816917
                ],
                [
                    89.2207428,
                    55.3791146
                ],
                [
                    89.2222087,
                    55.3776931
                ],
                [
                    89.2226768,
                    55.3767381
                ],
                [
                    89.222792,
                    55.376193
                ],
                [
                    89.221848,
                    55.3728569
                ],
                [
                    89.220935,
                    55.3697621
                ],
                [
                    89.2202442,
                    55.3685627
                ],
                [
                    89.2191602,
                    55.367156
                ],
                [
                    89.2190109,
                    55.3671776
                ],
                [
                    89.2185846,
                    55.3672542
                ],
                [
                    89.2182296,
                    55.3674886
                ],
                [
                    89.2185846,
                    55.3689498
                ],
                [
                    89.2177403,
                    55.3688952
                ],
                [
                    89.2169153,
                    55.3686281
                ],
                [
                    89.2160039,
                    55.3685354
                ],
                [
                    89.215553,
                    55.3683173
                ],
                [
                    89.2150925,
                    55.3680665
                ],
                [
                    89.2148622,
                    55.3680774
                ],
                [
                    89.2144497,
                    55.3683991
                ],
                [
                    89.2144689,
                    55.368579
                ],
                [
                    89.2143442,
                    55.3687044
                ],
                [
                    89.2150349,
                    55.3693096
                ],
                [
                    89.2148143,
                    55.3696585
                ],
                [
                    89.2150061,
                    55.3697457
                ],
                [
                    89.2154091,
                    55.3697675
                ],
                [
                    89.2156681,
                    55.3699257
                ],
                [
                    89.2156012,
                    55.370099
                ],
                [
                    89.2159909,
                    55.3702608
                ],
                [
                    89.2160359,
                    55.3704482
                ],
                [
                    89.2163207,
                    55.370593
                ],
                [
                    89.2164106,
                    55.3707549
                ],
                [
                    89.2155562,
                    55.3704482
                ],
                [
                    89.2141172,
                    55.3702097
                ],
                [
                    89.2135775,
                    55.3702523
                ],
                [
                    89.2118387,
                    55.3697668
                ],
                [
                    89.2095001,
                    55.3715386
                ],
                [
                    89.2088257,
                    55.3722541
                ],
                [
                    89.2086308,
                    55.3727481
                ],
                [
                    89.2079113,
                    55.3728759
                ],
                [
                    89.2054529,
                    55.3743409
                ],
                [
                    89.2051082,
                    55.3753289
                ],
                [
                    89.2057827,
                    55.3756952
                ],
                [
                    89.2071168,
                    55.3757718
                ],
                [
                    89.2075514,
                    55.3759592
                ],
                [
                    89.2066071,
                    55.3763595
                ],
                [
                    89.2063973,
                    55.3766661
                ],
                [
                    89.2060076,
                    55.3767598
                ],
                [
                    89.2055279,
                    55.3765043
                ],
                [
                    89.2045386,
                    55.376828
                ],
                [
                    89.2034443,
                    55.377092
                ],
                [
                    89.2031894,
                    55.3774071
                ],
                [
                    89.2030695,
                    55.3777818
                ]
            ],
            "longitude": 89.218155,
            "latitude": 55.377697
        },
        "6264": {
            "name": "Скворцово",
            "population": 190,
            "type": "hamlet",
            "poly": [
                [
                    89.2079852,
                    55.6351341
                ],
                [
                    89.2081658,
                    55.635389
                ],
                [
                    89.2087828,
                    55.6356268
                ],
                [
                    89.2103629,
                    55.6367141
                ],
                [
                    89.2121538,
                    55.639602
                ],
                [
                    89.2149761,
                    55.6368471
                ],
                [
                    89.2212955,
                    55.6338276
                ],
                [
                    89.2239114,
                    55.6352876
                ],
                [
                    89.2254104,
                    55.6359678
                ],
                [
                    89.2266155,
                    55.6358517
                ],
                [
                    89.2272916,
                    55.6354867
                ],
                [
                    89.2285554,
                    55.6357853
                ],
                [
                    89.230002,
                    55.6357746
                ],
                [
                    89.22782,
                    55.6350738
                ],
                [
                    89.2259577,
                    55.634373
                ],
                [
                    89.2257132,
                    55.633927
                ],
                [
                    89.2268607,
                    55.6325147
                ],
                [
                    89.2246068,
                    55.6298752
                ],
                [
                    89.2213737,
                    55.6269049
                ],
                [
                    89.2248226,
                    55.625531
                ],
                [
                    89.2279676,
                    55.6237553
                ],
                [
                    89.2292609,
                    55.6224774
                ],
                [
                    89.2301425,
                    55.6221288
                ],
                [
                    89.2279088,
                    55.6206019
                ],
                [
                    89.2253223,
                    55.6195397
                ],
                [
                    89.2250576,
                    55.6186102
                ],
                [
                    89.2178859,
                    55.6177471
                ],
                [
                    89.2175038,
                    55.6189256
                ],
                [
                    89.2152112,
                    55.6227429
                ],
                [
                    89.2152994,
                    55.6233238
                ],
                [
                    89.2177096,
                    55.623805
                ],
                [
                    89.2182093,
                    55.6240706
                ],
                [
                    89.217592,
                    55.6250995
                ],
                [
                    89.2148291,
                    55.6266096
                ],
                [
                    89.2115959,
                    55.6284184
                ],
                [
                    89.2109493,
                    55.6295467
                ],
                [
                    89.2098211,
                    55.6309291
                ],
                [
                    89.2099265,
                    55.6316427
                ],
                [
                    89.2092794,
                    55.633775
                ],
                [
                    89.2089333,
                    55.6342082
                ],
                [
                    89.2082109,
                    55.6346329
                ],
                [
                    89.2079852,
                    55.6351341
                ]
            ],
            "longitude": 89.218193,
            "latitude": 55.632961
        },
        "6265": {
            "name": "Соловьёвка",
            "population": 164,
            "type": "hamlet",
            "poly": [
                [
                    89.2054764,
                    56.5760237
                ],
                [
                    89.2058218,
                    56.5772399
                ],
                [
                    89.207322,
                    56.5773317
                ],
                [
                    89.2067941,
                    56.5781121
                ],
                [
                    89.2078219,
                    56.578311
                ],
                [
                    89.2162117,
                    56.5792597
                ],
                [
                    89.2188231,
                    56.5801931
                ],
                [
                    89.2199621,
                    56.5796728
                ],
                [
                    89.2236014,
                    56.5794127
                ],
                [
                    89.2232402,
                    56.5786477
                ],
                [
                    89.2231847,
                    56.5779285
                ],
                [
                    89.2235458,
                    56.5773623
                ],
                [
                    89.2254349,
                    56.5769492
                ],
                [
                    89.2270184,
                    56.5772858
                ],
                [
                    89.2279352,
                    56.5782192
                ],
                [
                    89.2282685,
                    56.5798105
                ],
                [
                    89.2306577,
                    56.5798717
                ],
                [
                    89.2328245,
                    56.5788313
                ],
                [
                    89.2353526,
                    56.5780356
                ],
                [
                    89.2363527,
                    56.5785865
                ],
                [
                    89.2367694,
                    56.5797799
                ],
                [
                    89.2387974,
                    56.5797034
                ],
                [
                    89.2389917,
                    56.5787701
                ],
                [
                    89.2379361,
                    56.5772705
                ],
                [
                    89.235047,
                    56.5771328
                ],
                [
                    89.2339635,
                    56.5769186
                ],
                [
                    89.2332413,
                    56.5761994
                ],
                [
                    89.2332968,
                    56.5755108
                ],
                [
                    89.2349359,
                    56.5748221
                ],
                [
                    89.2357415,
                    56.5738886
                ],
                [
                    89.2357415,
                    56.5727868
                ],
                [
                    89.2347692,
                    56.5725878
                ],
                [
                    89.2331023,
                    56.5726491
                ],
                [
                    89.2317967,
                    56.571486
                ],
                [
                    89.2287963,
                    56.5704146
                ],
                [
                    89.227435,
                    56.5706595
                ],
                [
                    89.2241848,
                    56.5699096
                ],
                [
                    89.2236569,
                    56.5699708
                ],
                [
                    89.2230736,
                    56.5724501
                ],
                [
                    89.2242681,
                    56.5742559
                ],
                [
                    89.2236847,
                    56.5750211
                ],
                [
                    89.2231569,
                    56.5739193
                ],
                [
                    89.2211567,
                    56.5732765
                ],
                [
                    89.2178786,
                    56.572695
                ],
                [
                    89.2168229,
                    56.5731694
                ],
                [
                    89.2147116,
                    56.575878
                ],
                [
                    89.2125169,
                    56.5762912
                ],
                [
                    89.2079609,
                    56.5763983
                ],
                [
                    89.2071275,
                    56.5759392
                ],
                [
                    89.2054764,
                    56.5760237
                ]
            ],
            "longitude": 89.226501,
            "latitude": 56.575649
        },
        "6266": {
            "name": "Сартачуль",
            "population": 78,
            "type": "hamlet",
            "poly": [
                [
                    89.2120315,
                    55.2451918
                ],
                [
                    89.2131324,
                    55.2457597
                ],
                [
                    89.2130276,
                    55.2462079
                ],
                [
                    89.2132373,
                    55.2463524
                ],
                [
                    89.2129839,
                    55.2464371
                ],
                [
                    89.2133596,
                    55.2475029
                ],
                [
                    89.2142683,
                    55.2479861
                ],
                [
                    89.2147489,
                    55.2481703
                ],
                [
                    89.2155964,
                    55.2483895
                ],
                [
                    89.2163828,
                    55.2487232
                ],
                [
                    89.2170731,
                    55.2492013
                ],
                [
                    89.2175536,
                    55.2492262
                ],
                [
                    89.2175624,
                    55.2494802
                ],
                [
                    89.2183837,
                    55.2498388
                ],
                [
                    89.2175274,
                    55.2502821
                ],
                [
                    89.2178376,
                    55.2505795
                ],
                [
                    89.2186464,
                    55.2505897
                ],
                [
                    89.219151,
                    55.2503592
                ],
                [
                    89.2199026,
                    55.2508039
                ],
                [
                    89.2206112,
                    55.2511201
                ],
                [
                    89.2213377,
                    55.2515892
                ],
                [
                    89.2232524,
                    55.2519095
                ],
                [
                    89.2234886,
                    55.2519156
                ],
                [
                    89.2240433,
                    55.2522767
                ],
                [
                    89.223417,
                    55.252599
                ],
                [
                    89.223596,
                    55.2527479
                ],
                [
                    89.2232309,
                    55.2528621
                ],
                [
                    89.2232238,
                    55.2530273
                ],
                [
                    89.223553,
                    55.2533578
                ],
                [
                    89.2239181,
                    55.2536066
                ],
                [
                    89.2241543,
                    55.253576
                ],
                [
                    89.2243654,
                    55.253525
                ],
                [
                    89.2244621,
                    55.2537372
                ],
                [
                    89.2246124,
                    55.2538881
                ],
                [
                    89.2245945,
                    55.2544286
                ],
                [
                    89.2243261,
                    55.2545979
                ],
                [
                    89.2240147,
                    55.2551466
                ],
                [
                    89.2238107,
                    55.255318
                ],
                [
                    89.2234779,
                    55.2557361
                ],
                [
                    89.2224149,
                    55.2562215
                ],
                [
                    89.2220764,
                    55.2563248
                ],
                [
                    89.2220893,
                    55.2563867
                ],
                [
                    89.2226762,
                    55.25666
                ],
                [
                    89.2227263,
                    55.2571944
                ],
                [
                    89.2225903,
                    55.2575534
                ],
                [
                    89.2223469,
                    55.2579429
                ],
                [
                    89.2222145,
                    55.2584039
                ],
                [
                    89.2226118,
                    55.2587955
                ],
                [
                    89.2223613,
                    55.2590076
                ],
                [
                    89.2219464,
                    55.259574
                ],
                [
                    89.2218342,
                    55.2598312
                ],
                [
                    89.2215067,
                    55.2599421
                ],
                [
                    89.2219487,
                    55.2602658
                ],
                [
                    89.2226153,
                    55.2603402
                ],
                [
                    89.2231925,
                    55.2601118
                ],
                [
                    89.2235292,
                    55.2594827
                ],
                [
                    89.2238086,
                    55.2589932
                ],
                [
                    89.2240331,
                    55.2584137
                ],
                [
                    89.2245462,
                    55.2577375
                ],
                [
                    89.2252516,
                    55.2569112
                ],
                [
                    89.2255998,
                    55.2565301
                ],
                [
                    89.2260029,
                    55.2562298
                ],
                [
                    89.2263167,
                    55.2561855
                ],
                [
                    89.2265389,
                    55.2560732
                ],
                [
                    89.2288399,
                    55.2568358
                ],
                [
                    89.2306293,
                    55.2571393
                ],
                [
                    89.2314997,
                    55.2570805
                ],
                [
                    89.2366509,
                    55.2572221
                ],
                [
                    89.2372464,
                    55.2567734
                ],
                [
                    89.2383401,
                    55.2563981
                ],
                [
                    89.2396097,
                    55.2545714
                ],
                [
                    89.239332,
                    55.2537441
                ],
                [
                    89.2356951,
                    55.2511151
                ],
                [
                    89.2348883,
                    55.2501193
                ],
                [
                    89.2335602,
                    55.249178
                ],
                [
                    89.2328438,
                    55.2495274
                ],
                [
                    89.2321495,
                    55.2499497
                ],
                [
                    89.2295727,
                    55.2490765
                ],
                [
                    89.2292544,
                    55.2490866
                ],
                [
                    89.2291504,
                    55.2491377
                ],
                [
                    89.228721,
                    55.2495641
                ],
                [
                    89.2283631,
                    55.2497151
                ],
                [
                    89.2268886,
                    55.2500415
                ],
                [
                    89.226684,
                    55.2501737
                ],
                [
                    89.2257714,
                    55.2503267
                ],
                [
                    89.2255459,
                    55.2504429
                ],
                [
                    89.2254314,
                    55.2507469
                ],
                [
                    89.2251809,
                    55.2507856
                ],
                [
                    89.2249948,
                    55.2509978
                ],
                [
                    89.2248158,
                    55.2509856
                ],
                [
                    89.2245832,
                    55.2507673
                ],
                [
                    89.2246154,
                    55.2506918
                ],
                [
                    89.2248659,
                    55.2505878
                ],
                [
                    89.2250413,
                    55.2502287
                ],
                [
                    89.2250305,
                    55.2500125
                ],
                [
                    89.2247836,
                    55.2499595
                ],
                [
                    89.2245581,
                    55.2497779
                ],
                [
                    89.2240285,
                    55.2495617
                ],
                [
                    89.2240249,
                    55.2493964
                ],
                [
                    89.2242611,
                    55.249121
                ],
                [
                    89.2234236,
                    55.2485417
                ],
                [
                    89.2233556,
                    55.2483254
                ],
                [
                    89.2231194,
                    55.2480051
                ],
                [
                    89.2227257,
                    55.2477828
                ],
                [
                    89.2227078,
                    55.2475971
                ],
                [
                    89.2225146,
                    55.2474094
                ],
                [
                    89.2224681,
                    55.2472503
                ],
                [
                    89.2225719,
                    55.2471157
                ],
                [
                    89.2225468,
                    55.2469647
                ],
                [
                    89.2218239,
                    55.2464526
                ],
                [
                    89.2216056,
                    55.2463159
                ],
                [
                    89.2215268,
                    55.2461262
                ],
                [
                    89.2216056,
                    55.2459528
                ],
                [
                    89.2214946,
                    55.245557
                ],
                [
                    89.2216485,
                    55.2450021
                ],
                [
                    89.2214123,
                    55.2448531
                ],
                [
                    89.2215053,
                    55.2446736
                ],
                [
                    89.2211296,
                    55.2445797
                ],
                [
                    89.2209435,
                    55.2445797
                ],
                [
                    89.2206571,
                    55.2443329
                ],
                [
                    89.2200058,
                    55.2441839
                ],
                [
                    89.2195298,
                    55.2442166
                ],
                [
                    89.219061,
                    55.2444063
                ],
                [
                    89.2182915,
                    55.2449694
                ],
                [
                    89.2179801,
                    55.2450347
                ],
                [
                    89.2173359,
                    55.2448613
                ],
                [
                    89.2169959,
                    55.2445838
                ],
                [
                    89.2169637,
                    55.2444043
                ],
                [
                    89.2168063,
                    55.2442737
                ],
                [
                    89.2163696,
                    55.2443839
                ],
                [
                    89.2160762,
                    55.244392
                ],
                [
                    89.2159259,
                    55.2442757
                ],
                [
                    89.2158937,
                    55.2439085
                ],
                [
                    89.2154534,
                    55.2439309
                ],
                [
                    89.2150562,
                    55.2440472
                ],
                [
                    89.2149345,
                    55.2443451
                ],
                [
                    89.2145659,
                    55.2443594
                ],
                [
                    89.2145122,
                    55.244543
                ],
                [
                    89.2146375,
                    55.2445879
                ],
                [
                    89.2145015,
                    55.2447042
                ],
                [
                    89.2141221,
                    55.2447246
                ],
                [
                    89.212984,
                    55.244541
                ],
                [
                    89.2123255,
                    55.2447736
                ],
                [
                    89.2120315,
                    55.2451918
                ]
            ],
            "longitude": 89.22718,
            "latitude": 55.252319
        },
        "6267": {
            "name": "Белогорка",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    89.2192239,
                    56.7102797
                ],
                [
                    89.2273089,
                    56.7151847
                ],
                [
                    89.2280913,
                    56.7149747
                ],
                [
                    89.2292215,
                    56.7158335
                ],
                [
                    89.2300908,
                    56.7155282
                ],
                [
                    89.2303864,
                    56.716406
                ],
                [
                    89.2316905,
                    56.7167591
                ],
                [
                    89.2333823,
                    56.7164282
                ],
                [
                    89.236619,
                    56.7122498
                ],
                [
                    89.234364,
                    56.7115937
                ],
                [
                    89.2332774,
                    56.7109674
                ],
                [
                    89.2328971,
                    56.7104754
                ],
                [
                    89.2323265,
                    56.7106096
                ],
                [
                    89.2310225,
                    56.7100877
                ],
                [
                    89.2323809,
                    56.709521
                ],
                [
                    89.2349346,
                    56.7073588
                ],
                [
                    89.230941,
                    56.7062701
                ],
                [
                    89.2300039,
                    56.7065767
                ],
                [
                    89.2265613,
                    56.7085905
                ],
                [
                    89.2214147,
                    56.7068535
                ],
                [
                    89.2197977,
                    56.7080942
                ],
                [
                    89.2192239,
                    56.7102797
                ]
            ],
            "longitude": 89.227203,
            "latitude": 56.710186
        },
        "6268": {
            "name": "Усть-Чульск",
            "population": 31,
            "type": "hamlet",
            "poly": [
                [
                    89.2215705,
                    57.2710818
                ],
                [
                    89.2225491,
                    57.2727677
                ],
                [
                    89.2249376,
                    57.2736555
                ],
                [
                    89.2260157,
                    57.2742473
                ],
                [
                    89.226845,
                    57.2750275
                ],
                [
                    89.2278402,
                    57.2756641
                ],
                [
                    89.2286696,
                    57.2768118
                ],
                [
                    89.2304112,
                    57.2775202
                ],
                [
                    89.2330982,
                    57.2786051
                ],
                [
                    89.2327798,
                    57.2794469
                ],
                [
                    89.2321827,
                    57.2797069
                ],
                [
                    89.2323817,
                    57.2802
                ],
                [
                    89.231851,
                    57.2808456
                ],
                [
                    89.2321495,
                    57.281518
                ],
                [
                    89.2329291,
                    57.2815987
                ],
                [
                    89.2328959,
                    57.2827372
                ],
                [
                    89.2365948,
                    57.2860631
                ],
                [
                    89.2367938,
                    57.2866637
                ],
                [
                    89.2383529,
                    57.2876049
                ],
                [
                    89.238867,
                    57.2876677
                ],
                [
                    89.2392984,
                    57.2882055
                ],
                [
                    89.2386348,
                    57.2885013
                ],
                [
                    89.2392984,
                    57.2889495
                ],
                [
                    89.2398788,
                    57.2886088
                ],
                [
                    89.2412722,
                    57.2882772
                ],
                [
                    89.2432128,
                    57.2884296
                ],
                [
                    89.2438431,
                    57.2881786
                ],
                [
                    89.2441085,
                    57.2877752
                ],
                [
                    89.2432128,
                    57.286081
                ],
                [
                    89.2424333,
                    57.2853908
                ],
                [
                    89.2428314,
                    57.2845392
                ],
                [
                    89.2416703,
                    57.2836965
                ],
                [
                    89.2406585,
                    57.2827821
                ],
                [
                    89.2399453,
                    57.2829165
                ],
                [
                    89.2389832,
                    57.2825848
                ],
                [
                    89.2389998,
                    57.2824055
                ],
                [
                    89.2400946,
                    57.2824772
                ],
                [
                    89.2402272,
                    57.2821545
                ],
                [
                    89.2390828,
                    57.2815
                ],
                [
                    89.2380046,
                    57.2811683
                ],
                [
                    89.2382368,
                    57.2809442
                ],
                [
                    89.238867,
                    57.2808635
                ],
                [
                    89.239033,
                    57.2804959
                ],
                [
                    89.2375402,
                    57.2804152
                ],
                [
                    89.2378719,
                    57.2798145
                ],
                [
                    89.2386515,
                    57.2786669
                ],
                [
                    89.2393813,
                    57.2783352
                ],
                [
                    89.2389832,
                    57.2779496
                ],
                [
                    89.2368767,
                    57.2770081
                ],
                [
                    89.2363127,
                    57.2763984
                ],
                [
                    89.233891,
                    57.2755018
                ],
                [
                    89.2347205,
                    57.2752776
                ],
                [
                    89.234339,
                    57.2747575
                ],
                [
                    89.2325642,
                    57.2735201
                ],
                [
                    89.2327964,
                    57.2730089
                ],
                [
                    89.2323983,
                    57.2726413
                ],
                [
                    89.2294791,
                    57.271592
                ],
                [
                    89.2277872,
                    57.2714396
                ],
                [
                    89.2249707,
                    57.2689205
                ],
                [
                    89.2235924,
                    57.269222
                ],
                [
                    89.2231295,
                    57.2695752
                ],
                [
                    89.2224827,
                    57.2696649
                ],
                [
                    89.2216036,
                    57.2707052
                ],
                [
                    89.2215705,
                    57.2710818
                ]
            ],
            "longitude": 89.233955,
            "latitude": 57.27644
        },
        "6269": {
            "name": "Покровка",
            "population": 127,
            "type": "hamlet",
            "poly": [
                [
                    89.2283578,
                    56.532323
                ],
                [
                    89.2308788,
                    56.5336741
                ],
                [
                    89.2346075,
                    56.5389217
                ],
                [
                    89.2381228,
                    56.5389217
                ],
                [
                    89.2412122,
                    56.541878
                ],
                [
                    89.2465742,
                    56.5439727
                ],
                [
                    89.2504448,
                    56.5417214
                ],
                [
                    89.2474264,
                    56.540253
                ],
                [
                    89.247746,
                    56.5394699
                ],
                [
                    89.2468583,
                    56.5387455
                ],
                [
                    89.2477815,
                    56.5383539
                ],
                [
                    89.2458285,
                    56.536533
                ],
                [
                    89.2462901,
                    56.536063
                ],
                [
                    89.2433427,
                    56.5342616
                ],
                [
                    89.2380519,
                    56.5294247
                ],
                [
                    89.2283578,
                    56.532323
                ]
            ],
            "longitude": 89.241714,
            "latitude": 56.538124
        },
        "6270": {
            "name": "Лебедевка",
            "population": 142,
            "type": "hamlet",
            "poly": [
                [
                    89.241536,
                    56.2725838
                ],
                [
                    89.2444995,
                    56.275567
                ],
                [
                    89.2465488,
                    56.2773199
                ],
                [
                    89.2469367,
                    56.2778734
                ],
                [
                    89.2496785,
                    56.2794878
                ],
                [
                    89.2535005,
                    56.2820861
                ],
                [
                    89.2544421,
                    56.2826241
                ],
                [
                    89.25591,
                    56.2819477
                ],
                [
                    89.2570178,
                    56.28081
                ],
                [
                    89.2565192,
                    56.2801489
                ],
                [
                    89.2590396,
                    56.279457
                ],
                [
                    89.2622522,
                    56.27835
                ],
                [
                    89.2615045,
                    56.2767202
                ],
                [
                    89.2607012,
                    56.2754594
                ],
                [
                    89.2572394,
                    56.2727069
                ],
                [
                    89.2535005,
                    56.2696004
                ],
                [
                    89.252448,
                    56.2684624
                ],
                [
                    89.2501216,
                    56.2674781
                ],
                [
                    89.2476013,
                    56.2670936
                ],
                [
                    89.2460227,
                    56.2671551
                ],
                [
                    89.2456349,
                    56.2672782
                ],
                [
                    89.2456904,
                    56.2677088
                ],
                [
                    89.2439455,
                    56.2685393
                ],
                [
                    89.2420069,
                    56.2709691
                ],
                [
                    89.2427546,
                    56.2713382
                ],
                [
                    89.2426716,
                    56.2718611
                ],
                [
                    89.241536,
                    56.2725838
                ]
            ],
            "longitude": 89.248993,
            "latitude": 56.275288
        },
        "6271": {
            "name": "Агапа",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.25,
            "latitude": 71.45
        },
        "6272": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.2592257,
            "latitude": 59.8338084
        },
        "6273": {
            "name": "Александровский Шлюз",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.2898685,
            "latitude": 59.4297436
        },
        "6274": {
            "name": "Колокольный Яр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.297103,
            "latitude": 60.948485
        },
        "6275": {
            "name": "Львовка",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    89.2846012,
                    56.2254762
                ],
                [
                    89.2857893,
                    56.2255734
                ],
                [
                    89.2862086,
                    56.2270303
                ],
                [
                    89.2851253,
                    56.2275548
                ],
                [
                    89.2866279,
                    56.2285261
                ],
                [
                    89.2876064,
                    56.229206
                ],
                [
                    89.2880607,
                    56.2306628
                ],
                [
                    89.2929179,
                    56.2304297
                ],
                [
                    89.2913804,
                    56.2299052
                ],
                [
                    89.2911707,
                    56.2291088
                ],
                [
                    89.2932674,
                    56.2288952
                ],
                [
                    89.2952942,
                    56.2293225
                ],
                [
                    89.2981247,
                    56.2294391
                ],
                [
                    89.2995574,
                    56.2286815
                ],
                [
                    89.2988935,
                    56.2274189
                ],
                [
                    89.2972161,
                    56.2264281
                ],
                [
                    89.2954689,
                    56.2252043
                ],
                [
                    89.295399,
                    56.2240775
                ],
                [
                    89.2964822,
                    56.2234753
                ],
                [
                    89.2987537,
                    56.2229507
                ],
                [
                    89.2993477,
                    56.2234558
                ],
                [
                    89.2978801,
                    56.2239027
                ],
                [
                    89.2975656,
                    56.2246798
                ],
                [
                    89.30106,
                    56.2256317
                ],
                [
                    89.3021083,
                    56.2264864
                ],
                [
                    89.3022132,
                    56.2271469
                ],
                [
                    89.3028422,
                    56.2278462
                ],
                [
                    89.3041002,
                    56.2280016
                ],
                [
                    89.3053232,
                    56.2277685
                ],
                [
                    89.3077344,
                    56.2278074
                ],
                [
                    89.3081188,
                    56.2272052
                ],
                [
                    89.3064763,
                    56.2267001
                ],
                [
                    89.3068608,
                    56.2245632
                ],
                [
                    89.3054281,
                    56.220697
                ],
                [
                    89.3052883,
                    56.2190067
                ],
                [
                    89.304834,
                    56.2184432
                ],
                [
                    89.2997321,
                    56.2180546
                ],
                [
                    89.2988236,
                    56.2169859
                ],
                [
                    89.297286,
                    56.2162864
                ],
                [
                    89.2976354,
                    56.2142266
                ],
                [
                    89.2963425,
                    56.2121279
                ],
                [
                    89.2971812,
                    56.2120113
                ],
                [
                    89.2968317,
                    56.2111756
                ],
                [
                    89.2985091,
                    56.2109036
                ],
                [
                    89.2969366,
                    56.2106704
                ],
                [
                    89.2960979,
                    56.2102039
                ],
                [
                    89.2946652,
                    56.2102039
                ],
                [
                    89.2939663,
                    56.212089
                ],
                [
                    89.2911045,
                    56.2134575
                ],
                [
                    89.2905068,
                    56.215412
                ],
                [
                    89.2892138,
                    56.2164807
                ],
                [
                    89.2885149,
                    56.2185209
                ],
                [
                    89.2897729,
                    56.2188901
                ],
                [
                    89.2901923,
                    56.2214547
                ],
                [
                    89.2897031,
                    56.2216685
                ],
                [
                    89.2885499,
                    56.2212022
                ],
                [
                    89.2846012,
                    56.2254762
                ]
            ],
            "longitude": 89.297218,
            "latitude": 56.219959
        },
        "6276": {
            "name": "Пузаново",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    89.30226,
                    56.4309591
                ],
                [
                    89.3059756,
                    56.4327064
                ],
                [
                    89.3089272,
                    56.4315352
                ],
                [
                    89.3111151,
                    56.4314776
                ],
                [
                    89.3117748,
                    56.433724
                ],
                [
                    89.3128861,
                    56.4348952
                ],
                [
                    89.3148654,
                    56.4349336
                ],
                [
                    89.3191367,
                    56.4324376
                ],
                [
                    89.3218106,
                    56.4307479
                ],
                [
                    89.3210119,
                    56.4299607
                ],
                [
                    89.3185464,
                    56.4298838
                ],
                [
                    89.3184768,
                    56.4288085
                ],
                [
                    89.3171921,
                    56.4282901
                ],
                [
                    89.3167406,
                    56.4289045
                ],
                [
                    89.3147613,
                    56.4281172
                ],
                [
                    89.3138584,
                    56.4271955
                ],
                [
                    89.3135806,
                    56.4255056
                ],
                [
                    89.3126777,
                    56.4249871
                ],
                [
                    89.3114623,
                    56.4247182
                ],
                [
                    89.3102469,
                    56.4252559
                ],
                [
                    89.3096913,
                    56.425736
                ],
                [
                    89.3076425,
                    56.4260817
                ],
                [
                    89.3062534,
                    56.4264274
                ],
                [
                    89.3061145,
                    56.4268882
                ],
                [
                    89.3043435,
                    56.4277716
                ],
                [
                    89.3064617,
                    56.429903
                ],
                [
                    89.3041352,
                    56.4296918
                ],
                [
                    89.30226,
                    56.4309591
                ]
            ],
            "longitude": 89.312782,
            "latitude": 56.429058
        },
        "6277": {
            "name": "Пасечное",
            "population": 140,
            "type": "hamlet",
            "poly": [
                [
                    89.3055225,
                    57.439538
                ],
                [
                    89.3063054,
                    57.4402236
                ],
                [
                    89.3075262,
                    57.4402093
                ],
                [
                    89.3080172,
                    57.4404093
                ],
                [
                    89.310326,
                    57.4403879
                ],
                [
                    89.3104057,
                    57.4392524
                ],
                [
                    89.3143334,
                    57.4399451
                ],
                [
                    89.3171996,
                    57.438174
                ],
                [
                    89.3199596,
                    57.4374384
                ],
                [
                    89.3239537,
                    57.4367028
                ],
                [
                    89.3239404,
                    57.4359957
                ],
                [
                    89.3224277,
                    57.4356243
                ],
                [
                    89.3194819,
                    57.4345816
                ],
                [
                    89.3144794,
                    57.4345887
                ],
                [
                    89.3144661,
                    57.4341387
                ],
                [
                    89.3139884,
                    57.433803
                ],
                [
                    89.3129666,
                    57.4337816
                ],
                [
                    89.313033,
                    57.434503
                ],
                [
                    89.311507,
                    57.4348101
                ],
                [
                    89.3095033,
                    57.4349815
                ],
                [
                    89.3085081,
                    57.433753
                ],
                [
                    89.3074864,
                    57.4331888
                ],
                [
                    89.3073536,
                    57.4335316
                ],
                [
                    89.3062391,
                    57.4338673
                ],
                [
                    89.3062125,
                    57.4350387
                ],
                [
                    89.3066769,
                    57.4354815
                ],
                [
                    89.3078447,
                    57.4356315
                ],
                [
                    89.3084418,
                    57.4360743
                ],
                [
                    89.3083622,
                    57.437067
                ],
                [
                    89.3075129,
                    57.4376741
                ],
                [
                    89.3067964,
                    57.4384454
                ],
                [
                    89.3055225,
                    57.439538
                ]
            ],
            "longitude": 89.314064,
            "latitude": 57.436478
        },
        "6278": {
            "name": "Хохловка",
            "population": 74,
            "type": "hamlet",
            "poly": [
                [
                    89.3044768,
                    56.5938795
                ],
                [
                    89.3048897,
                    56.5946214
                ],
                [
                    89.307063,
                    56.5952915
                ],
                [
                    89.3079106,
                    56.5951598
                ],
                [
                    89.3148004,
                    56.5964042
                ],
                [
                    89.3175171,
                    56.5971461
                ],
                [
                    89.318995,
                    56.5971341
                ],
                [
                    89.3195601,
                    56.5963325
                ],
                [
                    89.3211032,
                    56.5967393
                ],
                [
                    89.3206903,
                    56.5982708
                ],
                [
                    89.3223203,
                    56.5984144
                ],
                [
                    89.3260585,
                    56.5993117
                ],
                [
                    89.3279494,
                    56.5995869
                ],
                [
                    89.3286666,
                    56.5994672
                ],
                [
                    89.3297824,
                    56.5995901
                ],
                [
                    89.3323906,
                    56.6030835
                ],
                [
                    89.3352812,
                    56.6029878
                ],
                [
                    89.3340422,
                    56.6000088
                ],
                [
                    89.331543,
                    56.5981185
                ],
                [
                    89.3315212,
                    56.5972211
                ],
                [
                    89.3256965,
                    56.5961323
                ],
                [
                    89.322067,
                    56.5943853
                ],
                [
                    89.3197632,
                    56.5941101
                ],
                [
                    89.3192849,
                    56.5942297
                ],
                [
                    89.3143732,
                    56.5929015
                ],
                [
                    89.3085268,
                    56.5904842
                ],
                [
                    89.3068892,
                    56.589739
                ],
                [
                    89.3061503,
                    56.5922401
                ],
                [
                    89.30484,
                    56.5932621
                ],
                [
                    89.3044768,
                    56.5938795
                ]
            ],
            "longitude": 89.316452,
            "latitude": 56.594463
        },
        "6279": {
            "name": "Якша",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.3275194,
            "latitude": 59.0436617
        },
        "6280": {
            "name": "Комса",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.3332206,
            "latitude": 61.841454
        },
        "6281": {
            "name": "Росинка",
            "population": 148,
            "type": "hamlet",
            "poly": [
                [
                    89.3276049,
                    55.6896404
                ],
                [
                    89.3285021,
                    55.6903534
                ],
                [
                    89.328708,
                    55.6914975
                ],
                [
                    89.3285755,
                    55.6929814
                ],
                [
                    89.3289728,
                    55.6929648
                ],
                [
                    89.3294728,
                    55.692799
                ],
                [
                    89.3301641,
                    55.6929151
                ],
                [
                    89.3306789,
                    55.6928488
                ],
                [
                    89.3306789,
                    55.6925255
                ],
                [
                    89.3312672,
                    55.6928322
                ],
                [
                    89.3335764,
                    55.6931804
                ],
                [
                    89.334959,
                    55.69357
                ],
                [
                    89.3355325,
                    55.6934457
                ],
                [
                    89.3362386,
                    55.6934954
                ],
                [
                    89.3370328,
                    55.693313
                ],
                [
                    89.3379888,
                    55.6934042
                ],
                [
                    89.3386948,
                    55.6929731
                ],
                [
                    89.3398274,
                    55.6932218
                ],
                [
                    89.3434603,
                    55.6929897
                ],
                [
                    89.3453282,
                    55.6930477
                ],
                [
                    89.3462548,
                    55.6930063
                ],
                [
                    89.3468578,
                    55.6927327
                ],
                [
                    89.3477845,
                    55.6927576
                ],
                [
                    89.3477992,
                    55.6930063
                ],
                [
                    89.3489023,
                    55.6930063
                ],
                [
                    89.3488287,
                    55.6918954
                ],
                [
                    89.3485345,
                    55.6918374
                ],
                [
                    89.3476227,
                    55.6916799
                ],
                [
                    89.3477256,
                    55.6906933
                ],
                [
                    89.347402,
                    55.6906933
                ],
                [
                    89.3473432,
                    55.6898228
                ],
                [
                    89.3468578,
                    55.6897814
                ],
                [
                    89.3466225,
                    55.6899223
                ],
                [
                    89.3462842,
                    55.6902208
                ],
                [
                    89.34574,
                    55.6901545
                ],
                [
                    89.3447546,
                    55.6900384
                ],
                [
                    89.3441074,
                    55.6901628
                ],
                [
                    89.3432985,
                    55.6905192
                ],
                [
                    89.3425778,
                    55.6907182
                ],
                [
                    89.3419159,
                    55.6905773
                ],
                [
                    89.3416365,
                    55.6901462
                ],
                [
                    89.3413717,
                    55.6898892
                ],
                [
                    89.3404598,
                    55.689798
                ],
                [
                    89.3384154,
                    55.6898892
                ],
                [
                    89.3375623,
                    55.6901213
                ],
                [
                    89.3357532,
                    55.6900633
                ],
                [
                    89.3344883,
                    55.6901959
                ],
                [
                    89.3329587,
                    55.6899887
                ],
                [
                    89.3312231,
                    55.6900881
                ],
                [
                    89.3300317,
                    55.6899804
                ],
                [
                    89.3288404,
                    55.6897897
                ],
                [
                    89.3279538,
                    55.6896178
                ],
                [
                    89.3276049,
                    55.6896404
                ]
            ],
            "longitude": 89.338181,
            "latitude": 55.691448
        },
        "6282": {
            "name": "Малая Косуль",
            "population": 43,
            "type": "hamlet",
            "poly": [
                [
                    89.3341798,
                    56.0838897
                ],
                [
                    89.3350985,
                    56.0843324
                ],
                [
                    89.3348479,
                    56.0845771
                ],
                [
                    89.3344513,
                    56.0845305
                ],
                [
                    89.3344722,
                    56.0858352
                ],
                [
                    89.335537,
                    56.0861032
                ],
                [
                    89.3351612,
                    56.0876176
                ],
                [
                    89.3343678,
                    56.0888057
                ],
                [
                    89.335704,
                    56.0892717
                ],
                [
                    89.3360172,
                    56.0887941
                ],
                [
                    89.3377502,
                    56.0879787
                ],
                [
                    89.3394414,
                    56.0880253
                ],
                [
                    89.3403183,
                    56.0878039
                ],
                [
                    89.3409029,
                    56.0870002
                ],
                [
                    89.3413413,
                    56.0863245
                ],
                [
                    89.3411117,
                    56.0853576
                ],
                [
                    89.3420512,
                    56.0853809
                ],
                [
                    89.3427402,
                    56.0845538
                ],
                [
                    89.3428864,
                    56.0840295
                ],
                [
                    89.3424688,
                    56.0835868
                ],
                [
                    89.3421347,
                    56.082049
                ],
                [
                    89.342782,
                    56.0813499
                ],
                [
                    89.3429281,
                    56.0806043
                ],
                [
                    89.3410282,
                    56.0797771
                ],
                [
                    89.3402556,
                    56.0804062
                ],
                [
                    89.3392117,
                    56.0808023
                ],
                [
                    89.3353491,
                    56.0835519
                ],
                [
                    89.3347436,
                    56.0835752
                ],
                [
                    89.3341798,
                    56.0838897
                ]
            ],
            "longitude": 89.339592,
            "latitude": 56.084087
        },
        "6283": {
            "name": "Георгиевка",
            "population": 166,
            "type": "hamlet",
            "poly": [
                [
                    89.3308577,
                    56.3938881
                ],
                [
                    89.3325608,
                    56.3943851
                ],
                [
                    89.3343258,
                    56.3947964
                ],
                [
                    89.33414,
                    56.3953106
                ],
                [
                    89.3320034,
                    56.3953106
                ],
                [
                    89.3325298,
                    56.3970072
                ],
                [
                    89.33959,
                    56.3997663
                ],
                [
                    89.3429962,
                    56.4001775
                ],
                [
                    89.3443896,
                    56.399732
                ],
                [
                    89.3455354,
                    56.398601
                ],
                [
                    89.3439561,
                    56.3977784
                ],
                [
                    89.3473624,
                    56.3967673
                ],
                [
                    89.3499016,
                    56.3952934
                ],
                [
                    89.3534627,
                    56.3937167
                ],
                [
                    89.3542987,
                    56.3929797
                ],
                [
                    89.3561567,
                    56.3917114
                ],
                [
                    89.3563115,
                    56.389586
                ],
                [
                    89.3556612,
                    56.3892774
                ],
                [
                    89.3545774,
                    56.3892603
                ],
                [
                    89.3535373,
                    56.3889183
                ],
                [
                    89.352255,
                    56.3881118
                ],
                [
                    89.3507996,
                    56.388009
                ],
                [
                    89.3499016,
                    56.3874262
                ],
                [
                    89.3472695,
                    56.3888832
                ],
                [
                    89.3433988,
                    56.3907687
                ],
                [
                    89.3374224,
                    56.3915228
                ],
                [
                    89.3341091,
                    56.3917457
                ],
                [
                    89.3309196,
                    56.3927569
                ],
                [
                    89.3308577,
                    56.3938881
                ]
            ],
            "longitude": 89.348022,
            "latitude": 56.393684
        },
        "6284": {
            "name": "Ершово",
            "population": 242,
            "type": "hamlet",
            "poly": [
                [
                    89.3835228,
                    55.9485048
                ],
                [
                    89.3839644,
                    55.9487404
                ],
                [
                    89.3839119,
                    55.9489112
                ],
                [
                    89.3841432,
                    55.9489877
                ],
                [
                    89.3844482,
                    55.9489818
                ],
                [
                    89.3854788,
                    55.949606
                ],
                [
                    89.3848037,
                    55.9499938
                ],
                [
                    89.385645,
                    55.950406
                ],
                [
                    89.3861067,
                    55.9505383
                ],
                [
                    89.3871568,
                    55.9510207
                ],
                [
                    89.387776,
                    55.9511413
                ],
                [
                    89.387951,
                    55.9510734
                ],
                [
                    89.3883481,
                    55.9512016
                ],
                [
                    89.3887586,
                    55.9510207
                ],
                [
                    89.3897615,
                    55.9509604
                ],
                [
                    89.3908047,
                    55.950885
                ],
                [
                    89.3923595,
                    55.9515784
                ],
                [
                    89.3933825,
                    55.9522115
                ],
                [
                    89.3939681,
                    55.9522341
                ],
                [
                    89.3942575,
                    55.9524489
                ],
                [
                    89.3940825,
                    55.9526034
                ],
                [
                    89.3945873,
                    55.9528898
                ],
                [
                    89.3966535,
                    55.9523057
                ],
                [
                    89.3989218,
                    55.9516651
                ],
                [
                    89.3994601,
                    55.951552
                ],
                [
                    89.3998842,
                    55.9513561
                ],
                [
                    89.3998236,
                    55.9509114
                ],
                [
                    89.3992987,
                    55.9502331
                ],
                [
                    89.3989621,
                    55.9498072
                ],
                [
                    89.399191,
                    55.9492758
                ],
                [
                    89.3995745,
                    55.948605
                ],
                [
                    89.4003082,
                    55.9483186
                ],
                [
                    89.4014457,
                    55.9477458
                ],
                [
                    89.4022938,
                    55.9476214
                ],
                [
                    89.403263,
                    55.9475686
                ],
                [
                    89.4049456,
                    55.9472332
                ],
                [
                    89.404584,
                    55.9469141
                ],
                [
                    89.4033792,
                    55.94711
                ],
                [
                    89.4033523,
                    55.9470422
                ],
                [
                    89.4023427,
                    55.9472269
                ],
                [
                    89.4020466,
                    55.9464279
                ],
                [
                    89.401286,
                    55.946507
                ],
                [
                    89.3994823,
                    55.9462131
                ],
                [
                    89.4000114,
                    55.9452237
                ],
                [
                    89.4001082,
                    55.9447846
                ],
                [
                    89.3981563,
                    55.9441326
                ],
                [
                    89.3977727,
                    55.9435483
                ],
                [
                    89.3979612,
                    55.9432468
                ],
                [
                    89.3983179,
                    55.943096
                ],
                [
                    89.3991996,
                    55.9429151
                ],
                [
                    89.3985602,
                    55.9426211
                ],
                [
                    89.3985467,
                    55.942312
                ],
                [
                    89.3977256,
                    55.942312
                ],
                [
                    89.3966622,
                    55.9420595
                ],
                [
                    89.3969045,
                    55.9418974
                ],
                [
                    89.3968438,
                    55.9415582
                ],
                [
                    89.3962112,
                    55.9415469
                ],
                [
                    89.3960026,
                    55.9410493
                ],
                [
                    89.3962179,
                    55.9407327
                ],
                [
                    89.3965477,
                    55.9405932
                ],
                [
                    89.3961574,
                    55.9402615
                ],
                [
                    89.3963795,
                    55.9400579
                ],
                [
                    89.3953159,
                    55.939975
                ],
                [
                    89.395168,
                    55.9397451
                ],
                [
                    89.3951478,
                    55.9396094
                ],
                [
                    89.3956391,
                    55.9393116
                ],
                [
                    89.3954978,
                    55.9387763
                ],
                [
                    89.3955986,
                    55.9383767
                ],
                [
                    89.395888,
                    55.9378904
                ],
                [
                    89.3961574,
                    55.9377434
                ],
                [
                    89.3961103,
                    55.937619
                ],
                [
                    89.3959083,
                    55.9375549
                ],
                [
                    89.3955112,
                    55.9375323
                ],
                [
                    89.3938959,
                    55.9379243
                ],
                [
                    89.3933103,
                    55.938109
                ],
                [
                    89.3887134,
                    55.9381166
                ],
                [
                    89.3897095,
                    55.9375624
                ],
                [
                    89.3902278,
                    55.9365785
                ],
                [
                    89.3885181,
                    55.9363599
                ],
                [
                    89.3884374,
                    55.9365898
                ],
                [
                    89.3875355,
                    55.9365408
                ],
                [
                    89.3850587,
                    55.9365936
                ],
                [
                    89.3851798,
                    55.9371025
                ],
                [
                    89.384419,
                    55.9371958
                ],
                [
                    89.3842847,
                    55.9372005
                ],
                [
                    89.3854019,
                    55.9394623
                ],
                [
                    89.3863937,
                    55.9420151
                ],
                [
                    89.3841958,
                    55.9420151
                ],
                [
                    89.3839013,
                    55.942286
                ],
                [
                    89.3838908,
                    55.9433756
                ],
                [
                    89.3842484,
                    55.9445416
                ],
                [
                    89.3854578,
                    55.9468796
                ],
                [
                    89.3853211,
                    55.9470798
                ],
                [
                    89.3842063,
                    55.9473389
                ],
                [
                    89.3842168,
                    55.947598
                ],
                [
                    89.3836174,
                    55.9481633
                ],
                [
                    89.3835228,
                    55.9485048
                ]
            ],
            "longitude": 89.392662,
            "latitude": 55.947575
        },
        "6285": {
            "name": "Безручейка",
            "population": 56,
            "type": "hamlet",
            "poly": [
                [
                    89.3996134,
                    56.6053124
                ],
                [
                    89.400048,
                    56.6064488
                ],
                [
                    89.4038786,
                    56.6069273
                ],
                [
                    89.4070029,
                    56.6079441
                ],
                [
                    89.411241,
                    56.6089458
                ],
                [
                    89.4264819,
                    56.6124294
                ],
                [
                    89.4297963,
                    56.6120556
                ],
                [
                    89.430394,
                    56.6110839
                ],
                [
                    89.4259114,
                    56.608288
                ],
                [
                    89.4185219,
                    56.6072712
                ],
                [
                    89.4145283,
                    56.6058956
                ],
                [
                    89.4090133,
                    56.6051779
                ],
                [
                    89.4065138,
                    56.6052526
                ],
                [
                    89.4009989,
                    56.6041162
                ],
                [
                    89.3999665,
                    56.6044003
                ],
                [
                    89.3996134,
                    56.6053124
                ]
            ],
            "longitude": 89.414299,
            "latitude": 56.607788
        },
        "6286": {
            "name": "Косонголь",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    89.4176049,
                    55.6419131
                ],
                [
                    89.4180994,
                    55.6421727
                ],
                [
                    89.4183752,
                    55.642209
                ],
                [
                    89.4185134,
                    55.6422311
                ],
                [
                    89.4194219,
                    55.6426465
                ],
                [
                    89.4209283,
                    55.6425946
                ],
                [
                    89.4220784,
                    55.6421143
                ],
                [
                    89.4227224,
                    55.6415626
                ],
                [
                    89.4235849,
                    55.6399855
                ],
                [
                    89.4244934,
                    55.6378825
                ],
                [
                    89.4247924,
                    55.6369024
                ],
                [
                    89.4269774,
                    55.6340008
                ],
                [
                    89.4264369,
                    55.6331115
                ],
                [
                    89.4268509,
                    55.6317742
                ],
                [
                    89.4259715,
                    55.6316993
                ],
                [
                    89.4256779,
                    55.6316638
                ],
                [
                    89.4244934,
                    55.6313782
                ],
                [
                    89.4243669,
                    55.6315924
                ],
                [
                    89.4227454,
                    55.6312548
                ],
                [
                    89.4223889,
                    55.6320079
                ],
                [
                    89.4219978,
                    55.6326051
                ],
                [
                    89.4221589,
                    55.6329167
                ],
                [
                    89.4224349,
                    55.6331439
                ],
                [
                    89.4224004,
                    55.6337282
                ],
                [
                    89.4220899,
                    55.6339489
                ],
                [
                    89.4217794,
                    55.6343838
                ],
                [
                    89.4218024,
                    55.6346045
                ],
                [
                    89.4223659,
                    55.6347733
                ],
                [
                    89.4212849,
                    55.6356171
                ],
                [
                    89.4207444,
                    55.6358508
                ],
                [
                    89.4196058,
                    55.6369219
                ],
                [
                    89.4190309,
                    55.6377202
                ],
                [
                    89.4192034,
                    55.6380123
                ],
                [
                    89.4192034,
                    55.6390638
                ],
                [
                    89.4190653,
                    55.6405177
                ],
                [
                    89.4182374,
                    55.6414653
                ],
                [
                    89.4176049,
                    55.6419131
                ]
            ],
            "longitude": 89.424019,
            "latitude": 55.635288
        },
        "6287": {
            "name": "Шушь",
            "population": 84,
            "type": "hamlet",
            "poly": [
                [
                    89.4196753,
                    55.6705495
                ],
                [
                    89.4211859,
                    55.67166
                ],
                [
                    89.4246926,
                    55.6713152
                ],
                [
                    89.4278487,
                    55.6711225
                ],
                [
                    89.4288557,
                    55.6683588
                ],
                [
                    89.4263201,
                    55.6683081
                ],
                [
                    89.4246567,
                    55.6680292
                ],
                [
                    89.4244589,
                    55.6684146
                ],
                [
                    89.4242341,
                    55.6684045
                ],
                [
                    89.4243599,
                    55.6687341
                ],
                [
                    89.4224717,
                    55.6685921
                ],
                [
                    89.4223188,
                    55.6692818
                ],
                [
                    89.4212219,
                    55.6692919
                ],
                [
                    89.4212489,
                    55.6698041
                ],
                [
                    89.4205745,
                    55.6698345
                ],
                [
                    89.4205205,
                    55.6696773
                ],
                [
                    89.4197203,
                    55.6696672
                ],
                [
                    89.4196753,
                    55.6705495
                ]
            ],
            "longitude": 89.424835,
            "latitude": 55.670078
        },
        "6288": {
            "name": "Михайловка",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    89.4442144,
                    56.305882
                ],
                [
                    89.4450367,
                    56.3063183
                ],
                [
                    89.4475038,
                    56.3056241
                ],
                [
                    89.4502926,
                    56.3056241
                ],
                [
                    89.4499708,
                    56.3040769
                ],
                [
                    89.4500066,
                    56.3018949
                ],
                [
                    89.4506144,
                    56.3019346
                ],
                [
                    89.451687,
                    56.3009824
                ],
                [
                    89.451258,
                    56.3003476
                ],
                [
                    89.451401,
                    56.2991772
                ],
                [
                    89.4491127,
                    56.2986217
                ],
                [
                    89.4456803,
                    56.2984431
                ],
                [
                    89.4453943,
                    56.2992367
                ],
                [
                    89.4444646,
                    56.3012601
                ],
                [
                    89.4446434,
                    56.3025694
                ],
                [
                    89.4451797,
                    56.3029066
                ],
                [
                    89.4451082,
                    56.3034224
                ],
                [
                    89.4446077,
                    56.3050092
                ],
                [
                    89.4442144,
                    56.305882
                ]
            ],
            "longitude": 89.447495,
            "latitude": 56.302322
        },
        "6289": {
            "name": "Вишняково-Катеюл",
            "population": 77,
            "type": "hamlet",
            "poly": [
                [
                    89.4533481,
                    56.3108425
                ],
                [
                    89.4536743,
                    56.3113223
                ],
                [
                    89.4546811,
                    56.3115898
                ],
                [
                    89.4557446,
                    56.3115898
                ],
                [
                    89.4560141,
                    56.3120224
                ],
                [
                    89.4582403,
                    56.3124785
                ],
                [
                    89.4588784,
                    56.3123134
                ],
                [
                    89.4596725,
                    56.3119358
                ],
                [
                    89.4605659,
                    56.3118257
                ],
                [
                    89.4610622,
                    56.3123055
                ],
                [
                    89.4618279,
                    56.3126988
                ],
                [
                    89.4624093,
                    56.3128639
                ],
                [
                    89.4636004,
                    56.3126044
                ],
                [
                    89.4642384,
                    56.3121639
                ],
                [
                    89.4646214,
                    56.3115504
                ],
                [
                    89.4647206,
                    56.3109212
                ],
                [
                    89.4653587,
                    56.3099301
                ],
                [
                    89.4651886,
                    56.3091042
                ],
                [
                    89.4615868,
                    56.3084514
                ],
                [
                    89.4605233,
                    56.3083727
                ],
                [
                    89.4601972,
                    56.3084514
                ],
                [
                    89.458056,
                    56.3079794
                ],
                [
                    89.4579425,
                    56.3075704
                ],
                [
                    89.4582545,
                    56.3070197
                ],
                [
                    89.4592755,
                    56.3071928
                ],
                [
                    89.4611189,
                    56.3072242
                ],
                [
                    89.4625511,
                    56.304998
                ],
                [
                    89.4624234,
                    56.3037944
                ],
                [
                    89.4616719,
                    56.3031493
                ],
                [
                    89.460268,
                    56.3030156
                ],
                [
                    89.4594598,
                    56.3041878
                ],
                [
                    89.456964,
                    56.3041012
                ],
                [
                    89.4565529,
                    56.3034483
                ],
                [
                    89.4557163,
                    56.3032752
                ],
                [
                    89.4548229,
                    56.303346
                ],
                [
                    89.454199,
                    56.3037079
                ],
                [
                    89.4538303,
                    56.3042664
                ],
                [
                    89.4534616,
                    56.3044867
                ],
                [
                    89.453802,
                    56.3049666
                ],
                [
                    89.4537878,
                    56.3059342
                ],
                [
                    89.4553901,
                    56.3064061
                ],
                [
                    89.4576306,
                    56.3071456
                ],
                [
                    89.4574179,
                    56.3078063
                ],
                [
                    89.4566095,
                    56.3081446
                ],
                [
                    89.4560424,
                    56.3081839
                ],
                [
                    89.4552482,
                    56.3079794
                ],
                [
                    89.4550639,
                    56.3077749
                ],
                [
                    89.4545251,
                    56.3077985
                ],
                [
                    89.454355,
                    56.3087345
                ],
                [
                    89.4533481,
                    56.3108425
                ]
            ],
            "longitude": 89.457848,
            "latitude": 56.308685
        },
        "6290": {
            "name": "Алексеевка",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    89.4545229,
                    56.5124466
                ],
                [
                    89.4549496,
                    56.5134079
                ],
                [
                    89.4561764,
                    56.513869
                ],
                [
                    89.4595901,
                    56.5138395
                ],
                [
                    89.4601057,
                    56.5135551
                ],
                [
                    89.459999,
                    56.5125741
                ],
                [
                    89.4596612,
                    56.5125937
                ],
                [
                    89.4596257,
                    56.5116814
                ],
                [
                    89.4600702,
                    56.5116519
                ],
                [
                    89.4599457,
                    56.5067367
                ],
                [
                    89.4587011,
                    56.5068054
                ],
                [
                    89.4588789,
                    56.5075805
                ],
                [
                    89.4580611,
                    56.5095034
                ],
                [
                    89.4578655,
                    56.5108475
                ],
                [
                    89.4559275,
                    56.5108671
                ],
                [
                    89.4545229,
                    56.5124466
                ]
            ],
            "longitude": 89.45842,
            "latitude": 56.511295
        },
        "6291": {
            "name": "Индыгино",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.4698283,
            "latitude": 61.1156189
        },
        "6292": {
            "name": "Лосиноборское",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.4704499,
            "latitude": 58.4570087
        },
        "6293": {
            "name": "Ларневка",
            "population": 182,
            "type": "hamlet",
            "poly": [
                [
                    89.4697435,
                    56.5235623
                ],
                [
                    89.4704126,
                    56.5242763
                ],
                [
                    89.4697435,
                    56.5254557
                ],
                [
                    89.4769363,
                    56.5243881
                ],
                [
                    89.485354,
                    56.5238265
                ],
                [
                    89.4929355,
                    56.5242578
                ],
                [
                    89.4979534,
                    56.5251503
                ],
                [
                    89.4982807,
                    56.5235056
                ],
                [
                    89.4998442,
                    56.5221919
                ],
                [
                    89.499317,
                    56.5216804
                ],
                [
                    89.4971171,
                    56.5214698
                ],
                [
                    89.4968989,
                    56.5200356
                ],
                [
                    89.4963022,
                    56.519976
                ],
                [
                    89.4867754,
                    56.5187804
                ],
                [
                    89.4860773,
                    56.518291
                ],
                [
                    89.4799976,
                    56.518628
                ],
                [
                    89.4792703,
                    56.5181546
                ],
                [
                    89.4780485,
                    56.518283
                ],
                [
                    89.4778886,
                    56.5188687
                ],
                [
                    89.4763614,
                    56.5184194
                ],
                [
                    89.4717362,
                    56.5194785
                ],
                [
                    89.4734378,
                    56.5211153
                ],
                [
                    89.4728125,
                    56.5222626
                ],
                [
                    89.4706308,
                    56.5218053
                ],
                [
                    89.4697435,
                    56.5235623
                ]
            ],
            "longitude": 89.48674,
            "latitude": 56.521336
        },
        "6294": {
            "name": "Чистый Ручей",
            "population": 30,
            "type": "hamlet",
            "poly": [
                [
                    89.4897408,
                    56.6294886
                ],
                [
                    89.4908869,
                    56.6298621
                ],
                [
                    89.4902502,
                    56.6304926
                ],
                [
                    89.4919428,
                    56.6313331
                ],
                [
                    89.4924297,
                    56.6321823
                ],
                [
                    89.4924158,
                    56.6330392
                ],
                [
                    89.4913586,
                    56.6334523
                ],
                [
                    89.4914838,
                    56.633743
                ],
                [
                    89.4950469,
                    56.6353254
                ],
                [
                    89.4985277,
                    56.6368195
                ],
                [
                    89.5141065,
                    56.6399709
                ],
                [
                    89.5159743,
                    56.6373797
                ],
                [
                    89.5140641,
                    56.6366561
                ],
                [
                    89.5146159,
                    56.6361191
                ],
                [
                    89.510371,
                    56.6337612
                ],
                [
                    89.5057865,
                    56.6331075
                ],
                [
                    89.4999285,
                    56.6322203
                ],
                [
                    89.4983579,
                    56.6318934
                ],
                [
                    89.4959383,
                    56.6299555
                ],
                [
                    89.4914387,
                    56.6287881
                ],
                [
                    89.4899955,
                    56.6290916
                ],
                [
                    89.4897408,
                    56.6294886
                ]
            ],
            "longitude": 89.50029,
            "latitude": 56.635063
        },
        "6295": {
            "name": "Глинка",
            "population": 165,
            "type": "hamlet",
            "poly": [
                [
                    89.5147742,
                    55.7640389
                ],
                [
                    89.5153004,
                    55.7645816
                ],
                [
                    89.515839,
                    55.7656953
                ],
                [
                    89.5162024,
                    55.7663155
                ],
                [
                    89.5167788,
                    55.7670274
                ],
                [
                    89.5172954,
                    55.7674427
                ],
                [
                    89.517072,
                    55.7678874
                ],
                [
                    89.5162445,
                    55.7682699
                ],
                [
                    89.5153913,
                    55.7684865
                ],
                [
                    89.5148011,
                    55.7687932
                ],
                [
                    89.5180084,
                    55.7721273
                ],
                [
                    89.5201831,
                    55.7734515
                ],
                [
                    89.5240747,
                    55.7755403
                ],
                [
                    89.5248766,
                    55.7761153
                ],
                [
                    89.5260594,
                    55.7767523
                ],
                [
                    89.5299383,
                    55.7783475
                ],
                [
                    89.5305698,
                    55.7782574
                ],
                [
                    89.5328249,
                    55.7771525
                ],
                [
                    89.5322137,
                    55.7770506
                ],
                [
                    89.5317005,
                    55.77671
                ],
                [
                    89.5313824,
                    55.7762338
                ],
                [
                    89.5313977,
                    55.7760029
                ],
                [
                    89.5316236,
                    55.7758615
                ],
                [
                    89.5321932,
                    55.775518
                ],
                [
                    89.532496,
                    55.7753102
                ],
                [
                    89.5325165,
                    55.775137
                ],
                [
                    89.5326705,
                    55.7750331
                ],
                [
                    89.5327064,
                    55.7748859
                ],
                [
                    89.5331272,
                    55.7746463
                ],
                [
                    89.5334762,
                    55.7746146
                ],
                [
                    89.5335121,
                    55.7743028
                ],
                [
                    89.5336815,
                    55.7741152
                ],
                [
                    89.5335891,
                    55.7738814
                ],
                [
                    89.5337379,
                    55.7736967
                ],
                [
                    89.5338611,
                    55.773512
                ],
                [
                    89.5336558,
                    55.7732378
                ],
                [
                    89.5336712,
                    55.7731396
                ],
                [
                    89.5337841,
                    55.7730588
                ],
                [
                    89.5340099,
                    55.7729578
                ],
                [
                    89.5341639,
                    55.7728423
                ],
                [
                    89.5340766,
                    55.7726172
                ],
                [
                    89.5338611,
                    55.7723227
                ],
                [
                    89.5338149,
                    55.7721495
                ],
                [
                    89.5337841,
                    55.7719908
                ],
                [
                    89.533312,
                    55.7716011
                ],
                [
                    89.53304,
                    55.7714135
                ],
                [
                    89.5330554,
                    55.7712143
                ],
                [
                    89.5329733,
                    55.7707986
                ],
                [
                    89.5329117,
                    55.7706716
                ],
                [
                    89.5324447,
                    55.770484
                ],
                [
                    89.5317108,
                    55.7702617
                ],
                [
                    89.5312232,
                    55.7700769
                ],
                [
                    89.5305973,
                    55.7700971
                ],
                [
                    89.530392,
                    55.7702097
                ],
                [
                    89.5295196,
                    55.7701578
                ],
                [
                    89.5290629,
                    55.7700481
                ],
                [
                    89.5280057,
                    55.7694909
                ],
                [
                    89.5278928,
                    55.7693466
                ],
                [
                    89.5279185,
                    55.7692051
                ],
                [
                    89.5282264,
                    55.7690233
                ],
                [
                    89.5285702,
                    55.7687173
                ],
                [
                    89.528755,
                    55.7685123
                ],
                [
                    89.528719,
                    55.7682092
                ],
                [
                    89.5285343,
                    55.7674961
                ],
                [
                    89.5282315,
                    55.7671324
                ],
                [
                    89.5280724,
                    55.7669996
                ],
                [
                    89.527939,
                    55.7664106
                ],
                [
                    89.5278682,
                    55.7663403
                ],
                [
                    89.5275398,
                    55.7663791
                ],
                [
                    89.5268533,
                    55.7660946
                ],
                [
                    89.5268501,
                    55.7658267
                ],
                [
                    89.5266136,
                    55.7655828
                ],
                [
                    89.5260159,
                    55.7650321
                ],
                [
                    89.5253984,
                    55.7642931
                ],
                [
                    89.5247547,
                    55.7636722
                ],
                [
                    89.5245576,
                    55.7635558
                ],
                [
                    89.5241635,
                    55.7634689
                ],
                [
                    89.5240157,
                    55.7632989
                ],
                [
                    89.5238876,
                    55.7626467
                ],
                [
                    89.5237398,
                    55.7622789
                ],
                [
                    89.5233917,
                    55.7619112
                ],
                [
                    89.5232242,
                    55.7615657
                ],
                [
                    89.5223768,
                    55.7610649
                ],
                [
                    89.5218809,
                    55.7609799
                ],
                [
                    89.5214309,
                    55.7607045
                ],
                [
                    89.5212174,
                    55.7605068
                ],
                [
                    89.5205803,
                    55.7602111
                ],
                [
                    89.5187082,
                    55.7603945
                ],
                [
                    89.5158767,
                    55.7621991
                ],
                [
                    89.516428,
                    55.7629181
                ],
                [
                    89.5164405,
                    55.7630802
                ],
                [
                    89.5162024,
                    55.7632353
                ],
                [
                    89.5147742,
                    55.7640389
                ]
            ],
            "longitude": 89.522835,
            "latitude": 55.769402
        },
        "6296": {
            "name": "станция Белоозёрка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.5398874,
            "latitude": 55.6964897
        },
        "6297": {
            "name": "Васильевка",
            "population": 150,
            "type": "hamlet",
            "poly": [
                [
                    89.5322702,
                    56.5226038
                ],
                [
                    89.5326253,
                    56.5236077
                ],
                [
                    89.5404818,
                    56.5254439
                ],
                [
                    89.5436333,
                    56.5259091
                ],
                [
                    89.5434113,
                    56.5266191
                ],
                [
                    89.5497143,
                    56.5270352
                ],
                [
                    89.569866,
                    56.5295812
                ],
                [
                    89.5711532,
                    56.5278431
                ],
                [
                    89.5715527,
                    56.5267415
                ],
                [
                    89.5672472,
                    56.5259091
                ],
                [
                    89.566537,
                    56.5219917
                ],
                [
                    89.5615656,
                    56.5216
                ],
                [
                    89.559213,
                    56.5217959
                ],
                [
                    89.5573488,
                    56.5214041
                ],
                [
                    89.5582809,
                    56.5205961
                ],
                [
                    89.5559284,
                    56.5202288
                ],
                [
                    89.5523331,
                    56.5218693
                ],
                [
                    89.5493148,
                    56.5216
                ],
                [
                    89.5437664,
                    56.5221142
                ],
                [
                    89.5433669,
                    56.521551
                ],
                [
                    89.5344451,
                    56.5211103
                ],
                [
                    89.5338681,
                    56.5228487
                ],
                [
                    89.5322702,
                    56.5226038
                ]
            ],
            "longitude": 89.553261,
            "latitude": 56.52467
        },
        "6298": {
            "name": "Боготольский Завод",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    89.5553457,
                    56.1197214
                ],
                [
                    89.5582875,
                    56.125055
                ],
                [
                    89.5607957,
                    56.1279718
                ],
                [
                    89.5629633,
                    56.1274713
                ],
                [
                    89.569497,
                    56.1320791
                ],
                [
                    89.5723769,
                    56.1311645
                ],
                [
                    89.5701473,
                    56.1302498
                ],
                [
                    89.5687229,
                    56.1285758
                ],
                [
                    89.5656573,
                    56.1255383
                ],
                [
                    89.5635207,
                    56.1246408
                ],
                [
                    89.5633038,
                    56.1235016
                ],
                [
                    89.5637373,
                    56.1228802
                ],
                [
                    89.5633038,
                    56.121741
                ],
                [
                    89.5636755,
                    56.1209642
                ],
                [
                    89.5663385,
                    56.1204809
                ],
                [
                    89.5637373,
                    56.1203083
                ],
                [
                    89.5614769,
                    56.1170974
                ],
                [
                    89.560517,
                    56.1109339
                ],
                [
                    89.5601144,
                    56.1110375
                ],
                [
                    89.5563985,
                    56.1130403
                ],
                [
                    89.5560889,
                    56.11563
                ],
                [
                    89.5568321,
                    56.1164069
                ],
                [
                    89.5553457,
                    56.1197214
                ]
            ],
            "longitude": 89.560219,
            "latitude": 56.120888
        },
        "6299": {
            "name": "Можары",
            "population": 173,
            "type": "hamlet",
            "poly": [
                [
                    89.5650024,
                    55.5022869
                ],
                [
                    89.5668417,
                    55.5022033
                ],
                [
                    89.5684043,
                    55.5023312
                ],
                [
                    89.571906,
                    55.502923
                ],
                [
                    89.5748146,
                    55.5033975
                ],
                [
                    89.5769608,
                    55.5034401
                ],
                [
                    89.5792765,
                    55.5035681
                ],
                [
                    89.5797065,
                    55.503679
                ],
                [
                    89.5805771,
                    55.5039656
                ],
                [
                    89.5836847,
                    55.5055179
                ],
                [
                    89.5851849,
                    55.506126
                ],
                [
                    89.5896414,
                    55.5072171
                ],
                [
                    89.5898768,
                    55.508783
                ],
                [
                    89.5901267,
                    55.5095492
                ],
                [
                    89.5900532,
                    55.5096658
                ],
                [
                    89.5897885,
                    55.5094659
                ],
                [
                    89.5893473,
                    55.509366
                ],
                [
                    89.5887884,
                    55.5091744
                ],
                [
                    89.5884648,
                    55.5092161
                ],
                [
                    89.5874058,
                    55.5102572
                ],
                [
                    89.5872734,
                    55.5107319
                ],
                [
                    89.5874646,
                    55.5109234
                ],
                [
                    89.5880088,
                    55.5110734
                ],
                [
                    89.588759,
                    55.511165
                ],
                [
                    89.589259,
                    55.5113565
                ],
                [
                    89.5883872,
                    55.5126488
                ],
                [
                    89.5888578,
                    55.512857
                ],
                [
                    89.5894756,
                    55.512882
                ],
                [
                    89.5899757,
                    55.5127987
                ],
                [
                    89.5904905,
                    55.5128653
                ],
                [
                    89.5912406,
                    55.512907
                ],
                [
                    89.5918289,
                    55.5129736
                ],
                [
                    89.5934321,
                    55.5119409
                ],
                [
                    89.5944764,
                    55.5114412
                ],
                [
                    89.5946675,
                    55.5110581
                ],
                [
                    89.5944911,
                    55.5105334
                ],
                [
                    89.5942411,
                    55.5103835
                ],
                [
                    89.5938734,
                    55.5103668
                ],
                [
                    89.5940499,
                    55.5101086
                ],
                [
                    89.5942999,
                    55.5097505
                ],
                [
                    89.5947853,
                    55.5092591
                ],
                [
                    89.5948147,
                    55.5090426
                ],
                [
                    89.5946088,
                    55.5087427
                ],
                [
                    89.5944764,
                    55.5082596
                ],
                [
                    89.5941087,
                    55.5078682
                ],
                [
                    89.593638,
                    55.5077599
                ],
                [
                    89.5931231,
                    55.5078099
                ],
                [
                    89.593388,
                    55.5073934
                ],
                [
                    89.5939469,
                    55.5064022
                ],
                [
                    89.5942411,
                    55.5058608
                ],
                [
                    89.5941234,
                    55.5048279
                ],
                [
                    89.5946088,
                    55.5039283
                ],
                [
                    89.5952265,
                    55.5035368
                ],
                [
                    89.5959178,
                    55.5035035
                ],
                [
                    89.5971533,
                    55.5033119
                ],
                [
                    89.5974769,
                    55.5032952
                ],
                [
                    89.5980799,
                    55.5028787
                ],
                [
                    89.5981828,
                    55.5022123
                ],
                [
                    89.5994623,
                    55.5023872
                ],
                [
                    89.600845,
                    55.5024206
                ],
                [
                    89.6036837,
                    55.5027538
                ],
                [
                    89.605581,
                    55.5026705
                ],
                [
                    89.6070224,
                    55.5023706
                ],
                [
                    89.6082726,
                    55.5020873
                ],
                [
                    89.6091698,
                    55.5017208
                ],
                [
                    89.6093904,
                    55.5014376
                ],
                [
                    89.6092139,
                    55.5011627
                ],
                [
                    89.6087286,
                    55.5007628
                ],
                [
                    89.6079343,
                    55.5002213
                ],
                [
                    89.6079785,
                    55.4997465
                ],
                [
                    89.608302,
                    55.498955
                ],
                [
                    89.6076255,
                    55.4985718
                ],
                [
                    89.6073166,
                    55.4984468
                ],
                [
                    89.6055516,
                    55.4983385
                ],
                [
                    89.6048456,
                    55.4984968
                ],
                [
                    89.6018452,
                    55.4996548
                ],
                [
                    89.6013304,
                    55.500038
                ],
                [
                    89.6005214,
                    55.500213
                ],
                [
                    89.5977269,
                    55.5005962
                ],
                [
                    89.5968792,
                    55.5004443
                ],
                [
                    89.5956141,
                    55.5007087
                ],
                [
                    89.5911033,
                    55.5014552
                ],
                [
                    89.5905837,
                    55.5017111
                ],
                [
                    89.5902749,
                    55.5017111
                ],
                [
                    89.5899285,
                    55.501549
                ],
                [
                    89.5896876,
                    55.5010969
                ],
                [
                    89.589183,
                    55.5007941
                ],
                [
                    89.588686,
                    55.5007045
                ],
                [
                    89.5867279,
                    55.5007983
                ],
                [
                    89.5852445,
                    55.5007941
                ],
                [
                    89.5845366,
                    55.500841
                ],
                [
                    89.5832263,
                    55.5006832
                ],
                [
                    89.5817052,
                    55.5004912
                ],
                [
                    89.580568,
                    55.5001073
                ],
                [
                    89.5802668,
                    55.500086
                ],
                [
                    89.5796794,
                    55.5001799
                ],
                [
                    89.5757485,
                    55.500231
                ],
                [
                    89.5756355,
                    55.500086
                ],
                [
                    89.5751912,
                    55.4992201
                ],
                [
                    89.5746264,
                    55.4993012
                ],
                [
                    89.5739636,
                    55.4991348
                ],
                [
                    89.5737604,
                    55.4990581
                ],
                [
                    89.572051,
                    55.4990282
                ],
                [
                    89.5718928,
                    55.499395
                ],
                [
                    89.5716895,
                    55.4995528
                ],
                [
                    89.5715615,
                    55.4997533
                ],
                [
                    89.5712377,
                    55.4997832
                ],
                [
                    89.5711398,
                    55.49986
                ],
                [
                    89.5699274,
                    55.4998429
                ],
                [
                    89.5697918,
                    55.4997149
                ],
                [
                    89.5696111,
                    55.499314
                ],
                [
                    89.5682556,
                    55.4991092
                ],
                [
                    89.5678941,
                    55.4991306
                ],
                [
                    89.5676155,
                    55.4992841
                ],
                [
                    89.5675101,
                    55.4994419
                ],
                [
                    89.5669528,
                    55.4993524
                ],
                [
                    89.566757,
                    55.499395
                ],
                [
                    89.5664106,
                    55.4999751
                ],
                [
                    89.566388,
                    55.5004742
                ],
                [
                    89.5661169,
                    55.5010926
                ],
                [
                    89.5655898,
                    55.501822
                ],
                [
                    89.5650024,
                    55.5022869
                ]
            ],
            "longitude": 89.589012,
            "latitude": 55.503826
        },
        "6300": {
            "name": "Шулдат",
            "population": 83,
            "type": "hamlet",
            "poly": [
                [
                    89.584737,
                    56.3879864
                ],
                [
                    89.5852522,
                    56.3889298
                ],
                [
                    89.5859261,
                    56.3890505
                ],
                [
                    89.5887799,
                    56.3885678
                ],
                [
                    89.5931993,
                    56.3870429
                ],
                [
                    89.597797,
                    56.385847
                ],
                [
                    89.6023355,
                    56.3838831
                ],
                [
                    89.6049118,
                    56.3821166
                ],
                [
                    89.6047929,
                    56.3806683
                ],
                [
                    89.605328,
                    56.3804598
                ],
                [
                    89.6050968,
                    56.3801805
                ],
                [
                    89.604892,
                    56.3799331
                ],
                [
                    89.6030885,
                    56.3796368
                ],
                [
                    89.5989069,
                    56.3800648
                ],
                [
                    89.5927236,
                    56.3807012
                ],
                [
                    89.592585,
                    56.382391
                ],
                [
                    89.5912968,
                    56.3838063
                ],
                [
                    89.5913364,
                    56.3841135
                ],
                [
                    89.5853117,
                    56.3864066
                ],
                [
                    89.5866197,
                    56.3873172
                ],
                [
                    89.584737,
                    56.3879864
                ]
            ],
            "longitude": 89.595734,
            "latitude": 56.383949
        },
        "6301": {
            "name": "Имангда Рудная",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.607,
            "latitude": 69.1062
        },
        "6302": {
            "name": "Гудково",
            "population": 177,
            "type": "hamlet",
            "poly": [
                [
                    89.6031229,
                    55.8885936
                ],
                [
                    89.6031766,
                    55.8890644
                ],
                [
                    89.6036131,
                    55.8895276
                ],
                [
                    89.6040026,
                    55.8897498
                ],
                [
                    89.6042913,
                    55.8901942
                ],
                [
                    89.6045868,
                    55.8902883
                ],
                [
                    89.6050838,
                    55.8905481
                ],
                [
                    89.6056815,
                    55.8913201
                ],
                [
                    89.6060172,
                    55.8915725
                ],
                [
                    89.6062791,
                    55.8927436
                ],
                [
                    89.6063615,
                    55.8936397
                ],
                [
                    89.6062154,
                    55.8941361
                ],
                [
                    89.6065463,
                    55.8949892
                ],
                [
                    89.606628,
                    55.8951218
                ],
                [
                    89.6069804,
                    55.895223
                ],
                [
                    89.607277,
                    55.8956736
                ],
                [
                    89.6067053,
                    55.8962086
                ],
                [
                    89.6061079,
                    55.8969412
                ],
                [
                    89.6070578,
                    55.89784
                ],
                [
                    89.6075348,
                    55.8981918
                ],
                [
                    89.607956,
                    55.8985774
                ],
                [
                    89.6083944,
                    55.8988569
                ],
                [
                    89.6091509,
                    55.899922
                ],
                [
                    89.6092688,
                    55.9002041
                ],
                [
                    89.6093443,
                    55.9003846
                ],
                [
                    89.6093099,
                    55.900599
                ],
                [
                    89.6092582,
                    55.9009267
                ],
                [
                    89.609443,
                    55.9012014
                ],
                [
                    89.6096321,
                    55.9013677
                ],
                [
                    89.6105262,
                    55.9015869
                ],
                [
                    89.6116244,
                    55.9019581
                ],
                [
                    89.6125002,
                    55.9019442
                ],
                [
                    89.6126636,
                    55.9019722
                ],
                [
                    89.6142914,
                    55.9018758
                ],
                [
                    89.6145385,
                    55.9017734
                ],
                [
                    89.6147319,
                    55.9014783
                ],
                [
                    89.6149898,
                    55.9013096
                ],
                [
                    89.6144902,
                    55.9007434
                ],
                [
                    89.61456,
                    55.9006169
                ],
                [
                    89.614517,
                    55.9003518
                ],
                [
                    89.6141839,
                    55.8995597
                ],
                [
                    89.614098,
                    55.8991771
                ],
                [
                    89.6138025,
                    55.8989844
                ],
                [
                    89.6138025,
                    55.8987946
                ],
                [
                    89.6143559,
                    55.8985928
                ],
                [
                    89.6149146,
                    55.8982765
                ],
                [
                    89.6151456,
                    55.8980205
                ],
                [
                    89.6151402,
                    55.8976681
                ],
                [
                    89.6152692,
                    55.8973277
                ],
                [
                    89.6153444,
                    55.8969572
                ],
                [
                    89.6148824,
                    55.8962403
                ],
                [
                    89.6139099,
                    55.8957764
                ],
                [
                    89.6139046,
                    55.8956921
                ],
                [
                    89.6142323,
                    55.8954029
                ],
                [
                    89.6146889,
                    55.8951769
                ],
                [
                    89.6141571,
                    55.8927881
                ],
                [
                    89.6137488,
                    55.8926013
                ],
                [
                    89.6136091,
                    55.8923573
                ],
                [
                    89.6139099,
                    55.8917487
                ],
                [
                    89.6138992,
                    55.8914113
                ],
                [
                    89.6132545,
                    55.8906973
                ],
                [
                    89.6127391,
                    55.8904956
                ],
                [
                    89.6116478,
                    55.8896894
                ],
                [
                    89.6110707,
                    55.8893422
                ],
                [
                    89.6097486,
                    55.8891657
                ],
                [
                    89.6092135,
                    55.8889833
                ],
                [
                    89.6079333,
                    55.8887715
                ],
                [
                    89.6071893,
                    55.8887002
                ],
                [
                    89.6062544,
                    55.8885478
                ],
                [
                    89.6059702,
                    55.8884354
                ],
                [
                    89.6052584,
                    55.8880889
                ],
                [
                    89.6042913,
                    55.8878479
                ],
                [
                    89.6037071,
                    55.8878893
                ],
                [
                    89.6033713,
                    55.8880776
                ],
                [
                    89.6031229,
                    55.8885936
                ]
            ],
            "longitude": 89.610802,
            "latitude": 55.893585
        },
        "6303": {
            "name": "Красное Озеро",
            "population": 103,
            "type": "hamlet",
            "poly": [
                [
                    89.6055786,
                    55.338901
                ],
                [
                    89.605636,
                    55.3391116
                ],
                [
                    89.6069829,
                    55.3394673
                ],
                [
                    89.6074872,
                    55.3397505
                ],
                [
                    89.6080808,
                    55.3404584
                ],
                [
                    89.608751,
                    55.3410247
                ],
                [
                    89.6095107,
                    55.341424
                ],
                [
                    89.610066,
                    55.3418669
                ],
                [
                    89.6102064,
                    55.3421573
                ],
                [
                    89.610149,
                    55.343003
                ],
                [
                    89.6098554,
                    55.3437907
                ],
                [
                    89.6105958,
                    55.3439432
                ],
                [
                    89.6108703,
                    55.3438343
                ],
                [
                    89.6120065,
                    55.3438379
                ],
                [
                    89.6126193,
                    55.3439541
                ],
                [
                    89.612964,
                    55.3441465
                ],
                [
                    89.6129576,
                    55.3446365
                ],
                [
                    89.6126704,
                    55.3450648
                ],
                [
                    89.6128555,
                    55.345268
                ],
                [
                    89.6134938,
                    55.3453116
                ],
                [
                    89.6138768,
                    55.3454931
                ],
                [
                    89.6141194,
                    55.3453007
                ],
                [
                    89.6148662,
                    55.3451229
                ],
                [
                    89.6153513,
                    55.3451628
                ],
                [
                    89.6158173,
                    55.3450829
                ],
                [
                    89.6163216,
                    55.3450938
                ],
                [
                    89.6171004,
                    55.3452644
                ],
                [
                    89.6178919,
                    55.3454713
                ],
                [
                    89.6179429,
                    55.3457363
                ],
                [
                    89.6191813,
                    55.3457835
                ],
                [
                    89.6200239,
                    55.3455875
                ],
                [
                    89.6210388,
                    55.3454568
                ],
                [
                    89.6214346,
                    55.3452172
                ],
                [
                    89.6222261,
                    55.3452245
                ],
                [
                    89.6229729,
                    55.3452234
                ],
                [
                    89.6260398,
                    55.3460386
                ],
                [
                    89.6277104,
                    55.3447909
                ],
                [
                    89.6238921,
                    55.3423097
                ],
                [
                    89.6228453,
                    55.3415474
                ],
                [
                    89.622724,
                    55.3412861
                ],
                [
                    89.6201223,
                    55.3401755
                ],
                [
                    89.6167812,
                    55.3387413
                ],
                [
                    89.6137172,
                    55.3389918
                ],
                [
                    89.6129066,
                    55.3389446
                ],
                [
                    89.6101617,
                    55.3385561
                ],
                [
                    89.6088468,
                    55.3383274
                ],
                [
                    89.6076723,
                    55.3378083
                ],
                [
                    89.6068935,
                    55.3379027
                ],
                [
                    89.6064978,
                    55.3377865
                ],
                [
                    89.606319,
                    55.3378228
                ],
                [
                    89.6059041,
                    55.3381931
                ],
                [
                    89.6055786,
                    55.338901
                ]
            ],
            "longitude": 89.618881,
            "latitude": 55.343021
        },
        "6304": {
            "name": "Лозняки",
            "population": 59,
            "type": "hamlet",
            "poly": [
                [
                    89.6152639,
                    56.2527032
                ],
                [
                    89.6168692,
                    56.2536279
                ],
                [
                    89.6179592,
                    56.2538151
                ],
                [
                    89.6201986,
                    56.2541674
                ],
                [
                    89.6226164,
                    56.2540683
                ],
                [
                    89.6241622,
                    56.2541784
                ],
                [
                    89.6246775,
                    56.2547399
                ],
                [
                    89.6254107,
                    56.25485
                ],
                [
                    89.6259062,
                    56.2546848
                ],
                [
                    89.626144,
                    56.2542555
                ],
                [
                    89.6266988,
                    56.2540683
                ],
                [
                    89.6277493,
                    56.2540463
                ],
                [
                    89.6268575,
                    56.2536169
                ],
                [
                    89.6275115,
                    56.2529894
                ],
                [
                    89.6278682,
                    56.2522297
                ],
                [
                    89.6272142,
                    56.2521196
                ],
                [
                    89.6273727,
                    56.2518334
                ],
                [
                    89.6265997,
                    56.2517673
                ],
                [
                    89.625708,
                    56.2517783
                ],
                [
                    89.6247963,
                    56.251371
                ],
                [
                    89.6230326,
                    56.2508315
                ],
                [
                    89.6229335,
                    56.2505232
                ],
                [
                    89.6225371,
                    56.2505012
                ],
                [
                    89.6221408,
                    56.2506553
                ],
                [
                    89.6200599,
                    56.250336
                ],
                [
                    89.6194542,
                    56.2508205
                ],
                [
                    89.619023,
                    56.2506443
                ],
                [
                    89.6188074,
                    56.2508134
                ],
                [
                    89.6190737,
                    56.2510178
                ],
                [
                    89.6187185,
                    56.2513983
                ],
                [
                    89.6171205,
                    56.2515533
                ],
                [
                    89.6166892,
                    56.2513912
                ],
                [
                    89.6164133,
                    56.2514701
                ],
                [
                    89.6152837,
                    56.2522297
                ],
                [
                    89.6152639,
                    56.2527032
                ]
            ],
            "longitude": 89.622231,
            "latitude": 56.252655
        },
        "6305": {
            "name": "Крутоярский",
            "population": 143,
            "type": "hamlet",
            "poly": [
                [
                    89.6174187,
                    55.7235439
                ],
                [
                    89.6195153,
                    55.7242407
                ],
                [
                    89.620283,
                    55.7245763
                ],
                [
                    89.6209704,
                    55.7251118
                ],
                [
                    89.6215318,
                    55.7255118
                ],
                [
                    89.6231702,
                    55.7259119
                ],
                [
                    89.6235827,
                    55.7261119
                ],
                [
                    89.6248315,
                    55.7261183
                ],
                [
                    89.6256908,
                    55.7249828
                ],
                [
                    89.6270083,
                    55.7248021
                ],
                [
                    89.6283145,
                    55.7253957
                ],
                [
                    89.633963,
                    55.7266474
                ],
                [
                    89.6344786,
                    55.7260345
                ],
                [
                    89.6348452,
                    55.7253828
                ],
                [
                    89.6355899,
                    55.7254409
                ],
                [
                    89.6372054,
                    55.7252473
                ],
                [
                    89.6373085,
                    55.725015
                ],
                [
                    89.6367815,
                    55.7243052
                ],
                [
                    89.6364607,
                    55.7240149
                ],
                [
                    89.6365585,
                    55.7238744
                ],
                [
                    89.6366211,
                    55.7237632
                ],
                [
                    89.6369075,
                    55.7226211
                ],
                [
                    89.6368157,
                    55.7225179
                ],
                [
                    89.6358076,
                    55.7224146
                ],
                [
                    89.6357847,
                    55.7223243
                ],
                [
                    89.6249346,
                    55.7217629
                ],
                [
                    89.6249689,
                    55.7216145
                ],
                [
                    89.6223224,
                    55.7213564
                ],
                [
                    89.6222193,
                    55.721408
                ],
                [
                    89.6210735,
                    55.7214403
                ],
                [
                    89.6190456,
                    55.7212789
                ],
                [
                    89.6190227,
                    55.7214596
                ],
                [
                    89.6184613,
                    55.721408
                ],
                [
                    89.6184481,
                    55.7216632
                ],
                [
                    89.6184155,
                    55.721821
                ],
                [
                    89.6177967,
                    55.7218661
                ],
                [
                    89.6175905,
                    55.7220404
                ],
                [
                    89.6174187,
                    55.7235439
                ]
            ],
            "longitude": 89.624985,
            "latitude": 55.722755
        },
        "6306": {
            "name": "Корнилово",
            "population": 236,
            "type": "hamlet",
            "poly": [
                [
                    89.6249395,
                    55.562739
                ],
                [
                    89.625758,
                    55.563548
                ],
                [
                    89.6265858,
                    55.5638469
                ],
                [
                    89.6273039,
                    55.5641289
                ],
                [
                    89.6279389,
                    55.5642142
                ],
                [
                    89.6284017,
                    55.563948
                ],
                [
                    89.6293273,
                    55.5630817
                ],
                [
                    89.631697,
                    55.5636773
                ],
                [
                    89.6320561,
                    55.564124
                ],
                [
                    89.63208,
                    55.5644353
                ],
                [
                    89.6323354,
                    55.5650986
                ],
                [
                    89.6331093,
                    55.5660867
                ],
                [
                    89.6338514,
                    55.5667319
                ],
                [
                    89.634745,
                    55.567165
                ],
                [
                    89.6351758,
                    55.5673815
                ],
                [
                    89.6372026,
                    55.5674627
                ],
                [
                    89.6415033,
                    55.567738
                ],
                [
                    89.6437614,
                    55.5680808
                ],
                [
                    89.6458439,
                    55.5681034
                ],
                [
                    89.6503441,
                    55.5671424
                ],
                [
                    89.6510782,
                    55.5669349
                ],
                [
                    89.651557,
                    55.5646158
                ],
                [
                    89.6533682,
                    55.5602886
                ],
                [
                    89.6528267,
                    55.5599521
                ],
                [
                    89.6527245,
                    55.5592041
                ],
                [
                    89.6516317,
                    55.5590597
                ],
                [
                    89.6508657,
                    55.5588056
                ],
                [
                    89.6486954,
                    55.5587507
                ],
                [
                    89.6476026,
                    55.5585716
                ],
                [
                    89.6469183,
                    55.5583377
                ],
                [
                    89.646857,
                    55.5579449
                ],
                [
                    89.6471277,
                    55.5574713
                ],
                [
                    89.6475566,
                    55.557194
                ],
                [
                    89.6482001,
                    55.5570842
                ],
                [
                    89.6488078,
                    55.5571478
                ],
                [
                    89.6493337,
                    55.5569803
                ],
                [
                    89.6494257,
                    55.5568156
                ],
                [
                    89.6493848,
                    55.5566914
                ],
                [
                    89.648292,
                    55.5565095
                ],
                [
                    89.6474086,
                    55.5564257
                ],
                [
                    89.646377,
                    55.5565124
                ],
                [
                    89.6452536,
                    55.5566395
                ],
                [
                    89.6448655,
                    55.5565961
                ],
                [
                    89.6427871,
                    55.5555246
                ],
                [
                    89.642353,
                    55.5553946
                ],
                [
                    89.6418526,
                    55.5555275
                ],
                [
                    89.6415564,
                    55.5560936
                ],
                [
                    89.6412449,
                    55.5564228
                ],
                [
                    89.6407955,
                    55.5565846
                ],
                [
                    89.6401674,
                    55.5566366
                ],
                [
                    89.6400959,
                    55.5563275
                ],
                [
                    89.6402746,
                    55.5561744
                ],
                [
                    89.6412142,
                    55.555591
                ],
                [
                    89.6412602,
                    55.5551606
                ],
                [
                    89.6408414,
                    55.5546205
                ],
                [
                    89.6409793,
                    55.5543606
                ],
                [
                    89.6412245,
                    55.5542739
                ],
                [
                    89.6424347,
                    55.5542277
                ],
                [
                    89.6430169,
                    55.5540775
                ],
                [
                    89.6429862,
                    55.5536038
                ],
                [
                    89.6428432,
                    55.5534478
                ],
                [
                    89.6417147,
                    55.553494
                ],
                [
                    89.6404585,
                    55.5530839
                ],
                [
                    89.6399069,
                    55.5527026
                ],
                [
                    89.6379409,
                    55.5522375
                ],
                [
                    89.6374864,
                    55.551966
                ],
                [
                    89.6370881,
                    55.5509203
                ],
                [
                    89.6368583,
                    55.5505159
                ],
                [
                    89.6364498,
                    55.5502617
                ],
                [
                    89.6357808,
                    55.549993
                ],
                [
                    89.6352855,
                    55.5500392
                ],
                [
                    89.6348251,
                    55.5497721
                ],
                [
                    89.6334235,
                    55.5500762
                ],
                [
                    89.6333439,
                    55.5520266
                ],
                [
                    89.6327339,
                    55.5531068
                ],
                [
                    89.6318586,
                    55.553917
                ],
                [
                    89.6298694,
                    55.5567673
                ],
                [
                    89.6289941,
                    55.5572024
                ],
                [
                    89.6285697,
                    55.5579074
                ],
                [
                    89.6275883,
                    55.5583424
                ],
                [
                    89.6273231,
                    55.5591825
                ],
                [
                    89.6273231,
                    55.5600525
                ],
                [
                    89.6267723,
                    55.5602811
                ],
                [
                    89.6267728,
                    55.5603189
                ],
                [
                    89.6266655,
                    55.5609254
                ],
                [
                    89.6262723,
                    55.561399
                ],
                [
                    89.6258025,
                    55.5616734
                ],
                [
                    89.6257208,
                    55.5619997
                ],
                [
                    89.6249395,
                    55.562739
                ]
            ],
            "longitude": 89.639183,
            "latitude": 55.560318
        },
        "6307": {
            "name": "Баит",
            "population": 101,
            "type": "hamlet",
            "poly": [
                [
                    89.6360117,
                    55.4253156
                ],
                [
                    89.6366545,
                    55.4274218
                ],
                [
                    89.6364889,
                    55.4275066
                ],
                [
                    89.6363372,
                    55.4275044
                ],
                [
                    89.6371909,
                    55.4294739
                ],
                [
                    89.6380084,
                    55.4311821
                ],
                [
                    89.6385905,
                    55.4321093
                ],
                [
                    89.6393719,
                    55.4328394
                ],
                [
                    89.6410213,
                    55.4339636
                ],
                [
                    89.6411255,
                    55.4339494
                ],
                [
                    89.6418639,
                    55.4336565
                ],
                [
                    89.6421805,
                    55.433642
                ],
                [
                    89.642252,
                    55.4332885
                ],
                [
                    89.6416749,
                    55.4322918
                ],
                [
                    89.642635,
                    55.431892
                ],
                [
                    89.6440035,
                    55.4315443
                ],
                [
                    89.6444019,
                    55.4313878
                ],
                [
                    89.6450504,
                    55.4313588
                ],
                [
                    89.64551,
                    55.4314371
                ],
                [
                    89.6461534,
                    55.4314632
                ],
                [
                    89.646659,
                    55.4313849
                ],
                [
                    89.6469756,
                    55.4312343
                ],
                [
                    89.6469909,
                    55.4309155
                ],
                [
                    89.646659,
                    55.4304577
                ],
                [
                    89.6464854,
                    55.4303302
                ],
                [
                    89.6462658,
                    55.4302752
                ],
                [
                    89.6457806,
                    55.4288554
                ],
                [
                    89.6455406,
                    55.4284642
                ],
                [
                    89.6449585,
                    55.4283193
                ],
                [
                    89.644887,
                    55.4280614
                ],
                [
                    89.6462198,
                    55.4284932
                ],
                [
                    89.6475169,
                    55.428554
                ],
                [
                    89.647859,
                    55.428328
                ],
                [
                    89.6475884,
                    55.4273602
                ],
                [
                    89.6461994,
                    55.4274906
                ],
                [
                    89.6455713,
                    55.4274036
                ],
                [
                    89.6453108,
                    55.4267719
                ],
                [
                    89.6446317,
                    55.4268241
                ],
                [
                    89.6444529,
                    55.4259953
                ],
                [
                    89.6442385,
                    55.4258939
                ],
                [
                    89.6439933,
                    55.4258185
                ],
                [
                    89.643738,
                    55.4254157
                ],
                [
                    89.6437686,
                    55.4245203
                ],
                [
                    89.6439065,
                    55.424129
                ],
                [
                    89.6437125,
                    55.4235755
                ],
                [
                    89.6438555,
                    55.4234364
                ],
                [
                    89.6435745,
                    55.4227988
                ],
                [
                    89.6428188,
                    55.4229727
                ],
                [
                    89.6427984,
                    55.4231205
                ],
                [
                    89.6424818,
                    55.4232046
                ],
                [
                    89.6424665,
                    55.4233842
                ],
                [
                    89.6421411,
                    55.4234666
                ],
                [
                    89.641256,
                    55.4232119
                ],
                [
                    89.639523,
                    55.4228015
                ],
                [
                    89.6389869,
                    55.4224831
                ],
                [
                    89.6384097,
                    55.4224987
                ],
                [
                    89.6378215,
                    55.4223828
                ],
                [
                    89.6374783,
                    55.422603
                ],
                [
                    89.6369431,
                    55.4226285
                ],
                [
                    89.6369104,
                    55.4230273
                ],
                [
                    89.6366245,
                    55.4237089
                ],
                [
                    89.636077,
                    55.4248217
                ],
                [
                    89.6360117,
                    55.4253156
                ]
            ],
            "longitude": 89.642395,
            "latitude": 55.426765
        },
        "6308": {
            "name": "Булатово",
            "population": 223,
            "type": "hamlet",
            "poly": [
                [
                    89.6335393,
                    56.4161034
                ],
                [
                    89.6358857,
                    56.4161034
                ],
                [
                    89.6380895,
                    56.4162349
                ],
                [
                    89.639342,
                    56.4164366
                ],
                [
                    89.6409116,
                    56.4171031
                ],
                [
                    89.6426714,
                    56.4174188
                ],
                [
                    89.6455094,
                    56.4189447
                ],
                [
                    89.6465082,
                    56.4196726
                ],
                [
                    89.6480641,
                    56.4200919
                ],
                [
                    89.6464787,
                    56.4221438
                ],
                [
                    89.6444176,
                    56.4249496
                ],
                [
                    89.6461458,
                    56.4253705
                ],
                [
                    89.6495862,
                    56.422819
                ],
                [
                    89.6507911,
                    56.4214949
                ],
                [
                    89.6506484,
                    56.4204777
                ],
                [
                    89.6518217,
                    56.4204426
                ],
                [
                    89.6529482,
                    56.4200378
                ],
                [
                    89.6570719,
                    56.4206663
                ],
                [
                    89.6612546,
                    56.4206292
                ],
                [
                    89.663984,
                    56.4204271
                ],
                [
                    89.6660641,
                    56.4191419
                ],
                [
                    89.6675051,
                    56.4178398
                ],
                [
                    89.6665715,
                    56.4174077
                ],
                [
                    89.667434,
                    56.416852
                ],
                [
                    89.6661149,
                    56.4162402
                ],
                [
                    89.6654047,
                    56.4166724
                ],
                [
                    89.6626244,
                    56.4161392
                ],
                [
                    89.6607777,
                    56.4173684
                ],
                [
                    89.6591745,
                    56.4172337
                ],
                [
                    89.6542939,
                    56.4162009
                ],
                [
                    89.6474447,
                    56.4156228
                ],
                [
                    89.6418944,
                    56.4141466
                ],
                [
                    89.6360092,
                    56.4142701
                ],
                [
                    89.6356955,
                    56.4142792
                ],
                [
                    89.6356479,
                    56.4149106
                ],
                [
                    89.6340625,
                    56.4149194
                ],
                [
                    89.6335393,
                    56.4161034
                ]
            ],
            "longitude": 89.649681,
            "latitude": 56.417549
        },
        "6309": {
            "name": "Шулдат",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    89.6413834,
                    56.2350118
                ],
                [
                    89.6451818,
                    56.2369675
                ],
                [
                    89.6549569,
                    56.2404753
                ],
                [
                    89.658085,
                    56.2409099
                ],
                [
                    89.6597607,
                    56.2399166
                ],
                [
                    89.66004,
                    56.2367813
                ],
                [
                    89.6593697,
                    56.235881
                ],
                [
                    89.6425006,
                    56.2337078
                ],
                [
                    89.6413834,
                    56.2350118
                ]
            ],
            "longitude": 89.654091,
            "latitude": 56.236656
        },
        "6310": {
            "name": "Куликовка",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    89.6493123,
                    56.5421531
                ],
                [
                    89.6552424,
                    56.5451091
                ],
                [
                    89.6603202,
                    56.5469884
                ],
                [
                    89.6617406,
                    56.5457551
                ],
                [
                    89.6590064,
                    56.5439542
                ],
                [
                    89.6598586,
                    56.5429557
                ],
                [
                    89.6580476,
                    56.5419573
                ],
                [
                    89.6549228,
                    56.5411546
                ],
                [
                    89.6499514,
                    56.5419965
                ],
                [
                    89.6493123,
                    56.5421531
                ]
            ],
            "longitude": 89.656334,
            "latitude": 56.543457
        },
        "6311": {
            "name": "Камышта",
            "population": 111,
            "type": "hamlet",
            "poly": [
                [
                    89.6550276,
                    55.0550378
                ],
                [
                    89.655164,
                    55.0553985
                ],
                [
                    89.6556769,
                    55.0559266
                ],
                [
                    89.6569299,
                    55.056979
                ],
                [
                    89.658118,
                    55.0581726
                ],
                [
                    89.6586049,
                    55.0584924
                ],
                [
                    89.6588841,
                    55.0587899
                ],
                [
                    89.6605591,
                    55.0599798
                ],
                [
                    89.6615525,
                    55.0604966
                ],
                [
                    89.6634028,
                    55.0610283
                ],
                [
                    89.6647467,
                    55.0609725
                ],
                [
                    89.6665127,
                    55.0609539
                ],
                [
                    89.6677073,
                    55.0610469
                ],
                [
                    89.6706288,
                    55.0610618
                ],
                [
                    89.6711222,
                    55.0610729
                ],
                [
                    89.6716741,
                    55.0613555
                ],
                [
                    89.6723558,
                    55.0618352
                ],
                [
                    89.6730115,
                    55.062378
                ],
                [
                    89.6784735,
                    55.0594109
                ],
                [
                    89.6785871,
                    55.0592296
                ],
                [
                    89.6795891,
                    55.0585937
                ],
                [
                    89.680689,
                    55.0578956
                ],
                [
                    89.6809974,
                    55.0577654
                ],
                [
                    89.6816142,
                    55.0577608
                ],
                [
                    89.6857693,
                    55.0581559
                ],
                [
                    89.6861021,
                    55.0581001
                ],
                [
                    89.6879362,
                    55.0569427
                ],
                [
                    89.6871408,
                    55.0531914
                ],
                [
                    89.6863942,
                    55.0505137
                ],
                [
                    89.680089,
                    55.046696
                ],
                [
                    89.6792943,
                    55.0461009
                ],
                [
                    89.6770557,
                    55.0448808
                ],
                [
                    89.6767857,
                    55.0449046
                ],
                [
                    89.6760585,
                    55.045467
                ],
                [
                    89.6752275,
                    55.0460086
                ],
                [
                    89.6755339,
                    55.0453034
                ],
                [
                    89.6759339,
                    55.0447647
                ],
                [
                    89.6761053,
                    55.04436
                ],
                [
                    89.6747462,
                    55.0453554
                ],
                [
                    89.6723496,
                    55.0471352
                ],
                [
                    89.6701685,
                    55.0482467
                ],
                [
                    89.6695599,
                    55.048668
                ],
                [
                    89.6680319,
                    55.0492398
                ],
                [
                    89.6675774,
                    55.0494481
                ],
                [
                    89.6669736,
                    55.049556
                ],
                [
                    89.6656362,
                    55.0496601
                ],
                [
                    89.6645909,
                    55.0499539
                ],
                [
                    89.6608318,
                    55.0514862
                ],
                [
                    89.6596956,
                    55.0517912
                ],
                [
                    89.6591568,
                    55.0520739
                ],
                [
                    89.6577934,
                    55.0528065
                ],
                [
                    89.6570143,
                    55.0531486
                ],
                [
                    89.6565144,
                    55.0534053
                ],
                [
                    89.6553133,
                    55.0542717
                ],
                [
                    89.655125,
                    55.0546064
                ],
                [
                    89.6550276,
                    55.0550378
                ]
            ],
            "longitude": 89.672951,
            "latitude": 55.052593
        },
        "6312": {
            "name": "Куличка",
            "population": 124,
            "type": "hamlet",
            "poly": [
                [
                    89.6649789,
                    55.9880651
                ],
                [
                    89.6666802,
                    55.988672
                ],
                [
                    89.6675998,
                    55.9887823
                ],
                [
                    89.6688917,
                    55.9891558
                ],
                [
                    89.6694281,
                    55.9898049
                ],
                [
                    89.6697018,
                    55.9899519
                ],
                [
                    89.6691216,
                    55.9903315
                ],
                [
                    89.6687603,
                    55.9907173
                ],
                [
                    89.6681144,
                    55.9918256
                ],
                [
                    89.6678516,
                    55.9928482
                ],
                [
                    89.6676874,
                    55.9930809
                ],
                [
                    89.6677531,
                    55.9933135
                ],
                [
                    89.6673261,
                    55.9944708
                ],
                [
                    89.6698879,
                    55.9948749
                ],
                [
                    89.6699536,
                    55.9950341
                ],
                [
                    89.6702054,
                    55.9951504
                ],
                [
                    89.6717205,
                    55.995233
                ],
                [
                    89.6734984,
                    55.9950714
                ],
                [
                    89.6751274,
                    55.9947726
                ],
                [
                    89.6756442,
                    55.9946208
                ],
                [
                    89.6766776,
                    55.9945816
                ],
                [
                    89.6771506,
                    55.994464
                ],
                [
                    89.6766776,
                    55.9937195
                ],
                [
                    89.6766601,
                    55.9934843
                ],
                [
                    89.6769579,
                    55.9931219
                ],
                [
                    89.6775622,
                    55.99297
                ],
                [
                    89.6785694,
                    55.9932051
                ],
                [
                    89.6793139,
                    55.9939007
                ],
                [
                    89.6803386,
                    55.9939252
                ],
                [
                    89.6820552,
                    55.9940819
                ],
                [
                    89.6821953,
                    55.9945473
                ],
                [
                    89.6822216,
                    55.9950126
                ],
                [
                    89.6819939,
                    55.995522
                ],
                [
                    89.6820289,
                    55.9956347
                ],
                [
                    89.6854621,
                    55.9959726
                ],
                [
                    89.6855322,
                    55.995571
                ],
                [
                    89.6857161,
                    55.9953751
                ],
                [
                    89.6859,
                    55.9952869
                ],
                [
                    89.6858825,
                    55.9949146
                ],
                [
                    89.6858387,
                    55.9946403
                ],
                [
                    89.685357,
                    55.9943024
                ],
                [
                    89.6858738,
                    55.9930288
                ],
                [
                    89.684814,
                    55.9929504
                ],
                [
                    89.6838419,
                    55.9926369
                ],
                [
                    89.6823267,
                    55.9925341
                ],
                [
                    89.6816698,
                    55.9922254
                ],
                [
                    89.6814771,
                    55.9917993
                ],
                [
                    89.6816435,
                    55.9913829
                ],
                [
                    89.6820201,
                    55.9911918
                ],
                [
                    89.6822128,
                    55.9910204
                ],
                [
                    89.6828872,
                    55.9907755
                ],
                [
                    89.6841659,
                    55.9907461
                ],
                [
                    89.6846389,
                    55.9908538
                ],
                [
                    89.6858037,
                    55.9912898
                ],
                [
                    89.6858738,
                    55.9912408
                ],
                [
                    89.6854534,
                    55.9905599
                ],
                [
                    89.6854796,
                    55.990168
                ],
                [
                    89.6859613,
                    55.9895606
                ],
                [
                    89.685576,
                    55.9892127
                ],
                [
                    89.6849354,
                    55.9890866
                ],
                [
                    89.6843837,
                    55.9886898
                ],
                [
                    89.6840071,
                    55.9877149
                ],
                [
                    89.6837356,
                    55.9881754
                ],
                [
                    89.6832714,
                    55.9882538
                ],
                [
                    89.6830874,
                    55.9881558
                ],
                [
                    89.6827371,
                    55.9881803
                ],
                [
                    89.6821503,
                    55.988195
                ],
                [
                    89.6803549,
                    55.9879892
                ],
                [
                    89.6796367,
                    55.9879451
                ],
                [
                    89.6794528,
                    55.988097
                ],
                [
                    89.6790674,
                    55.9880921
                ],
                [
                    89.6787346,
                    55.9878031
                ],
                [
                    89.6785507,
                    55.9877345
                ],
                [
                    89.6778062,
                    55.9875875
                ],
                [
                    89.6758532,
                    55.9870976
                ],
                [
                    89.6743905,
                    55.9870437
                ],
                [
                    89.6716755,
                    55.986544
                ],
                [
                    89.6708347,
                    55.9868967
                ],
                [
                    89.669267,
                    55.9874405
                ],
                [
                    89.6686977,
                    55.9871858
                ],
                [
                    89.6677868,
                    55.9872299
                ],
                [
                    89.667489,
                    55.9871613
                ],
                [
                    89.6675591,
                    55.9874895
                ],
                [
                    89.6659668,
                    55.9871245
                ],
                [
                    89.6649789,
                    55.9880651
                ]
            ],
            "longitude": 89.67691,
            "latitude": 55.9902
        },
        "6313": {
            "name": "Солбатский",
            "population": 167,
            "type": "hamlet",
            "poly": [
                [
                    89.703926,
                    55.176659
                ],
                [
                    89.7056178,
                    55.1776844
                ],
                [
                    89.7055245,
                    55.1778385
                ],
                [
                    89.7078495,
                    55.1769613
                ],
                [
                    89.7119805,
                    55.1800966
                ],
                [
                    89.7122088,
                    55.180233
                ],
                [
                    89.7136101,
                    55.1803396
                ],
                [
                    89.7184469,
                    55.1804937
                ],
                [
                    89.7191734,
                    55.1804878
                ],
                [
                    89.7191734,
                    55.1806241
                ],
                [
                    89.7227232,
                    55.1832376
                ],
                [
                    89.7225156,
                    55.1825976
                ],
                [
                    89.722007,
                    55.1816672
                ],
                [
                    89.7211871,
                    55.1809856
                ],
                [
                    89.7205747,
                    55.1805767
                ],
                [
                    89.7204086,
                    55.1802092
                ],
                [
                    89.7206785,
                    55.1797173
                ],
                [
                    89.7209276,
                    55.1792491
                ],
                [
                    89.72154,
                    55.1776607
                ],
                [
                    89.7218513,
                    55.1772458
                ],
                [
                    89.7217268,
                    55.1771214
                ],
                [
                    89.7220278,
                    55.1767894
                ],
                [
                    89.7225052,
                    55.176339
                ],
                [
                    89.7225052,
                    55.175687
                ],
                [
                    89.7227232,
                    55.1750587
                ],
                [
                    89.7232837,
                    55.1744896
                ],
                [
                    89.7233564,
                    55.1741636
                ],
                [
                    89.7231176,
                    55.173885
                ],
                [
                    89.723045,
                    55.1734642
                ],
                [
                    89.7235328,
                    55.1737724
                ],
                [
                    89.7243216,
                    55.1740451
                ],
                [
                    89.7265428,
                    55.1740629
                ],
                [
                    89.7273005,
                    55.1739206
                ],
                [
                    89.7284527,
                    55.1735057
                ],
                [
                    89.7302275,
                    55.1726224
                ],
                [
                    89.7316391,
                    55.1718103
                ],
                [
                    89.7327082,
                    55.1709863
                ],
                [
                    89.726657,
                    55.1681171
                ],
                [
                    89.7227647,
                    55.1700616
                ],
                [
                    89.71908,
                    55.1672812
                ],
                [
                    89.7072682,
                    55.172824
                ],
                [
                    89.7093234,
                    55.1744363
                ],
                [
                    89.7053999,
                    55.1760011
                ],
                [
                    89.703926,
                    55.176659
                ]
            ],
            "longitude": 89.718842,
            "latitude": 55.174152
        },
        "6314": {
            "name": "Горбы",
            "population": 243,
            "type": "hamlet",
            "poly": [
                [
                    89.7200602,
                    55.7596237
                ],
                [
                    89.7202483,
                    55.7598606
                ],
                [
                    89.7208485,
                    55.7601932
                ],
                [
                    89.7212427,
                    55.7606267
                ],
                [
                    89.7210544,
                    55.7608082
                ],
                [
                    89.722452,
                    55.7617204
                ],
                [
                    89.723321,
                    55.7620077
                ],
                [
                    89.7224698,
                    55.7627184
                ],
                [
                    89.7212516,
                    55.7640036
                ],
                [
                    89.7221564,
                    55.7643665
                ],
                [
                    89.7215383,
                    55.764941
                ],
                [
                    89.7212605,
                    55.7654349
                ],
                [
                    89.7211889,
                    55.765697
                ],
                [
                    89.7216547,
                    55.7668359
                ],
                [
                    89.7202211,
                    55.7678488
                ],
                [
                    89.7228369,
                    55.7678891
                ],
                [
                    89.7236968,
                    55.7678539
                ],
                [
                    89.7230967,
                    55.7693656
                ],
                [
                    89.7233117,
                    55.7695319
                ],
                [
                    89.7238134,
                    55.769673
                ],
                [
                    89.7245748,
                    55.7700812
                ],
                [
                    89.7250675,
                    55.7701921
                ],
                [
                    89.7253273,
                    55.770177
                ],
                [
                    89.7266263,
                    55.7695773
                ],
                [
                    89.7270115,
                    55.7695521
                ],
                [
                    89.7276475,
                    55.7696579
                ],
                [
                    89.7284985,
                    55.7701316
                ],
                [
                    89.7289375,
                    55.7702273
                ],
                [
                    89.7293764,
                    55.7701618
                ],
                [
                    89.7300393,
                    55.7701971
                ],
                [
                    89.7345005,
                    55.7724697
                ],
                [
                    89.7360413,
                    55.7731197
                ],
                [
                    89.7370805,
                    55.7731751
                ],
                [
                    89.7385586,
                    55.7732406
                ],
                [
                    89.7389617,
                    55.7731499
                ],
                [
                    89.7397948,
                    55.7726964
                ],
                [
                    89.7410221,
                    55.7722026
                ],
                [
                    89.7412819,
                    55.7719809
                ],
                [
                    89.7413699,
                    55.7718369
                ],
                [
                    89.7414371,
                    55.7714842
                ],
                [
                    89.7411683,
                    55.7712512
                ],
                [
                    89.7365767,
                    55.7691298
                ],
                [
                    89.731459,
                    55.7659802
                ],
                [
                    89.7325117,
                    55.7655158
                ],
                [
                    89.7333448,
                    55.7647649
                ],
                [
                    89.7334165,
                    55.7636864
                ],
                [
                    89.7326371,
                    55.7627288
                ],
                [
                    89.7327178,
                    55.7623911
                ],
                [
                    89.7342317,
                    55.7610403
                ],
                [
                    89.7352888,
                    55.761378
                ],
                [
                    89.7359248,
                    55.7608689
                ],
                [
                    89.7367848,
                    55.7610504
                ],
                [
                    89.7372058,
                    55.7604052
                ],
                [
                    89.7353336,
                    55.7598608
                ],
                [
                    89.73545,
                    55.7596542
                ],
                [
                    89.7350379,
                    55.7592812
                ],
                [
                    89.7352529,
                    55.7590544
                ],
                [
                    89.7350917,
                    55.7587066
                ],
                [
                    89.7332194,
                    55.7581823
                ],
                [
                    89.7328342,
                    55.7579605
                ],
                [
                    89.7321176,
                    55.7577589
                ],
                [
                    89.7306574,
                    55.7574766
                ],
                [
                    89.730102,
                    55.7572901
                ],
                [
                    89.7287134,
                    55.75728
                ],
                [
                    89.7282745,
                    55.757396
                ],
                [
                    89.7278714,
                    55.7575623
                ],
                [
                    89.7283193,
                    55.756907
                ],
                [
                    89.7273517,
                    55.7566802
                ],
                [
                    89.7267964,
                    55.75666
                ],
                [
                    89.7266172,
                    55.7564332
                ],
                [
                    89.7262051,
                    55.7562971
                ],
                [
                    89.7254437,
                    55.7571591
                ],
                [
                    89.7246285,
                    55.7568969
                ],
                [
                    89.7242433,
                    55.7568869
                ],
                [
                    89.7236789,
                    55.757023
                ],
                [
                    89.7221739,
                    55.7578446
                ],
                [
                    89.7216006,
                    55.7582781
                ],
                [
                    89.721314,
                    55.7586965
                ],
                [
                    89.7213498,
                    55.7588326
                ],
                [
                    89.7212154,
                    55.7589082
                ],
                [
                    89.7205081,
                    55.759049
                ],
                [
                    89.720096,
                    55.7593263
                ],
                [
                    89.7200602,
                    55.7596237
                ]
            ],
            "longitude": 89.730804,
            "latitude": 55.765022
        },
        "6315": {
            "name": "Новопетровка",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    89.7195875,
                    56.4263356
                ],
                [
                    89.7280927,
                    56.4316521
                ],
                [
                    89.7286159,
                    56.4314856
                ],
                [
                    89.7306136,
                    56.4326164
                ],
                [
                    89.7322307,
                    56.4317573
                ],
                [
                    89.7338637,
                    56.4325989
                ],
                [
                    89.7345902,
                    56.4324825
                ],
                [
                    89.7355193,
                    56.4319346
                ],
                [
                    89.7343736,
                    56.4313011
                ],
                [
                    89.7347142,
                    56.4309632
                ],
                [
                    89.7344478,
                    56.4300444
                ],
                [
                    89.7364011,
                    56.4291046
                ],
                [
                    89.7360065,
                    56.4285347
                ],
                [
                    89.7347508,
                    56.4279666
                ],
                [
                    89.737909,
                    56.4265007
                ],
                [
                    89.7363109,
                    56.4255958
                ],
                [
                    89.733381,
                    56.4265708
                ],
                [
                    89.7308569,
                    56.4281209
                ],
                [
                    89.7237415,
                    56.4251399
                ],
                [
                    89.7218136,
                    56.425161
                ],
                [
                    89.7195875,
                    56.4263356
                ]
            ],
            "longitude": 89.731277,
            "latitude": 56.429729
        },
        "6316": {
            "name": "Александровка",
            "population": 126,
            "type": "hamlet",
            "poly": [
                [
                    89.7377106,
                    55.8003761
                ],
                [
                    89.7379053,
                    55.8018444
                ],
                [
                    89.7383751,
                    55.8024562
                ],
                [
                    89.7394797,
                    55.8028978
                ],
                [
                    89.7401305,
                    55.8037066
                ],
                [
                    89.7402221,
                    55.8041394
                ],
                [
                    89.7411662,
                    55.8045206
                ],
                [
                    89.7420736,
                    55.8047266
                ],
                [
                    89.7431277,
                    55.8048245
                ],
                [
                    89.7441726,
                    55.8047524
                ],
                [
                    89.7459874,
                    55.8048451
                ],
                [
                    89.7462074,
                    55.8050511
                ],
                [
                    89.7482697,
                    55.8055457
                ],
                [
                    89.7506437,
                    55.8063338
                ],
                [
                    89.7516607,
                    55.806594
                ],
                [
                    89.752482,
                    55.8066652
                ],
                [
                    89.7528902,
                    55.8065755
                ],
                [
                    89.7530873,
                    55.8064278
                ],
                [
                    89.7534628,
                    55.8065228
                ],
                [
                    89.7536128,
                    55.8067681
                ],
                [
                    89.7538462,
                    55.8068036
                ],
                [
                    89.7539858,
                    55.806781
                ],
                [
                    89.7542579,
                    55.8065717
                ],
                [
                    89.7545157,
                    55.806612
                ],
                [
                    89.754974,
                    55.8066603
                ],
                [
                    89.7556328,
                    55.8065959
                ],
                [
                    89.7561341,
                    55.8066844
                ],
                [
                    89.7571939,
                    55.8067729
                ],
                [
                    89.7588265,
                    55.8074571
                ],
                [
                    89.7595569,
                    55.807449
                ],
                [
                    89.7606597,
                    55.8068534
                ],
                [
                    89.7608888,
                    55.8065556
                ],
                [
                    89.7612898,
                    55.8065476
                ],
                [
                    89.761519,
                    55.8055817
                ],
                [
                    89.7597574,
                    55.8041571
                ],
                [
                    89.7597718,
                    55.8039961
                ],
                [
                    89.7605881,
                    55.8040363
                ],
                [
                    89.7604162,
                    55.8038271
                ],
                [
                    89.7605738,
                    55.8024989
                ],
                [
                    89.7597145,
                    55.8024748
                ],
                [
                    89.7586403,
                    55.8022655
                ],
                [
                    89.7583253,
                    55.8019757
                ],
                [
                    89.7580245,
                    55.8009937
                ],
                [
                    89.7577237,
                    55.8005509
                ],
                [
                    89.7569074,
                    55.8002531
                ],
                [
                    89.7565924,
                    55.7998425
                ],
                [
                    89.7567928,
                    55.7982889
                ],
                [
                    89.7564347,
                    55.7980554
                ],
                [
                    89.7556185,
                    55.7977495
                ],
                [
                    89.7546876,
                    55.7977253
                ],
                [
                    89.7539429,
                    55.7974919
                ],
                [
                    89.7522816,
                    55.7971618
                ],
                [
                    89.7517517,
                    55.797355
                ],
                [
                    89.7490019,
                    55.7973953
                ],
                [
                    89.7479994,
                    55.7975321
                ],
                [
                    89.7475268,
                    55.7984982
                ],
                [
                    89.7451263,
                    55.7984522
                ],
                [
                    89.7446193,
                    55.7990817
                ],
                [
                    89.7423278,
                    55.8000348
                ],
                [
                    89.7418466,
                    55.7998545
                ],
                [
                    89.7400937,
                    55.7996291
                ],
                [
                    89.7377106,
                    55.8003761
                ]
            ],
            "longitude": 89.749756,
            "latitude": 55.802021
        },
        "6317": {
            "name": "Икон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.75,
            "latitude": 70.416667
        },
        "6318": {
            "name": "Косоголь",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    89.73849,
                    55.5751528
                ],
                [
                    89.743052,
                    55.5753964
                ],
                [
                    89.7438162,
                    55.575511
                ],
                [
                    89.7438084,
                    55.5759078
                ],
                [
                    89.7450094,
                    55.5762384
                ],
                [
                    89.7468498,
                    55.5764941
                ],
                [
                    89.7472319,
                    55.5763574
                ],
                [
                    89.7479104,
                    55.5751054
                ],
                [
                    89.7485031,
                    55.5750393
                ],
                [
                    89.7498444,
                    55.5751627
                ],
                [
                    89.7501173,
                    55.5753258
                ],
                [
                    89.7508348,
                    55.5755022
                ],
                [
                    89.7539853,
                    55.5754801
                ],
                [
                    89.7550147,
                    55.5752994
                ],
                [
                    89.7557243,
                    55.5747615
                ],
                [
                    89.7581262,
                    55.572201
                ],
                [
                    89.7570719,
                    55.5721622
                ],
                [
                    89.7567225,
                    55.5718659
                ],
                [
                    89.7564106,
                    55.5716331
                ],
                [
                    89.7558429,
                    55.5715767
                ],
                [
                    89.7557493,
                    55.5713051
                ],
                [
                    89.7546388,
                    55.5702116
                ],
                [
                    89.7546138,
                    55.5699224
                ],
                [
                    89.7554062,
                    55.5694356
                ],
                [
                    89.7555247,
                    55.5690617
                ],
                [
                    89.7556432,
                    55.5688818
                ],
                [
                    89.7581075,
                    55.5687125
                ],
                [
                    89.759218,
                    55.5689841
                ],
                [
                    89.7597545,
                    55.5690405
                ],
                [
                    89.7599354,
                    55.5692204
                ],
                [
                    89.759742,
                    55.56988
                ],
                [
                    89.7599292,
                    55.5701763
                ],
                [
                    89.7603534,
                    55.5703739
                ],
                [
                    89.7610522,
                    55.5702786
                ],
                [
                    89.7615282,
                    55.5698726
                ],
                [
                    89.7622228,
                    55.5695006
                ],
                [
                    89.762503,
                    55.5692319
                ],
                [
                    89.7631245,
                    55.5685774
                ],
                [
                    89.7654883,
                    55.5672408
                ],
                [
                    89.7669262,
                    55.5659455
                ],
                [
                    89.7685711,
                    55.5651187
                ],
                [
                    89.7698993,
                    55.5644021
                ],
                [
                    89.7712762,
                    55.5642023
                ],
                [
                    89.7718244,
                    55.563844
                ],
                [
                    89.7722997,
                    55.5636786
                ],
                [
                    89.773238,
                    55.5636304
                ],
                [
                    89.7742127,
                    55.5632307
                ],
                [
                    89.7737132,
                    55.5627277
                ],
                [
                    89.7730674,
                    55.5624039
                ],
                [
                    89.772848,
                    55.5626933
                ],
                [
                    89.7722753,
                    55.5628862
                ],
                [
                    89.7714955,
                    55.5630447
                ],
                [
                    89.7706182,
                    55.5633823
                ],
                [
                    89.7687173,
                    55.5642161
                ],
                [
                    89.766565,
                    55.5646252
                ],
                [
                    89.7658145,
                    55.5647189
                ],
                [
                    89.7653758,
                    55.5646417
                ],
                [
                    89.7642353,
                    55.5646142
                ],
                [
                    89.7627926,
                    55.5651323
                ],
                [
                    89.7612037,
                    55.5663505
                ],
                [
                    89.7608723,
                    55.5668907
                ],
                [
                    89.7601801,
                    55.5674088
                ],
                [
                    89.7594393,
                    55.5677395
                ],
                [
                    89.7579869,
                    55.5680978
                ],
                [
                    89.7566904,
                    55.5682852
                ],
                [
                    89.7560738,
                    55.5680572
                ],
                [
                    89.7552745,
                    55.5679469
                ],
                [
                    89.7546409,
                    55.5678036
                ],
                [
                    89.754017,
                    55.5677761
                ],
                [
                    89.7533249,
                    55.5676658
                ],
                [
                    89.7524671,
                    55.5671643
                ],
                [
                    89.7513753,
                    55.5668666
                ],
                [
                    89.7467451,
                    55.5663154
                ],
                [
                    89.7446005,
                    55.5659792
                ],
                [
                    89.74346,
                    55.5652681
                ],
                [
                    89.7426607,
                    55.564998
                ],
                [
                    89.7417639,
                    55.5648382
                ],
                [
                    89.73849,
                    55.5751528
                ]
            ],
            "longitude": 89.750244,
            "latitude": 55.569962
        },
        "6319": {
            "name": "Сумароково",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.7522487,
            "latitude": 61.6588196
        },
        "6320": {
            "name": "Павловка",
            "population": 117,
            "type": "hamlet",
            "poly": [
                [
                    89.7452088,
                    56.317693
                ],
                [
                    89.7453356,
                    56.317948
                ],
                [
                    89.7463978,
                    56.3186514
                ],
                [
                    89.7461125,
                    56.3188976
                ],
                [
                    89.7474918,
                    56.3202428
                ],
                [
                    89.7496163,
                    56.3220363
                ],
                [
                    89.7506785,
                    56.3230473
                ],
                [
                    89.7518676,
                    56.3234517
                ],
                [
                    89.7524542,
                    56.3241023
                ],
                [
                    89.7539446,
                    56.3259045
                ],
                [
                    89.755752,
                    56.3270121
                ],
                [
                    89.7568141,
                    56.3267747
                ],
                [
                    89.7598107,
                    56.3264846
                ],
                [
                    89.7608412,
                    56.3261858
                ],
                [
                    89.7608729,
                    56.3255704
                ],
                [
                    89.7599375,
                    56.3241199
                ],
                [
                    89.7583362,
                    56.3232583
                ],
                [
                    89.7558154,
                    56.3220363
                ],
                [
                    89.7549909,
                    56.3218693
                ],
                [
                    89.7552605,
                    56.3206208
                ],
                [
                    89.7545312,
                    56.3199438
                ],
                [
                    89.7530726,
                    56.3203571
                ],
                [
                    89.7520262,
                    56.3195042
                ],
                [
                    89.751931,
                    56.3189327
                ],
                [
                    89.7522481,
                    56.3180711
                ],
                [
                    89.7505517,
                    56.3169896
                ],
                [
                    89.7497748,
                    56.3170775
                ],
                [
                    89.7472381,
                    56.3159784
                ],
                [
                    89.7460173,
                    56.3173149
                ],
                [
                    89.7452088,
                    56.317693
                ]
            ],
            "longitude": 89.752785,
            "latitude": 56.321842
        },
        "6321": {
            "name": "Сосновка",
            "population": 56,
            "type": "hamlet",
            "poly": [
                [
                    89.755616,
                    55.3818651
                ],
                [
                    89.7556606,
                    55.3819884
                ],
                [
                    89.7563564,
                    55.3821516
                ],
                [
                    89.7561394,
                    55.3822713
                ],
                [
                    89.7557947,
                    55.3824961
                ],
                [
                    89.7558841,
                    55.3827028
                ],
                [
                    89.7563117,
                    55.3827391
                ],
                [
                    89.7565862,
                    55.3829712
                ],
                [
                    89.756433,
                    55.3831887
                ],
                [
                    89.7559798,
                    55.3834208
                ],
                [
                    89.7559287,
                    55.3836348
                ],
                [
                    89.7560819,
                    55.3837653
                ],
                [
                    89.7568671,
                    55.3837943
                ],
                [
                    89.7570522,
                    55.3839394
                ],
                [
                    89.7569373,
                    55.3841025
                ],
                [
                    89.7561713,
                    55.384476
                ],
                [
                    89.7562351,
                    55.3846791
                ],
                [
                    89.7566359,
                    55.3848756
                ],
                [
                    89.7566511,
                    55.3850265
                ],
                [
                    89.7561457,
                    55.3855225
                ],
                [
                    89.7567993,
                    55.3860099
                ],
                [
                    89.757024,
                    55.3863464
                ],
                [
                    89.7580811,
                    55.3875589
                ],
                [
                    89.7585356,
                    55.3878112
                ],
                [
                    89.7596284,
                    55.3880665
                ],
                [
                    89.7607161,
                    55.388519
                ],
                [
                    89.7613526,
                    55.3888914
                ],
                [
                    89.7618552,
                    55.3889095
                ],
                [
                    89.7637303,
                    55.3893582
                ],
                [
                    89.7644804,
                    55.3896845
                ],
                [
                    89.7652064,
                    55.3896664
                ],
                [
                    89.767289,
                    55.3901649
                ],
                [
                    89.7673049,
                    55.3903507
                ],
                [
                    89.767672,
                    55.3905274
                ],
                [
                    89.7685257,
                    55.3906407
                ],
                [
                    89.7687731,
                    55.3905274
                ],
                [
                    89.7689167,
                    55.3907178
                ],
                [
                    89.7701375,
                    55.3910169
                ],
                [
                    89.7711748,
                    55.3911982
                ],
                [
                    89.7715019,
                    55.3912072
                ],
                [
                    89.7715897,
                    55.3910803
                ],
                [
                    89.7719887,
                    55.3912208
                ],
                [
                    89.7753319,
                    55.3915244
                ],
                [
                    89.7754755,
                    55.3899519
                ],
                [
                    89.7756271,
                    55.3895893
                ],
                [
                    89.7743026,
                    55.3889684
                ],
                [
                    89.7742627,
                    55.3887237
                ],
                [
                    89.7725552,
                    55.3876269
                ],
                [
                    89.7719966,
                    55.3879215
                ],
                [
                    89.7723557,
                    55.3872734
                ],
                [
                    89.7730818,
                    55.3865799
                ],
                [
                    89.7734329,
                    55.3861312
                ],
                [
                    89.7707599,
                    55.3850525
                ],
                [
                    89.7704088,
                    55.3850343
                ],
                [
                    89.7694753,
                    55.3849255
                ],
                [
                    89.7691082,
                    55.3848349
                ],
                [
                    89.7693476,
                    55.3846762
                ],
                [
                    89.7694593,
                    55.3843136
                ],
                [
                    89.7692439,
                    55.383815
                ],
                [
                    89.7687731,
                    55.383398
                ],
                [
                    89.7676879,
                    55.3830898
                ],
                [
                    89.7674087,
                    55.3828632
                ],
                [
                    89.7672012,
                    55.3822014
                ],
                [
                    89.7668262,
                    55.3817435
                ],
                [
                    89.7673049,
                    55.3808369
                ],
                [
                    89.7696508,
                    55.3770244
                ],
                [
                    89.7703087,
                    55.3759076
                ],
                [
                    89.7677122,
                    55.3752356
                ],
                [
                    89.7685484,
                    55.3737304
                ],
                [
                    89.7688165,
                    55.3730013
                ],
                [
                    89.7688804,
                    55.3722614
                ],
                [
                    89.7686889,
                    55.3718261
                ],
                [
                    89.7681718,
                    55.3715541
                ],
                [
                    89.7673867,
                    55.3715287
                ],
                [
                    89.7674314,
                    55.3716701
                ],
                [
                    89.7673675,
                    55.3718588
                ],
                [
                    89.7671186,
                    55.3720292
                ],
                [
                    89.7664803,
                    55.3720365
                ],
                [
                    89.7663207,
                    55.3720982
                ],
                [
                    89.7661356,
                    55.3723448
                ],
                [
                    89.7659313,
                    55.3724972
                ],
                [
                    89.7656632,
                    55.3724754
                ],
                [
                    89.7653121,
                    55.3725987
                ],
                [
                    89.76521,
                    55.3726023
                ],
                [
                    89.7650951,
                    55.3724101
                ],
                [
                    89.7648334,
                    55.3722795
                ],
                [
                    89.7643866,
                    55.3724536
                ],
                [
                    89.764278,
                    55.3726749
                ],
                [
                    89.7638567,
                    55.3727656
                ],
                [
                    89.763244,
                    55.3726749
                ],
                [
                    89.7629056,
                    55.3724899
                ],
                [
                    89.7627588,
                    55.372236
                ],
                [
                    89.7623503,
                    55.3721199
                ],
                [
                    89.7615396,
                    55.3722106
                ],
                [
                    89.7613354,
                    55.3722977
                ],
                [
                    89.7604545,
                    55.372236
                ],
                [
                    89.7602502,
                    55.3727801
                ],
                [
                    89.7602055,
                    55.3733241
                ],
                [
                    89.7598736,
                    55.3737195
                ],
                [
                    89.7598991,
                    55.37389
                ],
                [
                    89.7600715,
                    55.3740133
                ],
                [
                    89.7611183,
                    55.3742092
                ],
                [
                    89.7613481,
                    55.3743071
                ],
                [
                    89.7612715,
                    55.374746
                ],
                [
                    89.7608694,
                    55.3753879
                ],
                [
                    89.7609267,
                    55.3759392
                ],
                [
                    89.760346,
                    55.3762475
                ],
                [
                    89.7597906,
                    55.3763745
                ],
                [
                    89.7595544,
                    55.376632
                ],
                [
                    89.7597332,
                    55.3768967
                ],
                [
                    89.7599438,
                    55.3770781
                ],
                [
                    89.7596438,
                    55.3773428
                ],
                [
                    89.7593374,
                    55.3773573
                ],
                [
                    89.7595097,
                    55.3775096
                ],
                [
                    89.7595927,
                    55.3776185
                ],
                [
                    89.7592672,
                    55.3779158
                ],
                [
                    89.7592161,
                    55.3781008
                ],
                [
                    89.7588395,
                    55.3783003
                ],
                [
                    89.7589225,
                    55.3784127
                ],
                [
                    89.7588777,
                    55.3786122
                ],
                [
                    89.7585969,
                    55.3786883
                ],
                [
                    89.7584054,
                    55.3789023
                ],
                [
                    89.7581501,
                    55.3788914
                ],
                [
                    89.7579139,
                    55.3786956
                ],
                [
                    89.7576714,
                    55.3786412
                ],
                [
                    89.7575884,
                    55.3787971
                ],
                [
                    89.7577863,
                    55.3790256
                ],
                [
                    89.758099,
                    55.3794136
                ],
                [
                    89.7579841,
                    55.3796059
                ],
                [
                    89.7575565,
                    55.3797074
                ],
                [
                    89.7571799,
                    55.3796312
                ],
                [
                    89.7565798,
                    55.3799794
                ],
                [
                    89.7566437,
                    55.3801535
                ],
                [
                    89.7566437,
                    55.3805886
                ],
                [
                    89.7575054,
                    55.3807482
                ],
                [
                    89.757799,
                    55.3809078
                ],
                [
                    89.7577544,
                    55.3810492
                ],
                [
                    89.7573139,
                    55.3811834
                ],
                [
                    89.7572054,
                    55.3813611
                ],
                [
                    89.7576522,
                    55.3815098
                ],
                [
                    89.7575948,
                    55.3816584
                ],
                [
                    89.7573139,
                    55.381702
                ],
                [
                    89.7571543,
                    55.3818216
                ],
                [
                    89.7568414,
                    55.38176
                ],
                [
                    89.7560628,
                    55.3817672
                ],
                [
                    89.755616,
                    55.3818651
                ]
            ],
            "longitude": 89.762428,
            "latitude": 55.381687
        },
        "6322": {
            "name": "Сютик",
            "population": 180,
            "type": "hamlet",
            "poly": [
                [
                    89.7480678,
                    55.8958167
                ],
                [
                    89.7483178,
                    55.8982747
                ],
                [
                    89.7498204,
                    55.8982007
                ],
                [
                    89.7509388,
                    55.8980142
                ],
                [
                    89.7519424,
                    55.8980625
                ],
                [
                    89.7527798,
                    55.8979531
                ],
                [
                    89.7541963,
                    55.8979242
                ],
                [
                    89.7543741,
                    55.8977763
                ],
                [
                    89.7553721,
                    55.8978792
                ],
                [
                    89.755395,
                    55.8980335
                ],
                [
                    89.757238,
                    55.8977108
                ],
                [
                    89.7585822,
                    55.8989719
                ],
                [
                    89.7594245,
                    55.8991126
                ],
                [
                    89.7603475,
                    55.8992281
                ],
                [
                    89.7609121,
                    55.899409
                ],
                [
                    89.7606522,
                    55.89963
                ],
                [
                    89.760482,
                    55.8999164
                ],
                [
                    89.7604551,
                    55.9004289
                ],
                [
                    89.7602579,
                    55.9006198
                ],
                [
                    89.7597471,
                    55.9005695
                ],
                [
                    89.7594425,
                    55.9005344
                ],
                [
                    89.7590571,
                    55.9007102
                ],
                [
                    89.7589406,
                    55.9011774
                ],
                [
                    89.7591288,
                    55.9015542
                ],
                [
                    89.7595321,
                    55.9016346
                ],
                [
                    89.7598278,
                    55.9017853
                ],
                [
                    89.7598995,
                    55.9021118
                ],
                [
                    89.7599712,
                    55.9022927
                ],
                [
                    89.7604103,
                    55.9024484
                ],
                [
                    89.7606522,
                    55.9024685
                ],
                [
                    89.7617545,
                    55.9024886
                ],
                [
                    89.7623459,
                    55.9028051
                ],
                [
                    89.7629463,
                    55.9028101
                ],
                [
                    89.7636901,
                    55.9029809
                ],
                [
                    89.7643084,
                    55.9029207
                ],
                [
                    89.766244,
                    55.9023027
                ],
                [
                    89.7666921,
                    55.9015241
                ],
                [
                    89.7669609,
                    55.9013784
                ],
                [
                    89.7686546,
                    55.9014788
                ],
                [
                    89.7687532,
                    55.9012729
                ],
                [
                    89.7702318,
                    55.9005344
                ],
                [
                    89.7704827,
                    55.9005746
                ],
                [
                    89.7707605,
                    55.9007906
                ],
                [
                    89.7707336,
                    55.9010518
                ],
                [
                    89.7716118,
                    55.9014839
                ],
                [
                    89.7732338,
                    55.9017451
                ],
                [
                    89.773646,
                    55.9018406
                ],
                [
                    89.7739327,
                    55.9020666
                ],
                [
                    89.7740977,
                    55.9026169
                ],
                [
                    89.7765351,
                    55.9031243
                ],
                [
                    89.7762842,
                    55.9029082
                ],
                [
                    89.7757489,
                    55.9022319
                ],
                [
                    89.7757372,
                    55.9020327
                ],
                [
                    89.7753274,
                    55.9017491
                ],
                [
                    89.7748829,
                    55.9004679
                ],
                [
                    89.774637,
                    55.9000276
                ],
                [
                    89.7736166,
                    55.8991694
                ],
                [
                    89.7737596,
                    55.899114
                ],
                [
                    89.7738625,
                    55.8990851
                ],
                [
                    89.7743103,
                    55.899437
                ],
                [
                    89.7756464,
                    55.8987805
                ],
                [
                    89.7753785,
                    55.8987579
                ],
                [
                    89.7751876,
                    55.8986735
                ],
                [
                    89.7747765,
                    55.8986015
                ],
                [
                    89.7743067,
                    55.8984512
                ],
                [
                    89.7745342,
                    55.8982434
                ],
                [
                    89.7744205,
                    55.8981611
                ],
                [
                    89.7744131,
                    55.8978009
                ],
                [
                    89.774292,
                    55.897589
                ],
                [
                    89.7732753,
                    55.8971938
                ],
                [
                    89.772699,
                    55.8971527
                ],
                [
                    89.7723797,
                    55.8969963
                ],
                [
                    89.772053,
                    55.8966485
                ],
                [
                    89.7711427,
                    55.8966258
                ],
                [
                    89.7705884,
                    55.8964838
                ],
                [
                    89.7705004,
                    55.8958664
                ],
                [
                    89.7700819,
                    55.8957676
                ],
                [
                    89.7697039,
                    55.895533
                ],
                [
                    89.7697631,
                    55.8951863
                ],
                [
                    89.7694763,
                    55.8949291
                ],
                [
                    89.7695509,
                    55.8947104
                ],
                [
                    89.7702391,
                    55.8943052
                ],
                [
                    89.7708585,
                    55.8941927
                ],
                [
                    89.7712255,
                    55.8942184
                ],
                [
                    89.77165,
                    55.8944081
                ],
                [
                    89.7719252,
                    55.8943856
                ],
                [
                    89.7711625,
                    55.8938196
                ],
                [
                    89.7708585,
                    55.8934176
                ],
                [
                    89.7707954,
                    55.8929803
                ],
                [
                    89.770566,
                    55.8927037
                ],
                [
                    89.7707954,
                    55.8926137
                ],
                [
                    89.7707209,
                    55.8925397
                ],
                [
                    89.7704513,
                    55.892514
                ],
                [
                    89.7702162,
                    55.8925847
                ],
                [
                    89.7699065,
                    55.8925172
                ],
                [
                    89.7699007,
                    55.8922631
                ],
                [
                    89.7693387,
                    55.8920283
                ],
                [
                    89.7690519,
                    55.8917035
                ],
                [
                    89.7689888,
                    55.8915234
                ],
                [
                    89.769201,
                    55.8912887
                ],
                [
                    89.7695107,
                    55.8911632
                ],
                [
                    89.769419,
                    55.8909606
                ],
                [
                    89.7689315,
                    55.8908062
                ],
                [
                    89.7689745,
                    55.8903298
                ],
                [
                    89.7673525,
                    55.8896062
                ],
                [
                    89.7659277,
                    55.8887016
                ],
                [
                    89.7657037,
                    55.8886564
                ],
                [
                    89.7642251,
                    55.8870784
                ],
                [
                    89.7632595,
                    55.8878962
                ],
                [
                    89.7627129,
                    55.8880771
                ],
                [
                    89.7616375,
                    55.8886249
                ],
                [
                    89.7616017,
                    55.8893787
                ],
                [
                    89.7610013,
                    55.8904491
                ],
                [
                    89.7604546,
                    55.8908209
                ],
                [
                    89.7583936,
                    55.8913235
                ],
                [
                    89.7553378,
                    55.8917606
                ],
                [
                    89.7529272,
                    55.8919817
                ],
                [
                    89.7522731,
                    55.8921224
                ],
                [
                    89.7520311,
                    55.8922481
                ],
                [
                    89.7523627,
                    55.8927908
                ],
                [
                    89.7526674,
                    55.8932631
                ],
                [
                    89.7527211,
                    55.8936651
                ],
                [
                    89.7524702,
                    55.8939716
                ],
                [
                    89.7517175,
                    55.8942932
                ],
                [
                    89.7500328,
                    55.8952228
                ],
                [
                    89.7480678,
                    55.8958167
                ]
            ],
            "longitude": 89.76609,
            "latitude": 55.896492
        },
        "6323": {
            "name": "Вагино",
            "population": 138,
            "type": "hamlet",
            "poly": [
                [
                    89.7596573,
                    56.2122988
                ],
                [
                    89.7605063,
                    56.2131188
                ],
                [
                    89.7620793,
                    56.2126099
                ],
                [
                    89.7649105,
                    56.2145184
                ],
                [
                    89.7849587,
                    56.2084904
                ],
                [
                    89.7848729,
                    56.2071066
                ],
                [
                    89.7861027,
                    56.2058022
                ],
                [
                    89.7845652,
                    56.204975
                ],
                [
                    89.7803737,
                    56.2038857
                ],
                [
                    89.7789299,
                    56.204281
                ],
                [
                    89.7768045,
                    56.204863
                ],
                [
                    89.7724849,
                    56.2055757
                ],
                [
                    89.7632416,
                    56.2085178
                ],
                [
                    89.7596573,
                    56.2122988
                ]
            ],
            "longitude": 89.772102,
            "latitude": 56.208103
        },
        "6324": {
            "name": "Орга",
            "population": 228,
            "type": "hamlet",
            "poly": [
                [
                    89.7680005,
                    56.1523717
                ],
                [
                    89.7680292,
                    56.1548725
                ],
                [
                    89.7723477,
                    56.154984
                ],
                [
                    89.7723191,
                    56.1555734
                ],
                [
                    89.778917,
                    56.1575036
                ],
                [
                    89.7791405,
                    56.1570059
                ],
                [
                    89.7805369,
                    56.157037
                ],
                [
                    89.7824919,
                    56.157317
                ],
                [
                    89.7831622,
                    56.1566948
                ],
                [
                    89.7819334,
                    56.156477
                ],
                [
                    89.7824471,
                    56.1558038
                ],
                [
                    89.7834125,
                    56.1558636
                ],
                [
                    89.7853787,
                    56.1548482
                ],
                [
                    89.7857362,
                    56.1552663
                ],
                [
                    89.7873091,
                    56.1554056
                ],
                [
                    89.7884173,
                    56.1558038
                ],
                [
                    89.7892038,
                    56.1543106
                ],
                [
                    89.7884888,
                    56.1541115
                ],
                [
                    89.7888106,
                    56.1512243
                ],
                [
                    89.7849854,
                    56.1506468
                ],
                [
                    89.7844134,
                    56.1499897
                ],
                [
                    89.7833767,
                    56.1497308
                ],
                [
                    89.7834482,
                    56.149014
                ],
                [
                    89.7844492,
                    56.1486157
                ],
                [
                    89.7840917,
                    56.1482572
                ],
                [
                    89.7799806,
                    56.1484564
                ],
                [
                    89.7779786,
                    56.1488347
                ],
                [
                    89.7774066,
                    56.1481178
                ],
                [
                    89.7741892,
                    56.1496313
                ],
                [
                    89.7704713,
                    56.1491334
                ],
                [
                    89.7695061,
                    56.150607
                ],
                [
                    89.7689158,
                    56.1506672
                ],
                [
                    89.7680005,
                    56.1523717
                ]
            ],
            "longitude": 89.779404,
            "latitude": 56.153389
        },
        "6325": {
            "name": "Кутузовка",
            "population": 167,
            "type": "hamlet",
            "poly": [
                [
                    89.7626734,
                    55.1293352
                ],
                [
                    89.7666798,
                    55.1295132
                ],
                [
                    89.7744808,
                    55.1293605
                ],
                [
                    89.7777547,
                    55.1294005
                ],
                [
                    89.7808581,
                    55.1294479
                ],
                [
                    89.7817723,
                    55.1295987
                ],
                [
                    89.7818636,
                    55.1295042
                ],
                [
                    89.7827723,
                    55.1292702
                ],
                [
                    89.7845685,
                    55.1293492
                ],
                [
                    89.7901804,
                    55.1296561
                ],
                [
                    89.79467,
                    55.1298539
                ],
                [
                    89.794692,
                    55.129735
                ],
                [
                    89.7917027,
                    55.1293628
                ],
                [
                    89.7907528,
                    55.1281209
                ],
                [
                    89.7907594,
                    55.1279234
                ],
                [
                    89.7915964,
                    55.1268258
                ],
                [
                    89.7905469,
                    55.1265675
                ],
                [
                    89.7860563,
                    55.1251584
                ],
                [
                    89.7842428,
                    55.1241898
                ],
                [
                    89.7838642,
                    55.1245772
                ],
                [
                    89.7830604,
                    55.1244443
                ],
                [
                    89.7814056,
                    55.124066
                ],
                [
                    89.7815704,
                    55.1244367
                ],
                [
                    89.7814854,
                    55.1245948
                ],
                [
                    89.7798061,
                    55.1256978
                ],
                [
                    89.779264,
                    55.1256765
                ],
                [
                    89.7786688,
                    55.1254729
                ],
                [
                    89.7779301,
                    55.1254699
                ],
                [
                    89.7771383,
                    55.1252055
                ],
                [
                    89.7762402,
                    55.1244459
                ],
                [
                    89.7743696,
                    55.1231939
                ],
                [
                    89.7722811,
                    55.1219845
                ],
                [
                    89.7713989,
                    55.1217505
                ],
                [
                    89.7713723,
                    55.1233124
                ],
                [
                    89.7711385,
                    55.1243152
                ],
                [
                    89.7709737,
                    55.1244489
                ],
                [
                    89.7705805,
                    55.1244732
                ],
                [
                    89.7690447,
                    55.1242423
                ],
                [
                    89.7660155,
                    55.1239931
                ],
                [
                    89.7658242,
                    55.1243425
                ],
                [
                    89.7657658,
                    55.1260351
                ],
                [
                    89.7656967,
                    55.1262174
                ],
                [
                    89.7656382,
                    55.1278916
                ],
                [
                    89.7654788,
                    55.1282805
                ],
                [
                    89.765455,
                    55.128629
                ],
                [
                    89.7652786,
                    55.1289257
                ],
                [
                    89.7646247,
                    55.128991
                ],
                [
                    89.7637009,
                    55.1291572
                ],
                [
                    89.7626734,
                    55.1293352
                ]
            ],
            "longitude": 89.780479,
            "latitude": 55.127594
        },
        "6326": {
            "name": "Сухая Долина",
            "population": 259,
            "type": "hamlet",
            "poly": [
                [
                    89.7661033,
                    55.2300208
                ],
                [
                    89.7678753,
                    55.2304197
                ],
                [
                    89.7686923,
                    55.2305624
                ],
                [
                    89.7698955,
                    55.2306955
                ],
                [
                    89.7679089,
                    55.2398279
                ],
                [
                    89.7691396,
                    55.2397551
                ],
                [
                    89.7700844,
                    55.2396095
                ],
                [
                    89.7705388,
                    55.2397493
                ],
                [
                    89.7724283,
                    55.2398861
                ],
                [
                    89.7743024,
                    55.2401656
                ],
                [
                    89.7770702,
                    55.2407304
                ],
                [
                    89.7790567,
                    55.240943
                ],
                [
                    89.7800371,
                    55.2411759
                ],
                [
                    89.781661,
                    55.2417436
                ],
                [
                    89.7828866,
                    55.2420231
                ],
                [
                    89.7883711,
                    55.2427393
                ],
                [
                    89.7916342,
                    55.2430974
                ],
                [
                    89.7914198,
                    55.2425238
                ],
                [
                    89.7914402,
                    55.2419678
                ],
                [
                    89.7919355,
                    55.2406344
                ],
                [
                    89.7927401,
                    55.2379133
                ],
                [
                    89.7927657,
                    55.2374708
                ],
                [
                    89.7924848,
                    55.2369146
                ],
                [
                    89.7923316,
                    55.2364837
                ],
                [
                    89.792301,
                    55.2361838
                ],
                [
                    89.7932304,
                    55.2364109
                ],
                [
                    89.7930253,
                    55.2307983
                ],
                [
                    89.7903086,
                    55.2306818
                ],
                [
                    89.7863561,
                    55.2305886
                ],
                [
                    89.7859271,
                    55.2306352
                ],
                [
                    89.7844054,
                    55.2303236
                ],
                [
                    89.7819184,
                    55.229881
                ],
                [
                    89.780555,
                    55.2298519
                ],
                [
                    89.7780578,
                    55.2294791
                ],
                [
                    89.7766229,
                    55.2294966
                ],
                [
                    89.77337,
                    55.2298082
                ],
                [
                    89.7692234,
                    55.2299858
                ],
                [
                    89.7661033,
                    55.2300208
                ]
            ],
            "longitude": 89.783333,
            "latitude": 55.236187
        },
        "6327": {
            "name": "Чиндат",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    89.7736491,
                    56.5578878
                ],
                [
                    89.7773217,
                    56.5603625
                ],
                [
                    89.7799034,
                    56.5599718
                ],
                [
                    89.7822123,
                    56.5591903
                ],
                [
                    89.7830487,
                    56.5587194
                ],
                [
                    89.784994,
                    56.5586894
                ],
                [
                    89.7861031,
                    56.5588998
                ],
                [
                    89.7887029,
                    56.5589899
                ],
                [
                    89.7903574,
                    56.5584289
                ],
                [
                    89.791321,
                    56.5584289
                ],
                [
                    89.7919937,
                    56.5587695
                ],
                [
                    89.7944663,
                    56.5587695
                ],
                [
                    89.7960662,
                    56.5570362
                ],
                [
                    89.7958662,
                    56.5567756
                ],
                [
                    89.7952662,
                    56.5565652
                ],
                [
                    89.7931573,
                    56.5567456
                ],
                [
                    89.7906119,
                    56.555954
                ],
                [
                    89.7904483,
                    56.5557536
                ],
                [
                    89.7888302,
                    56.5556935
                ],
                [
                    89.7876666,
                    56.5560442
                ],
                [
                    89.7819033,
                    56.5562446
                ],
                [
                    89.7803033,
                    56.5565652
                ],
                [
                    89.7800852,
                    56.5560342
                ],
                [
                    89.7764308,
                    56.5562246
                ],
                [
                    89.7743763,
                    56.5566354
                ],
                [
                    89.7737764,
                    56.5572165
                ],
                [
                    89.7736491,
                    56.5578878
                ]
            ],
            "longitude": 89.785667,
            "latitude": 56.557655
        },
        "6328": {
            "name": "Никольск",
            "population": 44,
            "type": "hamlet",
            "poly": [
                [
                    89.7802582,
                    56.5535313
                ],
                [
                    89.7811654,
                    56.5534846
                ],
                [
                    89.7847719,
                    56.5526895
                ],
                [
                    89.7991422,
                    56.5527812
                ],
                [
                    89.7994195,
                    56.5511298
                ],
                [
                    89.7967564,
                    56.5474903
                ],
                [
                    89.7910815,
                    56.5480196
                ],
                [
                    89.7871612,
                    56.5486459
                ],
                [
                    89.7831841,
                    56.5478943
                ],
                [
                    89.7807411,
                    56.5480039
                ],
                [
                    89.7807411,
                    56.5503214
                ],
                [
                    89.7802932,
                    56.5532984
                ],
                [
                    89.7802582,
                    56.5535313
                ]
            ],
            "longitude": 89.788528,
            "latitude": 56.550442
        },
        "6329": {
            "name": "Ильинка",
            "population": 188,
            "type": "hamlet",
            "poly": [
                [
                    89.7870079,
                    56.3633699
                ],
                [
                    89.7884447,
                    56.3644128
                ],
                [
                    89.7903274,
                    56.3636855
                ],
                [
                    89.7914421,
                    56.3647833
                ],
                [
                    89.793622,
                    56.3640423
                ],
                [
                    89.7933744,
                    56.3636855
                ],
                [
                    89.794613,
                    56.3633562
                ],
                [
                    89.7945883,
                    56.3638914
                ],
                [
                    89.795703,
                    56.3653321
                ],
                [
                    89.7955792,
                    56.3663887
                ],
                [
                    89.7958517,
                    56.3666082
                ],
                [
                    89.7964214,
                    56.3664436
                ],
                [
                    89.7982298,
                    56.3677333
                ],
                [
                    89.798973,
                    56.3680214
                ],
                [
                    89.7988739,
                    56.3683645
                ],
                [
                    89.7994685,
                    56.3685703
                ],
                [
                    89.7994932,
                    56.3688447
                ],
                [
                    89.8015245,
                    56.3693523
                ],
                [
                    89.8020696,
                    56.369023
                ],
                [
                    89.8026393,
                    56.3692151
                ],
                [
                    89.8025155,
                    56.3694895
                ],
                [
                    89.8089068,
                    56.3710535
                ],
                [
                    89.8100711,
                    56.3702167
                ],
                [
                    89.8103436,
                    56.3692974
                ],
                [
                    89.8100463,
                    56.3688447
                ],
                [
                    89.8081884,
                    56.3681998
                ],
                [
                    89.8082875,
                    56.3680352
                ],
                [
                    89.8068259,
                    56.3674452
                ],
                [
                    89.8029366,
                    56.3663887
                ],
                [
                    89.803333,
                    56.3661143
                ],
                [
                    89.8022924,
                    56.3656889
                ],
                [
                    89.8015989,
                    56.3661005
                ],
                [
                    89.800831,
                    56.3646872
                ],
                [
                    89.8013263,
                    56.3645363
                ],
                [
                    89.8002612,
                    56.3630543
                ],
                [
                    89.7993446,
                    56.3631229
                ],
                [
                    89.7991464,
                    56.3627936
                ],
                [
                    89.7998896,
                    56.3626975
                ],
                [
                    89.7980317,
                    56.3597608
                ],
                [
                    89.7962337,
                    56.3597832
                ],
                [
                    89.7958269,
                    56.3597883
                ],
                [
                    89.7949599,
                    56.3596648
                ],
                [
                    89.793622,
                    56.360049
                ],
                [
                    89.7930523,
                    56.360694
                ],
                [
                    89.7904512,
                    56.3614762
                ],
                [
                    89.7899011,
                    56.3619681
                ],
                [
                    89.7870079,
                    56.3633699
                ]
            ],
            "longitude": 89.79953,
            "latitude": 56.364883
        },
        "6330": {
            "name": "Птицетоварной фермы",
            "population": 122,
            "type": "hamlet",
            "poly": [
                [
                    89.8029874,
                    56.1913588
                ],
                [
                    89.8044587,
                    56.1915451
                ],
                [
                    89.8048747,
                    56.191387
                ],
                [
                    89.8052501,
                    56.1914491
                ],
                [
                    89.8052907,
                    56.1918104
                ],
                [
                    89.8066098,
                    56.1916354
                ],
                [
                    89.8072288,
                    56.1916975
                ],
                [
                    89.8065285,
                    56.1925218
                ],
                [
                    89.8060112,
                    56.1924936
                ],
                [
                    89.805514,
                    56.1930017
                ],
                [
                    89.8056763,
                    56.1938993
                ],
                [
                    89.8067417,
                    56.1938147
                ],
                [
                    89.80662,
                    56.1929565
                ],
                [
                    89.8068736,
                    56.1926912
                ],
                [
                    89.8077767,
                    56.1927025
                ],
                [
                    89.8082942,
                    56.1921492
                ],
                [
                    89.8098365,
                    56.1922847
                ],
                [
                    89.8110237,
                    56.1906474
                ],
                [
                    89.8092683,
                    56.1900771
                ],
                [
                    89.8094103,
                    56.1887954
                ],
                [
                    89.8078071,
                    56.1886543
                ],
                [
                    89.8075433,
                    56.1884792
                ],
                [
                    89.8048646,
                    56.1886204
                ],
                [
                    89.8047327,
                    56.189552
                ],
                [
                    89.8041137,
                    56.1895238
                ],
                [
                    89.8041542,
                    56.1889366
                ],
                [
                    89.8035455,
                    56.1889705
                ],
                [
                    89.8035352,
                    56.1895577
                ],
                [
                    89.8031092,
                    56.189569
                ],
                [
                    89.8030889,
                    56.1897835
                ],
                [
                    89.8033628,
                    56.190111
                ],
                [
                    89.8029874,
                    56.1913588
                ]
            ],
            "longitude": 89.807266,
            "latitude": 56.190407
        },
        "6331": {
            "name": "Белая Роща",
            "population": 214,
            "type": "hamlet",
            "poly": [
                [
                    89.8311533,
                    55.5013851
                ],
                [
                    89.8335392,
                    55.5043162
                ],
                [
                    89.8371358,
                    55.5043162
                ],
                [
                    89.838845,
                    55.5039935
                ],
                [
                    89.8415039,
                    55.5031868
                ],
                [
                    89.8441153,
                    55.5019229
                ],
                [
                    89.846151,
                    55.501291
                ],
                [
                    89.8468216,
                    55.5008472
                ],
                [
                    89.8475813,
                    55.4998791
                ],
                [
                    89.8475813,
                    55.4984269
                ],
                [
                    89.8474863,
                    55.4966787
                ],
                [
                    89.838845,
                    55.4925636
                ],
                [
                    89.8370408,
                    55.4932898
                ],
                [
                    89.835379,
                    55.4940429
                ],
                [
                    89.8340021,
                    55.495307
                ],
                [
                    89.8339546,
                    55.4966787
                ],
                [
                    89.8340021,
                    55.4981041
                ],
                [
                    89.834287,
                    55.4991261
                ],
                [
                    89.8339072,
                    55.5003901
                ],
                [
                    89.8311533,
                    55.5013851
                ]
            ],
            "longitude": 89.838203,
            "latitude": 55.497066
        },
        "6332": {
            "name": "Березняки",
            "population": 260,
            "type": "hamlet",
            "poly": [
                [
                    89.8372729,
                    55.7252801
                ],
                [
                    89.8378098,
                    55.7268351
                ],
                [
                    89.8382086,
                    55.7270338
                ],
                [
                    89.8401556,
                    55.7275222
                ],
                [
                    89.8410773,
                    55.727699
                ],
                [
                    89.8417063,
                    55.7280445
                ],
                [
                    89.8419671,
                    55.7285887
                ],
                [
                    89.841783,
                    55.7291848
                ],
                [
                    89.8413074,
                    55.7297722
                ],
                [
                    89.8410159,
                    55.729919
                ],
                [
                    89.840479,
                    55.7304805
                ],
                [
                    89.8405097,
                    55.730852
                ],
                [
                    89.8448357,
                    55.7330978
                ],
                [
                    89.8458668,
                    55.7331531
                ],
                [
                    89.8465049,
                    55.7328712
                ],
                [
                    89.8467995,
                    55.7326611
                ],
                [
                    89.8495092,
                    55.7325893
                ],
                [
                    89.8494897,
                    55.7323847
                ],
                [
                    89.8490379,
                    55.7321636
                ],
                [
                    89.8484784,
                    55.731362
                ],
                [
                    89.8478501,
                    55.7313233
                ],
                [
                    89.8472512,
                    55.7314726
                ],
                [
                    89.8464166,
                    55.73087
                ],
                [
                    89.8470254,
                    55.7302232
                ],
                [
                    89.846937,
                    55.7299468
                ],
                [
                    89.8473494,
                    55.7297312
                ],
                [
                    89.8485079,
                    55.7301071
                ],
                [
                    89.8505991,
                    55.7304499
                ],
                [
                    89.8515613,
                    55.7305549
                ],
                [
                    89.8520816,
                    55.7304886
                ],
                [
                    89.8564604,
                    55.7306655
                ],
                [
                    89.8563719,
                    55.7302729
                ],
                [
                    89.854811,
                    55.728056
                ],
                [
                    89.8538336,
                    55.726862
                ],
                [
                    89.8514533,
                    55.7237434
                ],
                [
                    89.8508642,
                    55.7233121
                ],
                [
                    89.8477965,
                    55.7214614
                ],
                [
                    89.8479192,
                    55.7207701
                ],
                [
                    89.8476431,
                    55.7207788
                ],
                [
                    89.8478272,
                    55.7202172
                ],
                [
                    89.845342,
                    55.7203209
                ],
                [
                    89.8437619,
                    55.7207269
                ],
                [
                    89.8421511,
                    55.7214095
                ],
                [
                    89.8399728,
                    55.7222735
                ],
                [
                    89.8379478,
                    55.7234572
                ],
                [
                    89.8373649,
                    55.7239064
                ],
                [
                    89.8372729,
                    55.7252801
                ]
            ],
            "longitude": 89.8442,
            "latitude": 55.7243
        },
        "6333": {
            "name": "Разгуляевка",
            "population": 87,
            "type": "hamlet",
            "poly": [
                [
                    89.8311781,
                    56.2672998
                ],
                [
                    89.833259,
                    56.2673961
                ],
                [
                    89.8324415,
                    56.2687992
                ],
                [
                    89.8339774,
                    56.2691156
                ],
                [
                    89.8334324,
                    56.2698997
                ],
                [
                    89.8345313,
                    56.2703459
                ],
                [
                    89.8354445,
                    56.269219
                ],
                [
                    89.8386915,
                    56.2695149
                ],
                [
                    89.8384252,
                    56.2700712
                ],
                [
                    89.8391608,
                    56.270198
                ],
                [
                    89.8394399,
                    56.2695571
                ],
                [
                    89.841076,
                    56.270691
                ],
                [
                    89.8411648,
                    56.2708671
                ],
                [
                    89.8424078,
                    56.2710713
                ],
                [
                    89.842801,
                    56.2708248
                ],
                [
                    89.8442977,
                    56.2712333
                ],
                [
                    89.8459084,
                    56.2717052
                ],
                [
                    89.8464792,
                    56.2721488
                ],
                [
                    89.8467836,
                    56.272508
                ],
                [
                    89.8482549,
                    56.272832
                ],
                [
                    89.8486608,
                    56.2728038
                ],
                [
                    89.8493077,
                    56.2729165
                ],
                [
                    89.8494726,
                    56.2733954
                ],
                [
                    89.8513751,
                    56.2738179
                ],
                [
                    89.851895,
                    56.2736418
                ],
                [
                    89.8524025,
                    56.2737686
                ],
                [
                    89.8527703,
                    56.2736841
                ],
                [
                    89.8563851,
                    56.2747052
                ],
                [
                    89.8575774,
                    56.275339
                ],
                [
                    89.8576661,
                    56.2755854
                ],
                [
                    89.8588457,
                    56.2757404
                ],
                [
                    89.8595687,
                    56.2749587
                ],
                [
                    89.8593784,
                    56.2743953
                ],
                [
                    89.8598858,
                    56.2741066
                ],
                [
                    89.8590612,
                    56.273677
                ],
                [
                    89.8591755,
                    56.2734517
                ],
                [
                    89.8585794,
                    56.2733179
                ],
                [
                    89.857831,
                    56.2738179
                ],
                [
                    89.8537977,
                    56.2726137
                ],
                [
                    89.8539879,
                    56.27167
                ],
                [
                    89.8527957,
                    56.2714868
                ],
                [
                    89.8512229,
                    56.2708107
                ],
                [
                    89.846771,
                    56.2692754
                ],
                [
                    89.8426742,
                    56.2676061
                ],
                [
                    89.8380827,
                    56.2663665
                ],
                [
                    89.8347745,
                    56.2664684
                ],
                [
                    89.8313559,
                    56.2660007
                ],
                [
                    89.8311781,
                    56.2672998
                ]
            ],
            "longitude": 89.845978,
            "latitude": 56.271221
        },
        "6334": {
            "name": "Новая Сокса",
            "population": 254,
            "type": "hamlet",
            "poly": [
                [
                    89.8349726,
                    55.6753093
                ],
                [
                    89.8356293,
                    55.6762562
                ],
                [
                    89.8368958,
                    55.6774252
                ],
                [
                    89.8377583,
                    55.6778887
                ],
                [
                    89.8362423,
                    55.6787985
                ],
                [
                    89.8358445,
                    55.6793359
                ],
                [
                    89.8361072,
                    55.679446
                ],
                [
                    89.8367676,
                    55.6793698
                ],
                [
                    89.837323,
                    55.6793529
                ],
                [
                    89.8386964,
                    55.6801188
                ],
                [
                    89.8394244,
                    55.6808339
                ],
                [
                    89.8398822,
                    55.6810031
                ],
                [
                    89.8399723,
                    55.6815363
                ],
                [
                    89.8395205,
                    55.6818536
                ],
                [
                    89.8395145,
                    55.6823952
                ],
                [
                    89.8394845,
                    55.6825882
                ],
                [
                    89.8391182,
                    55.6827371
                ],
                [
                    89.8386319,
                    55.682754
                ],
                [
                    89.8381336,
                    55.6825002
                ],
                [
                    89.8379354,
                    55.6824596
                ],
                [
                    89.8370648,
                    55.6828116
                ],
                [
                    89.8370708,
                    55.6830519
                ],
                [
                    89.8376953,
                    55.6832449
                ],
                [
                    89.838806,
                    55.6832753
                ],
                [
                    89.8395805,
                    55.6834581
                ],
                [
                    89.8398207,
                    55.6835664
                ],
                [
                    89.8400909,
                    55.6834953
                ],
                [
                    89.8406192,
                    55.6835157
                ],
                [
                    89.8406373,
                    55.6839421
                ],
                [
                    89.8404932,
                    55.6842772
                ],
                [
                    89.8407273,
                    55.684548
                ],
                [
                    89.8410275,
                    55.6845751
                ],
                [
                    89.8411416,
                    55.6847173
                ],
                [
                    89.8424505,
                    55.6851404
                ],
                [
                    89.8427927,
                    55.6853434
                ],
                [
                    89.8437774,
                    55.686061
                ],
                [
                    89.8442937,
                    55.6861828
                ],
                [
                    89.8443057,
                    55.6863182
                ],
                [
                    89.84466,
                    55.6865382
                ],
                [
                    89.8451703,
                    55.6867481
                ],
                [
                    89.8469896,
                    55.6870933
                ],
                [
                    89.847686,
                    55.6873607
                ],
                [
                    89.8488148,
                    55.6876314
                ],
                [
                    89.8494032,
                    55.6875807
                ],
                [
                    89.8500576,
                    55.6876788
                ],
                [
                    89.8501357,
                    55.687821
                ],
                [
                    89.8503999,
                    55.6879902
                ],
                [
                    89.8509463,
                    55.6880477
                ],
                [
                    89.8514446,
                    55.6879293
                ],
                [
                    89.852069,
                    55.6879936
                ],
                [
                    89.8524355,
                    55.6882918
                ],
                [
                    89.8527957,
                    55.6883299
                ],
                [
                    89.8534712,
                    55.6867349
                ],
                [
                    89.8535312,
                    55.6858592
                ],
                [
                    89.853989,
                    55.685288
                ],
                [
                    89.8546518,
                    55.6850305
                ],
                [
                    89.8553497,
                    55.6840616
                ],
                [
                    89.8554773,
                    55.6837316
                ],
                [
                    89.8539238,
                    55.6834777
                ],
                [
                    89.8536236,
                    55.6833846
                ],
                [
                    89.8580216,
                    55.681836
                ],
                [
                    89.8595601,
                    55.6810998
                ],
                [
                    89.8604607,
                    55.6804608
                ],
                [
                    89.8611287,
                    55.6795087
                ],
                [
                    89.8611287,
                    55.6791872
                ],
                [
                    89.860821,
                    55.6789163
                ],
                [
                    89.8603406,
                    55.6788444
                ],
                [
                    89.8601755,
                    55.6786878
                ],
                [
                    89.8598078,
                    55.6785397
                ],
                [
                    89.8562879,
                    55.6773548
                ],
                [
                    89.8543741,
                    55.6764789
                ],
                [
                    89.8530982,
                    55.6756833
                ],
                [
                    89.8527155,
                    55.6752939
                ],
                [
                    89.8521526,
                    55.6744729
                ],
                [
                    89.8518824,
                    55.6742528
                ],
                [
                    89.850629,
                    55.6736688
                ],
                [
                    89.8475774,
                    55.6726105
                ],
                [
                    89.8458182,
                    55.6719097
                ],
                [
                    89.8451997,
                    55.6714729
                ],
                [
                    89.8428717,
                    55.6720082
                ],
                [
                    89.842262,
                    55.6722939
                ],
                [
                    89.8407046,
                    55.6724473
                ],
                [
                    89.8401042,
                    55.673061
                ],
                [
                    89.8380872,
                    55.6736693
                ],
                [
                    89.8373649,
                    55.6736746
                ],
                [
                    89.8365487,
                    55.6742565
                ],
                [
                    89.8353948,
                    55.6745528
                ],
                [
                    89.8350195,
                    55.6748543
                ],
                [
                    89.8349726,
                    55.6753093
                ]
            ],
            "longitude": 89.846268,
            "latitude": 55.679012
        },
        "6335": {
            "name": "Учум",
            "population": 55,
            "type": "hamlet",
            "poly": [
                [
                    89.8418896,
                    55.1561559
                ],
                [
                    89.8421694,
                    55.1560889
                ],
                [
                    89.8426569,
                    55.156094
                ],
                [
                    89.8435957,
                    55.1559393
                ],
                [
                    89.8440922,
                    55.1563777
                ],
                [
                    89.8454642,
                    55.1555577
                ],
                [
                    89.8468634,
                    55.1543869
                ],
                [
                    89.8479015,
                    55.1533502
                ],
                [
                    89.849409,
                    55.151122
                ],
                [
                    89.8522976,
                    55.1466858
                ],
                [
                    89.8519636,
                    55.1466754
                ],
                [
                    89.8511151,
                    55.1464278
                ],
                [
                    89.8510699,
                    55.1465877
                ],
                [
                    89.8504561,
                    55.1464949
                ],
                [
                    89.8496437,
                    55.1479806
                ],
                [
                    89.8489486,
                    55.1488162
                ],
                [
                    89.8484702,
                    55.1491412
                ],
                [
                    89.8466377,
                    55.1498427
                ],
                [
                    89.8457982,
                    55.1504308
                ],
                [
                    89.8455455,
                    55.1504514
                ],
                [
                    89.8454011,
                    55.1512354
                ],
                [
                    89.8448685,
                    55.1514418
                ],
                [
                    89.8442095,
                    55.1519472
                ],
                [
                    89.8432888,
                    55.1529685
                ],
                [
                    89.8426659,
                    55.1544539
                ],
                [
                    89.8425576,
                    55.1550986
                ],
                [
                    89.8421243,
                    55.155929
                ],
                [
                    89.8418896,
                    55.1561559
                ]
            ],
            "longitude": 89.846619,
            "latitude": 55.152122
        },
        "6336": {
            "name": "Новониколаевка",
            "population": 128,
            "type": "hamlet",
            "poly": [
                [
                    89.8534774,
                    55.8755526
                ],
                [
                    89.8560257,
                    55.8769429
                ],
                [
                    89.8565438,
                    55.8774928
                ],
                [
                    89.8568098,
                    55.8775635
                ],
                [
                    89.8569078,
                    55.8776891
                ],
                [
                    89.8567398,
                    55.8779797
                ],
                [
                    89.8575799,
                    55.87915
                ],
                [
                    89.858028,
                    55.8804538
                ],
                [
                    89.8598482,
                    55.8806266
                ],
                [
                    89.8642308,
                    55.8805402
                ],
                [
                    89.865449,
                    55.8805873
                ],
                [
                    89.8685154,
                    55.8808622
                ],
                [
                    89.8809631,
                    55.8838309
                ],
                [
                    89.8816352,
                    55.8823466
                ],
                [
                    89.8814671,
                    55.8818361
                ],
                [
                    89.8811731,
                    55.8815141
                ],
                [
                    89.8812851,
                    55.8812628
                ],
                [
                    89.8815371,
                    55.8812156
                ],
                [
                    89.8831614,
                    55.8811764
                ],
                [
                    89.8834694,
                    55.8807287
                ],
                [
                    89.8834274,
                    55.8804774
                ],
                [
                    89.880137,
                    55.879747
                ],
                [
                    89.8798989,
                    55.8795742
                ],
                [
                    89.8799566,
                    55.8793385
                ],
                [
                    89.8805167,
                    55.8788673
                ],
                [
                    89.8802086,
                    55.8788045
                ],
                [
                    89.8799706,
                    55.8786866
                ],
                [
                    89.8795785,
                    55.878938
                ],
                [
                    89.8779543,
                    55.8791265
                ],
                [
                    89.8767081,
                    55.8789615
                ],
                [
                    89.875532,
                    55.8785531
                ],
                [
                    89.8742158,
                    55.878616
                ],
                [
                    89.8736697,
                    55.8784746
                ],
                [
                    89.8724096,
                    55.8777363
                ],
                [
                    89.8711914,
                    55.8774928
                ],
                [
                    89.8708554,
                    55.8772493
                ],
                [
                    89.8708414,
                    55.8768408
                ],
                [
                    89.8735437,
                    55.875317
                ],
                [
                    89.8744958,
                    55.8750028
                ],
                [
                    89.8823914,
                    55.8747372
                ],
                [
                    89.8859199,
                    55.8747812
                ],
                [
                    89.8860543,
                    55.8748817
                ],
                [
                    89.8865472,
                    55.8746178
                ],
                [
                    89.8857182,
                    55.8745298
                ],
                [
                    89.8841724,
                    55.8740396
                ],
                [
                    89.884038,
                    55.873782
                ],
                [
                    89.8840044,
                    55.872965
                ],
                [
                    89.8834667,
                    55.8719469
                ],
                [
                    89.8835339,
                    55.8712179
                ],
                [
                    89.8833995,
                    55.870954
                ],
                [
                    89.8830747,
                    55.8708597
                ],
                [
                    89.8824474,
                    55.8708471
                ],
                [
                    89.8821562,
                    55.8706963
                ],
                [
                    89.8806146,
                    55.8694833
                ],
                [
                    89.8803548,
                    55.8687743
                ],
                [
                    89.8773796,
                    55.8693425
                ],
                [
                    89.8771377,
                    55.8707754
                ],
                [
                    89.8734188,
                    55.8720625
                ],
                [
                    89.8724958,
                    55.8721379
                ],
                [
                    89.8701659,
                    55.8720173
                ],
                [
                    89.8682751,
                    55.8720675
                ],
                [
                    89.8674685,
                    55.8721229
                ],
                [
                    89.8653358,
                    55.8718765
                ],
                [
                    89.8652008,
                    55.8715504
                ],
                [
                    89.8646721,
                    55.8715353
                ],
                [
                    89.8643405,
                    55.8715856
                ],
                [
                    89.8643405,
                    55.871827
                ],
                [
                    89.8630859,
                    55.8722895
                ],
                [
                    89.861912,
                    55.8730587
                ],
                [
                    89.8617955,
                    55.8736771
                ],
                [
                    89.862154,
                    55.8738882
                ],
                [
                    89.8641971,
                    55.8743608
                ],
                [
                    89.8638925,
                    55.8747378
                ],
                [
                    89.8624252,
                    55.8747328
                ],
                [
                    89.8616691,
                    55.8745757
                ],
                [
                    89.8590508,
                    55.8746386
                ],
                [
                    89.8562224,
                    55.8752277
                ],
                [
                    89.8555363,
                    55.8751727
                ],
                [
                    89.8549482,
                    55.8752827
                ],
                [
                    89.8541361,
                    55.8752591
                ],
                [
                    89.8536601,
                    55.8754319
                ],
                [
                    89.8534774,
                    55.8755526
                ]
            ],
            "longitude": 89.863068,
            "latitude": 55.877045
        },
        "6337": {
            "name": "Захаринка",
            "population": 151,
            "type": "hamlet",
            "poly": [
                [
                    89.8430632,
                    56.0309641
                ],
                [
                    89.8433335,
                    56.0311343
                ],
                [
                    89.8437732,
                    56.0311522
                ],
                [
                    89.844222,
                    56.0308694
                ],
                [
                    89.8448219,
                    56.0308464
                ],
                [
                    89.8449961,
                    56.0305022
                ],
                [
                    89.8451495,
                    56.0304382
                ],
                [
                    89.8460015,
                    56.030625
                ],
                [
                    89.8460747,
                    56.0307568
                ],
                [
                    89.8458961,
                    56.0312482
                ],
                [
                    89.8454679,
                    56.0317728
                ],
                [
                    89.8451129,
                    56.0320812
                ],
                [
                    89.8446594,
                    56.0320287
                ],
                [
                    89.8448747,
                    56.0325393
                ],
                [
                    89.8450189,
                    56.0326608
                ],
                [
                    89.8453488,
                    56.0326774
                ],
                [
                    89.8455633,
                    56.0327499
                ],
                [
                    89.8457333,
                    56.0332078
                ],
                [
                    89.8458406,
                    56.0332253
                ],
                [
                    89.8463103,
                    56.0332477
                ],
                [
                    89.8471199,
                    56.0335301
                ],
                [
                    89.8473793,
                    56.0334877
                ],
                [
                    89.8474643,
                    56.0333552
                ],
                [
                    89.84733,
                    56.0332303
                ],
                [
                    89.847102,
                    56.0329653
                ],
                [
                    89.8471467,
                    56.0328179
                ],
                [
                    89.8474956,
                    56.0326854
                ],
                [
                    89.8478087,
                    56.0326555
                ],
                [
                    89.8483857,
                    56.0328229
                ],
                [
                    89.8496918,
                    56.0330353
                ],
                [
                    89.8501123,
                    56.0331828
                ],
                [
                    89.8508503,
                    56.0333377
                ],
                [
                    89.8518316,
                    56.0337886
                ],
                [
                    89.8519534,
                    56.032243
                ],
                [
                    89.8521252,
                    56.0316812
                ],
                [
                    89.852474,
                    56.0312288
                ],
                [
                    89.8530214,
                    56.030745
                ],
                [
                    89.8551772,
                    56.0295429
                ],
                [
                    89.8574943,
                    56.0284657
                ],
                [
                    89.8593774,
                    56.0284782
                ],
                [
                    89.860102,
                    56.0283182
                ],
                [
                    89.8607909,
                    56.0281382
                ],
                [
                    89.8613231,
                    56.0281082
                ],
                [
                    89.863711,
                    56.0277519
                ],
                [
                    89.8647444,
                    56.027504
                ],
                [
                    89.8652826,
                    56.0273184
                ],
                [
                    89.8662182,
                    56.0266409
                ],
                [
                    89.8667729,
                    56.0263889
                ],
                [
                    89.8672452,
                    56.0264649
                ],
                [
                    89.8680146,
                    56.0267129
                ],
                [
                    89.8693931,
                    56.0273604
                ],
                [
                    89.8698339,
                    56.0274564
                ],
                [
                    89.8707638,
                    56.0274816
                ],
                [
                    89.8717213,
                    56.0271341
                ],
                [
                    89.8722925,
                    56.0267712
                ],
                [
                    89.8701399,
                    56.0261119
                ],
                [
                    89.8695527,
                    56.0258182
                ],
                [
                    89.8685744,
                    56.0249965
                ],
                [
                    89.8683284,
                    56.0246903
                ],
                [
                    89.8673443,
                    56.0241466
                ],
                [
                    89.8668701,
                    56.0239873
                ],
                [
                    89.8666842,
                    56.0234653
                ],
                [
                    89.8669382,
                    56.0226694
                ],
                [
                    89.8672853,
                    56.0221295
                ],
                [
                    89.8680475,
                    56.0216555
                ],
                [
                    89.8697651,
                    56.0208836
                ],
                [
                    89.8701122,
                    56.0207496
                ],
                [
                    89.8731359,
                    56.0196296
                ],
                [
                    89.8743776,
                    56.0189416
                ],
                [
                    89.8745385,
                    56.0186776
                ],
                [
                    89.8748786,
                    56.0183136
                ],
                [
                    89.8753794,
                    56.0180636
                ],
                [
                    89.8759412,
                    56.0178356
                ],
                [
                    89.8751362,
                    56.0170496
                ],
                [
                    89.8743245,
                    56.0172955
                ],
                [
                    89.8739094,
                    56.0174195
                ],
                [
                    89.8736696,
                    56.0173895
                ],
                [
                    89.8734013,
                    56.0173195
                ],
                [
                    89.872614,
                    56.0167055
                ],
                [
                    89.8723671,
                    56.0166295
                ],
                [
                    89.8721811,
                    56.0166375
                ],
                [
                    89.8708893,
                    56.0168435
                ],
                [
                    89.870739,
                    56.0168395
                ],
                [
                    89.8703632,
                    56.0159855
                ],
                [
                    89.8701021,
                    56.0155014
                ],
                [
                    89.8699266,
                    56.0153174
                ],
                [
                    89.8696762,
                    56.0153074
                ],
                [
                    89.8693441,
                    56.0152405
                ],
                [
                    89.8680047,
                    56.0152549
                ],
                [
                    89.8678811,
                    56.0142095
                ],
                [
                    89.8674889,
                    56.0141599
                ],
                [
                    89.866925,
                    56.0141583
                ],
                [
                    89.8667246,
                    56.0141871
                ],
                [
                    89.8663009,
                    56.0141983
                ],
                [
                    89.8654449,
                    56.0143935
                ],
                [
                    89.8651816,
                    56.014544
                ],
                [
                    89.8631806,
                    56.0151552
                ],
                [
                    89.8627054,
                    56.0157009
                ],
                [
                    89.8621986,
                    56.0161425
                ],
                [
                    89.8617808,
                    56.0162465
                ],
                [
                    89.8607244,
                    56.0166914
                ],
                [
                    89.8604439,
                    56.0168706
                ],
                [
                    89.8604697,
                    56.0170514
                ],
                [
                    89.8605613,
                    56.017221
                ],
                [
                    89.8609048,
                    56.0172962
                ],
                [
                    89.8611481,
                    56.017477
                ],
                [
                    89.8609849,
                    56.0177074
                ],
                [
                    89.859545,
                    56.0175602
                ],
                [
                    89.8588294,
                    56.0173762
                ],
                [
                    89.8587692,
                    56.017221
                ],
                [
                    89.8585946,
                    56.0170562
                ],
                [
                    89.85842,
                    56.0170546
                ],
                [
                    89.8582454,
                    56.0171234
                ],
                [
                    89.8582368,
                    56.0173426
                ],
                [
                    89.8579734,
                    56.0173778
                ],
                [
                    89.8576242,
                    56.0171266
                ],
                [
                    89.8574954,
                    56.0171426
                ],
                [
                    89.8574352,
                    56.0172418
                ],
                [
                    89.8574982,
                    56.017621
                ],
                [
                    89.8572349,
                    56.018037
                ],
                [
                    89.8564075,
                    56.018677
                ],
                [
                    89.8559581,
                    56.019165
                ],
                [
                    89.8559495,
                    56.0196194
                ],
                [
                    89.8562215,
                    56.0202738
                ],
                [
                    89.8561871,
                    56.0204242
                ],
                [
                    89.8561785,
                    56.020597
                ],
                [
                    89.8562959,
                    56.0210866
                ],
                [
                    89.8561213,
                    56.0213921
                ],
                [
                    89.8560755,
                    56.0218129
                ],
                [
                    89.8561585,
                    56.0221233
                ],
                [
                    89.8563875,
                    56.0223345
                ],
                [
                    89.856001,
                    56.0224561
                ],
                [
                    89.8556575,
                    56.0231584
                ],
                [
                    89.8555373,
                    56.0236415
                ],
                [
                    89.8554972,
                    56.0245342
                ],
                [
                    89.8548849,
                    56.02513
                ],
                [
                    89.8548002,
                    56.025185
                ],
                [
                    89.8545047,
                    56.0253296
                ],
                [
                    89.8539688,
                    56.025551
                ],
                [
                    89.8536665,
                    56.0257315
                ],
                [
                    89.8531765,
                    56.0258953
                ],
                [
                    89.8525673,
                    56.0261755
                ],
                [
                    89.8513237,
                    56.0266836
                ],
                [
                    89.8503092,
                    56.0272684
                ],
                [
                    89.8497321,
                    56.0275167
                ],
                [
                    89.8496657,
                    56.0275948
                ],
                [
                    89.8496611,
                    56.0279147
                ],
                [
                    89.8490359,
                    56.0285916
                ],
                [
                    89.8475473,
                    56.0296512
                ],
                [
                    89.8471992,
                    56.0298009
                ],
                [
                    89.8461824,
                    56.0297907
                ],
                [
                    89.8459259,
                    56.0297395
                ],
                [
                    89.8454105,
                    56.0297804
                ],
                [
                    89.8445381,
                    56.0300428
                ],
                [
                    89.8443938,
                    56.0301413
                ],
                [
                    89.8443045,
                    56.0305188
                ],
                [
                    89.8439494,
                    56.0306455
                ],
                [
                    89.8435396,
                    56.0306544
                ],
                [
                    89.8431021,
                    56.0307837
                ],
                [
                    89.8430632,
                    56.0309641
                ]
            ],
            "longitude": 89.864639,
            "latitude": 56.023869
        },
        "6338": {
            "name": "Кресты",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.866667,
            "latitude": 70.75
        },
        "6339": {
            "name": "Марьясово",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    89.876326,
                    55.4502603
                ],
                [
                    89.8773056,
                    55.4506197
                ],
                [
                    89.8778983,
                    55.4509092
                ],
                [
                    89.8791989,
                    55.4514647
                ],
                [
                    89.879306,
                    55.4513714
                ],
                [
                    89.8797011,
                    55.4515441
                ],
                [
                    89.8795858,
                    55.4516561
                ],
                [
                    89.8801127,
                    55.4518522
                ],
                [
                    89.8804914,
                    55.4515908
                ],
                [
                    89.8820637,
                    55.4524451
                ],
                [
                    89.8822448,
                    55.4523844
                ],
                [
                    89.8820966,
                    55.4522583
                ],
                [
                    89.882904,
                    55.4519403
                ],
                [
                    89.8831339,
                    55.4518195
                ],
                [
                    89.8809194,
                    55.4505964
                ],
                [
                    89.879166,
                    55.4498774
                ],
                [
                    89.8773632,
                    55.4492845
                ],
                [
                    89.8772487,
                    55.4493571
                ],
                [
                    89.8769022,
                    55.4495926
                ],
                [
                    89.8765976,
                    55.4500408
                ],
                [
                    89.876326,
                    55.4502603
                ]
            ],
            "longitude": 89.879745,
            "latitude": 55.450954
        },
        "6340": {
            "name": "Гнетово",
            "population": 108,
            "type": "hamlet",
            "poly": [
                [
                    89.8707902,
                    56.2820288
                ],
                [
                    89.87245,
                    56.2826063
                ],
                [
                    89.8742584,
                    56.2826063
                ],
                [
                    89.8797827,
                    56.2839264
                ],
                [
                    89.8838206,
                    56.2854115
                ],
                [
                    89.8854556,
                    56.2878177
                ],
                [
                    89.886595,
                    56.2887389
                ],
                [
                    89.8879081,
                    56.2889864
                ],
                [
                    89.8888742,
                    56.2879139
                ],
                [
                    89.8900137,
                    56.2869652
                ],
                [
                    89.8906329,
                    56.2857415
                ],
                [
                    89.889989,
                    56.2841877
                ],
                [
                    89.8882053,
                    56.2833214
                ],
                [
                    89.8851088,
                    56.2829776
                ],
                [
                    89.8842665,
                    56.2821113
                ],
                [
                    89.8829535,
                    56.2821388
                ],
                [
                    89.8815415,
                    56.281575
                ],
                [
                    89.8788661,
                    56.2809562
                ],
                [
                    89.8766118,
                    56.2810249
                ],
                [
                    89.8761411,
                    56.2813
                ],
                [
                    89.875175,
                    56.2807774
                ],
                [
                    89.8721032,
                    56.2804749
                ],
                [
                    89.8710875,
                    56.2814512
                ],
                [
                    89.8707902,
                    56.2820288
                ]
            ],
            "longitude": 89.882271,
            "latitude": 56.283981
        },
        "6341": {
            "name": "Каргала",
            "population": 152,
            "type": "hamlet",
            "poly": [
                [
                    89.8727987,
                    55.7738445
                ],
                [
                    89.8729769,
                    55.7744777
                ],
                [
                    89.8734084,
                    55.7746729
                ],
                [
                    89.8730801,
                    55.7753325
                ],
                [
                    89.8733082,
                    55.7758096
                ],
                [
                    89.874522,
                    55.7756808
                ],
                [
                    89.8767209,
                    55.7758869
                ],
                [
                    89.878347,
                    55.7756808
                ],
                [
                    89.8825384,
                    55.7758483
                ],
                [
                    89.8826988,
                    55.7763636
                ],
                [
                    89.8823323,
                    55.778051
                ],
                [
                    89.8815536,
                    55.7792489
                ],
                [
                    89.881439,
                    55.7803438
                ],
                [
                    89.8928828,
                    55.7804079
                ],
                [
                    89.8929561,
                    55.780243
                ],
                [
                    89.8915049,
                    55.7773825
                ],
                [
                    89.8916074,
                    55.7773671
                ],
                [
                    89.8917248,
                    55.7773495
                ],
                [
                    89.8919447,
                    55.7772093
                ],
                [
                    89.8939089,
                    55.7774484
                ],
                [
                    89.8961956,
                    55.7774567
                ],
                [
                    89.897808,
                    55.7771022
                ],
                [
                    89.8995964,
                    55.7770609
                ],
                [
                    89.9049174,
                    55.7774649
                ],
                [
                    89.9093882,
                    55.7773083
                ],
                [
                    89.9111819,
                    55.7747536
                ],
                [
                    89.9114915,
                    55.7746745
                ],
                [
                    89.9124953,
                    55.7747062
                ],
                [
                    89.9125422,
                    55.7742365
                ],
                [
                    89.9114446,
                    55.7741679
                ],
                [
                    89.9109755,
                    55.7739885
                ],
                [
                    89.9098216,
                    55.7739305
                ],
                [
                    89.9093713,
                    55.7736614
                ],
                [
                    89.9084144,
                    55.7736667
                ],
                [
                    89.9063974,
                    55.7733448
                ],
                [
                    89.9063692,
                    55.7731443
                ],
                [
                    89.9057407,
                    55.7733078
                ],
                [
                    89.9049303,
                    55.7732487
                ],
                [
                    89.9033729,
                    55.7728622
                ],
                [
                    89.9014261,
                    55.7730555
                ],
                [
                    89.9006932,
                    55.7727334
                ],
                [
                    89.8994105,
                    55.7728365
                ],
                [
                    89.8982738,
                    55.77279
                ],
                [
                    89.897922,
                    55.7730703
                ],
                [
                    89.897365,
                    55.7732187
                ],
                [
                    89.8967933,
                    55.7731692
                ],
                [
                    89.8965587,
                    55.7729054
                ],
                [
                    89.8961483,
                    55.7727487
                ],
                [
                    89.8921026,
                    55.7722953
                ],
                [
                    89.8908273,
                    55.7718995
                ],
                [
                    89.8903436,
                    55.7718748
                ],
                [
                    89.8896253,
                    55.7720891
                ],
                [
                    89.8888777,
                    55.7718088
                ],
                [
                    89.8874852,
                    55.7717676
                ],
                [
                    89.8864738,
                    55.7719572
                ],
                [
                    89.8851399,
                    55.771949
                ],
                [
                    89.8848907,
                    55.7718006
                ],
                [
                    89.8840991,
                    55.7719655
                ],
                [
                    89.8838059,
                    55.7719572
                ],
                [
                    89.8836154,
                    55.7717511
                ],
                [
                    89.8832782,
                    55.7717428
                ],
                [
                    89.8829007,
                    55.7718434
                ],
                [
                    89.8827212,
                    55.7718913
                ],
                [
                    89.8826479,
                    55.7722375
                ],
                [
                    89.8820469,
                    55.7722458
                ],
                [
                    89.8801853,
                    55.7725673
                ],
                [
                    89.8770924,
                    55.7725179
                ],
                [
                    89.87548,
                    55.7726003
                ],
                [
                    89.8752454,
                    55.7730456
                ],
                [
                    89.8752748,
                    55.7733671
                ],
                [
                    89.8746937,
                    55.7733854
                ],
                [
                    89.8730989,
                    55.7735385
                ],
                [
                    89.8727987,
                    55.7738445
                ]
            ],
            "longitude": 89.889366,
            "latitude": 55.774643
        },
        "6342": {
            "name": "Дмитриевка",
            "population": 140,
            "type": "hamlet",
            "poly": [
                [
                    89.8953186,
                    56.3869857
                ],
                [
                    89.8953186,
                    56.3883982
                ],
                [
                    89.8972013,
                    56.3889878
                ],
                [
                    89.9032457,
                    56.3900026
                ],
                [
                    89.9042367,
                    56.3903317
                ],
                [
                    89.9058469,
                    56.3899066
                ],
                [
                    89.9061937,
                    56.3893032
                ],
                [
                    89.9098105,
                    56.3899614
                ],
                [
                    89.9094637,
                    56.3906196
                ],
                [
                    89.9095876,
                    56.3914286
                ],
                [
                    89.9132539,
                    56.391648
                ],
                [
                    89.9201159,
                    56.3914012
                ],
                [
                    89.9210325,
                    56.3913601
                ],
                [
                    89.9211316,
                    56.3900848
                ],
                [
                    89.9214289,
                    56.3883159
                ],
                [
                    89.9161522,
                    56.3884804
                ],
                [
                    89.9127089,
                    56.3885901
                ],
                [
                    89.9122878,
                    56.3887273
                ],
                [
                    89.909216,
                    56.3882199
                ],
                [
                    89.9088939,
                    56.3896323
                ],
                [
                    89.9063671,
                    56.3891112
                ],
                [
                    89.9073333,
                    56.3878633
                ],
                [
                    89.9057726,
                    56.3874656
                ],
                [
                    89.9050542,
                    56.3870954
                ],
                [
                    89.901264,
                    56.386396
                ],
                [
                    89.8969783,
                    56.3859297
                ],
                [
                    89.8961361,
                    56.3859709
                ],
                [
                    89.8953186,
                    56.3869857
                ]
            ],
            "longitude": 89.913033,
            "latitude": 56.389912
        },
        "6343": {
            "name": "Отделение Бригады № 2",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.924225,
            "latitude": 55.516335
        },
        "6344": {
            "name": "Бор",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    89.9373011,
                    57.4927807
                ],
                [
                    89.9379685,
                    57.4936696
                ],
                [
                    89.9426796,
                    57.4947331
                ],
                [
                    89.9463299,
                    57.4931025
                ],
                [
                    89.9429534,
                    57.4923884
                ],
                [
                    89.9426397,
                    57.4904051
                ],
                [
                    89.9439458,
                    57.4893445
                ],
                [
                    89.9428964,
                    57.4853899
                ],
                [
                    89.9398963,
                    57.4859356
                ],
                [
                    89.94094,
                    57.4873703
                ],
                [
                    89.9385502,
                    57.4877413
                ],
                [
                    89.9392632,
                    57.4890012
                ],
                [
                    89.94094,
                    57.4889889
                ],
                [
                    89.9409457,
                    57.4909845
                ],
                [
                    89.9389666,
                    57.4922382
                ],
                [
                    89.9379627,
                    57.4920542
                ],
                [
                    89.9373011,
                    57.4927807
                ]
            ],
            "longitude": 89.941971,
            "latitude": 57.489506
        },
        "6345": {
            "name": "Зелёная Горка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    89.936283,
                    55.8977039
                ],
                [
                    89.9364082,
                    55.898088
                ],
                [
                    89.9367968,
                    55.8984056
                ],
                [
                    89.9374028,
                    55.8983243
                ],
                [
                    89.9378375,
                    55.8983022
                ],
                [
                    89.9382854,
                    55.8984979
                ],
                [
                    89.9376136,
                    55.8993067
                ],
                [
                    89.9371657,
                    55.8996095
                ],
                [
                    89.9367836,
                    55.8997129
                ],
                [
                    89.9381866,
                    55.8997018
                ],
                [
                    89.9397795,
                    55.8997774
                ],
                [
                    89.93947,
                    55.900047
                ],
                [
                    89.9393975,
                    55.9003572
                ],
                [
                    89.9391406,
                    55.9006969
                ],
                [
                    89.9390682,
                    55.9011179
                ],
                [
                    89.9387652,
                    55.9014761
                ],
                [
                    89.9394633,
                    55.9014871
                ],
                [
                    89.9404119,
                    55.9014391
                ],
                [
                    89.9408071,
                    55.9016422
                ],
                [
                    89.9411957,
                    55.9015942
                ],
                [
                    89.9417292,
                    55.9016127
                ],
                [
                    89.9419202,
                    55.9016976
                ],
                [
                    89.9431981,
                    55.9018269
                ],
                [
                    89.9434088,
                    55.9019487
                ],
                [
                    89.9453519,
                    55.9022146
                ],
                [
                    89.9459382,
                    55.9021112
                ],
                [
                    89.9470711,
                    55.9017641
                ],
                [
                    89.9475388,
                    55.9018896
                ],
                [
                    89.9486717,
                    55.9020632
                ],
                [
                    89.94991,
                    55.902041
                ],
                [
                    89.950134,
                    55.9017198
                ],
                [
                    89.950292,
                    55.901273
                ],
                [
                    89.9501801,
                    55.9010846
                ],
                [
                    89.9504764,
                    55.9002538
                ],
                [
                    89.9506082,
                    55.9001024
                ],
                [
                    89.9510363,
                    55.8993601
                ],
                [
                    89.9521363,
                    55.8997331
                ],
                [
                    89.9526381,
                    55.9001008
                ],
                [
                    89.9524117,
                    55.8994661
                ],
                [
                    89.9523911,
                    55.898566
                ],
                [
                    89.9525557,
                    55.8981967
                ],
                [
                    89.9535541,
                    55.8970195
                ],
                [
                    89.9552316,
                    55.8945382
                ],
                [
                    89.9555713,
                    55.8936841
                ],
                [
                    89.955602,
                    55.8933147
                ],
                [
                    89.955259,
                    55.893153
                ],
                [
                    89.95171,
                    55.892131
                ],
                [
                    89.9497445,
                    55.892066
                ],
                [
                    89.9494231,
                    55.8920275
                ],
                [
                    89.9487064,
                    55.8917882
                ],
                [
                    89.9482743,
                    55.8914809
                ],
                [
                    89.947721,
                    55.890949
                ],
                [
                    89.9470307,
                    55.8904348
                ],
                [
                    89.9464195,
                    55.8901068
                ],
                [
                    89.9463351,
                    55.8904673
                ],
                [
                    89.9460559,
                    55.8909845
                ],
                [
                    89.9461613,
                    55.8912652
                ],
                [
                    89.946077,
                    55.8915577
                ],
                [
                    89.9455131,
                    55.8917261
                ],
                [
                    89.9447807,
                    55.8916789
                ],
                [
                    89.9439534,
                    55.891865
                ],
                [
                    89.9421459,
                    55.8922344
                ],
                [
                    89.9418931,
                    55.8923053
                ],
                [
                    89.9410289,
                    55.8922107
                ],
                [
                    89.9407338,
                    55.8922817
                ],
                [
                    89.9405125,
                    55.8925683
                ],
                [
                    89.9403279,
                    55.8927367
                ],
                [
                    89.9398064,
                    55.892911
                ],
                [
                    89.9393479,
                    55.8928726
                ],
                [
                    89.9389053,
                    55.8927012
                ],
                [
                    89.9390265,
                    55.8924796
                ],
                [
                    89.9391003,
                    55.891602
                ],
                [
                    89.9389527,
                    55.8912149
                ],
                [
                    89.9384047,
                    55.8914602
                ],
                [
                    89.9378461,
                    55.8916109
                ],
                [
                    89.9375984,
                    55.8917882
                ],
                [
                    89.9373982,
                    55.8923023
                ],
                [
                    89.9370188,
                    55.892651
                ],
                [
                    89.9367975,
                    55.8930085
                ],
                [
                    89.9367567,
                    55.8932725
                ],
                [
                    89.9366052,
                    55.8934202
                ],
                [
                    89.9365195,
                    55.8938265
                ],
                [
                    89.9366249,
                    55.8940297
                ],
                [
                    89.9369082,
                    55.894351
                ],
                [
                    89.9371387,
                    55.8943621
                ],
                [
                    89.9375866,
                    55.8942217
                ],
                [
                    89.9379884,
                    55.8940297
                ],
                [
                    89.9383243,
                    55.8939484
                ],
                [
                    89.9386471,
                    55.8938487
                ],
                [
                    89.9389829,
                    55.893989
                ],
                [
                    89.939556,
                    55.8942919
                ],
                [
                    89.9398986,
                    55.8942771
                ],
                [
                    89.9409854,
                    55.8945578
                ],
                [
                    89.941183,
                    55.89482
                ],
                [
                    89.9413938,
                    55.8950269
                ],
                [
                    89.9417692,
                    55.8951672
                ],
                [
                    89.942217,
                    55.895182
                ],
                [
                    89.9424806,
                    55.8950712
                ],
                [
                    89.9426057,
                    55.8947609
                ],
                [
                    89.9424806,
                    55.8945246
                ],
                [
                    89.9421973,
                    55.8943547
                ],
                [
                    89.9428626,
                    55.8940666
                ],
                [
                    89.9433303,
                    55.8940629
                ],
                [
                    89.9450033,
                    55.8942586
                ],
                [
                    89.9447333,
                    55.8944765
                ],
                [
                    89.9446937,
                    55.894772
                ],
                [
                    89.9444764,
                    55.8951155
                ],
                [
                    89.9445429,
                    55.8956949
                ],
                [
                    89.9441213,
                    55.8961676
                ],
                [
                    89.9433309,
                    55.8964815
                ],
                [
                    89.9366914,
                    55.8974196
                ],
                [
                    89.9365663,
                    55.8976559
                ],
                [
                    89.936283,
                    55.8977039
                ]
            ],
            "longitude": 89.947655,
            "latitude": 55.894279
        },
        "6346": {
            "name": "Алексеевка",
            "population": 117,
            "type": "hamlet",
            "poly": [
                [
                    89.946572,
                    55.6242864
                ],
                [
                    89.9468888,
                    55.6274372
                ],
                [
                    89.9515922,
                    55.6313857
                ],
                [
                    89.9523599,
                    55.631881
                ],
                [
                    89.9528454,
                    55.6323719
                ],
                [
                    89.9542778,
                    55.6322507
                ],
                [
                    89.954722,
                    55.6321521
                ],
                [
                    89.954747,
                    55.6320169
                ],
                [
                    89.9546821,
                    55.6317182
                ],
                [
                    89.9547619,
                    55.6313069
                ],
                [
                    89.9548019,
                    55.6311688
                ],
                [
                    89.9551762,
                    55.631042
                ],
                [
                    89.955845,
                    55.6309941
                ],
                [
                    89.9561943,
                    55.6307659
                ],
                [
                    89.9561943,
                    55.6304785
                ],
                [
                    89.9557751,
                    55.6301404
                ],
                [
                    89.9547569,
                    55.6295262
                ],
                [
                    89.954712,
                    55.6293205
                ],
                [
                    89.9552311,
                    55.6289401
                ],
                [
                    89.9553209,
                    55.6287175
                ],
                [
                    89.9551812,
                    55.6280047
                ],
                [
                    89.9548368,
                    55.6274214
                ],
                [
                    89.9543527,
                    55.6271678
                ],
                [
                    89.9539883,
                    55.6271171
                ],
                [
                    89.953614,
                    55.626979
                ],
                [
                    89.9533645,
                    55.6268128
                ],
                [
                    89.9533545,
                    55.6264915
                ],
                [
                    89.9534294,
                    55.6263422
                ],
                [
                    89.9540532,
                    55.6261534
                ],
                [
                    89.9546921,
                    55.625959
                ],
                [
                    89.9548917,
                    55.6256828
                ],
                [
                    89.9548817,
                    55.6255053
                ],
                [
                    89.954193,
                    55.6251249
                ],
                [
                    89.9539135,
                    55.6249304
                ],
                [
                    89.9539135,
                    55.6247106
                ],
                [
                    89.9540931,
                    55.6243471
                ],
                [
                    89.954662,
                    55.6240512
                ],
                [
                    89.9555505,
                    55.6238483
                ],
                [
                    89.9562991,
                    55.6234623
                ],
                [
                    89.9566984,
                    55.6233383
                ],
                [
                    89.9572624,
                    55.6233016
                ],
                [
                    89.9593336,
                    55.6234497
                ],
                [
                    89.9612801,
                    55.6234286
                ],
                [
                    89.9627462,
                    55.6230481
                ],
                [
                    89.961486,
                    55.6211248
                ],
                [
                    89.961068,
                    55.6199517
                ],
                [
                    89.9606437,
                    55.6195395
                ],
                [
                    89.9598826,
                    55.6179084
                ],
                [
                    89.9592276,
                    55.6175384
                ],
                [
                    89.9589468,
                    55.6174609
                ],
                [
                    89.9580796,
                    55.6174609
                ],
                [
                    89.9559772,
                    55.6181726
                ],
                [
                    89.9539808,
                    55.6186306
                ],
                [
                    89.9534131,
                    55.6186799
                ],
                [
                    89.9526707,
                    55.6188737
                ],
                [
                    89.9505711,
                    55.6191481
                ],
                [
                    89.9499472,
                    55.6194083
                ],
                [
                    89.9495208,
                    55.6196904
                ],
                [
                    89.9491309,
                    55.6201721
                ],
                [
                    89.9490577,
                    55.6213004
                ],
                [
                    89.9487897,
                    55.6217614
                ],
                [
                    89.9479733,
                    55.6225664
                ],
                [
                    89.9470472,
                    55.6231994
                ],
                [
                    89.9467548,
                    55.6241213
                ],
                [
                    89.946572,
                    55.6242864
                ]
            ],
            "longitude": 89.95295,
            "latitude": 55.622517
        },
        "6347": {
            "name": "Шипиловка",
            "population": 46,
            "type": "hamlet",
            "poly": [
                [
                    89.9567177,
                    55.7792655
                ],
                [
                    89.9574123,
                    55.7794674
                ],
                [
                    89.9612372,
                    55.7800212
                ],
                [
                    89.9626114,
                    55.7797765
                ],
                [
                    89.9654973,
                    55.7799955
                ],
                [
                    89.967948,
                    55.7808069
                ],
                [
                    89.9695742,
                    55.7807425
                ],
                [
                    89.9688642,
                    55.781232
                ],
                [
                    89.9707881,
                    55.7815025
                ],
                [
                    89.97175,
                    55.7810903
                ],
                [
                    89.9759643,
                    55.7819919
                ],
                [
                    89.9786081,
                    55.7824491
                ],
                [
                    89.9798629,
                    55.7823039
                ],
                [
                    89.9807215,
                    55.7823951
                ],
                [
                    89.9813339,
                    55.7826787
                ],
                [
                    89.9813459,
                    55.7828677
                ],
                [
                    89.9812319,
                    55.7829015
                ],
                [
                    89.9812458,
                    55.7831104
                ],
                [
                    89.9827693,
                    55.7833467
                ],
                [
                    89.9834222,
                    55.7836928
                ],
                [
                    89.9835048,
                    55.7839713
                ],
                [
                    89.983092,
                    55.7844102
                ],
                [
                    89.9825591,
                    55.7847014
                ],
                [
                    89.9824015,
                    55.7848322
                ],
                [
                    89.982394,
                    55.7850685
                ],
                [
                    89.9833172,
                    55.7844355
                ],
                [
                    89.9834823,
                    55.7844144
                ],
                [
                    89.9835273,
                    55.784617
                ],
                [
                    89.9831896,
                    55.7849968
                ],
                [
                    89.9822965,
                    55.7853682
                ],
                [
                    89.9790618,
                    55.7863092
                ],
                [
                    89.9788816,
                    55.7865287
                ],
                [
                    89.981576,
                    55.7857733
                ],
                [
                    89.9818837,
                    55.7857564
                ],
                [
                    89.9833772,
                    55.7851445
                ],
                [
                    89.9843754,
                    55.7841401
                ],
                [
                    89.9846906,
                    55.7839924
                ],
                [
                    89.985321,
                    55.7839249
                ],
                [
                    89.9849833,
                    55.7828571
                ],
                [
                    89.9852427,
                    55.7828115
                ],
                [
                    89.98755,
                    55.7824393
                ],
                [
                    89.9874224,
                    55.7822747
                ],
                [
                    89.9873774,
                    55.7820173
                ],
                [
                    89.9877377,
                    55.7816163
                ],
                [
                    89.988173,
                    55.7813673
                ],
                [
                    89.9886383,
                    55.7809073
                ],
                [
                    89.9887283,
                    55.7800632
                ],
                [
                    89.9888934,
                    55.7797593
                ],
                [
                    89.9894413,
                    55.7786112
                ],
                [
                    89.9898541,
                    55.7781427
                ],
                [
                    89.9905296,
                    55.777784
                ],
                [
                    89.9908552,
                    55.7771169
                ],
                [
                    89.9895946,
                    55.7769603
                ],
                [
                    89.9887884,
                    55.7769108
                ],
                [
                    89.9879089,
                    55.7766964
                ],
                [
                    89.9840244,
                    55.7749651
                ],
                [
                    89.9829983,
                    55.7745611
                ],
                [
                    89.9719155,
                    55.7728442
                ],
                [
                    89.9712869,
                    55.7728864
                ],
                [
                    89.9690073,
                    55.7722004
                ],
                [
                    89.968829,
                    55.7719577
                ],
                [
                    89.9681067,
                    55.7721529
                ],
                [
                    89.9671967,
                    55.7721265
                ],
                [
                    89.9635661,
                    55.7727756
                ],
                [
                    89.9598886,
                    55.772327
                ],
                [
                    89.95926,
                    55.7737993
                ],
                [
                    89.9580217,
                    55.7761051
                ],
                [
                    89.9580207,
                    55.776529
                ],
                [
                    89.9573744,
                    55.7775244
                ],
                [
                    89.9574836,
                    55.7775487
                ],
                [
                    89.9576464,
                    55.7775666
                ],
                [
                    89.9567177,
                    55.7792655
                ]
            ],
            "longitude": 89.976173,
            "latitude": 55.77779
        },
        "6348": {
            "name": "Коробейниково",
            "population": 169,
            "type": "hamlet",
            "poly": [
                [
                    89.9947145,
                    56.3735647
                ],
                [
                    89.9956497,
                    56.3748495
                ],
                [
                    89.9957924,
                    56.3758504
                ],
                [
                    89.995396,
                    56.3758855
                ],
                [
                    89.9953801,
                    56.3764737
                ],
                [
                    89.9958558,
                    56.376781
                ],
                [
                    89.9951582,
                    56.3769214
                ],
                [
                    89.9950472,
                    56.3773428
                ],
                [
                    89.9967278,
                    56.3772462
                ],
                [
                    89.9969973,
                    56.3789142
                ],
                [
                    89.9962363,
                    56.3791161
                ],
                [
                    89.9961094,
                    56.3797833
                ],
                [
                    89.9966644,
                    56.3813721
                ],
                [
                    90.0002316,
                    56.3814248
                ],
                [
                    90.0001999,
                    56.3811176
                ],
                [
                    90.0006913,
                    56.3809069
                ],
                [
                    90.0014841,
                    56.3807928
                ],
                [
                    90.0029902,
                    56.3811088
                ],
                [
                    90.0064783,
                    56.3808191
                ],
                [
                    90.0083174,
                    56.3803978
                ],
                [
                    90.0096491,
                    56.3802749
                ],
                [
                    90.0082222,
                    56.3811
                ],
                [
                    90.0122492,
                    56.3812492
                ],
                [
                    90.015769,
                    56.3823289
                ],
                [
                    90.0171959,
                    56.3827415
                ],
                [
                    90.0177983,
                    56.3827064
                ],
                [
                    90.0184325,
                    56.3818198
                ],
                [
                    90.0183786,
                    56.3814336
                ],
                [
                    90.0162351,
                    56.3809631
                ],
                [
                    90.0164,
                    56.3805979
                ],
                [
                    90.0148399,
                    56.3802468
                ],
                [
                    90.0164506,
                    56.3789195
                ],
                [
                    90.0157785,
                    56.3773042
                ],
                [
                    90.0142563,
                    56.3774798
                ],
                [
                    90.0132925,
                    56.3762647
                ],
                [
                    90.009944,
                    56.3767283
                ],
                [
                    90.0086503,
                    56.377241
                ],
                [
                    90.0085362,
                    56.3769179
                ],
                [
                    90.0087652,
                    56.375601
                ],
                [
                    90.0083394,
                    56.3737791
                ],
                [
                    90.0062879,
                    56.3726859
                ],
                [
                    90.0053202,
                    56.3714855
                ],
                [
                    90.0009076,
                    56.3710139
                ],
                [
                    89.9983917,
                    56.3720428
                ],
                [
                    89.9960305,
                    56.3730289
                ],
                [
                    89.9959531,
                    56.3733075
                ],
                [
                    89.9947145,
                    56.3735647
                ]
            ],
            "longitude": 90.00238,
            "latitude": 56.3773
        },
        "6349": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.0155288,
            "latitude": 65.6344363
        },
        "6350": {
            "name": "Берёзовая Роща",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    90.007514,
                    55.7194765
                ],
                [
                    90.0078976,
                    55.720168
                ],
                [
                    90.0092044,
                    55.722191
                ],
                [
                    90.0096647,
                    55.7224611
                ],
                [
                    90.0137122,
                    55.72285
                ],
                [
                    90.0136738,
                    55.7233578
                ],
                [
                    90.0138646,
                    55.7241524
                ],
                [
                    90.0143311,
                    55.7247608
                ],
                [
                    90.0144539,
                    55.7252931
                ],
                [
                    90.0152027,
                    55.7257978
                ],
                [
                    90.0167005,
                    55.7256181
                ],
                [
                    90.0173266,
                    55.7260882
                ],
                [
                    90.0182964,
                    55.7262472
                ],
                [
                    90.0187629,
                    55.7261919
                ],
                [
                    90.0198433,
                    55.7262956
                ],
                [
                    90.0205185,
                    55.7262265
                ],
                [
                    90.0206044,
                    55.7271183
                ],
                [
                    90.0229369,
                    55.7269455
                ],
                [
                    90.0239068,
                    55.7266205
                ],
                [
                    90.0251835,
                    55.7266551
                ],
                [
                    90.025736,
                    55.7269386
                ],
                [
                    90.026669,
                    55.727941
                ],
                [
                    90.0277002,
                    55.7281138
                ],
                [
                    90.0285473,
                    55.7281415
                ],
                [
                    90.0270987,
                    55.7272151
                ],
                [
                    90.0275775,
                    55.7269731
                ],
                [
                    90.0274056,
                    55.7268349
                ],
                [
                    90.0270128,
                    55.7268971
                ],
                [
                    90.0253186,
                    55.7253623
                ],
                [
                    90.024717,
                    55.7253484
                ],
                [
                    90.023207,
                    55.7238827
                ],
                [
                    90.0228265,
                    55.7229286
                ],
                [
                    90.0227528,
                    55.7216149
                ],
                [
                    90.023649,
                    55.7216425
                ],
                [
                    90.0244838,
                    55.7192294
                ],
                [
                    90.0237717,
                    55.7191602
                ],
                [
                    90.0235753,
                    55.718932
                ],
                [
                    90.0204448,
                    55.7184342
                ],
                [
                    90.0200642,
                    55.718856
                ],
                [
                    90.0157183,
                    55.7190358
                ],
                [
                    90.0135774,
                    55.7146598
                ],
                [
                    90.0131727,
                    55.7154248
                ],
                [
                    90.0126548,
                    55.7163108
                ],
                [
                    90.0123095,
                    55.7166782
                ],
                [
                    90.007936,
                    55.7186338
                ],
                [
                    90.0075523,
                    55.7189471
                ],
                [
                    90.007514,
                    55.7194765
                ]
            ],
            "longitude": 90.016327,
            "latitude": 55.722034
        },
        "6351": {
            "name": "Стан Абагалах",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.016667,
            "latitude": 70.416667
        },
        "6352": {
            "name": "Большая Сосновка",
            "population": 261,
            "type": "hamlet",
            "poly": [
                [
                    90.0186179,
                    55.674439
                ],
                [
                    90.019556,
                    55.6779182
                ],
                [
                    90.0189117,
                    55.6780023
                ],
                [
                    90.0207062,
                    55.6803692
                ],
                [
                    90.0211874,
                    55.6803138
                ],
                [
                    90.023574,
                    55.6820192
                ],
                [
                    90.0266185,
                    55.683481
                ],
                [
                    90.0272962,
                    55.6831432
                ],
                [
                    90.0308908,
                    55.6823293
                ],
                [
                    90.0339452,
                    55.6817922
                ],
                [
                    90.0350648,
                    55.6818919
                ],
                [
                    90.0382174,
                    55.6817867
                ],
                [
                    90.0408691,
                    55.6829605
                ],
                [
                    90.0419843,
                    55.6866534
                ],
                [
                    90.0424459,
                    55.687135
                ],
                [
                    90.0431726,
                    55.6874617
                ],
                [
                    90.044194,
                    55.6882977
                ],
                [
                    90.0459815,
                    55.6893717
                ],
                [
                    90.046944,
                    55.6900526
                ],
                [
                    90.047111,
                    55.6897647
                ],
                [
                    90.047111,
                    55.6892609
                ],
                [
                    90.0482306,
                    55.6881537
                ],
                [
                    90.048869,
                    55.687052
                ],
                [
                    90.0490654,
                    55.6869468
                ],
                [
                    90.0497038,
                    55.6869523
                ],
                [
                    90.0505582,
                    55.6870299
                ],
                [
                    90.0506269,
                    55.6868914
                ],
                [
                    90.04991,
                    55.6863157
                ],
                [
                    90.0489959,
                    55.6835616
                ],
                [
                    90.0487633,
                    55.6819953
                ],
                [
                    90.0487508,
                    55.6816196
                ],
                [
                    90.0489795,
                    55.6813033
                ],
                [
                    90.0504094,
                    55.6809711
                ],
                [
                    90.051698,
                    55.6809755
                ],
                [
                    90.0516853,
                    55.6807842
                ],
                [
                    90.0507019,
                    55.6803453
                ],
                [
                    90.0479397,
                    55.6790474
                ],
                [
                    90.0464358,
                    55.6778707
                ],
                [
                    90.0443536,
                    55.6767216
                ],
                [
                    90.0439843,
                    55.6764557
                ],
                [
                    90.0432615,
                    55.6764247
                ],
                [
                    90.0426486,
                    55.6763539
                ],
                [
                    90.0423893,
                    55.676088
                ],
                [
                    90.0423972,
                    55.6757247
                ],
                [
                    90.0420594,
                    55.6754146
                ],
                [
                    90.0408179,
                    55.6746437
                ],
                [
                    90.0413994,
                    55.6744488
                ],
                [
                    90.0402522,
                    55.6739836
                ],
                [
                    90.0384609,
                    55.6734475
                ],
                [
                    90.0373295,
                    55.6733013
                ],
                [
                    90.0362766,
                    55.6733146
                ],
                [
                    90.0356245,
                    55.6734253
                ],
                [
                    90.0349724,
                    55.6737532
                ],
                [
                    90.0342259,
                    55.6742716
                ],
                [
                    90.0343124,
                    55.6747545
                ],
                [
                    90.0341552,
                    55.6749228
                ],
                [
                    90.0338567,
                    55.6749273
                ],
                [
                    90.0336288,
                    55.6746482
                ],
                [
                    90.0331495,
                    55.6742494
                ],
                [
                    90.0321831,
                    55.6739791
                ],
                [
                    90.0311146,
                    55.6738684
                ],
                [
                    90.0303603,
                    55.6740102
                ],
                [
                    90.0292918,
                    55.6742051
                ],
                [
                    90.0292008,
                    55.6743784
                ],
                [
                    90.0274053,
                    55.6746466
                ],
                [
                    90.0253797,
                    55.6747505
                ],
                [
                    90.0225714,
                    55.6748283
                ],
                [
                    90.0186179,
                    55.674439
                ]
            ],
            "longitude": 90.033401,
            "latitude": 55.678028
        },
        "6353": {
            "name": "Андроново",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.037498,
            "latitude": 55.555569
        },
        "6354": {
            "name": "Прогресс",
            "population": 129,
            "type": "hamlet",
            "poly": [
                [
                    90.0352823,
                    55.8353211
                ],
                [
                    90.0365649,
                    55.8363192
                ],
                [
                    90.0385072,
                    55.8371835
                ],
                [
                    90.039973,
                    55.8381507
                ],
                [
                    90.0407243,
                    55.8387268
                ],
                [
                    90.0414205,
                    55.8386857
                ],
                [
                    90.0445171,
                    55.8380992
                ],
                [
                    90.0483542,
                    55.8395481
                ],
                [
                    90.0483824,
                    55.8408018
                ],
                [
                    90.0482579,
                    55.8411148
                ],
                [
                    90.0486918,
                    55.8415493
                ],
                [
                    90.049325,
                    55.8420629
                ],
                [
                    90.0482461,
                    55.8424909
                ],
                [
                    90.0477888,
                    55.8431361
                ],
                [
                    90.0477888,
                    55.843439
                ],
                [
                    90.0489849,
                    55.8446899
                ],
                [
                    90.0508495,
                    55.8452298
                ],
                [
                    90.051084,
                    55.8449204
                ],
                [
                    90.0514241,
                    55.8447624
                ],
                [
                    90.052116,
                    55.8451837
                ],
                [
                    90.0528665,
                    55.8455327
                ],
                [
                    90.0536991,
                    55.8451508
                ],
                [
                    90.0539336,
                    55.8446109
                ],
                [
                    90.0539101,
                    55.8443542
                ],
                [
                    90.0523857,
                    55.8433402
                ],
                [
                    90.0517759,
                    55.8429189
                ],
                [
                    90.0514443,
                    55.8424384
                ],
                [
                    90.0504273,
                    55.8415954
                ],
                [
                    90.0503218,
                    55.8406802
                ],
                [
                    90.0502444,
                    55.8403286
                ],
                [
                    90.0503663,
                    55.840081
                ],
                [
                    90.0508166,
                    55.8399862
                ],
                [
                    90.0512294,
                    55.8399546
                ],
                [
                    90.0516516,
                    55.8397491
                ],
                [
                    90.0519705,
                    55.8394383
                ],
                [
                    90.0522145,
                    55.8393224
                ],
                [
                    90.0543346,
                    55.8390801
                ],
                [
                    90.0544871,
                    55.8382096
                ],
                [
                    90.0541662,
                    55.8369817
                ],
                [
                    90.0532515,
                    55.8363627
                ],
                [
                    90.0529231,
                    55.8357107
                ],
                [
                    90.0534626,
                    55.8353025
                ],
                [
                    90.053744,
                    55.8351839
                ],
                [
                    90.0537323,
                    55.8349337
                ],
                [
                    90.0535212,
                    55.8348085
                ],
                [
                    90.0536267,
                    55.8343871
                ],
                [
                    90.0532163,
                    55.8338734
                ],
                [
                    90.0520554,
                    55.8330107
                ],
                [
                    90.0515159,
                    55.8329711
                ],
                [
                    90.0510469,
                    55.8322862
                ],
                [
                    90.0507537,
                    55.8320886
                ],
                [
                    90.0509061,
                    55.8319108
                ],
                [
                    90.0507537,
                    55.8316276
                ],
                [
                    90.0505543,
                    55.8315815
                ],
                [
                    90.0505309,
                    55.8311798
                ],
                [
                    90.0507537,
                    55.8309954
                ],
                [
                    90.0507537,
                    55.8307517
                ],
                [
                    90.0504253,
                    55.8305738
                ],
                [
                    90.04971,
                    55.8294805
                ],
                [
                    90.0486663,
                    55.8289141
                ],
                [
                    90.0484201,
                    55.8286704
                ],
                [
                    90.048209,
                    55.8286045
                ],
                [
                    90.0481152,
                    55.8284464
                ],
                [
                    90.0482442,
                    55.8282949
                ],
                [
                    90.0477047,
                    55.8273004
                ],
                [
                    90.0474233,
                    55.8271686
                ],
                [
                    90.0448903,
                    55.8277153
                ],
                [
                    90.0420994,
                    55.8277087
                ],
                [
                    90.0410205,
                    55.8275704
                ],
                [
                    90.0401929,
                    55.8278089
                ],
                [
                    90.0405777,
                    55.8292085
                ],
                [
                    90.0415488,
                    55.8311638
                ],
                [
                    90.0416771,
                    55.8322238
                ],
                [
                    90.0423184,
                    55.8334792
                ],
                [
                    90.0384339,
                    55.8341069
                ],
                [
                    90.0352823,
                    55.8353211
                ]
            ],
            "longitude": 90.04689,
            "latitude": 55.834908
        },
        "6355": {
            "name": "Зарянка",
            "population": 132,
            "type": "hamlet",
            "poly": [
                [
                    90.0483739,
                    55.8920623
                ],
                [
                    90.0528676,
                    55.8976435
                ],
                [
                    90.0539277,
                    55.899153
                ],
                [
                    90.0545281,
                    55.8995475
                ],
                [
                    90.0552411,
                    55.8998894
                ],
                [
                    90.0562824,
                    55.9001471
                ],
                [
                    90.0584401,
                    55.9004259
                ],
                [
                    90.0608417,
                    55.9007782
                ],
                [
                    90.0609144,
                    55.9004472
                ],
                [
                    90.0626265,
                    55.8988891
                ],
                [
                    90.0648077,
                    55.8976925
                ],
                [
                    90.0659804,
                    55.8967062
                ],
                [
                    90.0682056,
                    55.8955949
                ],
                [
                    90.0666811,
                    55.8948782
                ],
                [
                    90.065356,
                    55.8940694
                ],
                [
                    90.0709196,
                    55.8906593
                ],
                [
                    90.0732687,
                    55.8890348
                ],
                [
                    90.0720604,
                    55.8886517
                ],
                [
                    90.0719681,
                    55.8881482
                ],
                [
                    90.0702606,
                    55.8876853
                ],
                [
                    90.067859,
                    55.8881219
                ],
                [
                    90.0674931,
                    55.887901
                ],
                [
                    90.0629338,
                    55.8881851
                ],
                [
                    90.0625492,
                    55.8881588
                ],
                [
                    90.06102,
                    55.8883429
                ],
                [
                    90.0584401,
                    55.8890163
                ],
                [
                    90.0541153,
                    55.8916888
                ],
                [
                    90.0538339,
                    55.8920623
                ],
                [
                    90.0535524,
                    55.8927725
                ],
                [
                    90.0532897,
                    55.8930356
                ],
                [
                    90.05268,
                    55.8927567
                ],
                [
                    90.0513103,
                    55.8924727
                ],
                [
                    90.0483739,
                    55.8920623
                ]
            ],
            "longitude": 90.057556,
            "latitude": 55.894855
        },
        "6356": {
            "name": "Петровка",
            "population": 31,
            "type": "hamlet",
            "poly": [
                [
                    90.0540414,
                    55.8506106
                ],
                [
                    90.0573029,
                    55.8528734
                ],
                [
                    90.0588786,
                    55.8520094
                ],
                [
                    90.0596299,
                    55.8518037
                ],
                [
                    90.062928,
                    55.8496437
                ],
                [
                    90.0639541,
                    55.8492117
                ],
                [
                    90.0642106,
                    55.8493557
                ],
                [
                    90.065933,
                    55.8482757
                ],
                [
                    90.0630013,
                    55.8461978
                ],
                [
                    90.0601246,
                    55.847391
                ],
                [
                    90.0568448,
                    55.8490574
                ],
                [
                    90.0540414,
                    55.8506106
                ]
            ],
            "longitude": 90.060486,
            "latitude": 55.84948
        },
        "6357": {
            "name": "Сопка",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    90.0570302,
                    57.4676227
                ],
                [
                    90.0576736,
                    57.4710481
                ],
                [
                    90.0636509,
                    57.4732123
                ],
                [
                    90.0713782,
                    57.4735949
                ],
                [
                    90.0746361,
                    57.4732515
                ],
                [
                    90.0773282,
                    57.4712887
                ],
                [
                    90.072706,
                    57.467856
                ],
                [
                    90.0680792,
                    57.46605
                ],
                [
                    90.0693342,
                    57.4648668
                ],
                [
                    90.0685024,
                    57.4650392
                ],
                [
                    90.0668108,
                    57.4651367
                ],
                [
                    90.063628,
                    57.4653201
                ],
                [
                    90.0585796,
                    57.4652264
                ],
                [
                    90.0575142,
                    57.4649257
                ],
                [
                    90.058741,
                    57.4660066
                ],
                [
                    90.0570302,
                    57.4676227
                ]
            ],
            "longitude": 90.065323,
            "latitude": 57.469418
        },
        "6358": {
            "name": "Слабцовка",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    90.0577435,
                    56.4563993
                ],
                [
                    90.060211,
                    56.4578146
                ],
                [
                    90.0609865,
                    56.4578991
                ],
                [
                    90.0600582,
                    56.4583795
                ],
                [
                    90.0619617,
                    56.4592624
                ],
                [
                    90.0652399,
                    56.4588599
                ],
                [
                    90.0672608,
                    56.4573472
                ],
                [
                    90.0682949,
                    56.4560227
                ],
                [
                    90.0685534,
                    56.4554578
                ],
                [
                    90.0695403,
                    56.454867
                ],
                [
                    90.0696932,
                    56.4544125
                ],
                [
                    90.0692349,
                    56.4540618
                ],
                [
                    90.0676487,
                    56.4537437
                ],
                [
                    90.0684007,
                    56.4531658
                ],
                [
                    90.0688471,
                    56.4529775
                ],
                [
                    90.0713499,
                    56.4532372
                ],
                [
                    90.0758737,
                    56.4532047
                ],
                [
                    90.0767763,
                    56.4531326
                ],
                [
                    90.0778009,
                    56.4521092
                ],
                [
                    90.0759303,
                    56.4510079
                ],
                [
                    90.0749433,
                    56.4513767
                ],
                [
                    90.0747647,
                    56.451678
                ],
                [
                    90.0744639,
                    56.4518806
                ],
                [
                    90.0735396,
                    56.4513784
                ],
                [
                    90.0699705,
                    56.4522469
                ],
                [
                    90.0690587,
                    56.4528151
                ],
                [
                    90.0652752,
                    56.453419
                ],
                [
                    90.0646642,
                    56.4537631
                ],
                [
                    90.062937,
                    56.4540359
                ],
                [
                    90.060117,
                    56.455276
                ],
                [
                    90.0577435,
                    56.4563993
                ]
            ],
            "longitude": 90.065445,
            "latitude": 56.455276
        },
        "6359": {
            "name": "Никулино",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.0754254,
            "latitude": 60.4074204
        },
        "6360": {
            "name": "Зеленцы",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    90.0681589,
                    56.4601093
                ],
                [
                    90.0686251,
                    56.4610405
                ],
                [
                    90.0685175,
                    56.4625065
                ],
                [
                    90.0716013,
                    56.4637744
                ],
                [
                    90.0728563,
                    56.4628631
                ],
                [
                    90.0757967,
                    56.4627244
                ],
                [
                    90.076227,
                    56.4620112
                ],
                [
                    90.0759209,
                    56.4618035
                ],
                [
                    90.0762734,
                    56.4615633
                ],
                [
                    90.0762616,
                    56.4613166
                ],
                [
                    90.0758386,
                    56.4611868
                ],
                [
                    90.0757916,
                    56.4608557
                ],
                [
                    90.0753451,
                    56.4607973
                ],
                [
                    90.0755214,
                    56.4604272
                ],
                [
                    90.0759679,
                    56.4602325
                ],
                [
                    90.0770254,
                    56.4608103
                ],
                [
                    90.0778244,
                    56.4605246
                ],
                [
                    90.0779184,
                    56.4607323
                ],
                [
                    90.0818898,
                    56.4602714
                ],
                [
                    90.0838051,
                    56.4596222
                ],
                [
                    90.0842046,
                    56.4591418
                ],
                [
                    90.0840401,
                    56.4586289
                ],
                [
                    90.0850506,
                    56.4579732
                ],
                [
                    90.0849801,
                    56.4574018
                ],
                [
                    90.0848038,
                    56.4571486
                ],
                [
                    90.0859083,
                    56.4567266
                ],
                [
                    90.0850741,
                    56.4558696
                ],
                [
                    90.0855793,
                    56.4557657
                ],
                [
                    90.0851563,
                    56.4551878
                ],
                [
                    90.0838873,
                    56.4544541
                ],
                [
                    90.0829473,
                    56.4551618
                ],
                [
                    90.0826066,
                    56.4544736
                ],
                [
                    90.0797278,
                    56.4550839
                ],
                [
                    90.07949,
                    56.455255
                ],
                [
                    90.0751511,
                    56.4567411
                ],
                [
                    90.073932,
                    56.4576129
                ],
                [
                    90.0719599,
                    56.4585639
                ],
                [
                    90.0681589,
                    56.4601093
                ]
            ],
            "longitude": 90.078438,
            "latitude": 56.458763
        },
        "6361": {
            "name": "Сухореченский",
            "population": 184,
            "type": "hamlet",
            "poly": [
                [
                    90.0791375,
                    55.5958696
                ],
                [
                    90.0798821,
                    55.5966627
                ],
                [
                    90.0827579,
                    55.5997259
                ],
                [
                    90.085648,
                    55.5985029
                ],
                [
                    90.0868657,
                    55.5965926
                ],
                [
                    90.0961975,
                    55.596341
                ],
                [
                    90.0991261,
                    55.5944544
                ],
                [
                    90.0934034,
                    55.5930703
                ],
                [
                    90.0941048,
                    55.5889105
                ],
                [
                    90.0880993,
                    55.588592
                ],
                [
                    90.0816302,
                    55.5913422
                ],
                [
                    90.0791375,
                    55.5958696
                ]
            ],
            "longitude": 90.084839,
            "latitude": 55.595936
        },
        "6362": {
            "name": "Глядень",
            "population": 145,
            "type": "hamlet",
            "poly": [
                [
                    90.0830466,
                    55.7250678
                ],
                [
                    90.0852255,
                    55.7249867
                ],
                [
                    90.0870589,
                    55.7251543
                ],
                [
                    90.0895944,
                    55.7257004
                ],
                [
                    90.0929828,
                    55.7265707
                ],
                [
                    90.0938179,
                    55.7268139
                ],
                [
                    90.094173,
                    55.7267707
                ],
                [
                    90.0943458,
                    55.7266518
                ],
                [
                    90.0942882,
                    55.7259112
                ],
                [
                    90.0947394,
                    55.7255274
                ],
                [
                    90.0949121,
                    55.7252517
                ],
                [
                    90.0944994,
                    55.7247274
                ],
                [
                    90.094509,
                    55.7243315
                ],
                [
                    90.0945889,
                    55.7240374
                ],
                [
                    90.0950926,
                    55.7237814
                ],
                [
                    90.0951418,
                    55.7233386
                ],
                [
                    90.094896,
                    55.7229926
                ],
                [
                    90.0939746,
                    55.7227054
                ],
                [
                    90.09352,
                    55.7225013
                ],
                [
                    90.0936428,
                    55.7216744
                ],
                [
                    90.093348,
                    55.7200931
                ],
                [
                    90.0933277,
                    55.719783
                ],
                [
                    90.0930577,
                    55.7190734
                ],
                [
                    90.0918967,
                    55.716871
                ],
                [
                    90.0920196,
                    55.7164515
                ],
                [
                    90.0872356,
                    55.7156512
                ],
                [
                    90.0866596,
                    55.7158372
                ],
                [
                    90.0863064,
                    55.7157853
                ],
                [
                    90.0857151,
                    55.7155474
                ],
                [
                    90.085216,
                    55.7154047
                ],
                [
                    90.0839874,
                    55.7155647
                ],
                [
                    90.0834729,
                    55.7161444
                ],
                [
                    90.0835189,
                    55.7166158
                ],
                [
                    90.0831887,
                    55.7166029
                ],
                [
                    90.083844,
                    55.7188106
                ],
                [
                    90.08394,
                    55.7198041
                ],
                [
                    90.08364,
                    55.7215206
                ],
                [
                    90.0835649,
                    55.7241488
                ],
                [
                    90.0830466,
                    55.7250678
                ]
            ],
            "longitude": 90.089516,
            "latitude": 55.721622
        },
        "6363": {
            "name": "Касово",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.1048202,
            "latitude": 59.8000897
        },
        "6364": {
            "name": "Счастливое",
            "population": 11,
            "type": "hamlet",
            "poly": [
                [
                    90.0936095,
                    56.5323821
                ],
                [
                    90.0943053,
                    56.5330681
                ],
                [
                    90.0950504,
                    56.5330477
                ],
                [
                    90.0954752,
                    56.5331156
                ],
                [
                    90.0961403,
                    56.5334755
                ],
                [
                    90.096442,
                    56.533591
                ],
                [
                    90.0966329,
                    56.5335468
                ],
                [
                    90.0969962,
                    56.5332956
                ],
                [
                    90.097341,
                    56.533248
                ],
                [
                    90.0980922,
                    56.5332922
                ],
                [
                    90.0992129,
                    56.5337302
                ],
                [
                    90.1077535,
                    56.5357641
                ],
                [
                    90.1082769,
                    56.5356826
                ],
                [
                    90.1088125,
                    56.5359169
                ],
                [
                    90.1103028,
                    56.5362734
                ],
                [
                    90.1102227,
                    56.5365756
                ],
                [
                    90.109533,
                    56.5364432
                ],
                [
                    90.1090959,
                    56.5371936
                ],
                [
                    90.1098841,
                    56.5373531
                ],
                [
                    90.1138188,
                    56.5385415
                ],
                [
                    90.1147794,
                    56.5387554
                ],
                [
                    90.1148964,
                    56.538864
                ],
                [
                    90.1174518,
                    56.5392918
                ],
                [
                    90.1181845,
                    56.5393325
                ],
                [
                    90.1184785,
                    56.5389038
                ],
                [
                    90.1184075,
                    56.5383888
                ],
                [
                    90.1177572,
                    56.5382389
                ],
                [
                    90.1178637,
                    56.5381172
                ],
                [
                    90.1182893,
                    56.5381998
                ],
                [
                    90.1189947,
                    56.5374545
                ],
                [
                    90.1198617,
                    56.5377196
                ],
                [
                    90.119641,
                    56.5382476
                ],
                [
                    90.119444,
                    56.5388321
                ],
                [
                    90.1209809,
                    56.5388929
                ],
                [
                    90.1213671,
                    56.5379694
                ],
                [
                    90.1215878,
                    56.5379716
                ],
                [
                    90.1216351,
                    56.5377348
                ],
                [
                    90.1207839,
                    56.5375935
                ],
                [
                    90.1210243,
                    56.5373241
                ],
                [
                    90.1211701,
                    56.536909
                ],
                [
                    90.1210992,
                    56.5364744
                ],
                [
                    90.1184588,
                    56.5357356
                ],
                [
                    90.1165867,
                    56.535351
                ],
                [
                    90.115779,
                    56.5350902
                ],
                [
                    90.115176,
                    56.5349924
                ],
                [
                    90.1151129,
                    56.5351423
                ],
                [
                    90.1131662,
                    56.5347816
                ],
                [
                    90.1129021,
                    56.5351423
                ],
                [
                    90.1123071,
                    56.5350098
                ],
                [
                    90.1125672,
                    56.5345382
                ],
                [
                    90.1108056,
                    56.5341145
                ],
                [
                    90.1090488,
                    56.5338306
                ],
                [
                    90.1096934,
                    56.532987
                ],
                [
                    90.1083272,
                    56.5326581
                ],
                [
                    90.1079808,
                    56.533125
                ],
                [
                    90.1071822,
                    56.5328438
                ],
                [
                    90.1062971,
                    56.5323026
                ],
                [
                    90.1055851,
                    56.5326687
                ],
                [
                    90.1063163,
                    56.5330826
                ],
                [
                    90.1055947,
                    56.5339686
                ],
                [
                    90.1053295,
                    56.5339352
                ],
                [
                    90.1037059,
                    56.5335244
                ],
                [
                    90.1022596,
                    56.5329485
                ],
                [
                    90.1017957,
                    56.5326824
                ],
                [
                    90.1005592,
                    56.5326661
                ],
                [
                    90.0995127,
                    56.5326287
                ],
                [
                    90.0983197,
                    56.5323613
                ],
                [
                    90.0982195,
                    56.5322382
                ],
                [
                    90.0983428,
                    56.5319265
                ],
                [
                    90.0982277,
                    56.5317505
                ],
                [
                    90.0977228,
                    56.5315638
                ],
                [
                    90.0973164,
                    56.531506
                ],
                [
                    90.09699,
                    56.531523
                ],
                [
                    90.096953,
                    56.5317166
                ],
                [
                    90.0968606,
                    56.5317811
                ],
                [
                    90.0965712,
                    56.5316996
                ],
                [
                    90.0961834,
                    56.5313226
                ],
                [
                    90.0959494,
                    56.5312649
                ],
                [
                    90.0953398,
                    56.5314041
                ],
                [
                    90.0939913,
                    56.5320969
                ],
                [
                    90.0936095,
                    56.5323821
                ]
            ],
            "longitude": 90.1113146,
            "latitude": 56.5354932
        },
        "6365": {
            "name": "Подкаменная Тунгуска",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.130028,
            "latitude": 61.599873
        },
        "6366": {
            "name": "Степноозерка",
            "population": 243,
            "type": "hamlet",
            "poly": [
                [
                    90.1197889,
                    55.7358707
                ],
                [
                    90.1255179,
                    55.7375073
                ],
                [
                    90.1245555,
                    55.7377118
                ],
                [
                    90.1239465,
                    55.7379164
                ],
                [
                    90.1236617,
                    55.7383145
                ],
                [
                    90.1226301,
                    55.738825
                ],
                [
                    90.1225123,
                    55.7389223
                ],
                [
                    90.1224809,
                    55.7391567
                ],
                [
                    90.1223001,
                    55.7392761
                ],
                [
                    90.1226694,
                    55.7399971
                ],
                [
                    90.1232587,
                    55.7403686
                ],
                [
                    90.1242722,
                    55.7405765
                ],
                [
                    90.1247672,
                    55.7406871
                ],
                [
                    90.12692,
                    55.740634
                ],
                [
                    90.1294657,
                    55.7402713
                ],
                [
                    90.1294028,
                    55.7408154
                ],
                [
                    90.1290179,
                    55.7408065
                ],
                [
                    90.1289864,
                    55.7410365
                ],
                [
                    90.1294814,
                    55.7411028
                ],
                [
                    90.1293164,
                    55.7416601
                ],
                [
                    90.1319642,
                    55.7419211
                ],
                [
                    90.1331687,
                    55.7418573
                ],
                [
                    90.1332999,
                    55.7418503
                ],
                [
                    90.1331349,
                    55.7410055
                ],
                [
                    90.1334885,
                    55.7403554
                ],
                [
                    90.1351225,
                    55.7407995
                ],
                [
                    90.1359966,
                    55.7410704
                ],
                [
                    90.1369984,
                    55.7412086
                ],
                [
                    90.1378037,
                    55.7415127
                ],
                [
                    90.1389626,
                    55.7417394
                ],
                [
                    90.1400037,
                    55.7417228
                ],
                [
                    90.1419287,
                    55.7415514
                ],
                [
                    90.1450911,
                    55.7415459
                ],
                [
                    90.1465053,
                    55.7416233
                ],
                [
                    90.1474678,
                    55.7414574
                ],
                [
                    90.1489705,
                    55.7416509
                ],
                [
                    90.1499035,
                    55.7416067
                ],
                [
                    90.1504633,
                    55.7409543
                ],
                [
                    90.1512392,
                    55.7404678
                ],
                [
                    90.1525552,
                    55.7395389
                ],
                [
                    90.1527909,
                    55.73908
                ],
                [
                    90.1528007,
                    55.7384331
                ],
                [
                    90.1522409,
                    55.737753
                ],
                [
                    90.1515534,
                    55.7373605
                ],
                [
                    90.1496919,
                    55.7367903
                ],
                [
                    90.1441521,
                    55.7362546
                ],
                [
                    90.1414819,
                    55.7348722
                ],
                [
                    90.1401776,
                    55.7338613
                ],
                [
                    90.1397939,
                    55.733654
                ],
                [
                    90.137354,
                    55.733222
                ],
                [
                    90.1304484,
                    55.7331269
                ],
                [
                    90.1285455,
                    55.7333775
                ],
                [
                    90.1269956,
                    55.733222
                ],
                [
                    90.1248319,
                    55.7326949
                ],
                [
                    90.1231132,
                    55.7320123
                ],
                [
                    90.1197889,
                    55.7358707
                ]
            ],
            "longitude": 90.136139,
            "latitude": 55.737614
        },
        "6367": {
            "name": "Новоракитка",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.147705,
            "latitude": 55.585773
        },
        "6368": {
            "name": "Ивановка",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    90.1445373,
                    56.4436689
                ],
                [
                    90.1451574,
                    56.4444243
                ],
                [
                    90.1486025,
                    56.4467538
                ],
                [
                    90.1491078,
                    56.4473885
                ],
                [
                    90.1505203,
                    56.4485183
                ],
                [
                    90.1509338,
                    56.4488357
                ],
                [
                    90.1496131,
                    56.449756
                ],
                [
                    90.150727,
                    56.4502383
                ],
                [
                    90.1523463,
                    56.4498448
                ],
                [
                    90.1544839,
                    56.4511028
                ],
                [
                    90.1562064,
                    56.4514797
                ],
                [
                    90.157606,
                    56.4522234
                ],
                [
                    90.1594542,
                    56.4513111
                ],
                [
                    90.1591312,
                    56.4497344
                ],
                [
                    90.1553452,
                    56.4462931
                ],
                [
                    90.1542147,
                    56.4456385
                ],
                [
                    90.1523306,
                    56.4447856
                ],
                [
                    90.1530663,
                    56.44425
                ],
                [
                    90.1501595,
                    56.4426432
                ],
                [
                    90.1497289,
                    56.4428912
                ],
                [
                    90.1486881,
                    56.4424647
                ],
                [
                    90.1460325,
                    56.4427424
                ],
                [
                    90.144597,
                    56.4435259
                ],
                [
                    90.1445373,
                    56.4436689
                ]
            ],
            "longitude": 90.153152,
            "latitude": 56.447563
        },
        "6369": {
            "name": "Богатое",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    90.1482355,
                    56.5530969
                ],
                [
                    90.1494336,
                    56.553405
                ],
                [
                    90.1486611,
                    56.5544788
                ],
                [
                    90.1491876,
                    56.5546317
                ],
                [
                    90.1501744,
                    56.5547638
                ],
                [
                    90.1518454,
                    56.5551339
                ],
                [
                    90.1529393,
                    56.5555596
                ],
                [
                    90.1535005,
                    56.5557316
                ],
                [
                    90.1552818,
                    56.5557664
                ],
                [
                    90.1558934,
                    56.5559505
                ],
                [
                    90.1574887,
                    56.555987
                ],
                [
                    90.1582296,
                    56.5561695
                ],
                [
                    90.1584188,
                    56.5565204
                ],
                [
                    90.1600865,
                    56.5568784
                ],
                [
                    90.1607076,
                    56.556682
                ],
                [
                    90.161871,
                    56.556894
                ],
                [
                    90.1622745,
                    56.5568645
                ],
                [
                    90.1627853,
                    56.5566264
                ],
                [
                    90.162965,
                    56.5564127
                ],
                [
                    90.1669216,
                    56.557205
                ],
                [
                    90.1677634,
                    56.5560478
                ],
                [
                    90.1669531,
                    56.5557994
                ],
                [
                    90.1665117,
                    56.5558133
                ],
                [
                    90.1657613,
                    56.5556171
                ],
                [
                    90.1636254,
                    56.5552565
                ],
                [
                    90.1635003,
                    56.5549489
                ],
                [
                    90.1621822,
                    56.554933
                ],
                [
                    90.1575736,
                    56.553724
                ],
                [
                    90.1573811,
                    56.5536339
                ],
                [
                    90.157285,
                    56.5536281
                ],
                [
                    90.1564211,
                    56.5538136
                ],
                [
                    90.1545812,
                    56.5534702
                ],
                [
                    90.154436,
                    56.5534257
                ],
                [
                    90.1540344,
                    56.5534135
                ],
                [
                    90.1537721,
                    56.5533868
                ],
                [
                    90.1534331,
                    56.55323
                ],
                [
                    90.1532394,
                    56.5532456
                ],
                [
                    90.1528943,
                    56.5532801
                ],
                [
                    90.1526442,
                    56.5532556
                ],
                [
                    90.1523495,
                    56.5530854
                ],
                [
                    90.1520328,
                    56.552962
                ],
                [
                    90.1516636,
                    56.5529598
                ],
                [
                    90.1514295,
                    56.5530031
                ],
                [
                    90.1511874,
                    56.5530554
                ],
                [
                    90.1509937,
                    56.5530165
                ],
                [
                    90.1504691,
                    56.552714
                ],
                [
                    90.15012,
                    56.552714
                ],
                [
                    90.1499364,
                    56.5528363
                ],
                [
                    90.1498093,
                    56.5530866
                ],
                [
                    90.1491878,
                    56.5529464
                ],
                [
                    90.1495801,
                    56.552516
                ],
                [
                    90.1489715,
                    56.5523442
                ],
                [
                    90.1482355,
                    56.5530969
                ]
            ],
            "longitude": 90.157501,
            "latitude": 56.5544063
        },
        "6370": {
            "name": "Лопатка",
            "population": 143,
            "type": "hamlet",
            "poly": [
                [
                    90.1535339,
                    55.3260624
                ],
                [
                    90.1541218,
                    55.3264628
                ],
                [
                    90.154978,
                    55.3272763
                ],
                [
                    90.1564731,
                    55.3264419
                ],
                [
                    90.1565495,
                    55.3268245
                ],
                [
                    90.1566626,
                    55.3270898
                ],
                [
                    90.1567191,
                    55.3273085
                ],
                [
                    90.1567304,
                    55.3279275
                ],
                [
                    90.1569367,
                    55.3280995
                ],
                [
                    90.1574935,
                    55.3284452
                ],
                [
                    90.1579514,
                    55.3286992
                ],
                [
                    90.1582481,
                    55.3288343
                ],
                [
                    90.1597376,
                    55.3288906
                ],
                [
                    90.1604356,
                    55.3287201
                ],
                [
                    90.1620466,
                    55.3283584
                ],
                [
                    90.1629312,
                    55.3280642
                ],
                [
                    90.1634117,
                    55.3278921
                ],
                [
                    90.1641183,
                    55.3274548
                ],
                [
                    90.1654579,
                    55.3270062
                ],
                [
                    90.1667183,
                    55.3263261
                ],
                [
                    90.1680383,
                    55.3255254
                ],
                [
                    90.1688324,
                    55.325078
                ],
                [
                    90.1694092,
                    55.325066
                ],
                [
                    90.1699575,
                    55.3251609
                ],
                [
                    90.170958,
                    55.325513
                ],
                [
                    90.1715543,
                    55.3251416
                ],
                [
                    90.171718,
                    55.324961
                ],
                [
                    90.1716438,
                    55.3243075
                ],
                [
                    90.1717144,
                    55.3237899
                ],
                [
                    90.1717172,
                    55.3230459
                ],
                [
                    90.1720807,
                    55.3228648
                ],
                [
                    90.1725187,
                    55.3227208
                ],
                [
                    90.1731065,
                    55.3222946
                ],
                [
                    90.1733694,
                    55.3214102
                ],
                [
                    90.1740307,
                    55.321013
                ],
                [
                    90.174774,
                    55.3206287
                ],
                [
                    90.176325,
                    55.3199946
                ],
                [
                    90.176791,
                    55.3198562
                ],
                [
                    90.1790898,
                    55.3190189
                ],
                [
                    90.1794788,
                    55.3185465
                ],
                [
                    90.1814088,
                    55.3177035
                ],
                [
                    90.1818719,
                    55.317547
                ],
                [
                    90.1818212,
                    55.3175203
                ],
                [
                    90.1816639,
                    55.3171436
                ],
                [
                    90.1815155,
                    55.3170612
                ],
                [
                    90.1814957,
                    55.3165404
                ],
                [
                    90.181123,
                    55.3165137
                ],
                [
                    90.1809621,
                    55.3163294
                ],
                [
                    90.1802078,
                    55.3163006
                ],
                [
                    90.1799726,
                    55.316139
                ],
                [
                    90.1799726,
                    55.316033
                ],
                [
                    90.1796959,
                    55.3159342
                ],
                [
                    90.179922,
                    55.315787
                ],
                [
                    90.1795999,
                    55.3156912
                ],
                [
                    90.1788313,
                    55.3155832
                ],
                [
                    90.1785943,
                    55.3154998
                ],
                [
                    90.1780879,
                    55.3154597
                ],
                [
                    90.1776627,
                    55.315365
                ],
                [
                    90.177509,
                    55.3148873
                ],
                [
                    90.1772088,
                    55.3142656
                ],
                [
                    90.1772177,
                    55.3136176
                ],
                [
                    90.1771111,
                    55.3134508
                ],
                [
                    90.1766281,
                    55.3131369
                ],
                [
                    90.1749653,
                    55.3137169
                ],
                [
                    90.1748202,
                    55.3136961
                ],
                [
                    90.1746968,
                    55.313667
                ],
                [
                    90.1717313,
                    55.3136028
                ],
                [
                    90.1716044,
                    55.313769
                ],
                [
                    90.1714597,
                    55.3139093
                ],
                [
                    90.1710595,
                    55.3141318
                ],
                [
                    90.1706141,
                    55.3142026
                ],
                [
                    90.1701664,
                    55.3142386
                ],
                [
                    90.1697979,
                    55.3143763
                ],
                [
                    90.1696508,
                    55.3146131
                ],
                [
                    90.1696441,
                    55.3149309
                ],
                [
                    90.1695582,
                    55.315093
                ],
                [
                    90.1693298,
                    55.3151908
                ],
                [
                    90.168059,
                    55.3155536
                ],
                [
                    90.1674238,
                    55.3158701
                ],
                [
                    90.1668812,
                    55.3163063
                ],
                [
                    90.1663724,
                    55.316709
                ],
                [
                    90.1660559,
                    55.3168775
                ],
                [
                    90.1657552,
                    55.3169779
                ],
                [
                    90.1652645,
                    55.3170397
                ],
                [
                    90.16448,
                    55.3170564
                ],
                [
                    90.164238,
                    55.3171657
                ],
                [
                    90.1638944,
                    55.3173986
                ],
                [
                    90.1634331,
                    55.3177807
                ],
                [
                    90.1632544,
                    55.3179956
                ],
                [
                    90.1632274,
                    55.3184253
                ],
                [
                    90.1630849,
                    55.3185231
                ],
                [
                    90.1626892,
                    55.3185539
                ],
                [
                    90.1625219,
                    55.3186543
                ],
                [
                    90.1620652,
                    55.3187456
                ],
                [
                    90.162072,
                    55.3188228
                ],
                [
                    90.1622031,
                    55.3189463
                ],
                [
                    90.1623139,
                    55.3189695
                ],
                [
                    90.1624134,
                    55.3189579
                ],
                [
                    90.1625174,
                    55.3189566
                ],
                [
                    90.1626327,
                    55.3190338
                ],
                [
                    90.1627321,
                    55.31903
                ],
                [
                    90.1628611,
                    55.3190647
                ],
                [
                    90.162886,
                    55.3191265
                ],
                [
                    90.162757,
                    55.319259
                ],
                [
                    90.1625219,
                    55.3191663
                ],
                [
                    90.162323,
                    55.3191831
                ],
                [
                    90.1620856,
                    55.3191651
                ],
                [
                    90.1619838,
                    55.3191831
                ],
                [
                    90.1618097,
                    55.3191599
                ],
                [
                    90.1616447,
                    55.3191779
                ],
                [
                    90.1614139,
                    55.3192435
                ],
                [
                    90.1590201,
                    55.3195444
                ],
                [
                    90.1579005,
                    55.3193385
                ],
                [
                    90.1566687,
                    55.3193601
                ],
                [
                    90.1555836,
                    55.3211021
                ],
                [
                    90.1556334,
                    55.3214469
                ],
                [
                    90.1559769,
                    55.3218071
                ],
                [
                    90.1556365,
                    55.322578
                ],
                [
                    90.1556423,
                    55.3228015
                ],
                [
                    90.1588162,
                    55.3233193
                ],
                [
                    90.1582481,
                    55.3234367
                ],
                [
                    90.1581125,
                    55.3235621
                ],
                [
                    90.1579005,
                    55.3236586
                ],
                [
                    90.1576235,
                    55.3237534
                ],
                [
                    90.1575359,
                    55.3238226
                ],
                [
                    90.1575331,
                    55.3238644
                ],
                [
                    90.1578863,
                    55.323866
                ],
                [
                    90.1580446,
                    55.3238467
                ],
                [
                    90.1580814,
                    55.3238756
                ],
                [
                    90.1580588,
                    55.3239544
                ],
                [
                    90.1576998,
                    55.3241024
                ],
                [
                    90.1576207,
                    55.3241377
                ],
                [
                    90.1576235,
                    55.3242069
                ],
                [
                    90.157697,
                    55.3242825
                ],
                [
                    90.1576207,
                    55.3243629
                ],
                [
                    90.1574313,
                    55.3244111
                ],
                [
                    90.15729,
                    55.3245092
                ],
                [
                    90.1570893,
                    55.3246426
                ],
                [
                    90.1570159,
                    55.3246571
                ],
                [
                    90.1569311,
                    55.3245783
                ],
                [
                    90.1567671,
                    55.3245558
                ],
                [
                    90.1563234,
                    55.324641
                ],
                [
                    90.1561539,
                    55.324789
                ],
                [
                    90.1559871,
                    55.325043
                ],
                [
                    90.1556423,
                    55.3250478
                ],
                [
                    90.1547746,
                    55.3253855
                ],
                [
                    90.1542687,
                    55.3256846
                ],
                [
                    90.1535339,
                    55.3260624
                ]
            ],
            "longitude": 90.167465,
            "latitude": 55.322323
        },
        "6371": {
            "name": "Новая Кузурба",
            "population": 207,
            "type": "hamlet",
            "poly": [
                [
                    90.1537744,
                    55.2631397
                ],
                [
                    90.1567844,
                    55.2631595
                ],
                [
                    90.1597692,
                    55.2628708
                ],
                [
                    90.1622814,
                    55.2624615
                ],
                [
                    90.1635271,
                    55.2621926
                ],
                [
                    90.1651128,
                    55.2620206
                ],
                [
                    90.1659455,
                    55.2620799
                ],
                [
                    90.1664555,
                    55.2622045
                ],
                [
                    90.1668303,
                    55.2623943
                ],
                [
                    90.167382,
                    55.2628253
                ],
                [
                    90.167958,
                    55.2632563
                ],
                [
                    90.1682876,
                    55.2633591
                ],
                [
                    90.1684784,
                    55.2633769
                ],
                [
                    90.168586,
                    55.2635845
                ],
                [
                    90.1687248,
                    55.2637407
                ],
                [
                    90.1690509,
                    55.2639542
                ],
                [
                    90.1691238,
                    55.2639641
                ],
                [
                    90.1694083,
                    55.2643496
                ],
                [
                    90.169901,
                    55.2653184
                ],
                [
                    90.1701023,
                    55.2657988
                ],
                [
                    90.1702827,
                    55.2664017
                ],
                [
                    90.1713934,
                    55.2685073
                ],
                [
                    90.1727441,
                    55.2708167
                ],
                [
                    90.1729392,
                    55.2709723
                ],
                [
                    90.1732385,
                    55.2709427
                ],
                [
                    90.1781336,
                    55.2687593
                ],
                [
                    90.1784372,
                    55.267336
                ],
                [
                    90.1785394,
                    55.2633182
                ],
                [
                    90.178817,
                    55.2630439
                ],
                [
                    90.1795283,
                    55.2631428
                ],
                [
                    90.1801789,
                    55.2631403
                ],
                [
                    90.1808208,
                    55.2630884
                ],
                [
                    90.181428,
                    55.2630835
                ],
                [
                    90.1821913,
                    55.2631181
                ],
                [
                    90.1827985,
                    55.2630316
                ],
                [
                    90.1834925,
                    55.2629451
                ],
                [
                    90.18557,
                    55.2629352
                ],
                [
                    90.1868668,
                    55.2631082
                ],
                [
                    90.1874697,
                    55.2632046
                ],
                [
                    90.1879858,
                    55.2633479
                ],
                [
                    90.1903954,
                    55.2633402
                ],
                [
                    90.1909644,
                    55.263273
                ],
                [
                    90.1915161,
                    55.2632414
                ],
                [
                    90.1925154,
                    55.2632354
                ],
                [
                    90.192904,
                    55.2632908
                ],
                [
                    90.1932718,
                    55.2633956
                ],
                [
                    90.1940941,
                    55.263708
                ],
                [
                    90.1958296,
                    55.2645324
                ],
                [
                    90.1991965,
                    55.2661013
                ],
                [
                    90.2014357,
                    55.2669163
                ],
                [
                    90.2043244,
                    55.2678838
                ],
                [
                    90.2057899,
                    55.2684375
                ],
                [
                    90.206943,
                    55.2692016
                ],
                [
                    90.2070211,
                    55.2692937
                ],
                [
                    90.2074208,
                    55.269062
                ],
                [
                    90.2070797,
                    55.2689648
                ],
                [
                    90.2070264,
                    55.2688231
                ],
                [
                    90.2067298,
                    55.2683211
                ],
                [
                    90.2064366,
                    55.268149
                ],
                [
                    90.2062447,
                    55.2679942
                ],
                [
                    90.2062377,
                    55.2678727
                ],
                [
                    90.2063922,
                    55.2676591
                ],
                [
                    90.2063354,
                    55.2673626
                ],
                [
                    90.2058557,
                    55.2666267
                ],
                [
                    90.205742,
                    55.2663261
                ],
                [
                    90.2057047,
                    55.2660143
                ],
                [
                    90.2059659,
                    55.2655396
                ],
                [
                    90.2059854,
                    55.2652714
                ],
                [
                    90.2058611,
                    55.2651509
                ],
                [
                    90.2050828,
                    55.2648351
                ],
                [
                    90.2048431,
                    55.2646155
                ],
                [
                    90.2046921,
                    55.2643513
                ],
                [
                    90.2042604,
                    55.2639747
                ],
                [
                    90.2041041,
                    55.2637105
                ],
                [
                    90.2039032,
                    55.2634716
                ],
                [
                    90.2036209,
                    55.2633309
                ],
                [
                    90.2025637,
                    55.2633269
                ],
                [
                    90.2012474,
                    55.2634008
                ],
                [
                    90.2002437,
                    55.2634625
                ],
                [
                    90.1993181,
                    55.2634281
                ],
                [
                    90.1974908,
                    55.2630987
                ],
                [
                    90.1964332,
                    55.262863
                ],
                [
                    90.1962972,
                    55.2627871
                ],
                [
                    90.1962722,
                    55.2627191
                ],
                [
                    90.1965248,
                    55.2624992
                ],
                [
                    90.1965192,
                    55.2622382
                ],
                [
                    90.1960807,
                    55.2620389
                ],
                [
                    90.1953506,
                    55.261827
                ],
                [
                    90.1949232,
                    55.2616688
                ],
                [
                    90.1919142,
                    55.2614505
                ],
                [
                    90.1919642,
                    55.2604951
                ],
                [
                    90.191942,
                    55.2600554
                ],
                [
                    90.1917699,
                    55.2595113
                ],
                [
                    90.1912258,
                    55.2585906
                ],
                [
                    90.1909094,
                    55.2578756
                ],
                [
                    90.1908094,
                    55.2577269
                ],
                [
                    90.1910259,
                    55.2575007
                ],
                [
                    90.1910065,
                    55.2572603
                ],
                [
                    90.1914368,
                    55.2572555
                ],
                [
                    90.1915367,
                    55.2572033
                ],
                [
                    90.1915922,
                    55.2569296
                ],
                [
                    90.1915839,
                    55.2565959
                ],
                [
                    90.191459,
                    55.2561592
                ],
                [
                    90.1913424,
                    55.2557495
                ],
                [
                    90.1914312,
                    55.2554689
                ],
                [
                    90.19139,
                    55.2550793
                ],
                [
                    90.1921759,
                    55.2546508
                ],
                [
                    90.1931878,
                    55.2545844
                ],
                [
                    90.1937303,
                    55.2545598
                ],
                [
                    90.1941078,
                    55.2544285
                ],
                [
                    90.1945713,
                    55.2541865
                ],
                [
                    90.1946518,
                    55.2539697
                ],
                [
                    90.1947129,
                    55.2538637
                ],
                [
                    90.1946518,
                    55.2537546
                ],
                [
                    90.1942896,
                    55.2535728
                ],
                [
                    90.1922457,
                    55.2534832
                ],
                [
                    90.1915518,
                    55.2534214
                ],
                [
                    90.1895946,
                    55.2534059
                ],
                [
                    90.1885917,
                    55.2533658
                ],
                [
                    90.1888627,
                    55.2529301
                ],
                [
                    90.189432,
                    55.2523955
                ],
                [
                    90.1906627,
                    55.2507608
                ],
                [
                    90.1913729,
                    55.2500995
                ],
                [
                    90.1824129,
                    55.2514311
                ],
                [
                    90.1816625,
                    55.2515498
                ],
                [
                    90.1805999,
                    55.2518909
                ],
                [
                    90.1705333,
                    55.2561105
                ],
                [
                    90.1627783,
                    55.2593633
                ],
                [
                    90.1595472,
                    55.2607251
                ],
                [
                    90.1577386,
                    55.2614814
                ],
                [
                    90.1537744,
                    55.2631397
                ]
            ],
            "longitude": 90.18515,
            "latitude": 55.2593
        },
        "6372": {
            "name": "Крещенка",
            "population": 30,
            "type": "hamlet",
            "poly": [
                [
                    90.1697858,
                    56.4334047
                ],
                [
                    90.1706831,
                    56.4340558
                ],
                [
                    90.1716924,
                    56.4345983
                ],
                [
                    90.1733466,
                    56.4346293
                ],
                [
                    90.1756736,
                    56.4346293
                ],
                [
                    90.1762624,
                    56.4343813
                ],
                [
                    90.1793184,
                    56.4345828
                ],
                [
                    90.182823,
                    56.4336837
                ],
                [
                    90.1846173,
                    56.4328311
                ],
                [
                    90.1938694,
                    56.4333117
                ],
                [
                    90.2010468,
                    56.4328776
                ],
                [
                    90.2022804,
                    56.4339472
                ],
                [
                    90.2029813,
                    56.4338697
                ],
                [
                    90.2042991,
                    56.4325211
                ],
                [
                    90.2044112,
                    56.431653
                ],
                [
                    90.2007104,
                    56.4309088
                ],
                [
                    90.1996169,
                    56.4310949
                ],
                [
                    90.1993646,
                    56.4313274
                ],
                [
                    90.1968133,
                    56.4305988
                ],
                [
                    90.1899442,
                    56.4297461
                ],
                [
                    90.1896079,
                    56.4294671
                ],
                [
                    90.1877014,
                    56.4294206
                ],
                [
                    90.1871126,
                    56.4295911
                ],
                [
                    90.1841687,
                    56.4293741
                ],
                [
                    90.1821501,
                    56.4299632
                ],
                [
                    90.1806642,
                    56.4299322
                ],
                [
                    90.1786175,
                    56.4302422
                ],
                [
                    90.1754213,
                    56.4310484
                ],
                [
                    90.1717205,
                    56.4331412
                ],
                [
                    90.1697858,
                    56.4334047
                ]
            ],
            "longitude": 90.185524,
            "latitude": 56.431168
        },
        "6373": {
            "name": "Терехта",
            "population": 184,
            "type": "hamlet",
            "poly": [
                [
                    90.1888178,
                    55.4316844
                ],
                [
                    90.1888856,
                    55.4319381
                ],
                [
                    90.1892288,
                    55.4327272
                ],
                [
                    90.1895131,
                    55.4339749
                ],
                [
                    90.1897752,
                    55.4346667
                ],
                [
                    90.1897842,
                    55.4349844
                ],
                [
                    90.1900913,
                    55.435443
                ],
                [
                    90.1901093,
                    55.4357068
                ],
                [
                    90.1902632,
                    55.4359836
                ],
                [
                    90.190821,
                    55.4358885
                ],
                [
                    90.1909973,
                    55.435882
                ],
                [
                    90.1911822,
                    55.4359689
                ],
                [
                    90.1921822,
                    55.4359754
                ],
                [
                    90.193139,
                    55.4354071
                ],
                [
                    90.1939266,
                    55.4350545
                ],
                [
                    90.1944323,
                    55.4349152
                ],
                [
                    90.198175,
                    55.4329619
                ],
                [
                    90.1986374,
                    55.4327774
                ],
                [
                    90.199844,
                    55.4323941
                ],
                [
                    90.200263,
                    55.4322158
                ],
                [
                    90.2004726,
                    55.4320662
                ],
                [
                    90.2006243,
                    55.4318796
                ],
                [
                    90.2006749,
                    55.4315045
                ],
                [
                    90.20087,
                    55.4299672
                ],
                [
                    90.20087,
                    55.4287844
                ],
                [
                    90.2002607,
                    55.4288993
                ],
                [
                    90.1992491,
                    55.4288019
                ],
                [
                    90.1989195,
                    55.4288096
                ],
                [
                    90.1984273,
                    55.4289403
                ],
                [
                    90.1981473,
                    55.4289582
                ],
                [
                    90.1974654,
                    55.4291862
                ],
                [
                    90.1942864,
                    55.4297269
                ],
                [
                    90.1924394,
                    55.4299319
                ],
                [
                    90.1911118,
                    55.4299011
                ],
                [
                    90.1907279,
                    55.4299677
                ],
                [
                    90.1906377,
                    55.4300933
                ],
                [
                    90.1906556,
                    55.4302957
                ],
                [
                    90.1896261,
                    55.4306134
                ],
                [
                    90.1895358,
                    55.4307672
                ],
                [
                    90.1895494,
                    55.4308056
                ],
                [
                    90.1896532,
                    55.4308517
                ],
                [
                    90.1896081,
                    55.431049
                ],
                [
                    90.1895131,
                    55.4311387
                ],
                [
                    90.1894139,
                    55.4311797
                ],
                [
                    90.1889397,
                    55.4312335
                ],
                [
                    90.1889578,
                    55.4314077
                ],
                [
                    90.1888178,
                    55.4316844
                ]
            ],
            "longitude": 90.195152,
            "latitude": 55.431801
        },
        "6374": {
            "name": "Голубки",
            "population": 128,
            "type": "hamlet",
            "poly": [
                [
                    90.1854032,
                    55.7821049
                ],
                [
                    90.187194,
                    55.7825353
                ],
                [
                    90.1887797,
                    55.7831426
                ],
                [
                    90.1885884,
                    55.7837268
                ],
                [
                    90.1887114,
                    55.7841958
                ],
                [
                    90.1882056,
                    55.7846877
                ],
                [
                    90.188315,
                    55.7850567
                ],
                [
                    90.1902014,
                    55.7861789
                ],
                [
                    90.1895863,
                    55.7864479
                ],
                [
                    90.1892992,
                    55.7869091
                ],
                [
                    90.1889848,
                    55.7871013
                ],
                [
                    90.1886294,
                    55.787009
                ],
                [
                    90.1882466,
                    55.7872627
                ],
                [
                    90.1878092,
                    55.7871935
                ],
                [
                    90.1877271,
                    55.7877008
                ],
                [
                    90.1883286,
                    55.7877392
                ],
                [
                    90.1892445,
                    55.7879545
                ],
                [
                    90.191008,
                    55.7890843
                ],
                [
                    90.192334,
                    55.7903678
                ],
                [
                    90.1932089,
                    55.790852
                ],
                [
                    90.1936873,
                    55.7912824
                ],
                [
                    90.1942271,
                    55.7912316
                ],
                [
                    90.194908,
                    55.7910805
                ],
                [
                    90.1951409,
                    55.7911082
                ],
                [
                    90.1953201,
                    55.7912896
                ],
                [
                    90.1955754,
                    55.7915918
                ],
                [
                    90.1960413,
                    55.7918235
                ],
                [
                    90.1971925,
                    55.7913399
                ],
                [
                    90.1981511,
                    55.7913022
                ],
                [
                    90.1983527,
                    55.7911385
                ],
                [
                    90.1983661,
                    55.790942
                ],
                [
                    90.1990335,
                    55.7901512
                ],
                [
                    90.199762,
                    55.7897321
                ],
                [
                    90.2003846,
                    55.7889665
                ],
                [
                    90.2007475,
                    55.788765
                ],
                [
                    90.2012671,
                    55.7886693
                ],
                [
                    90.2017688,
                    55.7888003
                ],
                [
                    90.2019703,
                    55.7889791
                ],
                [
                    90.2024496,
                    55.7887045
                ],
                [
                    90.2026512,
                    55.7881354
                ],
                [
                    90.2029737,
                    55.7878155
                ],
                [
                    90.2033769,
                    55.7877248
                ],
                [
                    90.2035426,
                    55.7876367
                ],
                [
                    90.2034799,
                    55.7874906
                ],
                [
                    90.2030454,
                    55.7875259
                ],
                [
                    90.2026467,
                    55.7874075
                ],
                [
                    90.2023298,
                    55.7870035
                ],
                [
                    90.2022423,
                    55.7866346
                ],
                [
                    90.2029422,
                    55.7858426
                ],
                [
                    90.2031697,
                    55.785513
                ],
                [
                    90.2014374,
                    55.7852916
                ],
                [
                    90.2004313,
                    55.7850702
                ],
                [
                    90.1997226,
                    55.7850259
                ],
                [
                    90.1988128,
                    55.7851637
                ],
                [
                    90.1974217,
                    55.7855031
                ],
                [
                    90.1972271,
                    55.7853864
                ],
                [
                    90.1924844,
                    55.7802752
                ],
                [
                    90.1854032,
                    55.7821049
                ]
            ],
            "longitude": 90.196167,
            "latitude": 55.787117
        },
        "6375": {
            "name": "Сереж",
            "population": 17,
            "type": "hamlet",
            "poly": [
                [
                    90.1954552,
                    55.8607001
                ],
                [
                    90.1962998,
                    55.8609261
                ],
                [
                    90.198264,
                    55.8612623
                ],
                [
                    90.1986667,
                    55.8612127
                ],
                [
                    90.1990792,
                    55.8612899
                ],
                [
                    90.1995506,
                    55.8608545
                ],
                [
                    90.1991185,
                    55.8606946
                ],
                [
                    90.1997817,
                    55.8601748
                ],
                [
                    90.2002577,
                    55.8597576
                ],
                [
                    90.2008175,
                    55.859719
                ],
                [
                    90.2013872,
                    55.8598403
                ],
                [
                    90.2019568,
                    55.8597135
                ],
                [
                    90.2022613,
                    55.8591899
                ],
                [
                    90.2000024,
                    55.858545
                ],
                [
                    90.1993836,
                    55.8583135
                ],
                [
                    90.1982541,
                    55.8582198
                ],
                [
                    90.1980971,
                    55.858319
                ],
                [
                    90.1979792,
                    55.858804
                ],
                [
                    90.1976746,
                    55.8591017
                ],
                [
                    90.1972104,
                    55.8592735
                ],
                [
                    90.1965257,
                    55.8596253
                ],
                [
                    90.1959462,
                    55.8598293
                ],
                [
                    90.1954552,
                    55.8607001
                ]
            ],
            "longitude": 90.197723,
            "latitude": 55.860466
        },
        "6376": {
            "name": "Мелецк",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    90.2037055,
                    57.4186978
                ],
                [
                    90.206691,
                    57.4197728
                ],
                [
                    90.2120292,
                    57.4192353
                ],
                [
                    90.2150414,
                    57.4178196
                ],
                [
                    90.2153714,
                    57.4163681
                ],
                [
                    90.2130184,
                    57.4158279
                ],
                [
                    90.2083664,
                    57.4163559
                ],
                [
                    90.2053631,
                    57.4172341
                ],
                [
                    90.2037055,
                    57.4186978
                ]
            ],
            "longitude": 90.20916,
            "latitude": 57.418152
        },
        "6377": {
            "name": "Черноозерск",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.213638,
            "latitude": 55.183632
        },
        "6378": {
            "name": "Ушканка",
            "population": 241,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.222672,
            "latitude": 55.571255
        },
        "6379": {
            "name": "Набережная",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.228714,
            "latitude": 55.534081
        },
        "6380": {
            "name": "Александровка",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    90.224243,
                    57.106473
                ],
                [
                    90.2242507,
                    57.1070292
                ],
                [
                    90.2256893,
                    57.1072457
                ],
                [
                    90.2259785,
                    57.1077764
                ],
                [
                    90.2263538,
                    57.1080651
                ],
                [
                    90.2269714,
                    57.1082774
                ],
                [
                    90.2261349,
                    57.1086382
                ],
                [
                    90.2256346,
                    57.1089864
                ],
                [
                    90.225486,
                    57.1092878
                ],
                [
                    90.2252906,
                    57.1092835
                ],
                [
                    90.2251577,
                    57.1096401
                ],
                [
                    90.2251498,
                    57.110001
                ],
                [
                    90.2252543,
                    57.1101169
                ],
                [
                    90.2252056,
                    57.1101503
                ],
                [
                    90.2251134,
                    57.1101823
                ],
                [
                    90.2250622,
                    57.110302
                ],
                [
                    90.2250878,
                    57.1106901
                ],
                [
                    90.2249904,
                    57.1108779
                ],
                [
                    90.2250775,
                    57.1110378
                ],
                [
                    90.2250724,
                    57.1119824
                ],
                [
                    90.2251493,
                    57.1120922
                ],
                [
                    90.2250904,
                    57.112159
                ],
                [
                    90.2251211,
                    57.1125096
                ],
                [
                    90.2253286,
                    57.1125833
                ],
                [
                    90.2258333,
                    57.112632
                ],
                [
                    90.2262406,
                    57.1127446
                ],
                [
                    90.2263572,
                    57.1127502
                ],
                [
                    90.2279881,
                    57.1122063
                ],
                [
                    90.2283762,
                    57.1119303
                ],
                [
                    90.2284804,
                    57.1116347
                ],
                [
                    90.2297413,
                    57.1118564
                ],
                [
                    90.2298013,
                    57.1118172
                ],
                [
                    90.2297653,
                    57.1115868
                ],
                [
                    90.2299174,
                    57.1113564
                ],
                [
                    90.2300975,
                    57.1105566
                ],
                [
                    90.2303417,
                    57.1101871
                ],
                [
                    90.2308539,
                    57.1094915
                ],
                [
                    90.2295651,
                    57.1090568
                ],
                [
                    90.2299094,
                    57.1088264
                ],
                [
                    90.2299654,
                    57.1086003
                ],
                [
                    90.2303176,
                    57.1084721
                ],
                [
                    90.2306579,
                    57.1085569
                ],
                [
                    90.2309101,
                    57.1085721
                ],
                [
                    90.2311382,
                    57.1084069
                ],
                [
                    90.2316746,
                    57.1076874
                ],
                [
                    90.2317907,
                    57.1072831
                ],
                [
                    90.2316145,
                    57.1068939
                ],
                [
                    90.2309541,
                    57.106694
                ],
                [
                    90.230942,
                    57.1065657
                ],
                [
                    90.2311342,
                    57.1064548
                ],
                [
                    90.2315185,
                    57.1058027
                ],
                [
                    90.2319388,
                    57.1055353
                ],
                [
                    90.2321629,
                    57.1049984
                ],
                [
                    90.232263,
                    57.1049223
                ],
                [
                    90.2326913,
                    57.1049114
                ],
                [
                    90.2327993,
                    57.1048462
                ],
                [
                    90.2328074,
                    57.1047245
                ],
                [
                    90.2327473,
                    57.1046853
                ],
                [
                    90.2326552,
                    57.1046745
                ],
                [
                    90.2326552,
                    57.1045092
                ],
                [
                    90.2325592,
                    57.1043875
                ],
                [
                    90.2326032,
                    57.1038571
                ],
                [
                    90.2327193,
                    57.103431
                ],
                [
                    90.2325712,
                    57.1032896
                ],
                [
                    90.232263,
                    57.1031483
                ],
                [
                    90.2318387,
                    57.1031157
                ],
                [
                    90.2314023,
                    57.1031309
                ],
                [
                    90.230898,
                    57.1030853
                ],
                [
                    90.2300415,
                    57.103094
                ],
                [
                    90.2302336,
                    57.1035331
                ],
                [
                    90.2298693,
                    57.1036005
                ],
                [
                    90.2297773,
                    57.1036984
                ],
                [
                    90.2298894,
                    57.1038744
                ],
                [
                    90.2299109,
                    57.1045114
                ],
                [
                    90.2297389,
                    57.1046515
                ],
                [
                    90.2295747,
                    57.1046515
                ],
                [
                    90.2295044,
                    57.1048511
                ],
                [
                    90.229606,
                    57.1049827
                ],
                [
                    90.2294731,
                    57.1052714
                ],
                [
                    90.2292855,
                    57.1055516
                ],
                [
                    90.2292542,
                    57.1060951
                ],
                [
                    90.2289806,
                    57.1065069
                ],
                [
                    90.2264711,
                    57.1064772
                ],
                [
                    90.2261114,
                    57.1065197
                ],
                [
                    90.2249935,
                    57.1062777
                ],
                [
                    90.2242899,
                    57.1061673
                ],
                [
                    90.224243,
                    57.106473
                ]
            ],
            "longitude": 90.2292051,
            "latitude": 57.1075152
        },
        "6381": {
            "name": "Муслинка",
            "population": 70,
            "type": "hamlet",
            "poly": [
                [
                    90.2265409,
                    57.1618945
                ],
                [
                    90.227314,
                    57.1631599
                ],
                [
                    90.2281226,
                    57.1630792
                ],
                [
                    90.2289241,
                    57.164283
                ],
                [
                    90.2284914,
                    57.1643638
                ],
                [
                    90.2287681,
                    57.1647522
                ],
                [
                    90.2289738,
                    57.1647368
                ],
                [
                    90.2296618,
                    57.1651753
                ],
                [
                    90.2298817,
                    57.1654137
                ],
                [
                    90.2295483,
                    57.1655252
                ],
                [
                    90.230059,
                    57.1660637
                ],
                [
                    90.2305128,
                    57.1662636
                ],
                [
                    90.230903,
                    57.1666444
                ],
                [
                    90.2302806,
                    57.1669298
                ],
                [
                    90.2306849,
                    57.1672452
                ],
                [
                    90.2306495,
                    57.167922
                ],
                [
                    90.230997,
                    57.1681527
                ],
                [
                    90.2313659,
                    57.168195
                ],
                [
                    90.232905,
                    57.1687219
                ],
                [
                    90.2359053,
                    57.1699563
                ],
                [
                    90.2363309,
                    57.1700524
                ],
                [
                    90.2369906,
                    57.1700947
                ],
                [
                    90.2375297,
                    57.1701755
                ],
                [
                    90.2378417,
                    57.1704639
                ],
                [
                    90.2390192,
                    57.1706639
                ],
                [
                    90.2396008,
                    57.17086
                ],
                [
                    90.2401611,
                    57.1709215
                ],
                [
                    90.2402959,
                    57.1708138
                ],
                [
                    90.2405229,
                    57.1708177
                ],
                [
                    90.2406647,
                    57.17091
                ],
                [
                    90.2413386,
                    57.171033
                ],
                [
                    90.2417854,
                    57.1710215
                ],
                [
                    90.2422677,
                    57.1707408
                ],
                [
                    90.2425728,
                    57.1703793
                ],
                [
                    90.2411471,
                    57.1687834
                ],
                [
                    90.2404945,
                    57.168395
                ],
                [
                    90.2398491,
                    57.1681874
                ],
                [
                    90.2399909,
                    57.1680951
                ],
                [
                    90.2397639,
                    57.1679182
                ],
                [
                    90.2392816,
                    57.1679143
                ],
                [
                    90.2385652,
                    57.1676567
                ],
                [
                    90.238413,
                    57.1675101
                ],
                [
                    90.2380544,
                    57.1674313
                ],
                [
                    90.2373599,
                    57.1670547
                ],
                [
                    90.2374597,
                    57.1669883
                ],
                [
                    90.2371465,
                    57.1668406
                ],
                [
                    90.237033,
                    57.1668603
                ],
                [
                    90.2367915,
                    57.1667146
                ],
                [
                    90.2357247,
                    57.1665043
                ],
                [
                    90.2358771,
                    57.1661888
                ],
                [
                    90.2351982,
                    57.1655278
                ],
                [
                    90.2384954,
                    57.1650395
                ],
                [
                    90.2388401,
                    57.1644561
                ],
                [
                    90.2388897,
                    57.1643176
                ],
                [
                    90.2387337,
                    57.1641792
                ],
                [
                    90.2376838,
                    57.1639138
                ],
                [
                    90.23723,
                    57.1637061
                ],
                [
                    90.2368539,
                    57.1635407
                ],
                [
                    90.2363292,
                    57.1636907
                ],
                [
                    90.2360454,
                    57.1639753
                ],
                [
                    90.2348609,
                    57.1643753
                ],
                [
                    90.2341871,
                    57.1646061
                ],
                [
                    90.2336976,
                    57.1641176
                ],
                [
                    90.234031,
                    57.1640138
                ],
                [
                    90.233655,
                    57.1637253
                ],
                [
                    90.2333501,
                    57.1638253
                ],
                [
                    90.2328394,
                    57.1634907
                ],
                [
                    90.2325344,
                    57.1623676
                ],
                [
                    90.2313357,
                    57.1616945
                ],
                [
                    90.2311299,
                    57.1617868
                ],
                [
                    90.2308179,
                    57.1615791
                ],
                [
                    90.2308818,
                    57.1607945
                ],
                [
                    90.230215,
                    57.160356
                ],
                [
                    90.2296334,
                    57.160456
                ],
                [
                    90.2287397,
                    57.1607945
                ],
                [
                    90.2274629,
                    57.1610253
                ],
                [
                    90.2265409,
                    57.1618945
                ]
            ],
            "longitude": 90.233032,
            "latitude": 57.166336
        },
        "6382": {
            "name": "Биктимировка",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    90.2274286,
                    57.1988119
                ],
                [
                    90.2277052,
                    57.1992154
                ],
                [
                    90.227535,
                    57.1994728
                ],
                [
                    90.2275633,
                    57.1996304
                ],
                [
                    90.2284429,
                    57.20003
                ],
                [
                    90.2290387,
                    57.2009022
                ],
                [
                    90.2289961,
                    57.2011327
                ],
                [
                    90.2293153,
                    57.2012364
                ],
                [
                    90.2297286,
                    57.2016669
                ],
                [
                    90.2301985,
                    57.2015901
                ],
                [
                    90.2311117,
                    57.2012635
                ],
                [
                    90.2313954,
                    57.2012539
                ],
                [
                    90.2317589,
                    57.2015468
                ],
                [
                    90.2329204,
                    57.2021568
                ],
                [
                    90.2335588,
                    57.2027235
                ],
                [
                    90.2338691,
                    57.2036216
                ],
                [
                    90.2331421,
                    57.2038473
                ],
                [
                    90.2325392,
                    57.2039001
                ],
                [
                    90.2321757,
                    57.2041498
                ],
                [
                    90.2326633,
                    57.205312
                ],
                [
                    90.2324594,
                    57.2069399
                ],
                [
                    90.2329116,
                    57.2072328
                ],
                [
                    90.2357931,
                    57.2078715
                ],
                [
                    90.2371673,
                    57.2084285
                ],
                [
                    90.2402616,
                    57.2086926
                ],
                [
                    90.2405275,
                    57.2088222
                ],
                [
                    90.2408557,
                    57.2088318
                ],
                [
                    90.2409708,
                    57.2086686
                ],
                [
                    90.2418576,
                    57.2086253
                ],
                [
                    90.242097,
                    57.2064981
                ],
                [
                    90.241565,
                    57.2056961
                ],
                [
                    90.2418132,
                    57.2052928
                ],
                [
                    90.2415561,
                    57.2051151
                ],
                [
                    90.2415738,
                    57.2050094
                ],
                [
                    90.241822,
                    57.2049902
                ],
                [
                    90.2424644,
                    57.2029801
                ],
                [
                    90.2424781,
                    57.2029204
                ],
                [
                    90.2427619,
                    57.2028435
                ],
                [
                    90.243019,
                    57.2020319
                ],
                [
                    90.2425935,
                    57.2019263
                ],
                [
                    90.2426644,
                    57.2017486
                ],
                [
                    90.2421413,
                    57.2016189
                ],
                [
                    90.2409621,
                    57.2016381
                ],
                [
                    90.2406163,
                    57.2016909
                ],
                [
                    90.2406429,
                    57.2009177
                ],
                [
                    90.2389051,
                    57.2010329
                ],
                [
                    90.238781,
                    57.2008408
                ],
                [
                    90.2407138,
                    57.2003125
                ],
                [
                    90.2406074,
                    57.1996257
                ],
                [
                    90.2408114,
                    57.199155
                ],
                [
                    90.2408911,
                    57.198473
                ],
                [
                    90.240705,
                    57.1984346
                ],
                [
                    90.240634,
                    57.1981944
                ],
                [
                    90.2402084,
                    57.19818
                ],
                [
                    90.2388253,
                    57.1951203
                ],
                [
                    90.2383518,
                    57.1952306
                ],
                [
                    90.2378411,
                    57.1951614
                ],
                [
                    90.2371318,
                    57.1952767
                ],
                [
                    90.2368764,
                    57.1952806
                ],
                [
                    90.2367062,
                    57.1951537
                ],
                [
                    90.2363799,
                    57.1951768
                ],
                [
                    90.2359047,
                    57.1954227
                ],
                [
                    90.2334362,
                    57.1954535
                ],
                [
                    90.2332306,
                    57.1954919
                ],
                [
                    90.2330391,
                    57.1953881
                ],
                [
                    90.2327909,
                    57.1955688
                ],
                [
                    90.2328263,
                    57.1957109
                ],
                [
                    90.2326065,
                    57.1959031
                ],
                [
                    90.2324575,
                    57.1958185
                ],
                [
                    90.2319964,
                    57.1959261
                ],
                [
                    90.2322447,
                    57.1961682
                ],
                [
                    90.2322447,
                    57.196295
                ],
                [
                    90.2314432,
                    57.196614
                ],
                [
                    90.2305921,
                    57.1970405
                ],
                [
                    90.2296628,
                    57.1969675
                ],
                [
                    90.2294074,
                    57.1970251
                ],
                [
                    90.2293508,
                    57.1971981
                ],
                [
                    90.2289961,
                    57.197298
                ],
                [
                    90.2281521,
                    57.1974517
                ],
                [
                    90.2281166,
                    57.1978513
                ],
                [
                    90.2284358,
                    57.1979013
                ],
                [
                    90.2290742,
                    57.1981241
                ],
                [
                    90.2292444,
                    57.1983393
                ],
                [
                    90.2292302,
                    57.1986236
                ],
                [
                    90.2287834,
                    57.1987966
                ],
                [
                    90.2281875,
                    57.1988657
                ],
                [
                    90.2276627,
                    57.1988004
                ],
                [
                    90.2274286,
                    57.1988119
                ]
            ],
            "longitude": 90.235161,
            "latitude": 57.201191
        },
        "6383": {
            "name": "Борцы",
            "population": 113,
            "type": "hamlet",
            "poly": [
                [
                    90.2325071,
                    56.3903311
                ],
                [
                    90.2325509,
                    56.3924165
                ],
                [
                    90.2338439,
                    56.3927186
                ],
                [
                    90.2355803,
                    56.3928915
                ],
                [
                    90.2386212,
                    56.3928152
                ],
                [
                    90.2394664,
                    56.3930745
                ],
                [
                    90.2401554,
                    56.3931305
                ],
                [
                    90.2416712,
                    56.3926881
                ],
                [
                    90.2426913,
                    56.3925366
                ],
                [
                    90.2433573,
                    56.3932549
                ],
                [
                    90.245367,
                    56.3933947
                ],
                [
                    90.2456656,
                    56.3933375
                ],
                [
                    90.245987,
                    56.392721
                ],
                [
                    90.2478016,
                    56.3926892
                ],
                [
                    90.2486284,
                    56.3926765
                ],
                [
                    90.2503854,
                    56.3921171
                ],
                [
                    90.2522458,
                    56.392098
                ],
                [
                    90.2522343,
                    56.3933629
                ],
                [
                    90.2523491,
                    56.3937189
                ],
                [
                    90.2563225,
                    56.3937189
                ],
                [
                    90.2563111,
                    56.3917993
                ],
                [
                    90.2543244,
                    56.3917802
                ],
                [
                    90.2540602,
                    56.3911891
                ],
                [
                    90.2547952,
                    56.3909412
                ],
                [
                    90.2568049,
                    56.3908013
                ],
                [
                    90.2568049,
                    56.3902674
                ],
                [
                    90.2563225,
                    56.3898987
                ],
                [
                    90.2562766,
                    56.3892248
                ],
                [
                    90.2556181,
                    56.3884154
                ],
                [
                    90.2540603,
                    56.3879304
                ],
                [
                    90.2531403,
                    56.3876879
                ],
                [
                    90.2516071,
                    56.3881729
                ],
                [
                    90.2508624,
                    56.3881487
                ],
                [
                    90.2504681,
                    56.3874454
                ],
                [
                    90.244817,
                    56.3875909
                ],
                [
                    90.2406115,
                    56.3881002
                ],
                [
                    90.2337337,
                    56.3898704
                ],
                [
                    90.2325071,
                    56.3903311
                ]
            ],
            "longitude": 90.243172,
            "latitude": 56.390678
        },
        "6384": {
            "name": "Верхняя Чулымка",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    90.2423894,
                    56.0634269
                ],
                [
                    90.2427084,
                    56.0635526
                ],
                [
                    90.2428116,
                    56.0642754
                ],
                [
                    90.2429804,
                    56.0643592
                ],
                [
                    90.2433932,
                    56.0643958
                ],
                [
                    90.2434026,
                    56.064951
                ],
                [
                    90.243881,
                    56.0651343
                ],
                [
                    90.2444574,
                    56.0656708
                ],
                [
                    90.2448897,
                    56.0656439
                ],
                [
                    90.2449738,
                    56.0658719
                ],
                [
                    90.245304,
                    56.0659959
                ],
                [
                    90.245304,
                    56.0661232
                ],
                [
                    90.2456855,
                    56.0662449
                ],
                [
                    90.2501024,
                    56.0655756
                ],
                [
                    90.254088,
                    56.0653566
                ],
                [
                    90.2555156,
                    56.0644461
                ],
                [
                    90.2558584,
                    56.0574388
                ],
                [
                    90.2549972,
                    56.0568659
                ],
                [
                    90.2536597,
                    56.0551573
                ],
                [
                    90.2529634,
                    56.0548708
                ],
                [
                    90.2516808,
                    56.0546764
                ],
                [
                    90.2514059,
                    56.0544615
                ],
                [
                    90.2499034,
                    56.0557405
                ],
                [
                    90.2515525,
                    56.0562725
                ],
                [
                    90.2507463,
                    56.0570398
                ],
                [
                    90.2498485,
                    56.0575002
                ],
                [
                    90.2497202,
                    56.0577662
                ],
                [
                    90.2473566,
                    56.0587279
                ],
                [
                    90.2470267,
                    56.0595872
                ],
                [
                    90.2447913,
                    56.0594952
                ],
                [
                    90.2445531,
                    56.0599862
                ],
                [
                    90.2440584,
                    56.059976
                ],
                [
                    90.2437836,
                    56.060109
                ],
                [
                    90.2445348,
                    56.0606921
                ],
                [
                    90.2445348,
                    56.0612138
                ],
                [
                    90.2434401,
                    56.0617614
                ],
                [
                    90.2438154,
                    56.0620128
                ],
                [
                    90.2437028,
                    56.0623375
                ],
                [
                    90.2428116,
                    56.0626151
                ],
                [
                    90.2423988,
                    56.0629032
                ],
                [
                    90.2423894,
                    56.0634269
                ]
            ],
            "longitude": 90.248695,
            "latitude": 56.06242
        },
        "6385": {
            "name": "Щелево",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    90.2474285,
                    57.3816544
                ],
                [
                    90.2486619,
                    57.383599
                ],
                [
                    90.2490611,
                    57.3852821
                ],
                [
                    90.2483909,
                    57.3882947
                ],
                [
                    90.2517489,
                    57.3886367
                ],
                [
                    90.2561621,
                    57.3886367
                ],
                [
                    90.2584934,
                    57.3870305
                ],
                [
                    90.2558555,
                    57.3854282
                ],
                [
                    90.2555204,
                    57.3827382
                ],
                [
                    90.2568893,
                    57.3800326
                ],
                [
                    90.2559197,
                    57.3782339
                ],
                [
                    90.2538949,
                    57.3778611
                ],
                [
                    90.2474285,
                    57.3816544
                ]
            ],
            "longitude": 90.253639,
            "latitude": 57.384087
        },
        "6386": {
            "name": "Зерцалы",
            "population": 237,
            "type": "hamlet",
            "poly": [
                [
                    90.2463907,
                    56.2740676
                ],
                [
                    90.2466021,
                    56.2754229
                ],
                [
                    90.2504077,
                    56.2755509
                ],
                [
                    90.2527718,
                    56.274996
                ],
                [
                    90.2530793,
                    56.2753162
                ],
                [
                    90.2563852,
                    56.2746759
                ],
                [
                    90.2580958,
                    56.2748466
                ],
                [
                    90.2619783,
                    56.2746226
                ],
                [
                    90.2663989,
                    56.2741957
                ],
                [
                    90.2675521,
                    56.2735554
                ],
                [
                    90.2678596,
                    56.2730538
                ],
                [
                    90.2690513,
                    56.2717625
                ],
                [
                    90.2691474,
                    56.2713784
                ],
                [
                    90.2697048,
                    56.2709194
                ],
                [
                    90.2698393,
                    56.270119
                ],
                [
                    90.2718766,
                    56.2683687
                ],
                [
                    90.2694549,
                    56.2672693
                ],
                [
                    90.2682248,
                    56.2675575
                ],
                [
                    90.2682056,
                    56.2666823
                ],
                [
                    90.2645153,
                    56.2671733
                ],
                [
                    90.2630161,
                    56.2678884
                ],
                [
                    90.2616131,
                    56.2693506
                ],
                [
                    90.2593067,
                    56.2704605
                ],
                [
                    90.2568657,
                    56.2714744
                ],
                [
                    90.2540019,
                    56.2727123
                ],
                [
                    90.2511189,
                    56.2735234
                ],
                [
                    90.2488701,
                    56.2736515
                ],
                [
                    90.2479345,
                    56.2735887
                ],
                [
                    90.2472811,
                    56.2738768
                ],
                [
                    90.2463907,
                    56.2740676
                ]
            ],
            "longitude": 90.262749,
            "latitude": 56.271999
        },
        "6387": {
            "name": "Стан Самоедская Речка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.2686249,
            "latitude": 70.4833811
        },
        "6388": {
            "name": "Ворожейка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.2741232,
            "latitude": 58.2144775
        },
        "6389": {
            "name": "Нижний Ададым",
            "population": 201,
            "type": "hamlet",
            "poly": [
                [
                    90.2723541,
                    55.9123933
                ],
                [
                    90.2723919,
                    55.9128683
                ],
                [
                    90.2730779,
                    55.9131898
                ],
                [
                    90.2744999,
                    55.9136792
                ],
                [
                    90.274874,
                    55.9136442
                ],
                [
                    90.2755601,
                    55.9134624
                ],
                [
                    90.2759717,
                    55.9134624
                ],
                [
                    90.2769571,
                    55.9138959
                ],
                [
                    90.278853,
                    55.9149584
                ],
                [
                    90.2794891,
                    55.9155386
                ],
                [
                    90.2794891,
                    55.915902
                ],
                [
                    90.2793644,
                    55.9165381
                ],
                [
                    90.2791398,
                    55.9175586
                ],
                [
                    90.2785162,
                    55.9181528
                ],
                [
                    90.2778067,
                    55.9186835
                ],
                [
                    90.2774061,
                    55.9190894
                ],
                [
                    90.278828,
                    55.9191523
                ],
                [
                    90.2810482,
                    55.9190265
                ],
                [
                    90.2833682,
                    55.9187049
                ],
                [
                    90.2843162,
                    55.9185232
                ],
                [
                    90.2856258,
                    55.9189216
                ],
                [
                    90.2842787,
                    55.920005
                ],
                [
                    90.2894675,
                    55.9217383
                ],
                [
                    90.2897669,
                    55.9221366
                ],
                [
                    90.2903781,
                    55.9226119
                ],
                [
                    90.2910142,
                    55.9228006
                ],
                [
                    90.2919123,
                    55.9226748
                ],
                [
                    90.2923363,
                    55.9224791
                ],
                [
                    90.2925983,
                    55.9225909
                ],
                [
                    90.2954546,
                    55.9230801
                ],
                [
                    90.2959286,
                    55.9223952
                ],
                [
                    90.2963028,
                    55.9223044
                ],
                [
                    90.2964899,
                    55.9219619
                ],
                [
                    90.296348,
                    55.9216673
                ],
                [
                    90.2969713,
                    55.9217074
                ],
                [
                    90.29691,
                    55.9211549
                ],
                [
                    90.2971501,
                    55.9209659
                ],
                [
                    90.2971501,
                    55.9207884
                ],
                [
                    90.2968129,
                    55.920777
                ],
                [
                    90.2966649,
                    55.9187671
                ],
                [
                    90.2964478,
                    55.9187599
                ],
                [
                    90.2969906,
                    55.9177114
                ],
                [
                    90.2966713,
                    55.916083
                ],
                [
                    90.2966713,
                    55.9156213
                ],
                [
                    90.2964158,
                    55.915038
                ],
                [
                    90.2956431,
                    55.9150952
                ],
                [
                    90.2925026,
                    55.9137221
                ],
                [
                    90.2902914,
                    55.9131136
                ],
                [
                    90.2895889,
                    55.9129884
                ],
                [
                    90.2892297,
                    55.913051
                ],
                [
                    90.2882238,
                    55.9134268
                ],
                [
                    90.2870663,
                    55.9133284
                ],
                [
                    90.2863958,
                    55.9133373
                ],
                [
                    90.2841686,
                    55.9126797
                ],
                [
                    90.2837615,
                    55.9123396
                ],
                [
                    90.2836737,
                    55.9120667
                ],
                [
                    90.2834182,
                    55.9119236
                ],
                [
                    90.2830031,
                    55.9119057
                ],
                [
                    90.2827317,
                    55.9117357
                ],
                [
                    90.2828514,
                    55.9113867
                ],
                [
                    90.2826119,
                    55.9112614
                ],
                [
                    90.2822607,
                    55.9110332
                ],
                [
                    90.2817418,
                    55.9106798
                ],
                [
                    90.2809675,
                    55.9105679
                ],
                [
                    90.2806242,
                    55.9105768
                ],
                [
                    90.280289,
                    55.9103889
                ],
                [
                    90.2796184,
                    55.9102681
                ],
                [
                    90.2787643,
                    55.910031
                ],
                [
                    90.2774631,
                    55.9098252
                ],
                [
                    90.2768165,
                    55.9097983
                ],
                [
                    90.2766967,
                    55.9099952
                ],
                [
                    90.2754674,
                    55.9102368
                ],
                [
                    90.2746292,
                    55.9106484
                ],
                [
                    90.2740784,
                    55.9107334
                ],
                [
                    90.2735675,
                    55.9110064
                ],
                [
                    90.2728011,
                    55.9116238
                ],
                [
                    90.2726016,
                    55.9119415
                ],
                [
                    90.2723541,
                    55.9123933
                ]
            ],
            "longitude": 90.287003,
            "latitude": 55.917126
        },
        "6390": {
            "name": "Красная Заря",
            "population": 73,
            "type": "hamlet",
            "poly": [
                [
                    90.2850937,
                    56.480405
                ],
                [
                    90.2851331,
                    56.4805683
                ],
                [
                    90.2853932,
                    56.4808142
                ],
                [
                    90.2856257,
                    56.481269
                ],
                [
                    90.2856021,
                    56.4814431
                ],
                [
                    90.2864021,
                    56.4819088
                ],
                [
                    90.2864494,
                    56.4820285
                ],
                [
                    90.2863706,
                    56.4820959
                ],
                [
                    90.28641,
                    56.4821612
                ],
                [
                    90.2866898,
                    56.4823223
                ],
                [
                    90.2865991,
                    56.4825159
                ],
                [
                    90.2868711,
                    56.4828445
                ],
                [
                    90.2870128,
                    56.483382
                ],
                [
                    90.2874188,
                    56.4836192
                ],
                [
                    90.2875922,
                    56.4838847
                ],
                [
                    90.287541,
                    56.4841328
                ],
                [
                    90.2877735,
                    56.4844679
                ],
                [
                    90.287943,
                    56.4847072
                ],
                [
                    90.2881518,
                    56.484816
                ],
                [
                    90.2882188,
                    56.4852273
                ],
                [
                    90.2885026,
                    56.4854079
                ],
                [
                    90.2893341,
                    56.4857822
                ],
                [
                    90.2896533,
                    56.486733
                ],
                [
                    90.2894957,
                    56.4867983
                ],
                [
                    90.2897637,
                    56.4869854
                ],
                [
                    90.2899646,
                    56.4869071
                ],
                [
                    90.2903745,
                    56.4868897
                ],
                [
                    90.2904612,
                    56.4870355
                ],
                [
                    90.2904257,
                    56.4872552
                ],
                [
                    90.290477,
                    56.4874249
                ],
                [
                    90.2910641,
                    56.4885542
                ],
                [
                    90.291872,
                    56.4886216
                ],
                [
                    90.2923646,
                    56.4884585
                ],
                [
                    90.2943193,
                    56.4884193
                ],
                [
                    90.2949144,
                    56.4887957
                ],
                [
                    90.2950129,
                    56.4889741
                ],
                [
                    90.2952533,
                    56.4898531
                ],
                [
                    90.2955055,
                    56.4901816
                ],
                [
                    90.295608,
                    56.4904297
                ],
                [
                    90.2962976,
                    56.4903774
                ],
                [
                    90.2970425,
                    56.4902665
                ],
                [
                    90.2974414,
                    56.4901643
                ],
                [
                    90.2978849,
                    56.4897878
                ],
                [
                    90.2978407,
                    56.488912
                ],
                [
                    90.2974663,
                    56.4885231
                ],
                [
                    90.2974269,
                    56.4884116
                ],
                [
                    90.2978949,
                    56.4880662
                ],
                [
                    90.2978998,
                    56.4879166
                ],
                [
                    90.2974762,
                    56.4876229
                ],
                [
                    90.297353,
                    56.4875658
                ],
                [
                    90.297752,
                    56.4875168
                ],
                [
                    90.2979441,
                    56.4873917
                ],
                [
                    90.2985008,
                    56.4868804
                ],
                [
                    90.2987323,
                    56.4866138
                ],
                [
                    90.2984613,
                    56.4862194
                ],
                [
                    90.2976978,
                    56.4852648
                ],
                [
                    90.297486,
                    56.4851505
                ],
                [
                    90.2971461,
                    56.4851369
                ],
                [
                    90.2950771,
                    56.4855231
                ],
                [
                    90.2947767,
                    56.4850988
                ],
                [
                    90.2949294,
                    56.4848568
                ],
                [
                    90.2950525,
                    56.4845195
                ],
                [
                    90.2953136,
                    56.4843073
                ],
                [
                    90.2955057,
                    56.4841387
                ],
                [
                    90.2948456,
                    56.4832764
                ],
                [
                    90.293821,
                    56.4835239
                ],
                [
                    90.2928703,
                    56.4837171
                ],
                [
                    90.2925215,
                    56.4832456
                ],
                [
                    90.2924291,
                    56.4829668
                ],
                [
                    90.29262,
                    56.4824364
                ],
                [
                    90.2925707,
                    56.4821643
                ],
                [
                    90.2922998,
                    56.4819297
                ],
                [
                    90.2923614,
                    56.4816033
                ],
                [
                    90.2925523,
                    56.4814027
                ],
                [
                    90.2929216,
                    56.4812361
                ],
                [
                    90.2929525,
                    56.4810729
                ],
                [
                    90.2928417,
                    56.4809777
                ],
                [
                    90.2921951,
                    56.4807158
                ],
                [
                    90.2917271,
                    56.4802874
                ],
                [
                    90.2911914,
                    56.4798181
                ],
                [
                    90.2911853,
                    56.4795665
                ],
                [
                    90.2909266,
                    56.4792196
                ],
                [
                    90.2902431,
                    56.4785259
                ],
                [
                    90.2900707,
                    56.4783729
                ],
                [
                    90.289147,
                    56.4782233
                ],
                [
                    90.2881927,
                    56.4778764
                ],
                [
                    90.2875831,
                    56.4777234
                ],
                [
                    90.2873109,
                    56.4777245
                ],
                [
                    90.2869836,
                    56.4778892
                ],
                [
                    90.2868106,
                    56.4781921
                ],
                [
                    90.2867528,
                    56.4784877
                ],
                [
                    90.2868395,
                    56.4785704
                ],
                [
                    90.2864809,
                    56.4786575
                ],
                [
                    90.2852671,
                    56.4792103
                ],
                [
                    90.2851883,
                    56.4794301
                ],
                [
                    90.2853105,
                    56.479713
                ],
                [
                    90.2850937,
                    56.480405
                ]
            ],
            "longitude": 90.2899059,
            "latitude": 56.4821279
        },
        "6391": {
            "name": "Сахарное",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    90.2857955,
                    56.8050526
                ],
                [
                    90.2862972,
                    56.8068995
                ],
                [
                    90.287871,
                    56.8075569
                ],
                [
                    90.2885052,
                    56.8081834
                ],
                [
                    90.2886894,
                    56.8087343
                ],
                [
                    90.2894264,
                    56.8092696
                ],
                [
                    90.2895433,
                    56.8095761
                ],
                [
                    90.2901598,
                    56.8097778
                ],
                [
                    90.2921475,
                    56.8100881
                ],
                [
                    90.2933521,
                    56.80958
                ],
                [
                    90.2937596,
                    56.8088933
                ],
                [
                    90.2939651,
                    56.8087071
                ],
                [
                    90.2952052,
                    56.807747
                ],
                [
                    90.2954814,
                    56.8074716
                ],
                [
                    90.2957473,
                    56.8073261
                ],
                [
                    90.2959988,
                    56.8070604
                ],
                [
                    90.2977066,
                    56.8060362
                ],
                [
                    90.2982061,
                    56.8058752
                ],
                [
                    90.2985178,
                    56.8057608
                ],
                [
                    90.2986774,
                    56.8056366
                ],
                [
                    90.2987518,
                    56.805495
                ],
                [
                    90.298727,
                    56.8053321
                ],
                [
                    90.2987341,
                    56.8051439
                ],
                [
                    90.2988014,
                    56.8049519
                ],
                [
                    90.2988793,
                    56.8048452
                ],
                [
                    90.2994391,
                    56.8041391
                ],
                [
                    90.2998289,
                    56.8037666
                ],
                [
                    90.2999954,
                    56.8034194
                ],
                [
                    90.3004878,
                    56.8031323
                ],
                [
                    90.3008422,
                    56.8026919
                ],
                [
                    90.3012107,
                    56.8022341
                ],
                [
                    90.3014905,
                    56.8017161
                ],
                [
                    90.3015083,
                    56.8015532
                ],
                [
                    90.3014091,
                    56.8014659
                ],
                [
                    90.3011256,
                    56.8012913
                ],
                [
                    90.3012603,
                    56.8010352
                ],
                [
                    90.3015508,
                    56.8002941
                ],
                [
                    90.2984612,
                    56.7998848
                ],
                [
                    90.2985002,
                    56.8004377
                ],
                [
                    90.2982521,
                    56.8013456
                ],
                [
                    90.2957047,
                    56.8008218
                ],
                [
                    90.2948083,
                    56.8012661
                ],
                [
                    90.2946206,
                    56.8014116
                ],
                [
                    90.2930333,
                    56.8018248
                ],
                [
                    90.2925372,
                    56.8025678
                ],
                [
                    90.2918392,
                    56.8032526
                ],
                [
                    90.2916231,
                    56.8036522
                ],
                [
                    90.2908719,
                    56.8038365
                ],
                [
                    90.2904645,
                    56.8039005
                ],
                [
                    90.2868052,
                    56.803384
                ],
                [
                    90.2857955,
                    56.8050526
                ]
            ],
            "longitude": 90.293709,
            "latitude": 56.804871
        },
        "6392": {
            "name": "Бугарикта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.313251,
            "latitude": 64.9200898
        },
        "6393": {
            "name": "Чердынь",
            "population": 262,
            "type": "hamlet",
            "poly": [
                [
                    90.3177174,
                    55.8691066
                ],
                [
                    90.3177427,
                    55.8695773
                ],
                [
                    90.317913,
                    55.8698003
                ],
                [
                    90.3181211,
                    55.8698038
                ],
                [
                    90.3183104,
                    55.8703807
                ],
                [
                    90.318159,
                    55.8709009
                ],
                [
                    90.3179887,
                    55.8711557
                ],
                [
                    90.3183671,
                    55.8714813
                ],
                [
                    90.3183104,
                    55.8717255
                ],
                [
                    90.3182536,
                    55.8720051
                ],
                [
                    90.3184807,
                    55.8725218
                ],
                [
                    90.3188907,
                    55.8729747
                ],
                [
                    90.319761,
                    55.8733781
                ],
                [
                    90.3204613,
                    55.873686
                ],
                [
                    90.3214074,
                    55.8739054
                ],
                [
                    90.3214642,
                    55.8740788
                ],
                [
                    90.321256,
                    55.8741956
                ],
                [
                    90.3204424,
                    55.8740434
                ],
                [
                    90.3198305,
                    55.8738134
                ],
                [
                    90.3194899,
                    55.8739196
                ],
                [
                    90.320436,
                    55.8742734
                ],
                [
                    90.320947,
                    55.874553
                ],
                [
                    90.3215273,
                    55.8752147
                ],
                [
                    90.3221454,
                    55.8756535
                ],
                [
                    90.322259,
                    55.8758552
                ],
                [
                    90.3208638,
                    55.8767654
                ],
                [
                    90.3196022,
                    55.8772475
                ],
                [
                    90.3206824,
                    55.8773315
                ],
                [
                    90.320572,
                    55.8786628
                ],
                [
                    90.3214709,
                    55.8786186
                ],
                [
                    90.3221174,
                    55.8788353
                ],
                [
                    90.3227324,
                    55.8788397
                ],
                [
                    90.323103,
                    55.8787026
                ],
                [
                    90.3235209,
                    55.878707
                ],
                [
                    90.3234893,
                    55.8776942
                ],
                [
                    90.3240176,
                    55.8775925
                ],
                [
                    90.3267378,
                    55.8776013
                ],
                [
                    90.3270926,
                    55.8775527
                ],
                [
                    90.3277234,
                    55.8773182
                ],
                [
                    90.3288587,
                    55.8770484
                ],
                [
                    90.3316184,
                    55.8769467
                ],
                [
                    90.3331637,
                    55.8771723
                ],
                [
                    90.3344805,
                    55.8776544
                ],
                [
                    90.3346224,
                    55.8782073
                ],
                [
                    90.3345514,
                    55.8786938
                ],
                [
                    90.335056,
                    55.8789326
                ],
                [
                    90.3355607,
                    55.878937
                ],
                [
                    90.3361441,
                    55.8788353
                ],
                [
                    90.3361126,
                    55.8779994
                ],
                [
                    90.3358681,
                    55.8777782
                ],
                [
                    90.3354739,
                    55.8769688
                ],
                [
                    90.3353556,
                    55.8758454
                ],
                [
                    90.3350166,
                    55.8730542
                ],
                [
                    90.3351247,
                    55.8729388
                ],
                [
                    90.3351822,
                    55.8728773
                ],
                [
                    90.3363649,
                    55.8732268
                ],
                [
                    90.3367118,
                    55.8729923
                ],
                [
                    90.337453,
                    55.871621
                ],
                [
                    90.3357026,
                    55.8712317
                ],
                [
                    90.3342597,
                    55.8712804
                ],
                [
                    90.3332347,
                    55.8710813
                ],
                [
                    90.3326118,
                    55.8712627
                ],
                [
                    90.3296945,
                    55.8697542
                ],
                [
                    90.3287168,
                    55.869502
                ],
                [
                    90.3292214,
                    55.8687765
                ],
                [
                    90.3286301,
                    55.8686615
                ],
                [
                    90.3270138,
                    55.8683872
                ],
                [
                    90.3263278,
                    55.8681571
                ],
                [
                    90.3260755,
                    55.8678828
                ],
                [
                    90.3262805,
                    55.8676174
                ],
                [
                    90.3262411,
                    55.8674537
                ],
                [
                    90.3257286,
                    55.8670113
                ],
                [
                    90.3249145,
                    55.8669601
                ],
                [
                    90.3244414,
                    55.8677688
                ],
                [
                    90.3238422,
                    55.8676662
                ],
                [
                    90.3239494,
                    55.8674609
                ],
                [
                    90.3236656,
                    55.8674538
                ],
                [
                    90.3236845,
                    55.8673653
                ],
                [
                    90.3230096,
                    55.8671247
                ],
                [
                    90.3226248,
                    55.8671317
                ],
                [
                    90.3223031,
                    55.8675104
                ],
                [
                    90.3216723,
                    55.8673795
                ],
                [
                    90.3213254,
                    55.8677334
                ],
                [
                    90.3210416,
                    55.867737
                ],
                [
                    90.3209154,
                    55.8678325
                ],
                [
                    90.3209533,
                    55.8679529
                ],
                [
                    90.3207577,
                    55.8680272
                ],
                [
                    90.3197296,
                    55.868098
                ],
                [
                    90.3185564,
                    55.8680873
                ],
                [
                    90.3177174,
                    55.8691066
                ]
            ],
            "longitude": 90.326851,
            "latitude": 55.870857
        },
        "6394": {
            "name": "Краевая",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    90.3206694,
                    56.5521939
                ],
                [
                    90.3210704,
                    56.5522461
                ],
                [
                    90.3209892,
                    56.5525217
                ],
                [
                    90.321548,
                    56.5525838
                ],
                [
                    90.3216696,
                    56.5523851
                ],
                [
                    90.323688,
                    56.5527477
                ],
                [
                    90.3231428,
                    56.5538303
                ],
                [
                    90.3245125,
                    56.5541109
                ],
                [
                    90.3252243,
                    56.5529761
                ],
                [
                    90.3297206,
                    56.5537111
                ],
                [
                    90.3291799,
                    56.5545976
                ],
                [
                    90.3311262,
                    56.554913
                ],
                [
                    90.3312794,
                    56.5547938
                ],
                [
                    90.3318967,
                    56.5548732
                ],
                [
                    90.3325319,
                    56.5552407
                ],
                [
                    90.3338565,
                    56.5554716
                ],
                [
                    90.3344287,
                    56.5547491
                ],
                [
                    90.3351811,
                    56.5548434
                ],
                [
                    90.3356046,
                    56.5549353
                ],
                [
                    90.3360911,
                    56.5550321
                ],
                [
                    90.3371319,
                    56.5551513
                ],
                [
                    90.3376275,
                    56.5551389
                ],
                [
                    90.3377986,
                    56.5560899
                ],
                [
                    90.3396385,
                    56.5560865
                ],
                [
                    90.3397375,
                    56.5552923
                ],
                [
                    90.3398254,
                    56.555159
                ],
                [
                    90.3397045,
                    56.5548195
                ],
                [
                    90.3398914,
                    56.5538799
                ],
                [
                    90.3384175,
                    56.5537465
                ],
                [
                    90.3367016,
                    56.5534737
                ],
                [
                    90.3360122,
                    56.5530351
                ],
                [
                    90.3352295,
                    56.5528923
                ],
                [
                    90.3352351,
                    56.553063
                ],
                [
                    90.3351507,
                    56.5531717
                ],
                [
                    90.3349423,
                    56.5532586
                ],
                [
                    90.3347227,
                    56.553271
                ],
                [
                    90.3345368,
                    56.5532369
                ],
                [
                    90.3344636,
                    56.5530879
                ],
                [
                    90.3344805,
                    56.5528333
                ],
                [
                    90.3338497,
                    56.5527868
                ],
                [
                    90.3323968,
                    56.5524888
                ],
                [
                    90.3236294,
                    56.5510169
                ],
                [
                    90.3224941,
                    56.5510591
                ],
                [
                    90.3221202,
                    56.5513099
                ],
                [
                    90.3217552,
                    56.5517171
                ],
                [
                    90.321985,
                    56.5517569
                ],
                [
                    90.3218228,
                    56.5519804
                ],
                [
                    90.3214218,
                    56.5519158
                ],
                [
                    90.3213362,
                    56.55204
                ],
                [
                    90.3207596,
                    56.5519481
                ],
                [
                    90.3206694,
                    56.5521939
                ]
            ],
            "longitude": 90.3311531,
            "latitude": 56.5531132
        },
        "6395": {
            "name": "Заворки",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    90.3130973,
                    56.1206355
                ],
                [
                    90.3135767,
                    56.1209664
                ],
                [
                    90.3150148,
                    56.1211255
                ],
                [
                    90.317857,
                    56.1211064
                ],
                [
                    90.318051,
                    56.1216472
                ],
                [
                    90.3189756,
                    56.1217872
                ],
                [
                    90.3211162,
                    56.1223959
                ],
                [
                    90.3233866,
                    56.1224793
                ],
                [
                    90.3260083,
                    56.1222606
                ],
                [
                    90.3274886,
                    56.1216641
                ],
                [
                    90.3286122,
                    56.1214156
                ],
                [
                    90.3316083,
                    56.1212963
                ],
                [
                    90.3326249,
                    56.1207296
                ],
                [
                    90.3319421,
                    56.1198372
                ],
                [
                    90.332842,
                    56.1196417
                ],
                [
                    90.3343616,
                    56.1208536
                ],
                [
                    90.334794,
                    56.1213879
                ],
                [
                    90.3352674,
                    56.1214823
                ],
                [
                    90.3366932,
                    56.1214269
                ],
                [
                    90.3374238,
                    56.1206386
                ],
                [
                    90.3377277,
                    56.1201239
                ],
                [
                    90.3376927,
                    56.1195081
                ],
                [
                    90.3391128,
                    56.1194169
                ],
                [
                    90.3420874,
                    56.1190455
                ],
                [
                    90.3479724,
                    56.1181659
                ],
                [
                    90.3493399,
                    56.1181366
                ],
                [
                    90.3500449,
                    56.1179758
                ],
                [
                    90.3496911,
                    56.1168686
                ],
                [
                    90.3459814,
                    56.1170277
                ],
                [
                    90.3459814,
                    56.1164168
                ],
                [
                    90.3429453,
                    56.1161877
                ],
                [
                    90.337672,
                    56.1154432
                ],
                [
                    90.3353777,
                    56.1151568
                ],
                [
                    90.3298076,
                    56.1150868
                ],
                [
                    90.3279699,
                    56.1159522
                ],
                [
                    90.3281868,
                    56.1161495
                ],
                [
                    90.3264518,
                    56.116684
                ],
                [
                    90.3248424,
                    56.1166268
                ],
                [
                    90.3138848,
                    56.1174986
                ],
                [
                    90.3131087,
                    56.1178931
                ],
                [
                    90.3130973,
                    56.1206355
                ]
            ],
            "longitude": 90.332703,
            "latitude": 56.118137
        },
        "6396": {
            "name": "Чулымка",
            "population": 11,
            "type": "hamlet",
            "poly": [
                [
                    90.3173328,
                    56.0709844
                ],
                [
                    90.3178123,
                    56.071709
                ],
                [
                    90.3204713,
                    56.0711652
                ],
                [
                    90.3298311,
                    56.0753782
                ],
                [
                    90.3328673,
                    56.0763911
                ],
                [
                    90.3328102,
                    56.0767478
                ],
                [
                    90.3329814,
                    56.0767797
                ],
                [
                    90.3334494,
                    56.0764357
                ],
                [
                    90.3347392,
                    56.0768688
                ],
                [
                    90.3340429,
                    56.0772893
                ],
                [
                    90.3342027,
                    56.0774485
                ],
                [
                    90.3350017,
                    56.0773339
                ],
                [
                    90.3355724,
                    56.0774358
                ],
                [
                    90.3365312,
                    56.077251
                ],
                [
                    90.3373416,
                    56.0775441
                ],
                [
                    90.3380835,
                    56.077181
                ],
                [
                    90.3394646,
                    56.0769962
                ],
                [
                    90.3413023,
                    56.0770791
                ],
                [
                    90.3417018,
                    56.076888
                ],
                [
                    90.3426719,
                    56.0768434
                ],
                [
                    90.3426949,
                    56.0764166
                ],
                [
                    90.341154,
                    56.0762892
                ],
                [
                    90.341211,
                    56.0761108
                ],
                [
                    90.3406517,
                    56.0760471
                ],
                [
                    90.3407202,
                    56.0757987
                ],
                [
                    90.3401058,
                    56.0757103
                ],
                [
                    90.3385453,
                    56.074802
                ],
                [
                    90.3377427,
                    56.0749762
                ],
                [
                    90.3341981,
                    56.0738813
                ],
                [
                    90.3325246,
                    56.0729796
                ],
                [
                    90.326918,
                    56.0700337
                ],
                [
                    90.3270366,
                    56.0695953
                ],
                [
                    90.326014,
                    56.0699419
                ],
                [
                    90.3247995,
                    56.0700235
                ],
                [
                    90.3235851,
                    56.069682
                ],
                [
                    90.3213844,
                    56.0684944
                ],
                [
                    90.3213202,
                    56.0682285
                ],
                [
                    90.3173689,
                    56.0682854
                ],
                [
                    90.3173328,
                    56.0709844
                ]
            ],
            "longitude": 90.337898,
            "latitude": 56.076283
        },
        "6397": {
            "name": "Белопольск",
            "population": 212,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.350815,
            "latitude": 55.144505
        },
        "6398": {
            "name": "Нижний Тунуй",
            "population": 57,
            "type": "hamlet",
            "poly": [
                [
                    90.3413001,
                    57.0996271
                ],
                [
                    90.3413615,
                    57.0996925
                ],
                [
                    90.3416357,
                    57.099737
                ],
                [
                    90.3422377,
                    57.0997565
                ],
                [
                    90.3427449,
                    57.0997398
                ],
                [
                    90.3429729,
                    57.0997273
                ],
                [
                    90.3432137,
                    57.0998233
                ],
                [
                    90.3437722,
                    57.0997913
                ],
                [
                    90.3442435,
                    57.0998915
                ],
                [
                    90.3447277,
                    57.0999263
                ],
                [
                    90.3451119,
                    57.100064
                ],
                [
                    90.3455603,
                    57.1001795
                ],
                [
                    90.345217,
                    57.1004411
                ],
                [
                    90.3453374,
                    57.1005691
                ],
                [
                    90.3455704,
                    57.1006331
                ],
                [
                    90.3460086,
                    57.1006192
                ],
                [
                    90.3464056,
                    57.1001795
                ],
                [
                    90.3467771,
                    57.1002477
                ],
                [
                    90.3469462,
                    57.1001086
                ],
                [
                    90.3472741,
                    57.0998247
                ],
                [
                    90.3479171,
                    57.0999249
                ],
                [
                    90.3482219,
                    57.0998024
                ],
                [
                    90.3483346,
                    57.0996897
                ],
                [
                    90.3484627,
                    57.0995144
                ],
                [
                    90.3485524,
                    57.0994754
                ],
                [
                    90.3487727,
                    57.099481
                ],
                [
                    90.3489802,
                    57.099513
                ],
                [
                    90.3489611,
                    57.1004074
                ],
                [
                    90.3492163,
                    57.1008232
                ],
                [
                    90.3495765,
                    57.1013342
                ],
                [
                    90.3497165,
                    57.1016929
                ],
                [
                    90.3497165,
                    57.1018777
                ],
                [
                    90.3498067,
                    57.1022364
                ],
                [
                    90.3497867,
                    57.1024103
                ],
                [
                    90.3495115,
                    57.1027364
                ],
                [
                    90.3491662,
                    57.1029104
                ],
                [
                    90.3489711,
                    57.1029919
                ],
                [
                    90.3489661,
                    57.1030979
                ],
                [
                    90.3491262,
                    57.1031712
                ],
                [
                    90.3495859,
                    57.103164
                ],
                [
                    90.3501454,
                    57.1030883
                ],
                [
                    90.350418,
                    57.1031328
                ],
                [
                    90.3505901,
                    57.1031317
                ],
                [
                    90.3507848,
                    57.1030761
                ],
                [
                    90.3510389,
                    57.1031317
                ],
                [
                    90.3511107,
                    57.1032519
                ],
                [
                    90.3510471,
                    57.1034501
                ],
                [
                    90.350961,
                    57.1035903
                ],
                [
                    90.3510061,
                    57.1038452
                ],
                [
                    90.3508278,
                    57.1040734
                ],
                [
                    90.3508298,
                    57.1041658
                ],
                [
                    90.3511107,
                    57.1042826
                ],
                [
                    90.3510205,
                    57.1044463
                ],
                [
                    90.3509098,
                    57.1045231
                ],
                [
                    90.3509303,
                    57.1045865
                ],
                [
                    90.3511373,
                    57.1046355
                ],
                [
                    90.3514078,
                    57.1045999
                ],
                [
                    90.3520657,
                    57.104414
                ],
                [
                    90.3521845,
                    57.1044173
                ],
                [
                    90.3525411,
                    57.1046856
                ],
                [
                    90.3528424,
                    57.1046844
                ],
                [
                    90.3530371,
                    57.1047245
                ],
                [
                    90.3530904,
                    57.104946
                ],
                [
                    90.3530289,
                    57.1051441
                ],
                [
                    90.3531068,
                    57.1053011
                ],
                [
                    90.3532092,
                    57.1052844
                ],
                [
                    90.353322,
                    57.1054513
                ],
                [
                    90.3533731,
                    57.1055348
                ],
                [
                    90.3536335,
                    57.105694
                ],
                [
                    90.3537851,
                    57.1057329
                ],
                [
                    90.3539942,
                    57.1058242
                ],
                [
                    90.3542721,
                    57.1058295
                ],
                [
                    90.3544176,
                    57.1058629
                ],
                [
                    90.354598,
                    57.1058173
                ],
                [
                    90.3549464,
                    57.1057995
                ],
                [
                    90.3551493,
                    57.1058106
                ],
                [
                    90.3555284,
                    57.1057015
                ],
                [
                    90.3560571,
                    57.1054689
                ],
                [
                    90.3563994,
                    57.1052986
                ],
                [
                    90.3567068,
                    57.104997
                ],
                [
                    90.356922,
                    57.1048211
                ],
                [
                    90.3572417,
                    57.1047622
                ],
                [
                    90.3574548,
                    57.1047299
                ],
                [
                    90.3580697,
                    57.104741
                ],
                [
                    90.3580695,
                    57.104683
                ],
                [
                    90.3581463,
                    57.1043417
                ],
                [
                    90.3584627,
                    57.1042321
                ],
                [
                    90.3602418,
                    57.1041837
                ],
                [
                    90.3606867,
                    57.1043524
                ],
                [
                    90.3621314,
                    57.1039786
                ],
                [
                    90.3621232,
                    57.1036429
                ],
                [
                    90.3601692,
                    57.1020675
                ],
                [
                    90.3587562,
                    57.1015305
                ],
                [
                    90.3579837,
                    57.101313
                ],
                [
                    90.3586971,
                    57.1003924
                ],
                [
                    90.360113,
                    57.0991287
                ],
                [
                    90.3561363,
                    57.0967024
                ],
                [
                    90.3553357,
                    57.0968103
                ],
                [
                    90.3548746,
                    57.0969947
                ],
                [
                    90.3544231,
                    57.0971008
                ],
                [
                    90.3537891,
                    57.0972817
                ],
                [
                    90.353408,
                    57.0971669
                ],
                [
                    90.3527708,
                    57.09752
                ],
                [
                    90.352204,
                    57.0981914
                ],
                [
                    90.3521015,
                    57.0980349
                ],
                [
                    90.3518614,
                    57.0979653
                ],
                [
                    90.3515988,
                    57.0979722
                ],
                [
                    90.3511761,
                    57.098047
                ],
                [
                    90.3507854,
                    57.0980105
                ],
                [
                    90.3505593,
                    57.0978618
                ],
                [
                    90.350174,
                    57.0977504
                ],
                [
                    90.3496537,
                    57.0974406
                ],
                [
                    90.3496636,
                    57.0973509
                ],
                [
                    90.3490883,
                    57.0970927
                ],
                [
                    90.3487631,
                    57.0970791
                ],
                [
                    90.3484579,
                    57.0969676
                ],
                [
                    90.3479525,
                    57.096772
                ],
                [
                    90.3473821,
                    57.0965844
                ],
                [
                    90.3470868,
                    57.0966197
                ],
                [
                    90.3468318,
                    57.0967312
                ],
                [
                    90.3464165,
                    57.0967393
                ],
                [
                    90.3461713,
                    57.0966306
                ],
                [
                    90.3456159,
                    57.096492
                ],
                [
                    90.3450455,
                    57.0964621
                ],
                [
                    90.3449469,
                    57.096507
                ],
                [
                    90.3449155,
                    57.0965844
                ],
                [
                    90.3447453,
                    57.0970981
                ],
                [
                    90.3446721,
                    57.097169
                ],
                [
                    90.3444595,
                    57.0974204
                ],
                [
                    90.3443407,
                    57.0976174
                ],
                [
                    90.3438904,
                    57.0977397
                ],
                [
                    90.3434213,
                    57.097665
                ],
                [
                    90.3431211,
                    57.097682
                ],
                [
                    90.3424456,
                    57.0976412
                ],
                [
                    90.3421829,
                    57.0975869
                ],
                [
                    90.3420203,
                    57.0976174
                ],
                [
                    90.3418679,
                    57.0977049
                ],
                [
                    90.3415988,
                    57.0977717
                ],
                [
                    90.3414221,
                    57.0979915
                ],
                [
                    90.3413914,
                    57.098107
                ],
                [
                    90.3420216,
                    57.0983283
                ],
                [
                    90.3413231,
                    57.0994768
                ],
                [
                    90.3413001,
                    57.0996271
                ]
            ],
            "longitude": 90.354248,
            "latitude": 57.101017
        },
        "6399": {
            "name": "Подкаменка",
            "population": 46,
            "type": "hamlet",
            "poly": [
                [
                    90.366655,
                    57.3154599
                ],
                [
                    90.3666949,
                    57.3157371
                ],
                [
                    90.3673223,
                    57.3156262
                ],
                [
                    90.3676303,
                    57.3156355
                ],
                [
                    90.3674874,
                    57.3159952
                ],
                [
                    90.3679294,
                    57.3160915
                ],
                [
                    90.368072,
                    57.3162301
                ],
                [
                    90.3681076,
                    57.3163764
                ],
                [
                    90.3680363,
                    57.3164842
                ],
                [
                    90.3684998,
                    57.3167036
                ],
                [
                    90.3682787,
                    57.3170039
                ],
                [
                    90.3686709,
                    57.3171849
                ],
                [
                    90.3684071,
                    57.3173774
                ],
                [
                    90.3687564,
                    57.3175005
                ],
                [
                    90.3691628,
                    57.3177277
                ],
                [
                    90.3696405,
                    57.3174659
                ],
                [
                    90.3719112,
                    57.3178208
                ],
                [
                    90.3733036,
                    57.3181817
                ],
                [
                    90.37532,
                    57.3196313
                ],
                [
                    90.3763337,
                    57.3193727
                ],
                [
                    90.3759661,
                    57.3183441
                ],
                [
                    90.3780826,
                    57.3187411
                ],
                [
                    90.3805693,
                    57.3187191
                ],
                [
                    90.3825299,
                    57.3184342
                ],
                [
                    90.3831343,
                    57.3181278
                ],
                [
                    90.3820794,
                    57.3171383
                ],
                [
                    90.3810354,
                    57.3166613
                ],
                [
                    90.380685,
                    57.3168486
                ],
                [
                    90.3797724,
                    57.3167047
                ],
                [
                    90.378732,
                    57.3166239
                ],
                [
                    90.3786007,
                    57.3164366
                ],
                [
                    90.3779765,
                    57.3164248
                ],
                [
                    90.3775567,
                    57.3165509
                ],
                [
                    90.3740123,
                    57.3160818
                ],
                [
                    90.372063,
                    57.3158453
                ],
                [
                    90.3711468,
                    57.3157093
                ],
                [
                    90.3706467,
                    57.3156679
                ],
                [
                    90.3703036,
                    57.3155752
                ],
                [
                    90.3701174,
                    57.3154648
                ],
                [
                    90.369475,
                    57.3152697
                ],
                [
                    90.3687595,
                    57.3148301
                ],
                [
                    90.3689457,
                    57.3146093
                ],
                [
                    90.3687083,
                    57.3145975
                ],
                [
                    90.3684345,
                    57.3146714
                ],
                [
                    90.3679724,
                    57.3149887
                ],
                [
                    90.3679383,
                    57.3151765
                ],
                [
                    90.3669003,
                    57.3152351
                ],
                [
                    90.366655,
                    57.3154599
                ]
            ],
            "longitude": 90.376442,
            "latitude": 57.31736
        },
        "6400": {
            "name": "Красногорский",
            "population": 269,
            "type": "hamlet",
            "poly": [
                [
                    90.3662771,
                    55.6257066
                ],
                [
                    90.3668651,
                    55.6262029
                ],
                [
                    90.3693791,
                    55.6260259
                ],
                [
                    90.3707566,
                    55.6263705
                ],
                [
                    90.3738306,
                    55.6269932
                ],
                [
                    90.3730254,
                    55.6277933
                ],
                [
                    90.3740753,
                    55.6276649
                ],
                [
                    90.3745565,
                    55.6274821
                ],
                [
                    90.3752739,
                    55.6274031
                ],
                [
                    90.3765512,
                    55.6271611
                ],
                [
                    90.3782048,
                    55.6272352
                ],
                [
                    90.3788784,
                    55.6273883
                ],
                [
                    90.3798233,
                    55.6273586
                ],
                [
                    90.3812844,
                    55.627008
                ],
                [
                    90.3827892,
                    55.6270672
                ],
                [
                    90.3837866,
                    55.6269487
                ],
                [
                    90.3845215,
                    55.6267215
                ],
                [
                    90.3852126,
                    55.6262572
                ],
                [
                    90.3854576,
                    55.6259064
                ],
                [
                    90.3862012,
                    55.6252001
                ],
                [
                    90.3873736,
                    55.6246913
                ],
                [
                    90.3904182,
                    55.6246123
                ],
                [
                    90.3903745,
                    55.6243109
                ],
                [
                    90.3912144,
                    55.6241973
                ],
                [
                    90.3915556,
                    55.6240392
                ],
                [
                    90.392378,
                    55.6235502
                ],
                [
                    90.3930866,
                    55.6227401
                ],
                [
                    90.3910103,
                    55.6225354
                ],
                [
                    90.3895151,
                    55.6224751
                ],
                [
                    90.3855849,
                    55.6188206
                ],
                [
                    90.3856063,
                    55.6182704
                ],
                [
                    90.3852301,
                    55.6181173
                ],
                [
                    90.3843639,
                    55.6181024
                ],
                [
                    90.3839615,
                    55.6181864
                ],
                [
                    90.3838303,
                    55.6184927
                ],
                [
                    90.3825092,
                    55.6184829
                ],
                [
                    90.3819842,
                    55.6185224
                ],
                [
                    90.3818093,
                    55.6186508
                ],
                [
                    90.3810744,
                    55.6185767
                ],
                [
                    90.3799807,
                    55.6187497
                ],
                [
                    90.3788346,
                    55.6190658
                ],
                [
                    90.3775923,
                    55.6194561
                ],
                [
                    90.3768486,
                    55.6202169
                ],
                [
                    90.376447,
                    55.6203527
                ],
                [
                    90.3744313,
                    55.6205385
                ],
                [
                    90.3737944,
                    55.6207203
                ],
                [
                    90.3730244,
                    55.6211037
                ],
                [
                    90.3703478,
                    55.6231711
                ],
                [
                    90.3697935,
                    55.6239077
                ],
                [
                    90.3696199,
                    55.6244104
                ],
                [
                    90.3686064,
                    55.6249542
                ],
                [
                    90.3662771,
                    55.6257066
                ]
            ],
            "longitude": 90.38031,
            "latitude": 55.622471
        },
        "6401": {
            "name": "Таачек",
            "population": 18,
            "type": "hamlet",
            "poly": [
                [
                    90.3845043,
                    56.841462
                ],
                [
                    90.3846262,
                    56.8417194
                ],
                [
                    90.388885,
                    56.8431592
                ],
                [
                    90.3910797,
                    56.8450739
                ],
                [
                    90.393039,
                    56.8456649
                ],
                [
                    90.3936626,
                    56.8458994
                ],
                [
                    90.3942437,
                    56.8463528
                ],
                [
                    90.3946617,
                    56.8468702
                ],
                [
                    90.3953101,
                    56.8475813
                ],
                [
                    90.4001703,
                    56.8474951
                ],
                [
                    90.3975872,
                    56.8423083
                ],
                [
                    90.3959353,
                    56.8397672
                ],
                [
                    90.3865989,
                    56.8406047
                ],
                [
                    90.3867889,
                    56.8412403
                ],
                [
                    90.3845043,
                    56.841462
                ]
            ],
            "longitude": 90.394409,
            "latitude": 56.844086
        },
        "6402": {
            "name": "Улуй",
            "population": 13,
            "type": "hamlet",
            "poly": [
                [
                    90.3974651,
                    56.1419113
                ],
                [
                    90.3985012,
                    56.1424448
                ],
                [
                    90.4110337,
                    56.1488979
                ],
                [
                    90.4118185,
                    56.1485959
                ],
                [
                    90.4125461,
                    56.1479442
                ],
                [
                    90.4131596,
                    56.1469269
                ],
                [
                    90.4125889,
                    56.1463308
                ],
                [
                    90.4036431,
                    56.1422452
                ],
                [
                    90.3984781,
                    56.14118
                ],
                [
                    90.3974651,
                    56.1419113
                ]
            ],
            "longitude": 90.406914,
            "latitude": 56.145401
        },
        "6403": {
            "name": "Усть-Березовка",
            "population": 215,
            "type": "hamlet",
            "poly": [
                [
                    90.3888772,
                    55.7940117
                ],
                [
                    90.3894069,
                    55.7941846
                ],
                [
                    90.3911156,
                    55.7941174
                ],
                [
                    90.39197,
                    55.7939156
                ],
                [
                    90.3940035,
                    55.7940885
                ],
                [
                    90.3954046,
                    55.7940309
                ],
                [
                    90.3973356,
                    55.7943191
                ],
                [
                    90.4004113,
                    55.7950011
                ],
                [
                    90.4016568,
                    55.7954502
                ],
                [
                    90.402004,
                    55.79551
                ],
                [
                    90.4018634,
                    55.7957889
                ],
                [
                    90.4021232,
                    55.7957582
                ],
                [
                    90.4025606,
                    55.795812
                ],
                [
                    90.4031074,
                    55.7960272
                ],
                [
                    90.4035175,
                    55.7963038
                ],
                [
                    90.4036816,
                    55.7965958
                ],
                [
                    90.4039823,
                    55.7966342
                ],
                [
                    90.4048982,
                    55.7964114
                ],
                [
                    90.4051989,
                    55.7960502
                ],
                [
                    90.40606,
                    55.7958855
                ],
                [
                    90.4071448,
                    55.7958619
                ],
                [
                    90.4087546,
                    55.7957674
                ],
                [
                    90.4093915,
                    55.7956219
                ],
                [
                    90.4102524,
                    55.7956258
                ],
                [
                    90.4109593,
                    55.7957281
                ],
                [
                    90.4115543,
                    55.7959445
                ],
                [
                    90.4117362,
                    55.7961491
                ],
                [
                    90.4137383,
                    55.7964127
                ],
                [
                    90.4145726,
                    55.7965386
                ],
                [
                    90.4153789,
                    55.796759
                ],
                [
                    90.4161516,
                    55.796759
                ],
                [
                    90.416342,
                    55.7964851
                ],
                [
                    90.4162748,
                    55.7960539
                ],
                [
                    90.4177418,
                    55.7963026
                ],
                [
                    90.4185761,
                    55.7962239
                ],
                [
                    90.4191808,
                    55.795544
                ],
                [
                    90.4183568,
                    55.7953465
                ],
                [
                    90.4180014,
                    55.7951467
                ],
                [
                    90.4176733,
                    55.7947471
                ],
                [
                    90.416689,
                    55.7945242
                ],
                [
                    90.4148846,
                    55.7938045
                ],
                [
                    90.4152608,
                    55.7929536
                ],
                [
                    90.413721,
                    55.7925306
                ],
                [
                    90.4118137,
                    55.7921765
                ],
                [
                    90.41142,
                    55.791965
                ],
                [
                    90.4112275,
                    55.7922257
                ],
                [
                    90.4110263,
                    55.7921814
                ],
                [
                    90.4109476,
                    55.7919797
                ],
                [
                    90.4103002,
                    55.7919551
                ],
                [
                    90.4099852,
                    55.7920437
                ],
                [
                    90.409854,
                    55.7919355
                ],
                [
                    90.4095565,
                    55.7919158
                ],
                [
                    90.4096615,
                    55.7917141
                ],
                [
                    90.4082704,
                    55.7912469
                ],
                [
                    90.4077367,
                    55.7907205
                ],
                [
                    90.4076842,
                    55.7901942
                ],
                [
                    90.4074398,
                    55.7900013
                ],
                [
                    90.4045691,
                    55.7887332
                ],
                [
                    90.402023,
                    55.7880606
                ],
                [
                    90.3995966,
                    55.7874169
                ],
                [
                    90.3995071,
                    55.7874418
                ],
                [
                    90.3998746,
                    55.7878551
                ],
                [
                    90.3998658,
                    55.7881994
                ],
                [
                    90.3994546,
                    55.7887307
                ],
                [
                    90.3993846,
                    55.7892226
                ],
                [
                    90.3988859,
                    55.7905261
                ],
                [
                    90.3989209,
                    55.7911999
                ],
                [
                    90.3979411,
                    55.7911704
                ],
                [
                    90.3974249,
                    55.7912688
                ],
                [
                    90.3971886,
                    55.7915246
                ],
                [
                    90.3967337,
                    55.7919328
                ],
                [
                    90.39606,
                    55.791923
                ],
                [
                    90.3948702,
                    55.7917311
                ],
                [
                    90.3937941,
                    55.7916377
                ],
                [
                    90.392228,
                    55.7918738
                ],
                [
                    90.3914756,
                    55.7921197
                ],
                [
                    90.3906095,
                    55.7918098
                ],
                [
                    90.3888772,
                    55.7940117
                ]
            ],
            "longitude": 90.408696,
            "latitude": 55.7929457
        },
        "6404": {
            "name": "Промбор",
            "population": 141,
            "type": "hamlet",
            "poly": [
                [
                    90.399612,
                    57.3278916
                ],
                [
                    90.400455,
                    57.3284633
                ],
                [
                    90.4004208,
                    57.3294671
                ],
                [
                    90.40086,
                    57.3299381
                ],
                [
                    90.4026623,
                    57.331105
                ],
                [
                    90.4024342,
                    57.3313389
                ],
                [
                    90.4022973,
                    57.3319885
                ],
                [
                    90.4026794,
                    57.3329029
                ],
                [
                    90.4034722,
                    57.3338695
                ],
                [
                    90.4040141,
                    57.3343221
                ],
                [
                    90.4045388,
                    57.3342205
                ],
                [
                    90.405189,
                    57.33487
                ],
                [
                    90.4057137,
                    57.3353041
                ],
                [
                    90.4070541,
                    57.3359136
                ],
                [
                    90.4080817,
                    57.3353792
                ],
                [
                    90.4081948,
                    57.3353379
                ],
                [
                    90.4069628,
                    57.3345806
                ],
                [
                    90.4066148,
                    57.3342851
                ],
                [
                    90.4077784,
                    57.3340789
                ],
                [
                    90.4081492,
                    57.3338757
                ],
                [
                    90.408269,
                    57.3332815
                ],
                [
                    90.4080693,
                    57.332321
                ],
                [
                    90.4076187,
                    57.3312928
                ],
                [
                    90.4069001,
                    57.33052
                ],
                [
                    90.4083089,
                    57.3299196
                ],
                [
                    90.410385,
                    57.3295194
                ],
                [
                    90.4136988,
                    57.3284233
                ],
                [
                    90.4132863,
                    57.3273196
                ],
                [
                    90.4128184,
                    57.3269768
                ],
                [
                    90.4129076,
                    57.3262611
                ],
                [
                    90.4131526,
                    57.3259905
                ],
                [
                    90.4121835,
                    57.325768
                ],
                [
                    90.4117267,
                    57.3256778
                ],
                [
                    90.4113926,
                    57.3254733
                ],
                [
                    90.4088527,
                    57.3252809
                ],
                [
                    90.4082845,
                    57.3254011
                ],
                [
                    90.4070257,
                    57.3253831
                ],
                [
                    90.4058672,
                    57.3254673
                ],
                [
                    90.4055664,
                    57.3254252
                ],
                [
                    90.4043188,
                    57.3261769
                ],
                [
                    90.4027703,
                    57.3268385
                ],
                [
                    90.4009768,
                    57.32753
                ],
                [
                    90.399612,
                    57.3278916
                ]
            ],
            "longitude": 90.408745,
            "latitude": 57.327839
        },
        "6405": {
            "name": "Нагорново",
            "population": 256,
            "type": "hamlet",
            "poly": [
                [
                    90.3972943,
                    56.4056708
                ],
                [
                    90.3979308,
                    56.4058932
                ],
                [
                    90.3977131,
                    56.406162
                ],
                [
                    90.3987348,
                    56.4078581
                ],
                [
                    90.4026715,
                    56.4094986
                ],
                [
                    90.4038776,
                    56.4110185
                ],
                [
                    90.4061056,
                    56.4131778
                ],
                [
                    90.4059046,
                    56.4134465
                ],
                [
                    90.4064573,
                    56.4137338
                ],
                [
                    90.4073452,
                    56.4127515
                ],
                [
                    90.4095564,
                    56.411695
                ],
                [
                    90.4139956,
                    56.410518
                ],
                [
                    90.4246832,
                    56.4065327
                ],
                [
                    90.4270619,
                    56.4044843
                ],
                [
                    90.4260903,
                    56.4038448
                ],
                [
                    90.4247502,
                    56.4039374
                ],
                [
                    90.4212156,
                    56.4038726
                ],
                [
                    90.4194902,
                    56.4033164
                ],
                [
                    90.4175805,
                    56.4031774
                ],
                [
                    90.4184348,
                    56.401342
                ],
                [
                    90.417882,
                    56.4013698
                ],
                [
                    90.4173292,
                    56.4008136
                ],
                [
                    90.4172957,
                    56.4003223
                ],
                [
                    90.4163744,
                    56.3996363
                ],
                [
                    90.415051,
                    56.4000442
                ],
                [
                    90.4159388,
                    56.4009804
                ],
                [
                    90.415118,
                    56.4016942
                ],
                [
                    90.4156708,
                    56.4021114
                ],
                [
                    90.4176307,
                    56.4021855
                ],
                [
                    90.4171281,
                    56.4031217
                ],
                [
                    90.4156373,
                    56.4043082
                ],
                [
                    90.4117216,
                    56.4045446
                ],
                [
                    90.4111561,
                    56.4056221
                ],
                [
                    90.4105071,
                    56.4061898
                ],
                [
                    90.4073243,
                    56.4079392
                ],
                [
                    90.4062564,
                    56.4080551
                ],
                [
                    90.4047278,
                    56.407163
                ],
                [
                    90.4024873,
                    56.4058191
                ],
                [
                    90.4007702,
                    56.4053093
                ],
                [
                    90.3986858,
                    56.4053726
                ],
                [
                    90.3973361,
                    56.4054135
                ],
                [
                    90.3972943,
                    56.4056708
                ]
            ],
            "longitude": 90.416924,
            "latitude": 56.40591
        },
        "6406": {
            "name": "Красновка",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    90.4209961,
                    56.4242547
                ],
                [
                    90.4215171,
                    56.4253973
                ],
                [
                    90.4210511,
                    56.425614
                ],
                [
                    90.4213477,
                    56.4260708
                ],
                [
                    90.4216336,
                    56.4262904
                ],
                [
                    90.4225443,
                    56.4274734
                ],
                [
                    90.4228987,
                    56.4281759
                ],
                [
                    90.4228299,
                    56.4290778
                ],
                [
                    90.4230628,
                    56.4291393
                ],
                [
                    90.4233964,
                    56.4294525
                ],
                [
                    90.4235606,
                    56.4297893
                ],
                [
                    90.4243866,
                    56.4302372
                ],
                [
                    90.4244501,
                    56.4303953
                ],
                [
                    90.4243178,
                    56.4304392
                ],
                [
                    90.4247837,
                    56.4305183
                ],
                [
                    90.4252285,
                    56.4305447
                ],
                [
                    90.4258109,
                    56.4307847
                ],
                [
                    90.426171,
                    56.4307086
                ],
                [
                    90.4259327,
                    56.4305183
                ],
                [
                    90.4260651,
                    56.4303778
                ],
                [
                    90.4264622,
                    56.4302724
                ],
                [
                    90.4264199,
                    56.430164
                ],
                [
                    90.4279448,
                    56.4297746
                ],
                [
                    90.4292951,
                    56.4292212
                ],
                [
                    90.4293427,
                    56.4291334
                ],
                [
                    90.43091,
                    56.4288699
                ],
                [
                    90.4322602,
                    56.4288172
                ],
                [
                    90.4325832,
                    56.4292154
                ],
                [
                    90.4333881,
                    56.4291832
                ],
                [
                    90.4336952,
                    56.4287762
                ],
                [
                    90.4354161,
                    56.429069
                ],
                [
                    90.435845,
                    56.4290426
                ],
                [
                    90.4384819,
                    56.4296956
                ],
                [
                    90.4388251,
                    56.4293564
                ],
                [
                    90.4389531,
                    56.42923
                ],
                [
                    90.4412882,
                    56.4299766
                ],
                [
                    90.4411121,
                    56.4296402
                ],
                [
                    90.4410274,
                    56.429331
                ],
                [
                    90.4410511,
                    56.4292298
                ],
                [
                    90.4417797,
                    56.4289524
                ],
                [
                    90.4418509,
                    56.4288831
                ],
                [
                    90.4417933,
                    56.4285852
                ],
                [
                    90.4414713,
                    56.4282235
                ],
                [
                    90.4411426,
                    56.4281167
                ],
                [
                    90.4408105,
                    56.4281242
                ],
                [
                    90.4402853,
                    56.4281785
                ],
                [
                    90.4395567,
                    56.428068
                ],
                [
                    90.4393364,
                    56.427963
                ],
                [
                    90.4393432,
                    56.4277269
                ],
                [
                    90.4397871,
                    56.4272172
                ],
                [
                    90.4397159,
                    56.4269904
                ],
                [
                    90.4395058,
                    56.4268424
                ],
                [
                    90.4390619,
                    56.4267374
                ],
                [
                    90.438235,
                    56.4267562
                ],
                [
                    90.4364593,
                    56.4272322
                ],
                [
                    90.4360255,
                    56.4275151
                ],
                [
                    90.4354732,
                    56.4274364
                ],
                [
                    90.4359679,
                    56.4271216
                ],
                [
                    90.4365818,
                    56.426659
                ],
                [
                    90.435716,
                    56.4263689
                ],
                [
                    90.4336761,
                    56.4273443
                ],
                [
                    90.4319369,
                    56.4268728
                ],
                [
                    90.4315969,
                    56.4264871
                ],
                [
                    90.4314286,
                    56.4264362
                ],
                [
                    90.4315778,
                    56.4260409
                ],
                [
                    90.4304101,
                    56.4253606
                ],
                [
                    90.430247,
                    56.4251946
                ],
                [
                    90.4299781,
                    56.4250507
                ],
                [
                    90.4296206,
                    56.4247331
                ],
                [
                    90.429409,
                    56.4245229
                ],
                [
                    90.4291608,
                    56.4244059
                ],
                [
                    90.4285553,
                    56.424284
                ],
                [
                    90.4280555,
                    56.4242072
                ],
                [
                    90.4278474,
                    56.4242792
                ],
                [
                    90.4277468,
                    56.4244212
                ],
                [
                    90.4276323,
                    56.4245066
                ],
                [
                    90.42728,
                    56.4245594
                ],
                [
                    90.4270717,
                    56.4246333
                ],
                [
                    90.4266276,
                    56.424805
                ],
                [
                    90.4264056,
                    56.4249173
                ],
                [
                    90.4264021,
                    56.4250037
                ],
                [
                    90.4264142,
                    56.4250545
                ],
                [
                    90.4263622,
                    56.4251639
                ],
                [
                    90.4263136,
                    56.4252838
                ],
                [
                    90.4262095,
                    56.4253337
                ],
                [
                    90.4259649,
                    56.4253481
                ],
                [
                    90.4257549,
                    56.4252215
                ],
                [
                    90.4255103,
                    56.4250948
                ],
                [
                    90.4253958,
                    56.4249643
                ],
                [
                    90.4252327,
                    56.4248415
                ],
                [
                    90.4250956,
                    56.4247081
                ],
                [
                    90.4249741,
                    56.4245201
                ],
                [
                    90.4248024,
                    56.424426
                ],
                [
                    90.4248214,
                    56.4240691
                ],
                [
                    90.4250677,
                    56.4240614
                ],
                [
                    90.4250991,
                    56.4238484
                ],
                [
                    90.4254842,
                    56.4238551
                ],
                [
                    90.4255074,
                    56.4236597
                ],
                [
                    90.4248974,
                    56.4236433
                ],
                [
                    90.4248974,
                    56.4235191
                ],
                [
                    90.4229362,
                    56.423491
                ],
                [
                    90.4225592,
                    56.4235753
                ],
                [
                    90.4222457,
                    56.423662
                ],
                [
                    90.4220042,
                    56.4238283
                ],
                [
                    90.4213858,
                    56.4238892
                ],
                [
                    90.4211739,
                    56.4239829
                ],
                [
                    90.4209961,
                    56.4242547
                ]
            ],
            "longitude": 90.4282329,
            "latitude": 56.427353
        },
        "6407": {
            "name": "Каменка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    90.4195602,
                    56.1656403
                ],
                [
                    90.4199704,
                    56.1661268
                ],
                [
                    90.4202557,
                    56.166107
                ],
                [
                    90.421736,
                    56.1664545
                ],
                [
                    90.4218786,
                    56.1663552
                ],
                [
                    90.4228417,
                    56.1672986
                ],
                [
                    90.4237335,
                    56.1671397
                ],
                [
                    90.4240723,
                    56.1676461
                ],
                [
                    90.4252494,
                    56.1678844
                ],
                [
                    90.4268723,
                    56.1680532
                ],
                [
                    90.4291374,
                    56.1680532
                ],
                [
                    90.4291909,
                    56.1684008
                ],
                [
                    90.4296814,
                    56.1684117
                ],
                [
                    90.4297106,
                    56.1685825
                ],
                [
                    90.4302,
                    56.1686923
                ],
                [
                    90.4303681,
                    56.1691722
                ],
                [
                    90.4308648,
                    56.1694488
                ],
                [
                    90.4317268,
                    56.1694284
                ],
                [
                    90.4320044,
                    56.1690095
                ],
                [
                    90.4323112,
                    56.1690014
                ],
                [
                    90.4325669,
                    56.1682978
                ],
                [
                    90.4341521,
                    56.1683425
                ],
                [
                    90.4354086,
                    56.1676104
                ],
                [
                    90.4380384,
                    56.1674884
                ],
                [
                    90.4390096,
                    56.1673815
                ],
                [
                    90.4401876,
                    56.1674609
                ],
                [
                    90.4403949,
                    56.1665863
                ],
                [
                    90.4404637,
                    56.1663211
                ],
                [
                    90.440303,
                    56.1661462
                ],
                [
                    90.4402956,
                    56.1654385
                ],
                [
                    90.4398281,
                    56.1653815
                ],
                [
                    90.4354144,
                    56.1656634
                ],
                [
                    90.4355999,
                    56.1653615
                ],
                [
                    90.4353287,
                    56.1649246
                ],
                [
                    90.433688,
                    56.1650755
                ],
                [
                    90.4327178,
                    56.164861
                ],
                [
                    90.4324752,
                    56.1641937
                ],
                [
                    90.4320187,
                    56.1637091
                ],
                [
                    90.4298785,
                    56.1634946
                ],
                [
                    90.4285088,
                    56.1633039
                ],
                [
                    90.4269965,
                    56.163439
                ],
                [
                    90.4270393,
                    56.1637806
                ],
                [
                    90.4261404,
                    56.1639792
                ],
                [
                    90.4251702,
                    56.1639554
                ],
                [
                    90.4250989,
                    56.1636694
                ],
                [
                    90.4244425,
                    56.1635899
                ],
                [
                    90.4240145,
                    56.1643526
                ],
                [
                    90.4235865,
                    56.1642811
                ],
                [
                    90.4227161,
                    56.1638282
                ],
                [
                    90.4230728,
                    56.163439
                ],
                [
                    90.4213615,
                    56.1634258
                ],
                [
                    90.4210048,
                    56.1639422
                ],
                [
                    90.4205506,
                    56.1642747
                ],
                [
                    90.4197028,
                    56.1648955
                ],
                [
                    90.4199704,
                    56.165114
                ],
                [
                    90.4195602,
                    56.1656403
                ]
            ],
            "longitude": 90.431244,
            "latitude": 56.166142
        },
        "6408": {
            "name": "Нагорново",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.435936,
            "latitude": 56.28368
        },
        "6409": {
            "name": "Карабановка",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    90.4176717,
                    56.7459158
                ],
                [
                    90.4193046,
                    56.7468314
                ],
                [
                    90.419784,
                    56.7468516
                ],
                [
                    90.4209374,
                    56.7472531
                ],
                [
                    90.4222438,
                    56.7474091
                ],
                [
                    90.4237608,
                    56.7476401
                ],
                [
                    90.4241663,
                    56.7476574
                ],
                [
                    90.4240241,
                    56.7477556
                ],
                [
                    90.4248564,
                    56.7477961
                ],
                [
                    90.4252619,
                    56.7477556
                ],
                [
                    90.4261679,
                    56.7480791
                ],
                [
                    90.4261205,
                    56.7482033
                ],
                [
                    90.4273003,
                    56.7483015
                ],
                [
                    90.4282169,
                    56.7488012
                ],
                [
                    90.4287067,
                    56.7487261
                ],
                [
                    90.4302659,
                    56.7491766
                ],
                [
                    90.4302343,
                    56.7494539
                ],
                [
                    90.4308242,
                    56.7493643
                ],
                [
                    90.4311455,
                    56.7495318
                ],
                [
                    90.4334473,
                    56.7503809
                ],
                [
                    90.4346167,
                    56.7507506
                ],
                [
                    90.4357913,
                    56.7513686
                ],
                [
                    90.4369448,
                    56.752157
                ],
                [
                    90.4388726,
                    56.7525931
                ],
                [
                    90.4391571,
                    56.7525035
                ],
                [
                    90.4400736,
                    56.7527923
                ],
                [
                    90.4406846,
                    56.7530753
                ],
                [
                    90.4411428,
                    56.7529714
                ],
                [
                    90.4436869,
                    56.7532024
                ],
                [
                    90.4443611,
                    56.753162
                ],
                [
                    90.4455305,
                    56.7532486
                ],
                [
                    90.4483504,
                    56.7531725
                ],
                [
                    90.4487508,
                    56.7532695
                ],
                [
                    90.4496104,
                    56.7532672
                ],
                [
                    90.4499264,
                    56.7531818
                ],
                [
                    90.4512706,
                    56.7531563
                ],
                [
                    90.451338,
                    56.7530478
                ],
                [
                    90.4517594,
                    56.7520174
                ],
                [
                    90.4517215,
                    56.7518141
                ],
                [
                    90.4516371,
                    56.7516708
                ],
                [
                    90.4509082,
                    56.7515646
                ],
                [
                    90.4504152,
                    56.7513659
                ],
                [
                    90.4496062,
                    56.7513243
                ],
                [
                    90.4492733,
                    56.7512365
                ],
                [
                    90.4489319,
                    56.7510263
                ],
                [
                    90.4486033,
                    56.7507513
                ],
                [
                    90.4483842,
                    56.7503586
                ],
                [
                    90.4480892,
                    56.7500189
                ],
                [
                    90.4474487,
                    56.7498664
                ],
                [
                    90.4471031,
                    56.7498503
                ],
                [
                    90.4471284,
                    56.7495499
                ],
                [
                    90.447221,
                    56.7492935
                ],
                [
                    90.4461508,
                    56.7491179
                ],
                [
                    90.445957,
                    56.7493027
                ],
                [
                    90.445881,
                    56.7495776
                ],
                [
                    90.4450763,
                    56.7494691
                ],
                [
                    90.4448611,
                    56.749406
                ],
                [
                    90.4444569,
                    56.7494298
                ],
                [
                    90.4437995,
                    56.7495037
                ],
                [
                    90.4424553,
                    56.7495245
                ],
                [
                    90.4416083,
                    56.7495106
                ],
                [
                    90.4411364,
                    56.7494367
                ],
                [
                    90.4408414,
                    56.7493281
                ],
                [
                    90.4408581,
                    56.7490231
                ],
                [
                    90.4406602,
                    56.7488961
                ],
                [
                    90.4400576,
                    56.7487459
                ],
                [
                    90.4395098,
                    56.7485495
                ],
                [
                    90.4392865,
                    56.7482075
                ],
                [
                    90.4391769,
                    56.7479072
                ],
                [
                    90.4392022,
                    56.7476946
                ],
                [
                    90.4397837,
                    56.747281
                ],
                [
                    90.440264,
                    56.7466386
                ],
                [
                    90.4406391,
                    56.7463336
                ],
                [
                    90.4406096,
                    56.7461996
                ],
                [
                    90.4405254,
                    56.7461049
                ],
                [
                    90.4398427,
                    56.7458992
                ],
                [
                    90.4397879,
                    56.7457721
                ],
                [
                    90.4398848,
                    56.7455711
                ],
                [
                    90.4398891,
                    56.7453932
                ],
                [
                    90.4400028,
                    56.7453331
                ],
                [
                    90.4403062,
                    56.7454186
                ],
                [
                    90.4407866,
                    56.7456659
                ],
                [
                    90.4409678,
                    56.7456012
                ],
                [
                    90.441031,
                    56.745451
                ],
                [
                    90.4411827,
                    56.7453262
                ],
                [
                    90.4411743,
                    56.7451991
                ],
                [
                    90.4406264,
                    56.7449472
                ],
                [
                    90.4398891,
                    56.7451067
                ],
                [
                    90.4388356,
                    56.7454995
                ],
                [
                    90.4384564,
                    56.7456543
                ],
                [
                    90.4377611,
                    56.7464838
                ],
                [
                    90.4364843,
                    56.7476807
                ],
                [
                    90.4361219,
                    56.7479788
                ],
                [
                    90.4358564,
                    56.7476946
                ],
                [
                    90.4353803,
                    56.7475352
                ],
                [
                    90.4344364,
                    56.7472071
                ],
                [
                    90.4321103,
                    56.7462944
                ],
                [
                    90.4311159,
                    56.7457306
                ],
                [
                    90.4300666,
                    56.7453331
                ],
                [
                    90.4295315,
                    56.7452083
                ],
                [
                    90.4290342,
                    56.745213
                ],
                [
                    90.428697,
                    56.7452546
                ],
                [
                    90.4275889,
                    56.7449311
                ],
                [
                    90.4249679,
                    56.7446168
                ],
                [
                    90.4228947,
                    56.7440137
                ],
                [
                    90.4228811,
                    56.743891
                ],
                [
                    90.4205951,
                    56.7434173
                ],
                [
                    90.4198156,
                    56.7433653
                ],
                [
                    90.4190938,
                    56.7443561
                ],
                [
                    90.4192098,
                    56.7445467
                ],
                [
                    90.4176717,
                    56.7459158
                ]
            ],
            "longitude": 90.4396083,
            "latitude": 56.750154
        },
        "6410": {
            "name": "Курбатово",
            "population": 87,
            "type": "hamlet",
            "poly": [
                [
                    90.4276866,
                    56.3511218
                ],
                [
                    90.4280673,
                    56.3512976
                ],
                [
                    90.4287723,
                    56.3514866
                ],
                [
                    90.4336426,
                    56.352731
                ],
                [
                    90.4399841,
                    56.3538916
                ],
                [
                    90.4423488,
                    56.3543988
                ],
                [
                    90.4439678,
                    56.3551294
                ],
                [
                    90.445738,
                    56.3549005
                ],
                [
                    90.445945,
                    56.3542268
                ],
                [
                    90.4455052,
                    56.3536678
                ],
                [
                    90.4454793,
                    56.3534241
                ],
                [
                    90.4480407,
                    56.3545278
                ],
                [
                    90.4472645,
                    56.3556603
                ],
                [
                    90.4449705,
                    56.3574495
                ],
                [
                    90.4459709,
                    56.3583837
                ],
                [
                    90.4456316,
                    56.3586728
                ],
                [
                    90.4472083,
                    56.3595887
                ],
                [
                    90.4489304,
                    56.3586252
                ],
                [
                    90.4503263,
                    56.3582049
                ],
                [
                    90.452042,
                    56.3581786
                ],
                [
                    90.4520173,
                    56.3572432
                ],
                [
                    90.4515175,
                    56.3543451
                ],
                [
                    90.4514352,
                    56.3534679
                ],
                [
                    90.4512139,
                    56.353186
                ],
                [
                    90.4517107,
                    56.3527986
                ],
                [
                    90.4516577,
                    56.3520176
                ],
                [
                    90.4518714,
                    56.351497
                ],
                [
                    90.4512345,
                    56.3509191
                ],
                [
                    90.4502589,
                    56.3506201
                ],
                [
                    90.4495065,
                    56.3501033
                ],
                [
                    90.4484096,
                    56.3498808
                ],
                [
                    90.4466381,
                    56.3503869
                ],
                [
                    90.4459298,
                    56.3508169
                ],
                [
                    90.4447377,
                    56.3510018
                ],
                [
                    90.4439678,
                    56.3512687
                ],
                [
                    90.4439575,
                    56.3507842
                ],
                [
                    90.4404969,
                    56.3507962
                ],
                [
                    90.4386626,
                    56.3503437
                ],
                [
                    90.4371244,
                    56.349736
                ],
                [
                    90.4360084,
                    56.3494434
                ],
                [
                    90.4326461,
                    56.3497804
                ],
                [
                    90.4290007,
                    56.3505438
                ],
                [
                    90.4277184,
                    56.3508785
                ],
                [
                    90.4276866,
                    56.3511218
                ]
            ],
            "longitude": 90.442276,
            "latitude": 56.352295
        },
        "6411": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.443532,
            "latitude": 57.2425867
        },
        "6412": {
            "name": "Парилово",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.445198,
            "latitude": 55.157791
        },
        "6413": {
            "name": "Сосновое Озеро",
            "population": 162,
            "type": "hamlet",
            "poly": [
                [
                    90.4396952,
                    56.3080603
                ],
                [
                    90.4398633,
                    56.3123648
                ],
                [
                    90.4415932,
                    56.3158694
                ],
                [
                    90.4429626,
                    56.3156295
                ],
                [
                    90.443347,
                    56.3144036
                ],
                [
                    90.445221,
                    56.3138839
                ],
                [
                    90.4443801,
                    56.3120983
                ],
                [
                    90.4434191,
                    56.310779
                ],
                [
                    90.4476235,
                    56.3103392
                ],
                [
                    90.4486325,
                    56.3098994
                ],
                [
                    90.4513714,
                    56.3096595
                ],
                [
                    90.4525967,
                    56.3097395
                ],
                [
                    90.4533174,
                    56.310166
                ],
                [
                    90.4527168,
                    56.311312
                ],
                [
                    90.4541583,
                    56.3113254
                ],
                [
                    90.4578582,
                    56.3090998
                ],
                [
                    90.4580984,
                    56.3085534
                ],
                [
                    90.4590354,
                    56.3080869
                ],
                [
                    90.4587952,
                    56.3060211
                ],
                [
                    90.4588191,
                    56.3052081
                ],
                [
                    90.4560803,
                    56.3038353
                ],
                [
                    90.4549752,
                    56.3031422
                ],
                [
                    90.4441398,
                    56.3056613
                ],
                [
                    90.4419535,
                    56.3062477
                ],
                [
                    90.4409204,
                    56.3069274
                ],
                [
                    90.4396952,
                    56.3080603
                ]
            ],
            "longitude": 90.450043,
            "latitude": 56.306805
        },
        "6414": {
            "name": "Ельничная",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    90.4139621,
                    55.344516
                ],
                [
                    90.4139771,
                    55.3446635
                ],
                [
                    90.4141019,
                    55.3448366
                ],
                [
                    90.4144811,
                    55.344987
                ],
                [
                    90.4157486,
                    55.3452169
                ],
                [
                    90.4161978,
                    55.3452396
                ],
                [
                    90.4163475,
                    55.3451998
                ],
                [
                    90.4164523,
                    55.3450551
                ],
                [
                    90.4166669,
                    55.3449274
                ],
                [
                    90.4169114,
                    55.3449047
                ],
                [
                    90.4171958,
                    55.3449416
                ],
                [
                    90.4173306,
                    55.3448395
                ],
                [
                    90.4173505,
                    55.344621
                ],
                [
                    90.4173854,
                    55.3444223
                ],
                [
                    90.4175152,
                    55.3442691
                ],
                [
                    90.4176898,
                    55.3441868
                ],
                [
                    90.418059,
                    55.3441159
                ],
                [
                    90.4184134,
                    55.3440903
                ],
                [
                    90.4187677,
                    55.3439683
                ],
                [
                    90.4191819,
                    55.3436647
                ],
                [
                    90.4197508,
                    55.3432646
                ],
                [
                    90.4205792,
                    55.3429638
                ],
                [
                    90.4213627,
                    55.3428843
                ],
                [
                    90.4221312,
                    55.3428077
                ],
                [
                    90.4225453,
                    55.3426743
                ],
                [
                    90.4227998,
                    55.3425494
                ],
                [
                    90.4238278,
                    55.342277
                ],
                [
                    90.424771,
                    55.3417236
                ],
                [
                    90.4251452,
                    55.3416271
                ],
                [
                    90.4256343,
                    55.3415647
                ],
                [
                    90.4260535,
                    55.3414654
                ],
                [
                    90.4261882,
                    55.341332
                ],
                [
                    90.4264627,
                    55.3409177
                ],
                [
                    90.4265725,
                    55.3408382
                ],
                [
                    90.4272012,
                    55.3406906
                ],
                [
                    90.4277551,
                    55.3406481
                ],
                [
                    90.4283689,
                    55.340492
                ],
                [
                    90.4287681,
                    55.3403189
                ],
                [
                    90.4290726,
                    55.3401997
                ],
                [
                    90.4295317,
                    55.3401287
                ],
                [
                    90.4301604,
                    55.3401827
                ],
                [
                    90.4306595,
                    55.3401912
                ],
                [
                    90.4315577,
                    55.3400124
                ],
                [
                    90.4320168,
                    55.3400039
                ],
                [
                    90.432421,
                    55.340089
                ],
                [
                    90.4332893,
                    55.3405942
                ],
                [
                    90.4338032,
                    55.3409461
                ],
                [
                    90.4343921,
                    55.3411248
                ],
                [
                    90.4351956,
                    55.3412497
                ],
                [
                    90.4359691,
                    55.3412043
                ],
                [
                    90.4364381,
                    55.3410425
                ],
                [
                    90.4367625,
                    55.3408411
                ],
                [
                    90.4375559,
                    55.3406651
                ],
                [
                    90.43802,
                    55.3406396
                ],
                [
                    90.4384093,
                    55.3405715
                ],
                [
                    90.4388684,
                    55.3402252
                ],
                [
                    90.4391428,
                    55.3400748
                ],
                [
                    90.4399962,
                    55.3398251
                ],
                [
                    90.4405201,
                    55.3395526
                ],
                [
                    90.441084,
                    55.3393937
                ],
                [
                    90.4416779,
                    55.3392773
                ],
                [
                    90.4419923,
                    55.3391269
                ],
                [
                    90.4426859,
                    55.3386785
                ],
                [
                    90.4429354,
                    55.3385451
                ],
                [
                    90.4433432,
                    55.3385307
                ],
                [
                    90.4436177,
                    55.33863
                ],
                [
                    90.4440369,
                    55.3387236
                ],
                [
                    90.4443962,
                    55.3387463
                ],
                [
                    90.4446655,
                    55.3385903
                ],
                [
                    90.4448453,
                    55.3382781
                ],
                [
                    90.4456737,
                    55.3377218
                ],
                [
                    90.4466019,
                    55.3375316
                ],
                [
                    90.4481538,
                    55.3376026
                ],
                [
                    90.449022,
                    55.3375033
                ],
                [
                    90.4494363,
                    55.3374181
                ],
                [
                    90.4502447,
                    55.3370293
                ],
                [
                    90.4505691,
                    55.3370066
                ],
                [
                    90.4509683,
                    55.3370378
                ],
                [
                    90.451123,
                    55.3371229
                ],
                [
                    90.4512378,
                    55.3372847
                ],
                [
                    90.4514573,
                    55.337333
                ],
                [
                    90.4517917,
                    55.3373245
                ],
                [
                    90.4519564,
                    55.3372109
                ],
                [
                    90.4522159,
                    55.3368476
                ],
                [
                    90.4526051,
                    55.3365156
                ],
                [
                    90.4528596,
                    55.3364616
                ],
                [
                    90.453144,
                    55.3364872
                ],
                [
                    90.4532937,
                    55.3367313
                ],
                [
                    90.4534235,
                    55.336788
                ],
                [
                    90.4537378,
                    55.3367597
                ],
                [
                    90.4540922,
                    55.3365808
                ],
                [
                    90.4542469,
                    55.3365042
                ],
                [
                    90.4554795,
                    55.3362204
                ],
                [
                    90.4563278,
                    55.3357095
                ],
                [
                    90.4566971,
                    55.33563
                ],
                [
                    90.4568119,
                    55.3358259
                ],
                [
                    90.4576303,
                    55.3367256
                ],
                [
                    90.4582163,
                    55.3366805
                ],
                [
                    90.4591297,
                    55.3363281
                ],
                [
                    90.4597621,
                    55.3359903
                ],
                [
                    90.4600303,
                    55.3360738
                ],
                [
                    90.46042,
                    55.3360993
                ],
                [
                    90.461442,
                    55.3359085
                ],
                [
                    90.4617741,
                    55.3359067
                ],
                [
                    90.462068,
                    55.3359521
                ],
                [
                    90.4623586,
                    55.3361174
                ],
                [
                    90.4624065,
                    55.3363554
                ],
                [
                    90.4623873,
                    55.3364698
                ],
                [
                    90.4622277,
                    55.3365752
                ],
                [
                    90.4613845,
                    55.3366388
                ],
                [
                    90.4611609,
                    55.3367169
                ],
                [
                    90.4609885,
                    55.336864
                ],
                [
                    90.4609789,
                    55.3370366
                ],
                [
                    90.4611961,
                    55.3372618
                ],
                [
                    90.4616304,
                    55.337507
                ],
                [
                    90.4622181,
                    55.3377323
                ],
                [
                    90.4628249,
                    55.3381282
                ],
                [
                    90.4641247,
                    55.3384134
                ],
                [
                    90.4656673,
                    55.3386949
                ],
                [
                    90.4660538,
                    55.3386931
                ],
                [
                    90.4661622,
                    55.3386114
                ],
                [
                    90.4661239,
                    55.3385296
                ],
                [
                    90.464789,
                    55.3379557
                ],
                [
                    90.4646293,
                    55.3377468
                ],
                [
                    90.4646804,
                    55.3376505
                ],
                [
                    90.4651372,
                    55.3375397
                ],
                [
                    90.4657056,
                    55.3376414
                ],
                [
                    90.4681744,
                    55.3385024
                ],
                [
                    90.4685417,
                    55.3385024
                ],
                [
                    90.4686183,
                    55.3383952
                ],
                [
                    90.4684459,
                    55.3382645
                ],
                [
                    90.4681297,
                    55.3381228
                ],
                [
                    90.4666861,
                    55.337745
                ],
                [
                    90.4661622,
                    55.3375742
                ],
                [
                    90.4658142,
                    55.3374071
                ],
                [
                    90.4658174,
                    55.3372146
                ],
                [
                    90.4657216,
                    55.3372128
                ],
                [
                    90.463887,
                    55.3360762
                ],
                [
                    90.463836,
                    55.3356566
                ],
                [
                    90.4631366,
                    55.3351988
                ],
                [
                    90.4624263,
                    55.3344019
                ],
                [
                    90.4618634,
                    55.3334754
                ],
                [
                    90.463097,
                    55.3327125
                ],
                [
                    90.4621508,
                    55.3315589
                ],
                [
                    90.4608614,
                    55.33073
                ],
                [
                    90.4597555,
                    55.3308504
                ],
                [
                    90.4587655,
                    55.3306233
                ],
                [
                    90.4583303,
                    55.330487
                ],
                [
                    90.4578992,
                    55.3302622
                ],
                [
                    90.4573323,
                    55.3298852
                ],
                [
                    90.4568532,
                    55.3293515
                ],
                [
                    90.4565378,
                    55.3292357
                ],
                [
                    90.4558791,
                    55.3291381
                ],
                [
                    90.4556075,
                    55.3291358
                ],
                [
                    90.455184,
                    55.328968
                ],
                [
                    90.4531477,
                    55.3284956
                ],
                [
                    90.4529484,
                    55.3285058
                ],
                [
                    90.4524016,
                    55.3286351
                ],
                [
                    90.452279,
                    55.3287194
                ],
                [
                    90.4518114,
                    55.3287732
                ],
                [
                    90.4508303,
                    55.3290101
                ],
                [
                    90.450654,
                    55.3289912
                ],
                [
                    90.4504368,
                    55.3288328
                ],
                [
                    90.4498313,
                    55.3284142
                ],
                [
                    90.4495196,
                    55.3280334
                ],
                [
                    90.4494174,
                    55.3279825
                ],
                [
                    90.4492232,
                    55.3279331
                ],
                [
                    90.449029,
                    55.3279389
                ],
                [
                    90.4486994,
                    55.3279898
                ],
                [
                    90.4480121,
                    55.3282238
                ],
                [
                    90.4474143,
                    55.3283808
                ],
                [
                    90.4471281,
                    55.328436
                ],
                [
                    90.446474,
                    55.3287165
                ],
                [
                    90.4461955,
                    55.3287165
                ],
                [
                    90.4458532,
                    55.328654
                ],
                [
                    90.4454418,
                    55.328263
                ],
                [
                    90.4453345,
                    55.3279578
                ],
                [
                    90.4453805,
                    55.3277499
                ],
                [
                    90.4433058,
                    55.3281816
                ],
                [
                    90.4427386,
                    55.3283604
                ],
                [
                    90.4424448,
                    55.3284127
                ],
                [
                    90.4407456,
                    55.3289403
                ],
                [
                    90.4394606,
                    55.3288996
                ],
                [
                    90.4383082,
                    55.3287514
                ],
                [
                    90.4360215,
                    55.3285334
                ],
                [
                    90.4352959,
                    55.3285145
                ],
                [
                    90.4347286,
                    55.3284302
                ],
                [
                    90.4341794,
                    55.3284709
                ],
                [
                    90.4338498,
                    55.3284476
                ],
                [
                    90.430909,
                    55.328795
                ],
                [
                    90.4276054,
                    55.3291496
                ],
                [
                    90.4273678,
                    55.3292383
                ],
                [
                    90.4293624,
                    55.3302001
                ],
                [
                    90.4299611,
                    55.330568
                ],
                [
                    90.4318535,
                    55.3321304
                ],
                [
                    90.4330592,
                    55.3328116
                ],
                [
                    90.4342528,
                    55.3331886
                ],
                [
                    90.4362409,
                    55.3337699
                ],
                [
                    90.4366721,
                    55.3338085
                ],
                [
                    90.4385604,
                    55.3337676
                ],
                [
                    90.439786,
                    55.3336654
                ],
                [
                    90.4401972,
                    55.3335701
                ],
                [
                    90.4428879,
                    55.3328162
                ],
                [
                    90.4435466,
                    55.3326981
                ],
                [
                    90.4452034,
                    55.3326504
                ],
                [
                    90.4463252,
                    55.332739
                ],
                [
                    90.4473552,
                    55.3329797
                ],
                [
                    90.4479107,
                    55.3331723
                ],
                [
                    90.447756,
                    55.3332518
                ],
                [
                    90.4370869,
                    55.3368139
                ],
                [
                    90.4360738,
                    55.3370352
                ],
                [
                    90.4325257,
                    55.3381081
                ],
                [
                    90.4288131,
                    55.3394391
                ],
                [
                    90.4272062,
                    55.3399414
                ],
                [
                    90.425764,
                    55.3404579
                ],
                [
                    90.4235983,
                    55.3411277
                ],
                [
                    90.4228048,
                    55.3414569
                ],
                [
                    90.4210533,
                    55.3419592
                ],
                [
                    90.4203397,
                    55.342084
                ],
                [
                    90.4177348,
                    55.3430148
                ],
                [
                    90.4168315,
                    55.3432248
                ],
                [
                    90.4159932,
                    55.3433582
                ],
                [
                    90.4152895,
                    55.3435398
                ],
                [
                    90.4146109,
                    55.3438349
                ],
                [
                    90.4143115,
                    55.344008
                ],
                [
                    90.414057,
                    55.3442237
                ],
                [
                    90.4139621,
                    55.344516
                ]
            ],
            "longitude": 90.452759,
            "latitude": 55.33213
        },
        "6415": {
            "name": "Монастырка",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    90.4492751,
                    56.8724796
                ],
                [
                    90.4535357,
                    56.8744618
                ],
                [
                    90.456147,
                    56.8733892
                ],
                [
                    90.459773,
                    56.8759001
                ],
                [
                    90.4594373,
                    56.8803851
                ],
                [
                    90.4660965,
                    56.881621
                ],
                [
                    90.4659459,
                    56.8807256
                ],
                [
                    90.4658706,
                    56.8795714
                ],
                [
                    90.4660477,
                    56.8780153
                ],
                [
                    90.4663223,
                    56.8764326
                ],
                [
                    90.4665172,
                    56.8764253
                ],
                [
                    90.4667564,
                    56.8748038
                ],
                [
                    90.4671992,
                    56.8722576
                ],
                [
                    90.467217,
                    56.8714444
                ],
                [
                    90.4668671,
                    56.8708296
                ],
                [
                    90.4662735,
                    56.8701567
                ],
                [
                    90.4656624,
                    56.8696435
                ],
                [
                    90.4637137,
                    56.8686874
                ],
                [
                    90.4635942,
                    56.8687503
                ],
                [
                    90.4535495,
                    56.869612
                ],
                [
                    90.4492751,
                    56.8724796
                ]
            ],
            "longitude": 90.460999,
            "latitude": 56.873474
        },
        "6416": {
            "name": "Симоново",
            "population": 128,
            "type": "hamlet",
            "poly": [
                [
                    90.454937,
                    56.5081207
                ],
                [
                    90.4554326,
                    56.5081534
                ],
                [
                    90.4560282,
                    56.5080797
                ],
                [
                    90.4561172,
                    56.5086968
                ],
                [
                    90.4562442,
                    56.50883
                ],
                [
                    90.4563374,
                    56.5092274
                ],
                [
                    90.4564306,
                    56.5095523
                ],
                [
                    90.4566721,
                    56.5101039
                ],
                [
                    90.4571762,
                    56.510936
                ],
                [
                    90.4571592,
                    56.5109874
                ],
                [
                    90.4570787,
                    56.5111604
                ],
                [
                    90.4571253,
                    56.5113123
                ],
                [
                    90.4572312,
                    56.5114034
                ],
                [
                    90.4585529,
                    56.5120626
                ],
                [
                    90.4587138,
                    56.5120976
                ],
                [
                    90.4596288,
                    56.5119854
                ],
                [
                    90.460082,
                    56.5118639
                ],
                [
                    90.4602388,
                    56.5117003
                ],
                [
                    90.4604633,
                    56.5113263
                ],
                [
                    90.4603023,
                    56.510964
                ],
                [
                    90.4599973,
                    56.5108612
                ],
                [
                    90.4594721,
                    56.5105643
                ],
                [
                    90.4595017,
                    56.5100805
                ],
                [
                    90.4592129,
                    56.5093381
                ],
                [
                    90.4589163,
                    56.5091891
                ],
                [
                    90.4589057,
                    56.5090547
                ],
                [
                    90.4593929,
                    56.5092651
                ],
                [
                    90.4599118,
                    56.5091979
                ],
                [
                    90.4601501,
                    56.5092972
                ],
                [
                    90.4603036,
                    56.5095281
                ],
                [
                    90.4605471,
                    56.5098261
                ],
                [
                    90.4608013,
                    56.5099839
                ],
                [
                    90.4609761,
                    56.5100277
                ],
                [
                    90.4621357,
                    56.510539
                ],
                [
                    90.4624057,
                    56.5107055
                ],
                [
                    90.4631258,
                    56.511322
                ],
                [
                    90.4634541,
                    56.5117661
                ],
                [
                    90.4650319,
                    56.5129551
                ],
                [
                    90.4654715,
                    56.5131363
                ],
                [
                    90.465588,
                    56.5133846
                ],
                [
                    90.4663346,
                    56.513221
                ],
                [
                    90.4665941,
                    56.5132444
                ],
                [
                    90.4671764,
                    56.5131275
                ],
                [
                    90.4676584,
                    56.5127156
                ],
                [
                    90.4692892,
                    56.5122248
                ],
                [
                    90.4707347,
                    56.5119443
                ],
                [
                    90.4701946,
                    56.5109276
                ],
                [
                    90.4695593,
                    56.5101767
                ],
                [
                    90.4677113,
                    56.5107639
                ],
                [
                    90.4652607,
                    56.5080998
                ],
                [
                    90.466087,
                    56.5078665
                ],
                [
                    90.4666249,
                    56.5078126
                ],
                [
                    90.4667984,
                    56.5077504
                ],
                [
                    90.4667529,
                    56.5076307
                ],
                [
                    90.4670694,
                    56.5074954
                ],
                [
                    90.4672083,
                    56.5075445
                ],
                [
                    90.4673883,
                    56.5075206
                ],
                [
                    90.4676421,
                    56.5076008
                ],
                [
                    90.468078,
                    56.5078557
                ],
                [
                    90.4683383,
                    56.5077671
                ],
                [
                    90.4684575,
                    56.5077001
                ],
                [
                    90.4684164,
                    56.507651
                ],
                [
                    90.468425,
                    56.5075732
                ],
                [
                    90.4686831,
                    56.5073806
                ],
                [
                    90.4697871,
                    56.5069521
                ],
                [
                    90.4701579,
                    56.5069485
                ],
                [
                    90.470403,
                    56.506678
                ],
                [
                    90.4707283,
                    56.5065823
                ],
                [
                    90.4708715,
                    56.506441
                ],
                [
                    90.4711079,
                    56.5063549
                ],
                [
                    90.4713378,
                    56.5063537
                ],
                [
                    90.4712033,
                    56.5060927
                ],
                [
                    90.4693251,
                    56.506362
                ],
                [
                    90.4690792,
                    56.5062373
                ],
                [
                    90.4687972,
                    56.5062432
                ],
                [
                    90.4685722,
                    56.50633
                ],
                [
                    90.4681492,
                    56.5063375
                ],
                [
                    90.4675068,
                    56.5064123
                ],
                [
                    90.4671299,
                    56.5063704
                ],
                [
                    90.4668209,
                    56.5063869
                ],
                [
                    90.465563,
                    56.5060727
                ],
                [
                    90.4649611,
                    56.5057615
                ],
                [
                    90.4640746,
                    56.505362
                ],
                [
                    90.4639174,
                    56.5052423
                ],
                [
                    90.4641993,
                    56.5048608
                ],
                [
                    90.464615,
                    56.504468
                ],
                [
                    90.4663941,
                    56.5048682
                ],
                [
                    90.4681279,
                    56.5033928
                ],
                [
                    90.466725,
                    56.5027738
                ],
                [
                    90.4651356,
                    56.5026279
                ],
                [
                    90.4637735,
                    56.5045648
                ],
                [
                    90.4605012,
                    56.5047323
                ],
                [
                    90.4604795,
                    56.5043134
                ],
                [
                    90.4605717,
                    56.5037838
                ],
                [
                    90.4607669,
                    56.5035773
                ],
                [
                    90.4609567,
                    56.5035444
                ],
                [
                    90.4609837,
                    56.5034531
                ],
                [
                    90.4609323,
                    56.5032272
                ],
                [
                    90.4610597,
                    56.5030626
                ],
                [
                    90.461301,
                    56.5030985
                ],
                [
                    90.4613959,
                    56.5029968
                ],
                [
                    90.4613633,
                    56.5025689
                ],
                [
                    90.4610514,
                    56.5024702
                ],
                [
                    90.4590288,
                    56.5040716
                ],
                [
                    90.4584887,
                    56.504773
                ],
                [
                    90.4566307,
                    56.5062478
                ],
                [
                    90.4565833,
                    56.5064329
                ],
                [
                    90.4562071,
                    56.5066704
                ],
                [
                    90.455692,
                    56.5070968
                ],
                [
                    90.454937,
                    56.5081207
                ]
            ],
            "longitude": 90.4618158,
            "latitude": 56.5084148
        },
        "6417": {
            "name": "Напарино",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.4653201,
            "latitude": 60.1485342
        },
        "6418": {
            "name": "Нижний Тюхтет",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    90.4610168,
                    56.9347951
                ],
                [
                    90.4641724,
                    56.9357073
                ],
                [
                    90.4642787,
                    56.9356949
                ],
                [
                    90.4656118,
                    56.9354354
                ],
                [
                    90.467649,
                    56.9341185
                ],
                [
                    90.4697749,
                    56.9324179
                ],
                [
                    90.4719948,
                    56.930243
                ],
                [
                    90.4727532,
                    56.9290045
                ],
                [
                    90.4720169,
                    56.9284033
                ],
                [
                    90.4717732,
                    56.9283245
                ],
                [
                    90.4685569,
                    56.9272553
                ],
                [
                    90.4613158,
                    56.9340853
                ],
                [
                    90.4610168,
                    56.9347951
                ]
            ],
            "longitude": 90.468613,
            "latitude": 56.93259
        },
        "6419": {
            "name": "Костеньки",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    90.4627946,
                    56.0737774
                ],
                [
                    90.4630844,
                    56.0738396
                ],
                [
                    90.4633965,
                    56.0736281
                ],
                [
                    90.4643997,
                    56.0736281
                ],
                [
                    90.4653137,
                    56.0734165
                ],
                [
                    90.4654029,
                    56.0731801
                ],
                [
                    90.4660494,
                    56.0730433
                ],
                [
                    90.4666959,
                    56.0734663
                ],
                [
                    90.4662723,
                    56.0741133
                ],
                [
                    90.4665468,
                    56.0742169
                ],
                [
                    90.4682361,
                    56.0735034
                ],
                [
                    90.4685831,
                    56.0739621
                ],
                [
                    90.4685466,
                    56.0747877
                ],
                [
                    90.4680444,
                    56.0749202
                ],
                [
                    90.4677978,
                    56.0757356
                ],
                [
                    90.4676426,
                    56.0761484
                ],
                [
                    90.46809,
                    56.0762911
                ],
                [
                    90.4682137,
                    56.0764788
                ],
                [
                    90.468442,
                    56.0780203
                ],
                [
                    90.4682137,
                    56.0782497
                ],
                [
                    90.4673006,
                    56.0782305
                ],
                [
                    90.4674033,
                    56.0787401
                ],
                [
                    90.4658281,
                    56.0787529
                ],
                [
                    90.4654515,
                    56.0786255
                ],
                [
                    90.4641503,
                    56.0787529
                ],
                [
                    90.4643101,
                    56.079479
                ],
                [
                    90.4645612,
                    56.0798548
                ],
                [
                    90.4638877,
                    56.0801096
                ],
                [
                    90.4639447,
                    56.0804217
                ],
                [
                    90.4646753,
                    56.0806892
                ],
                [
                    90.4669011,
                    56.0806319
                ],
                [
                    90.4669924,
                    56.0808293
                ],
                [
                    90.4677229,
                    56.0807529
                ],
                [
                    90.4680881,
                    56.0806446
                ],
                [
                    90.4700171,
                    56.0808612
                ],
                [
                    90.4705764,
                    56.0805427
                ],
                [
                    90.471638,
                    56.0803771
                ],
                [
                    90.4715695,
                    56.0797402
                ],
                [
                    90.4729163,
                    56.079772
                ],
                [
                    90.4730304,
                    56.0779821
                ],
                [
                    90.4741491,
                    56.0778866
                ],
                [
                    90.4743431,
                    56.0789312
                ],
                [
                    90.4747426,
                    56.0791924
                ],
                [
                    90.4755416,
                    56.0793007
                ],
                [
                    90.4758954,
                    56.0793835
                ],
                [
                    90.477014,
                    56.0792624
                ],
                [
                    90.4771396,
                    56.0777082
                ],
                [
                    90.4782125,
                    56.0776509
                ],
                [
                    90.4799931,
                    56.0773069
                ],
                [
                    90.4812829,
                    56.0769183
                ],
                [
                    90.4812487,
                    56.0755042
                ],
                [
                    90.4789887,
                    56.0755615
                ],
                [
                    90.4787033,
                    56.0754214
                ],
                [
                    90.478418,
                    56.075466
                ],
                [
                    90.4778929,
                    56.0755551
                ],
                [
                    90.4761123,
                    56.0757208
                ],
                [
                    90.4752163,
                    56.0750758
                ],
                [
                    90.4750451,
                    56.074168
                ],
                [
                    90.4757585,
                    56.0732204
                ],
                [
                    90.4762721,
                    56.0730293
                ],
                [
                    90.4778416,
                    56.0730293
                ],
                [
                    90.4785264,
                    56.0731646
                ],
                [
                    90.4813371,
                    56.0727744
                ],
                [
                    90.4816225,
                    56.072432
                ],
                [
                    90.4808806,
                    56.0715162
                ],
                [
                    90.4780983,
                    56.070465
                ],
                [
                    90.4767287,
                    56.0706402
                ],
                [
                    90.4770426,
                    56.0721294
                ],
                [
                    90.4717064,
                    56.0723842
                ],
                [
                    90.4708932,
                    56.072647
                ],
                [
                    90.4706364,
                    56.0726072
                ],
                [
                    90.4705649,
                    56.0724081
                ],
                [
                    90.4709788,
                    56.0713728
                ],
                [
                    90.4707789,
                    56.0709269
                ],
                [
                    90.4694093,
                    56.0706641
                ],
                [
                    90.4697374,
                    56.0703296
                ],
                [
                    90.46998,
                    56.0703455
                ],
                [
                    90.4699087,
                    56.0694695
                ],
                [
                    90.4688529,
                    56.0694775
                ],
                [
                    90.4684391,
                    56.0691987
                ],
                [
                    90.4668412,
                    56.0699314
                ],
                [
                    90.4676259,
                    56.0703535
                ],
                [
                    90.4675431,
                    56.0705049
                ],
                [
                    90.4629729,
                    56.073317
                ],
                [
                    90.4627946,
                    56.0737774
                ]
            ],
            "longitude": 90.472801,
            "latitude": 56.075085
        },
        "6420": {
            "name": "Усть-Терея",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.4824014,
            "latitude": 73.2575608
        },
        "6421": {
            "name": "Игинка",
            "population": 108,
            "type": "hamlet",
            "poly": [
                [
                    90.4793867,
                    56.3440609
                ],
                [
                    90.4804423,
                    56.3443821
                ],
                [
                    90.4809597,
                    56.3447376
                ],
                [
                    90.4806492,
                    56.3451506
                ],
                [
                    90.4821395,
                    56.345575
                ],
                [
                    90.4829881,
                    56.345747
                ],
                [
                    90.4829467,
                    56.3462173
                ],
                [
                    90.482574,
                    56.3465958
                ],
                [
                    90.4833607,
                    56.3472611
                ],
                [
                    90.4847474,
                    56.3471005
                ],
                [
                    90.4846439,
                    56.3478805
                ],
                [
                    90.4854925,
                    56.3482704
                ],
                [
                    90.4862377,
                    56.3483507
                ],
                [
                    90.4869828,
                    56.3486031
                ],
                [
                    90.4874175,
                    56.3481902
                ],
                [
                    90.4880591,
                    56.3483737
                ],
                [
                    90.4873968,
                    56.3491651
                ],
                [
                    90.4886179,
                    56.3494518
                ],
                [
                    90.4886386,
                    56.3490733
                ],
                [
                    90.4891561,
                    56.3486719
                ],
                [
                    90.4900047,
                    56.3489357
                ],
                [
                    90.4909361,
                    56.3479837
                ],
                [
                    90.4923022,
                    56.3484998
                ],
                [
                    90.4939994,
                    56.3473758
                ],
                [
                    90.4946824,
                    56.347697
                ],
                [
                    90.4959864,
                    56.3469858
                ],
                [
                    90.4955516,
                    56.3462632
                ],
                [
                    90.4948894,
                    56.3456553
                ],
                [
                    90.4942891,
                    56.3456897
                ],
                [
                    90.4941236,
                    56.3461141
                ],
                [
                    90.493958,
                    56.3462862
                ],
                [
                    90.4935238,
                    56.3460488
                ],
                [
                    90.4933881,
                    56.3458459
                ],
                [
                    90.4935916,
                    56.3456955
                ],
                [
                    90.4937069,
                    56.3454963
                ],
                [
                    90.4933474,
                    56.3452858
                ],
                [
                    90.4925403,
                    56.3451618
                ],
                [
                    90.491991,
                    56.3452745
                ],
                [
                    90.4906752,
                    56.345158
                ],
                [
                    90.4903632,
                    56.3450002
                ],
                [
                    90.4903565,
                    56.3448273
                ],
                [
                    90.4906142,
                    56.3447032
                ],
                [
                    90.4905192,
                    56.3443725
                ],
                [
                    90.4899902,
                    56.3438199
                ],
                [
                    90.4901123,
                    56.3435455
                ],
                [
                    90.4901598,
                    56.3433501
                ],
                [
                    90.4897054,
                    56.343196
                ],
                [
                    90.4889932,
                    56.3430794
                ],
                [
                    90.4886202,
                    56.3431358
                ],
                [
                    90.4885388,
                    56.3434065
                ],
                [
                    90.4881522,
                    56.3434102
                ],
                [
                    90.4876707,
                    56.3432523
                ],
                [
                    90.4873316,
                    56.3431471
                ],
                [
                    90.4870535,
                    56.3427111
                ],
                [
                    90.4864295,
                    56.3427111
                ],
                [
                    90.4854256,
                    56.3428501
                ],
                [
                    90.4851273,
                    56.3430418
                ],
                [
                    90.4849713,
                    56.343305
                ],
                [
                    90.4849035,
                    56.3435831
                ],
                [
                    90.4838048,
                    56.3435079
                ],
                [
                    90.4822381,
                    56.3436207
                ],
                [
                    90.4806714,
                    56.3436057
                ],
                [
                    90.4796971,
                    56.3435332
                ],
                [
                    90.4793867,
                    56.3440609
                ]
            ],
            "longitude": 90.488472,
            "latitude": 56.346355
        },
        "6422": {
            "name": "Климовка",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    90.4850101,
                    56.6515606
                ],
                [
                    90.4855202,
                    56.6526094
                ],
                [
                    90.4854383,
                    56.6528759
                ],
                [
                    90.4856901,
                    56.6533017
                ],
                [
                    90.4865969,
                    56.6539212
                ],
                [
                    90.4874028,
                    56.6544197
                ],
                [
                    90.4874658,
                    56.6546965
                ],
                [
                    90.4871825,
                    56.6550219
                ],
                [
                    90.4899089,
                    56.656652
                ],
                [
                    90.4904441,
                    56.6567386
                ],
                [
                    90.4914012,
                    56.6567489
                ],
                [
                    90.4923835,
                    56.6567905
                ],
                [
                    90.4932209,
                    56.6566347
                ],
                [
                    90.493775,
                    56.6560637
                ],
                [
                    90.4940584,
                    56.655721
                ],
                [
                    90.4944362,
                    56.6554753
                ],
                [
                    90.4944358,
                    56.6553464
                ],
                [
                    90.4927026,
                    56.6552344
                ],
                [
                    90.4929528,
                    56.6552103
                ],
                [
                    90.4935924,
                    56.654887
                ],
                [
                    90.4936105,
                    56.6546134
                ],
                [
                    90.4938761,
                    56.6541172
                ],
                [
                    90.49433,
                    56.6538989
                ],
                [
                    90.4943584,
                    56.6537047
                ],
                [
                    90.4941701,
                    56.6534835
                ],
                [
                    90.4937807,
                    56.6530624
                ],
                [
                    90.4927671,
                    56.6521735
                ],
                [
                    90.4940979,
                    56.6518361
                ],
                [
                    90.494851,
                    56.6517226
                ],
                [
                    90.4954571,
                    56.6516872
                ],
                [
                    90.4961457,
                    56.6513342
                ],
                [
                    90.4959033,
                    56.65113
                ],
                [
                    90.4969272,
                    56.6503743
                ],
                [
                    90.4925614,
                    56.6507368
                ],
                [
                    90.4883528,
                    56.6504054
                ],
                [
                    90.4878628,
                    56.650007
                ],
                [
                    90.4875043,
                    56.6498681
                ],
                [
                    90.4861188,
                    56.6505362
                ],
                [
                    90.486112,
                    56.6506364
                ],
                [
                    90.4862883,
                    56.6507541
                ],
                [
                    90.4860365,
                    56.6508926
                ],
                [
                    90.4859861,
                    56.6509826
                ],
                [
                    90.4851864,
                    56.6513633
                ],
                [
                    90.4850101,
                    56.6515606
                ]
            ],
            "longitude": 90.4907242,
            "latitude": 56.653024
        },
        "6423": {
            "name": "Секретарка",
            "population": 25,
            "type": "hamlet",
            "poly": [
                [
                    [
                        90.452602,
                        56.4664514
                    ],
                    [
                        90.4536398,
                        56.4669288
                    ],
                    [
                        90.4545844,
                        56.4672915
                    ],
                    [
                        90.4548089,
                        56.4670645
                    ],
                    [
                        90.4555841,
                        56.4667791
                    ],
                    [
                        90.4559442,
                        56.4665029
                    ],
                    [
                        90.4562153,
                        56.4665989
                    ],
                    [
                        90.4566135,
                        56.4665685
                    ],
                    [
                        90.4571811,
                        56.4660724
                    ],
                    [
                        90.4578546,
                        56.4650029
                    ],
                    [
                        90.4583333,
                        56.4646987
                    ],
                    [
                        90.4589687,
                        56.4648695
                    ],
                    [
                        90.4599048,
                        56.4646168
                    ],
                    [
                        90.4610062,
                        56.4639896
                    ],
                    [
                        90.4614002,
                        56.4635333
                    ],
                    [
                        90.4616924,
                        56.4633835
                    ],
                    [
                        90.4619254,
                        56.4630465
                    ],
                    [
                        90.4621753,
                        56.4629693
                    ],
                    [
                        90.4628362,
                        56.4623233
                    ],
                    [
                        90.4646746,
                        56.462658
                    ],
                    [
                        90.4654286,
                        56.4616704
                    ],
                    [
                        90.4652337,
                        56.4616119
                    ],
                    [
                        90.4663188,
                        56.4613104
                    ],
                    [
                        90.4670346,
                        56.4612325
                    ],
                    [
                        90.4678239,
                        56.461278
                    ],
                    [
                        90.4690363,
                        56.4612504
                    ],
                    [
                        90.4688672,
                        56.4608922
                    ],
                    [
                        90.4686265,
                        56.4605926
                    ],
                    [
                        90.4686135,
                        56.4605147
                    ],
                    [
                        90.4689214,
                        56.460408
                    ],
                    [
                        90.469314,
                        56.4604524
                    ],
                    [
                        90.4695373,
                        56.4603913
                    ],
                    [
                        90.4698128,
                        56.4600617
                    ],
                    [
                        90.4696371,
                        56.4596531
                    ],
                    [
                        90.4685853,
                        56.4594973
                    ],
                    [
                        90.4684725,
                        56.4592337
                    ],
                    [
                        90.4687089,
                        56.4590455
                    ],
                    [
                        90.4689973,
                        56.4589269
                    ],
                    [
                        90.4694073,
                        56.4584643
                    ],
                    [
                        90.4681472,
                        56.4581995
                    ],
                    [
                        90.4663624,
                        56.4602051
                    ],
                    [
                        90.4658766,
                        56.4600673
                    ],
                    [
                        90.4651196,
                        56.4600853
                    ],
                    [
                        90.4647032,
                        56.4601404
                    ],
                    [
                        90.464495,
                        56.4601272
                    ],
                    [
                        90.4643952,
                        56.4600709
                    ],
                    [
                        90.4643691,
                        56.4599535
                    ],
                    [
                        90.4643042,
                        56.4598876
                    ],
                    [
                        90.4641805,
                        56.4598408
                    ],
                    [
                        90.4637186,
                        56.4597102
                    ],
                    [
                        90.4633781,
                        56.45989
                    ],
                    [
                        90.4633759,
                        56.4599727
                    ],
                    [
                        90.4626573,
                        56.4604044
                    ],
                    [
                        90.4619881,
                        56.4606364
                    ],
                    [
                        90.4618623,
                        56.4608378
                    ],
                    [
                        90.4609557,
                        56.4612943
                    ],
                    [
                        90.4606976,
                        56.4613578
                    ],
                    [
                        90.4606477,
                        56.4614573
                    ],
                    [
                        90.4604287,
                        56.4614752
                    ],
                    [
                        90.4587764,
                        56.4624556
                    ],
                    [
                        90.4582484,
                        56.4626154
                    ],
                    [
                        90.4572953,
                        56.4631935
                    ],
                    [
                        90.4553933,
                        56.4645999
                    ],
                    [
                        90.453809,
                        56.4655992
                    ],
                    [
                        90.4529407,
                        56.4660812
                    ],
                    [
                        90.452602,
                        56.4664514
                    ]
                ],
                [
                    [
                        90.4878728,
                        56.4570039
                    ],
                    [
                        90.4879702,
                        56.4572263
                    ],
                    [
                        90.4880634,
                        56.4580221
                    ],
                    [
                        90.4884405,
                        56.4581173
                    ],
                    [
                        90.4887737,
                        56.4580118
                    ],
                    [
                        90.4890659,
                        56.4583673
                    ],
                    [
                        90.489532,
                        56.4586335
                    ],
                    [
                        90.4904957,
                        56.45897
                    ],
                    [
                        90.4907869,
                        56.4589641
                    ],
                    [
                        90.4908346,
                        56.4589056
                    ],
                    [
                        90.4913641,
                        56.4588091
                    ],
                    [
                        90.4914382,
                        56.4588969
                    ],
                    [
                        90.49165,
                        56.4590168
                    ],
                    [
                        90.4920154,
                        56.4590578
                    ],
                    [
                        90.4924231,
                        56.4589817
                    ],
                    [
                        90.4928731,
                        56.4588618
                    ],
                    [
                        90.493445,
                        56.4588325
                    ],
                    [
                        90.4938051,
                        56.4589495
                    ],
                    [
                        90.4944405,
                        56.4588881
                    ],
                    [
                        90.4945411,
                        56.4587857
                    ],
                    [
                        90.4951033,
                        56.4588389
                    ],
                    [
                        90.4954219,
                        56.4588183
                    ],
                    [
                        90.4958658,
                        56.4588389
                    ],
                    [
                        90.4962691,
                        56.458882
                    ],
                    [
                        90.4963504,
                        56.4589456
                    ],
                    [
                        90.496608,
                        56.4590037
                    ],
                    [
                        90.4969344,
                        56.4589291
                    ],
                    [
                        90.498651,
                        56.458955
                    ],
                    [
                        90.4989178,
                        56.4588675
                    ],
                    [
                        90.498946,
                        56.4587608
                    ],
                    [
                        90.4988028,
                        56.4585379
                    ],
                    [
                        90.4988657,
                        56.4580166
                    ],
                    [
                        90.4993242,
                        56.4577117
                    ],
                    [
                        90.4995275,
                        56.4576249
                    ],
                    [
                        90.4994387,
                        56.4575748
                    ],
                    [
                        90.4998014,
                        56.4573976
                    ],
                    [
                        90.4996404,
                        56.4571495
                    ],
                    [
                        90.4987254,
                        56.4562904
                    ],
                    [
                        90.4983357,
                        56.4556116
                    ],
                    [
                        90.4977765,
                        56.4551482
                    ],
                    [
                        90.4969759,
                        56.4546964
                    ],
                    [
                        90.4931212,
                        56.4556748
                    ],
                    [
                        90.4927527,
                        56.4558223
                    ],
                    [
                        90.491969,
                        56.4559417
                    ],
                    [
                        90.4914522,
                        56.4559557
                    ],
                    [
                        90.4898298,
                        56.456267
                    ],
                    [
                        90.4880084,
                        56.4565854
                    ],
                    [
                        90.4878897,
                        56.4566837
                    ],
                    [
                        90.4879491,
                        56.4568307
                    ],
                    [
                        90.4878728,
                        56.4570039
                    ]
                ]
            ],
            "longitude": 90.4928988,
            "latitude": 56.4576375
        },
        "6424": {
            "name": "Ишимка",
            "population": 31,
            "type": "hamlet",
            "poly": [
                [
                    90.4963558,
                    56.7783463
                ],
                [
                    90.4968985,
                    56.7789281
                ],
                [
                    90.4971446,
                    56.7790777
                ],
                [
                    90.4966066,
                    56.7793112
                ],
                [
                    90.4968257,
                    56.77947
                ],
                [
                    90.497392,
                    56.7798228
                ],
                [
                    90.4995934,
                    56.779747
                ],
                [
                    90.5018486,
                    56.7787146
                ],
                [
                    90.5023171,
                    56.7788975
                ],
                [
                    90.5033858,
                    56.7783859
                ],
                [
                    90.5039892,
                    56.7788051
                ],
                [
                    90.5049533,
                    56.7797877
                ],
                [
                    90.5045084,
                    56.7799077
                ],
                [
                    90.5048623,
                    56.7802826
                ],
                [
                    90.506214,
                    56.7799927
                ],
                [
                    90.5066219,
                    56.7800222
                ],
                [
                    90.5070434,
                    56.780242
                ],
                [
                    90.5070906,
                    56.7804932
                ],
                [
                    90.5068445,
                    56.7807536
                ],
                [
                    90.5068614,
                    56.7808736
                ],
                [
                    90.5070738,
                    56.7812485
                ],
                [
                    90.5079637,
                    56.7810564
                ],
                [
                    90.5084323,
                    56.781025
                ],
                [
                    90.5081255,
                    56.7804027
                ],
                [
                    90.5073064,
                    56.779193
                ],
                [
                    90.507812,
                    56.7790803
                ],
                [
                    90.5076974,
                    56.7788088
                ],
                [
                    90.5096492,
                    56.7780331
                ],
                [
                    90.5110348,
                    56.7778392
                ],
                [
                    90.5110786,
                    56.7780516
                ],
                [
                    90.5112302,
                    56.7784043
                ],
                [
                    90.5114696,
                    56.7787146
                ],
                [
                    90.5119112,
                    56.7787479
                ],
                [
                    90.5126765,
                    56.7786684
                ],
                [
                    90.51299,
                    56.7785853
                ],
                [
                    90.5130169,
                    56.778517
                ],
                [
                    90.5126832,
                    56.7776157
                ],
                [
                    90.513145,
                    56.7775695
                ],
                [
                    90.5128488,
                    56.7770083
                ],
                [
                    90.5113424,
                    56.7751612
                ],
                [
                    90.5104344,
                    56.7723513
                ],
                [
                    90.5107225,
                    56.7717425
                ],
                [
                    90.511027,
                    56.7714448
                ],
                [
                    90.5111669,
                    56.7708179
                ],
                [
                    90.5107636,
                    56.7701504
                ],
                [
                    90.5104344,
                    56.7694198
                ],
                [
                    90.5100394,
                    56.7689147
                ],
                [
                    90.5098254,
                    56.7680577
                ],
                [
                    90.5102698,
                    56.765622
                ],
                [
                    90.511636,
                    56.7644583
                ],
                [
                    90.5127553,
                    56.7633576
                ],
                [
                    90.5129446,
                    56.7630689
                ],
                [
                    90.5129527,
                    56.7628028
                ],
                [
                    90.5126319,
                    56.7625998
                ],
                [
                    90.512278,
                    56.762514
                ],
                [
                    90.5118253,
                    56.7625366
                ],
                [
                    90.510418,
                    56.7628073
                ],
                [
                    90.5099077,
                    56.7628253
                ],
                [
                    90.5090435,
                    56.762911
                ],
                [
                    90.5084756,
                    56.7630779
                ],
                [
                    90.5081464,
                    56.7633215
                ],
                [
                    90.5078337,
                    56.7640658
                ],
                [
                    90.5076938,
                    56.7641425
                ],
                [
                    90.5062782,
                    56.7657258
                ],
                [
                    90.5052494,
                    56.7661407
                ],
                [
                    90.5047249,
                    56.7666845
                ],
                [
                    90.5046069,
                    56.7671787
                ],
                [
                    90.5043414,
                    56.7695249
                ],
                [
                    90.5035787,
                    56.7705179
                ],
                [
                    90.5027528,
                    56.7710906
                ],
                [
                    90.5020828,
                    56.7716632
                ],
                [
                    90.5017583,
                    56.7720696
                ],
                [
                    90.5017246,
                    56.7724044
                ],
                [
                    90.5014718,
                    56.7731064
                ],
                [
                    90.5014893,
                    56.7733373
                ],
                [
                    90.5017047,
                    56.7734629
                ],
                [
                    90.5030091,
                    56.7734826
                ],
                [
                    90.5030031,
                    56.7742765
                ],
                [
                    90.5025336,
                    56.7742955
                ],
                [
                    90.5023563,
                    56.77439
                ],
                [
                    90.5023125,
                    56.7748019
                ],
                [
                    90.5019147,
                    56.7749385
                ],
                [
                    90.5018877,
                    56.7753782
                ],
                [
                    90.5012371,
                    56.7757143
                ],
                [
                    90.501109,
                    56.7759323
                ],
                [
                    90.5006033,
                    56.7763349
                ],
                [
                    90.4996696,
                    56.7767985
                ],
                [
                    90.4987493,
                    56.7771864
                ],
                [
                    90.4983178,
                    56.7772806
                ],
                [
                    90.4976469,
                    56.7775817
                ],
                [
                    90.4963558,
                    56.7783463
                ]
            ],
            "longitude": 90.5044795,
            "latitude": 56.772013
        },
        "6425": {
            "name": "Исаковка",
            "population": 86,
            "type": "hamlet",
            "poly": [
                [
                    90.5118576,
                    57.3200194
                ],
                [
                    90.5121058,
                    57.3202969
                ],
                [
                    90.5149006,
                    57.3219802
                ],
                [
                    90.5160775,
                    57.3224658
                ],
                [
                    90.5170003,
                    57.322614
                ],
                [
                    90.5167666,
                    57.323467
                ],
                [
                    90.5169156,
                    57.3237113
                ],
                [
                    90.5174062,
                    57.3240156
                ],
                [
                    90.5166849,
                    57.3253068
                ],
                [
                    90.5164717,
                    57.3260242
                ],
                [
                    90.5161614,
                    57.3264687
                ],
                [
                    90.5144298,
                    57.3270525
                ],
                [
                    90.5141014,
                    57.329412
                ],
                [
                    90.5198258,
                    57.3304148
                ],
                [
                    90.5205582,
                    57.3289742
                ],
                [
                    90.5174685,
                    57.3283547
                ],
                [
                    90.5176934,
                    57.328104
                ],
                [
                    90.5178599,
                    57.3278833
                ],
                [
                    90.5178628,
                    57.3276374
                ],
                [
                    90.5179971,
                    57.3273836
                ],
                [
                    90.5180473,
                    57.3269873
                ],
                [
                    90.5182739,
                    57.3265244
                ],
                [
                    90.5185847,
                    57.3261448
                ],
                [
                    90.5186501,
                    57.3261397
                ],
                [
                    90.51883,
                    57.3258207
                ],
                [
                    90.5199069,
                    57.3258295
                ],
                [
                    90.519921,
                    57.3255634
                ],
                [
                    90.5198671,
                    57.3252455
                ],
                [
                    90.5196436,
                    57.3246812
                ],
                [
                    90.5192566,
                    57.3239402
                ],
                [
                    90.5192274,
                    57.3235027
                ],
                [
                    90.5194719,
                    57.3227184
                ],
                [
                    90.5197713,
                    57.3222335
                ],
                [
                    90.5199867,
                    57.322273
                ],
                [
                    90.5204211,
                    57.3223518
                ],
                [
                    90.5205123,
                    57.3223281
                ],
                [
                    90.5204977,
                    57.3222552
                ],
                [
                    90.5204904,
                    57.3221586
                ],
                [
                    90.5206912,
                    57.322064
                ],
                [
                    90.5207058,
                    57.3219911
                ],
                [
                    90.5206401,
                    57.3219576
                ],
                [
                    90.5203481,
                    57.3219537
                ],
                [
                    90.5203444,
                    57.3218512
                ],
                [
                    90.5206436,
                    57.3216186
                ],
                [
                    90.5209394,
                    57.3215674
                ],
                [
                    90.5210818,
                    57.3215989
                ],
                [
                    90.5211949,
                    57.3216167
                ],
                [
                    90.5218045,
                    57.3217093
                ],
                [
                    90.5221732,
                    57.3216383
                ],
                [
                    90.522217,
                    57.3215733
                ],
                [
                    90.5223667,
                    57.3214708
                ],
                [
                    90.5225528,
                    57.3213131
                ],
                [
                    90.5231953,
                    57.3211476
                ],
                [
                    90.5233413,
                    57.3212028
                ],
                [
                    90.5234837,
                    57.3211929
                ],
                [
                    90.5237209,
                    57.3211338
                ],
                [
                    90.5240531,
                    57.3211298
                ],
                [
                    90.5242393,
                    57.3212915
                ],
                [
                    90.5244473,
                    57.3213624
                ],
                [
                    90.524681,
                    57.3214866
                ],
                [
                    90.524816,
                    57.3214826
                ],
                [
                    90.5249182,
                    57.3214334
                ],
                [
                    90.5249803,
                    57.3213072
                ],
                [
                    90.5251117,
                    57.3212599
                ],
                [
                    90.5252139,
                    57.3211023
                ],
                [
                    90.5253745,
                    57.3209899
                ],
                [
                    90.5256592,
                    57.3209702
                ],
                [
                    90.5258746,
                    57.3208953
                ],
                [
                    90.52609,
                    57.3209091
                ],
                [
                    90.5265171,
                    57.3210195
                ],
                [
                    90.5266412,
                    57.3210569
                ],
                [
                    90.5267908,
                    57.3210155
                ],
                [
                    90.5267945,
                    57.3209584
                ],
                [
                    90.5268346,
                    57.3208559
                ],
                [
                    90.526966,
                    57.3208224
                ],
                [
                    90.5272143,
                    57.3208638
                ],
                [
                    90.5273968,
                    57.3209288
                ],
                [
                    90.5275647,
                    57.3209505
                ],
                [
                    90.5276997,
                    57.3208717
                ],
                [
                    90.527937,
                    57.3205524
                ],
                [
                    90.5281925,
                    57.3199926
                ],
                [
                    90.5284006,
                    57.3198507
                ],
                [
                    90.5289628,
                    57.3193028
                ],
                [
                    90.5276413,
                    57.3174776
                ],
                [
                    90.5263476,
                    57.3178401
                ],
                [
                    90.5262132,
                    57.3177423
                ],
                [
                    90.5251094,
                    57.3179757
                ],
                [
                    90.521926,
                    57.317273
                ],
                [
                    90.5202271,
                    57.3180137
                ],
                [
                    90.5198548,
                    57.3184008
                ],
                [
                    90.5200212,
                    57.3186622
                ],
                [
                    90.5186123,
                    57.319926
                ],
                [
                    90.5179348,
                    57.3198818
                ],
                [
                    90.5166643,
                    57.3190544
                ],
                [
                    90.514664,
                    57.3196536
                ],
                [
                    90.5141996,
                    57.319846
                ],
                [
                    90.513198,
                    57.319272
                ],
                [
                    90.5118576,
                    57.3200194
                ]
            ],
            "longitude": 90.518044,
            "latitude": 57.322464
        },
        "6426": {
            "name": "Владимировка",
            "population": 185,
            "type": "hamlet",
            "poly": [
                [
                    90.5067802,
                    56.0212625
                ],
                [
                    90.5068244,
                    56.0218301
                ],
                [
                    90.5083193,
                    56.0217314
                ],
                [
                    90.5090699,
                    56.0217737
                ],
                [
                    90.5101422,
                    56.0219923
                ],
                [
                    90.5119147,
                    56.0221086
                ],
                [
                    90.5136241,
                    56.0222813
                ],
                [
                    90.5169987,
                    56.0227008
                ],
                [
                    90.5182413,
                    56.0231873
                ],
                [
                    90.5192694,
                    56.0234129
                ],
                [
                    90.5205121,
                    56.0234411
                ],
                [
                    90.5224864,
                    56.0235116
                ],
                [
                    90.5228647,
                    56.0230322
                ],
                [
                    90.5228774,
                    56.0228207
                ],
                [
                    90.5233694,
                    56.0228771
                ],
                [
                    90.5240633,
                    56.0224153
                ],
                [
                    90.5248706,
                    56.0220839
                ],
                [
                    90.5251229,
                    56.0218266
                ],
                [
                    90.526435,
                    56.0211497
                ],
                [
                    90.5269774,
                    56.0210228
                ],
                [
                    90.5275704,
                    56.0206386
                ],
                [
                    90.5296209,
                    56.0200107
                ],
                [
                    90.5317844,
                    56.0196405
                ],
                [
                    90.5344211,
                    56.019295
                ],
                [
                    90.5353167,
                    56.0193937
                ],
                [
                    90.5366287,
                    56.0196334
                ],
                [
                    90.5384832,
                    56.0204408
                ],
                [
                    90.5387923,
                    56.0202786
                ],
                [
                    90.5393095,
                    56.019436
                ],
                [
                    90.5394735,
                    56.0189777
                ],
                [
                    90.5394419,
                    56.0185123
                ],
                [
                    90.5392634,
                    56.0179983
                ],
                [
                    90.5391827,
                    56.0179914
                ],
                [
                    90.5390632,
                    56.0179856
                ],
                [
                    90.5390341,
                    56.0178575
                ],
                [
                    90.5372743,
                    56.0146917
                ],
                [
                    90.5372192,
                    56.0144449
                ],
                [
                    90.5376843,
                    56.0137132
                ],
                [
                    90.5382915,
                    56.0116285
                ],
                [
                    90.5341994,
                    56.0111436
                ],
                [
                    90.5341363,
                    56.0116549
                ],
                [
                    90.5338445,
                    56.0121309
                ],
                [
                    90.5327644,
                    56.012889
                ],
                [
                    90.5319049,
                    56.0136119
                ],
                [
                    90.5311796,
                    56.0139777
                ],
                [
                    90.5309429,
                    56.0142862
                ],
                [
                    90.5294371,
                    56.0151456
                ],
                [
                    90.5279626,
                    56.0157759
                ],
                [
                    90.5269613,
                    56.0158904
                ],
                [
                    90.5241701,
                    56.0153131
                ],
                [
                    90.5217102,
                    56.0149032
                ],
                [
                    90.5214027,
                    56.015031
                ],
                [
                    90.5211582,
                    56.0156172
                ],
                [
                    90.5217417,
                    56.0156921
                ],
                [
                    90.5227509,
                    56.016124
                ],
                [
                    90.5231057,
                    56.0164413
                ],
                [
                    90.5229875,
                    56.0167498
                ],
                [
                    90.522609,
                    56.0173007
                ],
                [
                    90.5237365,
                    56.0176048
                ],
                [
                    90.5248718,
                    56.0175828
                ],
                [
                    90.5245801,
                    56.0180058
                ],
                [
                    90.5247063,
                    56.0183937
                ],
                [
                    90.5240125,
                    56.0184686
                ],
                [
                    90.5234605,
                    56.0189269
                ],
                [
                    90.5210478,
                    56.0187374
                ],
                [
                    90.5209217,
                    56.018332
                ],
                [
                    90.5189111,
                    56.0183055
                ],
                [
                    90.5182646,
                    56.0187198
                ],
                [
                    90.516529,
                    56.0187572
                ],
                [
                    90.5157306,
                    56.0182724
                ],
                [
                    90.5152772,
                    56.0181733
                ],
                [
                    90.5134244,
                    56.018603
                ],
                [
                    90.5128429,
                    56.0186525
                ],
                [
                    90.5112955,
                    56.0184102
                ],
                [
                    90.5107929,
                    56.0183661
                ],
                [
                    90.5100143,
                    56.0184928
                ],
                [
                    90.5091145,
                    56.0184894
                ],
                [
                    90.5085149,
                    56.0198806
                ],
                [
                    90.5080733,
                    56.0198348
                ],
                [
                    90.5073479,
                    56.0211956
                ],
                [
                    90.5067802,
                    56.0212625
                ]
            ],
            "longitude": 90.525528,
            "latitude": 56.019482
        },
        "6427": {
            "name": "Сереуль",
            "population": 199,
            "type": "hamlet",
            "poly": [
                [
                    90.5284912,
                    55.7968858
                ],
                [
                    90.5289073,
                    55.797085
                ],
                [
                    90.5293927,
                    55.797085
                ],
                [
                    90.5300707,
                    55.7973968
                ],
                [
                    90.5303635,
                    55.7974315
                ],
                [
                    90.5319431,
                    55.7973925
                ],
                [
                    90.5325595,
                    55.7971846
                ],
                [
                    90.5334224,
                    55.797046
                ],
                [
                    90.5344164,
                    55.796444
                ],
                [
                    90.5347862,
                    55.7967515
                ],
                [
                    90.5347862,
                    55.7968338
                ],
                [
                    90.5356259,
                    55.7970157
                ],
                [
                    90.5366585,
                    55.7967645
                ],
                [
                    90.5384846,
                    55.7962534
                ],
                [
                    90.5389623,
                    55.7962837
                ],
                [
                    90.5395016,
                    55.7966519
                ],
                [
                    90.5397251,
                    55.7970287
                ],
                [
                    90.5400949,
                    55.7971889
                ],
                [
                    90.5406266,
                    55.7972972
                ],
                [
                    90.5413046,
                    55.7972972
                ],
                [
                    90.5415049,
                    55.797176
                ],
                [
                    90.5414741,
                    55.7969204
                ],
                [
                    90.541243,
                    55.7966952
                ],
                [
                    90.540719,
                    55.7963747
                ],
                [
                    90.5407266,
                    55.7962577
                ],
                [
                    90.5411428,
                    55.7961884
                ],
                [
                    90.5418517,
                    55.7962188
                ],
                [
                    90.5427532,
                    55.7965609
                ],
                [
                    90.5430768,
                    55.7966042
                ],
                [
                    90.5434466,
                    55.7964613
                ],
                [
                    90.5435314,
                    55.7962058
                ],
                [
                    90.5432771,
                    55.7957207
                ],
                [
                    90.5434235,
                    55.7954001
                ],
                [
                    90.5442402,
                    55.7952009
                ],
                [
                    90.5445022,
                    55.7949843
                ],
                [
                    90.5443558,
                    55.7947851
                ],
                [
                    90.5443789,
                    55.7945555
                ],
                [
                    90.5447949,
                    55.7944559
                ],
                [
                    90.5456579,
                    55.7944516
                ],
                [
                    90.5458506,
                    55.7943606
                ],
                [
                    90.5460278,
                    55.7942436
                ],
                [
                    90.5464422,
                    55.7940393
                ],
                [
                    90.546837,
                    55.7939906
                ],
                [
                    90.5472319,
                    55.7940664
                ],
                [
                    90.5477905,
                    55.7942938
                ],
                [
                    90.5483299,
                    55.7942613
                ],
                [
                    90.5485032,
                    55.7943425
                ],
                [
                    90.5484551,
                    55.7945158
                ],
                [
                    90.5486092,
                    55.7947269
                ],
                [
                    90.5489174,
                    55.7947648
                ],
                [
                    90.5491004,
                    55.7946349
                ],
                [
                    90.5494182,
                    55.7942938
                ],
                [
                    90.549736,
                    55.7941855
                ],
                [
                    90.5498998,
                    55.7942396
                ],
                [
                    90.5499672,
                    55.7944724
                ],
                [
                    90.5501502,
                    55.7945537
                ],
                [
                    90.5506221,
                    55.7945699
                ],
                [
                    90.5508244,
                    55.7944995
                ],
                [
                    90.5514986,
                    55.7945266
                ],
                [
                    90.5521535,
                    55.7941963
                ],
                [
                    90.5521631,
                    55.7940068
                ],
                [
                    90.5519801,
                    55.7937848
                ],
                [
                    90.5519801,
                    55.793552
                ],
                [
                    90.5524328,
                    55.79333
                ],
                [
                    90.5529625,
                    55.7933029
                ],
                [
                    90.5535404,
                    55.7931838
                ],
                [
                    90.553916,
                    55.7932217
                ],
                [
                    90.5542146,
                    55.7930809
                ],
                [
                    90.5543301,
                    55.7927019
                ],
                [
                    90.5550428,
                    55.7918951
                ],
                [
                    90.5552203,
                    55.791845
                ],
                [
                    90.5552825,
                    55.7916414
                ],
                [
                    90.5556523,
                    55.7914196
                ],
                [
                    90.555868,
                    55.7914265
                ],
                [
                    90.5561701,
                    55.7914681
                ],
                [
                    90.5562995,
                    55.7910384
                ],
                [
                    90.5565831,
                    55.7908755
                ],
                [
                    90.5569282,
                    55.7908166
                ],
                [
                    90.5576001,
                    55.7908235
                ],
                [
                    90.5580316,
                    55.790872
                ],
                [
                    90.5579576,
                    55.7903072
                ],
                [
                    90.5577665,
                    55.7895794
                ],
                [
                    90.5574029,
                    55.789219
                ],
                [
                    90.5557632,
                    55.7880476
                ],
                [
                    90.5555971,
                    55.7879571
                ],
                [
                    90.5538095,
                    55.7880784
                ],
                [
                    90.5538818,
                    55.7879873
                ],
                [
                    90.5539821,
                    55.7858776
                ],
                [
                    90.5544691,
                    55.7851567
                ],
                [
                    90.5550238,
                    55.7851463
                ],
                [
                    90.555856,
                    55.7850493
                ],
                [
                    90.5562253,
                    55.7850747
                ],
                [
                    90.5558478,
                    55.7838876
                ],
                [
                    90.5559402,
                    55.7834067
                ],
                [
                    90.5556243,
                    55.783086
                ],
                [
                    90.5531125,
                    55.7832767
                ],
                [
                    90.5520723,
                    55.7839482
                ],
                [
                    90.5506315,
                    55.7842689
                ],
                [
                    90.5498379,
                    55.7843555
                ],
                [
                    90.5475726,
                    55.7843078
                ],
                [
                    90.5453151,
                    55.7844638
                ],
                [
                    90.5440591,
                    55.7846371
                ],
                [
                    90.5431268,
                    55.7849751
                ],
                [
                    90.5432732,
                    55.7853477
                ],
                [
                    90.5432193,
                    55.7858719
                ],
                [
                    90.5426645,
                    55.7866777
                ],
                [
                    90.5419942,
                    55.7874965
                ],
                [
                    90.5414697,
                    55.7881227
                ],
                [
                    90.5414086,
                    55.7881983
                ],
                [
                    90.5400294,
                    55.788168
                ],
                [
                    90.5390663,
                    55.7882373
                ],
                [
                    90.5365853,
                    55.789355
                ],
                [
                    90.5356684,
                    55.7898575
                ],
                [
                    90.5353063,
                    55.7903037
                ],
                [
                    90.5352677,
                    55.7909708
                ],
                [
                    90.5352215,
                    55.7915469
                ],
                [
                    90.5348628,
                    55.7921953
                ],
                [
                    90.5338382,
                    55.7933085
                ],
                [
                    90.5333142,
                    55.7936594
                ],
                [
                    90.5325359,
                    55.7941575
                ],
                [
                    90.5313418,
                    55.7947336
                ],
                [
                    90.5304017,
                    55.7950844
                ],
                [
                    90.5292614,
                    55.79534
                ],
                [
                    90.5295468,
                    55.7955474
                ],
                [
                    90.5298703,
                    55.79634
                ],
                [
                    90.5288611,
                    55.7963357
                ],
                [
                    90.528576,
                    55.796483
                ],
                [
                    90.5284912,
                    55.7968858
                ]
            ],
            "longitude": 90.541275,
            "latitude": 55.791061
        },
        "6428": {
            "name": "Бирилюссы",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    90.535681,
                    57.111867
                ],
                [
                    90.5362511,
                    57.1124157
                ],
                [
                    90.5378917,
                    57.1133342
                ],
                [
                    90.5378493,
                    57.1134333
                ],
                [
                    90.5378254,
                    57.1134891
                ],
                [
                    90.5385949,
                    57.1137916
                ],
                [
                    90.5408702,
                    57.1152503
                ],
                [
                    90.5420377,
                    57.1161652
                ],
                [
                    90.5425352,
                    57.1164461
                ],
                [
                    90.5419448,
                    57.1168351
                ],
                [
                    90.5419382,
                    57.1174725
                ],
                [
                    90.5414738,
                    57.1180163
                ],
                [
                    90.5414538,
                    57.1183693
                ],
                [
                    90.5424025,
                    57.1190679
                ],
                [
                    90.5433909,
                    57.1197126
                ],
                [
                    90.5448039,
                    57.1200727
                ],
                [
                    90.5468271,
                    57.1210306
                ],
                [
                    90.5474506,
                    57.121794
                ],
                [
                    90.5476297,
                    57.1224386
                ],
                [
                    90.5507674,
                    57.1266767
                ],
                [
                    90.5526182,
                    57.1276093
                ],
                [
                    90.5537989,
                    57.1285526
                ],
                [
                    90.5532483,
                    57.1293735
                ],
                [
                    90.5534673,
                    57.1306335
                ],
                [
                    90.5563661,
                    57.1292366
                ],
                [
                    90.5591588,
                    57.1289162
                ],
                [
                    90.5580975,
                    57.1277569
                ],
                [
                    90.5576066,
                    57.1269216
                ],
                [
                    90.5574805,
                    57.1264643
                ],
                [
                    90.5576132,
                    57.1260502
                ],
                [
                    90.557852,
                    57.1258486
                ],
                [
                    90.5576928,
                    57.1256073
                ],
                [
                    90.5578056,
                    57.1253445
                ],
                [
                    90.5586812,
                    57.1251248
                ],
                [
                    90.5590195,
                    57.1249232
                ],
                [
                    90.5593645,
                    57.1244407
                ],
                [
                    90.5596696,
                    57.1242643
                ],
                [
                    90.5597824,
                    57.124059
                ],
                [
                    90.5620709,
                    57.1241166
                ],
                [
                    90.5653413,
                    57.1234721
                ],
                [
                    90.5644059,
                    57.1227735
                ],
                [
                    90.5628073,
                    57.121704
                ],
                [
                    90.5626282,
                    57.1212251
                ],
                [
                    90.5629466,
                    57.1211746
                ],
                [
                    90.5645585,
                    57.1207569
                ],
                [
                    90.5658322,
                    57.1206993
                ],
                [
                    90.5665618,
                    57.1208938
                ],
                [
                    90.567338,
                    57.1211962
                ],
                [
                    90.568406,
                    57.1210702
                ],
                [
                    90.5676892,
                    57.1185955
                ],
                [
                    90.5653094,
                    57.1186495
                ],
                [
                    90.5640739,
                    57.118564
                ],
                [
                    90.5630457,
                    57.1183614
                ],
                [
                    90.5622497,
                    57.1179743
                ],
                [
                    90.5597787,
                    57.1164796
                ],
                [
                    90.5592646,
                    57.1162005
                ],
                [
                    90.5562713,
                    57.1140125
                ],
                [
                    90.5548119,
                    57.1132696
                ],
                [
                    90.5534852,
                    57.1131165
                ],
                [
                    90.5527389,
                    57.1130625
                ],
                [
                    90.5512795,
                    57.1126708
                ],
                [
                    90.5507654,
                    57.1127338
                ],
                [
                    90.5501684,
                    57.1126978
                ],
                [
                    90.5495714,
                    57.1125087
                ],
                [
                    90.5476394,
                    57.1122205
                ],
                [
                    90.5462629,
                    57.1122521
                ],
                [
                    90.5446792,
                    57.1118829
                ],
                [
                    90.5442231,
                    57.1117028
                ],
                [
                    90.5438334,
                    57.1114056
                ],
                [
                    90.5438085,
                    57.111176
                ],
                [
                    90.5431617,
                    57.1104285
                ],
                [
                    90.5427969,
                    57.1096721
                ],
                [
                    90.5423906,
                    57.1094424
                ],
                [
                    90.5411136,
                    57.1097531
                ],
                [
                    90.5406161,
                    57.1095054
                ],
                [
                    90.5404088,
                    57.1095505
                ],
                [
                    90.5402347,
                    57.1093343
                ],
                [
                    90.5395713,
                    57.1095145
                ],
                [
                    90.5379212,
                    57.1102484
                ],
                [
                    90.5371969,
                    57.110277
                ],
                [
                    90.5367304,
                    57.1105443
                ],
                [
                    90.535681,
                    57.111867
                ]
            ],
            "longitude": 90.555061,
            "latitude": 57.119896
        },
        "6429": {
            "name": "Дорохта",
            "population": 46,
            "type": "hamlet",
            "poly": [
                [
                    90.5607676,
                    57.1446864
                ],
                [
                    90.5615655,
                    57.1457655
                ],
                [
                    90.5624189,
                    57.1458875
                ],
                [
                    90.5632988,
                    57.1460971
                ],
                [
                    90.5641487,
                    57.1464064
                ],
                [
                    90.5648712,
                    57.146961
                ],
                [
                    90.5651632,
                    57.1468854
                ],
                [
                    90.5656805,
                    57.1469898
                ],
                [
                    90.5659393,
                    57.1470114
                ],
                [
                    90.5659393,
                    57.1471301
                ],
                [
                    90.5670272,
                    57.1471985
                ],
                [
                    90.5677503,
                    57.1466407
                ],
                [
                    90.5680156,
                    57.1461261
                ],
                [
                    90.5682213,
                    57.1451976
                ],
                [
                    90.5705961,
                    57.1459174
                ],
                [
                    90.5727321,
                    57.1454424
                ],
                [
                    90.5725463,
                    57.1444635
                ],
                [
                    90.5722048,
                    57.1437935
                ],
                [
                    90.5725468,
                    57.1432255
                ],
                [
                    90.5732517,
                    57.1424664
                ],
                [
                    90.570733,
                    57.1411111
                ],
                [
                    90.5702546,
                    57.1407293
                ],
                [
                    90.5700317,
                    57.1400353
                ],
                [
                    90.5697664,
                    57.1399777
                ],
                [
                    90.5693472,
                    57.1400958
                ],
                [
                    90.5693206,
                    57.1405104
                ],
                [
                    90.5689757,
                    57.14138
                ],
                [
                    90.5685989,
                    57.1419558
                ],
                [
                    90.5679302,
                    57.1425461
                ],
                [
                    90.567113,
                    57.1430672
                ],
                [
                    90.5660569,
                    57.1436344
                ],
                [
                    90.5644161,
                    57.1440818
                ],
                [
                    90.5622801,
                    57.1445029
                ],
                [
                    90.5612054,
                    57.1446432
                ],
                [
                    90.5607676,
                    57.1446864
                ]
            ],
            "longitude": 90.570572,
            "latitude": 57.143837
        },
        "6430": {
            "name": "Фомка",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.573784,
            "latitude": 60.036057
        },
        "6431": {
            "name": "Тихий Ручей",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    90.5805478,
                    56.6283841
                ],
                [
                    90.5811823,
                    56.6289394
                ],
                [
                    90.5813491,
                    56.6291484
                ],
                [
                    90.5813583,
                    56.6294133
                ],
                [
                    90.5818308,
                    56.6293547
                ],
                [
                    90.5827663,
                    56.6294286
                ],
                [
                    90.5833667,
                    56.6295383
                ],
                [
                    90.5837096,
                    56.6296835
                ],
                [
                    90.5839967,
                    56.6299994
                ],
                [
                    90.5841125,
                    56.630323
                ],
                [
                    90.5841033,
                    56.6306389
                ],
                [
                    90.5846544,
                    56.6307994
                ],
                [
                    90.5849415,
                    56.6307535
                ],
                [
                    90.5874472,
                    56.6287332
                ],
                [
                    90.5871184,
                    56.628611
                ],
                [
                    90.5843673,
                    56.6281014
                ],
                [
                    90.5826721,
                    56.6276072
                ],
                [
                    90.5816485,
                    56.6275919
                ],
                [
                    90.5809814,
                    56.6276734
                ],
                [
                    90.5809399,
                    56.6283205
                ],
                [
                    90.5805478,
                    56.6283841
                ]
            ],
            "longitude": 90.5837207,
            "latitude": 56.6287456
        },
        "6432": {
            "name": "Большой Имыш",
            "population": 169,
            "type": "hamlet",
            "poly": [
                [
                    90.6004085,
                    55.1395542
                ],
                [
                    90.6013377,
                    55.1395417
                ],
                [
                    90.6019343,
                    55.1394649
                ],
                [
                    90.6033213,
                    55.1419035
                ],
                [
                    90.6033982,
                    55.1421646
                ],
                [
                    90.603403,
                    55.1425191
                ],
                [
                    90.603302,
                    55.1426895
                ],
                [
                    90.6030039,
                    55.1428929
                ],
                [
                    90.6025952,
                    55.1431018
                ],
                [
                    90.6021192,
                    55.1435415
                ],
                [
                    90.6018066,
                    55.1438905
                ],
                [
                    90.6015662,
                    55.1443879
                ],
                [
                    90.6012584,
                    55.1453607
                ],
                [
                    90.6012007,
                    55.1460972
                ],
                [
                    90.6011671,
                    55.1470397
                ],
                [
                    90.6009584,
                    55.1472507
                ],
                [
                    90.6007892,
                    55.1473368
                ],
                [
                    90.6005584,
                    55.1478046
                ],
                [
                    90.6004476,
                    55.1481827
                ],
                [
                    90.6005676,
                    55.1483287
                ],
                [
                    90.6007522,
                    55.1488616
                ],
                [
                    90.6008107,
                    55.1489987
                ],
                [
                    90.600983,
                    55.1491535
                ],
                [
                    90.6012662,
                    55.1492572
                ],
                [
                    90.6018047,
                    55.1493874
                ],
                [
                    90.6020478,
                    55.1494208
                ],
                [
                    90.6024817,
                    55.1494032
                ],
                [
                    90.6026633,
                    55.149361
                ],
                [
                    90.6028049,
                    55.1495843
                ],
                [
                    90.6030972,
                    55.1498428
                ],
                [
                    90.6032449,
                    55.1499607
                ],
                [
                    90.6035188,
                    55.1500503
                ],
                [
                    90.6040112,
                    55.1500486
                ],
                [
                    90.6045436,
                    55.1499624
                ],
                [
                    90.6050145,
                    55.1499659
                ],
                [
                    90.6056853,
                    55.1500468
                ],
                [
                    90.6069902,
                    55.1502772
                ],
                [
                    90.6091074,
                    55.150701
                ],
                [
                    90.6101045,
                    55.1508733
                ],
                [
                    90.6125418,
                    55.1511617
                ],
                [
                    90.6141052,
                    55.1514325
                ],
                [
                    90.6153423,
                    55.1518088
                ],
                [
                    90.6161886,
                    55.1520111
                ],
                [
                    90.6177981,
                    55.1522959
                ],
                [
                    90.6181551,
                    55.1514835
                ],
                [
                    90.6184751,
                    55.1500011
                ],
                [
                    90.6190168,
                    55.1486892
                ],
                [
                    90.6201677,
                    55.1469886
                ],
                [
                    90.6209432,
                    55.1472137
                ],
                [
                    90.6219957,
                    55.1474424
                ],
                [
                    90.6236852,
                    55.1476587
                ],
                [
                    90.6248023,
                    55.1478416
                ],
                [
                    90.6249531,
                    55.1478011
                ],
                [
                    90.6250977,
                    55.1476358
                ],
                [
                    90.6256671,
                    55.1465613
                ],
                [
                    90.6259379,
                    55.1462465
                ],
                [
                    90.6262118,
                    55.1460794
                ],
                [
                    90.626461,
                    55.1460706
                ],
                [
                    90.6267657,
                    55.1461093
                ],
                [
                    90.6272181,
                    55.1462254
                ],
                [
                    90.6276151,
                    55.1464241
                ],
                [
                    90.6277474,
                    55.1465349
                ],
                [
                    90.6279321,
                    55.1467723
                ],
                [
                    90.6280551,
                    55.1470467
                ],
                [
                    90.6280551,
                    55.1471856
                ],
                [
                    90.6279197,
                    55.1474828
                ],
                [
                    90.6276828,
                    55.1478416
                ],
                [
                    90.626938,
                    55.14829
                ],
                [
                    90.6269534,
                    55.1484026
                ],
                [
                    90.6271473,
                    55.148494
                ],
                [
                    90.6277751,
                    55.1486453
                ],
                [
                    90.6284631,
                    55.1487462
                ],
                [
                    90.6288263,
                    55.1487884
                ],
                [
                    90.6289925,
                    55.1487057
                ],
                [
                    90.6295433,
                    55.1482063
                ],
                [
                    90.6301157,
                    55.1478141
                ],
                [
                    90.6303342,
                    55.1476857
                ],
                [
                    90.6322361,
                    55.1458074
                ],
                [
                    90.6323653,
                    55.1458268
                ],
                [
                    90.6336394,
                    55.1443987
                ],
                [
                    90.6341318,
                    55.1440293
                ],
                [
                    90.6360798,
                    55.1419856
                ],
                [
                    90.6368168,
                    55.1413495
                ],
                [
                    90.6344641,
                    55.1407385
                ],
                [
                    90.6306512,
                    55.1395846
                ],
                [
                    90.630882,
                    55.1394034
                ],
                [
                    90.6309682,
                    55.139268
                ],
                [
                    90.6309989,
                    55.139115
                ],
                [
                    90.6309343,
                    55.1389672
                ],
                [
                    90.6308635,
                    55.138918
                ],
                [
                    90.6305558,
                    55.1387948
                ],
                [
                    90.6294572,
                    55.1384553
                ],
                [
                    90.6290109,
                    55.1381967
                ],
                [
                    90.6285216,
                    55.1380437
                ],
                [
                    90.6275861,
                    55.137808
                ],
                [
                    90.6271799,
                    55.1377464
                ],
                [
                    90.626549,
                    55.1377464
                ],
                [
                    90.6262628,
                    55.1377623
                ],
                [
                    90.625915,
                    55.1378361
                ],
                [
                    90.625515,
                    55.1378696
                ],
                [
                    90.6251518,
                    55.1377587
                ],
                [
                    90.6251303,
                    55.1376602
                ],
                [
                    90.6252226,
                    55.137567
                ],
                [
                    90.6243332,
                    55.1367684
                ],
                [
                    90.6241332,
                    55.1365203
                ],
                [
                    90.6240132,
                    55.1362547
                ],
                [
                    90.6239793,
                    55.1360348
                ],
                [
                    90.6241732,
                    55.1357956
                ],
                [
                    90.6242317,
                    55.1356531
                ],
                [
                    90.6242994,
                    55.1350849
                ],
                [
                    90.624441,
                    55.1347401
                ],
                [
                    90.6246995,
                    55.1344234
                ],
                [
                    90.625038,
                    55.1342176
                ],
                [
                    90.6253026,
                    55.1336687
                ],
                [
                    90.6250349,
                    55.1332869
                ],
                [
                    90.624841,
                    55.1331515
                ],
                [
                    90.6245487,
                    55.1330494
                ],
                [
                    90.624124,
                    55.1329738
                ],
                [
                    90.6234346,
                    55.1331638
                ],
                [
                    90.6231115,
                    55.1332992
                ],
                [
                    90.6228315,
                    55.1333731
                ],
                [
                    90.621979,
                    55.1334752
                ],
                [
                    90.6209665,
                    55.1335209
                ],
                [
                    90.6204095,
                    55.1335332
                ],
                [
                    90.6200372,
                    55.1334769
                ],
                [
                    90.6192032,
                    55.1332834
                ],
                [
                    90.6186277,
                    55.1331532
                ],
                [
                    90.6182923,
                    55.1331216
                ],
                [
                    90.6179691,
                    55.133023
                ],
                [
                    90.6177968,
                    55.1329122
                ],
                [
                    90.6176829,
                    55.1328981
                ],
                [
                    90.6172859,
                    55.1326729
                ],
                [
                    90.6167812,
                    55.1322718
                ],
                [
                    90.6162735,
                    55.1319903
                ],
                [
                    90.6157842,
                    55.1313306
                ],
                [
                    90.6153564,
                    55.1304632
                ],
                [
                    90.6153964,
                    55.1302134
                ],
                [
                    90.614984,
                    55.1301993
                ],
                [
                    90.6144732,
                    55.1300585
                ],
                [
                    90.6140454,
                    55.1299934
                ],
                [
                    90.6137561,
                    55.1300058
                ],
                [
                    90.6133561,
                    55.130106
                ],
                [
                    90.6131991,
                    55.1301518
                ],
                [
                    90.612279,
                    55.130136
                ],
                [
                    90.610411,
                    55.1295641
                ],
                [
                    90.6101155,
                    55.1295483
                ],
                [
                    90.6097216,
                    55.1295694
                ],
                [
                    90.6092446,
                    55.1296785
                ],
                [
                    90.6088569,
                    55.1298245
                ],
                [
                    90.6085337,
                    55.1298298
                ],
                [
                    90.6082383,
                    55.1297418
                ],
                [
                    90.6080414,
                    55.1296081
                ],
                [
                    90.6078629,
                    55.1293407
                ],
                [
                    90.6077552,
                    55.1293073
                ],
                [
                    90.6075028,
                    55.1292897
                ],
                [
                    90.6070566,
                    55.1293952
                ],
                [
                    90.6058718,
                    55.1296099
                ],
                [
                    90.6044938,
                    55.1297839
                ],
                [
                    90.6033782,
                    55.1297993
                ],
                [
                    90.6031551,
                    55.1299159
                ],
                [
                    90.6029589,
                    55.1301732
                ],
                [
                    90.6025281,
                    55.1309803
                ],
                [
                    90.602455,
                    55.1317545
                ],
                [
                    90.6025896,
                    55.1321569
                ],
                [
                    90.6029474,
                    55.1324648
                ],
                [
                    90.6032859,
                    55.1326869
                ],
                [
                    90.6036475,
                    55.1328144
                ],
                [
                    90.6044669,
                    55.132931
                ],
                [
                    90.6082098,
                    55.1332015
                ],
                [
                    90.6094215,
                    55.1333928
                ],
                [
                    90.6094984,
                    55.1335094
                ],
                [
                    90.6094177,
                    55.1336281
                ],
                [
                    90.6091715,
                    55.1337688
                ],
                [
                    90.6081944,
                    55.1340789
                ],
                [
                    90.6072712,
                    55.1345341
                ],
                [
                    90.6056401,
                    55.1353807
                ],
                [
                    90.6043976,
                    55.1362053
                ],
                [
                    90.6034282,
                    55.1373488
                ],
                [
                    90.6027627,
                    55.137938
                ],
                [
                    90.6015202,
                    55.1388769
                ],
                [
                    90.6004085,
                    55.1395542
                ]
            ],
            "longitude": 90.617104,
            "latitude": 55.141556
        },
        "6433": {
            "name": "Шпагино-1",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    90.6155012,
                    57.2136099
                ],
                [
                    90.6164642,
                    57.2141282
                ],
                [
                    90.6207891,
                    57.2155725
                ],
                [
                    90.6244311,
                    57.2159233
                ],
                [
                    90.6257326,
                    57.2121434
                ],
                [
                    90.6240634,
                    57.2105345
                ],
                [
                    90.6197152,
                    57.2120896
                ],
                [
                    90.619721,
                    57.2116914
                ],
                [
                    90.6191257,
                    57.2116851
                ],
                [
                    90.6191196,
                    57.2122905
                ],
                [
                    90.6155012,
                    57.2136099
                ]
            ],
            "longitude": 90.620621,
            "latitude": 57.214169
        },
        "6434": {
            "name": "Саросека",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    90.6172605,
                    56.3109345
                ],
                [
                    90.6173206,
                    56.3110512
                ],
                [
                    90.6177215,
                    56.3114292
                ],
                [
                    90.6179119,
                    56.311985
                ],
                [
                    90.617962,
                    56.3123685
                ],
                [
                    90.6183628,
                    56.3123629
                ],
                [
                    90.6186935,
                    56.3125741
                ],
                [
                    90.6189841,
                    56.3127631
                ],
                [
                    90.6192246,
                    56.3128187
                ],
                [
                    90.6194751,
                    56.3127631
                ],
                [
                    90.6200563,
                    56.3126075
                ],
                [
                    90.6207176,
                    56.3124408
                ],
                [
                    90.6212988,
                    56.3124185
                ],
                [
                    90.6236737,
                    56.3123907
                ],
                [
                    90.6239743,
                    56.3123574
                ],
                [
                    90.6240143,
                    56.3122685
                ],
                [
                    90.6240344,
                    56.3120906
                ],
                [
                    90.6273612,
                    56.3091002
                ],
                [
                    90.6267699,
                    56.3074549
                ],
                [
                    90.6260285,
                    56.3069824
                ],
                [
                    90.6236637,
                    56.3069935
                ],
                [
                    90.6190041,
                    56.3095282
                ],
                [
                    90.6178417,
                    56.3100396
                ],
                [
                    90.6172605,
                    56.3109345
                ]
            ],
            "longitude": 90.622993,
            "latitude": 56.309826
        },
        "6435": {
            "name": "Орловка",
            "population": 145,
            "type": "hamlet",
            "poly": [
                [
                    90.6232367,
                    56.2433538
                ],
                [
                    90.6240815,
                    56.2446257
                ],
                [
                    90.6258742,
                    56.2443007
                ],
                [
                    90.6258463,
                    56.2439518
                ],
                [
                    90.6288182,
                    56.2435642
                ],
                [
                    90.6287624,
                    56.2430525
                ],
                [
                    90.6293345,
                    56.2419593
                ],
                [
                    90.6301298,
                    56.2412149
                ],
                [
                    90.6290833,
                    56.2408583
                ],
                [
                    90.629617,
                    56.2400283
                ],
                [
                    90.630126,
                    56.2400532
                ],
                [
                    90.6300367,
                    56.2397405
                ],
                [
                    90.629599,
                    56.2392741
                ],
                [
                    90.6282597,
                    56.2388572
                ],
                [
                    90.6277774,
                    56.2385247
                ],
                [
                    90.6279828,
                    56.2380185
                ],
                [
                    90.6292687,
                    56.2375818
                ],
                [
                    90.6317691,
                    56.2379937
                ],
                [
                    90.6351088,
                    56.2365793
                ],
                [
                    90.6367162,
                    56.2353386
                ],
                [
                    90.6333049,
                    56.2331647
                ],
                [
                    90.6320548,
                    56.2337206
                ],
                [
                    90.6327127,
                    56.2355947
                ],
                [
                    90.6279512,
                    56.236751
                ],
                [
                    90.626098,
                    56.2377203
                ],
                [
                    90.6245175,
                    56.2384775
                ],
                [
                    90.6240815,
                    56.239371
                ],
                [
                    90.623809,
                    56.2413852
                ],
                [
                    90.6232639,
                    56.2422786
                ],
                [
                    90.6232367,
                    56.2433538
                ]
            ],
            "longitude": 90.626648,
            "latitude": 56.239712
        },
        "6436": {
            "name": "Красный Луг",
            "population": 85,
            "type": "hamlet",
            "poly": [
                [
                    90.6233962,
                    56.7082397
                ],
                [
                    90.6247953,
                    56.70864
                ],
                [
                    90.6253259,
                    56.7087653
                ],
                [
                    90.6257587,
                    56.7087539
                ],
                [
                    90.6269177,
                    56.7082658
                ],
                [
                    90.6271578,
                    56.7083894
                ],
                [
                    90.6271282,
                    56.7085066
                ],
                [
                    90.6271548,
                    56.7086286
                ],
                [
                    90.6276943,
                    56.7090012
                ],
                [
                    90.6279529,
                    56.7091581
                ],
                [
                    90.6283003,
                    56.7090826
                ],
                [
                    90.6290166,
                    56.7091144
                ],
                [
                    90.6301819,
                    56.7086258
                ],
                [
                    90.6309056,
                    56.7083358
                ],
                [
                    90.6317161,
                    56.7082167
                ],
                [
                    90.6331055,
                    56.7077082
                ],
                [
                    90.6334385,
                    56.7075135
                ],
                [
                    90.6334385,
                    56.7071203
                ],
                [
                    90.6337569,
                    56.7068263
                ],
                [
                    90.6340464,
                    56.7066118
                ],
                [
                    90.6340175,
                    56.7064608
                ],
                [
                    90.6323964,
                    56.7054478
                ],
                [
                    90.6291325,
                    56.7034098
                ],
                [
                    90.6285536,
                    56.7030085
                ],
                [
                    90.6286766,
                    56.7025675
                ],
                [
                    90.6290182,
                    56.7023207
                ],
                [
                    90.6287466,
                    56.7021898
                ],
                [
                    90.6281528,
                    56.7017504
                ],
                [
                    90.6275728,
                    56.7020433
                ],
                [
                    90.6269829,
                    56.7022109
                ],
                [
                    90.6270541,
                    56.7024062
                ],
                [
                    90.6272438,
                    56.7025527
                ],
                [
                    90.627143,
                    56.7028732
                ],
                [
                    90.6271756,
                    56.7033517
                ],
                [
                    90.6274068,
                    56.7035469
                ],
                [
                    90.6273179,
                    56.7037536
                ],
                [
                    90.6271163,
                    56.7038106
                ],
                [
                    90.6275194,
                    56.7040481
                ],
                [
                    90.6277507,
                    56.70397
                ],
                [
                    90.628305,
                    56.7043882
                ],
                [
                    90.6279404,
                    56.704743
                ],
                [
                    90.6294699,
                    56.7055956
                ],
                [
                    90.6273416,
                    56.7064792
                ],
                [
                    90.6269355,
                    56.7067883
                ],
                [
                    90.6255779,
                    56.7073985
                ],
                [
                    90.6252726,
                    56.707174
                ],
                [
                    90.6233962,
                    56.7082397
                ]
            ],
            "longitude": 90.6303135,
            "latitude": 56.706923
        },
        "6437": {
            "name": "Новоалександровка",
            "population": 109,
            "type": "hamlet",
            "poly": [
                [
                    90.6253014,
                    55.5908239
                ],
                [
                    90.626638,
                    55.5910914
                ],
                [
                    90.6281687,
                    55.5912928
                ],
                [
                    90.6285463,
                    55.592411
                ],
                [
                    90.6284939,
                    55.5933175
                ],
                [
                    90.6299303,
                    55.5937263
                ],
                [
                    90.6312094,
                    55.5923873
                ],
                [
                    90.631482,
                    55.5925651
                ],
                [
                    90.6334741,
                    55.5930331
                ],
                [
                    90.6338619,
                    55.5928791
                ],
                [
                    90.6336733,
                    55.5926006
                ],
                [
                    90.6341555,
                    55.5921741
                ],
                [
                    90.6351306,
                    55.5907877
                ],
                [
                    90.6356129,
                    55.590527
                ],
                [
                    90.6357702,
                    55.5902367
                ],
                [
                    90.6363363,
                    55.5897805
                ],
                [
                    90.636546,
                    55.5897508
                ],
                [
                    90.6367976,
                    55.5887021
                ],
                [
                    90.6369571,
                    55.5884062
                ],
                [
                    90.6372528,
                    55.588351
                ],
                [
                    90.6380916,
                    55.5873081
                ],
                [
                    90.639231,
                    55.5856119
                ],
                [
                    90.6392048,
                    55.5852767
                ],
                [
                    90.6391131,
                    55.5851138
                ],
                [
                    90.6399256,
                    55.5852545
                ],
                [
                    90.6414458,
                    55.5852545
                ],
                [
                    90.6422882,
                    55.5844805
                ],
                [
                    90.6420179,
                    55.5843277
                ],
                [
                    90.6412895,
                    55.5842529
                ],
                [
                    90.640826,
                    55.5840034
                ],
                [
                    90.6400534,
                    55.5837913
                ],
                [
                    90.6391264,
                    55.5839036
                ],
                [
                    90.6384201,
                    55.5837538
                ],
                [
                    90.6383098,
                    55.5832798
                ],
                [
                    90.6349768,
                    55.5832299
                ],
                [
                    90.6329903,
                    55.5837538
                ],
                [
                    90.6310259,
                    55.5839909
                ],
                [
                    90.6301209,
                    55.5849889
                ],
                [
                    90.6273398,
                    55.5875462
                ],
                [
                    90.6253532,
                    55.5902655
                ],
                [
                    90.6253014,
                    55.5908239
                ]
            ],
            "longitude": 90.633209,
            "latitude": 55.587627
        },
        "6438": {
            "name": "Ладановка",
            "population": 20,
            "type": "hamlet",
            "poly": [
                [
                    90.616953,
                    56.0633417
                ],
                [
                    90.6186696,
                    56.064076
                ],
                [
                    90.6198065,
                    56.0642876
                ],
                [
                    90.6316666,
                    56.0657437
                ],
                [
                    90.6371284,
                    56.0663037
                ],
                [
                    90.6393578,
                    56.0661668
                ],
                [
                    90.6398928,
                    56.0659179
                ],
                [
                    90.6441954,
                    56.065781
                ],
                [
                    90.6447527,
                    56.0641258
                ],
                [
                    90.6444183,
                    56.0639018
                ],
                [
                    90.6435712,
                    56.0640511
                ],
                [
                    90.6432814,
                    56.0636155
                ],
                [
                    90.6416317,
                    56.0634786
                ],
                [
                    90.6412081,
                    56.0629434
                ],
                [
                    90.639759,
                    56.0625576
                ],
                [
                    90.6371284,
                    56.0625203
                ],
                [
                    90.6346762,
                    56.0620473
                ],
                [
                    90.6331825,
                    56.0624829
                ],
                [
                    90.6307748,
                    56.0616615
                ],
                [
                    90.630708,
                    56.0612632
                ],
                [
                    90.6287684,
                    56.0607529
                ],
                [
                    90.6272525,
                    56.0610018
                ],
                [
                    90.6262716,
                    56.0617486
                ],
                [
                    90.6242652,
                    56.0616117
                ],
                [
                    90.6242429,
                    56.061313
                ],
                [
                    90.6231282,
                    56.0611761
                ],
                [
                    90.6227047,
                    56.0609769
                ],
                [
                    90.6215454,
                    56.0609022
                ],
                [
                    90.6207651,
                    56.0611761
                ],
                [
                    90.6194498,
                    56.0619851
                ],
                [
                    90.6173989,
                    56.0617362
                ],
                [
                    90.6170422,
                    56.0625825
                ],
                [
                    90.616953,
                    56.0633417
                ]
            ],
            "longitude": 90.634895,
            "latitude": 56.06414
        },
        "6439": {
            "name": "Ильинка",
            "population": 55,
            "type": "hamlet",
            "poly": [
                [
                    90.628289,
                    56.2967507
                ],
                [
                    90.6289912,
                    56.2978042
                ],
                [
                    90.6296834,
                    56.2981735
                ],
                [
                    90.6298697,
                    56.2990302
                ],
                [
                    90.6353804,
                    56.2989564
                ],
                [
                    90.6370044,
                    56.2985575
                ],
                [
                    90.6384952,
                    56.2980405
                ],
                [
                    90.6427547,
                    56.2975383
                ],
                [
                    90.6439527,
                    56.2977303
                ],
                [
                    90.6446448,
                    56.297494
                ],
                [
                    90.6457097,
                    56.2977746
                ],
                [
                    90.6464019,
                    56.297686
                ],
                [
                    90.6472271,
                    56.297361
                ],
                [
                    90.6480258,
                    56.2973758
                ],
                [
                    90.6508477,
                    56.2969917
                ],
                [
                    90.6511406,
                    56.2944361
                ],
                [
                    90.6495166,
                    56.2944951
                ],
                [
                    90.6459493,
                    56.2951008
                ],
                [
                    90.6401457,
                    56.2949531
                ],
                [
                    90.6379627,
                    56.2954406
                ],
                [
                    90.6375634,
                    56.2952781
                ],
                [
                    90.6353804,
                    56.2954849
                ],
                [
                    90.6328514,
                    56.2953667
                ],
                [
                    90.6318663,
                    56.2958247
                ],
                [
                    90.6300561,
                    56.2962088
                ],
                [
                    90.629923,
                    56.2965042
                ],
                [
                    90.628289,
                    56.2967507
                ]
            ],
            "longitude": 90.641182,
            "latitude": 56.296459
        },
        "6440": {
            "name": "Тальники",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    90.633131,
                    55.2793467
                ],
                [
                    90.6331724,
                    55.2811208
                ],
                [
                    90.6338382,
                    55.281125
                ],
                [
                    90.6345755,
                    55.2812815
                ],
                [
                    90.6358395,
                    55.2815793
                ],
                [
                    90.6371825,
                    55.2819628
                ],
                [
                    90.6388227,
                    55.2825991
                ],
                [
                    90.6398271,
                    55.2828648
                ],
                [
                    90.6400942,
                    55.2828841
                ],
                [
                    90.6404967,
                    55.2827705
                ],
                [
                    90.6410234,
                    55.2824663
                ],
                [
                    90.6413168,
                    55.2822156
                ],
                [
                    90.6417344,
                    55.2819842
                ],
                [
                    90.6430096,
                    55.2814614
                ],
                [
                    90.649709,
                    55.28177
                ],
                [
                    90.6502215,
                    55.2817834
                ],
                [
                    90.6503861,
                    55.2817405
                ],
                [
                    90.6507106,
                    55.2815343
                ],
                [
                    90.6507623,
                    55.2810737
                ],
                [
                    90.6509081,
                    55.2787221
                ],
                [
                    90.6505789,
                    55.2777391
                ],
                [
                    90.6505695,
                    55.2773695
                ],
                [
                    90.6506824,
                    55.2769785
                ],
                [
                    90.6508422,
                    55.2757892
                ],
                [
                    90.6511244,
                    55.275149
                ],
                [
                    90.6511338,
                    55.2749695
                ],
                [
                    90.6500052,
                    55.2747526
                ],
                [
                    90.6481384,
                    55.2742972
                ],
                [
                    90.6438083,
                    55.2730228
                ],
                [
                    90.6378333,
                    55.2760318
                ],
                [
                    90.6375023,
                    55.2761261
                ],
                [
                    90.6371487,
                    55.2761475
                ],
                [
                    90.6368402,
                    55.2760725
                ],
                [
                    90.6363888,
                    55.276079
                ],
                [
                    90.6358922,
                    55.2762225
                ],
                [
                    90.6355687,
                    55.2764668
                ],
                [
                    90.6354445,
                    55.2765782
                ],
                [
                    90.6353354,
                    55.276604
                ],
                [
                    90.6353505,
                    55.2771504
                ],
                [
                    90.6352865,
                    55.2772704
                ],
                [
                    90.6348878,
                    55.2775446
                ],
                [
                    90.6349179,
                    55.2778768
                ],
                [
                    90.6348426,
                    55.2780096
                ],
                [
                    90.6346884,
                    55.2781618
                ],
                [
                    90.6346846,
                    55.2785667
                ],
                [
                    90.6345078,
                    55.2787831
                ],
                [
                    90.6342821,
                    55.2789803
                ],
                [
                    90.6339849,
                    55.2791474
                ],
                [
                    90.6334884,
                    55.2792095
                ],
                [
                    90.633131,
                    55.2793467
                ]
            ],
            "longitude": 90.643387,
            "latitude": 55.277599
        },
        "6441": {
            "name": "Нижнешадрино",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.6449528,
            "latitude": 59.9173436
        },
        "6442": {
            "name": "Кумыры",
            "population": 70,
            "type": "hamlet",
            "poly": [
                [
                    90.6410869,
                    56.7510438
                ],
                [
                    90.6413479,
                    56.7513478
                ],
                [
                    90.643006,
                    56.7515632
                ],
                [
                    90.6428722,
                    56.752081
                ],
                [
                    90.6435967,
                    56.7521157
                ],
                [
                    90.6437931,
                    56.751417
                ],
                [
                    90.6442565,
                    56.7513839
                ],
                [
                    90.6452386,
                    56.7514198
                ],
                [
                    90.6456316,
                    56.7512955
                ],
                [
                    90.6463166,
                    56.7509917
                ],
                [
                    90.646503,
                    56.7507073
                ],
                [
                    90.6466894,
                    56.7500749
                ],
                [
                    90.6466289,
                    56.7486691
                ],
                [
                    90.6464174,
                    56.7480422
                ],
                [
                    90.6468002,
                    56.7476307
                ],
                [
                    90.6471578,
                    56.7473849
                ],
                [
                    90.6476917,
                    56.7472137
                ],
                [
                    90.6478831,
                    56.7471198
                ],
                [
                    90.6479486,
                    56.7469043
                ],
                [
                    90.6477874,
                    56.7466005
                ],
                [
                    90.6472837,
                    56.7463243
                ],
                [
                    90.6464677,
                    56.7460288
                ],
                [
                    90.6464476,
                    56.7458575
                ],
                [
                    90.6460698,
                    56.7456255
                ],
                [
                    90.6469058,
                    56.7450345
                ],
                [
                    90.6465383,
                    56.7448411
                ],
                [
                    90.6467951,
                    56.7445041
                ],
                [
                    90.6474096,
                    56.7446616
                ],
                [
                    90.6481752,
                    56.7447942
                ],
                [
                    90.6487797,
                    56.7448356
                ],
                [
                    90.6493841,
                    56.7447914
                ],
                [
                    90.6502958,
                    56.744529
                ],
                [
                    90.6515953,
                    56.7438136
                ],
                [
                    90.6522501,
                    56.743565
                ],
                [
                    90.6532826,
                    56.7433137
                ],
                [
                    90.6524465,
                    56.7426977
                ],
                [
                    90.6537712,
                    56.7419519
                ],
                [
                    90.6542145,
                    56.7416756
                ],
                [
                    90.6544964,
                    56.7412779
                ],
                [
                    90.6547484,
                    56.7405376
                ],
                [
                    90.6540785,
                    56.7403967
                ],
                [
                    90.6532323,
                    56.7402613
                ],
                [
                    90.6526178,
                    56.7402061
                ],
                [
                    90.6526732,
                    56.7400431
                ],
                [
                    90.6521599,
                    56.7399303
                ],
                [
                    90.651915,
                    56.7403971
                ],
                [
                    90.6511219,
                    56.7413235
                ],
                [
                    90.6499453,
                    56.7410795
                ],
                [
                    90.6496874,
                    56.7410795
                ],
                [
                    90.6489428,
                    56.7412899
                ],
                [
                    90.6489396,
                    56.7413977
                ],
                [
                    90.6490202,
                    56.7414508
                ],
                [
                    90.6490459,
                    56.7416169
                ],
                [
                    90.6490814,
                    56.7418697
                ],
                [
                    90.6490363,
                    56.742089
                ],
                [
                    90.6488042,
                    56.7421844
                ],
                [
                    90.6493811,
                    56.7425168
                ],
                [
                    90.649075,
                    56.7426759
                ],
                [
                    90.648759,
                    56.7428703
                ],
                [
                    90.6486527,
                    56.7431196
                ],
                [
                    90.6484399,
                    56.7432946
                ],
                [
                    90.6482884,
                    56.7434078
                ],
                [
                    90.6480595,
                    56.7434643
                ],
                [
                    90.6477467,
                    56.7434908
                ],
                [
                    90.6474341,
                    56.7434679
                ],
                [
                    90.646828,
                    56.7430507
                ],
                [
                    90.6462962,
                    56.7432822
                ],
                [
                    90.645039,
                    56.7435792
                ],
                [
                    90.6447392,
                    56.7437525
                ],
                [
                    90.6448843,
                    56.7438338
                ],
                [
                    90.6442814,
                    56.7443146
                ],
                [
                    90.6438334,
                    56.7441467
                ],
                [
                    90.6436625,
                    56.7441591
                ],
                [
                    90.6431467,
                    56.7443677
                ],
                [
                    90.6426664,
                    56.7444967
                ],
                [
                    90.6424214,
                    56.7448008
                ],
                [
                    90.6418992,
                    56.7452109
                ],
                [
                    90.6416607,
                    56.7452215
                ],
                [
                    90.6415156,
                    56.7453611
                ],
                [
                    90.6415317,
                    56.746351
                ],
                [
                    90.6416091,
                    56.7466621
                ],
                [
                    90.6417896,
                    56.7468619
                ],
                [
                    90.6414769,
                    56.7482318
                ],
                [
                    90.6412448,
                    56.748907
                ],
                [
                    90.6412899,
                    56.7493895
                ],
                [
                    90.641406,
                    56.7496299
                ],
                [
                    90.6417606,
                    56.7498172
                ],
                [
                    90.6421829,
                    56.7501566
                ],
                [
                    90.6422441,
                    56.750321
                ],
                [
                    90.6421087,
                    56.750579
                ],
                [
                    90.6419314,
                    56.7507434
                ],
                [
                    90.641464,
                    56.7508017
                ],
                [
                    90.6410869,
                    56.7510438
                ]
            ],
            "longitude": 90.6449891,
            "latitude": 56.7464614
        },
        "6443": {
            "name": "Шуточкино",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    90.6424253,
                    56.8635331
                ],
                [
                    90.6432793,
                    56.8643519
                ],
                [
                    90.6453791,
                    56.8643901
                ],
                [
                    90.6461141,
                    56.8642237
                ],
                [
                    90.646625,
                    56.8639425
                ],
                [
                    90.647178,
                    56.8639176
                ],
                [
                    90.6481019,
                    56.8637722
                ],
                [
                    90.648461,
                    56.863638
                ],
                [
                    90.6485498,
                    56.8636975
                ],
                [
                    90.6486301,
                    56.8636685
                ],
                [
                    90.6490601,
                    56.8639483
                ],
                [
                    90.6496952,
                    56.8639036
                ],
                [
                    90.6498228,
                    56.8641677
                ],
                [
                    90.6506685,
                    56.8640838
                ],
                [
                    90.6515702,
                    56.8638879
                ],
                [
                    90.6529196,
                    56.8645001
                ],
                [
                    90.6532464,
                    56.864512
                ],
                [
                    90.6533198,
                    56.8644901
                ],
                [
                    90.6534276,
                    56.8645572
                ],
                [
                    90.6535476,
                    56.8645773
                ],
                [
                    90.6538378,
                    56.8645127
                ],
                [
                    90.6539328,
                    56.8646253
                ],
                [
                    90.6553823,
                    56.86421
                ],
                [
                    90.654594,
                    56.8637212
                ],
                [
                    90.6547767,
                    56.8634499
                ],
                [
                    90.6549326,
                    56.8633422
                ],
                [
                    90.6551978,
                    56.8633324
                ],
                [
                    90.6550599,
                    56.8628857
                ],
                [
                    90.6547803,
                    56.8628544
                ],
                [
                    90.6545134,
                    56.8620171
                ],
                [
                    90.6543683,
                    56.8618084
                ],
                [
                    90.6541533,
                    56.8618368
                ],
                [
                    90.6540619,
                    56.8617545
                ],
                [
                    90.6539972,
                    56.8614804
                ],
                [
                    90.6542822,
                    56.8601992
                ],
                [
                    90.6543091,
                    56.8599935
                ],
                [
                    90.6542661,
                    56.8597565
                ],
                [
                    90.6542428,
                    56.8596556
                ],
                [
                    90.6539255,
                    56.8590688
                ],
                [
                    90.6534275,
                    56.8586623
                ],
                [
                    90.6533755,
                    56.8584046
                ],
                [
                    90.6530941,
                    56.8580955
                ],
                [
                    90.6529642,
                    56.8577
                ],
                [
                    90.6529306,
                    56.8573987
                ],
                [
                    90.6528186,
                    56.8573253
                ],
                [
                    90.6516296,
                    56.8574529
                ],
                [
                    90.6513776,
                    56.8578145
                ],
                [
                    90.6511571,
                    56.8580307
                ],
                [
                    90.6492393,
                    56.8580499
                ],
                [
                    90.6492498,
                    56.8584249
                ],
                [
                    90.6495123,
                    56.8586698
                ],
                [
                    90.6493723,
                    56.859129
                ],
                [
                    90.6493583,
                    56.8597565
                ],
                [
                    90.6490923,
                    56.860055
                ],
                [
                    90.6491762,
                    56.8601143
                ],
                [
                    90.6485254,
                    56.8606787
                ],
                [
                    90.6479829,
                    56.8609944
                ],
                [
                    90.6481859,
                    56.8611455
                ],
                [
                    90.6484028,
                    56.8613674
                ],
                [
                    90.6480143,
                    56.8614593
                ],
                [
                    90.6467825,
                    56.8618955
                ],
                [
                    90.6461701,
                    56.862192
                ],
                [
                    90.6441437,
                    56.8627143
                ],
                [
                    90.6442452,
                    56.8629745
                ],
                [
                    90.6435908,
                    56.8631026
                ],
                [
                    90.6424253,
                    56.8635331
                ]
            ],
            "longitude": 90.650482,
            "latitude": 56.861656
        },
        "6444": {
            "name": "Тимонино",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.655151,
            "latitude": 56.366398
        },
        "6445": {
            "name": "Холма",
            "population": 114,
            "type": "hamlet",
            "poly": [
                [
                    90.6356422,
                    55.7985346
                ],
                [
                    90.636503,
                    55.798658
                ],
                [
                    90.6385143,
                    55.7988357
                ],
                [
                    90.6423702,
                    55.7994183
                ],
                [
                    90.643837,
                    55.7998922
                ],
                [
                    90.6467724,
                    55.8013896
                ],
                [
                    90.6481173,
                    55.8022073
                ],
                [
                    90.6509032,
                    55.8036496
                ],
                [
                    90.6530304,
                    55.8047372
                ],
                [
                    90.655185,
                    55.8061795
                ],
                [
                    90.6560771,
                    55.8067795
                ],
                [
                    90.6584705,
                    55.8079642
                ],
                [
                    90.6581301,
                    55.8084516
                ],
                [
                    90.6574385,
                    55.8092228
                ],
                [
                    90.6599417,
                    55.8099199
                ],
                [
                    90.6615995,
                    55.8092228
                ],
                [
                    90.6630268,
                    55.8088588
                ],
                [
                    90.6638831,
                    55.8088896
                ],
                [
                    90.6677586,
                    55.8099693
                ],
                [
                    90.6694056,
                    55.8109441
                ],
                [
                    90.6721174,
                    55.80963
                ],
                [
                    90.6721393,
                    55.8092721
                ],
                [
                    90.6714147,
                    55.809266
                ],
                [
                    90.6711183,
                    55.8090192
                ],
                [
                    90.6703827,
                    55.8087539
                ],
                [
                    90.6708768,
                    55.8082295
                ],
                [
                    90.6710413,
                    55.8080567
                ],
                [
                    90.6712281,
                    55.8077297
                ],
                [
                    90.6717989,
                    55.8076433
                ],
                [
                    90.6718978,
                    55.8074706
                ],
                [
                    90.6722491,
                    55.8071312
                ],
                [
                    90.6730506,
                    55.8070633
                ],
                [
                    90.6730726,
                    55.8069276
                ],
                [
                    90.6724875,
                    55.8068519
                ],
                [
                    90.6713128,
                    55.8069691
                ],
                [
                    90.6708516,
                    55.807074
                ],
                [
                    90.6706211,
                    55.8069321
                ],
                [
                    90.6704784,
                    55.806747
                ],
                [
                    90.6709175,
                    55.8060436
                ],
                [
                    90.6703247,
                    55.805803
                ],
                [
                    90.6699074,
                    55.8055747
                ],
                [
                    90.6695342,
                    55.8057475
                ],
                [
                    90.6691389,
                    55.8058462
                ],
                [
                    90.6686778,
                    55.8058462
                ],
                [
                    90.6680959,
                    55.8056672
                ],
                [
                    90.6667126,
                    55.8053896
                ],
                [
                    90.6659331,
                    55.8049392
                ],
                [
                    90.6641435,
                    55.8044949
                ],
                [
                    90.6635395,
                    55.8040691
                ],
                [
                    90.6629138,
                    55.8039272
                ],
                [
                    90.6623649,
                    55.8036248
                ],
                [
                    90.6622331,
                    55.8032916
                ],
                [
                    90.6616952,
                    55.8032546
                ],
                [
                    90.6611462,
                    55.8030818
                ],
                [
                    90.6606522,
                    55.8030201
                ],
                [
                    90.6601691,
                    55.8027239
                ],
                [
                    90.6601142,
                    55.8021994
                ],
                [
                    90.6598727,
                    55.8017366
                ],
                [
                    90.6601032,
                    55.8015885
                ],
                [
                    90.6594664,
                    55.8011812
                ],
                [
                    90.6588955,
                    55.8008048
                ],
                [
                    90.6587967,
                    55.8003728
                ],
                [
                    90.6585881,
                    55.8002432
                ],
                [
                    90.6579623,
                    55.8002556
                ],
                [
                    90.6577427,
                    55.8001754
                ],
                [
                    90.6577098,
                    55.7999717
                ],
                [
                    90.657051,
                    55.7998545
                ],
                [
                    90.6568424,
                    55.7997372
                ],
                [
                    90.6564472,
                    55.7997742
                ],
                [
                    90.6562386,
                    55.7996076
                ],
                [
                    90.6563045,
                    55.7994472
                ],
                [
                    90.656546,
                    55.7993176
                ],
                [
                    90.6556787,
                    55.7991941
                ],
                [
                    90.655525,
                    55.7993608
                ],
                [
                    90.6551407,
                    55.7993793
                ],
                [
                    90.6547564,
                    55.7992312
                ],
                [
                    90.6546796,
                    55.7990831
                ],
                [
                    90.6535817,
                    55.7990769
                ],
                [
                    90.6532743,
                    55.7991016
                ],
                [
                    90.6505844,
                    55.7987868
                ],
                [
                    90.6502331,
                    55.7986202
                ],
                [
                    90.6499806,
                    55.7982623
                ],
                [
                    90.6494646,
                    55.7992003
                ],
                [
                    90.6488827,
                    55.7997372
                ],
                [
                    90.648535,
                    55.8000457
                ],
                [
                    90.6484106,
                    55.800089
                ],
                [
                    90.6479934,
                    55.7999285
                ],
                [
                    90.6475103,
                    55.7995644
                ],
                [
                    90.645062,
                    55.7970897
                ],
                [
                    90.6442715,
                    55.7962442
                ],
                [
                    90.6436896,
                    55.7959171
                ],
                [
                    90.6425697,
                    55.7954357
                ],
                [
                    90.6407541,
                    55.7953451
                ],
                [
                    90.6402359,
                    55.7950488
                ],
                [
                    90.6388745,
                    55.7947674
                ],
                [
                    90.6371793,
                    55.7947674
                ],
                [
                    90.6364766,
                    55.7950093
                ],
                [
                    90.6366699,
                    55.7956117
                ],
                [
                    90.6364679,
                    55.796377
                ],
                [
                    90.6356949,
                    55.7975767
                ],
                [
                    90.6358882,
                    55.7978483
                ],
                [
                    90.6358355,
                    55.7981544
                ],
                [
                    90.6356422,
                    55.7985346
                ]
            ],
            "longitude": 90.658119,
            "latitude": 55.804779
        },
        "6446": {
            "name": "Шпагино-2",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    90.6459482,
                    57.2211005
                ],
                [
                    90.6470571,
                    57.2219971
                ],
                [
                    90.6545824,
                    57.2239932
                ],
                [
                    90.6547384,
                    57.2239912
                ],
                [
                    90.6595727,
                    57.2239679
                ],
                [
                    90.6648255,
                    57.2230611
                ],
                [
                    90.66681,
                    57.2243155
                ],
                [
                    90.6708079,
                    57.2232348
                ],
                [
                    90.6701368,
                    57.2227072
                ],
                [
                    90.6754072,
                    57.2221605
                ],
                [
                    90.6752554,
                    57.2202836
                ],
                [
                    90.674415,
                    57.2183781
                ],
                [
                    90.6690979,
                    57.2185645
                ],
                [
                    90.6605123,
                    57.219819
                ],
                [
                    90.6558955,
                    57.2214666
                ],
                [
                    90.6485907,
                    57.2191213
                ],
                [
                    90.6473618,
                    57.2205115
                ],
                [
                    90.6472978,
                    57.2205791
                ],
                [
                    90.6459482,
                    57.2211005
                ]
            ],
            "longitude": 90.660873,
            "latitude": 57.221912
        },
        "6447": {
            "name": "Новоселы",
            "population": 69,
            "type": "hamlet",
            "poly": [
                [
                    90.6560223,
                    56.8252274
                ],
                [
                    90.6566122,
                    56.8260141
                ],
                [
                    90.6577709,
                    56.8262447
                ],
                [
                    90.6584714,
                    56.8265041
                ],
                [
                    90.6624637,
                    56.8276309
                ],
                [
                    90.6627639,
                    56.8274666
                ],
                [
                    90.6633116,
                    56.8272995
                ],
                [
                    90.6639173,
                    56.8272649
                ],
                [
                    90.6650234,
                    56.8268585
                ],
                [
                    90.6661347,
                    56.8265242
                ],
                [
                    90.6668194,
                    56.8260458
                ],
                [
                    90.6669826,
                    56.8262706
                ],
                [
                    90.667246,
                    56.8266193
                ],
                [
                    90.6676884,
                    56.8269392
                ],
                [
                    90.6685205,
                    56.8266626
                ],
                [
                    90.6696793,
                    56.8258268
                ],
                [
                    90.6701322,
                    56.8253109
                ],
                [
                    90.671075,
                    56.825749
                ],
                [
                    90.6718229,
                    56.8254089
                ],
                [
                    90.6724233,
                    56.8253686
                ],
                [
                    90.6739349,
                    56.8250054
                ],
                [
                    90.6736504,
                    56.8245011
                ],
                [
                    90.6733924,
                    56.8242503
                ],
                [
                    90.6735083,
                    56.8240717
                ],
                [
                    90.6738611,
                    56.8241639
                ],
                [
                    90.6743878,
                    56.8245299
                ],
                [
                    90.6752463,
                    56.8240601
                ],
                [
                    90.6748882,
                    56.8237604
                ],
                [
                    90.6756307,
                    56.8235875
                ],
                [
                    90.6758257,
                    56.8235068
                ],
                [
                    90.6755571,
                    56.8233367
                ],
                [
                    90.675773,
                    56.8231234
                ],
                [
                    90.6762102,
                    56.8232762
                ],
                [
                    90.676463,
                    56.8232964
                ],
                [
                    90.6768738,
                    56.823109
                ],
                [
                    90.6770318,
                    56.8231955
                ],
                [
                    90.6773109,
                    56.823135
                ],
                [
                    90.6776902,
                    56.8227488
                ],
                [
                    90.6778482,
                    56.8223942
                ],
                [
                    90.677095,
                    56.8223135
                ],
                [
                    90.6767263,
                    56.8221608
                ],
                [
                    90.6764946,
                    56.8221348
                ],
                [
                    90.6764419,
                    56.8220772
                ],
                [
                    90.6765894,
                    56.8214143
                ],
                [
                    90.6768527,
                    56.8211923
                ],
                [
                    90.6771108,
                    56.8208493
                ],
                [
                    90.6777112,
                    56.8208003
                ],
                [
                    90.6782484,
                    56.8208666
                ],
                [
                    90.6783854,
                    56.8207196
                ],
                [
                    90.6783854,
                    56.8206015
                ],
                [
                    90.6781589,
                    56.8202585
                ],
                [
                    90.677532,
                    56.8201288
                ],
                [
                    90.6774163,
                    56.8199328
                ],
                [
                    90.6775532,
                    56.8196416
                ],
                [
                    90.677943,
                    56.819486
                ],
                [
                    90.6780167,
                    56.818921
                ],
                [
                    90.6782116,
                    56.8189152
                ],
                [
                    90.6781852,
                    56.8185059
                ],
                [
                    90.677532,
                    56.8184627
                ],
                [
                    90.6772003,
                    56.8183589
                ],
                [
                    90.6766345,
                    56.8182964
                ],
                [
                    90.6766509,
                    56.8176523
                ],
                [
                    90.6756305,
                    56.8176613
                ],
                [
                    90.6756097,
                    56.8182206
                ],
                [
                    90.6754728,
                    56.8191401
                ],
                [
                    90.6752832,
                    56.8195638
                ],
                [
                    90.6753938,
                    56.819682
                ],
                [
                    90.6752568,
                    56.8197512
                ],
                [
                    90.6751831,
                    56.8200279
                ],
                [
                    90.6753253,
                    56.8201489
                ],
                [
                    90.6755097,
                    56.8202786
                ],
                [
                    90.6757151,
                    56.8203593
                ],
                [
                    90.6757151,
                    56.8204487
                ],
                [
                    90.6755097,
                    56.8204948
                ],
                [
                    90.675378,
                    56.820564
                ],
                [
                    90.6751463,
                    56.8204833
                ],
                [
                    90.6749145,
                    56.8205409
                ],
                [
                    90.6741877,
                    56.8213048
                ],
                [
                    90.6729342,
                    56.8225038
                ],
                [
                    90.6724021,
                    56.8228237
                ],
                [
                    90.6720335,
                    56.8231811
                ],
                [
                    90.6709696,
                    56.8234751
                ],
                [
                    90.6695265,
                    56.8237834
                ],
                [
                    90.6679833,
                    56.8240457
                ],
                [
                    90.6662505,
                    56.8241091
                ],
                [
                    90.6651972,
                    56.8242186
                ],
                [
                    90.6642228,
                    56.8242158
                ],
                [
                    90.6635223,
                    56.8243743
                ],
                [
                    90.6599672,
                    56.8246942
                ],
                [
                    90.6572969,
                    56.8251178
                ],
                [
                    90.6569703,
                    56.8249219
                ],
                [
                    90.6560223,
                    56.8252274
                ]
            ],
            "longitude": 90.667641,
            "latitude": 56.8249985
        },
        "6448": {
            "name": "Старая Еловка",
            "population": 152,
            "type": "hamlet",
            "poly": [
                [
                    90.6598707,
                    56.8920449
                ],
                [
                    90.6599805,
                    56.8924621
                ],
                [
                    90.6599133,
                    56.8932475
                ],
                [
                    90.6606793,
                    56.8932096
                ],
                [
                    90.6606463,
                    56.8934422
                ],
                [
                    90.6617998,
                    56.8935324
                ],
                [
                    90.6634209,
                    56.8938841
                ],
                [
                    90.6641025,
                    56.8940806
                ],
                [
                    90.6644648,
                    56.8942971
                ],
                [
                    90.6658182,
                    56.894831
                ],
                [
                    90.6674518,
                    56.8959136
                ],
                [
                    90.6679235,
                    56.8964325
                ],
                [
                    90.6682379,
                    56.8972725
                ],
                [
                    90.6682276,
                    56.8976738
                ],
                [
                    90.66839,
                    56.898789
                ],
                [
                    90.6679799,
                    56.8996103
                ],
                [
                    90.6679542,
                    56.8998249
                ],
                [
                    90.6676589,
                    56.900114
                ],
                [
                    90.6674154,
                    56.900614
                ],
                [
                    90.6669263,
                    56.9012977
                ],
                [
                    90.6668224,
                    56.9015883
                ],
                [
                    90.6673725,
                    56.9020981
                ],
                [
                    90.6676162,
                    56.9026901
                ],
                [
                    90.6676771,
                    56.9030013
                ],
                [
                    90.6677416,
                    56.9033799
                ],
                [
                    90.6685383,
                    56.9033612
                ],
                [
                    90.6692437,
                    56.903191
                ],
                [
                    90.669054,
                    56.9013533
                ],
                [
                    90.6693922,
                    56.9013117
                ],
                [
                    90.6699522,
                    56.901198
                ],
                [
                    90.6701918,
                    56.9011662
                ],
                [
                    90.6705256,
                    56.9012029
                ],
                [
                    90.6708884,
                    56.9012139
                ],
                [
                    90.6711617,
                    56.9012493
                ],
                [
                    90.6713543,
                    56.9012506
                ],
                [
                    90.6715872,
                    56.9013105
                ],
                [
                    90.6718426,
                    56.9014463
                ],
                [
                    90.6721382,
                    56.901549
                ],
                [
                    90.6723846,
                    56.901708
                ],
                [
                    90.6725414,
                    56.9018817
                ],
                [
                    90.6726332,
                    56.9020651
                ],
                [
                    90.6728998,
                    56.9020541
                ],
                [
                    90.6733835,
                    56.9020358
                ],
                [
                    90.6739816,
                    56.9019954
                ],
                [
                    90.6741272,
                    56.9020272
                ],
                [
                    90.6743265,
                    56.9021679
                ],
                [
                    90.6745796,
                    56.9021557
                ],
                [
                    90.6751396,
                    56.9019379
                ],
                [
                    90.6752537,
                    56.9018438
                ],
                [
                    90.6752336,
                    56.9010744
                ],
                [
                    90.6753097,
                    56.9009998
                ],
                [
                    90.676087,
                    56.9009142
                ],
                [
                    90.6761126,
                    56.9005434
                ],
                [
                    90.6754127,
                    56.9000328
                ],
                [
                    90.6747237,
                    56.8998327
                ],
                [
                    90.6742042,
                    56.8997222
                ],
                [
                    90.6737941,
                    56.8995759
                ],
                [
                    90.6737121,
                    56.8988652
                ],
                [
                    90.6743956,
                    56.8984112
                ],
                [
                    90.6750408,
                    56.8981753
                ],
                [
                    90.6761618,
                    56.898038
                ],
                [
                    90.6759158,
                    56.8962102
                ],
                [
                    90.6744229,
                    56.8944362
                ],
                [
                    90.6738516,
                    56.8943305
                ],
                [
                    90.6740703,
                    56.8941107
                ],
                [
                    90.6742322,
                    56.8939004
                ],
                [
                    90.6741535,
                    56.8934584
                ],
                [
                    90.674206,
                    56.8919339
                ],
                [
                    90.6728715,
                    56.8877378
                ],
                [
                    90.6728715,
                    56.8874414
                ],
                [
                    90.6723502,
                    56.8868143
                ],
                [
                    90.6712233,
                    56.8861719
                ],
                [
                    90.6697569,
                    56.8850592
                ],
                [
                    90.6695014,
                    56.8847342
                ],
                [
                    90.669239,
                    56.8845774
                ],
                [
                    90.6689765,
                    56.8845086
                ],
                [
                    90.667579,
                    56.8846289
                ],
                [
                    90.6679024,
                    56.8851992
                ],
                [
                    90.6669654,
                    56.8855068
                ],
                [
                    90.6671547,
                    56.8859523
                ],
                [
                    90.6666524,
                    56.8860888
                ],
                [
                    90.6667819,
                    56.886414
                ],
                [
                    90.6672934,
                    56.8863307
                ],
                [
                    90.6676432,
                    56.8865468
                ],
                [
                    90.6676133,
                    56.8866157
                ],
                [
                    90.6667785,
                    56.8868888
                ],
                [
                    90.6667976,
                    56.8879606
                ],
                [
                    90.6662745,
                    56.8886501
                ],
                [
                    90.6658043,
                    56.8887441
                ],
                [
                    90.6656022,
                    56.8888717
                ],
                [
                    90.6662774,
                    56.8892633
                ],
                [
                    90.6661541,
                    56.8894692
                ],
                [
                    90.6658975,
                    56.8897339
                ],
                [
                    90.6657797,
                    56.8902283
                ],
                [
                    90.6655399,
                    56.8903666
                ],
                [
                    90.66455,
                    56.890659
                ],
                [
                    90.6632173,
                    56.8911178
                ],
                [
                    90.6629038,
                    56.891053
                ],
                [
                    90.6605046,
                    56.8920241
                ],
                [
                    90.6598707,
                    56.8920449
                ]
            ],
            "longitude": 90.670532,
            "latitude": 56.893341
        },
        "6449": {
            "name": "Карелино",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.682312,
            "latitude": 55.141933
        },
        "6450": {
            "name": "Турецк",
            "population": 114,
            "type": "hamlet",
            "poly": [
                [
                    90.6814153,
                    56.5764484
                ],
                [
                    90.6815346,
                    56.5766396
                ],
                [
                    90.6818957,
                    56.5769913
                ],
                [
                    90.6827387,
                    56.57673
                ],
                [
                    90.6830437,
                    56.576919
                ],
                [
                    90.6833835,
                    56.5773312
                ],
                [
                    90.6834419,
                    56.577605
                ],
                [
                    90.683713,
                    56.5780436
                ],
                [
                    90.6839883,
                    56.5781859
                ],
                [
                    90.6852971,
                    56.5781789
                ],
                [
                    90.6858309,
                    56.5780599
                ],
                [
                    90.686136,
                    56.5781533
                ],
                [
                    90.6866739,
                    56.5787132
                ],
                [
                    90.686424,
                    56.5791798
                ],
                [
                    90.6867544,
                    56.5792545
                ],
                [
                    90.6876228,
                    56.5788299
                ],
                [
                    90.6886818,
                    56.5786619
                ],
                [
                    90.6893257,
                    56.5783632
                ],
                [
                    90.6890545,
                    56.5780296
                ],
                [
                    90.6890673,
                    56.577752
                ],
                [
                    90.6891647,
                    56.577549
                ],
                [
                    90.6893846,
                    56.5774705
                ],
                [
                    90.6894799,
                    56.577138
                ],
                [
                    90.6896387,
                    56.5768318
                ],
                [
                    90.6898347,
                    56.5766422
                ],
                [
                    90.6903271,
                    56.5764789
                ],
                [
                    90.691492,
                    56.5764322
                ],
                [
                    90.6917129,
                    56.5763795
                ],
                [
                    90.6925138,
                    56.5764525
                ],
                [
                    90.6934337,
                    56.5764999
                ],
                [
                    90.6941156,
                    56.5765764
                ],
                [
                    90.6944597,
                    56.5764853
                ],
                [
                    90.695393,
                    56.5764196
                ],
                [
                    90.6960813,
                    56.5762191
                ],
                [
                    90.6961541,
                    56.5764999
                ],
                [
                    90.6965485,
                    56.5763941
                ],
                [
                    90.6970101,
                    56.5763638
                ],
                [
                    90.6971456,
                    56.5762155
                ],
                [
                    90.6972337,
                    56.5759504
                ],
                [
                    90.6971694,
                    56.5757955
                ],
                [
                    90.6971016,
                    56.5756181
                ],
                [
                    90.6971422,
                    56.5752653
                ],
                [
                    90.6972778,
                    56.5750544
                ],
                [
                    90.6975015,
                    56.5748491
                ],
                [
                    90.6980504,
                    56.5746064
                ],
                [
                    90.6987519,
                    56.574388
                ],
                [
                    90.699162,
                    56.5743077
                ],
                [
                    90.7001617,
                    56.5743842
                ],
                [
                    90.7005344,
                    56.5744888
                ],
                [
                    90.7009987,
                    56.5741042
                ],
                [
                    90.7005277,
                    56.5740333
                ],
                [
                    90.7000329,
                    56.5737458
                ],
                [
                    90.6998973,
                    56.5738037
                ],
                [
                    90.6995246,
                    56.5737103
                ],
                [
                    90.6993653,
                    56.5734098
                ],
                [
                    90.699433,
                    56.5732437
                ],
                [
                    90.6998567,
                    56.5729972
                ],
                [
                    90.700914,
                    56.5723887
                ],
                [
                    90.7019306,
                    56.5719126
                ],
                [
                    90.7019645,
                    56.5717185
                ],
                [
                    90.7021644,
                    56.5714646
                ],
                [
                    90.7015883,
                    56.5714048
                ],
                [
                    90.7010121,
                    56.5713208
                ],
                [
                    90.7004972,
                    56.5712629
                ],
                [
                    90.7007615,
                    56.5709904
                ],
                [
                    90.7009682,
                    56.5707439
                ],
                [
                    90.7009784,
                    56.5705778
                ],
                [
                    90.7008326,
                    56.57035
                ],
                [
                    90.7005277,
                    56.5699188
                ],
                [
                    90.700121,
                    56.5696947
                ],
                [
                    90.6999787,
                    56.5693045
                ],
                [
                    90.6938015,
                    56.5675322
                ],
                [
                    90.6883428,
                    56.5694563
                ],
                [
                    90.6887621,
                    56.5706097
                ],
                [
                    90.688659,
                    56.5712713
                ],
                [
                    90.6887512,
                    56.5714162
                ],
                [
                    90.6895265,
                    56.5720748
                ],
                [
                    90.6898844,
                    56.5725512
                ],
                [
                    90.6901094,
                    56.5727947
                ],
                [
                    90.6901582,
                    56.5731815
                ],
                [
                    90.6901962,
                    56.5736444
                ],
                [
                    90.6897651,
                    56.5736549
                ],
                [
                    90.6884286,
                    56.5739073
                ],
                [
                    90.6879976,
                    56.5740984
                ],
                [
                    90.6876641,
                    56.5742896
                ],
                [
                    90.6877535,
                    56.5744464
                ],
                [
                    90.6881006,
                    56.5747331
                ],
                [
                    90.688369,
                    56.5749153
                ],
                [
                    90.6886346,
                    56.5750437
                ],
                [
                    90.6877863,
                    56.5750212
                ],
                [
                    90.6873715,
                    56.5751317
                ],
                [
                    90.6867805,
                    56.5752735
                ],
                [
                    90.6864796,
                    56.5750749
                ],
                [
                    90.6852596,
                    56.5744477
                ],
                [
                    90.6851295,
                    56.5743999
                ],
                [
                    90.6846822,
                    56.5739519
                ],
                [
                    90.6848991,
                    56.5736965
                ],
                [
                    90.6854467,
                    56.5735785
                ],
                [
                    90.6852678,
                    56.5726213
                ],
                [
                    90.6851431,
                    56.5722822
                ],
                [
                    90.6843216,
                    56.5723076
                ],
                [
                    90.6842484,
                    56.5718461
                ],
                [
                    90.6827926,
                    56.5719492
                ],
                [
                    90.683258,
                    56.5730492
                ],
                [
                    90.6834296,
                    56.5742159
                ],
                [
                    90.6829091,
                    56.5742681
                ],
                [
                    90.6823561,
                    56.5744473
                ],
                [
                    90.6819386,
                    56.574637
                ],
                [
                    90.6818681,
                    56.5748222
                ],
                [
                    90.6822341,
                    56.5752926
                ],
                [
                    90.6824238,
                    56.57566
                ],
                [
                    90.6833293,
                    56.5754449
                ],
                [
                    90.6837034,
                    56.5759691
                ],
                [
                    90.6830447,
                    56.5761154
                ],
                [
                    90.6827409,
                    56.5759243
                ],
                [
                    90.6814425,
                    56.5763275
                ],
                [
                    90.6814153,
                    56.5764484
                ]
            ],
            "longitude": 90.6913183,
            "latitude": 56.5747896
        },
        "6451": {
            "name": "Грибной",
            "population": 20,
            "type": "hamlet",
            "poly": [
                [
                    90.6953513,
                    56.3248812
                ],
                [
                    90.6984713,
                    56.3256635
                ],
                [
                    90.698953,
                    56.325072
                ],
                [
                    90.6957184,
                    56.3243787
                ],
                [
                    90.6953513,
                    56.3248812
                ]
            ],
            "longitude": 90.696899,
            "latitude": 56.325001
        },
        "6452": {
            "name": "Баженовка",
            "population": 52,
            "type": "hamlet",
            "poly": [
                [
                    90.6948316,
                    56.6777468
                ],
                [
                    90.6950806,
                    56.6778364
                ],
                [
                    90.6954808,
                    56.6779113
                ],
                [
                    90.6969273,
                    56.6783363
                ],
                [
                    90.6976387,
                    56.6785529
                ],
                [
                    90.6980863,
                    56.6785447
                ],
                [
                    90.6976239,
                    56.6787613
                ],
                [
                    90.69878,
                    56.6796455
                ],
                [
                    90.6998738,
                    56.6797578
                ],
                [
                    90.7018597,
                    56.6793556
                ],
                [
                    90.7029833,
                    56.6791114
                ],
                [
                    90.7036621,
                    56.6788346
                ],
                [
                    90.7042905,
                    56.6784242
                ],
                [
                    90.7053043,
                    56.6776817
                ],
                [
                    90.7057311,
                    56.6773251
                ],
                [
                    90.7061542,
                    56.6771041
                ],
                [
                    90.7062684,
                    56.6768568
                ],
                [
                    90.7065602,
                    56.6766228
                ],
                [
                    90.7069585,
                    56.6760732
                ],
                [
                    90.7069585,
                    56.6759459
                ],
                [
                    90.7071993,
                    56.6757755
                ],
                [
                    90.7073892,
                    56.6754523
                ],
                [
                    90.7076949,
                    56.6751342
                ],
                [
                    90.7083989,
                    56.6744218
                ],
                [
                    90.7098254,
                    56.6730909
                ],
                [
                    90.710599,
                    56.6723097
                ],
                [
                    90.711428,
                    56.6719356
                ],
                [
                    90.7125945,
                    56.6718346
                ],
                [
                    90.71624,
                    56.6718496
                ],
                [
                    90.7175699,
                    56.6719092
                ],
                [
                    90.7177599,
                    56.6716706
                ],
                [
                    90.7170543,
                    56.6709102
                ],
                [
                    90.7162944,
                    56.670597
                ],
                [
                    90.7162763,
                    56.6695632
                ],
                [
                    90.7146932,
                    56.6695731
                ],
                [
                    90.7131282,
                    56.6697371
                ],
                [
                    90.7124136,
                    56.6697173
                ],
                [
                    90.7109391,
                    56.670105
                ],
                [
                    90.709166,
                    56.670269
                ],
                [
                    90.7074654,
                    56.6702143
                ],
                [
                    90.7068321,
                    56.6703833
                ],
                [
                    90.7064251,
                    56.670776
                ],
                [
                    90.7063979,
                    56.6709748
                ],
                [
                    90.7044259,
                    56.6727094
                ],
                [
                    90.7032046,
                    56.6727094
                ],
                [
                    90.7028699,
                    56.6730026
                ],
                [
                    90.7028518,
                    56.6732561
                ],
                [
                    90.7024629,
                    56.6733505
                ],
                [
                    90.7021643,
                    56.6737283
                ],
                [
                    90.7018568,
                    56.6740613
                ],
                [
                    90.7017749,
                    56.6744574
                ],
                [
                    90.7015387,
                    56.6744701
                ],
                [
                    90.701534,
                    56.6745974
                ],
                [
                    90.7012654,
                    56.6746483
                ],
                [
                    90.7012422,
                    56.6747322
                ],
                [
                    90.7010662,
                    56.6747628
                ],
                [
                    90.7009412,
                    56.6749205
                ],
                [
                    90.7008485,
                    56.6750045
                ],
                [
                    90.7009041,
                    56.6753836
                ],
                [
                    90.6997833,
                    56.6761928
                ],
                [
                    90.6988279,
                    56.6765672
                ],
                [
                    90.6972068,
                    56.6768773
                ],
                [
                    90.6966858,
                    56.676925
                ],
                [
                    90.6959114,
                    56.6773504
                ],
                [
                    90.6950212,
                    56.6775091
                ],
                [
                    90.6948553,
                    56.6776068
                ],
                [
                    90.6948316,
                    56.6777468
                ]
            ],
            "longitude": 90.703817,
            "latitude": 56.6755485
        },
        "6453": {
            "name": "Новая Ильинка",
            "population": 54,
            "type": "hamlet",
            "poly": [
                [
                    90.7068007,
                    56.0748773
                ],
                [
                    90.7082637,
                    56.0761798
                ],
                [
                    90.70903,
                    56.0762964
                ],
                [
                    90.7104582,
                    56.0772101
                ],
                [
                    90.7128269,
                    56.077735
                ],
                [
                    90.7144989,
                    56.0784931
                ],
                [
                    90.7200722,
                    56.0775017
                ],
                [
                    90.7240432,
                    56.0779293
                ],
                [
                    90.7266905,
                    56.0774628
                ],
                [
                    90.7266209,
                    56.0756743
                ],
                [
                    90.7233465,
                    56.0738663
                ],
                [
                    90.7204205,
                    56.071475
                ],
                [
                    90.719689,
                    56.0713
                ],
                [
                    90.7193059,
                    56.0708139
                ],
                [
                    90.7165191,
                    56.0712806
                ],
                [
                    90.7145685,
                    56.07165
                ],
                [
                    90.7127224,
                    56.0728165
                ],
                [
                    90.7107717,
                    56.0732637
                ],
                [
                    90.7070794,
                    56.0745079
                ],
                [
                    90.7068007,
                    56.0748773
                ]
            ],
            "longitude": 90.717178,
            "latitude": 56.074642
        },
        "6454": {
            "name": "Лесные Поляны",
            "population": 234,
            "type": "hamlet",
            "poly": [
                [
                    90.7071679,
                    55.9223851
                ],
                [
                    90.7072418,
                    55.9228476
                ],
                [
                    90.7081214,
                    55.9239973
                ],
                [
                    90.7084492,
                    55.9241798
                ],
                [
                    90.708905,
                    55.9248839
                ],
                [
                    90.7099152,
                    55.9248079
                ],
                [
                    90.7109624,
                    55.925015
                ],
                [
                    90.7115783,
                    55.9252428
                ],
                [
                    90.7124776,
                    55.9257536
                ],
                [
                    90.7139437,
                    55.9261332
                ],
                [
                    90.7131553,
                    55.9263955
                ],
                [
                    90.7132785,
                    55.9266785
                ],
                [
                    90.7136727,
                    55.9268441
                ],
                [
                    90.7137713,
                    55.9267682
                ],
                [
                    90.7143995,
                    55.927203
                ],
                [
                    90.7152988,
                    55.9267406
                ],
                [
                    90.7155946,
                    55.9270926
                ],
                [
                    90.7162352,
                    55.9270926
                ],
                [
                    90.7164077,
                    55.9271685
                ],
                [
                    90.716617,
                    55.9270857
                ],
                [
                    90.7167403,
                    55.9268993
                ],
                [
                    90.7165185,
                    55.926568
                ],
                [
                    90.7175735,
                    55.9263184
                ],
                [
                    90.7180465,
                    55.9260799
                ],
                [
                    90.7191425,
                    55.925753
                ],
                [
                    90.7197102,
                    55.925298
                ],
                [
                    90.7200808,
                    55.9256337
                ],
                [
                    90.7207431,
                    55.9253289
                ],
                [
                    90.7209954,
                    55.9251743
                ],
                [
                    90.7227615,
                    55.9247149
                ],
                [
                    90.72314,
                    55.9244189
                ],
                [
                    90.7231873,
                    55.9240257
                ],
                [
                    90.723621,
                    55.9236812
                ],
                [
                    90.7253083,
                    55.9228374
                ],
                [
                    90.7260179,
                    55.9228329
                ],
                [
                    90.7273188,
                    55.9226474
                ],
                [
                    90.7277919,
                    55.9226297
                ],
                [
                    90.7278786,
                    55.9224132
                ],
                [
                    90.7277524,
                    55.9219184
                ],
                [
                    90.7276185,
                    55.9214501
                ],
                [
                    90.7266723,
                    55.9206726
                ],
                [
                    90.7266881,
                    55.9202661
                ],
                [
                    90.7283833,
                    55.9201733
                ],
                [
                    90.7283768,
                    55.920124
                ],
                [
                    90.7283596,
                    55.920032
                ],
                [
                    90.7298419,
                    55.9199038
                ],
                [
                    90.7296211,
                    55.9193339
                ],
                [
                    90.72888,
                    55.9186225
                ],
                [
                    90.7285883,
                    55.9183795
                ],
                [
                    90.7266092,
                    55.9183795
                ],
                [
                    90.7259469,
                    55.9181277
                ],
                [
                    90.7254777,
                    55.9187281
                ],
                [
                    90.7232512,
                    55.9186857
                ],
                [
                    90.7231755,
                    55.9191098
                ],
                [
                    90.7223871,
                    55.919071
                ],
                [
                    90.7219455,
                    55.918562
                ],
                [
                    90.7205894,
                    55.9189331
                ],
                [
                    90.7190188,
                    55.9187246
                ],
                [
                    90.7179717,
                    55.918212
                ],
                [
                    90.7168552,
                    55.9184171
                ],
                [
                    90.7171895,
                    55.9186786
                ],
                [
                    90.7172084,
                    55.9189861
                ],
                [
                    90.7181924,
                    55.9194845
                ],
                [
                    90.7177698,
                    55.9199157
                ],
                [
                    90.7169751,
                    55.9200924
                ],
                [
                    90.7156441,
                    55.9201525
                ],
                [
                    90.7113935,
                    55.9206179
                ],
                [
                    90.7113566,
                    55.9210045
                ],
                [
                    90.7111225,
                    55.9213013
                ],
                [
                    90.7107529,
                    55.921467
                ],
                [
                    90.7100384,
                    55.9215567
                ],
                [
                    90.708634,
                    55.9215705
                ],
                [
                    90.7080672,
                    55.9216396
                ],
                [
                    90.7075991,
                    55.9219019
                ],
                [
                    90.7071679,
                    55.9223851
                ]
            ],
            "longitude": 90.718735,
            "latitude": 55.922626
        },
        "6455": {
            "name": "Малая Покровка",
            "population": 80,
            "type": "hamlet",
            "poly": [
                [
                    90.7109428,
                    56.2295659
                ],
                [
                    90.711194,
                    56.2296124
                ],
                [
                    90.7115149,
                    56.2291083
                ],
                [
                    90.7140543,
                    56.229116
                ],
                [
                    90.7180867,
                    56.2296202
                ],
                [
                    90.7211842,
                    56.231148
                ],
                [
                    90.7250071,
                    56.2323346
                ],
                [
                    90.7319138,
                    56.2342114
                ],
                [
                    90.733337,
                    56.2343354
                ],
                [
                    90.7343695,
                    56.2341493
                ],
                [
                    90.7351508,
                    56.233242
                ],
                [
                    90.7353323,
                    56.2324122
                ],
                [
                    90.734244,
                    56.2318383
                ],
                [
                    90.7279791,
                    56.2296667
                ],
                [
                    90.7288024,
                    56.2288446
                ],
                [
                    90.7286489,
                    56.2281
                ],
                [
                    90.7270164,
                    56.2275803
                ],
                [
                    90.720333,
                    56.2261609
                ],
                [
                    90.7187145,
                    56.2260368
                ],
                [
                    90.7150449,
                    56.2259747
                ],
                [
                    90.7146123,
                    56.2257575
                ],
                [
                    90.7129381,
                    56.2255947
                ],
                [
                    90.7125424,
                    56.2267001
                ],
                [
                    90.7109428,
                    56.2295659
                ]
            ],
            "longitude": 90.723183,
            "latitude": 56.228798
        },
        "6456": {
            "name": "Барабановка",
            "population": 68,
            "type": "hamlet",
            "poly": [
                [
                    90.7288288,
                    56.1135512
                ],
                [
                    90.7298598,
                    56.1150427
                ],
                [
                    90.731922,
                    56.1170158
                ],
                [
                    90.7316155,
                    56.1181188
                ],
                [
                    90.7320892,
                    56.11888
                ],
                [
                    90.7334547,
                    56.1196102
                ],
                [
                    90.7335383,
                    56.1211325
                ],
                [
                    90.7336382,
                    56.1211526
                ],
                [
                    90.7349316,
                    56.1214121
                ],
                [
                    90.734848,
                    56.1219869
                ],
                [
                    90.7382199,
                    56.1223286
                ],
                [
                    90.7395854,
                    56.122049
                ],
                [
                    90.7409787,
                    56.1227014
                ],
                [
                    90.7435703,
                    56.122717
                ],
                [
                    90.7443227,
                    56.1222509
                ],
                [
                    90.7474995,
                    56.1231674
                ],
                [
                    90.7534629,
                    56.1243479
                ],
                [
                    90.7548283,
                    56.1243324
                ],
                [
                    90.7554693,
                    56.1237887
                ],
                [
                    90.7578101,
                    56.1241149
                ],
                [
                    90.7586461,
                    56.1231208
                ],
                [
                    90.7573364,
                    56.1227946
                ],
                [
                    90.7564168,
                    56.1222354
                ],
                [
                    90.756974,
                    56.1211481
                ],
                [
                    90.7549399,
                    56.1207908
                ],
                [
                    90.7468307,
                    56.1198121
                ],
                [
                    90.745075,
                    56.1191597
                ],
                [
                    90.7425113,
                    56.1174197
                ],
                [
                    90.7416475,
                    56.1174663
                ],
                [
                    90.7396411,
                    56.1145766
                ],
                [
                    90.7401148,
                    56.114297
                ],
                [
                    90.7398083,
                    56.1135046
                ],
                [
                    90.7377183,
                    56.1126967
                ],
                [
                    90.7372724,
                    56.113054
                ],
                [
                    90.733817,
                    56.112821
                ],
                [
                    90.7325908,
                    56.1133803
                ],
                [
                    90.7313647,
                    56.1125258
                ],
                [
                    90.7305286,
                    56.1127122
                ],
                [
                    90.7288288,
                    56.1135512
                ]
            ],
            "longitude": 90.737671,
            "latitude": 56.118301
        },
        "6457": {
            "name": "Тимонино",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    90.7216758,
                    56.3969855
                ],
                [
                    90.7248251,
                    56.3978184
                ],
                [
                    90.7322386,
                    56.3993453
                ],
                [
                    90.7338829,
                    56.3997463
                ],
                [
                    90.7345797,
                    56.4003478
                ],
                [
                    90.7346075,
                    56.4009031
                ],
                [
                    90.734301,
                    56.4016433
                ],
                [
                    90.7349698,
                    56.4024299
                ],
                [
                    90.7357502,
                    56.4027075
                ],
                [
                    90.738147,
                    56.4024145
                ],
                [
                    90.7496295,
                    56.404373
                ],
                [
                    90.7524444,
                    56.404481
                ],
                [
                    90.7529739,
                    56.4037253
                ],
                [
                    90.7530575,
                    56.4030313
                ],
                [
                    90.7568757,
                    56.4036636
                ],
                [
                    90.7622825,
                    56.4040492
                ],
                [
                    90.7669647,
                    56.4037562
                ],
                [
                    90.7700861,
                    56.4022757
                ],
                [
                    90.7701419,
                    56.4008568
                ],
                [
                    90.7580741,
                    56.4003633
                ],
                [
                    90.7508558,
                    56.3993916
                ],
                [
                    90.7477622,
                    56.3993145
                ],
                [
                    90.742439,
                    56.3983891
                ],
                [
                    90.7397635,
                    56.3976487
                ],
                [
                    90.7377847,
                    56.3969855
                ],
                [
                    90.7310959,
                    56.3959366
                ],
                [
                    90.7267203,
                    56.3949032
                ],
                [
                    90.7230414,
                    56.3960138
                ],
                [
                    90.7225677,
                    56.3959521
                ],
                [
                    90.7216758,
                    56.3969855
                ]
            ],
            "longitude": 90.745728,
            "latitude": 56.401443
        },
        "6458": {
            "name": "Ярлыково",
            "population": 225,
            "type": "hamlet",
            "poly": [
                [
                    90.7457157,
                    56.0081772
                ],
                [
                    90.7458931,
                    56.0084417
                ],
                [
                    90.7463071,
                    56.0085629
                ],
                [
                    90.7481698,
                    56.0087062
                ],
                [
                    90.7502198,
                    56.0088219
                ],
                [
                    90.7522501,
                    56.0093453
                ],
                [
                    90.7550984,
                    56.0099404
                ],
                [
                    90.7566949,
                    56.0106456
                ],
                [
                    90.758814,
                    56.0117531
                ],
                [
                    90.7600558,
                    56.0121498
                ],
                [
                    90.7607094,
                    56.0124206
                ],
                [
                    90.7617881,
                    56.0121737
                ],
                [
                    90.7631821,
                    56.0121949
                ],
                [
                    90.7636236,
                    56.0123254
                ],
                [
                    90.7639642,
                    56.0125404
                ],
                [
                    90.7647527,
                    56.0129036
                ],
                [
                    90.7655096,
                    56.013087
                ],
                [
                    90.7664116,
                    56.0130517
                ],
                [
                    90.767301,
                    56.0128331
                ],
                [
                    90.7691554,
                    56.0121878
                ],
                [
                    90.7701647,
                    56.0116977
                ],
                [
                    90.7716316,
                    56.0105384
                ],
                [
                    90.772556,
                    56.0100983
                ],
                [
                    90.7729314,
                    56.0100125
                ],
                [
                    90.7738801,
                    56.0091436
                ],
                [
                    90.7739148,
                    56.0088831
                ],
                [
                    90.7730401,
                    56.0086007
                ],
                [
                    90.7705146,
                    56.0083941
                ],
                [
                    90.7702928,
                    56.0082701
                ],
                [
                    90.7695167,
                    56.0081117
                ],
                [
                    90.7690485,
                    56.0079464
                ],
                [
                    90.7688021,
                    56.0076227
                ],
                [
                    90.7687529,
                    56.0072369
                ],
                [
                    90.7680014,
                    56.0063277
                ],
                [
                    90.7673607,
                    56.0053496
                ],
                [
                    90.767993,
                    56.0051678
                ],
                [
                    90.7686389,
                    56.0050295
                ],
                [
                    90.7716201,
                    56.0041782
                ],
                [
                    90.7708001,
                    56.0036809
                ],
                [
                    90.7696079,
                    56.0033141
                ],
                [
                    90.769015,
                    56.0036879
                ],
                [
                    90.7679364,
                    56.0039489
                ],
                [
                    90.7663406,
                    56.0045167
                ],
                [
                    90.763439,
                    56.0036703
                ],
                [
                    90.7581911,
                    56.0047424
                ],
                [
                    90.7576107,
                    56.0047354
                ],
                [
                    90.7569168,
                    56.0049964
                ],
                [
                    90.756078,
                    56.0050987
                ],
                [
                    90.7547029,
                    56.0051304
                ],
                [
                    90.7529683,
                    56.0055183
                ],
                [
                    90.7512652,
                    56.0055607
                ],
                [
                    90.7502812,
                    56.005543
                ],
                [
                    90.7491584,
                    56.005744
                ],
                [
                    90.7486728,
                    56.0060262
                ],
                [
                    90.7469886,
                    56.0053914
                ],
                [
                    90.7469359,
                    56.0054285
                ],
                [
                    90.7468183,
                    56.0055324
                ],
                [
                    90.7472535,
                    56.0060579
                ],
                [
                    90.7471968,
                    56.0064317
                ],
                [
                    90.7468057,
                    56.0066081
                ],
                [
                    90.7467174,
                    56.0068549
                ],
                [
                    90.7465155,
                    56.0069889
                ],
                [
                    90.7464398,
                    56.0072852
                ],
                [
                    90.7468491,
                    56.0074994
                ],
                [
                    90.7459818,
                    56.0079292
                ],
                [
                    90.7457157,
                    56.0081772
                ]
            ],
            "longitude": 90.76181,
            "latitude": 56.008904
        },
        "6459": {
            "name": "Канаш",
            "population": 88,
            "type": "hamlet",
            "poly": [
                [
                    90.754374,
                    55.7004405
                ],
                [
                    90.7545457,
                    55.701039
                ],
                [
                    90.7544921,
                    55.7023389
                ],
                [
                    90.7554576,
                    55.7032759
                ],
                [
                    90.7560477,
                    55.7036084
                ],
                [
                    90.7569919,
                    55.7037898
                ],
                [
                    90.7576249,
                    55.7036205
                ],
                [
                    90.7582579,
                    55.7030885
                ],
                [
                    90.7583223,
                    55.7022844
                ],
                [
                    90.7586684,
                    55.7023252
                ],
                [
                    90.7588764,
                    55.7023319
                ],
                [
                    90.7592115,
                    55.702499
                ],
                [
                    90.7615571,
                    55.7047307
                ],
                [
                    90.7642872,
                    55.706529
                ],
                [
                    90.7651606,
                    55.7071542
                ],
                [
                    90.7665889,
                    55.7087605
                ],
                [
                    90.7687642,
                    55.7073151
                ],
                [
                    90.7699672,
                    55.7063216
                ],
                [
                    90.7682148,
                    55.7059069
                ],
                [
                    90.7675557,
                    55.7057955
                ],
                [
                    90.7680501,
                    55.7055014
                ],
                [
                    90.768484,
                    55.7050217
                ],
                [
                    90.7691707,
                    55.7046812
                ],
                [
                    90.7699068,
                    55.7043531
                ],
                [
                    90.7712691,
                    55.7033565
                ],
                [
                    90.7727962,
                    55.7024279
                ],
                [
                    90.7734609,
                    55.7018583
                ],
                [
                    90.7731313,
                    55.7017469
                ],
                [
                    90.7731139,
                    55.7013451
                ],
                [
                    90.7723174,
                    55.7010139
                ],
                [
                    90.7720042,
                    55.7008189
                ],
                [
                    90.7711858,
                    55.7012678
                ],
                [
                    90.7708397,
                    55.7010077
                ],
                [
                    90.7703398,
                    55.7007539
                ],
                [
                    90.7699278,
                    55.700726
                ],
                [
                    90.7686809,
                    55.7008653
                ],
                [
                    90.7684501,
                    55.700822
                ],
                [
                    90.7682524,
                    55.7006487
                ],
                [
                    90.7678898,
                    55.700271
                ],
                [
                    90.7674339,
                    55.700076
                ],
                [
                    90.7671812,
                    55.7000296
                ],
                [
                    90.7676457,
                    55.6995819
                ],
                [
                    90.7667767,
                    55.6988322
                ],
                [
                    90.7655965,
                    55.6990257
                ],
                [
                    90.7646631,
                    55.6990499
                ],
                [
                    90.7638584,
                    55.6991466
                ],
                [
                    90.7635365,
                    55.6993038
                ],
                [
                    90.7630966,
                    55.6996968
                ],
                [
                    90.762807,
                    55.6998601
                ],
                [
                    90.7621632,
                    55.6993703
                ],
                [
                    90.7618521,
                    55.6994368
                ],
                [
                    90.7616482,
                    55.6993401
                ],
                [
                    90.761498,
                    55.6989411
                ],
                [
                    90.7611869,
                    55.6986629
                ],
                [
                    90.7600711,
                    55.699455
                ],
                [
                    90.7587836,
                    55.6988322
                ],
                [
                    90.7578073,
                    55.6995033
                ],
                [
                    90.757067,
                    55.6996364
                ],
                [
                    90.7558868,
                    55.6994671
                ],
                [
                    90.7552431,
                    55.6995638
                ],
                [
                    90.7546423,
                    55.6999931
                ],
                [
                    90.754374,
                    55.7004405
                ]
            ],
            "longitude": 90.766502,
            "latitude": 55.702415
        },
        "6460": {
            "name": "Покровка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.773308,
            "latitude": 56.314991
        },
        "6461": {
            "name": "Александровка",
            "population": 172,
            "type": "hamlet",
            "poly": [
                [
                    90.7666707,
                    56.5339649
                ],
                [
                    90.7670469,
                    56.5340715
                ],
                [
                    90.7672943,
                    56.5341107
                ],
                [
                    90.7670808,
                    56.5346807
                ],
                [
                    90.767196,
                    56.535159
                ],
                [
                    90.7699884,
                    56.5350563
                ],
                [
                    90.7701409,
                    56.535288
                ],
                [
                    90.7700222,
                    56.5356075
                ],
                [
                    90.7711236,
                    56.5356711
                ],
                [
                    90.7720623,
                    56.5356897
                ],
                [
                    90.7726519,
                    56.5357327
                ],
                [
                    90.7730349,
                    56.5357196
                ],
                [
                    90.7730383,
                    56.5352768
                ],
                [
                    90.7742616,
                    56.5352637
                ],
                [
                    90.7742752,
                    56.5354898
                ],
                [
                    90.7746683,
                    56.5354805
                ],
                [
                    90.7746988,
                    56.5353384
                ],
                [
                    90.7763119,
                    56.5353553
                ],
                [
                    90.7767025,
                    56.5352544
                ],
                [
                    90.7772194,
                    56.5351913
                ],
                [
                    90.7778887,
                    56.5352146
                ],
                [
                    90.7781641,
                    56.5347031
                ],
                [
                    90.7785114,
                    56.534348
                ],
                [
                    90.7789308,
                    56.5341915
                ],
                [
                    90.7794772,
                    56.5341705
                ],
                [
                    90.7801846,
                    56.5342896
                ],
                [
                    90.7802905,
                    56.5343761
                ],
                [
                    90.7807226,
                    56.5342102
                ],
                [
                    90.7806591,
                    56.5339673
                ],
                [
                    90.7803075,
                    56.5336029
                ],
                [
                    90.7802895,
                    56.5335424
                ],
                [
                    90.7813612,
                    56.5331756
                ],
                [
                    90.7818229,
                    56.5336054
                ],
                [
                    90.7821237,
                    56.5336171
                ],
                [
                    90.7825092,
                    56.5335283
                ],
                [
                    90.7831657,
                    56.533241
                ],
                [
                    90.7837037,
                    56.5336849
                ],
                [
                    90.7843052,
                    56.5335938
                ],
                [
                    90.7845933,
                    56.5334746
                ],
                [
                    90.7859657,
                    56.53443
                ],
                [
                    90.7857213,
                    56.5352983
                ],
                [
                    90.7891651,
                    56.5356183
                ],
                [
                    90.7896396,
                    56.5359383
                ],
                [
                    90.7919481,
                    56.5361719
                ],
                [
                    90.7923464,
                    56.5352236
                ],
                [
                    90.7944178,
                    56.5352656
                ],
                [
                    90.7949473,
                    56.535011
                ],
                [
                    90.7950193,
                    56.5345438
                ],
                [
                    90.7954641,
                    56.5343406
                ],
                [
                    90.7954556,
                    56.5334483
                ],
                [
                    90.7917237,
                    56.5330839
                ],
                [
                    90.7922108,
                    56.533509
                ],
                [
                    90.7922151,
                    56.5336001
                ],
                [
                    90.7919097,
                    56.5337093
                ],
                [
                    90.7916581,
                    56.5336758
                ],
                [
                    90.7910422,
                    56.5334043
                ],
                [
                    90.7908839,
                    56.5334115
                ],
                [
                    90.7907082,
                    56.533488
                ],
                [
                    90.7904046,
                    56.5337033
                ],
                [
                    90.7902896,
                    56.5338647
                ],
                [
                    90.790038,
                    56.5339544
                ],
                [
                    90.789858,
                    56.5339508
                ],
                [
                    90.7896606,
                    56.533799
                ],
                [
                    90.7890446,
                    56.534225
                ],
                [
                    90.7887193,
                    56.5341188
                ],
                [
                    90.7884672,
                    56.5339155
                ],
                [
                    90.7884401,
                    56.5336225
                ],
                [
                    90.7882211,
                    56.533577
                ],
                [
                    90.786524,
                    56.5335172
                ],
                [
                    90.7863938,
                    56.5335022
                ],
                [
                    90.7860712,
                    56.5334514
                ],
                [
                    90.7856673,
                    56.5329969
                ],
                [
                    90.7865375,
                    56.5326785
                ],
                [
                    90.7863993,
                    56.5324991
                ],
                [
                    90.78583,
                    56.5321971
                ],
                [
                    90.7862691,
                    56.5319982
                ],
                [
                    90.78612,
                    56.5318876
                ],
                [
                    90.7867002,
                    56.5315407
                ],
                [
                    90.7863451,
                    56.5310922
                ],
                [
                    90.7860143,
                    56.5308605
                ],
                [
                    90.7873536,
                    56.5303357
                ],
                [
                    90.7870526,
                    56.5301563
                ],
                [
                    90.7866975,
                    56.5297915
                ],
                [
                    90.7859601,
                    56.5299873
                ],
                [
                    90.7852769,
                    56.529464
                ],
                [
                    90.7849895,
                    56.5294909
                ],
                [
                    90.7843985,
                    56.5296674
                ],
                [
                    90.7842304,
                    56.5296778
                ],
                [
                    90.784122,
                    56.5290484
                ],
                [
                    90.7842603,
                    56.5287673
                ],
                [
                    90.7842657,
                    56.5286267
                ],
                [
                    90.7835446,
                    56.5284922
                ],
                [
                    90.7834388,
                    56.5286462
                ],
                [
                    90.779732,
                    56.5289289
                ],
                [
                    90.7798268,
                    56.5298017
                ],
                [
                    90.7800776,
                    56.5298017
                ],
                [
                    90.7801894,
                    56.5301475
                ],
                [
                    90.7805994,
                    56.5303586
                ],
                [
                    90.7806944,
                    56.530581
                ],
                [
                    90.7802369,
                    56.530682
                ],
                [
                    90.7798878,
                    56.5303306
                ],
                [
                    90.7797048,
                    56.5302428
                ],
                [
                    90.7788848,
                    56.5300241
                ],
                [
                    90.7785628,
                    56.5297905
                ],
                [
                    90.7788543,
                    56.5296784
                ],
                [
                    90.7782646,
                    56.5292242
                ],
                [
                    90.7771123,
                    56.529469
                ],
                [
                    90.7765194,
                    56.529641
                ],
                [
                    90.7763793,
                    56.5295403
                ],
                [
                    90.7752474,
                    56.5297796
                ],
                [
                    90.7749086,
                    56.5298468
                ],
                [
                    90.7745866,
                    56.5300057
                ],
                [
                    90.7747832,
                    56.5306897
                ],
                [
                    90.774102,
                    56.5306617
                ],
                [
                    90.7738479,
                    56.5306374
                ],
                [
                    90.7732142,
                    56.5305346
                ],
                [
                    90.7724423,
                    56.5305352
                ],
                [
                    90.7721197,
                    56.5311329
                ],
                [
                    90.7720783,
                    56.5326568
                ],
                [
                    90.7716398,
                    56.5329443
                ],
                [
                    90.7718319,
                    56.5334436
                ],
                [
                    90.7710965,
                    56.5334305
                ],
                [
                    90.7710321,
                    56.5342677
                ],
                [
                    90.7691954,
                    56.5341948
                ],
                [
                    90.7691717,
                    56.5338323
                ],
                [
                    90.7685142,
                    56.5338211
                ],
                [
                    90.7683313,
                    56.533509
                ],
                [
                    90.7673688,
                    56.5334772
                ],
                [
                    90.7667521,
                    56.5334828
                ],
                [
                    90.7666707,
                    56.5339649
                ]
            ],
            "longitude": 90.777599,
            "latitude": 56.5323612
        },
        "6462": {
            "name": "Малиновка",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    90.7868552,
                    55.7354342
                ],
                [
                    90.7889999,
                    55.7359576
                ],
                [
                    90.7896034,
                    55.7363352
                ],
                [
                    90.7905153,
                    55.7367353
                ],
                [
                    90.7909445,
                    55.7371431
                ],
                [
                    90.7909713,
                    55.7375961
                ],
                [
                    90.7911725,
                    55.7381397
                ],
                [
                    90.7922051,
                    55.7389928
                ],
                [
                    90.7935194,
                    55.7398535
                ],
                [
                    90.7936804,
                    55.7402461
                ],
                [
                    90.7954775,
                    55.7406991
                ],
                [
                    90.7962553,
                    55.7407142
                ],
                [
                    90.7983743,
                    55.7401329
                ],
                [
                    90.8001848,
                    55.7395062
                ],
                [
                    90.8009492,
                    55.738872
                ],
                [
                    90.8014588,
                    55.7385398
                ],
                [
                    90.8020355,
                    55.738419
                ],
                [
                    90.8025585,
                    55.7384115
                ],
                [
                    90.8037119,
                    55.7375432
                ],
                [
                    90.8043959,
                    55.7366825
                ],
                [
                    90.8050128,
                    55.7357387
                ],
                [
                    90.7972612,
                    55.7332582
                ],
                [
                    90.7971754,
                    55.7326421
                ],
                [
                    90.7961454,
                    55.7318024
                ],
                [
                    90.7951691,
                    55.7308478
                ],
                [
                    90.7945027,
                    55.7311911
                ],
                [
                    90.7940392,
                    55.7312829
                ],
                [
                    90.7924857,
                    55.7312781
                ],
                [
                    90.7914643,
                    55.7314763
                ],
                [
                    90.7910609,
                    55.7317324
                ],
                [
                    90.7906575,
                    55.7322544
                ],
                [
                    90.7903484,
                    55.7325685
                ],
                [
                    90.7868552,
                    55.7354342
                ]
            ],
            "longitude": 90.79615,
            "latitude": 55.735962
        },
        "6463": {
            "name": "Тукай",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    90.8142761,
                    55.4024069
                ],
                [
                    90.815045,
                    55.4036411
                ],
                [
                    90.8170668,
                    55.4056782
                ],
                [
                    90.8190031,
                    55.4070471
                ],
                [
                    90.8195266,
                    55.4067531
                ],
                [
                    90.8216609,
                    55.4055543
                ],
                [
                    90.8213871,
                    55.4052359
                ],
                [
                    90.8209504,
                    55.4051335
                ],
                [
                    90.8205233,
                    55.404891
                ],
                [
                    90.8203714,
                    55.4041958
                ],
                [
                    90.8198019,
                    55.4040448
                ],
                [
                    90.8192134,
                    55.403576
                ],
                [
                    90.8190425,
                    55.4031879
                ],
                [
                    90.8194507,
                    55.4026597
                ],
                [
                    90.8198114,
                    55.4028592
                ],
                [
                    90.8196215,
                    55.4031879
                ],
                [
                    90.8197543,
                    55.4035328
                ],
                [
                    90.8201151,
                    55.4036406
                ],
                [
                    90.8207036,
                    55.4034951
                ],
                [
                    90.8211972,
                    55.4029346
                ],
                [
                    90.8208554,
                    55.4028268
                ],
                [
                    90.8207796,
                    55.4025627
                ],
                [
                    90.8210643,
                    55.4023687
                ],
                [
                    90.8204758,
                    55.4018567
                ],
                [
                    90.8205233,
                    55.4014147
                ],
                [
                    90.8214914,
                    55.4010374
                ],
                [
                    90.8222413,
                    55.4010482
                ],
                [
                    90.8230007,
                    55.4004068
                ],
                [
                    90.8230956,
                    55.3996414
                ],
                [
                    90.8235133,
                    55.3993989
                ],
                [
                    90.8237221,
                    55.3991132
                ],
                [
                    90.823276,
                    55.3977279
                ],
                [
                    90.823817,
                    55.3969086
                ],
                [
                    90.8246238,
                    55.3965205
                ],
                [
                    90.8245954,
                    55.3960677
                ],
                [
                    90.8239879,
                    55.3955178
                ],
                [
                    90.8251364,
                    55.3951836
                ],
                [
                    90.8265317,
                    55.3951728
                ],
                [
                    90.8273196,
                    55.3927416
                ],
                [
                    90.8243896,
                    55.392368
                ],
                [
                    90.8222494,
                    55.3920951
                ],
                [
                    90.8201991,
                    55.3945264
                ],
                [
                    90.8192025,
                    55.3979278
                ],
                [
                    90.8171712,
                    55.3972378
                ],
                [
                    90.8144659,
                    55.4006336
                ],
                [
                    90.8142761,
                    55.4024069
                ]
            ],
            "longitude": 90.821213,
            "latitude": 55.399433
        },
        "6464": {
            "name": "Козловка",
            "population": 65,
            "type": "hamlet",
            "poly": [
                [
                    90.7998512,
                    56.3763442
                ],
                [
                    90.8022759,
                    56.3766837
                ],
                [
                    90.8033628,
                    56.3764213
                ],
                [
                    90.8077105,
                    56.3764985
                ],
                [
                    90.8122813,
                    56.3775942
                ],
                [
                    90.8132567,
                    56.3764213
                ],
                [
                    90.8175766,
                    56.3781343
                ],
                [
                    90.8169355,
                    56.3791219
                ],
                [
                    90.8180782,
                    56.379554
                ],
                [
                    90.820921,
                    56.3802176
                ],
                [
                    90.8213112,
                    56.3795849
                ],
                [
                    90.8245162,
                    56.3799244
                ],
                [
                    90.8266343,
                    56.3809583
                ],
                [
                    90.8344101,
                    56.3825939
                ],
                [
                    90.8343543,
                    56.3834271
                ],
                [
                    90.8345796,
                    56.3834313
                ],
                [
                    90.8348936,
                    56.3841581
                ],
                [
                    90.8345083,
                    56.3842055
                ],
                [
                    90.8349934,
                    56.3846716
                ],
                [
                    90.8371053,
                    56.3852325
                ],
                [
                    90.8398308,
                    56.3855089
                ],
                [
                    90.8401447,
                    56.3849876
                ],
                [
                    90.8401018,
                    56.384008
                ],
                [
                    90.8422423,
                    56.3842845
                ],
                [
                    90.8428131,
                    56.3843003
                ],
                [
                    90.8427275,
                    56.3848375
                ],
                [
                    90.8457954,
                    56.3850271
                ],
                [
                    90.8463947,
                    56.3844662
                ],
                [
                    90.8466231,
                    56.3835103
                ],
                [
                    90.8462521,
                    56.3830995
                ],
                [
                    90.8456955,
                    56.3828388
                ],
                [
                    90.8457669,
                    56.3822937
                ],
                [
                    90.8498337,
                    56.3823727
                ],
                [
                    90.8509467,
                    56.3825702
                ],
                [
                    90.8520169,
                    56.3828941
                ],
                [
                    90.8529016,
                    56.3815747
                ],
                [
                    90.852445,
                    56.3814325
                ],
                [
                    90.8528874,
                    56.3802948
                ],
                [
                    90.8508611,
                    56.3800973
                ],
                [
                    90.8488634,
                    56.3799867
                ],
                [
                    90.8472937,
                    56.3797813
                ],
                [
                    90.8433411,
                    56.3794653
                ],
                [
                    90.8402873,
                    56.3793547
                ],
                [
                    90.83799,
                    56.37941
                ],
                [
                    90.8375477,
                    56.3796312
                ],
                [
                    90.8375905,
                    56.3808242
                ],
                [
                    90.8338804,
                    56.3808321
                ],
                [
                    90.8331283,
                    56.3806817
                ],
                [
                    90.8341762,
                    56.3794842
                ],
                [
                    90.8250794,
                    56.3773485
                ],
                [
                    90.8234518,
                    56.3768917
                ],
                [
                    90.8253489,
                    56.3746978
                ],
                [
                    90.8343062,
                    56.3761298
                ],
                [
                    90.8383195,
                    56.3761397
                ],
                [
                    90.8386584,
                    56.3749545
                ],
                [
                    90.8377308,
                    56.3748261
                ],
                [
                    90.8379092,
                    56.3738482
                ],
                [
                    90.8373919,
                    56.373621
                ],
                [
                    90.8374633,
                    56.3733839
                ],
                [
                    90.8298971,
                    56.3724116
                ],
                [
                    90.825828,
                    56.371393
                ],
                [
                    90.8242952,
                    56.3748965
                ],
                [
                    90.8230132,
                    56.3767175
                ],
                [
                    90.8221771,
                    56.3766558
                ],
                [
                    90.8162965,
                    56.3765941
                ],
                [
                    90.8066534,
                    56.3751588
                ],
                [
                    90.8068485,
                    56.3737081
                ],
                [
                    90.8049255,
                    56.3734612
                ],
                [
                    90.8022221,
                    56.3734303
                ],
                [
                    90.8020827,
                    56.3749891
                ],
                [
                    90.8005758,
                    56.3749861
                ],
                [
                    90.7998512,
                    56.3763442
                ]
            ],
            "longitude": 90.826729,
            "latitude": 56.378525
        },
        "6465": {
            "name": "Могучий",
            "population": 162,
            "type": "hamlet",
            "poly": [
                [
                    90.8282426,
                    55.2609657
                ],
                [
                    90.8284491,
                    55.2613081
                ],
                [
                    90.8287495,
                    55.2613777
                ],
                [
                    90.8283365,
                    55.2617628
                ],
                [
                    90.8285992,
                    55.262378
                ],
                [
                    90.8291438,
                    55.2632232
                ],
                [
                    90.8299418,
                    55.2634586
                ],
                [
                    90.8308148,
                    55.2634746
                ],
                [
                    90.8313124,
                    55.2645712
                ],
                [
                    90.8320635,
                    55.2649029
                ],
                [
                    90.8358187,
                    55.2671708
                ],
                [
                    90.8370954,
                    55.2673848
                ],
                [
                    90.837931,
                    55.2673634
                ],
                [
                    90.8390857,
                    55.266882
                ],
                [
                    90.8386927,
                    55.2646836
                ],
                [
                    90.8384861,
                    55.2642824
                ],
                [
                    90.8380824,
                    55.2638331
                ],
                [
                    90.8373971,
                    55.2626348
                ],
                [
                    90.8385518,
                    55.2623513
                ],
                [
                    90.8379698,
                    55.2613349
                ],
                [
                    90.8376224,
                    55.2612439
                ],
                [
                    90.8371812,
                    55.2613081
                ],
                [
                    90.8367963,
                    55.2614098
                ],
                [
                    90.836862,
                    55.2610407
                ],
                [
                    90.8366836,
                    55.2608695
                ],
                [
                    90.8357824,
                    55.2606127
                ],
                [
                    90.834853,
                    55.2605913
                ],
                [
                    90.8340268,
                    55.2606876
                ],
                [
                    90.8338297,
                    55.2603559
                ],
                [
                    90.8335856,
                    55.2603398
                ],
                [
                    90.8328533,
                    55.2600831
                ],
                [
                    90.8323921,
                    55.2599814
                ],
                [
                    90.831885,
                    55.2600777
                ],
                [
                    90.8312186,
                    55.2600777
                ],
                [
                    90.8290686,
                    55.2603826
                ],
                [
                    90.8285805,
                    55.2605378
                ],
                [
                    90.8282426,
                    55.2609657
                ]
            ],
            "longitude": 90.835358,
            "latitude": 55.26252
        },
        "6466": {
            "name": "Сергеево",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.8370203,
            "latitude": 59.6640043
        },
        "6467": {
            "name": "Плотбище",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    90.8302117,
                    56.0434077
                ],
                [
                    90.831518,
                    56.0441373
                ],
                [
                    90.8390507,
                    56.0459856
                ],
                [
                    90.8390942,
                    56.0463747
                ],
                [
                    90.8415325,
                    56.0469584
                ],
                [
                    90.8441014,
                    56.04708
                ],
                [
                    90.8451465,
                    56.0461315
                ],
                [
                    90.8483686,
                    56.046399
                ],
                [
                    90.8525486,
                    56.0480284
                ],
                [
                    90.8536806,
                    56.0481256
                ],
                [
                    90.8564673,
                    56.0490011
                ],
                [
                    90.8609956,
                    56.0489524
                ],
                [
                    90.8609956,
                    56.0475177
                ],
                [
                    90.8595588,
                    56.045256
                ],
                [
                    90.8565543,
                    56.0458154
                ],
                [
                    90.8537677,
                    56.0456938
                ],
                [
                    90.8512423,
                    56.0449399
                ],
                [
                    90.8474106,
                    56.0434563
                ],
                [
                    90.8422727,
                    56.0433834
                ],
                [
                    90.8375267,
                    56.0411458
                ],
                [
                    90.8357415,
                    56.0401972
                ],
                [
                    90.8344353,
                    56.0400513
                ],
                [
                    90.8339563,
                    56.0401486
                ],
                [
                    90.8317357,
                    56.0417538
                ],
                [
                    90.8306036,
                    56.0425078
                ],
                [
                    90.8302117,
                    56.0434077
                ]
            ],
            "longitude": 90.843102,
            "latitude": 56.044987
        },
        "6468": {
            "name": "Елга",
            "population": 181,
            "type": "hamlet",
            "poly": [
                [
                    90.8268165,
                    56.7941318
                ],
                [
                    90.8268876,
                    56.7942517
                ],
                [
                    90.8270888,
                    56.7946061
                ],
                [
                    90.8271401,
                    56.7949507
                ],
                [
                    90.8273512,
                    56.7951994
                ],
                [
                    90.829668,
                    56.7959185
                ],
                [
                    90.8329568,
                    56.7965573
                ],
                [
                    90.834605,
                    56.7969612
                ],
                [
                    90.8374046,
                    56.7975588
                ],
                [
                    90.8387441,
                    56.7980822
                ],
                [
                    90.8402193,
                    56.798552
                ],
                [
                    90.8412127,
                    56.798655
                ],
                [
                    90.8436059,
                    56.7993185
                ],
                [
                    90.8441251,
                    56.7994504
                ],
                [
                    90.8447197,
                    56.7995039
                ],
                [
                    90.8457595,
                    56.7993883
                ],
                [
                    90.845738,
                    56.7990963
                ],
                [
                    90.8468904,
                    56.7993304
                ],
                [
                    90.8474028,
                    56.7988837
                ],
                [
                    90.8478388,
                    56.7989939
                ],
                [
                    90.8477244,
                    56.7991559
                ],
                [
                    90.8482708,
                    56.7992748
                ],
                [
                    90.8482097,
                    56.7994098
                ],
                [
                    90.8496478,
                    56.7998214
                ],
                [
                    90.8496913,
                    56.799924
                ],
                [
                    90.8500997,
                    56.800005
                ],
                [
                    90.8502812,
                    56.7997933
                ],
                [
                    90.8509579,
                    56.7999132
                ],
                [
                    90.8516681,
                    56.7991786
                ],
                [
                    90.8519423,
                    56.7987109
                ],
                [
                    90.8521238,
                    56.7985693
                ],
                [
                    90.8522028,
                    56.7984278
                ],
                [
                    90.8521811,
                    56.7983403
                ],
                [
                    90.8519976,
                    56.7980648
                ],
                [
                    90.8520193,
                    56.7978444
                ],
                [
                    90.8521278,
                    56.797623
                ],
                [
                    90.852116,
                    56.7974372
                ],
                [
                    90.8519443,
                    56.7972557
                ],
                [
                    90.8516701,
                    56.797085
                ],
                [
                    90.8501687,
                    56.7967555
                ],
                [
                    90.8493914,
                    56.7964875
                ],
                [
                    90.8488706,
                    56.7962531
                ],
                [
                    90.8477283,
                    56.7960122
                ],
                [
                    90.847243,
                    56.7960035
                ],
                [
                    90.8466569,
                    56.7959279
                ],
                [
                    90.8463118,
                    56.7958944
                ],
                [
                    90.8456331,
                    56.7957885
                ],
                [
                    90.8453746,
                    56.7957842
                ],
                [
                    90.8448163,
                    56.7956621
                ],
                [
                    90.8442797,
                    56.7954666
                ],
                [
                    90.8439779,
                    56.7954007
                ],
                [
                    90.8436958,
                    56.7953456
                ],
                [
                    90.8430743,
                    56.7952094
                ],
                [
                    90.8424982,
                    56.795163
                ],
                [
                    90.8419754,
                    56.7950884
                ],
                [
                    90.8416577,
                    56.7950106
                ],
                [
                    90.841348,
                    56.7949998
                ],
                [
                    90.8411389,
                    56.7949469
                ],
                [
                    90.8406516,
                    56.7946627
                ],
                [
                    90.8404721,
                    56.7944974
                ],
                [
                    90.8404204,
                    56.7943571
                ],
                [
                    90.8402333,
                    56.794224
                ],
                [
                    90.8395937,
                    56.7940278
                ],
                [
                    90.8382643,
                    56.7938125
                ],
                [
                    90.8370082,
                    56.7936669
                ],
                [
                    90.8359023,
                    56.7934306
                ],
                [
                    90.8356865,
                    56.7933124
                ],
                [
                    90.8355131,
                    56.7930971
                ],
                [
                    90.8354774,
                    56.793061
                ],
                [
                    90.8349111,
                    56.7929271
                ],
                [
                    90.8335203,
                    56.7926645
                ],
                [
                    90.833181,
                    56.7925943
                ],
                [
                    90.832893,
                    56.7924257
                ],
                [
                    90.8325694,
                    56.7922691
                ],
                [
                    90.8320564,
                    56.7921362
                ],
                [
                    90.831143,
                    56.7919525
                ],
                [
                    90.82962,
                    56.7916726
                ],
                [
                    90.8288052,
                    56.7915646
                ],
                [
                    90.8284539,
                    56.791584
                ],
                [
                    90.8281798,
                    56.7916931
                ],
                [
                    90.8280456,
                    56.7918574
                ],
                [
                    90.8277576,
                    56.792175
                ],
                [
                    90.8270631,
                    56.7928676
                ],
                [
                    90.8269842,
                    56.7929087
                ],
                [
                    90.8270533,
                    56.7935732
                ],
                [
                    90.8268244,
                    56.793974
                ],
                [
                    90.8268165,
                    56.7941318
                ]
            ],
            "longitude": 90.8449055,
            "latitude": 56.7974608
        },
        "6469": {
            "name": "Аешка",
            "population": 227,
            "type": "hamlet",
            "poly": [
                [
                    90.8375334,
                    54.9228272
                ],
                [
                    90.8376207,
                    54.9234008
                ],
                [
                    90.8377829,
                    54.9235191
                ],
                [
                    90.8379888,
                    54.9235764
                ],
                [
                    90.8381821,
                    54.9235872
                ],
                [
                    90.8390991,
                    54.9236696
                ],
                [
                    90.8394796,
                    54.9237879
                ],
                [
                    90.8400909,
                    54.9240818
                ],
                [
                    90.8409517,
                    54.9239743
                ],
                [
                    90.8412761,
                    54.9239098
                ],
                [
                    90.8433158,
                    54.9238632
                ],
                [
                    90.8443887,
                    54.9237843
                ],
                [
                    90.8465221,
                    54.9238488
                ],
                [
                    90.8468838,
                    54.9238637
                ],
                [
                    90.847046,
                    54.9238703
                ],
                [
                    90.8476262,
                    54.9239385
                ],
                [
                    90.8479568,
                    54.9239169
                ],
                [
                    90.8488176,
                    54.9241105
                ],
                [
                    90.8489922,
                    54.9241105
                ],
                [
                    90.8490733,
                    54.9241607
                ],
                [
                    90.8504082,
                    54.9243794
                ],
                [
                    90.8528597,
                    54.9247342
                ],
                [
                    90.8537018,
                    54.9246948
                ],
                [
                    90.8544004,
                    54.9247665
                ],
                [
                    90.8550803,
                    54.9247414
                ],
                [
                    90.8555107,
                    54.9246912
                ],
                [
                    90.8561345,
                    54.9247199
                ],
                [
                    90.8569205,
                    54.9247091
                ],
                [
                    90.8579934,
                    54.9246231
                ],
                [
                    90.8588791,
                    54.924322
                ],
                [
                    90.8607941,
                    54.9240281
                ],
                [
                    90.8610624,
                    54.92396
                ],
                [
                    90.8613431,
                    54.9239707
                ],
                [
                    90.8615427,
                    54.924046
                ],
                [
                    90.861892,
                    54.9239707
                ],
                [
                    90.8617547,
                    54.9234115
                ],
                [
                    90.8618171,
                    54.9229706
                ],
                [
                    90.8614678,
                    54.9226014
                ],
                [
                    90.8617485,
                    54.9220637
                ],
                [
                    90.8620167,
                    54.9218055
                ],
                [
                    90.8619918,
                    54.9215403
                ],
                [
                    90.8617048,
                    54.9214901
                ],
                [
                    90.8608128,
                    54.9214148
                ],
                [
                    90.8603269,
                    54.921439
                ],
                [
                    90.8600206,
                    54.9214542
                ],
                [
                    90.8594281,
                    54.9215833
                ],
                [
                    90.8591349,
                    54.9216263
                ],
                [
                    90.8571325,
                    54.9217661
                ],
                [
                    90.8558538,
                    54.9217912
                ],
                [
                    90.8546936,
                    54.9216729
                ],
                [
                    90.8513813,
                    54.9212714
                ],
                [
                    90.8509634,
                    54.9211424
                ],
                [
                    90.8498905,
                    54.9210886
                ],
                [
                    90.8491731,
                    54.9206978
                ],
                [
                    90.8487053,
                    54.9205114
                ],
                [
                    90.8476761,
                    54.920411
                ],
                [
                    90.8446819,
                    54.9202748
                ],
                [
                    90.8433408,
                    54.9201995
                ],
                [
                    90.84248,
                    54.920031
                ],
                [
                    90.842087,
                    54.9200274
                ],
                [
                    90.8412574,
                    54.9204756
                ],
                [
                    90.8404278,
                    54.9207874
                ],
                [
                    90.8390617,
                    54.9211818
                ],
                [
                    90.8390323,
                    54.9212332
                ],
                [
                    90.8385337,
                    54.9214075
                ],
                [
                    90.838282,
                    54.9215152
                ],
                [
                    90.8379576,
                    54.9217697
                ],
                [
                    90.8375334,
                    54.9228272
                ]
            ],
            "longitude": 90.8474827,
            "latitude": 54.9222047
        },
        "6470": {
            "name": "Камчатка",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.863197,
            "latitude": 55.119869
        },
        "6471": {
            "name": "Тулат",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    90.8572635,
                    56.4891556
                ],
                [
                    90.8592802,
                    56.490269
                ],
                [
                    90.8589441,
                    56.4904752
                ],
                [
                    90.8604753,
                    56.4916607
                ],
                [
                    90.8615396,
                    56.4922689
                ],
                [
                    90.8694197,
                    56.4929493
                ],
                [
                    90.8709135,
                    56.4920112
                ],
                [
                    90.8705214,
                    56.4917741
                ],
                [
                    90.8706895,
                    56.4908772
                ],
                [
                    90.865573,
                    56.488836
                ],
                [
                    90.8639297,
                    56.4900731
                ],
                [
                    90.858898,
                    56.4879043
                ],
                [
                    90.8572635,
                    56.4891556
                ]
            ],
            "longitude": 90.864014,
            "latitude": 56.491009
        },
        "6472": {
            "name": "Новотроицк",
            "population": 74,
            "type": "hamlet",
            "poly": [
                [
                    90.8614917,
                    55.3654513
                ],
                [
                    90.8617546,
                    55.3658867
                ],
                [
                    90.8619864,
                    55.3661702
                ],
                [
                    90.8617095,
                    55.3668215
                ],
                [
                    90.8616269,
                    55.3673806
                ],
                [
                    90.8664261,
                    55.3670178
                ],
                [
                    90.8669518,
                    55.3668855
                ],
                [
                    90.8673273,
                    55.3669196
                ],
                [
                    90.8674625,
                    55.3671672
                ],
                [
                    90.8675151,
                    55.3672867
                ],
                [
                    90.8677553,
                    55.367308
                ],
                [
                    90.867868,
                    55.3671586
                ],
                [
                    90.8679582,
                    55.3668684
                ],
                [
                    90.8682961,
                    55.3666635
                ],
                [
                    90.8688594,
                    55.3666678
                ],
                [
                    90.8693851,
                    55.3669068
                ],
                [
                    90.8693551,
                    55.3671458
                ],
                [
                    90.8704066,
                    55.3672483
                ],
                [
                    90.8704741,
                    55.3669965
                ],
                [
                    90.870722,
                    55.3667489
                ],
                [
                    90.8712551,
                    55.3666977
                ],
                [
                    90.8722166,
                    55.36683
                ],
                [
                    90.8729976,
                    55.3668343
                ],
                [
                    90.8735008,
                    55.3664715
                ],
                [
                    90.8739815,
                    55.3663818
                ],
                [
                    90.8756188,
                    55.3666379
                ],
                [
                    90.8759192,
                    55.3669196
                ],
                [
                    90.8763096,
                    55.3670818
                ],
                [
                    90.8768204,
                    55.3669623
                ],
                [
                    90.877241,
                    55.3671843
                ],
                [
                    90.8777592,
                    55.3671885
                ],
                [
                    90.8792388,
                    55.3674105
                ],
                [
                    90.8803202,
                    55.3671715
                ],
                [
                    90.8812591,
                    55.3668343
                ],
                [
                    90.881582,
                    55.3666166
                ],
                [
                    90.881642,
                    55.3663775
                ],
                [
                    90.8814468,
                    55.3656434
                ],
                [
                    90.8811876,
                    55.365401
                ],
                [
                    90.8819649,
                    55.365272
                ],
                [
                    90.8825508,
                    55.3650842
                ],
                [
                    90.8823706,
                    55.3641878
                ],
                [
                    90.8811539,
                    55.3642775
                ],
                [
                    90.880831,
                    55.3641921
                ],
                [
                    90.8780822,
                    55.3643372
                ],
                [
                    90.8776991,
                    55.3644397
                ],
                [
                    90.8767678,
                    55.3640726
                ],
                [
                    90.8764599,
                    55.3638591
                ],
                [
                    90.8754911,
                    55.3636628
                ],
                [
                    90.87468,
                    55.3636713
                ],
                [
                    90.8740115,
                    55.3636756
                ],
                [
                    90.873238,
                    55.3634622
                ],
                [
                    90.8724419,
                    55.3633597
                ],
                [
                    90.8717284,
                    55.3633682
                ],
                [
                    90.8713378,
                    55.3634792
                ],
                [
                    90.8706093,
                    55.3639616
                ],
                [
                    90.8704441,
                    55.3635817
                ],
                [
                    90.8701587,
                    55.3635091
                ],
                [
                    90.86931,
                    55.363492
                ],
                [
                    90.868529,
                    55.3636542
                ],
                [
                    90.867868,
                    55.3639317
                ],
                [
                    90.8664636,
                    55.364239
                ],
                [
                    90.865322,
                    55.3643073
                ],
                [
                    90.8645259,
                    55.3643031
                ],
                [
                    90.8631515,
                    55.364508
                ],
                [
                    90.8625207,
                    55.3648025
                ],
                [
                    90.8614917,
                    55.3654513
                ]
            ],
            "longitude": 90.8723304,
            "latitude": 55.3649435
        },
        "6473": {
            "name": "Скоробогатово",
            "population": 104,
            "type": "hamlet",
            "poly": [
                [
                    90.8639444,
                    55.7556328
                ],
                [
                    90.8642529,
                    55.7561837
                ],
                [
                    90.8645479,
                    55.7568176
                ],
                [
                    90.8649503,
                    55.7573157
                ],
                [
                    90.8651649,
                    55.7573685
                ],
                [
                    90.8651299,
                    55.7583974
                ],
                [
                    90.8657414,
                    55.7587294
                ],
                [
                    90.8661384,
                    55.7584879
                ],
                [
                    90.8667714,
                    55.7581196
                ],
                [
                    90.8672756,
                    55.7581076
                ],
                [
                    90.867619,
                    55.7583189
                ],
                [
                    90.8687777,
                    55.7582887
                ],
                [
                    90.8690245,
                    55.7585
                ],
                [
                    90.8694965,
                    55.7584215
                ],
                [
                    90.8699579,
                    55.7586207
                ],
                [
                    90.8703548,
                    55.7586449
                ],
                [
                    90.8705909,
                    55.759152
                ],
                [
                    90.87102,
                    55.7591157
                ],
                [
                    90.871653,
                    55.7592969
                ],
                [
                    90.8719534,
                    55.7595323
                ],
                [
                    90.872801,
                    55.7594659
                ],
                [
                    90.8734448,
                    55.7591399
                ],
                [
                    90.8742065,
                    55.7591822
                ],
                [
                    90.8753438,
                    55.7594478
                ],
                [
                    90.8761914,
                    55.7593512
                ],
                [
                    90.8771677,
                    55.7595987
                ],
                [
                    90.8783586,
                    55.7593934
                ],
                [
                    90.8802576,
                    55.7592184
                ],
                [
                    90.8808906,
                    55.7592123
                ],
                [
                    90.8820386,
                    55.7595927
                ],
                [
                    90.8819957,
                    55.7597979
                ],
                [
                    90.8822531,
                    55.7598764
                ],
                [
                    90.8825214,
                    55.7597919
                ],
                [
                    90.8826716,
                    55.7598643
                ],
                [
                    90.8831544,
                    55.759816
                ],
                [
                    90.8835621,
                    55.7592546
                ],
                [
                    90.8872314,
                    55.7594478
                ],
                [
                    90.8893235,
                    55.7594659
                ],
                [
                    90.8900853,
                    55.7590373
                ],
                [
                    90.890214,
                    55.7587354
                ],
                [
                    90.8878644,
                    55.7581498
                ],
                [
                    90.8878215,
                    55.7578118
                ],
                [
                    90.8881112,
                    55.7573107
                ],
                [
                    90.886019,
                    55.7567854
                ],
                [
                    90.8852787,
                    55.7570269
                ],
                [
                    90.884517,
                    55.7573046
                ],
                [
                    90.8837123,
                    55.7574797
                ],
                [
                    90.8816631,
                    55.7574193
                ],
                [
                    90.8790882,
                    55.7564534
                ],
                [
                    90.8779187,
                    55.7562783
                ],
                [
                    90.8770711,
                    55.756224
                ],
                [
                    90.8743782,
                    55.7558074
                ],
                [
                    90.8739705,
                    55.7556685
                ],
                [
                    90.8728761,
                    55.7556202
                ],
                [
                    90.8717174,
                    55.755741
                ],
                [
                    90.870505,
                    55.755578
                ],
                [
                    90.8676512,
                    55.7555478
                ],
                [
                    90.8659238,
                    55.7553787
                ],
                [
                    90.8647436,
                    55.7554029
                ],
                [
                    90.8639444,
                    55.7556328
                ]
            ],
            "longitude": 90.873825,
            "latitude": 55.757595
        },
        "6474": {
            "name": "Старожилово",
            "population": 202,
            "type": "hamlet",
            "poly": [
                [
                    90.873255,
                    55.8314905
                ],
                [
                    90.8747638,
                    55.8316129
                ],
                [
                    90.8753337,
                    55.8322814
                ],
                [
                    90.8758366,
                    55.8323944
                ],
                [
                    90.8789883,
                    55.8324979
                ],
                [
                    90.8786195,
                    55.8329498
                ],
                [
                    90.8786362,
                    55.8338631
                ],
                [
                    90.8794912,
                    55.8341549
                ],
                [
                    90.8809999,
                    55.8340137
                ],
                [
                    90.8817208,
                    55.8344938
                ],
                [
                    90.8845204,
                    55.8344091
                ],
                [
                    90.8866829,
                    55.8347009
                ],
                [
                    90.8875714,
                    55.8346539
                ],
                [
                    90.8875546,
                    55.8341267
                ],
                [
                    90.8883928,
                    55.8338536
                ],
                [
                    90.8901195,
                    55.8339195
                ],
                [
                    90.8919971,
                    55.8340984
                ],
                [
                    90.8921479,
                    55.833976
                ],
                [
                    90.8917455,
                    55.8335335
                ],
                [
                    90.8912762,
                    55.8332982
                ],
                [
                    90.8912595,
                    55.8330722
                ],
                [
                    90.8920474,
                    55.8329216
                ],
                [
                    90.8927682,
                    55.8329122
                ],
                [
                    90.8926843,
                    55.8326486
                ],
                [
                    90.8922988,
                    55.8326674
                ],
                [
                    90.8919132,
                    55.8322155
                ],
                [
                    90.8921982,
                    55.83182
                ],
                [
                    90.8931705,
                    55.8314246
                ],
                [
                    90.892567,
                    55.8311798
                ],
                [
                    90.8923156,
                    55.8308409
                ],
                [
                    90.8925335,
                    55.8304454
                ],
                [
                    90.8924329,
                    55.8298617
                ],
                [
                    90.8926006,
                    55.829664
                ],
                [
                    90.8938579,
                    55.8296451
                ],
                [
                    90.8943105,
                    55.829099
                ],
                [
                    90.8939101,
                    55.8288417
                ],
                [
                    90.8883277,
                    55.82878
                ],
                [
                    90.8883595,
                    55.82869
                ],
                [
                    90.8883277,
                    55.8286219
                ],
                [
                    90.8836653,
                    55.8282864
                ],
                [
                    90.8829787,
                    55.8279624
                ],
                [
                    90.8824293,
                    55.8274224
                ],
                [
                    90.8809874,
                    55.8267899
                ],
                [
                    90.8797171,
                    55.8265469
                ],
                [
                    90.8788931,
                    55.8264929
                ],
                [
                    90.877664,
                    55.8267899
                ],
                [
                    90.8770939,
                    55.8269522
                ],
                [
                    90.8767754,
                    55.8271688
                ],
                [
                    90.8767945,
                    55.8277684
                ],
                [
                    90.8766916,
                    55.8279032
                ],
                [
                    90.8768927,
                    55.8279879
                ],
                [
                    90.8759037,
                    55.8289201
                ],
                [
                    90.873255,
                    55.8314905
                ]
            ],
            "longitude": 90.88253,
            "latitude": 55.829437
        },
        "6475": {
            "name": "Сосновка",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    90.8760761,
                    57.2292756
                ],
                [
                    90.8793917,
                    57.2314383
                ],
                [
                    90.8827371,
                    57.233033
                ],
                [
                    90.8860375,
                    57.2312203
                ],
                [
                    90.8916946,
                    57.2304793
                ],
                [
                    90.8932984,
                    57.2296006
                ],
                [
                    90.8929561,
                    57.2283276
                ],
                [
                    90.8903109,
                    57.2272716
                ],
                [
                    90.8816942,
                    57.2276385
                ],
                [
                    90.8760761,
                    57.2292756
                ]
            ],
            "longitude": 90.884254,
            "latitude": 57.229549
        },
        "6476": {
            "name": "Малая Сосновка",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    90.8781564,
                    55.9520001
                ],
                [
                    90.8786284,
                    55.9529761
                ],
                [
                    90.8792544,
                    55.9537903
                ],
                [
                    90.8798611,
                    55.9548741
                ],
                [
                    90.8796878,
                    55.9552462
                ],
                [
                    90.8793218,
                    55.9555212
                ],
                [
                    90.8796974,
                    55.9554457
                ],
                [
                    90.8800153,
                    55.9554672
                ],
                [
                    90.8804583,
                    55.9557368
                ],
                [
                    90.8808724,
                    55.9558393
                ],
                [
                    90.8815177,
                    55.9557854
                ],
                [
                    90.8815851,
                    55.9559417
                ],
                [
                    90.8813829,
                    55.9560334
                ],
                [
                    90.8811229,
                    55.9563892
                ],
                [
                    90.8817104,
                    55.9566966
                ],
                [
                    90.8837714,
                    55.9589341
                ],
                [
                    90.8853221,
                    55.958492
                ],
                [
                    90.8863045,
                    55.9584704
                ],
                [
                    90.889791,
                    55.9577587
                ],
                [
                    90.8900029,
                    55.9577695
                ],
                [
                    90.8907348,
                    55.9573058
                ],
                [
                    90.8903207,
                    55.9564486
                ],
                [
                    90.8894731,
                    55.9548256
                ],
                [
                    90.8867379,
                    55.9512667
                ],
                [
                    90.886786,
                    55.9509216
                ],
                [
                    90.8853124,
                    55.951353
                ],
                [
                    90.8852301,
                    55.9513577
                ],
                [
                    90.8845516,
                    55.9513961
                ],
                [
                    90.8841612,
                    55.9515446
                ],
                [
                    90.8840219,
                    55.9515795
                ],
                [
                    90.8835788,
                    55.951326
                ],
                [
                    90.883078,
                    55.9510941
                ],
                [
                    90.882452,
                    55.9508083
                ],
                [
                    90.8823749,
                    55.9509755
                ],
                [
                    90.8815659,
                    55.9513422
                ],
                [
                    90.8803812,
                    55.9516064
                ],
                [
                    90.880073,
                    55.951752
                ],
                [
                    90.8798708,
                    55.9517035
                ],
                [
                    90.8796107,
                    55.9515202
                ],
                [
                    90.8793218,
                    55.951477
                ],
                [
                    90.8784935,
                    55.9516226
                ],
                [
                    90.8782431,
                    55.951752
                ],
                [
                    90.8781564,
                    55.9520001
                ]
            ],
            "longitude": 90.886208,
            "latitude": 55.954903
        },
        "6477": {
            "name": "Черемшанка",
            "population": 70,
            "type": "hamlet",
            "poly": [
                [
                    90.8827213,
                    56.6477555
                ],
                [
                    90.8834212,
                    56.6478381
                ],
                [
                    90.8843141,
                    56.6481416
                ],
                [
                    90.885385,
                    56.6482618
                ],
                [
                    90.8852366,
                    56.6490501
                ],
                [
                    90.8859482,
                    56.6491377
                ],
                [
                    90.8864039,
                    56.6493251
                ],
                [
                    90.8870449,
                    56.6489972
                ],
                [
                    90.8870672,
                    56.6487344
                ],
                [
                    90.8876897,
                    56.648881
                ],
                [
                    90.8876748,
                    56.648989
                ],
                [
                    90.8887457,
                    56.6489666
                ],
                [
                    90.8886493,
                    56.6486122
                ],
                [
                    90.8897609,
                    56.648551
                ],
                [
                    90.889798,
                    56.6488281
                ],
                [
                    90.8906576,
                    56.6488566
                ],
                [
                    90.8907206,
                    56.6487283
                ],
                [
                    90.8911615,
                    56.6487038
                ],
                [
                    90.8911912,
                    56.6485673
                ],
                [
                    90.8918803,
                    56.6486284
                ],
                [
                    90.892073,
                    56.6485184
                ],
                [
                    90.8943719,
                    56.6485996
                ],
                [
                    90.89437,
                    56.6487111
                ],
                [
                    90.8952269,
                    56.6487136
                ],
                [
                    90.8958892,
                    56.6487798
                ],
                [
                    90.8970054,
                    56.6487213
                ],
                [
                    90.8970888,
                    56.6493706
                ],
                [
                    90.8982328,
                    56.649424
                ],
                [
                    90.8984273,
                    56.6497271
                ],
                [
                    90.898557,
                    56.6502134
                ],
                [
                    90.8986728,
                    56.6504247
                ],
                [
                    90.8987329,
                    56.6505189
                ],
                [
                    90.8989414,
                    56.6505673
                ],
                [
                    90.8994046,
                    56.6505622
                ],
                [
                    90.9012248,
                    56.6502083
                ],
                [
                    90.9013777,
                    56.6501421
                ],
                [
                    90.901549,
                    56.6499791
                ],
                [
                    90.9017621,
                    56.6493706
                ],
                [
                    90.9021604,
                    56.6492331
                ],
                [
                    90.9024059,
                    56.6491745
                ],
                [
                    90.9033831,
                    56.6492611
                ],
                [
                    90.9042817,
                    56.6493018
                ],
                [
                    90.9052543,
                    56.6492458
                ],
                [
                    90.9070004,
                    56.6492102
                ],
                [
                    90.9079962,
                    56.6493018
                ],
                [
                    90.9097747,
                    56.64934
                ],
                [
                    90.9102935,
                    56.6492127
                ],
                [
                    90.910451,
                    56.6490752
                ],
                [
                    90.9104973,
                    56.6488766
                ],
                [
                    90.9101361,
                    56.6484361
                ],
                [
                    90.9101453,
                    56.6480821
                ],
                [
                    90.906792,
                    56.6479599
                ],
                [
                    90.9068522,
                    56.6469413
                ],
                [
                    90.9065373,
                    56.6469006
                ],
                [
                    90.8996599,
                    56.6466227
                ],
                [
                    90.898224,
                    56.6465387
                ],
                [
                    90.8972746,
                    56.6465845
                ],
                [
                    90.897006,
                    56.6464063
                ],
                [
                    90.8959176,
                    56.6463375
                ],
                [
                    90.8954763,
                    56.6464002
                ],
                [
                    90.8927851,
                    56.6463567
                ],
                [
                    90.8923779,
                    56.6463007
                ],
                [
                    90.88885,
                    56.6461329
                ],
                [
                    90.8887369,
                    56.6462137
                ],
                [
                    90.8883186,
                    56.6462075
                ],
                [
                    90.8862266,
                    56.6459091
                ],
                [
                    90.8839199,
                    56.6451692
                ],
                [
                    90.8829022,
                    56.6459712
                ],
                [
                    90.8827439,
                    56.6462013
                ],
                [
                    90.8827213,
                    56.6477555
                ]
            ],
            "longitude": 90.8968822,
            "latitude": 56.6478688
        },
        "6478": {
            "name": "Троицк",
            "population": 114,
            "type": "hamlet",
            "poly": [
                [
                    90.8968182,
                    56.7639968
                ],
                [
                    90.8968721,
                    56.7641579
                ],
                [
                    90.8970662,
                    56.7643278
                ],
                [
                    90.897391,
                    56.7644547
                ],
                [
                    90.8976808,
                    56.7645594
                ],
                [
                    90.8977993,
                    56.7646929
                ],
                [
                    90.8983522,
                    56.7649996
                ],
                [
                    90.8987341,
                    56.765097
                ],
                [
                    90.8994055,
                    56.7652449
                ],
                [
                    90.8998466,
                    56.7652593
                ],
                [
                    90.9015228,
                    56.7650964
                ],
                [
                    90.9045478,
                    56.7650802
                ],
                [
                    90.9049186,
                    56.7651356
                ],
                [
                    90.9057907,
                    56.7650317
                ],
                [
                    90.9074885,
                    56.7652026
                ],
                [
                    90.9081753,
                    56.7651564
                ],
                [
                    90.9088916,
                    56.7650364
                ],
                [
                    90.9090854,
                    56.7643713
                ],
                [
                    90.9098437,
                    56.7643921
                ],
                [
                    90.9099575,
                    56.7640226
                ],
                [
                    90.9112888,
                    56.7641127
                ],
                [
                    90.9113815,
                    56.7631867
                ],
                [
                    90.9095404,
                    56.7631221
                ],
                [
                    90.909671,
                    56.7629188
                ],
                [
                    90.9099911,
                    56.7623715
                ],
                [
                    90.909987,
                    56.7619651
                ],
                [
                    90.9096752,
                    56.7616095
                ],
                [
                    90.9089042,
                    56.7612284
                ],
                [
                    90.9087188,
                    56.7606326
                ],
                [
                    90.9085377,
                    56.7602146
                ],
                [
                    90.9086176,
                    56.7595888
                ],
                [
                    90.9087736,
                    56.7591454
                ],
                [
                    90.9088073,
                    56.7579213
                ],
                [
                    90.9090685,
                    56.7572885
                ],
                [
                    90.9091654,
                    56.7569328
                ],
                [
                    90.9091191,
                    56.7566949
                ],
                [
                    90.9088789,
                    56.7564663
                ],
                [
                    90.9081838,
                    56.7563693
                ],
                [
                    90.90724,
                    56.75633
                ],
                [
                    90.9069619,
                    56.7564178
                ],
                [
                    90.9066447,
                    56.7564136
                ],
                [
                    90.9066531,
                    56.75673
                ],
                [
                    90.9065637,
                    56.7567262
                ],
                [
                    90.9062782,
                    56.756543
                ],
                [
                    90.9054241,
                    56.7566929
                ],
                [
                    90.9047723,
                    56.7571007
                ],
                [
                    90.9044432,
                    56.7575735
                ],
                [
                    90.9041272,
                    56.7583565
                ],
                [
                    90.9040284,
                    56.7595257
                ],
                [
                    90.9041272,
                    56.7602041
                ],
                [
                    90.9040304,
                    56.7612575
                ],
                [
                    90.9033774,
                    56.7616328
                ],
                [
                    90.9025663,
                    56.7618724
                ],
                [
                    90.9021819,
                    56.7619041
                ],
                [
                    90.9017237,
                    56.761832
                ],
                [
                    90.9009232,
                    56.7616415
                ],
                [
                    90.9002754,
                    56.7615433
                ],
                [
                    90.8988693,
                    56.7614394
                ],
                [
                    90.8986797,
                    56.7614596
                ],
                [
                    90.898606,
                    56.7616068
                ],
                [
                    90.8984638,
                    56.7618435
                ],
                [
                    90.8982742,
                    56.7620629
                ],
                [
                    90.8976317,
                    56.7624613
                ],
                [
                    90.8973684,
                    56.7626951
                ],
                [
                    90.8972472,
                    56.762874
                ],
                [
                    90.897242,
                    56.7631281
                ],
                [
                    90.8972682,
                    56.7633561
                ],
                [
                    90.8971788,
                    56.763486
                ],
                [
                    90.8971283,
                    56.7635372
                ],
                [
                    90.8969611,
                    56.7636687
                ],
                [
                    90.8968586,
                    56.7637958
                ],
                [
                    90.8968182,
                    56.7639968
                ]
            ],
            "longitude": 90.9072252,
            "latitude": 56.7624578
        },
        "6479": {
            "name": "Кызыкчуль",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    90.9034713,
                    55.5269278
                ],
                [
                    90.9039447,
                    55.528168
                ],
                [
                    90.9042578,
                    55.5287242
                ],
                [
                    90.9045694,
                    55.5288104
                ],
                [
                    90.904881,
                    55.5287948
                ],
                [
                    90.9096385,
                    55.5280226
                ],
                [
                    90.9115775,
                    55.5276346
                ],
                [
                    90.9122008,
                    55.5276032
                ],
                [
                    90.913468,
                    55.5274425
                ],
                [
                    90.9143406,
                    55.527372
                ],
                [
                    90.9165081,
                    55.526882
                ],
                [
                    90.9168474,
                    55.5267095
                ],
                [
                    90.91781,
                    55.5265096
                ],
                [
                    90.918177,
                    55.5266703
                ],
                [
                    90.9186409,
                    55.526639
                ],
                [
                    90.9193335,
                    55.526443
                ],
                [
                    90.9202338,
                    55.5260197
                ],
                [
                    90.9211063,
                    55.5251926
                ],
                [
                    90.9211894,
                    55.5252122
                ],
                [
                    90.9210509,
                    55.525561
                ],
                [
                    90.9214249,
                    55.5258629
                ],
                [
                    90.9214387,
                    55.5263215
                ],
                [
                    90.9222836,
                    55.5263685
                ],
                [
                    90.9226852,
                    55.5263058
                ],
                [
                    90.9232808,
                    55.5264979
                ],
                [
                    90.9240079,
                    55.5263058
                ],
                [
                    90.9239594,
                    55.5261569
                ],
                [
                    90.9243195,
                    55.5262196
                ],
                [
                    90.9261062,
                    55.5258394
                ],
                [
                    90.9262585,
                    55.5255179
                ],
                [
                    90.9264039,
                    55.5254905
                ],
                [
                    90.9268125,
                    55.5255728
                ],
                [
                    90.9271518,
                    55.5255493
                ],
                [
                    90.9273319,
                    55.5253925
                ],
                [
                    90.9276504,
                    55.5241616
                ],
                [
                    90.9276081,
                    55.5241033
                ],
                [
                    90.9267779,
                    55.5236129
                ],
                [
                    90.9259815,
                    55.5236913
                ],
                [
                    90.9257322,
                    55.5235266
                ],
                [
                    90.9252959,
                    55.5234874
                ],
                [
                    90.9251436,
                    55.5233032
                ],
                [
                    90.925102,
                    55.5229543
                ],
                [
                    90.9248389,
                    55.5229072
                ],
                [
                    90.9245896,
                    55.5230484
                ],
                [
                    90.9244026,
                    55.5234247
                ],
                [
                    90.9240633,
                    55.5234953
                ],
                [
                    90.9226229,
                    55.5234365
                ],
                [
                    90.9224498,
                    55.5235266
                ],
                [
                    90.9222905,
                    55.5233581
                ],
                [
                    90.9219373,
                    55.5233777
                ],
                [
                    90.9217988,
                    55.5235227
                ],
                [
                    90.9214733,
                    55.5236991
                ],
                [
                    90.921044,
                    55.523703
                ],
                [
                    90.9206285,
                    55.5234521
                ],
                [
                    90.9199706,
                    55.5237893
                ],
                [
                    90.9156701,
                    55.5242479
                ],
                [
                    90.910207,
                    55.5249832
                ],
                [
                    90.9056084,
                    55.5258254
                ],
                [
                    90.9039988,
                    55.5262465
                ],
                [
                    90.9036472,
                    55.5265297
                ],
                [
                    90.9034713,
                    55.5269278
                ]
            ],
            "longitude": 90.91539,
            "latitude": 55.525482
        },
        "6480": {
            "name": "Боровка",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    90.9013212,
                    56.3173004
                ],
                [
                    90.9014432,
                    56.3190407
                ],
                [
                    90.9093926,
                    56.3188473
                ],
                [
                    90.9108221,
                    56.3185863
                ],
                [
                    90.9124433,
                    56.3188956
                ],
                [
                    90.913315,
                    56.3193597
                ],
                [
                    90.9143609,
                    56.3193887
                ],
                [
                    90.9153022,
                    56.3195724
                ],
                [
                    90.9157904,
                    56.3198141
                ],
                [
                    90.9157381,
                    56.3199881
                ],
                [
                    90.9136288,
                    56.3203361
                ],
                [
                    90.9120598,
                    56.3206841
                ],
                [
                    90.9105083,
                    56.3207615
                ],
                [
                    90.9100376,
                    56.3213898
                ],
                [
                    90.9067776,
                    56.3214092
                ],
                [
                    90.9063014,
                    56.3225277
                ],
                [
                    90.9061849,
                    56.3228012
                ],
                [
                    90.9059234,
                    56.3236035
                ],
                [
                    90.9095843,
                    56.3240579
                ],
                [
                    90.9126699,
                    56.3240965
                ],
                [
                    90.9135939,
                    56.3251211
                ],
                [
                    90.9152151,
                    56.3251115
                ],
                [
                    90.9155987,
                    56.3242222
                ],
                [
                    90.9161216,
                    56.3239129
                ],
                [
                    90.9171153,
                    56.3238645
                ],
                [
                    90.9173254,
                    56.323191
                ],
                [
                    90.9176732,
                    56.3220762
                ],
                [
                    90.9163308,
                    56.3212835
                ],
                [
                    90.9162611,
                    56.3209355
                ],
                [
                    90.9164703,
                    56.3206938
                ],
                [
                    90.9162262,
                    56.3205294
                ],
                [
                    90.9162088,
                    56.3203168
                ],
                [
                    90.9166446,
                    56.3201331
                ],
                [
                    90.9189458,
                    56.3201041
                ],
                [
                    90.9196779,
                    56.3202878
                ],
                [
                    90.9200266,
                    56.3202298
                ],
                [
                    90.9209157,
                    56.3198721
                ],
                [
                    90.9222057,
                    56.3199881
                ],
                [
                    90.9224149,
                    56.3204134
                ],
                [
                    90.9228159,
                    56.3208388
                ],
                [
                    90.923827,
                    56.3208001
                ],
                [
                    90.923878,
                    56.320627
                ],
                [
                    90.9242802,
                    56.319263
                ],
                [
                    90.9239489,
                    56.318741
                ],
                [
                    90.9233911,
                    56.3181899
                ],
                [
                    90.9194513,
                    56.3173198
                ],
                [
                    90.9180393,
                    56.3172618
                ],
                [
                    90.9159822,
                    56.3169137
                ],
                [
                    90.9148491,
                    56.3169814
                ],
                [
                    90.912914,
                    56.3170104
                ],
                [
                    90.9116413,
                    56.3173971
                ],
                [
                    90.9108569,
                    56.3175228
                ],
                [
                    90.909532,
                    56.3171554
                ],
                [
                    90.9084338,
                    56.3164013
                ],
                [
                    90.9069171,
                    56.316643
                ],
                [
                    90.9059932,
                    56.316498
                ],
                [
                    90.9041103,
                    56.3164206
                ],
                [
                    90.9026808,
                    56.316672
                ],
                [
                    90.9019139,
                    56.3172811
                ],
                [
                    90.9015422,
                    56.3172932
                ],
                [
                    90.9013212,
                    56.3173004
                ]
            ],
            "longitude": 90.915634,
            "latitude": 56.31879
        },
        "6481": {
            "name": "Ивановка",
            "population": 163,
            "type": "hamlet",
            "poly": [
                [
                    90.9035519,
                    56.8274909
                ],
                [
                    90.9036344,
                    56.8278254
                ],
                [
                    90.9046678,
                    56.82842
                ],
                [
                    90.9057303,
                    56.8288952
                ],
                [
                    90.9068365,
                    56.8292801
                ],
                [
                    90.9095437,
                    56.8307241
                ],
                [
                    90.9098833,
                    56.831101
                ],
                [
                    90.909927,
                    56.8317699
                ],
                [
                    90.9101065,
                    56.8320566
                ],
                [
                    90.9107711,
                    56.8323008
                ],
                [
                    90.911266,
                    56.8323883
                ],
                [
                    90.9115959,
                    56.8323804
                ],
                [
                    90.9118239,
                    56.8323087
                ],
                [
                    90.9119712,
                    56.8323002
                ],
                [
                    90.9121071,
                    56.8325083
                ],
                [
                    90.9125185,
                    56.8329479
                ],
                [
                    90.9127242,
                    56.8334235
                ],
                [
                    90.9126194,
                    56.8347315
                ],
                [
                    90.9128639,
                    56.8347718
                ],
                [
                    90.9168383,
                    56.8354279
                ],
                [
                    90.9181852,
                    56.835653
                ],
                [
                    90.9186074,
                    56.8356037
                ],
                [
                    90.9194023,
                    56.835427
                ],
                [
                    90.919719,
                    56.8352912
                ],
                [
                    90.9202966,
                    56.8349531
                ],
                [
                    90.9203525,
                    56.8348835
                ],
                [
                    90.9206071,
                    56.8341412
                ],
                [
                    90.9213057,
                    56.8338677
                ],
                [
                    90.9214889,
                    56.8340546
                ],
                [
                    90.9219019,
                    56.8342142
                ],
                [
                    90.9221192,
                    56.8341021
                ],
                [
                    90.9223676,
                    56.8341361
                ],
                [
                    90.9231004,
                    56.8344588
                ],
                [
                    90.9234451,
                    56.8347408
                ],
                [
                    90.923768,
                    56.834858
                ],
                [
                    90.9241748,
                    56.8349837
                ],
                [
                    90.9242896,
                    56.8352045
                ],
                [
                    90.9244107,
                    56.8352487
                ],
                [
                    90.9247554,
                    56.8351807
                ],
                [
                    90.9249324,
                    56.8352538
                ],
                [
                    90.9250976,
                    56.8355142
                ],
                [
                    90.9252965,
                    56.8357451
                ],
                [
                    90.9256167,
                    56.8359787
                ],
                [
                    90.9258884,
                    56.8359707
                ],
                [
                    90.9260728,
                    56.8358088
                ],
                [
                    90.9262911,
                    56.835785
                ],
                [
                    90.9263687,
                    56.8358805
                ],
                [
                    90.9262086,
                    56.8359548
                ],
                [
                    90.926262,
                    56.8360344
                ],
                [
                    90.9265773,
                    56.8360822
                ],
                [
                    90.9267277,
                    56.8362653
                ],
                [
                    90.9268636,
                    56.836345
                ],
                [
                    90.9282317,
                    56.8363317
                ],
                [
                    90.931361,
                    56.8350631
                ],
                [
                    90.9317734,
                    56.8350949
                ],
                [
                    90.9321615,
                    56.8349914
                ],
                [
                    90.9326903,
                    56.8346251
                ],
                [
                    90.9331651,
                    56.8341464
                ],
                [
                    90.9332019,
                    56.8339642
                ],
                [
                    90.9330428,
                    56.8337348
                ],
                [
                    90.9314747,
                    56.832928
                ],
                [
                    90.9298368,
                    56.8323037
                ],
                [
                    90.9286414,
                    56.831913
                ],
                [
                    90.9287035,
                    56.8314819
                ],
                [
                    90.9284435,
                    56.8307769
                ],
                [
                    90.9265766,
                    56.8291078
                ],
                [
                    90.922757,
                    56.8272287
                ],
                [
                    90.9223254,
                    56.8268838
                ],
                [
                    90.9208536,
                    56.8264913
                ],
                [
                    90.9190807,
                    56.8261787
                ],
                [
                    90.9199904,
                    56.8256996
                ],
                [
                    90.9212014,
                    56.8250879
                ],
                [
                    90.9207077,
                    56.8247804
                ],
                [
                    90.9195154,
                    56.8243352
                ],
                [
                    90.9191086,
                    56.8241704
                ],
                [
                    90.9181647,
                    56.8239326
                ],
                [
                    90.9173977,
                    56.8238221
                ],
                [
                    90.9172332,
                    56.8238051
                ],
                [
                    90.9151,
                    56.8232461
                ],
                [
                    90.9145349,
                    56.8231289
                ],
                [
                    90.9136158,
                    56.8230881
                ],
                [
                    90.9130507,
                    56.8230218
                ],
                [
                    90.9123396,
                    56.822857
                ],
                [
                    90.912026,
                    56.8227669
                ],
                [
                    90.9119701,
                    56.8226786
                ],
                [
                    90.9115572,
                    56.8223795
                ],
                [
                    90.9110386,
                    56.8221281
                ],
                [
                    90.9109144,
                    56.8222147
                ],
                [
                    90.9100264,
                    56.8221043
                ],
                [
                    90.9090297,
                    56.8220278
                ],
                [
                    90.9083248,
                    56.823173
                ],
                [
                    90.9080671,
                    56.823535
                ],
                [
                    90.9081261,
                    56.8238561
                ],
                [
                    90.9077256,
                    56.8237049
                ],
                [
                    90.9070859,
                    56.823552
                ],
                [
                    90.9067071,
                    56.8235469
                ],
                [
                    90.9061172,
                    56.823744
                ],
                [
                    90.9055707,
                    56.8240855
                ],
                [
                    90.905422,
                    56.8242622
                ],
                [
                    90.9054787,
                    56.8247118
                ],
                [
                    90.9055485,
                    56.8253001
                ],
                [
                    90.9052923,
                    56.8258034
                ],
                [
                    90.9048375,
                    56.8261954
                ],
                [
                    90.9043331,
                    56.8264582
                ],
                [
                    90.904236,
                    56.8264981
                ],
                [
                    90.9035665,
                    56.8271246
                ],
                [
                    90.9035519,
                    56.8274909
                ]
            ],
            "longitude": 90.918816,
            "latitude": 56.829227
        },
        "6482": {
            "name": "Назимово",
            "population": 243,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.931118,
            "latitude": 59.5127058
        },
        "6483": {
            "name": "Изыкчуль",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    90.9321439,
                    56.545173
                ],
                [
                    90.9332373,
                    56.5456818
                ],
                [
                    90.9336219,
                    56.545697
                ],
                [
                    90.9355613,
                    56.5445733
                ],
                [
                    90.9366656,
                    56.5435616
                ],
                [
                    90.9357646,
                    56.5429316
                ],
                [
                    90.9336603,
                    56.5439978
                ],
                [
                    90.9332758,
                    56.5440039
                ],
                [
                    90.9329791,
                    56.544128
                ],
                [
                    90.933111,
                    56.544331
                ],
                [
                    90.9321439,
                    56.545173
                ]
            ],
            "longitude": 90.9348346,
            "latitude": 56.5443386
        },
        "6484": {
            "name": "Ольховка",
            "population": 83,
            "type": "hamlet",
            "poly": [
                [
                    90.9481837,
                    56.402941
                ],
                [
                    90.9523084,
                    56.4043444
                ],
                [
                    90.9525035,
                    56.4047453
                ],
                [
                    90.9559036,
                    56.4055164
                ],
                [
                    90.9549666,
                    56.407131
                ],
                [
                    90.9549282,
                    56.4071972
                ],
                [
                    90.9536462,
                    56.4071047
                ],
                [
                    90.9517232,
                    56.4079682
                ],
                [
                    90.9495214,
                    56.4085696
                ],
                [
                    90.9485738,
                    56.4086004
                ],
                [
                    90.9482115,
                    56.410019
                ],
                [
                    90.95412,
                    56.4106049
                ],
                [
                    90.9555135,
                    56.4100344
                ],
                [
                    90.9565168,
                    56.4085233
                ],
                [
                    90.9611989,
                    56.4090167
                ],
                [
                    90.9608924,
                    56.4100344
                ],
                [
                    90.9623974,
                    56.4101886
                ],
                [
                    90.9626204,
                    56.4094793
                ],
                [
                    90.9646881,
                    56.4096359
                ],
                [
                    90.9659979,
                    56.4070145
                ],
                [
                    90.9717949,
                    56.4083098
                ],
                [
                    90.9721014,
                    56.408757
                ],
                [
                    90.9767279,
                    56.4097438
                ],
                [
                    90.9794034,
                    56.4094663
                ],
                [
                    90.9804346,
                    56.4099443
                ],
                [
                    90.9817724,
                    56.4099134
                ],
                [
                    90.9821514,
                    56.4091733
                ],
                [
                    90.9830209,
                    56.4088033
                ],
                [
                    90.9847824,
                    56.4082852
                ],
                [
                    90.9864769,
                    56.4069159
                ],
                [
                    90.9884389,
                    56.4069159
                ],
                [
                    90.9885504,
                    56.4060276
                ],
                [
                    90.9865882,
                    56.4055712
                ],
                [
                    90.9818616,
                    56.4055712
                ],
                [
                    90.981438,
                    56.4043005
                ],
                [
                    90.9776922,
                    56.4040784
                ],
                [
                    90.9772686,
                    56.4055218
                ],
                [
                    90.9633781,
                    56.4030668
                ],
                [
                    90.9610216,
                    56.4026321
                ],
                [
                    90.960502,
                    56.4025363
                ],
                [
                    90.9548834,
                    56.4019317
                ],
                [
                    90.94941,
                    56.4009053
                ],
                [
                    90.9481837,
                    56.402941
                ]
            ],
            "longitude": 90.965744,
            "latitude": 56.406078
        },
        "6485": {
            "name": "Приморский",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.982521,
            "latitude": 54.75108
        },
        "6486": {
            "name": "Увалы",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.992584,
            "latitude": 55.112152
        },
        "6487": {
            "name": "Зеленоборск",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.992813,
            "latitude": 54.900875
        },
        "6488": {
            "name": "Балдаштык",
            "population": 35,
            "type": "hamlet",
            "poly": [
                [
                    90.9879593,
                    55.4041821
                ],
                [
                    90.989149,
                    55.4042063
                ],
                [
                    90.9885259,
                    55.4054929
                ],
                [
                    90.9888233,
                    55.4059674
                ],
                [
                    90.9893048,
                    55.4062649
                ],
                [
                    90.9888233,
                    55.4071333
                ],
                [
                    90.9892765,
                    55.4079053
                ],
                [
                    90.9897864,
                    55.4082832
                ],
                [
                    90.9910894,
                    55.4087013
                ],
                [
                    90.9909218,
                    55.4090899
                ],
                [
                    90.9922248,
                    55.4096366
                ],
                [
                    90.9929188,
                    55.4096447
                ],
                [
                    90.9933862,
                    55.4094839
                ],
                [
                    90.993457,
                    55.409315
                ],
                [
                    90.9941652,
                    55.409508
                ],
                [
                    90.9950575,
                    55.4094356
                ],
                [
                    90.9955815,
                    55.4091381
                ],
                [
                    90.9961339,
                    55.4081973
                ],
                [
                    90.9966438,
                    55.4072405
                ],
                [
                    90.9966296,
                    55.4068706
                ],
                [
                    90.997208,
                    55.4067072
                ],
                [
                    90.9978311,
                    55.4066669
                ],
                [
                    90.9995024,
                    55.4067956
                ],
                [
                    91.0002531,
                    55.4067393
                ],
                [
                    91.0063999,
                    55.4017133
                ],
                [
                    91.0076746,
                    55.4009493
                ],
                [
                    91.0075047,
                    55.4006839
                ],
                [
                    91.0066549,
                    55.4003461
                ],
                [
                    91.0061733,
                    55.399952
                ],
                [
                    91.0057908,
                    55.4000485
                ],
                [
                    91.0037939,
                    55.4005552
                ],
                [
                    91.0033548,
                    55.4012629
                ],
                [
                    91.0028449,
                    55.4017374
                ],
                [
                    91.0017969,
                    55.4014479
                ],
                [
                    91.0012728,
                    55.4015122
                ],
                [
                    91.000423,
                    55.4020591
                ],
                [
                    90.9987376,
                    55.4023325
                ],
                [
                    90.9982419,
                    55.4025657
                ],
                [
                    90.9967831,
                    55.4023727
                ],
                [
                    90.996344,
                    55.4021475
                ],
                [
                    90.996259,
                    55.4017937
                ],
                [
                    90.99565,
                    55.4016168
                ],
                [
                    90.9946727,
                    55.4016328
                ],
                [
                    90.9930015,
                    55.4021556
                ],
                [
                    90.9916559,
                    55.402043
                ],
                [
                    90.9913868,
                    55.4017535
                ],
                [
                    90.9907353,
                    55.4015122
                ],
                [
                    90.990013,
                    55.4014157
                ],
                [
                    90.989319,
                    55.401665
                ],
                [
                    90.9894465,
                    55.4023888
                ],
                [
                    90.98871,
                    55.4030402
                ],
                [
                    90.9879593,
                    55.4041821
                ]
            ],
            "longitude": 90.993866,
            "latitude": 55.405151
        },
        "6489": {
            "name": "Таежка",
            "population": 130,
            "type": "hamlet",
            "poly": [
                [
                    90.9949748,
                    56.6200554
                ],
                [
                    91.0040795,
                    56.6298978
                ],
                [
                    91.0065271,
                    56.6292737
                ],
                [
                    91.0074127,
                    56.6299035
                ],
                [
                    91.0080204,
                    56.6298281
                ],
                [
                    91.0095622,
                    56.6292717
                ],
                [
                    91.0088385,
                    56.6284457
                ],
                [
                    91.0101321,
                    56.6280078
                ],
                [
                    91.011308,
                    56.627351
                ],
                [
                    91.011679,
                    56.6273659
                ],
                [
                    91.0118961,
                    56.6272813
                ],
                [
                    91.0119142,
                    56.627127
                ],
                [
                    91.0118327,
                    56.6269827
                ],
                [
                    91.0121132,
                    56.6267538
                ],
                [
                    91.0124479,
                    56.6267638
                ],
                [
                    91.0132258,
                    56.6265647
                ],
                [
                    91.0132711,
                    56.6264552
                ],
                [
                    91.0144561,
                    56.6258282
                ],
                [
                    91.0146732,
                    56.6255993
                ],
                [
                    91.0162201,
                    56.624609
                ],
                [
                    91.0162201,
                    56.6242656
                ],
                [
                    91.0158696,
                    56.623657
                ],
                [
                    91.015777,
                    56.6234404
                ],
                [
                    91.0158882,
                    56.6232671
                ],
                [
                    91.0161892,
                    56.6229231
                ],
                [
                    91.0171063,
                    56.62249
                ],
                [
                    91.017588,
                    56.6223447
                ],
                [
                    91.018241,
                    56.6220211
                ],
                [
                    91.0183059,
                    56.6218453
                ],
                [
                    91.0185097,
                    56.6218504
                ],
                [
                    91.0188153,
                    56.6216389
                ],
                [
                    91.0190052,
                    56.6213076
                ],
                [
                    91.0192137,
                    56.6208311
                ],
                [
                    91.0190886,
                    56.6201609
                ],
                [
                    91.0188153,
                    56.6198883
                ],
                [
                    91.0185884,
                    56.6197303
                ],
                [
                    91.0177871,
                    56.618874
                ],
                [
                    91.0174927,
                    56.6187211
                ],
                [
                    91.017143,
                    56.6186461
                ],
                [
                    91.016805,
                    56.6186331
                ],
                [
                    91.0161499,
                    56.6185075
                ],
                [
                    91.0136303,
                    56.6185564
                ],
                [
                    91.0131027,
                    56.6187016
                ],
                [
                    91.0128507,
                    56.618744
                ],
                [
                    91.0122164,
                    56.618757
                ],
                [
                    91.0118844,
                    56.6189022
                ],
                [
                    91.0118548,
                    56.6187798
                ],
                [
                    91.0117984,
                    56.6185352
                ],
                [
                    91.0116384,
                    56.6183101
                ],
                [
                    91.0115139,
                    56.6182286
                ],
                [
                    91.0104171,
                    56.6176268
                ],
                [
                    91.0016184,
                    56.6190562
                ],
                [
                    91.0003968,
                    56.6194225
                ],
                [
                    90.998492,
                    56.6201838
                ],
                [
                    90.9980289,
                    56.6193939
                ],
                [
                    90.9956783,
                    56.6198175
                ],
                [
                    90.9949748,
                    56.6200554
                ]
            ],
            "longitude": 91.0094003,
            "latitude": 56.6234297
        },
        "6490": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.0229566,
            "latitude": 55.9839059
        },
        "6491": {
            "name": "Старая Чёрная",
            "population": 35,
            "type": "hamlet",
            "poly": [
                [
                    91.0072703,
                    56.279122
                ],
                [
                    91.0075993,
                    56.2797663
                ],
                [
                    91.008619,
                    56.2797611
                ],
                [
                    91.0091547,
                    56.2798368
                ],
                [
                    91.0098971,
                    56.2797898
                ],
                [
                    91.0107288,
                    56.2797194
                ],
                [
                    91.0106924,
                    56.279772
                ],
                [
                    91.0103795,
                    56.2800552
                ],
                [
                    91.0103604,
                    56.2804104
                ],
                [
                    91.0105408,
                    56.2808018
                ],
                [
                    91.0108319,
                    56.281157
                ],
                [
                    91.0111014,
                    56.2812732
                ],
                [
                    91.0116043,
                    56.2814228
                ],
                [
                    91.0119291,
                    56.2814816
                ],
                [
                    91.0125233,
                    56.281539
                ],
                [
                    91.0131537,
                    56.281559
                ],
                [
                    91.0136661,
                    56.2815764
                ],
                [
                    91.0140198,
                    56.281555
                ],
                [
                    91.0143855,
                    56.2814776
                ],
                [
                    91.0155043,
                    56.2812652
                ],
                [
                    91.0160913,
                    56.2812118
                ],
                [
                    91.0164859,
                    56.2812078
                ],
                [
                    91.0167746,
                    56.2810822
                ],
                [
                    91.01702,
                    56.2810208
                ],
                [
                    91.0175325,
                    56.28093
                ],
                [
                    91.0179727,
                    56.2807684
                ],
                [
                    91.0183096,
                    56.2806802
                ],
                [
                    91.0185839,
                    56.2806415
                ],
                [
                    91.0187595,
                    56.2807176
                ],
                [
                    91.0191492,
                    56.2806509
                ],
                [
                    91.0196858,
                    56.2804412
                ],
                [
                    91.0200274,
                    56.2802942
                ],
                [
                    91.0199528,
                    56.2801433
                ],
                [
                    91.0202848,
                    56.2800004
                ],
                [
                    91.0207372,
                    56.2798909
                ],
                [
                    91.0220147,
                    56.2796959
                ],
                [
                    91.0225007,
                    56.2795864
                ],
                [
                    91.0227124,
                    56.2794688
                ],
                [
                    91.0228351,
                    56.2792485
                ],
                [
                    91.0232922,
                    56.2791002
                ],
                [
                    91.0232754,
                    56.278988
                ],
                [
                    91.0232008,
                    56.2788945
                ],
                [
                    91.0235761,
                    56.2787008
                ],
                [
                    91.0231768,
                    56.2775094
                ],
                [
                    91.0252314,
                    56.2764555
                ],
                [
                    91.0276253,
                    56.2751251
                ],
                [
                    91.0285251,
                    56.2755566
                ],
                [
                    91.0296367,
                    56.2748927
                ],
                [
                    91.0304057,
                    56.274766
                ],
                [
                    91.0309226,
                    56.2746225
                ],
                [
                    91.0312104,
                    56.2745181
                ],
                [
                    91.0316451,
                    56.2745671
                ],
                [
                    91.0317919,
                    56.2745247
                ],
                [
                    91.0320093,
                    56.2742442
                ],
                [
                    91.032297,
                    56.2740518
                ],
                [
                    91.032532,
                    56.2737876
                ],
                [
                    91.0325908,
                    56.2735756
                ],
                [
                    91.0326906,
                    56.2719221
                ],
                [
                    91.0326378,
                    56.2716155
                ],
                [
                    91.0324222,
                    56.2711368
                ],
                [
                    91.0324087,
                    56.2711067
                ],
                [
                    91.031557,
                    56.2714883
                ],
                [
                    91.0304821,
                    56.2724113
                ],
                [
                    91.0303176,
                    56.2725385
                ],
                [
                    91.0290136,
                    56.2719971
                ],
                [
                    91.02833,
                    56.2712739
                ],
                [
                    91.0280104,
                    56.2713547
                ],
                [
                    91.0268921,
                    56.2718922
                ],
                [
                    91.026629,
                    56.272521
                ],
                [
                    91.0262295,
                    56.2728654
                ],
                [
                    91.0259993,
                    56.2729359
                ],
                [
                    91.0251441,
                    56.2739012
                ],
                [
                    91.0237484,
                    56.2748248
                ],
                [
                    91.0227334,
                    56.2753988
                ],
                [
                    91.0216667,
                    56.2762597
                ],
                [
                    91.0198951,
                    56.2774572
                ],
                [
                    91.0191715,
                    56.2776659
                ],
                [
                    91.0185137,
                    56.2779946
                ],
                [
                    91.0130017,
                    56.2783468
                ],
                [
                    91.0122263,
                    56.2784772
                ],
                [
                    91.0085563,
                    56.2785633
                ],
                [
                    91.0076447,
                    56.2787016
                ],
                [
                    91.0076744,
                    56.2789681
                ],
                [
                    91.0072703,
                    56.279122
                ]
            ],
            "longitude": 91.024277,
            "latitude": 56.275761
        },
        "6492": {
            "name": "Холодный Ключ",
            "population": 81,
            "type": "hamlet",
            "poly": [
                [
                    91.0299863,
                    55.5020323
                ],
                [
                    91.0334834,
                    55.5036453
                ],
                [
                    91.0341759,
                    55.5040276
                ],
                [
                    91.0350242,
                    55.5049101
                ],
                [
                    91.0351194,
                    55.5051993
                ],
                [
                    91.0358119,
                    55.5054052
                ],
                [
                    91.0369286,
                    55.5052287
                ],
                [
                    91.0373441,
                    55.5049542
                ],
                [
                    91.0383467,
                    55.5038172
                ],
                [
                    91.0395427,
                    55.5034933
                ],
                [
                    91.0392398,
                    55.5023314
                ],
                [
                    91.0418971,
                    55.5016156
                ],
                [
                    91.0412567,
                    55.501341
                ],
                [
                    91.0415865,
                    55.5009027
                ],
                [
                    91.041013,
                    55.4983225
                ],
                [
                    91.0407979,
                    55.4982031
                ],
                [
                    91.0389627,
                    55.4969773
                ],
                [
                    91.0380885,
                    55.4969135
                ],
                [
                    91.0374739,
                    55.4969577
                ],
                [
                    91.0372748,
                    55.4968204
                ],
                [
                    91.03576,
                    55.497144
                ],
                [
                    91.0345568,
                    55.4971391
                ],
                [
                    91.0323408,
                    55.4975265
                ],
                [
                    91.0323234,
                    55.4990268
                ],
                [
                    91.0325658,
                    55.4994779
                ],
                [
                    91.0314578,
                    55.4994632
                ],
                [
                    91.0307826,
                    55.499674
                ],
                [
                    91.0303585,
                    55.5000565
                ],
                [
                    91.0299949,
                    55.5008556
                ],
                [
                    91.0299863,
                    55.5020323
                ]
            ],
            "longitude": 91.03479,
            "latitude": 55.501404
        },
        "6493": {
            "name": "Петровка",
            "population": 55,
            "type": "hamlet",
            "poly": [
                [
                    91.0197368,
                    56.8739816
                ],
                [
                    91.019758,
                    56.8740647
                ],
                [
                    91.0199057,
                    56.8742074
                ],
                [
                    91.0217061,
                    56.8744508
                ],
                [
                    91.0241035,
                    56.8749893
                ],
                [
                    91.0258281,
                    56.875067
                ],
                [
                    91.0277517,
                    56.8751654
                ],
                [
                    91.0283633,
                    56.8752945
                ],
                [
                    91.0296793,
                    56.8753011
                ],
                [
                    91.0313288,
                    56.8752315
                ],
                [
                    91.032378,
                    56.8752978
                ],
                [
                    91.0327904,
                    56.8753839
                ],
                [
                    91.0329541,
                    56.875659
                ],
                [
                    91.0329966,
                    56.875954
                ],
                [
                    91.0331725,
                    56.8761329
                ],
                [
                    91.0345491,
                    56.8762986
                ],
                [
                    91.0358408,
                    56.8765405
                ],
                [
                    91.0360531,
                    56.8764908
                ],
                [
                    91.0362472,
                    56.8761793
                ],
                [
                    91.0365261,
                    56.8760799
                ],
                [
                    91.0368172,
                    56.8761428
                ],
                [
                    91.037175,
                    56.8760998
                ],
                [
                    91.0377874,
                    56.876239
                ],
                [
                    91.039995,
                    56.8771039
                ],
                [
                    91.0401162,
                    56.8772298
                ],
                [
                    91.0405287,
                    56.8775479
                ],
                [
                    91.0415233,
                    56.8778031
                ],
                [
                    91.045356,
                    56.8795892
                ],
                [
                    91.0455016,
                    56.8798145
                ],
                [
                    91.0462233,
                    56.8801459
                ],
                [
                    91.0473573,
                    56.8804507
                ],
                [
                    91.0488068,
                    56.8811698
                ],
                [
                    91.0498377,
                    56.8815807
                ],
                [
                    91.0531126,
                    56.8831578
                ],
                [
                    91.0549926,
                    56.8839696
                ],
                [
                    91.0560902,
                    56.8844003
                ],
                [
                    91.0567815,
                    56.884556
                ],
                [
                    91.0574244,
                    56.8847946
                ],
                [
                    91.0578065,
                    56.8848377
                ],
                [
                    91.0573456,
                    56.8852783
                ],
                [
                    91.0568483,
                    56.8855964
                ],
                [
                    91.0574184,
                    56.8859674
                ],
                [
                    91.0580005,
                    56.885984
                ],
                [
                    91.0584432,
                    56.885931
                ],
                [
                    91.060772,
                    56.8860469
                ],
                [
                    91.0619425,
                    56.8860768
                ],
                [
                    91.0627551,
                    56.8860668
                ],
                [
                    91.0631675,
                    56.886153
                ],
                [
                    91.0641803,
                    56.8860138
                ],
                [
                    91.064811,
                    56.8858051
                ],
                [
                    91.0656479,
                    56.8853876
                ],
                [
                    91.0656661,
                    56.8850066
                ],
                [
                    91.0650778,
                    56.8844235
                ],
                [
                    91.0643198,
                    56.8839862
                ],
                [
                    91.0636951,
                    56.8835223
                ],
                [
                    91.0637861,
                    56.8831777
                ],
                [
                    91.0635486,
                    56.8829478
                ],
                [
                    91.0633131,
                    56.8827039
                ],
                [
                    91.0621972,
                    56.8824123
                ],
                [
                    91.061615,
                    56.8821473
                ],
                [
                    91.0613482,
                    56.8817761
                ],
                [
                    91.0608387,
                    56.8815575
                ],
                [
                    91.060675,
                    56.8813487
                ],
                [
                    91.0604184,
                    56.8812408
                ],
                [
                    91.0596539,
                    56.8809444
                ],
                [
                    91.0589322,
                    56.8806031
                ],
                [
                    91.0588114,
                    56.8804849
                ],
                [
                    91.0586254,
                    56.8803069
                ],
                [
                    91.0579243,
                    56.8799151
                ],
                [
                    91.0577239,
                    56.8797405
                ],
                [
                    91.0572709,
                    56.8794365
                ],
                [
                    91.056697,
                    56.8791715
                ],
                [
                    91.0562455,
                    56.8791194
                ],
                [
                    91.0558766,
                    56.8789518
                ],
                [
                    91.0555873,
                    56.8786747
                ],
                [
                    91.0558305,
                    56.8785139
                ],
                [
                    91.0558814,
                    56.8783628
                ],
                [
                    91.0554267,
                    56.878196
                ],
                [
                    91.0552058,
                    56.8782924
                ],
                [
                    91.0549991,
                    56.8782021
                ],
                [
                    91.0547225,
                    56.87817
                ],
                [
                    91.0544522,
                    56.8782021
                ],
                [
                    91.0543552,
                    56.8783124
                ],
                [
                    91.0543171,
                    56.8784149
                ],
                [
                    91.0538894,
                    56.8784219
                ],
                [
                    91.0535426,
                    56.8782639
                ],
                [
                    91.0531427,
                    56.8782205
                ],
                [
                    91.0528272,
                    56.8781159
                ],
                [
                    91.0527453,
                    56.8779354
                ],
                [
                    91.0518833,
                    56.8774766
                ],
                [
                    91.0508847,
                    56.8772065
                ],
                [
                    91.0508226,
                    56.8770925
                ],
                [
                    91.0506537,
                    56.8769758
                ],
                [
                    91.0504699,
                    56.8770151
                ],
                [
                    91.0501743,
                    56.8770192
                ],
                [
                    91.0498688,
                    56.8769378
                ],
                [
                    91.0495508,
                    56.8767124
                ],
                [
                    91.0494116,
                    56.8766134
                ],
                [
                    91.0489149,
                    56.8764125
                ],
                [
                    91.048582,
                    56.8759265
                ],
                [
                    91.0488131,
                    56.8755682
                ],
                [
                    91.048818,
                    56.8754161
                ],
                [
                    91.048654,
                    56.8752709
                ],
                [
                    91.0484156,
                    56.8752465
                ],
                [
                    91.04813,
                    56.8751026
                ],
                [
                    91.0478791,
                    56.8750917
                ],
                [
                    91.0474444,
                    56.8749899
                ],
                [
                    91.0472779,
                    56.8747591
                ],
                [
                    91.0469925,
                    56.8745755
                ],
                [
                    91.0466061,
                    56.8745002
                ],
                [
                    91.04638,
                    56.874526
                ],
                [
                    91.0461143,
                    56.8743767
                ],
                [
                    91.0457758,
                    56.8740549
                ],
                [
                    91.0454847,
                    56.8740284
                ],
                [
                    91.0452809,
                    56.8739329
                ],
                [
                    91.0448588,
                    56.8733735
                ],
                [
                    91.0439904,
                    56.8729917
                ],
                [
                    91.0435343,
                    56.8729387
                ],
                [
                    91.0430492,
                    56.8727
                ],
                [
                    91.0424718,
                    56.8723182
                ],
                [
                    91.0421788,
                    56.871912
                ],
                [
                    91.041748,
                    56.8717954
                ],
                [
                    91.0413172,
                    56.8714984
                ],
                [
                    91.041286,
                    56.8708133
                ],
                [
                    91.0410464,
                    56.870519
                ],
                [
                    91.0405789,
                    56.8703592
                ],
                [
                    91.0394488,
                    56.8700049
                ],
                [
                    91.03926,
                    56.8698745
                ],
                [
                    91.0389818,
                    56.8699641
                ],
                [
                    91.0388948,
                    56.870032
                ],
                [
                    91.0387358,
                    56.8700184
                ],
                [
                    91.0386191,
                    56.8701135
                ],
                [
                    91.0385943,
                    56.8702099
                ],
                [
                    91.0384873,
                    56.870237
                ],
                [
                    91.0383508,
                    56.8702153
                ],
                [
                    91.0380179,
                    56.8702139
                ],
                [
                    91.0380229,
                    56.8702615
                ],
                [
                    91.0379956,
                    56.8702927
                ],
                [
                    91.0378192,
                    56.8702737
                ],
                [
                    91.0365524,
                    56.8705819
                ],
                [
                    91.0362717,
                    56.8705724
                ],
                [
                    91.0361773,
                    56.870647
                ],
                [
                    91.0358767,
                    56.8706755
                ],
                [
                    91.0354967,
                    56.8707597
                ],
                [
                    91.0354569,
                    56.8708167
                ],
                [
                    91.0352234,
                    56.8709158
                ],
                [
                    91.035057,
                    56.8709688
                ],
                [
                    91.0348209,
                    56.8709511
                ],
                [
                    91.034518,
                    56.8708941
                ],
                [
                    91.0341851,
                    56.870928
                ],
                [
                    91.0339541,
                    56.8710828
                ],
                [
                    91.0337976,
                    56.8711127
                ],
                [
                    91.0335567,
                    56.8710814
                ],
                [
                    91.0332263,
                    56.8710828
                ],
                [
                    91.0327171,
                    56.8711588
                ],
                [
                    91.0324662,
                    56.871205
                ],
                [
                    91.0322128,
                    56.8711453
                ],
                [
                    91.0321383,
                    56.8710692
                ],
                [
                    91.0320116,
                    56.8709864
                ],
                [
                    91.0316961,
                    56.8709633
                ],
                [
                    91.031331,
                    56.8708371
                ],
                [
                    91.03109,
                    56.870814
                ],
                [
                    91.0308963,
                    56.8708574
                ],
                [
                    91.0306553,
                    56.8708086
                ],
                [
                    91.0303846,
                    56.8708642
                ],
                [
                    91.0300144,
                    56.8708371
                ],
                [
                    91.0295077,
                    56.8709552
                ],
                [
                    91.0292394,
                    56.871091
                ],
                [
                    91.0289016,
                    56.871148
                ],
                [
                    91.02874,
                    56.8711941
                ],
                [
                    91.0284321,
                    56.8711412
                ],
                [
                    91.0282359,
                    56.8711181
                ],
                [
                    91.0280446,
                    56.8711561
                ],
                [
                    91.027985,
                    56.8712647
                ],
                [
                    91.0274632,
                    56.8712688
                ],
                [
                    91.0273689,
                    56.871319
                ],
                [
                    91.02721,
                    56.8714358
                ],
                [
                    91.0270013,
                    56.8714236
                ],
                [
                    91.0268324,
                    56.8714914
                ],
                [
                    91.0266237,
                    56.8715227
                ],
                [
                    91.0264474,
                    56.8714629
                ],
                [
                    91.0263132,
                    56.871391
                ],
                [
                    91.0261394,
                    56.8713842
                ],
                [
                    91.0260475,
                    56.8714629
                ],
                [
                    91.0258686,
                    56.8715322
                ],
                [
                    91.0256475,
                    56.8715267
                ],
                [
                    91.0256053,
                    56.8715457
                ],
                [
                    91.0256649,
                    56.8716285
                ],
                [
                    91.0255805,
                    56.8716598
                ],
                [
                    91.0250489,
                    56.87171
                ],
                [
                    91.0244999,
                    56.8717494
                ],
                [
                    91.02448,
                    56.8718688
                ],
                [
                    91.0243062,
                    56.8719462
                ],
                [
                    91.0241298,
                    56.8719272
                ],
                [
                    91.0240155,
                    56.8719299
                ],
                [
                    91.0239783,
                    56.8720019
                ],
                [
                    91.0238217,
                    56.8720779
                ],
                [
                    91.0234964,
                    56.8721376
                ],
                [
                    91.0233399,
                    56.8721023
                ],
                [
                    91.0231287,
                    56.8720969
                ],
                [
                    91.0228828,
                    56.8721933
                ],
                [
                    91.0225326,
                    56.8722625
                ],
                [
                    91.0218395,
                    56.8721444
                ],
                [
                    91.0215986,
                    56.8721743
                ],
                [
                    91.020903,
                    56.8723928
                ],
                [
                    91.0205378,
                    56.8724173
                ],
                [
                    91.0204767,
                    56.872495
                ],
                [
                    91.0201128,
                    56.8724712
                ],
                [
                    91.0198217,
                    56.8728821
                ],
                [
                    91.0198848,
                    56.872959
                ],
                [
                    91.0197464,
                    56.8736999
                ],
                [
                    91.0197368,
                    56.8739816
                ]
            ],
            "longitude": 91.039932,
            "latitude": 56.873997
        },
        "6494": {
            "name": "Крюково",
            "population": 187,
            "type": "hamlet",
            "poly": [
                [
                    91.0267771,
                    55.3584857
                ],
                [
                    91.0268832,
                    55.3590338
                ],
                [
                    91.0280403,
                    55.3590502
                ],
                [
                    91.0297278,
                    55.3589571
                ],
                [
                    91.0297182,
                    55.3594942
                ],
                [
                    91.030075,
                    55.3599492
                ],
                [
                    91.0309332,
                    55.3598998
                ],
                [
                    91.0327171,
                    55.3596696
                ],
                [
                    91.0332378,
                    55.3596038
                ],
                [
                    91.0340189,
                    55.359845
                ],
                [
                    91.0344335,
                    55.3598724
                ],
                [
                    91.0357642,
                    55.3599053
                ],
                [
                    91.0363813,
                    55.3600862
                ],
                [
                    91.0372492,
                    55.3602068
                ],
                [
                    91.0374131,
                    55.3604205
                ],
                [
                    91.0381363,
                    55.3608261
                ],
                [
                    91.0387245,
                    55.3608755
                ],
                [
                    91.0390813,
                    55.3608481
                ],
                [
                    91.0393803,
                    55.361018
                ],
                [
                    91.0399878,
                    55.3610618
                ],
                [
                    91.0403445,
                    55.361018
                ],
                [
                    91.0407592,
                    55.361018
                ],
                [
                    91.0412992,
                    55.3607823
                ],
                [
                    91.0418295,
                    55.3606124
                ],
                [
                    91.0420995,
                    55.3603054
                ],
                [
                    91.042196,
                    55.3600807
                ],
                [
                    91.0436617,
                    55.3600423
                ],
                [
                    91.0492834,
                    55.3600807
                ],
                [
                    91.0498716,
                    55.3592311
                ],
                [
                    91.0470849,
                    55.3586611
                ],
                [
                    91.0474802,
                    55.3581184
                ],
                [
                    91.0449152,
                    55.3575922
                ],
                [
                    91.0445681,
                    55.357351
                ],
                [
                    91.0438159,
                    55.3571646
                ],
                [
                    91.0431506,
                    55.357055
                ],
                [
                    91.0424467,
                    55.3567754
                ],
                [
                    91.0415402,
                    55.3566
                ],
                [
                    91.0404506,
                    55.3569289
                ],
                [
                    91.0395345,
                    55.3572304
                ],
                [
                    91.0372396,
                    55.3575867
                ],
                [
                    91.0350796,
                    55.3577402
                ],
                [
                    91.0345396,
                    55.3578389
                ],
                [
                    91.0338549,
                    55.3578718
                ],
                [
                    91.032206,
                    55.3576251
                ],
                [
                    91.0308657,
                    55.357647
                ],
                [
                    91.0294578,
                    55.3578443
                ],
                [
                    91.0267771,
                    55.3584857
                ]
            ],
            "longitude": 91.040154,
            "latitude": 55.358871
        },
        "6495": {
            "name": "Вольный",
            "population": 97,
            "type": "hamlet",
            "poly": [
                [
                    91.0354379,
                    55.2681539
                ],
                [
                    91.0356976,
                    55.2686016
                ],
                [
                    91.0357526,
                    55.2688656
                ],
                [
                    91.0361138,
                    55.2692862
                ],
                [
                    91.0364084,
                    55.2693826
                ],
                [
                    91.0362236,
                    55.2695591
                ],
                [
                    91.0366714,
                    55.2699528
                ],
                [
                    91.0370423,
                    55.2702687
                ],
                [
                    91.037771,
                    55.2705801
                ],
                [
                    91.0381103,
                    55.2707375
                ],
                [
                    91.038192,
                    55.2709809
                ],
                [
                    91.0378401,
                    55.271482
                ],
                [
                    91.0375574,
                    55.2716789
                ],
                [
                    91.0381229,
                    55.2721585
                ],
                [
                    91.0383679,
                    55.2722658
                ],
                [
                    91.0399385,
                    55.2718721
                ],
                [
                    91.0402464,
                    55.271865
                ],
                [
                    91.0410002,
                    55.2719902
                ],
                [
                    91.0413333,
                    55.2718686
                ],
                [
                    91.0417919,
                    55.272001
                ],
                [
                    91.0420244,
                    55.2719652
                ],
                [
                    91.0422694,
                    55.2717683
                ],
                [
                    91.042728,
                    55.2716073
                ],
                [
                    91.0433186,
                    55.2712172
                ],
                [
                    91.0437017,
                    55.2709237
                ],
                [
                    91.0438903,
                    55.270895
                ],
                [
                    91.0439783,
                    55.2707196
                ],
                [
                    91.0444683,
                    55.2707805
                ],
                [
                    91.0466295,
                    55.2707161
                ],
                [
                    91.0470128,
                    55.2704512
                ],
                [
                    91.0472515,
                    55.2704047
                ],
                [
                    91.0467803,
                    55.2691376
                ],
                [
                    91.0463295,
                    55.2681764
                ],
                [
                    91.0463154,
                    55.2681354
                ],
                [
                    91.0444368,
                    55.2683215
                ],
                [
                    91.0436516,
                    55.2679421
                ],
                [
                    91.0422121,
                    55.2671156
                ],
                [
                    91.0415902,
                    55.2669044
                ],
                [
                    91.0406729,
                    55.2667935
                ],
                [
                    91.0393598,
                    55.266729
                ],
                [
                    91.0384739,
                    55.2664999
                ],
                [
                    91.0380028,
                    55.266346
                ],
                [
                    91.0370415,
                    55.2664785
                ],
                [
                    91.0365201,
                    55.2664928
                ],
                [
                    91.0366583,
                    55.2673626
                ],
                [
                    91.0360866,
                    55.2675774
                ],
                [
                    91.0357348,
                    55.2678852
                ],
                [
                    91.0354379,
                    55.2681539
                ]
            ],
            "longitude": 91.040794,
            "latitude": 55.269238
        },
        "6496": {
            "name": "Селедково",
            "population": 221,
            "type": "hamlet",
            "poly": [
                [
                    91.0302041,
                    55.8881638
                ],
                [
                    91.0304947,
                    55.8893169
                ],
                [
                    91.0306737,
                    55.890304
                ],
                [
                    91.034803,
                    55.8930382
                ],
                [
                    91.0335269,
                    55.8932677
                ],
                [
                    91.0304208,
                    55.8934972
                ],
                [
                    91.0338279,
                    55.8996129
                ],
                [
                    91.0344419,
                    55.8993227
                ],
                [
                    91.0355856,
                    55.8991404
                ],
                [
                    91.0356458,
                    55.8992822
                ],
                [
                    91.0361996,
                    55.8991337
                ],
                [
                    91.0372469,
                    55.8986477
                ],
                [
                    91.0392093,
                    55.8982764
                ],
                [
                    91.0407142,
                    55.8980942
                ],
                [
                    91.0412439,
                    55.8975879
                ],
                [
                    91.0419904,
                    55.8970952
                ],
                [
                    91.0426645,
                    55.8968994
                ],
                [
                    91.0429584,
                    55.8970013
                ],
                [
                    91.0432543,
                    55.8969737
                ],
                [
                    91.0438115,
                    55.8967055
                ],
                [
                    91.0447632,
                    55.8963184
                ],
                [
                    91.0450936,
                    55.8960226
                ],
                [
                    91.045927,
                    55.8957737
                ],
                [
                    91.0477565,
                    55.894936
                ],
                [
                    91.0482594,
                    55.8945848
                ],
                [
                    91.0492012,
                    55.8948447
                ],
                [
                    91.048746,
                    55.8925451
                ],
                [
                    91.0486767,
                    55.8900823
                ],
                [
                    91.0485842,
                    55.8899052
                ],
                [
                    91.0475286,
                    55.8899225
                ],
                [
                    91.04091,
                    55.8909076
                ],
                [
                    91.0399623,
                    55.8909249
                ],
                [
                    91.0386371,
                    55.8907736
                ],
                [
                    91.0364951,
                    55.8900823
                ],
                [
                    91.0355782,
                    55.8897021
                ],
                [
                    91.0345765,
                    55.8895768
                ],
                [
                    91.0333052,
                    55.889054
                ],
                [
                    91.032134,
                    55.8882546
                ],
                [
                    91.031587,
                    55.8877231
                ],
                [
                    91.0311786,
                    55.8877663
                ],
                [
                    91.0302041,
                    55.8881638
                ]
            ],
            "longitude": 91.041176,
            "latitude": 55.893631
        },
        "6497": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.0413777,
            "latitude": 56.3002852
        },
        "6498": {
            "name": "Старая",
            "population": 25,
            "type": "hamlet",
            "poly": [
                [
                    91.0416407,
                    55.1585044
                ],
                [
                    91.042089,
                    55.1588488
                ],
                [
                    91.0423363,
                    55.1596082
                ],
                [
                    91.0419808,
                    55.1600763
                ],
                [
                    91.0468036,
                    55.1611094
                ],
                [
                    91.0470509,
                    55.1609947
                ],
                [
                    91.0484885,
                    55.1615598
                ],
                [
                    91.0489832,
                    55.1617982
                ],
                [
                    91.0496169,
                    55.1623457
                ],
                [
                    91.0506062,
                    55.1622044
                ],
                [
                    91.054177,
                    55.1610211
                ],
                [
                    91.057284,
                    55.1595552
                ],
                [
                    91.0579641,
                    55.159043
                ],
                [
                    91.0570521,
                    55.1586721
                ],
                [
                    91.0548416,
                    55.1575859
                ],
                [
                    91.0518119,
                    55.15559
                ],
                [
                    91.0487513,
                    55.1541239
                ],
                [
                    91.0475456,
                    55.1543535
                ],
                [
                    91.0442221,
                    55.1553957
                ],
                [
                    91.0448095,
                    55.156111
                ],
                [
                    91.0448869,
                    55.1567028
                ],
                [
                    91.0445622,
                    55.1572238
                ],
                [
                    91.0438357,
                    55.1576124
                ],
                [
                    91.0425063,
                    55.1579127
                ],
                [
                    91.0416407,
                    55.1585044
                ]
            ],
            "longitude": 91.048653,
            "latitude": 55.158302
        },
        "6499": {
            "name": "Красный Яр",
            "population": 77,
            "type": "hamlet",
            "poly": [
                [
                    91.0420634,
                    55.9824931
                ],
                [
                    91.0423622,
                    55.9833677
                ],
                [
                    91.0436499,
                    55.9846283
                ],
                [
                    91.0455812,
                    55.9858631
                ],
                [
                    91.046363,
                    55.9873036
                ],
                [
                    91.0457882,
                    55.9879852
                ],
                [
                    91.0462019,
                    55.9886154
                ],
                [
                    91.0474206,
                    55.9889241
                ],
                [
                    91.0479304,
                    55.9900601
                ],
                [
                    91.0472824,
                    55.9902333
                ],
                [
                    91.0477815,
                    55.9908367
                ],
                [
                    91.0483937,
                    55.9906812
                ],
                [
                    91.0494066,
                    55.9926815
                ],
                [
                    91.052479,
                    55.9923707
                ],
                [
                    91.0533757,
                    55.9927436
                ],
                [
                    91.0542034,
                    55.9926922
                ],
                [
                    91.0549161,
                    55.9932194
                ],
                [
                    91.0560429,
                    55.992795
                ],
                [
                    91.0573994,
                    55.9943382
                ],
                [
                    91.0597447,
                    55.9963699
                ],
                [
                    91.0605954,
                    55.9961384
                ],
                [
                    91.0608253,
                    55.9954698
                ],
                [
                    91.0598596,
                    55.9950969
                ],
                [
                    91.0609633,
                    55.9946596
                ],
                [
                    91.0600666,
                    55.9940938
                ],
                [
                    91.0603425,
                    55.9936695
                ],
                [
                    91.0595837,
                    55.9928851
                ],
                [
                    91.0592388,
                    55.9920235
                ],
                [
                    91.058779,
                    55.9915862
                ],
                [
                    91.0583421,
                    55.9917277
                ],
                [
                    91.0576293,
                    55.9910461
                ],
                [
                    91.0568476,
                    55.9912776
                ],
                [
                    91.0564797,
                    55.9908146
                ],
                [
                    91.055514,
                    55.9905703
                ],
                [
                    91.0557669,
                    55.9891942
                ],
                [
                    91.0550312,
                    55.9888984
                ],
                [
                    91.0550772,
                    55.9878695
                ],
                [
                    91.0545943,
                    55.9877409
                ],
                [
                    91.0536516,
                    55.9870721
                ],
                [
                    91.0540195,
                    55.9864933
                ],
                [
                    91.055652,
                    55.9852585
                ],
                [
                    91.0548932,
                    55.9846411
                ],
                [
                    91.0532837,
                    55.9851299
                ],
                [
                    91.0522951,
                    55.9852457
                ],
                [
                    91.0520881,
                    55.984937
                ],
                [
                    91.0509155,
                    55.9851428
                ],
                [
                    91.0504787,
                    55.984744
                ],
                [
                    91.0509155,
                    55.9846026
                ],
                [
                    91.0491681,
                    55.9831105
                ],
                [
                    91.0503176,
                    55.982969
                ],
                [
                    91.0505016,
                    55.9824416
                ],
                [
                    91.0488002,
                    55.98203
                ],
                [
                    91.0483633,
                    55.981657
                ],
                [
                    91.0461331,
                    55.9817599
                ],
                [
                    91.0458571,
                    55.9811939
                ],
                [
                    91.0445236,
                    55.9815026
                ],
                [
                    91.0437648,
                    55.9820943
                ],
                [
                    91.0420634,
                    55.9824931
                ]
            ],
            "longitude": 91.050804,
            "latitude": 55.987534
        },
        "6500": {
            "name": "Якушево",
            "population": 177,
            "type": "hamlet",
            "poly": [
                [
                    91.0491488,
                    55.1906834
                ],
                [
                    91.0497821,
                    55.1908814
                ],
                [
                    91.0504455,
                    55.1911281
                ],
                [
                    91.0506315,
                    55.1913548
                ],
                [
                    91.0508627,
                    55.1914351
                ],
                [
                    91.0510738,
                    55.191613
                ],
                [
                    91.0514465,
                    55.191627
                ],
                [
                    91.052335,
                    55.1914457
                ],
                [
                    91.0529461,
                    55.191464
                ],
                [
                    91.0532036,
                    55.1916041
                ],
                [
                    91.0537343,
                    55.1917923
                ],
                [
                    91.0541404,
                    55.191868
                ],
                [
                    91.054434,
                    55.1920264
                ],
                [
                    91.0539796,
                    55.192272
                ],
                [
                    91.053871,
                    55.1924257
                ],
                [
                    91.0538751,
                    55.1925359
                ],
                [
                    91.0540399,
                    55.1926461
                ],
                [
                    91.0543897,
                    55.1927172
                ],
                [
                    91.0545546,
                    55.1928894
                ],
                [
                    91.0547999,
                    55.1930363
                ],
                [
                    91.0553587,
                    55.1930959
                ],
                [
                    91.0558614,
                    55.1930087
                ],
                [
                    91.0560744,
                    55.1929766
                ],
                [
                    91.0568023,
                    55.1932612
                ],
                [
                    91.0563077,
                    55.1938166
                ],
                [
                    91.0557488,
                    55.194193
                ],
                [
                    91.0558075,
                    55.1942278
                ],
                [
                    91.0575353,
                    55.1946312
                ],
                [
                    91.057479,
                    55.1947298
                ],
                [
                    91.0578691,
                    55.1948561
                ],
                [
                    91.0577243,
                    55.1950557
                ],
                [
                    91.0580942,
                    55.1951911
                ],
                [
                    91.0583998,
                    55.1952003
                ],
                [
                    91.0589426,
                    55.1950511
                ],
                [
                    91.0602414,
                    55.1952485
                ],
                [
                    91.0604505,
                    55.1951475
                ],
                [
                    91.0610133,
                    55.1951705
                ],
                [
                    91.0611926,
                    55.1950081
                ],
                [
                    91.0616299,
                    55.1950827
                ],
                [
                    91.0623738,
                    55.1952491
                ],
                [
                    91.0631025,
                    55.1954097
                ],
                [
                    91.0634996,
                    55.1954815
                ],
                [
                    91.063952,
                    55.1954528
                ],
                [
                    91.0654344,
                    55.1954657
                ],
                [
                    91.0657254,
                    55.1954352
                ],
                [
                    91.0659148,
                    55.1953565
                ],
                [
                    91.0661104,
                    55.1951192
                ],
                [
                    91.0663718,
                    55.1949946
                ],
                [
                    91.0667795,
                    55.1946609
                ],
                [
                    91.066817,
                    55.1945162
                ],
                [
                    91.0665982,
                    55.1943069
                ],
                [
                    91.0665789,
                    55.1940737
                ],
                [
                    91.0664374,
                    55.1939213
                ],
                [
                    91.0662315,
                    55.1938699
                ],
                [
                    91.0659292,
                    55.1939654
                ],
                [
                    91.0655689,
                    55.1938222
                ],
                [
                    91.0657523,
                    55.1934366
                ],
                [
                    91.0651218,
                    55.1933136
                ],
                [
                    91.0636357,
                    55.1928839
                ],
                [
                    91.0632593,
                    55.1927223
                ],
                [
                    91.0628701,
                    55.1930804
                ],
                [
                    91.0624325,
                    55.1929849
                ],
                [
                    91.0620563,
                    55.1930492
                ],
                [
                    91.0614326,
                    55.1929672
                ],
                [
                    91.0611209,
                    55.1930245
                ],
                [
                    91.0608495,
                    55.1929327
                ],
                [
                    91.0601811,
                    55.1928495
                ],
                [
                    91.0598794,
                    55.192884
                ],
                [
                    91.058814,
                    55.1927405
                ],
                [
                    91.0583214,
                    55.1925512
                ],
                [
                    91.0577987,
                    55.1923073
                ],
                [
                    91.0575022,
                    55.1919745
                ],
                [
                    91.0573162,
                    55.1915499
                ],
                [
                    91.0571252,
                    55.1913376
                ],
                [
                    91.0571956,
                    55.1910392
                ],
                [
                    91.0575172,
                    55.1903592
                ],
                [
                    91.0576077,
                    55.1897681
                ],
                [
                    91.0575424,
                    55.189639
                ],
                [
                    91.0575826,
                    55.1894956
                ],
                [
                    91.0573866,
                    55.189355
                ],
                [
                    91.0571001,
                    55.1892918
                ],
                [
                    91.0569041,
                    55.1891197
                ],
                [
                    91.0569242,
                    55.1889246
                ],
                [
                    91.0564969,
                    55.1884942
                ],
                [
                    91.056502,
                    55.1881556
                ],
                [
                    91.0564517,
                    55.1880609
                ],
                [
                    91.0560949,
                    55.1880007
                ],
                [
                    91.0559943,
                    55.1878974
                ],
                [
                    91.0558335,
                    55.1878802
                ],
                [
                    91.0556626,
                    55.1879777
                ],
                [
                    91.0554515,
                    55.1879892
                ],
                [
                    91.0543407,
                    55.1883479
                ],
                [
                    91.0540141,
                    55.1885917
                ],
                [
                    91.0537929,
                    55.1886922
                ],
                [
                    91.0537276,
                    55.1888672
                ],
                [
                    91.052466,
                    55.1886778
                ],
                [
                    91.0523705,
                    55.1885831
                ],
                [
                    91.0513351,
                    55.188675
                ],
                [
                    91.0511793,
                    55.1885372
                ],
                [
                    91.0509783,
                    55.1884282
                ],
                [
                    91.0507722,
                    55.1884339
                ],
                [
                    91.0502797,
                    55.1885487
                ],
                [
                    91.049767,
                    55.1886032
                ],
                [
                    91.0497218,
                    55.1887295
                ],
                [
                    91.0494604,
                    55.1891197
                ],
                [
                    91.04925,
                    55.189229
                ],
                [
                    91.049189,
                    55.189266
                ],
                [
                    91.0495358,
                    55.1896361
                ],
                [
                    91.0502294,
                    55.1899833
                ],
                [
                    91.0500887,
                    55.1902329
                ],
                [
                    91.0497469,
                    55.190144
                ],
                [
                    91.049566,
                    55.1903219
                ],
                [
                    91.0494353,
                    55.1903047
                ],
                [
                    91.0491488,
                    55.1906834
                ]
            ],
            "longitude": 91.055603,
            "latitude": 55.191948
        },
        "6501": {
            "name": "Табажак",
            "population": 103,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.079956,
            "latitude": 54.810879
        },
        "6502": {
            "name": "Никифоровка",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    91.0640486,
                    57.0990944
                ],
                [
                    91.0683023,
                    57.1016307
                ],
                [
                    91.0719328,
                    57.1018896
                ],
                [
                    91.0791814,
                    57.102205
                ],
                [
                    91.0839154,
                    57.0972059
                ],
                [
                    91.0845309,
                    57.0930921
                ],
                [
                    91.0915066,
                    57.0916532
                ],
                [
                    91.0984824,
                    57.0877313
                ],
                [
                    91.0992844,
                    57.0841638
                ],
                [
                    91.0850039,
                    57.0846164
                ],
                [
                    91.0859766,
                    57.086412
                ],
                [
                    91.0859644,
                    57.0873253
                ],
                [
                    91.0856221,
                    57.0876673
                ],
                [
                    91.084302,
                    57.0883913
                ],
                [
                    91.0836603,
                    57.0885606
                ],
                [
                    91.0816678,
                    57.0889193
                ],
                [
                    91.075721,
                    57.0913998
                ],
                [
                    91.0640486,
                    57.0990944
                ]
            ],
            "longitude": 91.082504,
            "latitude": 57.092522
        },
        "6503": {
            "name": "Кизылка",
            "population": 12,
            "type": "hamlet",
            "poly": [
                [
                    91.0790756,
                    55.5900961
                ],
                [
                    91.0815101,
                    55.5908452
                ],
                [
                    91.0824839,
                    55.5907687
                ],
                [
                    91.0855813,
                    55.5904248
                ],
                [
                    91.0891654,
                    55.5908299
                ],
                [
                    91.0947244,
                    55.5922591
                ],
                [
                    91.0949814,
                    55.5911891
                ],
                [
                    91.095847,
                    55.5902108
                ],
                [
                    91.0989849,
                    55.5888808
                ],
                [
                    91.0988362,
                    55.5883916
                ],
                [
                    91.0970102,
                    55.5882999
                ],
                [
                    91.0936965,
                    55.5885139
                ],
                [
                    91.0930608,
                    55.5882846
                ],
                [
                    91.0885721,
                    55.5876434
                ],
                [
                    91.0863387,
                    55.5873062
                ],
                [
                    91.0849591,
                    55.5872986
                ],
                [
                    91.0831873,
                    55.5880477
                ],
                [
                    91.0822405,
                    55.5874209
                ],
                [
                    91.0815101,
                    55.5877266
                ],
                [
                    91.0800223,
                    55.5872451
                ],
                [
                    91.0792244,
                    55.58804
                ],
                [
                    91.0792123,
                    55.588206
                ],
                [
                    91.0790756,
                    55.5900961
                ]
            ],
            "longitude": 91.087654,
            "latitude": 55.589966
        },
        "6504": {
            "name": "Тесь",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.088997,
            "latitude": 54.744198
        },
        "6505": {
            "name": "Медвежий Яр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.0957466,
            "latitude": 70.535327
        },
        "6506": {
            "name": "Аммала",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    91.0893935,
                    55.7973852
                ],
                [
                    91.0896639,
                    55.7976724
                ],
                [
                    91.0912567,
                    55.7981961
                ],
                [
                    91.0914671,
                    55.7980271
                ],
                [
                    91.0944423,
                    55.7987366
                ],
                [
                    91.1042095,
                    55.8012029
                ],
                [
                    91.1075454,
                    55.8005948
                ],
                [
                    91.1083268,
                    55.7998853
                ],
                [
                    91.1066438,
                    55.7994123
                ],
                [
                    91.1046904,
                    55.7982636
                ],
                [
                    91.1015348,
                    55.7974697
                ],
                [
                    91.1028572,
                    55.7959492
                ],
                [
                    91.0990705,
                    55.7950538
                ],
                [
                    91.0996715,
                    55.7939388
                ],
                [
                    91.0974476,
                    55.7938712
                ],
                [
                    91.0956745,
                    55.7933981
                ],
                [
                    91.0924287,
                    55.7948173
                ],
                [
                    91.0918878,
                    55.7945808
                ],
                [
                    91.0899344,
                    55.7961857
                ],
                [
                    91.0900546,
                    55.796625
                ],
                [
                    91.0893935,
                    55.7973852
                ]
            ],
            "longitude": 91.098251,
            "latitude": 55.797478
        },
        "6507": {
            "name": "Ильтюково",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    91.0942391,
                    55.2132414
                ],
                [
                    91.0944361,
                    55.2134868
                ],
                [
                    91.0944879,
                    55.2136599
                ],
                [
                    91.0945567,
                    55.2137621
                ],
                [
                    91.0961565,
                    55.2146145
                ],
                [
                    91.0971052,
                    55.215231
                ],
                [
                    91.1022416,
                    55.2173184
                ],
                [
                    91.102316,
                    55.2172398
                ],
                [
                    91.1033567,
                    55.2164044
                ],
                [
                    91.1038672,
                    55.2165657
                ],
                [
                    91.1042834,
                    55.2165657
                ],
                [
                    91.105053,
                    55.216176
                ],
                [
                    91.1060583,
                    55.2153874
                ],
                [
                    91.1051002,
                    55.2148812
                ],
                [
                    91.1044169,
                    55.2140658
                ],
                [
                    91.1046133,
                    55.2139403
                ],
                [
                    91.1032625,
                    55.2136177
                ],
                [
                    91.1023358,
                    55.2132324
                ],
                [
                    91.1017704,
                    55.2128874
                ],
                [
                    91.101197,
                    55.2123273
                ],
                [
                    91.1006395,
                    55.2114133
                ],
                [
                    91.1004746,
                    55.2114088
                ],
                [
                    91.0998071,
                    55.210786
                ],
                [
                    91.0992337,
                    55.2100511
                ],
                [
                    91.0990296,
                    55.2093566
                ],
                [
                    91.0990688,
                    55.2088368
                ],
                [
                    91.0980244,
                    55.2091908
                ],
                [
                    91.0970898,
                    55.2096165
                ],
                [
                    91.0957862,
                    55.2096165
                ],
                [
                    91.0958569,
                    55.2101766
                ],
                [
                    91.0954328,
                    55.2103065
                ],
                [
                    91.0950165,
                    55.2103737
                ],
                [
                    91.094726,
                    55.2105306
                ],
                [
                    91.0950086,
                    55.2111803
                ],
                [
                    91.094726,
                    55.212632
                ],
                [
                    91.0942783,
                    55.212986
                ],
                [
                    91.0942391,
                    55.2132414
                ]
            ],
            "longitude": 91.098854,
            "latitude": 55.213848
        },
        "6508": {
            "name": "Постойка",
            "population": 18,
            "type": "hamlet",
            "poly": [
                [
                    91.1145242,
                    56.2348909
                ],
                [
                    91.114787,
                    56.2363409
                ],
                [
                    91.1148527,
                    56.2381091
                ],
                [
                    91.1154815,
                    56.2383073
                ],
                [
                    91.1150686,
                    56.2386619
                ],
                [
                    91.1154252,
                    56.2411236
                ],
                [
                    91.1155472,
                    56.241473
                ],
                [
                    91.1148996,
                    56.2419998
                ],
                [
                    91.1148715,
                    56.2429176
                ],
                [
                    91.1154909,
                    56.2443465
                ],
                [
                    91.1152656,
                    56.2448888
                ],
                [
                    91.115519,
                    56.245306
                ],
                [
                    91.1160915,
                    56.2455094
                ],
                [
                    91.1173115,
                    56.2454208
                ],
                [
                    91.1182407,
                    56.2450401
                ],
                [
                    91.1182876,
                    56.2445864
                ],
                [
                    91.1187475,
                    56.2443934
                ],
                [
                    91.1190383,
                    56.2432514
                ],
                [
                    91.1198925,
                    56.2414991
                ],
                [
                    91.1203899,
                    56.2407116
                ],
                [
                    91.1201552,
                    56.2401118
                ],
                [
                    91.1200145,
                    56.2387819
                ],
                [
                    91.1201834,
                    56.2360384
                ],
                [
                    91.1198737,
                    56.2355794
                ],
                [
                    91.1193575,
                    56.2334929
                ],
                [
                    91.1190009,
                    56.2312133
                ],
                [
                    91.118954,
                    56.2305404
                ],
                [
                    91.1186161,
                    56.2304725
                ],
                [
                    91.1173304,
                    56.2306134
                ],
                [
                    91.1162041,
                    56.2305195
                ],
                [
                    91.1158662,
                    56.2305977
                ],
                [
                    91.1151155,
                    56.2315107
                ],
                [
                    91.1149372,
                    56.23282
                ],
                [
                    91.1145242,
                    56.2348909
                ]
            ],
            "longitude": 91.117851,
            "latitude": 56.238033
        },
        "6509": {
            "name": "Глушково",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    91.1177436,
                    56.0445181
                ],
                [
                    91.1184621,
                    56.0458023
                ],
                [
                    91.1207973,
                    56.047568
                ],
                [
                    91.1225936,
                    56.0477887
                ],
                [
                    91.1251084,
                    56.0482302
                ],
                [
                    91.125755,
                    56.0485913
                ],
                [
                    91.1276232,
                    56.0485311
                ],
                [
                    91.1292399,
                    56.0480496
                ],
                [
                    91.1292758,
                    56.0473674
                ],
                [
                    91.130138,
                    56.0471467
                ],
                [
                    91.1313595,
                    56.0471667
                ],
                [
                    91.1324013,
                    56.0467654
                ],
                [
                    91.1329043,
                    56.0470263
                ],
                [
                    91.132509,
                    56.047568
                ],
                [
                    91.132581,
                    56.0479493
                ],
                [
                    91.1336587,
                    56.0476684
                ],
                [
                    91.1350958,
                    56.0469862
                ],
                [
                    91.1356347,
                    56.0468256
                ],
                [
                    91.1362454,
                    56.0473072
                ],
                [
                    91.1367843,
                    56.0473072
                ],
                [
                    91.1371075,
                    56.0469862
                ],
                [
                    91.1363891,
                    56.0462437
                ],
                [
                    91.1367484,
                    56.045722
                ],
                [
                    91.1376824,
                    56.0453408
                ],
                [
                    91.137898,
                    56.0449395
                ],
                [
                    91.1377902,
                    56.0443776
                ],
                [
                    91.1386524,
                    56.0440766
                ],
                [
                    91.1385087,
                    56.0436753
                ],
                [
                    91.1371795,
                    56.0436151
                ],
                [
                    91.1366047,
                    56.0434947
                ],
                [
                    91.1356495,
                    56.0442449
                ],
                [
                    91.1354549,
                    56.0443977
                ],
                [
                    91.1340539,
                    56.0429529
                ],
                [
                    91.130605,
                    56.0440365
                ],
                [
                    91.1261502,
                    56.0446585
                ],
                [
                    91.1233838,
                    56.0445381
                ],
                [
                    91.1235995,
                    56.0441368
                ],
                [
                    91.1220547,
                    56.0438759
                ],
                [
                    91.1218032,
                    56.0441769
                ],
                [
                    91.1179949,
                    56.0432137
                ],
                [
                    91.1177436,
                    56.0445181
                ]
            ],
            "longitude": 91.12825,
            "latitude": 56.04604
        },
        "6510": {
            "name": "Беловка",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    91.1276587,
                    56.7853594
                ],
                [
                    91.1280477,
                    56.7856517
                ],
                [
                    91.1291422,
                    56.7859788
                ],
                [
                    91.1320731,
                    56.7845021
                ],
                [
                    91.1340009,
                    56.7860887
                ],
                [
                    91.1346341,
                    56.7869212
                ],
                [
                    91.1354482,
                    56.7876941
                ],
                [
                    91.1358282,
                    56.7878923
                ],
                [
                    91.1379721,
                    56.7871689
                ],
                [
                    91.1399713,
                    56.7857617
                ],
                [
                    91.141464,
                    56.7852562
                ],
                [
                    91.1415816,
                    56.7850233
                ],
                [
                    91.1425043,
                    56.7841115
                ],
                [
                    91.143816,
                    56.7820203
                ],
                [
                    91.1432732,
                    56.7812125
                ],
                [
                    91.1434541,
                    56.7811382
                ],
                [
                    91.1427032,
                    56.780702
                ],
                [
                    91.1420972,
                    56.7799735
                ],
                [
                    91.1418529,
                    56.779924
                ],
                [
                    91.1408479,
                    56.7802551
                ],
                [
                    91.1362706,
                    56.7813305
                ],
                [
                    91.1357821,
                    56.7814891
                ],
                [
                    91.1338734,
                    56.7821185
                ],
                [
                    91.1300107,
                    56.7843633
                ],
                [
                    91.1289523,
                    56.7844922
                ],
                [
                    91.1276587,
                    56.7853594
                ]
            ],
            "longitude": 91.1380558,
            "latitude": 56.7834858
        },
        "6511": {
            "name": "Тойлук",
            "population": 190,
            "type": "hamlet",
            "poly": [
                [
                    91.1436186,
                    55.4759575
                ],
                [
                    91.1448172,
                    55.4761273
                ],
                [
                    91.1452926,
                    55.4764318
                ],
                [
                    91.1457472,
                    55.4765782
                ],
                [
                    91.1464809,
                    55.4762913
                ],
                [
                    91.1492604,
                    55.4758814
                ],
                [
                    91.1515957,
                    55.4757174
                ],
                [
                    91.152412,
                    55.4748272
                ],
                [
                    91.1535073,
                    55.4745578
                ],
                [
                    91.1546026,
                    55.4741772
                ],
                [
                    91.1549229,
                    55.4739136
                ],
                [
                    91.1549952,
                    55.4737145
                ],
                [
                    91.1546336,
                    55.4733045
                ],
                [
                    91.1537139,
                    55.4734509
                ],
                [
                    91.1536209,
                    55.473041
                ],
                [
                    91.1532696,
                    55.4729531
                ],
                [
                    91.152846,
                    55.4730058
                ],
                [
                    91.1533523,
                    55.4725432
                ],
                [
                    91.1534865,
                    55.4713308
                ],
                [
                    91.1540859,
                    55.4702414
                ],
                [
                    91.1546956,
                    55.469357
                ],
                [
                    91.1549126,
                    55.4687654
                ],
                [
                    91.1548919,
                    55.4681972
                ],
                [
                    91.1542616,
                    55.4679512
                ],
                [
                    91.1536003,
                    55.4678575
                ],
                [
                    91.1528666,
                    55.4680274
                ],
                [
                    91.1519366,
                    55.4685721
                ],
                [
                    91.1505796,
                    55.4683493
                ],
                [
                    91.1504384,
                    55.4683261
                ],
                [
                    91.1495601,
                    55.4686717
                ],
                [
                    91.1486508,
                    55.4687478
                ],
                [
                    91.1484241,
                    55.4687746
                ],
                [
                    91.1470182,
                    55.4689411
                ],
                [
                    91.1455819,
                    55.4692164
                ],
                [
                    91.1447036,
                    55.4692984
                ],
                [
                    91.1439803,
                    55.4691988
                ],
                [
                    91.1436496,
                    55.4692925
                ],
                [
                    91.1445589,
                    55.4717408
                ],
                [
                    91.1446519,
                    55.4720395
                ],
                [
                    91.1445899,
                    55.4727013
                ],
                [
                    91.1439385,
                    55.4748852
                ],
                [
                    91.1436186,
                    55.4759575
                ]
            ],
            "longitude": 91.14888,
            "latitude": 55.471592
        },
        "6512": {
            "name": "Ключи",
            "population": 252,
            "type": "hamlet",
            "poly": [
                [
                    91.1384982,
                    55.3664113
                ],
                [
                    91.142175,
                    55.3667747
                ],
                [
                    91.14587,
                    55.3669875
                ],
                [
                    91.1473398,
                    55.363527
                ],
                [
                    91.1458721,
                    55.361744
                ],
                [
                    91.1494877,
                    55.3602834
                ],
                [
                    91.1498074,
                    55.3602315
                ],
                [
                    91.1529949,
                    55.359714
                ],
                [
                    91.1565205,
                    55.3599322
                ],
                [
                    91.1575215,
                    55.3590948
                ],
                [
                    91.1582081,
                    55.3583795
                ],
                [
                    91.1585225,
                    55.3571255
                ],
                [
                    91.1557487,
                    55.3546724
                ],
                [
                    91.1558486,
                    55.3540728
                ],
                [
                    91.1569794,
                    55.3515244
                ],
                [
                    91.1587188,
                    55.3491266
                ],
                [
                    91.1497021,
                    55.3479588
                ],
                [
                    91.1423648,
                    55.3447209
                ],
                [
                    91.1414602,
                    55.3458909
                ],
                [
                    91.1452637,
                    55.3478541
                ],
                [
                    91.1389742,
                    55.3498717
                ],
                [
                    91.1392112,
                    55.3502391
                ],
                [
                    91.15025,
                    55.350237
                ],
                [
                    91.150239,
                    55.3518754
                ],
                [
                    91.1515662,
                    55.3533424
                ],
                [
                    91.1514695,
                    55.3536637
                ],
                [
                    91.1506969,
                    55.3545968
                ],
                [
                    91.1507071,
                    55.3552614
                ],
                [
                    91.1504463,
                    55.3555184
                ],
                [
                    91.1501282,
                    55.3559326
                ],
                [
                    91.1497372,
                    55.3562147
                ],
                [
                    91.1492426,
                    55.3563772
                ],
                [
                    91.1471533,
                    55.3564047
                ],
                [
                    91.1459842,
                    55.3563979
                ],
                [
                    91.1458516,
                    55.3559182
                ],
                [
                    91.1455827,
                    55.3559018
                ],
                [
                    91.1440917,
                    55.3562807
                ],
                [
                    91.144067,
                    55.3565558
                ],
                [
                    91.1428574,
                    55.3566484
                ],
                [
                    91.1418947,
                    55.3567691
                ],
                [
                    91.1417812,
                    55.3568533
                ],
                [
                    91.1416775,
                    55.3570806
                ],
                [
                    91.1419095,
                    55.3573753
                ],
                [
                    91.1423561,
                    55.3575079
                ],
                [
                    91.1423802,
                    55.3575832
                ],
                [
                    91.1409679,
                    55.3580932
                ],
                [
                    91.1413288,
                    55.3585035
                ],
                [
                    91.1412397,
                    55.3585439
                ],
                [
                    91.1394391,
                    55.3593613
                ],
                [
                    91.1400838,
                    55.3605829
                ],
                [
                    91.1384982,
                    55.3664113
                ]
            ],
            "longitude": 91.151321,
            "latitude": 55.357048
        },
        "6513": {
            "name": "Курбатово",
            "population": 45,
            "type": "hamlet",
            "poly": [
                [
                    91.1483107,
                    55.5775639
                ],
                [
                    91.1543168,
                    55.5801145
                ],
                [
                    91.1562385,
                    55.581871
                ],
                [
                    91.1565848,
                    55.5817927
                ],
                [
                    91.1575196,
                    55.581778
                ],
                [
                    91.1590518,
                    55.5816068
                ],
                [
                    91.1613111,
                    55.5811567
                ],
                [
                    91.1615275,
                    55.5809022
                ],
                [
                    91.1629038,
                    55.5802368
                ],
                [
                    91.1643581,
                    55.5799285
                ],
                [
                    91.165241,
                    55.5798209
                ],
                [
                    91.1660547,
                    55.5793658
                ],
                [
                    91.1663836,
                    55.5794246
                ],
                [
                    91.1667039,
                    55.5793022
                ],
                [
                    91.1678812,
                    55.5793218
                ],
                [
                    91.1682794,
                    55.5792876
                ],
                [
                    91.1687295,
                    55.5787885
                ],
                [
                    91.1695605,
                    55.5786417
                ],
                [
                    91.1701837,
                    55.5786857
                ],
                [
                    91.1709282,
                    55.5786417
                ],
                [
                    91.1712571,
                    55.5788423
                ],
                [
                    91.172365,
                    55.5792093
                ],
                [
                    91.1729537,
                    55.5795518
                ],
                [
                    91.1731701,
                    55.5798013
                ],
                [
                    91.174105,
                    55.5800509
                ],
                [
                    91.1742522,
                    55.5801977
                ],
                [
                    91.1748494,
                    55.580594
                ],
                [
                    91.1749533,
                    55.5808484
                ],
                [
                    91.1752823,
                    55.5809561
                ],
                [
                    91.1757843,
                    55.581279
                ],
                [
                    91.1756545,
                    55.5815872
                ],
                [
                    91.176044,
                    55.5816949
                ],
                [
                    91.1765894,
                    55.5814698
                ],
                [
                    91.1781821,
                    55.5805206
                ],
                [
                    91.1777147,
                    55.5797084
                ],
                [
                    91.1778705,
                    55.5791603
                ],
                [
                    91.176681,
                    55.5786381
                ],
                [
                    91.1752185,
                    55.5781871
                ],
                [
                    91.1735454,
                    55.5776422
                ],
                [
                    91.1725316,
                    55.5771599
                ],
                [
                    91.1719776,
                    55.576972
                ],
                [
                    91.1713571,
                    55.576853
                ],
                [
                    91.1695123,
                    55.5775482
                ],
                [
                    91.1691023,
                    55.5773885
                ],
                [
                    91.1689583,
                    55.5772194
                ],
                [
                    91.1674458,
                    55.5764678
                ],
                [
                    91.1655844,
                    55.5760011
                ],
                [
                    91.1645152,
                    55.5759135
                ],
                [
                    91.1641385,
                    55.5759698
                ],
                [
                    91.1635623,
                    55.5761828
                ],
                [
                    91.1632521,
                    55.5764145
                ],
                [
                    91.1628366,
                    55.5770628
                ],
                [
                    91.1624765,
                    55.5774167
                ],
                [
                    91.1618227,
                    55.5776328
                ],
                [
                    91.1600776,
                    55.5776798
                ],
                [
                    91.1598062,
                    55.5777706
                ],
                [
                    91.1575514,
                    55.577589
                ],
                [
                    91.1572744,
                    55.5782936
                ],
                [
                    91.1539892,
                    55.5777017
                ],
                [
                    91.1527704,
                    55.5771912
                ],
                [
                    91.1521333,
                    55.5767653
                ],
                [
                    91.1502275,
                    55.5757976
                ],
                [
                    91.1495073,
                    55.5759918
                ],
                [
                    91.1491639,
                    55.5764271
                ],
                [
                    91.1493459,
                    55.5766889
                ],
                [
                    91.1491251,
                    55.576925
                ],
                [
                    91.1483107,
                    55.5775639
                ]
            ],
            "longitude": 91.16423,
            "latitude": 55.578747
        },
        "6514": {
            "name": "Тальцы",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.164322,
            "latitude": 54.893154
        },
        "6515": {
            "name": "Предгорье",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    91.1615995,
                    56.244784
                ],
                [
                    91.1633979,
                    56.2458488
                ],
                [
                    91.1636141,
                    56.246231
                ],
                [
                    91.1640219,
                    56.2465532
                ],
                [
                    91.1649063,
                    56.2462201
                ],
                [
                    91.1668472,
                    56.2452755
                ],
                [
                    91.1669848,
                    56.2449834
                ],
                [
                    91.1681002,
                    56.2443772
                ],
                [
                    91.1681382,
                    56.2441633
                ],
                [
                    91.1693666,
                    56.2436994
                ],
                [
                    91.1707965,
                    56.2428728
                ],
                [
                    91.1696257,
                    56.2423022
                ],
                [
                    91.167035,
                    56.2424526
                ],
                [
                    91.1665931,
                    56.2424782
                ],
                [
                    91.1659309,
                    56.2426541
                ],
                [
                    91.1642035,
                    56.24363
                ],
                [
                    91.1634814,
                    56.2432141
                ],
                [
                    91.1621645,
                    56.2437793
                ],
                [
                    91.1627984,
                    56.2441561
                ],
                [
                    91.1615995,
                    56.244784
                ]
            ],
            "longitude": 91.166344,
            "latitude": 56.244411
        },
        "6516": {
            "name": "Куллог",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.18232,
            "latitude": 54.815712
        },
        "6517": {
            "name": "Берёзовый",
            "population": 159,
            "type": "hamlet",
            "poly": [
                [
                    91.1964928,
                    55.1921714
                ],
                [
                    91.1969169,
                    55.1923585
                ],
                [
                    91.1974308,
                    55.1925382
                ],
                [
                    91.1981246,
                    55.1925235
                ],
                [
                    91.1998785,
                    55.1926775
                ],
                [
                    91.201157,
                    55.1927069
                ],
                [
                    91.2017609,
                    55.1928609
                ],
                [
                    91.2023455,
                    55.1929196
                ],
                [
                    91.2035854,
                    55.1929452
                ],
                [
                    91.2042343,
                    55.1930809
                ],
                [
                    91.2048446,
                    55.1930699
                ],
                [
                    91.2052493,
                    55.1929672
                ],
                [
                    91.2058854,
                    55.1927142
                ],
                [
                    91.206303,
                    55.1924318
                ],
                [
                    91.2068169,
                    55.1921678
                ],
                [
                    91.2089048,
                    55.1916654
                ],
                [
                    91.2109286,
                    55.1913426
                ],
                [
                    91.2114104,
                    55.1915187
                ],
                [
                    91.2118151,
                    55.191537
                ],
                [
                    91.2131321,
                    55.1912546
                ],
                [
                    91.213948,
                    55.1911153
                ],
                [
                    91.2149438,
                    55.1907412
                ],
                [
                    91.2154514,
                    55.1897437
                ],
                [
                    91.2153614,
                    55.1894943
                ],
                [
                    91.2151687,
                    55.1893952
                ],
                [
                    91.214083,
                    55.1888818
                ],
                [
                    91.2128045,
                    55.188372
                ],
                [
                    91.2118922,
                    55.188174
                ],
                [
                    91.2115646,
                    55.1879062
                ],
                [
                    91.2114425,
                    55.1876091
                ],
                [
                    91.2117445,
                    55.1873964
                ],
                [
                    91.2107678,
                    55.186938
                ],
                [
                    91.2103953,
                    55.1866519
                ],
                [
                    91.2099328,
                    55.1866702
                ],
                [
                    91.2087698,
                    55.187026
                ],
                [
                    91.2076457,
                    55.1874698
                ],
                [
                    91.2070932,
                    55.1877595
                ],
                [
                    91.2063864,
                    55.1882656
                ],
                [
                    91.2054035,
                    55.1902204
                ],
                [
                    91.2049602,
                    55.1906385
                ],
                [
                    91.2042793,
                    55.1910676
                ],
                [
                    91.2035533,
                    55.1912986
                ],
                [
                    91.2029815,
                    55.191372
                ],
                [
                    91.202307,
                    55.191339
                ],
                [
                    91.2008807,
                    55.1910346
                ],
                [
                    91.1985487,
                    55.1905762
                ],
                [
                    91.1979833,
                    55.1908035
                ],
                [
                    91.1968333,
                    55.1911813
                ],
                [
                    91.1966085,
                    55.1913243
                ],
                [
                    91.1965828,
                    55.191691
                ],
                [
                    91.1965185,
                    55.1919661
                ],
                [
                    91.1964928,
                    55.1921714
                ]
            ],
            "longitude": 91.20977,
            "latitude": 55.189945
        },
        "6518": {
            "name": "Ничково",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    91.2078349,
                    56.0708355
                ],
                [
                    91.2079818,
                    56.07202
                ],
                [
                    91.2079383,
                    56.0735386
                ],
                [
                    91.2078724,
                    56.0736297
                ],
                [
                    91.2078707,
                    56.074832
                ],
                [
                    91.2087422,
                    56.0748023
                ],
                [
                    91.2100706,
                    56.0744464
                ],
                [
                    91.2103576,
                    56.0744405
                ],
                [
                    91.2108359,
                    56.0743219
                ],
                [
                    91.2114416,
                    56.0742981
                ],
                [
                    91.2122812,
                    56.0740668
                ],
                [
                    91.2135991,
                    56.0738829
                ],
                [
                    91.2151508,
                    56.0730999
                ],
                [
                    91.2165005,
                    56.0725483
                ],
                [
                    91.217659,
                    56.0732186
                ],
                [
                    91.2189875,
                    56.072916
                ],
                [
                    91.2202522,
                    56.0722279
                ],
                [
                    91.2203691,
                    56.072222
                ],
                [
                    91.2203193,
                    56.0706054
                ],
                [
                    91.2198516,
                    56.0704962
                ],
                [
                    91.219537,
                    56.0702305
                ],
                [
                    91.2193755,
                    56.069865
                ],
                [
                    91.219401,
                    56.0693952
                ],
                [
                    91.2192905,
                    56.0691959
                ],
                [
                    91.2185763,
                    56.0689633
                ],
                [
                    91.2183807,
                    56.0687782
                ],
                [
                    91.2181257,
                    56.0686501
                ],
                [
                    91.2177431,
                    56.0685884
                ],
                [
                    91.2175645,
                    56.0686121
                ],
                [
                    91.2173434,
                    56.0687972
                ],
                [
                    91.2172074,
                    56.0688826
                ],
                [
                    91.2169949,
                    56.0688731
                ],
                [
                    91.2167823,
                    56.068783
                ],
                [
                    91.2165719,
                    56.0686613
                ],
                [
                    91.2162367,
                    56.0683478
                ],
                [
                    91.2156664,
                    56.0677282
                ],
                [
                    91.2155968,
                    56.0668995
                ],
                [
                    91.2138903,
                    56.067021
                ],
                [
                    91.2135639,
                    56.0671304
                ],
                [
                    91.213233,
                    56.0671741
                ],
                [
                    91.2129413,
                    56.067162
                ],
                [
                    91.2127237,
                    56.0671255
                ],
                [
                    91.2125713,
                    56.0670648
                ],
                [
                    91.2120315,
                    56.067145
                ],
                [
                    91.2116006,
                    56.0673418
                ],
                [
                    91.2114308,
                    56.0673078
                ],
                [
                    91.2112567,
                    56.0673102
                ],
                [
                    91.2111261,
                    56.0674317
                ],
                [
                    91.211113,
                    56.0675581
                ],
                [
                    91.2111261,
                    56.0677111
                ],
                [
                    91.2110259,
                    56.0677792
                ],
                [
                    91.2097505,
                    56.0679955
                ],
                [
                    91.2090452,
                    56.0677962
                ],
                [
                    91.2078864,
                    56.0677802
                ],
                [
                    91.2079064,
                    56.0678411
                ],
                [
                    91.2080023,
                    56.0679033
                ],
                [
                    91.2079341,
                    56.0697161
                ],
                [
                    91.2080176,
                    56.0698035
                ],
                [
                    91.207948,
                    56.069856
                ],
                [
                    91.2078349,
                    56.0708355
                ]
            ],
            "longitude": 91.214554,
            "latitude": 56.071327
        },
        "6519": {
            "name": "Шарыповка",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    91.198686,
                    56.7955371
                ],
                [
                    91.2128067,
                    56.8059557
                ],
                [
                    91.214513,
                    56.8053261
                ],
                [
                    91.2149589,
                    56.8035256
                ],
                [
                    91.2145716,
                    56.8031482
                ],
                [
                    91.2145311,
                    56.8022578
                ],
                [
                    91.2151212,
                    56.8020704
                ],
                [
                    91.2157249,
                    56.8019791
                ],
                [
                    91.2161528,
                    56.8019939
                ],
                [
                    91.2169547,
                    56.8021518
                ],
                [
                    91.2173106,
                    56.802063
                ],
                [
                    91.2175359,
                    56.8022307
                ],
                [
                    91.2172925,
                    56.8028843
                ],
                [
                    91.2175898,
                    56.8029386
                ],
                [
                    91.2187207,
                    56.8022677
                ],
                [
                    91.2191126,
                    56.8025365
                ],
                [
                    91.2187522,
                    56.8028967
                ],
                [
                    91.2184774,
                    56.803242
                ],
                [
                    91.2194324,
                    56.8033801
                ],
                [
                    91.2199865,
                    56.8032839
                ],
                [
                    91.2201666,
                    56.8031704
                ],
                [
                    91.2206623,
                    56.803353
                ],
                [
                    91.2211623,
                    56.8035898
                ],
                [
                    91.2216669,
                    56.8037106
                ],
                [
                    91.2228066,
                    56.8015696
                ],
                [
                    91.2234328,
                    56.8017497
                ],
                [
                    91.224023,
                    56.8017842
                ],
                [
                    91.2251312,
                    56.8019742
                ],
                [
                    91.2263746,
                    56.8021271
                ],
                [
                    91.2270051,
                    56.8022455
                ],
                [
                    91.2279873,
                    56.802137
                ],
                [
                    91.2292183,
                    56.7995035
                ],
                [
                    91.2272643,
                    56.7990811
                ],
                [
                    91.2258283,
                    56.7988961
                ],
                [
                    91.2258058,
                    56.7986124
                ],
                [
                    91.2249048,
                    56.7984705
                ],
                [
                    91.2247696,
                    56.7987511
                ],
                [
                    91.2228213,
                    56.7986001
                ],
                [
                    91.2223312,
                    56.798341
                ],
                [
                    91.2219259,
                    56.7982269
                ],
                [
                    91.2215599,
                    56.7982084
                ],
                [
                    91.2185472,
                    56.7987758
                ],
                [
                    91.2181755,
                    56.7992507
                ],
                [
                    91.2154669,
                    56.7990965
                ],
                [
                    91.2150896,
                    56.798782
                ],
                [
                    91.2153712,
                    56.798338
                ],
                [
                    91.2145209,
                    56.7979926
                ],
                [
                    91.2138057,
                    56.7978168
                ],
                [
                    91.2138733,
                    56.7976441
                ],
                [
                    91.213665,
                    56.7975023
                ],
                [
                    91.2128822,
                    56.7975671
                ],
                [
                    91.2113505,
                    56.7968701
                ],
                [
                    91.2111084,
                    56.7964076
                ],
                [
                    91.2106072,
                    56.7963681
                ],
                [
                    91.2099385,
                    56.7964452
                ],
                [
                    91.2097713,
                    56.7964982
                ],
                [
                    91.2083019,
                    56.7961754
                ],
                [
                    91.2077563,
                    56.7958477
                ],
                [
                    91.2072812,
                    56.7952021
                ],
                [
                    91.2063134,
                    56.7947925
                ],
                [
                    91.2060142,
                    56.7947588
                ],
                [
                    91.2057327,
                    56.7948262
                ],
                [
                    91.2055039,
                    56.794725
                ],
                [
                    91.2047032,
                    56.7945564
                ],
                [
                    91.2032074,
                    56.7943829
                ],
                [
                    91.2019667,
                    56.794142
                ],
                [
                    91.2018827,
                    56.7939389
                ],
                [
                    91.201061,
                    56.7936784
                ],
                [
                    91.2006898,
                    56.7937593
                ],
                [
                    91.200142,
                    56.7943415
                ],
                [
                    91.1999818,
                    56.7949016
                ],
                [
                    91.198686,
                    56.7955371
                ]
            ],
            "longitude": 91.2213909,
            "latitude": 56.800167
        },
        "6520": {
            "name": "Левоямное",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    91.2185382,
                    56.3195201
                ],
                [
                    91.2195112,
                    56.3200864
                ],
                [
                    91.2193731,
                    56.3203095
                ],
                [
                    91.2202561,
                    56.3205327
                ],
                [
                    91.2214574,
                    56.3199232
                ],
                [
                    91.2216496,
                    56.3202896
                ],
                [
                    91.2222983,
                    56.3206193
                ],
                [
                    91.2228689,
                    56.3211156
                ],
                [
                    91.2235235,
                    56.3213754
                ],
                [
                    91.2243164,
                    56.3216086
                ],
                [
                    91.2238539,
                    56.3221814
                ],
                [
                    91.2250853,
                    56.3225611
                ],
                [
                    91.2233253,
                    56.3236136
                ],
                [
                    91.2242984,
                    56.3240699
                ],
                [
                    91.224863,
                    56.3238568
                ],
                [
                    91.2252234,
                    56.3241465
                ],
                [
                    91.2263706,
                    56.3245828
                ],
                [
                    91.2274999,
                    56.3237735
                ],
                [
                    91.2277882,
                    56.3237502
                ],
                [
                    91.2286771,
                    56.3234438
                ],
                [
                    91.2289474,
                    56.323184
                ],
                [
                    91.2292778,
                    56.3232572
                ],
                [
                    91.2296261,
                    56.3229042
                ],
                [
                    91.2299805,
                    56.3229841
                ],
                [
                    91.2301907,
                    56.3228176
                ],
                [
                    91.23323,
                    56.323597
                ],
                [
                    91.234185,
                    56.3225345
                ],
                [
                    91.235074,
                    56.322328
                ],
                [
                    91.2354644,
                    56.3217818
                ],
                [
                    91.2356566,
                    56.3213321
                ],
                [
                    91.2348516,
                    56.3210457
                ],
                [
                    91.2346896,
                    56.3211722
                ],
                [
                    91.2343111,
                    56.3210756
                ],
                [
                    91.2344193,
                    56.3208958
                ],
                [
                    91.2328516,
                    56.3205594
                ],
                [
                    91.2327915,
                    56.320646
                ],
                [
                    91.2305812,
                    56.3202396
                ],
                [
                    91.230431,
                    56.3203462
                ],
                [
                    91.2290555,
                    56.3199465
                ],
                [
                    91.2287611,
                    56.3195701
                ],
                [
                    91.2278661,
                    56.3194035
                ],
                [
                    91.22765,
                    56.3195301
                ],
                [
                    91.2262265,
                    56.319157
                ],
                [
                    91.2242444,
                    56.318814
                ],
                [
                    91.223866,
                    56.319247
                ],
                [
                    91.2219139,
                    56.3191037
                ],
                [
                    91.2214634,
                    56.318764
                ],
                [
                    91.2199377,
                    56.3188239
                ],
                [
                    91.2188506,
                    56.3191337
                ],
                [
                    91.2185382,
                    56.3195201
                ]
            ],
            "longitude": 91.22699,
            "latitude": 56.321175
        },
        "6521": {
            "name": "Ногинск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.244591,
            "latitude": 64.485275
        },
        "6522": {
            "name": "Шушково",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    91.2338545,
                    56.2072947
                ],
                [
                    91.2341009,
                    56.2076134
                ],
                [
                    91.2343817,
                    56.2082668
                ],
                [
                    91.2346052,
                    56.2086684
                ],
                [
                    91.2345837,
                    56.2088844
                ],
                [
                    91.2344187,
                    56.2092209
                ],
                [
                    91.2344691,
                    56.2093867
                ],
                [
                    91.2349505,
                    56.2097258
                ],
                [
                    91.2351522,
                    56.2102663
                ],
                [
                    91.2357757,
                    56.2111485
                ],
                [
                    91.2362112,
                    56.211536
                ],
                [
                    91.2364496,
                    56.2116788
                ],
                [
                    91.237472,
                    56.2117936
                ],
                [
                    91.2383201,
                    56.2118089
                ],
                [
                    91.2395809,
                    56.2116865
                ],
                [
                    91.2408187,
                    56.2115258
                ],
                [
                    91.2434044,
                    56.2113754
                ],
                [
                    91.2446771,
                    56.2113574
                ],
                [
                    91.248094,
                    56.2115726
                ],
                [
                    91.2483304,
                    56.2112738
                ],
                [
                    91.2480296,
                    56.2099312
                ],
                [
                    91.2479975,
                    56.2098045
                ],
                [
                    91.2491323,
                    56.2095522
                ],
                [
                    91.2502139,
                    56.2091378
                ],
                [
                    91.2513814,
                    56.208349
                ],
                [
                    91.2524346,
                    56.2071219
                ],
                [
                    91.2531581,
                    56.2043408
                ],
                [
                    91.2535669,
                    56.2034015
                ],
                [
                    91.2544624,
                    56.2025361
                ],
                [
                    91.2555257,
                    56.2019446
                ],
                [
                    91.257462,
                    56.2012411
                ],
                [
                    91.2598572,
                    56.2004254
                ],
                [
                    91.261525,
                    56.1994977
                ],
                [
                    91.2621294,
                    56.1989497
                ],
                [
                    91.2611221,
                    56.1987027
                ],
                [
                    91.2580046,
                    56.1986422
                ],
                [
                    91.2577869,
                    56.1980013
                ],
                [
                    91.257082,
                    56.1978706
                ],
                [
                    91.2561135,
                    56.1977718
                ],
                [
                    91.2535836,
                    56.1979071
                ],
                [
                    91.2513247,
                    56.1985308
                ],
                [
                    91.2495366,
                    56.1988241
                ],
                [
                    91.2478576,
                    56.1997678
                ],
                [
                    91.2476456,
                    56.2008421
                ],
                [
                    91.244551,
                    56.2019738
                ],
                [
                    91.2420541,
                    56.2026545
                ],
                [
                    91.2402359,
                    56.2029783
                ],
                [
                    91.2392062,
                    56.2017829
                ],
                [
                    91.2384451,
                    56.2007182
                ],
                [
                    91.2361066,
                    56.2015443
                ],
                [
                    91.2363588,
                    56.2019172
                ],
                [
                    91.23778,
                    56.2046299
                ],
                [
                    91.2378085,
                    56.2048595
                ],
                [
                    91.2374992,
                    56.2051049
                ],
                [
                    91.2360551,
                    56.2050698
                ],
                [
                    91.2356826,
                    56.205175
                ],
                [
                    91.2363473,
                    56.2060006
                ],
                [
                    91.2361869,
                    56.2062938
                ],
                [
                    91.235545,
                    56.2067974
                ],
                [
                    91.2347255,
                    56.206995
                ],
                [
                    91.2338545,
                    56.2072947
                ]
            ],
            "longitude": 91.249115,
            "latitude": 56.202995
        },
        "6523": {
            "name": "Соболевка",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    91.2504683,
                    56.1478816
                ],
                [
                    91.2507286,
                    56.1479892
                ],
                [
                    91.2504766,
                    56.148382
                ],
                [
                    91.251375,
                    56.1488075
                ],
                [
                    91.2529783,
                    56.1491442
                ],
                [
                    91.254481,
                    56.1496071
                ],
                [
                    91.2546992,
                    56.1498689
                ],
                [
                    91.2550602,
                    56.1500046
                ],
                [
                    91.256269,
                    56.1502056
                ],
                [
                    91.2566048,
                    56.1503178
                ],
                [
                    91.2571672,
                    56.1502945
                ],
                [
                    91.2589049,
                    56.1508182
                ],
                [
                    91.2591903,
                    56.1507527
                ],
                [
                    91.259778,
                    56.1502758
                ],
                [
                    91.2598115,
                    56.150084
                ],
                [
                    91.2603656,
                    56.1501682
                ],
                [
                    91.2608776,
                    56.1501776
                ],
                [
                    91.2611547,
                    56.1500934
                ],
                [
                    91.261247,
                    56.1499344
                ],
                [
                    91.2611966,
                    56.1496118
                ],
                [
                    91.2611462,
                    56.1493686
                ],
                [
                    91.2605587,
                    56.1490787
                ],
                [
                    91.2606258,
                    56.1488122
                ],
                [
                    91.2604831,
                    56.1485971
                ],
                [
                    91.2601809,
                    56.1484287
                ],
                [
                    91.2597947,
                    56.1483726
                ],
                [
                    91.251845,
                    56.1460344
                ],
                [
                    91.2517695,
                    56.1464834
                ],
                [
                    91.2515512,
                    56.1467874
                ],
                [
                    91.2514757,
                    56.1471474
                ],
                [
                    91.250653,
                    56.1476431
                ],
                [
                    91.2504683,
                    56.1478816
                ]
            ],
            "longitude": 91.255707,
            "latitude": 56.148846
        },
        "6524": {
            "name": "Дивный",
            "population": 244,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.266174,
            "latitude": 55.094547
        },
        "6525": {
            "name": "Гладкий Мыс",
            "population": 53,
            "type": "hamlet",
            "poly": [
                [
                    91.2534649,
                    55.4837636
                ],
                [
                    91.2536137,
                    55.4839416
                ],
                [
                    91.2540684,
                    55.4841899
                ],
                [
                    91.2555646,
                    55.4844475
                ],
                [
                    91.2562176,
                    55.4846395
                ],
                [
                    91.2572261,
                    55.4848035
                ],
                [
                    91.2571978,
                    55.4848483
                ],
                [
                    91.2564408,
                    55.4860447
                ],
                [
                    91.2653414,
                    55.4879732
                ],
                [
                    91.2711543,
                    55.4899889
                ],
                [
                    91.2725828,
                    55.4890822
                ],
                [
                    91.2732242,
                    55.489337
                ],
                [
                    91.2745799,
                    55.490461
                ],
                [
                    91.2747717,
                    55.490712
                ],
                [
                    91.2768746,
                    55.4904235
                ],
                [
                    91.2771061,
                    55.4901351
                ],
                [
                    91.2763522,
                    55.489588
                ],
                [
                    91.2739451,
                    55.488228
                ],
                [
                    91.274408,
                    55.487591
                ],
                [
                    91.273998,
                    55.4873212
                ],
                [
                    91.2738855,
                    55.4869952
                ],
                [
                    91.2741104,
                    55.4864894
                ],
                [
                    91.2741505,
                    55.48585
                ],
                [
                    91.2736459,
                    55.4853497
                ],
                [
                    91.2750582,
                    55.4838579
                ],
                [
                    91.2751394,
                    55.4838011
                ],
                [
                    91.2738498,
                    55.4833327
                ],
                [
                    91.2724445,
                    55.4830188
                ],
                [
                    91.2728496,
                    55.4823912
                ],
                [
                    91.2727589,
                    55.4823725
                ],
                [
                    91.2699977,
                    55.4816979
                ],
                [
                    91.2686337,
                    55.483609
                ],
                [
                    91.2692041,
                    55.4837402
                ],
                [
                    91.2681956,
                    55.4851454
                ],
                [
                    91.2677492,
                    55.4855576
                ],
                [
                    91.2680551,
                    55.485848
                ],
                [
                    91.2679063,
                    55.4859651
                ],
                [
                    91.2676335,
                    55.4859604
                ],
                [
                    91.2674186,
                    55.4858011
                ],
                [
                    91.2672202,
                    55.4858105
                ],
                [
                    91.2670714,
                    55.48567
                ],
                [
                    91.2667077,
                    55.4858995
                ],
                [
                    91.2649139,
                    55.485759
                ],
                [
                    91.2648808,
                    55.4858995
                ],
                [
                    91.2645832,
                    55.4858995
                ],
                [
                    91.2642939,
                    55.4860962
                ],
                [
                    91.2640128,
                    55.4861196
                ],
                [
                    91.2636078,
                    55.4859885
                ],
                [
                    91.2635664,
                    55.4857402
                ],
                [
                    91.2634259,
                    55.4856606
                ],
                [
                    91.2632771,
                    55.4853983
                ],
                [
                    91.2633019,
                    55.4851454
                ],
                [
                    91.2627894,
                    55.484944
                ],
                [
                    91.2625166,
                    55.4846723
                ],
                [
                    91.2589538,
                    55.4839463
                ],
                [
                    91.2541593,
                    55.4830844
                ],
                [
                    91.2537956,
                    55.4832811
                ],
                [
                    91.2535559,
                    55.4835481
                ],
                [
                    91.2534649,
                    55.4837636
                ]
            ],
            "longitude": 91.271881,
            "latitude": 55.485416
        },
        "6526": {
            "name": "Чёрная Кома",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.274117,
            "latitude": 54.931484
        },
        "6527": {
            "name": "Малиногорка",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    91.2736869,
                    56.187524
                ],
                [
                    91.2738941,
                    56.1877722
                ],
                [
                    91.2748675,
                    56.1879225
                ],
                [
                    91.2756088,
                    56.1877757
                ],
                [
                    91.2760246,
                    56.1878164
                ],
                [
                    91.2764784,
                    56.188697
                ],
                [
                    91.2771286,
                    56.1894342
                ],
                [
                    91.2774721,
                    56.1896117
                ],
                [
                    91.2767974,
                    56.1897482
                ],
                [
                    91.2762331,
                    56.1899871
                ],
                [
                    91.2768096,
                    56.1905536
                ],
                [
                    91.2775181,
                    56.1904248
                ],
                [
                    91.2777002,
                    56.1900753
                ],
                [
                    91.278636,
                    56.1898936
                ],
                [
                    91.2790945,
                    56.1898936
                ],
                [
                    91.2793897,
                    56.1897433
                ],
                [
                    91.2795907,
                    56.1896839
                ],
                [
                    91.2802627,
                    56.1896699
                ],
                [
                    91.2818078,
                    56.1893449
                ],
                [
                    91.2819208,
                    56.1891212
                ],
                [
                    91.2820904,
                    56.1890024
                ],
                [
                    91.2831267,
                    56.1888626
                ],
                [
                    91.2835538,
                    56.1886739
                ],
                [
                    91.2833277,
                    56.1883384
                ],
                [
                    91.2823102,
                    56.1880623
                ],
                [
                    91.2812802,
                    56.1883244
                ],
                [
                    91.2806018,
                    56.1874017
                ],
                [
                    91.2811672,
                    56.1872444
                ],
                [
                    91.2807212,
                    56.1867761
                ],
                [
                    91.2801936,
                    56.1867761
                ],
                [
                    91.279195,
                    56.1863811
                ],
                [
                    91.2790506,
                    56.1860072
                ],
                [
                    91.2777002,
                    56.186147
                ],
                [
                    91.2757972,
                    56.1865175
                ],
                [
                    91.275546,
                    56.1869788
                ],
                [
                    91.275257,
                    56.1872374
                ],
                [
                    91.2747106,
                    56.1873947
                ],
                [
                    91.2742145,
                    56.1873423
                ],
                [
                    91.2736994,
                    56.1873108
                ],
                [
                    91.2736869,
                    56.187524
                ]
            ],
            "longitude": 91.278214,
            "latitude": 56.188015
        },
        "6528": {
            "name": "Мальфино",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    91.2730164,
                    56.0666019
                ],
                [
                    91.2740768,
                    56.0671652
                ],
                [
                    91.2748436,
                    56.0677476
                ],
                [
                    91.2764856,
                    56.0686148
                ],
                [
                    91.2765255,
                    56.0688153
                ],
                [
                    91.2770186,
                    56.069089
                ],
                [
                    91.2768561,
                    56.0691829
                ],
                [
                    91.2770471,
                    56.0693595
                ],
                [
                    91.2776286,
                    56.0696507
                ],
                [
                    91.2775574,
                    56.0697048
                ],
                [
                    91.2781446,
                    56.0700437
                ],
                [
                    91.2783156,
                    56.0699642
                ],
                [
                    91.2788943,
                    56.0702999
                ],
                [
                    91.279798,
                    56.0706468
                ],
                [
                    91.2806104,
                    56.0705624
                ],
                [
                    91.2807471,
                    56.0707072
                ],
                [
                    91.2804365,
                    56.0709077
                ],
                [
                    91.2807729,
                    56.0713516
                ],
                [
                    91.2809496,
                    56.0713532
                ],
                [
                    91.2809211,
                    56.0716221
                ],
                [
                    91.2811178,
                    56.0717001
                ],
                [
                    91.2816106,
                    56.0715469
                ],
                [
                    91.2821415,
                    56.07183
                ],
                [
                    91.2822418,
                    56.0717831
                ],
                [
                    91.2832015,
                    56.0722189
                ],
                [
                    91.2838254,
                    56.0726629
                ],
                [
                    91.2844676,
                    56.0729949
                ],
                [
                    91.2846081,
                    56.0729551
                ],
                [
                    91.2848398,
                    56.0730814
                ],
                [
                    91.2847376,
                    56.0731323
                ],
                [
                    91.2855586,
                    56.0734714
                ],
                [
                    91.285679,
                    56.0734103
                ],
                [
                    91.2861752,
                    56.0736689
                ],
                [
                    91.2863394,
                    56.0735692
                ],
                [
                    91.2866532,
                    56.0737158
                ],
                [
                    91.2865729,
                    56.0740182
                ],
                [
                    91.2873209,
                    56.0743349
                ],
                [
                    91.2873975,
                    56.074285
                ],
                [
                    91.2879339,
                    56.0745161
                ],
                [
                    91.2894445,
                    56.0740345
                ],
                [
                    91.2906285,
                    56.0733849
                ],
                [
                    91.2906285,
                    56.0732606
                ],
                [
                    91.2905172,
                    56.073115
                ],
                [
                    91.2900812,
                    56.0728095
                ],
                [
                    91.2895485,
                    56.0725061
                ],
                [
                    91.2889974,
                    56.072278
                ],
                [
                    91.288151,
                    56.0718391
                ],
                [
                    91.2884812,
                    56.0718707
                ],
                [
                    91.2881455,
                    56.0717353
                ],
                [
                    91.2874906,
                    56.0713422
                ],
                [
                    91.2867335,
                    56.0709838
                ],
                [
                    91.2862336,
                    56.0707159
                ],
                [
                    91.285783,
                    56.0703015
                ],
                [
                    91.2855348,
                    56.0700673
                ],
                [
                    91.2851572,
                    56.0698188
                ],
                [
                    91.2845898,
                    56.0695988
                ],
                [
                    91.2834915,
                    56.0692811
                ],
                [
                    91.2839932,
                    56.0690438
                ],
                [
                    91.2835572,
                    56.0688473
                ],
                [
                    91.2831431,
                    56.0689899
                ],
                [
                    91.2827198,
                    56.068775
                ],
                [
                    91.2822236,
                    56.0690184
                ],
                [
                    91.2813588,
                    56.0684063
                ],
                [
                    91.2806382,
                    56.0679786
                ],
                [
                    91.2800216,
                    56.0673727
                ],
                [
                    91.2799322,
                    56.0672983
                ],
                [
                    91.2788503,
                    56.0666761
                ],
                [
                    91.2780986,
                    56.0664082
                ],
                [
                    91.2773561,
                    56.0661577
                ],
                [
                    91.2752581,
                    56.0653918
                ],
                [
                    91.2745137,
                    56.0650618
                ],
                [
                    91.2741281,
                    56.0649676
                ],
                [
                    91.2730962,
                    56.0655803
                ],
                [
                    91.2740568,
                    56.0660465
                ],
                [
                    91.2730164,
                    56.0666019
                ]
            ],
            "longitude": 91.280807,
            "latitude": 56.069744
        },
        "6529": {
            "name": "Загайново",
            "population": 41,
            "type": "hamlet",
            "poly": [
                [
                    91.2810536,
                    55.8656761
                ],
                [
                    91.2829037,
                    55.8665676
                ],
                [
                    91.2838489,
                    55.8660598
                ],
                [
                    91.2841305,
                    55.8654391
                ],
                [
                    91.28586,
                    55.8648749
                ],
                [
                    91.2890776,
                    55.862584
                ],
                [
                    91.2903446,
                    55.8612636
                ],
                [
                    91.2901234,
                    55.8608798
                ],
                [
                    91.2916316,
                    55.8599882
                ],
                [
                    91.2922953,
                    55.8593449
                ],
                [
                    91.2932807,
                    55.8579905
                ],
                [
                    91.2932405,
                    55.8574487
                ],
                [
                    91.2928986,
                    55.8573584
                ],
                [
                    91.293723,
                    55.8565909
                ],
                [
                    91.2951912,
                    55.8568054
                ],
                [
                    91.2956537,
                    55.8543221
                ],
                [
                    91.2951711,
                    55.8517596
                ],
                [
                    91.2928986,
                    55.8518725
                ],
                [
                    91.2911088,
                    55.8517484
                ],
                [
                    91.2905256,
                    55.8528321
                ],
                [
                    91.2901636,
                    55.8528433
                ],
                [
                    91.2894597,
                    55.8539157
                ],
                [
                    91.2916316,
                    55.8543334
                ],
                [
                    91.2907065,
                    55.8559588
                ],
                [
                    91.2890374,
                    55.8558459
                ],
                [
                    91.2884944,
                    55.8561394
                ],
                [
                    91.2883738,
                    55.8566473
                ],
                [
                    91.2898418,
                    55.8569295
                ],
                [
                    91.2860007,
                    55.8601011
                ],
                [
                    91.2844522,
                    55.8605074
                ],
                [
                    91.2840499,
                    55.861004
                ],
                [
                    91.2843517,
                    55.8610943
                ],
                [
                    91.2834266,
                    55.8619746
                ],
                [
                    91.2836679,
                    55.8621438
                ],
                [
                    91.281677,
                    55.863295
                ],
                [
                    91.2834065,
                    55.8641639
                ],
                [
                    91.2810536,
                    55.8656761
                ]
            ],
            "longitude": 91.290565,
            "latitude": 55.859188
        },
        "6530": {
            "name": "Кипрейный",
            "population": 22,
            "type": "hamlet",
            "poly": [
                [
                    91.2917104,
                    56.887038
                ],
                [
                    91.2927466,
                    56.8875999
                ],
                [
                    91.2933843,
                    56.8878508
                ],
                [
                    91.293817,
                    56.8879814
                ],
                [
                    91.2937031,
                    56.8884728
                ],
                [
                    91.2942687,
                    56.888732
                ],
                [
                    91.2953579,
                    56.8890679
                ],
                [
                    91.2957186,
                    56.8888709
                ],
                [
                    91.2966144,
                    56.8889911
                ],
                [
                    91.2972482,
                    56.8887983
                ],
                [
                    91.2974001,
                    56.8886511
                ],
                [
                    91.297624,
                    56.8885951
                ],
                [
                    91.2980074,
                    56.8883339
                ],
                [
                    91.2983148,
                    56.8882385
                ],
                [
                    91.2984818,
                    56.888338
                ],
                [
                    91.2991992,
                    56.8885848
                ],
                [
                    91.299313,
                    56.8885101
                ],
                [
                    91.299685,
                    56.8878321
                ],
                [
                    91.2998948,
                    56.8877203
                ],
                [
                    91.2999963,
                    56.8876662
                ],
                [
                    91.2999773,
                    56.8870359
                ],
                [
                    91.300534,
                    56.8860353
                ],
                [
                    91.3027497,
                    56.88645
                ],
                [
                    91.3028826,
                    56.8863308
                ],
                [
                    91.3043629,
                    56.8865511
                ],
                [
                    91.3066924,
                    56.8869165
                ],
                [
                    91.3070815,
                    56.886113
                ],
                [
                    91.3074848,
                    56.885885
                ],
                [
                    91.3069771,
                    56.8857865
                ],
                [
                    91.3064789,
                    56.8857554
                ],
                [
                    91.3068822,
                    56.8852681
                ],
                [
                    91.3071669,
                    56.8848767
                ],
                [
                    91.3012362,
                    56.8836066
                ],
                [
                    91.3009563,
                    56.8835547
                ],
                [
                    91.3004629,
                    56.8835651
                ],
                [
                    91.300183,
                    56.8836973
                ],
                [
                    91.2996516,
                    56.8841198
                ],
                [
                    91.2994475,
                    56.8843349
                ],
                [
                    91.2990738,
                    56.8842876
                ],
                [
                    91.2983337,
                    56.8841487
                ],
                [
                    91.2976353,
                    56.8841611
                ],
                [
                    91.297195,
                    56.8841259
                ],
                [
                    91.296637,
                    56.8840014
                ],
                [
                    91.295134,
                    56.8845198
                ],
                [
                    91.2945456,
                    56.8848537
                ],
                [
                    91.2939459,
                    56.885173
                ],
                [
                    91.2935208,
                    56.8854239
                ],
                [
                    91.2931413,
                    56.8857951
                ],
                [
                    91.2929515,
                    56.8861248
                ],
                [
                    91.2917104,
                    56.887038
                ]
            ],
            "longitude": 91.298737,
            "latitude": 56.885429
        },
        "6531": {
            "name": "Новая Дорога",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    91.2986255,
                    56.1543056
                ],
                [
                    91.2992699,
                    56.1544581
                ],
                [
                    91.3014337,
                    56.1545018
                ],
                [
                    91.3056986,
                    56.1546153
                ],
                [
                    91.3074391,
                    56.15479
                ],
                [
                    91.3086797,
                    56.1547989
                ],
                [
                    91.309057,
                    56.1549732
                ],
                [
                    91.3101327,
                    56.155161
                ],
                [
                    91.3102291,
                    56.154857
                ],
                [
                    91.3131513,
                    56.1549732
                ],
                [
                    91.3143395,
                    56.154857
                ],
                [
                    91.3151503,
                    56.1546871
                ],
                [
                    91.315359,
                    56.1544501
                ],
                [
                    91.3153751,
                    56.1541237
                ],
                [
                    91.3152948,
                    56.1537526
                ],
                [
                    91.3155196,
                    56.15314
                ],
                [
                    91.3156079,
                    56.1527644
                ],
                [
                    91.3154473,
                    56.152505
                ],
                [
                    91.3148934,
                    56.1523888
                ],
                [
                    91.3118508,
                    56.151888
                ],
                [
                    91.3073871,
                    56.151718
                ],
                [
                    91.3073871,
                    56.1522546
                ],
                [
                    91.3068011,
                    56.152277
                ],
                [
                    91.306199,
                    56.15204
                ],
                [
                    91.3052918,
                    56.1517717
                ],
                [
                    91.3040234,
                    56.1516152
                ],
                [
                    91.3034213,
                    56.1516152
                ],
                [
                    91.3028513,
                    56.1514766
                ],
                [
                    91.302474,
                    56.1513156
                ],
                [
                    91.2994795,
                    56.1514989
                ],
                [
                    91.2991584,
                    56.1525408
                ],
                [
                    91.2986526,
                    56.1535648
                ],
                [
                    91.2986255,
                    56.1543056
                ]
            ],
            "longitude": 91.304512,
            "latitude": 56.153461
        },
        "6532": {
            "name": "Колмогорово",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.314972,
            "latitude": 59.262726
        },
        "6533": {
            "name": "Бескиш",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.315132,
            "latitude": 54.901943
        },
        "6534": {
            "name": "Курганы",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.315178,
            "latitude": 55.181683
        },
        "6535": {
            "name": "Старая Козулька",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    91.3185624,
                    56.2109962
                ],
                [
                    91.3191144,
                    56.2118899
                ],
                [
                    91.3215678,
                    56.211542
                ],
                [
                    91.322132,
                    56.2119103
                ],
                [
                    91.3226963,
                    56.2121627
                ],
                [
                    91.3232361,
                    56.2121969
                ],
                [
                    91.3243033,
                    56.211883
                ],
                [
                    91.3261311,
                    56.2109825
                ],
                [
                    91.3269898,
                    56.2105459
                ],
                [
                    91.3282042,
                    56.210389
                ],
                [
                    91.3303386,
                    56.2102662
                ],
                [
                    91.3306698,
                    56.2103276
                ],
                [
                    91.33316,
                    56.2101912
                ],
                [
                    91.3338715,
                    56.2100002
                ],
                [
                    91.3339083,
                    56.2098432
                ],
                [
                    91.3337488,
                    56.2094748
                ],
                [
                    91.333712,
                    56.2091405
                ],
                [
                    91.333847,
                    56.208929
                ],
                [
                    91.3342885,
                    56.2085674
                ],
                [
                    91.3365702,
                    56.2075782
                ],
                [
                    91.3368278,
                    56.2073735
                ],
                [
                    91.3377111,
                    56.2070665
                ],
                [
                    91.3383612,
                    56.2070869
                ],
                [
                    91.33895,
                    56.2070051
                ],
                [
                    91.339453,
                    56.2065479
                ],
                [
                    91.3395756,
                    56.2063023
                ],
                [
                    91.3397351,
                    56.2051492
                ],
                [
                    91.3405815,
                    56.2047125
                ],
                [
                    91.3410599,
                    56.2045829
                ],
                [
                    91.3418818,
                    56.2037573
                ],
                [
                    91.3396738,
                    56.2031909
                ],
                [
                    91.3413175,
                    56.2017853
                ],
                [
                    91.3406674,
                    56.2012803
                ],
                [
                    91.3388151,
                    56.2004614
                ],
                [
                    91.3381895,
                    56.2007344
                ],
                [
                    91.3372325,
                    56.2015328
                ],
                [
                    91.3379687,
                    56.2020309
                ],
                [
                    91.3368401,
                    56.202761
                ],
                [
                    91.3354539,
                    56.2037846
                ],
                [
                    91.3343254,
                    56.2029043
                ],
                [
                    91.3334176,
                    56.2023312
                ],
                [
                    91.331504,
                    56.2035526
                ],
                [
                    91.3340678,
                    56.2045965
                ],
                [
                    91.3331846,
                    56.2051902
                ],
                [
                    91.3316389,
                    56.2057838
                ],
                [
                    91.330633,
                    56.2065548
                ],
                [
                    91.3297253,
                    56.2070187
                ],
                [
                    91.3288789,
                    56.2070119
                ],
                [
                    91.3265727,
                    56.2077146
                ],
                [
                    91.3216781,
                    56.208738
                ],
                [
                    91.3206723,
                    56.2091951
                ],
                [
                    91.3207213,
                    56.2095431
                ],
                [
                    91.3212366,
                    56.2101775
                ],
                [
                    91.3185869,
                    56.2106414
                ],
                [
                    91.3185624,
                    56.2109962
                ]
            ],
            "longitude": 91.33255,
            "latitude": 56.207573
        },
        "6536": {
            "name": "Угольный",
            "population": 260,
            "type": "hamlet",
            "poly": [
                [
                    91.3277541,
                    55.3781109
                ],
                [
                    91.3278201,
                    55.3785018
                ],
                [
                    91.328263,
                    55.3788981
                ],
                [
                    91.329262,
                    55.3789302
                ],
                [
                    91.3301196,
                    55.3790266
                ],
                [
                    91.3311092,
                    55.3788713
                ],
                [
                    91.3311186,
                    55.3783305
                ],
                [
                    91.3322307,
                    55.3784322
                ],
                [
                    91.3332108,
                    55.378459
                ],
                [
                    91.3335689,
                    55.3783947
                ],
                [
                    91.3334841,
                    55.379305
                ],
                [
                    91.3332013,
                    55.3794924
                ],
                [
                    91.3329375,
                    55.3798672
                ],
                [
                    91.332994,
                    55.3800707
                ],
                [
                    91.3333899,
                    55.3805418
                ],
                [
                    91.3337197,
                    55.3809166
                ],
                [
                    91.3344171,
                    55.3811094
                ],
                [
                    91.3350015,
                    55.3810558
                ],
                [
                    91.3352936,
                    55.3808095
                ],
                [
                    91.3367167,
                    55.3812325
                ],
                [
                    91.3371596,
                    55.3808952
                ],
                [
                    91.3381775,
                    55.3811683
                ],
                [
                    91.3391293,
                    55.3804829
                ],
                [
                    91.3394686,
                    55.380681
                ],
                [
                    91.3400812,
                    55.3808256
                ],
                [
                    91.3403168,
                    55.3807346
                ],
                [
                    91.3403922,
                    55.3802955
                ],
                [
                    91.3405241,
                    55.3800064
                ],
                [
                    91.341099,
                    55.3794656
                ],
                [
                    91.3410519,
                    55.3791604
                ],
                [
                    91.3410896,
                    55.3787374
                ],
                [
                    91.3411839,
                    55.3784162
                ],
                [
                    91.3409671,
                    55.3781538
                ],
                [
                    91.3405336,
                    55.3780467
                ],
                [
                    91.3400434,
                    55.3781109
                ],
                [
                    91.3399398,
                    55.3779824
                ],
                [
                    91.3400812,
                    55.3779021
                ],
                [
                    91.3402885,
                    55.377463
                ],
                [
                    91.3402791,
                    55.3766063
                ],
                [
                    91.340232,
                    55.3763118
                ],
                [
                    91.3394498,
                    55.3760762
                ],
                [
                    91.3387712,
                    55.3760226
                ],
                [
                    91.3383471,
                    55.3762208
                ],
                [
                    91.3377816,
                    55.3761244
                ],
                [
                    91.3382811,
                    55.3756692
                ],
                [
                    91.3382906,
                    55.3753479
                ],
                [
                    91.338055,
                    55.3749891
                ],
                [
                    91.3371879,
                    55.3748927
                ],
                [
                    91.3369712,
                    55.3745607
                ],
                [
                    91.3365094,
                    55.3744054
                ],
                [
                    91.3359062,
                    55.3744322
                ],
                [
                    91.3350117,
                    55.3748339
                ],
                [
                    91.3346112,
                    55.3749276
                ],
                [
                    91.3332682,
                    55.3750012
                ],
                [
                    91.3325378,
                    55.3748339
                ],
                [
                    91.3319488,
                    55.3745527
                ],
                [
                    91.3315333,
                    55.374475
                ],
                [
                    91.3306851,
                    55.3744911
                ],
                [
                    91.3297144,
                    55.3751551
                ],
                [
                    91.328574,
                    55.3758138
                ],
                [
                    91.3280651,
                    55.3762582
                ],
                [
                    91.3279426,
                    55.3765849
                ],
                [
                    91.3280463,
                    55.3769169
                ],
                [
                    91.327952,
                    55.3773934
                ],
                [
                    91.3277541,
                    55.3781109
                ]
            ],
            "longitude": 91.3347824,
            "latitude": 55.3776762
        },
        "6537": {
            "name": "Уланово",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    91.3314392,
                    56.9295913
                ],
                [
                    91.3425529,
                    56.9349353
                ],
                [
                    91.3465112,
                    56.9327677
                ],
                [
                    91.3396463,
                    56.9302507
                ],
                [
                    91.3412723,
                    56.9288285
                ],
                [
                    91.3422722,
                    56.9266677
                ],
                [
                    91.3455535,
                    56.9272065
                ],
                [
                    91.3501909,
                    56.9185956
                ],
                [
                    91.3554438,
                    56.9180737
                ],
                [
                    91.3590719,
                    56.9139524
                ],
                [
                    91.358763,
                    56.9126896
                ],
                [
                    91.3485636,
                    56.9103341
                ],
                [
                    91.3425277,
                    56.9117216
                ],
                [
                    91.3425091,
                    56.9120985
                ],
                [
                    91.3421862,
                    56.9124045
                ],
                [
                    91.3408388,
                    56.9127895
                ],
                [
                    91.3402337,
                    56.9133183
                ],
                [
                    91.3416034,
                    56.9157498
                ],
                [
                    91.3415626,
                    56.9163374
                ],
                [
                    91.3411877,
                    56.9166657
                ],
                [
                    91.3408462,
                    56.9170709
                ],
                [
                    91.34121,
                    56.9172411
                ],
                [
                    91.3419782,
                    56.9171904
                ],
                [
                    91.3427689,
                    56.9168926
                ],
                [
                    91.3431327,
                    56.9171073
                ],
                [
                    91.343103,
                    56.9175855
                ],
                [
                    91.3407665,
                    56.9214895
                ],
                [
                    91.3401648,
                    56.9215687
                ],
                [
                    91.3389903,
                    56.9221741
                ],
                [
                    91.3386351,
                    56.9227834
                ],
                [
                    91.3392296,
                    56.9230485
                ],
                [
                    91.3397397,
                    56.9235958
                ],
                [
                    91.3397165,
                    56.9241023
                ],
                [
                    91.3391075,
                    56.9243586
                ],
                [
                    91.3381854,
                    56.9244947
                ],
                [
                    91.3369095,
                    56.9247543
                ],
                [
                    91.3353434,
                    56.9252892
                ],
                [
                    91.3350941,
                    56.9259127
                ],
                [
                    91.3352739,
                    56.9266565
                ],
                [
                    91.3346418,
                    56.9270648
                ],
                [
                    91.334346,
                    56.9274984
                ],
                [
                    91.3348814,
                    56.9280714
                ],
                [
                    91.334951,
                    56.9287094
                ],
                [
                    91.3329512,
                    56.9290234
                ],
                [
                    91.3314392,
                    56.9295913
                ]
            ],
            "longitude": 91.348503,
            "latitude": 56.91848
        },
        "6538": {
            "name": "Енисей",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.354843,
            "latitude": 55.03751
        },
        "6539": {
            "name": "Уяр",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.3605578,
            "latitude": 54.621801
        },
        "6540": {
            "name": "Малиногорка",
            "population": 115,
            "type": "hamlet",
            "poly": [
                [
                    91.3593518,
                    56.1442024
                ],
                [
                    91.3725516,
                    56.1461614
                ],
                [
                    91.3727114,
                    56.1462414
                ],
                [
                    91.3727829,
                    56.146431
                ],
                [
                    91.3729342,
                    56.1464451
                ],
                [
                    91.3821942,
                    56.1483482
                ],
                [
                    91.3844744,
                    56.1449356
                ],
                [
                    91.3825305,
                    56.1445697
                ],
                [
                    91.3818527,
                    56.14512
                ],
                [
                    91.3616176,
                    56.1415039
                ],
                [
                    91.3593518,
                    56.1442024
                ]
            ],
            "longitude": 91.370354,
            "latitude": 56.144539
        },
        "6541": {
            "name": "Трясучая",
            "population": 103,
            "type": "hamlet",
            "poly": [
                [
                    91.3711779,
                    55.5630754
                ],
                [
                    91.3712812,
                    55.5632214
                ],
                [
                    91.3725005,
                    55.5633383
                ],
                [
                    91.3733168,
                    55.5632624
                ],
                [
                    91.3753007,
                    55.5632916
                ],
                [
                    91.3765407,
                    55.5631747
                ],
                [
                    91.3776876,
                    55.5629059
                ],
                [
                    91.3782559,
                    55.5627131
                ],
                [
                    91.3784626,
                    55.561971
                ],
                [
                    91.3789586,
                    55.5624501
                ],
                [
                    91.3797336,
                    55.5623917
                ],
                [
                    91.3805085,
                    55.5622573
                ],
                [
                    91.3807979,
                    55.562345
                ],
                [
                    91.3818622,
                    55.5617665
                ],
                [
                    91.3842181,
                    55.560551
                ],
                [
                    91.3857783,
                    55.5603289
                ],
                [
                    91.3856854,
                    55.5601419
                ],
                [
                    91.385954,
                    55.5597738
                ],
                [
                    91.3864825,
                    55.5595698
                ],
                [
                    91.386605,
                    55.5595225
                ],
                [
                    91.3877623,
                    55.5593004
                ],
                [
                    91.3879689,
                    55.5589965
                ],
                [
                    91.3876796,
                    55.5586634
                ],
                [
                    91.3875143,
                    55.5585407
                ],
                [
                    91.3877313,
                    55.5583946
                ],
                [
                    91.3875453,
                    55.5582544
                ],
                [
                    91.3874316,
                    55.5578511
                ],
                [
                    91.387163,
                    55.5578394
                ],
                [
                    91.385799,
                    55.5574479
                ],
                [
                    91.385427,
                    55.5574187
                ],
                [
                    91.3851169,
                    55.5570154
                ],
                [
                    91.385396,
                    55.5561037
                ],
                [
                    91.3850034,
                    55.5558466
                ],
                [
                    91.3842594,
                    55.5555543
                ],
                [
                    91.3836498,
                    55.5555836
                ],
                [
                    91.3839184,
                    55.5551978
                ],
                [
                    91.3837324,
                    55.5549524
                ],
                [
                    91.3833398,
                    55.5548472
                ],
                [
                    91.3830091,
                    55.5548705
                ],
                [
                    91.3819965,
                    55.5551569
                ],
                [
                    91.3806325,
                    55.5553147
                ],
                [
                    91.3796199,
                    55.555455
                ],
                [
                    91.3790206,
                    55.5556479
                ],
                [
                    91.3809219,
                    55.5568226
                ],
                [
                    91.3801779,
                    55.5567817
                ],
                [
                    91.3789586,
                    55.5570388
                ],
                [
                    91.3783489,
                    55.5570505
                ],
                [
                    91.3776566,
                    55.5569687
                ],
                [
                    91.3771917,
                    55.5570213
                ],
                [
                    91.3768507,
                    55.5575648
                ],
                [
                    91.3747221,
                    55.5569336
                ],
                [
                    91.3740298,
                    55.5565128
                ],
                [
                    91.3732858,
                    55.5562849
                ],
                [
                    91.3732445,
                    55.5566881
                ],
                [
                    91.3730481,
                    55.5570855
                ],
                [
                    91.3732548,
                    55.5590375
                ],
                [
                    91.3721182,
                    55.5591076
                ],
                [
                    91.3722938,
                    55.560177
                ],
                [
                    91.3719425,
                    55.5605451
                ],
                [
                    91.3723455,
                    55.561223
                ],
                [
                    91.3727485,
                    55.5616379
                ],
                [
                    91.3738954,
                    55.5613048
                ],
                [
                    91.3740298,
                    55.5615386
                ],
                [
                    91.3740194,
                    55.5617139
                ],
                [
                    91.3743708,
                    55.562567
                ],
                [
                    91.3727588,
                    55.5626839
                ],
                [
                    91.3711779,
                    55.5630754
                ]
            ],
            "longitude": 91.381721,
            "latitude": 55.55912
        },
        "6542": {
            "name": "Марьясово",
            "population": 156,
            "type": "hamlet",
            "poly": [
                [
                    91.4406425,
                    55.3207943
                ],
                [
                    91.4430553,
                    55.322425
                ],
                [
                    91.4451253,
                    55.3235797
                ],
                [
                    91.4459432,
                    55.3243725
                ],
                [
                    91.4492956,
                    55.3256938
                ],
                [
                    91.4503154,
                    55.3259408
                ],
                [
                    91.4519108,
                    55.3263831
                ],
                [
                    91.4520045,
                    55.3262844
                ],
                [
                    91.4522037,
                    55.3261304
                ],
                [
                    91.4526581,
                    55.3259063
                ],
                [
                    91.4530822,
                    55.3255157
                ],
                [
                    91.4537789,
                    55.3250791
                ],
                [
                    91.4561821,
                    55.3243438
                ],
                [
                    91.456788,
                    55.3238957
                ],
                [
                    91.4580199,
                    55.3236774
                ],
                [
                    91.4585551,
                    55.3231201
                ],
                [
                    91.4587065,
                    55.322672
                ],
                [
                    91.4589792,
                    55.3221205
                ],
                [
                    91.4589287,
                    55.3215632
                ],
                [
                    91.4592921,
                    55.3211438
                ],
                [
                    91.4593931,
                    55.3208565
                ],
                [
                    91.4591508,
                    55.3206784
                ],
                [
                    91.4589691,
                    55.3203107
                ],
                [
                    91.4578179,
                    55.319897
                ],
                [
                    91.4581512,
                    55.319627
                ],
                [
                    91.4577876,
                    55.3193397
                ],
                [
                    91.4571818,
                    55.3192191
                ],
                [
                    91.4570504,
                    55.3190122
                ],
                [
                    91.456687,
                    55.3189318
                ],
                [
                    91.4557378,
                    55.319604
                ],
                [
                    91.4557277,
                    55.3200809
                ],
                [
                    91.4550613,
                    55.3205807
                ],
                [
                    91.4542838,
                    55.3209714
                ],
                [
                    91.4541121,
                    55.3211495
                ],
                [
                    91.4529711,
                    55.3212185
                ],
                [
                    91.4520724,
                    55.3215574
                ],
                [
                    91.4509718,
                    55.3216206
                ],
                [
                    91.4502952,
                    55.3214655
                ],
                [
                    91.4491744,
                    55.3215747
                ],
                [
                    91.4484171,
                    55.3213334
                ],
                [
                    91.447892,
                    55.320845
                ],
                [
                    91.4467106,
                    55.3205348
                ],
                [
                    91.4443276,
                    55.3202073
                ],
                [
                    91.443302,
                    55.3199742
                ],
                [
                    91.4433424,
                    55.3197674
                ],
                [
                    91.4431647,
                    55.3194411
                ],
                [
                    91.4424942,
                    55.3193124
                ],
                [
                    91.4422034,
                    55.3197169
                ],
                [
                    91.4416473,
                    55.319649
                ],
                [
                    91.4406425,
                    55.3207943
                ]
            ],
            "longitude": 91.452286,
            "latitude": 55.322777
        },
        "6543": {
            "name": "Красный Хутор",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.4552325,
            "latitude": 53.0416706
        },
        "6544": {
            "name": "Тайга",
            "population": 14,
            "type": "hamlet",
            "poly": [
                [
                    91.4588736,
                    56.2158443
                ],
                [
                    91.4589024,
                    56.2159675
                ],
                [
                    91.4602503,
                    56.2166347
                ],
                [
                    91.4615039,
                    56.2173754
                ],
                [
                    91.4624329,
                    56.2182965
                ],
                [
                    91.4630149,
                    56.218869
                ],
                [
                    91.4642237,
                    56.2200203
                ],
                [
                    91.4643804,
                    56.2204497
                ],
                [
                    91.4645707,
                    56.2205742
                ],
                [
                    91.4653878,
                    56.2207173
                ],
                [
                    91.4670107,
                    56.22068
                ],
                [
                    91.4691261,
                    56.2205306
                ],
                [
                    91.4692716,
                    56.2193607
                ],
                [
                    91.4696746,
                    56.2187632
                ],
                [
                    91.4704804,
                    56.218813
                ],
                [
                    91.470861,
                    56.2179044
                ],
                [
                    91.4708162,
                    56.2172945
                ],
                [
                    91.471208,
                    56.2169397
                ],
                [
                    91.4701335,
                    56.2165538
                ],
                [
                    91.4707155,
                    56.2156576
                ],
                [
                    91.4667981,
                    56.2149667
                ],
                [
                    91.4657124,
                    56.2149107
                ],
                [
                    91.4630149,
                    56.2149356
                ],
                [
                    91.461918,
                    56.2151472
                ],
                [
                    91.4600153,
                    56.2156701
                ],
                [
                    91.4588736,
                    56.2158443
                ]
            ],
            "longitude": 91.465576,
            "latitude": 56.217304
        },
        "6545": {
            "name": "Кемчуг",
            "population": 154,
            "type": "hamlet",
            "poly": [
                [
                    91.4587192,
                    57.0238101
                ],
                [
                    91.4589045,
                    57.0240829
                ],
                [
                    91.4602752,
                    57.0244307
                ],
                [
                    91.460603,
                    57.0244591
                ],
                [
                    91.4606624,
                    57.0243596
                ],
                [
                    91.4610662,
                    57.0243673
                ],
                [
                    91.4614534,
                    57.0244656
                ],
                [
                    91.4615247,
                    57.0243195
                ],
                [
                    91.4617409,
                    57.0241889
                ],
                [
                    91.4625058,
                    57.023907
                ],
                [
                    91.4640024,
                    57.0236394
                ],
                [
                    91.4651854,
                    57.0237118
                ],
                [
                    91.4666952,
                    57.0240316
                ],
                [
                    91.4677234,
                    57.0245084
                ],
                [
                    91.4686514,
                    57.0250518
                ],
                [
                    91.4693158,
                    57.0258539
                ],
                [
                    91.4695274,
                    57.0259529
                ],
                [
                    91.4704516,
                    57.0260619
                ],
                [
                    91.4706669,
                    57.0262054
                ],
                [
                    91.4712868,
                    57.0263831
                ],
                [
                    91.4715095,
                    57.0263751
                ],
                [
                    91.4716431,
                    57.0263528
                ],
                [
                    91.4726156,
                    57.02527
                ],
                [
                    91.4733505,
                    57.024769
                ],
                [
                    91.4739555,
                    57.0244841
                ],
                [
                    91.4746348,
                    57.0243387
                ],
                [
                    91.4755628,
                    57.0243124
                ],
                [
                    91.4760936,
                    57.0243407
                ],
                [
                    91.4772108,
                    57.0247023
                ],
                [
                    91.4774038,
                    57.024571
                ],
                [
                    91.4792449,
                    57.0254013
                ],
                [
                    91.481279,
                    57.0261973
                ],
                [
                    91.4818172,
                    57.0263629
                ],
                [
                    91.4823888,
                    57.0264862
                ],
                [
                    91.4830792,
                    57.0265286
                ],
                [
                    91.483135,
                    57.0264154
                ],
                [
                    91.4834912,
                    57.0262236
                ],
                [
                    91.4837733,
                    57.025967
                ],
                [
                    91.4838942,
                    57.0256012
                ],
                [
                    91.4822826,
                    57.0251068
                ],
                [
                    91.4824461,
                    57.024722
                ],
                [
                    91.4804867,
                    57.0244272
                ],
                [
                    91.4797683,
                    57.0239473
                ],
                [
                    91.4796334,
                    57.0236483
                ],
                [
                    91.4791811,
                    57.0234311
                ],
                [
                    91.4787934,
                    57.0233866
                ],
                [
                    91.4786946,
                    57.0235242
                ],
                [
                    91.4783962,
                    57.0235945
                ],
                [
                    91.4779913,
                    57.0234539
                ],
                [
                    91.4778147,
                    57.0233556
                ],
                [
                    91.4776531,
                    57.0231715
                ],
                [
                    91.4770697,
                    57.0229832
                ],
                [
                    91.4765831,
                    57.0229077
                ],
                [
                    91.4762753,
                    57.022677
                ],
                [
                    91.4756101,
                    57.0224515
                ],
                [
                    91.4757185,
                    57.0223077
                ],
                [
                    91.4769937,
                    57.0224288
                ],
                [
                    91.4774802,
                    57.0217419
                ],
                [
                    91.4775619,
                    57.0214253
                ],
                [
                    91.4777576,
                    57.0213043
                ],
                [
                    91.4777728,
                    57.0211822
                ],
                [
                    91.4777405,
                    57.020994
                ],
                [
                    91.4770127,
                    57.0208936
                ],
                [
                    91.477273,
                    57.0205222
                ],
                [
                    91.4776435,
                    57.0204033
                ],
                [
                    91.4785577,
                    57.0204519
                ],
                [
                    91.4785805,
                    57.0200474
                ],
                [
                    91.4771362,
                    57.0197867
                ],
                [
                    91.47695,
                    57.0194112
                ],
                [
                    91.4759806,
                    57.0194215
                ],
                [
                    91.4757261,
                    57.0194484
                ],
                [
                    91.4758286,
                    57.0197971
                ],
                [
                    91.4758192,
                    57.020125
                ],
                [
                    91.4756177,
                    57.0204353
                ],
                [
                    91.474196,
                    57.0220451
                ],
                [
                    91.4740415,
                    57.0220438
                ],
                [
                    91.4739584,
                    57.0219869
                ],
                [
                    91.4739346,
                    57.0218317
                ],
                [
                    91.4736971,
                    57.0216908
                ],
                [
                    91.4730888,
                    57.0214761
                ],
                [
                    91.4725164,
                    57.0213804
                ],
                [
                    91.4720223,
                    57.021255
                ],
                [
                    91.471552,
                    57.0212201
                ],
                [
                    91.4710697,
                    57.021202
                ],
                [
                    91.4706516,
                    57.0212783
                ],
                [
                    91.4703024,
                    57.0212938
                ],
                [
                    91.4700862,
                    57.0212654
                ],
                [
                    91.4700055,
                    57.0210662
                ],
                [
                    91.4695779,
                    57.0208748
                ],
                [
                    91.4684804,
                    57.0205787
                ],
                [
                    91.4679055,
                    57.020483
                ],
                [
                    91.4677938,
                    57.0206718
                ],
                [
                    91.4673876,
                    57.0205955
                ],
                [
                    91.4672593,
                    57.0205128
                ],
                [
                    91.4666916,
                    57.0205567
                ],
                [
                    91.46505,
                    57.0210223
                ],
                [
                    91.4644799,
                    57.0211425
                ],
                [
                    91.4637934,
                    57.0213223
                ],
                [
                    91.4628265,
                    57.0213688
                ],
                [
                    91.4627125,
                    57.0216016
                ],
                [
                    91.4617385,
                    57.0219584
                ],
                [
                    91.4613513,
                    57.0222985
                ],
                [
                    91.4601397,
                    57.0230485
                ],
                [
                    91.459724,
                    57.0234545
                ],
                [
                    91.4595102,
                    57.0235295
                ],
                [
                    91.4594627,
                    57.0238243
                ],
                [
                    91.4593724,
                    57.0238631
                ],
                [
                    91.4589852,
                    57.0238114
                ],
                [
                    91.4587192,
                    57.0238101
                ]
            ],
            "longitude": 91.472061,
            "latitude": 57.023518
        },
        "6546": {
            "name": "Шарловка",
            "population": 76,
            "type": "hamlet",
            "poly": [
                [
                    91.4639943,
                    56.1149493
                ],
                [
                    91.464388,
                    56.1157105
                ],
                [
                    91.4645404,
                    56.1157565
                ],
                [
                    91.4646293,
                    56.1162769
                ],
                [
                    91.466185,
                    56.1162981
                ],
                [
                    91.4663311,
                    56.1163831
                ],
                [
                    91.4697728,
                    56.1172823
                ],
                [
                    91.4724525,
                    56.1176505
                ],
                [
                    91.4730177,
                    56.1178204
                ],
                [
                    91.4741861,
                    56.1179478
                ],
                [
                    91.4749481,
                    56.117962
                ],
                [
                    91.4762943,
                    56.1182523
                ],
                [
                    91.4768214,
                    56.1182948
                ],
                [
                    91.4773802,
                    56.1184859
                ],
                [
                    91.478339,
                    56.1185142
                ],
                [
                    91.4789105,
                    56.1186381
                ],
                [
                    91.4796154,
                    56.1188541
                ],
                [
                    91.4810441,
                    56.1190842
                ],
                [
                    91.4823395,
                    56.1191054
                ],
                [
                    91.4837493,
                    56.119332
                ],
                [
                    91.4840414,
                    56.1193497
                ],
                [
                    91.4841557,
                    56.1192895
                ],
                [
                    91.4842319,
                    56.1190629
                ],
                [
                    91.4844922,
                    56.1184682
                ],
                [
                    91.4844478,
                    56.1181496
                ],
                [
                    91.4847472,
                    56.1178752
                ],
                [
                    91.4862424,
                    56.1182501
                ],
                [
                    91.4864692,
                    56.1178661
                ],
                [
                    91.4858637,
                    56.1175982
                ],
                [
                    91.4860385,
                    56.1171829
                ],
                [
                    91.4853061,
                    56.1170634
                ],
                [
                    91.4852454,
                    56.1168273
                ],
                [
                    91.4839469,
                    56.1165593
                ],
                [
                    91.4839074,
                    56.1164793
                ],
                [
                    91.4835911,
                    56.1163934
                ],
                [
                    91.4834247,
                    56.1163331
                ],
                [
                    91.4825673,
                    56.1161985
                ],
                [
                    91.4800738,
                    56.1158197
                ],
                [
                    91.4783831,
                    56.1156348
                ],
                [
                    91.4778922,
                    56.1156185
                ],
                [
                    91.4767738,
                    56.1156783
                ],
                [
                    91.4765494,
                    56.1156729
                ],
                [
                    91.4764031,
                    56.1156384
                ],
                [
                    91.4755416,
                    56.1152922
                ],
                [
                    91.4752587,
                    56.1151436
                ],
                [
                    91.4750604,
                    56.1151073
                ],
                [
                    91.474693,
                    56.1151254
                ],
                [
                    91.4742086,
                    56.1149224
                ],
                [
                    91.4736559,
                    56.1147865
                ],
                [
                    91.4730381,
                    56.1146505
                ],
                [
                    91.4725212,
                    56.114569
                ],
                [
                    91.4720237,
                    56.1145273
                ],
                [
                    91.4698259,
                    56.1141647
                ],
                [
                    91.4695561,
                    56.1140959
                ],
                [
                    91.469374,
                    56.1139762
                ],
                [
                    91.4692309,
                    56.11392
                ],
                [
                    91.4679792,
                    56.113456
                ],
                [
                    91.4671274,
                    56.1133218
                ],
                [
                    91.466152,
                    56.1151363
                ],
                [
                    91.4649541,
                    56.1150481
                ],
                [
                    91.4645707,
                    56.1149418
                ],
                [
                    91.4643262,
                    56.1149273
                ],
                [
                    91.4639943,
                    56.1149493
                ]
            ],
            "longitude": 91.474319,
            "latitude": 56.117031
        },
        "6547": {
            "name": "Мендельский",
            "population": 66,
            "type": "hamlet",
            "poly": [
                [
                    91.4712739,
                    57.0947314
                ],
                [
                    91.4712865,
                    57.0949836
                ],
                [
                    91.471386,
                    57.0953102
                ],
                [
                    91.471585,
                    57.0955692
                ],
                [
                    91.4719042,
                    57.0959093
                ],
                [
                    91.4731936,
                    57.0971728
                ],
                [
                    91.4748354,
                    57.0989993
                ],
                [
                    91.4754642,
                    57.0996636
                ],
                [
                    91.4758415,
                    57.0999474
                ],
                [
                    91.4790007,
                    57.1019619
                ],
                [
                    91.4795024,
                    57.1017097
                ],
                [
                    91.4803357,
                    57.1017547
                ],
                [
                    91.4812727,
                    57.1016804
                ],
                [
                    91.4817661,
                    57.1016804
                ],
                [
                    91.4823326,
                    57.1009539
                ],
                [
                    91.4825051,
                    57.100898
                ],
                [
                    91.4825448,
                    57.1008061
                ],
                [
                    91.4826245,
                    57.1007737
                ],
                [
                    91.4841625,
                    57.1010017
                ],
                [
                    91.4838775,
                    57.1004809
                ],
                [
                    91.4835406,
                    57.0997385
                ],
                [
                    91.4833852,
                    57.0990136
                ],
                [
                    91.4833398,
                    57.0982183
                ],
                [
                    91.4835082,
                    57.0971873
                ],
                [
                    91.4822774,
                    57.0971274
                ],
                [
                    91.4818887,
                    57.0965925
                ],
                [
                    91.4818952,
                    57.0957128
                ],
                [
                    91.4815518,
                    57.0954911
                ],
                [
                    91.4817331,
                    57.0950406
                ],
                [
                    91.4814223,
                    57.0949034
                ],
                [
                    91.4814417,
                    57.0945057
                ],
                [
                    91.4810466,
                    57.0939707
                ],
                [
                    91.4806384,
                    57.0937631
                ],
                [
                    91.4807097,
                    57.0931507
                ],
                [
                    91.480457,
                    57.0929044
                ],
                [
                    91.4800295,
                    57.092739
                ],
                [
                    91.4796837,
                    57.0926076
                ],
                [
                    91.4792327,
                    57.0924363
                ],
                [
                    91.478099,
                    57.0924574
                ],
                [
                    91.4772633,
                    57.0922814
                ],
                [
                    91.4767062,
                    57.0925665
                ],
                [
                    91.476486,
                    57.0926615
                ],
                [
                    91.4759742,
                    57.0927742
                ],
                [
                    91.4750284,
                    57.0925595
                ],
                [
                    91.4747369,
                    57.0928903
                ],
                [
                    91.4732145,
                    57.0924468
                ],
                [
                    91.4731432,
                    57.092482
                ],
                [
                    91.4730979,
                    57.0927073
                ],
                [
                    91.4729878,
                    57.092834
                ],
                [
                    91.4727675,
                    57.092834
                ],
                [
                    91.4726574,
                    57.0927918
                ],
                [
                    91.4724242,
                    57.0926334
                ],
                [
                    91.4718064,
                    57.0925717
                ],
                [
                    91.4717632,
                    57.0931525
                ],
                [
                    91.4716679,
                    57.0934498
                ],
                [
                    91.4714563,
                    57.0938845
                ],
                [
                    91.4713569,
                    57.0943462
                ],
                [
                    91.4712739,
                    57.0947314
                ]
            ],
            "longitude": 91.478111,
            "latitude": 57.097839
        },
        "6548": {
            "name": "Саянск",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.4804592,
            "latitude": 53.1406535
        },
        "6549": {
            "name": "Комарково",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.4885706,
            "latitude": 53.7738176
        },
        "6550": {
            "name": "Ломоносово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.4905787,
            "latitude": 75.6334185
        },
        "6551": {
            "name": "Ганина Гарь",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    91.4896471,
                    57.0717175
                ],
                [
                    91.4940857,
                    57.0733452
                ],
                [
                    91.4976273,
                    57.0744193
                ],
                [
                    91.4990713,
                    57.0734278
                ],
                [
                    91.5009257,
                    57.0717175
                ],
                [
                    91.5009561,
                    57.0701806
                ],
                [
                    91.5035402,
                    57.0671562
                ],
                [
                    91.5127059,
                    57.0612803
                ],
                [
                    91.5134051,
                    57.0598918
                ],
                [
                    91.5131011,
                    57.0589164
                ],
                [
                    91.5081002,
                    57.0562301
                ],
                [
                    91.5047714,
                    57.0585941
                ],
                [
                    91.5013665,
                    57.0591396
                ],
                [
                    91.5004545,
                    57.059495
                ],
                [
                    91.4899815,
                    57.0675363
                ],
                [
                    91.4896471,
                    57.0717175
                ]
            ],
            "longitude": 91.500618,
            "latitude": 57.065361
        },
        "6552": {
            "name": "Безъязыково",
            "population": 190,
            "type": "hamlet",
            "poly": [
                [
                    91.4901417,
                    55.2855242
                ],
                [
                    91.4903245,
                    55.2856604
                ],
                [
                    91.4909717,
                    55.286037
                ],
                [
                    91.4914078,
                    55.2864496
                ],
                [
                    91.4916998,
                    55.2869443
                ],
                [
                    91.4917068,
                    55.2873229
                ],
                [
                    91.4915767,
                    55.2877675
                ],
                [
                    91.4912847,
                    55.2884425
                ],
                [
                    91.4911687,
                    55.2887629
                ],
                [
                    91.4914852,
                    55.2887809
                ],
                [
                    91.4917033,
                    55.288845
                ],
                [
                    91.4917173,
                    55.2896041
                ],
                [
                    91.4920655,
                    55.2897983
                ],
                [
                    91.4942566,
                    55.291022
                ],
                [
                    91.4945361,
                    55.2909247
                ],
                [
                    91.4944833,
                    55.2910874
                ],
                [
                    91.4945669,
                    55.2911876
                ],
                [
                    91.4949582,
                    55.2914079
                ],
                [
                    91.4951604,
                    55.2915606
                ],
                [
                    91.4956507,
                    55.2918228
                ],
                [
                    91.4967424,
                    55.2914351
                ],
                [
                    91.4978651,
                    55.2908535
                ],
                [
                    91.4979287,
                    55.2908123
                ],
                [
                    91.4981521,
                    55.290578
                ],
                [
                    91.4984194,
                    55.2904466
                ],
                [
                    91.4987232,
                    55.2903505
                ],
                [
                    91.4997868,
                    55.2898057
                ],
                [
                    91.4998684,
                    55.2896904
                ],
                [
                    91.4997868,
                    55.2894869
                ],
                [
                    91.4996151,
                    55.2895077
                ],
                [
                    91.4996096,
                    55.2894805
                ],
                [
                    91.4996883,
                    55.2894164
                ],
                [
                    91.5001188,
                    55.2892914
                ],
                [
                    91.5005325,
                    55.2890991
                ],
                [
                    91.5027187,
                    55.2887082
                ],
                [
                    91.5031211,
                    55.2887018
                ],
                [
                    91.5035824,
                    55.2885496
                ],
                [
                    91.5042212,
                    55.2882724
                ],
                [
                    91.5043901,
                    55.2881698
                ],
                [
                    91.5052041,
                    55.2877629
                ],
                [
                    91.5056306,
                    55.2873698
                ],
                [
                    91.5056657,
                    55.2871695
                ],
                [
                    91.5056877,
                    55.286829
                ],
                [
                    91.5057801,
                    55.2866563
                ],
                [
                    91.506101,
                    55.2864911
                ],
                [
                    91.5063516,
                    55.2864059
                ],
                [
                    91.5064703,
                    55.2861806
                ],
                [
                    91.5066286,
                    55.2860379
                ],
                [
                    91.5066637,
                    55.2858576
                ],
                [
                    91.5066154,
                    55.2855397
                ],
                [
                    91.5064571,
                    55.2854245
                ],
                [
                    91.5061538,
                    55.2853293
                ],
                [
                    91.5061494,
                    55.2852843
                ],
                [
                    91.5067651,
                    55.2851775
                ],
                [
                    91.5077279,
                    55.2851124
                ],
                [
                    91.5083082,
                    55.2849622
                ],
                [
                    91.5087303,
                    55.2848169
                ],
                [
                    91.508849,
                    55.2846767
                ],
                [
                    91.5088358,
                    55.2843412
                ],
                [
                    91.5087918,
                    55.2840808
                ],
                [
                    91.5085984,
                    55.2838104
                ],
                [
                    91.5082862,
                    55.283545
                ],
                [
                    91.5081851,
                    55.2834073
                ],
                [
                    91.5081983,
                    55.2832245
                ],
                [
                    91.5082335,
                    55.2830868
                ],
                [
                    91.5049757,
                    55.2835901
                ],
                [
                    91.5030721,
                    55.2839682
                ],
                [
                    91.5029314,
                    55.2840783
                ],
                [
                    91.5026807,
                    55.284489
                ],
                [
                    91.5025577,
                    55.2848495
                ],
                [
                    91.5024785,
                    55.2849196
                ],
                [
                    91.5023597,
                    55.284857
                ],
                [
                    91.5020169,
                    55.2847844
                ],
                [
                    91.5018806,
                    55.2846692
                ],
                [
                    91.5018058,
                    55.284524
                ],
                [
                    91.5016169,
                    55.2844264
                ],
                [
                    91.4982712,
                    55.2845966
                ],
                [
                    91.4982184,
                    55.2849722
                ],
                [
                    91.4980777,
                    55.2852276
                ],
                [
                    91.4979898,
                    55.2853603
                ],
                [
                    91.4979678,
                    55.2855681
                ],
                [
                    91.4959894,
                    55.2850523
                ],
                [
                    91.4955146,
                    55.2848195
                ],
                [
                    91.494332,
                    55.2845165
                ],
                [
                    91.4939099,
                    55.2846943
                ],
                [
                    91.4936769,
                    55.2848795
                ],
                [
                    91.4936637,
                    55.2851224
                ],
                [
                    91.4931966,
                    55.2850417
                ],
                [
                    91.492295,
                    55.2850222
                ],
                [
                    91.4917283,
                    55.2851004
                ],
                [
                    91.4904758,
                    55.2852458
                ],
                [
                    91.4902542,
                    55.285336
                ],
                [
                    91.4901417,
                    55.2855242
                ]
            ],
            "longitude": 91.500626,
            "latitude": 55.287468
        },
        "6553": {
            "name": "Голубая",
            "population": 261,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.5079806,
            "latitude": 52.9773072
        },
        "6554": {
            "name": "Таловая",
            "population": 180,
            "type": "hamlet",
            "poly": [
                [
                    91.5144738,
                    55.3395493
                ],
                [
                    91.5146506,
                    55.3400349
                ],
                [
                    91.5150144,
                    55.3405665
                ],
                [
                    91.5159264,
                    55.3412985
                ],
                [
                    91.5163078,
                    55.3416927
                ],
                [
                    91.5178487,
                    55.3429799
                ],
                [
                    91.5180962,
                    55.3431494
                ],
                [
                    91.5180429,
                    55.3432892
                ],
                [
                    91.5180104,
                    55.3433533
                ],
                [
                    91.5189602,
                    55.3439107
                ],
                [
                    91.5202434,
                    55.3449277
                ],
                [
                    91.5211074,
                    55.3457235
                ],
                [
                    91.522714,
                    55.3476051
                ],
                [
                    91.5237446,
                    55.3497682
                ],
                [
                    91.5244064,
                    55.352135
                ],
                [
                    91.5267631,
                    55.3516988
                ],
                [
                    91.5290287,
                    55.3498317
                ],
                [
                    91.5297155,
                    55.3490327
                ],
                [
                    91.5301023,
                    55.3492841
                ],
                [
                    91.530718,
                    55.3493469
                ],
                [
                    91.5310969,
                    55.3492661
                ],
                [
                    91.5314206,
                    55.3484493
                ],
                [
                    91.5321626,
                    55.348153
                ],
                [
                    91.5330309,
                    55.3475112
                ],
                [
                    91.5328731,
                    55.346995
                ],
                [
                    91.5324705,
                    55.3466404
                ],
                [
                    91.5322923,
                    55.3464719
                ],
                [
                    91.532687,
                    55.3463316
                ],
                [
                    91.5331434,
                    55.3463036
                ],
                [
                    91.5345619,
                    55.3457215
                ],
                [
                    91.5330694,
                    55.3452726
                ],
                [
                    91.5310835,
                    55.3446343
                ],
                [
                    91.5294924,
                    55.3437506
                ],
                [
                    91.5271488,
                    55.3430211
                ],
                [
                    91.5259401,
                    55.3427616
                ],
                [
                    91.5248423,
                    55.3421654
                ],
                [
                    91.5238925,
                    55.3414429
                ],
                [
                    91.5230661,
                    55.3404609
                ],
                [
                    91.5223631,
                    55.3395981
                ],
                [
                    91.522249,
                    55.33919
                ],
                [
                    91.5217063,
                    55.339176
                ],
                [
                    91.5213397,
                    55.3393576
                ],
                [
                    91.5204253,
                    55.3390207
                ],
                [
                    91.5175001,
                    55.3382104
                ],
                [
                    91.5168484,
                    55.3378742
                ],
                [
                    91.5167018,
                    55.3377507
                ],
                [
                    91.5161916,
                    55.3376903
                ],
                [
                    91.5157672,
                    55.3377191
                ],
                [
                    91.5154236,
                    55.3378713
                ],
                [
                    91.5150649,
                    55.3382075
                ],
                [
                    91.5150245,
                    55.3385006
                ],
                [
                    91.5153327,
                    55.338742
                ],
                [
                    91.5153166,
                    55.3387854
                ],
                [
                    91.5150346,
                    55.3387736
                ],
                [
                    91.5147315,
                    55.3388741
                ],
                [
                    91.5145243,
                    55.3390753
                ],
                [
                    91.5144738,
                    55.3395493
                ]
            ],
            "longitude": 91.5257616,
            "latitude": 55.3450638
        },
        "6555": {
            "name": "Куртак",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.535423,
            "latitude": 55.148136
        },
        "6556": {
            "name": "Чесноки",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.539452,
            "latitude": 55.20525
        },
        "6557": {
            "name": "Сарушка",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.5468576,
            "latitude": 54.5005922
        },
        "6558": {
            "name": "Малый Кайдат",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    91.5531055,
                    55.9685567
                ],
                [
                    91.5540281,
                    55.9691115
                ],
                [
                    91.5535926,
                    55.9693681
                ],
                [
                    91.5545782,
                    55.9699165
                ],
                [
                    91.5553232,
                    55.9705707
                ],
                [
                    91.5559479,
                    55.9707696
                ],
                [
                    91.5562343,
                    55.9709973
                ],
                [
                    91.5556728,
                    55.9711704
                ],
                [
                    91.5546126,
                    55.971815
                ],
                [
                    91.5543605,
                    55.971799
                ],
                [
                    91.5535066,
                    55.9722127
                ],
                [
                    91.5548476,
                    55.9730946
                ],
                [
                    91.5551628,
                    55.9736044
                ],
                [
                    91.5554035,
                    55.9738642
                ],
                [
                    91.5572086,
                    55.9749577
                ],
                [
                    91.5566585,
                    55.9754835
                ],
                [
                    91.5566699,
                    55.9756824
                ],
                [
                    91.556859,
                    55.9758395
                ],
                [
                    91.5572946,
                    55.9760415
                ],
                [
                    91.5579765,
                    55.9761762
                ],
                [
                    91.5582401,
                    55.976173
                ],
                [
                    91.5592602,
                    55.9758395
                ],
                [
                    91.5594608,
                    55.9759677
                ],
                [
                    91.5600109,
                    55.976314
                ],
                [
                    91.5615983,
                    55.9753841
                ],
                [
                    91.5615525,
                    55.9751789
                ],
                [
                    91.5620224,
                    55.9748198
                ],
                [
                    91.5621771,
                    55.9748871
                ],
                [
                    91.5642687,
                    55.9734633
                ],
                [
                    91.5646356,
                    55.9734601
                ],
                [
                    91.5647559,
                    55.973489
                ],
                [
                    91.5654837,
                    55.9733415
                ],
                [
                    91.5656155,
                    55.9734569
                ],
                [
                    91.5658734,
                    55.9734217
                ],
                [
                    91.5663834,
                    55.9730914
                ],
                [
                    91.5664522,
                    55.9728669
                ],
                [
                    91.5663204,
                    55.9727771
                ],
                [
                    91.5661313,
                    55.9727579
                ],
                [
                    91.5656499,
                    55.9722768
                ],
                [
                    91.5656499,
                    55.971876
                ],
                [
                    91.5655525,
                    55.9716996
                ],
                [
                    91.5646413,
                    55.9712538
                ],
                [
                    91.5639078,
                    55.9708786
                ],
                [
                    91.5632373,
                    55.970699
                ],
                [
                    91.5619765,
                    55.9701827
                ],
                [
                    91.5613118,
                    55.9696984
                ],
                [
                    91.5579536,
                    55.9679954
                ],
                [
                    91.5557817,
                    55.9674246
                ],
                [
                    91.5557301,
                    55.967524
                ],
                [
                    91.5551799,
                    55.9678255
                ],
                [
                    91.5550539,
                    55.967973
                ],
                [
                    91.5546184,
                    55.9679441
                ],
                [
                    91.5531055,
                    55.9685567
                ]
            ],
            "longitude": 91.560883,
            "latitude": 55.97282
        },
        "6559": {
            "name": "Малые Сыры",
            "population": 38,
            "type": "hamlet",
            "poly": [
                [
                    91.5594141,
                    55.5053529
                ],
                [
                    91.5600167,
                    55.5056743
                ],
                [
                    91.5607392,
                    55.5058807
                ],
                [
                    91.5612303,
                    55.5062303
                ],
                [
                    91.5612022,
                    55.5066514
                ],
                [
                    91.5614267,
                    55.5067468
                ],
                [
                    91.5631104,
                    55.5070328
                ],
                [
                    91.5636155,
                    55.5061827
                ],
                [
                    91.5643731,
                    55.5055311
                ],
                [
                    91.5643943,
                    55.5054835
                ],
                [
                    91.5648221,
                    55.504522
                ],
                [
                    91.5650746,
                    55.5039498
                ],
                [
                    91.5656359,
                    55.5030042
                ],
                [
                    91.5663655,
                    55.5031711
                ],
                [
                    91.5667162,
                    55.5026546
                ],
                [
                    91.5672213,
                    55.5024082
                ],
                [
                    91.5675721,
                    55.5024162
                ],
                [
                    91.5680632,
                    55.5008268
                ],
                [
                    91.5684981,
                    55.5005328
                ],
                [
                    91.5686524,
                    55.5000481
                ],
                [
                    91.5677124,
                    55.4996507
                ],
                [
                    91.5679228,
                    55.4991977
                ],
                [
                    91.5682315,
                    55.4992295
                ],
                [
                    91.5683718,
                    55.4986732
                ],
                [
                    91.5692417,
                    55.4987288
                ],
                [
                    91.569831,
                    55.4986255
                ],
                [
                    91.5701677,
                    55.4983394
                ],
                [
                    91.5694381,
                    55.4980533
                ],
                [
                    91.5719777,
                    55.497791
                ],
                [
                    91.5717672,
                    55.4972109
                ],
                [
                    91.5698871,
                    55.4972109
                ],
                [
                    91.5691575,
                    55.4962651
                ],
                [
                    91.5685402,
                    55.4963684
                ],
                [
                    91.5676444,
                    55.4961376
                ],
                [
                    91.5674468,
                    55.4961986
                ],
                [
                    91.5666746,
                    55.4961986
                ],
                [
                    91.5659383,
                    55.4961885
                ],
                [
                    91.5656884,
                    55.4966825
                ],
                [
                    91.5653797,
                    55.4969845
                ],
                [
                    91.5654639,
                    55.4971991
                ],
                [
                    91.5657445,
                    55.4974534
                ],
                [
                    91.5656884,
                    55.4976759
                ],
                [
                    91.5646569,
                    55.4973799
                ],
                [
                    91.5629544,
                    55.4987634
                ],
                [
                    91.5629544,
                    55.4991296
                ],
                [
                    91.562473,
                    55.5002974
                ],
                [
                    91.5629903,
                    55.5010746
                ],
                [
                    91.5632417,
                    55.5018151
                ],
                [
                    91.5631627,
                    55.5020877
                ],
                [
                    91.5630262,
                    55.5022504
                ],
                [
                    91.5630262,
                    55.5025352
                ],
                [
                    91.5628035,
                    55.5027224
                ],
                [
                    91.5622432,
                    55.503117
                ],
                [
                    91.5622575,
                    55.503296
                ],
                [
                    91.5611225,
                    55.5041707
                ],
                [
                    91.5599875,
                    55.5045491
                ],
                [
                    91.5606556,
                    55.5048868
                ],
                [
                    91.5602102,
                    55.5050048
                ],
                [
                    91.5598901,
                    55.5051138
                ],
                [
                    91.559501,
                    55.5051312
                ],
                [
                    91.5594141,
                    55.5053529
                ]
            ],
            "longitude": 91.56562,
            "latitude": 55.499996
        },
        "6560": {
            "name": "Виленка",
            "population": 38,
            "type": "hamlet",
            "poly": [
                [
                    91.5585097,
                    55.597314
                ],
                [
                    91.5592929,
                    55.5976421
                ],
                [
                    91.5621125,
                    55.5992149
                ],
                [
                    91.5630554,
                    55.5997983
                ],
                [
                    91.564088,
                    55.600123
                ],
                [
                    91.56451,
                    55.6003868
                ],
                [
                    91.5652194,
                    55.6010767
                ],
                [
                    91.5660994,
                    55.6016094
                ],
                [
                    91.5667011,
                    55.6019239
                ],
                [
                    91.5672309,
                    55.6024464
                ],
                [
                    91.5687484,
                    55.603116
                ],
                [
                    91.5691704,
                    55.6034052
                ],
                [
                    91.5712986,
                    55.6043842
                ],
                [
                    91.5740194,
                    55.6053683
                ],
                [
                    91.5751418,
                    55.6056269
                ],
                [
                    91.5760398,
                    55.605698
                ],
                [
                    91.5773867,
                    55.6055458
                ],
                [
                    91.5785541,
                    55.605348
                ],
                [
                    91.5788524,
                    55.6052045
                ],
                [
                    91.5789673,
                    55.605015
                ],
                [
                    91.579736,
                    55.6044537
                ],
                [
                    91.5801527,
                    55.6043117
                ],
                [
                    91.5802748,
                    55.6040804
                ],
                [
                    91.5803179,
                    55.6038085
                ],
                [
                    91.5802245,
                    55.6034757
                ],
                [
                    91.5791685,
                    55.6028102
                ],
                [
                    91.5774902,
                    55.6015565
                ],
                [
                    91.5740444,
                    55.5999648
                ],
                [
                    91.5722485,
                    55.5991975
                ],
                [
                    91.5713505,
                    55.5989565
                ],
                [
                    91.5704189,
                    55.5981892
                ],
                [
                    91.5690383,
                    55.5974282
                ],
                [
                    91.5676352,
                    55.596775
                ],
                [
                    91.5661199,
                    55.5962676
                ],
                [
                    91.5654239,
                    55.595589
                ],
                [
                    91.5645597,
                    55.5951324
                ],
                [
                    91.5637179,
                    55.5947899
                ],
                [
                    91.5631679,
                    55.5948089
                ],
                [
                    91.5618771,
                    55.5950245
                ],
                [
                    91.5613255,
                    55.5952228
                ],
                [
                    91.5596658,
                    55.5952402
                ],
                [
                    91.5589812,
                    55.5959632
                ],
                [
                    91.5587342,
                    55.5967369
                ],
                [
                    91.5585097,
                    55.597314
                ]
            ],
            "longitude": 91.565697,
            "latitude": 55.598637
        },
        "6561": {
            "name": "Большой Кемчуг",
            "population": 138,
            "type": "hamlet",
            "poly": [
                [
                    91.5643558,
                    56.1881585
                ],
                [
                    91.566179,
                    56.189015
                ],
                [
                    91.5670035,
                    56.189015
                ],
                [
                    91.5706041,
                    56.189688
                ],
                [
                    91.5735633,
                    56.1902232
                ],
                [
                    91.574113,
                    56.1905495
                ],
                [
                    91.5743329,
                    56.1910491
                ],
                [
                    91.5775395,
                    56.1918087
                ],
                [
                    91.5778691,
                    56.1922279
                ],
                [
                    91.5799492,
                    56.1925266
                ],
                [
                    91.58109,
                    56.1920288
                ],
                [
                    91.5814926,
                    56.1914065
                ],
                [
                    91.5818281,
                    56.1912447
                ],
                [
                    91.5842438,
                    56.1913567
                ],
                [
                    91.5856082,
                    56.1927133
                ],
                [
                    91.5858766,
                    56.1938956
                ],
                [
                    91.5868831,
                    56.1941693
                ],
                [
                    91.588091,
                    56.1942316
                ],
                [
                    91.5936828,
                    56.1915434
                ],
                [
                    91.5956735,
                    56.1915807
                ],
                [
                    91.5972392,
                    56.1913567
                ],
                [
                    91.5986931,
                    56.1901868
                ],
                [
                    91.5992747,
                    56.1895894
                ],
                [
                    91.6015114,
                    56.1895396
                ],
                [
                    91.6030548,
                    56.1899628
                ],
                [
                    91.6044415,
                    56.1879713
                ],
                [
                    91.6001246,
                    56.186988
                ],
                [
                    91.6027639,
                    56.1858678
                ],
                [
                    91.6035021,
                    56.184262
                ],
                [
                    91.6043296,
                    56.1830545
                ],
                [
                    91.6018022,
                    56.1804278
                ],
                [
                    91.5956735,
                    56.1823201
                ],
                [
                    91.5867489,
                    56.1841126
                ],
                [
                    91.5707115,
                    56.187349
                ],
                [
                    91.5669537,
                    56.1880211
                ],
                [
                    91.5643558,
                    56.1881585
                ]
            ],
            "longitude": 91.59021,
            "latitude": 56.186325
        },
        "6562": {
            "name": "Алгаштык",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.6077784,
            "latitude": 54.6547067
        },
        "6563": {
            "name": "Кара-Беллык",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.6099953,
            "latitude": 54.5838989
        },
        "6564": {
            "name": "Уза",
            "population": 233,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.6230563,
            "latitude": 54.436944
        },
        "6565": {
            "name": "Шарып",
            "population": 173,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.6244082,
            "latitude": 53.099455
        },
        "6566": {
            "name": "Ямская",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.630806,
            "latitude": 55.234749
        },
        "6567": {
            "name": "Листвягово",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.6478271,
            "latitude": 53.9825664
        },
        "6568": {
            "name": "Кривинское",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.6534738,
            "latitude": 53.5647149
        },
        "6569": {
            "name": "Можарский",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    91.6504606,
                    56.1866926
                ],
                [
                    91.6509149,
                    56.1868649
                ],
                [
                    91.6516239,
                    56.1870288
                ],
                [
                    91.6518985,
                    56.1869621
                ],
                [
                    91.6522131,
                    56.186826
                ],
                [
                    91.6520683,
                    56.187126
                ],
                [
                    91.6519485,
                    56.1874067
                ],
                [
                    91.6521332,
                    56.1876901
                ],
                [
                    91.6525077,
                    56.1880624
                ],
                [
                    91.6532466,
                    56.188218
                ],
                [
                    91.6530868,
                    56.1885013
                ],
                [
                    91.6529121,
                    56.1886958
                ],
                [
                    91.653007,
                    56.1886903
                ],
                [
                    91.6531168,
                    56.1886236
                ],
                [
                    91.6534164,
                    56.1886708
                ],
                [
                    91.6534014,
                    56.1887597
                ],
                [
                    91.6538358,
                    56.1888459
                ],
                [
                    91.6539406,
                    56.1888181
                ],
                [
                    91.6540055,
                    56.1887597
                ],
                [
                    91.6543949,
                    56.188832
                ],
                [
                    91.6543351,
                    56.1889987
                ],
                [
                    91.6551938,
                    56.1891459
                ],
                [
                    91.6569114,
                    56.1895238
                ],
                [
                    91.6575904,
                    56.1896794
                ],
                [
                    91.6576752,
                    56.1885736
                ],
                [
                    91.6580148,
                    56.1884097
                ],
                [
                    91.6581596,
                    56.1879484
                ],
                [
                    91.6591332,
                    56.1873955
                ],
                [
                    91.6598322,
                    56.1871955
                ],
                [
                    91.6597374,
                    56.1867732
                ],
                [
                    91.6597623,
                    56.1865703
                ],
                [
                    91.6596575,
                    56.1862814
                ],
                [
                    91.6596525,
                    56.1860591
                ],
                [
                    91.6597673,
                    56.1858646
                ],
                [
                    91.6597174,
                    56.185684
                ],
                [
                    91.6595726,
                    56.1855367
                ],
                [
                    91.6592031,
                    56.1853783
                ],
                [
                    91.6585291,
                    56.1851977
                ],
                [
                    91.6576853,
                    56.1851005
                ],
                [
                    91.6573508,
                    56.1848976
                ],
                [
                    91.6556332,
                    56.1849199
                ],
                [
                    91.6553536,
                    56.1847504
                ],
                [
                    91.6548943,
                    56.1847448
                ],
                [
                    91.6548892,
                    56.1848949
                ],
                [
                    91.6548044,
                    56.1852088
                ],
                [
                    91.6541453,
                    56.1853978
                ],
                [
                    91.6539656,
                    56.1855534
                ],
                [
                    91.6530569,
                    56.1858618
                ],
                [
                    91.652982,
                    56.1860674
                ],
                [
                    91.6526624,
                    56.1860841
                ],
                [
                    91.6519934,
                    56.186098
                ],
                [
                    91.6509249,
                    56.1862619
                ],
                [
                    91.6504606,
                    56.1866926
                ]
            ],
            "longitude": 91.655739,
            "latitude": 56.187244
        },
        "6570": {
            "name": "Малые Ручьи",
            "population": 123,
            "type": "hamlet",
            "poly": [
                [
                    91.6686879,
                    56.058591
                ],
                [
                    91.6687514,
                    56.0592031
                ],
                [
                    91.6693393,
                    56.059597
                ],
                [
                    91.66946,
                    56.0594036
                ],
                [
                    91.6697174,
                    56.0591428
                ],
                [
                    91.6702353,
                    56.0587898
                ],
                [
                    91.6707056,
                    56.0587046
                ],
                [
                    91.6710806,
                    56.0586869
                ],
                [
                    91.6713729,
                    56.0587117
                ],
                [
                    91.6721133,
                    56.0589281
                ],
                [
                    91.6733303,
                    56.0592457
                ],
                [
                    91.6734034,
                    56.0591623
                ],
                [
                    91.6735686,
                    56.0592014
                ],
                [
                    91.6740707,
                    56.0590701
                ],
                [
                    91.674417,
                    56.0590488
                ],
                [
                    91.6750716,
                    56.0589157
                ],
                [
                    91.6755133,
                    56.0588944
                ],
                [
                    91.6761425,
                    56.0587631
                ],
                [
                    91.6768257,
                    56.0587383
                ],
                [
                    91.6759709,
                    56.0576241
                ],
                [
                    91.6747507,
                    56.0578973
                ],
                [
                    91.673038,
                    56.0581475
                ],
                [
                    91.6733494,
                    56.0577075
                ],
                [
                    91.6736099,
                    56.0573207
                ],
                [
                    91.6744838,
                    56.0568434
                ],
                [
                    91.6745791,
                    56.0565915
                ],
                [
                    91.6745918,
                    56.0563821
                ],
                [
                    91.6743216,
                    56.0558622
                ],
                [
                    91.6742995,
                    56.0556156
                ],
                [
                    91.6734034,
                    56.0549148
                ],
                [
                    91.673092,
                    56.0547835
                ],
                [
                    91.6726853,
                    56.0548154
                ],
                [
                    91.6722182,
                    56.0549059
                ],
                [
                    91.6732541,
                    56.054425
                ],
                [
                    91.6744806,
                    56.0538146
                ],
                [
                    91.6746999,
                    56.0535893
                ],
                [
                    91.6732445,
                    56.0529505
                ],
                [
                    91.6727679,
                    56.0534952
                ],
                [
                    91.672161,
                    56.0540879
                ],
                [
                    91.6715509,
                    56.054622
                ],
                [
                    91.6709884,
                    56.0544233
                ],
                [
                    91.6702353,
                    56.0550514
                ],
                [
                    91.669997,
                    56.0555553
                ],
                [
                    91.6693965,
                    56.0559811
                ],
                [
                    91.6688849,
                    56.0567849
                ],
                [
                    91.6690247,
                    56.0571575
                ],
                [
                    91.6689452,
                    56.0572231
                ],
                [
                    91.6689357,
                    56.0573526
                ],
                [
                    91.6688817,
                    56.0575514
                ],
                [
                    91.6688658,
                    56.0577678
                ],
                [
                    91.6690088,
                    56.0580251
                ],
                [
                    91.6691709,
                    56.0582149
                ],
                [
                    91.6692598,
                    56.058293
                ],
                [
                    91.6694791,
                    56.0583373
                ],
                [
                    91.6686879,
                    56.058591
                ]
            ],
            "longitude": 91.671448,
            "latitude": 56.05711
        },
        "6571": {
            "name": "Ижульское",
            "population": 138,
            "type": "hamlet",
            "poly": [
                [
                    91.6765037,
                    55.1899503
                ],
                [
                    91.6767969,
                    55.19022
                ],
                [
                    91.6766592,
                    55.1937381
                ],
                [
                    91.676751,
                    55.1947862
                ],
                [
                    91.6766706,
                    55.1949762
                ],
                [
                    91.6777724,
                    55.1949762
                ],
                [
                    91.6776921,
                    55.1952448
                ],
                [
                    91.6779216,
                    55.1957623
                ],
                [
                    91.6784496,
                    55.1962274
                ],
                [
                    91.6790808,
                    55.1966532
                ],
                [
                    91.6799989,
                    55.1967187
                ],
                [
                    91.6804695,
                    55.1967056
                ],
                [
                    91.6810548,
                    55.1964632
                ],
                [
                    91.6813417,
                    55.1965942
                ],
                [
                    91.6816631,
                    55.1968824
                ],
                [
                    91.6821681,
                    55.1970527
                ],
                [
                    91.6825697,
                    55.197151
                ],
                [
                    91.6826081,
                    55.1980215
                ],
                [
                    91.6840461,
                    55.198007
                ],
                [
                    91.6843968,
                    55.1979455
                ],
                [
                    91.6845064,
                    55.1979194
                ],
                [
                    91.6845951,
                    55.1972992
                ],
                [
                    91.6845422,
                    55.1968129
                ],
                [
                    91.6869456,
                    55.1964842
                ],
                [
                    91.6874744,
                    55.1963501
                ],
                [
                    91.6875978,
                    55.1962025
                ],
                [
                    91.6875978,
                    55.1959576
                ],
                [
                    91.6870161,
                    55.1950152
                ],
                [
                    91.6869691,
                    55.1940593
                ],
                [
                    91.6871395,
                    55.1939385
                ],
                [
                    91.6872394,
                    55.1937373
                ],
                [
                    91.6872394,
                    55.1935662
                ],
                [
                    91.6873863,
                    55.1932207
                ],
                [
                    91.6882971,
                    55.1932342
                ],
                [
                    91.6890727,
                    55.1931771
                ],
                [
                    91.689249,
                    55.1931369
                ],
                [
                    91.6894018,
                    55.192835
                ],
                [
                    91.6893959,
                    55.1926338
                ],
                [
                    91.6891198,
                    55.1924124
                ],
                [
                    91.6891315,
                    55.1922145
                ],
                [
                    91.6892314,
                    55.1920401
                ],
                [
                    91.6893959,
                    55.1910338
                ],
                [
                    91.6895722,
                    55.1909264
                ],
                [
                    91.6897661,
                    55.1908727
                ],
                [
                    91.6899777,
                    55.1908862
                ],
                [
                    91.6900717,
                    55.1902455
                ],
                [
                    91.6894841,
                    55.190165
                ],
                [
                    91.6885145,
                    55.190165
                ],
                [
                    91.687304,
                    55.1900979
                ],
                [
                    91.6840011,
                    55.1899621
                ],
                [
                    91.6834551,
                    55.1899604
                ],
                [
                    91.6829498,
                    55.1899
                ],
                [
                    91.6810342,
                    55.1899
                ],
                [
                    91.6779198,
                    55.1899838
                ],
                [
                    91.6777024,
                    55.1899536
                ],
                [
                    91.6765037,
                    55.1899503
                ]
            ],
            "longitude": 91.683533,
            "latitude": 55.193241
        },
        "6572": {
            "name": "Новопокровка",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.6859422,
            "latitude": 53.1452992
        },
        "6573": {
            "name": "Новосибирский",
            "population": 100,
            "type": "hamlet",
            "poly": [
                [
                    91.6913251,
                    56.0739353
                ],
                [
                    91.6931732,
                    56.0745489
                ],
                [
                    91.6934101,
                    56.074861
                ],
                [
                    91.6941873,
                    56.0751731
                ],
                [
                    91.6946043,
                    56.0751625
                ],
                [
                    91.6949266,
                    56.0749932
                ],
                [
                    91.6959786,
                    56.0739882
                ],
                [
                    91.6959407,
                    56.0739195
                ],
                [
                    91.6977603,
                    56.072195
                ],
                [
                    91.6984522,
                    56.0719358
                ],
                [
                    91.6986797,
                    56.0717083
                ],
                [
                    91.6982816,
                    56.0715867
                ],
                [
                    91.698746,
                    56.070936
                ],
                [
                    91.6980447,
                    56.0707085
                ],
                [
                    91.6978741,
                    56.0704334
                ],
                [
                    91.6980826,
                    56.0701636
                ],
                [
                    91.6971496,
                    56.0698938
                ],
                [
                    91.6964823,
                    56.0698905
                ],
                [
                    91.6954148,
                    56.0700056
                ],
                [
                    91.6945535,
                    56.0696602
                ],
                [
                    91.6942624,
                    56.0694266
                ],
                [
                    91.6932312,
                    56.0709976
                ],
                [
                    91.6932919,
                    56.0711059
                ],
                [
                    91.6932494,
                    56.0711499
                ],
                [
                    91.6931038,
                    56.0711838
                ],
                [
                    91.6913251,
                    56.0739353
                ]
            ],
            "longitude": 91.695984,
            "latitude": 56.07225
        },
        "6574": {
            "name": "Чайда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.6996091,
            "latitude": 57.4346527
        },
        "6575": {
            "name": "Малая Тумна",
            "population": 225,
            "type": "hamlet",
            "poly": [
                [
                    91.7305888,
                    55.3278725
                ],
                [
                    91.7306151,
                    55.3282172
                ],
                [
                    91.7314054,
                    55.3295059
                ],
                [
                    91.7318269,
                    55.33041
                ],
                [
                    91.7307644,
                    55.3307097
                ],
                [
                    91.7307644,
                    55.3308295
                ],
                [
                    91.7315986,
                    55.3316237
                ],
                [
                    91.7315459,
                    55.3319783
                ],
                [
                    91.7324152,
                    55.3328623
                ],
                [
                    91.7329596,
                    55.3329922
                ],
                [
                    91.7334074,
                    55.3334217
                ],
                [
                    91.7350318,
                    55.3345354
                ],
                [
                    91.7353567,
                    55.3346054
                ],
                [
                    91.7371128,
                    55.3336764
                ],
                [
                    91.7372972,
                    55.3333368
                ],
                [
                    91.7371479,
                    55.3330621
                ],
                [
                    91.737025,
                    55.3316287
                ],
                [
                    91.7376127,
                    55.3305373
                ],
                [
                    91.7388279,
                    55.3290389
                ],
                [
                    91.7388771,
                    55.328903
                ],
                [
                    91.7387858,
                    55.3287911
                ],
                [
                    91.7383222,
                    55.3285154
                ],
                [
                    91.7376829,
                    55.3281318
                ],
                [
                    91.7384275,
                    55.3277282
                ],
                [
                    91.7388279,
                    55.3275883
                ],
                [
                    91.7392143,
                    55.3273086
                ],
                [
                    91.7395234,
                    55.3271767
                ],
                [
                    91.7398184,
                    55.3271327
                ],
                [
                    91.7403031,
                    55.3271767
                ],
                [
                    91.740577,
                    55.3273086
                ],
                [
                    91.7410758,
                    55.3274444
                ],
                [
                    91.7413006,
                    55.3274085
                ],
                [
                    91.7420381,
                    55.3265453
                ],
                [
                    91.7426141,
                    55.3254943
                ],
                [
                    91.7426633,
                    55.3251066
                ],
                [
                    91.7424666,
                    55.3248868
                ],
                [
                    91.7418976,
                    55.3246191
                ],
                [
                    91.741441,
                    55.3241715
                ],
                [
                    91.74057,
                    55.3229925
                ],
                [
                    91.7403241,
                    55.3225369
                ],
                [
                    91.7403944,
                    55.322421
                ],
                [
                    91.7411698,
                    55.3221483
                ],
                [
                    91.7402426,
                    55.3215376
                ],
                [
                    91.7402594,
                    55.3214097
                ],
                [
                    91.7403494,
                    55.3213586
                ],
                [
                    91.7406697,
                    55.3213394
                ],
                [
                    91.7413103,
                    55.3214353
                ],
                [
                    91.7413384,
                    55.3213234
                ],
                [
                    91.7414396,
                    55.3211699
                ],
                [
                    91.741906,
                    55.3210292
                ],
                [
                    91.7421342,
                    55.3210934
                ],
                [
                    91.7425996,
                    55.3208186
                ],
                [
                    91.7428893,
                    55.3205588
                ],
                [
                    91.7429947,
                    55.320369
                ],
                [
                    91.7427663,
                    55.3202391
                ],
                [
                    91.7424327,
                    55.3199193
                ],
                [
                    91.7420113,
                    55.3197444
                ],
                [
                    91.7414405,
                    55.3193647
                ],
                [
                    91.7403342,
                    55.3191249
                ],
                [
                    91.7376649,
                    55.3188401
                ],
                [
                    91.736699,
                    55.3188951
                ],
                [
                    91.7356278,
                    55.3189151
                ],
                [
                    91.7346883,
                    55.3188701
                ],
                [
                    91.7336442,
                    55.320439
                ],
                [
                    91.7334644,
                    55.3204006
                ],
                [
                    91.7332576,
                    55.3206129
                ],
                [
                    91.7332351,
                    55.3208841
                ],
                [
                    91.7330351,
                    55.3211334
                ],
                [
                    91.7320692,
                    55.3219028
                ],
                [
                    91.7333775,
                    55.3225122
                ],
                [
                    91.7334565,
                    55.3227171
                ],
                [
                    91.7336809,
                    55.3228391
                ],
                [
                    91.7345766,
                    55.3228591
                ],
                [
                    91.7330224,
                    55.3236584
                ],
                [
                    91.7318282,
                    55.3244127
                ],
                [
                    91.7312399,
                    55.3250322
                ],
                [
                    91.7307117,
                    55.3260093
                ],
                [
                    91.7307205,
                    55.326314
                ],
                [
                    91.7306415,
                    55.3266038
                ],
                [
                    91.7313527,
                    55.3270433
                ],
                [
                    91.7308786,
                    55.327403
                ],
                [
                    91.7305888,
                    55.3278725
                ]
            ],
            "longitude": 91.73494,
            "latitude": 55.32523
        },
        "6576": {
            "name": "Белозеровка",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.7439925,
            "latitude": 53.1002867
        },
        "6577": {
            "name": "Сергино",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.766243,
            "latitude": 56.069118
        },
        "6578": {
            "name": "Моисеевка",
            "population": 190,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.771896,
            "latitude": 54.171982
        },
        "6579": {
            "name": "Александровка",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.782623,
            "latitude": 54.630161
        },
        "6580": {
            "name": "Тагарский",
            "population": 47,
            "type": "hamlet",
            "poly": [
                [
                    91.8042709,
                    53.6418409
                ],
                [
                    91.8056287,
                    53.6422606
                ],
                [
                    91.8061785,
                    53.6426359
                ],
                [
                    91.8066283,
                    53.6427396
                ],
                [
                    91.8069115,
                    53.64271
                ],
                [
                    91.8071114,
                    53.6425974
                ],
                [
                    91.8078518,
                    53.6427188
                ],
                [
                    91.8079542,
                    53.6426095
                ],
                [
                    91.8084455,
                    53.6427369
                ],
                [
                    91.808971,
                    53.6422556
                ],
                [
                    91.8049073,
                    53.6409489
                ],
                [
                    91.8046992,
                    53.6410136
                ],
                [
                    91.8047541,
                    53.6411989
                ],
                [
                    91.8042709,
                    53.6418409
                ]
            ],
            "longitude": 91.806885,
            "latitude": 53.642185
        },
        "6581": {
            "name": "Ленск",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8160846,
            "latitude": 53.0473405
        },
        "6582": {
            "name": "Туруханка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8383298,
            "latitude": 57.5907301
        },
        "6583": {
            "name": "Солдатово",
            "population": 247,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.841976,
            "latitude": 53.6562751
        },
        "6584": {
            "name": "Ялань",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8427149,
            "latitude": 58.3539836
        },
        "6585": {
            "name": "Диссос",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8508858,
            "latitude": 54.0729662
        },
        "6586": {
            "name": "Огоньки",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    91.841843,
                    55.470163
                ],
                [
                    91.8428081,
                    55.4704403
                ],
                [
                    91.8437425,
                    55.4708025
                ],
                [
                    91.8453982,
                    55.4711997
                ],
                [
                    91.8462775,
                    55.4709543
                ],
                [
                    91.8475432,
                    55.4708623
                ],
                [
                    91.8480448,
                    55.4712322
                ],
                [
                    91.8482234,
                    55.4715476
                ],
                [
                    91.8481615,
                    55.4717151
                ],
                [
                    91.8480071,
                    55.4721352
                ],
                [
                    91.8486287,
                    55.4725834
                ],
                [
                    91.8490821,
                    55.4728093
                ],
                [
                    91.8493501,
                    55.4727431
                ],
                [
                    91.8497623,
                    55.4727119
                ],
                [
                    91.8504286,
                    55.4727937
                ],
                [
                    91.850834,
                    55.472564
                ],
                [
                    91.8512736,
                    55.4724472
                ],
                [
                    91.8516859,
                    55.4724394
                ],
                [
                    91.8521805,
                    55.4727314
                ],
                [
                    91.8523316,
                    55.4727158
                ],
                [
                    91.8525309,
                    55.4724705
                ],
                [
                    91.852737,
                    55.4723965
                ],
                [
                    91.8530255,
                    55.4724238
                ],
                [
                    91.8533072,
                    55.4726146
                ],
                [
                    91.853582,
                    55.4725601
                ],
                [
                    91.8538293,
                    55.4725757
                ],
                [
                    91.8541384,
                    55.4727548
                ],
                [
                    91.8542552,
                    55.4731831
                ],
                [
                    91.8545438,
                    55.4733311
                ],
                [
                    91.8549216,
                    55.4732454
                ],
                [
                    91.8550247,
                    55.4731325
                ],
                [
                    91.8546537,
                    55.4729806
                ],
                [
                    91.8546674,
                    55.4727353
                ],
                [
                    91.8548598,
                    55.4725834
                ],
                [
                    91.8552582,
                    55.472599
                ],
                [
                    91.8555056,
                    55.4727781
                ],
                [
                    91.8555674,
                    55.4730741
                ],
                [
                    91.8559796,
                    55.4730273
                ],
                [
                    91.8562132,
                    55.4728171
                ],
                [
                    91.8562475,
                    55.4726419
                ],
                [
                    91.8560483,
                    55.4724627
                ],
                [
                    91.856062,
                    55.4723342
                ],
                [
                    91.8561994,
                    55.4722719
                ],
                [
                    91.8564193,
                    55.4722719
                ],
                [
                    91.8568658,
                    55.4723342
                ],
                [
                    91.8572985,
                    55.4722525
                ],
                [
                    91.8575391,
                    55.471867
                ],
                [
                    91.8581162,
                    55.4718085
                ],
                [
                    91.8584803,
                    55.4717346
                ],
                [
                    91.8591054,
                    55.4710998
                ],
                [
                    91.8604238,
                    55.4706354
                ],
                [
                    91.8618397,
                    55.4702976
                ],
                [
                    91.8622656,
                    55.4701146
                ],
                [
                    91.8623137,
                    55.4698226
                ],
                [
                    91.8622107,
                    55.4695266
                ],
                [
                    91.8624099,
                    55.4693007
                ],
                [
                    91.8629114,
                    55.4692306
                ],
                [
                    91.8636809,
                    55.4692267
                ],
                [
                    91.8639419,
                    55.4690593
                ],
                [
                    91.86399,
                    55.4689074
                ],
                [
                    91.8642579,
                    55.4685024
                ],
                [
                    91.8645916,
                    55.4682451
                ],
                [
                    91.8636367,
                    55.467992
                ],
                [
                    91.8633413,
                    55.4680737
                ],
                [
                    91.860978,
                    55.4680309
                ],
                [
                    91.860607,
                    55.4684048
                ],
                [
                    91.860078,
                    55.4683308
                ],
                [
                    91.859288,
                    55.4681477
                ],
                [
                    91.8586628,
                    55.4675753
                ],
                [
                    91.8582781,
                    55.4673299
                ],
                [
                    91.8572613,
                    55.4666912
                ],
                [
                    91.8567461,
                    55.4665783
                ],
                [
                    91.8562446,
                    55.466368
                ],
                [
                    91.8552965,
                    55.4657176
                ],
                [
                    91.8552278,
                    55.4654333
                ],
                [
                    91.8543347,
                    55.4646193
                ],
                [
                    91.854005,
                    55.4641364
                ],
                [
                    91.8534073,
                    55.4637663
                ],
                [
                    91.8519165,
                    55.4631665
                ],
                [
                    91.8507967,
                    55.4625745
                ],
                [
                    91.8488065,
                    55.4635735
                ],
                [
                    91.846542,
                    55.4644896
                ],
                [
                    91.8461298,
                    55.4651688
                ],
                [
                    91.8460585,
                    55.4661035
                ],
                [
                    91.8451736,
                    55.4671971
                ],
                [
                    91.843992,
                    55.4683685
                ],
                [
                    91.8422992,
                    55.4695056
                ],
                [
                    91.841843,
                    55.470163
                ]
            ],
            "longitude": 91.8536153,
            "latitude": 55.4688863
        },
        "6587": {
            "name": "Анциферово",
            "population": 208,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8622253,
            "latitude": 58.8724802
        },
        "6588": {
            "name": "Майский",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8656082,
            "latitude": 53.0325172
        },
        "6589": {
            "name": "Октябрьский",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8661384,
            "latitude": 54.3905922
        },
        "6590": {
            "name": "Бадаложная",
            "population": 31,
            "type": "hamlet",
            "poly": [
                [
                    91.8552128,
                    56.0691158
                ],
                [
                    91.855977,
                    56.0695087
                ],
                [
                    91.8573446,
                    56.070665
                ],
                [
                    91.8588128,
                    56.0716641
                ],
                [
                    91.8589134,
                    56.0725958
                ],
                [
                    91.8584709,
                    56.0729663
                ],
                [
                    91.8584307,
                    56.0734265
                ],
                [
                    91.857968,
                    56.0744929
                ],
                [
                    91.8572843,
                    56.0747623
                ],
                [
                    91.8573044,
                    56.0757837
                ],
                [
                    91.8578273,
                    56.0758511
                ],
                [
                    91.8594564,
                    56.0754358
                ],
                [
                    91.862634,
                    56.075447
                ],
                [
                    91.8647861,
                    56.0760082
                ],
                [
                    91.8641224,
                    56.0765021
                ],
                [
                    91.8679638,
                    56.079005
                ],
                [
                    91.8689292,
                    56.0784214
                ],
                [
                    91.8768733,
                    56.0831014
                ],
                [
                    91.8763304,
                    56.0835278
                ],
                [
                    91.8781405,
                    56.0844031
                ],
                [
                    91.8812578,
                    56.085054
                ],
                [
                    91.8813986,
                    56.0846388
                ],
                [
                    91.8851394,
                    56.0845602
                ],
                [
                    91.8850791,
                    56.0835502
                ],
                [
                    91.8844959,
                    56.0833034
                ],
                [
                    91.8843349,
                    56.0822709
                ],
                [
                    91.8883172,
                    56.0821138
                ],
                [
                    91.888478,
                    56.08162
                ],
                [
                    91.8918166,
                    56.081822
                ],
                [
                    91.8940893,
                    56.0825515
                ],
                [
                    91.8944312,
                    56.0822485
                ],
                [
                    91.8923396,
                    56.0814965
                ],
                [
                    91.8892423,
                    56.0810476
                ],
                [
                    91.8823592,
                    56.0803297
                ],
                [
                    91.8767616,
                    56.0784938
                ],
                [
                    91.8729317,
                    56.0764112
                ],
                [
                    91.870182,
                    56.0753973
                ],
                [
                    91.8692491,
                    56.0739175
                ],
                [
                    91.8663521,
                    56.0721635
                ],
                [
                    91.863406,
                    56.0702451
                ],
                [
                    91.8596742,
                    56.0688199
                ],
                [
                    91.8565317,
                    56.0675316
                ],
                [
                    91.8553535,
                    56.068184
                ],
                [
                    91.8558161,
                    56.0685433
                ],
                [
                    91.8552128,
                    56.0691158
                ]
            ],
            "longitude": 91.870941,
            "latitude": 56.077538
        },
        "6591": {
            "name": "Иннокентьевка",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8804757,
            "latitude": 54.7825714
        },
        "6592": {
            "name": "Омский",
            "population": 254,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8920322,
            "latitude": 57.5951021
        },
        "6593": {
            "name": "Масленниково",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8922036,
            "latitude": 58.1880628
        },
        "6594": {
            "name": "Сухое Озеро",
            "population": 238,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8948882,
            "latitude": 53.60641
        },
        "6595": {
            "name": "Большая Кеть",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8993536,
            "latitude": 57.593354
        },
        "6596": {
            "name": "Новый Ислам",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9133635,
            "latitude": 57.5352793
        },
        "6597": {
            "name": "Колдыбай",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9175683,
            "latitude": 54.5909806
        },
        "6598": {
            "name": "Кутужеково",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9272801,
            "latitude": 53.589162
        },
        "6599": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9320752,
            "latitude": 55.9782268
        },
        "6600": {
            "name": "Тёплый Ключ",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9358311,
            "latitude": 54.2474039
        },
        "6601": {
            "name": "Малый Телек",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9410195,
            "latitude": 54.3327327
        },
        "6602": {
            "name": "Михайловка",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9454584,
            "latitude": 56.5484605
        },
        "6603": {
            "name": "Мариловцева",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9500492,
            "latitude": 58.2671824
        },
        "6604": {
            "name": "Труд",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9506058,
            "latitude": 53.1587704
        },
        "6605": {
            "name": "Новомихайловка",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9512729,
            "latitude": 57.4759137
        },
        "6606": {
            "name": "имени Крупской",
            "population": 144,
            "type": "hamlet",
            "poly": [
                [
                    91.9511347,
                    53.6948227
                ],
                [
                    91.9616742,
                    53.6944411
                ],
                [
                    91.9615261,
                    53.6930486
                ],
                [
                    91.9566919,
                    53.693193
                ],
                [
                    91.9566919,
                    53.6930331
                ],
                [
                    91.9536955,
                    53.6929764
                ],
                [
                    91.9536694,
                    53.6930486
                ],
                [
                    91.9513437,
                    53.693064
                ],
                [
                    91.9511347,
                    53.6948227
                ]
            ],
            "longitude": 91.9558382,
            "latitude": 53.6938634
        },
        "6607": {
            "name": "Красный Ключ",
            "population": 145,
            "type": "hamlet",
            "poly": [
                [
                    91.9475384,
                    55.4454098
                ],
                [
                    91.947804,
                    55.4457762
                ],
                [
                    91.9498043,
                    55.445992
                ],
                [
                    91.9502951,
                    55.4461173
                ],
                [
                    91.9503933,
                    55.4462704
                ],
                [
                    91.9516328,
                    55.4465975
                ],
                [
                    91.9518046,
                    55.4462704
                ],
                [
                    91.9528722,
                    55.4464096
                ],
                [
                    91.9535594,
                    55.44563
                ],
                [
                    91.9543325,
                    55.4454351
                ],
                [
                    91.9548724,
                    55.4451219
                ],
                [
                    91.9552406,
                    55.4452263
                ],
                [
                    91.9556824,
                    55.4453934
                ],
                [
                    91.955572,
                    55.4456857
                ],
                [
                    91.9551179,
                    55.4457344
                ],
                [
                    91.9552406,
                    55.4458806
                ],
                [
                    91.9557561,
                    55.4458945
                ],
                [
                    91.9557806,
                    55.4460268
                ],
                [
                    91.955707,
                    55.4464722
                ],
                [
                    91.9561487,
                    55.4466393
                ],
                [
                    91.9565905,
                    55.4466254
                ],
                [
                    91.9569464,
                    55.4462565
                ],
                [
                    91.9571919,
                    55.4464444
                ],
                [
                    91.9576336,
                    55.446695
                ],
                [
                    91.9579527,
                    55.4465488
                ],
                [
                    91.9587749,
                    55.4465349
                ],
                [
                    91.9593271,
                    55.4466532
                ],
                [
                    91.9591676,
                    55.4469803
                ],
                [
                    91.9583331,
                    55.4471961
                ],
                [
                    91.9584681,
                    55.4476137
                ],
                [
                    91.9587504,
                    55.4479547
                ],
                [
                    91.9593517,
                    55.4479895
                ],
                [
                    91.9598794,
                    55.4475511
                ],
                [
                    91.9603825,
                    55.4476276
                ],
                [
                    91.9607015,
                    55.4487203
                ],
                [
                    91.9598302,
                    55.4488108
                ],
                [
                    91.9595971,
                    55.4494441
                ],
                [
                    91.960223,
                    55.4494372
                ],
                [
                    91.9608487,
                    55.4495833
                ],
                [
                    91.9615606,
                    55.4494024
                ],
                [
                    91.9619042,
                    55.449639
                ],
                [
                    91.9613397,
                    55.450154
                ],
                [
                    91.962346,
                    55.4505159
                ],
                [
                    91.96334,
                    55.4507526
                ],
                [
                    91.9635696,
                    55.4509824
                ],
                [
                    91.9643954,
                    55.4516364
                ],
                [
                    91.9657453,
                    55.4524158
                ],
                [
                    91.9657575,
                    55.4528543
                ],
                [
                    91.9662607,
                    55.4536963
                ],
                [
                    91.9692427,
                    55.4533205
                ],
                [
                    91.9697704,
                    55.453571
                ],
                [
                    91.9721388,
                    55.4519774
                ],
                [
                    91.9736851,
                    55.4522279
                ],
                [
                    91.9748632,
                    55.4526942
                ],
                [
                    91.9757958,
                    55.4521931
                ],
                [
                    91.976029,
                    55.4525133
                ],
                [
                    91.9772562,
                    55.4520331
                ],
                [
                    91.9769342,
                    55.4513868
                ],
                [
                    91.9758543,
                    55.4506463
                ],
                [
                    91.9748922,
                    55.4494938
                ],
                [
                    91.9742148,
                    55.4496552
                ],
                [
                    91.9720255,
                    55.4492599
                ],
                [
                    91.9717408,
                    55.4490929
                ],
                [
                    91.971947,
                    55.4485361
                ],
                [
                    91.9716818,
                    55.4478345
                ],
                [
                    91.9709358,
                    55.4474893
                ],
                [
                    91.9706413,
                    55.4471051
                ],
                [
                    91.9707198,
                    55.4469214
                ],
                [
                    91.9704645,
                    55.446643
                ],
                [
                    91.9698559,
                    55.4464481
                ],
                [
                    91.9692374,
                    55.4457688
                ],
                [
                    91.9681377,
                    55.4448667
                ],
                [
                    91.9680298,
                    55.4446607
                ],
                [
                    91.9682949,
                    55.4442374
                ],
                [
                    91.9680985,
                    55.443959
                ],
                [
                    91.9677844,
                    55.4439256
                ],
                [
                    91.9674701,
                    55.4441484
                ],
                [
                    91.9673328,
                    55.444037
                ],
                [
                    91.967431,
                    55.4436193
                ],
                [
                    91.9670088,
                    55.4435525
                ],
                [
                    91.966891,
                    55.4432295
                ],
                [
                    91.9671659,
                    55.4430569
                ],
                [
                    91.9677549,
                    55.4428509
                ],
                [
                    91.9673229,
                    55.4413027
                ],
                [
                    91.9663707,
                    55.440033
                ],
                [
                    91.965546,
                    55.439994
                ],
                [
                    91.9653104,
                    55.4400608
                ],
                [
                    91.9654282,
                    55.440395
                ],
                [
                    91.9649766,
                    55.4409185
                ],
                [
                    91.9643483,
                    55.4411858
                ],
                [
                    91.9635825,
                    55.4415422
                ],
                [
                    91.9627873,
                    55.441609
                ],
                [
                    91.961619,
                    55.4415589
                ],
                [
                    91.9607748,
                    55.44201
                ],
                [
                    91.9597047,
                    55.4417371
                ],
                [
                    91.9584873,
                    55.4408684
                ],
                [
                    91.9571522,
                    55.4404451
                ],
                [
                    91.9568194,
                    55.4405227
                ],
                [
                    91.9565337,
                    55.4406623
                ],
                [
                    91.9549432,
                    55.4410299
                ],
                [
                    91.9546389,
                    55.4412192
                ],
                [
                    91.954688,
                    55.441442
                ],
                [
                    91.9534412,
                    55.4414865
                ],
                [
                    91.9512421,
                    55.4416424
                ],
                [
                    91.9496811,
                    55.441932
                ],
                [
                    91.9497498,
                    55.4421381
                ],
                [
                    91.949416,
                    55.4421436
                ],
                [
                    91.9493154,
                    55.4422301
                ],
                [
                    91.9494234,
                    55.4425308
                ],
                [
                    91.9495707,
                    55.4426812
                ],
                [
                    91.9475384,
                    55.4454098
                ]
            ],
            "longitude": 91.960953,
            "latitude": 55.446392
        },
        "6608": {
            "name": "Шадрино",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9625772,
            "latitude": 54.6983898
        },
        "6609": {
            "name": "Даурское",
            "population": 230,
            "type": "hamlet",
            "poly": [
                [
                    91.9589735,
                    55.226601
                ],
                [
                    91.9590367,
                    55.2266913
                ],
                [
                    91.9591674,
                    55.226916
                ],
                [
                    91.9594554,
                    55.2268758
                ],
                [
                    91.9602957,
                    55.2267619
                ],
                [
                    91.96123,
                    55.2266479
                ],
                [
                    91.9616237,
                    55.2267082
                ],
                [
                    91.9615473,
                    55.2269227
                ],
                [
                    91.961465,
                    55.2270132
                ],
                [
                    91.9615884,
                    55.2271004
                ],
                [
                    91.9619527,
                    55.2272612
                ],
                [
                    91.9619704,
                    55.2274489
                ],
                [
                    91.9622054,
                    55.2275059
                ],
                [
                    91.9622994,
                    55.2273953
                ],
                [
                    91.9624875,
                    55.2273785
                ],
                [
                    91.9625932,
                    55.2273148
                ],
                [
                    91.962746,
                    55.2274925
                ],
                [
                    91.9631162,
                    55.2275796
                ],
                [
                    91.9633336,
                    55.227536
                ],
                [
                    91.963527,
                    55.2274943
                ],
                [
                    91.9638384,
                    55.2276015
                ],
                [
                    91.9644026,
                    55.2277557
                ],
                [
                    91.9645906,
                    55.2278596
                ],
                [
                    91.9645847,
                    55.2279132
                ],
                [
                    91.9647904,
                    55.2279802
                ],
                [
                    91.9648726,
                    55.2281277
                ],
                [
                    91.9648903,
                    55.2287242
                ],
                [
                    91.964996,
                    55.2289789
                ],
                [
                    91.9653486,
                    55.2290157
                ],
                [
                    91.9655543,
                    55.2290459
                ],
                [
                    91.9659715,
                    55.2290191
                ],
                [
                    91.9663887,
                    55.2288448
                ],
                [
                    91.966744,
                    55.2284966
                ],
                [
                    91.9669864,
                    55.2284002
                ],
                [
                    91.9671407,
                    55.2281908
                ],
                [
                    91.9674345,
                    55.2280986
                ],
                [
                    91.9682718,
                    55.2281405
                ],
                [
                    91.9683967,
                    55.2280023
                ],
                [
                    91.9684408,
                    55.2279227
                ],
                [
                    91.9687493,
                    55.2278975
                ],
                [
                    91.9693516,
                    55.2279311
                ],
                [
                    91.9694838,
                    55.2278934
                ],
                [
                    91.9699901,
                    55.2279418
                ],
                [
                    91.9705542,
                    55.2275698
                ],
                [
                    91.970848,
                    55.2272346
                ],
                [
                    91.9709303,
                    55.2269364
                ],
                [
                    91.9711536,
                    55.2265208
                ],
                [
                    91.971277,
                    55.2264203
                ],
                [
                    91.9711888,
                    55.2261924
                ],
                [
                    91.9712535,
                    55.2259075
                ],
                [
                    91.9706424,
                    55.2257232
                ],
                [
                    91.9705307,
                    55.225512
                ],
                [
                    91.9706189,
                    55.2252439
                ],
                [
                    91.9710834,
                    55.224318
                ],
                [
                    91.9715792,
                    55.2237314
                ],
                [
                    91.9716802,
                    55.2233544
                ],
                [
                    91.9720016,
                    55.2235377
                ],
                [
                    91.9724882,
                    55.2238362
                ],
                [
                    91.9726902,
                    55.2234486
                ],
                [
                    91.9730758,
                    55.2233491
                ],
                [
                    91.9732043,
                    55.223213
                ],
                [
                    91.9732502,
                    55.223014
                ],
                [
                    91.9734155,
                    55.2228045
                ],
                [
                    91.973489,
                    55.2226264
                ],
                [
                    91.9732135,
                    55.2225269
                ],
                [
                    91.9734431,
                    55.2224379
                ],
                [
                    91.9735349,
                    55.222286
                ],
                [
                    91.9735624,
                    55.2219613
                ],
                [
                    91.9735808,
                    55.2217414
                ],
                [
                    91.9733972,
                    55.2215266
                ],
                [
                    91.9730391,
                    55.2213905
                ],
                [
                    91.9707437,
                    55.2212805
                ],
                [
                    91.9704958,
                    55.221579
                ],
                [
                    91.9701377,
                    55.2218932
                ],
                [
                    91.969899,
                    55.2219561
                ],
                [
                    91.9692471,
                    55.2219404
                ],
                [
                    91.9692655,
                    55.2217361
                ],
                [
                    91.9696878,
                    55.2205735
                ],
                [
                    91.9697888,
                    55.2199136
                ],
                [
                    91.9697337,
                    55.2197407
                ],
                [
                    91.9684391,
                    55.2197931
                ],
                [
                    91.9685677,
                    55.220034
                ],
                [
                    91.9685218,
                    55.2202121
                ],
                [
                    91.9685034,
                    55.2204844
                ],
                [
                    91.9676679,
                    55.2205001
                ],
                [
                    91.9638943,
                    55.2197512
                ],
                [
                    91.9631782,
                    55.2197983
                ],
                [
                    91.9630313,
                    55.2198821
                ],
                [
                    91.9617826,
                    55.2198874
                ],
                [
                    91.9617367,
                    55.2201702
                ],
                [
                    91.9615806,
                    55.220474
                ],
                [
                    91.9619387,
                    55.2211024
                ],
                [
                    91.9618468,
                    55.2213433
                ],
                [
                    91.9602309,
                    55.2241504
                ],
                [
                    91.9601024,
                    55.224407
                ],
                [
                    91.9602584,
                    55.2245903
                ],
                [
                    91.9605306,
                    55.2247086
                ],
                [
                    91.9598549,
                    55.2259676
                ],
                [
                    91.9594671,
                    55.2263564
                ],
                [
                    91.959091,
                    55.2265641
                ],
                [
                    91.9589735,
                    55.226601
                ]
            ],
            "longitude": 91.966011,
            "latitude": 55.224712
        },
        "6610": {
            "name": "Коврига",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9719611,
            "latitude": 57.6146319
        },
        "6611": {
            "name": "Николаевка",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.97276,
            "latitude": 54.7798441
        },
        "6612": {
            "name": "Петропавловка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9742978,
            "latitude": 56.5721701
        },
        "6613": {
            "name": "Верхняя Бирюса",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9746279,
            "latitude": 55.9235338
        },
        "6614": {
            "name": "Алексеевка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9814107,
            "latitude": 56.6269936
        },
        "6615": {
            "name": "Майский",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.9864996,
            "latitude": 54.485515
        },
        "6616": {
            "name": "Восточная",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0001079,
            "latitude": 75.4999394
        },
        "6617": {
            "name": "Ермолаево",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.006875,
            "latitude": 53.2357285
        },
        "6618": {
            "name": "Никольск",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0196574,
            "latitude": 57.3156315
        },
        "6619": {
            "name": "Верхнекемское",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0213696,
            "latitude": 58.02021
        },
        "6620": {
            "name": "Пригородный",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0300642,
            "latitude": 53.5493656
        },
        "6621": {
            "name": "Кедровая",
            "population": 209,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0341719,
            "latitude": 54.1760308
        },
        "6622": {
            "name": "Лыткино",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0362941,
            "latitude": 53.5015686
        },
        "6623": {
            "name": "Новоивановка",
            "population": 198,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0382009,
            "latitude": 54.0582138
        },
        "6624": {
            "name": "Шадрино",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.045572,
            "latitude": 58.5608231
        },
        "6625": {
            "name": "Новотроицкая",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0525749,
            "latitude": 57.6277023
        },
        "6626": {
            "name": "Козлово",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0542028,
            "latitude": 53.3965487
        },
        "6627": {
            "name": "Коныгино",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0548682,
            "latitude": 53.6911989
        },
        "6628": {
            "name": "Паршино",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0684548,
            "latitude": 58.6832805
        },
        "6629": {
            "name": "Вознесенка",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0697261,
            "latitude": 53.1048977
        },
        "6630": {
            "name": "Новый Тимершик",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.0757641,
            "latitude": 57.5955902
        },
        "6631": {
            "name": "Щетинкина",
            "population": 228,
            "type": "hamlet",
            "poly": [
                [
                    92.0807299,
                    55.354708
                ],
                [
                    92.0808951,
                    55.3550667
                ],
                [
                    92.0810604,
                    55.3559762
                ],
                [
                    92.0819841,
                    55.3564459
                ],
                [
                    92.0825025,
                    55.3564715
                ],
                [
                    92.0832384,
                    55.3564715
                ],
                [
                    92.0841774,
                    55.35648
                ],
                [
                    92.0849285,
                    55.3564203
                ],
                [
                    92.0854843,
                    55.3562495
                ],
                [
                    92.0881801,
                    55.3557904
                ],
                [
                    92.0881878,
                    55.3569556
                ],
                [
                    92.088257,
                    55.3574343
                ],
                [
                    92.0883592,
                    55.3574393
                ],
                [
                    92.0903952,
                    55.3574343
                ],
                [
                    92.0904952,
                    55.3573972
                ],
                [
                    92.0906259,
                    55.356514
                ],
                [
                    92.0922027,
                    55.3565249
                ],
                [
                    92.0925795,
                    55.3562932
                ],
                [
                    92.0923949,
                    55.355762
                ],
                [
                    92.0923796,
                    55.3555499
                ],
                [
                    92.0917872,
                    55.3548634
                ],
                [
                    92.091695,
                    55.3546995
                ],
                [
                    92.0917552,
                    55.3545896
                ],
                [
                    92.0917872,
                    55.3545574
                ],
                [
                    92.0947798,
                    55.3542694
                ],
                [
                    92.0948039,
                    55.353149
                ],
                [
                    92.0946296,
                    55.3530021
                ],
                [
                    92.0943292,
                    55.3529269
                ],
                [
                    92.0938124,
                    55.352862
                ],
                [
                    92.0933197,
                    55.3526707
                ],
                [
                    92.0926948,
                    55.3523018
                ],
                [
                    92.0922681,
                    55.3521173
                ],
                [
                    92.0919497,
                    55.3520831
                ],
                [
                    92.0881461,
                    55.3519089
                ],
                [
                    92.0868963,
                    55.3518952
                ],
                [
                    92.0855984,
                    55.352008
                ],
                [
                    92.0810015,
                    55.3526639
                ],
                [
                    92.0819316,
                    55.3542682
                ],
                [
                    92.0807749,
                    55.3543152
                ],
                [
                    92.0807299,
                    55.354708
                ]
            ],
            "longitude": 92.087662,
            "latitude": 55.35466
        },
        "6632": {
            "name": "Борки",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1035689,
            "latitude": 58.4842663
        },
        "6633": {
            "name": "Корнилово",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.105391,
            "latitude": 53.2776776
        },
        "6634": {
            "name": "Вознесенка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.105811,
            "latitude": 54.7693647
        },
        "6635": {
            "name": "Алгайск",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1097153,
            "latitude": 57.2870174
        },
        "6636": {
            "name": "Еркалово",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1195303,
            "latitude": 58.5173754
        },
        "6637": {
            "name": "Джирим",
            "population": 253,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1268642,
            "latitude": 54.0184604
        },
        "6638": {
            "name": "Королевка",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1435965,
            "latitude": 54.7431904
        },
        "6639": {
            "name": "Берёзовая",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.145218,
            "latitude": 54.956154
        },
        "6640": {
            "name": "Горская",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1477062,
            "latitude": 58.4123378
        },
        "6641": {
            "name": "Ильинка",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1489445,
            "latitude": 53.9025566
        },
        "6642": {
            "name": "Малый Кемчуг",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1512109,
            "latitude": 56.2317345
        },
        "6643": {
            "name": "Пировский",
            "population": 66,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1578196,
            "latitude": 57.7808216
        },
        "6644": {
            "name": "Бельское",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1677037,
            "latitude": 57.8208784
        },
        "6645": {
            "name": "Петропавловка",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1688366,
            "latitude": 57.5652255
        },
        "6646": {
            "name": "Кызыкульский",
            "population": 25,
            "type": "hamlet",
            "poly": [
                [
                    92.1735855,
                    53.7206887
                ],
                [
                    92.1747142,
                    53.7217479
                ],
                [
                    92.1754096,
                    53.7222167
                ],
                [
                    92.1769487,
                    53.7229453
                ],
                [
                    92.17818,
                    53.7232556
                ],
                [
                    92.1788755,
                    53.7227294
                ],
                [
                    92.1788185,
                    53.7224697
                ],
                [
                    92.1789838,
                    53.7222741
                ],
                [
                    92.1776613,
                    53.7219368
                ],
                [
                    92.173785,
                    53.720483
                ],
                [
                    92.1735855,
                    53.7206887
                ]
            ],
            "longitude": 92.1764939,
            "latitude": 53.7221806
        },
        "6647": {
            "name": "Восточный",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1799934,
            "latitude": 54.3627466
        },
        "6648": {
            "name": "Известковый",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.1932042,
            "latitude": 56.0949012
        },
        "6649": {
            "name": "Малый Кызыкуль",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2178428,
            "latitude": 53.7692904
        },
        "6650": {
            "name": "Шумбаш",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2215254,
            "latitude": 57.3736627
        },
        "6651": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2313432,
            "latitude": 58.2168019
        },
        "6652": {
            "name": "Тунгусы Первые",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.233333,
            "latitude": 70.6
        },
        "6653": {
            "name": "Новый Сатыш",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2336526,
            "latitude": 57.8669932
        },
        "6654": {
            "name": "Куренная Ошма",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2368169,
            "latitude": 57.823598
        },
        "6655": {
            "name": "Усть-Шушь",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2411723,
            "latitude": 53.906557
        },
        "6656": {
            "name": "Мензот",
            "population": 162,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2431501,
            "latitude": 54.5603021
        },
        "6657": {
            "name": "Хмельники",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2567885,
            "latitude": 55.9162545
        },
        "6658": {
            "name": "Прутовая",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.2718568,
            "latitude": 58.3910247
        },
        "6659": {
            "name": "Средняя Салба",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3068683,
            "latitude": 54.1881528
        },
        "6660": {
            "name": "Долгово",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3142419,
            "latitude": 57.7328359
        },
        "6661": {
            "name": "Васильевка",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3348028,
            "latitude": 54.5475255
        },
        "6662": {
            "name": "Жерлык",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    92.3345836,
                    53.7717431
                ],
                [
                    92.3351049,
                    53.7718504
                ],
                [
                    92.3353089,
                    53.7720222
                ],
                [
                    92.3353548,
                    53.7721939
                ],
                [
                    92.3378175,
                    53.7728991
                ],
                [
                    92.3415499,
                    53.7735861
                ],
                [
                    92.3428756,
                    53.7733872
                ],
                [
                    92.3436302,
                    53.7735168
                ],
                [
                    92.3442217,
                    53.7734897
                ],
                [
                    92.3445021,
                    53.7735409
                ],
                [
                    92.3447621,
                    53.7732125
                ],
                [
                    92.3430948,
                    53.7728991
                ],
                [
                    92.3430386,
                    53.7729443
                ],
                [
                    92.3423861,
                    53.7727755
                ],
                [
                    92.3416161,
                    53.772667
                ],
                [
                    92.336813,
                    53.7717028
                ],
                [
                    92.334957,
                    53.771094
                ],
                [
                    92.3348932,
                    53.7714124
                ],
                [
                    92.3345836,
                    53.7717431
                ]
            ],
            "longitude": 92.3389145,
            "latitude": 53.7726496
        },
        "6663": {
            "name": "Шагирислам",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.343025,
            "latitude": 57.5042746
        },
        "6664": {
            "name": "Майское Утро",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.346472,
            "latitude": 53.6964315
        },
        "6665": {
            "name": "Смоленка",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    92.3439733,
                    55.2373932
                ],
                [
                    92.348684,
                    55.2375152
                ],
                [
                    92.3506467,
                    55.2373525
                ],
                [
                    92.3508784,
                    55.2359566
                ],
                [
                    92.3501933,
                    55.235631
                ],
                [
                    92.3494776,
                    55.2342245
                ],
                [
                    92.349196,
                    55.2338859
                ],
                [
                    92.3482748,
                    55.2338772
                ],
                [
                    92.3481606,
                    55.2337556
                ],
                [
                    92.348663,
                    55.2330003
                ],
                [
                    92.3489143,
                    55.2321841
                ],
                [
                    92.3473764,
                    55.2321754
                ],
                [
                    92.3470795,
                    55.2363299
                ],
                [
                    92.3441713,
                    55.2362084
                ],
                [
                    92.3439733,
                    55.2373932
                ]
            ],
            "longitude": 92.348396,
            "latitude": 55.235294
        },
        "6666": {
            "name": "Верхнебельск",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3537362,
            "latitude": 58.1007
        },
        "6667": {
            "name": "Большая Идра",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3618833,
            "latitude": 54.356093
        },
        "6668": {
            "name": "Весёлые Ключи",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3678409,
            "latitude": 53.4485935
        },
        "6669": {
            "name": "Еленинск",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3772959,
            "latitude": 54.506034
        },
        "6670": {
            "name": "Кемский",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.380554,
            "latitude": 57.9422667
        },
        "6671": {
            "name": "Кузьмовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3833329,
            "latitude": 62.983333
        },
        "6672": {
            "name": "Малая Еловая",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3860212,
            "latitude": 56.1267121
        },
        "6673": {
            "name": "Михайловка",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.386714,
            "latitude": 57.954109
        },
        "6674": {
            "name": "Заречный",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3869901,
            "latitude": 54.05342
        },
        "6675": {
            "name": "Филипповка",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.397333,
            "latitude": 57.939855
        },
        "6676": {
            "name": "Комсомольский",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.3999209,
            "latitude": 54.2897022
        },
        "6677": {
            "name": "Снежница",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4062462,
            "latitude": 56.0920192
        },
        "6678": {
            "name": "Медведа",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4070841,
            "latitude": 56.5085984
        },
        "6679": {
            "name": "Большая Речка",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.416367,
            "latitude": 53.037533
        },
        "6680": {
            "name": "Бахта",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4168302,
            "latitude": 55.7393108
        },
        "6681": {
            "name": "Адриха",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4184443,
            "latitude": 54.4243631
        },
        "6682": {
            "name": "Южаково",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4231715,
            "latitude": 58.3619288
        },
        "6683": {
            "name": "Гладкое",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4278557,
            "latitude": 56.3560154
        },
        "6684": {
            "name": "Сухая",
            "population": 104,
            "type": "hamlet",
            "poly": [
                [
                    92.4322712,
                    56.216652
                ],
                [
                    92.4331961,
                    56.2182964
                ],
                [
                    92.4332532,
                    56.2185631
                ],
                [
                    92.4334188,
                    56.2187662
                ],
                [
                    92.4337099,
                    56.218925
                ],
                [
                    92.4340639,
                    56.218998
                ],
                [
                    92.4340753,
                    56.2196202
                ],
                [
                    92.4353941,
                    56.2197598
                ],
                [
                    92.4363458,
                    56.2197212
                ],
                [
                    92.4364104,
                    56.2197186
                ],
                [
                    92.4370441,
                    56.2197408
                ],
                [
                    92.4376835,
                    56.2199281
                ],
                [
                    92.4380175,
                    56.2203902
                ],
                [
                    92.4381858,
                    56.2206232
                ],
                [
                    92.4390765,
                    56.2205947
                ],
                [
                    92.4398987,
                    56.2209661
                ],
                [
                    92.4406922,
                    56.220947
                ],
                [
                    92.4414401,
                    56.2208454
                ],
                [
                    92.4413658,
                    56.2204677
                ],
                [
                    92.441149,
                    56.2201344
                ],
                [
                    92.4409206,
                    56.2199535
                ],
                [
                    92.4406294,
                    56.2194297
                ],
                [
                    92.4401099,
                    56.2188297
                ],
                [
                    92.4402412,
                    56.2186139
                ],
                [
                    92.4410405,
                    56.2181726
                ],
                [
                    92.4418512,
                    56.2178933
                ],
                [
                    92.4421538,
                    56.2176584
                ],
                [
                    92.4432841,
                    56.2173885
                ],
                [
                    92.4431242,
                    56.2172171
                ],
                [
                    92.4432223,
                    56.2171493
                ],
                [
                    92.4436096,
                    56.2168584
                ],
                [
                    92.4444603,
                    56.2166679
                ],
                [
                    92.4445516,
                    56.2167917
                ],
                [
                    92.4465612,
                    56.2159409
                ],
                [
                    92.4468296,
                    56.215852
                ],
                [
                    92.4479657,
                    56.2156742
                ],
                [
                    92.4483596,
                    56.2155758
                ],
                [
                    92.448765,
                    56.2155409
                ],
                [
                    92.4486108,
                    56.2145155
                ],
                [
                    92.4485423,
                    56.2140392
                ],
                [
                    92.4482683,
                    56.2135567
                ],
                [
                    92.4484453,
                    56.2135249
                ],
                [
                    92.448451,
                    56.2134138
                ],
                [
                    92.4516024,
                    56.2123185
                ],
                [
                    92.4513139,
                    56.2121196
                ],
                [
                    92.4512199,
                    56.2120549
                ],
                [
                    92.4513173,
                    56.2118798
                ],
                [
                    92.4512375,
                    56.2117039
                ],
                [
                    92.451146,
                    56.211502
                ],
                [
                    92.4507292,
                    56.2114639
                ],
                [
                    92.444512,
                    56.2123656
                ],
                [
                    92.4443864,
                    56.2118767
                ],
                [
                    92.4420626,
                    56.2123529
                ],
                [
                    92.4416184,
                    56.2124335
                ],
                [
                    92.439368,
                    56.2128419
                ],
                [
                    92.4377923,
                    56.2128641
                ],
                [
                    92.4368503,
                    56.2130038
                ],
                [
                    92.436228,
                    56.2130324
                ],
                [
                    92.4355429,
                    56.2131911
                ],
                [
                    92.4342583,
                    56.2136959
                ],
                [
                    92.4338925,
                    56.2138742
                ],
                [
                    92.4337271,
                    56.2144901
                ],
                [
                    92.4342752,
                    56.2152996
                ],
                [
                    92.434669,
                    56.2160679
                ],
                [
                    92.4353941,
                    56.2160012
                ],
                [
                    92.4356511,
                    56.216033
                ],
                [
                    92.4357081,
                    56.2159631
                ],
                [
                    92.4359023,
                    56.2160552
                ],
                [
                    92.4350402,
                    56.2161282
                ],
                [
                    92.4337271,
                    56.2162647
                ],
                [
                    92.4325396,
                    56.2163536
                ],
                [
                    92.4325852,
                    56.2164838
                ],
                [
                    92.4324939,
                    56.2166012
                ],
                [
                    92.4322712,
                    56.216652
                ]
            ],
            "longitude": 92.4373493,
            "latitude": 56.2164429
        },
        "6685": {
            "name": "Новониколаевское",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4381897,
            "latitude": 57.8712736
        },
        "6686": {
            "name": "Байкал",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4383768,
            "latitude": 58.337994
        },
        "6687": {
            "name": "Зезезино",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.442711,
            "latitude": 54.562466
        },
        "6688": {
            "name": "Волоковое",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4458731,
            "latitude": 57.6579231
        },
        "6689": {
            "name": "Песочный",
            "population": 186,
            "type": "hamlet",
            "poly": [
                [
                    92.4416238,
                    53.2703412
                ],
                [
                    92.4422022,
                    53.2705393
                ],
                [
                    92.4427123,
                    53.2706494
                ],
                [
                    92.4433118,
                    53.270445
                ],
                [
                    92.4437009,
                    53.2707059
                ],
                [
                    92.4443372,
                    53.2716525
                ],
                [
                    92.4454888,
                    53.2725707
                ],
                [
                    92.4485072,
                    53.2717845
                ],
                [
                    92.4481811,
                    53.2702563
                ],
                [
                    92.4503739,
                    53.2694009
                ],
                [
                    92.4516517,
                    53.2687593
                ],
                [
                    92.4515518,
                    53.2686147
                ],
                [
                    92.4555956,
                    53.2671931
                ],
                [
                    92.4547821,
                    53.2662955
                ],
                [
                    92.4544661,
                    53.2662198
                ],
                [
                    92.4541853,
                    53.2661131
                ],
                [
                    92.4537615,
                    53.2658206
                ],
                [
                    92.4527613,
                    53.265759
                ],
                [
                    92.45243,
                    53.2657274
                ],
                [
                    92.4521618,
                    53.2656741
                ],
                [
                    92.4519147,
                    53.2655829
                ],
                [
                    92.4516675,
                    53.2650891
                ],
                [
                    92.45121,
                    53.2646518
                ],
                [
                    92.4515939,
                    53.2644129
                ],
                [
                    92.4515518,
                    53.2641611
                ],
                [
                    92.4501057,
                    53.2637272
                ],
                [
                    92.4490541,
                    53.2638498
                ],
                [
                    92.4470611,
                    53.2644663
                ],
                [
                    92.4459463,
                    53.2645983
                ],
                [
                    92.4453153,
                    53.2648595
                ],
                [
                    92.4447789,
                    53.2649066
                ],
                [
                    92.4442425,
                    53.2647022
                ],
                [
                    92.4440374,
                    53.2649208
                ],
                [
                    92.443906,
                    53.2652589
                ],
                [
                    92.4441111,
                    53.2654067
                ],
                [
                    92.4442373,
                    53.2656206
                ],
                [
                    92.4445843,
                    53.2664761
                ],
                [
                    92.4447684,
                    53.2674699
                ],
                [
                    92.4448998,
                    53.26769
                ],
                [
                    92.4451522,
                    53.2679322
                ],
                [
                    92.4448683,
                    53.2680643
                ],
                [
                    92.4446473,
                    53.2682341
                ],
                [
                    92.4446527,
                    53.2683442
                ],
                [
                    92.4440322,
                    53.2685518
                ],
                [
                    92.44399,
                    53.2686555
                ],
                [
                    92.4432697,
                    53.2689071
                ],
                [
                    92.4429805,
                    53.2690612
                ],
                [
                    92.4426334,
                    53.2693694
                ],
                [
                    92.4422127,
                    53.2696116
                ],
                [
                    92.4416238,
                    53.2703412
                ]
            ],
            "longitude": 92.4490648,
            "latitude": 53.267245
        },
        "6690": {
            "name": "Каменск",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4656772,
            "latitude": 58.3432814
        },
        "6691": {
            "name": "Холмовая",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4690898,
            "latitude": 57.6505273
        },
        "6692": {
            "name": "Игнатово",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4691201,
            "latitude": 57.616889
        },
        "6693": {
            "name": "Прудный",
            "population": 196,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4758386,
            "latitude": 53.9991774
        },
        "6694": {
            "name": "Усковское",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4782396,
            "latitude": 57.5675345
        },
        "6695": {
            "name": "Подолка",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.4884132,
            "latitude": 56.3367388
        },
        "6696": {
            "name": "Раменское",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.5026233,
            "latitude": 57.5838437
        },
        "6697": {
            "name": "Куртюл",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.522133,
            "latitude": 55.03817
        },
        "6698": {
            "name": "Вечерницы",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.5327944,
            "latitude": 56.3253933
        },
        "6699": {
            "name": "Верхний Суэтук",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.534996,
            "latitude": 53.462536
        },
        "6700": {
            "name": "Загорье",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.535659,
            "latitude": 54.1086878
        },
        "6701": {
            "name": "Тыжновка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.5395049,
            "latitude": 56.4324369
        },
        "6702": {
            "name": "Покровка",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.5484247,
            "latitude": 56.4887161
        },
        "6703": {
            "name": "Новая Шушь",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.5523627,
            "latitude": 54.156854
        },
        "6704": {
            "name": "Туба",
            "population": 59,
            "type": "hamlet",
            "poly": [
                [
                    92.5578636,
                    53.823422
                ],
                [
                    92.5588055,
                    53.8237219
                ],
                [
                    92.562491,
                    53.8244812
                ],
                [
                    92.5628242,
                    53.8244772
                ],
                [
                    92.5638838,
                    53.8242491
                ],
                [
                    92.564717,
                    53.8241468
                ],
                [
                    92.566783,
                    53.8241468
                ],
                [
                    92.5672028,
                    53.8239265
                ],
                [
                    92.5674561,
                    53.8238557
                ],
                [
                    92.5675894,
                    53.8236865
                ],
                [
                    92.5674561,
                    53.8235016
                ],
                [
                    92.5672162,
                    53.8233167
                ],
                [
                    92.5673256,
                    53.823199
                ],
                [
                    92.5676027,
                    53.822825
                ],
                [
                    92.561438,
                    53.8213458
                ],
                [
                    92.5612005,
                    53.8216633
                ],
                [
                    92.5609915,
                    53.8217917
                ],
                [
                    92.5578636,
                    53.823422
                ]
            ],
            "longitude": 92.5621638,
            "latitude": 53.8231503
        },
        "6705": {
            "name": "Рудиковка",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.56308,
            "latitude": 58.195572
        },
        "6706": {
            "name": "Старомолино",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.5690113,
            "latitude": 53.5618136
        },
        "6707": {
            "name": "Богдановка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.5951352,
            "latitude": 57.7981526
        },
        "6708": {
            "name": "Тагашет",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.602056,
            "latitude": 54.1880659
        },
        "6709": {
            "name": "Раскаты",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6025993,
            "latitude": 56.2993956
        },
        "6710": {
            "name": "Мужичкино",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6067453,
            "latitude": 56.2606381
        },
        "6711": {
            "name": "Борлок",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6155599,
            "latitude": 56.3465109
        },
        "6712": {
            "name": "Суворовский",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6221542,
            "latitude": 60.5818838
        },
        "6713": {
            "name": "Паница",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.633333,
            "latitude": 62.966667
        },
        "6714": {
            "name": "Малые Кныши",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6378946,
            "latitude": 54.323073
        },
        "6715": {
            "name": "Чубчиково",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6457454,
            "latitude": 53.5404442
        },
        "6716": {
            "name": "Щелкановка",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6556774,
            "latitude": 57.4971448
        },
        "6717": {
            "name": "Гамурино",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6557841,
            "latitude": 57.3971962
        },
        "6718": {
            "name": "Тюлюпта",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.658806,
            "latitude": 55.103237
        },
        "6719": {
            "name": "Ясная Поляна",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6594958,
            "latitude": 56.3107505
        },
        "6720": {
            "name": "Куркино",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6619062,
            "latitude": 53.4915615
        },
        "6721": {
            "name": "Красное Знамя",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6647254,
            "latitude": 56.4457819
        },
        "6722": {
            "name": "Ключи",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.6942977,
            "latitude": 53.6076283
        },
        "6723": {
            "name": "Нижняя Буланка",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.709976,
            "latitude": 53.350697
        },
        "6724": {
            "name": "Ленинка",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.710281,
            "latitude": 56.597301
        },
        "6725": {
            "name": "Усть-Золотая",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7201865,
            "latitude": 52.0907215
        },
        "6726": {
            "name": "Гляден",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7325995,
            "latitude": 56.3670087
        },
        "6727": {
            "name": "Простор",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7613381,
            "latitude": 56.3137744
        },
        "6728": {
            "name": "Плоское",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7643262,
            "latitude": 56.3064199
        },
        "6729": {
            "name": "Сотниково",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7650158,
            "latitude": 58.0690268
        },
        "6730": {
            "name": "Шалагино",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7683224,
            "latitude": 53.5254372
        },
        "6731": {
            "name": "Поначево",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7780343,
            "latitude": 54.124129
        },
        "6732": {
            "name": "Верхняя Буланка",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.779182,
            "latitude": 53.377396
        },
        "6733": {
            "name": "Ентауль",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7917055,
            "latitude": 56.9060002
        },
        "6734": {
            "name": "Чумница",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7925062,
            "latitude": 57.6342967
        },
        "6735": {
            "name": "Объединение",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7943685,
            "latitude": 56.3063605
        },
        "6736": {
            "name": "Долганы",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7999999,
            "latitude": 70.666667
        },
        "6737": {
            "name": "Верхний Кебеж",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8125188,
            "latitude": 53.2434874
        },
        "6738": {
            "name": "Шошкино",
            "population": 178,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.816055,
            "latitude": 56.583721
        },
        "6739": {
            "name": "Уральская",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8170915,
            "latitude": 54.0420889
        },
        "6740": {
            "name": "Нижняя Быстрая",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8180195,
            "latitude": 54.2186832
        },
        "6741": {
            "name": "Булановка",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8196699,
            "latitude": 56.4798744
        },
        "6742": {
            "name": "Смородинка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8288586,
            "latitude": 58.1355752
        },
        "6743": {
            "name": "Казанка",
            "population": 173,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8313124,
            "latitude": 57.0281638
        },
        "6744": {
            "name": "Черниговка",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8343416,
            "latitude": 53.2712703
        },
        "6745": {
            "name": "Подгорный",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8497047,
            "latitude": 53.8483708
        },
        "6746": {
            "name": "Томиловка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8595798,
            "latitude": 57.5445066
        },
        "6747": {
            "name": "Замятино",
            "population": 256,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8778517,
            "latitude": 56.1794314
        },
        "6748": {
            "name": "Кемское",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8933264,
            "latitude": 57.394479
        },
        "6749": {
            "name": "Хмелёво",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.8943397,
            "latitude": 56.8166811
        },
        "6750": {
            "name": "Ирба",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.9051275,
            "latitude": 53.9744136
        },
        "6751": {
            "name": "Чёрная Речка",
            "population": 48,
            "type": "hamlet",
            "poly": [
                [
                    92.8981583,
                    53.1507216
                ],
                [
                    92.900347,
                    53.1514292
                ],
                [
                    92.9025572,
                    53.1509918
                ],
                [
                    92.9051106,
                    53.1495634
                ],
                [
                    92.9070633,
                    53.1481477
                ],
                [
                    92.9091876,
                    53.14744
                ],
                [
                    92.9113333,
                    53.1474915
                ],
                [
                    92.91305,
                    53.1480835
                ],
                [
                    92.9147237,
                    53.148817
                ],
                [
                    92.917231,
                    53.1488132
                ],
                [
                    92.918543,
                    53.1485725
                ],
                [
                    92.9195516,
                    53.1481993
                ],
                [
                    92.9193156,
                    53.1476331
                ],
                [
                    92.9177277,
                    53.1472855
                ],
                [
                    92.9153888,
                    53.1466936
                ],
                [
                    92.9144017,
                    53.1456511
                ],
                [
                    92.9134791,
                    53.1446601
                ],
                [
                    92.9121273,
                    53.1440681
                ],
                [
                    92.910196,
                    53.1440681
                ],
                [
                    92.9083507,
                    53.1443384
                ],
                [
                    92.9067629,
                    53.1448017
                ],
                [
                    92.9050677,
                    53.1453036
                ],
                [
                    92.9043596,
                    53.1456769
                ],
                [
                    92.9038232,
                    53.1460372
                ],
                [
                    92.9028146,
                    53.1465392
                ],
                [
                    92.9018705,
                    53.1474658
                ],
                [
                    92.9005187,
                    53.1484181
                ],
                [
                    92.8991454,
                    53.1492932
                ],
                [
                    92.8981583,
                    53.1507216
                ]
            ],
            "longitude": 92.9090698,
            "latitude": 53.146725
        },
        "6752": {
            "name": "Усть-Тунгуска",
            "population": 267,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.9149302,
            "latitude": 58.1188968
        },
        "6753": {
            "name": "Михайловка",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.925063,
            "latitude": 56.8959009
        },
        "6754": {
            "name": "Крутой Лог",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.9393189,
            "latitude": 58.0409772
        },
        "6755": {
            "name": "Покровка",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.9509914,
            "latitude": 53.1859639
        },
        "6756": {
            "name": "Широкий Лог",
            "population": 37,
            "type": "hamlet",
            "poly": [
                [
                    92.9561912,
                    58.0708468
                ],
                [
                    92.9574531,
                    58.0726582
                ],
                [
                    92.9585741,
                    58.0758517
                ],
                [
                    92.9594135,
                    58.0761377
                ],
                [
                    92.9606191,
                    58.0761318
                ],
                [
                    92.9622076,
                    58.0756313
                ],
                [
                    92.9640892,
                    58.075816
                ],
                [
                    92.9656328,
                    58.0765011
                ],
                [
                    92.9662862,
                    58.0764892
                ],
                [
                    92.965768,
                    58.0758339
                ],
                [
                    92.9663877,
                    58.0756909
                ],
                [
                    92.959436,
                    58.071681
                ],
                [
                    92.958715,
                    58.0715678
                ],
                [
                    92.9567545,
                    58.0704893
                ],
                [
                    92.9561912,
                    58.0708468
                ]
            ],
            "longitude": 92.9598537,
            "latitude": 58.0740506
        },
        "6757": {
            "name": "Средний Кужебар",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.9708971,
            "latitude": 53.4878241
        },
        "6758": {
            "name": "Каргино",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.974804,
            "latitude": 58.0038755
        },
        "6759": {
            "name": "Енашимо",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.9755523,
            "latitude": 60.2520955
        },
        "6760": {
            "name": "Князевка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    92.9693907,
                    56.6385614
                ],
                [
                    92.969634,
                    56.6388682
                ],
                [
                    92.9701621,
                    56.6388384
                ],
                [
                    92.9708122,
                    56.6390171
                ],
                [
                    92.9712862,
                    56.6389501
                ],
                [
                    92.9711508,
                    56.6386671
                ],
                [
                    92.9710831,
                    56.6383841
                ],
                [
                    92.9717873,
                    56.6383766
                ],
                [
                    92.9720582,
                    56.6385703
                ],
                [
                    92.9725593,
                    56.6384362
                ],
                [
                    92.9737782,
                    56.6382128
                ],
                [
                    92.9743741,
                    56.6383096
                ],
                [
                    92.9744587,
                    56.6384325
                ],
                [
                    92.9744282,
                    56.6385498
                ],
                [
                    92.9746348,
                    56.6386224
                ],
                [
                    92.9749158,
                    56.638654
                ],
                [
                    92.9751748,
                    56.6386717
                ],
                [
                    92.9752581,
                    56.638645
                ],
                [
                    92.9754664,
                    56.6385991
                ],
                [
                    92.9763551,
                    56.6385113
                ],
                [
                    92.9764661,
                    56.6385342
                ],
                [
                    92.9765147,
                    56.6386259
                ],
                [
                    92.9769362,
                    56.6387124
                ],
                [
                    92.9770784,
                    56.6386752
                ],
                [
                    92.9774915,
                    56.6387124
                ],
                [
                    92.9776201,
                    56.638772
                ],
                [
                    92.9780466,
                    56.6387534
                ],
                [
                    92.9786494,
                    56.6387943
                ],
                [
                    92.9789212,
                    56.6388378
                ],
                [
                    92.9793994,
                    56.6388467
                ],
                [
                    92.9797388,
                    56.6388012
                ],
                [
                    92.9798215,
                    56.638997
                ],
                [
                    92.9801444,
                    56.6390379
                ],
                [
                    92.9803513,
                    56.6386874
                ],
                [
                    92.9806245,
                    56.6386464
                ],
                [
                    92.9811626,
                    56.6387511
                ],
                [
                    92.981651,
                    56.6388194
                ],
                [
                    92.9823296,
                    56.6388832
                ],
                [
                    92.9827436,
                    56.638997
                ],
                [
                    92.9833893,
                    56.6390243
                ],
                [
                    92.9835797,
                    56.6388103
                ],
                [
                    92.9833479,
                    56.6386601
                ],
                [
                    92.9832651,
                    56.6384188
                ],
                [
                    92.98353,
                    56.6380774
                ],
                [
                    92.9839274,
                    56.6376768
                ],
                [
                    92.9841923,
                    56.6374219
                ],
                [
                    92.9841757,
                    56.6370668
                ],
                [
                    92.9839936,
                    56.6367482
                ],
                [
                    92.9840764,
                    56.6366116
                ],
                [
                    92.9839687,
                    56.6364113
                ],
                [
                    92.9837121,
                    56.6363567
                ],
                [
                    92.9835549,
                    56.6359788
                ],
                [
                    92.9833231,
                    56.6358058
                ],
                [
                    92.9829792,
                    56.6356757
                ],
                [
                    92.9831782,
                    56.6354825
                ],
                [
                    92.983383,
                    56.6351478
                ],
                [
                    92.9834708,
                    56.6348999
                ],
                [
                    92.983506,
                    56.6346102
                ],
                [
                    92.9839353,
                    56.6343796
                ],
                [
                    92.9839348,
                    56.6341176
                ],
                [
                    92.9830164,
                    56.6341945
                ],
                [
                    92.9825354,
                    56.6342186
                ],
                [
                    92.9820718,
                    56.6341272
                ],
                [
                    92.9813023,
                    56.6338867
                ],
                [
                    92.9809174,
                    56.6336943
                ],
                [
                    92.9804626,
                    56.6335644
                ],
                [
                    92.9800341,
                    56.6334249
                ],
                [
                    92.9797192,
                    56.6333431
                ],
                [
                    92.979658,
                    56.6332133
                ],
                [
                    92.979728,
                    56.6330834
                ],
                [
                    92.9799291,
                    56.6329775
                ],
                [
                    92.9801216,
                    56.6328092
                ],
                [
                    92.9803489,
                    56.6324965
                ],
                [
                    92.9809524,
                    56.6319962
                ],
                [
                    92.9810749,
                    56.6318231
                ],
                [
                    92.9806113,
                    56.6318183
                ],
                [
                    92.9799204,
                    56.6319578
                ],
                [
                    92.9794394,
                    56.6320347
                ],
                [
                    92.9792032,
                    56.6319385
                ],
                [
                    92.9777856,
                    56.6320879
                ],
                [
                    92.9771107,
                    56.6321635
                ],
                [
                    92.9766542,
                    56.6321828
                ],
                [
                    92.9761508,
                    56.6322569
                ],
                [
                    92.975741,
                    56.6322633
                ],
                [
                    92.9752084,
                    56.6322601
                ],
                [
                    92.9750269,
                    56.6323728
                ],
                [
                    92.9750796,
                    56.6325208
                ],
                [
                    92.9750426,
                    56.6325732
                ],
                [
                    92.9749727,
                    56.6329383
                ],
                [
                    92.9746244,
                    56.6332036
                ],
                [
                    92.9742487,
                    56.6333015
                ],
                [
                    92.9741234,
                    56.6334574
                ],
                [
                    92.9742487,
                    56.6339286
                ],
                [
                    92.9738926,
                    56.6339286
                ],
                [
                    92.9736422,
                    56.6340881
                ],
                [
                    92.973662,
                    56.6342948
                ],
                [
                    92.9736818,
                    56.6345268
                ],
                [
                    92.9734313,
                    56.6347443
                ],
                [
                    92.973517,
                    56.6349944
                ],
                [
                    92.9737279,
                    56.6352808
                ],
                [
                    92.9737016,
                    56.6354911
                ],
                [
                    92.9734773,
                    56.6354621
                ],
                [
                    92.9733588,
                    56.6353062
                ],
                [
                    92.9729304,
                    56.6351503
                ],
                [
                    92.9727722,
                    56.6352663
                ],
                [
                    92.9725217,
                    56.6352917
                ],
                [
                    92.972291,
                    56.6350959
                ],
                [
                    92.9716581,
                    56.6350742
                ],
                [
                    92.9712693,
                    56.6351648
                ],
                [
                    92.9712033,
                    56.6353642
                ],
                [
                    92.9714802,
                    56.635531
                ],
                [
                    92.9719548,
                    56.6355056
                ],
                [
                    92.9724096,
                    56.6354113
                ],
                [
                    92.9727326,
                    56.6355527
                ],
                [
                    92.9727722,
                    56.635879
                ],
                [
                    92.9729238,
                    56.6361508
                ],
                [
                    92.972403,
                    56.6360892
                ],
                [
                    92.9720603,
                    56.635908
                ],
                [
                    92.9717768,
                    56.6361073
                ],
                [
                    92.9714605,
                    56.6363393
                ],
                [
                    92.9709134,
                    56.6364481
                ],
                [
                    92.9705904,
                    56.6363248
                ],
                [
                    92.970386,
                    56.6362016
                ],
                [
                    92.9701685,
                    56.636256
                ],
                [
                    92.9701751,
                    56.6366547
                ],
                [
                    92.9699444,
                    56.6370136
                ],
                [
                    92.9698192,
                    56.6372565
                ],
                [
                    92.9695028,
                    56.6375863
                ],
                [
                    92.9695094,
                    56.6381373
                ],
                [
                    92.9693907,
                    56.6385614
                ]
            ],
            "longitude": 92.977272,
            "latitude": 56.636398
        },
        "6761": {
            "name": "Придорожный",
            "population": 148,
            "type": "hamlet",
            "poly": [
                [
                    92.9742471,
                    56.2265936
                ],
                [
                    92.9745261,
                    56.2280011
                ],
                [
                    92.9744649,
                    56.2287812
                ],
                [
                    92.9756666,
                    56.2286977
                ],
                [
                    92.9759852,
                    56.2301839
                ],
                [
                    92.9767792,
                    56.2301362
                ],
                [
                    92.9779164,
                    56.2298976
                ],
                [
                    92.9790107,
                    56.2299573
                ],
                [
                    92.9809022,
                    56.2295684
                ],
                [
                    92.9818217,
                    56.2290627
                ],
                [
                    92.9836456,
                    56.2293728
                ],
                [
                    92.9872505,
                    56.2289792
                ],
                [
                    92.9901473,
                    56.2290746
                ],
                [
                    92.9953647,
                    56.2299382
                ],
                [
                    92.9962413,
                    56.2306491
                ],
                [
                    92.9989664,
                    56.2320087
                ],
                [
                    93.001434,
                    56.2322354
                ],
                [
                    93.0022526,
                    56.2317988
                ],
                [
                    93.000815,
                    56.2303079
                ],
                [
                    92.9993129,
                    56.22964
                ],
                [
                    92.9986445,
                    56.2288838
                ],
                [
                    92.9979579,
                    56.2278699
                ],
                [
                    92.9982154,
                    56.2273689
                ],
                [
                    92.9969708,
                    56.2267964
                ],
                [
                    92.9970813,
                    56.2258707
                ],
                [
                    92.9957692,
                    56.2251621
                ],
                [
                    92.9953433,
                    56.2244392
                ],
                [
                    92.9945246,
                    56.224518
                ],
                [
                    92.9942886,
                    56.225854
                ],
                [
                    92.9931514,
                    56.2267964
                ],
                [
                    92.9921428,
                    56.2270349
                ],
                [
                    92.9904691,
                    56.2269276
                ],
                [
                    92.9890315,
                    56.2260091
                ],
                [
                    92.9848687,
                    56.2252814
                ],
                [
                    92.9833055,
                    56.2250118
                ],
                [
                    92.9822079,
                    56.2246611
                ],
                [
                    92.9825513,
                    56.2242913
                ],
                [
                    92.9818035,
                    56.2240217
                ],
                [
                    92.9807274,
                    56.2246134
                ],
                [
                    92.979486,
                    56.2244154
                ],
                [
                    92.9773832,
                    56.2235684
                ],
                [
                    92.9759884,
                    56.2236519
                ],
                [
                    92.9756419,
                    56.2255319
                ],
                [
                    92.975599,
                    56.2265339
                ],
                [
                    92.9742471,
                    56.2265936
                ]
            ],
            "longitude": 92.9790492,
            "latitude": 56.2266741
        },
        "6762": {
            "name": "Урман",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.980743,
            "latitude": 55.551231
        },
        "6763": {
            "name": "Погорелка",
            "population": 183,
            "type": "hamlet",
            "poly": [
                [
                    92.9637554,
                    56.3311596
                ],
                [
                    92.9709125,
                    56.3365064
                ],
                [
                    92.9750705,
                    56.3379233
                ],
                [
                    92.9767196,
                    56.3383857
                ],
                [
                    92.9770238,
                    56.3392931
                ],
                [
                    92.9768644,
                    56.3406581
                ],
                [
                    92.9788346,
                    56.3412844
                ],
                [
                    92.9826301,
                    56.3421676
                ],
                [
                    92.9841222,
                    56.3425048
                ],
                [
                    92.9901341,
                    56.3439981
                ],
                [
                    92.9941034,
                    56.3410355
                ],
                [
                    92.9915828,
                    56.339807
                ],
                [
                    92.9903804,
                    56.3387953
                ],
                [
                    92.98376,
                    56.3360008
                ],
                [
                    92.9815436,
                    56.3360651
                ],
                [
                    92.9787042,
                    56.3345875
                ],
                [
                    92.9783565,
                    56.3338407
                ],
                [
                    92.9657662,
                    56.3294024
                ],
                [
                    92.9637554,
                    56.3311596
                ]
            ],
            "longitude": 92.9869328,
            "latitude": 56.3406185
        },
        "6764": {
            "name": "Родниковый",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.9920362,
            "latitude": 56.4163237
        },
        "6765": {
            "name": "Таловка",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.998849,
            "latitude": 53.3596014
        },
        "6766": {
            "name": "Береть",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.00235,
            "latitude": 55.691589
        },
        "6767": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.0024018,
            "latitude": 56.2902877
        },
        "6768": {
            "name": "Савино",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.0033684,
            "latitude": 58.014125
        },
        "6769": {
            "name": "Новотроицкое",
            "population": 157,
            "type": "hamlet",
            "poly": [
                [
                    93.0138755,
                    56.6624084
                ],
                [
                    93.0142436,
                    56.6631244
                ],
                [
                    93.0150351,
                    56.6634267
                ],
                [
                    93.0156654,
                    56.663877
                ],
                [
                    93.0162074,
                    56.6639047
                ],
                [
                    93.0176696,
                    56.6638354
                ],
                [
                    93.0190939,
                    56.6638354
                ],
                [
                    93.0201149,
                    56.6638285
                ],
                [
                    93.0212368,
                    56.664445
                ],
                [
                    93.0221442,
                    56.6649783
                ],
                [
                    93.0232409,
                    56.665574
                ],
                [
                    93.0251695,
                    56.6657749
                ],
                [
                    93.0266443,
                    56.6654978
                ],
                [
                    93.0273249,
                    56.6649783
                ],
                [
                    93.0279048,
                    56.6635306
                ],
                [
                    93.0288627,
                    56.6624223
                ],
                [
                    93.0298711,
                    56.6615494
                ],
                [
                    93.031182,
                    56.6609952
                ],
                [
                    93.0329089,
                    56.6603371
                ],
                [
                    93.0338921,
                    56.6597759
                ],
                [
                    93.0338795,
                    56.6592841
                ],
                [
                    93.0336526,
                    56.6588961
                ],
                [
                    93.0329845,
                    56.6585358
                ],
                [
                    93.0323039,
                    56.6582449
                ],
                [
                    93.0317743,
                    56.6580119
                ],
                [
                    93.0308039,
                    56.6577599
                ],
                [
                    93.0297664,
                    56.6573346
                ],
                [
                    93.0293674,
                    56.6570445
                ],
                [
                    93.0287623,
                    56.656847
                ],
                [
                    93.0279525,
                    56.6566964
                ],
                [
                    93.0272655,
                    56.6565682
                ],
                [
                    93.0264241,
                    56.6563725
                ],
                [
                    93.0254788,
                    56.6560936
                ],
                [
                    93.0247036,
                    56.655823
                ],
                [
                    93.0239031,
                    56.6556324
                ],
                [
                    93.0232288,
                    56.6555077
                ],
                [
                    93.0209142,
                    56.6547773
                ],
                [
                    93.0191748,
                    56.6544586
                ],
                [
                    93.0173651,
                    56.6548085
                ],
                [
                    93.0169334,
                    56.6548574
                ],
                [
                    93.0165752,
                    56.6549842
                ],
                [
                    93.0163395,
                    56.6550922
                ],
                [
                    93.015991,
                    56.6554835
                ],
                [
                    93.0157946,
                    56.6558451
                ],
                [
                    93.0152987,
                    56.6569487
                ],
                [
                    93.01523,
                    56.6571565
                ],
                [
                    93.0151024,
                    56.6574425
                ],
                [
                    93.0149502,
                    56.657707
                ],
                [
                    93.0147636,
                    56.657993
                ],
                [
                    93.0146458,
                    56.6582682
                ],
                [
                    93.0145378,
                    56.6584706
                ],
                [
                    93.014474,
                    56.658646
                ],
                [
                    93.0144936,
                    56.6588618
                ],
                [
                    93.0145869,
                    56.6592504
                ],
                [
                    93.0147342,
                    56.6596551
                ],
                [
                    93.0147784,
                    56.6598359
                ],
                [
                    93.0147735,
                    56.6599924
                ],
                [
                    93.0147342,
                    56.6601408
                ],
                [
                    93.0146065,
                    56.6604376
                ],
                [
                    93.0143463,
                    56.6609098
                ],
                [
                    93.013988,
                    56.6616194
                ],
                [
                    93.0140313,
                    56.6619664
                ],
                [
                    93.0138755,
                    56.6624084
                ]
            ],
            "longitude": 93.024109,
            "latitude": 56.660069
        },
        "6770": {
            "name": "Суханово",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.0326459,
            "latitude": 56.3445877
        },
        "6771": {
            "name": "Верхобродово",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.0330108,
            "latitude": 56.830077
        },
        "6772": {
            "name": "Усть-Ангарск",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    93.028319,
                    58.1060073
                ],
                [
                    93.0289329,
                    58.1066397
                ],
                [
                    93.0312196,
                    58.1072235
                ],
                [
                    93.0319869,
                    58.1069965
                ],
                [
                    93.0323246,
                    58.1070532
                ],
                [
                    93.0333989,
                    58.1076087
                ],
                [
                    93.0342046,
                    58.1081478
                ],
                [
                    93.0350487,
                    58.1082087
                ],
                [
                    93.0358927,
                    58.1087032
                ],
                [
                    93.0369056,
                    58.1087478
                ],
                [
                    93.0381411,
                    58.1084073
                ],
                [
                    93.0385938,
                    58.1079573
                ],
                [
                    93.0390389,
                    58.1076938
                ],
                [
                    93.0401514,
                    58.1074951
                ],
                [
                    93.0408728,
                    58.10756
                ],
                [
                    93.0415174,
                    58.1079978
                ],
                [
                    93.0420929,
                    58.1080303
                ],
                [
                    93.0428371,
                    58.1079735
                ],
                [
                    93.0437503,
                    58.1072559
                ],
                [
                    93.0451238,
                    58.1072357
                ],
                [
                    93.0462059,
                    58.1075762
                ],
                [
                    93.0462289,
                    58.1076978
                ],
                [
                    93.0466663,
                    58.1084276
                ],
                [
                    93.0487842,
                    58.1097694
                ],
                [
                    93.0508714,
                    58.1074708
                ],
                [
                    93.0514776,
                    58.1072478
                ],
                [
                    93.0516847,
                    58.1069235
                ],
                [
                    93.0520991,
                    58.1065221
                ],
                [
                    93.0523599,
                    58.1062911
                ],
                [
                    93.0517078,
                    58.1062627
                ],
                [
                    93.0518459,
                    58.1055653
                ],
                [
                    93.051938,
                    58.1053423
                ],
                [
                    93.0520914,
                    58.1049491
                ],
                [
                    93.0521605,
                    58.1046085
                ],
                [
                    93.0524214,
                    58.1044544
                ],
                [
                    93.0522909,
                    58.1042598
                ],
                [
                    93.0518919,
                    58.1042679
                ],
                [
                    93.0511323,
                    58.1038787
                ],
                [
                    93.0500196,
                    58.1035949
                ],
                [
                    93.0507179,
                    58.1029867
                ],
                [
                    93.0507102,
                    58.1025407
                ],
                [
                    93.0507946,
                    58.1018919
                ],
                [
                    93.0511246,
                    58.1019244
                ],
                [
                    93.0515466,
                    58.101673
                ],
                [
                    93.0517922,
                    58.101154
                ],
                [
                    93.0515466,
                    58.1009796
                ],
                [
                    93.0503956,
                    58.1007201
                ],
                [
                    93.0495976,
                    58.1004079
                ],
                [
                    93.047848,
                    58.099978
                ],
                [
                    93.0465128,
                    58.1000064
                ],
                [
                    93.0458606,
                    58.1001727
                ],
                [
                    93.0462366,
                    58.0998969
                ],
                [
                    93.0475027,
                    58.0984736
                ],
                [
                    93.0474797,
                    58.0981492
                ],
                [
                    93.0463824,
                    58.0975734
                ],
                [
                    93.0449398,
                    58.096884
                ],
                [
                    93.0444717,
                    58.0968759
                ],
                [
                    93.0438118,
                    58.0969813
                ],
                [
                    93.0423308,
                    58.0974558
                ],
                [
                    93.0419164,
                    58.0977234
                ],
                [
                    93.0432209,
                    58.0984493
                ],
                [
                    93.0417553,
                    58.0990697
                ],
                [
                    93.0413486,
                    58.1000267
                ],
                [
                    93.0407577,
                    58.1005984
                ],
                [
                    93.0413638,
                    58.1010607
                ],
                [
                    93.039154,
                    58.1022163
                ],
                [
                    93.0388624,
                    58.102561
                ],
                [
                    93.0380643,
                    58.1028083
                ],
                [
                    93.0362764,
                    58.1034449
                ],
                [
                    93.0350947,
                    58.1041868
                ],
                [
                    93.0345959,
                    58.1038219
                ],
                [
                    93.0343886,
                    58.1041544
                ],
                [
                    93.0334065,
                    58.1039638
                ],
                [
                    93.0328157,
                    58.1044909
                ],
                [
                    93.0320023,
                    58.1042841
                ],
                [
                    93.032079,
                    58.1046693
                ],
                [
                    93.0315879,
                    58.1048396
                ],
                [
                    93.0308742,
                    58.1044544
                ],
                [
                    93.0301376,
                    58.1045152
                ],
                [
                    93.0299457,
                    58.1049166
                ],
                [
                    93.030529,
                    58.1052491
                ],
                [
                    93.0306057,
                    58.1054437
                ],
                [
                    93.028649,
                    58.1057721
                ],
                [
                    93.028319,
                    58.1060073
                ]
            ],
            "longitude": 93.0429397,
            "latitude": 58.1042399
        },
        "6773": {
            "name": "Куромба",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.0479335,
            "latitude": 61.0782748
        },
        "6774": {
            "name": "Брод",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.071671,
            "latitude": 55.662899
        },
        "6775": {
            "name": "Шестаково",
            "population": 27,
            "type": "hamlet",
            "poly": [
                [
                    93.0626813,
                    56.6446214
                ],
                [
                    93.0627851,
                    56.6448978
                ],
                [
                    93.0635489,
                    56.6446363
                ],
                [
                    93.0646318,
                    56.6443196
                ],
                [
                    93.0654205,
                    56.6440959
                ],
                [
                    93.0660591,
                    56.6439548
                ],
                [
                    93.0665411,
                    56.6439204
                ],
                [
                    93.067117,
                    56.6437999
                ],
                [
                    93.0677242,
                    56.6437517
                ],
                [
                    93.0680121,
                    56.6439823
                ],
                [
                    93.0686444,
                    56.644003
                ],
                [
                    93.0690888,
                    56.6439204
                ],
                [
                    93.0694957,
                    56.6438791
                ],
                [
                    93.0699715,
                    56.6438481
                ],
                [
                    93.0704409,
                    56.6439961
                ],
                [
                    93.0708979,
                    56.6439754
                ],
                [
                    93.0711045,
                    56.6438033
                ],
                [
                    93.0717054,
                    56.643793
                ],
                [
                    93.0721748,
                    56.644058
                ],
                [
                    93.0724378,
                    56.6441647
                ],
                [
                    93.0726569,
                    56.6443437
                ],
                [
                    93.0731076,
                    56.6442611
                ],
                [
                    93.0739465,
                    56.6441751
                ],
                [
                    93.0745161,
                    56.6443437
                ],
                [
                    93.0746123,
                    56.6445744
                ],
                [
                    93.0749684,
                    56.6446938
                ],
                [
                    93.0753189,
                    56.6445286
                ],
                [
                    93.07602,
                    56.6444494
                ],
                [
                    93.0763143,
                    56.644181
                ],
                [
                    93.0766022,
                    56.6440399
                ],
                [
                    93.0771656,
                    56.6440708
                ],
                [
                    93.0777665,
                    56.6441121
                ],
                [
                    93.0782986,
                    56.6440915
                ],
                [
                    93.0787555,
                    56.64394
                ],
                [
                    93.0787994,
                    56.6436991
                ],
                [
                    93.0788182,
                    56.6435029
                ],
                [
                    93.07915,
                    56.6433033
                ],
                [
                    93.0793565,
                    56.6431587
                ],
                [
                    93.079369,
                    56.6428593
                ],
                [
                    93.0797946,
                    56.6427939
                ],
                [
                    93.0803957,
                    56.642725
                ],
                [
                    93.0806022,
                    56.64267
                ],
                [
                    93.0809215,
                    56.6424566
                ],
                [
                    93.0812407,
                    56.642398
                ],
                [
                    93.0816101,
                    56.6425116
                ],
                [
                    93.0818855,
                    56.6428042
                ],
                [
                    93.0821484,
                    56.6428145
                ],
                [
                    93.0822297,
                    56.6426355
                ],
                [
                    93.0824176,
                    56.6424187
                ],
                [
                    93.0829121,
                    56.6422294
                ],
                [
                    93.0831124,
                    56.6420573
                ],
                [
                    93.0829935,
                    56.6419196
                ],
                [
                    93.0829715,
                    56.6417337
                ],
                [
                    93.082545,
                    56.6415611
                ],
                [
                    93.0815539,
                    56.6413891
                ],
                [
                    93.0814537,
                    56.6412033
                ],
                [
                    93.0813118,
                    56.6409859
                ],
                [
                    93.0809577,
                    56.6407645
                ],
                [
                    93.0810418,
                    56.6406014
                ],
                [
                    93.0815596,
                    56.6407231
                ],
                [
                    93.0817278,
                    56.6406306
                ],
                [
                    93.0815552,
                    56.6404067
                ],
                [
                    93.0813605,
                    56.6402411
                ],
                [
                    93.0811523,
                    56.6402241
                ],
                [
                    93.0810373,
                    56.6401438
                ],
                [
                    93.0808957,
                    56.6400464
                ],
                [
                    93.0807097,
                    56.6401511
                ],
                [
                    93.0804132,
                    56.6400489
                ],
                [
                    93.0802052,
                    56.6398858
                ],
                [
                    93.0801653,
                    56.6397933
                ],
                [
                    93.0802539,
                    56.6396594
                ],
                [
                    93.0803247,
                    56.6394841
                ],
                [
                    93.0802716,
                    56.6392846
                ],
                [
                    93.0801388,
                    56.6391142
                ],
                [
                    93.0800989,
                    56.6389073
                ],
                [
                    93.0801786,
                    56.6386882
                ],
                [
                    93.080214,
                    56.6384618
                ],
                [
                    93.0802539,
                    56.6383085
                ],
                [
                    93.0803512,
                    56.6382062
                ],
                [
                    93.0802362,
                    56.6380845
                ],
                [
                    93.080037,
                    56.6379969
                ],
                [
                    93.0798156,
                    56.637734
                ],
                [
                    93.0796961,
                    56.6375709
                ],
                [
                    93.0795116,
                    56.6374979
                ],
                [
                    93.0789128,
                    56.6374741
                ],
                [
                    93.0785748,
                    56.6374982
                ],
                [
                    93.0784684,
                    56.637388
                ],
                [
                    93.0780552,
                    56.6374018
                ],
                [
                    93.0775607,
                    56.6375395
                ],
                [
                    93.0774417,
                    56.637925
                ],
                [
                    93.077354,
                    56.6381626
                ],
                [
                    93.0771225,
                    56.6381901
                ],
                [
                    93.0770536,
                    56.6380662
                ],
                [
                    93.0768471,
                    56.6378837
                ],
                [
                    93.0765779,
                    56.6379422
                ],
                [
                    93.0763963,
                    56.6377977
                ],
                [
                    93.0759707,
                    56.6375498
                ],
                [
                    93.0758392,
                    56.6373536
                ],
                [
                    93.0755137,
                    56.6374293
                ],
                [
                    93.0756639,
                    56.6376531
                ],
                [
                    93.0757516,
                    56.6380076
                ],
                [
                    93.0753635,
                    56.6381178
                ],
                [
                    93.0751882,
                    56.6379732
                ],
                [
                    93.0751757,
                    56.6377873
                ],
                [
                    93.0753635,
                    56.6376944
                ],
                [
                    93.0752758,
                    56.6375567
                ],
                [
                    93.0749065,
                    56.637505
                ],
                [
                    93.0750192,
                    56.6373433
                ],
                [
                    93.0753134,
                    56.6372641
                ],
                [
                    93.0752946,
                    56.6371092
                ],
                [
                    93.0748627,
                    56.6372055
                ],
                [
                    93.0745184,
                    56.6371574
                ],
                [
                    93.0744495,
                    56.6369439
                ],
                [
                    93.0744808,
                    56.6367683
                ],
                [
                    93.0743243,
                    56.636641
                ],
                [
                    93.0738415,
                    56.636309
                ],
                [
                    93.0735958,
                    56.6361632
                ],
                [
                    93.0732933,
                    56.6360835
                ],
                [
                    93.0725461,
                    56.6359639
                ],
                [
                    93.0722769,
                    56.6362536
                ],
                [
                    93.0715628,
                    56.6362536
                ],
                [
                    93.0711331,
                    56.6366329
                ],
                [
                    93.0708641,
                    56.6366898
                ],
                [
                    93.070434,
                    56.6367487
                ],
                [
                    93.0703657,
                    56.6367681
                ],
                [
                    93.0702766,
                    56.6367544
                ],
                [
                    93.0701505,
                    56.6367556
                ],
                [
                    93.0700595,
                    56.6368113
                ],
                [
                    93.0691932,
                    56.6371204
                ],
                [
                    93.0692411,
                    56.6373535
                ],
                [
                    93.0694183,
                    56.6373924
                ],
                [
                    93.069675,
                    56.6375385
                ],
                [
                    93.0696573,
                    56.6376991
                ],
                [
                    93.0693917,
                    56.6377868
                ],
                [
                    93.0690907,
                    56.6377576
                ],
                [
                    93.0689668,
                    56.6378793
                ],
                [
                    93.0691173,
                    56.6379718
                ],
                [
                    93.0693208,
                    56.6380107
                ],
                [
                    93.0691084,
                    56.6382298
                ],
                [
                    93.0693651,
                    56.6384878
                ],
                [
                    93.0695422,
                    56.6386923
                ],
                [
                    93.0691704,
                    56.6389211
                ],
                [
                    93.0686568,
                    56.6389746
                ],
                [
                    93.0684533,
                    56.6391888
                ],
                [
                    93.0683117,
                    56.6393738
                ],
                [
                    93.0679841,
                    56.6393008
                ],
                [
                    93.0678779,
                    56.639442
                ],
                [
                    93.0681081,
                    56.6396562
                ],
                [
                    93.0685242,
                    56.6398022
                ],
                [
                    93.068595,
                    56.6400067
                ],
                [
                    93.0689668,
                    56.640216
                ],
                [
                    93.0697016,
                    56.640255
                ],
                [
                    93.0700203,
                    56.640474
                ],
                [
                    93.0700822,
                    56.6406201
                ],
                [
                    93.0698609,
                    56.6408197
                ],
                [
                    93.0694006,
                    56.64099
                ],
                [
                    93.0689048,
                    56.6411215
                ],
                [
                    93.0686127,
                    56.6412529
                ],
                [
                    93.0684091,
                    56.6415109
                ],
                [
                    93.0680373,
                    56.6414233
                ],
                [
                    93.0677009,
                    56.6413843
                ],
                [
                    93.0672228,
                    56.6415839
                ],
                [
                    93.0665146,
                    56.6418224
                ],
                [
                    93.0660542,
                    56.6419928
                ],
                [
                    93.0655585,
                    56.6420756
                ],
                [
                    93.0649653,
                    56.6419587
                ],
                [
                    93.0646112,
                    56.641764
                ],
                [
                    93.0640712,
                    56.6417202
                ],
                [
                    93.0639473,
                    56.6419052
                ],
                [
                    93.0646732,
                    56.6419782
                ],
                [
                    93.0652132,
                    56.6422606
                ],
                [
                    93.065886,
                    56.6423433
                ],
                [
                    93.065585,
                    56.6424893
                ],
                [
                    93.0650804,
                    56.6424601
                ],
                [
                    93.0650184,
                    56.6426938
                ],
                [
                    93.0650096,
                    56.6429031
                ],
                [
                    93.0644696,
                    56.6430637
                ],
                [
                    93.0642394,
                    56.6432876
                ],
                [
                    93.0638588,
                    56.643497
                ],
                [
                    93.0637791,
                    56.6438134
                ],
                [
                    93.063726,
                    56.64412
                ],
                [
                    93.0632214,
                    56.6443829
                ],
                [
                    93.0626813,
                    56.6446214
                ]
            ],
            "longitude": 93.074417,
            "latitude": 56.640129
        },
        "6776": {
            "name": "Красный Кордон",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.0762468,
            "latitude": 54.0684127
        },
        "6777": {
            "name": "Черняевка",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.0974453,
            "latitude": 57.2390026
        },
        "6778": {
            "name": "Верх-Подъёмная",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1066536,
            "latitude": 56.780574
        },
        "6779": {
            "name": "Лукино",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.108688,
            "latitude": 55.945705
        },
        "6780": {
            "name": "Червизюль",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1240254,
            "latitude": 53.217734
        },
        "6781": {
            "name": "Иркутское",
            "population": 136,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1245498,
            "latitude": 56.3760469
        },
        "6782": {
            "name": "Минжуль",
            "population": 178,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1368924,
            "latitude": 56.2710906
        },
        "6783": {
            "name": "Бобровка",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1422564,
            "latitude": 57.3211077
        },
        "6784": {
            "name": "Андреев Ключ",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1537197,
            "latitude": 54.0639387
        },
        "6785": {
            "name": "Малороссийка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1715499,
            "latitude": 57.0927011
        },
        "6786": {
            "name": "Орловка",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1890152,
            "latitude": 57.2635199
        },
        "6787": {
            "name": "Верхние Куряты",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1934687,
            "latitude": 53.7337027
        },
        "6788": {
            "name": "Березняки",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1947043,
            "latitude": 57.5587229
        },
        "6789": {
            "name": "Алексеевка",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2018746,
            "latitude": 53.4414605
        },
        "6790": {
            "name": "Ковригино",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.209106,
            "latitude": 56.622837
        },
        "6791": {
            "name": "Свищево",
            "population": 256,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.212807,
            "latitude": 55.884613
        },
        "6792": {
            "name": "Татарская",
            "population": 192,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2155857,
            "latitude": 56.3152205
        },
        "6793": {
            "name": "Маралсовхоз",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2200685,
            "latitude": 52.2356329
        },
        "6794": {
            "name": "Водорезово",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.233228,
            "latitude": 57.5874693
        },
        "6795": {
            "name": "Худоногово",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2333961,
            "latitude": 56.1650844
        },
        "6796": {
            "name": "Маганский",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.23452,
            "latitude": 55.873116
        },
        "6797": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2387385,
            "latitude": 53.6625681
        },
        "6798": {
            "name": "Зырянка",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.242226,
            "latitude": 57.731316
        },
        "6799": {
            "name": "Серебряково",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2492239,
            "latitude": 56.2136788
        },
        "6800": {
            "name": "Курбатово",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2505634,
            "latitude": 57.7429113
        },
        "6801": {
            "name": "Тартазяк",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2543581,
            "latitude": 54.1273688
        },
        "6802": {
            "name": "Лопатино",
            "population": 221,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.25457,
            "latitude": 55.955997
        },
        "6803": {
            "name": "Гавань",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2587793,
            "latitude": 57.7576667
        },
        "6804": {
            "name": "Нижнее Комарово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2632639,
            "latitude": 56.8848665
        },
        "6805": {
            "name": "Верхняя Мульга",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2657555,
            "latitude": 54.1681759
        },
        "6806": {
            "name": "Пионерск",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2678657,
            "latitude": 54.315384
        },
        "6807": {
            "name": "Порог",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2684345,
            "latitude": 57.4541484
        },
        "6808": {
            "name": "Красная Сибирь",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.27063,
            "latitude": 55.931656
        },
        "6809": {
            "name": "Карымская",
            "population": 160,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2865352,
            "latitude": 56.336036
        },
        "6810": {
            "name": "Есауловка",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.286888,
            "latitude": 56.100647
        },
        "6811": {
            "name": "Жистык",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.288963,
            "latitude": 55.712189
        },
        "6812": {
            "name": "Усть-Каспа",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2891168,
            "latitude": 54.1924645
        },
        "6813": {
            "name": "Самково",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2931413,
            "latitude": 57.6033124
        },
        "6814": {
            "name": "Жержул",
            "population": 203,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.2956494,
            "latitude": 55.4013499
        },
        "6815": {
            "name": "Язаевка",
            "population": 206,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.298309,
            "latitude": 57.324158
        },
        "6816": {
            "name": "Подпорожье",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3026075,
            "latitude": 57.5280824
        },
        "6817": {
            "name": "Луговское",
            "population": 131,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3038656,
            "latitude": 57.3039884
        },
        "6818": {
            "name": "Муратово",
            "population": 169,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3059775,
            "latitude": 57.1884257
        },
        "6819": {
            "name": "Бузуново",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3244975,
            "latitude": 56.7012277
        },
        "6820": {
            "name": "Минск",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3343983,
            "latitude": 57.099061
        },
        "6821": {
            "name": "Татарка",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.351791,
            "latitude": 58.189266
        },
        "6822": {
            "name": "Джотка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3550968,
            "latitude": 54.6708157
        },
        "6823": {
            "name": "Малый Унгут",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3592153,
            "latitude": 55.4452674
        },
        "6824": {
            "name": "Береговая-Подъёмная",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3767118,
            "latitude": 56.9124075
        },
        "6825": {
            "name": "Кордон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3770227,
            "latitude": 68.4407563
        },
        "6826": {
            "name": "Куваршино",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3772702,
            "latitude": 56.2461369
        },
        "6827": {
            "name": "Толстомысово",
            "population": 190,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.377778,
            "latitude": 56.415791
        },
        "6828": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3841311,
            "latitude": 54.1954317
        },
        "6829": {
            "name": "Верхняя Базаиха",
            "population": 209,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.386009,
            "latitude": 55.689137
        },
        "6830": {
            "name": "Анастасино",
            "population": 219,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3920342,
            "latitude": 55.1242796
        },
        "6831": {
            "name": "Сорокино",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3926631,
            "latitude": 55.8825752
        },
        "6832": {
            "name": "Тагенарское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4,
            "latitude": 70.833333
        },
        "6833": {
            "name": "Барабаново",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.423683,
            "latitude": 56.286957
        },
        "6834": {
            "name": "Вельмо",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4258598,
            "latitude": 61.0177997
        },
        "6835": {
            "name": "Самарка",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.430001,
            "latitude": 55.8842204
        },
        "6836": {
            "name": "Джебь",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4313816,
            "latitude": 54.4866885
        },
        "6837": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4535481,
            "latitude": 53.9091621
        },
        "6838": {
            "name": "Маральский",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4555359,
            "latitude": 52.255909
        },
        "6839": {
            "name": "Покровка",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4565884,
            "latitude": 57.1584142
        },
        "6840": {
            "name": "Кизенжуль",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4570277,
            "latitude": 55.7727367
        },
        "6841": {
            "name": "Правый",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4752039,
            "latitude": 55.8632398
        },
        "6842": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4825689,
            "latitude": 53.9678665
        },
        "6843": {
            "name": "Новоерудинский",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4843041,
            "latitude": 59.7833367
        },
        "6844": {
            "name": "Новосельск",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4875775,
            "latitude": 55.829796
        },
        "6845": {
            "name": "Малая Кускунка",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.489906,
            "latitude": 55.965443
        },
        "6846": {
            "name": "Спирино",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4954481,
            "latitude": 55.100278
        },
        "6847": {
            "name": "Малиновка",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.4985152,
            "latitude": 53.7900457
        },
        "6848": {
            "name": "Агата",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5005345,
            "latitude": 66.9334292
        },
        "6849": {
            "name": "Берег Таскино",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5233252,
            "latitude": 56.7950731
        },
        "6850": {
            "name": "Нововасильевка",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5272083,
            "latitude": 55.2590616
        },
        "6851": {
            "name": "Верхнешалинское",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5427043,
            "latitude": 55.6889054
        },
        "6852": {
            "name": "Чистополка",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5550798,
            "latitude": 57.482922
        },
        "6853": {
            "name": "Малое Нахвальское",
            "population": 236,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.563611,
            "latitude": 56.7074659
        },
        "6854": {
            "name": "Козьмо-Демьяновка",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5663667,
            "latitude": 57.1384017
        },
        "6855": {
            "name": "Кекур",
            "population": 234,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5762719,
            "latitude": 56.6166475
        },
        "6856": {
            "name": "Кускун",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.57962,
            "latitude": 55.95187
        },
        "6857": {
            "name": "Троицкое",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5801593,
            "latitude": 57.0763463
        },
        "6858": {
            "name": "Новоалексеевка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6011073,
            "latitude": 55.4955834
        },
        "6859": {
            "name": "Кубеинка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6178233,
            "latitude": 55.6560855
        },
        "6860": {
            "name": "Дементьевка",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6186758,
            "latitude": 57.6186492
        },
        "6861": {
            "name": "Золотой Ключ",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6260837,
            "latitude": 57.3652305
        },
        "6862": {
            "name": "Широково",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6372066,
            "latitude": 57.579123
        },
        "6863": {
            "name": "Пимия",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6422717,
            "latitude": 55.3640343
        },
        "6864": {
            "name": "Ручейки",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6658932,
            "latitude": 55.8589655
        },
        "6865": {
            "name": "Жайма",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6739349,
            "latitude": 54.83853
        },
        "6866": {
            "name": "Жайма",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6823486,
            "latitude": 54.8462313
        },
        "6867": {
            "name": "Абакшино",
            "population": 211,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6895483,
            "latitude": 56.5729919
        },
        "6868": {
            "name": "Исток",
            "population": 213,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7021433,
            "latitude": 56.602612
        },
        "6869": {
            "name": "Большой Балчуг",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7133064,
            "latitude": 56.4535723
        },
        "6870": {
            "name": "Малая Камарчага",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7212317,
            "latitude": 55.7993065
        },
        "6871": {
            "name": "Сосновка",
            "population": 241,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.776085,
            "latitude": 55.636353
        },
        "6872": {
            "name": "Новомихайловка",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7770436,
            "latitude": 55.5639774
        },
        "6873": {
            "name": "Межталовка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7983421,
            "latitude": 57.3261307
        },
        "6874": {
            "name": "Кирза",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7989024,
            "latitude": 55.111211
        },
        "6875": {
            "name": "Сергеевка",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7997556,
            "latitude": 55.9273381
        },
        "6876": {
            "name": "Усть-Кан",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8010254,
            "latitude": 56.5133832
        },
        "6877": {
            "name": "Средняя Шилка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8055846,
            "latitude": 57.3474647
        },
        "6878": {
            "name": "Пит-Городок",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.819572,
            "latitude": 59.304657
        },
        "6879": {
            "name": "Пинчино",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8236009,
            "latitude": 55.848499
        },
        "6880": {
            "name": "Тингино",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8266462,
            "latitude": 55.8888765
        },
        "6881": {
            "name": "Сугристое",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8523717,
            "latitude": 55.5773457
        },
        "6882": {
            "name": "Островки",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8640057,
            "latitude": 55.5367408
        },
        "6883": {
            "name": "Подпорог",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8900261,
            "latitude": 56.4591888
        },
        "6884": {
            "name": "Белогорка",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.918322,
            "latitude": 55.714444
        },
        "6885": {
            "name": "Хвойный",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.9238452,
            "latitude": 55.9850907
        },
        "6886": {
            "name": "Жандат",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.9289398,
            "latitude": 55.8891064
        },
        "6887": {
            "name": "Покосное",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.9454015,
            "latitude": 55.5869317
        },
        "6888": {
            "name": "Тунгусы",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.966667,
            "latitude": 70.683333
        },
        "6889": {
            "name": "Хабайдак",
            "population": 199,
            "type": "hamlet",
            "poly": [
                [
                    93.980686,
                    54.9475347
                ],
                [
                    93.9819494,
                    54.9476557
                ],
                [
                    93.9820547,
                    54.9484417
                ],
                [
                    93.9831575,
                    54.949675
                ],
                [
                    93.9832102,
                    54.9514284
                ],
                [
                    93.9839472,
                    54.9532725
                ],
                [
                    93.9860528,
                    54.9533632
                ],
                [
                    93.9866319,
                    54.9518819
                ],
                [
                    93.9882638,
                    54.948889
                ],
                [
                    93.9893693,
                    54.947982
                ],
                [
                    93.993528,
                    54.9497657
                ],
                [
                    93.9972055,
                    54.9495843
                ],
                [
                    94.0039963,
                    54.9486471
                ],
                [
                    94.0064705,
                    54.9461377
                ],
                [
                    94.0086288,
                    54.9408463
                ],
                [
                    94.0126823,
                    54.9365824
                ],
                [
                    94.0108924,
                    54.934919
                ],
                [
                    94.0053123,
                    54.936159
                ],
                [
                    94.0025223,
                    54.9389714
                ],
                [
                    94.0008378,
                    54.9407858
                ],
                [
                    94.0019432,
                    54.9426303
                ],
                [
                    94.0012063,
                    54.9456842
                ],
                [
                    93.9992585,
                    54.9456237
                ],
                [
                    93.9953103,
                    54.9444748
                ],
                [
                    93.9936258,
                    54.9434467
                ],
                [
                    93.9985215,
                    54.9385178
                ],
                [
                    93.9942575,
                    54.9374896
                ],
                [
                    93.9899935,
                    54.9404229
                ],
                [
                    93.9875302,
                    54.9429238
                ],
                [
                    93.9846086,
                    54.9465975
                ],
                [
                    93.9821081,
                    54.9470056
                ],
                [
                    93.980686,
                    54.9475347
                ]
            ],
            "longitude": 93.991554,
            "latitude": 54.946812
        },
        "6890": {
            "name": "Новогеоргиевка",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0010053,
            "latitude": 55.6249546
        },
        "6891": {
            "name": "Никольское",
            "population": 206,
            "type": "hamlet",
            "poly": [
                [
                    94.0187021,
                    55.8943785
                ],
                [
                    94.0196172,
                    55.8954763
                ],
                [
                    94.0205536,
                    55.8959655
                ],
                [
                    94.02066,
                    55.8965622
                ],
                [
                    94.0222348,
                    55.8971707
                ],
                [
                    94.0219368,
                    55.8977792
                ],
                [
                    94.0221922,
                    55.8997479
                ],
                [
                    94.0233201,
                    55.9002609
                ],
                [
                    94.025661,
                    55.9004637
                ],
                [
                    94.0268102,
                    55.899903
                ],
                [
                    94.029066,
                    55.9008694
                ],
                [
                    94.0357908,
                    55.9029811
                ],
                [
                    94.0362622,
                    55.9026369
                ],
                [
                    94.0363164,
                    55.9021298
                ],
                [
                    94.0369315,
                    55.9019422
                ],
                [
                    94.0376371,
                    55.9018154
                ],
                [
                    94.0385959,
                    55.9008113
                ],
                [
                    94.0424286,
                    55.9038055
                ],
                [
                    94.0446928,
                    55.9051149
                ],
                [
                    94.0473152,
                    55.9057656
                ],
                [
                    94.0505251,
                    55.9043598
                ],
                [
                    94.0483899,
                    55.902488
                ],
                [
                    94.0474441,
                    55.9021988
                ],
                [
                    94.0460111,
                    55.9009054
                ],
                [
                    94.0442629,
                    55.8998128
                ],
                [
                    94.0430878,
                    55.8998369
                ],
                [
                    94.0413968,
                    55.9006001
                ],
                [
                    94.0397918,
                    55.8995958
                ],
                [
                    94.0375134,
                    55.8995476
                ],
                [
                    94.0363383,
                    55.8989772
                ],
                [
                    94.0374847,
                    55.8968963
                ],
                [
                    94.0353065,
                    55.8967195
                ],
                [
                    94.0339022,
                    55.8965428
                ],
                [
                    94.03249,
                    55.8967094
                ],
                [
                    94.0302299,
                    55.8960942
                ],
                [
                    94.0286347,
                    55.895793
                ],
                [
                    94.0293372,
                    55.8951766
                ],
                [
                    94.0285603,
                    55.8945927
                ],
                [
                    94.0274363,
                    55.8943703
                ],
                [
                    94.0263701,
                    55.8940598
                ],
                [
                    94.0258907,
                    55.8938002
                ],
                [
                    94.0240557,
                    55.8932868
                ],
                [
                    94.0234636,
                    55.8933928
                ],
                [
                    94.0211281,
                    55.8930885
                ],
                [
                    94.0187021,
                    55.8943785
                ]
            ],
            "longitude": 94.0309725,
            "latitude": 55.8985009
        },
        "6892": {
            "name": "Тиберкуль",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0312557,
            "latitude": 53.9073563
        },
        "6893": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0382559,
            "latitude": 62.8652769
        },
        "6894": {
            "name": "Булатновка",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0435981,
            "latitude": 55.435328
        },
        "6895": {
            "name": "Кой",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.059402,
            "latitude": 55.095379
        },
        "6896": {
            "name": "Речка",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0652244,
            "latitude": 56.0282601
        },
        "6897": {
            "name": "Малый Имбеж",
            "population": 66,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0674223,
            "latitude": 55.5361001
        },
        "6898": {
            "name": "Луково",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0704728,
            "latitude": 55.7960559
        },
        "6899": {
            "name": "Кандаки",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0812778,
            "latitude": 58.0059204
        },
        "6900": {
            "name": "Хайдак",
            "population": 192,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0848906,
            "latitude": 55.467579
        },
        "6901": {
            "name": "Ивановка",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    94.084667,
                    54.9425754
                ],
                [
                    94.0895806,
                    54.9440293
                ],
                [
                    94.0906228,
                    54.9432168
                ],
                [
                    94.0943452,
                    54.9432168
                ],
                [
                    94.0969508,
                    54.9422333
                ],
                [
                    94.0951641,
                    54.9402234
                ],
                [
                    94.0909951,
                    54.9385983
                ],
                [
                    94.0876449,
                    54.9393681
                ],
                [
                    94.0855604,
                    54.9415491
                ],
                [
                    94.084667,
                    54.9425754
                ]
            ],
            "longitude": 94.088354,
            "latitude": 54.9415856
        },
        "6902": {
            "name": "Казыр",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0906266,
            "latitude": 53.7031519
        },
        "6903": {
            "name": "Керамический",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.1075177,
            "latitude": 55.9567363
        },
        "6904": {
            "name": "Новомихайловка",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.1076813,
            "latitude": 55.7790301
        },
        "6905": {
            "name": "Балайский Косогор",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.110881,
            "latitude": 55.8311321
        },
        "6906": {
            "name": "Марьевка",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.1455344,
            "latitude": 55.853177
        },
        "6907": {
            "name": "Семеновка",
            "population": 232,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.1681763,
            "latitude": 55.70149
        },
        "6908": {
            "name": "Каменно-Горновка",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.1856069,
            "latitude": 55.8851621
        },
        "6909": {
            "name": "Слюдрудник",
            "population": 150,
            "type": "hamlet",
            "poly": [
                [
                    94.1816274,
                    57.9899496
                ],
                [
                    94.1826574,
                    57.990905
                ],
                [
                    94.1843311,
                    57.9911098
                ],
                [
                    94.1859469,
                    57.9915317
                ],
                [
                    94.1878073,
                    57.9914737
                ],
                [
                    94.1897814,
                    57.990814
                ],
                [
                    94.1926138,
                    57.9899951
                ],
                [
                    94.1954033,
                    57.9891534
                ],
                [
                    94.1968474,
                    57.9886427
                ],
                [
                    94.1989652,
                    57.988471
                ],
                [
                    94.2022697,
                    57.9884937
                ],
                [
                    94.2050163,
                    57.9878795
                ],
                [
                    94.2062887,
                    57.9875508
                ],
                [
                    94.2066471,
                    57.9871288
                ],
                [
                    94.2041151,
                    57.9864918
                ],
                [
                    94.2010252,
                    57.985741
                ],
                [
                    94.1989652,
                    57.9851267
                ],
                [
                    94.1919271,
                    57.9830563
                ],
                [
                    94.1904651,
                    57.9829505
                ],
                [
                    94.1874639,
                    57.9858547
                ],
                [
                    94.183902,
                    57.9883572
                ],
                [
                    94.1819279,
                    57.9895857
                ],
                [
                    94.1816274,
                    57.9899496
                ]
            ],
            "longitude": 94.1887086,
            "latitude": 57.9888346
        },
        "6910": {
            "name": "Асафьевка",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.1973494,
            "latitude": 55.3894254
        },
        "6911": {
            "name": "Чистяки",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.20777,
            "latitude": 57.9160567
        },
        "6912": {
            "name": "Кутурчин",
            "population": 27,
            "type": "hamlet",
            "poly": [
                [
                    94.2100471,
                    54.934411
                ],
                [
                    94.2124687,
                    54.9371328
                ],
                [
                    94.2128898,
                    54.9394311
                ],
                [
                    94.2160484,
                    54.9402778
                ],
                [
                    94.2207861,
                    54.9391287
                ],
                [
                    94.2207861,
                    54.9369513
                ],
                [
                    94.2198386,
                    54.9327173
                ],
                [
                    94.2164695,
                    54.9312655
                ],
                [
                    94.2119423,
                    54.9330197
                ],
                [
                    94.2100471,
                    54.934411
                ]
            ],
            "longitude": 94.2159827,
            "latitude": 54.9368562
        },
        "6913": {
            "name": "Аргаза",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.2285632,
            "latitude": 55.2729904
        },
        "6914": {
            "name": "Ялай",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.2417192,
            "latitude": 57.1418093
        },
        "6915": {
            "name": "Летовье",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.2499999,
            "latitude": 71.333333
        },
        "6916": {
            "name": "Никольск",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.25242,
            "latitude": 57.8826884
        },
        "6917": {
            "name": "имени Кравченко",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.2717821,
            "latitude": 55.3051158
        },
        "6918": {
            "name": "Ной",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.2885322,
            "latitude": 55.5442978
        },
        "6919": {
            "name": "Вайвида",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.3266698,
            "latitude": 60.8292554
        },
        "6920": {
            "name": "Новопокровка",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.3331518,
            "latitude": 55.3861884
        },
        "6921": {
            "name": "Лукашино",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.369676,
            "latitude": 57.1282084
        },
        "6922": {
            "name": "Новониколаевка",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.371738,
            "latitude": 55.627713
        },
        "6923": {
            "name": "Николаевка",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.3859063,
            "latitude": 55.7127857
        },
        "6924": {
            "name": "Крестьянское",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.3902356,
            "latitude": 55.4602477
        },
        "6925": {
            "name": "Корсаково",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.3926114,
            "latitude": 57.0830668
        },
        "6926": {
            "name": "Бугарихта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.4,
            "latitude": 59.733333
        },
        "6927": {
            "name": "Алдарак",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.4199302,
            "latitude": 55.2518177
        },
        "6928": {
            "name": "Конок",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.4466968,
            "latitude": 55.3185469
        },
        "6929": {
            "name": "Кузьминка",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.4479884,
            "latitude": 55.7153104
        },
        "6930": {
            "name": "Верх-Канарай",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.464039,
            "latitude": 56.9849557
        },
        "6931": {
            "name": "Конок",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    94.4884318,
                    55.4506999
                ],
                [
                    94.4901305,
                    55.4519188
                ],
                [
                    94.4911465,
                    55.4526478
                ],
                [
                    94.4918782,
                    55.4526413
                ],
                [
                    94.4920835,
                    55.4524983
                ],
                [
                    94.4941449,
                    55.4513757
                ],
                [
                    94.4947662,
                    55.4505121
                ],
                [
                    94.4942149,
                    55.4496237
                ],
                [
                    94.4933979,
                    55.4495095
                ],
                [
                    94.491608,
                    55.450197
                ],
                [
                    94.4908095,
                    55.450374
                ],
                [
                    94.490065,
                    55.450539
                ],
                [
                    94.489953,
                    55.450559
                ],
                [
                    94.4889869,
                    55.4504782
                ],
                [
                    94.4884318,
                    55.4506999
                ]
            ],
            "longitude": 94.492009,
            "latitude": 55.4510664
        },
        "6932": {
            "name": "Ивашиха",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.4935811,
            "latitude": 55.1859626
        },
        "6933": {
            "name": "Вахрушево",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5051885,
            "latitude": 57.2255096
        },
        "6934": {
            "name": "Искра",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    94.5004271,
                    56.0727116
                ],
                [
                    94.5004538,
                    56.0732484
                ],
                [
                    94.5007115,
                    56.0732633
                ],
                [
                    94.5007293,
                    56.0740834
                ],
                [
                    94.5025421,
                    56.0739243
                ],
                [
                    94.504959,
                    56.0734422
                ],
                [
                    94.5074012,
                    56.0734077
                ],
                [
                    94.5082648,
                    56.0732186
                ],
                [
                    94.5092449,
                    56.0728524
                ],
                [
                    94.5111595,
                    56.0725748
                ],
                [
                    94.5111832,
                    56.072112
                ],
                [
                    94.5117268,
                    56.0716096
                ],
                [
                    94.5120814,
                    56.0704991
                ],
                [
                    94.5122724,
                    56.0701122
                ],
                [
                    94.5114638,
                    56.0699283
                ],
                [
                    94.5111528,
                    56.0696499
                ],
                [
                    94.5103974,
                    56.0694461
                ],
                [
                    94.5101308,
                    56.0692721
                ],
                [
                    94.5088779,
                    56.0689093
                ],
                [
                    94.5081137,
                    56.0688248
                ],
                [
                    94.5067008,
                    56.06878
                ],
                [
                    94.5060788,
                    56.06879
                ],
                [
                    94.5056078,
                    56.0688496
                ],
                [
                    94.5047991,
                    56.0688795
                ],
                [
                    94.504657,
                    56.0691479
                ],
                [
                    94.503955,
                    56.0690336
                ],
                [
                    94.5032085,
                    56.0689789
                ],
                [
                    94.5019561,
                    56.068966
                ],
                [
                    94.5013935,
                    56.0689393
                ],
                [
                    94.5008309,
                    56.068966
                ],
                [
                    94.5007832,
                    56.0700434
                ],
                [
                    94.501609,
                    56.0703607
                ],
                [
                    94.5008092,
                    56.0724134
                ],
                [
                    94.5004271,
                    56.0727116
                ]
            ],
            "longitude": 94.5072766,
            "latitude": 56.0711686
        },
        "6935": {
            "name": "Новая Прилука",
            "population": 51,
            "type": "hamlet",
            "poly": [
                [
                    94.4920604,
                    56.0124794
                ],
                [
                    94.4948629,
                    56.0140185
                ],
                [
                    94.49794,
                    56.012972
                ],
                [
                    94.5033253,
                    56.0146957
                ],
                [
                    94.5104139,
                    56.0151267
                ],
                [
                    94.515744,
                    56.0144187
                ],
                [
                    94.5158539,
                    56.0099244
                ],
                [
                    94.5119525,
                    56.0071845
                ],
                [
                    94.5090401,
                    56.0061685
                ],
                [
                    94.5035451,
                    56.0061069
                ],
                [
                    94.498105,
                    56.0072153
                ],
                [
                    94.4977753,
                    56.0092163
                ],
                [
                    94.4923901,
                    56.0112789
                ],
                [
                    94.4920604,
                    56.0124794
                ]
            ],
            "longitude": 94.5100403,
            "latitude": 56.0095766
        },
        "6936": {
            "name": "Новоалександровка",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5134928,
            "latitude": 55.8639618
        },
        "6937": {
            "name": "Новая Печера",
            "population": 199,
            "type": "hamlet",
            "poly": [
                [
                    [
                        94.5106128,
                        56.0481458
                    ],
                    [
                        94.5107518,
                        56.0486904
                    ],
                    [
                        94.5115395,
                        56.0496758
                    ],
                    [
                        94.5131612,
                        56.0505316
                    ],
                    [
                        94.5270625,
                        56.0557436
                    ],
                    [
                        94.5288233,
                        56.0561843
                    ],
                    [
                        94.5320206,
                        56.0557954
                    ],
                    [
                        94.5342911,
                        56.0546286
                    ],
                    [
                        94.5301208,
                        56.0529432
                    ],
                    [
                        94.5306768,
                        56.0521912
                    ],
                    [
                        94.528916,
                        56.0514133
                    ],
                    [
                        94.5290087,
                        56.0508428
                    ],
                    [
                        94.5232629,
                        56.0486385
                    ],
                    [
                        94.520946,
                        56.0481198
                    ],
                    [
                        94.5192315,
                        56.0478346
                    ],
                    [
                        94.5164975,
                        56.0477568
                    ],
                    [
                        94.5148295,
                        56.0473159
                    ],
                    [
                        94.5123736,
                        56.0473418
                    ],
                    [
                        94.5106128,
                        56.0481458
                    ]
                ],
                [
                    [
                        94.5104245,
                        56.0436537
                    ],
                    [
                        94.5114193,
                        56.0439984
                    ],
                    [
                        94.5128876,
                        56.0447408
                    ],
                    [
                        94.5127456,
                        56.0454301
                    ],
                    [
                        94.5137905,
                        56.0454325
                    ],
                    [
                        94.5138261,
                        56.0456717
                    ],
                    [
                        94.5159987,
                        56.0458412
                    ],
                    [
                        94.5172452,
                        56.0457714
                    ],
                    [
                        94.5192931,
                        56.0460405
                    ],
                    [
                        94.5213665,
                        56.0461195
                    ],
                    [
                        94.5226456,
                        56.0459074
                    ],
                    [
                        94.5228369,
                        56.0451833
                    ],
                    [
                        94.5242088,
                        56.045218
                    ],
                    [
                        94.5249192,
                        56.0451385
                    ],
                    [
                        94.5249916,
                        56.0440371
                    ],
                    [
                        94.5220787,
                        56.0435583
                    ],
                    [
                        94.5168,
                        56.0429706
                    ],
                    [
                        94.5108035,
                        56.0426197
                    ],
                    [
                        94.5104245,
                        56.0436537
                    ]
                ]
            ],
            "longitude": 94.5220143,
            "latitude": 56.0509381
        },
        "6938": {
            "name": "Струково",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5252755,
            "latitude": 56.9896887
        },
        "6939": {
            "name": "Данилки",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5339839,
            "latitude": 57.3009739
        },
        "6940": {
            "name": "Воронино",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5451522,
            "latitude": 55.6703674
        },
        "6941": {
            "name": "Покровка",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5488377,
            "latitude": 55.7227226
        },
        "6942": {
            "name": "Новомихайловка",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5589143,
            "latitude": 55.2852876
        },
        "6943": {
            "name": "Новосёлово",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5690076,
            "latitude": 55.4879156
        },
        "6944": {
            "name": "Батов",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5902188,
            "latitude": 56.8347421
        },
        "6945": {
            "name": "Татьяновка",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5993006,
            "latitude": 55.8095121
        },
        "6946": {
            "name": "Устье",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6170064,
            "latitude": 57.7760851
        },
        "6947": {
            "name": "Пашино",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6198993,
            "latitude": 58.1344588
        },
        "6948": {
            "name": "Калиновка",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6274175,
            "latitude": 55.5300672
        },
        "6949": {
            "name": "Орловка",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6335105,
            "latitude": 55.2305096
        },
        "6950": {
            "name": "Бартанас",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6611732,
            "latitude": 57.2575
        },
        "6951": {
            "name": "Власть Труда",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6703014,
            "latitude": 55.8805572
        },
        "6952": {
            "name": "Карлык",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6713634,
            "latitude": 55.1311103
        },
        "6953": {
            "name": "Шудрово",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6747799,
            "latitude": 55.3311178
        },
        "6954": {
            "name": "Авдинка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6769783,
            "latitude": 55.7562213
        },
        "6955": {
            "name": "Верхний Агашул",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    94.6741752,
                    55.4576381
                ],
                [
                    94.6819,
                    55.4549126
                ],
                [
                    94.6933584,
                    55.4513059
                ],
                [
                    94.6963195,
                    55.4495585
                ],
                [
                    94.6906547,
                    55.4468324
                ],
                [
                    94.6836166,
                    55.4474166
                ],
                [
                    94.6767502,
                    55.4514082
                ],
                [
                    94.6741752,
                    55.4576381
                ]
            ],
            "longitude": 94.6848458,
            "latitude": 55.4503455
        },
        "6956": {
            "name": "Колома",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.716667,
            "latitude": 70.25
        },
        "6957": {
            "name": "Среднее",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7216811,
            "latitude": 57.6048614
        },
        "6958": {
            "name": "Точильное",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7225007,
            "latitude": 55.8692262
        },
        "6959": {
            "name": "Зеленино",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7329685,
            "latitude": 55.1777531
        },
        "6960": {
            "name": "Снегиревка",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7351561,
            "latitude": 55.5962032
        },
        "6961": {
            "name": "Караульное",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7365846,
            "latitude": 57.0802179
        },
        "6962": {
            "name": "Канарай",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7373215,
            "latitude": 56.9507318
        },
        "6963": {
            "name": "Алексеевка",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7509282,
            "latitude": 55.1190177
        },
        "6964": {
            "name": "Глубоково",
            "population": 206,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7602573,
            "latitude": 55.8586778
        },
        "6965": {
            "name": "Решающий",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7688765,
            "latitude": 58.1982127
        },
        "6966": {
            "name": "Лужки",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7696,
            "latitude": 57.309465
        },
        "6967": {
            "name": "Совхозный",
            "population": 123,
            "type": "hamlet",
            "poly": [
                [
                    94.7644597,
                    55.5022192
                ],
                [
                    94.76629,
                    55.5038683
                ],
                [
                    94.7672921,
                    55.5055247
                ],
                [
                    94.7698091,
                    55.5062016
                ],
                [
                    94.7711116,
                    55.5054518
                ],
                [
                    94.7733282,
                    55.5062988
                ],
                [
                    94.7748302,
                    55.5049378
                ],
                [
                    94.7738582,
                    55.5037748
                ],
                [
                    94.776976,
                    55.5026531
                ],
                [
                    94.7745448,
                    55.5000316
                ],
                [
                    94.7680646,
                    55.5015143
                ],
                [
                    94.7671205,
                    55.5015143
                ],
                [
                    94.7644597,
                    55.5022192
                ]
            ],
            "longitude": 94.7714081,
            "latitude": 55.5028335
        },
        "6968": {
            "name": "Кировский",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.772586,
            "latitude": 58.9118409
        },
        "6969": {
            "name": "Бурмакино",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7815851,
            "latitude": 57.0118448
        },
        "6970": {
            "name": "Папиково",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7820894,
            "latitude": 55.3777823
        },
        "6971": {
            "name": "Новый",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.785576,
            "latitude": 56.7314167
        },
        "6972": {
            "name": "Большая Степь",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7910913,
            "latitude": 56.8832944
        },
        "6973": {
            "name": "Новобородинка",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7944752,
            "latitude": 57.0579727
        },
        "6974": {
            "name": "Мурма",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.7992104,
            "latitude": 57.2835572
        },
        "6975": {
            "name": "Буровой",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8112305,
            "latitude": 57.2791135
        },
        "6976": {
            "name": "Благодатка",
            "population": 162,
            "type": "hamlet",
            "poly": [
                [
                    94.8161298,
                    55.494246
                ],
                [
                    94.8174602,
                    55.4944162
                ],
                [
                    94.8192197,
                    55.4951698
                ],
                [
                    94.8220521,
                    55.4955588
                ],
                [
                    94.8233396,
                    55.4960936
                ],
                [
                    94.8250991,
                    55.4976494
                ],
                [
                    94.8269874,
                    55.4985002
                ],
                [
                    94.8282319,
                    55.5002747
                ],
                [
                    94.8303348,
                    55.5010525
                ],
                [
                    94.831708,
                    55.4999101
                ],
                [
                    94.8294335,
                    55.498646
                ],
                [
                    94.8305772,
                    55.4964303
                ],
                [
                    94.8254424,
                    55.4932735
                ],
                [
                    94.8269015,
                    55.4920822
                ],
                [
                    94.8335384,
                    55.4873374
                ],
                [
                    94.8287319,
                    55.4857812
                ],
                [
                    94.8240112,
                    55.4898904
                ],
                [
                    94.8193484,
                    55.4920822
                ],
                [
                    94.816516,
                    55.4932735
                ],
                [
                    94.8161298,
                    55.494246
                ]
            ],
            "longitude": 94.8259704,
            "latitude": 55.4907797
        },
        "6977": {
            "name": "Абалаково",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8314962,
            "latitude": 55.066632
        },
        "6978": {
            "name": "Калиновка",
            "population": 72,
            "type": "hamlet",
            "poly": [
                [
                    94.8346786,
                    55.5321259
                ],
                [
                    94.8367386,
                    55.5344575
                ],
                [
                    94.8449783,
                    55.5370803
                ],
                [
                    94.8518448,
                    55.5369832
                ],
                [
                    94.8581962,
                    55.5344575
                ],
                [
                    94.8612861,
                    55.5324174
                ],
                [
                    94.8600635,
                    55.5305651
                ],
                [
                    94.8544197,
                    55.5297943
                ],
                [
                    94.8556213,
                    55.5266851
                ],
                [
                    94.8502998,
                    55.5257135
                ],
                [
                    94.8460083,
                    55.5266851
                ],
                [
                    94.8403434,
                    55.526005
                ],
                [
                    94.8346786,
                    55.5321259
                ]
            ],
            "longitude": 94.8493591,
            "latitude": 55.5334734
        },
        "6979": {
            "name": "Пайтурма",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8516784,
            "latitude": 71.6196753
        },
        "6980": {
            "name": "Петропавловка",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8607694,
            "latitude": 55.180044
        },
        "6981": {
            "name": "Вятка",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8688614,
            "latitude": 55.3473477
        },
        "6982": {
            "name": "Чуриново",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8739189,
            "latitude": 55.6550895
        },
        "6983": {
            "name": "Павловка",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8778716,
            "latitude": 55.2429779
        },
        "6984": {
            "name": "Гмирянка",
            "population": 261,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8792647,
            "latitude": 56.0057522
        },
        "6985": {
            "name": "Тембенчи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.883333,
            "latitude": 66.9
        },
        "6986": {
            "name": "Глинная",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.884105,
            "latitude": 57.2646487
        },
        "6987": {
            "name": "Михалевка",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8957914,
            "latitude": 55.9526839
        },
        "6988": {
            "name": "Усть-Казачка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    94.892443,
                    56.1605162
                ],
                [
                    94.8970659,
                    56.1612289
                ],
                [
                    94.8980458,
                    56.1614687
                ],
                [
                    94.8987287,
                    56.1612372
                ],
                [
                    94.9011339,
                    56.1612206
                ],
                [
                    94.9023957,
                    56.1618407
                ],
                [
                    94.9032272,
                    56.1623533
                ],
                [
                    94.9038646,
                    56.1626946
                ],
                [
                    94.904179,
                    56.1626168
                ],
                [
                    94.9057508,
                    56.1614692
                ],
                [
                    94.904668,
                    56.1606912
                ],
                [
                    94.904668,
                    56.1602828
                ],
                [
                    94.9036201,
                    56.159602
                ],
                [
                    94.902223,
                    56.1599715
                ],
                [
                    94.8993938,
                    56.1601855
                ],
                [
                    94.8936655,
                    56.1590379
                ],
                [
                    94.892443,
                    56.1605162
                ]
            ],
            "longitude": 94.8972212,
            "latitude": 56.160597
        },
        "6989": {
            "name": "Макарово",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.8985716,
            "latitude": 56.8174131
        },
        "6990": {
            "name": "Льнозавода",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9060533,
            "latitude": 55.2802699
        },
        "6991": {
            "name": "Лозовая",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9111523,
            "latitude": 55.7784069
        },
        "6992": {
            "name": "Черемшанка",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9454609,
            "latitude": 56.1330532
        },
        "6993": {
            "name": "Соловьёвка",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.946701,
            "latitude": 55.7068401
        },
        "6994": {
            "name": "Унерчик",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9543239,
            "latitude": 55.5812393
        },
        "6995": {
            "name": "Солонечное",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9582725,
            "latitude": 55.8299876
        },
        "6996": {
            "name": "Борки",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9596678,
            "latitude": 56.9700347
        },
        "6997": {
            "name": "Залесный",
            "population": 154,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9649269,
            "latitude": 56.4999808
        },
        "6998": {
            "name": "Курыш",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9717381,
            "latitude": 56.6100816
        },
        "6999": {
            "name": "Воскресенка",
            "population": 173,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9746731,
            "latitude": 55.9456693
        },
        "7000": {
            "name": "Усть-Намакан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.976735,
            "latitude": 70.6147648
        },
        "7001": {
            "name": "Цапка-Лайда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.983333,
            "latitude": 70.416667
        },
        "7002": {
            "name": "Бакчет",
            "population": 243,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9899172,
            "latitude": 57.0566245
        },
        "7003": {
            "name": "Камень",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95,
            "latitude": 70.666667
        },
        "7004": {
            "name": "Балаган",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0018854,
            "latitude": 70.5331774
        },
        "7005": {
            "name": "Кондратьево",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0086058,
            "latitude": 56.8491873
        },
        "7006": {
            "name": "Низинка",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0234424,
            "latitude": 55.8090762
        },
        "7007": {
            "name": "Тульское",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.029851,
            "latitude": 55.8327568
        },
        "7008": {
            "name": "Комарово",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0348759,
            "latitude": 56.1880221
        },
        "7009": {
            "name": "Загорский",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0435882,
            "latitude": 56.1092165
        },
        "7010": {
            "name": "Щекатурово",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0451422,
            "latitude": 57.1876285
        },
        "7011": {
            "name": "Междуречка",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0553796,
            "latitude": 55.2784426
        },
        "7012": {
            "name": "Чурюково",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0571136,
            "latitude": 56.6298911
        },
        "7013": {
            "name": "Ивановка",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0579662,
            "latitude": 56.0498322
        },
        "7014": {
            "name": "Вознесенка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.058016,
            "latitude": 56.656907
        },
        "7015": {
            "name": "Алешино",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0595073,
            "latitude": 56.2588738
        },
        "7016": {
            "name": "Скакальная",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0599002,
            "latitude": 57.1385862
        },
        "7017": {
            "name": "Алега",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0907423,
            "latitude": 56.4225179
        },
        "7018": {
            "name": "Любава",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0969264,
            "latitude": 56.3815561
        },
        "7019": {
            "name": "Спасовка",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0981176,
            "latitude": 56.0497127
        },
        "7020": {
            "name": "Колон",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1078032,
            "latitude": 57.017268
        },
        "7021": {
            "name": "Верховая",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1109842,
            "latitude": 55.8945276
        },
        "7022": {
            "name": "Кан-Оклер",
            "population": 90,
            "type": "hamlet",
            "poly": [
                [
                    95.1059528,
                    55.0324179
                ],
                [
                    95.1138751,
                    55.0425678
                ],
                [
                    95.1186627,
                    55.0455611
                ],
                [
                    95.1214612,
                    55.0447008
                ],
                [
                    95.1213028,
                    55.0407002
                ],
                [
                    95.1211448,
                    55.0402524
                ],
                [
                    95.1168661,
                    55.0378612
                ],
                [
                    95.1127208,
                    55.0350138
                ],
                [
                    95.1095578,
                    55.0325818
                ],
                [
                    95.1085752,
                    55.0311545
                ],
                [
                    95.1059528,
                    55.0324179
                ]
            ],
            "longitude": 95.114989,
            "latitude": 55.04016
        },
        "7023": {
            "name": "Топол",
            "population": 222,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1197416,
            "latitude": 56.9424053
        },
        "7024": {
            "name": "Ивантай",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.131984,
            "latitude": 56.5262272
        },
        "7025": {
            "name": "Кан",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1335016,
            "latitude": 55.1600242
        },
        "7026": {
            "name": "Усть-Анжа",
            "population": 120,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1347522,
            "latitude": 55.3429547
        },
        "7027": {
            "name": "Рябинки",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1500661,
            "latitude": 56.0095262
        },
        "7028": {
            "name": "Михайловка",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1534028,
            "latitude": 55.7005822
        },
        "7029": {
            "name": "Михайловка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1586351,
            "latitude": 56.5725986
        },
        "7030": {
            "name": "Лощинка",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1611395,
            "latitude": 55.7616062
        },
        "7031": {
            "name": "Орешники",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.163182,
            "latitude": 56.0603942
        },
        "7032": {
            "name": "Чарга",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1693033,
            "latitude": 55.3834227
        },
        "7033": {
            "name": "Бурный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1829426,
            "latitude": 57.7597435
        },
        "7034": {
            "name": "Шамы",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1921819,
            "latitude": 55.1488717
        },
        "7035": {
            "name": "Петрушки",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.230045,
            "latitude": 56.1299814
        },
        "7036": {
            "name": "Каменка",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.2404494,
            "latitude": 55.8414965
        },
        "7037": {
            "name": "Северо-Александровка",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.2512401,
            "latitude": 56.5285615
        },
        "7038": {
            "name": "Капитоново",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.2713445,
            "latitude": 55.132414
        },
        "7039": {
            "name": "Старая Солянка",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.2772242,
            "latitude": 56.0408495
        },
        "7040": {
            "name": "Сухо-Ерша",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.306116,
            "latitude": 56.5822034
        },
        "7041": {
            "name": "Овражная",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3071629,
            "latitude": 56.0213
        },
        "7042": {
            "name": "Кедровка",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3106212,
            "latitude": 56.8594556
        },
        "7043": {
            "name": "Мокрый Ельник",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3126192,
            "latitude": 56.7172329
        },
        "7044": {
            "name": "Новотроицк",
            "population": 103,
            "type": "hamlet",
            "poly": [
                [
                    95.3180685,
                    55.4586155
                ],
                [
                    95.3237333,
                    55.461438
                ],
                [
                    95.3281965,
                    55.461438
                ],
                [
                    95.3281965,
                    55.4594915
                ],
                [
                    95.334548,
                    55.4561821
                ],
                [
                    95.3290548,
                    55.4538459
                ],
                [
                    95.3253899,
                    55.4556516
                ],
                [
                    95.3218451,
                    55.4566688
                ],
                [
                    95.3180685,
                    55.4586155
                ]
            ],
            "longitude": 95.3267337,
            "latitude": 55.4577742
        },
        "7045": {
            "name": "Михайловка",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3294571,
            "latitude": 56.1984964
        },
        "7046": {
            "name": "Харьковка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3382381,
            "latitude": 56.9512876
        },
        "7047": {
            "name": "Чемурай",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.342222,
            "latitude": 56.9065077
        },
        "7048": {
            "name": "Преображенка",
            "population": 264,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3431017,
            "latitude": 55.8003081
        },
        "7049": {
            "name": "Латынцево",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3567502,
            "latitude": 55.7261067
        },
        "7050": {
            "name": "Завировка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3576396,
            "latitude": 55.9702583
        },
        "7051": {
            "name": "Козыла",
            "population": 212,
            "type": "hamlet",
            "poly": [
                [
                    95.365447,
                    55.5759206
                ],
                [
                    95.3656187,
                    55.5774733
                ],
                [
                    95.3714552,
                    55.5800932
                ],
                [
                    95.3754034,
                    55.579511
                ],
                [
                    95.3754034,
                    55.5785407
                ],
                [
                    95.3767766,
                    55.5770851
                ],
                [
                    95.37815,
                    55.5764058
                ],
                [
                    95.3762617,
                    55.5752413
                ],
                [
                    95.3716269,
                    55.5764058
                ],
                [
                    95.3692236,
                    55.5758236
                ],
                [
                    95.365447,
                    55.5759206
                ]
            ],
            "longitude": 95.3721875,
            "latitude": 55.5777438
        },
        "7052": {
            "name": "Николаевка",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3738834,
            "latitude": 56.6199934
        },
        "7053": {
            "name": "Ракитовка",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.377351,
            "latitude": 55.8197708
        },
        "7054": {
            "name": "Малый Ирбей",
            "population": 178,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3774288,
            "latitude": 55.6378353
        },
        "7055": {
            "name": "Сергеевка",
            "population": 30,
            "type": "hamlet",
            "poly": [
                [
                    95.3767766,
                    55.4810928
                ],
                [
                    95.3775749,
                    55.4830918
                ],
                [
                    95.3818665,
                    55.4846481
                ],
                [
                    95.3870764,
                    55.4841083
                ],
                [
                    95.3901663,
                    55.4835247
                ],
                [
                    95.3881063,
                    55.4815792
                ],
                [
                    95.3879347,
                    55.4789527
                ],
                [
                    95.388793,
                    55.4769097
                ],
                [
                    95.3826132,
                    55.4759368
                ],
                [
                    95.3796949,
                    55.4767151
                ],
                [
                    95.3790083,
                    55.4792445
                ],
                [
                    95.3767766,
                    55.4810928
                ]
            ],
            "longitude": 95.3836563,
            "latitude": 55.4804774
        },
        "7056": {
            "name": "Ивановка",
            "population": 248,
            "type": "hamlet",
            "poly": [
                [
                    95.3702499,
                    56.547748
                ],
                [
                    95.372653,
                    56.5484104
                ],
                [
                    95.3963424,
                    56.5460447
                ],
                [
                    95.4003249,
                    56.5422545
                ],
                [
                    95.3869354,
                    56.5438634
                ],
                [
                    95.386901,
                    56.5398932
                ],
                [
                    95.3814422,
                    56.5401724
                ],
                [
                    95.3805839,
                    56.5443366
                ],
                [
                    95.3766357,
                    56.544999
                ],
                [
                    95.3709365,
                    56.5460447
                ],
                [
                    95.3702499,
                    56.547748
                ]
            ],
            "longitude": 95.3850101,
            "latitude": 56.5455659
        },
        "7057": {
            "name": "Белоярск",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4103377,
            "latitude": 56.2567112
        },
        "7058": {
            "name": "Семеновка",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4141767,
            "latitude": 56.8390495
        },
        "7059": {
            "name": "Круглово",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4179085,
            "latitude": 56.3352706
        },
        "7060": {
            "name": "Леонтьевка",
            "population": 251,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4245722,
            "latitude": 56.4541419
        },
        "7061": {
            "name": "Альгинка",
            "population": 197,
            "type": "hamlet",
            "poly": [
                [
                    95.4236403,
                    55.498696
                ],
                [
                    95.428275,
                    55.5007378
                ],
                [
                    95.43188,
                    55.5006406
                ],
                [
                    95.4339399,
                    55.498696
                ],
                [
                    95.4337683,
                    55.4971402
                ],
                [
                    95.4317083,
                    55.4961679
                ],
                [
                    95.4291334,
                    55.4955844
                ],
                [
                    95.4262152,
                    55.4955844
                ],
                [
                    95.4243269,
                    55.4963623
                ],
                [
                    95.4236403,
                    55.498696
                ]
            ],
            "longitude": 95.4291383,
            "latitude": 55.4978937
        },
        "7062": {
            "name": "Малая Уря",
            "population": 232,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4308088,
            "latitude": 56.1164278
        },
        "7063": {
            "name": "Верхний Танай",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4325597,
            "latitude": 56.7221812
        },
        "7064": {
            "name": "Новоалександровка",
            "population": 56,
            "type": "hamlet",
            "poly": [
                [
                    95.4452696,
                    55.4747693
                ],
                [
                    95.4476728,
                    55.4781744
                ],
                [
                    95.4471578,
                    55.4795364
                ],
                [
                    95.4502478,
                    55.4808983
                ],
                [
                    95.4528227,
                    55.482552
                ],
                [
                    95.4572859,
                    55.4827465
                ],
                [
                    95.4548225,
                    55.4787144
                ],
                [
                    95.4527626,
                    55.4761849
                ],
                [
                    95.452076,
                    55.4740445
                ],
                [
                    95.4507627,
                    55.4736991
                ],
                [
                    95.4488745,
                    55.4726289
                ],
                [
                    95.4452696,
                    55.4747693
                ]
            ],
            "longitude": 95.4501416,
            "latitude": 55.4785036
        },
        "7065": {
            "name": "Крутая Горка",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4778082,
            "latitude": 56.1648049
        },
        "7066": {
            "name": "Петровка",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4880511,
            "latitude": 56.5943839
        },
        "7067": {
            "name": "Буинка",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4927718,
            "latitude": 55.3054967
        },
        "7068": {
            "name": "Таловая",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4931451,
            "latitude": 56.8060855
        },
        "7069": {
            "name": "Усть-Кайтым",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.4982134,
            "latitude": 57.3945956
        },
        "7070": {
            "name": "Кочиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5,
            "latitude": 70.566667
        },
        "7071": {
            "name": "Польное",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5006277,
            "latitude": 56.211266
        },
        "7072": {
            "name": "Чисково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5058659,
            "latitude": 64.0508709
        },
        "7073": {
            "name": "Зелёная Дубрава",
            "population": 154,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.530756,
            "latitude": 55.9136157
        },
        "7074": {
            "name": "Нижнеистокино",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    95.5235399,
                    55.5717494
                ],
                [
                    95.5240549,
                    55.5734963
                ],
                [
                    95.530578,
                    55.5751461
                ],
                [
                    95.5355562,
                    55.5766987
                ],
                [
                    95.5431093,
                    55.5767958
                ],
                [
                    95.5482591,
                    55.5760195
                ],
                [
                    95.5468858,
                    55.5718464
                ],
                [
                    95.5436243,
                    55.5689347
                ],
                [
                    95.532123,
                    55.5683524
                ],
                [
                    95.5269731,
                    55.569323
                ],
                [
                    95.5235399,
                    55.5717494
                ]
            ],
            "longitude": 95.5399124,
            "latitude": 55.5729892
        },
        "7075": {
            "name": "Ашпатск",
            "population": 264,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5428327,
            "latitude": 56.6847783
        },
        "7076": {
            "name": "Берёзовка",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5431059,
            "latitude": 55.445825
        },
        "7077": {
            "name": "Манкур",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.55,
            "latitude": 62.816667
        },
        "7078": {
            "name": "Архангельское",
            "population": 267,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5524587,
            "latitude": 56.5424566
        },
        "7079": {
            "name": "Плитная",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5569508,
            "latitude": 56.7452762
        },
        "7080": {
            "name": "Асанск",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5631284,
            "latitude": 57.0406931
        },
        "7081": {
            "name": "Подояйск",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5662438,
            "latitude": 56.2437251
        },
        "7082": {
            "name": "Краснополянск",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.567056,
            "latitude": 56.1787936
        },
        "7083": {
            "name": "Дорожный",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.572778,
            "latitude": 56.0498108
        },
        "7084": {
            "name": "Левобережное",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5840037,
            "latitude": 56.235908
        },
        "7085": {
            "name": "Зелёная Слобода",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5946466,
            "latitude": 55.444456
        },
        "7086": {
            "name": "Малые Пруды",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5948408,
            "latitude": 56.1050525
        },
        "7087": {
            "name": "Коростелево",
            "population": 225,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.6119751,
            "latitude": 55.6724377
        },
        "7088": {
            "name": "Орловка",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.6189142,
            "latitude": 55.8657253
        },
        "7089": {
            "name": "Карьерный",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.6403265,
            "latitude": 56.2473942
        },
        "7090": {
            "name": "Хомутово",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.6715837,
            "latitude": 55.7218462
        },
        "7091": {
            "name": "Рождественка",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.6728579,
            "latitude": 55.3638088
        },
        "7092": {
            "name": "Тагаши",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.6827307,
            "latitude": 56.5155165
        },
        "7093": {
            "name": "Быстровка",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.6976627,
            "latitude": 56.9769577
        },
        "7094": {
            "name": "Ношино",
            "population": 270,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.721275,
            "latitude": 56.607788
        },
        "7095": {
            "name": "Васильевка",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.7274849,
            "latitude": 55.4875453
        },
        "7096": {
            "name": "Прилуки",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.7291657,
            "latitude": 57.7514304
        },
        "7097": {
            "name": "Курыш-Поповичи",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.7584217,
            "latitude": 56.3430716
        },
        "7098": {
            "name": "Богачево",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.7751042,
            "latitude": 55.3804906
        },
        "7099": {
            "name": "Мачино",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.7766947,
            "latitude": 56.5626705
        },
        "7100": {
            "name": "Гремучая Падь",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.7803034,
            "latitude": 56.4408079
        },
        "7101": {
            "name": "Подъянда",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.7939647,
            "latitude": 55.7971138
        },
        "7102": {
            "name": "Малкас",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8134826,
            "latitude": 56.9208045
        },
        "7103": {
            "name": "Стрелка",
            "population": 188,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8150645,
            "latitude": 55.5468534
        },
        "7104": {
            "name": "Матвеевка",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8181194,
            "latitude": 56.7885472
        },
        "7105": {
            "name": "Луговая",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8223224,
            "latitude": 57.3761965
        },
        "7106": {
            "name": "Восток",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8229173,
            "latitude": 56.9515545
        },
        "7107": {
            "name": "Агул",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8327678,
            "latitude": 55.7531052
        },
        "7108": {
            "name": "Ловать",
            "population": 163,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8379075,
            "latitude": 56.2442053
        },
        "7109": {
            "name": "Троицк",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8404723,
            "latitude": 56.7433233
        },
        "7110": {
            "name": "Каменка",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8522063,
            "latitude": 58.5512596
        },
        "7111": {
            "name": "Ильино-Посадское",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8569528,
            "latitude": 55.4568117
        },
        "7112": {
            "name": "Средние Мангареки",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8668202,
            "latitude": 56.7330443
        },
        "7113": {
            "name": "Кунгул",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8747923,
            "latitude": 56.8183356
        },
        "7114": {
            "name": "Стерлитамак",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8819335,
            "latitude": 56.6693506
        },
        "7115": {
            "name": "Прокопьевка",
            "population": 169,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8862293,
            "latitude": 55.7538769
        },
        "7116": {
            "name": "Богдановка",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8900113,
            "latitude": 56.4614938
        },
        "7117": {
            "name": "Минушка",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8924517,
            "latitude": 55.3999836
        },
        "7118": {
            "name": "Долженовка",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.8985203,
            "latitude": 56.6858692
        },
        "7119": {
            "name": "Огурцы",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.9047563,
            "latitude": 56.5337045
        },
        "7120": {
            "name": "Успенка",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.9285755,
            "latitude": 56.5835253
        },
        "7121": {
            "name": "Суздалево",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.9317948,
            "latitude": 56.8401334
        },
        "7122": {
            "name": "Новосеменовка",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.942428,
            "latitude": 56.4083218
        },
        "7123": {
            "name": "Тёплые Ключи",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.9496549,
            "latitude": 56.2788004
        },
        "7124": {
            "name": "Шивера",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.9556472,
            "latitude": 57.3774813
        },
        "7125": {
            "name": "Новогеоргиевка",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.9926912,
            "latitude": 56.3698954
        },
        "7126": {
            "name": "Чигашет",
            "population": 118,
            "type": "hamlet",
            "poly": [
                [
                    95.9844814,
                    57.3869631
                ],
                [
                    95.9892675,
                    57.3895998
                ],
                [
                    95.9942456,
                    57.3914269
                ],
                [
                    96.0025262,
                    57.3938077
                ],
                [
                    96.0060024,
                    57.39145
                ],
                [
                    96.0039913,
                    57.3900127
                ],
                [
                    95.9990951,
                    57.3865132
                ],
                [
                    95.987744,
                    57.3837375
                ],
                [
                    95.9844814,
                    57.3869631
                ]
            ],
            "longitude": 95.9972735,
            "latitude": 57.3892251
        },
        "7127": {
            "name": "Красный Хлебороб",
            "population": 264,
            "type": "hamlet",
            "poly": [
                [
                    96.0061494,
                    56.2888947
                ],
                [
                    96.0071374,
                    56.290064
                ],
                [
                    96.0095962,
                    56.2899027
                ],
                [
                    96.0119433,
                    56.2920861
                ],
                [
                    96.015028,
                    56.2928676
                ],
                [
                    96.018001,
                    56.2923094
                ],
                [
                    96.0215105,
                    56.2922474
                ],
                [
                    96.0216893,
                    56.2909076
                ],
                [
                    96.0349844,
                    56.291096
                ],
                [
                    96.0359143,
                    56.2897264
                ],
                [
                    96.032302,
                    56.2878705
                ],
                [
                    96.0296017,
                    56.288466
                ],
                [
                    96.0293514,
                    56.2891706
                ],
                [
                    96.0148976,
                    56.2881753
                ],
                [
                    96.0104126,
                    56.2882356
                ],
                [
                    96.0061494,
                    56.2888947
                ]
            ],
            "longitude": 96.0204644,
            "latitude": 56.2903981
        },
        "7128": {
            "name": "Алексеевка",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.020651,
            "latitude": 56.7355443
        },
        "7129": {
            "name": "Новомариновка",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0251452,
            "latitude": 55.4463641
        },
        "7130": {
            "name": "Воробьевка",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.028271,
            "latitude": 56.7227839
        },
        "7131": {
            "name": "Черниговка",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0296339,
            "latitude": 56.3102763
        },
        "7132": {
            "name": "Милехино",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0303393,
            "latitude": 56.2273989
        },
        "7133": {
            "name": "Краснинка",
            "population": 163,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0593476,
            "latitude": 56.4085135
        },
        "7134": {
            "name": "Далай-Отрез",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0610379,
            "latitude": 56.3068176
        },
        "7135": {
            "name": "Ягнянда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.066667,
            "latitude": 59.9
        },
        "7136": {
            "name": "Городок",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0812,
            "latitude": 56.947063
        },
        "7137": {
            "name": "Пайтурма",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.083333,
            "latitude": 71.116667
        },
        "7138": {
            "name": "Красный Яр",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.1041379,
            "latitude": 56.5409683
        },
        "7139": {
            "name": "Гагарина",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.1126828,
            "latitude": 56.7288107
        },
        "7140": {
            "name": "Тарака",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.15876,
            "latitude": 56.430748
        },
        "7141": {
            "name": "Зимник",
            "population": 239,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.1631179,
            "latitude": 56.784444
        },
        "7142": {
            "name": "Белоглинная",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.1669716,
            "latitude": 56.6266646
        },
        "7143": {
            "name": "Новогеоргиевка",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.1729006,
            "latitude": 56.7734974
        },
        "7144": {
            "name": "Тамала",
            "population": 20,
            "type": "hamlet",
            "poly": [
                [
                    96.171332,
                    56.293861
                ],
                [
                    96.1719676,
                    56.2949097
                ],
                [
                    96.1750863,
                    56.295513
                ],
                [
                    96.1795212,
                    56.2957274
                ],
                [
                    96.1829556,
                    56.2979196
                ],
                [
                    96.1863354,
                    56.2978699
                ],
                [
                    96.1867825,
                    56.2964808
                ],
                [
                    96.184219,
                    56.2934852
                ],
                [
                    96.1773405,
                    56.2933847
                ],
                [
                    96.1755344,
                    56.2924518
                ],
                [
                    96.1724049,
                    56.2921541
                ],
                [
                    96.171332,
                    56.293861
                ]
            ],
            "longitude": 96.1749014,
            "latitude": 56.293963
        },
        "7145": {
            "name": "Троицк",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.1792465,
            "latitude": 55.9558738
        },
        "7146": {
            "name": "Каяк",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.2322599,
            "latitude": 71.5103917
        },
        "7147": {
            "name": "Гавриловка",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.1833696,
            "latitude": 55.996408
        },
        "7148": {
            "name": "Новокиевлянка",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.212,
            "latitude": 56.5607678
        },
        "7149": {
            "name": "Канарай",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2141282,
            "latitude": 56.7166775
        },
        "7150": {
            "name": "Каменка",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.217705,
            "latitude": 56.881924
        },
        "7151": {
            "name": "Белая Таежка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.229019,
            "latitude": 56.908485
        },
        "7152": {
            "name": "Абакумовка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2314241,
            "latitude": 55.7357597
        },
        "7153": {
            "name": "Новоникольск",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2388055,
            "latitude": 56.3832866
        },
        "7154": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2410484,
            "latitude": 56.376463
        },
        "7155": {
            "name": "Ильинка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2609389,
            "latitude": 56.4578495
        },
        "7156": {
            "name": "Тулень",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2693828,
            "latitude": 57.3885841
        },
        "7157": {
            "name": "Борки",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2865911,
            "latitude": 56.6501403
        },
        "7158": {
            "name": "Высокогородецк",
            "population": 169,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2932942,
            "latitude": 56.7105125
        },
        "7159": {
            "name": "Росляки",
            "population": 197,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2969827,
            "latitude": 55.7132627
        },
        "7160": {
            "name": "Верх-Атины",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2973601,
            "latitude": 55.9116381
        },
        "7161": {
            "name": "Поскотино",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.3004446,
            "latitude": 56.4731908
        },
        "7162": {
            "name": "Сенное",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.3314433,
            "latitude": 56.6145792
        },
        "7163": {
            "name": "Коха",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.3413472,
            "latitude": 56.3489532
        },
        "7164": {
            "name": "Лобачевка",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.3554214,
            "latitude": 55.8343029
        },
        "7165": {
            "name": "Воздвиженка",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.3559196,
            "latitude": 56.4819049
        },
        "7166": {
            "name": "Копейка",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.3739014,
            "latitude": 56.2945551
        },
        "7167": {
            "name": "Сулемка",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.395098,
            "latitude": 56.1640401
        },
        "7168": {
            "name": "Тёплый Ключ",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.410416,
            "latitude": 56.863655
        },
        "7169": {
            "name": "Озерный",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4112275,
            "latitude": 57.054275
        },
        "7170": {
            "name": "Новорождественка",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4203986,
            "latitude": 56.4352066
        },
        "7171": {
            "name": "Тугуша",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4381608,
            "latitude": 55.9530716
        },
        "7172": {
            "name": "Ермаковка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4467949,
            "latitude": 56.8074486
        },
        "7173": {
            "name": "Байкалово",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4801823,
            "latitude": 56.4543805
        },
        "7174": {
            "name": "Тумиха",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4936319,
            "latitude": 55.7596383
        },
        "7175": {
            "name": "Бирюса",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4945089,
            "latitude": 57.1656066
        },
        "7176": {
            "name": "Эстония",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4987629,
            "latitude": 56.3984817
        },
        "7177": {
            "name": "Новый Локатуй",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4999997,
            "latitude": 56.0143113
        },
        "7178": {
            "name": "Локатуй",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5051139,
            "latitude": 56.0233297
        },
        "7179": {
            "name": "Пушкино",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5140641,
            "latitude": 56.7079865
        },
        "7180": {
            "name": "Егоровка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5159493,
            "latitude": 55.8748261
        },
        "7181": {
            "name": "Максаковка",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5162753,
            "latitude": 56.2639834
        },
        "7182": {
            "name": "Горелый Борок",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.538365,
            "latitude": 56.3495734
        },
        "7183": {
            "name": "Нововоздвиженка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5629227,
            "latitude": 56.4647923
        },
        "7184": {
            "name": "Рудовка",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5663642,
            "latitude": 56.3310169
        },
        "7185": {
            "name": "Пермяково",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5740445,
            "latitude": 56.048056
        },
        "7186": {
            "name": "Климентьевка",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5888317,
            "latitude": 56.0578846
        },
        "7187": {
            "name": "Плахино",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.589153,
            "latitude": 57.2878002
        },
        "7188": {
            "name": "Новая Пойма",
            "population": 190,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5921835,
            "latitude": 56.1781693
        },
        "7189": {
            "name": "Верх-Тугуша",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5958057,
            "latitude": 55.8826899
        },
        "7190": {
            "name": "Первая Рассоха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5996074,
            "latitude": 71.1997307
        },
        "7191": {
            "name": "Старая Пойма",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.6381423,
            "latitude": 56.1876401
        },
        "7192": {
            "name": "Михайловка",
            "population": 173,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.6422034,
            "latitude": 56.3456472
        },
        "7193": {
            "name": "Романовка",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.6554299,
            "latitude": 56.4272352
        },
        "7194": {
            "name": "Зубенкино",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.6965368,
            "latitude": 56.2788309
        },
        "7195": {
            "name": "Шарбыш",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.7132241,
            "latitude": 56.1744459
        },
        "7196": {
            "name": "Ошарово",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.758056,
            "latitude": 56.2772189
        },
        "7197": {
            "name": "Покровка",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.7668262,
            "latitude": 56.4235511
        },
        "7198": {
            "name": "Славянка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.7824858,
            "latitude": 61.0226694
        },
        "7199": {
            "name": "Рождественка",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.7924564,
            "latitude": 56.271414
        },
        "7200": {
            "name": "Лазарево",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.7996677,
            "latitude": 56.8241139
        },
        "7201": {
            "name": "Иркинеево",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.8126794,
            "latitude": 58.494867
        },
        "7202": {
            "name": "Успенка",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.842159,
            "latitude": 56.380833
        },
        "7203": {
            "name": "Фокино",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.8607069,
            "latitude": 56.3390185
        },
        "7204": {
            "name": "Пея",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.8790861,
            "latitude": 57.1751857
        },
        "7205": {
            "name": "Алексеевка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.9785986,
            "latitude": 56.3769257
        },
        "7206": {
            "name": "Боганида",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.9999999,
            "latitude": 71.366667
        },
        "7207": {
            "name": "Догадаево",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.0466134,
            "latitude": 56.1402147
        },
        "7208": {
            "name": "Елизаветка",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.0507437,
            "latitude": 56.1355457
        },
        "7209": {
            "name": "Ярки",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.0976002,
            "latitude": 58.3950467
        },
        "7210": {
            "name": "Борзово",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.1357452,
            "latitude": 57.1186593
        },
        "7211": {
            "name": "Сагыр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.316667,
            "latitude": 72.483333
        },
        "7212": {
            "name": "Бедоба",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.2031688,
            "latitude": 58.8039324
        },
        "7213": {
            "name": "Ильинка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.2321157,
            "latitude": 56.3135954
        },
        "7214": {
            "name": "Прохладный",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.2879148,
            "latitude": 56.2483507
        },
        "7215": {
            "name": "Люча",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.3038205,
            "latitude": 60.1817431
        },
        "7216": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.3245764,
            "latitude": 58.5623366
        },
        "7217": {
            "name": "Ключи",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.3688244,
            "latitude": 56.1208345
        },
        "7218": {
            "name": "Усть-Панакачет",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.3813239,
            "latitude": 56.8849135
        },
        "7219": {
            "name": "Лебяжье",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.3978936,
            "latitude": 56.3631477
        },
        "7220": {
            "name": "Хиндичет",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.4298905,
            "latitude": 57.004109
        },
        "7221": {
            "name": "Южная Тунгуска",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.4393041,
            "latitude": 56.4881349
        },
        "7222": {
            "name": "Боярка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.5034416,
            "latitude": 70.768189
        },
        "7223": {
            "name": "Малеево",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.5356499,
            "latitude": 57.4318245
        },
        "7224": {
            "name": "Сосновка",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.5436189,
            "latitude": 56.4545918
        },
        "7225": {
            "name": "Лапино",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.6136393,
            "latitude": 56.9562288
        },
        "7226": {
            "name": "Кедровый",
            "population": 168,
            "type": "hamlet",
            "poly": [
                [
                    97.6903303,
                    56.5504189
                ],
                [
                    97.6915244,
                    56.5518056
                ],
                [
                    97.7019855,
                    56.5523936
                ],
                [
                    97.7064044,
                    56.5508471
                ],
                [
                    97.6949869,
                    56.542532
                ],
                [
                    97.6909035,
                    56.5441871
                ],
                [
                    97.690999,
                    56.5478386
                ],
                [
                    97.692846,
                    56.5494799
                ],
                [
                    97.6903303,
                    56.5504189
                ]
            ],
            "longitude": 97.6963972,
            "latitude": 56.5479582
        },
        "7227": {
            "name": "Глинный",
            "population": 68,
            "type": "hamlet",
            "poly": [
                [
                    97.7010469,
                    56.7788033
                ],
                [
                    97.7028941,
                    56.7843819
                ],
                [
                    97.7096332,
                    56.7841346
                ],
                [
                    97.7163793,
                    56.7848171
                ],
                [
                    97.7180286,
                    56.781655
                ],
                [
                    97.7198185,
                    56.7812997
                ],
                [
                    97.7213476,
                    56.7788431
                ],
                [
                    97.7189949,
                    56.7770596
                ],
                [
                    97.7010469,
                    56.7788033
                ]
            ],
            "longitude": 97.708759,
            "latitude": 56.7816034
        },
        "7228": {
            "name": "Верхнее Чунку",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.7656784,
            "latitude": 61.8061599
        },
        "7229": {
            "name": "Беленький",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.9833329,
            "latitude": 71.216667
        },
        "7230": {
            "name": "Карго",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.9967109,
            "latitude": 71.2002772
        },
        "7231": {
            "name": "Заимка",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.0456888,
            "latitude": 58.4025227
        },
        "7232": {
            "name": "Корда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.116667,
            "latitude": 61.416667
        },
        "7233": {
            "name": "Мезенский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.266667,
            "latitude": 71.3
        },
        "7234": {
            "name": "Бурунгда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.3665319,
            "latitude": 65.0654384
        },
        "7235": {
            "name": "Гольтявино",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.4366053,
            "latitude": 58.4331467
        },
        "7236": {
            "name": "Подхребетный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.5838902,
            "latitude": 71.4831678
        },
        "7237": {
            "name": "Ленинский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.7201357,
            "latitude": 58.8059788
        },
        "7238": {
            "name": "Климино",
            "population": 192,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.7446255,
            "latitude": 58.6402581
        },
        "7239": {
            "name": "Тембенчи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.8471181,
            "latitude": 64.9496315
        },
        "7240": {
            "name": "Чадобец",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.8597093,
            "latitude": 58.660253
        },
        "7241": {
            "name": "Сыромолотово",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.9359275,
            "latitude": 58.6701147
        },
        "7242": {
            "name": "Юрохта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.9875443,
            "latitude": 58.9534056
        },
        "7243": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.0726572,
            "latitude": 64.1319018
        },
        "7244": {
            "name": "Бидея",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.1964441,
            "latitude": 57.9166861
        },
        "7245": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.7636863,
            "latitude": 59.3854391
        },
        "7246": {
            "name": "Оскоба",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.4756027,
            "latitude": 60.2649181
        },
        "7247": {
            "name": "Гули-Центральное",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.6,
            "latitude": 71
        },
        "7248": {
            "name": "Новая Чиринда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.6344394,
            "latitude": 67.016427
        },
        "7249": {
            "name": "Чемба",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.7158596,
            "latitude": 57.8566039
        },
        "7250": {
            "name": "Карамышево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.9193385,
            "latitude": 57.5773146
        },
        "7251": {
            "name": "Кербо",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.0995036,
            "latitude": 62.7368295
        },
        "7252": {
            "name": "Воеволи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.3,
            "latitude": 65.9
        },
        "7253": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.4104297,
            "latitude": 58.9210496
        },
        "7254": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.6344132,
            "latitude": 58.9753437
        },
        "7255": {
            "name": "Мурукта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.0130009,
            "latitude": 67.7687674
        },
        "7256": {
            "name": "Жданиха",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8673775,
            "latitude": 72.1709816
        },
        "7257": {
            "name": "Чуюнго",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.832348,
            "latitude": 62.5643413
        },
        "7258": {
            "name": "Угоян",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.0732417,
            "latitude": 59.0969057
        },
        "7259": {
            "name": "Кирбей",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.4794157,
            "latitude": 69.1197977
        },
        "7260": {
            "name": "Старорыбное",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.811477,
            "latitude": 72.7543804
        },
        "7261": {
            "name": "Аян",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.666667,
            "latitude": 61.75
        },
        "7262": {
            "name": "Покусагыр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.916667,
            "latitude": 73.666667
        },
        "7263": {
            "name": "Новый",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.3254238,
            "latitude": 72.9645565
        },
        "7264": {
            "name": "Гусиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.5,
            "latitude": 73.65
        },
        "7265": {
            "name": "Косистый",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.7789548,
            "latitude": 73.6935383
        },
        "7266": {
            "name": "Илья",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.1334351,
            "latitude": 73.5595306
        },
        "7267": {
            "name": "Угольный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.1735603,
            "latitude": 73.5414262
        },
        "7268": {
            "name": "Кожевниково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.3,
            "latitude": 73.55
        },
        "7269": {
            "name": "Анабырка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.8,
            "latitude": 72.166667
        },
        "7270": {
            "name": "Нордвик",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.5333329,
            "latitude": 74.033333
        },
        "7271": {
            "name": "Шивилиг",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.9199132,
            "latitude": 50.9918749
        },
        "7272": {
            "name": "Хиндиктиг-Холь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.9277601,
            "latitude": 50.3443245
        },
        "7273": {
            "name": "Ээр-Хавак",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.2606267,
            "latitude": 51.0109326
        },
        "7274": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.3821991,
            "latitude": 50.8418179
        },
        "7275": {
            "name": "Ак-Суг",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.478141,
            "latitude": 51.3857657
        },
        "7276": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.0624973,
            "latitude": 51.1462758
        },
        "7277": {
            "name": "Кирсарай",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.8148471,
            "latitude": 51.3754037
        },
        "7278": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 92.7311823,
            "latitude": 51.3158533
        },
        "7279": {
            "name": "Хурэ",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.1570702,
            "latitude": 51.078268
        },
        "7280": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.184508,
            "latitude": 51.6879433
        },
        "7281": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.3072197,
            "latitude": 51.9857362
        },
        "7282": {
            "name": "Чкаловка",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5070574,
            "latitude": 52.0275263
        },
        "7283": {
            "name": "Каък",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5194731,
            "latitude": 51.3425793
        },
        "7284": {
            "name": "Кара-Тал",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.5381866,
            "latitude": 51.6573081
        },
        "7285": {
            "name": "Оттук-Даш",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.6006442,
            "latitude": 51.5660532
        },
        "7286": {
            "name": "Шивилиг",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7104046,
            "latitude": 52.2398849
        },
        "7287": {
            "name": "Деспен",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.7846647,
            "latitude": 50.7992547
        },
        "7288": {
            "name": "Ленинка",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8752053,
            "latitude": 51.9903052
        },
        "7289": {
            "name": "Билелиг",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 93.8794007,
            "latitude": 52.2732863
        },
        "7290": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.0206583,
            "latitude": 51.9908959
        },
        "7291": {
            "name": "Вавилинский затон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.4463063,
            "latitude": 51.7606657
        },
        "7292": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.5098589,
            "latitude": 50.2694283
        },
        "7293": {
            "name": "Усть-Хадын",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.568761,
            "latitude": 51.288216
        },
        "7294": {
            "name": "Октябрьский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.6939405,
            "latitude": 53.1746181
        },
        "7295": {
            "name": "Севи",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 94.9264865,
            "latitude": 52.489418
        },
        "7296": {
            "name": "Марачевка",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0043647,
            "latitude": 50.9409379
        },
        "7297": {
            "name": "Краснояровка",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.0479523,
            "latitude": 51.0016375
        },
        "7298": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.1148706,
            "latitude": 50.6207473
        },
        "7299": {
            "name": "Куран",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.2724868,
            "latitude": 50.7958609
        },
        "7300": {
            "name": "Бай-Соот",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3156444,
            "latitude": 51.7499553
        },
        "7301": {
            "name": "Тардан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.3268616,
            "latitude": 51.7078829
        },
        "7302": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5164397,
            "latitude": 51.5185978
        },
        "7303": {
            "name": "Мерген",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5663186,
            "latitude": 51.5113124
        },
        "7304": {
            "name": "Авыйган",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.5926481,
            "latitude": 51.3204989
        },
        "7305": {
            "name": "Бельбей",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.7707928,
            "latitude": 51.2865241
        },
        "7306": {
            "name": "Усть-Сизим",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.904065,
            "latitude": 51.3257084
        },
        "7307": {
            "name": "Эржей",
            "population": 232,
            "type": "hamlet",
            "poly": null,
            "longitude": 95.9339671,
            "latitude": 51.3380002
        },
        "7308": {
            "name": "Кызыл-Таштыг",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0110271,
            "latitude": 52.0262574
        },
        "7309": {
            "name": "Шуй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0441761,
            "latitude": 51.3749787
        },
        "7310": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.0568038,
            "latitude": 52.5650689
        },
        "7311": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2330467,
            "latitude": 51.2431935
        },
        "7312": {
            "name": "Ужеп",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2435472,
            "latitude": 51.3400023
        },
        "7313": {
            "name": "Усть-Ужеп",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.2546187,
            "latitude": 51.3294147
        },
        "7314": {
            "name": "Улуг-Танзек",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.277844,
            "latitude": 50.6274209
        },
        "7315": {
            "name": "Ак-Суг",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.4687597,
            "latitude": 53.4384202
        },
        "7316": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.5318523,
            "latitude": 51.3388257
        },
        "7317": {
            "name": "Баянколь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.6398956,
            "latitude": 50.5073917
        },
        "7318": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.6408046,
            "latitude": 51.365012
        },
        "7319": {
            "name": "Кара-Бельдыр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.7054333,
            "latitude": 51.1320983
        },
        "7320": {
            "name": "Арыскан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.7070766,
            "latitude": 53.4557266
        },
        "7321": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.7101602,
            "latitude": 51.3734198
        },
        "7322": {
            "name": "Катазы",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.9018443,
            "latitude": 51.1876568
        },
        "7323": {
            "name": "Белдир",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.9468639,
            "latitude": 50.5040435
        },
        "7324": {
            "name": "Кыбыг-Ада",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 96.9667115,
            "latitude": 50.5067503
        },
        "7325": {
            "name": "Тастыг",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.1100734,
            "latitude": 49.9494705
        },
        "7326": {
            "name": "Чиргаланды",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.2023901,
            "latitude": 50.5833638
        },
        "7327": {
            "name": "Эми",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.6861401,
            "latitude": 50.6356281
        },
        "7328": {
            "name": "Усть-Оттук-Даш",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.7657014,
            "latitude": 50.5732256
        },
        "7329": {
            "name": "Уш-Белдир",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.0534747,
            "latitude": 51.4717472
        },
        "7330": {
            "name": "Тарыс",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.1955881,
            "latitude": 50.3722971
        },
        "7331": {
            "name": "Чойган",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.7918229,
            "latitude": 52.5841545
        },
        "7332": {
            "name": "Ясная Поляна",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    84.5224163,
                    56.0333896
                ],
                [
                    84.5233226,
                    56.0337559
                ],
                [
                    84.5236697,
                    56.0335081
                ],
                [
                    84.5243639,
                    56.033799
                ],
                [
                    84.5237276,
                    56.0342515
                ],
                [
                    84.5249231,
                    56.034941
                ],
                [
                    84.5258294,
                    56.0342191
                ],
                [
                    84.5271793,
                    56.0347686
                ],
                [
                    84.5263886,
                    56.0353934
                ],
                [
                    84.5267936,
                    56.035652
                ],
                [
                    84.5266008,
                    56.0358459
                ],
                [
                    84.5278734,
                    56.0366323
                ],
                [
                    84.528934,
                    56.0370632
                ],
                [
                    84.5298016,
                    56.0364599
                ],
                [
                    84.5309587,
                    56.0368478
                ],
                [
                    84.5314794,
                    56.0368047
                ],
                [
                    84.5321735,
                    56.0361906
                ],
                [
                    84.5330412,
                    56.0362876
                ],
                [
                    84.5332534,
                    56.0364492
                ],
                [
                    84.5318457,
                    56.0370955
                ],
                [
                    84.5325399,
                    56.0377634
                ],
                [
                    84.5337548,
                    56.0373756
                ],
                [
                    84.5340826,
                    56.0377203
                ],
                [
                    84.532887,
                    56.0381512
                ],
                [
                    84.5350274,
                    56.0397563
                ],
                [
                    84.5373221,
                    56.0402302
                ],
                [
                    84.5377078,
                    56.0397994
                ],
                [
                    84.5370714,
                    56.039153
                ],
                [
                    84.539154,
                    56.03911
                ],
                [
                    84.5392504,
                    56.0393039
                ],
                [
                    84.5388262,
                    56.0393469
                ],
                [
                    84.5391347,
                    56.0396055
                ],
                [
                    84.5394818,
                    56.0400148
                ],
                [
                    84.5396939,
                    56.040478
                ],
                [
                    84.5403688,
                    56.0404133
                ],
                [
                    84.540446,
                    56.0401656
                ],
                [
                    84.5420658,
                    56.0397778
                ],
                [
                    84.5417379,
                    56.0392715
                ],
                [
                    84.5407931,
                    56.03939
                ],
                [
                    84.540581,
                    56.0389268
                ],
                [
                    84.5392119,
                    56.0387868
                ],
                [
                    84.539019,
                    56.0386144
                ],
                [
                    84.5394818,
                    56.0384098
                ],
                [
                    84.539289,
                    56.0381512
                ],
                [
                    84.5406581,
                    56.0378496
                ],
                [
                    84.5403496,
                    56.0374726
                ],
                [
                    84.5420465,
                    56.0370632
                ],
                [
                    84.5412366,
                    56.0360151
                ],
                [
                    84.5386527,
                    56.0357166
                ],
                [
                    84.5382477,
                    56.0355335
                ],
                [
                    84.5368401,
                    56.0355766
                ],
                [
                    84.5364544,
                    56.0358351
                ],
                [
                    84.5355867,
                    56.0357382
                ],
                [
                    84.5354517,
                    56.0353288
                ],
                [
                    84.5349889,
                    56.0352426
                ],
                [
                    84.5352781,
                    56.0350164
                ],
                [
                    84.5351046,
                    56.0346716
                ],
                [
                    84.5351431,
                    56.0344454
                ],
                [
                    84.5346996,
                    56.0338313
                ],
                [
                    84.5343718,
                    56.0337343
                ],
                [
                    84.5342176,
                    56.0339067
                ],
                [
                    84.5326364,
                    56.0333034
                ],
                [
                    84.5324821,
                    56.0334973
                ],
                [
                    84.5318264,
                    56.0334004
                ],
                [
                    84.5319036,
                    56.034133
                ],
                [
                    84.5312287,
                    56.0341114
                ],
                [
                    84.5311516,
                    56.033368
                ],
                [
                    84.5304188,
                    56.0334111
                ],
                [
                    84.5304574,
                    56.034036
                ],
                [
                    84.5298596,
                    56.0340145
                ],
                [
                    84.529821,
                    56.0341976
                ],
                [
                    84.5291461,
                    56.0339821
                ],
                [
                    84.5290497,
                    56.0336158
                ],
                [
                    84.5284326,
                    56.0336374
                ],
                [
                    84.5278734,
                    56.0335296
                ],
                [
                    84.5275263,
                    56.0339067
                ],
                [
                    84.5270828,
                    56.0343053
                ],
                [
                    84.5232455,
                    56.0328401
                ],
                [
                    84.5224163,
                    56.0333896
                ]
            ],
            "longitude": 84.5367416,
            "latitude": 56.0381752
        },
        "7333": {
            "name": "Кожевниково",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6203407,
            "latitude": 56.0111228
        },
        "7334": {
            "name": "139 км",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6243805,
            "latitude": 55.7088769
        },
        "7335": {
            "name": "Зелёная Горка",
            "population": 159,
            "type": "hamlet",
            "poly": [
                [
                    84.6350237,
                    55.704924
                ],
                [
                    84.6356293,
                    55.7051767
                ],
                [
                    84.6352928,
                    55.7053663
                ],
                [
                    84.635719,
                    55.7055306
                ],
                [
                    84.636533,
                    55.7061198
                ],
                [
                    84.6393245,
                    55.7063521
                ],
                [
                    84.6405934,
                    55.7076211
                ],
                [
                    84.639959,
                    55.7079249
                ],
                [
                    84.6401176,
                    55.7084432
                ],
                [
                    84.6392611,
                    55.7092117
                ],
                [
                    84.6398638,
                    55.7093368
                ],
                [
                    84.6404983,
                    55.7091402
                ],
                [
                    84.6408789,
                    55.7097479
                ],
                [
                    84.6435118,
                    55.7098551
                ],
                [
                    84.6442203,
                    55.7095747
                ],
                [
                    84.6440968,
                    55.7079571
                ],
                [
                    84.6441081,
                    55.7053094
                ],
                [
                    84.6441754,
                    55.7009678
                ],
                [
                    84.6447126,
                    55.6999847
                ],
                [
                    84.6438444,
                    55.6992109
                ],
                [
                    84.6396668,
                    55.7001083
                ],
                [
                    84.6378948,
                    55.7008414
                ],
                [
                    84.6366387,
                    55.7031798
                ],
                [
                    84.6350237,
                    55.704924
                ]
            ],
            "longitude": 84.6409053,
            "latitude": 55.7048716
        },
        "7336": {
            "name": "Бжицкая",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6433915,
            "latitude": 55.7191378
        },
        "7337": {
            "name": "Таскаево",
            "population": 143,
            "type": "hamlet",
            "poly": [
                [
                    84.6441248,
                    55.6991552
                ],
                [
                    84.6449733,
                    55.7000225
                ],
                [
                    84.6444126,
                    55.7009547
                ],
                [
                    84.6442925,
                    55.7036987
                ],
                [
                    84.6485024,
                    55.7038117
                ],
                [
                    84.6486293,
                    55.701774
                ],
                [
                    84.6572417,
                    55.7012556
                ],
                [
                    84.658923,
                    55.7005674
                ],
                [
                    84.6610959,
                    55.7001026
                ],
                [
                    84.6625393,
                    55.6995216
                ],
                [
                    84.6617938,
                    55.6984937
                ],
                [
                    84.6616511,
                    55.696706
                ],
                [
                    84.6614766,
                    55.696116
                ],
                [
                    84.6588278,
                    55.6957406
                ],
                [
                    84.6527055,
                    55.6967865
                ],
                [
                    84.6520869,
                    55.6980736
                ],
                [
                    84.6441248,
                    55.6991552
                ]
            ],
            "longitude": 84.652754,
            "latitude": 55.7003128
        },
        "7338": {
            "name": "Алабучинка",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6611594,
            "latitude": 55.9538636
        },
        "7339": {
            "name": "Кленовка",
            "population": 238,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.662862,
            "latitude": 55.6848677
        },
        "7340": {
            "name": "Чутовка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6827709,
            "latitude": 55.9386883
        },
        "7341": {
            "name": "Шитиково",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6844328,
            "latitude": 55.7466896
        },
        "7342": {
            "name": "Чахлово",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.707169,
            "latitude": 55.790062
        },
        "7343": {
            "name": "Васильевка",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7185414,
            "latitude": 55.4003202
        },
        "7344": {
            "name": "14 км",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7542718,
            "latitude": 55.6142189
        },
        "7345": {
            "name": "31 км",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7580133,
            "latitude": 55.4703705
        },
        "7346": {
            "name": "Юльяновка",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7607818,
            "latitude": 55.4352919
        },
        "7347": {
            "name": "Блок-Пост 149 км",
            "population": 13,
            "type": "hamlet",
            "poly": [
                [
                    84.7798875,
                    55.7038975
                ],
                [
                    84.7825601,
                    55.7038583
                ],
                [
                    84.7837923,
                    55.7035454
                ],
                [
                    84.7820048,
                    55.70334
                ],
                [
                    84.7818139,
                    55.7029
                ],
                [
                    84.7809808,
                    55.7028022
                ],
                [
                    84.7800089,
                    55.7035063
                ],
                [
                    84.7798875,
                    55.7038975
                ]
            ],
            "longitude": 84.7803021,
            "latitude": 55.7037142
        },
        "7348": {
            "name": "Филоново",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7839975,
            "latitude": 55.8675405
        },
        "7349": {
            "name": "23 км",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7857931,
            "latitude": 55.5347956
        },
        "7350": {
            "name": "Милютино",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.789246,
            "latitude": 55.899033
        },
        "7351": {
            "name": "Приречье",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8006811,
            "latitude": 55.8915125
        },
        "7352": {
            "name": "Логовой",
            "population": 110,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8160524,
            "latitude": 55.5591572
        },
        "7353": {
            "name": "Старый Шалай",
            "population": 189,
            "type": "hamlet",
            "poly": [
                [
                    84.8501517,
                    55.6135052
                ],
                [
                    84.8512207,
                    55.6134146
                ],
                [
                    84.8525037,
                    55.6146524
                ],
                [
                    84.8541075,
                    55.6143505
                ],
                [
                    84.8542678,
                    55.6159808
                ],
                [
                    84.8565664,
                    55.6159808
                ],
                [
                    84.857101,
                    55.6153468
                ],
                [
                    84.8597203,
                    55.6148336
                ],
                [
                    84.8603083,
                    55.6127504
                ],
                [
                    84.8603618,
                    55.611573
                ],
                [
                    84.8612171,
                    55.6113918
                ],
                [
                    84.8605222,
                    55.6103049
                ],
                [
                    84.8580632,
                    55.6102445
                ],
                [
                    84.8581701,
                    55.608765
                ],
                [
                    84.855711,
                    55.6080403
                ],
                [
                    84.8531986,
                    55.6053831
                ],
                [
                    84.8519157,
                    55.6055341
                ],
                [
                    84.8518622,
                    55.6069533
                ],
                [
                    84.8544282,
                    55.6115126
                ],
                [
                    84.8519157,
                    55.6109993
                ],
                [
                    84.8502586,
                    55.6113616
                ],
                [
                    84.8501517,
                    55.6135052
                ]
            ],
            "longitude": 84.8558784,
            "latitude": 55.6124229
        },
        "7354": {
            "name": "Любаровка",
            "population": 156,
            "type": "hamlet",
            "poly": [
                [
                    84.865862,
                    55.5046987
                ],
                [
                    84.8680166,
                    55.5058119
                ],
                [
                    84.8670057,
                    55.5065428
                ],
                [
                    84.8771623,
                    55.5119916
                ],
                [
                    84.8804525,
                    55.5150798
                ],
                [
                    84.8804525,
                    55.5162355
                ],
                [
                    84.8822291,
                    55.5165779
                ],
                [
                    84.8815865,
                    55.5172627
                ],
                [
                    84.8840047,
                    55.5200422
                ],
                [
                    84.8856084,
                    55.5210106
                ],
                [
                    84.888495,
                    55.5208896
                ],
                [
                    84.8896711,
                    55.5175001
                ],
                [
                    84.8883881,
                    55.5142919
                ],
                [
                    84.8875587,
                    55.5144913
                ],
                [
                    84.8846104,
                    55.5097291
                ],
                [
                    84.8698687,
                    55.5031788
                ],
                [
                    84.8680544,
                    55.5042491
                ],
                [
                    84.867374,
                    55.5039066
                ],
                [
                    84.865862,
                    55.5046987
                ]
            ],
            "longitude": 84.8801653,
            "latitude": 55.5105046
        },
        "7355": {
            "name": "Новоягодное",
            "population": 27,
            "type": "hamlet",
            "poly": [
                [
                    84.8791141,
                    55.6761173
                ],
                [
                    84.880073,
                    55.6761037
                ],
                [
                    84.8799596,
                    55.6752725
                ],
                [
                    84.8803376,
                    55.675102
                ],
                [
                    84.8809801,
                    55.6759332
                ],
                [
                    84.8819062,
                    55.6756455
                ],
                [
                    84.8818117,
                    55.6751766
                ],
                [
                    84.8821708,
                    55.6749847
                ],
                [
                    84.8820952,
                    55.6744732
                ],
                [
                    84.8828134,
                    55.6741535
                ],
                [
                    84.8820196,
                    55.6736632
                ],
                [
                    84.8812302,
                    55.6738334
                ],
                [
                    84.8801076,
                    55.6733813
                ],
                [
                    84.8794871,
                    55.6742707
                ],
                [
                    84.8791141,
                    55.6761173
                ]
            ],
            "longitude": 84.8812649,
            "latitude": 55.6744746
        },
        "7356": {
            "name": "Большой Улус",
            "population": 25,
            "type": "hamlet",
            "poly": [
                [
                    84.8928272,
                    55.5743182
                ],
                [
                    84.8939329,
                    55.5755309
                ],
                [
                    84.8939896,
                    55.5767062
                ],
                [
                    84.8949346,
                    55.5769359
                ],
                [
                    84.8951803,
                    55.5774647
                ],
                [
                    84.8963332,
                    55.5777158
                ],
                [
                    84.8970325,
                    55.5772671
                ],
                [
                    84.8981098,
                    55.5771549
                ],
                [
                    84.8992437,
                    55.5776036
                ],
                [
                    84.9003588,
                    55.5774647
                ],
                [
                    84.8999525,
                    55.5767703
                ],
                [
                    84.9006234,
                    55.5758835
                ],
                [
                    84.8999808,
                    55.5754187
                ],
                [
                    84.9020881,
                    55.574954
                ],
                [
                    84.9026896,
                    55.5743393
                ],
                [
                    84.9008187,
                    55.5720123
                ],
                [
                    84.8993219,
                    55.5722087
                ],
                [
                    84.8990453,
                    55.569964
                ],
                [
                    84.8972309,
                    55.5702205
                ],
                [
                    84.8946227,
                    55.5701991
                ],
                [
                    84.8940558,
                    55.5708189
                ],
                [
                    84.8934132,
                    55.5709685
                ],
                [
                    84.894207,
                    55.5726354
                ],
                [
                    84.893451,
                    55.572785
                ],
                [
                    84.8928272,
                    55.5743182
                ]
            ],
            "longitude": 84.8971718,
            "latitude": 55.5738443
        },
        "7357": {
            "name": "Алаево",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9009298,
            "latitude": 56.1528315
        },
        "7358": {
            "name": "Чёрный Падун",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9144227,
            "latitude": 55.3896037
        },
        "7359": {
            "name": "Сосновый Острог",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.922638,
            "latitude": 56.009197
        },
        "7360": {
            "name": "46 км",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9452708,
            "latitude": 55.4255192
        },
        "7361": {
            "name": "Глинковка",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9463376,
            "latitude": 55.4184675
        },
        "7362": {
            "name": "Каип",
            "population": 75,
            "type": "hamlet",
            "poly": [
                [
                    84.9401667,
                    55.530312
                ],
                [
                    84.9479534,
                    55.5369006
                ],
                [
                    84.9501456,
                    55.539895
                ],
                [
                    84.9574032,
                    55.5438302
                ],
                [
                    84.9610319,
                    55.5424187
                ],
                [
                    84.9609563,
                    55.5412638
                ],
                [
                    84.9589908,
                    55.5407933
                ],
                [
                    84.9582348,
                    55.5394245
                ],
                [
                    84.9520357,
                    55.5357027
                ],
                [
                    84.9527161,
                    55.5351038
                ],
                [
                    84.9490117,
                    55.5302692
                ],
                [
                    84.9460634,
                    55.5303548
                ],
                [
                    84.9441735,
                    55.5288572
                ],
                [
                    84.9401667,
                    55.530312
                ]
            ],
            "longitude": 84.9502677,
            "latitude": 55.5364115
        },
        "7363": {
            "name": "Мохово",
            "population": 208,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9503543,
            "latitude": 55.8376384
        },
        "7364": {
            "name": "Юрты-Константиновы",
            "population": 103,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.957237,
            "latitude": 56.066563
        },
        "7365": {
            "name": "Тутальский Санаторий",
            "population": 103,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9678936,
            "latitude": 55.7266015
        },
        "7366": {
            "name": "Осоавиахим",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9717475,
            "latitude": 55.7215913
        },
        "7367": {
            "name": "Мариновка",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    84.9718752,
                    55.5419142
                ],
                [
                    84.9731448,
                    55.5423906
                ],
                [
                    84.9743342,
                    55.5417025
                ],
                [
                    84.9752964,
                    55.5420806
                ],
                [
                    84.9781029,
                    55.5407119
                ],
                [
                    84.9763255,
                    55.5398802
                ],
                [
                    84.9742139,
                    55.5409842
                ],
                [
                    84.9732785,
                    55.5405683
                ],
                [
                    84.9718752,
                    55.5419142
                ]
            ],
            "longitude": 84.9752247,
            "latitude": 55.5411981
        },
        "7368": {
            "name": "Левососновский",
            "population": 174,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9784935,
            "latitude": 55.2157723
        },
        "7369": {
            "name": "Усть-Сосновка",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.981209,
            "latitude": 56.082417
        },
        "7370": {
            "name": "Сланцевый Рудник",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9872583,
            "latitude": 55.7105394
        },
        "7371": {
            "name": "Иткара",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.988632,
            "latitude": 55.954056
        },
        "7372": {
            "name": "Канаш",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.331604,
            "latitude": 54.082134
        },
        "7373": {
            "name": "Денисовка",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0025263,
            "latitude": 54.9543101
        },
        "7374": {
            "name": "Романовский",
            "population": 118,
            "type": "hamlet",
            "poly": [
                [
                    84.9933466,
                    55.267165
                ],
                [
                    84.9944873,
                    55.2694204
                ],
                [
                    84.9965672,
                    55.2691528
                ],
                [
                    84.9968755,
                    55.2710989
                ],
                [
                    84.999184,
                    55.2732428
                ],
                [
                    85.0004338,
                    55.2732611
                ],
                [
                    85.0011298,
                    55.2737015
                ],
                [
                    85.0003627,
                    55.2740044
                ],
                [
                    84.9997932,
                    55.2736125
                ],
                [
                    84.9969698,
                    55.2740837
                ],
                [
                    84.9988444,
                    55.2749503
                ],
                [
                    85.002673,
                    55.2754978
                ],
                [
                    85.0007943,
                    55.2766062
                ],
                [
                    85.0013311,
                    55.2771795
                ],
                [
                    85.0044175,
                    55.2765298
                ],
                [
                    85.0069,
                    55.277791
                ],
                [
                    85.0093826,
                    55.2771031
                ],
                [
                    85.0081078,
                    55.2734339
                ],
                [
                    85.0063633,
                    55.2726695
                ],
                [
                    85.0071013,
                    55.2715228
                ],
                [
                    85.0053568,
                    55.2717139
                ],
                [
                    85.0042833,
                    55.2704907
                ],
                [
                    85.0023375,
                    55.2720961
                ],
                [
                    85.0013311,
                    55.2720197
                ],
                [
                    84.9990498,
                    55.2695351
                ],
                [
                    85.0004588,
                    55.2690381
                ],
                [
                    84.9992511,
                    55.2680825
                ],
                [
                    85.0005259,
                    55.2673944
                ],
                [
                    84.9983117,
                    55.267662
                ],
                [
                    84.9976408,
                    55.2669739
                ],
                [
                    84.9933466,
                    55.267165
                ]
            ],
            "longitude": 85.0054045,
            "latitude": 55.2741312
        },
        "7375": {
            "name": "Кокуй",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0171138,
            "latitude": 55.3324924
        },
        "7376": {
            "name": "Кулаково",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.022942,
            "latitude": 55.890938
        },
        "7377": {
            "name": "Берёзово",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0453625,
            "latitude": 55.1759167
        },
        "7378": {
            "name": "54 км",
            "population": 39,
            "type": "hamlet",
            "poly": [
                [
                    85.0505316,
                    55.465058
                ],
                [
                    85.051779,
                    55.4651223
                ],
                [
                    85.0519302,
                    55.4660973
                ],
                [
                    85.0511553,
                    55.4660973
                ],
                [
                    85.0510986,
                    55.4666544
                ],
                [
                    85.0516844,
                    55.4666437
                ],
                [
                    85.0518357,
                    55.4671901
                ],
                [
                    85.0527996,
                    55.4670829
                ],
                [
                    85.0527807,
                    55.4666223
                ],
                [
                    85.0521569,
                    55.4663115
                ],
                [
                    85.0523649,
                    55.4654973
                ],
                [
                    85.0531776,
                    55.4654866
                ],
                [
                    85.0537067,
                    55.4641687
                ],
                [
                    85.0534799,
                    55.4631401
                ],
                [
                    85.0517033,
                    55.4631401
                ],
                [
                    85.0516089,
                    55.4644901
                ],
                [
                    85.050645,
                    55.4645866
                ],
                [
                    85.0505316,
                    55.465058
                ]
            ],
            "longitude": 85.0522672,
            "latitude": 55.4649334
        },
        "7379": {
            "name": "Катково",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0560746,
            "latitude": 55.145199
        },
        "7380": {
            "name": "Бархатово",
            "population": 247,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0605046,
            "latitude": 55.3607171
        },
        "7381": {
            "name": "Косогорово",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.091364,
            "latitude": 56.1467106
        },
        "7382": {
            "name": "Октябрьский",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1110942,
            "latitude": 55.7782445
        },
        "7383": {
            "name": "Калтышино",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1195991,
            "latitude": 54.8316016
        },
        "7384": {
            "name": "Тайгинский Леспромхоз",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.121239,
            "latitude": 54.50742
        },
        "7385": {
            "name": "Дауровка",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1269,
            "latitude": 55.912239
        },
        "7386": {
            "name": "Верх-Иткара",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1329727,
            "latitude": 55.9824392
        },
        "7387": {
            "name": "Листвянка",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1334026,
            "latitude": 55.4228336
        },
        "7388": {
            "name": "Иван-Брод",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1404048,
            "latitude": 54.6101269
        },
        "7389": {
            "name": "64 км",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1689122,
            "latitude": 55.4175664
        },
        "7390": {
            "name": "Мелково",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1763334,
            "latitude": 56.0265267
        },
        "7391": {
            "name": "Комсомольский",
            "population": 139,
            "type": "hamlet",
            "poly": [
                [
                    85.1692446,
                    55.3745514
                ],
                [
                    85.1715681,
                    55.3759281
                ],
                [
                    85.1715681,
                    55.3763996
                ],
                [
                    85.172763,
                    55.3768711
                ],
                [
                    85.172066,
                    55.3772482
                ],
                [
                    85.1745221,
                    55.3787757
                ],
                [
                    85.1765468,
                    55.3795489
                ],
                [
                    85.1775094,
                    55.3811706
                ],
                [
                    85.1792021,
                    55.3815854
                ],
                [
                    85.1798328,
                    55.3810197
                ],
                [
                    85.1835834,
                    55.3796809
                ],
                [
                    85.1845127,
                    55.3789643
                ],
                [
                    85.184911,
                    55.377682
                ],
                [
                    85.1813928,
                    55.3741176
                ],
                [
                    85.1796004,
                    55.373665
                ],
                [
                    85.1782063,
                    55.3738913
                ],
                [
                    85.1773434,
                    55.3750606
                ],
                [
                    85.169809,
                    55.3738913
                ],
                [
                    85.1692446,
                    55.3745514
                ]
            ],
            "longitude": 85.178166,
            "latitude": 55.3777319
        },
        "7392": {
            "name": "Лукошкино",
            "population": 252,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1971119,
            "latitude": 55.2698626
        },
        "7393": {
            "name": "Среднеберезовский",
            "population": 69,
            "type": "hamlet",
            "poly": [
                [
                    85.1942758,
                    55.2019172
                ],
                [
                    85.1947129,
                    55.2026475
                ],
                [
                    85.1970538,
                    55.2031819
                ],
                [
                    85.1991325,
                    55.2031233
                ],
                [
                    85.1991766,
                    55.2039042
                ],
                [
                    85.2016485,
                    55.203879
                ],
                [
                    85.2012513,
                    55.2032492
                ],
                [
                    85.2004206,
                    55.2032574
                ],
                [
                    85.2002645,
                    55.2028299
                ],
                [
                    85.2016535,
                    55.2020105
                ],
                [
                    85.2037802,
                    55.2022476
                ],
                [
                    85.2027208,
                    55.204162
                ],
                [
                    85.2008669,
                    55.2047288
                ],
                [
                    85.1994764,
                    55.2047162
                ],
                [
                    85.1991012,
                    55.2059504
                ],
                [
                    85.2015797,
                    55.2061742
                ],
                [
                    85.2014236,
                    55.2067264
                ],
                [
                    85.2058246,
                    55.2071538
                ],
                [
                    85.2056685,
                    55.2041081
                ],
                [
                    85.2079782,
                    55.203841
                ],
                [
                    85.2079782,
                    55.2034313
                ],
                [
                    85.2071668,
                    55.20336
                ],
                [
                    85.207354,
                    55.2026475
                ],
                [
                    85.2058246,
                    55.2022735
                ],
                [
                    85.2046385,
                    55.2027722
                ],
                [
                    85.2044825,
                    55.2022735
                ],
                [
                    85.2050755,
                    55.2020063
                ],
                [
                    85.2074164,
                    55.2017035
                ],
                [
                    85.2089146,
                    55.2011157
                ],
                [
                    85.2081031,
                    55.1998153
                ],
                [
                    85.2056061,
                    55.2006347
                ],
                [
                    85.2045761,
                    55.2007594
                ],
                [
                    85.2043264,
                    55.1997262
                ],
                [
                    85.20339,
                    55.1994412
                ],
                [
                    85.2024847,
                    55.199459
                ],
                [
                    85.2025161,
                    55.1998331
                ],
                [
                    85.2005184,
                    55.1998865
                ],
                [
                    85.1962735,
                    55.2003497
                ],
                [
                    85.1945256,
                    55.2009197
                ],
                [
                    85.1950874,
                    55.2017569
                ],
                [
                    85.1942758,
                    55.2019172
                ]
            ],
            "longitude": 85.1993862,
            "latitude": 55.2021468
        },
        "7394": {
            "name": "Шипицино",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2009759,
            "latitude": 54.9029983
        },
        "7395": {
            "name": "Тальменка",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2016842,
            "latitude": 55.80269
        },
        "7396": {
            "name": "Нижняя Тайменка",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2153681,
            "latitude": 55.6678555
        },
        "7397": {
            "name": "Каленово",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2212735,
            "latitude": 55.7939517
        },
        "7398": {
            "name": "Балахнино",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2244976,
            "latitude": 55.9065852
        },
        "7399": {
            "name": "Нижнешубино",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2429103,
            "latitude": 56.0070209
        },
        "7400": {
            "name": "Козлово",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2550788,
            "latitude": 55.2363397
        },
        "7401": {
            "name": "Чаща",
            "population": 65,
            "type": "hamlet",
            "poly": [
                [
                    85.2495129,
                    55.4039002
                ],
                [
                    85.2510535,
                    55.4044987
                ],
                [
                    85.2515401,
                    55.4042685
                ],
                [
                    85.2536213,
                    55.4054195
                ],
                [
                    85.2553781,
                    55.40611
                ],
                [
                    85.2554592,
                    55.4064937
                ],
                [
                    85.2566485,
                    55.4071535
                ],
                [
                    85.2556755,
                    55.4076139
                ],
                [
                    85.2520806,
                    55.4064783
                ],
                [
                    85.2504859,
                    55.4066471
                ],
                [
                    85.2500535,
                    55.4071535
                ],
                [
                    85.2508643,
                    55.4072763
                ],
                [
                    85.2512014,
                    55.4077565
                ],
                [
                    85.2544078,
                    55.409138
                ],
                [
                    85.2538725,
                    55.4098758
                ],
                [
                    85.2565483,
                    55.4109608
                ],
                [
                    85.2581538,
                    55.4103532
                ],
                [
                    85.2579243,
                    55.4097456
                ],
                [
                    85.2607529,
                    55.4088776
                ],
                [
                    85.2605144,
                    55.4079837
                ],
                [
                    85.2608584,
                    55.4078752
                ],
                [
                    85.2611893,
                    55.4068159
                ],
                [
                    85.2675411,
                    55.406417
                ],
                [
                    85.2669194,
                    55.405619
                ],
                [
                    85.265595,
                    55.4058645
                ],
                [
                    85.265541,
                    55.4061714
                ],
                [
                    85.2643247,
                    55.4061868
                ],
                [
                    85.2641895,
                    55.4058185
                ],
                [
                    85.261865,
                    55.4057724
                ],
                [
                    85.2612164,
                    55.4054809
                ],
                [
                    85.2614596,
                    55.4047596
                ],
                [
                    85.2601351,
                    55.4038848
                ],
                [
                    85.2596217,
                    55.4041764
                ],
                [
                    85.2554863,
                    55.4031482
                ],
                [
                    85.2551079,
                    55.4033477
                ],
                [
                    85.2515941,
                    55.4022888
                ],
                [
                    85.2502967,
                    55.4029487
                ],
                [
                    85.2495129,
                    55.4039002
                ]
            ],
            "longitude": 85.258416,
            "latitude": 55.4066663
        },
        "7402": {
            "name": "Тыхта",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2599506,
            "latitude": 55.1290421
        },
        "7403": {
            "name": "Крылово",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2617284,
            "latitude": 55.6599343
        },
        "7404": {
            "name": "Корчуганово",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.263687,
            "latitude": 55.8007708
        },
        "7405": {
            "name": "Митрофаново",
            "population": 120,
            "type": "hamlet",
            "poly": [
                [
                    85.2789601,
                    55.6458693
                ],
                [
                    85.2857988,
                    55.6491656
                ],
                [
                    85.2947733,
                    55.6487355
                ],
                [
                    85.2979931,
                    55.6483433
                ],
                [
                    85.3009046,
                    55.6479213
                ],
                [
                    85.3004561,
                    55.6462025
                ],
                [
                    85.2985628,
                    55.6444507
                ],
                [
                    85.2955026,
                    55.6434817
                ],
                [
                    85.2875099,
                    55.6435596
                ],
                [
                    85.2789601,
                    55.6458693
                ]
            ],
            "longitude": 85.2949025,
            "latitude": 55.6468792
        },
        "7406": {
            "name": "Тарсьма",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.304863,
            "latitude": 54.988678
        },
        "7407": {
            "name": "79 км",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3152471,
            "latitude": 55.3144155
        },
        "7408": {
            "name": "Дмитриевка",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.325363,
            "latitude": 54.466717
        },
        "7409": {
            "name": "Северная",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3253675,
            "latitude": 56.0403556
        },
        "7410": {
            "name": "Верх-Мостовинский",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3274535,
            "latitude": 55.4470602
        },
        "7411": {
            "name": "Хрестиновский",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.328201,
            "latitude": 54.572857
        },
        "7412": {
            "name": "Апрелька",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.330414,
            "latitude": 54.523952
        },
        "7413": {
            "name": "Симаново",
            "population": 176,
            "type": "hamlet",
            "poly": [
                [
                    85.3239016,
                    55.3769662
                ],
                [
                    85.3257746,
                    55.3785951
                ],
                [
                    85.329253,
                    55.3841109
                ],
                [
                    85.3304762,
                    55.3884969
                ],
                [
                    85.3295588,
                    55.3904075
                ],
                [
                    85.3301704,
                    55.3910154
                ],
                [
                    85.332311,
                    55.3921877
                ],
                [
                    85.3365539,
                    55.3935337
                ],
                [
                    85.3393533,
                    55.393713
                ],
                [
                    85.3402724,
                    55.3938435
                ],
                [
                    85.3395021,
                    55.3945496
                ],
                [
                    85.3407859,
                    55.3950945
                ],
                [
                    85.3403129,
                    55.3955703
                ],
                [
                    85.3403535,
                    55.3957929
                ],
                [
                    85.3406373,
                    55.3960001
                ],
                [
                    85.3404616,
                    55.3962381
                ],
                [
                    85.3410022,
                    55.3966755
                ],
                [
                    85.3420022,
                    55.3970976
                ],
                [
                    85.342205,
                    55.397113
                ],
                [
                    85.3435699,
                    55.3965067
                ],
                [
                    85.3445565,
                    55.3962995
                ],
                [
                    85.3453403,
                    55.3960615
                ],
                [
                    85.3454349,
                    55.3956855
                ],
                [
                    85.3457592,
                    55.3954936
                ],
                [
                    85.3457998,
                    55.3951329
                ],
                [
                    85.3460295,
                    55.3947875
                ],
                [
                    85.3469755,
                    55.3942733
                ],
                [
                    85.3470836,
                    55.3938972
                ],
                [
                    85.3474619,
                    55.3940353
                ],
                [
                    85.3480122,
                    55.393921
                ],
                [
                    85.3492641,
                    55.3940838
                ],
                [
                    85.3496178,
                    55.393921
                ],
                [
                    85.350086,
                    55.3940132
                ],
                [
                    85.3505447,
                    55.3938667
                ],
                [
                    85.3517775,
                    55.3939861
                ],
                [
                    85.3519781,
                    55.3939101
                ],
                [
                    85.3521597,
                    55.393693
                ],
                [
                    85.3525419,
                    55.3932588
                ],
                [
                    85.3525993,
                    55.392803
                ],
                [
                    85.3531631,
                    55.392461
                ],
                [
                    85.3527426,
                    55.3923036
                ],
                [
                    85.3521978,
                    55.3920865
                ],
                [
                    85.3513665,
                    55.3922494
                ],
                [
                    85.3507167,
                    55.3921245
                ],
                [
                    85.3498758,
                    55.3922765
                ],
                [
                    85.3495987,
                    55.3921734
                ],
                [
                    85.3496273,
                    55.3919943
                ],
                [
                    85.3498661,
                    55.3917337
                ],
                [
                    85.3497323,
                    55.3915004
                ],
                [
                    85.3491495,
                    55.3912344
                ],
                [
                    85.3492833,
                    55.3908436
                ],
                [
                    85.3490062,
                    55.390442
                ],
                [
                    85.3493598,
                    55.390214
                ],
                [
                    85.3491017,
                    55.3900349
                ],
                [
                    85.3488151,
                    55.3900186
                ],
                [
                    85.3486526,
                    55.3901597
                ],
                [
                    85.3486526,
                    55.3904745
                ],
                [
                    85.3480315,
                    55.3903497
                ],
                [
                    85.347869,
                    55.3899969
                ],
                [
                    85.3475345,
                    55.3897635
                ],
                [
                    85.3477543,
                    55.3893836
                ],
                [
                    85.3472096,
                    55.3889276
                ],
                [
                    85.3468083,
                    55.3888516
                ],
                [
                    85.3464642,
                    55.3890416
                ],
                [
                    85.3460151,
                    55.3889276
                ],
                [
                    85.3453749,
                    55.389009
                ],
                [
                    85.3444861,
                    55.3888679
                ],
                [
                    85.3445435,
                    55.3887539
                ],
                [
                    85.3452506,
                    55.3884608
                ],
                [
                    85.3458336,
                    55.3879777
                ],
                [
                    85.3461776,
                    55.3878909
                ],
                [
                    85.348127,
                    55.3879994
                ],
                [
                    85.3489011,
                    55.3880917
                ],
                [
                    85.3501147,
                    55.3887376
                ],
                [
                    85.3509556,
                    55.3882546
                ],
                [
                    85.3486025,
                    55.3871116
                ],
                [
                    85.3494817,
                    55.3866123
                ],
                [
                    85.3495558,
                    55.3864017
                ],
                [
                    85.3491638,
                    55.386133
                ],
                [
                    85.3480152,
                    55.3858874
                ],
                [
                    85.3473394,
                    55.3854882
                ],
                [
                    85.3456772,
                    55.385089
                ],
                [
                    85.3435061,
                    55.3834895
                ],
                [
                    85.3432194,
                    55.3829032
                ],
                [
                    85.3440221,
                    55.3825232
                ],
                [
                    85.3399034,
                    55.3793853
                ],
                [
                    85.3388809,
                    55.3794613
                ],
                [
                    85.3360395,
                    55.3774086
                ],
                [
                    85.3343632,
                    55.3758404
                ],
                [
                    85.3332356,
                    55.3761444
                ],
                [
                    85.3255143,
                    55.3767743
                ],
                [
                    85.3239016,
                    55.3769662
                ]
            ],
            "longitude": 85.3373712,
            "latitude": 55.386857
        },
        "7414": {
            "name": "Касимовка",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3408462,
            "latitude": 54.7424004
        },
        "7415": {
            "name": "Сарасет",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7467655,
            "latitude": 52.8561495
        },
        "7416": {
            "name": "Юрманово",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3444289,
            "latitude": 55.5478834
        },
        "7417": {
            "name": "Харьков Лог",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.357368,
            "latitude": 54.550129
        },
        "7418": {
            "name": "Маслиха",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.362289,
            "latitude": 54.440079
        },
        "7419": {
            "name": "Ключевой",
            "population": 130,
            "type": "hamlet",
            "poly": [
                [
                    85.3602396,
                    55.3270794
                ],
                [
                    85.3617209,
                    55.3277025
                ],
                [
                    85.3624911,
                    55.3271486
                ],
                [
                    85.3644992,
                    55.3282044
                ],
                [
                    85.3637081,
                    55.329866
                ],
                [
                    85.3645296,
                    55.3303679
                ],
                [
                    85.3665106,
                    55.3278668
                ],
                [
                    85.3708134,
                    55.3252721
                ],
                [
                    85.3700389,
                    55.3249294
                ],
                [
                    85.3739973,
                    55.3224569
                ],
                [
                    85.3763639,
                    55.3216
                ],
                [
                    85.3750301,
                    55.320988
                ],
                [
                    85.3736532,
                    55.3213063
                ],
                [
                    85.3692214,
                    55.3200087
                ],
                [
                    85.3653059,
                    55.320327
                ],
                [
                    85.3631115,
                    55.3198863
                ],
                [
                    85.3622079,
                    55.320278
                ],
                [
                    85.365521,
                    55.3217959
                ],
                [
                    85.3641872,
                    55.3234851
                ],
                [
                    85.3631975,
                    55.3236564
                ],
                [
                    85.3602396,
                    55.3270794
                ]
            ],
            "longitude": 85.3678472,
            "latitude": 55.3230127
        },
        "7420": {
            "name": "Заря",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.385178,
            "latitude": 54.472733
        },
        "7421": {
            "name": "210 км",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3874179,
            "latitude": 54.947425
        },
        "7422": {
            "name": "Юрьевка",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3971046,
            "latitude": 55.2439071
        },
        "7423": {
            "name": "Кирово",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4148713,
            "latitude": 55.6983119
        },
        "7424": {
            "name": "Бормотово",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4292755,
            "latitude": 54.9448043
        },
        "7425": {
            "name": "Хорошеборка",
            "population": 160,
            "type": "hamlet",
            "poly": [
                [
                    85.4129381,
                    55.5202917
                ],
                [
                    85.4157549,
                    55.521377
                ],
                [
                    85.4201759,
                    55.5214656
                ],
                [
                    85.4241665,
                    55.518852
                ],
                [
                    85.429761,
                    55.5192729
                ],
                [
                    85.4307783,
                    55.5194501
                ],
                [
                    85.432891,
                    55.5173902
                ],
                [
                    85.4343385,
                    55.517368
                ],
                [
                    85.4359035,
                    55.5164156
                ],
                [
                    85.4369207,
                    55.5148428
                ],
                [
                    85.4424371,
                    55.5163713
                ],
                [
                    85.4457626,
                    55.5163934
                ],
                [
                    85.4479144,
                    55.5159283
                ],
                [
                    85.4460364,
                    55.514577
                ],
                [
                    85.4428283,
                    55.5144884
                ],
                [
                    85.4360991,
                    55.5132479
                ],
                [
                    85.4328127,
                    55.514577
                ],
                [
                    85.4318738,
                    55.5139789
                ],
                [
                    85.4276093,
                    55.5144663
                ],
                [
                    85.4269442,
                    55.5136024
                ],
                [
                    85.4258879,
                    55.5140011
                ],
                [
                    85.42847,
                    55.516482
                ],
                [
                    85.4272181,
                    55.5173016
                ],
                [
                    85.4243621,
                    55.5161055
                ],
                [
                    85.4233449,
                    55.5160169
                ],
                [
                    85.4185327,
                    55.5174123
                ],
                [
                    85.4144248,
                    55.517656
                ],
                [
                    85.4130163,
                    55.5189406
                ],
                [
                    85.4129381,
                    55.5202917
                ]
            ],
            "longitude": 85.4294584,
            "latitude": 55.5178413
        },
        "7426": {
            "name": "Сураново",
            "population": 234,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4377795,
            "latitude": 56.1704416
        },
        "7427": {
            "name": "Ранний",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4407868,
            "latitude": 54.8880507
        },
        "7428": {
            "name": "Хопкино",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4433989,
            "latitude": 55.9414464
        },
        "7429": {
            "name": "Подкопенная",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.450554,
            "latitude": 54.459839
        },
        "7430": {
            "name": "Пархаевка",
            "population": 245,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4647345,
            "latitude": 54.6987189
        },
        "7431": {
            "name": "Копылово",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4747291,
            "latitude": 55.6562016
        },
        "7432": {
            "name": "Нижнеяшкино",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4790659,
            "latitude": 55.8278418
        },
        "7433": {
            "name": "96 км",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    85.4860732,
                    55.2494445
                ],
                [
                    85.4869003,
                    55.253651
                ],
                [
                    85.4883636,
                    55.2541224
                ],
                [
                    85.4883636,
                    55.2552828
                ],
                [
                    85.4900815,
                    55.2552828
                ],
                [
                    85.4900179,
                    55.254485
                ],
                [
                    85.4944078,
                    55.2522731
                ],
                [
                    85.4944715,
                    55.2502423
                ],
                [
                    85.4966983,
                    55.2503148
                ],
                [
                    85.4982251,
                    55.2497708
                ],
                [
                    85.4998794,
                    55.2498434
                ],
                [
                    85.5008974,
                    55.2491906
                ],
                [
                    85.498098,
                    55.2485015
                ],
                [
                    85.4910994,
                    55.2485015
                ],
                [
                    85.4860732,
                    55.2494445
                ]
            ],
            "longitude": 85.4903377,
            "latitude": 55.2506052
        },
        "7434": {
            "name": "Терехино",
            "population": 236,
            "type": "hamlet",
            "poly": [
                [
                    85.4838936,
                    55.3458433
                ],
                [
                    85.4895733,
                    55.3479963
                ],
                [
                    85.49178,
                    55.3493773
                ],
                [
                    85.4931463,
                    55.3495677
                ],
                [
                    85.4937881,
                    55.3492695
                ],
                [
                    85.4953698,
                    55.3492625
                ],
                [
                    85.4961638,
                    55.3502183
                ],
                [
                    85.4975764,
                    55.3498556
                ],
                [
                    85.4988672,
                    55.3503449
                ],
                [
                    85.4979206,
                    55.3513234
                ],
                [
                    85.4993479,
                    55.3518556
                ],
                [
                    85.5008387,
                    55.3518556
                ],
                [
                    85.5013394,
                    55.3520832
                ],
                [
                    85.5048383,
                    55.3515037
                ],
                [
                    85.5043363,
                    55.351054
                ],
                [
                    85.50461,
                    55.3506994
                ],
                [
                    85.5055533,
                    55.3503102
                ],
                [
                    85.5047774,
                    55.3485803
                ],
                [
                    85.505083,
                    55.3482831
                ],
                [
                    85.5047066,
                    55.3481792
                ],
                [
                    85.503996,
                    55.3463075
                ],
                [
                    85.501775,
                    55.3435047
                ],
                [
                    85.4954769,
                    55.3423628
                ],
                [
                    85.4948989,
                    55.3427781
                ],
                [
                    85.4936211,
                    55.3423586
                ],
                [
                    85.4928681,
                    55.3428908
                ],
                [
                    85.4922012,
                    55.3431844
                ],
                [
                    85.4911185,
                    55.3426821
                ],
                [
                    85.4885628,
                    55.3426734
                ],
                [
                    85.4853225,
                    55.3442392
                ],
                [
                    85.4838936,
                    55.3458433
                ]
            ],
            "longitude": 85.4951218,
            "latitude": 55.346763
        },
        "7435": {
            "name": "Колмаково",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4961782,
            "latitude": 55.6918613
        },
        "7436": {
            "name": "Пушкино",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4985642,
            "latitude": 54.7758092
        },
        "7437": {
            "name": "Соломино",
            "population": 102,
            "type": "hamlet",
            "poly": [
                [
                    85.4792735,
                    55.2995456
                ],
                [
                    85.4965818,
                    55.3089762
                ],
                [
                    85.4988941,
                    55.3109848
                ],
                [
                    85.4968252,
                    55.3137033
                ],
                [
                    85.5009096,
                    55.3148358
                ],
                [
                    85.5038356,
                    55.3125831
                ],
                [
                    85.5047821,
                    55.3092037
                ],
                [
                    85.5093336,
                    55.3084931
                ],
                [
                    85.5105658,
                    55.30748
                ],
                [
                    85.5080339,
                    55.3061746
                ],
                [
                    85.5091096,
                    55.3050847
                ],
                [
                    85.5118633,
                    55.3052684
                ],
                [
                    85.5121215,
                    55.30435
                ],
                [
                    85.5095829,
                    55.3037867
                ],
                [
                    85.5083781,
                    55.3050847
                ],
                [
                    85.5077435,
                    55.3057276
                ],
                [
                    85.5064322,
                    55.3049604
                ],
                [
                    85.5070102,
                    55.3037994
                ],
                [
                    85.5079468,
                    55.3029353
                ],
                [
                    85.5085708,
                    55.3027026
                ],
                [
                    85.5080868,
                    55.3020168
                ],
                [
                    85.5030607,
                    55.3007171
                ],
                [
                    85.4966926,
                    55.2990515
                ],
                [
                    85.4912712,
                    55.2988065
                ],
                [
                    85.487958,
                    55.2980716
                ],
                [
                    85.4871835,
                    55.2975327
                ],
                [
                    85.4840425,
                    55.2975327
                ],
                [
                    85.4792735,
                    55.2995456
                ]
            ],
            "longitude": 85.501122,
            "latitude": 55.304981
        },
        "7438": {
            "name": "Цыпино",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.5038493,
            "latitude": 55.1423843
        },
        "7439": {
            "name": "Подкопенная",
            "population": 105,
            "type": "hamlet",
            "poly": [
                [
                    85.5080565,
                    55.0207042
                ],
                [
                    85.5089277,
                    55.0208949
                ],
                [
                    85.5080565,
                    55.0213671
                ],
                [
                    85.508217,
                    55.0219366
                ],
                [
                    85.5088808,
                    55.021935
                ],
                [
                    85.5080943,
                    55.0245772
                ],
                [
                    85.5084111,
                    55.0249494
                ],
                [
                    85.5105652,
                    55.0250765
                ],
                [
                    85.5096148,
                    55.0262386
                ],
                [
                    85.5105413,
                    55.0264384
                ],
                [
                    85.5114679,
                    55.0254651
                ],
                [
                    85.5122916,
                    55.0249657
                ],
                [
                    85.5118085,
                    55.0247887
                ],
                [
                    85.5123499,
                    55.0224913
                ],
                [
                    85.5168086,
                    55.0223965
                ],
                [
                    85.5175758,
                    55.0227018
                ],
                [
                    85.5178767,
                    55.0224657
                ],
                [
                    85.5204584,
                    55.022493
                ],
                [
                    85.5205693,
                    55.0215668
                ],
                [
                    85.5201258,
                    55.0213852
                ],
                [
                    85.5201892,
                    55.0209403
                ],
                [
                    85.5177183,
                    55.0208223
                ],
                [
                    85.5174966,
                    55.0190062
                ],
                [
                    85.5155484,
                    55.0190062
                ],
                [
                    85.5141229,
                    55.0192695
                ],
                [
                    85.5141862,
                    55.0203864
                ],
                [
                    85.5134735,
                    55.020341
                ],
                [
                    85.5118262,
                    55.020341
                ],
                [
                    85.5117786,
                    55.0190879
                ],
                [
                    85.5103849,
                    55.0190789
                ],
                [
                    85.5102423,
                    55.0205136
                ],
                [
                    85.5093078,
                    55.0202139
                ],
                [
                    85.5080565,
                    55.0207042
                ]
            ],
            "longitude": 85.5143556,
            "latitude": 55.0216642
        },
        "7440": {
            "name": "Новый Исток",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.5491481,
            "latitude": 54.9486149
        },
        "7441": {
            "name": "Синеречка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.5502469,
            "latitude": 55.7216989
        },
        "7442": {
            "name": "Колбиха",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.5595392,
            "latitude": 55.6740703
        },
        "7443": {
            "name": "Кочкуровка",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.566208,
            "latitude": 54.395863
        },
        "7444": {
            "name": "Понтряжка",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.572716,
            "latitude": 54.39864
        },
        "7445": {
            "name": "Бурухино",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    85.566031,
                    55.130997
                ],
                [
                    85.5724775,
                    55.1324544
                ],
                [
                    85.5759059,
                    55.1318513
                ],
                [
                    85.5774296,
                    55.1309635
                ],
                [
                    85.5785191,
                    55.1309441
                ],
                [
                    85.5802492,
                    55.1304703
                ],
                [
                    85.5802078,
                    55.1301801
                ],
                [
                    85.5781565,
                    55.1291494
                ],
                [
                    85.5760844,
                    55.1297418
                ],
                [
                    85.5744183,
                    55.1287467
                ],
                [
                    85.573631,
                    55.1287348
                ],
                [
                    85.572367,
                    55.1291258
                ],
                [
                    85.5716626,
                    55.1287348
                ],
                [
                    85.5699843,
                    55.1294219
                ],
                [
                    85.5723256,
                    55.1309263
                ],
                [
                    85.5670421,
                    55.1291968
                ],
                [
                    85.566031,
                    55.130997
                ]
            ],
            "longitude": 85.5746342,
            "latitude": 55.13058
        },
        "7446": {
            "name": "Морковкино",
            "population": 174,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6178998,
            "latitude": 55.7063484
        },
        "7447": {
            "name": "Дружный",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.620277,
            "latitude": 54.664204
        },
        "7448": {
            "name": "Медынино",
            "population": 165,
            "type": "hamlet",
            "poly": [
                [
                    85.6014038,
                    55.5453625
                ],
                [
                    85.6036098,
                    55.5462821
                ],
                [
                    85.6047128,
                    55.546085
                ],
                [
                    85.6133627,
                    55.5493363
                ],
                [
                    85.6129562,
                    55.5505186
                ],
                [
                    85.6156267,
                    55.5515366
                ],
                [
                    85.6165556,
                    55.5512082
                ],
                [
                    85.6187966,
                    55.5516156
                ],
                [
                    85.6207259,
                    55.5529972
                ],
                [
                    85.6227825,
                    55.5556189
                ],
                [
                    85.6257741,
                    55.5582627
                ],
                [
                    85.6276111,
                    55.5593974
                ],
                [
                    85.6271082,
                    55.5599662
                ],
                [
                    85.6284936,
                    55.5608483
                ],
                [
                    85.6298277,
                    55.5603492
                ],
                [
                    85.6304845,
                    55.5609006
                ],
                [
                    85.629879,
                    55.5612778
                ],
                [
                    85.6302793,
                    55.5619046
                ],
                [
                    85.6317468,
                    55.5627635
                ],
                [
                    85.6320956,
                    55.5627113
                ],
                [
                    85.6328859,
                    55.5621251
                ],
                [
                    85.6341994,
                    55.5628622
                ],
                [
                    85.6332964,
                    55.5637675
                ],
                [
                    85.6347434,
                    55.5643884
                ],
                [
                    85.6361289,
                    55.5635236
                ],
                [
                    85.6348974,
                    55.5627866
                ],
                [
                    85.6363034,
                    55.5616607
                ],
                [
                    85.637032,
                    55.5597165
                ],
                [
                    85.6366523,
                    55.5582945
                ],
                [
                    85.632691,
                    55.5580565
                ],
                [
                    85.6314595,
                    55.557273
                ],
                [
                    85.629951,
                    55.554452
                ],
                [
                    85.6232598,
                    55.5496223
                ],
                [
                    85.6211664,
                    55.5496455
                ],
                [
                    85.6178003,
                    55.5484148
                ],
                [
                    85.6164046,
                    55.5473465
                ],
                [
                    85.6135721,
                    55.5466034
                ],
                [
                    85.6100009,
                    55.545837
                ],
                [
                    85.6089747,
                    55.545419
                ],
                [
                    85.6068812,
                    55.5433288
                ],
                [
                    85.6054034,
                    55.5427714
                ],
                [
                    85.6047055,
                    55.543143
                ],
                [
                    85.605075,
                    55.5437004
                ],
                [
                    85.6014038,
                    55.5453625
                ]
            ],
            "longitude": 85.6233187,
            "latitude": 55.5524664
        },
        "7449": {
            "name": "Писаная",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.629982,
            "latitude": 55.66119
        },
        "7450": {
            "name": "Корниловка",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    85.6285805,
                    55.1239398
                ],
                [
                    85.6353831,
                    55.1332298
                ],
                [
                    85.6342618,
                    55.1343251
                ],
                [
                    85.635211,
                    55.1350313
                ],
                [
                    85.6424465,
                    55.1338553
                ],
                [
                    85.6402638,
                    55.1319314
                ],
                [
                    85.6401433,
                    55.1306782
                ],
                [
                    85.6380893,
                    55.1313236
                ],
                [
                    85.6352865,
                    55.1274832
                ],
                [
                    85.636253,
                    55.1265162
                ],
                [
                    85.6309372,
                    55.1232003
                ],
                [
                    85.6285805,
                    55.1239398
                ]
            ],
            "longitude": 85.6351002,
            "latitude": 55.129827
        },
        "7451": {
            "name": "Осиновая Грива",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    85.6307267,
                    55.1881649
                ],
                [
                    85.6318599,
                    55.1894089
                ],
                [
                    85.6357825,
                    55.1899812
                ],
                [
                    85.6339084,
                    55.1903792
                ],
                [
                    85.6338648,
                    55.1914491
                ],
                [
                    85.632165,
                    55.1925437
                ],
                [
                    85.6376984,
                    55.1965234
                ],
                [
                    85.6468233,
                    55.191955
                ],
                [
                    85.6500593,
                    55.1935382
                ],
                [
                    85.6509838,
                    55.193679
                ],
                [
                    85.6527097,
                    55.1920781
                ],
                [
                    85.6507155,
                    55.1913291
                ],
                [
                    85.6472431,
                    55.1893784
                ],
                [
                    85.6456921,
                    55.1902032
                ],
                [
                    85.6441269,
                    55.1916424
                ],
                [
                    85.6427245,
                    55.1918582
                ],
                [
                    85.6396581,
                    55.1912337
                ],
                [
                    85.638225,
                    55.1914272
                ],
                [
                    85.6394115,
                    55.1898615
                ],
                [
                    85.6377966,
                    55.1889646
                ],
                [
                    85.6385853,
                    55.1885674
                ],
                [
                    85.6409436,
                    55.1865779
                ],
                [
                    85.6418371,
                    55.1867189
                ],
                [
                    85.6424073,
                    55.186323
                ],
                [
                    85.6429466,
                    55.1862702
                ],
                [
                    85.6437712,
                    55.1859254
                ],
                [
                    85.6492628,
                    55.1887868
                ],
                [
                    85.6547817,
                    55.1900615
                ],
                [
                    85.6543185,
                    55.1885131
                ],
                [
                    85.6449164,
                    55.1840982
                ],
                [
                    85.6366438,
                    55.183249
                ],
                [
                    85.6354419,
                    55.1836185
                ],
                [
                    85.6353494,
                    55.1845686
                ],
                [
                    85.6324874,
                    55.1851393
                ],
                [
                    85.6342399,
                    55.1860642
                ],
                [
                    85.6334847,
                    55.1871535
                ],
                [
                    85.6320016,
                    55.1880156
                ],
                [
                    85.6313055,
                    55.187732
                ],
                [
                    85.6307267,
                    55.1881649
                ]
            ],
            "longitude": 85.6371235,
            "latitude": 55.1869918
        },
        "7452": {
            "name": "Миничево",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6506948,
            "latitude": 55.7331806
        },
        "7453": {
            "name": "Корбелкино",
            "population": 83,
            "type": "hamlet",
            "poly": [
                [
                    85.6439089,
                    55.0461858
                ],
                [
                    85.6454654,
                    55.0472706
                ],
                [
                    85.6440033,
                    55.0479139
                ],
                [
                    85.6451541,
                    55.0487864
                ],
                [
                    85.6457248,
                    55.0485932
                ],
                [
                    85.6471161,
                    55.0494297
                ],
                [
                    85.6488281,
                    55.048865
                ],
                [
                    85.6498138,
                    55.0496674
                ],
                [
                    85.6507995,
                    55.0495188
                ],
                [
                    85.6562469,
                    55.0518963
                ],
                [
                    85.6620573,
                    55.0499646
                ],
                [
                    85.6624205,
                    55.0492216
                ],
                [
                    85.6633024,
                    55.0497269
                ],
                [
                    85.6640026,
                    55.0491001
                ],
                [
                    85.6630121,
                    55.0482805
                ],
                [
                    85.6631772,
                    55.0477656
                ],
                [
                    85.6637825,
                    55.0479442
                ],
                [
                    85.6651215,
                    55.0475449
                ],
                [
                    85.6642777,
                    55.0471877
                ],
                [
                    85.6651215,
                    55.0465677
                ],
                [
                    85.6641493,
                    55.0461473
                ],
                [
                    85.6636357,
                    55.0465046
                ],
                [
                    85.6593436,
                    55.0451428
                ],
                [
                    85.6589034,
                    55.0448066
                ],
                [
                    85.6568642,
                    55.0453222
                ],
                [
                    85.6554742,
                    55.0448365
                ],
                [
                    85.6558043,
                    55.0443216
                ],
                [
                    85.6541352,
                    55.0436069
                ],
                [
                    85.6534566,
                    55.0443531
                ],
                [
                    85.6524936,
                    55.0444372
                ],
                [
                    85.6511979,
                    55.0444024
                ],
                [
                    85.6501605,
                    55.0438376
                ],
                [
                    85.6487857,
                    55.0450266
                ],
                [
                    85.6491488,
                    55.0451603
                ],
                [
                    85.6475923,
                    55.0456359
                ],
                [
                    85.6469958,
                    55.0453535
                ],
                [
                    85.6460101,
                    55.0456656
                ],
                [
                    85.6454913,
                    55.0452347
                ],
                [
                    85.6439089,
                    55.0461858
                ]
            ],
            "longitude": 85.656083,
            "latitude": 55.0463621
        },
        "7454": {
            "name": "Покровка",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.66848,
            "latitude": 54.552456
        },
        "7455": {
            "name": "Печёркино",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.690002,
            "latitude": 54.420929
        },
        "7456": {
            "name": "Усть-Стрелина",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6955141,
            "latitude": 55.6127466
        },
        "7457": {
            "name": "Знаменский",
            "population": 200,
            "type": "hamlet",
            "poly": [
                [
                    85.6899582,
                    55.1935039
                ],
                [
                    85.6938547,
                    55.1949768
                ],
                [
                    85.6931813,
                    55.1960254
                ],
                [
                    85.6951798,
                    55.1966538
                ],
                [
                    85.6952122,
                    55.1969866
                ],
                [
                    85.6957788,
                    55.1972454
                ],
                [
                    85.6960866,
                    55.1969866
                ],
                [
                    85.6970906,
                    55.1973932
                ],
                [
                    85.6975456,
                    55.1979515
                ],
                [
                    85.7004942,
                    55.1965184
                ],
                [
                    85.6998802,
                    55.196239
                ],
                [
                    85.7003153,
                    55.1956116
                ],
                [
                    85.7000796,
                    55.1951011
                ],
                [
                    85.6987841,
                    55.1942692
                ],
                [
                    85.6993347,
                    55.1936407
                ],
                [
                    85.7005214,
                    55.1932195
                ],
                [
                    85.7009856,
                    55.1927069
                ],
                [
                    85.699697,
                    55.1922261
                ],
                [
                    85.6982543,
                    55.192213
                ],
                [
                    85.6941656,
                    55.1905932
                ],
                [
                    85.6927352,
                    55.1915071
                ],
                [
                    85.6918879,
                    55.1915202
                ],
                [
                    85.6904452,
                    55.1923699
                ],
                [
                    85.6911092,
                    55.1927882
                ],
                [
                    85.6899582,
                    55.1935039
                ]
            ],
            "longitude": 85.6968745,
            "latitude": 55.1935397
        },
        "7458": {
            "name": "Торопово",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.69973,
            "latitude": 54.681923
        },
        "7459": {
            "name": "Портнягино",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7034505,
            "latitude": 54.9664938
        },
        "7460": {
            "name": "Чуваш-Пай",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.704651,
            "latitude": 54.327705
        },
        "7461": {
            "name": "Южный",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.717598,
            "latitude": 54.586262
        },
        "7462": {
            "name": "115 км",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7320822,
            "latitude": 55.2473647
        },
        "7463": {
            "name": "Заречный",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.734322,
            "latitude": 54.273495
        },
        "7464": {
            "name": "Орловский",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.736137,
            "latitude": 54.795639
        },
        "7465": {
            "name": "Пещерка",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.73893,
            "latitude": 55.620872
        },
        "7466": {
            "name": "Дедюево",
            "population": 136,
            "type": "hamlet",
            "poly": [
                [
                    85.7164163,
                    55.3718721
                ],
                [
                    85.717625,
                    55.3730261
                ],
                [
                    85.7237785,
                    55.373464
                ],
                [
                    85.7321417,
                    55.3730132
                ],
                [
                    85.7346576,
                    55.3724079
                ],
                [
                    85.7356927,
                    55.3709963
                ],
                [
                    85.7372339,
                    55.36985
                ],
                [
                    85.7385786,
                    55.3684281
                ],
                [
                    85.7396665,
                    55.3689433
                ],
                [
                    85.7396591,
                    55.3701977
                ],
                [
                    85.7399764,
                    55.3705841
                ],
                [
                    85.7395759,
                    55.3724981
                ],
                [
                    85.7411171,
                    55.3724465
                ],
                [
                    85.741933,
                    55.3713647
                ],
                [
                    85.7435574,
                    55.3708804
                ],
                [
                    85.7451061,
                    55.3701154
                ],
                [
                    85.7454159,
                    55.3696053
                ],
                [
                    85.7449248,
                    55.3690978
                ],
                [
                    85.7469646,
                    55.3674492
                ],
                [
                    85.7476672,
                    55.3677325
                ],
                [
                    85.7509989,
                    55.3656974
                ],
                [
                    85.7495484,
                    55.3641516
                ],
                [
                    85.7465792,
                    55.3629922
                ],
                [
                    85.7478485,
                    55.3621162
                ],
                [
                    85.7487951,
                    55.361925
                ],
                [
                    85.7497583,
                    55.3618906
                ],
                [
                    85.7510465,
                    55.3612042
                ],
                [
                    85.7510789,
                    55.3606406
                ],
                [
                    85.7514522,
                    55.3602869
                ],
                [
                    85.7519203,
                    55.3601487
                ],
                [
                    85.7525934,
                    55.3601851
                ],
                [
                    85.7534678,
                    55.360663
                ],
                [
                    85.7540652,
                    55.3601794
                ],
                [
                    85.7539396,
                    55.3590509
                ],
                [
                    85.750529,
                    55.3587919
                ],
                [
                    85.75055,
                    55.3593425
                ],
                [
                    85.7491747,
                    55.3595981
                ],
                [
                    85.7461297,
                    55.3592656
                ],
                [
                    85.7445591,
                    55.3595753
                ],
                [
                    85.741482,
                    55.3572978
                ],
                [
                    85.7364114,
                    55.3579216
                ],
                [
                    85.7302693,
                    55.3613485
                ],
                [
                    85.7164163,
                    55.3718721
                ]
            ],
            "longitude": 85.7408832,
            "latitude": 55.3642128
        },
        "7467": {
            "name": "123 км",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7424251,
            "latitude": 55.182837
        },
        "7468": {
            "name": "13 км",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7527091,
            "latitude": 55.3372184
        },
        "7469": {
            "name": "Дедюево",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7580068,
            "latitude": 55.3394407
        },
        "7470": {
            "name": "Известковый",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.761322,
            "latitude": 55.597027
        },
        "7471": {
            "name": "Каменушка",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.767845,
            "latitude": 54.300526
        },
        "7472": {
            "name": "239 км",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7743467,
            "latitude": 54.8756604
        },
        "7473": {
            "name": "Салаирский Дом Отдыха",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.783859,
            "latitude": 54.276772
        },
        "7474": {
            "name": "Новоподиково",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.784195,
            "latitude": 55.680389
        },
        "7475": {
            "name": "Уньга",
            "population": 39,
            "type": "hamlet",
            "poly": [
                [
                    85.782241,
                    55.2132882
                ],
                [
                    85.7827151,
                    55.2142686
                ],
                [
                    85.7858852,
                    55.2132206
                ],
                [
                    85.7860106,
                    55.2140495
                ],
                [
                    85.7842194,
                    55.2147009
                ],
                [
                    85.7849075,
                    55.2179025
                ],
                [
                    85.7891146,
                    55.2170912
                ],
                [
                    85.7892331,
                    55.2176827
                ],
                [
                    85.7914256,
                    55.2175982
                ],
                [
                    85.7909219,
                    55.2142517
                ],
                [
                    85.790122,
                    55.2142517
                ],
                [
                    85.7900923,
                    55.2135924
                ],
                [
                    85.7907441,
                    55.2133896
                ],
                [
                    85.7896775,
                    55.2097891
                ],
                [
                    85.7863593,
                    55.2100596
                ],
                [
                    85.7859741,
                    55.2121726
                ],
                [
                    85.782241,
                    55.2132882
                ]
            ],
            "longitude": 85.7867246,
            "latitude": 55.215061
        },
        "7476": {
            "name": "Подонино",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7927137,
            "latitude": 55.5765474
        },
        "7477": {
            "name": "130 км",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7987114,
            "latitude": 55.1393723
        },
        "7478": {
            "name": "Карьер (Белая Глинка)",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.808708,
            "latitude": 54.715122
        },
        "7479": {
            "name": "Каменный Брод",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.808853,
            "latitude": 55.981026
        },
        "7480": {
            "name": "Михайловка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    85.8044867,
                    56.2725011
                ],
                [
                    85.8051678,
                    56.2734256
                ],
                [
                    85.8095574,
                    56.274182
                ],
                [
                    85.8133162,
                    56.2755686
                ],
                [
                    85.8187401,
                    56.2762269
                ],
                [
                    85.8193961,
                    56.2753445
                ],
                [
                    85.817504,
                    56.2748263
                ],
                [
                    85.8150065,
                    56.2747422
                ],
                [
                    85.813619,
                    56.2746582
                ],
                [
                    85.8078167,
                    56.2728513
                ],
                [
                    85.8080185,
                    56.2723891
                ],
                [
                    85.8073626,
                    56.272221
                ],
                [
                    85.8078419,
                    56.2717027
                ],
                [
                    85.8068833,
                    56.2714366
                ],
                [
                    85.8064292,
                    56.2720669
                ],
                [
                    85.8059246,
                    56.2718988
                ],
                [
                    85.805521,
                    56.2721509
                ],
                [
                    85.8050417,
                    56.2719828
                ],
                [
                    85.8044867,
                    56.2725011
                ]
            ],
            "longitude": 85.8112728,
            "latitude": 56.274266
        },
        "7481": {
            "name": "Соколовка",
            "population": 150,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.818161,
            "latitude": 54.701107
        },
        "7482": {
            "name": "Октябрьский",
            "population": 254,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8194603,
            "latitude": 54.9798227
        },
        "7483": {
            "name": "Крутовка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.821121,
            "latitude": 55.980465
        },
        "7484": {
            "name": "Семёновский",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    85.8241372,
                    55.4848687
                ],
                [
                    85.8249222,
                    55.4871094
                ],
                [
                    85.8285657,
                    55.488259
                ],
                [
                    85.8319726,
                    55.4894711
                ],
                [
                    85.8333865,
                    55.489756
                ],
                [
                    85.8341929,
                    55.4877978
                ],
                [
                    85.8345176,
                    55.4860058
                ],
                [
                    85.837642,
                    55.485509
                ],
                [
                    85.8372569,
                    55.483562
                ],
                [
                    85.834502,
                    55.4797348
                ],
                [
                    85.8305327,
                    55.47767
                ],
                [
                    85.8266059,
                    55.4778145
                ],
                [
                    85.8272343,
                    55.4795238
                ],
                [
                    85.8254554,
                    55.4821831
                ],
                [
                    85.8260923,
                    55.4825523
                ],
                [
                    85.8241372,
                    55.4848687
                ]
            ],
            "longitude": 85.826683,
            "latitude": 55.4846
        },
        "7485": {
            "name": "Подъяково",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.828003,
            "latitude": 55.565578
        },
        "7486": {
            "name": "Гавриловка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.834839,
            "latitude": 54.26075
        },
        "7487": {
            "name": "Пихтач",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8421375,
            "latitude": 56.0516213
        },
        "7488": {
            "name": "Мостовая",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.845612,
            "latitude": 54.462322
        },
        "7489": {
            "name": "137 км",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8478087,
            "latitude": 55.0921099
        },
        "7490": {
            "name": "Ушаково",
            "population": 219,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8565115,
            "latitude": 54.9298911
        },
        "7491": {
            "name": "Буреничево",
            "population": 193,
            "type": "hamlet",
            "poly": [
                [
                    85.8623308,
                    55.3567634
                ],
                [
                    85.863242,
                    55.3591591
                ],
                [
                    85.8635838,
                    55.3602598
                ],
                [
                    85.8655962,
                    55.3602598
                ],
                [
                    85.8667351,
                    55.362418
                ],
                [
                    85.863356,
                    55.3647055
                ],
                [
                    85.8638496,
                    55.366626
                ],
                [
                    85.8626346,
                    55.3679207
                ],
                [
                    85.8630484,
                    55.3687131
                ],
                [
                    85.8642633,
                    55.3687562
                ],
                [
                    85.8654404,
                    55.3685836
                ],
                [
                    85.8679083,
                    55.3686915
                ],
                [
                    85.8674527,
                    55.3672458
                ],
                [
                    85.8713255,
                    55.3630594
                ],
                [
                    85.8723885,
                    55.3632536
                ],
                [
                    85.8734896,
                    55.3629084
                ],
                [
                    85.8737555,
                    55.3622609
                ],
                [
                    85.8744769,
                    55.362671
                ],
                [
                    85.8762993,
                    55.3660806
                ],
                [
                    85.880438,
                    55.3653469
                ],
                [
                    85.8826021,
                    55.3631673
                ],
                [
                    85.8792989,
                    55.3574481
                ],
                [
                    85.8808177,
                    55.3570812
                ],
                [
                    85.8803736,
                    55.3553647
                ],
                [
                    85.8798903,
                    55.3554105
                ],
                [
                    85.8798635,
                    55.3556471
                ],
                [
                    85.8794205,
                    55.3557157
                ],
                [
                    85.8789238,
                    55.3550442
                ],
                [
                    85.8782526,
                    55.3551663
                ],
                [
                    85.8784674,
                    55.3555097
                ],
                [
                    85.8737958,
                    55.3559142
                ],
                [
                    85.8715809,
                    55.3550289
                ],
                [
                    85.8637679,
                    55.3553903
                ],
                [
                    85.8642711,
                    55.3558012
                ],
                [
                    85.863889,
                    55.3564789
                ],
                [
                    85.8623308,
                    55.3567634
                ]
            ],
            "longitude": 85.869865,
            "latitude": 55.357933
        },
        "7492": {
            "name": "Низовка",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.871193,
            "latitude": 55.957508
        },
        "7493": {
            "name": "Дегтярёвка",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.873489,
            "latitude": 54.456318
        },
        "7494": {
            "name": "Ракитный",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.875061,
            "latitude": 54.698624
        },
        "7495": {
            "name": "Новоникольское",
            "population": 13,
            "type": "hamlet",
            "poly": [
                [
                    85.873045,
                    56.3519749
                ],
                [
                    85.8754474,
                    56.3545298
                ],
                [
                    85.8759124,
                    56.3568484
                ],
                [
                    85.8762741,
                    56.3569343
                ],
                [
                    85.8767649,
                    56.3572778
                ],
                [
                    85.8768424,
                    56.3575282
                ],
                [
                    85.8767907,
                    56.3578932
                ],
                [
                    85.8771007,
                    56.3578645
                ],
                [
                    85.8774753,
                    56.3579075
                ],
                [
                    85.8775657,
                    56.3582939
                ],
                [
                    85.8773202,
                    56.3586302
                ],
                [
                    85.8774236,
                    56.3590309
                ],
                [
                    85.877514,
                    56.3594173
                ],
                [
                    85.876752,
                    56.3598252
                ],
                [
                    85.8766486,
                    56.3599826
                ],
                [
                    85.8785344,
                    56.3599969
                ],
                [
                    85.8788186,
                    56.3598538
                ],
                [
                    85.8788703,
                    56.3594889
                ],
                [
                    85.8791286,
                    56.3592384
                ],
                [
                    85.8794644,
                    56.359174
                ],
                [
                    85.8799036,
                    56.3593171
                ],
                [
                    85.8800198,
                    56.3597536
                ],
                [
                    85.880291,
                    56.3599039
                ],
                [
                    85.8804202,
                    56.3594745
                ],
                [
                    85.8807432,
                    56.359267
                ],
                [
                    85.8813115,
                    56.3580148
                ],
                [
                    85.882616,
                    56.3577787
                ],
                [
                    85.8834944,
                    56.3581221
                ],
                [
                    85.8846439,
                    56.3587876
                ],
                [
                    85.8871884,
                    56.357471
                ],
                [
                    85.8846052,
                    56.3562545
                ],
                [
                    85.8841142,
                    56.3561113
                ],
                [
                    85.8824869,
                    56.3554458
                ],
                [
                    85.8820865,
                    56.3549592
                ],
                [
                    85.8812081,
                    56.3544439
                ],
                [
                    85.8804719,
                    56.3537855
                ],
                [
                    85.8791544,
                    56.3525403
                ],
                [
                    85.8777724,
                    56.3517387
                ],
                [
                    85.874892,
                    56.3513809
                ],
                [
                    85.873045,
                    56.3519749
                ]
            ],
            "longitude": 85.8789575,
            "latitude": 56.3557551
        },
        "7496": {
            "name": "Крёково",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.879263,
            "latitude": 55.5179779
        },
        "7497": {
            "name": "Контрольная",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.880206,
            "latitude": 54.8605124
        },
        "7498": {
            "name": "Соболинка",
            "population": 56,
            "type": "hamlet",
            "poly": [
                [
                    85.8713733,
                    56.2722843
                ],
                [
                    85.8768029,
                    56.2743872
                ],
                [
                    85.8876399,
                    56.2704587
                ],
                [
                    85.8866727,
                    56.2697059
                ],
                [
                    85.8890204,
                    56.2688292
                ],
                [
                    85.8894667,
                    56.2691734
                ],
                [
                    85.8917483,
                    56.2682554
                ],
                [
                    85.8918805,
                    56.2679386
                ],
                [
                    85.893691,
                    56.2670389
                ],
                [
                    85.895741,
                    56.2667359
                ],
                [
                    85.8991138,
                    56.2650695
                ],
                [
                    85.8987087,
                    56.2647894
                ],
                [
                    85.8994196,
                    56.2643762
                ],
                [
                    85.8996511,
                    56.2639952
                ],
                [
                    85.9006348,
                    56.2634856
                ],
                [
                    85.9012879,
                    56.2639217
                ],
                [
                    85.9027344,
                    56.263178
                ],
                [
                    85.9024534,
                    56.2629438
                ],
                [
                    85.9022881,
                    56.2630127
                ],
                [
                    85.9007671,
                    56.2622276
                ],
                [
                    85.898919,
                    56.2630342
                ],
                [
                    85.8966715,
                    56.2610112
                ],
                [
                    85.8964003,
                    56.2610184
                ],
                [
                    85.8961549,
                    56.2620586
                ],
                [
                    85.8958061,
                    56.2628477
                ],
                [
                    85.8957545,
                    56.2635005
                ],
                [
                    85.8951603,
                    56.264182
                ],
                [
                    85.894747,
                    56.2643398
                ],
                [
                    85.894437,
                    56.2643541
                ],
                [
                    85.8931841,
                    56.2647343
                ],
                [
                    85.8928612,
                    56.2647128
                ],
                [
                    85.8924091,
                    56.2648563
                ],
                [
                    85.8920345,
                    56.2648419
                ],
                [
                    85.8908715,
                    56.2652112
                ],
                [
                    85.889734,
                    56.2652112
                ],
                [
                    85.8893055,
                    56.2653699
                ],
                [
                    85.8889985,
                    56.2655814
                ],
                [
                    85.8871311,
                    56.2661573
                ],
                [
                    85.8854434,
                    56.2668036
                ],
                [
                    85.883179,
                    56.2672649
                ],
                [
                    85.8825812,
                    56.2679729
                ],
                [
                    85.8817928,
                    56.2684048
                ],
                [
                    85.8791317,
                    56.2689953
                ],
                [
                    85.8760232,
                    56.270104
                ],
                [
                    85.8745145,
                    56.2710909
                ],
                [
                    85.8738326,
                    56.2714926
                ],
                [
                    85.8713733,
                    56.2722843
                ]
            ],
            "longitude": 85.887037,
            "latitude": 56.2684964
        },
        "7499": {
            "name": "Старая Балахонка",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.896172,
            "latitude": 55.538322
        },
        "7500": {
            "name": "Усть-Канда",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.90062,
            "latitude": 54.444176
        },
        "7501": {
            "name": "Нагорный",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9020438,
            "latitude": 55.0634539
        },
        "7502": {
            "name": "Назаровка",
            "population": 75,
            "type": "hamlet",
            "poly": [
                [
                    85.89129,
                    56.24033
                ],
                [
                    85.8924505,
                    56.2407926
                ],
                [
                    85.8937371,
                    56.2401757
                ],
                [
                    85.8954021,
                    56.2385635
                ],
                [
                    85.8969914,
                    56.2380588
                ],
                [
                    85.8982276,
                    56.2371475
                ],
                [
                    85.8990096,
                    56.2372176
                ],
                [
                    85.8986816,
                    56.2367409
                ],
                [
                    85.8990853,
                    56.2366708
                ],
                [
                    85.9003719,
                    56.2370493
                ],
                [
                    85.8996655,
                    56.237512
                ],
                [
                    85.8999178,
                    56.2378906
                ],
                [
                    85.8993628,
                    56.2391804
                ],
                [
                    85.8993628,
                    56.2398673
                ],
                [
                    85.8984545,
                    56.2399655
                ],
                [
                    85.8965878,
                    56.2414655
                ],
                [
                    85.8967644,
                    56.2417178
                ],
                [
                    85.896285,
                    56.2420262
                ],
                [
                    85.896058,
                    56.2418019
                ],
                [
                    85.8954273,
                    56.2423487
                ],
                [
                    85.8959571,
                    56.2426711
                ],
                [
                    85.8955534,
                    56.2430496
                ],
                [
                    85.8962598,
                    56.2434982
                ],
                [
                    85.8980257,
                    56.2427972
                ],
                [
                    85.8988582,
                    56.2428814
                ],
                [
                    85.8997411,
                    56.2419842
                ],
                [
                    85.9010782,
                    56.2412132
                ],
                [
                    85.9020873,
                    56.2412552
                ],
                [
                    85.9060733,
                    56.2420403
                ],
                [
                    85.9082681,
                    56.2428393
                ],
                [
                    85.9088735,
                    56.2432879
                ],
                [
                    85.9104124,
                    56.2424328
                ],
                [
                    85.9121531,
                    56.2417879
                ],
                [
                    85.9139947,
                    56.2409188
                ],
                [
                    85.9119513,
                    56.2391804
                ],
                [
                    85.9121026,
                    56.2387598
                ],
                [
                    85.9115729,
                    56.2386196
                ],
                [
                    85.9104628,
                    56.2376242
                ],
                [
                    85.9122288,
                    56.2363063
                ],
                [
                    85.9133135,
                    56.2362642
                ],
                [
                    85.9178797,
                    56.2346798
                ],
                [
                    85.9185861,
                    56.2342311
                ],
                [
                    85.9197213,
                    56.2342452
                ],
                [
                    85.9188131,
                    56.233502
                ],
                [
                    85.9174508,
                    56.2329412
                ],
                [
                    85.9157858,
                    56.2323102
                ],
                [
                    85.9099078,
                    56.2340629
                ],
                [
                    85.9075112,
                    56.2347359
                ],
                [
                    85.9059976,
                    56.2347219
                ],
                [
                    85.9023901,
                    56.2356473
                ],
                [
                    85.8973698,
                    56.2344835
                ],
                [
                    85.8966887,
                    56.2355491
                ],
                [
                    85.8966887,
                    56.2359417
                ],
                [
                    85.8960832,
                    56.2364465
                ],
                [
                    85.8958562,
                    56.2376382
                ],
                [
                    85.8947462,
                    56.2375541
                ],
                [
                    85.8929046,
                    56.2392785
                ],
                [
                    85.89129,
                    56.24033
                ]
            ],
            "longitude": 85.9065694,
            "latitude": 56.2398637
        },
        "7503": {
            "name": "Емельяновка",
            "population": 251,
            "type": "hamlet",
            "poly": [
                [
                    85.8933463,
                    56.3859271
                ],
                [
                    85.8938761,
                    56.3867232
                ],
                [
                    85.8934472,
                    56.3874494
                ],
                [
                    85.8952384,
                    56.3878264
                ],
                [
                    85.8962223,
                    56.387603
                ],
                [
                    85.9023525,
                    56.3857176
                ],
                [
                    85.9072719,
                    56.3841534
                ],
                [
                    85.9092144,
                    56.3831897
                ],
                [
                    85.9102992,
                    56.3831758
                ],
                [
                    85.9110812,
                    56.3835808
                ],
                [
                    85.912847,
                    56.3827987
                ],
                [
                    85.9124687,
                    56.3824355
                ],
                [
                    85.9134778,
                    56.3821003
                ],
                [
                    85.9135787,
                    56.3818908
                ],
                [
                    85.9166968,
                    56.3805639
                ],
                [
                    85.9147796,
                    56.37929
                ],
                [
                    85.9137099,
                    56.3777144
                ],
                [
                    85.9144768,
                    56.3772115
                ],
                [
                    85.9160712,
                    56.3766862
                ],
                [
                    85.9176656,
                    56.3765968
                ],
                [
                    85.9180288,
                    56.3760157
                ],
                [
                    85.9180692,
                    56.3755128
                ],
                [
                    85.9143759,
                    56.3747752
                ],
                [
                    85.9113486,
                    56.3754234
                ],
                [
                    85.9088057,
                    56.3727188
                ],
                [
                    85.9095676,
                    56.3725176
                ],
                [
                    85.9099712,
                    56.3720845
                ],
                [
                    85.9077764,
                    56.3706455
                ],
                [
                    85.9034121,
                    56.3701146
                ],
                [
                    85.9032859,
                    56.3705896
                ],
                [
                    85.9031093,
                    56.3710367
                ],
                [
                    85.903513,
                    56.371372
                ],
                [
                    85.902958,
                    56.3712742
                ],
                [
                    85.9026805,
                    56.3715396
                ],
                [
                    85.9021507,
                    56.3714139
                ],
                [
                    85.9014191,
                    56.3715396
                ],
                [
                    85.9003091,
                    56.3714418
                ],
                [
                    85.8992496,
                    56.3713999
                ],
                [
                    85.8982152,
                    56.3717632
                ],
                [
                    85.8982152,
                    56.3722661
                ],
                [
                    85.8989216,
                    56.3726853
                ],
                [
                    85.900183,
                    56.3727551
                ],
                [
                    85.9006622,
                    56.3729367
                ],
                [
                    85.9015452,
                    56.3733
                ],
                [
                    85.9027057,
                    56.3734536
                ],
                [
                    85.9039166,
                    56.3731044
                ],
                [
                    85.9044969,
                    56.3733279
                ],
                [
                    85.9053546,
                    56.3746271
                ],
                [
                    85.9056573,
                    56.3758984
                ],
                [
                    85.9053294,
                    56.3766807
                ],
                [
                    85.9037653,
                    56.377407
                ],
                [
                    85.9010659,
                    56.3778401
                ],
                [
                    85.899855,
                    56.3779379
                ],
                [
                    85.8989216,
                    56.3790134
                ],
                [
                    85.8991486,
                    56.3798376
                ],
                [
                    85.897963,
                    56.3808432
                ],
                [
                    85.897408,
                    56.3810109
                ],
                [
                    85.8968277,
                    56.3817651
                ],
                [
                    85.8969791,
                    56.3823936
                ],
                [
                    85.8955411,
                    56.3842652
                ],
                [
                    85.8949609,
                    56.3843769
                ],
                [
                    85.8943554,
                    56.3855082
                ],
                [
                    85.8933463,
                    56.3859271
                ]
            ],
            "longitude": 85.9101322,
            "latitude": 56.379339
        },
        "7504": {
            "name": "Восход",
            "population": 266,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9115527,
            "latitude": 55.0492523
        },
        "7505": {
            "name": "Первомайский",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9147889,
            "latitude": 54.9817067
        },
        "7506": {
            "name": "Денисово",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.932663,
            "latitude": 55.473503
        },
        "7507": {
            "name": "Ивановка",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.944794,
            "latitude": 54.552559
        },
        "7508": {
            "name": "251 км",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9516963,
            "latitude": 54.8487034
        },
        "7509": {
            "name": "Подсобный",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9543378,
            "latitude": 56.2007532
        },
        "7510": {
            "name": "Вотиновка",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.966942,
            "latitude": 55.851952
        },
        "7511": {
            "name": "Сутункин Брод",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.972107,
            "latitude": 55.579975
        },
        "7512": {
            "name": "Тарабарино",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9751527,
            "latitude": 54.859168
        },
        "7513": {
            "name": "Красная Горка",
            "population": 163,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.976868,
            "latitude": 54.700314
        },
        "7514": {
            "name": "Брянский (157 км)",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9795455,
            "latitude": 54.9519272
        },
        "7515": {
            "name": "Заря",
            "population": 89,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.983818,
            "latitude": 55.197262
        },
        "7516": {
            "name": "Саратовка",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.990501,
            "latitude": 54.44611
        },
        "7517": {
            "name": "Цветущий",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9910074,
            "latitude": 54.8967557
        },
        "7518": {
            "name": "Пинигино",
            "population": 233,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9936908,
            "latitude": 55.0853918
        },
        "7519": {
            "name": "Клинцовка",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.994148,
            "latitude": 55.924213
        },
        "7520": {
            "name": "Солнечный",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.995392,
            "latitude": 55.540253
        },
        "7521": {
            "name": "Строительный",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.006935,
            "latitude": 54.843193
        },
        "7522": {
            "name": "Сосновка-2",
            "population": 168,
            "type": "hamlet",
            "poly": [
                [
                    85.9998286,
                    55.8374308
                ],
                [
                    86.002058,
                    55.8388176
                ],
                [
                    86.0025664,
                    55.8398518
                ],
                [
                    86.0024463,
                    55.8412161
                ],
                [
                    86.0062358,
                    55.844727
                ],
                [
                    86.0056618,
                    55.8462785
                ],
                [
                    86.0046873,
                    55.8463234
                ],
                [
                    86.0035542,
                    55.8469005
                ],
                [
                    86.0058904,
                    55.8482027
                ],
                [
                    86.0069918,
                    55.8476593
                ],
                [
                    86.0125319,
                    55.8473408
                ],
                [
                    86.0164034,
                    55.8473502
                ],
                [
                    86.0178385,
                    55.8472471
                ],
                [
                    86.0175048,
                    55.846404
                ],
                [
                    86.0131828,
                    55.8456077
                ],
                [
                    86.0123818,
                    55.8416164
                ],
                [
                    86.0122439,
                    55.8386827
                ],
                [
                    86.0125109,
                    55.8381354
                ],
                [
                    86.0138859,
                    55.8377906
                ],
                [
                    86.0140194,
                    55.8370409
                ],
                [
                    86.0151942,
                    55.8365012
                ],
                [
                    86.0138592,
                    55.8356765
                ],
                [
                    86.0080387,
                    55.8355266
                ],
                [
                    86.0071576,
                    55.8347619
                ],
                [
                    86.0044743,
                    55.8355716
                ],
                [
                    85.9998286,
                    55.8374308
                ]
            ],
            "longitude": 86.008919,
            "latitude": 55.842335
        },
        "7523": {
            "name": "Устюжанино",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.011665,
            "latitude": 54.505615
        },
        "7524": {
            "name": "Новая Балахонка",
            "population": 254,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.02169,
            "latitude": 55.605988
        },
        "7525": {
            "name": "Непрерывка",
            "population": 98,
            "type": "hamlet",
            "poly": [
                [
                    86.0201459,
                    54.7544573
                ],
                [
                    86.0238868,
                    54.7550447
                ],
                [
                    86.0241829,
                    54.7523924
                ],
                [
                    86.0242709,
                    54.7490699
                ],
                [
                    86.0234259,
                    54.7467634
                ],
                [
                    86.0205915,
                    54.7470885
                ],
                [
                    86.0211725,
                    54.7486838
                ],
                [
                    86.0211901,
                    54.7496897
                ],
                [
                    86.0201459,
                    54.7544573
                ]
            ],
            "longitude": 86.021751,
            "latitude": 54.752808
        },
        "7526": {
            "name": "Школьный",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.027245,
            "latitude": 54.783966
        },
        "7527": {
            "name": "Родниковый",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.033966,
            "latitude": 54.401543
        },
        "7528": {
            "name": "Сапогово",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.038712,
            "latitude": 54.728531
        },
        "7529": {
            "name": "Воскресенка (Суровка)",
            "population": 107,
            "type": "hamlet",
            "poly": [
                [
                    86.0278816,
                    56.2598304
                ],
                [
                    86.0283861,
                    56.2604805
                ],
                [
                    86.0297383,
                    56.2606599
                ],
                [
                    86.0302025,
                    56.2604693
                ],
                [
                    86.0326042,
                    56.2599313
                ],
                [
                    86.0331491,
                    56.2599873
                ],
                [
                    86.0341985,
                    56.2597968
                ],
                [
                    86.0364387,
                    56.2590681
                ],
                [
                    86.0374882,
                    56.2591242
                ],
                [
                    86.0381744,
                    56.2596174
                ],
                [
                    86.0391834,
                    56.259438
                ],
                [
                    86.0398292,
                    56.2599873
                ],
                [
                    86.0407375,
                    56.2596622
                ],
                [
                    86.0413833,
                    56.2597407
                ],
                [
                    86.0422915,
                    56.2594268
                ],
                [
                    86.0431794,
                    56.2588327
                ],
                [
                    86.0459242,
                    56.2581489
                ],
                [
                    86.0462472,
                    56.2576781
                ],
                [
                    86.0457628,
                    56.25677
                ],
                [
                    86.0511715,
                    56.2556714
                ],
                [
                    86.0530081,
                    56.2550884
                ],
                [
                    86.0516276,
                    56.2538861
                ],
                [
                    86.0509398,
                    56.2534379
                ],
                [
                    86.0499213,
                    56.2534416
                ],
                [
                    86.0495047,
                    56.2535922
                ],
                [
                    86.047858,
                    56.2539559
                ],
                [
                    86.0470314,
                    56.2539559
                ],
                [
                    86.0466213,
                    56.2542718
                ],
                [
                    86.0458212,
                    56.2542865
                ],
                [
                    86.0440488,
                    56.2545547
                ],
                [
                    86.0433081,
                    56.2545767
                ],
                [
                    86.0425517,
                    56.2547783
                ],
                [
                    86.0422436,
                    56.2541463
                ],
                [
                    86.0409976,
                    56.2544131
                ],
                [
                    86.0406378,
                    56.2538818
                ],
                [
                    86.0402864,
                    56.2538841
                ],
                [
                    86.0390018,
                    56.25427
                ],
                [
                    86.0386991,
                    56.2547409
                ],
                [
                    86.0389816,
                    56.2551557
                ],
                [
                    86.0385982,
                    56.2558844
                ],
                [
                    86.0358332,
                    56.2563104
                ],
                [
                    86.0354498,
                    56.2562319
                ],
                [
                    86.0350664,
                    56.2565907
                ],
                [
                    86.0347434,
                    56.25677
                ],
                [
                    86.0337949,
                    56.2567364
                ],
                [
                    86.0328867,
                    56.2570951
                ],
                [
                    86.0306263,
                    56.2575996
                ],
                [
                    86.0291531,
                    56.2581713
                ],
                [
                    86.0293347,
                    56.2588888
                ],
                [
                    86.0278816,
                    56.2598304
                ]
            ],
            "longitude": 86.0409567,
            "latitude": 56.2576402
        },
        "7530": {
            "name": "Мамаевский",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.048058,
            "latitude": 55.246929
        },
        "7531": {
            "name": "3-й Склад",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0495508,
            "latitude": 56.020188
        },
        "7532": {
            "name": "Ровенский",
            "population": 100,
            "type": "hamlet",
            "poly": [
                [
                    86.0374738,
                    55.8108577
                ],
                [
                    86.038513,
                    55.8113832
                ],
                [
                    86.0395513,
                    55.8121916
                ],
                [
                    86.0402894,
                    55.8119245
                ],
                [
                    86.0408524,
                    55.8112144
                ],
                [
                    86.0414279,
                    55.8109051
                ],
                [
                    86.0414029,
                    55.8101599
                ],
                [
                    86.0416281,
                    55.8100334
                ],
                [
                    86.042216,
                    55.8099701
                ],
                [
                    86.042729,
                    55.8095624
                ],
                [
                    86.0435797,
                    55.8095905
                ],
                [
                    86.0444554,
                    55.8101599
                ],
                [
                    86.0452059,
                    55.8107716
                ],
                [
                    86.0464821,
                    55.810652
                ],
                [
                    86.0470326,
                    55.8107926
                ],
                [
                    86.0499818,
                    55.8130794
                ],
                [
                    86.0510227,
                    55.8136812
                ],
                [
                    86.0529643,
                    55.8143279
                ],
                [
                    86.0542854,
                    55.8144235
                ],
                [
                    86.0551361,
                    55.8146315
                ],
                [
                    86.0563972,
                    55.8151432
                ],
                [
                    86.0573579,
                    55.8147834
                ],
                [
                    86.0594597,
                    55.81322
                ],
                [
                    86.0605907,
                    55.8129726
                ],
                [
                    86.0635235,
                    55.8110584
                ],
                [
                    86.0643742,
                    55.8108968
                ],
                [
                    86.0644116,
                    55.810728
                ],
                [
                    86.064124,
                    55.8103976
                ],
                [
                    86.0632733,
                    55.8100672
                ],
                [
                    86.0618471,
                    55.8095681
                ],
                [
                    86.0608838,
                    55.8089916
                ],
                [
                    86.0607712,
                    55.8081058
                ],
                [
                    86.0604209,
                    55.8080636
                ],
                [
                    86.0599455,
                    55.8083307
                ],
                [
                    86.0592199,
                    55.8083307
                ],
                [
                    86.0589572,
                    55.808387
                ],
                [
                    86.0591198,
                    55.8075433
                ],
                [
                    86.0587195,
                    55.8049911
                ],
                [
                    86.0534025,
                    55.8055888
                ],
                [
                    86.0494868,
                    55.8065942
                ],
                [
                    86.049149,
                    55.8067418
                ],
                [
                    86.0488486,
                    55.8067418
                ],
                [
                    86.0433316,
                    55.8086893
                ],
                [
                    86.0374738,
                    55.8108577
                ]
            ],
            "longitude": 86.052246,
            "latitude": 55.810474
        },
        "7533": {
            "name": "Трекино",
            "population": 197,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.064186,
            "latitude": 54.83046
        },
        "7534": {
            "name": "Терентьевка",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0678339,
            "latitude": 56.0000012
        },
        "7535": {
            "name": "Шанда",
            "population": 198,
            "type": "hamlet",
            "poly": [
                [
                    86.0589311,
                    54.3099831
                ],
                [
                    86.0606396,
                    54.3103944
                ],
                [
                    86.0622342,
                    54.3108666
                ],
                [
                    86.0660575,
                    54.3121885
                ],
                [
                    86.0695418,
                    54.3133767
                ],
                [
                    86.0701826,
                    54.313641
                ],
                [
                    86.0706283,
                    54.3140105
                ],
                [
                    86.0708788,
                    54.3147517
                ],
                [
                    86.0720721,
                    54.3149038
                ],
                [
                    86.0725877,
                    54.3148527
                ],
                [
                    86.0736189,
                    54.3142619
                ],
                [
                    86.0760085,
                    54.3153254
                ],
                [
                    86.0758519,
                    54.3157094
                ],
                [
                    86.0780756,
                    54.3165097
                ],
                [
                    86.0794108,
                    54.3156772
                ],
                [
                    86.0817725,
                    54.3146849
                ],
                [
                    86.0805848,
                    54.312888
                ],
                [
                    86.081941,
                    54.3124752
                ],
                [
                    86.0820345,
                    54.3116275
                ],
                [
                    86.0816245,
                    54.3111952
                ],
                [
                    86.0801929,
                    54.3109099
                ],
                [
                    86.0788549,
                    54.3114009
                ],
                [
                    86.0767831,
                    54.3106832
                ],
                [
                    86.0766967,
                    54.3102762
                ],
                [
                    86.0765098,
                    54.3101377
                ],
                [
                    86.0757976,
                    54.3100411
                ],
                [
                    86.0741431,
                    54.3101167
                ],
                [
                    86.0733446,
                    54.3099614
                ],
                [
                    86.072208,
                    54.3099404
                ],
                [
                    86.0715534,
                    54.3098145
                ],
                [
                    86.0707189,
                    54.3095124
                ],
                [
                    86.0699852,
                    54.3091766
                ],
                [
                    86.069086,
                    54.3089248
                ],
                [
                    86.0686256,
                    54.3089248
                ],
                [
                    86.0673871,
                    54.3086198
                ],
                [
                    86.066738,
                    54.3085956
                ],
                [
                    86.0661671,
                    54.3088078
                ],
                [
                    86.0653614,
                    54.3091274
                ],
                [
                    86.064703,
                    54.3092832
                ],
                [
                    86.0630824,
                    54.3090334
                ],
                [
                    86.0611538,
                    54.3096008
                ],
                [
                    86.0602252,
                    54.3095898
                ],
                [
                    86.0598905,
                    54.3095032
                ],
                [
                    86.0595864,
                    54.3096572
                ],
                [
                    86.0591951,
                    54.3097631
                ],
                [
                    86.0589311,
                    54.3099831
                ]
            ],
            "longitude": 86.067863,
            "latitude": 54.310856
        },
        "7536": {
            "name": "Привольный",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.069267,
            "latitude": 55.49799
        },
        "7537": {
            "name": "20 км",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.074532,
            "latitude": 54.318306
        },
        "7538": {
            "name": "Хмелёво",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.075111,
            "latitude": 54.721439
        },
        "7539": {
            "name": "Плотниково",
            "population": 260,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0768514,
            "latitude": 55.0236505
        },
        "7540": {
            "name": "Новоильинский",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.080284,
            "latitude": 54.713676
        },
        "7541": {
            "name": "Горняк",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.081047,
            "latitude": 54.660366
        },
        "7542": {
            "name": "Павловка",
            "population": 79,
            "type": "hamlet",
            "poly": [
                [
                    86.072826,
                    54.5014669
                ],
                [
                    86.0772502,
                    54.5019494
                ],
                [
                    86.0843115,
                    54.5024049
                ],
                [
                    86.0935247,
                    54.5028962
                ],
                [
                    86.0991329,
                    54.5027032
                ],
                [
                    86.1051149,
                    54.5021001
                ],
                [
                    86.1045333,
                    54.5000497
                ],
                [
                    86.097305,
                    54.5008457
                ],
                [
                    86.0908244,
                    54.5004356
                ],
                [
                    86.0892043,
                    54.4993259
                ],
                [
                    86.0811866,
                    54.4992053
                ],
                [
                    86.0793172,
                    54.4992053
                ],
                [
                    86.0802311,
                    54.4982886
                ],
                [
                    86.0764923,
                    54.4974683
                ],
                [
                    86.0757861,
                    54.4988435
                ],
                [
                    86.0771985,
                    54.4995913
                ],
                [
                    86.076808,
                    54.5006263
                ],
                [
                    86.0731897,
                    54.5002356
                ],
                [
                    86.072826,
                    54.5014669
                ]
            ],
            "longitude": 86.08329,
            "latitude": 54.500946
        },
        "7543": {
            "name": "168 км",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.087995,
            "latitude": 54.8907612
        },
        "7544": {
            "name": "Петровский",
            "population": 103,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.090752,
            "latitude": 54.825195
        },
        "7545": {
            "name": "326-го Квартала",
            "population": 194,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0918472,
            "latitude": 56.019812
        },
        "7546": {
            "name": "Малиновка",
            "population": 41,
            "type": "hamlet",
            "poly": [
                [
                    86.0839369,
                    56.3157612
                ],
                [
                    86.0846938,
                    56.3172653
                ],
                [
                    86.0841892,
                    56.3186994
                ],
                [
                    86.0844099,
                    56.3203257
                ],
                [
                    86.0877526,
                    56.3240153
                ],
                [
                    86.0898337,
                    56.3257464
                ],
                [
                    86.0917574,
                    56.3257464
                ],
                [
                    86.0929557,
                    56.3254841
                ],
                [
                    86.0939018,
                    56.3257639
                ],
                [
                    86.0956677,
                    56.3275822
                ],
                [
                    86.0953839,
                    56.3279494
                ],
                [
                    86.0958253,
                    56.3281767
                ],
                [
                    86.0964876,
                    56.3280893
                ],
                [
                    86.0976228,
                    56.328911
                ],
                [
                    86.1015646,
                    56.3277746
                ],
                [
                    86.1004609,
                    56.3271277
                ],
                [
                    86.1003663,
                    56.3244875
                ],
                [
                    86.0993257,
                    56.3228263
                ],
                [
                    86.097339,
                    56.3229312
                ],
                [
                    86.0940279,
                    56.3217946
                ],
                [
                    86.0926719,
                    56.3204481
                ],
                [
                    86.0925458,
                    56.3194338
                ],
                [
                    86.0917259,
                    56.3184021
                ],
                [
                    86.0912529,
                    56.3183146
                ],
                [
                    86.0903699,
                    56.3169505
                ],
                [
                    86.089077,
                    56.316111
                ],
                [
                    86.0880363,
                    56.3146769
                ],
                [
                    86.0862074,
                    56.3154464
                ],
                [
                    86.0839369,
                    56.3157612
                ]
            ],
            "longitude": 86.092403,
            "latitude": 56.3234832
        },
        "7547": {
            "name": "Солнечный",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.093971,
            "latitude": 54.636742
        },
        "7548": {
            "name": "Каменный Ключ",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.096268,
            "latitude": 54.093002
        },
        "7549": {
            "name": "Маручак",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.097954,
            "latitude": 55.148537
        },
        "7550": {
            "name": "169 км",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.100586,
            "latitude": 54.877815
        },
        "7551": {
            "name": "Новокамышинский",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.100929,
            "latitude": 54.651913
        },
        "7552": {
            "name": "Козлы",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1015665,
            "latitude": 55.9959933
        },
        "7553": {
            "name": "Сосновка",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.101791,
            "latitude": 55.745918
        },
        "7554": {
            "name": "Русско-Урский",
            "population": 134,
            "type": "hamlet",
            "poly": [
                [
                    86.0899557,
                    54.5090468
                ],
                [
                    86.0930838,
                    54.5105657
                ],
                [
                    86.0941104,
                    54.5108449
                ],
                [
                    86.0920947,
                    54.5142214
                ],
                [
                    86.1018776,
                    54.5160008
                ],
                [
                    86.1013847,
                    54.5168658
                ],
                [
                    86.1035163,
                    54.5173327
                ],
                [
                    86.1059896,
                    54.5176945
                ],
                [
                    86.1094081,
                    54.5176478
                ],
                [
                    86.1106347,
                    54.5166674
                ],
                [
                    86.1117407,
                    54.5148231
                ],
                [
                    86.1138923,
                    54.5149748
                ],
                [
                    86.1145156,
                    54.5138309
                ],
                [
                    86.1147368,
                    54.5135157
                ],
                [
                    86.1161847,
                    54.5135857
                ],
                [
                    86.1164662,
                    54.5131772
                ],
                [
                    86.1166068,
                    54.5121382
                ],
                [
                    86.1161042,
                    54.5120215
                ],
                [
                    86.1144754,
                    54.5120215
                ],
                [
                    86.1144453,
                    54.5114378
                ],
                [
                    86.1136609,
                    54.5115079
                ],
                [
                    86.1136309,
                    54.5120682
                ],
                [
                    86.1106548,
                    54.5121733
                ],
                [
                    86.1105341,
                    54.5113678
                ],
                [
                    86.1081211,
                    54.5114086
                ],
                [
                    86.1082518,
                    54.5121733
                ],
                [
                    86.1073662,
                    54.5121485
                ],
                [
                    86.106655,
                    54.5123156
                ],
                [
                    86.10573,
                    54.5127475
                ],
                [
                    86.1041716,
                    54.5127125
                ],
                [
                    86.1027438,
                    54.5124732
                ],
                [
                    86.1005017,
                    54.5117086
                ],
                [
                    86.0984423,
                    54.5114908
                ],
                [
                    86.0961787,
                    54.5106317
                ],
                [
                    86.0967189,
                    54.5096824
                ],
                [
                    86.0912069,
                    54.5078167
                ],
                [
                    86.0899557,
                    54.5090468
                ]
            ],
            "longitude": 86.105553,
            "latitude": 54.513912
        },
        "7555": {
            "name": "Индустрия",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1066774,
            "latitude": 54.6205877
        },
        "7556": {
            "name": "Егозово",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.11013,
            "latitude": 54.714176
        },
        "7557": {
            "name": "Новостройка",
            "population": 175,
            "type": "hamlet",
            "poly": [
                [
                    86.0986597,
                    56.1773726
                ],
                [
                    86.1002117,
                    56.1792423
                ],
                [
                    86.0987384,
                    56.180784
                ],
                [
                    86.0990527,
                    56.1813634
                ],
                [
                    86.0996224,
                    56.18144
                ],
                [
                    86.0996813,
                    56.181757
                ],
                [
                    86.1001724,
                    56.1819976
                ],
                [
                    86.0996813,
                    56.1825552
                ],
                [
                    86.0999367,
                    56.1827082
                ],
                [
                    86.1035316,
                    56.1818336
                ],
                [
                    86.1049656,
                    56.1817352
                ],
                [
                    86.1053781,
                    56.1819648
                ],
                [
                    86.105496,
                    56.1823802
                ],
                [
                    86.1072836,
                    56.1826973
                ],
                [
                    86.1078337,
                    56.1824677
                ],
                [
                    86.1085212,
                    56.1824786
                ],
                [
                    86.1122929,
                    56.1835719
                ],
                [
                    86.1137466,
                    56.1834516
                ],
                [
                    86.1153377,
                    56.1839327
                ],
                [
                    86.1182451,
                    56.1851462
                ],
                [
                    86.1243741,
                    56.1777006
                ],
                [
                    86.123608,
                    56.1772632
                ],
                [
                    86.1227829,
                    56.1762245
                ],
                [
                    86.1227829,
                    56.175973
                ],
                [
                    86.1223311,
                    56.1760932
                ],
                [
                    86.119738,
                    56.1757761
                ],
                [
                    86.1188737,
                    56.1754153
                ],
                [
                    86.1163003,
                    56.1752731
                ],
                [
                    86.1146306,
                    56.1748467
                ],
                [
                    86.1137859,
                    56.1751966
                ],
                [
                    86.1129804,
                    56.1751747
                ],
                [
                    86.1120768,
                    56.175295
                ],
                [
                    86.1114678,
                    56.17512
                ],
                [
                    86.1115267,
                    56.1741905
                ],
                [
                    86.1109767,
                    56.1740812
                ],
                [
                    86.1086587,
                    56.1744202
                ],
                [
                    86.1082069,
                    56.1749013
                ],
                [
                    86.10693,
                    56.1750872
                ],
                [
                    86.1050835,
                    56.1753387
                ],
                [
                    86.1044156,
                    56.1757433
                ],
                [
                    86.1009975,
                    56.175962
                ],
                [
                    86.0989348,
                    56.1758964
                ],
                [
                    86.0986597,
                    56.1773726
                ]
            ],
            "longitude": 86.110724,
            "latitude": 56.1782233
        },
        "7558": {
            "name": "Данковка",
            "population": 270,
            "type": "hamlet",
            "poly": [
                [
                    86.0995028,
                    56.3044006
                ],
                [
                    86.0999936,
                    56.3053608
                ],
                [
                    86.1010268,
                    56.3047087
                ],
                [
                    86.1027319,
                    56.3043003
                ],
                [
                    86.1044368,
                    56.3041785
                ],
                [
                    86.1048631,
                    56.3039348
                ],
                [
                    86.1068005,
                    56.3045654
                ],
                [
                    86.1080793,
                    56.3052247
                ],
                [
                    86.1089447,
                    56.3052462
                ],
                [
                    86.1101072,
                    56.3045153
                ],
                [
                    86.1112955,
                    56.3040853
                ],
                [
                    86.1124838,
                    56.3035765
                ],
                [
                    86.1128454,
                    56.3037127
                ],
                [
                    86.1131554,
                    56.3036983
                ],
                [
                    86.1133233,
                    56.3041283
                ],
                [
                    86.1142662,
                    56.3044651
                ],
                [
                    86.1144342,
                    56.3044078
                ],
                [
                    86.1144342,
                    56.3045726
                ],
                [
                    86.1148346,
                    56.3047231
                ],
                [
                    86.1150671,
                    56.3051387
                ],
                [
                    86.1171724,
                    56.3057764
                ],
                [
                    86.1179862,
                    56.3031609
                ],
                [
                    86.1199495,
                    56.3033257
                ],
                [
                    86.1201045,
                    56.3025948
                ],
                [
                    86.1205178,
                    56.3025876
                ],
                [
                    86.1212024,
                    56.3022078
                ],
                [
                    86.1247931,
                    56.3019283
                ],
                [
                    86.127063,
                    56.3016146
                ],
                [
                    86.1206612,
                    56.2929797
                ],
                [
                    86.1124063,
                    56.2943098
                ],
                [
                    86.1116313,
                    56.2940231
                ],
                [
                    86.1104946,
                    56.2920663
                ],
                [
                    86.1099651,
                    56.2900663
                ],
                [
                    86.1101847,
                    56.2885036
                ],
                [
                    86.1097067,
                    56.2877939
                ],
                [
                    86.1094355,
                    56.2871558
                ],
                [
                    86.1083118,
                    56.287163
                ],
                [
                    86.1073301,
                    56.2870483
                ],
                [
                    86.1060514,
                    56.2883387
                ],
                [
                    86.1059997,
                    56.2888118
                ],
                [
                    86.103636,
                    56.2889695
                ],
                [
                    86.1034164,
                    56.2891344
                ],
                [
                    86.1037394,
                    56.2898083
                ],
                [
                    86.1034294,
                    56.290181
                ],
                [
                    86.1038942,
                    56.291371
                ],
                [
                    86.1042173,
                    56.291543
                ],
                [
                    86.1040752,
                    56.2919516
                ],
                [
                    86.1034294,
                    56.2918871
                ],
                [
                    86.1028352,
                    56.2919229
                ],
                [
                    86.1026027,
                    56.2922168
                ],
                [
                    86.1026931,
                    56.2927688
                ],
                [
                    86.1034939,
                    56.2936002
                ],
                [
                    86.1038942,
                    56.2943385
                ],
                [
                    86.103636,
                    56.2950051
                ],
                [
                    86.1032613,
                    56.295471
                ],
                [
                    86.1034552,
                    56.2964888
                ],
                [
                    86.104101,
                    56.2971195
                ],
                [
                    86.1039459,
                    56.2983952
                ],
                [
                    86.1039073,
                    56.2986532
                ],
                [
                    86.1043464,
                    56.2989112
                ],
                [
                    86.1045143,
                    56.2989184
                ],
                [
                    86.1039589,
                    56.2992767
                ],
                [
                    86.1035456,
                    56.3007889
                ],
                [
                    86.1023573,
                    56.301656
                ],
                [
                    86.1013369,
                    56.3019427
                ],
                [
                    86.1007686,
                    56.3026521
                ],
                [
                    86.0996707,
                    56.3032684
                ],
                [
                    86.0995028,
                    56.3044006
                ]
            ],
            "longitude": 86.1129366,
            "latitude": 56.3002919
        },
        "7559": {
            "name": "Раскатиха",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.125099,
            "latitude": 54.794586
        },
        "7560": {
            "name": "Сыромолотная",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1257178,
            "latitude": 55.0712839
        },
        "7561": {
            "name": "Арсентьевка",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    86.1261481,
                    55.7543742
                ],
                [
                    86.126961,
                    55.7553402
                ],
                [
                    86.1326105,
                    55.7554775
                ],
                [
                    86.1380011,
                    55.75462
                ],
                [
                    86.1378031,
                    55.753505
                ],
                [
                    86.1385329,
                    55.7530414
                ],
                [
                    86.1394908,
                    55.7538397
                ],
                [
                    86.1406748,
                    55.7536574
                ],
                [
                    86.1432638,
                    55.7524056
                ],
                [
                    86.1450822,
                    55.7516003
                ],
                [
                    86.1452184,
                    55.7501203
                ],
                [
                    86.1469475,
                    55.7488555
                ],
                [
                    86.1486657,
                    55.7485111
                ],
                [
                    86.1502594,
                    55.7491562
                ],
                [
                    86.1509026,
                    55.7489871
                ],
                [
                    86.1523564,
                    55.7494192
                ],
                [
                    86.1529298,
                    55.7497242
                ],
                [
                    86.1531912,
                    55.7499218
                ],
                [
                    86.1538008,
                    55.7502999
                ],
                [
                    86.1544878,
                    55.749896
                ],
                [
                    86.1545667,
                    55.750224
                ],
                [
                    86.1569435,
                    55.7487379
                ],
                [
                    86.1608823,
                    55.7486078
                ],
                [
                    86.1611762,
                    55.7480814
                ],
                [
                    86.1605102,
                    55.7466069
                ],
                [
                    86.1598987,
                    55.7469911
                ],
                [
                    86.1584092,
                    55.7471644
                ],
                [
                    86.1577352,
                    55.7473939
                ],
                [
                    86.1573191,
                    55.747333
                ],
                [
                    86.1571859,
                    55.7471222
                ],
                [
                    86.1564414,
                    55.747186
                ],
                [
                    86.1558545,
                    55.7469583
                ],
                [
                    86.1558284,
                    55.7467663
                ],
                [
                    86.1552504,
                    55.7466945
                ],
                [
                    86.1548345,
                    55.7459092
                ],
                [
                    86.1526976,
                    55.7477682
                ],
                [
                    86.1519864,
                    55.7480744
                ],
                [
                    86.1494088,
                    55.747429
                ],
                [
                    86.14886,
                    55.747696
                ],
                [
                    86.1477395,
                    55.7472854
                ],
                [
                    86.1471271,
                    55.7465384
                ],
                [
                    86.1458114,
                    55.7463084
                ],
                [
                    86.1449437,
                    55.7464801
                ],
                [
                    86.1441528,
                    55.7464592
                ],
                [
                    86.1437677,
                    55.7461993
                ],
                [
                    86.1434065,
                    55.7456532
                ],
                [
                    86.1426593,
                    55.7452468
                ],
                [
                    86.1417074,
                    55.7445306
                ],
                [
                    86.1406988,
                    55.743994
                ],
                [
                    86.1379539,
                    55.7450318
                ],
                [
                    86.1376784,
                    55.7479681
                ],
                [
                    86.1353028,
                    55.7492271
                ],
                [
                    86.1321006,
                    55.7500967
                ],
                [
                    86.1299535,
                    55.7514392
                ],
                [
                    86.1269204,
                    55.7531168
                ],
                [
                    86.1261481,
                    55.7543742
                ]
            ],
            "longitude": 86.142174,
            "latitude": 55.749191
        },
        "7562": {
            "name": "Объект 1200",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1471783,
            "latitude": 55.4121506
        },
        "7563": {
            "name": "Поречье",
            "population": 75,
            "type": "hamlet",
            "poly": [
                [
                    86.1508283,
                    54.5602963
                ],
                [
                    86.1675477,
                    54.564564
                ],
                [
                    86.1687246,
                    54.5630141
                ],
                [
                    86.1520052,
                    54.5587462
                ],
                [
                    86.1508283,
                    54.5602963
                ]
            ],
            "longitude": 86.157982,
            "latitude": 54.561771
        },
        "7564": {
            "name": "Майский",
            "population": 156,
            "type": "hamlet",
            "poly": [
                [
                    86.1566831,
                    56.1706838
                ],
                [
                    86.1570956,
                    56.1711431
                ],
                [
                    86.1582743,
                    56.1718977
                ],
                [
                    86.1585493,
                    56.171843
                ],
                [
                    86.15906,
                    56.1722258
                ],
                [
                    86.1589422,
                    56.1724555
                ],
                [
                    86.1591976,
                    56.172707
                ],
                [
                    86.1588833,
                    56.1731007
                ],
                [
                    86.1587653,
                    56.173549
                ],
                [
                    86.1583332,
                    56.1737787
                ],
                [
                    86.1579207,
                    56.1741177
                ],
                [
                    86.1575474,
                    56.1745113
                ],
                [
                    86.1578939,
                    56.1751762
                ],
                [
                    86.1581031,
                    56.1752703
                ],
                [
                    86.1579503,
                    56.1754808
                ],
                [
                    86.1582399,
                    56.1754987
                ],
                [
                    86.1581031,
                    56.1757451
                ],
                [
                    86.1581595,
                    56.1764617
                ],
                [
                    86.1584169,
                    56.1765423
                ],
                [
                    86.1584411,
                    56.1766722
                ],
                [
                    86.1582963,
                    56.1767394
                ],
                [
                    86.1585457,
                    56.1768558
                ],
                [
                    86.1585296,
                    56.1770484
                ],
                [
                    86.1583284,
                    56.1771156
                ],
                [
                    86.1581273,
                    56.1773798
                ],
                [
                    86.1583123,
                    56.1777068
                ],
                [
                    86.1578939,
                    56.1780203
                ],
                [
                    86.1579583,
                    56.1782442
                ],
                [
                    86.1583043,
                    56.1784906
                ],
                [
                    86.1585215,
                    56.1785667
                ],
                [
                    86.1590285,
                    56.1791892
                ],
                [
                    86.1592618,
                    56.1792071
                ],
                [
                    86.1599779,
                    56.1799013
                ],
                [
                    86.1592457,
                    56.1800983
                ],
                [
                    86.1586825,
                    56.1801252
                ],
                [
                    86.1588112,
                    56.1805596
                ],
                [
                    86.1595676,
                    56.1810478
                ],
                [
                    86.1599538,
                    56.1815762
                ],
                [
                    86.1600825,
                    56.1826062
                ],
                [
                    86.1605894,
                    56.1826644
                ],
                [
                    86.1609917,
                    56.1825838
                ],
                [
                    86.1614343,
                    56.1826375
                ],
                [
                    86.1620779,
                    56.1824942
                ],
                [
                    86.1625366,
                    56.1825524
                ],
                [
                    86.163124,
                    56.1824987
                ],
                [
                    86.1647172,
                    56.1825659
                ],
                [
                    86.1653931,
                    56.1823061
                ],
                [
                    86.1659724,
                    56.1821494
                ],
                [
                    86.1662862,
                    56.18193
                ],
                [
                    86.1666,
                    56.1813702
                ],
                [
                    86.166946,
                    56.1811463
                ],
                [
                    86.1675495,
                    56.1811373
                ],
                [
                    86.1677747,
                    56.1809403
                ],
                [
                    86.1675092,
                    56.1806134
                ],
                [
                    86.1675816,
                    56.1804432
                ],
                [
                    86.1679437,
                    56.1803447
                ],
                [
                    86.1684506,
                    56.1801521
                ],
                [
                    86.1691346,
                    56.1802551
                ],
                [
                    86.1695208,
                    56.1801745
                ],
                [
                    86.1702769,
                    56.1800879
                ],
                [
                    86.1601012,
                    56.1699511
                ],
                [
                    86.1585689,
                    56.170137
                ],
                [
                    86.1583725,
                    56.170312
                ],
                [
                    86.1566831,
                    56.1706838
                ]
            ],
            "longitude": 86.163198,
            "latitude": 56.1804581
        },
        "7565": {
            "name": "Донской",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1643513,
            "latitude": 55.8970204
        },
        "7566": {
            "name": "Оселки",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1643705,
            "latitude": 54.069589
        },
        "7567": {
            "name": "Новобарачаты",
            "population": 138,
            "type": "hamlet",
            "poly": [
                [
                    86.161046,
                    55.0438595
                ],
                [
                    86.1614934,
                    55.0445765
                ],
                [
                    86.1617474,
                    55.0454702
                ],
                [
                    86.1628598,
                    55.0456469
                ],
                [
                    86.1642866,
                    55.0460279
                ],
                [
                    86.1638211,
                    55.0467657
                ],
                [
                    86.1682829,
                    55.0484074
                ],
                [
                    86.1693349,
                    55.0482827
                ],
                [
                    86.1701874,
                    55.0486083
                ],
                [
                    86.1713421,
                    55.0478948
                ],
                [
                    86.1716021,
                    55.0479779
                ],
                [
                    86.1720857,
                    55.0480195
                ],
                [
                    86.1725452,
                    55.0478221
                ],
                [
                    86.1720434,
                    55.0468626
                ],
                [
                    86.1732103,
                    55.0471848
                ],
                [
                    86.1739176,
                    55.0472471
                ],
                [
                    86.1748668,
                    55.0471259
                ],
                [
                    86.1753565,
                    55.0478636
                ],
                [
                    86.1748426,
                    55.0478775
                ],
                [
                    86.1742199,
                    55.0479814
                ],
                [
                    86.1737242,
                    55.0483451
                ],
                [
                    86.173833,
                    55.0488993
                ],
                [
                    86.1746129,
                    55.0494049
                ],
                [
                    86.1753565,
                    55.0495158
                ],
                [
                    86.1761546,
                    55.0497617
                ],
                [
                    86.1761909,
                    55.0500976
                ],
                [
                    86.1754351,
                    55.0507868
                ],
                [
                    86.1752296,
                    55.0508076
                ],
                [
                    86.1738693,
                    55.0518362
                ],
                [
                    86.1771581,
                    55.0532319
                ],
                [
                    86.1793589,
                    55.052186
                ],
                [
                    86.1801388,
                    55.0517219
                ],
                [
                    86.1803504,
                    55.0514345
                ],
                [
                    86.179492,
                    55.0504759
                ],
                [
                    86.1792199,
                    55.050417
                ],
                [
                    86.1785005,
                    55.0505105
                ],
                [
                    86.1782345,
                    55.0504828
                ],
                [
                    86.1785126,
                    55.0502334
                ],
                [
                    86.1785549,
                    55.0499529
                ],
                [
                    86.1781921,
                    55.0494334
                ],
                [
                    86.1776397,
                    55.0489994
                ],
                [
                    86.179365,
                    55.0490558
                ],
                [
                    86.1822863,
                    55.0470252
                ],
                [
                    86.182862,
                    55.0465263
                ],
                [
                    86.1829801,
                    55.045799
                ],
                [
                    86.1833048,
                    55.045706
                ],
                [
                    86.1788687,
                    55.0431496
                ],
                [
                    86.1769793,
                    55.0439723
                ],
                [
                    86.1759893,
                    55.0436172
                ],
                [
                    86.1745006,
                    55.0426257
                ],
                [
                    86.1754921,
                    55.0422018
                ],
                [
                    86.1749196,
                    55.0417034
                ],
                [
                    86.1734494,
                    55.0408328
                ],
                [
                    86.1722243,
                    55.0398855
                ],
                [
                    86.167503,
                    55.0410779
                ],
                [
                    86.1666203,
                    55.0411749
                ],
                [
                    86.1649879,
                    55.0399243
                ],
                [
                    86.1634523,
                    55.0399
                ],
                [
                    86.1622854,
                    55.0401113
                ],
                [
                    86.1617292,
                    55.040042
                ],
                [
                    86.1611065,
                    55.0412615
                ],
                [
                    86.1619952,
                    55.0413931
                ],
                [
                    86.1617595,
                    55.0425363
                ],
                [
                    86.161046,
                    55.0438595
                ]
            ],
            "longitude": 86.1695268,
            "latitude": 55.044323
        },
        "7568": {
            "name": "Кабаново",
            "population": 185,
            "type": "hamlet",
            "poly": [
                [
                    86.1558877,
                    54.9845017
                ],
                [
                    86.1580917,
                    54.9857562
                ],
                [
                    86.1588445,
                    54.985808
                ],
                [
                    86.159194,
                    54.985125
                ],
                [
                    86.160441,
                    54.9853527
                ],
                [
                    86.1611211,
                    54.98506
                ],
                [
                    86.1627743,
                    54.985911
                ],
                [
                    86.162831,
                    54.986247
                ],
                [
                    86.1636245,
                    54.9862362
                ],
                [
                    86.1640212,
                    54.9866156
                ],
                [
                    86.1635584,
                    54.9868866
                ],
                [
                    86.1619902,
                    54.9871414
                ],
                [
                    86.1625947,
                    54.9878135
                ],
                [
                    86.164777,
                    54.9885777
                ],
                [
                    86.1655233,
                    54.9883121
                ],
                [
                    86.1664018,
                    54.9876671
                ],
                [
                    86.1664679,
                    54.9870655
                ],
                [
                    86.1668363,
                    54.9868595
                ],
                [
                    86.1687068,
                    54.986892
                ],
                [
                    86.1692641,
                    54.987098
                ],
                [
                    86.1693208,
                    54.98764
                ],
                [
                    86.1700387,
                    54.9881061
                ],
                [
                    86.1708889,
                    54.9880574
                ],
                [
                    86.171314,
                    54.987846
                ],
                [
                    86.1723437,
                    54.987911
                ],
                [
                    86.1736001,
                    54.9890329
                ],
                [
                    86.1740913,
                    54.9888974
                ],
                [
                    86.1738457,
                    54.9873636
                ],
                [
                    86.1741575,
                    54.9870655
                ],
                [
                    86.1747053,
                    54.9870276
                ],
                [
                    86.1752633,
                    54.9870798
                ],
                [
                    86.1760812,
                    54.9874002
                ],
                [
                    86.1768184,
                    54.9881137
                ],
                [
                    86.1778089,
                    54.9887819
                ],
                [
                    86.1786756,
                    54.9886265
                ],
                [
                    86.1789001,
                    54.9882802
                ],
                [
                    86.1787076,
                    54.9876264
                ],
                [
                    86.179138,
                    54.987199
                ],
                [
                    86.1798345,
                    54.987002
                ],
                [
                    86.1810243,
                    54.986866
                ],
                [
                    86.1808212,
                    54.9856866
                ],
                [
                    86.1799699,
                    54.9856394
                ],
                [
                    86.180086,
                    54.9850566
                ],
                [
                    86.1772759,
                    54.9849123
                ],
                [
                    86.1769712,
                    54.9846903
                ],
                [
                    86.1726241,
                    54.9843217
                ],
                [
                    86.1729577,
                    54.9833742
                ],
                [
                    86.1725232,
                    54.9833634
                ],
                [
                    86.1724382,
                    54.9834881
                ],
                [
                    86.169812,
                    54.9832441
                ],
                [
                    86.1695759,
                    54.9833851
                ],
                [
                    86.1694153,
                    54.9839434
                ],
                [
                    86.168121,
                    54.9837591
                ],
                [
                    86.1661467,
                    54.9842307
                ],
                [
                    86.1647014,
                    54.9832225
                ],
                [
                    86.1645503,
                    54.9828701
                ],
                [
                    86.1651359,
                    54.9826316
                ],
                [
                    86.1652965,
                    54.9820407
                ],
                [
                    86.1631994,
                    54.9816721
                ],
                [
                    86.1630766,
                    54.9818564
                ],
                [
                    86.1630388,
                    54.9823226
                ],
                [
                    86.1629349,
                    54.9823768
                ],
                [
                    86.1619713,
                    54.9821221
                ],
                [
                    86.1595624,
                    54.9810921
                ],
                [
                    86.1575314,
                    54.9820191
                ],
                [
                    86.1562749,
                    54.9827834
                ],
                [
                    86.1563223,
                    54.9829894
                ],
                [
                    86.156785,
                    54.9833038
                ],
                [
                    86.156785,
                    54.9839163
                ],
                [
                    86.1558877,
                    54.9845017
                ]
            ],
            "longitude": 86.170723,
            "latitude": 54.984852
        },
        "7569": {
            "name": "Новороссийка",
            "population": 258,
            "type": "hamlet",
            "poly": [
                [
                    86.1646645,
                    54.4431431
                ],
                [
                    86.1894238,
                    54.4522307
                ],
                [
                    86.1920157,
                    54.4491942
                ],
                [
                    86.1679528,
                    54.4403534
                ],
                [
                    86.1646645,
                    54.4431431
                ]
            ],
            "longitude": 86.179169,
            "latitude": 54.447235
        },
        "7570": {
            "name": "Чиндатский",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    86.1767384,
                    56.1315964
                ],
                [
                    86.1778447,
                    56.1321513
                ],
                [
                    86.1789813,
                    56.132992
                ],
                [
                    86.179987,
                    56.133362
                ],
                [
                    86.1804799,
                    56.1330369
                ],
                [
                    86.1808923,
                    56.1330369
                ],
                [
                    86.1815259,
                    56.1333732
                ],
                [
                    86.1821193,
                    56.1334124
                ],
                [
                    86.1830245,
                    56.1340682
                ],
                [
                    86.1831754,
                    56.1343372
                ],
                [
                    86.1833665,
                    56.1343932
                ],
                [
                    86.1845533,
                    56.1334853
                ],
                [
                    86.185077,
                    56.1328388
                ],
                [
                    86.1854118,
                    56.1317913
                ],
                [
                    86.186004,
                    56.1305487
                ],
                [
                    86.1859525,
                    56.1294524
                ],
                [
                    86.1830172,
                    56.1280948
                ],
                [
                    86.1784134,
                    56.1265306
                ],
                [
                    86.1782269,
                    56.1268374
                ],
                [
                    86.178438,
                    56.127824
                ],
                [
                    86.1785085,
                    56.1301222
                ],
                [
                    86.1767384,
                    56.1315964
                ]
            ],
            "longitude": 86.1822718,
            "latitude": 56.1308662
        },
        "7571": {
            "name": "189 км",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.186646,
            "latitude": 54.74794
        },
        "7572": {
            "name": "Медведчиково",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1886841,
            "latitude": 56.529997
        },
        "7573": {
            "name": "Еловка",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.192955,
            "latitude": 54.100811
        },
        "7574": {
            "name": "Солонечная",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.194786,
            "latitude": 55.413376
        },
        "7575": {
            "name": "Красная Поляна",
            "population": 239,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.195526,
            "latitude": 54.734562
        },
        "7576": {
            "name": "Берёзовка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.201866,
            "latitude": 54.830971
        },
        "7577": {
            "name": "Калиновка",
            "population": 152,
            "type": "hamlet",
            "poly": [
                [
                    86.1986514,
                    54.4927577
                ],
                [
                    86.2016766,
                    54.4956251
                ],
                [
                    86.2084531,
                    54.4976913
                ],
                [
                    86.2165849,
                    54.5003616
                ],
                [
                    86.2183516,
                    54.499434
                ],
                [
                    86.2171657,
                    54.4980005
                ],
                [
                    86.2133659,
                    54.4947959
                ],
                [
                    86.2111395,
                    54.4940368
                ],
                [
                    86.2008538,
                    54.4897495
                ],
                [
                    86.1991838,
                    54.4908741
                ],
                [
                    86.1986514,
                    54.4927577
                ]
            ],
            "longitude": 86.209732,
            "latitude": 54.497223
        },
        "7578": {
            "name": "Лапшиновка",
            "population": 191,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.210541,
            "latitude": 54.722595
        },
        "7579": {
            "name": "Верховская",
            "population": 198,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.214035,
            "latitude": 54.364315
        },
        "7580": {
            "name": "Дуброво",
            "population": 196,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2268904,
            "latitude": 54.1493765
        },
        "7581": {
            "name": "Пугачи",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.235413,
            "latitude": 55.278584
        },
        "7582": {
            "name": "Жургавань",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.236557,
            "latitude": 55.348118
        },
        "7583": {
            "name": "Проектная",
            "population": 242,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.237427,
            "latitude": 54.545017
        },
        "7584": {
            "name": "Нижегородка",
            "population": 110,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.249176,
            "latitude": 54.679626
        },
        "7585": {
            "name": "Бускускан",
            "population": 223,
            "type": "hamlet",
            "poly": [
                [
                    86.2410333,
                    54.1974882
                ],
                [
                    86.2518742,
                    54.1980624
                ],
                [
                    86.2533018,
                    54.1931557
                ],
                [
                    86.2617335,
                    54.1879352
                ],
                [
                    86.2610643,
                    54.1875176
                ],
                [
                    86.2591014,
                    54.1860035
                ],
                [
                    86.2462976,
                    54.1947478
                ],
                [
                    86.2444239,
                    54.1939387
                ],
                [
                    86.2419256,
                    54.1944346
                ],
                [
                    86.2410333,
                    54.1974882
                ]
            ],
            "longitude": 86.249878,
            "latitude": 54.195042
        },
        "7586": {
            "name": "Димитрово",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2502089,
            "latitude": 56.4642309
        },
        "7587": {
            "name": "Октябрьский",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.256317,
            "latitude": 54.375324
        },
        "7588": {
            "name": "Антоновка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2638464,
            "latitude": 56.1077074
        },
        "7589": {
            "name": "Кара-Чумыш",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.275734,
            "latitude": 54.086823
        },
        "7590": {
            "name": "Мальцево",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2767495,
            "latitude": 56.1745421
        },
        "7591": {
            "name": "Артышта",
            "population": 263,
            "type": "hamlet",
            "poly": [
                [
                    86.2641426,
                    54.1826619
                ],
                [
                    86.2664624,
                    54.1833407
                ],
                [
                    86.2808276,
                    54.182192
                ],
                [
                    86.2834151,
                    54.1806516
                ],
                [
                    86.2793554,
                    54.1771529
                ],
                [
                    86.2861365,
                    54.1708597
                ],
                [
                    86.2833259,
                    54.16958
                ],
                [
                    86.2745819,
                    54.1737583
                ],
                [
                    86.2728866,
                    54.1765523
                ],
                [
                    86.2696299,
                    54.1781973
                ],
                [
                    86.2669532,
                    54.1773618
                ],
                [
                    86.2641426,
                    54.1826619
                ]
            ],
            "longitude": 86.277489,
            "latitude": 54.176342
        },
        "7592": {
            "name": "Станционный",
            "population": 120,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2786929,
            "latitude": 55.7117769
        },
        "7593": {
            "name": "Смирновский",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.304306,
            "latitude": 55.110683
        },
        "7594": {
            "name": "Тихеевка",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.313483,
            "latitude": 56.4808119
        },
        "7595": {
            "name": "Вознесенка",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.313614,
            "latitude": 55.402966
        },
        "7596": {
            "name": "Мереть",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.317162,
            "latitude": 54.50079
        },
        "7597": {
            "name": "Озеровка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.324707,
            "latitude": 54.778606
        },
        "7598": {
            "name": "шахты № 5",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3251989,
            "latitude": 54.5385909
        },
        "7599": {
            "name": "Александровка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.331375,
            "latitude": 55.356632
        },
        "7600": {
            "name": "Тырган",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.343231,
            "latitude": 54.132484
        },
        "7601": {
            "name": "Малиновка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.350571,
            "latitude": 55.362995
        },
        "7602": {
            "name": "Тебеньковка",
            "population": 209,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.360123,
            "latitude": 55.36134
        },
        "7603": {
            "name": "Берёзовка",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3627455,
            "latitude": 53.9250549
        },
        "7604": {
            "name": "Осиновка",
            "population": 220,
            "type": "hamlet",
            "poly": [
                [
                    86.353605,
                    54.4508819
                ],
                [
                    86.3580788,
                    54.453358
                ],
                [
                    86.3601903,
                    54.4548145
                ],
                [
                    86.3699252,
                    54.4569991
                ],
                [
                    86.37286,
                    54.452713
                ],
                [
                    86.3702116,
                    54.4516102
                ],
                [
                    86.3641273,
                    54.4498207
                ],
                [
                    86.3617292,
                    54.4515894
                ],
                [
                    86.3561461,
                    54.4489467
                ],
                [
                    86.353605,
                    54.4508819
                ]
            ],
            "longitude": 86.36335,
            "latitude": 54.453457
        },
        "7605": {
            "name": "Михайловский",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.365829,
            "latitude": 55.276508
        },
        "7606": {
            "name": "Ольговка",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.367233,
            "latitude": 56.555408
        },
        "7607": {
            "name": "Верх-Великосельское",
            "population": 80,
            "type": "hamlet",
            "poly": [
                [
                    86.3518442,
                    56.4300728
                ],
                [
                    86.3525505,
                    56.4307981
                ],
                [
                    86.3525304,
                    56.4315012
                ],
                [
                    86.3528533,
                    56.4313784
                ],
                [
                    86.3533982,
                    56.4315458
                ],
                [
                    86.3538219,
                    56.4319699
                ],
                [
                    86.3552347,
                    56.4325055
                ],
                [
                    86.3579795,
                    56.4330076
                ],
                [
                    86.3605344,
                    56.4316717
                ],
                [
                    86.3616485,
                    56.430529
                ],
                [
                    86.3604376,
                    56.430029
                ],
                [
                    86.3596142,
                    56.4299397
                ],
                [
                    86.3584355,
                    56.4295737
                ],
                [
                    86.3582256,
                    56.4291005
                ],
                [
                    86.3590813,
                    56.4290202
                ],
                [
                    86.3593881,
                    56.4284845
                ],
                [
                    86.3599854,
                    56.428297
                ],
                [
                    86.3617454,
                    56.4286006
                ],
                [
                    86.3636667,
                    56.4284131
                ],
                [
                    86.3695921,
                    56.4286452
                ],
                [
                    86.3706093,
                    56.4285738
                ],
                [
                    86.3713197,
                    56.4288148
                ],
                [
                    86.3718363,
                    56.4287702
                ],
                [
                    86.3725629,
                    56.4288059
                ],
                [
                    86.3738061,
                    56.4287434
                ],
                [
                    86.3777616,
                    56.4278952
                ],
                [
                    86.3777456,
                    56.427172
                ],
                [
                    86.3781008,
                    56.4269488
                ],
                [
                    86.3782784,
                    56.4267881
                ],
                [
                    86.3782461,
                    56.4265917
                ],
                [
                    86.3778102,
                    56.4267703
                ],
                [
                    86.3772451,
                    56.4267345
                ],
                [
                    86.3770028,
                    56.4264756
                ],
                [
                    86.3774227,
                    56.425806
                ],
                [
                    86.3775841,
                    56.4252256
                ],
                [
                    86.3773904,
                    56.425047
                ],
                [
                    86.3768737,
                    56.4248774
                ],
                [
                    86.3765993,
                    56.4244756
                ],
                [
                    86.3768092,
                    56.424172
                ],
                [
                    86.3773581,
                    56.4240559
                ],
                [
                    86.3779878,
                    56.4238773
                ],
                [
                    86.3780524,
                    56.4235737
                ],
                [
                    86.3775034,
                    56.4231005
                ],
                [
                    86.3775196,
                    56.4226629
                ],
                [
                    86.3784399,
                    56.4223861
                ],
                [
                    86.3785529,
                    56.4221807
                ],
                [
                    86.377568,
                    56.4219843
                ],
                [
                    86.3768737,
                    56.4216985
                ],
                [
                    86.3763409,
                    56.4217521
                ],
                [
                    86.3755982,
                    56.4210377
                ],
                [
                    86.3750977,
                    56.4211627
                ],
                [
                    86.3746457,
                    56.4209663
                ],
                [
                    86.3744196,
                    56.4210734
                ],
                [
                    86.3736285,
                    56.4210288
                ],
                [
                    86.3730311,
                    56.4207877
                ],
                [
                    86.3722723,
                    56.4208145
                ],
                [
                    86.3715134,
                    56.4199036
                ],
                [
                    86.3716264,
                    56.4192517
                ],
                [
                    86.372353,
                    56.4192785
                ],
                [
                    86.3733217,
                    56.4191535
                ],
                [
                    86.3743226,
                    56.4186623
                ],
                [
                    86.3727889,
                    56.4180461
                ],
                [
                    86.3682359,
                    56.4173138
                ],
                [
                    86.3663146,
                    56.4175102
                ],
                [
                    86.3659109,
                    56.4178139
                ],
                [
                    86.3649583,
                    56.4180193
                ],
                [
                    86.3641995,
                    56.4183676
                ],
                [
                    86.3641995,
                    56.4190909
                ],
                [
                    86.3639089,
                    56.4203501
                ],
                [
                    86.3625042,
                    56.4214663
                ],
                [
                    86.3607605,
                    56.4223147
                ],
                [
                    86.3576205,
                    56.4228261
                ],
                [
                    86.3564735,
                    56.4229061
                ],
                [
                    86.3559052,
                    56.4236834
                ],
                [
                    86.3560809,
                    56.424672
                ],
                [
                    86.3554237,
                    56.4257623
                ],
                [
                    86.3541247,
                    56.4263229
                ],
                [
                    86.3541045,
                    56.4268809
                ],
                [
                    86.3546494,
                    56.4274278
                ],
                [
                    86.3546293,
                    56.4285662
                ],
                [
                    86.3526313,
                    56.4294143
                ],
                [
                    86.3518442,
                    56.4300728
                ]
            ],
            "longitude": 86.3673971,
            "latitude": 56.4240327
        },
        "7608": {
            "name": "Илиндеевка",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.368797,
            "latitude": 55.34227
        },
        "7609": {
            "name": "Ольговка",
            "population": 201,
            "type": "hamlet",
            "poly": [
                [
                    86.3485931,
                    56.2246211
                ],
                [
                    86.3495147,
                    56.2253823
                ],
                [
                    86.3505943,
                    56.2259239
                ],
                [
                    86.3514369,
                    56.2259386
                ],
                [
                    86.3527007,
                    56.2264655
                ],
                [
                    86.3532274,
                    56.2264655
                ],
                [
                    86.3541226,
                    56.2267436
                ],
                [
                    86.3538856,
                    56.2271096
                ],
                [
                    86.3530167,
                    56.2268461
                ],
                [
                    86.3523584,
                    56.2268461
                ],
                [
                    86.3520161,
                    56.2272706
                ],
                [
                    86.3523848,
                    56.2276073
                ],
                [
                    86.3538067,
                    56.2280756
                ],
                [
                    86.3550705,
                    56.2280317
                ],
                [
                    86.3552811,
                    56.2281781
                ],
                [
                    86.3554654,
                    56.2280464
                ],
                [
                    86.3561764,
                    56.2275926
                ],
                [
                    86.3570717,
                    56.2273731
                ],
                [
                    86.3579668,
                    56.2277097
                ],
                [
                    86.3582303,
                    56.227578
                ],
                [
                    86.3588622,
                    56.2277244
                ],
                [
                    86.3592308,
                    56.2276219
                ],
                [
                    86.3596785,
                    56.227739
                ],
                [
                    86.3602314,
                    56.2276658
                ],
                [
                    86.3619693,
                    56.2276219
                ],
                [
                    86.3626539,
                    56.2271096
                ],
                [
                    86.3630225,
                    56.2269778
                ],
                [
                    86.3630752,
                    56.2273438
                ],
                [
                    86.3624695,
                    56.2279
                ],
                [
                    86.3631226,
                    56.2282706
                ],
                [
                    86.3646392,
                    56.2286922
                ],
                [
                    86.3653807,
                    56.2288795
                ],
                [
                    86.3642685,
                    56.2304439
                ],
                [
                    86.3638135,
                    56.2313056
                ],
                [
                    86.36592,
                    56.2315211
                ],
                [
                    86.3673861,
                    56.2295071
                ],
                [
                    86.3678748,
                    56.2297132
                ],
                [
                    86.3674535,
                    56.2303221
                ],
                [
                    86.3673018,
                    56.230856
                ],
                [
                    86.368018,
                    56.2313343
                ],
                [
                    86.3695979,
                    56.2313197
                ],
                [
                    86.3706248,
                    56.2319197
                ],
                [
                    86.3712567,
                    56.2320661
                ],
                [
                    86.3725733,
                    56.2321393
                ],
                [
                    86.3736002,
                    56.2323003
                ],
                [
                    86.375496,
                    56.2312026
                ],
                [
                    86.3769705,
                    56.2312904
                ],
                [
                    86.3779448,
                    56.2299439
                ],
                [
                    86.379472,
                    56.2302951
                ],
                [
                    86.3800513,
                    56.2294023
                ],
                [
                    86.3777341,
                    56.2287144
                ],
                [
                    86.3773918,
                    56.2287583
                ],
                [
                    86.3767336,
                    56.229739
                ],
                [
                    86.3748114,
                    56.2292852
                ],
                [
                    86.3750747,
                    56.2289047
                ],
                [
                    86.3730999,
                    56.2284802
                ],
                [
                    86.3733369,
                    56.2280411
                ],
                [
                    86.372389,
                    56.2276605
                ],
                [
                    86.3706774,
                    56.2274849
                ],
                [
                    86.3703088,
                    56.2277484
                ],
                [
                    86.3698085,
                    56.2275581
                ],
                [
                    86.3688869,
                    56.2276313
                ],
                [
                    86.3681232,
                    56.2274263
                ],
                [
                    86.3682022,
                    56.2269872
                ],
                [
                    86.3673334,
                    56.2267969
                ],
                [
                    86.3664118,
                    56.2267677
                ],
                [
                    86.3659115,
                    56.2272068
                ],
                [
                    86.3656218,
                    56.227119
                ],
                [
                    86.364805,
                    56.2269939
                ],
                [
                    86.3646109,
                    56.2265562
                ],
                [
                    86.3636295,
                    56.2264483
                ],
                [
                    86.363101,
                    56.2267901
                ],
                [
                    86.3627019,
                    56.2267841
                ],
                [
                    86.3625402,
                    56.2260346
                ],
                [
                    86.362098,
                    56.225543
                ],
                [
                    86.3613106,
                    56.2253211
                ],
                [
                    86.3603399,
                    56.2253031
                ],
                [
                    86.3598115,
                    56.225525
                ],
                [
                    86.3598101,
                    56.2260996
                ],
                [
                    86.3549388,
                    56.2249578
                ],
                [
                    86.3547282,
                    56.2244162
                ],
                [
                    86.3536223,
                    56.2236843
                ],
                [
                    86.3513579,
                    56.2230841
                ],
                [
                    86.3505153,
                    56.2231133
                ],
                [
                    86.34962,
                    56.2240063
                ],
                [
                    86.3485931,
                    56.2246211
                ]
            ],
            "longitude": 86.3703806,
            "latitude": 56.2292856
        },
        "7610": {
            "name": "Алексеевка",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.374565,
            "latitude": 53.980251
        },
        "7611": {
            "name": "Урманай",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.375145,
            "latitude": 55.284245
        },
        "7612": {
            "name": "Ляпки",
            "population": 143,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.379044,
            "latitude": 55.178596
        },
        "7613": {
            "name": "Инченково",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.383568,
            "latitude": 54.059406
        },
        "7614": {
            "name": "Дмитриевка",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.384834,
            "latitude": 55.618992
        },
        "7615": {
            "name": "Калиновка",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.386246,
            "latitude": 54.098442
        },
        "7616": {
            "name": "Александровка",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3875427,
            "latitude": 53.9474738
        },
        "7617": {
            "name": "имени Ильича",
            "population": 213,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.389099,
            "latitude": 54.312168
        },
        "7618": {
            "name": "Малиновка",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.390839,
            "latitude": 54.005478
        },
        "7619": {
            "name": "Арышево",
            "population": 133,
            "type": "hamlet",
            "poly": [
                [
                    86.3750386,
                    56.3164236
                ],
                [
                    86.375979,
                    56.3169337
                ],
                [
                    86.3770536,
                    56.316756
                ],
                [
                    86.3778803,
                    56.3171457
                ],
                [
                    86.3786759,
                    56.3170139
                ],
                [
                    86.3793579,
                    56.3172087
                ],
                [
                    86.3793062,
                    56.3175984
                ],
                [
                    86.3801226,
                    56.3178105
                ],
                [
                    86.3808045,
                    56.3173807
                ],
                [
                    86.3815899,
                    56.3170254
                ],
                [
                    86.3831088,
                    56.3170425
                ],
                [
                    86.3834292,
                    56.316819
                ],
                [
                    86.3842145,
                    56.3168305
                ],
                [
                    86.3845245,
                    56.3167159
                ],
                [
                    86.3850825,
                    56.3161657
                ],
                [
                    86.3858264,
                    56.3160167
                ],
                [
                    86.3862398,
                    56.3158505
                ],
                [
                    86.3872938,
                    56.3158333
                ],
                [
                    86.3879757,
                    56.3159021
                ],
                [
                    86.3885524,
                    56.3157284
                ],
                [
                    86.3888434,
                    56.3157467
                ],
                [
                    86.3891541,
                    56.3161832
                ],
                [
                    86.3896436,
                    56.3162052
                ],
                [
                    86.3896701,
                    56.3169827
                ],
                [
                    86.3899346,
                    56.3174338
                ],
                [
                    86.3905893,
                    56.3171918
                ],
                [
                    86.3910522,
                    56.3170304
                ],
                [
                    86.392236,
                    56.3169901
                ],
                [
                    86.3926196,
                    56.3171037
                ],
                [
                    86.3928114,
                    56.3170414
                ],
                [
                    86.3930891,
                    56.316935
                ],
                [
                    86.3934991,
                    56.3170964
                ],
                [
                    86.3953466,
                    56.3163794
                ],
                [
                    86.3966584,
                    56.3161891
                ],
                [
                    86.3994921,
                    56.3152036
                ],
                [
                    86.4026837,
                    56.3145982
                ],
                [
                    86.4009299,
                    56.3130488
                ],
                [
                    86.4001398,
                    56.3130314
                ],
                [
                    86.4008747,
                    56.3123989
                ],
                [
                    86.3997039,
                    56.3119709
                ],
                [
                    86.3986652,
                    56.3116674
                ],
                [
                    86.3971973,
                    56.3121027
                ],
                [
                    86.3964584,
                    56.3121051
                ],
                [
                    86.3957798,
                    56.3118645
                ],
                [
                    86.3947445,
                    56.3119339
                ],
                [
                    86.3922974,
                    56.3116261
                ],
                [
                    86.3914649,
                    56.3112903
                ],
                [
                    86.3898756,
                    56.3111503
                ],
                [
                    86.3887908,
                    56.3123677
                ],
                [
                    86.3881349,
                    56.3126896
                ],
                [
                    86.3880088,
                    56.3119759
                ],
                [
                    86.3873529,
                    56.3120319
                ],
                [
                    86.3872519,
                    56.311752
                ],
                [
                    86.3863185,
                    56.31185
                ],
                [
                    86.3862933,
                    56.3121578
                ],
                [
                    86.3848049,
                    56.3120459
                ],
                [
                    86.3831399,
                    56.3121858
                ],
                [
                    86.381601,
                    56.3128715
                ],
                [
                    86.3765631,
                    56.3140779
                ],
                [
                    86.3760051,
                    56.3143415
                ],
                [
                    86.3750386,
                    56.3164236
                ]
            ],
            "longitude": 86.3933036,
            "latitude": 56.3141567
        },
        "7620": {
            "name": "Золотарёвский",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.395485,
            "latitude": 54.71553
        },
        "7621": {
            "name": "Упоровка",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.396965,
            "latitude": 55.254364
        },
        "7622": {
            "name": "Чесноково",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.401558,
            "latitude": 54.819347
        },
        "7623": {
            "name": "Старопокровка",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.406174,
            "latitude": 56.501717
        },
        "7624": {
            "name": "Панинск",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.410538,
            "latitude": 55.323605
        },
        "7625": {
            "name": "Сарапки",
            "population": 257,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.410881,
            "latitude": 55.068214
        },
        "7626": {
            "name": "Наша Родина",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    86.3974388,
                    56.1821589
                ],
                [
                    86.3977778,
                    56.182716
                ],
                [
                    86.3986981,
                    56.1832012
                ],
                [
                    86.4000867,
                    56.1835607
                ],
                [
                    86.4035741,
                    56.1834708
                ],
                [
                    86.4046881,
                    56.1831653
                ],
                [
                    86.4078365,
                    56.181467
                ],
                [
                    86.4087245,
                    56.1811974
                ],
                [
                    86.4098063,
                    56.1806762
                ],
                [
                    86.4116307,
                    56.1804246
                ],
                [
                    86.4131161,
                    56.1807211
                ],
                [
                    86.417653,
                    56.1800831
                ],
                [
                    86.417314,
                    56.179463
                ],
                [
                    86.4184925,
                    56.1792474
                ],
                [
                    86.4183311,
                    56.1788879
                ],
                [
                    86.4199134,
                    56.1784116
                ],
                [
                    86.4208821,
                    56.1790946
                ],
                [
                    86.4234008,
                    56.1780521
                ],
                [
                    86.4239659,
                    56.1783757
                ],
                [
                    86.4251123,
                    56.1778364
                ],
                [
                    86.425419,
                    56.1780881
                ],
                [
                    86.4258064,
                    56.1779263
                ],
                [
                    86.4251123,
                    56.1771624
                ],
                [
                    86.4262909,
                    56.1766142
                ],
                [
                    86.4274211,
                    56.1770456
                ],
                [
                    86.4281315,
                    56.1768389
                ],
                [
                    86.4266299,
                    56.1761109
                ],
                [
                    86.4225356,
                    56.1758695
                ],
                [
                    86.4226431,
                    56.1756394
                ],
                [
                    86.4082173,
                    56.1780118
                ],
                [
                    86.4092754,
                    56.1780946
                ],
                [
                    86.4058035,
                    56.1785317
                ],
                [
                    86.4058117,
                    56.1788676
                ],
                [
                    86.4025465,
                    56.1791391
                ],
                [
                    86.4023729,
                    56.1799305
                ],
                [
                    86.4015875,
                    56.1799075
                ],
                [
                    86.40067,
                    56.1800501
                ],
                [
                    86.4001657,
                    56.1798845
                ],
                [
                    86.3987687,
                    56.1798845
                ],
                [
                    86.3987356,
                    56.1802433
                ],
                [
                    86.3977617,
                    56.1813681
                ],
                [
                    86.3974388,
                    56.1821589
                ]
            ],
            "longitude": 86.4119912,
            "latitude": 56.1788345
        },
        "7627": {
            "name": "Семёново",
            "population": 104,
            "type": "hamlet",
            "poly": [
                [
                    86.4140589,
                    54.9012206
                ],
                [
                    86.4143009,
                    54.9017085
                ],
                [
                    86.4188213,
                    54.9018676
                ],
                [
                    86.4192456,
                    54.9045833
                ],
                [
                    86.4198545,
                    54.9045091
                ],
                [
                    86.4203157,
                    54.9052728
                ],
                [
                    86.4195777,
                    54.9061214
                ],
                [
                    86.4204264,
                    54.9065775
                ],
                [
                    86.4216995,
                    54.9069382
                ],
                [
                    86.4226774,
                    54.906429
                ],
                [
                    86.4227512,
                    54.9059729
                ],
                [
                    86.4222161,
                    54.9036816
                ],
                [
                    86.4226589,
                    54.9027375
                ],
                [
                    86.4228434,
                    54.9016342
                ],
                [
                    86.4223268,
                    54.9010507
                ],
                [
                    86.4212936,
                    54.9009871
                ],
                [
                    86.4211765,
                    54.9004362
                ],
                [
                    86.4216609,
                    54.899919
                ],
                [
                    86.4211996,
                    54.8987387
                ],
                [
                    86.4196775,
                    54.8978502
                ],
                [
                    86.4185012,
                    54.8968025
                ],
                [
                    86.4188472,
                    54.8957282
                ],
                [
                    86.4225603,
                    54.8946804
                ],
                [
                    86.422422,
                    54.8939907
                ],
                [
                    86.4230216,
                    54.8929562
                ],
                [
                    86.4238749,
                    54.8921073
                ],
                [
                    86.4244054,
                    54.89094
                ],
                [
                    86.4239672,
                    54.8907809
                ],
                [
                    86.4241517,
                    54.8904227
                ],
                [
                    86.4226987,
                    54.8901309
                ],
                [
                    86.4224911,
                    54.8902635
                ],
                [
                    86.4224911,
                    54.8899319
                ],
                [
                    86.4218915,
                    54.8898391
                ],
                [
                    86.4215686,
                    54.890184
                ],
                [
                    86.4211535,
                    54.8902635
                ],
                [
                    86.4200271,
                    54.8919459
                ],
                [
                    86.4197701,
                    54.8922197
                ],
                [
                    86.4182359,
                    54.8926022
                ],
                [
                    86.4177901,
                    54.8931498
                ],
                [
                    86.418697,
                    54.893541
                ],
                [
                    86.417979,
                    54.8944754
                ],
                [
                    86.4187196,
                    54.8946753
                ],
                [
                    86.4180848,
                    54.8953272
                ],
                [
                    86.4168379,
                    54.8950751
                ],
                [
                    86.4156665,
                    54.895023
                ],
                [
                    86.4145253,
                    54.8951794
                ],
                [
                    86.4145001,
                    54.8952548
                ],
                [
                    86.4147661,
                    54.895529
                ],
                [
                    86.4148241,
                    54.8964691
                ],
                [
                    86.4148688,
                    54.8974456
                ],
                [
                    86.4168209,
                    54.8973577
                ],
                [
                    86.4174016,
                    54.8985787
                ],
                [
                    86.4169065,
                    54.899173
                ],
                [
                    86.4145063,
                    54.8992356
                ],
                [
                    86.4142282,
                    54.8994199
                ],
                [
                    86.4140589,
                    54.9012206
                ]
            ],
            "longitude": 86.418968,
            "latitude": 54.900879
        },
        "7628": {
            "name": "Бердовка",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.443817,
            "latitude": 55.556263
        },
        "7629": {
            "name": "Майский",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    86.439797,
                    56.0604867
                ],
                [
                    86.443629,
                    56.0640523
                ],
                [
                    86.447974,
                    56.0648552
                ],
                [
                    86.448497,
                    56.0648889
                ],
                [
                    86.4493117,
                    56.0647261
                ],
                [
                    86.4494424,
                    56.0640748
                ],
                [
                    86.453717,
                    56.0644229
                ],
                [
                    86.4558292,
                    56.0617445
                ],
                [
                    86.4493217,
                    56.05965
                ],
                [
                    86.4479941,
                    56.0591277
                ],
                [
                    86.4466967,
                    56.0585324
                ],
                [
                    86.4462742,
                    56.0588694
                ],
                [
                    86.4430457,
                    56.0585493
                ],
                [
                    86.4409436,
                    56.0588357
                ],
                [
                    86.439797,
                    56.0604867
                ]
            ],
            "longitude": 86.4483425,
            "latitude": 56.0631725
        },
        "7630": {
            "name": "Иганино",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.451042,
            "latitude": 54.008224
        },
        "7631": {
            "name": "Мальцево",
            "population": 90,
            "type": "hamlet",
            "poly": [
                [
                    86.4411791,
                    56.1267732
                ],
                [
                    86.4412735,
                    56.1271674
                ],
                [
                    86.441902,
                    56.1273426
                ],
                [
                    86.4425621,
                    56.1273513
                ],
                [
                    86.4432065,
                    56.1271499
                ],
                [
                    86.4439137,
                    56.1269397
                ],
                [
                    86.4447309,
                    56.1271674
                ],
                [
                    86.4463966,
                    56.1272112
                ],
                [
                    86.4476225,
                    56.1275878
                ],
                [
                    86.448204,
                    56.1273688
                ],
                [
                    86.448644,
                    56.1274039
                ],
                [
                    86.4501055,
                    56.1262389
                ],
                [
                    86.4505613,
                    56.1261075
                ],
                [
                    86.4521957,
                    56.1249776
                ],
                [
                    86.4522114,
                    56.1238301
                ],
                [
                    86.4517556,
                    56.1236111
                ],
                [
                    86.4519756,
                    56.1229891
                ],
                [
                    86.4504512,
                    56.1228052
                ],
                [
                    86.4504198,
                    56.122665
                ],
                [
                    86.451237,
                    56.1223497
                ],
                [
                    86.4521014,
                    56.1224373
                ],
                [
                    86.4528871,
                    56.1221394
                ],
                [
                    86.4545372,
                    56.1195726
                ],
                [
                    86.4557315,
                    56.1182147
                ],
                [
                    86.456926,
                    56.1173561
                ],
                [
                    86.4566274,
                    56.1160769
                ],
                [
                    86.4568317,
                    56.1153322
                ],
                [
                    86.457256,
                    56.114973
                ],
                [
                    86.4576017,
                    56.1139478
                ],
                [
                    86.4559988,
                    56.1137113
                ],
                [
                    86.4548044,
                    56.1137726
                ],
                [
                    86.4530286,
                    56.114456
                ],
                [
                    86.4517556,
                    56.115341
                ],
                [
                    86.4517556,
                    56.115525
                ],
                [
                    86.4524,
                    56.1156739
                ],
                [
                    86.4523842,
                    56.1158754
                ],
                [
                    86.4541286,
                    56.1162697
                ],
                [
                    86.4538458,
                    56.1166114
                ],
                [
                    86.4518971,
                    56.1164449
                ],
                [
                    86.4513156,
                    56.1165413
                ],
                [
                    86.4508598,
                    56.1173824
                ],
                [
                    86.4490682,
                    56.1183549
                ],
                [
                    86.4467739,
                    56.1183023
                ],
                [
                    86.445328,
                    56.1185213
                ],
                [
                    86.4446679,
                    56.1190207
                ],
                [
                    86.4443065,
                    56.1189681
                ],
                [
                    86.4435522,
                    56.120107
                ],
                [
                    86.4435364,
                    56.1210444
                ],
                [
                    86.4429865,
                    56.1224723
                ],
                [
                    86.4450452,
                    56.1236899
                ],
                [
                    86.4461138,
                    56.1247849
                ],
                [
                    86.4459724,
                    56.1251703
                ],
                [
                    86.4451708,
                    56.1254594
                ],
                [
                    86.4442594,
                    56.1258272
                ],
                [
                    86.442845,
                    56.1259061
                ],
                [
                    86.4427507,
                    56.1260813
                ],
                [
                    86.4426093,
                    56.1263178
                ],
                [
                    86.4414464,
                    56.1263178
                ],
                [
                    86.4411791,
                    56.1267732
                ]
            ],
            "longitude": 86.4521212,
            "latitude": 56.1194504
        },
        "7632": {
            "name": "Новопокровка",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.457855,
            "latitude": 54.659309
        },
        "7633": {
            "name": "Инченково",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.466339,
            "latitude": 54.071568
        },
        "7634": {
            "name": "Красная Горка",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.468414,
            "latitude": 53.856632
        },
        "7635": {
            "name": "Ленинка",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.47187,
            "latitude": 54.913464
        },
        "7636": {
            "name": "Литвиновский",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.472603,
            "latitude": 54.70351
        },
        "7637": {
            "name": "Бердюгино",
            "population": 192,
            "type": "hamlet",
            "poly": [
                [
                    86.4690891,
                    54.8657003
                ],
                [
                    86.4714314,
                    54.8666854
                ],
                [
                    86.4708008,
                    54.8686813
                ],
                [
                    86.471071,
                    54.8725693
                ],
                [
                    86.48499,
                    54.8727508
                ],
                [
                    86.4947647,
                    54.8693034
                ],
                [
                    86.4944044,
                    54.8669187
                ],
                [
                    86.4947197,
                    54.8636005
                ],
                [
                    86.4921521,
                    54.8632116
                ],
                [
                    86.4894044,
                    54.8631857
                ],
                [
                    86.488053,
                    54.8638338
                ],
                [
                    86.4835936,
                    54.8631857
                ],
                [
                    86.483053,
                    54.8626672
                ],
                [
                    86.4837737,
                    54.8620709
                ],
                [
                    86.4839539,
                    54.8604116
                ],
                [
                    86.4767918,
                    54.8599709
                ],
                [
                    86.4690891,
                    54.8657003
                ]
            ],
            "longitude": 86.476547,
            "latitude": 54.868237
        },
        "7638": {
            "name": "Степной",
            "population": 236,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.477898,
            "latitude": 54.307652
        },
        "7639": {
            "name": "Красная Поляна",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.48246,
            "latitude": 53.91338
        },
        "7640": {
            "name": "Золх",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.49498,
            "latitude": 53.874142
        },
        "7641": {
            "name": "Пономаревка",
            "population": 18,
            "type": "hamlet",
            "poly": [
                [
                    86.4891127,
                    56.1248739
                ],
                [
                    86.4891127,
                    56.1250981
                ],
                [
                    86.49003,
                    56.1250936
                ],
                [
                    86.4908749,
                    56.1251923
                ],
                [
                    86.4943348,
                    56.1265781
                ],
                [
                    86.4944152,
                    56.1267395
                ],
                [
                    86.4933773,
                    56.1276903
                ],
                [
                    86.4944474,
                    56.1279907
                ],
                [
                    86.4955176,
                    56.127188
                ],
                [
                    86.4958796,
                    56.1272911
                ],
                [
                    86.4959601,
                    56.127475
                ],
                [
                    86.4968452,
                    56.1279862
                ],
                [
                    86.4973521,
                    56.1280176
                ],
                [
                    86.4978349,
                    56.1279638
                ],
                [
                    86.4983338,
                    56.1275019
                ],
                [
                    86.4983579,
                    56.1269996
                ],
                [
                    86.498543,
                    56.1269324
                ],
                [
                    86.499251,
                    56.1264301
                ],
                [
                    86.5022362,
                    56.1240262
                ],
                [
                    86.5026063,
                    56.1238109
                ],
                [
                    86.5027753,
                    56.1234521
                ],
                [
                    86.5036684,
                    56.1226807
                ],
                [
                    86.5042156,
                    56.1219317
                ],
                [
                    86.5018661,
                    56.1212409
                ],
                [
                    86.5021396,
                    56.1209584
                ],
                [
                    86.5001924,
                    56.120003
                ],
                [
                    86.496636,
                    56.1190072
                ],
                [
                    86.4953969,
                    56.1199178
                ],
                [
                    86.4927577,
                    56.121842
                ],
                [
                    86.4905933,
                    56.1235373
                ],
                [
                    86.4897886,
                    56.1232279
                ],
                [
                    86.4892978,
                    56.1238961
                ],
                [
                    86.4892334,
                    56.1244971
                ],
                [
                    86.4891127,
                    56.1248739
                ]
            ],
            "longitude": 86.4968644,
            "latitude": 56.1234678
        },
        "7642": {
            "name": "Юго-Александровка",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.500748,
            "latitude": 55.653996
        },
        "7643": {
            "name": "Углерод",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.501671,
            "latitude": 54.093014
        },
        "7644": {
            "name": "Воскресенка",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.502167,
            "latitude": 55.208824
        },
        "7645": {
            "name": "Заря",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.514969,
            "latitude": 54.528042
        },
        "7646": {
            "name": "Чистугаш",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.516953,
            "latitude": 53.830463
        },
        "7647": {
            "name": "Центральный",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.523453,
            "latitude": 53.951107
        },
        "7648": {
            "name": "Хахалино",
            "population": 185,
            "type": "hamlet",
            "poly": [
                [
                    86.5183702,
                    54.4733224
                ],
                [
                    86.5187526,
                    54.4769364
                ],
                [
                    86.5206246,
                    54.4767727
                ],
                [
                    86.5251535,
                    54.4773808
                ],
                [
                    86.528837,
                    54.4792169
                ],
                [
                    86.5333659,
                    54.4789012
                ],
                [
                    86.5349559,
                    54.4766557
                ],
                [
                    86.5333659,
                    54.4760944
                ],
                [
                    86.5324399,
                    54.4749599
                ],
                [
                    86.5292798,
                    54.4737903
                ],
                [
                    86.5272469,
                    54.47434
                ],
                [
                    86.5183702,
                    54.4733224
                ]
            ],
            "longitude": 86.525948,
            "latitude": 54.475731
        },
        "7649": {
            "name": "Максимово",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.532585,
            "latitude": 54.829113
        },
        "7650": {
            "name": "Кара-Чумыш",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.534645,
            "latitude": 53.781498
        },
        "7651": {
            "name": "Камешек",
            "population": 66,
            "type": "hamlet",
            "poly": [
                [
                    86.5376362,
                    54.4285191
                ],
                [
                    86.5493508,
                    54.4307672
                ],
                [
                    86.550619,
                    54.4296314
                ],
                [
                    86.548264,
                    54.4288352
                ],
                [
                    86.5435338,
                    54.4278283
                ],
                [
                    86.5386828,
                    54.4271725
                ],
                [
                    86.5376362,
                    54.4285191
                ]
            ],
            "longitude": 86.541008,
            "latitude": 54.428291
        },
        "7652": {
            "name": "Берёзовский",
            "population": 141,
            "type": "hamlet",
            "poly": [
                [
                    86.5416179,
                    56.2181813
                ],
                [
                    86.5514411,
                    56.2216233
                ],
                [
                    86.5517748,
                    56.2218706
                ],
                [
                    86.554073,
                    56.2218706
                ],
                [
                    86.5559636,
                    56.2208813
                ],
                [
                    86.559448,
                    56.2190676
                ],
                [
                    86.5610791,
                    56.2161201
                ],
                [
                    86.5571868,
                    56.2118943
                ],
                [
                    86.5555557,
                    56.2116469
                ],
                [
                    86.5539618,
                    56.2122241
                ],
                [
                    86.5521084,
                    56.2123272
                ],
                [
                    86.5498841,
                    56.2132136
                ],
                [
                    86.5499213,
                    56.2137496
                ],
                [
                    86.5479196,
                    56.2145535
                ],
                [
                    86.5447316,
                    56.2144298
                ],
                [
                    86.5426558,
                    56.2158521
                ],
                [
                    86.5422851,
                    56.2166766
                ],
                [
                    86.5427299,
                    56.2174187
                ],
                [
                    86.5417291,
                    56.2176866
                ],
                [
                    86.5416179,
                    56.2181813
                ]
            ],
            "longitude": 86.552849,
            "latitude": 56.217026
        },
        "7653": {
            "name": "Новопокровка",
            "population": 31,
            "type": "hamlet",
            "poly": [
                [
                    86.5499775,
                    56.5398854
                ],
                [
                    86.5565203,
                    56.5460046
                ],
                [
                    86.5530153,
                    56.5490961
                ],
                [
                    86.5564035,
                    56.5506739
                ],
                [
                    86.568496,
                    56.5470673
                ],
                [
                    86.5663345,
                    56.5452639
                ],
                [
                    86.5654582,
                    56.5452961
                ],
                [
                    86.5624789,
                    56.5436537
                ],
                [
                    86.5623037,
                    56.5420111
                ],
                [
                    86.5555272,
                    56.5380817
                ],
                [
                    86.5537747,
                    56.5378884
                ],
                [
                    86.5520501,
                    56.5384279
                ],
                [
                    86.5499775,
                    56.5398854
                ]
            ],
            "longitude": 86.561127,
            "latitude": 56.545685
        },
        "7654": {
            "name": "Азаново",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.570381,
            "latitude": 56.112835
        },
        "7655": {
            "name": "Октябринка",
            "population": 27,
            "type": "hamlet",
            "poly": [
                [
                    86.5638211,
                    54.0360529
                ],
                [
                    86.566909,
                    54.0388296
                ],
                [
                    86.5685976,
                    54.0385321
                ],
                [
                    86.5687665,
                    54.0387588
                ],
                [
                    86.5701174,
                    54.0392546
                ],
                [
                    86.5705517,
                    54.0395237
                ],
                [
                    86.5718301,
                    54.0410253
                ],
                [
                    86.5726022,
                    54.0411103
                ],
                [
                    86.5732776,
                    54.0405153
                ],
                [
                    86.5763896,
                    54.0389146
                ],
                [
                    86.5768961,
                    54.0382488
                ],
                [
                    86.5768238,
                    54.0380646
                ],
                [
                    86.576655,
                    54.0368888
                ],
                [
                    86.5767756,
                    54.0364779
                ],
                [
                    86.5749904,
                    54.0354012
                ],
                [
                    86.5750386,
                    54.0351887
                ],
                [
                    86.5745079,
                    54.0349337
                ],
                [
                    86.565365,
                    54.0324968
                ],
                [
                    86.5650515,
                    54.0333185
                ],
                [
                    86.5652686,
                    54.034452
                ],
                [
                    86.5646413,
                    54.0355004
                ],
                [
                    86.5646172,
                    54.0359537
                ],
                [
                    86.5638211,
                    54.0360529
                ]
            ],
            "longitude": 86.5721948,
            "latitude": 54.0362387
        },
        "7656": {
            "name": "Успенка",
            "population": 248,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.596245,
            "latitude": 55.717182
        },
        "7657": {
            "name": "Старосергеевка",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.598915,
            "latitude": 54.094997
        },
        "7658": {
            "name": "Нижний Тереш",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.60408,
            "latitude": 53.72345
        },
        "7659": {
            "name": "Долгополово",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.60762,
            "latitude": 54.77478
        },
        "7660": {
            "name": "Нижегородка",
            "population": 257,
            "type": "hamlet",
            "poly": [
                [
                    86.5956771,
                    56.4132226
                ],
                [
                    86.6034174,
                    56.4186353
                ],
                [
                    86.6077257,
                    56.4189988
                ],
                [
                    86.6148089,
                    56.4152424
                ],
                [
                    86.6191172,
                    56.410718
                ],
                [
                    86.6248859,
                    56.4064759
                ],
                [
                    86.6109387,
                    56.3983945
                ],
                [
                    86.6103545,
                    56.3971013
                ],
                [
                    86.6075067,
                    56.3971417
                ],
                [
                    86.6061923,
                    56.3983137
                ],
                [
                    86.6037825,
                    56.398637
                ],
                [
                    86.6041476,
                    56.3996876
                ],
                [
                    86.6024681,
                    56.4008999
                ],
                [
                    86.59889,
                    56.4093849
                ],
                [
                    86.5956771,
                    56.4132226
                ]
            ],
            "longitude": 86.608009,
            "latitude": 56.409424
        },
        "7661": {
            "name": "Задубровский",
            "population": 167,
            "type": "hamlet",
            "poly": [
                [
                    86.5993033,
                    54.4229667
                ],
                [
                    86.6024756,
                    54.4265641
                ],
                [
                    86.6064528,
                    54.4313694
                ],
                [
                    86.6098184,
                    54.433814
                ],
                [
                    86.6140212,
                    54.4355748
                ],
                [
                    86.6212353,
                    54.4381503
                ],
                [
                    86.6237795,
                    54.4363428
                ],
                [
                    86.6173223,
                    54.4344322
                ],
                [
                    86.6146975,
                    54.4324559
                ],
                [
                    86.610688,
                    54.4290277
                ],
                [
                    86.605519,
                    54.4255055
                ],
                [
                    86.6017671,
                    54.4221329
                ],
                [
                    86.5993033,
                    54.4229667
                ]
            ],
            "longitude": 86.611259,
            "latitude": 54.432007
        },
        "7662": {
            "name": "Петровский",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.618401,
            "latitude": 54.37719
        },
        "7663": {
            "name": "Тайбинка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.624199,
            "latitude": 53.931644
        },
        "7664": {
            "name": "Верх-Тереш",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.624275,
            "latitude": 53.745571
        },
        "7665": {
            "name": "Михайловский",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    86.6360483,
                    54.9989904
                ],
                [
                    86.6394816,
                    55.0009596
                ],
                [
                    86.6408942,
                    55.0021749
                ],
                [
                    86.6422282,
                    55.0039527
                ],
                [
                    86.6438762,
                    55.0054492
                ],
                [
                    86.6447394,
                    55.0067768
                ],
                [
                    86.6498011,
                    55.0060342
                ],
                [
                    86.6490948,
                    55.0051004
                ],
                [
                    86.6480158,
                    55.002535
                ],
                [
                    86.6474664,
                    55.0010384
                ],
                [
                    86.6467405,
                    54.999463
                ],
                [
                    86.6459558,
                    54.9965821
                ],
                [
                    86.6402075,
                    54.9974262
                ],
                [
                    86.6360483,
                    54.9989904
                ]
            ],
            "longitude": 86.644394,
            "latitude": 55.001457
        },
        "7666": {
            "name": "Ивановка",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.651443,
            "latitude": 54.196156
        },
        "7667": {
            "name": "Нижняя Суета",
            "population": 30,
            "type": "hamlet",
            "poly": [
                [
                    86.6494582,
                    55.5256625
                ],
                [
                    86.6504734,
                    55.5303738
                ],
                [
                    86.653886,
                    55.5307074
                ],
                [
                    86.6570625,
                    55.5241844
                ],
                [
                    86.6572177,
                    55.5207246
                ],
                [
                    86.6557071,
                    55.517658
                ],
                [
                    86.6530545,
                    55.5180444
                ],
                [
                    86.6528728,
                    55.5219421
                ],
                [
                    86.6494582,
                    55.5256625
                ]
            ],
            "longitude": 86.652046,
            "latitude": 55.526588
        },
        "7668": {
            "name": "Глухаринка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    86.6488966,
                    55.7665954
                ],
                [
                    86.6522379,
                    55.7685072
                ],
                [
                    86.6534658,
                    55.7699048
                ],
                [
                    86.6530375,
                    55.7706919
                ],
                [
                    86.653523,
                    55.7708044
                ],
                [
                    86.6544368,
                    55.7703546
                ],
                [
                    86.6554934,
                    55.7703385
                ],
                [
                    86.657978,
                    55.767977
                ],
                [
                    86.6544368,
                    55.766001
                ],
                [
                    86.6525599,
                    55.7661922
                ],
                [
                    86.6500743,
                    55.766258
                ],
                [
                    86.6488966,
                    55.7665954
                ]
            ],
            "longitude": 86.65435,
            "latitude": 55.76796
        },
        "7669": {
            "name": "Ускат",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6647781,
            "latitude": 54.0888064
        },
        "7670": {
            "name": "Новоорловка",
            "population": 42,
            "type": "hamlet",
            "poly": [
                [
                    86.6621275,
                    56.5642528
                ],
                [
                    86.6720875,
                    56.5664446
                ],
                [
                    86.6740317,
                    56.5693943
                ],
                [
                    86.679894,
                    56.5705807
                ],
                [
                    86.6885978,
                    56.571108
                ],
                [
                    86.6976006,
                    56.5692789
                ],
                [
                    86.6934133,
                    56.5665764
                ],
                [
                    86.6793257,
                    56.5637254
                ],
                [
                    86.6775909,
                    56.5631156
                ],
                [
                    86.6766039,
                    56.5624399
                ],
                [
                    86.6692461,
                    56.5613521
                ],
                [
                    86.6641315,
                    56.5612532
                ],
                [
                    86.6621275,
                    56.5642528
                ]
            ],
            "longitude": 86.677124,
            "latitude": 56.565548
        },
        "7671": {
            "name": "Красный Холм",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.678986,
            "latitude": 53.631226
        },
        "7672": {
            "name": "Антоновка",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.680717,
            "latitude": 54.251328
        },
        "7673": {
            "name": "Кутоново",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.688599,
            "latitude": 54.094521
        },
        "7674": {
            "name": "Таловая",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.708221,
            "latitude": 53.683647
        },
        "7675": {
            "name": "Лукьяновка",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.709221,
            "latitude": 54.220104
        },
        "7676": {
            "name": "Новодубровка",
            "population": 173,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.717278,
            "latitude": 54.370323
        },
        "7677": {
            "name": "Ивановка",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.723236,
            "latitude": 55.140297
        },
        "7678": {
            "name": "Большекитатский",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    86.7178295,
                    55.8395704
                ],
                [
                    86.7262753,
                    55.8462131
                ],
                [
                    86.7356955,
                    55.8442803
                ],
                [
                    86.7370028,
                    55.8442191
                ],
                [
                    86.7388547,
                    55.8432405
                ],
                [
                    86.7385279,
                    55.8423842
                ],
                [
                    86.7315558,
                    55.8381635
                ],
                [
                    86.7309148,
                    55.8374463
                ],
                [
                    86.7300224,
                    55.8374664
                ],
                [
                    86.7299867,
                    55.8349806
                ],
                [
                    86.7178295,
                    55.8395704
                ]
            ],
            "longitude": 86.731377,
            "latitude": 55.841335
        },
        "7679": {
            "name": "Новый Путь",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.735893,
            "latitude": 53.717159
        },
        "7680": {
            "name": "Новорождественское",
            "population": 264,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.747742,
            "latitude": 53.767906
        },
        "7681": {
            "name": "Комаровка",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.751488,
            "latitude": 55.158268
        },
        "7682": {
            "name": "Маяковка",
            "population": 238,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.765625,
            "latitude": 54.005802
        },
        "7683": {
            "name": "Котовский",
            "population": 44,
            "type": "hamlet",
            "poly": [
                [
                    86.7616647,
                    56.3691112
                ],
                [
                    86.7633396,
                    56.3742626
                ],
                [
                    86.7683944,
                    56.3778566
                ],
                [
                    86.7704283,
                    56.3776579
                ],
                [
                    86.7820931,
                    56.3732523
                ],
                [
                    86.7813752,
                    56.3681172
                ],
                [
                    86.7671382,
                    56.3655992
                ],
                [
                    86.762233,
                    56.3677362
                ],
                [
                    86.7616647,
                    56.3691112
                ]
            ],
            "longitude": 86.769432,
            "latitude": 56.37178
        },
        "7684": {
            "name": "Змеинка",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.774567,
            "latitude": 55.095875
        },
        "7685": {
            "name": "Поперечное",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.787529,
            "latitude": 54.872429
        },
        "7686": {
            "name": "Малая Златогорка",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    86.7859687,
                    55.8176701
                ],
                [
                    86.7903612,
                    55.8202553
                ],
                [
                    86.7903612,
                    55.8229578
                ],
                [
                    86.7981699,
                    55.8238978
                ],
                [
                    86.8034687,
                    55.8187277
                ],
                [
                    86.7893851,
                    55.8137527
                ],
                [
                    86.7860384,
                    55.8153589
                ],
                [
                    86.7859687,
                    55.8176701
                ]
            ],
            "longitude": 86.791428,
            "latitude": 55.81657
        },
        "7687": {
            "name": "Бенжереп 2-й",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.795395,
            "latitude": 53.262932
        },
        "7688": {
            "name": "Мостовая",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.799026,
            "latitude": 53.462486
        },
        "7689": {
            "name": "Пушкино",
            "population": 143,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.800369,
            "latitude": 54.191242
        },
        "7690": {
            "name": "Егултыс",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.805946,
            "latitude": 54.022526
        },
        "7691": {
            "name": "Чапаевский",
            "population": 209,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.806892,
            "latitude": 54.140015
        },
        "7692": {
            "name": "Большая Златогорка",
            "population": 22,
            "type": "hamlet",
            "poly": [
                [
                    86.8103667,
                    55.8480233
                ],
                [
                    86.8114823,
                    55.8497063
                ],
                [
                    86.812807,
                    55.8500977
                ],
                [
                    86.8130161,
                    55.8508804
                ],
                [
                    86.8167811,
                    55.8529547
                ],
                [
                    86.8179663,
                    55.8528373
                ],
                [
                    86.8197093,
                    55.8506848
                ],
                [
                    86.8169205,
                    55.8487278
                ],
                [
                    86.8166416,
                    55.8481016
                ],
                [
                    86.8139922,
                    55.8472013
                ],
                [
                    86.8113428,
                    55.8474362
                ],
                [
                    86.8103667,
                    55.8480233
                ]
            ],
            "longitude": 86.81488,
            "latitude": 55.849461
        },
        "7693": {
            "name": "Тихеевка",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    86.8085397,
                    55.735064
                ],
                [
                    86.8107529,
                    55.7385609
                ],
                [
                    86.8140728,
                    55.7403092
                ],
                [
                    86.8155007,
                    55.7404499
                ],
                [
                    86.8169285,
                    55.7405906
                ],
                [
                    86.8207124,
                    55.7392442
                ],
                [
                    86.8206054,
                    55.7377771
                ],
                [
                    86.8200342,
                    55.7351242
                ],
                [
                    86.820641,
                    55.733858
                ],
                [
                    86.8200698,
                    55.7326923
                ],
                [
                    86.8168928,
                    55.732833
                ],
                [
                    86.8125021,
                    55.7315868
                ],
                [
                    86.8085397,
                    55.735064
                ]
            ],
            "longitude": 86.816063,
            "latitude": 55.737011
        },
        "7694": {
            "name": "Новохудяково",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.8246,
            "latitude": 54.508743
        },
        "7695": {
            "name": "Иверка",
            "population": 181,
            "type": "hamlet",
            "poly": [
                [
                    86.8081743,
                    55.9436738
                ],
                [
                    86.8105395,
                    55.9441153
                ],
                [
                    86.8132425,
                    55.9499175
                ],
                [
                    86.8207886,
                    55.9508003
                ],
                [
                    86.8533379,
                    55.9501067
                ],
                [
                    86.8441025,
                    55.9362306
                ],
                [
                    86.8418499,
                    55.9334548
                ],
                [
                    86.83757,
                    55.9354735
                ],
                [
                    86.8353176,
                    55.9347165
                ],
                [
                    86.8341913,
                    55.935789
                ],
                [
                    86.8297988,
                    55.936546
                ],
                [
                    86.8257442,
                    55.9354735
                ],
                [
                    86.8236043,
                    55.933644
                ],
                [
                    86.8228159,
                    55.9345273
                ],
                [
                    86.8193244,
                    55.9364829
                ],
                [
                    86.8163961,
                    55.9355366
                ],
                [
                    86.8143688,
                    55.9356628
                ],
                [
                    86.8125668,
                    55.9376184
                ],
                [
                    86.8106521,
                    55.9375553
                ],
                [
                    86.8081743,
                    55.9436738
                ]
            ],
            "longitude": 86.826958,
            "latitude": 55.943478
        },
        "7696": {
            "name": "Ускатский",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.829109,
            "latitude": 54.100632
        },
        "7697": {
            "name": "Ломачёвка",
            "population": 78,
            "type": "hamlet",
            "poly": [
                [
                    86.8145372,
                    56.1358281
                ],
                [
                    86.8270696,
                    56.1414763
                ],
                [
                    86.837609,
                    56.1403126
                ],
                [
                    86.8512911,
                    56.1367998
                ],
                [
                    86.8426871,
                    56.1318023
                ],
                [
                    86.8272612,
                    56.133009
                ],
                [
                    86.8145372,
                    56.1358281
                ]
            ],
            "longitude": 86.835274,
            "latitude": 56.137012
        },
        "7698": {
            "name": "Апанас",
            "population": 136,
            "type": "hamlet",
            "poly": [
                [
                    86.8311201,
                    53.5295027
                ],
                [
                    86.8321695,
                    53.5309703
                ],
                [
                    86.8344553,
                    53.533159
                ],
                [
                    86.8375886,
                    53.5348602
                ],
                [
                    86.8394769,
                    53.5364926
                ],
                [
                    86.8442834,
                    53.5383289
                ],
                [
                    86.8487466,
                    53.5398591
                ],
                [
                    86.8523515,
                    53.538941
                ],
                [
                    86.8520082,
                    53.5358804
                ],
                [
                    86.8521798,
                    53.53384
                ],
                [
                    86.84806,
                    53.5320034
                ],
                [
                    86.8479691,
                    53.5314832
                ],
                [
                    86.8501199,
                    53.5298607
                ],
                [
                    86.852366,
                    53.5250602
                ],
                [
                    86.838899,
                    53.5210499
                ],
                [
                    86.8398731,
                    53.5189391
                ],
                [
                    86.834286,
                    53.5212561
                ],
                [
                    86.8343131,
                    53.5247471
                ],
                [
                    86.8348325,
                    53.5263549
                ],
                [
                    86.8323883,
                    53.5278448
                ],
                [
                    86.8314921,
                    53.5285453
                ],
                [
                    86.8311201,
                    53.5295027
                ]
            ],
            "longitude": 86.836967,
            "latitude": 53.531898
        },
        "7699": {
            "name": "Алексеевка",
            "population": 38,
            "type": "hamlet",
            "poly": [
                [
                    86.8288317,
                    53.561151
                ],
                [
                    86.8309592,
                    53.5624045
                ],
                [
                    86.8322671,
                    53.5628056
                ],
                [
                    86.8341542,
                    53.563405
                ],
                [
                    86.8365989,
                    53.5633808
                ],
                [
                    86.8383966,
                    53.5631597
                ],
                [
                    86.83854,
                    53.5629341
                ],
                [
                    86.8393043,
                    53.5630061
                ],
                [
                    86.8399109,
                    53.5633664
                ],
                [
                    86.8441791,
                    53.5631961
                ],
                [
                    86.8462439,
                    53.5633088
                ],
                [
                    86.8467334,
                    53.5632257
                ],
                [
                    86.8468626,
                    53.5626963
                ],
                [
                    86.8447023,
                    53.5620187
                ],
                [
                    86.8437684,
                    53.5608684
                ],
                [
                    86.8413911,
                    53.5602823
                ],
                [
                    86.8392194,
                    53.5599724
                ],
                [
                    86.8386241,
                    53.5602155
                ],
                [
                    86.8366232,
                    53.5598355
                ],
                [
                    86.8349906,
                    53.5589981
                ],
                [
                    86.8349611,
                    53.5584374
                ],
                [
                    86.8354221,
                    53.5578537
                ],
                [
                    86.8350137,
                    53.5576055
                ],
                [
                    86.833197,
                    53.5584515
                ],
                [
                    86.8335173,
                    53.5590211
                ],
                [
                    86.8320269,
                    53.5599716
                ],
                [
                    86.8311822,
                    53.5598873
                ],
                [
                    86.8288317,
                    53.561151
                ]
            ],
            "longitude": 86.838959,
            "latitude": 53.561771
        },
        "7700": {
            "name": "Листвянка",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    86.829627,
                    56.0132167
                ],
                [
                    86.8352411,
                    56.0163339
                ],
                [
                    86.846469,
                    56.0114801
                ],
                [
                    86.8514095,
                    56.0072744
                ],
                [
                    86.8492387,
                    56.0058515
                ],
                [
                    86.8396949,
                    56.008781
                ],
                [
                    86.8389838,
                    56.0086764
                ],
                [
                    86.8383849,
                    56.0093459
                ],
                [
                    86.8354282,
                    56.0099527
                ],
                [
                    86.8343428,
                    56.0107269
                ],
                [
                    86.8326586,
                    56.0108733
                ],
                [
                    86.8310867,
                    56.0119613
                ],
                [
                    86.8296645,
                    56.0125681
                ],
                [
                    86.829627,
                    56.0132167
                ]
            ],
            "longitude": 86.840584,
            "latitude": 56.010967
        },
        "7701": {
            "name": "Майский",
            "population": 213,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.847122,
            "latitude": 54.301121
        },
        "7702": {
            "name": "Хлебозавода",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.8564318,
            "latitude": 54.0015681
        },
        "7703": {
            "name": "Первомайский",
            "population": 254,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.861053,
            "latitude": 53.935207
        },
        "7704": {
            "name": "Ананьино",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.866562,
            "latitude": 53.573742
        },
        "7705": {
            "name": "Ключи",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.874184,
            "latitude": 53.964291
        },
        "7706": {
            "name": "Фомиха",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.876816,
            "latitude": 55.032959
        },
        "7707": {
            "name": "Большая Песчанка",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.877815,
            "latitude": 56.235176
        },
        "7708": {
            "name": "Матюшино",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.885094,
            "latitude": 53.746452
        },
        "7709": {
            "name": "Красная Тайга",
            "population": 138,
            "type": "hamlet",
            "poly": [
                [
                    86.8737225,
                    55.8989811
                ],
                [
                    86.8737682,
                    55.899455
                ],
                [
                    86.8780404,
                    55.9033743
                ],
                [
                    86.88103,
                    55.9067183
                ],
                [
                    86.8864961,
                    55.9043108
                ],
                [
                    86.8888386,
                    55.9043733
                ],
                [
                    86.8913487,
                    55.9057803
                ],
                [
                    86.8934682,
                    55.9056552
                ],
                [
                    86.8948626,
                    55.9051237
                ],
                [
                    86.8907909,
                    55.8966183
                ],
                [
                    86.8888386,
                    55.895555
                ],
                [
                    86.8880579,
                    55.896931
                ],
                [
                    86.8861615,
                    55.8975252
                ],
                [
                    86.8850459,
                    55.8975252
                ],
                [
                    86.8822013,
                    55.8964306
                ],
                [
                    86.8808627,
                    55.8973376
                ],
                [
                    86.8808627,
                    55.8985259
                ],
                [
                    86.8797471,
                    55.8984946
                ],
                [
                    86.8789105,
                    55.8974627
                ],
                [
                    86.8774045,
                    55.8971187
                ],
                [
                    86.8765678,
                    55.8974627
                ],
                [
                    86.8775718,
                    55.8981194
                ],
                [
                    86.8771814,
                    55.8985885
                ],
                [
                    86.8765554,
                    55.8979308
                ],
                [
                    86.8753903,
                    55.8980333
                ],
                [
                    86.8747506,
                    55.8984432
                ],
                [
                    86.874682,
                    55.8989683
                ],
                [
                    86.8737225,
                    55.8989811
                ]
            ],
            "longitude": 86.885147,
            "latitude": 55.902504
        },
        "7710": {
            "name": "Шарово",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.88961,
            "latitude": 53.309799
        },
        "7711": {
            "name": "Мунай",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.9067,
            "latitude": 53.215073
        },
        "7712": {
            "name": "Иверка",
            "population": 53,
            "type": "hamlet",
            "poly": [
                [
                    86.8884884,
                    56.1583799
                ],
                [
                    86.8938048,
                    56.1593429
                ],
                [
                    86.9060566,
                    56.1593293
                ],
                [
                    86.9205159,
                    56.1589673
                ],
                [
                    86.9247593,
                    56.1580385
                ],
                [
                    86.9242564,
                    56.1556821
                ],
                [
                    86.9148498,
                    56.154999
                ],
                [
                    86.9121641,
                    56.1523829
                ],
                [
                    86.9059094,
                    56.1519115
                ],
                [
                    86.9054706,
                    56.1532833
                ],
                [
                    86.9016565,
                    56.1540757
                ],
                [
                    86.8959291,
                    56.154629
                ],
                [
                    86.8884951,
                    56.1553574
                ],
                [
                    86.8884884,
                    56.1583799
                ]
            ],
            "longitude": 86.906998,
            "latitude": 56.155556
        },
        "7713": {
            "name": "Левашовка",
            "population": 55,
            "type": "hamlet",
            "poly": [
                [
                    86.8964218,
                    56.5330481
                ],
                [
                    86.9005344,
                    56.5357695
                ],
                [
                    86.9026281,
                    56.5365323
                ],
                [
                    86.9048713,
                    56.5384288
                ],
                [
                    86.9110402,
                    56.5409231
                ],
                [
                    86.9123113,
                    56.5409025
                ],
                [
                    86.9160875,
                    56.5423248
                ],
                [
                    86.9170596,
                    56.5439944
                ],
                [
                    86.9177325,
                    56.5444066
                ],
                [
                    86.929547,
                    56.5394802
                ],
                [
                    86.9314537,
                    56.5372332
                ],
                [
                    86.9293974,
                    56.5360581
                ],
                [
                    86.9284627,
                    56.5346974
                ],
                [
                    86.9188916,
                    56.5316667
                ],
                [
                    86.9148911,
                    56.5303677
                ],
                [
                    86.9036001,
                    56.5284707
                ],
                [
                    86.899824,
                    56.530512
                ],
                [
                    86.8964218,
                    56.5330481
                ]
            ],
            "longitude": 86.912651,
            "latitude": 56.535812
        },
        "7714": {
            "name": "Урнас",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.926323,
            "latitude": 53.237438
        },
        "7715": {
            "name": "Рямовая",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.929298,
            "latitude": 54.560814
        },
        "7716": {
            "name": "Кандалеп",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.929749,
            "latitude": 53.273609
        },
        "7717": {
            "name": "Новый Урал",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.933632,
            "latitude": 53.596649
        },
        "7718": {
            "name": "75-й Пикет",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.938774,
            "latitude": 53.738247
        },
        "7719": {
            "name": "Верх-Кинерки",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.941864,
            "latitude": 53.580894
        },
        "7720": {
            "name": "Берёзовая Речка",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.943767,
            "latitude": 52.84432
        },
        "7721": {
            "name": "Островка",
            "population": 193,
            "type": "hamlet",
            "poly": [
                [
                    86.9220902,
                    56.3752874
                ],
                [
                    86.9380733,
                    56.3809804
                ],
                [
                    86.9407372,
                    56.381472
                ],
                [
                    86.9733576,
                    56.3853531
                ],
                [
                    86.9755542,
                    56.3806958
                ],
                [
                    86.9661606,
                    56.3775388
                ],
                [
                    86.9630762,
                    56.3768401
                ],
                [
                    86.9551781,
                    56.3737864
                ],
                [
                    86.951159,
                    56.37301
                ],
                [
                    86.9449433,
                    56.3705254
                ],
                [
                    86.9236793,
                    56.3726994
                ],
                [
                    86.9220902,
                    56.3752874
                ]
            ],
            "longitude": 86.945908,
            "latitude": 56.377693
        },
        "7722": {
            "name": "Тыхта",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.949242,
            "latitude": 54.31834
        },
        "7723": {
            "name": "Октябрь",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.950226,
            "latitude": 54.174789
        },
        "7724": {
            "name": "Тихоновка",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.960693,
            "latitude": 54.130859
        },
        "7725": {
            "name": "360 км",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.97007,
            "latitude": 53.783794
        },
        "7726": {
            "name": "Южный",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.971382,
            "latitude": 53.683422
        },
        "7727": {
            "name": "Калмыковский",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.979248,
            "latitude": 53.628208
        },
        "7728": {
            "name": "Сметанино",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.979515,
            "latitude": 53.874916
        },
        "7729": {
            "name": "Серп и Молот",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.981598,
            "latitude": 54.074429
        },
        "7730": {
            "name": "324 км",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.982079,
            "latitude": 56.162239
        },
        "7731": {
            "name": "Большая Сулага",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.994362,
            "latitude": 53.089993
        },
        "7732": {
            "name": "Вяземка",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    86.9877367,
                    55.8582953
                ],
                [
                    87.0218165,
                    55.8626776
                ],
                [
                    87.0276729,
                    55.8631471
                ],
                [
                    87.0283424,
                    55.8595787
                ],
                [
                    87.0269479,
                    55.8587648
                ],
                [
                    87.0228762,
                    55.8579822
                ],
                [
                    87.0174101,
                    55.8572935
                ],
                [
                    87.0131153,
                    55.8576692
                ],
                [
                    87.0096013,
                    55.8571683
                ],
                [
                    87.0080954,
                    55.8562292
                ],
                [
                    87.0036332,
                    55.8559474
                ],
                [
                    87.0018484,
                    55.8547264
                ],
                [
                    87.0005654,
                    55.8553839
                ],
                [
                    86.9997846,
                    55.8543821
                ],
                [
                    86.9947089,
                    55.855196
                ],
                [
                    86.9902468,
                    55.8554152
                ],
                [
                    86.9880715,
                    55.8566361
                ],
                [
                    86.9877367,
                    55.8582953
                ]
            ],
            "longitude": 87.004524,
            "latitude": 55.857639
        },
        "7733": {
            "name": "Ленинский",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.00547,
            "latitude": 53.685181
        },
        "7734": {
            "name": "Шарап",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.006256,
            "latitude": 53.828575
        },
        "7735": {
            "name": "Весёлый",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.007149,
            "latitude": 54.052818
        },
        "7736": {
            "name": "Загорские усадьбы",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    87.0020413,
                    53.7666987
                ],
                [
                    87.0042943,
                    53.7677006
                ],
                [
                    87.0053028,
                    53.7691084
                ],
                [
                    87.0069551,
                    53.7697806
                ],
                [
                    87.0093368,
                    53.7677894
                ],
                [
                    87.0100879,
                    53.7677767
                ],
                [
                    87.0111179,
                    53.7669523
                ],
                [
                    87.0116758,
                    53.7662294
                ],
                [
                    87.0120835,
                    53.7655699
                ],
                [
                    87.0114183,
                    53.7646066
                ],
                [
                    87.0108389,
                    53.7645812
                ],
                [
                    87.0101094,
                    53.7610676
                ],
                [
                    87.0063114,
                    53.7612579
                ],
                [
                    87.0065259,
                    53.7626532
                ],
                [
                    87.0066976,
                    53.7628942
                ],
                [
                    87.0071267,
                    53.765164
                ],
                [
                    87.0063328,
                    53.7660392
                ],
                [
                    87.0041655,
                    53.765443
                ],
                [
                    87.0020413,
                    53.7666987
                ]
            ],
            "longitude": 87.0083842,
            "latitude": 53.765899
        },
        "7737": {
            "name": "Юла",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0084,
            "latitude": 53.287758
        },
        "7738": {
            "name": "Михайловка",
            "population": 154,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.008667,
            "latitude": 53.627708
        },
        "7739": {
            "name": "Луговской",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0107576,
            "latitude": 52.7831669
        },
        "7740": {
            "name": "Подгорный",
            "population": 227,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0149,
            "latitude": 53.81424
        },
        "7741": {
            "name": "Глуховка",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.015518,
            "latitude": 53.769428
        },
        "7742": {
            "name": "Ивановка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.016281,
            "latitude": 53.784615
        },
        "7743": {
            "name": "Калиновский",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.018044,
            "latitude": 53.616302
        },
        "7744": {
            "name": "Мурюк",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0224161,
            "latitude": 55.545175
        },
        "7745": {
            "name": "Восточный",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0294256,
            "latitude": 53.9273395
        },
        "7746": {
            "name": "Учул",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.029869,
            "latitude": 53.608017
        },
        "7747": {
            "name": "Кирзаводский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.0435406,
            "latitude": 53.7206962
        },
        "7748": {
            "name": "Килинск",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.043999,
            "latitude": 53.333309
        },
        "7749": {
            "name": "Чигирь",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.044502,
            "latitude": 54.514072
        },
        "7750": {
            "name": "Пушкино",
            "population": 203,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.056068,
            "latitude": 53.677898
        },
        "7751": {
            "name": "Подгорная",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.057953,
            "latitude": 53.433304
        },
        "7752": {
            "name": "Новый",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.05806,
            "latitude": 53.701309
        },
        "7753": {
            "name": "Красинск",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.059692,
            "latitude": 53.633381
        },
        "7754": {
            "name": "Салтымаково",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.063148,
            "latitude": 54.823547
        },
        "7755": {
            "name": "Тунда",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    87.0459501,
                    56.0189859
                ],
                [
                    87.0734819,
                    56.0286999
                ],
                [
                    87.0798982,
                    56.0283088
                ],
                [
                    87.0895809,
                    56.0208115
                ],
                [
                    87.0805981,
                    56.0190511
                ],
                [
                    87.0635658,
                    56.0116172
                ],
                [
                    87.054233,
                    56.0144214
                ],
                [
                    87.0459501,
                    56.0189859
                ]
            ],
            "longitude": 87.06765,
            "latitude": 56.02095
        },
        "7756": {
            "name": "3669 км",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.074623,
            "latitude": 56.159607
        },
        "7757": {
            "name": "Белорус",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.075829,
            "latitude": 53.497353
        },
        "7758": {
            "name": "Кыргай",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.078911,
            "latitude": 54.269878
        },
        "7759": {
            "name": "Юрьевка",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.080025,
            "latitude": 53.566113
        },
        "7760": {
            "name": "Малиновка",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.086754,
            "latitude": 53.550957
        },
        "7761": {
            "name": "Малая Талда",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.089432,
            "latitude": 54.129871
        },
        "7762": {
            "name": "Нижние Кинерки",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.10276,
            "latitude": 53.530182
        },
        "7763": {
            "name": "Базарный",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.1048579,
            "latitude": 52.77414
        },
        "7764": {
            "name": "Митино",
            "population": 191,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.109283,
            "latitude": 53.825256
        },
        "7765": {
            "name": "Гавриловка",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.118553,
            "latitude": 53.61726
        },
        "7766": {
            "name": "Гавриловка",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.12529,
            "latitude": 53.392586
        },
        "7767": {
            "name": "Карагол",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.125938,
            "latitude": 52.778378
        },
        "7768": {
            "name": "Тагарыш",
            "population": 245,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.131142,
            "latitude": 54.014194
        },
        "7769": {
            "name": "Шартонка",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.137444,
            "latitude": 53.254383
        },
        "7770": {
            "name": "Новостройка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.1482083,
            "latitude": 53.2859445
        },
        "7771": {
            "name": "Рябиновка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.148567,
            "latitude": 53.456062
        },
        "7772": {
            "name": "Таргай",
            "population": 124,
            "type": "hamlet",
            "poly": [
                [
                    87.1360364,
                    53.5660024
                ],
                [
                    87.1368326,
                    53.5664036
                ],
                [
                    87.1385216,
                    53.5665898
                ],
                [
                    87.1402589,
                    53.5666186
                ],
                [
                    87.1413206,
                    53.5669482
                ],
                [
                    87.1436446,
                    53.5669498
                ],
                [
                    87.1453106,
                    53.5678474
                ],
                [
                    87.1445015,
                    53.5685361
                ],
                [
                    87.1427774,
                    53.5692858
                ],
                [
                    87.1451386,
                    53.5705678
                ],
                [
                    87.1473752,
                    53.5712691
                ],
                [
                    87.1500553,
                    53.5722928
                ],
                [
                    87.1527094,
                    53.5722498
                ],
                [
                    87.1548087,
                    53.571691
                ],
                [
                    87.1556772,
                    53.5708743
                ],
                [
                    87.1555808,
                    53.5698857
                ],
                [
                    87.1550017,
                    53.5690832
                ],
                [
                    87.155074,
                    53.5685387
                ],
                [
                    87.15665,
                    53.5681176
                ],
                [
                    87.1574146,
                    53.5674927
                ],
                [
                    87.1568596,
                    53.5665469
                ],
                [
                    87.1564773,
                    53.5651528
                ],
                [
                    87.1559741,
                    53.5636151
                ],
                [
                    87.153556,
                    53.5623786
                ],
                [
                    87.1528824,
                    53.5632677
                ],
                [
                    87.1511067,
                    53.5638693
                ],
                [
                    87.1501444,
                    53.5647789
                ],
                [
                    87.1503538,
                    53.5656629
                ],
                [
                    87.1487912,
                    53.5653217
                ],
                [
                    87.1464392,
                    53.5649892
                ],
                [
                    87.1449381,
                    53.5646877
                ],
                [
                    87.1430623,
                    53.5647517
                ],
                [
                    87.1410266,
                    53.5645668
                ],
                [
                    87.1386166,
                    53.5647923
                ],
                [
                    87.1366396,
                    53.5651999
                ],
                [
                    87.1361087,
                    53.5655152
                ],
                [
                    87.1360364,
                    53.5660024
                ]
            ],
            "longitude": 87.150703,
            "latitude": 53.567108
        },
        "7773": {
            "name": "Балластный Карьер",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.15477,
            "latitude": 53.304092
        },
        "7774": {
            "name": "Курья",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.15992,
            "latitude": 53.310429
        },
        "7775": {
            "name": "Крутая",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.163803,
            "latitude": 53.285923
        },
        "7776": {
            "name": "Ключи",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.167099,
            "latitude": 53.549343
        },
        "7777": {
            "name": "Правдинка",
            "population": 128,
            "type": "hamlet",
            "poly": [
                [
                    87.1582061,
                    56.3236396
                ],
                [
                    87.160715,
                    56.324751
                ],
                [
                    87.1620784,
                    56.325182
                ],
                [
                    87.1631692,
                    56.3257868
                ],
                [
                    87.1639192,
                    56.3264143
                ],
                [
                    87.1639737,
                    56.3274953
                ],
                [
                    87.1658689,
                    56.3276919
                ],
                [
                    87.1669597,
                    56.3280547
                ],
                [
                    87.1673823,
                    56.3287653
                ],
                [
                    87.1749497,
                    56.3322879
                ],
                [
                    87.1772404,
                    56.3341473
                ],
                [
                    87.1772949,
                    56.3360747
                ],
                [
                    87.1768586,
                    56.3363014
                ],
                [
                    87.179422,
                    56.3376241
                ],
                [
                    87.1821217,
                    56.338138
                ],
                [
                    87.1832534,
                    56.3388862
                ],
                [
                    87.1843714,
                    56.3389089
                ],
                [
                    87.1849304,
                    56.3384403
                ],
                [
                    87.1849577,
                    56.3381833
                ],
                [
                    87.1840871,
                    56.3378668
                ],
                [
                    87.1843442,
                    56.3376845
                ],
                [
                    87.1845448,
                    56.3372901
                ],
                [
                    87.183671,
                    56.3370826
                ],
                [
                    87.183671,
                    56.3367827
                ],
                [
                    87.1842535,
                    56.336529
                ],
                [
                    87.1860844,
                    56.337221
                ],
                [
                    87.1874574,
                    56.3371748
                ],
                [
                    87.1877488,
                    56.337613
                ],
                [
                    87.1916185,
                    56.3396427
                ],
                [
                    87.1919098,
                    56.3392275
                ],
                [
                    87.1945729,
                    56.3370595
                ],
                [
                    87.1933841,
                    56.3363695
                ],
                [
                    87.1893209,
                    56.3342456
                ],
                [
                    87.1837988,
                    56.3315245
                ],
                [
                    87.1837988,
                    56.3312599
                ],
                [
                    87.1792856,
                    56.3298237
                ],
                [
                    87.175427,
                    56.3279111
                ],
                [
                    87.1724955,
                    56.3262631
                ],
                [
                    87.1712138,
                    56.3253785
                ],
                [
                    87.1656235,
                    56.323496
                ],
                [
                    87.16441,
                    56.3235035
                ],
                [
                    87.16441,
                    56.323065
                ],
                [
                    87.1640555,
                    56.3226794
                ],
                [
                    87.1613285,
                    56.3215982
                ],
                [
                    87.1582743,
                    56.3231936
                ],
                [
                    87.1582061,
                    56.3236396
                ]
            ],
            "longitude": 87.171402,
            "latitude": 56.328552
        },
        "7778": {
            "name": "Букино",
            "population": 96,
            "type": "hamlet",
            "poly": [
                [
                    87.1697399,
                    53.6829275
                ],
                [
                    87.1749776,
                    53.684583
                ],
                [
                    87.1794825,
                    53.6862866
                ],
                [
                    87.1831733,
                    53.6863026
                ],
                [
                    87.1862671,
                    53.6829595
                ],
                [
                    87.1885739,
                    53.6813363
                ],
                [
                    87.1886552,
                    53.6809023
                ],
                [
                    87.1851544,
                    53.6802111
                ],
                [
                    87.183689,
                    53.6797128
                ],
                [
                    87.1824406,
                    53.6803558
                ],
                [
                    87.1791025,
                    53.6809666
                ],
                [
                    87.175656,
                    53.681272
                ],
                [
                    87.1710968,
                    53.681931
                ],
                [
                    87.1697399,
                    53.6829275
                ]
            ],
            "longitude": 87.1796952,
            "latitude": 53.6830489
        },
        "7779": {
            "name": "Летяжка",
            "population": 178,
            "type": "hamlet",
            "poly": [
                [
                    87.1761714,
                    55.9989929
                ],
                [
                    87.1820488,
                    55.9999282
                ],
                [
                    87.1838646,
                    56.0000083
                ],
                [
                    87.1895509,
                    55.9989662
                ],
                [
                    87.1928958,
                    55.9966948
                ],
                [
                    87.1951416,
                    55.9948777
                ],
                [
                    87.1962407,
                    55.9920448
                ],
                [
                    87.1968141,
                    55.9897998
                ],
                [
                    87.1962407,
                    55.9884367
                ],
                [
                    87.1938992,
                    55.9874744
                ],
                [
                    87.1940426,
                    55.9863518
                ],
                [
                    87.1958106,
                    55.9856033
                ],
                [
                    87.195715,
                    55.9853093
                ],
                [
                    87.1937081,
                    55.9840797
                ],
                [
                    87.1935648,
                    55.9831173
                ],
                [
                    87.1949505,
                    55.982155
                ],
                [
                    87.192848,
                    55.9793747
                ],
                [
                    87.1912233,
                    55.9791341
                ],
                [
                    87.1870184,
                    55.9791073
                ],
                [
                    87.1850113,
                    55.9818074
                ],
                [
                    87.1828134,
                    55.9851222
                ],
                [
                    87.1807587,
                    55.9875813
                ],
                [
                    87.1789429,
                    55.988891
                ],
                [
                    87.1784173,
                    55.9894256
                ],
                [
                    87.1789429,
                    55.9898532
                ],
                [
                    87.1801375,
                    55.9954121
                ],
                [
                    87.176267,
                    55.9985654
                ],
                [
                    87.1761714,
                    55.9989929
                ]
            ],
            "longitude": 87.187469,
            "latitude": 55.991966
        },
        "7780": {
            "name": "Осман",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.192383,
            "latitude": 53.285042
        },
        "7781": {
            "name": "Смирновка",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.196106,
            "latitude": 53.661396
        },
        "7782": {
            "name": "Тайлеп",
            "population": 248,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.20665,
            "latitude": 53.444622
        },
        "7783": {
            "name": "Туйла",
            "population": 132,
            "type": "hamlet",
            "poly": [
                [
                    87.1954291,
                    56.5948052
                ],
                [
                    87.1962462,
                    56.5963136
                ],
                [
                    87.1970393,
                    56.5967237
                ],
                [
                    87.1980487,
                    56.5967105
                ],
                [
                    87.1981689,
                    56.5973191
                ],
                [
                    87.2027111,
                    56.5996476
                ],
                [
                    87.2035281,
                    56.6020951
                ],
                [
                    87.2050664,
                    56.6017114
                ],
                [
                    87.2068688,
                    56.6021877
                ],
                [
                    87.2073735,
                    56.6027433
                ],
                [
                    87.206965,
                    56.6029417
                ],
                [
                    87.2081426,
                    56.6039868
                ],
                [
                    87.2053067,
                    56.6050715
                ],
                [
                    87.2042012,
                    56.6050186
                ],
                [
                    87.2015575,
                    56.6062223
                ],
                [
                    87.201173,
                    56.6067514
                ],
                [
                    87.199707,
                    56.6075053
                ],
                [
                    87.2020141,
                    56.6092116
                ],
                [
                    87.2049943,
                    56.6091851
                ],
                [
                    87.2061478,
                    56.6096216
                ],
                [
                    87.2079983,
                    56.6096348
                ],
                [
                    87.2088876,
                    56.6093439
                ],
                [
                    87.2102814,
                    56.6085503
                ],
                [
                    87.2111467,
                    56.6085503
                ],
                [
                    87.2118677,
                    56.6090396
                ],
                [
                    87.2149439,
                    56.6102432
                ],
                [
                    87.2159052,
                    56.6102697
                ],
                [
                    87.2183085,
                    56.6091322
                ],
                [
                    87.2173232,
                    56.6073202
                ],
                [
                    87.2221778,
                    56.6056138
                ],
                [
                    87.2217452,
                    56.6054419
                ],
                [
                    87.2217452,
                    56.604754
                ],
                [
                    87.2205676,
                    56.6043836
                ],
                [
                    87.2197505,
                    56.6043968
                ],
                [
                    87.2193659,
                    56.604635
                ],
                [
                    87.217924,
                    56.6040132
                ],
                [
                    87.2179,
                    56.603537
                ],
                [
                    87.217179,
                    56.6031005
                ],
                [
                    87.2167223,
                    56.6033518
                ],
                [
                    87.2160014,
                    56.602955
                ],
                [
                    87.2151842,
                    56.6018966
                ],
                [
                    87.2147276,
                    56.6018702
                ],
                [
                    87.2132856,
                    56.6022406
                ],
                [
                    87.2137663,
                    56.602955
                ],
                [
                    87.2117475,
                    56.6029417
                ],
                [
                    87.210642,
                    56.6023067
                ],
                [
                    87.209897,
                    56.6006531
                ],
                [
                    87.2050183,
                    56.5968428
                ],
                [
                    87.2042012,
                    56.5970677
                ],
                [
                    87.2027111,
                    56.5964327
                ],
                [
                    87.2026631,
                    56.5957976
                ],
                [
                    87.201149,
                    56.5951492
                ],
                [
                    87.199707,
                    56.5962607
                ],
                [
                    87.1974239,
                    56.5945671
                ],
                [
                    87.1965346,
                    56.5945671
                ],
                [
                    87.1954291,
                    56.5948052
                ]
            ],
            "longitude": 87.210487,
            "latitude": 56.604694
        },
        "7784": {
            "name": "Усть-Тала",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.210823,
            "latitude": 53.277893
        },
        "7785": {
            "name": "Зенкино",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    87.2075802,
                    56.4904455
                ],
                [
                    87.2103098,
                    56.4925956
                ],
                [
                    87.2132059,
                    56.4940473
                ],
                [
                    87.2140714,
                    56.4941025
                ],
                [
                    87.2148038,
                    56.4934042
                ],
                [
                    87.2201964,
                    56.495352
                ],
                [
                    87.2211951,
                    56.4950764
                ],
                [
                    87.2248568,
                    56.4968404
                ],
                [
                    87.2263881,
                    56.4960319
                ],
                [
                    87.224424,
                    56.4936247
                ],
                [
                    87.2234919,
                    56.4935328
                ],
                [
                    87.2198303,
                    56.4911071
                ],
                [
                    87.2184654,
                    56.4908314
                ],
                [
                    87.2181659,
                    56.4903169
                ],
                [
                    87.2153364,
                    56.4896736
                ],
                [
                    87.2132392,
                    56.489692
                ],
                [
                    87.2129729,
                    56.4887731
                ],
                [
                    87.2095109,
                    56.4879277
                ],
                [
                    87.2075802,
                    56.4904455
                ]
            ],
            "longitude": 87.215469,
            "latitude": 56.49107
        },
        "7786": {
            "name": "Иганино",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.22316,
            "latitude": 53.993893
        },
        "7787": {
            "name": "Зайцево",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.2373937,
            "latitude": 52.6296699
        },
        "7788": {
            "name": "Шорохово",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.242859,
            "latitude": 53.934383
        },
        "7789": {
            "name": "Малышев Лог",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    87.2210342,
                    53.5193086
                ],
                [
                    87.2249137,
                    53.5236766
                ],
                [
                    87.2257264,
                    53.5274267
                ],
                [
                    87.2289409,
                    53.5309355
                ],
                [
                    87.2246257,
                    53.533485
                ],
                [
                    87.2230829,
                    53.5365368
                ],
                [
                    87.2274431,
                    53.5379714
                ],
                [
                    87.2309472,
                    53.5384841
                ],
                [
                    87.2339899,
                    53.5398281
                ],
                [
                    87.2378952,
                    53.542094
                ],
                [
                    87.2422531,
                    53.5448914
                ],
                [
                    87.2456155,
                    53.5471239
                ],
                [
                    87.2486648,
                    53.5493651
                ],
                [
                    87.2509822,
                    53.5524502
                ],
                [
                    87.2570144,
                    53.5493856
                ],
                [
                    87.2530662,
                    53.5462239
                ],
                [
                    87.2505599,
                    53.5452243
                ],
                [
                    87.2509033,
                    53.5429802
                ],
                [
                    87.2517616,
                    53.5408381
                ],
                [
                    87.2551948,
                    53.53992
                ],
                [
                    87.2613533,
                    53.5403665
                ],
                [
                    87.260688,
                    53.5386958
                ],
                [
                    87.2547828,
                    53.5384714
                ],
                [
                    87.248603,
                    53.5387774
                ],
                [
                    87.2441398,
                    53.5365331
                ],
                [
                    87.2415649,
                    53.5330642
                ],
                [
                    87.2402603,
                    53.5305338
                ],
                [
                    87.2431098,
                    53.5301053
                ],
                [
                    87.2466117,
                    53.5277788
                ],
                [
                    87.2476417,
                    53.5253298
                ],
                [
                    87.2483283,
                    53.5224724
                ],
                [
                    87.2446548,
                    53.5222478
                ],
                [
                    87.2401916,
                    53.5218396
                ],
                [
                    87.2365867,
                    53.520717
                ],
                [
                    87.2350417,
                    53.5180634
                ],
                [
                    87.2359001,
                    53.5157158
                ],
                [
                    87.2215085,
                    53.5122369
                ],
                [
                    87.2218238,
                    53.5148993
                ],
                [
                    87.2210342,
                    53.5193086
                ]
            ],
            "longitude": 87.2429921,
            "latitude": 53.5422836
        },
        "7790": {
            "name": "Муратово",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.245712,
            "latitude": 53.680695
        },
        "7791": {
            "name": "Жерново",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.249168,
            "latitude": 54.171185
        },
        "7792": {
            "name": "Кульчаны",
            "population": 255,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.250687,
            "latitude": 53.620171
        },
        "7793": {
            "name": "Камышенка",
            "population": 205,
            "type": "hamlet",
            "poly": [
                [
                    87.2402968,
                    56.106775
                ],
                [
                    87.2403091,
                    56.1078556
                ],
                [
                    87.2407628,
                    56.1094421
                ],
                [
                    87.2412657,
                    56.109449
                ],
                [
                    87.2413393,
                    56.1096268
                ],
                [
                    87.2434978,
                    56.1094421
                ],
                [
                    87.2446628,
                    56.108984
                ],
                [
                    87.2460855,
                    56.1088745
                ],
                [
                    87.2479496,
                    56.1084642
                ],
                [
                    87.2516288,
                    56.1085463
                ],
                [
                    87.2523033,
                    56.1085052
                ],
                [
                    87.2523279,
                    56.1088061
                ],
                [
                    87.2541062,
                    56.1086147
                ],
                [
                    87.2541675,
                    56.1083753
                ],
                [
                    87.258742,
                    56.107329
                ],
                [
                    87.2590608,
                    56.1073358
                ],
                [
                    87.2591957,
                    56.1070691
                ],
                [
                    87.2678174,
                    56.1040667
                ],
                [
                    87.2683325,
                    56.1035674
                ],
                [
                    87.2676089,
                    56.1030544
                ],
                [
                    87.2653646,
                    56.1021037
                ],
                [
                    87.2634636,
                    56.1012213
                ],
                [
                    87.2621635,
                    56.1021105
                ],
                [
                    87.2604221,
                    56.102815
                ],
                [
                    87.2582269,
                    56.1035127
                ],
                [
                    87.2564241,
                    56.1044292
                ],
                [
                    87.2517304,
                    56.1055333
                ],
                [
                    87.2512198,
                    56.1043486
                ],
                [
                    87.2530237,
                    56.1039367
                ],
                [
                    87.2532231,
                    56.1033175
                ],
                [
                    87.2546423,
                    56.1030496
                ],
                [
                    87.2551405,
                    56.1028573
                ],
                [
                    87.2554854,
                    56.1025367
                ],
                [
                    87.2566735,
                    56.1020344
                ],
                [
                    87.2551788,
                    56.1010511
                ],
                [
                    87.2546548,
                    56.1012862
                ],
                [
                    87.2529176,
                    56.1002175
                ],
                [
                    87.2510397,
                    56.101158
                ],
                [
                    87.2501966,
                    56.1003671
                ],
                [
                    87.249545,
                    56.0995014
                ],
                [
                    87.2482803,
                    56.098486
                ],
                [
                    87.247073,
                    56.0978126
                ],
                [
                    87.2444094,
                    56.0985501
                ],
                [
                    87.2446777,
                    56.0999396
                ],
                [
                    87.2452334,
                    56.1011045
                ],
                [
                    87.2476479,
                    56.103584
                ],
                [
                    87.2479354,
                    56.1041611
                ],
                [
                    87.2487594,
                    56.1044175
                ],
                [
                    87.2507082,
                    56.1041334
                ],
                [
                    87.2509001,
                    56.1043721
                ],
                [
                    87.2512888,
                    56.1049264
                ],
                [
                    87.2514393,
                    56.105569
                ],
                [
                    87.2500222,
                    56.1058175
                ],
                [
                    87.2486732,
                    56.1058107
                ],
                [
                    87.2470175,
                    56.1061321
                ],
                [
                    87.2463185,
                    56.1061116
                ],
                [
                    87.245227,
                    56.1058723
                ],
                [
                    87.243044,
                    56.1061321
                ],
                [
                    87.2411185,
                    56.105927
                ],
                [
                    87.2407015,
                    56.1061048
                ],
                [
                    87.2402968,
                    56.106775
                ]
            ],
            "longitude": 87.253891,
            "latitude": 56.106659
        },
        "7794": {
            "name": "Подстрелка",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    87.2538311,
                    53.3565529
                ],
                [
                    87.2548163,
                    53.3575355
                ],
                [
                    87.255954,
                    53.3576337
                ],
                [
                    87.2556973,
                    53.359759
                ],
                [
                    87.2593273,
                    53.3607656
                ],
                [
                    87.2659272,
                    53.3604155
                ],
                [
                    87.2657269,
                    53.3601162
                ],
                [
                    87.2636723,
                    53.3570456
                ],
                [
                    87.2661289,
                    53.3567064
                ],
                [
                    87.2650106,
                    53.3555356
                ],
                [
                    87.2639839,
                    53.3557325
                ],
                [
                    87.2610777,
                    53.3533671
                ],
                [
                    87.2582333,
                    53.3533484
                ],
                [
                    87.2555848,
                    53.3543249
                ],
                [
                    87.2563181,
                    53.3552879
                ],
                [
                    87.2538311,
                    53.3565529
                ]
            ],
            "longitude": 87.260544,
            "latitude": 53.355209
        },
        "7795": {
            "name": "Карчагол",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.2642881,
            "latitude": 53.4055741
        },
        "7796": {
            "name": "Подкатунь",
            "population": 17,
            "type": "hamlet",
            "poly": [
                [
                    87.2652188,
                    53.2814017
                ],
                [
                    87.2673206,
                    53.2821179
                ],
                [
                    87.271395,
                    53.2833989
                ],
                [
                    87.2700603,
                    53.2804799
                ],
                [
                    87.2712545,
                    53.2794929
                ],
                [
                    87.2760665,
                    53.2796819
                ],
                [
                    87.2779281,
                    53.2773297
                ],
                [
                    87.2733268,
                    53.2747043
                ],
                [
                    87.272474,
                    53.2722663
                ],
                [
                    87.2800706,
                    53.2706295
                ],
                [
                    87.2856554,
                    53.2699153
                ],
                [
                    87.2864281,
                    53.268907
                ],
                [
                    87.2708681,
                    53.2690539
                ],
                [
                    87.2689012,
                    53.269075
                ],
                [
                    87.267145,
                    53.2692221
                ],
                [
                    87.2666426,
                    53.2793278
                ],
                [
                    87.2652188,
                    53.2814017
                ]
            ],
            "longitude": 87.2700189,
            "latitude": 53.2765382
        },
        "7797": {
            "name": "Новый Пункт",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.2744683,
            "latitude": 53.3914166
        },
        "7798": {
            "name": "Верхний Калтан",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.274635,
            "latitude": 53.492195
        },
        "7799": {
            "name": "Малая Щедруха",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.277657,
            "latitude": 53.873432
        },
        "7800": {
            "name": "Фёдоровка",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.279839,
            "latitude": 53.578087
        },
        "7801": {
            "name": "Шушталеп",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    87.2632629,
                    53.5648545
                ],
                [
                    87.2670394,
                    53.567862
                ],
                [
                    87.2839481,
                    53.5746917
                ],
                [
                    87.2883255,
                    53.5747645
                ],
                [
                    87.2905078,
                    53.5753811
                ],
                [
                    87.2953164,
                    53.5786745
                ],
                [
                    87.3007549,
                    53.5809772
                ],
                [
                    87.3045025,
                    53.5820262
                ],
                [
                    87.306351,
                    53.5828409
                ],
                [
                    87.3070881,
                    53.5825899
                ],
                [
                    87.3072383,
                    53.5819122
                ],
                [
                    87.3068821,
                    53.5809517
                ],
                [
                    87.3062813,
                    53.5793127
                ],
                [
                    87.3059508,
                    53.5781146
                ],
                [
                    87.305468,
                    53.5770323
                ],
                [
                    87.305173,
                    53.5764112
                ],
                [
                    87.3044156,
                    53.5746352
                ],
                [
                    87.3015791,
                    53.5749342
                ],
                [
                    87.2986694,
                    53.5745851
                ],
                [
                    87.2960373,
                    53.5748243
                ],
                [
                    87.3016829,
                    53.5703801
                ],
                [
                    87.2975888,
                    53.564898
                ],
                [
                    87.2907287,
                    53.5570035
                ],
                [
                    87.2896987,
                    53.5539443
                ],
                [
                    87.286523,
                    53.5506298
                ],
                [
                    87.2852844,
                    53.549703
                ],
                [
                    87.2758576,
                    53.5505402
                ],
                [
                    87.2708944,
                    53.5501361
                ],
                [
                    87.2715026,
                    53.5530265
                ],
                [
                    87.2715884,
                    53.5585841
                ],
                [
                    87.2730476,
                    53.5638859
                ],
                [
                    87.2632629,
                    53.5648545
                ]
            ],
            "longitude": 87.280998,
            "latitude": 53.567406
        },
        "7802": {
            "name": "Зелёный Луг",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.302467,
            "latitude": 53.478233
        },
        "7803": {
            "name": "Подкорчияк",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.30352,
            "latitude": 53.436646
        },
        "7804": {
            "name": "Николаевка 1-я",
            "population": 78,
            "type": "hamlet",
            "poly": [
                [
                    87.3019381,
                    56.2785728
                ],
                [
                    87.3031929,
                    56.2793092
                ],
                [
                    87.3037665,
                    56.2793291
                ],
                [
                    87.3067061,
                    56.2809014
                ],
                [
                    87.306742,
                    56.2812397
                ],
                [
                    87.3091799,
                    56.2826925
                ],
                [
                    87.3093233,
                    56.2831104
                ],
                [
                    87.3104706,
                    56.2833691
                ],
                [
                    87.309646,
                    56.2840656
                ],
                [
                    87.309646,
                    56.2844238
                ],
                [
                    87.3114027,
                    56.2846825
                ],
                [
                    87.3141273,
                    56.2850407
                ],
                [
                    87.3159199,
                    56.2860356
                ],
                [
                    87.3159916,
                    56.2866724
                ],
                [
                    87.3183219,
                    56.2887418
                ],
                [
                    87.3191463,
                    56.2888811
                ],
                [
                    87.3205446,
                    56.2882045
                ],
                [
                    87.3190389,
                    56.28713
                ],
                [
                    87.3204729,
                    56.2861948
                ],
                [
                    87.3201861,
                    56.2854984
                ],
                [
                    87.3157406,
                    56.2828119
                ],
                [
                    87.3152028,
                    56.2827323
                ],
                [
                    87.3128367,
                    56.2806228
                ],
                [
                    87.3124065,
                    56.2800655
                ],
                [
                    87.3117612,
                    56.2800257
                ],
                [
                    87.3053439,
                    56.2767616
                ],
                [
                    87.3036231,
                    56.2774384
                ],
                [
                    87.3048419,
                    56.2780355
                ],
                [
                    87.3040533,
                    56.2780355
                ],
                [
                    87.3033721,
                    56.2776175
                ],
                [
                    87.3019381,
                    56.2785728
                ]
            ],
            "longitude": 87.311577,
            "latitude": 56.283016
        },
        "7805": {
            "name": "Мокроусово",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.312881,
            "latitude": 53.937881
        },
        "7806": {
            "name": "Кедровка",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.3147287,
            "latitude": 53.127062
        },
        "7807": {
            "name": "Усково",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.323135,
            "latitude": 54.102093
        },
        "7808": {
            "name": "Бардина",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.3428213,
            "latitude": 53.9372583
        },
        "7809": {
            "name": "Таёжно-Александровка",
            "population": 40,
            "type": "hamlet",
            "poly": [
                [
                    87.326807,
                    56.5684279
                ],
                [
                    87.330738,
                    56.5697255
                ],
                [
                    87.3376511,
                    56.5714057
                ],
                [
                    87.3396675,
                    56.5716671
                ],
                [
                    87.3389219,
                    56.5719845
                ],
                [
                    87.3356009,
                    56.5724512
                ],
                [
                    87.3354992,
                    56.5733472
                ],
                [
                    87.3341097,
                    56.5734593
                ],
                [
                    87.3336693,
                    56.5728432
                ],
                [
                    87.3321782,
                    56.5728152
                ],
                [
                    87.3326357,
                    56.5738979
                ],
                [
                    87.3337879,
                    56.5739166
                ],
                [
                    87.3344148,
                    56.5745233
                ],
                [
                    87.3357195,
                    56.5744953
                ],
                [
                    87.3379222,
                    56.574738
                ],
                [
                    87.3391592,
                    56.5744766
                ],
                [
                    87.3395319,
                    56.574934
                ],
                [
                    87.3402266,
                    56.5749246
                ],
                [
                    87.3425649,
                    56.57471
                ],
                [
                    87.3421074,
                    56.5740846
                ],
                [
                    87.3428021,
                    56.5738139
                ],
                [
                    87.344361,
                    56.5747753
                ],
                [
                    87.3493086,
                    56.5734126
                ],
                [
                    87.3492917,
                    56.5727779
                ],
                [
                    87.349817,
                    56.5727965
                ],
                [
                    87.3502575,
                    56.5734686
                ],
                [
                    87.3526974,
                    56.5728339
                ],
                [
                    87.3511725,
                    56.5717418
                ],
                [
                    87.3547138,
                    56.5717884
                ],
                [
                    87.3569335,
                    56.570967
                ],
                [
                    87.3569842,
                    56.5707243
                ],
                [
                    87.3587804,
                    56.570743
                ],
                [
                    87.3604578,
                    56.5703229
                ],
                [
                    87.3604239,
                    56.5700896
                ],
                [
                    87.3591362,
                    56.5690907
                ],
                [
                    87.3600173,
                    56.5686613
                ],
                [
                    87.3621861,
                    56.5691001
                ],
                [
                    87.3630502,
                    56.5699402
                ],
                [
                    87.3656427,
                    56.5692401
                ],
                [
                    87.3671846,
                    56.5690721
                ],
                [
                    87.3685232,
                    56.5679985
                ],
                [
                    87.3691161,
                    56.5682132
                ],
                [
                    87.3701667,
                    56.5690347
                ],
                [
                    87.372522,
                    56.5696508
                ],
                [
                    87.3737589,
                    56.5688107
                ],
                [
                    87.3681165,
                    56.5667476
                ],
                [
                    87.3668965,
                    56.5666729
                ],
                [
                    87.3644058,
                    56.5654686
                ],
                [
                    87.3630672,
                    56.5663555
                ],
                [
                    87.362525,
                    56.5663275
                ],
                [
                    87.3618472,
                    56.565898
                ],
                [
                    87.3587804,
                    56.5669343
                ],
                [
                    87.359204,
                    56.5671957
                ],
                [
                    87.3577468,
                    56.5676158
                ],
                [
                    87.3548324,
                    56.5682226
                ],
                [
                    87.3518333,
                    56.5682132
                ],
                [
                    87.3515452,
                    56.5684279
                ],
                [
                    87.3499017,
                    56.5684373
                ],
                [
                    87.3486139,
                    56.5678305
                ],
                [
                    87.3477836,
                    56.5678025
                ],
                [
                    87.3470381,
                    56.5684466
                ],
                [
                    87.3470381,
                    56.5710137
                ],
                [
                    87.3451404,
                    56.5719845
                ],
                [
                    87.3412771,
                    56.5720311
                ],
                [
                    87.3394472,
                    56.5707337
                ],
                [
                    87.3366853,
                    56.570771
                ],
                [
                    87.3290097,
                    56.5677931
                ],
                [
                    87.3278914,
                    56.5677745
                ],
                [
                    87.326807,
                    56.5684279
                ]
            ],
            "longitude": 87.350288,
            "latitude": 56.570442
        },
        "7810": {
            "name": "Сухаринка",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.3532491,
            "latitude": 53.1324864
        },
        "7811": {
            "name": "Осиновка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.361237,
            "latitude": 54.275356
        },
        "7812": {
            "name": "Юрково",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.363487,
            "latitude": 53.510937
        },
        "7813": {
            "name": "Верх-Теш",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.3644259,
            "latitude": 53.3794527
        },
        "7814": {
            "name": "Тельбес",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.370018,
            "latitude": 53.229645
        },
        "7815": {
            "name": "Учулен",
            "population": 27,
            "type": "hamlet",
            "poly": [
                [
                    87.3650562,
                    53.1484748
                ],
                [
                    87.3675498,
                    53.1477768
                ],
                [
                    87.3687689,
                    53.1483751
                ],
                [
                    87.3715397,
                    53.1456165
                ],
                [
                    87.3736454,
                    53.1447856
                ],
                [
                    87.3768041,
                    53.1449518
                ],
                [
                    87.3783003,
                    53.1464475
                ],
                [
                    87.3784665,
                    53.1448521
                ],
                [
                    87.3806277,
                    53.1454504
                ],
                [
                    87.3831213,
                    53.1456498
                ],
                [
                    87.3850609,
                    53.148641
                ],
                [
                    87.3837309,
                    53.1491727
                ],
                [
                    87.385615,
                    53.1497377
                ],
                [
                    87.3870558,
                    53.1491727
                ],
                [
                    87.3883857,
                    53.1470125
                ],
                [
                    87.3862246,
                    53.1462148
                ],
                [
                    87.3848392,
                    53.1445196
                ],
                [
                    87.3847197,
                    53.1436745
                ],
                [
                    87.3881463,
                    53.1430938
                ],
                [
                    87.392437,
                    53.1439869
                ],
                [
                    87.3921627,
                    53.142659
                ],
                [
                    87.3842968,
                    53.1423834
                ],
                [
                    87.382952,
                    53.143234
                ],
                [
                    87.3763576,
                    53.1431676
                ],
                [
                    87.3714533,
                    53.1425693
                ],
                [
                    87.3699295,
                    53.143716
                ],
                [
                    87.3692645,
                    53.1449956
                ],
                [
                    87.3651916,
                    53.14694
                ],
                [
                    87.3650562,
                    53.1484748
                ]
            ],
            "longitude": 87.380386,
            "latitude": 53.144222
        },
        "7816": {
            "name": "Петровка",
            "population": 139,
            "type": "hamlet",
            "poly": [
                [
                    87.3827455,
                    56.2171961
                ],
                [
                    87.3829132,
                    56.2180752
                ],
                [
                    87.3837995,
                    56.2178887
                ],
                [
                    87.3854762,
                    56.218821
                ],
                [
                    87.388662,
                    56.217982
                ],
                [
                    87.391225,
                    56.2180752
                ],
                [
                    87.3933088,
                    56.2174758
                ],
                [
                    87.3929736,
                    56.2169431
                ],
                [
                    87.3942191,
                    56.2166101
                ],
                [
                    87.3946024,
                    56.2171029
                ],
                [
                    87.3966384,
                    56.2163304
                ],
                [
                    87.3985785,
                    56.2151982
                ],
                [
                    87.4031154,
                    56.211372
                ],
                [
                    87.4014291,
                    56.2108024
                ],
                [
                    87.3938598,
                    56.2128139
                ],
                [
                    87.3934526,
                    56.2125342
                ],
                [
                    87.3921113,
                    56.2129071
                ],
                [
                    87.3914166,
                    56.2125741
                ],
                [
                    87.3905543,
                    56.2129871
                ],
                [
                    87.3914406,
                    56.2140394
                ],
                [
                    87.3894525,
                    56.2144923
                ],
                [
                    87.3888057,
                    56.2151849
                ],
                [
                    87.3873684,
                    56.2158376
                ],
                [
                    87.3867218,
                    56.2155312
                ],
                [
                    87.385596,
                    56.2155312
                ],
                [
                    87.3847816,
                    56.215731
                ],
                [
                    87.3829851,
                    56.2168232
                ],
                [
                    87.3827455,
                    56.2171961
                ]
            ],
            "longitude": 87.391266,
            "latitude": 56.21656
        },
        "7817": {
            "name": "Веселая Грива",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.3912997,
            "latitude": 52.978193
        },
        "7818": {
            "name": "Боровой",
            "population": 98,
            "type": "hamlet",
            "poly": [
                [
                    87.3823996,
                    55.9090451
                ],
                [
                    87.3870512,
                    55.9120867
                ],
                [
                    87.3859068,
                    55.9131419
                ],
                [
                    87.4052511,
                    55.9208171
                ],
                [
                    87.4061371,
                    55.9168245
                ],
                [
                    87.3983846,
                    55.9127281
                ],
                [
                    87.4009319,
                    55.9099969
                ],
                [
                    87.3948406,
                    55.9071
                ],
                [
                    87.390706,
                    55.9079691
                ],
                [
                    87.387162,
                    55.9065619
                ],
                [
                    87.3823996,
                    55.9090451
                ]
            ],
            "longitude": 87.3945453,
            "latitude": 55.9131419
        },
        "7819": {
            "name": "Комиссаровка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    87.3995647,
                    56.1036338
                ],
                [
                    87.400173,
                    56.1040441
                ],
                [
                    87.4010757,
                    56.1043998
                ],
                [
                    87.4016545,
                    56.1040332
                ],
                [
                    87.4015564,
                    56.1030209
                ],
                [
                    87.4023707,
                    56.1029881
                ],
                [
                    87.4030771,
                    56.1030374
                ],
                [
                    87.4042937,
                    56.1032508
                ],
                [
                    87.4055103,
                    56.103103
                ],
                [
                    87.4069526,
                    56.1033
                ],
                [
                    87.410622,
                    56.1027036
                ],
                [
                    87.4106514,
                    56.1017296
                ],
                [
                    87.409268,
                    56.1010948
                ],
                [
                    87.4069918,
                    56.1009416
                ],
                [
                    87.4067564,
                    56.1010401
                ],
                [
                    87.4070605,
                    56.1019211
                ],
                [
                    87.4064424,
                    56.1019977
                ],
                [
                    87.4053534,
                    56.1006024
                ],
                [
                    87.4043231,
                    56.1006078
                ],
                [
                    87.4037247,
                    56.1000333
                ],
                [
                    87.4052552,
                    56.0998581
                ],
                [
                    87.4051768,
                    56.0996611
                ],
                [
                    87.4036266,
                    56.099798
                ],
                [
                    87.4034304,
                    56.0988731
                ],
                [
                    87.4048824,
                    56.0986488
                ],
                [
                    87.4046175,
                    56.0983861
                ],
                [
                    87.4024589,
                    56.098594
                ],
                [
                    87.4023217,
                    56.0970234
                ],
                [
                    87.4020175,
                    56.0968702
                ],
                [
                    87.4016447,
                    56.0968757
                ],
                [
                    87.401164,
                    56.0965309
                ],
                [
                    87.4008206,
                    56.096509
                ],
                [
                    87.4006832,
                    56.0967498
                ],
                [
                    87.4007813,
                    56.0971767
                ],
                [
                    87.4004183,
                    56.0973846
                ],
                [
                    87.4005655,
                    56.0979976
                ],
                [
                    87.4020273,
                    56.09791
                ],
                [
                    87.4021058,
                    56.0986925
                ],
                [
                    87.40085,
                    56.0987637
                ],
                [
                    87.4008892,
                    56.0992453
                ],
                [
                    87.4024002,
                    56.0992234
                ],
                [
                    87.4026061,
                    56.1000497
                ],
                [
                    87.4010854,
                    56.1001318
                ],
                [
                    87.4013896,
                    56.1024026
                ],
                [
                    87.4000455,
                    56.1028841
                ],
                [
                    87.3996432,
                    56.102906
                ],
                [
                    87.3995647,
                    56.1036338
                ]
            ],
            "longitude": 87.405167,
            "latitude": 56.102806
        },
        "7820": {
            "name": "Курейное",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.4142043,
            "latitude": 53.8544485
        },
        "7821": {
            "name": "Есаулка",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.43853,
            "latitude": 53.897438
        },
        "7822": {
            "name": "Красный Калтан",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.44072,
            "latitude": 53.609699
        },
        "7823": {
            "name": "Заборье",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    87.4319501,
                    56.5482931
                ],
                [
                    87.435789,
                    56.5492125
                ],
                [
                    87.4364773,
                    56.548979
                ],
                [
                    87.4374834,
                    56.5489936
                ],
                [
                    87.440475,
                    56.5500735
                ],
                [
                    87.4447111,
                    56.5523062
                ],
                [
                    87.4463789,
                    56.5519851
                ],
                [
                    87.4492383,
                    56.5533714
                ],
                [
                    87.450059,
                    56.5534152
                ],
                [
                    87.4498737,
                    56.5538529
                ],
                [
                    87.449556,
                    56.5540426
                ],
                [
                    87.4491853,
                    56.5537946
                ],
                [
                    87.4487882,
                    56.5539697
                ],
                [
                    87.4489205,
                    56.5546555
                ],
                [
                    87.4496089,
                    56.5549327
                ],
                [
                    87.450562,
                    56.5560271
                ],
                [
                    87.4528918,
                    56.554028
                ],
                [
                    87.4561483,
                    56.5533276
                ],
                [
                    87.4596165,
                    56.5518976
                ],
                [
                    87.4603843,
                    56.5518684
                ],
                [
                    87.4602519,
                    56.5508907
                ],
                [
                    87.4615757,
                    56.5505113
                ],
                [
                    87.4614433,
                    56.5496795
                ],
                [
                    87.4604108,
                    56.549373
                ],
                [
                    87.4593782,
                    56.549373
                ],
                [
                    87.4590341,
                    56.5496065
                ],
                [
                    87.4581869,
                    56.5495919
                ],
                [
                    87.4582663,
                    56.5471109
                ],
                [
                    87.4598017,
                    56.5471255
                ],
                [
                    87.460146,
                    56.547359
                ],
                [
                    87.4612844,
                    56.5473153
                ],
                [
                    87.4617345,
                    56.5467023
                ],
                [
                    87.4601195,
                    56.5454325
                ],
                [
                    87.4586634,
                    56.5453888
                ],
                [
                    87.4573926,
                    56.5460163
                ],
                [
                    87.4579486,
                    56.5462644
                ],
                [
                    87.4567572,
                    56.5471109
                ],
                [
                    87.4548245,
                    56.5471255
                ],
                [
                    87.4541097,
                    56.5463812
                ],
                [
                    87.4536596,
                    56.5439584
                ],
                [
                    87.4522035,
                    56.5440606
                ],
                [
                    87.451065,
                    56.5439
                ],
                [
                    87.4499266,
                    56.5435059
                ],
                [
                    87.4487088,
                    56.5435059
                ],
                [
                    87.4478616,
                    56.5444255
                ],
                [
                    87.4472262,
                    56.5446006
                ],
                [
                    87.446882,
                    56.544586
                ],
                [
                    87.4469085,
                    56.5441481
                ],
                [
                    87.445823,
                    56.5435205
                ],
                [
                    87.4450288,
                    56.5435205
                ],
                [
                    87.4438109,
                    56.5443671
                ],
                [
                    87.4430961,
                    56.5443379
                ],
                [
                    87.4423018,
                    56.5447758
                ],
                [
                    87.4427519,
                    56.5450239
                ],
                [
                    87.4411369,
                    56.5458558
                ],
                [
                    87.4407663,
                    56.5465126
                ],
                [
                    87.4396543,
                    56.5475634
                ],
                [
                    87.438913,
                    56.5475634
                ],
                [
                    87.4378275,
                    56.5469358
                ],
                [
                    87.4369803,
                    56.5466731
                ],
                [
                    87.4365303,
                    56.5469504
                ],
                [
                    87.4322943,
                    56.5475342
                ],
                [
                    87.4319501,
                    56.5482931
                ]
            ],
            "longitude": 87.446175,
            "latitude": 56.549126
        },
        "7824": {
            "name": "517 км",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.446251,
            "latitude": 52.9751964
        },
        "7825": {
            "name": "Юрьевка",
            "population": 38,
            "type": "hamlet",
            "poly": [
                [
                    87.4394752,
                    56.2287805
                ],
                [
                    87.4406302,
                    56.2309674
                ],
                [
                    87.4458459,
                    56.2309574
                ],
                [
                    87.4459,
                    56.2318201
                ],
                [
                    87.4448352,
                    56.2329035
                ],
                [
                    87.444763,
                    56.2332746
                ],
                [
                    87.4451601,
                    56.2339768
                ],
                [
                    87.4454488,
                    56.234057
                ],
                [
                    87.4460263,
                    56.2338664
                ],
                [
                    87.4463332,
                    56.2336257
                ],
                [
                    87.4467843,
                    56.2337862
                ],
                [
                    87.4468203,
                    56.2341272
                ],
                [
                    87.4472174,
                    56.2337762
                ],
                [
                    87.4479755,
                    56.233736
                ],
                [
                    87.4490222,
                    56.2339968
                ],
                [
                    87.449726,
                    56.2338564
                ],
                [
                    87.4509713,
                    56.234057
                ],
                [
                    87.4510435,
                    56.234388
                ],
                [
                    87.4514947,
                    56.2346087
                ],
                [
                    87.4520902,
                    56.2345184
                ],
                [
                    87.4527399,
                    56.2342576
                ],
                [
                    87.4530287,
                    56.2337461
                ],
                [
                    87.4533897,
                    56.2334652
                ],
                [
                    87.4541115,
                    56.2331442
                ],
                [
                    87.4541296,
                    56.232743
                ],
                [
                    87.4528663,
                    56.2300044
                ],
                [
                    87.4527219,
                    56.2290514
                ],
                [
                    87.4538047,
                    56.228309
                ],
                [
                    87.4539852,
                    56.2276268
                ],
                [
                    87.453534,
                    56.2263827
                ],
                [
                    87.45357,
                    56.2253995
                ],
                [
                    87.453913,
                    56.2248979
                ],
                [
                    87.4543281,
                    56.2237139
                ],
                [
                    87.4545808,
                    56.2234631
                ],
                [
                    87.4543823,
                    56.223132
                ],
                [
                    87.4509533,
                    56.223443
                ],
                [
                    87.4496358,
                    56.2237842
                ],
                [
                    87.4480657,
                    56.2238845
                ],
                [
                    87.4466941,
                    56.224647
                ],
                [
                    87.4449977,
                    56.2252892
                ],
                [
                    87.4445645,
                    56.2252992
                ],
                [
                    87.4428861,
                    56.2262022
                ],
                [
                    87.4418394,
                    56.2266837
                ],
                [
                    87.4412438,
                    56.2268944
                ],
                [
                    87.4405039,
                    56.2269546
                ],
                [
                    87.4394752,
                    56.2287805
                ]
            ],
            "longitude": 87.448402,
            "latitude": 56.228794
        },
        "7826": {
            "name": "Чёрный Калтан",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.45031,
            "latitude": 53.520149
        },
        "7827": {
            "name": "Усть-Нарык",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.452477,
            "latitude": 54.335739
        },
        "7828": {
            "name": "Ерунаково",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.453751,
            "latitude": 54.082523
        },
        "7829": {
            "name": "Петухов Лог",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.459946,
            "latitude": 52.9842
        },
        "7830": {
            "name": "Староабашево",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.466736,
            "latitude": 53.823566
        },
        "7831": {
            "name": "Керегеш",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.471069,
            "latitude": 53.904888
        },
        "7832": {
            "name": "Берёзовая Грива",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.482925,
            "latitude": 53.678314
        },
        "7833": {
            "name": "527 км",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.4968135,
            "latitude": 52.9177416
        },
        "7834": {
            "name": "Чистая Грива",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.49752,
            "latitude": 54.031353
        },
        "7835": {
            "name": "Бобровский",
            "population": 39,
            "type": "hamlet",
            "poly": [
                [
                    87.493374,
                    56.1592907
                ],
                [
                    87.4936957,
                    56.1597386
                ],
                [
                    87.4942162,
                    56.1597149
                ],
                [
                    87.4941925,
                    56.1598624
                ],
                [
                    87.4938282,
                    56.1601733
                ],
                [
                    87.4950867,
                    56.1605948
                ],
                [
                    87.4960707,
                    56.1605421
                ],
                [
                    87.4977454,
                    56.1602075
                ],
                [
                    87.4975704,
                    56.1606054
                ],
                [
                    87.4976934,
                    56.1608978
                ],
                [
                    87.498299,
                    56.1610295
                ],
                [
                    87.4985356,
                    56.1607476
                ],
                [
                    87.4990087,
                    56.1609426
                ],
                [
                    87.4992783,
                    56.1609347
                ],
                [
                    87.50004,
                    56.1605369
                ],
                [
                    87.5003996,
                    56.1602787
                ],
                [
                    87.5000211,
                    56.1600126
                ],
                [
                    87.5003428,
                    56.1597228
                ],
                [
                    87.5002766,
                    56.1594356
                ],
                [
                    87.5007023,
                    56.1586189
                ],
                [
                    87.5005273,
                    56.1585029
                ],
                [
                    87.5006976,
                    56.1582922
                ],
                [
                    87.5006929,
                    56.1577626
                ],
                [
                    87.5004753,
                    56.1575703
                ],
                [
                    87.5000115,
                    56.157428
                ],
                [
                    87.4996,
                    56.1574148
                ],
                [
                    87.4993919,
                    56.1576388
                ],
                [
                    87.4984788,
                    56.1574148
                ],
                [
                    87.4983132,
                    56.1571355
                ],
                [
                    87.4979678,
                    56.1568984
                ],
                [
                    87.4973907,
                    56.1567666
                ],
                [
                    87.4966999,
                    56.1568009
                ],
                [
                    87.4962931,
                    56.1570934
                ],
                [
                    87.4961322,
                    56.1574754
                ],
                [
                    87.4950867,
                    56.1583053
                ],
                [
                    87.4947508,
                    56.1583211
                ],
                [
                    87.4944716,
                    56.1582263
                ],
                [
                    87.4941452,
                    56.1583686
                ],
                [
                    87.4938424,
                    56.1589403
                ],
                [
                    87.493374,
                    56.1592907
                ]
            ],
            "longitude": 87.49752,
            "latitude": 56.15889
        },
        "7836": {
            "name": "Тоннель",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.502075,
            "latitude": 53.901798
        },
        "7837": {
            "name": "Кайдулы",
            "population": 115,
            "type": "hamlet",
            "poly": [
                [
                    87.4885862,
                    56.277858
                ],
                [
                    87.4894753,
                    56.2808672
                ],
                [
                    87.490852,
                    56.2803896
                ],
                [
                    87.4938061,
                    56.2804214
                ],
                [
                    87.4940355,
                    56.2802463
                ],
                [
                    87.4947526,
                    56.2802622
                ],
                [
                    87.4953261,
                    56.2804214
                ],
                [
                    87.4967028,
                    56.2830643
                ],
                [
                    87.4986244,
                    56.2837966
                ],
                [
                    87.5036435,
                    56.2837807
                ],
                [
                    87.5064541,
                    56.2833986
                ],
                [
                    87.5139399,
                    56.2867735
                ],
                [
                    87.5144561,
                    56.2867576
                ],
                [
                    87.5161196,
                    56.2858184
                ],
                [
                    87.5174676,
                    56.2858343
                ],
                [
                    87.518414,
                    56.2850383
                ],
                [
                    87.51698,
                    56.2830324
                ],
                [
                    87.5159762,
                    56.2824593
                ],
                [
                    87.5133089,
                    56.2824911
                ],
                [
                    87.5117315,
                    56.2818543
                ],
                [
                    87.5103835,
                    56.2807717
                ],
                [
                    87.5085766,
                    56.2804214
                ],
                [
                    87.5110431,
                    56.2789248
                ],
                [
                    87.5113586,
                    56.2781923
                ],
                [
                    87.5127353,
                    56.2782242
                ],
                [
                    87.5127353,
                    56.277237
                ],
                [
                    87.511674,
                    56.2763453
                ],
                [
                    87.5140833,
                    56.2750237
                ],
                [
                    87.5137103,
                    56.2746893
                ],
                [
                    87.5132802,
                    56.2746733
                ],
                [
                    87.5124198,
                    56.2750714
                ],
                [
                    87.5117315,
                    56.2746096
                ],
                [
                    87.5082038,
                    56.2746256
                ],
                [
                    87.5078883,
                    56.2748963
                ],
                [
                    87.5039304,
                    56.2750714
                ],
                [
                    87.5030699,
                    56.2746574
                ],
                [
                    87.502611,
                    56.2746893
                ],
                [
                    87.5019514,
                    56.2751033
                ],
                [
                    87.501177,
                    56.2751033
                ],
                [
                    87.5003453,
                    56.2747052
                ],
                [
                    87.5003453,
                    56.2739568
                ],
                [
                    87.499743,
                    56.2733994
                ],
                [
                    87.4987965,
                    56.2731287
                ],
                [
                    87.4982516,
                    56.2733198
                ],
                [
                    87.4983376,
                    56.2743867
                ],
                [
                    87.497764,
                    56.2748803
                ],
                [
                    87.4965308,
                    56.2750555
                ],
                [
                    87.4933472,
                    56.2751033
                ],
                [
                    87.4926876,
                    56.2758198
                ],
                [
                    87.4926876,
                    56.2769504
                ],
                [
                    87.4908807,
                    56.2780968
                ],
                [
                    87.4905652,
                    56.278049
                ],
                [
                    87.4895614,
                    56.2774599
                ],
                [
                    87.4892172,
                    56.2774918
                ],
                [
                    87.4885862,
                    56.277858
                ]
            ],
            "longitude": 87.503563,
            "latitude": 56.279125
        },
        "7838": {
            "name": "Казанка-20",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    87.4975377,
                    55.6538571
                ],
                [
                    87.4987127,
                    55.6543046
                ],
                [
                    87.5007982,
                    55.6546029
                ],
                [
                    87.5032363,
                    55.6541057
                ],
                [
                    87.5059976,
                    55.6529124
                ],
                [
                    87.5070549,
                    55.6515202
                ],
                [
                    87.5119312,
                    55.6520672
                ],
                [
                    87.5164255,
                    55.6514539
                ],
                [
                    87.5188049,
                    55.6528959
                ],
                [
                    87.5204205,
                    55.6522163
                ],
                [
                    87.5204792,
                    55.6493159
                ],
                [
                    87.5150743,
                    55.6472108
                ],
                [
                    87.5109912,
                    55.6453543
                ],
                [
                    87.5063794,
                    55.6454869
                ],
                [
                    87.5024138,
                    55.6476252
                ],
                [
                    87.4996233,
                    55.6512053
                ],
                [
                    87.4986538,
                    55.6513711
                ],
                [
                    87.4975377,
                    55.6538571
                ]
            ],
            "longitude": 87.5101981,
            "latitude": 55.6493324
        },
        "7839": {
            "name": "Тенеш",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5123828,
            "latitude": 53.0918027
        },
        "7840": {
            "name": "Каменный Карьер",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5130166,
            "latitude": 52.9989987
        },
        "7841": {
            "name": "Петропавловка",
            "population": 39,
            "type": "hamlet",
            "poly": [
                [
                    87.5093013,
                    55.9631822
                ],
                [
                    87.5093611,
                    55.9670268
                ],
                [
                    87.5105557,
                    55.9684307
                ],
                [
                    87.5093611,
                    55.9708375
                ],
                [
                    87.5094133,
                    55.9723267
                ],
                [
                    87.5110524,
                    55.9735314
                ],
                [
                    87.5111503,
                    55.9753796
                ],
                [
                    87.5157008,
                    55.9753933
                ],
                [
                    87.5155541,
                    55.9729291
                ],
                [
                    87.5184654,
                    55.9716011
                ],
                [
                    87.5195418,
                    55.9713272
                ],
                [
                    87.5211566,
                    55.9713409
                ],
                [
                    87.5210588,
                    55.969164
                ],
                [
                    87.5166305,
                    55.9669733
                ],
                [
                    87.5161105,
                    55.9630151
                ],
                [
                    87.5093013,
                    55.9631822
                ]
            ],
            "longitude": 87.5134068,
            "latitude": 55.9708074
        },
        "7842": {
            "name": "Краснознаменка",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.51976,
            "latitude": 54.122925
        },
        "7843": {
            "name": "Клепочный",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.521626,
            "latitude": 52.924145
        },
        "7844": {
            "name": "Ячменюха",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    87.5160854,
                    54.497191
                ],
                [
                    87.5192826,
                    54.4984407
                ],
                [
                    87.5232177,
                    54.4971552
                ],
                [
                    87.5262919,
                    54.4996904
                ],
                [
                    87.5273372,
                    54.4981193
                ],
                [
                    87.5301655,
                    54.4969767
                ],
                [
                    87.5280135,
                    54.4919417
                ],
                [
                    87.5246933,
                    54.4904418
                ],
                [
                    87.5232792,
                    54.487406
                ],
                [
                    87.5216624,
                    54.487077
                ],
                [
                    87.5196102,
                    54.4890481
                ],
                [
                    87.5160854,
                    54.497191
                ]
            ],
            "longitude": 87.523636,
            "latitude": 54.493626
        },
        "7845": {
            "name": "Антибесская",
            "population": 184,
            "type": "hamlet",
            "poly": [
                [
                    87.5156506,
                    56.1701743
                ],
                [
                    87.5166189,
                    56.1703225
                ],
                [
                    87.5173803,
                    56.1703184
                ],
                [
                    87.5205294,
                    56.1707875
                ],
                [
                    87.520729,
                    56.1706641
                ],
                [
                    87.5216752,
                    56.170841
                ],
                [
                    87.5226953,
                    56.1711661
                ],
                [
                    87.5240111,
                    56.1714624
                ],
                [
                    87.5258148,
                    56.1716641
                ],
                [
                    87.5259553,
                    56.1717217
                ],
                [
                    87.5261327,
                    56.1716394
                ],
                [
                    87.5269014,
                    56.1717299
                ],
                [
                    87.5280916,
                    56.1720345
                ],
                [
                    87.5292596,
                    56.1722114
                ],
                [
                    87.5304867,
                    56.1720756
                ],
                [
                    87.5307232,
                    56.1717382
                ],
                [
                    87.5303684,
                    56.1716476
                ],
                [
                    87.5304571,
                    56.1715283
                ],
                [
                    87.5311889,
                    56.1716271
                ],
                [
                    87.5314403,
                    56.1712608
                ],
                [
                    87.5308785,
                    56.1712073
                ],
                [
                    87.5309006,
                    56.1710838
                ],
                [
                    87.5312185,
                    56.1710345
                ],
                [
                    87.5317803,
                    56.1710221
                ],
                [
                    87.5318912,
                    56.1709645
                ],
                [
                    87.5318764,
                    56.1708616
                ],
                [
                    87.5314476,
                    56.1706311
                ],
                [
                    87.5301984,
                    56.169664
                ],
                [
                    87.5289934,
                    56.168952
                ],
                [
                    87.5275741,
                    56.1684746
                ],
                [
                    87.5224439,
                    56.16717
                ],
                [
                    87.5219413,
                    56.1671
                ],
                [
                    87.5214978,
                    56.1676021
                ],
                [
                    87.5209655,
                    56.1674375
                ],
                [
                    87.519975,
                    56.1676103
                ],
                [
                    87.5190879,
                    56.1682153
                ],
                [
                    87.5183783,
                    56.1684787
                ],
                [
                    87.5181196,
                    56.1688039
                ],
                [
                    87.5177499,
                    56.1690343
                ],
                [
                    87.517543,
                    56.1690755
                ],
                [
                    87.5170994,
                    56.1692936
                ],
                [
                    87.5156727,
                    56.1696805
                ],
                [
                    87.5156506,
                    56.1701743
                ]
            ],
            "longitude": 87.524162,
            "latitude": 56.170158
        },
        "7846": {
            "name": "Медвежка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.527512,
            "latitude": 54.81311
        },
        "7847": {
            "name": "Подъельники",
            "population": 75,
            "type": "hamlet",
            "poly": [
                [
                    87.5177626,
                    56.2289844
                ],
                [
                    87.5181554,
                    56.2294081
                ],
                [
                    87.5182016,
                    56.2299924
                ],
                [
                    87.5190909,
                    56.2308784
                ],
                [
                    87.5210545,
                    56.2324064
                ],
                [
                    87.5230758,
                    56.2321688
                ],
                [
                    87.5244503,
                    56.2319441
                ],
                [
                    87.5236302,
                    56.2312122
                ],
                [
                    87.5251433,
                    56.230705
                ],
                [
                    87.525536,
                    56.2308656
                ],
                [
                    87.5275688,
                    56.2301272
                ],
                [
                    87.5288163,
                    56.230705
                ],
                [
                    87.529567,
                    56.2315589
                ],
                [
                    87.5306528,
                    56.2321303
                ],
                [
                    87.5316114,
                    56.2323999
                ],
                [
                    87.5320041,
                    56.2327081
                ],
                [
                    87.5327779,
                    56.2330419
                ],
                [
                    87.5334826,
                    56.2331768
                ],
                [
                    87.5346145,
                    56.2327209
                ],
                [
                    87.5353768,
                    56.2325604
                ],
                [
                    87.536116,
                    56.2321303
                ],
                [
                    87.5365203,
                    56.2317772
                ],
                [
                    87.5365087,
                    56.2314113
                ],
                [
                    87.5348224,
                    56.2296521
                ],
                [
                    87.5329974,
                    56.2286313
                ],
                [
                    87.5323391,
                    56.2283616
                ],
                [
                    87.5315883,
                    56.2278865
                ],
                [
                    87.5300752,
                    56.2271417
                ],
                [
                    87.5288971,
                    56.2272059
                ],
                [
                    87.5282619,
                    56.227559
                ],
                [
                    87.5273609,
                    56.2271417
                ],
                [
                    87.5269682,
                    56.2268335
                ],
                [
                    87.5262752,
                    56.2265509
                ],
                [
                    87.5251317,
                    56.2264418
                ],
                [
                    87.5239305,
                    56.22614
                ],
                [
                    87.5225791,
                    56.2260822
                ],
                [
                    87.5217706,
                    56.2258575
                ],
                [
                    87.5183864,
                    56.2278993
                ],
                [
                    87.5177626,
                    56.2289844
                ]
            ],
            "longitude": 87.529686,
            "latitude": 56.229656
        },
        "7848": {
            "name": "Мальковка",
            "population": 153,
            "type": "hamlet",
            "poly": [
                [
                    87.5431234,
                    56.1324056
                ],
                [
                    87.5485414,
                    56.1339152
                ],
                [
                    87.5515754,
                    56.1340359
                ],
                [
                    87.5506002,
                    56.1349417
                ],
                [
                    87.5602819,
                    56.1388433
                ],
                [
                    87.5706464,
                    56.1424886
                ],
                [
                    87.5721633,
                    56.1424886
                ],
                [
                    87.5730303,
                    56.1435752
                ],
                [
                    87.5814822,
                    56.1468953
                ],
                [
                    87.5831076,
                    56.1467746
                ],
                [
                    87.5836034,
                    56.1465192
                ],
                [
                    87.584065,
                    56.1451149
                ],
                [
                    87.5848462,
                    56.1454116
                ],
                [
                    87.5858403,
                    56.145372
                ],
                [
                    87.5863729,
                    56.1449368
                ],
                [
                    87.5883968,
                    56.1449764
                ],
                [
                    87.5890359,
                    56.1452335
                ],
                [
                    87.5897461,
                    56.1450159
                ],
                [
                    87.589675,
                    56.1446401
                ],
                [
                    87.5881483,
                    56.1443236
                ],
                [
                    87.5864795,
                    56.1442643
                ],
                [
                    87.5843134,
                    56.143928
                ],
                [
                    87.5851657,
                    56.1430576
                ],
                [
                    87.5843846,
                    56.1421674
                ],
                [
                    87.584491,
                    56.1407827
                ],
                [
                    87.5807984,
                    56.1403672
                ],
                [
                    87.5798752,
                    56.1398727
                ],
                [
                    87.57881,
                    56.1399122
                ],
                [
                    87.5777448,
                    56.1390022
                ],
                [
                    87.5768216,
                    56.1390418
                ],
                [
                    87.5764665,
                    56.1386461
                ],
                [
                    87.5728804,
                    56.1365291
                ],
                [
                    87.5719572,
                    56.1362719
                ],
                [
                    87.5700753,
                    56.1362917
                ],
                [
                    87.5694362,
                    56.1356982
                ],
                [
                    87.5694716,
                    56.1346495
                ],
                [
                    87.5695427,
                    56.1335613
                ],
                [
                    87.5671993,
                    56.1329281
                ],
                [
                    87.5633645,
                    56.1326313
                ],
                [
                    87.5600979,
                    56.1323147
                ],
                [
                    87.560879,
                    56.1312858
                ],
                [
                    87.560595,
                    56.1298017
                ],
                [
                    87.5595653,
                    56.1280998
                ],
                [
                    87.5581852,
                    56.1280576
                ],
                [
                    87.5562348,
                    56.1280576
                ],
                [
                    87.5560181,
                    56.1299297
                ],
                [
                    87.5513587,
                    56.1295673
                ],
                [
                    87.5475661,
                    56.1296881
                ],
                [
                    87.545399,
                    56.1286615
                ],
                [
                    87.5444237,
                    56.1292654
                ],
                [
                    87.5448572,
                    56.1309563
                ],
                [
                    87.5431234,
                    56.1324056
                ]
            ],
            "longitude": 87.555618,
            "latitude": 56.132313
        },
        "7849": {
            "name": "Усть-Аскарлы",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.557938,
            "latitude": 54.192741
        },
        "7850": {
            "name": "Увал",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.573906,
            "latitude": 54.115757
        },
        "7851": {
            "name": "Берензас",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.581139,
            "latitude": 53.679562
        },
        "7852": {
            "name": "Черемза",
            "population": 110,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.584732,
            "latitude": 53.759632
        },
        "7853": {
            "name": "534 км",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5950572,
            "latitude": 52.9298413
        },
        "7854": {
            "name": "Верх-Подобас",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.597176,
            "latitude": 53.70377
        },
        "7855": {
            "name": "Новоказанка",
            "population": 179,
            "type": "hamlet",
            "poly": [
                [
                    87.5747871,
                    56.1002397
                ],
                [
                    87.5963459,
                    56.1118457
                ],
                [
                    87.5977458,
                    56.1113254
                ],
                [
                    87.5987724,
                    56.1118978
                ],
                [
                    87.6026922,
                    56.1135109
                ],
                [
                    87.6067053,
                    56.1112213
                ],
                [
                    87.6015722,
                    56.1080989
                ],
                [
                    87.6081985,
                    56.1054258
                ],
                [
                    87.6022255,
                    56.1011246
                ],
                [
                    87.594386,
                    56.1039873
                ],
                [
                    87.589253,
                    56.1009684
                ],
                [
                    87.588413,
                    56.1013328
                ],
                [
                    87.5867331,
                    56.1003959
                ],
                [
                    87.5864531,
                    56.0998753
                ],
                [
                    87.5808534,
                    56.0968561
                ],
                [
                    87.5747871,
                    56.1002397
                ]
            ],
            "longitude": 87.5975999,
            "latitude": 56.1083394
        },
        "7856": {
            "name": "Мутный",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.613754,
            "latitude": 54.352303
        },
        "7857": {
            "name": "Раздольное",
            "population": 68,
            "type": "hamlet",
            "poly": [
                [
                    87.6101131,
                    56.1232331
                ],
                [
                    87.6155554,
                    56.1253694
                ],
                [
                    87.6172162,
                    56.1257254
                ],
                [
                    87.6181105,
                    56.1257824
                ],
                [
                    87.6196946,
                    56.1254975
                ],
                [
                    87.6201545,
                    56.1250561
                ],
                [
                    87.620921,
                    56.1252554
                ],
                [
                    87.6203334,
                    56.1258251
                ],
                [
                    87.6206911,
                    56.1259675
                ],
                [
                    87.6209977,
                    56.1256542
                ],
                [
                    87.621713,
                    56.1259105
                ],
                [
                    87.6210743,
                    56.1266083
                ],
                [
                    87.6226585,
                    56.1269786
                ],
                [
                    87.6241659,
                    56.1272919
                ],
                [
                    87.6265677,
                    56.1280324
                ],
                [
                    87.6273086,
                    56.1276479
                ],
                [
                    87.6279474,
                    56.1269644
                ],
                [
                    87.629276,
                    56.1272065
                ],
                [
                    87.6300426,
                    56.1264659
                ],
                [
                    87.6266188,
                    56.1253836
                ],
                [
                    87.6257756,
                    56.1255118
                ],
                [
                    87.6242426,
                    56.1248282
                ],
                [
                    87.6233994,
                    56.1249991
                ],
                [
                    87.6230162,
                    56.1245149
                ],
                [
                    87.6219941,
                    56.1242585
                ],
                [
                    87.6212532,
                    56.1243013
                ],
                [
                    87.6183149,
                    56.1232189
                ],
                [
                    87.6175739,
                    56.1232189
                ],
                [
                    87.6166285,
                    56.1239452
                ],
                [
                    87.6157343,
                    56.1236889
                ],
                [
                    87.6115951,
                    56.1221365
                ],
                [
                    87.6101131,
                    56.1232331
                ]
            ],
            "longitude": 87.619743,
            "latitude": 56.124729
        },
        "7858": {
            "name": "Калининский",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.624748,
            "latitude": 56.188171
        },
        "7859": {
            "name": "538 км",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.6374802,
            "latitude": 52.9233085
        },
        "7860": {
            "name": "Кольчезас",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.6405733,
            "latitude": 53.7947312
        },
        "7861": {
            "name": "Турла",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    87.6471228,
                    52.7144977
                ],
                [
                    87.6477251,
                    52.7148684
                ],
                [
                    87.6489967,
                    52.71477
                ],
                [
                    87.648968,
                    52.7144746
                ],
                [
                    87.6482988,
                    52.7140171
                ],
                [
                    87.6475913,
                    52.7139302
                ],
                [
                    87.6471515,
                    52.714214
                ],
                [
                    87.6471228,
                    52.7144977
                ]
            ],
            "longitude": 87.6483051,
            "latitude": 52.7146511
        },
        "7862": {
            "name": "Центральный",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.6713041,
            "latitude": 53.0352192
        },
        "7863": {
            "name": "Берёзовый",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.6813811,
            "latitude": 53.4059631
        },
        "7864": {
            "name": "Покровка",
            "population": 213,
            "type": "hamlet",
            "poly": [
                [
                    87.6674148,
                    55.9642269
                ],
                [
                    87.6674759,
                    55.9663835
                ],
                [
                    87.6680264,
                    55.9673078
                ],
                [
                    87.6724301,
                    55.9672907
                ],
                [
                    87.6747238,
                    55.9694814
                ],
                [
                    87.678363,
                    55.9694814
                ],
                [
                    87.6796473,
                    55.9711244
                ],
                [
                    87.6801979,
                    55.9707992
                ],
                [
                    87.6806872,
                    55.970765
                ],
                [
                    87.6812683,
                    55.9720143
                ],
                [
                    87.6824915,
                    55.97198
                ],
                [
                    87.6829808,
                    55.9717062
                ],
                [
                    87.686406,
                    55.9717062
                ],
                [
                    87.6857638,
                    55.9676501
                ],
                [
                    87.6885467,
                    55.9676843
                ],
                [
                    87.6891278,
                    55.9671366
                ],
                [
                    87.6861613,
                    55.9615737
                ],
                [
                    87.6864977,
                    55.9550854
                ],
                [
                    87.685305,
                    55.9545204
                ],
                [
                    87.6712375,
                    55.9545546
                ],
                [
                    87.6720632,
                    55.9563009
                ],
                [
                    87.6697696,
                    55.9569858
                ],
                [
                    87.6688827,
                    55.9576021
                ],
                [
                    87.6696167,
                    55.9579616
                ],
                [
                    87.6695861,
                    55.958595
                ],
                [
                    87.6707482,
                    55.9592284
                ],
                [
                    87.670687,
                    55.9598618
                ],
                [
                    87.6689133,
                    55.9617106
                ],
                [
                    87.6701977,
                    55.9620359
                ],
                [
                    87.67032,
                    55.962344
                ],
                [
                    87.6674148,
                    55.9642269
                ]
            ],
            "longitude": 87.6820341,
            "latitude": 55.9634327
        },
        "7865": {
            "name": "Заречный",
            "population": 138,
            "type": "hamlet",
            "poly": [
                [
                    87.6799197,
                    56.2675922
                ],
                [
                    87.6802066,
                    56.2679745
                ],
                [
                    87.6809236,
                    56.2679426
                ],
                [
                    87.6819275,
                    56.2685797
                ],
                [
                    87.6823577,
                    56.2683408
                ],
                [
                    87.6829887,
                    56.2683408
                ],
                [
                    87.6859141,
                    56.2698697
                ],
                [
                    87.6872908,
                    56.2698856
                ],
                [
                    87.6880364,
                    56.2704271
                ],
                [
                    87.6888682,
                    56.270236
                ],
                [
                    87.6900441,
                    56.270443
                ],
                [
                    87.6908758,
                    56.2712871
                ],
                [
                    87.6896139,
                    56.2718922
                ],
                [
                    87.6917936,
                    56.2730547
                ],
                [
                    87.6934284,
                    56.2722904
                ],
                [
                    87.6933997,
                    56.2705227
                ],
                [
                    87.692023,
                    56.2697423
                ],
                [
                    87.6917649,
                    56.2682293
                ],
                [
                    87.6886387,
                    56.26764
                ],
                [
                    87.6886387,
                    56.2662225
                ],
                [
                    87.6865451,
                    56.2648687
                ],
                [
                    87.6871187,
                    56.2639289
                ],
                [
                    87.6857133,
                    56.2633236
                ],
                [
                    87.6837917,
                    56.2637696
                ],
                [
                    87.6816694,
                    56.2628139
                ],
                [
                    87.6813826,
                    56.2625591
                ],
                [
                    87.6809523,
                    56.2625591
                ],
                [
                    87.6806942,
                    56.2635148
                ],
                [
                    87.6808663,
                    56.2641041
                ],
                [
                    87.6814112,
                    56.2640563
                ],
                [
                    87.6819562,
                    56.2637219
                ],
                [
                    87.683591,
                    56.2644386
                ],
                [
                    87.6836196,
                    56.2646775
                ],
                [
                    87.684394,
                    56.2650598
                ],
                [
                    87.6843653,
                    56.2659677
                ],
                [
                    87.6833041,
                    56.266557
                ],
                [
                    87.6819275,
                    56.2659358
                ],
                [
                    87.6799197,
                    56.2675922
                ]
            ],
            "longitude": 87.686172,
            "latitude": 56.267818
        },
        "7866": {
            "name": "Карачарово",
            "population": 235,
            "type": "hamlet",
            "poly": [
                [
                    87.6716023,
                    55.7488087
                ],
                [
                    87.6720451,
                    55.7492045
                ],
                [
                    87.6736467,
                    55.7495856
                ],
                [
                    87.6879313,
                    55.7510953
                ],
                [
                    87.6880484,
                    55.7517255
                ],
                [
                    87.6958223,
                    55.7522311
                ],
                [
                    87.6972545,
                    55.7521798
                ],
                [
                    87.697549,
                    55.7485348
                ],
                [
                    87.7002262,
                    55.7485993
                ],
                [
                    87.7003615,
                    55.746641
                ],
                [
                    87.6986323,
                    55.7464593
                ],
                [
                    87.6993615,
                    55.7445771
                ],
                [
                    87.7004033,
                    55.7428648
                ],
                [
                    87.704183,
                    55.7426524
                ],
                [
                    87.7062525,
                    55.7414133
                ],
                [
                    87.7071119,
                    55.7390822
                ],
                [
                    87.7049633,
                    55.7388403
                ],
                [
                    87.6988822,
                    55.7385984
                ],
                [
                    87.6934784,
                    55.7381512
                ],
                [
                    87.6923065,
                    55.7384665
                ],
                [
                    87.6919809,
                    55.7392069
                ],
                [
                    87.6893506,
                    55.7395074
                ],
                [
                    87.6871239,
                    55.7404017
                ],
                [
                    87.6842983,
                    55.7406363
                ],
                [
                    87.684116,
                    55.7413327
                ],
                [
                    87.682345,
                    55.7405997
                ],
                [
                    87.6812122,
                    55.7398739
                ],
                [
                    87.6777354,
                    55.7399766
                ],
                [
                    87.6780349,
                    55.740585
                ],
                [
                    87.6765114,
                    55.7404164
                ],
                [
                    87.6745191,
                    55.741274
                ],
                [
                    87.6771104,
                    55.7429599
                ],
                [
                    87.6766547,
                    55.743561
                ],
                [
                    87.6765505,
                    55.744873
                ],
                [
                    87.6760817,
                    55.7455839
                ],
                [
                    87.6733081,
                    55.7470571
                ],
                [
                    87.6716023,
                    55.7488087
                ]
            ],
            "longitude": 87.6888884,
            "latitude": 55.7454149
        },
        "7867": {
            "name": "Тарлашка",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    87.7049707,
                    52.7253331
                ],
                [
                    87.7050806,
                    52.7255239
                ],
                [
                    87.7056374,
                    52.7254618
                ],
                [
                    87.7061283,
                    52.7257857
                ],
                [
                    87.706524,
                    52.7259411
                ],
                [
                    87.7058426,
                    52.726012
                ],
                [
                    87.7058719,
                    52.7263626
                ],
                [
                    87.7061796,
                    52.7266643
                ],
                [
                    87.7067145,
                    52.7268241
                ],
                [
                    87.7072713,
                    52.7268551
                ],
                [
                    87.7074398,
                    52.7275252
                ],
                [
                    87.7079527,
                    52.7276272
                ],
                [
                    87.7084363,
                    52.7272456
                ],
                [
                    87.7098943,
                    52.7267265
                ],
                [
                    87.709909,
                    52.7264602
                ],
                [
                    87.7089492,
                    52.7260786
                ],
                [
                    87.7085315,
                    52.7257236
                ],
                [
                    87.7078282,
                    52.7252577
                ],
                [
                    87.70722,
                    52.7245255
                ],
                [
                    87.706099,
                    52.7239664
                ],
                [
                    87.7052198,
                    52.7241349
                ],
                [
                    87.7055349,
                    52.7250758
                ],
                [
                    87.7049707,
                    52.7253331
                ]
            ],
            "longitude": 87.7063909,
            "latitude": 52.7260787
        },
        "7868": {
            "name": "Балбынь",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7120209,
            "latitude": 53.770202
        },
        "7869": {
            "name": "Орлово-Розово",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    87.7018341,
                    56.0485572
                ],
                [
                    87.7103158,
                    56.0528269
                ],
                [
                    87.7103158,
                    56.0538609
                ],
                [
                    87.714258,
                    56.0565624
                ],
                [
                    87.7135412,
                    56.0572962
                ],
                [
                    87.7134218,
                    56.05823
                ],
                [
                    87.7150812,
                    56.0596278
                ],
                [
                    87.7165491,
                    56.0628377
                ],
                [
                    87.7226899,
                    56.0662522
                ],
                [
                    87.7236441,
                    56.0662113
                ],
                [
                    87.7263842,
                    56.0639031
                ],
                [
                    87.7262619,
                    56.0614445
                ],
                [
                    87.7252099,
                    56.0608845
                ],
                [
                    87.7247206,
                    56.0596415
                ],
                [
                    87.726898,
                    56.0592727
                ],
                [
                    87.7269714,
                    56.0581252
                ],
                [
                    87.7293201,
                    56.0581526
                ],
                [
                    87.7285616,
                    56.0574149
                ],
                [
                    87.7285861,
                    56.05568
                ],
                [
                    87.7257481,
                    56.055639
                ],
                [
                    87.7251854,
                    56.0553248
                ],
                [
                    87.7239376,
                    56.0553384
                ],
                [
                    87.7219315,
                    56.055598
                ],
                [
                    87.719118,
                    56.0530843
                ],
                [
                    87.7145919,
                    56.050584
                ],
                [
                    87.7140048,
                    56.0499965
                ],
                [
                    87.7124145,
                    56.049491
                ],
                [
                    87.7106775,
                    56.0483433
                ],
                [
                    87.7077416,
                    56.045911
                ],
                [
                    87.706763,
                    56.0463073
                ],
                [
                    87.7051238,
                    56.0456651
                ],
                [
                    87.7018341,
                    56.0485572
                ]
            ],
            "longitude": 87.715421,
            "latitude": 56.0544568
        },
        "7870": {
            "name": "Чуазас",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.726936,
            "latitude": 53.491512
        },
        "7871": {
            "name": "Юдино",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7279246,
            "latitude": 52.6068763
        },
        "7872": {
            "name": "Усть-Уруш",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    87.7286518,
                    52.7385287
                ],
                [
                    87.7288913,
                    52.7388958
                ],
                [
                    87.7293255,
                    52.7390726
                ],
                [
                    87.7303061,
                    52.7393808
                ],
                [
                    87.7316984,
                    52.7401513
                ],
                [
                    87.732754,
                    52.7394261
                ],
                [
                    87.7322599,
                    52.7390409
                ],
                [
                    87.732507,
                    52.7388369
                ],
                [
                    87.7315862,
                    52.7385287
                ],
                [
                    87.7313542,
                    52.7385604
                ],
                [
                    87.7310921,
                    52.7387735
                ],
                [
                    87.7304409,
                    52.7383792
                ],
                [
                    87.7299169,
                    52.7386284
                ],
                [
                    87.7293928,
                    52.7386058
                ],
                [
                    87.7292581,
                    52.7383701
                ],
                [
                    87.7288838,
                    52.7383112
                ],
                [
                    87.7286518,
                    52.7385287
                ]
            ],
            "longitude": 87.73093,
            "latitude": 52.7393001
        },
        "7873": {
            "name": "Новоивановский 3-й",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    87.7212782,
                    55.8529149
                ],
                [
                    87.7223032,
                    55.8542902
                ],
                [
                    87.7233533,
                    55.8550526
                ],
                [
                    87.7248951,
                    55.8546083
                ],
                [
                    87.7254867,
                    55.8552257
                ],
                [
                    87.7288452,
                    55.8545241
                ],
                [
                    87.7283702,
                    55.8537055
                ],
                [
                    87.7278202,
                    55.8531207
                ],
                [
                    87.7302787,
                    55.8524284
                ],
                [
                    87.7316287,
                    55.8537382
                ],
                [
                    87.7337538,
                    55.854627
                ],
                [
                    87.7344372,
                    55.8554736
                ],
                [
                    87.7372539,
                    55.8576486
                ],
                [
                    87.7383957,
                    55.8571107
                ],
                [
                    87.7401958,
                    55.8564278
                ],
                [
                    87.7395624,
                    55.8547486
                ],
                [
                    87.7404125,
                    55.8543323
                ],
                [
                    87.7407958,
                    55.8535043
                ],
                [
                    87.7388791,
                    55.8513244
                ],
                [
                    87.7389374,
                    55.8509689
                ],
                [
                    87.7388624,
                    55.850763
                ],
                [
                    87.7386874,
                    55.8506274
                ],
                [
                    87.7382707,
                    55.8504917
                ],
                [
                    87.737954,
                    55.8504917
                ],
                [
                    87.7374457,
                    55.850618
                ],
                [
                    87.7371873,
                    55.850618
                ],
                [
                    87.7369456,
                    55.8503654
                ],
                [
                    87.7369623,
                    55.849935
                ],
                [
                    87.736354,
                    55.8494952
                ],
                [
                    87.7334871,
                    55.848887
                ],
                [
                    87.7318787,
                    55.8481899
                ],
                [
                    87.731062,
                    55.8475022
                ],
                [
                    87.7301453,
                    55.8479233
                ],
                [
                    87.7285036,
                    55.8470999
                ],
                [
                    87.7258034,
                    55.8486859
                ],
                [
                    87.7225866,
                    55.8491069
                ],
                [
                    87.7224116,
                    55.8496496
                ],
                [
                    87.7241617,
                    55.851184
                ],
                [
                    87.7256868,
                    55.8506461
                ],
                [
                    87.7262785,
                    55.8512449
                ],
                [
                    87.7237283,
                    55.8520074
                ],
                [
                    87.7212782,
                    55.8529149
                ]
            ],
            "longitude": 87.7333681,
            "latitude": 55.8516177
        },
        "7874": {
            "name": "545 км",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7349183,
            "latitude": 52.927664
        },
        "7875": {
            "name": "Нижний Сокол",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7396417,
            "latitude": 52.6212279
        },
        "7876": {
            "name": "Габовск",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7488047,
            "latitude": 52.6147921
        },
        "7877": {
            "name": "Ивановка",
            "population": 153,
            "type": "hamlet",
            "poly": [
                [
                    87.7530036,
                    55.8817402
                ],
                [
                    87.7535067,
                    55.8834052
                ],
                [
                    87.7530161,
                    55.8838356
                ],
                [
                    87.7550413,
                    55.8866292
                ],
                [
                    87.7538212,
                    55.8875957
                ],
                [
                    87.756777,
                    55.8895356
                ],
                [
                    87.7577833,
                    55.8900152
                ],
                [
                    87.7576073,
                    55.8903891
                ],
                [
                    87.7578966,
                    55.8909322
                ],
                [
                    87.7586136,
                    55.8911015
                ],
                [
                    87.7598086,
                    55.8910451
                ],
                [
                    87.7608652,
                    55.8916376
                ],
                [
                    87.7622614,
                    55.8921384
                ],
                [
                    87.76484,
                    55.8915459
                ],
                [
                    87.7667897,
                    55.8903609
                ],
                [
                    87.7673305,
                    55.8896907
                ],
                [
                    87.7684249,
                    55.8889995
                ],
                [
                    87.7725631,
                    55.8901986
                ],
                [
                    87.7766638,
                    55.8861072
                ],
                [
                    87.7759594,
                    55.8857192
                ],
                [
                    87.7736701,
                    55.8851478
                ],
                [
                    87.7717581,
                    55.8844917
                ],
                [
                    87.7713933,
                    55.8842095
                ],
                [
                    87.7710161,
                    55.8836662
                ],
                [
                    87.7711419,
                    55.8832077
                ],
                [
                    87.7716827,
                    55.8823187
                ],
                [
                    87.7686136,
                    55.8813027
                ],
                [
                    87.7676702,
                    55.8821494
                ],
                [
                    87.7663494,
                    55.8817402
                ],
                [
                    87.7657456,
                    55.8821776
                ],
                [
                    87.7549155,
                    55.8783323
                ],
                [
                    87.7548778,
                    55.8775844
                ],
                [
                    87.7534941,
                    55.8775632
                ],
                [
                    87.7535319,
                    55.8782194
                ],
                [
                    87.7530161,
                    55.8798281
                ],
                [
                    87.7530036,
                    55.8817402
                ]
            ],
            "longitude": 87.7626887,
            "latitude": 55.8857671
        },
        "7878": {
            "name": "Усть-Мрасский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7819976,
            "latitude": 53.7593725
        },
        "7879": {
            "name": "3-й",
            "population": 62,
            "type": "hamlet",
            "poly": [
                [
                    87.782756,
                    55.9762422
                ],
                [
                    87.7832953,
                    55.9764629
                ],
                [
                    87.7837461,
                    55.9769448
                ],
                [
                    87.7842131,
                    55.977116
                ],
                [
                    87.785348,
                    55.977098
                ],
                [
                    87.7863383,
                    55.9773097
                ],
                [
                    87.785968,
                    55.9777151
                ],
                [
                    87.7879806,
                    55.9784538
                ],
                [
                    87.7893491,
                    55.9791249
                ],
                [
                    87.7927625,
                    55.9795393
                ],
                [
                    87.7945577,
                    55.979242
                ],
                [
                    87.7942679,
                    55.9786024
                ],
                [
                    87.7946543,
                    55.978688
                ],
                [
                    87.7991624,
                    55.9782691
                ],
                [
                    87.7982527,
                    55.9775619
                ],
                [
                    87.7988082,
                    55.9773863
                ],
                [
                    87.7965219,
                    55.9753773
                ],
                [
                    87.8007242,
                    55.9741926
                ],
                [
                    87.7995166,
                    55.9729177
                ],
                [
                    87.7977214,
                    55.9734358
                ],
                [
                    87.7966266,
                    55.97226
                ],
                [
                    87.7946865,
                    55.9725754
                ],
                [
                    87.7935916,
                    55.9729628
                ],
                [
                    87.7939378,
                    55.9732781
                ],
                [
                    87.7925612,
                    55.9733457
                ],
                [
                    87.7926899,
                    55.9746611
                ],
                [
                    87.7885361,
                    55.9765485
                ],
                [
                    87.7847927,
                    55.9749313
                ],
                [
                    87.782756,
                    55.9762422
                ]
            ],
            "longitude": 87.7928848,
            "latitude": 55.9762881
        },
        "7880": {
            "name": "Акколь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7933716,
            "latitude": 53.7476143
        },
        "7881": {
            "name": "Килинск",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.793877,
            "latitude": 52.522236
        },
        "7882": {
            "name": "Камешек",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.7938834,
            "latitude": 53.5744182
        },
        "7883": {
            "name": "2-й",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    87.7971845,
                    56.015227
                ],
                [
                    87.803353,
                    56.0185624
                ],
                [
                    87.8038864,
                    56.019378
                ],
                [
                    87.80447,
                    56.019631
                ],
                [
                    87.805436,
                    56.0193442
                ],
                [
                    87.8063719,
                    56.0199179
                ],
                [
                    87.8067845,
                    56.0197154
                ],
                [
                    87.8063417,
                    56.0194398
                ],
                [
                    87.8066939,
                    56.0192823
                ],
                [
                    87.8066235,
                    56.0191924
                ],
                [
                    87.808324,
                    56.0183375
                ],
                [
                    87.8074386,
                    56.0178706
                ],
                [
                    87.8058687,
                    56.0186524
                ],
                [
                    87.8028801,
                    56.0171169
                ],
                [
                    87.8017027,
                    56.016712
                ],
                [
                    87.8015618,
                    56.0164645
                ],
                [
                    87.8011593,
                    56.0165095
                ],
                [
                    87.8007971,
                    56.0165882
                ],
                [
                    87.7997505,
                    56.0157276
                ],
                [
                    87.7983719,
                    56.0150639
                ],
                [
                    87.8016323,
                    56.012932
                ],
                [
                    87.8018235,
                    56.012482
                ],
                [
                    87.8014411,
                    56.0123301
                ],
                [
                    87.7985128,
                    56.0137758
                ],
                [
                    87.7979895,
                    56.0147208
                ],
                [
                    87.7971845,
                    56.015227
                ]
            ],
            "longitude": 87.8018857,
            "latitude": 56.0172393
        },
        "7884": {
            "name": "4-й",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    87.7918979,
                    55.9354018
                ],
                [
                    87.7923809,
                    55.9359789
                ],
                [
                    87.792711,
                    55.9364163
                ],
                [
                    87.793025,
                    55.9364479
                ],
                [
                    87.7935885,
                    55.9362269
                ],
                [
                    87.7941036,
                    55.9362765
                ],
                [
                    87.7944418,
                    55.9365696
                ],
                [
                    87.7943774,
                    55.9371603
                ],
                [
                    87.7946833,
                    55.9374489
                ],
                [
                    87.7964705,
                    55.9374354
                ],
                [
                    87.7972594,
                    55.9376879
                ],
                [
                    87.7980242,
                    55.9377735
                ],
                [
                    87.7980403,
                    55.9386212
                ],
                [
                    87.8028865,
                    55.9388872
                ],
                [
                    87.8062516,
                    55.9395139
                ],
                [
                    87.8085781,
                    55.9377826
                ],
                [
                    87.8119753,
                    55.9373497
                ],
                [
                    87.8128528,
                    55.9376202
                ],
                [
                    87.8137464,
                    55.9368041
                ],
                [
                    87.8123133,
                    55.9364795
                ],
                [
                    87.8112186,
                    55.9360015
                ],
                [
                    87.8100916,
                    55.9349734
                ],
                [
                    87.8095361,
                    55.9346036
                ],
                [
                    87.8078053,
                    55.9341617
                ],
                [
                    87.8065897,
                    55.9334943
                ],
                [
                    87.8054063,
                    55.933066
                ],
                [
                    87.8043598,
                    55.9330028
                ],
                [
                    87.8026048,
                    55.9331426
                ],
                [
                    87.8017756,
                    55.932863
                ],
                [
                    87.8019125,
                    55.9339723
                ],
                [
                    87.8015824,
                    55.9348607
                ],
                [
                    87.8005036,
                    55.9356002
                ],
                [
                    87.7990949,
                    55.9369664
                ],
                [
                    87.7975734,
                    55.936741
                ],
                [
                    87.7962129,
                    55.9366553
                ],
                [
                    87.7957621,
                    55.9364163
                ],
                [
                    87.7954159,
                    55.9360105
                ],
                [
                    87.794796,
                    55.9358572
                ],
                [
                    87.7929686,
                    55.9361052
                ],
                [
                    87.7925098,
                    55.9355596
                ],
                [
                    87.7920831,
                    55.9353206
                ],
                [
                    87.7918979,
                    55.9354018
                ]
            ],
            "longitude": 87.8055805,
            "latitude": 55.9365092
        },
        "7885": {
            "name": "Якунинск",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8079872,
            "latitude": 52.5273276
        },
        "7886": {
            "name": "Макариха",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.808052,
            "latitude": 54.2066
        },
        "7887": {
            "name": "Загадное",
            "population": 197,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.815773,
            "latitude": 54.150238
        },
        "7888": {
            "name": "Чувашка",
            "population": 249,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8184293,
            "latitude": 53.5979026
        },
        "7889": {
            "name": "Сельхоз",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8223896,
            "latitude": 53.7955497
        },
        "7890": {
            "name": "Новоивановский 2-й",
            "population": 69,
            "type": "hamlet",
            "poly": [
                [
                    87.8146524,
                    55.8905344
                ],
                [
                    87.817232,
                    55.8919258
                ],
                [
                    87.8224403,
                    55.8956039
                ],
                [
                    87.8232756,
                    55.8964718
                ],
                [
                    87.8238406,
                    55.896458
                ],
                [
                    87.827059,
                    55.895783
                ],
                [
                    87.8290244,
                    55.8954524
                ],
                [
                    87.8304493,
                    55.8948325
                ],
                [
                    87.8320953,
                    55.8945708
                ],
                [
                    87.8356085,
                    55.8932208
                ],
                [
                    87.8286804,
                    55.8902726
                ],
                [
                    87.8284101,
                    55.8906446
                ],
                [
                    87.8146524,
                    55.8905344
                ]
            ],
            "longitude": 87.8231559,
            "latitude": 55.8933036
        },
        "7891": {
            "name": "Тополёк",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8262399,
            "latitude": 53.72074
        },
        "7892": {
            "name": "Тутуяс",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8376159,
            "latitude": 53.8089681
        },
        "7893": {
            "name": "10-й разъезд",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    87.8399397,
                    56.1459629
                ],
                [
                    87.8430626,
                    56.1471334
                ],
                [
                    87.8446762,
                    56.1469071
                ],
                [
                    87.843852,
                    56.1473145
                ],
                [
                    87.8438752,
                    56.1476896
                ],
                [
                    87.8466846,
                    56.1489894
                ],
                [
                    87.8469516,
                    56.1491511
                ],
                [
                    87.84896,
                    56.1480194
                ],
                [
                    87.8489832,
                    56.1476702
                ],
                [
                    87.8485653,
                    56.1476702
                ],
                [
                    87.8458255,
                    56.1467131
                ],
                [
                    87.8455237,
                    56.1464414
                ],
                [
                    87.846197,
                    56.1459758
                ],
                [
                    87.8469748,
                    56.1457883
                ],
                [
                    87.8463131,
                    56.1453679
                ],
                [
                    87.8462434,
                    56.1441326
                ],
                [
                    87.8469052,
                    56.1435505
                ],
                [
                    87.8476017,
                    56.1435699
                ],
                [
                    87.8482402,
                    56.1431948
                ],
                [
                    87.849227,
                    56.1431948
                ],
                [
                    87.8499351,
                    56.1430137
                ],
                [
                    87.8488787,
                    56.1428197
                ],
                [
                    87.8469864,
                    56.1417072
                ],
                [
                    87.8456923,
                    56.1408701
                ],
                [
                    87.8452683,
                    56.1416943
                ],
                [
                    87.845872,
                    56.1424575
                ],
                [
                    87.8459184,
                    56.1436152
                ],
                [
                    87.8455817,
                    56.1437834
                ],
                [
                    87.8455585,
                    56.1447212
                ],
                [
                    87.8451522,
                    56.1448958
                ],
                [
                    87.8445717,
                    56.1448828
                ],
                [
                    87.8446182,
                    56.1458141
                ],
                [
                    87.8442467,
                    56.1458206
                ],
                [
                    87.8436082,
                    56.1454196
                ],
                [
                    87.8432367,
                    56.1454261
                ],
                [
                    87.8429115,
                    56.1456395
                ],
                [
                    87.8401719,
                    56.1456072
                ],
                [
                    87.8399397,
                    56.1459629
                ]
            ],
            "longitude": 87.844727,
            "latitude": 56.146488
        },
        "7894": {
            "name": "Казас",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8455209,
            "latitude": 53.6062736
        },
        "7895": {
            "name": "Тоз",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8478713,
            "latitude": 53.4598815
        },
        "7896": {
            "name": "Новоивановский 4-й",
            "population": 81,
            "type": "hamlet",
            "poly": [
                [
                    87.8345556,
                    55.7959817
                ],
                [
                    87.8372514,
                    55.7968681
                ],
                [
                    87.8455679,
                    55.8011853
                ],
                [
                    87.8435079,
                    55.8017142
                ],
                [
                    87.8442455,
                    55.8030007
                ],
                [
                    87.8442963,
                    55.803887
                ],
                [
                    87.8437114,
                    55.8043158
                ],
                [
                    87.8412443,
                    55.8072173
                ],
                [
                    87.8456442,
                    55.8094611
                ],
                [
                    87.848925,
                    55.8120622
                ],
                [
                    87.8524602,
                    55.813334
                ],
                [
                    87.853859,
                    55.812891
                ],
                [
                    87.8593778,
                    55.8126909
                ],
                [
                    87.8599882,
                    55.8114476
                ],
                [
                    87.8604969,
                    55.8106616
                ],
                [
                    87.8605732,
                    55.8099042
                ],
                [
                    87.8601917,
                    55.8090753
                ],
                [
                    87.8583351,
                    55.8070315
                ],
                [
                    87.8581062,
                    55.8041728
                ],
                [
                    87.8563259,
                    55.8009852
                ],
                [
                    87.8544185,
                    55.7984549
                ],
                [
                    87.8539607,
                    55.7977401
                ],
                [
                    87.8536809,
                    55.7958673
                ],
                [
                    87.8532994,
                    55.7957243
                ],
                [
                    87.8525365,
                    55.7951239
                ],
                [
                    87.8523584,
                    55.7945949
                ],
                [
                    87.8516463,
                    55.794166
                ],
                [
                    87.8481366,
                    55.794166
                ],
                [
                    87.8453645,
                    55.7943947
                ],
                [
                    87.8416513,
                    55.7949237
                ],
                [
                    87.8375313,
                    55.7946092
                ],
                [
                    87.8368191,
                    55.7942803
                ],
                [
                    87.8345556,
                    55.7959817
                ]
            ],
            "longitude": 87.8504822,
            "latitude": 55.8035211
        },
        "7897": {
            "name": "Чушла",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8600854,
            "latitude": 52.7068746
        },
        "7898": {
            "name": "Раевка",
            "population": 255,
            "type": "hamlet",
            "poly": [
                [
                    87.8681184,
                    56.1627436
                ],
                [
                    87.8711684,
                    56.165729
                ],
                [
                    87.871971,
                    56.1677667
                ],
                [
                    87.8726532,
                    56.1680776
                ],
                [
                    87.8727787,
                    56.1775724
                ],
                [
                    87.8735938,
                    56.1822491
                ],
                [
                    87.8773877,
                    56.1828959
                ],
                [
                    87.8777576,
                    56.1820039
                ],
                [
                    87.8771617,
                    56.1804944
                ],
                [
                    87.8767291,
                    56.1785147
                ],
                [
                    87.8798643,
                    56.1774676
                ],
                [
                    87.8802405,
                    56.1739772
                ],
                [
                    87.8824979,
                    56.1709751
                ],
                [
                    87.8815794,
                    56.170475
                ],
                [
                    87.8794254,
                    56.1687758
                ],
                [
                    87.8785795,
                    56.1675465
                ],
                [
                    87.8754974,
                    56.161952
                ],
                [
                    87.8750454,
                    56.1609794
                ],
                [
                    87.8745971,
                    56.1607106
                ],
                [
                    87.8727236,
                    56.1605904
                ],
                [
                    87.8712647,
                    56.1603301
                ],
                [
                    87.8707099,
                    56.1610023
                ],
                [
                    87.869888,
                    56.1615973
                ],
                [
                    87.8681184,
                    56.1627436
                ]
            ],
            "longitude": 87.875587,
            "latitude": 56.172642
        },
        "7899": {
            "name": "Михайловка",
            "population": 261,
            "type": "hamlet",
            "poly": [
                [
                    87.8886459,
                    55.9113928
                ],
                [
                    87.8908738,
                    55.9127825
                ],
                [
                    87.8893045,
                    55.914558
                ],
                [
                    87.8903557,
                    55.9157484
                ],
                [
                    87.8930572,
                    55.9158728
                ],
                [
                    87.9033077,
                    55.9114634
                ],
                [
                    87.9083661,
                    55.9112538
                ],
                [
                    87.9120048,
                    55.9107914
                ],
                [
                    87.9093403,
                    55.9066013
                ],
                [
                    87.9072777,
                    55.9070122
                ],
                [
                    87.8988303,
                    55.9071614
                ],
                [
                    87.8956477,
                    55.9055226
                ],
                [
                    87.8949936,
                    55.9042521
                ],
                [
                    87.895201,
                    55.9019857
                ],
                [
                    87.8944265,
                    55.9006265
                ],
                [
                    87.8917692,
                    55.9011038
                ],
                [
                    87.8916764,
                    55.9022472
                ],
                [
                    87.8906916,
                    55.9030317
                ],
                [
                    87.8886533,
                    55.9086549
                ],
                [
                    87.8886459,
                    55.9113928
                ]
            ],
            "longitude": 87.9007051,
            "latitude": 55.9100031
        },
        "7900": {
            "name": "Приметкино",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.902634,
            "latitude": 56.201378
        },
        "7901": {
            "name": "Аксас",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.904205,
            "latitude": 53.863789
        },
        "7902": {
            "name": "Сокушта",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.9104084,
            "latitude": 52.6706035
        },
        "7903": {
            "name": "Милехино",
            "population": 80,
            "type": "hamlet",
            "poly": [
                [
                    87.9072556,
                    56.3223392
                ],
                [
                    87.9093661,
                    56.3224111
                ],
                [
                    87.9162871,
                    56.3237649
                ],
                [
                    87.9209447,
                    56.3243406
                ],
                [
                    87.9211276,
                    56.326649
                ],
                [
                    87.9207088,
                    56.3291322
                ],
                [
                    87.9249952,
                    56.3290518
                ],
                [
                    87.9262016,
                    56.3296152
                ],
                [
                    87.9268173,
                    56.3301802
                ],
                [
                    87.9273905,
                    56.3301449
                ],
                [
                    87.9278788,
                    56.330498
                ],
                [
                    87.9287278,
                    56.3305016
                ],
                [
                    87.9318276,
                    56.3285794
                ],
                [
                    87.9345026,
                    56.3262959
                ],
                [
                    87.9348423,
                    56.3255307
                ],
                [
                    87.9362379,
                    56.3245135
                ],
                [
                    87.9350319,
                    56.3226896
                ],
                [
                    87.9264475,
                    56.3225624
                ],
                [
                    87.9264076,
                    56.319813
                ],
                [
                    87.9246581,
                    56.3197542
                ],
                [
                    87.9245544,
                    56.3217086
                ],
                [
                    87.9202359,
                    56.3215753
                ],
                [
                    87.9162659,
                    56.3213398
                ],
                [
                    87.9148435,
                    56.3213987
                ],
                [
                    87.9134423,
                    56.3210455
                ],
                [
                    87.9117014,
                    56.3208807
                ],
                [
                    87.9115528,
                    56.3214458
                ],
                [
                    87.908651,
                    56.3209363
                ],
                [
                    87.9075402,
                    56.3215988
                ],
                [
                    87.9072556,
                    56.3223392
                ]
            ],
            "longitude": 87.927895,
            "latitude": 56.325851
        },
        "7904": {
            "name": "Большая Натальевка",
            "population": 136,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.933135,
            "latitude": 55.5160221
        },
        "7905": {
            "name": "Шестаково",
            "population": 254,
            "type": "hamlet",
            "poly": [
                [
                    87.9493516,
                    55.8950078
                ],
                [
                    87.9501906,
                    55.8961884
                ],
                [
                    87.9527124,
                    55.8966248
                ],
                [
                    87.9536537,
                    55.8978349
                ],
                [
                    87.9543902,
                    55.9005519
                ],
                [
                    87.9543938,
                    55.902944
                ],
                [
                    87.9561054,
                    55.9035404
                ],
                [
                    87.9630905,
                    55.9026846
                ],
                [
                    87.9603835,
                    55.8988482
                ],
                [
                    87.9616051,
                    55.897367
                ],
                [
                    87.9645245,
                    55.8963565
                ],
                [
                    87.9681566,
                    55.8980644
                ],
                [
                    87.9725736,
                    55.899417
                ],
                [
                    87.9785872,
                    55.8947225
                ],
                [
                    87.9741926,
                    55.8934255
                ],
                [
                    87.9750715,
                    55.8924139
                ],
                [
                    87.9726661,
                    55.8914541
                ],
                [
                    87.9683177,
                    55.8902349
                ],
                [
                    87.9694279,
                    55.8878483
                ],
                [
                    87.9682252,
                    55.8875629
                ],
                [
                    87.9667468,
                    55.8861363
                ],
                [
                    87.9659585,
                    55.884294
                ],
                [
                    87.9641082,
                    55.8841902
                ],
                [
                    87.9635531,
                    55.8854355
                ],
                [
                    87.959251,
                    55.8855134
                ],
                [
                    87.9580483,
                    55.8871219
                ],
                [
                    87.9559666,
                    55.8875629
                ],
                [
                    87.9556341,
                    55.8891594
                ],
                [
                    87.9543476,
                    55.8907797
                ],
                [
                    87.9530633,
                    55.8919497
                ],
                [
                    87.9512388,
                    55.8929495
                ],
                [
                    87.9493516,
                    55.8950078
                ]
            ],
            "longitude": 87.9608896,
            "latitude": 55.8950163
        },
        "7906": {
            "name": "Верх-Кочура",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.9715609,
            "latitude": 52.6565748
        },
        "7907": {
            "name": "Новоивановка",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.9978513,
            "latitude": 55.7895322
        },
        "7908": {
            "name": "Тонгул",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    88.0017442,
                    56.570242
                ],
                [
                    88.0021112,
                    56.5708935
                ],
                [
                    88.0054547,
                    56.5740157
                ],
                [
                    88.0054547,
                    56.5746446
                ],
                [
                    88.0081866,
                    56.5774072
                ],
                [
                    88.0081051,
                    56.5780585
                ],
                [
                    88.0093283,
                    56.579159
                ],
                [
                    88.0114894,
                    56.5803043
                ],
                [
                    88.0122641,
                    56.5803941
                ],
                [
                    88.0152661,
                    56.5794856
                ],
                [
                    88.0153079,
                    56.5787267
                ],
                [
                    88.0158298,
                    56.5785542
                ],
                [
                    88.0158089,
                    56.5770133
                ],
                [
                    88.014598,
                    56.5766109
                ],
                [
                    88.0130532,
                    56.5766799
                ],
                [
                    88.013596,
                    56.5760704
                ],
                [
                    88.0124269,
                    56.5741499
                ],
                [
                    88.0127609,
                    56.5739544
                ],
                [
                    88.0128235,
                    56.5734254
                ],
                [
                    88.0112786,
                    56.5736784
                ],
                [
                    88.0099217,
                    56.5725169
                ],
                [
                    88.010882,
                    56.5719763
                ],
                [
                    88.0100678,
                    56.5711598
                ],
                [
                    88.0085438,
                    56.5708493
                ],
                [
                    88.0090021,
                    56.5692536
                ],
                [
                    88.0080234,
                    56.5688717
                ],
                [
                    88.0086351,
                    56.5682427
                ],
                [
                    88.0074118,
                    56.567771
                ],
                [
                    88.0031305,
                    56.5689167
                ],
                [
                    88.0021112,
                    56.5693435
                ],
                [
                    88.0017442,
                    56.570242
                ]
            ],
            "longitude": 88.008392,
            "latitude": 56.574001
        },
        "7909": {
            "name": "Чистопольский",
            "population": 97,
            "type": "hamlet",
            "poly": [
                [
                    88.0086453,
                    56.0875983
                ],
                [
                    88.008669,
                    56.0888272
                ],
                [
                    88.0103269,
                    56.0897654
                ],
                [
                    88.0114164,
                    56.088999
                ],
                [
                    88.0128138,
                    56.0896729
                ],
                [
                    88.0147085,
                    56.0896861
                ],
                [
                    88.0173375,
                    56.0881269
                ],
                [
                    88.0192323,
                    56.088008
                ],
                [
                    88.0205823,
                    56.0875851
                ],
                [
                    88.0195165,
                    56.086713
                ],
                [
                    88.0183323,
                    56.0863429
                ],
                [
                    88.0171717,
                    56.0854972
                ],
                [
                    88.0167454,
                    56.0843475
                ],
                [
                    88.0185927,
                    56.0836867
                ],
                [
                    88.0160585,
                    56.0839378
                ],
                [
                    88.0119847,
                    56.0854311
                ],
                [
                    88.0086453,
                    56.0875983
                ]
            ],
            "longitude": 88.013786,
            "latitude": 56.087006
        },
        "7910": {
            "name": "Малый Лабыш",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.0493536,
            "latitude": 52.6305405
        },
        "7911": {
            "name": "Чулеш",
            "population": 239,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.049698,
            "latitude": 52.541859
        },
        "7912": {
            "name": "Куркули",
            "population": 110,
            "type": "hamlet",
            "poly": [
                [
                    88.0447269,
                    56.4132902
                ],
                [
                    88.0460073,
                    56.4137904
                ],
                [
                    88.0491569,
                    56.4136192
                ],
                [
                    88.0502553,
                    56.4140153
                ],
                [
                    88.0508015,
                    56.4138307
                ],
                [
                    88.0515661,
                    56.4130652
                ],
                [
                    88.0531014,
                    56.4124643
                ],
                [
                    88.0537932,
                    56.412602
                ],
                [
                    88.0546489,
                    56.4129947
                ],
                [
                    88.0563176,
                    56.4121387
                ],
                [
                    88.0570945,
                    56.4115612
                ],
                [
                    88.0583931,
                    56.4117157
                ],
                [
                    88.0617915,
                    56.4126657
                ],
                [
                    88.0666584,
                    56.4137803
                ],
                [
                    88.0688854,
                    56.4143107
                ],
                [
                    88.0692678,
                    56.4139851
                ],
                [
                    88.0631992,
                    56.4117593
                ],
                [
                    88.0637152,
                    56.4113094
                ],
                [
                    88.062641,
                    56.4108193
                ],
                [
                    88.0627563,
                    56.4106279
                ],
                [
                    88.0621859,
                    56.4105238
                ],
                [
                    88.0620038,
                    56.410309
                ],
                [
                    88.0620038,
                    56.410121
                ],
                [
                    88.0623498,
                    56.4099565
                ],
                [
                    88.0619371,
                    56.4097449
                ],
                [
                    88.0623558,
                    56.4093756
                ],
                [
                    88.0620645,
                    56.4092111
                ],
                [
                    88.0593155,
                    56.4082139
                ],
                [
                    88.0596493,
                    56.4078547
                ],
                [
                    88.0581807,
                    56.4071496
                ],
                [
                    88.0585569,
                    56.4069045
                ],
                [
                    88.0579319,
                    56.4065855
                ],
                [
                    88.0585812,
                    56.4060416
                ],
                [
                    88.0554317,
                    56.4061759
                ],
                [
                    88.0548855,
                    56.4061221
                ],
                [
                    88.0543576,
                    56.4060315
                ],
                [
                    88.0534777,
                    56.4057394
                ],
                [
                    88.0523489,
                    56.405595
                ],
                [
                    88.0520516,
                    56.4056051
                ],
                [
                    88.0518513,
                    56.4056789
                ],
                [
                    88.0511352,
                    56.4063773
                ],
                [
                    88.0536354,
                    56.4075861
                ],
                [
                    88.0533199,
                    56.4077707
                ],
                [
                    88.0526948,
                    56.4075223
                ],
                [
                    88.0524824,
                    56.4077036
                ],
                [
                    88.051827,
                    56.4074115
                ],
                [
                    88.0515054,
                    56.4076532
                ],
                [
                    88.0522397,
                    56.4080461
                ],
                [
                    88.0518452,
                    56.4082878
                ],
                [
                    88.0516996,
                    56.4082274
                ],
                [
                    88.0512627,
                    56.4083852
                ],
                [
                    88.0506558,
                    56.4081904
                ],
                [
                    88.0501764,
                    56.408224
                ],
                [
                    88.0498487,
                    56.4089559
                ],
                [
                    88.0498426,
                    56.4095704
                ],
                [
                    88.0492904,
                    56.4100135
                ],
                [
                    88.0484469,
                    56.4101814
                ],
                [
                    88.0476701,
                    56.4108495
                ],
                [
                    88.0464625,
                    56.4112423
                ],
                [
                    88.0457161,
                    56.41185
                ],
                [
                    88.044824,
                    56.4128101
                ],
                [
                    88.0447269,
                    56.4132902
                ]
            ],
            "longitude": 88.054054,
            "latitude": 56.410046
        },
        "7913": {
            "name": "Большой Лабыш",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.0609615,
            "latitude": 52.6074618
        },
        "7914": {
            "name": "Константиновка",
            "population": 143,
            "type": "hamlet",
            "poly": [
                [
                    88.0518412,
                    56.1284064
                ],
                [
                    88.0520278,
                    56.1310706
                ],
                [
                    88.0528195,
                    56.1328513
                ],
                [
                    88.0537594,
                    56.1339711
                ],
                [
                    88.0561483,
                    56.1354861
                ],
                [
                    88.0559475,
                    56.1359079
                ],
                [
                    88.0572624,
                    56.1379543
                ],
                [
                    88.0573988,
                    56.1389221
                ],
                [
                    88.055848,
                    56.1398842
                ],
                [
                    88.0580152,
                    56.1405971
                ],
                [
                    88.0592191,
                    56.1415805
                ],
                [
                    88.059151,
                    56.1419742
                ],
                [
                    88.0596065,
                    56.1426871
                ],
                [
                    88.0641513,
                    56.1442602
                ],
                [
                    88.0649389,
                    56.1441423
                ],
                [
                    88.0659584,
                    56.1433292
                ],
                [
                    88.0664202,
                    56.1432388
                ],
                [
                    88.0686446,
                    56.143613
                ],
                [
                    88.0692919,
                    56.1432462
                ],
                [
                    88.0691104,
                    56.142843
                ],
                [
                    88.0677927,
                    56.1427841
                ],
                [
                    88.0669472,
                    56.1427948
                ],
                [
                    88.066135,
                    56.142769
                ],
                [
                    88.0661854,
                    56.1422512
                ],
                [
                    88.0676704,
                    56.1420574
                ],
                [
                    88.0684535,
                    56.1418495
                ],
                [
                    88.0688389,
                    56.140604
                ],
                [
                    88.0697256,
                    56.1406326
                ],
                [
                    88.0700899,
                    56.1413211
                ],
                [
                    88.0709585,
                    56.1417622
                ],
                [
                    88.071271,
                    56.1420423
                ],
                [
                    88.0719157,
                    56.1420332
                ],
                [
                    88.0732412,
                    56.1415124
                ],
                [
                    88.0742931,
                    56.1408949
                ],
                [
                    88.0749667,
                    56.140127
                ],
                [
                    88.0758227,
                    56.140127
                ],
                [
                    88.0764297,
                    56.1398408
                ],
                [
                    88.0781054,
                    56.1400286
                ],
                [
                    88.0795383,
                    56.1399964
                ],
                [
                    88.080406,
                    56.1391204
                ],
                [
                    88.0804424,
                    56.1381966
                ],
                [
                    88.0793826,
                    56.1377575
                ],
                [
                    88.079437,
                    56.1371669
                ],
                [
                    88.0799261,
                    56.1366672
                ],
                [
                    88.0798448,
                    56.1363199
                ],
                [
                    88.0791652,
                    56.1364325
                ],
                [
                    88.0787632,
                    56.136249
                ],
                [
                    88.0785674,
                    56.136001
                ],
                [
                    88.0787712,
                    56.1356679
                ],
                [
                    88.0798511,
                    56.1357657
                ],
                [
                    88.0793011,
                    56.1352439
                ],
                [
                    88.079369,
                    56.1344262
                ],
                [
                    88.078821,
                    56.1341088
                ],
                [
                    88.0782141,
                    56.1334419
                ],
                [
                    88.0763391,
                    56.1339567
                ],
                [
                    88.0746915,
                    56.1335749
                ],
                [
                    88.074301,
                    56.1332147
                ],
                [
                    88.0744368,
                    56.1325408
                ],
                [
                    88.0741546,
                    56.1315596
                ],
                [
                    88.0752249,
                    56.1315489
                ],
                [
                    88.0758092,
                    56.1314429
                ],
                [
                    88.0757005,
                    56.1308523
                ],
                [
                    88.0762983,
                    56.1307008
                ],
                [
                    88.0775347,
                    56.1308901
                ],
                [
                    88.0783092,
                    56.1308825
                ],
                [
                    88.0782835,
                    56.1306367
                ],
                [
                    88.0767867,
                    56.1299868
                ],
                [
                    88.0762575,
                    56.1298451
                ],
                [
                    88.076144,
                    56.1294122
                ],
                [
                    88.0774029,
                    56.1290897
                ],
                [
                    88.0775729,
                    56.127755
                ],
                [
                    88.0767058,
                    56.1270584
                ],
                [
                    88.076661,
                    56.1263055
                ],
                [
                    88.077426,
                    56.1261118
                ],
                [
                    88.0777929,
                    56.125665
                ],
                [
                    88.078513,
                    56.1253242
                ],
                [
                    88.0788759,
                    56.124995
                ],
                [
                    88.0790022,
                    56.1237792
                ],
                [
                    88.079566,
                    56.1221969
                ],
                [
                    88.0783024,
                    56.1213859
                ],
                [
                    88.0765632,
                    56.1216888
                ],
                [
                    88.0761692,
                    56.1212041
                ],
                [
                    88.0741311,
                    56.1208936
                ],
                [
                    88.0731951,
                    56.1203233
                ],
                [
                    88.0726909,
                    56.1204694
                ],
                [
                    88.0723343,
                    56.1209222
                ],
                [
                    88.0726637,
                    56.1216661
                ],
                [
                    88.0737739,
                    56.1220602
                ],
                [
                    88.0736583,
                    56.123556
                ],
                [
                    88.0711419,
                    56.1229158
                ],
                [
                    88.069688,
                    56.1231582
                ],
                [
                    88.0676345,
                    56.1229854
                ],
                [
                    88.067881,
                    56.1227037
                ],
                [
                    88.070005,
                    56.1223918
                ],
                [
                    88.0693946,
                    56.1191151
                ],
                [
                    88.0690575,
                    56.1179456
                ],
                [
                    88.0686772,
                    56.1170548
                ],
                [
                    88.0685705,
                    56.11605
                ],
                [
                    88.0677859,
                    56.115964
                ],
                [
                    88.0672206,
                    56.1160186
                ],
                [
                    88.0660575,
                    56.1164125
                ],
                [
                    88.0638287,
                    56.1159786
                ],
                [
                    88.0637572,
                    56.1164321
                ],
                [
                    88.0621029,
                    56.1167018
                ],
                [
                    88.0599548,
                    56.1192644
                ],
                [
                    88.0588522,
                    56.1199998
                ],
                [
                    88.0581968,
                    56.1202444
                ],
                [
                    88.0577381,
                    56.1206209
                ],
                [
                    88.0575002,
                    56.1211505
                ],
                [
                    88.0578875,
                    56.1217797
                ],
                [
                    88.057686,
                    56.1219862
                ],
                [
                    88.057181,
                    56.1217343
                ],
                [
                    88.0546337,
                    56.1232242
                ],
                [
                    88.0537842,
                    56.1240291
                ],
                [
                    88.0535395,
                    56.1249531
                ],
                [
                    88.0522462,
                    56.1264409
                ],
                [
                    88.0518412,
                    56.1284064
                ]
            ],
            "longitude": 88.066742,
            "latitude": 56.127384
        },
        "7915": {
            "name": "Таенза",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.0828697,
            "latitude": 52.9391524
        },
        "7916": {
            "name": "Московка",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.0872918,
            "latitude": 55.3664769
        },
        "7917": {
            "name": "Распадный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1029487,
            "latitude": 53.7659509
        },
        "7918": {
            "name": "Верхняя Александровка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1064092,
            "latitude": 52.812543
        },
        "7919": {
            "name": "Новый Берикуль",
            "population": 227,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1326055,
            "latitude": 55.4865624
        },
        "7920": {
            "name": "Сайзак",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1369831,
            "latitude": 52.6565821
        },
        "7921": {
            "name": "Карбалык",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1508309,
            "latitude": 52.6884832
        },
        "7922": {
            "name": "Узунгол",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1677227,
            "latitude": 52.6459071
        },
        "7923": {
            "name": "Джелсай",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1722544,
            "latitude": 52.7935352
        },
        "7924": {
            "name": "Верхние Кичи",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.1724041,
            "latitude": 52.752763
        },
        "7925": {
            "name": "Рубино",
            "population": 195,
            "type": "hamlet",
            "poly": [
                [
                    88.1563404,
                    56.3583418
                ],
                [
                    88.156518,
                    56.3586041
                ],
                [
                    88.1568731,
                    56.3589484
                ],
                [
                    88.1571541,
                    56.3588582
                ],
                [
                    88.1583231,
                    56.3589484
                ],
                [
                    88.1591221,
                    56.3596779
                ],
                [
                    88.1601135,
                    56.360014
                ],
                [
                    88.1613563,
                    56.3603172
                ],
                [
                    88.1619038,
                    56.3611041
                ],
                [
                    88.1625992,
                    56.3618172
                ],
                [
                    88.1621109,
                    56.3623335
                ],
                [
                    88.1621109,
                    56.3626204
                ],
                [
                    88.1627472,
                    56.3628909
                ],
                [
                    88.1636201,
                    56.3626368
                ],
                [
                    88.1647298,
                    56.362227
                ],
                [
                    88.1652625,
                    56.3621778
                ],
                [
                    88.1674819,
                    56.3614975
                ],
                [
                    88.1694498,
                    56.3613336
                ],
                [
                    88.1702044,
                    56.3615221
                ],
                [
                    88.170959,
                    56.36185
                ],
                [
                    88.1712993,
                    56.3626778
                ],
                [
                    88.1718468,
                    56.3629728
                ],
                [
                    88.1729861,
                    56.3631613
                ],
                [
                    88.1747912,
                    56.3630712
                ],
                [
                    88.1755014,
                    56.3637596
                ],
                [
                    88.1757233,
                    56.3643989
                ],
                [
                    88.1755902,
                    56.3654725
                ],
                [
                    88.175383,
                    56.3659888
                ],
                [
                    88.1757085,
                    56.3660216
                ],
                [
                    88.1771289,
                    56.3662183
                ],
                [
                    88.1775432,
                    56.3662511
                ],
                [
                    88.1781498,
                    56.3660872
                ],
                [
                    88.180828,
                    56.3642596
                ],
                [
                    88.1812275,
                    56.3638662
                ],
                [
                    88.1834173,
                    56.3574074
                ],
                [
                    88.1830178,
                    56.3569975
                ],
                [
                    88.1709294,
                    56.3527101
                ],
                [
                    88.1702932,
                    56.3519968
                ],
                [
                    88.1687988,
                    56.3523412
                ],
                [
                    88.1678962,
                    56.3523248
                ],
                [
                    88.1665054,
                    56.3518657
                ],
                [
                    88.1654696,
                    56.3517427
                ],
                [
                    88.1636645,
                    56.3520378
                ],
                [
                    88.1635461,
                    56.3524395
                ],
                [
                    88.1629839,
                    56.3529478
                ],
                [
                    88.1620221,
                    56.3527183
                ],
                [
                    88.1619778,
                    56.3534807
                ],
                [
                    88.1624956,
                    56.3541775
                ],
                [
                    88.162688,
                    56.354694
                ],
                [
                    88.1613267,
                    56.3549645
                ],
                [
                    88.1608681,
                    56.3549399
                ],
                [
                    88.1605277,
                    56.3559646
                ],
                [
                    88.1580864,
                    56.3567024
                ],
                [
                    88.1563404,
                    56.3583418
                ]
            ],
            "longitude": 88.17263,
            "latitude": 56.359596
        },
        "7926": {
            "name": "Средние Кичи",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.195229,
            "latitude": 52.744408
        },
        "7927": {
            "name": "Фёдоровка",
            "population": 64,
            "type": "hamlet",
            "poly": [
                [
                    88.1788143,
                    56.2737671
                ],
                [
                    88.1788487,
                    56.274064
                ],
                [
                    88.1801531,
                    56.2743489
                ],
                [
                    88.1812053,
                    56.2749234
                ],
                [
                    88.1823857,
                    56.2749248
                ],
                [
                    88.1833792,
                    56.2743682
                ],
                [
                    88.1842575,
                    56.2742282
                ],
                [
                    88.1850557,
                    56.2737127
                ],
                [
                    88.1857358,
                    56.2736585
                ],
                [
                    88.1862034,
                    56.273798
                ],
                [
                    88.1865143,
                    56.2741528
                ],
                [
                    88.1870919,
                    56.2741788
                ],
                [
                    88.1871774,
                    56.2738073
                ],
                [
                    88.1880898,
                    56.2737418
                ],
                [
                    88.1903713,
                    56.2735879
                ],
                [
                    88.1919253,
                    56.2744757
                ],
                [
                    88.1941862,
                    56.2751419
                ],
                [
                    88.1972292,
                    56.276453
                ],
                [
                    88.197595,
                    56.2769476
                ],
                [
                    88.1977515,
                    56.2773289
                ],
                [
                    88.1982616,
                    56.2778698
                ],
                [
                    88.1988806,
                    56.2781287
                ],
                [
                    88.1998646,
                    56.2781545
                ],
                [
                    88.201504,
                    56.277661
                ],
                [
                    88.2032529,
                    56.2777726
                ],
                [
                    88.2045501,
                    56.2783909
                ],
                [
                    88.2052803,
                    56.2791681
                ],
                [
                    88.2076863,
                    56.2791102
                ],
                [
                    88.2085168,
                    56.279849
                ],
                [
                    88.2090285,
                    56.2798572
                ],
                [
                    88.2094741,
                    56.2794107
                ],
                [
                    88.2098153,
                    56.2792683
                ],
                [
                    88.2101807,
                    56.2783607
                ],
                [
                    88.210072,
                    56.2777814
                ],
                [
                    88.2098219,
                    56.2774193
                ],
                [
                    88.2099812,
                    56.2769905
                ],
                [
                    88.2105067,
                    56.276677
                ],
                [
                    88.2116504,
                    56.2763018
                ],
                [
                    88.2116535,
                    56.2754218
                ],
                [
                    88.2109606,
                    56.275037
                ],
                [
                    88.2110901,
                    56.2741317
                ],
                [
                    88.210618,
                    56.2737442
                ],
                [
                    88.2097691,
                    56.272163
                ],
                [
                    88.2096969,
                    56.2719968
                ],
                [
                    88.2089496,
                    56.271778
                ],
                [
                    88.2089853,
                    56.2710484
                ],
                [
                    88.2087594,
                    56.2710085
                ],
                [
                    88.2083789,
                    56.2718459
                ],
                [
                    88.2080529,
                    56.2714385
                ],
                [
                    88.2076316,
                    56.2714536
                ],
                [
                    88.2070473,
                    56.2716271
                ],
                [
                    88.2065801,
                    56.2713557
                ],
                [
                    88.2061099,
                    56.2712424
                ],
                [
                    88.2056051,
                    56.2709122
                ],
                [
                    88.2047314,
                    56.270838
                ],
                [
                    88.2041526,
                    56.2709369
                ],
                [
                    88.2036128,
                    56.2705506
                ],
                [
                    88.2028593,
                    56.2702816
                ],
                [
                    88.2014534,
                    56.2702169
                ],
                [
                    88.2001122,
                    56.2702818
                ],
                [
                    88.199589,
                    56.2699326
                ],
                [
                    88.1983814,
                    56.2698677
                ],
                [
                    88.1973258,
                    56.2697164
                ],
                [
                    88.1962676,
                    56.2690328
                ],
                [
                    88.1920519,
                    56.2683683
                ],
                [
                    88.1897328,
                    56.2669132
                ],
                [
                    88.188457,
                    56.2660779
                ],
                [
                    88.1874844,
                    56.266224
                ],
                [
                    88.1836533,
                    56.2682475
                ],
                [
                    88.1835757,
                    56.2684524
                ],
                [
                    88.1839375,
                    56.2686996
                ],
                [
                    88.1848071,
                    56.2691091
                ],
                [
                    88.1851731,
                    56.2702542
                ],
                [
                    88.1845079,
                    56.270801
                ],
                [
                    88.1834018,
                    56.2712144
                ],
                [
                    88.1826436,
                    56.272068
                ],
                [
                    88.181607,
                    56.2727981
                ],
                [
                    88.1804748,
                    56.2727894
                ],
                [
                    88.1806139,
                    56.2730984
                ],
                [
                    88.1788143,
                    56.2737671
                ]
            ],
            "longitude": 88.195786,
            "latitude": 56.270966
        },
        "7928": {
            "name": "Малый Майзас",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2116559,
            "latitude": 53.4892927
        },
        "7929": {
            "name": "Ивановка",
            "population": 48,
            "type": "hamlet",
            "poly": [
                [
                    88.1916013,
                    56.1236047
                ],
                [
                    88.192607,
                    56.1236233
                ],
                [
                    88.1958135,
                    56.1249941
                ],
                [
                    88.1969414,
                    56.1251683
                ],
                [
                    88.1979468,
                    56.125138
                ],
                [
                    88.1986462,
                    56.1253322
                ],
                [
                    88.1990474,
                    56.1258802
                ],
                [
                    88.1992104,
                    56.1257741
                ],
                [
                    88.1995094,
                    56.1258271
                ],
                [
                    88.1995773,
                    56.1262588
                ],
                [
                    88.20008,
                    56.1273796
                ],
                [
                    88.200542,
                    56.1276371
                ],
                [
                    88.2003518,
                    56.1280157
                ],
                [
                    88.2013844,
                    56.1282808
                ],
                [
                    88.2015475,
                    56.1285382
                ],
                [
                    88.2008953,
                    56.1286291
                ],
                [
                    88.2007594,
                    56.1291365
                ],
                [
                    88.2016819,
                    56.1291287
                ],
                [
                    88.2019279,
                    56.1294091
                ],
                [
                    88.2027431,
                    56.1294848
                ],
                [
                    88.2038165,
                    56.1293258
                ],
                [
                    88.2047948,
                    56.1297347
                ],
                [
                    88.2051889,
                    56.1301512
                ],
                [
                    88.2055965,
                    56.1302572
                ],
                [
                    88.2047676,
                    56.1304465
                ],
                [
                    88.2048492,
                    56.1306358
                ],
                [
                    88.2054198,
                    56.1305146
                ],
                [
                    88.2063709,
                    56.131181
                ],
                [
                    88.2071067,
                    56.1314772
                ],
                [
                    88.2072948,
                    56.1318701
                ],
                [
                    88.2068601,
                    56.1322108
                ],
                [
                    88.2069415,
                    56.1325818
                ],
                [
                    88.2066291,
                    56.132968
                ],
                [
                    88.2070072,
                    56.1339521
                ],
                [
                    88.2089933,
                    56.1346792
                ],
                [
                    88.2099172,
                    56.1352319
                ],
                [
                    88.2116428,
                    56.1353757
                ],
                [
                    88.2137488,
                    56.1360798
                ],
                [
                    88.2154744,
                    56.136307
                ],
                [
                    88.2167788,
                    56.1370414
                ],
                [
                    88.223287,
                    56.1396608
                ],
                [
                    88.2250462,
                    56.1396757
                ],
                [
                    88.2271187,
                    56.1389341
                ],
                [
                    88.2275128,
                    56.1389416
                ],
                [
                    88.2276079,
                    56.137912
                ],
                [
                    88.2280563,
                    56.1375108
                ],
                [
                    88.2280563,
                    56.1372003
                ],
                [
                    88.2291432,
                    56.1375032
                ],
                [
                    88.2295373,
                    56.1369505
                ],
                [
                    88.2299856,
                    56.1368294
                ],
                [
                    88.2299177,
                    56.1371474
                ],
                [
                    88.2301448,
                    56.137153
                ],
                [
                    88.2302617,
                    56.136839
                ],
                [
                    88.2295825,
                    56.1363658
                ],
                [
                    88.2301557,
                    56.1362594
                ],
                [
                    88.2297523,
                    56.1350409
                ],
                [
                    88.230835,
                    56.1325209
                ],
                [
                    88.2306426,
                    56.1321395
                ],
                [
                    88.2309821,
                    56.1315966
                ],
                [
                    88.2317294,
                    56.1314357
                ],
                [
                    88.2325107,
                    56.1325431
                ],
                [
                    88.2331391,
                    56.1321456
                ],
                [
                    88.2326466,
                    56.1318332
                ],
                [
                    88.2335637,
                    56.1316061
                ],
                [
                    88.2340902,
                    56.1320604
                ],
                [
                    88.2344978,
                    56.132155
                ],
                [
                    88.2345378,
                    56.1317657
                ],
                [
                    88.2351848,
                    56.1316145
                ],
                [
                    88.2348817,
                    56.1313129
                ],
                [
                    88.2327291,
                    56.1314788
                ],
                [
                    88.2314908,
                    56.1312578
                ],
                [
                    88.2285209,
                    56.1299194
                ],
                [
                    88.2237836,
                    56.1296612
                ],
                [
                    88.2231621,
                    56.1296071
                ],
                [
                    88.2226599,
                    56.1293439
                ],
                [
                    88.2227958,
                    56.1283216
                ],
                [
                    88.2234569,
                    56.1279806
                ],
                [
                    88.2228468,
                    56.127375
                ],
                [
                    88.220435,
                    56.1274507
                ],
                [
                    88.2189913,
                    56.1278293
                ],
                [
                    88.2176809,
                    56.1278375
                ],
                [
                    88.2151593,
                    56.1274507
                ],
                [
                    88.2130584,
                    56.1266554
                ],
                [
                    88.2130287,
                    56.1263118
                ],
                [
                    88.2148629,
                    56.1248729
                ],
                [
                    88.2146728,
                    56.1244791
                ],
                [
                    88.2141565,
                    56.124002
                ],
                [
                    88.2141988,
                    56.123548
                ],
                [
                    88.2149309,
                    56.1231992
                ],
                [
                    88.2149173,
                    56.1229568
                ],
                [
                    88.2145096,
                    56.1227296
                ],
                [
                    88.2158277,
                    56.1213436
                ],
                [
                    88.2160722,
                    56.1203135
                ],
                [
                    88.2164541,
                    56.1195459
                ],
                [
                    88.2147815,
                    56.1190031
                ],
                [
                    88.2133683,
                    56.1188289
                ],
                [
                    88.2128249,
                    56.1184805
                ],
                [
                    88.2126684,
                    56.118102
                ],
                [
                    88.2134363,
                    56.1173291
                ],
                [
                    88.2136569,
                    56.1161854
                ],
                [
                    88.2110721,
                    56.1157308
                ],
                [
                    88.2052937,
                    56.1154028
                ],
                [
                    88.2021317,
                    56.1167686
                ],
                [
                    88.2017377,
                    56.1173973
                ],
                [
                    88.2011127,
                    56.11742
                ],
                [
                    88.2009814,
                    56.1177275
                ],
                [
                    88.2014116,
                    56.1183441
                ],
                [
                    88.201561,
                    56.1188365
                ],
                [
                    88.201493,
                    56.1195333
                ],
                [
                    88.2025221,
                    56.1211739
                ],
                [
                    88.2015067,
                    56.120821
                ],
                [
                    88.1957669,
                    56.1207189
                ],
                [
                    88.1920499,
                    56.1224797
                ],
                [
                    88.1916013,
                    56.1236047
                ]
            ],
            "longitude": 88.215645,
            "latitude": 56.129879
        },
        "7930": {
            "name": "Нижние Кичи",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2203161,
            "latitude": 52.7572227
        },
        "7931": {
            "name": "Знаменка",
            "population": 199,
            "type": "hamlet",
            "poly": [
                [
                    88.2187905,
                    56.0581536
                ],
                [
                    88.2195534,
                    56.0629534
                ],
                [
                    88.2208135,
                    56.0672608
                ],
                [
                    88.2215995,
                    56.0674359
                ],
                [
                    88.2225289,
                    56.0672413
                ],
                [
                    88.2225554,
                    56.0677746
                ],
                [
                    88.2256072,
                    56.0683079
                ],
                [
                    88.2271995,
                    56.0678339
                ],
                [
                    88.2290183,
                    56.068465
                ],
                [
                    88.2305964,
                    56.0678487
                ],
                [
                    88.2317906,
                    56.0682635
                ],
                [
                    88.2335788,
                    56.0681524
                ],
                [
                    88.2339666,
                    56.0687375
                ],
                [
                    88.2373041,
                    56.068532
                ],
                [
                    88.2385999,
                    56.0672669
                ],
                [
                    88.2363053,
                    56.0656155
                ],
                [
                    88.2360893,
                    56.065033
                ],
                [
                    88.2365807,
                    56.0648532
                ],
                [
                    88.2381297,
                    56.0660784
                ],
                [
                    88.2398548,
                    56.0668809
                ],
                [
                    88.242525,
                    56.0669349
                ],
                [
                    88.2455355,
                    56.0663023
                ],
                [
                    88.2452867,
                    56.0624133
                ],
                [
                    88.2376986,
                    56.0610244
                ],
                [
                    88.2377566,
                    56.0586706
                ],
                [
                    88.2386108,
                    56.056996
                ],
                [
                    88.2399542,
                    56.0566332
                ],
                [
                    88.241389,
                    56.0566024
                ],
                [
                    88.2444989,
                    56.0578758
                ],
                [
                    88.2460496,
                    56.057976
                ],
                [
                    88.2473185,
                    56.05776
                ],
                [
                    88.2489771,
                    56.0566024
                ],
                [
                    88.2461989,
                    56.0544259
                ],
                [
                    88.2479405,
                    56.0535461
                ],
                [
                    88.246116,
                    56.0525272
                ],
                [
                    88.2446812,
                    56.0532527
                ],
                [
                    88.2429647,
                    56.0535461
                ],
                [
                    88.2327643,
                    56.0467611
                ],
                [
                    88.2306081,
                    56.0478032
                ],
                [
                    88.2291153,
                    56.0475253
                ],
                [
                    88.2285098,
                    56.0458655
                ],
                [
                    88.2271665,
                    56.0445609
                ],
                [
                    88.2238078,
                    56.0439819
                ],
                [
                    88.2216931,
                    56.044422
                ],
                [
                    88.222315,
                    56.0467379
                ],
                [
                    88.2191637,
                    56.0474558
                ],
                [
                    88.2200896,
                    56.0497288
                ],
                [
                    88.2195534,
                    56.0527433
                ],
                [
                    88.220051,
                    56.0551513
                ],
                [
                    88.2187905,
                    56.0581536
                ]
            ],
            "longitude": 88.229675,
            "latitude": 56.058052
        },
        "7932": {
            "name": "3747 км",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.230682,
            "latitude": 56.175644
        },
        "7933": {
            "name": "Суета",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2375455,
            "latitude": 53.0357957
        },
        "7934": {
            "name": "Путятинский",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    88.2563707,
                    55.9960546
                ],
                [
                    88.2582174,
                    55.9970625
                ],
                [
                    88.2603785,
                    55.997934
                ],
                [
                    88.2602827,
                    55.998418
                ],
                [
                    88.2595979,
                    55.9987219
                ],
                [
                    88.2594053,
                    55.9993219
                ],
                [
                    88.2603914,
                    55.9995061
                ],
                [
                    88.2618153,
                    55.9994514
                ],
                [
                    88.2627174,
                    55.9996094
                ],
                [
                    88.2637721,
                    55.9995728
                ],
                [
                    88.2637501,
                    56.0005368
                ],
                [
                    88.2633908,
                    56.0013346
                ],
                [
                    88.2661548,
                    56.0014768
                ],
                [
                    88.2714951,
                    56.0029872
                ],
                [
                    88.2702946,
                    56.0006458
                ],
                [
                    88.2689531,
                    55.997167
                ],
                [
                    88.2686638,
                    55.9967076
                ],
                [
                    88.268703,
                    55.9961469
                ],
                [
                    88.269573,
                    55.9962665
                ],
                [
                    88.2706037,
                    55.9956792
                ],
                [
                    88.2714974,
                    55.9949421
                ],
                [
                    88.2718095,
                    55.9946914
                ],
                [
                    88.2698519,
                    55.994035
                ],
                [
                    88.2705697,
                    55.9933615
                ],
                [
                    88.271454,
                    55.9931321
                ],
                [
                    88.2704088,
                    55.9917704
                ],
                [
                    88.2682715,
                    55.991735
                ],
                [
                    88.266488,
                    55.9936518
                ],
                [
                    88.2658942,
                    55.9936437
                ],
                [
                    88.2628419,
                    55.993504
                ],
                [
                    88.2598658,
                    55.9935962
                ],
                [
                    88.2579898,
                    55.9940625
                ],
                [
                    88.2573587,
                    55.9945093
                ],
                [
                    88.2569258,
                    55.9950974
                ],
                [
                    88.2565109,
                    55.9955184
                ],
                [
                    88.2563707,
                    55.9960546
                ]
            ],
            "longitude": 88.2670164,
            "latitude": 55.998405
        },
        "7935": {
            "name": "Верхний Таймет",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2690882,
            "latitude": 52.4852546
        },
        "7936": {
            "name": "Средняя Пурла",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2694387,
            "latitude": 52.7967213
        },
        "7937": {
            "name": "Верхний Нымзас",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2750876,
            "latitude": 52.7022005
        },
        "7938": {
            "name": "Ржавчик",
            "population": 255,
            "type": "hamlet",
            "poly": [
                [
                    88.2675933,
                    55.6891976
                ],
                [
                    88.2693099,
                    55.6912295
                ],
                [
                    88.2693099,
                    55.6921004
                ],
                [
                    88.2736015,
                    55.6949061
                ],
                [
                    88.2754898,
                    55.6954866
                ],
                [
                    88.2777214,
                    55.6971313
                ],
                [
                    88.2808844,
                    55.6967361
                ],
                [
                    88.2791501,
                    55.6908289
                ],
                [
                    88.2782364,
                    55.6911328
                ],
                [
                    88.2741165,
                    55.6915198
                ],
                [
                    88.2713699,
                    55.688617
                ],
                [
                    88.2675933,
                    55.6891976
                ]
            ],
            "longitude": 88.2754899,
            "latitude": 55.6930679
        },
        "7939": {
            "name": "Смычка",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2872724,
            "latitude": 55.6868027
        },
        "7940": {
            "name": "Аверьяновка",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    88.2844234,
                    56.1646318
                ],
                [
                    88.284576,
                    56.1662054
                ],
                [
                    88.2850586,
                    56.1664582
                ],
                [
                    88.2883465,
                    56.1664513
                ],
                [
                    88.2896203,
                    56.1666309
                ],
                [
                    88.291013,
                    56.1665931
                ],
                [
                    88.2928812,
                    56.1665458
                ],
                [
                    88.2936625,
                    56.1663661
                ],
                [
                    88.2973528,
                    56.1665166
                ],
                [
                    88.2972801,
                    56.1659028
                ],
                [
                    88.2982404,
                    56.1659065
                ],
                [
                    88.2981616,
                    56.1645709
                ],
                [
                    88.2976537,
                    56.1645599
                ],
                [
                    88.2972122,
                    56.1642289
                ],
                [
                    88.2961468,
                    56.1640483
                ],
                [
                    88.295276,
                    56.1640209
                ],
                [
                    88.2938323,
                    56.1642762
                ],
                [
                    88.2902748,
                    56.1641746
                ],
                [
                    88.2903694,
                    56.1630268
                ],
                [
                    88.2888873,
                    56.1628934
                ],
                [
                    88.2887541,
                    56.1635858
                ],
                [
                    88.2883465,
                    56.163652
                ],
                [
                    88.2889182,
                    56.1641686
                ],
                [
                    88.2878539,
                    56.1640965
                ],
                [
                    88.2868009,
                    56.1645977
                ],
                [
                    88.2844234,
                    56.1646318
                ]
            ],
            "longitude": 88.2893323,
            "latitude": 56.1656505
        },
        "7941": {
            "name": "Узунгол",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2993627,
            "latitude": 52.6547954
        },
        "7942": {
            "name": "Святогорка",
            "population": 39,
            "type": "hamlet",
            "poly": [
                [
                    88.2891693,
                    56.2280858
                ],
                [
                    88.2908198,
                    56.2291877
                ],
                [
                    88.2930447,
                    56.2303206
                ],
                [
                    88.2950319,
                    56.2316989
                ],
                [
                    88.2966284,
                    56.2324825
                ],
                [
                    88.2990401,
                    56.2334548
                ],
                [
                    88.3002969,
                    56.2342477
                ],
                [
                    88.3015198,
                    56.2348613
                ],
                [
                    88.3050355,
                    56.2367492
                ],
                [
                    88.3060708,
                    56.2371161
                ],
                [
                    88.3059819,
                    56.2379805
                ],
                [
                    88.3066489,
                    56.2385426
                ],
                [
                    88.3114724,
                    56.240468
                ],
                [
                    88.3136634,
                    56.2415062
                ],
                [
                    88.3153958,
                    56.2427048
                ],
                [
                    88.3160099,
                    56.2429595
                ],
                [
                    88.3170942,
                    56.2426859
                ],
                [
                    88.3180622,
                    56.2423273
                ],
                [
                    88.3181982,
                    56.2421385
                ],
                [
                    88.3188096,
                    56.2415911
                ],
                [
                    88.3200178,
                    56.2410075
                ],
                [
                    88.3193361,
                    56.2399112
                ],
                [
                    88.3184869,
                    56.2399867
                ],
                [
                    88.3146315,
                    56.2377875
                ],
                [
                    88.3131879,
                    56.2367303
                ],
                [
                    88.3115271,
                    56.2359661
                ],
                [
                    88.3100058,
                    56.2345515
                ],
                [
                    88.3074083,
                    56.2338608
                ],
                [
                    88.3053242,
                    56.2330583
                ],
                [
                    88.3030993,
                    56.2316423
                ],
                [
                    88.3007385,
                    56.2305755
                ],
                [
                    88.2999742,
                    56.2303678
                ],
                [
                    88.2992268,
                    56.2304056
                ],
                [
                    88.299193,
                    56.2298014
                ],
                [
                    88.2982758,
                    56.2294048
                ],
                [
                    88.2971039,
                    56.2297919
                ],
                [
                    88.2967473,
                    56.2293576
                ],
                [
                    88.2963227,
                    56.2289139
                ],
                [
                    88.2965604,
                    56.2286968
                ],
                [
                    88.2957452,
                    56.2282058
                ],
                [
                    88.2950488,
                    56.2281114
                ],
                [
                    88.2922466,
                    56.2266769
                ],
                [
                    88.2891693,
                    56.2280858
                ]
            ],
            "longitude": 88.305481,
            "latitude": 56.234749
        },
        "7943": {
            "name": "Большой Берчикуль",
            "population": 230,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3058118,
            "latitude": 55.6368384
        },
        "7944": {
            "name": "Нижний Нымзас",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3061209,
            "latitude": 52.6999491
        },
        "7945": {
            "name": "Тундинка",
            "population": 131,
            "type": "hamlet",
            "poly": [
                [
                    88.2936111,
                    56.5385558
                ],
                [
                    88.2939764,
                    56.5389156
                ],
                [
                    88.2948375,
                    56.5389299
                ],
                [
                    88.2958814,
                    56.5393184
                ],
                [
                    88.2970819,
                    56.5393328
                ],
                [
                    88.2985693,
                    56.5399947
                ],
                [
                    88.2998219,
                    56.5399659
                ],
                [
                    88.3012311,
                    56.5403975
                ],
                [
                    88.3017008,
                    56.5406709
                ],
                [
                    88.3016485,
                    56.5412608
                ],
                [
                    88.3023532,
                    56.541232
                ],
                [
                    88.3032666,
                    56.5408004
                ],
                [
                    88.3040234,
                    56.5410018
                ],
                [
                    88.3048062,
                    56.5410018
                ],
                [
                    88.3051194,
                    56.5414622
                ],
                [
                    88.3065808,
                    56.5416924
                ],
                [
                    88.3073115,
                    56.5414047
                ],
                [
                    88.307729,
                    56.5414047
                ],
                [
                    88.3081204,
                    56.5416637
                ],
                [
                    88.309634,
                    56.5416637
                ],
                [
                    88.3099471,
                    56.5414622
                ],
                [
                    88.3122175,
                    56.5416205
                ],
                [
                    88.313444,
                    56.5418651
                ],
                [
                    88.3160797,
                    56.5429154
                ],
                [
                    88.3175932,
                    56.5429154
                ],
                [
                    88.3206726,
                    56.543534
                ],
                [
                    88.3218469,
                    56.5435772
                ],
                [
                    88.3225776,
                    56.5429297
                ],
                [
                    88.3225515,
                    56.5416349
                ],
                [
                    88.3229951,
                    56.5414191
                ],
                [
                    88.3217947,
                    56.5412464
                ],
                [
                    88.3214554,
                    56.5410162
                ],
                [
                    88.3136528,
                    56.5384839
                ],
                [
                    88.3126611,
                    56.5389299
                ],
                [
                    88.3106516,
                    56.5389299
                ],
                [
                    88.3037363,
                    56.5363687
                ],
                [
                    88.300657,
                    56.5363543
                ],
                [
                    88.3002656,
                    56.5361816
                ],
                [
                    88.2979169,
                    56.5363975
                ],
                [
                    88.2960641,
                    56.5376925
                ],
                [
                    88.2960641,
                    56.5383112
                ],
                [
                    88.2953595,
                    56.5385127
                ],
                [
                    88.2949942,
                    56.5382681
                ],
                [
                    88.2936111,
                    56.5385558
                ]
            ],
            "longitude": 88.311539,
            "latitude": 56.540356
        },
        "7946": {
            "name": "Белка",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.312309,
            "latitude": 52.6533203
        },
        "7947": {
            "name": "Усть-Карагол",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3148037,
            "latitude": 52.7615494
        },
        "7948": {
            "name": "Усть-Кезес",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.317909,
            "latitude": 52.803837
        },
        "7949": {
            "name": "Заря",
            "population": 93,
            "type": "hamlet",
            "poly": [
                [
                    88.3129794,
                    56.0404893
                ],
                [
                    88.3142014,
                    56.0426438
                ],
                [
                    88.3160874,
                    56.044567
                ],
                [
                    88.3174552,
                    56.0441214
                ],
                [
                    88.322908,
                    56.0466095
                ],
                [
                    88.3246679,
                    56.0466963
                ],
                [
                    88.3262789,
                    56.0460607
                ],
                [
                    88.326621,
                    56.045558
                ],
                [
                    88.3249444,
                    56.0449208
                ],
                [
                    88.3252623,
                    56.0440995
                ],
                [
                    88.3256157,
                    56.0440967
                ],
                [
                    88.3261985,
                    56.044137
                ],
                [
                    88.3272311,
                    56.0408885
                ],
                [
                    88.3259346,
                    56.0408597
                ],
                [
                    88.3257729,
                    56.0390357
                ],
                [
                    88.3264087,
                    56.0383478
                ],
                [
                    88.3263259,
                    56.0375634
                ],
                [
                    88.3230119,
                    56.037909
                ],
                [
                    88.3183589,
                    56.0378436
                ],
                [
                    88.3180309,
                    56.0394417
                ],
                [
                    88.3144377,
                    56.0392949
                ],
                [
                    88.3129794,
                    56.0404893
                ]
            ],
            "longitude": 88.3190298,
            "latitude": 56.0413872
        },
        "7950": {
            "name": "Студёный Плёс",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3243359,
            "latitude": 53.6641043
        },
        "7951": {
            "name": "Ключевая",
            "population": 89,
            "type": "hamlet",
            "poly": [
                [
                    88.3076826,
                    56.1676283
                ],
                [
                    88.3078993,
                    56.1684588
                ],
                [
                    88.3095169,
                    56.1686779
                ],
                [
                    88.3122513,
                    56.1686779
                ],
                [
                    88.3139667,
                    56.1688954
                ],
                [
                    88.3139667,
                    56.168659
                ],
                [
                    88.3144593,
                    56.1687062
                ],
                [
                    88.3145227,
                    56.1691047
                ],
                [
                    88.3185864,
                    56.1688197
                ],
                [
                    88.3185864,
                    56.1693114
                ],
                [
                    88.3236617,
                    56.1693395
                ],
                [
                    88.3253455,
                    56.1683831
                ],
                [
                    88.3275905,
                    56.1684344
                ],
                [
                    88.3276729,
                    56.1689237
                ],
                [
                    88.3280635,
                    56.1689616
                ],
                [
                    88.3281247,
                    56.1693471
                ],
                [
                    88.3292864,
                    56.1693587
                ],
                [
                    88.3316381,
                    56.1708716
                ],
                [
                    88.3328738,
                    56.1700986
                ],
                [
                    88.3364026,
                    56.1698598
                ],
                [
                    88.3386616,
                    56.169406
                ],
                [
                    88.339784,
                    56.1693683
                ],
                [
                    88.3404788,
                    56.1687913
                ],
                [
                    88.3409375,
                    56.1681294
                ],
                [
                    88.3409037,
                    56.1671561
                ],
                [
                    88.3456618,
                    56.1665122
                ],
                [
                    88.346774,
                    56.1653387
                ],
                [
                    88.3478013,
                    56.1639687
                ],
                [
                    88.3482349,
                    56.1635471
                ],
                [
                    88.3498073,
                    56.1638269
                ],
                [
                    88.3499286,
                    56.1617166
                ],
                [
                    88.3489832,
                    56.1613659
                ],
                [
                    88.3484193,
                    56.1614311
                ],
                [
                    88.348425,
                    56.1620292
                ],
                [
                    88.3478284,
                    56.1620474
                ],
                [
                    88.3473373,
                    56.1626262
                ],
                [
                    88.3446857,
                    56.1632944
                ],
                [
                    88.3397266,
                    56.1640712
                ],
                [
                    88.3395618,
                    56.1643185
                ],
                [
                    88.3405556,
                    56.1662078
                ],
                [
                    88.3399354,
                    56.1664084
                ],
                [
                    88.3366235,
                    56.1664746
                ],
                [
                    88.3334475,
                    56.1668623
                ],
                [
                    88.3333116,
                    56.1671933
                ],
                [
                    88.3314372,
                    56.1670596
                ],
                [
                    88.3303564,
                    56.1667961
                ],
                [
                    88.3292184,
                    56.1666826
                ],
                [
                    88.3284882,
                    56.1662225
                ],
                [
                    88.3172433,
                    56.1663434
                ],
                [
                    88.3172704,
                    56.1668265
                ],
                [
                    88.3120626,
                    56.1668927
                ],
                [
                    88.3116523,
                    56.1663231
                ],
                [
                    88.3094999,
                    56.1664179
                ],
                [
                    88.3095848,
                    56.1674486
                ],
                [
                    88.3076826,
                    56.1676283
                ]
            ],
            "longitude": 88.3324193,
            "latitude": 56.1676576
        },
        "7952": {
            "name": "Нижний Алзак",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3426762,
            "latitude": 52.7095663
        },
        "7953": {
            "name": "Парушка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3443143,
            "latitude": 53.1662822
        },
        "7954": {
            "name": "Прокопьево",
            "population": 74,
            "type": "hamlet",
            "poly": [
                [
                    88.3315299,
                    56.3629574
                ],
                [
                    88.3315597,
                    56.3632875
                ],
                [
                    88.3349271,
                    56.3642614
                ],
                [
                    88.3379369,
                    56.3646411
                ],
                [
                    88.3382051,
                    56.3650207
                ],
                [
                    88.3359999,
                    56.3657965
                ],
                [
                    88.3330497,
                    56.3661596
                ],
                [
                    88.3326027,
                    56.3663577
                ],
                [
                    88.3325729,
                    56.3676946
                ],
                [
                    88.3363873,
                    56.3676781
                ],
                [
                    88.3364171,
                    56.3681072
                ],
                [
                    88.3360297,
                    56.3683383
                ],
                [
                    88.3359999,
                    56.3689985
                ],
                [
                    88.3353443,
                    56.369048
                ],
                [
                    88.3350463,
                    56.3692296
                ],
                [
                    88.3350463,
                    56.3696422
                ],
                [
                    88.3360893,
                    56.3696257
                ],
                [
                    88.3368045,
                    56.3692791
                ],
                [
                    88.3383541,
                    56.3695926
                ],
                [
                    88.3410659,
                    56.3699722
                ],
                [
                    88.3429731,
                    56.3698237
                ],
                [
                    88.3444929,
                    56.3704013
                ],
                [
                    88.3461021,
                    56.3705664
                ],
                [
                    88.3468769,
                    56.3717381
                ],
                [
                    88.3478305,
                    56.3720847
                ],
                [
                    88.3491417,
                    56.3721177
                ],
                [
                    88.3509893,
                    56.3711275
                ],
                [
                    88.3519727,
                    56.371144
                ],
                [
                    88.3523005,
                    56.3713256
                ],
                [
                    88.3528667,
                    56.3726788
                ],
                [
                    88.3536713,
                    56.3726953
                ],
                [
                    88.3561149,
                    56.3717711
                ],
                [
                    88.3567407,
                    56.37088
                ],
                [
                    88.3570983,
                    56.3698402
                ],
                [
                    88.3564725,
                    56.369015
                ],
                [
                    88.3569195,
                    56.3681898
                ],
                [
                    88.3578476,
                    56.3667196
                ],
                [
                    88.3571622,
                    56.3659769
                ],
                [
                    88.3554039,
                    56.3659604
                ],
                [
                    88.355255,
                    56.3656302
                ],
                [
                    88.354659,
                    56.3655972
                ],
                [
                    88.3532882,
                    56.3659769
                ],
                [
                    88.349593,
                    56.3657953
                ],
                [
                    88.3497718,
                    56.3640787
                ],
                [
                    88.3481328,
                    56.3638476
                ],
                [
                    88.3481328,
                    56.3630717
                ],
                [
                    88.349593,
                    56.3633193
                ],
                [
                    88.349593,
                    56.3626756
                ],
                [
                    88.3486692,
                    56.3623784
                ],
                [
                    88.3455402,
                    56.3619327
                ],
                [
                    88.3447356,
                    56.3620813
                ],
                [
                    88.3442886,
                    56.3617181
                ],
                [
                    88.3424409,
                    56.3617512
                ],
                [
                    88.3412745,
                    56.3627593
                ],
                [
                    88.3353145,
                    56.3627263
                ],
                [
                    88.3340033,
                    56.362099
                ],
                [
                    88.3322749,
                    56.3624621
                ],
                [
                    88.3315299,
                    56.3629574
                ]
            ],
            "longitude": 88.3454924,
            "latitude": 56.3671501
        },
        "7955": {
            "name": "Средний Чилей",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3615874,
            "latitude": 53.1228826
        },
        "7956": {
            "name": "Чилису-Анзас",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3623481,
            "latitude": 52.6847621
        },
        "7957": {
            "name": "Верхний Алзак",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.371888,
            "latitude": 52.7021642
        },
        "7958": {
            "name": "Столяровка",
            "population": 53,
            "type": "hamlet",
            "poly": [
                [
                    88.3681657,
                    56.6005846
                ],
                [
                    88.3681866,
                    56.6012626
                ],
                [
                    88.3696271,
                    56.6016763
                ],
                [
                    88.3695644,
                    56.6031702
                ],
                [
                    88.3723202,
                    56.6052156
                ],
                [
                    88.3726751,
                    56.6058361
                ],
                [
                    88.3723619,
                    56.6065025
                ],
                [
                    88.3726751,
                    56.6068932
                ],
                [
                    88.3745957,
                    56.6064451
                ],
                [
                    88.3749924,
                    56.6069391
                ],
                [
                    88.3771009,
                    56.6075596
                ],
                [
                    88.3784162,
                    56.6072953
                ],
                [
                    88.3793347,
                    56.6065715
                ],
                [
                    88.379627,
                    56.606468
                ],
                [
                    88.3795853,
                    56.6060544
                ],
                [
                    88.3783952,
                    56.6056063
                ],
                [
                    88.3783744,
                    56.6050317
                ],
                [
                    88.3803368,
                    56.6042159
                ],
                [
                    88.3803159,
                    56.6039171
                ],
                [
                    88.3795018,
                    56.6039516
                ],
                [
                    88.3787293,
                    56.6044112
                ],
                [
                    88.3780194,
                    56.6043882
                ],
                [
                    88.3774558,
                    56.6040205
                ],
                [
                    88.3772471,
                    56.6033196
                ],
                [
                    88.3782492,
                    56.6028714
                ],
                [
                    88.3768922,
                    56.6022624
                ],
                [
                    88.3756813,
                    56.6022624
                ],
                [
                    88.3749715,
                    56.602722
                ],
                [
                    88.3741782,
                    56.6027105
                ],
                [
                    88.3730508,
                    56.6016993
                ],
                [
                    88.3719444,
                    56.6010213
                ],
                [
                    88.3703577,
                    56.6010442
                ],
                [
                    88.3696271,
                    56.6012396
                ],
                [
                    88.3685622,
                    56.6005846
                ],
                [
                    88.3681657,
                    56.6005846
                ]
            ],
            "longitude": 88.373756,
            "latitude": 56.604305
        },
        "7959": {
            "name": "Усть-Азас",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3899063,
            "latitude": 52.9275863
        },
        "7960": {
            "name": "Усть-Пызас",
            "population": 24,
            "type": "hamlet",
            "poly": [
                [
                    88.3984206,
                    52.8339367
                ],
                [
                    88.404154,
                    52.8361471
                ],
                [
                    88.4031356,
                    52.8348255
                ],
                [
                    88.4032488,
                    52.8331392
                ],
                [
                    88.4063041,
                    52.8327061
                ],
                [
                    88.4074356,
                    52.8361699
                ],
                [
                    88.4070207,
                    52.8371269
                ],
                [
                    88.4100383,
                    52.8380612
                ],
                [
                    88.4082655,
                    52.8363749
                ],
                [
                    88.4075864,
                    52.8340279
                ],
                [
                    88.4083787,
                    52.8319998
                ],
                [
                    88.4121884,
                    52.8309287
                ],
                [
                    88.4155832,
                    52.831225
                ],
                [
                    88.416149,
                    52.830359
                ],
                [
                    88.4119998,
                    52.8299487
                ],
                [
                    88.407662,
                    52.8301994
                ],
                [
                    88.4003443,
                    52.8320909
                ],
                [
                    88.3986469,
                    52.8330253
                ],
                [
                    88.3984206,
                    52.8339367
                ]
            ],
            "longitude": 88.4054063,
            "latitude": 52.8317937
        },
        "7961": {
            "name": "Кондрашка",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.408637,
            "latitude": 55.7229773
        },
        "7962": {
            "name": "За-Мрассу",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4124979,
            "latitude": 53.0405744
        },
        "7963": {
            "name": "Дальний Кезек",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4142224,
            "latitude": 53.0904211
        },
        "7964": {
            "name": "Усть-Анзас",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.415085,
            "latitude": 53.052124
        },
        "7965": {
            "name": "3755 км",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4160807,
            "latitude": 56.1083103
        },
        "7966": {
            "name": "Октябрьский",
            "population": 255,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4170484,
            "latitude": 56.1674664
        },
        "7967": {
            "name": "Почаевка",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4185934,
            "latitude": 56.1354353
        },
        "7968": {
            "name": "Городок",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4210065,
            "latitude": 55.5902413
        },
        "7969": {
            "name": "Чазы-Бук",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.422008,
            "latitude": 53.0067272
        },
        "7970": {
            "name": "Новый",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4231668,
            "latitude": 52.8289984
        },
        "7971": {
            "name": "Тёплая Речка",
            "population": 59,
            "type": "hamlet",
            "poly": [
                [
                    88.4154316,
                    56.2994665
                ],
                [
                    88.4154554,
                    56.3004321
                ],
                [
                    88.4167666,
                    56.3009612
                ],
                [
                    88.4165043,
                    56.3015961
                ],
                [
                    88.4179348,
                    56.3017549
                ],
                [
                    88.4178394,
                    56.3020988
                ],
                [
                    88.416409,
                    56.3022972
                ],
                [
                    88.4179109,
                    56.3038314
                ],
                [
                    88.4186261,
                    56.3038843
                ],
                [
                    88.4192698,
                    56.3034875
                ],
                [
                    88.4216299,
                    56.3044266
                ],
                [
                    88.4233941,
                    56.3044266
                ],
                [
                    88.423704,
                    56.304625
                ],
                [
                    88.4247292,
                    56.3042414
                ],
                [
                    88.4264455,
                    56.3042679
                ],
                [
                    88.4264933,
                    56.3046514
                ],
                [
                    88.4274946,
                    56.3054185
                ],
                [
                    88.4278999,
                    56.3054053
                ],
                [
                    88.4295687,
                    56.3024559
                ],
                [
                    88.4322626,
                    56.3010009
                ],
                [
                    88.4327156,
                    56.3011464
                ],
                [
                    88.4361485,
                    56.3023104
                ],
                [
                    88.4382703,
                    56.3007099
                ],
                [
                    88.4367684,
                    56.2992417
                ],
                [
                    88.4381988,
                    56.2986729
                ],
                [
                    88.4389616,
                    56.2986993
                ],
                [
                    88.4403205,
                    56.2977469
                ],
                [
                    88.4387471,
                    56.2965431
                ],
                [
                    88.4363154,
                    56.298276
                ],
                [
                    88.4334308,
                    56.2979056
                ],
                [
                    88.4337645,
                    56.29694
                ],
                [
                    88.4333116,
                    56.2965563
                ],
                [
                    88.4341936,
                    56.2955774
                ],
                [
                    88.4315711,
                    56.2945455
                ],
                [
                    88.4299501,
                    56.2950615
                ],
                [
                    88.4292349,
                    56.2949159
                ],
                [
                    88.4292349,
                    56.2944397
                ],
                [
                    88.4282575,
                    56.2944132
                ],
                [
                    88.4244192,
                    56.2958288
                ],
                [
                    88.4243477,
                    56.296424
                ],
                [
                    88.420128,
                    56.297522
                ],
                [
                    88.4191506,
                    56.2968738
                ],
                [
                    88.4156461,
                    56.2979321
                ],
                [
                    88.4167666,
                    56.2987126
                ],
                [
                    88.4154316,
                    56.2994665
                ]
            ],
            "longitude": 88.4282228,
            "latitude": 56.3005957
        },
        "7972": {
            "name": "Ближний Кезек",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.43391,
            "latitude": 53.0872449
        },
        "7973": {
            "name": "Таска",
            "population": 14,
            "type": "hamlet",
            "poly": [
                [
                    88.4314297,
                    52.8304851
                ],
                [
                    88.4321511,
                    52.8313719
                ],
                [
                    88.4353352,
                    52.8307106
                ],
                [
                    88.4368526,
                    52.8306956
                ],
                [
                    88.4382208,
                    52.8321382
                ],
                [
                    88.4394118,
                    52.8318803
                ],
                [
                    88.4391328,
                    52.8302057
                ],
                [
                    88.4398254,
                    52.8295663
                ],
                [
                    88.4398078,
                    52.8288117
                ],
                [
                    88.4344213,
                    52.8296425
                ],
                [
                    88.4314297,
                    52.8304851
                ]
            ],
            "longitude": 88.4366252,
            "latitude": 52.8300311
        },
        "7974": {
            "name": "Верхний Анзас",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4394792,
            "latitude": 53.0570747
        },
        "7975": {
            "name": "Сандайка",
            "population": 244,
            "type": "hamlet",
            "poly": [
                [
                    88.4498012,
                    56.3363064
                ],
                [
                    88.4509187,
                    56.3366161
                ],
                [
                    88.4515706,
                    56.3376227
                ],
                [
                    88.4530606,
                    56.3390422
                ],
                [
                    88.4543178,
                    56.339068
                ],
                [
                    88.4561337,
                    56.3399971
                ],
                [
                    88.4571581,
                    56.3416488
                ],
                [
                    88.4599518,
                    56.3419327
                ],
                [
                    88.4599984,
                    56.343223
                ],
                [
                    88.4633044,
                    56.3459067
                ],
                [
                    88.4643287,
                    56.3459325
                ],
                [
                    88.4645936,
                    56.3457101
                ],
                [
                    88.4651657,
                    56.3456996
                ],
                [
                    88.4653754,
                    56.3459004
                ],
                [
                    88.4674925,
                    56.3453296
                ],
                [
                    88.4674353,
                    56.3444418
                ],
                [
                    88.4670347,
                    56.343871
                ],
                [
                    88.467874,
                    56.3435751
                ],
                [
                    88.4673971,
                    56.3420847
                ],
                [
                    88.4695904,
                    56.3413553
                ],
                [
                    88.4685415,
                    56.3406154
                ],
                [
                    88.467874,
                    56.3406048
                ],
                [
                    88.4675688,
                    56.3403194
                ],
                [
                    88.4671302,
                    56.3406154
                ],
                [
                    88.4661575,
                    56.3401503
                ],
                [
                    88.4646508,
                    56.340404
                ],
                [
                    88.4644029,
                    56.3394314
                ],
                [
                    88.4654326,
                    56.3388923
                ],
                [
                    88.4654326,
                    56.3381206
                ],
                [
                    88.4650894,
                    56.3377295
                ],
                [
                    88.4660621,
                    56.3369577
                ],
                [
                    88.4677977,
                    56.3363657
                ],
                [
                    88.4716884,
                    56.3363446
                ],
                [
                    88.4720698,
                    56.3362177
                ],
                [
                    88.4720126,
                    56.3353825
                ],
                [
                    88.4697049,
                    56.3355305
                ],
                [
                    88.4678358,
                    56.3357948
                ],
                [
                    88.4661384,
                    56.3358054
                ],
                [
                    88.4658142,
                    56.3354036
                ],
                [
                    88.465776,
                    56.334653
                ],
                [
                    88.4640213,
                    56.3325491
                ],
                [
                    88.4654518,
                    56.3323376
                ],
                [
                    88.4651085,
                    56.3318195
                ],
                [
                    88.4640596,
                    56.3315763
                ],
                [
                    88.4640213,
                    56.3312274
                ],
                [
                    88.4634302,
                    56.3312063
                ],
                [
                    88.4627054,
                    56.3296308
                ],
                [
                    88.4616565,
                    56.329303
                ],
                [
                    88.460722,
                    56.3283196
                ],
                [
                    88.4599591,
                    56.3283196
                ],
                [
                    88.4591771,
                    56.3288589
                ],
                [
                    88.458555,
                    56.3285367
                ],
                [
                    88.4572047,
                    56.3288465
                ],
                [
                    88.4577634,
                    56.3294402
                ],
                [
                    88.4560406,
                    56.3299049
                ],
                [
                    88.4572512,
                    56.3314537
                ],
                [
                    88.4553422,
                    56.3320991
                ],
                [
                    88.4565528,
                    56.3327444
                ],
                [
                    88.4557612,
                    56.333209
                ],
                [
                    88.4565062,
                    56.3350675
                ],
                [
                    88.4557612,
                    56.3353772
                ],
                [
                    88.4538056,
                    56.3353256
                ],
                [
                    88.4525484,
                    56.3338285
                ],
                [
                    88.4502203,
                    56.3342931
                ],
                [
                    88.4498012,
                    56.3363064
                ]
            ],
            "longitude": 88.4598312,
            "latitude": 56.3352385
        },
        "7976": {
            "name": "Верхний Бугзас",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.4664309,
            "latitude": 52.6500722
        },
        "7977": {
            "name": "Байла",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5025358,
            "latitude": 55.7427914
        },
        "7978": {
            "name": "Парлагол",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.509363,
            "latitude": 52.8280615
        },
        "7979": {
            "name": "Барсук",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5121885,
            "latitude": 53.6541528
        },
        "7980": {
            "name": "Камзас",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5153258,
            "latitude": 52.4255183
        },
        "7981": {
            "name": "Мрассу",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5168287,
            "latitude": 52.2960208
        },
        "7982": {
            "name": "Средний Бугзас",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5229811,
            "latitude": 52.6654454
        },
        "7983": {
            "name": "Учас",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5253819,
            "latitude": 53.1909767
        },
        "7984": {
            "name": "Яковлевка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    88.5222206,
                    55.3436857
                ],
                [
                    88.5231074,
                    55.344253
                ],
                [
                    88.5251027,
                    55.3476566
                ],
                [
                    88.532086,
                    55.3564794
                ],
                [
                    88.5339295,
                    55.3570332
                ],
                [
                    88.5347433,
                    55.356488
                ],
                [
                    88.5364005,
                    55.3561699
                ],
                [
                    88.5369034,
                    55.355688
                ],
                [
                    88.5355945,
                    55.3542183
                ],
                [
                    88.5351359,
                    55.3531541
                ],
                [
                    88.5342856,
                    55.3527486
                ],
                [
                    88.5342534,
                    55.3519168
                ],
                [
                    88.5344321,
                    55.3511418
                ],
                [
                    88.5346062,
                    55.3502479
                ],
                [
                    88.5344812,
                    55.3497144
                ],
                [
                    88.5334945,
                    55.3484785
                ],
                [
                    88.5336594,
                    55.3473469
                ],
                [
                    88.5344545,
                    55.3463264
                ],
                [
                    88.5354397,
                    55.3448279
                ],
                [
                    88.5354956,
                    55.3435788
                ],
                [
                    88.5350418,
                    55.3426334
                ],
                [
                    88.5325419,
                    55.3427242
                ],
                [
                    88.5312977,
                    55.3429181
                ],
                [
                    88.530144,
                    55.3427542
                ],
                [
                    88.5273967,
                    55.3418375
                ],
                [
                    88.5261205,
                    55.3411995
                ],
                [
                    88.5222206,
                    55.3436857
                ]
            ],
            "longitude": 88.5280955,
            "latitude": 55.3458288
        },
        "7985": {
            "name": "Камышловка",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5334348,
            "latitude": 55.9739183
        },
        "7986": {
            "name": "Колхозный Карчит",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.540466,
            "latitude": 52.8047977
        },
        "7987": {
            "name": "Эльбеза",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5553184,
            "latitude": 52.6659749
        },
        "7988": {
            "name": "Кайчак",
            "population": 270,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.560729,
            "latitude": 55.732354
        },
        "7989": {
            "name": "Старый Тяжин",
            "population": 262,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5668209,
            "latitude": 56.1386874
        },
        "7990": {
            "name": "Камень-Садат",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    88.5560652,
                    55.3788391
                ],
                [
                    88.5652366,
                    55.3831467
                ],
                [
                    88.568324,
                    55.3860354
                ],
                [
                    88.5738928,
                    55.38066
                ],
                [
                    88.5736416,
                    55.3795932
                ],
                [
                    88.5725392,
                    55.3781213
                ],
                [
                    88.5701823,
                    55.376606
                ],
                [
                    88.5693122,
                    55.3757255
                ],
                [
                    88.5670764,
                    55.3746247
                ],
                [
                    88.5660142,
                    55.3741627
                ],
                [
                    88.5637141,
                    55.3740733
                ],
                [
                    88.5614228,
                    55.3748405
                ],
                [
                    88.5601515,
                    55.3743246
                ],
                [
                    88.5592888,
                    55.374273
                ],
                [
                    88.5560652,
                    55.3788391
                ]
            ],
            "longitude": 88.5669589,
            "latitude": 55.3810204
        },
        "7991": {
            "name": "Антоново",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5784101,
            "latitude": 55.8165467
        },
        "7992": {
            "name": "Трехречье",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.5979148,
            "latitude": 53.2065349
        },
        "7993": {
            "name": "Борисоглебское",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.6338567,
            "latitude": 56.1967969
        },
        "7994": {
            "name": "Солдаткино",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.634436,
            "latitude": 55.4807626
        },
        "7995": {
            "name": "Кинжир",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.642502,
            "latitude": 55.519669
        },
        "7996": {
            "name": "Усть-Барандат",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.6851835,
            "latitude": 55.821634
        },
        "7997": {
            "name": "Сливень",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7087925,
            "latitude": 53.6728917
        },
        "7998": {
            "name": "Ильинка",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7168488,
            "latitude": 53.1602034
        },
        "7999": {
            "name": "Вознесенка",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7171058,
            "latitude": 55.7692924
        },
        "8000": {
            "name": "Кантус",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7340234,
            "latitude": 52.8138372
        },
        "8001": {
            "name": "Новогеоргиевка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7414193,
            "latitude": 55.6160254
        },
        "8002": {
            "name": "Бороковка",
            "population": 206,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7696409,
            "latitude": 56.1304609
        },
        "8003": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7718968,
            "latitude": 53.66
        },
        "8004": {
            "name": "Большой Ортон",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7814186,
            "latitude": 53.2331479
        },
        "8005": {
            "name": "Большая Покровка",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7940168,
            "latitude": 55.9045032
        },
        "8006": {
            "name": "Сензас",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    88.809949,
                    52.9273681
                ],
                [
                    88.8149624,
                    52.9305706
                ],
                [
                    88.8150636,
                    52.9313665
                ],
                [
                    88.821984,
                    52.9378817
                ],
                [
                    88.8217723,
                    52.9445458
                ],
                [
                    88.8202908,
                    52.9442588
                ],
                [
                    88.8193913,
                    52.9455979
                ],
                [
                    88.8226718,
                    52.9465543
                ],
                [
                    88.8224337,
                    52.94881
                ],
                [
                    88.8254081,
                    52.9489115
                ],
                [
                    88.8263367,
                    52.9409482
                ],
                [
                    88.8281139,
                    52.9401704
                ],
                [
                    88.8293888,
                    52.9350385
                ],
                [
                    88.823846,
                    52.9315872
                ],
                [
                    88.8251367,
                    52.9307842
                ],
                [
                    88.8219192,
                    52.925394
                ],
                [
                    88.8196744,
                    52.9253489
                ],
                [
                    88.8173173,
                    52.9214241
                ],
                [
                    88.8132019,
                    52.9211985
                ],
                [
                    88.809949,
                    52.9273681
                ]
            ],
            "longitude": 88.8222125,
            "latitude": 52.9349493
        },
        "8007": {
            "name": "Лужба",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.8761535,
            "latitude": 53.6596653
        },
        "8008": {
            "name": "Большепичугино",
            "population": 199,
            "type": "hamlet",
            "poly": [
                [
                    88.8578121,
                    55.6565002
                ],
                [
                    88.8578835,
                    55.6592452
                ],
                [
                    88.8633219,
                    55.6611423
                ],
                [
                    88.8695472,
                    55.6608598
                ],
                [
                    88.873769,
                    55.6593663
                ],
                [
                    88.881497,
                    55.6593663
                ],
                [
                    88.8896327,
                    55.6641016
                ],
                [
                    88.8916258,
                    55.6636884
                ],
                [
                    88.8991582,
                    55.6580671
                ],
                [
                    88.8981617,
                    55.6541979
                ],
                [
                    88.8961659,
                    55.6541184
                ],
                [
                    88.8915148,
                    55.6522209
                ],
                [
                    88.8867206,
                    55.6521806
                ],
                [
                    88.8856473,
                    55.652665
                ],
                [
                    88.8616045,
                    55.6563387
                ],
                [
                    88.8578121,
                    55.6565002
                ]
            ],
            "longitude": 88.8834524,
            "latitude": 55.6583425
        },
        "8009": {
            "name": "Новотроицк",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.8836455,
            "latitude": 56.0936831
        },
        "8010": {
            "name": "Беляковка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    88.8801919,
                    56.2760102
                ],
                [
                    88.8839488,
                    56.2788885
                ],
                [
                    88.8856019,
                    56.2793056
                ],
                [
                    88.8925148,
                    56.2791388
                ],
                [
                    88.9079183,
                    56.2781376
                ],
                [
                    88.9070166,
                    56.2697104
                ],
                [
                    88.9044619,
                    56.2683752
                ],
                [
                    88.8995779,
                    56.2678745
                ],
                [
                    88.8921391,
                    56.268709
                ],
                [
                    88.887255,
                    56.2717965
                ],
                [
                    88.8820704,
                    56.2719634
                ],
                [
                    88.8801919,
                    56.2760102
                ]
            ],
            "longitude": 88.8958209,
            "latitude": 56.2745918
        },
        "8011": {
            "name": "Амзас",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.8962463,
            "latitude": 53.6593101
        },
        "8012": {
            "name": "Алексеевка",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.9304876,
            "latitude": 55.9561437
        },
        "8013": {
            "name": "Изындаево",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.1879796,
            "latitude": 55.7496515
        },
        "8014": {
            "name": "Новопреображенка",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.2281484,
            "latitude": 55.8807274
        },
        "8015": {
            "name": "Макарово",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.2302706,
            "latitude": 56.0137493
        },
        "8016": {
            "name": "Чернышово",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.2564725,
            "latitude": 55.951723
        },
        "8017": {
            "name": "Лесной",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.6697423,
            "latitude": 55.2730329
        },
        "8018": {
            "name": "Главстан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.7543842,
            "latitude": 54.6526265
        },
        "8019": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.8711974,
            "latitude": 54.7111364
        },
        "8020": {
            "name": "Калтас",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.997314,
            "latitude": 53.587757
        },
        "8021": {
            "name": "Чарыш",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.034348,
            "latitude": 53.479504
        },
        "8022": {
            "name": "Неожиданный",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.083923,
            "latitude": 53.351364
        },
        "8023": {
            "name": "Николаевка",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.127396,
            "latitude": 53.36351
        },
        "8024": {
            "name": "Чебаки",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.217361,
            "latitude": 54.55563
        },
        "8025": {
            "name": "Шора",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.279358,
            "latitude": 53.421432
        },
        "8026": {
            "name": "Кирово",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.284851,
            "latitude": 54.696934
        },
        "8027": {
            "name": "Агаскыр",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.315318,
            "latitude": 54.9680447
        },
        "8028": {
            "name": "Мирный",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.3233313,
            "latitude": 54.3228136
        },
        "8029": {
            "name": "Шора",
            "population": 184,
            "type": "hamlet",
            "poly": [
                [
                    89.3423575,
                    53.3251204
                ],
                [
                    89.3426127,
                    53.3284357
                ],
                [
                    89.3438888,
                    53.3287977
                ],
                [
                    89.3449415,
                    53.3275974
                ],
                [
                    89.344144,
                    53.3273687
                ],
                [
                    89.3455158,
                    53.3256919
                ],
                [
                    89.3497765,
                    53.3222134
                ],
                [
                    89.3514354,
                    53.3207651
                ],
                [
                    89.3524895,
                    53.321202
                ],
                [
                    89.3536625,
                    53.3196254
                ],
                [
                    89.3526699,
                    53.3192347
                ],
                [
                    89.3534898,
                    53.3182979
                ],
                [
                    89.3497572,
                    53.3158355
                ],
                [
                    89.3481302,
                    53.3164263
                ],
                [
                    89.3480663,
                    53.3174364
                ],
                [
                    89.3451953,
                    53.3175698
                ],
                [
                    89.3460884,
                    53.3185417
                ],
                [
                    89.3445572,
                    53.3184655
                ],
                [
                    89.3448458,
                    53.3204708
                ],
                [
                    89.3440164,
                    53.3242819
                ],
                [
                    89.3423575,
                    53.3251204
                ]
            ],
            "longitude": 89.348602,
            "latitude": 53.320553
        },
        "8030": {
            "name": "Талкин Ключ",
            "population": 169,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.425819,
            "latitude": 54.728886
        },
        "8031": {
            "name": "Казынет",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.429314,
            "latitude": 53.436852
        },
        "8032": {
            "name": "Тлачек",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.435086,
            "latitude": 52.7436746
        },
        "8033": {
            "name": "Малая Сыя",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.438622,
            "latitude": 54.404625
        },
        "8034": {
            "name": "Нижний Матур",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.455315,
            "latitude": 52.63007
        },
        "8035": {
            "name": "Кашпар",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.4673836,
            "latitude": 53.9283736
        },
        "8036": {
            "name": "Костино",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.4986277,
            "latitude": 55.0304633
        },
        "8037": {
            "name": "Тузуксу",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.526863,
            "latitude": 53.374004
        },
        "8038": {
            "name": "Мендоль",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.52729,
            "latitude": 54.204075
        },
        "8039": {
            "name": "Трошкин",
            "population": 262,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.54862,
            "latitude": 54.5463
        },
        "8040": {
            "name": "Кызылсуг",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.552806,
            "latitude": 52.7852684
        },
        "8041": {
            "name": "Ясная Поляна",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.57885,
            "latitude": 53.465694
        },
        "8042": {
            "name": "Усть-Тунгужуль",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.5876726,
            "latitude": 54.2392287
        },
        "8043": {
            "name": "Большой Бор",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.590431,
            "latitude": 52.817318
        },
        "8044": {
            "name": "Ала-Тау",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.608055,
            "latitude": 53.456882
        },
        "8045": {
            "name": "Подлиственки",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.636139,
            "latitude": 54.755875
        },
        "8046": {
            "name": "Шепчул",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.63678,
            "latitude": 52.668823
        },
        "8047": {
            "name": "Топанов",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.658127,
            "latitude": 54.54211
        },
        "8048": {
            "name": "Улень",
            "population": 12,
            "type": "hamlet",
            "poly": [
                [
                    89.6903481,
                    54.0865931
                ],
                [
                    89.6918837,
                    54.0869267
                ],
                [
                    89.6937037,
                    54.0885946
                ],
                [
                    89.6969455,
                    54.0876272
                ],
                [
                    89.6978555,
                    54.0871936
                ],
                [
                    89.701211,
                    54.0872936
                ],
                [
                    89.7023485,
                    54.0863929
                ],
                [
                    89.701666,
                    54.0853254
                ],
                [
                    89.6976849,
                    54.0834905
                ],
                [
                    89.6935899,
                    54.0820559
                ],
                [
                    89.6904619,
                    54.0829567
                ],
                [
                    89.6904619,
                    54.085292
                ],
                [
                    89.6903481,
                    54.0865931
                ]
            ],
            "longitude": 89.695244,
            "latitude": 54.085293
        },
        "8049": {
            "name": "Нанхчул",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.713036,
            "latitude": 53.440434
        },
        "8050": {
            "name": "Верхние Сиры",
            "population": 222,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.718689,
            "latitude": 52.771538
        },
        "8051": {
            "name": "Иничул",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.7219289,
            "latitude": 52.6904553
        },
        "8052": {
            "name": "Верхняя Тёя",
            "population": 150,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.731819,
            "latitude": 52.992466
        },
        "8053": {
            "name": "Кагаево",
            "population": 203,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.743431,
            "latitude": 54.951187
        },
        "8054": {
            "name": "Верхний Курлугаш",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.749428,
            "latitude": 52.826225
        },
        "8055": {
            "name": "Большой Он",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.7562528,
            "latitude": 52.0679176
        },
        "8056": {
            "name": "Усть-Фыркал",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.756821,
            "latitude": 54.634243
        },
        "8057": {
            "name": "Кожухово",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.7972398,
            "latitude": 54.890993
        },
        "8058": {
            "name": "Тюрт-Тас",
            "population": 178,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.80114,
            "latitude": 53.097439
        },
        "8059": {
            "name": "Хабзас",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.801788,
            "latitude": 53.380711
        },
        "8060": {
            "name": "Лырсы",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.804825,
            "latitude": 53.017529
        },
        "8061": {
            "name": "Марчелгаш",
            "population": 234,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.820465,
            "latitude": 54.499043
        },
        "8062": {
            "name": "Малый Анзас",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.820618,
            "latitude": 52.391609
        },
        "8063": {
            "name": "Кубайка",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.824867,
            "latitude": 52.330372
        },
        "8064": {
            "name": "Колтаров",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    89.8320951,
                    54.0621428
                ],
                [
                    89.8326354,
                    54.063261
                ],
                [
                    89.8371,
                    54.0642624
                ],
                [
                    89.8374697,
                    54.0642624
                ],
                [
                    89.8375834,
                    54.0650801
                ],
                [
                    89.8392327,
                    54.0651302
                ],
                [
                    89.8403418,
                    54.0630941
                ],
                [
                    89.8390052,
                    54.0625434
                ],
                [
                    89.8373559,
                    54.0624766
                ],
                [
                    89.8361616,
                    54.0620093
                ],
                [
                    89.839574,
                    54.0573859
                ],
                [
                    89.8372706,
                    54.0571856
                ],
                [
                    89.8352516,
                    54.0579034
                ],
                [
                    89.8327207,
                    54.0604571
                ],
                [
                    89.8320951,
                    54.0621428
                ]
            ],
            "longitude": 89.8350188,
            "latitude": 54.0609752
        },
        "8065": {
            "name": "Малый Сютик",
            "population": 135,
            "type": "hamlet",
            "poly": [
                [
                    89.830721,
                    54.9530881
                ],
                [
                    89.8325744,
                    54.9550423
                ],
                [
                    89.8365852,
                    54.9564031
                ],
                [
                    89.8415987,
                    54.9569265
                ],
                [
                    89.8455487,
                    54.9564206
                ],
                [
                    89.8467641,
                    54.9535417
                ],
                [
                    89.8494987,
                    54.9516049
                ],
                [
                    89.8464907,
                    54.949005
                ],
                [
                    89.8429053,
                    54.9468062
                ],
                [
                    89.8411429,
                    54.9469109
                ],
                [
                    89.839016,
                    54.9486909
                ],
                [
                    89.8376487,
                    54.9494587
                ],
                [
                    89.8352483,
                    54.949511
                ],
                [
                    89.8336379,
                    54.9493016
                ],
                [
                    89.8322706,
                    54.9498077
                ],
                [
                    89.8314331,
                    54.9507374
                ],
                [
                    89.830721,
                    54.9530881
                ]
            ],
            "longitude": 89.837372,
            "latitude": 54.952328
        },
        "8066": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.8468037,
            "latitude": 52.9745244
        },
        "8067": {
            "name": "Большой Сютик",
            "population": 229,
            "type": "hamlet",
            "poly": [
                [
                    89.861233,
                    55.0232836
                ],
                [
                    89.8625194,
                    55.0236308
                ],
                [
                    89.8640851,
                    55.024089
                ],
                [
                    89.8737063,
                    55.0199791
                ],
                [
                    89.8744863,
                    55.0149103
                ],
                [
                    89.8739753,
                    55.0145967
                ],
                [
                    89.871626,
                    55.0133767
                ],
                [
                    89.8680599,
                    55.0134619
                ],
                [
                    89.8654224,
                    55.0140796
                ],
                [
                    89.8649395,
                    55.0151019
                ],
                [
                    89.8637055,
                    55.0165451
                ],
                [
                    89.8630969,
                    55.0174938
                ],
                [
                    89.8618606,
                    55.0175047
                ],
                [
                    89.8626214,
                    55.0187369
                ],
                [
                    89.8627165,
                    55.020078
                ],
                [
                    89.8613661,
                    55.0214082
                ],
                [
                    89.861233,
                    55.0232836
                ]
            ],
            "longitude": 89.866722,
            "latitude": 55.017849
        },
        "8068": {
            "name": "Верхний Туим",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.8702,
            "latitude": 54.2194564
        },
        "8069": {
            "name": "Картоев",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.879379,
            "latitude": 53.077721
        },
        "8070": {
            "name": "Илиморов",
            "population": 150,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.913063,
            "latitude": 52.987068
        },
        "8071": {
            "name": "Тупик",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.9352607,
            "latitude": 54.385736
        },
        "8072": {
            "name": "Картузов",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.973434,
            "latitude": 53.079796
        },
        "8073": {
            "name": "Югачи",
            "population": 259,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.977058,
            "latitude": 53.26017
        },
        "8074": {
            "name": "Политов",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 89.98835,
            "latitude": 52.97197
        },
        "8075": {
            "name": "Улуг-Кичиг",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.003723,
            "latitude": 53.247353
        },
        "8076": {
            "name": "Средний Кисач",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.0136943,
            "latitude": 53.8914614
        },
        "8077": {
            "name": "Тисин",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.0336038,
            "latitude": 54.2837504
        },
        "8078": {
            "name": "Чиланы",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.0410113,
            "latitude": 52.814927
        },
        "8079": {
            "name": "Майский",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.058838,
            "latitude": 53.579044
        },
        "8080": {
            "name": "Чалгыстаг",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.059761,
            "latitude": 54.316822
        },
        "8081": {
            "name": "Печегол",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.084808,
            "latitude": 52.862087
        },
        "8082": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.0892386,
            "latitude": 53.4151143
        },
        "8083": {
            "name": "Казановская",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.099457,
            "latitude": 53.190193
        },
        "8084": {
            "name": "Карагай",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.111229,
            "latitude": 52.845657
        },
        "8085": {
            "name": "Анчыл-Чон",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.11293,
            "latitude": 53.209892
        },
        "8086": {
            "name": "Печень",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.144012,
            "latitude": 52.869278
        },
        "8087": {
            "name": "Абрамов",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.148636,
            "latitude": 52.986187
        },
        "8088": {
            "name": "Ах-Хол",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.174919,
            "latitude": 53.584946
        },
        "8089": {
            "name": "Горюново",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.178291,
            "latitude": 55.050758
        },
        "8090": {
            "name": "Когунек",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.210083,
            "latitude": 54.958847
        },
        "8091": {
            "name": "Конгарово",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.222046,
            "latitude": 55.100449
        },
        "8092": {
            "name": "Бейка",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.241112,
            "latitude": 53.245506
        },
        "8093": {
            "name": "Перевозное",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.253525,
            "latitude": 52.863453
        },
        "8094": {
            "name": "Сартак",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.257149,
            "latitude": 52.822403
        },
        "8095": {
            "name": "Кирово",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.258598,
            "latitude": 52.727383
        },
        "8096": {
            "name": "Харачул",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.2688532,
            "latitude": 52.7114697
        },
        "8097": {
            "name": "Катюшкино",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.273872,
            "latitude": 54.301155
        },
        "8098": {
            "name": "Бейка",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.2951426,
            "latitude": 53.6694179
        },
        "8099": {
            "name": "Бырганов",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.298882,
            "latitude": 52.995983
        },
        "8100": {
            "name": "Сорский подхоз",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    90.2969197,
                    53.9828791
                ],
                [
                    90.2987294,
                    53.9880341
                ],
                [
                    90.3024292,
                    53.9921717
                ],
                [
                    90.3062497,
                    53.9912969
                ],
                [
                    90.3068128,
                    53.9897601
                ],
                [
                    90.3080192,
                    53.984227
                ],
                [
                    90.3071345,
                    53.982548
                ],
                [
                    90.3037564,
                    53.9798521
                ],
                [
                    90.2988902,
                    53.9808453
                ],
                [
                    90.2969197,
                    53.9828791
                ]
            ],
            "longitude": 90.3033944,
            "latitude": 53.985754
        },
        "8101": {
            "name": "Усть-Сос",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.308006,
            "latitude": 52.942356
        },
        "8102": {
            "name": "Туманное",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.3302406,
            "latitude": 54.0880602
        },
        "8103": {
            "name": "Анхаков",
            "population": 245,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.331635,
            "latitude": 53.015266
        },
        "8104": {
            "name": "Уйбат",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.364342,
            "latitude": 53.723888
        },
        "8105": {
            "name": "Усть-База",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.387146,
            "latitude": 53.161095
        },
        "8106": {
            "name": "Камышта",
            "population": 197,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.393158,
            "latitude": 53.562008
        },
        "8107": {
            "name": "Монастырёво",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.405281,
            "latitude": 55.037579
        },
        "8108": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.421439,
            "latitude": 53.4531127
        },
        "8109": {
            "name": "Маткечик",
            "population": 246,
            "type": "hamlet",
            "poly": [
                [
                    90.4194238,
                    53.0069308
                ],
                [
                    90.4251163,
                    53.0089941
                ],
                [
                    90.4231711,
                    53.0109961
                ],
                [
                    90.4226934,
                    53.011381
                ],
                [
                    90.4287485,
                    53.0141423
                ],
                [
                    90.4333913,
                    53.0104168
                ],
                [
                    90.4390389,
                    53.0056102
                ],
                [
                    90.4319747,
                    53.0032578
                ],
                [
                    90.4292314,
                    53.0051562
                ],
                [
                    90.4227159,
                    53.0029276
                ],
                [
                    90.4194238,
                    53.0069308
                ]
            ],
            "longitude": 90.430641,
            "latitude": 53.009174
        },
        "8110": {
            "name": "Красный Ключ",
            "population": 249,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.435257,
            "latitude": 52.868286
        },
        "8111": {
            "name": "Малый Монок",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.436874,
            "latitude": 52.839417
        },
        "8112": {
            "name": "Цветногорск",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.4529879,
            "latitude": 54.2404552
        },
        "8113": {
            "name": "Давыдково",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.5045666,
            "latitude": 54.1256628
        },
        "8114": {
            "name": "Гальджа",
            "population": 157,
            "type": "hamlet",
            "poly": [
                [
                    90.4962345,
                    54.3874698
                ],
                [
                    90.5037581,
                    54.3888012
                ],
                [
                    90.5067824,
                    54.3911849
                ],
                [
                    90.5072506,
                    54.3914541
                ],
                [
                    90.5079257,
                    54.3917432
                ],
                [
                    90.5106549,
                    54.3909272
                ],
                [
                    90.5178834,
                    54.3886939
                ],
                [
                    90.5174777,
                    54.3877704
                ],
                [
                    90.5172657,
                    54.3870255
                ],
                [
                    90.5163713,
                    54.3862242
                ],
                [
                    90.5151911,
                    54.384549
                ],
                [
                    90.5088108,
                    54.385043
                ],
                [
                    90.4968616,
                    54.3863745
                ],
                [
                    90.4962345,
                    54.3874698
                ]
            ],
            "longitude": 90.510803,
            "latitude": 54.388008
        },
        "8115": {
            "name": "Аев",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.513519,
            "latitude": 53.608967
        },
        "8116": {
            "name": "Сыры",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.525391,
            "latitude": 53.346909
        },
        "8117": {
            "name": "Старый Борец",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.5377048,
            "latitude": 54.4639938
        },
        "8118": {
            "name": "Усть-Табат",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.550201,
            "latitude": 53.077885
        },
        "8119": {
            "name": "Чертыковская",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.56234,
            "latitude": 53.162018
        },
        "8120": {
            "name": "Богдановка",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.567238,
            "latitude": 52.934128
        },
        "8121": {
            "name": "Верх-Киндирла",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.599449,
            "latitude": 52.947819
        },
        "8122": {
            "name": "Камызяк",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.599831,
            "latitude": 53.854214
        },
        "8123": {
            "name": "Карасук",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.6082544,
            "latitude": 54.3080385
        },
        "8124": {
            "name": "Усть-Киндирла",
            "population": 253,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.639862,
            "latitude": 53.03561
        },
        "8125": {
            "name": "Бей-Булук",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.676445,
            "latitude": 54.544304
        },
        "8126": {
            "name": "Базандаиха",
            "population": 89,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.684799,
            "latitude": 54.835247
        },
        "8127": {
            "name": "Камышта",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.692787,
            "latitude": 53.263935
        },
        "8128": {
            "name": "Камышовая",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.693909,
            "latitude": 53.787285
        },
        "8129": {
            "name": "Белёлик",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.7395696,
            "latitude": 54.1475849
        },
        "8130": {
            "name": "Капчалы",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.739761,
            "latitude": 53.617256
        },
        "8131": {
            "name": "Верхняя Ерба",
            "population": 208,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.7565644,
            "latitude": 54.319591
        },
        "8132": {
            "name": "Уты",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.789787,
            "latitude": 53.074848
        },
        "8133": {
            "name": "Уйтак",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.791222,
            "latitude": 53.353123
        },
        "8134": {
            "name": "Борозда",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.801331,
            "latitude": 54.538177
        },
        "8135": {
            "name": "Чаптыков",
            "population": 229,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.806023,
            "latitude": 53.239292
        },
        "8136": {
            "name": "Салбык",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.879089,
            "latitude": 53.869347
        },
        "8137": {
            "name": "Ханкуль",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.893661,
            "latitude": 53.397945
        },
        "8138": {
            "name": "Сафьянов",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.894012,
            "latitude": 53.359089
        },
        "8139": {
            "name": "Имени Ильича",
            "population": 143,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.938179,
            "latitude": 53.516308
        },
        "8140": {
            "name": "Таёжная",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.958694,
            "latitude": 54.14888
        },
        "8141": {
            "name": "Дехановка",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.990471,
            "latitude": 53.000221
        },
        "8142": {
            "name": "Черемушка",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 90.998116,
            "latitude": 54.463284
        },
        "8143": {
            "name": "Кирба",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.0053821,
            "latitude": 53.461212
        },
        "8144": {
            "name": "Оросительный",
            "population": 171,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.039368,
            "latitude": 53.577324
        },
        "8145": {
            "name": "Трояков",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.048271,
            "latitude": 53.465939
        },
        "8146": {
            "name": "Красный Катамор",
            "population": 107,
            "type": "hamlet",
            "poly": [
                [
                    91.0511079,
                    53.0220066
                ],
                [
                    91.0513299,
                    53.0256157
                ],
                [
                    91.0648424,
                    53.0249398
                ],
                [
                    91.0670907,
                    53.0270719
                ],
                [
                    91.0729177,
                    53.0265962
                ],
                [
                    91.074208,
                    53.0262374
                ],
                [
                    91.0770383,
                    53.0241262
                ],
                [
                    91.0768024,
                    53.0222235
                ],
                [
                    91.073986,
                    53.0210051
                ],
                [
                    91.0511079,
                    53.0220066
                ]
            ],
            "longitude": 91.067444,
            "latitude": 53.02232
        },
        "8147": {
            "name": "Тутатчиков",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.0716381,
            "latitude": 53.5056525
        },
        "8148": {
            "name": "Хоных",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.080215,
            "latitude": 53.544334
        },
        "8149": {
            "name": "Хызыл-Салда",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.122215,
            "latitude": 53.430347
        },
        "8150": {
            "name": "Шурышев",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.1233731,
            "latitude": 53.515058
        },
        "8151": {
            "name": "Полиндейка",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.127769,
            "latitude": 54.217598
        },
        "8152": {
            "name": "Тигей",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.128113,
            "latitude": 53.594555
        },
        "8153": {
            "name": "Усть-Ерба",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.163239,
            "latitude": 54.445271
        },
        "8154": {
            "name": "Заря",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.175575,
            "latitude": 53.730602
        },
        "8155": {
            "name": "Ковыльная",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.187637,
            "latitude": 53.904263
        },
        "8156": {
            "name": "Климаниховский",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.1969576,
            "latitude": 54.5061298
        },
        "8157": {
            "name": "Баинов",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.202888,
            "latitude": 53.551006
        },
        "8158": {
            "name": "Сахарный",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.2678144,
            "latitude": 53.653544
        },
        "8159": {
            "name": "Красный Камень",
            "population": 197,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.273468,
            "latitude": 54.094357
        },
        "8160": {
            "name": "Абакано-Перевоз",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.317566,
            "latitude": 54.274975
        },
        "8161": {
            "name": "Смирновка",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.370293,
            "latitude": 53.381248
        },
        "8162": {
            "name": "Дмитриевка",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.395142,
            "latitude": 53.268856
        },
        "8163": {
            "name": "Мохов",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.410286,
            "latitude": 53.926334
        },
        "8164": {
            "name": "Герасимово",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.560707,
            "latitude": 53.326355
        },
        "8165": {
            "name": "Берёзовка",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.650589,
            "latitude": 53.407681
        },
        "8166": {
            "name": "Монастырка",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 91.759247,
            "latitude": 53.212826
        },
        "8167": {
            "name": "Жиндо 2-е",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.9660796,
            "latitude": 49.9450115
        },
        "8168": {
            "name": "Средний Шергольджин",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.2781349,
            "latitude": 50.1630994
        },
        "8169": {
            "name": "Егоркино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.428886,
            "latitude": 52.4549647
        },
        "8170": {
            "name": "Кукун",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.9130876,
            "latitude": 50.9770632
        },
        "8171": {
            "name": "Лесоучасток Катангар",
            "population": 256,
            "type": "hamlet",
            "poly": [
                [
                    108.9829519,
                    51.0012964
                ],
                [
                    108.9843268,
                    51.0017709
                ],
                [
                    108.9874758,
                    51.0022314
                ],
                [
                    108.9901148,
                    51.0023012
                ],
                [
                    108.9951932,
                    51.0008637
                ],
                [
                    108.9974995,
                    51.0010312
                ],
                [
                    108.9996728,
                    51.0022593
                ],
                [
                    109.0024892,
                    51.00452
                ],
                [
                    109.003975,
                    51.004199
                ],
                [
                    109.0021122,
                    51.0015894
                ],
                [
                    109.0041746,
                    50.9982958
                ],
                [
                    109.0030658,
                    50.9976678
                ],
                [
                    109.0002937,
                    50.9983516
                ],
                [
                    108.9980318,
                    50.998882
                ],
                [
                    108.9935965,
                    50.9993007
                ],
                [
                    108.986367,
                    50.9998868
                ],
                [
                    108.9836837,
                    51.0005846
                ],
                [
                    108.9829519,
                    51.0012964
                ]
            ],
            "longitude": 109.0003044,
            "latitude": 51.0013565
        },
        "8172": {
            "name": "Мухор-Шибирка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.695877,
            "latitude": 51.342682
        },
        "8173": {
            "name": "Могзон",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.8331972,
            "latitude": 50.5840755
        },
        "8174": {
            "name": "Дутый",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.784645,
            "latitude": 50.99258
        },
        "8175": {
            "name": "Букукун",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.1316534,
            "latitude": 49.4538536
        },
        "8176": {
            "name": "Сарантуй",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.2932553,
            "latitude": 51.6250135
        },
        "8177": {
            "name": "Тайдут",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.426466,
            "latitude": 51.6381902
        },
        "8178": {
            "name": "3",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.0826195,
            "latitude": 52.0717326
        },
        "8179": {
            "name": "Улётка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.7964396,
            "latitude": 51.6958101
        },
        "8180": {
            "name": "Устье",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.9323617,
            "latitude": 49.9701165
        },
        "8181": {
            "name": "Карымка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.56103,
            "latitude": 51.38589
        },
        "8182": {
            "name": "Преображенка",
            "population": 119,
            "type": "hamlet",
            "poly": [
                [
                    112.8211511,
                    52.2070061
                ],
                [
                    112.8233247,
                    52.2098168
                ],
                [
                    112.8255099,
                    52.2112654
                ],
                [
                    112.8252394,
                    52.2122926
                ],
                [
                    112.8260311,
                    52.2138069
                ],
                [
                    112.8271039,
                    52.2158589
                ],
                [
                    112.8274627,
                    52.2165452
                ],
                [
                    112.8273822,
                    52.2177587
                ],
                [
                    112.8272156,
                    52.2202719
                ],
                [
                    112.8270764,
                    52.2223714
                ],
                [
                    112.8286678,
                    52.2226211
                ],
                [
                    112.8321883,
                    52.223367
                ],
                [
                    112.8322551,
                    52.2232809
                ],
                [
                    112.8334123,
                    52.2217895
                ],
                [
                    112.8297991,
                    52.2139702
                ],
                [
                    112.8274993,
                    52.2104612
                ],
                [
                    112.826676,
                    52.2094647
                ],
                [
                    112.8259764,
                    52.2084555
                ],
                [
                    112.8232191,
                    52.2056355
                ],
                [
                    112.8211511,
                    52.2070061
                ]
            ],
            "longitude": 112.8286857,
            "latitude": 52.2183348
        },
        "8183": {
            "name": "Кука",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    112.9110087,
                    51.8002441
                ],
                [
                    112.915613,
                    51.7994809
                ],
                [
                    112.9182965,
                    51.8020384
                ],
                [
                    112.9246571,
                    51.8017589
                ],
                [
                    112.9258649,
                    51.8022461
                ],
                [
                    112.9368834,
                    51.7990649
                ],
                [
                    112.9438403,
                    51.7921134
                ],
                [
                    112.938458,
                    51.7893905
                ],
                [
                    112.9366895,
                    51.7893925
                ],
                [
                    112.931145,
                    51.7930009
                ],
                [
                    112.9298477,
                    51.7928935
                ],
                [
                    112.9192983,
                    51.7975173
                ],
                [
                    112.917096,
                    51.7973803
                ],
                [
                    112.9111753,
                    51.7995539
                ],
                [
                    112.9110087,
                    51.8002441
                ]
            ],
            "longitude": 112.9308259,
            "latitude": 51.7951998
        },
        "8184": {
            "name": "Тасей",
            "population": 97,
            "type": "hamlet",
            "poly": [
                [
                    112.9457032,
                    52.21378
                ],
                [
                    112.9461002,
                    52.2149949
                ],
                [
                    112.9497828,
                    52.2175558
                ],
                [
                    112.9545068,
                    52.2178695
                ],
                [
                    112.9620733,
                    52.2218528
                ],
                [
                    112.9664751,
                    52.2169706
                ],
                [
                    112.9555137,
                    52.2110829
                ],
                [
                    112.9485802,
                    52.211171
                ],
                [
                    112.9457032,
                    52.21378
                ]
            ],
            "longitude": 112.955688,
            "latitude": 52.215809
        },
        "8185": {
            "name": "Хвойный",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    112.9826044,
                    51.6769783
                ],
                [
                    112.9890815,
                    51.6842575
                ],
                [
                    112.9928116,
                    51.6829815
                ],
                [
                    112.9863345,
                    51.6757022
                ],
                [
                    112.9826044,
                    51.6769783
                ]
            ],
            "longitude": 112.9878242,
            "latitude": 51.6799891
        },
        "8186": {
            "name": "Красная Речка",
            "population": 155,
            "type": "hamlet",
            "poly": [
                [
                    113.0523128,
                    51.6352011
                ],
                [
                    113.0545371,
                    51.6394957
                ],
                [
                    113.0549437,
                    51.6412175
                ],
                [
                    113.055427,
                    51.6432639
                ],
                [
                    113.0597193,
                    51.6423706
                ],
                [
                    113.0617346,
                    51.6470318
                ],
                [
                    113.0652908,
                    51.6466382
                ],
                [
                    113.0654567,
                    51.6448052
                ],
                [
                    113.0625035,
                    51.6414801
                ],
                [
                    113.0623542,
                    51.6338502
                ],
                [
                    113.0571778,
                    51.6339738
                ],
                [
                    113.0565514,
                    51.6356955
                ],
                [
                    113.0551269,
                    51.635908
                ],
                [
                    113.0541721,
                    51.6348684
                ],
                [
                    113.0523128,
                    51.6352011
                ]
            ],
            "longitude": 113.0579134,
            "latitude": 51.6406489
        },
        "8187": {
            "name": "Дорожное",
            "population": 187,
            "type": "hamlet",
            "poly": [
                [
                    113.1669747,
                    50.3164074
                ],
                [
                    113.1675308,
                    50.3171405
                ],
                [
                    113.168643,
                    50.3171977
                ],
                [
                    113.1688223,
                    50.3175757
                ],
                [
                    113.1711004,
                    50.3177131
                ],
                [
                    113.1716924,
                    50.3173352
                ],
                [
                    113.1725354,
                    50.3172894
                ],
                [
                    113.173235,
                    50.3175757
                ],
                [
                    113.1733965,
                    50.3182057
                ],
                [
                    113.1747597,
                    50.3186753
                ],
                [
                    113.174957,
                    50.3183774
                ],
                [
                    113.1770557,
                    50.3182286
                ],
                [
                    113.1782396,
                    50.3183316
                ],
                [
                    113.1796388,
                    50.3176101
                ],
                [
                    113.1808765,
                    50.3176444
                ],
                [
                    113.1820963,
                    50.3179308
                ],
                [
                    113.1851457,
                    50.3174955
                ],
                [
                    113.1857017,
                    50.3170603
                ],
                [
                    113.1855582,
                    50.3162585
                ],
                [
                    113.1852354,
                    50.3159836
                ],
                [
                    113.1855582,
                    50.3149068
                ],
                [
                    113.1867421,
                    50.3140478
                ],
                [
                    113.1894148,
                    50.3133491
                ],
                [
                    113.1877108,
                    50.3118026
                ],
                [
                    113.1857735,
                    50.3132231
                ],
                [
                    113.1778091,
                    50.3105654
                ],
                [
                    113.1752979,
                    50.3106915
                ],
                [
                    113.174688,
                    50.3120776
                ],
                [
                    113.1713695,
                    50.3134178
                ],
                [
                    113.1670465,
                    50.3138989
                ],
                [
                    113.1669747,
                    50.3164074
                ]
            ],
            "longitude": 113.1778264,
            "latitude": 50.3158896
        },
        "8188": {
            "name": "Зыково",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    113.192646,
                    52.0245553
                ],
                [
                    113.193593,
                    52.0267041
                ],
                [
                    113.1955894,
                    52.0275868
                ],
                [
                    113.1988019,
                    52.0296359
                ],
                [
                    113.2008161,
                    52.0313305
                ],
                [
                    113.2064671,
                    52.0289985
                ],
                [
                    113.2056681,
                    52.0265403
                ],
                [
                    113.2046026,
                    52.0256297
                ],
                [
                    113.2117943,
                    52.0219147
                ],
                [
                    113.211232,
                    52.0212954
                ],
                [
                    113.2121495,
                    52.0208948
                ],
                [
                    113.2142443,
                    52.0210962
                ],
                [
                    113.2096923,
                    52.0179726
                ],
                [
                    113.1990682,
                    52.021168
                ],
                [
                    113.1983579,
                    52.0220239
                ],
                [
                    113.1954576,
                    52.023153
                ],
                [
                    113.1932971,
                    52.0234809
                ],
                [
                    113.192646,
                    52.0245553
                ]
            ],
            "longitude": 113.2023791,
            "latitude": 52.0229421
        },
        "8189": {
            "name": "ЧЭС",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    113.2045228,
                    52.0135341
                ],
                [
                    113.2057984,
                    52.0146125
                ],
                [
                    113.2163095,
                    52.0112197
                ],
                [
                    113.2211173,
                    52.0094363
                ],
                [
                    113.2242517,
                    52.0113143
                ],
                [
                    113.2237815,
                    52.0120509
                ],
                [
                    113.22316,
                    52.0119051
                ],
                [
                    113.2217098,
                    52.0137631
                ],
                [
                    113.2210291,
                    52.013581
                ],
                [
                    113.2193422,
                    52.0148196
                ],
                [
                    113.2146957,
                    52.0171693
                ],
                [
                    113.2159683,
                    52.0178796
                ],
                [
                    113.2152284,
                    52.0182985
                ],
                [
                    113.2154948,
                    52.0187538
                ],
                [
                    113.2167449,
                    52.0187068
                ],
                [
                    113.2229233,
                    52.0156757
                ],
                [
                    113.2260929,
                    52.012269
                ],
                [
                    113.2249062,
                    52.011559
                ],
                [
                    113.2278139,
                    52.0098561
                ],
                [
                    113.2259936,
                    52.0071571
                ],
                [
                    113.2278953,
                    52.0065139
                ],
                [
                    113.2275698,
                    52.0056202
                ],
                [
                    113.2265043,
                    52.0048185
                ],
                [
                    113.226762,
                    52.0046768
                ],
                [
                    113.2275749,
                    52.0042297
                ],
                [
                    113.2278919,
                    52.0040554
                ],
                [
                    113.2284869,
                    52.0037281
                ],
                [
                    113.2302125,
                    52.002779
                ],
                [
                    113.2249358,
                    52.0005551
                ],
                [
                    113.2225056,
                    52.0022789
                ],
                [
                    113.2224201,
                    52.0038711
                ],
                [
                    113.2213957,
                    52.0040648
                ],
                [
                    113.2203072,
                    52.0025591
                ],
                [
                    113.2188469,
                    52.003024
                ],
                [
                    113.2170526,
                    52.0004031
                ],
                [
                    113.2105085,
                    52.0059155
                ],
                [
                    113.2132108,
                    52.0094362
                ],
                [
                    113.212476,
                    52.0095188
                ],
                [
                    113.2121209,
                    52.009118
                ],
                [
                    113.2081394,
                    52.0109164
                ],
                [
                    113.2078295,
                    52.0115044
                ],
                [
                    113.2045228,
                    52.0135341
                ]
            ],
            "longitude": 113.2188134,
            "latitude": 52.0056533
        },
        "8190": {
            "name": "Наклонный",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    113.2141786,
                    51.9874475
                ],
                [
                    113.2174831,
                    51.989086
                ],
                [
                    113.2164102,
                    51.9912266
                ],
                [
                    113.218513,
                    51.992178
                ],
                [
                    113.2171826,
                    51.9938692
                ],
                [
                    113.2239633,
                    51.9968551
                ],
                [
                    113.2262225,
                    51.9941286
                ],
                [
                    113.223062,
                    51.9922308
                ],
                [
                    113.2239633,
                    51.9914116
                ],
                [
                    113.2271819,
                    51.9929707
                ],
                [
                    113.230186,
                    51.9900638
                ],
                [
                    113.2268815,
                    51.9886103
                ],
                [
                    113.2283406,
                    51.9873153
                ],
                [
                    113.230186,
                    51.9883724
                ],
                [
                    113.2314305,
                    51.9871831
                ],
                [
                    113.230186,
                    51.9857296
                ],
                [
                    113.2305882,
                    51.9850121
                ],
                [
                    113.230636,
                    51.9841995
                ],
                [
                    113.2311313,
                    51.9838016
                ],
                [
                    113.2259803,
                    51.9779586
                ],
                [
                    113.2232337,
                    51.9790424
                ],
                [
                    113.2246499,
                    51.9806812
                ],
                [
                    113.2178264,
                    51.9844081
                ],
                [
                    113.2193713,
                    51.9857296
                ],
                [
                    113.2141786,
                    51.9874475
                ]
            ],
            "longitude": 113.2233195,
            "latitude": 51.9895617
        },
        "8191": {
            "name": "Черновская",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    113.2229762,
                    51.9673571
                ],
                [
                    113.2280402,
                    51.9740725
                ],
                [
                    113.2306581,
                    51.9822143
                ],
                [
                    113.233748,
                    51.9795445
                ],
                [
                    113.2313447,
                    51.974284
                ],
                [
                    113.2332759,
                    51.9721691
                ],
                [
                    113.2301431,
                    51.964475
                ],
                [
                    113.2229762,
                    51.9673571
                ]
            ],
            "longitude": 113.2280907,
            "latitude": 51.9701091
        },
        "8192": {
            "name": "Черново",
            "population": 228,
            "type": "hamlet",
            "poly": [
                [
                    113.240968,
                    51.955761
                ],
                [
                    113.2489556,
                    51.9577953
                ],
                [
                    113.2474178,
                    51.9610931
                ],
                [
                    113.2496472,
                    51.9614592
                ],
                [
                    113.2522173,
                    51.9582148
                ],
                [
                    113.2499188,
                    51.9539309
                ],
                [
                    113.2435623,
                    51.9521834
                ],
                [
                    113.240968,
                    51.955761
                ]
            ],
            "longitude": 113.245715,
            "latitude": 51.9551671
        },
        "8193": {
            "name": "Сибирский",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    113.2456355,
                    51.9897467
                ],
                [
                    113.2460647,
                    51.9933407
                ],
                [
                    113.2494979,
                    51.9934993
                ],
                [
                    113.26263,
                    51.9996295
                ],
                [
                    113.2634025,
                    52.0029585
                ],
                [
                    113.2694106,
                    52.005706
                ],
                [
                    113.2739596,
                    52.0047021
                ],
                [
                    113.2754188,
                    52.0005278
                ],
                [
                    113.2662349,
                    51.9980441
                ],
                [
                    113.2523303,
                    51.9904867
                ],
                [
                    113.2482963,
                    51.9894824
                ],
                [
                    113.2456355,
                    51.9897467
                ]
            ],
            "longitude": 113.2586819,
            "latitude": 51.9963002
        },
        "8194": {
            "name": "Мухор-Кондуй",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    113.2705358,
                    52.4165629
                ],
                [
                    113.2782247,
                    52.4211509
                ],
                [
                    113.2790143,
                    52.417729
                ],
                [
                    113.2780169,
                    52.4152194
                ],
                [
                    113.275066,
                    52.4141294
                ],
                [
                    113.2711176,
                    52.4144081
                ],
                [
                    113.2705358,
                    52.4165629
                ]
            ],
            "longitude": 113.274818,
            "latitude": 52.416309
        },
        "8195": {
            "name": "Верхняя Салия",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.281532,
            "latitude": 51.1998842
        },
        "8196": {
            "name": "Такеча",
            "population": 202,
            "type": "hamlet",
            "poly": [
                [
                    113.2898089,
                    50.4695203
                ],
                [
                    113.2908388,
                    50.4717055
                ],
                [
                    113.2941004,
                    50.4724703
                ],
                [
                    113.2978769,
                    50.4729073
                ],
                [
                    113.3023401,
                    50.4735628
                ],
                [
                    113.3001085,
                    50.4702852
                ],
                [
                    113.2989842,
                    50.4681819
                ],
                [
                    113.3015591,
                    50.4654502
                ],
                [
                    113.299877,
                    50.4637545
                ],
                [
                    113.2978769,
                    50.4626364
                ],
                [
                    113.294787,
                    50.4649312
                ],
                [
                    113.2904955,
                    50.4664609
                ],
                [
                    113.2898089,
                    50.4695203
                ]
            ],
            "longitude": 113.2956292,
            "latitude": 50.4687685
        },
        "8197": {
            "name": "Кутузовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.3086998,
            "latitude": 52.083183
        },
        "8198": {
            "name": "Лесоучасток Верх-Нарым",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.4212755,
            "latitude": 51.5566405
        },
        "8199": {
            "name": "Противочумная Станция",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.4360662,
            "latitude": 52.1147653
        },
        "8200": {
            "name": "Эбэр-Алханай",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    113.502244,
                    50.8146911
                ],
                [
                    113.5045287,
                    50.8158976
                ],
                [
                    113.5097541,
                    50.8139284
                ],
                [
                    113.509484,
                    50.813062
                ],
                [
                    113.506783,
                    50.8127994
                ],
                [
                    113.502244,
                    50.8146911
                ]
            ],
            "longitude": 113.5061388,
            "latitude": 50.8142271
        },
        "8201": {
            "name": "Молоковка",
            "population": 230,
            "type": "hamlet",
            "poly": [
                [
                    113.5207738,
                    51.9026967
                ],
                [
                    113.5220769,
                    51.9030259
                ],
                [
                    113.5225093,
                    51.9028813
                ],
                [
                    113.5225699,
                    51.9029911
                ],
                [
                    113.5228323,
                    51.9037327
                ],
                [
                    113.5241437,
                    51.9038189
                ],
                [
                    113.5241695,
                    51.9042131
                ],
                [
                    113.5241669,
                    51.9048387
                ],
                [
                    113.5253205,
                    51.9045354
                ],
                [
                    113.5253852,
                    51.9046312
                ],
                [
                    113.5255119,
                    51.9049153
                ],
                [
                    113.5273225,
                    51.9048626
                ],
                [
                    113.5273303,
                    51.9051083
                ],
                [
                    113.5276407,
                    51.9051099
                ],
                [
                    113.5276226,
                    51.9053142
                ],
                [
                    113.5279485,
                    51.9053126
                ],
                [
                    113.5287658,
                    51.9061472
                ],
                [
                    113.5286468,
                    51.9064089
                ],
                [
                    113.528784,
                    51.9064097
                ],
                [
                    113.5287946,
                    51.9064698
                ],
                [
                    113.5291093,
                    51.9064652
                ],
                [
                    113.5291262,
                    51.9065658
                ],
                [
                    113.529408,
                    51.9065607
                ],
                [
                    113.5294589,
                    51.9065149
                ],
                [
                    113.5295394,
                    51.9062711
                ],
                [
                    113.5292936,
                    51.9061724
                ],
                [
                    113.5293752,
                    51.9055214
                ],
                [
                    113.5293263,
                    51.9047176
                ],
                [
                    113.5291409,
                    51.9046542
                ],
                [
                    113.5293057,
                    51.9041327
                ],
                [
                    113.5295954,
                    51.9042348
                ],
                [
                    113.5298728,
                    51.9039285
                ],
                [
                    113.5300303,
                    51.9039036
                ],
                [
                    113.5300691,
                    51.9040791
                ],
                [
                    113.5301829,
                    51.9040744
                ],
                [
                    113.5301674,
                    51.9043919
                ],
                [
                    113.5302301,
                    51.9045264
                ],
                [
                    113.5303361,
                    51.9045218
                ],
                [
                    113.5306349,
                    51.9042768
                ],
                [
                    113.5314899,
                    51.9040288
                ],
                [
                    113.5303694,
                    51.9003555
                ],
                [
                    113.5299693,
                    51.9002383
                ],
                [
                    113.529739,
                    51.9003131
                ],
                [
                    113.5293712,
                    51.8996223
                ],
                [
                    113.5295692,
                    51.89956
                ],
                [
                    113.529549,
                    51.8989765
                ],
                [
                    113.5297841,
                    51.8986504
                ],
                [
                    113.529732,
                    51.8982585
                ],
                [
                    113.5291178,
                    51.898326
                ],
                [
                    113.5289094,
                    51.8978818
                ],
                [
                    113.5288336,
                    51.897231
                ],
                [
                    113.5285417,
                    51.8963641
                ],
                [
                    113.5278325,
                    51.8960692
                ],
                [
                    113.5274779,
                    51.8957647
                ],
                [
                    113.5273235,
                    51.8956378
                ],
                [
                    113.5267741,
                    51.8958872
                ],
                [
                    113.527153,
                    51.8962808
                ],
                [
                    113.5260823,
                    51.8967482
                ],
                [
                    113.5260788,
                    51.8967692
                ],
                [
                    113.5259532,
                    51.8968263
                ],
                [
                    113.525854,
                    51.8975434
                ],
                [
                    113.5257744,
                    51.8979968
                ],
                [
                    113.5254606,
                    51.8981902
                ],
                [
                    113.5253065,
                    51.8983779
                ],
                [
                    113.5254375,
                    51.898453
                ],
                [
                    113.5255685,
                    51.8986378
                ],
                [
                    113.5257604,
                    51.898632
                ],
                [
                    113.5257698,
                    51.8988544
                ],
                [
                    113.5256762,
                    51.898993
                ],
                [
                    113.5257978,
                    51.8990132
                ],
                [
                    113.5259335,
                    51.8988457
                ],
                [
                    113.5259897,
                    51.8988486
                ],
                [
                    113.5260412,
                    51.8991056
                ],
                [
                    113.5260739,
                    51.8992817
                ],
                [
                    113.5259897,
                    51.8994059
                ],
                [
                    113.5259216,
                    51.899402
                ],
                [
                    113.5258206,
                    51.8999981
                ],
                [
                    113.5262752,
                    51.9000293
                ],
                [
                    113.5263889,
                    51.8998072
                ],
                [
                    113.5266334,
                    51.8997583
                ],
                [
                    113.5268584,
                    51.8998492
                ],
                [
                    113.5270141,
                    51.8999951
                ],
                [
                    113.5270021,
                    51.9002982
                ],
                [
                    113.5265615,
                    51.9006319
                ],
                [
                    113.5263567,
                    51.900689
                ],
                [
                    113.5255743,
                    51.9008946
                ],
                [
                    113.5247912,
                    51.9010229
                ],
                [
                    113.5246207,
                    51.9007891
                ],
                [
                    113.5231683,
                    51.9010034
                ],
                [
                    113.5231431,
                    51.9011593
                ],
                [
                    113.5233641,
                    51.9016697
                ],
                [
                    113.5246271,
                    51.9014476
                ],
                [
                    113.5251007,
                    51.9021294
                ],
                [
                    113.5232757,
                    51.9025035
                ],
                [
                    113.5232065,
                    51.902309
                ],
                [
                    113.5209433,
                    51.9024287
                ],
                [
                    113.5207738,
                    51.9026967
                ]
            ],
            "longitude": 113.528452,
            "latitude": 51.901391
        },
        "8202": {
            "name": "Ручейки",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.5375113,
            "latitude": 52.2763735
        },
        "8203": {
            "name": "Новоказачинск",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.543633,
            "latitude": 50.4095238
        },
        "8204": {
            "name": "Авдей",
            "population": 245,
            "type": "hamlet",
            "poly": [
                [
                    113.6214138,
                    52.3680809
                ],
                [
                    113.6216637,
                    52.3700654
                ],
                [
                    113.6232454,
                    52.3700289
                ],
                [
                    113.6259974,
                    52.3730029
                ],
                [
                    113.6337521,
                    52.3763052
                ],
                [
                    113.6432523,
                    52.3707831
                ],
                [
                    113.6416892,
                    52.3689356
                ],
                [
                    113.6332282,
                    52.3646122
                ],
                [
                    113.6261702,
                    52.3665484
                ],
                [
                    113.6214138,
                    52.3680809
                ]
            ],
            "longitude": 113.636063,
            "latitude": 52.37207
        },
        "8205": {
            "name": "Каменка",
            "population": 142,
            "type": "hamlet",
            "poly": [
                [
                    113.6556084,
                    51.8743159
                ],
                [
                    113.6592562,
                    51.8742364
                ],
                [
                    113.6629469,
                    51.87368
                ],
                [
                    113.6652215,
                    51.8731236
                ],
                [
                    113.6662514,
                    51.8724611
                ],
                [
                    113.6658652,
                    51.8722757
                ],
                [
                    113.6631615,
                    51.8727791
                ],
                [
                    113.6585696,
                    51.8729117
                ],
                [
                    113.6556084,
                    51.8743159
                ]
            ],
            "longitude": 113.6613596,
            "latitude": 51.8734346
        },
        "8206": {
            "name": "Подволок",
            "population": 173,
            "type": "hamlet",
            "poly": [
                [
                    113.6719221,
                    52.423802
                ],
                [
                    113.6771578,
                    52.4291928
                ],
                [
                    113.6837667,
                    52.4294021
                ],
                [
                    113.691234,
                    52.4259479
                ],
                [
                    113.6825651,
                    52.4155837
                ],
                [
                    113.6728663,
                    52.4196669
                ],
                [
                    113.6719221,
                    52.423802
                ]
            ],
            "longitude": 113.68042,
            "latitude": 52.421185
        },
        "8207": {
            "name": "Кумахта",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.7370606,
            "latitude": 51.3591428
        },
        "8208": {
            "name": "Дом Инвалидов",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    114.0153952,
                    51.7983519
                ],
                [
                    114.0270682,
                    51.8154405
                ],
                [
                    114.0480108,
                    51.8151222
                ],
                [
                    114.0471525,
                    51.8097097
                ],
                [
                    114.032733,
                    51.8079054
                ],
                [
                    114.0229483,
                    51.7966533
                ],
                [
                    114.0153952,
                    51.7983519
                ]
            ],
            "longitude": 114.0232916,
            "latitude": 51.8018551
        },
        "8209": {
            "name": "Юмурчен",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.033638,
            "latitude": 53.613205
        },
        "8210": {
            "name": "Лесозавод",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.0610807,
            "latitude": 51.3947029
        },
        "8211": {
            "name": "Пунцук",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.2908043,
            "latitude": 51.0793983
        },
        "8212": {
            "name": "Зубковщина",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.3977222,
            "latitude": 51.500546
        },
        "8213": {
            "name": "Баян-Булак",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.4025856,
            "latitude": 50.6376865
        },
        "8214": {
            "name": "Булактуй",
            "population": 136,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.4394787,
            "latitude": 51.0698354
        },
        "8215": {
            "name": "Тарская",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.5009403,
            "latitude": 51.6325398
        },
        "8216": {
            "name": "Седловая",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.5392983,
            "latitude": 51.48087
        },
        "8217": {
            "name": "Хусатуй",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.6090069,
            "latitude": 51.0993807
        },
        "8218": {
            "name": "Перевал",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.6108667,
            "latitude": 51.4682294
        },
        "8219": {
            "name": "разъезд 67",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.655212,
            "latitude": 51.465279
        },
        "8220": {
            "name": "Красный Яр",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.6736517,
            "latitude": 53.9170857
        },
        "8221": {
            "name": "Усть-Нацигун",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.6905434,
            "latitude": 51.6777144
        },
        "8222": {
            "name": "Бурятская",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.701561,
            "latitude": 51.450928
        },
        "8223": {
            "name": "разъезд 69",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.848251,
            "latitude": 51.369385
        },
        "8224": {
            "name": "Дэлбэрхэй",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.8688902,
            "latitude": 50.9359123
        },
        "8225": {
            "name": "Занта",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.9688517,
            "latitude": 50.8612441
        },
        "8226": {
            "name": "Остречная",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.0518776,
            "latitude": 51.2090539
        },
        "8227": {
            "name": "Цугол",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.0753698,
            "latitude": 50.8183388
        },
        "8228": {
            "name": "Ульдурга",
            "population": 259,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.11871,
            "latitude": 52.53995
        },
        "8229": {
            "name": "Хулугли",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.1538889,
            "latitude": 54.003333
        },
        "8230": {
            "name": "71 разъезд",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.1965698,
            "latitude": 51.0941467
        },
        "8231": {
            "name": "Зубарево",
            "population": 218,
            "type": "hamlet",
            "poly": [
                [
                    115.2565732,
                    51.7888359
                ],
                [
                    115.2594607,
                    51.7889395
                ],
                [
                    115.2667421,
                    51.7867392
                ],
                [
                    115.2803842,
                    51.7876452
                ],
                [
                    115.2804679,
                    51.7855743
                ],
                [
                    115.2677046,
                    51.7837881
                ],
                [
                    115.2633943,
                    51.782183
                ],
                [
                    115.257745,
                    51.7860403
                ],
                [
                    115.2565732,
                    51.7888359
                ]
            ],
            "longitude": 115.2686495,
            "latitude": 51.7850042
        },
        "8232": {
            "name": "Курильжа",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.3034104,
            "latitude": 50.8303058
        },
        "8233": {
            "name": "Булак",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.3398759,
            "latitude": 51.0355458
        },
        "8234": {
            "name": "Бильчир",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.3456544,
            "latitude": 51.4474599
        },
        "8235": {
            "name": "Уненкер",
            "population": 212,
            "type": "hamlet",
            "poly": [
                [
                    115.3399887,
                    51.7740275
                ],
                [
                    115.3417641,
                    51.7782752
                ],
                [
                    115.3480372,
                    51.77725
                ],
                [
                    115.3547838,
                    51.778202
                ],
                [
                    115.3650813,
                    51.7781288
                ],
                [
                    115.3724197,
                    51.7755656
                ],
                [
                    115.3726564,
                    51.7727093
                ],
                [
                    115.3621222,
                    51.7713177
                ],
                [
                    115.3399887,
                    51.7740275
                ]
            ],
            "longitude": 115.3564409,
            "latitude": 51.7753459
        },
        "8236": {
            "name": "Светлый",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.415985,
            "latitude": 52.419918
        },
        "8237": {
            "name": "Кыэкен",
            "population": 102,
            "type": "hamlet",
            "poly": [
                [
                    115.4043516,
                    52.072099
                ],
                [
                    115.4165698,
                    52.0757634
                ],
                [
                    115.4283463,
                    52.0766682
                ],
                [
                    115.4308489,
                    52.0693391
                ],
                [
                    115.4389452,
                    52.0657647
                ],
                [
                    115.4460112,
                    52.0568046
                ],
                [
                    115.4378412,
                    52.0543606
                ],
                [
                    115.4193667,
                    52.0582528
                ],
                [
                    115.405382,
                    52.0661719
                ],
                [
                    115.4043516,
                    52.072099
                ]
            ],
            "longitude": 115.42228,
            "latitude": 52.0624725
        },
        "8238": {
            "name": "Торга",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.5899917,
            "latitude": 52.1849623
        },
        "8239": {
            "name": "Красноярово",
            "population": 248,
            "type": "hamlet",
            "poly": [
                [
                    115.5792261,
                    51.7690064
                ],
                [
                    115.5803056,
                    51.769443
                ],
                [
                    115.5839176,
                    51.7690577
                ],
                [
                    115.588111,
                    51.7706507
                ],
                [
                    115.5913909,
                    51.770702
                ],
                [
                    115.5915154,
                    51.7696744
                ],
                [
                    115.6012306,
                    51.7714471
                ],
                [
                    115.6035556,
                    51.7710617
                ],
                [
                    115.6036387,
                    51.7700597
                ],
                [
                    115.5955427,
                    51.7680557
                ],
                [
                    115.5894811,
                    51.7659745
                ],
                [
                    115.5893565,
                    51.764587
                ],
                [
                    115.5849556,
                    51.7635592
                ],
                [
                    115.584665,
                    51.7641502
                ],
                [
                    115.5807208,
                    51.7652808
                ],
                [
                    115.5797243,
                    51.7659231
                ],
                [
                    115.5792261,
                    51.7690064
                ]
            ],
            "longitude": 115.5909757,
            "latitude": 51.7682613
        },
        "8240": {
            "name": "Тополёвка",
            "population": 252,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.606339,
            "latitude": 50.90403
        },
        "8241": {
            "name": "Зунор",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.62795,
            "latitude": 51.11112
        },
        "8242": {
            "name": "Цагакшино",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.6733784,
            "latitude": 52.2259695
        },
        "8243": {
            "name": "Ерама",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.7311495,
            "latitude": 51.0963713
        },
        "8244": {
            "name": "Акима",
            "population": 251,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.7363052,
            "latitude": 53.0506978
        },
        "8245": {
            "name": "Халтуй",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.7589683,
            "latitude": 52.2694105
        },
        "8246": {
            "name": "Онон",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.8064833,
            "latitude": 51.7146003
        },
        "8247": {
            "name": "Кокуй-Комогорцево",
            "population": 162,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.8619,
            "latitude": 51.93424
        },
        "8248": {
            "name": "Кокаревка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.916667,
            "latitude": 55.583333
        },
        "8249": {
            "name": "Маяк",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.108656,
            "latitude": 50.7801981
        },
        "8250": {
            "name": "Волочаевка",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.29145,
            "latitude": 51.71563
        },
        "8251": {
            "name": "Апрелково",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.3586108,
            "latitude": 51.853005
        },
        "8252": {
            "name": "Зун-Торей",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.4643083,
            "latitude": 50.4355575
        },
        "8253": {
            "name": "Зелёное Озеро",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.579042,
            "latitude": 53.676004
        },
        "8254": {
            "name": "Шахалинор",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.7328776,
            "latitude": 49.9070852
        },
        "8255": {
            "name": "Калакан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.765175,
            "latitude": 55.124744
        },
        "8256": {
            "name": "Борщовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.8317325,
            "latitude": 51.9691635
        },
        "8257": {
            "name": "Налгекан",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.8513434,
            "latitude": 52.7654084
        },
        "8258": {
            "name": "Семиозёрье",
            "population": 78,
            "type": "hamlet",
            "poly": [
                [
                    116.8869616,
                    50.0419345
                ],
                [
                    116.8882023,
                    50.0426898
                ],
                [
                    116.8896149,
                    50.0435497
                ],
                [
                    116.8950721,
                    50.0405097
                ],
                [
                    116.8979894,
                    50.0388813
                ],
                [
                    116.8963035,
                    50.0376032
                ],
                [
                    116.8935396,
                    50.0388813
                ],
                [
                    116.891826,
                    50.0376565
                ],
                [
                    116.8911323,
                    50.0380287
                ],
                [
                    116.8895561,
                    50.0391958
                ],
                [
                    116.8905184,
                    50.0397411
                ],
                [
                    116.8869616,
                    50.0419345
                ]
            ],
            "longitude": 116.8919426,
            "latitude": 50.0403168
        },
        "8259": {
            "name": "Рудник Жетково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.9159654,
            "latitude": 51.3088469
        },
        "8260": {
            "name": "Шеметово",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.9495273,
            "latitude": 51.9988271
        },
        "8261": {
            "name": "Олдонда",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.9517646,
            "latitude": 50.8867426
        },
        "8262": {
            "name": "Шапка",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.0338714,
            "latitude": 52.1630328
        },
        "8263": {
            "name": "Алеур",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.1093753,
            "latitude": 52.5631267
        },
        "8264": {
            "name": "Перевальное",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.216667,
            "latitude": 56.583333
        },
        "8265": {
            "name": "Мациевская",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.2758413,
            "latitude": 49.7255399
        },
        "8266": {
            "name": "Ковекта",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.2978875,
            "latitude": 52.9156638
        },
        "8267": {
            "name": "Кодар",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.305278,
            "latitude": 56.595556
        },
        "8268": {
            "name": "Красный Бульчут",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.3666669,
            "latitude": 56.516667
        },
        "8269": {
            "name": "Арчикой",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.4007063,
            "latitude": 53.0358366
        },
        "8270": {
            "name": "Рыбатское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.5,
            "latitude": 57.733333
        },
        "8271": {
            "name": "Озёрная",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.5686157,
            "latitude": 52.8161552
        },
        "8272": {
            "name": "Арамогойтуй",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.609512,
            "latitude": 50.381798
        },
        "8273": {
            "name": "Ничатка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.666667,
            "latitude": 57.833333
        },
        "8274": {
            "name": "Сырыгичи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.6673739,
            "latitude": 53.845264
        },
        "8275": {
            "name": "Сивачи",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.6863053,
            "latitude": 51.4688195
        },
        "8276": {
            "name": "Рыбатское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.6999999,
            "latitude": 57.85
        },
        "8277": {
            "name": "Зудыра",
            "population": 43,
            "type": "hamlet",
            "poly": [
                [
                    117.7911169,
                    53.1053869
                ],
                [
                    117.7952895,
                    53.1065267
                ],
                [
                    117.8019657,
                    53.1088187
                ],
                [
                    117.8050534,
                    53.1090441
                ],
                [
                    117.8055541,
                    53.1073784
                ],
                [
                    117.8032383,
                    53.1063639
                ],
                [
                    117.7993369,
                    53.1046855
                ],
                [
                    117.7965621,
                    53.1037586
                ],
                [
                    117.7926816,
                    53.1031324
                ],
                [
                    117.7911169,
                    53.1053869
                ]
            ],
            "longitude": 117.7950934,
            "latitude": 53.1047663
        },
        "8278": {
            "name": "Имандан-Макит",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.8,
            "latitude": 54.1
        },
        "8279": {
            "name": "Антипенко",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.05,
            "latitude": 54.283333
        },
        "8280": {
            "name": "Пури",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.0628856,
            "latitude": 50.7867969
        },
        "8281": {
            "name": "Березовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.1057685,
            "latitude": 50.7244509
        },
        "8282": {
            "name": "Яблоновый",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.2507,
            "latitude": 55.1579
        },
        "8283": {
            "name": "Нанагры",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.2956917,
            "latitude": 53.2389053
        },
        "8284": {
            "name": "Гырынкина Ильи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.3,
            "latitude": 57.916667
        },
        "8285": {
            "name": "Удокан",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.308495,
            "latitude": 56.751884
        },
        "8286": {
            "name": "Павлова",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.4666669,
            "latitude": 57.766667
        },
        "8287": {
            "name": "Тёмная",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.5191987,
            "latitude": 53.3956816
        },
        "8288": {
            "name": "Кендагиры",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.5401862,
            "latitude": 53.45526
        },
        "8289": {
            "name": "Дом Отдыха Чалбучи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.646611,
            "latitude": 52.4597779
        },
        "8290": {
            "name": "Чина",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.6759584,
            "latitude": 56.487024
        },
        "8291": {
            "name": "Горький",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 118.6811063,
            "latitude": 53.5411507
        },
        "8292": {
            "name": "Норинск",
            "population": 230,
            "type": "hamlet",
            "poly": [
                [
                    119.0169656,
                    50.6688888
                ],
                [
                    119.0193848,
                    50.6704221
                ],
                [
                    119.0327711,
                    50.6704221
                ],
                [
                    119.0374482,
                    50.6721597
                ],
                [
                    119.0408351,
                    50.6687354
                ],
                [
                    119.0530117,
                    50.661324
                ],
                [
                    119.0513989,
                    50.658768
                ],
                [
                    119.0367224,
                    50.6635731
                ],
                [
                    119.0238815,
                    50.659627
                ],
                [
                    119.0169656,
                    50.6688888
                ]
            ],
            "longitude": 119.0346258,
            "latitude": 50.6661799
        },
        "8293": {
            "name": "Верея",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.1178978,
            "latitude": 50.5900814
        },
        "8294": {
            "name": "Кислый Ключ",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.1297061,
            "latitude": 53.7063543
        },
        "8295": {
            "name": "Смирновский",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    119.2012768,
                    51.149992
                ],
                [
                    119.2091055,
                    51.1527291
                ],
                [
                    119.2192015,
                    51.1496163
                ],
                [
                    119.2206133,
                    51.1438195
                ],
                [
                    119.2145813,
                    51.1434974
                ],
                [
                    119.2023463,
                    51.1474962
                ],
                [
                    119.2012768,
                    51.149992
                ]
            ],
            "longitude": 119.2081403,
            "latitude": 51.1470105
        },
        "8296": {
            "name": "Запокровский рудник",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.2735618,
            "latitude": 50.7742116
        },
        "8297": {
            "name": "Артеушка",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.2874555,
            "latitude": 53.7787779
        },
        "8298": {
            "name": "Бугутуй",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    119.2870027,
                    50.9604686
                ],
                [
                    119.2934507,
                    50.9618744
                ],
                [
                    119.2985878,
                    50.9599777
                ],
                [
                    119.2935924,
                    50.9559385
                ],
                [
                    119.2875696,
                    50.9573443
                ],
                [
                    119.2870027,
                    50.9604686
                ]
            ],
            "longitude": 119.291805,
            "latitude": 50.9598449
        },
        "8299": {
            "name": "Михайловский Участок",
            "population": 35,
            "type": "hamlet",
            "poly": [
                [
                    119.3584263,
                    51.0928329
                ],
                [
                    119.361314,
                    51.097904
                ],
                [
                    119.3712603,
                    51.0976689
                ],
                [
                    119.3713138,
                    51.0931015
                ],
                [
                    119.3687877,
                    51.0918353
                ],
                [
                    119.3657524,
                    51.0903139
                ],
                [
                    119.3584263,
                    51.0928329
                ]
            ],
            "longitude": 119.3659663,
            "latitude": 51.0939076
        },
        "8300": {
            "name": "Воробьевка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    119.3754033,
                    50.94824
                ],
                [
                    119.3787131,
                    50.9604589
                ],
                [
                    119.3865642,
                    50.9633677
                ],
                [
                    119.3934147,
                    50.9608468
                ],
                [
                    119.3949542,
                    50.9587621
                ],
                [
                    119.406577,
                    50.9526528
                ],
                [
                    119.3902589,
                    50.9448938
                ],
                [
                    119.3865642,
                    50.9469792
                ],
                [
                    119.379021,
                    50.9447968
                ],
                [
                    119.3754033,
                    50.94824
                ]
            ],
            "longitude": 119.3896431,
            "latitude": 50.9536226
        },
        "8301": {
            "name": "Пеньковая",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.4071728,
            "latitude": 53.8135532
        },
        "8302": {
            "name": "Мотогорск",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    119.5069914,
                    51.727856
                ],
                [
                    119.509897,
                    51.7284014
                ],
                [
                    119.5121569,
                    51.7279651
                ],
                [
                    119.5132722,
                    51.7271834
                ],
                [
                    119.5125238,
                    51.7261563
                ],
                [
                    119.5117607,
                    51.72592
                ],
                [
                    119.5114325,
                    51.7259802
                ],
                [
                    119.5091339,
                    51.7264016
                ],
                [
                    119.5069914,
                    51.727856
                ]
            ],
            "longitude": 119.5109389,
            "latitude": 51.7268835
        },
        "8303": {
            "name": "Павловка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    119.5085269,
                    51.3628981
                ],
                [
                    119.516504,
                    51.3675728
                ],
                [
                    119.5212622,
                    51.3654321
                ],
                [
                    119.5237813,
                    51.3618495
                ],
                [
                    119.5205625,
                    51.3591842
                ],
                [
                    119.5170591,
                    51.3585386
                ],
                [
                    119.516294,
                    51.3583977
                ],
                [
                    119.5109861,
                    51.3614732
                ],
                [
                    119.5085269,
                    51.3628981
                ]
            ],
            "longitude": 119.5156643,
            "latitude": 51.3620243
        },
        "8304": {
            "name": "Благодатск",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    119.5472018,
                    51.2321176
                ],
                [
                    119.5522328,
                    51.2349527
                ],
                [
                    119.5566445,
                    51.2328446
                ],
                [
                    119.5523102,
                    51.2295005
                ],
                [
                    119.5472018,
                    51.2321176
                ]
            ],
            "longitude": 119.5516136,
            "latitude": 51.232263
        },
        "8305": {
            "name": "Воздвиженка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.5541268,
            "latitude": 51.2879173
        },
        "8306": {
            "name": "Хайкан",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.597198,
            "latitude": 52.0610743
        },
        "8307": {
            "name": "Никольское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.6571658,
            "latitude": 51.3567466
        },
        "8308": {
            "name": "Раздольное",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.6635061,
            "latitude": 53.8057294
        },
        "8309": {
            "name": "Флоровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.783333,
            "latitude": 55.1
        },
        "8310": {
            "name": "Будюмкан",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.842236,
            "latitude": 52.6379106
        },
        "8311": {
            "name": "Аргунские-Ключи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 119.9314917,
            "latitude": 51.3988028
        },
        "8312": {
            "name": "Урюпино",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 120.0171398,
            "latitude": 52.7611157
        },
        "8313": {
            "name": "Записина",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    120.2576519,
                    51.7478223
                ],
                [
                    120.2582835,
                    51.7487295
                ],
                [
                    120.259934,
                    51.7482707
                ],
                [
                    120.2591087,
                    51.7473636
                ],
                [
                    120.2576519,
                    51.7478223
                ]
            ],
            "longitude": 120.2586796,
            "latitude": 51.7480892
        },
        "8314": {
            "name": "Верхняя Верея",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    120.3115371,
                    51.7877886
                ],
                [
                    120.3143412,
                    51.7882366
                ],
                [
                    120.3155454,
                    51.7864551
                ],
                [
                    120.3117308,
                    51.7860801
                ],
                [
                    120.3115371,
                    51.7877886
                ]
            ],
            "longitude": 120.3127735,
            "latitude": 51.7872586
        },
        "8315": {
            "name": "Ниж. Верея",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    120.5597405,
                    51.9303452
                ],
                [
                    120.5648555,
                    51.9323816
                ],
                [
                    120.5673929,
                    51.9307425
                ],
                [
                    120.5666276,
                    51.9282838
                ],
                [
                    120.5611904,
                    51.9279858
                ],
                [
                    120.5597405,
                    51.9303452
                ]
            ],
            "longitude": 120.5634504,
            "latitude": 51.9299485
        },
        "8316": {
            "name": "Тетёркин Ключ",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 120.6162699,
            "latitude": 53.742597
        },
        "8317": {
            "name": "Германовский",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 120.7827934,
            "latitude": 53.846946
        },
        "8318": {
            "name": "Красавка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 120.9898559,
            "latitude": 53.8910909
        },
        "8319": {
            "name": "Колокольный",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 121.138444,
            "latitude": 53.9411015
        },
        "8320": {
            "name": "Потайка",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    121.2356292,
                    53.9747746
                ],
                [
                    121.2382079,
                    53.9771279
                ],
                [
                    121.2401196,
                    53.9767226
                ],
                [
                    121.2396083,
                    53.9746962
                ],
                [
                    121.2373631,
                    53.973794
                ],
                [
                    121.2356292,
                    53.9747746
                ]
            ],
            "longitude": 121.2377914,
            "latitude": 53.9762591
        },
        "8321": {
            "name": "Чичатка",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 121.2991626,
            "latitude": 54.0401328
        },
        "8322": {
            "name": "Усть-Стрелка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 121.3864139,
            "latitude": 53.322161
        },
        "8323": {
            "name": "Жанна",
            "population": 111,
            "type": "hamlet",
            "poly": [
                [
                    121.3956674,
                    54.0550949
                ],
                [
                    121.4106222,
                    54.055365
                ],
                [
                    121.4146101,
                    54.0534291
                ],
                [
                    121.4128462,
                    54.0507279
                ],
                [
                    121.4031831,
                    54.0505027
                ],
                [
                    121.397738,
                    54.0515383
                ],
                [
                    121.3956674,
                    54.0550949
                ]
            ],
            "longitude": 121.40567,
            "latitude": 54.053177
        },
        "8324": {
            "name": "Покровка",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 121.5360538,
            "latitude": 53.3434383
        },
        "8325": {
            "name": "Малоковали",
            "population": 24,
            "type": "hamlet",
            "poly": [
                [
                    121.539448,
                    54.1089806
                ],
                [
                    121.5447416,
                    54.1100108
                ],
                [
                    121.5492392,
                    54.1100221
                ],
                [
                    121.5499687,
                    54.1094523
                ],
                [
                    121.5504558,
                    54.107939
                ],
                [
                    121.5461922,
                    54.1074987
                ],
                [
                    121.5400231,
                    54.107003
                ],
                [
                    121.539448,
                    54.1089806
                ]
            ],
            "longitude": 121.5466646,
            "latitude": 54.1092745
        },
        "8326": {
            "name": "Утени",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 121.637722,
            "latitude": 54.0615072
        },
        "8327": {
            "name": "Кайнаул",
            "population": 192,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.4346899,
            "latitude": 57.9208478
        },
        "8328": {
            "name": "Бакшеево",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.4958757,
            "latitude": 57.9141276
        },
        "8329": {
            "name": "Ветлинка",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.5165503,
            "latitude": 55.3616059
        },
        "8330": {
            "name": "Носовка",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.5495837,
            "latitude": 55.3172992
        },
        "8331": {
            "name": "Бузан",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.5764567,
            "latitude": 55.6924049
        },
        "8332": {
            "name": "Тупицыно",
            "population": 103,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.5879749,
            "latitude": 55.4486173
        },
        "8333": {
            "name": "Голубки",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.670486,
            "latitude": 55.299606
        },
        "8334": {
            "name": "Стрункино",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.6775118,
            "latitude": 55.8525384
        },
        "8335": {
            "name": "Красноярка",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.6846845,
            "latitude": 57.2423915
        },
        "8336": {
            "name": "Саургачи",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.696992,
            "latitude": 57.7666759
        },
        "8337": {
            "name": "Мариинка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.6975654,
            "latitude": 55.6807673
        },
        "8338": {
            "name": "Калмацкое",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.7340157,
            "latitude": 55.4691941
        },
        "8339": {
            "name": "Угут",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.7354746,
            "latitude": 57.3529437
        },
        "8340": {
            "name": "Березянка",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.7476777,
            "latitude": 57.793222
        },
        "8341": {
            "name": "Елизаветинка",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.7741688,
            "latitude": 55.611295
        },
        "8342": {
            "name": "Колпаково",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.7796866,
            "latitude": 57.3832831
        },
        "8343": {
            "name": "Котино",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.8083264,
            "latitude": 55.7645135
        },
        "8344": {
            "name": "Хутор",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.8188213,
            "latitude": 57.7164588
        },
        "8345": {
            "name": "Осиново",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.8329238,
            "latitude": 55.4629999
        },
        "8346": {
            "name": "Борки",
            "population": 230,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.8562747,
            "latitude": 57.7931708
        },
        "8347": {
            "name": "Кабаново",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.8735445,
            "latitude": 55.3354152
        },
        "8348": {
            "name": "Малая Игиза",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.8747362,
            "latitude": 57.4460747
        },
        "8349": {
            "name": "Соколовка",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9024006,
            "latitude": 55.4722584
        },
        "8350": {
            "name": "Еланка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9072815,
            "latitude": 57.812422
        },
        "8351": {
            "name": "№ 45",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9090951,
            "latitude": 55.7227218
        },
        "8352": {
            "name": "Затон",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9118299,
            "latitude": 57.7516234
        },
        "8353": {
            "name": "Кушма",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9135114,
            "latitude": 57.490399
        },
        "8354": {
            "name": "Колодцы",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9364807,
            "latitude": 56.0060625
        },
        "8355": {
            "name": "Караульное",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9387965,
            "latitude": 55.8322063
        },
        "8356": {
            "name": "Гуляй-Поле",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9389274,
            "latitude": 56.2694167
        },
        "8357": {
            "name": "Емонтаево",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9535582,
            "latitude": 55.1455351
        },
        "8358": {
            "name": "Рыбье",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 70.9819558,
            "latitude": 55.4487867
        },
        "8359": {
            "name": "Бостандык",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0103825,
            "latitude": 55.6707973
        },
        "8360": {
            "name": "Юнино",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0127637,
            "latitude": 54.9053712
        },
        "8361": {
            "name": "Лебяжье",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0156584,
            "latitude": 55.2335685
        },
        "8362": {
            "name": "Стахановка",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.029715,
            "latitude": 56.2889288
        },
        "8363": {
            "name": "Редкое",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0468626,
            "latitude": 55.7654359
        },
        "8364": {
            "name": "Ольгино",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.046867,
            "latitude": 56.241136
        },
        "8365": {
            "name": "№ 46",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0572712,
            "latitude": 55.6695004
        },
        "8366": {
            "name": "Батареевка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0614301,
            "latitude": 55.5246053
        },
        "8367": {
            "name": "Станкевичи",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0706566,
            "latitude": 55.7877079
        },
        "8368": {
            "name": "Атеринки",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0755397,
            "latitude": 57.5221788
        },
        "8369": {
            "name": "Екатериновка",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0828927,
            "latitude": 57.781734
        },
        "8370": {
            "name": "Красный Яр",
            "population": 136,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0918343,
            "latitude": 56.3861652
        },
        "8371": {
            "name": "Сырьевка",
            "population": 89,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.0989182,
            "latitude": 55.541262
        },
        "8372": {
            "name": "Светиловка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.117203,
            "latitude": 54.289738
        },
        "8373": {
            "name": "Козулино",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.1343256,
            "latitude": 56.3123235
        },
        "8374": {
            "name": "Байымбет",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.1412254,
            "latitude": 55.6221145
        },
        "8375": {
            "name": "Малая Ашеванка",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.1445215,
            "latitude": 57.6407595
        },
        "8376": {
            "name": "Ястреб",
            "population": 95,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.1494101,
            "latitude": 55.8900483
        },
        "8377": {
            "name": "Моховое",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.1682985,
            "latitude": 55.112319
        },
        "8378": {
            "name": "Сосновка",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.1698522,
            "latitude": 55.1191359
        },
        "8379": {
            "name": "Верхний Яман",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.1841881,
            "latitude": 56.0081739
        },
        "8380": {
            "name": "Дурбет",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.1967805,
            "latitude": 55.3287034
        },
        "8381": {
            "name": "Память Свободы",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2072558,
            "latitude": 54.961314
        },
        "8382": {
            "name": "Новолосево",
            "population": 244,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2077512,
            "latitude": 55.1423806
        },
        "8383": {
            "name": "Граковка",
            "population": 70,
            "type": "hamlet",
            "poly": [
                [
                    71.2122883,
                    57.576061
                ],
                [
                    71.2132916,
                    57.5776448
                ],
                [
                    71.2161341,
                    57.5784815
                ],
                [
                    71.2207044,
                    57.5783919
                ],
                [
                    71.2247174,
                    57.5760012
                ],
                [
                    71.2238256,
                    57.5723551
                ],
                [
                    71.2198684,
                    57.5708309
                ],
                [
                    71.2160689,
                    57.570891
                ],
                [
                    71.2129571,
                    57.5725942
                ],
                [
                    71.2122883,
                    57.576061
                ]
            ],
            "longitude": 71.2181232,
            "latitude": 57.574313
        },
        "8384": {
            "name": "Ширяево",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2183922,
            "latitude": 56.1830533
        },
        "8385": {
            "name": "Культжугут",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2190696,
            "latitude": 55.2331015
        },
        "8386": {
            "name": "Михайловка",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2252255,
            "latitude": 55.5849402
        },
        "8387": {
            "name": "Ереминская База",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2293049,
            "latitude": 55.635012
        },
        "8388": {
            "name": "Орловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2354568,
            "latitude": 54.5861782
        },
        "8389": {
            "name": "Летние",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2388558,
            "latitude": 57.6798929
        },
        "8390": {
            "name": "Троицк",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2392914,
            "latitude": 56.4575611
        },
        "8391": {
            "name": "Бородинка",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2393465,
            "latitude": 54.3120774
        },
        "8392": {
            "name": "Новопокровка",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2427246,
            "latitude": 56.0138358
        },
        "8393": {
            "name": "Мечебилово",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2437867,
            "latitude": 54.440215
        },
        "8394": {
            "name": "Ольвиополь",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2540194,
            "latitude": 54.5152234
        },
        "8395": {
            "name": "Красноярка",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2578453,
            "latitude": 57.7312034
        },
        "8396": {
            "name": "Гагаринка",
            "population": 173,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2620302,
            "latitude": 55.5257787
        },
        "8397": {
            "name": "Фреганка",
            "population": 14,
            "type": "hamlet",
            "poly": [
                [
                    71.2663524,
                    57.6597107
                ],
                [
                    71.2667672,
                    57.6607726
                ],
                [
                    71.2685048,
                    57.6616544
                ],
                [
                    71.2709972,
                    57.6621152
                ],
                [
                    71.2720688,
                    57.661682
                ],
                [
                    71.2729344,
                    57.6603271
                ],
                [
                    71.2730004,
                    57.658839
                ],
                [
                    71.2727331,
                    57.6582846
                ],
                [
                    71.2720749,
                    57.6580293
                ],
                [
                    71.2694304,
                    57.6577463
                ],
                [
                    71.2668188,
                    57.6588074
                ],
                [
                    71.2663524,
                    57.6597107
                ]
            ],
            "longitude": 71.2715969,
            "latitude": 57.6587571
        },
        "8398": {
            "name": "Староназываевка",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2830392,
            "latitude": 55.4737944
        },
        "8399": {
            "name": "Камчатка",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2882389,
            "latitude": 56.3686457
        },
        "8400": {
            "name": "Кордон № 1",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.2888371,
            "latitude": 55.1029418
        },
        "8401": {
            "name": "№ 12",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.296792,
            "latitude": 55.0567701
        },
        "8402": {
            "name": "Нахимовка",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3008241,
            "latitude": 55.3222503
        },
        "8403": {
            "name": "Большая Сафониха",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.301033,
            "latitude": 55.767647
        },
        "8404": {
            "name": "Омар",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3028438,
            "latitude": 54.8125244
        },
        "8405": {
            "name": "Майка",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3082646,
            "latitude": 55.9122716
        },
        "8406": {
            "name": "Богословка",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3191237,
            "latitude": 55.6507567
        },
        "8407": {
            "name": "Ночка",
            "population": 262,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3213699,
            "latitude": 54.7128224
        },
        "8408": {
            "name": "Нововоскресенка",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.328172,
            "latitude": 55.4845811
        },
        "8409": {
            "name": "Новоосиново",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3380458,
            "latitude": 55.8470439
        },
        "8410": {
            "name": "Бежевка",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3452267,
            "latitude": 54.2342638
        },
        "8411": {
            "name": "Лукерьино",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3771723,
            "latitude": 55.2188068
        },
        "8412": {
            "name": "Длинное",
            "population": 252,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3785019,
            "latitude": 54.215491
        },
        "8413": {
            "name": "Эбаргуль",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3850394,
            "latitude": 57.6880845
        },
        "8414": {
            "name": "Лебедки",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3866363,
            "latitude": 55.5229289
        },
        "8415": {
            "name": "Малая Тава",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    71.3783233,
                    57.4994959
                ],
                [
                    71.3836608,
                    57.5023063
                ],
                [
                    71.391934,
                    57.5015607
                ],
                [
                    71.3959372,
                    57.4987502
                ],
                [
                    71.3958304,
                    57.4947349
                ],
                [
                    71.3883045,
                    57.4930712
                ],
                [
                    71.3807252,
                    57.4959108
                ],
                [
                    71.3783233,
                    57.4994959
                ]
            ],
            "longitude": 71.3878068,
            "latitude": 57.4980717
        },
        "8416": {
            "name": "Южный",
            "population": 201,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.3879574,
            "latitude": 54.8826259
        },
        "8417": {
            "name": "Смелое",
            "population": 131,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.412028,
            "latitude": 54.4962658
        },
        "8418": {
            "name": "Новотроицк",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4244807,
            "latitude": 54.1965352
        },
        "8419": {
            "name": "Озеро Камысловское",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4309388,
            "latitude": 54.9212102
        },
        "8420": {
            "name": "Самаровка",
            "population": 103,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.448889,
            "latitude": 55.8242256
        },
        "8421": {
            "name": "Демьяновка",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4618885,
            "latitude": 55.5556215
        },
        "8422": {
            "name": "Улендыкуль",
            "population": 211,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4646529,
            "latitude": 54.7966651
        },
        "8423": {
            "name": "Евсюки",
            "population": 247,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4690551,
            "latitude": 55.168937
        },
        "8424": {
            "name": "Новопетроград",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4731535,
            "latitude": 54.7565029
        },
        "8425": {
            "name": "Ик",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4793087,
            "latitude": 56.0438052
        },
        "8426": {
            "name": "Малая Сафониха",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4898194,
            "latitude": 55.7157626
        },
        "8427": {
            "name": "Кабанье",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4926747,
            "latitude": 56.1463851
        },
        "8428": {
            "name": "Крым",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.4948438,
            "latitude": 54.2286511
        },
        "8429": {
            "name": "Красный Пахарь",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5027811,
            "latitude": 56.0921056
        },
        "8430": {
            "name": "№ 48",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5296178,
            "latitude": 55.5063617
        },
        "8431": {
            "name": "Северный",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5311345,
            "latitude": 55.0311031
        },
        "8432": {
            "name": "2779 км",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5342527,
            "latitude": 54.9228629
        },
        "8433": {
            "name": "Шаровка",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5392942,
            "latitude": 54.5762693
        },
        "8434": {
            "name": "Щегловка",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5492094,
            "latitude": 54.2854839
        },
        "8435": {
            "name": "Сулу-Терек",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5548279,
            "latitude": 55.6543643
        },
        "8436": {
            "name": "Козловка",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5553984,
            "latitude": 55.7364641
        },
        "8437": {
            "name": "Каран-Гарал",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5607398,
            "latitude": 55.7630869
        },
        "8438": {
            "name": "Кирей",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5619348,
            "latitude": 55.665757
        },
        "8439": {
            "name": "Новотимофеевка",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5664477,
            "latitude": 54.3454741
        },
        "8440": {
            "name": "Хмаровка",
            "population": 228,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.568454,
            "latitude": 54.5427411
        },
        "8441": {
            "name": "Увальное",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5802419,
            "latitude": 54.4423902
        },
        "8442": {
            "name": "Белотурковка",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5834567,
            "latitude": 54.515985
        },
        "8443": {
            "name": "Горькое",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5846095,
            "latitude": 56.2741304
        },
        "8444": {
            "name": "Ивановка",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.585464,
            "latitude": 54.907059
        },
        "8445": {
            "name": "Чикишево",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5885871,
            "latitude": 55.9057001
        },
        "8446": {
            "name": "Красновознесенка",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5957981,
            "latitude": 54.7840831
        },
        "8447": {
            "name": "Челдак",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.5963353,
            "latitude": 56.3322647
        },
        "8448": {
            "name": "Кухарево",
            "population": 162,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6107746,
            "latitude": 54.9282068
        },
        "8449": {
            "name": "Новгородцево",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6187572,
            "latitude": 55.9390581
        },
        "8450": {
            "name": "Андрюшевка",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6197931,
            "latitude": 54.2223088
        },
        "8451": {
            "name": "Николаевка",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.62323,
            "latitude": 55.028698
        },
        "8452": {
            "name": "Васютино",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6236043,
            "latitude": 54.820744
        },
        "8453": {
            "name": "Ураш",
            "population": 191,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6255597,
            "latitude": 57.6067328
        },
        "8454": {
            "name": "Калачики",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6355917,
            "latitude": 56.0516022
        },
        "8455": {
            "name": "Спасск",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6357371,
            "latitude": 55.3982762
        },
        "8456": {
            "name": "Чумановка",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6405904,
            "latitude": 55.9610747
        },
        "8457": {
            "name": "Ксеньевка",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.643913,
            "latitude": 54.716583
        },
        "8458": {
            "name": "Кочковатка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.649368,
            "latitude": 55.507423
        },
        "8459": {
            "name": "Сингуль",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6580086,
            "latitude": 56.2462351
        },
        "8460": {
            "name": "Усть-Китерма",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6732146,
            "latitude": 56.0805977
        },
        "8461": {
            "name": "Новоалександровка",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.679504,
            "latitude": 54.85873
        },
        "8462": {
            "name": "Гаркушино",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6801284,
            "latitude": 54.9046593
        },
        "8463": {
            "name": "Ясная Поляна",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.6884367,
            "latitude": 54.7941784
        },
        "8464": {
            "name": "Константиновка",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7152632,
            "latitude": 55.2266182
        },
        "8465": {
            "name": "Черняевка",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7153763,
            "latitude": 55.6738743
        },
        "8466": {
            "name": "Пушкино",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7225735,
            "latitude": 55.8172055
        },
        "8467": {
            "name": "имени Максима Горького",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7287331,
            "latitude": 56.1957619
        },
        "8468": {
            "name": "Платово",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7288943,
            "latitude": 54.4876924
        },
        "8469": {
            "name": "Чистополье",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7319054,
            "latitude": 54.9103403
        },
        "8470": {
            "name": "Тумба",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.733292,
            "latitude": 54.734543
        },
        "8471": {
            "name": "Вятка",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.739059,
            "latitude": 57.697456
        },
        "8472": {
            "name": "Никополь",
            "population": 190,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.745442,
            "latitude": 54.1517778
        },
        "8473": {
            "name": "Пролетарский",
            "population": 228,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7612459,
            "latitude": 55.022817
        },
        "8474": {
            "name": "Майский",
            "population": 252,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7706947,
            "latitude": 55.1154963
        },
        "8475": {
            "name": "Салтаим",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.788078,
            "latitude": 56.049709
        },
        "8476": {
            "name": "Грязновка",
            "population": 204,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.792694,
            "latitude": 54.888664
        },
        "8477": {
            "name": "Березово",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.7963925,
            "latitude": 56.11283
        },
        "8478": {
            "name": "2595 км",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8019584,
            "latitude": 55.4224179
        },
        "8479": {
            "name": "Черноморка",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8094639,
            "latitude": 54.3803906
        },
        "8480": {
            "name": "Малахово",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8172011,
            "latitude": 54.3629988
        },
        "8481": {
            "name": "Коломенка",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8277724,
            "latitude": 56.303866
        },
        "8482": {
            "name": "Милютино",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.835756,
            "latitude": 55.5074645
        },
        "8483": {
            "name": "2798 км",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.83591,
            "latitude": 54.9332324
        },
        "8484": {
            "name": "Бельдеж № 7",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8361966,
            "latitude": 54.4197929
        },
        "8485": {
            "name": "Колмаково",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8380505,
            "latitude": 55.9180828
        },
        "8486": {
            "name": "Драгунка",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8402573,
            "latitude": 55.3162535
        },
        "8487": {
            "name": "Кзыл Агаш",
            "population": 237,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8433378,
            "latitude": 54.7121342
        },
        "8488": {
            "name": "Шахово",
            "population": 245,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8486654,
            "latitude": 54.4574554
        },
        "8489": {
            "name": "Инсарка",
            "population": 225,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8549652,
            "latitude": 54.8098734
        },
        "8490": {
            "name": "Мысы",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8613754,
            "latitude": 56.1916877
        },
        "8491": {
            "name": "Калугино",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8669528,
            "latitude": 56.0548311
        },
        "8492": {
            "name": "Кипо-Кулары",
            "population": 190,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8678587,
            "latitude": 57.533488
        },
        "8493": {
            "name": "Надеждовка",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8705813,
            "latitude": 54.9081657
        },
        "8494": {
            "name": "Поддол",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8707142,
            "latitude": 57.4930057
        },
        "8495": {
            "name": "Заозерная",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8762548,
            "latitude": 56.3922192
        },
        "8496": {
            "name": "Азы",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8801425,
            "latitude": 57.4883234
        },
        "8497": {
            "name": "Ошировский",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.8884821,
            "latitude": 55.3938491
        },
        "8498": {
            "name": "Ростовка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.889716,
            "latitude": 55.3836674
        },
        "8499": {
            "name": "Чебачиха",
            "population": 16,
            "type": "hamlet",
            "poly": [
                [
                    71.8913131,
                    57.197583
                ],
                [
                    71.8950623,
                    57.1985199
                ],
                [
                    71.8967034,
                    57.198814
                ],
                [
                    71.8970443,
                    57.1986567
                ],
                [
                    71.8972336,
                    57.1977745
                ],
                [
                    71.8982309,
                    57.1975898
                ],
                [
                    71.8989757,
                    57.1976309
                ],
                [
                    71.9019423,
                    57.1974257
                ],
                [
                    71.9026366,
                    57.1971658
                ],
                [
                    71.9079259,
                    57.1914412
                ],
                [
                    71.9068151,
                    57.1907777
                ],
                [
                    71.9060829,
                    57.1909829
                ],
                [
                    71.9054012,
                    57.1910171
                ],
                [
                    71.904871,
                    57.1907982
                ],
                [
                    71.9041767,
                    57.1904083
                ],
                [
                    71.903495,
                    57.1898953
                ],
                [
                    71.9022326,
                    57.1893344
                ],
                [
                    71.900541,
                    57.1888282
                ],
                [
                    71.89967,
                    57.1889992
                ],
                [
                    71.8913131,
                    57.197583
                ]
            ],
            "longitude": 71.8987119,
            "latitude": 57.1931406
        },
        "8500": {
            "name": "Фёдоровка",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9101364,
            "latitude": 54.8941334
        },
        "8501": {
            "name": "Гольбштадт",
            "population": 246,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.913055,
            "latitude": 54.922203
        },
        "8502": {
            "name": "Виноградовка",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9183483,
            "latitude": 55.0837695
        },
        "8503": {
            "name": "Красный Цвет",
            "population": 162,
            "type": "hamlet",
            "poly": [
                [
                    71.9106229,
                    55.06124
                ],
                [
                    71.9197618,
                    55.0602852
                ],
                [
                    71.927508,
                    55.0611393
                ],
                [
                    71.9275423,
                    55.0581087
                ],
                [
                    71.922768,
                    55.0566192
                ],
                [
                    71.9218668,
                    55.0519732
                ],
                [
                    71.9194206,
                    55.0519732
                ],
                [
                    71.9188198,
                    55.0566929
                ],
                [
                    71.9130262,
                    55.0555622
                ],
                [
                    71.9106229,
                    55.06124
                ]
            ],
            "longitude": 71.9213952,
            "latitude": 55.0574976
        },
        "8504": {
            "name": "Старичье",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9220621,
            "latitude": 56.2950023
        },
        "8505": {
            "name": "Лидинка",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9227543,
            "latitude": 55.661144
        },
        "8506": {
            "name": "Бродниково",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9253394,
            "latitude": 57.5920184
        },
        "8507": {
            "name": "Лузино",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9270721,
            "latitude": 55.1723865
        },
        "8508": {
            "name": "Красный Флаг",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9334214,
            "latitude": 54.8728046
        },
        "8509": {
            "name": "Климино",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9381041,
            "latitude": 55.8455
        },
        "8510": {
            "name": "Лески",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9400475,
            "latitude": 55.4423839
        },
        "8511": {
            "name": "Федосеевка",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9453019,
            "latitude": 55.7859709
        },
        "8512": {
            "name": "Комаровка",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9501402,
            "latitude": 57.5351376
        },
        "8513": {
            "name": "Краснопутиловка",
            "population": 249,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9519673,
            "latitude": 54.41612
        },
        "8514": {
            "name": "Гостиловка",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9581039,
            "latitude": 54.3538948
        },
        "8515": {
            "name": "Обновление",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9662381,
            "latitude": 55.0582176
        },
        "8516": {
            "name": "Малые Кулары",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9779577,
            "latitude": 57.538
        },
        "8517": {
            "name": "Илеуш",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9786047,
            "latitude": 54.8002554
        },
        "8518": {
            "name": "Ромадан",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9790638,
            "latitude": 54.7424166
        },
        "8519": {
            "name": "Чагино",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9829648,
            "latitude": 56.4518397
        },
        "8520": {
            "name": "Новоколомзино",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9850935,
            "latitude": 54.3523821
        },
        "8521": {
            "name": "Усть-Логатка",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9868375,
            "latitude": 56.2219328
        },
        "8522": {
            "name": "Новосергеевка",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 71.9880927,
            "latitude": 54.45876
        },
        "8523": {
            "name": "Селивановка",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0075393,
            "latitude": 54.6159422
        },
        "8524": {
            "name": "Алексеевский",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0080942,
            "latitude": 55.3277768
        },
        "8525": {
            "name": "Харловка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0147045,
            "latitude": 55.1176662
        },
        "8526": {
            "name": "Степок",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0158629,
            "latitude": 54.8420941
        },
        "8527": {
            "name": "Шефер",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.018295,
            "latitude": 55.00568
        },
        "8528": {
            "name": "Губернское",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0219869,
            "latitude": 55.0670371
        },
        "8529": {
            "name": "Каменка",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0261711,
            "latitude": 54.3805663
        },
        "8530": {
            "name": "Питомник",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.048264,
            "latitude": 54.801926
        },
        "8531": {
            "name": "Мирное Поле",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0533605,
            "latitude": 55.0289758
        },
        "8532": {
            "name": "Черноусово",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0617975,
            "latitude": 55.7256555
        },
        "8533": {
            "name": "Короли",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.063516,
            "latitude": 55.5815821
        },
        "8534": {
            "name": "Старый Конкуль",
            "population": 120,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.070684,
            "latitude": 56.0983331
        },
        "8535": {
            "name": "Ивановка",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.074221,
            "latitude": 55.6447994
        },
        "8536": {
            "name": "Елизаветино",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0754994,
            "latitude": 54.4986923
        },
        "8537": {
            "name": "Малая Черноостровка",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0769434,
            "latitude": 55.2929113
        },
        "8538": {
            "name": "Долгановка",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0769774,
            "latitude": 55.509769
        },
        "8539": {
            "name": "Алексеевское Лесничество",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.080483,
            "latitude": 55.3249517
        },
        "8540": {
            "name": "Дачное",
            "population": 196,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0806543,
            "latitude": 54.809942
        },
        "8541": {
            "name": "Новый Конкуль",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.089638,
            "latitude": 56.086456
        },
        "8542": {
            "name": "Путиловка",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0962639,
            "latitude": 54.5554834
        },
        "8543": {
            "name": "Лаптево",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0987815,
            "latitude": 56.0060611
        },
        "8544": {
            "name": "Петровка",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.0994878,
            "latitude": 55.7805978
        },
        "8545": {
            "name": "Татьяновка",
            "population": 178,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1187102,
            "latitude": 54.7173675
        },
        "8546": {
            "name": "Помурино",
            "population": 233,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1190429,
            "latitude": 54.9452972
        },
        "8547": {
            "name": "Славянское",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1295739,
            "latitude": 54.4739216
        },
        "8548": {
            "name": "Щучье",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1310644,
            "latitude": 55.4281803
        },
        "8549": {
            "name": "Чайкино",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1311309,
            "latitude": 55.7005284
        },
        "8550": {
            "name": "Колькуль",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1394873,
            "latitude": 56.2373033
        },
        "8551": {
            "name": "Островная",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1429563,
            "latitude": 56.3485963
        },
        "8552": {
            "name": "Луговая",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1431702,
            "latitude": 56.1901049
        },
        "8553": {
            "name": "Вторая Пятилетка",
            "population": 255,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1591149,
            "latitude": 55.8601428
        },
        "8554": {
            "name": "Форпост",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1609956,
            "latitude": 56.7832622
        },
        "8555": {
            "name": "Чащино",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1648858,
            "latitude": 55.933828
        },
        "8556": {
            "name": "Сосновый",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1704383,
            "latitude": 57.6511493
        },
        "8557": {
            "name": "Красный Восток",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1736963,
            "latitude": 54.4384241
        },
        "8558": {
            "name": "Ермолино",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1792452,
            "latitude": 55.6608253
        },
        "8559": {
            "name": "Зотино",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1795541,
            "latitude": 55.9884994
        },
        "8560": {
            "name": "Лесногорский",
            "population": 110,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1889184,
            "latitude": 54.8473597
        },
        "8561": {
            "name": "Орлово-Кукушкино",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1942529,
            "latitude": 55.7626348
        },
        "8562": {
            "name": "Голубки",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1946049,
            "latitude": 55.4134645
        },
        "8563": {
            "name": "Первомайский",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1952491,
            "latitude": 55.4481884
        },
        "8564": {
            "name": "Борятино",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.1990456,
            "latitude": 55.2786845
        },
        "8565": {
            "name": "Шулаевка",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2156892,
            "latitude": 55.1915766
        },
        "8566": {
            "name": "Первомайский",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2170993,
            "latitude": 56.0154117
        },
        "8567": {
            "name": "Спартак",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2234567,
            "latitude": 55.0293337
        },
        "8568": {
            "name": "Соколовка",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2252961,
            "latitude": 56.1225835
        },
        "8569": {
            "name": "Рябинка",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2273493,
            "latitude": 55.0651447
        },
        "8570": {
            "name": "Славянка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2278779,
            "latitude": 54.434146
        },
        "8571": {
            "name": "Вербовка",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2375346,
            "latitude": 54.5881648
        },
        "8572": {
            "name": "Больше-Васильевка",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2474612,
            "latitude": 54.6512578
        },
        "8573": {
            "name": "Токарево",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2748409,
            "latitude": 55.5464626
        },
        "8574": {
            "name": "Балашовка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2811126,
            "latitude": 55.2265881
        },
        "8575": {
            "name": "Лесной",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2861804,
            "latitude": 55.135868
        },
        "8576": {
            "name": "Нейдорф",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.292061,
            "latitude": 54.849197
        },
        "8577": {
            "name": "Полуяновка",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2932442,
            "latitude": 57.5156708
        },
        "8578": {
            "name": "Гурково",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.2987597,
            "latitude": 56.2624288
        },
        "8579": {
            "name": "имени Чапаева",
            "population": 250,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3086665,
            "latitude": 54.9906677
        },
        "8580": {
            "name": "Южный",
            "population": 206,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.316581,
            "latitude": 55.0534281
        },
        "8581": {
            "name": "Мокшино",
            "population": 95,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3166417,
            "latitude": 55.3478348
        },
        "8582": {
            "name": "Владимировка",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.318126,
            "latitude": 55.4523821
        },
        "8583": {
            "name": "Кумыра",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3207049,
            "latitude": 56.2009658
        },
        "8584": {
            "name": "Красный Шар",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3236955,
            "latitude": 55.8574646
        },
        "8585": {
            "name": "Победа",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3337894,
            "latitude": 54.8427165
        },
        "8586": {
            "name": "Райнфельд",
            "population": 235,
            "type": "hamlet",
            "poly": [
                [
                    72.3424361,
                    54.9406733
                ],
                [
                    72.3436834,
                    54.9406973
                ],
                [
                    72.3437109,
                    54.9410801
                ],
                [
                    72.3434512,
                    54.9410937
                ],
                [
                    72.3434512,
                    54.9417717
                ],
                [
                    72.3497309,
                    54.9421243
                ],
                [
                    72.3566481,
                    54.9423413
                ],
                [
                    72.3567189,
                    54.9415412
                ],
                [
                    72.3585367,
                    54.941609
                ],
                [
                    72.3585839,
                    54.9421243
                ],
                [
                    72.3592686,
                    54.9423955
                ],
                [
                    72.362857,
                    54.9424498
                ],
                [
                    72.3629514,
                    54.94127
                ],
                [
                    72.3634236,
                    54.9412429
                ],
                [
                    72.3634944,
                    54.9400902
                ],
                [
                    72.3608739,
                    54.9400224
                ],
                [
                    72.3608031,
                    54.9405784
                ],
                [
                    72.360024,
                    54.9405377
                ],
                [
                    72.360024,
                    54.9398868
                ],
                [
                    72.3592213,
                    54.9398732
                ],
                [
                    72.3591269,
                    54.9396834
                ],
                [
                    72.3585131,
                    54.9396698
                ],
                [
                    72.3583478,
                    54.9394664
                ],
                [
                    72.357498,
                    54.9394392
                ],
                [
                    72.3574743,
                    54.9391273
                ],
                [
                    72.3571911,
                    54.9390053
                ],
                [
                    72.3509113,
                    54.9389782
                ],
                [
                    72.3507933,
                    54.9394528
                ],
                [
                    72.3425305,
                    54.9393036
                ],
                [
                    72.3424372,
                    54.940658
                ],
                [
                    72.3424361,
                    54.9406733
                ]
            ],
            "longitude": 72.352577,
            "latitude": 54.940254
        },
        "8587": {
            "name": "Городки",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3526171,
            "latitude": 56.1406787
        },
        "8588": {
            "name": "Новокиевский",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3581314,
            "latitude": 55.2590424
        },
        "8589": {
            "name": "Славинка",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3619911,
            "latitude": 55.2539036
        },
        "8590": {
            "name": "Богородск",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3742793,
            "latitude": 55.5940336
        },
        "8591": {
            "name": "Капустино",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3777559,
            "latitude": 55.4227302
        },
        "8592": {
            "name": "Кошкуль",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3790253,
            "latitude": 56.0170059
        },
        "8593": {
            "name": "Шахат",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3820871,
            "latitude": 54.377564
        },
        "8594": {
            "name": "Сергеевка",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.3832797,
            "latitude": 55.7495927
        },
        "8595": {
            "name": "Ильинка",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4009442,
            "latitude": 55.640594
        },
        "8596": {
            "name": "Оша",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4114909,
            "latitude": 56.157456
        },
        "8597": {
            "name": "Субботинка",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4116771,
            "latitude": 55.3747563
        },
        "8598": {
            "name": "Сарыбалы",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4122186,
            "latitude": 56.2655193
        },
        "8599": {
            "name": "Бобровица",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4127771,
            "latitude": 54.0885341
        },
        "8600": {
            "name": "Крушановка",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4218142,
            "latitude": 54.3084229
        },
        "8601": {
            "name": "2640 км",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4292942,
            "latitude": 55.2352376
        },
        "8602": {
            "name": "Коновалиха",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4395505,
            "latitude": 56.8444011
        },
        "8603": {
            "name": "Татьяновский",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4408033,
            "latitude": 54.9542432
        },
        "8604": {
            "name": "Татьяновский Кордон",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4439136,
            "latitude": 54.9660811
        },
        "8605": {
            "name": "Дубровка",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4443551,
            "latitude": 54.4979433
        },
        "8606": {
            "name": "Решетино",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4462115,
            "latitude": 56.9247424
        },
        "8607": {
            "name": "Грибановка",
            "population": 52,
            "type": "hamlet",
            "poly": [
                [
                    72.4436071,
                    54.8751239
                ],
                [
                    72.4441334,
                    54.8753552
                ],
                [
                    72.4441334,
                    54.8754335
                ],
                [
                    72.4440506,
                    54.8755288
                ],
                [
                    72.444908,
                    54.875869
                ],
                [
                    72.4450855,
                    54.8759132
                ],
                [
                    72.445251,
                    54.8758384
                ],
                [
                    72.446144,
                    54.8761956
                ],
                [
                    72.4472617,
                    54.876495
                ],
                [
                    72.4478648,
                    54.8765121
                ],
                [
                    72.448267,
                    54.876757
                ],
                [
                    72.4485331,
                    54.8770496
                ],
                [
                    72.448397,
                    54.8771449
                ],
                [
                    72.4486395,
                    54.8772538
                ],
                [
                    72.4487223,
                    54.8772061
                ],
                [
                    72.4491067,
                    54.8773728
                ],
                [
                    72.4497571,
                    54.8769986
                ],
                [
                    72.4501416,
                    54.8772095
                ],
                [
                    72.4498636,
                    54.8773762
                ],
                [
                    72.4497334,
                    54.877315
                ],
                [
                    72.4495502,
                    54.8774375
                ],
                [
                    72.4498932,
                    54.8776552
                ],
                [
                    72.4500233,
                    54.8775668
                ],
                [
                    72.4498991,
                    54.8775021
                ],
                [
                    72.450662,
                    54.8770496
                ],
                [
                    72.4510286,
                    54.8772197
                ],
                [
                    72.4508335,
                    54.8773422
                ],
                [
                    72.4511232,
                    54.8775123
                ],
                [
                    72.451277,
                    54.8774205
                ],
                [
                    72.4514899,
                    54.8775361
                ],
                [
                    72.4506975,
                    54.8780363
                ],
                [
                    72.4510404,
                    54.8782574
                ],
                [
                    72.4508098,
                    54.8783969
                ],
                [
                    72.451141,
                    54.8787303
                ],
                [
                    72.4515549,
                    54.8789481
                ],
                [
                    72.4519038,
                    54.8790535
                ],
                [
                    72.4526075,
                    54.8790467
                ],
                [
                    72.4531279,
                    54.8787133
                ],
                [
                    72.453465,
                    54.8788528
                ],
                [
                    72.4537784,
                    54.8786623
                ],
                [
                    72.4544526,
                    54.8790195
                ],
                [
                    72.454151,
                    54.8792372
                ],
                [
                    72.4545531,
                    54.8794312
                ],
                [
                    72.4548665,
                    54.8792202
                ],
                [
                    72.4559251,
                    54.8797543
                ],
                [
                    72.4564928,
                    54.8794039
                ],
                [
                    72.456954,
                    54.8796455
                ],
                [
                    72.4580185,
                    54.8790025
                ],
                [
                    72.4576578,
                    54.8786997
                ],
                [
                    72.4573207,
                    54.8788188
                ],
                [
                    72.4565815,
                    54.8783595
                ],
                [
                    72.457504,
                    54.8777369
                ],
                [
                    72.4572675,
                    54.8775838
                ],
                [
                    72.4574626,
                    54.8774579
                ],
                [
                    72.4564987,
                    54.8768931
                ],
                [
                    72.4553455,
                    54.8776008
                ],
                [
                    72.4546122,
                    54.8772912
                ],
                [
                    72.4560729,
                    54.8763964
                ],
                [
                    72.4548547,
                    54.8756989
                ],
                [
                    72.4545117,
                    54.8758792
                ],
                [
                    72.4543757,
                    54.8757942
                ],
                [
                    72.4532285,
                    54.8765087
                ],
                [
                    72.4531219,
                    54.8764576
                ],
                [
                    72.4544762,
                    54.8755968
                ],
                [
                    72.4542397,
                    54.8755084
                ],
                [
                    72.4541569,
                    54.8755458
                ],
                [
                    72.4535833,
                    54.8751953
                ],
                [
                    72.4525662,
                    54.8758384
                ],
                [
                    72.4519511,
                    54.8755322
                ],
                [
                    72.4532226,
                    54.8747734
                ],
                [
                    72.4489234,
                    54.8724631
                ],
                [
                    72.4488228,
                    54.8724733
                ],
                [
                    72.4486632,
                    54.8725754
                ],
                [
                    72.4487401,
                    54.8726434
                ],
                [
                    72.4483498,
                    54.8729088
                ],
                [
                    72.4481487,
                    54.8728136
                ],
                [
                    72.4474272,
                    54.8732899
                ],
                [
                    72.4464988,
                    54.872902
                ],
                [
                    72.4453102,
                    54.8738071
                ],
                [
                    72.4455526,
                    54.8739262
                ],
                [
                    72.4436071,
                    54.8751239
                ]
            ],
            "longitude": 72.450394,
            "latitude": 54.876423
        },
        "8608": {
            "name": "Кускуны",
            "population": 188,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4558631,
            "latitude": 57.5202382
        },
        "8609": {
            "name": "Южное",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4598802,
            "latitude": 54.5776679
        },
        "8610": {
            "name": "Охровка",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.466393,
            "latitude": 54.950638
        },
        "8611": {
            "name": "Иваново-Сергиевка",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4763554,
            "latitude": 56.1476793
        },
        "8612": {
            "name": "Малый Тевриз",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4777514,
            "latitude": 57.4509636
        },
        "8613": {
            "name": "Каспиль",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4888098,
            "latitude": 55.7607233
        },
        "8614": {
            "name": "Кудук-Чилик",
            "population": 165,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.4949676,
            "latitude": 54.3738101
        },
        "8615": {
            "name": "Большая Окунёвка",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5079682,
            "latitude": 55.5199897
        },
        "8616": {
            "name": "Маломогильное",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5111521,
            "latitude": 55.3615822
        },
        "8617": {
            "name": "Выборненовка",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5153206,
            "latitude": 55.1890723
        },
        "8618": {
            "name": "Вишневка",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5169952,
            "latitude": 54.7712699
        },
        "8619": {
            "name": "Канаковка",
            "population": 124,
            "type": "hamlet",
            "poly": [
                [
                    72.509134,
                    55.3102486
                ],
                [
                    72.5091491,
                    55.3105867
                ],
                [
                    72.510062,
                    55.3105998
                ],
                [
                    72.5100501,
                    55.3107949
                ],
                [
                    72.5103958,
                    55.3108059
                ],
                [
                    72.510408,
                    55.3115309
                ],
                [
                    72.510587,
                    55.3117069
                ],
                [
                    72.5108068,
                    55.3118065
                ],
                [
                    72.5126585,
                    55.3118366
                ],
                [
                    72.5126295,
                    55.3120703
                ],
                [
                    72.5144696,
                    55.3120634
                ],
                [
                    72.5144615,
                    55.3121933
                ],
                [
                    72.5143272,
                    55.3123137
                ],
                [
                    72.5163498,
                    55.3123438
                ],
                [
                    72.5163917,
                    55.312193
                ],
                [
                    72.5163591,
                    55.3120302
                ],
                [
                    72.516535,
                    55.3120023
                ],
                [
                    72.5170395,
                    55.3120262
                ],
                [
                    72.5177517,
                    55.3119828
                ],
                [
                    72.5179043,
                    55.3120784
                ],
                [
                    72.5201529,
                    55.3120726
                ],
                [
                    72.520102,
                    55.3124026
                ],
                [
                    72.5213382,
                    55.3124258
                ],
                [
                    72.52144,
                    55.3119452
                ],
                [
                    72.5215264,
                    55.3119423
                ],
                [
                    72.5215977,
                    55.3115514
                ],
                [
                    72.5215112,
                    55.311537
                ],
                [
                    72.5216028,
                    55.3110158
                ],
                [
                    72.5221267,
                    55.3110274
                ],
                [
                    72.5219741,
                    55.3125995
                ],
                [
                    72.5267307,
                    55.3125792
                ],
                [
                    72.5268273,
                    55.3119249
                ],
                [
                    72.5277125,
                    55.312171
                ],
                [
                    72.5279313,
                    55.3122926
                ],
                [
                    72.5281195,
                    55.31231
                ],
                [
                    72.5286943,
                    55.3122202
                ],
                [
                    72.5290759,
                    55.3121913
                ],
                [
                    72.529081,
                    55.3120755
                ],
                [
                    72.5292692,
                    55.3118525
                ],
                [
                    72.5292845,
                    55.3113777
                ],
                [
                    72.5299254,
                    55.3113661
                ],
                [
                    72.5299814,
                    55.3110621
                ],
                [
                    72.5293557,
                    55.3108739
                ],
                [
                    72.5297525,
                    55.3096724
                ],
                [
                    72.5286893,
                    55.3095103
                ],
                [
                    72.5283993,
                    55.3092526
                ],
                [
                    72.525235,
                    55.3090615
                ],
                [
                    72.5248535,
                    55.3091773
                ],
                [
                    72.5244516,
                    55.3091339
                ],
                [
                    72.5239022,
                    55.3089978
                ],
                [
                    72.5224981,
                    55.3090412
                ],
                [
                    72.5223506,
                    55.3092178
                ],
                [
                    72.522086,
                    55.3093047
                ],
                [
                    72.5214451,
                    55.3093481
                ],
                [
                    72.5212517,
                    55.3094118
                ],
                [
                    72.5212212,
                    55.309574
                ],
                [
                    72.5191762,
                    55.3094639
                ],
                [
                    72.5191558,
                    55.3092005
                ],
                [
                    72.5187641,
                    55.3091831
                ],
                [
                    72.5187081,
                    55.3094495
                ],
                [
                    72.5178942,
                    55.3094205
                ],
                [
                    72.5179043,
                    55.3088704
                ],
                [
                    72.5173753,
                    55.3088617
                ],
                [
                    72.5173295,
                    55.3094031
                ],
                [
                    72.5165918,
                    55.3093684
                ],
                [
                    72.5166427,
                    55.3087748
                ],
                [
                    72.5162459,
                    55.308714
                ],
                [
                    72.5156253,
                    55.3086793
                ],
                [
                    72.5154625,
                    55.3087314
                ],
                [
                    72.5154676,
                    55.3088212
                ],
                [
                    72.5157626,
                    55.3090325
                ],
                [
                    72.5157677,
                    55.3092728
                ],
                [
                    72.5158847,
                    55.309351
                ],
                [
                    72.5165257,
                    55.3093539
                ],
                [
                    72.5165054,
                    55.309574
                ],
                [
                    72.5158644,
                    55.3095566
                ],
                [
                    72.5158491,
                    55.3093829
                ],
                [
                    72.5136311,
                    55.3093394
                ],
                [
                    72.5136311,
                    55.309435
                ],
                [
                    72.5124,
                    55.3094031
                ],
                [
                    72.5123389,
                    55.3092236
                ],
                [
                    72.5118913,
                    55.3090094
                ],
                [
                    72.5111689,
                    55.3089891
                ],
                [
                    72.5112247,
                    55.3085287
                ],
                [
                    72.5105075,
                    55.3084998
                ],
                [
                    72.5104414,
                    55.308963
                ],
                [
                    72.5097495,
                    55.3089254
                ],
                [
                    72.5095867,
                    55.3102601
                ],
                [
                    72.509134,
                    55.3102486
                ]
            ],
            "longitude": 72.5205315,
            "latitude": 55.3106477
        },
        "8620": {
            "name": "Георгиевка",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5210488,
            "latitude": 55.9633863
        },
        "8621": {
            "name": "Чебуренки",
            "population": 178,
            "type": "hamlet",
            "poly": [
                [
                    72.5078258,
                    54.8852823
                ],
                [
                    72.5094148,
                    54.8855805
                ],
                [
                    72.5096906,
                    54.8853977
                ],
                [
                    72.5101089,
                    54.8855132
                ],
                [
                    72.5099667,
                    54.8857441
                ],
                [
                    72.5102594,
                    54.8858114
                ],
                [
                    72.5135378,
                    54.8824824
                ],
                [
                    72.5160467,
                    54.8834013
                ],
                [
                    72.5187062,
                    54.8843875
                ],
                [
                    72.5189152,
                    54.8845077
                ],
                [
                    72.5197014,
                    54.8848252
                ],
                [
                    72.5184553,
                    54.8859654
                ],
                [
                    72.5190072,
                    54.886278
                ],
                [
                    72.5208304,
                    54.886913
                ],
                [
                    72.5217001,
                    54.8871583
                ],
                [
                    72.5212151,
                    54.887649
                ],
                [
                    72.5219761,
                    54.8879617
                ],
                [
                    72.5220765,
                    54.8881829
                ],
                [
                    72.5224445,
                    54.8882839
                ],
                [
                    72.5227455,
                    54.8881781
                ],
                [
                    72.5232724,
                    54.8877885
                ],
                [
                    72.5241003,
                    54.8880915
                ],
                [
                    72.5235986,
                    54.888664
                ],
                [
                    72.5245018,
                    54.8889526
                ],
                [
                    72.5250454,
                    54.8890632
                ],
                [
                    72.5254552,
                    54.8887024
                ],
                [
                    72.5274874,
                    54.889246
                ],
                [
                    72.5287419,
                    54.8882936
                ],
                [
                    72.5292269,
                    54.8883128
                ],
                [
                    72.5296534,
                    54.8879953
                ],
                [
                    72.5301636,
                    54.887548
                ],
                [
                    72.5303057,
                    54.8872353
                ],
                [
                    72.5302221,
                    54.8866148
                ],
                [
                    72.5203453,
                    54.8829346
                ],
                [
                    72.5200944,
                    54.8829009
                ],
                [
                    72.5169332,
                    54.8818233
                ],
                [
                    72.5165903,
                    54.881934
                ],
                [
                    72.5147755,
                    54.8813422
                ],
                [
                    72.514165,
                    54.8817511
                ],
                [
                    72.5139476,
                    54.8819869
                ],
                [
                    72.5135461,
                    54.8819773
                ],
                [
                    72.513312,
                    54.8820398
                ],
                [
                    72.5131614,
                    54.8822082
                ],
                [
                    72.5131196,
                    54.8823188
                ],
                [
                    72.5130193,
                    54.8825979
                ],
                [
                    72.5124087,
                    54.8824199
                ],
                [
                    72.5121997,
                    54.8826412
                ],
                [
                    72.5116979,
                    54.8824824
                ],
                [
                    72.5117146,
                    54.8822467
                ],
                [
                    72.5106859,
                    54.8819869
                ],
                [
                    72.5085701,
                    54.8843009
                ],
                [
                    72.5078258,
                    54.8852823
                ]
            ],
            "longitude": 72.5216277,
            "latitude": 54.884896
        },
        "8622": {
            "name": "2647 км",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5246039,
            "latitude": 55.2035743
        },
        "8623": {
            "name": "Шипачи",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5314856,
            "latitude": 55.8485366
        },
        "8624": {
            "name": "Помогаевка",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.538231,
            "latitude": 55.216728
        },
        "8625": {
            "name": "Рассвет",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5555066,
            "latitude": 55.4815389
        },
        "8626": {
            "name": "Залесная",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5727716,
            "latitude": 55.6684506
        },
        "8627": {
            "name": "Чадск",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.57354,
            "latitude": 54.327946
        },
        "8628": {
            "name": "Яблоновка",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.57399,
            "latitude": 54.394123
        },
        "8629": {
            "name": "Андреевка",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5794798,
            "latitude": 55.3175518
        },
        "8630": {
            "name": "Кокчинск",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.583054,
            "latitude": 54.363205
        },
        "8631": {
            "name": "Приозерка",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5859886,
            "latitude": 56.1077142
        },
        "8632": {
            "name": "Чулково",
            "population": 154,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5896085,
            "latitude": 55.1549966
        },
        "8633": {
            "name": "Комсомольское",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.59348,
            "latitude": 54.574028
        },
        "8634": {
            "name": "Астрахановка",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.5986584,
            "latitude": 55.263848
        },
        "8635": {
            "name": "Восточный",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.609895,
            "latitude": 55.9914886
        },
        "8636": {
            "name": "Бичили",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6134954,
            "latitude": 57.5788432
        },
        "8637": {
            "name": "Бабайловка",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6161588,
            "latitude": 55.2274013
        },
        "8638": {
            "name": "Большемогильное",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6171209,
            "latitude": 55.3978256
        },
        "8639": {
            "name": "Уки",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.621138,
            "latitude": 56.989353
        },
        "8640": {
            "name": "Тарлык",
            "population": 234,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6276351,
            "latitude": 55.5247463
        },
        "8641": {
            "name": "Гуровка",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.630592,
            "latitude": 55.591984
        },
        "8642": {
            "name": "Вознесенка",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6525453,
            "latitude": 57.5181059
        },
        "8643": {
            "name": "Филатовка",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6544229,
            "latitude": 55.2155903
        },
        "8644": {
            "name": "Масляновка",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6599781,
            "latitude": 55.2001491
        },
        "8645": {
            "name": "Оброскино",
            "population": 212,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6620261,
            "latitude": 55.5503596
        },
        "8646": {
            "name": "Тарналы",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6727386,
            "latitude": 54.595438
        },
        "8647": {
            "name": "Кочки",
            "population": 250,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.675285,
            "latitude": 55.088432
        },
        "8648": {
            "name": "Пестровка",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6838309,
            "latitude": 55.4820099
        },
        "8649": {
            "name": "Громогласово",
            "population": 221,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6855442,
            "latitude": 53.9722229
        },
        "8650": {
            "name": "Карагаш",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.6869569,
            "latitude": 54.4093017
        },
        "8651": {
            "name": "Малая Степнинка",
            "population": 225,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.696701,
            "latitude": 55.052715
        },
        "8652": {
            "name": "Зелёная Долина",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7116158,
            "latitude": 54.7743577
        },
        "8653": {
            "name": "Беляевка",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.712151,
            "latitude": 55.236404
        },
        "8654": {
            "name": "Михайловка",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7132437,
            "latitude": 54.8065201
        },
        "8655": {
            "name": "Койчубай",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7149637,
            "latitude": 54.7194543
        },
        "8656": {
            "name": "Орловка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7371546,
            "latitude": 55.8994714
        },
        "8657": {
            "name": "Восточный",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7386925,
            "latitude": 55.140771
        },
        "8658": {
            "name": "Карбаиново",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7392506,
            "latitude": 56.1907411
        },
        "8659": {
            "name": "Барсуковка",
            "population": 236,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7429889,
            "latitude": 55.2268791
        },
        "8660": {
            "name": "Новое Поле",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.753731,
            "latitude": 55.087337
        },
        "8661": {
            "name": "Чугунлы",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7541955,
            "latitude": 56.5253665
        },
        "8662": {
            "name": "Покровка",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7613744,
            "latitude": 55.1782651
        },
        "8663": {
            "name": "2857 км",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7664652,
            "latitude": 54.9604463
        },
        "8664": {
            "name": "Верхние Уки",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7734374,
            "latitude": 56.7753232
        },
        "8665": {
            "name": "Калиновка",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7753684,
            "latitude": 55.3781187
        },
        "8666": {
            "name": "Поспелово",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7777194,
            "latitude": 56.8819136
        },
        "8667": {
            "name": "Баслы",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7811457,
            "latitude": 57.0093305
        },
        "8668": {
            "name": "Новосолдатка",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7849311,
            "latitude": 55.8295746
        },
        "8669": {
            "name": "Мироненовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7850305,
            "latitude": 55.1170374
        },
        "8670": {
            "name": "Ивановка",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7873428,
            "latitude": 55.4993176
        },
        "8671": {
            "name": "Быструха",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.7925701,
            "latitude": 55.420569
        },
        "8672": {
            "name": "Охотниково",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8017398,
            "latitude": 55.9423809
        },
        "8673": {
            "name": "Павловка",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8098031,
            "latitude": 55.5721623
        },
        "8674": {
            "name": "Савиново",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8153331,
            "latitude": 56.2000365
        },
        "8675": {
            "name": "Веденино",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8183733,
            "latitude": 56.029408
        },
        "8676": {
            "name": "Большой Искак",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8197947,
            "latitude": 54.7273897
        },
        "8677": {
            "name": "Степановка",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8347721,
            "latitude": 55.4250334
        },
        "8678": {
            "name": "Николаевка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8384044,
            "latitude": 55.6197603
        },
        "8679": {
            "name": "Доронино",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8430337,
            "latitude": 57.4626107
        },
        "8680": {
            "name": "Алонский",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.8594493,
            "latitude": 54.9622014
        },
        "8681": {
            "name": "Руслановка",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.860294,
            "latitude": 54.6763314
        },
        "8682": {
            "name": "2672 км",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.876656,
            "latitude": 55.0917223
        },
        "8683": {
            "name": "Александровка",
            "population": 235,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.891914,
            "latitude": 54.984215
        },
        "8684": {
            "name": "Кайгарлы",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.900005,
            "latitude": 57.4561842
        },
        "8685": {
            "name": "Глебовка",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9004648,
            "latitude": 55.7235544
        },
        "8686": {
            "name": "Тишанка",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9032531,
            "latitude": 54.3135424
        },
        "8687": {
            "name": "Ягодное",
            "population": 254,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.915421,
            "latitude": 54.675053
        },
        "8688": {
            "name": "Славгородка",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9275457,
            "latitude": 54.1143679
        },
        "8689": {
            "name": "Журавлёвка",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9379376,
            "latitude": 56.0449385
        },
        "8690": {
            "name": "Нагорно-Аевск",
            "population": 254,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9410914,
            "latitude": 57.3978517
        },
        "8691": {
            "name": "Лесное",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.947783,
            "latitude": 54.5546734
        },
        "8692": {
            "name": "Плоское",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9637627,
            "latitude": 55.8437084
        },
        "8693": {
            "name": "Меркутлы",
            "population": 243,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9706014,
            "latitude": 56.0899724
        },
        "8694": {
            "name": "Ближняя Роща",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9714774,
            "latitude": 54.8976628
        },
        "8695": {
            "name": "Барсуковка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.974182,
            "latitude": 54.621357
        },
        "8696": {
            "name": "Новопавловка",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.9904071,
            "latitude": 54.2857162
        },
        "8697": {
            "name": "Чердынцево",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 72.993378,
            "latitude": 56.299655
        },
        "8698": {
            "name": "Большая Казанка",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0143601,
            "latitude": 56.0241362
        },
        "8699": {
            "name": "Петрушенко",
            "population": 227,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0174053,
            "latitude": 55.0375004
        },
        "8700": {
            "name": "Южное",
            "population": 247,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0260459,
            "latitude": 54.632178
        },
        "8701": {
            "name": "Тулумбай",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0261814,
            "latitude": 54.8375027
        },
        "8702": {
            "name": "Тамбовка",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0311659,
            "latitude": 55.4733641
        },
        "8703": {
            "name": "Лузино",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.041374,
            "latitude": 54.953907
        },
        "8704": {
            "name": "Кутумбет",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0446963,
            "latitude": 54.4864302
        },
        "8705": {
            "name": "Николаевка",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0797773,
            "latitude": 56.2202263
        },
        "8706": {
            "name": "Чаунино",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.07993,
            "latitude": 57.1452905
        },
        "8707": {
            "name": "Галицыно",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0835725,
            "latitude": 55.8594488
        },
        "8708": {
            "name": "Куртайлы",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0869112,
            "latitude": 55.9118885
        },
        "8709": {
            "name": "Сарат",
            "population": 225,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.0889466,
            "latitude": 54.3658051
        },
        "8710": {
            "name": "Бердянка",
            "population": 259,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.101356,
            "latitude": 54.6397197
        },
        "8711": {
            "name": "Воронково",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1307596,
            "latitude": 54.5568408
        },
        "8712": {
            "name": "Баирово",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1373873,
            "latitude": 56.0667187
        },
        "8713": {
            "name": "Крутобережный",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.139603,
            "latitude": 55.0417793
        },
        "8714": {
            "name": "Зелёная",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1418329,
            "latitude": 56.3543529
        },
        "8715": {
            "name": "Новинка",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.142792,
            "latitude": 54.76091
        },
        "8716": {
            "name": "Большешипицыно",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1620593,
            "latitude": 55.7320821
        },
        "8717": {
            "name": "Вишневое",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1684199,
            "latitude": 56.5701719
        },
        "8718": {
            "name": "Песчанка",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1727796,
            "latitude": 54.3388682
        },
        "8719": {
            "name": "Малокулачье",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1795203,
            "latitude": 55.2633827
        },
        "8720": {
            "name": "Новопокровка",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1834388,
            "latitude": 55.5786473
        },
        "8721": {
            "name": "Алексеевка",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.1858283,
            "latitude": 55.6805424
        },
        "8722": {
            "name": "Зелёное Поле",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.204483,
            "latitude": 54.933781
        },
        "8723": {
            "name": "Луговая",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.236959,
            "latitude": 55.240011
        },
        "8724": {
            "name": "Михайловка",
            "population": 158,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.237411,
            "latitude": 56.243366
        },
        "8725": {
            "name": "Садовое",
            "population": 245,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2466872,
            "latitude": 54.6447591
        },
        "8726": {
            "name": "Большекулачье",
            "population": 236,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.255215,
            "latitude": 55.2119601
        },
        "8727": {
            "name": "Дувановка",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2569108,
            "latitude": 53.9662757
        },
        "8728": {
            "name": "Фёдоровка",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2583242,
            "latitude": 57.5902943
        },
        "8729": {
            "name": "Индеры",
            "population": 103,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2637407,
            "latitude": 55.857588
        },
        "8730": {
            "name": "Балангуль",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2665618,
            "latitude": 55.8048082
        },
        "8731": {
            "name": "Андреевка",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2727776,
            "latitude": 54.3916462
        },
        "8732": {
            "name": "Александровка",
            "population": 156,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2796677,
            "latitude": 56.2165629
        },
        "8733": {
            "name": "Аксеново",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2812466,
            "latitude": 55.5727353
        },
        "8734": {
            "name": "Авяк",
            "population": 255,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2864207,
            "latitude": 57.1316659
        },
        "8735": {
            "name": "Урусово",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.2930247,
            "latitude": 55.6565905
        },
        "8736": {
            "name": "Муртук",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3057577,
            "latitude": 54.5278027
        },
        "8737": {
            "name": "Бессарабка",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3076412,
            "latitude": 53.6127998
        },
        "8738": {
            "name": "Беспалово",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3124907,
            "latitude": 55.9476281
        },
        "8739": {
            "name": "Кохановка",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.322726,
            "latitude": 54.2740707
        },
        "8740": {
            "name": "Новотроицк",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3289048,
            "latitude": 56.4124173
        },
        "8741": {
            "name": "Калмакуль",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3336405,
            "latitude": 56.0336414
        },
        "8742": {
            "name": "Таборы",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3356384,
            "latitude": 57.348507
        },
        "8743": {
            "name": "Фадино",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3402577,
            "latitude": 54.7854882
        },
        "8744": {
            "name": "Плахино",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3568094,
            "latitude": 56.3245091
        },
        "8745": {
            "name": "Зеленовка",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3701663,
            "latitude": 55.1423265
        },
        "8746": {
            "name": "Алексеевка",
            "population": 21,
            "type": "hamlet",
            "poly": [
                [
                    73.3669056,
                    55.3255413
                ],
                [
                    73.3675947,
                    55.3255786
                ],
                [
                    73.3676767,
                    55.3259146
                ],
                [
                    73.3682017,
                    55.326036
                ],
                [
                    73.3693338,
                    55.3260266
                ],
                [
                    73.3690877,
                    55.3264
                ],
                [
                    73.3702689,
                    55.3267173
                ],
                [
                    73.370433,
                    55.3269413
                ],
                [
                    73.3707119,
                    55.3267173
                ],
                [
                    73.3720409,
                    55.3270907
                ],
                [
                    73.3734508,
                    55.3250927
                ],
                [
                    73.3765014,
                    55.3220152
                ],
                [
                    73.3783471,
                    55.3187917
                ],
                [
                    73.3781677,
                    55.3183687
                ],
                [
                    73.3770909,
                    55.3183395
                ],
                [
                    73.3770976,
                    55.3178314
                ],
                [
                    73.3761773,
                    55.3178076
                ],
                [
                    73.3754903,
                    55.3175973
                ],
                [
                    73.3753058,
                    55.3179124
                ],
                [
                    73.3730499,
                    55.3175157
                ],
                [
                    73.3706299,
                    55.3192311
                ],
                [
                    73.3702402,
                    55.3201296
                ],
                [
                    73.3681197,
                    55.3230304
                ],
                [
                    73.3669056,
                    55.3255413
                ]
            ],
            "longitude": 73.3719663,
            "latitude": 55.3222006
        },
        "8747": {
            "name": "Тузаклы",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3720508,
            "latitude": 57.2507808
        },
        "8748": {
            "name": "Нижняя Бития",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.3810929,
            "latitude": 55.4848201
        },
        "8749": {
            "name": "Берёзовка",
            "population": 203,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4076039,
            "latitude": 54.4806059
        },
        "8750": {
            "name": "Александровка",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4093173,
            "latitude": 55.9066273
        },
        "8751": {
            "name": "Калачёвка",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4122138,
            "latitude": 55.5285827
        },
        "8752": {
            "name": "Ракитинка",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    73.4039818,
                    55.0982226
                ],
                [
                    73.4061781,
                    55.1004199
                ],
                [
                    73.4130123,
                    55.1005673
                ],
                [
                    73.4131105,
                    55.1006867
                ],
                [
                    73.4134663,
                    55.1008622
                ],
                [
                    73.4175521,
                    55.1012202
                ],
                [
                    73.4207299,
                    55.1015431
                ],
                [
                    73.4219201,
                    55.101515
                ],
                [
                    73.4248894,
                    55.1015992
                ],
                [
                    73.425098,
                    55.1015852
                ],
                [
                    73.4252329,
                    55.1014939
                ],
                [
                    73.4254906,
                    55.1009955
                ],
                [
                    73.4262022,
                    55.1006445
                ],
                [
                    73.4269139,
                    55.0997179
                ],
                [
                    73.4305702,
                    55.099402
                ],
                [
                    73.4368155,
                    55.0991352
                ],
                [
                    73.4365578,
                    55.0984823
                ],
                [
                    73.4340916,
                    55.0985947
                ],
                [
                    73.433883,
                    55.0979909
                ],
                [
                    73.4335885,
                    55.0978505
                ],
                [
                    73.4331591,
                    55.0977733
                ],
                [
                    73.4316745,
                    55.0977592
                ],
                [
                    73.430742,
                    55.0975135
                ],
                [
                    73.430558,
                    55.0974925
                ],
                [
                    73.4294782,
                    55.0976961
                ],
                [
                    73.4290733,
                    55.0976961
                ],
                [
                    73.4268525,
                    55.0970361
                ],
                [
                    73.4248403,
                    55.097345
                ],
                [
                    73.4233188,
                    55.097661
                ],
                [
                    73.4233679,
                    55.0982086
                ],
                [
                    73.4230612,
                    55.0983349
                ],
                [
                    73.422779,
                    55.0983419
                ],
                [
                    73.4227298,
                    55.0981524
                ],
                [
                    73.4223618,
                    55.0981103
                ],
                [
                    73.4221778,
                    55.0984823
                ],
                [
                    73.4217974,
                    55.0984823
                ],
                [
                    73.4218465,
                    55.0978435
                ],
                [
                    73.4161288,
                    55.0973731
                ],
                [
                    73.4146565,
                    55.0973872
                ],
                [
                    73.4142147,
                    55.0974644
                ],
                [
                    73.413773,
                    55.0974503
                ],
                [
                    73.4131596,
                    55.0974784
                ],
                [
                    73.4124725,
                    55.0976329
                ],
                [
                    73.4110246,
                    55.0976961
                ],
                [
                    73.4088406,
                    55.0979277
                ],
                [
                    73.4041413,
                    55.0977312
                ],
                [
                    73.4039818,
                    55.0982226
                ]
            ],
            "longitude": 73.4187504,
            "latitude": 55.0994179
        },
        "8753": {
            "name": "Назаровка",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4366301,
            "latitude": 54.1690581
        },
        "8754": {
            "name": "Айлинка",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4368578,
            "latitude": 57.3538411
        },
        "8755": {
            "name": "Бердовка",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4375485,
            "latitude": 54.1989211
        },
        "8756": {
            "name": "Липовка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4480873,
            "latitude": 57.2328926
        },
        "8757": {
            "name": "Дубрава",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4515478,
            "latitude": 56.4617374
        },
        "8758": {
            "name": "Черноусовка",
            "population": 232,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4542815,
            "latitude": 53.5707097
        },
        "8759": {
            "name": "Давыдовка",
            "population": 20,
            "type": "hamlet",
            "poly": [
                [
                    73.4523315,
                    55.1478029
                ],
                [
                    73.4526857,
                    55.1493922
                ],
                [
                    73.4539718,
                    55.1534723
                ],
                [
                    73.4561228,
                    55.1532696
                ],
                [
                    73.4558124,
                    55.1518315
                ],
                [
                    73.4545226,
                    55.1476791
                ],
                [
                    73.4523315,
                    55.1478029
                ]
            ],
            "longitude": 73.4548002,
            "latitude": 55.1506157
        },
        "8760": {
            "name": "Карманово",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4567967,
            "latitude": 55.8111028
        },
        "8761": {
            "name": "Степановка",
            "population": 251,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4575405,
            "latitude": 53.8355273
        },
        "8762": {
            "name": "Сибкоммуна",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.468843,
            "latitude": 54.7995626
        },
        "8763": {
            "name": "Интенис",
            "population": 171,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4898877,
            "latitude": 55.7752009
        },
        "8764": {
            "name": "Степановка",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.4956901,
            "latitude": 55.7151299
        },
        "8765": {
            "name": "Квашнино",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.500391,
            "latitude": 56.4121643
        },
        "8766": {
            "name": "Малахово",
            "population": 172,
            "type": "hamlet",
            "poly": [
                [
                    73.4925305,
                    55.2539566
                ],
                [
                    73.4934094,
                    55.2546207
                ],
                [
                    73.4954467,
                    55.254689
                ],
                [
                    73.4976238,
                    55.254689
                ],
                [
                    73.4990686,
                    55.254651
                ],
                [
                    73.4992684,
                    55.2542222
                ],
                [
                    73.4995547,
                    55.254226
                ],
                [
                    73.4995547,
                    55.2546434
                ],
                [
                    73.4999275,
                    55.2546358
                ],
                [
                    73.500074,
                    55.2544992
                ],
                [
                    73.5004069,
                    55.254503
                ],
                [
                    73.5005599,
                    55.2543247
                ],
                [
                    73.5007398,
                    55.2543247
                ],
                [
                    73.5008396,
                    55.2544537
                ],
                [
                    73.5021646,
                    55.254355
                ],
                [
                    73.5047612,
                    55.2543816
                ],
                [
                    73.5047678,
                    55.2548104
                ],
                [
                    73.5149545,
                    55.25467
                ],
                [
                    73.515101,
                    55.2529055
                ],
                [
                    73.5123579,
                    55.251528
                ],
                [
                    73.5113992,
                    55.2512585
                ],
                [
                    73.5099144,
                    55.2510043
                ],
                [
                    73.5091554,
                    55.2509587
                ],
                [
                    73.5043817,
                    55.2508449
                ],
                [
                    73.5024775,
                    55.2508639
                ],
                [
                    73.499295,
                    55.2510195
                ],
                [
                    73.4974041,
                    55.2511599
                ],
                [
                    73.4952869,
                    55.2514255
                ],
                [
                    73.494488,
                    55.2515432
                ],
                [
                    73.4944547,
                    55.252674
                ],
                [
                    73.493942,
                    55.2528258
                ],
                [
                    73.4936757,
                    55.2529662
                ],
                [
                    73.4930032,
                    55.2529776
                ],
                [
                    73.4925305,
                    55.2539566
                ]
            ],
            "longitude": 73.5031551,
            "latitude": 55.2531414
        },
        "8767": {
            "name": "Классино",
            "population": 195,
            "type": "hamlet",
            "poly": [
                [
                    73.4928757,
                    55.3143131
                ],
                [
                    73.4936551,
                    55.3160169
                ],
                [
                    73.4940448,
                    55.3159819
                ],
                [
                    73.4940448,
                    55.3168922
                ],
                [
                    73.4956649,
                    55.317254
                ],
                [
                    73.4961153,
                    55.3172201
                ],
                [
                    73.5089421,
                    55.3139975
                ],
                [
                    73.5100629,
                    55.3137159
                ],
                [
                    73.5108854,
                    55.3140324
                ],
                [
                    73.5112843,
                    55.313889
                ],
                [
                    73.5112214,
                    55.3135783
                ],
                [
                    73.5109799,
                    55.3133811
                ],
                [
                    73.5093943,
                    55.313411
                ],
                [
                    73.5093943,
                    55.3131959
                ],
                [
                    73.5096673,
                    55.3130883
                ],
                [
                    73.5094888,
                    55.3128194
                ],
                [
                    73.5102028,
                    55.3123533
                ],
                [
                    73.5101083,
                    55.3121501
                ],
                [
                    73.5106859,
                    55.3120784
                ],
                [
                    73.5108224,
                    55.3123951
                ],
                [
                    73.5111374,
                    55.3124131
                ],
                [
                    73.5112528,
                    55.3126988
                ],
                [
                    73.5113474,
                    55.3129329
                ],
                [
                    73.5116204,
                    55.3129389
                ],
                [
                    73.5117745,
                    55.313097
                ],
                [
                    73.514137,
                    55.313097
                ],
                [
                    73.5149457,
                    55.3118876
                ],
                [
                    73.5149725,
                    55.3115128
                ],
                [
                    73.5143005,
                    55.3113025
                ],
                [
                    73.5139156,
                    55.3103248
                ],
                [
                    73.5076195,
                    55.3105115
                ],
                [
                    73.5064711,
                    55.310815
                ],
                [
                    73.5032948,
                    55.3113677
                ],
                [
                    73.5025598,
                    55.3112333
                ],
                [
                    73.5020741,
                    55.3112408
                ],
                [
                    73.4986616,
                    55.3120027
                ],
                [
                    73.4986747,
                    55.3126675
                ],
                [
                    73.4979003,
                    55.3127422
                ],
                [
                    73.4974146,
                    55.3130111
                ],
                [
                    73.4955903,
                    55.313153
                ],
                [
                    73.4957478,
                    55.3136161
                ],
                [
                    73.4963253,
                    55.3136758
                ],
                [
                    73.4955829,
                    55.3139746
                ],
                [
                    73.4948036,
                    55.314103
                ],
                [
                    73.4944754,
                    55.3143481
                ],
                [
                    73.4937987,
                    55.3144764
                ],
                [
                    73.4935936,
                    55.3142197
                ],
                [
                    73.4928757,
                    55.3143131
                ]
            ],
            "longitude": 73.503632,
            "latitude": 55.31234
        },
        "8768": {
            "name": "Новоселецк",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5113995,
            "latitude": 54.6798341
        },
        "8769": {
            "name": "Левобережный",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5301087,
            "latitude": 55.009265
        },
        "8770": {
            "name": "Лапино",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5409532,
            "latitude": 54.5789045
        },
        "8771": {
            "name": "Тогунас",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5536859,
            "latitude": 53.7734392
        },
        "8772": {
            "name": "Новосанжаровский разъезд",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5555902,
            "latitude": 53.6999512
        },
        "8773": {
            "name": "Падь",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5565291,
            "latitude": 54.8078175
        },
        "8774": {
            "name": "Осиповка",
            "population": 164,
            "type": "hamlet",
            "poly": [
                [
                    73.5464261,
                    55.4055972
                ],
                [
                    73.5465565,
                    55.4078074
                ],
                [
                    73.5491343,
                    55.4080547
                ],
                [
                    73.5603615,
                    55.4091774
                ],
                [
                    73.5637043,
                    55.4087815
                ],
                [
                    73.5685442,
                    55.4078152
                ],
                [
                    73.5677239,
                    55.4042173
                ],
                [
                    73.5649553,
                    55.4042173
                ],
                [
                    73.5560942,
                    55.4019545
                ],
                [
                    73.5559813,
                    55.4018385
                ],
                [
                    73.5556426,
                    55.4020796
                ],
                [
                    73.5502604,
                    55.4035073
                ],
                [
                    73.5499473,
                    55.4036617
                ],
                [
                    73.5497718,
                    55.4038668
                ],
                [
                    73.5496625,
                    55.404187
                ],
                [
                    73.5495496,
                    55.4047395
                ],
                [
                    73.5493507,
                    55.4057315
                ],
                [
                    73.5464261,
                    55.4055972
                ]
            ],
            "longitude": 73.55748,
            "latitude": 55.406075
        },
        "8775": {
            "name": "Никоновка",
            "population": 198,
            "type": "hamlet",
            "poly": [
                [
                    73.5493278,
                    55.3712084
                ],
                [
                    73.5504366,
                    55.3715616
                ],
                [
                    73.5514094,
                    55.3715773
                ],
                [
                    73.5521188,
                    55.3722747
                ],
                [
                    73.5523836,
                    55.372647
                ],
                [
                    73.5523946,
                    55.3730318
                ],
                [
                    73.5547152,
                    55.3734375
                ],
                [
                    73.5587368,
                    55.3738432
                ],
                [
                    73.5610363,
                    55.3742072
                ],
                [
                    73.5621704,
                    55.3742012
                ],
                [
                    73.5644909,
                    55.3737895
                ],
                [
                    73.5664526,
                    55.373278
                ],
                [
                    73.5667218,
                    55.3725541
                ],
                [
                    73.5670499,
                    55.3721112
                ],
                [
                    73.5674806,
                    55.3718082
                ],
                [
                    73.5679933,
                    55.3715752
                ],
                [
                    73.5680299,
                    55.3700115
                ],
                [
                    73.5664963,
                    55.3696963
                ],
                [
                    73.566037,
                    55.3699574
                ],
                [
                    73.5656268,
                    55.3699574
                ],
                [
                    73.5653807,
                    55.3700692
                ],
                [
                    73.5651345,
                    55.3699294
                ],
                [
                    73.5650854,
                    55.3701252
                ],
                [
                    73.5647244,
                    55.3701252
                ],
                [
                    73.5646916,
                    55.3699201
                ],
                [
                    73.564019,
                    55.3699387
                ],
                [
                    73.564019,
                    55.3701345
                ],
                [
                    73.5636252,
                    55.3701159
                ],
                [
                    73.5634611,
                    55.3699387
                ],
                [
                    73.5630838,
                    55.3699294
                ],
                [
                    73.5624111,
                    55.3702464
                ],
                [
                    73.5609181,
                    55.3702557
                ],
                [
                    73.5609345,
                    55.3697149
                ],
                [
                    73.5594743,
                    55.3696404
                ],
                [
                    73.5596876,
                    55.3692394
                ],
                [
                    73.5603275,
                    55.3692581
                ],
                [
                    73.5604915,
                    55.3691649
                ],
                [
                    73.5616564,
                    55.3691649
                ],
                [
                    73.5618697,
                    55.3688106
                ],
                [
                    73.5617384,
                    55.3685029
                ],
                [
                    73.5606556,
                    55.3681113
                ],
                [
                    73.5588509,
                    55.3680367
                ],
                [
                    73.558654,
                    55.3685495
                ],
                [
                    73.5569641,
                    55.3685961
                ],
                [
                    73.5555696,
                    55.368736
                ],
                [
                    73.5555696,
                    55.3683444
                ],
                [
                    73.5550938,
                    55.3683723
                ],
                [
                    73.5550938,
                    55.3680367
                ],
                [
                    73.5541913,
                    55.3681206
                ],
                [
                    73.5541094,
                    55.369053
                ],
                [
                    73.5535188,
                    55.3690623
                ],
                [
                    73.5535188,
                    55.3685495
                ],
                [
                    73.5516484,
                    55.3686148
                ],
                [
                    73.5499914,
                    55.3709363
                ],
                [
                    73.5493278,
                    55.3712084
                ]
            ],
            "longitude": 73.5581674,
            "latitude": 55.3711682
        },
        "8776": {
            "name": "Котовщиково",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5582514,
            "latitude": 56.9333371
        },
        "8777": {
            "name": "Малобутаково",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5615246,
            "latitude": 57.2143465
        },
        "8778": {
            "name": "Лобково",
            "population": 239,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5652609,
            "latitude": 54.7021794
        },
        "8779": {
            "name": "Кушайлы",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.567688,
            "latitude": 55.6067871
        },
        "8780": {
            "name": "Коготово",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5722923,
            "latitude": 56.5288891
        },
        "8781": {
            "name": "Жуковка",
            "population": 165,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5749112,
            "latitude": 53.5869797
        },
        "8782": {
            "name": "Орловка",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5817342,
            "latitude": 55.9079217
        },
        "8783": {
            "name": "Шарапово",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5866145,
            "latitude": 56.0804674
        },
        "8784": {
            "name": "Заготзерно",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5926647,
            "latitude": 55.6018315
        },
        "8785": {
            "name": "Ларионовка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.5951458,
            "latitude": 57.4846057
        },
        "8786": {
            "name": "Малочередово",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6021987,
            "latitude": 57.2024419
        },
        "8787": {
            "name": "Калиновка",
            "population": 231,
            "type": "hamlet",
            "poly": [
                [
                    73.5996521,
                    55.2056669
                ],
                [
                    73.5996596,
                    55.2058343
                ],
                [
                    73.6002915,
                    55.2058987
                ],
                [
                    73.6003893,
                    55.206182
                ],
                [
                    73.6009007,
                    55.2063708
                ],
                [
                    73.6008857,
                    55.2065082
                ],
                [
                    73.6022696,
                    55.206461
                ],
                [
                    73.6022772,
                    55.2060875
                ],
                [
                    73.6026684,
                    55.2060875
                ],
                [
                    73.6026984,
                    55.2059287
                ],
                [
                    73.6020591,
                    55.2058858
                ],
                [
                    73.6020892,
                    55.205697
                ],
                [
                    73.6036688,
                    55.205727
                ],
                [
                    73.6044736,
                    55.2053536
                ],
                [
                    73.6050753,
                    55.2052463
                ],
                [
                    73.6057222,
                    55.2050102
                ],
                [
                    73.6068279,
                    55.2049716
                ],
                [
                    73.6076854,
                    55.205139
                ],
                [
                    73.6088814,
                    55.2051519
                ],
                [
                    73.6099903,
                    55.2054261
                ],
                [
                    73.6126989,
                    55.2053737
                ],
                [
                    73.617244,
                    55.2049939
                ],
                [
                    73.6191951,
                    55.2048891
                ],
                [
                    73.6201822,
                    55.2046926
                ],
                [
                    73.6203658,
                    55.2045092
                ],
                [
                    73.6203658,
                    55.2042603
                ],
                [
                    73.6202051,
                    55.2036971
                ],
                [
                    73.6190344,
                    55.2037102
                ],
                [
                    73.6190115,
                    55.2035268
                ],
                [
                    73.6191492,
                    55.2034744
                ],
                [
                    73.6190802,
                    55.2028849
                ],
                [
                    73.618713,
                    55.203029
                ],
                [
                    73.6184835,
                    55.2029373
                ],
                [
                    73.6185294,
                    55.2027539
                ],
                [
                    73.6188049,
                    55.2024788
                ],
                [
                    73.6184835,
                    55.2024002
                ],
                [
                    73.6184375,
                    55.2018631
                ],
                [
                    73.6181851,
                    55.2016666
                ],
                [
                    73.6184835,
                    55.2013391
                ],
                [
                    73.6188049,
                    55.2013391
                ],
                [
                    73.6188327,
                    55.2009461
                ],
                [
                    73.6186402,
                    55.2009255
                ],
                [
                    73.6186462,
                    55.2006336
                ],
                [
                    73.6187966,
                    55.2006233
                ],
                [
                    73.6188086,
                    55.2000292
                ],
                [
                    73.6186041,
                    55.2000189
                ],
                [
                    73.6187003,
                    55.1987963
                ],
                [
                    73.6206921,
                    55.1987379
                ],
                [
                    73.6204695,
                    55.1983738
                ],
                [
                    73.6204695,
                    55.1981334
                ],
                [
                    73.6208064,
                    55.1979411
                ],
                [
                    73.6207944,
                    55.1976251
                ],
                [
                    73.620644,
                    55.1974294
                ],
                [
                    73.6196451,
                    55.1973985
                ],
                [
                    73.6195067,
                    55.1976938
                ],
                [
                    73.6179903,
                    55.1977522
                ],
                [
                    73.6169493,
                    55.1977762
                ],
                [
                    73.6169372,
                    55.1977041
                ],
                [
                    73.616516,
                    55.1977007
                ],
                [
                    73.6166664,
                    55.1965295
                ],
                [
                    73.614091,
                    55.1956468
                ],
                [
                    73.6128212,
                    55.1961655
                ],
                [
                    73.6117622,
                    55.1964883
                ],
                [
                    73.610998,
                    55.1967631
                ],
                [
                    73.6101374,
                    55.1971649
                ],
                [
                    73.6076643,
                    55.1948225
                ],
                [
                    73.6021569,
                    55.1955361
                ],
                [
                    73.6016755,
                    55.195257
                ],
                [
                    73.6010737,
                    55.195506
                ],
                [
                    73.6012542,
                    55.1957593
                ],
                [
                    73.6012091,
                    55.1958924
                ],
                [
                    73.6011038,
                    55.1960427
                ],
                [
                    73.6002539,
                    55.1967768
                ],
                [
                    73.6008556,
                    55.197322
                ],
                [
                    73.601668,
                    55.1969185
                ],
                [
                    73.6014273,
                    55.196575
                ],
                [
                    73.6024277,
                    55.1963604
                ],
                [
                    73.6034882,
                    55.197043
                ],
                [
                    73.6037139,
                    55.1975281
                ],
                [
                    73.6021794,
                    55.1977041
                ],
                [
                    73.6024653,
                    55.1980175
                ],
                [
                    73.6027661,
                    55.199563
                ],
                [
                    73.605316,
                    55.1993784
                ],
                [
                    73.6059704,
                    55.2024476
                ],
                [
                    73.6025931,
                    55.2029456
                ],
                [
                    73.6029166,
                    55.2035637
                ],
                [
                    73.6008705,
                    55.2035723
                ],
                [
                    73.60066,
                    55.2045853
                ],
                [
                    73.6013821,
                    55.2048085
                ],
                [
                    73.6020666,
                    55.2048471
                ],
                [
                    73.6020741,
                    55.2051218
                ],
                [
                    73.6034581,
                    55.205169
                ],
                [
                    73.6034356,
                    55.205345
                ],
                [
                    73.6017281,
                    55.2053364
                ],
                [
                    73.5996521,
                    55.2056669
                ]
            ],
            "longitude": 73.6149278,
            "latitude": 55.2029965
        },
        "8788": {
            "name": "Александрино",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6208739,
            "latitude": 56.9712432
        },
        "8789": {
            "name": "Максимовка",
            "population": 109,
            "type": "hamlet",
            "poly": [
                [
                    73.6272695,
                    55.4632054
                ],
                [
                    73.6298772,
                    55.4633964
                ],
                [
                    73.6304032,
                    55.4615218
                ],
                [
                    73.634997,
                    55.4619218
                ],
                [
                    73.6357189,
                    55.4597079
                ],
                [
                    73.6360962,
                    55.4589172
                ],
                [
                    73.636736,
                    55.4575869
                ],
                [
                    73.6367623,
                    55.4566715
                ],
                [
                    73.6365655,
                    55.4558528
                ],
                [
                    73.6364867,
                    55.4531065
                ],
                [
                    73.6364342,
                    55.4529725
                ],
                [
                    73.6351348,
                    55.4522356
                ],
                [
                    73.6324311,
                    55.4516735
                ],
                [
                    73.6281906,
                    55.4522222
                ],
                [
                    73.6272695,
                    55.4632054
                ]
            ],
            "longitude": 73.631607,
            "latitude": 55.45787
        },
        "8790": {
            "name": "Чучкино",
            "population": 265,
            "type": "hamlet",
            "poly": [
                [
                    73.6261083,
                    55.4201604
                ],
                [
                    73.6273363,
                    55.422433
                ],
                [
                    73.6294719,
                    55.4225845
                ],
                [
                    73.6351313,
                    55.4230389
                ],
                [
                    73.6368397,
                    55.4236449
                ],
                [
                    73.6383881,
                    55.4232813
                ],
                [
                    73.6395938,
                    55.4225379
                ],
                [
                    73.6449097,
                    55.4228831
                ],
                [
                    73.6503448,
                    55.4228853
                ],
                [
                    73.6486548,
                    55.4177788
                ],
                [
                    73.6481584,
                    55.4170082
                ],
                [
                    73.6411306,
                    55.4155964
                ],
                [
                    73.6315007,
                    55.4149481
                ],
                [
                    73.6262685,
                    55.4177665
                ],
                [
                    73.6261083,
                    55.4201604
                ]
            ],
            "longitude": 73.637268,
            "latitude": 55.419403
        },
        "8791": {
            "name": "Крупянка",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6394959,
            "latitude": 55.5973633
        },
        "8792": {
            "name": "Владимировка",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.640518,
            "latitude": 56.140335
        },
        "8793": {
            "name": "Пальцевка",
            "population": 191,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6420649,
            "latitude": 54.4822423
        },
        "8794": {
            "name": "18 Партсъезд",
            "population": 234,
            "type": "hamlet",
            "poly": [
                [
                    73.634462,
                    55.1163627
                ],
                [
                    73.6390907,
                    55.1192381
                ],
                [
                    73.6460959,
                    55.1151879
                ],
                [
                    73.6470786,
                    55.114481
                ],
                [
                    73.6497425,
                    55.1158948
                ],
                [
                    73.6509171,
                    55.1162988
                ],
                [
                    73.6516156,
                    55.116448
                ],
                [
                    73.652391,
                    55.1164788
                ],
                [
                    73.6529131,
                    55.1163471
                ],
                [
                    73.6532662,
                    55.1160924
                ],
                [
                    73.6541798,
                    55.1142308
                ],
                [
                    73.6543947,
                    55.1139059
                ],
                [
                    73.6555539,
                    55.1127379
                ],
                [
                    73.6544945,
                    55.1123603
                ],
                [
                    73.6543717,
                    55.1122154
                ],
                [
                    73.6538036,
                    55.1118729
                ],
                [
                    73.6535886,
                    55.1113372
                ],
                [
                    73.6520379,
                    55.1111791
                ],
                [
                    73.6507328,
                    55.1099276
                ],
                [
                    73.6481073,
                    55.1085619
                ],
                [
                    73.6474164,
                    55.1091503
                ],
                [
                    73.6472398,
                    55.1096202
                ],
                [
                    73.6468406,
                    55.1098925
                ],
                [
                    73.644384,
                    55.1110342
                ],
                [
                    73.6425722,
                    55.1120529
                ],
                [
                    73.6414053,
                    55.1125139
                ],
                [
                    73.6400081,
                    55.1133087
                ],
                [
                    73.6371062,
                    55.114683
                ],
                [
                    73.6363309,
                    55.1151572
                ],
                [
                    73.635993,
                    55.1155655
                ],
                [
                    73.6358395,
                    55.1159431
                ],
                [
                    73.6355018,
                    55.1161671
                ],
                [
                    73.6351102,
                    55.1162812
                ],
                [
                    73.634462,
                    55.1163627
                ]
            ],
            "longitude": 73.643478,
            "latitude": 55.114075
        },
        "8795": {
            "name": "Густафьево",
            "population": 188,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6550236,
            "latitude": 54.9533765
        },
        "8796": {
            "name": "Берёзовка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6562896,
            "latitude": 54.8571398
        },
        "8797": {
            "name": "Гончаровка",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6575518,
            "latitude": 54.4267849
        },
        "8798": {
            "name": "Новотелегино",
            "population": 160,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6598938,
            "latitude": 54.6476697
        },
        "8799": {
            "name": "Халдеевка",
            "population": 200,
            "type": "hamlet",
            "poly": [
                [
                    73.6499156,
                    55.3257347
                ],
                [
                    73.6505461,
                    55.3292265
                ],
                [
                    73.6527407,
                    55.3292281
                ],
                [
                    73.6533967,
                    55.3291192
                ],
                [
                    73.6538888,
                    55.329368
                ],
                [
                    73.6534514,
                    55.3299589
                ],
                [
                    73.6536974,
                    55.3306276
                ],
                [
                    73.6545175,
                    55.3315735
                ],
                [
                    73.6603947,
                    55.3316694
                ],
                [
                    73.6599573,
                    55.3311251
                ],
                [
                    73.6598753,
                    55.3305498
                ],
                [
                    73.6617068,
                    55.330612
                ],
                [
                    73.6618884,
                    55.330285
                ],
                [
                    73.6642856,
                    55.3327609
                ],
                [
                    73.6653305,
                    55.3331298
                ],
                [
                    73.6707693,
                    55.3322464
                ],
                [
                    73.6682955,
                    55.3279455
                ],
                [
                    73.666263,
                    55.3243068
                ],
                [
                    73.6622521,
                    55.3243092
                ],
                [
                    73.658354,
                    55.3242617
                ],
                [
                    73.652781,
                    55.3243383
                ],
                [
                    73.652869,
                    55.3251321
                ],
                [
                    73.6524449,
                    55.3251966
                ],
                [
                    73.6524486,
                    55.3254749
                ],
                [
                    73.6514723,
                    55.3255456
                ],
                [
                    73.6506591,
                    55.3257482
                ],
                [
                    73.6499156,
                    55.3257347
                ]
            ],
            "longitude": 73.6604686,
            "latitude": 55.3276606
        },
        "8800": {
            "name": "Кондрашино",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.661348,
            "latitude": 57.1514226
        },
        "8801": {
            "name": "Берёзовка",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    73.6507402,
                    55.4896837
                ],
                [
                    73.6557954,
                    55.4930752
                ],
                [
                    73.6594537,
                    55.4961084
                ],
                [
                    73.6655066,
                    55.4998572
                ],
                [
                    73.6672717,
                    55.4987557
                ],
                [
                    73.6710274,
                    55.4964286
                ],
                [
                    73.6537667,
                    55.4878559
                ],
                [
                    73.652978,
                    55.4883221
                ],
                [
                    73.6507402,
                    55.4896837
                ]
            ],
            "longitude": 73.6613827,
            "latitude": 55.4939983
        },
        "8802": {
            "name": "Никольск",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6690738,
            "latitude": 57.0606819
        },
        "8803": {
            "name": "Дубровка",
            "population": 236,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6727451,
            "latitude": 55.5124277
        },
        "8804": {
            "name": "Трещеткино",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.674271,
            "latitude": 56.4713683
        },
        "8805": {
            "name": "Пушкарево",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6777424,
            "latitude": 57.1393155
        },
        "8806": {
            "name": "Черналы",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1736882,
            "latitude": 56.3226739
        },
        "8807": {
            "name": "Максим Горький",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6835448,
            "latitude": 57.2550153
        },
        "8808": {
            "name": "Ярмоклеевка",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.6862843,
            "latitude": 54.3340278
        },
        "8809": {
            "name": "Якушино",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7014131,
            "latitude": 57.1654238
        },
        "8810": {
            "name": "Новокоролёвка",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    73.6916066,
                    55.3964569
                ],
                [
                    73.6920976,
                    55.3976972
                ],
                [
                    73.6942458,
                    55.3974744
                ],
                [
                    73.6942994,
                    55.3980105
                ],
                [
                    73.6993954,
                    55.3978643
                ],
                [
                    73.6993417,
                    55.3983273
                ],
                [
                    73.702397,
                    55.3986201
                ],
                [
                    73.703869,
                    55.3982237
                ],
                [
                    73.7038827,
                    55.3979805
                ],
                [
                    73.704166,
                    55.3978906
                ],
                [
                    73.7045544,
                    55.3979841
                ],
                [
                    73.7053305,
                    55.3975641
                ],
                [
                    73.7060115,
                    55.3969394
                ],
                [
                    73.7065825,
                    55.3969705
                ],
                [
                    73.7073252,
                    55.3961996
                ],
                [
                    73.7062781,
                    55.3959707
                ],
                [
                    73.7052139,
                    55.3954308
                ],
                [
                    73.7082051,
                    55.3926573
                ],
                [
                    73.7065445,
                    55.3909977
                ],
                [
                    73.7069481,
                    55.3908331
                ],
                [
                    73.7063258,
                    55.3904431
                ],
                [
                    73.7056929,
                    55.3906869
                ],
                [
                    73.7055534,
                    55.3906381
                ],
                [
                    73.7057036,
                    55.3902725
                ],
                [
                    73.7061542,
                    55.3899496
                ],
                [
                    73.7060898,
                    55.3897729
                ],
                [
                    73.705489,
                    55.3897302
                ],
                [
                    73.7049741,
                    55.3895779
                ],
                [
                    73.7049848,
                    55.389389
                ],
                [
                    73.7055319,
                    55.3891635
                ],
                [
                    73.7049633,
                    55.3884505
                ],
                [
                    73.7044054,
                    55.3885785
                ],
                [
                    73.704384,
                    55.3886577
                ],
                [
                    73.7039046,
                    55.3888241
                ],
                [
                    73.7037832,
                    55.3886882
                ],
                [
                    73.7039441,
                    55.3885724
                ],
                [
                    73.7037081,
                    55.3883104
                ],
                [
                    73.7038154,
                    55.3881641
                ],
                [
                    73.7036974,
                    55.3877254
                ],
                [
                    73.7026771,
                    55.3874268
                ],
                [
                    73.7013908,
                    55.3873963
                ],
                [
                    73.7008544,
                    55.3875121
                ],
                [
                    73.7005326,
                    55.3876949
                ],
                [
                    73.7000498,
                    55.3877071
                ],
                [
                    73.6995992,
                    55.3879752
                ],
                [
                    73.6992237,
                    55.3879752
                ],
                [
                    73.6989555,
                    55.3878716
                ],
                [
                    73.6984942,
                    55.3880423
                ],
                [
                    73.6981616,
                    55.388286
                ],
                [
                    73.6984191,
                    55.3886212
                ],
                [
                    73.6982582,
                    55.3887126
                ],
                [
                    73.6980114,
                    55.3888649
                ],
                [
                    73.6979792,
                    55.3890904
                ],
                [
                    73.6981723,
                    55.3894438
                ],
                [
                    73.6978183,
                    55.3895535
                ],
                [
                    73.6975715,
                    55.3895047
                ],
                [
                    73.6974965,
                    55.3892915
                ],
                [
                    73.697121,
                    55.3892854
                ],
                [
                    73.6967777,
                    55.389456
                ],
                [
                    73.6968742,
                    55.3895474
                ],
                [
                    73.6974106,
                    55.3895474
                ],
                [
                    73.697475,
                    55.3896266
                ],
                [
                    73.6971746,
                    55.3899313
                ],
                [
                    73.6967346,
                    55.3899191
                ],
                [
                    73.6959516,
                    55.3901446
                ],
                [
                    73.6955225,
                    55.3901568
                ],
                [
                    73.6952757,
                    55.390303
                ],
                [
                    73.6952113,
                    55.3905589
                ],
                [
                    73.6945784,
                    55.3909428
                ],
                [
                    73.6950826,
                    55.3912231
                ],
                [
                    73.6940934,
                    55.3917908
                ],
                [
                    73.6946213,
                    55.3920823
                ],
                [
                    73.6948358,
                    55.3919665
                ],
                [
                    73.6950719,
                    55.3920457
                ],
                [
                    73.6953937,
                    55.3918446
                ],
                [
                    73.6958443,
                    55.3920579
                ],
                [
                    73.6961876,
                    55.3919056
                ],
                [
                    73.6962412,
                    55.3917959
                ],
                [
                    73.6973677,
                    55.3913145
                ],
                [
                    73.697711,
                    55.3916314
                ],
                [
                    73.6975715,
                    55.3919909
                ],
                [
                    73.6973998,
                    55.3922894
                ],
                [
                    73.6967991,
                    55.3926124
                ],
                [
                    73.6972958,
                    55.3929725
                ],
                [
                    73.6969708,
                    55.3932399
                ],
                [
                    73.6964022,
                    55.3932582
                ],
                [
                    73.6961554,
                    55.3931668
                ],
                [
                    73.696016,
                    55.3934288
                ],
                [
                    73.6954152,
                    55.3937639
                ],
                [
                    73.6952221,
                    55.3939041
                ],
                [
                    73.695147,
                    55.3942636
                ],
                [
                    73.6947638,
                    55.3944194
                ],
                [
                    73.6942136,
                    55.3944707
                ],
                [
                    73.6929047,
                    55.3955004
                ],
                [
                    73.6924971,
                    55.3957258
                ],
                [
                    73.6916817,
                    55.3961767
                ],
                [
                    73.6916066,
                    55.3964569
                ]
            ],
            "longitude": 73.7038023,
            "latitude": 55.3933058
        },
        "8811": {
            "name": "Трусовка",
            "population": 142,
            "type": "hamlet",
            "poly": [
                [
                    73.7001612,
                    55.2447982
                ],
                [
                    73.7002981,
                    55.2456042
                ],
                [
                    73.7073565,
                    55.2478881
                ],
                [
                    73.7091631,
                    55.2478594
                ],
                [
                    73.7145426,
                    55.2485872
                ],
                [
                    73.7167469,
                    55.2489784
                ],
                [
                    73.7170347,
                    55.2453709
                ],
                [
                    73.7174842,
                    55.2451646
                ],
                [
                    73.7180077,
                    55.2450137
                ],
                [
                    73.719151,
                    55.2449451
                ],
                [
                    73.7189043,
                    55.2439537
                ],
                [
                    73.7150892,
                    55.2438577
                ],
                [
                    73.7144409,
                    55.2406942
                ],
                [
                    73.7142793,
                    55.2394378
                ],
                [
                    73.7142205,
                    55.238818
                ],
                [
                    73.7142793,
                    55.2382903
                ],
                [
                    73.7148816,
                    55.2372684
                ],
                [
                    73.7152929,
                    55.2369584
                ],
                [
                    73.714147,
                    55.2369166
                ],
                [
                    73.7132215,
                    55.2366401
                ],
                [
                    73.7121491,
                    55.2366066
                ],
                [
                    73.7113851,
                    55.2366736
                ],
                [
                    73.7102392,
                    55.2368663
                ],
                [
                    73.7082413,
                    55.2370087
                ],
                [
                    73.7061845,
                    55.2370925
                ],
                [
                    73.7049064,
                    55.2370422
                ],
                [
                    73.7036136,
                    55.2369668
                ],
                [
                    73.703643,
                    55.2376286
                ],
                [
                    73.7035401,
                    55.2377626
                ],
                [
                    73.7031582,
                    55.2380055
                ],
                [
                    73.7031875,
                    55.2388515
                ],
                [
                    73.7033344,
                    55.2389855
                ],
                [
                    73.7036283,
                    55.2390442
                ],
                [
                    73.7040396,
                    55.2392787
                ],
                [
                    73.7042453,
                    55.2404178
                ],
                [
                    73.7041718,
                    55.2408617
                ],
                [
                    73.7037457,
                    55.2413727
                ],
                [
                    73.7025411,
                    55.2422772
                ],
                [
                    73.7022326,
                    55.2426206
                ],
                [
                    73.701836,
                    55.2428467
                ],
                [
                    73.7010279,
                    55.2431734
                ],
                [
                    73.7001812,
                    55.244145
                ],
                [
                    73.7001612,
                    55.2447982
                ]
            ],
            "longitude": 73.708803,
            "latitude": 55.242726
        },
        "8812": {
            "name": "Травкино",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    73.7064986,
                    54.9767638
                ],
                [
                    73.7071797,
                    54.9769581
                ],
                [
                    73.707602,
                    54.9770149
                ],
                [
                    73.7075183,
                    54.9771415
                ],
                [
                    73.7069666,
                    54.97748
                ],
                [
                    73.7067878,
                    54.9777311
                ],
                [
                    73.7066622,
                    54.978159
                ],
                [
                    73.7073294,
                    54.9783451
                ],
                [
                    73.7083625,
                    54.9783698
                ],
                [
                    73.7105793,
                    54.9785798
                ],
                [
                    73.7120214,
                    54.978586
                ],
                [
                    73.7122904,
                    54.9785489
                ],
                [
                    73.7123442,
                    54.9770729
                ],
                [
                    73.7120967,
                    54.9768135
                ],
                [
                    73.7121613,
                    54.9736945
                ],
                [
                    73.7120967,
                    54.9730892
                ],
                [
                    73.7130652,
                    54.9730151
                ],
                [
                    73.7132481,
                    54.9729533
                ],
                [
                    73.7132051,
                    54.9711929
                ],
                [
                    73.7129468,
                    54.9709088
                ],
                [
                    73.7081365,
                    54.9711929
                ],
                [
                    73.7083517,
                    54.9723603
                ],
                [
                    73.7079859,
                    54.9721936
                ],
                [
                    73.7069205,
                    54.9722183
                ],
                [
                    73.7073509,
                    54.9730089
                ],
                [
                    73.7076307,
                    54.9730398
                ],
                [
                    73.7074908,
                    54.9743924
                ],
                [
                    73.7069528,
                    54.9743862
                ],
                [
                    73.7068452,
                    54.975078
                ],
                [
                    73.7065976,
                    54.9750718
                ],
                [
                    73.7065976,
                    54.9754115
                ],
                [
                    73.7065253,
                    54.9754143
                ],
                [
                    73.7064986,
                    54.9767638
                ]
            ],
            "longitude": 73.7088105,
            "latitude": 54.976621
        },
        "8813": {
            "name": "Усть-Заостровское Лесничес",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7098017,
            "latitude": 54.7576328
        },
        "8814": {
            "name": "2733 км",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7104259,
            "latitude": 54.9578754
        },
        "8815": {
            "name": "Там-Чилик",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7121965,
            "latitude": 53.7350158
        },
        "8816": {
            "name": "Сафоново",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7208504,
            "latitude": 56.1860781
        },
        "8817": {
            "name": "Усть-Тамак",
            "population": 163,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7267841,
            "latitude": 57.2473941
        },
        "8818": {
            "name": "Пограничное",
            "population": 162,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7303383,
            "latitude": 53.8362414
        },
        "8819": {
            "name": "Казырлы",
            "population": 66,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7314557,
            "latitude": 55.8323093
        },
        "8820": {
            "name": "Тоскино",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7372077,
            "latitude": 56.62207
        },
        "8821": {
            "name": "Богочаново",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7424435,
            "latitude": 57.162547
        },
        "8822": {
            "name": "Чеченево",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7457497,
            "latitude": 56.8743065
        },
        "8823": {
            "name": "Новооболонь",
            "population": 206,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7509069,
            "latitude": 55.5874189
        },
        "8824": {
            "name": "Андриановка",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7524644,
            "latitude": 53.805253
        },
        "8825": {
            "name": "Горькое",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7617988,
            "latitude": 56.0100456
        },
        "8826": {
            "name": "2737 км",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7636858,
            "latitude": 54.9645746
        },
        "8827": {
            "name": "Вперед",
            "population": 201,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.763821,
            "latitude": 55.0898296
        },
        "8828": {
            "name": "Чернышеевка",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7667227,
            "latitude": 55.532859
        },
        "8829": {
            "name": "Егорьевка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7698741,
            "latitude": 55.1693145
        },
        "8830": {
            "name": "Зелёная Роща",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7728306,
            "latitude": 54.9275446
        },
        "8831": {
            "name": "Яланкуль",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7764229,
            "latitude": 56.1144986
        },
        "8832": {
            "name": "Нива",
            "population": 238,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7812887,
            "latitude": 54.7516814
        },
        "8833": {
            "name": "Кириллино",
            "population": 208,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7827239,
            "latitude": 56.8845326
        },
        "8834": {
            "name": "Кайдаул",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7875352,
            "latitude": 54.1348671
        },
        "8835": {
            "name": "Озёрное",
            "population": 228,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7885511,
            "latitude": 53.9264369
        },
        "8836": {
            "name": "Щербаково",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7906992,
            "latitude": 57.0689109
        },
        "8837": {
            "name": "Солдатка",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7917159,
            "latitude": 57.1495482
        },
        "8838": {
            "name": "Николаевка",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7920689,
            "latitude": 55.5028225
        },
        "8839": {
            "name": "СибНИВИ",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7924932,
            "latitude": 55.0771597
        },
        "8840": {
            "name": "Развязка",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7945552,
            "latitude": 54.9821851
        },
        "8841": {
            "name": "Вороновка",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.7978063,
            "latitude": 56.4573594
        },
        "8842": {
            "name": "Крутиха",
            "population": 154,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8050028,
            "latitude": 55.5998041
        },
        "8843": {
            "name": "Невольное",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8069657,
            "latitude": 53.7257936
        },
        "8844": {
            "name": "Новоивановка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.81005,
            "latitude": 53.7931777
        },
        "8845": {
            "name": "Заготзерно (Пристань)",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8132652,
            "latitude": 57.1504302
        },
        "8846": {
            "name": "Прудки",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8157157,
            "latitude": 55.030271
        },
        "8847": {
            "name": "Тимино",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8287951,
            "latitude": 56.9415182
        },
        "8848": {
            "name": "Новолюблинка",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1736592,
            "latitude": 54.1406376
        },
        "8849": {
            "name": "Степановка",
            "population": 119,
            "type": "hamlet",
            "poly": [
                [
                    73.8253663,
                    55.2078957
                ],
                [
                    73.8264918,
                    55.2084571
                ],
                [
                    73.8266627,
                    55.2096659
                ],
                [
                    73.8269703,
                    55.2098998
                ],
                [
                    73.8268678,
                    55.2105627
                ],
                [
                    73.8275512,
                    55.2108941
                ],
                [
                    73.8270386,
                    55.2123368
                ],
                [
                    73.8282687,
                    55.2126682
                ],
                [
                    73.828327,
                    55.2135723
                ],
                [
                    73.8307753,
                    55.2137115
                ],
                [
                    73.8307289,
                    55.2127267
                ],
                [
                    73.8310365,
                    55.2124732
                ],
                [
                    73.831344,
                    55.211557
                ],
                [
                    73.8324374,
                    55.2113425
                ],
                [
                    73.831754,
                    55.2107186
                ],
                [
                    73.8335992,
                    55.2076772
                ],
                [
                    73.8350343,
                    55.2077747
                ],
                [
                    73.835581,
                    55.2053374
                ],
                [
                    73.8350685,
                    55.203836
                ],
                [
                    73.8360936,
                    55.203563
                ],
                [
                    73.8363643,
                    55.2026361
                ],
                [
                    73.8337878,
                    55.2024149
                ],
                [
                    73.833416,
                    55.2031262
                ],
                [
                    73.8309189,
                    55.2028993
                ],
                [
                    73.8304491,
                    55.2034843
                ],
                [
                    73.8278621,
                    55.2032352
                ],
                [
                    73.8269894,
                    55.2039474
                ],
                [
                    73.8264769,
                    55.2048492
                ],
                [
                    73.8256653,
                    55.2064091
                ],
                [
                    73.8259216,
                    55.2067503
                ],
                [
                    73.8253663,
                    55.2078957
                ]
            ],
            "longitude": 73.8305264,
            "latitude": 55.207208
        },
        "8850": {
            "name": "Аксаковка",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8429024,
            "latitude": 54.9136717
        },
        "8851": {
            "name": "Константиноградка",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8472486,
            "latitude": 54.2004865
        },
        "8852": {
            "name": "Сыропятская",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.84903,
            "latitude": 55.039452
        },
        "8853": {
            "name": "Агафоновка",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.862755,
            "latitude": 55.525421
        },
        "8854": {
            "name": "Сыропятское",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.864838,
            "latitude": 54.975552
        },
        "8855": {
            "name": "Русская Поляна",
            "population": 251,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8716552,
            "latitude": 53.7563372
        },
        "8856": {
            "name": "Николенко",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.8719225,
            "latitude": 54.7942562
        },
        "8857": {
            "name": "Новая",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.891784,
            "latitude": 54.842881
        },
        "8858": {
            "name": "Русиново",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9068611,
            "latitude": 55.8871891
        },
        "8859": {
            "name": "Сосновка",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9070321,
            "latitude": 55.637082
        },
        "8860": {
            "name": "Малая Кова",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9100406,
            "latitude": 57.1695206
        },
        "8861": {
            "name": "Камышино",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9175269,
            "latitude": 54.1428311
        },
        "8862": {
            "name": "Топольки",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.918985,
            "latitude": 54.3968751
        },
        "8863": {
            "name": "Шкуново",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9289504,
            "latitude": 56.8296842
        },
        "8864": {
            "name": "Бузан",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.936813,
            "latitude": 53.93095
        },
        "8865": {
            "name": "Кирибай",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9446094,
            "latitude": 54.2845935
        },
        "8866": {
            "name": "Кабурлы",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9449188,
            "latitude": 56.2082154
        },
        "8867": {
            "name": "Смирновка",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9481523,
            "latitude": 54.7770608
        },
        "8868": {
            "name": "Большетерехино",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9485914,
            "latitude": 56.6084843
        },
        "8869": {
            "name": "Станкеевка",
            "population": 244,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9509995,
            "latitude": 54.9289383
        },
        "8870": {
            "name": "Черново",
            "population": 198,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9513459,
            "latitude": 55.8423071
        },
        "8871": {
            "name": "Кубрино",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9524434,
            "latitude": 56.8643439
        },
        "8872": {
            "name": "Чистоозёрье",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9566674,
            "latitude": 55.8072078
        },
        "8873": {
            "name": "Корниловка",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9583772,
            "latitude": 55.0233761
        },
        "8874": {
            "name": "Солоновка",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9667855,
            "latitude": 54.5831193
        },
        "8875": {
            "name": "Байкал",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.966881,
            "latitude": 55.09428
        },
        "8876": {
            "name": "Дубровка",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9682161,
            "latitude": 55.1450474
        },
        "8877": {
            "name": "Михайловка",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.985104,
            "latitude": 56.8840898
        },
        "8878": {
            "name": "Черноозёрье",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9866818,
            "latitude": 55.7422712
        },
        "8879": {
            "name": "Аксеновка",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 73.9972539,
            "latitude": 55.4506656
        },
        "8880": {
            "name": "Коновалово",
            "population": 89,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0007646,
            "latitude": 56.8066988
        },
        "8881": {
            "name": "Малые Туралы",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0045978,
            "latitude": 56.736327
        },
        "8882": {
            "name": "Уваровка",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0080399,
            "latitude": 56.0066386
        },
        "8883": {
            "name": "Краснодарка",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0224153,
            "latitude": 54.251924
        },
        "8884": {
            "name": "Северная",
            "population": 240,
            "type": "hamlet",
            "poly": [
                [
                    74.0273063,
                    55.5737465
                ],
                [
                    74.0291469,
                    55.580589
                ],
                [
                    74.0331084,
                    55.5804081
                ],
                [
                    74.0402977,
                    55.5787305
                ],
                [
                    74.0408846,
                    55.5769587
                ],
                [
                    74.0422584,
                    55.576887
                ],
                [
                    74.0438056,
                    55.5748248
                ],
                [
                    74.0450328,
                    55.5747644
                ],
                [
                    74.0450861,
                    55.5741046
                ],
                [
                    74.038257,
                    55.5743723
                ],
                [
                    74.0273063,
                    55.5737465
                ]
            ],
            "longitude": 74.0357143,
            "latitude": 55.5764036
        },
        "8885": {
            "name": "Плотниково",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0398182,
            "latitude": 56.3569136
        },
        "8886": {
            "name": "Михеевка",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0403082,
            "latitude": 55.1110144
        },
        "8887": {
            "name": "Новая Деревня",
            "population": 169,
            "type": "hamlet",
            "poly": [
                [
                    74.0390002,
                    54.9816335
                ],
                [
                    74.0394024,
                    54.9827946
                ],
                [
                    74.0400241,
                    54.9828926
                ],
                [
                    74.0404751,
                    54.9828856
                ],
                [
                    74.0408773,
                    54.9829415
                ],
                [
                    74.0409139,
                    54.9830394
                ],
                [
                    74.0412674,
                    54.9831234
                ],
                [
                    74.04234,
                    54.9830185
                ],
                [
                    74.0428154,
                    54.9828506
                ],
                [
                    74.0428763,
                    54.9826547
                ],
                [
                    74.0428763,
                    54.9821721
                ],
                [
                    74.0430592,
                    54.9818504
                ],
                [
                    74.0430714,
                    54.9816056
                ],
                [
                    74.0431811,
                    54.9815146
                ],
                [
                    74.043437,
                    54.9813747
                ],
                [
                    74.0434614,
                    54.9812698
                ],
                [
                    74.0434736,
                    54.981046
                ],
                [
                    74.0436686,
                    54.9806892
                ],
                [
                    74.0435833,
                    54.9804165
                ],
                [
                    74.0437296,
                    54.9802346
                ],
                [
                    74.0439612,
                    54.9801437
                ],
                [
                    74.0438515,
                    54.9798708
                ],
                [
                    74.044144,
                    54.9795561
                ],
                [
                    74.0444609,
                    54.9788985
                ],
                [
                    74.0449851,
                    54.9785278
                ],
                [
                    74.0450826,
                    54.9781361
                ],
                [
                    74.0461918,
                    54.9757576
                ],
                [
                    74.0470085,
                    54.9736728
                ],
                [
                    74.0442537,
                    54.9732811
                ],
                [
                    74.0439368,
                    54.9735399
                ],
                [
                    74.0436565,
                    54.9738967
                ],
                [
                    74.0417549,
                    54.9738337
                ],
                [
                    74.0415599,
                    54.9740296
                ],
                [
                    74.0410236,
                    54.975114
                ],
                [
                    74.0408895,
                    54.9752819
                ],
                [
                    74.0407554,
                    54.9758066
                ],
                [
                    74.0409139,
                    54.9759395
                ],
                [
                    74.0416452,
                    54.9760794
                ],
                [
                    74.0409017,
                    54.9771987
                ],
                [
                    74.0401703,
                    54.9777723
                ],
                [
                    74.0395974,
                    54.9789895
                ],
                [
                    74.0393902,
                    54.9792903
                ],
                [
                    74.039439,
                    54.9795771
                ],
                [
                    74.0390002,
                    54.9816335
                ]
            ],
            "longitude": 74.0433421,
            "latitude": 54.9787357
        },
        "8888": {
            "name": "Розовка",
            "population": 259,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0444856,
            "latitude": 53.8483412
        },
        "8889": {
            "name": "Волотовка",
            "population": 257,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0459422,
            "latitude": 53.812178
        },
        "8890": {
            "name": "Комсомол",
            "population": 262,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.045946,
            "latitude": 54.6455773
        },
        "8891": {
            "name": "Поморцево",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.051181,
            "latitude": 56.6522899
        },
        "8892": {
            "name": "Мамешево",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0545954,
            "latitude": 57.0933602
        },
        "8893": {
            "name": "Салтыковка",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0637443,
            "latitude": 54.9090423
        },
        "8894": {
            "name": "Большое Озеро",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0662769,
            "latitude": 55.2495674
        },
        "8895": {
            "name": "Свидерск",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0685004,
            "latitude": 56.6742756
        },
        "8896": {
            "name": "Мясники",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0814219,
            "latitude": 56.2608217
        },
        "8897": {
            "name": "Спайка",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0922126,
            "latitude": 54.715241
        },
        "8898": {
            "name": "Никитино",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0942919,
            "latitude": 55.0322407
        },
        "8899": {
            "name": "Каракуль",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.0956932,
            "latitude": 56.3171489
        },
        "8900": {
            "name": "Курманово",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.098016,
            "latitude": 57.0197041
        },
        "8901": {
            "name": "Сосновка",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1011628,
            "latitude": 54.497044
        },
        "8902": {
            "name": "Сибиляково",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1044723,
            "latitude": 57.0341891
        },
        "8903": {
            "name": "Юрлагино",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1044988,
            "latitude": 56.9978442
        },
        "8904": {
            "name": "Большие Кучки",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1102487,
            "latitude": 56.7131314
        },
        "8905": {
            "name": "Сухокарасук",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.113686,
            "latitude": 56.0835434
        },
        "8906": {
            "name": "Пятилетка",
            "population": 212,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.115321,
            "latitude": 57.1319213
        },
        "8907": {
            "name": "Копейкино",
            "population": 204,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1200787,
            "latitude": 56.9812223
        },
        "8908": {
            "name": "Любимово",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1237666,
            "latitude": 56.7028264
        },
        "8909": {
            "name": "Новороссийка",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1255673,
            "latitude": 54.8390925
        },
        "8910": {
            "name": "Отделение № 4 Опытного Хозя",
            "population": 244,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1417909,
            "latitude": 54.2984185
        },
        "8911": {
            "name": "Саратово",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1480447,
            "latitude": 55.7015585
        },
        "8912": {
            "name": "Спасское",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1550607,
            "latitude": 55.2157108
        },
        "8913": {
            "name": "Куйгалы",
            "population": 227,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1600423,
            "latitude": 56.2197297
        },
        "8914": {
            "name": "Исаевка",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1616318,
            "latitude": 55.3054178
        },
        "8915": {
            "name": "Петрово",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1760327,
            "latitude": 56.9560822
        },
        "8916": {
            "name": "Вяжевка",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.17896,
            "latitude": 55.3808911
        },
        "8917": {
            "name": "Устюгово",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1848145,
            "latitude": 56.5775488
        },
        "8918": {
            "name": "Тимирка",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.1976267,
            "latitude": 57.2059813
        },
        "8919": {
            "name": "Самаринка",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2000143,
            "latitude": 55.0506391
        },
        "8920": {
            "name": "Игнатьево",
            "population": 89,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2023866,
            "latitude": 55.0574249
        },
        "8921": {
            "name": "Золотухино",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2129895,
            "latitude": 54.2077815
        },
        "8922": {
            "name": "Сеитово",
            "population": 208,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.214554,
            "latitude": 56.9986987
        },
        "8923": {
            "name": "Добролюбовка",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2195309,
            "latitude": 56.1202242
        },
        "8924": {
            "name": "2767 км",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2286448,
            "latitude": 55.0115052
        },
        "8925": {
            "name": "Моховое Озеро",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2298354,
            "latitude": 55.9311853
        },
        "8926": {
            "name": "Лоскутово",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.230639,
            "latitude": 56.8719578
        },
        "8927": {
            "name": "Зотино",
            "population": 209,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2386674,
            "latitude": 55.0689399
        },
        "8928": {
            "name": "Согра",
            "population": 228,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2403393,
            "latitude": 55.7125465
        },
        "8929": {
            "name": "1-я Фоминовка",
            "population": 160,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2598837,
            "latitude": 54.832271
        },
        "8930": {
            "name": "Новоюрьево",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2630931,
            "latitude": 55.2429333
        },
        "8931": {
            "name": "Кольцово",
            "population": 150,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.276195,
            "latitude": 55.1545612
        },
        "8932": {
            "name": "Круглово",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2782922,
            "latitude": 55.1341414
        },
        "8933": {
            "name": "Каратал",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2843972,
            "latitude": 53.9923207
        },
        "8934": {
            "name": "2771 км",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2874807,
            "latitude": 55.0153176
        },
        "8935": {
            "name": "Боровянка",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2887062,
            "latitude": 55.7337577
        },
        "8936": {
            "name": "Аэропорт",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2887865,
            "latitude": 56.9049183
        },
        "8937": {
            "name": "Красная Тула",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.2949224,
            "latitude": 54.6422345
        },
        "8938": {
            "name": "Гриневичи",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.299711,
            "latitude": 57.3016821
        },
        "8939": {
            "name": "Пригородное Тарское Леснич",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.304038,
            "latitude": 56.8894671
        },
        "8940": {
            "name": "Новая Ивановка",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3046273,
            "latitude": 54.9137531
        },
        "8941": {
            "name": "Кошкуль",
            "population": 253,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3046364,
            "latitude": 56.4998757
        },
        "8942": {
            "name": "Победа",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3111998,
            "latitude": 54.5032132
        },
        "8943": {
            "name": "Милино",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3245896,
            "latitude": 55.8432485
        },
        "8944": {
            "name": "Тусказань",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3286633,
            "latitude": 56.3694119
        },
        "8945": {
            "name": "Крапивка",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3316582,
            "latitude": 57.0823298
        },
        "8946": {
            "name": "Карасёво",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.332675,
            "latitude": 55.3111173
        },
        "8947": {
            "name": "Подольск",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3474203,
            "latitude": 55.5184318
        },
        "8948": {
            "name": "Осокино",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3573382,
            "latitude": 55.0242153
        },
        "8949": {
            "name": "Осокино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3578513,
            "latitude": 55.0230685
        },
        "8950": {
            "name": "Баландино",
            "population": 246,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3622407,
            "latitude": 54.4231346
        },
        "8951": {
            "name": "Михайловка",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5283844,
            "latitude": 56.3683799
        },
        "8952": {
            "name": "Ефимовка",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3637663,
            "latitude": 54.7579033
        },
        "8953": {
            "name": "Ишеево",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3669638,
            "latitude": 57.0799333
        },
        "8954": {
            "name": "Архиповка",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3733012,
            "latitude": 55.0602556
        },
        "8955": {
            "name": "Быган",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.377571,
            "latitude": 57.269791
        },
        "8956": {
            "name": "Ростовка",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3814185,
            "latitude": 55.8012721
        },
        "8957": {
            "name": "Кирсаново",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3877412,
            "latitude": 55.2658277
        },
        "8958": {
            "name": "Молодёжное",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.392986,
            "latitude": 54.0495347
        },
        "8959": {
            "name": "Голубовка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.3993673,
            "latitude": 53.4950108
        },
        "8960": {
            "name": "Степное",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.400963,
            "latitude": 53.7883525
        },
        "8961": {
            "name": "Нетесово",
            "population": 258,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4080995,
            "latitude": 54.2341235
        },
        "8962": {
            "name": "Новоивановка",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4107121,
            "latitude": 54.3898775
        },
        "8963": {
            "name": "Коршуново",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4151293,
            "latitude": 56.449317
        },
        "8964": {
            "name": "Советская Крестьянка",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4157243,
            "latitude": 56.6968457
        },
        "8965": {
            "name": "Соснино",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4169431,
            "latitude": 55.4344721
        },
        "8966": {
            "name": "Исаковка",
            "population": 213,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4207243,
            "latitude": 55.7453635
        },
        "8967": {
            "name": "Тимшиняково",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4407666,
            "latitude": 56.9413059
        },
        "8968": {
            "name": "Любовка",
            "population": 261,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.444901,
            "latitude": 54.160095
        },
        "8969": {
            "name": "Яковлевка",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4528312,
            "latitude": 55.3996996
        },
        "8970": {
            "name": "Любовский",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4529199,
            "latitude": 54.1493763
        },
        "8971": {
            "name": "Красный Овцевод",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4544157,
            "latitude": 54.5780832
        },
        "8972": {
            "name": "Весёлый",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4556241,
            "latitude": 55.3058138
        },
        "8973": {
            "name": "Логуновка",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4569127,
            "latitude": 53.8634132
        },
        "8974": {
            "name": "Куликово",
            "population": 225,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4595933,
            "latitude": 55.0630865
        },
        "8975": {
            "name": "Нерпинский Кордон",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4598264,
            "latitude": 56.9510658
        },
        "8976": {
            "name": "Горошино",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4683811,
            "latitude": 54.8798459
        },
        "8977": {
            "name": "2783 км",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.470954,
            "latitude": 55.0337684
        },
        "8978": {
            "name": "Осихино",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4710581,
            "latitude": 56.1147894
        },
        "8979": {
            "name": "Пихтовое",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4836513,
            "latitude": 57.467347
        },
        "8980": {
            "name": "Криводаново",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.487263,
            "latitude": 56.1737924
        },
        "8981": {
            "name": "Крупское",
            "population": 239,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4911056,
            "latitude": 54.4666948
        },
        "8982": {
            "name": "Новоивановка",
            "population": 110,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.4991821,
            "latitude": 55.565715
        },
        "8983": {
            "name": "Архангелка",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5075083,
            "latitude": 55.0678892
        },
        "8984": {
            "name": "Бещаул",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.512016,
            "latitude": 55.831635
        },
        "8985": {
            "name": "Коренево",
            "population": 258,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.515646,
            "latitude": 56.7510991
        },
        "8986": {
            "name": "Жарагач",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5156733,
            "latitude": 54.3662037
        },
        "8987": {
            "name": "Ермак",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5164882,
            "latitude": 55.1776577
        },
        "8988": {
            "name": "Бородихино",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5166476,
            "latitude": 56.741001
        },
        "8989": {
            "name": "2786 км",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5178871,
            "latitude": 55.0383206
        },
        "8990": {
            "name": "Кибер-Спасское",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5190125,
            "latitude": 55.2031779
        },
        "8991": {
            "name": "Благовещенка",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5267263,
            "latitude": 54.7387326
        },
        "8992": {
            "name": "Чулино",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5353164,
            "latitude": 55.297949
        },
        "8993": {
            "name": "Рождественка",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5429083,
            "latitude": 55.5533918
        },
        "8994": {
            "name": "Большемурлы",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5510481,
            "latitude": 55.9299703
        },
        "8995": {
            "name": "Лесной",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5514784,
            "latitude": 55.5887455
        },
        "8996": {
            "name": "Сидоровка",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.556853,
            "latitude": 55.7212165
        },
        "8997": {
            "name": "Безымянная",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5581348,
            "latitude": 56.1330307
        },
        "8998": {
            "name": "Калачинская",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5691311,
            "latitude": 55.2564239
        },
        "8999": {
            "name": "Моисеевка",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5706908,
            "latitude": 53.9331617
        },
        "9000": {
            "name": "Секменево",
            "population": 211,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5717008,
            "latitude": 56.6108666
        },
        "9001": {
            "name": "Берняжка",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5729369,
            "latitude": 56.6232882
        },
        "9002": {
            "name": "Кирсановка",
            "population": 253,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5746647,
            "latitude": 56.0416453
        },
        "9003": {
            "name": "Розенталь",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.591141,
            "latitude": 54.61356
        },
        "9004": {
            "name": "Атачка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.593212,
            "latitude": 56.7932054
        },
        "9005": {
            "name": "Новое Село",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.594113,
            "latitude": 54.9704455
        },
        "9006": {
            "name": "Пичугино",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.5953692,
            "latitude": 53.7635395
        },
        "9007": {
            "name": "Сидоровка",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6010801,
            "latitude": 57.0098162
        },
        "9008": {
            "name": "Хутора",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6066748,
            "latitude": 55.8782017
        },
        "9009": {
            "name": "Киргап",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6149022,
            "latitude": 56.7191244
        },
        "9010": {
            "name": "Талапкер",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6198378,
            "latitude": 54.0614687
        },
        "9011": {
            "name": "Рассохино",
            "population": 206,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6205928,
            "latitude": 54.241355
        },
        "9012": {
            "name": "Новомалиновка",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6206405,
            "latitude": 55.8192803
        },
        "9013": {
            "name": "Бызовка",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.626191,
            "latitude": 56.206908
        },
        "9014": {
            "name": "Кабурлы",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6314862,
            "latitude": 55.3735605
        },
        "9015": {
            "name": "Терехово",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6325488,
            "latitude": 56.5526327
        },
        "9016": {
            "name": "Покровка",
            "population": 235,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.632899,
            "latitude": 55.7849752
        },
        "9017": {
            "name": "Гущино",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6434522,
            "latitude": 56.0137392
        },
        "9018": {
            "name": "Кызылтан",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6509983,
            "latitude": 53.8305554
        },
        "9019": {
            "name": "Шуево",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6547254,
            "latitude": 56.5283654
        },
        "9020": {
            "name": "Воскресенка",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6569731,
            "latitude": 54.6038049
        },
        "9021": {
            "name": "Павловка",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6571961,
            "latitude": 54.8406878
        },
        "9022": {
            "name": "Кочковатое",
            "population": 163,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6604283,
            "latitude": 54.7517355
        },
        "9023": {
            "name": "Киксы",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6609466,
            "latitude": 57.3315929
        },
        "9024": {
            "name": "Колбышево",
            "population": 253,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6667662,
            "latitude": 56.4535749
        },
        "9025": {
            "name": "Любимовка",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6729246,
            "latitude": 55.5058567
        },
        "9026": {
            "name": "Платоновка",
            "population": 241,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6739021,
            "latitude": 53.8795231
        },
        "9027": {
            "name": "Подлесное",
            "population": 250,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6747443,
            "latitude": 54.354481
        },
        "9028": {
            "name": "Большемитькино",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6748182,
            "latitude": 55.3023807
        },
        "9029": {
            "name": "Суворовка",
            "population": 249,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6806492,
            "latitude": 54.473346
        },
        "9030": {
            "name": "Пустынное",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6834391,
            "latitude": 55.9390554
        },
        "9031": {
            "name": "Мешково",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6851226,
            "latitude": 56.4061093
        },
        "9032": {
            "name": "Новоградка",
            "population": 238,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6862393,
            "latitude": 54.6164108
        },
        "9033": {
            "name": "Бобровка",
            "population": 155,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6894105,
            "latitude": 57.1493578
        },
        "9034": {
            "name": "Отрадновка",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.6947027,
            "latitude": 55.8002716
        },
        "9035": {
            "name": "2797 км",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.696414,
            "latitude": 55.058866
        },
        "9036": {
            "name": "Хлебоприемный Пункт",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.7001487,
            "latitude": 56.3343211
        },
        "9037": {
            "name": "Борисовка",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.7144658,
            "latitude": 55.8793755
        },
        "9038": {
            "name": "Лаврино",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.73661,
            "latitude": 55.3849393
        },
        "9039": {
            "name": "Роднички",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.7422166,
            "latitude": 57.0537245
        },
        "9040": {
            "name": "Бешметовка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.745178,
            "latitude": 56.774837
        },
        "9041": {
            "name": "Зенкуль",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.7509513,
            "latitude": 55.4922423
        },
        "9042": {
            "name": "Чеплярово",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.753702,
            "latitude": 56.5832816
        },
        "9043": {
            "name": "Михайловка",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.7567276,
            "latitude": 57.3470263
        },
        "9044": {
            "name": "Качесово",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.758324,
            "latitude": 56.0427442
        },
        "9045": {
            "name": "Барышниково",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.7615418,
            "latitude": 55.7339331
        },
        "9046": {
            "name": "Новоермаковка",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.7636919,
            "latitude": 57.0487936
        },
        "9047": {
            "name": "Елизаветино",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.765102,
            "latitude": 54.8758309
        },
        "9048": {
            "name": "Северное",
            "population": 204,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.7702223,
            "latitude": 54.5043147
        },
        "9049": {
            "name": "Таволжанка",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.779442,
            "latitude": 55.093967
        },
        "9050": {
            "name": "Сеткуловка",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8009759,
            "latitude": 56.2736738
        },
        "9051": {
            "name": "Машканка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.804212,
            "latitude": 56.7216173
        },
        "9052": {
            "name": "Танатово",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.805091,
            "latitude": 56.3729688
        },
        "9053": {
            "name": "Валерино",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8082993,
            "latitude": 55.0729496
        },
        "9054": {
            "name": "Пугачевка",
            "population": 165,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8193467,
            "latitude": 55.3668969
        },
        "9055": {
            "name": "Камышинка",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.819469,
            "latitude": 55.4417583
        },
        "9056": {
            "name": "Придорожное",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8197738,
            "latitude": 55.405377
        },
        "9057": {
            "name": "Алексеевка",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8203275,
            "latitude": 56.540131
        },
        "9058": {
            "name": "Уразай",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8264946,
            "latitude": 56.8152124
        },
        "9059": {
            "name": "Ясная Поляна",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.834503,
            "latitude": 55.106297
        },
        "9060": {
            "name": "Курляно-Дубовка",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8347441,
            "latitude": 57.1748137
        },
        "9061": {
            "name": "Моисеевка",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8377086,
            "latitude": 55.8889582
        },
        "9062": {
            "name": "Кирьяновка",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8418517,
            "latitude": 54.3989065
        },
        "9063": {
            "name": "Николаевка",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8430567,
            "latitude": 55.8083421
        },
        "9064": {
            "name": "Сибирское",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8520159,
            "latitude": 54.0105256
        },
        "9065": {
            "name": "Межевная",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8551715,
            "latitude": 57.0921268
        },
        "9066": {
            "name": "Ачаирка",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8567454,
            "latitude": 55.5347547
        },
        "9067": {
            "name": "Измайловка",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8583477,
            "latitude": 55.2520986
        },
        "9068": {
            "name": "Инцисс",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.861488,
            "latitude": 56.494766
        },
        "9069": {
            "name": "Озерное",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.861584,
            "latitude": 55.6839176
        },
        "9070": {
            "name": "Стеклянка",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8749936,
            "latitude": 54.5743641
        },
        "9071": {
            "name": "Камышино-Воронежское",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8753091,
            "latitude": 55.9647525
        },
        "9072": {
            "name": "Камышино",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8804342,
            "latitude": 54.6940395
        },
        "9073": {
            "name": "Сергеевка",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8816953,
            "latitude": 54.9852032
        },
        "9074": {
            "name": "Пробуждение",
            "population": 194,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8830437,
            "latitude": 54.3350515
        },
        "9075": {
            "name": "Измайловка",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8871651,
            "latitude": 55.2593955
        },
        "9076": {
            "name": "Богомель",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8909513,
            "latitude": 57.0263217
        },
        "9077": {
            "name": "Крутые Луки",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8940078,
            "latitude": 55.1474123
        },
        "9078": {
            "name": "Ольховка",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.8961536,
            "latitude": 54.7840072
        },
        "9079": {
            "name": "Окунево",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.904457,
            "latitude": 56.443054
        },
        "9080": {
            "name": "Воскресенка",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9101154,
            "latitude": 55.7775878
        },
        "9081": {
            "name": "Кирьяновка",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9118637,
            "latitude": 55.1865472
        },
        "9082": {
            "name": "Новорождественка",
            "population": 236,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.913747,
            "latitude": 56.2009156
        },
        "9083": {
            "name": "2812 км",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9138839,
            "latitude": 55.0862731
        },
        "9084": {
            "name": "Целинное",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9206668,
            "latitude": 54.1381944
        },
        "9085": {
            "name": "Берёзовка",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9238325,
            "latitude": 54.8606756
        },
        "9086": {
            "name": "Ивановка",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9311805,
            "latitude": 56.7284588
        },
        "9087": {
            "name": "Нижняя Омка",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9436733,
            "latitude": 55.4148363
        },
        "9088": {
            "name": "Сперановка",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9562118,
            "latitude": 56.122234
        },
        "9089": {
            "name": "Волчино",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9577853,
            "latitude": 54.798658
        },
        "9090": {
            "name": "Лесная База",
            "population": 95,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9607049,
            "latitude": 54.1462526
        },
        "9091": {
            "name": "Захаровка",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.973144,
            "latitude": 56.0149141
        },
        "9092": {
            "name": "Слободка",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9753518,
            "latitude": 55.3849667
        },
        "9093": {
            "name": "Усть-Инцы",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9759163,
            "latitude": 57.0030342
        },
        "9094": {
            "name": "Старая Рига",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9764069,
            "latitude": 55.1933647
        },
        "9095": {
            "name": "Вишневка",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9771847,
            "latitude": 55.4463732
        },
        "9096": {
            "name": "Виноградовка",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9780699,
            "latitude": 55.5256544
        },
        "9097": {
            "name": "Удачная",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9809561,
            "latitude": 55.6463642
        },
        "9098": {
            "name": "Некрасовка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9856445,
            "latitude": 55.6991278
        },
        "9099": {
            "name": "Николаевка",
            "population": 169,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9867168,
            "latitude": 54.9458934
        },
        "9100": {
            "name": "Стрельниково",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9882232,
            "latitude": 54.7505823
        },
        "9101": {
            "name": "Ольговка",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 74.9967866,
            "latitude": 54.3576405
        },
        "9102": {
            "name": "Старый Ревель",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.001404,
            "latitude": 55.193592
        },
        "9103": {
            "name": "Васьковка",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0035778,
            "latitude": 54.4437448
        },
        "9104": {
            "name": "Большеникольск",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0054143,
            "latitude": 56.1408039
        },
        "9105": {
            "name": "Илюшкино",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0079942,
            "latitude": 55.098465
        },
        "9106": {
            "name": "Малоникольск",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0092272,
            "latitude": 56.1781137
        },
        "9107": {
            "name": "Рождественка",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0093424,
            "latitude": 54.6141613
        },
        "9108": {
            "name": "Петропавловка",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0229999,
            "latitude": 55.8175339
        },
        "9109": {
            "name": "Соловьёвка",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0269245,
            "latitude": 54.9915955
        },
        "9110": {
            "name": "Копьево",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0305635,
            "latitude": 55.9271147
        },
        "9111": {
            "name": "Локти",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0337242,
            "latitude": 55.2287064
        },
        "9112": {
            "name": "Илюшкинская",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.044719,
            "latitude": 55.1083789
        },
        "9113": {
            "name": "Локти",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0474669,
            "latitude": 55.2329918
        },
        "9114": {
            "name": "Ольховка",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0504031,
            "latitude": 53.8824462
        },
        "9115": {
            "name": "Воскресенка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.051768,
            "latitude": 55.4661415
        },
        "9116": {
            "name": "Миргородка",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0703178,
            "latitude": 54.9317039
        },
        "9117": {
            "name": "Народное Береговое",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0735458,
            "latitude": 53.9193791
        },
        "9118": {
            "name": "Радищево",
            "population": 110,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0739028,
            "latitude": 55.8777262
        },
        "9119": {
            "name": "Полтавка",
            "population": 183,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0746282,
            "latitude": 55.2968386
        },
        "9120": {
            "name": "Киршовка",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0779893,
            "latitude": 55.4628729
        },
        "9121": {
            "name": "Костяковка",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0797272,
            "latitude": 54.7047604
        },
        "9122": {
            "name": "Епанчино",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.081991,
            "latitude": 55.6024636
        },
        "9123": {
            "name": "Андреевка",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.0843036,
            "latitude": 54.5367814
        },
        "9124": {
            "name": "Игоревка",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.094091,
            "latitude": 56.5704262
        },
        "9125": {
            "name": "Преображенка",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1013762,
            "latitude": 54.3113202
        },
        "9126": {
            "name": "Петровка",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1071823,
            "latitude": 57.4116095
        },
        "9127": {
            "name": "Черлак",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1143702,
            "latitude": 53.8811911
        },
        "9128": {
            "name": "Сыщиково",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.120821,
            "latitude": 56.9760521
        },
        "9129": {
            "name": "Народное Степное",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1250382,
            "latitude": 53.908723
        },
        "9130": {
            "name": "Короленка",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1305684,
            "latitude": 57.0092366
        },
        "9131": {
            "name": "2826 км",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1314308,
            "latitude": 55.1130804
        },
        "9132": {
            "name": "Павловка",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1423732,
            "latitude": 56.7945299
        },
        "9133": {
            "name": "Ермолаевка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1467373,
            "latitude": 55.0812907
        },
        "9134": {
            "name": "Михайловка",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1531315,
            "latitude": 56.840711
        },
        "9135": {
            "name": "Хомутинка",
            "population": 162,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1544269,
            "latitude": 55.5045514
        },
        "9136": {
            "name": "Лилейка",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1603619,
            "latitude": 57.0533992
        },
        "9137": {
            "name": "Юрто-Уйск",
            "population": 204,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1737764,
            "latitude": 56.9630229
        },
        "9138": {
            "name": "Новый Ревель",
            "population": 250,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.176048,
            "latitude": 55.140919
        },
        "9139": {
            "name": "Кирилловка",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1814242,
            "latitude": 54.6476784
        },
        "9140": {
            "name": "Караклинка",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.187174,
            "latitude": 56.6511931
        },
        "9141": {
            "name": "Рязанка",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1899608,
            "latitude": 55.5283113
        },
        "9142": {
            "name": "Михайловка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.1942705,
            "latitude": 54.7297439
        },
        "9143": {
            "name": "Вятка-1",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2025422,
            "latitude": 56.6489712
        },
        "9144": {
            "name": "Медвежья Грива",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2123154,
            "latitude": 55.2572654
        },
        "9145": {
            "name": "Эстонка",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2229191,
            "latitude": 57.072173
        },
        "9146": {
            "name": "Алексеевка",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.22921,
            "latitude": 56.613354
        },
        "9147": {
            "name": "Михайловка",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2465592,
            "latitude": 54.148541
        },
        "9148": {
            "name": "Хмелевка",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2674459,
            "latitude": 56.8208455
        },
        "9149": {
            "name": "Андреевка",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2761371,
            "latitude": 56.8732366
        },
        "9150": {
            "name": "Васильевка",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2852636,
            "latitude": 54.893386
        },
        "9151": {
            "name": "Погранично-Григорьевка",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2912059,
            "latitude": 54.1042133
        },
        "9152": {
            "name": "Орловка",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2920925,
            "latitude": 54.7297439
        },
        "9153": {
            "name": "Пресновка",
            "population": 237,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.2949726,
            "latitude": 54.8047452
        },
        "9154": {
            "name": "Мариновка",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.3116958,
            "latitude": 54.5678747
        },
        "9155": {
            "name": "Павловка",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.3182364,
            "latitude": 56.3157854
        },
        "9156": {
            "name": "Кузнецовка",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.3269664,
            "latitude": 53.9732136
        },
        "9157": {
            "name": "Стретенка",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.3337824,
            "latitude": 54.4055216
        },
        "9158": {
            "name": "Денисовка",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.3367614,
            "latitude": 56.9675292
        },
        "9159": {
            "name": "Черталы",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.386948,
            "latitude": 56.355225
        },
        "9160": {
            "name": "Тамбовка",
            "population": 173,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.3883568,
            "latitude": 56.8813948
        },
        "9161": {
            "name": "Богдановка",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.3908226,
            "latitude": 56.9421412
        },
        "9162": {
            "name": "Козинка",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.4121923,
            "latitude": 54.1405112
        },
        "9163": {
            "name": "Алексеевка",
            "population": 174,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.4473957,
            "latitude": 54.7698414
        },
        "9164": {
            "name": "Плотбище",
            "population": 190,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.4786693,
            "latitude": 56.3789593
        },
        "9165": {
            "name": "Ленинск",
            "population": 120,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.4917742,
            "latitude": 54.5380372
        },
        "9166": {
            "name": "Тармакла",
            "population": 206,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.5276665,
            "latitude": 56.5017174
        },
        "9167": {
            "name": "Язово",
            "population": 204,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.5429375,
            "latitude": 54.7621865
        },
        "9168": {
            "name": "Курнево",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.5653133,
            "latitude": 56.3009092
        },
        "9169": {
            "name": "Самохвалово",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.5730356,
            "latitude": 56.3438705
        },
        "9170": {
            "name": "Надеждинка",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.6568734,
            "latitude": 56.4109129
        },
        "9171": {
            "name": "Чинянино",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.6664056,
            "latitude": 56.358627
        },
        "9172": {
            "name": "Новоалександровка",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.6813304,
            "latitude": 56.8625406
        },
        "9173": {
            "name": "Любимовка",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.7040046,
            "latitude": 56.3150644
        },
        "9174": {
            "name": "Казанка",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.7202826,
            "latitude": 56.517189
        },
        "9175": {
            "name": "Льнозавод",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.8052531,
            "latitude": 56.4185276
        },
        "9176": {
            "name": "Малинкино",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.8205438,
            "latitude": 56.4855593
        },
        "9177": {
            "name": "Колобово",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.8322592,
            "latitude": 56.5099799
        },
        "9178": {
            "name": "Неждановка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.8833096,
            "latitude": 56.9753417
        },
        "9179": {
            "name": "Большекрасноярка",
            "population": 236,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.9279435,
            "latitude": 56.408315
        },
        "9180": {
            "name": "Михайловка",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.93154,
            "latitude": 56.5475636
        },
        "9181": {
            "name": "Соловьёвка",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.962565,
            "latitude": 57.0724818
        },
        "9182": {
            "name": "Петропавловка",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.9752123,
            "latitude": 56.9536855
        },
        "9183": {
            "name": "Успенка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.0014073,
            "latitude": 57.0924278
        },
        "9184": {
            "name": "Юдинка",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.0350361,
            "latitude": 56.4488617
        },
        "9185": {
            "name": "Елизарово",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.0483792,
            "latitude": 56.9392266
        },
        "9186": {
            "name": "Гузенево",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.0827537,
            "latitude": 56.4415975
        },
        "9187": {
            "name": "Первомайский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.8112246,
            "latitude": 59.1921037
        },
        "9188": {
            "name": "Пионерный",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    76.2311244,
                    59.1725201
                ],
                [
                    76.2339577,
                    59.1732661
                ],
                [
                    76.2357072,
                    59.1736736
                ],
                [
                    76.2351631,
                    59.174257
                ],
                [
                    76.2344767,
                    59.1741197
                ],
                [
                    76.2338405,
                    59.1749519
                ],
                [
                    76.2363994,
                    59.1754476
                ],
                [
                    76.2368099,
                    59.1749099
                ],
                [
                    76.2394323,
                    59.1754923
                ],
                [
                    76.2399054,
                    59.1749468
                ],
                [
                    76.247068,
                    59.1766101
                ],
                [
                    76.2478528,
                    59.1770866
                ],
                [
                    76.2489489,
                    59.1773656
                ],
                [
                    76.2504146,
                    59.1767461
                ],
                [
                    76.2507657,
                    59.1762819
                ],
                [
                    76.2521612,
                    59.1764105
                ],
                [
                    76.2553698,
                    59.1733316
                ],
                [
                    76.2519977,
                    59.1724729
                ],
                [
                    76.2542458,
                    59.1700744
                ],
                [
                    76.2577405,
                    59.1708181
                ],
                [
                    76.2584967,
                    59.1701478
                ],
                [
                    76.2588645,
                    59.1692994
                ],
                [
                    76.2587419,
                    59.1681577
                ],
                [
                    76.2560034,
                    59.167414
                ],
                [
                    76.25678,
                    59.1654342
                ],
                [
                    76.2496066,
                    59.1629201
                ],
                [
                    76.2445791,
                    59.1617677
                ],
                [
                    76.2459892,
                    59.1600496
                ],
                [
                    76.2410639,
                    59.1589495
                ],
                [
                    76.2394085,
                    59.1599762
                ],
                [
                    76.2380393,
                    59.1599553
                ],
                [
                    76.2338701,
                    59.161883
                ],
                [
                    76.2361182,
                    59.1637582
                ],
                [
                    76.2320052,
                    59.1683142
                ],
                [
                    76.2340745,
                    59.1692045
                ],
                [
                    76.2311244,
                    59.1725201
                ]
            ],
            "longitude": 76.2448136,
            "latitude": 59.1677108
        },
        "9189": {
            "name": "Игольско-Таловское месторо",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.4187602,
            "latitude": 57.7452386
        },
        "9190": {
            "name": "Айполово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.6020084,
            "latitude": 58.723735
        },
        "9191": {
            "name": "Ломовое месторождение",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.0425109,
            "latitude": 59.2656949
        },
        "9192": {
            "name": "Матюшкиноская",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.066667,
            "latitude": 59.933333
        },
        "9193": {
            "name": "Светлая Протока",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.179581,
            "latitude": 60.685032
        },
        "9194": {
            "name": "Медведево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.3548334,
            "latitude": 60.6143848
        },
        "9195": {
            "name": "Ларино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.6746784,
            "latitude": 60.5239092
        },
        "9196": {
            "name": "Тополевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.2648105,
            "latitude": 60.4484708
        },
        "9197": {
            "name": "Лавровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.362258,
            "latitude": 57.454686
        },
        "9198": {
            "name": "Бочкарёвка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.3666669,
            "latitude": 57.433333
        },
        "9199": {
            "name": "Погорелово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.433333,
            "latitude": 57.466667
        },
        "9200": {
            "name": "Мыльджинское месторождени",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    78.4144013,
                    58.7903599
                ],
                [
                    78.4210961,
                    58.7905378
                ],
                [
                    78.4341423,
                    58.7868018
                ],
                [
                    78.4372322,
                    58.7797733
                ],
                [
                    78.4592049,
                    58.780405
                ],
                [
                    78.4602349,
                    58.7906268
                ],
                [
                    78.4739678,
                    58.7905378
                ],
                [
                    78.4732811,
                    58.7681153
                ],
                [
                    78.4646981,
                    58.7612611
                ],
                [
                    78.4408371,
                    58.7605489
                ],
                [
                    78.424701,
                    58.7756
                ],
                [
                    78.4144013,
                    58.7903599
                ]
            ],
            "longitude": 78.4589748,
            "latitude": 58.7722015
        },
        "9201": {
            "name": "Пырчино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.1242761,
            "latitude": 59.7026323
        },
        "9202": {
            "name": "Калининск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.40696,
            "latitude": 57.551144
        },
        "9203": {
            "name": "Лушниково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.4298524,
            "latitude": 57.5598776
        },
        "9204": {
            "name": "Останино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.4674682,
            "latitude": 57.5755512
        },
        "9205": {
            "name": "Гонохово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.5092169,
            "latitude": 57.5788731
        },
        "9206": {
            "name": "Рогалево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.6097961,
            "latitude": 57.496075
        },
        "9207": {
            "name": "Усть-Чижапка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.612854,
            "latitude": 58.998795
        },
        "9208": {
            "name": "Таванга",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.7369745,
            "latitude": 57.4973231
        },
        "9209": {
            "name": "Наунак",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.129143,
            "latitude": 58.971134
        },
        "9210": {
            "name": "Осипово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.1778344,
            "latitude": 57.8391412
        },
        "9211": {
            "name": "Казальцево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.5364111,
            "latitude": 59.2512155
        },
        "9212": {
            "name": "Тарск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.5898519,
            "latitude": 58.2947782
        },
        "9213": {
            "name": "Усть-Чузик",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.597641,
            "latitude": 58.050331
        },
        "9214": {
            "name": "Чановка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.6128617,
            "latitude": 58.462538
        },
        "9215": {
            "name": "Новиково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.6312621,
            "latitude": 58.2040373
        },
        "9216": {
            "name": "Сенькино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.6731491,
            "latitude": 58.5041576
        },
        "9217": {
            "name": "5 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.803177,
            "latitude": 59.063667
        },
        "9218": {
            "name": "Гребенщиково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.911642,
            "latitude": 57.3981846
        },
        "9219": {
            "name": "Веселый",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.9212043,
            "latitude": 56.8781745
        },
        "9220": {
            "name": "Центральный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.9761945,
            "latitude": 57.4844826
        },
        "9221": {
            "name": "Кёнга",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.976501,
            "latitude": 57.428196
        },
        "9222": {
            "name": "Новая Бурка",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.057152,
            "latitude": 56.915192
        },
        "9223": {
            "name": "Нельмач",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.097771,
            "latitude": 58.681053
        },
        "9224": {
            "name": "Белка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.102556,
            "latitude": 58.5904565
        },
        "9225": {
            "name": "Кедровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.242922,
            "latitude": 57.1230403
        },
        "9226": {
            "name": "Восток",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.275253,
            "latitude": 59.166855
        },
        "9227": {
            "name": "Хохловка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.3633184,
            "latitude": 57.2015444
        },
        "9228": {
            "name": "Заозеро",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.4270483,
            "latitude": 58.704259
        },
        "9229": {
            "name": "Голещихино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.4497272,
            "latitude": 58.7223879
        },
        "9230": {
            "name": "Вялово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.457787,
            "latitude": 58.7156913
        },
        "9231": {
            "name": "Перемитино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.5393433,
            "latitude": 58.6694331
        },
        "9232": {
            "name": "Андарма",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7009928,
            "latitude": 56.9142786
        },
        "9233": {
            "name": "Алатаево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7496044,
            "latitude": 58.8282516
        },
        "9234": {
            "name": "Богатырёвка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.753853,
            "latitude": 56.980011
        },
        "9235": {
            "name": "Светлозелёное",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7664641,
            "latitude": 57.3764901
        },
        "9236": {
            "name": "Нижняя Чигара",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.783768,
            "latitude": 58.5744788
        },
        "9237": {
            "name": "Панычево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.794205,
            "latitude": 57.053921
        },
        "9238": {
            "name": "Пчёлка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.917793,
            "latitude": 57.222813
        },
        "9239": {
            "name": "Хуторское",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.924065,
            "latitude": 57.268841
        },
        "9240": {
            "name": "Черемхово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.9633036,
            "latitude": 57.4961961
        },
        "9241": {
            "name": "Большая Галка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.969589,
            "latitude": 56.930569
        },
        "9242": {
            "name": "Чернышевка",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.9925461,
            "latitude": 57.0013872
        },
        "9243": {
            "name": "Бундюр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.99884,
            "latitude": 57.546528
        },
        "9244": {
            "name": "Басмасово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.0443947,
            "latitude": 58.6367769
        },
        "9245": {
            "name": "Весёлое",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.1162014,
            "latitude": 57.5644983
        },
        "9246": {
            "name": "Юрты",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.1683499,
            "latitude": 58.4923919
        },
        "9247": {
            "name": "Сухое",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.177742,
            "latitude": 57.111458
        },
        "9248": {
            "name": "Подольск",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.1825676,
            "latitude": 57.2533955
        },
        "9249": {
            "name": "Первомайск",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.250275,
            "latitude": 56.982708
        },
        "9250": {
            "name": "Лось-Гора",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.2733039,
            "latitude": 57.5243845
        },
        "9251": {
            "name": "Кузнецовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.2846706,
            "latitude": 56.917925
        },
        "9252": {
            "name": "Нижняя Тига",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.3060744,
            "latitude": 57.5688782
        },
        "9253": {
            "name": "Мостовая",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.3156734,
            "latitude": 57.5984001
        },
        "9254": {
            "name": "Чумакаевка",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.331314,
            "latitude": 57.044056
        },
        "9255": {
            "name": "Зайкино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.455381,
            "latitude": 58.6370376
        },
        "9256": {
            "name": "Петропавловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.479809,
            "latitude": 58.3337665
        },
        "9257": {
            "name": "Полынянка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.509056,
            "latitude": 56.952286
        },
        "9258": {
            "name": "Светлянка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5558585,
            "latitude": 57.8618433
        },
        "9259": {
            "name": "Гвоздевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5605744,
            "latitude": 57.9555299
        },
        "9260": {
            "name": "Клюквинка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5702386,
            "latitude": 58.1613627
        },
        "9261": {
            "name": "Андреевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6026715,
            "latitude": 58.0690756
        },
        "9262": {
            "name": "Трудовой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6368706,
            "latitude": 57.8168266
        },
        "9263": {
            "name": "Тоинка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6726092,
            "latitude": 58.0331304
        },
        "9264": {
            "name": "Первомайка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.705224,
            "latitude": 58.1151574
        },
        "9265": {
            "name": "Карамзинка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7292888,
            "latitude": 58.0292907
        },
        "9266": {
            "name": "Нюльядрово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.583333,
            "latitude": 60.416667
        },
        "9267": {
            "name": "Матюшкино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7771384,
            "latitude": 58.1646915
        },
        "9268": {
            "name": "Комарово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7960806,
            "latitude": 58.4567936
        },
        "9269": {
            "name": "Север",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.813095,
            "latitude": 58.440559
        },
        "9270": {
            "name": "Волково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8886896,
            "latitude": 58.391193
        },
        "9271": {
            "name": "Кананак",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.905278,
            "latitude": 60.044722
        },
        "9272": {
            "name": "Бородинск",
            "population": 20,
            "type": "hamlet",
            "poly": [
                [
                    82.9210724,
                    57.0255037
                ],
                [
                    82.9267802,
                    57.0276292
                ],
                [
                    82.9306855,
                    57.0275825
                ],
                [
                    82.9306855,
                    57.0206451
                ],
                [
                    82.9242481,
                    57.0200611
                ],
                [
                    82.9210724,
                    57.0255037
                ]
            ],
            "longitude": 82.929184,
            "latitude": 57.023602
        },
        "9273": {
            "name": "Старокороткино",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    82.965709,
                    58.026012
                ],
                [
                    82.968055,
                    58.0290816
                ],
                [
                    82.9668853,
                    58.0298585
                ],
                [
                    82.9716562,
                    58.0327633
                ],
                [
                    82.9748179,
                    58.0361688
                ],
                [
                    82.9771209,
                    58.0381888
                ],
                [
                    82.975683,
                    58.0388898
                ],
                [
                    82.9778051,
                    58.0414759
                ],
                [
                    82.9700165,
                    58.0421513
                ],
                [
                    82.9698981,
                    58.0439827
                ],
                [
                    82.9743026,
                    58.044151
                ],
                [
                    82.9811196,
                    58.0429979
                ],
                [
                    82.9828439,
                    58.0418519
                ],
                [
                    82.9840138,
                    58.038996
                ],
                [
                    82.9767332,
                    58.0320282
                ],
                [
                    82.9738019,
                    58.0299936
                ],
                [
                    82.9708884,
                    58.0280414
                ],
                [
                    82.9678635,
                    58.0255958
                ],
                [
                    82.965709,
                    58.026012
                ]
            ],
            "longitude": 82.9714344,
            "latitude": 58.0312238
        },
        "9274": {
            "name": "Новоильинка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    83.006386,
                    58.2262686
                ],
                [
                    83.0070941,
                    58.227116
                ],
                [
                    83.0097763,
                    58.2281215
                ],
                [
                    83.0119746,
                    58.2300671
                ],
                [
                    83.0140775,
                    58.2292988
                ],
                [
                    83.0126087,
                    58.2274323
                ],
                [
                    83.0148714,
                    58.2235929
                ],
                [
                    83.0146568,
                    58.2169367
                ],
                [
                    83.0067722,
                    58.2174662
                ],
                [
                    83.0065575,
                    58.2226307
                ],
                [
                    83.006386,
                    58.2262686
                ]
            ],
            "longitude": 83.0077585,
            "latitude": 58.2227623
        },
        "9275": {
            "name": "Васильевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.082787,
            "latitude": 57.8268834
        },
        "9276": {
            "name": "Новоабрамкино",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1040139,
            "latitude": 57.9261779
        },
        "9277": {
            "name": "Малый Компас",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.145,
            "latitude": 60.058333
        },
        "9278": {
            "name": "Тискино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1830521,
            "latitude": 58.0842829
        },
        "9279": {
            "name": "Новосондрово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2000911,
            "latitude": 58.0535112
        },
        "9280": {
            "name": "Аптала",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.222237,
            "latitude": 56.174774
        },
        "9281": {
            "name": "Коломино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3138547,
            "latitude": 57.8241109
        },
        "9282": {
            "name": "Пыль-Карамо",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.355833,
            "latitude": 60.166111
        },
        "9283": {
            "name": "Трехустье Кальджа",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3896039,
            "latitude": 58.0191433
        },
        "9284": {
            "name": "Старочерново",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4184108,
            "latitude": 56.3443944
        },
        "9285": {
            "name": "Волкодаевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4419285,
            "latitude": 55.9235968
        },
        "9286": {
            "name": "Новодубровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4419284,
            "latitude": 56.4335264
        },
        "9287": {
            "name": "Типсино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4456349,
            "latitude": 58.4382208
        },
        "9288": {
            "name": "Большой Татош",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4689003,
            "latitude": 57.6009982
        },
        "9289": {
            "name": "Нефтебаза",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5044981,
            "latitude": 57.7058714
        },
        "9290": {
            "name": "Родионовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5147442,
            "latitude": 58.4397329
        },
        "9291": {
            "name": "Верхняя Уртамка",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.529541,
            "latitude": 56.133076
        },
        "9292": {
            "name": "Лымбель-Карамо",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.552778,
            "latitude": 60.244722
        },
        "9293": {
            "name": "Верхняя Фёдоровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5582002,
            "latitude": 57.6246441
        },
        "9294": {
            "name": "Батурино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.564751,
            "latitude": 56.496601
        },
        "9295": {
            "name": "Малое Бабарыкино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5648379,
            "latitude": 56.5772359
        },
        "9296": {
            "name": "Усть-Речка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5722951,
            "latitude": 58.442582
        },
        "9297": {
            "name": "Тызырачево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.581699,
            "latitude": 56.7415737
        },
        "9298": {
            "name": "Алексеевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5962573,
            "latitude": 57.4422462
        },
        "9299": {
            "name": "Кузнецово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6014018,
            "latitude": 56.5998273
        },
        "9300": {
            "name": "Верх. Бровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6353961,
            "latitude": 57.1706646
        },
        "9301": {
            "name": "Николаевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6382434,
            "latitude": 56.8799642
        },
        "9302": {
            "name": "Вознесенка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.647069,
            "latitude": 57.0814015
        },
        "9303": {
            "name": "Белосток",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.662865,
            "latitude": 57.177273
        },
        "9304": {
            "name": "Михайловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6780055,
            "latitude": 56.9287213
        },
        "9305": {
            "name": "Крыловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6946192,
            "latitude": 57.2193981
        },
        "9306": {
            "name": "Федораевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.7042429,
            "latitude": 56.8682138
        },
        "9307": {
            "name": "Екимово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.7623258,
            "latitude": 55.9630207
        },
        "9308": {
            "name": "Мохово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.7868566,
            "latitude": 58.4338357
        },
        "9309": {
            "name": "Юдино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8115091,
            "latitude": 58.4425013
        },
        "9310": {
            "name": "Тедель-Кынак",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8198758,
            "latitude": 60.3194283
        },
        "9311": {
            "name": "Нижняя Фёдоровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8548494,
            "latitude": 57.7046505
        },
        "9312": {
            "name": "Старосайнаково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8641614,
            "latitude": 57.0880165
        },
        "9313": {
            "name": "Перелюбка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.9145692,
            "latitude": 56.7280682
        },
        "9314": {
            "name": "Дегтяревка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.9475692,
            "latitude": 56.9451613
        },
        "9315": {
            "name": "Руян",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.9561415,
            "latitude": 56.1469749
        },
        "9316": {
            "name": "Кайтес",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.9590295,
            "latitude": 56.7755028
        },
        "9317": {
            "name": "Бараново",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0151503,
            "latitude": 57.2821337
        },
        "9318": {
            "name": "Могильники",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0418334,
            "latitude": 56.1148129
        },
        "9319": {
            "name": "Балашовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0531585,
            "latitude": 56.8534099
        },
        "9320": {
            "name": "Былино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0634829,
            "latitude": 57.2554909
        },
        "9321": {
            "name": "Новороссийский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0658615,
            "latitude": 56.9826212
        },
        "9322": {
            "name": "Новоказанский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0885208,
            "latitude": 56.9771021
        },
        "9323": {
            "name": "Чагино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0906876,
            "latitude": 57.180485
        },
        "9324": {
            "name": "Казырбак",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1068722,
            "latitude": 57.2559212
        },
        "9325": {
            "name": "Тайное",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1127894,
            "latitude": 58.3897918
        },
        "9326": {
            "name": "Новопокровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1190765,
            "latitude": 56.9072476
        },
        "9327": {
            "name": "Астраханцево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.121819,
            "latitude": 56.4574131
        },
        "9328": {
            "name": "Старая Шегарка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1546664,
            "latitude": 56.5534956
        },
        "9329": {
            "name": "Кулманы",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.2232879,
            "latitude": 56.6042721
        },
        "9330": {
            "name": "Ванжиль-Кынак",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.23297,
            "latitude": 60.389321
        },
        "9331": {
            "name": "Берёзовая Речка",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.328758,
            "latitude": 56.152927
        },
        "9332": {
            "name": "Ергай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3304334,
            "latitude": 57.3458002
        },
        "9333": {
            "name": "Поздняково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3325351,
            "latitude": 56.6695108
        },
        "9334": {
            "name": "Новониколаевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.356793,
            "latitude": 56.7699247
        },
        "9335": {
            "name": "Салтанаково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.38206,
            "latitude": 56.9987961
        },
        "9336": {
            "name": "Красноигловск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3922481,
            "latitude": 56.9680418
        },
        "9337": {
            "name": "Бугры",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4068878,
            "latitude": 57.250663
        },
        "9338": {
            "name": "Новоигловск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4148473,
            "latitude": 56.9730757
        },
        "9339": {
            "name": "Куролино",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4887584,
            "latitude": 58.7208198
        },
        "9340": {
            "name": "86-й квартал",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.552559,
            "latitude": 56.373974
        },
        "9341": {
            "name": "Госконюшня",
            "population": 29,
            "type": "hamlet",
            "poly": [
                [
                    84.6437567,
                    56.2170264
                ],
                [
                    84.6486931,
                    56.2192002
                ],
                [
                    84.6501509,
                    56.2198421
                ],
                [
                    84.6483915,
                    56.2208443
                ],
                [
                    84.6497411,
                    56.2214754
                ],
                [
                    84.6525328,
                    56.2197228
                ],
                [
                    84.6520393,
                    56.2176945
                ],
                [
                    84.6491853,
                    56.2173008
                ],
                [
                    84.6458359,
                    56.2160945
                ],
                [
                    84.6442931,
                    56.2164656
                ],
                [
                    84.6437567,
                    56.2170264
                ]
            ],
            "longitude": 84.6511453,
            "latitude": 56.218079
        },
        "9342": {
            "name": "Урочище Лесной",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6593024,
            "latitude": 57.3081683
        },
        "9343": {
            "name": "Кижирово",
            "population": 108,
            "type": "hamlet",
            "poly": [
                [
                    84.6856006,
                    56.7777441
                ],
                [
                    84.6868705,
                    56.7788987
                ],
                [
                    84.6914365,
                    56.777374
                ],
                [
                    84.6930306,
                    56.7726071
                ],
                [
                    84.6990556,
                    56.7682394
                ],
                [
                    84.6969365,
                    56.7664762
                ],
                [
                    84.6964786,
                    56.7664476
                ],
                [
                    84.695337,
                    56.7665308
                ],
                [
                    84.6938429,
                    56.7666926
                ],
                [
                    84.6933353,
                    56.7663689
                ],
                [
                    84.692615,
                    56.7661089
                ],
                [
                    84.692078,
                    56.7661348
                ],
                [
                    84.6910104,
                    56.7665244
                ],
                [
                    84.6903544,
                    56.7671225
                ],
                [
                    84.6887832,
                    56.7678481
                ],
                [
                    84.688626,
                    56.7680281
                ],
                [
                    84.6885143,
                    56.7686209
                ],
                [
                    84.6885223,
                    56.7688746
                ],
                [
                    84.6893125,
                    56.7691524
                ],
                [
                    84.6889813,
                    56.7692662
                ],
                [
                    84.6886899,
                    56.7694237
                ],
                [
                    84.688175,
                    56.7695265
                ],
                [
                    84.6871412,
                    56.7718253
                ],
                [
                    84.6856276,
                    56.775642
                ],
                [
                    84.6856006,
                    56.7777441
                ]
            ],
            "longitude": 84.6906596,
            "latitude": 56.7679823
        },
        "9344": {
            "name": "Рыбинск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7306036,
            "latitude": 58.3903666
        },
        "9345": {
            "name": "Семиозёрки",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    84.731616,
                    56.7521359
                ],
                [
                    84.7319789,
                    56.7541259
                ],
                [
                    84.7328004,
                    56.7550895
                ],
                [
                    84.7345581,
                    56.7560636
                ],
                [
                    84.736545,
                    56.7592621
                ],
                [
                    84.7393343,
                    56.7586338
                ],
                [
                    84.7368124,
                    56.7547334
                ],
                [
                    84.7361629,
                    56.7525653
                ],
                [
                    84.7361247,
                    56.7510465
                ],
                [
                    84.7364494,
                    56.7506589
                ],
                [
                    84.7369653,
                    56.750418
                ],
                [
                    84.738551,
                    56.75002
                ],
                [
                    84.7393916,
                    56.748124
                ],
                [
                    84.740557,
                    56.7474326
                ],
                [
                    84.7428495,
                    56.7481973
                ],
                [
                    84.7454096,
                    56.7466678
                ],
                [
                    84.7373856,
                    56.7454631
                ],
                [
                    84.734902,
                    56.7471707
                ],
                [
                    84.7329915,
                    56.7485639
                ],
                [
                    84.731616,
                    56.7521359
                ]
            ],
            "longitude": 84.734711,
            "latitude": 56.751408
        },
        "9346": {
            "name": "Коломино",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.748398,
            "latitude": 56.564568
        },
        "9347": {
            "name": "Быково",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7593822,
            "latitude": 56.5652586
        },
        "9348": {
            "name": "Головина",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    84.7513252,
                    56.3810008
                ],
                [
                    84.7525755,
                    56.3816113
                ],
                [
                    84.7551584,
                    56.382704
                ],
                [
                    84.753777,
                    56.383132
                ],
                [
                    84.7530582,
                    56.3835499
                ],
                [
                    84.7551504,
                    56.3851277
                ],
                [
                    84.752593,
                    56.3859752
                ],
                [
                    84.7549254,
                    56.3871116
                ],
                [
                    84.7560711,
                    56.3878232
                ],
                [
                    84.7574038,
                    56.3876905
                ],
                [
                    84.7587438,
                    56.3874785
                ],
                [
                    84.7603002,
                    56.3874084
                ],
                [
                    84.7635618,
                    56.3877885
                ],
                [
                    84.7669138,
                    56.3880003
                ],
                [
                    84.76751,
                    56.3873134
                ],
                [
                    84.766995,
                    56.3867432
                ],
                [
                    84.7651068,
                    56.3866482
                ],
                [
                    84.7651068,
                    56.386112
                ],
                [
                    84.7651068,
                    56.385983
                ],
                [
                    84.76751,
                    56.3848426
                ],
                [
                    84.7666517,
                    56.3837022
                ],
                [
                    84.7645918,
                    56.383132
                ],
                [
                    84.7630468,
                    56.383132
                ],
                [
                    84.7620168,
                    56.3819915
                ],
                [
                    84.7599569,
                    56.380851
                ],
                [
                    84.757382,
                    56.3800906
                ],
                [
                    84.755837,
                    56.3805658
                ],
                [
                    84.752449,
                    56.3804808
                ],
                [
                    84.7513252,
                    56.3810008
                ]
            ],
            "longitude": 84.7595829,
            "latitude": 56.3847382
        },
        "9349": {
            "name": "Вольная слобода",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    84.7557264,
                    56.510003
                ],
                [
                    84.7600682,
                    56.5162591
                ],
                [
                    84.7642001,
                    56.5151205
                ],
                [
                    84.766525,
                    56.5149098
                ],
                [
                    84.778198,
                    56.5156201
                ],
                [
                    84.7797987,
                    56.5157059
                ],
                [
                    84.7818586,
                    56.5157059
                ],
                [
                    84.7838541,
                    56.5155047
                ],
                [
                    84.7857639,
                    56.515185
                ],
                [
                    84.791579,
                    56.5136223
                ],
                [
                    84.791064,
                    56.5117872
                ],
                [
                    84.7899053,
                    56.5114912
                ],
                [
                    84.7874376,
                    56.5111242
                ],
                [
                    84.7780907,
                    56.5102688
                ],
                [
                    84.7622034,
                    56.5087562
                ],
                [
                    84.7584955,
                    56.5083873
                ],
                [
                    84.7557264,
                    56.510003
                ]
            ],
            "longitude": 84.7618334,
            "latitude": 56.5137531
        },
        "9350": {
            "name": "Петровский Участок",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.792,
            "latitude": 56.515442
        },
        "9351": {
            "name": "Поперечка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8096257,
            "latitude": 56.7263711
        },
        "9352": {
            "name": "Примыканье",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8427552,
            "latitude": 56.491039
        },
        "9353": {
            "name": "Кайдаловка",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8454417,
            "latitude": 56.5001306
        },
        "9354": {
            "name": "Петропавловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8596274,
            "latitude": 56.8028983
        },
        "9355": {
            "name": "Ольго-Сапеженка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8634212,
            "latitude": 56.94256
        },
        "9356": {
            "name": "Ламеевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8740891,
            "latitude": 57.8588902
        },
        "9357": {
            "name": "Медведка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8821306,
            "latitude": 56.1762225
        },
        "9358": {
            "name": "Нибега",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.885941,
            "latitude": 58.283829
        },
        "9359": {
            "name": "Лесная Дача",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    84.8998006,
                    56.4423203
                ],
                [
                    84.9005409,
                    56.442688
                ],
                [
                    84.9000152,
                    56.4431387
                ],
                [
                    84.8999621,
                    56.4435118
                ],
                [
                    84.9001981,
                    56.4438676
                ],
                [
                    84.900992,
                    56.4445852
                ],
                [
                    84.9012705,
                    56.4445205
                ],
                [
                    84.9018176,
                    56.4441469
                ],
                [
                    84.9025901,
                    56.443625
                ],
                [
                    84.9028476,
                    56.4434234
                ],
                [
                    84.9031593,
                    56.4432627
                ],
                [
                    84.9040069,
                    56.4428653
                ],
                [
                    84.9055942,
                    56.4421542
                ],
                [
                    84.9066461,
                    56.4416673
                ],
                [
                    84.9074723,
                    56.4412581
                ],
                [
                    84.9080058,
                    56.4413345
                ],
                [
                    84.9082335,
                    56.4413002
                ],
                [
                    84.908491,
                    56.4412409
                ],
                [
                    84.9086948,
                    56.4410689
                ],
                [
                    84.9082657,
                    56.4408258
                ],
                [
                    84.9089314,
                    56.4403685
                ],
                [
                    84.9088665,
                    56.4402682
                ],
                [
                    84.9093391,
                    56.4399296
                ],
                [
                    84.9097677,
                    56.4395091
                ],
                [
                    84.9093064,
                    56.4394023
                ],
                [
                    84.9085237,
                    56.4391707
                ],
                [
                    84.9079658,
                    56.4392122
                ],
                [
                    84.9073328,
                    56.4393308
                ],
                [
                    84.9065491,
                    56.4395565
                ],
                [
                    84.9061741,
                    56.439811
                ],
                [
                    84.9058308,
                    56.4398347
                ],
                [
                    84.9054016,
                    56.440066
                ],
                [
                    84.9045213,
                    56.4403276
                ],
                [
                    84.9033524,
                    56.4402499
                ],
                [
                    84.9019794,
                    56.4408731
                ],
                [
                    84.9018409,
                    56.440936
                ],
                [
                    84.9017323,
                    56.4409853
                ],
                [
                    84.9003483,
                    56.4416673
                ],
                [
                    84.8998006,
                    56.4423203
                ]
            ],
            "longitude": 84.9050754,
            "latitude": 56.442338
        },
        "9360": {
            "name": "Полуденовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.918716,
            "latitude": 58.4398
        },
        "9361": {
            "name": "Ветеран-3",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    84.9113475,
                    56.4385994
                ],
                [
                    84.9117659,
                    56.4390205
                ],
                [
                    84.9119139,
                    56.4391765
                ],
                [
                    84.9120448,
                    56.4391896
                ],
                [
                    84.9122787,
                    56.4391617
                ],
                [
                    84.9124182,
                    56.4391765
                ],
                [
                    84.9125469,
                    56.4392388
                ],
                [
                    84.9125738,
                    56.43931
                ],
                [
                    84.9124933,
                    56.4394464
                ],
                [
                    84.9124128,
                    56.4396154
                ],
                [
                    84.9124128,
                    56.4398734
                ],
                [
                    84.9129224,
                    56.4404191
                ],
                [
                    84.9129301,
                    56.4404175
                ],
                [
                    84.9135876,
                    56.4402767
                ],
                [
                    84.9146659,
                    56.4400721
                ],
                [
                    84.915462,
                    56.4399488
                ],
                [
                    84.9157817,
                    56.4399268
                ],
                [
                    84.9163825,
                    56.4399446
                ],
                [
                    84.9168621,
                    56.439925
                ],
                [
                    84.9173985,
                    56.4398687
                ],
                [
                    84.9179328,
                    56.4397934
                ],
                [
                    84.9184317,
                    56.4396985
                ],
                [
                    84.9190057,
                    56.4396599
                ],
                [
                    84.9195011,
                    56.4397379
                ],
                [
                    84.9203043,
                    56.4397401
                ],
                [
                    84.9206258,
                    56.4397874
                ],
                [
                    84.9209798,
                    56.4398082
                ],
                [
                    84.9212931,
                    56.4397857
                ],
                [
                    84.9231063,
                    56.439673
                ],
                [
                    84.9241309,
                    56.4396344
                ],
                [
                    84.9244474,
                    56.4396315
                ],
                [
                    84.9246433,
                    56.4395947
                ],
                [
                    84.9251017,
                    56.4392608
                ],
                [
                    84.9259953,
                    56.4384114
                ],
                [
                    84.9261455,
                    56.4381534
                ],
                [
                    84.9262367,
                    56.4378895
                ],
                [
                    84.9262659,
                    56.4377068
                ],
                [
                    84.9262205,
                    56.4374832
                ],
                [
                    84.9261585,
                    56.4372916
                ],
                [
                    84.9260606,
                    56.4371567
                ],
                [
                    84.9260328,
                    56.4371184
                ],
                [
                    84.9257992,
                    56.4369327
                ],
                [
                    84.9254696,
                    56.4366854
                ],
                [
                    84.9252197,
                    56.4365709
                ],
                [
                    84.9247853,
                    56.4364107
                ],
                [
                    84.9244152,
                    56.436301
                ],
                [
                    84.9240504,
                    56.4362269
                ],
                [
                    84.9234764,
                    56.4361171
                ],
                [
                    84.9228273,
                    56.4359807
                ],
                [
                    84.922425,
                    56.4359244
                ],
                [
                    84.9218939,
                    56.4358561
                ],
                [
                    84.9215559,
                    56.4357731
                ],
                [
                    84.9212069,
                    56.4356634
                ],
                [
                    84.9210813,
                    56.4355435
                ],
                [
                    84.9209901,
                    56.4353359
                ],
                [
                    84.9209976,
                    56.4351206
                ],
                [
                    84.9193136,
                    56.4348863
                ],
                [
                    84.91979,
                    56.4375746
                ],
                [
                    84.9162355,
                    56.43787
                ],
                [
                    84.9158549,
                    56.4363935
                ],
                [
                    84.9152989,
                    56.43646
                ],
                [
                    84.9142205,
                    56.4373616
                ],
                [
                    84.9131853,
                    56.4376908
                ],
                [
                    84.9120104,
                    56.4383936
                ],
                [
                    84.9113475,
                    56.4385994
                ]
            ],
            "longitude": 84.9204001,
            "latitude": 56.4391699
        },
        "9362": {
            "name": "Штамово",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    84.9649788,
                    56.5761611
                ],
                [
                    84.9651931,
                    56.576205
                ],
                [
                    84.9659012,
                    56.5761297
                ],
                [
                    84.9667488,
                    56.57627
                ],
                [
                    84.9672531,
                    56.5763365
                ],
                [
                    84.9675749,
                    56.5763764
                ],
                [
                    84.9680577,
                    56.576471
                ],
                [
                    84.9683796,
                    56.5764887
                ],
                [
                    84.969077,
                    56.5763173
                ],
                [
                    84.9694203,
                    56.5761105
                ],
                [
                    84.9696027,
                    56.5759509
                ],
                [
                    84.9698387,
                    56.5758445
                ],
                [
                    84.970225,
                    56.5757751
                ],
                [
                    84.9707829,
                    56.5758105
                ],
                [
                    84.9712227,
                    56.5757987
                ],
                [
                    84.9717163,
                    56.5758046
                ],
                [
                    84.9719738,
                    56.5757514
                ],
                [
                    84.9722098,
                    56.5755978
                ],
                [
                    84.9724244,
                    56.5753954
                ],
                [
                    84.9728642,
                    56.5751413
                ],
                [
                    84.9733256,
                    56.5751235
                ],
                [
                    84.9739157,
                    56.5751235
                ],
                [
                    84.9743448,
                    56.5750718
                ],
                [
                    84.9747954,
                    56.5749935
                ],
                [
                    84.9750315,
                    56.5748576
                ],
                [
                    84.9756859,
                    56.5745104
                ],
                [
                    84.9762975,
                    56.5743375
                ],
                [
                    84.9769412,
                    56.5744335
                ],
                [
                    84.9774669,
                    56.5745458
                ],
                [
                    84.9780034,
                    56.574633
                ],
                [
                    84.9784754,
                    56.5746108
                ],
                [
                    84.9795376,
                    56.5744926
                ],
                [
                    84.9796127,
                    56.5729427
                ],
                [
                    84.9787544,
                    56.5719631
                ],
                [
                    84.9781536,
                    56.5717843
                ],
                [
                    84.972757,
                    56.5721507
                ],
                [
                    84.9695383,
                    56.5723871
                ],
                [
                    84.967296,
                    56.5729383
                ],
                [
                    84.9659047,
                    56.574745
                ],
                [
                    84.9649788,
                    56.5761611
                ]
            ],
            "longitude": 84.9709652,
            "latitude": 56.5743331
        },
        "9363": {
            "name": "Казанка",
            "population": 84,
            "type": "hamlet",
            "poly": [
                [
                    84.9665674,
                    56.3009741
                ],
                [
                    84.9693956,
                    56.3024141
                ],
                [
                    84.9721368,
                    56.3018974
                ],
                [
                    84.972832,
                    56.3026807
                ],
                [
                    84.9741315,
                    56.3026868
                ],
                [
                    84.9755013,
                    56.3032879
                ],
                [
                    84.9774089,
                    56.3030111
                ],
                [
                    84.9780797,
                    56.3026392
                ],
                [
                    84.9799601,
                    56.3019998
                ],
                [
                    84.9806546,
                    56.3010677
                ],
                [
                    84.9802255,
                    56.3004962
                ],
                [
                    84.9767064,
                    56.3002105
                ],
                [
                    84.9757623,
                    56.3001629
                ],
                [
                    84.9760198,
                    56.2995914
                ],
                [
                    84.9774443,
                    56.2995615
                ],
                [
                    84.9774969,
                    56.298893
                ],
                [
                    84.9749595,
                    56.2992014
                ],
                [
                    84.971713,
                    56.2999211
                ],
                [
                    84.9665674,
                    56.3009741
                ]
            ],
            "longitude": 84.9747267,
            "latitude": 56.3010213
        },
        "9364": {
            "name": "Спутник",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    84.9784582,
                    56.5712764
                ],
                [
                    84.9810049,
                    56.5727129
                ],
                [
                    84.9829039,
                    56.5728133
                ],
                [
                    84.9873242,
                    56.5720509
                ],
                [
                    84.9889335,
                    56.5694281
                ],
                [
                    84.9875061,
                    56.5693285
                ],
                [
                    84.9803933,
                    56.5706028
                ],
                [
                    84.9793791,
                    56.5709113
                ],
                [
                    84.9784582,
                    56.5712764
                ]
            ],
            "longitude": 84.9844277,
            "latitude": 56.5707372
        },
        "9365": {
            "name": "Писарево",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0151759,
            "latitude": 56.395067
        },
        "9366": {
            "name": "Просекино",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0294037,
            "latitude": 56.3815178
        },
        "9367": {
            "name": "Георгиевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0406109,
            "latitude": 56.7904369
        },
        "9368": {
            "name": "Надежда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.05719,
            "latitude": 56.730797
        },
        "9369": {
            "name": "Киргизка",
            "population": 142,
            "type": "hamlet",
            "poly": [
                [
                    85.0575901,
                    56.551115
                ],
                [
                    85.0714119,
                    56.5584219
                ],
                [
                    85.0772891,
                    56.5559174
                ],
                [
                    85.0764178,
                    56.5552018
                ],
                [
                    85.0797835,
                    56.5533373
                ],
                [
                    85.067431,
                    56.5466133
                ],
                [
                    85.0595891,
                    56.5483839
                ],
                [
                    85.0575901,
                    56.551115
                ]
            ],
            "longitude": 85.0683275,
            "latitude": 56.5507733
        },
        "9370": {
            "name": "Михайловка",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0770052,
            "latitude": 56.7338441
        },
        "9371": {
            "name": "Реженка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    85.1051077,
                    56.5838391
                ],
                [
                    85.1074691,
                    56.5848332
                ],
                [
                    85.1109882,
                    56.5855304
                ],
                [
                    85.1133271,
                    56.5865112
                ],
                [
                    85.1164813,
                    56.5861331
                ],
                [
                    85.1171035,
                    56.5859499
                ],
                [
                    85.1193556,
                    56.5845541
                ],
                [
                    85.1192387,
                    56.5835629
                ],
                [
                    85.1108295,
                    56.5792567
                ],
                [
                    85.1084025,
                    56.5806321
                ],
                [
                    85.1071894,
                    56.5809972
                ],
                [
                    85.1068254,
                    56.5810103
                ],
                [
                    85.105495,
                    56.581938
                ],
                [
                    85.1051077,
                    56.5838391
                ]
            ],
            "longitude": 85.1127941,
            "latitude": 56.5835815
        },
        "9372": {
            "name": "Копылово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1253153,
            "latitude": 56.5809337
        },
        "9373": {
            "name": "Малая Михайловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.132301,
            "latitude": 56.525112
        },
        "9374": {
            "name": "Бобровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1521179,
            "latitude": 56.720905
        },
        "9375": {
            "name": "Конинино",
            "population": 147,
            "type": "hamlet",
            "poly": [
                [
                    85.1474056,
                    56.6331664
                ],
                [
                    85.1485062,
                    56.6353201
                ],
                [
                    85.1539287,
                    56.6339453
                ],
                [
                    85.1591923,
                    56.6335971
                ],
                [
                    85.1660308,
                    56.6327651
                ],
                [
                    85.1664879,
                    56.6314728
                ],
                [
                    85.1620247,
                    56.6295844
                ],
                [
                    85.1529416,
                    56.6224726
                ],
                [
                    85.1490363,
                    56.6233225
                ],
                [
                    85.1557739,
                    56.6313489
                ],
                [
                    85.1474056,
                    56.6331664
                ]
            ],
            "longitude": 85.158211,
            "latitude": 56.628941
        },
        "9376": {
            "name": "Санджик",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.184174,
            "latitude": 58.277176
        },
        "9377": {
            "name": "104 км",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1903019,
            "latitude": 56.6034955
        },
        "9378": {
            "name": "Постниково",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1943052,
            "latitude": 56.6053475
        },
        "9379": {
            "name": "Ягодное",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1966831,
            "latitude": 56.3669239
        },
        "9380": {
            "name": "Авиатор-1",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    85.1966867,
                    56.4027529
                ],
                [
                    85.1975906,
                    56.4031914
                ],
                [
                    85.199009,
                    56.4035722
                ],
                [
                    85.2006081,
                    56.4038877
                ],
                [
                    85.2010796,
                    56.4037749
                ],
                [
                    85.2023296,
                    56.4017104
                ],
                [
                    85.2025579,
                    56.4015774
                ],
                [
                    85.2032308,
                    56.4006459
                ],
                [
                    85.2012315,
                    56.400132
                ],
                [
                    85.2011415,
                    56.4002639
                ],
                [
                    85.2006189,
                    56.4004417
                ],
                [
                    85.2004515,
                    56.4007768
                ],
                [
                    85.2006395,
                    56.4009998
                ],
                [
                    85.2010882,
                    56.4013569
                ],
                [
                    85.2005561,
                    56.401798
                ],
                [
                    85.199995,
                    56.4019446
                ],
                [
                    85.1979468,
                    56.4014925
                ],
                [
                    85.1966867,
                    56.4027529
                ]
            ],
            "longitude": 85.2015126,
            "latitude": 56.4020108
        },
        "9381": {
            "name": "Каштак",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2045154,
            "latitude": 56.3572051
        },
        "9382": {
            "name": "Авиатор-2",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    85.2009252,
                    56.3987285
                ],
                [
                    85.2010727,
                    56.3988493
                ],
                [
                    85.2014348,
                    56.3990348
                ],
                [
                    85.2028086,
                    56.3993192
                ],
                [
                    85.2041626,
                    56.3995422
                ],
                [
                    85.2062477,
                    56.3966574
                ],
                [
                    85.20442,
                    56.3964285
                ],
                [
                    85.2027056,
                    56.396454
                ],
                [
                    85.2014809,
                    56.3982918
                ],
                [
                    85.2011427,
                    56.3984215
                ],
                [
                    85.2010121,
                    56.398586
                ],
                [
                    85.2009252,
                    56.3987285
                ]
            ],
            "longitude": 85.2047098,
            "latitude": 56.3971304
        },
        "9383": {
            "name": "Восход",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2047991,
            "latitude": 56.4215211
        },
        "9384": {
            "name": "Вороново",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2132607,
            "latitude": 56.340124
        },
        "9385": {
            "name": "Кусково",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.227486,
            "latitude": 56.639107
        },
        "9386": {
            "name": "Бодажково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2345515,
            "latitude": 56.4919087
        },
        "9387": {
            "name": "Каракозово",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2385387,
            "latitude": 57.0061068
        },
        "9388": {
            "name": "Плотниково",
            "population": 131,
            "type": "hamlet",
            "poly": [
                [
                    85.2366763,
                    56.3784053
                ],
                [
                    85.2378286,
                    56.3806032
                ],
                [
                    85.2397007,
                    56.3823615
                ],
                [
                    85.2369767,
                    56.3834663
                ],
                [
                    85.2367986,
                    56.385272
                ],
                [
                    85.243134,
                    56.3867325
                ],
                [
                    85.2443732,
                    56.3882535
                ],
                [
                    85.2467603,
                    56.388146
                ],
                [
                    85.2484984,
                    56.3864124
                ],
                [
                    85.2475543,
                    56.3855571
                ],
                [
                    85.2451295,
                    56.3840247
                ],
                [
                    85.2442498,
                    56.3827417
                ],
                [
                    85.2423615,
                    56.379831
                ],
                [
                    85.2412242,
                    56.3778587
                ],
                [
                    85.2381987,
                    56.3778944
                ],
                [
                    85.2366763,
                    56.3784053
                ]
            ],
            "longitude": 85.244354,
            "latitude": 56.385349
        },
        "9389": {
            "name": "СТ \"Маяк\"",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2638467,
            "latitude": 56.4308015
        },
        "9390": {
            "name": "Аркашево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2654505,
            "latitude": 56.4431674
        },
        "9391": {
            "name": "Петухово",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2743624,
            "latitude": 56.3514228
        },
        "9392": {
            "name": "Москали",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3385091,
            "latitude": 56.7150025
        },
        "9393": {
            "name": "Смена",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4118542,
            "latitude": 56.3732365
        },
        "9394": {
            "name": "Милоновка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4334757,
            "latitude": 56.6700735
        },
        "9395": {
            "name": "26 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4357196,
            "latitude": 56.2120819
        },
        "9396": {
            "name": "Николаевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4391406,
            "latitude": 56.6961913
        },
        "9397": {
            "name": "41 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4414103,
            "latitude": 56.3188286
        },
        "9398": {
            "name": "31 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4652453,
            "latitude": 56.2500579
        },
        "9399": {
            "name": "129 км",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4721703,
            "latitude": 56.7468854
        },
        "9400": {
            "name": "Ольговка",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.488579,
            "latitude": 56.8233153
        },
        "9401": {
            "name": "Ущерб",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4981921,
            "latitude": 56.7431954
        },
        "9402": {
            "name": "Суетиловка",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    85.6450041,
                    56.5907981
                ],
                [
                    85.6457214,
                    56.5917427
                ],
                [
                    85.6473746,
                    56.5931337
                ],
                [
                    85.6488094,
                    56.5953318
                ],
                [
                    85.6496827,
                    56.5957955
                ],
                [
                    85.6517413,
                    56.5966884
                ],
                [
                    85.6535504,
                    56.5973581
                ],
                [
                    85.6546733,
                    56.5970833
                ],
                [
                    85.655453,
                    56.5966884
                ],
                [
                    85.6559833,
                    56.5962419
                ],
                [
                    85.6562952,
                    56.5947995
                ],
                [
                    85.6545797,
                    56.594353
                ],
                [
                    85.6521156,
                    56.5939752
                ],
                [
                    85.6518349,
                    56.5926357
                ],
                [
                    85.6512111,
                    56.5902142
                ],
                [
                    85.6477801,
                    56.5902829
                ],
                [
                    85.6450041,
                    56.5907981
                ]
            ],
            "longitude": 85.6510605,
            "latitude": 56.5942182
        },
        "9403": {
            "name": "Камаевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7353228,
            "latitude": 56.6572655
        },
        "9404": {
            "name": "Копыловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.738724,
            "latitude": 57.482704
        },
        "9405": {
            "name": "Митрофановка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7445721,
            "latitude": 57.2054912
        },
        "9406": {
            "name": "Осколково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7597476,
            "latitude": 57.5047034
        },
        "9407": {
            "name": "Комаровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7627202,
            "latitude": 57.4868919
        },
        "9408": {
            "name": "153 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7802482,
            "latitude": 56.8784475
        },
        "9409": {
            "name": "Михайловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.780792,
            "latitude": 57.275623
        },
        "9410": {
            "name": "Совхозный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8048393,
            "latitude": 57.5730602
        },
        "9411": {
            "name": "Отрадный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8276469,
            "latitude": 57.4198403
        },
        "9412": {
            "name": "Минаевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.838058,
            "latitude": 57.43354
        },
        "9413": {
            "name": "161 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8862702,
            "latitude": 56.9092555
        },
        "9414": {
            "name": "Вороно-Пашня",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.893875,
            "latitude": 56.899044
        },
        "9415": {
            "name": "Караколь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.901985,
            "latitude": 57.257336
        },
        "9416": {
            "name": "Ново-Троица",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.967361,
            "latitude": 56.919498
        },
        "9417": {
            "name": "Горьковка",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9767847,
            "latitude": 56.7019237
        },
        "9418": {
            "name": "167 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0005268,
            "latitude": 56.9352909
        },
        "9419": {
            "name": "169 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0356744,
            "latitude": 56.939159
        },
        "9420": {
            "name": "Балагачево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0435729,
            "latitude": 57.4189157
        },
        "9421": {
            "name": "Спасо-Яйское",
            "population": 211,
            "type": "hamlet",
            "poly": [
                [
                    86.1123843,
                    56.7018679
                ],
                [
                    86.1124701,
                    56.7078518
                ],
                [
                    86.1142725,
                    56.7134107
                ],
                [
                    86.1212247,
                    56.7175064
                ],
                [
                    86.1207098,
                    56.7191078
                ],
                [
                    86.1224265,
                    56.720191
                ],
                [
                    86.1292843,
                    56.7174781
                ],
                [
                    86.1291212,
                    56.7150594
                ],
                [
                    86.1268896,
                    56.715813
                ],
                [
                    86.1244864,
                    56.7155775
                ],
                [
                    86.1226754,
                    56.7136627
                ],
                [
                    86.1224265,
                    56.7062028
                ],
                [
                    86.1200232,
                    56.703894
                ],
                [
                    86.1188988,
                    56.7022614
                ],
                [
                    86.1183838,
                    56.6980674
                ],
                [
                    86.1135859,
                    56.6974383
                ],
                [
                    86.1123843,
                    56.7018679
                ]
            ],
            "longitude": 86.116928,
            "latitude": 56.705891
        },
        "9422": {
            "name": "Сахалинка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1179022,
            "latitude": 57.2787891
        },
        "9423": {
            "name": "Усманка",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1601958,
            "latitude": 56.6305224
        },
        "9424": {
            "name": "Заречный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1718726,
            "latitude": 57.1791539
        },
        "9425": {
            "name": "Новостройка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1727839,
            "latitude": 56.6230148
        },
        "9426": {
            "name": "Куендат",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1815476,
            "latitude": 57.114462
        },
        "9427": {
            "name": "Борисова Гора",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.189466,
            "latitude": 57.091415
        },
        "9428": {
            "name": "Феоктистовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.200218,
            "latitude": 56.966209
        },
        "9429": {
            "name": "Майский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2234654,
            "latitude": 57.1090675
        },
        "9430": {
            "name": "Причулымский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2460948,
            "latitude": 57.0035883
        },
        "9431": {
            "name": "Петровск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2916941,
            "latitude": 57.2087283
        },
        "9432": {
            "name": "Верх Куендат",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4029307,
            "latitude": 57.1456419
        },
        "9433": {
            "name": "Францево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4091105,
            "latitude": 57.5621624
        },
        "9434": {
            "name": "Васильевка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4674541,
            "latitude": 56.6051874
        },
        "9435": {
            "name": "Кульдорск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6114563,
            "latitude": 56.9647395
        },
        "9436": {
            "name": "Линда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6425573,
            "latitude": 57.1413298
        },
        "9437": {
            "name": "Бихтулино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7018943,
            "latitude": 56.9395681
        },
        "9438": {
            "name": "Лиллиенгофка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.7203237,
            "latitude": 57.0350849
        },
        "9439": {
            "name": "Вамбалы",
            "population": 224,
            "type": "hamlet",
            "poly": [
                [
                    86.723701,
                    56.6635259
                ],
                [
                    86.7337947,
                    56.6677355
                ],
                [
                    86.7461544,
                    56.6672167
                ],
                [
                    86.7482143,
                    56.6646698
                ],
                [
                    86.747871,
                    56.6543411
                ],
                [
                    86.7418628,
                    56.6542939
                ],
                [
                    86.7307392,
                    56.655648
                ],
                [
                    86.725246,
                    56.6572048
                ],
                [
                    86.723701,
                    56.6635259
                ]
            ],
            "longitude": 86.733192,
            "latitude": 56.658772
        },
        "9440": {
            "name": "Гагарино",
            "population": 213,
            "type": "hamlet",
            "poly": [
                [
                    86.7979693,
                    56.7003204
                ],
                [
                    86.8050901,
                    56.7022096
                ],
                [
                    86.8133727,
                    56.7036232
                ],
                [
                    86.8186835,
                    56.7036114
                ],
                [
                    86.828039,
                    56.705025
                ],
                [
                    86.8297235,
                    56.7021154
                ],
                [
                    86.7988416,
                    56.6979165
                ],
                [
                    86.7979693,
                    56.7003204
                ]
            ],
            "longitude": 86.812881,
            "latitude": 56.701244
        },
        "9441": {
            "name": "Малиновка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.8262028,
            "latitude": 57.0240246
        },
        "9442": {
            "name": "Туендат",
            "population": 172,
            "type": "hamlet",
            "poly": [
                [
                    86.9264439,
                    56.7285042
                ],
                [
                    86.929802,
                    56.7382629
                ],
                [
                    86.9341258,
                    56.7374497
                ],
                [
                    86.9367436,
                    56.7365081
                ],
                [
                    86.9356814,
                    56.7385218
                ],
                [
                    86.9362715,
                    56.7404154
                ],
                [
                    86.938589,
                    56.7398976
                ],
                [
                    86.938589,
                    56.7388149
                ],
                [
                    86.9405631,
                    56.7339894
                ],
                [
                    86.9418076,
                    56.7291398
                ],
                [
                    86.9413355,
                    56.7280568
                ],
                [
                    86.9382027,
                    56.7253021
                ],
                [
                    86.9366578,
                    56.7262203
                ],
                [
                    86.9378594,
                    56.7284571
                ],
                [
                    86.9373015,
                    56.7288338
                ],
                [
                    86.9380418,
                    56.7313893
                ],
                [
                    86.936529,
                    56.7329772
                ],
                [
                    86.933482,
                    56.7333774
                ],
                [
                    86.9325379,
                    56.7318943
                ],
                [
                    86.9309929,
                    56.7316118
                ],
                [
                    86.9300917,
                    56.7294223
                ],
                [
                    86.9290188,
                    56.727892
                ],
                [
                    86.9264439,
                    56.7285042
                ]
            ],
            "longitude": 86.938705,
            "latitude": 56.73307
        },
        "9443": {
            "name": "Тукай",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    87.1039643,
                    56.7444634
                ],
                [
                    87.1045651,
                    56.7444634
                ],
                [
                    87.1046939,
                    56.7440045
                ],
                [
                    87.1063032,
                    56.7443222
                ],
                [
                    87.1107664,
                    56.7394386
                ],
                [
                    87.1163765,
                    56.7372625
                ],
                [
                    87.1160975,
                    56.7369448
                ],
                [
                    87.1174612,
                    56.7365788
                ],
                [
                    87.1170202,
                    56.7361445
                ],
                [
                    87.1133295,
                    56.7368506
                ],
                [
                    87.1102085,
                    56.7378145
                ],
                [
                    87.1077934,
                    56.7392397
                ],
                [
                    87.1061959,
                    56.7405213
                ],
                [
                    87.1050683,
                    56.741711
                ],
                [
                    87.1042433,
                    56.7431808
                ],
                [
                    87.1039643,
                    56.7444634
                ]
            ],
            "longitude": 87.109802,
            "latitude": 56.7389867
        },
        "9444": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.2354249,
            "latitude": 59.232578
        },
        "9445": {
            "name": "Орловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.2906044,
            "latitude": 57.0518289
        },
        "9446": {
            "name": "вахт.п. Чуйка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.3753501,
            "latitude": 58.0291414
        },
        "9447": {
            "name": "вахт.п. Жаровка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.5434066,
            "latitude": 58.0392291
        },
        "9448": {
            "name": "Красный Яр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.6157751,
            "latitude": 57.2275618
        },
        "9449": {
            "name": "Байгалы",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 87.8860072,
            "latitude": 57.245075
        },
        "9450": {
            "name": "Покровский Яр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.2801091,
            "latitude": 57.0784204
        },
        "9451": {
            "name": "Куяновская Гарь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.3586667,
            "latitude": 57.3481773
        },
        "9452": {
            "name": "Озёрное",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.6373285,
            "latitude": 57.4761177
        },
        "9453": {
            "name": "Верхнее Скоблино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 88.6413187,
            "latitude": 57.450201
        },
        "9454": {
            "name": "Покровка",
            "population": 101,
            "type": "hamlet",
            "poly": [
                [
                    75.1291272,
                    55.7091944
                ],
                [
                    75.1374271,
                    55.7107779
                ],
                [
                    75.1415903,
                    55.7099264
                ],
                [
                    75.1433139,
                    55.7083129
                ],
                [
                    75.1373741,
                    55.7067442
                ],
                [
                    75.1385673,
                    55.704772
                ],
                [
                    75.1359952,
                    55.7039353
                ],
                [
                    75.1332904,
                    55.7044284
                ],
                [
                    75.1322297,
                    55.7049961
                ],
                [
                    75.1304531,
                    55.7066546
                ],
                [
                    75.1291272,
                    55.7091944
                ]
            ],
            "longitude": 75.134377,
            "latitude": 55.70591
        },
        "9455": {
            "name": "Степановка 1-я",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    75.1845696,
                    55.3880003
                ],
                [
                    75.185545,
                    55.3936136
                ],
                [
                    75.1865975,
                    55.3960337
                ],
                [
                    75.189986,
                    55.3991533
                ],
                [
                    75.1974047,
                    55.3983078
                ],
                [
                    75.1979438,
                    55.39564
                ],
                [
                    75.1989706,
                    55.3940072
                ],
                [
                    75.1976357,
                    55.3889043
                ],
                [
                    75.1932975,
                    55.3886127
                ],
                [
                    75.1882661,
                    55.3876649
                ],
                [
                    75.1845696,
                    55.3880003
                ]
            ],
            "longitude": 75.192276,
            "latitude": 55.393391
        },
        "9456": {
            "name": "Рождественка",
            "population": 69,
            "type": "hamlet",
            "poly": [
                [
                    75.2370981,
                    55.4183943
                ],
                [
                    75.245749,
                    55.4250085
                ],
                [
                    75.2517301,
                    55.4275868
                ],
                [
                    75.2622036,
                    55.4228379
                ],
                [
                    75.2468755,
                    55.4136971
                ],
                [
                    75.2432076,
                    55.4129447
                ],
                [
                    75.2381249,
                    55.4148245
                ],
                [
                    75.2370981,
                    55.4183943
                ]
            ],
            "longitude": 75.248589,
            "latitude": 55.421307
        },
        "9457": {
            "name": "Николо-Гавриловка",
            "population": 84,
            "type": "hamlet",
            "poly": [
                [
                    75.2642508,
                    55.7005298
                ],
                [
                    75.2652712,
                    55.7021589
                ],
                [
                    75.2664049,
                    55.7029893
                ],
                [
                    75.2687574,
                    55.7028296
                ],
                [
                    75.2715067,
                    55.7018873
                ],
                [
                    75.2726688,
                    55.7028137
                ],
                [
                    75.2768636,
                    55.7016318
                ],
                [
                    75.2757865,
                    55.7004978
                ],
                [
                    75.2774021,
                    55.6995714
                ],
                [
                    75.2751063,
                    55.6975429
                ],
                [
                    75.2710532,
                    55.6981658
                ],
                [
                    75.2696644,
                    55.6985652
                ],
                [
                    75.2642508,
                    55.7005298
                ]
            ],
            "longitude": 75.27169,
            "latitude": 55.700714
        },
        "9458": {
            "name": "Воздвиженка",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    75.2739717,
                    55.2816963
                ],
                [
                    75.2740501,
                    55.2848912
                ],
                [
                    75.2782869,
                    55.2848912
                ],
                [
                    75.2781691,
                    55.2886666
                ],
                [
                    75.2980192,
                    55.290543
                ],
                [
                    75.2988038,
                    55.2900739
                ],
                [
                    75.2975485,
                    55.2821655
                ],
                [
                    75.2802484,
                    55.2797078
                ],
                [
                    75.2739717,
                    55.2816963
                ]
            ],
            "longitude": 75.283012,
            "latitude": 55.283173
        },
        "9459": {
            "name": "Резино",
            "population": 102,
            "type": "hamlet",
            "poly": [
                [
                    75.2865001,
                    55.8442911
                ],
                [
                    75.294148,
                    55.845964
                ],
                [
                    75.2997432,
                    55.8476926
                ],
                [
                    75.2983527,
                    55.8494768
                ],
                [
                    75.3064973,
                    55.8508336
                ],
                [
                    75.3068283,
                    55.8515956
                ],
                [
                    75.3097087,
                    55.8514097
                ],
                [
                    75.3102715,
                    55.8499229
                ],
                [
                    75.3072256,
                    55.8471164
                ],
                [
                    75.3066297,
                    55.8456108
                ],
                [
                    75.2998757,
                    55.8431572
                ],
                [
                    75.2958034,
                    55.8424694
                ],
                [
                    75.2894136,
                    55.8418002
                ],
                [
                    75.2865001,
                    55.8442911
                ]
            ],
            "longitude": 75.297737,
            "latitude": 55.84584
        },
        "9460": {
            "name": "Кузнецово",
            "population": 166,
            "type": "hamlet",
            "poly": [
                [
                    75.3383671,
                    55.193591
                ],
                [
                    75.3395182,
                    55.1955894
                ],
                [
                    75.3648891,
                    55.1967391
                ],
                [
                    75.3688698,
                    55.184775
                ],
                [
                    75.3654646,
                    55.1844738
                ],
                [
                    75.3525154,
                    55.1849119
                ],
                [
                    75.3390386,
                    55.1915925
                ],
                [
                    75.3383671,
                    55.193591
                ]
            ],
            "longitude": 75.354401,
            "latitude": 55.190151
        },
        "9461": {
            "name": "Моховая",
            "population": 82,
            "type": "hamlet",
            "poly": [
                [
                    75.3556313,
                    54.9402015
                ],
                [
                    75.3883069,
                    54.9428732
                ],
                [
                    75.3893087,
                    54.9387124
                ],
                [
                    75.3783665,
                    54.9378049
                ],
                [
                    75.3786362,
                    54.9364105
                ],
                [
                    75.3721634,
                    54.9353259
                ],
                [
                    75.3724331,
                    54.9340642
                ],
                [
                    75.3566424,
                    54.9328494
                ],
                [
                    75.3556313,
                    54.9402015
                ]
            ],
            "longitude": 75.366081,
            "latitude": 54.937073
        },
        "9462": {
            "name": "Остановочная Платформа Лаг",
            "population": 56,
            "type": "hamlet",
            "poly": [
                [
                    75.3875134,
                    55.1455385
                ],
                [
                    75.4057674,
                    55.1478521
                ],
                [
                    75.4060703,
                    55.1471829
                ],
                [
                    75.4046164,
                    55.1469175
                ],
                [
                    75.3911884,
                    55.1447076
                ],
                [
                    75.3880889,
                    55.1441133
                ],
                [
                    75.3875134,
                    55.1455385
                ]
            ],
            "longitude": 75.399551,
            "latitude": 55.146664
        },
        "9463": {
            "name": "Сибиряк",
            "population": 72,
            "type": "hamlet",
            "poly": [
                [
                    75.3858223,
                    55.1484034
                ],
                [
                    75.386414,
                    55.1484634
                ],
                [
                    75.3912468,
                    55.149089
                ],
                [
                    75.4037735,
                    55.1506089
                ],
                [
                    75.4068477,
                    55.1507953
                ],
                [
                    75.411946,
                    55.1505644
                ],
                [
                    75.4132802,
                    55.1504801
                ],
                [
                    75.4133391,
                    55.1491882
                ],
                [
                    75.3868598,
                    55.1461088
                ],
                [
                    75.3858223,
                    55.1484034
                ]
            ],
            "longitude": 75.399567,
            "latitude": 55.148376
        },
        "9464": {
            "name": "Дмитриевка",
            "population": 58,
            "type": "hamlet",
            "poly": [
                [
                    75.401104,
                    55.7076923
                ],
                [
                    75.4013937,
                    55.7092842
                ],
                [
                    75.4039295,
                    55.7091413
                ],
                [
                    75.4051249,
                    55.7111413
                ],
                [
                    75.4073346,
                    55.7138554
                ],
                [
                    75.4126595,
                    55.7128351
                ],
                [
                    75.4109931,
                    55.710427
                ],
                [
                    75.4100152,
                    55.7105087
                ],
                [
                    75.4093994,
                    55.7096107
                ],
                [
                    75.4089283,
                    55.707978
                ],
                [
                    75.4107759,
                    55.7060595
                ],
                [
                    75.4103412,
                    55.7055084
                ],
                [
                    75.4084575,
                    55.7053247
                ],
                [
                    75.4049438,
                    55.7060595
                ],
                [
                    75.4050886,
                    55.7066106
                ],
                [
                    75.4036397,
                    55.7068147
                ],
                [
                    75.4038932,
                    55.7074882
                ],
                [
                    75.401104,
                    55.7076923
                ]
            ],
            "longitude": 75.405731,
            "latitude": 55.708115
        },
        "9465": {
            "name": "Красноникольск",
            "population": 105,
            "type": "hamlet",
            "poly": [
                [
                    75.406317,
                    55.6139842
                ],
                [
                    75.4101478,
                    55.6167085
                ],
                [
                    75.4112119,
                    55.6165683
                ],
                [
                    75.412808,
                    55.6174096
                ],
                [
                    75.4228815,
                    55.6132631
                ],
                [
                    75.4207178,
                    55.6108791
                ],
                [
                    75.4191926,
                    55.608455
                ],
                [
                    75.4129854,
                    55.6088557
                ],
                [
                    75.4096512,
                    55.6089759
                ],
                [
                    75.4084098,
                    55.6093966
                ],
                [
                    75.4084098,
                    55.6121412
                ],
                [
                    75.406317,
                    55.6139842
                ]
            ],
            "longitude": 75.415215,
            "latitude": 55.61195
        },
        "9466": {
            "name": "Платоновка",
            "population": 201,
            "type": "hamlet",
            "poly": [
                [
                    75.4140277,
                    55.1575719
                ],
                [
                    75.4180649,
                    55.1591445
                ],
                [
                    75.4259925,
                    55.1617864
                ],
                [
                    75.4261393,
                    55.1661891
                ],
                [
                    75.4284148,
                    55.1683483
                ],
                [
                    75.4443067,
                    55.1592494
                ],
                [
                    75.4434259,
                    55.156146
                ],
                [
                    75.4312408,
                    55.1553282
                ],
                [
                    75.4301765,
                    55.1559783
                ],
                [
                    75.4227994,
                    55.1542378
                ],
                [
                    75.4140277,
                    55.1575719
                ]
            ],
            "longitude": 75.431587,
            "latitude": 55.160053
        },
        "9467": {
            "name": "Зелёная Грива",
            "population": 35,
            "type": "hamlet",
            "poly": [
                [
                    75.4366852,
                    55.4420221
                ],
                [
                    75.4444234,
                    55.4454507
                ],
                [
                    75.4458381,
                    55.4457911
                ],
                [
                    75.4505111,
                    55.4458884
                ],
                [
                    75.4540267,
                    55.4434567
                ],
                [
                    75.457285,
                    55.4346526
                ],
                [
                    75.4505181,
                    55.4352814
                ],
                [
                    75.4502968,
                    55.4338257
                ],
                [
                    75.4446377,
                    55.4336554
                ],
                [
                    75.4406506,
                    55.4348229
                ],
                [
                    75.438507,
                    55.4378875
                ],
                [
                    75.4384642,
                    55.4401736
                ],
                [
                    75.4366852,
                    55.4420221
                ]
            ],
            "longitude": 75.444588,
            "latitude": 55.438675
        },
        "9468": {
            "name": "Зелёная Роща",
            "population": 150,
            "type": "hamlet",
            "poly": [
                [
                    75.4676877,
                    55.582226
                ],
                [
                    75.4691479,
                    55.5831451
                ],
                [
                    75.4755526,
                    55.5850957
                ],
                [
                    75.4812604,
                    55.583689
                ],
                [
                    75.4769795,
                    55.5797688
                ],
                [
                    75.4781409,
                    55.5789621
                ],
                [
                    75.4777096,
                    55.5767486
                ],
                [
                    75.4761499,
                    55.5758481
                ],
                [
                    75.4703094,
                    55.579281
                ],
                [
                    75.469347,
                    55.5807442
                ],
                [
                    75.4676877,
                    55.582226
                ]
            ],
            "longitude": 75.473854,
            "latitude": 55.580673
        },
        "9469": {
            "name": "Розенталь",
            "population": 137,
            "type": "hamlet",
            "poly": [
                [
                    75.4689504,
                    55.3136214
                ],
                [
                    75.4740502,
                    55.3183372
                ],
                [
                    75.4833181,
                    55.3185325
                ],
                [
                    75.4829258,
                    55.3157422
                ],
                [
                    75.492537,
                    55.3150445
                ],
                [
                    75.4968032,
                    55.3118912
                ],
                [
                    75.4713041,
                    55.3096027
                ],
                [
                    75.4689504,
                    55.3136214
                ]
            ],
            "longitude": 75.479279,
            "latitude": 55.313221
        },
        "9470": {
            "name": "Чинявино",
            "population": 102,
            "type": "hamlet",
            "poly": [
                [
                    75.469202,
                    55.5074347
                ],
                [
                    75.4704641,
                    55.5096317
                ],
                [
                    75.4723338,
                    55.5096317
                ],
                [
                    75.4720533,
                    55.5072229
                ],
                [
                    75.4808881,
                    55.5022195
                ],
                [
                    75.4842069,
                    55.4992277
                ],
                [
                    75.4887879,
                    55.498857
                ],
                [
                    75.4948179,
                    55.4995189
                ],
                [
                    75.4907044,
                    55.4956267
                ],
                [
                    75.4925275,
                    55.4941703
                ],
                [
                    75.4979031,
                    55.4929787
                ],
                [
                    75.502484,
                    55.4887944
                ],
                [
                    75.4934623,
                    55.4888739
                ],
                [
                    75.4830851,
                    55.4910455
                ],
                [
                    75.4760267,
                    55.4934818
                ],
                [
                    75.4758397,
                    55.4948058
                ],
                [
                    75.4741569,
                    55.4953884
                ],
                [
                    75.4738297,
                    55.4963681
                ],
                [
                    75.4787846,
                    55.4968712
                ],
                [
                    75.4807011,
                    55.4982216
                ],
                [
                    75.473035,
                    55.5006839
                ],
                [
                    75.4720066,
                    55.5038609
                ],
                [
                    75.4701369,
                    55.5046816
                ],
                [
                    75.4709783,
                    55.5070376
                ],
                [
                    75.469202,
                    55.5074347
                ]
            ],
            "longitude": 75.485817,
            "latitude": 55.494972
        },
        "9471": {
            "name": "Остановочная Платформа 2850",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 75.499771,
            "latitude": 55.159016
        },
        "9472": {
            "name": "Степановка 2-я",
            "population": 178,
            "type": "hamlet",
            "poly": [
                [
                    75.5024326,
                    55.2274721
                ],
                [
                    75.5064996,
                    55.2294852
                ],
                [
                    75.5038906,
                    55.2321327
                ],
                [
                    75.5036603,
                    55.2354583
                ],
                [
                    75.5206957,
                    55.2331611
                ],
                [
                    75.5283693,
                    55.2300323
                ],
                [
                    75.5278322,
                    55.2284787
                ],
                [
                    75.5211178,
                    55.2281505
                ],
                [
                    75.5215015,
                    55.2263999
                ],
                [
                    75.5243791,
                    55.2249338
                ],
                [
                    75.5221154,
                    55.2225703
                ],
                [
                    75.5192761,
                    55.2212134
                ],
                [
                    75.5170124,
                    55.2209945
                ],
                [
                    75.5072286,
                    55.2225922
                ],
                [
                    75.5024326,
                    55.2274721
                ]
            ],
            "longitude": 75.512527,
            "latitude": 55.228287
        },
        "9473": {
            "name": "Варваровка",
            "population": 75,
            "type": "hamlet",
            "poly": [
                [
                    75.5121925,
                    54.9590673
                ],
                [
                    75.5141036,
                    54.9619519
                ],
                [
                    75.533707,
                    54.9585187
                ],
                [
                    75.5321967,
                    54.9554215
                ],
                [
                    75.5121925,
                    54.9590673
                ]
            ],
            "longitude": 75.521095,
            "latitude": 54.958565
        },
        "9474": {
            "name": "Безбожник",
            "population": 53,
            "type": "hamlet",
            "poly": [
                [
                    75.5169029,
                    55.1798833
                ],
                [
                    75.5169413,
                    55.180913
                ],
                [
                    75.5221593,
                    55.1822493
                ],
                [
                    75.5215838,
                    55.1828627
                ],
                [
                    75.521814,
                    55.1839361
                ],
                [
                    75.5347824,
                    55.1861924
                ],
                [
                    75.5357416,
                    55.1861486
                ],
                [
                    75.5365857,
                    55.1843304
                ],
                [
                    75.5373147,
                    55.1744278
                ],
                [
                    75.519627,
                    55.1736609
                ],
                [
                    75.518783,
                    55.1757425
                ],
                [
                    75.5189364,
                    55.1780649
                ],
                [
                    75.5169029,
                    55.1798833
                ]
            ],
            "longitude": 75.527618,
            "latitude": 55.179325
        },
        "9475": {
            "name": "Воробьёво",
            "population": 72,
            "type": "hamlet",
            "poly": [
                [
                    75.5233789,
                    55.9608821
                ],
                [
                    75.5239217,
                    55.9642238
                ],
                [
                    75.5255499,
                    55.9666539
                ],
                [
                    75.5274947,
                    55.9680714
                ],
                [
                    75.5292585,
                    55.968451
                ],
                [
                    75.531927,
                    55.9672614
                ],
                [
                    75.5321983,
                    55.9650591
                ],
                [
                    75.5296204,
                    55.964806
                ],
                [
                    75.5286706,
                    55.9609581
                ],
                [
                    75.5264544,
                    55.9603505
                ],
                [
                    75.526364,
                    55.9591099
                ],
                [
                    75.5252333,
                    55.9590086
                ],
                [
                    75.5233789,
                    55.9608821
                ]
            ],
            "longitude": 75.528259,
            "latitude": 55.964359
        },
        "9476": {
            "name": "Михайловка",
            "population": 113,
            "type": "hamlet",
            "poly": [
                [
                    75.5579034,
                    55.4963381
                ],
                [
                    75.5592544,
                    55.4969617
                ],
                [
                    75.5588791,
                    55.4974577
                ],
                [
                    75.5597298,
                    55.4981946
                ],
                [
                    75.5619315,
                    55.4988749
                ],
                [
                    75.5675109,
                    55.4993709
                ],
                [
                    75.5725899,
                    55.4997394
                ],
                [
                    75.5725149,
                    55.5007597
                ],
                [
                    75.5747666,
                    55.5008447
                ],
                [
                    75.5779441,
                    55.4999803
                ],
                [
                    75.5807713,
                    55.4986907
                ],
                [
                    75.5807212,
                    55.4979112
                ],
                [
                    75.5777188,
                    55.496494
                ],
                [
                    75.5685367,
                    55.4957003
                ],
                [
                    75.5681613,
                    55.4953743
                ],
                [
                    75.5633076,
                    55.4937302
                ],
                [
                    75.5616813,
                    55.4965507
                ],
                [
                    75.5589292,
                    55.4955586
                ],
                [
                    75.5579034,
                    55.4963381
                ]
            ],
            "longitude": 75.568359,
            "latitude": 55.497486
        },
        "9477": {
            "name": "Мураши",
            "population": 175,
            "type": "hamlet",
            "poly": [
                [
                    75.5727612,
                    55.7173508
                ],
                [
                    75.5729758,
                    55.7203728
                ],
                [
                    75.5792915,
                    55.7209081
                ],
                [
                    75.5804565,
                    55.7204419
                ],
                [
                    75.58248,
                    55.72058
                ],
                [
                    75.5831545,
                    55.7222723
                ],
                [
                    75.5878453,
                    55.7220132
                ],
                [
                    75.5873241,
                    55.7179207
                ],
                [
                    75.5796288,
                    55.7173508
                ],
                [
                    75.5763176,
                    55.7171781
                ],
                [
                    75.5727612,
                    55.7173508
                ]
            ],
            "longitude": 75.580727,
            "latitude": 55.719433
        },
        "9478": {
            "name": "Тарка",
            "population": 147,
            "type": "hamlet",
            "poly": [
                [
                    75.6286767,
                    55.6098446
                ],
                [
                    75.6307889,
                    55.6114178
                ],
                [
                    75.6309986,
                    55.612373
                ],
                [
                    75.6327699,
                    55.613154
                ],
                [
                    75.6337979,
                    55.6126773
                ],
                [
                    75.634191,
                    55.612871
                ],
                [
                    75.6345341,
                    55.6129235
                ],
                [
                    75.6355491,
                    55.6123866
                ],
                [
                    75.6357706,
                    55.6125764
                ],
                [
                    75.6369236,
                    55.6118906
                ],
                [
                    75.6381436,
                    55.6124391
                ],
                [
                    75.639552,
                    55.6118537
                ],
                [
                    75.63923,
                    55.6108767
                ],
                [
                    75.6333191,
                    55.6084142
                ],
                [
                    75.63254,
                    55.6088018
                ],
                [
                    75.6316289,
                    55.6088356
                ],
                [
                    75.6306556,
                    55.6092234
                ],
                [
                    75.6303243,
                    55.6098232
                ],
                [
                    75.6295215,
                    55.609419
                ],
                [
                    75.6286767,
                    55.6098446
                ]
            ],
            "longitude": 75.632019,
            "latitude": 55.61182
        },
        "9479": {
            "name": "Малый Ермак",
            "population": 121,
            "type": "hamlet",
            "poly": [
                [
                    75.6369535,
                    55.2310074
                ],
                [
                    75.6382026,
                    55.2323181
                ],
                [
                    75.6437739,
                    55.2362072
                ],
                [
                    75.6466219,
                    55.2356611
                ],
                [
                    75.6503693,
                    55.2358653
                ],
                [
                    75.6540167,
                    55.2341558
                ],
                [
                    75.6484956,
                    55.228685
                ],
                [
                    75.6370783,
                    55.2286993
                ],
                [
                    75.6369535,
                    55.2310074
                ]
            ],
            "longitude": 75.641731,
            "latitude": 55.232536
        },
        "9480": {
            "name": "Озёрный",
            "population": 89,
            "type": "hamlet",
            "poly": [
                [
                    75.6459053,
                    55.6726111
                ],
                [
                    75.646689,
                    55.6748207
                ],
                [
                    75.6483739,
                    55.6771627
                ],
                [
                    75.6528017,
                    55.6777813
                ],
                [
                    75.6542907,
                    55.6773615
                ],
                [
                    75.6507641,
                    55.6718377
                ],
                [
                    75.6467282,
                    55.6718156
                ],
                [
                    75.6459053,
                    55.6726111
                ]
            ],
            "longitude": 75.649155,
            "latitude": 55.674122
        },
        "9481": {
            "name": "Тайлаково",
            "population": 179,
            "type": "hamlet",
            "poly": [
                [
                    75.6324112,
                    55.392041
                ],
                [
                    75.6412432,
                    55.396128
                ],
                [
                    75.6586267,
                    55.4004535
                ],
                [
                    75.6602155,
                    55.3983837
                ],
                [
                    75.6508695,
                    55.3910324
                ],
                [
                    75.6332991,
                    55.3886702
                ],
                [
                    75.6324112,
                    55.392041
                ]
            ],
            "longitude": 75.649651,
            "latitude": 55.394276
        },
        "9482": {
            "name": "Новотроицк",
            "population": 128,
            "type": "hamlet",
            "poly": [
                [
                    75.6745182,
                    55.0046803
                ],
                [
                    75.6772152,
                    55.006669
                ],
                [
                    75.6844586,
                    55.0049897
                ],
                [
                    75.6957475,
                    55.0023601
                ],
                [
                    75.698329,
                    55.0037081
                ],
                [
                    75.7039927,
                    55.0062271
                ],
                [
                    75.7076915,
                    55.0052548
                ],
                [
                    75.7056494,
                    55.0008574
                ],
                [
                    75.6976355,
                    54.9970784
                ],
                [
                    75.6929349,
                    54.9969237
                ],
                [
                    75.6801049,
                    55.0006585
                ],
                [
                    75.6818387,
                    55.0023822
                ],
                [
                    75.6745182,
                    55.0046803
                ]
            ],
            "longitude": 75.688126,
            "latitude": 55.001396
        },
        "9483": {
            "name": "Евгеньевка",
            "population": 151,
            "type": "hamlet",
            "poly": [
                [
                    75.6800793,
                    55.0876106
                ],
                [
                    75.6816785,
                    55.0910972
                ],
                [
                    75.6954623,
                    55.091533
                ],
                [
                    75.7018592,
                    55.088613
                ],
                [
                    75.7060476,
                    55.0808545
                ],
                [
                    75.6838108,
                    55.0780209
                ],
                [
                    75.6826685,
                    55.0808545
                ],
                [
                    75.6800793,
                    55.0876106
                ]
            ],
            "longitude": 75.691528,
            "latitude": 55.085754
        },
        "9484": {
            "name": "Остановочная Платформа Заб",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    75.7011426,
                    55.1844948
                ],
                [
                    75.7014237,
                    55.1853863
                ],
                [
                    75.7028602,
                    55.1859033
                ],
                [
                    75.708981,
                    55.1863134
                ],
                [
                    75.7083252,
                    55.1855646
                ],
                [
                    75.7065764,
                    55.1848692
                ],
                [
                    75.7011426,
                    55.1844948
                ]
            ],
            "longitude": 75.703598,
            "latitude": 55.185402
        },
        "9485": {
            "name": "Мартыново",
            "population": 85,
            "type": "hamlet",
            "poly": [
                [
                    75.7386502,
                    56.0665636
                ],
                [
                    75.7415991,
                    56.0671573
                ],
                [
                    75.7427109,
                    56.0653762
                ],
                [
                    75.7442578,
                    56.0666716
                ],
                [
                    75.7473035,
                    56.0645666
                ],
                [
                    75.7438228,
                    56.063784
                ],
                [
                    75.7442578,
                    56.0626504
                ],
                [
                    75.7455631,
                    56.0604643
                ],
                [
                    75.7474002,
                    56.0603833
                ],
                [
                    75.7473035,
                    56.0590878
                ],
                [
                    75.7460949,
                    56.0591147
                ],
                [
                    75.7473035,
                    56.0578191
                ],
                [
                    75.7472068,
                    56.0566855
                ],
                [
                    75.7444513,
                    56.0546069
                ],
                [
                    75.7419375,
                    56.0573333
                ],
                [
                    75.7412123,
                    56.0588178
                ],
                [
                    75.7409706,
                    56.0609771
                ],
                [
                    75.7414057,
                    56.0620297
                ],
                [
                    75.7398587,
                    56.0634601
                ],
                [
                    75.7386502,
                    56.0665636
                ]
            ],
            "longitude": 75.7435,
            "latitude": 56.061825
        },
        "9486": {
            "name": "Малая Старинка",
            "population": 172,
            "type": "hamlet",
            "poly": [
                [
                    75.7880569,
                    54.8226899
                ],
                [
                    75.7909542,
                    54.824288
                ],
                [
                    75.7902761,
                    54.826401
                ],
                [
                    75.8014957,
                    54.8292773
                ],
                [
                    75.805965,
                    54.8312658
                ],
                [
                    75.8112049,
                    54.83226
                ],
                [
                    75.8111433,
                    54.8305024
                ],
                [
                    75.8071979,
                    54.8297212
                ],
                [
                    75.8100953,
                    54.8258151
                ],
                [
                    75.8043314,
                    54.8245366
                ],
                [
                    75.8065814,
                    54.8199019
                ],
                [
                    75.7959784,
                    54.8180549
                ],
                [
                    75.7950537,
                    54.8196
                ],
                [
                    75.7995229,
                    54.8203991
                ],
                [
                    75.79866,
                    54.8231338
                ],
                [
                    75.7898446,
                    54.8200617
                ],
                [
                    75.7880569,
                    54.8226899
                ]
            ],
            "longitude": 75.799927,
            "latitude": 54.823059
        },
        "9487": {
            "name": "Родькино",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    75.7970902,
                    55.83072
                ],
                [
                    75.7992943,
                    55.8310171
                ],
                [
                    75.8021155,
                    55.8309429
                ],
                [
                    75.8043196,
                    55.8280957
                ],
                [
                    75.8010575,
                    55.82713
                ],
                [
                    75.7988095,
                    55.8276252
                ],
                [
                    75.7970902,
                    55.83072
                ]
            ],
            "longitude": 75.801201,
            "latitude": 55.829128
        },
        "9488": {
            "name": "Первомихайловка",
            "population": 263,
            "type": "hamlet",
            "poly": [
                [
                    75.7825134,
                    55.1154803
                ],
                [
                    75.7901877,
                    55.1152238
                ],
                [
                    75.7994564,
                    55.1178743
                ],
                [
                    75.817695,
                    55.1204961
                ],
                [
                    75.820821,
                    55.1218364
                ],
                [
                    75.8247214,
                    55.1135708
                ],
                [
                    75.8253692,
                    55.1120031
                ],
                [
                    75.8250204,
                    55.1094093
                ],
                [
                    75.8145058,
                    55.1078415
                ],
                [
                    75.8124128,
                    55.1043922
                ],
                [
                    75.8100209,
                    55.1025391
                ],
                [
                    75.7825134,
                    55.1154803
                ]
            ],
            "longitude": 75.804787,
            "latitude": 55.111889
        },
        "9489": {
            "name": "Городенка",
            "population": 228,
            "type": "hamlet",
            "poly": [
                [
                    75.7962558,
                    54.9573655
                ],
                [
                    75.801804,
                    54.9603962
                ],
                [
                    75.8125535,
                    54.958361
                ],
                [
                    75.8209913,
                    54.9548434
                ],
                [
                    75.8177549,
                    54.9532283
                ],
                [
                    75.8278494,
                    54.9498873
                ],
                [
                    75.8242277,
                    54.9473869
                ],
                [
                    75.8073521,
                    54.9521221
                ],
                [
                    75.8043469,
                    54.9488031
                ],
                [
                    75.8008793,
                    54.9494226
                ],
                [
                    75.8055027,
                    54.9528079
                ],
                [
                    75.7962558,
                    54.9573655
                ]
            ],
            "longitude": 75.811104,
            "latitude": 54.952015
        },
        "9490": {
            "name": "Силиш",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    75.8498271,
                    55.9052599
                ],
                [
                    75.8505998,
                    55.9070077
                ],
                [
                    75.8663826,
                    55.912436
                ],
                [
                    75.8680658,
                    55.9100235
                ],
                [
                    75.8515931,
                    55.9039297
                ],
                [
                    75.8506273,
                    55.9044711
                ],
                [
                    75.8498271,
                    55.9052599
                ]
            ],
            "longitude": 75.86113,
            "latitude": 55.908596
        },
        "9491": {
            "name": "Камышино",
            "population": 45,
            "type": "hamlet",
            "poly": [
                [
                    75.8680605,
                    54.8761513
                ],
                [
                    75.8682839,
                    54.8797167
                ],
                [
                    75.8704055,
                    54.8812584
                ],
                [
                    75.8917888,
                    54.881146
                ],
                [
                    75.894329,
                    54.8733726
                ],
                [
                    75.8855636,
                    54.8717021
                ],
                [
                    75.8760723,
                    54.8724089
                ],
                [
                    75.8731133,
                    54.8741757
                ],
                [
                    75.8680605,
                    54.8761513
                ]
            ],
            "longitude": 75.880051,
            "latitude": 54.87653
        },
        "9492": {
            "name": "Тихоновка",
            "population": 84,
            "type": "hamlet",
            "poly": [
                [
                    75.8811583,
                    55.7669575
                ],
                [
                    75.8835849,
                    55.7680466
                ],
                [
                    75.8839721,
                    55.7687292
                ],
                [
                    75.8847207,
                    55.7692519
                ],
                [
                    75.8869408,
                    55.7701087
                ],
                [
                    75.8928781,
                    55.7718367
                ],
                [
                    75.8936784,
                    55.7715317
                ],
                [
                    75.8966413,
                    55.7715801
                ],
                [
                    75.8975764,
                    55.7707041
                ],
                [
                    75.8954854,
                    55.7691648
                ],
                [
                    75.8930589,
                    55.7679886
                ],
                [
                    75.8915616,
                    55.7674948
                ],
                [
                    75.8842302,
                    55.7649533
                ],
                [
                    75.8814681,
                    55.7661733
                ],
                [
                    75.8811583,
                    55.7669575
                ]
            ],
            "longitude": 75.887329,
            "latitude": 55.767265
        },
        "9493": {
            "name": "Чернышевский",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    75.8896691,
                    55.0402225
                ],
                [
                    75.8920526,
                    55.0430819
                ],
                [
                    75.9059061,
                    55.0414175
                ],
                [
                    75.9025544,
                    55.0316007
                ],
                [
                    75.8905629,
                    55.030875
                ],
                [
                    75.8896691,
                    55.0402225
                ]
            ],
            "longitude": 75.897728,
            "latitude": 55.034325
        },
        "9494": {
            "name": "Нововознесенка",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    75.8980653,
                    55.3626607
                ],
                [
                    75.9014696,
                    55.3648744
                ],
                [
                    75.902739,
                    55.3648908
                ],
                [
                    75.9079897,
                    55.3645956
                ],
                [
                    75.9152023,
                    55.3643989
                ],
                [
                    75.9157503,
                    55.3638742
                ],
                [
                    75.9249248,
                    55.3611849
                ],
                [
                    75.9229629,
                    55.359463
                ],
                [
                    75.9220974,
                    55.3597418
                ],
                [
                    75.9212319,
                    55.3565931
                ],
                [
                    75.9000559,
                    55.354379
                ],
                [
                    75.8980653,
                    55.3626607
                ]
            ],
            "longitude": 75.911064,
            "latitude": 55.360447
        },
        "9495": {
            "name": "Волово",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    75.8998945,
                    54.8303082
                ],
                [
                    75.900737,
                    54.8328039
                ],
                [
                    75.9025123,
                    54.8347795
                ],
                [
                    75.9097339,
                    54.8375522
                ],
                [
                    75.9150899,
                    54.8370497
                ],
                [
                    75.9151294,
                    54.8349367
                ],
                [
                    75.9157519,
                    54.8325439
                ],
                [
                    75.9180387,
                    54.8302042
                ],
                [
                    75.9082595,
                    54.826807
                ],
                [
                    75.9081692,
                    54.8293376
                ],
                [
                    75.8998945,
                    54.8303082
                ]
            ],
            "longitude": 75.91111,
            "latitude": 54.833294
        },
        "9496": {
            "name": "Ваховский",
            "population": 69,
            "type": "hamlet",
            "poly": [
                [
                    75.9058207,
                    55.0878574
                ],
                [
                    75.9089701,
                    55.0932188
                ],
                [
                    75.918498,
                    55.0931047
                ],
                [
                    75.9204913,
                    55.0880399
                ],
                [
                    75.915548,
                    55.0821302
                ],
                [
                    75.9100465,
                    55.0813315
                ],
                [
                    75.9086911,
                    55.0818107
                ],
                [
                    75.9060201,
                    55.0838416
                ],
                [
                    75.9058207,
                    55.0878574
                ]
            ],
            "longitude": 75.911827,
            "latitude": 55.0853
        },
        "9497": {
            "name": "Георгиевка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    75.9308877,
                    54.7648106
                ],
                [
                    75.9344103,
                    54.7675753
                ],
                [
                    75.9368268,
                    54.7672917
                ],
                [
                    75.943667,
                    54.7621166
                ],
                [
                    75.944691,
                    54.7613603
                ],
                [
                    75.9432984,
                    54.7606041
                ],
                [
                    75.945674,
                    54.7593515
                ],
                [
                    75.9481316,
                    54.760226
                ],
                [
                    75.9494832,
                    54.7581934
                ],
                [
                    75.9474353,
                    54.7577207
                ],
                [
                    75.9467799,
                    54.7586661
                ],
                [
                    75.9441176,
                    54.7572244
                ],
                [
                    75.9452644,
                    54.7566808
                ],
                [
                    75.9413323,
                    54.7543881
                ],
                [
                    75.9394482,
                    54.7551445
                ],
                [
                    75.9385062,
                    54.7536553
                ],
                [
                    75.9371136,
                    54.7534899
                ],
                [
                    75.9353114,
                    54.7543408
                ],
                [
                    75.9374412,
                    54.7559245
                ],
                [
                    75.936704,
                    54.7567753
                ],
                [
                    75.9414143,
                    54.7600369
                ],
                [
                    75.9344921,
                    54.7650705
                ],
                [
                    75.9313793,
                    54.7641017
                ],
                [
                    75.9308877,
                    54.7648106
                ]
            ],
            "longitude": 75.941765,
            "latitude": 54.758839
        },
        "9498": {
            "name": "Яминка",
            "population": 48,
            "type": "hamlet",
            "poly": [
                [
                    75.9456981,
                    54.7090023
                ],
                [
                    75.9507771,
                    54.7106587
                ],
                [
                    75.9499579,
                    54.713853
                ],
                [
                    75.9592147,
                    54.7147757
                ],
                [
                    75.960894,
                    54.7119364
                ],
                [
                    75.9569619,
                    54.7106587
                ],
                [
                    75.9575353,
                    54.7092153
                ],
                [
                    75.9541357,
                    54.7078901
                ],
                [
                    75.9489067,
                    54.707219
                ],
                [
                    75.9456981,
                    54.7090023
                ]
            ],
            "longitude": 75.955002,
            "latitude": 54.710823
        },
        "9499": {
            "name": "Кабанка",
            "population": 109,
            "type": "hamlet",
            "poly": [
                [
                    75.9682732,
                    55.4425919
                ],
                [
                    75.9777523,
                    55.4446925
                ],
                [
                    75.9851445,
                    55.4427053
                ],
                [
                    75.9876508,
                    55.4393361
                ],
                [
                    75.9914445,
                    55.4351072
                ],
                [
                    75.9901399,
                    55.4293339
                ],
                [
                    75.9843655,
                    55.4284346
                ],
                [
                    75.9762532,
                    55.4373398
                ],
                [
                    75.9720648,
                    55.4390656
                ],
                [
                    75.9682732,
                    55.4425919
                ]
            ],
            "longitude": 75.983902,
            "latitude": 55.435982
        },
        "9500": {
            "name": "Верхнеомка",
            "population": 185,
            "type": "hamlet",
            "poly": [
                [
                    75.9960159,
                    55.5080433
                ],
                [
                    75.997399,
                    55.5089804
                ],
                [
                    75.9987573,
                    55.5088405
                ],
                [
                    76.0016717,
                    55.5079734
                ],
                [
                    76.0032277,
                    55.5074559
                ],
                [
                    76.0052034,
                    55.5086307
                ],
                [
                    76.0105877,
                    55.5065188
                ],
                [
                    76.0117238,
                    55.5058055
                ],
                [
                    76.0143418,
                    55.5054138
                ],
                [
                    76.0163175,
                    55.5043928
                ],
                [
                    76.016614,
                    55.5037773
                ],
                [
                    76.0178983,
                    55.5020568
                ],
                [
                    76.0123412,
                    55.4998186
                ],
                [
                    76.0075745,
                    55.5013573
                ],
                [
                    76.0054752,
                    55.5025044
                ],
                [
                    76.0017211,
                    55.5044067
                ],
                [
                    75.9979175,
                    55.5054278
                ],
                [
                    75.9967568,
                    55.5065188
                ],
                [
                    75.9978188,
                    55.5072181
                ],
                [
                    75.9960159,
                    55.5080433
                ]
            ],
            "longitude": 76.006737,
            "latitude": 55.504742
        },
        "9501": {
            "name": "Черниговка",
            "population": 187,
            "type": "hamlet",
            "poly": [
                [
                    76.0040669,
                    56.0171042
                ],
                [
                    76.0041727,
                    56.0181097
                ],
                [
                    76.0057601,
                    56.0192335
                ],
                [
                    76.0063421,
                    56.0196623
                ],
                [
                    76.0086702,
                    56.020165
                ],
                [
                    76.0103898,
                    56.0204164
                ],
                [
                    76.010575,
                    56.0207713
                ],
                [
                    76.016554,
                    56.0209635
                ],
                [
                    76.0222155,
                    56.020993
                ],
                [
                    76.0257869,
                    56.0209043
                ],
                [
                    76.0270015,
                    56.0203309
                ],
                [
                    76.0273479,
                    56.0188343
                ],
                [
                    76.0265013,
                    56.0182871
                ],
                [
                    76.0250992,
                    56.0183759
                ],
                [
                    76.0234854,
                    56.0181245
                ],
                [
                    76.0166334,
                    56.0175182
                ],
                [
                    76.0117558,
                    56.0169256
                ],
                [
                    76.008776,
                    56.0168084
                ],
                [
                    76.0084849,
                    56.0173112
                ],
                [
                    76.0040669,
                    56.0171042
                ]
            ],
            "longitude": 76.015091,
            "latitude": 56.018742
        },
        "9502": {
            "name": "Трактовый",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.0514527,
            "latitude": 55.2134709
        },
        "9503": {
            "name": "Старая Скирла",
            "population": 12,
            "type": "hamlet",
            "poly": [
                [
                    76.0584228,
                    56.475693
                ],
                [
                    76.0612221,
                    56.4764452
                ],
                [
                    76.0641728,
                    56.4767794
                ],
                [
                    76.0664047,
                    56.4769257
                ],
                [
                    76.0668964,
                    56.4761736
                ],
                [
                    76.0664803,
                    56.4757348
                ],
                [
                    76.0668586,
                    56.4750454
                ],
                [
                    76.0656859,
                    56.4747947
                ],
                [
                    76.0650807,
                    56.4754632
                ],
                [
                    76.0636432,
                    56.4750663
                ],
                [
                    76.0635675,
                    56.4734575
                ],
                [
                    76.0623948,
                    56.4732276
                ],
                [
                    76.0616382,
                    56.4745857
                ],
                [
                    76.0593685,
                    56.4741679
                ],
                [
                    76.0588767,
                    56.4744604
                ],
                [
                    76.0584228,
                    56.475693
                ]
            ],
            "longitude": 76.062889,
            "latitude": 56.474876
        },
        "9504": {
            "name": "Большая Тахта",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    76.0651874,
                    54.7032985
                ],
                [
                    76.0655562,
                    54.7050025
                ],
                [
                    76.0696111,
                    54.7060438
                ],
                [
                    76.0714543,
                    54.7015708
                ],
                [
                    76.0726831,
                    54.7017838
                ],
                [
                    76.0717,
                    54.7062804
                ],
                [
                    76.0785402,
                    54.7051208
                ],
                [
                    76.0828408,
                    54.7048368
                ],
                [
                    76.0845202,
                    54.7027305
                ],
                [
                    76.0762055,
                    54.699133
                ],
                [
                    76.0706351,
                    54.6985412
                ],
                [
                    76.0668668,
                    54.6985886
                ],
                [
                    76.0666621,
                    54.7010975
                ],
                [
                    76.0651874,
                    54.7032985
                ]
            ],
            "longitude": 76.070938,
            "latitude": 54.700794
        },
        "9505": {
            "name": "Лебяжье",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    76.0623769,
                    54.9091293
                ],
                [
                    76.0653419,
                    54.9142022
                ],
                [
                    76.0684002,
                    54.9188853
                ],
                [
                    76.0759877,
                    54.920965
                ],
                [
                    76.0794197,
                    54.9141217
                ],
                [
                    76.0746804,
                    54.9095319
                ],
                [
                    76.0653886,
                    54.9085253
                ],
                [
                    76.0623769,
                    54.9091293
                ]
            ],
            "longitude": 76.071915,
            "latitude": 54.913158
        },
        "9506": {
            "name": "Мухино",
            "population": 72,
            "type": "hamlet",
            "poly": [
                [
                    76.0739684,
                    54.5241577
                ],
                [
                    76.0921276,
                    54.5272131
                ],
                [
                    76.0931049,
                    54.5255482
                ],
                [
                    76.0974871,
                    54.5255848
                ],
                [
                    76.0972664,
                    54.5238466
                ],
                [
                    76.0933571,
                    54.5237734
                ],
                [
                    76.0931364,
                    54.5230965
                ],
                [
                    76.0792963,
                    54.5211752
                ],
                [
                    76.0748826,
                    54.5207361
                ],
                [
                    76.0739684,
                    54.5241577
                ]
            ],
            "longitude": 76.085068,
            "latitude": 54.523529
        },
        "9507": {
            "name": "Малая Скирла",
            "population": 263,
            "type": "hamlet",
            "poly": [
                [
                    76.0699606,
                    56.4792446
                ],
                [
                    76.0722681,
                    56.4805816
                ],
                [
                    76.0767697,
                    56.4815007
                ],
                [
                    76.0782829,
                    56.4816887
                ],
                [
                    76.0813849,
                    56.4819394
                ],
                [
                    76.0836925,
                    56.4811247
                ],
                [
                    76.084449,
                    56.4828794
                ],
                [
                    76.0903503,
                    56.4834225
                ],
                [
                    76.0919013,
                    56.4826496
                ],
                [
                    76.0929984,
                    56.4827332
                ],
                [
                    76.0926956,
                    56.4836314
                ],
                [
                    76.0934523,
                    56.4842789
                ],
                [
                    76.0957599,
                    56.4844878
                ],
                [
                    76.098597,
                    56.4841536
                ],
                [
                    76.0981809,
                    56.4853233
                ],
                [
                    76.1007155,
                    56.4849473
                ],
                [
                    76.100375,
                    56.48407
                ],
                [
                    76.1011316,
                    56.4838403
                ],
                [
                    76.1006398,
                    56.4829003
                ],
                [
                    76.0998076,
                    56.4830883
                ],
                [
                    76.0992401,
                    56.4813545
                ],
                [
                    76.0955329,
                    56.4807905
                ],
                [
                    76.0908043,
                    56.4798295
                ],
                [
                    76.0889885,
                    56.4798295
                ],
                [
                    76.0900477,
                    56.4782418
                ],
                [
                    76.0879671,
                    56.4779076
                ],
                [
                    76.0848273,
                    56.478785
                ],
                [
                    76.0828602,
                    56.4779912
                ],
                [
                    76.0778668,
                    56.4772391
                ],
                [
                    76.0755971,
                    56.47726
                ],
                [
                    76.0740839,
                    56.476675
                ],
                [
                    76.0732895,
                    56.4760064
                ],
                [
                    76.0721168,
                    56.4758811
                ],
                [
                    76.0714737,
                    56.4770719
                ],
                [
                    76.0699606,
                    56.4792446
                ]
            ],
            "longitude": 76.086357,
            "latitude": 56.481216
        },
        "9508": {
            "name": "Цветнополье",
            "population": 29,
            "type": "hamlet",
            "poly": [
                [
                    76.0923661,
                    54.4238349
                ],
                [
                    76.1115468,
                    54.4314924
                ],
                [
                    76.1149694,
                    54.428342
                ],
                [
                    76.0948859,
                    54.4208152
                ],
                [
                    76.0923661,
                    54.4238349
                ]
            ],
            "longitude": 76.104591,
            "latitude": 54.426094
        },
        "9509": {
            "name": "Мирный",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    76.1315793,
                    55.998728
                ],
                [
                    76.1358775,
                    56.0003092
                ],
                [
                    76.1394687,
                    56.0004674
                ],
                [
                    76.14306,
                    55.9998823
                ],
                [
                    76.1426357,
                    55.9987438
                ],
                [
                    76.135312,
                    55.9972415
                ],
                [
                    76.1372631,
                    55.9945215
                ],
                [
                    76.1353685,
                    55.9933037
                ],
                [
                    76.1341809,
                    55.9936042
                ],
                [
                    76.1339263,
                    55.9950908
                ],
                [
                    76.1315793,
                    55.998728
                ]
            ],
            "longitude": 76.137657,
            "latitude": 55.998253
        },
        "9510": {
            "name": "Мироновка",
            "population": 129,
            "type": "hamlet",
            "poly": [
                [
                    76.1340399,
                    54.5088715
                ],
                [
                    76.1345677,
                    54.5140581
                ],
                [
                    76.1354347,
                    54.5173404
                ],
                [
                    76.1376588,
                    54.5175592
                ],
                [
                    76.1384881,
                    54.5203818
                ],
                [
                    76.1402222,
                    54.5202067
                ],
                [
                    76.1406745,
                    54.5194628
                ],
                [
                    76.1433887,
                    54.5196379
                ],
                [
                    76.143841,
                    54.5208631
                ],
                [
                    76.1465175,
                    54.5204693
                ],
                [
                    76.1462159,
                    54.5093748
                ],
                [
                    76.1427101,
                    54.5088715
                ],
                [
                    76.1421447,
                    54.5070768
                ],
                [
                    76.1359624,
                    54.5068141
                ],
                [
                    76.1340399,
                    54.5088715
                ]
            ],
            "longitude": 76.143578,
            "latitude": 54.514744
        },
        "9511": {
            "name": "Новоалександровка",
            "population": 139,
            "type": "hamlet",
            "poly": [
                [
                    76.1390827,
                    55.7480234
                ],
                [
                    76.1408978,
                    55.7489996
                ],
                [
                    76.1417449,
                    55.7498623
                ],
                [
                    76.1438826,
                    55.7512016
                ],
                [
                    76.1481179,
                    55.7521096
                ],
                [
                    76.1473918,
                    55.7527906
                ],
                [
                    76.1500943,
                    55.7533127
                ],
                [
                    76.1503363,
                    55.7530176
                ],
                [
                    76.1570723,
                    55.7547881
                ],
                [
                    76.1580001,
                    55.7545157
                ],
                [
                    76.1592505,
                    55.7533127
                ],
                [
                    76.1580001,
                    55.7521777
                ],
                [
                    76.1564673,
                    55.7502709
                ],
                [
                    76.150659,
                    55.7482505
                ],
                [
                    76.1456977,
                    55.7465705
                ],
                [
                    76.144891,
                    55.7478645
                ],
                [
                    76.1406155,
                    55.746684
                ],
                [
                    76.1390827,
                    55.7480234
                ]
            ],
            "longitude": 76.150276,
            "latitude": 55.750656
        },
        "9512": {
            "name": "Чаны-Сакан",
            "population": 102,
            "type": "hamlet",
            "poly": [
                [
                    76.1423049,
                    55.3548965
                ],
                [
                    76.1560858,
                    55.3574118
                ],
                [
                    76.1581599,
                    55.3553419
                ],
                [
                    76.1618932,
                    55.3561541
                ],
                [
                    76.1642899,
                    55.3511494
                ],
                [
                    76.1492645,
                    55.3478475
                ],
                [
                    76.1456233,
                    55.3480834
                ],
                [
                    76.145297,
                    55.3487534
                ],
                [
                    76.1423049,
                    55.3548965
                ]
            ],
            "longitude": 76.153587,
            "latitude": 55.352318
        },
        "9513": {
            "name": "Воскресенка",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    76.1455879,
                    56.4423891
                ],
                [
                    76.1467458,
                    56.4434493
                ],
                [
                    76.1481571,
                    56.4440093
                ],
                [
                    76.1493874,
                    56.4424891
                ],
                [
                    76.1518481,
                    56.4418691
                ],
                [
                    76.1544173,
                    56.441609
                ],
                [
                    76.1579634,
                    56.4420891
                ],
                [
                    76.1593024,
                    56.4403688
                ],
                [
                    76.1607499,
                    56.4385084
                ],
                [
                    76.1624506,
                    56.4365479
                ],
                [
                    76.1627039,
                    56.4345072
                ],
                [
                    76.1639342,
                    56.4331667
                ],
                [
                    76.1653817,
                    56.4299654
                ],
                [
                    76.1624144,
                    56.4295852
                ],
                [
                    76.1605327,
                    56.4310659
                ],
                [
                    76.1603156,
                    56.4324064
                ],
                [
                    76.1589767,
                    56.433887
                ],
                [
                    76.1568056,
                    56.4367279
                ],
                [
                    76.1528613,
                    56.4360077
                ],
                [
                    76.1514861,
                    56.436928
                ],
                [
                    76.1513053,
                    56.4391085
                ],
                [
                    76.1484466,
                    56.4392486
                ],
                [
                    76.1457688,
                    56.441489
                ],
                [
                    76.1455879,
                    56.4423891
                ]
            ],
            "longitude": 76.157265,
            "latitude": 56.437092
        },
        "9514": {
            "name": "Новониколаевка",
            "population": 18,
            "type": "hamlet",
            "poly": [
                [
                    76.1519422,
                    56.5968091
                ],
                [
                    76.1546172,
                    56.5974742
                ],
                [
                    76.15269,
                    56.5997702
                ],
                [
                    76.1546747,
                    56.6000394
                ],
                [
                    76.156343,
                    56.5980759
                ],
                [
                    76.1570909,
                    56.5970308
                ],
                [
                    76.1585291,
                    56.5965716
                ],
                [
                    76.1590468,
                    56.5955581
                ],
                [
                    76.159507,
                    56.5964291
                ],
                [
                    76.1624697,
                    56.5956215
                ],
                [
                    76.1644256,
                    56.5950197
                ],
                [
                    76.1657488,
                    56.5942279
                ],
                [
                    76.1648283,
                    56.5935786
                ],
                [
                    76.1685964,
                    56.5926759
                ],
                [
                    76.1671007,
                    56.590522
                ],
                [
                    76.1655762,
                    56.5906329
                ],
                [
                    76.1638791,
                    56.5914089
                ],
                [
                    76.1595933,
                    56.5926442
                ],
                [
                    76.1568608,
                    56.5937053
                ],
                [
                    76.1578675,
                    56.5946396
                ],
                [
                    76.1558253,
                    56.5951781
                ],
                [
                    76.1535817,
                    56.5945129
                ],
                [
                    76.1522586,
                    56.5956056
                ],
                [
                    76.1519422,
                    56.5968091
                ]
            ],
            "longitude": 76.16066,
            "latitude": 56.594982
        },
        "9515": {
            "name": "Малиновка",
            "population": 74,
            "type": "hamlet",
            "poly": [
                [
                    76.1715472,
                    54.6281692
                ],
                [
                    76.1738869,
                    54.6300111
                ],
                [
                    76.1726702,
                    54.6303633
                ],
                [
                    76.172062,
                    54.6315551
                ],
                [
                    76.1741677,
                    54.632476
                ],
                [
                    76.1752908,
                    54.6319614
                ],
                [
                    76.1777241,
                    54.6332344
                ],
                [
                    76.1821228,
                    54.63058
                ],
                [
                    76.1836201,
                    54.6289276
                ],
                [
                    76.1815613,
                    54.6283859
                ],
                [
                    76.1807658,
                    54.6287109
                ],
                [
                    76.1783792,
                    54.6274107
                ],
                [
                    76.1754312,
                    54.6279254
                ],
                [
                    76.1729043,
                    54.6274378
                ],
                [
                    76.1715472,
                    54.6281692
                ]
            ],
            "longitude": 76.177452,
            "latitude": 54.629982
        },
        "9516": {
            "name": "Тарышта",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    76.1747101,
                    55.2404477
                ],
                [
                    76.175325,
                    55.2408939
                ],
                [
                    76.1808307,
                    55.2420092
                ],
                [
                    76.1826193,
                    55.2417862
                ],
                [
                    76.183877,
                    55.2407345
                ],
                [
                    76.174794,
                    55.2397785
                ],
                [
                    76.1747101,
                    55.2404477
                ]
            ],
            "longitude": 76.178101,
            "latitude": 55.24041
        },
        "9517": {
            "name": "Бакейка",
            "population": 69,
            "type": "hamlet",
            "poly": [
                [
                    76.1948902,
                    56.4696435
                ],
                [
                    76.1961334,
                    56.4698397
                ],
                [
                    76.1956894,
                    56.4708533
                ],
                [
                    76.196311,
                    56.4718997
                ],
                [
                    76.1972285,
                    56.4730441
                ],
                [
                    76.1977613,
                    56.4730441
                ],
                [
                    76.2023787,
                    56.472292
                ],
                [
                    76.2071744,
                    56.469761
                ],
                [
                    76.2069961,
                    56.4692674
                ],
                [
                    76.2056938,
                    56.4683355
                ],
                [
                    76.2054866,
                    56.4678123
                ],
                [
                    76.2006916,
                    56.4674526
                ],
                [
                    76.1993004,
                    56.4676978
                ],
                [
                    76.1971397,
                    56.4668149
                ],
                [
                    76.1964294,
                    56.4676488
                ],
                [
                    76.1951862,
                    56.4687442
                ],
                [
                    76.1948902,
                    56.4696435
                ]
            ],
            "longitude": 76.199715,
            "latitude": 56.469975
        },
        "9518": {
            "name": "Новоалександровка",
            "population": 210,
            "type": "hamlet",
            "poly": [
                [
                    76.1995309,
                    54.9792892
                ],
                [
                    76.2002147,
                    54.9795669
                ],
                [
                    76.2023185,
                    54.9809251
                ],
                [
                    76.2031462,
                    54.9812276
                ],
                [
                    76.2205691,
                    54.9875947
                ],
                [
                    76.224093,
                    54.9878663
                ],
                [
                    76.2273014,
                    54.9861764
                ],
                [
                    76.2224626,
                    54.9813476
                ],
                [
                    76.2145101,
                    54.9726725
                ],
                [
                    76.2020976,
                    54.9695328
                ],
                [
                    76.2023921,
                    54.9718997
                ],
                [
                    76.1997413,
                    54.9723344
                ],
                [
                    76.2005408,
                    54.9748701
                ],
                [
                    76.2020555,
                    54.9749426
                ],
                [
                    76.1995309,
                    54.9792892
                ]
            ],
            "longitude": 76.212257,
            "latitude": 54.98008
        },
        "9519": {
            "name": "Богдановка",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    76.2036852,
                    55.3201088
                ],
                [
                    76.2121614,
                    55.3213243
                ],
                [
                    76.2135053,
                    55.3210498
                ],
                [
                    76.2198454,
                    55.3219125
                ],
                [
                    76.2259442,
                    55.3220105
                ],
                [
                    76.2255588,
                    55.3194636
                ],
                [
                    76.2250483,
                    55.3160894
                ],
                [
                    76.2188117,
                    55.3161483
                ],
                [
                    76.2196386,
                    55.3132855
                ],
                [
                    76.2178124,
                    55.3124423
                ],
                [
                    76.2145046,
                    55.3123638
                ],
                [
                    76.2108522,
                    55.3134423
                ],
                [
                    76.2107143,
                    55.3158149
                ],
                [
                    76.2059593,
                    55.3153443
                ],
                [
                    76.20496,
                    55.3156973
                ],
                [
                    76.2044057,
                    55.3176158
                ],
                [
                    76.2036852,
                    55.3201088
                ]
            ],
            "longitude": 76.216637,
            "latitude": 55.317509
        },
        "9520": {
            "name": "Минино",
            "population": 80,
            "type": "hamlet",
            "poly": [
                [
                    76.2103004,
                    55.232472
                ],
                [
                    76.2118841,
                    55.2328921
                ],
                [
                    76.2244798,
                    55.2333121
                ],
                [
                    76.2318825,
                    55.2280824
                ],
                [
                    76.2248481,
                    55.2210664
                ],
                [
                    76.2129522,
                    55.2207092
                ],
                [
                    76.2116631,
                    55.2242804
                ],
                [
                    76.2103004,
                    55.232472
                ]
            ],
            "longitude": 76.220634,
            "latitude": 55.223335
        },
        "9521": {
            "name": "Чичканка",
            "population": 80,
            "type": "hamlet",
            "poly": [
                [
                    76.2117412,
                    56.0980713
                ],
                [
                    76.2142095,
                    56.1000326
                ],
                [
                    76.2263478,
                    56.1028424
                ],
                [
                    76.22885,
                    56.1028613
                ],
                [
                    76.2294586,
                    56.1015601
                ],
                [
                    76.2258746,
                    56.0998629
                ],
                [
                    76.216272,
                    56.097034
                ],
                [
                    76.2125527,
                    56.0970529
                ],
                [
                    76.2117412,
                    56.0980713
                ]
            ],
            "longitude": 76.220711,
            "latitude": 56.099876
        },
        "9522": {
            "name": "Майский",
            "population": 76,
            "type": "hamlet",
            "poly": [
                [
                    76.2215711,
                    55.8882804
                ],
                [
                    76.2322442,
                    55.8909288
                ],
                [
                    76.2339444,
                    55.889075
                ],
                [
                    76.2327165,
                    55.8875918
                ],
                [
                    76.2250186,
                    55.8849167
                ],
                [
                    76.2223738,
                    55.8862675
                ],
                [
                    76.2230351,
                    55.8868767
                ],
                [
                    76.2215711,
                    55.8882804
                ]
            ],
            "longitude": 76.225281,
            "latitude": 55.887753
        },
        "9523": {
            "name": "Альменево",
            "population": 115,
            "type": "hamlet",
            "poly": [
                [
                    76.2180415,
                    56.4580258
                ],
                [
                    76.2193442,
                    56.4588056
                ],
                [
                    76.2205745,
                    56.4590455
                ],
                [
                    76.2206107,
                    56.4599053
                ],
                [
                    76.2201041,
                    56.460565
                ],
                [
                    76.2224562,
                    56.4611249
                ],
                [
                    76.2240484,
                    56.4609449
                ],
                [
                    76.2241208,
                    56.4598253
                ],
                [
                    76.2232523,
                    56.4598253
                ],
                [
                    76.22318,
                    56.4593454
                ],
                [
                    76.2258939,
                    56.4592055
                ],
                [
                    76.2259663,
                    56.4584057
                ],
                [
                    76.2290783,
                    56.4586456
                ],
                [
                    76.2326607,
                    56.4590255
                ],
                [
                    76.2334206,
                    56.4587256
                ],
                [
                    76.2345424,
                    56.4592055
                ],
                [
                    76.2352299,
                    56.460625
                ],
                [
                    76.2358813,
                    56.460745
                ],
                [
                    76.2381248,
                    56.457526
                ],
                [
                    76.2414901,
                    56.4545066
                ],
                [
                    76.2419244,
                    56.4537267
                ],
                [
                    76.2416245,
                    56.4526224
                ],
                [
                    76.2397791,
                    56.4525876
                ],
                [
                    76.2377268,
                    56.4538667
                ],
                [
                    76.2371116,
                    56.4551865
                ],
                [
                    76.2364603,
                    56.4551065
                ],
                [
                    76.2346871,
                    56.4567861
                ],
                [
                    76.2323712,
                    56.4559863
                ],
                [
                    76.2308876,
                    56.4564862
                ],
                [
                    76.226111,
                    56.4565862
                ],
                [
                    76.2263281,
                    56.4554464
                ],
                [
                    76.2205745,
                    56.4554464
                ],
                [
                    76.2198146,
                    56.4559063
                ],
                [
                    76.2186567,
                    56.4569261
                ],
                [
                    76.2180415,
                    56.4580258
                ]
            ],
            "longitude": 76.230881,
            "latitude": 56.458202
        },
        "9524": {
            "name": "Дубровино",
            "population": 54,
            "type": "hamlet",
            "poly": [
                [
                    76.2161626,
                    55.1177807
                ],
                [
                    76.2183803,
                    55.1185557
                ],
                [
                    76.2255754,
                    55.1225012
                ],
                [
                    76.2335837,
                    55.1175975
                ],
                [
                    76.2340518,
                    55.1165688
                ],
                [
                    76.2361463,
                    55.1155964
                ],
                [
                    76.240212,
                    55.1139052
                ],
                [
                    76.241173,
                    55.11251
                ],
                [
                    76.2394975,
                    55.1097616
                ],
                [
                    76.2389554,
                    55.1095784
                ],
                [
                    76.2347418,
                    55.1086199
                ],
                [
                    76.2343722,
                    55.1079715
                ],
                [
                    76.2238752,
                    55.1091273
                ],
                [
                    76.2205979,
                    55.1113543
                ],
                [
                    76.2161626,
                    55.1177807
                ]
            ],
            "longitude": 76.231003,
            "latitude": 55.111233
        },
        "9525": {
            "name": "Янабино",
            "population": 101,
            "type": "hamlet",
            "poly": [
                [
                    76.2308326,
                    55.9902395
                ],
                [
                    76.233027,
                    55.9911505
                ],
                [
                    76.2335473,
                    55.9907582
                ],
                [
                    76.2397684,
                    55.9925043
                ],
                [
                    76.2432069,
                    55.9932508
                ],
                [
                    76.2435914,
                    55.9940606
                ],
                [
                    76.2449488,
                    55.9923905
                ],
                [
                    76.2432296,
                    55.9909607
                ],
                [
                    76.2407638,
                    55.9898978
                ],
                [
                    76.2380944,
                    55.989379
                ],
                [
                    76.2347689,
                    55.98843
                ],
                [
                    76.2351535,
                    55.9878606
                ],
                [
                    76.2330454,
                    55.987456
                ],
                [
                    76.2317376,
                    55.9884047
                ],
                [
                    76.2326198,
                    55.9887337
                ],
                [
                    76.2308326,
                    55.9902395
                ]
            ],
            "longitude": 76.237747,
            "latitude": 55.990528
        },
        "9526": {
            "name": "Малая Тахта",
            "population": 39,
            "type": "hamlet",
            "poly": [
                [
                    76.2429867,
                    54.5977927
                ],
                [
                    76.249646,
                    54.5981339
                ],
                [
                    76.2560789,
                    54.601388
                ],
                [
                    76.2581174,
                    54.603356
                ],
                [
                    76.2607449,
                    54.6045631
                ],
                [
                    76.2655922,
                    54.6027
                ],
                [
                    76.2615603,
                    54.6017029
                ],
                [
                    76.2546292,
                    54.5969792
                ],
                [
                    76.2482417,
                    54.5952995
                ],
                [
                    76.2435756,
                    54.5953782
                ],
                [
                    76.2429867,
                    54.5977927
                ]
            ],
            "longitude": 76.253967,
            "latitude": 54.59808
        },
        "9527": {
            "name": "Дубровино",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    76.2529281,
                    55.9473664
                ],
                [
                    76.2580181,
                    55.9487716
                ],
                [
                    76.2585836,
                    55.9492664
                ],
                [
                    76.2626485,
                    55.9499987
                ],
                [
                    76.2639564,
                    55.9499195
                ],
                [
                    76.2700714,
                    55.9490091
                ],
                [
                    76.2713085,
                    55.9477424
                ],
                [
                    76.263921,
                    55.946258
                ],
                [
                    76.2540592,
                    55.9452683
                ],
                [
                    76.2529281,
                    55.9473664
                ]
            ],
            "longitude": 76.261375,
            "latitude": 55.948261
        },
        "9528": {
            "name": "Малинино",
            "population": 140,
            "type": "hamlet",
            "poly": [
                [
                    76.2723079,
                    55.5598568
                ],
                [
                    76.2731749,
                    55.5606592
                ],
                [
                    76.2788896,
                    55.5618628
                ],
                [
                    76.2848013,
                    55.5608821
                ],
                [
                    76.2896489,
                    55.561261
                ],
                [
                    76.2956789,
                    55.5609936
                ],
                [
                    76.2965853,
                    55.559099
                ],
                [
                    76.2868507,
                    55.5568477
                ],
                [
                    76.2730961,
                    55.554418
                ],
                [
                    76.2729779,
                    55.5551982
                ],
                [
                    76.2723079,
                    55.5598568
                ]
            ],
            "longitude": 76.282463,
            "latitude": 55.559647
        },
        "9529": {
            "name": "Озёрный",
            "population": 172,
            "type": "hamlet",
            "poly": [
                [
                    76.2857334,
                    54.832223
                ],
                [
                    76.2862035,
                    54.8342314
                ],
                [
                    76.2891812,
                    54.8354725
                ],
                [
                    76.2944706,
                    54.8368264
                ],
                [
                    76.2958811,
                    54.8369392
                ],
                [
                    76.2972132,
                    54.8357884
                ],
                [
                    76.2977226,
                    54.8367361
                ],
                [
                    76.2993682,
                    54.8371423
                ],
                [
                    76.2999809,
                    54.8364976
                ],
                [
                    76.3011705,
                    54.8348407
                ],
                [
                    76.3052844,
                    54.8343442
                ],
                [
                    76.3030902,
                    54.8324712
                ],
                [
                    76.2974091,
                    54.8314783
                ],
                [
                    76.2979969,
                    54.8305981
                ],
                [
                    76.2955285,
                    54.828725
                ],
                [
                    76.2911011,
                    54.8277996
                ],
                [
                    76.287614,
                    54.8295149
                ],
                [
                    76.2857334,
                    54.832223
                ]
            ],
            "longitude": 76.291435,
            "latitude": 54.833111
        },
        "9530": {
            "name": "Табулгинский",
            "population": 162,
            "type": "hamlet",
            "poly": [
                [
                    76.3007616,
                    54.9019006
                ],
                [
                    76.3028979,
                    54.9032367
                ],
                [
                    76.303685,
                    54.9038185
                ],
                [
                    76.3049967,
                    54.90384
                ],
                [
                    76.3055964,
                    54.9057793
                ],
                [
                    76.3081824,
                    54.9033444
                ],
                [
                    76.3111433,
                    54.9036245
                ],
                [
                    76.3132421,
                    54.9043572
                ],
                [
                    76.3163529,
                    54.9047881
                ],
                [
                    76.3165028,
                    54.9016851
                ],
                [
                    76.3097566,
                    54.8985603
                ],
                [
                    76.3049967,
                    54.8981508
                ],
                [
                    76.3007616,
                    54.9019006
                ]
            ],
            "longitude": 76.309418,
            "latitude": 54.901474
        },
        "9531": {
            "name": "Комбар",
            "population": 131,
            "type": "hamlet",
            "poly": [
                [
                    76.3063744,
                    55.4702353
                ],
                [
                    76.3161915,
                    55.4720122
                ],
                [
                    76.319615,
                    55.4673593
                ],
                [
                    76.3335157,
                    55.4695572
                ],
                [
                    76.3352481,
                    55.4665176
                ],
                [
                    76.3166452,
                    55.4597125
                ],
                [
                    76.3118192,
                    55.4624955
                ],
                [
                    76.3116954,
                    55.4650678
                ],
                [
                    76.3093443,
                    55.4661434
                ],
                [
                    76.3071581,
                    55.4678504
                ],
                [
                    76.3065394,
                    55.4685752
                ],
                [
                    76.3063744,
                    55.4702353
                ]
            ],
            "longitude": 76.314552,
            "latitude": 55.466545
        },
        "9532": {
            "name": "Кабаклы",
            "population": 63,
            "type": "hamlet",
            "poly": [
                [
                    76.317024,
                    55.2595666
                ],
                [
                    76.3434906,
                    55.2626783
                ],
                [
                    76.3443273,
                    55.259943
                ],
                [
                    76.3363125,
                    55.2588388
                ],
                [
                    76.3360042,
                    55.2598176
                ],
                [
                    76.3279893,
                    55.2573331
                ],
                [
                    76.3227488,
                    55.2567558
                ],
                [
                    76.3177286,
                    55.2570319
                ],
                [
                    76.317024,
                    55.2595666
                ]
            ],
            "longitude": 76.32959,
            "latitude": 55.258686
        },
        "9533": {
            "name": "Ивановка",
            "population": 109,
            "type": "hamlet",
            "poly": [
                [
                    76.3157468,
                    55.2463141
                ],
                [
                    76.3186974,
                    55.2493766
                ],
                [
                    76.3234975,
                    55.251711
                ],
                [
                    76.3187413,
                    55.252213
                ],
                [
                    76.3208552,
                    55.2549739
                ],
                [
                    76.3265361,
                    55.2562288
                ],
                [
                    76.3359161,
                    55.2571072
                ],
                [
                    76.3406281,
                    55.2566554
                ],
                [
                    76.3417291,
                    55.2550492
                ],
                [
                    76.3395712,
                    55.2539951
                ],
                [
                    76.3281655,
                    55.2511086
                ],
                [
                    76.3175524,
                    55.245084
                ],
                [
                    76.3157468,
                    55.2463141
                ]
            ],
            "longitude": 76.331108,
            "latitude": 55.254478
        },
        "9534": {
            "name": "Ядрышниково",
            "population": 11,
            "type": "hamlet",
            "poly": [
                [
                    76.3224792,
                    56.483704
                ],
                [
                    76.3255793,
                    56.4867185
                ],
                [
                    76.3262682,
                    56.4865188
                ],
                [
                    76.3265265,
                    56.4860244
                ],
                [
                    76.3280421,
                    56.4855964
                ],
                [
                    76.3293855,
                    56.4860719
                ],
                [
                    76.3327095,
                    56.4850924
                ],
                [
                    76.3327611,
                    56.4855394
                ],
                [
                    76.3348623,
                    56.4854158
                ],
                [
                    76.3346557,
                    56.4849593
                ],
                [
                    76.3378246,
                    56.4850259
                ],
                [
                    76.3378246,
                    56.4832951
                ],
                [
                    76.3370152,
                    56.4829622
                ],
                [
                    76.3348968,
                    56.4828196
                ],
                [
                    76.3343973,
                    56.4831429
                ],
                [
                    76.3331745,
                    56.4833426
                ],
                [
                    76.33252,
                    56.482753
                ],
                [
                    76.3274566,
                    56.4844648
                ],
                [
                    76.327336,
                    56.4842271
                ],
                [
                    76.3265954,
                    56.4842271
                ],
                [
                    76.3258204,
                    56.4828576
                ],
                [
                    76.3224792,
                    56.483704
                ]
            ],
            "longitude": 76.333633,
            "latitude": 56.484085
        },
        "9535": {
            "name": "Чаячье",
            "population": 64,
            "type": "hamlet",
            "poly": [
                [
                    76.322999,
                    54.6988126
                ],
                [
                    76.3248057,
                    54.6991488
                ],
                [
                    76.3236421,
                    54.7003697
                ],
                [
                    76.3252956,
                    54.7015375
                ],
                [
                    76.3306236,
                    54.7028114
                ],
                [
                    76.3315422,
                    54.7022983
                ],
                [
                    76.3348493,
                    54.7028822
                ],
                [
                    76.3369009,
                    54.7026345
                ],
                [
                    76.3376052,
                    54.7016083
                ],
                [
                    76.3392587,
                    54.7020506
                ],
                [
                    76.3403916,
                    54.7004582
                ],
                [
                    76.3389218,
                    54.6996619
                ],
                [
                    76.3400242,
                    54.6988833
                ],
                [
                    76.3415859,
                    54.6992019
                ],
                [
                    76.3422901,
                    54.6984764
                ],
                [
                    76.3415552,
                    54.6979101
                ],
                [
                    76.3383707,
                    54.6973616
                ],
                [
                    76.3379114,
                    54.6989541
                ],
                [
                    76.3368703,
                    54.6997681
                ],
                [
                    76.3348493,
                    54.7004051
                ],
                [
                    76.3304705,
                    54.6997681
                ],
                [
                    76.3277145,
                    54.6985648
                ],
                [
                    76.3254793,
                    54.6980871
                ],
                [
                    76.3234277,
                    54.6981048
                ],
                [
                    76.322999,
                    54.6988126
                ]
            ],
            "longitude": 76.333954,
            "latitude": 54.701122
        },
        "9536": {
            "name": "Лебяжинский",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    76.3763297,
                    54.8148728
                ],
                [
                    76.378994,
                    54.8166789
                ],
                [
                    76.3787588,
                    54.8172659
                ],
                [
                    76.3818149,
                    54.818056
                ],
                [
                    76.3847927,
                    54.8162725
                ],
                [
                    76.3884756,
                    54.8165434
                ],
                [
                    76.3901996,
                    54.8133376
                ],
                [
                    76.3790331,
                    54.8108314
                ],
                [
                    76.3777794,
                    54.8111927
                ],
                [
                    76.3763297,
                    54.8148728
                ]
            ],
            "longitude": 76.383004,
            "latitude": 54.8150451
        },
        "9537": {
            "name": "Тюсмень",
            "population": 95,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.392197,
            "latitude": 55.840179
        },
        "9538": {
            "name": "Ахтырка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.402939,
            "latitude": 55.710896
        },
        "9539": {
            "name": "Садовка",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    76.4127165,
                    56.4764561
                ],
                [
                    76.4129641,
                    56.4787804
                ],
                [
                    76.4161374,
                    56.478942
                ],
                [
                    76.4181854,
                    56.4787555
                ],
                [
                    76.4194232,
                    56.4797249
                ],
                [
                    76.4173077,
                    56.4798865
                ],
                [
                    76.4174425,
                    56.4802982
                ],
                [
                    76.4208271,
                    56.4810021
                ],
                [
                    76.4226293,
                    56.4808565
                ],
                [
                    76.422259,
                    56.4796504
                ],
                [
                    76.4198959,
                    56.4785567
                ],
                [
                    76.4187706,
                    56.4776742
                ],
                [
                    76.4191532,
                    56.4757601
                ],
                [
                    76.420346,
                    56.4739453
                ],
                [
                    76.4226416,
                    56.4731498
                ],
                [
                    76.4221239,
                    56.4718818
                ],
                [
                    76.4221239,
                    56.4709744
                ],
                [
                    76.424712,
                    56.4694826
                ],
                [
                    76.4235868,
                    56.4690723
                ],
                [
                    76.4216962,
                    56.470129
                ],
                [
                    76.4175103,
                    56.4699923
                ],
                [
                    76.41634,
                    56.4724164
                ],
                [
                    76.4164975,
                    56.4740075
                ],
                [
                    76.4157098,
                    56.4750889
                ],
                [
                    76.4154846,
                    56.4761827
                ],
                [
                    76.4130316,
                    56.4759838
                ],
                [
                    76.4127165,
                    56.4764561
                ]
            ],
            "longitude": 76.418991,
            "latitude": 56.473793
        },
        "9540": {
            "name": "Новочекино",
            "population": 59,
            "type": "hamlet",
            "poly": [
                [
                    76.4151711,
                    56.5131463
                ],
                [
                    76.4153912,
                    56.5136017
                ],
                [
                    76.4160239,
                    56.5157573
                ],
                [
                    76.4180051,
                    56.5164253
                ],
                [
                    76.418858,
                    56.5171539
                ],
                [
                    76.4184178,
                    56.5181405
                ],
                [
                    76.4213618,
                    56.5205387
                ],
                [
                    76.423563,
                    56.5199771
                ],
                [
                    76.4220497,
                    56.5187173
                ],
                [
                    76.4230678,
                    56.5180494
                ],
                [
                    76.4232604,
                    56.5173208
                ],
                [
                    76.4209216,
                    56.5148921
                ],
                [
                    76.420674,
                    56.5137839
                ],
                [
                    76.4220497,
                    56.5118103
                ],
                [
                    76.4227376,
                    56.5093356
                ],
                [
                    76.4212517,
                    56.5085917
                ],
                [
                    76.4190506,
                    56.5091383
                ],
                [
                    76.4178675,
                    56.5099581
                ],
                [
                    76.419711,
                    56.5107931
                ],
                [
                    76.419766,
                    56.5114156
                ],
                [
                    76.4167944,
                    56.5119773
                ],
                [
                    76.4151711,
                    56.5131463
                ]
            ],
            "longitude": 76.419273,
            "latitude": 56.515991
        },
        "9541": {
            "name": "Васильевка",
            "population": 252,
            "type": "hamlet",
            "poly": [
                [
                    76.4212987,
                    55.3379186
                ],
                [
                    76.424665,
                    55.3389237
                ],
                [
                    76.4234868,
                    55.3405031
                ],
                [
                    76.4292094,
                    55.3410774
                ],
                [
                    76.4346795,
                    55.3421781
                ],
                [
                    76.4464613,
                    55.3439009
                ],
                [
                    76.4495751,
                    55.3424174
                ],
                [
                    76.4372884,
                    55.3394501
                ],
                [
                    76.4232343,
                    55.3360519
                ],
                [
                    76.4212987,
                    55.3379186
                ]
            ],
            "longitude": 76.434738,
            "latitude": 55.340252
        },
        "9542": {
            "name": "Царицыно",
            "population": 24,
            "type": "hamlet",
            "poly": [
                [
                    76.4284193,
                    54.9992023
                ],
                [
                    76.4296539,
                    55.0009923
                ],
                [
                    76.4321231,
                    55.0005989
                ],
                [
                    76.4333577,
                    55.0020741
                ],
                [
                    76.4397365,
                    55.001307
                ],
                [
                    76.4450178,
                    54.9995957
                ],
                [
                    76.4457037,
                    54.9980023
                ],
                [
                    76.4430973,
                    54.9974122
                ],
                [
                    76.4362041,
                    54.9983171
                ],
                [
                    76.4341465,
                    54.9987695
                ],
                [
                    76.4342151,
                    54.9992023
                ],
                [
                    76.4318487,
                    54.9997727
                ],
                [
                    76.4298596,
                    54.9987302
                ],
                [
                    76.4284193,
                    54.9992023
                ]
            ],
            "longitude": 76.439171,
            "latitude": 54.998962
        },
        "9543": {
            "name": "Чекиаул",
            "population": 48,
            "type": "hamlet",
            "poly": [
                [
                    76.4516789,
                    56.4834546
                ],
                [
                    76.4529256,
                    56.4835495
                ],
                [
                    76.4524527,
                    56.4852112
                ],
                [
                    76.4569238,
                    56.4863981
                ],
                [
                    76.461094,
                    56.4866355
                ],
                [
                    76.4672418,
                    56.4857572
                ],
                [
                    76.4686605,
                    56.4823151
                ],
                [
                    76.4667479,
                    56.4817619
                ],
                [
                    76.4640174,
                    56.4811518
                ],
                [
                    76.4636304,
                    56.4807008
                ],
                [
                    76.4593837,
                    56.4800617
                ],
                [
                    76.4530546,
                    56.480131
                ],
                [
                    76.4516789,
                    56.4834546
                ]
            ],
            "longitude": 76.460922,
            "latitude": 56.482903
        },
        "9544": {
            "name": "2912 км",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.465233,
            "latitude": 55.271759
        },
        "9545": {
            "name": "Полтавка",
            "population": 170,
            "type": "hamlet",
            "poly": [
                [
                    76.4615442,
                    55.1226506
                ],
                [
                    76.4633048,
                    55.1279715
                ],
                [
                    76.4622359,
                    55.1285107
                ],
                [
                    76.4618586,
                    55.1300205
                ],
                [
                    76.4641222,
                    55.1303441
                ],
                [
                    76.4644365,
                    55.1295532
                ],
                [
                    76.4678318,
                    55.1299846
                ],
                [
                    76.4696553,
                    55.1272525
                ],
                [
                    76.4789611,
                    55.1301284
                ],
                [
                    76.4800929,
                    55.128295
                ],
                [
                    76.4783952,
                    55.1282231
                ],
                [
                    76.4792126,
                    55.126821
                ],
                [
                    76.4691523,
                    55.1238011
                ],
                [
                    76.4660714,
                    55.1230101
                ],
                [
                    76.4644993,
                    55.123118
                ],
                [
                    76.4634934,
                    55.1217876
                ],
                [
                    76.4615442,
                    55.1226506
                ]
            ],
            "longitude": 76.470329,
            "latitude": 55.125957
        },
        "9546": {
            "name": "Покровка",
            "population": 245,
            "type": "hamlet",
            "poly": [
                [
                    76.4559933,
                    54.8262841
                ],
                [
                    76.4599623,
                    54.8270725
                ],
                [
                    76.4636233,
                    54.8281565
                ],
                [
                    76.4672501,
                    54.8297529
                ],
                [
                    76.4682081,
                    54.8300486
                ],
                [
                    76.4824074,
                    54.8331032
                ],
                [
                    76.4820653,
                    54.8341674
                ],
                [
                    76.4828523,
                    54.8343644
                ],
                [
                    76.4844946,
                    54.8334579
                ],
                [
                    76.4868897,
                    54.8337338
                ],
                [
                    76.4874029,
                    54.8330835
                ],
                [
                    76.4930827,
                    54.8341871
                ],
                [
                    76.4941091,
                    54.8322558
                ],
                [
                    76.4858974,
                    54.8303245
                ],
                [
                    76.4845973,
                    54.8305413
                ],
                [
                    76.481689,
                    54.8294573
                ],
                [
                    76.4826128,
                    54.8273485
                ],
                [
                    76.4717323,
                    54.8249438
                ],
                [
                    76.4666342,
                    54.8239977
                ],
                [
                    76.4625626,
                    54.8228545
                ],
                [
                    76.4612967,
                    54.824254
                ],
                [
                    76.4604755,
                    54.8243722
                ],
                [
                    76.4595517,
                    54.8251212
                ],
                [
                    76.4571908,
                    54.8244708
                ],
                [
                    76.4559933,
                    54.8262841
                ]
            ],
            "longitude": 76.471138,
            "latitude": 54.827507
        },
        "9547": {
            "name": "Добринка",
            "population": 69,
            "type": "hamlet",
            "poly": [
                [
                    76.4624305,
                    55.4873526
                ],
                [
                    76.4632567,
                    55.4894591
                ],
                [
                    76.4708992,
                    55.4900833
                ],
                [
                    76.4728959,
                    55.4909024
                ],
                [
                    76.4738598,
                    55.4908244
                ],
                [
                    76.4766139,
                    55.4923066
                ],
                [
                    76.4792991,
                    55.4930477
                ],
                [
                    76.4783352,
                    55.4942179
                ],
                [
                    76.478886,
                    55.4951149
                ],
                [
                    76.4818466,
                    55.495622
                ],
                [
                    76.4837744,
                    55.4942569
                ],
                [
                    76.4831548,
                    55.4939838
                ],
                [
                    76.4837055,
                    55.4925407
                ],
                [
                    76.4781286,
                    55.4908244
                ],
                [
                    76.4795745,
                    55.4895372
                ],
                [
                    76.4789548,
                    55.488835
                ],
                [
                    76.4653911,
                    55.4861043
                ],
                [
                    76.4644961,
                    55.4868455
                ],
                [
                    76.4624305,
                    55.4873526
                ]
            ],
            "longitude": 76.474136,
            "latitude": 55.48941
        },
        "9548": {
            "name": "Узунгуль",
            "population": 57,
            "type": "hamlet",
            "poly": [
                [
                    76.4613456,
                    55.4358234
                ],
                [
                    76.4707755,
                    55.4387732
                ],
                [
                    76.4719652,
                    55.4381733
                ],
                [
                    76.4725821,
                    55.4384983
                ],
                [
                    76.4713924,
                    55.440298
                ],
                [
                    76.4756667,
                    55.4418228
                ],
                [
                    76.4768564,
                    55.440548
                ],
                [
                    76.4808663,
                    55.4414729
                ],
                [
                    76.4824086,
                    55.4392982
                ],
                [
                    76.4626675,
                    55.4343984
                ],
                [
                    76.4613456,
                    55.4358234
                ]
            ],
            "longitude": 76.47464,
            "latitude": 55.438496
        },
        "9549": {
            "name": "Верх-Чекино",
            "population": 47,
            "type": "hamlet",
            "poly": [
                [
                    76.4999199,
                    56.6830229
                ],
                [
                    76.5052527,
                    56.683524
                ],
                [
                    76.5058842,
                    56.6851812
                ],
                [
                    76.5040597,
                    56.6852968
                ],
                [
                    76.5040949,
                    56.6862024
                ],
                [
                    76.5031126,
                    56.6876861
                ],
                [
                    76.5026565,
                    56.6884761
                ],
                [
                    76.5082699,
                    56.6914047
                ],
                [
                    76.5123747,
                    56.6915588
                ],
                [
                    76.5140237,
                    56.6913276
                ],
                [
                    76.5140588,
                    56.6892853
                ],
                [
                    76.5138132,
                    56.6884376
                ],
                [
                    76.5103749,
                    56.6862602
                ],
                [
                    76.5105855,
                    56.6847187
                ],
                [
                    76.5142342,
                    56.6844875
                ],
                [
                    76.5147604,
                    56.6842948
                ],
                [
                    76.5129712,
                    56.6824641
                ],
                [
                    76.5088662,
                    56.6805177
                ],
                [
                    76.5072876,
                    56.6776075
                ],
                [
                    76.504972,
                    56.6779737
                ],
                [
                    76.5037441,
                    56.6790144
                ],
                [
                    76.5036388,
                    56.6798817
                ],
                [
                    76.5012531,
                    56.6802671
                ],
                [
                    76.5003059,
                    56.6819052
                ],
                [
                    76.4999199,
                    56.6830229
                ]
            ],
            "longitude": 76.508545,
            "latitude": 56.688965
        },
        "9550": {
            "name": "Гавриловка",
            "population": 78,
            "type": "hamlet",
            "poly": [
                [
                    76.5004572,
                    56.6570566
                ],
                [
                    76.5010186,
                    56.6575194
                ],
                [
                    76.5106316,
                    56.6602576
                ],
                [
                    76.5131927,
                    56.6579822
                ],
                [
                    76.5152977,
                    56.6565938
                ],
                [
                    76.5159642,
                    56.6569409
                ],
                [
                    76.5232618,
                    56.6577701
                ],
                [
                    76.5235424,
                    56.6556296
                ],
                [
                    76.5197885,
                    56.6548389
                ],
                [
                    76.5168765,
                    56.655186
                ],
                [
                    76.5109824,
                    56.6542989
                ],
                [
                    76.5088072,
                    56.6536239
                ],
                [
                    76.5027377,
                    56.6552439
                ],
                [
                    76.5008432,
                    56.6563045
                ],
                [
                    76.5004572,
                    56.6570566
                ]
            ],
            "longitude": 76.510399,
            "latitude": 56.656994
        },
        "9551": {
            "name": "Ядкан",
            "population": 20,
            "type": "hamlet",
            "poly": [
                [
                    76.4990586,
                    56.7358537
                ],
                [
                    76.5004345,
                    56.7372158
                ],
                [
                    76.5110732,
                    56.7360193
                ],
                [
                    76.5190605,
                    56.7350989
                ],
                [
                    76.5241953,
                    56.7331108
                ],
                [
                    76.5269808,
                    56.7309753
                ],
                [
                    76.5246651,
                    56.7300731
                ],
                [
                    76.5195975,
                    56.7309937
                ],
                [
                    76.5155702,
                    56.7322087
                ],
                [
                    76.5109054,
                    56.7325217
                ],
                [
                    76.4990586,
                    56.7358537
                ]
            ],
            "longitude": 76.515045,
            "latitude": 56.733883
        },
        "9552": {
            "name": "Алферовка",
            "population": 109,
            "type": "hamlet",
            "poly": [
                [
                    76.4966272,
                    54.1101689
                ],
                [
                    76.4984379,
                    54.1107198
                ],
                [
                    76.4975211,
                    54.1120097
                ],
                [
                    76.5017157,
                    54.1131384
                ],
                [
                    76.5065979,
                    54.1138236
                ],
                [
                    76.5097611,
                    54.1136086
                ],
                [
                    76.5151705,
                    54.1154896
                ],
                [
                    76.5224824,
                    54.1176527
                ],
                [
                    76.5231263,
                    54.1168722
                ],
                [
                    76.5248433,
                    54.114791
                ],
                [
                    76.5186545,
                    54.1129906
                ],
                [
                    76.5119615,
                    54.1111632
                ],
                [
                    76.5055436,
                    54.1087176
                ],
                [
                    76.5012344,
                    54.1075754
                ],
                [
                    76.4982087,
                    54.1068229
                ],
                [
                    76.4971544,
                    54.1086505
                ],
                [
                    76.4968964,
                    54.1093935
                ],
                [
                    76.4966272,
                    54.1101689
                ]
            ],
            "longitude": 76.516861,
            "latitude": 54.115234
        },
        "9553": {
            "name": "Кабаклы",
            "population": 267,
            "type": "hamlet",
            "poly": [
                [
                    76.5136759,
                    55.1854385
                ],
                [
                    76.5141712,
                    55.1858156
                ],
                [
                    76.5165927,
                    55.1862712
                ],
                [
                    76.5159598,
                    55.1878264
                ],
                [
                    76.5168128,
                    55.1880306
                ],
                [
                    76.5158222,
                    55.1890203
                ],
                [
                    76.5182712,
                    55.1898372
                ],
                [
                    76.5189316,
                    55.189146
                ],
                [
                    76.5216834,
                    55.1902456
                ],
                [
                    76.5199498,
                    55.1921776
                ],
                [
                    76.522674,
                    55.192963
                ],
                [
                    76.5264714,
                    55.1921619
                ],
                [
                    76.5309567,
                    55.1890831
                ],
                [
                    76.5230042,
                    55.1857685
                ],
                [
                    76.5221787,
                    55.1863183
                ],
                [
                    76.5214082,
                    55.1856271
                ],
                [
                    76.5167577,
                    55.1844488
                ],
                [
                    76.5156571,
                    55.184653
                ],
                [
                    76.5139784,
                    55.1844645
                ],
                [
                    76.5136759,
                    55.1854385
                ]
            ],
            "longitude": 76.522751,
            "latitude": 55.188057
        },
        "9554": {
            "name": "Игнатьевка",
            "population": 113,
            "type": "hamlet",
            "poly": [
                [
                    76.5274115,
                    55.6094225
                ],
                [
                    76.5288117,
                    55.6103291
                ],
                [
                    76.5309632,
                    55.6094996
                ],
                [
                    76.531373,
                    55.610194
                ],
                [
                    76.5330806,
                    55.6118336
                ],
                [
                    76.5321243,
                    55.6126822
                ],
                [
                    76.5340368,
                    55.6135309
                ],
                [
                    76.5333878,
                    55.6138973
                ],
                [
                    76.5362907,
                    55.615286
                ],
                [
                    76.5376909,
                    55.6142831
                ],
                [
                    76.5395692,
                    55.6152667
                ],
                [
                    76.5428818,
                    55.6159803
                ],
                [
                    76.5438039,
                    55.6153824
                ],
                [
                    76.544521,
                    55.6156524
                ],
                [
                    76.545409,
                    55.6149967
                ],
                [
                    76.5455797,
                    55.6141866
                ],
                [
                    76.5425403,
                    55.6124701
                ],
                [
                    76.5429501,
                    55.6122193
                ],
                [
                    76.5418573,
                    55.6119107
                ],
                [
                    76.5401498,
                    55.6118336
                ],
                [
                    76.5375885,
                    55.6113899
                ],
                [
                    76.5365981,
                    55.6107727
                ],
                [
                    76.5335927,
                    55.6081879
                ],
                [
                    76.5318511,
                    55.6088245
                ],
                [
                    76.5290507,
                    55.6070691
                ],
                [
                    76.5276506,
                    55.6078021
                ],
                [
                    76.5290849,
                    55.6087859
                ],
                [
                    76.528197,
                    55.6088052
                ],
                [
                    76.5277872,
                    55.609056
                ],
                [
                    76.5274115,
                    55.6094225
                ]
            ],
            "longitude": 76.533691,
            "latitude": 55.610542
        },
        "9555": {
            "name": "Таволга",
            "population": 56,
            "type": "hamlet",
            "poly": [
                [
                    76.5296054,
                    56.5781147
                ],
                [
                    76.5313918,
                    56.5784823
                ],
                [
                    76.5308422,
                    56.5795095
                ],
                [
                    76.5356125,
                    56.5805583
                ],
                [
                    76.5370848,
                    56.5800609
                ],
                [
                    76.5375559,
                    56.5793257
                ],
                [
                    76.538989,
                    56.577001
                ],
                [
                    76.5382234,
                    56.576828
                ],
                [
                    76.5385766,
                    56.5749897
                ],
                [
                    76.5348272,
                    56.5744274
                ],
                [
                    76.5335316,
                    56.5762008
                ],
                [
                    76.5328445,
                    56.5762008
                ],
                [
                    76.530744,
                    56.576655
                ],
                [
                    76.5296054,
                    56.5781147
                ]
            ],
            "longitude": 76.535683,
            "latitude": 56.577084
        },
        "9556": {
            "name": "Чертокулич",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.537376,
            "latitude": 55.277496
        },
        "9557": {
            "name": "Оравка",
            "population": 225,
            "type": "hamlet",
            "poly": [
                [
                    76.5340673,
                    55.4457696
                ],
                [
                    76.5356977,
                    55.4457696
                ],
                [
                    76.5357858,
                    55.4464944
                ],
                [
                    76.5374603,
                    55.4465443
                ],
                [
                    76.5374603,
                    55.4469942
                ],
                [
                    76.5391348,
                    55.4469942
                ],
                [
                    76.5459647,
                    55.4470942
                ],
                [
                    76.546802,
                    55.4463694
                ],
                [
                    76.5540728,
                    55.4469942
                ],
                [
                    76.5540287,
                    55.4461944
                ],
                [
                    76.5568928,
                    55.4462444
                ],
                [
                    76.5574657,
                    55.447519
                ],
                [
                    76.5598893,
                    55.4472191
                ],
                [
                    76.5598893,
                    55.4446199
                ],
                [
                    76.5550862,
                    55.44427
                ],
                [
                    76.5524864,
                    55.4446699
                ],
                [
                    76.5527949,
                    55.4425703
                ],
                [
                    76.5496222,
                    55.4425953
                ],
                [
                    76.5488731,
                    55.4430952
                ],
                [
                    76.5475952,
                    55.4430202
                ],
                [
                    76.5466699,
                    55.4421454
                ],
                [
                    76.5418227,
                    55.4420954
                ],
                [
                    76.5417787,
                    55.4434451
                ],
                [
                    76.5384738,
                    55.4436951
                ],
                [
                    76.5397957,
                    55.4444449
                ],
                [
                    76.5344639,
                    55.44407
                ],
                [
                    76.5340673,
                    55.4457696
                ]
            ],
            "longitude": 76.546814,
            "latitude": 55.44458
        },
        "9558": {
            "name": "Ильинка",
            "population": 212,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.549606,
            "latitude": 55.782314
        },
        "9559": {
            "name": "Кругленькая",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.5520381,
            "latitude": 55.5562583
        },
        "9560": {
            "name": "Берёзовка",
            "population": 195,
            "type": "hamlet",
            "poly": [
                [
                    76.5621096,
                    54.0304528
                ],
                [
                    76.5683504,
                    54.032347
                ],
                [
                    76.570277,
                    54.0309448
                ],
                [
                    76.5744653,
                    54.032224
                ],
                [
                    76.5750518,
                    54.0314123
                ],
                [
                    76.5766852,
                    54.0319781
                ],
                [
                    76.578235,
                    54.0310924
                ],
                [
                    76.5792402,
                    54.0314861
                ],
                [
                    76.5786119,
                    54.0322732
                ],
                [
                    76.5793658,
                    54.0324454
                ],
                [
                    76.5804129,
                    54.0311662
                ],
                [
                    76.579282,
                    54.030748
                ],
                [
                    76.580036,
                    54.0296902
                ],
                [
                    76.5778999,
                    54.0290506
                ],
                [
                    76.5740466,
                    54.0284847
                ],
                [
                    76.5786538,
                    54.0257046
                ],
                [
                    76.5784863,
                    54.0247697
                ],
                [
                    76.576769,
                    54.0244498
                ],
                [
                    76.5727482,
                    54.0277221
                ],
                [
                    76.571366,
                    54.0275498
                ],
                [
                    76.5672614,
                    54.0261229
                ],
                [
                    76.5664656,
                    54.0273284
                ],
                [
                    76.5650415,
                    54.0270086
                ],
                [
                    76.5644551,
                    54.0286815
                ],
                [
                    76.5631986,
                    54.0286815
                ],
                [
                    76.5621096,
                    54.0304528
                ]
            ],
            "longitude": 76.572517,
            "latitude": 54.029724
        },
        "9561": {
            "name": "Серп и Молот",
            "population": 76,
            "type": "hamlet",
            "poly": [
                [
                    76.5928018,
                    55.5303298
                ],
                [
                    76.5960491,
                    55.5312841
                ],
                [
                    76.596174,
                    55.5320793
                ],
                [
                    76.5964863,
                    55.5323797
                ],
                [
                    76.5964863,
                    55.5327862
                ],
                [
                    76.597985,
                    55.5330512
                ],
                [
                    76.6018256,
                    55.5330866
                ],
                [
                    76.605354,
                    55.5337404
                ],
                [
                    76.6087886,
                    55.5347123
                ],
                [
                    76.6098815,
                    55.5338641
                ],
                [
                    76.6088823,
                    55.5333516
                ],
                [
                    76.6095068,
                    55.5326448
                ],
                [
                    76.6081017,
                    55.5322914
                ],
                [
                    76.607602,
                    55.5318673
                ],
                [
                    76.6063844,
                    55.5316376
                ],
                [
                    76.6054164,
                    55.5317082
                ],
                [
                    76.6036054,
                    55.53086
                ],
                [
                    76.6020754,
                    55.5304182
                ],
                [
                    76.5984534,
                    55.5294462
                ],
                [
                    76.5956745,
                    55.5280854
                ],
                [
                    76.5928018,
                    55.5303298
                ]
            ],
            "longitude": 76.59996,
            "latitude": 55.531467
        },
        "9562": {
            "name": "Новоалексеевка",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    76.5958467,
                    54.7854587
                ],
                [
                    76.5973371,
                    54.7856272
                ],
                [
                    76.5979801,
                    54.7849194
                ],
                [
                    76.5990905,
                    54.7852733
                ],
                [
                    76.59836,
                    54.786554
                ],
                [
                    76.6102539,
                    54.7887614
                ],
                [
                    76.6124164,
                    54.7854924
                ],
                [
                    76.6066886,
                    54.7843128
                ],
                [
                    76.6072731,
                    54.783268
                ],
                [
                    76.6058996,
                    54.7830657
                ],
                [
                    76.6063087,
                    54.7824253
                ],
                [
                    76.6050229,
                    54.7821388
                ],
                [
                    76.6031818,
                    54.7838409
                ],
                [
                    76.6021882,
                    54.785307
                ],
                [
                    76.5966942,
                    54.7842622
                ],
                [
                    76.5958467,
                    54.7854587
                ]
            ],
            "longitude": 76.605186,
            "latitude": 54.78619
        },
        "9563": {
            "name": "Зеленопольский",
            "population": 51,
            "type": "hamlet",
            "poly": [
                [
                    76.6048389,
                    55.0550009
                ],
                [
                    76.6081966,
                    55.0551139
                ],
                [
                    76.6076888,
                    55.0561719
                ],
                [
                    76.6079845,
                    55.0569354
                ],
                [
                    76.6095488,
                    55.0573135
                ],
                [
                    76.6098409,
                    55.05673
                ],
                [
                    76.6108463,
                    55.056899
                ],
                [
                    76.6114799,
                    55.0560294
                ],
                [
                    76.6140034,
                    55.0517609
                ],
                [
                    76.6141853,
                    55.0504217
                ],
                [
                    76.6124808,
                    55.0501472
                ],
                [
                    76.6118621,
                    55.0513217
                ],
                [
                    76.6098118,
                    55.0515093
                ],
                [
                    76.6096419,
                    55.0519402
                ],
                [
                    76.6092841,
                    55.0524614
                ],
                [
                    76.6079496,
                    55.052378
                ],
                [
                    76.6070458,
                    55.0529722
                ],
                [
                    76.6059116,
                    55.0528807
                ],
                [
                    76.6055918,
                    55.0537832
                ],
                [
                    76.6048389,
                    55.0550009
                ]
            ],
            "longitude": 76.611153,
            "latitude": 55.052982
        },
        "9564": {
            "name": "Ольховка",
            "population": 152,
            "type": "hamlet",
            "poly": [
                [
                    76.6174348,
                    54.7448927
                ],
                [
                    76.6178503,
                    54.7454884
                ],
                [
                    76.6186142,
                    54.74784
                ],
                [
                    76.6185874,
                    54.7483274
                ],
                [
                    76.6187134,
                    54.7491019
                ],
                [
                    76.6196077,
                    54.7494834
                ],
                [
                    76.6194852,
                    54.7497506
                ],
                [
                    76.6205843,
                    54.75006
                ],
                [
                    76.6215895,
                    54.7498125
                ],
                [
                    76.6220988,
                    54.7488224
                ],
                [
                    76.6230771,
                    54.7490545
                ],
                [
                    76.6223131,
                    54.7498666
                ],
                [
                    76.623707,
                    54.75006
                ],
                [
                    76.6238142,
                    54.7498512
                ],
                [
                    76.6261596,
                    54.7504777
                ],
                [
                    76.6268833,
                    54.7505086
                ],
                [
                    76.627473,
                    54.750733
                ],
                [
                    76.6279287,
                    54.7505705
                ],
                [
                    76.6290143,
                    54.7485671
                ],
                [
                    76.6267359,
                    54.748134
                ],
                [
                    76.6272184,
                    54.7476002
                ],
                [
                    76.6258378,
                    54.7472676
                ],
                [
                    76.6252349,
                    54.7478246
                ],
                [
                    76.6232379,
                    54.7472521
                ],
                [
                    76.6239751,
                    54.7461846
                ],
                [
                    76.6179709,
                    54.7439799
                ],
                [
                    76.6174348,
                    54.7448927
                ]
            ],
            "longitude": 76.622963,
            "latitude": 54.748077
        },
        "9565": {
            "name": "Пахомово",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    76.6135881,
                    56.4320534
                ],
                [
                    76.6176019,
                    56.433584
                ],
                [
                    76.6278442,
                    56.434464
                ],
                [
                    76.6288823,
                    56.4320151
                ],
                [
                    76.6340726,
                    56.430408
                ],
                [
                    76.6367716,
                    56.42727
                ],
                [
                    76.6270137,
                    56.4217205
                ],
                [
                    76.6244532,
                    56.4242848
                ],
                [
                    76.6254912,
                    56.4250886
                ],
                [
                    76.6235535,
                    56.4279971
                ],
                [
                    76.6202317,
                    56.4280736
                ],
                [
                    76.6182248,
                    56.4289538
                ],
                [
                    76.6146953,
                    56.4308672
                ],
                [
                    76.6135881,
                    56.4320534
                ]
            ],
            "longitude": 76.63205,
            "latitude": 56.428375
        },
        "9566": {
            "name": "Новый Кошкуль",
            "population": 62,
            "type": "hamlet",
            "poly": [
                [
                    76.6278125,
                    54.9589961
                ],
                [
                    76.6290146,
                    54.9594521
                ],
                [
                    76.6312686,
                    54.9592919
                ],
                [
                    76.6317409,
                    54.9589591
                ],
                [
                    76.6338017,
                    54.9595877
                ],
                [
                    76.6353043,
                    54.9589714
                ],
                [
                    76.6344457,
                    54.9582073
                ],
                [
                    76.6388463,
                    54.9557421
                ],
                [
                    76.6406066,
                    54.9562598
                ],
                [
                    76.6418946,
                    54.9553476
                ],
                [
                    76.6364849,
                    54.9527467
                ],
                [
                    76.6324707,
                    54.9541273
                ],
                [
                    76.6292293,
                    54.9571472
                ],
                [
                    76.6306031,
                    54.9577759
                ],
                [
                    76.6278125,
                    54.9589961
                ]
            ],
            "longitude": 76.633995,
            "latitude": 54.95583
        },
        "9567": {
            "name": "Митрофановка",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    76.6259472,
                    54.1092973
                ],
                [
                    76.6259473,
                    54.1098539
                ],
                [
                    76.6259472,
                    54.1101931
                ],
                [
                    76.6296796,
                    54.1115147
                ],
                [
                    76.6363428,
                    54.1122343
                ],
                [
                    76.6426553,
                    54.1130713
                ],
                [
                    76.6444588,
                    54.1129832
                ],
                [
                    76.6475399,
                    54.1140257
                ],
                [
                    76.6503704,
                    54.1144368
                ],
                [
                    76.6519988,
                    54.1153325
                ],
                [
                    76.6513976,
                    54.1161988
                ],
                [
                    76.6544286,
                    54.1163309
                ],
                [
                    76.6565578,
                    54.1144809
                ],
                [
                    76.6570749,
                    54.1131034
                ],
                [
                    76.6574596,
                    54.1123811
                ],
                [
                    76.6566831,
                    54.1124839
                ],
                [
                    76.6558063,
                    54.1136439
                ],
                [
                    76.6551049,
                    54.113453
                ],
                [
                    76.6555809,
                    54.1118378
                ],
                [
                    76.6473896,
                    54.1097673
                ],
                [
                    76.646563,
                    54.1109861
                ],
                [
                    76.6459869,
                    54.1107952
                ],
                [
                    76.6451602,
                    54.1115882
                ],
                [
                    76.6445339,
                    54.1114413
                ],
                [
                    76.6461872,
                    54.1094589
                ],
                [
                    76.6414278,
                    54.1083134
                ],
                [
                    76.6376453,
                    54.108475
                ],
                [
                    76.6341884,
                    54.1080344
                ],
                [
                    76.6297297,
                    54.1083428
                ],
                [
                    76.6295794,
                    54.1093708
                ],
                [
                    76.6259472,
                    54.1092973
                ]
            ],
            "longitude": 76.647339,
            "latitude": 54.112797
        },
        "9568": {
            "name": "Олтарь",
            "population": 126,
            "type": "hamlet",
            "poly": [
                [
                    76.6389437,
                    54.5361446
                ],
                [
                    76.6437583,
                    54.5371847
                ],
                [
                    76.6433975,
                    54.5415543
                ],
                [
                    76.6546503,
                    54.5437978
                ],
                [
                    76.6569844,
                    54.5401022
                ],
                [
                    76.6587433,
                    54.5404881
                ],
                [
                    76.6602542,
                    54.5390229
                ],
                [
                    76.6606263,
                    54.5382248
                ],
                [
                    76.6612351,
                    54.5382575
                ],
                [
                    76.6619455,
                    54.5370539
                ],
                [
                    76.6529478,
                    54.5349082
                ],
                [
                    76.6486518,
                    54.5341427
                ],
                [
                    76.6482347,
                    54.5345941
                ],
                [
                    76.6463178,
                    54.534267
                ],
                [
                    76.6455624,
                    54.5352876
                ],
                [
                    76.6404321,
                    54.5340773
                ],
                [
                    76.6389437,
                    54.5361446
                ]
            ],
            "longitude": 76.65287,
            "latitude": 54.537159
        },
        "9569": {
            "name": "Сарыбалык",
            "population": 130,
            "type": "hamlet",
            "poly": [
                [
                    76.6481422,
                    55.2645199
                ],
                [
                    76.6486486,
                    55.2651611
                ],
                [
                    76.6499428,
                    55.2656741
                ],
                [
                    76.6508431,
                    55.2650329
                ],
                [
                    76.6518559,
                    55.2658023
                ],
                [
                    76.6534877,
                    55.2650329
                ],
                [
                    76.6528125,
                    55.2641031
                ],
                [
                    76.6547257,
                    55.2642313
                ],
                [
                    76.6552321,
                    55.2646161
                ],
                [
                    76.6547257,
                    55.2649367
                ],
                [
                    76.6554572,
                    55.2657703
                ],
                [
                    76.6583832,
                    55.2643596
                ],
                [
                    76.6581581,
                    55.2634298
                ],
                [
                    76.6566388,
                    55.2622435
                ],
                [
                    76.6561324,
                    55.2624358
                ],
                [
                    76.655626,
                    55.2619549
                ],
                [
                    76.6565825,
                    55.2615381
                ],
                [
                    76.6529251,
                    55.2592935
                ],
                [
                    76.6516082,
                    55.2599229
                ],
                [
                    76.6494364,
                    55.2609609
                ],
                [
                    76.6510682,
                    55.2626924
                ],
                [
                    76.6496614,
                    55.2635901
                ],
                [
                    76.6510682,
                    55.2641672
                ],
                [
                    76.6505055,
                    55.264584
                ],
                [
                    76.6488737,
                    55.2639428
                ],
                [
                    76.6481422,
                    55.2645199
                ]
            ],
            "longitude": 76.654106,
            "latitude": 55.262402
        },
        "9570": {
            "name": "Киевка",
            "population": 65,
            "type": "hamlet",
            "poly": [
                [
                    76.6395645,
                    53.9635853
                ],
                [
                    76.6437462,
                    53.9643107
                ],
                [
                    76.6426471,
                    53.9658088
                ],
                [
                    76.6498847,
                    53.9675433
                ],
                [
                    76.6510373,
                    53.9674645
                ],
                [
                    76.6554601,
                    53.9688521
                ],
                [
                    76.6558355,
                    53.9686471
                ],
                [
                    76.6574975,
                    53.9690413
                ],
                [
                    76.6573634,
                    53.9697823
                ],
                [
                    76.6611699,
                    53.9704446
                ],
                [
                    76.6626442,
                    53.9682056
                ],
                [
                    76.6630463,
                    53.9665499
                ],
                [
                    76.6535034,
                    53.9638376
                ],
                [
                    76.6498847,
                    53.9631753
                ],
                [
                    76.6487588,
                    53.9632068
                ],
                [
                    76.6428884,
                    53.9616929
                ],
                [
                    76.6424863,
                    53.9623237
                ],
                [
                    76.6402346,
                    53.9620083
                ],
                [
                    76.6395645,
                    53.9635853
                ]
            ],
            "longitude": 76.654732,
            "latitude": 53.966763
        },
        "9571": {
            "name": "Старый Кошкуль",
            "population": 57,
            "type": "hamlet",
            "poly": [
                [
                    76.6481583,
                    54.9642435
                ],
                [
                    76.6520273,
                    54.9661374
                ],
                [
                    76.6527621,
                    54.9672823
                ],
                [
                    76.6551465,
                    54.9708719
                ],
                [
                    76.6555663,
                    54.9724987
                ],
                [
                    76.6562861,
                    54.9734885
                ],
                [
                    76.6598702,
                    54.9730581
                ],
                [
                    76.6609949,
                    54.9748914
                ],
                [
                    76.6634992,
                    54.9742373
                ],
                [
                    76.6616547,
                    54.9715605
                ],
                [
                    76.6623295,
                    54.9715088
                ],
                [
                    76.6613998,
                    54.969245
                ],
                [
                    76.6600951,
                    54.9684789
                ],
                [
                    76.6584306,
                    54.9682981
                ],
                [
                    76.6575908,
                    54.9674115
                ],
                [
                    76.6576958,
                    54.9664043
                ],
                [
                    76.6546816,
                    54.9637097
                ],
                [
                    76.6520273,
                    54.962866
                ],
                [
                    76.6481583,
                    54.9642435
                ]
            ],
            "longitude": 76.657928,
            "latitude": 54.970478
        },
        "9572": {
            "name": "Орловка",
            "population": 268,
            "type": "hamlet",
            "poly": [
                [
                    76.6379333,
                    54.482012
                ],
                [
                    76.6441114,
                    54.4825272
                ],
                [
                    76.6437861,
                    54.4841586
                ],
                [
                    76.6596007,
                    54.485601
                ],
                [
                    76.661936,
                    54.4856182
                ],
                [
                    76.6653649,
                    54.4849828
                ],
                [
                    76.6656014,
                    54.4843475
                ],
                [
                    76.6737895,
                    54.4849657
                ],
                [
                    76.6749719,
                    54.4805523
                ],
                [
                    76.6759177,
                    54.4791268
                ],
                [
                    76.6699467,
                    54.4784227
                ],
                [
                    76.6709222,
                    54.4760354
                ],
                [
                    76.6658083,
                    54.4755373
                ],
                [
                    76.6665769,
                    54.4745411
                ],
                [
                    76.652802,
                    54.4727891
                ],
                [
                    76.6512648,
                    54.4778216
                ],
                [
                    76.6492548,
                    54.478749
                ],
                [
                    76.6473038,
                    54.478646
                ],
                [
                    76.6462101,
                    54.4789551
                ],
                [
                    76.6429881,
                    54.4787662
                ],
                [
                    76.642929,
                    54.4800371
                ],
                [
                    76.6384063,
                    54.4795734
                ],
                [
                    76.6379333,
                    54.482012
                ]
            ],
            "longitude": 76.660858,
            "latitude": 54.481796
        },
        "9573": {
            "name": "Бугриновка",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    76.6562728,
                    54.393549
                ],
                [
                    76.6594145,
                    54.3944673
                ],
                [
                    76.6585168,
                    54.3956319
                ],
                [
                    76.6650182,
                    54.3974534
                ],
                [
                    76.6648387,
                    54.3983045
                ],
                [
                    76.6674546,
                    54.3991181
                ],
                [
                    76.668583,
                    54.3979536
                ],
                [
                    76.6697884,
                    54.3982447
                ],
                [
                    76.6716862,
                    54.3969607
                ],
                [
                    76.670981,
                    54.3965427
                ],
                [
                    76.6713785,
                    54.3957514
                ],
                [
                    76.664813,
                    54.3940268
                ],
                [
                    76.665108,
                    54.3935639
                ],
                [
                    76.6580937,
                    54.3916004
                ],
                [
                    76.6562728,
                    54.393549
                ]
            ],
            "longitude": 76.664383,
            "latitude": 54.395412
        },
        "9574": {
            "name": "Агачаулово",
            "population": 59,
            "type": "hamlet",
            "poly": [
                [
                    76.6551798,
                    56.5435859
                ],
                [
                    76.6562467,
                    56.5444066
                ],
                [
                    76.6554775,
                    56.544858
                ],
                [
                    76.6561226,
                    56.5454599
                ],
                [
                    76.659497,
                    56.544817
                ],
                [
                    76.6588766,
                    56.544475
                ],
                [
                    76.6598195,
                    56.5439142
                ],
                [
                    76.6615315,
                    56.5442425
                ],
                [
                    76.6619781,
                    56.5440236
                ],
                [
                    76.6627721,
                    56.5429567
                ],
                [
                    76.6648314,
                    56.5430661
                ],
                [
                    76.6658735,
                    56.5427105
                ],
                [
                    76.6684787,
                    56.5427652
                ],
                [
                    76.66962,
                    56.5427242
                ],
                [
                    76.6706125,
                    56.5425463
                ],
                [
                    76.671332,
                    56.5423275
                ],
                [
                    76.6746815,
                    56.5427379
                ],
                [
                    76.6751033,
                    56.5420813
                ],
                [
                    76.671059,
                    56.5413426
                ],
                [
                    76.6700418,
                    56.5406996
                ],
                [
                    76.668702,
                    56.5405218
                ],
                [
                    76.6676351,
                    56.5409459
                ],
                [
                    76.6658239,
                    56.5408912
                ],
                [
                    76.6645089,
                    56.540344
                ],
                [
                    76.6633179,
                    56.5395369
                ],
                [
                    76.662524,
                    56.5395095
                ],
                [
                    76.6616059,
                    56.5403576
                ],
                [
                    76.6625736,
                    56.5416709
                ],
                [
                    76.6618789,
                    56.5420129
                ],
                [
                    76.6605639,
                    56.5411374
                ],
                [
                    76.6598195,
                    56.5413836
                ],
                [
                    76.6590504,
                    56.5419034
                ],
                [
                    76.6593977,
                    56.5424916
                ],
                [
                    76.6577353,
                    56.5426831
                ],
                [
                    76.6551798,
                    56.5435859
                ]
            ],
            "longitude": 76.665619,
            "latitude": 56.54158
        },
        "9575": {
            "name": "2926 км",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    76.6702935,
                    55.2948461
                ],
                [
                    76.6711451,
                    55.2954785
                ],
                [
                    76.6717375,
                    55.295612
                ],
                [
                    76.672478,
                    55.2951412
                ],
                [
                    76.6717128,
                    55.2949515
                ],
                [
                    76.6702935,
                    55.2948461
                ]
            ],
            "longitude": 76.671631,
            "latitude": 55.295223
        },
        "9576": {
            "name": "Песцы",
            "population": 138,
            "type": "hamlet",
            "poly": [
                [
                    76.6650607,
                    55.3032147
                ],
                [
                    76.6709905,
                    55.3049024
                ],
                [
                    76.6712315,
                    55.3041751
                ],
                [
                    76.6751848,
                    55.300484
                ],
                [
                    76.6787764,
                    55.3011152
                ],
                [
                    76.6797647,
                    55.2995646
                ],
                [
                    76.6792585,
                    55.2995097
                ],
                [
                    76.679596,
                    55.2988648
                ],
                [
                    76.6750401,
                    55.2977669
                ],
                [
                    76.6736661,
                    55.2972454
                ],
                [
                    76.6699058,
                    55.2966279
                ],
                [
                    76.6693755,
                    55.2977395
                ],
                [
                    76.6709422,
                    55.2989197
                ],
                [
                    76.6702432,
                    55.2997979
                ],
                [
                    76.668363,
                    55.2994137
                ],
                [
                    76.667423,
                    55.3004429
                ],
                [
                    76.6663863,
                    55.3002507
                ],
                [
                    76.6655428,
                    55.3015818
                ],
                [
                    76.6661695,
                    55.3018288
                ],
                [
                    76.6650607,
                    55.3032147
                ]
            ],
            "longitude": 76.672287,
            "latitude": 55.300392
        },
        "9577": {
            "name": "Николаевка",
            "population": 99,
            "type": "hamlet",
            "poly": [
                [
                    76.6738581,
                    55.3360195
                ],
                [
                    76.6743222,
                    55.3375592
                ],
                [
                    76.6778802,
                    55.3372366
                ],
                [
                    76.6776224,
                    55.3361368
                ],
                [
                    76.6803811,
                    55.3360635
                ],
                [
                    76.6806904,
                    55.3374125
                ],
                [
                    76.6812576,
                    55.3375885
                ],
                [
                    76.6830108,
                    55.3377205
                ],
                [
                    76.6831398,
                    55.3375005
                ],
                [
                    76.6838101,
                    55.3375738
                ],
                [
                    76.6838874,
                    55.3377498
                ],
                [
                    76.6871618,
                    55.3378818
                ],
                [
                    76.6873423,
                    55.3368553
                ],
                [
                    76.6860789,
                    55.3357995
                ],
                [
                    76.6865688,
                    55.3349783
                ],
                [
                    76.6862594,
                    55.3339225
                ],
                [
                    76.686414,
                    55.3332772
                ],
                [
                    76.6850733,
                    55.3332772
                ],
                [
                    76.6854602,
                    55.332456
                ],
                [
                    76.6835523,
                    55.33228
                ],
                [
                    76.6830624,
                    55.3332186
                ],
                [
                    76.6816702,
                    55.3332626
                ],
                [
                    76.6820311,
                    55.3324853
                ],
                [
                    76.6815413,
                    55.3324266
                ],
                [
                    76.6809483,
                    55.3331746
                ],
                [
                    76.680149,
                    55.3331599
                ],
                [
                    76.6809225,
                    55.3321773
                ],
                [
                    76.6800973,
                    55.3316934
                ],
                [
                    76.679556,
                    55.3316347
                ],
                [
                    76.679324,
                    55.3319427
                ],
                [
                    76.6782669,
                    55.3319134
                ],
                [
                    76.6780606,
                    55.3329106
                ],
                [
                    76.678963,
                    55.3330719
                ],
                [
                    76.6783443,
                    55.3343038
                ],
                [
                    76.676823,
                    55.3343038
                ],
                [
                    76.6770036,
                    55.3345677
                ],
                [
                    76.6760496,
                    55.3346117
                ],
                [
                    76.6764622,
                    55.3358142
                ],
                [
                    76.6738581,
                    55.3360195
                ]
            ],
            "longitude": 76.683456,
            "latitude": 55.335461
        },
        "9578": {
            "name": "Ковыльный",
            "population": 113,
            "type": "hamlet",
            "poly": [
                [
                    76.679699,
                    55.1342611
                ],
                [
                    76.6834583,
                    55.1349394
                ],
                [
                    76.6833511,
                    55.135539
                ],
                [
                    76.6865743,
                    55.1362261
                ],
                [
                    76.6871485,
                    55.1354252
                ],
                [
                    76.6914819,
                    55.1361824
                ],
                [
                    76.6939702,
                    55.1366813
                ],
                [
                    76.6946898,
                    55.1350314
                ],
                [
                    76.6920408,
                    55.1346024
                ],
                [
                    76.6928907,
                    55.1324666
                ],
                [
                    76.690479,
                    55.1319807
                ],
                [
                    76.6896751,
                    55.1324972
                ],
                [
                    76.6882892,
                    55.1323615
                ],
                [
                    76.687271,
                    55.1330662
                ],
                [
                    76.6828151,
                    55.1324228
                ],
                [
                    76.6824017,
                    55.1333595
                ],
                [
                    76.6802886,
                    55.1331713
                ],
                [
                    76.679699,
                    55.1342611
                ]
            ],
            "longitude": 76.6874359,
            "latitude": 55.1340506
        },
        "9579": {
            "name": "Вятка",
            "population": 86,
            "type": "hamlet",
            "poly": [
                [
                    76.7003181,
                    56.5437816
                ],
                [
                    76.7010865,
                    56.5451937
                ],
                [
                    76.7043311,
                    56.5466764
                ],
                [
                    76.7069779,
                    56.5470058
                ],
                [
                    76.7094967,
                    56.545735
                ],
                [
                    76.7112471,
                    56.5456879
                ],
                [
                    76.7139793,
                    56.5459939
                ],
                [
                    76.7155162,
                    56.5477824
                ],
                [
                    76.7193584,
                    56.5500651
                ],
                [
                    76.7213649,
                    56.5483472
                ],
                [
                    76.7203403,
                    56.5455232
                ],
                [
                    76.7167115,
                    56.5426989
                ],
                [
                    76.7135097,
                    56.5394508
                ],
                [
                    76.7101798,
                    56.5386975
                ],
                [
                    76.7063802,
                    56.5407218
                ],
                [
                    76.7092833,
                    56.5441817
                ],
                [
                    76.7026233,
                    56.5431932
                ],
                [
                    76.7003181,
                    56.5437816
                ]
            ],
            "longitude": 76.714569,
            "latitude": 56.545013
        },
        "9580": {
            "name": "Тынгиза",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    76.7118569,
                    56.9259045
                ],
                [
                    76.7134318,
                    56.9262202
                ],
                [
                    76.7152638,
                    56.9241856
                ],
                [
                    76.7172243,
                    56.9243785
                ],
                [
                    76.7177386,
                    56.9227122
                ],
                [
                    76.7213382,
                    56.9220982
                ],
                [
                    76.7230095,
                    56.9213439
                ],
                [
                    76.7241666,
                    56.9196599
                ],
                [
                    76.7237166,
                    56.9189757
                ],
                [
                    76.7240702,
                    56.9185021
                ],
                [
                    76.7222703,
                    56.9173617
                ],
                [
                    76.7208561,
                    56.9169582
                ],
                [
                    76.7195705,
                    56.9170284
                ],
                [
                    76.7172565,
                    56.9174144
                ],
                [
                    76.7156494,
                    56.9181687
                ],
                [
                    76.7151995,
                    56.9192389
                ],
                [
                    76.7150709,
                    56.9199932
                ],
                [
                    76.7134638,
                    56.9216597
                ],
                [
                    76.7128211,
                    56.9232209
                ],
                [
                    76.7118569,
                    56.9259045
                ]
            ],
            "longitude": 76.717148,
            "latitude": 56.920048
        },
        "9581": {
            "name": "Худышка",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    76.7220724,
                    56.641358
                ],
                [
                    76.7225556,
                    56.6419135
                ],
                [
                    76.7239611,
                    56.6427829
                ],
                [
                    76.7254324,
                    56.6423603
                ],
                [
                    76.7248395,
                    56.6415995
                ],
                [
                    76.7264864,
                    56.6412856
                ],
                [
                    76.727365,
                    56.6421188
                ],
                [
                    76.7274748,
                    56.6435195
                ],
                [
                    76.7278481,
                    56.6438818
                ],
                [
                    76.7298905,
                    56.6441353
                ],
                [
                    76.7310544,
                    56.6435195
                ],
                [
                    76.7308128,
                    56.6423482
                ],
                [
                    76.7314277,
                    56.6422758
                ],
                [
                    76.731801,
                    56.6420584
                ],
                [
                    76.7341069,
                    56.6423241
                ],
                [
                    76.7350952,
                    56.640718
                ],
                [
                    76.7337995,
                    56.6404161
                ],
                [
                    76.7345901,
                    56.6397157
                ],
                [
                    76.7352928,
                    56.6396432
                ],
                [
                    76.7361273,
                    56.6387979
                ],
                [
                    76.7350952,
                    56.6378559
                ],
                [
                    76.7343705,
                    56.6376989
                ],
                [
                    76.7321524,
                    56.6386892
                ],
                [
                    76.7308787,
                    56.637868
                ],
                [
                    76.7339752,
                    56.6361651
                ],
                [
                    76.7331406,
                    56.6358269
                ],
                [
                    76.7349634,
                    56.6347641
                ],
                [
                    76.732943,
                    56.633508
                ],
                [
                    76.7291218,
                    56.6358269
                ],
                [
                    76.7292755,
                    56.6363221
                ],
                [
                    76.7296489,
                    56.6364791
                ],
                [
                    76.7291877,
                    56.6370226
                ],
                [
                    76.7281775,
                    56.6370709
                ],
                [
                    76.7277383,
                    56.6374574
                ],
                [
                    76.7287705,
                    56.6382303
                ],
                [
                    76.7258058,
                    56.639293
                ],
                [
                    76.7258058,
                    56.6400176
                ],
                [
                    76.7253884,
                    56.6403195
                ],
                [
                    76.7253226,
                    56.6411286
                ],
                [
                    76.7244661,
                    56.6411165
                ],
                [
                    76.723434,
                    56.6401625
                ],
                [
                    76.7225556,
                    56.6404765
                ],
                [
                    76.7220724,
                    56.641358
                ]
            ],
            "longitude": 76.729866,
            "latitude": 56.640064
        },
        "9582": {
            "name": "Садовый",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    76.7352745,
                    54.5058838
                ],
                [
                    76.7369979,
                    54.506427
                ],
                [
                    76.7357915,
                    54.5084187
                ],
                [
                    76.736087,
                    54.5091525
                ],
                [
                    76.7375068,
                    54.5094193
                ],
                [
                    76.7396076,
                    54.5076468
                ],
                [
                    76.7393451,
                    54.5072037
                ],
                [
                    76.7383849,
                    54.5070131
                ],
                [
                    76.7381141,
                    54.5059362
                ],
                [
                    76.7355043,
                    54.5054454
                ],
                [
                    76.7352745,
                    54.5058838
                ]
            ],
            "longitude": 76.737915,
            "latitude": 54.50774
        },
        "9583": {
            "name": "Юдино",
            "population": 43,
            "type": "hamlet",
            "poly": [
                [
                    76.7314072,
                    54.7545142
                ],
                [
                    76.7331722,
                    54.754894
                ],
                [
                    76.7333217,
                    54.7567583
                ],
                [
                    76.7384669,
                    54.7576387
                ],
                [
                    76.7406506,
                    54.7593648
                ],
                [
                    76.7483983,
                    54.7619365
                ],
                [
                    76.7473214,
                    54.7632137
                ],
                [
                    76.749565,
                    54.764232
                ],
                [
                    76.7537529,
                    54.759779
                ],
                [
                    76.7511504,
                    54.758847
                ],
                [
                    76.751629,
                    54.758122
                ],
                [
                    76.7513897,
                    54.7567065
                ],
                [
                    76.7496846,
                    54.7561714
                ],
                [
                    76.7469026,
                    54.7558089
                ],
                [
                    76.7430737,
                    54.7550148
                ],
                [
                    76.7368216,
                    54.7538582
                ],
                [
                    76.7324243,
                    54.7527361
                ],
                [
                    76.7314072,
                    54.7545142
                ]
            ],
            "longitude": 76.744698,
            "latitude": 54.757961
        },
        "9584": {
            "name": "Калиновка",
            "population": 76,
            "type": "hamlet",
            "poly": [
                [
                    76.7367157,
                    55.1813724
                ],
                [
                    76.7381781,
                    55.1819207
                ],
                [
                    76.7375597,
                    55.1825521
                ],
                [
                    76.7398514,
                    55.1832666
                ],
                [
                    76.7420268,
                    55.1840143
                ],
                [
                    76.7442386,
                    55.1850777
                ],
                [
                    76.7449734,
                    55.185626
                ],
                [
                    76.7453299,
                    55.186004
                ],
                [
                    76.7467777,
                    55.1868472
                ],
                [
                    76.7470833,
                    55.1868306
                ],
                [
                    76.7473889,
                    55.1870216
                ],
                [
                    76.7483129,
                    55.1871878
                ],
                [
                    76.7490186,
                    55.1875782
                ],
                [
                    76.7495206,
                    55.1875035
                ],
                [
                    76.7499353,
                    55.1876114
                ],
                [
                    76.7508739,
                    55.186897
                ],
                [
                    76.751274,
                    55.1864401
                ],
                [
                    76.7515214,
                    55.1859375
                ],
                [
                    76.7522125,
                    55.1855842
                ],
                [
                    76.7531147,
                    55.1859002
                ],
                [
                    76.754206,
                    55.1852273
                ],
                [
                    76.7532821,
                    55.1847329
                ],
                [
                    76.7531595,
                    55.1846942
                ],
                [
                    76.7516467,
                    55.1854627
                ],
                [
                    76.7515358,
                    55.185356
                ],
                [
                    76.7499935,
                    55.1842303
                ],
                [
                    76.7487494,
                    55.1836363
                ],
                [
                    76.7492805,
                    55.1832375
                ],
                [
                    76.7482619,
                    55.1829011
                ],
                [
                    76.74784,
                    55.1832292
                ],
                [
                    76.746996,
                    55.1829509
                ],
                [
                    76.7438457,
                    55.1821741
                ],
                [
                    76.7408846,
                    55.1814347
                ],
                [
                    76.7383018,
                    55.1806329
                ],
                [
                    76.7376106,
                    55.1807949
                ],
                [
                    76.7371813,
                    55.1809985
                ],
                [
                    76.7367157,
                    55.1813724
                ]
            ],
            "longitude": 76.745491,
            "latitude": 55.184456
        },
        "9585": {
            "name": "Коровинка",
            "population": 92,
            "type": "hamlet",
            "poly": [
                [
                    76.7589062,
                    56.5382186
                ],
                [
                    76.7600092,
                    56.5392548
                ],
                [
                    76.7609182,
                    56.5400938
                ],
                [
                    76.7618476,
                    56.5401783
                ],
                [
                    76.763063,
                    56.5405612
                ],
                [
                    76.7632774,
                    56.5408709
                ],
                [
                    76.763257,
                    56.5412538
                ],
                [
                    76.7627055,
                    56.5419407
                ],
                [
                    76.7635634,
                    56.54305
                ],
                [
                    76.7638494,
                    56.543095
                ],
                [
                    76.7648196,
                    56.5449981
                ],
                [
                    76.7661065,
                    56.5467885
                ],
                [
                    76.7668316,
                    56.5468279
                ],
                [
                    76.767475,
                    56.5480553
                ],
                [
                    76.7683023,
                    56.5478864
                ],
                [
                    76.7694768,
                    56.5490349
                ],
                [
                    76.7713356,
                    56.5485451
                ],
                [
                    76.7710598,
                    56.5478076
                ],
                [
                    76.7722752,
                    56.5475429
                ],
                [
                    76.7715807,
                    56.5469236
                ],
                [
                    76.771019,
                    56.5470306
                ],
                [
                    76.7704675,
                    56.5461861
                ],
                [
                    76.7698955,
                    56.5454091
                ],
                [
                    76.7694257,
                    56.5454654
                ],
                [
                    76.7687925,
                    56.5445083
                ],
                [
                    76.7690479,
                    56.5444238
                ],
                [
                    76.7681592,
                    56.5429937
                ],
                [
                    76.7687006,
                    56.5427403
                ],
                [
                    76.768721,
                    56.5424531
                ],
                [
                    76.7692215,
                    56.5422673
                ],
                [
                    76.7690887,
                    56.5418506
                ],
                [
                    76.767138,
                    56.5415635
                ],
                [
                    76.7656979,
                    56.5416142
                ],
                [
                    76.7655958,
                    56.541006
                ],
                [
                    76.7665763,
                    56.5408652
                ],
                [
                    76.7663515,
                    56.5405161
                ],
                [
                    76.7668316,
                    56.5402796
                ],
                [
                    76.766372,
                    56.5398179
                ],
                [
                    76.7654426,
                    56.5393843
                ],
                [
                    76.7646256,
                    56.5397841
                ],
                [
                    76.7639719,
                    56.5394519
                ],
                [
                    76.7655652,
                    56.5386297
                ],
                [
                    76.7643702,
                    56.5380609
                ],
                [
                    76.7628689,
                    56.5380609
                ],
                [
                    76.7625113,
                    56.5381679
                ],
                [
                    76.7622357,
                    56.5380328
                ],
                [
                    76.7625113,
                    56.5374527
                ],
                [
                    76.7617863,
                    56.5370079
                ],
                [
                    76.7612144,
                    56.5369797
                ],
                [
                    76.7589062,
                    56.5382186
                ]
            ],
            "longitude": 76.764854,
            "latitude": 56.54216
        },
        "9586": {
            "name": "Матвеевка",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    76.7949102,
                    55.0474225
                ],
                [
                    76.7961018,
                    55.0477151
                ],
                [
                    76.7966806,
                    55.0468959
                ],
                [
                    76.8000511,
                    55.0476956
                ],
                [
                    76.7997107,
                    55.0483197
                ],
                [
                    76.8004937,
                    55.0484367
                ],
                [
                    76.8036939,
                    55.0446722
                ],
                [
                    76.8063156,
                    55.0453549
                ],
                [
                    76.8074391,
                    55.0441651
                ],
                [
                    76.7975998,
                    55.0412
                ],
                [
                    76.7965444,
                    55.0421754
                ],
                [
                    76.7967487,
                    55.0434628
                ],
                [
                    76.7981446,
                    55.0437554
                ],
                [
                    76.795523,
                    55.0459401
                ],
                [
                    76.7954209,
                    55.0464668
                ],
                [
                    76.7949102,
                    55.0474225
                ]
            ],
            "longitude": 76.8004226,
            "latitude": 55.0442447
        },
        "9587": {
            "name": "Селиваново",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    76.8035338,
                    53.8994421
                ],
                [
                    76.8067954,
                    53.9007111
                ],
                [
                    76.8100365,
                    53.8981005
                ],
                [
                    76.8110622,
                    53.8981609
                ],
                [
                    76.8113289,
                    53.8976411
                ],
                [
                    76.8125802,
                    53.8976291
                ],
                [
                    76.8127853,
                    53.896928
                ],
                [
                    76.8125802,
                    53.895961
                ],
                [
                    76.8126007,
                    53.8943654
                ],
                [
                    76.8118827,
                    53.8943533
                ],
                [
                    76.811534,
                    53.8947281
                ],
                [
                    76.810057,
                    53.89445
                ],
                [
                    76.8092365,
                    53.8915609
                ],
                [
                    76.8075134,
                    53.8917785
                ],
                [
                    76.8068159,
                    53.8927335
                ],
                [
                    76.8072672,
                    53.8934709
                ],
                [
                    76.8075339,
                    53.8940995
                ],
                [
                    76.8070006,
                    53.8944138
                ],
                [
                    76.8037183,
                    53.8954412
                ],
                [
                    76.8036364,
                    53.8966621
                ],
                [
                    76.8047236,
                    53.8963116
                ],
                [
                    76.8059133,
                    53.8963599
                ],
                [
                    76.8064057,
                    53.8976895
                ],
                [
                    76.8071441,
                    53.8980279
                ],
                [
                    76.8055851,
                    53.8987048
                ],
                [
                    76.8049287,
                    53.8984872
                ],
                [
                    76.8040466,
                    53.8988861
                ],
                [
                    76.8035338,
                    53.8994421
                ]
            ],
            "longitude": 76.809006,
            "latitude": 53.896217
        },
        "9588": {
            "name": "Белехта",
            "population": 235,
            "type": "hamlet",
            "poly": [
                [
                    76.813018,
                    55.2646536
                ],
                [
                    76.8143338,
                    55.2649247
                ],
                [
                    76.8135499,
                    55.2658499
                ],
                [
                    76.8150897,
                    55.2663284
                ],
                [
                    76.8157616,
                    55.2662168
                ],
                [
                    76.8172454,
                    55.2643824
                ],
                [
                    76.8183372,
                    55.263186
                ],
                [
                    76.8191491,
                    55.2615588
                ],
                [
                    76.8190651,
                    55.2611281
                ],
                [
                    76.819905,
                    55.2588467
                ],
                [
                    76.8192331,
                    55.2586234
                ],
                [
                    76.8192891,
                    55.2582724
                ],
                [
                    76.8173014,
                    55.2580171
                ],
                [
                    76.8160975,
                    55.2581129
                ],
                [
                    76.8150337,
                    55.2615588
                ],
                [
                    76.8137179,
                    55.2627712
                ],
                [
                    76.813018,
                    55.2646536
                ]
            ],
            "longitude": 76.817131,
            "latitude": 55.261093
        },
        "9589": {
            "name": "Север",
            "population": 191,
            "type": "hamlet",
            "poly": [
                [
                    76.8285964,
                    55.3762096
                ],
                [
                    76.8292178,
                    55.3772452
                ],
                [
                    76.8304397,
                    55.3774688
                ],
                [
                    76.8312269,
                    55.3773865
                ],
                [
                    76.8319104,
                    55.377716
                ],
                [
                    76.8333189,
                    55.3781161
                ],
                [
                    76.832093,
                    55.3788237
                ],
                [
                    76.8333552,
                    55.3793017
                ],
                [
                    76.8356206,
                    55.3783824
                ],
                [
                    76.8358472,
                    55.3781617
                ],
                [
                    76.8350381,
                    55.3779043
                ],
                [
                    76.8350057,
                    55.377463
                ],
                [
                    76.8357177,
                    55.3769297
                ],
                [
                    76.8361385,
                    55.3771136
                ],
                [
                    76.8357501,
                    55.3775549
                ],
                [
                    76.8385009,
                    55.3787317
                ],
                [
                    76.8410901,
                    55.3800188
                ],
                [
                    76.8418021,
                    55.3804417
                ],
                [
                    76.8446178,
                    55.3815633
                ],
                [
                    76.8458476,
                    55.3805153
                ],
                [
                    76.8448443,
                    55.3795775
                ],
                [
                    76.8453622,
                    55.3791179
                ],
                [
                    76.8422229,
                    55.3775733
                ],
                [
                    76.8387599,
                    55.3763597
                ],
                [
                    76.8364297,
                    55.3752747
                ],
                [
                    76.8356206,
                    55.3747414
                ],
                [
                    76.834585,
                    55.3748702
                ],
                [
                    76.8340024,
                    55.3753115
                ],
                [
                    76.8321901,
                    55.3748885
                ],
                [
                    76.8313162,
                    55.3758632
                ],
                [
                    76.8295362,
                    55.3754954
                ],
                [
                    76.8297304,
                    55.3746495
                ],
                [
                    76.8291397,
                    55.3745903
                ],
                [
                    76.8285964,
                    55.3762096
                ]
            ],
            "longitude": 76.837418,
            "latitude": 55.377323
        },
        "9590": {
            "name": "Нефтепровод",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.853371,
            "latitude": 55.350601
        },
        "9591": {
            "name": "Маметкино",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    76.8533924,
                    55.2082148
                ],
                [
                    76.8538331,
                    55.2084802
                ],
                [
                    76.8544084,
                    55.208578
                ],
                [
                    76.8539064,
                    55.2092485
                ],
                [
                    76.8558282,
                    55.2095697
                ],
                [
                    76.8559628,
                    55.2097373
                ],
                [
                    76.8573214,
                    55.2101144
                ],
                [
                    76.8586556,
                    55.2099259
                ],
                [
                    76.8587902,
                    55.209437
                ],
                [
                    76.8584353,
                    55.2093392
                ],
                [
                    76.8576152,
                    55.2088923
                ],
                [
                    76.856942,
                    55.2092066
                ],
                [
                    76.8565871,
                    55.2090739
                ],
                [
                    76.8548857,
                    55.2087177
                ],
                [
                    76.8557543,
                    55.2078779
                ],
                [
                    76.8562933,
                    55.2082079
                ],
                [
                    76.8569909,
                    55.2082358
                ],
                [
                    76.8574682,
                    55.2077958
                ],
                [
                    76.8565503,
                    55.2074256
                ],
                [
                    76.8571134,
                    55.2072371
                ],
                [
                    76.8579457,
                    55.2074117
                ],
                [
                    76.8598429,
                    55.2072161
                ],
                [
                    76.8599041,
                    55.2069367
                ],
                [
                    76.8560975,
                    55.2061196
                ],
                [
                    76.8543594,
                    55.2079983
                ],
                [
                    76.8535148,
                    55.2078517
                ],
                [
                    76.8533924,
                    55.2082148
                ]
            ],
            "longitude": 76.856606,
            "latitude": 55.207874
        },
        "9592": {
            "name": "Старый Майзас",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    76.8535069,
                    56.5960259
                ],
                [
                    76.8542108,
                    56.5967304
                ],
                [
                    76.8554264,
                    56.5966364
                ],
                [
                    76.8564929,
                    56.5956736
                ],
                [
                    76.8582844,
                    56.595885
                ],
                [
                    76.8592442,
                    56.5953683
                ],
                [
                    76.8600333,
                    56.5936539
                ],
                [
                    76.8626993,
                    56.5941706
                ],
                [
                    76.8630192,
                    56.5932547
                ],
                [
                    76.8621021,
                    56.5931373
                ],
                [
                    76.8633818,
                    56.5898022
                ],
                [
                    76.8614836,
                    56.5895556
                ],
                [
                    76.8620595,
                    56.5880641
                ],
                [
                    76.8590521,
                    56.5877117
                ],
                [
                    76.8573034,
                    56.5881933
                ],
                [
                    76.8563649,
                    56.5895556
                ],
                [
                    76.8548507,
                    56.5908474
                ],
                [
                    76.8554052,
                    56.5912349
                ],
                [
                    76.8567062,
                    56.5918808
                ],
                [
                    76.8566422,
                    56.5928085
                ],
                [
                    76.8550426,
                    56.5933604
                ],
                [
                    76.8552985,
                    56.5951217
                ],
                [
                    76.8535069,
                    56.5960259
                ]
            ],
            "longitude": 76.859398,
            "latitude": 56.592129
        },
        "9593": {
            "name": "Камышинка",
            "population": 193,
            "type": "hamlet",
            "poly": [
                [
                    76.8539625,
                    56.7220114
                ],
                [
                    76.8556099,
                    56.7256758
                ],
                [
                    76.8587266,
                    56.7260667
                ],
                [
                    76.8607748,
                    56.7293155
                ],
                [
                    76.8614426,
                    56.733199
                ],
                [
                    76.8571683,
                    56.7331746
                ],
                [
                    76.8566785,
                    56.7346156
                ],
                [
                    76.8601069,
                    56.7364961
                ],
                [
                    76.8638914,
                    56.7365205
                ],
                [
                    76.8657615,
                    56.7353971
                ],
                [
                    76.8668301,
                    56.7332723
                ],
                [
                    76.8681658,
                    56.729975
                ],
                [
                    76.864782,
                    56.7263598
                ],
                [
                    76.8660287,
                    56.7259446
                ],
                [
                    76.8628674,
                    56.7182
                ],
                [
                    76.861309,
                    56.7176381
                ],
                [
                    76.8581478,
                    56.7178335
                ],
                [
                    76.8574354,
                    56.7166607
                ],
                [
                    76.8552981,
                    56.7169295
                ],
                [
                    76.8558325,
                    56.7184444
                ],
                [
                    76.8584595,
                    56.7206188
                ],
                [
                    76.8539625,
                    56.7220114
                ]
            ],
            "longitude": 76.861397,
            "latitude": 56.726513
        },
        "9594": {
            "name": "Бочкаревка",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    76.8503534,
                    56.9325494
                ],
                [
                    76.8585263,
                    56.9350792
                ],
                [
                    76.8576619,
                    56.933214
                ],
                [
                    76.8587621,
                    56.9325065
                ],
                [
                    76.8593908,
                    56.933064
                ],
                [
                    76.8588407,
                    56.933943
                ],
                [
                    76.8597051,
                    56.9352507
                ],
                [
                    76.8615912,
                    56.9361725
                ],
                [
                    76.8595873,
                    56.9370943
                ],
                [
                    76.8596266,
                    56.9377588
                ],
                [
                    76.8619841,
                    56.9384876
                ],
                [
                    76.8656384,
                    56.9360653
                ],
                [
                    76.8685854,
                    56.9378231
                ],
                [
                    76.8696856,
                    56.9370514
                ],
                [
                    76.8744008,
                    56.9397952
                ],
                [
                    76.8773477,
                    56.9391307
                ],
                [
                    76.8759332,
                    56.9365584
                ],
                [
                    76.8698821,
                    56.9325065
                ],
                [
                    76.8672101,
                    56.9317562
                ],
                [
                    76.8627307,
                    56.929119
                ],
                [
                    76.8599802,
                    56.9278539
                ],
                [
                    76.857544,
                    56.9271892
                ],
                [
                    76.8562866,
                    56.9280683
                ],
                [
                    76.8566622,
                    56.9285546
                ],
                [
                    76.8559723,
                    56.9295692
                ],
                [
                    76.8591943,
                    56.9315632
                ],
                [
                    76.8578191,
                    56.9318848
                ],
                [
                    76.8546756,
                    56.9301481
                ],
                [
                    76.8503534,
                    56.9325494
                ]
            ],
            "longitude": 76.865082,
            "latitude": 56.933842
        },
        "9595": {
            "name": "Юрки",
            "population": 248,
            "type": "hamlet",
            "poly": [
                [
                    76.862082,
                    55.0558221
                ],
                [
                    76.8635255,
                    55.0563525
                ],
                [
                    76.8632803,
                    55.0567737
                ],
                [
                    76.8645605,
                    55.0571169
                ],
                [
                    76.8647512,
                    55.0567581
                ],
                [
                    76.8676927,
                    55.0576473
                ],
                [
                    76.8673387,
                    55.0597064
                ],
                [
                    76.8666577,
                    55.0602212
                ],
                [
                    76.8677744,
                    55.0607204
                ],
                [
                    76.8673387,
                    55.0611259
                ],
                [
                    76.8688094,
                    55.0619526
                ],
                [
                    76.8706615,
                    55.0609544
                ],
                [
                    76.8726498,
                    55.0582869
                ],
                [
                    76.8761089,
                    55.0596441
                ],
                [
                    76.8788053,
                    55.0573821
                ],
                [
                    76.8777158,
                    55.0569609
                ],
                [
                    76.8773618,
                    55.0561653
                ],
                [
                    76.8743384,
                    55.0552605
                ],
                [
                    76.8746653,
                    55.0551045
                ],
                [
                    76.8734124,
                    55.054262
                ],
                [
                    76.8722685,
                    55.0547768
                ],
                [
                    76.8712606,
                    55.0554789
                ],
                [
                    76.8688367,
                    55.0548704
                ],
                [
                    76.8674204,
                    55.0551045
                ],
                [
                    76.8639613,
                    55.0542464
                ],
                [
                    76.8633349,
                    55.0548392
                ],
                [
                    76.8629263,
                    55.0546832
                ],
                [
                    76.862082,
                    55.0558221
                ]
            ],
            "longitude": 76.871216,
            "latitude": 55.056797
        },
        "9596": {
            "name": "Ивановка",
            "population": 154,
            "type": "hamlet",
            "poly": [
                [
                    76.8653163,
                    56.7172227
                ],
                [
                    76.8688782,
                    56.7218893
                ],
                [
                    76.8704366,
                    56.7231352
                ],
                [
                    76.8681213,
                    56.7240147
                ],
                [
                    76.8699023,
                    56.7267018
                ],
                [
                    76.8718169,
                    56.7291934
                ],
                [
                    76.8734197,
                    56.7296819
                ],
                [
                    76.876492,
                    56.7300483
                ],
                [
                    76.8797868,
                    56.7295353
                ],
                [
                    76.8759131,
                    56.7243811
                ],
                [
                    76.8776051,
                    56.7238437
                ],
                [
                    76.8759577,
                    56.7206433
                ],
                [
                    76.8726628,
                    56.7184688
                ],
                [
                    76.870214,
                    56.716734
                ],
                [
                    76.8723957,
                    56.7156833
                ],
                [
                    76.8707928,
                    56.7143882
                ],
                [
                    76.8670973,
                    56.7143394
                ],
                [
                    76.8655834,
                    56.7152679
                ],
                [
                    76.8653163,
                    56.7172227
                ]
            ],
            "longitude": 76.874252,
            "latitude": 56.72411
        },
        "9597": {
            "name": "Шмаковка",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    76.8670332,
                    56.5548664
                ],
                [
                    76.8688036,
                    56.5564312
                ],
                [
                    76.8705405,
                    56.556689
                ],
                [
                    76.8722775,
                    56.5586034
                ],
                [
                    76.8738474,
                    56.5594318
                ],
                [
                    76.8737082,
                    56.5608987
                ],
                [
                    76.8741815,
                    56.5625794
                ],
                [
                    76.8756846,
                    56.5634628
                ],
                [
                    76.8767201,
                    56.5639966
                ],
                [
                    76.8790249,
                    56.5637757
                ],
                [
                    76.8818976,
                    56.5630211
                ],
                [
                    76.8821648,
                    56.5599472
                ],
                [
                    76.8801941,
                    56.5559158
                ],
                [
                    76.8764195,
                    56.5527677
                ],
                [
                    76.8713088,
                    56.5530254
                ],
                [
                    76.8670332,
                    56.5548664
                ]
            ],
            "longitude": 76.876694,
            "latitude": 56.556568
        },
        "9598": {
            "name": "Тайский",
            "population": 193,
            "type": "hamlet",
            "poly": [
                [
                    76.8790298,
                    55.4637757
                ],
                [
                    76.8805507,
                    55.4639992
                ],
                [
                    76.8806126,
                    55.4654038
                ],
                [
                    76.8806634,
                    55.4665539
                ],
                [
                    76.8847755,
                    55.4662027
                ],
                [
                    76.8887749,
                    55.4655002
                ],
                [
                    76.8926617,
                    55.4642228
                ],
                [
                    76.8926053,
                    55.4634883
                ],
                [
                    76.8909154,
                    55.4624025
                ],
                [
                    76.8876483,
                    55.4628176
                ],
                [
                    76.8859021,
                    55.4631689
                ],
                [
                    76.8858457,
                    55.4635841
                ],
                [
                    76.88179,
                    55.4640312
                ],
                [
                    76.881452,
                    55.462147
                ],
                [
                    76.8801564,
                    55.4624344
                ],
                [
                    76.8790298,
                    55.4637757
                ]
            ],
            "longitude": 76.884995,
            "latitude": 55.464783
        },
        "9599": {
            "name": "Чебаклы",
            "population": 93,
            "type": "hamlet",
            "poly": [
                [
                    76.902075,
                    54.6448068
                ],
                [
                    76.9045183,
                    54.6460419
                ],
                [
                    76.9026085,
                    54.6472606
                ],
                [
                    76.9100227,
                    54.6510953
                ],
                [
                    76.9111461,
                    54.6507866
                ],
                [
                    76.9135894,
                    54.6486093
                ],
                [
                    76.9122133,
                    54.6469194
                ],
                [
                    76.9051923,
                    54.6431005
                ],
                [
                    76.902075,
                    54.6448068
                ]
            ],
            "longitude": 76.90873,
            "latitude": 54.647518
        },
        "9600": {
            "name": "Орлово",
            "population": 170,
            "type": "hamlet",
            "poly": [
                [
                    76.9140991,
                    55.7744398
                ],
                [
                    76.9142187,
                    55.7759223
                ],
                [
                    76.9145627,
                    55.7807237
                ],
                [
                    76.9153415,
                    55.7813725
                ],
                [
                    76.9153415,
                    55.7820704
                ],
                [
                    76.9159177,
                    55.7834577
                ],
                [
                    76.9183348,
                    55.7853122
                ],
                [
                    76.9197351,
                    55.7851677
                ],
                [
                    76.9199054,
                    55.7854051
                ],
                [
                    76.9214297,
                    55.785526
                ],
                [
                    76.9215268,
                    55.783876
                ],
                [
                    76.9197975,
                    55.7834133
                ],
                [
                    76.9191998,
                    55.7831069
                ],
                [
                    76.9185924,
                    55.7827917
                ],
                [
                    76.9182868,
                    55.782413
                ],
                [
                    76.9180759,
                    55.781798
                ],
                [
                    76.9181746,
                    55.7809285
                ],
                [
                    76.9186579,
                    55.7802126
                ],
                [
                    76.9192592,
                    55.7792531
                ],
                [
                    76.9206599,
                    55.7779163
                ],
                [
                    76.9211508,
                    55.7770775
                ],
                [
                    76.9211213,
                    55.7762798
                ],
                [
                    76.9207042,
                    55.77554
                ],
                [
                    76.9188723,
                    55.7729559
                ],
                [
                    76.9177939,
                    55.7727814
                ],
                [
                    76.9151258,
                    55.7727466
                ],
                [
                    76.9143528,
                    55.7732049
                ],
                [
                    76.9140991,
                    55.7744398
                ]
            ],
            "longitude": 76.916153,
            "latitude": 55.776997
        },
        "9601": {
            "name": "Васильевка",
            "population": 126,
            "type": "hamlet",
            "poly": [
                [
                    76.9164454,
                    54.038227
                ],
                [
                    76.9202679,
                    54.0411909
                ],
                [
                    76.9318841,
                    54.0449608
                ],
                [
                    76.9330716,
                    54.0439367
                ],
                [
                    76.9340737,
                    54.0443289
                ],
                [
                    76.9326263,
                    54.0460285
                ],
                [
                    76.9429064,
                    54.0475538
                ],
                [
                    76.9417188,
                    54.0491662
                ],
                [
                    76.9435744,
                    54.0496455
                ],
                [
                    76.9451702,
                    54.0479024
                ],
                [
                    76.944094,
                    54.0474013
                ],
                [
                    76.9450589,
                    54.0458978
                ],
                [
                    76.9352983,
                    54.0421716
                ],
                [
                    76.9364487,
                    54.0409294
                ],
                [
                    76.9237936,
                    54.0346527
                ],
                [
                    76.9201937,
                    54.0323641
                ],
                [
                    76.9181897,
                    54.033018
                ],
                [
                    76.9197113,
                    54.035045
                ],
                [
                    76.9226431,
                    54.0361784
                ],
                [
                    76.9233111,
                    54.0370284
                ],
                [
                    76.921604,
                    54.0375514
                ],
                [
                    76.9193772,
                    54.0363963
                ],
                [
                    76.9172248,
                    54.0374425
                ],
                [
                    76.9164454,
                    54.038227
                ]
            ],
            "longitude": 76.924164,
            "latitude": 54.039989
        },
        "9602": {
            "name": "Кирзавод",
            "population": 175,
            "type": "hamlet",
            "poly": [
                [
                    76.9231796,
                    55.3417037
                ],
                [
                    76.924091,
                    55.3422455
                ],
                [
                    76.9245259,
                    55.3424339
                ],
                [
                    76.9259965,
                    55.3422808
                ],
                [
                    76.9263901,
                    55.3426342
                ],
                [
                    76.9277364,
                    55.34307
                ],
                [
                    76.9290828,
                    55.3425753
                ],
                [
                    76.9294763,
                    55.3427873
                ],
                [
                    76.9294142,
                    55.3430111
                ],
                [
                    76.9306776,
                    55.3439063
                ],
                [
                    76.9311747,
                    55.3438003
                ],
                [
                    76.9336603,
                    55.3445423
                ],
                [
                    76.9346752,
                    55.3448956
                ],
                [
                    76.9355452,
                    55.3449781
                ],
                [
                    76.9380307,
                    55.3429993
                ],
                [
                    76.9372851,
                    55.3428109
                ],
                [
                    76.9373248,
                    55.3425076
                ],
                [
                    76.9369536,
                    55.3421984
                ],
                [
                    76.935918,
                    55.3419864
                ],
                [
                    76.9360837,
                    55.3416683
                ],
                [
                    76.9302426,
                    55.3398307
                ],
                [
                    76.9283992,
                    55.3393949
                ],
                [
                    76.9277986,
                    55.3393949
                ],
                [
                    76.9274879,
                    55.3396541
                ],
                [
                    76.9252716,
                    55.3393713
                ],
                [
                    76.9245259,
                    55.3404315
                ],
                [
                    76.9250023,
                    55.3405729
                ],
                [
                    76.9242981,
                    55.341421
                ],
                [
                    76.9236353,
                    55.3412796
                ],
                [
                    76.9231796,
                    55.3417037
                ]
            ],
            "longitude": 76.930824,
            "latitude": 55.342072
        },
        "9603": {
            "name": "Беспаловка",
            "population": 48,
            "type": "hamlet",
            "poly": [
                [
                    76.9251323,
                    56.7799499
                ],
                [
                    76.9259773,
                    56.7818763
                ],
                [
                    76.9286214,
                    56.782175
                ],
                [
                    76.9284033,
                    56.7800545
                ],
                [
                    76.9312655,
                    56.7804577
                ],
                [
                    76.9323285,
                    56.780398
                ],
                [
                    76.9326556,
                    56.7798454
                ],
                [
                    76.9339913,
                    56.7802934
                ],
                [
                    76.935436,
                    56.7817121
                ],
                [
                    76.9347545,
                    56.7822945
                ],
                [
                    76.9353815,
                    56.7827872
                ],
                [
                    76.9391159,
                    56.7816523
                ],
                [
                    76.9398518,
                    56.7807116
                ],
                [
                    76.9367444,
                    56.7794123
                ],
                [
                    76.9388704,
                    56.7790838
                ],
                [
                    76.9374258,
                    56.7777696
                ],
                [
                    76.935654,
                    56.7771124
                ],
                [
                    76.9320287,
                    56.7763209
                ],
                [
                    76.9319742,
                    56.7778592
                ],
                [
                    76.9292756,
                    56.7777248
                ],
                [
                    76.9277491,
                    56.7784715
                ],
                [
                    76.9251323,
                    56.7799499
                ]
            ],
            "longitude": 76.933937,
            "latitude": 56.779259
        },
        "9604": {
            "name": "Орловка",
            "population": 223,
            "type": "hamlet",
            "poly": [
                [
                    76.9204597,
                    54.3122221
                ],
                [
                    76.9293961,
                    54.3150952
                ],
                [
                    76.9306654,
                    54.3142363
                ],
                [
                    76.9315285,
                    54.3146361
                ],
                [
                    76.931224,
                    54.315421
                ],
                [
                    76.9321379,
                    54.3161466
                ],
                [
                    76.9393733,
                    54.3177015
                ],
                [
                    76.9427499,
                    54.3176867
                ],
                [
                    76.9444508,
                    54.3149175
                ],
                [
                    76.9410489,
                    54.3137031
                ],
                [
                    76.9416327,
                    54.3120444
                ],
                [
                    76.9387385,
                    54.3110817
                ],
                [
                    76.9335596,
                    54.3105337
                ],
                [
                    76.9320618,
                    54.3111706
                ],
                [
                    76.9227192,
                    54.3088749
                ],
                [
                    76.9220591,
                    54.309334
                ],
                [
                    76.9210436,
                    54.3109781
                ],
                [
                    76.9204597,
                    54.3122221
                ]
            ],
            "longitude": 76.934868,
            "latitude": 54.312923
        },
        "9605": {
            "name": "Бурсянино",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    76.9500378,
                    55.8757749
                ],
                [
                    76.9515749,
                    55.8757749
                ],
                [
                    76.9519255,
                    55.8765616
                ],
                [
                    76.9514131,
                    55.8766826
                ],
                [
                    76.9514671,
                    55.8784072
                ],
                [
                    76.9516558,
                    55.880162
                ],
                [
                    76.9509007,
                    55.8802981
                ],
                [
                    76.9505232,
                    55.8805856
                ],
                [
                    76.9506041,
                    55.8814478
                ],
                [
                    76.9517907,
                    55.8833235
                ],
                [
                    76.9525458,
                    55.8836411
                ],
                [
                    76.9530043,
                    55.8853049
                ],
                [
                    76.9533818,
                    55.8861065
                ],
                [
                    76.9550539,
                    55.8859704
                ],
                [
                    76.9557281,
                    55.8862729
                ],
                [
                    76.9561056,
                    55.8860612
                ],
                [
                    76.9573462,
                    55.8865754
                ],
                [
                    76.9600698,
                    55.8847755
                ],
                [
                    76.9572922,
                    55.8833083
                ],
                [
                    76.9559168,
                    55.8827638
                ],
                [
                    76.9547302,
                    55.8820831
                ],
                [
                    76.9537594,
                    55.881115
                ],
                [
                    76.95322,
                    55.8802074
                ],
                [
                    76.9531661,
                    55.8786493
                ],
                [
                    76.9537594,
                    55.8773482
                ],
                [
                    76.9533279,
                    55.8770457
                ],
                [
                    76.9530582,
                    55.8762741
                ],
                [
                    76.9544875,
                    55.8760018
                ],
                [
                    76.9541639,
                    55.8748974
                ],
                [
                    76.9519794,
                    55.8752756
                ],
                [
                    76.9500917,
                    55.8753513
                ],
                [
                    76.9500378,
                    55.8757749
                ]
            ],
            "longitude": 76.954742,
            "latitude": 55.883488
        },
        "9606": {
            "name": "Красноярка",
            "population": 258,
            "type": "hamlet",
            "poly": [
                [
                    76.9485871,
                    55.7536655
                ],
                [
                    76.9494,
                    55.7543557
                ],
                [
                    76.9505838,
                    55.7548453
                ],
                [
                    76.9499419,
                    55.7556157
                ],
                [
                    76.9509974,
                    55.7562096
                ],
                [
                    76.9503698,
                    55.756964
                ],
                [
                    76.9509118,
                    55.7571647
                ],
                [
                    76.950213,
                    55.7580474
                ],
                [
                    76.9515821,
                    55.7584326
                ],
                [
                    76.952609,
                    55.7571807
                ],
                [
                    76.9536358,
                    55.7574696
                ],
                [
                    76.9544916,
                    55.7565066
                ],
                [
                    76.9551761,
                    55.7565066
                ],
                [
                    76.9558607,
                    55.7561535
                ],
                [
                    76.9562601,
                    55.7564103
                ],
                [
                    76.9569446,
                    55.7561214
                ],
                [
                    76.9566308,
                    55.7557843
                ],
                [
                    76.9570302,
                    55.7556077
                ],
                [
                    76.9594833,
                    55.7570844
                ],
                [
                    76.9611377,
                    55.7562819
                ],
                [
                    76.9622216,
                    55.7568918
                ],
                [
                    76.9635907,
                    55.7560893
                ],
                [
                    76.9625353,
                    55.7555917
                ],
                [
                    76.9630203,
                    55.7552867
                ],
                [
                    76.9623642,
                    55.7549015
                ],
                [
                    76.963876,
                    55.7539223
                ],
                [
                    76.9617652,
                    55.7527345
                ],
                [
                    76.9622216,
                    55.7524776
                ],
                [
                    76.9629632,
                    55.7523974
                ],
                [
                    76.9646461,
                    55.7511452
                ],
                [
                    76.9643324,
                    55.7490583
                ],
                [
                    76.9622786,
                    55.7470997
                ],
                [
                    76.9612518,
                    55.7466662
                ],
                [
                    76.9579715,
                    55.7479506
                ],
                [
                    76.9576577,
                    55.7483038
                ],
                [
                    76.9587416,
                    55.7495239
                ],
                [
                    76.9592836,
                    55.7494757
                ],
                [
                    76.95974,
                    55.749877
                ],
                [
                    76.9587131,
                    55.7510329
                ],
                [
                    76.9569446,
                    55.752895
                ],
                [
                    76.9540352,
                    55.7537136
                ],
                [
                    76.9534362,
                    55.7540507
                ],
                [
                    76.952067,
                    55.7535371
                ],
                [
                    76.9512683,
                    55.7535852
                ],
                [
                    76.9507834,
                    55.7533444
                ],
                [
                    76.9508975,
                    55.7531438
                ],
                [
                    76.9504839,
                    55.7529913
                ],
                [
                    76.9501131,
                    55.7532321
                ],
                [
                    76.9495141,
                    55.7529833
                ],
                [
                    76.9485871,
                    55.7536655
                ]
            ],
            "longitude": 76.959137,
            "latitude": 55.7533
        },
        "9607": {
            "name": "Черниговка",
            "population": 224,
            "type": "hamlet",
            "poly": [
                [
                    76.9460761,
                    55.0330448
                ],
                [
                    76.9469954,
                    55.033318
                ],
                [
                    76.9493786,
                    55.0332594
                ],
                [
                    76.9512852,
                    55.0331228
                ],
                [
                    76.9523406,
                    55.032596
                ],
                [
                    76.9547238,
                    55.0337862
                ],
                [
                    76.9523066,
                    55.0364007
                ],
                [
                    76.956324,
                    55.0387418
                ],
                [
                    76.9645971,
                    55.0395417
                ],
                [
                    76.9653802,
                    55.0386053
                ],
                [
                    76.963814,
                    55.0381956
                ],
                [
                    76.9658568,
                    55.0349374
                ],
                [
                    76.9648014,
                    55.0339618
                ],
                [
                    76.9633374,
                    55.0335716
                ],
                [
                    76.9646312,
                    55.0320302
                ],
                [
                    76.9632012,
                    55.0311521
                ],
                [
                    76.9641205,
                    55.0299618
                ],
                [
                    76.965278,
                    55.0299813
                ],
                [
                    76.9658228,
                    55.0292398
                ],
                [
                    76.958605,
                    55.0287325
                ],
                [
                    76.9568687,
                    55.0284397
                ],
                [
                    76.9546557,
                    55.0282251
                ],
                [
                    76.9524768,
                    55.0274445
                ],
                [
                    76.9517958,
                    55.0278543
                ],
                [
                    76.9519661,
                    55.0283422
                ],
                [
                    76.9531917,
                    55.0292008
                ],
                [
                    76.9528172,
                    55.0300594
                ],
                [
                    76.9516937,
                    55.0302155
                ],
                [
                    76.9509107,
                    55.0299618
                ],
                [
                    76.951149,
                    55.0296886
                ],
                [
                    76.9495488,
                    55.0289276
                ],
                [
                    76.9478465,
                    55.0285178
                ],
                [
                    76.9465188,
                    55.0304496
                ],
                [
                    76.9461102,
                    55.0314838
                ],
                [
                    76.9460761,
                    55.0330448
                ]
            ],
            "longitude": 76.959396,
            "latitude": 55.032192
        },
        "9608": {
            "name": "Козловка",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 76.969604,
            "latitude": 55.608578
        },
        "9609": {
            "name": "Ночка",
            "population": 185,
            "type": "hamlet",
            "poly": [
                [
                    76.9632263,
                    55.8133789
                ],
                [
                    76.9677253,
                    55.8163538
                ],
                [
                    76.9707246,
                    55.8164398
                ],
                [
                    76.9709695,
                    55.8155112
                ],
                [
                    76.97403,
                    55.8154596
                ],
                [
                    76.9738464,
                    55.8167321
                ],
                [
                    76.9753154,
                    55.8168353
                ],
                [
                    76.9753154,
                    55.816457
                ],
                [
                    76.9769375,
                    55.8165086
                ],
                [
                    76.9769069,
                    55.8169556
                ],
                [
                    76.9791411,
                    55.8172652
                ],
                [
                    76.9814365,
                    55.817248
                ],
                [
                    76.9824771,
                    55.8177122
                ],
                [
                    76.9836401,
                    55.8179186
                ],
                [
                    76.9864252,
                    55.8180045
                ],
                [
                    76.9883839,
                    55.8176091
                ],
                [
                    76.9884452,
                    55.8166977
                ],
                [
                    76.9871291,
                    55.8164645
                ],
                [
                    76.986112,
                    55.8161606
                ],
                [
                    76.9854411,
                    55.8157593
                ],
                [
                    76.984965,
                    55.815352
                ],
                [
                    76.9846079,
                    55.814671
                ],
                [
                    76.9810587,
                    55.8146163
                ],
                [
                    76.9806476,
                    55.815127
                ],
                [
                    76.9796304,
                    55.8155952
                ],
                [
                    76.9793112,
                    55.815662
                ],
                [
                    76.9781749,
                    55.8156347
                ],
                [
                    76.9773202,
                    55.8152243
                ],
                [
                    76.9765141,
                    55.8146832
                ],
                [
                    76.9762381,
                    55.8146467
                ],
                [
                    76.9759167,
                    55.8135503
                ],
                [
                    76.9757436,
                    55.8127599
                ],
                [
                    76.9769338,
                    55.8103704
                ],
                [
                    76.9755272,
                    55.8079624
                ],
                [
                    76.9705929,
                    55.8087347
                ],
                [
                    76.9704739,
                    55.8105893
                ],
                [
                    76.9712723,
                    55.8131471
                ],
                [
                    76.9707731,
                    55.8141675
                ],
                [
                    76.9702683,
                    55.814742
                ],
                [
                    76.9671628,
                    55.81231
                ],
                [
                    76.9632263,
                    55.8133789
                ]
            ],
            "longitude": 76.974533,
            "latitude": 55.814159
        },
        "9610": {
            "name": "Блюдцы",
            "population": 148,
            "type": "hamlet",
            "poly": [
                [
                    76.9861065,
                    54.9476914
                ],
                [
                    76.9879234,
                    54.9481088
                ],
                [
                    76.9886958,
                    54.9479522
                ],
                [
                    76.9882415,
                    54.9487088
                ],
                [
                    76.9952823,
                    54.9507436
                ],
                [
                    76.9970995,
                    54.9498306
                ],
                [
                    77.0019146,
                    54.9500132
                ],
                [
                    77.0023688,
                    54.9493349
                ],
                [
                    77.0047309,
                    54.9493088
                ],
                [
                    77.0047764,
                    54.9485262
                ],
                [
                    77.0040041,
                    54.948474
                ],
                [
                    77.0036861,
                    54.9488653
                ],
                [
                    77.0015966,
                    54.948761
                ],
                [
                    77.0014603,
                    54.948187
                ],
                [
                    77.0003701,
                    54.9482392
                ],
                [
                    77.0004155,
                    54.9476653
                ],
                [
                    77.0009152,
                    54.9476653
                ],
                [
                    77.001006,
                    54.9455259
                ],
                [
                    76.9967815,
                    54.9450041
                ],
                [
                    76.9939197,
                    54.9439083
                ],
                [
                    76.9915575,
                    54.9430473
                ],
                [
                    76.9903311,
                    54.9432821
                ],
                [
                    76.9901039,
                    54.9438561
                ],
                [
                    76.9867879,
                    54.9451607
                ],
                [
                    76.9861762,
                    54.9456752
                ],
                [
                    76.9861065,
                    54.9476914
                ]
            ],
            "longitude": 76.994354,
            "latitude": 54.948029
        },
        "9611": {
            "name": "Григорьевка",
            "population": 108,
            "type": "hamlet",
            "poly": [
                [
                    76.9930377,
                    55.8458047
                ],
                [
                    76.9938282,
                    55.8465629
                ],
                [
                    76.9959033,
                    55.8464519
                ],
                [
                    76.997682,
                    55.8464234
                ],
                [
                    76.998824,
                    55.8466404
                ],
                [
                    76.9997802,
                    55.8470919
                ],
                [
                    77.0000005,
                    55.8478132
                ],
                [
                    76.99979,
                    55.8485045
                ],
                [
                    76.999405,
                    55.8489056
                ],
                [
                    76.9989336,
                    55.8496509
                ],
                [
                    76.9986701,
                    55.8510007
                ],
                [
                    76.9979783,
                    55.8514259
                ],
                [
                    76.9986372,
                    55.853127
                ],
                [
                    77.0012064,
                    55.8534598
                ],
                [
                    77.0033473,
                    55.8535892
                ],
                [
                    77.0037097,
                    55.853016
                ],
                [
                    77.0045294,
                    55.8510237
                ],
                [
                    77.0040565,
                    55.8495449
                ],
                [
                    77.0039537,
                    55.8483437
                ],
                [
                    77.0045856,
                    55.8478017
                ],
                [
                    77.0017663,
                    55.8453794
                ],
                [
                    76.9978137,
                    55.843567
                ],
                [
                    76.9962326,
                    55.8440479
                ],
                [
                    76.9958374,
                    55.8445657
                ],
                [
                    76.9961997,
                    55.8449355
                ],
                [
                    76.9948493,
                    55.844991
                ],
                [
                    76.9930377,
                    55.8458047
                ]
            ],
            "longitude": 77.001144,
            "latitude": 55.85043
        },
        "9612": {
            "name": "Бровничи",
            "population": 85,
            "type": "hamlet",
            "poly": [
                [
                    76.9939805,
                    55.919553
                ],
                [
                    76.9943127,
                    55.9200805
                ],
                [
                    77.0000717,
                    55.9234936
                ],
                [
                    77.0005978,
                    55.9239745
                ],
                [
                    77.0007639,
                    55.9244709
                ],
                [
                    77.0007085,
                    55.9249984
                ],
                [
                    77.0004316,
                    55.9254327
                ],
                [
                    76.9994071,
                    55.9261773
                ],
                [
                    77.0028404,
                    55.9276819
                ],
                [
                    77.0034496,
                    55.9275889
                ],
                [
                    77.0042802,
                    55.9275734
                ],
                [
                    77.0074365,
                    55.9287212
                ],
                [
                    77.0087655,
                    55.9289694
                ],
                [
                    77.0096791,
                    55.9287832
                ],
                [
                    77.0122264,
                    55.9294347
                ],
                [
                    77.0129463,
                    55.929109
                ],
                [
                    77.0136108,
                    55.9281008
                ],
                [
                    77.0117835,
                    55.9275268
                ],
                [
                    77.0127802,
                    55.9265186
                ],
                [
                    77.0083779,
                    55.9227179
                ],
                [
                    77.0069381,
                    55.9220198
                ],
                [
                    77.0050001,
                    55.9219733
                ],
                [
                    77.0039479,
                    55.9213217
                ],
                [
                    77.0053877,
                    55.9203598
                ],
                [
                    77.0038649,
                    55.9195841
                ],
                [
                    76.9968323,
                    55.9185601
                ],
                [
                    76.9947004,
                    55.9191341
                ],
                [
                    76.9939805,
                    55.919553
                ]
            ],
            "longitude": 77.00341,
            "latitude": 55.92498
        },
        "9613": {
            "name": "Покровка",
            "population": 158,
            "type": "hamlet",
            "poly": [
                [
                    77.0001091,
                    54.4352754
                ],
                [
                    77.0071271,
                    54.4372516
                ],
                [
                    77.0096754,
                    54.4374516
                ],
                [
                    77.0099585,
                    54.4370516
                ],
                [
                    77.0149742,
                    54.4382161
                ],
                [
                    77.0146709,
                    54.4386513
                ],
                [
                    77.0199091,
                    54.4402745
                ],
                [
                    77.0243585,
                    54.4415682
                ],
                [
                    77.0283022,
                    54.4427326
                ],
                [
                    77.0296574,
                    54.4412742
                ],
                [
                    77.0292326,
                    54.4411919
                ],
                [
                    77.0297989,
                    54.4403215
                ],
                [
                    77.029354,
                    54.4401568
                ],
                [
                    77.0298798,
                    54.4395335
                ],
                [
                    77.0221742,
                    54.4371222
                ],
                [
                    77.0153181,
                    54.4352754
                ],
                [
                    77.0032237,
                    54.431711
                ],
                [
                    77.0011607,
                    54.432511
                ],
                [
                    77.0004529,
                    54.4339697
                ],
                [
                    77.0011203,
                    54.434052
                ],
                [
                    77.0001091,
                    54.4352754
                ]
            ],
            "longitude": 77.01355,
            "latitude": 54.436005
        },
        "9614": {
            "name": "Ольгино",
            "population": 48,
            "type": "hamlet",
            "poly": [
                [
                    77.0062401,
                    55.9690688
                ],
                [
                    77.0078796,
                    55.9698061
                ],
                [
                    77.006445,
                    55.9705269
                ],
                [
                    77.007821,
                    55.9712642
                ],
                [
                    77.0111586,
                    55.969888
                ],
                [
                    77.0101923,
                    55.9689377
                ],
                [
                    77.0109829,
                    55.9686428
                ],
                [
                    77.0127395,
                    55.9695931
                ],
                [
                    77.0136178,
                    55.9698224
                ],
                [
                    77.0144961,
                    55.9706253
                ],
                [
                    77.0145546,
                    55.971084
                ],
                [
                    77.0149352,
                    55.9713134
                ],
                [
                    77.0135885,
                    55.9720998
                ],
                [
                    77.0151109,
                    55.9726732
                ],
                [
                    77.0162819,
                    55.9719523
                ],
                [
                    77.0183606,
                    55.9720998
                ],
                [
                    77.020205,
                    55.9733776
                ],
                [
                    77.0227813,
                    55.9726076
                ],
                [
                    77.0207027,
                    55.9716574
                ],
                [
                    77.0213761,
                    55.9710676
                ],
                [
                    77.0196487,
                    55.9701501
                ],
                [
                    77.0188583,
                    55.9706744
                ],
                [
                    77.0171017,
                    55.9698061
                ],
                [
                    77.017453,
                    55.9694784
                ],
                [
                    77.0194438,
                    55.9685609
                ],
                [
                    77.0178921,
                    55.9674795
                ],
                [
                    77.0158428,
                    55.9683151
                ],
                [
                    77.013852,
                    55.9672992
                ],
                [
                    77.0126517,
                    55.9677908
                ],
                [
                    77.0118319,
                    55.9675286
                ],
                [
                    77.0104852,
                    55.968184
                ],
                [
                    77.0095191,
                    55.967545
                ],
                [
                    77.0090506,
                    55.9676925
                ],
                [
                    77.0082602,
                    55.9674795
                ],
                [
                    77.0081138,
                    55.9681676
                ],
                [
                    77.0062401,
                    55.9690688
                ]
            ],
            "longitude": 77.015923,
            "latitude": 55.971031
        },
        "9615": {
            "name": "Николаевка",
            "population": 106,
            "type": "hamlet",
            "poly": [
                [
                    77.0065216,
                    56.8144734
                ],
                [
                    77.0090257,
                    56.8150395
                ],
                [
                    77.0114208,
                    56.8138179
                ],
                [
                    77.0171363,
                    56.8127751
                ],
                [
                    77.0216544,
                    56.811762
                ],
                [
                    77.0262268,
                    56.8077988
                ],
                [
                    77.0278054,
                    56.8049677
                ],
                [
                    77.0250293,
                    56.8042227
                ],
                [
                    77.0213822,
                    56.8062492
                ],
                [
                    77.0166464,
                    56.8090802
                ],
                [
                    77.0156122,
                    56.8105403
                ],
                [
                    77.0102232,
                    56.8117322
                ],
                [
                    77.0069572,
                    56.81352
                ],
                [
                    77.0065216,
                    56.8144734
                ]
            ],
            "longitude": 77.019653,
            "latitude": 56.810169
        },
        "9616": {
            "name": "Федосьевка",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    77.0131597,
                    54.1746508
                ],
                [
                    77.0144663,
                    54.1750144
                ],
                [
                    77.0168867,
                    54.1750395
                ],
                [
                    77.0177864,
                    54.1757165
                ],
                [
                    77.0166083,
                    54.1802546
                ],
                [
                    77.0169938,
                    54.1809566
                ],
                [
                    77.0172937,
                    54.1818592
                ],
                [
                    77.0170795,
                    54.1825361
                ],
                [
                    77.0192527,
                    54.1827862
                ],
                [
                    77.0196926,
                    54.1828369
                ],
                [
                    77.0200997,
                    54.1820973
                ],
                [
                    77.0210636,
                    54.1821475
                ],
                [
                    77.0213849,
                    54.1812575
                ],
                [
                    77.0203566,
                    54.1809817
                ],
                [
                    77.0211063,
                    54.179327
                ],
                [
                    77.0224987,
                    54.17949
                ],
                [
                    77.0235483,
                    54.1792518
                ],
                [
                    77.0243622,
                    54.1765815
                ],
                [
                    77.0248548,
                    54.176055
                ],
                [
                    77.0262257,
                    54.1717546
                ],
                [
                    77.0257759,
                    54.1710775
                ],
                [
                    77.0241908,
                    54.1707265
                ],
                [
                    77.023741,
                    54.1714788
                ],
                [
                    77.0224987,
                    54.1715916
                ],
                [
                    77.0222845,
                    54.1724066
                ],
                [
                    77.0229057,
                    54.1729457
                ],
                [
                    77.0215562,
                    54.1736228
                ],
                [
                    77.0215776,
                    54.1728705
                ],
                [
                    77.0196285,
                    54.1725069
                ],
                [
                    77.016951,
                    54.1726323
                ],
                [
                    77.0151946,
                    54.1724944
                ],
                [
                    77.0137809,
                    54.1735977
                ],
                [
                    77.0135372,
                    54.1740108
                ],
                [
                    77.0131597,
                    54.1746508
                ]
            ],
            "longitude": 77.020546,
            "latitude": 54.176254
        },
        "9617": {
            "name": "Канавы",
            "population": 115,
            "type": "hamlet",
            "poly": [
                [
                    77.0134454,
                    54.6894088
                ],
                [
                    77.0306468,
                    54.6947652
                ],
                [
                    77.032051,
                    54.6939537
                ],
                [
                    77.0278735,
                    54.6920262
                ],
                [
                    77.028751,
                    54.6910929
                ],
                [
                    77.023345,
                    54.6880898
                ],
                [
                    77.0219759,
                    54.6890841
                ],
                [
                    77.0168857,
                    54.6871361
                ],
                [
                    77.0147794,
                    54.6882319
                ],
                [
                    77.0134454,
                    54.6894088
                ]
            ],
            "longitude": 77.023521,
            "latitude": 54.690323
        },
        "9618": {
            "name": "Козловка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.0192064,
                    56.790568
                ],
                [
                    77.0210353,
                    56.7911166
                ],
                [
                    77.0244756,
                    56.7911166
                ],
                [
                    77.0243885,
                    56.791856
                ],
                [
                    77.0288738,
                    56.7919514
                ],
                [
                    77.0289609,
                    56.7909973
                ],
                [
                    77.0361462,
                    56.7911882
                ],
                [
                    77.036364,
                    56.7922614
                ],
                [
                    77.037322,
                    56.7922614
                ],
                [
                    77.0398477,
                    56.7909019
                ],
                [
                    77.0377575,
                    56.7904488
                ],
                [
                    77.0333157,
                    56.7901626
                ],
                [
                    77.0308335,
                    56.7893278
                ],
                [
                    77.0284384,
                    56.7886122
                ],
                [
                    77.0305722,
                    56.7864416
                ],
                [
                    77.0290916,
                    56.7859168
                ],
                [
                    77.0270013,
                    56.7870141
                ],
                [
                    77.0243449,
                    56.7875389
                ],
                [
                    77.0230821,
                    56.7888269
                ],
                [
                    77.0197289,
                    56.7882783
                ],
                [
                    77.0192064,
                    56.790568
                ]
            ],
            "longitude": 77.025963,
            "latitude": 56.789669
        },
        "9619": {
            "name": "Спасск",
            "population": 74,
            "type": "hamlet",
            "poly": [
                [
                    77.0207925,
                    54.0859444
                ],
                [
                    77.0244225,
                    54.0860348
                ],
                [
                    77.0241981,
                    54.0868998
                ],
                [
                    77.0243976,
                    54.0869125
                ],
                [
                    77.029668,
                    54.0872492
                ],
                [
                    77.0297923,
                    54.0872571
                ],
                [
                    77.0299686,
                    54.0863168
                ],
                [
                    77.0330791,
                    54.0864945
                ],
                [
                    77.0349526,
                    54.0793986
                ],
                [
                    77.0373356,
                    54.0794971
                ],
                [
                    77.0380127,
                    54.0771674
                ],
                [
                    77.0354274,
                    54.0769257
                ],
                [
                    77.0358882,
                    54.0741875
                ],
                [
                    77.035713,
                    54.0741769
                ],
                [
                    77.033668,
                    54.0740535
                ],
                [
                    77.0297922,
                    54.0738196
                ],
                [
                    77.0293754,
                    54.0729637
                ],
                [
                    77.0299845,
                    54.0698598
                ],
                [
                    77.0266024,
                    54.0693519
                ],
                [
                    77.0235407,
                    54.069145
                ],
                [
                    77.0235407,
                    54.0692209
                ],
                [
                    77.0235407,
                    54.0720514
                ],
                [
                    77.0237293,
                    54.0732787
                ],
                [
                    77.0237439,
                    54.0739655
                ],
                [
                    77.023746,
                    54.0740652
                ],
                [
                    77.0237189,
                    54.0741743
                ],
                [
                    77.0207925,
                    54.0859444
                ]
            ],
            "longitude": 77.030457,
            "latitude": 54.078785
        },
        "9620": {
            "name": "Алексеевка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.034743,
                    56.581358
                ],
                [
                    77.0367471,
                    56.5827856
                ],
                [
                    77.0358386,
                    56.5838157
                ],
                [
                    77.0390453,
                    56.5851255
                ],
                [
                    77.0405685,
                    56.5843897
                ],
                [
                    77.0419581,
                    56.5832565
                ],
                [
                    77.0428087,
                    56.5830732
                ],
                [
                    77.043802,
                    56.5828592
                ],
                [
                    77.046688,
                    56.5846693
                ],
                [
                    77.0473828,
                    56.5855228
                ],
                [
                    77.0491732,
                    56.5862586
                ],
                [
                    77.0497077,
                    56.586288
                ],
                [
                    77.0542238,
                    56.5845957
                ],
                [
                    77.0474897,
                    56.5805338
                ],
                [
                    77.0430003,
                    56.5781053
                ],
                [
                    77.0406487,
                    56.5775901
                ],
                [
                    77.0371213,
                    56.5777226
                ],
                [
                    77.035518,
                    56.5789148
                ],
                [
                    77.0377627,
                    56.5800775
                ],
                [
                    77.0392324,
                    56.5792239
                ],
                [
                    77.0413702,
                    56.5804749
                ],
                [
                    77.0397401,
                    56.5812697
                ],
                [
                    77.035999,
                    56.5807546
                ],
                [
                    77.034743,
                    56.581358
                ]
            ],
            "longitude": 77.044189,
            "latitude": 56.581299
        },
        "9621": {
            "name": "Петропавловка",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    77.0548793,
                    53.91809
                ],
                [
                    77.0635552,
                    53.9193881
                ],
                [
                    77.0686395,
                    53.9087224
                ],
                [
                    77.0697916,
                    53.905742
                ],
                [
                    77.0625784,
                    53.9046058
                ],
                [
                    77.0618922,
                    53.9063823
                ],
                [
                    77.0587063,
                    53.9089201
                ],
                [
                    77.0548793,
                    53.91809
                ]
            ],
            "longitude": 77.06356,
            "latitude": 53.910324
        },
        "9622": {
            "name": "Аникино",
            "population": 35,
            "type": "hamlet",
            "poly": [
                [
                    77.0749854,
                    56.8045863
                ],
                [
                    77.0783059,
                    56.806434
                ],
                [
                    77.083205,
                    56.8086988
                ],
                [
                    77.0850557,
                    56.8084306
                ],
                [
                    77.0867976,
                    56.807179
                ],
                [
                    77.0869608,
                    56.8061359
                ],
                [
                    77.0889205,
                    56.8038412
                ],
                [
                    77.0924588,
                    56.8014867
                ],
                [
                    77.0864779,
                    56.7990653
                ],
                [
                    77.0843481,
                    56.8010396
                ],
                [
                    77.0821163,
                    56.802053
                ],
                [
                    77.0789047,
                    56.8030365
                ],
                [
                    77.0759652,
                    56.8036326
                ],
                [
                    77.0749854,
                    56.8045863
                ]
            ],
            "longitude": 77.083511,
            "latitude": 56.805183
        },
        "9623": {
            "name": "Георгиевка",
            "population": 116,
            "type": "hamlet",
            "poly": [
                [
                    77.0874278,
                    56.0055723
                ],
                [
                    77.0957403,
                    56.014773
                ],
                [
                    77.1000009,
                    56.0151699
                ],
                [
                    77.0951661,
                    56.0084689
                ],
                [
                    77.09738,
                    56.0078851
                ],
                [
                    77.0908219,
                    56.0016259
                ],
                [
                    77.0878561,
                    56.0022565
                ],
                [
                    77.0874278,
                    56.0055723
                ]
            ],
            "longitude": 77.092056,
            "latitude": 56.006912
        },
        "9624": {
            "name": "Бишбуга",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.0959198,
                    55.2308832
                ],
                [
                    77.0980667,
                    55.2316455
                ],
                [
                    77.0992212,
                    55.2321768
                ],
                [
                    77.1001326,
                    55.232939
                ],
                [
                    77.1008009,
                    55.2340247
                ],
                [
                    77.1014895,
                    55.2344404
                ],
                [
                    77.1033934,
                    55.234094
                ],
                [
                    77.1057226,
                    55.2337937
                ],
                [
                    77.1067757,
                    55.2340709
                ],
                [
                    77.1072213,
                    55.2345097
                ],
                [
                    77.1117581,
                    55.2293354
                ],
                [
                    77.1015908,
                    55.2282266
                ],
                [
                    77.0959198,
                    55.2308832
                ]
            ],
            "longitude": 77.103439,
            "latitude": 55.231308
        },
        "9625": {
            "name": "Берестянка",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    77.1013886,
                    56.6530932
                ],
                [
                    77.1066889,
                    56.656298
                ],
                [
                    77.1105237,
                    56.6592283
                ],
                [
                    77.1130802,
                    56.660205
                ],
                [
                    77.1164163,
                    56.6585086
                ],
                [
                    77.1140156,
                    56.6562294
                ],
                [
                    77.107593,
                    56.6520134
                ],
                [
                    77.1052234,
                    56.6516706
                ],
                [
                    77.1013886,
                    56.6530932
                ]
            ],
            "longitude": 77.109833,
            "latitude": 56.656303
        },
        "9626": {
            "name": "Зенкино",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    77.1107243,
                    55.0224728
                ],
                [
                    77.1208213,
                    55.0248924
                ],
                [
                    77.1251042,
                    55.0260784
                ],
                [
                    77.1300699,
                    55.0272643
                ],
                [
                    77.1308975,
                    55.0263867
                ],
                [
                    77.1318286,
                    55.0266595
                ],
                [
                    77.1314355,
                    55.0273711
                ],
                [
                    77.133339,
                    55.027549
                ],
                [
                    77.1336907,
                    55.0269086
                ],
                [
                    77.1304837,
                    55.0260784
                ],
                [
                    77.1312699,
                    55.0253075
                ],
                [
                    77.1283112,
                    55.0241452
                ],
                [
                    77.1280215,
                    55.0243349
                ],
                [
                    77.1261801,
                    55.0237894
                ],
                [
                    77.1234283,
                    55.0233031
                ],
                [
                    77.1229317,
                    55.0234573
                ],
                [
                    77.1225179,
                    55.0240384
                ],
                [
                    77.1214834,
                    55.0233861
                ],
                [
                    77.1198902,
                    55.0232201
                ],
                [
                    77.1199728,
                    55.0225559
                ],
                [
                    77.1197247,
                    55.0222593
                ],
                [
                    77.1190833,
                    55.0220933
                ],
                [
                    77.1186488,
                    55.0223068
                ],
                [
                    77.1180074,
                    55.0228998
                ],
                [
                    77.117097,
                    55.0225084
                ],
                [
                    77.1179453,
                    55.0215832
                ],
                [
                    77.1169728,
                    55.0213342
                ],
                [
                    77.1166625,
                    55.0214765
                ],
                [
                    77.1149037,
                    55.021002
                ],
                [
                    77.1150693,
                    55.0208004
                ],
                [
                    77.1144693,
                    55.0207055
                ],
                [
                    77.1138279,
                    55.0212037
                ],
                [
                    77.1131865,
                    55.0217019
                ],
                [
                    77.1116968,
                    55.021346
                ],
                [
                    77.1107243,
                    55.0224728
                ]
            ],
            "longitude": 77.120537,
            "latitude": 55.024097
        },
        "9627": {
            "name": "Куликовка",
            "population": 116,
            "type": "hamlet",
            "poly": [
                [
                    77.1399215,
                    54.5054712
                ],
                [
                    77.1424256,
                    54.5060601
                ],
                [
                    77.1427426,
                    54.5056
                ],
                [
                    77.1471486,
                    54.506373
                ],
                [
                    77.1476874,
                    54.5057104
                ],
                [
                    77.1495576,
                    54.5062073
                ],
                [
                    77.1491772,
                    54.5069619
                ],
                [
                    77.1571333,
                    54.5091703
                ],
                [
                    77.1593205,
                    54.507238
                ],
                [
                    77.1575137,
                    54.5063362
                ],
                [
                    77.1555801,
                    54.5059681
                ],
                [
                    77.1548828,
                    54.5060785
                ],
                [
                    77.1420452,
                    54.5028761
                ],
                [
                    77.1399215,
                    54.5054712
                ]
            ],
            "longitude": 77.15139,
            "latitude": 54.506477
        },
        "9628": {
            "name": "Украинка",
            "population": 114,
            "type": "hamlet",
            "poly": [
                [
                    77.1437365,
                    54.1312121
                ],
                [
                    77.1509167,
                    54.1337184
                ],
                [
                    77.1478965,
                    54.136877
                ],
                [
                    77.1495336,
                    54.1375385
                ],
                [
                    77.151566,
                    54.1361659
                ],
                [
                    77.1534853,
                    54.1367943
                ],
                [
                    77.1537677,
                    54.1364305
                ],
                [
                    77.1522152,
                    54.1356533
                ],
                [
                    77.1533725,
                    54.1348099
                ],
                [
                    77.1595259,
                    54.1374227
                ],
                [
                    77.1603444,
                    54.1376873
                ],
                [
                    77.1614454,
                    54.1367447
                ],
                [
                    77.1615865,
                    54.1355871
                ],
                [
                    77.1608526,
                    54.1348099
                ],
                [
                    77.161643,
                    54.1340657
                ],
                [
                    77.1590743,
                    54.133338
                ],
                [
                    77.1550379,
                    54.1333049
                ],
                [
                    77.1531749,
                    54.1314857
                ],
                [
                    77.1509732,
                    54.1307249
                ],
                [
                    77.1494489,
                    54.1303279
                ],
                [
                    77.1501264,
                    54.1292859
                ],
                [
                    77.1487715,
                    54.1290378
                ],
                [
                    77.1471908,
                    54.1298648
                ],
                [
                    77.1445939,
                    54.1298317
                ],
                [
                    77.1437365,
                    54.1312121
                ]
            ],
            "longitude": 77.154922,
            "latitude": 54.133984
        },
        "9629": {
            "name": "Питомник",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.1462723,
                    54.3475558
                ],
                [
                    77.1754995,
                    54.355309
                ],
                [
                    77.1803099,
                    54.3496441
                ],
                [
                    77.1511158,
                    54.3416383
                ],
                [
                    77.1462723,
                    54.3475558
                ]
            ],
            "longitude": 77.156006,
            "latitude": 54.347511
        },
        "9630": {
            "name": "Кошкуль",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.158821,
            "latitude": 55.365917
        },
        "9631": {
            "name": "Чистое Озеро",
            "population": 123,
            "type": "hamlet",
            "poly": [
                [
                    77.1592043,
                    55.6589859
                ],
                [
                    77.1597864,
                    55.6592132
                ],
                [
                    77.1609056,
                    55.659188
                ],
                [
                    77.1609952,
                    55.6602235
                ],
                [
                    77.1650693,
                    55.6626226
                ],
                [
                    77.1664125,
                    55.66535
                ],
                [
                    77.1658752,
                    55.6672186
                ],
                [
                    77.1690092,
                    55.6675721
                ],
                [
                    77.1714268,
                    55.6647692
                ],
                [
                    77.1751876,
                    55.6666883
                ],
                [
                    77.1768441,
                    55.6659812
                ],
                [
                    77.1759039,
                    55.6653247
                ],
                [
                    77.1769784,
                    55.6646429
                ],
                [
                    77.1765307,
                    55.6644661
                ],
                [
                    77.1769336,
                    55.6640368
                ],
                [
                    77.1732177,
                    55.6625216
                ],
                [
                    77.1735311,
                    55.6596173
                ],
                [
                    77.1709343,
                    55.6585818
                ],
                [
                    77.1717402,
                    55.6575463
                ],
                [
                    77.1663677,
                    55.655652
                ],
                [
                    77.1656961,
                    55.6564602
                ],
                [
                    77.1643081,
                    55.6560814
                ],
                [
                    77.163368,
                    55.6567381
                ],
                [
                    77.1642635,
                    55.65742
                ],
                [
                    77.1631442,
                    55.6572685
                ],
                [
                    77.1620249,
                    55.6583293
                ],
                [
                    77.160055,
                    55.6577989
                ],
                [
                    77.1592043,
                    55.6589859
                ]
            ],
            "longitude": 77.165207,
            "latitude": 55.659012
        },
        "9632": {
            "name": "Грушевка",
            "population": 126,
            "type": "hamlet",
            "poly": [
                [
                    77.166683,
                    53.9172435
                ],
                [
                    77.1678821,
                    53.9175324
                ],
                [
                    77.166901,
                    53.9189448
                ],
                [
                    77.1730601,
                    53.9204214
                ],
                [
                    77.1733326,
                    53.9199399
                ],
                [
                    77.1766613,
                    53.9218603
                ],
                [
                    77.1814538,
                    53.9217374
                ],
                [
                    77.1825439,
                    53.9201325
                ],
                [
                    77.1831981,
                    53.9201967
                ],
                [
                    77.1833616,
                    53.9197152
                ],
                [
                    77.1845607,
                    53.9198115
                ],
                [
                    77.1851603,
                    53.9181744
                ],
                [
                    77.1829256,
                    53.9173719
                ],
                [
                    77.1823804,
                    53.9176929
                ],
                [
                    77.1794917,
                    53.9170509
                ],
                [
                    77.1797098,
                    53.9146111
                ],
                [
                    77.1780746,
                    53.9144185
                ],
                [
                    77.1773115,
                    53.9152853
                ],
                [
                    77.176603,
                    53.9149001
                ],
                [
                    77.1749678,
                    53.9166978
                ],
                [
                    77.1690811,
                    53.9151569
                ],
                [
                    77.1677731,
                    53.9149964
                ],
                [
                    77.166683,
                    53.9172435
                ]
            ],
            "longitude": 77.176933,
            "latitude": 53.91843
        },
        "9633": {
            "name": "Теренгуль",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    77.1758002,
                    53.768531
                ],
                [
                    77.1760097,
                    53.7691912
                ],
                [
                    77.1803147,
                    53.7695809
                ],
                [
                    77.1804776,
                    53.7689299
                ],
                [
                    77.1758002,
                    53.768531
                ]
            ],
            "longitude": 77.1781971,
            "latitude": 53.769072
        },
        "9634": {
            "name": "Алексеевка",
            "population": 84,
            "type": "hamlet",
            "poly": [
                [
                    77.1704002,
                    54.4384657
                ],
                [
                    77.1706913,
                    54.4401444
                ],
                [
                    77.1883746,
                    54.443812
                ],
                [
                    77.188981,
                    54.4417525
                ],
                [
                    77.1874771,
                    54.440229
                ],
                [
                    77.1857549,
                    54.4393544
                ],
                [
                    77.1715646,
                    54.4370549
                ],
                [
                    77.1704002,
                    54.4384657
                ]
            ],
            "longitude": 77.179436,
            "latitude": 54.440311
        },
        "9635": {
            "name": "Саратовка",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    77.1668698,
                    53.747859
                ],
                [
                    77.1678848,
                    53.7486092
                ],
                [
                    77.1689631,
                    53.7488718
                ],
                [
                    77.1697243,
                    53.7485717
                ],
                [
                    77.1712467,
                    53.7503347
                ],
                [
                    77.1697878,
                    53.7508223
                ],
                [
                    77.1699894,
                    53.7510326
                ],
                [
                    77.1708661,
                    53.7519475
                ],
                [
                    77.1782244,
                    53.7493594
                ],
                [
                    77.182855,
                    53.7483467
                ],
                [
                    77.1825378,
                    53.7478966
                ],
                [
                    77.1877394,
                    53.7460585
                ],
                [
                    77.1867879,
                    53.7448581
                ],
                [
                    77.1893252,
                    53.7438452
                ],
                [
                    77.1890076,
                    53.7436055
                ],
                [
                    77.1856461,
                    53.7410691
                ],
                [
                    77.1841237,
                    53.7418569
                ],
                [
                    77.183635,
                    53.7415153
                ],
                [
                    77.1834259,
                    53.7413692
                ],
                [
                    77.1827281,
                    53.7415568
                ],
                [
                    77.1811423,
                    53.7402062
                ],
                [
                    77.1800638,
                    53.7406939
                ],
                [
                    77.1807617,
                    53.7415568
                ],
                [
                    77.1789856,
                    53.7418944
                ],
                [
                    77.1791262,
                    53.7433159
                ],
                [
                    77.1766386,
                    53.7444454
                ],
                [
                    77.1772342,
                    53.7457483
                ],
                [
                    77.1791759,
                    53.7467712
                ],
                [
                    77.1761311,
                    53.7481966
                ],
                [
                    77.175243,
                    53.7472964
                ],
                [
                    77.1735938,
                    53.7480466
                ],
                [
                    77.1730229,
                    53.747559
                ],
                [
                    77.1707392,
                    53.7483467
                ],
                [
                    77.169534,
                    53.7465462
                ],
                [
                    77.1677182,
                    53.7467282
                ],
                [
                    77.1668698,
                    53.747859
                ]
            ],
            "longitude": 77.181526,
            "latitude": 53.745758
        },
        "9636": {
            "name": "Аполиха",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    77.1658803,
                    54.0695492
                ],
                [
                    77.1824377,
                    54.0731097
                ],
                [
                    77.1828846,
                    54.0723369
                ],
                [
                    77.1890466,
                    54.0736479
                ],
                [
                    77.1898652,
                    54.0723146
                ],
                [
                    77.1870812,
                    54.0713141
                ],
                [
                    77.1875147,
                    54.0707432
                ],
                [
                    77.1887671,
                    54.0692904
                ],
                [
                    77.1815324,
                    54.0679506
                ],
                [
                    77.1770047,
                    54.0668822
                ],
                [
                    77.1721834,
                    54.0656709
                ],
                [
                    77.1697139,
                    54.0683347
                ],
                [
                    77.1669386,
                    54.0676722
                ],
                [
                    77.1658803,
                    54.0695492
                ]
            ],
            "longitude": 77.181961,
            "latitude": 54.069885
        },
        "9637": {
            "name": "Комаровка",
            "population": 43,
            "type": "hamlet",
            "poly": [
                [
                    77.1845998,
                    56.5745056
                ],
                [
                    77.1855706,
                    56.5747572
                ],
                [
                    77.1903102,
                    56.5738765
                ],
                [
                    77.1916236,
                    56.5765817
                ],
                [
                    77.192309,
                    56.5774938
                ],
                [
                    77.1954497,
                    56.5788463
                ],
                [
                    77.1986476,
                    56.5786576
                ],
                [
                    77.1990474,
                    56.5780915
                ],
                [
                    77.1984763,
                    56.5757953
                ],
                [
                    77.2052718,
                    56.5747572
                ],
                [
                    77.2061284,
                    56.5739394
                ],
                [
                    77.2047008,
                    56.5715486
                ],
                [
                    77.202645,
                    56.5716744
                ],
                [
                    77.1931084,
                    56.5696295
                ],
                [
                    77.1903128,
                    56.5688801
                ],
                [
                    77.187455,
                    56.5681194
                ],
                [
                    77.18637,
                    56.5686228
                ],
                [
                    77.1872837,
                    56.571234
                ],
                [
                    77.1851137,
                    56.5728384
                ],
                [
                    77.1845998,
                    56.5745056
                ]
            ],
            "longitude": 77.196152,
            "latitude": 56.57505
        },
        "9638": {
            "name": "Весёлый Кут",
            "population": 232,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.211929,
            "latitude": 54.176548
        },
        "9639": {
            "name": "Двуозерный",
            "population": 81,
            "type": "hamlet",
            "poly": [
                [
                    77.2067123,
                    55.0885145
                ],
                [
                    77.2071616,
                    55.088731
                ],
                [
                    77.2072089,
                    55.0890287
                ],
                [
                    77.2075635,
                    55.0891776
                ],
                [
                    77.2082492,
                    55.0889069
                ],
                [
                    77.2088167,
                    55.0883521
                ],
                [
                    77.2091714,
                    55.0884469
                ],
                [
                    77.2089113,
                    55.0887446
                ],
                [
                    77.2091241,
                    55.0888528
                ],
                [
                    77.2094551,
                    55.0885686
                ],
                [
                    77.2110629,
                    55.0890829
                ],
                [
                    77.2108738,
                    55.0892452
                ],
                [
                    77.2110629,
                    55.0895159
                ],
                [
                    77.2113703,
                    55.0893535
                ],
                [
                    77.2116067,
                    55.0898271
                ],
                [
                    77.2102826,
                    55.090003
                ],
                [
                    77.2104245,
                    55.0910178
                ],
                [
                    77.212056,
                    55.0925198
                ],
                [
                    77.2112757,
                    55.0929527
                ],
                [
                    77.2115831,
                    55.0932775
                ],
                [
                    77.2155554,
                    55.0924792
                ],
                [
                    77.2154608,
                    55.0921003
                ],
                [
                    77.2157682,
                    55.0919109
                ],
                [
                    77.2154135,
                    55.0916673
                ],
                [
                    77.2147042,
                    55.0917621
                ],
                [
                    77.2146332,
                    55.0909908
                ],
                [
                    77.2140421,
                    55.0907337
                ],
                [
                    77.2140185,
                    55.0903548
                ],
                [
                    77.2142786,
                    55.0901654
                ],
                [
                    77.2140658,
                    55.0894617
                ],
                [
                    77.213049,
                    55.089137
                ],
                [
                    77.2117486,
                    55.0892858
                ],
                [
                    77.2117959,
                    55.0888528
                ],
                [
                    77.2111575,
                    55.0885822
                ],
                [
                    77.2115122,
                    55.0880138
                ],
                [
                    77.2101644,
                    55.0870801
                ],
                [
                    77.208462,
                    55.0867689
                ],
                [
                    77.2075399,
                    55.088095
                ],
                [
                    77.2071852,
                    55.088095
                ],
                [
                    77.2067123,
                    55.0885145
                ]
            ],
            "longitude": 77.212151,
            "latitude": 55.090893
        },
        "9640": {
            "name": "Межгривный",
            "population": 187,
            "type": "hamlet",
            "poly": [
                [
                    77.2061668,
                    55.4002695
                ],
                [
                    77.2089052,
                    55.4012077
                ],
                [
                    77.2115758,
                    55.4019402
                ],
                [
                    77.2123,
                    55.4018502
                ],
                [
                    77.214948,
                    55.4024799
                ],
                [
                    77.2152648,
                    55.4023899
                ],
                [
                    77.2165775,
                    55.403071
                ],
                [
                    77.2172338,
                    55.402647
                ],
                [
                    77.2167585,
                    55.4019659
                ],
                [
                    77.2172338,
                    55.4015803
                ],
                [
                    77.2182296,
                    55.4017217
                ],
                [
                    77.2185463,
                    55.4011948
                ],
                [
                    77.2177317,
                    55.4010278
                ],
                [
                    77.2179806,
                    55.4006679
                ],
                [
                    77.2175959,
                    55.4002695
                ],
                [
                    77.2178675,
                    55.3999611
                ],
                [
                    77.2158532,
                    55.39919
                ],
                [
                    77.2155364,
                    55.3996655
                ],
                [
                    77.2144727,
                    55.3993185
                ],
                [
                    77.2136806,
                    55.398933
                ],
                [
                    77.2084752,
                    55.3981747
                ],
                [
                    77.2079094,
                    55.3985346
                ],
                [
                    77.2081584,
                    55.3988816
                ],
                [
                    77.2078189,
                    55.3992157
                ],
                [
                    77.2083168,
                    55.3997298
                ],
                [
                    77.2069362,
                    55.3994213
                ],
                [
                    77.2061668,
                    55.4002695
                ]
            ],
            "longitude": 77.212212,
            "latitude": 55.400608
        },
        "9641": {
            "name": "Подольск",
            "population": 110,
            "type": "hamlet",
            "poly": [
                [
                    77.2136527,
                    53.9578431
                ],
                [
                    77.2141194,
                    53.9596083
                ],
                [
                    77.2240535,
                    53.9576862
                ],
                [
                    77.2254536,
                    53.9578431
                ],
                [
                    77.2252536,
                    53.9587453
                ],
                [
                    77.2308714,
                    53.9597247
                ],
                [
                    77.2324541,
                    53.9600006
                ],
                [
                    77.2328541,
                    53.9594122
                ],
                [
                    77.2345209,
                    53.9593338
                ],
                [
                    77.2358543,
                    53.9570585
                ],
                [
                    77.2299872,
                    53.9554501
                ],
                [
                    77.2260536,
                    53.954744
                ],
                [
                    77.2231867,
                    53.9544694
                ],
                [
                    77.2184531,
                    53.9549401
                ],
                [
                    77.2189198,
                    53.9565878
                ],
                [
                    77.2136527,
                    53.9578431
                ]
            ],
            "longitude": 77.22599,
            "latitude": 53.956589
        },
        "9642": {
            "name": "Мариинка",
            "population": 138,
            "type": "hamlet",
            "poly": [
                [
                    77.2176547,
                    55.9726039
                ],
                [
                    77.2241877,
                    55.9738225
                ],
                [
                    77.2249499,
                    55.9735178
                ],
                [
                    77.2275268,
                    55.9736194
                ],
                [
                    77.2276719,
                    55.9741271
                ],
                [
                    77.228906,
                    55.9740865
                ],
                [
                    77.2290148,
                    55.9738428
                ],
                [
                    77.2314102,
                    55.9734772
                ],
                [
                    77.2359834,
                    55.9717915
                ],
                [
                    77.2371085,
                    55.9717712
                ],
                [
                    77.2381611,
                    55.9715681
                ],
                [
                    77.2384151,
                    55.971304
                ],
                [
                    77.2373989,
                    55.9704307
                ],
                [
                    77.2369996,
                    55.9673026
                ],
                [
                    77.2340598,
                    55.9675667
                ],
                [
                    77.2328621,
                    55.9670995
                ],
                [
                    77.2319184,
                    55.9678511
                ],
                [
                    77.2286881,
                    55.9680745
                ],
                [
                    77.2270549,
                    55.9686026
                ],
                [
                    77.2269823,
                    55.9692323
                ],
                [
                    77.2276719,
                    55.9694354
                ],
                [
                    77.2275268,
                    55.9697807
                ],
                [
                    77.2247684,
                    55.9693542
                ],
                [
                    77.2228811,
                    55.969476
                ],
                [
                    77.2223729,
                    55.9701463
                ],
                [
                    77.220159,
                    55.9697198
                ],
                [
                    77.2190701,
                    55.9698823
                ],
                [
                    77.2185257,
                    55.9704713
                ],
                [
                    77.218562,
                    55.9709181
                ],
                [
                    77.2189613,
                    55.9710197
                ],
                [
                    77.2176547,
                    55.9726039
                ]
            ],
            "longitude": 77.229683,
            "latitude": 55.971729
        },
        "9643": {
            "name": "Дружинино",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    77.2325261,
                    54.6166725
                ],
                [
                    77.2408102,
                    54.6185312
                ],
                [
                    77.2416904,
                    54.6177218
                ],
                [
                    77.243865,
                    54.6182614
                ],
                [
                    77.2433472,
                    54.618861
                ],
                [
                    77.2508548,
                    54.6220386
                ],
                [
                    77.2511654,
                    54.6213791
                ],
                [
                    77.2516832,
                    54.6176918
                ],
                [
                    77.2340276,
                    54.6129547
                ],
                [
                    77.2328366,
                    54.6145138
                ],
                [
                    77.2340793,
                    54.6149935
                ],
                [
                    77.2325261,
                    54.6166725
                ]
            ],
            "longitude": 77.248703,
            "latitude": 54.61832
        },
        "9644": {
            "name": "Чернаковка",
            "population": 238,
            "type": "hamlet",
            "poly": [
                [
                    77.2484808,
                    56.5716026
                ],
                [
                    77.2492069,
                    56.573264
                ],
                [
                    77.2524462,
                    56.5762175
                ],
                [
                    77.2564117,
                    56.5781249
                ],
                [
                    77.2614383,
                    56.5801552
                ],
                [
                    77.2647335,
                    56.5799706
                ],
                [
                    77.2693692,
                    56.5815701
                ],
                [
                    77.270933,
                    56.5813856
                ],
                [
                    77.2699277,
                    56.578494
                ],
                [
                    77.2715474,
                    56.5762483
                ],
                [
                    77.2678612,
                    56.5721872
                ],
                [
                    77.2661857,
                    56.5714795
                ],
                [
                    77.257026,
                    56.5690487
                ],
                [
                    77.2512175,
                    56.567941
                ],
                [
                    77.2490951,
                    56.5684949
                ],
                [
                    77.2484808,
                    56.5716026
                ]
            ],
            "longitude": 77.258224,
            "latitude": 56.572678
        },
        "9645": {
            "name": "Вороново",
            "population": 57,
            "type": "hamlet",
            "poly": [
                [
                    77.2625875,
                    56.1639751
                ],
                [
                    77.2641478,
                    56.16545
                ],
                [
                    77.2646921,
                    56.1652681
                ],
                [
                    77.2666877,
                    56.1669652
                ],
                [
                    77.2689737,
                    56.165753
                ],
                [
                    77.2686471,
                    56.1648439
                ],
                [
                    77.2708968,
                    56.1641973
                ],
                [
                    77.2699171,
                    56.1634296
                ],
                [
                    77.2738359,
                    56.1613485
                ],
                [
                    77.2749245,
                    56.1606009
                ],
                [
                    77.2765936,
                    56.1598532
                ],
                [
                    77.2771016,
                    56.1593683
                ],
                [
                    77.2758316,
                    56.1586206
                ],
                [
                    77.275251,
                    56.1588631
                ],
                [
                    77.2738722,
                    56.1581357
                ],
                [
                    77.2716951,
                    56.1592066
                ],
                [
                    77.2716225,
                    56.1597522
                ],
                [
                    77.2722031,
                    56.1601361
                ],
                [
                    77.268756,
                    56.1617526
                ],
                [
                    77.2683206,
                    56.1613687
                ],
                [
                    77.2678489,
                    56.1615101
                ],
                [
                    77.2673046,
                    56.1612676
                ],
                [
                    77.2663612,
                    56.1617728
                ],
                [
                    77.2653452,
                    56.1618536
                ],
                [
                    77.2636398,
                    56.1627426
                ],
                [
                    77.2642567,
                    56.1632275
                ],
                [
                    77.2625875,
                    56.1639751
                ]
            ],
            "longitude": 77.267845,
            "latitude": 56.162884
        },
        "9646": {
            "name": "Успенка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.2584339,
                    54.066221
                ],
                [
                    77.262025,
                    54.0669454
                ],
                [
                    77.2630125,
                    54.0651673
                ],
                [
                    77.2635063,
                    54.0653912
                ],
                [
                    77.2654365,
                    54.06468
                ],
                [
                    77.2659077,
                    54.0641267
                ],
                [
                    77.2684215,
                    54.06468
                ],
                [
                    77.268242,
                    54.0650883
                ],
                [
                    77.2692295,
                    54.0654966
                ],
                [
                    77.2687581,
                    54.0662342
                ],
                [
                    77.2696784,
                    54.066142
                ],
                [
                    77.2703068,
                    54.0652595
                ],
                [
                    77.2733592,
                    54.0659971
                ],
                [
                    77.2736959,
                    54.0658259
                ],
                [
                    77.2756036,
                    54.066221
                ],
                [
                    77.2745039,
                    54.0676962
                ],
                [
                    77.2780949,
                    54.0684864
                ],
                [
                    77.2784091,
                    54.067762
                ],
                [
                    77.2795313,
                    54.0678674
                ],
                [
                    77.2798904,
                    54.0671562
                ],
                [
                    77.2814391,
                    54.0674328
                ],
                [
                    77.2825613,
                    54.0655888
                ],
                [
                    77.2607681,
                    54.0605043
                ],
                [
                    77.258793,
                    54.0638633
                ],
                [
                    77.2598928,
                    54.0642321
                ],
                [
                    77.2584339,
                    54.066221
                ]
            ],
            "longitude": 77.271111,
            "latitude": 54.064171
        },
        "9647": {
            "name": "Сергеевка",
            "population": 12,
            "type": "hamlet",
            "poly": [
                [
                    77.2605595,
                    54.4782736
                ],
                [
                    77.2834234,
                    54.4854329
                ],
                [
                    77.286136,
                    54.4845324
                ],
                [
                    77.2871048,
                    54.4821011
                ],
                [
                    77.2785018,
                    54.4797371
                ],
                [
                    77.2777655,
                    54.4807052
                ],
                [
                    77.2764867,
                    54.4801649
                ],
                [
                    77.2771068,
                    54.4792418
                ],
                [
                    77.2682713,
                    54.4767651
                ],
                [
                    77.2666823,
                    54.4773505
                ],
                [
                    77.2657524,
                    54.4777107
                ],
                [
                    77.2617996,
                    54.476675
                ],
                [
                    77.2605595,
                    54.4782736
                ]
            ],
            "longitude": 77.275055,
            "latitude": 54.480846
        },
        "9648": {
            "name": "Романовка",
            "population": 120,
            "type": "hamlet",
            "poly": [
                [
                    77.2728838,
                    53.8661487
                ],
                [
                    77.2755085,
                    53.8668171
                ],
                [
                    77.2770599,
                    53.8672121
                ],
                [
                    77.2824698,
                    53.857641
                ],
                [
                    77.2867408,
                    53.8524907
                ],
                [
                    77.285046,
                    53.851841
                ],
                [
                    77.2829443,
                    53.8510351
                ],
                [
                    77.2772497,
                    53.857641
                ],
                [
                    77.2756361,
                    53.8584807
                ],
                [
                    77.2762057,
                    53.8605517
                ],
                [
                    77.2728838,
                    53.8661487
                ]
            ],
            "longitude": 77.278709,
            "latitude": 53.859112
        },
        "9649": {
            "name": "Моревка",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    77.2720064,
                    54.2378435
                ],
                [
                    77.2948688,
                    54.2439855
                ],
                [
                    77.2982278,
                    54.2405452
                ],
                [
                    77.2739929,
                    54.2340439
                ],
                [
                    77.2720064,
                    54.2378435
                ]
            ],
            "longitude": 77.286385,
            "latitude": 54.238823
        },
        "9650": {
            "name": "Остановочная Платформа 2966",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.28759,
            "latitude": 55.355782
        },
        "9651": {
            "name": "Михайловка",
            "population": 174,
            "type": "hamlet",
            "poly": [
                [
                    77.2736503,
                    54.4523426
                ],
                [
                    77.2822373,
                    54.4540066
                ],
                [
                    77.2840808,
                    54.4537387
                ],
                [
                    77.2844932,
                    54.4531887
                ],
                [
                    77.2857303,
                    54.4533579
                ],
                [
                    77.2852209,
                    54.4540912
                ],
                [
                    77.2959182,
                    54.4567846
                ],
                [
                    77.298732,
                    54.4542605
                ],
                [
                    77.2972281,
                    54.4534002
                ],
                [
                    77.2917218,
                    54.4518631
                ],
                [
                    77.2870644,
                    54.4508336
                ],
                [
                    77.2867976,
                    54.4512003
                ],
                [
                    77.2797631,
                    54.4496066
                ],
                [
                    77.2788899,
                    54.4499028
                ],
                [
                    77.2785017,
                    54.4504387
                ],
                [
                    77.2749602,
                    54.4493809
                ],
                [
                    77.2748146,
                    54.449663
                ],
                [
                    77.2746448,
                    54.4512991
                ],
                [
                    77.2736503,
                    54.4523426
                ]
            ],
            "longitude": 77.287994,
            "latitude": 54.452724
        },
        "9652": {
            "name": "Тайлаково",
            "population": 157,
            "type": "hamlet",
            "poly": [
                [
                    77.28868,
                    55.4970969
                ],
                [
                    77.2906851,
                    55.4986476
                ],
                [
                    77.2917262,
                    55.4976866
                ],
                [
                    77.2923817,
                    55.4981016
                ],
                [
                    77.2934614,
                    55.4975556
                ],
                [
                    77.2948881,
                    55.4987132
                ],
                [
                    77.2982428,
                    55.500526
                ],
                [
                    77.3007877,
                    55.4994994
                ],
                [
                    77.2982813,
                    55.4972498
                ],
                [
                    77.2960834,
                    55.4958519
                ],
                [
                    77.298397,
                    55.4941263
                ],
                [
                    77.296469,
                    55.4935365
                ],
                [
                    77.2943097,
                    55.4942355
                ],
                [
                    77.2921118,
                    55.4934491
                ],
                [
                    77.2910321,
                    55.4936457
                ],
                [
                    77.2901067,
                    55.4940826
                ],
                [
                    77.2899139,
                    55.4946505
                ],
                [
                    77.290338,
                    55.4950437
                ],
                [
                    77.2912635,
                    55.4946723
                ],
                [
                    77.2921118,
                    55.4953932
                ],
                [
                    77.28868,
                    55.4970969
                ]
            ],
            "longitude": 77.294281,
            "latitude": 55.496334
        },
        "9653": {
            "name": "Тюменка",
            "population": 243,
            "type": "hamlet",
            "poly": [
                [
                    77.2905923,
                    54.7194551
                ],
                [
                    77.2945565,
                    54.7212899
                ],
                [
                    77.2958599,
                    54.7221211
                ],
                [
                    77.3009917,
                    54.7239245
                ],
                [
                    77.3075627,
                    54.7254612
                ],
                [
                    77.3092733,
                    54.7251319
                ],
                [
                    77.3108902,
                    54.7247099
                ],
                [
                    77.3114183,
                    54.7237833
                ],
                [
                    77.3077256,
                    54.7227484
                ],
                [
                    77.2953711,
                    54.719063
                ],
                [
                    77.2918561,
                    54.71832
                ],
                [
                    77.2905923,
                    54.7194551
                ]
            ],
            "longitude": 77.301384,
            "latitude": 54.722485
        },
        "9654": {
            "name": "Богословка",
            "population": 227,
            "type": "hamlet",
            "poly": [
                [
                    77.2841112,
                    53.6828081
                ],
                [
                    77.2911141,
                    53.686748
                ],
                [
                    77.2897135,
                    53.6875256
                ],
                [
                    77.2926898,
                    53.6884068
                ],
                [
                    77.294528,
                    53.6877848
                ],
                [
                    77.2975043,
                    53.6861778
                ],
                [
                    77.3058202,
                    53.6894954
                ],
                [
                    77.3083587,
                    53.6903248
                ],
                [
                    77.3093217,
                    53.6890807
                ],
                [
                    77.3152742,
                    53.6915169
                ],
                [
                    77.3163246,
                    53.6906876
                ],
                [
                    77.3125606,
                    53.6879403
                ],
                [
                    77.310022,
                    53.6884068
                ],
                [
                    77.3087965,
                    53.6865407
                ],
                [
                    77.306433,
                    53.6861778
                ],
                [
                    77.3049449,
                    53.6865925
                ],
                [
                    77.3053826,
                    53.684467
                ],
                [
                    77.3022312,
                    53.6830154
                ],
                [
                    77.3005681,
                    53.6845189
                ],
                [
                    77.2984672,
                    53.6837931
                ],
                [
                    77.294528,
                    53.6825488
                ],
                [
                    77.2962788,
                    53.6817193
                ],
                [
                    77.2976794,
                    53.6824451
                ],
                [
                    77.3006556,
                    53.6821341
                ],
                [
                    77.301706,
                    53.6805787
                ],
                [
                    77.2982046,
                    53.6797492
                ],
                [
                    77.2940028,
                    53.6792307
                ],
                [
                    77.2929524,
                    53.6799047
                ],
                [
                    77.2955785,
                    53.6810972
                ],
                [
                    77.2914643,
                    53.6832228
                ],
                [
                    77.2930399,
                    53.6836894
                ],
                [
                    77.2938277,
                    53.6830673
                ],
                [
                    77.2942654,
                    53.6840523
                ],
                [
                    77.2912892,
                    53.6852447
                ],
                [
                    77.2870874,
                    53.6819786
                ],
                [
                    77.2841112,
                    53.6828081
                ]
            ],
            "longitude": 77.30188,
            "latitude": 53.686256
        },
        "9655": {
            "name": "Аялу",
            "population": 76,
            "type": "hamlet",
            "poly": [
                [
                    77.2968197,
                    55.1730283
                ],
                [
                    77.2979035,
                    55.1735441
                ],
                [
                    77.3001433,
                    55.1729871
                ],
                [
                    77.3017328,
                    55.1720586
                ],
                [
                    77.3017328,
                    55.1715428
                ],
                [
                    77.3024913,
                    55.1713572
                ],
                [
                    77.3035029,
                    55.1704287
                ],
                [
                    77.3032862,
                    55.1698304
                ],
                [
                    77.3041532,
                    55.1694177
                ],
                [
                    77.3048395,
                    55.1701192
                ],
                [
                    77.30614,
                    55.1695621
                ],
                [
                    77.3035029,
                    55.1679321
                ],
                [
                    77.3023108,
                    55.1684067
                ],
                [
                    77.3020579,
                    55.1693352
                ],
                [
                    77.3012631,
                    55.1692114
                ],
                [
                    77.30036,
                    55.1697272
                ],
                [
                    77.3001433,
                    55.1703049
                ],
                [
                    77.3005768,
                    55.170862
                ],
                [
                    77.299493,
                    55.1714603
                ],
                [
                    77.2984815,
                    55.1711508
                ],
                [
                    77.2970004,
                    55.1721618
                ],
                [
                    77.2975061,
                    55.1725951
                ],
                [
                    77.2968197,
                    55.1730283
                ]
            ],
            "longitude": 77.301895,
            "latitude": 55.170204
        },
        "9656": {
            "name": "III Интернационал",
            "population": 44,
            "type": "hamlet",
            "poly": [
                [
                    77.2981514,
                    53.7550438
                ],
                [
                    77.303389,
                    53.7560556
                ],
                [
                    77.3043225,
                    53.7548292
                ],
                [
                    77.309975,
                    53.7562702
                ],
                [
                    77.3140717,
                    53.7502912
                ],
                [
                    77.3034409,
                    53.7474393
                ],
                [
                    77.3003813,
                    53.7514564
                ],
                [
                    77.2998627,
                    53.7513644
                ],
                [
                    77.2981514,
                    53.7550438
                ]
            ],
            "longitude": 77.305206,
            "latitude": 53.752346
        },
        "9657": {
            "name": "Новояблоновка",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    77.2954908,
                    54.8771638
                ],
                [
                    77.2976006,
                    54.8779575
                ],
                [
                    77.2980064,
                    54.8776618
                ],
                [
                    77.3001703,
                    54.8783465
                ],
                [
                    77.3000351,
                    54.8786733
                ],
                [
                    77.304417,
                    54.8800894
                ],
                [
                    77.3048498,
                    54.8796693
                ],
                [
                    77.3078253,
                    54.8806808
                ],
                [
                    77.3081769,
                    54.880883
                ],
                [
                    77.3079875,
                    54.8811009
                ],
                [
                    77.3092589,
                    54.881521
                ],
                [
                    77.3094482,
                    54.8812876
                ],
                [
                    77.3141007,
                    54.8827814
                ],
                [
                    77.3136408,
                    54.8831393
                ],
                [
                    77.3145335,
                    54.8833727
                ],
                [
                    77.3147499,
                    54.8830304
                ],
                [
                    77.3187802,
                    54.8839017
                ],
                [
                    77.3200245,
                    54.8840729
                ],
                [
                    77.3209171,
                    54.8829993
                ],
                [
                    77.3184827,
                    54.8822679
                ],
                [
                    77.3196728,
                    54.8812409
                ],
                [
                    77.3188073,
                    54.8810231
                ],
                [
                    77.3191589,
                    54.8803384
                ],
                [
                    77.3184286,
                    54.880105
                ],
                [
                    77.318185,
                    54.880354
                ],
                [
                    77.31429,
                    54.8792491
                ],
                [
                    77.3102597,
                    54.8783777
                ],
                [
                    77.3074466,
                    54.8777708
                ],
                [
                    77.308258,
                    54.8768526
                ],
                [
                    77.3073654,
                    54.8766503
                ],
                [
                    77.306581,
                    54.877335
                ],
                [
                    77.304931,
                    54.8768526
                ],
                [
                    77.3046334,
                    54.8771638
                ],
                [
                    77.3023613,
                    54.8765413
                ],
                [
                    77.3024695,
                    54.8762301
                ],
                [
                    77.2990072,
                    54.8752496
                ],
                [
                    77.2979523,
                    54.8762145
                ],
                [
                    77.2967891,
                    54.8759188
                ],
                [
                    77.2954908,
                    54.8771638
                ]
            ],
            "longitude": 77.311028,
            "latitude": 54.880627
        },
        "9658": {
            "name": "Курский",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    77.3187054,
                    53.8053844
                ],
                [
                    77.320078,
                    53.8061949
                ],
                [
                    77.3257128,
                    53.8051711
                ],
                [
                    77.3306251,
                    53.8045738
                ],
                [
                    77.3402331,
                    53.80291
                ],
                [
                    77.3393662,
                    53.8019714
                ],
                [
                    77.3187054,
                    53.8053844
                ]
            ],
            "longitude": 77.330734,
            "latitude": 53.803959
        },
        "9659": {
            "name": "Улуцк",
            "population": 23,
            "type": "hamlet",
            "poly": [
                [
                    77.3355071,
                    56.1881047
                ],
                [
                    77.3379733,
                    56.1888855
                ],
                [
                    77.3418851,
                    56.1891458
                ],
                [
                    77.3422678,
                    56.1900212
                ],
                [
                    77.3426505,
                    56.1902815
                ],
                [
                    77.3433733,
                    56.1901632
                ],
                [
                    77.343841,
                    56.189548
                ],
                [
                    77.3445639,
                    56.189619
                ],
                [
                    77.3454143,
                    56.1889092
                ],
                [
                    77.3441812,
                    56.188223
                ],
                [
                    77.3455418,
                    56.1871109
                ],
                [
                    77.3437985,
                    56.1863064
                ],
                [
                    77.3428206,
                    56.1870636
                ],
                [
                    77.342608,
                    56.1877735
                ],
                [
                    77.339419,
                    56.1869453
                ],
                [
                    77.3374204,
                    56.186614
                ],
                [
                    77.3355071,
                    56.1881047
                ]
            ],
            "longitude": 77.342354,
            "latitude": 56.188484
        },
        "9660": {
            "name": "Новоалександровка",
            "population": 39,
            "type": "hamlet",
            "poly": [
                [
                    77.3422493,
                    55.1203983
                ],
                [
                    77.3434788,
                    55.1210473
                ],
                [
                    77.3451434,
                    55.1205173
                ],
                [
                    77.3459,
                    55.1213177
                ],
                [
                    77.3449164,
                    55.1219343
                ],
                [
                    77.3458811,
                    55.1228212
                ],
                [
                    77.3469593,
                    55.1234053
                ],
                [
                    77.347924,
                    55.1229943
                ],
                [
                    77.3491913,
                    55.1241191
                ],
                [
                    77.3488318,
                    55.1243463
                ],
                [
                    77.3490967,
                    55.1245301
                ],
                [
                    77.3496075,
                    55.1243679
                ],
                [
                    77.350364,
                    55.1250493
                ],
                [
                    77.3498723,
                    55.125536
                ],
                [
                    77.3503262,
                    55.1256874
                ],
                [
                    77.3509315,
                    55.1250277
                ],
                [
                    77.3515368,
                    55.1253629
                ],
                [
                    77.3510261,
                    55.126066
                ],
                [
                    77.3535797,
                    55.1268555
                ],
                [
                    77.3551686,
                    55.1249952
                ],
                [
                    77.3526339,
                    55.1244004
                ],
                [
                    77.3513666,
                    55.1249952
                ],
                [
                    77.3496642,
                    55.1239353
                ],
                [
                    77.3509126,
                    55.1235026
                ],
                [
                    77.349475,
                    55.1225292
                ],
                [
                    77.3486616,
                    55.1228969
                ],
                [
                    77.3477915,
                    55.1222588
                ],
                [
                    77.3494183,
                    55.1218153
                ],
                [
                    77.3483969,
                    55.1215557
                ],
                [
                    77.3474322,
                    55.1219992
                ],
                [
                    77.3471484,
                    55.1217396
                ],
                [
                    77.3474322,
                    55.1216098
                ],
                [
                    77.3463161,
                    55.1208634
                ],
                [
                    77.3472241,
                    55.1202252
                ],
                [
                    77.3468647,
                    55.1199007
                ],
                [
                    77.347243,
                    55.1196735
                ],
                [
                    77.3447462,
                    55.1185053
                ],
                [
                    77.3430438,
                    55.1191219
                ],
                [
                    77.3435356,
                    55.1195762
                ],
                [
                    77.3422493,
                    55.1203983
                ]
            ],
            "longitude": 77.346085,
            "latitude": 55.120167
        },
        "9661": {
            "name": "Славянка",
            "population": 139,
            "type": "hamlet",
            "poly": [
                [
                    77.3334575,
                    54.1383608
                ],
                [
                    77.3350091,
                    54.1399722
                ],
                [
                    77.3376187,
                    54.1405919
                ],
                [
                    77.3536991,
                    54.1356751
                ],
                [
                    77.3541928,
                    54.1360057
                ],
                [
                    77.3597645,
                    54.1343942
                ],
                [
                    77.3568729,
                    54.130799
                ],
                [
                    77.3407925,
                    54.1356338
                ],
                [
                    77.339664,
                    54.1345595
                ],
                [
                    77.3373366,
                    54.1355098
                ],
                [
                    77.3382534,
                    54.1365841
                ],
                [
                    77.3334575,
                    54.1383608
                ]
            ],
            "longitude": 77.347,
            "latitude": 54.136059
        },
        "9662": {
            "name": "Понькино",
            "population": 38,
            "type": "hamlet",
            "poly": [
                [
                    77.3570057,
                    56.6012633
                ],
                [
                    77.3585499,
                    56.6027744
                ],
                [
                    77.3570915,
                    56.6035456
                ],
                [
                    77.3570343,
                    56.6043956
                ],
                [
                    77.3576634,
                    56.6053242
                ],
                [
                    77.3592934,
                    56.6054974
                ],
                [
                    77.361867,
                    56.6046632
                ],
                [
                    77.3628965,
                    56.6029633
                ],
                [
                    77.3642691,
                    56.6028531
                ],
                [
                    77.3662422,
                    56.6036401
                ],
                [
                    77.3671001,
                    56.6053714
                ],
                [
                    77.3677292,
                    56.6060954
                ],
                [
                    77.3695593,
                    56.6079841
                ],
                [
                    77.3721043,
                    56.607386
                ],
                [
                    77.3710177,
                    56.6063315
                ],
                [
                    77.371847,
                    56.6053242
                ],
                [
                    77.3716467,
                    56.6047419
                ],
                [
                    77.3697308,
                    56.6051511
                ],
                [
                    77.3697595,
                    56.6045215
                ],
                [
                    77.371418,
                    56.6038447
                ],
                [
                    77.370217,
                    56.6028216
                ],
                [
                    77.3668427,
                    56.6014364
                ],
                [
                    77.3613809,
                    56.5987446
                ],
                [
                    77.36038,
                    56.5991854
                ],
                [
                    77.3608662,
                    56.6001456
                ],
                [
                    77.3570057,
                    56.6012633
                ]
            ],
            "longitude": 77.361191,
            "latitude": 56.601971
        },
        "9663": {
            "name": "Соловьёвка",
            "population": 254,
            "type": "hamlet",
            "poly": [
                [
                    77.3564004,
                    53.9357596
                ],
                [
                    77.3632988,
                    53.9401713
                ],
                [
                    77.3604883,
                    53.941976
                ],
                [
                    77.365513,
                    53.9452342
                ],
                [
                    77.3686641,
                    53.9437304
                ],
                [
                    77.3693455,
                    53.9442818
                ],
                [
                    77.3719856,
                    53.9436803
                ],
                [
                    77.3770103,
                    53.9454848
                ],
                [
                    77.3778619,
                    53.9444823
                ],
                [
                    77.3747108,
                    53.9423269
                ],
                [
                    77.3772869,
                    53.9409209
                ],
                [
                    77.3793949,
                    53.9397703
                ],
                [
                    77.3658537,
                    53.9308961
                ],
                [
                    77.364064,
                    53.9318169
                ],
                [
                    77.3564004,
                    53.9357596
                ]
            ],
            "longitude": 77.367729,
            "latitude": 53.938618
        },
        "9664": {
            "name": "Остановочная Платформа 142 к",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.371552,
            "latitude": 54.281372
        },
        "9665": {
            "name": "Нововасильевский",
            "population": 86,
            "type": "hamlet",
            "poly": [
                [
                    77.3650579,
                    55.0430205
                ],
                [
                    77.3677855,
                    55.0437852
                ],
                [
                    77.3705516,
                    55.0443505
                ],
                [
                    77.3714029,
                    55.0435303
                ],
                [
                    77.3725636,
                    55.0437076
                ],
                [
                    77.3724088,
                    55.0439293
                ],
                [
                    77.3734921,
                    55.0442396
                ],
                [
                    77.3732792,
                    55.0445167
                ],
                [
                    77.3742272,
                    55.0447051
                ],
                [
                    77.3742852,
                    55.045093
                ],
                [
                    77.3748075,
                    55.0454699
                ],
                [
                    77.3758328,
                    55.0456029
                ],
                [
                    77.3763744,
                    55.0447384
                ],
                [
                    77.3769161,
                    55.0446497
                ],
                [
                    77.3778639,
                    55.0431646
                ],
                [
                    77.3765872,
                    55.0429429
                ],
                [
                    77.376413,
                    55.0431202
                ],
                [
                    77.3756974,
                    55.0429983
                ],
                [
                    77.3758907,
                    55.0423665
                ],
                [
                    77.3764324,
                    55.0417458
                ],
                [
                    77.3779413,
                    55.0422889
                ],
                [
                    77.3792373,
                    55.042555
                ],
                [
                    77.3798564,
                    55.0418456
                ],
                [
                    77.3786183,
                    55.0414798
                ],
                [
                    77.3783669,
                    55.0416572
                ],
                [
                    77.3770514,
                    55.0414244
                ],
                [
                    77.3767806,
                    55.0408702
                ],
                [
                    77.3756393,
                    55.0406707
                ],
                [
                    77.3752331,
                    55.0410254
                ],
                [
                    77.3740918,
                    55.040848
                ],
                [
                    77.3734534,
                    55.0415907
                ],
                [
                    77.3731245,
                    55.041502
                ],
                [
                    77.3728536,
                    55.0417458
                ],
                [
                    77.3737049,
                    55.0420229
                ],
                [
                    77.3732792,
                    55.0425106
                ],
                [
                    77.3713255,
                    55.0422224
                ],
                [
                    77.3714416,
                    55.041768
                ],
                [
                    77.3704163,
                    55.0416904
                ],
                [
                    77.3699134,
                    55.0424441
                ],
                [
                    77.3694684,
                    55.042688
                ],
                [
                    77.3677855,
                    55.0422668
                ],
                [
                    77.3685012,
                    55.0414133
                ],
                [
                    77.3672245,
                    55.0412692
                ],
                [
                    77.3663733,
                    55.0422114
                ],
                [
                    77.3656382,
                    55.0420894
                ],
                [
                    77.3651353,
                    55.0426769
                ],
                [
                    77.3650579,
                    55.0430205
                ]
            ],
            "longitude": 77.373436,
            "latitude": 55.043331
        },
        "9666": {
            "name": "Чурым",
            "population": 38,
            "type": "hamlet",
            "poly": [
                [
                    77.370418,
                    55.3941288
                ],
                [
                    77.370418,
                    55.3945246
                ],
                [
                    77.3723796,
                    55.394979
                ],
                [
                    77.3720957,
                    55.3956093
                ],
                [
                    77.3729216,
                    55.3957412
                ],
                [
                    77.3730765,
                    55.3951109
                ],
                [
                    77.3737217,
                    55.3955506
                ],
                [
                    77.3744702,
                    55.3956826
                ],
                [
                    77.3741347,
                    55.3960197
                ],
                [
                    77.3735152,
                    55.3963422
                ],
                [
                    77.3729474,
                    55.3961956
                ],
                [
                    77.3727667,
                    55.3967379
                ],
                [
                    77.3733088,
                    55.397075
                ],
                [
                    77.3733088,
                    55.3973242
                ],
                [
                    77.3742379,
                    55.3974268
                ],
                [
                    77.374909,
                    55.3978665
                ],
                [
                    77.3760705,
                    55.3978665
                ],
                [
                    77.3762253,
                    55.3972216
                ],
                [
                    77.3790386,
                    55.3969138
                ],
                [
                    77.3790386,
                    55.3952721
                ],
                [
                    77.379529,
                    55.3952135
                ],
                [
                    77.3797355,
                    55.3956239
                ],
                [
                    77.3802001,
                    55.3956386
                ],
                [
                    77.3809744,
                    55.3953161
                ],
                [
                    77.380613,
                    55.3948324
                ],
                [
                    77.3790901,
                    55.3946712
                ],
                [
                    77.3778772,
                    55.3944513
                ],
                [
                    77.3764576,
                    55.3945979
                ],
                [
                    77.3762511,
                    55.3947445
                ],
                [
                    77.3765867,
                    55.3950376
                ],
                [
                    77.3752444,
                    55.3949936
                ],
                [
                    77.3751155,
                    55.3942021
                ],
                [
                    77.3740056,
                    55.3941142
                ],
                [
                    77.3735669,
                    55.3943487
                ],
                [
                    77.3734894,
                    55.394935
                ],
                [
                    77.370418,
                    55.3941288
                ]
            ],
            "longitude": 77.376068,
            "latitude": 55.396038
        },
        "9667": {
            "name": "Новокарасук",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    77.3798015,
                    53.5929667
                ],
                [
                    77.3803365,
                    53.5945189
                ],
                [
                    77.3811687,
                    53.594907
                ],
                [
                    77.3802771,
                    53.5963532
                ],
                [
                    77.380396,
                    53.5982229
                ],
                [
                    77.3851511,
                    53.5976938
                ],
                [
                    77.3891335,
                    53.5972352
                ],
                [
                    77.3890147,
                    53.59593
                ],
                [
                    77.3906195,
                    53.59593
                ],
                [
                    77.3907385,
                    53.5941309
                ],
                [
                    77.3885392,
                    53.5940956
                ],
                [
                    77.3886581,
                    53.5934959
                ],
                [
                    77.3896091,
                    53.5935311
                ],
                [
                    77.3905602,
                    53.5920141
                ],
                [
                    77.3874099,
                    53.5917672
                ],
                [
                    77.3878259,
                    53.5906029
                ],
                [
                    77.3851809,
                    53.5905147
                ],
                [
                    77.38527,
                    53.591873
                ],
                [
                    77.3849728,
                    53.59339
                ],
                [
                    77.3805148,
                    53.5920847
                ],
                [
                    77.3798015,
                    53.5929667
                ]
            ],
            "longitude": 77.385506,
            "latitude": 53.594589
        },
        "9668": {
            "name": "Танчик",
            "population": 158,
            "type": "hamlet",
            "poly": [
                [
                    77.3840369,
                    55.3328847
                ],
                [
                    77.3847001,
                    55.3329633
                ],
                [
                    77.3843684,
                    55.3341735
                ],
                [
                    77.3858331,
                    55.3343621
                ],
                [
                    77.3858054,
                    55.3346136
                ],
                [
                    77.3880159,
                    55.3348494
                ],
                [
                    77.3882924,
                    55.3335134
                ],
                [
                    77.3892319,
                    55.3329161
                ],
                [
                    77.3882924,
                    55.3322245
                ],
                [
                    77.3889556,
                    55.331863
                ],
                [
                    77.3893147,
                    55.3314229
                ],
                [
                    77.3926031,
                    55.3315015
                ],
                [
                    77.3934044,
                    55.3320202
                ],
                [
                    77.3942887,
                    55.3320988
                ],
                [
                    77.3954769,
                    55.3310928
                ],
                [
                    77.3943163,
                    55.3302597
                ],
                [
                    77.3938742,
                    55.330527
                ],
                [
                    77.3919123,
                    55.3300397
                ],
                [
                    77.392161,
                    55.3295838
                ],
                [
                    77.3918017,
                    55.3287193
                ],
                [
                    77.3909451,
                    55.3286092
                ],
                [
                    77.3910004,
                    55.3280748
                ],
                [
                    77.391028,
                    55.3268015
                ],
                [
                    77.3878779,
                    55.3265028
                ],
                [
                    77.3879331,
                    55.3258897
                ],
                [
                    77.3891766,
                    55.3258897
                ],
                [
                    77.389149,
                    55.3245377
                ],
                [
                    77.3876292,
                    55.324349
                ],
                [
                    77.3874358,
                    55.3251508
                ],
                [
                    77.3858331,
                    55.3250722
                ],
                [
                    77.3856949,
                    55.325701
                ],
                [
                    77.3872976,
                    55.3259211
                ],
                [
                    77.3873529,
                    55.3265028
                ],
                [
                    77.3853357,
                    55.3266285
                ],
                [
                    77.3851146,
                    55.3282791
                ],
                [
                    77.3847554,
                    55.3306842
                ],
                [
                    77.3855015,
                    55.3306684
                ],
                [
                    77.3849764,
                    55.3320202
                ],
                [
                    77.3841475,
                    55.332476
                ],
                [
                    77.3840369,
                    55.3328847
                ]
            ],
            "longitude": 77.388405,
            "latitude": 55.329929
        },
        "9669": {
            "name": "Александро-Невский",
            "population": 217,
            "type": "hamlet",
            "poly": [
                [
                    77.3780087,
                    54.0171465
                ],
                [
                    77.3810746,
                    54.0182473
                ],
                [
                    77.3803082,
                    54.0187477
                ],
                [
                    77.3823521,
                    54.0195482
                ],
                [
                    77.3805636,
                    54.0216997
                ],
                [
                    77.387973,
                    54.0244514
                ],
                [
                    77.3905279,
                    54.0223501
                ],
                [
                    77.3943603,
                    54.0239011
                ],
                [
                    77.3981076,
                    54.0247015
                ],
                [
                    77.4007477,
                    54.0234508
                ],
                [
                    77.403984,
                    54.0234008
                ],
                [
                    77.4083274,
                    54.0194482
                ],
                [
                    77.4052614,
                    54.0170964
                ],
                [
                    77.4006625,
                    54.0161457
                ],
                [
                    77.3982779,
                    54.0194482
                ],
                [
                    77.3958933,
                    54.019148
                ],
                [
                    77.3923164,
                    54.0180972
                ],
                [
                    77.3805636,
                    54.0139439
                ],
                [
                    77.3782642,
                    54.0158455
                ],
                [
                    77.3793713,
                    54.0161457
                ],
                [
                    77.3780087,
                    54.0171465
                ]
            ],
            "longitude": 77.392738,
            "latitude": 54.020546
        },
        "9670": {
            "name": "Яча",
            "population": 21,
            "type": "hamlet",
            "poly": [
                [
                    77.3903095,
                    55.6246297
                ],
                [
                    77.392666,
                    55.6253313
                ],
                [
                    77.392109,
                    55.6261054
                ],
                [
                    77.3935228,
                    55.6266375
                ],
                [
                    77.3940371,
                    55.6261779
                ],
                [
                    77.3974219,
                    55.6270004
                ],
                [
                    77.3983217,
                    55.626444
                ],
                [
                    77.3993499,
                    55.6252829
                ],
                [
                    77.3993499,
                    55.6232266
                ],
                [
                    77.3999926,
                    55.6226218
                ],
                [
                    77.3998641,
                    55.6216299
                ],
                [
                    77.4006353,
                    55.6210735
                ],
                [
                    77.4000355,
                    55.6189928
                ],
                [
                    77.3986644,
                    55.6176621
                ],
                [
                    77.3960937,
                    55.6172991
                ],
                [
                    77.3935228,
                    55.6194041
                ],
                [
                    77.3915092,
                    55.6235895
                ],
                [
                    77.3905237,
                    55.6234685
                ],
                [
                    77.3903095,
                    55.6246297
                ]
            ],
            "longitude": 77.397034,
            "latitude": 55.621048
        },
        "9671": {
            "name": "Нижний Баган",
            "population": 83,
            "type": "hamlet",
            "poly": [
                [
                    77.38756,
                    54.0844878
                ],
                [
                    77.3888935,
                    54.0847616
                ],
                [
                    77.38776,
                    54.0858566
                ],
                [
                    77.3918937,
                    54.087108
                ],
                [
                    77.4035612,
                    54.0894935
                ],
                [
                    77.4041612,
                    54.088203
                ],
                [
                    77.406028,
                    54.0884768
                ],
                [
                    77.4094949,
                    54.0877729
                ],
                [
                    77.4048946,
                    54.0838621
                ],
                [
                    77.4031611,
                    54.0843314
                ],
                [
                    77.3982274,
                    54.0839403
                ],
                [
                    77.3967602,
                    54.0855681
                ],
                [
                    77.389933,
                    54.0835424
                ],
                [
                    77.3893601,
                    54.084175
                ],
                [
                    77.3880934,
                    54.0839012
                ],
                [
                    77.38756,
                    54.0844878
                ]
            ],
            "longitude": 77.40136,
            "latitude": 54.086639
        },
        "9672": {
            "name": "Первомайский",
            "population": 166,
            "type": "hamlet",
            "poly": [
                [
                    77.4163281,
                    54.151064
                ],
                [
                    77.4210887,
                    54.1517868
                ],
                [
                    77.4302574,
                    54.1520966
                ],
                [
                    77.4337838,
                    54.1505477
                ],
                [
                    77.4341364,
                    54.1472948
                ],
                [
                    77.4313153,
                    54.1468301
                ],
                [
                    77.4309627,
                    54.1474497
                ],
                [
                    77.4170333,
                    54.1487406
                ],
                [
                    77.4163281,
                    54.151064
                ]
            ],
            "longitude": 77.425499,
            "latitude": 54.150032
        },
        "9673": {
            "name": "Искра",
            "population": 62,
            "type": "hamlet",
            "poly": [
                [
                    77.4123277,
                    54.428624
                ],
                [
                    77.4161552,
                    54.4292219
                ],
                [
                    77.41573,
                    54.4303764
                ],
                [
                    77.4188133,
                    54.431036
                ],
                [
                    77.4328123,
                    54.4330563
                ],
                [
                    77.4337338,
                    54.4311185
                ],
                [
                    77.4352576,
                    54.4312422
                ],
                [
                    77.435683,
                    54.4302733
                ],
                [
                    77.4329541,
                    54.4292219
                ],
                [
                    77.4262204,
                    54.4285622
                ],
                [
                    77.4211878,
                    54.4279437
                ],
                [
                    77.4124694,
                    54.426954
                ],
                [
                    77.4123277,
                    54.428624
                ]
            ],
            "longitude": 77.426544,
            "latitude": 54.430435
        },
        "9674": {
            "name": "Обгонный Пункт Районная",
            "population": 204,
            "type": "hamlet",
            "poly": [
                [
                    77.4247217,
                    53.7817083
                ],
                [
                    77.4248987,
                    53.7826239
                ],
                [
                    77.4286178,
                    53.7827547
                ],
                [
                    77.4286178,
                    53.7831471
                ],
                [
                    77.43092,
                    53.7832517
                ],
                [
                    77.4310085,
                    53.7827808
                ],
                [
                    77.4332663,
                    53.7828855
                ],
                [
                    77.4331336,
                    53.7833563
                ],
                [
                    77.4355244,
                    53.783461
                ],
                [
                    77.4354801,
                    53.7829116
                ],
                [
                    77.4341519,
                    53.7828593
                ],
                [
                    77.433532,
                    53.7814729
                ],
                [
                    77.4280865,
                    53.7813159
                ],
                [
                    77.4281308,
                    53.7817345
                ],
                [
                    77.4247217,
                    53.7817083
                ]
            ],
            "longitude": 77.430077,
            "latitude": 53.782181
        },
        "9675": {
            "name": "Мальково",
            "population": 218,
            "type": "hamlet",
            "poly": [
                [
                    77.4276211,
                    54.5777246
                ],
                [
                    77.4276211,
                    54.5781174
                ],
                [
                    77.4300604,
                    54.5791777
                ],
                [
                    77.429349,
                    54.5800024
                ],
                [
                    77.4377851,
                    54.5827514
                ],
                [
                    77.4430028,
                    54.5851664
                ],
                [
                    77.4479832,
                    54.5862462
                ],
                [
                    77.4502193,
                    54.5837331
                ],
                [
                    77.4496094,
                    54.5823391
                ],
                [
                    77.4435448,
                    54.5802381
                ],
                [
                    77.4340583,
                    54.5776461
                ],
                [
                    77.4321609,
                    54.5771551
                ],
                [
                    77.431043,
                    54.5781174
                ],
                [
                    77.4288069,
                    54.5773908
                ],
                [
                    77.4276211,
                    54.5777246
                ]
            ],
            "longitude": 77.445335,
            "latitude": 54.582111
        },
        "9676": {
            "name": "Казарма 150 км",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.450775,
            "latitude": 54.230797
        },
        "9677": {
            "name": "Шейнфельд",
            "population": 61,
            "type": "hamlet",
            "poly": [
                [
                    77.4457003,
                    53.6810183
                ],
                [
                    77.4491107,
                    53.681834
                ],
                [
                    77.4499632,
                    53.6810183
                ],
                [
                    77.4563249,
                    53.6819894
                ],
                [
                    77.457571,
                    53.6798529
                ],
                [
                    77.4565217,
                    53.6796587
                ],
                [
                    77.4568496,
                    53.6789983
                ],
                [
                    77.4472743,
                    53.6772891
                ],
                [
                    77.447012,
                    53.6787653
                ],
                [
                    77.4457003,
                    53.6810183
                ]
            ],
            "longitude": 77.451599,
            "latitude": 53.679932
        },
        "9678": {
            "name": "Тимофеевка",
            "population": 102,
            "type": "hamlet",
            "poly": [
                [
                    77.4482914,
                    56.1484243
                ],
                [
                    77.450541,
                    56.1521704
                ],
                [
                    77.4556967,
                    56.1505294
                ],
                [
                    77.4582746,
                    56.150588
                ],
                [
                    77.4591269,
                    56.1531034
                ],
                [
                    77.474514,
                    56.1523162
                ],
                [
                    77.4725411,
                    56.1485616
                ],
                [
                    77.4569227,
                    56.1459515
                ],
                [
                    77.4482914,
                    56.1484243
                ]
            ],
            "longitude": 77.459404,
            "latitude": 56.1492
        },
        "9679": {
            "name": "151 км",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.4644118,
            "latitude": 54.223598
        },
        "9680": {
            "name": "Сергино",
            "population": 133,
            "type": "hamlet",
            "poly": [
                [
                    77.4870193,
                    55.4698408
                ],
                [
                    77.4870686,
                    55.4705393
                ],
                [
                    77.488991,
                    55.4710702
                ],
                [
                    77.4893853,
                    55.4708746
                ],
                [
                    77.4900262,
                    55.4714055
                ],
                [
                    77.4895332,
                    55.4719084
                ],
                [
                    77.491012,
                    55.472523
                ],
                [
                    77.4933781,
                    55.4728304
                ],
                [
                    77.4944132,
                    55.4720201
                ],
                [
                    77.4966314,
                    55.4723833
                ],
                [
                    77.4978637,
                    55.4730539
                ],
                [
                    77.5001311,
                    55.4732774
                ],
                [
                    77.5029408,
                    55.474339
                ],
                [
                    77.5035816,
                    55.4742552
                ],
                [
                    77.5047154,
                    55.4747022
                ],
                [
                    77.5041238,
                    55.4751213
                ],
                [
                    77.5049618,
                    55.4762108
                ],
                [
                    77.5065885,
                    55.4765181
                ],
                [
                    77.5076236,
                    55.4759035
                ],
                [
                    77.5090038,
                    55.4766299
                ],
                [
                    77.5082644,
                    55.4773562
                ],
                [
                    77.5095953,
                    55.4780825
                ],
                [
                    77.5091024,
                    55.4785854
                ],
                [
                    77.5100883,
                    55.4795351
                ],
                [
                    77.5111727,
                    55.4796748
                ],
                [
                    77.5117642,
                    55.4789765
                ],
                [
                    77.5104333,
                    55.4772724
                ],
                [
                    77.5093982,
                    55.4757638
                ],
                [
                    77.5069335,
                    55.474814
                ],
                [
                    77.5072293,
                    55.4743949
                ],
                [
                    77.5035323,
                    55.4721598
                ],
                [
                    77.5017085,
                    55.4717128
                ],
                [
                    77.5001311,
                    55.4720481
                ],
                [
                    77.4996874,
                    55.4723833
                ],
                [
                    77.4956948,
                    55.4717128
                ],
                [
                    77.4958427,
                    55.4713216
                ],
                [
                    77.4905191,
                    55.4700643
                ],
                [
                    77.489698,
                    55.4693254
                ],
                [
                    77.4879559,
                    55.4696452
                ],
                [
                    77.4870193,
                    55.4698408
                ]
            ],
            "longitude": 77.502121,
            "latitude": 55.473053
        },
        "9681": {
            "name": "Заливной Луг",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.508789,
            "latitude": 55.651829
        },
        "9682": {
            "name": "Водино",
            "population": 198,
            "type": "hamlet",
            "poly": [
                [
                    77.5077273,
                    54.0162833
                ],
                [
                    77.5098257,
                    54.0217578
                ],
                [
                    77.5133466,
                    54.0264168
                ],
                [
                    77.5140579,
                    54.0264168
                ],
                [
                    77.5147692,
                    54.026187
                ],
                [
                    77.5156228,
                    54.0253305
                ],
                [
                    77.5156566,
                    54.022412
                ],
                [
                    77.5157545,
                    54.0217261
                ],
                [
                    77.5151604,
                    54.0207758
                ],
                [
                    77.5148759,
                    54.0194594
                ],
                [
                    77.5152671,
                    54.0193968
                ],
                [
                    77.5150893,
                    54.0191042
                ],
                [
                    77.5155161,
                    54.0190416
                ],
                [
                    77.5152315,
                    54.0182684
                ],
                [
                    77.5148403,
                    54.0183729
                ],
                [
                    77.5147692,
                    54.0179968
                ],
                [
                    77.5182901,
                    54.0178923
                ],
                [
                    77.5180767,
                    54.0162624
                ],
                [
                    77.5077273,
                    54.0162833
                ]
            ],
            "longitude": 77.512711,
            "latitude": 54.020096
        },
        "9683": {
            "name": "Макаровка",
            "population": 62,
            "type": "hamlet",
            "poly": [
                [
                    77.5067622,
                    56.6322294
                ],
                [
                    77.5077315,
                    56.6342593
                ],
                [
                    77.5099682,
                    56.6345463
                ],
                [
                    77.5103783,
                    56.6335622
                ],
                [
                    77.5125406,
                    56.6336032
                ],
                [
                    77.5124287,
                    56.6342798
                ],
                [
                    77.5174988,
                    56.6354485
                ],
                [
                    77.5205184,
                    56.6353049
                ],
                [
                    77.5223452,
                    56.6332546
                ],
                [
                    77.5252903,
                    56.6328445
                ],
                [
                    77.5252903,
                    56.6322294
                ],
                [
                    77.5196983,
                    56.6309376
                ],
                [
                    77.5152993,
                    56.6297688
                ],
                [
                    77.5108257,
                    56.6297688
                ],
                [
                    77.5074705,
                    56.630302
                ],
                [
                    77.5067622,
                    56.6322294
                ]
            ],
            "longitude": 77.5149,
            "latitude": 56.632576
        },
        "9684": {
            "name": "Демидовка",
            "population": 25,
            "type": "hamlet",
            "poly": [
                [
                    77.5124717,
                    53.5338619
                ],
                [
                    77.5129644,
                    53.5357945
                ],
                [
                    77.5136541,
                    53.5371415
                ],
                [
                    77.5149351,
                    53.5377271
                ],
                [
                    77.5213401,
                    53.5383127
                ],
                [
                    77.5257743,
                    53.5384884
                ],
                [
                    77.5260699,
                    53.5353846
                ],
                [
                    77.5218328,
                    53.5349746
                ],
                [
                    77.5217343,
                    53.533042
                ],
                [
                    77.5203547,
                    53.5329248
                ],
                [
                    77.519862,
                    53.5336276
                ],
                [
                    77.5152307,
                    53.533042
                ],
                [
                    77.5149351,
                    53.5342133
                ],
                [
                    77.5124717,
                    53.5338619
                ]
            ],
            "longitude": 77.519371,
            "latitude": 53.535912
        },
        "9685": {
            "name": "Красный Хутор",
            "population": 47,
            "type": "hamlet",
            "poly": [
                [
                    77.5165123,
                    54.4569561
                ],
                [
                    77.5183836,
                    54.4580109
                ],
                [
                    77.5233452,
                    54.4593788
                ],
                [
                    77.5256134,
                    54.4593788
                ],
                [
                    77.5264356,
                    54.4589998
                ],
                [
                    77.5269744,
                    54.4592305
                ],
                [
                    77.5266625,
                    54.4594612
                ],
                [
                    77.5278816,
                    54.4599557
                ],
                [
                    77.5276265,
                    54.4605489
                ],
                [
                    77.5317376,
                    54.4619003
                ],
                [
                    77.5329284,
                    54.4609774
                ],
                [
                    77.5345728,
                    54.4615542
                ],
                [
                    77.53531,
                    54.4603677
                ],
                [
                    77.5295828,
                    54.4583735
                ],
                [
                    77.5276547,
                    54.4579779
                ],
                [
                    77.5245077,
                    54.4569231
                ],
                [
                    77.5224096,
                    54.4560661
                ],
                [
                    77.5203966,
                    54.4556211
                ],
                [
                    77.5177882,
                    54.4547145
                ],
                [
                    77.5167675,
                    54.4558518
                ],
                [
                    77.5165123,
                    54.4569561
                ]
            ],
            "longitude": 77.527771,
            "latitude": 54.459072
        },
        "9686": {
            "name": "Назарово",
            "population": 66,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.551079,
            "latitude": 55.666454
        },
        "9687": {
            "name": "Антошкино",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.558159,
            "latitude": 55.54488
        },
        "9688": {
            "name": "Ясная Поляна",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.5706289,
                    53.9987053
                ],
                [
                    77.5733924,
                    53.9994462
                ],
                [
                    77.5776588,
                    53.9983063
                ],
                [
                    77.5811494,
                    53.9934044
                ],
                [
                    77.5786769,
                    53.9926349
                ],
                [
                    77.5793556,
                    53.9915518
                ],
                [
                    77.5767376,
                    53.9908392
                ],
                [
                    77.5759134,
                    53.9912953
                ],
                [
                    77.5706289,
                    53.9987053
                ]
            ],
            "longitude": 77.576012,
            "latitude": 53.995941
        },
        "9689": {
            "name": "Пучинное",
            "population": 26,
            "type": "hamlet",
            "poly": [
                [
                    77.5800286,
                    53.7605486
                ],
                [
                    77.5801749,
                    53.7655186
                ],
                [
                    77.5805404,
                    53.7663397
                ],
                [
                    77.5858043,
                    53.7663829
                ],
                [
                    77.5854388,
                    53.7613698
                ],
                [
                    77.5806135,
                    53.7602029
                ],
                [
                    77.5800286,
                    53.7605486
                ]
            ],
            "longitude": 77.582077,
            "latitude": 53.76392
        },
        "9690": {
            "name": "Луганск",
            "population": 101,
            "type": "hamlet",
            "poly": [
                [
                    77.5933826,
                    53.6237179
                ],
                [
                    77.594035,
                    53.6248141
                ],
                [
                    77.5968618,
                    53.6262972
                ],
                [
                    77.5994712,
                    53.6245562
                ],
                [
                    77.6007757,
                    53.6229441
                ],
                [
                    77.604255,
                    53.6186235
                ],
                [
                    77.6019718,
                    53.6179141
                ],
                [
                    77.6013195,
                    53.6184945
                ],
                [
                    77.5990363,
                    53.6183655
                ],
                [
                    77.5972967,
                    53.6205582
                ],
                [
                    77.5967531,
                    53.6217189
                ],
                [
                    77.5950134,
                    53.6211385
                ],
                [
                    77.5936001,
                    53.6223638
                ],
                [
                    77.5933826,
                    53.6237179
                ]
            ],
            "longitude": 77.599037,
            "latitude": 53.622169
        },
        "9691": {
            "name": "Тычкино",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    77.6036656,
                    56.2008292
                ],
                [
                    77.6124696,
                    56.200579
                ],
                [
                    77.6109787,
                    56.1961817
                ],
                [
                    77.6085111,
                    56.1954094
                ],
                [
                    77.6074828,
                    56.1901176
                ],
                [
                    77.6040255,
                    56.190561
                ],
                [
                    77.6036656,
                    56.2008292
                ]
            ],
            "longitude": 77.607452,
            "latitude": 56.196781
        },
        "9692": {
            "name": "Первомайский",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.6270207,
                    53.4519709
                ],
                [
                    77.6275846,
                    53.452441
                ],
                [
                    77.6290508,
                    53.4522395
                ],
                [
                    77.6299531,
                    53.4531798
                ],
                [
                    77.6282613,
                    53.4534484
                ],
                [
                    77.628938,
                    53.4545901
                ],
                [
                    77.6304042,
                    53.4541872
                ],
                [
                    77.6315321,
                    53.4570078
                ],
                [
                    77.6319831,
                    53.458418
                ],
                [
                    77.6327727,
                    53.459761
                ],
                [
                    77.6344645,
                    53.459291
                ],
                [
                    77.6350284,
                    53.4603654
                ],
                [
                    77.6375097,
                    53.4600296
                ],
                [
                    77.6366074,
                    53.4588209
                ],
                [
                    77.6353667,
                    53.4590895
                ],
                [
                    77.6290508,
                    53.4506947
                ],
                [
                    77.6276974,
                    53.4510977
                ],
                [
                    77.6284869,
                    53.4517694
                ],
                [
                    77.6270207,
                    53.4519709
                ]
            ],
            "longitude": 77.633446,
            "latitude": 53.458889
        },
        "9693": {
            "name": "Михайловка 2-я",
            "population": 66,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.638176,
            "latitude": 55.846142
        },
        "9694": {
            "name": "Медведкино",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.638298,
            "latitude": 55.599941
        },
        "9695": {
            "name": "Ленинское",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.6327431,
                    53.9549857
                ],
                [
                    77.6362733,
                    53.9565163
                ],
                [
                    77.638503,
                    53.9555324
                ],
                [
                    77.643055,
                    53.956243
                ],
                [
                    77.6485361,
                    53.9566803
                ],
                [
                    77.6503012,
                    53.9546578
                ],
                [
                    77.6491864,
                    53.9543298
                ],
                [
                    77.6500225,
                    53.9529631
                ],
                [
                    77.6422189,
                    53.9508311
                ],
                [
                    77.6412899,
                    53.9519245
                ],
                [
                    77.640175,
                    53.9520338
                ],
                [
                    77.6389675,
                    53.9510498
                ],
                [
                    77.6361805,
                    53.9532911
                ],
                [
                    77.6344154,
                    53.9530178
                ],
                [
                    77.6327431,
                    53.9549857
                ]
            ],
            "longitude": 77.642868,
            "latitude": 53.954166
        },
        "9696": {
            "name": "Приомский",
            "population": 204,
            "type": "hamlet",
            "poly": [
                [
                    77.6456802,
                    55.4106969
                ],
                [
                    77.6479063,
                    55.4107884
                ],
                [
                    77.6479063,
                    55.4119972
                ],
                [
                    77.6520037,
                    55.4121071
                ],
                [
                    77.6519713,
                    55.4110632
                ],
                [
                    77.6526167,
                    55.4109166
                ],
                [
                    77.6546168,
                    55.4121437
                ],
                [
                    77.6563591,
                    55.4121804
                ],
                [
                    77.6567463,
                    55.4111914
                ],
                [
                    77.6555525,
                    55.4109166
                ],
                [
                    77.6565527,
                    55.4090668
                ],
                [
                    77.6562623,
                    55.4081327
                ],
                [
                    77.6574561,
                    55.406649
                ],
                [
                    77.6548105,
                    55.4060995
                ],
                [
                    77.6553913,
                    55.4051836
                ],
                [
                    77.6511003,
                    55.4032052
                ],
                [
                    77.6482935,
                    55.4031686
                ],
                [
                    77.6463577,
                    55.4034434
                ],
                [
                    77.6456802,
                    55.4106969
                ]
            ],
            "longitude": 77.6508483,
            "latitude": 55.4081422
        },
        "9697": {
            "name": "Осиновка",
            "population": 141,
            "type": "hamlet",
            "poly": [
                [
                    77.6478333,
                    53.6920779
                ],
                [
                    77.6491907,
                    53.6924798
                ],
                [
                    77.6501603,
                    53.6917908
                ],
                [
                    77.6526813,
                    53.6927668
                ],
                [
                    77.653457,
                    53.6917908
                ],
                [
                    77.6551053,
                    53.6920205
                ],
                [
                    77.6572384,
                    53.6896665
                ],
                [
                    77.6568506,
                    53.6870253
                ],
                [
                    77.6550083,
                    53.6862214
                ],
                [
                    77.6543296,
                    53.6881737
                ],
                [
                    77.6494816,
                    53.6883459
                ],
                [
                    77.6522935,
                    53.6907574
                ],
                [
                    77.6488029,
                    53.6911593
                ],
                [
                    77.6478333,
                    53.6920779
                ]
            ],
            "longitude": 77.654236,
            "latitude": 53.69001
        },
        "9698": {
            "name": "Басково",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    77.6480358,
                    54.4634366
                ],
                [
                    77.649358,
                    54.4634958
                ],
                [
                    77.6502394,
                    54.4631608
                ],
                [
                    77.6531888,
                    54.4634366
                ],
                [
                    77.6543415,
                    54.4635155
                ],
                [
                    77.6547144,
                    54.4641854
                ],
                [
                    77.65624,
                    54.4645598
                ],
                [
                    77.6573248,
                    54.4646386
                ],
                [
                    77.6576977,
                    54.4641657
                ],
                [
                    77.6593928,
                    54.4645992
                ],
                [
                    77.6606472,
                    54.4635352
                ],
                [
                    77.6572909,
                    54.4625893
                ],
                [
                    77.6569858,
                    54.4609341
                ],
                [
                    77.6564773,
                    54.4606582
                ],
                [
                    77.6561383,
                    54.4607174
                ],
                [
                    77.6554941,
                    54.4613085
                ],
                [
                    77.6532566,
                    54.4606582
                ],
                [
                    77.6504427,
                    54.4602838
                ],
                [
                    77.6491207,
                    54.4615253
                ],
                [
                    77.6481036,
                    54.4624317
                ],
                [
                    77.6480358,
                    54.4634366
                ]
            ],
            "longitude": 77.654884,
            "latitude": 54.463062
        },
        "9699": {
            "name": "Караси",
            "population": 115,
            "type": "hamlet",
            "poly": [
                [
                    77.6504689,
                    54.0694139
                ],
                [
                    77.6510956,
                    54.0709168
                ],
                [
                    77.6519129,
                    54.0724675
                ],
                [
                    77.6523761,
                    54.0739222
                ],
                [
                    77.6521581,
                    54.0767197
                ],
                [
                    77.6532207,
                    54.0766877
                ],
                [
                    77.6532752,
                    54.0769754
                ],
                [
                    77.6528393,
                    54.077439
                ],
                [
                    77.6528937,
                    54.0778705
                ],
                [
                    77.654583,
                    54.0777107
                ],
                [
                    77.6543922,
                    54.0771512
                ],
                [
                    77.6553731,
                    54.0770393
                ],
                [
                    77.6556183,
                    54.0767037
                ],
                [
                    77.6577434,
                    54.0759364
                ],
                [
                    77.6590784,
                    54.0757286
                ],
                [
                    77.6609038,
                    54.0750092
                ],
                [
                    77.661258,
                    54.0747695
                ],
                [
                    77.6617757,
                    54.0760483
                ],
                [
                    77.6638463,
                    54.0758565
                ],
                [
                    77.6633287,
                    54.0744178
                ],
                [
                    77.6635739,
                    54.0739862
                ],
                [
                    77.6634921,
                    54.0732828
                ],
                [
                    77.6632197,
                    54.0728831
                ],
                [
                    77.6627565,
                    54.0728831
                ],
                [
                    77.6622389,
                    54.071812
                ],
                [
                    77.6610946,
                    54.0719879
                ],
                [
                    77.6612035,
                    54.0723396
                ],
                [
                    77.6601137,
                    54.0724994
                ],
                [
                    77.6590239,
                    54.0697017
                ],
                [
                    77.6580159,
                    54.069286
                ],
                [
                    77.6574437,
                    54.0687744
                ],
                [
                    77.6557,
                    54.068039
                ],
                [
                    77.654147,
                    54.0664561
                ],
                [
                    77.652703,
                    54.0670157
                ],
                [
                    77.6533842,
                    54.0681029
                ],
                [
                    77.6528937,
                    54.0683268
                ],
                [
                    77.6520219,
                    54.0683428
                ],
                [
                    77.6522126,
                    54.0691102
                ],
                [
                    77.6504689,
                    54.0694139
                ]
            ],
            "longitude": 77.656296,
            "latitude": 54.072723
        },
        "9700": {
            "name": "Шагир",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.659882,
            "latitude": 55.797153
        },
        "9701": {
            "name": "Бочаниха",
            "population": 164,
            "type": "hamlet",
            "poly": [
                [
                    77.6595107,
                    54.1833654
                ],
                [
                    77.6612334,
                    54.184115
                ],
                [
                    77.668124,
                    54.1852523
                ],
                [
                    77.6696258,
                    54.1856659
                ],
                [
                    77.6719226,
                    54.1860019
                ],
                [
                    77.6755004,
                    54.1860277
                ],
                [
                    77.674617,
                    54.186829
                ],
                [
                    77.6680798,
                    54.186493
                ],
                [
                    77.6672405,
                    54.1880695
                ],
                [
                    77.6673731,
                    54.1887157
                ],
                [
                    77.668124,
                    54.1895427
                ],
                [
                    77.669184,
                    54.1899045
                ],
                [
                    77.67073,
                    54.1899045
                ],
                [
                    77.6724526,
                    54.1894652
                ],
                [
                    77.6765604,
                    54.1879403
                ],
                [
                    77.6770464,
                    54.1869582
                ],
                [
                    77.6825677,
                    54.1870616
                ],
                [
                    77.6840695,
                    54.1872425
                ],
                [
                    77.6845553,
                    54.1860794
                ],
                [
                    77.6838486,
                    54.1859243
                ],
                [
                    77.6847762,
                    54.1839341
                ],
                [
                    77.6834511,
                    54.1838049
                ],
                [
                    77.6837603,
                    54.1833396
                ],
                [
                    77.6831861,
                    54.1832362
                ],
                [
                    77.6834511,
                    54.1829002
                ],
                [
                    77.6827444,
                    54.1827451
                ],
                [
                    77.6820376,
                    54.1834947
                ],
                [
                    77.6810217,
                    54.1828743
                ],
                [
                    77.6812426,
                    54.18259
                ],
                [
                    77.6805358,
                    54.1824607
                ],
                [
                    77.6797849,
                    54.1833396
                ],
                [
                    77.6781506,
                    54.1826158
                ],
                [
                    77.6760746,
                    54.1824607
                ],
                [
                    77.6751471,
                    54.1821247
                ],
                [
                    77.674617,
                    54.1827709
                ],
                [
                    77.672541,
                    54.1820213
                ],
                [
                    77.6688307,
                    54.1819179
                ],
                [
                    77.6685657,
                    54.1815043
                ],
                [
                    77.666313,
                    54.18122
                ],
                [
                    77.6664455,
                    54.1807288
                ],
                [
                    77.6660038,
                    54.1806513
                ],
                [
                    77.6655179,
                    54.1813234
                ],
                [
                    77.6649437,
                    54.1811941
                ],
                [
                    77.6649437,
                    54.1808064
                ],
                [
                    77.6623818,
                    54.1804703
                ],
                [
                    77.6617634,
                    54.1808581
                ],
                [
                    77.6600055,
                    54.1804131
                ],
                [
                    77.6599966,
                    54.1819955
                ],
                [
                    77.6595107,
                    54.1833654
                ]
            ],
            "longitude": 77.672806,
            "latitude": 54.18409
        },
        "9702": {
            "name": "Новоникольское",
            "population": 82,
            "type": "hamlet",
            "poly": [
                [
                    77.6709634,
                    56.219339
                ],
                [
                    77.672217,
                    56.2201953
                ],
                [
                    77.6755121,
                    56.2228239
                ],
                [
                    77.6763001,
                    56.2235806
                ],
                [
                    77.6766224,
                    56.2246757
                ],
                [
                    77.6775895,
                    56.2248749
                ],
                [
                    77.6790221,
                    56.2258903
                ],
                [
                    77.6835709,
                    56.2246558
                ],
                [
                    77.6842156,
                    56.2232819
                ],
                [
                    77.6837858,
                    56.2231027
                ],
                [
                    77.6848603,
                    56.2221269
                ],
                [
                    77.6857557,
                    56.2218083
                ],
                [
                    77.685111,
                    56.2198767
                ],
                [
                    77.6827112,
                    56.2203347
                ],
                [
                    77.6820666,
                    56.2189805
                ],
                [
                    77.6779835,
                    56.2199364
                ],
                [
                    77.6777327,
                    56.2191398
                ],
                [
                    77.6768731,
                    56.2190602
                ],
                [
                    77.6773745,
                    56.2187615
                ],
                [
                    77.6772313,
                    56.2176661
                ],
                [
                    77.6748316,
                    56.2179848
                ],
                [
                    77.6740436,
                    56.2176462
                ],
                [
                    77.6720021,
                    56.2184627
                ],
                [
                    77.6709634,
                    56.219339
                ]
            ],
            "longitude": 77.679092,
            "latitude": 56.222008
        },
        "9703": {
            "name": "Таганово",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.693771,
            "latitude": 55.680664
        },
        "9704": {
            "name": "Гнедухино",
            "population": 172,
            "type": "hamlet",
            "poly": [
                [
                    77.6904316,
                    54.1624044
                ],
                [
                    77.6920924,
                    54.1629423
                ],
                [
                    77.6924458,
                    54.1626733
                ],
                [
                    77.6939653,
                    54.1631906
                ],
                [
                    77.6956614,
                    54.1635216
                ],
                [
                    77.6955907,
                    54.1637698
                ],
                [
                    77.6985237,
                    54.164618
                ],
                [
                    77.703294,
                    54.1651559
                ],
                [
                    77.7032389,
                    54.1653471
                ],
                [
                    77.7059347,
                    54.1657284
                ],
                [
                    77.7064051,
                    54.1648281
                ],
                [
                    77.7068755,
                    54.1646162
                ],
                [
                    77.7076534,
                    54.164701
                ],
                [
                    77.7082867,
                    54.1637477
                ],
                [
                    77.7070745,
                    54.1629638
                ],
                [
                    77.7053557,
                    54.1627837
                ],
                [
                    77.7013573,
                    54.1620634
                ],
                [
                    77.6998376,
                    54.1619045
                ],
                [
                    77.6993853,
                    54.162127
                ],
                [
                    77.6985892,
                    54.1617244
                ],
                [
                    77.6979379,
                    54.1614914
                ],
                [
                    77.6974132,
                    54.1614172
                ],
                [
                    77.6972866,
                    54.1615444
                ],
                [
                    77.6958211,
                    54.1610783
                ],
                [
                    77.6959659,
                    54.1608452
                ],
                [
                    77.6933063,
                    54.1599766
                ],
                [
                    77.6923112,
                    54.1600083
                ],
                [
                    77.6920941,
                    54.1602202
                ],
                [
                    77.6918228,
                    54.161163
                ],
                [
                    77.6904316,
                    54.1624044
                ]
            ],
            "longitude": 77.699135,
            "latitude": 54.163223
        },
        "9705": {
            "name": "Кусган",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    77.7037892,
                    53.7900314
                ],
                [
                    77.7054804,
                    53.7917666
                ],
                [
                    77.7071715,
                    53.7921346
                ],
                [
                    77.7077946,
                    53.7899789
                ],
                [
                    77.7037892,
                    53.7900314
                ]
            ],
            "longitude": 77.7061,
            "latitude": 53.790558
        },
        "9706": {
            "name": "Большие Кулики",
            "population": 151,
            "type": "hamlet",
            "poly": [
                [
                    77.7088334,
                    56.2835415
                ],
                [
                    77.7115184,
                    56.284119
                ],
                [
                    77.7141699,
                    56.2843239
                ],
                [
                    77.7140692,
                    56.2846965
                ],
                [
                    77.7149754,
                    56.2851809
                ],
                [
                    77.7165864,
                    56.285125
                ],
                [
                    77.7190029,
                    56.284771
                ],
                [
                    77.7198419,
                    56.2837278
                ],
                [
                    77.7193385,
                    56.2836533
                ],
                [
                    77.7196405,
                    56.2830571
                ],
                [
                    77.7214865,
                    56.2830012
                ],
                [
                    77.7251448,
                    56.2825541
                ],
                [
                    77.7248092,
                    56.2797594
                ],
                [
                    77.7242386,
                    56.278567
                ],
                [
                    77.7203118,
                    56.2785483
                ],
                [
                    77.7192714,
                    56.2784552
                ],
                [
                    77.7170562,
                    56.2777844
                ],
                [
                    77.7167542,
                    56.2771881
                ],
                [
                    77.7124246,
                    56.2755857
                ],
                [
                    77.711619,
                    56.2762565
                ],
                [
                    77.7123575,
                    56.2766291
                ],
                [
                    77.7114177,
                    56.2778962
                ],
                [
                    77.7129952,
                    56.2785856
                ],
                [
                    77.7130959,
                    56.279424
                ],
                [
                    77.7099074,
                    56.2821069
                ],
                [
                    77.710478,
                    56.282256
                ],
                [
                    77.7088334,
                    56.2835415
                ]
            ],
            "longitude": 77.71698,
            "latitude": 56.28093
        },
        "9707": {
            "name": "Алексеевка",
            "population": 89,
            "type": "hamlet",
            "poly": [
                [
                    77.7250877,
                    56.3139667
                ],
                [
                    77.7258559,
                    56.3141633
                ],
                [
                    77.7256392,
                    56.3144583
                ],
                [
                    77.7268013,
                    56.3148952
                ],
                [
                    77.7264271,
                    56.3153322
                ],
                [
                    77.7276483,
                    56.3160641
                ],
                [
                    77.73273,
                    56.3178884
                ],
                [
                    77.7335769,
                    56.316796
                ],
                [
                    77.7352905,
                    56.3171674
                ],
                [
                    77.7363168,
                    56.316352
                ],
                [
                    77.7370435,
                    56.3152776
                ],
                [
                    77.7376344,
                    56.3153759
                ],
                [
                    77.7380283,
                    56.3146768
                ],
                [
                    77.7367875,
                    56.3142944
                ],
                [
                    77.7362556,
                    56.3147969
                ],
                [
                    77.7344436,
                    56.3141633
                ],
                [
                    77.7343451,
                    56.313923
                ],
                [
                    77.7335966,
                    56.3137154
                ],
                [
                    77.7332027,
                    56.3140978
                ],
                [
                    77.732336,
                    56.3137919
                ],
                [
                    77.7307406,
                    56.3138356
                ],
                [
                    77.7292831,
                    56.3132238
                ],
                [
                    77.7276876,
                    56.3126994
                ],
                [
                    77.7278452,
                    56.3124481
                ],
                [
                    77.7267816,
                    56.3120985
                ],
                [
                    77.7262042,
                    56.3130514
                ],
                [
                    77.7254816,
                    56.312896
                ],
                [
                    77.7251271,
                    56.3131364
                ],
                [
                    77.7250877,
                    56.3139667
                ]
            ],
            "longitude": 77.730072,
            "latitude": 56.315224
        },
        "9708": {
            "name": "Токпан",
            "population": 58,
            "type": "hamlet",
            "poly": [
                [
                    77.7564091,
                    53.4997394
                ],
                [
                    77.7613183,
                    53.5004532
                ],
                [
                    77.7655729,
                    53.5009723
                ],
                [
                    77.768082,
                    53.4995447
                ],
                [
                    77.7690638,
                    53.4983118
                ],
                [
                    77.7667729,
                    53.4974033
                ],
                [
                    77.7615364,
                    53.4959756
                ],
                [
                    77.7592455,
                    53.4957809
                ],
                [
                    77.7564091,
                    53.4997394
                ]
            ],
            "longitude": 77.761642,
            "latitude": 53.498245
        },
        "9709": {
            "name": "Воскресенка",
            "population": 270,
            "type": "hamlet",
            "poly": [
                [
                    77.7569938,
                    53.9119831
                ],
                [
                    77.759973,
                    53.9120426
                ],
                [
                    77.759771,
                    53.9141245
                ],
                [
                    77.7658807,
                    53.9144516
                ],
                [
                    77.7659312,
                    53.9171876
                ],
                [
                    77.7694153,
                    53.9172174
                ],
                [
                    77.7689103,
                    53.9134107
                ],
                [
                    77.7686073,
                    53.9125185
                ],
                [
                    77.7683044,
                    53.9110908
                ],
                [
                    77.7662847,
                    53.9108231
                ],
                [
                    77.7663351,
                    53.9091575
                ],
                [
                    77.7683044,
                    53.9092467
                ],
                [
                    77.7689608,
                    53.9089196
                ],
                [
                    77.7691123,
                    53.9078488
                ],
                [
                    77.7685568,
                    53.9073133
                ],
                [
                    77.7673955,
                    53.9072241
                ],
                [
                    77.767345,
                    53.9060343
                ],
                [
                    77.7685568,
                    53.906064
                ],
                [
                    77.7692638,
                    53.9057368
                ],
                [
                    77.7691628,
                    53.9047254
                ],
                [
                    77.7705766,
                    53.9046064
                ],
                [
                    77.7704251,
                    53.9027025
                ],
                [
                    77.7692638,
                    53.902881
                ],
                [
                    77.76785,
                    53.9024348
                ],
                [
                    77.7606294,
                    53.9022861
                ],
                [
                    77.7606799,
                    53.903595
                ],
                [
                    77.7592156,
                    53.9035652
                ],
                [
                    77.7592156,
                    53.9044577
                ],
                [
                    77.7584582,
                    53.9044279
                ],
                [
                    77.7584077,
                    53.9047849
                ],
                [
                    77.7574987,
                    53.9047849
                ],
                [
                    77.7569938,
                    53.9119831
                ]
            ],
            "longitude": 77.762703,
            "latitude": 53.90657
        },
        "9710": {
            "name": "Остановочная Платформа 2997",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    77.7613307,
                    55.3563268
                ],
                [
                    77.7613676,
                    55.3576949
                ],
                [
                    77.7680327,
                    55.3576318
                ],
                [
                    77.7684029,
                    55.3571266
                ],
                [
                    77.7678846,
                    55.3563057
                ],
                [
                    77.7613307,
                    55.3563268
                ]
            ],
            "longitude": 77.764702,
            "latitude": 55.356998
        },
        "9711": {
            "name": "Усть-Ургулька",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    77.7814686,
                    56.330737
                ],
                [
                    77.7854079,
                    56.3322985
                ],
                [
                    77.792282,
                    56.3335105
                ],
                [
                    77.7911002,
                    56.3305623
                ],
                [
                    77.7896229,
                    56.330999
                ],
                [
                    77.787673,
                    56.3303329
                ],
                [
                    77.7869048,
                    56.3289789
                ],
                [
                    77.7848761,
                    56.3281598
                ],
                [
                    77.7814686,
                    56.330737
                ]
            ],
            "longitude": 77.788223,
            "latitude": 56.33218
        },
        "9712": {
            "name": "Бекташ",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.8050191,
            "latitude": 55.7953241
        },
        "9713": {
            "name": "Новоказарино",
            "population": 197,
            "type": "hamlet",
            "poly": [
                [
                    77.8031126,
                    54.3698154
                ],
                [
                    77.8066325,
                    54.3712594
                ],
                [
                    77.8099789,
                    54.3718803
                ],
                [
                    77.8149117,
                    54.373974
                ],
                [
                    77.8162751,
                    54.3756777
                ],
                [
                    77.818035,
                    54.3763419
                ],
                [
                    77.8209848,
                    54.3736563
                ],
                [
                    77.8191257,
                    54.3724434
                ],
                [
                    77.8119867,
                    54.3692233
                ],
                [
                    77.8058393,
                    54.3667828
                ],
                [
                    77.8031126,
                    54.3698154
                ]
            ],
            "longitude": 77.812523,
            "latitude": 54.371193
        },
        "9714": {
            "name": "Бехтень",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    77.8036097,
                    54.8461698
                ],
                [
                    77.8039428,
                    54.8478261
                ],
                [
                    77.8192763,
                    54.8524234
                ],
                [
                    77.8303861,
                    54.8550832
                ],
                [
                    77.831276,
                    54.8533993
                ],
                [
                    77.8195681,
                    54.8489201
                ],
                [
                    77.8036097,
                    54.8461698
                ]
            ],
            "longitude": 77.814507,
            "latitude": 54.849083
        },
        "9715": {
            "name": "Ярково",
            "population": 53,
            "type": "hamlet",
            "poly": [
                [
                    77.8092509,
                    55.6476459
                ],
                [
                    77.8158215,
                    55.6499528
                ],
                [
                    77.8263832,
                    55.6517379
                ],
                [
                    77.8288168,
                    55.6514907
                ],
                [
                    77.8297902,
                    55.6503373
                ],
                [
                    77.8281353,
                    55.6493212
                ],
                [
                    77.8235603,
                    55.6482226
                ],
                [
                    77.8168436,
                    55.6470142
                ],
                [
                    77.8129986,
                    55.645998
                ],
                [
                    77.8100295,
                    55.6462726
                ],
                [
                    77.8092509,
                    55.6476459
                ]
            ],
            "longitude": 77.818817,
            "latitude": 55.649158
        },
        "9716": {
            "name": "Забоевка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    77.8263488,
                    56.3324567
                ],
                [
                    77.8285032,
                    56.3340349
                ],
                [
                    77.8299557,
                    56.3333524
                ],
                [
                    77.8305959,
                    56.3331613
                ],
                [
                    77.8315561,
                    56.3331068
                ],
                [
                    77.833058,
                    56.3333797
                ],
                [
                    77.8352738,
                    56.3336118
                ],
                [
                    77.8385976,
                    56.3339666
                ],
                [
                    77.8409858,
                    56.334922
                ],
                [
                    77.8416014,
                    56.3358228
                ],
                [
                    77.8418968,
                    56.3369692
                ],
                [
                    77.8425369,
                    56.3379791
                ],
                [
                    77.8424631,
                    56.3394393
                ],
                [
                    77.8443835,
                    56.3393983
                ],
                [
                    77.8465009,
                    56.3386341
                ],
                [
                    77.8454421,
                    56.3374332
                ],
                [
                    77.8469687,
                    56.337092
                ],
                [
                    77.8465501,
                    56.3365461
                ],
                [
                    77.8468948,
                    56.3361913
                ],
                [
                    77.8464024,
                    56.3357136
                ],
                [
                    77.8445066,
                    56.3361367
                ],
                [
                    77.8417737,
                    56.333953
                ],
                [
                    77.8426108,
                    56.3334207
                ],
                [
                    77.8409612,
                    56.3321786
                ],
                [
                    77.8403949,
                    56.3323697
                ],
                [
                    77.8399764,
                    56.3321786
                ],
                [
                    77.8391393,
                    56.332165
                ],
                [
                    77.8390408,
                    56.3319056
                ],
                [
                    77.8383513,
                    56.3317145
                ],
                [
                    77.8379821,
                    56.3317964
                ],
                [
                    77.8362341,
                    56.3313733
                ],
                [
                    77.835914,
                    56.3311276
                ],
                [
                    77.8351261,
                    56.3310048
                ],
                [
                    77.8334519,
                    56.3315371
                ],
                [
                    77.8337966,
                    56.3308273
                ],
                [
                    77.8327625,
                    56.3307045
                ],
                [
                    77.8324425,
                    56.331114
                ],
                [
                    77.8317285,
                    56.3309775
                ],
                [
                    77.832344,
                    56.3298582
                ],
                [
                    77.8302266,
                    56.3295306
                ],
                [
                    77.8295126,
                    56.3304997
                ],
                [
                    77.8263488,
                    56.3324567
                ]
            ],
            "longitude": 77.838127,
            "latitude": 56.333271
        },
        "9717": {
            "name": "Красный Кут",
            "population": 132,
            "type": "hamlet",
            "poly": [
                [
                    77.8453076,
                    54.2494721
                ],
                [
                    77.8468083,
                    54.2506814
                ],
                [
                    77.849344,
                    54.2515582
                ],
                [
                    77.8671971,
                    54.2445739
                ],
                [
                    77.8671971,
                    54.2436365
                ],
                [
                    77.862902,
                    54.2417919
                ],
                [
                    77.8567957,
                    54.2444529
                ],
                [
                    77.8460838,
                    54.2487767
                ],
                [
                    77.8453076,
                    54.2494721
                ]
            ],
            "longitude": 77.856667,
            "latitude": 54.246662
        },
        "9718": {
            "name": "Анисимовка",
            "population": 164,
            "type": "hamlet",
            "poly": [
                [
                    77.8476551,
                    53.4149715
                ],
                [
                    77.848529,
                    53.4161759
                ],
                [
                    77.8502222,
                    53.4169246
                ],
                [
                    77.8544825,
                    53.417185
                ],
                [
                    77.8597258,
                    53.4162735
                ],
                [
                    77.8664438,
                    53.4164363
                ],
                [
                    77.8709226,
                    53.4161759
                ],
                [
                    77.8725612,
                    53.4149715
                ],
                [
                    77.8719057,
                    53.4120741
                ],
                [
                    77.8705949,
                    53.411716
                ],
                [
                    77.8689017,
                    53.4118462
                ],
                [
                    77.8649146,
                    53.4127578
                ],
                [
                    77.8645322,
                    53.4117811
                ],
                [
                    77.8487475,
                    53.4123019
                ],
                [
                    77.8486383,
                    53.4135716
                ],
                [
                    77.8477644,
                    53.4135716
                ],
                [
                    77.8476551,
                    53.4149715
                ]
            ],
            "longitude": 77.859779,
            "latitude": 53.41354
        },
        "9719": {
            "name": "Новокаменево",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.904564,
            "latitude": 55.548458
        },
        "9720": {
            "name": "Осинцево",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.905632,
            "latitude": 55.40955
        },
        "9721": {
            "name": "Михайловка 1-я",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    77.8936546,
                    55.7015861
                ],
                [
                    77.8970393,
                    55.7034432
                ],
                [
                    77.8957478,
                    55.7041208
                ],
                [
                    77.897841,
                    55.70525
                ],
                [
                    77.9101774,
                    55.7076339
                ],
                [
                    77.9211778,
                    55.7074331
                ],
                [
                    77.9212669,
                    55.7057017
                ],
                [
                    77.9162789,
                    55.7058774
                ],
                [
                    77.9171695,
                    55.7041961
                ],
                [
                    77.9120034,
                    55.7043968
                ],
                [
                    77.9068817,
                    55.7042212
                ],
                [
                    77.9041205,
                    55.7034181
                ],
                [
                    77.9000232,
                    55.7025398
                ],
                [
                    77.8977074,
                    55.7009085
                ],
                [
                    77.8960595,
                    55.6998796
                ],
                [
                    77.8936546,
                    55.7015861
                ]
            ],
            "longitude": 77.905754,
            "latitude": 55.705143
        },
        "9722": {
            "name": "Чернозерка",
            "population": 204,
            "type": "hamlet",
            "poly": [
                [
                    77.9285675,
                    53.8286708
                ],
                [
                    77.9298486,
                    53.8297334
                ],
                [
                    77.9311989,
                    53.8292839
                ],
                [
                    77.9314759,
                    53.8295699
                ],
                [
                    77.931095,
                    53.829856
                ],
                [
                    77.932203,
                    53.831082
                ],
                [
                    77.9337264,
                    53.8305303
                ],
                [
                    77.934746,
                    53.8309118
                ],
                [
                    77.9358383,
                    53.8305303
                ],
                [
                    77.9362884,
                    53.8311025
                ],
                [
                    77.9379157,
                    53.8323897
                ],
                [
                    77.9399989,
                    53.8318131
                ],
                [
                    77.9386095,
                    53.8296362
                ],
                [
                    77.9382966,
                    53.8296108
                ],
                [
                    77.9374656,
                    53.8287934
                ],
                [
                    77.9366,
                    53.8290387
                ],
                [
                    77.9332416,
                    53.8262186
                ],
                [
                    77.9314413,
                    53.8267908
                ],
                [
                    77.9316836,
                    53.8271587
                ],
                [
                    77.9292254,
                    53.8280169
                ],
                [
                    77.9296063,
                    53.8282417
                ],
                [
                    77.9285675,
                    53.8286708
                ]
            ],
            "longitude": 77.934227,
            "latitude": 53.829453
        },
        "9723": {
            "name": "Остановочная Площадка 206 км",
            "population": 12,
            "type": "hamlet",
            "poly": [
                [
                    77.9390137,
                    53.8295814
                ],
                [
                    77.9396965,
                    53.8302214
                ],
                [
                    77.9396563,
                    53.8308377
                ],
                [
                    77.9403793,
                    53.8317148
                ],
                [
                    77.9413835,
                    53.8314541
                ],
                [
                    77.9392547,
                    53.8294154
                ],
                [
                    77.9390137,
                    53.8295814
                ]
            ],
            "longitude": 77.941147,
            "latitude": 53.831409
        },
        "9724": {
            "name": "Ефремовка",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 77.946259,
            "latitude": 55.956306
        },
        "9725": {
            "name": "Владимировка",
            "population": 199,
            "type": "hamlet",
            "poly": [
                [
                    77.939569,
                    54.1640651
                ],
                [
                    77.9494612,
                    54.1660386
                ],
                [
                    77.9497448,
                    54.1657804
                ],
                [
                    77.9503749,
                    54.1659279
                ],
                [
                    77.9508474,
                    54.1652455
                ],
                [
                    77.9541553,
                    54.1661861
                ],
                [
                    77.9558881,
                    54.1662968
                ],
                [
                    77.9570537,
                    54.1669608
                ],
                [
                    77.9583769,
                    54.1671452
                ],
                [
                    77.9595425,
                    54.1657619
                ],
                [
                    77.9572112,
                    54.1650242
                ],
                [
                    77.9579358,
                    54.1639729
                ],
                [
                    77.9576208,
                    54.1636777
                ],
                [
                    77.9566757,
                    54.1633642
                ],
                [
                    77.9551005,
                    54.1627002
                ],
                [
                    77.9548484,
                    54.1628477
                ],
                [
                    77.9538403,
                    54.162571
                ],
                [
                    77.9535568,
                    54.1627739
                ],
                [
                    77.9524541,
                    54.1622759
                ],
                [
                    77.9527062,
                    54.1617041
                ],
                [
                    77.9499653,
                    54.161077
                ],
                [
                    77.9502173,
                    54.1605789
                ],
                [
                    77.9465944,
                    54.159675
                ],
                [
                    77.9463739,
                    54.1599702
                ],
                [
                    77.9454602,
                    54.159675
                ],
                [
                    77.9452711,
                    54.1599333
                ],
                [
                    77.943885,
                    54.1594168
                ],
                [
                    77.943192,
                    54.1592508
                ],
                [
                    77.9414907,
                    54.1609663
                ],
                [
                    77.939569,
                    54.1640651
                ]
            ],
            "longitude": 77.948326,
            "latitude": 54.163395
        },
        "9726": {
            "name": "Новотандово",
            "population": 90,
            "type": "hamlet",
            "poly": [
                [
                    77.9446829,
                    55.095474
                ],
                [
                    77.9462821,
                    55.096034
                ],
                [
                    77.9476904,
                    55.0963754
                ],
                [
                    77.947762,
                    55.0960886
                ],
                [
                    77.9485258,
                    55.0962798
                ],
                [
                    77.9488122,
                    55.0960067
                ],
                [
                    77.9505308,
                    55.0964437
                ],
                [
                    77.951414,
                    55.0964301
                ],
                [
                    77.9522016,
                    55.0969491
                ],
                [
                    77.9527745,
                    55.0968944
                ],
                [
                    77.9548034,
                    55.0958974
                ],
                [
                    77.9561878,
                    55.0949004
                ],
                [
                    77.9569038,
                    55.0937667
                ],
                [
                    77.9548988,
                    55.0933706
                ],
                [
                    77.9548511,
                    55.0931657
                ],
                [
                    77.9555672,
                    55.0928243
                ],
                [
                    77.9544692,
                    55.0921686
                ],
                [
                    77.9560684,
                    55.0913081
                ],
                [
                    77.9544215,
                    55.0903382
                ],
                [
                    77.9528222,
                    55.0903246
                ],
                [
                    77.9512946,
                    55.0910622
                ],
                [
                    77.9504353,
                    55.0905705
                ],
                [
                    77.9498147,
                    55.0911851
                ],
                [
                    77.9513424,
                    55.0917042
                ],
                [
                    77.951772,
                    55.0914583
                ],
                [
                    77.9522731,
                    55.0918271
                ],
                [
                    77.9522255,
                    55.0925238
                ],
                [
                    77.9517481,
                    55.0931248
                ],
                [
                    77.9517958,
                    55.0937121
                ],
                [
                    77.9501489,
                    55.0953238
                ],
                [
                    77.946664,
                    55.0945453
                ],
                [
                    77.9456854,
                    55.0950779
                ],
                [
                    77.9452319,
                    55.0951052
                ],
                [
                    77.9446829,
                    55.095474
                ]
            ],
            "longitude": 77.952988,
            "latitude": 55.094765
        },
        "9727": {
            "name": "Осолодино",
            "population": 105,
            "type": "hamlet",
            "poly": [
                [
                    77.9517968,
                    53.7799458
                ],
                [
                    77.9521191,
                    53.7803798
                ],
                [
                    77.9534163,
                    53.7802218
                ],
                [
                    77.9534618,
                    53.7803092
                ],
                [
                    77.955342,
                    53.7800952
                ],
                [
                    77.9559426,
                    53.7800268
                ],
                [
                    77.9566595,
                    53.7798957
                ],
                [
                    77.9572,
                    53.7797175
                ],
                [
                    77.9570293,
                    53.7795494
                ],
                [
                    77.9579624,
                    53.7793006
                ],
                [
                    77.958281,
                    53.7794116
                ],
                [
                    77.9590264,
                    53.7790922
                ],
                [
                    77.96017,
                    53.7785341
                ],
                [
                    77.9591914,
                    53.777744
                ],
                [
                    77.9573476,
                    53.7771753
                ],
                [
                    77.9548043,
                    53.7780387
                ],
                [
                    77.9523872,
                    53.7786733
                ],
                [
                    77.9517968,
                    53.7799458
                ]
            ],
            "longitude": 77.956596,
            "latitude": 53.779228
        },
        "9728": {
            "name": "Новогребенщиково",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    77.9599946,
                    55.6665588
                ],
                [
                    77.968874,
                    55.671849
                ],
                [
                    77.9715152,
                    55.6691783
                ],
                [
                    77.971242,
                    55.6676117
                ],
                [
                    77.9674625,
                    55.6651976
                ],
                [
                    77.9641384,
                    55.6650435
                ],
                [
                    77.9606777,
                    55.6660451
                ],
                [
                    77.9599946,
                    55.6665588
                ]
            ],
            "longitude": 77.967499,
            "latitude": 55.6688
        },
        "9729": {
            "name": "Горносталиха",
            "population": 14,
            "type": "hamlet",
            "poly": [
                [
                    77.9718572,
                    54.4652356
                ],
                [
                    77.9733035,
                    54.4670495
                ],
                [
                    77.9721363,
                    54.4674624
                ],
                [
                    77.9726438,
                    54.4686126
                ],
                [
                    77.9738363,
                    54.470559
                ],
                [
                    77.9760946,
                    54.4722399
                ],
                [
                    77.9780992,
                    54.4729624
                ],
                [
                    77.9795708,
                    54.4732425
                ],
                [
                    77.9826918,
                    54.471945
                ],
                [
                    77.9797992,
                    54.4703083
                ],
                [
                    77.9813978,
                    54.4688632
                ],
                [
                    77.9790634,
                    54.4677573
                ],
                [
                    77.9796723,
                    54.466666
                ],
                [
                    77.9754095,
                    54.4650734
                ],
                [
                    77.9744199,
                    54.465796
                ],
                [
                    77.9728468,
                    54.4648079
                ],
                [
                    77.9718572,
                    54.4652356
                ]
            ],
            "longitude": 77.976143,
            "latitude": 54.468975
        },
        "9730": {
            "name": "Кавказское",
            "population": 157,
            "type": "hamlet",
            "poly": [
                [
                    77.977886,
                    53.9608366
                ],
                [
                    77.9788425,
                    53.9613233
                ],
                [
                    77.9793854,
                    53.9609887
                ],
                [
                    77.9810658,
                    53.9615515
                ],
                [
                    77.9804356,
                    53.9624787
                ],
                [
                    77.9838321,
                    53.9643956
                ],
                [
                    77.9872446,
                    53.9648063
                ],
                [
                    77.9913811,
                    53.9627226
                ],
                [
                    77.9964223,
                    53.9587984
                ],
                [
                    77.9918206,
                    53.9563342
                ],
                [
                    77.9847628,
                    53.9552998
                ],
                [
                    77.9824877,
                    53.9559539
                ],
                [
                    77.9812468,
                    53.9554671
                ],
                [
                    77.9782996,
                    53.9571252
                ],
                [
                    77.9788167,
                    53.9589049
                ],
                [
                    77.9802644,
                    53.9592395
                ],
                [
                    77.977886,
                    53.9608366
                ]
            ],
            "longitude": 77.986908,
            "latitude": 53.959908
        },
        "9731": {
            "name": "Троицкое",
            "population": 84,
            "type": "hamlet",
            "poly": [
                [
                    77.9876252,
                    54.0043976
                ],
                [
                    77.9905169,
                    54.004519
                ],
                [
                    77.9905582,
                    54.0054173
                ],
                [
                    77.9925823,
                    54.005563
                ],
                [
                    77.992665,
                    54.0052231
                ],
                [
                    77.9915496,
                    54.005126
                ],
                [
                    77.9922106,
                    54.0011684
                ],
                [
                    77.9934498,
                    54.0011199
                ],
                [
                    77.994276,
                    54.0003429
                ],
                [
                    77.9938629,
                    53.999663
                ],
                [
                    77.9932846,
                    53.9996144
                ],
                [
                    77.9936151,
                    53.9959478
                ],
                [
                    77.9945239,
                    53.994855
                ],
                [
                    77.9939456,
                    53.9947336
                ],
                [
                    77.9940695,
                    53.9939564
                ],
                [
                    77.9945239,
                    53.9939564
                ],
                [
                    77.9945652,
                    53.992815
                ],
                [
                    77.9930411,
                    53.9925607
                ],
                [
                    77.9930322,
                    53.9921305
                ],
                [
                    77.995598,
                    53.9924508
                ],
                [
                    77.9955567,
                    53.9910422
                ],
                [
                    77.9908886,
                    53.990775
                ],
                [
                    77.9894428,
                    53.9941022
                ],
                [
                    77.9901451,
                    53.9941264
                ],
                [
                    77.9896907,
                    53.9958992
                ],
                [
                    77.9901038,
                    53.9967734
                ],
                [
                    77.9888645,
                    53.9967977
                ],
                [
                    77.9882448,
                    53.9985703
                ],
                [
                    77.9889884,
                    53.9986432
                ],
                [
                    77.9882035,
                    54.0013384
                ],
                [
                    77.9876252,
                    54.0043976
                ]
            ],
            "longitude": 77.990845,
            "latitude": 53.99807
        },
        "9732": {
            "name": "Староярково",
            "population": 79,
            "type": "hamlet",
            "poly": [
                [
                    77.9807083,
                    54.8786556
                ],
                [
                    77.9839281,
                    54.8799452
                ],
                [
                    77.9882483,
                    54.8814693
                ],
                [
                    77.9873109,
                    54.8825009
                ],
                [
                    77.9937505,
                    54.883978
                ],
                [
                    78.0023502,
                    54.8853377
                ],
                [
                    78.0072002,
                    54.8859238
                ],
                [
                    78.0078932,
                    54.8838607
                ],
                [
                    78.0022687,
                    54.8828995
                ],
                [
                    77.9957067,
                    54.8814927
                ],
                [
                    77.981931,
                    54.8772487
                ],
                [
                    77.9807083,
                    54.8786556
                ]
            ],
            "longitude": 77.99501,
            "latitude": 54.882946
        },
        "9733": {
            "name": "Красносельский",
            "population": 209,
            "type": "hamlet",
            "poly": [
                [
                    78.003972,
                    53.704277
                ],
                [
                    78.0041315,
                    53.7057463
                ],
                [
                    78.0045748,
                    53.7065334
                ],
                [
                    78.0061705,
                    53.7086113
                ],
                [
                    78.008369,
                    53.710773
                ],
                [
                    78.0108157,
                    53.7141098
                ],
                [
                    78.0120469,
                    53.7143847
                ],
                [
                    78.0130795,
                    53.7152241
                ],
                [
                    78.0137149,
                    53.715533
                ],
                [
                    78.0153489,
                    53.715157
                ],
                [
                    78.0160297,
                    53.7160031
                ],
                [
                    78.0189232,
                    53.7147675
                ],
                [
                    78.0200806,
                    53.7145526
                ],
                [
                    78.0193885,
                    53.7132901
                ],
                [
                    78.0184239,
                    53.7133976
                ],
                [
                    78.0182197,
                    53.7131693
                ],
                [
                    78.0176637,
                    53.7130954
                ],
                [
                    78.017085,
                    53.7120948
                ],
                [
                    78.0185488,
                    53.7117993
                ],
                [
                    78.016824,
                    53.7089718
                ],
                [
                    78.0143617,
                    53.7094285
                ],
                [
                    78.0148042,
                    53.7101539
                ],
                [
                    78.0140894,
                    53.7103755
                ],
                [
                    78.0138397,
                    53.7097106
                ],
                [
                    78.013295,
                    53.7098517
                ],
                [
                    78.0119675,
                    53.7085219
                ],
                [
                    78.0114001,
                    53.7086159
                ],
                [
                    78.0106172,
                    53.7077495
                ],
                [
                    78.0127958,
                    53.7068831
                ],
                [
                    78.0123646,
                    53.7064196
                ],
                [
                    78.0114682,
                    53.706695
                ],
                [
                    78.0095505,
                    53.7045121
                ],
                [
                    78.0079733,
                    53.7045524
                ],
                [
                    78.0066797,
                    53.7035112
                ],
                [
                    78.0055145,
                    53.7037522
                ],
                [
                    78.003972,
                    53.704277
                ]
            ],
            "longitude": 78.010223,
            "latitude": 53.708202
        },
        "9734": {
            "name": "Круглоозёрка",
            "population": 98,
            "type": "hamlet",
            "poly": [
                [
                    78.0037723,
                    55.224461
                ],
                [
                    78.0111893,
                    55.2251957
                ],
                [
                    78.0129849,
                    55.22691
                ],
                [
                    78.0141951,
                    55.2270882
                ],
                [
                    78.0145464,
                    55.2273998
                ],
                [
                    78.0143903,
                    55.2280677
                ],
                [
                    78.0160298,
                    55.2295371
                ],
                [
                    78.0169276,
                    55.2292922
                ],
                [
                    78.0167715,
                    55.2311622
                ],
                [
                    78.0191527,
                    55.2312957
                ],
                [
                    78.0193479,
                    55.226064
                ],
                [
                    78.0143903,
                    55.2234368
                ],
                [
                    78.0096668,
                    55.2217891
                ],
                [
                    78.0050996,
                    55.2212102
                ],
                [
                    78.0037723,
                    55.224461
                ]
            ],
            "longitude": 78.015923,
            "latitude": 55.225613
        },
        "9735": {
            "name": "Ягодный",
            "population": 263,
            "type": "hamlet",
            "poly": [
                [
                    78.011702,
                    53.7632865
                ],
                [
                    78.0129934,
                    53.7637408
                ],
                [
                    78.0128027,
                    53.7638843
                ],
                [
                    78.0135223,
                    53.7641765
                ],
                [
                    78.0138201,
                    53.7643305
                ],
                [
                    78.0144548,
                    53.7639797
                ],
                [
                    78.0151689,
                    53.7643362
                ],
                [
                    78.0146744,
                    53.7644293
                ],
                [
                    78.0169869,
                    53.7655468
                ],
                [
                    78.0211314,
                    53.7647473
                ],
                [
                    78.0210358,
                    53.764502
                ],
                [
                    78.0212589,
                    53.7640856
                ],
                [
                    78.0208884,
                    53.7631913
                ],
                [
                    78.0213676,
                    53.7629981
                ],
                [
                    78.0215041,
                    53.7625648
                ],
                [
                    78.0212819,
                    53.7624466
                ],
                [
                    78.0209043,
                    53.7616531
                ],
                [
                    78.0202936,
                    53.761284
                ],
                [
                    78.0190287,
                    53.7620488
                ],
                [
                    78.0179775,
                    53.7614227
                ],
                [
                    78.0175253,
                    53.7611483
                ],
                [
                    78.0183901,
                    53.7606629
                ],
                [
                    78.0179141,
                    53.7603815
                ],
                [
                    78.0167345,
                    53.7606112
                ],
                [
                    78.0158966,
                    53.7607066
                ],
                [
                    78.0157568,
                    53.7610194
                ],
                [
                    78.0155287,
                    53.7613246
                ],
                [
                    78.0150598,
                    53.761501
                ],
                [
                    78.0145548,
                    53.7616879
                ],
                [
                    78.0135894,
                    53.7623514
                ],
                [
                    78.0131823,
                    53.762691
                ],
                [
                    78.0136932,
                    53.7629593
                ],
                [
                    78.0131823,
                    53.7633457
                ],
                [
                    78.012024,
                    53.762963
                ],
                [
                    78.011702,
                    53.7632865
                ]
            ],
            "longitude": 78.017059,
            "latitude": 53.76292
        },
        "9736": {
            "name": "Чистоозерка",
            "population": 13,
            "type": "hamlet",
            "poly": [
                [
                    78.0030055,
                    54.7849674
                ],
                [
                    78.0056039,
                    54.7853091
                ],
                [
                    78.0089317,
                    54.7861503
                ],
                [
                    78.0103449,
                    54.7867286
                ],
                [
                    78.0137182,
                    54.7887263
                ],
                [
                    78.0148124,
                    54.7879903
                ],
                [
                    78.0168182,
                    54.7888051
                ],
                [
                    78.0160432,
                    54.7897777
                ],
                [
                    78.0208754,
                    54.7907764
                ],
                [
                    78.0219695,
                    54.78962
                ],
                [
                    78.0215136,
                    54.7870966
                ],
                [
                    78.0217416,
                    54.7862291
                ],
                [
                    78.0202828,
                    54.7858085
                ],
                [
                    78.018049,
                    54.7858348
                ],
                [
                    78.0171373,
                    54.7866234
                ],
                [
                    78.0126698,
                    54.7850462
                ],
                [
                    78.0069259,
                    54.7832849
                ],
                [
                    78.0031878,
                    54.7843627
                ],
                [
                    78.0030055,
                    54.7849674
                ]
            ],
            "longitude": 78.018501,
            "latitude": 54.787857
        },
        "9737": {
            "name": "Осинники",
            "population": 146,
            "type": "hamlet",
            "poly": [
                [
                    78.0173227,
                    54.2049513
                ],
                [
                    78.0233113,
                    54.2061803
                ],
                [
                    78.0234688,
                    54.2057194
                ],
                [
                    78.0293699,
                    54.2066514
                ],
                [
                    78.0307707,
                    54.2041832
                ],
                [
                    78.0327932,
                    54.2042088
                ],
                [
                    78.0334147,
                    54.203246
                ],
                [
                    78.0313922,
                    54.2028005
                ],
                [
                    78.0257627,
                    54.2012386
                ],
                [
                    78.0197391,
                    54.2000708
                ],
                [
                    78.0194765,
                    54.2014793
                ],
                [
                    78.0195815,
                    54.2020938
                ],
                [
                    78.0180318,
                    54.2024062
                ],
                [
                    78.0173227,
                    54.2049513
                ]
            ],
            "longitude": 78.024185,
            "latitude": 54.20406
        },
        "9738": {
            "name": "Мангазерка",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.024643,
            "latitude": 55.509621
        },
        "9739": {
            "name": "Марково",
            "population": 21,
            "type": "hamlet",
            "poly": [
                [
                    78.0274747,
                    55.3962407
                ],
                [
                    78.0385256,
                    55.3994946
                ],
                [
                    78.0409814,
                    55.396415
                ],
                [
                    78.0350467,
                    55.3937419
                ],
                [
                    78.0317724,
                    55.3939744
                ],
                [
                    78.0295213,
                    55.3928121
                ],
                [
                    78.0280887,
                    55.3928121
                ],
                [
                    78.0274747,
                    55.3962407
                ]
            ],
            "longitude": 78.034943,
            "latitude": 55.397602
        },
        "9740": {
            "name": "Озерный",
            "population": 65,
            "type": "hamlet",
            "poly": [
                [
                    78.0346238,
                    55.6060565
                ],
                [
                    78.0366261,
                    55.6066873
                ],
                [
                    78.0362796,
                    55.6075356
                ],
                [
                    78.0367802,
                    55.6080794
                ],
                [
                    78.0409775,
                    55.6082969
                ],
                [
                    78.0479473,
                    55.6081229
                ],
                [
                    78.049064,
                    55.606535
                ],
                [
                    78.0452133,
                    55.6048601
                ],
                [
                    78.0417359,
                    55.6044337
                ],
                [
                    78.0393602,
                    55.6041423
                ],
                [
                    78.0387825,
                    55.6050777
                ],
                [
                    78.0365106,
                    55.6047079
                ],
                [
                    78.0346238,
                    55.6060565
                ]
            ],
            "longitude": 78.041108,
            "latitude": 55.6063556
        },
        "9741": {
            "name": "Городище",
            "population": 232,
            "type": "hamlet",
            "poly": [
                [
                    78.0381846,
                    54.6367361
                ],
                [
                    78.0461546,
                    54.6392048
                ],
                [
                    78.0583342,
                    54.6420956
                ],
                [
                    78.0599619,
                    54.6398545
                ],
                [
                    78.049859,
                    54.6370609
                ],
                [
                    78.045874,
                    54.6345596
                ],
                [
                    78.0416645,
                    54.6352743
                ],
                [
                    78.0381846,
                    54.6367361
                ]
            ],
            "longitude": 78.047958,
            "latitude": 54.637531
        },
        "9742": {
            "name": "Зелёный Луг",
            "population": 30,
            "type": "hamlet",
            "poly": [
                [
                    78.0456725,
                    54.0342164
                ],
                [
                    78.050227,
                    54.0368525
                ],
                [
                    78.0549136,
                    54.0363098
                ],
                [
                    78.0563658,
                    54.0339451
                ],
                [
                    78.0549136,
                    54.0325494
                ],
                [
                    78.0521413,
                    54.0338675
                ],
                [
                    78.049831,
                    54.031774
                ],
                [
                    78.0456725,
                    54.0342164
                ]
            ],
            "longitude": 78.04924,
            "latitude": 54.034332
        },
        "9743": {
            "name": "Мирный",
            "population": 85,
            "type": "hamlet",
            "poly": [
                [
                    78.0434357,
                    55.684501
                ],
                [
                    78.046144,
                    55.6864505
                ],
                [
                    78.0474773,
                    55.6860982
                ],
                [
                    78.0509773,
                    55.6873666
                ],
                [
                    78.0532273,
                    55.6865445
                ],
                [
                    78.0534357,
                    55.6848063
                ],
                [
                    78.058269,
                    55.6849473
                ],
                [
                    78.058769,
                    55.6840312
                ],
                [
                    78.0577274,
                    55.6827627
                ],
                [
                    78.056144,
                    55.6822459
                ],
                [
                    78.049519,
                    55.6811183
                ],
                [
                    78.0489773,
                    55.681917
                ],
                [
                    78.0497273,
                    55.6830681
                ],
                [
                    78.0496023,
                    55.6838902
                ],
                [
                    78.046394,
                    55.6834909
                ],
                [
                    78.0445189,
                    55.6837963
                ],
                [
                    78.0434357,
                    55.684501
                ]
            ],
            "longitude": 78.050591,
            "latitude": 55.684864
        },
        "9744": {
            "name": "Ярок",
            "population": 66,
            "type": "hamlet",
            "poly": [
                [
                    78.0517435,
                    53.7700106
                ],
                [
                    78.0532351,
                    53.7697167
                ],
                [
                    78.0560524,
                    53.7696433
                ],
                [
                    78.0583726,
                    53.7703779
                ],
                [
                    78.0587455,
                    53.7685413
                ],
                [
                    78.0564253,
                    53.768223
                ],
                [
                    78.0555138,
                    53.7675863
                ],
                [
                    78.0534836,
                    53.7673904
                ],
                [
                    78.0521164,
                    53.7685168
                ],
                [
                    78.0517435,
                    53.7700106
                ]
            ],
            "longitude": 78.055222,
            "latitude": 53.768444
        },
        "9745": {
            "name": "Малиновка",
            "population": 37,
            "type": "hamlet",
            "poly": [
                [
                    78.0454933,
                    56.3972982
                ],
                [
                    78.0478004,
                    56.3975695
                ],
                [
                    78.0481177,
                    56.3976493
                ],
                [
                    78.0480311,
                    56.3979526
                ],
                [
                    78.0494731,
                    56.398192
                ],
                [
                    78.0499922,
                    56.3975376
                ],
                [
                    78.0506843,
                    56.3974738
                ],
                [
                    78.0507132,
                    56.3980324
                ],
                [
                    78.051463,
                    56.3980324
                ],
                [
                    78.0516072,
                    56.3976493
                ],
                [
                    78.0525877,
                    56.3979206
                ],
                [
                    78.0548083,
                    56.3982718
                ],
                [
                    78.055212,
                    56.397761
                ],
                [
                    78.05576,
                    56.3978887
                ],
                [
                    78.0556445,
                    56.398559
                ],
                [
                    78.0570577,
                    56.3987665
                ],
                [
                    78.0573749,
                    56.3981122
                ],
                [
                    78.0578364,
                    56.3982079
                ],
                [
                    78.0577498,
                    56.398958
                ],
                [
                    78.0595955,
                    56.3991815
                ],
                [
                    78.0599128,
                    56.3996922
                ],
                [
                    78.061845,
                    56.3998198
                ],
                [
                    78.0621622,
                    56.399373
                ],
                [
                    78.0627678,
                    56.3994368
                ],
                [
                    78.0627678,
                    56.3998837
                ],
                [
                    78.0646423,
                    56.399772
                ],
                [
                    78.0653345,
                    56.3988463
                ],
                [
                    78.065594,
                    56.397777
                ],
                [
                    78.0644116,
                    56.3976653
                ],
                [
                    78.0641809,
                    56.3986069
                ],
                [
                    78.0638348,
                    56.398575
                ],
                [
                    78.063979,
                    56.397362
                ],
                [
                    78.0615854,
                    56.3970588
                ],
                [
                    78.0604319,
                    56.3970269
                ],
                [
                    78.0604895,
                    56.3967715
                ],
                [
                    78.0597686,
                    56.3966438
                ],
                [
                    78.0591917,
                    56.3970748
                ],
                [
                    78.0580671,
                    56.3966917
                ],
                [
                    78.0595379,
                    56.3963246
                ],
                [
                    78.058442,
                    56.3938666
                ],
                [
                    78.0542027,
                    56.3944093
                ],
                [
                    78.0546929,
                    56.3958617
                ],
                [
                    78.0538277,
                    56.3967077
                ],
                [
                    78.0523858,
                    56.3963725
                ],
                [
                    78.0527029,
                    56.3956064
                ],
                [
                    78.0493001,
                    56.3952552
                ],
                [
                    78.0490405,
                    56.3958298
                ],
                [
                    78.0484349,
                    56.3957979
                ],
                [
                    78.0485501,
                    56.3954627
                ],
                [
                    78.0465027,
                    56.3952233
                ],
                [
                    78.0454933,
                    56.3972982
                ]
            ],
            "longitude": 78.055977,
            "latitude": 56.396725
        },
        "9746": {
            "name": "Остановочная Платформа 3017",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    78.071352,
                    55.3359682
                ],
                [
                    78.0713698,
                    55.3361397
                ],
                [
                    78.0720793,
                    55.3361447
                ],
                [
                    78.072097,
                    55.3363213
                ],
                [
                    78.0738352,
                    55.3363616
                ],
                [
                    78.0761144,
                    55.3362759
                ],
                [
                    78.0759637,
                    55.3359278
                ],
                [
                    78.0761056,
                    55.3356353
                ],
                [
                    78.0760346,
                    55.3353932
                ],
                [
                    78.0747575,
                    55.3352065
                ],
                [
                    78.0726734,
                    55.3353478
                ],
                [
                    78.0727976,
                    55.3355445
                ],
                [
                    78.0725404,
                    55.3357563
                ],
                [
                    78.071352,
                    55.3359682
                ]
            ],
            "longitude": 78.074364,
            "latitude": 55.335678
        },
        "9747": {
            "name": "Усть-Тандовка",
            "population": 266,
            "type": "hamlet",
            "poly": [
                [
                    78.0666377,
                    55.0036656
                ],
                [
                    78.0702273,
                    55.004441
                ],
                [
                    78.0729779,
                    55.0053768
                ],
                [
                    78.0740968,
                    55.0066334
                ],
                [
                    78.0739103,
                    55.0079166
                ],
                [
                    78.0767541,
                    55.0089058
                ],
                [
                    78.0809964,
                    55.0102157
                ],
                [
                    78.0903669,
                    55.0122206
                ],
                [
                    78.0924181,
                    55.0105365
                ],
                [
                    78.084726,
                    55.0081038
                ],
                [
                    78.0842598,
                    55.0054837
                ],
                [
                    78.0806235,
                    55.0046816
                ],
                [
                    78.0784324,
                    55.0054837
                ],
                [
                    78.0769406,
                    55.0043073
                ],
                [
                    78.0749359,
                    55.0048153
                ],
                [
                    78.0687356,
                    55.0020346
                ],
                [
                    78.0666377,
                    55.0036656
                ]
            ],
            "longitude": 78.080795,
            "latitude": 55.006767
        },
        "9748": {
            "name": "Ургуль",
            "population": 85,
            "type": "hamlet",
            "poly": [
                [
                    78.0746738,
                    56.6941671
                ],
                [
                    78.0773244,
                    56.6947537
                ],
                [
                    78.0783527,
                    56.6943554
                ],
                [
                    78.0809714,
                    56.6953825
                ],
                [
                    78.081969,
                    56.6974537
                ],
                [
                    78.0841513,
                    56.6972141
                ],
                [
                    78.0852424,
                    56.6976763
                ],
                [
                    78.0875494,
                    56.6974537
                ],
                [
                    78.0894511,
                    56.6978817
                ],
                [
                    78.0935351,
                    56.697933
                ],
                [
                    78.0933792,
                    56.6967519
                ],
                [
                    78.0944704,
                    56.6968033
                ],
                [
                    78.0950315,
                    56.6964952
                ],
                [
                    78.0950627,
                    56.695605
                ],
                [
                    78.0938156,
                    56.6952113
                ],
                [
                    78.0891082,
                    56.6951942
                ],
                [
                    78.088921,
                    56.6949374
                ],
                [
                    78.085336,
                    56.6941671
                ],
                [
                    78.0862089,
                    56.6926606
                ],
                [
                    78.083029,
                    56.6920272
                ],
                [
                    78.0823743,
                    56.6934139
                ],
                [
                    78.0806285,
                    56.6942698
                ],
                [
                    78.0784569,
                    56.6936361
                ],
                [
                    78.0788203,
                    56.6924723
                ],
                [
                    78.0778538,
                    56.692284
                ],
                [
                    78.0771056,
                    56.693294
                ],
                [
                    78.0749545,
                    56.6931913
                ],
                [
                    78.0746738,
                    56.6941671
                ]
            ],
            "longitude": 78.083176,
            "latitude": 56.695309
        },
        "9749": {
            "name": "Карачилик",
            "population": 22,
            "type": "hamlet",
            "poly": [
                [
                    78.0815289,
                    53.6263379
                ],
                [
                    78.0835605,
                    53.6264474
                ],
                [
                    78.0866262,
                    53.6200068
                ],
                [
                    78.0857397,
                    53.6198314
                ],
                [
                    78.0815289,
                    53.6263379
                ]
            ],
            "longitude": 78.08474,
            "latitude": 53.622635
        },
        "9750": {
            "name": "Новомихайловка",
            "population": 28,
            "type": "hamlet",
            "poly": [
                [
                    78.0796077,
                    54.7426916
                ],
                [
                    78.0833233,
                    54.743727
                ],
                [
                    78.0817858,
                    54.745428
                ],
                [
                    78.0866546,
                    54.7457238
                ],
                [
                    78.0949826,
                    54.7488298
                ],
                [
                    78.098442,
                    54.7463894
                ],
                [
                    78.0903702,
                    54.7426916
                ],
                [
                    78.0889608,
                    54.7434312
                ],
                [
                    78.0816577,
                    54.7417301
                ],
                [
                    78.0796077,
                    54.7426916
                ]
            ],
            "longitude": 78.091011,
            "latitude": 54.745502
        },
        "9751": {
            "name": "Старогребенщиково",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.094139,
            "latitude": 55.440559
        },
        "9752": {
            "name": "Бронзовка",
            "population": 118,
            "type": "hamlet",
            "poly": [
                [
                    78.1044271,
                    53.9522451
                ],
                [
                    78.1057596,
                    53.9531287
                ],
                [
                    78.1071555,
                    53.9534026
                ],
                [
                    78.1084245,
                    53.9534523
                ],
                [
                    78.1116817,
                    53.950515
                ],
                [
                    78.1125066,
                    53.9517348
                ],
                [
                    78.1151081,
                    53.9535768
                ],
                [
                    78.1196554,
                    53.9519713
                ],
                [
                    78.1216648,
                    53.9502038
                ],
                [
                    78.1181961,
                    53.9481002
                ],
                [
                    78.1204592,
                    53.9463078
                ],
                [
                    78.1179,
                    53.9452995
                ],
                [
                    78.1151081,
                    53.947204
                ],
                [
                    78.1089956,
                    53.9448638
                ],
                [
                    78.1058442,
                    53.9464696
                ],
                [
                    78.1056115,
                    53.947677
                ],
                [
                    78.1060768,
                    53.9486728
                ],
                [
                    78.1070498,
                    53.9489342
                ],
                [
                    78.106246,
                    53.9504403
                ],
                [
                    78.1052519,
                    53.9502536
                ],
                [
                    78.1047866,
                    53.9507515
                ],
                [
                    78.1046809,
                    53.9514983
                ],
                [
                    78.1044271,
                    53.9522451
                ]
            ],
            "longitude": 78.107613,
            "latitude": 53.950466
        },
        "9753": {
            "name": "Степановка",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.115097,
            "latitude": 55.794178
        },
        "9754": {
            "name": "Остановочная Платформа 3020",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    78.1217384,
                    55.3318185
                ],
                [
                    78.1217473,
                    55.33198
                ],
                [
                    78.1267137,
                    55.3319346
                ],
                [
                    78.1267137,
                    55.331758
                ],
                [
                    78.1217384,
                    55.3318185
                ]
            ],
            "longitude": 78.124146,
            "latitude": 55.331879
        },
        "9755": {
            "name": "Ударник",
            "population": 209,
            "type": "hamlet",
            "poly": [
                [
                    78.1201878,
                    56.3808769
                ],
                [
                    78.1234469,
                    56.3820905
                ],
                [
                    78.1235051,
                    56.3823376
                ],
                [
                    78.124669,
                    56.382692
                ],
                [
                    78.1254644,
                    56.3820046
                ],
                [
                    78.1256778,
                    56.382155
                ],
                [
                    78.1251734,
                    56.3826598
                ],
                [
                    78.1259881,
                    56.3829712
                ],
                [
                    78.1276565,
                    56.381575
                ],
                [
                    78.1304887,
                    56.3828746
                ],
                [
                    78.1325644,
                    56.3832934
                ],
                [
                    78.1325449,
                    56.3843889
                ],
                [
                    78.1328554,
                    56.3856025
                ],
                [
                    78.1347371,
                    56.3857206
                ],
                [
                    78.1375694,
                    56.3847863
                ],
                [
                    78.1375112,
                    56.3831431
                ],
                [
                    78.1383065,
                    56.3808983
                ],
                [
                    78.1394511,
                    56.3801035
                ],
                [
                    78.1367158,
                    56.3784601
                ],
                [
                    78.1357265,
                    56.3790079
                ],
                [
                    78.1341551,
                    56.3781057
                ],
                [
                    78.1299455,
                    56.3767307
                ],
                [
                    78.1278504,
                    56.3768596
                ],
                [
                    78.1273461,
                    56.3760325
                ],
                [
                    78.1258717,
                    56.3764729
                ],
                [
                    78.125794,
                    56.3766985
                ],
                [
                    78.1233305,
                    56.3774719
                ],
                [
                    78.1235245,
                    56.3779231
                ],
                [
                    78.1220889,
                    56.3788039
                ],
                [
                    78.1210802,
                    56.3795772
                ],
                [
                    78.1217203,
                    56.3798565
                ],
                [
                    78.1201878,
                    56.3808769
                ]
            ],
            "longitude": 78.130394,
            "latitude": 56.379856
        },
        "9756": {
            "name": "Тандов",
            "population": 122,
            "type": "hamlet",
            "poly": [
                [
                    78.1330414,
                    55.1622816
                ],
                [
                    78.1333527,
                    55.1633001
                ],
                [
                    78.1361262,
                    55.1631546
                ],
                [
                    78.137428,
                    55.1627504
                ],
                [
                    78.1411071,
                    55.1622816
                ],
                [
                    78.1433428,
                    55.1622978
                ],
                [
                    78.1456069,
                    55.1626211
                ],
                [
                    78.1460314,
                    55.1622169
                ],
                [
                    78.1456352,
                    55.1616672
                ],
                [
                    78.1462861,
                    55.1614409
                ],
                [
                    78.1463144,
                    55.1607295
                ],
                [
                    78.1457484,
                    55.1596625
                ],
                [
                    78.1448428,
                    55.1597756
                ],
                [
                    78.1446164,
                    55.1589834
                ],
                [
                    78.1429183,
                    55.1589511
                ],
                [
                    78.1427767,
                    55.1591936
                ],
                [
                    78.1400034,
                    55.1594523
                ],
                [
                    78.1402015,
                    55.160196
                ],
                [
                    78.1342866,
                    55.1608427
                ],
                [
                    78.1335508,
                    55.1612469
                ],
                [
                    78.1338621,
                    55.1621684
                ],
                [
                    78.1330414,
                    55.1622816
                ]
            ],
            "longitude": 78.140656,
            "latitude": 55.161213
        },
        "9757": {
            "name": "Казатово",
            "population": 63,
            "type": "hamlet",
            "poly": [
                [
                    78.1330072,
                    55.6507862
                ],
                [
                    78.1351888,
                    55.6527162
                ],
                [
                    78.1393096,
                    55.6545092
                ],
                [
                    78.142353,
                    55.6554817
                ],
                [
                    78.1448578,
                    55.654099
                ],
                [
                    78.1431071,
                    55.6527617
                ],
                [
                    78.1370202,
                    55.6499504
                ],
                [
                    78.1348656,
                    55.6494337
                ],
                [
                    78.1330072,
                    55.6507862
                ]
            ],
            "longitude": 78.140953,
            "latitude": 55.652992
        },
        "9758": {
            "name": "Широкая Курья",
            "population": 45,
            "type": "hamlet",
            "poly": [
                [
                    78.136007,
                    54.5684669
                ],
                [
                    78.1390658,
                    54.5697534
                ],
                [
                    78.1397856,
                    54.5713181
                ],
                [
                    78.1436842,
                    54.5727436
                ],
                [
                    78.1462632,
                    54.5734389
                ],
                [
                    78.1473428,
                    54.572222
                ],
                [
                    78.1463832,
                    54.5720134
                ],
                [
                    78.1487223,
                    54.5705879
                ],
                [
                    78.144164,
                    54.5681888
                ],
                [
                    78.1409252,
                    54.5665893
                ],
                [
                    78.1379862,
                    54.5659633
                ],
                [
                    78.1364868,
                    54.5671456
                ],
                [
                    78.1372065,
                    54.5675629
                ],
                [
                    78.136007,
                    54.5684669
                ]
            ],
            "longitude": 78.142319,
            "latitude": 54.56995
        },
        "9759": {
            "name": "Кавкуй",
            "population": 87,
            "type": "hamlet",
            "poly": [
                [
                    78.1511352,
                    53.6508521
                ],
                [
                    78.1521202,
                    53.6519029
                ],
                [
                    78.1535978,
                    53.6530705
                ],
                [
                    78.1543365,
                    53.6526035
                ],
                [
                    78.1551738,
                    53.6528954
                ],
                [
                    78.1663537,
                    53.6462105
                ],
                [
                    78.1616255,
                    53.6433492
                ],
                [
                    78.1582765,
                    53.6456558
                ],
                [
                    78.1606405,
                    53.6466775
                ],
                [
                    78.1551245,
                    53.6495677
                ],
                [
                    78.15345,
                    53.6489838
                ],
                [
                    78.1511352,
                    53.6508521
                ]
            ],
            "longitude": 78.159012,
            "latitude": 53.649128
        },
        "9760": {
            "name": "Остановочная Платформа 3023",
            "population": 18,
            "type": "hamlet",
            "poly": [
                [
                    78.1677442,
                    55.3396192
                ],
                [
                    78.1744786,
                    55.3407634
                ],
                [
                    78.1743389,
                    55.3396192
                ],
                [
                    78.1733888,
                    55.3394285
                ],
                [
                    78.1700635,
                    55.3389517
                ],
                [
                    78.1680236,
                    55.3388087
                ],
                [
                    78.1677442,
                    55.3396192
                ]
            ],
            "longitude": 78.170486,
            "latitude": 55.339588
        },
        "9761": {
            "name": "Журавлевка",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    78.1767244,
                    55.603472
                ],
                [
                    78.1770772,
                    55.6041324
                ],
                [
                    78.1796136,
                    55.6046058
                ],
                [
                    78.1836498,
                    55.6051166
                ],
                [
                    78.185326,
                    55.6038832
                ],
                [
                    78.1863405,
                    55.6026871
                ],
                [
                    78.1855465,
                    55.6018647
                ],
                [
                    78.1819955,
                    55.6013165
                ],
                [
                    78.1800547,
                    55.600843
                ],
                [
                    78.1784006,
                    55.6008305
                ],
                [
                    78.1772978,
                    55.6017526
                ],
                [
                    78.1768787,
                    55.6025749
                ],
                [
                    78.1767244,
                    55.603472
                ]
            ],
            "longitude": 78.181244,
            "latitude": 55.602814
        },
        "9762": {
            "name": "Чебачье",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    78.1900747,
                    53.7354115
                ],
                [
                    78.1984037,
                    53.7400989
                ],
                [
                    78.2015238,
                    53.7380964
                ],
                [
                    78.1925529,
                    53.7319305
                ],
                [
                    78.1905944,
                    53.7331637
                ],
                [
                    78.1919843,
                    53.7343222
                ],
                [
                    78.1900747,
                    53.7354115
                ]
            ],
            "longitude": 78.195496,
            "latitude": 53.736301
        },
        "9763": {
            "name": "Большие Луки",
            "population": 206,
            "type": "hamlet",
            "poly": [
                [
                    78.1981679,
                    54.0357782
                ],
                [
                    78.2005359,
                    54.0432736
                ],
                [
                    78.2015755,
                    54.0436127
                ],
                [
                    78.2060227,
                    54.0429345
                ],
                [
                    78.2028462,
                    54.0353033
                ],
                [
                    78.1981679,
                    54.0357782
                ]
            ],
            "longitude": 78.203194,
            "latitude": 54.040051
        },
        "9764": {
            "name": "Кучугур",
            "population": 255,
            "type": "hamlet",
            "poly": [
                [
                    78.1962299,
                    53.9949815
                ],
                [
                    78.199405,
                    53.9955148
                ],
                [
                    78.201843,
                    53.9955148
                ],
                [
                    78.2018997,
                    53.9969646
                ],
                [
                    78.2023249,
                    53.9982644
                ],
                [
                    78.2028635,
                    53.9982311
                ],
                [
                    78.2030903,
                    53.9984977
                ],
                [
                    78.2038558,
                    53.998531
                ],
                [
                    78.2030336,
                    53.9990476
                ],
                [
                    78.2042526,
                    53.9992642
                ],
                [
                    78.2073994,
                    53.9991309
                ],
                [
                    78.2086467,
                    53.9987143
                ],
                [
                    78.2084766,
                    53.9978812
                ],
                [
                    78.2076829,
                    53.9979145
                ],
                [
                    78.2071442,
                    53.9970813
                ],
                [
                    78.209724,
                    53.9960148
                ],
                [
                    78.2105178,
                    53.9969813
                ],
                [
                    78.2111131,
                    53.9970813
                ],
                [
                    78.2127184,
                    53.9988263
                ],
                [
                    78.2143165,
                    53.9995475
                ],
                [
                    78.2153087,
                    53.9999474
                ],
                [
                    78.2167829,
                    53.9995475
                ],
                [
                    78.2153654,
                    53.9975979
                ],
                [
                    78.2170947,
                    53.9972479
                ],
                [
                    78.2183137,
                    53.9972313
                ],
                [
                    78.2229346,
                    53.9967313
                ],
                [
                    78.2226794,
                    53.9957648
                ],
                [
                    78.2207801,
                    53.9956981
                ],
                [
                    78.2200997,
                    53.9937816
                ],
                [
                    78.2185972,
                    53.9933817
                ],
                [
                    78.2167262,
                    53.9932817
                ],
                [
                    78.2146283,
                    53.993915
                ],
                [
                    78.2145433,
                    53.9943483
                ],
                [
                    78.2113115,
                    53.9941149
                ],
                [
                    78.2092137,
                    53.993115
                ],
                [
                    78.2084483,
                    53.993015
                ],
                [
                    78.2080797,
                    53.9923817
                ],
                [
                    78.2061237,
                    53.9929317
                ],
                [
                    78.2056701,
                    53.9921984
                ],
                [
                    78.2037318,
                    53.9933187
                ],
                [
                    78.2015028,
                    53.9937983
                ],
                [
                    78.1997168,
                    53.9940483
                ],
                [
                    78.1965984,
                    53.993815
                ],
                [
                    78.1962299,
                    53.9949815
                ]
            ],
            "longitude": 78.213242,
            "latitude": 53.995731
        },
        "9765": {
            "name": "Обгонный Пункт Чебачий",
            "population": 24,
            "type": "hamlet",
            "poly": [
                [
                    78.2125901,
                    53.758606
                ],
                [
                    78.2160679,
                    53.7586354
                ],
                [
                    78.2161341,
                    53.7582829
                ],
                [
                    78.21731,
                    53.7583319
                ],
                [
                    78.2172934,
                    53.7575878
                ],
                [
                    78.2127226,
                    53.7575388
                ],
                [
                    78.2125901,
                    53.758606
                ]
            ],
            "longitude": 78.214592,
            "latitude": 53.758038
        },
        "9766": {
            "name": "Новоалексеевка",
            "population": 54,
            "type": "hamlet",
            "poly": [
                [
                    78.2092885,
                    54.7254563
                ],
                [
                    78.2103409,
                    54.7265907
                ],
                [
                    78.226758,
                    54.7311687
                ],
                [
                    78.2280683,
                    54.7286888
                ],
                [
                    78.2118142,
                    54.7239976
                ],
                [
                    78.2092885,
                    54.7254563
                ]
            ],
            "longitude": 78.217712,
            "latitude": 54.727821
        },
        "9767": {
            "name": "Весёлая",
            "population": 107,
            "type": "hamlet",
            "poly": [
                [
                    78.2115725,
                    56.6041364
                ],
                [
                    78.2127852,
                    56.6054715
                ],
                [
                    78.2124587,
                    56.6061647
                ],
                [
                    78.2133917,
                    56.6064984
                ],
                [
                    78.2127852,
                    56.6078334
                ],
                [
                    78.2144645,
                    56.6098101
                ],
                [
                    78.2173564,
                    56.6103749
                ],
                [
                    78.2195021,
                    56.6088346
                ],
                [
                    78.2212281,
                    56.6100338
                ],
                [
                    78.2227485,
                    56.6096315
                ],
                [
                    78.2238289,
                    56.6105538
                ],
                [
                    78.2239802,
                    56.6106829
                ],
                [
                    78.2242332,
                    56.6113581
                ],
                [
                    78.224421,
                    56.6118593
                ],
                [
                    78.2255964,
                    56.6117505
                ],
                [
                    78.2268831,
                    56.611545
                ],
                [
                    78.2286706,
                    56.6126799
                ],
                [
                    78.228851,
                    56.6126408
                ],
                [
                    78.2278764,
                    56.6118911
                ],
                [
                    78.2287176,
                    56.6115785
                ],
                [
                    78.22922,
                    56.6113392
                ],
                [
                    78.2295227,
                    56.6108134
                ],
                [
                    78.2299975,
                    56.610675
                ],
                [
                    78.2297497,
                    56.6101157
                ],
                [
                    78.2304215,
                    56.6096679
                ],
                [
                    78.2304,
                    56.609573
                ],
                [
                    78.2303175,
                    56.6092097
                ],
                [
                    78.2306959,
                    56.6090222
                ],
                [
                    78.2309304,
                    56.6081671
                ],
                [
                    78.2320966,
                    56.6074483
                ],
                [
                    78.2302307,
                    56.606216
                ],
                [
                    78.2310703,
                    56.6056769
                ],
                [
                    78.2276186,
                    56.603623
                ],
                [
                    78.2232339,
                    56.6020568
                ],
                [
                    78.2231279,
                    56.6021152
                ],
                [
                    78.2219439,
                    56.6027669
                ],
                [
                    78.2216946,
                    56.6029041
                ],
                [
                    78.2202668,
                    56.6030663
                ],
                [
                    78.2187559,
                    56.6032379
                ],
                [
                    78.2161438,
                    56.60275
                ],
                [
                    78.2143712,
                    56.6033406
                ],
                [
                    78.2119923,
                    56.6029555
                ],
                [
                    78.2115725,
                    56.6041364
                ]
            ],
            "longitude": 78.224602,
            "latitude": 56.606434
        },
        "9768": {
            "name": "Ивушка",
            "population": 211,
            "type": "hamlet",
            "poly": [
                [
                    78.2145984,
                    55.5398624
                ],
                [
                    78.2166682,
                    55.5410928
                ],
                [
                    78.2153582,
                    55.5421601
                ],
                [
                    78.2184235,
                    55.5437166
                ],
                [
                    78.2199955,
                    55.5448579
                ],
                [
                    78.2217508,
                    55.5449469
                ],
                [
                    78.2243445,
                    55.5452433
                ],
                [
                    78.2252877,
                    55.5464884
                ],
                [
                    78.2310516,
                    55.5474666
                ],
                [
                    78.2340645,
                    55.5454657
                ],
                [
                    78.2277243,
                    55.5427827
                ],
                [
                    78.2296368,
                    55.5412411
                ],
                [
                    78.2248161,
                    55.5395659
                ],
                [
                    78.222432,
                    55.5405295
                ],
                [
                    78.2207814,
                    55.5397142
                ],
                [
                    78.2192881,
                    55.5384096
                ],
                [
                    78.2183711,
                    55.5389729
                ],
                [
                    78.2191309,
                    55.5395659
                ],
                [
                    78.2180567,
                    55.5398772
                ],
                [
                    78.2169825,
                    55.539136
                ],
                [
                    78.2161442,
                    55.5391508
                ],
                [
                    78.2145984,
                    55.5398624
                ]
            ],
            "longitude": 78.224854,
            "latitude": 55.542126
        },
        "9769": {
            "name": "Дунаевка",
            "population": 192,
            "type": "hamlet",
            "poly": [
                [
                    78.2158833,
                    55.2146966
                ],
                [
                    78.2175108,
                    55.2162379
                ],
                [
                    78.2180968,
                    55.2165165
                ],
                [
                    78.2183572,
                    55.2163308
                ],
                [
                    78.2207986,
                    55.2174078
                ],
                [
                    78.2217426,
                    55.2185034
                ],
                [
                    78.2230121,
                    55.219339
                ],
                [
                    78.2213845,
                    55.2200075
                ],
                [
                    78.2232724,
                    55.22166
                ],
                [
                    78.2277972,
                    55.2250949
                ],
                [
                    78.2299781,
                    55.226413
                ],
                [
                    78.2342749,
                    55.2238695
                ],
                [
                    78.2343401,
                    55.2215301
                ],
                [
                    78.2324521,
                    55.2209916
                ],
                [
                    78.2313453,
                    55.2195247
                ],
                [
                    78.2316708,
                    55.2191905
                ],
                [
                    78.2304013,
                    55.2175564
                ],
                [
                    78.2174783,
                    55.212598
                ],
                [
                    78.2162412,
                    55.2136566
                ],
                [
                    78.2165343,
                    55.2140095
                ],
                [
                    78.2158833,
                    55.2146966
                ]
            ],
            "longitude": 78.225616,
            "latitude": 55.220062
        },
        "9770": {
            "name": "Нижнебаяновский",
            "population": 165,
            "type": "hamlet",
            "poly": [
                [
                    78.2329869,
                    53.8583491
                ],
                [
                    78.2337503,
                    53.8597748
                ],
                [
                    78.2364222,
                    53.8616507
                ],
                [
                    78.2373553,
                    53.8620634
                ],
                [
                    78.2375461,
                    53.8627012
                ],
                [
                    78.2393698,
                    53.8639142
                ],
                [
                    78.2396667,
                    53.863639
                ],
                [
                    78.2402816,
                    53.8639267
                ],
                [
                    78.2412783,
                    53.8631889
                ],
                [
                    78.2398363,
                    53.862226
                ],
                [
                    78.2394674,
                    53.8625008
                ],
                [
                    78.2389148,
                    53.8621249
                ],
                [
                    78.2413419,
                    53.8607378
                ],
                [
                    78.2399847,
                    53.8596748
                ],
                [
                    78.238776,
                    53.8584366
                ],
                [
                    78.2422537,
                    53.8602375
                ],
                [
                    78.2425718,
                    53.8600249
                ],
                [
                    78.2416388,
                    53.8593121
                ],
                [
                    78.2391789,
                    53.8579614
                ],
                [
                    78.2385004,
                    53.8579864
                ],
                [
                    78.2374825,
                    53.8586742
                ],
                [
                    78.2371644,
                    53.8583741
                ],
                [
                    78.2372704,
                    53.8580114
                ],
                [
                    78.236507,
                    53.8578488
                ],
                [
                    78.2363374,
                    53.858149
                ],
                [
                    78.2358285,
                    53.858224
                ],
                [
                    78.2352771,
                    53.8580614
                ],
                [
                    78.2340472,
                    53.8575486
                ],
                [
                    78.2349166,
                    53.8567232
                ],
                [
                    78.2333898,
                    53.8561479
                ],
                [
                    78.2331778,
                    53.8567482
                ],
                [
                    78.233199,
                    53.8576112
                ],
                [
                    78.2329869,
                    53.8583491
                ]
            ],
            "longitude": 78.237671,
            "latitude": 53.860062
        },
        "9771": {
            "name": "Бергуль",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    78.2479295,
                    55.6042936
                ],
                [
                    78.2512339,
                    55.6056857
                ],
                [
                    78.2563586,
                    55.6076946
                ],
                [
                    78.2662998,
                    55.6110004
                ],
                [
                    78.2677,
                    55.6096718
                ],
                [
                    78.2650956,
                    55.6084064
                ],
                [
                    78.259915,
                    55.6067139
                ],
                [
                    78.259523,
                    55.6061445
                ],
                [
                    78.2591261,
                    55.6052239
                ],
                [
                    78.2565266,
                    55.6052111
                ],
                [
                    78.2551544,
                    55.6042778
                ],
                [
                    78.2493017,
                    55.6028541
                ],
                [
                    78.2479295,
                    55.6042936
                ]
            ],
            "longitude": 78.258331,
            "latitude": 55.607029
        },
        "9772": {
            "name": "Карасарт",
            "population": 249,
            "type": "hamlet",
            "poly": [
                [
                    78.257439,
                    53.6260508
                ],
                [
                    78.2575182,
                    53.6265674
                ],
                [
                    78.2610549,
                    53.6267708
                ],
                [
                    78.2617147,
                    53.625362
                ],
                [
                    78.2643805,
                    53.6253465
                ],
                [
                    78.2645124,
                    53.6250647
                ],
                [
                    78.2660169,
                    53.6245795
                ],
                [
                    78.2634831,
                    53.6214644
                ],
                [
                    78.2626121,
                    53.6217148
                ],
                [
                    78.2621106,
                    53.6208225
                ],
                [
                    78.2602895,
                    53.6204625
                ],
                [
                    78.2605534,
                    53.6209947
                ],
                [
                    78.2596296,
                    53.62112
                ],
                [
                    78.2597352,
                    53.6217774
                ],
                [
                    78.2588378,
                    53.6225601
                ],
                [
                    78.2578613,
                    53.6225444
                ],
                [
                    78.257914,
                    53.6229358
                ],
                [
                    78.2587587,
                    53.6231237
                ],
                [
                    78.2581516,
                    53.625143
                ],
                [
                    78.2588378,
                    53.6251273
                ],
                [
                    78.2587587,
                    53.6256595
                ],
                [
                    78.2594449,
                    53.6257065
                ],
                [
                    78.2593921,
                    53.6260821
                ],
                [
                    78.257439,
                    53.6260508
                ]
            ],
            "longitude": 78.261238,
            "latitude": 53.624016
        },
        "9773": {
            "name": "Мамон",
            "population": 108,
            "type": "hamlet",
            "poly": [
                [
                    78.2572016,
                    54.441322
                ],
                [
                    78.2579098,
                    54.4440319
                ],
                [
                    78.2580933,
                    54.4454192
                ],
                [
                    78.263599,
                    54.4477669
                ],
                [
                    78.2641037,
                    54.4467531
                ],
                [
                    78.2669483,
                    54.4468332
                ],
                [
                    78.2681871,
                    54.4465664
                ],
                [
                    78.2695176,
                    54.4454192
                ],
                [
                    78.2727751,
                    54.4462729
                ],
                [
                    78.273188,
                    54.445606
                ],
                [
                    78.2755279,
                    54.446353
                ],
                [
                    78.277042,
                    54.4445922
                ],
                [
                    78.2762161,
                    54.4436584
                ],
                [
                    78.2697929,
                    54.4417107
                ],
                [
                    78.2700682,
                    54.4412572
                ],
                [
                    78.2635531,
                    54.439763
                ],
                [
                    78.2599286,
                    54.4393094
                ],
                [
                    78.2582769,
                    54.4401099
                ],
                [
                    78.2572016,
                    54.441322
                ]
            ],
            "longitude": 78.262474,
            "latitude": 54.442963
        },
        "9774": {
            "name": "Голованово",
            "population": 145,
            "type": "hamlet",
            "poly": [
                [
                    78.2663526,
                    54.985117
                ],
                [
                    78.2665658,
                    54.9860193
                ],
                [
                    78.2678718,
                    54.9864628
                ],
                [
                    78.2671788,
                    54.9872427
                ],
                [
                    78.2746151,
                    54.9895518
                ],
                [
                    78.2752281,
                    54.9883284
                ],
                [
                    78.2736022,
                    54.9878391
                ],
                [
                    78.275388,
                    54.9858969
                ],
                [
                    78.2755479,
                    54.984857
                ],
                [
                    78.2681117,
                    54.9830064
                ],
                [
                    78.2669389,
                    54.9841994
                ],
                [
                    78.2663526,
                    54.985117
                ]
            ],
            "longitude": 78.270508,
            "latitude": 54.985821
        },
        "9775": {
            "name": "Сизево",
            "population": 269,
            "type": "hamlet",
            "poly": [
                [
                    78.2595653,
                    54.8931147
                ],
                [
                    78.2615251,
                    54.8940624
                ],
                [
                    78.2667808,
                    54.8957529
                ],
                [
                    78.2707004,
                    54.8972385
                ],
                [
                    78.2729274,
                    54.8980325
                ],
                [
                    78.2750207,
                    54.8985703
                ],
                [
                    78.27364,
                    54.8998253
                ],
                [
                    78.2779604,
                    54.9012339
                ],
                [
                    78.2791184,
                    54.9000302
                ],
                [
                    78.2807219,
                    54.9003887
                ],
                [
                    78.2829934,
                    54.8988008
                ],
                [
                    78.2821472,
                    54.8975458
                ],
                [
                    78.2766687,
                    54.8964701
                ],
                [
                    78.2696314,
                    54.8943186
                ],
                [
                    78.2626831,
                    54.8917058
                ],
                [
                    78.2615696,
                    54.8927817
                ],
                [
                    78.260367,
                    54.8924487
                ],
                [
                    78.2595653,
                    54.8931147
                ]
            ],
            "longitude": 78.273209,
            "latitude": 54.897358
        },
        "9776": {
            "name": "Стеклянный",
            "population": 11,
            "type": "hamlet",
            "poly": [
                [
                    78.2674726,
                    53.7571143
                ],
                [
                    78.2676239,
                    53.7579636
                ],
                [
                    78.2703836,
                    53.7582095
                ],
                [
                    78.2711019,
                    53.7583883
                ],
                [
                    78.2715178,
                    53.7577625
                ],
                [
                    78.2740129,
                    53.7578072
                ],
                [
                    78.2734458,
                    53.7585224
                ],
                [
                    78.2777933,
                    53.7592375
                ],
                [
                    78.2804019,
                    53.7591258
                ],
                [
                    78.283086,
                    53.7586341
                ],
                [
                    78.2866397,
                    53.757226
                ],
                [
                    78.2851275,
                    53.755885
                ],
                [
                    78.2831994,
                    53.7557285
                ],
                [
                    78.2802507,
                    53.7556168
                ],
                [
                    78.2784738,
                    53.7553039
                ],
                [
                    78.2770373,
                    53.7555274
                ],
                [
                    78.2752603,
                    53.754678
                ],
                [
                    78.2743531,
                    53.7553262
                ],
                [
                    78.2717824,
                    53.756265
                ],
                [
                    78.2674726,
                    53.7571143
                ]
            ],
            "longitude": 78.278206,
            "latitude": 53.757694
        },
        "9777": {
            "name": "Малые Кайлы",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.283661,
            "latitude": 55.419395
        },
        "9778": {
            "name": "Остановочная Площадка 391 км",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.286911,
            "latitude": 53.756035
        },
        "9779": {
            "name": "Заречный",
            "population": 244,
            "type": "hamlet",
            "poly": [
                [
                    78.2826991,
                    55.469677
                ],
                [
                    78.2949489,
                    55.4738003
                ],
                [
                    78.2980781,
                    55.4709064
                ],
                [
                    78.2837399,
                    55.4675166
                ],
                [
                    78.2826991,
                    55.469677
                ]
            ],
            "longitude": 78.289137,
            "latitude": 55.4709493
        },
        "9780": {
            "name": "Кордон",
            "population": 117,
            "type": "hamlet",
            "poly": [
                [
                    78.2807639,
                    56.6118723
                ],
                [
                    78.2814951,
                    56.6126267
                ],
                [
                    78.2825462,
                    56.612413
                ],
                [
                    78.282729,
                    56.6133183
                ],
                [
                    78.28394,
                    56.614538
                ],
                [
                    78.2867963,
                    56.6145003
                ],
                [
                    78.2887843,
                    56.6149152
                ],
                [
                    78.2894241,
                    56.6147266
                ],
                [
                    78.2907951,
                    56.6149026
                ],
                [
                    78.2908178,
                    56.6154936
                ],
                [
                    78.2930573,
                    56.6156948
                ],
                [
                    78.295388,
                    56.6157325
                ],
                [
                    78.2965305,
                    56.6158582
                ],
                [
                    78.296759,
                    56.615305
                ],
                [
                    78.2994553,
                    56.6155942
                ],
                [
                    78.3020602,
                    56.6163234
                ],
                [
                    78.3024258,
                    56.6166755
                ],
                [
                    78.3039796,
                    56.6169646
                ],
                [
                    78.3038425,
                    56.6158834
                ],
                [
                    78.3039796,
                    56.6152798
                ],
                [
                    78.3024258,
                    56.6136452
                ],
                [
                    78.3020291,
                    56.6132853
                ],
                [
                    78.301329,
                    56.6130543
                ],
                [
                    78.3013747,
                    56.6121866
                ],
                [
                    78.2992039,
                    56.6120483
                ],
                [
                    78.2983813,
                    56.6122369
                ],
                [
                    78.2961192,
                    56.612086
                ],
                [
                    78.2952509,
                    56.6124507
                ],
                [
                    78.294931,
                    56.6128908
                ],
                [
                    78.2944054,
                    56.6128531
                ],
                [
                    78.2945425,
                    56.6124255
                ],
                [
                    78.2933086,
                    56.6123752
                ],
                [
                    78.2909322,
                    56.6116836
                ],
                [
                    78.2899039,
                    56.6117088
                ],
                [
                    78.2887157,
                    56.6115076
                ],
                [
                    78.287459,
                    56.611583
                ],
                [
                    78.2861336,
                    56.6116962
                ],
                [
                    78.2860194,
                    56.6109795
                ],
                [
                    78.2838029,
                    56.6108663
                ],
                [
                    78.2823176,
                    56.6114699
                ],
                [
                    78.2812894,
                    56.6115076
                ],
                [
                    78.2807639,
                    56.6118723
                ]
            ],
            "longitude": 78.293442,
            "latitude": 56.614075
        },
        "9781": {
            "name": "Светлое",
            "population": 156,
            "type": "hamlet",
            "poly": [
                [
                    78.283342,
                    54.4895336
                ],
                [
                    78.2869981,
                    54.4911575
                ],
                [
                    78.2915145,
                    54.4912824
                ],
                [
                    78.2906542,
                    54.492365
                ],
                [
                    78.2978947,
                    54.4942386
                ],
                [
                    78.300834,
                    54.4948215
                ],
                [
                    78.301049,
                    54.4942386
                ],
                [
                    78.3059238,
                    54.4954044
                ],
                [
                    78.3075727,
                    54.4953211
                ],
                [
                    78.3079311,
                    54.4944885
                ],
                [
                    78.3134511,
                    54.4956959
                ],
                [
                    78.3139529,
                    54.494655
                ],
                [
                    78.3104402,
                    54.4925316
                ],
                [
                    78.306569,
                    54.4914906
                ],
                [
                    78.3054937,
                    54.4922817
                ],
                [
                    78.2984682,
                    54.4899083
                ],
                [
                    78.2946688,
                    54.4881178
                ],
                [
                    78.2885753,
                    54.4862855
                ],
                [
                    78.2866397,
                    54.4867852
                ],
                [
                    78.283342,
                    54.4895336
                ]
            ],
            "longitude": 78.296608,
            "latitude": 54.491657
        },
        "9782": {
            "name": "Немки",
            "population": 58,
            "type": "hamlet",
            "poly": [
                [
                    78.3027376,
                    54.3126388
                ],
                [
                    78.3047255,
                    54.3133586
                ],
                [
                    78.3132255,
                    54.3149581
                ],
                [
                    78.3152737,
                    54.3152692
                ],
                [
                    78.3248101,
                    54.3167174
                ],
                [
                    78.3292657,
                    54.315078
                ],
                [
                    78.3295399,
                    54.3136385
                ],
                [
                    78.3194633,
                    54.3117591
                ],
                [
                    78.3152134,
                    54.3110393
                ],
                [
                    78.3130884,
                    54.3116391
                ],
                [
                    78.3102779,
                    54.3104794
                ],
                [
                    78.3052739,
                    54.3103194
                ],
                [
                    78.3033546,
                    54.3109593
                ],
                [
                    78.3027376,
                    54.3126388
                ]
            ],
            "longitude": 78.317337,
            "latitude": 54.31348
        },
        "9783": {
            "name": "Токаревка",
            "population": 167,
            "type": "hamlet",
            "poly": [
                [
                    78.3388021,
                    53.5932225
                ],
                [
                    78.3410457,
                    53.5929071
                ],
                [
                    78.3410457,
                    53.5926618
                ],
                [
                    78.3418723,
                    53.5925391
                ],
                [
                    78.3422265,
                    53.5928896
                ],
                [
                    78.3431121,
                    53.5927143
                ],
                [
                    78.3432007,
                    53.5933626
                ],
                [
                    78.3420789,
                    53.593643
                ],
                [
                    78.3432301,
                    53.5950096
                ],
                [
                    78.3445586,
                    53.5948344
                ],
                [
                    78.3456509,
                    53.5970419
                ],
                [
                    78.3465365,
                    53.5970244
                ],
                [
                    78.3466251,
                    53.5976551
                ],
                [
                    78.3468318,
                    53.6000901
                ],
                [
                    78.3477764,
                    53.6000901
                ],
                [
                    78.3502562,
                    53.5993544
                ],
                [
                    78.3499019,
                    53.5974974
                ],
                [
                    78.3494001,
                    53.5965688
                ],
                [
                    78.3498429,
                    53.5959557
                ],
                [
                    78.3489573,
                    53.59331
                ],
                [
                    78.3478355,
                    53.5930648
                ],
                [
                    78.3463299,
                    53.5932575
                ],
                [
                    78.3460347,
                    53.5921887
                ],
                [
                    78.3479536,
                    53.5917156
                ],
                [
                    78.3468022,
                    53.5901737
                ],
                [
                    78.3459166,
                    53.5902087
                ],
                [
                    78.3456509,
                    53.5898408
                ],
                [
                    78.3465365,
                    53.5895954
                ],
                [
                    78.3464185,
                    53.5884565
                ],
                [
                    78.3457985,
                    53.588071
                ],
                [
                    78.3442634,
                    53.5882287
                ],
                [
                    78.3416656,
                    53.5886142
                ],
                [
                    78.3406914,
                    53.5891574
                ],
                [
                    78.340839,
                    53.5901036
                ],
                [
                    78.3392154,
                    53.5901036
                ],
                [
                    78.3395696,
                    53.5908045
                ],
                [
                    78.3402781,
                    53.5916105
                ],
                [
                    78.3390678,
                    53.5917857
                ],
                [
                    78.3388021,
                    53.5932225
                ]
            ],
            "longitude": 78.345856,
            "latitude": 53.594345
        },
        "9784": {
            "name": "Грамотино",
            "population": 133,
            "type": "hamlet",
            "poly": [
                [
                    78.3457002,
                    53.7429621
                ],
                [
                    78.3468495,
                    53.7431946
                ],
                [
                    78.346789,
                    53.7448222
                ],
                [
                    78.3491178,
                    53.7452157
                ],
                [
                    78.3493899,
                    53.7446612
                ],
                [
                    78.3511441,
                    53.7450368
                ],
                [
                    78.3505392,
                    53.74611
                ],
                [
                    78.3498134,
                    53.7464498
                ],
                [
                    78.3487246,
                    53.7461994
                ],
                [
                    78.3481802,
                    53.7466286
                ],
                [
                    78.3495109,
                    53.7472188
                ],
                [
                    78.3485507,
                    53.7478392
                ],
                [
                    78.3498266,
                    53.7477833
                ],
                [
                    78.350819,
                    53.7481186
                ],
                [
                    78.3512915,
                    53.7488731
                ],
                [
                    78.3509135,
                    53.7504938
                ],
                [
                    78.3520004,
                    53.7502982
                ],
                [
                    78.3524729,
                    53.7487334
                ],
                [
                    78.3556863,
                    53.7450447
                ],
                [
                    78.3535598,
                    53.7439547
                ],
                [
                    78.3487397,
                    53.7422499
                ],
                [
                    78.3499211,
                    53.7399581
                ],
                [
                    78.3481254,
                    53.7395948
                ],
                [
                    78.3460631,
                    53.7410124
                ],
                [
                    78.3457002,
                    53.7429621
                ]
            ],
            "longitude": 78.35257,
            "latitude": 53.745838
        },
        "9785": {
            "name": "Горка",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.356316,
            "latitude": 55.406998
        },
        "9786": {
            "name": "Щелчиха",
            "population": 86,
            "type": "hamlet",
            "poly": [
                [
                    78.3787002,
                    54.6637211
                ],
                [
                    78.3821616,
                    54.6640562
                ],
                [
                    78.3853415,
                    54.6648167
                ],
                [
                    78.3896086,
                    54.6657814
                ],
                [
                    78.3913317,
                    54.6663229
                ],
                [
                    78.3928448,
                    54.6674038
                ],
                [
                    78.393881,
                    54.6676676
                ],
                [
                    78.3958744,
                    54.6653175
                ],
                [
                    78.3917342,
                    54.6641202
                ],
                [
                    78.3884374,
                    54.6629229
                ],
                [
                    78.3828404,
                    54.6614151
                ],
                [
                    78.381537,
                    54.6625681
                ],
                [
                    78.3799269,
                    54.6621247
                ],
                [
                    78.3787002,
                    54.6637211
                ]
            ],
            "longitude": 78.38829,
            "latitude": 54.664314
        },
        "9787": {
            "name": "Озерянка",
            "population": 13,
            "type": "hamlet",
            "poly": [
                [
                    78.389195,
                    53.6218858
                ],
                [
                    78.3909271,
                    53.623769
                ],
                [
                    78.3956284,
                    53.626166
                ],
                [
                    78.3972368,
                    53.6241605
                ],
                [
                    78.3959171,
                    53.6232066
                ],
                [
                    78.3969481,
                    53.6225217
                ],
                [
                    78.3976904,
                    53.6228152
                ],
                [
                    78.399175,
                    53.6213477
                ],
                [
                    78.4019794,
                    53.6185591
                ],
                [
                    78.399505,
                    53.6173116
                ],
                [
                    78.3988039,
                    53.6178742
                ],
                [
                    78.3979379,
                    53.6179964
                ],
                [
                    78.3969481,
                    53.6185347
                ],
                [
                    78.3967007,
                    53.6191951
                ],
                [
                    78.3952985,
                    53.6194153
                ],
                [
                    78.3940613,
                    53.6194397
                ],
                [
                    78.3927004,
                    53.6203937
                ],
                [
                    78.3921231,
                    53.6200757
                ],
                [
                    78.3930716,
                    53.6191462
                ],
                [
                    78.3909271,
                    53.618339
                ],
                [
                    78.3896487,
                    53.6194642
                ],
                [
                    78.3910921,
                    53.6202714
                ],
                [
                    78.389195,
                    53.6218858
                ]
            ],
            "longitude": 78.394798,
            "latitude": 53.621639
        },
        "9788": {
            "name": "Новая Курья",
            "population": 162,
            "type": "hamlet",
            "poly": [
                [
                    78.3806803,
                    53.8376524
                ],
                [
                    78.380708,
                    53.8393997
                ],
                [
                    78.3830881,
                    53.8393507
                ],
                [
                    78.3931618,
                    53.8414245
                ],
                [
                    78.3960123,
                    53.8424695
                ],
                [
                    78.3959016,
                    53.8429104
                ],
                [
                    78.3957909,
                    53.8448044
                ],
                [
                    78.397147,
                    53.8453922
                ],
                [
                    78.3980049,
                    53.8452779
                ],
                [
                    78.4017134,
                    53.844282
                ],
                [
                    78.4014643,
                    53.8440044
                ],
                [
                    78.40711,
                    53.8439064
                ],
                [
                    78.4092687,
                    53.8447228
                ],
                [
                    78.4102096,
                    53.8447228
                ],
                [
                    78.4100436,
                    53.8428124
                ],
                [
                    78.4086598,
                    53.8425348
                ],
                [
                    78.4068886,
                    53.8423389
                ],
                [
                    78.4062244,
                    53.8423389
                ],
                [
                    78.4043979,
                    53.8424205
                ],
                [
                    78.4021765,
                    53.8420292
                ],
                [
                    78.4000632,
                    53.8416105
                ],
                [
                    78.395828,
                    53.8400491
                ],
                [
                    78.3932448,
                    53.839416
                ],
                [
                    78.3878758,
                    53.8383546
                ],
                [
                    78.3876268,
                    53.8387301
                ],
                [
                    78.3870179,
                    53.8386485
                ],
                [
                    78.3869349,
                    53.8381749
                ],
                [
                    78.3813722,
                    53.8374237
                ],
                [
                    78.3806803,
                    53.8376524
                ]
            ],
            "longitude": 78.398613,
            "latitude": 53.843384
        },
        "9789": {
            "name": "Ваганово",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.402603,
            "latitude": 55.872227
        },
        "9790": {
            "name": "Покровка",
            "population": 38,
            "type": "hamlet",
            "poly": [
                [
                    78.3986842,
                    54.1133028
                ],
                [
                    78.4038441,
                    54.1150083
                ],
                [
                    78.4094133,
                    54.1150216
                ],
                [
                    78.4131639,
                    54.1158211
                ],
                [
                    78.4168691,
                    54.1154746
                ],
                [
                    78.4166645,
                    54.1130363
                ],
                [
                    78.4148688,
                    54.1113307
                ],
                [
                    78.4090041,
                    54.1117837
                ],
                [
                    78.4049807,
                    54.111304
                ],
                [
                    78.3990024,
                    54.1115972
                ],
                [
                    78.3986842,
                    54.1133028
                ]
            ],
            "longitude": 78.412079,
            "latitude": 54.114002
        },
        "9791": {
            "name": "Надеждинка",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    78.418781,
                    56.7710685
                ],
                [
                    78.4199121,
                    56.771816
                ],
                [
                    78.4199787,
                    56.7727822
                ],
                [
                    78.4219748,
                    56.773001
                ],
                [
                    78.42274,
                    56.7729098
                ],
                [
                    78.4217752,
                    56.7743317
                ],
                [
                    78.4228731,
                    56.7745687
                ],
                [
                    78.4220746,
                    56.7753708
                ],
                [
                    78.4225737,
                    56.775389
                ],
                [
                    78.4240375,
                    56.7750974
                ],
                [
                    78.4247695,
                    56.775863
                ],
                [
                    78.4256677,
                    56.7754255
                ],
                [
                    78.4268654,
                    56.7757354
                ],
                [
                    78.4275308,
                    56.7750245
                ],
                [
                    78.4269985,
                    56.7748604
                ],
                [
                    78.4273312,
                    56.7743317
                ],
                [
                    78.4336857,
                    56.7748604
                ],
                [
                    78.4340849,
                    56.7738942
                ],
                [
                    78.4349499,
                    56.7732562
                ],
                [
                    78.4323549,
                    56.7728551
                ],
                [
                    78.432488,
                    56.7720712
                ],
                [
                    78.4315232,
                    56.7717977
                ],
                [
                    78.430392,
                    56.7717977
                ],
                [
                    78.4275308,
                    56.7711961
                ],
                [
                    78.4265993,
                    56.7713602
                ],
                [
                    78.4270318,
                    56.7705216
                ],
                [
                    78.4261668,
                    56.7703939
                ],
                [
                    78.4256677,
                    56.7706856
                ],
                [
                    78.4235051,
                    56.7701387
                ],
                [
                    78.4236382,
                    56.7694459
                ],
                [
                    78.4226735,
                    56.7693912
                ],
                [
                    78.4220414,
                    56.7700658
                ],
                [
                    78.4212096,
                    56.7697194
                ],
                [
                    78.4205442,
                    56.7705216
                ],
                [
                    78.4194463,
                    56.7705762
                ],
                [
                    78.418781,
                    56.7710685
                ]
            ],
            "longitude": 78.425438,
            "latitude": 56.772854
        },
        "9792": {
            "name": "Малинино",
            "population": 82,
            "type": "hamlet",
            "poly": [
                [
                    78.4246263,
                    55.4687115
                ],
                [
                    78.4256318,
                    55.4695038
                ],
                [
                    78.4282311,
                    55.4707965
                ],
                [
                    78.4314191,
                    55.471005
                ],
                [
                    78.4360293,
                    55.4704212
                ],
                [
                    78.4386532,
                    55.4685363
                ],
                [
                    78.4361285,
                    55.4622522
                ],
                [
                    78.4334065,
                    55.4621782
                ],
                [
                    78.4332056,
                    55.462816
                ],
                [
                    78.4340593,
                    55.4653215
                ],
                [
                    78.4341196,
                    55.4663635
                ],
                [
                    78.4334299,
                    55.4671684
                ],
                [
                    78.431836,
                    55.4679608
                ],
                [
                    78.4299477,
                    55.4678913
                ],
                [
                    78.4261958,
                    55.4671406
                ],
                [
                    78.4252394,
                    55.4678774
                ],
                [
                    78.4246263,
                    55.4687115
                ]
            ],
            "longitude": 78.436401,
            "latitude": 55.468014
        },
        "9793": {
            "name": "Анган",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    78.4375507,
                    55.6428434
                ],
                [
                    78.4458621,
                    55.6447777
                ],
                [
                    78.4512388,
                    55.6463074
                ],
                [
                    78.4564811,
                    55.6474957
                ],
                [
                    78.4594383,
                    55.6474957
                ],
                [
                    78.4601551,
                    55.6465729
                ],
                [
                    78.4601103,
                    55.6448915
                ],
                [
                    78.4588334,
                    55.6443984
                ],
                [
                    78.4532327,
                    55.6428434
                ],
                [
                    78.4497379,
                    55.6423756
                ],
                [
                    78.4472287,
                    55.6419963
                ],
                [
                    78.4454365,
                    55.6415538
                ],
                [
                    78.4438907,
                    55.6414273
                ],
                [
                    78.4449437,
                    55.6402641
                ],
                [
                    78.4428378,
                    55.6398342
                ],
                [
                    78.4407095,
                    55.641086
                ],
                [
                    78.4401655,
                    55.6411605
                ],
                [
                    78.4391413,
                    55.6413009
                ],
                [
                    78.4375507,
                    55.6428434
                ]
            ],
            "longitude": 78.45118,
            "latitude": 55.64389
        },
        "9794": {
            "name": "Патрушево",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.45153,
            "latitude": 55.575287
        },
        "9795": {
            "name": "Новогутово",
            "population": 134,
            "type": "hamlet",
            "poly": [
                [
                    78.4541687,
                    55.3065116
                ],
                [
                    78.4584531,
                    55.3096275
                ],
                [
                    78.4590482,
                    55.3103048
                ],
                [
                    78.4661888,
                    55.3122555
                ],
                [
                    78.4670456,
                    55.3119168
                ],
                [
                    78.4709016,
                    55.3147885
                ],
                [
                    78.4750431,
                    55.3123638
                ],
                [
                    78.4693544,
                    55.3084489
                ],
                [
                    78.4655699,
                    55.3067148
                ],
                [
                    78.461714,
                    55.3053736
                ],
                [
                    78.458422,
                    55.3045356
                ],
                [
                    78.4578819,
                    55.3043981
                ],
                [
                    78.4568584,
                    55.304371
                ],
                [
                    78.4558463,
                    55.3048918
                ],
                [
                    78.4550732,
                    55.305333
                ],
                [
                    78.4541687,
                    55.3065116
                ]
            ],
            "longitude": 78.460533,
            "latitude": 55.308029
        },
        "9796": {
            "name": "Сартаково",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    78.4710771,
                    55.4551906
                ],
                [
                    78.4714501,
                    55.4559631
                ],
                [
                    78.4723421,
                    55.4564688
                ],
                [
                    78.4730718,
                    55.4572229
                ],
                [
                    78.4732016,
                    55.4577746
                ],
                [
                    78.4738017,
                    55.4597608
                ],
                [
                    78.4755694,
                    55.459816
                ],
                [
                    78.476656,
                    55.4594206
                ],
                [
                    78.4807428,
                    55.4584275
                ],
                [
                    78.4788616,
                    55.457085
                ],
                [
                    78.4756018,
                    55.4563769
                ],
                [
                    78.4722285,
                    55.4548503
                ],
                [
                    78.4710771,
                    55.4551906
                ]
            ],
            "longitude": 78.475235,
            "latitude": 55.457317
        },
        "9797": {
            "name": "Крыловка",
            "population": 251,
            "type": "hamlet",
            "poly": [
                [
                    78.4746457,
                    54.0236003
                ],
                [
                    78.4791371,
                    54.0258983
                ],
                [
                    78.4811655,
                    54.0262812
                ],
                [
                    78.4809481,
                    54.0270472
                ],
                [
                    78.484208,
                    54.0285365
                ],
                [
                    78.4835561,
                    54.0290046
                ],
                [
                    78.4876128,
                    54.0304513
                ],
                [
                    78.4900034,
                    54.0302386
                ],
                [
                    78.4934082,
                    54.0292599
                ],
                [
                    78.4910901,
                    54.027728
                ],
                [
                    78.4867435,
                    54.0252599
                ],
                [
                    78.4873231,
                    54.0243663
                ],
                [
                    78.4851742,
                    54.0224442
                ],
                [
                    78.4823245,
                    54.0210042
                ],
                [
                    78.4813828,
                    54.0215575
                ],
                [
                    78.4787024,
                    54.0199828
                ],
                [
                    78.4764567,
                    54.01977
                ],
                [
                    78.4758772,
                    54.0203658
                ],
                [
                    78.4765292,
                    54.0209617
                ],
                [
                    78.4751528,
                    54.0220256
                ],
                [
                    78.4746457,
                    54.0236003
                ]
            ],
            "longitude": 78.483849,
            "latitude": 54.025089
        },
        "9798": {
            "name": "Кармышак",
            "population": 185,
            "type": "hamlet",
            "poly": [
                [
                    78.4965394,
                    55.1784144
                ],
                [
                    78.4978267,
                    55.1786803
                ],
                [
                    78.4968738,
                    55.1798306
                ],
                [
                    78.4987965,
                    55.1803238
                ],
                [
                    78.4988522,
                    55.1805943
                ],
                [
                    78.5006356,
                    55.1811194
                ],
                [
                    78.5008028,
                    55.1808648
                ],
                [
                    78.5035615,
                    55.1813421
                ],
                [
                    78.5069301,
                    55.1820776
                ],
                [
                    78.5104722,
                    55.1836332
                ],
                [
                    78.5128965,
                    55.1841423
                ],
                [
                    78.5226495,
                    55.1842219
                ],
                [
                    78.5226773,
                    55.1834105
                ],
                [
                    78.5203087,
                    55.181724
                ],
                [
                    78.5171599,
                    55.1809921
                ],
                [
                    78.5128095,
                    55.1807939
                ],
                [
                    78.5132866,
                    55.1792419
                ],
                [
                    78.5117819,
                    55.1783985
                ],
                [
                    78.5089396,
                    55.1776984
                ],
                [
                    78.5054842,
                    55.17921
                ],
                [
                    78.4978491,
                    55.1771574
                ],
                [
                    78.4965394,
                    55.1784144
                ]
            ],
            "longitude": 78.510201,
            "latitude": 55.18119
        },
        "9799": {
            "name": "Помельцево",
            "population": 213,
            "type": "hamlet",
            "poly": [
                [
                    78.5013702,
                    55.4606863
                ],
                [
                    78.5024509,
                    55.4613057
                ],
                [
                    78.5037915,
                    55.4613741
                ],
                [
                    78.5055746,
                    55.4614045
                ],
                [
                    78.5078269,
                    55.4618758
                ],
                [
                    78.5091356,
                    55.4631842
                ],
                [
                    78.5092956,
                    55.4640944
                ],
                [
                    78.5085998,
                    55.4691349
                ],
                [
                    78.509303,
                    55.4695335
                ],
                [
                    78.5118601,
                    55.4687001
                ],
                [
                    78.5137779,
                    55.4662358
                ],
                [
                    78.5163986,
                    55.465385
                ],
                [
                    78.5202532,
                    55.4655559
                ],
                [
                    78.5210813,
                    55.4649762
                ],
                [
                    78.5056856,
                    55.4591823
                ],
                [
                    78.5035823,
                    55.4599286
                ],
                [
                    78.5013702,
                    55.4606863
                ]
            ],
            "longitude": 78.51355,
            "latitude": 55.463673
        },
        "9800": {
            "name": "Новогребенщиково",
            "population": 72,
            "type": "hamlet",
            "poly": [
                [
                    78.5037728,
                    54.8998907
                ],
                [
                    78.5049644,
                    54.9003396
                ],
                [
                    78.5062381,
                    54.8991583
                ],
                [
                    78.5091143,
                    54.9011193
                ],
                [
                    78.5119594,
                    54.9024236
                ],
                [
                    78.517414,
                    54.9026076
                ],
                [
                    78.5207832,
                    54.9039542
                ],
                [
                    78.5241935,
                    54.9043794
                ],
                [
                    78.5318358,
                    54.9064345
                ],
                [
                    78.5324522,
                    54.9053715
                ],
                [
                    78.52255,
                    54.9026076
                ],
                [
                    78.5230019,
                    54.9015681
                ],
                [
                    78.5210708,
                    54.9010011
                ],
                [
                    78.5199204,
                    54.9014028
                ],
                [
                    78.5158527,
                    54.900505
                ],
                [
                    78.511333,
                    54.8993237
                ],
                [
                    78.5088677,
                    54.8979534
                ],
                [
                    78.5058683,
                    54.8980479
                ],
                [
                    78.5037728,
                    54.8998907
                ]
            ],
            "longitude": 78.516525,
            "latitude": 54.901154
        },
        "9801": {
            "name": "Нестеровка",
            "population": 183,
            "type": "hamlet",
            "poly": [
                [
                    78.5186631,
                    53.7758777
                ],
                [
                    78.5191489,
                    53.7765476
                ],
                [
                    78.5218007,
                    53.7763562
                ],
                [
                    78.5229748,
                    53.7766911
                ],
                [
                    78.5231974,
                    53.7771337
                ],
                [
                    78.5226104,
                    53.7771816
                ],
                [
                    78.5219019,
                    53.7767749
                ],
                [
                    78.520829,
                    53.7767868
                ],
                [
                    78.5207683,
                    53.7782103
                ],
                [
                    78.5200799,
                    53.7783419
                ],
                [
                    78.5211732,
                    53.7806026
                ],
                [
                    78.5240881,
                    53.7803275
                ],
                [
                    78.5245132,
                    53.7820498
                ],
                [
                    78.5230153,
                    53.7830904
                ],
                [
                    78.5236225,
                    53.7834851
                ],
                [
                    78.524574,
                    53.7831622
                ],
                [
                    78.5262743,
                    53.7837721
                ],
                [
                    78.5279747,
                    53.7849083
                ],
                [
                    78.5291286,
                    53.7850877
                ],
                [
                    78.5316589,
                    53.7850877
                ],
                [
                    78.533663,
                    53.7847529
                ],
                [
                    78.5361326,
                    53.7854704
                ],
                [
                    78.5384403,
                    53.7853389
                ],
                [
                    78.5410516,
                    53.7854346
                ],
                [
                    78.5415778,
                    53.7845137
                ],
                [
                    78.5398775,
                    53.7838319
                ],
                [
                    78.5371245,
                    53.7839157
                ],
                [
                    78.5337237,
                    53.7836286
                ],
                [
                    78.5333188,
                    53.7821455
                ],
                [
                    78.5325496,
                    53.7820857
                ],
                [
                    78.5324686,
                    53.7825522
                ],
                [
                    78.5281974,
                    53.7812963
                ],
                [
                    78.5275699,
                    53.7818704
                ],
                [
                    78.5267602,
                    53.7811049
                ],
                [
                    78.527914,
                    53.7800165
                ],
                [
                    78.5278533,
                    53.779849
                ],
                [
                    78.5258695,
                    53.7797892
                ],
                [
                    78.5261326,
                    53.7784495
                ],
                [
                    78.5256063,
                    53.7776481
                ],
                [
                    78.5254646,
                    53.7768945
                ],
                [
                    78.5257278,
                    53.7755427
                ],
                [
                    78.5233391,
                    53.7741072
                ],
                [
                    78.5221853,
                    53.775136
                ],
                [
                    78.5217197,
                    53.77577
                ],
                [
                    78.519493,
                    53.7759136
                ],
                [
                    78.5206064,
                    53.7747054
                ],
                [
                    78.5196954,
                    53.7744661
                ],
                [
                    78.5186631,
                    53.7758777
                ]
            ],
            "longitude": 78.529671,
            "latitude": 53.784161
        },
        "9802": {
            "name": "Остановочная Платформа 3046",
            "population": 28,
            "type": "hamlet",
            "poly": [
                [
                    78.506304,
                    55.3582334
                ],
                [
                    78.5266845,
                    55.3591424
                ],
                [
                    78.5267961,
                    55.3598189
                ],
                [
                    78.5281721,
                    55.3600303
                ],
                [
                    78.5286928,
                    55.3608336
                ],
                [
                    78.5312217,
                    55.3612986
                ],
                [
                    78.5329325,
                    55.3612986
                ],
                [
                    78.5331929,
                    55.3609604
                ],
                [
                    78.5350524,
                    55.360897
                ],
                [
                    78.5350524,
                    55.3606011
                ],
                [
                    78.5372094,
                    55.3605588
                ],
                [
                    78.5372466,
                    55.3596075
                ],
                [
                    78.541226,
                    55.3597977
                ],
                [
                    78.544722,
                    55.3595229
                ],
                [
                    78.5451682,
                    55.3593961
                ],
                [
                    78.5459121,
                    55.3596709
                ],
                [
                    78.5538337,
                    55.3588676
                ],
                [
                    78.5533769,
                    55.3578248
                ],
                [
                    78.5533638,
                    55.357785
                ],
                [
                    78.5530899,
                    55.3567535
                ],
                [
                    78.547065,
                    55.3572609
                ],
                [
                    78.5437922,
                    55.3575991
                ],
                [
                    78.5380648,
                    55.3574934
                ],
                [
                    78.5381392,
                    55.3567958
                ],
                [
                    78.517424,
                    55.3559078
                ],
                [
                    78.5174984,
                    55.3565632
                ],
                [
                    78.5138909,
                    55.3563941
                ],
                [
                    78.5064156,
                    55.3561826
                ],
                [
                    78.5064218,
                    55.3572096
                ],
                [
                    78.5064221,
                    55.3572678
                ],
                [
                    78.506304,
                    55.3582334
                ]
            ],
            "longitude": 78.530144,
            "latitude": 55.359028
        },
        "9803": {
            "name": "Михайловка",
            "population": 251,
            "type": "hamlet",
            "poly": [
                [
                    78.5343837,
                    54.5720223
                ],
                [
                    78.5385629,
                    54.5749375
                ],
                [
                    78.5432478,
                    54.5729088
                ],
                [
                    78.5537681,
                    54.5706582
                ],
                [
                    78.559091,
                    54.5704404
                ],
                [
                    78.5659596,
                    54.5693051
                ],
                [
                    78.5743581,
                    54.5675361
                ],
                [
                    78.5790673,
                    54.5703678
                ],
                [
                    78.5846409,
                    54.5688453
                ],
                [
                    78.5813717,
                    54.5635396
                ],
                [
                    78.5787508,
                    54.5614614
                ],
                [
                    78.5722741,
                    54.562796
                ],
                [
                    78.5714725,
                    54.5618897
                ],
                [
                    78.5550047,
                    54.5654241
                ],
                [
                    78.5433731,
                    54.5678266
                ],
                [
                    78.5343837,
                    54.5720223
                ]
            ],
            "longitude": 78.560341,
            "latitude": 54.568199
        },
        "9804": {
            "name": "Свободный Труд",
            "population": 109,
            "type": "hamlet",
            "poly": [
                [
                    78.5625398,
                    53.6622133
                ],
                [
                    78.5626608,
                    53.6632348
                ],
                [
                    78.5631447,
                    53.6637724
                ],
                [
                    78.5677115,
                    53.6638083
                ],
                [
                    78.5684072,
                    53.6635215
                ],
                [
                    78.5684979,
                    53.6621417
                ],
                [
                    78.570252,
                    53.662052
                ],
                [
                    78.570252,
                    53.6615503
                ],
                [
                    78.5709174,
                    53.6614607
                ],
                [
                    78.5711896,
                    53.6606004
                ],
                [
                    78.5697681,
                    53.6598656
                ],
                [
                    78.570252,
                    53.6595072
                ],
                [
                    78.5701613,
                    53.6580376
                ],
                [
                    78.5696169,
                    53.6579659
                ],
                [
                    78.5698891,
                    53.656317
                ],
                [
                    78.5709174,
                    53.6557793
                ],
                [
                    78.5702823,
                    53.6553491
                ],
                [
                    78.5684676,
                    53.6559406
                ],
                [
                    78.5680442,
                    53.6565679
                ],
                [
                    78.5685886,
                    53.6570697
                ],
                [
                    78.5666228,
                    53.6576074
                ],
                [
                    78.5671369,
                    53.6584856
                ],
                [
                    78.5659574,
                    53.6589516
                ],
                [
                    78.5658062,
                    53.6594355
                ],
                [
                    78.5678628,
                    53.659543
                ],
                [
                    78.5677115,
                    53.6600986
                ],
                [
                    78.5658667,
                    53.6601165
                ],
                [
                    78.5657759,
                    53.6604571
                ],
                [
                    78.5668042,
                    53.6609589
                ],
                [
                    78.5658667,
                    53.6612277
                ],
                [
                    78.5649594,
                    53.661156
                ],
                [
                    78.5639916,
                    53.6609229
                ],
                [
                    78.5632657,
                    53.6613352
                ],
                [
                    78.5633262,
                    53.6620879
                ],
                [
                    78.5625398,
                    53.6622133
                ]
            ],
            "longitude": 78.567085,
            "latitude": 53.662048
        },
        "9805": {
            "name": "Чича",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    78.5714076,
                    54.744109
                ],
                [
                    78.5733772,
                    54.7455632
                ],
                [
                    78.5766751,
                    54.7468058
                ],
                [
                    78.577179,
                    54.7464092
                ],
                [
                    78.5791027,
                    54.7476518
                ],
                [
                    78.5840038,
                    54.7490794
                ],
                [
                    78.5855852,
                    54.7478397
                ],
                [
                    78.5883695,
                    54.7486369
                ],
                [
                    78.5905538,
                    54.7496345
                ],
                [
                    78.5935167,
                    54.7476337
                ],
                [
                    78.5891338,
                    54.745431
                ],
                [
                    78.5878055,
                    54.7463035
                ],
                [
                    78.5876681,
                    54.7456954
                ],
                [
                    78.5861566,
                    54.7460391
                ],
                [
                    78.5856527,
                    54.7447172
                ],
                [
                    78.5824464,
                    54.7437389
                ],
                [
                    78.5831793,
                    54.7430779
                ],
                [
                    78.5823548,
                    54.7427077
                ],
                [
                    78.5818968,
                    54.7429721
                ],
                [
                    78.5774538,
                    54.7414386
                ],
                [
                    78.57553,
                    54.742602
                ],
                [
                    78.5739269,
                    54.7419674
                ],
                [
                    78.5714076,
                    54.744109
                ]
            ],
            "longitude": 78.579536,
            "latitude": 54.745514
        },
        "9806": {
            "name": "Бурундуково",
            "population": 79,
            "type": "hamlet",
            "poly": [
                [
                    78.5727091,
                    55.4923065
                ],
                [
                    78.5731384,
                    55.4929067
                ],
                [
                    78.5734581,
                    55.4939468
                ],
                [
                    78.5738952,
                    55.4947304
                ],
                [
                    78.5746456,
                    55.4954526
                ],
                [
                    78.5751614,
                    55.4958706
                ],
                [
                    78.5770936,
                    55.4979672
                ],
                [
                    78.5793315,
                    55.4995918
                ],
                [
                    78.5807412,
                    55.4996626
                ],
                [
                    78.581542,
                    55.4983163
                ],
                [
                    78.5819555,
                    55.4961358
                ],
                [
                    78.5824205,
                    55.4960333
                ],
                [
                    78.5873809,
                    55.4973065
                ],
                [
                    78.588001,
                    55.4952869
                ],
                [
                    78.5872775,
                    55.4946869
                ],
                [
                    78.5860633,
                    55.4938965
                ],
                [
                    78.583609,
                    55.493194
                ],
                [
                    78.5813319,
                    55.4938433
                ],
                [
                    78.5797516,
                    55.494604
                ],
                [
                    78.5772931,
                    55.49454
                ],
                [
                    78.5767219,
                    55.4939514
                ],
                [
                    78.5755071,
                    55.4935412
                ],
                [
                    78.5742163,
                    55.4920632
                ],
                [
                    78.5727091,
                    55.4923065
                ]
            ],
            "longitude": 78.580544,
            "latitude": 55.495972
        },
        "9807": {
            "name": "Ичкала",
            "population": 41,
            "type": "hamlet",
            "poly": [
                [
                    78.572271,
                    56.6264794
                ],
                [
                    78.5724484,
                    56.6269188
                ],
                [
                    78.5733361,
                    56.6275535
                ],
                [
                    78.5740462,
                    56.6273338
                ],
                [
                    78.5746231,
                    56.6280906
                ],
                [
                    78.5734248,
                    56.6287742
                ],
                [
                    78.5754663,
                    56.62936
                ],
                [
                    78.5763982,
                    56.6295553
                ],
                [
                    78.576842,
                    56.6287009
                ],
                [
                    78.5781735,
                    56.6286033
                ],
                [
                    78.5802594,
                    56.6305318
                ],
                [
                    78.5843423,
                    56.6318743
                ],
                [
                    78.5853631,
                    56.6317035
                ],
                [
                    78.5884253,
                    56.6306538
                ],
                [
                    78.5876265,
                    56.6287009
                ],
                [
                    78.5860287,
                    56.6281394
                ],
                [
                    78.5850524,
                    56.62853
                ],
                [
                    78.5846086,
                    56.6275047
                ],
                [
                    78.5831441,
                    56.6266747
                ],
                [
                    78.5812801,
                    56.6264061
                ],
                [
                    78.5798156,
                    56.6268212
                ],
                [
                    78.5793718,
                    56.6263817
                ],
                [
                    78.5804369,
                    56.6260644
                ],
                [
                    78.5820346,
                    56.6253808
                ],
                [
                    78.5806588,
                    56.6245507
                ],
                [
                    78.57986,
                    56.6248437
                ],
                [
                    78.5785729,
                    56.6240624
                ],
                [
                    78.5767977,
                    56.624331
                ],
                [
                    78.5759545,
                    56.6248925
                ],
                [
                    78.5774634,
                    56.626162
                ],
                [
                    78.5759101,
                    56.6267235
                ],
                [
                    78.5739574,
                    56.6255517
                ],
                [
                    78.572271,
                    56.6264794
                ]
            ],
            "longitude": 78.582069,
            "latitude": 56.62888
        },
        "9808": {
            "name": "Аккуль",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.588257,
            "latitude": 55.63324
        },
        "9809": {
            "name": "Малокарагаевка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    78.5866501,
                    56.6445409
                ],
                [
                    78.5872714,
                    56.6449313
                ],
                [
                    78.5883365,
                    56.6449313
                ],
                [
                    78.5881146,
                    56.6453461
                ],
                [
                    78.5874933,
                    56.6456145
                ],
                [
                    78.587804,
                    56.6466393
                ],
                [
                    78.5907775,
                    56.6489085
                ],
                [
                    78.5908661,
                    56.6498112
                ],
                [
                    78.591887,
                    56.6505188
                ],
                [
                    78.5929521,
                    56.6507627
                ],
                [
                    78.5940172,
                    56.6504212
                ],
                [
                    78.5925083,
                    56.6491525
                ],
                [
                    78.5930852,
                    56.6486645
                ],
                [
                    78.5945054,
                    56.6497136
                ],
                [
                    78.595393,
                    56.6496892
                ],
                [
                    78.5970794,
                    56.6506164
                ],
                [
                    78.5991209,
                    56.6499088
                ],
                [
                    78.6009849,
                    56.650714
                ],
                [
                    78.6012511,
                    56.65047
                ],
                [
                    78.601118,
                    56.6500308
                ],
                [
                    78.6016506,
                    56.6497868
                ],
                [
                    78.6016949,
                    56.6491281
                ],
                [
                    78.601118,
                    56.6483961
                ],
                [
                    78.5963693,
                    56.6480789
                ],
                [
                    78.5939284,
                    56.6466881
                ],
                [
                    78.5941503,
                    56.6461757
                ],
                [
                    78.5907775,
                    56.6436136
                ],
                [
                    78.5890022,
                    56.6442968
                ],
                [
                    78.587804,
                    56.6435404
                ],
                [
                    78.5866501,
                    56.6445409
                ]
            ],
            "longitude": 78.591698,
            "latitude": 56.647511
        },
        "9810": {
            "name": "Арисово",
            "population": 216,
            "type": "hamlet",
            "poly": [
                [
                    78.6224563,
                    55.2724064
                ],
                [
                    78.6226019,
                    55.2742476
                ],
                [
                    78.6231552,
                    55.275475
                ],
                [
                    78.6242616,
                    55.2759726
                ],
                [
                    78.6262125,
                    55.2766195
                ],
                [
                    78.6274064,
                    55.2769678
                ],
                [
                    78.6288332,
                    55.2768683
                ],
                [
                    78.629037,
                    55.2763707
                ],
                [
                    78.6302017,
                    55.2756741
                ],
                [
                    78.6308132,
                    55.2748447
                ],
                [
                    78.6312499,
                    55.2743637
                ],
                [
                    78.6319197,
                    55.2742144
                ],
                [
                    78.6322108,
                    55.2732524
                ],
                [
                    78.6332008,
                    55.2713448
                ],
                [
                    78.6339579,
                    55.2714111
                ],
                [
                    78.6346276,
                    55.2702168
                ],
                [
                    78.6297649,
                    55.270084
                ],
                [
                    78.6294155,
                    55.2708139
                ],
                [
                    78.6289496,
                    55.2707808
                ],
                [
                    78.6287458,
                    55.271577
                ],
                [
                    78.6255428,
                    55.2712452
                ],
                [
                    78.6257758,
                    55.2707808
                ],
                [
                    78.6248731,
                    55.2706149
                ],
                [
                    78.6248149,
                    55.2710296
                ],
                [
                    78.6236502,
                    55.2709135
                ],
                [
                    78.6224563,
                    55.2724064
                ]
            ],
            "longitude": 78.627556,
            "latitude": 55.273441
        },
        "9811": {
            "name": "Петропавловский",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    78.6366459,
                    54.9187299
                ],
                [
                    78.6370675,
                    54.9196183
                ],
                [
                    78.6398779,
                    54.9206413
                ],
                [
                    78.6426884,
                    54.9210451
                ],
                [
                    78.6470915,
                    54.9215027
                ],
                [
                    78.6480751,
                    54.919026
                ],
                [
                    78.6489184,
                    54.9180299
                ],
                [
                    78.6422669,
                    54.9161723
                ],
                [
                    78.6405337,
                    54.9177338
                ],
                [
                    78.6380511,
                    54.9168992
                ],
                [
                    78.6366459,
                    54.9187299
                ]
            ],
            "longitude": 78.642738,
            "latitude": 54.919403
        },
        "9812": {
            "name": "Чуклайда",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.643784,
            "latitude": 55.499615
        },
        "9813": {
            "name": "Абакумово",
            "population": 103,
            "type": "hamlet",
            "poly": [
                [
                    78.6429758,
                    55.1906407
                ],
                [
                    78.6430303,
                    55.1938449
                ],
                [
                    78.6455099,
                    55.1938293
                ],
                [
                    78.6459053,
                    55.1943032
                ],
                [
                    78.6463274,
                    55.1948091
                ],
                [
                    78.6480713,
                    55.1949491
                ],
                [
                    78.6500877,
                    55.1949491
                ],
                [
                    78.6501149,
                    55.1964888
                ],
                [
                    78.6544201,
                    55.1965977
                ],
                [
                    78.6545836,
                    55.193876
                ],
                [
                    78.6534392,
                    55.1938915
                ],
                [
                    78.6536027,
                    55.1916051
                ],
                [
                    78.6488887,
                    55.1908585
                ],
                [
                    78.6489432,
                    55.1903141
                ],
                [
                    78.6496517,
                    55.1902674
                ],
                [
                    78.6496244,
                    55.1899096
                ],
                [
                    78.648916,
                    55.1898474
                ],
                [
                    78.649025,
                    55.1885719
                ],
                [
                    78.6454554,
                    55.1885563
                ],
                [
                    78.6439023,
                    55.1893341
                ],
                [
                    78.6429758,
                    55.1906407
                ]
            ],
            "longitude": 78.645348,
            "latitude": 55.191761
        },
        "9814": {
            "name": "Морозовка",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.649918,
            "latitude": 55.425728
        },
        "9815": {
            "name": "Барлакуль",
            "population": 170,
            "type": "hamlet",
            "poly": [
                [
                    78.6510956,
                    54.3035001
                ],
                [
                    78.6543259,
                    54.3046968
                ],
                [
                    78.6576075,
                    54.3061627
                ],
                [
                    78.6603763,
                    54.3063123
                ],
                [
                    78.6619658,
                    54.3066115
                ],
                [
                    78.6617094,
                    54.3072696
                ],
                [
                    78.6631964,
                    54.307838
                ],
                [
                    78.6630426,
                    54.3084363
                ],
                [
                    78.6683751,
                    54.3092141
                ],
                [
                    78.6683239,
                    54.3103807
                ],
                [
                    78.6721182,
                    54.3108892
                ],
                [
                    78.6759125,
                    54.3109491
                ],
                [
                    78.6787839,
                    54.3127737
                ],
                [
                    78.6820142,
                    54.3111884
                ],
                [
                    78.6841164,
                    54.3114875
                ],
                [
                    78.6851419,
                    54.3105901
                ],
                [
                    78.683296,
                    54.308526
                ],
                [
                    78.6815014,
                    54.3093636
                ],
                [
                    78.6800145,
                    54.3084363
                ],
                [
                    78.675649,
                    54.3069208
                ],
                [
                    78.6743925,
                    54.3078408
                ],
                [
                    78.6680675,
                    54.305714
                ],
                [
                    78.6655038,
                    54.3043079
                ],
                [
                    78.6558879,
                    54.300349
                ],
                [
                    78.6530079,
                    54.302632
                ],
                [
                    78.6521211,
                    54.3024529
                ],
                [
                    78.6510956,
                    54.3035001
                ]
            ],
            "longitude": 78.668205,
            "latitude": 54.306973
        },
        "9816": {
            "name": "Новокиевка",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.669472,
            "latitude": 55.579308
        },
        "9817": {
            "name": "Новопокровский",
            "population": 100,
            "type": "hamlet",
            "poly": [
                [
                    78.6925444,
                    54.2258914
                ],
                [
                    78.6968538,
                    54.227401
                ],
                [
                    78.6983652,
                    54.2170144
                ],
                [
                    78.6944407,
                    54.2163828
                ],
                [
                    78.6925444,
                    54.2258914
                ]
            ],
            "longitude": 78.696655,
            "latitude": 54.22139
        },
        "9818": {
            "name": "Сургуты",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    78.7116011,
                    56.0607992
                ],
                [
                    78.7126797,
                    56.0612723
                ],
                [
                    78.7123715,
                    56.0616379
                ],
                [
                    78.7127952,
                    56.0621002
                ],
                [
                    78.713816,
                    56.0624658
                ],
                [
                    78.7140856,
                    56.0633475
                ],
                [
                    78.7156648,
                    56.0636808
                ],
                [
                    78.7179568,
                    56.0644442
                ],
                [
                    78.7195167,
                    56.064627
                ],
                [
                    78.7201716,
                    56.0649388
                ],
                [
                    78.7210961,
                    56.0650678
                ],
                [
                    78.7213079,
                    56.0648313
                ],
                [
                    78.7227909,
                    56.0650248
                ],
                [
                    78.7232146,
                    56.0642829
                ],
                [
                    78.7211152,
                    56.0638636
                ],
                [
                    78.7215968,
                    56.0631432
                ],
                [
                    78.7209035,
                    56.0628852
                ],
                [
                    78.7205375,
                    56.0632077
                ],
                [
                    78.7193627,
                    56.0626701
                ],
                [
                    78.7195746,
                    56.0623905
                ],
                [
                    78.7194205,
                    56.0618637
                ],
                [
                    78.7183612,
                    56.061111
                ],
                [
                    78.7177642,
                    56.0608637
                ],
                [
                    78.7172056,
                    56.0611433
                ],
                [
                    78.7168204,
                    56.0608207
                ],
                [
                    78.7154338,
                    56.0604766
                ],
                [
                    78.7144708,
                    56.0611325
                ],
                [
                    78.7136426,
                    56.0608852
                ],
                [
                    78.7142589,
                    56.0602615
                ],
                [
                    78.7128722,
                    56.0597131
                ],
                [
                    78.7116011,
                    56.0607992
                ]
            ],
            "longitude": 78.716995,
            "latitude": 56.062714
        },
        "9819": {
            "name": "Новопокровка",
            "population": 21,
            "type": "hamlet",
            "poly": [
                [
                    78.7291712,
                    56.2887955
                ],
                [
                    78.7303622,
                    56.2890624
                ],
                [
                    78.7308891,
                    56.2883378
                ],
                [
                    78.7325153,
                    56.2887319
                ],
                [
                    78.7321259,
                    56.2892023
                ],
                [
                    78.7328131,
                    56.2893675
                ],
                [
                    78.7331567,
                    56.2888717
                ],
                [
                    78.7343477,
                    56.2891006
                ],
                [
                    78.7342332,
                    56.2893548
                ],
                [
                    78.7345539,
                    56.2896218
                ],
                [
                    78.7339583,
                    56.2900667
                ],
                [
                    78.7347371,
                    56.2903464
                ],
                [
                    78.7371193,
                    56.2905116
                ],
                [
                    78.7375774,
                    56.2903845
                ],
                [
                    78.7384019,
                    56.2906642
                ],
                [
                    78.7380813,
                    56.2909438
                ],
                [
                    78.7403031,
                    56.2920624
                ],
                [
                    78.7416087,
                    56.29252
                ],
                [
                    78.7417003,
                    56.293753
                ],
                [
                    78.7426623,
                    56.293753
                ],
                [
                    78.7427539,
                    56.2934734
                ],
                [
                    78.743235,
                    56.2933971
                ],
                [
                    78.7434868,
                    56.2924184
                ],
                [
                    78.7437389,
                    56.292304
                ],
                [
                    78.743945,
                    56.2923929
                ],
                [
                    78.743716,
                    56.2926217
                ],
                [
                    78.7440366,
                    56.2928251
                ],
                [
                    78.743945,
                    56.293181
                ],
                [
                    78.7447466,
                    56.2933463
                ],
                [
                    78.7447925,
                    56.2936259
                ],
                [
                    78.7464417,
                    56.2936895
                ],
                [
                    78.7465333,
                    56.2929268
                ],
                [
                    78.7435327,
                    56.2918209
                ],
                [
                    78.7437847,
                    56.2914269
                ],
                [
                    78.7422957,
                    56.2909184
                ],
                [
                    78.74154,
                    56.2905116
                ],
                [
                    78.7421126,
                    56.2901938
                ],
                [
                    78.7411506,
                    56.2895582
                ],
                [
                    78.7406925,
                    56.289787
                ],
                [
                    78.7400053,
                    56.2895836
                ],
                [
                    78.7401198,
                    56.2892404
                ],
                [
                    78.7390891,
                    56.288948
                ],
                [
                    78.7387454,
                    56.2891768
                ],
                [
                    78.7384936,
                    56.2891006
                ],
                [
                    78.7376461,
                    56.2897616
                ],
                [
                    78.7310722,
                    56.2880708
                ],
                [
                    78.7315991,
                    56.2874733
                ],
                [
                    78.7304309,
                    56.2871809
                ],
                [
                    78.7291712,
                    56.2887955
                ]
            ],
            "longitude": 78.740005,
            "latitude": 56.290577
        },
        "9820": {
            "name": "Успенский",
            "population": 120,
            "type": "hamlet",
            "poly": [
                [
                    78.7230746,
                    53.6554598
                ],
                [
                    78.725624,
                    53.659539
                ],
                [
                    78.7333996,
                    53.6577261
                ],
                [
                    78.7399388,
                    53.6605663
                ],
                [
                    78.7425137,
                    53.6638444
                ],
                [
                    78.7521377,
                    53.6599545
                ],
                [
                    78.7436609,
                    53.6545911
                ],
                [
                    78.7323162,
                    53.6535335
                ],
                [
                    78.7230746,
                    53.6554598
                ]
            ],
            "longitude": 78.740089,
            "latitude": 53.657196
        },
        "9821": {
            "name": "Красный Яр",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.741219,
            "latitude": 55.020565
        },
        "9822": {
            "name": "Малышево",
            "population": 59,
            "type": "hamlet",
            "poly": [
                [
                    78.7457426,
                    54.9768052
                ],
                [
                    78.7473458,
                    54.9793444
                ],
                [
                    78.7491734,
                    54.9811476
                ],
                [
                    78.7505841,
                    54.9815891
                ],
                [
                    78.7509688,
                    54.9824171
                ],
                [
                    78.754143,
                    54.98422
                ],
                [
                    78.7555217,
                    54.983337
                ],
                [
                    78.7585996,
                    54.98468
                ],
                [
                    78.759818,
                    54.9835577
                ],
                [
                    78.7570927,
                    54.9821595
                ],
                [
                    78.7553293,
                    54.9809084
                ],
                [
                    78.7578622,
                    54.9801172
                ],
                [
                    78.756708,
                    54.9790133
                ],
                [
                    78.7527963,
                    54.9790685
                ],
                [
                    78.7484039,
                    54.975738
                ],
                [
                    78.7457426,
                    54.9768052
                ]
            ],
            "longitude": 78.752159,
            "latitude": 54.980942
        },
        "9823": {
            "name": "Труновское",
            "population": 141,
            "type": "hamlet",
            "poly": [
                [
                    78.7326976,
                    55.3413247
                ],
                [
                    78.7327169,
                    55.343392
                ],
                [
                    78.7439873,
                    55.343624
                ],
                [
                    78.7442583,
                    55.3445069
                ],
                [
                    78.7524741,
                    55.3444678
                ],
                [
                    78.7521356,
                    55.3457113
                ],
                [
                    78.7540621,
                    55.3459777
                ],
                [
                    78.7543745,
                    55.3451783
                ],
                [
                    78.7550513,
                    55.3451635
                ],
                [
                    78.7559104,
                    55.3455928
                ],
                [
                    78.7572642,
                    55.345652
                ],
                [
                    78.7592427,
                    55.3451191
                ],
                [
                    78.7590604,
                    55.3447935
                ],
                [
                    78.759477,
                    55.3447194
                ],
                [
                    78.7610129,
                    55.3453856
                ],
                [
                    78.762679,
                    55.3448971
                ],
                [
                    78.7625489,
                    55.3434167
                ],
                [
                    78.7678971,
                    55.3433839
                ],
                [
                    78.7677815,
                    55.3413589
                ],
                [
                    78.7593728,
                    55.3413589
                ],
                [
                    78.7578108,
                    55.3416106
                ],
                [
                    78.7560187,
                    55.3416622
                ],
                [
                    78.7538538,
                    55.340441
                ],
                [
                    78.7514133,
                    55.3402465
                ],
                [
                    78.7509602,
                    55.3398133
                ],
                [
                    78.7451886,
                    55.3406964
                ],
                [
                    78.7461369,
                    55.3411677
                ],
                [
                    78.7326976,
                    55.3413247
                ]
            ],
            "longitude": 78.752945,
            "latitude": 55.343151
        },
        "9824": {
            "name": "Рямской",
            "population": 41,
            "type": "hamlet",
            "poly": [
                [
                    78.7768395,
                    54.2847036
                ],
                [
                    78.7806496,
                    54.2908892
                ],
                [
                    78.7961283,
                    54.2969349
                ],
                [
                    78.7993431,
                    54.2931352
                ],
                [
                    78.7876936,
                    54.2855794
                ],
                [
                    78.7782416,
                    54.2825344
                ],
                [
                    78.7768395,
                    54.2847036
                ]
            ],
            "longitude": 78.787758,
            "latitude": 54.28968
        },
        "9825": {
            "name": "Осинниковский",
            "population": 43,
            "type": "hamlet",
            "poly": [
                [
                    78.7890655,
                    53.89455
                ],
                [
                    78.7933812,
                    53.8947619
                ],
                [
                    78.7943702,
                    53.8917595
                ],
                [
                    78.7969776,
                    53.8910531
                ],
                [
                    78.7996749,
                    53.8914946
                ],
                [
                    78.8002743,
                    53.8904879
                ],
                [
                    78.7957787,
                    53.888492
                ],
                [
                    78.7912833,
                    53.8896047
                ],
                [
                    78.7890655,
                    53.89455
                ]
            ],
            "longitude": 78.79557,
            "latitude": 53.890572
        },
        "9826": {
            "name": "Алексотово",
            "population": 53,
            "type": "hamlet",
            "poly": [
                [
                    78.800638,
                    54.5560725
                ],
                [
                    78.8053015,
                    54.5558376
                ],
                [
                    78.8118686,
                    54.5534854
                ],
                [
                    78.8168546,
                    54.5524441
                ],
                [
                    78.8159836,
                    54.5510084
                ],
                [
                    78.8168088,
                    54.5502108
                ],
                [
                    78.818898,
                    54.5477954
                ],
                [
                    78.8163897,
                    54.5471393
                ],
                [
                    78.8149292,
                    54.5480305
                ],
                [
                    78.813829,
                    54.5478178
                ],
                [
                    78.8130956,
                    54.5483496
                ],
                [
                    78.8105368,
                    54.5472128
                ],
                [
                    78.8051966,
                    54.5514694
                ],
                [
                    78.8040646,
                    54.5520985
                ],
                [
                    78.803914,
                    54.5533908
                ],
                [
                    78.8013141,
                    54.5547039
                ],
                [
                    78.800638,
                    54.5560725
                ]
            ],
            "longitude": 78.810822,
            "latitude": 54.551765
        },
        "9827": {
            "name": "Пензино",
            "population": 223,
            "type": "hamlet",
            "poly": [
                [
                    78.8034596,
                    55.2789199
                ],
                [
                    78.8038503,
                    55.2799716
                ],
                [
                    78.8050668,
                    55.2808307
                ],
                [
                    78.8060887,
                    55.2811078
                ],
                [
                    78.8045802,
                    55.2816344
                ],
                [
                    78.8055047,
                    55.2821887
                ],
                [
                    78.8070132,
                    55.2823827
                ],
                [
                    78.8065266,
                    55.2830478
                ],
                [
                    78.8054848,
                    55.2841375
                ],
                [
                    78.8041423,
                    55.2855418
                ],
                [
                    78.8064779,
                    55.2873706
                ],
                [
                    78.8089595,
                    55.2888669
                ],
                [
                    78.808035,
                    55.2897536
                ],
                [
                    78.8089595,
                    55.2900029
                ],
                [
                    78.8112465,
                    55.2889778
                ],
                [
                    78.8113438,
                    55.2883682
                ],
                [
                    78.8165503,
                    55.2903908
                ],
                [
                    78.818594,
                    55.29028
                ],
                [
                    78.8194698,
                    55.2894765
                ],
                [
                    78.8199564,
                    55.2895873
                ],
                [
                    78.8200393,
                    55.2895102
                ],
                [
                    78.8214162,
                    55.2882296
                ],
                [
                    78.8074998,
                    55.2831586
                ],
                [
                    78.8078404,
                    55.2821887
                ],
                [
                    78.8091542,
                    55.2813296
                ],
                [
                    78.8210269,
                    55.2822164
                ],
                [
                    78.8213189,
                    55.2809693
                ],
                [
                    78.8212987,
                    55.2809187
                ],
                [
                    78.8206377,
                    55.279251
                ],
                [
                    78.8071105,
                    55.2777266
                ],
                [
                    78.8064293,
                    55.2793618
                ],
                [
                    78.8034596,
                    55.2789199
                ]
            ],
            "longitude": 78.813477,
            "latitude": 55.287228
        },
        "9828": {
            "name": "Горькое Озеро",
            "population": 81,
            "type": "hamlet",
            "poly": [
                [
                    78.8073242,
                    54.8759845
                ],
                [
                    78.8102433,
                    54.8777209
                ],
                [
                    78.8086105,
                    54.8787741
                ],
                [
                    78.8140528,
                    54.8812504
                ],
                [
                    78.8188521,
                    54.8830435
                ],
                [
                    78.8194953,
                    54.8811366
                ],
                [
                    78.8214249,
                    54.8790587
                ],
                [
                    78.8174668,
                    54.8775786
                ],
                [
                    78.8167741,
                    54.8782902
                ],
                [
                    78.8130139,
                    54.8764115
                ],
                [
                    78.8120739,
                    54.8770093
                ],
                [
                    78.8083137,
                    54.8751021
                ],
                [
                    78.8073242,
                    54.8759845
                ]
            ],
            "longitude": 78.815598,
            "latitude": 54.879601
        },
        "9829": {
            "name": "Вишняки",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.829483,
            "latitude": 55.531284
        },
        "9830": {
            "name": "Павловка",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.835594,
            "latitude": 55.53933
        },
        "9831": {
            "name": "Новоалексеевка",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.837326,
            "latitude": 55.676636
        },
        "9832": {
            "name": "Ивановка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    78.8372968,
                    56.3486841
                ],
                [
                    78.8372968,
                    56.3489556
                ],
                [
                    78.8383658,
                    56.3493505
                ],
                [
                    78.8422853,
                    56.3476105
                ],
                [
                    78.8440892,
                    56.3462776
                ],
                [
                    78.8448464,
                    56.3464997
                ],
                [
                    78.8450468,
                    56.3463146
                ],
                [
                    78.8457149,
                    56.3464134
                ],
                [
                    78.8462939,
                    56.3456358
                ],
                [
                    78.8452918,
                    56.3453273
                ],
                [
                    78.8454031,
                    56.3451915
                ],
                [
                    78.8450691,
                    56.3451051
                ],
                [
                    78.8450913,
                    56.3449077
                ],
                [
                    78.8435324,
                    56.3444634
                ],
                [
                    78.8422408,
                    56.3448336
                ],
                [
                    78.8422853,
                    56.3452779
                ],
                [
                    78.8418845,
                    56.3451792
                ],
                [
                    78.8410827,
                    56.345821
                ],
                [
                    78.842174,
                    56.346327
                ],
                [
                    78.8418176,
                    56.3465491
                ],
                [
                    78.8421072,
                    56.3467466
                ],
                [
                    78.8417508,
                    56.3470304
                ],
                [
                    78.8410159,
                    56.3467959
                ],
                [
                    78.8406819,
                    56.3469687
                ],
                [
                    78.8407264,
                    56.3474747
                ],
                [
                    78.8397243,
                    56.3480671
                ],
                [
                    78.8393011,
                    56.3479807
                ],
                [
                    78.838633,
                    56.348499
                ],
                [
                    78.8378981,
                    56.3482769
                ],
                [
                    78.8372968,
                    56.3486841
                ]
            ],
            "longitude": 78.842796,
            "latitude": 56.346252
        },
        "9833": {
            "name": "Осиново",
            "population": 162,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.842896,
            "latitude": 55.463005
        },
        "9834": {
            "name": "Хапово",
            "population": 245,
            "type": "hamlet",
            "poly": [
                [
                    78.8380834,
                    54.7122558
                ],
                [
                    78.8388112,
                    54.7134201
                ],
                [
                    78.8382513,
                    54.7146814
                ],
                [
                    78.839707,
                    54.7148754
                ],
                [
                    78.8392591,
                    54.7160073
                ],
                [
                    78.8460335,
                    54.7168805
                ],
                [
                    78.8464255,
                    54.7163307
                ],
                [
                    78.8481051,
                    54.7173656
                ],
                [
                    78.8509604,
                    54.7172039
                ],
                [
                    78.8549355,
                    54.7162661
                ],
                [
                    78.8580148,
                    54.7153605
                ],
                [
                    78.8599743,
                    54.714358
                ],
                [
                    78.8641734,
                    54.7142933
                ],
                [
                    78.8651811,
                    54.7140346
                ],
                [
                    78.8653491,
                    54.7133877
                ],
                [
                    78.8675326,
                    54.7136465
                ],
                [
                    78.8697161,
                    54.7136141
                ],
                [
                    78.86994,
                    54.7146491
                ],
                [
                    78.8709478,
                    54.7146491
                ],
                [
                    78.8709478,
                    54.7135494
                ],
                [
                    78.8732993,
                    54.7134848
                ],
                [
                    78.8731313,
                    54.7124175
                ],
                [
                    78.8721795,
                    54.7123851
                ],
                [
                    78.8718996,
                    54.7130643
                ],
                [
                    78.8675886,
                    54.7131613
                ],
                [
                    78.8652371,
                    54.7128703
                ],
                [
                    78.8651811,
                    54.7119
                ],
                [
                    78.8611501,
                    54.7117059
                ],
                [
                    78.8612061,
                    54.7124175
                ],
                [
                    78.8585187,
                    54.7132907
                ],
                [
                    78.8580148,
                    54.7128379
                ],
                [
                    78.8563912,
                    54.7130967
                ],
                [
                    78.8546363,
                    54.7138325
                ],
                [
                    78.8541139,
                    54.7145753
                ],
                [
                    78.8530879,
                    54.7151018
                ],
                [
                    78.8514083,
                    54.7152959
                ],
                [
                    78.8490569,
                    54.7150048
                ],
                [
                    78.8494488,
                    54.7133231
                ],
                [
                    78.8494488,
                    54.712094
                ],
                [
                    78.8555514,
                    54.7112855
                ],
                [
                    78.8554394,
                    54.7070806
                ],
                [
                    78.8563912,
                    54.7069512
                ],
                [
                    78.8561112,
                    54.7059161
                ],
                [
                    78.8503446,
                    54.7060455
                ],
                [
                    78.848329,
                    54.7061102
                ],
                [
                    78.8471533,
                    54.7070159
                ],
                [
                    78.8503446,
                    54.7072747
                ],
                [
                    78.8514083,
                    54.7093125
                ],
                [
                    78.8490009,
                    54.7094742
                ],
                [
                    78.8460895,
                    54.7092478
                ],
                [
                    78.8431222,
                    54.7097653
                ],
                [
                    78.8433155,
                    54.7105604
                ],
                [
                    78.8429168,
                    54.7109444
                ],
                [
                    78.8422082,
                    54.7111015
                ],
                [
                    78.8414014,
                    54.71102
                ],
                [
                    78.840649,
                    54.7108121
                ],
                [
                    78.839595,
                    54.7102181
                ],
                [
                    78.8380834,
                    54.7122558
                ]
            ],
            "longitude": 78.845253,
            "latitude": 54.712902
        },
        "9835": {
            "name": "Дмитриевский",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    78.8426537,
                    55.402941
                ],
                [
                    78.8438155,
                    55.4069067
                ],
                [
                    78.850595,
                    55.4094988
                ],
                [
                    78.8551607,
                    55.4067496
                ],
                [
                    78.8533419,
                    55.4042961
                ],
                [
                    78.8470812,
                    55.399877
                ],
                [
                    78.8432072,
                    55.4005056
                ],
                [
                    78.8426537,
                    55.402941
                ]
            ],
            "longitude": 78.850739,
            "latitude": 55.406418
        },
        "9836": {
            "name": "Новощербаки",
            "population": 204,
            "type": "hamlet",
            "poly": [
                [
                    78.8834338,
                    54.9419171
                ],
                [
                    78.885779,
                    54.9435335
                ],
                [
                    78.8956288,
                    54.945599
                ],
                [
                    78.9004755,
                    54.9429049
                ],
                [
                    78.901101,
                    54.9404801
                ],
                [
                    78.8942967,
                    54.9379761
                ],
                [
                    78.8910948,
                    54.9367977
                ],
                [
                    78.886248,
                    54.9377857
                ],
                [
                    78.8834338,
                    54.9419171
                ]
            ],
            "longitude": 78.892815,
            "latitude": 54.941647
        },
        "9837": {
            "name": "Старый Карапуз",
            "population": 176,
            "type": "hamlet",
            "poly": [
                [
                    78.8966463,
                    55.0712285
                ],
                [
                    78.8974262,
                    55.071962
                ],
                [
                    78.8995429,
                    55.073142
                ],
                [
                    78.9046677,
                    55.0742582
                ],
                [
                    78.9066436,
                    55.0719827
                ],
                [
                    78.9072301,
                    55.0713879
                ],
                [
                    78.9087341,
                    55.0725042
                ],
                [
                    78.9110737,
                    55.0736204
                ],
                [
                    78.911691,
                    55.073205
                ],
                [
                    78.913079,
                    55.0723128
                ],
                [
                    78.9122435,
                    55.0718025
                ],
                [
                    78.913079,
                    55.0711966
                ],
                [
                    78.913079,
                    55.0703035
                ],
                [
                    78.9140517,
                    55.0694288
                ],
                [
                    78.9149172,
                    55.0686449
                ],
                [
                    78.9139703,
                    55.0684216
                ],
                [
                    78.913079,
                    55.0691233
                ],
                [
                    78.9123549,
                    55.0687087
                ],
                [
                    78.9135246,
                    55.0677199
                ],
                [
                    78.9124663,
                    55.0674647
                ],
                [
                    78.9116307,
                    55.0679751
                ],
                [
                    78.9100153,
                    55.067369
                ],
                [
                    78.9112965,
                    55.0665078
                ],
                [
                    78.9083999,
                    55.0659655
                ],
                [
                    78.9072301,
                    55.0659336
                ],
                [
                    78.9055033,
                    55.0649767
                ],
                [
                    78.9029966,
                    55.0643387
                ],
                [
                    78.901604,
                    55.0641792
                ],
                [
                    78.9010339,
                    55.0646691
                ],
                [
                    78.9003785,
                    55.0652638
                ],
                [
                    78.9012697,
                    55.0659336
                ],
                [
                    78.9023281,
                    55.0663802
                ],
                [
                    78.901214,
                    55.067688
                ],
                [
                    78.9041664,
                    55.0691233
                ],
                [
                    78.9020496,
                    55.0708138
                ],
                [
                    78.9013254,
                    55.0710371
                ],
                [
                    78.8981503,
                    55.0703035
                ],
                [
                    78.8972033,
                    55.0703992
                ],
                [
                    78.8966463,
                    55.0712285
                ]
            ],
            "longitude": 78.90519,
            "latitude": 55.067001
        },
        "9838": {
            "name": "Остановочная Платформа 3071",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    78.9134923,
                    55.3442826
                ],
                [
                    78.9144019,
                    55.3453171
                ],
                [
                    78.9157024,
                    55.3454624
                ],
                [
                    78.9177245,
                    55.3453983
                ],
                [
                    78.9201977,
                    55.345035
                ],
                [
                    78.9203255,
                    55.3442399
                ],
                [
                    78.9135674,
                    55.3438381
                ],
                [
                    78.9134923,
                    55.3442826
                ]
            ],
            "longitude": 78.916733,
            "latitude": 55.34465
        },
        "9839": {
            "name": "Епанешниково",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.918709,
            "latitude": 55.643097
        },
        "9840": {
            "name": "Ракитники",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    78.9172347,
                    55.349432
                ],
                [
                    78.9181142,
                    55.3501629
                ],
                [
                    78.9185599,
                    55.3509284
                ],
                [
                    78.9219174,
                    55.3512187
                ],
                [
                    78.9247129,
                    55.3510718
                ],
                [
                    78.9242314,
                    55.3485541
                ],
                [
                    78.9174151,
                    55.3484575
                ],
                [
                    78.9172347,
                    55.349432
                ]
            ],
            "longitude": 78.921211,
            "latitude": 55.350056
        },
        "9841": {
            "name": "Новогорносталево",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    78.9032871,
                    54.3740521
                ],
                [
                    78.9126219,
                    54.3760374
                ],
                [
                    78.9151988,
                    54.3770497
                ],
                [
                    78.9182551,
                    54.3783411
                ],
                [
                    78.9207122,
                    54.3798769
                ],
                [
                    78.9231692,
                    54.3807494
                ],
                [
                    78.9293418,
                    54.3835764
                ],
                [
                    78.9307801,
                    54.3827737
                ],
                [
                    78.9296414,
                    54.3818314
                ],
                [
                    78.9310198,
                    54.3809937
                ],
                [
                    78.9299411,
                    54.3801561
                ],
                [
                    78.9313194,
                    54.3793184
                ],
                [
                    78.9277237,
                    54.3764563
                ],
                [
                    78.9242479,
                    54.3748506
                ],
                [
                    78.9215511,
                    54.3764214
                ],
                [
                    78.9196334,
                    54.3752346
                ],
                [
                    78.9182551,
                    54.3762818
                ],
                [
                    78.9140002,
                    54.3751997
                ],
                [
                    78.9062096,
                    54.3725467
                ],
                [
                    78.9032871,
                    54.3740521
                ]
            ],
            "longitude": 78.923653,
            "latitude": 54.378296
        },
        "9842": {
            "name": "Алешинский",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    78.9345728,
                    56.3410641
                ],
                [
                    78.9349904,
                    56.3414807
                ],
                [
                    78.9346006,
                    56.341635
                ],
                [
                    78.9353523,
                    56.3422984
                ],
                [
                    78.9364936,
                    56.3418355
                ],
                [
                    78.9369667,
                    56.342391
                ],
                [
                    78.9430354,
                    56.3411875
                ],
                [
                    78.9430354,
                    56.3409098
                ],
                [
                    78.9464873,
                    56.3403389
                ],
                [
                    78.9459861,
                    56.3394903
                ],
                [
                    78.9472389,
                    56.3393823
                ],
                [
                    78.9484081,
                    56.3398143
                ],
                [
                    78.9511083,
                    56.339984
                ],
                [
                    78.9494659,
                    56.3413727
                ],
                [
                    78.9487978,
                    56.3415732
                ],
                [
                    78.9487143,
                    56.3422212
                ],
                [
                    78.9491597,
                    56.3427767
                ],
                [
                    78.9497443,
                    56.3425915
                ],
                [
                    78.9508021,
                    56.3429001
                ],
                [
                    78.9528343,
                    56.3405704
                ],
                [
                    78.9517486,
                    56.3400766
                ],
                [
                    78.9519156,
                    56.3392897
                ],
                [
                    78.9516651,
                    56.3389194
                ],
                [
                    78.9502454,
                    56.3386571
                ],
                [
                    78.9472667,
                    56.338688
                ],
                [
                    78.9450397,
                    56.3368672
                ],
                [
                    78.9435922,
                    56.3372221
                ],
                [
                    78.9421725,
                    56.3379319
                ],
                [
                    78.9428684,
                    56.3383794
                ],
                [
                    78.9418106,
                    56.3389966
                ],
                [
                    78.9372731,
                    56.3397217
                ],
                [
                    78.9374122,
                    56.3401692
                ],
                [
                    78.9347955,
                    56.3406629
                ],
                [
                    78.9345728,
                    56.3410641
                ]
            ],
            "longitude": 78.943741,
            "latitude": 56.339302
        },
        "9843": {
            "name": "Елизаветинка",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.973412,
            "latitude": 55.654449
        },
        "9844": {
            "name": "Бережки",
            "population": 107,
            "type": "hamlet",
            "poly": [
                [
                    78.9729235,
                    54.7591074
                ],
                [
                    78.9735759,
                    54.7599869
                ],
                [
                    78.9760826,
                    54.7601891
                ],
                [
                    78.9786562,
                    54.7603866
                ],
                [
                    78.9785559,
                    54.7589453
                ],
                [
                    78.9808085,
                    54.7587034
                ],
                [
                    78.9819715,
                    54.7602946
                ],
                [
                    78.9822884,
                    54.7605114
                ],
                [
                    78.9825689,
                    54.7608364
                ],
                [
                    78.9825819,
                    54.7611194
                ],
                [
                    78.9847757,
                    54.761286
                ],
                [
                    78.9865264,
                    54.7607791
                ],
                [
                    78.9853156,
                    54.7600757
                ],
                [
                    78.9850035,
                    54.7597823
                ],
                [
                    78.9848123,
                    54.7594524
                ],
                [
                    78.9844639,
                    54.7586578
                ],
                [
                    78.9842451,
                    54.7580179
                ],
                [
                    78.983852,
                    54.7572886
                ],
                [
                    78.9827462,
                    54.7550268
                ],
                [
                    78.982294,
                    54.7541498
                ],
                [
                    78.9803881,
                    54.7540904
                ],
                [
                    78.979808,
                    54.7546952
                ],
                [
                    78.9790066,
                    54.755053
                ],
                [
                    78.9778563,
                    54.7551192
                ],
                [
                    78.9772705,
                    54.7550026
                ],
                [
                    78.9767511,
                    54.7550565
                ],
                [
                    78.9755387,
                    54.7555896
                ],
                [
                    78.9748251,
                    54.7562758
                ],
                [
                    78.9743377,
                    54.7571542
                ],
                [
                    78.9737493,
                    54.7582978
                ],
                [
                    78.9729235,
                    54.7591074
                ]
            ],
            "longitude": 78.979401,
            "latitude": 54.756916
        },
        "9845": {
            "name": "Красновка",
            "population": 95,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.000275,
            "latitude": 55.484035
        },
        "9846": {
            "name": "Николаевка 2-я",
            "population": 141,
            "type": "hamlet",
            "poly": [
                [
                    78.9993745,
                    55.182723
                ],
                [
                    79.0035147,
                    55.1838672
                ],
                [
                    79.0047231,
                    55.1854196
                ],
                [
                    79.0082925,
                    55.185996
                ],
                [
                    79.0103466,
                    55.1857008
                ],
                [
                    79.0102599,
                    55.1875366
                ],
                [
                    79.0070707,
                    55.1892443
                ],
                [
                    79.0068606,
                    55.1914357
                ],
                [
                    79.0162697,
                    55.1919058
                ],
                [
                    79.0180259,
                    55.1915555
                ],
                [
                    79.0210982,
                    55.1908726
                ],
                [
                    79.0217001,
                    55.1904115
                ],
                [
                    79.025958,
                    55.1858309
                ],
                [
                    79.0070235,
                    55.1809912
                ],
                [
                    79.0064454,
                    55.1807539
                ],
                [
                    79.0047919,
                    55.180371
                ],
                [
                    79.0019444,
                    55.1797191
                ],
                [
                    79.0018979,
                    55.1802701
                ],
                [
                    78.9993745,
                    55.182723
                ]
            ],
            "longitude": 79.014717,
            "latitude": 55.18631
        },
        "9847": {
            "name": "Ганино",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.020302,
            "latitude": 53.759064
        },
        "9848": {
            "name": "Гривенский",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    79.0237269,
                    54.9578727
                ],
                [
                    79.0272061,
                    54.9599878
                ],
                [
                    79.0297643,
                    54.9595765
                ],
                [
                    79.0321178,
                    54.9605753
                ],
                [
                    79.0338574,
                    54.9592828
                ],
                [
                    79.0319132,
                    54.958754
                ],
                [
                    79.0342667,
                    54.9559337
                ],
                [
                    79.0383599,
                    54.9569913
                ],
                [
                    79.0419414,
                    54.9539947
                ],
                [
                    79.0385645,
                    54.9527019
                ],
                [
                    79.0388715,
                    54.9514679
                ],
                [
                    79.0325271,
                    54.9505276
                ],
                [
                    79.0237269,
                    54.9578727
                ]
            ],
            "longitude": 79.032288,
            "latitude": 54.955467
        },
        "9849": {
            "name": "Новый Карапуз",
            "population": 53,
            "type": "hamlet",
            "poly": [
                [
                    79.0820254,
                    55.1341075
                ],
                [
                    79.0850275,
                    55.1367154
                ],
                [
                    79.0907243,
                    55.1386205
                ],
                [
                    79.0924262,
                    55.1375801
                ],
                [
                    79.0931826,
                    55.1328102
                ],
                [
                    79.0915516,
                    55.1319184
                ],
                [
                    79.0905115,
                    55.1277154
                ],
                [
                    79.0862566,
                    55.128256
                ],
                [
                    79.087084,
                    55.130121
                ],
                [
                    79.085973,
                    55.1329183
                ],
                [
                    79.0835383,
                    55.1331616
                ],
                [
                    79.0820727,
                    55.1338372
                ],
                [
                    79.0820254,
                    55.1341075
                ]
            ],
            "longitude": 79.089844,
            "latitude": 55.133221
        },
        "9850": {
            "name": "Дружный",
            "population": 193,
            "type": "hamlet",
            "poly": [
                [
                    79.085396,
                    54.4331181
                ],
                [
                    79.088837,
                    54.4342954
                ],
                [
                    79.0881848,
                    54.4355774
                ],
                [
                    79.0896241,
                    54.4358782
                ],
                [
                    79.0940111,
                    54.4377537
                ],
                [
                    79.0987101,
                    54.4392136
                ],
                [
                    79.1039728,
                    54.4349364
                ],
                [
                    79.1047825,
                    54.4341254
                ],
                [
                    79.1008692,
                    54.4323986
                ],
                [
                    79.0947771,
                    54.4300367
                ],
                [
                    79.0924581,
                    54.4311462
                ],
                [
                    79.0862696,
                    54.4290256
                ],
                [
                    79.0855033,
                    54.4306334
                ],
                [
                    79.0856746,
                    54.4319084
                ],
                [
                    79.085396,
                    54.4331181
                ]
            ],
            "longitude": 79.095459,
            "latitude": 54.43375
        },
        "9851": {
            "name": "Угурманский",
            "population": 98,
            "type": "hamlet",
            "poly": [
                [
                    79.0963011,
                    55.6903871
                ],
                [
                    79.0995185,
                    55.6910627
                ],
                [
                    79.0999727,
                    55.6909702
                ],
                [
                    79.1006793,
                    55.6914254
                ],
                [
                    79.1020546,
                    55.690764
                ],
                [
                    79.1024204,
                    55.6907995
                ],
                [
                    79.1025719,
                    55.691276
                ],
                [
                    79.1031649,
                    55.6915392
                ],
                [
                    79.1044897,
                    55.6916956
                ],
                [
                    79.105436,
                    55.6915036
                ],
                [
                    79.1075305,
                    55.6918521
                ],
                [
                    79.1080983,
                    55.6915605
                ],
                [
                    79.1080731,
                    55.6912476
                ],
                [
                    79.1121611,
                    55.6911765
                ],
                [
                    79.1123251,
                    55.6910058
                ],
                [
                    79.1162113,
                    55.6908067
                ],
                [
                    79.1202109,
                    55.6903159
                ],
                [
                    79.1201479,
                    55.6895692
                ],
                [
                    79.1199081,
                    55.6890287
                ],
                [
                    79.1190249,
                    55.6886873
                ],
                [
                    79.1189492,
                    55.6878836
                ],
                [
                    79.1172837,
                    55.6879049
                ],
                [
                    79.117309,
                    55.6885237
                ],
                [
                    79.1163374,
                    55.6884952
                ],
                [
                    79.1158832,
                    55.6881894
                ],
                [
                    79.1141925,
                    55.688225
                ],
                [
                    79.1137509,
                    55.6861268
                ],
                [
                    79.1122494,
                    55.6862619
                ],
                [
                    79.1121359,
                    55.6866958
                ],
                [
                    79.1094862,
                    55.6871439
                ],
                [
                    79.1097007,
                    55.6888153
                ],
                [
                    79.1070258,
                    55.6889077
                ],
                [
                    79.106824,
                    55.6886802
                ],
                [
                    79.1016761,
                    55.6888651
                ],
                [
                    79.099897,
                    55.6894554
                ],
                [
                    79.0986038,
                    55.6895052
                ],
                [
                    79.0976196,
                    55.6891922
                ],
                [
                    79.0963011,
                    55.6903871
                ]
            ],
            "longitude": 79.110863,
            "latitude": 55.68951
        },
        "9852": {
            "name": "Палкин Водопой",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    79.1061427,
                    53.815874
                ],
                [
                    79.106938,
                    53.8172493
                ],
                [
                    79.1081881,
                    53.8175176
                ],
                [
                    79.1125064,
                    53.8178307
                ],
                [
                    79.1153852,
                    53.8165113
                ],
                [
                    79.1182451,
                    53.8142414
                ],
                [
                    79.1171087,
                    53.8132462
                ],
                [
                    79.1137185,
                    53.8138277
                ],
                [
                    79.1095707,
                    53.8138612
                ],
                [
                    79.1077146,
                    53.814521
                ],
                [
                    79.1068054,
                    53.815259
                ],
                [
                    79.1061427,
                    53.815874
                ]
            ],
            "longitude": 79.112587,
            "latitude": 53.816578
        },
        "9853": {
            "name": "Жданковский",
            "population": 47,
            "type": "hamlet",
            "poly": [
                [
                    79.1383674,
                    55.3764021
                ],
                [
                    79.1384778,
                    55.3768286
                ],
                [
                    79.1391402,
                    55.3791497
                ],
                [
                    79.1387649,
                    55.3827501
                ],
                [
                    79.1402002,
                    55.3832644
                ],
                [
                    79.1411939,
                    55.3835529
                ],
                [
                    79.1443958,
                    55.382863
                ],
                [
                    79.1452128,
                    55.3815834
                ],
                [
                    79.1464273,
                    55.3794131
                ],
                [
                    79.1437775,
                    55.3775563
                ],
                [
                    79.1438437,
                    55.3771298
                ],
                [
                    79.1440204,
                    55.3763142
                ],
                [
                    79.1433579,
                    55.375185
                ],
                [
                    79.1417018,
                    55.3753983
                ],
                [
                    79.1416797,
                    55.3759002
                ],
                [
                    79.1389636,
                    55.3760759
                ],
                [
                    79.1383674,
                    55.3764021
                ]
            ],
            "longitude": 79.143188,
            "latitude": 55.378922
        },
        "9854": {
            "name": "Новолобинский",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    79.141703,
                    53.8325329
                ],
                [
                    79.1428422,
                    53.8401492
                ],
                [
                    79.1436925,
                    53.8449837
                ],
                [
                    79.1437833,
                    53.8459686
                ],
                [
                    79.1450213,
                    53.8465917
                ],
                [
                    79.1487259,
                    53.8471317
                ],
                [
                    79.1520294,
                    53.8396374
                ],
                [
                    79.1506481,
                    53.8336854
                ],
                [
                    79.1501468,
                    53.8299036
                ],
                [
                    79.1459902,
                    53.8299887
                ],
                [
                    79.1421807,
                    53.8299806
                ],
                [
                    79.141703,
                    53.8325329
                ]
            ],
            "longitude": 79.147041,
            "latitude": 53.842232
        },
        "9855": {
            "name": "Андреевка",
            "population": 160,
            "type": "hamlet",
            "poly": [
                [
                    79.1421116,
                    55.7132496
                ],
                [
                    79.146932,
                    55.7141733
                ],
                [
                    79.148843,
                    55.7147269
                ],
                [
                    79.1526182,
                    55.7137591
                ],
                [
                    79.1606367,
                    55.7140502
                ],
                [
                    79.1600361,
                    55.7124508
                ],
                [
                    79.1583435,
                    55.7115588
                ],
                [
                    79.1569239,
                    55.7118971
                ],
                [
                    79.1550129,
                    55.7118664
                ],
                [
                    79.1529926,
                    55.7112204
                ],
                [
                    79.1517368,
                    55.7100208
                ],
                [
                    79.1509178,
                    55.7089441
                ],
                [
                    79.1502626,
                    55.7050679
                ],
                [
                    79.1489522,
                    55.7048218
                ],
                [
                    79.1478602,
                    55.7026067
                ],
                [
                    79.1434921,
                    55.7010991
                ],
                [
                    79.1427277,
                    55.7017144
                ],
                [
                    79.1434047,
                    55.7037758
                ],
                [
                    79.145294,
                    55.7083596
                ],
                [
                    79.1440382,
                    55.7094363
                ],
                [
                    79.1421116,
                    55.7132496
                ]
            ],
            "longitude": 79.148392,
            "latitude": 55.709122
        },
        "9856": {
            "name": "Гандичи",
            "population": 98,
            "type": "hamlet",
            "poly": [
                [
                    79.1598773,
                    55.0388263
                ],
                [
                    79.1649802,
                    55.0411146
                ],
                [
                    79.1664874,
                    55.0418818
                ],
                [
                    79.1678721,
                    55.0428382
                ],
                [
                    79.170418,
                    55.0445332
                ],
                [
                    79.1736698,
                    55.0483601
                ],
                [
                    79.1767759,
                    55.0495252
                ],
                [
                    79.1857244,
                    55.0415595
                ],
                [
                    79.1856135,
                    55.0394407
                ],
                [
                    79.1813241,
                    55.0375973
                ],
                [
                    79.1786988,
                    55.0377032
                ],
                [
                    79.165165,
                    55.0334016
                ],
                [
                    79.1630204,
                    55.0347154
                ],
                [
                    79.1598773,
                    55.0388263
                ]
            ],
            "longitude": 79.174881,
            "latitude": 55.040562
        },
        "9857": {
            "name": "Белоозерный",
            "population": 109,
            "type": "hamlet",
            "poly": [
                [
                    79.1729641,
                    55.1530295
                ],
                [
                    79.1751245,
                    55.1545355
                ],
                [
                    79.1877417,
                    55.1594852
                ],
                [
                    79.1892756,
                    55.1600283
                ],
                [
                    79.1903126,
                    55.1601517
                ],
                [
                    79.1913065,
                    55.1598678
                ],
                [
                    79.1944391,
                    55.1602751
                ],
                [
                    79.1952385,
                    55.1596827
                ],
                [
                    79.1949016,
                    55.1590774
                ],
                [
                    79.1939803,
                    55.1585466
                ],
                [
                    79.1744204,
                    55.1513559
                ],
                [
                    79.1733746,
                    55.1518814
                ],
                [
                    79.1729641,
                    55.1530295
                ]
            ],
            "longitude": 79.183792,
            "latitude": 55.155941
        },
        "9858": {
            "name": "Ильинка",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.184761,
            "latitude": 55.502914
        },
        "9859": {
            "name": "Каревский",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    79.1854086,
                    54.3021108
                ],
                [
                    79.1870167,
                    54.302534
                ],
                [
                    79.1866699,
                    54.3034907
                ],
                [
                    79.1871744,
                    54.3035275
                ],
                [
                    79.188278,
                    54.3032884
                ],
                [
                    79.1896024,
                    54.301982
                ],
                [
                    79.1915574,
                    54.3023868
                ],
                [
                    79.1919358,
                    54.3020004
                ],
                [
                    79.1925033,
                    54.3020924
                ],
                [
                    79.1926295,
                    54.3018348
                ],
                [
                    79.1948683,
                    54.3026076
                ],
                [
                    79.1953097,
                    54.3020188
                ],
                [
                    79.1955304,
                    54.299774
                ],
                [
                    79.196571,
                    54.2987804
                ],
                [
                    79.1968548,
                    54.2960202
                ],
                [
                    79.1983999,
                    54.2936094
                ],
                [
                    79.1971071,
                    54.293407
                ],
                [
                    79.196098,
                    54.29464
                ],
                [
                    79.1952151,
                    54.2943455
                ],
                [
                    79.1964449,
                    54.2929285
                ],
                [
                    79.1943637,
                    54.2923212
                ],
                [
                    79.1941746,
                    54.292634
                ],
                [
                    79.1953728,
                    54.2932781
                ],
                [
                    79.1948367,
                    54.2939223
                ],
                [
                    79.1939854,
                    54.293683
                ],
                [
                    79.1930709,
                    54.2937934
                ],
                [
                    79.1928187,
                    54.2940879
                ],
                [
                    79.1931655,
                    54.2943455
                ],
                [
                    79.1928187,
                    54.2948056
                ],
                [
                    79.1920619,
                    54.2947688
                ],
                [
                    79.1908006,
                    54.2960018
                ],
                [
                    79.1912105,
                    54.296149
                ],
                [
                    79.1910529,
                    54.2965906
                ],
                [
                    79.1918412,
                    54.296793
                ],
                [
                    79.1910844,
                    54.2977683
                ],
                [
                    79.1904853,
                    54.2977499
                ],
                [
                    79.1889087,
                    54.2981179
                ],
                [
                    79.1875213,
                    54.2994612
                ],
                [
                    79.1873951,
                    54.3002524
                ],
                [
                    79.1885618,
                    54.3005468
                ],
                [
                    79.188278,
                    54.300786
                ],
                [
                    79.187742,
                    54.3007676
                ],
                [
                    79.1873005,
                    54.3011908
                ],
                [
                    79.1871113,
                    54.3016876
                ],
                [
                    79.1864176,
                    54.3015588
                ],
                [
                    79.1865753,
                    54.3018164
                ],
                [
                    79.1857554,
                    54.3016324
                ],
                [
                    79.1854086,
                    54.3021108
                ]
            ],
            "longitude": 79.193771,
            "latitude": 54.298725
        },
        "9860": {
            "name": "Сергиевка",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.219955,
            "latitude": 55.73613
        },
        "9861": {
            "name": "Ленинградский",
            "population": 139,
            "type": "hamlet",
            "poly": [
                [
                    79.2297436,
                    54.1333388
                ],
                [
                    79.2339114,
                    54.135696
                ],
                [
                    79.2385201,
                    54.1370956
                ],
                [
                    79.2433092,
                    54.1308422
                ],
                [
                    79.2463084,
                    54.1240523
                ],
                [
                    79.2417429,
                    54.1227143
                ],
                [
                    79.2370703,
                    54.1216254
                ],
                [
                    79.2335477,
                    54.12799
                ],
                [
                    79.2297436,
                    54.1333388
                ]
            ],
            "longitude": 79.236702,
            "latitude": 54.129108
        },
        "9862": {
            "name": "Николаевка",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.255577,
            "latitude": 55.649551
        },
        "9863": {
            "name": "Голубинский",
            "population": 229,
            "type": "hamlet",
            "poly": [
                [
                    79.257893,
                    53.7064565
                ],
                [
                    79.257893,
                    53.7079142
                ],
                [
                    79.2638189,
                    53.708848
                ],
                [
                    79.2673975,
                    53.7081192
                ],
                [
                    79.2783642,
                    53.7082558
                ],
                [
                    79.2791338,
                    53.7076181
                ],
                [
                    79.2771329,
                    53.7024931
                ],
                [
                    79.2751703,
                    53.7018781
                ],
                [
                    79.2747087,
                    53.699919
                ],
                [
                    79.2752474,
                    53.6970713
                ],
                [
                    79.2737467,
                    53.6960689
                ],
                [
                    79.2714764,
                    53.6954765
                ],
                [
                    79.2705529,
                    53.6957955
                ],
                [
                    79.267436,
                    53.6971624
                ],
                [
                    79.2669358,
                    53.6982788
                ],
                [
                    79.2672436,
                    53.701058
                ],
                [
                    79.2660123,
                    53.7022653
                ],
                [
                    79.2633572,
                    53.7030626
                ],
                [
                    79.2613947,
                    53.703632
                ],
                [
                    79.2587781,
                    53.7049304
                ],
                [
                    79.257893,
                    53.7064565
                ]
            ],
            "longitude": 79.272072,
            "latitude": 53.703159
        },
        "9864": {
            "name": "Колмаково",
            "population": 83,
            "type": "hamlet",
            "poly": [
                [
                    79.2694532,
                    55.4314284
                ],
                [
                    79.2702109,
                    55.4321879
                ],
                [
                    79.2753381,
                    55.4356557
                ],
                [
                    79.2768282,
                    55.4363292
                ],
                [
                    79.2817281,
                    55.4373895
                ],
                [
                    79.2849358,
                    55.4375758
                ],
                [
                    79.2890021,
                    55.4352402
                ],
                [
                    79.2881434,
                    55.4341655
                ],
                [
                    79.2850115,
                    55.4339935
                ],
                [
                    79.2808441,
                    55.4338359
                ],
                [
                    79.2742015,
                    55.429465
                ],
                [
                    79.2722315,
                    55.4298377
                ],
                [
                    79.2694532,
                    55.4314284
                ]
            ],
            "longitude": 79.275902,
            "latitude": 55.434338
        },
        "9865": {
            "name": "Калиновский",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    79.2816798,
                    53.767532
                ],
                [
                    79.2851835,
                    53.7687957
                ],
                [
                    79.2896771,
                    53.7654014
                ],
                [
                    79.2912343,
                    53.7642795
                ],
                [
                    79.2875844,
                    53.7631959
                ],
                [
                    79.2816798,
                    53.767532
                ]
            ],
            "longitude": 79.28511,
            "latitude": 53.767273
        },
        "9866": {
            "name": "Белолебяжий",
            "population": 51,
            "type": "hamlet",
            "poly": [
                [
                    79.283867,
                    54.9847354
                ],
                [
                    79.2881102,
                    54.9866599
                ],
                [
                    79.2944547,
                    54.9820687
                ],
                [
                    79.2961115,
                    54.9807005
                ],
                [
                    79.2969198,
                    54.9788685
                ],
                [
                    79.2953437,
                    54.977477
                ],
                [
                    79.2881102,
                    54.9761319
                ],
                [
                    79.2861704,
                    54.9762246
                ],
                [
                    79.2841095,
                    54.9770828
                ],
                [
                    79.2858067,
                    54.9791932
                ],
                [
                    79.2853218,
                    54.9807701
                ],
                [
                    79.2871807,
                    54.9821151
                ],
                [
                    79.283867,
                    54.9847354
                ]
            ],
            "longitude": 79.289856,
            "latitude": 54.981464
        },
        "9867": {
            "name": "Суходолье",
            "population": 148,
            "type": "hamlet",
            "poly": [
                [
                    79.314592,
                    55.0441151
                ],
                [
                    79.3158018,
                    55.0510289
                ],
                [
                    79.3162857,
                    55.0511155
                ],
                [
                    79.3184634,
                    55.0517219
                ],
                [
                    79.3282329,
                    55.0473382
                ],
                [
                    79.325057,
                    55.0423648
                ],
                [
                    79.318282,
                    55.0427461
                ],
                [
                    79.3153784,
                    55.0432659
                ],
                [
                    79.314592,
                    55.0441151
                ]
            ],
            "longitude": 79.319244,
            "latitude": 55.04636
        },
        "9868": {
            "name": "Клубничная",
            "population": 106,
            "type": "hamlet",
            "poly": [
                [
                    79.3245178,
                    55.324373
                ],
                [
                    79.3355509,
                    55.3243449
                ],
                [
                    79.3453499,
                    55.324359
                ],
                [
                    79.34846,
                    55.3230951
                ],
                [
                    79.3488302,
                    55.3222244
                ],
                [
                    79.348608,
                    55.3207498
                ],
                [
                    79.3472999,
                    55.3204128
                ],
                [
                    79.3434987,
                    55.3209324
                ],
                [
                    79.3412526,
                    55.3205392
                ],
                [
                    79.3384141,
                    55.3214661
                ],
                [
                    79.3332801,
                    55.3222385
                ],
                [
                    79.3249127,
                    55.3222946
                ],
                [
                    79.3245178,
                    55.324373
                ]
            ],
            "longitude": 79.338905,
            "latitude": 55.323067
        },
        "9869": {
            "name": "Клубничный",
            "population": 87,
            "type": "hamlet",
            "poly": [
                [
                    79.332856,
                    55.3255134
                ],
                [
                    79.3346226,
                    55.3266764
                ],
                [
                    79.3423198,
                    55.3296625
                ],
                [
                    79.3527425,
                    55.3341557
                ],
                [
                    79.3553924,
                    55.3343279
                ],
                [
                    79.3580927,
                    55.3325623
                ],
                [
                    79.3576889,
                    55.3305526
                ],
                [
                    79.3537267,
                    55.329117
                ],
                [
                    79.3471905,
                    55.3271071
                ],
                [
                    79.3468624,
                    55.3248243
                ],
                [
                    79.332856,
                    55.3255134
                ]
            ],
            "longitude": 79.350998,
            "latitude": 55.330067
        },
        "9870": {
            "name": "Красиково",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.351974,
            "latitude": 55.906281
        },
        "9871": {
            "name": "Подлесный",
            "population": 108,
            "type": "hamlet",
            "poly": [
                [
                    79.3763958,
                    55.2918025
                ],
                [
                    79.3778715,
                    55.2926932
                ],
                [
                    79.3791996,
                    55.2931637
                ],
                [
                    79.3837742,
                    55.2934158
                ],
                [
                    79.3896472,
                    55.2895842
                ],
                [
                    79.3897949,
                    55.2883238
                ],
                [
                    79.3871387,
                    55.2870801
                ],
                [
                    79.3798489,
                    55.2849456
                ],
                [
                    79.3776354,
                    55.2864414
                ],
                [
                    79.3776354,
                    55.2870297
                ],
                [
                    79.3783142,
                    55.2886263
                ],
                [
                    79.3784322,
                    55.2895842
                ],
                [
                    79.3765434,
                    55.290811
                ],
                [
                    79.3763958,
                    55.2918025
                ]
            ],
            "longitude": 79.382889,
            "latitude": 55.289211
        },
        "9872": {
            "name": "Шушковский",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    79.37436,
                    55.3859889
                ],
                [
                    79.376027,
                    55.3879788
                ],
                [
                    79.3771867,
                    55.3883356
                ],
                [
                    79.3801584,
                    55.3890355
                ],
                [
                    79.3854979,
                    55.390051
                ],
                [
                    79.3933017,
                    55.3909979
                ],
                [
                    79.3944372,
                    55.3885552
                ],
                [
                    79.3898951,
                    55.3876357
                ],
                [
                    79.3855462,
                    55.3866476
                ],
                [
                    79.3873341,
                    55.3850693
                ],
                [
                    79.3861502,
                    55.3847399
                ],
                [
                    79.3828402,
                    55.3842321
                ],
                [
                    79.3776216,
                    55.3837518
                ],
                [
                    79.37436,
                    55.3859889
                ]
            ],
            "longitude": 79.387894,
            "latitude": 55.388069
        },
        "9873": {
            "name": "Зуевский",
            "population": 99,
            "type": "hamlet",
            "poly": [
                [
                    79.3781701,
                    53.7579993
                ],
                [
                    79.3830174,
                    53.7614969
                ],
                [
                    79.3885702,
                    53.7637049
                ],
                [
                    79.3954742,
                    53.766426
                ],
                [
                    79.397741,
                    53.7654196
                ],
                [
                    79.4001662,
                    53.7638902
                ],
                [
                    79.3996801,
                    53.7483709
                ],
                [
                    79.3917809,
                    53.7480834
                ],
                [
                    79.3833928,
                    53.7526342
                ],
                [
                    79.3797939,
                    53.7559885
                ],
                [
                    79.3781701,
                    53.7579993
                ]
            ],
            "longitude": 79.391129,
            "latitude": 53.758366
        },
        "9874": {
            "name": "Плеханово",
            "population": 120,
            "type": "hamlet",
            "poly": [
                [
                    79.4169073,
                    54.3616729
                ],
                [
                    79.4194739,
                    54.3657345
                ],
                [
                    79.4328663,
                    54.3674216
                ],
                [
                    79.4330551,
                    54.3633521
                ],
                [
                    79.43617,
                    54.3626371
                ],
                [
                    79.4436269,
                    54.3628571
                ],
                [
                    79.4482521,
                    54.3543317
                ],
                [
                    79.4369251,
                    54.3521313
                ],
                [
                    79.4355092,
                    54.3548818
                ],
                [
                    79.4292794,
                    54.3591171
                ],
                [
                    79.4206051,
                    54.3598867
                ],
                [
                    79.4169073,
                    54.3616729
                ]
            ],
            "longitude": 79.429359,
            "latitude": 54.36208
        },
        "9875": {
            "name": "Луговой",
            "population": 145,
            "type": "hamlet",
            "poly": [
                [
                    79.4271576,
                    54.0965049
                ],
                [
                    79.4325686,
                    54.097668
                ],
                [
                    79.4310414,
                    54.1010477
                ],
                [
                    79.4286771,
                    54.1044442
                ],
                [
                    79.4321106,
                    54.1050856
                ],
                [
                    79.4346709,
                    54.1017597
                ],
                [
                    79.438398,
                    54.0988782
                ],
                [
                    79.4395681,
                    54.0981213
                ],
                [
                    79.4393279,
                    54.0957268
                ],
                [
                    79.439658,
                    54.09233
                ],
                [
                    79.438167,
                    54.0917514
                ],
                [
                    79.436699,
                    54.0913335
                ],
                [
                    79.4345701,
                    54.0950704
                ],
                [
                    79.4320186,
                    54.0954856
                ],
                [
                    79.4318775,
                    54.0952278
                ],
                [
                    79.4319727,
                    54.0949054
                ],
                [
                    79.4323357,
                    54.0942403
                ],
                [
                    79.4293814,
                    54.0935924
                ],
                [
                    79.4277891,
                    54.0949917
                ],
                [
                    79.4271576,
                    54.0965049
                ]
            ],
            "longitude": 79.435349,
            "latitude": 54.097656
        },
        "9876": {
            "name": "Успенский",
            "population": 37,
            "type": "hamlet",
            "poly": [
                [
                    79.4254078,
                    53.930604
                ],
                [
                    79.4325651,
                    53.9337164
                ],
                [
                    79.442325,
                    53.9337643
                ],
                [
                    79.4431231,
                    53.9310515
                ],
                [
                    79.4429827,
                    53.9282312
                ],
                [
                    79.4332971,
                    53.9253362
                ],
                [
                    79.4267091,
                    53.9268687
                ],
                [
                    79.4254078,
                    53.930604
                ]
            ],
            "longitude": 79.435738,
            "latitude": 53.930779
        },
        "9877": {
            "name": "Ксеньевка",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    79.4259165,
                    55.4387463
                ],
                [
                    79.4263043,
                    55.4401946
                ],
                [
                    79.4407826,
                    55.4432194
                ],
                [
                    79.4477308,
                    55.4438793
                ],
                [
                    79.4482532,
                    55.4424522
                ],
                [
                    79.4477308,
                    55.4408179
                ],
                [
                    79.4396191,
                    55.4395163
                ],
                [
                    79.4267567,
                    55.4374079
                ],
                [
                    79.4259165,
                    55.4387463
                ]
            ],
            "longitude": 79.438141,
            "latitude": 55.440708
        },
        "9878": {
            "name": "Кирилловка",
            "population": 144,
            "type": "hamlet",
            "poly": [
                [
                    79.4514316,
                    55.119536
                ],
                [
                    79.457945,
                    55.1215193
                ],
                [
                    79.4533772,
                    55.1271541
                ],
                [
                    79.455365,
                    55.1287743
                ],
                [
                    79.4662347,
                    55.132498
                ],
                [
                    79.4681379,
                    55.1308538
                ],
                [
                    79.4671652,
                    55.1290886
                ],
                [
                    79.462978,
                    55.1272267
                ],
                [
                    79.465135,
                    55.1248326
                ],
                [
                    79.4642891,
                    55.1230429
                ],
                [
                    79.4663616,
                    55.1200197
                ],
                [
                    79.4652619,
                    55.1162465
                ],
                [
                    79.4632741,
                    55.115932
                ],
                [
                    79.4533349,
                    55.1167544
                ],
                [
                    79.4514316,
                    55.119536
                ]
            ],
            "longitude": 79.460876,
            "latitude": 55.12022
        },
        "9879": {
            "name": "Кротово",
            "population": 122,
            "type": "hamlet",
            "poly": [
                [
                    79.4471194,
                    54.7524397
                ],
                [
                    79.4474014,
                    54.7539946
                ],
                [
                    79.4489992,
                    54.7543743
                ],
                [
                    79.4489992,
                    54.7549709
                ],
                [
                    79.44737,
                    54.755441
                ],
                [
                    79.4481219,
                    54.7558749
                ],
                [
                    79.4493125,
                    54.7558206
                ],
                [
                    79.4493751,
                    54.7569596
                ],
                [
                    79.4489052,
                    54.7571404
                ],
                [
                    79.4489678,
                    54.7576466
                ],
                [
                    79.4499391,
                    54.7574839
                ],
                [
                    79.4499077,
                    54.7578997
                ],
                [
                    79.4491245,
                    54.7582432
                ],
                [
                    79.4488112,
                    54.759129
                ],
                [
                    79.4496258,
                    54.7601052
                ],
                [
                    79.4484979,
                    54.760304
                ],
                [
                    79.4483412,
                    54.7607559
                ],
                [
                    79.4487485,
                    54.761244
                ],
                [
                    79.4513176,
                    54.7632324
                ],
                [
                    79.4547325,
                    54.767733
                ],
                [
                    79.4570509,
                    54.7679319
                ],
                [
                    79.4548265,
                    54.7691066
                ],
                [
                    79.4558604,
                    54.7702633
                ],
                [
                    79.4569256,
                    54.7705886
                ],
                [
                    79.4578028,
                    54.7700826
                ],
                [
                    79.4584294,
                    54.7705344
                ],
                [
                    79.4579594,
                    54.7723778
                ],
                [
                    79.4588367,
                    54.7722874
                ],
                [
                    79.4596512,
                    54.7713296
                ],
                [
                    79.4620636,
                    54.7715645
                ],
                [
                    79.4623143,
                    54.7708778
                ],
                [
                    79.4637554,
                    54.7708416
                ],
                [
                    79.4649773,
                    54.7714742
                ],
                [
                    79.4659798,
                    54.7727392
                ],
                [
                    79.4656039,
                    54.7731368
                ],
                [
                    79.4660112,
                    54.7734259
                ],
                [
                    79.4664811,
                    54.7731006
                ],
                [
                    79.4670137,
                    54.7733717
                ],
                [
                    79.467515,
                    54.7728838
                ],
                [
                    79.4698647,
                    54.773191
                ],
                [
                    79.4701316,
                    54.7726188
                ],
                [
                    79.4695401,
                    54.7723239
                ],
                [
                    79.4698334,
                    54.7717814
                ],
                [
                    79.4712745,
                    54.7724139
                ],
                [
                    79.4718698,
                    54.7722151
                ],
                [
                    79.472747,
                    54.7725043
                ],
                [
                    79.4739376,
                    54.7708416
                ],
                [
                    79.4726217,
                    54.7693958
                ],
                [
                    79.4701153,
                    54.7686187
                ],
                [
                    79.4658232,
                    54.7679319
                ],
                [
                    79.4651653,
                    54.7682933
                ],
                [
                    79.4609358,
                    54.7675342
                ],
                [
                    79.4605285,
                    54.7676065
                ],
                [
                    79.4599645,
                    54.7665582
                ],
                [
                    79.458492,
                    54.7664317
                ],
                [
                    79.4580848,
                    54.7661064
                ],
                [
                    79.4570822,
                    54.7634855
                ],
                [
                    79.4573642,
                    54.7624732
                ],
                [
                    79.4583667,
                    54.760774
                ],
                [
                    79.4582414,
                    54.7603221
                ],
                [
                    79.4521008,
                    54.7589482
                ],
                [
                    79.450785,
                    54.7577189
                ],
                [
                    79.4500957,
                    54.7552421
                ],
                [
                    79.450785,
                    54.7546455
                ],
                [
                    79.4525394,
                    54.7544647
                ],
                [
                    79.4514429,
                    54.7534884
                ],
                [
                    79.453166,
                    54.7528555
                ],
                [
                    79.4518502,
                    54.7517888
                ],
                [
                    79.4496571,
                    54.7522408
                ],
                [
                    79.4471194,
                    54.7524397
                ]
            ],
            "longitude": 79.462044,
            "latitude": 54.769531
        },
        "9880": {
            "name": "Центральный",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    79.4647401,
                    53.7509157
                ],
                [
                    79.4684385,
                    53.7515027
                ],
                [
                    79.4709592,
                    53.7517616
                ],
                [
                    79.4742974,
                    53.752199
                ],
                [
                    79.4748716,
                    53.7510768
                ],
                [
                    79.474677,
                    53.7509675
                ],
                [
                    79.4737329,
                    53.7506912
                ],
                [
                    79.4711928,
                    53.7501445
                ],
                [
                    79.4702876,
                    53.7499489
                ],
                [
                    79.4673582,
                    53.7496036
                ],
                [
                    79.4662876,
                    53.7495863
                ],
                [
                    79.4652267,
                    53.7495057
                ],
                [
                    79.4650418,
                    53.7499776
                ],
                [
                    79.4647401,
                    53.7509157
                ]
            ],
            "longitude": 79.47274,
            "latitude": 53.750866
        },
        "9881": {
            "name": "Еланка",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.49588,
            "latitude": 55.82782
        },
        "9882": {
            "name": "Ежула",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.50882,
            "latitude": 55.699974
        },
        "9883": {
            "name": "Новая Качемка",
            "population": 70,
            "type": "hamlet",
            "poly": [
                [
                    79.5149905,
                    55.3960841
                ],
                [
                    79.5152116,
                    55.3963831
                ],
                [
                    79.5170029,
                    55.3972543
                ],
                [
                    79.5187768,
                    55.3978432
                ],
                [
                    79.5183245,
                    55.398394
                ],
                [
                    79.519466,
                    55.3986937
                ],
                [
                    79.5191204,
                    55.399087
                ],
                [
                    79.5203589,
                    55.3995266
                ],
                [
                    79.5215203,
                    55.3996119
                ],
                [
                    79.5223022,
                    55.3994764
                ],
                [
                    79.52323,
                    55.3996194
                ],
                [
                    79.5265308,
                    55.4006336
                ],
                [
                    79.5274284,
                    55.4005833
                ],
                [
                    79.5280542,
                    55.3998452
                ],
                [
                    79.5296036,
                    55.400031
                ],
                [
                    79.5305941,
                    55.3989763
                ],
                [
                    79.5281933,
                    55.3978115
                ],
                [
                    79.5260887,
                    55.3964455
                ],
                [
                    79.5246738,
                    55.3961643
                ],
                [
                    79.5223569,
                    55.3957324
                ],
                [
                    79.5203674,
                    55.3959326
                ],
                [
                    79.5200301,
                    55.3962413
                ],
                [
                    79.519599,
                    55.3960497
                ],
                [
                    79.5198025,
                    55.3956697
                ],
                [
                    79.5190623,
                    55.395238
                ],
                [
                    79.5170406,
                    55.3947799
                ],
                [
                    79.5162774,
                    55.3946702
                ],
                [
                    79.5156006,
                    55.3948334
                ],
                [
                    79.5160252,
                    55.3953256
                ],
                [
                    79.5153219,
                    55.3956446
                ],
                [
                    79.5149905,
                    55.3960841
                ]
            ],
            "longitude": 79.52298,
            "latitude": 55.397732
        },
        "9884": {
            "name": "Новобородино",
            "population": 29,
            "type": "hamlet",
            "poly": [
                [
                    79.5245856,
                    55.5126415
                ],
                [
                    79.5250452,
                    55.5131893
                ],
                [
                    79.5262546,
                    55.5137645
                ],
                [
                    79.5294475,
                    55.512573
                ],
                [
                    79.5318663,
                    55.5156819
                ],
                [
                    79.5356155,
                    55.514641
                ],
                [
                    79.5370426,
                    55.513066
                ],
                [
                    79.5368491,
                    55.511354
                ],
                [
                    79.5360509,
                    55.5107103
                ],
                [
                    79.5375748,
                    55.508642
                ],
                [
                    79.5319631,
                    55.5091762
                ],
                [
                    79.5319389,
                    55.5078887
                ],
                [
                    79.5305602,
                    55.5072723
                ],
                [
                    79.529254,
                    55.5069161
                ],
                [
                    79.5276818,
                    55.5079845
                ],
                [
                    79.5268594,
                    55.509231
                ],
                [
                    79.528746,
                    55.5114225
                ],
                [
                    79.5260611,
                    55.5117786
                ],
                [
                    79.5245856,
                    55.5126415
                ]
            ],
            "longitude": 79.531471,
            "latitude": 55.511761
        },
        "9885": {
            "name": "Урожайный",
            "population": 176,
            "type": "hamlet",
            "poly": [
                [
                    79.5255843,
                    53.7917521
                ],
                [
                    79.5257205,
                    53.7929772
                ],
                [
                    79.5264959,
                    53.7940456
                ],
                [
                    79.5266591,
                    53.7967684
                ],
                [
                    79.5288445,
                    53.799128
                ],
                [
                    79.5329511,
                    53.8013329
                ],
                [
                    79.538551,
                    53.8014799
                ],
                [
                    79.5397715,
                    53.7963101
                ],
                [
                    79.5378154,
                    53.7902767
                ],
                [
                    79.5350044,
                    53.7888371
                ],
                [
                    79.5313517,
                    53.7890694
                ],
                [
                    79.5291963,
                    53.790547
                ],
                [
                    79.5255843,
                    53.7917521
                ]
            ],
            "longitude": 79.532356,
            "latitude": 53.79451
        },
        "9886": {
            "name": "Целинный",
            "population": 123,
            "type": "hamlet",
            "poly": [
                [
                    79.5352611,
                    53.7507581
                ],
                [
                    79.540301,
                    53.7526344
                ],
                [
                    79.5504431,
                    53.7520089
                ],
                [
                    79.5471454,
                    53.7490288
                ],
                [
                    79.5413514,
                    53.7500472
                ],
                [
                    79.5400945,
                    53.7490877
                ],
                [
                    79.5398656,
                    53.7460853
                ],
                [
                    79.5354479,
                    53.7463429
                ],
                [
                    79.5352611,
                    53.7507581
                ]
            ],
            "longitude": 79.536957,
            "latitude": 53.75066
        },
        "9887": {
            "name": "Хромовский",
            "population": 86,
            "type": "hamlet",
            "poly": [
                [
                    79.5239632,
                    54.7868642
                ],
                [
                    79.5250206,
                    54.7869094
                ],
                [
                    79.5252555,
                    54.7859609
                ],
                [
                    79.5270178,
                    54.7858932
                ],
                [
                    79.5292109,
                    54.786661
                ],
                [
                    79.528741,
                    54.7872481
                ],
                [
                    79.531404,
                    54.7890546
                ],
                [
                    79.5320697,
                    54.7895513
                ],
                [
                    79.531169,
                    54.7903416
                ],
                [
                    79.5333229,
                    54.7913803
                ],
                [
                    79.5347719,
                    54.7906126
                ],
                [
                    79.5346153,
                    54.7914706
                ],
                [
                    79.5358293,
                    54.7911771
                ],
                [
                    79.5372,
                    54.7923512
                ],
                [
                    79.5403329,
                    54.7921028
                ],
                [
                    79.5407245,
                    54.7924866
                ],
                [
                    79.5429176,
                    54.792306
                ],
                [
                    79.5440925,
                    54.792735
                ],
                [
                    79.5453457,
                    54.7922157
                ],
                [
                    79.5453065,
                    54.7916286
                ],
                [
                    79.5481262,
                    54.791448
                ],
                [
                    79.5481653,
                    54.7921479
                ],
                [
                    79.5490269,
                    54.7923286
                ],
                [
                    79.5498885,
                    54.7921479
                ],
                [
                    79.5498885,
                    54.7912222
                ],
                [
                    79.5521599,
                    54.79059
                ],
                [
                    79.5520424,
                    54.7902468
                ],
                [
                    79.5505699,
                    54.7900661
                ],
                [
                    79.5501626,
                    54.7904635
                ],
                [
                    79.5491601,
                    54.7903371
                ],
                [
                    79.5490034,
                    54.7908248
                ],
                [
                    79.5474369,
                    54.7909332
                ],
                [
                    79.5472176,
                    54.789741
                ],
                [
                    79.5463404,
                    54.789741
                ],
                [
                    79.5463717,
                    54.7909151
                ],
                [
                    79.5451812,
                    54.7910416
                ],
                [
                    79.5447426,
                    54.7901023
                ],
                [
                    79.5441786,
                    54.7901384
                ],
                [
                    79.5441473,
                    54.7910777
                ],
                [
                    79.5420482,
                    54.7910416
                ],
                [
                    79.5413903,
                    54.7902648
                ],
                [
                    79.5400118,
                    54.7904635
                ],
                [
                    79.5384453,
                    54.7914932
                ],
                [
                    79.5355943,
                    54.7902829
                ],
                [
                    79.5338712,
                    54.7899397
                ],
                [
                    79.5319914,
                    54.7858932
                ],
                [
                    79.5308322,
                    54.7857125
                ],
                [
                    79.5299236,
                    54.7864351
                ],
                [
                    79.5272293,
                    54.7855499
                ],
                [
                    79.5272293,
                    54.7850441
                ],
                [
                    79.5262581,
                    54.7848273
                ],
                [
                    79.524253,
                    54.7849718
                ],
                [
                    79.5239632,
                    54.7868642
                ]
            ],
            "longitude": 79.54306,
            "latitude": 54.79192
        },
        "9888": {
            "name": "Лебединка",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    79.5415836,
                    55.5962309
                ],
                [
                    79.5418548,
                    55.5967481
                ],
                [
                    79.5555513,
                    55.598472
                ],
                [
                    79.5589077,
                    55.5971887
                ],
                [
                    79.5552462,
                    55.5951582
                ],
                [
                    79.5456519,
                    55.593664
                ],
                [
                    79.5436855,
                    55.5938364
                ],
                [
                    79.5424311,
                    55.5951007
                ],
                [
                    79.5415836,
                    55.5962309
                ]
            ],
            "longitude": 79.552071,
            "latitude": 55.596191
        },
        "9889": {
            "name": "Степной",
            "population": 204,
            "type": "hamlet",
            "poly": [
                [
                    79.5716933,
                    53.9232971
                ],
                [
                    79.574352,
                    53.925816
                ],
                [
                    79.5848175,
                    53.923194
                ],
                [
                    79.5834449,
                    53.9211405
                ],
                [
                    79.5816332,
                    53.9196177
                ],
                [
                    79.5796667,
                    53.9181546
                ],
                [
                    79.5754024,
                    53.9200779
                ],
                [
                    79.5716933,
                    53.9232971
                ]
            ],
            "longitude": 79.578636,
            "latitude": 53.922436
        },
        "9890": {
            "name": "Асенкритово",
            "population": 234,
            "type": "hamlet",
            "poly": [
                [
                    79.565493,
                    55.2384206
                ],
                [
                    79.5659229,
                    55.2390579
                ],
                [
                    79.5780902,
                    55.2416808
                ],
                [
                    79.5771873,
                    55.2436907
                ],
                [
                    79.5816587,
                    55.2448671
                ],
                [
                    79.5827766,
                    55.2446956
                ],
                [
                    79.5839804,
                    55.2430044
                ],
                [
                    79.5881078,
                    55.2442299
                ],
                [
                    79.5907304,
                    55.2444505
                ],
                [
                    79.5930521,
                    55.2434456
                ],
                [
                    79.5932241,
                    55.2428818
                ],
                [
                    79.5915473,
                    55.2418033
                ],
                [
                    79.5846683,
                    55.2393031
                ],
                [
                    79.5812288,
                    55.2384696
                ],
                [
                    79.5831635,
                    55.2366311
                ],
                [
                    79.5786491,
                    55.2338608
                ],
                [
                    79.5761125,
                    55.2334195
                ],
                [
                    79.5740058,
                    55.2343757
                ],
                [
                    79.5734469,
                    55.2353073
                ],
                [
                    79.5745647,
                    55.2369743
                ],
                [
                    79.5682446,
                    55.2360427
                ],
                [
                    79.5664389,
                    55.2368272
                ],
                [
                    79.565493,
                    55.2384206
                ]
            ],
            "longitude": 79.58094,
            "latitude": 55.239681
        },
        "9891": {
            "name": "Комендантка",
            "population": 106,
            "type": "hamlet",
            "poly": [
                [
                    79.6096244,
                    54.5973004
                ],
                [
                    79.6170494,
                    54.5998776
                ],
                [
                    79.6168615,
                    54.6001136
                ],
                [
                    79.6171748,
                    54.6002769
                ],
                [
                    79.6176134,
                    54.6000228
                ],
                [
                    79.6203391,
                    54.6015836
                ],
                [
                    79.6163289,
                    54.6010754
                ],
                [
                    79.6138225,
                    54.6038702
                ],
                [
                    79.6192112,
                    54.605703
                ],
                [
                    79.6226575,
                    54.602618
                ],
                [
                    79.6268243,
                    54.6042694
                ],
                [
                    79.6261351,
                    54.6049408
                ],
                [
                    79.6257278,
                    54.604596
                ],
                [
                    79.6252265,
                    54.6043964
                ],
                [
                    79.6234721,
                    54.6040879
                ],
                [
                    79.6221249,
                    54.605213
                ],
                [
                    79.624036,
                    54.60583
                ],
                [
                    79.6243493,
                    54.6056304
                ],
                [
                    79.6253205,
                    54.6059207
                ],
                [
                    79.6249759,
                    54.6062111
                ],
                [
                    79.6280462,
                    54.6070095
                ],
                [
                    79.6289234,
                    54.6060477
                ],
                [
                    79.6298007,
                    54.6059933
                ],
                [
                    79.6311792,
                    54.6045234
                ],
                [
                    79.6325577,
                    54.6051223
                ],
                [
                    79.6318058,
                    54.6059752
                ],
                [
                    79.6322756,
                    54.6062111
                ],
                [
                    79.6326517,
                    54.6059026
                ],
                [
                    79.6335915,
                    54.6061748
                ],
                [
                    79.6343435,
                    54.6051767
                ],
                [
                    79.6286415,
                    54.603108
                ],
                [
                    79.6289234,
                    54.6028176
                ],
                [
                    79.6277956,
                    54.6023095
                ],
                [
                    79.6273256,
                    54.602745
                ],
                [
                    79.6255712,
                    54.602001
                ],
                [
                    79.624412,
                    54.601511
                ],
                [
                    79.6235974,
                    54.6015654
                ],
                [
                    79.6184907,
                    54.5989157
                ],
                [
                    79.6181773,
                    54.5992424
                ],
                [
                    79.6136346,
                    54.5972278
                ],
                [
                    79.6138225,
                    54.5969919
                ],
                [
                    79.6131646,
                    54.5967922
                ],
                [
                    79.6110578,
                    54.5961775
                ],
                [
                    79.6096244,
                    54.5973004
                ]
            ],
            "longitude": 79.627762,
            "latitude": 54.603741
        },
        "9892": {
            "name": "Зелёная Роща",
            "population": 171,
            "type": "hamlet",
            "poly": [
                [
                    79.6399413,
                    53.9056202
                ],
                [
                    79.6452757,
                    53.909077
                ],
                [
                    79.6566047,
                    53.9032968
                ],
                [
                    79.654201,
                    53.8998157
                ],
                [
                    79.6413913,
                    53.8997204
                ],
                [
                    79.6399413,
                    53.9056202
                ]
            ],
            "longitude": 79.647575,
            "latitude": 53.903896
        },
        "9893": {
            "name": "Аткуль",
            "population": 172,
            "type": "hamlet",
            "poly": [
                [
                    79.6456721,
                    54.9759716
                ],
                [
                    79.6596762,
                    54.9775971
                ],
                [
                    79.6646328,
                    54.9755652
                ],
                [
                    79.6673077,
                    54.9719979
                ],
                [
                    79.6682517,
                    54.9694239
                ],
                [
                    79.6641607,
                    54.9677981
                ],
                [
                    79.6481897,
                    54.966127
                ],
                [
                    79.6470882,
                    54.970869
                ],
                [
                    79.6456721,
                    54.9759716
                ]
            ],
            "longitude": 79.655182,
            "latitude": 54.971306
        },
        "9894": {
            "name": "Новодоволенский",
            "population": 119,
            "type": "hamlet",
            "poly": [
                [
                    79.6656858,
                    54.5795517
                ],
                [
                    79.6659365,
                    54.5799511
                ],
                [
                    79.6665004,
                    54.5798059
                ],
                [
                    79.667503,
                    54.5822389
                ],
                [
                    79.6684742,
                    54.5821118
                ],
                [
                    79.6688188,
                    54.5829652
                ],
                [
                    79.6675969,
                    54.5830378
                ],
                [
                    79.6676909,
                    54.5842361
                ],
                [
                    79.6684742,
                    54.586215
                ],
                [
                    79.6702913,
                    54.5859972
                ],
                [
                    79.6708239,
                    54.5873225
                ],
                [
                    79.6738315,
                    54.5871954
                ],
                [
                    79.6736749,
                    54.5868141
                ],
                [
                    79.6720458,
                    54.5869231
                ],
                [
                    79.6720458,
                    54.5867052
                ],
                [
                    79.6741447,
                    54.586324
                ],
                [
                    79.6737376,
                    54.5853073
                ],
                [
                    79.6743641,
                    54.585162
                ],
                [
                    79.67521,
                    54.584345
                ],
                [
                    79.6748028,
                    54.5819121
                ],
                [
                    79.6754607,
                    54.5815308
                ],
                [
                    79.6758993,
                    54.5815308
                ],
                [
                    79.6765572,
                    54.5818939
                ],
                [
                    79.6774345,
                    54.5820937
                ],
                [
                    79.6784997,
                    54.5818576
                ],
                [
                    79.6790636,
                    54.5821481
                ],
                [
                    79.6800348,
                    54.5819484
                ],
                [
                    79.6791889,
                    54.5810587
                ],
                [
                    79.6808181,
                    54.580169
                ],
                [
                    79.6820399,
                    54.5800964
                ],
                [
                    79.6817266,
                    54.5795335
                ],
                [
                    79.6776851,
                    54.5795153
                ],
                [
                    79.6775911,
                    54.5788798
                ],
                [
                    79.6758993,
                    54.5795153
                ],
                [
                    79.6742388,
                    54.579824
                ],
                [
                    79.672923,
                    54.5795153
                ],
                [
                    79.6694454,
                    54.5791159
                ],
                [
                    79.6705733,
                    54.5784259
                ],
                [
                    79.6702913,
                    54.5775179
                ],
                [
                    79.6685995,
                    54.5776632
                ],
                [
                    79.6684427,
                    54.5772274
                ],
                [
                    79.6673776,
                    54.5772092
                ],
                [
                    79.6671269,
                    54.5775543
                ],
                [
                    79.6660931,
                    54.5776269
                ],
                [
                    79.6656858,
                    54.5795517
                ]
            ],
            "longitude": 79.671005,
            "latitude": 54.581715
        },
        "9895": {
            "name": "Каменка",
            "population": 158,
            "type": "hamlet",
            "poly": [
                [
                    79.6674406,
                    55.1513677
                ],
                [
                    79.6748105,
                    55.1528153
                ],
                [
                    79.6782651,
                    55.1525897
                ],
                [
                    79.6783638,
                    55.15039
                ],
                [
                    79.6842861,
                    55.1426434
                ],
                [
                    79.6808644,
                    55.1405185
                ],
                [
                    79.6806612,
                    55.1398907
                ],
                [
                    79.6795812,
                    55.1389388
                ],
                [
                    79.6783309,
                    55.1391644
                ],
                [
                    79.6750737,
                    55.1414775
                ],
                [
                    79.6714545,
                    55.1421357
                ],
                [
                    79.6690856,
                    55.1442417
                ],
                [
                    79.6676051,
                    55.1471938
                ],
                [
                    79.6674406,
                    55.1513677
                ]
            ],
            "longitude": 79.675919,
            "latitude": 55.144539
        },
        "9896": {
            "name": "Ревунка",
            "population": 42,
            "type": "hamlet",
            "poly": [
                [
                    79.6774204,
                    55.7012566
                ],
                [
                    79.6783832,
                    55.7018311
                ],
                [
                    79.6845571,
                    55.7042408
                ],
                [
                    79.6907875,
                    55.7054056
                ],
                [
                    79.697018,
                    55.7066662
                ],
                [
                    79.6986606,
                    55.7053737
                ],
                [
                    79.6964233,
                    55.7041291
                ],
                [
                    79.6906177,
                    55.7021982
                ],
                [
                    79.6832827,
                    55.6990542
                ],
                [
                    79.67844,
                    55.6999799
                ],
                [
                    79.6774204,
                    55.7012566
                ]
            ],
            "longitude": 79.686958,
            "latitude": 55.703434
        },
        "9897": {
            "name": "Беспятый",
            "population": 100,
            "type": "hamlet",
            "poly": [
                [
                    79.6917944,
                    54.1873916
                ],
                [
                    79.6960169,
                    54.1884703
                ],
                [
                    79.6985924,
                    54.1862572
                ],
                [
                    79.7002952,
                    54.1865924
                ],
                [
                    79.7024755,
                    54.1866017
                ],
                [
                    79.7035386,
                    54.186102
                ],
                [
                    79.7029835,
                    54.1846069
                ],
                [
                    79.7027059,
                    54.1827831
                ],
                [
                    79.7019181,
                    54.181084
                ],
                [
                    79.6994327,
                    54.1799747
                ],
                [
                    79.6917944,
                    54.1873916
                ]
            ],
            "longitude": 79.696709,
            "latitude": 54.185463
        },
        "9898": {
            "name": "Брянский",
            "population": 133,
            "type": "hamlet",
            "poly": [
                [
                    79.7378638,
                    54.2051967
                ],
                [
                    79.7388396,
                    54.2064001
                ],
                [
                    79.7397304,
                    54.2062264
                ],
                [
                    79.7400062,
                    54.2066978
                ],
                [
                    79.7392214,
                    54.2070575
                ],
                [
                    79.745521,
                    54.2141404
                ],
                [
                    79.7462634,
                    54.2138551
                ],
                [
                    79.7465604,
                    54.214252
                ],
                [
                    79.746221,
                    54.2143884
                ],
                [
                    79.7463907,
                    54.2146861
                ],
                [
                    79.7481724,
                    54.2140908
                ],
                [
                    79.7482148,
                    54.2137311
                ],
                [
                    79.7498267,
                    54.2131729
                ],
                [
                    79.7521812,
                    54.2132225
                ],
                [
                    79.7531937,
                    54.2136072
                ],
                [
                    79.7542993,
                    54.2131189
                ],
                [
                    79.7554053,
                    54.2124039
                ],
                [
                    79.7551296,
                    54.212193
                ],
                [
                    79.7555326,
                    54.2119946
                ],
                [
                    79.7554901,
                    54.2114984
                ],
                [
                    79.7546841,
                    54.2114612
                ],
                [
                    79.7525842,
                    54.209092
                ],
                [
                    79.7536236,
                    54.2090175
                ],
                [
                    79.7534327,
                    54.2079631
                ],
                [
                    79.750951,
                    54.2062636
                ],
                [
                    79.7488936,
                    54.2068094
                ],
                [
                    79.7493387,
                    54.2041502
                ],
                [
                    79.7459007,
                    54.2038061
                ],
                [
                    79.7440456,
                    54.2035527
                ],
                [
                    79.7424421,
                    54.2035128
                ],
                [
                    79.7385648,
                    54.2042263
                ],
                [
                    79.7378638,
                    54.2051967
                ]
            ],
            "longitude": 79.745583,
            "latitude": 54.208271
        },
        "9899": {
            "name": "Орловка",
            "population": 92,
            "type": "hamlet",
            "poly": [
                [
                    79.7477834,
                    55.2908126
                ],
                [
                    79.7482682,
                    55.2929235
                ],
                [
                    79.7507207,
                    55.2958299
                ],
                [
                    79.755141,
                    55.3003109
                ],
                [
                    79.7585917,
                    55.3000349
                ],
                [
                    79.7587343,
                    55.298379
                ],
                [
                    79.7586771,
                    55.2958299
                ],
                [
                    79.755854,
                    55.293979
                ],
                [
                    79.7553692,
                    55.2922416
                ],
                [
                    79.7534014,
                    55.2901793
                ],
                [
                    79.7477834,
                    55.2908126
                ]
            ],
            "longitude": 79.754173,
            "latitude": 55.295883
        },
        "9900": {
            "name": "Покровка",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    79.7487023,
                    54.3634606
                ],
                [
                    79.7543391,
                    54.3652959
                ],
                [
                    79.7582627,
                    54.367614
                ],
                [
                    79.7577654,
                    54.3685798
                ],
                [
                    79.7591469,
                    54.3691593
                ],
                [
                    79.7582075,
                    54.3711874
                ],
                [
                    79.7656679,
                    54.3729902
                ],
                [
                    79.7650047,
                    54.3743422
                ],
                [
                    79.7681547,
                    54.3751147
                ],
                [
                    79.7694257,
                    54.3733121
                ],
                [
                    79.7706968,
                    54.3736984
                ],
                [
                    79.7721336,
                    54.3717669
                ],
                [
                    79.7727415,
                    54.3717025
                ],
                [
                    79.7811414,
                    54.3746319
                ],
                [
                    79.7830203,
                    54.3728292
                ],
                [
                    79.7781572,
                    54.3710265
                ],
                [
                    79.7789862,
                    54.3703826
                ],
                [
                    79.7768862,
                    54.3696422
                ],
                [
                    79.7767895,
                    54.3690283
                ],
                [
                    79.7754494,
                    54.3688052
                ],
                [
                    79.7706968,
                    54.3667125
                ],
                [
                    79.7700889,
                    54.3669379
                ],
                [
                    79.768493,
                    54.3659664
                ],
                [
                    79.7679889,
                    54.36565
                ],
                [
                    79.7636232,
                    54.3641046
                ],
                [
                    79.7587048,
                    54.3626878
                ],
                [
                    79.758318,
                    54.3630098
                ],
                [
                    79.7544496,
                    54.3615609
                ],
                [
                    79.7551128,
                    54.3605627
                ],
                [
                    79.7540075,
                    54.3600796
                ],
                [
                    79.7524602,
                    54.3617219
                ],
                [
                    79.7512444,
                    54.3612711
                ],
                [
                    79.7487023,
                    54.3634606
                ]
            ],
            "longitude": 79.760963,
            "latitude": 54.36541
        },
        "9901": {
            "name": "Хабаровский",
            "population": 113,
            "type": "hamlet",
            "poly": [
                [
                    79.756706,
                    53.8452262
                ],
                [
                    79.7569545,
                    53.8458643
                ],
                [
                    79.7595114,
                    53.8460319
                ],
                [
                    79.7601195,
                    53.8461216
                ],
                [
                    79.7606204,
                    53.8455791
                ],
                [
                    79.7610765,
                    53.8454688
                ],
                [
                    79.7616596,
                    53.8454821
                ],
                [
                    79.7618614,
                    53.8456497
                ],
                [
                    79.7621381,
                    53.8459584
                ],
                [
                    79.7624969,
                    53.8462892
                ],
                [
                    79.7626315,
                    53.8466994
                ],
                [
                    79.7624446,
                    53.8470566
                ],
                [
                    79.7613082,
                    53.847136
                ],
                [
                    79.7603961,
                    53.84778
                ],
                [
                    79.7594691,
                    53.8483665
                ],
                [
                    79.7602765,
                    53.8488208
                ],
                [
                    79.7649416,
                    53.8487414
                ],
                [
                    79.7661708,
                    53.8477932
                ],
                [
                    79.7663353,
                    53.8471934
                ],
                [
                    79.7717929,
                    53.8479961
                ],
                [
                    79.7734975,
                    53.8475903
                ],
                [
                    79.7741853,
                    53.8462848
                ],
                [
                    79.7728994,
                    53.845191
                ],
                [
                    79.7700136,
                    53.8442559
                ],
                [
                    79.7674418,
                    53.8443882
                ],
                [
                    79.7615954,
                    53.8429944
                ],
                [
                    79.7583657,
                    53.843012
                ],
                [
                    79.7567882,
                    53.843559
                ],
                [
                    79.756706,
                    53.8452262
                ]
            ],
            "longitude": 79.764671,
            "latitude": 53.846436
        },
        "9902": {
            "name": "Баган",
            "population": 260,
            "type": "hamlet",
            "poly": [
                [
                    79.7618789,
                    54.508113
                ],
                [
                    79.7632836,
                    54.5090108
                ],
                [
                    79.7637203,
                    54.50984
                ],
                [
                    79.7626071,
                    54.5156795
                ],
                [
                    79.7633323,
                    54.5164654
                ],
                [
                    79.7678348,
                    54.518058
                ],
                [
                    79.7814518,
                    54.5174078
                ],
                [
                    79.7874717,
                    54.5169111
                ],
                [
                    79.7879882,
                    54.516697
                ],
                [
                    79.7910129,
                    54.5158662
                ],
                [
                    79.789744,
                    54.5156778
                ],
                [
                    79.7861733,
                    54.5156606
                ],
                [
                    79.786793,
                    54.5145215
                ],
                [
                    79.7844027,
                    54.5143844
                ],
                [
                    79.7801976,
                    54.5136221
                ],
                [
                    79.7812009,
                    54.5122174
                ],
                [
                    79.7791353,
                    54.5116863
                ],
                [
                    79.7817616,
                    54.5092193
                ],
                [
                    79.7787516,
                    54.50802
                ],
                [
                    79.7862323,
                    54.5021944
                ],
                [
                    79.7855094,
                    54.5017831
                ],
                [
                    79.7832076,
                    54.5015861
                ],
                [
                    79.7770106,
                    54.5001038
                ],
                [
                    79.7689376,
                    54.5043916
                ],
                [
                    79.7664234,
                    54.507551
                ],
                [
                    79.7635669,
                    54.5066807
                ],
                [
                    79.7618789,
                    54.508113
                ]
            ],
            "longitude": 79.7743,
            "latitude": 54.511185
        },
        "9903": {
            "name": "Крещенский",
            "population": 67,
            "type": "hamlet",
            "poly": [
                [
                    79.7580732,
                    55.3984387
                ],
                [
                    79.7585711,
                    55.3995205
                ],
                [
                    79.7642642,
                    55.4018805
                ],
                [
                    79.7728366,
                    55.4042528
                ],
                [
                    79.7804564,
                    55.406207
                ],
                [
                    79.7838983,
                    55.40676
                ],
                [
                    79.7854353,
                    55.4064405
                ],
                [
                    79.7860198,
                    55.4053835
                ],
                [
                    79.7855651,
                    55.404769
                ],
                [
                    79.7810626,
                    55.4035276
                ],
                [
                    79.7795473,
                    55.4034907
                ],
                [
                    79.775023,
                    55.4021755
                ],
                [
                    79.7648704,
                    55.3981314
                ],
                [
                    79.7591556,
                    55.3977749
                ],
                [
                    79.7580732,
                    55.3984387
                ]
            ],
            "longitude": 79.778122,
            "latitude": 55.404881
        },
        "9904": {
            "name": "Московка",
            "population": 97,
            "type": "hamlet",
            "poly": [
                [
                    79.7902447,
                    55.2525709
                ],
                [
                    79.7918616,
                    55.2541633
                ],
                [
                    79.7921463,
                    55.2544436
                ],
                [
                    79.7934341,
                    55.2546768
                ],
                [
                    79.7942405,
                    55.2546082
                ],
                [
                    79.7943729,
                    55.2543544
                ],
                [
                    79.7967439,
                    55.2545396
                ],
                [
                    79.797779,
                    55.2535518
                ],
                [
                    79.7972494,
                    55.2533941
                ],
                [
                    79.7975864,
                    55.2520358
                ],
                [
                    79.7981039,
                    55.2514939
                ],
                [
                    79.7977068,
                    55.250554
                ],
                [
                    79.7963708,
                    55.2503963
                ],
                [
                    79.7958412,
                    55.249868
                ],
                [
                    79.7960578,
                    55.2494495
                ],
                [
                    79.797779,
                    55.249278
                ],
                [
                    79.798453,
                    55.2490242
                ],
                [
                    79.7988501,
                    55.2469592
                ],
                [
                    79.7986215,
                    55.246767
                ],
                [
                    79.798513,
                    55.2462525
                ],
                [
                    79.7988261,
                    55.2454909
                ],
                [
                    79.7996204,
                    55.2425955
                ],
                [
                    79.797803,
                    55.2423622
                ],
                [
                    79.7966597,
                    55.242417
                ],
                [
                    79.7959857,
                    55.2436315
                ],
                [
                    79.7937952,
                    55.2434806
                ],
                [
                    79.7930369,
                    55.244647
                ],
                [
                    79.792736,
                    55.2455115
                ],
                [
                    79.7928924,
                    55.2464995
                ],
                [
                    79.792375,
                    55.2471307
                ],
                [
                    79.792736,
                    55.2482078
                ],
                [
                    79.7926879,
                    55.2487635
                ],
                [
                    79.7922065,
                    55.2489556
                ],
                [
                    79.7924515,
                    55.249739
                ],
                [
                    79.7924833,
                    55.2498406
                ],
                [
                    79.7914001,
                    55.2506981
                ],
                [
                    79.7902447,
                    55.2525709
                ]
            ],
            "longitude": 79.794975,
            "latitude": 55.247791
        },
        "9905": {
            "name": "Ачеканка",
            "population": 40,
            "type": "hamlet",
            "poly": [
                [
                    79.7843736,
                    55.5186953
                ],
                [
                    79.7886757,
                    55.5193787
                ],
                [
                    79.7892947,
                    55.5206752
                ],
                [
                    79.790347,
                    55.5211833
                ],
                [
                    79.7948347,
                    55.5210081
                ],
                [
                    79.7991368,
                    55.5202723
                ],
                [
                    79.7987963,
                    55.5188705
                ],
                [
                    79.7966917,
                    55.5180996
                ],
                [
                    79.7944633,
                    55.5174512
                ],
                [
                    79.791554,
                    55.5173811
                ],
                [
                    79.7879019,
                    55.517679
                ],
                [
                    79.7845726,
                    55.5171189
                ],
                [
                    79.7843736,
                    55.5186953
                ]
            ],
            "longitude": 79.795174,
            "latitude": 55.519703
        },
        "9906": {
            "name": "Херсонка",
            "population": 114,
            "type": "hamlet",
            "poly": [
                [
                    79.7887697,
                    55.0521699
                ],
                [
                    79.7889499,
                    55.0535561
                ],
                [
                    79.7976769,
                    55.0562545
                ],
                [
                    79.7990928,
                    55.0570655
                ],
                [
                    79.8076653,
                    55.0587611
                ],
                [
                    79.8096475,
                    55.0569918
                ],
                [
                    79.7977541,
                    55.0525238
                ],
                [
                    79.7892331,
                    55.0510492
                ],
                [
                    79.7887697,
                    55.0521699
                ]
            ],
            "longitude": 79.799683,
            "latitude": 55.055027
        },
        "9907": {
            "name": "Целинный",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    79.8157946,
                    54.1776499
                ],
                [
                    79.8178918,
                    54.1797438
                ],
                [
                    79.8237462,
                    54.1804508
                ],
                [
                    79.8255334,
                    54.1777145
                ],
                [
                    79.828959,
                    54.1777145
                ],
                [
                    79.8287306,
                    54.176066
                ],
                [
                    79.8225693,
                    54.176585
                ],
                [
                    79.8172352,
                    54.1751689
                ],
                [
                    79.8165998,
                    54.1755554
                ],
                [
                    79.8157946,
                    54.1776499
                ]
            ],
            "longitude": 79.821953,
            "latitude": 54.178032
        },
        "9908": {
            "name": "Заречноубинская",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    79.8833964,
                    55.5275994
                ],
                [
                    79.885402,
                    55.5297996
                ],
                [
                    79.8892398,
                    55.5333309
                ],
                [
                    79.8895617,
                    55.5339334
                ],
                [
                    79.8928547,
                    55.5349703
                ],
                [
                    79.8958011,
                    55.5326723
                ],
                [
                    79.8981286,
                    55.5342276
                ],
                [
                    79.9003323,
                    55.5327704
                ],
                [
                    79.900877,
                    55.5318876
                ],
                [
                    79.8962469,
                    55.5294492
                ],
                [
                    79.8866895,
                    55.5264782
                ],
                [
                    79.884882,
                    55.5265763
                ],
                [
                    79.8833964,
                    55.5275994
                ]
            ],
            "longitude": 79.89006,
            "latitude": 55.529381
        },
        "9909": {
            "name": "Солонцовый",
            "population": 176,
            "type": "hamlet",
            "poly": [
                [
                    79.897661,
                    54.8078695
                ],
                [
                    79.8986101,
                    54.8085828
                ],
                [
                    79.8990403,
                    54.809149
                ],
                [
                    79.9001283,
                    54.8096976
                ],
                [
                    79.9002457,
                    54.8100362
                ],
                [
                    79.9031438,
                    54.811142
                ],
                [
                    79.9052492,
                    54.811593
                ],
                [
                    79.9058349,
                    54.809361
                ],
                [
                    79.9065652,
                    54.8065862
                ],
                [
                    79.9057676,
                    54.8059962
                ],
                [
                    79.9040941,
                    54.8062436
                ],
                [
                    79.9017197,
                    54.8058995
                ],
                [
                    79.9005591,
                    54.8058382
                ],
                [
                    79.897661,
                    54.8078695
                ]
            ],
            "longitude": 79.902443,
            "latitude": 54.808773
        },
        "9910": {
            "name": "Иванкино",
            "population": 154,
            "type": "hamlet",
            "poly": [
                [
                    79.9000855,
                    54.8867473
                ],
                [
                    79.9016806,
                    54.8901625
                ],
                [
                    79.9123152,
                    54.8913348
                ],
                [
                    79.9186959,
                    54.8930167
                ],
                [
                    79.9219749,
                    54.8930677
                ],
                [
                    79.9225953,
                    54.890927
                ],
                [
                    79.9290646,
                    54.8915896
                ],
                [
                    79.9295077,
                    54.8889392
                ],
                [
                    79.9219749,
                    54.8875629
                ],
                [
                    79.9211773,
                    54.8876139
                ],
                [
                    79.9210001,
                    54.8889901
                ],
                [
                    79.9178983,
                    54.8886843
                ],
                [
                    79.9186959,
                    54.8852181
                ],
                [
                    79.9133787,
                    54.8844534
                ],
                [
                    79.9129355,
                    54.887308
                ],
                [
                    79.902301,
                    54.8860847
                ],
                [
                    79.9000855,
                    54.8867473
                ]
            ],
            "longitude": 79.915459,
            "latitude": 54.890182
        },
        "9911": {
            "name": "Сарыбалык",
            "population": 257,
            "type": "hamlet",
            "poly": [
                [
                    79.9403918,
                    54.7469015
                ],
                [
                    79.9420758,
                    54.7484611
                ],
                [
                    79.9425849,
                    54.7482577
                ],
                [
                    79.9452087,
                    54.7497947
                ],
                [
                    79.952297,
                    54.7527329
                ],
                [
                    79.952767,
                    54.7524842
                ],
                [
                    79.9644764,
                    54.7573883
                ],
                [
                    79.9667087,
                    54.755829
                ],
                [
                    79.9652989,
                    54.7550607
                ],
                [
                    79.9645548,
                    54.7553996
                ],
                [
                    79.9594245,
                    54.7529589
                ],
                [
                    79.9594245,
                    54.7525972
                ],
                [
                    79.9610302,
                    54.7518966
                ],
                [
                    79.9611085,
                    54.751535
                ],
                [
                    79.9582497,
                    54.7502015
                ],
                [
                    79.9572706,
                    54.7502015
                ],
                [
                    79.9575839,
                    54.749546
                ],
                [
                    79.9528453,
                    54.7472631
                ],
                [
                    79.9531978,
                    54.7470145
                ],
                [
                    79.9507306,
                    54.7460651
                ],
                [
                    79.9495165,
                    54.7471953
                ],
                [
                    79.9484983,
                    54.7469693
                ],
                [
                    79.9479892,
                    54.746472
                ],
                [
                    79.9461094,
                    54.7466302
                ],
                [
                    79.9445821,
                    54.7457939
                ],
                [
                    79.9431723,
                    54.7468336
                ],
                [
                    79.9424282,
                    54.7463364
                ],
                [
                    79.9432898,
                    54.7455678
                ],
                [
                    79.942389,
                    54.7450027
                ],
                [
                    79.9403918,
                    54.7469015
                ]
            ],
            "longitude": 79.952744,
            "latitude": 54.750668
        },
        "9912": {
            "name": "Филино",
            "population": 163,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.954002,
            "latitude": 55.285664
        },
        "9913": {
            "name": "Рождественский",
            "population": 62,
            "type": "hamlet",
            "poly": [
                [
                    79.974406,
                    54.0213467
                ],
                [
                    79.9836765,
                    54.0238697
                ],
                [
                    79.9960895,
                    54.0242082
                ],
                [
                    79.9968228,
                    54.0215928
                ],
                [
                    79.9753488,
                    54.0178695
                ],
                [
                    79.974406,
                    54.0213467
                ]
            ],
            "longitude": 79.985756,
            "latitude": 54.021843
        },
        "9914": {
            "name": "Старомихайловский",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.996246,
            "latitude": 55.098671
        },
        "9915": {
            "name": "Беркуты",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.99929,
            "latitude": 55.182129
        },
        "9916": {
            "name": "Груздевка",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.006363,
            "latitude": 55.254131
        },
        "9917": {
            "name": "Безногое",
            "population": 45,
            "type": "hamlet",
            "poly": [
                [
                    80.0311855,
                    54.4080421
                ],
                [
                    80.035531,
                    54.4077354
                ],
                [
                    80.0370672,
                    54.4083839
                ],
                [
                    80.0459077,
                    54.4077857
                ],
                [
                    80.0467245,
                    54.4068315
                ],
                [
                    80.0505874,
                    54.4056895
                ],
                [
                    80.0508327,
                    54.4050827
                ],
                [
                    80.0504456,
                    54.4045378
                ],
                [
                    80.0475216,
                    54.404369
                ],
                [
                    80.0470617,
                    54.4042976
                ],
                [
                    80.0464486,
                    54.4051363
                ],
                [
                    80.0445478,
                    54.4056359
                ],
                [
                    80.0440266,
                    54.4051006
                ],
                [
                    80.0451916,
                    54.402638
                ],
                [
                    80.0437813,
                    54.4021026
                ],
                [
                    80.0405929,
                    54.4018171
                ],
                [
                    80.042463,
                    54.40055
                ],
                [
                    80.0430762,
                    54.3998183
                ],
                [
                    80.0421564,
                    54.3973196
                ],
                [
                    80.0403783,
                    54.3965522
                ],
                [
                    80.0376497,
                    54.396802
                ],
                [
                    80.0349895,
                    54.3994949
                ],
                [
                    80.0311855,
                    54.4080421
                ]
            ],
            "longitude": 80.039284,
            "latitude": 54.404057
        },
        "9918": {
            "name": "Казарма 3144 км",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.050713,
            "latitude": 55.243355
        },
        "9919": {
            "name": "Земировский",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.066071,
            "latitude": 53.997253
        },
        "9920": {
            "name": "Безлюдный",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.0662008,
            "latitude": 55.2293953
        },
        "9921": {
            "name": "Лисьи Норки",
            "population": 20,
            "type": "hamlet",
            "poly": [
                [
                    80.0820052,
                    55.8682261
                ],
                [
                    80.0834533,
                    55.8715329
                ],
                [
                    80.0841138,
                    55.873229
                ],
                [
                    80.085638,
                    55.8742694
                ],
                [
                    80.088026,
                    55.8750105
                ],
                [
                    80.0900583,
                    55.8749962
                ],
                [
                    80.0907696,
                    55.8739843
                ],
                [
                    80.0902869,
                    55.8717467
                ],
                [
                    80.0890675,
                    55.8702216
                ],
                [
                    80.0912777,
                    55.8693664
                ],
                [
                    80.0918874,
                    55.8680265
                ],
                [
                    80.0899313,
                    55.86777
                ],
                [
                    80.0820561,
                    55.8668577
                ],
                [
                    80.0820052,
                    55.8682261
                ]
            ],
            "longitude": 80.08741,
            "latitude": 55.871311
        },
        "9922": {
            "name": "Даниловская Ферма",
            "population": 225,
            "type": "hamlet",
            "poly": [
                [
                    80.1067313,
                    54.7182001
                ],
                [
                    80.1112519,
                    54.7179825
                ],
                [
                    80.1113651,
                    54.7177432
                ],
                [
                    80.1122314,
                    54.7177214
                ],
                [
                    80.1122314,
                    54.7180261
                ],
                [
                    80.112759,
                    54.7180478
                ],
                [
                    80.1129473,
                    54.7185483
                ],
                [
                    80.1123822,
                    54.719571
                ],
                [
                    80.1147179,
                    54.720202
                ],
                [
                    80.1155844,
                    54.7201367
                ],
                [
                    80.1158858,
                    54.719571
                ],
                [
                    80.117242,
                    54.7198974
                ],
                [
                    80.1161872,
                    54.7207459
                ],
                [
                    80.1167146,
                    54.7212246
                ],
                [
                    80.1202182,
                    54.7207459
                ],
                [
                    80.1204819,
                    54.7201367
                ],
                [
                    80.1202182,
                    54.7194622
                ],
                [
                    80.121612,
                    54.7190705
                ],
                [
                    80.1216497,
                    54.718483
                ],
                [
                    80.1234203,
                    54.7178302
                ],
                [
                    80.1267356,
                    54.7178085
                ],
                [
                    80.1285062,
                    54.717308
                ],
                [
                    80.1337427,
                    54.7173733
                ],
                [
                    80.1326878,
                    54.7164158
                ],
                [
                    80.1311809,
                    54.7158283
                ],
                [
                    80.1300884,
                    54.7167857
                ],
                [
                    80.1261327,
                    54.7156324
                ],
                [
                    80.1249649,
                    54.7172427
                ],
                [
                    80.1242115,
                    54.7154366
                ],
                [
                    80.1214236,
                    54.7150884
                ],
                [
                    80.1220641,
                    54.7164593
                ],
                [
                    80.1205949,
                    54.7163505
                ],
                [
                    80.1206325,
                    54.7156977
                ],
                [
                    80.1182592,
                    54.7156106
                ],
                [
                    80.1178448,
                    54.7148708
                ],
                [
                    80.1166016,
                    54.7149578
                ],
                [
                    80.1160365,
                    54.7152407
                ],
                [
                    80.1158104,
                    54.7158718
                ],
                [
                    80.114944,
                    54.714305
                ],
                [
                    80.1133617,
                    54.7145008
                ],
                [
                    80.1117418,
                    54.7150449
                ],
                [
                    80.1108376,
                    54.7164811
                ],
                [
                    80.106882,
                    54.7162852
                ],
                [
                    80.1067313,
                    54.7182001
                ]
            ],
            "longitude": 80.117798,
            "latitude": 54.717278
        },
        "9923": {
            "name": "Лебедевский",
            "population": 52,
            "type": "hamlet",
            "poly": [
                [
                    80.14559,
                    55.2342729
                ],
                [
                    80.1457023,
                    55.2347212
                ],
                [
                    80.1466757,
                    55.2347959
                ],
                [
                    80.1474619,
                    55.2341982
                ],
                [
                    80.1485102,
                    55.2346571
                ],
                [
                    80.1508688,
                    55.2342195
                ],
                [
                    80.1509997,
                    55.2333656
                ],
                [
                    80.1514865,
                    55.2331628
                ],
                [
                    80.1524787,
                    55.2329386
                ],
                [
                    80.1536392,
                    55.2330987
                ],
                [
                    80.1541072,
                    55.233056
                ],
                [
                    80.1543693,
                    55.2319672
                ],
                [
                    80.1543506,
                    55.2314441
                ],
                [
                    80.1540885,
                    55.2311986
                ],
                [
                    80.1584314,
                    55.2311773
                ],
                [
                    80.1589929,
                    55.231284
                ],
                [
                    80.1600787,
                    55.2321166
                ],
                [
                    80.1608461,
                    55.232074
                ],
                [
                    80.1604718,
                    55.2316363
                ],
                [
                    80.1605092,
                    55.2313801
                ],
                [
                    80.161389,
                    55.2313267
                ],
                [
                    80.1628161,
                    55.2270578
                ],
                [
                    80.1636103,
                    55.2260311
                ],
                [
                    80.1633456,
                    55.2254272
                ],
                [
                    80.1574686,
                    55.22434
                ],
                [
                    80.1565155,
                    55.2244608
                ],
                [
                    80.1561851,
                    55.224697
                ],
                [
                    80.1533959,
                    55.2270885
                ],
                [
                    80.1530589,
                    55.2270031
                ],
                [
                    80.1515426,
                    55.2280387
                ],
                [
                    80.150925,
                    55.2278145
                ],
                [
                    80.15012,
                    55.2284017
                ],
                [
                    80.150457,
                    55.2285298
                ],
                [
                    80.1500451,
                    55.2289034
                ],
                [
                    80.1495209,
                    55.2297575
                ],
                [
                    80.1483604,
                    55.23122
                ],
                [
                    80.1475181,
                    55.2314868
                ],
                [
                    80.1469565,
                    55.2317537
                ],
                [
                    80.1463574,
                    55.232202
                ],
                [
                    80.145721,
                    55.2336431
                ],
                [
                    80.14559,
                    55.2342729
                ]
            ],
            "longitude": 80.150917,
            "latitude": 55.230385
        },
        "9924": {
            "name": "Барановский",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    80.1662054,
                    54.9309994
                ],
                [
                    80.1710095,
                    54.9315805
                ],
                [
                    80.1799854,
                    54.9315805
                ],
                [
                    80.1812496,
                    54.9280212
                ],
                [
                    80.1815024,
                    54.925406
                ],
                [
                    80.1803647,
                    54.925188
                ],
                [
                    80.1778362,
                    54.9256966
                ],
                [
                    80.1712623,
                    54.9262777
                ],
                [
                    80.171515,
                    54.9286023
                ],
                [
                    80.1670904,
                    54.9279485
                ],
                [
                    80.1662054,
                    54.9309994
                ]
            ],
            "longitude": 80.175125,
            "latitude": 54.928192
        },
        "9925": {
            "name": "Первомайский",
            "population": 28,
            "type": "hamlet",
            "poly": [
                [
                    80.1728339,
                    55.0424766
                ],
                [
                    80.1729437,
                    55.0437353
                ],
                [
                    80.1754701,
                    55.0436094
                ],
                [
                    80.1756898,
                    55.0447422
                ],
                [
                    80.1777219,
                    55.0447107
                ],
                [
                    80.1779416,
                    55.0460323
                ],
                [
                    80.1788203,
                    55.0459064
                ],
                [
                    80.1786006,
                    55.0446478
                ],
                [
                    80.1801384,
                    55.0445219
                ],
                [
                    80.1803032,
                    55.0455918
                ],
                [
                    80.1823902,
                    55.0453715
                ],
                [
                    80.1825,
                    55.0464099
                ],
                [
                    80.1860699,
                    55.0460638
                ],
                [
                    80.1860699,
                    55.0453401
                ],
                [
                    80.1868937,
                    55.0452457
                ],
                [
                    80.1867839,
                    55.0437982
                ],
                [
                    80.192276,
                    55.043043
                ],
                [
                    80.1921662,
                    55.042036
                ],
                [
                    80.1902987,
                    55.0421619
                ],
                [
                    80.1898044,
                    55.0411863
                ],
                [
                    80.1887061,
                    55.0414696
                ],
                [
                    80.1887061,
                    55.0422563
                ],
                [
                    80.1878823,
                    55.0422877
                ],
                [
                    80.1874979,
                    55.0410919
                ],
                [
                    80.1850264,
                    55.0409661
                ],
                [
                    80.1844772,
                    55.041029
                ],
                [
                    80.1844223,
                    55.042036
                ],
                [
                    80.181731,
                    55.0423821
                ],
                [
                    80.1813467,
                    55.0417528
                ],
                [
                    80.178326,
                    55.0419101
                ],
                [
                    80.1782711,
                    55.0426339
                ],
                [
                    80.1773374,
                    55.0426339
                ],
                [
                    80.1771178,
                    55.0421619
                ],
                [
                    80.1756898,
                    55.0423192
                ],
                [
                    80.1756349,
                    55.0431688
                ],
                [
                    80.174152,
                    55.0432632
                ],
                [
                    80.1739872,
                    55.0424766
                ],
                [
                    80.1728339,
                    55.0424766
                ]
            ],
            "longitude": 80.184593,
            "latitude": 55.042706
        },
        "9926": {
            "name": "Николаевский",
            "population": 51,
            "type": "hamlet",
            "poly": [
                [
                    80.2054258,
                    54.1268378
                ],
                [
                    80.2075602,
                    54.1279842
                ],
                [
                    80.2093529,
                    54.1294308
                ],
                [
                    80.2125857,
                    54.1308256
                ],
                [
                    80.214496,
                    54.1320999
                ],
                [
                    80.2193953,
                    54.1341028
                ],
                [
                    80.2205208,
                    54.1314972
                ],
                [
                    80.2204914,
                    54.1304984
                ],
                [
                    80.2186987,
                    54.1297924
                ],
                [
                    80.2131735,
                    54.1283975
                ],
                [
                    80.2148781,
                    54.1275536
                ],
                [
                    80.2142021,
                    54.1268992
                ],
                [
                    80.2107317,
                    54.1253653
                ],
                [
                    80.2124094,
                    54.1239542
                ],
                [
                    80.2106339,
                    54.1231572
                ],
                [
                    80.2078541,
                    54.1249187
                ],
                [
                    80.2058262,
                    54.1258659
                ],
                [
                    80.2054258,
                    54.1268378
                ]
            ],
            "longitude": 80.211914,
            "latitude": 54.129246
        },
        "9927": {
            "name": "Усть-Сумы",
            "population": 80,
            "type": "hamlet",
            "poly": [
                [
                    80.2354622,
                    54.8479293
                ],
                [
                    80.24082,
                    54.8509311
                ],
                [
                    80.2442344,
                    54.8492632
                ],
                [
                    80.2449806,
                    54.8514114
                ],
                [
                    80.2499411,
                    54.853888
                ],
                [
                    80.2536286,
                    54.8543176
                ],
                [
                    80.2542937,
                    54.8539283
                ],
                [
                    80.2542432,
                    54.8519927
                ],
                [
                    80.2531896,
                    54.8502742
                ],
                [
                    80.2541114,
                    54.8484292
                ],
                [
                    80.2558235,
                    54.8451434
                ],
                [
                    80.249937,
                    54.8403063
                ],
                [
                    80.2478722,
                    54.8386975
                ],
                [
                    80.2466206,
                    54.8395317
                ],
                [
                    80.2474073,
                    54.8402112
                ],
                [
                    80.2431931,
                    54.8422335
                ],
                [
                    80.2408893,
                    54.8437866
                ],
                [
                    80.2383327,
                    54.842913
                ],
                [
                    80.2372649,
                    54.8443528
                ],
                [
                    80.2375741,
                    54.8448381
                ],
                [
                    80.2395969,
                    54.8457116
                ],
                [
                    80.237855,
                    54.8457602
                ],
                [
                    80.2374336,
                    54.8461808
                ],
                [
                    80.2384169,
                    54.8465852
                ],
                [
                    80.2354622,
                    54.8479293
                ]
            ],
            "longitude": 80.251602,
            "latitude": 54.847485
        },
        "9928": {
            "name": "Москвинка",
            "population": 98,
            "type": "hamlet",
            "poly": [
                [
                    80.2449608,
                    54.7344141
                ],
                [
                    80.2464829,
                    54.7347962
                ],
                [
                    80.246152,
                    54.7352929
                ],
                [
                    80.2533655,
                    54.7383877
                ],
                [
                    80.2532993,
                    54.7406035
                ],
                [
                    80.2539611,
                    54.7393428
                ],
                [
                    80.2566083,
                    54.7398776
                ],
                [
                    80.2556156,
                    54.7417114
                ],
                [
                    80.2548214,
                    54.7419788
                ],
                [
                    80.25502,
                    54.7425137
                ],
                [
                    80.2583951,
                    54.7429339
                ],
                [
                    80.260976,
                    54.7407563
                ],
                [
                    80.2630937,
                    54.741444
                ],
                [
                    80.2636894,
                    54.7394956
                ],
                [
                    80.2640865,
                    54.7354839
                ],
                [
                    80.2602481,
                    54.7337645
                ],
                [
                    80.2607114,
                    54.733306
                ],
                [
                    80.2582627,
                    54.7325035
                ],
                [
                    80.2567406,
                    54.7335735
                ],
                [
                    80.2529023,
                    54.7327328
                ],
                [
                    80.2526376,
                    54.7331531
                ],
                [
                    80.2515787,
                    54.7334588
                ],
                [
                    80.2506522,
                    54.7333442
                ],
                [
                    80.248733,
                    54.7335352
                ],
                [
                    80.2464829,
                    54.7329239
                ],
                [
                    80.2453579,
                    54.7332678
                ],
                [
                    80.2449608,
                    54.7344141
                ]
            ],
            "longitude": 80.257523,
            "latitude": 54.737225
        },
        "9929": {
            "name": "Чернявский",
            "population": 93,
            "type": "hamlet",
            "poly": [
                [
                    80.2545354,
                    55.0352476
                ],
                [
                    80.2547823,
                    55.0368275
                ],
                [
                    80.2549468,
                    55.0404114
                ],
                [
                    80.2545765,
                    55.0419204
                ],
                [
                    80.2563459,
                    55.0420147
                ],
                [
                    80.2573335,
                    55.0436415
                ],
                [
                    80.2599258,
                    55.043335
                ],
                [
                    80.2597612,
                    55.0430285
                ],
                [
                    80.2588971,
                    55.0424627
                ],
                [
                    80.258033,
                    55.0425098
                ],
                [
                    80.2579095,
                    55.0419675
                ],
                [
                    80.2584856,
                    55.0416846
                ],
                [
                    80.2589794,
                    55.0395862
                ],
                [
                    80.2585268,
                    55.0383837
                ],
                [
                    80.2568397,
                    55.038478
                ],
                [
                    80.2567574,
                    55.0374877
                ],
                [
                    80.256963,
                    55.0367567
                ],
                [
                    80.2577449,
                    55.0368746
                ],
                [
                    80.2598023,
                    55.0337148
                ],
                [
                    80.2606253,
                    55.0313094
                ],
                [
                    80.2614483,
                    55.0306726
                ],
                [
                    80.262765,
                    55.0286444
                ],
                [
                    80.2614071,
                    55.0282199
                ],
                [
                    80.2616952,
                    55.0277482
                ],
                [
                    80.2621066,
                    55.0278189
                ],
                [
                    80.2622712,
                    55.0274651
                ],
                [
                    80.2614071,
                    55.0273708
                ],
                [
                    80.2611191,
                    55.027701
                ],
                [
                    80.2592263,
                    55.0272529
                ],
                [
                    80.2588148,
                    55.0275831
                ],
                [
                    80.2582799,
                    55.0275359
                ],
                [
                    80.258033,
                    55.0280312
                ],
                [
                    80.2585679,
                    55.0281491
                ],
                [
                    80.2568808,
                    55.0298708
                ],
                [
                    80.2582799,
                    55.0302717
                ],
                [
                    80.2579918,
                    55.0308141
                ],
                [
                    80.2567574,
                    55.0305547
                ],
                [
                    80.2561813,
                    55.0309321
                ],
                [
                    80.2558521,
                    55.0317575
                ],
                [
                    80.2560167,
                    55.0326772
                ],
                [
                    80.2550703,
                    55.0327243
                ],
                [
                    80.2551115,
                    55.0335733
                ],
                [
                    80.2546588,
                    55.0340214
                ],
                [
                    80.2545354,
                    55.0352476
                ]
            ],
            "longitude": 80.257607,
            "latitude": 55.033329
        },
        "9930": {
            "name": "Москвинский",
            "population": 99,
            "type": "hamlet",
            "poly": [
                [
                    80.2931287,
                    54.6996951
                ],
                [
                    80.2933273,
                    54.7009188
                ],
                [
                    80.2939813,
                    54.7014182
                ],
                [
                    80.2951803,
                    54.7023337
                ],
                [
                    80.293989,
                    54.7037486
                ],
                [
                    80.3059011,
                    54.7065016
                ],
                [
                    80.3084159,
                    54.7069222
                ],
                [
                    80.3096072,
                    54.7054692
                ],
                [
                    80.2990848,
                    54.7003452
                ],
                [
                    80.2931287,
                    54.6996951
                ]
            ],
            "longitude": 80.301247,
            "latitude": 54.702415
        },
        "9931": {
            "name": "Третьяковский",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.312057,
            "latitude": 55.427532
        },
        "9932": {
            "name": "Шибаки",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.345703,
            "latitude": 55.321091
        },
        "9933": {
            "name": "Советский",
            "population": 116,
            "type": "hamlet",
            "poly": [
                [
                    80.3908862,
                    54.2049621
                ],
                [
                    80.396964,
                    54.2062344
                ],
                [
                    80.4014423,
                    54.1968788
                ],
                [
                    80.3942129,
                    54.1961677
                ],
                [
                    80.3908862,
                    54.2049621
                ]
            ],
            "longitude": 80.395729,
            "latitude": 54.201122
        },
        "9934": {
            "name": "Голубовский",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.4078424,
            "latitude": 54.9922637
        },
        "9935": {
            "name": "Маяк",
            "population": 56,
            "type": "hamlet",
            "poly": [
                [
                    80.4011661,
                    54.4316771
                ],
                [
                    80.4018868,
                    54.4326414
                ],
                [
                    80.4026318,
                    54.4358136
                ],
                [
                    80.4033766,
                    54.4375883
                ],
                [
                    80.4034967,
                    54.4386782
                ],
                [
                    80.4023914,
                    54.4401873
                ],
                [
                    80.4023434,
                    54.4421853
                ],
                [
                    80.403809,
                    54.4430935
                ],
                [
                    80.4054188,
                    54.4436663
                ],
                [
                    80.407389,
                    54.4451333
                ],
                [
                    80.4109689,
                    54.4451193
                ],
                [
                    80.4129871,
                    54.4451892
                ],
                [
                    80.4142605,
                    54.4450495
                ],
                [
                    80.4153658,
                    54.4442671
                ],
                [
                    80.4158703,
                    54.4441693
                ],
                [
                    80.4203873,
                    54.4378259
                ],
                [
                    80.419186,
                    54.4375045
                ],
                [
                    80.4169275,
                    54.4378398
                ],
                [
                    80.4166632,
                    54.4373508
                ],
                [
                    80.4171676,
                    54.4367639
                ],
                [
                    80.4169996,
                    54.4364704
                ],
                [
                    80.4175281,
                    54.435604
                ],
                [
                    80.4150774,
                    54.4349892
                ],
                [
                    80.4139242,
                    54.4362608
                ],
                [
                    80.4105605,
                    54.4349053
                ],
                [
                    80.4086624,
                    54.4343184
                ],
                [
                    80.4062357,
                    54.4337594
                ],
                [
                    80.4036649,
                    54.4329768
                ],
                [
                    80.4011661,
                    54.4316771
                ]
            ],
            "longitude": 80.411316,
            "latitude": 54.439945
        },
        "9936": {
            "name": "Теренино",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.41655,
            "latitude": 55.342621
        },
        "9937": {
            "name": "Сапожковский",
            "population": 87,
            "type": "hamlet",
            "poly": [
                [
                    80.4231816,
                    54.5272829
                ],
                [
                    80.4255754,
                    54.5303965
                ],
                [
                    80.4278868,
                    54.5309712
                ],
                [
                    80.4284646,
                    54.531546
                ],
                [
                    80.4330046,
                    54.5337493
                ],
                [
                    80.4356461,
                    54.5325519
                ],
                [
                    80.4322617,
                    54.530157
                ],
                [
                    80.4320141,
                    54.5293427
                ],
                [
                    80.4339126,
                    54.5294385
                ],
                [
                    80.4330872,
                    54.5237858
                ],
                [
                    80.4325919,
                    54.5237379
                ],
                [
                    80.4312712,
                    54.5252709
                ],
                [
                    80.4296202,
                    54.5251272
                ],
                [
                    80.429125,
                    54.5228277
                ],
                [
                    80.430941,
                    54.5220132
                ],
                [
                    80.42929,
                    54.5195698
                ],
                [
                    80.4254929,
                    54.5202406
                ],
                [
                    80.4245024,
                    54.5210551
                ],
                [
                    80.4253278,
                    54.5217737
                ],
                [
                    80.4238419,
                    54.5220612
                ],
                [
                    80.4239245,
                    54.522684
                ],
                [
                    80.4258231,
                    54.5249356
                ],
                [
                    80.42475,
                    54.5250793
                ],
                [
                    80.4231816,
                    54.5272829
                ]
            ],
            "longitude": 80.426682,
            "latitude": 54.529354
        },
        "9938": {
            "name": "Петроградский",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    80.425136,
                    55.0639633
                ],
                [
                    80.4257912,
                    55.064005
                ],
                [
                    80.4285573,
                    55.0635048
                ],
                [
                    80.4289213,
                    55.0619623
                ],
                [
                    80.4306682,
                    55.0623375
                ],
                [
                    80.4309595,
                    55.0619623
                ],
                [
                    80.4302316,
                    55.0617956
                ],
                [
                    80.4305955,
                    55.0612536
                ],
                [
                    80.4315419,
                    55.0590857
                ],
                [
                    80.4344536,
                    55.0577933
                ],
                [
                    80.4378021,
                    55.0586271
                ],
                [
                    80.4411507,
                    55.0594193
                ],
                [
                    80.4420242,
                    55.0580434
                ],
                [
                    80.4405683,
                    55.0579184
                ],
                [
                    80.4412963,
                    55.0570011
                ],
                [
                    80.4381661,
                    55.0564174
                ],
                [
                    80.4378021,
                    55.0571679
                ],
                [
                    80.4357639,
                    55.0566676
                ],
                [
                    80.4364918,
                    55.0558754
                ],
                [
                    80.4358367,
                    55.0556669
                ],
                [
                    80.435036,
                    55.0563757
                ],
                [
                    80.4327066,
                    55.0559171
                ],
                [
                    80.434308,
                    55.0534153
                ],
                [
                    80.4315419,
                    55.0531234
                ],
                [
                    80.4308139,
                    55.0543326
                ],
                [
                    80.4312507,
                    55.0558754
                ],
                [
                    80.4289941,
                    55.0557086
                ],
                [
                    80.4274654,
                    55.0593359
                ],
                [
                    80.4252816,
                    55.0632547
                ],
                [
                    80.425136,
                    55.0639633
                ]
            ],
            "longitude": 80.431549,
            "latitude": 55.057476
        },
        "9939": {
            "name": "Кубанский",
            "population": 187,
            "type": "hamlet",
            "poly": [
                [
                    80.4239787,
                    55.1089195
                ],
                [
                    80.4244155,
                    55.1101687
                ],
                [
                    80.4265993,
                    55.1098356
                ],
                [
                    80.4269633,
                    55.1104185
                ],
                [
                    80.4359896,
                    55.1094192
                ],
                [
                    80.4388287,
                    55.1091693
                ],
                [
                    80.4439971,
                    55.1085447
                ],
                [
                    80.4441426,
                    55.1097106
                ],
                [
                    80.4461081,
                    55.1101687
                ],
                [
                    80.4560081,
                    55.1100021
                ],
                [
                    80.4561535,
                    55.1090861
                ],
                [
                    80.4503301,
                    55.1069624
                ],
                [
                    80.4483647,
                    55.1070873
                ],
                [
                    80.4478551,
                    55.1077536
                ],
                [
                    80.4453801,
                    55.1063794
                ],
                [
                    80.441886,
                    55.106546
                ],
                [
                    80.4385375,
                    55.1067958
                ],
                [
                    80.4356258,
                    55.1074205
                ],
                [
                    80.4331508,
                    55.1067958
                ],
                [
                    80.4319133,
                    55.1073788
                ],
                [
                    80.4322044,
                    55.1085864
                ],
                [
                    80.4290743,
                    55.1082116
                ],
                [
                    80.4239787,
                    55.1089195
                ]
            ],
            "longitude": 80.443336,
            "latitude": 55.107586
        },
        "9940": {
            "name": "Блокпост Капралово",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.452049,
            "latitude": 55.16489
        },
        "9941": {
            "name": "Медяковский",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.50177,
            "latitude": 55.531528
        },
        "9942": {
            "name": "Покровка",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.519638,
            "latitude": 54.117241
        },
        "9943": {
            "name": "Сарыкамышка",
            "population": 128,
            "type": "hamlet",
            "poly": [
                [
                    80.5609515,
                    54.7360974
                ],
                [
                    80.5611152,
                    54.7385865
                ],
                [
                    80.5641714,
                    54.7403508
                ],
                [
                    80.5695199,
                    54.7418001
                ],
                [
                    80.5725216,
                    54.7430603
                ],
                [
                    80.5769968,
                    54.7454545
                ],
                [
                    80.5791798,
                    54.7445094
                ],
                [
                    80.5757961,
                    54.7427137
                ],
                [
                    80.5777607,
                    54.7398152
                ],
                [
                    80.573231,
                    54.7380194
                ],
                [
                    80.5713755,
                    54.7394687
                ],
                [
                    80.5681009,
                    54.738681
                ],
                [
                    80.5702294,
                    54.7371686
                ],
                [
                    80.5682646,
                    54.7352781
                ],
                [
                    80.5625887,
                    54.7344589
                ],
                [
                    80.5609515,
                    54.7360974
                ]
            ],
            "longitude": 80.572731,
            "latitude": 54.740864
        },
        "9944": {
            "name": "Петровский",
            "population": 191,
            "type": "hamlet",
            "poly": [
                [
                    80.5679158,
                    54.5737664
                ],
                [
                    80.5691247,
                    54.5738901
                ],
                [
                    80.5684847,
                    54.5746733
                ],
                [
                    80.580788,
                    54.5769817
                ],
                [
                    80.5844861,
                    54.5760336
                ],
                [
                    80.5852683,
                    54.5761985
                ],
                [
                    80.5859083,
                    54.5749207
                ],
                [
                    80.5924512,
                    54.575539
                ],
                [
                    80.5936602,
                    54.5742199
                ],
                [
                    80.5879707,
                    54.5729007
                ],
                [
                    80.5874019,
                    54.5719525
                ],
                [
                    80.5842727,
                    54.5712105
                ],
                [
                    80.5743163,
                    54.5697263
                ],
                [
                    80.5709027,
                    54.56985
                ],
                [
                    80.569907,
                    54.5717052
                ],
                [
                    80.5684847,
                    54.5726121
                ],
                [
                    80.5679158,
                    54.5737664
                ]
            ],
            "longitude": 80.578346,
            "latitude": 54.573231
        },
        "9945": {
            "name": "Ровенский",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.582222,
            "latitude": 55.426914
        },
        "9946": {
            "name": "Малосуминский",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    80.5900144,
                    54.7933992
                ],
                [
                    80.5909537,
                    54.793793
                ],
                [
                    80.5921064,
                    54.793153
                ],
                [
                    80.5937714,
                    54.7947283
                ],
                [
                    80.5954364,
                    54.7950482
                ],
                [
                    80.5971868,
                    54.794236
                ],
                [
                    80.5969733,
                    54.7932761
                ],
                [
                    80.5979553,
                    54.7928823
                ],
                [
                    80.6012426,
                    54.7903224
                ],
                [
                    80.6001326,
                    54.789387
                ],
                [
                    80.6011572,
                    54.7884516
                ],
                [
                    80.5990226,
                    54.7876146
                ],
                [
                    80.5971868,
                    54.7888208
                ],
                [
                    80.5953937,
                    54.7888454
                ],
                [
                    80.5927894,
                    54.7895593
                ],
                [
                    80.5921491,
                    54.7902977
                ],
                [
                    80.5906121,
                    54.7919716
                ],
                [
                    80.5912952,
                    54.7925131
                ],
                [
                    80.5900144,
                    54.7933992
                ]
            ],
            "longitude": 80.595306,
            "latitude": 54.791084
        },
        "9947": {
            "name": "Суворинский",
            "population": 21,
            "type": "hamlet",
            "poly": [
                [
                    80.6084978,
                    55.1481307
                ],
                [
                    80.6110431,
                    55.1487947
                ],
                [
                    80.6179044,
                    55.1485734
                ],
                [
                    80.6179598,
                    55.1476564
                ],
                [
                    80.6218331,
                    55.1473402
                ],
                [
                    80.6223311,
                    55.1477197
                ],
                [
                    80.6262597,
                    55.1473086
                ],
                [
                    80.6315717,
                    55.1466761
                ],
                [
                    80.6328444,
                    55.1462018
                ],
                [
                    80.6410889,
                    55.1452215
                ],
                [
                    80.6407569,
                    55.1443677
                ],
                [
                    80.6327337,
                    55.1456642
                ],
                [
                    80.6326784,
                    55.1448421
                ],
                [
                    80.6304651,
                    55.1447472
                ],
                [
                    80.6304651,
                    55.1452848
                ],
                [
                    80.6284177,
                    55.145348
                ],
                [
                    80.6266471,
                    55.1444942
                ],
                [
                    80.6253191,
                    55.1447472
                ],
                [
                    80.6227184,
                    55.1432292
                ],
                [
                    80.618015,
                    55.1445258
                ],
                [
                    80.6212244,
                    55.1349112
                ],
                [
                    80.6197304,
                    55.1346581
                ],
                [
                    80.6219437,
                    55.1316847
                ],
                [
                    80.6174618,
                    55.1311153
                ],
                [
                    80.6170744,
                    55.1339622
                ],
                [
                    80.6169084,
                    55.1351326
                ],
                [
                    80.6174618,
                    55.1367773
                ],
                [
                    80.6160231,
                    55.1375681
                ],
                [
                    80.6169637,
                    55.1390862
                ],
                [
                    80.6160231,
                    55.1392444
                ],
                [
                    80.6152484,
                    55.1440831
                ],
                [
                    80.6094938,
                    55.1455694
                ],
                [
                    80.6084978,
                    55.1481307
                ]
            ],
            "longitude": 80.618675,
            "latitude": 55.137371
        },
        "9948": {
            "name": "Преображенский",
            "population": 40,
            "type": "hamlet",
            "poly": [
                [
                    80.6129096,
                    54.9880324
                ],
                [
                    80.6153334,
                    54.9895649
                ],
                [
                    80.6207745,
                    54.9903312
                ],
                [
                    80.6247317,
                    54.9918636
                ],
                [
                    80.626364,
                    54.9911258
                ],
                [
                    80.6245833,
                    54.9881176
                ],
                [
                    80.6332396,
                    54.9858471
                ],
                [
                    80.6378893,
                    54.9843996
                ],
                [
                    80.636801,
                    54.9829521
                ],
                [
                    80.6337342,
                    54.9836049
                ],
                [
                    80.6328439,
                    54.9842861
                ],
                [
                    80.6280458,
                    54.9844848
                ],
                [
                    80.6262651,
                    54.9855633
                ],
                [
                    80.6210713,
                    54.985989
                ],
                [
                    80.6203293,
                    54.9866134
                ],
                [
                    80.6179055,
                    54.9865283
                ],
                [
                    80.6171636,
                    54.9874932
                ],
                [
                    80.6153334,
                    54.9874081
                ],
                [
                    80.6129096,
                    54.9880324
                ]
            ],
            "longitude": 80.622757,
            "latitude": 54.989391
        },
        "9949": {
            "name": "Зубари",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    80.6226901,
                    54.9384117
                ],
                [
                    80.6306105,
                    54.941602
                ],
                [
                    80.6323491,
                    54.9403814
                ],
                [
                    80.6353435,
                    54.9409362
                ],
                [
                    80.6362128,
                    54.939993
                ],
                [
                    80.626747,
                    54.9361644
                ],
                [
                    80.6226901,
                    54.9384117
                ]
            ],
            "longitude": 80.629318,
            "latitude": 54.939266
        },
        "9950": {
            "name": "Новый Вокзал",
            "population": 14,
            "type": "hamlet",
            "poly": [
                [
                    80.6365457,
                    54.5190318
                ],
                [
                    80.6397906,
                    54.5205864
                ],
                [
                    80.6434476,
                    54.5220213
                ],
                [
                    80.6478772,
                    54.5223501
                ],
                [
                    80.6534399,
                    54.5236057
                ],
                [
                    80.6534399,
                    54.5239345
                ],
                [
                    80.6583845,
                    54.5249807
                ],
                [
                    80.6594662,
                    54.5238747
                ],
                [
                    80.6576119,
                    54.5232469
                ],
                [
                    80.6583845,
                    54.521812
                ],
                [
                    80.6454564,
                    54.5189421
                ],
                [
                    80.6442202,
                    54.519271
                ],
                [
                    80.6433961,
                    54.5174772
                ],
                [
                    80.6368548,
                    54.5161318
                ],
                [
                    80.6365457,
                    54.5190318
                ]
            ],
            "longitude": 80.647202,
            "latitude": 54.520721
        },
        "9951": {
            "name": "Красновка",
            "population": 150,
            "type": "hamlet",
            "poly": [
                [
                    80.6509001,
                    55.1950789
                ],
                [
                    80.6552461,
                    55.1991355
                ],
                [
                    80.6633495,
                    55.2014608
                ],
                [
                    80.6664279,
                    55.2008149
                ],
                [
                    80.6663826,
                    55.2003498
                ],
                [
                    80.6635306,
                    55.2002465
                ],
                [
                    80.6627157,
                    55.1997298
                ],
                [
                    80.6658393,
                    55.1991872
                ],
                [
                    80.6655677,
                    55.198748
                ],
                [
                    80.6674691,
                    55.1981796
                ],
                [
                    80.6674691,
                    55.1966034
                ],
                [
                    80.6732184,
                    55.194743
                ],
                [
                    80.6738975,
                    55.1957766
                ],
                [
                    80.6726752,
                    55.1968877
                ],
                [
                    80.6757988,
                    55.1985154
                ],
                [
                    80.6776548,
                    55.1984121
                ],
                [
                    80.6774285,
                    55.1989805
                ],
                [
                    80.6757535,
                    55.1992906
                ],
                [
                    80.6731731,
                    55.200634
                ],
                [
                    80.6804617,
                    55.1998331
                ],
                [
                    80.6808238,
                    55.1976111
                ],
                [
                    80.6743954,
                    55.1936319
                ],
                [
                    80.6757535,
                    55.193296
                ],
                [
                    80.6757535,
                    55.1924949
                ],
                [
                    80.67684,
                    55.1922106
                ],
                [
                    80.6770664,
                    55.1927016
                ],
                [
                    80.679013,
                    55.1928567
                ],
                [
                    80.6807333,
                    55.1925724
                ],
                [
                    80.6805521,
                    55.1916421
                ],
                [
                    80.6810502,
                    55.1912545
                ],
                [
                    80.6800542,
                    55.1906084
                ],
                [
                    80.6788319,
                    55.1912286
                ],
                [
                    80.6787867,
                    55.1917196
                ],
                [
                    80.6767495,
                    55.1917972
                ],
                [
                    80.6753008,
                    55.1911253
                ],
                [
                    80.6730826,
                    55.191823
                ],
                [
                    80.6708644,
                    55.1909961
                ],
                [
                    80.6702758,
                    55.1914612
                ],
                [
                    80.6710906,
                    55.1919781
                ],
                [
                    80.6675596,
                    55.193451
                ],
                [
                    80.6676049,
                    55.1941228
                ],
                [
                    80.6654319,
                    55.1947947
                ],
                [
                    80.6625346,
                    55.1942262
                ],
                [
                    80.6581887,
                    55.193606
                ],
                [
                    80.6571927,
                    55.1939678
                ],
                [
                    80.6549745,
                    55.1931926
                ],
                [
                    80.6537974,
                    55.1931667
                ],
                [
                    80.6536164,
                    55.1938903
                ],
                [
                    80.6509001,
                    55.1950789
                ]
            ],
            "longitude": 80.660805,
            "latitude": 55.197617
        },
        "9952": {
            "name": "Зимовка",
            "population": 17,
            "type": "hamlet",
            "poly": [
                [
                    80.6987104,
                    54.7054232
                ],
                [
                    80.6989734,
                    54.7059298
                ],
                [
                    80.7004053,
                    54.7064532
                ],
                [
                    80.7017496,
                    54.7053894
                ],
                [
                    80.7029479,
                    54.7059804
                ],
                [
                    80.7032109,
                    54.7057778
                ],
                [
                    80.7041753,
                    54.7061155
                ],
                [
                    80.7032402,
                    54.7065714
                ],
                [
                    80.7045553,
                    54.7077027
                ],
                [
                    80.7037662,
                    54.7092054
                ],
                [
                    80.7046722,
                    54.7096443
                ],
                [
                    80.706338,
                    54.7088846
                ],
                [
                    80.7066594,
                    54.7080572
                ],
                [
                    80.7076823,
                    54.708091
                ],
                [
                    80.708033,
                    54.709256
                ],
                [
                    80.7088513,
                    54.7094924
                ],
                [
                    80.7122413,
                    54.7085638
                ],
                [
                    80.7127381,
                    54.707804
                ],
                [
                    80.7117445,
                    54.7072299
                ],
                [
                    80.712329,
                    54.7068078
                ],
                [
                    80.7126797,
                    54.7062506
                ],
                [
                    80.7127966,
                    54.7053894
                ],
                [
                    80.7083837,
                    54.7049504
                ],
                [
                    80.7064841,
                    54.7053557
                ],
                [
                    80.7057827,
                    54.7049335
                ],
                [
                    80.7064549,
                    54.7044776
                ],
                [
                    80.7051105,
                    54.7030085
                ],
                [
                    80.7036307,
                    54.7031325
                ],
                [
                    80.7003761,
                    54.7049167
                ],
                [
                    80.6999962,
                    54.7047816
                ],
                [
                    80.6987104,
                    54.7054232
                ]
            ],
            "longitude": 80.705986,
            "latitude": 54.706379
        },
        "9953": {
            "name": "Князевский",
            "population": 130,
            "type": "hamlet",
            "poly": [
                [
                    80.735232,
                    54.8823108
                ],
                [
                    80.7397778,
                    54.8848404
                ],
                [
                    80.7500553,
                    54.8885352
                ],
                [
                    80.7453118,
                    54.8935367
                ],
                [
                    80.7492647,
                    54.8946165
                ],
                [
                    80.7517353,
                    54.891917
                ],
                [
                    80.7533164,
                    54.8909792
                ],
                [
                    80.755787,
                    54.8908371
                ],
                [
                    80.757714,
                    54.8914055
                ],
                [
                    80.757961,
                    54.8930536
                ],
                [
                    80.7605303,
                    54.8945029
                ],
                [
                    80.7619139,
                    54.8957247
                ],
                [
                    80.7622104,
                    54.8965487
                ],
                [
                    80.7653727,
                    54.8959236
                ],
                [
                    80.7673985,
                    54.8964919
                ],
                [
                    80.7694244,
                    54.8948438
                ],
                [
                    80.7714008,
                    54.8954406
                ],
                [
                    80.7725373,
                    54.8943324
                ],
                [
                    80.7725867,
                    54.8936788
                ],
                [
                    80.7705114,
                    54.8931105
                ],
                [
                    80.771302,
                    54.8924285
                ],
                [
                    80.7682385,
                    54.8903824
                ],
                [
                    80.7661633,
                    54.890013
                ],
                [
                    80.7610474,
                    54.8882376
                ],
                [
                    80.74966,
                    54.8844425
                ],
                [
                    80.7483259,
                    54.8852952
                ],
                [
                    80.744867,
                    54.8841015
                ],
                [
                    80.7455589,
                    54.8834477
                ],
                [
                    80.7437801,
                    54.8825666
                ],
                [
                    80.7370107,
                    54.8812022
                ],
                [
                    80.735232,
                    54.8823108
                ]
            ],
            "longitude": 80.754959,
            "latitude": 54.889412
        },
        "9954": {
            "name": "3192 км",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    80.7724228,
                    55.1210868
                ],
                [
                    80.7734371,
                    55.1230092
                ],
                [
                    80.7756397,
                    55.1227109
                ],
                [
                    80.7772047,
                    55.123987
                ],
                [
                    80.7789436,
                    55.1233572
                ],
                [
                    80.7776973,
                    55.1225286
                ],
                [
                    80.7812621,
                    55.1218492
                ],
                [
                    80.7802767,
                    55.1198438
                ],
                [
                    80.7764802,
                    55.1194792
                ],
                [
                    80.7765381,
                    55.1190815
                ],
                [
                    80.7742486,
                    55.119098
                ],
                [
                    80.7741327,
                    55.1198604
                ],
                [
                    80.773466,
                    55.1198438
                ],
                [
                    80.7724228,
                    55.1210868
                ]
            ],
            "longitude": 80.777939,
            "latitude": 55.120724
        },
        "9955": {
            "name": "Каяк",
            "population": 44,
            "type": "hamlet",
            "poly": [
                [
                    80.7859265,
                    55.0268151
                ],
                [
                    80.7866549,
                    55.0276037
                ],
                [
                    80.7872485,
                    55.0277996
                ],
                [
                    80.7893259,
                    55.0284852
                ],
                [
                    80.792442,
                    55.0300161
                ],
                [
                    80.7947487,
                    55.0320804
                ],
                [
                    80.7955986,
                    55.0329153
                ],
                [
                    80.7979863,
                    55.0334719
                ],
                [
                    80.8010618,
                    55.0338894
                ],
                [
                    80.8050684,
                    55.0354201
                ],
                [
                    80.806161,
                    55.0354665
                ],
                [
                    80.8078607,
                    55.0351882
                ],
                [
                    80.8091962,
                    55.0342373
                ],
                [
                    80.8093581,
                    55.0333328
                ],
                [
                    80.8086296,
                    55.03324
                ],
                [
                    80.8080631,
                    55.0338894
                ],
                [
                    80.8067276,
                    55.0337966
                ],
                [
                    80.8070918,
                    55.0331936
                ],
                [
                    80.8038543,
                    55.0323587
                ],
                [
                    80.802883,
                    55.0326138
                ],
                [
                    80.799605,
                    55.0312686
                ],
                [
                    80.7972983,
                    55.029297
                ],
                [
                    80.795558,
                    55.0287867
                ],
                [
                    80.794425,
                    55.0294826
                ],
                [
                    80.7932514,
                    55.0289259
                ],
                [
                    80.7945869,
                    55.0277197
                ],
                [
                    80.7918754,
                    55.0268847
                ],
                [
                    80.7905399,
                    55.0275342
                ],
                [
                    80.7902162,
                    55.0269543
                ],
                [
                    80.7907423,
                    55.0263975
                ],
                [
                    80.789771,
                    55.0260032
                ],
                [
                    80.7868573,
                    55.0260728
                ],
                [
                    80.7859265,
                    55.0268151
                ]
            ],
            "longitude": 80.79615,
            "latitude": 55.03167
        },
        "9956": {
            "name": "Натальинский",
            "population": 92,
            "type": "hamlet",
            "poly": [
                [
                    80.8391934,
                    55.3070993
                ],
                [
                    80.841789,
                    55.307853
                ],
                [
                    80.8444904,
                    55.3091494
                ],
                [
                    80.8475627,
                    55.3093906
                ],
                [
                    80.8468211,
                    55.3107774
                ],
                [
                    80.8476687,
                    55.3110185
                ],
                [
                    80.8486751,
                    55.3099935
                ],
                [
                    80.8635598,
                    55.3122545
                ],
                [
                    80.8641425,
                    55.3112296
                ],
                [
                    80.8627653,
                    55.3109281
                ],
                [
                    80.8627653,
                    55.3098126
                ],
                [
                    80.8433251,
                    55.3066772
                ],
                [
                    80.8393523,
                    55.3063757
                ],
                [
                    80.8391934,
                    55.3070993
                ]
            ],
            "longitude": 80.84967,
            "latitude": 55.309105
        },
        "9957": {
            "name": "Ваничкино",
            "population": 88,
            "type": "hamlet",
            "poly": [
                [
                    80.8406196,
                    54.9166645
                ],
                [
                    80.8408314,
                    54.9173035
                ],
                [
                    80.85089,
                    54.9210459
                ],
                [
                    80.8546487,
                    54.9192508
                ],
                [
                    80.8571369,
                    54.9208025
                ],
                [
                    80.8563427,
                    54.9212285
                ],
                [
                    80.8587615,
                    54.923473
                ],
                [
                    80.861531,
                    54.9223237
                ],
                [
                    80.8601015,
                    54.921624
                ],
                [
                    80.8611604,
                    54.9206808
                ],
                [
                    80.8582487,
                    54.9181554
                ],
                [
                    80.8521076,
                    54.9151126
                ],
                [
                    80.8495135,
                    54.9141388
                ],
                [
                    80.842049,
                    54.9130433
                ],
                [
                    80.8415672,
                    54.9141779
                ],
                [
                    80.8412549,
                    54.9148083
                ],
                [
                    80.8440078,
                    54.915995
                ],
                [
                    80.8416784,
                    54.9156603
                ],
                [
                    80.8406196,
                    54.9166645
                ]
            ],
            "longitude": 80.850349,
            "latitude": 54.917686
        },
        "9958": {
            "name": "Александровский",
            "population": 55,
            "type": "hamlet",
            "poly": [
                [
                    80.8386158,
                    54.5727023
                ],
                [
                    80.8393211,
                    54.5746643
                ],
                [
                    80.8411545,
                    54.5752775
                ],
                [
                    80.8561748,
                    54.5692685
                ],
                [
                    80.8553286,
                    54.5682056
                ],
                [
                    80.8594186,
                    54.5668974
                ],
                [
                    80.8614635,
                    54.5673471
                ],
                [
                    80.8699962,
                    54.5647714
                ],
                [
                    80.8688679,
                    54.5632995
                ],
                [
                    80.8655536,
                    54.5632587
                ],
                [
                    80.8605469,
                    54.564935
                ],
                [
                    80.8564568,
                    54.5657526
                ],
                [
                    80.8479947,
                    54.5688188
                ],
                [
                    80.8452446,
                    54.5702496
                ],
                [
                    80.8462318,
                    54.5710672
                ],
                [
                    80.8425649,
                    54.5722527
                ],
                [
                    80.8406609,
                    54.5715986
                ],
                [
                    80.8386158,
                    54.5727023
                ]
            ],
            "longitude": 80.853195,
            "latitude": 54.56879
        },
        "9959": {
            "name": "Чувашкино",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.910042,
            "latitude": 55.201969
        },
        "9960": {
            "name": "Васильевский",
            "population": 108,
            "type": "hamlet",
            "poly": [
                [
                    80.9515502,
                    55.2779599
                ],
                [
                    80.9533903,
                    55.2791182
                ],
                [
                    80.9536808,
                    55.280249
                ],
                [
                    80.9530997,
                    55.2809108
                ],
                [
                    80.9535813,
                    55.2812441
                ],
                [
                    80.9561166,
                    55.2806519
                ],
                [
                    80.9556176,
                    55.2798353
                ],
                [
                    80.9577481,
                    55.2774635
                ],
                [
                    80.959007,
                    55.2798904
                ],
                [
                    80.961428,
                    55.2801111
                ],
                [
                    80.9620091,
                    55.2791458
                ],
                [
                    80.9629291,
                    55.2795043
                ],
                [
                    80.961767,
                    55.2811315
                ],
                [
                    80.9635585,
                    55.2815176
                ],
                [
                    80.9650111,
                    55.2806902
                ],
                [
                    80.9665122,
                    55.2812142
                ],
                [
                    80.9682553,
                    55.2806075
                ],
                [
                    80.967529,
                    55.2801111
                ],
                [
                    80.9679648,
                    55.2795043
                ],
                [
                    80.9712088,
                    55.2804144
                ],
                [
                    80.9719836,
                    55.2801111
                ],
                [
                    80.9728068,
                    55.279394
                ],
                [
                    80.9715963,
                    55.279201
                ],
                [
                    80.97179,
                    55.2785115
                ],
                [
                    80.9706762,
                    55.278346
                ],
                [
                    80.9702405,
                    55.2790079
                ],
                [
                    80.968449,
                    55.2786218
                ],
                [
                    80.9688259,
                    55.2778802
                ],
                [
                    80.9689816,
                    55.2775738
                ],
                [
                    80.9664637,
                    55.276967
                ],
                [
                    80.9666574,
                    55.2763878
                ],
                [
                    80.9653501,
                    55.2760568
                ],
                [
                    80.9651564,
                    55.2765533
                ],
                [
                    80.9640911,
                    55.2763326
                ],
                [
                    80.9641879,
                    55.2758086
                ],
                [
                    80.9619607,
                    55.2752845
                ],
                [
                    80.9618638,
                    55.2747329
                ],
                [
                    80.9606049,
                    55.2744571
                ],
                [
                    80.9607501,
                    55.275257
                ],
                [
                    80.9582807,
                    55.2748708
                ],
                [
                    80.9540681,
                    55.2747881
                ],
                [
                    80.9539229,
                    55.2752018
                ],
                [
                    80.9546008,
                    55.2755604
                ],
                [
                    80.9541166,
                    55.276443
                ],
                [
                    80.9526154,
                    55.2763326
                ],
                [
                    80.9515502,
                    55.2779599
                ]
            ],
            "longitude": 80.9616547,
            "latitude": 55.2777965
        },
        "9961": {
            "name": "Синельниково",
            "population": 39,
            "type": "hamlet",
            "poly": [
                [
                    80.983607,
                    54.7608641
                ],
                [
                    80.98762,
                    54.7615257
                ],
                [
                    80.9917968,
                    54.7610532
                ],
                [
                    80.9932709,
                    54.7582178
                ],
                [
                    80.9931891,
                    54.7561857
                ],
                [
                    80.9931891,
                    54.7525465
                ],
                [
                    80.9913054,
                    54.7519321
                ],
                [
                    80.9882752,
                    54.7519794
                ],
                [
                    80.9878657,
                    54.7530664
                ],
                [
                    80.9851631,
                    54.7533027
                ],
                [
                    80.9843441,
                    54.7555713
                ],
                [
                    80.9837708,
                    54.7582178
                ],
                [
                    80.9850812,
                    54.7585959
                ],
                [
                    80.9850812,
                    54.7596828
                ],
                [
                    80.9838527,
                    54.7600608
                ],
                [
                    80.983607,
                    54.7608641
                ]
            ],
            "longitude": 80.988068,
            "latitude": 54.75647
        },
        "9962": {
            "name": "Шерстобитово",
            "population": 100,
            "type": "hamlet",
            "poly": [
                [
                    80.986247,
                    54.9729139
                ],
                [
                    80.986247,
                    54.9737129
                ],
                [
                    80.9913088,
                    54.9759644
                ],
                [
                    80.9923212,
                    54.9756739
                ],
                [
                    80.9951052,
                    54.976618
                ],
                [
                    80.9963706,
                    54.9777437
                ],
                [
                    80.9968135,
                    54.9794866
                ],
                [
                    80.9933335,
                    54.9801765
                ],
                [
                    80.9944724,
                    54.9822461
                ],
                [
                    80.9978892,
                    54.9820646
                ],
                [
                    80.998079,
                    54.98152
                ],
                [
                    81.0020652,
                    54.98152
                ],
                [
                    81.0026345,
                    54.9809027
                ],
                [
                    81.0018121,
                    54.9802128
                ],
                [
                    81.0032674,
                    54.9796682
                ],
                [
                    81.002951,
                    54.9790146
                ],
                [
                    81.0012426,
                    54.9761823
                ],
                [
                    80.9996608,
                    54.9763638
                ],
                [
                    80.9983321,
                    54.9751655
                ],
                [
                    80.9991546,
                    54.9746934
                ],
                [
                    80.9956746,
                    54.9718971
                ],
                [
                    80.9921946,
                    54.9703717
                ],
                [
                    80.9905495,
                    54.9718971
                ],
                [
                    80.989031,
                    54.9713523
                ],
                [
                    80.9876303,
                    54.9722147
                ],
                [
                    80.986247,
                    54.9729139
                ]
            ],
            "longitude": 80.998077,
            "latitude": 54.977886
        },
        "9963": {
            "name": "Бочино",
            "population": 18,
            "type": "hamlet",
            "poly": [
                [
                    80.997259,
                    55.2846888
                ],
                [
                    80.9986632,
                    55.2851852
                ],
                [
                    80.9982759,
                    55.2873636
                ],
                [
                    81.0021979,
                    55.2887698
                ],
                [
                    81.0045221,
                    55.2888525
                ],
                [
                    81.0076694,
                    55.2873911
                ],
                [
                    81.0097514,
                    55.288108
                ],
                [
                    81.0097514,
                    55.2853231
                ],
                [
                    81.0064105,
                    55.2841098
                ],
                [
                    81.0036989,
                    55.2834594
                ],
                [
                    81.0016653,
                    55.2836685
                ],
                [
                    80.997259,
                    55.2846888
                ]
            ],
            "longitude": 81.004303,
            "latitude": 55.286251
        },
        "9964": {
            "name": "Волковский",
            "population": 13,
            "type": "hamlet",
            "poly": [
                [
                    81.032819,
                    54.8821923
                ],
                [
                    81.0341896,
                    54.8826775
                ],
                [
                    81.033557,
                    54.8835873
                ],
                [
                    81.0474214,
                    54.8884692
                ],
                [
                    81.0486339,
                    54.8874383
                ],
                [
                    81.0469997,
                    54.8869531
                ],
                [
                    81.0478959,
                    54.8858615
                ],
                [
                    81.0457872,
                    54.8854673
                ],
                [
                    81.0466834,
                    54.8846183
                ],
                [
                    81.0451546,
                    54.8841937
                ],
                [
                    81.0454182,
                    54.882071
                ],
                [
                    81.0446275,
                    54.880767
                ],
                [
                    81.0436259,
                    54.8809186
                ],
                [
                    81.0425714,
                    54.8820103
                ],
                [
                    81.0386178,
                    54.8792203
                ],
                [
                    81.0355075,
                    54.8784317
                ],
                [
                    81.0341896,
                    54.8797965
                ],
                [
                    81.0377743,
                    54.8810096
                ],
                [
                    81.0366145,
                    54.8819194
                ],
                [
                    81.0340842,
                    54.8820103
                ],
                [
                    81.0330298,
                    54.8815858
                ],
                [
                    81.032819,
                    54.8821923
                ]
            ],
            "longitude": 81.041374,
            "latitude": 54.88467
        },
        "9965": {
            "name": "Дубрава",
            "population": 31,
            "type": "hamlet",
            "poly": [
                [
                    81.040999,
                    55.325449
                ],
                [
                    81.0425484,
                    55.3288371
                ],
                [
                    81.0424032,
                    55.3294155
                ],
                [
                    81.0459863,
                    55.3298838
                ],
                [
                    81.045502,
                    55.3307101
                ],
                [
                    81.04434,
                    55.3310957
                ],
                [
                    81.0435652,
                    55.330655
                ],
                [
                    81.0418221,
                    55.3317843
                ],
                [
                    81.04158,
                    55.3327758
                ],
                [
                    81.0436621,
                    55.3339601
                ],
                [
                    81.0451147,
                    55.3339601
                ],
                [
                    81.0461315,
                    55.3335745
                ],
                [
                    81.0475841,
                    55.3325004
                ],
                [
                    81.0501988,
                    55.3331063
                ],
                [
                    81.049182,
                    55.3344007
                ],
                [
                    81.0490367,
                    55.3356951
                ],
                [
                    81.0528135,
                    55.3358053
                ],
                [
                    81.0541693,
                    55.3370446
                ],
                [
                    81.054944,
                    55.3361633
                ],
                [
                    81.0557671,
                    55.336301
                ],
                [
                    81.0600766,
                    55.3344558
                ],
                [
                    81.0602217,
                    55.3339876
                ],
                [
                    81.0593987,
                    55.333602
                ],
                [
                    81.060125,
                    55.3323627
                ],
                [
                    81.0602217,
                    55.3306275
                ],
                [
                    81.0609481,
                    55.3303796
                ],
                [
                    81.0628849,
                    55.3289748
                ],
                [
                    81.0646765,
                    55.3283413
                ],
                [
                    81.0648217,
                    55.3272946
                ],
                [
                    81.0674364,
                    55.3264958
                ],
                [
                    81.0676301,
                    55.3259724
                ],
                [
                    81.0661775,
                    55.3252561
                ],
                [
                    81.0632239,
                    55.3240716
                ],
                [
                    81.0612871,
                    55.3210963
                ],
                [
                    81.0600766,
                    55.3205453
                ],
                [
                    81.0587692,
                    55.3210963
                ],
                [
                    81.0548956,
                    55.3230523
                ],
                [
                    81.054363,
                    55.3210688
                ],
                [
                    81.0524746,
                    55.3204902
                ],
                [
                    81.0496177,
                    55.3239063
                ],
                [
                    81.0447757,
                    55.323438
                ],
                [
                    81.0440494,
                    55.324595
                ],
                [
                    81.040999,
                    55.325449
                ]
            ],
            "longitude": 81.05275,
            "latitude": 55.328453
        },
        "9966": {
            "name": "Филимоновский",
            "population": 118,
            "type": "hamlet",
            "poly": [
                [
                    81.0605274,
                    54.9333074
                ],
                [
                    81.0607853,
                    54.9344928
                ],
                [
                    81.0616106,
                    54.9357967
                ],
                [
                    81.0632097,
                    54.9355893
                ],
                [
                    81.0635707,
                    54.9358856
                ],
                [
                    81.0635707,
                    54.9365376
                ],
                [
                    81.0651182,
                    54.9371599
                ],
                [
                    81.0672331,
                    54.9368043
                ],
                [
                    81.067749,
                    54.9359745
                ],
                [
                    81.0733714,
                    54.9354411
                ],
                [
                    81.0740605,
                    54.9325133
                ],
                [
                    81.0785297,
                    54.9315885
                ],
                [
                    81.0771369,
                    54.9266092
                ],
                [
                    81.0745579,
                    54.9268759
                ],
                [
                    81.0736809,
                    54.9272909
                ],
                [
                    81.0733199,
                    54.9269352
                ],
                [
                    81.0712566,
                    54.9270538
                ],
                [
                    81.0690901,
                    54.9279726
                ],
                [
                    81.0656341,
                    54.9296028
                ],
                [
                    81.0655309,
                    54.9287432
                ],
                [
                    81.0659951,
                    54.9280023
                ],
                [
                    81.0647572,
                    54.9273205
                ],
                [
                    81.0628787,
                    54.9283128
                ],
                [
                    81.0614559,
                    54.9300473
                ],
                [
                    81.0632097,
                    54.9315589
                ],
                [
                    81.0605274,
                    54.9333074
                ]
            ],
            "longitude": 81.071777,
            "latitude": 54.93045
        },
        "9967": {
            "name": "Залесный",
            "population": 150,
            "type": "hamlet",
            "poly": [
                [
                    81.0824449,
                    55.0158791
                ],
                [
                    81.0845446,
                    55.0161939
                ],
                [
                    81.085126,
                    55.0157494
                ],
                [
                    81.0860951,
                    55.0167495
                ],
                [
                    81.0846092,
                    55.0173051
                ],
                [
                    81.0849645,
                    55.0179163
                ],
                [
                    81.0880655,
                    55.0173792
                ],
                [
                    81.0873225,
                    55.0159161
                ],
                [
                    81.0891639,
                    55.0161384
                ],
                [
                    81.0892931,
                    55.0156383
                ],
                [
                    81.0883563,
                    55.0152123
                ],
                [
                    81.0889055,
                    55.0149715
                ],
                [
                    81.08981,
                    55.0155457
                ],
                [
                    81.0896484,
                    55.0163791
                ],
                [
                    81.0912959,
                    55.0168792
                ],
                [
                    81.0910698,
                    55.0172681
                ],
                [
                    81.0924588,
                    55.0174903
                ],
                [
                    81.0931372,
                    55.0160828
                ],
                [
                    81.0949784,
                    55.0160828
                ],
                [
                    81.0949461,
                    55.0155827
                ],
                [
                    81.0976919,
                    55.0157679
                ],
                [
                    81.098564,
                    55.0139899
                ],
                [
                    81.0972396,
                    55.0136565
                ],
                [
                    81.0959151,
                    55.0136935
                ],
                [
                    81.0949784,
                    55.0138047
                ],
                [
                    81.0955599,
                    55.0129897
                ],
                [
                    81.0963997,
                    55.0129897
                ],
                [
                    81.0966259,
                    55.0125822
                ],
                [
                    81.0956568,
                    55.0120265
                ],
                [
                    81.0972072,
                    55.0108596
                ],
                [
                    81.0991778,
                    55.0114523
                ],
                [
                    81.1005345,
                    55.0106558
                ],
                [
                    81.0995331,
                    55.0098593
                ],
                [
                    81.0995331,
                    55.0089887
                ],
                [
                    81.0966581,
                    55.0085256
                ],
                [
                    81.0959151,
                    55.0079699
                ],
                [
                    81.0903914,
                    55.006914
                ],
                [
                    81.0890347,
                    55.0081551
                ],
                [
                    81.0910052,
                    55.0084145
                ],
                [
                    81.0903591,
                    55.0086738
                ],
                [
                    81.0921681,
                    55.0093407
                ],
                [
                    81.0917804,
                    55.0098779
                ],
                [
                    81.0907144,
                    55.0097852
                ],
                [
                    81.0906821,
                    55.0093407
                ],
                [
                    81.0894223,
                    55.0093221
                ],
                [
                    81.0895192,
                    55.0096741
                ],
                [
                    81.0887117,
                    55.0096926
                ],
                [
                    81.0885824,
                    55.0099334
                ],
                [
                    81.0887763,
                    55.010415
                ],
                [
                    81.0851583,
                    55.0128971
                ],
                [
                    81.0841892,
                    55.0143418
                ],
                [
                    81.0832848,
                    55.0142307
                ],
                [
                    81.0824449,
                    55.0158791
                ]
            ],
            "longitude": 81.092453,
            "latitude": 55.011929
        },
        "9968": {
            "name": "Малая Ужаниха",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    81.0876669,
                    54.7387756
                ],
                [
                    81.0914188,
                    54.7430118
                ],
                [
                    81.0918051,
                    54.7450183
                ],
                [
                    81.0901498,
                    54.7448909
                ],
                [
                    81.0903153,
                    54.7458464
                ],
                [
                    81.0944535,
                    54.7464196
                ],
                [
                    81.095226,
                    54.7446998
                ],
                [
                    81.0963295,
                    54.7440947
                ],
                [
                    81.1012953,
                    54.7434896
                ],
                [
                    81.095226,
                    54.7366414
                ],
                [
                    81.0876669,
                    54.7387756
                ]
            ],
            "longitude": 81.094566,
            "latitude": 54.741592
        },
        "9969": {
            "name": "Снежинский",
            "population": 24,
            "type": "hamlet",
            "poly": [
                [
                    81.1604255,
                    54.8795877
                ],
                [
                    81.1647582,
                    54.880397
                ],
                [
                    81.1628451,
                    54.8814328
                ],
                [
                    81.1656023,
                    54.8831808
                ],
                [
                    81.1674029,
                    54.8831484
                ],
                [
                    81.1668964,
                    54.8813357
                ],
                [
                    81.1674029,
                    54.8805264
                ],
                [
                    81.1687533,
                    54.8803322
                ],
                [
                    81.1703289,
                    54.8787784
                ],
                [
                    81.1729173,
                    54.8787136
                ],
                [
                    81.1727484,
                    54.8775158
                ],
                [
                    81.1698224,
                    54.8762857
                ],
                [
                    81.1708352,
                    54.8756705
                ],
                [
                    81.172242,
                    54.876059
                ],
                [
                    81.1746053,
                    54.8738899
                ],
                [
                    81.1727484,
                    54.8734366
                ],
                [
                    81.1701038,
                    54.8742136
                ],
                [
                    81.1685845,
                    54.8740518
                ],
                [
                    81.1656585,
                    54.8746022
                ],
                [
                    81.1618885,
                    54.8764799
                ],
                [
                    81.1627888,
                    54.8773216
                ],
                [
                    81.1605943,
                    54.8788431
                ],
                [
                    81.1604255,
                    54.8795877
                ]
            ],
            "longitude": 81.166824,
            "latitude": 54.877995
        },
        "9970": {
            "name": "Новокузьминка",
            "population": 252,
            "type": "hamlet",
            "poly": [
                [
                    81.1569199,
                    54.1356912
                ],
                [
                    81.1748962,
                    54.1360362
                ],
                [
                    81.1864765,
                    54.1340442
                ],
                [
                    81.1728036,
                    54.1271569
                ],
                [
                    81.1629628,
                    54.1275316
                ],
                [
                    81.1572608,
                    54.1319224
                ],
                [
                    81.1569199,
                    54.1356912
                ]
            ],
            "longitude": 81.169373,
            "latitude": 54.132153
        },
        "9971": {
            "name": "Большедорожное",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    81.2172733,
                    55.0891448
                ],
                [
                    81.2183006,
                    55.0893031
                ],
                [
                    81.2190908,
                    55.0881725
                ],
                [
                    81.2180635,
                    55.0879238
                ],
                [
                    81.2172733,
                    55.0891448
                ]
            ],
            "longitude": 81.217461,
            "latitude": 55.088871
        },
        "9972": {
            "name": "Кузнецкий",
            "population": 221,
            "type": "hamlet",
            "poly": [
                [
                    81.2945163,
                    55.1765672
                ],
                [
                    81.2954035,
                    55.1772005
                ],
                [
                    81.2974442,
                    55.1778845
                ],
                [
                    81.2993074,
                    55.1781125
                ],
                [
                    81.3013037,
                    55.1802656
                ],
                [
                    81.3009488,
                    55.1810509
                ],
                [
                    81.3015699,
                    55.1814815
                ],
                [
                    81.3036549,
                    55.1816588
                ],
                [
                    81.3051189,
                    55.1812029
                ],
                [
                    81.3063167,
                    55.1822161
                ],
                [
                    81.3073814,
                    55.1822414
                ],
                [
                    81.3091115,
                    55.1818868
                ],
                [
                    81.3124387,
                    55.1797844
                ],
                [
                    81.3108417,
                    55.1787204
                ],
                [
                    81.3132372,
                    55.1772512
                ],
                [
                    81.3102649,
                    55.1753512
                ],
                [
                    81.3105755,
                    55.1747938
                ],
                [
                    81.3091115,
                    55.1738818
                ],
                [
                    81.3078553,
                    55.1740881
                ],
                [
                    81.303788,
                    55.1746925
                ],
                [
                    81.300239,
                    55.1770232
                ],
                [
                    81.2997067,
                    55.1768458
                ],
                [
                    81.3003721,
                    55.1761872
                ],
                [
                    81.2989969,
                    55.1760098
                ],
                [
                    81.2984202,
                    55.1764405
                ],
                [
                    81.2978435,
                    55.1762379
                ],
                [
                    81.2984645,
                    55.1755032
                ],
                [
                    81.2970893,
                    55.1750725
                ],
                [
                    81.2958028,
                    55.1753765
                ],
                [
                    81.2945163,
                    55.1765672
                ]
            ],
            "longitude": 81.304688,
            "latitude": 55.178265
        },
        "9973": {
            "name": "Каськовский",
            "population": 87,
            "type": "hamlet",
            "poly": [
                [
                    81.3109429,
                    55.3904943
                ],
                [
                    81.3130662,
                    55.3911708
                ],
                [
                    81.312393,
                    55.3919356
                ],
                [
                    81.3124448,
                    55.3928474
                ],
                [
                    81.3139467,
                    55.3935239
                ],
                [
                    81.3149824,
                    55.3930239
                ],
                [
                    81.3167433,
                    55.3930239
                ],
                [
                    81.3175201,
                    55.3944946
                ],
                [
                    81.3195917,
                    55.3951122
                ],
                [
                    81.3204203,
                    55.3946416
                ],
                [
                    81.32099,
                    55.3951122
                ],
                [
                    81.3188149,
                    55.3958769
                ],
                [
                    81.3151896,
                    55.3995826
                ],
                [
                    81.316536,
                    55.4001413
                ],
                [
                    81.3214561,
                    55.4023469
                ],
                [
                    81.3204721,
                    55.4031409
                ],
                [
                    81.3253402,
                    55.4051992
                ],
                [
                    81.3289656,
                    55.4031409
                ],
                [
                    81.3276709,
                    55.4020822
                ],
                [
                    81.3300014,
                    55.4006119
                ],
                [
                    81.3284477,
                    55.400259
                ],
                [
                    81.3272565,
                    55.4003472
                ],
                [
                    81.327878,
                    55.3992885
                ],
                [
                    81.3284477,
                    55.3953475
                ],
                [
                    81.3276709,
                    55.3935239
                ],
                [
                    81.3295353,
                    55.391112
                ],
                [
                    81.3267386,
                    55.3906708
                ],
                [
                    81.3237866,
                    55.3890235
                ],
                [
                    81.3175719,
                    55.3896412
                ],
                [
                    81.3156556,
                    55.3903178
                ],
                [
                    81.3168469,
                    55.3871408
                ],
                [
                    81.313118,
                    55.3862288
                ],
                [
                    81.3137395,
                    55.3878174
                ],
                [
                    81.3119269,
                    55.388847
                ],
                [
                    81.3128073,
                    55.3895824
                ],
                [
                    81.3118751,
                    55.3897295
                ],
                [
                    81.3109429,
                    55.3904943
                ]
            ],
            "longitude": 81.325012,
            "latitude": 55.396568
        },
        "9974": {
            "name": "Средний Алеус",
            "population": 201,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.351761,
            "latitude": 54.187954
        },
        "9975": {
            "name": "Илюшино",
            "population": 74,
            "type": "hamlet",
            "poly": [
                [
                    81.369612,
                    55.0238234
                ],
                [
                    81.3697295,
                    55.02406
                ],
                [
                    81.369656,
                    55.0247577
                ],
                [
                    81.3704929,
                    55.0254646
                ],
                [
                    81.3732239,
                    55.0251869
                ],
                [
                    81.3731358,
                    55.0247829
                ],
                [
                    81.3763953,
                    55.0244294
                ],
                [
                    81.3774083,
                    55.0255404
                ],
                [
                    81.3768357,
                    55.0259696
                ],
                [
                    81.3782453,
                    55.0267018
                ],
                [
                    81.3830024,
                    55.0259443
                ],
                [
                    81.3838393,
                    55.026828
                ],
                [
                    81.3904023,
                    55.0273077
                ],
                [
                    81.3909309,
                    55.0249344
                ],
                [
                    81.3857333,
                    55.0240002
                ],
                [
                    81.3866582,
                    55.0236972
                ],
                [
                    81.3863499,
                    55.0229144
                ],
                [
                    81.3874071,
                    55.0227882
                ],
                [
                    81.3878476,
                    55.0231165
                ],
                [
                    81.3911071,
                    55.0229397
                ],
                [
                    81.3914154,
                    55.0224599
                ],
                [
                    81.3907107,
                    55.0218287
                ],
                [
                    81.3886845,
                    55.0217782
                ],
                [
                    81.3885083,
                    55.0214247
                ],
                [
                    81.3893892,
                    55.0211217
                ],
                [
                    81.3882,
                    55.0200611
                ],
                [
                    81.3863059,
                    55.0205409
                ],
                [
                    81.3859535,
                    55.0200611
                ],
                [
                    81.3831345,
                    55.0202379
                ],
                [
                    81.3830905,
                    55.0206671
                ],
                [
                    81.3803155,
                    55.0214499
                ],
                [
                    81.3792583,
                    55.0211217
                ],
                [
                    81.3739727,
                    55.0224599
                ],
                [
                    81.3741048,
                    55.0232679
                ],
                [
                    81.3725191,
                    55.0226872
                ],
                [
                    81.3716822,
                    55.0228639
                ],
                [
                    81.3716822,
                    55.0233942
                ],
                [
                    81.3709774,
                    55.0237477
                ],
                [
                    81.3699644,
                    55.0234699
                ],
                [
                    81.369612,
                    55.0238234
                ]
            ],
            "longitude": 81.38224,
            "latitude": 55.023476
        },
        "9976": {
            "name": "Зырянка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    81.3806993,
                    54.5692181
                ],
                [
                    81.3851192,
                    54.5732471
                ],
                [
                    81.3827237,
                    54.5746161
                ],
                [
                    81.3827237,
                    54.5754766
                ],
                [
                    81.3850517,
                    54.5769825
                ],
                [
                    81.3903826,
                    54.5791531
                ],
                [
                    81.3972993,
                    54.5787424
                ],
                [
                    81.3992562,
                    54.5770802
                ],
                [
                    81.3868062,
                    54.5684943
                ],
                [
                    81.3819139,
                    54.5684552
                ],
                [
                    81.3806993,
                    54.5692181
                ]
            ],
            "longitude": 81.388756,
            "latitude": 54.574684
        },
        "9977": {
            "name": "Пушкарёво",
            "population": 270,
            "type": "hamlet",
            "poly": [
                [
                    81.3808207,
                    54.17697
                ],
                [
                    81.3933814,
                    54.1844993
                ],
                [
                    81.3971819,
                    54.1820478
                ],
                [
                    81.3948225,
                    54.1751435
                ],
                [
                    81.3886431,
                    54.1716594
                ],
                [
                    81.3808207,
                    54.17697
                ]
            ],
            "longitude": 81.389671,
            "latitude": 54.177399
        },
        "9978": {
            "name": "Сидоркино",
            "population": 121,
            "type": "hamlet",
            "poly": [
                [
                    81.3854017,
                    54.8624808
                ],
                [
                    81.3875962,
                    54.8629342
                ],
                [
                    81.3872023,
                    54.8640029
                ],
                [
                    81.3990751,
                    54.8654925
                ],
                [
                    81.3999191,
                    54.8646505
                ],
                [
                    81.4029014,
                    54.8650391
                ],
                [
                    81.4030702,
                    54.8667878
                ],
                [
                    81.4058837,
                    54.8670792
                ],
                [
                    81.4070653,
                    54.8668526
                ],
                [
                    81.4075155,
                    54.8657192
                ],
                [
                    81.4087534,
                    54.8648125
                ],
                [
                    81.4072903,
                    54.8629342
                ],
                [
                    81.4039143,
                    54.8610234
                ],
                [
                    81.400932,
                    54.8596632
                ],
                [
                    81.3986249,
                    54.8592097
                ],
                [
                    81.3961491,
                    54.8608615
                ],
                [
                    81.3937858,
                    54.8607967
                ],
                [
                    81.3935044,
                    54.8611854
                ],
                [
                    81.3950799,
                    54.8619302
                ],
                [
                    81.3951924,
                    54.8624484
                ],
                [
                    81.3928292,
                    54.8622217
                ],
                [
                    81.392154,
                    54.8630637
                ],
                [
                    81.3905222,
                    54.8627075
                ],
                [
                    81.3896781,
                    54.8613473
                ],
                [
                    81.3862457,
                    54.8613149
                ],
                [
                    81.3854017,
                    54.8624808
                ]
            ],
            "longitude": 81.397842,
            "latitude": 54.862995
        },
        "9979": {
            "name": "Боготольский",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    81.3961947,
                    54.7314916
                ],
                [
                    81.3988464,
                    54.7319736
                ],
                [
                    81.3996812,
                    54.7310947
                ],
                [
                    81.4009088,
                    54.7312931
                ],
                [
                    81.4006142,
                    54.7323422
                ],
                [
                    81.4022837,
                    54.7324556
                ],
                [
                    81.4029221,
                    54.731605
                ],
                [
                    81.4035605,
                    54.7317184
                ],
                [
                    81.4033149,
                    54.7326258
                ],
                [
                    81.4040515,
                    54.733051
                ],
                [
                    81.406605,
                    54.7333913
                ],
                [
                    81.4073416,
                    54.7322288
                ],
                [
                    81.4105334,
                    54.7325974
                ],
                [
                    81.4118593,
                    54.7315483
                ],
                [
                    81.4122521,
                    54.7281174
                ],
                [
                    81.4098951,
                    54.72721
                ],
                [
                    81.4074398,
                    54.7270398
                ],
                [
                    81.4071943,
                    54.7276637
                ],
                [
                    81.4088146,
                    54.7279756
                ],
                [
                    81.4087165,
                    54.7299888
                ],
                [
                    81.4071452,
                    54.73152
                ],
                [
                    81.4052301,
                    54.7312364
                ],
                [
                    81.4054756,
                    54.7304425
                ],
                [
                    81.4036096,
                    54.7302157
                ],
                [
                    81.4029712,
                    54.7308962
                ],
                [
                    81.4008106,
                    54.7307261
                ],
                [
                    81.4013507,
                    54.7295919
                ],
                [
                    81.3979625,
                    54.7291665
                ],
                [
                    81.3974714,
                    54.7302157
                ],
                [
                    81.3964893,
                    54.7303007
                ],
                [
                    81.3961947,
                    54.7314916
                ]
            ],
            "longitude": 81.409294,
            "latitude": 54.731052
        },
        "9980": {
            "name": "Антоново",
            "population": 182,
            "type": "hamlet",
            "poly": [
                [
                    81.3925679,
                    54.0901389
                ],
                [
                    81.3937032,
                    54.0931562
                ],
                [
                    81.4304209,
                    54.0973701
                ],
                [
                    81.431355,
                    54.0949261
                ],
                [
                    81.3925679,
                    54.0901389
                ]
            ],
            "longitude": 81.412224,
            "latitude": 54.094025
        },
        "9981": {
            "name": "Секты",
            "population": 65,
            "type": "hamlet",
            "poly": [
                [
                    81.4185316,
                    55.1424239
                ],
                [
                    81.4227987,
                    55.1439114
                ],
                [
                    81.4293356,
                    55.1453816
                ],
                [
                    81.4379304,
                    55.1462809
                ],
                [
                    81.4392015,
                    55.1449146
                ],
                [
                    81.4205689,
                    55.1407378
                ],
                [
                    81.4185316,
                    55.1424239
                ]
            ],
            "longitude": 81.43087,
            "latitude": 55.144337
        },
        "9982": {
            "name": "Малоникольское",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    81.4171642,
                    54.6093437
                ],
                [
                    81.4174113,
                    54.6099639
                ],
                [
                    81.4200472,
                    54.6112042
                ],
                [
                    81.4226007,
                    54.6093437
                ],
                [
                    81.4394047,
                    54.6163559
                ],
                [
                    81.4415463,
                    54.6163082
                ],
                [
                    81.4458297,
                    54.611729
                ],
                [
                    81.4249895,
                    54.60505
                ],
                [
                    81.4238363,
                    54.6085327
                ],
                [
                    81.4188116,
                    54.606863
                ],
                [
                    81.4171642,
                    54.6093437
                ]
            ],
            "longitude": 81.433716,
            "latitude": 54.612495
        },
        "9983": {
            "name": "Тихомировский",
            "population": 93,
            "type": "hamlet",
            "poly": [
                [
                    81.4273,
                    55.0839051
                ],
                [
                    81.4305505,
                    55.0855667
                ],
                [
                    81.4325539,
                    55.0854787
                ],
                [
                    81.4347329,
                    55.0843147
                ],
                [
                    81.4353624,
                    55.0854787
                ],
                [
                    81.4374687,
                    55.0847304
                ],
                [
                    81.4382677,
                    55.0852154
                ],
                [
                    81.4400835,
                    55.084578
                ],
                [
                    81.4397929,
                    55.083899
                ],
                [
                    81.4423835,
                    55.0827211
                ],
                [
                    81.4423275,
                    55.0815242
                ],
                [
                    81.4422867,
                    55.0810719
                ],
                [
                    81.4444172,
                    55.0797692
                ],
                [
                    81.444054,
                    55.0793811
                ],
                [
                    81.4473018,
                    55.0786001
                ],
                [
                    81.4467413,
                    55.0777457
                ],
                [
                    81.4420113,
                    55.0780873
                ],
                [
                    81.4367666,
                    55.0806423
                ],
                [
                    81.4381466,
                    55.0775378
                ],
                [
                    81.436234,
                    55.0766231
                ],
                [
                    81.434515,
                    55.0764845
                ],
                [
                    81.4339339,
                    55.077815
                ],
                [
                    81.4343212,
                    55.0780922
                ],
                [
                    81.4338129,
                    55.0793396
                ],
                [
                    81.4337886,
                    55.0798662
                ],
                [
                    81.4351687,
                    55.0801434
                ],
                [
                    81.4355561,
                    55.0810304
                ],
                [
                    81.4273,
                    55.0839051
                ]
            ],
            "longitude": 81.438164,
            "latitude": 55.08147
        },
        "9984": {
            "name": "Усть-Алеус",
            "population": 137,
            "type": "hamlet",
            "poly": [
                [
                    81.4338989,
                    54.0975827
                ],
                [
                    81.4554208,
                    54.1011692
                ],
                [
                    81.4567084,
                    54.0993086
                ],
                [
                    81.4356694,
                    54.0955721
                ],
                [
                    81.4338989,
                    54.0975827
                ]
            ],
            "longitude": 81.448334,
            "latitude": 54.099041
        },
        "9985": {
            "name": "Новорождественский",
            "population": 46,
            "type": "hamlet",
            "poly": [
                [
                    81.443484,
                    54.7924653
                ],
                [
                    81.4575512,
                    54.7963901
                ],
                [
                    81.4589052,
                    54.7952192
                ],
                [
                    81.4582658,
                    54.7936363
                ],
                [
                    81.4567613,
                    54.7928773
                ],
                [
                    81.4559338,
                    54.7935929
                ],
                [
                    81.4546174,
                    54.7930725
                ],
                [
                    81.4549183,
                    54.7924002
                ],
                [
                    81.448148,
                    54.7897979
                ],
                [
                    81.4477342,
                    54.7899714
                ],
                [
                    81.4466811,
                    54.7911424
                ],
                [
                    81.4444995,
                    54.7911641
                ],
                [
                    81.443484,
                    54.7924653
                ]
            ],
            "longitude": 81.452492,
            "latitude": 54.79422
        },
        "9986": {
            "name": "Черемшанка",
            "population": 135,
            "type": "hamlet",
            "poly": [
                [
                    81.488883,
                    54.2182706
                ],
                [
                    81.4966731,
                    54.2195683
                ],
                [
                    81.4987283,
                    54.2218151
                ],
                [
                    81.5005559,
                    54.2215312
                ],
                [
                    81.5021323,
                    54.2194317
                ],
                [
                    81.5038512,
                    54.2186675
                ],
                [
                    81.5066092,
                    54.2176971
                ],
                [
                    81.5064232,
                    54.2115462
                ],
                [
                    81.5014317,
                    54.2117327
                ],
                [
                    81.4935493,
                    54.2125522
                ],
                [
                    81.4924106,
                    54.2161714
                ],
                [
                    81.4925567,
                    54.2169395
                ],
                [
                    81.4890421,
                    54.2171259
                ],
                [
                    81.488883,
                    54.2182706
                ]
            ],
            "longitude": 81.501518,
            "latitude": 54.218037
        },
        "9987": {
            "name": "Большая Поляна",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.535187,
            "latitude": 55.184643
        },
        "9988": {
            "name": "Милованово",
            "population": 80,
            "type": "hamlet",
            "poly": [
                [
                    81.5428966,
                    54.0906266
                ],
                [
                    81.5453205,
                    54.0918748
                ],
                [
                    81.5474939,
                    54.0929465
                ],
                [
                    81.5569076,
                    54.0978263
                ],
                [
                    81.5586463,
                    54.0978484
                ],
                [
                    81.5596566,
                    54.0965789
                ],
                [
                    81.5561927,
                    54.0918953
                ],
                [
                    81.5535466,
                    54.0908513
                ],
                [
                    81.5506599,
                    54.0922056
                ],
                [
                    81.5434435,
                    54.0891582
                ],
                [
                    81.5428966,
                    54.0906266
                ]
            ],
            "longitude": 81.552834,
            "latitude": 54.09317
        },
        "9989": {
            "name": "Севастьяновка",
            "population": 110,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.563408,
            "latitude": 55.090515
        },
        "9990": {
            "name": "Покровское",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    81.5849606,
                    54.6357232
                ],
                [
                    81.5869447,
                    54.6376051
                ],
                [
                    81.5922354,
                    54.6402843
                ],
                [
                    81.6046355,
                    54.6443664
                ],
                [
                    81.6064542,
                    54.6436967
                ],
                [
                    81.6105324,
                    54.6389447
                ],
                [
                    81.6041395,
                    54.6368077
                ],
                [
                    81.6029821,
                    54.6379879
                ],
                [
                    81.5887633,
                    54.6340008
                ],
                [
                    81.5849606,
                    54.6357232
                ]
            ],
            "longitude": 81.595726,
            "latitude": 54.639557
        },
        "9991": {
            "name": "Новорощинский",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.614433,
            "latitude": 55.208664
        },
        "9992": {
            "name": "Борисовский",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.615097,
            "latitude": 54.532993
        },
        "9993": {
            "name": "Антипинский",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.623398,
            "latitude": 54.970196
        },
        "9994": {
            "name": "Казанка",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.665161,
            "latitude": 54.794914
        },
        "9995": {
            "name": "Лесной",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.695518,
            "latitude": 54.742428
        },
        "9996": {
            "name": "Бугринская Роща",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    81.6962013,
                    54.4755022
                ],
                [
                    81.6997062,
                    54.4774417
                ],
                [
                    81.7043793,
                    54.4748718
                ],
                [
                    81.7052138,
                    54.4700227
                ],
                [
                    81.6985379,
                    54.4700712
                ],
                [
                    81.6993724,
                    54.4730292
                ],
                [
                    81.6962013,
                    54.4755022
                ]
            ],
            "longitude": 81.702301,
            "latitude": 54.472813
        },
        "9997": {
            "name": "Абрашино",
            "population": 37,
            "type": "hamlet",
            "poly": [
                [
                    81.7066083,
                    54.2314606
                ],
                [
                    81.7097196,
                    54.235272
                ],
                [
                    81.7139386,
                    54.2428977
                ],
                [
                    81.7171242,
                    54.2463757
                ],
                [
                    81.7192809,
                    54.2453439
                ],
                [
                    81.7196383,
                    54.2448503
                ],
                [
                    81.7200268,
                    54.2442238
                ],
                [
                    81.7196399,
                    54.2428465
                ],
                [
                    81.7195569,
                    54.2413183
                ],
                [
                    81.7185908,
                    54.2394494
                ],
                [
                    81.7174528,
                    54.235423
                ],
                [
                    81.7171366,
                    54.2345813
                ],
                [
                    81.7126302,
                    54.2335144
                ],
                [
                    81.7081428,
                    54.2308129
                ],
                [
                    81.7066083,
                    54.2314606
                ]
            ],
            "longitude": 81.71566,
            "latitude": 54.238159
        },
        "9998": {
            "name": "Березовский",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.738472,
            "latitude": 54.723602
        },
        "9999": {
            "name": "Александровский",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.775055,
            "latitude": 55.124928
        },
        "10000": {
            "name": "Владиславский",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.786766,
            "latitude": 55.257309
        },
        "10001": {
            "name": "Ольшанский",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.795837,
            "latitude": 55.013729
        },
        "10002": {
            "name": "Тараданово",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.8150248,
            "latitude": 53.8117827
        },
        "10003": {
            "name": "Маслово",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.843254,
            "latitude": 54.865856
        },
        "10004": {
            "name": "Студенкино",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.843384,
            "latitude": 55.169094
        },
        "10005": {
            "name": "Малая Крутишка",
            "population": 259,
            "type": "hamlet",
            "poly": [
                [
                    81.8565226,
                    54.0707423
                ],
                [
                    81.8578023,
                    54.0721832
                ],
                [
                    81.8605193,
                    54.0724247
                ],
                [
                    81.8617451,
                    54.0695653
                ],
                [
                    81.8606383,
                    54.0678401
                ],
                [
                    81.8619526,
                    54.0663585
                ],
                [
                    81.8639586,
                    54.0653031
                ],
                [
                    81.8719479,
                    54.065709
                ],
                [
                    81.8740576,
                    54.0655872
                ],
                [
                    81.876859,
                    54.065364
                ],
                [
                    81.8838108,
                    54.0657496
                ],
                [
                    81.887546,
                    54.0656684
                ],
                [
                    81.8877189,
                    54.0642882
                ],
                [
                    81.8864739,
                    54.0641055
                ],
                [
                    81.8868197,
                    54.0630298
                ],
                [
                    81.8831882,
                    54.0629486
                ],
                [
                    81.8826694,
                    54.0621975
                ],
                [
                    81.8842258,
                    54.0614059
                ],
                [
                    81.8825657,
                    54.0593759
                ],
                [
                    81.8809056,
                    54.0585639
                ],
                [
                    81.8785191,
                    54.0593353
                ],
                [
                    81.8732967,
                    54.0599443
                ],
                [
                    81.8706336,
                    54.0606142
                ],
                [
                    81.8668638,
                    54.0573459
                ],
                [
                    81.8635089,
                    54.0577519
                ],
                [
                    81.8622639,
                    54.0584218
                ],
                [
                    81.8640969,
                    54.0606548
                ],
                [
                    81.8653766,
                    54.0605736
                ],
                [
                    81.8665871,
                    54.0620554
                ],
                [
                    81.8650653,
                    54.0630703
                ],
                [
                    81.8603616,
                    54.063862
                ],
                [
                    81.8590128,
                    54.0646739
                ],
                [
                    81.8583557,
                    54.0656887
                ],
                [
                    81.8575948,
                    54.0689361
                ],
                [
                    81.8565226,
                    54.0707423
                ]
            ],
            "longitude": 81.867722,
            "latitude": 54.062683
        },
        "10006": {
            "name": "Зорино",
            "population": 142,
            "type": "hamlet",
            "poly": [
                [
                    81.8721239,
                    53.7565671
                ],
                [
                    81.8732098,
                    53.7579367
                ],
                [
                    81.8833814,
                    53.7547051
                ],
                [
                    81.8913087,
                    53.7542985
                ],
                [
                    81.8947474,
                    53.7541701
                ],
                [
                    81.9010459,
                    53.7533996
                ],
                [
                    81.9022404,
                    53.7513235
                ],
                [
                    81.9042313,
                    53.750553
                ],
                [
                    81.9058964,
                    53.7481343
                ],
                [
                    81.9046657,
                    53.7458225
                ],
                [
                    81.9010459,
                    53.7438959
                ],
                [
                    81.8995256,
                    53.7440029
                ],
                [
                    81.8997428,
                    53.7445809
                ],
                [
                    81.9007563,
                    53.7458225
                ],
                [
                    81.8944579,
                    53.7491403
                ],
                [
                    81.8907657,
                    53.75066
                ],
                [
                    81.8829108,
                    53.7520513
                ],
                [
                    81.87473,
                    53.7499323
                ],
                [
                    81.8731011,
                    53.7528004
                ],
                [
                    81.8748387,
                    53.7531856
                ],
                [
                    81.87473,
                    53.7537635
                ],
                [
                    81.8759608,
                    53.7556468
                ],
                [
                    81.8721239,
                    53.7565671
                ]
            ],
            "longitude": 81.897278,
            "latitude": 53.74995
        },
        "10007": {
            "name": "Ермиловка",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    81.9266178,
                    55.3006386
                ],
                [
                    81.9287422,
                    55.3066484
                ],
                [
                    81.9318966,
                    55.3092865
                ],
                [
                    81.9338279,
                    55.3088835
                ],
                [
                    81.9389137,
                    55.3125473
                ],
                [
                    81.9465101,
                    55.3176761
                ],
                [
                    81.9486345,
                    55.3161009
                ],
                [
                    81.9463813,
                    55.3141593
                ],
                [
                    81.9488277,
                    55.3125107
                ],
                [
                    81.9315748,
                    55.3009684
                ],
                [
                    81.9266178,
                    55.3006386
                ]
            ],
            "longitude": 81.937386,
            "latitude": 55.307846
        },
        "10008": {
            "name": "Козлово",
            "population": 163,
            "type": "hamlet",
            "poly": [
                [
                    81.9335145,
                    54.9121691
                ],
                [
                    81.9417142,
                    54.914041
                ],
                [
                    81.9432262,
                    54.9155118
                ],
                [
                    81.9490998,
                    54.9150438
                ],
                [
                    81.9490416,
                    54.9137736
                ],
                [
                    81.9520074,
                    54.9132053
                ],
                [
                    81.958637,
                    54.9114002
                ],
                [
                    81.9591022,
                    54.9081574
                ],
                [
                    81.9607887,
                    54.9047138
                ],
                [
                    81.9575321,
                    54.9011361
                ],
                [
                    81.9589859,
                    54.8975246
                ],
                [
                    81.9544499,
                    54.8969896
                ],
                [
                    81.9486927,
                    54.9015039
                ],
                [
                    81.9402604,
                    54.9050147
                ],
                [
                    81.9335145,
                    54.9121691
                ]
            ],
            "longitude": 81.950272,
            "latitude": 54.907032
        },
        "10009": {
            "name": "Малый Чик",
            "population": 164,
            "type": "hamlet",
            "poly": [
                [
                    81.9581826,
                    54.6922542
                ],
                [
                    81.9678637,
                    54.6981249
                ],
                [
                    81.9747495,
                    54.6932392
                ],
                [
                    81.9754994,
                    54.6877225
                ],
                [
                    81.963364,
                    54.6857914
                ],
                [
                    81.9587279,
                    54.6885106
                ],
                [
                    81.9581826,
                    54.6922542
                ]
            ],
            "longitude": 81.966866,
            "latitude": 54.692085
        },
        "10010": {
            "name": "Майский",
            "population": 231,
            "type": "hamlet",
            "poly": [
                [
                    81.9839249,
                    54.8884376
                ],
                [
                    81.9885439,
                    54.892734
                ],
                [
                    82.0035985,
                    54.8880112
                ],
                [
                    82.0012034,
                    54.8846983
                ],
                [
                    82.0044539,
                    54.8833862
                ],
                [
                    82.0031422,
                    54.8820413
                ],
                [
                    81.9839249,
                    54.8884376
                ]
            ],
            "longitude": 81.99456,
            "latitude": 54.887589
        },
        "10011": {
            "name": "Поротниково",
            "population": 162,
            "type": "hamlet",
            "poly": [
                [
                    81.9907387,
                    53.744849
                ],
                [
                    81.9912255,
                    53.7455818
                ],
                [
                    81.9968015,
                    53.7462622
                ],
                [
                    81.9991331,
                    53.746017
                ],
                [
                    82.0060063,
                    53.7498997
                ],
                [
                    82.0056965,
                    53.7520716
                ],
                [
                    82.0066258,
                    53.7533275
                ],
                [
                    82.0106087,
                    53.753406
                ],
                [
                    82.011538,
                    53.7516006
                ],
                [
                    82.0116708,
                    53.7478585
                ],
                [
                    82.0086246,
                    53.7436941
                ],
                [
                    81.9960049,
                    53.742572
                ],
                [
                    81.9921548,
                    53.7428599
                ],
                [
                    81.9907829,
                    53.7434357
                ],
                [
                    81.9907387,
                    53.744849
                ]
            ],
            "longitude": 82.001457,
            "latitude": 53.745422
        },
        "10012": {
            "name": "Малореченка",
            "population": 228,
            "type": "hamlet",
            "poly": [
                [
                    81.9971531,
                    54.8455255
                ],
                [
                    81.9976549,
                    54.848441
                ],
                [
                    81.9991603,
                    54.8498856
                ],
                [
                    82.004133,
                    54.8487299
                ],
                [
                    82.0067332,
                    54.850621
                ],
                [
                    82.0143061,
                    54.8487562
                ],
                [
                    82.008923,
                    54.8389319
                ],
                [
                    82.0034487,
                    54.8399827
                ],
                [
                    82.000529,
                    54.8414276
                ],
                [
                    82.0024906,
                    54.8438706
                ],
                [
                    81.9971531,
                    54.8455255
                ]
            ],
            "longitude": 82.006744,
            "latitude": 54.845009
        },
        "10013": {
            "name": "Остановочная Платформа 3273",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    82.0084758,
                    55.035427
                ],
                [
                    82.0086101,
                    55.0357844
                ],
                [
                    82.0084786,
                    55.035842
                ],
                [
                    82.008666,
                    55.0361529
                ],
                [
                    82.008982,
                    55.0362074
                ],
                [
                    82.0122116,
                    55.0357972
                ],
                [
                    82.0120858,
                    55.0352924
                ],
                [
                    82.0118733,
                    55.0349976
                ],
                [
                    82.0084758,
                    55.035427
                ]
            ],
            "longitude": 82.010056,
            "latitude": 55.03566
        },
        "10014": {
            "name": "Сартаково",
            "population": 102,
            "type": "hamlet",
            "poly": [
                [
                    81.9979302,
                    54.9890182
                ],
                [
                    82.0006096,
                    54.9920558
                ],
                [
                    81.9990786,
                    54.995752
                ],
                [
                    82.0009286,
                    54.9976548
                ],
                [
                    82.0069889,
                    54.995935
                ],
                [
                    82.0101785,
                    54.9955324
                ],
                [
                    82.0152181,
                    54.998899
                ],
                [
                    82.0170681,
                    54.9979476
                ],
                [
                    82.0225543,
                    54.9978378
                ],
                [
                    82.0252336,
                    54.9968132
                ],
                [
                    82.0203216,
                    54.9940686
                ],
                [
                    82.015856,
                    54.9916167
                ],
                [
                    82.0212147,
                    54.9874077
                ],
                [
                    82.0197474,
                    54.9840036
                ],
                [
                    82.014963,
                    54.9815145
                ],
                [
                    82.0089665,
                    54.981185
                ],
                [
                    82.0059682,
                    54.9824296
                ],
                [
                    82.0037354,
                    54.9842233
                ],
                [
                    82.0054579,
                    54.9863463
                ],
                [
                    82.0048199,
                    54.9874443
                ],
                [
                    81.9979302,
                    54.9890182
                ]
            ],
            "longitude": 82.011536,
            "latitude": 54.990059
        },
        "10015": {
            "name": "Семеновский",
            "population": 98,
            "type": "hamlet",
            "poly": [
                [
                    82.0507838,
                    55.165895
                ],
                [
                    82.0509626,
                    55.166547
                ],
                [
                    82.0518014,
                    55.1669397
                ],
                [
                    82.0579485,
                    55.1669869
                ],
                [
                    82.058086,
                    55.1639155
                ],
                [
                    82.0581397,
                    55.1627078
                ],
                [
                    82.0589058,
                    55.1626853
                ],
                [
                    82.0592438,
                    55.1619227
                ],
                [
                    82.0629051,
                    55.1611086
                ],
                [
                    82.0627305,
                    55.1597957
                ],
                [
                    82.0594804,
                    55.1595189
                ],
                [
                    82.0590241,
                    55.159815
                ],
                [
                    82.0582524,
                    55.1596702
                ],
                [
                    82.0584777,
                    55.1580612
                ],
                [
                    82.0584161,
                    55.156613
                ],
                [
                    82.059041,
                    55.1540937
                ],
                [
                    82.0591994,
                    55.1510713
                ],
                [
                    82.0543323,
                    55.1509355
                ],
                [
                    82.0530826,
                    55.1519011
                ],
                [
                    82.0525809,
                    55.1526755
                ],
                [
                    82.0523697,
                    55.1544356
                ],
                [
                    82.0520528,
                    55.1569248
                ],
                [
                    82.0522729,
                    55.158564
                ],
                [
                    82.0518289,
                    55.1595083
                ],
                [
                    82.0510451,
                    55.162525
                ],
                [
                    82.0507838,
                    55.165895
                ]
            ],
            "longitude": 82.056702,
            "latitude": 55.159451
        },
        "10016": {
            "name": "Бармашево",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.069046,
            "latitude": 55.008022
        },
        "10017": {
            "name": "Остановочная Платформа 3277",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.075974,
            "latitude": 55.028103
        },
        "10018": {
            "name": "Вдовино",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.077972,
            "latitude": 56.050777
        },
        "10019": {
            "name": "Остановочная Платформа Клы",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.078926,
            "latitude": 53.810314
        },
        "10020": {
            "name": "Степной",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    82.1050936,
                    54.693076
                ],
                [
                    82.1119665,
                    54.6964876
                ],
                [
                    82.1279406,
                    54.689473
                ],
                [
                    82.1243206,
                    54.6870121
                ],
                [
                    82.1178093,
                    54.6868893
                ],
                [
                    82.1167438,
                    54.6855978
                ],
                [
                    82.1126439,
                    54.6855297
                ],
                [
                    82.1132521,
                    54.6877044
                ],
                [
                    82.1084925,
                    54.6899646
                ],
                [
                    82.1050936,
                    54.693076
                ]
            ],
            "longitude": 82.116524,
            "latitude": 54.690392
        },
        "10021": {
            "name": "Комихинский",
            "population": 73,
            "type": "hamlet",
            "poly": [
                [
                    82.0992745,
                    54.781323
                ],
                [
                    82.1013246,
                    54.7848298
                ],
                [
                    82.1102551,
                    54.7831866
                ],
                [
                    82.1120621,
                    54.7822248
                ],
                [
                    82.1142512,
                    54.781343
                ],
                [
                    82.1172049,
                    54.7810424
                ],
                [
                    82.1185948,
                    54.7800004
                ],
                [
                    82.1196372,
                    54.7779662
                ],
                [
                    82.1257357,
                    54.7726148
                ],
                [
                    82.1266566,
                    54.7718832
                ],
                [
                    82.1233206,
                    54.7710213
                ],
                [
                    82.1210968,
                    54.7709512
                ],
                [
                    82.1199153,
                    54.7712618
                ],
                [
                    82.1135215,
                    54.7766134
                ],
                [
                    82.1136258,
                    54.7776155
                ],
                [
                    82.1122879,
                    54.7789783
                ],
                [
                    82.1092474,
                    54.7800204
                ],
                [
                    82.1073188,
                    54.7801707
                ],
                [
                    82.1047995,
                    54.7811527
                ],
                [
                    82.1039656,
                    54.7804813
                ],
                [
                    82.0992745,
                    54.781323
                ]
            ],
            "longitude": 82.120148,
            "latitude": 54.772888
        },
        "10022": {
            "name": "Ерестная",
            "population": 25,
            "type": "hamlet",
            "poly": [
                [
                    82.1134795,
                    54.3719944
                ],
                [
                    82.1214347,
                    54.3760044
                ],
                [
                    82.1258102,
                    54.3786636
                ],
                [
                    82.1273897,
                    54.3808792
                ],
                [
                    82.12959,
                    54.3830199
                ],
                [
                    82.1327048,
                    54.3846668
                ],
                [
                    82.1348832,
                    54.386143
                ],
                [
                    82.137151,
                    54.3876392
                ],
                [
                    82.138632,
                    54.3886168
                ],
                [
                    82.1446962,
                    54.3912534
                ],
                [
                    82.1496259,
                    54.3932083
                ],
                [
                    82.1539428,
                    54.3895932
                ],
                [
                    82.1487999,
                    54.3872968
                ],
                [
                    82.1465082,
                    54.3879174
                ],
                [
                    82.1400595,
                    54.3847364
                ],
                [
                    82.1399903,
                    54.3836933
                ],
                [
                    82.1395265,
                    54.3821138
                ],
                [
                    82.1373948,
                    54.3810895
                ],
                [
                    82.1341438,
                    54.378684
                ],
                [
                    82.1306796,
                    54.3765266
                ],
                [
                    82.1263094,
                    54.374245
                ],
                [
                    82.1265226,
                    54.3736086
                ],
                [
                    82.126949,
                    54.3731895
                ],
                [
                    82.1267891,
                    54.3729101
                ],
                [
                    82.1244974,
                    54.372522
                ],
                [
                    82.1214921,
                    54.3719954
                ],
                [
                    82.1207934,
                    54.3708456
                ],
                [
                    82.119461,
                    54.3706127
                ],
                [
                    82.1189281,
                    54.3712336
                ],
                [
                    82.1160235,
                    54.3707058
                ],
                [
                    82.1134795,
                    54.3719944
                ]
            ],
            "longitude": 82.131348,
            "latitude": 54.380486
        },
        "10023": {
            "name": "Артамоново",
            "population": 73,
            "type": "hamlet",
            "poly": [
                [
                    82.1201716,
                    54.179312
                ],
                [
                    82.1215093,
                    54.1800738
                ],
                [
                    82.1232086,
                    54.1815549
                ],
                [
                    82.1253057,
                    54.1828879
                ],
                [
                    82.1252334,
                    54.1849614
                ],
                [
                    82.1228832,
                    54.1841786
                ],
                [
                    82.1220517,
                    54.1851095
                ],
                [
                    82.1245103,
                    54.1860404
                ],
                [
                    82.1257757,
                    54.1880291
                ],
                [
                    82.127005,
                    54.1898273
                ],
                [
                    82.1280174,
                    54.1914562
                ],
                [
                    82.1304398,
                    54.192535
                ],
                [
                    82.1317776,
                    54.19226
                ],
                [
                    82.1334769,
                    54.1916677
                ],
                [
                    82.1364417,
                    54.1928735
                ],
                [
                    82.1386833,
                    54.1938677
                ],
                [
                    82.1402742,
                    54.1932754
                ],
                [
                    82.1442513,
                    54.1894888
                ],
                [
                    82.1431939,
                    54.1887669
                ],
                [
                    82.1441067,
                    54.1877118
                ],
                [
                    82.1385749,
                    54.1863155
                ],
                [
                    82.1381049,
                    54.1852576
                ],
                [
                    82.1338023,
                    54.1822955
                ],
                [
                    82.1293913,
                    54.1796294
                ],
                [
                    82.1285597,
                    54.1800526
                ],
                [
                    82.1272219,
                    54.1813857
                ],
                [
                    82.1259926,
                    54.1813857
                ],
                [
                    82.1231002,
                    54.178656
                ],
                [
                    82.1223047,
                    54.1781693
                ],
                [
                    82.1201716,
                    54.179312
                ]
            ],
            "longitude": 82.131783,
            "latitude": 54.186726
        },
        "10024": {
            "name": "Нижний Сузун",
            "population": 31,
            "type": "hamlet",
            "poly": [
                [
                    82.1368245,
                    53.720152
                ],
                [
                    82.1380994,
                    53.7208091
                ],
                [
                    82.1376334,
                    53.7216777
                ],
                [
                    82.1405116,
                    53.7225171
                ],
                [
                    82.1414337,
                    53.7219945
                ],
                [
                    82.1422317,
                    53.7219132
                ],
                [
                    82.1438217,
                    53.7220205
                ],
                [
                    82.1443734,
                    53.7214524
                ],
                [
                    82.1453173,
                    53.7214588
                ],
                [
                    82.1483073,
                    53.7226002
                ],
                [
                    82.1482878,
                    53.7237341
                ],
                [
                    82.1491553,
                    53.7242332
                ],
                [
                    82.1505415,
                    53.7242838
                ],
                [
                    82.151921,
                    53.7245775
                ],
                [
                    82.1537447,
                    53.7233203
                ],
                [
                    82.1532147,
                    53.7223105
                ],
                [
                    82.1526048,
                    53.7219166
                ],
                [
                    82.1511777,
                    53.7211939
                ],
                [
                    82.1512441,
                    53.7207164
                ],
                [
                    82.1520702,
                    53.7202389
                ],
                [
                    82.1519562,
                    53.7189747
                ],
                [
                    82.1511492,
                    53.7189691
                ],
                [
                    82.1502512,
                    53.7192822
                ],
                [
                    82.1493907,
                    53.7192318
                ],
                [
                    82.147924,
                    53.7184647
                ],
                [
                    82.1453667,
                    53.7182155
                ],
                [
                    82.1438038,
                    53.7177432
                ],
                [
                    82.1419008,
                    53.7180252
                ],
                [
                    82.1399093,
                    53.7181714
                ],
                [
                    82.1386403,
                    53.7180802
                ],
                [
                    82.1376049,
                    53.7177898
                ],
                [
                    82.1368245,
                    53.720152
                ]
            ],
            "longitude": 82.145599,
            "latitude": 53.720684
        },
        "10025": {
            "name": "Новоотрубное",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.146957,
            "latitude": 55.128391
        },
        "10026": {
            "name": "Вахрушево",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.155624,
            "latitude": 55.250351
        },
        "10027": {
            "name": "Федосово",
            "population": 167,
            "type": "hamlet",
            "poly": [
                [
                    82.1473024,
                    54.8754015
                ],
                [
                    82.1510662,
                    54.877316
                ],
                [
                    82.1579393,
                    54.8756212
                ],
                [
                    82.167158,
                    54.8713213
                ],
                [
                    82.1658489,
                    54.8689357
                ],
                [
                    82.1611031,
                    54.8684021
                ],
                [
                    82.1572847,
                    54.8691241
                ],
                [
                    82.1569575,
                    54.8708191
                ],
                [
                    82.1494843,
                    54.8736753
                ],
                [
                    82.1473024,
                    54.8754015
                ]
            ],
            "longitude": 82.157486,
            "latitude": 54.872799
        },
        "10028": {
            "name": "Красный Камешок",
            "population": 195,
            "type": "hamlet",
            "poly": [
                [
                    82.1561781,
                    53.9055272
                ],
                [
                    82.1598495,
                    53.9062387
                ],
                [
                    82.1566612,
                    53.9102226
                ],
                [
                    82.1608639,
                    53.9103649
                ],
                [
                    82.1615884,
                    53.9095397
                ],
                [
                    82.1672404,
                    53.9094259
                ],
                [
                    82.1670955,
                    53.9118161
                ],
                [
                    82.165598,
                    53.9111047
                ],
                [
                    82.1641971,
                    53.9119584
                ],
                [
                    82.167965,
                    53.9146045
                ],
                [
                    82.1733271,
                    53.9158849
                ],
                [
                    82.1744382,
                    53.9136656
                ],
                [
                    82.1687862,
                    53.9113608
                ],
                [
                    82.16811,
                    53.9090559
                ],
                [
                    82.1722644,
                    53.9081738
                ],
                [
                    82.1724093,
                    53.9070924
                ],
                [
                    82.1688829,
                    53.9058403
                ],
                [
                    82.1653081,
                    53.905698
                ],
                [
                    82.1638106,
                    53.9057549
                ],
                [
                    82.1628928,
                    53.9062956
                ],
                [
                    82.1615402,
                    53.9044458
                ],
                [
                    82.1652115,
                    53.9018844
                ],
                [
                    82.1624097,
                    53.9019413
                ],
                [
                    82.1605258,
                    53.9043604
                ],
                [
                    82.1569027,
                    53.9038766
                ],
                [
                    82.1561781,
                    53.9055272
                ]
            ],
            "longitude": 82.160873,
            "latitude": 53.90786
        },
        "10029": {
            "name": "Тропино",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.195923,
            "latitude": 54.922401
        },
        "10030": {
            "name": "Лушники",
            "population": 91,
            "type": "hamlet",
            "poly": [
                [
                    82.1917957,
                    54.0546606
                ],
                [
                    82.1939908,
                    54.0551324
                ],
                [
                    82.1937434,
                    54.0559128
                ],
                [
                    82.1978862,
                    54.0566931
                ],
                [
                    82.1972988,
                    54.0572012
                ],
                [
                    82.197979,
                    54.0576731
                ],
                [
                    82.1989683,
                    54.0576731
                ],
                [
                    82.199463,
                    54.0571105
                ],
                [
                    82.2018745,
                    54.0578001
                ],
                [
                    82.2027711,
                    54.0575642
                ],
                [
                    82.2038531,
                    54.0571468
                ],
                [
                    82.2060791,
                    54.057165
                ],
                [
                    82.2082433,
                    54.0587619
                ],
                [
                    82.2095727,
                    54.0585441
                ],
                [
                    82.2141793,
                    54.0562031
                ],
                [
                    82.215756,
                    54.0567657
                ],
                [
                    82.2164052,
                    54.0560035
                ],
                [
                    82.2170545,
                    54.0545335
                ],
                [
                    82.2181057,
                    54.0541705
                ],
                [
                    82.2191567,
                    54.0527731
                ],
                [
                    82.217611,
                    54.0524827
                ],
                [
                    82.2187548,
                    54.051666
                ],
                [
                    82.2178182,
                    54.0503821
                ],
                [
                    82.2152613,
                    54.0497965
                ],
                [
                    82.2142411,
                    54.0508311
                ],
                [
                    82.212046,
                    54.0509763
                ],
                [
                    82.2071921,
                    54.0494698
                ],
                [
                    82.2053371,
                    54.0502321
                ],
                [
                    82.2023073,
                    54.0508129
                ],
                [
                    82.1973607,
                    54.0525553
                ],
                [
                    82.196866,
                    54.0533901
                ],
                [
                    82.1921358,
                    54.0541342
                ],
                [
                    82.1917957,
                    54.0546606
                ]
            ],
            "longitude": 82.209175,
            "latitude": 54.053967
        },
        "10031": {
            "name": "Кочетовка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.23452,
            "latitude": 55.397663
        },
        "10032": {
            "name": "Первомайский",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.248177,
            "latitude": 55.210861
        },
        "10033": {
            "name": "Поперечное",
            "population": 230,
            "type": "hamlet",
            "poly": [
                [
                    82.2357799,
                    54.5892227
                ],
                [
                    82.2401787,
                    54.5947448
                ],
                [
                    82.250687,
                    54.5948864
                ],
                [
                    82.2588738,
                    54.5888687
                ],
                [
                    82.2669384,
                    54.5895767
                ],
                [
                    82.2724369,
                    54.5849036
                ],
                [
                    82.2648612,
                    54.5829917
                ],
                [
                    82.2357799,
                    54.5892227
                ]
            ],
            "longitude": 82.254807,
            "latitude": 54.587929
        },
        "10034": {
            "name": "Хохловка",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.256683,
            "latitude": 56.109581
        },
        "10035": {
            "name": "участок Новостройка",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    82.259016,
                    53.8963315
                ],
                [
                    82.2619464,
                    53.8990827
                ],
                [
                    82.2664275,
                    53.8997248
                ],
                [
                    82.268709,
                    53.8990203
                ],
                [
                    82.2685853,
                    53.8984374
                ],
                [
                    82.2662357,
                    53.8970529
                ],
                [
                    82.266854,
                    53.8963424
                ],
                [
                    82.2680907,
                    53.8963606
                ],
                [
                    82.2692346,
                    53.8959234
                ],
                [
                    82.2696056,
                    53.8950125
                ],
                [
                    82.2696365,
                    53.8939012
                ],
                [
                    82.2678433,
                    53.8929356
                ],
                [
                    82.2652463,
                    53.8914963
                ],
                [
                    82.2644116,
                    53.8921157
                ],
                [
                    82.2641024,
                    53.8931724
                ],
                [
                    82.2632059,
                    53.8947028
                ],
                [
                    82.2624639,
                    53.8945024
                ],
                [
                    82.2597741,
                    53.8953222
                ],
                [
                    82.259016,
                    53.8963315
                ]
            ],
            "longitude": 82.267044,
            "latitude": 53.894806
        },
        "10036": {
            "name": "Молот",
            "population": 248,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.292595,
            "latitude": 55.29818
        },
        "10037": {
            "name": "Антоновка",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.298119,
            "latitude": 54.827515
        },
        "10038": {
            "name": "Казаково",
            "population": 231,
            "type": "hamlet",
            "poly": [
                [
                    82.2847162,
                    54.9449708
                ],
                [
                    82.2879961,
                    54.9486965
                ],
                [
                    82.2930253,
                    54.9516266
                ],
                [
                    82.3020634,
                    54.9562306
                ],
                [
                    82.3071655,
                    54.9559795
                ],
                [
                    82.3124498,
                    54.9524637
                ],
                [
                    82.3091333,
                    54.9495546
                ],
                [
                    82.2999861,
                    54.9456825
                ],
                [
                    82.301626,
                    54.9432544
                ],
                [
                    82.2974349,
                    54.9419356
                ],
                [
                    82.2931347,
                    54.9403237
                ],
                [
                    82.2868663,
                    54.9426683
                ],
                [
                    82.2847162,
                    54.9449708
                ]
            ],
            "longitude": 82.298401,
            "latitude": 54.948757
        },
        "10039": {
            "name": "Приозерная",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.298744,
            "latitude": 54.899082
        },
        "10040": {
            "name": "Лаптевка",
            "population": 74,
            "type": "hamlet",
            "poly": [
                [
                    82.2978082,
                    55.7857815
                ],
                [
                    82.2988705,
                    55.7863788
                ],
                [
                    82.2985118,
                    55.7867124
                ],
                [
                    82.3029542,
                    55.7915061
                ],
                [
                    82.3014642,
                    55.792398
                ],
                [
                    82.308045,
                    55.7973616
                ],
                [
                    82.3076311,
                    55.7978657
                ],
                [
                    82.3088038,
                    55.7985947
                ],
                [
                    82.3094936,
                    55.798618
                ],
                [
                    82.3101006,
                    55.7983388
                ],
                [
                    82.3103214,
                    55.7978967
                ],
                [
                    82.3117286,
                    55.7969429
                ],
                [
                    82.3127495,
                    55.7965706
                ],
                [
                    82.3145982,
                    55.7963147
                ],
                [
                    82.3157847,
                    55.7962526
                ],
                [
                    82.3166401,
                    55.7965939
                ],
                [
                    82.3172057,
                    55.7971988
                ],
                [
                    82.3176886,
                    55.7975012
                ],
                [
                    82.3178265,
                    55.7966016
                ],
                [
                    82.3170263,
                    55.7940966
                ],
                [
                    82.3140188,
                    55.7918318
                ],
                [
                    82.313053,
                    55.791413
                ],
                [
                    82.3122253,
                    55.7906063
                ],
                [
                    82.3108181,
                    55.7896135
                ],
                [
                    82.3093143,
                    55.7890007
                ],
                [
                    82.3078242,
                    55.7880621
                ],
                [
                    82.3084727,
                    55.7876665
                ],
                [
                    82.3074104,
                    55.7870692
                ],
                [
                    82.3067068,
                    55.7874493
                ],
                [
                    82.3042648,
                    55.7863245
                ],
                [
                    82.3032163,
                    55.7869063
                ],
                [
                    82.3001674,
                    55.7849592
                ],
                [
                    82.3000294,
                    55.7851686
                ],
                [
                    82.2986911,
                    55.7846489
                ],
                [
                    82.2980841,
                    55.7849359
                ],
                [
                    82.2978082,
                    55.7857815
                ]
            ],
            "longitude": 82.308846,
            "latitude": 55.79385
        },
        "10041": {
            "name": "Харьковка",
            "population": 107,
            "type": "hamlet",
            "poly": [
                [
                    82.3088609,
                    54.1066733
                ],
                [
                    82.3137304,
                    54.108939
                ],
                [
                    82.3129961,
                    54.1095507
                ],
                [
                    82.3183679,
                    54.1130848
                ],
                [
                    82.3197977,
                    54.1121786
                ],
                [
                    82.3255173,
                    54.1154633
                ],
                [
                    82.3289954,
                    54.1126317
                ],
                [
                    82.3171698,
                    54.1068772
                ],
                [
                    82.3215368,
                    54.1032293
                ],
                [
                    82.3215754,
                    54.1017111
                ],
                [
                    82.318793,
                    54.1012806
                ],
                [
                    82.316822,
                    54.1043396
                ],
                [
                    82.310059,
                    54.1036372
                ],
                [
                    82.3092861,
                    54.1046568
                ],
                [
                    82.3107547,
                    54.1052912
                ],
                [
                    82.3088609,
                    54.1066733
                ]
            ],
            "longitude": 82.316956,
            "latitude": 54.109104
        },
        "10042": {
            "name": "Остановочная Платформа 3293",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.319496,
            "latitude": 55.005383
        },
        "10043": {
            "name": "Шигаево",
            "population": 243,
            "type": "hamlet",
            "poly": [
                [
                    82.3080198,
                    54.2463332
                ],
                [
                    82.3095213,
                    54.2477646
                ],
                [
                    82.310193,
                    54.2511351
                ],
                [
                    82.3122872,
                    54.2531665
                ],
                [
                    82.3160014,
                    54.2551517
                ],
                [
                    82.3154877,
                    54.2554979
                ],
                [
                    82.3177795,
                    54.2568598
                ],
                [
                    82.319281,
                    54.2567444
                ],
                [
                    82.3218493,
                    54.2556826
                ],
                [
                    82.3219679,
                    54.2526818
                ],
                [
                    82.3273417,
                    54.2539975
                ],
                [
                    82.3286061,
                    54.2523586
                ],
                [
                    82.3210591,
                    54.248411
                ],
                [
                    82.3285666,
                    54.2458483
                ],
                [
                    82.3260377,
                    54.2432393
                ],
                [
                    82.3192415,
                    54.2458945
                ],
                [
                    82.3160804,
                    54.243424
                ],
                [
                    82.3136963,
                    54.2444492
                ],
                [
                    82.3095608,
                    54.2455251
                ],
                [
                    82.3080198,
                    54.2463332
                ]
            ],
            "longitude": 82.319519,
            "latitude": 54.248936
        },
        "10044": {
            "name": "Камышинка",
            "population": 153,
            "type": "hamlet",
            "poly": [
                [
                    82.3291803,
                    53.6427248
                ],
                [
                    82.3481454,
                    53.6474833
                ],
                [
                    82.3513845,
                    53.6436431
                ],
                [
                    82.3434405,
                    53.639779
                ],
                [
                    82.3394609,
                    53.6389677
                ],
                [
                    82.3355177,
                    53.6394965
                ],
                [
                    82.3298376,
                    53.6416116
                ],
                [
                    82.3291803,
                    53.6427248
                ]
            ],
            "longitude": 82.341988,
            "latitude": 53.642845
        },
        "10045": {
            "name": "Орловка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.422691,
            "latitude": 55.818714
        },
        "10046": {
            "name": "Шилово",
            "population": 179,
            "type": "hamlet",
            "poly": [
                [
                    82.4049785,
                    54.7339278
                ],
                [
                    82.4074143,
                    54.7346058
                ],
                [
                    82.4142432,
                    54.7353341
                ],
                [
                    82.4152002,
                    54.7345305
                ],
                [
                    82.4197238,
                    54.7339529
                ],
                [
                    82.4202892,
                    54.7348319
                ],
                [
                    82.4244649,
                    54.7357359
                ],
                [
                    82.4275966,
                    54.7369162
                ],
                [
                    82.4311633,
                    54.7376947
                ],
                [
                    82.4346865,
                    54.7381467
                ],
                [
                    82.4377313,
                    54.7366902
                ],
                [
                    82.4420374,
                    54.7358615
                ],
                [
                    82.4420808,
                    54.7343296
                ],
                [
                    82.4441252,
                    54.7333502
                ],
                [
                    82.4443862,
                    54.7311401
                ],
                [
                    82.4406455,
                    54.7281261
                ],
                [
                    82.4283796,
                    54.7272721
                ],
                [
                    82.4238559,
                    54.7274982
                ],
                [
                    82.4195498,
                    54.7287038
                ],
                [
                    82.416331,
                    54.727473
                ],
                [
                    82.4194193,
                    54.7230772
                ],
                [
                    82.4158091,
                    54.7214444
                ],
                [
                    82.4149827,
                    54.7215448
                ],
                [
                    82.4144172,
                    54.7262171
                ],
                [
                    82.4065444,
                    54.7298592
                ],
                [
                    82.4049785,
                    54.7339278
                ]
            ],
            "longitude": 82.423157,
            "latitude": 54.731796
        },
        "10047": {
            "name": "Рождественка",
            "population": 26,
            "type": "hamlet",
            "poly": [
                [
                    82.4238373,
                    54.374998
                ],
                [
                    82.4248716,
                    54.3762405
                ],
                [
                    82.4301397,
                    54.3762216
                ],
                [
                    82.4339858,
                    54.3764664
                ],
                [
                    82.4381228,
                    54.3743391
                ],
                [
                    82.440579,
                    54.3768429
                ],
                [
                    82.4414841,
                    54.3775394
                ],
                [
                    82.4438434,
                    54.3780665
                ],
                [
                    82.449758,
                    54.37897
                ],
                [
                    82.4511154,
                    54.3786688
                ],
                [
                    82.4540242,
                    54.3804006
                ],
                [
                    82.4553493,
                    54.3800618
                ],
                [
                    82.4570623,
                    54.3783112
                ],
                [
                    82.4513417,
                    54.3770123
                ],
                [
                    82.4499196,
                    54.3759393
                ],
                [
                    82.449661,
                    54.3741696
                ],
                [
                    82.4461058,
                    54.3738308
                ],
                [
                    82.4444898,
                    54.3743014
                ],
                [
                    82.4437788,
                    54.3740943
                ],
                [
                    82.4427122,
                    54.3734731
                ],
                [
                    82.4401589,
                    54.3728518
                ],
                [
                    82.4391246,
                    54.3732283
                ],
                [
                    82.437444,
                    54.3725882
                ],
                [
                    82.4373794,
                    54.3717222
                ],
                [
                    82.4355372,
                    54.3714586
                ],
                [
                    82.4345676,
                    54.3723246
                ],
                [
                    82.4344706,
                    54.3735672
                ],
                [
                    82.4283621,
                    54.3719858
                ],
                [
                    82.4279096,
                    54.3728518
                ],
                [
                    82.4299781,
                    54.3740755
                ],
                [
                    82.4252271,
                    54.3733978
                ],
                [
                    82.4238373,
                    54.374998
                ]
            ],
            "longitude": 82.444183,
            "latitude": 54.376579
        },
        "10048": {
            "name": "участок Нечунаевский",
            "population": 188,
            "type": "hamlet",
            "poly": [
                [
                    82.4401651,
                    53.8067482
                ],
                [
                    82.4447771,
                    53.8069542
                ],
                [
                    82.4518695,
                    53.8067253
                ],
                [
                    82.4528771,
                    53.8059701
                ],
                [
                    82.4515594,
                    53.8043451
                ],
                [
                    82.4518695,
                    53.8033381
                ],
                [
                    82.450513,
                    53.8017817
                ],
                [
                    82.4478001,
                    53.8001565
                ],
                [
                    82.4447384,
                    53.8017588
                ],
                [
                    82.4464436,
                    53.8045053
                ],
                [
                    82.440824,
                    53.8050546
                ],
                [
                    82.4401651,
                    53.8067482
                ]
            ],
            "longitude": 82.44883,
            "latitude": 53.804691
        },
        "10049": {
            "name": "Плоское",
            "population": 217,
            "type": "hamlet",
            "poly": [
                [
                    82.4431213,
                    54.2091737
                ],
                [
                    82.446875,
                    54.2104446
                ],
                [
                    82.451419,
                    54.2141995
                ],
                [
                    82.4579387,
                    54.2094048
                ],
                [
                    82.4650511,
                    54.2136796
                ],
                [
                    82.468953,
                    54.2143727
                ],
                [
                    82.4694469,
                    54.2133908
                ],
                [
                    82.4633717,
                    54.209347
                ],
                [
                    82.4594204,
                    54.2078449
                ],
                [
                    82.4615443,
                    54.2064873
                ],
                [
                    82.4602107,
                    54.2055629
                ],
                [
                    82.4551728,
                    54.2037429
                ],
                [
                    82.4539379,
                    54.204234
                ],
                [
                    82.4532465,
                    54.205014
                ],
                [
                    82.4480109,
                    54.2063717
                ],
                [
                    82.445739,
                    54.2059384
                ],
                [
                    82.4441091,
                    54.2076427
                ],
                [
                    82.4431213,
                    54.2091737
                ]
            ],
            "longitude": 82.451378,
            "latitude": 54.210903
        },
        "10050": {
            "name": "Кротово",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.465401,
            "latitude": 53.544064
        },
        "10051": {
            "name": "Татчиха",
            "population": 40,
            "type": "hamlet",
            "poly": [
                [
                    82.4700769,
                    54.3754739
                ],
                [
                    82.4712728,
                    54.3765658
                ],
                [
                    82.472404,
                    54.3772999
                ],
                [
                    82.4796437,
                    54.3792953
                ],
                [
                    82.4830373,
                    54.375568
                ],
                [
                    82.4808072,
                    54.3745703
                ],
                [
                    82.4824555,
                    54.3720852
                ],
                [
                    82.476347,
                    54.3709367
                ],
                [
                    82.4731797,
                    54.3723111
                ],
                [
                    82.4738907,
                    54.3731583
                ],
                [
                    82.4728241,
                    54.3747585
                ],
                [
                    82.4704648,
                    54.3741561
                ],
                [
                    82.4700769,
                    54.3754739
                ]
            ],
            "longitude": 82.472969,
            "latitude": 54.375408
        },
        "10052": {
            "name": "Ершовка",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.482895,
            "latitude": 55.835716
        },
        "10053": {
            "name": "Большая Черемшанка",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.498749,
            "latitude": 55.304138
        },
        "10054": {
            "name": "Клитенка",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    82.4989952,
                    54.1250913
                ],
                [
                    82.5024092,
                    54.1260666
                ],
                [
                    82.5039882,
                    54.124391
                ],
                [
                    82.5043723,
                    54.1235657
                ],
                [
                    82.5068475,
                    54.1191389
                ],
                [
                    82.5097494,
                    54.1125101
                ],
                [
                    82.5075729,
                    54.1121349
                ],
                [
                    82.5057379,
                    54.1157621
                ],
                [
                    82.5042016,
                    54.1157621
                ],
                [
                    82.5039882,
                    54.1163124
                ],
                [
                    82.5026226,
                    54.1162124
                ],
                [
                    82.5017691,
                    54.1185636
                ],
                [
                    82.5007022,
                    54.1199142
                ],
                [
                    82.5007876,
                    54.1210147
                ],
                [
                    82.5023666,
                    54.1213899
                ],
                [
                    82.4998487,
                    54.1237408
                ],
                [
                    82.4989952,
                    54.1250913
                ]
            ],
            "longitude": 82.504951,
            "latitude": 54.11797
        },
        "10055": {
            "name": "Чик",
            "population": 241,
            "type": "hamlet",
            "poly": [
                [
                    82.4951525,
                    55.0756118
                ],
                [
                    82.4998939,
                    55.0776418
                ],
                [
                    82.5011642,
                    55.0773193
                ],
                [
                    82.5030421,
                    55.0790266
                ],
                [
                    82.5019485,
                    55.0794124
                ],
                [
                    82.5029869,
                    55.0804051
                ],
                [
                    82.5023462,
                    55.0813725
                ],
                [
                    82.5031857,
                    55.0818468
                ],
                [
                    82.5041357,
                    55.0815875
                ],
                [
                    82.5067597,
                    55.0837839
                ],
                [
                    82.5035165,
                    55.0848096
                ],
                [
                    82.5063729,
                    55.0863187
                ],
                [
                    82.5054414,
                    55.0869002
                ],
                [
                    82.5085701,
                    55.0890176
                ],
                [
                    82.5072179,
                    55.0898301
                ],
                [
                    82.5133414,
                    55.0933452
                ],
                [
                    82.5143846,
                    55.0928834
                ],
                [
                    82.5169267,
                    55.0936564
                ],
                [
                    82.5201583,
                    55.0955907
                ],
                [
                    82.5223619,
                    55.0993767
                ],
                [
                    82.523664,
                    55.1013682
                ],
                [
                    82.5273147,
                    55.0999757
                ],
                [
                    82.5285315,
                    55.0980135
                ],
                [
                    82.5254341,
                    55.095798
                ],
                [
                    82.5241618,
                    55.0940572
                ],
                [
                    82.5215068,
                    55.092158
                ],
                [
                    82.5187964,
                    55.0903854
                ],
                [
                    82.5157542,
                    55.0908286
                ],
                [
                    82.514555,
                    55.09016
                ],
                [
                    82.5140169,
                    55.0871939
                ],
                [
                    82.5120256,
                    55.0853795
                ],
                [
                    82.5094489,
                    55.0840028
                ],
                [
                    82.509692,
                    55.0813789
                ],
                [
                    82.5083001,
                    55.0803356
                ],
                [
                    82.5072949,
                    55.0804936
                ],
                [
                    82.5042572,
                    55.0782425
                ],
                [
                    82.5023876,
                    55.0767612
                ],
                [
                    82.5026224,
                    55.0763976
                ],
                [
                    82.4981933,
                    55.0738906
                ],
                [
                    82.4951525,
                    55.0756118
                ]
            ],
            "longitude": 82.5114651,
            "latitude": 55.0884152
        },
        "10056": {
            "name": "Новоалександровка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.535347,
            "latitude": 56.168526
        },
        "10057": {
            "name": "Крохалёвка",
            "population": 254,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5444071,
            "latitude": 55.1460409
        },
        "10058": {
            "name": "Фёдоровский",
            "population": 37,
            "type": "hamlet",
            "poly": [
                [
                    82.5431093,
                    54.1610788
                ],
                [
                    82.5466497,
                    54.1616526
                ],
                [
                    82.5485779,
                    54.1606346
                ],
                [
                    82.5513596,
                    54.1536008
                ],
                [
                    82.5515493,
                    54.1523976
                ],
                [
                    82.5503164,
                    54.152268
                ],
                [
                    82.5514228,
                    54.150139
                ],
                [
                    82.5491469,
                    54.1492134
                ],
                [
                    82.5476927,
                    54.1491578
                ],
                [
                    82.5459226,
                    54.1527308
                ],
                [
                    82.5431093,
                    54.1610788
                ]
            ],
            "longitude": 82.549004,
            "latitude": 54.155708
        },
        "10059": {
            "name": "Новоосиновский",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.551086,
            "latitude": 53.822308
        },
        "10060": {
            "name": "Прогресс",
            "population": 196,
            "type": "hamlet",
            "poly": [
                [
                    82.5407296,
                    54.7002619
                ],
                [
                    82.5437653,
                    54.702211
                ],
                [
                    82.546548,
                    54.7027794
                ],
                [
                    82.5445523,
                    54.7048583
                ],
                [
                    82.5455361,
                    54.7055566
                ],
                [
                    82.5475318,
                    54.70606
                ],
                [
                    82.5523945,
                    54.7059139
                ],
                [
                    82.5586064,
                    54.7051181
                ],
                [
                    82.5608831,
                    54.7036564
                ],
                [
                    82.5603208,
                    54.7025683
                ],
                [
                    82.5521134,
                    54.7012852
                ],
                [
                    82.5483188,
                    54.7015775
                ],
                [
                    82.5466603,
                    54.7012202
                ],
                [
                    82.5467447,
                    54.6990112
                ],
                [
                    82.5432874,
                    54.6978905
                ],
                [
                    82.5419101,
                    54.6992874
                ],
                [
                    82.5407296,
                    54.7002619
                ]
            ],
            "longitude": 82.552589,
            "latitude": 54.703613
        },
        "10061": {
            "name": "Мальчиха",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.555786,
            "latitude": 55.848804
        },
        "10062": {
            "name": "Новоозерный",
            "population": 170,
            "type": "hamlet",
            "poly": [
                [
                    82.5551555,
                    54.962489
                ],
                [
                    82.5554006,
                    54.9632219
                ],
                [
                    82.5560616,
                    54.9634345
                ],
                [
                    82.5562839,
                    54.9656559
                ],
                [
                    82.5569335,
                    54.9657508
                ],
                [
                    82.557834,
                    54.9657344
                ],
                [
                    82.5596576,
                    54.9656952
                ],
                [
                    82.561259,
                    54.9652797
                ],
                [
                    82.5614812,
                    54.9647235
                ],
                [
                    82.5625241,
                    54.9646025
                ],
                [
                    82.5627634,
                    54.9643179
                ],
                [
                    82.5622449,
                    54.9632349
                ],
                [
                    82.5627862,
                    54.9630681
                ],
                [
                    82.5624329,
                    54.9625381
                ],
                [
                    82.5618743,
                    54.9618281
                ],
                [
                    82.5600393,
                    54.9618281
                ],
                [
                    82.55984,
                    54.9628292
                ],
                [
                    82.5585178,
                    54.9630648
                ],
                [
                    82.558079,
                    54.9628325
                ],
                [
                    82.5575547,
                    54.9622403
                ],
                [
                    82.5574522,
                    54.9618412
                ],
                [
                    82.5575148,
                    54.9612195
                ],
                [
                    82.5575433,
                    54.9600547
                ],
                [
                    82.5568709,
                    54.9598879
                ],
                [
                    82.5560218,
                    54.960624
                ],
                [
                    82.5552296,
                    54.9616187
                ],
                [
                    82.5551555,
                    54.962489
                ]
            ],
            "longitude": 82.5585814,
            "latitude": 54.9634368
        },
        "10063": {
            "name": "Кордон",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5740435,
            "latitude": 55.145526
        },
        "10064": {
            "name": "Дальняя Поляна",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.578308,
            "latitude": 56.039837
        },
        "10065": {
            "name": "Шипуновский",
            "population": 155,
            "type": "hamlet",
            "poly": [
                [
                    82.5815271,
                    53.958648
                ],
                [
                    82.5825124,
                    53.9614819
                ],
                [
                    82.5889713,
                    53.9678147
                ],
                [
                    82.5933503,
                    53.9701115
                ],
                [
                    82.5965615,
                    53.9713779
                ],
                [
                    82.5996997,
                    53.971571
                ],
                [
                    82.6031299,
                    53.9687163
                ],
                [
                    82.600612,
                    53.9655608
                ],
                [
                    82.5921096,
                    53.9587768
                ],
                [
                    82.5884604,
                    53.9581971
                ],
                [
                    82.5815271,
                    53.958648
                ]
            ],
            "longitude": 82.593071,
            "latitude": 53.965462
        },
        "10066": {
            "name": "Каменка",
            "population": 105,
            "type": "hamlet",
            "poly": [
                [
                    82.6072966,
                    54.3828662
                ],
                [
                    82.6075175,
                    54.383207
                ],
                [
                    82.6097925,
                    54.385355
                ],
                [
                    82.6106649,
                    54.3850785
                ],
                [
                    82.6110735,
                    54.3853743
                ],
                [
                    82.6108527,
                    54.3854837
                ],
                [
                    82.6108527,
                    54.3856444
                ],
                [
                    82.6117251,
                    54.3861782
                ],
                [
                    82.6113827,
                    54.3863454
                ],
                [
                    82.6125313,
                    54.3874643
                ],
                [
                    82.6123325,
                    54.3875672
                ],
                [
                    82.6122,
                    54.3874708
                ],
                [
                    82.6108085,
                    54.3879531
                ],
                [
                    82.6112833,
                    54.3884161
                ],
                [
                    82.6108747,
                    54.3886411
                ],
                [
                    82.61093,
                    54.3887688
                ],
                [
                    82.6112966,
                    54.3888568
                ],
                [
                    82.6103692,
                    54.389334
                ],
                [
                    82.6102397,
                    54.3896731
                ],
                [
                    82.6106496,
                    54.3904643
                ],
                [
                    82.6112966,
                    54.3907281
                ],
                [
                    82.6126969,
                    54.3899594
                ],
                [
                    82.616518,
                    54.388699
                ],
                [
                    82.6161314,
                    54.3883389
                ],
                [
                    82.6170481,
                    54.3880431
                ],
                [
                    82.6166615,
                    54.3876573
                ],
                [
                    82.6165069,
                    54.3876894
                ],
                [
                    82.6162198,
                    54.3874386
                ],
                [
                    82.616783,
                    54.387175
                ],
                [
                    82.6164186,
                    54.3868213
                ],
                [
                    82.6173352,
                    54.3864354
                ],
                [
                    82.6173904,
                    54.3866605
                ],
                [
                    82.6188923,
                    54.3868534
                ],
                [
                    82.6194003,
                    54.3867763
                ],
                [
                    82.6200408,
                    54.3863261
                ],
                [
                    82.6206151,
                    54.3863068
                ],
                [
                    82.6213108,
                    54.3865126
                ],
                [
                    82.6215538,
                    54.3862104
                ],
                [
                    82.6213881,
                    54.386146
                ],
                [
                    82.6219845,
                    54.3854065
                ],
                [
                    82.6210348,
                    54.3850978
                ],
                [
                    82.6230005,
                    54.3813548
                ],
                [
                    82.6226913,
                    54.3810075
                ],
                [
                    82.6215317,
                    54.3808338
                ],
                [
                    82.6214213,
                    54.3809432
                ],
                [
                    82.6210458,
                    54.380911
                ],
                [
                    82.6204384,
                    54.3814898
                ],
                [
                    82.6201071,
                    54.3821266
                ],
                [
                    82.6193451,
                    54.3825318
                ],
                [
                    82.6189807,
                    54.3828147
                ],
                [
                    82.6189144,
                    54.3831234
                ],
                [
                    82.6176002,
                    54.3832135
                ],
                [
                    82.617788,
                    54.38176
                ],
                [
                    82.6172247,
                    54.3807245
                ],
                [
                    82.6156566,
                    54.3811297
                ],
                [
                    82.6159658,
                    54.3816378
                ],
                [
                    82.6154467,
                    54.3817857
                ],
                [
                    82.6164075,
                    54.3831877
                ],
                [
                    82.6152259,
                    54.3829048
                ],
                [
                    82.6148173,
                    54.383072
                ],
                [
                    82.6147731,
                    54.383162
                ],
                [
                    82.613978,
                    54.3831942
                ],
                [
                    82.6128847,
                    54.3823645
                ],
                [
                    82.6126748,
                    54.3824803
                ],
                [
                    82.6124208,
                    54.3824417
                ],
                [
                    82.6115153,
                    54.38176
                ],
                [
                    82.6094612,
                    54.3824096
                ],
                [
                    82.6096268,
                    54.3825639
                ],
                [
                    82.6092403,
                    54.3826282
                ],
                [
                    82.6087102,
                    54.3821587
                ],
                [
                    82.6072966,
                    54.3828662
                ]
            ],
            "longitude": 82.614792,
            "latitude": 54.385868
        },
        "10067": {
            "name": "Павино",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.614917,
            "latitude": 55.0153017
        },
        "10068": {
            "name": "Озерки",
            "population": 113,
            "type": "hamlet",
            "poly": [
                [
                    82.6245952,
                    54.5086111
                ],
                [
                    82.6292791,
                    54.5100987
                ],
                [
                    82.6301608,
                    54.5106745
                ],
                [
                    82.6310149,
                    54.5118582
                ],
                [
                    82.6324201,
                    54.5118582
                ],
                [
                    82.6339079,
                    54.5121141
                ],
                [
                    82.6347344,
                    54.5110264
                ],
                [
                    82.6357814,
                    54.5110904
                ],
                [
                    82.6380683,
                    54.5107225
                ],
                [
                    82.6390602,
                    54.5100827
                ],
                [
                    82.6392806,
                    54.5090749
                ],
                [
                    82.6412368,
                    54.50258
                ],
                [
                    82.640796,
                    54.5012361
                ],
                [
                    82.6397214,
                    54.5004041
                ],
                [
                    82.6362223,
                    54.5004041
                ],
                [
                    82.6363325,
                    54.4993161
                ],
                [
                    82.6303261,
                    54.4993481
                ],
                [
                    82.6302159,
                    54.5011241
                ],
                [
                    82.6325027,
                    54.502724
                ],
                [
                    82.6324476,
                    54.5071074
                ],
                [
                    82.6314282,
                    54.5083391
                ],
                [
                    82.6247604,
                    54.5060516
                ],
                [
                    82.6245952,
                    54.5086111
                ]
            ],
            "longitude": 82.636215,
            "latitude": 54.509693
        },
        "10069": {
            "name": "Михайловка",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.637756,
            "latitude": 55.910797
        },
        "10070": {
            "name": "Марчиха",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.654015,
            "latitude": 55.922035
        },
        "10071": {
            "name": "Малый Оёш",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6551692,
            "latitude": 55.2756392
        },
        "10072": {
            "name": "Новоеловка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.66259,
            "latitude": 55.94643
        },
        "10073": {
            "name": "Северный",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.689835,
            "latitude": 56.016357
        },
        "10074": {
            "name": "Тропино",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.695381,
            "latitude": 55.533329
        },
        "10075": {
            "name": "Восход",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.699501,
            "latitude": 56.012108
        },
        "10076": {
            "name": "Тула",
            "population": 190,
            "type": "hamlet",
            "poly": [
                [
                    82.6879219,
                    54.5908641
                ],
                [
                    82.6927182,
                    54.5942416
                ],
                [
                    82.6951902,
                    54.5952676
                ],
                [
                    82.6962232,
                    54.5962722
                ],
                [
                    82.6978466,
                    54.5966356
                ],
                [
                    82.6995068,
                    54.5980676
                ],
                [
                    82.7002079,
                    54.597747
                ],
                [
                    82.7009826,
                    54.5970417
                ],
                [
                    82.7019788,
                    54.5969348
                ],
                [
                    82.7026798,
                    54.5962508
                ],
                [
                    82.7021264,
                    54.5951821
                ],
                [
                    82.7030856,
                    54.5943057
                ],
                [
                    82.7032522,
                    54.5943002
                ],
                [
                    82.7043769,
                    54.594263
                ],
                [
                    82.7046721,
                    54.5938568
                ],
                [
                    82.714191,
                    54.596657
                ],
                [
                    82.7126045,
                    54.5951821
                ],
                [
                    82.7158881,
                    54.5929377
                ],
                [
                    82.7144492,
                    54.5910565
                ],
                [
                    82.7131948,
                    54.5903938
                ],
                [
                    82.7100587,
                    54.5896884
                ],
                [
                    82.7077713,
                    54.5894105
                ],
                [
                    82.7023846,
                    54.5848353
                ],
                [
                    82.6987321,
                    54.5856691
                ],
                [
                    82.6976252,
                    54.5867381
                ],
                [
                    82.6947843,
                    54.5874009
                ],
                [
                    82.6917958,
                    54.5885553
                ],
                [
                    82.6910948,
                    54.5892394
                ],
                [
                    82.6902463,
                    54.5889401
                ],
                [
                    82.6886967,
                    54.5892181
                ],
                [
                    82.6892132,
                    54.5903511
                ],
                [
                    82.6879219,
                    54.5908641
                ]
            ],
            "longitude": 82.700768,
            "latitude": 54.592125
        },
        "10077": {
            "name": "Сибиряк",
            "population": 101,
            "type": "hamlet",
            "poly": [
                [
                    82.7255552,
                    54.161824
                ],
                [
                    82.7282721,
                    54.1622702
                ],
                [
                    82.7308841,
                    54.1622135
                ],
                [
                    82.7338601,
                    54.1601761
                ],
                [
                    82.729428,
                    54.1587549
                ],
                [
                    82.7263677,
                    54.1599289
                ],
                [
                    82.7255552,
                    54.161824
                ]
            ],
            "longitude": 82.7304,
            "latitude": 54.160465
        },
        "10078": {
            "name": "Алексеевский",
            "population": 174,
            "type": "hamlet",
            "poly": [
                [
                    82.7261645,
                    54.3047225
                ],
                [
                    82.7272445,
                    54.3052306
                ],
                [
                    82.7270522,
                    54.3053494
                ],
                [
                    82.7275215,
                    54.3056793
                ],
                [
                    82.7278834,
                    54.3054549
                ],
                [
                    82.7282113,
                    54.3056166
                ],
                [
                    82.7277138,
                    54.3059729
                ],
                [
                    82.7284262,
                    54.3062863
                ],
                [
                    82.7286637,
                    54.306151
                ],
                [
                    82.7291782,
                    54.3063721
                ],
                [
                    82.7294044,
                    54.3062203
                ],
                [
                    82.7295062,
                    54.30625
                ],
                [
                    82.7298737,
                    54.306029
                ],
                [
                    82.7308462,
                    54.3064084
                ],
                [
                    82.7305466,
                    54.3066129
                ],
                [
                    82.7307784,
                    54.3067053
                ],
                [
                    82.7306823,
                    54.3068009
                ],
                [
                    82.7315926,
                    54.3071737
                ],
                [
                    82.7313777,
                    54.3072727
                ],
                [
                    82.7322372,
                    54.3076587
                ],
                [
                    82.7326839,
                    54.3072529
                ],
                [
                    82.7347364,
                    54.308104
                ],
                [
                    82.734314,
                    54.3084951
                ],
                [
                    82.7377435,
                    54.309678
                ],
                [
                    82.7389098,
                    54.3094273
                ],
                [
                    82.7393612,
                    54.3090488
                ],
                [
                    82.7401377,
                    54.3086587
                ],
                [
                    82.7405409,
                    54.308126
                ],
                [
                    82.7407416,
                    54.3076646
                ],
                [
                    82.7431142,
                    54.3059279
                ],
                [
                    82.7434809,
                    54.3047072
                ],
                [
                    82.7432221,
                    54.3042793
                ],
                [
                    82.7425966,
                    54.304166
                ],
                [
                    82.7397034,
                    54.3029384
                ],
                [
                    82.7398536,
                    54.3028198
                ],
                [
                    82.7393412,
                    54.3025827
                ],
                [
                    82.7390938,
                    54.3027115
                ],
                [
                    82.738873,
                    54.3025053
                ],
                [
                    82.7378923,
                    54.3021496
                ],
                [
                    82.7380602,
                    54.3020156
                ],
                [
                    82.7374947,
                    54.3017888
                ],
                [
                    82.7371943,
                    54.3020053
                ],
                [
                    82.7366112,
                    54.3017681
                ],
                [
                    82.736894,
                    54.3015104
                ],
                [
                    82.7363462,
                    54.3013042
                ],
                [
                    82.7365052,
                    54.3011907
                ],
                [
                    82.7359575,
                    54.3009742
                ],
                [
                    82.7357454,
                    54.301098
                ],
                [
                    82.7345439,
                    54.3007216
                ],
                [
                    82.7342965,
                    54.3009021
                ],
                [
                    82.7323087,
                    54.2999225
                ],
                [
                    82.7268771,
                    54.3041446
                ],
                [
                    82.7266395,
                    54.3041452
                ],
                [
                    82.7264302,
                    54.3043036
                ],
                [
                    82.7265999,
                    54.3043959
                ],
                [
                    82.7261645,
                    54.3047225
                ]
            ],
            "longitude": 82.73555,
            "latitude": 54.305016
        },
        "10079": {
            "name": "Малиновка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.73555,
            "latitude": 56.028606
        },
        "10080": {
            "name": "Паутовский",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.756302,
            "latitude": 55.568367
        },
        "10081": {
            "name": "Паутово",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.758049,
            "latitude": 55.544334
        },
        "10082": {
            "name": "Подгорная",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.763222,
            "latitude": 55.327274
        },
        "10083": {
            "name": "Катковский",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    82.7659476,
                    55.169608
                ],
                [
                    82.766916,
                    55.1772349
                ],
                [
                    82.7684569,
                    55.1781979
                ],
                [
                    82.7728126,
                    55.1758045
                ],
                [
                    82.7754767,
                    55.1737081
                ],
                [
                    82.7770792,
                    55.1741657
                ],
                [
                    82.7776613,
                    55.1733131
                ],
                [
                    82.7774216,
                    55.172879
                ],
                [
                    82.7765108,
                    55.1720615
                ],
                [
                    82.7716963,
                    55.1698907
                ],
                [
                    82.7686692,
                    55.1691905
                ],
                [
                    82.7660051,
                    55.1695582
                ],
                [
                    82.7659476,
                    55.169608
                ]
            ],
            "longitude": 82.772748,
            "latitude": 55.173083
        },
        "10084": {
            "name": "Воробьевский",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    82.7683924,
                    55.1600462
                ],
                [
                    82.7731521,
                    55.1659389
                ],
                [
                    82.7760649,
                    55.1674034
                ],
                [
                    82.777715,
                    55.1673325
                ],
                [
                    82.7781944,
                    55.1664035
                ],
                [
                    82.7781173,
                    55.1661052
                ],
                [
                    82.7778691,
                    55.1660758
                ],
                [
                    82.7777835,
                    55.1658216
                ],
                [
                    82.777929,
                    55.1657825
                ],
                [
                    82.7777885,
                    55.1649989
                ],
                [
                    82.7777464,
                    55.1645262
                ],
                [
                    82.7772275,
                    55.1635808
                ],
                [
                    82.7761966,
                    55.1635548
                ],
                [
                    82.7749903,
                    55.1619022
                ],
                [
                    82.7734125,
                    55.1615898
                ],
                [
                    82.7730408,
                    55.161716
                ],
                [
                    82.7691626,
                    55.1595966
                ],
                [
                    82.7683924,
                    55.1600462
                ]
            ],
            "longitude": 82.7736398,
            "latitude": 55.164444
        },
        "10085": {
            "name": "Чаус",
            "population": 121,
            "type": "hamlet",
            "poly": [
                [
                    82.7727657,
                    55.333786
                ],
                [
                    82.7763352,
                    55.3360963
                ],
                [
                    82.7760275,
                    55.3374315
                ],
                [
                    82.7762209,
                    55.3380015
                ],
                [
                    82.7745944,
                    55.3383365
                ],
                [
                    82.7745505,
                    55.3385965
                ],
                [
                    82.7747615,
                    55.3394315
                ],
                [
                    82.7753417,
                    55.3406165
                ],
                [
                    82.7761154,
                    55.3410065
                ],
                [
                    82.7766517,
                    55.3428314
                ],
                [
                    82.7768891,
                    55.3429364
                ],
                [
                    82.7771265,
                    55.3434364
                ],
                [
                    82.7776101,
                    55.3434964
                ],
                [
                    82.7778474,
                    55.3442163
                ],
                [
                    82.7767924,
                    55.3442913
                ],
                [
                    82.7767572,
                    55.3445413
                ],
                [
                    82.7761946,
                    55.3446163
                ],
                [
                    82.7763001,
                    55.3452162
                ],
                [
                    82.7749549,
                    55.3453662
                ],
                [
                    82.7754824,
                    55.3462461
                ],
                [
                    82.776854,
                    55.3479508
                ],
                [
                    82.7800806,
                    55.3508751
                ],
                [
                    82.781329,
                    55.3517998
                ],
                [
                    82.7817423,
                    55.3523596
                ],
                [
                    82.7816719,
                    55.3531394
                ],
                [
                    82.7815049,
                    55.3540241
                ],
                [
                    82.781584,
                    55.354354
                ],
                [
                    82.7832193,
                    55.3544689
                ],
                [
                    82.7833951,
                    55.3538341
                ],
                [
                    82.7834945,
                    55.353838
                ],
                [
                    82.7841628,
                    55.3538635
                ],
                [
                    82.7840666,
                    55.3517392
                ],
                [
                    82.7840391,
                    55.3504427
                ],
                [
                    82.7832286,
                    55.347498
                ],
                [
                    82.7827478,
                    55.3463732
                ],
                [
                    82.7827478,
                    55.3456546
                ],
                [
                    82.7816626,
                    55.3434908
                ],
                [
                    82.7815664,
                    55.3427564
                ],
                [
                    82.78044,
                    55.3390456
                ],
                [
                    82.7803713,
                    55.3381784
                ],
                [
                    82.7797256,
                    55.3368189
                ],
                [
                    82.7787777,
                    55.3355375
                ],
                [
                    82.7785717,
                    55.3349203
                ],
                [
                    82.7789288,
                    55.3332247
                ],
                [
                    82.7794509,
                    55.3317166
                ],
                [
                    82.7727657,
                    55.333786
                ]
            ],
            "longitude": 82.780052,
            "latitude": 55.343563
        },
        "10086": {
            "name": "Красный Восток",
            "population": 175,
            "type": "hamlet",
            "poly": [
                [
                    82.8080527,
                    54.9219009
                ],
                [
                    82.8094936,
                    54.9249958
                ],
                [
                    82.810371,
                    54.9270953
                ],
                [
                    82.8132109,
                    54.9317632
                ],
                [
                    82.8133354,
                    54.9321459
                ],
                [
                    82.813917,
                    54.9325941
                ],
                [
                    82.8145352,
                    54.9328152
                ],
                [
                    82.8147685,
                    54.9331156
                ],
                [
                    82.8148295,
                    54.9334831
                ],
                [
                    82.8154864,
                    54.9342465
                ],
                [
                    82.8171462,
                    54.9337759
                ],
                [
                    82.8174608,
                    54.9339294
                ],
                [
                    82.81877,
                    54.9338773
                ],
                [
                    82.8187704,
                    54.9322867
                ],
                [
                    82.8183181,
                    54.9315568
                ],
                [
                    82.8184941,
                    54.930151
                ],
                [
                    82.8182286,
                    54.9295378
                ],
                [
                    82.8181416,
                    54.9280643
                ],
                [
                    82.8166832,
                    54.9275388
                ],
                [
                    82.8163953,
                    54.9265353
                ],
                [
                    82.8146172,
                    54.9241425
                ],
                [
                    82.813688,
                    54.921857
                ],
                [
                    82.8104399,
                    54.9215699
                ],
                [
                    82.8080527,
                    54.9219009
                ]
            ],
            "longitude": 82.81344,
            "latitude": 54.9283501
        },
        "10087": {
            "name": "Охотхозяйство",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.816696,
            "latitude": 55.428684
        },
        "10088": {
            "name": "Орловский",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.844582,
            "latitude": 55.577835
        },
        "10089": {
            "name": "Седова Заимка",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    82.84712,
                    55.3661737
                ],
                [
                    82.8475854,
                    55.3679873
                ],
                [
                    82.8489162,
                    55.3705465
                ],
                [
                    82.8500935,
                    55.3734377
                ],
                [
                    82.8490959,
                    55.3762242
                ],
                [
                    82.8503269,
                    55.376479
                ],
                [
                    82.8507779,
                    55.3740843
                ],
                [
                    82.8508505,
                    55.3727687
                ],
                [
                    82.8507804,
                    55.3723067
                ],
                [
                    82.8508365,
                    55.3718686
                ],
                [
                    82.849428,
                    55.3696547
                ],
                [
                    82.8486851,
                    55.3685316
                ],
                [
                    82.8491176,
                    55.3670115
                ],
                [
                    82.8500323,
                    55.3662324
                ],
                [
                    82.8508916,
                    55.3656797
                ],
                [
                    82.8521181,
                    55.364796
                ],
                [
                    82.851439,
                    55.3636135
                ],
                [
                    82.8497309,
                    55.3631031
                ],
                [
                    82.8477852,
                    55.3635515
                ],
                [
                    82.84712,
                    55.3661737
                ]
            ],
            "longitude": 82.84922,
            "latitude": 55.364975
        },
        "10090": {
            "name": "Целинный",
            "population": 146,
            "type": "hamlet",
            "poly": [
                [
                    82.8493957,
                    54.369406
                ],
                [
                    82.8505144,
                    54.3699347
                ],
                [
                    82.8503455,
                    54.3700454
                ],
                [
                    82.8506621,
                    54.3702175
                ],
                [
                    82.8511289,
                    54.3703222
                ],
                [
                    82.851077,
                    54.370433
                ],
                [
                    82.8514833,
                    54.3706143
                ],
                [
                    82.8518724,
                    54.3703172
                ],
                [
                    82.8523392,
                    54.3705539
                ],
                [
                    82.8520626,
                    54.3707553
                ],
                [
                    82.8527369,
                    54.3710676
                ],
                [
                    82.8526072,
                    54.3712187
                ],
                [
                    82.8534718,
                    54.3716719
                ],
                [
                    82.8536101,
                    54.3715964
                ],
                [
                    82.8539473,
                    54.3717475
                ],
                [
                    82.8549674,
                    54.3720345
                ],
                [
                    82.8556245,
                    54.3715611
                ],
                [
                    82.8568464,
                    54.3722585
                ],
                [
                    82.8584928,
                    54.3715085
                ],
                [
                    82.8616588,
                    54.3728364
                ],
                [
                    82.8621865,
                    54.3723692
                ],
                [
                    82.8610889,
                    54.3718282
                ],
                [
                    82.8630308,
                    54.3701191
                ],
                [
                    82.8623131,
                    54.3695535
                ],
                [
                    82.8611101,
                    54.3691723
                ],
                [
                    82.8599281,
                    54.3684838
                ],
                [
                    82.8590838,
                    54.3684346
                ],
                [
                    82.8587461,
                    54.3684838
                ],
                [
                    82.8576907,
                    54.3675738
                ],
                [
                    82.8570786,
                    54.3674509
                ],
                [
                    82.8569098,
                    54.3671926
                ],
                [
                    82.8559811,
                    54.367082
                ],
                [
                    82.8554956,
                    54.3667868
                ],
                [
                    82.8549679,
                    54.3667991
                ],
                [
                    82.8549046,
                    54.366504
                ],
                [
                    82.8544191,
                    54.3663933
                ],
                [
                    82.8528994,
                    54.3667008
                ],
                [
                    82.8521607,
                    54.3671066
                ],
                [
                    82.8513164,
                    54.3666762
                ],
                [
                    82.8504721,
                    54.3672787
                ],
                [
                    82.8519074,
                    54.3680411
                ],
                [
                    82.8516119,
                    54.3682501
                ],
                [
                    82.8519285,
                    54.36841
                ],
                [
                    82.8512742,
                    54.3686682
                ],
                [
                    82.8508099,
                    54.3684961
                ],
                [
                    82.8493957,
                    54.369406
                ]
            ],
            "longitude": 82.855972,
            "latitude": 54.36953
        },
        "10091": {
            "name": "Бибиха",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.865425,
            "latitude": 55.325504
        },
        "10092": {
            "name": "Виноград",
            "population": 242,
            "type": "hamlet",
            "poly": [
                [
                    82.8720563,
                    54.0163785
                ],
                [
                    82.8721583,
                    54.0180855
                ],
                [
                    82.8737892,
                    54.018355
                ],
                [
                    82.8731369,
                    54.0217386
                ],
                [
                    82.8756853,
                    54.022583
                ],
                [
                    82.8808229,
                    54.0111675
                ],
                [
                    82.8802622,
                    54.0108979
                ],
                [
                    82.8720563,
                    54.0163785
                ]
            ],
            "longitude": 82.876114,
            "latitude": 54.017254
        },
        "10093": {
            "name": "Зелёный Мыс",
            "population": 212,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.890984,
            "latitude": 55.295609
        },
        "10094": {
            "name": "Бобровицкий",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    82.89714,
                    54.2866595
                ],
                [
                    82.8994517,
                    54.2940689
                ],
                [
                    82.9015674,
                    54.2938059
                ],
                [
                    82.903017,
                    54.2918165
                ],
                [
                    82.9011756,
                    54.28762
                ],
                [
                    82.8995496,
                    54.2855388
                ],
                [
                    82.89714,
                    54.2866595
                ]
            ],
            "longitude": 82.900597,
            "latitude": 54.290173
        },
        "10095": {
            "name": "Бородавкино",
            "population": 242,
            "type": "hamlet",
            "poly": [
                [
                    82.8956207,
                    54.4832846
                ],
                [
                    82.8976596,
                    54.4844531
                ],
                [
                    82.8985688,
                    54.4840209
                ],
                [
                    82.899175,
                    54.4844531
                ],
                [
                    82.898927,
                    54.4846131
                ],
                [
                    82.8995607,
                    54.4849332
                ],
                [
                    82.899637,
                    54.4851841
                ],
                [
                    82.9006628,
                    54.4859576
                ],
                [
                    82.9019853,
                    54.4865338
                ],
                [
                    82.9019853,
                    54.4868219
                ],
                [
                    82.9032527,
                    54.4875261
                ],
                [
                    82.903666,
                    54.487334
                ],
                [
                    82.9041895,
                    54.4875741
                ],
                [
                    82.9041344,
                    54.4877501
                ],
                [
                    82.9037487,
                    54.4878622
                ],
                [
                    82.9037487,
                    54.4880862
                ],
                [
                    82.904465,
                    54.4885183
                ],
                [
                    82.9049634,
                    54.489124
                ],
                [
                    82.9051814,
                    54.4893345
                ],
                [
                    82.9068896,
                    54.4907749
                ],
                [
                    82.9080744,
                    54.491319
                ],
                [
                    82.9101959,
                    54.4919431
                ],
                [
                    82.9118766,
                    54.4927432
                ],
                [
                    82.9117664,
                    54.4929192
                ],
                [
                    82.9121797,
                    54.4930793
                ],
                [
                    82.9117664,
                    54.4934793
                ],
                [
                    82.9126756,
                    54.4936874
                ],
                [
                    82.9138603,
                    54.4936874
                ],
                [
                    82.9147696,
                    54.4930633
                ],
                [
                    82.9160645,
                    54.4933513
                ],
                [
                    82.9164503,
                    54.4924392
                ],
                [
                    82.9148522,
                    54.491431
                ],
                [
                    82.9149894,
                    54.490608
                ],
                [
                    82.914909,
                    54.4902223
                ],
                [
                    82.9140404,
                    54.4891722
                ],
                [
                    82.9128554,
                    54.4881168
                ],
                [
                    82.9125733,
                    54.4881627
                ],
                [
                    82.9124604,
                    54.4879267
                ],
                [
                    82.9113093,
                    54.4873236
                ],
                [
                    82.9121106,
                    54.4867926
                ],
                [
                    82.9108353,
                    54.485901
                ],
                [
                    82.9106886,
                    54.485606
                ],
                [
                    82.9093795,
                    54.4849176
                ],
                [
                    82.9087927,
                    54.4846685
                ],
                [
                    82.9077883,
                    54.4852389
                ],
                [
                    82.9047412,
                    54.4835671
                ],
                [
                    82.9037368,
                    54.484144
                ],
                [
                    82.903229,
                    54.4841768
                ],
                [
                    82.9028791,
                    54.4839605
                ],
                [
                    82.902518,
                    54.484144
                ],
                [
                    82.9020214,
                    54.4838425
                ],
                [
                    82.902597,
                    54.4834819
                ],
                [
                    82.9021004,
                    54.4831147
                ],
                [
                    82.9023487,
                    54.4829181
                ],
                [
                    82.9019989,
                    54.4827214
                ],
                [
                    82.9011412,
                    54.4832393
                ],
                [
                    82.9004189,
                    54.4828722
                ],
                [
                    82.9009267,
                    54.4825509
                ],
                [
                    82.9003625,
                    54.4823411
                ],
                [
                    82.8996679,
                    54.4827545
                ],
                [
                    82.8979248,
                    54.482092
                ],
                [
                    82.8956207,
                    54.4832846
                ]
            ],
            "longitude": 82.908249,
            "latitude": 54.488159
        },
        "10096": {
            "name": "Октябрьский",
            "population": 129,
            "type": "hamlet",
            "poly": [
                [
                    82.9046781,
                    54.4440821
                ],
                [
                    82.9051189,
                    54.4443692
                ],
                [
                    82.9046957,
                    54.4446358
                ],
                [
                    82.9087691,
                    54.446871
                ],
                [
                    82.9132479,
                    54.4440718
                ],
                [
                    82.9139886,
                    54.4433335
                ],
                [
                    82.9140944,
                    54.4429644
                ],
                [
                    82.9160693,
                    54.4434463
                ],
                [
                    82.9168981,
                    54.4429131
                ],
                [
                    82.9141649,
                    54.4418569
                ],
                [
                    82.9145528,
                    54.4414365
                ],
                [
                    82.9136359,
                    54.4410058
                ],
                [
                    82.9125602,
                    54.4404623
                ],
                [
                    82.909157,
                    54.4406264
                ],
                [
                    82.9079579,
                    54.4415596
                ],
                [
                    82.9082929,
                    54.4417134
                ],
                [
                    82.9054892,
                    54.4439078
                ],
                [
                    82.9049426,
                    54.4438565
                ],
                [
                    82.9046781,
                    54.4440821
                ]
            ],
            "longitude": 82.908577,
            "latitude": 54.443913
        },
        "10097": {
            "name": "Юрт-Ора",
            "population": 51,
            "type": "hamlet",
            "poly": [
                [
                    82.9028449,
                    55.4459855
                ],
                [
                    82.9135353,
                    55.4499591
                ],
                [
                    82.9193777,
                    55.4493215
                ],
                [
                    82.9174091,
                    55.4474376
                ],
                [
                    82.9177997,
                    55.4452466
                ],
                [
                    82.9132226,
                    55.4439481
                ],
                [
                    82.9086217,
                    55.4453964
                ],
                [
                    82.9043011,
                    55.4450863
                ],
                [
                    82.9028449,
                    55.4459855
                ]
            ],
            "longitude": 82.912888,
            "latitude": 55.447243
        },
        "10098": {
            "name": "Голубой Залив",
            "population": 238,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.9191027,
            "latitude": 54.8421088
        },
        "10099": {
            "name": "Гилево",
            "population": 108,
            "type": "hamlet",
            "poly": [
                [
                    82.929687,
                    54.3485062
                ],
                [
                    82.9320536,
                    54.3500305
                ],
                [
                    82.9327687,
                    54.3502016
                ],
                [
                    82.9336026,
                    54.3497131
                ],
                [
                    82.9342315,
                    54.3499252
                ],
                [
                    82.9344311,
                    54.3500683
                ],
                [
                    82.9347986,
                    54.3502698
                ],
                [
                    82.934161,
                    54.3506666
                ],
                [
                    82.9332856,
                    54.3502572
                ],
                [
                    82.9326264,
                    54.350717
                ],
                [
                    82.9334693,
                    54.3510949
                ],
                [
                    82.9331992,
                    54.3513469
                ],
                [
                    82.9334369,
                    54.351561
                ],
                [
                    82.9336747,
                    54.3515484
                ],
                [
                    82.934604,
                    54.3523987
                ],
                [
                    82.9354362,
                    54.352046
                ],
                [
                    82.9357168,
                    54.3520429
                ],
                [
                    82.9363717,
                    54.3521631
                ],
                [
                    82.9370888,
                    54.3507684
                ],
                [
                    82.9367076,
                    54.3504112
                ],
                [
                    82.9366964,
                    54.3503343
                ],
                [
                    82.936983,
                    54.3500452
                ],
                [
                    82.9381595,
                    54.3502698
                ],
                [
                    82.938354,
                    54.350125
                ],
                [
                    82.9379758,
                    54.349873
                ],
                [
                    82.9392834,
                    54.3491613
                ],
                [
                    82.9410665,
                    54.3499297
                ],
                [
                    82.9406018,
                    54.3501817
                ],
                [
                    82.9414015,
                    54.3509375
                ],
                [
                    82.9418662,
                    54.3510131
                ],
                [
                    82.941315,
                    54.351265
                ],
                [
                    82.9422336,
                    54.3518066
                ],
                [
                    82.9429036,
                    54.3517437
                ],
                [
                    82.9432711,
                    54.3519704
                ],
                [
                    82.9435953,
                    54.351983
                ],
                [
                    82.9439087,
                    54.35175
                ],
                [
                    82.944152,
                    54.3516723
                ],
                [
                    82.9437278,
                    54.3512196
                ],
                [
                    82.9436061,
                    54.3510697
                ],
                [
                    82.9442437,
                    54.3511894
                ],
                [
                    82.9449353,
                    54.3509753
                ],
                [
                    82.9439735,
                    54.3500998
                ],
                [
                    82.945065,
                    54.3497471
                ],
                [
                    82.943498,
                    54.3482858
                ],
                [
                    82.9441896,
                    54.3480464
                ],
                [
                    82.9449628,
                    54.3475783
                ],
                [
                    82.9446489,
                    54.347153
                ],
                [
                    82.9440097,
                    54.3467563
                ],
                [
                    82.9410989,
                    54.3456024
                ],
                [
                    82.9406991,
                    54.3460811
                ],
                [
                    82.9384729,
                    54.3459929
                ],
                [
                    82.9380406,
                    54.3461819
                ],
                [
                    82.9369167,
                    54.3460181
                ],
                [
                    82.9332964,
                    54.3461
                ],
                [
                    82.9324103,
                    54.3466418
                ],
                [
                    82.9300436,
                    54.347763
                ],
                [
                    82.9296978,
                    54.3481724
                ],
                [
                    82.929687,
                    54.3485062
                ]
            ],
            "longitude": 82.937126,
            "latitude": 54.348763
        },
        "10100": {
            "name": "Таловка",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.949509,
            "latitude": 55.584518
        },
        "10101": {
            "name": "Чупино",
            "population": 228,
            "type": "hamlet",
            "poly": [
                [
                    82.9407756,
                    54.5287387
                ],
                [
                    82.9438129,
                    54.53002
                ],
                [
                    82.9441863,
                    54.5305279
                ],
                [
                    82.9456597,
                    54.5307337
                ],
                [
                    82.945878,
                    54.5303379
                ],
                [
                    82.9461509,
                    54.5306546
                ],
                [
                    82.9476493,
                    54.5305951
                ],
                [
                    82.9484863,
                    54.5307737
                ],
                [
                    82.9502165,
                    54.5313037
                ],
                [
                    82.951226,
                    54.5313512
                ],
                [
                    82.9539819,
                    54.5313829
                ],
                [
                    82.955046,
                    54.5307812
                ],
                [
                    82.9560829,
                    54.5293879
                ],
                [
                    82.9562739,
                    54.5283112
                ],
                [
                    82.9554826,
                    54.5281687
                ],
                [
                    82.9568196,
                    54.5267753
                ],
                [
                    82.9569833,
                    54.5263477
                ],
                [
                    82.9589206,
                    54.5258093
                ],
                [
                    82.9596846,
                    54.525366
                ],
                [
                    82.9564922,
                    54.5232915
                ],
                [
                    82.9576382,
                    54.5225472
                ],
                [
                    82.9602849,
                    54.5211219
                ],
                [
                    82.9621949,
                    54.5192056
                ],
                [
                    82.9619767,
                    54.5186988
                ],
                [
                    82.9633409,
                    54.5182395
                ],
                [
                    82.9639685,
                    54.5175743
                ],
                [
                    82.9628771,
                    54.5159746
                ],
                [
                    82.9630954,
                    54.5157371
                ],
                [
                    82.9625497,
                    54.5154836
                ],
                [
                    82.9606396,
                    54.5160697
                ],
                [
                    82.9608852,
                    54.5171309
                ],
                [
                    82.9601212,
                    54.5175268
                ],
                [
                    82.9591116,
                    54.5176694
                ],
                [
                    82.9570925,
                    54.5196332
                ],
                [
                    82.9548474,
                    54.519728
                ],
                [
                    82.9543639,
                    54.5197441
                ],
                [
                    82.952563,
                    54.5202667
                ],
                [
                    82.9508167,
                    54.5213595
                ],
                [
                    82.9494252,
                    54.5223888
                ],
                [
                    82.9497253,
                    54.5229906
                ],
                [
                    82.9501892,
                    54.5233073
                ],
                [
                    82.9486533,
                    54.5235199
                ],
                [
                    82.9476893,
                    54.5233172
                ],
                [
                    82.9472563,
                    54.5233659
                ],
                [
                    82.9461247,
                    54.5231956
                ],
                [
                    82.9447276,
                    54.5231551
                ],
                [
                    82.9432468,
                    54.5232524
                ],
                [
                    82.9430093,
                    54.5236983
                ],
                [
                    82.9441828,
                    54.5242983
                ],
                [
                    82.9438615,
                    54.5244037
                ],
                [
                    82.9441129,
                    54.5248334
                ],
                [
                    82.9436519,
                    54.5250361
                ],
                [
                    82.943135,
                    54.5250766
                ],
                [
                    82.942674,
                    54.5253766
                ],
                [
                    82.9421291,
                    54.5255712
                ],
                [
                    82.9415005,
                    54.5262684
                ],
                [
                    82.9417939,
                    54.5268035
                ],
                [
                    82.9415983,
                    54.5271035
                ],
                [
                    82.9411512,
                    54.5274359
                ],
                [
                    82.941235,
                    54.5280277
                ],
                [
                    82.9407756,
                    54.5287387
                ]
            ],
            "longitude": 82.952698,
            "latitude": 54.525436
        },
        "10102": {
            "name": "Чащино",
            "population": 120,
            "type": "hamlet",
            "poly": [
                [
                    82.948296,
                    54.058399
                ],
                [
                    82.9485641,
                    54.0608254
                ],
                [
                    82.9581381,
                    54.0615781
                ],
                [
                    82.9613748,
                    54.0582052
                ],
                [
                    82.9523914,
                    54.0570808
                ],
                [
                    82.948296,
                    54.058399
                ]
            ],
            "longitude": 82.95488,
            "latitude": 54.05946
        },
        "10103": {
            "name": "Ломовская Дача",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    82.9530307,
                    55.2140568
                ],
                [
                    82.9531598,
                    55.2147927
                ],
                [
                    82.9535037,
                    55.2152189
                ],
                [
                    82.954163,
                    55.2155285
                ],
                [
                    82.9549082,
                    55.2158637
                ],
                [
                    82.9553524,
                    55.2155448
                ],
                [
                    82.956069,
                    55.2148989
                ],
                [
                    82.9570005,
                    55.2146782
                ],
                [
                    82.9576024,
                    55.2140568
                ],
                [
                    82.9586628,
                    55.2143021
                ],
                [
                    82.959193,
                    55.2138361
                ],
                [
                    82.9606261,
                    55.2137134
                ],
                [
                    82.9605258,
                    55.2134273
                ],
                [
                    82.9600243,
                    55.2126342
                ],
                [
                    82.960182,
                    55.2122335
                ],
                [
                    82.9582473,
                    55.2117593
                ],
                [
                    82.9573015,
                    55.2110725
                ],
                [
                    82.9567354,
                    55.2109768
                ],
                [
                    82.9561406,
                    55.2108762
                ],
                [
                    82.9545641,
                    55.2114241
                ],
                [
                    82.9538047,
                    55.2129449
                ],
                [
                    82.9530307,
                    55.2140568
                ]
            ],
            "longitude": 82.9554528,
            "latitude": 55.2132474
        },
        "10104": {
            "name": "Пристань-Почта",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.975029,
            "latitude": 55.454838
        },
        "10105": {
            "name": "Берёзовка",
            "population": 208,
            "type": "hamlet",
            "poly": [
                [
                    82.9853738,
                    54.4806812
                ],
                [
                    82.9854059,
                    54.4808699
                ],
                [
                    82.9881109,
                    54.4828179
                ],
                [
                    82.9867879,
                    54.4841147
                ],
                [
                    82.9883182,
                    54.4850446
                ],
                [
                    82.9896778,
                    54.4845141
                ],
                [
                    82.9908622,
                    54.4850156
                ],
                [
                    82.9919553,
                    54.4856461
                ],
                [
                    82.9923457,
                    54.4859247
                ],
                [
                    82.9942874,
                    54.4872497
                ],
                [
                    82.9961657,
                    54.4858232
                ],
                [
                    82.9958385,
                    54.4855097
                ],
                [
                    82.9963403,
                    54.4850751
                ],
                [
                    82.9947032,
                    54.4836675
                ],
                [
                    82.9949651,
                    54.4835787
                ],
                [
                    82.9953362,
                    54.4839211
                ],
                [
                    82.995991,
                    54.4837436
                ],
                [
                    82.9958819,
                    54.4830588
                ],
                [
                    82.9936554,
                    54.4810932
                ],
                [
                    82.992171,
                    54.4803703
                ],
                [
                    82.9916189,
                    54.480434
                ],
                [
                    82.9912761,
                    54.480662
                ],
                [
                    82.9907303,
                    54.4802308
                ],
                [
                    82.9902283,
                    54.480421
                ],
                [
                    82.9900318,
                    54.4803322
                ],
                [
                    82.9895286,
                    54.4802989
                ],
                [
                    82.9888967,
                    54.4802815
                ],
                [
                    82.988482,
                    54.4798123
                ],
                [
                    82.9873687,
                    54.4792289
                ],
                [
                    82.985928,
                    54.4800659
                ],
                [
                    82.9862118,
                    54.4803449
                ],
                [
                    82.9855351,
                    54.4805859
                ],
                [
                    82.9853738,
                    54.4806812
                ]
            ],
            "longitude": 82.990913,
            "latitude": 54.482376
        },
        "10106": {
            "name": "Санаторный",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.0082382,
            "latitude": 54.6996254
        },
        "10107": {
            "name": "Малая Черемшанка",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.027145,
            "latitude": 55.596977
        },
        "10108": {
            "name": "Семёновский",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.035828,
            "latitude": 54.257362
        },
        "10109": {
            "name": "Украинка",
            "population": 114,
            "type": "hamlet",
            "poly": [
                [
                    83.0655928,
                    54.2672665
                ],
                [
                    83.0659541,
                    54.2675303
                ],
                [
                    83.0662251,
                    54.2677061
                ],
                [
                    83.0657434,
                    54.2679171
                ],
                [
                    83.067821,
                    54.2693415
                ],
                [
                    83.0692061,
                    54.268937
                ],
                [
                    83.069989,
                    54.2699393
                ],
                [
                    83.0804075,
                    54.2755834
                ],
                [
                    83.0831175,
                    54.2736142
                ],
                [
                    83.0815819,
                    54.2728582
                ],
                [
                    83.0821841,
                    54.2722604
                ],
                [
                    83.0808291,
                    54.2717856
                ],
                [
                    83.0798353,
                    54.27219
                ],
                [
                    83.078902,
                    54.2711878
                ],
                [
                    83.0799258,
                    54.2703965
                ],
                [
                    83.0798655,
                    54.2688667
                ],
                [
                    83.0738132,
                    54.2670906
                ],
                [
                    83.0723979,
                    54.2670555
                ],
                [
                    83.071073,
                    54.2677413
                ],
                [
                    83.0690556,
                    54.2676182
                ],
                [
                    83.0705009,
                    54.2662465
                ],
                [
                    83.0680318,
                    54.2650507
                ],
                [
                    83.066466,
                    54.2658069
                ],
                [
                    83.0667671,
                    54.2667565
                ],
                [
                    83.0655928,
                    54.2672665
                ]
            ],
            "longitude": 83.072693,
            "latitude": 54.269684
        },
        "10110": {
            "name": "Середино",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.081398,
            "latitude": 55.797413
        },
        "10111": {
            "name": "Раздольный",
            "population": 96,
            "type": "hamlet",
            "poly": [
                [
                    83.0797148,
                    54.4834546
                ],
                [
                    83.083256,
                    54.4856
                ],
                [
                    83.0842743,
                    54.4856707
                ],
                [
                    83.0845935,
                    54.4854676
                ],
                [
                    83.0852319,
                    54.4859091
                ],
                [
                    83.0850951,
                    54.4860062
                ],
                [
                    83.0861642,
                    54.4867949
                ],
                [
                    83.0873445,
                    54.4860856
                ],
                [
                    83.0868125,
                    54.4854676
                ],
                [
                    83.0887427,
                    54.4846642
                ],
                [
                    83.0892443,
                    54.4850703
                ],
                [
                    83.0897154,
                    54.4848054
                ],
                [
                    83.0894115,
                    54.4845582
                ],
                [
                    83.0896091,
                    54.4842933
                ],
                [
                    83.0911745,
                    54.4836929
                ],
                [
                    83.0912657,
                    54.4833574
                ],
                [
                    83.0907034,
                    54.4829424
                ],
                [
                    83.0907185,
                    54.482757
                ],
                [
                    83.090293,
                    54.4825539
                ],
                [
                    83.0899282,
                    54.4826069
                ],
                [
                    83.0887033,
                    54.482192
                ],
                [
                    83.0884117,
                    54.4820797
                ],
                [
                    83.0876788,
                    54.48198
                ],
                [
                    83.0865997,
                    54.4811323
                ],
                [
                    83.0862198,
                    54.4810529
                ],
                [
                    83.0858398,
                    54.4806908
                ],
                [
                    83.0862654,
                    54.4804966
                ],
                [
                    83.0850976,
                    54.479917
                ],
                [
                    83.0845023,
                    54.4802317
                ],
                [
                    83.0849127,
                    54.480735
                ],
                [
                    83.0846543,
                    54.4807968
                ],
                [
                    83.0845023,
                    54.480682
                ],
                [
                    83.0842287,
                    54.4808674
                ],
                [
                    83.0843959,
                    54.4810176
                ],
                [
                    83.0838488,
                    54.48115
                ],
                [
                    83.0828913,
                    54.4803553
                ],
                [
                    83.0821161,
                    54.4809204
                ],
                [
                    83.0830737,
                    54.4815738
                ],
                [
                    83.0797148,
                    54.4834546
                ]
            ],
            "longitude": 83.086639,
            "latitude": 54.483959
        },
        "10112": {
            "name": "Михайловка",
            "population": 130,
            "type": "hamlet",
            "poly": [
                [
                    83.0753259,
                    54.4215875
                ],
                [
                    83.0773338,
                    54.4228855
                ],
                [
                    83.0778916,
                    54.4237942
                ],
                [
                    83.0779288,
                    54.4250705
                ],
                [
                    83.0785981,
                    54.4257195
                ],
                [
                    83.0843469,
                    54.4289468
                ],
                [
                    83.0837226,
                    54.4294334
                ],
                [
                    83.0881919,
                    54.4315383
                ],
                [
                    83.0880059,
                    54.4318195
                ],
                [
                    83.0888612,
                    54.4322953
                ],
                [
                    83.0896421,
                    54.431906
                ],
                [
                    83.0983062,
                    54.4362965
                ],
                [
                    83.1025452,
                    54.4336796
                ],
                [
                    83.1040698,
                    54.4342851
                ],
                [
                    83.1049994,
                    54.4337661
                ],
                [
                    83.0970791,
                    54.430738
                ],
                [
                    83.0904229,
                    54.4269958
                ],
                [
                    83.0894933,
                    54.4267362
                ],
                [
                    83.0839528,
                    54.4238374
                ],
                [
                    83.0809408,
                    54.4223447
                ],
                [
                    83.0787469,
                    54.4216956
                ],
                [
                    83.0768504,
                    54.4215875
                ],
                [
                    83.0759952,
                    54.4211115
                ],
                [
                    83.0753259,
                    54.4215875
                ]
            ],
            "longitude": 83.088356,
            "latitude": 54.428677
        },
        "10113": {
            "name": "Зональный",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    83.096494,
                    54.7764684
                ],
                [
                    83.0989005,
                    54.7769531
                ],
                [
                    83.1013616,
                    54.7770441
                ],
                [
                    83.1040177,
                    54.7764832
                ],
                [
                    83.10682,
                    54.7752573
                ],
                [
                    83.1102277,
                    54.7717332
                ],
                [
                    83.1129785,
                    54.769521
                ],
                [
                    83.1138017,
                    54.7688244
                ],
                [
                    83.109938,
                    54.7667229
                ],
                [
                    83.10898,
                    54.7674146
                ],
                [
                    83.1023053,
                    54.7720013
                ],
                [
                    83.1017374,
                    54.7725688
                ],
                [
                    83.1012978,
                    54.7729016
                ],
                [
                    83.1014964,
                    54.772999
                ],
                [
                    83.096494,
                    54.7764684
                ]
            ],
            "longitude": 83.1041255,
            "latitude": 54.7732541
        },
        "10114": {
            "name": "Усть-Тоя",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.108345,
            "latitude": 56.069923
        },
        "10115": {
            "name": "Рябчинка",
            "population": 201,
            "type": "hamlet",
            "poly": [
                [
                    83.1005222,
                    54.6175133
                ],
                [
                    83.1012136,
                    54.6186143
                ],
                [
                    83.1087504,
                    54.6174332
                ],
                [
                    83.1116545,
                    54.6175934
                ],
                [
                    83.1126571,
                    54.6175333
                ],
                [
                    83.1158378,
                    54.6166525
                ],
                [
                    83.1150081,
                    54.6155514
                ],
                [
                    83.1132449,
                    54.6147907
                ],
                [
                    83.1125842,
                    54.6147165
                ],
                [
                    83.1120365,
                    54.6146549
                ],
                [
                    83.1120694,
                    54.61415
                ],
                [
                    83.1129337,
                    54.61413
                ],
                [
                    83.1134177,
                    54.6136295
                ],
                [
                    83.1099258,
                    54.6125684
                ],
                [
                    83.1081281,
                    54.6126885
                ],
                [
                    83.1072984,
                    54.6123682
                ],
                [
                    83.1071255,
                    54.6128287
                ],
                [
                    83.1064341,
                    54.6128687
                ],
                [
                    83.1060538,
                    54.6124282
                ],
                [
                    83.1049474,
                    54.6129888
                ],
                [
                    83.1025274,
                    54.6133292
                ],
                [
                    83.1038066,
                    54.6144103
                ],
                [
                    83.1074366,
                    54.6147506
                ],
                [
                    83.1075404,
                    54.6154713
                ],
                [
                    83.1056389,
                    54.6158717
                ],
                [
                    83.1051203,
                    54.6155314
                ],
                [
                    83.1027694,
                    54.6158517
                ],
                [
                    83.1016976,
                    54.616132
                ],
                [
                    83.1018359,
                    54.6169928
                ],
                [
                    83.1005222,
                    54.6175133
                ]
            ],
            "longitude": 83.1097829,
            "latitude": 54.6157107
        },
        "10116": {
            "name": "Карагужево",
            "population": 235,
            "type": "hamlet",
            "poly": [
                [
                    83.1136722,
                    54.1490233
                ],
                [
                    83.1140153,
                    54.1504968
                ],
                [
                    83.1159212,
                    54.1506754
                ],
                [
                    83.1176747,
                    54.1502735
                ],
                [
                    83.1179796,
                    54.1520595
                ],
                [
                    83.1168742,
                    54.1527961
                ],
                [
                    83.1195425,
                    54.1535105
                ],
                [
                    83.1218296,
                    54.157082
                ],
                [
                    83.1241167,
                    54.1585998
                ],
                [
                    83.1253746,
                    54.1585998
                ],
                [
                    83.1240024,
                    54.159314
                ],
                [
                    83.1246885,
                    54.1612335
                ],
                [
                    83.1257939,
                    54.1623047
                ],
                [
                    83.12709,
                    54.1635322
                ],
                [
                    83.1285766,
                    54.1639562
                ],
                [
                    83.1301013,
                    54.163867
                ],
                [
                    83.1306731,
                    54.1634429
                ],
                [
                    83.131321,
                    54.1636215
                ],
                [
                    83.1309018,
                    54.1650051
                ],
                [
                    83.13418,
                    54.1655854
                ],
                [
                    83.134828,
                    54.1645811
                ],
                [
                    83.1327696,
                    54.1627957
                ],
                [
                    83.1307494,
                    54.1627734
                ],
                [
                    83.1315117,
                    54.1614343
                ],
                [
                    83.129987,
                    54.1608094
                ],
                [
                    83.1288433,
                    54.1606532
                ],
                [
                    83.1285385,
                    54.1595372
                ],
                [
                    83.1302156,
                    54.157082
                ],
                [
                    83.1301776,
                    54.1558766
                ],
                [
                    83.1294914,
                    54.154448
                ],
                [
                    83.1281954,
                    54.1542694
                ],
                [
                    83.1294152,
                    54.1531979
                ],
                [
                    83.1291484,
                    54.1524613
                ],
                [
                    83.1285003,
                    54.1524166
                ],
                [
                    83.1272806,
                    54.1539346
                ],
                [
                    83.1252984,
                    54.1528854
                ],
                [
                    83.127128,
                    54.151546
                ],
                [
                    83.1265182,
                    54.1512112
                ],
                [
                    83.1256033,
                    54.1515683
                ],
                [
                    83.1238499,
                    54.1499387
                ],
                [
                    83.1218677,
                    54.1506977
                ],
                [
                    83.1207242,
                    54.1477508
                ],
                [
                    83.118742,
                    54.1479964
                ],
                [
                    83.1182846,
                    54.1471703
                ],
                [
                    83.1206098,
                    54.1464559
                ],
                [
                    83.1186276,
                    54.144692
                ],
                [
                    83.1179796,
                    54.1444911
                ],
                [
                    83.1147395,
                    54.1456074
                ],
                [
                    83.1145871,
                    54.1469024
                ],
                [
                    83.1154638,
                    54.1485992
                ],
                [
                    83.1136722,
                    54.1490233
                ]
            ],
            "longitude": 83.12355,
            "latitude": 54.151638
        },
        "10117": {
            "name": "Красный Яр",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.136559,
            "latitude": 55.511944
        },
        "10118": {
            "name": "Бобровичинск",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.137207,
            "latitude": 55.974319
        },
        "10119": {
            "name": "Светлый",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1460009,
            "latitude": 55.1945394
        },
        "10120": {
            "name": "Новолебедевка",
            "population": 172,
            "type": "hamlet",
            "poly": [
                [
                    83.1295535,
                    54.4598143
                ],
                [
                    83.1708486,
                    54.4666853
                ],
                [
                    83.1715246,
                    54.4659426
                ],
                [
                    83.1663201,
                    54.4643531
                ],
                [
                    83.1671749,
                    54.4624064
                ],
                [
                    83.1528871,
                    54.4603817
                ],
                [
                    83.1496334,
                    54.4601115
                ],
                [
                    83.1470769,
                    54.4592469
                ],
                [
                    83.1312733,
                    54.4562477
                ],
                [
                    83.1295535,
                    54.4598143
                ]
            ],
            "longitude": 83.148613,
            "latitude": 54.461216
        },
        "10121": {
            "name": "Крутоборка",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.182739,
            "latitude": 55.530884
        },
        "10122": {
            "name": "Локти",
            "population": 247,
            "type": "hamlet",
            "poly": [
                [
                    83.1687586,
                    55.2681681
                ],
                [
                    83.1714247,
                    55.269278
                ],
                [
                    83.1726288,
                    55.268792
                ],
                [
                    83.1731807,
                    55.2683204
                ],
                [
                    83.1742092,
                    55.2688635
                ],
                [
                    83.1732811,
                    55.2693637
                ],
                [
                    83.176191,
                    55.2709358
                ],
                [
                    83.1785991,
                    55.2720934
                ],
                [
                    83.1809417,
                    55.2725467
                ],
                [
                    83.1816396,
                    55.2723026
                ],
                [
                    83.1833415,
                    55.2725495
                ],
                [
                    83.1858337,
                    55.2735148
                ],
                [
                    83.1871465,
                    55.2744702
                ],
                [
                    83.1891657,
                    55.2755533
                ],
                [
                    83.1907909,
                    55.2758786
                ],
                [
                    83.196378,
                    55.2748085
                ],
                [
                    83.1992563,
                    55.2745125
                ],
                [
                    83.2002312,
                    55.2740769
                ],
                [
                    83.2010849,
                    55.2732214
                ],
                [
                    83.2036678,
                    55.2717314
                ],
                [
                    83.2056578,
                    55.2707843
                ],
                [
                    83.206894,
                    55.2694946
                ],
                [
                    83.2020242,
                    55.2679931
                ],
                [
                    83.1971246,
                    55.2669648
                ],
                [
                    83.1923558,
                    55.2665613
                ],
                [
                    83.1899071,
                    55.2663368
                ],
                [
                    83.1933717,
                    55.263544
                ],
                [
                    83.1908913,
                    55.2623887
                ],
                [
                    83.1895868,
                    55.2633893
                ],
                [
                    83.1871114,
                    55.2638567
                ],
                [
                    83.1800258,
                    55.2651453
                ],
                [
                    83.1798768,
                    55.2658221
                ],
                [
                    83.1760362,
                    55.2664608
                ],
                [
                    83.1743266,
                    55.2676082
                ],
                [
                    83.1727542,
                    55.2670484
                ],
                [
                    83.1728044,
                    55.266348
                ],
                [
                    83.1697471,
                    55.2660474
                ],
                [
                    83.1690416,
                    55.2670913
                ],
                [
                    83.1687586,
                    55.2681681
                ]
            ],
            "longitude": 83.1838105,
            "latitude": 55.268401
        },
        "10123": {
            "name": "Ремесленный",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1894718,
            "latitude": 54.9795926
        },
        "10124": {
            "name": "Казарма 45 км",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    83.1907547,
                    54.723931
                ],
                [
                    83.1909568,
                    54.7240337
                ],
                [
                    83.1910157,
                    54.7241078
                ],
                [
                    83.1911391,
                    54.7239944
                ],
                [
                    83.1914671,
                    54.7240677
                ],
                [
                    83.191439,
                    54.7241145
                ],
                [
                    83.1912873,
                    54.7243671
                ],
                [
                    83.1920385,
                    54.7246726
                ],
                [
                    83.1922528,
                    54.7244143
                ],
                [
                    83.1921008,
                    54.7243493
                ],
                [
                    83.1944422,
                    54.7217611
                ],
                [
                    83.1943808,
                    54.7215672
                ],
                [
                    83.1946011,
                    54.7213636
                ],
                [
                    83.1933559,
                    54.7210298
                ],
                [
                    83.1926098,
                    54.7218863
                ],
                [
                    83.1907547,
                    54.723931
                ]
            ],
            "longitude": 83.1930531,
            "latitude": 54.7229367
        },
        "10125": {
            "name": "Ложок",
            "population": 66,
            "type": "hamlet",
            "poly": [
                [
                    83.1881524,
                    54.8432145
                ],
                [
                    83.1898501,
                    54.8439679
                ],
                [
                    83.1900003,
                    54.8442891
                ],
                [
                    83.1953003,
                    54.8458582
                ],
                [
                    83.1969929,
                    54.8463527
                ],
                [
                    83.1997513,
                    54.8434786
                ],
                [
                    83.201027,
                    54.8433875
                ],
                [
                    83.2019711,
                    54.8430168
                ],
                [
                    83.2024002,
                    54.8434369
                ],
                [
                    83.2047606,
                    54.8429427
                ],
                [
                    83.2058335,
                    54.8426214
                ],
                [
                    83.2055759,
                    54.8421766
                ],
                [
                    83.2068635,
                    54.8421272
                ],
                [
                    83.207593,
                    54.8417812
                ],
                [
                    83.2077218,
                    54.8408174
                ],
                [
                    83.2068205,
                    54.8405209
                ],
                [
                    83.2046748,
                    54.8408174
                ],
                [
                    83.2036019,
                    54.8405209
                ],
                [
                    83.2004262,
                    54.8413858
                ],
                [
                    83.19798,
                    54.8397548
                ],
                [
                    83.1947613,
                    54.8410646
                ],
                [
                    83.1961035,
                    54.841823
                ],
                [
                    83.1918671,
                    54.8423987
                ],
                [
                    83.1881524,
                    54.8432145
                ]
            ],
            "longitude": 83.1984235,
            "latitude": 54.8420705
        },
        "10126": {
            "name": "Шадриха",
            "population": 41,
            "type": "hamlet",
            "poly": [
                [
                    83.1961182,
                    54.8129024
                ],
                [
                    83.1961182,
                    54.8132731
                ],
                [
                    83.1966427,
                    54.814191
                ],
                [
                    83.1978795,
                    54.8152231
                ],
                [
                    83.1988987,
                    54.8155823
                ],
                [
                    83.1999179,
                    54.8143678
                ],
                [
                    83.2008381,
                    54.813216
                ],
                [
                    83.2021542,
                    54.813695
                ],
                [
                    83.2022135,
                    54.812891
                ],
                [
                    83.2006501,
                    54.8124748
                ],
                [
                    83.199433,
                    54.8124235
                ],
                [
                    83.1973848,
                    54.8114199
                ],
                [
                    83.196989,
                    54.8115738
                ],
                [
                    83.1968208,
                    54.8119616
                ],
                [
                    83.1964547,
                    54.812566
                ],
                [
                    83.1961182,
                    54.8129024
                ]
            ],
            "longitude": 83.1985417,
            "latitude": 54.8135367
        },
        "10127": {
            "name": "Верх-Тоя",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.200302,
            "latitude": 55.882481
        },
        "10128": {
            "name": "Сельская",
            "population": 200,
            "type": "hamlet",
            "poly": [
                [
                    83.1957056,
                    54.721189
                ],
                [
                    83.1960936,
                    54.7216287
                ],
                [
                    83.1969684,
                    54.7218364
                ],
                [
                    83.1971309,
                    54.7219052
                ],
                [
                    83.1968547,
                    54.7221618
                ],
                [
                    83.1976509,
                    54.7224715
                ],
                [
                    83.1979199,
                    54.7222983
                ],
                [
                    83.2057084,
                    54.7156041
                ],
                [
                    83.2088769,
                    54.7112491
                ],
                [
                    83.2095867,
                    54.7102735
                ],
                [
                    83.2084564,
                    54.7099404
                ],
                [
                    83.2081447,
                    54.7098485
                ],
                [
                    83.2095305,
                    54.7081924
                ],
                [
                    83.2078892,
                    54.7076881
                ],
                [
                    83.2006864,
                    54.715667
                ],
                [
                    83.1957056,
                    54.721189
                ]
            ],
            "longitude": 83.2026529,
            "latitude": 54.7166312
        },
        "10129": {
            "name": "Новокаменка",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2037622,
            "latitude": 55.1658244
        },
        "10130": {
            "name": "Остановочная Платформа Бар",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    83.2072034,
                    55.17279
                ],
                [
                    83.2105724,
                    55.1745067
                ],
                [
                    83.2122766,
                    55.1751313
                ],
                [
                    83.2128627,
                    55.1753168
                ],
                [
                    83.2138809,
                    55.1753711
                ],
                [
                    83.2147321,
                    55.1753573
                ],
                [
                    83.2152766,
                    55.1749576
                ],
                [
                    83.2161321,
                    55.1749931
                ],
                [
                    83.2162099,
                    55.1743802
                ],
                [
                    83.2126322,
                    55.1739804
                ],
                [
                    83.2099256,
                    55.1729944
                ],
                [
                    83.2076856,
                    55.1725324
                ],
                [
                    83.2072034,
                    55.17279
                ]
            ],
            "longitude": 83.2122702,
            "latitude": 55.1743708
        },
        "10131": {
            "name": "Инской",
            "population": 185,
            "type": "hamlet",
            "poly": [
                [
                    83.2249903,
                    54.2186468
                ],
                [
                    83.2266564,
                    54.2201415
                ],
                [
                    83.2274781,
                    54.2224634
                ],
                [
                    83.2261087,
                    54.2228237
                ],
                [
                    83.2266793,
                    54.2239045
                ],
                [
                    83.2280487,
                    54.2244116
                ],
                [
                    83.2288932,
                    54.2242514
                ],
                [
                    83.2294866,
                    54.2246517
                ],
                [
                    83.2311299,
                    54.2245984
                ],
                [
                    83.2339374,
                    54.223691
                ],
                [
                    83.2334352,
                    54.2225835
                ],
                [
                    83.2273868,
                    54.2173924
                ],
                [
                    83.2249903,
                    54.2186468
                ]
            ],
            "longitude": 83.229607,
            "latitude": 54.222004
        },
        "10132": {
            "name": "Каменушка",
            "population": 83,
            "type": "hamlet",
            "poly": [
                [
                    83.2243103,
                    54.8428659
                ],
                [
                    83.2250681,
                    54.8434286
                ],
                [
                    83.2256995,
                    54.84371
                ],
                [
                    83.2268564,
                    54.8437559
                ],
                [
                    83.2275482,
                    54.8441036
                ],
                [
                    83.230041,
                    54.8437243
                ],
                [
                    83.2307383,
                    54.8429054
                ],
                [
                    83.2301464,
                    54.8427142
                ],
                [
                    83.2295644,
                    54.8423905
                ],
                [
                    83.22966,
                    54.8422739
                ],
                [
                    83.2302419,
                    54.8422043
                ],
                [
                    83.2305203,
                    54.8422189
                ],
                [
                    83.2307452,
                    54.842371
                ],
                [
                    83.2309532,
                    54.8424196
                ],
                [
                    83.2311893,
                    54.8425086
                ],
                [
                    83.2314677,
                    54.8425951
                ],
                [
                    83.2325235,
                    54.8428597
                ],
                [
                    83.2333643,
                    54.842961
                ],
                [
                    83.2337651,
                    54.8430398
                ],
                [
                    83.2344446,
                    54.8429948
                ],
                [
                    83.2347965,
                    54.8428343
                ],
                [
                    83.2346352,
                    54.8424459
                ],
                [
                    83.2344055,
                    54.8422095
                ],
                [
                    83.2342637,
                    54.8419533
                ],
                [
                    83.23399,
                    54.8416606
                ],
                [
                    83.2339696,
                    54.8414675
                ],
                [
                    83.2332567,
                    54.8408555
                ],
                [
                    83.2328461,
                    54.8410019
                ],
                [
                    83.232548,
                    54.8409118
                ],
                [
                    83.2325028,
                    54.8405381
                ],
                [
                    83.2325782,
                    54.840214
                ],
                [
                    83.2322351,
                    54.8400086
                ],
                [
                    83.2312262,
                    54.8398308
                ],
                [
                    83.2300525,
                    54.8405223
                ],
                [
                    83.2292358,
                    54.8402101
                ],
                [
                    83.227918,
                    54.8399098
                ],
                [
                    83.2271012,
                    54.8397319
                ],
                [
                    83.2268306,
                    54.8396061
                ],
                [
                    83.2258258,
                    54.840191
                ],
                [
                    83.2254689,
                    54.8410384
                ],
                [
                    83.2271985,
                    54.8413387
                ],
                [
                    83.2290379,
                    54.8419332
                ],
                [
                    83.2289281,
                    54.8420501
                ],
                [
                    83.2264023,
                    54.8419616
                ],
                [
                    83.2244806,
                    54.8418731
                ],
                [
                    83.2243103,
                    54.8428659
                ]
            ],
            "longitude": 83.2314747,
            "latitude": 54.8419284
        },
        "10133": {
            "name": "Таскаево",
            "population": 247,
            "type": "hamlet",
            "poly": [
                [
                    83.226211,
                    54.4993401
                ],
                [
                    83.2262832,
                    54.4998223
                ],
                [
                    83.2270414,
                    54.500011
                ],
                [
                    83.2303629,
                    54.5034702
                ],
                [
                    83.2319514,
                    54.5066985
                ],
                [
                    83.2321319,
                    54.5084802
                ],
                [
                    83.2332873,
                    54.5093606
                ],
                [
                    83.2350203,
                    54.5116034
                ],
                [
                    83.2352369,
                    54.5134268
                ],
                [
                    83.2371504,
                    54.5139927
                ],
                [
                    83.2384141,
                    54.5130705
                ],
                [
                    83.2396055,
                    54.5131543
                ],
                [
                    83.2407247,
                    54.512295
                ],
                [
                    83.2381252,
                    54.5108488
                ],
                [
                    83.2398221,
                    54.5104715
                ],
                [
                    83.240111,
                    54.510744
                ],
                [
                    83.2415912,
                    54.5106392
                ],
                [
                    83.2401471,
                    54.5096121
                ],
                [
                    83.2389195,
                    54.5095493
                ],
                [
                    83.2372588,
                    54.508627
                ],
                [
                    83.2364284,
                    54.508082
                ],
                [
                    83.2376558,
                    54.5074322
                ],
                [
                    83.2374032,
                    54.5070129
                ],
                [
                    83.2387029,
                    54.5066147
                ],
                [
                    83.2391001,
                    54.50586
                ],
                [
                    83.2385223,
                    54.5055036
                ],
                [
                    83.2341899,
                    54.5043507
                ],
                [
                    83.2335762,
                    54.5032186
                ],
                [
                    83.2336845,
                    54.5016044
                ],
                [
                    83.2330707,
                    54.4993401
                ],
                [
                    83.2336123,
                    54.4992353
                ],
                [
                    83.2327819,
                    54.4985224
                ],
                [
                    83.2315543,
                    54.4982289
                ],
                [
                    83.2306155,
                    54.4984176
                ],
                [
                    83.2300019,
                    54.4973064
                ],
                [
                    83.2281967,
                    54.4974531
                ],
                [
                    83.2270774,
                    54.4980612
                ],
                [
                    83.2266081,
                    54.4989418
                ],
                [
                    83.2267886,
                    54.4991933
                ],
                [
                    83.226211,
                    54.4993401
                ]
            ],
            "longitude": 83.23497,
            "latitude": 54.507427
        },
        "10134": {
            "name": "Воробьи",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.239182,
            "latitude": 55.909027
        },
        "10135": {
            "name": "Комаровка",
            "population": 23,
            "type": "hamlet",
            "poly": [
                [
                    83.2377074,
                    55.0371269
                ],
                [
                    83.2380271,
                    55.0375918
                ],
                [
                    83.2385557,
                    55.0381131
                ],
                [
                    83.2387216,
                    55.0385041
                ],
                [
                    83.2383344,
                    55.0390746
                ],
                [
                    83.2387155,
                    55.0395079
                ],
                [
                    83.2385987,
                    55.040082
                ],
                [
                    83.2386479,
                    55.040487
                ],
                [
                    83.2396744,
                    55.0409449
                ],
                [
                    83.2407193,
                    55.041128
                ],
                [
                    83.2411434,
                    55.0410294
                ],
                [
                    83.2413217,
                    55.041047
                ],
                [
                    83.2414262,
                    55.0411597
                ],
                [
                    83.2414139,
                    55.0412971
                ],
                [
                    83.2439586,
                    55.0404835
                ],
                [
                    83.2437004,
                    55.0401947
                ],
                [
                    83.2427907,
                    55.0405046
                ],
                [
                    83.2419302,
                    55.0402581
                ],
                [
                    83.241838,
                    55.0400608
                ],
                [
                    83.2427354,
                    55.0396628
                ],
                [
                    83.2428153,
                    55.0394339
                ],
                [
                    83.2419794,
                    55.038814
                ],
                [
                    83.2412848,
                    55.0382293
                ],
                [
                    83.2407562,
                    55.0379652
                ],
                [
                    83.2404488,
                    55.0375671
                ],
                [
                    83.239828,
                    55.0369683
                ],
                [
                    83.2392072,
                    55.0365598
                ],
                [
                    83.2377074,
                    55.0371269
                ]
            ],
            "longitude": 83.2399876,
            "latitude": 55.0393847
        },
        "10136": {
            "name": "Изовка",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.243805,
            "latitude": 55.780582
        },
        "10137": {
            "name": "Междуречье",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2562801,
            "latitude": 54.9642502
        },
        "10138": {
            "name": "Остановочная Платформа Фер",
            "population": 19,
            "type": "hamlet",
            "poly": [
                [
                    83.2540882,
                    55.1668012
                ],
                [
                    83.254394,
                    55.1673117
                ],
                [
                    83.2547669,
                    55.1681397
                ],
                [
                    83.2552918,
                    55.1689177
                ],
                [
                    83.2559476,
                    55.1688923
                ],
                [
                    83.2574863,
                    55.1688938
                ],
                [
                    83.2581718,
                    55.1691196
                ],
                [
                    83.2588503,
                    55.1702
                ],
                [
                    83.2594309,
                    55.1708557
                ],
                [
                    83.258746,
                    55.1711314
                ],
                [
                    83.2589743,
                    55.1713773
                ],
                [
                    83.2592417,
                    55.1714853
                ],
                [
                    83.259607,
                    55.1715375
                ],
                [
                    83.2594744,
                    55.1717612
                ],
                [
                    83.2600048,
                    55.172496
                ],
                [
                    83.2604138,
                    55.1730556
                ],
                [
                    83.2612312,
                    55.1728861
                ],
                [
                    83.2613733,
                    55.1728648
                ],
                [
                    83.2615052,
                    55.1728451
                ],
                [
                    83.2615182,
                    55.1724427
                ],
                [
                    83.2611856,
                    55.1717461
                ],
                [
                    83.2605724,
                    55.1707439
                ],
                [
                    83.2593917,
                    55.1687917
                ],
                [
                    83.2589808,
                    55.1682776
                ],
                [
                    83.2583644,
                    55.1671649
                ],
                [
                    83.2570578,
                    55.1673302
                ],
                [
                    83.2573743,
                    55.1663803
                ],
                [
                    83.2568821,
                    55.1661785
                ],
                [
                    83.2565673,
                    55.1660495
                ],
                [
                    83.2548647,
                    55.1666568
                ],
                [
                    83.2540882,
                    55.1668012
                ]
            ],
            "longitude": 83.2583809,
            "latitude": 55.168551
        },
        "10139": {
            "name": "Жеребцово",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2651862,
            "latitude": 55.1025232
        },
        "10140": {
            "name": "Чёрный Мыс",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.267014,
            "latitude": 55.51601
        },
        "10141": {
            "name": "Ключи",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    83.2642817,
                    54.8467021
                ],
                [
                    83.2644173,
                    54.8476901
                ],
                [
                    83.2694006,
                    54.8475966
                ],
                [
                    83.2741791,
                    54.8484504
                ],
                [
                    83.2791263,
                    54.8475368
                ],
                [
                    83.2786583,
                    54.8464142
                ],
                [
                    83.2716453,
                    54.847029
                ],
                [
                    83.2658715,
                    54.8462776
                ],
                [
                    83.2642817,
                    54.8467021
                ]
            ],
            "longitude": 83.2720454,
            "latitude": 54.847538
        },
        "10142": {
            "name": "Совхозная",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2884867,
            "latitude": 54.9792084
        },
        "10143": {
            "name": "Еловкино",
            "population": 200,
            "type": "hamlet",
            "poly": [
                [
                    83.2896451,
                    54.0979596
                ],
                [
                    83.2901644,
                    54.0988123
                ],
                [
                    83.291653,
                    54.1010452
                ],
                [
                    83.2955303,
                    54.1021211
                ],
                [
                    83.2988884,
                    54.1023849
                ],
                [
                    83.3003078,
                    54.1015121
                ],
                [
                    83.3026272,
                    54.0976551
                ],
                [
                    83.3028348,
                    54.0957874
                ],
                [
                    83.3002731,
                    54.0954017
                ],
                [
                    83.2980575,
                    54.0961732
                ],
                [
                    83.2959112,
                    54.0955235
                ],
                [
                    83.290926,
                    54.0965183
                ],
                [
                    83.2896451,
                    54.0979596
                ]
            ],
            "longitude": 83.295723,
            "latitude": 54.099228
        },
        "10144": {
            "name": "Бариново",
            "population": 184,
            "type": "hamlet",
            "poly": [
                [
                    83.2943705,
                    54.1741333
                ],
                [
                    83.2945143,
                    54.176884
                ],
                [
                    83.3007245,
                    54.1775997
                ],
                [
                    83.3058317,
                    54.1749333
                ],
                [
                    83.3073903,
                    54.1731228
                ],
                [
                    83.3028345,
                    54.1705964
                ],
                [
                    83.3022831,
                    54.1722947
                ],
                [
                    83.298063,
                    54.1723088
                ],
                [
                    83.2943705,
                    54.1741333
                ]
            ],
            "longitude": 83.301201,
            "latitude": 54.174141
        },
        "10145": {
            "name": "Мостовая",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3061313,
            "latitude": 55.0658363
        },
        "10146": {
            "name": "Пригородный",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.321358,
            "latitude": 54.219685
        },
        "10147": {
            "name": "Отважный",
            "population": 211,
            "type": "hamlet",
            "poly": [
                [
                    83.3249864,
                    54.1916186
                ],
                [
                    83.3292403,
                    54.1940602
                ],
                [
                    83.3304551,
                    54.1938233
                ],
                [
                    83.3327489,
                    54.1885479
                ],
                [
                    83.3311319,
                    54.187256
                ],
                [
                    83.3276342,
                    54.1887768
                ],
                [
                    83.3264218,
                    54.1903989
                ],
                [
                    83.3249864,
                    54.1916186
                ]
            ],
            "longitude": 83.329308,
            "latitude": 54.191383
        },
        "10148": {
            "name": "Логовой",
            "population": 11,
            "type": "hamlet",
            "poly": [
                [
                    83.351555,
                    54.6702364
                ],
                [
                    83.3521024,
                    54.6702138
                ],
                [
                    83.3522002,
                    54.6737637
                ],
                [
                    83.353862,
                    54.6737411
                ],
                [
                    83.3537251,
                    54.6683257
                ],
                [
                    83.3523565,
                    54.6683144
                ],
                [
                    83.3522784,
                    54.6692415
                ],
                [
                    83.3516723,
                    54.6692302
                ],
                [
                    83.351555,
                    54.6702364
                ]
            ],
            "longitude": 83.3530615,
            "latitude": 54.6711566
        },
        "10149": {
            "name": "Шуринский",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    83.3448782,
                    55.2073727
                ],
                [
                    83.3449012,
                    55.208833
                ],
                [
                    83.3509064,
                    55.2108181
                ],
                [
                    83.3543003,
                    55.2111416
                ],
                [
                    83.3579946,
                    55.2116722
                ],
                [
                    83.3599548,
                    55.2126328
                ],
                [
                    83.3600804,
                    55.2132207
                ],
                [
                    83.3616888,
                    55.2138659
                ],
                [
                    83.3653419,
                    55.2138932
                ],
                [
                    83.3669412,
                    55.2131203
                ],
                [
                    83.3671925,
                    55.212217
                ],
                [
                    83.3680219,
                    55.21226
                ],
                [
                    83.3699385,
                    55.2125433
                ],
                [
                    83.3685999,
                    55.2106398
                ],
                [
                    83.3699876,
                    55.2079252
                ],
                [
                    83.3691723,
                    55.2077826
                ],
                [
                    83.3690693,
                    55.2074081
                ],
                [
                    83.3676797,
                    55.2072613
                ],
                [
                    83.3659124,
                    55.2074633
                ],
                [
                    83.3624556,
                    55.2065344
                ],
                [
                    83.361402,
                    55.2058535
                ],
                [
                    83.3589043,
                    55.2052715
                ],
                [
                    83.3573731,
                    55.2059323
                ],
                [
                    83.3577849,
                    55.2053963
                ],
                [
                    83.3553144,
                    55.2045006
                ],
                [
                    83.3527924,
                    55.2039499
                ],
                [
                    83.3509525,
                    55.2040524
                ],
                [
                    83.3501895,
                    55.205084
                ],
                [
                    83.3493182,
                    55.2050512
                ],
                [
                    83.3489837,
                    55.205903
                ],
                [
                    83.3490481,
                    55.2075329
                ],
                [
                    83.3448782,
                    55.2073727
                ]
            ],
            "longitude": 83.3587314,
            "latitude": 55.2085503
        },
        "10150": {
            "name": "Геодезическая",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3665655,
            "latitude": 54.996844
        },
        "10151": {
            "name": "Малиновка",
            "population": 136,
            "type": "hamlet",
            "poly": [
                [
                    83.3715696,
                    54.9611276
                ],
                [
                    83.3719367,
                    54.9611866
                ],
                [
                    83.3717202,
                    54.9621179
                ],
                [
                    83.3736397,
                    54.962375
                ],
                [
                    83.3743079,
                    54.9638302
                ],
                [
                    83.3753427,
                    54.9639343
                ],
                [
                    83.3765025,
                    54.9620463
                ],
                [
                    83.377317,
                    54.9620101
                ],
                [
                    83.3775595,
                    54.9613383
                ],
                [
                    83.3784596,
                    54.961423
                ],
                [
                    83.3789102,
                    54.9605207
                ],
                [
                    83.3771484,
                    54.9599054
                ],
                [
                    83.3777063,
                    54.9593659
                ],
                [
                    83.3797815,
                    54.9602019
                ],
                [
                    83.3804076,
                    54.9595176
                ],
                [
                    83.3803067,
                    54.9587674
                ],
                [
                    83.3786899,
                    54.9581689
                ],
                [
                    83.3789247,
                    54.9576547
                ],
                [
                    83.3782042,
                    54.9572934
                ],
                [
                    83.3766786,
                    54.9581436
                ],
                [
                    83.3745014,
                    54.9577487
                ],
                [
                    83.3732726,
                    54.9583544
                ],
                [
                    83.3719427,
                    54.9585365
                ],
                [
                    83.3717202,
                    54.9589761
                ],
                [
                    83.3723918,
                    54.9591214
                ],
                [
                    83.3715696,
                    54.9611276
                ]
            ],
            "longitude": 83.3746201,
            "latitude": 54.9606204
        },
        "10152": {
            "name": "Пионерский",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3875678,
            "latitude": 55.0109428
        },
        "10153": {
            "name": "Щукино",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.390762,
            "latitude": 55.672382
        },
        "10154": {
            "name": "Спутник",
            "population": 122,
            "type": "hamlet",
            "poly": [
                [
                    83.4091083,
                    54.205046
                ],
                [
                    83.4105559,
                    54.2061593
                ],
                [
                    83.4117059,
                    54.206658
                ],
                [
                    83.4134905,
                    54.2054635
                ],
                [
                    83.4132525,
                    54.2052547
                ],
                [
                    83.4138276,
                    54.2047792
                ],
                [
                    83.4135301,
                    54.2041182
                ],
                [
                    83.4125387,
                    54.2031671
                ],
                [
                    83.4141647,
                    54.2021117
                ],
                [
                    83.4136701,
                    54.2018924
                ],
                [
                    83.4121206,
                    54.2019988
                ],
                [
                    83.4105955,
                    54.2029468
                ],
                [
                    83.4100205,
                    54.2039558
                ],
                [
                    83.4106352,
                    54.2041414
                ],
                [
                    83.4091083,
                    54.205046
                ]
            ],
            "longitude": 83.41169,
            "latitude": 54.204372
        },
        "10155": {
            "name": "Шмаково",
            "population": 230,
            "type": "hamlet",
            "poly": [
                [
                    83.3978201,
                    55.0268519
                ],
                [
                    83.39998,
                    55.0285447
                ],
                [
                    83.4023163,
                    55.0307428
                ],
                [
                    83.4047848,
                    55.0327639
                ],
                [
                    83.4103831,
                    55.0338249
                ],
                [
                    83.4094573,
                    55.0360227
                ],
                [
                    83.4121463,
                    55.0374625
                ],
                [
                    83.4154524,
                    55.0420596
                ],
                [
                    83.4189788,
                    55.0434992
                ],
                [
                    83.4213151,
                    55.0432972
                ],
                [
                    83.4199486,
                    55.0410746
                ],
                [
                    83.4214473,
                    55.040241
                ],
                [
                    83.4201249,
                    55.0370584
                ],
                [
                    83.4246211,
                    55.0354669
                ],
                [
                    83.4115292,
                    55.0259676
                ],
                [
                    83.4088403,
                    55.027433
                ],
                [
                    83.4047848,
                    55.0264224
                ],
                [
                    83.4006412,
                    55.0258918
                ],
                [
                    83.3978201,
                    55.0268519
                ]
            ],
            "longitude": 83.413528,
            "latitude": 55.031124
        },
        "10156": {
            "name": "Искра",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    83.4171591,
                    54.160775
                ],
                [
                    83.4173991,
                    54.1636052
                ],
                [
                    83.4177419,
                    54.1648094
                ],
                [
                    83.4183932,
                    54.1651907
                ],
                [
                    83.4199359,
                    54.165271
                ],
                [
                    83.4197645,
                    54.1642073
                ],
                [
                    83.419456,
                    54.1606345
                ],
                [
                    83.4171591,
                    54.160775
                ]
            ],
            "longitude": 83.418274,
            "latitude": 54.163151
        },
        "10157": {
            "name": "Орск",
            "population": 176,
            "type": "hamlet",
            "poly": [
                [
                    83.4145737,
                    55.2145769
                ],
                [
                    83.4203235,
                    55.2145326
                ],
                [
                    83.4284306,
                    55.2151354
                ],
                [
                    83.4327786,
                    55.2148126
                ],
                [
                    83.43407,
                    55.2124066
                ],
                [
                    83.4399025,
                    55.2120428
                ],
                [
                    83.4456018,
                    55.2121873
                ],
                [
                    83.4567474,
                    55.2094415
                ],
                [
                    83.459325,
                    55.2076922
                ],
                [
                    83.4506329,
                    55.206586
                ],
                [
                    83.4422071,
                    55.2053126
                ],
                [
                    83.4353916,
                    55.2038437
                ],
                [
                    83.4274407,
                    55.2026647
                ],
                [
                    83.4221019,
                    55.2008631
                ],
                [
                    83.4198326,
                    55.2012991
                ],
                [
                    83.4171741,
                    55.2031158
                ],
                [
                    83.4154764,
                    55.2050105
                ],
                [
                    83.4209984,
                    55.2061309
                ],
                [
                    83.4182986,
                    55.2084766
                ],
                [
                    83.4190349,
                    55.2091417
                ],
                [
                    83.4216733,
                    55.2094568
                ],
                [
                    83.4216119,
                    55.2109621
                ],
                [
                    83.4187896,
                    55.2109971
                ],
                [
                    83.4148015,
                    55.2126074
                ],
                [
                    83.4145737,
                    55.2145769
                ]
            ],
            "longitude": 83.43309,
            "latitude": 55.208012
        },
        "10158": {
            "name": "Новый Порос",
            "population": 155,
            "type": "hamlet",
            "poly": [
                [
                    83.431341,
                    55.3038742
                ],
                [
                    83.4334836,
                    55.3067651
                ],
                [
                    83.4376896,
                    55.3079847
                ],
                [
                    83.4369311,
                    55.3095885
                ],
                [
                    83.4354472,
                    55.3106875
                ],
                [
                    83.4344359,
                    55.3152108
                ],
                [
                    83.4370547,
                    55.3171075
                ],
                [
                    83.4357461,
                    55.3218331
                ],
                [
                    83.4384997,
                    55.3223716
                ],
                [
                    83.4374411,
                    55.3265788
                ],
                [
                    83.4389013,
                    55.327547
                ],
                [
                    83.4425765,
                    55.3240508
                ],
                [
                    83.444778,
                    55.320104
                ],
                [
                    83.4467676,
                    55.3159211
                ],
                [
                    83.4486256,
                    55.3127497
                ],
                [
                    83.4441976,
                    55.3096999
                ],
                [
                    83.442213,
                    55.307533
                ],
                [
                    83.4391179,
                    55.3063134
                ],
                [
                    83.4359437,
                    55.3031966
                ],
                [
                    83.431341,
                    55.3038742
                ]
            ],
            "longitude": 83.441971,
            "latitude": 55.316265
        },
        "10159": {
            "name": "Сушзавод",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.445839,
            "latitude": 54.172798
        },
        "10160": {
            "name": "Майский",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.449509,
            "latitude": 55.244011
        },
        "10161": {
            "name": "Запрудный",
            "population": 118,
            "type": "hamlet",
            "poly": [
                [
                    83.4430615,
                    54.3685523
                ],
                [
                    83.4504208,
                    54.3709707
                ],
                [
                    83.4541947,
                    54.3713004
                ],
                [
                    83.4543834,
                    54.3699814
                ],
                [
                    83.452119,
                    54.3683325
                ],
                [
                    83.4449486,
                    54.3667934
                ],
                [
                    83.4430615,
                    54.3685523
                ]
            ],
            "longitude": 83.450089,
            "latitude": 54.369205
        },
        "10162": {
            "name": "Михайловский",
            "population": 5,
            "type": "hamlet",
            "poly": [
                [
                    83.4408024,
                    55.0715153
                ],
                [
                    83.4476138,
                    55.0712631
                ],
                [
                    83.4473445,
                    55.071639
                ],
                [
                    83.449735,
                    55.0726125
                ],
                [
                    83.4497687,
                    55.072892
                ],
                [
                    83.4506777,
                    55.0737305
                ],
                [
                    83.4520749,
                    55.074463
                ],
                [
                    83.4518393,
                    55.07481
                ],
                [
                    83.4524452,
                    55.0749738
                ],
                [
                    83.4531187,
                    55.0750798
                ],
                [
                    83.4534217,
                    55.0748485
                ],
                [
                    83.4544822,
                    55.0747811
                ],
                [
                    83.4547011,
                    55.0754364
                ],
                [
                    83.4573609,
                    55.0765254
                ],
                [
                    83.4598187,
                    55.0772675
                ],
                [
                    83.4591116,
                    55.0785492
                ],
                [
                    83.4636401,
                    55.0800718
                ],
                [
                    83.4672257,
                    55.0771711
                ],
                [
                    83.4678486,
                    55.0751377
                ],
                [
                    83.4666871,
                    55.0728824
                ],
                [
                    83.4658958,
                    55.0729884
                ],
                [
                    83.4639094,
                    55.0727185
                ],
                [
                    83.4623607,
                    55.0727185
                ],
                [
                    83.4608961,
                    55.0725258
                ],
                [
                    83.4598019,
                    55.0720824
                ],
                [
                    83.4557279,
                    55.0717933
                ],
                [
                    83.4515868,
                    55.0706655
                ],
                [
                    83.4520244,
                    55.0704631
                ],
                [
                    83.4514353,
                    55.0702511
                ],
                [
                    83.4501389,
                    55.0705788
                ],
                [
                    83.4473445,
                    55.0697402
                ],
                [
                    83.4441965,
                    55.0697691
                ],
                [
                    83.4440787,
                    55.068757
                ],
                [
                    83.4408297,
                    55.0687378
                ],
                [
                    83.4408024,
                    55.0715153
                ]
            ],
            "longitude": 83.459015,
            "latitude": 55.074139
        },
        "10163": {
            "name": "Калиновка",
            "population": 182,
            "type": "hamlet",
            "poly": [
                [
                    83.451365,
                    54.7143878
                ],
                [
                    83.451756,
                    54.7142749
                ],
                [
                    83.4535399,
                    54.7155313
                ],
                [
                    83.4542731,
                    54.7153901
                ],
                [
                    83.454884,
                    54.716223
                ],
                [
                    83.4583054,
                    54.7151501
                ],
                [
                    83.4593074,
                    54.7153477
                ],
                [
                    83.4596495,
                    54.7163923
                ],
                [
                    83.461238,
                    54.717931
                ],
                [
                    83.46202,
                    54.7182274
                ],
                [
                    83.4621176,
                    54.7179592
                ],
                [
                    83.4613602,
                    54.7171828
                ],
                [
                    83.4626798,
                    54.7170558
                ],
                [
                    83.4632175,
                    54.7162653
                ],
                [
                    83.4633884,
                    54.7154042
                ],
                [
                    83.4626798,
                    54.7151783
                ],
                [
                    83.4631196,
                    54.7142325
                ],
                [
                    83.4638528,
                    54.7140067
                ],
                [
                    83.4629731,
                    54.7118185
                ],
                [
                    83.4615801,
                    54.7105761
                ],
                [
                    83.4620288,
                    54.7096788
                ],
                [
                    83.462717,
                    54.7093535
                ],
                [
                    83.4637023,
                    54.7094077
                ],
                [
                    83.4640151,
                    54.7092541
                ],
                [
                    83.4644843,
                    54.7084589
                ],
                [
                    83.4653133,
                    54.7078445
                ],
                [
                    83.4647033,
                    54.7075463
                ],
                [
                    83.4663142,
                    54.7062992
                ],
                [
                    83.4674404,
                    54.7059468
                ],
                [
                    83.4685821,
                    54.7053233
                ],
                [
                    83.4724609,
                    54.7026031
                ],
                [
                    83.4726955,
                    54.7027387
                ],
                [
                    83.4730553,
                    54.7025851
                ],
                [
                    83.4732742,
                    54.7026754
                ],
                [
                    83.4746662,
                    54.7012475
                ],
                [
                    83.4747444,
                    54.7006329
                ],
                [
                    83.4730396,
                    54.7001268
                ],
                [
                    83.472758,
                    54.7003076
                ],
                [
                    83.4724922,
                    54.7001268
                ],
                [
                    83.4707248,
                    54.7011662
                ],
                [
                    83.4693172,
                    54.7016632
                ],
                [
                    83.4687542,
                    54.7020157
                ],
                [
                    83.4683162,
                    54.7017626
                ],
                [
                    83.4673622,
                    54.7026754
                ],
                [
                    83.4673308,
                    54.7028923
                ],
                [
                    83.465282,
                    54.7039406
                ],
                [
                    83.4651881,
                    54.7044919
                ],
                [
                    83.4647659,
                    54.7046094
                ],
                [
                    83.4642654,
                    54.7044196
                ],
                [
                    83.4610434,
                    54.7053052
                ],
                [
                    83.4622634,
                    54.7062631
                ],
                [
                    83.461888,
                    54.7073203
                ],
                [
                    83.4622165,
                    54.7074288
                ],
                [
                    83.4616221,
                    54.7090734
                ],
                [
                    83.4606993,
                    54.7098143
                ],
                [
                    83.4602301,
                    54.7107179
                ],
                [
                    83.4599173,
                    54.7109076
                ],
                [
                    83.458932,
                    54.7104287
                ],
                [
                    83.4519145,
                    54.7135833
                ],
                [
                    83.451365,
                    54.7143878
                ]
            ],
            "longitude": 83.459023,
            "latitude": 54.712795
        },
        "10164": {
            "name": "Романово",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.46312,
            "latitude": 54.194756
        },
        "10165": {
            "name": "Казанка",
            "population": 160,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4771599,
            "latitude": 55.6678899
        },
        "10166": {
            "name": "Ярское",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.479431,
            "latitude": 55.099091
        },
        "10167": {
            "name": "Безменово",
            "population": 155,
            "type": "hamlet",
            "poly": [
                [
                    83.4715712,
                    54.1260216
                ],
                [
                    83.4737216,
                    54.1271137
                ],
                [
                    83.4730765,
                    54.1299067
                ],
                [
                    83.4754777,
                    54.1306416
                ],
                [
                    83.4749043,
                    54.1325735
                ],
                [
                    83.4777713,
                    54.1330145
                ],
                [
                    83.481391,
                    54.1282687
                ],
                [
                    83.4812476,
                    54.1270927
                ],
                [
                    83.4795632,
                    54.1262736
                ],
                [
                    83.4812118,
                    54.1257696
                ],
                [
                    83.490028,
                    54.120897
                ],
                [
                    83.4884152,
                    54.1203929
                ],
                [
                    83.4817852,
                    54.1186495
                ],
                [
                    83.478058,
                    54.1216531
                ],
                [
                    83.4727182,
                    54.1253286
                ],
                [
                    83.4715712,
                    54.1260216
                ]
            ],
            "longitude": 83.480446,
            "latitude": 54.123405
        },
        "10168": {
            "name": "Дзержинский",
            "population": 57,
            "type": "hamlet",
            "poly": [
                [
                    83.4733885,
                    54.9121958
                ],
                [
                    83.4738511,
                    54.9135981
                ],
                [
                    83.4757859,
                    54.915919
                ],
                [
                    83.4753233,
                    54.9178772
                ],
                [
                    83.4764589,
                    54.9183606
                ],
                [
                    83.4774684,
                    54.9173695
                ],
                [
                    83.4785199,
                    54.9169827
                ],
                [
                    83.4839457,
                    54.916064
                ],
                [
                    83.4878153,
                    54.9139124
                ],
                [
                    83.4900446,
                    54.9109385
                ],
                [
                    83.4886145,
                    54.9109627
                ],
                [
                    83.4874789,
                    54.9116397
                ],
                [
                    83.48689,
                    54.9118573
                ],
                [
                    83.4851234,
                    54.9108418
                ],
                [
                    83.4846187,
                    54.9110594
                ],
                [
                    83.4816593,
                    54.9111474
                ],
                [
                    83.4733885,
                    54.9121958
                ]
            ],
            "longitude": 83.481567,
            "latitude": 54.914063
        },
        "10169": {
            "name": "Старый Порос",
            "population": 122,
            "type": "hamlet",
            "poly": [
                [
                    83.4712099,
                    55.4203999
                ],
                [
                    83.4713815,
                    55.4220562
                ],
                [
                    83.4746431,
                    55.4239071
                ],
                [
                    83.4801362,
                    55.4250761
                ],
                [
                    83.4837411,
                    55.4275114
                ],
                [
                    83.4882043,
                    55.4265373
                ],
                [
                    83.488376,
                    55.4236149
                ],
                [
                    83.4874573,
                    55.4210451
                ],
                [
                    83.4900926,
                    55.4187437
                ],
                [
                    83.4929504,
                    55.4170018
                ],
                [
                    83.4912338,
                    55.4157351
                ],
                [
                    83.4876893,
                    55.416795
                ],
                [
                    83.4829082,
                    55.4184389
                ],
                [
                    83.4799646,
                    55.4176719
                ],
                [
                    83.475673,
                    55.4172822
                ],
                [
                    83.4758447,
                    55.4189385
                ],
                [
                    83.4730981,
                    55.4195231
                ],
                [
                    83.4712099,
                    55.4203999
                ]
            ],
            "longitude": 83.4830511,
            "latitude": 55.4203267
        },
        "10170": {
            "name": "Кошево",
            "population": 206,
            "type": "hamlet",
            "poly": [
                [
                    83.481129,
                    55.2548168
                ],
                [
                    83.4816244,
                    55.2551544
                ],
                [
                    83.4818366,
                    55.2556021
                ],
                [
                    83.4831061,
                    55.2561347
                ],
                [
                    83.4841522,
                    55.2566503
                ],
                [
                    83.4836385,
                    55.257499
                ],
                [
                    83.485016,
                    55.258127
                ],
                [
                    83.48636,
                    55.2566397
                ],
                [
                    83.4875364,
                    55.2570067
                ],
                [
                    83.4873577,
                    55.2576878
                ],
                [
                    83.4876667,
                    55.2581567
                ],
                [
                    83.4888916,
                    55.2586765
                ],
                [
                    83.4889325,
                    55.2588547
                ],
                [
                    83.4904627,
                    55.2593915
                ],
                [
                    83.4923688,
                    55.2600576
                ],
                [
                    83.4939995,
                    55.2605286
                ],
                [
                    83.4950158,
                    55.2604628
                ],
                [
                    83.4977894,
                    55.2614345
                ],
                [
                    83.4997701,
                    55.2620391
                ],
                [
                    83.5002419,
                    55.2616014
                ],
                [
                    83.5018745,
                    55.2621343
                ],
                [
                    83.5039411,
                    55.2627922
                ],
                [
                    83.5048418,
                    55.2618297
                ],
                [
                    83.5053344,
                    55.2611119
                ],
                [
                    83.5056013,
                    55.2607229
                ],
                [
                    83.5045942,
                    55.2604409
                ],
                [
                    83.504386,
                    55.260369
                ],
                [
                    83.4989829,
                    55.2585042
                ],
                [
                    83.4995919,
                    55.257943
                ],
                [
                    83.4997919,
                    55.2575959
                ],
                [
                    83.5000918,
                    55.2572592
                ],
                [
                    83.5007935,
                    55.2565422
                ],
                [
                    83.5017589,
                    55.2567217
                ],
                [
                    83.5029281,
                    55.2570831
                ],
                [
                    83.5066511,
                    55.2582865
                ],
                [
                    83.5081984,
                    55.2565825
                ],
                [
                    83.5060577,
                    55.2557636
                ],
                [
                    83.5061623,
                    55.2553094
                ],
                [
                    83.5035331,
                    55.2539137
                ],
                [
                    83.5025849,
                    55.2539999
                ],
                [
                    83.5017996,
                    55.2548751
                ],
                [
                    83.500863,
                    55.2550741
                ],
                [
                    83.5005314,
                    55.2549348
                ],
                [
                    83.5005489,
                    55.2542485
                ],
                [
                    83.5008339,
                    55.2530649
                ],
                [
                    83.4991004,
                    55.2522294
                ],
                [
                    83.495267,
                    55.2509529
                ],
                [
                    83.4928994,
                    55.250177
                ],
                [
                    83.4914277,
                    55.2521067
                ],
                [
                    83.4892811,
                    55.2514569
                ],
                [
                    83.488618,
                    55.2521498
                ],
                [
                    83.4881584,
                    55.252299
                ],
                [
                    83.4893603,
                    55.2526783
                ],
                [
                    83.489046,
                    55.2530301
                ],
                [
                    83.4907048,
                    55.2535611
                ],
                [
                    83.4928749,
                    55.2542605
                ],
                [
                    83.4953368,
                    55.2550641
                ],
                [
                    83.4975764,
                    55.2557272
                ],
                [
                    83.4987107,
                    55.2561548
                ],
                [
                    83.5005861,
                    55.2565036
                ],
                [
                    83.4996737,
                    55.2575389
                ],
                [
                    83.4993011,
                    55.2578031
                ],
                [
                    83.4986868,
                    55.258402
                ],
                [
                    83.4985537,
                    55.2583561
                ],
                [
                    83.4945495,
                    55.256974
                ],
                [
                    83.4833752,
                    55.2531403
                ],
                [
                    83.4826295,
                    55.2537505
                ],
                [
                    83.481129,
                    55.2548168
                ]
            ],
            "longitude": 83.492638,
            "latitude": 55.256912
        },
        "10171": {
            "name": "Каменка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    83.4996347,
                    55.1100801
                ],
                [
                    83.5004959,
                    55.1113473
                ],
                [
                    83.5073609,
                    55.1139015
                ],
                [
                    83.5007624,
                    55.1190855
                ],
                [
                    83.5048282,
                    55.1193905
                ],
                [
                    83.5078941,
                    55.1216773
                ],
                [
                    83.5130262,
                    55.1232018
                ],
                [
                    83.5167587,
                    55.1226683
                ],
                [
                    83.5233571,
                    55.1224015
                ],
                [
                    83.523757,
                    55.1199622
                ],
                [
                    83.5227572,
                    55.115655
                ],
                [
                    83.513754,
                    55.1131055
                ],
                [
                    83.5097038,
                    55.1105077
                ],
                [
                    83.505692,
                    55.1091529
                ],
                [
                    83.5031752,
                    55.1105924
                ],
                [
                    83.4996347,
                    55.1100801
                ]
            ],
            "longitude": 83.512054,
            "latitude": 55.114853
        },
        "10172": {
            "name": "Умна",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.517822,
            "latitude": 55.602768
        },
        "10173": {
            "name": "Пустынка",
            "population": 25,
            "type": "hamlet",
            "poly": [
                [
                    83.5148468,
                    55.0921869
                ],
                [
                    83.5155554,
                    55.0921955
                ],
                [
                    83.5160831,
                    55.0929375
                ],
                [
                    83.5159172,
                    55.0930496
                ],
                [
                    83.5160077,
                    55.0931532
                ],
                [
                    83.5153744,
                    55.0933171
                ],
                [
                    83.5155705,
                    55.0937312
                ],
                [
                    83.515872,
                    55.0936622
                ],
                [
                    83.5163242,
                    55.0940159
                ],
                [
                    83.5170027,
                    55.0938002
                ],
                [
                    83.5174098,
                    55.0942661
                ],
                [
                    83.5166861,
                    55.0944904
                ],
                [
                    83.5179375,
                    55.095888
                ],
                [
                    83.5182239,
                    55.0958103
                ],
                [
                    83.5185857,
                    55.0961554
                ],
                [
                    83.5189174,
                    55.0960778
                ],
                [
                    83.5193848,
                    55.0965867
                ],
                [
                    83.5188873,
                    55.0966902
                ],
                [
                    83.5192038,
                    55.0976737
                ],
                [
                    83.5195356,
                    55.0976564
                ],
                [
                    83.5205306,
                    55.098752
                ],
                [
                    83.5213447,
                    55.0986312
                ],
                [
                    83.5219326,
                    55.0993472
                ],
                [
                    83.522777,
                    55.0990798
                ],
                [
                    83.5225509,
                    55.0988296
                ],
                [
                    83.5233197,
                    55.0985018
                ],
                [
                    83.5231388,
                    55.0982344
                ],
                [
                    83.5215407,
                    55.0985449
                ],
                [
                    83.5211789,
                    55.0981999
                ],
                [
                    83.5221438,
                    55.0978376
                ],
                [
                    83.5220383,
                    55.097665
                ],
                [
                    83.5227619,
                    55.0974494
                ],
                [
                    83.5223699,
                    55.0970267
                ],
                [
                    83.5220533,
                    55.0970871
                ],
                [
                    83.5219478,
                    55.0970094
                ],
                [
                    83.5215558,
                    55.0971647
                ],
                [
                    83.5214503,
                    55.0970698
                ],
                [
                    83.5204854,
                    55.0973631
                ],
                [
                    83.5201839,
                    55.0969577
                ],
                [
                    83.5206211,
                    55.096811
                ],
                [
                    83.5205608,
                    55.096673
                ],
                [
                    83.5221287,
                    55.0961899
                ],
                [
                    83.5218724,
                    55.0959915
                ],
                [
                    83.5200179,
                    55.0965954
                ],
                [
                    83.5197316,
                    55.0961468
                ],
                [
                    83.519053,
                    55.095517
                ],
                [
                    83.5192943,
                    55.0953962
                ],
                [
                    83.5191888,
                    55.0952668
                ],
                [
                    83.5197014,
                    55.0951288
                ],
                [
                    83.5189627,
                    55.0943955
                ],
                [
                    83.5224152,
                    55.0934379
                ],
                [
                    83.523169,
                    55.0929979
                ],
                [
                    83.5244203,
                    55.0926355
                ],
                [
                    83.5238173,
                    55.0917986
                ],
                [
                    83.5226564,
                    55.0921351
                ],
                [
                    83.5221438,
                    55.0913414
                ],
                [
                    83.5211186,
                    55.0916002
                ],
                [
                    83.5209226,
                    55.091488
                ],
                [
                    83.518631,
                    55.0923594
                ],
                [
                    83.517259,
                    55.0926096
                ],
                [
                    83.5166258,
                    55.0916606
                ],
                [
                    83.5157966,
                    55.091859
                ],
                [
                    83.5157212,
                    55.0919539
                ],
                [
                    83.5149222,
                    55.0920747
                ],
                [
                    83.5148468,
                    55.0921869
                ]
            ],
            "longitude": 83.518898,
            "latitude": 55.093586
        },
        "10174": {
            "name": "Высокая Поляна",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    83.5239303,
                    54.3307632
                ],
                [
                    83.5248107,
                    54.3313939
                ],
                [
                    83.5240561,
                    54.3317019
                ],
                [
                    83.5251377,
                    54.3325819
                ],
                [
                    83.5259677,
                    54.3328312
                ],
                [
                    83.5268733,
                    54.3323619
                ],
                [
                    83.5278039,
                    54.3329045
                ],
                [
                    83.5272254,
                    54.3337698
                ],
                [
                    83.5287095,
                    54.3344445
                ],
                [
                    83.5303444,
                    54.3341511
                ],
                [
                    83.5298414,
                    54.3333152
                ],
                [
                    83.5305708,
                    54.3331832
                ],
                [
                    83.530923,
                    54.3335058
                ],
                [
                    83.5346457,
                    54.3328312
                ],
                [
                    83.5351739,
                    54.3333005
                ],
                [
                    83.535853,
                    54.3330952
                ],
                [
                    83.5354757,
                    54.3327579
                ],
                [
                    83.5368089,
                    54.3324645
                ],
                [
                    83.5369848,
                    54.3329632
                ],
                [
                    83.5379408,
                    54.3328312
                ],
                [
                    83.5385442,
                    54.3320062
                ],
                [
                    83.5400788,
                    54.3315992
                ],
                [
                    83.5402548,
                    54.3305872
                ],
                [
                    83.537488,
                    54.3304552
                ],
                [
                    83.5363561,
                    54.3310565
                ],
                [
                    83.533237,
                    54.3305578
                ],
                [
                    83.5322058,
                    54.3306605
                ],
                [
                    83.5293886,
                    54.3305432
                ],
                [
                    83.5290868,
                    54.3311739
                ],
                [
                    83.5283573,
                    54.3311299
                ],
                [
                    83.5280052,
                    54.3313059
                ],
                [
                    83.5270996,
                    54.3312179
                ],
                [
                    83.5287849,
                    54.3295165
                ],
                [
                    83.5259425,
                    54.3284897
                ],
                [
                    83.5250119,
                    54.3294725
                ],
                [
                    83.5264456,
                    54.3299418
                ],
                [
                    83.5262444,
                    54.3302938
                ],
                [
                    83.5254647,
                    54.3307192
                ],
                [
                    83.5248358,
                    54.3303525
                ],
                [
                    83.5239303,
                    54.3307632
                ]
            ],
            "longitude": 83.526718,
            "latitude": 54.331814
        },
        "10175": {
            "name": "Паровозный",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    83.5287127,
                    55.0935279
                ],
                [
                    83.5289046,
                    55.0938234
                ],
                [
                    83.5292587,
                    55.0937305
                ],
                [
                    83.5302619,
                    55.0944566
                ],
                [
                    83.5300996,
                    55.0945579
                ],
                [
                    83.5299816,
                    55.0951235
                ],
                [
                    83.5302177,
                    55.0954696
                ],
                [
                    83.5308225,
                    55.0955371
                ],
                [
                    83.5318257,
                    55.0951995
                ],
                [
                    83.5329469,
                    55.0963222
                ],
                [
                    83.5325487,
                    55.0963729
                ],
                [
                    83.5324454,
                    55.0966008
                ],
                [
                    83.5327405,
                    55.0968203
                ],
                [
                    83.5325487,
                    55.0969132
                ],
                [
                    83.5330798,
                    55.0972677
                ],
                [
                    83.5330356,
                    55.0981203
                ],
                [
                    83.5342601,
                    55.0987956
                ],
                [
                    83.5352191,
                    55.0983567
                ],
                [
                    83.5352781,
                    55.0982216
                ],
                [
                    83.5347912,
                    55.0979177
                ],
                [
                    83.5352781,
                    55.0975463
                ],
                [
                    83.5357797,
                    55.0978586
                ],
                [
                    83.5356764,
                    55.0976645
                ],
                [
                    83.5335962,
                    55.0961534
                ],
                [
                    83.5324602,
                    55.0948787
                ],
                [
                    83.5320617,
                    55.0950053
                ],
                [
                    83.531634,
                    55.0944312
                ],
                [
                    83.532652,
                    55.0938656
                ],
                [
                    83.5322831,
                    55.0937305
                ],
                [
                    83.5319291,
                    55.0938909
                ],
                [
                    83.5306533,
                    55.0928054
                ],
                [
                    83.5300849,
                    55.0927427
                ],
                [
                    83.5297161,
                    55.0928778
                ],
                [
                    83.5298488,
                    55.0930973
                ],
                [
                    83.5287127,
                    55.0935279
                ]
            ],
            "longitude": 83.5307545,
            "latitude": 55.0940862
        },
        "10176": {
            "name": "Дубинский",
            "population": 20,
            "type": "hamlet",
            "poly": [
                [
                    83.5383381,
                    54.8363046
                ],
                [
                    83.538498,
                    54.8371642
                ],
                [
                    83.5387113,
                    54.8374711
                ],
                [
                    83.5424157,
                    54.837333
                ],
                [
                    83.5425408,
                    54.8374238
                ],
                [
                    83.5430286,
                    54.8377781
                ],
                [
                    83.5439082,
                    54.8381157
                ],
                [
                    83.5451075,
                    54.838346
                ],
                [
                    83.5456138,
                    54.8377627
                ],
                [
                    83.5480391,
                    54.8372409
                ],
                [
                    83.5505442,
                    54.8369032
                ],
                [
                    83.55201,
                    54.8368111
                ],
                [
                    83.5547551,
                    54.8368418
                ],
                [
                    83.5547817,
                    54.8341251
                ],
                [
                    83.550944,
                    54.8340944
                ],
                [
                    83.549345,
                    54.8341711
                ],
                [
                    83.5475327,
                    54.8343553
                ],
                [
                    83.5459336,
                    54.8341251
                ],
                [
                    83.5447877,
                    54.834647
                ],
                [
                    83.5426822,
                    54.8339102
                ],
                [
                    83.5410832,
                    54.8309016
                ],
                [
                    83.5385513,
                    54.8309169
                ],
                [
                    83.5384447,
                    54.8344935
                ],
                [
                    83.5389778,
                    54.8360437
                ],
                [
                    83.5383381,
                    54.8363046
                ]
            ],
            "longitude": 83.544426,
            "latitude": 54.836926
        },
        "10177": {
            "name": "Юрт-Акбалык",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.563278,
            "latitude": 55.657207
        },
        "10178": {
            "name": "Новомотково",
            "population": 130,
            "type": "hamlet",
            "poly": [
                [
                    83.554076,
                    55.1158375
                ],
                [
                    83.5630763,
                    55.1195023
                ],
                [
                    83.5690525,
                    55.1204493
                ],
                [
                    83.5714286,
                    55.1201611
                ],
                [
                    83.5753168,
                    55.1208199
                ],
                [
                    83.5856788,
                    55.1241048
                ],
                [
                    83.5891168,
                    55.1207879
                ],
                [
                    83.5822291,
                    55.1185964
                ],
                [
                    83.5809758,
                    55.1185291
                ],
                [
                    83.5773961,
                    55.1181481
                ],
                [
                    83.5752411,
                    55.1179987
                ],
                [
                    83.5736607,
                    55.1167846
                ],
                [
                    83.5747408,
                    55.1148079
                ],
                [
                    83.5676845,
                    55.1132842
                ],
                [
                    83.5615643,
                    55.1142726
                ],
                [
                    83.5581801,
                    55.1134901
                ],
                [
                    83.554796,
                    55.113449
                ],
                [
                    83.554076,
                    55.1158375
                ]
            ],
            "longitude": 83.569618,
            "latitude": 55.117443
        },
        "10179": {
            "name": "Кузнецовка",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.583603,
            "latitude": 55.442875
        },
        "10180": {
            "name": "Елбаши",
            "population": 270,
            "type": "hamlet",
            "poly": [
                [
                    83.5755575,
                    54.7440409
                ],
                [
                    83.5761094,
                    54.7443299
                ],
                [
                    83.5763276,
                    54.744604
                ],
                [
                    83.5770336,
                    54.7450485
                ],
                [
                    83.5783043,
                    54.7450115
                ],
                [
                    83.5790488,
                    54.7448707
                ],
                [
                    83.5794724,
                    54.744604
                ],
                [
                    83.5796392,
                    54.7441298
                ],
                [
                    83.5803837,
                    54.743426
                ],
                [
                    83.5807944,
                    54.7435593
                ],
                [
                    83.5809485,
                    54.7435519
                ],
                [
                    83.5813335,
                    54.7429962
                ],
                [
                    83.587071,
                    54.7412105
                ],
                [
                    83.5879695,
                    54.741129
                ],
                [
                    83.58856,
                    54.7406919
                ],
                [
                    83.5893429,
                    54.7406919
                ],
                [
                    83.5913068,
                    54.7393803
                ],
                [
                    83.5912169,
                    54.7407734
                ],
                [
                    83.5913196,
                    54.7409364
                ],
                [
                    83.5902543,
                    54.7413143
                ],
                [
                    83.5911143,
                    54.7420108
                ],
                [
                    83.5924363,
                    54.7415366
                ],
                [
                    83.5927701,
                    54.741544
                ],
                [
                    83.593476,
                    54.7412846
                ],
                [
                    83.5938868,
                    54.7415217
                ],
                [
                    83.5944772,
                    54.7413884
                ],
                [
                    83.5944515,
                    54.7406919
                ],
                [
                    83.5957736,
                    54.7402621
                ],
                [
                    83.5963769,
                    54.7395952
                ],
                [
                    83.598084,
                    54.739121
                ],
                [
                    83.5985076,
                    54.7392469
                ],
                [
                    83.5988541,
                    54.7391358
                ],
                [
                    83.599252,
                    54.7394026
                ],
                [
                    83.5999708,
                    54.7392173
                ],
                [
                    83.599958,
                    54.7390395
                ],
                [
                    83.6005613,
                    54.7386467
                ],
                [
                    83.6008822,
                    54.7387356
                ],
                [
                    83.6018063,
                    54.7386023
                ],
                [
                    83.6025251,
                    54.73858
                ],
                [
                    83.6024481,
                    54.7384244
                ],
                [
                    83.6061833,
                    54.7367719
                ],
                [
                    83.6064785,
                    54.7360531
                ],
                [
                    83.6061704,
                    54.7358086
                ],
                [
                    83.6065041,
                    54.7354677
                ],
                [
                    83.6064656,
                    54.7350379
                ],
                [
                    83.6061448,
                    54.7348229
                ],
                [
                    83.6056313,
                    54.73486
                ],
                [
                    83.6052078,
                    54.7352379
                ],
                [
                    83.6043093,
                    54.7349786
                ],
                [
                    83.603783,
                    54.7342227
                ],
                [
                    83.6040525,
                    54.7340003
                ],
                [
                    83.6054003,
                    54.7341782
                ],
                [
                    83.6057597,
                    54.7338077
                ],
                [
                    83.6053618,
                    54.7334742
                ],
                [
                    83.6054003,
                    54.7325922
                ],
                [
                    83.6059907,
                    54.7322217
                ],
                [
                    83.6062988,
                    54.7322439
                ],
                [
                    83.6068764,
                    54.7315028
                ],
                [
                    83.6071588,
                    54.7313397
                ],
                [
                    83.6079417,
                    54.7317029
                ],
                [
                    83.6084808,
                    54.7308876
                ],
                [
                    83.6084423,
                    54.7304503
                ],
                [
                    83.6068379,
                    54.7303392
                ],
                [
                    83.6065555,
                    54.7301984
                ],
                [
                    83.6062089,
                    54.7304281
                ],
                [
                    83.6063245,
                    54.7307839
                ],
                [
                    83.6051821,
                    54.7308135
                ],
                [
                    83.6050794,
                    54.731021
                ],
                [
                    83.6036546,
                    54.7305763
                ],
                [
                    83.6032311,
                    54.7299241
                ],
                [
                    83.6036932,
                    54.7291088
                ],
                [
                    83.6035648,
                    54.7289828
                ],
                [
                    83.6013956,
                    54.7280786
                ],
                [
                    83.597268,
                    54.7298525
                ],
                [
                    83.5984177,
                    54.73194
                ],
                [
                    83.5985974,
                    54.7322365
                ],
                [
                    83.5980583,
                    54.7324811
                ],
                [
                    83.5986873,
                    54.7331925
                ],
                [
                    83.5985461,
                    54.7333185
                ],
                [
                    83.5982765,
                    54.7332889
                ],
                [
                    83.5966849,
                    54.7335631
                ],
                [
                    83.5963127,
                    54.7333704
                ],
                [
                    83.5954527,
                    54.7333778
                ],
                [
                    83.595119,
                    54.7335483
                ],
                [
                    83.5936557,
                    54.7333185
                ],
                [
                    83.5927829,
                    54.7339633
                ],
                [
                    83.5920513,
                    54.7342671
                ],
                [
                    83.5917047,
                    54.7346673
                ],
                [
                    83.588868,
                    54.734156
                ],
                [
                    83.5883161,
                    54.7348526
                ],
                [
                    83.5913068,
                    54.735401
                ],
                [
                    83.5913196,
                    54.7355788
                ],
                [
                    83.591756,
                    54.7358975
                ],
                [
                    83.5915507,
                    54.7361939
                ],
                [
                    83.5911014,
                    54.7364533
                ],
                [
                    83.5901901,
                    54.7371869
                ],
                [
                    83.5891504,
                    54.7375278
                ],
                [
                    83.5884958,
                    54.7379798
                ],
                [
                    83.5879439,
                    54.7385949
                ],
                [
                    83.5871096,
                    54.7390024
                ],
                [
                    83.5844012,
                    54.7394618
                ],
                [
                    83.583092,
                    54.7398175
                ],
                [
                    83.582078,
                    54.740477
                ],
                [
                    83.5809741,
                    54.7410401
                ],
                [
                    83.5804992,
                    54.7407882
                ],
                [
                    83.5801655,
                    54.7409808
                ],
                [
                    83.580435,
                    54.7413143
                ],
                [
                    83.5799601,
                    54.7414402
                ],
                [
                    83.5797676,
                    54.7416922
                ],
                [
                    83.579498,
                    54.7414773
                ],
                [
                    83.5791258,
                    54.7416107
                ],
                [
                    83.5774828,
                    54.7426406
                ],
                [
                    83.5769566,
                    54.7432407
                ],
                [
                    83.5770079,
                    54.7435075
                ],
                [
                    83.576379,
                    54.743826
                ],
                [
                    83.5755575,
                    54.7440409
                ]
            ],
            "longitude": 83.597435,
            "latitude": 54.736195
        },
        "10181": {
            "name": "Сарачевка",
            "population": 165,
            "type": "hamlet",
            "poly": [
                [
                    83.5677184,
                    55.487887
                ],
                [
                    83.5701309,
                    55.4889921
                ],
                [
                    83.5697198,
                    55.4904729
                ],
                [
                    83.5704833,
                    55.4904147
                ],
                [
                    83.5708945,
                    55.4908057
                ],
                [
                    83.5703951,
                    55.4910469
                ],
                [
                    83.5713791,
                    55.4910552
                ],
                [
                    83.5726248,
                    55.4921816
                ],
                [
                    83.5741396,
                    55.4925027
                ],
                [
                    83.5761799,
                    55.4937971
                ],
                [
                    83.5773995,
                    55.4935925
                ],
                [
                    83.5803363,
                    55.4965371
                ],
                [
                    83.585444,
                    55.4998714
                ],
                [
                    83.592391,
                    55.5043648
                ],
                [
                    83.5953874,
                    55.5056108
                ],
                [
                    83.594477,
                    55.5067085
                ],
                [
                    83.5953963,
                    55.507905
                ],
                [
                    83.5964357,
                    55.509678
                ],
                [
                    83.5992161,
                    55.5098726
                ],
                [
                    83.5980306,
                    55.5072989
                ],
                [
                    83.6014813,
                    55.5068083
                ],
                [
                    83.6026854,
                    55.5090535
                ],
                [
                    83.6049519,
                    55.5084709
                ],
                [
                    83.6080293,
                    55.5069053
                ],
                [
                    83.6076518,
                    55.5056315
                ],
                [
                    83.6081075,
                    55.5044231
                ],
                [
                    83.6106618,
                    55.5011745
                ],
                [
                    83.6058535,
                    55.503348
                ],
                [
                    83.6044777,
                    55.5024435
                ],
                [
                    83.6028197,
                    55.502748
                ],
                [
                    83.6018786,
                    55.5021389
                ],
                [
                    83.6016097,
                    55.5012252
                ],
                [
                    83.600471,
                    55.4998867
                ],
                [
                    83.5981089,
                    55.501226
                ],
                [
                    83.5953977,
                    55.5008627
                ],
                [
                    83.5916416,
                    55.4970533
                ],
                [
                    83.5872333,
                    55.4944192
                ],
                [
                    83.5847306,
                    55.4925036
                ],
                [
                    83.5830381,
                    55.4923385
                ],
                [
                    83.5810858,
                    55.4913254
                ],
                [
                    83.5794277,
                    55.4918585
                ],
                [
                    83.5799207,
                    55.491173
                ],
                [
                    83.5784867,
                    55.4903099
                ],
                [
                    83.5722442,
                    55.4883709
                ],
                [
                    83.5719663,
                    55.4878024
                ],
                [
                    83.5714818,
                    55.4881934
                ],
                [
                    83.5713203,
                    55.4870869
                ],
                [
                    83.5706007,
                    55.4870619
                ],
                [
                    83.5701896,
                    55.4874696
                ],
                [
                    83.5694114,
                    55.4873864
                ],
                [
                    83.5698519,
                    55.4867624
                ],
                [
                    83.5681339,
                    55.4863464
                ],
                [
                    83.5677374,
                    55.4873864
                ],
                [
                    83.5677184,
                    55.487887
                ]
            ],
            "longitude": 83.599739,
            "latitude": 55.506248
        },
        "10182": {
            "name": "Харино",
            "population": 130,
            "type": "hamlet",
            "poly": [
                [
                    83.5866229,
                    54.6140385
                ],
                [
                    83.5872867,
                    54.6142409
                ],
                [
                    83.5889638,
                    54.6138969
                ],
                [
                    83.5901867,
                    54.6142004
                ],
                [
                    83.5906409,
                    54.6140588
                ],
                [
                    83.5923179,
                    54.6144229
                ],
                [
                    83.5959865,
                    54.6147467
                ],
                [
                    83.5978034,
                    54.6163652
                ],
                [
                    83.5988166,
                    54.6158796
                ],
                [
                    83.5973841,
                    54.6143015
                ],
                [
                    83.5983274,
                    54.6140385
                ],
                [
                    83.5986768,
                    54.6147467
                ],
                [
                    83.5998997,
                    54.6148074
                ],
                [
                    83.6005286,
                    54.614342
                ],
                [
                    83.6024502,
                    54.614605
                ],
                [
                    83.6024852,
                    54.6151715
                ],
                [
                    83.6039177,
                    54.6156166
                ],
                [
                    83.6056646,
                    54.6156369
                ],
                [
                    83.6066779,
                    54.6152322
                ],
                [
                    83.6079706,
                    54.6159201
                ],
                [
                    83.607167,
                    54.6165473
                ],
                [
                    83.6047562,
                    54.6169721
                ],
                [
                    83.6040924,
                    54.61766
                ],
                [
                    83.606573,
                    54.6185097
                ],
                [
                    83.6064333,
                    54.6190559
                ],
                [
                    83.6075164,
                    54.6193391
                ],
                [
                    83.6091935,
                    54.621443
                ],
                [
                    83.6103115,
                    54.6210586
                ],
                [
                    83.6104513,
                    54.621443
                ],
                [
                    83.6123729,
                    54.6212204
                ],
                [
                    83.6130367,
                    54.6220498
                ],
                [
                    83.6133861,
                    54.6223735
                ],
                [
                    83.6142946,
                    54.62207
                ],
                [
                    83.614609,
                    54.622596
                ],
                [
                    83.6161463,
                    54.6226971
                ],
                [
                    83.617474,
                    54.6223937
                ],
                [
                    83.6170547,
                    54.6219082
                ],
                [
                    83.6160066,
                    54.621362
                ],
                [
                    83.6159017,
                    54.6207754
                ],
                [
                    83.616915,
                    54.6198246
                ],
                [
                    83.6139102,
                    54.6181455
                ],
                [
                    83.6125476,
                    54.6184287
                ],
                [
                    83.6118139,
                    54.6178218
                ],
                [
                    83.6126874,
                    54.6175791
                ],
                [
                    83.6096826,
                    54.6165068
                ],
                [
                    83.6095428,
                    54.6156976
                ],
                [
                    83.6100669,
                    54.6152322
                ],
                [
                    83.6092983,
                    54.6147264
                ],
                [
                    83.6098224,
                    54.6143015
                ],
                [
                    83.608285,
                    54.6129864
                ],
                [
                    83.6059092,
                    54.6125008
                ],
                [
                    83.605455,
                    54.6122176
                ],
                [
                    83.5952179,
                    54.6138969
                ],
                [
                    83.587147,
                    54.6127032
                ],
                [
                    83.5866229,
                    54.6140385
                ]
            ],
            "longitude": 83.609215,
            "latitude": 54.617702
        },
        "10183": {
            "name": "Михайловка",
            "population": 228,
            "type": "hamlet",
            "poly": [
                [
                    83.6015689,
                    54.8911992
                ],
                [
                    83.6023474,
                    54.8915235
                ],
                [
                    83.6027232,
                    54.8914308
                ],
                [
                    83.6032333,
                    54.8915852
                ],
                [
                    83.6030857,
                    54.8917551
                ],
                [
                    83.6033676,
                    54.8918631
                ],
                [
                    83.6031931,
                    54.8919867
                ],
                [
                    83.6037971,
                    54.8921797
                ],
                [
                    83.6035689,
                    54.8923958
                ],
                [
                    83.6050455,
                    54.8931755
                ],
                [
                    83.6055286,
                    54.8931524
                ],
                [
                    83.6057167,
                    54.8933222
                ],
                [
                    83.6061854,
                    54.8936033
                ],
                [
                    83.6055858,
                    54.8938802
                ],
                [
                    83.6052974,
                    54.8941214
                ],
                [
                    83.605009,
                    54.8949054
                ],
                [
                    83.6056906,
                    54.8960513
                ],
                [
                    83.6068442,
                    54.8969709
                ],
                [
                    83.6039865,
                    54.8990363
                ],
                [
                    83.6085221,
                    54.9013277
                ],
                [
                    83.6091776,
                    54.9007248
                ],
                [
                    83.6097805,
                    54.8998655
                ],
                [
                    83.610436,
                    54.899579
                ],
                [
                    83.6110914,
                    54.898961
                ],
                [
                    83.6113273,
                    54.8990062
                ],
                [
                    83.6119473,
                    54.8988309
                ],
                [
                    83.6117206,
                    54.8986594
                ],
                [
                    83.6139229,
                    54.8981469
                ],
                [
                    83.6146569,
                    54.8986293
                ],
                [
                    83.6151551,
                    54.8988404
                ],
                [
                    83.6157843,
                    54.8986594
                ],
                [
                    83.6182487,
                    54.8974383
                ],
                [
                    83.6174098,
                    54.8968051
                ],
                [
                    83.6173574,
                    54.8965036
                ],
                [
                    83.6178817,
                    54.8967146
                ],
                [
                    83.6180652,
                    54.8966543
                ],
                [
                    83.622627,
                    54.8994735
                ],
                [
                    83.622863,
                    54.8993378
                ],
                [
                    83.6234136,
                    54.8996996
                ],
                [
                    83.6242525,
                    54.9005288
                ],
                [
                    83.6246196,
                    54.9005288
                ],
                [
                    83.6248817,
                    54.9007248
                ],
                [
                    83.6262358,
                    54.900501
                ],
                [
                    83.6262713,
                    54.9000464
                ],
                [
                    83.6266907,
                    54.9000765
                ],
                [
                    83.6260877,
                    54.8995489
                ],
                [
                    83.6267432,
                    54.8992022
                ],
                [
                    83.6262975,
                    54.898961
                ],
                [
                    83.6260091,
                    54.8990966
                ],
                [
                    83.6254323,
                    54.8988253
                ],
                [
                    83.6250127,
                    54.8983278
                ],
                [
                    83.6246458,
                    54.8981318
                ],
                [
                    83.6207394,
                    54.8967297
                ],
                [
                    83.621421,
                    54.895991
                ],
                [
                    83.6211327,
                    54.895795
                ],
                [
                    83.6207394,
                    54.8958101
                ],
                [
                    83.6201102,
                    54.8960211
                ],
                [
                    83.6185896,
                    54.8955236
                ],
                [
                    83.6183012,
                    54.8956291
                ],
                [
                    83.6181439,
                    54.895795
                ],
                [
                    83.6178555,
                    54.8958553
                ],
                [
                    83.6175671,
                    54.8957799
                ],
                [
                    83.6175671,
                    54.8956291
                ],
                [
                    83.6170952,
                    54.8955085
                ],
                [
                    83.6160727,
                    54.8947245
                ],
                [
                    83.6158892,
                    54.8947094
                ],
                [
                    83.6170427,
                    54.8938651
                ],
                [
                    83.6179079,
                    54.8942873
                ],
                [
                    83.6187731,
                    54.8936088
                ],
                [
                    83.6183012,
                    54.8934882
                ],
                [
                    83.6186682,
                    54.8932017
                ],
                [
                    83.6180914,
                    54.8930208
                ],
                [
                    83.6185371,
                    54.8923573
                ],
                [
                    83.6181701,
                    54.8922216
                ],
                [
                    83.6184847,
                    54.8917391
                ],
                [
                    83.6173311,
                    54.8910455
                ],
                [
                    83.6185394,
                    54.8900081
                ],
                [
                    83.6197956,
                    54.8903368
                ],
                [
                    83.6201364,
                    54.8898242
                ],
                [
                    83.6188255,
                    54.8894774
                ],
                [
                    83.6195858,
                    54.8887686
                ],
                [
                    83.6218143,
                    54.8877885
                ],
                [
                    83.620818,
                    54.88714
                ],
                [
                    83.6203461,
                    54.8874115
                ],
                [
                    83.6210016,
                    54.8877885
                ],
                [
                    83.6199004,
                    54.8883012
                ],
                [
                    83.6186682,
                    54.8877281
                ],
                [
                    83.6178817,
                    54.8884218
                ],
                [
                    83.6188516,
                    54.8889043
                ],
                [
                    83.6176458,
                    54.8903067
                ],
                [
                    83.6162824,
                    54.88999
                ],
                [
                    83.6157319,
                    54.890744
                ],
                [
                    83.6169641,
                    54.8911059
                ],
                [
                    83.6153255,
                    54.8927569
                ],
                [
                    83.6144472,
                    54.8944682
                ],
                [
                    83.6132937,
                    54.8934429
                ],
                [
                    83.6123498,
                    54.893458
                ],
                [
                    83.6114847,
                    54.8931414
                ],
                [
                    83.611039,
                    54.8928549
                ],
                [
                    83.6106719,
                    54.8924629
                ],
                [
                    83.6080764,
                    54.8911059
                ],
                [
                    83.6076307,
                    54.8903218
                ],
                [
                    83.6072899,
                    54.8903067
                ],
                [
                    83.6067918,
                    54.8905178
                ],
                [
                    83.6055071,
                    54.8902313
                ],
                [
                    83.6047468,
                    54.8911662
                ],
                [
                    83.603567,
                    54.8906384
                ],
                [
                    83.6033835,
                    54.8907741
                ],
                [
                    83.6025446,
                    54.8904122
                ],
                [
                    83.6015689,
                    54.8911992
                ]
            ],
            "longitude": 83.611679,
            "latitude": 54.896091
        },
        "10184": {
            "name": "Падун",
            "population": 63,
            "type": "hamlet",
            "poly": [
                [
                    83.6101077,
                    54.3442606
                ],
                [
                    83.6122699,
                    54.3454932
                ],
                [
                    83.616024,
                    54.3465458
                ],
                [
                    83.6193267,
                    54.3445237
                ],
                [
                    83.6196356,
                    54.3408533
                ],
                [
                    83.6191367,
                    54.3385816
                ],
                [
                    83.6155963,
                    54.3390525
                ],
                [
                    83.6122936,
                    54.3427093
                ],
                [
                    83.6101077,
                    54.3442606
                ]
            ],
            "longitude": 83.614151,
            "latitude": 54.344215
        },
        "10185": {
            "name": "Лихановский",
            "population": 112,
            "type": "hamlet",
            "poly": [
                [
                    83.619274,
                    54.2983496
                ],
                [
                    83.6196787,
                    54.2985726
                ],
                [
                    83.6214247,
                    54.2985643
                ],
                [
                    83.622062,
                    54.2986645
                ],
                [
                    83.6224218,
                    54.2988088
                ],
                [
                    83.6227142,
                    54.3000422
                ],
                [
                    83.6236585,
                    54.3004883
                ],
                [
                    83.6243554,
                    54.3004358
                ],
                [
                    83.6244229,
                    54.3000947
                ],
                [
                    83.6239283,
                    54.2996223
                ],
                [
                    83.6246479,
                    54.2991893
                ],
                [
                    83.6256372,
                    54.300016
                ],
                [
                    83.6277058,
                    54.3025088
                ],
                [
                    83.6298868,
                    54.3026925
                ],
                [
                    83.6301342,
                    54.3010787
                ],
                [
                    83.6314833,
                    54.2993861
                ],
                [
                    83.634766,
                    54.2992681
                ],
                [
                    83.634766,
                    54.2978903
                ],
                [
                    83.6339791,
                    54.2978641
                ],
                [
                    83.634069,
                    54.2967619
                ],
                [
                    83.6312358,
                    54.2965125
                ],
                [
                    83.6306738,
                    54.2971424
                ],
                [
                    83.6301342,
                    54.2971949
                ],
                [
                    83.6300442,
                    54.2963551
                ],
                [
                    83.6275034,
                    54.2963026
                ],
                [
                    83.6273011,
                    54.2971818
                ],
                [
                    83.6263117,
                    54.2970637
                ],
                [
                    83.6261319,
                    54.2963026
                ],
                [
                    83.6252774,
                    54.2963026
                ],
                [
                    83.62512,
                    54.2972474
                ],
                [
                    83.6240183,
                    54.2971818
                ],
                [
                    83.6241982,
                    54.2964207
                ],
                [
                    83.6231638,
                    54.2964076
                ],
                [
                    83.6227816,
                    54.2966831
                ],
                [
                    83.6203532,
                    54.296565
                ],
                [
                    83.619971,
                    54.2974573
                ],
                [
                    83.6192964,
                    54.2975229
                ],
                [
                    83.619274,
                    54.2983496
                ]
            ],
            "longitude": 83.627029,
            "latitude": 54.298553
        },
        "10186": {
            "name": "Умрева",
            "population": 175,
            "type": "hamlet",
            "poly": [
                [
                    83.6106488,
                    55.546607
                ],
                [
                    83.6123072,
                    55.5470203
                ],
                [
                    83.6123214,
                    55.5483744
                ],
                [
                    83.6181866,
                    55.5486631
                ],
                [
                    83.618263,
                    55.5484002
                ],
                [
                    83.6189865,
                    55.5484033
                ],
                [
                    83.620253,
                    55.5487979
                ],
                [
                    83.6254414,
                    55.5481914
                ],
                [
                    83.6272574,
                    55.5480827
                ],
                [
                    83.6273796,
                    55.5475682
                ],
                [
                    83.6286989,
                    55.5475358
                ],
                [
                    83.6296453,
                    55.5477142
                ],
                [
                    83.6291865,
                    55.5486715
                ],
                [
                    83.6297027,
                    55.5491907
                ],
                [
                    83.6298461,
                    55.5496125
                ],
                [
                    83.6308499,
                    55.5502452
                ],
                [
                    83.63083,
                    55.5507583
                ],
                [
                    83.6320587,
                    55.5511424
                ],
                [
                    83.6332448,
                    55.5502248
                ],
                [
                    83.6332566,
                    55.5495667
                ],
                [
                    83.6340668,
                    55.5490389
                ],
                [
                    83.6344184,
                    55.5486234
                ],
                [
                    83.6359061,
                    55.5482558
                ],
                [
                    83.6356254,
                    55.5475476
                ],
                [
                    83.6365462,
                    55.5466266
                ],
                [
                    83.6360672,
                    55.5460391
                ],
                [
                    83.6313708,
                    55.544376
                ],
                [
                    83.6327332,
                    55.5439906
                ],
                [
                    83.6342747,
                    55.5449845
                ],
                [
                    83.6354219,
                    55.5448222
                ],
                [
                    83.6374295,
                    55.5441732
                ],
                [
                    83.6388228,
                    55.5438066
                ],
                [
                    83.637897,
                    55.5425556
                ],
                [
                    83.6365167,
                    55.5427467
                ],
                [
                    83.6358264,
                    55.5417746
                ],
                [
                    83.634784,
                    55.5414256
                ],
                [
                    83.6326988,
                    55.5424143
                ],
                [
                    83.6315682,
                    55.5433864
                ],
                [
                    83.6313626,
                    55.5438765
                ],
                [
                    83.6280838,
                    55.542464
                ],
                [
                    83.6267812,
                    55.5429377
                ],
                [
                    83.6262232,
                    55.5428214
                ],
                [
                    83.6253502,
                    55.5437912
                ],
                [
                    83.6234588,
                    55.5443878
                ],
                [
                    83.6220225,
                    55.5441606
                ],
                [
                    83.6213414,
                    55.5442417
                ],
                [
                    83.6199972,
                    55.5430828
                ],
                [
                    83.6184017,
                    55.5430247
                ],
                [
                    83.6171828,
                    55.5418483
                ],
                [
                    83.6160715,
                    55.5419497
                ],
                [
                    83.6170035,
                    55.543187
                ],
                [
                    83.6159639,
                    55.5436738
                ],
                [
                    83.6171828,
                    55.5454587
                ],
                [
                    83.610749,
                    55.5454825
                ],
                [
                    83.6106488,
                    55.546607
                ]
            ],
            "longitude": 83.629333,
            "latitude": 55.546612
        },
        "10187": {
            "name": "Шумиха",
            "population": 43,
            "type": "hamlet",
            "poly": [
                [
                    83.6398579,
                    55.5991378
                ],
                [
                    83.6477448,
                    55.6042907
                ],
                [
                    83.6525454,
                    55.6038258
                ],
                [
                    83.6553572,
                    55.6014625
                ],
                [
                    83.6583062,
                    55.6017725
                ],
                [
                    83.6631755,
                    55.6005326
                ],
                [
                    83.6622839,
                    55.5990603
                ],
                [
                    83.6561116,
                    55.6003776
                ],
                [
                    83.6562488,
                    55.5984403
                ],
                [
                    83.6527512,
                    55.5963479
                ],
                [
                    83.6537113,
                    55.5954566
                ],
                [
                    83.651311,
                    55.5941778
                ],
                [
                    83.6469218,
                    55.5950304
                ],
                [
                    83.645413,
                    55.5977041
                ],
                [
                    83.6398579,
                    55.5991378
                ]
            ],
            "longitude": 83.647934,
            "latitude": 55.601086
        },
        "10188": {
            "name": "Красный Октябрь",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.660667,
            "latitude": 55.14307
        },
        "10189": {
            "name": "Камень",
            "population": 17,
            "type": "hamlet",
            "poly": [
                [
                    83.6633748,
                    55.6231002
                ],
                [
                    83.6657339,
                    55.6276847
                ],
                [
                    83.6657339,
                    55.6291405
                ],
                [
                    83.6689161,
                    55.6313095
                ],
                [
                    83.6720983,
                    55.62976
                ],
                [
                    83.6703426,
                    55.6283352
                ],
                [
                    83.6707815,
                    55.6276538
                ],
                [
                    83.6737569,
                    55.6289349
                ],
                [
                    83.6752691,
                    55.6281883
                ],
                [
                    83.6746009,
                    55.6268572
                ],
                [
                    83.6729761,
                    55.6260121
                ],
                [
                    83.6724823,
                    55.6249589
                ],
                [
                    83.6735881,
                    55.6229628
                ],
                [
                    83.6707561,
                    55.6197885
                ],
                [
                    83.6677849,
                    55.6191784
                ],
                [
                    83.6711796,
                    55.6218348
                ],
                [
                    83.6686418,
                    55.6244632
                ],
                [
                    83.6633748,
                    55.6231002
                ]
            ],
            "longitude": 83.66938,
            "latitude": 55.626583
        },
        "10190": {
            "name": "Боровушка",
            "population": 21,
            "type": "hamlet",
            "poly": [
                [
                    83.6663152,
                    55.1234513
                ],
                [
                    83.6664903,
                    55.1237884
                ],
                [
                    83.6683563,
                    55.1236618
                ],
                [
                    83.6684787,
                    55.1241477
                ],
                [
                    83.671238,
                    55.1240958
                ],
                [
                    83.6712769,
                    55.1238958
                ],
                [
                    83.6739196,
                    55.1237477
                ],
                [
                    83.6740233,
                    55.1238958
                ],
                [
                    83.6744508,
                    55.1238291
                ],
                [
                    83.6744508,
                    55.1236662
                ],
                [
                    83.6756685,
                    55.1234365
                ],
                [
                    83.6773267,
                    55.1235032
                ],
                [
                    83.678687,
                    55.1214068
                ],
                [
                    83.6797751,
                    55.1208586
                ],
                [
                    83.6800601,
                    55.1207993
                ],
                [
                    83.6808115,
                    55.1201326
                ],
                [
                    83.6779485,
                    55.1191769
                ],
                [
                    83.6797492,
                    55.11731
                ],
                [
                    83.6810058,
                    55.1178286
                ],
                [
                    83.6815629,
                    55.1176063
                ],
                [
                    83.6817831,
                    55.1171025
                ],
                [
                    83.6820811,
                    55.1171247
                ],
                [
                    83.6823661,
                    55.1166728
                ],
                [
                    83.6841538,
                    55.1168136
                ],
                [
                    83.6844388,
                    55.1161616
                ],
                [
                    83.6817831,
                    55.1156504
                ],
                [
                    83.6819645,
                    55.11548
                ],
                [
                    83.6825086,
                    55.1151614
                ],
                [
                    83.6823143,
                    55.1149539
                ],
                [
                    83.6824827,
                    55.1146575
                ],
                [
                    83.6837004,
                    55.1147539
                ],
                [
                    83.6838947,
                    55.1136869
                ],
                [
                    83.6824438,
                    55.1138203
                ],
                [
                    83.6816795,
                    55.1136647
                ],
                [
                    83.6814074,
                    55.1139759
                ],
                [
                    83.6811613,
                    55.1139685
                ],
                [
                    83.6807597,
                    55.1144056
                ],
                [
                    83.6814333,
                    55.1145686
                ],
                [
                    83.6812261,
                    55.1152058
                ],
                [
                    83.6799824,
                    55.1150947
                ],
                [
                    83.6788295,
                    55.1164061
                ],
                [
                    83.6789849,
                    55.1166061
                ],
                [
                    83.6788813,
                    55.1167543
                ],
                [
                    83.6785833,
                    55.1167247
                ],
                [
                    83.6784667,
                    55.1169617
                ],
                [
                    83.678687,
                    55.1169766
                ],
                [
                    83.6784797,
                    55.1173692
                ],
                [
                    83.6791404,
                    55.1174285
                ],
                [
                    83.6775988,
                    55.1192732
                ],
                [
                    83.6769769,
                    55.1191102
                ],
                [
                    83.6770158,
                    55.1188806
                ],
                [
                    83.6762903,
                    55.1186509
                ],
                [
                    83.6756167,
                    55.1191102
                ],
                [
                    83.6753965,
                    55.119051
                ],
                [
                    83.6752281,
                    55.119214
                ],
                [
                    83.6764976,
                    55.1196066
                ],
                [
                    83.6756037,
                    55.1205326
                ],
                [
                    83.674943,
                    55.1206808
                ],
                [
                    83.6742435,
                    55.1204734
                ],
                [
                    83.6728444,
                    55.1217846
                ],
                [
                    83.6728444,
                    55.1221698
                ],
                [
                    83.6716655,
                    55.1222661
                ],
                [
                    83.6716785,
                    55.1225328
                ],
                [
                    83.6700591,
                    55.122518
                ],
                [
                    83.6697482,
                    55.1227921
                ],
                [
                    83.667805,
                    55.1228884
                ],
                [
                    83.6665742,
                    55.1232662
                ],
                [
                    83.6663152,
                    55.1234513
                ]
            ],
            "longitude": 83.676964,
            "latitude": 55.121128
        },
        "10191": {
            "name": "Новослободка",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    83.6740435,
                    55.3083186
                ],
                [
                    83.6771193,
                    55.3101014
                ],
                [
                    83.6790064,
                    55.3111316
                ],
                [
                    83.6817041,
                    55.3102347
                ],
                [
                    83.6838972,
                    55.3106807
                ],
                [
                    83.6858792,
                    55.3092583
                ],
                [
                    83.6863155,
                    55.3079484
                ],
                [
                    83.6824556,
                    55.3053419
                ],
                [
                    83.682198,
                    55.3045504
                ],
                [
                    83.6792622,
                    55.3033364
                ],
                [
                    83.6801226,
                    55.3013663
                ],
                [
                    83.6780363,
                    55.3009705
                ],
                [
                    83.6769522,
                    55.3031509
                ],
                [
                    83.6773975,
                    55.3048316
                ],
                [
                    83.6758106,
                    55.3063115
                ],
                [
                    83.6740435,
                    55.3083186
                ]
            ],
            "longitude": 83.679939,
            "latitude": 55.30687
        },
        "10192": {
            "name": "Новошмаково",
            "population": 125,
            "type": "hamlet",
            "poly": [
                [
                    83.6749014,
                    54.2360399
                ],
                [
                    83.6750385,
                    54.2371953
                ],
                [
                    83.6798711,
                    54.2367941
                ],
                [
                    83.6837426,
                    54.2363448
                ],
                [
                    83.6833307,
                    54.2355745
                ],
                [
                    83.6842643,
                    54.2354462
                ],
                [
                    83.6845389,
                    54.2361522
                ],
                [
                    83.6859666,
                    54.2370027
                ],
                [
                    83.6854999,
                    54.2383507
                ],
                [
                    83.6844565,
                    54.2389444
                ],
                [
                    83.6850056,
                    54.2401318
                ],
                [
                    83.6867354,
                    54.2405971
                ],
                [
                    83.6902225,
                    54.237452
                ],
                [
                    83.6910462,
                    54.2359436
                ],
                [
                    83.6925289,
                    54.2369546
                ],
                [
                    83.6948079,
                    54.2379816
                ],
                [
                    83.6973614,
                    54.2379655
                ],
                [
                    83.6964553,
                    54.2365695
                ],
                [
                    83.6953021,
                    54.2361843
                ],
                [
                    83.6938743,
                    54.234371
                ],
                [
                    83.6915405,
                    54.2334402
                ],
                [
                    83.6916228,
                    54.2320921
                ],
                [
                    83.6900303,
                    54.2312736
                ],
                [
                    83.688328,
                    54.2310168
                ],
                [
                    83.6876415,
                    54.2313859
                ],
                [
                    83.6882181,
                    54.2317711
                ],
                [
                    83.69025,
                    54.2318513
                ],
                [
                    83.69025,
                    54.2331834
                ],
                [
                    83.6888771,
                    54.2325575
                ],
                [
                    83.6881083,
                    54.2327822
                ],
                [
                    83.6862687,
                    54.2331513
                ],
                [
                    83.6850879,
                    54.2339377
                ],
                [
                    83.682507,
                    54.2346117
                ],
                [
                    83.6812165,
                    54.2349808
                ],
                [
                    83.6814911,
                    54.2355906
                ],
                [
                    83.6778942,
                    54.2359436
                ],
                [
                    83.6775372,
                    54.2356066
                ],
                [
                    83.6756152,
                    54.2354943
                ],
                [
                    83.6749014,
                    54.2360399
                ]
            ],
            "longitude": 83.690384,
            "latitude": 54.235203
        },
        "10193": {
            "name": "Китерня",
            "population": 186,
            "type": "hamlet",
            "poly": [
                [
                    83.6843634,
                    54.8459437
                ],
                [
                    83.6844754,
                    54.8466045
                ],
                [
                    83.6857658,
                    54.8465999
                ],
                [
                    83.6856082,
                    54.8470785
                ],
                [
                    83.6852068,
                    54.8470868
                ],
                [
                    83.6852355,
                    54.8475737
                ],
                [
                    83.6858661,
                    54.8475572
                ],
                [
                    83.6858375,
                    54.8480523
                ],
                [
                    83.6887489,
                    54.8481419
                ],
                [
                    83.6907085,
                    54.8479485
                ],
                [
                    83.6916883,
                    54.849528
                ],
                [
                    83.6940398,
                    54.8491896
                ],
                [
                    83.6935639,
                    54.8478679
                ],
                [
                    83.6937879,
                    54.8478357
                ],
                [
                    83.6935079,
                    54.8473199
                ],
                [
                    83.692892,
                    54.8475133
                ],
                [
                    83.6926401,
                    54.8464979
                ],
                [
                    83.6923042,
                    54.8464496
                ],
                [
                    83.6921642,
                    54.8458371
                ],
                [
                    83.693032,
                    54.8458048
                ],
                [
                    83.69306,
                    54.8452245
                ],
                [
                    83.6924441,
                    54.8451762
                ],
                [
                    83.6927801,
                    54.8447732
                ],
                [
                    83.6924161,
                    54.8438222
                ],
                [
                    83.6925561,
                    54.8435804
                ],
                [
                    83.6918842,
                    54.8421135
                ],
                [
                    83.6922762,
                    54.8420813
                ],
                [
                    83.6922482,
                    54.8417911
                ],
                [
                    83.6920522,
                    54.8414848
                ],
                [
                    83.6921642,
                    54.8413397
                ],
                [
                    83.6925841,
                    54.8412914
                ],
                [
                    83.6946557,
                    54.8422908
                ],
                [
                    83.6956635,
                    54.8426777
                ],
                [
                    83.6955515,
                    54.8427583
                ],
                [
                    83.695859,
                    54.8432063
                ],
                [
                    83.6953728,
                    54.8434281
                ],
                [
                    83.6956755,
                    54.8436922
                ],
                [
                    83.69607,
                    54.8436235
                ],
                [
                    83.696125,
                    54.8436922
                ],
                [
                    83.6966571,
                    54.8435443
                ],
                [
                    83.6977141,
                    54.8427087
                ],
                [
                    83.6990758,
                    54.8431832
                ],
                [
                    83.7000432,
                    54.8434205
                ],
                [
                    83.7006166,
                    54.8434308
                ],
                [
                    83.7008495,
                    54.8430904
                ],
                [
                    83.7011003,
                    54.843111
                ],
                [
                    83.7013332,
                    54.8434102
                ],
                [
                    83.7027486,
                    54.8439879
                ],
                [
                    83.702874,
                    54.8443387
                ],
                [
                    83.7030532,
                    54.8448029
                ],
                [
                    83.7035011,
                    54.8452877
                ],
                [
                    83.7050419,
                    54.8456901
                ],
                [
                    83.7055794,
                    54.8460614
                ],
                [
                    83.7064752,
                    54.8462471
                ],
                [
                    83.7077293,
                    54.8458035
                ],
                [
                    83.7072098,
                    54.8457726
                ],
                [
                    83.7065827,
                    54.8455147
                ],
                [
                    83.7063677,
                    54.8453393
                ],
                [
                    83.7058481,
                    54.8443077
                ],
                [
                    83.7049882,
                    54.8433689
                ],
                [
                    83.7044507,
                    54.8428944
                ],
                [
                    83.7047373,
                    54.8427499
                ],
                [
                    83.7042715,
                    54.8424817
                ],
                [
                    83.7042894,
                    54.8422032
                ],
                [
                    83.7041282,
                    54.8421928
                ],
                [
                    83.7041819,
                    54.841254
                ],
                [
                    83.7036803,
                    54.8411818
                ],
                [
                    83.7033219,
                    54.8413365
                ],
                [
                    83.6972483,
                    54.8405834
                ],
                [
                    83.6972304,
                    54.8397271
                ],
                [
                    83.69603,
                    54.8397064
                ],
                [
                    83.6944175,
                    54.8399128
                ],
                [
                    83.6939338,
                    54.8402842
                ],
                [
                    83.6947042,
                    54.840604
                ],
                [
                    83.6948296,
                    54.8407381
                ],
                [
                    83.693207,
                    54.8410574
                ],
                [
                    83.6925885,
                    54.84072
                ],
                [
                    83.6917659,
                    54.8407897
                ],
                [
                    83.6916942,
                    54.8409239
                ],
                [
                    83.6913812,
                    54.8411737
                ],
                [
                    83.6909238,
                    54.841254
                ],
                [
                    83.6905476,
                    54.8413984
                ],
                [
                    83.6902788,
                    54.8412746
                ],
                [
                    83.688858,
                    54.8412761
                ],
                [
                    83.6876272,
                    54.8413675
                ],
                [
                    83.6864477,
                    54.8414407
                ],
                [
                    83.6855048,
                    54.8416099
                ],
                [
                    83.6849398,
                    54.8418008
                ],
                [
                    83.6849398,
                    54.8422651
                ],
                [
                    83.6851548,
                    54.8426365
                ],
                [
                    83.6851548,
                    54.8431523
                ],
                [
                    83.6849513,
                    54.843687
                ],
                [
                    83.6853432,
                    54.8439611
                ],
                [
                    83.6857911,
                    54.8449927
                ],
                [
                    83.6857911,
                    54.8458631
                ],
                [
                    83.6843634,
                    54.8459437
                ]
            ],
            "longitude": 83.691093,
            "latitude": 54.843586
        },
        "10194": {
            "name": "Девкино",
            "population": 110,
            "type": "hamlet",
            "poly": [
                [
                    83.6837865,
                    54.6132439
                ],
                [
                    83.6855771,
                    54.6139773
                ],
                [
                    83.6877136,
                    54.6154712
                ],
                [
                    83.6888334,
                    54.6162542
                ],
                [
                    83.6912582,
                    54.6190261
                ],
                [
                    83.6903376,
                    54.6260139
                ],
                [
                    83.6998148,
                    54.6226764
                ],
                [
                    83.7008629,
                    54.6210834
                ],
                [
                    83.701256,
                    54.6193639
                ],
                [
                    83.7008629,
                    54.6172903
                ],
                [
                    83.7010813,
                    54.6168098
                ],
                [
                    83.7038764,
                    54.6163546
                ],
                [
                    83.7037891,
                    54.6152924
                ],
                [
                    83.7007319,
                    54.6153177
                ],
                [
                    83.6997274,
                    54.614205
                ],
                [
                    83.6968013,
                    54.6149637
                ],
                [
                    83.6950107,
                    54.6124599
                ],
                [
                    83.6933947,
                    54.6130163
                ],
                [
                    83.6892171,
                    54.6106081
                ],
                [
                    83.6882412,
                    54.6106388
                ],
                [
                    83.6860139,
                    54.610563
                ],
                [
                    83.6850094,
                    54.6123334
                ],
                [
                    83.6837865,
                    54.6132439
                ]
            ],
            "longitude": 83.696487,
            "latitude": 54.615974
        },
        "10195": {
            "name": "Старобибеево",
            "population": 22,
            "type": "hamlet",
            "poly": [
                [
                    83.6904345,
                    55.7098995
                ],
                [
                    83.6922503,
                    55.7123499
                ],
                [
                    83.6983592,
                    55.711876
                ],
                [
                    83.7013747,
                    55.7121091
                ],
                [
                    83.7078238,
                    55.713636
                ],
                [
                    83.7102866,
                    55.7121138
                ],
                [
                    83.7101756,
                    55.709386
                ],
                [
                    83.7083071,
                    55.7084527
                ],
                [
                    83.7045349,
                    55.7085483
                ],
                [
                    83.7037449,
                    55.7098589
                ],
                [
                    83.7033776,
                    55.7097684
                ],
                [
                    83.7005649,
                    55.7081219
                ],
                [
                    83.6991645,
                    55.7088185
                ],
                [
                    83.6980389,
                    55.7078806
                ],
                [
                    83.6974915,
                    55.7077013
                ],
                [
                    83.6945777,
                    55.7067472
                ],
                [
                    83.6913915,
                    55.7070234
                ],
                [
                    83.6917766,
                    55.7083056
                ],
                [
                    83.6904345,
                    55.7098995
                ]
            ],
            "longitude": 83.701424,
            "latitude": 55.710899
        },
        "10196": {
            "name": "Кувшинка",
            "population": 16,
            "type": "hamlet",
            "poly": [
                [
                    83.7161081,
                    55.1389928
                ],
                [
                    83.7189621,
                    55.1394605
                ],
                [
                    83.7193702,
                    55.1391939
                ],
                [
                    83.720026,
                    55.1393022
                ],
                [
                    83.7200406,
                    55.1390356
                ],
                [
                    83.7194139,
                    55.1389607
                ],
                [
                    83.7194285,
                    55.1387941
                ],
                [
                    83.719924,
                    55.1388024
                ],
                [
                    83.7198365,
                    55.1384608
                ],
                [
                    83.7187435,
                    55.1381526
                ],
                [
                    83.7189767,
                    55.1378944
                ],
                [
                    83.7171841,
                    55.1372529
                ],
                [
                    83.7166205,
                    55.1387813
                ],
                [
                    83.7161935,
                    55.1387488
                ],
                [
                    83.7161081,
                    55.1389928
                ]
            ],
            "longitude": 83.7179734,
            "latitude": 55.1385207
        },
        "10197": {
            "name": "Порос",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    83.7104872,
                    55.3501667
                ],
                [
                    83.7109976,
                    55.3504505
                ],
                [
                    83.7129881,
                    55.3512788
                ],
                [
                    83.7200063,
                    55.3548187
                ],
                [
                    83.7195502,
                    55.3551595
                ],
                [
                    83.7203762,
                    55.3555476
                ],
                [
                    83.7198382,
                    55.3561943
                ],
                [
                    83.7192761,
                    55.3566361
                ],
                [
                    83.7174676,
                    55.3556555
                ],
                [
                    83.7169732,
                    55.355522
                ],
                [
                    83.7167036,
                    55.3556492
                ],
                [
                    83.7156252,
                    55.3558024
                ],
                [
                    83.7129949,
                    55.3570092
                ],
                [
                    83.7138494,
                    55.357474
                ],
                [
                    83.7153613,
                    55.3578518
                ],
                [
                    83.7158737,
                    55.3580858
                ],
                [
                    83.7179218,
                    55.359912
                ],
                [
                    83.7201446,
                    55.3612446
                ],
                [
                    83.7204853,
                    55.3618947
                ],
                [
                    83.7212708,
                    55.3621602
                ],
                [
                    83.7226586,
                    55.3622355
                ],
                [
                    83.7266265,
                    55.3607864
                ],
                [
                    83.7251011,
                    55.3600596
                ],
                [
                    83.7259853,
                    55.3594371
                ],
                [
                    83.7227886,
                    55.3579146
                ],
                [
                    83.7231237,
                    55.3577203
                ],
                [
                    83.7214329,
                    55.3569084
                ],
                [
                    83.7210113,
                    55.3571953
                ],
                [
                    83.7205953,
                    55.3570209
                ],
                [
                    83.7207589,
                    55.356897
                ],
                [
                    83.7207187,
                    55.3568758
                ],
                [
                    83.7209338,
                    55.3567095
                ],
                [
                    83.7198887,
                    55.3562177
                ],
                [
                    83.7204164,
                    55.3555655
                ],
                [
                    83.7208925,
                    55.355784
                ],
                [
                    83.7215292,
                    55.3553486
                ],
                [
                    83.7203648,
                    55.3546834
                ],
                [
                    83.7207434,
                    55.3544307
                ],
                [
                    83.7208954,
                    55.3540622
                ],
                [
                    83.7198485,
                    55.352942
                ],
                [
                    83.7190684,
                    55.352642
                ],
                [
                    83.7198371,
                    55.3518887
                ],
                [
                    83.7189193,
                    55.3507407
                ],
                [
                    83.7152883,
                    55.3493807
                ],
                [
                    83.714078,
                    55.349035
                ],
                [
                    83.7135044,
                    55.349459
                ],
                [
                    83.7116573,
                    55.3486763
                ],
                [
                    83.71051,
                    55.3493155
                ],
                [
                    83.7110034,
                    55.3496514
                ],
                [
                    83.71086,
                    55.3497493
                ],
                [
                    83.7104872,
                    55.3501667
                ]
            ],
            "longitude": 83.720406,
            "latitude": 55.359623
        },
        "10198": {
            "name": "Татарка",
            "population": 64,
            "type": "hamlet",
            "poly": [
                [
                    83.7082071,
                    54.1947044
                ],
                [
                    83.7109597,
                    54.1950579
                ],
                [
                    83.71482,
                    54.1946259
                ],
                [
                    83.7177405,
                    54.1934672
                ],
                [
                    83.7189489,
                    54.1930351
                ],
                [
                    83.7201909,
                    54.1915033
                ],
                [
                    83.7226078,
                    54.1926424
                ],
                [
                    83.7246891,
                    54.1897553
                ],
                [
                    83.7297243,
                    54.1916997
                ],
                [
                    83.7334168,
                    54.1897749
                ],
                [
                    83.7338867,
                    54.1890286
                ],
                [
                    83.7369078,
                    54.1901284
                ],
                [
                    83.7408353,
                    54.1907373
                ],
                [
                    83.7423459,
                    54.1888518
                ],
                [
                    83.7373106,
                    54.1875554
                ],
                [
                    83.7385191,
                    54.1866716
                ],
                [
                    83.7323761,
                    54.183843
                ],
                [
                    83.7286501,
                    54.1841573
                ],
                [
                    83.7255618,
                    54.1862001
                ],
                [
                    83.7268038,
                    54.1869073
                ],
                [
                    83.7243869,
                    54.1877126
                ],
                [
                    83.7216344,
                    54.1909926
                ],
                [
                    83.7194524,
                    54.1897553
                ],
                [
                    83.718009,
                    54.1895196
                ],
                [
                    83.7166998,
                    54.1908355
                ],
                [
                    83.7150214,
                    54.1899124
                ],
                [
                    83.7154914,
                    54.1893821
                ],
                [
                    83.7150214,
                    54.1891857
                ],
                [
                    83.7126045,
                    54.189932
                ],
                [
                    83.7119667,
                    54.1905802
                ],
                [
                    83.7147865,
                    54.1922692
                ],
                [
                    83.7139473,
                    54.1927602
                ],
                [
                    83.7083414,
                    54.1936832
                ],
                [
                    83.7082071,
                    54.1947044
                ]
            ],
            "longitude": 83.7314,
            "latitude": 54.187412
        },
        "10199": {
            "name": "Самарский",
            "population": 118,
            "type": "hamlet",
            "poly": [
                [
                    83.7279991,
                    55.079243
                ],
                [
                    83.7283271,
                    55.0795018
                ],
                [
                    83.7296481,
                    55.0790331
                ],
                [
                    83.7301609,
                    55.0795015
                ],
                [
                    83.7291652,
                    55.0798264
                ],
                [
                    83.7335947,
                    55.0838631
                ],
                [
                    83.7343713,
                    55.0836286
                ],
                [
                    83.7347171,
                    55.0840019
                ],
                [
                    83.7339098,
                    55.0842588
                ],
                [
                    83.733542,
                    55.0844756
                ],
                [
                    83.7332431,
                    55.0842682
                ],
                [
                    83.733019,
                    55.084342
                ],
                [
                    83.7333617,
                    55.0846753
                ],
                [
                    83.7330939,
                    55.0847795
                ],
                [
                    83.7331361,
                    55.0848644
                ],
                [
                    83.7330127,
                    55.0849426
                ],
                [
                    83.733122,
                    55.0850275
                ],
                [
                    83.7332759,
                    55.0849703
                ],
                [
                    83.7336428,
                    55.0853126
                ],
                [
                    83.7333594,
                    55.0854207
                ],
                [
                    83.7342313,
                    55.0860785
                ],
                [
                    83.7349514,
                    55.0858221
                ],
                [
                    83.7351125,
                    55.0859154
                ],
                [
                    83.7357508,
                    55.0864673
                ],
                [
                    83.7363589,
                    55.0861545
                ],
                [
                    83.7362925,
                    55.0860433
                ],
                [
                    83.736636,
                    55.0859305
                ],
                [
                    83.7374646,
                    55.0867259
                ],
                [
                    83.73688,
                    55.0868885
                ],
                [
                    83.7374148,
                    55.0873504
                ],
                [
                    83.7367297,
                    55.0875738
                ],
                [
                    83.7366818,
                    55.0877537
                ],
                [
                    83.7369444,
                    55.0880039
                ],
                [
                    83.7379497,
                    55.0876487
                ],
                [
                    83.737854,
                    55.0874906
                ],
                [
                    83.7381848,
                    55.0873772
                ],
                [
                    83.7385206,
                    55.0877246
                ],
                [
                    83.7380397,
                    55.0879634
                ],
                [
                    83.7367112,
                    55.088434
                ],
                [
                    83.7373941,
                    55.0892338
                ],
                [
                    83.7376009,
                    55.0892013
                ],
                [
                    83.737792,
                    55.0893689
                ],
                [
                    83.7390255,
                    55.0889648
                ],
                [
                    83.7392894,
                    55.0891355
                ],
                [
                    83.7397797,
                    55.0889558
                ],
                [
                    83.7399402,
                    55.0891434
                ],
                [
                    83.7382231,
                    55.0897439
                ],
                [
                    83.7386363,
                    55.0901017
                ],
                [
                    83.7394336,
                    55.0898631
                ],
                [
                    83.7403822,
                    55.0895825
                ],
                [
                    83.7405634,
                    55.0897576
                ],
                [
                    83.7403838,
                    55.089843
                ],
                [
                    83.7406088,
                    55.0900668
                ],
                [
                    83.740096,
                    55.0902043
                ],
                [
                    83.7392535,
                    55.0905217
                ],
                [
                    83.7399207,
                    55.0911729
                ],
                [
                    83.7414701,
                    55.0906533
                ],
                [
                    83.7416372,
                    55.0908306
                ],
                [
                    83.7421033,
                    55.0913291
                ],
                [
                    83.7425997,
                    55.0917758
                ],
                [
                    83.7430927,
                    55.0917864
                ],
                [
                    83.7429414,
                    55.0916014
                ],
                [
                    83.7436831,
                    55.0913975
                ],
                [
                    83.7433585,
                    55.0910449
                ],
                [
                    83.7443785,
                    55.0906379
                ],
                [
                    83.744193,
                    55.0904362
                ],
                [
                    83.7443346,
                    55.090219
                ],
                [
                    83.7440576,
                    55.0899293
                ],
                [
                    83.7432842,
                    55.0901625
                ],
                [
                    83.7429389,
                    55.0899007
                ],
                [
                    83.744021,
                    55.0895167
                ],
                [
                    83.7430624,
                    55.0886839
                ],
                [
                    83.7420561,
                    55.0889998
                ],
                [
                    83.74187,
                    55.0891708
                ],
                [
                    83.740826,
                    55.0895167
                ],
                [
                    83.7398106,
                    55.0884665
                ],
                [
                    83.7411708,
                    55.0879272
                ],
                [
                    83.7407927,
                    55.0876165
                ],
                [
                    83.7398425,
                    55.0880094
                ],
                [
                    83.739428,
                    55.0881799
                ],
                [
                    83.7387494,
                    55.0874098
                ],
                [
                    83.7403911,
                    55.0866597
                ],
                [
                    83.7397692,
                    55.0862206
                ],
                [
                    83.739407,
                    55.0860583
                ],
                [
                    83.7380433,
                    55.086741
                ],
                [
                    83.7376782,
                    55.0864433
                ],
                [
                    83.7374037,
                    55.0861076
                ],
                [
                    83.7390925,
                    55.085476
                ],
                [
                    83.7383753,
                    55.084835
                ],
                [
                    83.7375962,
                    55.0845296
                ],
                [
                    83.737153,
                    55.0841027
                ],
                [
                    83.7357377,
                    55.0827471
                ],
                [
                    83.7360879,
                    55.0826543
                ],
                [
                    83.7354517,
                    55.0820924
                ],
                [
                    83.7360689,
                    55.081911
                ],
                [
                    83.7374413,
                    55.081521
                ],
                [
                    83.7354547,
                    55.0796902
                ],
                [
                    83.7337119,
                    55.0801482
                ],
                [
                    83.7333843,
                    55.0802556
                ],
                [
                    83.7319812,
                    55.0807082
                ],
                [
                    83.7316148,
                    55.0803596
                ],
                [
                    83.7327733,
                    55.079918
                ],
                [
                    83.7317667,
                    55.0789888
                ],
                [
                    83.7323445,
                    55.0787552
                ],
                [
                    83.7312186,
                    55.0782045
                ],
                [
                    83.7307093,
                    55.0783951
                ],
                [
                    83.7302621,
                    55.0785585
                ],
                [
                    83.7298636,
                    55.078707
                ],
                [
                    83.7292627,
                    55.0787381
                ],
                [
                    83.7279991,
                    55.079243
                ]
            ],
            "longitude": 83.735825,
            "latitude": 55.084675
        },
        "10200": {
            "name": "Аплаксино",
            "population": 134,
            "type": "hamlet",
            "poly": [
                [
                    83.7328342,
                    54.9453713
                ],
                [
                    83.7350616,
                    54.9458489
                ],
                [
                    83.7353289,
                    54.94619
                ],
                [
                    83.7373482,
                    54.9465994
                ],
                [
                    83.7377343,
                    54.9461218
                ],
                [
                    83.7381204,
                    54.9460024
                ],
                [
                    83.7382689,
                    54.9456613
                ],
                [
                    83.7381798,
                    54.9453542
                ],
                [
                    83.7395459,
                    54.9444673
                ],
                [
                    83.7397538,
                    54.9438703
                ],
                [
                    83.7406744,
                    54.9434097
                ],
                [
                    83.741981,
                    54.9424886
                ],
                [
                    83.7416841,
                    54.9421815
                ],
                [
                    83.7428125,
                    54.941738
                ],
                [
                    83.7436144,
                    54.9421133
                ],
                [
                    83.7443568,
                    54.9409875
                ],
                [
                    83.7434362,
                    54.9403904
                ],
                [
                    83.7459902,
                    54.9388721
                ],
                [
                    83.746495,
                    54.9387527
                ],
                [
                    83.7472078,
                    54.9389233
                ],
                [
                    83.7480096,
                    54.9382921
                ],
                [
                    83.7475641,
                    54.9379168
                ],
                [
                    83.7479502,
                    54.9377462
                ],
                [
                    83.7486332,
                    54.9380703
                ],
                [
                    83.7488708,
                    54.9376609
                ],
                [
                    83.7483957,
                    54.9372685
                ],
                [
                    83.7487223,
                    54.9371491
                ],
                [
                    83.7473057,
                    54.9365907
                ],
                [
                    83.7478611,
                    54.9363643
                ],
                [
                    83.7481284,
                    54.9361937
                ],
                [
                    83.7476829,
                    54.9354601
                ],
                [
                    83.7469404,
                    54.9351359
                ],
                [
                    83.7449211,
                    54.9359036
                ],
                [
                    83.7432877,
                    54.9373879
                ],
                [
                    83.7398725,
                    54.9387186
                ],
                [
                    83.7404962,
                    54.9392133
                ],
                [
                    83.7401398,
                    54.9393668
                ],
                [
                    83.7398428,
                    54.9391963
                ],
                [
                    83.7396052,
                    54.9393157
                ],
                [
                    83.738833,
                    54.9390257
                ],
                [
                    83.7384768,
                    54.9392474
                ],
                [
                    83.7400507,
                    54.9400663
                ],
                [
                    83.7399616,
                    54.9407998
                ],
                [
                    83.7389816,
                    54.9424374
                ],
                [
                    83.7378234,
                    54.9419427
                ],
                [
                    83.7353883,
                    54.9441773
                ],
                [
                    83.7358634,
                    54.9447061
                ],
                [
                    83.7354476,
                    54.9450984
                ],
                [
                    83.7333985,
                    54.944689
                ],
                [
                    83.7328342,
                    54.9453713
                ]
            ],
            "longitude": 83.741875,
            "latitude": 54.941048
        },
        "10201": {
            "name": "Верх-Балта",
            "population": 177,
            "type": "hamlet",
            "poly": [
                [
                    83.750953,
                    55.3369329
                ],
                [
                    83.7511677,
                    55.3381554
                ],
                [
                    83.7521435,
                    55.3384329
                ],
                [
                    83.7574407,
                    55.3383933
                ],
                [
                    83.7595316,
                    55.3379969
                ],
                [
                    83.7619014,
                    55.3374815
                ],
                [
                    83.7623893,
                    55.3379572
                ],
                [
                    83.7676865,
                    55.3372041
                ],
                [
                    83.7681047,
                    55.3375608
                ],
                [
                    83.7710321,
                    55.3366094
                ],
                [
                    83.7710321,
                    55.335103
                ],
                [
                    83.7720776,
                    55.3342308
                ],
                [
                    83.7705442,
                    55.3333983
                ],
                [
                    83.7685926,
                    55.3340723
                ],
                [
                    83.7688017,
                    55.3343498
                ],
                [
                    83.7676865,
                    55.3347462
                ],
                [
                    83.7641318,
                    55.3347859
                ],
                [
                    83.7623196,
                    55.332764
                ],
                [
                    83.7653167,
                    55.3315349
                ],
                [
                    83.7647591,
                    55.3307816
                ],
                [
                    83.761762,
                    55.3297111
                ],
                [
                    83.7605074,
                    55.3300283
                ],
                [
                    83.760368,
                    55.3303455
                ],
                [
                    83.7578589,
                    55.3303455
                ],
                [
                    83.7566043,
                    55.3312971
                ],
                [
                    83.7534678,
                    55.3323675
                ],
                [
                    83.7540951,
                    55.3333983
                ],
                [
                    83.7526314,
                    55.3338344
                ],
                [
                    83.7534678,
                    55.3349444
                ],
                [
                    83.7573013,
                    55.3341912
                ],
                [
                    83.7577194,
                    55.3344291
                ],
                [
                    83.7582771,
                    55.3343101
                ],
                [
                    83.7581377,
                    55.3337155
                ],
                [
                    83.7585559,
                    55.3335569
                ],
                [
                    83.7590437,
                    55.3339137
                ],
                [
                    83.7588347,
                    55.334548
                ],
                [
                    83.7593225,
                    55.3357373
                ],
                [
                    83.7597407,
                    55.3358959
                ],
                [
                    83.7598801,
                    55.3363319
                ],
                [
                    83.7591134,
                    55.336213
                ],
                [
                    83.758765,
                    55.3362527
                ],
                [
                    83.7587326,
                    55.3364458
                ],
                [
                    83.7583401,
                    55.3364458
                ],
                [
                    83.7576977,
                    55.3359993
                ],
                [
                    83.7568056,
                    55.3358572
                ],
                [
                    83.7526303,
                    55.3360196
                ],
                [
                    83.7528087,
                    55.3370547
                ],
                [
                    83.750953,
                    55.3369329
                ]
            ],
            "longitude": 83.761444,
            "latitude": 55.335285
        },
        "10202": {
            "name": "Тасино",
            "population": 56,
            "type": "hamlet",
            "poly": [
                [
                    83.7645377,
                    55.4076015
                ],
                [
                    83.7651811,
                    55.408481
                ],
                [
                    83.7659735,
                    55.4095645
                ],
                [
                    83.7672159,
                    55.4091053
                ],
                [
                    83.7679602,
                    55.4090987
                ],
                [
                    83.7680955,
                    55.4119766
                ],
                [
                    83.7685061,
                    55.4120154
                ],
                [
                    83.7684377,
                    55.4124427
                ],
                [
                    83.7693274,
                    55.4124816
                ],
                [
                    83.7698748,
                    55.4157059
                ],
                [
                    83.7709014,
                    55.4157059
                ],
                [
                    83.7709014,
                    55.4150843
                ],
                [
                    83.7714489,
                    55.4150455
                ],
                [
                    83.7714489,
                    55.4142297
                ],
                [
                    83.7711067,
                    55.414152
                ],
                [
                    83.7709014,
                    55.4125981
                ],
                [
                    83.7704223,
                    55.4120154
                ],
                [
                    83.7709698,
                    55.4116658
                ],
                [
                    83.7702855,
                    55.4107722
                ],
                [
                    83.7705591,
                    55.4103449
                ],
                [
                    83.7702855,
                    55.4094124
                ],
                [
                    83.7693958,
                    55.4088685
                ],
                [
                    83.7693274,
                    55.4083634
                ],
                [
                    83.770217,
                    55.4080138
                ],
                [
                    83.7695501,
                    55.4074187
                ],
                [
                    83.7678726,
                    55.4076375
                ],
                [
                    83.7679719,
                    55.4090521
                ],
                [
                    83.7671691,
                    55.4090521
                ],
                [
                    83.7661083,
                    55.4072089
                ],
                [
                    83.7656747,
                    55.4073486
                ],
                [
                    83.7645377,
                    55.4076015
                ]
            ],
            "longitude": 83.7695617,
            "latitude": 55.4115616
        },
        "10203": {
            "name": "Новоалександровка",
            "population": 24,
            "type": "hamlet",
            "poly": [
                [
                    83.7609684,
                    55.3776894
                ],
                [
                    83.7611182,
                    55.378624
                ],
                [
                    83.7635005,
                    55.3797841
                ],
                [
                    83.7653723,
                    55.3800742
                ],
                [
                    83.7662825,
                    55.3825304
                ],
                [
                    83.768095,
                    55.3874208
                ],
                [
                    83.768095,
                    55.3902238
                ],
                [
                    83.7671447,
                    55.39128
                ],
                [
                    83.7665019,
                    55.3919631
                ],
                [
                    83.7660453,
                    55.3924357
                ],
                [
                    83.764278,
                    55.3941083
                ],
                [
                    83.7655583,
                    55.3959396
                ],
                [
                    83.7667814,
                    55.3995544
                ],
                [
                    83.7675775,
                    55.3991876
                ],
                [
                    83.769631,
                    55.3985264
                ],
                [
                    83.7704218,
                    55.3981864
                ],
                [
                    83.7709093,
                    55.3975274
                ],
                [
                    83.769724,
                    55.3961517
                ],
                [
                    83.7686542,
                    55.3956868
                ],
                [
                    83.7684189,
                    55.3946051
                ],
                [
                    83.7725193,
                    55.3910937
                ],
                [
                    83.7724544,
                    55.3876698
                ],
                [
                    83.7717344,
                    55.3848682
                ],
                [
                    83.7708016,
                    55.3825042
                ],
                [
                    83.7699504,
                    55.3812873
                ],
                [
                    83.768445,
                    55.3816124
                ],
                [
                    83.7681475,
                    55.3815336
                ],
                [
                    83.7658776,
                    55.379126
                ],
                [
                    83.7654491,
                    55.378806
                ],
                [
                    83.76423,
                    55.3788083
                ],
                [
                    83.7627186,
                    55.3784009
                ],
                [
                    83.7619284,
                    55.3776481
                ],
                [
                    83.7609684,
                    55.3776894
                ]
            ],
            "longitude": 83.76976,
            "latitude": 55.390987
        },
        "10204": {
            "name": "Инской",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    83.7683602,
                    55.1526947
                ],
                [
                    83.7687253,
                    55.1529821
                ],
                [
                    83.769212,
                    55.1535198
                ],
                [
                    83.7704775,
                    55.1531814
                ],
                [
                    83.7714753,
                    55.1531119
                ],
                [
                    83.7736737,
                    55.1526067
                ],
                [
                    83.77442,
                    55.1520875
                ],
                [
                    83.7748012,
                    55.1519068
                ],
                [
                    83.7751014,
                    55.1513876
                ],
                [
                    83.7762452,
                    55.1506784
                ],
                [
                    83.7767743,
                    55.1510677
                ],
                [
                    83.7769834,
                    55.1508314
                ],
                [
                    83.7773758,
                    55.1506385
                ],
                [
                    83.7768533,
                    55.1502442
                ],
                [
                    83.7772379,
                    55.1500465
                ],
                [
                    83.7777378,
                    55.1485742
                ],
                [
                    83.7785576,
                    55.1479239
                ],
                [
                    83.7793781,
                    55.1474835
                ],
                [
                    83.7803531,
                    55.1471524
                ],
                [
                    83.7811196,
                    55.1469377
                ],
                [
                    83.7834565,
                    55.1468279
                ],
                [
                    83.7834565,
                    55.1466968
                ],
                [
                    83.7837787,
                    55.1466646
                ],
                [
                    83.7838351,
                    55.1467689
                ],
                [
                    83.7860211,
                    55.1465772
                ],
                [
                    83.7860951,
                    55.1464411
                ],
                [
                    83.7872825,
                    55.146346
                ],
                [
                    83.7878905,
                    55.1462411
                ],
                [
                    83.7880904,
                    55.1461227
                ],
                [
                    83.7879536,
                    55.1458084
                ],
                [
                    83.7879479,
                    55.1456543
                ],
                [
                    83.7879938,
                    55.1454806
                ],
                [
                    83.7877695,
                    55.1452416
                ],
                [
                    83.786928,
                    55.145225
                ],
                [
                    83.7863932,
                    55.1451871
                ],
                [
                    83.7863888,
                    55.1454102
                ],
                [
                    83.786667,
                    55.1456724
                ],
                [
                    83.786994,
                    55.1458167
                ],
                [
                    83.7868936,
                    55.1458986
                ],
                [
                    83.7865236,
                    55.1457626
                ],
                [
                    83.7859328,
                    55.145261
                ],
                [
                    83.7855627,
                    55.145161
                ],
                [
                    83.7852359,
                    55.1451217
                ],
                [
                    83.784743,
                    55.1450189
                ],
                [
                    83.7845819,
                    55.1450889
                ],
                [
                    83.7844786,
                    55.1452036
                ],
                [
                    83.784351,
                    55.1453013
                ],
                [
                    83.7826775,
                    55.1454167
                ],
                [
                    83.7809681,
                    55.1455854
                ],
                [
                    83.7782526,
                    55.1461682
                ],
                [
                    83.7774151,
                    55.1462436
                ],
                [
                    83.7772794,
                    55.1463437
                ],
                [
                    83.7764802,
                    55.1464895
                ],
                [
                    83.7759638,
                    55.1467386
                ],
                [
                    83.772508,
                    55.1475193
                ],
                [
                    83.7721234,
                    55.1482226
                ],
                [
                    83.772931,
                    55.1495411
                ],
                [
                    83.7733999,
                    55.1494069
                ],
                [
                    83.7737613,
                    55.1497379
                ],
                [
                    83.7740538,
                    55.1497707
                ],
                [
                    83.7742546,
                    55.1497248
                ],
                [
                    83.7745053,
                    55.1497883
                ],
                [
                    83.7746905,
                    55.1497051
                ],
                [
                    83.7742482,
                    55.1491842
                ],
                [
                    83.7762209,
                    55.1506506
                ],
                [
                    83.7751744,
                    55.1513134
                ],
                [
                    83.7748499,
                    55.1510539
                ],
                [
                    83.7726272,
                    55.1518697
                ],
                [
                    83.7722459,
                    55.1515267
                ],
                [
                    83.7717916,
                    55.1515684
                ],
                [
                    83.7715807,
                    55.1514154
                ],
                [
                    83.7709561,
                    55.1513876
                ],
                [
                    83.7703152,
                    55.1515313
                ],
                [
                    83.769934,
                    55.1515452
                ],
                [
                    83.7700881,
                    55.1520551
                ],
                [
                    83.7694229,
                    55.152361
                ],
                [
                    83.7683602,
                    55.1526947
                ]
            ],
            "longitude": 83.779388,
            "latitude": 55.146816
        },
        "10205": {
            "name": "Усть-Тула",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    83.7724512,
                    55.7791288
                ],
                [
                    83.7747872,
                    55.7816201
                ],
                [
                    83.7794576,
                    55.7826243
                ],
                [
                    83.7825618,
                    55.7840928
                ],
                [
                    83.7846312,
                    55.7856998
                ],
                [
                    83.7856413,
                    55.7853673
                ],
                [
                    83.7854935,
                    55.7852288
                ],
                [
                    83.7859123,
                    55.7850487
                ],
                [
                    83.7875876,
                    55.7865032
                ],
                [
                    83.7878932,
                    55.7865851
                ],
                [
                    83.7882627,
                    55.7864118
                ],
                [
                    83.7883021,
                    55.78624
                ],
                [
                    83.7881789,
                    55.7852842
                ],
                [
                    83.7867746,
                    55.7829153
                ],
                [
                    83.7870504,
                    55.7827442
                ],
                [
                    83.7874891,
                    55.7824719
                ],
                [
                    83.7869471,
                    55.7816545
                ],
                [
                    83.7859862,
                    55.7807956
                ],
                [
                    83.7851732,
                    55.7803799
                ],
                [
                    83.7838429,
                    55.7799089
                ],
                [
                    83.7812068,
                    55.7797426
                ],
                [
                    83.7814039,
                    55.7792715
                ],
                [
                    83.7846559,
                    55.7772209
                ],
                [
                    83.780443,
                    55.7765836
                ],
                [
                    83.7801228,
                    55.7773872
                ],
                [
                    83.7803199,
                    55.778274
                ],
                [
                    83.7801224,
                    55.7794463
                ],
                [
                    83.7800981,
                    55.7795902
                ],
                [
                    83.7785715,
                    55.779129
                ],
                [
                    83.7782275,
                    55.7790251
                ],
                [
                    83.7779372,
                    55.7789374
                ],
                [
                    83.7771171,
                    55.7786896
                ],
                [
                    83.7749737,
                    55.778842
                ],
                [
                    83.7724512,
                    55.7791288
                ]
            ],
            "longitude": 83.782089,
            "latitude": 55.781696
        },
        "10206": {
            "name": "Пермский",
            "population": 68,
            "type": "hamlet",
            "poly": [
                [
                    83.7786827,
                    55.0284666
                ],
                [
                    83.7795701,
                    55.0346313
                ],
                [
                    83.7824911,
                    55.0376787
                ],
                [
                    83.7846593,
                    55.0370753
                ],
                [
                    83.7859831,
                    55.0376882
                ],
                [
                    83.7927033,
                    55.0441388
                ],
                [
                    83.7937634,
                    55.0454655
                ],
                [
                    83.7950809,
                    55.0455673
                ],
                [
                    83.7985305,
                    55.0442435
                ],
                [
                    83.7953889,
                    55.0394615
                ],
                [
                    83.789619,
                    55.0342975
                ],
                [
                    83.7876653,
                    55.0334109
                ],
                [
                    83.786479,
                    55.033271
                ],
                [
                    83.7830478,
                    55.0333467
                ],
                [
                    83.7829859,
                    55.030685
                ],
                [
                    83.7812612,
                    55.0284399
                ],
                [
                    83.7786827,
                    55.0284666
                ]
            ],
            "longitude": 83.78698,
            "latitude": 55.036983
        },
        "10207": {
            "name": "Вороново",
            "population": 233,
            "type": "hamlet",
            "poly": [
                [
                    83.7583013,
                    55.4757861
                ],
                [
                    83.7672123,
                    55.4778284
                ],
                [
                    83.7704883,
                    55.4794251
                ],
                [
                    83.7746162,
                    55.4818757
                ],
                [
                    83.7791371,
                    55.4840662
                ],
                [
                    83.784772,
                    55.4848555
                ],
                [
                    83.789424,
                    55.4853656
                ],
                [
                    83.7963037,
                    55.4864793
                ],
                [
                    83.797483,
                    55.4887067
                ],
                [
                    83.7998216,
                    55.4885487
                ],
                [
                    83.8048869,
                    55.4882241
                ],
                [
                    83.808425,
                    55.4914908
                ],
                [
                    83.8133392,
                    55.4913052
                ],
                [
                    83.811308,
                    55.4873332
                ],
                [
                    83.7993177,
                    55.4841033
                ],
                [
                    83.7996453,
                    55.4829895
                ],
                [
                    83.806538,
                    55.480082
                ],
                [
                    83.8024769,
                    55.4750809
                ],
                [
                    83.7972025,
                    55.4768922
                ],
                [
                    83.7933148,
                    55.4785255
                ],
                [
                    83.7927,
                    55.4789795
                ],
                [
                    83.7886377,
                    55.4738179
                ],
                [
                    83.7856893,
                    55.4727038
                ],
                [
                    83.7823477,
                    55.473298
                ],
                [
                    83.78641,
                    55.4766402
                ],
                [
                    83.788048,
                    55.4795736
                ],
                [
                    83.786541,
                    55.4810959
                ],
                [
                    83.7816269,
                    55.4803162
                ],
                [
                    83.777237,
                    55.4779769
                ],
                [
                    83.7720609,
                    55.4760089
                ],
                [
                    83.7650501,
                    55.4733723
                ],
                [
                    83.7603326,
                    55.4739293
                ],
                [
                    83.7583013,
                    55.4757861
                ]
            ],
            "longitude": 83.78804,
            "latitude": 55.481075
        },
        "10208": {
            "name": "Льнозавод",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.803169,
            "latitude": 55.157246
        },
        "10209": {
            "name": "Ясная Поляна",
            "population": 142,
            "type": "hamlet",
            "poly": [
                [
                    83.8195889,
                    54.2622354
                ],
                [
                    83.8330863,
                    54.2695015
                ],
                [
                    83.8466296,
                    54.2674103
                ],
                [
                    83.8503482,
                    54.2605728
                ],
                [
                    83.8284954,
                    54.2541634
                ],
                [
                    83.8195889,
                    54.2622354
                ]
            ],
            "longitude": 83.83783,
            "latitude": 54.262775
        },
        "10210": {
            "name": "Малиновка",
            "population": 203,
            "type": "hamlet",
            "poly": [
                [
                    83.8490462,
                    54.6554259
                ],
                [
                    83.850002,
                    54.6572465
                ],
                [
                    83.8504217,
                    54.6578533
                ],
                [
                    83.8527529,
                    54.6577994
                ],
                [
                    83.8528461,
                    54.6601727
                ],
                [
                    83.8527995,
                    54.6612784
                ],
                [
                    83.8534523,
                    54.6626538
                ],
                [
                    83.8550375,
                    54.6633415
                ],
                [
                    83.8562031,
                    54.6632336
                ],
                [
                    83.8569491,
                    54.6625729
                ],
                [
                    83.857765,
                    54.6611301
                ],
                [
                    83.8583479,
                    54.6611166
                ],
                [
                    83.8597,
                    54.66411
                ],
                [
                    83.8618913,
                    54.6692333
                ],
                [
                    83.8648753,
                    54.6688288
                ],
                [
                    83.8651551,
                    54.6661459
                ],
                [
                    83.8641992,
                    54.6635976
                ],
                [
                    83.8650851,
                    54.6601862
                ],
                [
                    83.8657379,
                    54.6598356
                ],
                [
                    83.8652949,
                    54.6571791
                ],
                [
                    83.8625674,
                    54.6580961
                ],
                [
                    83.8625907,
                    54.6568824
                ],
                [
                    83.8610055,
                    54.6546977
                ],
                [
                    83.8588141,
                    54.6542257
                ],
                [
                    83.8612386,
                    54.6521487
                ],
                [
                    83.8616815,
                    54.6532546
                ],
                [
                    83.8634299,
                    54.6538076
                ],
                [
                    83.8673231,
                    54.6546977
                ],
                [
                    83.8717758,
                    54.6534704
                ],
                [
                    83.8714028,
                    54.6531737
                ],
                [
                    83.871869,
                    54.6525533
                ],
                [
                    83.8659477,
                    54.6507595
                ],
                [
                    83.8636864,
                    54.651326
                ],
                [
                    83.8620079,
                    54.6499637
                ],
                [
                    83.8590006,
                    54.6509214
                ],
                [
                    83.8583479,
                    54.6512181
                ],
                [
                    83.8581614,
                    54.6522027
                ],
                [
                    83.8594902,
                    54.6526882
                ],
                [
                    83.8584877,
                    54.6536323
                ],
                [
                    83.8578816,
                    54.6532546
                ],
                [
                    83.8559001,
                    54.6549539
                ],
                [
                    83.8563663,
                    54.6555743
                ],
                [
                    83.8549209,
                    54.6562486
                ],
                [
                    83.8542449,
                    54.6551292
                ],
                [
                    83.85231,
                    54.6552776
                ],
                [
                    83.8490695,
                    54.6550348
                ],
                [
                    83.8490462,
                    54.6554259
                ]
            ],
            "longitude": 83.855446,
            "latitude": 54.66098
        },
        "10211": {
            "name": "Прямское",
            "population": 144,
            "type": "hamlet",
            "poly": [
                [
                    83.8455606,
                    54.3141207
                ],
                [
                    83.8501355,
                    54.3197543
                ],
                [
                    83.8536514,
                    54.3221261
                ],
                [
                    83.851491,
                    54.3238555
                ],
                [
                    83.8575291,
                    54.3279396
                ],
                [
                    83.8620157,
                    54.3288753
                ],
                [
                    83.8603651,
                    54.3275314
                ],
                [
                    83.8598357,
                    54.3260059
                ],
                [
                    83.8617042,
                    54.3254792
                ],
                [
                    83.8681386,
                    54.3282033
                ],
                [
                    83.8693247,
                    54.3245966
                ],
                [
                    83.8600902,
                    54.320199
                ],
                [
                    83.8479751,
                    54.3121685
                ],
                [
                    83.8455606,
                    54.3141207
                ]
            ],
            "longitude": 83.855469,
            "latitude": 54.322701
        },
        "10212": {
            "name": "Ермачиха",
            "population": 79,
            "type": "hamlet",
            "poly": [
                [
                    83.8572209,
                    55.1082286
                ],
                [
                    83.8573071,
                    55.1088069
                ],
                [
                    83.8579304,
                    55.1088719
                ],
                [
                    83.8586309,
                    55.1088856
                ],
                [
                    83.8586788,
                    55.1090363
                ],
                [
                    83.8597296,
                    55.109086
                ],
                [
                    83.8598073,
                    55.1088959
                ],
                [
                    83.8607177,
                    55.1089753
                ],
                [
                    83.8616692,
                    55.1090038
                ],
                [
                    83.8616766,
                    55.1095359
                ],
                [
                    83.8622543,
                    55.1095951
                ],
                [
                    83.8623718,
                    55.1093342
                ],
                [
                    83.8630322,
                    55.1093875
                ],
                [
                    83.8645097,
                    55.1096369
                ],
                [
                    83.8645056,
                    55.1098282
                ],
                [
                    83.8653142,
                    55.1099614
                ],
                [
                    83.8662245,
                    55.1103562
                ],
                [
                    83.8679899,
                    55.1103659
                ],
                [
                    83.8683583,
                    55.1094928
                ],
                [
                    83.8691767,
                    55.1094292
                ],
                [
                    83.8713105,
                    55.1086591
                ],
                [
                    83.8723392,
                    55.1091192
                ],
                [
                    83.872932,
                    55.1091894
                ],
                [
                    83.8732961,
                    55.1093928
                ],
                [
                    83.8737872,
                    55.109405
                ],
                [
                    83.8749732,
                    55.1097296
                ],
                [
                    83.8749657,
                    55.1099856
                ],
                [
                    83.8751082,
                    55.1100846
                ],
                [
                    83.8773866,
                    55.1103695
                ],
                [
                    83.877793,
                    55.1103259
                ],
                [
                    83.8837915,
                    55.1119969
                ],
                [
                    83.8855577,
                    55.1119024
                ],
                [
                    83.8858159,
                    55.1115029
                ],
                [
                    83.8856,
                    55.1112885
                ],
                [
                    83.8841965,
                    55.1107994
                ],
                [
                    83.8851378,
                    55.1098537
                ],
                [
                    83.8826364,
                    55.1091223
                ],
                [
                    83.881808,
                    55.1088014
                ],
                [
                    83.8819505,
                    55.1086029
                ],
                [
                    83.879677,
                    55.1078642
                ],
                [
                    83.8798294,
                    55.1077007
                ],
                [
                    83.8798972,
                    55.1075482
                ],
                [
                    83.8794442,
                    55.1074016
                ],
                [
                    83.8792134,
                    55.1075348
                ],
                [
                    83.878991,
                    55.1075445
                ],
                [
                    83.8786969,
                    55.1074392
                ],
                [
                    83.878174,
                    55.1071994
                ],
                [
                    83.8780682,
                    55.1073241
                ],
                [
                    83.8777062,
                    55.1073072
                ],
                [
                    83.8771346,
                    55.1071413
                ],
                [
                    83.876835,
                    55.1072716
                ],
                [
                    83.8760848,
                    55.10709
                ],
                [
                    83.8756777,
                    55.1069153
                ],
                [
                    83.8750433,
                    55.1067921
                ],
                [
                    83.8748376,
                    55.1065881
                ],
                [
                    83.8745762,
                    55.1065174
                ],
                [
                    83.8743066,
                    55.1062415
                ],
                [
                    83.8738515,
                    55.1060359
                ],
                [
                    83.8731715,
                    55.1060237
                ],
                [
                    83.872904,
                    55.1060907
                ],
                [
                    83.8727775,
                    55.1062994
                ],
                [
                    83.8720907,
                    55.1062807
                ],
                [
                    83.8716371,
                    55.1067804
                ],
                [
                    83.8714354,
                    55.1071238
                ],
                [
                    83.8712874,
                    55.1074956
                ],
                [
                    83.8671865,
                    55.1084132
                ],
                [
                    83.8647055,
                    55.1082678
                ],
                [
                    83.8576222,
                    55.1073754
                ],
                [
                    83.8575342,
                    55.107553
                ],
                [
                    83.8574054,
                    55.1081849
                ],
                [
                    83.8572209,
                    55.1082286
                ]
            ],
            "longitude": 83.865929,
            "latitude": 55.109436
        },
        "10213": {
            "name": "Изынский",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.866707,
            "latitude": 55.181465
        },
        "10214": {
            "name": "Семёновский",
            "population": 54,
            "type": "hamlet",
            "poly": [
                [
                    83.8615645,
                    55.0491272
                ],
                [
                    83.8625607,
                    55.0492655
                ],
                [
                    83.8626083,
                    55.0491788
                ],
                [
                    83.862937,
                    55.0492085
                ],
                [
                    83.8629111,
                    55.0493523
                ],
                [
                    83.8635412,
                    55.0494431
                ],
                [
                    83.8636216,
                    55.0492528
                ],
                [
                    83.8647663,
                    55.0494193
                ],
                [
                    83.8647534,
                    55.0494979
                ],
                [
                    83.86794,
                    55.0499733
                ],
                [
                    83.8679113,
                    55.0501402
                ],
                [
                    83.8685414,
                    55.0502319
                ],
                [
                    83.8685873,
                    55.0500791
                ],
                [
                    83.8690837,
                    55.0501386
                ],
                [
                    83.8698579,
                    55.0500715
                ],
                [
                    83.871346,
                    55.0502979
                ],
                [
                    83.8714456,
                    55.0504336
                ],
                [
                    83.873807,
                    55.050844
                ],
                [
                    83.8739157,
                    55.0508964
                ],
                [
                    83.878694,
                    55.0512311
                ],
                [
                    83.8789179,
                    55.0505431
                ],
                [
                    83.8793719,
                    55.05038
                ],
                [
                    83.8793308,
                    55.0495042
                ],
                [
                    83.8782139,
                    55.0493109
                ],
                [
                    83.877488,
                    55.0492878
                ],
                [
                    83.8772803,
                    55.0493077
                ],
                [
                    83.8771376,
                    55.0493919
                ],
                [
                    83.8771042,
                    55.0499287
                ],
                [
                    83.877184,
                    55.050049
                ],
                [
                    83.8766185,
                    55.0499803
                ],
                [
                    83.8766491,
                    55.0497946
                ],
                [
                    83.8763983,
                    55.0497595
                ],
                [
                    83.8763309,
                    55.04994
                ],
                [
                    83.87578,
                    55.0498667
                ],
                [
                    83.8759345,
                    55.0491072
                ],
                [
                    83.8758631,
                    55.0490324
                ],
                [
                    83.8755756,
                    55.0489623
                ],
                [
                    83.8751741,
                    55.0489205
                ],
                [
                    83.8750684,
                    55.0497726
                ],
                [
                    83.8746302,
                    55.0497187
                ],
                [
                    83.8749497,
                    55.0490425
                ],
                [
                    83.8743291,
                    55.0489327
                ],
                [
                    83.8739918,
                    55.0496054
                ],
                [
                    83.8734043,
                    55.04952
                ],
                [
                    83.8734865,
                    55.0487653
                ],
                [
                    83.8729791,
                    55.0487185
                ],
                [
                    83.8729182,
                    55.0494468
                ],
                [
                    83.872331,
                    55.0493668
                ],
                [
                    83.8724436,
                    55.0490705
                ],
                [
                    83.8718475,
                    55.0490008
                ],
                [
                    83.8718969,
                    55.0484102
                ],
                [
                    83.8714971,
                    55.0483638
                ],
                [
                    83.8713654,
                    55.0483017
                ],
                [
                    83.871291,
                    55.0480713
                ],
                [
                    83.8706525,
                    55.0480468
                ],
                [
                    83.870505,
                    55.0489408
                ],
                [
                    83.870344,
                    55.048936
                ],
                [
                    83.8703311,
                    55.0490314
                ],
                [
                    83.869093,
                    55.0488508
                ],
                [
                    83.8692061,
                    55.0484562
                ],
                [
                    83.8695144,
                    55.0484637
                ],
                [
                    83.8696341,
                    55.0479174
                ],
                [
                    83.8671605,
                    55.0476685
                ],
                [
                    83.8652551,
                    55.0474968
                ],
                [
                    83.8653003,
                    55.0473152
                ],
                [
                    83.8648057,
                    55.0472633
                ],
                [
                    83.8633833,
                    55.0472493
                ],
                [
                    83.862275,
                    55.0473469
                ],
                [
                    83.8621109,
                    55.0478853
                ],
                [
                    83.8619465,
                    55.0480365
                ],
                [
                    83.8615645,
                    55.0491272
                ]
            ],
            "longitude": 83.870583,
            "latitude": 55.049664
        },
        "10215": {
            "name": "Калаганово",
            "population": 73,
            "type": "hamlet",
            "poly": [
                [
                    83.8623693,
                    55.1812753
                ],
                [
                    83.864762,
                    55.1819995
                ],
                [
                    83.8645314,
                    55.1822135
                ],
                [
                    83.8678465,
                    55.1831023
                ],
                [
                    83.8677313,
                    55.1835961
                ],
                [
                    83.867443,
                    55.1837277
                ],
                [
                    83.8679619,
                    55.1843203
                ],
                [
                    83.8691439,
                    55.1842051
                ],
                [
                    83.8689708,
                    55.1853078
                ],
                [
                    83.8680196,
                    55.1853078
                ],
                [
                    83.8678754,
                    55.1862624
                ],
                [
                    83.8688844,
                    55.1862624
                ],
                [
                    83.8687115,
                    55.1873157
                ],
                [
                    83.8675295,
                    55.1873815
                ],
                [
                    83.8675872,
                    55.1878752
                ],
                [
                    83.8684808,
                    55.1878423
                ],
                [
                    83.8684808,
                    55.1884183
                ],
                [
                    83.8677024,
                    55.1885664
                ],
                [
                    83.8677313,
                    55.1892576
                ],
                [
                    83.8673565,
                    55.1902779
                ],
                [
                    83.8675006,
                    55.191364
                ],
                [
                    83.8682502,
                    55.191364
                ],
                [
                    83.8684232,
                    55.1915286
                ],
                [
                    83.8680772,
                    55.1917261
                ],
                [
                    83.8685385,
                    55.1919729
                ],
                [
                    83.869461,
                    55.1916931
                ],
                [
                    83.8702681,
                    55.1930425
                ],
                [
                    83.8713924,
                    55.1929273
                ],
                [
                    83.871623,
                    55.1932893
                ],
                [
                    83.8701817,
                    55.1942437
                ],
                [
                    83.8686826,
                    55.1938159
                ],
                [
                    83.868452,
                    55.1968106
                ],
                [
                    83.8694898,
                    55.198604
                ],
                [
                    83.8716807,
                    55.198604
                ],
                [
                    83.8730644,
                    55.1977978
                ],
                [
                    83.8705276,
                    55.1962347
                ],
                [
                    83.8712483,
                    55.195774
                ],
                [
                    83.8722284,
                    55.1962347
                ],
                [
                    83.8732951,
                    55.1961524
                ],
                [
                    83.8732951,
                    55.1951816
                ],
                [
                    83.8739004,
                    55.1951323
                ],
                [
                    83.8743905,
                    55.1946057
                ],
                [
                    83.8725744,
                    55.1933387
                ],
                [
                    83.8730068,
                    55.1932564
                ],
                [
                    83.8737563,
                    55.1938488
                ],
                [
                    83.8745923,
                    55.1939146
                ],
                [
                    83.8756589,
                    55.1934868
                ],
                [
                    83.8748806,
                    55.1927463
                ],
                [
                    83.8773886,
                    55.1922691
                ],
                [
                    83.8787723,
                    55.1931577
                ],
                [
                    83.8791759,
                    55.193026
                ],
                [
                    83.8804442,
                    55.1935032
                ],
                [
                    83.8811362,
                    55.1930096
                ],
                [
                    83.881511,
                    55.19324
                ],
                [
                    83.8808479,
                    55.1939804
                ],
                [
                    83.8817416,
                    55.1941944
                ],
                [
                    83.8815974,
                    55.194507
                ],
                [
                    83.8820875,
                    55.1945234
                ],
                [
                    83.8819146,
                    55.1948854
                ],
                [
                    83.8825199,
                    55.1949677
                ],
                [
                    83.8829523,
                    55.1944576
                ],
                [
                    83.8843073,
                    55.1948525
                ],
                [
                    83.8841055,
                    55.1951652
                ],
                [
                    83.8850568,
                    55.1954943
                ],
                [
                    83.8852874,
                    55.1953133
                ],
                [
                    83.8865846,
                    55.1957082
                ],
                [
                    83.8869018,
                    55.1953297
                ],
                [
                    83.888372,
                    55.1959714
                ],
                [
                    83.8869306,
                    55.196498
                ],
                [
                    83.8886314,
                    55.1972548
                ],
                [
                    83.8890062,
                    55.1968435
                ],
                [
                    83.8896404,
                    55.1969916
                ],
                [
                    83.8898422,
                    55.1967612
                ],
                [
                    83.8904187,
                    55.1969751
                ],
                [
                    83.8905052,
                    55.1967119
                ],
                [
                    83.8911971,
                    55.1968599
                ],
                [
                    83.8922925,
                    55.1959879
                ],
                [
                    83.8939357,
                    55.1976003
                ],
                [
                    83.8966744,
                    55.1987027
                ],
                [
                    83.8971068,
                    55.196827
                ],
                [
                    83.8914277,
                    55.1953791
                ],
                [
                    83.8910529,
                    55.1957082
                ],
                [
                    83.8904187,
                    55.1954614
                ],
                [
                    83.8894674,
                    55.1959714
                ],
                [
                    83.8877954,
                    55.1954284
                ],
                [
                    83.8882855,
                    55.1949677
                ],
                [
                    83.8862964,
                    55.1940627
                ],
                [
                    83.886354,
                    55.1937665
                ],
                [
                    83.8853739,
                    55.1933881
                ],
                [
                    83.8844225,
                    55.1940134
                ],
                [
                    83.8827217,
                    55.1934539
                ],
                [
                    83.8839325,
                    55.1931741
                ],
                [
                    83.8833848,
                    55.1928944
                ],
                [
                    83.8837595,
                    55.1926311
                ],
                [
                    83.8831253,
                    55.1922691
                ],
                [
                    83.882001,
                    55.193059
                ],
                [
                    83.879839,
                    55.1921375
                ],
                [
                    83.8820875,
                    55.1910678
                ],
                [
                    83.8816551,
                    55.1907716
                ],
                [
                    83.8826352,
                    55.1901627
                ],
                [
                    83.8833848,
                    55.1904589
                ],
                [
                    83.885518,
                    55.1892082
                ],
                [
                    83.8864405,
                    55.1885829
                ],
                [
                    83.8850568,
                    55.18776
                ],
                [
                    83.8832695,
                    55.1886816
                ],
                [
                    83.8824046,
                    55.1881221
                ],
                [
                    83.8793489,
                    55.1897019
                ],
                [
                    83.8804155,
                    55.1904589
                ],
                [
                    83.8783111,
                    55.1917261
                ],
                [
                    83.8756301,
                    55.192302
                ],
                [
                    83.8748806,
                    55.1912818
                ],
                [
                    83.8742464,
                    55.1914792
                ],
                [
                    83.8749382,
                    55.1924337
                ],
                [
                    83.8744482,
                    55.1925982
                ],
                [
                    83.8736986,
                    55.1917754
                ],
                [
                    83.8721131,
                    55.1920387
                ],
                [
                    83.8718825,
                    55.1910843
                ],
                [
                    83.8726897,
                    55.1907552
                ],
                [
                    83.8736986,
                    55.1889285
                ],
                [
                    83.8703258,
                    55.1884019
                ],
                [
                    83.8705276,
                    55.1860319
                ],
                [
                    83.8710465,
                    55.185209
                ],
                [
                    83.8702969,
                    55.1829377
                ],
                [
                    83.8635225,
                    55.1806498
                ],
                [
                    83.8623693,
                    55.1812753
                ]
            ],
            "longitude": 83.873169,
            "latitude": 55.192513
        },
        "10216": {
            "name": "Налетиха",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.89328,
            "latitude": 54.947227
        },
        "10217": {
            "name": "Эстонка",
            "population": 68,
            "type": "hamlet",
            "poly": [
                [
                    83.8895465,
                    55.59041
                ],
                [
                    83.8906295,
                    55.591736
                ],
                [
                    83.8981506,
                    55.5901719
                ],
                [
                    83.908319,
                    55.5903079
                ],
                [
                    83.9083792,
                    55.5891179
                ],
                [
                    83.9095501,
                    55.5866672
                ],
                [
                    83.9075922,
                    55.5845004
                ],
                [
                    83.9024384,
                    55.5859224
                ],
                [
                    83.8973082,
                    55.5870437
                ],
                [
                    83.8912312,
                    55.5888119
                ],
                [
                    83.8895708,
                    55.5897675
                ],
                [
                    83.8895465,
                    55.59041
                ]
            ],
            "longitude": 83.89875,
            "latitude": 55.58894
        },
        "10218": {
            "name": "имени Тельмана",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    83.908905,
                    55.5811195
                ],
                [
                    83.9095964,
                    55.5817378
                ],
                [
                    83.9101066,
                    55.5829592
                ],
                [
                    83.9110213,
                    55.5834854
                ],
                [
                    83.9138498,
                    55.5839018
                ],
                [
                    83.9143385,
                    55.5828374
                ],
                [
                    83.91236,
                    55.5825475
                ],
                [
                    83.9125248,
                    55.5821333
                ],
                [
                    83.9143202,
                    55.5824543
                ],
                [
                    83.9161338,
                    55.5803419
                ],
                [
                    83.917508,
                    55.5768849
                ],
                [
                    83.911917,
                    55.5759523
                ],
                [
                    83.911444,
                    55.576821
                ],
                [
                    83.9113341,
                    55.577577
                ],
                [
                    83.9117737,
                    55.5780016
                ],
                [
                    83.9107662,
                    55.5784055
                ],
                [
                    83.9102898,
                    55.5793478
                ],
                [
                    83.912818,
                    55.5796688
                ],
                [
                    83.9126714,
                    55.5800002
                ],
                [
                    83.9109677,
                    55.5796688
                ],
                [
                    83.9107478,
                    55.5798345
                ],
                [
                    83.9098327,
                    55.5798754
                ],
                [
                    83.9106379,
                    55.5806629
                ],
                [
                    83.9103362,
                    55.5809577
                ],
                [
                    83.9091912,
                    55.5807757
                ],
                [
                    83.908905,
                    55.5811195
                ]
            ],
            "longitude": 83.9138743,
            "latitude": 55.5792699
        },
        "10219": {
            "name": "Старососедово",
            "population": 168,
            "type": "hamlet",
            "poly": [
                [
                    83.9136472,
                    54.5989172
                ],
                [
                    83.9145371,
                    54.5997177
                ],
                [
                    83.9171316,
                    54.6007132
                ],
                [
                    83.9186141,
                    54.6001862
                ],
                [
                    83.9194566,
                    54.6004399
                ],
                [
                    83.9188164,
                    54.6011426
                ],
                [
                    83.9262385,
                    54.6035901
                ],
                [
                    83.9265999,
                    54.6031139
                ],
                [
                    83.9252859,
                    54.6027626
                ],
                [
                    83.9256902,
                    54.6021966
                ],
                [
                    83.923062,
                    54.6012988
                ],
                [
                    83.9262322,
                    54.5998616
                ],
                [
                    83.9271391,
                    54.5988198
                ],
                [
                    83.9329683,
                    54.5967507
                ],
                [
                    83.9350912,
                    54.5958137
                ],
                [
                    83.9362032,
                    54.5956966
                ],
                [
                    83.9372814,
                    54.5947986
                ],
                [
                    83.9384928,
                    54.5960498
                ],
                [
                    83.9397412,
                    54.5959503
                ],
                [
                    83.9394042,
                    54.5941544
                ],
                [
                    83.9378642,
                    54.5915783
                ],
                [
                    83.9345521,
                    54.5925145
                ],
                [
                    83.9329522,
                    54.5933256
                ],
                [
                    83.9331951,
                    54.593703
                ],
                [
                    83.9319143,
                    54.5939909
                ],
                [
                    83.9306556,
                    54.5944835
                ],
                [
                    83.93102,
                    54.5947841
                ],
                [
                    83.9301698,
                    54.5949952
                ],
                [
                    83.9277628,
                    54.594701
                ],
                [
                    83.9268242,
                    54.5945383
                ],
                [
                    83.9249992,
                    54.5940492
                ],
                [
                    83.9236169,
                    54.5917271
                ],
                [
                    83.9210387,
                    54.591157
                ],
                [
                    83.9181212,
                    54.5915885
                ],
                [
                    83.9185478,
                    54.5937994
                ],
                [
                    83.9136472,
                    54.5989172
                ]
            ],
            "longitude": 83.92234,
            "latitude": 54.597141
        },
        "10220": {
            "name": "Кубово",
            "population": 35,
            "type": "hamlet",
            "poly": [
                [
                    83.917917,
                    55.5037939
                ],
                [
                    83.9185737,
                    55.5040212
                ],
                [
                    83.9188655,
                    55.5038146
                ],
                [
                    83.9191209,
                    55.5039179
                ],
                [
                    83.9189385,
                    55.5041038
                ],
                [
                    83.9193397,
                    55.5042691
                ],
                [
                    83.9196681,
                    55.5040832
                ],
                [
                    83.9199599,
                    55.5042278
                ],
                [
                    83.9197775,
                    55.5044551
                ],
                [
                    83.9209812,
                    55.5048683
                ],
                [
                    83.9214191,
                    55.504517
                ],
                [
                    83.9279125,
                    55.506459
                ],
                [
                    83.9284597,
                    55.5059839
                ],
                [
                    83.9278396,
                    55.5055913
                ],
                [
                    83.9271465,
                    55.5055087
                ],
                [
                    83.9244834,
                    55.5042071
                ],
                [
                    83.9249576,
                    55.5037733
                ],
                [
                    83.9247023,
                    55.5036286
                ],
                [
                    83.9211273,
                    55.5035047
                ],
                [
                    83.9205436,
                    55.5032567
                ],
                [
                    83.919814,
                    55.5033807
                ],
                [
                    83.9186101,
                    55.5029468
                ],
                [
                    83.917917,
                    55.5037939
                ]
            ],
            "longitude": 83.9236442,
            "latitude": 55.5042693
        },
        "10221": {
            "name": "Вознесенка",
            "population": 64,
            "type": "hamlet",
            "poly": [
                [
                    83.9099241,
                    55.6243762
                ],
                [
                    83.9107321,
                    55.6247836
                ],
                [
                    83.9134447,
                    55.6253375
                ],
                [
                    83.9173981,
                    55.625419
                ],
                [
                    83.9179753,
                    55.6246695
                ],
                [
                    83.9249587,
                    55.6233823
                ],
                [
                    83.9270076,
                    55.6246206
                ],
                [
                    83.9287967,
                    55.6236267
                ],
                [
                    83.9297779,
                    55.6222906
                ],
                [
                    83.9298933,
                    55.6200909
                ],
                [
                    83.9306436,
                    55.6188687
                ],
                [
                    83.9332408,
                    55.6170273
                ],
                [
                    83.9297779,
                    55.6162125
                ],
                [
                    83.9281619,
                    55.6173043
                ],
                [
                    83.9263727,
                    55.6169784
                ],
                [
                    83.9250453,
                    55.6195368
                ],
                [
                    83.9244681,
                    55.6211663
                ],
                [
                    83.9234581,
                    55.6221929
                ],
                [
                    83.9230253,
                    55.6221277
                ],
                [
                    83.9226501,
                    55.6231216
                ],
                [
                    83.9233427,
                    55.6233986
                ],
                [
                    83.9179464,
                    55.6243762
                ],
                [
                    83.9132034,
                    55.6236391
                ],
                [
                    83.9107032,
                    55.6236919
                ],
                [
                    83.9099241,
                    55.6243762
                ]
            ],
            "longitude": 83.926765,
            "latitude": 55.621494
        },
        "10222": {
            "name": "Барсуково",
            "population": 105,
            "type": "hamlet",
            "poly": [
                [
                    83.9177501,
                    54.3877602
                ],
                [
                    83.921617,
                    54.3882679
                ],
                [
                    83.9243465,
                    54.3886873
                ],
                [
                    83.9255884,
                    54.3905156
                ],
                [
                    83.9301401,
                    54.391386
                ],
                [
                    83.932777,
                    54.391511
                ],
                [
                    83.9361366,
                    54.3911155
                ],
                [
                    83.9372262,
                    54.3921255
                ],
                [
                    83.9386007,
                    54.3954195
                ],
                [
                    83.9396622,
                    54.3976927
                ],
                [
                    83.9401171,
                    54.398421
                ],
                [
                    83.9426571,
                    54.3974279
                ],
                [
                    83.940155,
                    54.3910492
                ],
                [
                    83.9399276,
                    54.3893054
                ],
                [
                    83.9382595,
                    54.3876278
                ],
                [
                    83.9357574,
                    54.3883121
                ],
                [
                    83.9352646,
                    54.3887536
                ],
                [
                    83.9305259,
                    54.387694
                ],
                [
                    83.9251805,
                    54.3870759
                ],
                [
                    83.9211241,
                    54.3866344
                ],
                [
                    83.920328,
                    54.3874291
                ],
                [
                    83.9179776,
                    54.3870759
                ],
                [
                    83.9177501,
                    54.3877602
                ]
            ],
            "longitude": 83.936424,
            "latitude": 54.389957
        },
        "10223": {
            "name": "Бурлиха",
            "population": 64,
            "type": "hamlet",
            "poly": [
                [
                    83.9368264,
                    55.5327604
                ],
                [
                    83.9370949,
                    55.5333566
                ],
                [
                    83.9399505,
                    55.5332403
                ],
                [
                    83.9406646,
                    55.5337455
                ],
                [
                    83.9433424,
                    55.5333161
                ],
                [
                    83.944592,
                    55.5339475
                ],
                [
                    83.9450077,
                    55.5349729
                ],
                [
                    83.9471776,
                    55.5345751
                ],
                [
                    83.9504369,
                    55.5331177
                ],
                [
                    83.9544039,
                    55.5329652
                ],
                [
                    83.9532056,
                    55.5316238
                ],
                [
                    83.9532502,
                    55.5307398
                ],
                [
                    83.9520899,
                    55.530083
                ],
                [
                    83.9508402,
                    55.5301588
                ],
                [
                    83.9501262,
                    55.5293252
                ],
                [
                    83.9512268,
                    55.5288817
                ],
                [
                    83.950703,
                    55.5284113
                ],
                [
                    83.9483856,
                    55.5287443
                ],
                [
                    83.9482963,
                    55.5291232
                ],
                [
                    83.946656,
                    55.5294531
                ],
                [
                    83.9398591,
                    55.5297025
                ],
                [
                    83.9384777,
                    55.5302851
                ],
                [
                    83.938567,
                    55.5311944
                ],
                [
                    83.9382555,
                    55.5313947
                ],
                [
                    83.9383885,
                    55.5319522
                ],
                [
                    83.9368264,
                    55.5327604
                ]
            ],
            "longitude": 83.945679,
            "latitude": 55.532059
        },
        "10224": {
            "name": "Петропавловка",
            "population": 194,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.955185,
            "latitude": 54.28368
        },
        "10225": {
            "name": "Малиновка",
            "population": 95,
            "type": "hamlet",
            "poly": [
                [
                    83.9578019,
                    55.6307265
                ],
                [
                    83.9583791,
                    55.6332215
                ],
                [
                    83.9595355,
                    55.6334702
                ],
                [
                    83.9622338,
                    55.6317916
                ],
                [
                    83.9647118,
                    55.633377
                ],
                [
                    83.9665232,
                    55.6332243
                ],
                [
                    83.9756453,
                    55.6255931
                ],
                [
                    83.9719751,
                    55.6242343
                ],
                [
                    83.9703199,
                    55.6247876
                ],
                [
                    83.9674431,
                    55.6240316
                ],
                [
                    83.9629662,
                    55.6279912
                ],
                [
                    83.9628896,
                    55.6294656
                ],
                [
                    83.958064,
                    55.6276464
                ],
                [
                    83.9578019,
                    55.6307265
                ]
            ],
            "longitude": 83.968086,
            "latitude": 55.628246
        },
        "10226": {
            "name": "Остановочная Платформа Отг",
            "population": 41,
            "type": "hamlet",
            "poly": [
                [
                    83.9734347,
                    55.2067782
                ],
                [
                    83.9756497,
                    55.2085688
                ],
                [
                    83.9773725,
                    55.2077964
                ],
                [
                    83.9844706,
                    55.2125231
                ],
                [
                    83.9860637,
                    55.2122634
                ],
                [
                    83.9808232,
                    55.2087443
                ],
                [
                    83.9780185,
                    55.2071644
                ],
                [
                    83.9763573,
                    55.2079895
                ],
                [
                    83.9747883,
                    55.2063745
                ],
                [
                    83.9734347,
                    55.2067782
                ]
            ],
            "longitude": 83.974884,
            "latitude": 55.207306
        },
        "10227": {
            "name": "Кинтереп",
            "population": 64,
            "type": "hamlet",
            "poly": [
                [
                    83.9795269,
                    54.4763064
                ],
                [
                    83.9815662,
                    54.4807872
                ],
                [
                    83.9866829,
                    54.4820366
                ],
                [
                    83.9831976,
                    54.4848368
                ],
                [
                    83.9839762,
                    54.485246
                ],
                [
                    83.9855335,
                    54.4844491
                ],
                [
                    83.9933199,
                    54.4842552
                ],
                [
                    83.9959523,
                    54.482489
                ],
                [
                    83.9954333,
                    54.4808088
                ],
                [
                    83.9885368,
                    54.4814119
                ],
                [
                    83.9901682,
                    54.4792793
                ],
                [
                    83.9874986,
                    54.4756385
                ],
                [
                    83.9801571,
                    54.4749491
                ],
                [
                    83.9795269,
                    54.4763064
                ]
            ],
            "longitude": 83.987175,
            "latitude": 54.480469
        },
        "10228": {
            "name": "Насоново",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    83.9860969,
                    55.8170211
                ],
                [
                    83.9866671,
                    55.8176987
                ],
                [
                    83.9883775,
                    55.8175262
                ],
                [
                    83.9887064,
                    55.8173414
                ],
                [
                    83.9877854,
                    55.8165159
                ],
                [
                    83.9880705,
                    55.8157151
                ],
                [
                    83.9897151,
                    55.8159122
                ],
                [
                    83.9897809,
                    55.8166268
                ],
                [
                    83.9913159,
                    55.817095
                ],
                [
                    83.9915132,
                    55.8174399
                ],
                [
                    83.992807,
                    55.8180313
                ],
                [
                    83.9909211,
                    55.8180067
                ],
                [
                    83.9911843,
                    55.8203474
                ],
                [
                    83.9935525,
                    55.8204213
                ],
                [
                    83.993421,
                    55.8197068
                ],
                [
                    83.9939692,
                    55.8196452
                ],
                [
                    83.9939034,
                    55.8184255
                ],
                [
                    83.993399,
                    55.8183886
                ],
                [
                    83.9933333,
                    55.8178219
                ],
                [
                    83.9915351,
                    55.8169348
                ],
                [
                    83.9905045,
                    55.8165529
                ],
                [
                    83.9905922,
                    55.8157767
                ],
                [
                    83.9864916,
                    55.8154317
                ],
                [
                    83.9860969,
                    55.8170211
                ]
            ],
            "longitude": 83.992363,
            "latitude": 55.81929
        },
        "10229": {
            "name": "Никольский",
            "population": 121,
            "type": "hamlet",
            "poly": [
                [
                    83.987643,
                    55.1020919
                ],
                [
                    83.9909313,
                    55.1038715
                ],
                [
                    83.9930643,
                    55.1052442
                ],
                [
                    83.9947529,
                    55.1056001
                ],
                [
                    83.9954639,
                    55.1052951
                ],
                [
                    83.9980412,
                    55.1070237
                ],
                [
                    83.996086,
                    55.1073287
                ],
                [
                    83.9981301,
                    55.1085997
                ],
                [
                    83.9992854,
                    55.1077862
                ],
                [
                    84.0000853,
                    55.1081421
                ],
                [
                    83.9989298,
                    55.108803
                ],
                [
                    84.0005295,
                    55.1095147
                ],
                [
                    84.0024849,
                    55.1078371
                ],
                [
                    84.001685,
                    55.1074304
                ],
                [
                    84.0006185,
                    55.1080404
                ],
                [
                    83.9996409,
                    55.1075829
                ],
                [
                    84.0004408,
                    55.1069728
                ],
                [
                    83.9985744,
                    55.105956
                ],
                [
                    83.9977746,
                    55.1063119
                ],
                [
                    83.9963526,
                    55.1053459
                ],
                [
                    83.9976857,
                    55.1047358
                ],
                [
                    83.9959971,
                    55.103363
                ],
                [
                    83.995375,
                    55.1036173
                ],
                [
                    83.9944862,
                    55.1032613
                ],
                [
                    83.9938641,
                    55.1008207
                ],
                [
                    83.9920867,
                    55.1003123
                ],
                [
                    83.9898648,
                    55.1013292
                ],
                [
                    83.9888871,
                    55.1013292
                ],
                [
                    83.987643,
                    55.1020919
                ]
            ],
            "longitude": 83.992561,
            "latitude": 55.103745
        },
        "10230": {
            "name": "Изынский",
            "population": 120,
            "type": "hamlet",
            "poly": [
                [
                    83.9855213,
                    55.1784017
                ],
                [
                    83.9856589,
                    55.1795804
                ],
                [
                    83.9907505,
                    55.1795804
                ],
                [
                    83.9907505,
                    55.1801304
                ],
                [
                    83.9926771,
                    55.180209
                ],
                [
                    83.9927459,
                    55.1815054
                ],
                [
                    83.9933652,
                    55.1814269
                ],
                [
                    83.9938863,
                    55.1828742
                ],
                [
                    83.9943284,
                    55.1841768
                ],
                [
                    83.9947413,
                    55.1851589
                ],
                [
                    83.996943,
                    55.1852375
                ],
                [
                    83.9973559,
                    55.1859838
                ],
                [
                    83.9982503,
                    55.1859053
                ],
                [
                    83.9982503,
                    55.1851589
                ],
                [
                    83.999076,
                    55.1851589
                ],
                [
                    84.0003145,
                    55.1846875
                ],
                [
                    84.0026539,
                    55.1845697
                ],
                [
                    84.0025851,
                    55.184334
                ],
                [
                    84.0045116,
                    55.1841768
                ],
                [
                    84.0045116,
                    55.1839411
                ],
                [
                    84.0060253,
                    55.1836268
                ],
                [
                    84.0055437,
                    55.1821733
                ],
                [
                    84.0036172,
                    55.1821733
                ],
                [
                    84.0033419,
                    55.1815054
                ],
                [
                    84.0045804,
                    55.1811519
                ],
                [
                    84.0045116,
                    55.1805233
                ],
                [
                    84.0038236,
                    55.1806018
                ],
                [
                    84.0038236,
                    55.1803268
                ],
                [
                    84.0045116,
                    55.1800911
                ],
                [
                    84.0036172,
                    55.1780088
                ],
                [
                    84.0016218,
                    55.1779302
                ],
                [
                    84.001553,
                    55.1773801
                ],
                [
                    83.9998716,
                    55.1773174
                ],
                [
                    83.9966678,
                    55.1771837
                ],
                [
                    83.9968054,
                    55.1779302
                ],
                [
                    83.9902689,
                    55.1780874
                ],
                [
                    83.9902689,
                    55.1775766
                ],
                [
                    83.9893744,
                    55.1776552
                ],
                [
                    83.9886864,
                    55.177223
                ],
                [
                    83.9866222,
                    55.1773016
                ],
                [
                    83.9867598,
                    55.1784017
                ],
                [
                    83.9855213,
                    55.1784017
                ]
            ],
            "longitude": 83.993073,
            "latitude": 55.179623
        },
        "10231": {
            "name": "Глядень",
            "population": 54,
            "type": "hamlet",
            "poly": [
                [
                    83.9965165,
                    55.2552827
                ],
                [
                    83.9986481,
                    55.2559453
                ],
                [
                    83.9980668,
                    55.2567184
                ],
                [
                    83.9989388,
                    55.2570497
                ],
                [
                    83.9985512,
                    55.2577675
                ],
                [
                    83.9999077,
                    55.258154
                ],
                [
                    84.0028144,
                    55.2604731
                ],
                [
                    84.0035896,
                    55.2606387
                ],
                [
                    84.0050429,
                    55.2599209
                ],
                [
                    84.0139569,
                    55.2667116
                ],
                [
                    84.0180263,
                    55.264393
                ],
                [
                    84.0164761,
                    55.2640065
                ],
                [
                    84.0151196,
                    55.2630128
                ],
                [
                    84.0150227,
                    55.2611908
                ],
                [
                    84.0140538,
                    55.2606939
                ],
                [
                    84.0137631,
                    55.2599209
                ],
                [
                    84.0136662,
                    55.2593136
                ],
                [
                    84.0104688,
                    55.2561662
                ],
                [
                    84.0066901,
                    55.2548409
                ],
                [
                    84.004946,
                    55.2545096
                ],
                [
                    84.0022331,
                    55.2537917
                ],
                [
                    84.0001984,
                    55.254123
                ],
                [
                    83.9998108,
                    55.2548961
                ],
                [
                    83.9968072,
                    55.2545096
                ],
                [
                    83.9965165,
                    55.2552827
                ]
            ],
            "longitude": 84.009361,
            "latitude": 55.262276
        },
        "10232": {
            "name": "Горн",
            "population": 115,
            "type": "hamlet",
            "poly": [
                [
                    84.0164968,
                    55.5426703
                ],
                [
                    84.0188726,
                    55.5431238
                ],
                [
                    84.018147,
                    55.5436461
                ],
                [
                    84.018615,
                    55.5438364
                ],
                [
                    84.0196741,
                    55.5434963
                ],
                [
                    84.0203611,
                    55.5446138
                ],
                [
                    84.0184433,
                    55.5445652
                ],
                [
                    84.0180711,
                    55.5448081
                ],
                [
                    84.0181284,
                    55.5450996
                ],
                [
                    84.0203325,
                    55.5464923
                ],
                [
                    84.0212771,
                    55.5479011
                ],
                [
                    84.0219068,
                    55.5479497
                ],
                [
                    84.0215633,
                    55.5498605
                ],
                [
                    84.020676,
                    55.5503948
                ],
                [
                    84.0191302,
                    55.5509454
                ],
                [
                    84.0180998,
                    55.5518683
                ],
                [
                    84.0184483,
                    55.5526314
                ],
                [
                    84.0231377,
                    55.5505729
                ],
                [
                    84.024254,
                    55.5506701
                ],
                [
                    84.0254849,
                    55.5502005
                ],
                [
                    84.0319144,
                    55.5509089
                ],
                [
                    84.0309521,
                    55.5497633
                ],
                [
                    84.031725,
                    55.5496824
                ],
                [
                    84.0321257,
                    55.5491318
                ],
                [
                    84.033021,
                    55.5491198
                ],
                [
                    84.0338146,
                    55.5484355
                ],
                [
                    84.0326982,
                    55.548225
                ],
                [
                    84.0332135,
                    55.5475287
                ],
                [
                    84.0323833,
                    55.5470429
                ],
                [
                    84.031267,
                    55.548225
                ],
                [
                    84.0291488,
                    55.5480793
                ],
                [
                    84.0288053,
                    55.5474153
                ],
                [
                    84.0268302,
                    55.5475935
                ],
                [
                    84.0270306,
                    55.5484193
                ],
                [
                    84.0247406,
                    55.5479011
                ],
                [
                    84.0233094,
                    55.5477554
                ],
                [
                    84.0232052,
                    55.5473752
                ],
                [
                    84.0227381,
                    55.5468868
                ],
                [
                    84.0235315,
                    55.5458802
                ],
                [
                    84.0239162,
                    55.5457454
                ],
                [
                    84.024246,
                    55.5450199
                ],
                [
                    84.0236781,
                    55.5449059
                ],
                [
                    84.0251803,
                    55.5440871
                ],
                [
                    84.0252902,
                    55.5448644
                ],
                [
                    84.0257849,
                    55.544823
                ],
                [
                    84.0259131,
                    55.5442115
                ],
                [
                    84.0255284,
                    55.543942
                ],
                [
                    84.0272504,
                    55.5426878
                ],
                [
                    84.0276718,
                    55.543714
                ],
                [
                    84.0278916,
                    55.5436
                ],
                [
                    84.0281664,
                    55.5421903
                ],
                [
                    84.0285694,
                    55.5419623
                ],
                [
                    84.0285878,
                    55.5414196
                ],
                [
                    84.0272561,
                    55.5415614
                ],
                [
                    84.0273706,
                    55.5421282
                ],
                [
                    84.0251379,
                    55.5423711
                ],
                [
                    84.0249375,
                    55.543019
                ],
                [
                    84.023678,
                    55.543019
                ],
                [
                    84.0235063,
                    55.542112
                ],
                [
                    84.022991,
                    55.5419824
                ],
                [
                    84.019642,
                    55.5419339
                ],
                [
                    84.0187832,
                    55.5416261
                ],
                [
                    84.017928,
                    55.5417472
                ],
                [
                    84.0165254,
                    55.5421521
                ],
                [
                    84.0164968,
                    55.5426703
                ]
            ],
            "longitude": 84.0216898,
            "latitude": 55.5450709
        },
        "10233": {
            "name": "Новая Поляна",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    84.0203232,
                    55.8065155
                ],
                [
                    84.0212769,
                    55.8065869
                ],
                [
                    84.0214656,
                    55.8056968
                ],
                [
                    84.0223165,
                    55.8059799
                ],
                [
                    84.0219582,
                    55.8070506
                ],
                [
                    84.0230045,
                    55.8073483
                ],
                [
                    84.0231692,
                    55.8071954
                ],
                [
                    84.0226482,
                    55.8070217
                ],
                [
                    84.0231505,
                    55.8062101
                ],
                [
                    84.0240483,
                    55.8066162
                ],
                [
                    84.0229656,
                    55.8082671
                ],
                [
                    84.0245874,
                    55.8087261
                ],
                [
                    84.0261265,
                    55.8092258
                ],
                [
                    84.0269455,
                    55.8093601
                ],
                [
                    84.0276322,
                    55.8089898
                ],
                [
                    84.0278704,
                    55.8091268
                ],
                [
                    84.0284917,
                    55.8087123
                ],
                [
                    84.0291695,
                    55.8090327
                ],
                [
                    84.0296073,
                    55.8087603
                ],
                [
                    84.0293493,
                    55.8085631
                ],
                [
                    84.0301919,
                    55.8081936
                ],
                [
                    84.0291429,
                    55.807505
                ],
                [
                    84.0286432,
                    55.8074571
                ],
                [
                    84.0283467,
                    55.8072054
                ],
                [
                    84.0278704,
                    55.8072246
                ],
                [
                    84.0276492,
                    55.807403
                ],
                [
                    84.0273771,
                    55.8074826
                ],
                [
                    84.0276209,
                    55.8078682
                ],
                [
                    84.0274363,
                    55.8080163
                ],
                [
                    84.0257023,
                    55.8072122
                ],
                [
                    84.027246,
                    55.8061968
                ],
                [
                    84.0269127,
                    55.8058813
                ],
                [
                    84.0265619,
                    55.80597
                ],
                [
                    84.0255093,
                    55.8055757
                ],
                [
                    84.024141,
                    55.8065714
                ],
                [
                    84.0232373,
                    55.8061108
                ],
                [
                    84.0235732,
                    55.8058462
                ],
                [
                    84.0229957,
                    55.8055067
                ],
                [
                    84.0221624,
                    55.8053173
                ],
                [
                    84.0217883,
                    55.8054214
                ],
                [
                    84.0214819,
                    55.8053308
                ],
                [
                    84.0217251,
                    55.8051304
                ],
                [
                    84.0215646,
                    55.8049328
                ],
                [
                    84.0207331,
                    55.8047842
                ],
                [
                    84.020404,
                    55.8050774
                ],
                [
                    84.0209087,
                    55.8055678
                ],
                [
                    84.0204733,
                    55.8057868
                ],
                [
                    84.0203232,
                    55.8065155
                ]
            ],
            "longitude": 84.024986,
            "latitude": 55.807278
        },
        "10234": {
            "name": "Канарбуга",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.034569,
            "latitude": 55.252838
        },
        "10235": {
            "name": "Сибиряк",
            "population": 187,
            "type": "hamlet",
            "poly": [
                [
                    84.0640082,
                    55.4211578
                ],
                [
                    84.0672251,
                    55.4251921
                ],
                [
                    84.0671055,
                    55.4260573
                ],
                [
                    84.0689453,
                    55.4284197
                ],
                [
                    84.0702143,
                    55.4287373
                ],
                [
                    84.0725758,
                    55.4282115
                ],
                [
                    84.0734128,
                    55.4282624
                ],
                [
                    84.0751465,
                    55.4277874
                ],
                [
                    84.0763422,
                    55.4272955
                ],
                [
                    84.0766201,
                    55.426777
                ],
                [
                    84.0759835,
                    55.4262608
                ],
                [
                    84.0749074,
                    55.4265322
                ],
                [
                    84.0728747,
                    55.4237672
                ],
                [
                    84.071798,
                    55.4209365
                ],
                [
                    84.0640082,
                    55.4211578
                ]
            ],
            "longitude": 84.070526,
            "latitude": 55.424374
        },
        "10236": {
            "name": "Зелёная Горка",
            "population": 11,
            "type": "hamlet",
            "poly": [
                [
                    84.0682316,
                    55.4396261
                ],
                [
                    84.0717887,
                    55.4440008
                ],
                [
                    84.072566,
                    55.4438821
                ],
                [
                    84.0740007,
                    55.44317
                ],
                [
                    84.073672,
                    55.4427122
                ],
                [
                    84.0745688,
                    55.4424409
                ],
                [
                    84.073941,
                    55.4419831
                ],
                [
                    84.0731937,
                    55.4421018
                ],
                [
                    84.0726856,
                    55.4415253
                ],
                [
                    84.0742101,
                    55.4411014
                ],
                [
                    84.0735823,
                    55.4408131
                ],
                [
                    84.0721176,
                    55.4411014
                ],
                [
                    84.0715497,
                    55.4402705
                ],
                [
                    84.0725959,
                    55.4398127
                ],
                [
                    84.0718187,
                    55.4391174
                ],
                [
                    84.0707127,
                    55.4393887
                ],
                [
                    84.0701746,
                    55.4390496
                ],
                [
                    84.0682316,
                    55.4396261
                ]
            ],
            "longitude": 84.071518,
            "latitude": 55.441982
        },
        "10237": {
            "name": "Таганай",
            "population": 185,
            "type": "hamlet",
            "poly": [
                [
                    84.0615308,
                    55.550718
                ],
                [
                    84.069517,
                    55.5555268
                ],
                [
                    84.070891,
                    55.5549763
                ],
                [
                    84.0718356,
                    55.5558668
                ],
                [
                    84.0720073,
                    55.5571134
                ],
                [
                    84.0726657,
                    55.5574534
                ],
                [
                    84.0736675,
                    55.557162
                ],
                [
                    84.074011,
                    55.557939
                ],
                [
                    84.0746694,
                    55.5582628
                ],
                [
                    84.0752705,
                    55.5579552
                ],
                [
                    84.0755854,
                    55.5585542
                ],
                [
                    84.0816537,
                    55.5607882
                ],
                [
                    84.0826842,
                    55.5600598
                ],
                [
                    84.0839151,
                    55.560335
                ],
                [
                    84.0850887,
                    55.5599464
                ],
                [
                    84.0867203,
                    55.5600112
                ],
                [
                    84.0874359,
                    55.5594284
                ],
                [
                    84.0887526,
                    55.559736
                ],
                [
                    84.0899548,
                    55.5586837
                ],
                [
                    84.0892964,
                    55.5582952
                ],
                [
                    84.0896113,
                    55.5577933
                ],
                [
                    84.0884377,
                    55.5572429
                ],
                [
                    84.08735,
                    55.5570972
                ],
                [
                    84.0866916,
                    55.5571943
                ],
                [
                    84.0838578,
                    55.5566439
                ],
                [
                    84.0832853,
                    55.5571296
                ],
                [
                    84.0815106,
                    55.5566763
                ],
                [
                    84.0809954,
                    55.5568544
                ],
                [
                    84.0779898,
                    55.5558506
                ],
                [
                    84.0772742,
                    55.5565629
                ],
                [
                    84.076301,
                    55.5562068
                ],
                [
                    84.0768448,
                    55.5556563
                ],
                [
                    84.0746408,
                    55.554442
                ],
                [
                    84.0741541,
                    55.5545877
                ],
                [
                    84.0735244,
                    55.5542477
                ],
                [
                    84.0730378,
                    55.5540049
                ],
                [
                    84.0718642,
                    55.5535515
                ],
                [
                    84.070433,
                    55.5543287
                ],
                [
                    84.0700036,
                    55.5540696
                ],
                [
                    84.0705475,
                    55.5536325
                ],
                [
                    84.0702612,
                    55.5532763
                ],
                [
                    84.0696315,
                    55.5530982
                ],
                [
                    84.0684579,
                    55.5530658
                ],
                [
                    84.06883,
                    55.5527744
                ],
                [
                    84.0672843,
                    55.5517543
                ],
                [
                    84.0670267,
                    55.5509771
                ],
                [
                    84.0657672,
                    55.5502808
                ],
                [
                    84.0647081,
                    55.5498436
                ],
                [
                    84.0643073,
                    55.5501351
                ],
                [
                    84.063649,
                    55.5498922
                ],
                [
                    84.0617884,
                    55.5504265
                ],
                [
                    84.0615308,
                    55.550718
                ]
            ],
            "longitude": 84.079437,
            "latitude": 55.558369
        },
        "10238": {
            "name": "Мурлыткино",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    84.0767601,
                    55.2327662
                ],
                [
                    84.0788673,
                    55.2382592
                ],
                [
                    84.0833108,
                    55.2372977
                ],
                [
                    84.0793189,
                    55.231822
                ],
                [
                    84.0767601,
                    55.2327662
                ]
            ],
            "longitude": 84.080078,
            "latitude": 55.234627
        },
        "10239": {
            "name": "Елтышево",
            "population": 213,
            "type": "hamlet",
            "poly": [
                [
                    84.0686942,
                    55.3661619
                ],
                [
                    84.0756675,
                    55.3694309
                ],
                [
                    84.0922123,
                    55.3769879
                ],
                [
                    84.104336,
                    55.3782309
                ],
                [
                    84.1224759,
                    55.3739839
                ],
                [
                    84.1146365,
                    55.3688039
                ],
                [
                    84.1122665,
                    55.3656956
                ],
                [
                    84.1107168,
                    55.3593228
                ],
                [
                    84.1073441,
                    55.3566284
                ],
                [
                    84.1030598,
                    55.3518089
                ],
                [
                    84.098502,
                    55.3473517
                ],
                [
                    84.0955159,
                    55.3474787
                ],
                [
                    84.0906626,
                    55.3477145
                ],
                [
                    84.0916653,
                    55.3548147
                ],
                [
                    84.0789947,
                    55.3524308
                ],
                [
                    84.0737077,
                    55.3575611
                ],
                [
                    84.0686942,
                    55.3661619
                ]
            ],
            "longitude": 84.091187,
            "latitude": 55.364685
        },
        "10240": {
            "name": "Боровлянка",
            "population": 254,
            "type": "hamlet",
            "poly": [
                [
                    84.1039316,
                    55.0205712
                ],
                [
                    84.1047776,
                    55.0208725
                ],
                [
                    84.1057261,
                    55.0200642
                ],
                [
                    84.1066618,
                    55.0187047
                ],
                [
                    84.1081231,
                    55.0197261
                ],
                [
                    84.108687,
                    55.0198363
                ],
                [
                    84.1098407,
                    55.0197923
                ],
                [
                    84.1095971,
                    55.0200201
                ],
                [
                    84.1093664,
                    55.0199686
                ],
                [
                    84.1091357,
                    55.0201964
                ],
                [
                    84.1092895,
                    55.0202773
                ],
                [
                    84.1081871,
                    55.0215779
                ],
                [
                    84.1080333,
                    55.0218792
                ],
                [
                    84.1074052,
                    55.0224964
                ],
                [
                    84.1067515,
                    55.0222098
                ],
                [
                    84.1064311,
                    55.0222245
                ],
                [
                    84.1059953,
                    55.022467
                ],
                [
                    84.105662,
                    55.0229152
                ],
                [
                    84.1057774,
                    55.0232165
                ],
                [
                    84.1053287,
                    55.0235104
                ],
                [
                    84.1055338,
                    55.0237529
                ],
                [
                    84.1068284,
                    55.0243113
                ],
                [
                    84.1082,
                    55.0233488
                ],
                [
                    84.1098791,
                    55.0239733
                ],
                [
                    84.1106097,
                    55.0233561
                ],
                [
                    84.1111994,
                    55.0235472
                ],
                [
                    84.1116865,
                    55.0230548
                ],
                [
                    84.1114942,
                    55.022952
                ],
                [
                    84.1124812,
                    55.0221364
                ],
                [
                    84.1142757,
                    55.0227389
                ],
                [
                    84.114609,
                    55.0225331
                ],
                [
                    84.115173,
                    55.0226948
                ],
                [
                    84.1153268,
                    55.0224964
                ],
                [
                    84.1158267,
                    55.0227462
                ],
                [
                    84.1155575,
                    55.0230108
                ],
                [
                    84.1173264,
                    55.0235104
                ],
                [
                    84.1184144,
                    55.0227032
                ],
                [
                    84.1186466,
                    55.0220261
                ],
                [
                    84.1182236,
                    55.0217396
                ],
                [
                    84.118339,
                    55.0214824
                ],
                [
                    84.1171982,
                    55.020821
                ],
                [
                    84.1174674,
                    55.0206079
                ],
                [
                    84.1169547,
                    55.020336
                ],
                [
                    84.1172238,
                    55.0200935
                ],
                [
                    84.1166727,
                    55.019829
                ],
                [
                    84.1185441,
                    55.0189398
                ],
                [
                    84.1170444,
                    55.0182344
                ],
                [
                    84.1147682,
                    55.0177124
                ],
                [
                    84.1136296,
                    55.0174247
                ],
                [
                    84.1126734,
                    55.0172717
                ],
                [
                    84.1123658,
                    55.0170438
                ],
                [
                    84.1113788,
                    55.0172717
                ],
                [
                    84.1109815,
                    55.0160517
                ],
                [
                    84.111648,
                    55.0161546
                ],
                [
                    84.1118915,
                    55.0153315
                ],
                [
                    84.1121351,
                    55.0151992
                ],
                [
                    84.1122761,
                    55.0149567
                ],
                [
                    84.1119428,
                    55.0147582
                ],
                [
                    84.1125196,
                    55.0142291
                ],
                [
                    84.1143782,
                    55.0135897
                ],
                [
                    84.1148012,
                    55.0132663
                ],
                [
                    84.1140322,
                    55.0129208
                ],
                [
                    84.1148269,
                    55.0120168
                ],
                [
                    84.1141988,
                    55.0118184
                ],
                [
                    84.1134425,
                    55.0126416
                ],
                [
                    84.1127888,
                    55.0125019
                ],
                [
                    84.1126929,
                    55.0125807
                ],
                [
                    84.1124171,
                    55.0124872
                ],
                [
                    84.1111866,
                    55.0133324
                ],
                [
                    84.1093792,
                    55.0124799
                ],
                [
                    84.1095715,
                    55.0122153
                ],
                [
                    84.1093151,
                    55.0121638
                ],
                [
                    84.1093023,
                    55.0120389
                ],
                [
                    84.1088409,
                    55.0118625
                ],
                [
                    84.1076074,
                    55.0124171
                ],
                [
                    84.1075334,
                    55.0124358
                ],
                [
                    84.1065464,
                    55.0117302
                ],
                [
                    84.1056492,
                    55.0123329
                ],
                [
                    84.1060722,
                    55.0126195
                ],
                [
                    84.1057261,
                    55.0127738
                ],
                [
                    84.1055595,
                    55.0129796
                ],
                [
                    84.1049442,
                    55.0132369
                ],
                [
                    84.1050339,
                    55.0135823
                ],
                [
                    84.1052518,
                    55.0134868
                ],
                [
                    84.1058286,
                    55.0138469
                ],
                [
                    84.1058415,
                    55.0140306
                ],
                [
                    84.1061234,
                    55.0140233
                ],
                [
                    84.1064439,
                    55.0139424
                ],
                [
                    84.1067259,
                    55.0136485
                ],
                [
                    84.1069053,
                    55.0138763
                ],
                [
                    84.1067259,
                    55.0139718
                ],
                [
                    84.1069438,
                    55.0141703
                ],
                [
                    84.107213,
                    55.0141335
                ],
                [
                    84.1076103,
                    55.0142585
                ],
                [
                    84.1080077,
                    55.0148758
                ],
                [
                    84.1066234,
                    55.0154932
                ],
                [
                    84.1076872,
                    55.0160297
                ],
                [
                    84.1080461,
                    55.0160223
                ],
                [
                    84.1081871,
                    55.0158239
                ],
                [
                    84.1084691,
                    55.0157504
                ],
                [
                    84.1086999,
                    55.0158606
                ],
                [
                    84.1104688,
                    55.0152359
                ],
                [
                    84.1108917,
                    55.0171467
                ],
                [
                    84.1095715,
                    55.0167793
                ],
                [
                    84.1092767,
                    55.017257
                ],
                [
                    84.1094561,
                    55.018565
                ],
                [
                    84.1097125,
                    55.0186385
                ],
                [
                    84.1095971,
                    55.0195424
                ],
                [
                    84.1089434,
                    55.0197261
                ],
                [
                    84.1082,
                    55.0195792
                ],
                [
                    84.1082256,
                    55.0191309
                ],
                [
                    84.108764,
                    55.0184181
                ],
                [
                    84.1086486,
                    55.0180727
                ],
                [
                    84.1083794,
                    55.0180433
                ],
                [
                    84.1086358,
                    55.016963
                ],
                [
                    84.1080333,
                    55.0167131
                ],
                [
                    84.1079949,
                    55.0164706
                ],
                [
                    84.1073796,
                    55.0161766
                ],
                [
                    84.1069566,
                    55.0161766
                ],
                [
                    84.106085,
                    55.0163971
                ],
                [
                    84.1057517,
                    55.0168969
                ],
                [
                    84.1053544,
                    55.016816
                ],
                [
                    84.1047647,
                    55.0173231
                ],
                [
                    84.1052006,
                    55.0174627
                ],
                [
                    84.1050724,
                    55.0178816
                ],
                [
                    84.1050467,
                    55.0187561
                ],
                [
                    84.1039316,
                    55.0205712
                ]
            ],
            "longitude": 84.112122,
            "latitude": 55.018082
        },
        "10241": {
            "name": "Рожневский Бор",
            "population": 17,
            "type": "hamlet",
            "poly": [
                [
                    84.113656,
                    55.2490057
                ],
                [
                    84.1144436,
                    55.2492801
                ],
                [
                    84.1153441,
                    55.2489184
                ],
                [
                    84.119038,
                    55.2474344
                ],
                [
                    84.1182941,
                    55.2470603
                ],
                [
                    84.113656,
                    55.2490057
                ]
            ],
            "longitude": 84.115791,
            "latitude": 55.248352
        },
        "10242": {
            "name": "Верхний Елбак",
            "population": 146,
            "type": "hamlet",
            "poly": [
                [
                    84.1302662,
                    55.7059397
                ],
                [
                    84.1303688,
                    55.7065174
                ],
                [
                    84.1314453,
                    55.7068351
                ],
                [
                    84.131958,
                    55.7064596
                ],
                [
                    84.1328295,
                    55.7065174
                ],
                [
                    84.1330858,
                    55.7073839
                ],
                [
                    84.1342649,
                    55.7074417
                ],
                [
                    84.1345725,
                    55.7070662
                ],
                [
                    84.1355978,
                    55.7074128
                ],
                [
                    84.1353415,
                    55.7078461
                ],
                [
                    84.1358029,
                    55.7085682
                ],
                [
                    84.1391864,
                    55.7098101
                ],
                [
                    84.1403655,
                    55.7087126
                ],
                [
                    84.1412883,
                    55.7090592
                ],
                [
                    84.1404168,
                    55.7098679
                ],
                [
                    84.1410832,
                    55.7100412
                ],
                [
                    84.1419035,
                    55.7093191
                ],
                [
                    84.1425699,
                    55.709579
                ],
                [
                    84.1421598,
                    55.7105899
                ],
                [
                    84.1451844,
                    55.7123228
                ],
                [
                    84.1467737,
                    55.7122072
                ],
                [
                    84.1480553,
                    55.7134491
                ],
                [
                    84.1494394,
                    55.7139689
                ],
                [
                    84.1489268,
                    55.7145176
                ],
                [
                    84.149542,
                    55.7147486
                ],
                [
                    84.1517976,
                    55.7133336
                ],
                [
                    84.1551812,
                    55.7146331
                ],
                [
                    84.1568729,
                    55.7130736
                ],
                [
                    84.1549761,
                    55.712265
                ],
                [
                    84.1544634,
                    55.7125538
                ],
                [
                    84.1523616,
                    55.7115719
                ],
                [
                    84.1508749,
                    55.7118318
                ],
                [
                    84.1495932,
                    55.7113408
                ],
                [
                    84.1501572,
                    55.7107054
                ],
                [
                    84.1488755,
                    55.7101856
                ],
                [
                    84.1481066,
                    55.7103011
                ],
                [
                    84.1454408,
                    55.7086548
                ],
                [
                    84.144723,
                    55.7087992
                ],
                [
                    84.1430826,
                    55.7078461
                ],
                [
                    84.1431338,
                    55.7072684
                ],
                [
                    84.1410832,
                    55.707124
                ],
                [
                    84.1402117,
                    55.707615
                ],
                [
                    84.1395453,
                    55.7070951
                ],
                [
                    84.1398016,
                    55.7066329
                ],
                [
                    84.1357516,
                    55.7055064
                ],
                [
                    84.1312915,
                    55.7045532
                ],
                [
                    84.1308302,
                    55.7048132
                ],
                [
                    84.1302662,
                    55.7059397
                ]
            ],
            "longitude": 84.144577,
            "latitude": 55.709202
        },
        "10243": {
            "name": "Козловка",
            "population": 143,
            "type": "hamlet",
            "poly": [
                [
                    84.1786237,
                    55.8517913
                ],
                [
                    84.1791377,
                    55.8519356
                ],
                [
                    84.178795,
                    55.852777
                ],
                [
                    84.1804225,
                    55.8528972
                ],
                [
                    84.1808508,
                    55.852176
                ],
                [
                    84.1813647,
                    55.8524885
                ],
                [
                    84.1788807,
                    55.8557339
                ],
                [
                    84.1794375,
                    55.8568396
                ],
                [
                    84.1803369,
                    55.8566714
                ],
                [
                    84.1803369,
                    55.8573444
                ],
                [
                    84.1789235,
                    55.8575367
                ],
                [
                    84.1794375,
                    55.8595559
                ],
                [
                    84.18205,
                    55.8621998
                ],
                [
                    84.1825211,
                    55.8620796
                ],
                [
                    84.183292,
                    55.8627526
                ],
                [
                    84.1828637,
                    55.8629449
                ],
                [
                    84.1860331,
                    55.8652521
                ],
                [
                    84.1872751,
                    55.8658289
                ],
                [
                    84.1877034,
                    55.8656126
                ],
                [
                    84.1889454,
                    55.8662374
                ],
                [
                    84.1886884,
                    55.8665258
                ],
                [
                    84.1904872,
                    55.867463
                ],
                [
                    84.1921576,
                    55.8673189
                ],
                [
                    84.1926287,
                    55.8674871
                ],
                [
                    84.1921147,
                    55.8678235
                ],
                [
                    84.1934424,
                    55.8683282
                ],
                [
                    84.1956695,
                    55.8671747
                ],
                [
                    84.1941277,
                    55.8664777
                ],
                [
                    84.1931855,
                    55.8667181
                ],
                [
                    84.1923289,
                    55.8662134
                ],
                [
                    84.1930141,
                    55.8656126
                ],
                [
                    84.1918149,
                    55.8649637
                ],
                [
                    84.1914389,
                    55.8649563
                ],
                [
                    84.1902903,
                    55.8644111
                ],
                [
                    84.1902731,
                    55.8643148
                ],
                [
                    84.1897592,
                    55.8638581
                ],
                [
                    84.1892452,
                    55.8640504
                ],
                [
                    84.1873608,
                    55.8626324
                ],
                [
                    84.1877462,
                    55.8623921
                ],
                [
                    84.1872323,
                    55.8617191
                ],
                [
                    84.1861187,
                    55.8619835
                ],
                [
                    84.1857761,
                    55.8615268
                ],
                [
                    84.1850908,
                    55.8615989
                ],
                [
                    84.1849195,
                    55.8612864
                ],
                [
                    84.1856904,
                    55.8611422
                ],
                [
                    84.1845341,
                    55.8601087
                ],
                [
                    84.185048,
                    55.8599164
                ],
                [
                    84.1835062,
                    55.8579935
                ],
                [
                    84.183292,
                    55.857056
                ],
                [
                    84.1817502,
                    55.8567916
                ],
                [
                    84.1821357,
                    55.8553733
                ],
                [
                    84.1832492,
                    55.8555416
                ],
                [
                    84.1840201,
                    55.8547002
                ],
                [
                    84.1825211,
                    55.8544598
                ],
                [
                    84.1828637,
                    55.8534982
                ],
                [
                    84.1853906,
                    55.8538348
                ],
                [
                    84.1854763,
                    55.8535222
                ],
                [
                    84.1849624,
                    55.853402
                ],
                [
                    84.1852193,
                    55.8522
                ],
                [
                    84.1820072,
                    55.8515269
                ],
                [
                    84.1822213,
                    55.8512143
                ],
                [
                    84.1793946,
                    55.8505892
                ],
                [
                    84.1786237,
                    55.8517913
                ]
            ],
            "longitude": 84.181808,
            "latitude": 55.859039
        },
        "10244": {
            "name": "Старый Елбак",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    84.1808648,
                    55.7139675
                ],
                [
                    84.1812661,
                    55.7149849
                ],
                [
                    84.1822193,
                    55.714561
                ],
                [
                    84.1819684,
                    55.7151262
                ],
                [
                    84.1832226,
                    55.717189
                ],
                [
                    84.1852794,
                    55.7178672
                ],
                [
                    84.1861824,
                    55.7175281
                ],
                [
                    84.1874366,
                    55.7179802
                ],
                [
                    84.1895435,
                    55.7167934
                ],
                [
                    84.1886405,
                    55.7151544
                ],
                [
                    84.1895435,
                    55.7150131
                ],
                [
                    84.1898947,
                    55.7129784
                ],
                [
                    84.1906974,
                    55.7118762
                ],
                [
                    84.1892927,
                    55.7115088
                ],
                [
                    84.1875369,
                    55.7139393
                ],
                [
                    84.1855804,
                    55.7140523
                ],
                [
                    84.1852292,
                    55.7136284
                ],
                [
                    84.1858814,
                    55.7134306
                ],
                [
                    84.1855804,
                    55.7130067
                ],
                [
                    84.1843764,
                    55.7128088
                ],
                [
                    84.1819183,
                    55.7132328
                ],
                [
                    84.1816173,
                    55.7138827
                ],
                [
                    84.1808648,
                    55.7139675
                ]
            ],
            "longitude": 84.185074,
            "latitude": 55.714878
        },
        "10245": {
            "name": "Брусянка",
            "population": 147,
            "type": "hamlet",
            "poly": [
                [
                    84.1833013,
                    55.2008211
                ],
                [
                    84.1875158,
                    55.2039135
                ],
                [
                    84.1857097,
                    55.2048584
                ],
                [
                    84.1897738,
                    55.2065763
                ],
                [
                    84.1920316,
                    55.2054597
                ],
                [
                    84.1963229,
                    55.2083414
                ],
                [
                    84.1995577,
                    55.2091529
                ],
                [
                    84.2051271,
                    55.2104412
                ],
                [
                    84.2085891,
                    55.2087235
                ],
                [
                    84.188118,
                    55.1989312
                ],
                [
                    84.1833013,
                    55.2008211
                ]
            ],
            "longitude": 84.19574,
            "latitude": 55.207188
        },
        "10246": {
            "name": "Мезениха",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.199623,
            "latitude": 55.243973
        },
        "10247": {
            "name": "Прямушка",
            "population": 47,
            "type": "hamlet",
            "poly": [
                [
                    84.1956762,
                    55.110502
                ],
                [
                    84.1967291,
                    55.1112247
                ],
                [
                    84.1973609,
                    55.1110641
                ],
                [
                    84.1986244,
                    55.1115861
                ],
                [
                    84.1994668,
                    55.1113853
                ],
                [
                    84.2019939,
                    55.1096989
                ],
                [
                    84.2038892,
                    55.1108232
                ],
                [
                    84.2052229,
                    55.1101005
                ],
                [
                    84.2043805,
                    55.109458
                ],
                [
                    84.2056441,
                    55.1086549
                ],
                [
                    84.2048018,
                    55.1080125
                ],
                [
                    84.2058547,
                    55.1068881
                ],
                [
                    84.209154,
                    55.1050811
                ],
                [
                    84.2059249,
                    55.1034346
                ],
                [
                    84.2032574,
                    55.1051212
                ],
                [
                    84.2016429,
                    55.1064063
                ],
                [
                    84.1999582,
                    55.1054827
                ],
                [
                    84.1990456,
                    55.1060047
                ],
                [
                    84.1980629,
                    55.1058441
                ],
                [
                    84.1977119,
                    55.1061653
                ],
                [
                    84.1982735,
                    55.1064866
                ],
                [
                    84.1972907,
                    55.1070488
                ],
                [
                    84.1984139,
                    55.1079723
                ],
                [
                    84.1956762,
                    55.110502
                ]
            ],
            "longitude": 84.202759,
            "latitude": 55.106358
        },
        "10248": {
            "name": "Мезениха",
            "population": 32,
            "type": "hamlet",
            "poly": [
                [
                    84.1944493,
                    55.2712909
                ],
                [
                    84.1955071,
                    55.273601
                ],
                [
                    84.2011491,
                    55.2758106
                ],
                [
                    84.20397,
                    55.2784217
                ],
                [
                    84.2166644,
                    55.27802
                ],
                [
                    84.2173696,
                    55.275208
                ],
                [
                    84.2027358,
                    55.2721949
                ],
                [
                    84.1977992,
                    55.2652639
                ],
                [
                    84.1944493,
                    55.2712909
                ]
            ],
            "longitude": 84.2034,
            "latitude": 55.274872
        },
        "10249": {
            "name": "Чахлово",
            "population": 184,
            "type": "hamlet",
            "poly": [
                [
                    84.218648,
                    55.6122446
                ],
                [
                    84.2198224,
                    55.6126348
                ],
                [
                    84.2196497,
                    55.613025
                ],
                [
                    84.2246928,
                    55.6159121
                ],
                [
                    84.2243128,
                    55.6163803
                ],
                [
                    84.2249346,
                    55.617024
                ],
                [
                    84.2274561,
                    55.6179213
                ],
                [
                    84.2272143,
                    55.618565
                ],
                [
                    84.2276979,
                    55.6188771
                ],
                [
                    84.2279397,
                    55.6185455
                ],
                [
                    84.2292523,
                    55.6191696
                ],
                [
                    84.2298395,
                    55.618526
                ],
                [
                    84.2301158,
                    55.6180383
                ],
                [
                    84.2290796,
                    55.6173556
                ],
                [
                    84.226938,
                    55.6166924
                ],
                [
                    84.2263163,
                    55.6168679
                ],
                [
                    84.2260399,
                    55.6167509
                ],
                [
                    84.2289414,
                    55.6145856
                ],
                [
                    84.229425,
                    55.6140199
                ],
                [
                    84.2283197,
                    55.6135322
                ],
                [
                    84.2286795,
                    55.6131701
                ],
                [
                    84.2290796,
                    55.6129469
                ],
                [
                    84.2298741,
                    55.6129664
                ],
                [
                    84.2312212,
                    55.6123617
                ],
                [
                    84.2317048,
                    55.611874
                ],
                [
                    84.2314975,
                    55.6115423
                ],
                [
                    84.2291141,
                    55.6109765
                ],
                [
                    84.2288723,
                    55.6111911
                ],
                [
                    84.2276634,
                    55.6107814
                ],
                [
                    84.2275252,
                    55.6100986
                ],
                [
                    84.2254182,
                    55.6096304
                ],
                [
                    84.2250382,
                    55.6100986
                ],
                [
                    84.2246928,
                    55.6098255
                ],
                [
                    84.222588,
                    55.6087768
                ],
                [
                    84.2221367,
                    55.6102547
                ],
                [
                    84.220686,
                    55.6101766
                ],
                [
                    84.2206169,
                    55.6116398
                ],
                [
                    84.2202024,
                    55.6116398
                ],
                [
                    84.2201678,
                    55.612069
                ],
                [
                    84.2195461,
                    55.6120885
                ],
                [
                    84.2190625,
                    55.611874
                ],
                [
                    84.218648,
                    55.6122446
                ]
            ],
            "longitude": 84.225449,
            "latitude": 55.611641
        },
        "10250": {
            "name": "Ковалевка",
            "population": 174,
            "type": "hamlet",
            "poly": [
                [
                    84.2176862,
                    55.2966103
                ],
                [
                    84.2181694,
                    55.2969104
                ],
                [
                    84.2213979,
                    55.2953224
                ],
                [
                    84.2215955,
                    55.2954475
                ],
                [
                    84.2218371,
                    55.2953725
                ],
                [
                    84.2224301,
                    55.2957351
                ],
                [
                    84.2226936,
                    55.2955225
                ],
                [
                    84.2224521,
                    55.2952474
                ],
                [
                    84.2228693,
                    55.2947722
                ],
                [
                    84.2226058,
                    55.2946722
                ],
                [
                    84.2247142,
                    55.2931716
                ],
                [
                    84.2260319,
                    55.2935843
                ],
                [
                    84.2258343,
                    55.2937844
                ],
                [
                    84.2260759,
                    55.2945222
                ],
                [
                    84.2263175,
                    55.2945972
                ],
                [
                    84.2265371,
                    55.2949098
                ],
                [
                    84.2270642,
                    55.2949223
                ],
                [
                    84.227767,
                    55.29566
                ],
                [
                    84.2283819,
                    55.2956851
                ],
                [
                    84.2292604,
                    55.2954975
                ],
                [
                    84.2295679,
                    55.2953349
                ],
                [
                    84.2307758,
                    55.2952224
                ],
                [
                    84.2313029,
                    55.2963103
                ],
                [
                    84.2318415,
                    55.2964652
                ],
                [
                    84.2329263,
                    55.296768
                ],
                [
                    84.2368843,
                    55.2986655
                ],
                [
                    84.2367277,
                    55.2979107
                ],
                [
                    84.2369912,
                    55.2976231
                ],
                [
                    84.2374744,
                    55.2975481
                ],
                [
                    84.2383309,
                    55.2955725
                ],
                [
                    84.2383095,
                    55.2951102
                ],
                [
                    84.2373934,
                    55.2949812
                ],
                [
                    84.2347512,
                    55.2949494
                ],
                [
                    84.2349133,
                    55.2945898
                ],
                [
                    84.2315773,
                    55.2941495
                ],
                [
                    84.2311492,
                    55.2926965
                ],
                [
                    84.2297656,
                    55.2909957
                ],
                [
                    84.2292385,
                    55.2910332
                ],
                [
                    84.2288651,
                    55.2912834
                ],
                [
                    84.2290628,
                    55.291571
                ],
                [
                    84.2278987,
                    55.2918086
                ],
                [
                    84.2281184,
                    55.2912083
                ],
                [
                    84.2288431,
                    55.290583
                ],
                [
                    84.2278987,
                    55.2902454
                ],
                [
                    84.2202997,
                    55.293972
                ],
                [
                    84.2202997,
                    55.2942095
                ],
                [
                    84.2182133,
                    55.2955475
                ],
                [
                    84.2187184,
                    55.2960227
                ],
                [
                    84.2176862,
                    55.2966103
                ]
            ],
            "longitude": 84.228813,
            "latitude": 55.293816
        },
        "10251": {
            "name": "Киевка",
            "population": 150,
            "type": "hamlet",
            "poly": [
                [
                    84.2270679,
                    55.6064136
                ],
                [
                    84.2273995,
                    55.6072877
                ],
                [
                    84.2271694,
                    55.6073809
                ],
                [
                    84.2274824,
                    55.6078652
                ],
                [
                    84.2290851,
                    55.6076311
                ],
                [
                    84.2323182,
                    55.6074906
                ],
                [
                    84.2324011,
                    55.6078184
                ],
                [
                    84.2337828,
                    55.6075375
                ],
                [
                    84.2374304,
                    55.6075999
                ],
                [
                    84.2376238,
                    55.6048682
                ],
                [
                    84.2351921,
                    55.6048058
                ],
                [
                    84.2351644,
                    55.6050868
                ],
                [
                    84.2343354,
                    55.605196
                ],
                [
                    84.2341973,
                    55.6049463
                ],
                [
                    84.2327327,
                    55.6050556
                ],
                [
                    84.2325669,
                    55.6053209
                ],
                [
                    84.2311023,
                    55.6054146
                ],
                [
                    84.2309642,
                    55.6064448
                ],
                [
                    84.2302733,
                    55.6064292
                ],
                [
                    84.2301628,
                    55.6055863
                ],
                [
                    84.2273995,
                    55.6056487
                ],
                [
                    84.22751,
                    55.606398
                ],
                [
                    84.2270679,
                    55.6064136
                ]
            ],
            "longitude": 84.23291,
            "latitude": 55.606346
        },
        "10252": {
            "name": "Шубкино",
            "population": 170,
            "type": "hamlet",
            "poly": [
                [
                    84.2313155,
                    55.0739536
                ],
                [
                    84.2336524,
                    55.0756648
                ],
                [
                    84.2335437,
                    55.0760071
                ],
                [
                    84.235174,
                    55.0769715
                ],
                [
                    84.2357718,
                    55.0766604
                ],
                [
                    84.236261,
                    55.076816
                ],
                [
                    84.2371305,
                    55.0783715
                ],
                [
                    84.2358262,
                    55.0792737
                ],
                [
                    84.2368044,
                    55.079927
                ],
                [
                    84.23925,
                    55.0786826
                ],
                [
                    84.2410977,
                    55.0794915
                ],
                [
                    84.2406785,
                    55.0801334
                ],
                [
                    84.2401195,
                    55.0802692
                ],
                [
                    84.23925,
                    55.0812025
                ],
                [
                    84.2396847,
                    55.081358
                ],
                [
                    84.2386522,
                    55.0825712
                ],
                [
                    84.2396304,
                    55.0832867
                ],
                [
                    84.2424564,
                    55.0836911
                ],
                [
                    84.2461519,
                    55.0801137
                ],
                [
                    84.2479996,
                    55.0808914
                ],
                [
                    84.2491952,
                    55.080207
                ],
                [
                    84.2502822,
                    55.080487
                ],
                [
                    84.2506082,
                    55.0797715
                ],
                [
                    84.2483257,
                    55.077936
                ],
                [
                    84.2533799,
                    55.0765982
                ],
                [
                    84.2534342,
                    55.0737669
                ],
                [
                    84.2487061,
                    55.0749181
                ],
                [
                    84.2479453,
                    55.0742647
                ],
                [
                    84.245228,
                    55.0747625
                ],
                [
                    84.2461519,
                    55.0765048
                ],
                [
                    84.2429455,
                    55.077656
                ],
                [
                    84.2412064,
                    55.0759759
                ],
                [
                    84.2395217,
                    55.0767537
                ],
                [
                    84.2329459,
                    55.0725223
                ],
                [
                    84.2322434,
                    55.073139
                ],
                [
                    84.2313155,
                    55.0739536
                ]
            ],
            "longitude": 84.241058,
            "latitude": 55.078049
        },
        "10253": {
            "name": "Кадниха",
            "population": 123,
            "type": "hamlet",
            "poly": [
                [
                    84.2375877,
                    55.0256773
                ],
                [
                    84.2376678,
                    55.0261825
                ],
                [
                    84.2391899,
                    55.0261939
                ],
                [
                    84.2390498,
                    55.0282718
                ],
                [
                    84.2395905,
                    55.0282948
                ],
                [
                    84.2394903,
                    55.0285817
                ],
                [
                    84.2398909,
                    55.0285588
                ],
                [
                    84.2397783,
                    55.0297369
                ],
                [
                    84.2410613,
                    55.0297548
                ],
                [
                    84.2420314,
                    55.0296292
                ],
                [
                    84.2421879,
                    55.030526
                ],
                [
                    84.2433771,
                    55.0306157
                ],
                [
                    84.2441907,
                    55.0300059
                ],
                [
                    84.2444724,
                    55.0293064
                ],
                [
                    84.2439717,
                    55.0292167
                ],
                [
                    84.2437525,
                    55.028284
                ],
                [
                    84.2440968,
                    55.027423
                ],
                [
                    84.2440343,
                    55.0261674
                ],
                [
                    84.2434397,
                    55.0261136
                ],
                [
                    84.2434397,
                    55.0256472
                ],
                [
                    84.2440343,
                    55.0256293
                ],
                [
                    84.2445975,
                    55.0237637
                ],
                [
                    84.2445975,
                    55.0226156
                ],
                [
                    84.2439091,
                    55.02249
                ],
                [
                    84.2441281,
                    55.0215392
                ],
                [
                    84.2445975,
                    55.0215392
                ],
                [
                    84.2448165,
                    55.0210369
                ],
                [
                    84.2444411,
                    55.0210369
                ],
                [
                    84.2444724,
                    55.0201578
                ],
                [
                    84.2438465,
                    55.020086
                ],
                [
                    84.2440343,
                    55.0196555
                ],
                [
                    84.2444724,
                    55.0196555
                ],
                [
                    84.245067,
                    55.0191711
                ],
                [
                    84.2442533,
                    55.0191711
                ],
                [
                    84.2440343,
                    55.0186866
                ],
                [
                    84.2435336,
                    55.0186866
                ],
                [
                    84.2435648,
                    55.0180408
                ],
                [
                    84.2428764,
                    55.0180228
                ],
                [
                    84.242939,
                    55.0178075
                ],
                [
                    84.2402477,
                    55.0176281
                ],
                [
                    84.2403103,
                    55.0193684
                ],
                [
                    84.2396218,
                    55.0194043
                ],
                [
                    84.2395705,
                    55.0196038
                ],
                [
                    84.23921,
                    55.0195923
                ],
                [
                    84.2391698,
                    55.0204879
                ],
                [
                    84.2399711,
                    55.0204649
                ],
                [
                    84.239931,
                    55.0212916
                ],
                [
                    84.2401112,
                    55.0225086
                ],
                [
                    84.2391698,
                    55.0241504
                ],
                [
                    84.2382687,
                    55.0242078
                ],
                [
                    84.2382286,
                    55.024713
                ],
                [
                    84.2379082,
                    55.0247245
                ],
                [
                    84.2378681,
                    55.0252296
                ],
                [
                    84.2386893,
                    55.0252296
                ],
                [
                    84.2384489,
                    55.0256888
                ],
                [
                    84.2375877,
                    55.0256773
                ]
            ],
            "longitude": 84.242332,
            "latitude": 55.022289
        },
        "10254": {
            "name": "Верх-Чемской",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    84.2380956,
                    54.8654495
                ],
                [
                    84.2381975,
                    54.8657093
                ],
                [
                    84.2386197,
                    54.8659942
                ],
                [
                    84.2385637,
                    54.8661824
                ],
                [
                    84.2385615,
                    54.8664299
                ],
                [
                    84.240629,
                    54.866698
                ],
                [
                    84.2407892,
                    54.8668907
                ],
                [
                    84.2408183,
                    54.867184
                ],
                [
                    84.2412551,
                    54.8676867
                ],
                [
                    84.242187,
                    54.8678794
                ],
                [
                    84.2431188,
                    54.8678375
                ],
                [
                    84.2442399,
                    54.8674689
                ],
                [
                    84.2446331,
                    54.8676783
                ],
                [
                    84.2452883,
                    54.8673935
                ],
                [
                    84.2460599,
                    54.867804
                ],
                [
                    84.2459871,
                    54.8678962
                ],
                [
                    84.2464822,
                    54.8681057
                ],
                [
                    84.2470064,
                    54.8677789
                ],
                [
                    84.2478072,
                    54.8681895
                ],
                [
                    84.2480692,
                    54.8680889
                ],
                [
                    84.2498893,
                    54.8690189
                ],
                [
                    84.2502533,
                    54.8687006
                ],
                [
                    84.2493214,
                    54.8682649
                ],
                [
                    84.2497,
                    54.8679381
                ],
                [
                    84.2495544,
                    54.8674437
                ],
                [
                    84.2498456,
                    54.8673181
                ],
                [
                    84.2497437,
                    54.8670751
                ],
                [
                    84.2487536,
                    54.8661534
                ],
                [
                    84.2483459,
                    54.8661701
                ],
                [
                    84.2479673,
                    54.865659
                ],
                [
                    84.2481566,
                    54.8655584
                ],
                [
                    84.2476907,
                    54.8652149
                ],
                [
                    84.2476907,
                    54.8650724
                ],
                [
                    84.2473704,
                    54.8648378
                ],
                [
                    84.2490593,
                    54.864201
                ],
                [
                    84.2479382,
                    54.8631954
                ],
                [
                    84.2473558,
                    54.8634468
                ],
                [
                    84.2456668,
                    54.8639999
                ],
                [
                    84.2453611,
                    54.8637988
                ],
                [
                    84.2449971,
                    54.8639412
                ],
                [
                    84.2455067,
                    54.8645697
                ],
                [
                    84.2440652,
                    54.8649719
                ],
                [
                    84.2446331,
                    54.8659104
                ],
                [
                    84.2440943,
                    54.8655501
                ],
                [
                    84.2423471,
                    54.8652484
                ],
                [
                    84.241287,
                    54.8651824
                ],
                [
                    84.2407164,
                    54.8649384
                ],
                [
                    84.2395079,
                    54.864863
                ],
                [
                    84.2388964,
                    54.8649719
                ],
                [
                    84.2388236,
                    54.8652819
                ],
                [
                    84.2382266,
                    54.8653071
                ],
                [
                    84.2380956,
                    54.8654495
                ]
            ],
            "longitude": 84.245827,
            "latitude": 54.866344
        },
        "10255": {
            "name": "Лебяжье",
            "population": 12,
            "type": "hamlet",
            "poly": [
                [
                    84.242637,
                    55.5668154
                ],
                [
                    84.2438971,
                    55.5675283
                ],
                [
                    84.2450715,
                    55.5672939
                ],
                [
                    84.2467923,
                    55.5677681
                ],
                [
                    84.2534452,
                    55.5627537
                ],
                [
                    84.255054,
                    55.5607114
                ],
                [
                    84.2503034,
                    55.5597165
                ],
                [
                    84.242637,
                    55.5668154
                ]
            ],
            "longitude": 84.248177,
            "latitude": 55.564484
        },
        "10256": {
            "name": "Зверобойка",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.278397,
            "latitude": 55.162365
        },
        "10257": {
            "name": "Марай",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    84.274087,
                    54.9776784
                ],
                [
                    84.2742018,
                    54.977829
                ],
                [
                    84.274612,
                    54.9779138
                ],
                [
                    84.2750714,
                    54.9776407
                ],
                [
                    84.2756539,
                    54.9778431
                ],
                [
                    84.2764824,
                    54.9772923
                ],
                [
                    84.2770321,
                    54.9775277
                ],
                [
                    84.2761297,
                    54.9781962
                ],
                [
                    84.2767449,
                    54.9784316
                ],
                [
                    84.2776555,
                    54.977749
                ],
                [
                    84.2778934,
                    54.9779138
                ],
                [
                    84.2777212,
                    54.9780362
                ],
                [
                    84.2780493,
                    54.9781633
                ],
                [
                    84.2773438,
                    54.978667
                ],
                [
                    84.2779919,
                    54.9789495
                ],
                [
                    84.2780903,
                    54.9788365
                ],
                [
                    84.2786564,
                    54.9790766
                ],
                [
                    84.2782626,
                    54.9793779
                ],
                [
                    84.2789271,
                    54.9795615
                ],
                [
                    84.2792306,
                    54.9793402
                ],
                [
                    84.2815193,
                    54.9803571
                ],
                [
                    84.2822741,
                    54.9796274
                ],
                [
                    84.2843906,
                    54.9807384
                ],
                [
                    84.2854817,
                    54.982226
                ],
                [
                    84.2857278,
                    54.9827485
                ],
                [
                    84.2846285,
                    54.982838
                ],
                [
                    84.2847844,
                    54.983304
                ],
                [
                    84.2858919,
                    54.9832522
                ],
                [
                    84.2856046,
                    54.9853469
                ],
                [
                    84.2844398,
                    54.985314
                ],
                [
                    84.2845219,
                    54.9841278
                ],
                [
                    84.2838492,
                    54.9840995
                ],
                [
                    84.2836933,
                    54.985281
                ],
                [
                    84.2829713,
                    54.985281
                ],
                [
                    84.2829632,
                    54.984349
                ],
                [
                    84.2823069,
                    54.9843396
                ],
                [
                    84.2821757,
                    54.9844526
                ],
                [
                    84.2815932,
                    54.9844526
                ],
                [
                    84.2815686,
                    54.9852339
                ],
                [
                    84.280658,
                    54.9851633
                ],
                [
                    84.2806416,
                    54.9843349
                ],
                [
                    84.2798951,
                    54.9843631
                ],
                [
                    84.2797886,
                    54.9854219
                ],
                [
                    84.281541,
                    54.9855512
                ],
                [
                    84.2816662,
                    54.9862263
                ],
                [
                    84.2824423,
                    54.9861688
                ],
                [
                    84.2826175,
                    54.9855368
                ],
                [
                    84.2830181,
                    54.9855224
                ],
                [
                    84.282943,
                    54.9863125
                ],
                [
                    84.2851461,
                    54.9863269
                ],
                [
                    84.2851711,
                    54.9856517
                ],
                [
                    84.2862727,
                    54.9856374
                ],
                [
                    84.2863227,
                    54.9862838
                ],
                [
                    84.2871739,
                    54.9863125
                ],
                [
                    84.2873742,
                    54.9864561
                ],
                [
                    84.2877747,
                    54.9864561
                ],
                [
                    84.2878279,
                    54.9865896
                ],
                [
                    84.2884432,
                    54.9865613
                ],
                [
                    84.288435,
                    54.9871073
                ],
                [
                    84.2889764,
                    54.9871026
                ],
                [
                    84.2890092,
                    54.9868814
                ],
                [
                    84.29033,
                    54.9868014
                ],
                [
                    84.2903218,
                    54.9859871
                ],
                [
                    84.2901905,
                    54.9857658
                ],
                [
                    84.2896245,
                    54.9855022
                ],
                [
                    84.2886729,
                    54.985474
                ],
                [
                    84.2887139,
                    54.9851586
                ],
                [
                    84.2879838,
                    54.9851351
                ],
                [
                    84.2880084,
                    54.9848856
                ],
                [
                    84.2873357,
                    54.9848762
                ],
                [
                    84.2874916,
                    54.9838312
                ],
                [
                    84.2861216,
                    54.983803
                ],
                [
                    84.2861872,
                    54.9832899
                ],
                [
                    84.2874587,
                    54.9833511
                ],
                [
                    84.2872864,
                    54.9817835
                ],
                [
                    84.2856294,
                    54.9818353
                ],
                [
                    84.2844398,
                    54.9804418
                ],
                [
                    84.2837097,
                    54.9799946
                ],
                [
                    84.2841691,
                    54.9795803
                ],
                [
                    84.2836769,
                    54.9793779
                ],
                [
                    84.2833406,
                    54.9796274
                ],
                [
                    84.2826925,
                    54.9793732
                ],
                [
                    84.2831355,
                    54.9789919
                ],
                [
                    84.2825038,
                    54.9786859
                ],
                [
                    84.2823479,
                    54.9787518
                ],
                [
                    84.2820526,
                    54.9786529
                ],
                [
                    84.2814374,
                    54.9790531
                ],
                [
                    84.2806662,
                    54.9786953
                ],
                [
                    84.2812815,
                    54.9782198
                ],
                [
                    84.2807319,
                    54.9780126
                ],
                [
                    84.2802971,
                    54.9783798
                ],
                [
                    84.280051,
                    54.9784646
                ],
                [
                    84.2793455,
                    54.978168
                ],
                [
                    84.2794849,
                    54.9780691
                ],
                [
                    84.2792798,
                    54.9780126
                ],
                [
                    84.2791404,
                    54.978088
                ],
                [
                    84.2786974,
                    54.9779044
                ],
                [
                    84.2785087,
                    54.9777396
                ],
                [
                    84.2783446,
                    54.9778055
                ],
                [
                    84.2746941,
                    54.9763272
                ],
                [
                    84.274571,
                    54.976459
                ],
                [
                    84.2751617,
                    54.9767038
                ],
                [
                    84.274087,
                    54.9776784
                ]
            ],
            "longitude": 84.286827,
            "latitude": 54.98489
        },
        "10258": {
            "name": "Кустово",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    84.2811111,
                    55.939115
                ],
                [
                    84.2814048,
                    55.9398427
                ],
                [
                    84.2832241,
                    55.9395648
                ],
                [
                    84.2837864,
                    55.9397315
                ],
                [
                    84.2845471,
                    55.940843
                ],
                [
                    84.2856625,
                    55.9411661
                ],
                [
                    84.2858742,
                    55.9417589
                ],
                [
                    84.2867844,
                    55.9427429
                ],
                [
                    84.2873983,
                    55.9427666
                ],
                [
                    84.2867209,
                    55.9433356
                ],
                [
                    84.2883933,
                    55.9442247
                ],
                [
                    84.2889648,
                    55.9435609
                ],
                [
                    84.2881392,
                    55.9432408
                ],
                [
                    84.2878217,
                    55.9420908
                ],
                [
                    84.2883298,
                    55.942079
                ],
                [
                    84.288986,
                    55.9417589
                ],
                [
                    84.2899174,
                    55.9422449
                ],
                [
                    84.2908065,
                    55.9416877
                ],
                [
                    84.2923731,
                    55.941913
                ],
                [
                    84.2929235,
                    55.9423398
                ],
                [
                    84.2941301,
                    55.9420315
                ],
                [
                    84.2924789,
                    55.9412135
                ],
                [
                    84.2930293,
                    55.9407511
                ],
                [
                    84.2942994,
                    55.9410594
                ],
                [
                    84.2951885,
                    55.9402888
                ],
                [
                    84.2951462,
                    55.9398264
                ],
                [
                    84.2971784,
                    55.9400042
                ],
                [
                    84.2979405,
                    55.9390557
                ],
                [
                    84.2984274,
                    55.9392336
                ],
                [
                    84.3003538,
                    55.939281
                ],
                [
                    84.3018145,
                    55.9389965
                ],
                [
                    84.3041007,
                    55.93953
                ],
                [
                    84.304757,
                    55.9387238
                ],
                [
                    84.3041431,
                    55.9384866
                ],
                [
                    84.3035292,
                    55.9390795
                ],
                [
                    84.3013064,
                    55.9387119
                ],
                [
                    84.3019415,
                    55.9380005
                ],
                [
                    84.2978135,
                    55.9371824
                ],
                [
                    84.2976018,
                    55.9373603
                ],
                [
                    84.2964799,
                    55.9372773
                ],
                [
                    84.2959718,
                    55.9374195
                ],
                [
                    84.2963105,
                    55.9379412
                ],
                [
                    84.2948075,
                    55.9378227
                ],
                [
                    84.2927753,
                    55.9372535
                ],
                [
                    84.2920132,
                    55.9373365
                ],
                [
                    84.2916321,
                    55.9377041
                ],
                [
                    84.2912723,
                    55.9377634
                ],
                [
                    84.2894729,
                    55.9374314
                ],
                [
                    84.2889437,
                    55.9375025
                ],
                [
                    84.288478,
                    55.9376804
                ],
                [
                    84.2879276,
                    55.9376567
                ],
                [
                    84.287483,
                    55.9374077
                ],
                [
                    84.2857046,
                    55.936847
                ],
                [
                    84.2829527,
                    55.938002
                ],
                [
                    84.2812618,
                    55.9385956
                ],
                [
                    84.2830587,
                    55.9388068
                ],
                [
                    84.2830804,
                    55.9388186
                ],
                [
                    84.2811111,
                    55.939115
                ]
            ],
            "longitude": 84.290115,
            "latitude": 55.94006
        },
        "10259": {
            "name": "Киселевка",
            "population": 15,
            "type": "hamlet",
            "poly": [
                [
                    84.288944,
                    55.6351458
                ],
                [
                    84.2916266,
                    55.6380795
                ],
                [
                    84.2922134,
                    55.6380164
                ],
                [
                    84.2952593,
                    55.6412022
                ],
                [
                    84.2959858,
                    55.6410445
                ],
                [
                    84.2971036,
                    55.6410918
                ],
                [
                    84.2983051,
                    55.6404767
                ],
                [
                    84.29987,
                    55.6389942
                ],
                [
                    84.2984728,
                    55.6383003
                ],
                [
                    84.2973551,
                    55.6383161
                ],
                [
                    84.2965447,
                    55.6385684
                ],
                [
                    84.2954828,
                    55.6377009
                ],
                [
                    84.2961814,
                    55.6371331
                ],
                [
                    84.2936106,
                    55.6343571
                ],
                [
                    84.2921575,
                    55.6341047
                ],
                [
                    84.288944,
                    55.6351458
                ]
            ],
            "longitude": 84.293968,
            "latitude": 55.637901
        },
        "10260": {
            "name": "Правый Курундус",
            "population": 22,
            "type": "hamlet",
            "poly": [
                [
                    84.3019762,
                    54.993662
                ],
                [
                    84.3032179,
                    54.9945467
                ],
                [
                    84.30468,
                    54.9940412
                ],
                [
                    84.3038388,
                    54.993214
                ],
                [
                    84.3041593,
                    54.9930416
                ],
                [
                    84.3066628,
                    54.9950523
                ],
                [
                    84.3055212,
                    54.9956841
                ],
                [
                    84.3059418,
                    54.9959484
                ],
                [
                    84.3071034,
                    54.9953854
                ],
                [
                    84.3076442,
                    54.9958909
                ],
                [
                    84.3065026,
                    54.9965803
                ],
                [
                    84.3080848,
                    54.9973615
                ],
                [
                    84.3093666,
                    54.9966377
                ],
                [
                    84.3079646,
                    54.9956382
                ],
                [
                    84.308966,
                    54.9951097
                ],
                [
                    84.3086055,
                    54.9948569
                ],
                [
                    84.3074238,
                    54.9952591
                ],
                [
                    84.3071234,
                    54.9950178
                ],
                [
                    84.3078644,
                    54.9945812
                ],
                [
                    84.3069832,
                    54.9939033
                ],
                [
                    84.3072436,
                    54.9937884
                ],
                [
                    84.3056413,
                    54.9925246
                ],
                [
                    84.3060018,
                    54.9923178
                ],
                [
                    84.306843,
                    54.9929267
                ],
                [
                    84.307504,
                    54.9926395
                ],
                [
                    84.3067229,
                    54.991996
                ],
                [
                    84.3080447,
                    54.9914905
                ],
                [
                    84.3082049,
                    54.9915824
                ],
                [
                    84.3085454,
                    54.9914905
                ],
                [
                    84.3084052,
                    54.9913296
                ],
                [
                    84.3086255,
                    54.9912492
                ],
                [
                    84.309687,
                    54.9919731
                ],
                [
                    84.3101076,
                    54.9916398
                ],
                [
                    84.3092464,
                    54.9910653
                ],
                [
                    84.309687,
                    54.9908815
                ],
                [
                    84.3104881,
                    54.9915594
                ],
                [
                    84.311089,
                    54.9912722
                ],
                [
                    84.3103279,
                    54.9906517
                ],
                [
                    84.3108285,
                    54.9904334
                ],
                [
                    84.3118901,
                    54.9911573
                ],
                [
                    84.3123508,
                    54.990893
                ],
                [
                    84.3115496,
                    54.9901806
                ],
                [
                    84.3162162,
                    54.9882272
                ],
                [
                    84.3147141,
                    54.98717
                ],
                [
                    84.3141933,
                    54.9873998
                ],
                [
                    84.3151747,
                    54.9882501
                ],
                [
                    84.314634,
                    54.988434
                ],
                [
                    84.3135123,
                    54.9875607
                ],
                [
                    84.3129116,
                    54.987802
                ],
                [
                    84.3131118,
                    54.9879514
                ],
                [
                    84.3126312,
                    54.9881467
                ],
                [
                    84.3135324,
                    54.9889166
                ],
                [
                    84.3069832,
                    54.9915364
                ],
                [
                    84.3063423,
                    54.9910194
                ],
                [
                    84.3058216,
                    54.9912147
                ],
                [
                    84.3065426,
                    54.9917433
                ],
                [
                    84.306142,
                    54.9918237
                ],
                [
                    84.3054811,
                    54.9913526
                ],
                [
                    84.3050004,
                    54.9916398
                ],
                [
                    84.3048402,
                    54.9915479
                ],
                [
                    84.3044397,
                    54.9917088
                ],
                [
                    84.3051206,
                    54.9922948
                ],
                [
                    84.3035383,
                    54.9929727
                ],
                [
                    84.3026572,
                    54.9924901
                ],
                [
                    84.3020163,
                    54.9928578
                ],
                [
                    84.3028174,
                    54.9932599
                ],
                [
                    84.3019762,
                    54.993662
                ]
            ],
            "longitude": 84.305977,
            "latitude": 54.992092
        },
        "10261": {
            "name": "Терск",
            "population": 72,
            "type": "hamlet",
            "poly": [
                [
                    84.3053516,
                    55.526113
                ],
                [
                    84.3103499,
                    55.5354189
                ],
                [
                    84.3122678,
                    55.5355631
                ],
                [
                    84.3128212,
                    55.5354513
                ],
                [
                    84.3127422,
                    55.5342433
                ],
                [
                    84.3155092,
                    55.5335945
                ],
                [
                    84.3177624,
                    55.5347802
                ],
                [
                    84.3204,
                    55.5337532
                ],
                [
                    84.3173584,
                    55.531244
                ],
                [
                    84.3159869,
                    55.5308192
                ],
                [
                    84.3149983,
                    55.5303928
                ],
                [
                    84.3122678,
                    55.5291649
                ],
                [
                    84.3117539,
                    55.5284489
                ],
                [
                    84.3123469,
                    55.5282252
                ],
                [
                    84.3125445,
                    55.5277106
                ],
                [
                    84.3142012,
                    55.5273891
                ],
                [
                    84.3136513,
                    55.5265247
                ],
                [
                    84.3110028,
                    55.5266814
                ],
                [
                    84.3102913,
                    55.5257416
                ],
                [
                    84.3123469,
                    55.5232579
                ],
                [
                    84.3107657,
                    55.5228775
                ],
                [
                    84.3070499,
                    55.5233026
                ],
                [
                    84.3056663,
                    55.5247123
                ],
                [
                    84.3053516,
                    55.526113
                ]
            ],
            "longitude": 84.311348,
            "latitude": 55.531048
        },
        "10262": {
            "name": "Рыбкинск",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    84.3246643,
                    55.8846211
                ],
                [
                    84.3279323,
                    55.884697
                ],
                [
                    84.3289537,
                    55.8848173
                ],
                [
                    84.3338675,
                    55.8851651
                ],
                [
                    84.3320475,
                    55.884558
                ],
                [
                    84.3359532,
                    55.8840338
                ],
                [
                    84.3345948,
                    55.8833398
                ],
                [
                    84.3369574,
                    55.8817917
                ],
                [
                    84.337084,
                    55.8805965
                ],
                [
                    84.3354017,
                    55.8799129
                ],
                [
                    84.3341164,
                    55.8795
                ],
                [
                    84.3320264,
                    55.8788079
                ],
                [
                    84.3296746,
                    55.879293
                ],
                [
                    84.3268444,
                    55.8796697
                ],
                [
                    84.3253016,
                    55.8805411
                ],
                [
                    84.3249969,
                    55.8814294
                ],
                [
                    84.3266182,
                    55.88176
                ],
                [
                    84.3265762,
                    55.8826716
                ],
                [
                    84.3246643,
                    55.8846211
                ]
            ],
            "longitude": 84.330109,
            "latitude": 55.881107
        },
        "10263": {
            "name": "Витебск",
            "population": 257,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.356964,
            "latitude": 55.739655
        },
        "10264": {
            "name": "Мануйлово",
            "population": 111,
            "type": "hamlet",
            "poly": [
                [
                    84.3872966,
                    55.5858492
                ],
                [
                    84.3890712,
                    55.5865417
                ],
                [
                    84.3910147,
                    55.5870431
                ],
                [
                    84.3916063,
                    55.5870431
                ],
                [
                    84.3913528,
                    55.5875684
                ],
                [
                    84.3941414,
                    55.5877117
                ],
                [
                    84.3964652,
                    55.588428
                ],
                [
                    84.3968877,
                    55.5879982
                ],
                [
                    84.3990425,
                    55.5886429
                ],
                [
                    84.39693,
                    55.5896219
                ],
                [
                    84.3987468,
                    55.5904576
                ],
                [
                    84.3998876,
                    55.5902427
                ],
                [
                    84.4006677,
                    55.5907684
                ],
                [
                    84.3988735,
                    55.5916514
                ],
                [
                    84.3998453,
                    55.5921767
                ],
                [
                    84.3990106,
                    55.5922858
                ],
                [
                    84.3995065,
                    55.593127
                ],
                [
                    84.4006058,
                    55.5938241
                ],
                [
                    84.4010284,
                    55.5953281
                ],
                [
                    84.4016199,
                    55.5956862
                ],
                [
                    84.4020206,
                    55.5957026
                ],
                [
                    84.4024504,
                    55.596342
                ],
                [
                    84.4014509,
                    55.5965695
                ],
                [
                    84.4016621,
                    55.5983599
                ],
                [
                    84.4033222,
                    55.5977807
                ],
                [
                    84.4050672,
                    55.5977966
                ],
                [
                    84.4045352,
                    55.5971425
                ],
                [
                    84.4074083,
                    55.5951371
                ],
                [
                    84.4059718,
                    55.5944209
                ],
                [
                    84.4052535,
                    55.594779
                ],
                [
                    84.4048732,
                    55.594206
                ],
                [
                    84.4033522,
                    55.5946597
                ],
                [
                    84.4028874,
                    55.5945403
                ],
                [
                    84.4022536,
                    55.5935137
                ],
                [
                    84.4024227,
                    55.5927497
                ],
                [
                    84.4031409,
                    55.5925348
                ],
                [
                    84.4040705,
                    55.5936092
                ],
                [
                    84.406352,
                    55.5929407
                ],
                [
                    84.4045352,
                    55.5905054
                ],
                [
                    84.4033522,
                    55.590768
                ],
                [
                    84.4030142,
                    55.5903621
                ],
                [
                    84.4024227,
                    55.589025
                ],
                [
                    84.4041972,
                    55.5889534
                ],
                [
                    84.4036057,
                    55.5879982
                ],
                [
                    84.4045775,
                    55.5876401
                ],
                [
                    84.4045352,
                    55.5873535
                ],
                [
                    84.4032254,
                    55.5873058
                ],
                [
                    84.4035634,
                    55.5869476
                ],
                [
                    84.4052113,
                    55.5869715
                ],
                [
                    84.4054648,
                    55.5850611
                ],
                [
                    84.4069013,
                    55.5852522
                ],
                [
                    84.4079999,
                    55.585085
                ],
                [
                    84.4079576,
                    55.5846791
                ],
                [
                    84.4073661,
                    55.5837477
                ],
                [
                    84.4083379,
                    55.5833179
                ],
                [
                    84.4089716,
                    55.5824343
                ],
                [
                    84.4096899,
                    55.5825776
                ],
                [
                    84.4102814,
                    55.5818611
                ],
                [
                    84.4077996,
                    55.5809023
                ],
                [
                    84.4059718,
                    55.5808581
                ],
                [
                    84.4026339,
                    55.5829358
                ],
                [
                    84.4009104,
                    55.5849636
                ],
                [
                    84.3999298,
                    55.5848701
                ],
                [
                    84.3995495,
                    55.5851805
                ],
                [
                    84.4007748,
                    55.5874013
                ],
                [
                    84.399465,
                    55.5884758
                ],
                [
                    84.3965074,
                    55.5876878
                ],
                [
                    84.397437,
                    55.5864939
                ],
                [
                    84.3961272,
                    55.5861118
                ],
                [
                    84.3954089,
                    55.5855865
                ],
                [
                    84.3962539,
                    55.5844403
                ],
                [
                    84.3938456,
                    55.5835806
                ],
                [
                    84.3919865,
                    55.5847985
                ],
                [
                    84.3910992,
                    55.5844403
                ],
                [
                    84.3916063,
                    55.5841059
                ],
                [
                    84.39055,
                    55.5834373
                ],
                [
                    84.3872966,
                    55.5858492
                ]
            ],
            "longitude": 84.401199,
            "latitude": 55.588371
        },
        "10265": {
            "name": "Верхотуровка",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    84.4013288,
                    55.5138508
                ],
                [
                    84.4042019,
                    55.5140422
                ],
                [
                    84.4043709,
                    55.5136977
                ],
                [
                    84.4061624,
                    55.514023
                ],
                [
                    84.4062638,
                    55.5134297
                ],
                [
                    84.4046075,
                    55.5131809
                ],
                [
                    84.4066405,
                    55.512913
                ],
                [
                    84.406795,
                    55.5117442
                ],
                [
                    84.405385,
                    55.5112287
                ],
                [
                    84.4049118,
                    55.5111713
                ],
                [
                    84.4049794,
                    55.5109033
                ],
                [
                    84.406568,
                    55.5110565
                ],
                [
                    84.406906,
                    55.5106545
                ],
                [
                    84.4065004,
                    55.5104823
                ],
                [
                    84.4066356,
                    55.5102526
                ],
                [
                    84.4070074,
                    55.5102526
                ],
                [
                    84.4074131,
                    55.5094295
                ],
                [
                    84.4066694,
                    55.5092573
                ],
                [
                    84.4068384,
                    55.5089702
                ],
                [
                    84.4061624,
                    55.5087979
                ],
                [
                    84.4059596,
                    55.5078983
                ],
                [
                    84.4075145,
                    55.5080131
                ],
                [
                    84.4074469,
                    55.5075537
                ],
                [
                    84.4061624,
                    55.5073623
                ],
                [
                    84.4057568,
                    55.5068455
                ],
                [
                    84.4024133,
                    55.5071354
                ],
                [
                    84.4030527,
                    55.5088362
                ],
                [
                    84.4025795,
                    55.5092573
                ],
                [
                    84.4033907,
                    55.509353
                ],
                [
                    84.4034245,
                    55.5098506
                ],
                [
                    84.4015992,
                    55.5096784
                ],
                [
                    84.4015316,
                    55.5108268
                ],
                [
                    84.4027481,
                    55.5115
                ],
                [
                    84.4023168,
                    55.512975
                ],
                [
                    84.401464,
                    55.5131809
                ],
                [
                    84.4013288,
                    55.5138508
                ]
            ],
            "longitude": 84.404984,
            "latitude": 55.509537
        },
        "10266": {
            "name": "Краснознаменка",
            "population": 71,
            "type": "hamlet",
            "poly": [
                [
                    84.3943626,
                    55.8418705
                ],
                [
                    84.3949554,
                    55.844105
                ],
                [
                    84.3957386,
                    55.8440456
                ],
                [
                    84.3958233,
                    55.8426431
                ],
                [
                    84.3968817,
                    55.84275
                ],
                [
                    84.398046,
                    55.8438911
                ],
                [
                    84.3991269,
                    55.8440756
                ],
                [
                    84.4003474,
                    55.8438732
                ],
                [
                    84.4006288,
                    55.8442708
                ],
                [
                    84.4012553,
                    55.844361
                ],
                [
                    84.4019453,
                    55.8444477
                ],
                [
                    84.4055981,
                    55.8449261
                ],
                [
                    84.4061375,
                    55.844886
                ],
                [
                    84.4090115,
                    55.8451758
                ],
                [
                    84.4088264,
                    55.8456752
                ],
                [
                    84.4111615,
                    55.8459418
                ],
                [
                    84.4110374,
                    55.8463364
                ],
                [
                    84.4144944,
                    55.8468147
                ],
                [
                    84.4143886,
                    55.8471475
                ],
                [
                    84.4158492,
                    55.8473258
                ],
                [
                    84.4164845,
                    55.8472487
                ],
                [
                    84.4169033,
                    55.8459341
                ],
                [
                    84.4186619,
                    55.8459814
                ],
                [
                    84.419146,
                    55.8448834
                ],
                [
                    84.4194296,
                    55.8437247
                ],
                [
                    84.4159127,
                    55.8433324
                ],
                [
                    84.4112767,
                    55.8428927
                ],
                [
                    84.4108745,
                    55.8435701
                ],
                [
                    84.4099219,
                    55.8434156
                ],
                [
                    84.4094985,
                    55.8437365
                ],
                [
                    84.4091598,
                    55.8436296
                ],
                [
                    84.4095832,
                    55.8427025
                ],
                [
                    84.4077415,
                    55.842548
                ],
                [
                    84.4076116,
                    55.842685
                ],
                [
                    84.4070017,
                    55.8426291
                ],
                [
                    84.4062465,
                    55.8425554
                ],
                [
                    84.4061326,
                    55.8422152
                ],
                [
                    84.4048264,
                    55.8418996
                ],
                [
                    84.4046312,
                    55.8422692
                ],
                [
                    84.4037459,
                    55.8422641
                ],
                [
                    84.4036914,
                    55.8422921
                ],
                [
                    84.4035008,
                    55.8422794
                ],
                [
                    84.4033101,
                    55.842287
                ],
                [
                    84.4031194,
                    55.8422667
                ],
                [
                    84.4029969,
                    55.8422284
                ],
                [
                    84.4029969,
                    55.8419786
                ],
                [
                    84.4022978,
                    55.841948
                ],
                [
                    84.4021752,
                    55.8421647
                ],
                [
                    84.4013535,
                    55.842129
                ],
                [
                    84.4013535,
                    55.8418716
                ],
                [
                    84.3998877,
                    55.8418586
                ],
                [
                    84.3994644,
                    55.8428927
                ],
                [
                    84.3986811,
                    55.8427144
                ],
                [
                    84.3988293,
                    55.8419061
                ],
                [
                    84.3972416,
                    55.8417516
                ],
                [
                    84.3969452,
                    55.8425123
                ],
                [
                    84.3961408,
                    55.8423697
                ],
                [
                    84.3956963,
                    55.8420012
                ],
                [
                    84.3943626,
                    55.8418705
                ]
            ],
            "longitude": 84.41114,
            "latitude": 55.844646
        },
        "10267": {
            "name": "Кандереп",
            "population": 27,
            "type": "hamlet",
            "poly": [
                [
                    84.4029726,
                    55.7977141
                ],
                [
                    84.4085931,
                    55.80189
                ],
                [
                    84.4102727,
                    55.8011275
                ],
                [
                    84.4108542,
                    55.8016722
                ],
                [
                    84.4088515,
                    55.8023258
                ],
                [
                    84.4094975,
                    55.8026162
                ],
                [
                    84.4107249,
                    55.8021814
                ],
                [
                    84.4111219,
                    55.8024602
                ],
                [
                    84.4099973,
                    55.803018
                ],
                [
                    84.4121142,
                    55.8049141
                ],
                [
                    84.4129411,
                    55.8046725
                ],
                [
                    84.4135034,
                    55.8050257
                ],
                [
                    84.4140988,
                    55.8047654
                ],
                [
                    84.4149918,
                    55.8052487
                ],
                [
                    84.4134372,
                    55.8059365
                ],
                [
                    84.417638,
                    55.8092453
                ],
                [
                    84.419358,
                    55.808669
                ],
                [
                    84.4223679,
                    55.8103047
                ],
                [
                    84.424121,
                    55.8094497
                ],
                [
                    84.4221033,
                    55.8082229
                ],
                [
                    84.4205156,
                    55.8087806
                ],
                [
                    84.4195564,
                    55.8081858
                ],
                [
                    84.4216733,
                    55.8075352
                ],
                [
                    84.4096665,
                    55.7978309
                ],
                [
                    84.4063258,
                    55.7981098
                ],
                [
                    84.4045727,
                    55.7966038
                ],
                [
                    84.4029726,
                    55.7977141
                ]
            ],
            "longitude": 84.413353,
            "latitude": 55.803062
        },
        "10268": {
            "name": "Сабановка",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    84.4201332,
                    55.6169182
                ],
                [
                    84.4207754,
                    55.6171282
                ],
                [
                    84.4204036,
                    55.6181399
                ],
                [
                    84.4206064,
                    55.6187125
                ],
                [
                    84.4211135,
                    55.618598
                ],
                [
                    84.4213839,
                    55.6191706
                ],
                [
                    84.4229725,
                    55.6187888
                ],
                [
                    84.4235809,
                    55.6197623
                ],
                [
                    84.4266907,
                    55.6192469
                ],
                [
                    84.4279751,
                    55.6205258
                ],
                [
                    84.4281103,
                    55.6213465
                ],
                [
                    84.4286849,
                    55.6216518
                ],
                [
                    84.4307468,
                    55.6215373
                ],
                [
                    84.4309496,
                    55.6211747
                ],
                [
                    84.4318284,
                    55.621022
                ],
                [
                    84.4321327,
                    55.6212892
                ],
                [
                    84.4341269,
                    55.6209457
                ],
                [
                    84.4326782,
                    55.6183525
                ],
                [
                    84.4319299,
                    55.6184071
                ],
                [
                    84.4309496,
                    55.6165174
                ],
                [
                    84.4301384,
                    55.6166319
                ],
                [
                    84.4296652,
                    55.6161356
                ],
                [
                    84.4282117,
                    55.6163265
                ],
                [
                    84.4274005,
                    55.6163456
                ],
                [
                    84.4202008,
                    55.616231
                ],
                [
                    84.4201332,
                    55.6169182
                ]
            ],
            "longitude": 84.425964,
            "latitude": 55.618011
        },
        "10269": {
            "name": "Серебренниково",
            "population": 150,
            "type": "hamlet",
            "poly": [
                [
                    84.4279552,
                    54.3649947
                ],
                [
                    84.4325423,
                    54.3672146
                ],
                [
                    84.4331342,
                    54.3683568
                ],
                [
                    84.4314695,
                    54.3711583
                ],
                [
                    84.4286951,
                    54.3736364
                ],
                [
                    84.4316175,
                    54.3744768
                ],
                [
                    84.4323944,
                    54.3725159
                ],
                [
                    84.4348729,
                    54.3718479
                ],
                [
                    84.4353168,
                    54.3693697
                ],
                [
                    84.4347619,
                    54.3669128
                ],
                [
                    84.4380173,
                    54.3658999
                ],
                [
                    84.4390531,
                    54.3665896
                ],
                [
                    84.4440841,
                    54.3681628
                ],
                [
                    84.4475244,
                    54.3692404
                ],
                [
                    84.4483753,
                    54.3692404
                ],
                [
                    84.4486342,
                    54.3676887
                ],
                [
                    84.4438991,
                    54.3652749
                ],
                [
                    84.4410137,
                    54.364111
                ],
                [
                    84.43946,
                    54.3638739
                ],
                [
                    84.4400149,
                    54.3632704
                ],
                [
                    84.4420125,
                    54.3634213
                ],
                [
                    84.4493001,
                    54.3636799
                ],
                [
                    84.4609529,
                    54.3662232
                ],
                [
                    84.4613968,
                    54.3655551
                ],
                [
                    84.4571426,
                    54.3646714
                ],
                [
                    84.4501509,
                    54.3630549
                ],
                [
                    84.4440841,
                    54.3626454
                ],
                [
                    84.4400558,
                    54.3622008
                ],
                [
                    84.4368585,
                    54.3613756
                ],
                [
                    84.4349098,
                    54.3622789
                ],
                [
                    84.4367965,
                    54.3642188
                ],
                [
                    84.4379433,
                    54.3650809
                ],
                [
                    84.4338001,
                    54.3661801
                ],
                [
                    84.434355,
                    54.3649516
                ],
                [
                    84.4339111,
                    54.3630118
                ],
                [
                    84.4327643,
                    54.3629471
                ],
                [
                    84.4279552,
                    54.3649947
                ]
            ],
            "longitude": 84.43985,
            "latitude": 54.364918
        },
        "10270": {
            "name": "Долгово",
            "population": 211,
            "type": "hamlet",
            "poly": [
                [
                    84.445345,
                    55.4435168
                ],
                [
                    84.4509776,
                    55.4462558
                ],
                [
                    84.4516671,
                    55.4457669
                ],
                [
                    84.4574602,
                    55.4446828
                ],
                [
                    84.4571166,
                    55.4437437
                ],
                [
                    84.4639337,
                    55.4404945
                ],
                [
                    84.4680098,
                    55.4383314
                ],
                [
                    84.4692257,
                    55.4377911
                ],
                [
                    84.4720858,
                    55.4366158
                ],
                [
                    84.4717571,
                    55.4350493
                ],
                [
                    84.4667606,
                    55.4330724
                ],
                [
                    84.4630789,
                    55.4323637
                ],
                [
                    84.4612676,
                    55.433536
                ],
                [
                    84.4564288,
                    55.4368811
                ],
                [
                    84.4553746,
                    55.4366146
                ],
                [
                    84.4500609,
                    55.4369442
                ],
                [
                    84.4491817,
                    55.4362217
                ],
                [
                    84.4454741,
                    55.4372387
                ],
                [
                    84.4479187,
                    55.4392034
                ],
                [
                    84.447552,
                    55.4406595
                ],
                [
                    84.4492225,
                    55.4412373
                ],
                [
                    84.4480409,
                    55.4423697
                ],
                [
                    84.4469515,
                    55.4422243
                ],
                [
                    84.4468593,
                    55.4426702
                ],
                [
                    84.445345,
                    55.4435168
                ]
            ],
            "longitude": 84.453659,
            "latitude": 55.440716
        },
        "10271": {
            "name": "Высокая Грива",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.457436,
            "latitude": 55.118587
        },
        "10272": {
            "name": "Красный Яр",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    84.4598604,
                    55.1968683
                ],
                [
                    84.4604984,
                    55.1974509
                ],
                [
                    84.4617997,
                    55.1977276
                ],
                [
                    84.4625396,
                    55.1983684
                ],
                [
                    84.4632031,
                    55.1982227
                ],
                [
                    84.4674134,
                    55.2011936
                ],
                [
                    84.4687658,
                    55.2006693
                ],
                [
                    84.4702712,
                    55.2010043
                ],
                [
                    84.4716237,
                    55.2005819
                ],
                [
                    84.4714706,
                    55.1999849
                ],
                [
                    84.4709857,
                    55.1995917
                ],
                [
                    84.4708837,
                    55.1985431
                ],
                [
                    84.4725167,
                    55.1976111
                ],
                [
                    84.4704754,
                    55.1961692
                ],
                [
                    84.4718788,
                    55.1955867
                ],
                [
                    84.4729251,
                    55.1956741
                ],
                [
                    84.4746602,
                    55.194975
                ],
                [
                    84.4782581,
                    55.1938243
                ],
                [
                    84.478845,
                    55.1933437
                ],
                [
                    84.4776712,
                    55.1924552
                ],
                [
                    84.4771863,
                    55.1926008
                ],
                [
                    84.4762422,
                    55.19196
                ],
                [
                    84.4757574,
                    55.1921493
                ],
                [
                    84.476574,
                    55.1928485
                ],
                [
                    84.4742009,
                    55.1935185
                ],
                [
                    84.4732822,
                    55.1927028
                ],
                [
                    84.4727975,
                    55.1928922
                ],
                [
                    84.4735885,
                    55.1937369
                ],
                [
                    84.4700417,
                    55.1947856
                ],
                [
                    84.469761,
                    55.1945817
                ],
                [
                    84.4694803,
                    55.1946691
                ],
                [
                    84.4692761,
                    55.1944943
                ],
                [
                    84.4677196,
                    55.1949604
                ],
                [
                    84.4675155,
                    55.1945963
                ],
                [
                    84.4598604,
                    55.1968683
                ]
            ],
            "longitude": 84.467674,
            "latitude": 55.197895
        },
        "10273": {
            "name": "Останино",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    84.4533308,
                    55.3537987
                ],
                [
                    84.4542333,
                    55.3544325
                ],
                [
                    84.4545518,
                    55.3543269
                ],
                [
                    84.4548703,
                    55.3545834
                ],
                [
                    84.4551357,
                    55.3544778
                ],
                [
                    84.4552154,
                    55.3547645
                ],
                [
                    84.4556135,
                    55.3547947
                ],
                [
                    84.455295,
                    55.355353
                ],
                [
                    84.4553746,
                    55.356032
                ],
                [
                    84.4591171,
                    55.3555793
                ],
                [
                    84.4603646,
                    55.3548097
                ],
                [
                    84.4594091,
                    55.3537535
                ],
                [
                    84.4613202,
                    55.3536931
                ],
                [
                    84.4613733,
                    55.3535422
                ],
                [
                    84.4637621,
                    55.3533008
                ],
                [
                    84.4637621,
                    55.3526368
                ],
                [
                    84.4641603,
                    55.3526368
                ],
                [
                    84.4641072,
                    55.3520785
                ],
                [
                    84.4669207,
                    55.3520181
                ],
                [
                    84.4678231,
                    55.3526217
                ],
                [
                    84.4694688,
                    55.3542363
                ],
                [
                    84.4719107,
                    55.3538289
                ],
                [
                    84.4712206,
                    55.3522143
                ],
                [
                    84.4718045,
                    55.3521388
                ],
                [
                    84.4730255,
                    55.3521539
                ],
                [
                    84.475494,
                    55.3514447
                ],
                [
                    84.4762372,
                    55.3509769
                ],
                [
                    84.4753877,
                    55.350162
                ],
                [
                    84.4728663,
                    55.3506298
                ],
                [
                    84.4719903,
                    55.3493772
                ],
                [
                    84.4703182,
                    55.3497092
                ],
                [
                    84.4702384,
                    55.349513
                ],
                [
                    84.4677966,
                    55.3501318
                ],
                [
                    84.467133,
                    55.350494
                ],
                [
                    84.466151,
                    55.3507354
                ],
                [
                    84.4667879,
                    55.3518219
                ],
                [
                    84.4642399,
                    55.3518069
                ],
                [
                    84.4641867,
                    55.3516258
                ],
                [
                    84.4651423,
                    55.3515201
                ],
                [
                    84.4649831,
                    55.351158
                ],
                [
                    84.4636559,
                    55.3512334
                ],
                [
                    84.4633109,
                    55.3510221
                ],
                [
                    84.4626208,
                    55.3511881
                ],
                [
                    84.4603381,
                    55.3512485
                ],
                [
                    84.4602319,
                    55.3507354
                ],
                [
                    84.4579758,
                    55.3507958
                ],
                [
                    84.4581881,
                    55.3513541
                ],
                [
                    84.4563567,
                    55.3518672
                ],
                [
                    84.456569,
                    55.3522897
                ],
                [
                    84.4559851,
                    55.3525161
                ],
                [
                    84.4565425,
                    55.3529839
                ],
                [
                    84.455003,
                    55.3531046
                ],
                [
                    84.4533308,
                    55.3537987
                ]
            ],
            "longitude": 84.469841,
            "latitude": 55.351444
        },
        "10274": {
            "name": "Александровка",
            "population": 97,
            "type": "hamlet",
            "poly": [
                [
                    84.4564073,
                    55.5217328
                ],
                [
                    84.4579389,
                    55.5223008
                ],
                [
                    84.4588895,
                    55.5225101
                ],
                [
                    84.4581501,
                    55.5229885
                ],
                [
                    84.459893,
                    55.5241544
                ],
                [
                    84.4606852,
                    55.523706
                ],
                [
                    84.4630619,
                    55.525141
                ],
                [
                    84.4654913,
                    55.5262471
                ],
                [
                    84.4659667,
                    55.5269945
                ],
                [
                    84.4698221,
                    55.5284592
                ],
                [
                    84.4704031,
                    55.5281603
                ],
                [
                    84.4714066,
                    55.5286386
                ],
                [
                    84.4718291,
                    55.5283397
                ],
                [
                    84.4745226,
                    55.5297745
                ],
                [
                    84.4737832,
                    55.5303424
                ],
                [
                    84.4766352,
                    55.5318968
                ],
                [
                    84.4777443,
                    55.5312691
                ],
                [
                    84.4783252,
                    55.5317473
                ],
                [
                    84.477533,
                    55.5321359
                ],
                [
                    84.4800681,
                    55.5335108
                ],
                [
                    84.4813357,
                    55.5330923
                ],
                [
                    84.4821807,
                    55.5335407
                ],
                [
                    84.4813885,
                    55.5343178
                ],
                [
                    84.4819166,
                    55.5345868
                ],
                [
                    84.4827088,
                    55.5339591
                ],
                [
                    84.4850327,
                    55.5352742
                ],
                [
                    84.4861946,
                    55.5348259
                ],
                [
                    84.4863002,
                    55.533451
                ],
                [
                    84.4836595,
                    55.5321359
                ],
                [
                    84.4821807,
                    55.5328831
                ],
                [
                    84.4813357,
                    55.5324946
                ],
                [
                    84.4820223,
                    55.5321359
                ],
                [
                    84.4814941,
                    55.5318968
                ],
                [
                    84.4822863,
                    55.5313587
                ],
                [
                    84.4817054,
                    55.5309104
                ],
                [
                    84.480966,
                    55.5311196
                ],
                [
                    84.4800681,
                    55.5301033
                ],
                [
                    84.4757373,
                    55.5279809
                ],
                [
                    84.4743642,
                    55.5275325
                ],
                [
                    84.4734135,
                    55.5278016
                ],
                [
                    84.4688186,
                    55.5256193
                ],
                [
                    84.4695052,
                    55.525141
                ],
                [
                    84.4679208,
                    55.5243338
                ],
                [
                    84.4670758,
                    55.5246029
                ],
                [
                    84.4661251,
                    55.5246627
                ],
                [
                    84.4658823,
                    55.5245492
                ],
                [
                    84.4636956,
                    55.5235266
                ],
                [
                    84.4646463,
                    55.5229885
                ],
                [
                    84.4620056,
                    55.5212245
                ],
                [
                    84.4602099,
                    55.520776
                ],
                [
                    84.4595233,
                    55.5214039
                ],
                [
                    84.4582558,
                    55.5208657
                ],
                [
                    84.4564073,
                    55.5217328
                ]
            ],
            "longitude": 84.476234,
            "latitude": 55.529449
        },
        "10275": {
            "name": "Девино",
            "population": 33,
            "type": "hamlet",
            "poly": [
                [
                    84.4830941,
                    55.1823082
                ],
                [
                    84.4854098,
                    55.1830668
                ],
                [
                    84.4865676,
                    55.18285
                ],
                [
                    84.486226,
                    55.182655
                ],
                [
                    84.4868523,
                    55.1825683
                ],
                [
                    84.4867005,
                    55.1819397
                ],
                [
                    84.4900222,
                    55.1813219
                ],
                [
                    84.4906676,
                    55.1808342
                ],
                [
                    84.492205,
                    55.1804549
                ],
                [
                    84.4913319,
                    55.1792302
                ],
                [
                    84.4894338,
                    55.1797179
                ],
                [
                    84.4898134,
                    55.1804007
                ],
                [
                    84.4896616,
                    55.1806175
                ],
                [
                    84.4859412,
                    55.1813219
                ],
                [
                    84.4845177,
                    55.1818638
                ],
                [
                    84.4846316,
                    55.1820589
                ],
                [
                    84.4837584,
                    55.1821998
                ],
                [
                    84.4833029,
                    55.1820047
                ],
                [
                    84.4830941,
                    55.1823082
                ]
            ],
            "longitude": 84.488197,
            "latitude": 55.181267
        },
        "10276": {
            "name": "Красный Выселок",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    84.5019853,
                    55.4255184
                ],
                [
                    84.5078524,
                    55.4302533
                ],
                [
                    84.5101014,
                    55.4294765
                ],
                [
                    84.5110141,
                    55.4299204
                ],
                [
                    84.5127742,
                    55.4289771
                ],
                [
                    84.5138498,
                    55.4274605
                ],
                [
                    84.5153166,
                    55.4267391
                ],
                [
                    84.5148277,
                    55.4255369
                ],
                [
                    84.5137194,
                    55.4242791
                ],
                [
                    84.5115682,
                    55.425019
                ],
                [
                    84.5084065,
                    55.4255924
                ],
                [
                    84.5080289,
                    55.425739
                ],
                [
                    84.5069071,
                    55.4261473
                ],
                [
                    84.5060597,
                    55.4258328
                ],
                [
                    84.5050166,
                    55.4262397
                ],
                [
                    84.5033217,
                    55.4252409
                ],
                [
                    84.5025394,
                    55.4251854
                ],
                [
                    84.5019853,
                    55.4255184
                ]
            ],
            "longitude": 84.510277,
            "latitude": 55.427464
        },
        "10277": {
            "name": "Воробьева Заимка",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    84.508591,
                    54.2313864
                ],
                [
                    84.510903,
                    54.2326027
                ],
                [
                    84.5130764,
                    54.2314945
                ],
                [
                    84.5115042,
                    54.2293052
                ],
                [
                    84.5098395,
                    54.2302782
                ],
                [
                    84.508591,
                    54.2313864
                ]
            ],
            "longitude": 84.511086,
            "latitude": 54.230888
        },
        "10278": {
            "name": "Инской",
            "population": 105,
            "type": "hamlet",
            "poly": [
                [
                    84.5025336,
                    55.2264424
                ],
                [
                    84.5025529,
                    55.2268296
                ],
                [
                    84.5032446,
                    55.2278671
                ],
                [
                    84.5034176,
                    55.2279073
                ],
                [
                    84.5041862,
                    55.2275201
                ],
                [
                    84.5052367,
                    55.2272205
                ],
                [
                    84.506633,
                    55.2270233
                ],
                [
                    84.5065306,
                    55.2268296
                ],
                [
                    84.5073889,
                    55.2265885
                ],
                [
                    84.5088557,
                    55.2285977
                ],
                [
                    84.5090799,
                    55.2293539
                ],
                [
                    84.5092208,
                    55.229416
                ],
                [
                    84.5096179,
                    55.2293868
                ],
                [
                    84.509714,
                    55.229416
                ],
                [
                    84.5097781,
                    55.2297082
                ],
                [
                    84.5098677,
                    55.2297776
                ],
                [
                    84.5100023,
                    55.2297448
                ],
                [
                    84.5101752,
                    55.2298361
                ],
                [
                    84.5114563,
                    55.2297009
                ],
                [
                    84.5114949,
                    55.2298622
                ],
                [
                    84.5119431,
                    55.2301648
                ],
                [
                    84.5120904,
                    55.2305009
                ],
                [
                    84.512321,
                    55.2304607
                ],
                [
                    84.5132626,
                    55.2314762
                ],
                [
                    84.5145052,
                    55.2323747
                ],
                [
                    84.5148895,
                    55.2322688
                ],
                [
                    84.5154084,
                    55.2326925
                ],
                [
                    84.5155749,
                    55.2327363
                ],
                [
                    84.5157735,
                    55.232729
                ],
                [
                    84.51692,
                    55.2324076
                ],
                [
                    84.5170545,
                    55.2325172
                ],
                [
                    84.5172019,
                    55.2324259
                ],
                [
                    84.5174645,
                    55.2323784
                ],
                [
                    84.5186238,
                    55.2319912
                ],
                [
                    84.5183228,
                    55.2313301
                ],
                [
                    84.5182139,
                    55.2312095
                ],
                [
                    84.5178104,
                    55.231089
                ],
                [
                    84.5175285,
                    55.231078
                ],
                [
                    84.5174517,
                    55.2309794
                ],
                [
                    84.5174324,
                    55.23091
                ],
                [
                    84.517189,
                    55.2307968
                ],
                [
                    84.5169264,
                    55.230384
                ],
                [
                    84.5163756,
                    55.2298909
                ],
                [
                    84.5161001,
                    55.2297521
                ],
                [
                    84.5160745,
                    55.2296169
                ],
                [
                    84.516145,
                    55.2293466
                ],
                [
                    84.5165293,
                    55.2292626
                ],
                [
                    84.5166486,
                    55.2290359
                ],
                [
                    84.5165869,
                    55.2289228
                ],
                [
                    84.5167279,
                    55.2285064
                ],
                [
                    84.5165998,
                    55.2282507
                ],
                [
                    84.5162795,
                    55.2278781
                ],
                [
                    84.5157414,
                    55.2273886
                ],
                [
                    84.5157414,
                    55.2271803
                ],
                [
                    84.5158311,
                    55.2269539
                ],
                [
                    84.5157991,
                    55.2267018
                ],
                [
                    84.515671,
                    55.2265666
                ],
                [
                    84.5156838,
                    55.2262451
                ],
                [
                    84.5155365,
                    55.2261538
                ],
                [
                    84.5150497,
                    55.2260734
                ],
                [
                    84.5149984,
                    55.226004
                ],
                [
                    84.5149792,
                    55.2258798
                ],
                [
                    84.5150817,
                    55.2257702
                ],
                [
                    84.5151009,
                    55.225646
                ],
                [
                    84.5152803,
                    55.2255108
                ],
                [
                    84.5155557,
                    55.2254049
                ],
                [
                    84.5155621,
                    55.2252003
                ],
                [
                    84.5150625,
                    55.2249446
                ],
                [
                    84.5147102,
                    55.2244404
                ],
                [
                    84.5147486,
                    55.2243381
                ],
                [
                    84.515229,
                    55.2242285
                ],
                [
                    84.5153891,
                    55.2241043
                ],
                [
                    84.5153571,
                    55.2239509
                ],
                [
                    84.5150689,
                    55.2237499
                ],
                [
                    84.5149344,
                    55.2236221
                ],
                [
                    84.514928,
                    55.2233334
                ],
                [
                    84.5147422,
                    55.2231142
                ],
                [
                    84.5149023,
                    55.2229389
                ],
                [
                    84.5149087,
                    55.2219889
                ],
                [
                    84.5125836,
                    55.221503
                ],
                [
                    84.5124811,
                    55.2216126
                ],
                [
                    84.5121737,
                    55.2215432
                ],
                [
                    84.5118918,
                    55.2215615
                ],
                [
                    84.5114242,
                    55.2219378
                ],
                [
                    84.5112513,
                    55.2219487
                ],
                [
                    84.5110719,
                    55.2217259
                ],
                [
                    84.5106684,
                    55.2215615
                ],
                [
                    84.5094002,
                    55.2218757
                ],
                [
                    84.5094386,
                    55.2221497
                ],
                [
                    84.5074145,
                    55.2226137
                ],
                [
                    84.5066971,
                    55.2234503
                ],
                [
                    84.5031998,
                    55.2244587
                ],
                [
                    84.503424,
                    55.224824
                ],
                [
                    84.5033279,
                    55.2250286
                ],
                [
                    84.5033727,
                    55.2253391
                ],
                [
                    84.503014,
                    55.2256862
                ],
                [
                    84.5033279,
                    55.2260369
                ],
                [
                    84.5025336,
                    55.2264424
                ]
            ],
            "longitude": 84.511894,
            "latitude": 55.227158
        },
        "10279": {
            "name": "Пятилетка",
            "population": 262,
            "type": "hamlet",
            "poly": [
                [
                    84.5127867,
                    54.9710651
                ],
                [
                    84.5138746,
                    54.9718808
                ],
                [
                    84.5142754,
                    54.9717702
                ],
                [
                    84.5145929,
                    54.9719943
                ],
                [
                    84.5149833,
                    54.9719047
                ],
                [
                    84.5153789,
                    54.9722453
                ],
                [
                    84.5157589,
                    54.9723857
                ],
                [
                    84.5159671,
                    54.9724036
                ],
                [
                    84.516295,
                    54.9723199
                ],
                [
                    84.516597,
                    54.9722841
                ],
                [
                    84.5172112,
                    54.9720481
                ],
                [
                    84.5174557,
                    54.9722184
                ],
                [
                    84.5175808,
                    54.9724574
                ],
                [
                    84.5181169,
                    54.97278
                ],
                [
                    84.5181169,
                    54.9729952
                ],
                [
                    84.5177838,
                    54.9731834
                ],
                [
                    84.5176589,
                    54.9738556
                ],
                [
                    84.5170134,
                    54.9734762
                ],
                [
                    84.5156547,
                    54.9734493
                ],
                [
                    84.5153061,
                    54.973267
                ],
                [
                    84.514265,
                    54.9733806
                ],
                [
                    84.5149313,
                    54.9740438
                ],
                [
                    84.5137393,
                    54.9746234
                ],
                [
                    84.5164564,
                    54.976371
                ],
                [
                    84.5179503,
                    54.9757646
                ],
                [
                    84.5179139,
                    54.9746473
                ],
                [
                    84.5177682,
                    54.9739123
                ],
                [
                    84.5179035,
                    54.97327
                ],
                [
                    84.5183147,
                    54.973515
                ],
                [
                    84.5189654,
                    54.9732252
                ],
                [
                    84.5189654,
                    54.97278
                ],
                [
                    84.5185073,
                    54.9724813
                ],
                [
                    84.5194651,
                    54.9719435
                ],
                [
                    84.5196577,
                    54.9719106
                ],
                [
                    84.5196577,
                    54.9718031
                ],
                [
                    84.5195327,
                    54.9716059
                ],
                [
                    84.5197097,
                    54.971579
                ],
                [
                    84.5198347,
                    54.9716626
                ],
                [
                    84.5200116,
                    54.9715999
                ],
                [
                    84.5201574,
                    54.9715073
                ],
                [
                    84.5206415,
                    54.9714117
                ],
                [
                    84.5208757,
                    54.9714356
                ],
                [
                    84.5210683,
                    54.9712832
                ],
                [
                    84.5216513,
                    54.9713758
                ],
                [
                    84.5220469,
                    54.9714057
                ],
                [
                    84.5223175,
                    54.9712115
                ],
                [
                    84.5217658,
                    54.9705721
                ],
                [
                    84.5218572,
                    54.9704389
                ],
                [
                    84.5238904,
                    54.971059
                ],
                [
                    84.5240493,
                    54.9709587
                ],
                [
                    84.5270357,
                    54.9721349
                ],
                [
                    84.5284178,
                    54.9733202
                ],
                [
                    84.5296568,
                    54.9725087
                ],
                [
                    84.5294027,
                    54.9723628
                ],
                [
                    84.5301493,
                    54.9718431
                ],
                [
                    84.528116,
                    54.9710954
                ],
                [
                    84.5281319,
                    54.9709951
                ],
                [
                    84.5286243,
                    54.9705757
                ],
                [
                    84.5291962,
                    54.9707581
                ],
                [
                    84.5299587,
                    54.9700742
                ],
                [
                    84.528672,
                    54.969363
                ],
                [
                    84.527703,
                    54.9691077
                ],
                [
                    84.5275599,
                    54.9692353
                ],
                [
                    84.5265751,
                    54.9689618
                ],
                [
                    84.525622,
                    54.9685241
                ],
                [
                    84.5251295,
                    54.9683873
                ],
                [
                    84.5249866,
                    54.9685059
                ],
                [
                    84.5233345,
                    54.9682505
                ],
                [
                    84.5230803,
                    54.96836
                ],
                [
                    84.5218413,
                    54.9679223
                ],
                [
                    84.5213647,
                    54.9683052
                ],
                [
                    84.5208087,
                    54.9680682
                ],
                [
                    84.521047,
                    54.9677946
                ],
                [
                    84.5203004,
                    54.9673751
                ],
                [
                    84.5206817,
                    54.9670925
                ],
                [
                    84.5209358,
                    54.9671016
                ],
                [
                    84.5230803,
                    54.9653872
                ],
                [
                    84.5211741,
                    54.9645664
                ],
                [
                    84.5178064,
                    54.9670195
                ],
                [
                    84.5184735,
                    54.9671472
                ],
                [
                    84.5188706,
                    54.9673751
                ],
                [
                    84.5197762,
                    54.9667824
                ],
                [
                    84.5204593,
                    54.9670469
                ],
                [
                    84.5189819,
                    54.968132
                ],
                [
                    84.5192361,
                    54.9682688
                ],
                [
                    84.5188072,
                    54.9685697
                ],
                [
                    84.5184735,
                    54.9684238
                ],
                [
                    84.5179653,
                    54.968825
                ],
                [
                    84.5192996,
                    54.969363
                ],
                [
                    84.5188231,
                    54.9696913
                ],
                [
                    84.5164561,
                    54.9687065
                ],
                [
                    84.5158843,
                    54.9691168
                ],
                [
                    84.5157413,
                    54.9690712
                ],
                [
                    84.5156143,
                    54.9691897
                ],
                [
                    84.5151853,
                    54.969053
                ],
                [
                    84.5146294,
                    54.9694907
                ],
                [
                    84.5150424,
                    54.9696913
                ],
                [
                    84.5146294,
                    54.9700104
                ],
                [
                    84.5148947,
                    54.9701389
                ],
                [
                    84.5148397,
                    54.9701815
                ],
                [
                    84.514036,
                    54.9706259
                ],
                [
                    84.5127867,
                    54.9710651
                ]
            ],
            "longitude": 84.519966,
            "latitude": 54.97036
        },
        "10280": {
            "name": "Таскаево",
            "population": 84,
            "type": "hamlet",
            "poly": [
                [
                    84.5105198,
                    55.655747
                ],
                [
                    84.5132198,
                    55.6564671
                ],
                [
                    84.5137107,
                    55.6559963
                ],
                [
                    84.5172944,
                    55.6567441
                ],
                [
                    84.5251489,
                    55.6521742
                ],
                [
                    84.5266216,
                    55.6531159
                ],
                [
                    84.5271616,
                    55.6530328
                ],
                [
                    84.5271616,
                    55.652645
                ],
                [
                    84.5301071,
                    55.6518418
                ],
                [
                    84.5292726,
                    55.6507893
                ],
                [
                    84.5319726,
                    55.6486564
                ],
                [
                    84.5304507,
                    55.64777
                ],
                [
                    84.5285362,
                    55.6485179
                ],
                [
                    84.526818,
                    55.6471606
                ],
                [
                    84.5278489,
                    55.6463849
                ],
                [
                    84.525738,
                    55.6453876
                ],
                [
                    84.5224489,
                    55.6473268
                ],
                [
                    84.5220562,
                    55.6483794
                ],
                [
                    84.5213198,
                    55.6488226
                ],
                [
                    84.5225962,
                    55.6500968
                ],
                [
                    84.5234798,
                    55.6499029
                ],
                [
                    84.5237743,
                    55.6502907
                ],
                [
                    84.5234307,
                    55.6507616
                ],
                [
                    84.5253944,
                    55.6517864
                ],
                [
                    84.5176105,
                    55.6550781
                ],
                [
                    84.5163287,
                    55.6548938
                ],
                [
                    84.5169068,
                    55.6540004
                ],
                [
                    84.5125585,
                    55.6531638
                ],
                [
                    84.5105198,
                    55.655747
                ]
            ],
            "longitude": 84.525192,
            "latitude": 55.648197
        },
        "10281": {
            "name": "Новоабышево",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.525223,
            "latitude": 54.890839
        },
        "10282": {
            "name": "Остановочная Платформа Тын",
            "population": 14,
            "type": "hamlet",
            "poly": [
                [
                    84.5230224,
                    55.6924245
                ],
                [
                    84.5243184,
                    55.6927787
                ],
                [
                    84.5238078,
                    55.6937305
                ],
                [
                    84.5274601,
                    55.6943945
                ],
                [
                    84.5291096,
                    55.6933764
                ],
                [
                    84.5294631,
                    55.6928008
                ],
                [
                    84.5234936,
                    55.6916498
                ],
                [
                    84.5230224,
                    55.6924245
                ]
            ],
            "longitude": 84.527168,
            "latitude": 55.692932
        },
        "10283": {
            "name": "Гаревка",
            "population": 150,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.538177,
            "latitude": 55.118771
        },
        "10284": {
            "name": "Дресвянка",
            "population": 258,
            "type": "hamlet",
            "poly": [
                [
                    84.5335099,
                    54.2068939
                ],
                [
                    84.5388013,
                    54.2081635
                ],
                [
                    84.5384847,
                    54.2093802
                ],
                [
                    84.5396606,
                    54.2095653
                ],
                [
                    84.544545,
                    54.2098034
                ],
                [
                    84.5450424,
                    54.2086396
                ],
                [
                    84.5423289,
                    54.2054655
                ],
                [
                    84.5416958,
                    54.2041429
                ],
                [
                    84.5439119,
                    54.2019208
                ],
                [
                    84.5486606,
                    54.1996457
                ],
                [
                    84.548751,
                    54.197344
                ],
                [
                    84.5430526,
                    54.1909409
                ],
                [
                    84.5409269,
                    54.1921581
                ],
                [
                    84.5432335,
                    54.1952009
                ],
                [
                    84.5398415,
                    54.1946982
                ],
                [
                    84.5350928,
                    54.1959153
                ],
                [
                    84.5352737,
                    54.1971059
                ],
                [
                    84.5351832,
                    54.2001484
                ],
                [
                    84.5371732,
                    54.2036668
                ],
                [
                    84.5359069,
                    54.2048571
                ],
                [
                    84.5343692,
                    54.2044074
                ],
                [
                    84.5335099,
                    54.2068939
                ]
            ],
            "longitude": 84.543533,
            "latitude": 54.198959
        },
        "10285": {
            "name": "Остановочная Платформа 141 к",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.563248,
            "latitude": 55.161388
        },
        "10286": {
            "name": "Изылы",
            "population": 177,
            "type": "hamlet",
            "poly": [
                [
                    84.5637464,
                    55.1692065
                ],
                [
                    84.5652293,
                    55.170731
                ],
                [
                    84.5667419,
                    55.1702059
                ],
                [
                    84.5687883,
                    55.1718489
                ],
                [
                    84.5707161,
                    55.171002
                ],
                [
                    84.5712202,
                    55.1712392
                ],
                [
                    84.5735039,
                    55.1710359
                ],
                [
                    84.5745123,
                    55.1717134
                ],
                [
                    84.5735039,
                    55.1724926
                ],
                [
                    84.5736819,
                    55.1727128
                ],
                [
                    84.5722879,
                    55.1739153
                ],
                [
                    84.5702711,
                    55.1731023
                ],
                [
                    84.5686993,
                    55.1738984
                ],
                [
                    84.5670385,
                    55.1754736
                ],
                [
                    84.5678392,
                    55.1758462
                ],
                [
                    84.5684324,
                    55.1755921
                ],
                [
                    84.5704491,
                    55.1758631
                ],
                [
                    84.5700042,
                    55.1762357
                ],
                [
                    84.5727625,
                    55.1782172
                ],
                [
                    84.573326,
                    55.1780648
                ],
                [
                    84.5746309,
                    55.1762188
                ],
                [
                    84.5760545,
                    55.1741017
                ],
                [
                    84.5777449,
                    55.1732209
                ],
                [
                    84.5792279,
                    55.1723571
                ],
                [
                    84.5827869,
                    55.1714932
                ],
                [
                    84.5828166,
                    55.1697316
                ],
                [
                    84.5811557,
                    55.1683934
                ],
                [
                    84.5810371,
                    55.1678174
                ],
                [
                    84.5805329,
                    55.1678683
                ],
                [
                    84.5801472,
                    55.1672415
                ],
                [
                    84.5802066,
                    55.1656999
                ],
                [
                    84.5777449,
                    55.165395
                ],
                [
                    84.5773595,
                    55.1661912
                ],
                [
                    84.5761435,
                    55.165954
                ],
                [
                    84.574364,
                    55.1676819
                ],
                [
                    84.5737412,
                    55.1674786
                ],
                [
                    84.573415,
                    55.166801
                ],
                [
                    84.569945,
                    55.1668349
                ],
                [
                    84.5689069,
                    55.1665639
                ],
                [
                    84.5682544,
                    55.1667841
                ],
                [
                    84.5676316,
                    55.1671229
                ],
                [
                    84.5653776,
                    55.1671229
                ],
                [
                    84.5645472,
                    55.1673939
                ],
                [
                    84.5654963,
                    55.1686475
                ],
                [
                    84.5637464,
                    55.1692065
                ]
            ],
            "longitude": 84.573685,
            "latitude": 55.169727
        },
        "10287": {
            "name": "Новолушниково",
            "population": 21,
            "type": "hamlet",
            "poly": [
                [
                    84.5871285,
                    54.5169911
                ],
                [
                    84.5904461,
                    54.5184216
                ],
                [
                    84.5930369,
                    54.5201271
                ],
                [
                    84.5991033,
                    54.5210441
                ],
                [
                    84.6012518,
                    54.5209524
                ],
                [
                    84.6016941,
                    54.5203839
                ],
                [
                    84.5992928,
                    54.5193569
                ],
                [
                    84.5961965,
                    54.5182749
                ],
                [
                    84.5954382,
                    54.5156339
                ],
                [
                    84.5948063,
                    54.5142217
                ],
                [
                    84.5926894,
                    54.5132129
                ],
                [
                    84.5875709,
                    54.515799
                ],
                [
                    84.5871285,
                    54.5169911
                ]
            ],
            "longitude": 84.593781,
            "latitude": 54.518761
        },
        "10288": {
            "name": "Загора",
            "population": 179,
            "type": "hamlet",
            "poly": [
                [
                    84.5972324,
                    54.3042234
                ],
                [
                    84.6007467,
                    54.3061121
                ],
                [
                    84.6044922,
                    54.306247
                ],
                [
                    84.6078216,
                    54.3058962
                ],
                [
                    84.6129081,
                    54.3069484
                ],
                [
                    84.6170698,
                    54.3058962
                ],
                [
                    84.6173472,
                    54.3047091
                ],
                [
                    84.6162837,
                    54.3043853
                ],
                [
                    84.6131855,
                    54.3046821
                ],
                [
                    84.6103186,
                    54.3035759
                ],
                [
                    84.6074054,
                    54.3030902
                ],
                [
                    84.6086538,
                    54.3016062
                ],
                [
                    84.6079603,
                    54.2999333
                ],
                [
                    84.6056482,
                    54.2990158
                ],
                [
                    84.601949,
                    54.3002841
                ],
                [
                    84.6016715,
                    54.301984
                ],
                [
                    84.6005155,
                    54.3040076
                ],
                [
                    84.5986658,
                    54.3032521
                ],
                [
                    84.5972324,
                    54.3042234
                ]
            ],
            "longitude": 84.604095,
            "latitude": 54.302391
        },
        "10289": {
            "name": "Гранит",
            "population": 179,
            "type": "hamlet",
            "poly": [
                [
                    84.5957789,
                    55.1465512
                ],
                [
                    84.5961348,
                    55.1477037
                ],
                [
                    84.5971091,
                    55.1480401
                ],
                [
                    84.5979617,
                    55.1484901
                ],
                [
                    84.5984362,
                    55.1483409
                ],
                [
                    84.5989345,
                    55.1483138
                ],
                [
                    84.6008801,
                    55.1488833
                ],
                [
                    84.6014495,
                    55.1483409
                ],
                [
                    84.5992191,
                    55.1473918
                ],
                [
                    84.6000971,
                    55.1470393
                ],
                [
                    84.6007377,
                    55.147324
                ],
                [
                    84.6010936,
                    55.1469986
                ],
                [
                    84.600975,
                    55.1466732
                ],
                [
                    84.6030509,
                    55.146048
                ],
                [
                    84.6092318,
                    55.1468901
                ],
                [
                    84.6096033,
                    55.1466532
                ],
                [
                    84.6101334,
                    55.1460766
                ],
                [
                    84.6128382,
                    55.1467952
                ],
                [
                    84.6141194,
                    55.1469037
                ],
                [
                    84.6144516,
                    55.1461851
                ],
                [
                    84.6126246,
                    55.1456969
                ],
                [
                    84.6132653,
                    55.1446935
                ],
                [
                    84.6101808,
                    55.1432968
                ],
                [
                    84.6103944,
                    55.1430934
                ],
                [
                    84.6091606,
                    55.1425239
                ],
                [
                    84.6093267,
                    55.142334
                ],
                [
                    84.6089945,
                    55.1419679
                ],
                [
                    84.6080692,
                    55.1421577
                ],
                [
                    84.6070489,
                    55.1419408
                ],
                [
                    84.6061948,
                    55.1423883
                ],
                [
                    84.6047475,
                    55.1420086
                ],
                [
                    84.6056964,
                    55.1417238
                ],
                [
                    84.605483,
                    55.1413983
                ],
                [
                    84.6072387,
                    55.140883
                ],
                [
                    84.606954,
                    55.1406796
                ],
                [
                    84.606266,
                    55.1408288
                ],
                [
                    84.6060524,
                    55.1406932
                ],
                [
                    84.6050796,
                    55.140883
                ],
                [
                    84.6048898,
                    55.140666
                ],
                [
                    84.6037272,
                    55.1411271
                ],
                [
                    84.6031815,
                    55.1405304
                ],
                [
                    84.6023273,
                    55.1403677
                ],
                [
                    84.6018766,
                    55.1405576
                ],
                [
                    84.5981989,
                    55.140544
                ],
                [
                    84.5974397,
                    55.1409508
                ],
                [
                    84.5995039,
                    55.1420086
                ],
                [
                    84.5989819,
                    55.1423476
                ],
                [
                    84.5995514,
                    55.1429443
                ],
                [
                    84.6005953,
                    55.1425239
                ],
                [
                    84.6007614,
                    55.1427815
                ],
                [
                    84.6015207,
                    55.1426324
                ],
                [
                    84.6020189,
                    55.1429849
                ],
                [
                    84.604178,
                    55.1422255
                ],
                [
                    84.6055542,
                    55.1427273
                ],
                [
                    84.6048898,
                    55.1429578
                ],
                [
                    84.6050085,
                    55.1434324
                ],
                [
                    84.6010461,
                    55.1450461
                ],
                [
                    84.6010224,
                    55.1453579
                ],
                [
                    84.5992191,
                    55.1458868
                ],
                [
                    84.5983888,
                    55.1456834
                ],
                [
                    84.5957789,
                    55.1465512
                ]
            ],
            "longitude": 84.607079,
            "latitude": 55.144867
        },
        "10290": {
            "name": "Старогутово",
            "population": 101,
            "type": "hamlet",
            "poly": [
                [
                    84.5929357,
                    54.7382459
                ],
                [
                    84.5966257,
                    54.7416542
                ],
                [
                    84.6041784,
                    54.7442492
                ],
                [
                    84.6093281,
                    54.7434564
                ],
                [
                    84.6120217,
                    54.7437993
                ],
                [
                    84.6129331,
                    54.7460327
                ],
                [
                    84.6177395,
                    54.7477171
                ],
                [
                    84.6191129,
                    54.748906
                ],
                [
                    84.6191129,
                    54.7518782
                ],
                [
                    84.6217176,
                    54.7519838
                ],
                [
                    84.6243086,
                    54.7509077
                ],
                [
                    84.6265145,
                    54.7494283
                ],
                [
                    84.6204261,
                    54.7457012
                ],
                [
                    84.6193264,
                    54.7432896
                ],
                [
                    84.6226676,
                    54.7411527
                ],
                [
                    84.6202416,
                    54.739524
                ],
                [
                    84.6167361,
                    54.7403761
                ],
                [
                    84.6154446,
                    54.7385654
                ],
                [
                    84.6113857,
                    54.739311
                ],
                [
                    84.6099097,
                    54.7403761
                ],
                [
                    84.6049282,
                    54.7383524
                ],
                [
                    84.6001312,
                    54.7368612
                ],
                [
                    84.5945962,
                    54.7370742
                ],
                [
                    84.5929357,
                    54.7382459
                ]
            ],
            "longitude": 84.61235,
            "latitude": 54.742737
        },
        "10291": {
            "name": "Верх-Ачино",
            "population": 37,
            "type": "hamlet",
            "poly": [
                [
                    84.610072,
                    55.4443841
                ],
                [
                    84.6105609,
                    55.4444996
                ],
                [
                    84.6134536,
                    55.4443148
                ],
                [
                    84.6149612,
                    55.4447539
                ],
                [
                    84.6200949,
                    55.4456782
                ],
                [
                    84.6231914,
                    55.4461635
                ],
                [
                    84.6258397,
                    55.4462097
                ],
                [
                    84.6261655,
                    55.4475038
                ],
                [
                    84.6246581,
                    55.4501843
                ],
                [
                    84.6251878,
                    55.4506233
                ],
                [
                    84.6264916,
                    55.450785
                ],
                [
                    84.6253915,
                    55.4519403
                ],
                [
                    84.6302807,
                    55.4526104
                ],
                [
                    84.631829,
                    55.4503691
                ],
                [
                    84.6297103,
                    55.4491907
                ],
                [
                    84.6301177,
                    55.4485668
                ],
                [
                    84.6310141,
                    55.4484974
                ],
                [
                    84.6313401,
                    55.4479198
                ],
                [
                    84.6306474,
                    55.44755
                ],
                [
                    84.6313808,
                    55.4466257
                ],
                [
                    84.6319919,
                    55.4466488
                ],
                [
                    84.6321142,
                    55.4462791
                ],
                [
                    84.6295881,
                    55.44584
                ],
                [
                    84.6298325,
                    55.4447076
                ],
                [
                    84.6265322,
                    55.4441068
                ],
                [
                    84.6263692,
                    55.4434597
                ],
                [
                    84.6248211,
                    55.4434597
                ],
                [
                    84.6239247,
                    55.4438526
                ],
                [
                    84.6197689,
                    55.4427895
                ],
                [
                    84.6193615,
                    55.442489
                ],
                [
                    84.6187096,
                    55.442489
                ],
                [
                    84.6182207,
                    55.4430668
                ],
                [
                    84.6176909,
                    55.4429281
                ],
                [
                    84.6178946,
                    55.4425815
                ],
                [
                    84.6141463,
                    55.4420037
                ],
                [
                    84.6132906,
                    55.4427895
                ],
                [
                    84.6123129,
                    55.4431593
                ],
                [
                    84.6112128,
                    55.4429513
                ],
                [
                    84.610072,
                    55.4443841
                ]
            ],
            "longitude": 84.620308,
            "latitude": 55.444454
        },
        "10292": {
            "name": "Доронино",
            "population": 235,
            "type": "hamlet",
            "poly": [
                [
                    84.6013361,
                    54.9897109
                ],
                [
                    84.6020217,
                    54.9903027
                ],
                [
                    84.6030216,
                    54.9899402
                ],
                [
                    84.6038644,
                    54.9896964
                ],
                [
                    84.6050243,
                    54.9897205
                ],
                [
                    84.6050072,
                    54.9895243
                ],
                [
                    84.6047849,
                    54.9894949
                ],
                [
                    84.6047507,
                    54.9888867
                ],
                [
                    84.6040355,
                    54.9881988
                ],
                [
                    84.6048171,
                    54.9881317
                ],
                [
                    84.6057462,
                    54.9867898
                ],
                [
                    84.6061212,
                    54.9867461
                ],
                [
                    84.6069682,
                    54.9858141
                ],
                [
                    84.6073899,
                    54.985308
                ],
                [
                    84.6070465,
                    54.9850048
                ],
                [
                    84.6073051,
                    54.9846509
                ],
                [
                    84.606803,
                    54.9844043
                ],
                [
                    84.6065251,
                    54.9841027
                ],
                [
                    84.6067719,
                    54.9837382
                ],
                [
                    84.608615,
                    54.9836379
                ],
                [
                    84.6090689,
                    54.9837785
                ],
                [
                    84.6093844,
                    54.9838734
                ],
                [
                    84.6114116,
                    54.9836763
                ],
                [
                    84.6130064,
                    54.9844496
                ],
                [
                    84.6142005,
                    54.9839968
                ],
                [
                    84.6151366,
                    54.9842436
                ],
                [
                    84.6162594,
                    54.9834572
                ],
                [
                    84.6179422,
                    54.9830311
                ],
                [
                    84.6181031,
                    54.982772
                ],
                [
                    84.6192688,
                    54.9822148
                ],
                [
                    84.6194876,
                    54.9823493
                ],
                [
                    84.6212263,
                    54.9813806
                ],
                [
                    84.6213193,
                    54.9816167
                ],
                [
                    84.6220887,
                    54.9820681
                ],
                [
                    84.6218665,
                    54.9829511
                ],
                [
                    84.6224991,
                    54.9825979
                ],
                [
                    84.6243971,
                    54.9834123
                ],
                [
                    84.62438,
                    54.9841089
                ],
                [
                    84.62768,
                    54.9813224
                ],
                [
                    84.6275261,
                    54.9806552
                ],
                [
                    84.6266199,
                    54.9806257
                ],
                [
                    84.6272881,
                    54.9802071
                ],
                [
                    84.6283942,
                    54.9794667
                ],
                [
                    84.6266028,
                    54.9790165
                ],
                [
                    84.6260214,
                    54.976475
                ],
                [
                    84.6251323,
                    54.9760039
                ],
                [
                    84.625252,
                    54.9757095
                ],
                [
                    84.6258392,
                    54.9754072
                ],
                [
                    84.626102,
                    54.9752438
                ],
                [
                    84.6294762,
                    54.9734155
                ],
                [
                    84.6293368,
                    54.9727686
                ],
                [
                    84.6291082,
                    54.9722375
                ],
                [
                    84.6279688,
                    54.9719108
                ],
                [
                    84.6271921,
                    54.9724838
                ],
                [
                    84.6264191,
                    54.9720491
                ],
                [
                    84.6242894,
                    54.9728696
                ],
                [
                    84.6236276,
                    54.9722158
                ],
                [
                    84.6248587,
                    54.9717251
                ],
                [
                    84.6254914,
                    54.9711657
                ],
                [
                    84.6268422,
                    54.9703118
                ],
                [
                    84.6251665,
                    54.9693304
                ],
                [
                    84.6248587,
                    54.9693206
                ],
                [
                    84.6248758,
                    54.9691831
                ],
                [
                    84.6265515,
                    54.9685844
                ],
                [
                    84.6259701,
                    54.9674164
                ],
                [
                    84.6260556,
                    54.9668962
                ],
                [
                    84.6248074,
                    54.9669551
                ],
                [
                    84.6247903,
                    54.9662091
                ],
                [
                    84.6252178,
                    54.9657772
                ],
                [
                    84.6253717,
                    54.9653551
                ],
                [
                    84.6265686,
                    54.9647564
                ],
                [
                    84.6263292,
                    54.9645895
                ],
                [
                    84.626637,
                    54.9644717
                ],
                [
                    84.6244313,
                    54.9630876
                ],
                [
                    84.6232515,
                    54.963706
                ],
                [
                    84.6237986,
                    54.9640692
                ],
                [
                    84.6235079,
                    54.9644619
                ],
                [
                    84.6230121,
                    54.9658656
                ],
                [
                    84.6221058,
                    54.9663453
                ],
                [
                    84.6214914,
                    54.9654251
                ],
                [
                    84.6201288,
                    54.9656551
                ],
                [
                    84.6206631,
                    54.9668668
                ],
                [
                    84.6201021,
                    54.9673575
                ],
                [
                    84.6199151,
                    54.9679556
                ],
                [
                    84.6206097,
                    54.9687071
                ],
                [
                    84.6205563,
                    54.9702714
                ],
                [
                    84.6210105,
                    54.9704861
                ],
                [
                    84.6210906,
                    54.9709461
                ],
                [
                    84.6206364,
                    54.9713602
                ],
                [
                    84.6208234,
                    54.9716515
                ],
                [
                    84.6218654,
                    54.9716822
                ],
                [
                    84.6225066,
                    54.9722036
                ],
                [
                    84.622237,
                    54.9728733
                ],
                [
                    84.6222836,
                    54.9729934
                ],
                [
                    84.6227106,
                    54.9731861
                ],
                [
                    84.6231532,
                    54.9737942
                ],
                [
                    84.622076,
                    54.9739599
                ],
                [
                    84.6209961,
                    54.9739574
                ],
                [
                    84.6196486,
                    54.973942
                ],
                [
                    84.6192436,
                    54.9747382
                ],
                [
                    84.6188611,
                    54.9749818
                ],
                [
                    84.618139,
                    54.9753563
                ],
                [
                    84.6179352,
                    54.9757696
                ],
                [
                    84.6180313,
                    54.976067
                ],
                [
                    84.6183907,
                    54.9763694
                ],
                [
                    84.6187834,
                    54.9765236
                ],
                [
                    84.6190532,
                    54.9766609
                ],
                [
                    84.6186519,
                    54.9769853
                ],
                [
                    84.6182989,
                    54.9769719
                ],
                [
                    84.6179207,
                    54.9771726
                ],
                [
                    84.617115,
                    54.9775759
                ],
                [
                    84.6160373,
                    54.9781818
                ],
                [
                    84.6151967,
                    54.9791099
                ],
                [
                    84.6146119,
                    54.9791004
                ],
                [
                    84.6139275,
                    54.9791253
                ],
                [
                    84.6129592,
                    54.9796872
                ],
                [
                    84.6121433,
                    54.9796456
                ],
                [
                    84.6114191,
                    54.979669
                ],
                [
                    84.6105876,
                    54.9798937
                ],
                [
                    84.6090131,
                    54.9813246
                ],
                [
                    84.6082396,
                    54.9819744
                ],
                [
                    84.6078587,
                    54.9828726
                ],
                [
                    84.6077217,
                    54.9834142
                ],
                [
                    84.607524,
                    54.983157
                ],
                [
                    84.6070754,
                    54.9831977
                ],
                [
                    84.6051018,
                    54.9830441
                ],
                [
                    84.6027244,
                    54.9824888
                ],
                [
                    84.6019616,
                    54.9837641
                ],
                [
                    84.6023323,
                    54.9850963
                ],
                [
                    84.6038762,
                    54.9856678
                ],
                [
                    84.6033059,
                    54.9862773
                ],
                [
                    84.6021638,
                    54.9859997
                ],
                [
                    84.6013683,
                    54.9870603
                ],
                [
                    84.6018677,
                    54.9875035
                ],
                [
                    84.6016214,
                    54.9878298
                ],
                [
                    84.6020973,
                    54.9879926
                ],
                [
                    84.6017358,
                    54.9887467
                ],
                [
                    84.6013361,
                    54.9897109
                ]
            ],
            "longitude": 84.622658,
            "latitude": 54.97813
        },
        "10293": {
            "name": "Кусково",
            "population": 77,
            "type": "hamlet",
            "poly": [
                [
                    84.6181371,
                    55.2095009
                ],
                [
                    84.6196682,
                    55.2099085
                ],
                [
                    84.6210154,
                    55.2098852
                ],
                [
                    84.6209949,
                    55.2095242
                ],
                [
                    84.621832,
                    55.2094426
                ],
                [
                    84.6217912,
                    55.209035
                ],
                [
                    84.6215462,
                    55.2089418
                ],
                [
                    84.6216074,
                    55.2086739
                ],
                [
                    84.6245061,
                    55.207777
                ],
                [
                    84.6254452,
                    55.2085574
                ],
                [
                    84.62667,
                    55.2087321
                ],
                [
                    84.6257718,
                    55.2107471
                ],
                [
                    84.6276483,
                    55.2109811
                ],
                [
                    84.6288746,
                    55.2104443
                ],
                [
                    84.6297932,
                    55.2103861
                ],
                [
                    84.6299361,
                    55.2099435
                ],
                [
                    84.6323857,
                    55.2103861
                ],
                [
                    84.631855,
                    55.2111431
                ],
                [
                    84.6334268,
                    55.2116439
                ],
                [
                    84.6352232,
                    55.2119584
                ],
                [
                    84.6363051,
                    55.2103628
                ],
                [
                    84.6353661,
                    55.2101415
                ],
                [
                    84.6354886,
                    55.2099202
                ],
                [
                    84.6351007,
                    55.2096057
                ],
                [
                    84.632794,
                    55.2088137
                ],
                [
                    84.6324062,
                    55.2084409
                ],
                [
                    84.6284868,
                    55.2071364
                ],
                [
                    84.626772,
                    55.2067753
                ],
                [
                    84.6231997,
                    55.2069383
                ],
                [
                    84.6216687,
                    55.2073111
                ],
                [
                    84.6215258,
                    55.2078935
                ],
                [
                    84.61877,
                    55.2079983
                ],
                [
                    84.6188312,
                    55.2089301
                ],
                [
                    84.6182596,
                    55.2089301
                ],
                [
                    84.6181371,
                    55.2095009
                ]
            ],
            "longitude": 84.627724,
            "latitude": 55.209141
        },
        "10294": {
            "name": "Берёзовка",
            "population": 10,
            "type": "hamlet",
            "poly": [
                [
                    84.6249132,
                    55.5769087
                ],
                [
                    84.6262991,
                    55.5773864
                ],
                [
                    84.6258259,
                    55.5787812
                ],
                [
                    84.6260963,
                    55.5804244
                ],
                [
                    84.6265018,
                    55.5805199
                ],
                [
                    84.6259611,
                    55.5815516
                ],
                [
                    84.6251161,
                    55.5814752
                ],
                [
                    84.6250823,
                    55.5820866
                ],
                [
                    84.6257583,
                    55.5822394
                ],
                [
                    84.6265695,
                    55.5816663
                ],
                [
                    84.6272455,
                    55.5806154
                ],
                [
                    84.6319439,
                    55.5814943
                ],
                [
                    84.6312003,
                    55.5828317
                ],
                [
                    84.6339044,
                    55.5832902
                ],
                [
                    84.6349184,
                    55.5822203
                ],
                [
                    84.6354592,
                    55.5823541
                ],
                [
                    84.6349184,
                    55.5833093
                ],
                [
                    84.6378253,
                    55.5840544
                ],
                [
                    84.6387718,
                    55.5827935
                ],
                [
                    84.6397182,
                    55.5830227
                ],
                [
                    84.6391436,
                    55.5839589
                ],
                [
                    84.6410364,
                    55.5844556
                ],
                [
                    84.6416787,
                    55.5833857
                ],
                [
                    84.6430645,
                    55.5835959
                ],
                [
                    84.6425575,
                    55.5846275
                ],
                [
                    84.6452278,
                    55.5850669
                ],
                [
                    84.6458023,
                    55.5844365
                ],
                [
                    84.6453968,
                    55.5840353
                ],
                [
                    84.6446531,
                    55.5837869
                ],
                [
                    84.6452278,
                    55.5828126
                ],
                [
                    84.6437067,
                    55.5826979
                ],
                [
                    84.6430307,
                    55.5833666
                ],
                [
                    84.6411378,
                    55.582889
                ],
                [
                    84.6416449,
                    55.5819719
                ],
                [
                    84.6410025,
                    55.5818955
                ],
                [
                    84.6403604,
                    55.5826979
                ],
                [
                    84.6386703,
                    55.5822012
                ],
                [
                    84.639076,
                    55.5813033
                ],
                [
                    84.6377239,
                    55.5810549
                ],
                [
                    84.6368789,
                    55.5820675
                ],
                [
                    84.6350874,
                    55.581437
                ],
                [
                    84.635662,
                    55.5806345
                ],
                [
                    84.6337016,
                    55.5800232
                ],
                [
                    84.6332621,
                    55.5804435
                ],
                [
                    84.6308961,
                    55.5796792
                ],
                [
                    84.6299834,
                    55.5806919
                ],
                [
                    84.6266371,
                    55.5799467
                ],
                [
                    84.6277864,
                    55.5781507
                ],
                [
                    84.6315383,
                    55.5787239
                ],
                [
                    84.6327213,
                    55.577673
                ],
                [
                    84.6365071,
                    55.5774819
                ],
                [
                    84.6380619,
                    55.5769087
                ],
                [
                    84.6385351,
                    55.5759724
                ],
                [
                    84.6375887,
                    55.5758195
                ],
                [
                    84.6366423,
                    55.5761635
                ],
                [
                    84.6360677,
                    55.5771953
                ],
                [
                    84.6338706,
                    55.5773673
                ],
                [
                    84.6348508,
                    55.5765456
                ],
                [
                    84.6340734,
                    55.5763737
                ],
                [
                    84.6335326,
                    55.5770616
                ],
                [
                    84.6309637,
                    55.5771571
                ],
                [
                    84.6283272,
                    55.5768705
                ],
                [
                    84.6284624,
                    55.5752845
                ],
                [
                    84.6265695,
                    55.5750743
                ],
                [
                    84.6265018,
                    55.5757431
                ],
                [
                    84.6250823,
                    55.5757622
                ],
                [
                    84.6249132,
                    55.5769087
                ]
            ],
            "longitude": 84.633545,
            "latitude": 55.581833
        },
        "10295": {
            "name": "Голомыскино",
            "population": 98,
            "type": "hamlet",
            "poly": [
                [
                    84.6298468,
                    55.0326673
                ],
                [
                    84.6315834,
                    55.0330807
                ],
                [
                    84.6304346,
                    55.0338769
                ],
                [
                    84.6303544,
                    55.0342137
                ],
                [
                    84.6307018,
                    55.0343822
                ],
                [
                    84.6325185,
                    55.0334788
                ],
                [
                    84.6333734,
                    55.033831
                ],
                [
                    84.6326254,
                    55.0345353
                ],
                [
                    84.6340146,
                    55.0350405
                ],
                [
                    84.634923,
                    55.0343056
                ],
                [
                    84.6351635,
                    55.0344281
                ],
                [
                    84.6347894,
                    55.0353008
                ],
                [
                    84.6353238,
                    55.0357601
                ],
                [
                    84.6333734,
                    55.0371227
                ],
                [
                    84.6352169,
                    55.0379341
                ],
                [
                    84.6360451,
                    55.0389905
                ],
                [
                    84.6384762,
                    55.0395875
                ],
                [
                    84.639545,
                    55.0394498
                ],
                [
                    84.641148,
                    55.0381791
                ],
                [
                    84.6402396,
                    55.0379035
                ],
                [
                    84.641148,
                    55.0368931
                ],
                [
                    84.6424272,
                    55.0372997
                ],
                [
                    84.6422049,
                    55.0375349
                ],
                [
                    84.6424614,
                    55.0375937
                ],
                [
                    84.6426666,
                    55.0374369
                ],
                [
                    84.6445645,
                    55.0382305
                ],
                [
                    84.6445303,
                    55.0383775
                ],
                [
                    84.6452143,
                    55.0385343
                ],
                [
                    84.6458298,
                    55.0379366
                ],
                [
                    84.6451801,
                    55.03777
                ],
                [
                    84.6447184,
                    55.0380836
                ],
                [
                    84.6429401,
                    55.0372703
                ],
                [
                    84.6437095,
                    55.0365158
                ],
                [
                    84.6418458,
                    55.0358789
                ],
                [
                    84.6419826,
                    55.0355164
                ],
                [
                    84.6399821,
                    55.0347227
                ],
                [
                    84.6397085,
                    55.0348305
                ],
                [
                    84.6364426,
                    55.0335762
                ],
                [
                    84.6397427,
                    55.0310969
                ],
                [
                    84.641709,
                    55.0319593
                ],
                [
                    84.6412132,
                    55.0328608
                ],
                [
                    84.6438806,
                    55.0335958
                ],
                [
                    84.6457272,
                    55.0341053
                ],
                [
                    84.6473687,
                    55.0347325
                ],
                [
                    84.6484972,
                    55.0341151
                ],
                [
                    84.649506,
                    55.0344777
                ],
                [
                    84.6490957,
                    55.0352714
                ],
                [
                    84.6499848,
                    55.0353498
                ],
                [
                    84.6503268,
                    55.0348501
                ],
                [
                    84.6499677,
                    55.0347325
                ],
                [
                    84.6503096,
                    55.0342621
                ],
                [
                    84.6485143,
                    55.033782
                ],
                [
                    84.649147,
                    55.0329784
                ],
                [
                    84.6472148,
                    55.0324493
                ],
                [
                    84.6474713,
                    55.0320769
                ],
                [
                    84.6462744,
                    55.0314693
                ],
                [
                    84.6473345,
                    55.0310773
                ],
                [
                    84.6478646,
                    55.0303423
                ],
                [
                    84.6459666,
                    55.0301855
                ],
                [
                    84.6446842,
                    55.0301365
                ],
                [
                    84.6437438,
                    55.0304599
                ],
                [
                    84.6353825,
                    55.027314
                ],
                [
                    84.6319628,
                    55.0262849
                ],
                [
                    84.6300818,
                    55.0265594
                ],
                [
                    84.6300648,
                    55.0271866
                ],
                [
                    84.6340146,
                    55.0290977
                ],
                [
                    84.6375712,
                    55.0300973
                ],
                [
                    84.6383406,
                    55.0308029
                ],
                [
                    84.6386997,
                    55.0311361
                ],
                [
                    84.6384261,
                    55.0316261
                ],
                [
                    84.636152,
                    55.0333998
                ],
                [
                    84.6344079,
                    55.032802
                ],
                [
                    84.6334675,
                    55.0335272
                ],
                [
                    84.6306633,
                    55.0325963
                ],
                [
                    84.6312446,
                    55.0317241
                ],
                [
                    84.6306216,
                    55.0316414
                ],
                [
                    84.6298468,
                    55.0326673
                ]
            ],
            "longitude": 84.642738,
            "latitude": 55.031071
        },
        "10296": {
            "name": "Осиновка",
            "population": 22,
            "type": "hamlet",
            "poly": [
                [
                    84.6615039,
                    55.3212886
                ],
                [
                    84.6632856,
                    55.3212886
                ],
                [
                    84.6631012,
                    55.3220926
                ],
                [
                    84.6667874,
                    55.3223372
                ],
                [
                    84.6683233,
                    55.3225819
                ],
                [
                    84.6688148,
                    55.3222673
                ],
                [
                    84.6735453,
                    55.323281
                ],
                [
                    84.6739139,
                    55.3230014
                ],
                [
                    84.6760027,
                    55.3233509
                ],
                [
                    84.6758184,
                    55.3243995
                ],
                [
                    84.6770471,
                    55.3256228
                ],
                [
                    84.6810404,
                    55.3259024
                ],
                [
                    84.6817162,
                    55.3248539
                ],
                [
                    84.6812861,
                    55.3224072
                ],
                [
                    84.6795659,
                    55.3228266
                ],
                [
                    84.6764328,
                    55.321778
                ],
                [
                    84.6734838,
                    55.3212886
                ],
                [
                    84.6717637,
                    55.3201351
                ],
                [
                    84.6696134,
                    55.3201001
                ],
                [
                    84.6672789,
                    55.3191913
                ],
                [
                    84.6646372,
                    55.3192961
                ],
                [
                    84.6616269,
                    55.3203099
                ],
                [
                    84.6615039,
                    55.3212886
                ]
            ],
            "longitude": 84.666283,
            "latitude": 55.321152
        },
        "10297": {
            "name": "Елфимово",
            "population": 154,
            "type": "hamlet",
            "poly": [
                [
                    84.6793589,
                    55.6272373
                ],
                [
                    84.6804135,
                    55.6300616
                ],
                [
                    84.6813058,
                    55.6298631
                ],
                [
                    84.6812788,
                    55.6303669
                ],
                [
                    84.6807108,
                    55.6304737
                ],
                [
                    84.6807649,
                    55.6312065
                ],
                [
                    84.6823603,
                    55.6311301
                ],
                [
                    84.6822793,
                    55.6314507
                ],
                [
                    84.6807649,
                    55.6315881
                ],
                [
                    84.6810354,
                    55.6327024
                ],
                [
                    84.6828201,
                    55.6326261
                ],
                [
                    84.6838477,
                    55.6341525
                ],
                [
                    84.6829824,
                    55.6347325
                ],
                [
                    84.6824956,
                    55.6343204
                ],
                [
                    84.6815492,
                    55.634183
                ],
                [
                    84.6818467,
                    55.6349768
                ],
                [
                    84.6841992,
                    55.6361826
                ],
                [
                    84.6841992,
                    55.6366252
                ],
                [
                    84.6862003,
                    55.6372662
                ],
                [
                    84.6842804,
                    55.638472
                ],
                [
                    84.6817115,
                    55.6368236
                ],
                [
                    84.6809002,
                    55.6374189
                ],
                [
                    84.6829283,
                    55.6387925
                ],
                [
                    84.6835773,
                    55.6384872
                ],
                [
                    84.6851727,
                    55.6393572
                ],
                [
                    84.686687,
                    55.6385483
                ],
                [
                    84.6878227,
                    55.6372662
                ],
                [
                    84.6857135,
                    55.6361673
                ],
                [
                    84.6868222,
                    55.6353278
                ],
                [
                    84.6858217,
                    55.6348089
                ],
                [
                    84.6849292,
                    55.6348699
                ],
                [
                    84.6843615,
                    55.6345036
                ],
                [
                    84.6843885,
                    55.6342899
                ],
                [
                    84.6854702,
                    55.6340151
                ],
                [
                    84.6876605,
                    55.6339693
                ],
                [
                    84.6875794,
                    55.6345036
                ],
                [
                    84.6883095,
                    55.634473
                ],
                [
                    84.687985,
                    55.6347631
                ],
                [
                    84.6900942,
                    55.6361673
                ],
                [
                    84.6907431,
                    55.6370983
                ],
                [
                    84.6910946,
                    55.6371441
                ],
                [
                    84.6918518,
                    55.636671
                ],
                [
                    84.6938258,
                    55.637022
                ],
                [
                    84.6942314,
                    55.6359384
                ],
                [
                    84.6929064,
                    55.6351141
                ],
                [
                    84.6931498,
                    55.634992
                ],
                [
                    84.6943937,
                    55.6352057
                ],
                [
                    84.6947182,
                    55.634992
                ],
                [
                    84.6956376,
                    55.6350073
                ],
                [
                    84.6957728,
                    55.6346257
                ],
                [
                    84.6945289,
                    55.6343509
                ],
                [
                    84.6952589,
                    55.6332825
                ],
                [
                    84.6937176,
                    55.6326719
                ],
                [
                    84.6940151,
                    55.6324887
                ],
                [
                    84.6936906,
                    55.6323208
                ],
                [
                    84.6932039,
                    55.6324582
                ],
                [
                    84.6927712,
                    55.6321834
                ],
                [
                    84.6923115,
                    55.6324276
                ],
                [
                    84.6918248,
                    55.6323513
                ],
                [
                    84.690067,
                    55.6332825
                ],
                [
                    84.6891207,
                    55.6331145
                ],
                [
                    84.6890666,
                    55.6328093
                ],
                [
                    84.6886069,
                    55.6328093
                ],
                [
                    84.6883635,
                    55.6324887
                ],
                [
                    84.688661,
                    55.6323055
                ],
                [
                    84.6891207,
                    55.6324734
                ],
                [
                    84.6901482,
                    55.6318934
                ],
                [
                    84.6894452,
                    55.6315881
                ],
                [
                    84.6889584,
                    55.6316186
                ],
                [
                    84.6884987,
                    55.6311759
                ],
                [
                    84.6872008,
                    55.6316491
                ],
                [
                    84.6860921,
                    55.6309011
                ],
                [
                    84.6847671,
                    55.6311912
                ],
                [
                    84.6851457,
                    55.6318628
                ],
                [
                    84.6861462,
                    55.6315728
                ],
                [
                    84.6872008,
                    55.632046
                ],
                [
                    84.6855783,
                    55.6331298
                ],
                [
                    84.6859568,
                    55.6334809
                ],
                [
                    84.6864707,
                    55.6334198
                ],
                [
                    84.6865518,
                    55.6336488
                ],
                [
                    84.6841181,
                    55.633893
                ],
                [
                    84.6831176,
                    55.6323513
                ],
                [
                    84.6837936,
                    55.6321376
                ],
                [
                    84.6836314,
                    55.6315881
                ],
                [
                    84.6830094,
                    55.6315728
                ],
                [
                    84.6829013,
                    55.6312217
                ],
                [
                    84.683442,
                    55.6312217
                ],
                [
                    84.6838747,
                    55.6304432
                ],
                [
                    84.6838747,
                    55.6298631
                ],
                [
                    84.6843344,
                    55.6294967
                ],
                [
                    84.684037,
                    55.6287334
                ],
                [
                    84.6843344,
                    55.628596
                ],
                [
                    84.6830094,
                    55.6262602
                ],
                [
                    84.6807108,
                    55.6265809
                ],
                [
                    84.680738,
                    55.6270541
                ],
                [
                    84.6793589,
                    55.6272373
                ]
            ],
            "longitude": 84.68219,
            "latitude": 55.630417
        },
        "10298": {
            "name": "Жерновка",
            "population": 206,
            "type": "hamlet",
            "poly": [
                [
                    84.6837441,
                    54.3365353
                ],
                [
                    84.6933622,
                    54.3376353
                ],
                [
                    84.6959147,
                    54.3339256
                ],
                [
                    84.6940651,
                    54.3310136
                ],
                [
                    84.6896259,
                    54.3298272
                ],
                [
                    84.6858157,
                    54.3310783
                ],
                [
                    84.6837441,
                    54.3365353
                ]
            ],
            "longitude": 84.68914,
            "latitude": 54.333786
        },
        "10299": {
            "name": "Низовка",
            "population": 133,
            "type": "hamlet",
            "poly": [
                [
                    84.7023634,
                    55.0976334
                ],
                [
                    84.7025876,
                    55.0977732
                ],
                [
                    84.703357,
                    55.0975776
                ],
                [
                    84.7042975,
                    55.0981523
                ],
                [
                    84.7062423,
                    55.1000356
                ],
                [
                    84.7067126,
                    55.1002435
                ],
                [
                    84.7082515,
                    55.0995831
                ],
                [
                    84.7075248,
                    55.0989228
                ],
                [
                    84.7088072,
                    55.0983358
                ],
                [
                    84.708679,
                    55.0982257
                ],
                [
                    84.7093201,
                    55.0980056
                ],
                [
                    84.710453,
                    55.0988494
                ],
                [
                    84.712975,
                    55.0978711
                ],
                [
                    84.7127186,
                    55.0976143
                ],
                [
                    84.7132101,
                    55.0974064
                ],
                [
                    84.7124192,
                    55.0966726
                ],
                [
                    84.7127186,
                    55.0965014
                ],
                [
                    84.7109232,
                    55.0943244
                ],
                [
                    84.7106453,
                    55.0943366
                ],
                [
                    84.7104102,
                    55.0940553
                ],
                [
                    84.7099186,
                    55.0941776
                ],
                [
                    84.7095339,
                    55.0939086
                ],
                [
                    84.7096949,
                    55.0935936
                ],
                [
                    84.7097477,
                    55.0933704
                ],
                [
                    84.709021,
                    55.0926366
                ],
                [
                    84.7092561,
                    55.0925265
                ],
                [
                    84.7090422,
                    55.0924164
                ],
                [
                    84.7091492,
                    55.0922941
                ],
                [
                    84.7081233,
                    55.0915113
                ],
                [
                    84.7073966,
                    55.0915235
                ],
                [
                    84.7071401,
                    55.0912545
                ],
                [
                    84.7058363,
                    55.0915602
                ],
                [
                    84.7050669,
                    55.0908875
                ],
                [
                    84.7027799,
                    55.0914624
                ],
                [
                    84.7032715,
                    55.0920373
                ],
                [
                    84.7039982,
                    55.0918538
                ],
                [
                    84.7047034,
                    55.0926243
                ],
                [
                    84.7025662,
                    55.093297
                ],
                [
                    84.7044512,
                    55.095443
                ],
                [
                    84.7045766,
                    55.0955592
                ],
                [
                    84.7038369,
                    55.0958061
                ],
                [
                    84.7039491,
                    55.0959375
                ],
                [
                    84.7029349,
                    55.0962805
                ],
                [
                    84.7033776,
                    55.0968608
                ],
                [
                    84.7029685,
                    55.096973
                ],
                [
                    84.7032991,
                    55.0973096
                ],
                [
                    84.7023634,
                    55.0976334
                ]
            ],
            "longitude": 84.70636,
            "latitude": 55.095036
        },
        "10300": {
            "name": "Боровая",
            "population": 94,
            "type": "hamlet",
            "poly": [
                [
                    84.7111155,
                    55.2381685
                ],
                [
                    84.71331,
                    55.2388377
                ],
                [
                    84.7149686,
                    55.2391869
                ],
                [
                    84.7165761,
                    55.2397834
                ],
                [
                    84.7159893,
                    55.2404962
                ],
                [
                    84.71553,
                    55.2413982
                ],
                [
                    84.7143817,
                    55.2421983
                ],
                [
                    84.7141265,
                    55.2426202
                ],
                [
                    84.7162443,
                    55.2431439
                ],
                [
                    84.7161934,
                    55.2433766
                ],
                [
                    84.7167037,
                    55.2435221
                ],
                [
                    84.7172651,
                    55.2441913
                ],
                [
                    84.7204292,
                    55.2446713
                ],
                [
                    84.7214754,
                    55.2445404
                ],
                [
                    84.7235422,
                    55.2435512
                ],
                [
                    84.7267574,
                    55.2415728
                ],
                [
                    84.726936,
                    55.2412964
                ],
                [
                    84.7274208,
                    55.2413255
                ],
                [
                    84.7295387,
                    55.240569
                ],
                [
                    84.7286455,
                    55.2396816
                ],
                [
                    84.7273442,
                    55.2389396
                ],
                [
                    84.7290284,
                    55.2373829
                ],
                [
                    84.7286966,
                    55.2372083
                ],
                [
                    84.7290284,
                    55.2368736
                ],
                [
                    84.7286201,
                    55.2359134
                ],
                [
                    84.7279056,
                    55.2357679
                ],
                [
                    84.7270635,
                    55.2357097
                ],
                [
                    84.7262215,
                    55.2363062
                ],
                [
                    84.7264767,
                    55.2364517
                ],
                [
                    84.7249712,
                    55.2377466
                ],
                [
                    84.7239505,
                    55.2383867
                ],
                [
                    84.7225215,
                    55.2377757
                ],
                [
                    84.7228788,
                    55.2374411
                ],
                [
                    84.7210161,
                    55.2370628
                ],
                [
                    84.7205823,
                    55.2372228
                ],
                [
                    84.7203016,
                    55.2374992
                ],
                [
                    84.7206078,
                    55.2376302
                ],
                [
                    84.7202506,
                    55.238023
                ],
                [
                    84.7197913,
                    55.2382121
                ],
                [
                    84.7191533,
                    55.2378484
                ],
                [
                    84.7162189,
                    55.2380085
                ],
                [
                    84.71553,
                    55.2377902
                ],
                [
                    84.7151982,
                    55.2380376
                ],
                [
                    84.7145348,
                    55.237863
                ],
                [
                    84.7139224,
                    55.2385177
                ],
                [
                    84.7113707,
                    55.2379357
                ],
                [
                    84.7111155,
                    55.2381685
                ]
            ],
            "longitude": 84.721504,
            "latitude": 55.240841
        },
        "10301": {
            "name": "Правососновка",
            "population": 90,
            "type": "hamlet",
            "poly": [
                [
                    84.712597,
                    55.5488064
                ],
                [
                    84.7168222,
                    55.550599
                ],
                [
                    84.7176144,
                    55.5520181
                ],
                [
                    84.7193969,
                    55.5516073
                ],
                [
                    84.7346471,
                    55.5569845
                ],
                [
                    84.7373537,
                    55.5545574
                ],
                [
                    84.7172843,
                    55.5476113
                ],
                [
                    84.7162941,
                    55.5485076
                ],
                [
                    84.7137854,
                    55.5477607
                ],
                [
                    84.712597,
                    55.5488064
                ]
            ],
            "longitude": 84.722847,
            "latitude": 55.551094
        },
        "10302": {
            "name": "Изылинка",
            "population": 83,
            "type": "hamlet",
            "poly": [
                [
                    84.721645,
                    55.1107512
                ],
                [
                    84.7252432,
                    55.1118115
                ],
                [
                    84.7315675,
                    55.1075703
                ],
                [
                    84.7279692,
                    55.1060109
                ],
                [
                    84.721645,
                    55.1107512
                ]
            ],
            "longitude": 84.728981,
            "latitude": 55.108696
        },
        "10303": {
            "name": "Конево",
            "population": 79,
            "type": "hamlet",
            "poly": [
                [
                    84.7215781,
                    54.8378297
                ],
                [
                    84.7218272,
                    54.8391209
                ],
                [
                    84.7232047,
                    54.8389859
                ],
                [
                    84.7233512,
                    54.8400408
                ],
                [
                    84.7240693,
                    54.8404037
                ],
                [
                    84.7229181,
                    54.8427453
                ],
                [
                    84.7243134,
                    54.8429307
                ],
                [
                    84.7245638,
                    54.842601
                ],
                [
                    84.7264243,
                    54.8428277
                ],
                [
                    84.7272471,
                    54.841571
                ],
                [
                    84.7303956,
                    54.842189
                ],
                [
                    84.7305029,
                    54.8419624
                ],
                [
                    84.7295727,
                    54.8397785
                ],
                [
                    84.7304671,
                    54.838769
                ],
                [
                    84.7303598,
                    54.8376564
                ],
                [
                    84.7298231,
                    54.8374709
                ],
                [
                    84.7300736,
                    54.8371207
                ],
                [
                    84.7312542,
                    54.8374503
                ],
                [
                    84.7314331,
                    54.8370588
                ],
                [
                    84.7334724,
                    54.8375121
                ],
                [
                    84.7338302,
                    54.8370795
                ],
                [
                    84.7351182,
                    54.8372443
                ],
                [
                    84.7366566,
                    54.8381715
                ],
                [
                    84.7384097,
                    54.8402524
                ],
                [
                    84.7388033,
                    54.8401288
                ],
                [
                    84.7394831,
                    54.8407469
                ],
                [
                    84.7383382,
                    54.8436723
                ],
                [
                    84.7418801,
                    54.8447436
                ],
                [
                    84.7517905,
                    54.846371
                ],
                [
                    84.7519693,
                    54.846165
                ],
                [
                    84.7526491,
                    54.8462886
                ],
                [
                    84.7533647,
                    54.8451762
                ],
                [
                    84.7492144,
                    54.8442285
                ],
                [
                    84.7500374,
                    54.8433221
                ],
                [
                    84.7445992,
                    54.8421684
                ],
                [
                    84.7417728,
                    54.8392016
                ],
                [
                    84.7425957,
                    54.838872
                ],
                [
                    84.7418801,
                    54.8380066
                ],
                [
                    84.7420063,
                    54.8370955
                ],
                [
                    84.7374309,
                    54.8358463
                ],
                [
                    84.7318215,
                    54.834994
                ],
                [
                    84.7300776,
                    54.8351206
                ],
                [
                    84.729594,
                    54.8348843
                ],
                [
                    84.7278355,
                    54.8354666
                ],
                [
                    84.7271907,
                    54.8354835
                ],
                [
                    84.726839,
                    54.8360406
                ],
                [
                    84.7265606,
                    54.8360152
                ],
                [
                    84.7262528,
                    54.8365301
                ],
                [
                    84.7269123,
                    54.8369014
                ],
                [
                    84.7266338,
                    54.837374
                ],
                [
                    84.7251098,
                    54.8376694
                ],
                [
                    84.7215781,
                    54.8378297
                ]
            ],
            "longitude": 84.73214,
            "latitude": 54.83606
        },
        "10304": {
            "name": "Кармановка",
            "population": 46,
            "type": "hamlet",
            "poly": [
                [
                    84.7218555,
                    55.4751231
                ],
                [
                    84.7228637,
                    55.4765041
                ],
                [
                    84.7269809,
                    55.4816467
                ],
                [
                    84.7295016,
                    55.4908827
                ],
                [
                    84.7354673,
                    55.4912159
                ],
                [
                    84.7370636,
                    55.4895974
                ],
                [
                    84.7358874,
                    55.4829799
                ],
                [
                    84.7307619,
                    55.4763613
                ],
                [
                    84.7270649,
                    55.4744564
                ],
                [
                    84.7218555,
                    55.4751231
                ]
            ],
            "longitude": 84.732971,
            "latitude": 55.483105
        },
        "10305": {
            "name": "Новоизылинка",
            "population": 25,
            "type": "hamlet",
            "poly": [
                [
                    84.7333121,
                    55.1137448
                ],
                [
                    84.7461785,
                    55.1215396
                ],
                [
                    84.7493407,
                    55.1204172
                ],
                [
                    84.7386549,
                    55.1120609
                ],
                [
                    84.7333121,
                    55.1137448
                ]
            ],
            "longitude": 84.741165,
            "latitude": 55.11655
        },
        "10306": {
            "name": "Петуховка",
            "population": 79,
            "type": "hamlet",
            "poly": [
                [
                    84.7459068,
                    55.1093877
                ],
                [
                    84.7494505,
                    55.1114147
                ],
                [
                    84.7521764,
                    55.1118825
                ],
                [
                    84.7535393,
                    55.1106351
                ],
                [
                    84.7505409,
                    55.106347
                ],
                [
                    84.7463156,
                    55.1069708
                ],
                [
                    84.7459068,
                    55.1093877
                ]
            ],
            "longitude": 84.749168,
            "latitude": 55.109173
        },
        "10307": {
            "name": "Петени",
            "population": 97,
            "type": "hamlet",
            "poly": [
                [
                    84.7469932,
                    54.4154663
                ],
                [
                    84.7473813,
                    54.4169719
                ],
                [
                    84.7493218,
                    54.4176343
                ],
                [
                    84.7514951,
                    54.417815
                ],
                [
                    84.7518316,
                    54.4173332
                ],
                [
                    84.7536945,
                    54.4184925
                ],
                [
                    84.7520644,
                    54.4191699
                ],
                [
                    84.7485197,
                    54.4193506
                ],
                [
                    84.7473554,
                    54.4203141
                ],
                [
                    84.7487526,
                    54.4212775
                ],
                [
                    84.7512882,
                    54.4207808
                ],
                [
                    84.7539274,
                    54.4222711
                ],
                [
                    84.7574203,
                    54.4246194
                ],
                [
                    84.7587916,
                    54.4239571
                ],
                [
                    84.7580154,
                    54.4218044
                ],
                [
                    84.7571616,
                    54.4179505
                ],
                [
                    84.7556868,
                    54.4173031
                ],
                [
                    84.7542637,
                    54.4181613
                ],
                [
                    84.7526078,
                    54.4171977
                ],
                [
                    84.7555315,
                    54.4156922
                ],
                [
                    84.7493736,
                    54.4125002
                ],
                [
                    84.7478986,
                    54.4133132
                ],
                [
                    84.7469932,
                    54.4154663
                ]
            ],
            "longitude": 84.754677,
            "latitude": 54.419987
        },
        "10308": {
            "name": "Нижняя Матренка",
            "population": 183,
            "type": "hamlet",
            "poly": [
                [
                    84.7551117,
                    54.4651946
                ],
                [
                    84.758559,
                    54.4667315
                ],
                [
                    84.7607786,
                    54.466265
                ],
                [
                    84.7685234,
                    54.4623949
                ],
                [
                    84.7672011,
                    54.4594303
                ],
                [
                    84.7647454,
                    54.4603088
                ],
                [
                    84.7650288,
                    54.4615714
                ],
                [
                    84.7604008,
                    54.4637673
                ],
                [
                    84.7594091,
                    54.4627792
                ],
                [
                    84.7551117,
                    54.4651946
                ]
            ],
            "longitude": 84.761885,
            "latitude": 54.4642764
        },
        "10309": {
            "name": "Смирновка",
            "population": 267,
            "type": "hamlet",
            "poly": [
                [
                    84.7558764,
                    54.9740187
                ],
                [
                    84.7679275,
                    54.9800482
                ],
                [
                    84.7714181,
                    54.978129
                ],
                [
                    84.7734895,
                    54.971181
                ],
                [
                    84.7659189,
                    54.9700281
                ],
                [
                    84.7614384,
                    54.9715357
                ],
                [
                    84.7558764,
                    54.9740187
                ]
            ],
            "longitude": 84.766762,
            "latitude": 54.974007
        },
        "10310": {
            "name": "Саламатово",
            "population": 49,
            "type": "hamlet",
            "poly": [
                [
                    84.7618725,
                    55.1515366
                ],
                [
                    84.7628883,
                    55.152117
                ],
                [
                    84.7632366,
                    55.1520009
                ],
                [
                    84.765123,
                    55.15351
                ],
                [
                    84.7645426,
                    55.154024
                ],
                [
                    84.7672417,
                    55.1552014
                ],
                [
                    84.7670675,
                    55.1554833
                ],
                [
                    84.7685185,
                    55.1561631
                ],
                [
                    84.7681704,
                    55.1564284
                ],
                [
                    84.7692732,
                    55.1572741
                ],
                [
                    84.7703471,
                    55.1577218
                ],
                [
                    84.7706083,
                    55.1585674
                ],
                [
                    84.7714789,
                    55.1590317
                ],
                [
                    84.7731332,
                    55.159728
                ],
                [
                    84.7735105,
                    55.1594959
                ],
                [
                    84.7740619,
                    55.1596783
                ],
                [
                    84.7744102,
                    55.159413
                ],
                [
                    84.7773705,
                    55.1606068
                ],
                [
                    84.7781831,
                    55.1598607
                ],
                [
                    84.7792859,
                    55.1600265
                ],
                [
                    84.7798374,
                    55.1604741
                ],
                [
                    84.7805629,
                    55.1601923
                ],
                [
                    84.7800986,
                    55.1598938
                ],
                [
                    84.7800115,
                    55.1584348
                ],
                [
                    84.776819,
                    55.157042
                ],
                [
                    84.7755421,
                    55.1577218
                ],
                [
                    84.7734234,
                    55.1564284
                ],
                [
                    84.7745553,
                    55.155732
                ],
                [
                    84.7713337,
                    55.1545215
                ],
                [
                    84.7707824,
                    55.1548034
                ],
                [
                    84.7690991,
                    55.1540738
                ],
                [
                    84.7688959,
                    55.1543059
                ],
                [
                    84.7671836,
                    55.1529793
                ],
                [
                    84.7667483,
                    55.1530788
                ],
                [
                    84.7652101,
                    55.1522331
                ],
                [
                    84.7649488,
                    55.1523326
                ],
                [
                    84.7643104,
                    55.1518683
                ],
                [
                    84.7638461,
                    55.1521336
                ],
                [
                    84.7628012,
                    55.1511552
                ],
                [
                    84.7618725,
                    55.1515366
                ]
            ],
            "longitude": 84.773354,
            "latitude": 55.158062
        },
        "10311": {
            "name": "Кусмень",
            "population": 142,
            "type": "hamlet",
            "poly": [
                [
                    84.7820133,
                    55.2601757
                ],
                [
                    84.7840546,
                    55.2608737
                ],
                [
                    84.7831105,
                    55.2614553
                ],
                [
                    84.7842077,
                    55.2619787
                ],
                [
                    84.7842077,
                    55.2625894
                ],
                [
                    84.7836208,
                    55.2632001
                ],
                [
                    84.7854325,
                    55.2639125
                ],
                [
                    84.7851008,
                    55.2641306
                ],
                [
                    84.7865808,
                    55.265381
                ],
                [
                    84.7887497,
                    55.2653664
                ],
                [
                    84.7894131,
                    55.2646395
                ],
                [
                    84.7886221,
                    55.2637817
                ],
                [
                    84.7905614,
                    55.2628802
                ],
                [
                    84.7921434,
                    55.2632873
                ],
                [
                    84.7940062,
                    55.2628366
                ],
                [
                    84.7940827,
                    55.2633309
                ],
                [
                    84.7974509,
                    55.2634618
                ],
                [
                    84.7978592,
                    55.2642615
                ],
                [
                    84.7991351,
                    55.2650611
                ],
                [
                    84.8013295,
                    55.2655264
                ],
                [
                    84.8019419,
                    55.2652647
                ],
                [
                    84.8015081,
                    55.2644796
                ],
                [
                    84.8032943,
                    55.2636072
                ],
                [
                    84.8057184,
                    55.2634618
                ],
                [
                    84.8060246,
                    55.2631855
                ],
                [
                    84.8056418,
                    55.2620369
                ],
                [
                    84.8089335,
                    55.2617315
                ],
                [
                    84.8091376,
                    55.2614844
                ],
                [
                    84.8062032,
                    55.2604229
                ],
                [
                    84.8037535,
                    55.260452
                ],
                [
                    84.8026819,
                    55.2586634
                ],
                [
                    84.8032177,
                    55.258169
                ],
                [
                    84.8027329,
                    55.2578782
                ],
                [
                    84.7993392,
                    55.2567294
                ],
                [
                    84.7995178,
                    55.2563949
                ],
                [
                    84.7975275,
                    55.2555224
                ],
                [
                    84.7954606,
                    55.2551297
                ],
                [
                    84.7896428,
                    55.2532246
                ],
                [
                    84.7880863,
                    55.2533991
                ],
                [
                    84.7855601,
                    55.2542426
                ],
                [
                    84.7864022,
                    55.2555078
                ],
                [
                    84.7857132,
                    55.2559587
                ],
                [
                    84.7860194,
                    55.2565404
                ],
                [
                    84.7851773,
                    55.2565985
                ],
                [
                    84.785458,
                    55.2573402
                ],
                [
                    84.7849987,
                    55.2586489
                ],
                [
                    84.7852029,
                    55.2588234
                ],
                [
                    84.7842332,
                    55.2591869
                ],
                [
                    84.7835953,
                    55.2590706
                ],
                [
                    84.7824215,
                    55.2596522
                ],
                [
                    84.7820133,
                    55.2601757
                ]
            ],
            "longitude": 84.791382,
            "latitude": 55.257622
        },
        "10312": {
            "name": "Чудиново",
            "population": 242,
            "type": "hamlet",
            "poly": [
                [
                    84.8119385,
                    54.3421846
                ],
                [
                    84.8134769,
                    54.34433
                ],
                [
                    84.816047,
                    54.3434945
                ],
                [
                    84.8162447,
                    54.3422844
                ],
                [
                    84.8202482,
                    54.343869
                ],
                [
                    84.8214838,
                    54.3457705
                ],
                [
                    84.8299356,
                    54.342803
                ],
                [
                    84.8294906,
                    54.3402098
                ],
                [
                    84.8307264,
                    54.3395471
                ],
                [
                    84.8361632,
                    54.340642
                ],
                [
                    84.8388815,
                    54.3403539
                ],
                [
                    84.8381402,
                    54.3388844
                ],
                [
                    84.8393264,
                    54.3369826
                ],
                [
                    84.8374482,
                    54.3343603
                ],
                [
                    84.8337413,
                    54.3328617
                ],
                [
                    84.827316,
                    54.3279911
                ],
                [
                    84.8222746,
                    54.3285963
                ],
                [
                    84.8245976,
                    54.3299509
                ],
                [
                    84.8266735,
                    54.3307291
                ],
                [
                    84.828947,
                    54.3360317
                ],
                [
                    84.817085,
                    54.3369826
                ],
                [
                    84.816739,
                    54.3397488
                ],
                [
                    84.8119385,
                    54.3421846
                ]
            ],
            "longitude": 84.823166,
            "latitude": 54.340221
        },
        "10313": {
            "name": "Кучаниха",
            "population": 121,
            "type": "hamlet",
            "poly": [
                [
                    84.8465157,
                    55.0800589
                ],
                [
                    84.8500065,
                    55.0813078
                ],
                [
                    84.8545156,
                    55.0811413
                ],
                [
                    84.8549519,
                    55.0796426
                ],
                [
                    84.8597519,
                    55.0774777
                ],
                [
                    84.857861,
                    55.0765618
                ],
                [
                    84.8548065,
                    55.0772279
                ],
                [
                    84.8504429,
                    55.0756458
                ],
                [
                    84.8470975,
                    55.0770614
                ],
                [
                    84.8465157,
                    55.0800589
                ]
            ],
            "longitude": 84.850616,
            "latitude": 55.078781
        },
        "10314": {
            "name": "Мокрушино",
            "population": 109,
            "type": "hamlet",
            "poly": [
                [
                    84.8512813,
                    54.7501116
                ],
                [
                    84.8512813,
                    54.7507832
                ],
                [
                    84.856739,
                    54.7511538
                ],
                [
                    84.8613138,
                    54.7548824
                ],
                [
                    84.8636012,
                    54.7600694
                ],
                [
                    84.8651261,
                    54.7597684
                ],
                [
                    84.8674135,
                    54.7598147
                ],
                [
                    84.8680555,
                    54.7604862
                ],
                [
                    84.8677345,
                    54.7618986
                ],
                [
                    84.8725902,
                    54.7610419
                ],
                [
                    84.8735533,
                    54.7620144
                ],
                [
                    84.8753591,
                    54.7614818
                ],
                [
                    84.8729514,
                    54.7579854
                ],
                [
                    84.8755598,
                    54.7568508
                ],
                [
                    84.8725902,
                    54.7537708
                ],
                [
                    84.8711694,
                    54.7543677
                ],
                [
                    84.8705837,
                    54.7529834
                ],
                [
                    84.8724698,
                    54.7506211
                ],
                [
                    84.8669319,
                    54.7487451
                ],
                [
                    84.8640827,
                    54.7451549
                ],
                [
                    84.8636413,
                    54.7425142
                ],
                [
                    84.8512813,
                    54.7501116
                ]
            ],
            "longitude": 84.865623,
            "latitude": 54.749607
        },
        "10315": {
            "name": "Придолинный",
            "population": 161,
            "type": "hamlet",
            "poly": [
                [
                    84.8604109,
                    54.93891
                ],
                [
                    84.8739901,
                    54.9413367
                ],
                [
                    84.8776112,
                    54.9371765
                ],
                [
                    84.8679549,
                    54.9333625
                ],
                [
                    84.8604109,
                    54.93891
                ]
            ],
            "longitude": 84.866493,
            "latitude": 54.936897
        },
        "10316": {
            "name": "Разливы",
            "population": 22,
            "type": "hamlet",
            "poly": [
                [
                    84.8688862,
                    55.1779698
                ],
                [
                    84.8723346,
                    55.1779698
                ],
                [
                    84.8735237,
                    55.1750499
                ],
                [
                    84.8766154,
                    55.1732164
                ],
                [
                    84.8730481,
                    55.1728768
                ],
                [
                    84.8698374,
                    55.1749141
                ],
                [
                    84.8688862,
                    55.1779698
                ]
            ],
            "longitude": 84.87104,
            "latitude": 55.176399
        },
        "10317": {
            "name": "Родники",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    84.9001877,
                    55.1304836
                ],
                [
                    84.9061513,
                    55.1305668
                ],
                [
                    84.9094967,
                    55.1275731
                ],
                [
                    84.9060058,
                    55.1247454
                ],
                [
                    84.9025149,
                    55.123581
                ],
                [
                    84.902224,
                    55.1258266
                ],
                [
                    84.9003332,
                    55.1274899
                ],
                [
                    84.9001877,
                    55.1304836
                ]
            ],
            "longitude": 84.903214,
            "latitude": 55.125057
        },
        "10318": {
            "name": "Колтырак",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.915924,
            "latitude": 54.788818
        },
        "10319": {
            "name": "2-й Саранчет",
            "population": 113,
            "type": "hamlet",
            "poly": [
                [
                    97.2041691,
                    55.8224346
                ],
                [
                    97.2074372,
                    55.8243891
                ],
                [
                    97.2218109,
                    55.8161048
                ],
                [
                    97.21888,
                    55.8150877
                ],
                [
                    97.213363,
                    55.8181026
                ],
                [
                    97.2115312,
                    55.8177151
                ],
                [
                    97.204441,
                    55.8218679
                ],
                [
                    97.2041691,
                    55.8224346
                ]
            ],
            "longitude": 97.2153163,
            "latitude": 55.8184801
        },
        "10320": {
            "name": "1-й Саранчет",
            "population": 122,
            "type": "hamlet",
            "poly": [
                [
                    97.2346302,
                    55.809965
                ],
                [
                    97.237518,
                    55.8101103
                ],
                [
                    97.2420436,
                    55.810958
                ],
                [
                    97.2432503,
                    55.8097228
                ],
                [
                    97.2466986,
                    55.8092142
                ],
                [
                    97.251138,
                    55.8076156
                ],
                [
                    97.2512242,
                    55.8071554
                ],
                [
                    97.2544999,
                    55.8066709
                ],
                [
                    97.2583359,
                    55.8031827
                ],
                [
                    97.2598014,
                    55.8025771
                ],
                [
                    97.2589823,
                    55.8021168
                ],
                [
                    97.2629262,
                    55.799985
                ],
                [
                    97.2655123,
                    55.7993308
                ],
                [
                    97.2639601,
                    55.7966145
                ],
                [
                    97.2634725,
                    55.7956551
                ],
                [
                    97.2618267,
                    55.7961005
                ],
                [
                    97.2579255,
                    55.7951068
                ],
                [
                    97.2571637,
                    55.7953296
                ],
                [
                    97.2552131,
                    55.7938219
                ],
                [
                    97.2526531,
                    55.7947642
                ],
                [
                    97.252013,
                    55.7956208
                ],
                [
                    97.2495749,
                    55.7967002
                ],
                [
                    97.2491122,
                    55.7975865
                ],
                [
                    97.2507932,
                    55.7979741
                ],
                [
                    97.2509656,
                    55.8000334
                ],
                [
                    97.2494138,
                    55.8002515
                ],
                [
                    97.2489829,
                    55.8018019
                ],
                [
                    97.2514828,
                    55.8040306
                ],
                [
                    97.245621,
                    55.8062591
                ],
                [
                    97.243897,
                    55.8058958
                ],
                [
                    97.2400609,
                    55.8080758
                ],
                [
                    97.240492,
                    55.8086087
                ],
                [
                    97.2389834,
                    55.8091657
                ],
                [
                    97.2361818,
                    55.8086813
                ],
                [
                    97.2347595,
                    55.8088267
                ],
                [
                    97.2346302,
                    55.809965
                ]
            ],
            "longitude": 97.2472191,
            "latitude": 55.8074912
        },
        "10321": {
            "name": "Тинская Дача",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.2951133,
            "latitude": 56.0021467
        },
        "10322": {
            "name": "Туманшет",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.347061,
            "latitude": 55.825123
        },
        "10323": {
            "name": "Точильный",
            "population": 17,
            "type": "hamlet",
            "poly": [
                [
                    97.4199565,
                    56.0785048
                ],
                [
                    97.4241162,
                    56.0796774
                ],
                [
                    97.4271824,
                    56.0815799
                ],
                [
                    97.4255099,
                    56.0823576
                ],
                [
                    97.4237088,
                    56.0828601
                ],
                [
                    97.4249524,
                    56.0847863
                ],
                [
                    97.430999,
                    56.082872
                ],
                [
                    97.4343654,
                    56.082202
                ],
                [
                    97.4320925,
                    56.0805269
                ],
                [
                    97.430999,
                    56.0806705
                ],
                [
                    97.430463,
                    56.0791629
                ],
                [
                    97.4279327,
                    56.0771407
                ],
                [
                    97.4209428,
                    56.0771167
                ],
                [
                    97.4199565,
                    56.0785048
                ]
            ],
            "longitude": 97.428978,
            "latitude": 56.081242
        },
        "10324": {
            "name": "Камышлеевка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.432419,
            "latitude": 55.832367
        },
        "10325": {
            "name": "Туманшет",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.4480746,
            "latitude": 55.8809284
        },
        "10326": {
            "name": "Зыряновка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.462952,
            "latitude": 55.912384
        },
        "10327": {
            "name": "Черемшанка",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.47953,
            "latitude": 56.095951
        },
        "10328": {
            "name": "Троицк",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.548882,
            "latitude": 55.918934
        },
        "10329": {
            "name": "Покровка",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.552643,
            "latitude": 55.84724
        },
        "10330": {
            "name": "Георгиевка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.623764,
            "latitude": 55.519894
        },
        "10331": {
            "name": "Запань",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.629181,
            "latitude": 55.969841
        },
        "10332": {
            "name": "Ингашет",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.632088,
            "latitude": 55.695488
        },
        "10333": {
            "name": "Черманчет",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.6847,
            "latitude": 56.875633
        },
        "10334": {
            "name": "Авдюшино",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.700935,
            "latitude": 55.915237
        },
        "10335": {
            "name": "Старошелехова",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.716347,
            "latitude": 55.705635
        },
        "10336": {
            "name": "Енисейка",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.734428,
            "latitude": 55.974667
        },
        "10337": {
            "name": "Еловая",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.770955,
            "latitude": 56.0484082
        },
        "10338": {
            "name": "Благодатское",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.784157,
            "latitude": 55.555103
        },
        "10339": {
            "name": "Пойма",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.7869308,
            "latitude": 56.8834713
        },
        "10340": {
            "name": "Сафроновка",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.8132862,
            "latitude": 55.8848272
        },
        "10341": {
            "name": "Конторка",
            "population": 151,
            "type": "hamlet",
            "poly": [
                [
                    97.8458043,
                    56.0290989
                ],
                [
                    97.8477015,
                    56.030438
                ],
                [
                    97.8488498,
                    56.0311633
                ],
                [
                    97.8548409,
                    56.0316096
                ],
                [
                    97.8565385,
                    56.0318327
                ],
                [
                    97.858835,
                    56.0293779
                ],
                [
                    97.8616309,
                    56.0288478
                ],
                [
                    97.8680215,
                    56.0288478
                ],
                [
                    97.8679716,
                    56.0300474
                ],
                [
                    97.87576,
                    56.0306332
                ],
                [
                    97.8793546,
                    56.0304937
                ],
                [
                    97.8765589,
                    56.0280109
                ],
                [
                    97.8695692,
                    56.0272576
                ],
                [
                    97.8686704,
                    56.0260859
                ],
                [
                    97.8640274,
                    56.0255
                ],
                [
                    97.8617807,
                    56.0248025
                ],
                [
                    97.8574371,
                    56.0269507
                ],
                [
                    97.8571376,
                    56.0284154
                ],
                [
                    97.8538544,
                    56.0295004
                ],
                [
                    97.8502005,
                    56.0280998
                ],
                [
                    97.848859,
                    56.02736
                ],
                [
                    97.8458043,
                    56.0290989
                ]
            ],
            "longitude": 97.862007,
            "latitude": 56.027317
        },
        "10342": {
            "name": "Сереброво",
            "population": 234,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.864296,
            "latitude": 55.412247
        },
        "10343": {
            "name": "Серафимовка",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 97.954544,
            "latitude": 55.839527
        },
        "10344": {
            "name": "Колтоши",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.012985,
            "latitude": 55.480694
        },
        "10345": {
            "name": "Сафроновка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.016212,
            "latitude": 56.011478
        },
        "10346": {
            "name": "Новотремино",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.06765,
            "latitude": 56.726151
        },
        "10347": {
            "name": "Новый Акульшет",
            "population": 197,
            "type": "hamlet",
            "poly": [
                [
                    98.0685921,
                    55.9133914
                ],
                [
                    98.0690516,
                    55.9135052
                ],
                [
                    98.0691195,
                    55.9144189
                ],
                [
                    98.0692227,
                    55.9145971
                ],
                [
                    98.0703615,
                    55.9145217
                ],
                [
                    98.071489,
                    55.9142733
                ],
                [
                    98.0732056,
                    55.9135659
                ],
                [
                    98.0742939,
                    55.912978
                ],
                [
                    98.0747145,
                    55.9128899
                ],
                [
                    98.0774578,
                    55.9112519
                ],
                [
                    98.0807451,
                    55.9095037
                ],
                [
                    98.0807844,
                    55.9088717
                ],
                [
                    98.0832302,
                    55.9071517
                ],
                [
                    98.0835668,
                    55.9072115
                ],
                [
                    98.0837856,
                    55.9070888
                ],
                [
                    98.0843858,
                    55.9073058
                ],
                [
                    98.0848345,
                    55.9068687
                ],
                [
                    98.084829,
                    55.9065323
                ],
                [
                    98.0845149,
                    55.9062964
                ],
                [
                    98.083808,
                    55.9059945
                ],
                [
                    98.0831573,
                    55.9057933
                ],
                [
                    98.0828937,
                    55.9059788
                ],
                [
                    98.0823888,
                    55.9058184
                ],
                [
                    98.0820185,
                    55.9058153
                ],
                [
                    98.0818222,
                    55.9059254
                ],
                [
                    98.0810593,
                    55.9055952
                ],
                [
                    98.0800607,
                    55.9054883
                ],
                [
                    98.0783105,
                    55.9059505
                ],
                [
                    98.077598,
                    55.9064411
                ],
                [
                    98.0762629,
                    55.9067115
                ],
                [
                    98.0751466,
                    55.9074787
                ],
                [
                    98.075629,
                    55.9075951
                ],
                [
                    98.0763863,
                    55.9081265
                ],
                [
                    98.075988,
                    55.908485
                ],
                [
                    98.0755449,
                    55.9085667
                ],
                [
                    98.0746585,
                    55.909227
                ],
                [
                    98.0722968,
                    55.9081328
                ],
                [
                    98.0715395,
                    55.9085604
                ],
                [
                    98.0740302,
                    55.9096924
                ],
                [
                    98.0755366,
                    55.9103967
                ],
                [
                    98.0740827,
                    55.9111316
                ],
                [
                    98.0719089,
                    55.9119766
                ],
                [
                    98.0712848,
                    55.9122085
                ],
                [
                    98.0693424,
                    55.91336
                ],
                [
                    98.0687885,
                    55.9132067
                ],
                [
                    98.0685921,
                    55.9133914
                ]
            ],
            "longitude": 98.0765,
            "latitude": 55.91095
        },
        "10348": {
            "name": "Синякина",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.082596,
            "latitude": 56.086689
        },
        "10349": {
            "name": "Акульшет",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.107697,
            "latitude": 55.957447
        },
        "10350": {
            "name": "Байроновка",
            "population": 228,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.109871,
            "latitude": 55.889973
        },
        "10351": {
            "name": "Парижская Коммуна",
            "population": 204,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.120651,
            "latitude": 55.940441
        },
        "10352": {
            "name": "Коновалова",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.169472,
            "latitude": 56.100056
        },
        "10353": {
            "name": "Кондратьево",
            "population": 190,
            "type": "hamlet",
            "poly": [
                [
                    98.1739473,
                    57.347823
                ],
                [
                    98.1752166,
                    57.3489135
                ],
                [
                    98.1767367,
                    57.3489225
                ],
                [
                    98.1787572,
                    57.3485619
                ],
                [
                    98.184522,
                    57.3529487
                ],
                [
                    98.1906667,
                    57.3538414
                ],
                [
                    98.1918359,
                    57.3533458
                ],
                [
                    98.1916007,
                    57.3531982
                ],
                [
                    98.1913766,
                    57.3530575
                ],
                [
                    98.1911344,
                    57.3525394
                ],
                [
                    98.1873391,
                    57.3495651
                ],
                [
                    98.1836721,
                    57.3470703
                ],
                [
                    98.1831862,
                    57.3467983
                ],
                [
                    98.1804482,
                    57.3460733
                ],
                [
                    98.1756194,
                    57.3461296
                ],
                [
                    98.1739473,
                    57.347823
                ]
            ],
            "longitude": 98.184692,
            "latitude": 57.349693
        },
        "10354": {
            "name": "Яга",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.227989,
            "latitude": 54.705292
        },
        "10355": {
            "name": "Нижняя Гоголевка",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.242889,
            "latitude": 56.049362
        },
        "10356": {
            "name": "Новошелехова",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.253906,
            "latitude": 55.730427
        },
        "10357": {
            "name": "Тракт-Ужет",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.255348,
            "latitude": 56.261097
        },
        "10358": {
            "name": "Рыбинск",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.264153,
            "latitude": 56.097095
        },
        "10359": {
            "name": "Борок",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.278542,
            "latitude": 56.111729
        },
        "10360": {
            "name": "Костомарово",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.284622,
            "latitude": 56.103729
        },
        "10361": {
            "name": "Тракт-Кавказ",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.321045,
            "latitude": 56.302139
        },
        "10362": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.3810172,
            "latitude": 57.5268114
        },
        "10363": {
            "name": "Яковская",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.39669,
            "latitude": 56.448917
        },
        "10364": {
            "name": "Иванов Мыс",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.408821,
            "latitude": 56.511032
        },
        "10365": {
            "name": "Шемякина",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.425705,
            "latitude": 56.508018
        },
        "10366": {
            "name": "Топорок",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.4276223,
            "latitude": 56.1432452
        },
        "10367": {
            "name": "Шевченко",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.437012,
            "latitude": 56.13599
        },
        "10368": {
            "name": "Облепиха",
            "population": 233,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.452464,
            "latitude": 55.6661383
        },
        "10369": {
            "name": "Короленко",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.4604803,
            "latitude": 56.1100667
        },
        "10370": {
            "name": "Косой Брод",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.574013,
            "latitude": 55.447365
        },
        "10371": {
            "name": "Красная Кавалерия",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.613548,
            "latitude": 55.707863
        },
        "10372": {
            "name": "Малиновка",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.621239,
            "latitude": 56.151157
        },
        "10373": {
            "name": "Алгашет",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.621658,
            "latitude": 55.465275
        },
        "10374": {
            "name": "Буракова",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.658951,
            "latitude": 55.731411
        },
        "10375": {
            "name": "Новокиевск",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.66993,
            "latitude": 55.669235
        },
        "10376": {
            "name": "Загорье",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.680138,
            "latitude": 55.299088
        },
        "10377": {
            "name": "Мара",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.847221,
            "latitude": 55.001808
        },
        "10378": {
            "name": "Новое Село",
            "population": 162,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.851837,
            "latitude": 54.901459
        },
        "10379": {
            "name": "Нагорный",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.8670109,
            "latitude": 56.1888669
        },
        "10380": {
            "name": "Неванка",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.91655,
            "latitude": 56.490799
        },
        "10381": {
            "name": "Уват",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.951187,
            "latitude": 54.866322
        },
        "10382": {
            "name": "Муксут",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.974861,
            "latitude": 54.843304
        },
        "10383": {
            "name": "Таёжный",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 98.996772,
            "latitude": 55.6548236
        },
        "10384": {
            "name": "Майский",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.012962,
            "latitude": 54.828018
        },
        "10385": {
            "name": "Выдрино",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.030891,
            "latitude": 56.837303
        },
        "10386": {
            "name": "Швайкина",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.034286,
            "latitude": 54.815659
        },
        "10387": {
            "name": "Водопадный",
            "population": 204,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.034752,
            "latitude": 55.046936
        },
        "10388": {
            "name": "Чалоты",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.083466,
            "latitude": 54.650822
        },
        "10389": {
            "name": "Ганькина",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.103798,
            "latitude": 56.321266
        },
        "10390": {
            "name": "Абалаково",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.113609,
            "latitude": 54.743614
        },
        "10391": {
            "name": "Гродинск",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.131134,
            "latitude": 55.675735
        },
        "10392": {
            "name": "Шум",
            "population": 222,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.132774,
            "latitude": 54.80904
        },
        "10393": {
            "name": "Кедровый",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.1492619,
            "latitude": 56.1618688
        },
        "10394": {
            "name": "Игнит",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.1547538,
            "latitude": 55.1415848
        },
        "10395": {
            "name": "Новогродинск",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.167381,
            "latitude": 55.679031
        },
        "10396": {
            "name": "Кушун",
            "population": 136,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.192574,
            "latitude": 54.63773
        },
        "10397": {
            "name": "Тахтамай",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.199394,
            "latitude": 56.244576
        },
        "10398": {
            "name": "Каксат",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.203163,
            "latitude": 54.970436
        },
        "10399": {
            "name": "Балтурино",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.240562,
            "latitude": 56.190815
        },
        "10400": {
            "name": "Ук-Бадарановка",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.247215,
            "latitude": 55.087173
        },
        "10401": {
            "name": "Укар",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.263123,
            "latitude": 55.061707
        },
        "10402": {
            "name": "Привольное",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.264214,
            "latitude": 54.561237
        },
        "10403": {
            "name": "Пушкинский",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.269783,
            "latitude": 54.543167
        },
        "10404": {
            "name": "Кирей-Муксут",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.307434,
            "latitude": 54.630692
        },
        "10405": {
            "name": "Новочунка",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.311272,
            "latitude": 56.140976
        },
        "10406": {
            "name": "Хингуй",
            "population": 229,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.341057,
            "latitude": 54.7925
        },
        "10407": {
            "name": "Катын",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.34832,
            "latitude": 54.436962
        },
        "10408": {
            "name": "Черемшанка",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.352219,
            "latitude": 55.374809
        },
        "10409": {
            "name": "Казачья Бадарановка",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.376198,
            "latitude": 55.139317
        },
        "10410": {
            "name": "Шипицина",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.376297,
            "latitude": 55.213688
        },
        "10411": {
            "name": "Зенцова",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.381592,
            "latitude": 55.366596
        },
        "10412": {
            "name": "Тони",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.400803,
            "latitude": 55.548939
        },
        "10413": {
            "name": "Кургатей",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.429543,
            "latitude": 54.376617
        },
        "10414": {
            "name": "Усть-Кадуй",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.43158,
            "latitude": 55.148724
        },
        "10415": {
            "name": "Боровинок",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.432426,
            "latitude": 55.590633
        },
        "10416": {
            "name": "Верхний Хингуй",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.441895,
            "latitude": 54.795174
        },
        "10417": {
            "name": "Волчий Брод",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.451019,
            "latitude": 54.451843
        },
        "10418": {
            "name": "Приудинск",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.454376,
            "latitude": 55.727455
        },
        "10419": {
            "name": "Лесной",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.484779,
            "latitude": 55.043766
        },
        "10420": {
            "name": "Кадуй",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.499039,
            "latitude": 54.743546
        },
        "10421": {
            "name": "Баер",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.512947,
            "latitude": 55.765179
        },
        "10422": {
            "name": "Мунтубулук",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.532997,
            "latitude": 54.424789
        },
        "10423": {
            "name": "Питаева",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.536926,
            "latitude": 55.91534
        },
        "10424": {
            "name": "Октябрьский",
            "population": 208,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.547699,
            "latitude": 55.308846
        },
        "10425": {
            "name": "Баянда",
            "population": 264,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.56501,
            "latitude": 55.994942
        },
        "10426": {
            "name": "Окраина",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.566833,
            "latitude": 55.939053
        },
        "10427": {
            "name": "Орик",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.568848,
            "latitude": 54.313023
        },
        "10428": {
            "name": "Бородинск",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.572952,
            "latitude": 54.359295
        },
        "10429": {
            "name": "Мироново",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.5881406,
            "latitude": 56.0663941
        },
        "10430": {
            "name": "Ут",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.683655,
            "latitude": 54.274632
        },
        "10431": {
            "name": "Унгудул",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.689453,
            "latitude": 54.303593
        },
        "10432": {
            "name": "Юрты Карагозские",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.7,
            "latitude": 53.333333
        },
        "10433": {
            "name": "Кадуй",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.708717,
            "latitude": 54.777901
        },
        "10434": {
            "name": "Тарея",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.719086,
            "latitude": 55.869652
        },
        "10435": {
            "name": "Талый Ключ",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.72683,
            "latitude": 54.627491
        },
        "10436": {
            "name": "Кулиш",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.737823,
            "latitude": 55.841419
        },
        "10437": {
            "name": "Галдун",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.801567,
            "latitude": 54.213516
        },
        "10438": {
            "name": "Миллерова",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.814293,
            "latitude": 54.372585
        },
        "10439": {
            "name": "Захаровка",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.833992,
            "latitude": 56.152042
        },
        "10440": {
            "name": "Большой Одер",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.835632,
            "latitude": 54.261604
        },
        "10441": {
            "name": "Марга",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.844017,
            "latitude": 54.599422
        },
        "10442": {
            "name": "Гарбакарай",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.871368,
            "latitude": 54.160454
        },
        "10443": {
            "name": "Виленск",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.889809,
            "latitude": 54.547966
        },
        "10444": {
            "name": "Большеверстовск",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.898636,
            "latitude": 54.693539
        },
        "10445": {
            "name": "Елань",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.91938,
            "latitude": 56.184799
        },
        "10446": {
            "name": "Верхний Бурбук",
            "population": 89,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.922409,
            "latitude": 54.32098
        },
        "10447": {
            "name": "Варяг",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.975555,
            "latitude": 54.638256
        },
        "10448": {
            "name": "Чукша",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.050964,
            "latitude": 56.131393
        },
        "10449": {
            "name": "Килим",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.051834,
            "latitude": 54.700779
        },
        "10450": {
            "name": "Аверьяновка",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.075195,
            "latitude": 54.568951
        },
        "10451": {
            "name": "Южный Кадуй",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.082527,
            "latitude": 54.664642
        },
        "10452": {
            "name": "Северный Кадуй",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.095871,
            "latitude": 54.672676
        },
        "10453": {
            "name": "Икейский",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.100136,
            "latitude": 54.205296
        },
        "10454": {
            "name": "Ключевой",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.166466,
            "latitude": 54.601017
        },
        "10455": {
            "name": "Хараманут",
            "population": 268,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.193466,
            "latitude": 54.493889
        },
        "10456": {
            "name": "Харантей",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.21312,
            "latitude": 54.169605
        },
        "10457": {
            "name": "Трактово-Курзан",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.213501,
            "latitude": 54.613617
        },
        "10458": {
            "name": "Вознесенск",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.246887,
            "latitude": 54.193176
        },
        "10459": {
            "name": "Александровка",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.382164,
            "latitude": 54.478458
        },
        "10460": {
            "name": "Петровск",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.400932,
            "latitude": 54.365112
        },
        "10461": {
            "name": "Талхан",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.421967,
            "latitude": 54.240234
        },
        "10462": {
            "name": "Малый Утайчик",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.423386,
            "latitude": 54.638378
        },
        "10463": {
            "name": "Тарея",
            "population": 51,
            "type": "hamlet",
            "poly": [
                [
                    100.4199574,
                    56.2457113
                ],
                [
                    100.4204724,
                    56.2468559
                ],
                [
                    100.4206441,
                    56.2480004
                ],
                [
                    100.4209874,
                    56.2490495
                ],
                [
                    100.4218457,
                    56.2499078
                ],
                [
                    100.422704,
                    56.2509569
                ],
                [
                    100.4233907,
                    56.2516245
                ],
                [
                    100.423734,
                    56.2521966
                ],
                [
                    100.4247639,
                    56.2530549
                ],
                [
                    100.4263089,
                    56.2534364
                ],
                [
                    100.4281972,
                    56.2532456
                ],
                [
                    100.4290555,
                    56.2526735
                ],
                [
                    100.4309438,
                    56.252292
                ],
                [
                    100.4324886,
                    56.2521966
                ],
                [
                    100.434377,
                    56.2514337
                ],
                [
                    100.4362653,
                    56.2514337
                ],
                [
                    100.4378102,
                    56.2510523
                ],
                [
                    100.4390118,
                    56.2519106
                ],
                [
                    100.4402135,
                    56.2521966
                ],
                [
                    100.4410718,
                    56.2527688
                ],
                [
                    100.4410718,
                    56.2535317
                ],
                [
                    100.4422734,
                    56.2534364
                ],
                [
                    100.4433034,
                    56.2532456
                ],
                [
                    100.4448483,
                    56.2529596
                ],
                [
                    100.44605,
                    56.2526735
                ],
                [
                    100.4470799,
                    56.2521013
                ],
                [
                    100.4479382,
                    56.2511476
                ],
                [
                    100.4491399,
                    56.2516245
                ],
                [
                    100.4484532,
                    56.2521966
                ],
                [
                    100.4477666,
                    56.2527688
                ],
                [
                    100.4470799,
                    56.2532456
                ],
                [
                    100.4481099,
                    56.2538178
                ],
                [
                    100.4494832,
                    56.2541039
                ],
                [
                    100.4511998,
                    56.2539132
                ],
                [
                    100.4527447,
                    56.2538178
                ],
                [
                    100.4537747,
                    56.2535317
                ],
                [
                    100.4537747,
                    56.2531503
                ],
                [
                    100.4537747,
                    56.2525781
                ],
                [
                    100.4536031,
                    56.2516245
                ],
                [
                    100.4522298,
                    56.2513384
                ],
                [
                    100.4273389,
                    56.245139
                ],
                [
                    100.4245923,
                    56.2444713
                ],
                [
                    100.4233907,
                    56.2444713
                ],
                [
                    100.422189,
                    56.2441852
                ],
                [
                    100.4203007,
                    56.2448529
                ],
                [
                    100.4199574,
                    56.2457113
                ]
            ],
            "longitude": 100.4299138,
            "latitude": 56.248668
        },
        "10464": {
            "name": "Ингут",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.435081,
            "latitude": 54.177273
        },
        "10465": {
            "name": "Одон",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.482246,
            "latitude": 54.186092
        },
        "10466": {
            "name": "Луговой",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.486504,
            "latitude": 55.251637
        },
        "10467": {
            "name": "Новая Деревня",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.505623,
            "latitude": 54.561401
        },
        "10468": {
            "name": "Заусаева",
            "population": 248,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.514862,
            "latitude": 54.630154
        },
        "10469": {
            "name": "Карай",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.524841,
            "latitude": 55.195087
        },
        "10470": {
            "name": "Верхний Манут",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.543335,
            "latitude": 54.446026
        },
        "10471": {
            "name": "Казакова",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.549194,
            "latitude": 54.518162
        },
        "10472": {
            "name": "Павловка",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.555244,
            "latitude": 54.845585
        },
        "10473": {
            "name": "Кривуша",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.577019,
            "latitude": 54.086033
        },
        "10474": {
            "name": "Ангуй",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.581528,
            "latitude": 54.939884
        },
        "10475": {
            "name": "Ангуйский",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.586311,
            "latitude": 54.927391
        },
        "10476": {
            "name": "Чистяково",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.599152,
            "latitude": 55.112038
        },
        "10477": {
            "name": "Забор",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.62648,
            "latitude": 54.36401
        },
        "10478": {
            "name": "Евдокимовский",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.665489,
            "latitude": 54.247047
        },
        "10479": {
            "name": "Красноозёрский",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.6838,
            "latitude": 54.242184
        },
        "10480": {
            "name": "Ниргит",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.689575,
            "latitude": 54.828915
        },
        "10481": {
            "name": "Красный Октябрь",
            "population": 183,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.699005,
            "latitude": 54.3437
        },
        "10482": {
            "name": "Андреевка",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.702904,
            "latitude": 54.735641
        },
        "10483": {
            "name": "Александровка",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.707039,
            "latitude": 54.791859
        },
        "10484": {
            "name": "Иннокентьевский",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.724411,
            "latitude": 54.598717
        },
        "10485": {
            "name": "Буслайка Ангуйская",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.744629,
            "latitude": 54.940365
        },
        "10486": {
            "name": "Нюра",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.765305,
            "latitude": 54.539886
        },
        "10487": {
            "name": "Азей",
            "population": 121,
            "type": "hamlet",
            "poly": [
                [
                    100.778702,
                    54.455624
                ],
                [
                    100.788742,
                    54.458969
                ],
                [
                    100.801788,
                    54.446785
                ],
                [
                    100.79364,
                    54.443008
                ],
                [
                    100.778702,
                    54.455624
                ]
            ],
            "longitude": 100.790657,
            "latitude": 54.451416
        },
        "10488": {
            "name": "Ковинский",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.864021,
            "latitude": 56.980762
        },
        "10489": {
            "name": "Булак",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.88662,
            "latitude": 55.103394
        },
        "10490": {
            "name": "Октябрьский-1",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.908539,
            "latitude": 54.83902
        },
        "10491": {
            "name": "Уталай",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.908562,
            "latitude": 54.338737
        },
        "10492": {
            "name": "Паберега",
            "population": 250,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.925003,
            "latitude": 54.840668
        },
        "10493": {
            "name": "Воробьёво",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    100.9584137,
                    55.4262445
                ],
                [
                    100.9585853,
                    55.4272186
                ],
                [
                    100.9597869,
                    55.4277056
                ],
                [
                    100.9615036,
                    55.4277056
                ],
                [
                    100.9633918,
                    55.4286797
                ],
                [
                    100.9645935,
                    55.4291667
                ],
                [
                    100.9651084,
                    55.4286797
                ],
                [
                    100.9640785,
                    55.4278031
                ],
                [
                    100.9654518,
                    55.4272186
                ],
                [
                    100.9671684,
                    55.4269264
                ],
                [
                    100.967855,
                    55.427316
                ],
                [
                    100.9692283,
                    55.4272186
                ],
                [
                    100.9692283,
                    55.4265367
                ],
                [
                    100.9700866,
                    55.4255626
                ],
                [
                    100.9712883,
                    55.4247833
                ],
                [
                    100.9726615,
                    55.424491
                ],
                [
                    100.9712883,
                    55.4239065
                ],
                [
                    100.9700866,
                    55.4230298
                ],
                [
                    100.9697433,
                    55.4224452
                ],
                [
                    100.968885,
                    55.4217633
                ],
                [
                    100.967855,
                    55.4205942
                ],
                [
                    100.967855,
                    55.4199122
                ],
                [
                    100.9697433,
                    55.4193276
                ],
                [
                    100.9716316,
                    55.4195225
                ],
                [
                    100.9736915,
                    55.4193276
                ],
                [
                    100.9755798,
                    55.4189379
                ],
                [
                    100.9755798,
                    55.4183533
                ],
                [
                    100.9740348,
                    55.4179636
                ],
                [
                    100.9726615,
                    55.4177687
                ],
                [
                    100.9709449,
                    55.4175739
                ],
                [
                    100.9695716,
                    55.4172816
                ],
                [
                    100.9673399,
                    55.4172816
                ],
                [
                    100.965795,
                    55.4170867
                ],
                [
                    100.965795,
                    55.4182559
                ],
                [
                    100.965795,
                    55.4196199
                ],
                [
                    100.9649368,
                    55.4205942
                ],
                [
                    100.9640785,
                    55.4211787
                ],
                [
                    100.9632202,
                    55.4217633
                ],
                [
                    100.9620185,
                    55.4223478
                ],
                [
                    100.9615036,
                    55.4231272
                ],
                [
                    100.9609885,
                    55.4241014
                ],
                [
                    100.9597869,
                    55.4249781
                ],
                [
                    100.958757,
                    55.42566
                ],
                [
                    100.9584137,
                    55.4262445
                ]
            ],
            "longitude": 100.962708,
            "latitude": 55.424686
        },
        "10494": {
            "name": "Боробино",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.976776,
            "latitude": 54.882648
        },
        "10495": {
            "name": "Харгажин",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.99794,
            "latitude": 54.285519
        },
        "10496": {
            "name": "Зарбь",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.035347,
            "latitude": 55.446613
        },
        "10497": {
            "name": "Новотроицк",
            "population": 227,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.049141,
            "latitude": 54.456211
        },
        "10498": {
            "name": "Трактовая",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.060585,
            "latitude": 54.483204
        },
        "10499": {
            "name": "Таган",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.152267,
            "latitude": 54.296242
        },
        "10500": {
            "name": "Бада",
            "population": 239,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.153107,
            "latitude": 55.39954
        },
        "10501": {
            "name": "Широкие Кочки",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.174149,
            "latitude": 54.527527
        },
        "10502": {
            "name": "Левый Сарам",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.182594,
            "latitude": 53.341228
        },
        "10503": {
            "name": "Правый Сарам",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.198044,
            "latitude": 53.3307435
        },
        "10504": {
            "name": "Малой",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.2001388,
            "latitude": 54.5953908
        },
        "10505": {
            "name": "Каранцай",
            "population": 266,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.225937,
            "latitude": 54.133457
        },
        "10506": {
            "name": "Майский",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.240677,
            "latitude": 54.526031
        },
        "10507": {
            "name": "Бахвалово",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.2711068,
            "latitude": 53.3825503
        },
        "10508": {
            "name": "Александро-Невский Завод",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.280388,
            "latitude": 54.571571
        },
        "10509": {
            "name": "Александро-Невская Станица",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.285957,
            "latitude": 54.293442
        },
        "10510": {
            "name": "Придорожный",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.294266,
            "latitude": 56.69463
        },
        "10511": {
            "name": "Мингатуй",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.3011589,
            "latitude": 54.4329589
        },
        "10512": {
            "name": "Хахарей",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.316368,
            "latitude": 55.254723
        },
        "10513": {
            "name": "Тобино",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.320404,
            "latitude": 54.454689
        },
        "10514": {
            "name": "Верхнеокинский",
            "population": 239,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.322006,
            "latitude": 53.465218
        },
        "10515": {
            "name": "3-я Станица",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.3377606,
            "latitude": 54.2113228
        },
        "10516": {
            "name": "Ивановский",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.3647326,
            "latitude": 53.9592983
        },
        "10517": {
            "name": "Еланский",
            "population": 219,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.367355,
            "latitude": 54.349987
        },
        "10518": {
            "name": "Участок Междугранки",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.3702792,
            "latitude": 53.8572881
        },
        "10519": {
            "name": "Или",
            "population": 143,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.372971,
            "latitude": 54.171131
        },
        "10520": {
            "name": "Малая Кочерма",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.381607,
            "latitude": 54.502792
        },
        "10521": {
            "name": "Новокадинский",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.395744,
            "latitude": 54.76125
        },
        "10522": {
            "name": "Верхний Щельбей",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.403282,
            "latitude": 53.706738
        },
        "10523": {
            "name": "Таёжный",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.4135243,
            "latitude": 53.3414052
        },
        "10524": {
            "name": "Полтава",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.415695,
            "latitude": 54.093952
        },
        "10525": {
            "name": "Апраксина",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.420685,
            "latitude": 54.101894
        },
        "10526": {
            "name": "Урункуй",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.445625,
            "latitude": 53.953472
        },
        "10527": {
            "name": "Меньчукова",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.452621,
            "latitude": 54.046192
        },
        "10528": {
            "name": "Ромоданова",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.472382,
            "latitude": 54.056156
        },
        "10529": {
            "name": "Сулкет",
            "population": 211,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.475433,
            "latitude": 54.44239
        },
        "10530": {
            "name": "Броды",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.501877,
            "latitude": 54.613197
        },
        "10531": {
            "name": "Аршан",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.503944,
            "latitude": 54.195034
        },
        "10532": {
            "name": "Новые Броды",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.514984,
            "latitude": 54.700153
        },
        "10533": {
            "name": "Анчирикова",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.515022,
            "latitude": 56.468918
        },
        "10534": {
            "name": "Боровое",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.521263,
            "latitude": 54.033924
        },
        "10535": {
            "name": "Ханхатуй",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.526291,
            "latitude": 54.127464
        },
        "10536": {
            "name": "Хор-Бутырина",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.528381,
            "latitude": 53.342407
        },
        "10537": {
            "name": "Новоникольск",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.530396,
            "latitude": 53.765518
        },
        "10538": {
            "name": "Бузулук",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.549126,
            "latitude": 54.667225
        },
        "10539": {
            "name": "Ахтинский",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.554955,
            "latitude": 54.238392
        },
        "10540": {
            "name": "Осиповский",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.556244,
            "latitude": 53.520653
        },
        "10541": {
            "name": "Черемшанка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.575195,
            "latitude": 55.654045
        },
        "10542": {
            "name": "Харагун",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.575935,
            "latitude": 53.352978
        },
        "10543": {
            "name": "Окинские Сачки",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.597336,
            "latitude": 53.481647
        },
        "10544": {
            "name": "Ключи",
            "population": 208,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.603363,
            "latitude": 54.405045
        },
        "10545": {
            "name": "Игнай",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.620148,
            "latitude": 53.792133
        },
        "10546": {
            "name": "1-й Успенский",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.6380905,
            "latitude": 53.6119385
        },
        "10547": {
            "name": "Тихорут",
            "population": 136,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.646721,
            "latitude": 54.146709
        },
        "10548": {
            "name": "Братская Елань",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.6665484,
            "latitude": 55.9588386
        },
        "10549": {
            "name": "Среднепихтинский",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.6730504,
            "latitude": 53.3815548
        },
        "10550": {
            "name": "Дагник",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.673529,
            "latitude": 53.354412
        },
        "10551": {
            "name": "Шарагул-Сачки",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.675972,
            "latitude": 53.432133
        },
        "10552": {
            "name": "Окинский",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.687538,
            "latitude": 54.617882
        },
        "10553": {
            "name": "Стибутовский",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.689461,
            "latitude": 53.863331
        },
        "10554": {
            "name": "3-й Успенский",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.691279,
            "latitude": 53.6443198
        },
        "10555": {
            "name": "Пихтинский",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.7005,
            "latitude": 53.399895
        },
        "10556": {
            "name": "Листвянка",
            "population": 158,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.739296,
            "latitude": 54.235649
        },
        "10557": {
            "name": "Новометелкина",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.743912,
            "latitude": 53.312866
        },
        "10558": {
            "name": "Сологубово",
            "population": 150,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.753662,
            "latitude": 53.811142
        },
        "10559": {
            "name": "Хаихта",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.763046,
            "latitude": 54.3494
        },
        "10560": {
            "name": "Верхняя Зима",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.781921,
            "latitude": 53.797085
        },
        "10561": {
            "name": "Октябрьский",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.783661,
            "latitude": 54.093563
        },
        "10562": {
            "name": "Дубынино",
            "population": 256,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.79187,
            "latitude": 56.608471
        },
        "10563": {
            "name": "Городок",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.7993119,
            "latitude": 52.9871371
        },
        "10564": {
            "name": "Степной",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.822083,
            "latitude": 54.189667
        },
        "10565": {
            "name": "Первое Мая",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.8234096,
            "latitude": 53.5597567
        },
        "10566": {
            "name": "Сосновский",
            "population": 174,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.824966,
            "latitude": 54.279831
        },
        "10567": {
            "name": "Кимильтей",
            "population": 156,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.8422936,
            "latitude": 54.1360273
        },
        "10568": {
            "name": "Чернушка 1-я",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.845268,
            "latitude": 52.971775
        },
        "10569": {
            "name": "Харчев",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.86969,
            "latitude": 54.227409
        },
        "10570": {
            "name": "Феофановский",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.8722624,
            "latitude": 54.1288524
        },
        "10571": {
            "name": "Березовский",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.876732,
            "latitude": 54.402893
        },
        "10572": {
            "name": "Исаковка",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.877159,
            "latitude": 53.303047
        },
        "10573": {
            "name": "Чернушка 2-я",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.897408,
            "latitude": 52.967487
        },
        "10574": {
            "name": "Трактовый",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.901108,
            "latitude": 53.872238
        },
        "10575": {
            "name": "Мостовка",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.9425223,
            "latitude": 53.4064493
        },
        "10576": {
            "name": "Зобинский",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.951706,
            "latitude": 54.94186
        },
        "10577": {
            "name": "Инга",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.95668,
            "latitude": 52.971191
        },
        "10578": {
            "name": "Верхний",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.9571202,
            "latitude": 53.4588115
        },
        "10579": {
            "name": "Благодатный",
            "population": 196,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.9623418,
            "latitude": 53.5049407
        },
        "10580": {
            "name": "Перевоз",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.9630506,
            "latitude": 54.0402574
        },
        "10581": {
            "name": "Нижний Хазан",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.964157,
            "latitude": 53.837257
        },
        "10582": {
            "name": "Кустова",
            "population": 64,
            "type": "hamlet",
            "poly": [
                [
                    101.9821435,
                    53.8616277
                ],
                [
                    101.9838172,
                    53.8620453
                ],
                [
                    101.985169,
                    53.862716
                ],
                [
                    101.9867569,
                    53.8626527
                ],
                [
                    101.9882375,
                    53.8617669
                ],
                [
                    101.9908553,
                    53.8604129
                ],
                [
                    101.9947177,
                    53.8583375
                ],
                [
                    101.9949108,
                    53.8569074
                ],
                [
                    101.992572,
                    53.8560847
                ],
                [
                    101.9880015,
                    53.8588184
                ],
                [
                    101.9848042,
                    53.8598687
                ],
                [
                    101.9829589,
                    53.8608178
                ],
                [
                    101.9821435,
                    53.8616277
                ]
            ],
            "longitude": 101.98774,
            "latitude": 53.860069
        },
        "10583": {
            "name": "Челяба",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.990804,
            "latitude": 53.9575485
        },
        "10584": {
            "name": "Новая Када",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.996002,
            "latitude": 54.518814
        },
        "10585": {
            "name": "Полковникова",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.00071,
            "latitude": 53.847881
        },
        "10586": {
            "name": "Муруй",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.015732,
            "latitude": 53.345314
        },
        "10587": {
            "name": "Дмитриевка",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.039162,
            "latitude": 53.382992
        },
        "10588": {
            "name": "Березкина",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.043983,
            "latitude": 53.528061
        },
        "10589": {
            "name": "Заваль",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.052055,
            "latitude": 54.685749
        },
        "10590": {
            "name": "Подъвыездный",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.053894,
            "latitude": 56.29422
        },
        "10591": {
            "name": "Чаданова",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.053947,
            "latitude": 53.367447
        },
        "10592": {
            "name": "Щербакова",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.057526,
            "latitude": 53.412792
        },
        "10593": {
            "name": "Ургантуй",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.081184,
            "latitude": 52.750591
        },
        "10594": {
            "name": "Подгорная",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.090225,
            "latitude": 54.002068
        },
        "10595": {
            "name": "Заблагар",
            "population": 253,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.109741,
            "latitude": 53.436672
        },
        "10596": {
            "name": "Ока 2-я",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.1154258,
            "latitude": 53.8791218
        },
        "10597": {
            "name": "Халты",
            "population": 201,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.1262252,
            "latitude": 53.3470711
        },
        "10598": {
            "name": "Мариинск",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.127197,
            "latitude": 53.259811
        },
        "10599": {
            "name": "Жизневка",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.132164,
            "latitude": 53.306511
        },
        "10600": {
            "name": "Первомайский",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    102.127186,
                    55.6885231
                ],
                [
                    102.1311343,
                    55.6941351
                ],
                [
                    102.1373141,
                    55.6943286
                ],
                [
                    102.1421206,
                    55.695683
                ],
                [
                    102.1481287,
                    55.6931675
                ],
                [
                    102.1448671,
                    55.6907487
                ],
                [
                    102.1467554,
                    55.6867814
                ],
                [
                    102.1367991,
                    55.6848459
                ],
                [
                    102.127186,
                    55.6885231
                ]
            ],
            "longitude": 102.137146,
            "latitude": 55.690174
        },
        "10601": {
            "name": "Буринская дача",
            "population": 250,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.137772,
            "latitude": 54.068336
        },
        "10602": {
            "name": "Николаевский",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.1428199,
            "latitude": 53.6331203
        },
        "10603": {
            "name": "Нагишкина",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.143623,
            "latitude": 53.816269
        },
        "10604": {
            "name": "Нижнечиркина",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.14463,
            "latitude": 53.901035
        },
        "10605": {
            "name": "Замазчикова",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.144768,
            "latitude": 53.482235
        },
        "10606": {
            "name": "Хандагай",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.148262,
            "latitude": 53.133171
        },
        "10607": {
            "name": "Кирхай",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.1488595,
            "latitude": 53.3399307
        },
        "10608": {
            "name": "Шабалина",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.159348,
            "latitude": 53.515007
        },
        "10609": {
            "name": "Мягчинский",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.1720467,
            "latitude": 53.3172386
        },
        "10610": {
            "name": "Высотская",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.187126,
            "latitude": 53.277512
        },
        "10611": {
            "name": "Мардай",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.189781,
            "latitude": 53.302574
        },
        "10612": {
            "name": "Кундулун",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.199982,
            "latitude": 54.315151
        },
        "10613": {
            "name": "Индон",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.2141405,
            "latitude": 53.0696366
        },
        "10614": {
            "name": "Мольта",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.232864,
            "latitude": 54.081158
        },
        "10615": {
            "name": "Щеглаева",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.2342522,
            "latitude": 53.735637
        },
        "10616": {
            "name": "Октябрьск",
            "population": 165,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.244614,
            "latitude": 55.262569
        },
        "10617": {
            "name": "Делюр",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.244835,
            "latitude": 53.750965
        },
        "10618": {
            "name": "Чухлинская",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.2472,
            "latitude": 53.268372
        },
        "10619": {
            "name": "Пашенный",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.252579,
            "latitude": 56.44001
        },
        "10620": {
            "name": "Красный Брод",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.254097,
            "latitude": 53.061203
        },
        "10621": {
            "name": "Глинки",
            "population": 268,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.257591,
            "latitude": 53.859516
        },
        "10622": {
            "name": "Халты",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.258507,
            "latitude": 53.262123
        },
        "10623": {
            "name": "Черемшанка",
            "population": 256,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.265625,
            "latitude": 54.209644
        },
        "10624": {
            "name": "Каратаева",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.267998,
            "latitude": 53.350101
        },
        "10625": {
            "name": "Большерастягаевский",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.275917,
            "latitude": 53.899078
        },
        "10626": {
            "name": "Мандагай",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.289268,
            "latitude": 52.969288
        },
        "10627": {
            "name": "Елоты",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.292549,
            "latitude": 52.95433
        },
        "10628": {
            "name": "Баталаева",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.295631,
            "latitude": 53.032677
        },
        "10629": {
            "name": "Ключи",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.3001872,
            "latitude": 53.2314758
        },
        "10630": {
            "name": "Верхняя Иреть",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.307106,
            "latitude": 52.966759
        },
        "10631": {
            "name": "Полежаева",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.32579,
            "latitude": 52.967854
        },
        "10632": {
            "name": "Большелихачевский",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.326027,
            "latitude": 54.018089
        },
        "10633": {
            "name": "Жалгай",
            "population": 183,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.329163,
            "latitude": 53.137096
        },
        "10634": {
            "name": "Шалоты",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.3292941,
            "latitude": 53.1684328
        },
        "10635": {
            "name": "Бодорой",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.3314633,
            "latitude": 54.0834519
        },
        "10636": {
            "name": "Сенная Падь",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.331642,
            "latitude": 53.558926
        },
        "10637": {
            "name": "Труженик",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.333008,
            "latitude": 52.971378
        },
        "10638": {
            "name": "Мамуркова",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.337181,
            "latitude": 53.665199
        },
        "10639": {
            "name": "Романова",
            "population": 228,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.367905,
            "latitude": 53.511253
        },
        "10640": {
            "name": "Юлинск",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.385971,
            "latitude": 52.738857
        },
        "10641": {
            "name": "Мейеровка",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.4065591,
            "latitude": 53.7135889
        },
        "10642": {
            "name": "Киркей",
            "population": 191,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.4080579,
            "latitude": 53.2389399
        },
        "10643": {
            "name": "Халярты",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.409027,
            "latitude": 53.615215
        },
        "10644": {
            "name": "Большой Карлук",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.413826,
            "latitude": 53.484398
        },
        "10645": {
            "name": "Вершина",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.418365,
            "latitude": 53.29903
        },
        "10646": {
            "name": "Невидимова",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.4226159,
            "latitude": 52.9848335
        },
        "10647": {
            "name": "Куркат",
            "population": 143,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.425301,
            "latitude": 53.172375
        },
        "10648": {
            "name": "Бадарма",
            "population": 228,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.425644,
            "latitude": 57.753654
        },
        "10649": {
            "name": "Илганское",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.427956,
            "latitude": 53.557461
        },
        "10650": {
            "name": "Большеворонежский",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.443588,
            "latitude": 53.943573
        },
        "10651": {
            "name": "Холы",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.4437497,
            "latitude": 53.9288192
        },
        "10652": {
            "name": "Гусева",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.447746,
            "latitude": 52.9734079
        },
        "10653": {
            "name": "Хвойный",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.449493,
            "latitude": 55.266296
        },
        "10654": {
            "name": "Тунгусы",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.450188,
            "latitude": 52.788048
        },
        "10655": {
            "name": "Ленденева",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.453041,
            "latitude": 53.500443
        },
        "10656": {
            "name": "Завидная",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.4613593,
            "latitude": 53.2948859
        },
        "10657": {
            "name": "Корсунгай",
            "population": 150,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.468636,
            "latitude": 53.722786
        },
        "10658": {
            "name": "Московская",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.4752901,
            "latitude": 53.5586382
        },
        "10659": {
            "name": "Шастина",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.486549,
            "latitude": 53.356461
        },
        "10660": {
            "name": "Минеева",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.496414,
            "latitude": 53.509533
        },
        "10661": {
            "name": "Улзет",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.505318,
            "latitude": 53.110191
        },
        "10662": {
            "name": "Бухарова",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.510834,
            "latitude": 53.419163
        },
        "10663": {
            "name": "Кукунур",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.512939,
            "latitude": 53.184536
        },
        "10664": {
            "name": "Большебельск",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.519325,
            "latitude": 52.922215
        },
        "10665": {
            "name": "Шестакова",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.520546,
            "latitude": 52.962868
        },
        "10666": {
            "name": "Паточный",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.521133,
            "latitude": 52.958202
        },
        "10667": {
            "name": "Готол",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.536591,
            "latitude": 53.19035
        },
        "10668": {
            "name": "Ремезовский",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.5402771,
            "latitude": 53.3948932
        },
        "10669": {
            "name": "Задоновская",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.54879,
            "latitude": 53.93734
        },
        "10670": {
            "name": "Побединская",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.561516,
            "latitude": 53.954311
        },
        "10671": {
            "name": "Красное Поле",
            "population": 237,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.567749,
            "latitude": 53.617596
        },
        "10672": {
            "name": "Анучинск",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.586273,
            "latitude": 54.055298
        },
        "10673": {
            "name": "Тунгуй",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.590042,
            "latitude": 53.570805
        },
        "10674": {
            "name": "Ункурлик",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.5901254,
            "latitude": 53.6516894
        },
        "10675": {
            "name": "Малолучинск",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.59391,
            "latitude": 53.214455
        },
        "10676": {
            "name": "Занина",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.6054167,
            "latitude": 53.422602
        },
        "10677": {
            "name": "Буркова",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.612799,
            "latitude": 53.0244649
        },
        "10678": {
            "name": "Ей",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.613876,
            "latitude": 53.826893
        },
        "10679": {
            "name": "Мото-Бодары",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.6195705,
            "latitude": 52.6427214
        },
        "10680": {
            "name": "Алзобей",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.6284284,
            "latitude": 53.1150989
        },
        "10681": {
            "name": "Наймодай",
            "population": 250,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.631668,
            "latitude": 53.66227
        },
        "10682": {
            "name": "Хотхор",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.636436,
            "latitude": 53.474728
        },
        "10683": {
            "name": "Заречное",
            "population": 234,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.6386252,
            "latitude": 53.1654039
        },
        "10684": {
            "name": "Шапшалтуй",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.639084,
            "latitude": 53.300816
        },
        "10685": {
            "name": "Васильевское",
            "population": 120,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.639709,
            "latitude": 53.893345
        },
        "10686": {
            "name": "Бажей",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.640823,
            "latitude": 52.974976
        },
        "10687": {
            "name": "Багантуй",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.643181,
            "latitude": 53.592407
        },
        "10688": {
            "name": "Горячий Ключ",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.64418,
            "latitude": 53.487434
        },
        "10689": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.6544278,
            "latitude": 53.7718287
        },
        "10690": {
            "name": "Головинское",
            "population": 268,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.6682441,
            "latitude": 53.4298862
        },
        "10691": {
            "name": "Хигинская",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.6793511,
            "latitude": 53.123151
        },
        "10692": {
            "name": "Дабады",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.688812,
            "latitude": 52.09409
        },
        "10693": {
            "name": "Угольная",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.708176,
            "latitude": 53.286957
        },
        "10694": {
            "name": "Белые Ключи",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.709946,
            "latitude": 52.540768
        },
        "10695": {
            "name": "Халта",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7113521,
            "latitude": 53.0512361
        },
        "10696": {
            "name": "Корховская",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7125753,
            "latitude": 53.3915663
        },
        "10697": {
            "name": "Шульгина",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7252098,
            "latitude": 53.3959043
        },
        "10698": {
            "name": "Средняя",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.732819,
            "latitude": 52.956364
        },
        "10699": {
            "name": "Новоселова",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.742096,
            "latitude": 53.582581
        },
        "10700": {
            "name": "Куйта",
            "population": 242,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7544912,
            "latitude": 53.1848093
        },
        "10701": {
            "name": "Иванова",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7555764,
            "latitude": 53.3209225
        },
        "10702": {
            "name": "Аршан",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7556953,
            "latitude": 53.138077
        },
        "10703": {
            "name": "Саган-Жалгай",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7589491,
            "latitude": 53.6056711
        },
        "10704": {
            "name": "Шелемина",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7607045,
            "latitude": 53.4380039
        },
        "10705": {
            "name": "Русская Аларь",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.769096,
            "latitude": 52.946625
        },
        "10706": {
            "name": "Малый Кутулик",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7768698,
            "latitude": 53.3947738
        },
        "10707": {
            "name": "Герасимова",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.783691,
            "latitude": 53.004093
        },
        "10708": {
            "name": "Омулёвка",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7883784,
            "latitude": 53.2566732
        },
        "10709": {
            "name": "Жернакова",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.792641,
            "latitude": 52.987511
        },
        "10710": {
            "name": "Тюмень",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.795113,
            "latitude": 52.936672
        },
        "10711": {
            "name": "Большая Ерма",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7966209,
            "latitude": 53.4475
        },
        "10712": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.7976099,
            "latitude": 53.7630564
        },
        "10713": {
            "name": "Нарены",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.79998,
            "latitude": 53.22863
        },
        "10714": {
            "name": "Поморцева",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.802681,
            "latitude": 52.818783
        },
        "10715": {
            "name": "Чичиковская",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.80574,
            "latitude": 53.589432
        },
        "10716": {
            "name": "Шаховская",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8075869,
            "latitude": 53.5261463
        },
        "10717": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8088967,
            "latitude": 53.780988
        },
        "10718": {
            "name": "Гавриловская",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.819336,
            "latitude": 52.979469
        },
        "10719": {
            "name": "Тушама",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.822609,
            "latitude": 58.326633
        },
        "10720": {
            "name": "Гымыль",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.824478,
            "latitude": 52.926414
        },
        "10721": {
            "name": "Макарьевская",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.828659,
            "latitude": 53.565823
        },
        "10722": {
            "name": "Маломолева",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8319419,
            "latitude": 53.4012274
        },
        "10723": {
            "name": "Малая Ленская",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.834732,
            "latitude": 52.984283
        },
        "10724": {
            "name": "Заярск",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.835823,
            "latitude": 56.192467
        },
        "10725": {
            "name": "Кирюшина",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8367477,
            "latitude": 53.4458165
        },
        "10726": {
            "name": "Хорьки",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.838196,
            "latitude": 53.033203
        },
        "10727": {
            "name": "Топка",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.838669,
            "latitude": 52.938568
        },
        "10728": {
            "name": "Приморский",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.83989,
            "latitude": 54.283966
        },
        "10729": {
            "name": "Могой",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8427769,
            "latitude": 53.382151
        },
        "10730": {
            "name": "Сарапулова",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.853935,
            "latitude": 53.001606
        },
        "10731": {
            "name": "Тютрина",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8588564,
            "latitude": 53.3506582
        },
        "10732": {
            "name": "Катом",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.860016,
            "latitude": 53.157703
        },
        "10733": {
            "name": "Тарбажи",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.875923,
            "latitude": 52.9772
        },
        "10734": {
            "name": "Берестенникова",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8768748,
            "latitude": 53.3002657
        },
        "10735": {
            "name": "Табук",
            "population": 221,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.880531,
            "latitude": 53.035736
        },
        "10736": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8805326,
            "latitude": 53.7111143
        },
        "10737": {
            "name": "Зунгар",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.883171,
            "latitude": 54.029808
        },
        "10738": {
            "name": "Нижняя Иреть",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.8994876,
            "latitude": 52.7234455
        },
        "10739": {
            "name": "Савинская",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.904686,
            "latitude": 52.957706
        },
        "10740": {
            "name": "Кирилловская",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.905342,
            "latitude": 53.510387
        },
        "10741": {
            "name": "Южный",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.913055,
            "latitude": 55.839672
        },
        "10742": {
            "name": "Тарасовск",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.914307,
            "latitude": 54.375881
        },
        "10743": {
            "name": "Исакова",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.916763,
            "latitude": 52.982544
        },
        "10744": {
            "name": "Сутупова",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.91861,
            "latitude": 52.962654
        },
        "10745": {
            "name": "Шаманаева",
            "population": 250,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.921967,
            "latitude": 53.173092
        },
        "10746": {
            "name": "Трактовая",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.925385,
            "latitude": 53.219044
        },
        "10747": {
            "name": "Хамхар",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.9304441,
            "latitude": 53.7336902
        },
        "10748": {
            "name": "Кирзавод",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.931175,
            "latitude": 53.224152
        },
        "10749": {
            "name": "Заходы",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.931877,
            "latitude": 53.839355
        },
        "10750": {
            "name": "Чернухина",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.941589,
            "latitude": 53.053169
        },
        "10751": {
            "name": "Забитуй",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.942337,
            "latitude": 53.158718
        },
        "10752": {
            "name": "Протасова",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.955574,
            "latitude": 53.00301
        },
        "10753": {
            "name": "Дута",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.9578754,
            "latitude": 53.4219308
        },
        "10754": {
            "name": "Мотова",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.9580742,
            "latitude": 52.8830909
        },
        "10755": {
            "name": "Одиса",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.9611183,
            "latitude": 54.0101933
        },
        "10756": {
            "name": "Манинск",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.965965,
            "latitude": 52.392372
        },
        "10757": {
            "name": "Кедровый",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.968613,
            "latitude": 57.413582
        },
        "10758": {
            "name": "Громова",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.972832,
            "latitude": 53.184383
        },
        "10759": {
            "name": "Белькова",
            "population": 169,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.975555,
            "latitude": 52.986816
        },
        "10760": {
            "name": "Хуруй",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.978493,
            "latitude": 53.377472
        },
        "10761": {
            "name": "Мутовка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.983368,
            "latitude": 52.782837
        },
        "10762": {
            "name": "Муратова",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.990509,
            "latitude": 53.214321
        },
        "10763": {
            "name": "Шалоты",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.991463,
            "latitude": 53.585693
        },
        "10764": {
            "name": "Искра",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.995285,
            "latitude": 53.035511
        },
        "10765": {
            "name": "Елань",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.014915,
            "latitude": 52.935112
        },
        "10766": {
            "name": "Ступина",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.0156931,
            "latitude": 53.1848944
        },
        "10767": {
            "name": "Лохова",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.024246,
            "latitude": 52.824799
        },
        "10768": {
            "name": "Степное",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.0255949,
            "latitude": 53.7870227
        },
        "10769": {
            "name": "Миндей 2",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.0357234,
            "latitude": 56.2079974
        },
        "10770": {
            "name": "Кербулак",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.039299,
            "latitude": 53.277264
        },
        "10771": {
            "name": "Михайловщина",
            "population": 237,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.039558,
            "latitude": 54.200684
        },
        "10772": {
            "name": "Саган-Жалгай",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.04567,
            "latitude": 53.52673
        },
        "10773": {
            "name": "Дружный",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.046529,
            "latitude": 53.8778291
        },
        "10774": {
            "name": "Ключи",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.050072,
            "latitude": 52.949631
        },
        "10775": {
            "name": "Мольта",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.0530177,
            "latitude": 53.3648886
        },
        "10776": {
            "name": "Миндей 1",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.057388,
            "latitude": 56.243103
        },
        "10777": {
            "name": "Комарова",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.060837,
            "latitude": 52.906158
        },
        "10778": {
            "name": "Ташлыкова",
            "population": 203,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.085503,
            "latitude": 53.892475
        },
        "10779": {
            "name": "Кундулун",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.0919382,
            "latitude": 53.2782277
        },
        "10780": {
            "name": "Жлобина",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.092422,
            "latitude": 53.504257
        },
        "10781": {
            "name": "Аргалей",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.0989326,
            "latitude": 53.4283177
        },
        "10782": {
            "name": "Средний Булай",
            "population": 233,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.123451,
            "latitude": 52.970848
        },
        "10783": {
            "name": "Заморская",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.156204,
            "latitude": 53.004105
        },
        "10784": {
            "name": "Паршевникова",
            "population": 267,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.157738,
            "latitude": 53.036182
        },
        "10785": {
            "name": "Шубина",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.190056,
            "latitude": 53.231365
        },
        "10786": {
            "name": "Старый Кутугун",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.190552,
            "latitude": 53.255249
        },
        "10787": {
            "name": "Большая Черемшанка",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.194969,
            "latitude": 52.425785
        },
        "10788": {
            "name": "Касьяновка",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.201721,
            "latitude": 53.041908
        },
        "10789": {
            "name": "Апхайта",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.2139413,
            "latitude": 53.4128624
        },
        "10790": {
            "name": "Чистый",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.214317,
            "latitude": 55.473217
        },
        "10791": {
            "name": "Ундэр-Хуан",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.214516,
            "latitude": 53.464535
        },
        "10792": {
            "name": "Арансахой",
            "population": 95,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.215714,
            "latitude": 52.631859
        },
        "10793": {
            "name": "Ходарей",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.217575,
            "latitude": 52.260616
        },
        "10794": {
            "name": "Витух",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.218407,
            "latitude": 52.996758
        },
        "10795": {
            "name": "Балухарь",
            "population": 162,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.251099,
            "latitude": 53.239262
        },
        "10796": {
            "name": "Зангей",
            "population": 268,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.2744542,
            "latitude": 53.3930658
        },
        "10797": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.2814732,
            "latitude": 53.4454139
        },
        "10798": {
            "name": "Глубокий Лог",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.287773,
            "latitude": 52.9023183
        },
        "10799": {
            "name": "Поздеева",
            "population": 230,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.288826,
            "latitude": 53.197159
        },
        "10800": {
            "name": "Карда",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.292587,
            "latitude": 54.997169
        },
        "10801": {
            "name": "Субботина",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.297997,
            "latitude": 52.94508
        },
        "10802": {
            "name": "Чемодариха",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.299683,
            "latitude": 53.146633
        },
        "10803": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.2997269,
            "latitude": 52.71861
        },
        "10804": {
            "name": "Балтуй",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.3187554,
            "latitude": 53.3231837
        },
        "10805": {
            "name": "Борисова",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.323654,
            "latitude": 52.440147
        },
        "10806": {
            "name": "Быково",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.324142,
            "latitude": 53.504524
        },
        "10807": {
            "name": "Молочное",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.344666,
            "latitude": 53.05405
        },
        "10808": {
            "name": "Сохатый",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.345078,
            "latitude": 56.428856
        },
        "10809": {
            "name": "Бархатова",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.35289,
            "latitude": 53.007992
        },
        "10810": {
            "name": "Махонькина",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.390718,
            "latitude": 53.084347
        },
        "10811": {
            "name": "Халюты",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.392502,
            "latitude": 53.835644
        },
        "10812": {
            "name": "Калашникова",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.4015337,
            "latitude": 53.0773597
        },
        "10813": {
            "name": "Угольная",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.405098,
            "latitude": 53.217884
        },
        "10814": {
            "name": "Ясачная Хайрюзовка",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.415581,
            "latitude": 53.844574
        },
        "10815": {
            "name": "Белогорск",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.425163,
            "latitude": 52.841877
        },
        "10816": {
            "name": "Тушама",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.4313461,
            "latitude": 57.5791324
        },
        "10817": {
            "name": "Ершовка",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.436066,
            "latitude": 52.701618
        },
        "10818": {
            "name": "Склянка",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.438248,
            "latitude": 53.154816
        },
        "10819": {
            "name": "Саннолыжный",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.440292,
            "latitude": 52.717453
        },
        "10820": {
            "name": "Долганова",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.444115,
            "latitude": 53.797272
        },
        "10821": {
            "name": "Грязная",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.451515,
            "latitude": 53.034412
        },
        "10822": {
            "name": "Озёрный",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.456604,
            "latitude": 52.713291
        },
        "10823": {
            "name": "Сапиновка",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.470337,
            "latitude": 52.660225
        },
        "10824": {
            "name": "Макаровская",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.470833,
            "latitude": 53.19244
        },
        "10825": {
            "name": "Черниговская",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.472206,
            "latitude": 53.28381
        },
        "10826": {
            "name": "Баранова",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.474197,
            "latitude": 53.700699
        },
        "10827": {
            "name": "Донская",
            "population": 127,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.476006,
            "latitude": 53.407673
        },
        "10828": {
            "name": "Мутинова",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.49205,
            "latitude": 53.38414
        },
        "10829": {
            "name": "Вантеевская",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.4928324,
            "latitude": 53.2001298
        },
        "10830": {
            "name": "Степной",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.4955852,
            "latitude": 52.8932557
        },
        "10831": {
            "name": "Байханова",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.499641,
            "latitude": 53.262943
        },
        "10832": {
            "name": "Гречехан",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.5006824,
            "latitude": 53.1414642
        },
        "10833": {
            "name": "Картыгей",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.510094,
            "latitude": 53.438709
        },
        "10834": {
            "name": "Якимовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.510948,
            "latitude": 52.397514
        },
        "10835": {
            "name": "Тыргур",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.512711,
            "latitude": 53.12114
        },
        "10836": {
            "name": "Крюкова",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.520866,
            "latitude": 53.322071
        },
        "10837": {
            "name": "Чебогоры",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.523926,
            "latitude": 52.413273
        },
        "10838": {
            "name": "Быргазова",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.533302,
            "latitude": 53.043262
        },
        "10839": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.5367206,
            "latitude": 53.681635
        },
        "10840": {
            "name": "Тагай",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.5381293,
            "latitude": 53.7238467
        },
        "10841": {
            "name": "Пашкова",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.5426662,
            "latitude": 53.1902399
        },
        "10842": {
            "name": "Ягаты",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.542801,
            "latitude": 52.246979
        },
        "10843": {
            "name": "Ершова",
            "population": 69,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.54496,
            "latitude": 53.337616
        },
        "10844": {
            "name": "Целоты",
            "population": 243,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.546547,
            "latitude": 52.479012
        },
        "10845": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.5517141,
            "latitude": 53.6722167
        },
        "10846": {
            "name": "Шарагун",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.56179,
            "latitude": 53.067135
        },
        "10847": {
            "name": "Логанова",
            "population": 178,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.563957,
            "latitude": 53.289295
        },
        "10848": {
            "name": "Ключевая",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.572968,
            "latitude": 52.587139
        },
        "10849": {
            "name": "Батхай",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.5790431,
            "latitude": 53.725784
        },
        "10850": {
            "name": "Буреть",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.5828659,
            "latitude": 53.0250481
        },
        "10851": {
            "name": "Кулакова",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.585434,
            "latitude": 52.973942
        },
        "10852": {
            "name": "Тымырей",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.609146,
            "latitude": 53.287788
        },
        "10853": {
            "name": "Бадай",
            "population": 258,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.610146,
            "latitude": 52.876877
        },
        "10854": {
            "name": "Улей",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.6134776,
            "latitude": 53.6004512
        },
        "10855": {
            "name": "Карантин",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.6167459,
            "latitude": 51.7413365
        },
        "10856": {
            "name": "Архиереевка",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.626183,
            "latitude": 52.455685
        },
        "10857": {
            "name": "Гречехан",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.628868,
            "latitude": 53.231853
        },
        "10858": {
            "name": "Низовцева",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.639999,
            "latitude": 52.505478
        },
        "10859": {
            "name": "Чёрная",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.641609,
            "latitude": 56.41468
        },
        "10860": {
            "name": "Звёздочка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.649178,
            "latitude": 52.349003
        },
        "10861": {
            "name": "Калиновка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.657791,
            "latitude": 52.472832
        },
        "10862": {
            "name": "Усть-Малой",
            "population": 235,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.661064,
            "latitude": 53.949001
        },
        "10863": {
            "name": "Вербный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.6693508,
            "latitude": 51.7147646
        },
        "10864": {
            "name": "Шипняговка",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.671181,
            "latitude": 52.98642
        },
        "10865": {
            "name": "Бурундуйский",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.671623,
            "latitude": 54.223129
        },
        "10866": {
            "name": "Новый Алендарь",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.672386,
            "latitude": 53.108624
        },
        "10867": {
            "name": "Новоясачная",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.675797,
            "latitude": 52.46032
        },
        "10868": {
            "name": "120 км",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.6777994,
            "latitude": 51.7089233
        },
        "10869": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.6911742,
            "latitude": 53.2614969
        },
        "10870": {
            "name": "Жданово",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.7021629,
            "latitude": 53.5456122
        },
        "10871": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.7060447,
            "latitude": 53.6312548
        },
        "10872": {
            "name": "Куйтун",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.713844,
            "latitude": 52.114933
        },
        "10873": {
            "name": "Тюменск",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.71521,
            "latitude": 52.616749
        },
        "10874": {
            "name": "Хайга",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.7264626,
            "latitude": 53.7001698
        },
        "10875": {
            "name": "Усолье-Жилкино",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.737366,
            "latitude": 52.735786
        },
        "10876": {
            "name": "Старая Ясачная",
            "population": 128,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.7396856,
            "latitude": 52.4871303
        },
        "10877": {
            "name": "Захаровская",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.746941,
            "latitude": 52.9678
        },
        "10878": {
            "name": "Моголют",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.1448346,
            "latitude": 53.3409445
        },
        "10879": {
            "name": "Хонзой",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.411407,
            "latitude": 53.228916
        },
        "10880": {
            "name": "Заглик",
            "population": 249,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.752129,
            "latitude": 53.173809
        },
        "10881": {
            "name": "Широкая",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.757973,
            "latitude": 51.728828
        },
        "10882": {
            "name": "Грехневка",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.766289,
            "latitude": 52.900745
        },
        "10883": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.7763209,
            "latitude": 53.3464357
        },
        "10884": {
            "name": "Абрамовка",
            "population": 245,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.7801871,
            "latitude": 53.3910577
        },
        "10885": {
            "name": "Ключи",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.784721,
            "latitude": 52.813622
        },
        "10886": {
            "name": "Херетин",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.798737,
            "latitude": 53.159729
        },
        "10887": {
            "name": "Китой",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.8013441,
            "latitude": 52.5278946
        },
        "10888": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.8051968,
            "latitude": 53.3720135
        },
        "10889": {
            "name": "Андрияновская",
            "population": 103,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.811142,
            "latitude": 51.800522
        },
        "10890": {
            "name": "Граматуха",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.813423,
            "latitude": 51.949066
        },
        "10891": {
            "name": "Буровщина",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.81356,
            "latitude": 51.623898
        },
        "10892": {
            "name": "Булак",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.815857,
            "latitude": 53.256596
        },
        "10893": {
            "name": "Шунта",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.820534,
            "latitude": 53.158108
        },
        "10894": {
            "name": "Ангасольская",
            "population": 18,
            "type": "hamlet",
            "poly": [
                [
                    103.8253226,
                    51.732041
                ],
                [
                    103.8262695,
                    51.7326452
                ],
                [
                    103.8307741,
                    51.7330183
                ],
                [
                    103.8331842,
                    51.7321476
                ],
                [
                    103.8314914,
                    51.7311703
                ],
                [
                    103.8271876,
                    51.7309037
                ],
                [
                    103.8253226,
                    51.732041
                ]
            ],
            "longitude": 103.828896,
            "latitude": 51.731991
        },
        "10895": {
            "name": "Большая Глубокая",
            "population": 28,
            "type": "hamlet",
            "poly": [
                [
                    103.8389777,
                    51.8903508
                ],
                [
                    103.8390107,
                    51.8927739
                ],
                [
                    103.841801,
                    51.8960245
                ],
                [
                    103.8444154,
                    51.8968828
                ],
                [
                    103.8484801,
                    51.8952784
                ],
                [
                    103.8508557,
                    51.8897399
                ],
                [
                    103.8475562,
                    51.8874998
                ],
                [
                    103.8454239,
                    51.8873345
                ],
                [
                    103.8417492,
                    51.8877238
                ],
                [
                    103.8389777,
                    51.8903508
                ]
            ],
            "longitude": 103.84462,
            "latitude": 51.893906
        },
        "10896": {
            "name": "Хузино",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.844757,
            "latitude": 51.869587
        },
        "10897": {
            "name": "Муравей",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.850212,
            "latitude": 51.611317
        },
        "10898": {
            "name": "Набережный",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.8549628,
            "latitude": 52.6110107
        },
        "10899": {
            "name": "Глубокая",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.856781,
            "latitude": 51.877705
        },
        "10900": {
            "name": "Малаханова",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.8601416,
            "latitude": 53.4049334
        },
        "10901": {
            "name": "Санаторный",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.881691,
            "latitude": 51.94577
        },
        "10902": {
            "name": "Источник",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.884773,
            "latitude": 51.902668
        },
        "10903": {
            "name": "Родниковый",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.888603,
            "latitude": 51.92485
        },
        "10904": {
            "name": "Заведение",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.890518,
            "latitude": 53.053471
        },
        "10905": {
            "name": "Мангутай",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.904648,
            "latitude": 51.602367
        },
        "10906": {
            "name": "Селезнево",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.9095296,
            "latitude": 56.3951155
        },
        "10907": {
            "name": "Ключевая",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.923378,
            "latitude": 52.380039
        },
        "10908": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.9370067,
            "latitude": 53.6757455
        },
        "10909": {
            "name": "Горхон",
            "population": 158,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.9380594,
            "latitude": 53.7227362
        },
        "10910": {
            "name": "Зверево",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.942101,
            "latitude": 52.390945
        },
        "10911": {
            "name": "Селезневский",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.947517,
            "latitude": 56.441521
        },
        "10912": {
            "name": "Суховская ст",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.948158,
            "latitude": 52.499023
        },
        "10913": {
            "name": "Барда",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.4101094,
            "latitude": 52.831539
        },
        "10914": {
            "name": "Стеклянка",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.96846,
            "latitude": 52.399529
        },
        "10915": {
            "name": "Еловка",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.968941,
            "latitude": 52.701557
        },
        "10916": {
            "name": "Шаражалгай",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    103.965849,
                    51.7492941
                ],
                [
                    103.9705044,
                    51.7513242
                ],
                [
                    103.9781757,
                    51.7522124
                ],
                [
                    103.9800586,
                    51.7506586
                ],
                [
                    103.9794347,
                    51.7499285
                ],
                [
                    103.9758333,
                    51.7499466
                ],
                [
                    103.9730809,
                    51.7500916
                ],
                [
                    103.9699774,
                    51.7491672
                ],
                [
                    103.9664638,
                    51.7484783
                ],
                [
                    103.965849,
                    51.7492941
                ]
            ],
            "longitude": 103.97068,
            "latitude": 51.749588
        },
        "10917": {
            "name": "Русиновка",
            "population": 254,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.974335,
            "latitude": 53.133175
        },
        "10918": {
            "name": "Пионерск",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.977707,
            "latitude": 52.240063
        },
        "10919": {
            "name": "Табатай",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.9864953,
            "latitude": 53.4809335
        },
        "10920": {
            "name": "Трудный",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.989891,
            "latitude": 51.989185
        },
        "10921": {
            "name": "Таёжный",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.994774,
            "latitude": 51.996342
        },
        "10922": {
            "name": "Борохал",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.9993034,
            "latitude": 53.7213116
        },
        "10923": {
            "name": "Орехово",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.0001237,
            "latitude": 51.5602195
        },
        "10924": {
            "name": "Степановка",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.001053,
            "latitude": 52.78503
        },
        "10925": {
            "name": "Огоньки",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.015717,
            "latitude": 52.011509
        },
        "10926": {
            "name": "Нововоскресенка",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.017502,
            "latitude": 53.149685
        },
        "10927": {
            "name": "Пыловка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.0187001,
            "latitude": 51.7574744
        },
        "10928": {
            "name": "Быкова",
            "population": 260,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.022629,
            "latitude": 52.736679
        },
        "10929": {
            "name": "Прохоровка",
            "population": 201,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.0389223,
            "latitude": 53.3501031
        },
        "10930": {
            "name": "Ягодный",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.05439,
            "latitude": 52.008812
        },
        "10931": {
            "name": "Чупровка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.0579416,
            "latitude": 53.3052436
        },
        "10932": {
            "name": "КП Солнечный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.0596758,
            "latitude": 52.219608
        },
        "10933": {
            "name": "ЖК Светлый",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.0670357,
            "latitude": 52.218269
        },
        "10934": {
            "name": "Летняя",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.067406,
            "latitude": 52.149956
        },
        "10935": {
            "name": "Манькова",
            "population": 209,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.068695,
            "latitude": 53.132427
        },
        "10936": {
            "name": "Ударник",
            "population": 143,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.069862,
            "latitude": 52.432449
        },
        "10937": {
            "name": "Дачная",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.073227,
            "latitude": 52.126995
        },
        "10938": {
            "name": "Рассоха",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.083878,
            "latitude": 52.027695
        },
        "10939": {
            "name": "Орлёнок",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.084824,
            "latitude": 52.010841
        },
        "10940": {
            "name": "Бабха",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.087044,
            "latitude": 51.53326
        },
        "10941": {
            "name": "Вдовина",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.09639,
            "latitude": 52.361027
        },
        "10942": {
            "name": "Баклань",
            "population": 14,
            "type": "hamlet",
            "poly": [
                [
                    104.0996825,
                    51.7606028
                ],
                [
                    104.1025564,
                    51.7613177
                ],
                [
                    104.1056988,
                    51.7614839
                ],
                [
                    104.1079818,
                    51.7608854
                ],
                [
                    104.1082504,
                    51.7604865
                ],
                [
                    104.1059943,
                    51.7600958
                ],
                [
                    104.1029995,
                    51.7599296
                ],
                [
                    104.1004345,
                    51.7600293
                ],
                [
                    104.0996825,
                    51.7606028
                ]
            ],
            "longitude": 104.101501,
            "latitude": 51.760277
        },
        "10943": {
            "name": "Усть-Укыр",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.106743,
            "latitude": 53.131775
        },
        "10944": {
            "name": "Марковка",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.1155948,
            "latitude": 53.2857659
        },
        "10945": {
            "name": "Лаврентьевская",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.1315,
            "latitude": 53.172691
        },
        "10946": {
            "name": "Северный",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.139924,
            "latitude": 53.5783553
        },
        "10947": {
            "name": "Хоргелок",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.149567,
            "latitude": 53.133686
        },
        "10948": {
            "name": "Тихонова Падь",
            "population": 227,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.154175,
            "latitude": 52.632343
        },
        "10949": {
            "name": "Хайрюзовка",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.184364,
            "latitude": 52.40361
        },
        "10950": {
            "name": "Петрограновка",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.186127,
            "latitude": 53.067299
        },
        "10951": {
            "name": "Бухун",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.18644,
            "latitude": 52.897614
        },
        "10952": {
            "name": "Верхний Кет",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.197525,
            "latitude": 52.961758
        },
        "10953": {
            "name": "Тачигир",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.19812,
            "latitude": 53.146126
        },
        "10954": {
            "name": "Ангара",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.225784,
            "latitude": 52.388618
        },
        "10955": {
            "name": "Шотой",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.2484113,
            "latitude": 53.4357068
        },
        "10956": {
            "name": "Онгосор",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.2500202,
            "latitude": 53.3928097
        },
        "10957": {
            "name": "Тайтура",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.264236,
            "latitude": 52.553776
        },
        "10958": {
            "name": "Глазунова",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.2644897,
            "latitude": 52.3858006
        },
        "10959": {
            "name": "Чилим",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.276924,
            "latitude": 53.112045
        },
        "10960": {
            "name": "Харагун",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.304497,
            "latitude": 53.170628
        },
        "10961": {
            "name": "Парамоновка",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.3049029,
            "latitude": 53.059039
        },
        "10962": {
            "name": "Парфёновка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.3110828,
            "latitude": 52.3378349
        },
        "10963": {
            "name": "Балыхта",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.311867,
            "latitude": 54.46809
        },
        "10964": {
            "name": "Рязановщина",
            "population": 160,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.328781,
            "latitude": 52.716187
        },
        "10965": {
            "name": "Половинная",
            "population": 13,
            "type": "hamlet",
            "poly": [
                [
                    104.347476,
                    51.7981733
                ],
                [
                    104.3479558,
                    51.7996462
                ],
                [
                    104.3521882,
                    51.8006397
                ],
                [
                    104.3565133,
                    51.8004486
                ],
                [
                    104.3572297,
                    51.7980146
                ],
                [
                    104.3554603,
                    51.7982037
                ],
                [
                    104.3527024,
                    51.7982071
                ],
                [
                    104.3490707,
                    51.7980247
                ],
                [
                    104.347476,
                    51.7981733
                ]
            ],
            "longitude": 104.355522,
            "latitude": 51.799435
        },
        "10966": {
            "name": "Граничная",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.365662,
            "latitude": 53.13092
        },
        "10967": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.3700026,
            "latitude": 52.8039805
        },
        "10968": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.3720457,
            "latitude": 53.5017484
        },
        "10969": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.3766186,
            "latitude": 52.5640442
        },
        "10970": {
            "name": "Базой",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.391129,
            "latitude": 53.107239
        },
        "10971": {
            "name": "Мишонкова",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.394431,
            "latitude": 52.6555484
        },
        "10972": {
            "name": "Пономарёвка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.397247,
            "latitude": 51.804283
        },
        "10973": {
            "name": "Кирьяновская Контора",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.4,
            "latitude": 58.583333
        },
        "10974": {
            "name": "Зыкова",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.408363,
            "latitude": 52.58812
        },
        "10975": {
            "name": "Ивановка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    104.4118302,
                    51.8018239
                ],
                [
                    104.412373,
                    51.8028123
                ],
                [
                    104.4165907,
                    51.8023381
                ],
                [
                    104.418412,
                    51.8007376
                ],
                [
                    104.4180925,
                    51.7986233
                ],
                [
                    104.4166426,
                    51.7990295
                ],
                [
                    104.4135924,
                    51.8004686
                ],
                [
                    104.4118302,
                    51.8018239
                ]
            ],
            "longitude": 104.4143541,
            "latitude": 51.8015477
        },
        "10976": {
            "name": "Новогрудинина",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.414925,
            "latitude": 52.149414
        },
        "10977": {
            "name": "Карстовая",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.4214674,
            "latitude": 56.7070302
        },
        "10978": {
            "name": "Нашата",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.430008,
            "latitude": 53.241943
        },
        "10979": {
            "name": "Кударейка",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.433006,
            "latitude": 52.863224
        },
        "10980": {
            "name": "Веселая Поляна",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.442062,
            "latitude": 53.135448
        },
        "10981": {
            "name": "Турская",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.442192,
            "latitude": 52.532795
        },
        "10982": {
            "name": "Паньковка 1-я",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.452454,
            "latitude": 51.477505
        },
        "10983": {
            "name": "Талька",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.455269,
            "latitude": 52.452271
        },
        "10984": {
            "name": "Шумиха",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    104.4586303,
                    51.7999198
                ],
                [
                    104.4589288,
                    51.8002852
                ],
                [
                    104.4642542,
                    51.8018611
                ],
                [
                    104.4685669,
                    51.8011944
                ],
                [
                    104.4697105,
                    51.7998407
                ],
                [
                    104.468861,
                    51.7979415
                ],
                [
                    104.4680442,
                    51.7986688
                ],
                [
                    104.4669987,
                    51.8001034
                ],
                [
                    104.4642216,
                    51.8000023
                ],
                [
                    104.4619346,
                    51.799275
                ],
                [
                    104.4598474,
                    51.7992985
                ],
                [
                    104.4586303,
                    51.7999198
                ]
            ],
            "longitude": 104.46476,
            "latitude": 51.800293
        },
        "10985": {
            "name": "Первомайский",
            "population": 243,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.472609,
            "latitude": 52.2583464
        },
        "10986": {
            "name": "Ида",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.496986,
            "latitude": 53.307117
        },
        "10987": {
            "name": "Паньковка 2-я",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.508347,
            "latitude": 51.456238
        },
        "10988": {
            "name": "Батхай",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.5109958,
            "latitude": 52.8791502
        },
        "10989": {
            "name": "Максимовщина",
            "population": 251,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.518906,
            "latitude": 52.610821
        },
        "10990": {
            "name": "Уланово",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    104.5194133,
                    51.7961623
                ],
                [
                    104.519573,
                    51.7973671
                ],
                [
                    104.5252845,
                    51.7988615
                ],
                [
                    104.5264427,
                    51.7979723
                ],
                [
                    104.5255315,
                    51.7969
                ],
                [
                    104.5213226,
                    51.7948484
                ],
                [
                    104.5207813,
                    51.795693
                ],
                [
                    104.5194133,
                    51.7961623
                ]
            ],
            "longitude": 104.52211,
            "latitude": 51.796822
        },
        "10991": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.527269,
            "latitude": 54.3970186
        },
        "10992": {
            "name": "Тыпта",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.533646,
            "latitude": 54.5784
        },
        "10993": {
            "name": "Толодой",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.5572749,
            "latitude": 52.8030781
        },
        "10994": {
            "name": "Верхняя Идыга",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.562065,
            "latitude": 52.921959
        },
        "10995": {
            "name": "Лебединка",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.56897,
            "latitude": 52.15332
        },
        "10996": {
            "name": "Зады",
            "population": 219,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.570099,
            "latitude": 52.765961
        },
        "10997": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.5702702,
            "latitude": 54.4059087
        },
        "10998": {
            "name": "Берёзка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.579682,
            "latitude": 52.0661461
        },
        "10999": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.5870177,
            "latitude": 54.6101388
        },
        "11000": {
            "name": "Дорожный",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.587189,
            "latitude": 52.08847
        },
        "11001": {
            "name": "Бурдугуз",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.60302,
            "latitude": 52.051693
        },
        "11002": {
            "name": "Каштак",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.607292,
            "latitude": 52.573181
        },
        "11003": {
            "name": "Солянка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.6194767,
            "latitude": 52.6610209
        },
        "11004": {
            "name": "Бутырки",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.6267027,
            "latitude": 52.0404681
        },
        "11005": {
            "name": "Байдоново",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.638863,
            "latitude": 54.260197
        },
        "11006": {
            "name": "Тальцы",
            "population": 9,
            "type": "hamlet",
            "poly": [
                [
                    104.6642073,
                    51.9947185
                ],
                [
                    104.6643655,
                    51.9956085
                ],
                [
                    104.6642915,
                    51.9963615
                ],
                [
                    104.6645185,
                    51.9966371
                ],
                [
                    104.6653283,
                    51.9981792
                ],
                [
                    104.6676316,
                    51.9983458
                ],
                [
                    104.6713939,
                    51.9931356
                ],
                [
                    104.6733139,
                    51.9920898
                ],
                [
                    104.6726799,
                    51.9887481
                ],
                [
                    104.6687417,
                    51.9892716
                ],
                [
                    104.6668317,
                    51.9896163
                ],
                [
                    104.6656586,
                    51.9902808
                ],
                [
                    104.6653687,
                    51.9910514
                ],
                [
                    104.6642971,
                    51.991613
                ],
                [
                    104.664278,
                    51.9922732
                ],
                [
                    104.6642715,
                    51.9924989
                ],
                [
                    104.6642073,
                    51.9947185
                ]
            ],
            "longitude": 104.669983,
            "latitude": 51.99081
        },
        "11007": {
            "name": "Пуляевщина",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.67247,
            "latitude": 54.639889
        },
        "11008": {
            "name": "Батхай",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.677315,
            "latitude": 52.69175
        },
        "11009": {
            "name": "Бачай",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.678917,
            "latitude": 54.233788
        },
        "11010": {
            "name": "Рудовщина",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.698135,
            "latitude": 52.610096
        },
        "11011": {
            "name": "Бургаз",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.704567,
            "latitude": 52.543217
        },
        "11012": {
            "name": "Бутырина",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.709419,
            "latitude": 54.419914
        },
        "11013": {
            "name": "Мурино",
            "population": 43,
            "type": "hamlet",
            "poly": [
                [
                    104.715114,
                    52.672531
                ],
                [
                    104.7162009,
                    52.673054
                ],
                [
                    104.718926,
                    52.6738867
                ],
                [
                    104.7208003,
                    52.6739232
                ],
                [
                    104.7224311,
                    52.6734678
                ],
                [
                    104.7226596,
                    52.6716358
                ],
                [
                    104.7201566,
                    52.6710607
                ],
                [
                    104.7203422,
                    52.6699052
                ],
                [
                    104.7171311,
                    52.6694212
                ],
                [
                    104.715114,
                    52.672531
                ]
            ],
            "longitude": 104.719009,
            "latitude": 52.67165
        },
        "11014": {
            "name": "Мерзлотная",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.721519,
            "latitude": 56.761459
        },
        "11015": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.7287607,
            "latitude": 54.3018732
        },
        "11016": {
            "name": "Поливаниха",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.730507,
            "latitude": 52.270481
        },
        "11017": {
            "name": "Захарова",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.734138,
            "latitude": 54.361092
        },
        "11018": {
            "name": "Кайдакан",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.761459,
            "latitude": 54.481903
        },
        "11019": {
            "name": "Константиновка",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.769241,
            "latitude": 54.674652
        },
        "11020": {
            "name": "Качень",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.769951,
            "latitude": 54.613625
        },
        "11021": {
            "name": "Ангарские Хутора",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.785126,
            "latitude": 51.927151
        },
        "11022": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.7885187,
            "latitude": 54.5760282
        },
        "11023": {
            "name": "Чичек",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.797333,
            "latitude": 54.530457
        },
        "11024": {
            "name": "Зурцаган",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.8046755,
            "latitude": 53.0766251
        },
        "11025": {
            "name": "Малая Кура",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.8222703,
            "latitude": 52.8283259
        },
        "11026": {
            "name": "Никола",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.824692,
            "latitude": 51.893936
        },
        "11027": {
            "name": "Добролёт",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.831131,
            "latitude": 52.25209
        },
        "11028": {
            "name": "Большая Кура",
            "population": 199,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.847565,
            "latitude": 52.736904
        },
        "11029": {
            "name": "Черемшанка",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.863457,
            "latitude": 52.024384
        },
        "11030": {
            "name": "Комой",
            "population": 201,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.888306,
            "latitude": 52.712006
        },
        "11031": {
            "name": "Серафимовск",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.890717,
            "latitude": 53.145092
        },
        "11032": {
            "name": "Каймоново",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.894005,
            "latitude": 56.838364
        },
        "11033": {
            "name": "Шедой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.9057255,
            "latitude": 53.0427586
        },
        "11034": {
            "name": "Нижняя Слобода",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.91658,
            "latitude": 54.736523
        },
        "11035": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.9310019,
            "latitude": 54.3076415
        },
        "11036": {
            "name": "Бухтумур",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.942383,
            "latitude": 53.24638
        },
        "11037": {
            "name": "Ордынский",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.9538346,
            "latitude": 52.8817012
        },
        "11038": {
            "name": "Тимошинск",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.955963,
            "latitude": 53.274044
        },
        "11039": {
            "name": "Ирхипшин",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.9751252,
            "latitude": 53.0874883
        },
        "11040": {
            "name": "Баянгазуй",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.981659,
            "latitude": 52.989971
        },
        "11041": {
            "name": "Гушит",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.9884848,
            "latitude": 52.8839751
        },
        "11042": {
            "name": "Нижний Кукут",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.9944589,
            "latitude": 52.7523407
        },
        "11043": {
            "name": "Максимово",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.008194,
            "latitude": 57.123947
        },
        "11044": {
            "name": "Ишины",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.00885,
            "latitude": 52.813992
        },
        "11045": {
            "name": "Сагарук",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.025482,
            "latitude": 52.790321
        },
        "11046": {
            "name": "Красный Яр",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.047554,
            "latitude": 52.542862
        },
        "11047": {
            "name": "Бобровка",
            "population": 31,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.05114,
            "latitude": 57.19698
        },
        "11048": {
            "name": "Онгой",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.05941,
            "latitude": 53.039875
        },
        "11049": {
            "name": "Молодёжный",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.068153,
            "latitude": 55.055824
        },
        "11050": {
            "name": "Большие Коты",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.074036,
            "latitude": 51.904469
        },
        "11051": {
            "name": "Тотохон",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.091255,
            "latitude": 52.798767
        },
        "11052": {
            "name": "Тихий Плес",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.1013182,
            "latitude": 54.8241076
        },
        "11053": {
            "name": "Шохтой",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.112839,
            "latitude": 52.810005
        },
        "11054": {
            "name": "Кокорина",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.159531,
            "latitude": 53.084949
        },
        "11055": {
            "name": "Наумовка",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.1610292,
            "latitude": 52.8412208
        },
        "11056": {
            "name": "Заплескина",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.176003,
            "latitude": 54.381969
        },
        "11057": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.1905537,
            "latitude": 53.7263015
        },
        "11058": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.1949794,
            "latitude": 53.7185376
        },
        "11059": {
            "name": "Балахня",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.196373,
            "latitude": 54.818481
        },
        "11060": {
            "name": "Шертой",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.196693,
            "latitude": 53.33503
        },
        "11061": {
            "name": "Муромцовка",
            "population": 202,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.2090518,
            "latitude": 53.2019757
        },
        "11062": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.211114,
            "latitude": 54.4771307
        },
        "11063": {
            "name": "Игжиновка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.21199,
            "latitude": 54.723999
        },
        "11064": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.212138,
            "latitude": 52.9684986
        },
        "11065": {
            "name": "Тетере",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.216667,
            "latitude": 59.65
        },
        "11066": {
            "name": "Воробьёва",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.222626,
            "latitude": 54.581215
        },
        "11067": {
            "name": "Головновка",
            "population": 196,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.22345,
            "latitude": 54.769165
        },
        "11068": {
            "name": "Пономарёва",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.226166,
            "latitude": 54.659454
        },
        "11069": {
            "name": "Орловка",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.227371,
            "latitude": 54.807945
        },
        "11070": {
            "name": "Грузновка",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.228233,
            "latitude": 55.143711
        },
        "11071": {
            "name": "Кузнецовка",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.231323,
            "latitude": 54.797855
        },
        "11072": {
            "name": "Солнопечное",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.2376496,
            "latitude": 52.2990657
        },
        "11073": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.2392921,
            "latitude": 53.6219744
        },
        "11074": {
            "name": "Ныгей",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.25444,
            "latitude": 52.845791
        },
        "11075": {
            "name": "Маралтуй",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.267822,
            "latitude": 52.997944
        },
        "11076": {
            "name": "Хандабай",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.271889,
            "latitude": 52.864983
        },
        "11077": {
            "name": "Идыгей",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.273338,
            "latitude": 53.007427
        },
        "11078": {
            "name": "Нижний Кочергат",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.274467,
            "latitude": 52.138443
        },
        "11079": {
            "name": "Молой",
            "population": 66,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.2899347,
            "latitude": 53.036449
        },
        "11080": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.2943306,
            "latitude": 53.5467459
        },
        "11081": {
            "name": "Хиней",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.298622,
            "latitude": 52.862106
        },
        "11082": {
            "name": "Магдан",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.307922,
            "latitude": 53.609154
        },
        "11083": {
            "name": "Хуты",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.325409,
            "latitude": 53.233097
        },
        "11084": {
            "name": "Ихинагуй",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.329033,
            "latitude": 53.732746
        },
        "11085": {
            "name": "Нуху-Нур",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.340981,
            "latitude": 53.149879
        },
        "11086": {
            "name": "Якимовка",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.363892,
            "latitude": 54.823067
        },
        "11087": {
            "name": "Каменка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.368584,
            "latitude": 52.999207
        },
        "11088": {
            "name": "Бахай 1-й",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.375237,
            "latitude": 52.922722
        },
        "11089": {
            "name": "Тыпкысыр",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.379875,
            "latitude": 53.062092
        },
        "11090": {
            "name": "Тюменцева",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.381737,
            "latitude": 54.28809
        },
        "11091": {
            "name": "Гогон",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.397232,
            "latitude": 53.924072
        },
        "11092": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.41546,
            "latitude": 54.2331077
        },
        "11093": {
            "name": "Житова",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.416389,
            "latitude": 53.947651
        },
        "11094": {
            "name": "Еленинск",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.424187,
            "latitude": 53.198189
        },
        "11095": {
            "name": "Обхой",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.436508,
            "latitude": 53.973171
        },
        "11096": {
            "name": "Булунчук",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.4369161,
            "latitude": 52.3992984
        },
        "11097": {
            "name": "Шеметова",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.455391,
            "latitude": 54.014606
        },
        "11098": {
            "name": "Козлово",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.455566,
            "latitude": 54.210457
        },
        "11099": {
            "name": "Бахай 2-й",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.456924,
            "latitude": 52.957951
        },
        "11100": {
            "name": "Хабардина",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.473213,
            "latitude": 54.047047
        },
        "11101": {
            "name": "Коношаново",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.4784238,
            "latitude": 55.3575157
        },
        "11102": {
            "name": "Хобанова",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.478722,
            "latitude": 54.033672
        },
        "11103": {
            "name": "Большедворова",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.485603,
            "latitude": 54.067432
        },
        "11104": {
            "name": "Грехова",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.48658,
            "latitude": 54.868763
        },
        "11105": {
            "name": "Усть-Тальма",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.488266,
            "latitude": 54.025482
        },
        "11106": {
            "name": "Алексеевка",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.493774,
            "latitude": 54.074791
        },
        "11107": {
            "name": "Бохолдой",
            "population": 95,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.494209,
            "latitude": 52.981331
        },
        "11108": {
            "name": "Тальма",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.509926,
            "latitude": 54.012833
        },
        "11109": {
            "name": "Вершининск",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.510979,
            "latitude": 53.222527
        },
        "11110": {
            "name": "Челпанова",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.518272,
            "latitude": 54.090004
        },
        "11111": {
            "name": "Куницына",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.521812,
            "latitude": 54.145706
        },
        "11112": {
            "name": "Головское",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.5223802,
            "latitude": 55.4908903
        },
        "11113": {
            "name": "Толмачева",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.534912,
            "latitude": 54.096447
        },
        "11114": {
            "name": "Ремизова",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.537514,
            "latitude": 54.126072
        },
        "11115": {
            "name": "Шехаргун",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.548676,
            "latitude": 53.097778
        },
        "11116": {
            "name": "Мильзан",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.570778,
            "latitude": 53.065311
        },
        "11117": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.5748522,
            "latitude": 54.0501718
        },
        "11118": {
            "name": "Маяк",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.583961,
            "latitude": 53.153229
        },
        "11119": {
            "name": "Картухай",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.58786,
            "latitude": 54.037762
        },
        "11120": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.5989892,
            "latitude": 54.0280948
        },
        "11121": {
            "name": "Шаманка",
            "population": 262,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.600281,
            "latitude": 53.125973
        },
        "11122": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.6147104,
            "latitude": 55.6201027
        },
        "11123": {
            "name": "Шишкина",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.653259,
            "latitude": 54.017719
        },
        "11124": {
            "name": "Зангут",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.666595,
            "latitude": 53.129242
        },
        "11125": {
            "name": "Келора",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.684189,
            "latitude": 54.663277
        },
        "11126": {
            "name": "Тарасово",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.689484,
            "latitude": 56.147907
        },
        "11127": {
            "name": "Тухум",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.714439,
            "latitude": 53.42202
        },
        "11128": {
            "name": "Толстовка",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.719666,
            "latitude": 53.052189
        },
        "11129": {
            "name": "Улан",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.727997,
            "latitude": 53.2379
        },
        "11130": {
            "name": "Кистенева",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.743958,
            "latitude": 53.978622
        },
        "11131": {
            "name": "Скокнина",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.7591537,
            "latitude": 56.301985599999995
        },
        "11132": {
            "name": "Минган",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.760246,
            "latitude": 56.993031
        },
        "11133": {
            "name": "Турука",
            "population": 72,
            "type": "hamlet",
            "poly": [
                [
                    105.7529357,
                    56.6806682
                ],
                [
                    105.7537725,
                    56.6821651
                ],
                [
                    105.7595199,
                    56.6814609
                ],
                [
                    105.7621807,
                    56.6804826
                ],
                [
                    105.7667512,
                    56.679021
                ],
                [
                    105.7729331,
                    56.6773448
                ],
                [
                    105.7733172,
                    56.6769699
                ],
                [
                    105.7763234,
                    56.6760245
                ],
                [
                    105.7760874,
                    56.6754587
                ],
                [
                    105.7743901,
                    56.6757675
                ],
                [
                    105.7736198,
                    56.6743977
                ],
                [
                    105.7704655,
                    56.6749635
                ],
                [
                    105.7684699,
                    56.6756119
                ],
                [
                    105.7623524,
                    56.677689
                ],
                [
                    105.7566908,
                    56.6787357
                ],
                [
                    105.7529357,
                    56.6806682
                ]
            ],
            "longitude": 105.764114,
            "latitude": 56.678326
        },
        "11134": {
            "name": "Малан",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.774178,
            "latitude": 53.454491
        },
        "11135": {
            "name": "Нагатай",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.779678,
            "latitude": 53.470154
        },
        "11136": {
            "name": "Старый Хогот",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.787666,
            "latitude": 53.292793
        },
        "11137": {
            "name": "Лесной",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.816116,
            "latitude": 53.986618
        },
        "11138": {
            "name": "Харагун",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.816223,
            "latitude": 53.1278
        },
        "11139": {
            "name": "Куртун",
            "population": 68,
            "type": "hamlet",
            "poly": [
                [
                    105.801665,
                    52.610786
                ],
                [
                    105.804032,
                    52.6114673
                ],
                [
                    105.8062937,
                    52.6116589
                ],
                [
                    105.8077664,
                    52.6122338
                ],
                [
                    105.8089411,
                    52.6124148
                ],
                [
                    105.8100281,
                    52.6128406
                ],
                [
                    105.8106593,
                    52.6128193
                ],
                [
                    105.8119567,
                    52.6132771
                ],
                [
                    105.8114833,
                    52.6139371
                ],
                [
                    105.812132,
                    52.6143203
                ],
                [
                    105.8123424,
                    52.6147142
                ],
                [
                    105.815095,
                    52.6155233
                ],
                [
                    105.8174795,
                    52.6168432
                ],
                [
                    105.8184788,
                    52.6176629
                ],
                [
                    105.8210035,
                    52.6187698
                ],
                [
                    105.8229146,
                    52.6203665
                ],
                [
                    105.8265789,
                    52.6222398
                ],
                [
                    105.8265438,
                    52.622591
                ],
                [
                    105.8281918,
                    52.6234318
                ],
                [
                    105.8281042,
                    52.6238256
                ],
                [
                    105.8290685,
                    52.6242727
                ],
                [
                    105.8297873,
                    52.6243578
                ],
                [
                    105.83014,
                    52.6242915
                ],
                [
                    105.8305062,
                    52.6241236
                ],
                [
                    105.8303484,
                    52.6235809
                ],
                [
                    105.8294542,
                    52.6227507
                ],
                [
                    105.8288756,
                    52.6221014
                ],
                [
                    105.8275256,
                    52.6217289
                ],
                [
                    105.8270347,
                    52.6214415
                ],
                [
                    105.8272276,
                    52.6202707
                ],
                [
                    105.8265087,
                    52.6200898
                ],
                [
                    105.8256847,
                    52.6204836
                ],
                [
                    105.8244925,
                    52.6203239
                ],
                [
                    105.8235282,
                    52.6190573
                ],
                [
                    105.8232828,
                    52.6179183
                ],
                [
                    105.8238087,
                    52.616939
                ],
                [
                    105.8238613,
                    52.6160875
                ],
                [
                    105.8223886,
                    52.6151294
                ],
                [
                    105.8211613,
                    52.6150975
                ],
                [
                    105.8206529,
                    52.6144481
                ],
                [
                    105.8149197,
                    52.6124573
                ],
                [
                    105.8144288,
                    52.6114247
                ],
                [
                    105.8131665,
                    52.611084
                ],
                [
                    105.8123424,
                    52.6102749
                ],
                [
                    105.8098703,
                    52.6096468
                ],
                [
                    105.8073983,
                    52.6099768
                ],
                [
                    105.8062937,
                    52.6100301
                ],
                [
                    105.8049611,
                    52.6098065
                ],
                [
                    105.8042073,
                    52.6099236
                ],
                [
                    105.801665,
                    52.610786
                ]
            ],
            "longitude": 105.81739,
            "latitude": 52.614548
        },
        "11140": {
            "name": "Лидинская",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.820457,
            "latitude": 53.083069
        },
        "11141": {
            "name": "Хандагай",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.851768,
            "latitude": 53.165306
        },
        "11142": {
            "name": "Хотогор",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.853951,
            "latitude": 53.330597
        },
        "11143": {
            "name": "Токма",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.85569,
            "latitude": 58.251884
        },
        "11144": {
            "name": "Орлинга",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.855743,
            "latitude": 56.045906
        },
        "11145": {
            "name": "Жемчугова",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.85656,
            "latitude": 56.06522
        },
        "11146": {
            "name": "Сутай",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.888382,
            "latitude": 53.910667
        },
        "11147": {
            "name": "Тимирязева",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.8897028,
            "latitude": 53.917489
        },
        "11148": {
            "name": "Босогол",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.90567,
            "latitude": 53.877029
        },
        "11149": {
            "name": "Шитхулун",
            "population": 154,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.944481,
            "latitude": 53.326366
        },
        "11150": {
            "name": "Духовщина",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.9729433,
            "latitude": 53.2092596
        },
        "11151": {
            "name": "Исеть",
            "population": 242,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.982056,
            "latitude": 53.846863
        },
        "11152": {
            "name": "Зуева",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.983833,
            "latitude": 53.54504
        },
        "11153": {
            "name": "Полоскова",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.994934,
            "latitude": 53.523987
        },
        "11154": {
            "name": "Литвинова",
            "population": 188,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.995102,
            "latitude": 53.619198
        },
        "11155": {
            "name": "Алагуй",
            "population": 218,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.995491,
            "latitude": 52.778355
        },
        "11156": {
            "name": "Кайзаран",
            "population": 169,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.000816,
            "latitude": 53.303265
        },
        "11157": {
            "name": "Новохарбатова",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.013138,
            "latitude": 53.768723
        },
        "11158": {
            "name": "Боярск",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.020378,
            "latitude": 56.338928
        },
        "11159": {
            "name": "Хальск",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.040764,
            "latitude": 53.802177
        },
        "11160": {
            "name": "Малые Голы",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.050735,
            "latitude": 53.92931
        },
        "11161": {
            "name": "Чептыхой",
            "population": 76,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.059326,
            "latitude": 53.952778
        },
        "11162": {
            "name": "Суханай Байбет",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.059761,
            "latitude": 53.933899
        },
        "11163": {
            "name": "Копцыгай",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.072098,
            "latitude": 53.390591
        },
        "11164": {
            "name": "Косая Степь",
            "population": 100,
            "type": "hamlet",
            "poly": [
                [
                    [
                        106.0704341,
                        52.8477668
                    ],
                    [
                        106.0727212,
                        52.8489585
                    ],
                    [
                        106.0760577,
                        52.8489178
                    ],
                    [
                        106.0754028,
                        52.8535137
                    ],
                    [
                        106.0767471,
                        52.8535869
                    ],
                    [
                        106.0794368,
                        52.849189
                    ],
                    [
                        106.0805076,
                        52.8475076
                    ],
                    [
                        106.0817602,
                        52.8448997
                    ],
                    [
                        106.0841691,
                        52.8436305
                    ],
                    [
                        106.0842788,
                        52.8431738
                    ],
                    [
                        106.0826297,
                        52.84157
                    ],
                    [
                        106.0815173,
                        52.8387604
                    ],
                    [
                        106.0787875,
                        52.8373149
                    ],
                    [
                        106.0755521,
                        52.8372946
                    ],
                    [
                        106.0730245,
                        52.8412236
                    ],
                    [
                        106.0722157,
                        52.8426485
                    ],
                    [
                        106.0755755,
                        52.8448445
                    ],
                    [
                        106.0704341,
                        52.8477668
                    ]
                ],
                [
                    [
                        106.0874488,
                        52.8418954
                    ],
                    [
                        106.0874706,
                        52.8427455
                    ],
                    [
                        106.0877858,
                        52.8440938
                    ],
                    [
                        106.0884261,
                        52.8464957
                    ],
                    [
                        106.0892013,
                        52.8469231
                    ],
                    [
                        106.0915765,
                        52.8468499
                    ],
                    [
                        106.0920915,
                        52.843735
                    ],
                    [
                        106.0916302,
                        52.8397807
                    ],
                    [
                        106.0895734,
                        52.8400192
                    ],
                    [
                        106.0893342,
                        52.8417631
                    ],
                    [
                        106.0874488,
                        52.8418954
                    ]
                ]
            ],
            "longitude": 106.078957,
            "latitude": 52.84499
        },
        "11165": {
            "name": "Копылова",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.080818,
            "latitude": 53.360798
        },
        "11166": {
            "name": "Баганта",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    106.090559,
                    53.0971552
                ],
                [
                    106.0939862,
                    53.1006292
                ],
                [
                    106.0986228,
                    53.0994793
                ],
                [
                    106.0959819,
                    53.0960537
                ],
                [
                    106.090559,
                    53.0971552
                ]
            ],
            "longitude": 106.093864,
            "latitude": 53.097713
        },
        "11167": {
            "name": "Хомокашево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.1,
            "latitude": 60.316667
        },
        "11168": {
            "name": "Шеина",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.128227,
            "latitude": 54.090252
        },
        "11169": {
            "name": "Куяда",
            "population": 29,
            "type": "hamlet",
            "poly": [
                [
                    106.1288519,
                    52.5588676
                ],
                [
                    106.1294935,
                    52.5600371
                ],
                [
                    106.1294548,
                    52.5611087
                ],
                [
                    106.1309022,
                    52.5612189
                ],
                [
                    106.131283,
                    52.5603541
                ],
                [
                    106.1330426,
                    52.5601134
                ],
                [
                    106.1334792,
                    52.5588331
                ],
                [
                    106.1307949,
                    52.5577946
                ],
                [
                    106.1288519,
                    52.5588676
                ]
            ],
            "longitude": 106.130318,
            "latitude": 52.558411
        },
        "11170": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.1336267,
            "latitude": 54.0616403
        },
        "11171": {
            "name": "Щапова",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.139915,
            "latitude": 53.990536
        },
        "11172": {
            "name": "Большой Косогол",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.154503,
            "latitude": 53.84235
        },
        "11173": {
            "name": "Рыкова",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.176842,
            "latitude": 53.972485
        },
        "11174": {
            "name": "Корсукова",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.213089,
            "latitude": 53.745628
        },
        "11175": {
            "name": "Таловка",
            "population": 104,
            "type": "hamlet",
            "poly": [
                [
                    106.2191243,
                    52.6740401
                ],
                [
                    106.2201317,
                    52.6750406
                ],
                [
                    106.2191243,
                    52.6765381
                ],
                [
                    106.2228569,
                    52.6790606
                ],
                [
                    106.2216349,
                    52.6801807
                ],
                [
                    106.2221273,
                    52.68096
                ],
                [
                    106.2210984,
                    52.6819239
                ],
                [
                    106.2260754,
                    52.6844072
                ],
                [
                    106.2295517,
                    52.682521
                ],
                [
                    106.2313111,
                    52.6814413
                ],
                [
                    106.2294669,
                    52.6797384
                ],
                [
                    106.230454,
                    52.6784635
                ],
                [
                    106.2294455,
                    52.6775398
                ],
                [
                    106.2271709,
                    52.6757965
                ],
                [
                    106.2256045,
                    52.6750028
                ],
                [
                    106.2206693,
                    52.6725438
                ],
                [
                    106.2191243,
                    52.6740401
                ]
            ],
            "longitude": 106.225426,
            "latitude": 52.676414
        },
        "11176": {
            "name": "Юшина",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.231598,
            "latitude": 53.877907
        },
        "11177": {
            "name": "Хомокашево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.2499999,
            "latitude": 60.5
        },
        "11178": {
            "name": "Омолой",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.269035,
            "latitude": 56.463757
        },
        "11179": {
            "name": "Макрушина",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.281792,
            "latitude": 53.87986
        },
        "11180": {
            "name": "Чемякина",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.287842,
            "latitude": 53.857151
        },
        "11181": {
            "name": "Ацикяк",
            "population": 95,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.306778,
            "latitude": 54.187958
        },
        "11182": {
            "name": "Попова",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    106.3018251,
                    52.7383317
                ],
                [
                    106.3034598,
                    52.7408519
                ],
                [
                    106.3045923,
                    52.7425975
                ],
                [
                    106.3036611,
                    52.7432471
                ],
                [
                    106.3044303,
                    52.7457102
                ],
                [
                    106.3057866,
                    52.7466906
                ],
                [
                    106.3117988,
                    52.7441172
                ],
                [
                    106.3124061,
                    52.7432103
                ],
                [
                    106.3105032,
                    52.7418989
                ],
                [
                    106.3112725,
                    52.7412127
                ],
                [
                    106.3146936,
                    52.7424872
                ],
                [
                    106.3164952,
                    52.7405877
                ],
                [
                    106.3109688,
                    52.739264
                ],
                [
                    106.3104424,
                    52.7369966
                ],
                [
                    106.306078,
                    52.7364407
                ],
                [
                    106.3018251,
                    52.7383317
                ]
            ],
            "longitude": 106.30864,
            "latitude": 52.742584
        },
        "11183": {
            "name": "Кукуй",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.31205,
            "latitude": 53.870716
        },
        "11184": {
            "name": "Тарай",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.315292,
            "latitude": 54.019707
        },
        "11185": {
            "name": "Петрова",
            "population": 37,
            "type": "hamlet",
            "poly": [
                [
                    106.3109489,
                    52.7569218
                ],
                [
                    106.3134659,
                    52.7573948
                ],
                [
                    106.3158541,
                    52.7583223
                ],
                [
                    106.3199638,
                    52.7573289
                ],
                [
                    106.3212774,
                    52.7565241
                ],
                [
                    106.3204042,
                    52.7550972
                ],
                [
                    106.3194837,
                    52.7543336
                ],
                [
                    106.315389,
                    52.7560572
                ],
                [
                    106.3129171,
                    52.7555793
                ],
                [
                    106.3123473,
                    52.756527
                ],
                [
                    106.3111908,
                    52.7562929
                ],
                [
                    106.3109489,
                    52.7569218
                ]
            ],
            "longitude": 106.318718,
            "latitude": 52.756321
        },
        "11186": {
            "name": "Тырган",
            "population": 40,
            "type": "hamlet",
            "poly": [
                [
                    106.3356011,
                    52.7584369
                ],
                [
                    106.3387281,
                    52.7623364
                ],
                [
                    106.3432221,
                    52.7625936
                ],
                [
                    106.3477719,
                    52.7613216
                ],
                [
                    106.3440994,
                    52.7558936
                ],
                [
                    106.3414772,
                    52.755406
                ],
                [
                    106.3402261,
                    52.7544838
                ],
                [
                    106.3395581,
                    52.7548391
                ],
                [
                    106.3401047,
                    52.7557702
                ],
                [
                    106.3365824,
                    52.7558559
                ],
                [
                    106.3356011,
                    52.7584369
                ]
            ],
            "longitude": 106.341606,
            "latitude": 52.758919
        },
        "11187": {
            "name": "Ика",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.346397,
            "latitude": 59.310707
        },
        "11188": {
            "name": "Буредай",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.359543,
            "latitude": 54.171753
        },
        "11189": {
            "name": "Малая Тарель",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.364998,
            "latitude": 53.836967
        },
        "11190": {
            "name": "Подкаменка",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.365067,
            "latitude": 53.849751
        },
        "11191": {
            "name": "Нарин-Кунта",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.377373,
            "latitude": 52.760536
        },
        "11192": {
            "name": "Болото",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.397453,
            "latitude": 53.91671
        },
        "11193": {
            "name": "Мыс",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.398819,
            "latitude": 54.021576
        },
        "11194": {
            "name": "Большой Улун",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.417358,
            "latitude": 54.208332
        },
        "11195": {
            "name": "Дурутуй",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.427864,
            "latitude": 54.030964
        },
        "11196": {
            "name": "Борсой",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.452034,
            "latitude": 52.831348
        },
        "11197": {
            "name": "Загулан",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.457481,
            "latitude": 54.06913
        },
        "11198": {
            "name": "Хурай-Нур",
            "population": 178,
            "type": "hamlet",
            "poly": [
                [
                    106.458123,
                    52.8083494
                ],
                [
                    106.4592233,
                    52.8094251
                ],
                [
                    106.4583567,
                    52.810624
                ],
                [
                    106.4597643,
                    52.8119495
                ],
                [
                    106.4633145,
                    52.8121103
                ],
                [
                    106.4645917,
                    52.8114035
                ],
                [
                    106.4658797,
                    52.8114683
                ],
                [
                    106.4677157,
                    52.8124122
                ],
                [
                    106.4705645,
                    52.8114145
                ],
                [
                    106.4687947,
                    52.8100345
                ],
                [
                    106.4694026,
                    52.8094291
                ],
                [
                    106.4716631,
                    52.8093869
                ],
                [
                    106.4735052,
                    52.8090429
                ],
                [
                    106.4761778,
                    52.8100478
                ],
                [
                    106.4802322,
                    52.8100478
                ],
                [
                    106.4813255,
                    52.8093214
                ],
                [
                    106.479545,
                    52.8071284
                ],
                [
                    106.4803502,
                    52.8063044
                ],
                [
                    106.4796267,
                    52.805651
                ],
                [
                    106.4626707,
                    52.8081995
                ],
                [
                    106.4606236,
                    52.8069614
                ],
                [
                    106.458123,
                    52.8083494
                ]
            ],
            "longitude": 106.46637,
            "latitude": 52.809517
        },
        "11199": {
            "name": "Мухор-Булык",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.468399,
            "latitude": 52.854527
        },
        "11200": {
            "name": "Кузнецы",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.468788,
            "latitude": 54.049866
        },
        "11201": {
            "name": "Халха-Узур",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.486176,
            "latitude": 52.860077
        },
        "11202": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.4964765,
            "latitude": 54.0510926
        },
        "11203": {
            "name": "Хархатай",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.496681,
            "latitude": 52.871494
        },
        "11204": {
            "name": "Тонта",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.502785,
            "latitude": 52.880096
        },
        "11205": {
            "name": "Ялга-Узур",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.509369,
            "latitude": 52.800365
        },
        "11206": {
            "name": "Бутухей",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.512222,
            "latitude": 52.89732
        },
        "11207": {
            "name": "Таюра",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.548279,
            "latitude": 57.001175
        },
        "11208": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.5523306,
            "latitude": 54.1408385
        },
        "11209": {
            "name": "Юхта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.6046764,
            "latitude": 54.2844065
        },
        "11210": {
            "name": "Новосёлова",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.630432,
            "latitude": 57.007923
        },
        "11211": {
            "name": "Кучулга",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    106.6716037,
                    52.983757
                ],
                [
                    106.6726999,
                    52.9843052
                ],
                [
                    106.673584,
                    52.9838262
                ],
                [
                    106.6741852,
                    52.9840657
                ],
                [
                    106.6743355,
                    52.9830065
                ],
                [
                    106.6732481,
                    52.9827828
                ],
                [
                    106.6716037,
                    52.983757
                ]
            ],
            "longitude": 106.673454,
            "latitude": 52.983562
        },
        "11212": {
            "name": "Тетея",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.702499,
            "latitude": 60.98027
        },
        "11213": {
            "name": "Улан-Нур",
            "population": 6,
            "type": "hamlet",
            "poly": [
                [
                    106.7172176,
                    52.8741594
                ],
                [
                    106.7277052,
                    52.877909
                ],
                [
                    106.732436,
                    52.8747098
                ],
                [
                    106.7273632,
                    52.8706674
                ],
                [
                    106.7210364,
                    52.8682935
                ],
                [
                    106.7184429,
                    52.8691192
                ],
                [
                    106.7177875,
                    52.8709599
                ],
                [
                    106.7172176,
                    52.8741594
                ]
            ],
            "longitude": 106.720009,
            "latitude": 52.870754
        },
        "11214": {
            "name": "Шида",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.780098,
            "latitude": 53.057846
        },
        "11215": {
            "name": "Шевыкан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.790451,
            "latitude": 54.350842
        },
        "11216": {
            "name": "Куркут",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.827408,
            "latitude": 53.027637
        },
        "11217": {
            "name": "Сарма",
            "population": 77,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.834381,
            "latitude": 53.101704
        },
        "11218": {
            "name": "Сахюрта",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.883255,
            "latitude": 53.017082
        },
        "11219": {
            "name": "Назарово",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.904518,
            "latitude": 57.173164
        },
        "11220": {
            "name": "Курма",
            "population": 41,
            "type": "hamlet",
            "poly": [
                [
                    106.8343779,
                    53.1183683
                ],
                [
                    106.8565931,
                    53.1288809
                ],
                [
                    106.8775768,
                    53.1389989
                ],
                [
                    106.9059633,
                    53.1530533
                ],
                [
                    106.9218264,
                    53.1612636
                ],
                [
                    106.9337932,
                    53.1677038
                ],
                [
                    106.9499902,
                    53.1760446
                ],
                [
                    106.9560571,
                    53.181015
                ],
                [
                    106.9561128,
                    53.1862516
                ],
                [
                    106.9627363,
                    53.1965562
                ],
                [
                    106.9653601,
                    53.1991586
                ],
                [
                    106.973355,
                    53.2031737
                ],
                [
                    106.9767468,
                    53.2054471
                ],
                [
                    106.9807846,
                    53.2090262
                ],
                [
                    106.987972,
                    53.2128469
                ],
                [
                    106.9980666,
                    53.2163771
                ],
                [
                    107.0043267,
                    53.2196112
                ],
                [
                    107.0058114,
                    53.2129434
                ],
                [
                    107.0058114,
                    53.2085661
                ],
                [
                    106.9922207,
                    53.1934473
                ],
                [
                    106.9827986,
                    53.1867755
                ],
                [
                    106.9786872,
                    53.1843802
                ],
                [
                    106.9779448,
                    53.1807186
                ],
                [
                    106.975615,
                    53.1731761
                ],
                [
                    106.9690367,
                    53.1731207
                ],
                [
                    106.9647539,
                    53.1730523
                ],
                [
                    106.9593862,
                    53.1700401
                ],
                [
                    106.9564739,
                    53.1657269
                ],
                [
                    106.9547608,
                    53.1629539
                ],
                [
                    106.9461381,
                    53.1615502
                ],
                [
                    106.938372,
                    53.1603176
                ],
                [
                    106.9374013,
                    53.1581948
                ],
                [
                    106.9385434,
                    53.1547707
                ],
                [
                    106.9308344,
                    53.1546337
                ],
                [
                    106.9242104,
                    53.1536749
                ],
                [
                    106.9194708,
                    53.1524079
                ],
                [
                    106.9147883,
                    53.1504902
                ],
                [
                    106.9103913,
                    53.1502162
                ],
                [
                    106.9057659,
                    53.1486066
                ],
                [
                    106.9000555,
                    53.143846
                ],
                [
                    106.8974859,
                    53.1426129
                ],
                [
                    106.8938884,
                    53.141414
                ],
                [
                    106.8874928,
                    53.1384682
                ],
                [
                    106.8814398,
                    53.1357619
                ],
                [
                    106.8780136,
                    53.1336036
                ],
                [
                    106.8784704,
                    53.1267512
                ],
                [
                    106.8787559,
                    53.1198634
                ],
                [
                    106.8765289,
                    53.1077643
                ],
                [
                    106.87276,
                    53.1061874
                ],
                [
                    106.8693338,
                    53.1039933
                ],
                [
                    106.866628,
                    53.1005238
                ],
                [
                    106.8646421,
                    53.0976764
                ],
                [
                    106.8579897,
                    53.0962497
                ],
                [
                    106.8572553,
                    53.0969749
                ],
                [
                    106.8576415,
                    53.0976062
                ],
                [
                    106.8572982,
                    53.0981473
                ],
                [
                    106.8574269,
                    53.0985081
                ],
                [
                    106.8571265,
                    53.0992167
                ],
                [
                    106.8568047,
                    53.09941
                ],
                [
                    106.8562682,
                    53.0992682
                ],
                [
                    106.8555987,
                    53.0994853
                ],
                [
                    106.8549336,
                    53.0988154
                ],
                [
                    106.8540366,
                    53.0987787
                ],
                [
                    106.8528779,
                    53.0990235
                ],
                [
                    106.8529208,
                    53.0992296
                ],
                [
                    106.8536933,
                    53.0998351
                ],
                [
                    106.8534573,
                    53.1003634
                ],
                [
                    106.8526161,
                    53.1007222
                ],
                [
                    106.8515475,
                    53.100737
                ],
                [
                    106.8504274,
                    53.1014952
                ],
                [
                    106.8494018,
                    53.1010848
                ],
                [
                    106.8488653,
                    53.1013296
                ],
                [
                    106.8484791,
                    53.1021928
                ],
                [
                    106.8479212,
                    53.102824
                ],
                [
                    106.8474877,
                    53.1032988
                ],
                [
                    106.8478311,
                    53.1042134
                ],
                [
                    106.8479169,
                    53.1055661
                ],
                [
                    106.8477281,
                    53.1059158
                ],
                [
                    106.8478525,
                    53.1062746
                ],
                [
                    106.8471487,
                    53.1072813
                ],
                [
                    106.8459471,
                    53.1079253
                ],
                [
                    106.8432863,
                    53.1090202
                ],
                [
                    106.8427928,
                    53.1090975
                ],
                [
                    106.8421705,
                    53.1097158
                ],
                [
                    106.8414624,
                    53.109909
                ],
                [
                    106.8410762,
                    53.1105401
                ],
                [
                    106.8409904,
                    53.111094
                ],
                [
                    106.8402994,
                    53.1119421
                ],
                [
                    106.8396814,
                    53.1119183
                ],
                [
                    106.8388017,
                    53.1126138
                ],
                [
                    106.8380893,
                    53.1130885
                ],
                [
                    106.8368705,
                    53.1133351
                ],
                [
                    106.8361195,
                    53.1140435
                ],
                [
                    106.8360766,
                    53.1150094
                ],
                [
                    106.8364156,
                    53.1158189
                ],
                [
                    106.834832,
                    53.117817
                ],
                [
                    106.8343779,
                    53.1183683
                ]
            ],
            "longitude": 106.965897,
            "latitude": 53.179916
        },
        "11221": {
            "name": "Чанчур",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.990303,
            "latitude": 53.825939
        },
        "11222": {
            "name": "Бур",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.993828,
            "latitude": 58.812283
        },
        "11223": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.0067583,
            "latitude": 55.0519744
        },
        "11224": {
            "name": "Марково",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.056519,
            "latitude": 57.328968
        },
        "11225": {
            "name": "Глухова",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.09021,
            "latitude": 57.324921
        },
        "11226": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.0981063,
            "latitude": 55.1237781
        },
        "11227": {
            "name": "Вершина Ханды",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.119263,
            "latitude": 55.927639
        },
        "11228": {
            "name": "Тырка",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.137001,
            "latitude": 54.508305
        },
        "11229": {
            "name": "Ялга",
            "population": 90,
            "type": "hamlet",
            "poly": [
                [
                    107.1783741,
                    53.1407943
                ],
                [
                    107.1804408,
                    53.1413328
                ],
                [
                    107.1808146,
                    53.1409106
                ],
                [
                    107.1798792,
                    53.1406865
                ],
                [
                    107.1808305,
                    53.1396244
                ],
                [
                    107.1824895,
                    53.1396934
                ],
                [
                    107.1826174,
                    53.1391494
                ],
                [
                    107.1852903,
                    53.1394248
                ],
                [
                    107.1853477,
                    53.1393306
                ],
                [
                    107.1862093,
                    53.1394279
                ],
                [
                    107.1860336,
                    53.1399629
                ],
                [
                    107.1869931,
                    53.1401676
                ],
                [
                    107.187292,
                    53.1395463
                ],
                [
                    107.1875134,
                    53.1395718
                ],
                [
                    107.1878209,
                    53.1391543
                ],
                [
                    107.187992,
                    53.1387957
                ],
                [
                    107.1879898,
                    53.138609
                ],
                [
                    107.1873681,
                    53.1384348
                ],
                [
                    107.1865044,
                    53.1383533
                ],
                [
                    107.1865539,
                    53.1382138
                ],
                [
                    107.1867397,
                    53.1382321
                ],
                [
                    107.1868039,
                    53.1382037
                ],
                [
                    107.1868512,
                    53.1381145
                ],
                [
                    107.1868444,
                    53.1380517
                ],
                [
                    107.1867431,
                    53.1380274
                ],
                [
                    107.1869989,
                    53.1376782
                ],
                [
                    107.1870339,
                    53.1372446
                ],
                [
                    107.1872262,
                    53.1369755
                ],
                [
                    107.1870438,
                    53.1368822
                ],
                [
                    107.1867769,
                    53.1368539
                ],
                [
                    107.1863646,
                    53.1368491
                ],
                [
                    107.1861349,
                    53.1368964
                ],
                [
                    107.1858951,
                    53.1369917
                ],
                [
                    107.1856552,
                    53.1372471
                ],
                [
                    107.1853977,
                    53.1378122
                ],
                [
                    107.1847327,
                    53.1378218
                ],
                [
                    107.1845572,
                    53.1380821
                ],
                [
                    107.1845386,
                    53.1383506
                ],
                [
                    107.1845831,
                    53.1383626
                ],
                [
                    107.1845878,
                    53.138402
                ],
                [
                    107.1845572,
                    53.138453
                ],
                [
                    107.1844119,
                    53.1384996
                ],
                [
                    107.1844085,
                    53.1385624
                ],
                [
                    107.183611,
                    53.1384692
                ],
                [
                    107.1820839,
                    53.1384949
                ],
                [
                    107.1802224,
                    53.1384023
                ],
                [
                    107.1798542,
                    53.1388928
                ],
                [
                    107.1800184,
                    53.1388991
                ],
                [
                    107.1800006,
                    53.1392501
                ],
                [
                    107.1795814,
                    53.1392409
                ],
                [
                    107.1783741,
                    53.1407943
                ]
            ],
            "longitude": 107.185242,
            "latitude": 53.138893
        },
        "11230": {
            "name": "Тира",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.220734,
            "latitude": 57.27446
        },
        "11231": {
            "name": "Токия",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.2327155,
            "latitude": 62.2124975
        },
        "11232": {
            "name": "Чинонга",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.28389,
            "latitude": 54.618156
        },
        "11233": {
            "name": "Малый Хужир",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    107.2828248,
                    53.1778544
                ],
                [
                    107.2841514,
                    53.1790528
                ],
                [
                    107.2858985,
                    53.1786927
                ],
                [
                    107.2862812,
                    53.1775845
                ],
                [
                    107.2898108,
                    53.1778105
                ],
                [
                    107.2895699,
                    53.1790408
                ],
                [
                    107.2914757,
                    53.1792205
                ],
                [
                    107.2918009,
                    53.1778921
                ],
                [
                    107.2941016,
                    53.1780693
                ],
                [
                    107.2944744,
                    53.1772872
                ],
                [
                    107.2906383,
                    53.1762411
                ],
                [
                    107.2869661,
                    53.175895
                ],
                [
                    107.2828528,
                    53.1764479
                ],
                [
                    107.2828248,
                    53.1778544
                ]
            ],
            "longitude": 107.287125,
            "latitude": 53.1772
        },
        "11234": {
            "name": "Улькан",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.3222623,
            "latitude": 57.2430164
        },
        "11235": {
            "name": "Харанцы",
            "population": 97,
            "type": "hamlet",
            "poly": [
                [
                    107.4106512,
                    53.2270182
                ],
                [
                    107.4124054,
                    53.2285434
                ],
                [
                    107.4164984,
                    53.2265682
                ],
                [
                    107.4244756,
                    53.2282684
                ],
                [
                    107.4268145,
                    53.225993
                ],
                [
                    107.4289445,
                    53.2211172
                ],
                [
                    107.4252691,
                    53.2202168
                ],
                [
                    107.4237238,
                    53.2164658
                ],
                [
                    107.4177931,
                    53.2166658
                ],
                [
                    107.4142013,
                    53.2157905
                ],
                [
                    107.4131571,
                    53.2166158
                ],
                [
                    107.4146607,
                    53.2179663
                ],
                [
                    107.4116953,
                    53.2215923
                ],
                [
                    107.4137001,
                    53.2232927
                ],
                [
                    107.4106512,
                    53.2270182
                ]
            ],
            "longitude": 107.419411,
            "latitude": 53.221867
        },
        "11236": {
            "name": "Красноярово",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.455292,
            "latitude": 57.337029
        },
        "11237": {
            "name": "Мостовая",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.478279,
            "latitude": 56.219849
        },
        "11238": {
            "name": "Седанкина",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.481339,
            "latitude": 56.18483
        },
        "11239": {
            "name": "Зама",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.509056,
            "latitude": 53.461468
        },
        "11240": {
            "name": "Улан-Хушин",
            "population": 46,
            "type": "hamlet",
            "poly": [
                [
                    107.5219389,
                    53.2573041
                ],
                [
                    107.528623,
                    53.2593217
                ],
                [
                    107.533866,
                    53.2560385
                ],
                [
                    107.5292056,
                    53.2525533
                ],
                [
                    107.530432,
                    53.2492145
                ],
                [
                    107.5246371,
                    53.2475267
                ],
                [
                    107.5226441,
                    53.2517645
                ],
                [
                    107.5219389,
                    53.2573041
                ]
            ],
            "longitude": 107.5276885,
            "latitude": 53.2554932
        },
        "11241": {
            "name": "Песчаная",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    107.5822651,
                    53.2859162
                ],
                [
                    107.5826317,
                    53.2860442
                ],
                [
                    107.5836284,
                    53.2863743
                ],
                [
                    107.5842765,
                    53.2866601
                ],
                [
                    107.5853491,
                    53.2869775
                ],
                [
                    107.5867393,
                    53.2873428
                ],
                [
                    107.5875323,
                    53.2874098
                ],
                [
                    107.5905993,
                    53.2884914
                ],
                [
                    107.5923693,
                    53.2885417
                ],
                [
                    107.5932577,
                    53.2886353
                ],
                [
                    107.5935105,
                    53.2888757
                ],
                [
                    107.5947678,
                    53.2887244
                ],
                [
                    107.5943766,
                    53.2875104
                ],
                [
                    107.5911915,
                    53.2868983
                ],
                [
                    107.589086,
                    53.2870073
                ],
                [
                    107.5870074,
                    53.2852436
                ],
                [
                    107.5860243,
                    53.2851662
                ],
                [
                    107.5826183,
                    53.2852689
                ],
                [
                    107.5822651,
                    53.2859162
                ]
            ],
            "longitude": 107.589195,
            "latitude": 53.287479
        },
        "11242": {
            "name": "Инаригда",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.646202,
            "latitude": 63.1777
        },
        "11243": {
            "name": "Рыбный Уян",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.6900151,
            "latitude": 54.785925
        },
        "11244": {
            "name": "Новоселово",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.699066,
            "latitude": 56.057766
        },
        "11245": {
            "name": "Конец Луг",
            "population": 55,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.7090944,
            "latitude": 56.0212521
        },
        "11246": {
            "name": "Усык",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.718498,
            "latitude": 53.349152
        },
        "11247": {
            "name": "Осиново",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.725342,
            "latitude": 56.442142
        },
        "11248": {
            "name": "Верхолугск",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.730927,
            "latitude": 57.461403
        },
        "11249": {
            "name": "Узуры",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.740532,
            "latitude": 53.322834
        },
        "11250": {
            "name": "Ерема",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.763794,
            "latitude": 60.366081
        },
        "11251": {
            "name": "Юхта",
            "population": 191,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.772171,
            "latitude": 55.896793
        },
        "11252": {
            "name": "Верхнекарелина",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.779236,
            "latitude": 57.870625
        },
        "11253": {
            "name": "Кочерикова",
            "population": 44,
            "type": "hamlet",
            "poly": [
                [
                    107.7774413,
                    53.741435
                ],
                [
                    107.7804597,
                    53.7453166
                ],
                [
                    107.7820392,
                    53.7451505
                ],
                [
                    107.7856543,
                    53.7475167
                ],
                [
                    107.7870933,
                    53.746728
                ],
                [
                    107.7870933,
                    53.7457939
                ],
                [
                    107.786251,
                    53.7423691
                ],
                [
                    107.7798631,
                    53.7403763
                ],
                [
                    107.7774413,
                    53.741435
                ]
            ],
            "longitude": 107.780983,
            "latitude": 53.743221
        },
        "11254": {
            "name": "Балышева",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.796463,
            "latitude": 57.483444
        },
        "11255": {
            "name": "Ермаки",
            "population": 43,
            "type": "hamlet",
            "poly": [
                [
                    107.8103165,
                    56.6334709
                ],
                [
                    107.8120628,
                    56.6340092
                ],
                [
                    107.8130411,
                    56.6336109
                ],
                [
                    107.8136793,
                    56.6335232
                ],
                [
                    107.8141427,
                    56.6332683
                ],
                [
                    107.8147032,
                    56.6327052
                ],
                [
                    107.8155761,
                    56.6315849
                ],
                [
                    107.8162551,
                    56.6306424
                ],
                [
                    107.8160934,
                    56.6303579
                ],
                [
                    107.8147678,
                    56.6295695
                ],
                [
                    107.8162766,
                    56.6287988
                ],
                [
                    107.8183674,
                    56.6276962
                ],
                [
                    107.819596,
                    56.6269136
                ],
                [
                    107.8202534,
                    56.6261429
                ],
                [
                    107.8191326,
                    56.6256627
                ],
                [
                    107.8198977,
                    56.6247675
                ],
                [
                    107.8203504,
                    56.6244651
                ],
                [
                    107.8207815,
                    56.6244296
                ],
                [
                    107.8214497,
                    56.6235165
                ],
                [
                    107.8218915,
                    56.6224908
                ],
                [
                    107.8220532,
                    56.6211982
                ],
                [
                    107.8217837,
                    56.6202614
                ],
                [
                    107.8207384,
                    56.6192
                ],
                [
                    107.8197081,
                    56.6184764
                ],
                [
                    107.8188698,
                    56.6182583
                ],
                [
                    107.8187479,
                    56.6186608
                ],
                [
                    107.8181603,
                    56.6187824
                ],
                [
                    107.8176592,
                    56.6190662
                ],
                [
                    107.8178021,
                    56.6205372
                ],
                [
                    107.817639,
                    56.6220165
                ],
                [
                    107.8156387,
                    56.6221324
                ],
                [
                    107.8149376,
                    56.6230464
                ],
                [
                    107.8151967,
                    56.6241196
                ],
                [
                    107.817361,
                    56.6248826
                ],
                [
                    107.814648,
                    56.6267355
                ],
                [
                    107.8136573,
                    56.6273727
                ],
                [
                    107.8125295,
                    56.6272218
                ],
                [
                    107.8111578,
                    56.6279344
                ],
                [
                    107.8107768,
                    56.6287644
                ],
                [
                    107.8115693,
                    56.6295022
                ],
                [
                    107.8104872,
                    56.6306591
                ],
                [
                    107.8114169,
                    56.6311118
                ],
                [
                    107.812118,
                    56.6310447
                ],
                [
                    107.8135964,
                    56.6301393
                ],
                [
                    107.8148004,
                    56.6305166
                ],
                [
                    107.8143584,
                    56.6314136
                ],
                [
                    107.8124838,
                    56.63278
                ],
                [
                    107.8103165,
                    56.6334709
                ]
            ],
            "longitude": 107.818321,
            "latitude": 56.625477
        },
        "11256": {
            "name": "Тарасово",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.819107,
            "latitude": 55.860291
        },
        "11257": {
            "name": "Карнаухова",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.831971,
            "latitude": 56.4798001
        },
        "11258": {
            "name": "Заборье",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.8507648,
            "latitude": 57.5946476
        },
        "11259": {
            "name": "Скобельская",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.882492,
            "latitude": 57.511627
        },
        "11260": {
            "name": "Пашня",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.8923108,
            "latitude": 57.5586354
        },
        "11261": {
            "name": "Коротково",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.907349,
            "latitude": 56.697445
        },
        "11262": {
            "name": "Поперечная",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.934486,
            "latitude": 56.728104
        },
        "11263": {
            "name": "Усть-Киренга",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.971619,
            "latitude": 57.41296
        },
        "11264": {
            "name": "Оськино",
            "population": 46,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.984222,
            "latitude": 60.810665
        },
        "11265": {
            "name": "Бор",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.021622,
            "latitude": 57.735802
        },
        "11266": {
            "name": "Старая Деревня",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.021996,
            "latitude": 57.729488
        },
        "11267": {
            "name": "Хабарова",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.038155,
            "latitude": 57.770603
        },
        "11268": {
            "name": "Коммуна",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.041461,
            "latitude": 57.7377395
        },
        "11269": {
            "name": "Мога",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.042503,
            "latitude": 60.103386
        },
        "11270": {
            "name": "Верхне-Калинина",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.11927,
            "latitude": 59.896675
        },
        "11271": {
            "name": "Сидорова",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.130196,
            "latitude": 57.761753
        },
        "11272": {
            "name": "Нижнемартыново",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.1761646,
            "latitude": 56.9206256
        },
        "11273": {
            "name": "Хамакар",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.181274,
            "latitude": 61.991501
        },
        "11274": {
            "name": "Никольск",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.190254,
            "latitude": 57.766136
        },
        "11275": {
            "name": "Кутима",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.233528,
            "latitude": 57.163082
        },
        "11276": {
            "name": "Змеиново",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.307373,
            "latitude": 57.778202
        },
        "11277": {
            "name": "Соснино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.366667,
            "latitude": 58.783333
        },
        "11278": {
            "name": "Алексеевка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.3823587,
            "latitude": 57.8552158
        },
        "11279": {
            "name": "Воронежский",
            "population": 156,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.395889,
            "latitude": 57.866863
        },
        "11280": {
            "name": "Наканно",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.452057,
            "latitude": 62.9007
        },
        "11281": {
            "name": "Салтыкова",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.47908,
            "latitude": 57.946499
        },
        "11282": {
            "name": "Подъельник",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.554375,
            "latitude": 57.989712
        },
        "11283": {
            "name": "Никулина",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.594398,
            "latitude": 57.988884
        },
        "11284": {
            "name": "Банщиково",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.620132,
            "latitude": 58.021782
        },
        "11285": {
            "name": "Чечуйск",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.708015,
            "latitude": 58.0728
        },
        "11286": {
            "name": "Вишнякова",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.860237,
            "latitude": 58.133228
        },
        "11287": {
            "name": "Орлова",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.105042,
            "latitude": 58.279102
        },
        "11288": {
            "name": "Сполошино",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.114922,
            "latitude": 58.260986
        },
        "11289": {
            "name": "Золотой",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.236778,
            "latitude": 58.225655
        },
        "11290": {
            "name": "Шенара",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.3,
            "latitude": 59.716667
        },
        "11291": {
            "name": "Инела",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.3333329,
            "latitude": 59.883333
        },
        "11292": {
            "name": "Корек",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.3579019,
            "latitude": 60.27471
        },
        "11293": {
            "name": "Кондратьева",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.433333,
            "latitude": 61.883333
        },
        "11294": {
            "name": "Мироново",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.641029,
            "latitude": 58.301914
        },
        "11295": {
            "name": "Дарьина",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.657852,
            "latitude": 58.316414
        },
        "11296": {
            "name": "Мархая",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.683333,
            "latitude": 61.983333
        },
        "11297": {
            "name": "Ичера",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.775314,
            "latitude": 58.511806
        },
        "11298": {
            "name": "Мутина",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.034752,
            "latitude": 58.627182
        },
        "11299": {
            "name": "Частых",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.8509901,
            "latitude": 58.6404921
        },
        "11300": {
            "name": "Чайка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.4818857,
            "latitude": 59.0001456
        },
        "11301": {
            "name": "Садки",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.952187,
            "latitude": 59.200512
        },
        "11302": {
            "name": "Чуя",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.427834,
            "latitude": 59.266373
        },
        "11303": {
            "name": "Слюдянка",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.770447,
            "latitude": 57.971142
        },
        "11304": {
            "name": "Заря",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.928894,
            "latitude": 58.298077
        },
        "11305": {
            "name": "Воронцовка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.954536,
            "latitude": 58.722614
        },
        "11306": {
            "name": "Тетеринск",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.966072,
            "latitude": 58.287895
        },
        "11307": {
            "name": "Колотовка",
            "population": 165,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.201347,
            "latitude": 58.215435
        },
        "11308": {
            "name": "Мусковит",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.287155,
            "latitude": 58.213455
        },
        "11309": {
            "name": "Большой Северный",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.36628,
            "latitude": 58.193153
        },
        "11310": {
            "name": "Кяхтинский",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.235512,
            "latitude": 57.944382
        },
        "11311": {
            "name": "Васильевский",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.331573,
            "latitude": 58.14225
        },
        "11312": {
            "name": "Апрельск",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.587051,
            "latitude": 58.18882
        },
        "11313": {
            "name": "Андреевский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.8333329,
            "latitude": 59.483333
        },
        "11314": {
            "name": "Нерпо",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.318947,
            "latitude": 57.473873
        },
        "11315": {
            "name": "Червонный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.683333,
            "latitude": 59.616667
        },
        "11316": {
            "name": "Светлый",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.9658186,
            "latitude": 58.4370311
        },
        "11317": {
            "name": "Майский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.133333,
            "latitude": 59.616667
        },
        "11318": {
            "name": "Берёзовка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.1499999,
            "latitude": 57.766667
        },
        "11319": {
            "name": "Старая Берёзовская",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.2,
            "latitude": 57.733333
        },
        "11320": {
            "name": "Орон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.4505559,
            "latitude": 57.189722
        },
        "11321": {
            "name": "Сисково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.466667,
            "latitude": 57.416667
        },
        "11322": {
            "name": "Базный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.616667,
            "latitude": 57.416667
        },
        "11323": {
            "name": "Патом",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.897797,
            "latitude": 60.07719
        },
        "11324": {
            "name": "Molvo",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 116.9816494,
            "latitude": 59.2391075
        },
        "11325": {
            "name": "Воскресенский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 117.2,
            "latitude": 59.45
        },
        "11326": {
            "name": "Петровка",
            "population": 171,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.0570508,
            "latitude": 53.3637627
        },
        "11327": {
            "name": "Бигельды",
            "population": 30,
            "type": "hamlet",
            "poly": [
                [
                    78.13328,
                    53.4612551
                ],
                [
                    78.1334181,
                    53.4645487
                ],
                [
                    78.1350532,
                    53.4648331
                ],
                [
                    78.1378564,
                    53.4628165
                ],
                [
                    78.1400862,
                    53.4630821
                ],
                [
                    78.1412966,
                    53.4621655
                ],
                [
                    78.1401817,
                    53.4612995
                ],
                [
                    78.1418382,
                    53.4578857
                ],
                [
                    78.1387695,
                    53.4545474
                ],
                [
                    78.1360195,
                    53.454168
                ],
                [
                    78.1351806,
                    53.4544526
                ],
                [
                    78.13328,
                    53.4612551
                ]
            ],
            "longitude": 78.136777,
            "latitude": 53.4581837
        },
        "11328": {
            "name": "Чернавка",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.1572238,
            "latitude": 53.1725792
        },
        "11329": {
            "name": "Мирный",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.2312924,
            "latitude": 53.4168367
        },
        "11330": {
            "name": "Цветополь",
            "population": 212,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.2433435,
            "latitude": 53.1970587
        },
        "11331": {
            "name": "Первомайское",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.2517899,
            "latitude": 53.3551118
        },
        "11332": {
            "name": "Кинерал",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.2805793,
            "latitude": 53.4586068
        },
        "11333": {
            "name": "Павловка",
            "population": 135,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.389185,
            "latitude": 52.9403033
        },
        "11334": {
            "name": "Райгород",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.4042514,
            "latitude": 52.8630395
        },
        "11335": {
            "name": "Асямовка",
            "population": 235,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.4714955,
            "latitude": 53.2670918
        },
        "11336": {
            "name": "Айнак",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.475436,
            "latitude": 53.1823828
        },
        "11337": {
            "name": "Екатериновка",
            "population": 73,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.4967319,
            "latitude": 52.8550208
        },
        "11338": {
            "name": "Бурлинка",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.4967794,
            "latitude": 53.1960626
        },
        "11339": {
            "name": "Балластный Карьер",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.5165054,
            "latitude": 53.1308048
        },
        "11340": {
            "name": "Новоалексеевка",
            "population": 140,
            "type": "hamlet",
            "poly": [
                [
                    78.556128,
                    53.383709
                ],
                [
                    78.5586766,
                    53.3924753
                ],
                [
                    78.5636359,
                    53.3948412
                ],
                [
                    78.5904164,
                    53.3922781
                ],
                [
                    78.5954305,
                    53.3891598
                ],
                [
                    78.5981309,
                    53.3874803
                ],
                [
                    78.5973595,
                    53.3820903
                ],
                [
                    78.5955617,
                    53.3812439
                ],
                [
                    78.5748331,
                    53.3825397
                ],
                [
                    78.556128,
                    53.383709
                ]
            ],
            "longitude": 78.5800569,
            "latitude": 53.3870859
        },
        "11341": {
            "name": "Орловка",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.5958464,
            "latitude": 52.6128065
        },
        "11342": {
            "name": "Новознаменка",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.6261097,
            "latitude": 52.575891
        },
        "11343": {
            "name": "Старопесчаное",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.6413084,
            "latitude": 53.4033861
        },
        "11344": {
            "name": "Рожковка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.6820969,
            "latitude": 53.4660047
        },
        "11345": {
            "name": "Куатовка",
            "population": 54,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.6947544,
            "latitude": 52.8768795
        },
        "11346": {
            "name": "Новопокровка",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.7081023,
            "latitude": 52.482224
        },
        "11347": {
            "name": "Новокиевка",
            "population": 230,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.7190119,
            "latitude": 52.7348373
        },
        "11348": {
            "name": "Попасное",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.7202105,
            "latitude": 52.4677542
        },
        "11349": {
            "name": "Троицк",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.7734836,
            "latitude": 52.6205636
        },
        "11350": {
            "name": "Максимовка",
            "population": 194,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.7741396,
            "latitude": 53.089848
        },
        "11351": {
            "name": "Андреевка",
            "population": 87,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.7776569,
            "latitude": 53.1023179
        },
        "11352": {
            "name": "Новосовхозный",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.8389206,
            "latitude": 52.6689723
        },
        "11353": {
            "name": "Эстлань",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.84166,
            "latitude": 52.519375
        },
        "11354": {
            "name": "Волчий Ракит",
            "population": 49,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.8442146,
            "latitude": 53.3748786
        },
        "11355": {
            "name": "Ямбор",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.8678981,
            "latitude": 52.7365748
        },
        "11356": {
            "name": "Канна",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.873352,
            "latitude": 52.893448
        },
        "11357": {
            "name": "Весёлое",
            "population": 36,
            "type": "hamlet",
            "poly": [
                [
                    78.8727011,
                    53.0530006
                ],
                [
                    78.8741173,
                    53.0558689
                ],
                [
                    78.8775505,
                    53.058345
                ],
                [
                    78.884417,
                    53.0588609
                ],
                [
                    78.8924849,
                    53.058345
                ],
                [
                    78.8990082,
                    53.0562816
                ],
                [
                    78.9034285,
                    53.0539292
                ],
                [
                    78.9058316,
                    53.0507305
                ],
                [
                    78.9038147,
                    53.0474078
                ],
                [
                    78.8993086,
                    53.0458804
                ],
                [
                    78.8948883,
                    53.0465822
                ],
                [
                    78.8892235,
                    53.0501938
                ],
                [
                    78.8847603,
                    53.0514322
                ],
                [
                    78.8789238,
                    53.0518449
                ],
                [
                    78.8727011,
                    53.0530006
                ]
            ],
            "longitude": 78.8796659,
            "latitude": 53.0551909
        },
        "11358": {
            "name": "Воскресеновка",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.8824697,
            "latitude": 52.4277281
        },
        "11359": {
            "name": "Кротовка",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.9007476,
            "latitude": 52.5828195
        },
        "11360": {
            "name": "Кирилловка",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.9137399,
            "latitude": 53.4664315
        },
        "11361": {
            "name": "Карпиловка",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.970642,
            "latitude": 52.911505
        },
        "11362": {
            "name": "Городецкий",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 78.9792245,
            "latitude": 52.707901
        },
        "11363": {
            "name": "Мирный",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.0520621,
            "latitude": 52.4708681
        },
        "11364": {
            "name": "Георгиевка",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.0563863,
            "latitude": 53.0106599
        },
        "11365": {
            "name": "Платовка",
            "population": 269,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.0571805,
            "latitude": 52.3523643
        },
        "11366": {
            "name": "Владимировка",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.0774291,
            "latitude": 53.0962003
        },
        "11367": {
            "name": "Кирей",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.0827203,
            "latitude": 52.5178009
        },
        "11368": {
            "name": "Ермаковка",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.0953807,
            "latitude": 52.8368498
        },
        "11369": {
            "name": "Зелёная Роща",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.1120272,
            "latitude": 53.1865776
        },
        "11370": {
            "name": "Кильты",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.124396,
            "latitude": 52.6163967
        },
        "11371": {
            "name": "Николаевка",
            "population": 232,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.126602,
            "latitude": 52.948376
        },
        "11372": {
            "name": "Лесное",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.143639,
            "latitude": 53.351631
        },
        "11373": {
            "name": "Новороссийка",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.1562464,
            "latitude": 52.7862928
        },
        "11374": {
            "name": "Александровка",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.167542,
            "latitude": 53.307957
        },
        "11375": {
            "name": "Бославино",
            "population": 78,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.190598,
            "latitude": 52.844044
        },
        "11376": {
            "name": "Нововознесенка",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.1960888,
            "latitude": 52.1918075
        },
        "11377": {
            "name": "Красноармейский",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.21891,
            "latitude": 53.245193
        },
        "11378": {
            "name": "Неводное",
            "population": 212,
            "type": "hamlet",
            "poly": [
                [
                    79.2175929,
                    51.9695804
                ],
                [
                    79.2304733,
                    51.9638852
                ],
                [
                    79.245627,
                    51.9658459
                ],
                [
                    79.2424446,
                    51.9533332
                ],
                [
                    79.2342618,
                    51.9518389
                ],
                [
                    79.2209267,
                    51.9531464
                ],
                [
                    79.218199,
                    51.9557613
                ],
                [
                    79.2175929,
                    51.9695804
                ]
            ],
            "longitude": 79.2306141,
            "latitude": 51.9590185
        },
        "11379": {
            "name": "Красная Слобода",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.2337262,
            "latitude": 52.6778582
        },
        "11380": {
            "name": "24 км",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.2484088,
            "latitude": 52.6491793
        },
        "11381": {
            "name": "Белоцерковка",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.2495212,
            "latitude": 52.7275762
        },
        "11382": {
            "name": "Даниловка",
            "population": 79,
            "type": "hamlet",
            "poly": [
                [
                    79.2673935,
                    53.1261713
                ],
                [
                    79.2697968,
                    53.1307035
                ],
                [
                    79.2740454,
                    53.1358787
                ],
                [
                    79.2750753,
                    53.1396889
                ],
                [
                    79.2782082,
                    53.143576
                ],
                [
                    79.2797102,
                    53.1475142
                ],
                [
                    79.284903,
                    53.1451204
                ],
                [
                    79.2872633,
                    53.1421602
                ],
                [
                    79.2889799,
                    53.1380413
                ],
                [
                    79.2912544,
                    53.135235
                ],
                [
                    79.2905678,
                    53.1311155
                ],
                [
                    79.2855896,
                    53.1290555
                ],
                [
                    79.279753,
                    53.1273045
                ],
                [
                    79.2694534,
                    53.1241113
                ],
                [
                    79.2673935,
                    53.1261713
                ]
            ],
            "longitude": 79.2817903,
            "latitude": 53.1320603
        },
        "11383": {
            "name": "Дворское",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.29641,
            "latitude": 53.29903
        },
        "11384": {
            "name": "Сергеевка",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.3141418,
            "latitude": 52.6526342
        },
        "11385": {
            "name": "Петровка",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.3348483,
            "latitude": 52.4578841
        },
        "11386": {
            "name": "Озёрное",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.3385503,
            "latitude": 52.5148592
        },
        "11387": {
            "name": "Иркутский",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.3710331,
            "latitude": 51.9514015
        },
        "11388": {
            "name": "Макаровка",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.420067,
            "latitude": 52.293591
        },
        "11389": {
            "name": "Восход",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.4607255,
            "latitude": 53.5244066
        },
        "11390": {
            "name": "Алексеевка",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.472383,
            "latitude": 53.6220348
        },
        "11391": {
            "name": "Николаевка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.4739643,
            "latitude": 51.9429891
        },
        "11392": {
            "name": "Добровка",
            "population": 32,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.5189762,
            "latitude": 53.3079568
        },
        "11393": {
            "name": "Яготинская",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.523993,
            "latitude": 52.7250925
        },
        "11394": {
            "name": "Берёзовка",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.538605,
            "latitude": 53.474827
        },
        "11395": {
            "name": "Слава",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.5658392,
            "latitude": 52.385656
        },
        "11396": {
            "name": "Западный Угол",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.57146,
            "latitude": 52.1305022
        },
        "11397": {
            "name": "Пановка",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.5998457,
            "latitude": 53.2634059
        },
        "11398": {
            "name": "Екатериновка",
            "population": 179,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.610916,
            "latitude": 52.567303
        },
        "11399": {
            "name": "Красный Яр",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.6116002,
            "latitude": 52.4635686
        },
        "11400": {
            "name": "Калиновка",
            "population": 89,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.6463319,
            "latitude": 53.7035417
        },
        "11401": {
            "name": "Хабары",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.678224,
            "latitude": 53.7636479
        },
        "11402": {
            "name": "Байгамут",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.7008503,
            "latitude": 52.6414194
        },
        "11403": {
            "name": "Московка",
            "population": 136,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.7867613,
            "latitude": 53.4329183
        },
        "11404": {
            "name": "Циберманово",
            "population": 133,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.8152935,
            "latitude": 53.3024217
        },
        "11405": {
            "name": "Сибирский Гигант",
            "population": 228,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.8290105,
            "latitude": 53.2371841
        },
        "11406": {
            "name": "Талы",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.0286938,
            "latitude": 52.3081458
        },
        "11407": {
            "name": "Бор-Кособулат",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.8293048,
            "latitude": 51.4142744
        },
        "11408": {
            "name": "Тизек",
            "population": 247,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.8465219,
            "latitude": 52.5918641
        },
        "11409": {
            "name": "Урываево",
            "population": 83,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.8563404,
            "latitude": 53.7634213
        },
        "11410": {
            "name": "Заря",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.8904867,
            "latitude": 53.7630729
        },
        "11411": {
            "name": "Восточный",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.9205391,
            "latitude": 53.5724894
        },
        "11412": {
            "name": "Михайловка",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.9396658,
            "latitude": 53.0371023
        },
        "11413": {
            "name": "Михайловка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.9536384,
            "latitude": 53.5070029
        },
        "11414": {
            "name": "Береговой",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 79.9958874,
            "latitude": 53.2707837
        },
        "11415": {
            "name": "Алексеевский",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.0260671,
            "latitude": 53.9253108
        },
        "11416": {
            "name": "Сухой Ракит",
            "population": 60,
            "type": "hamlet",
            "poly": [
                [
                    80.051011,
                    52.8854557
                ],
                [
                    80.0528944,
                    52.9049339
                ],
                [
                    80.0582757,
                    52.906719
                ],
                [
                    80.0701144,
                    52.906232
                ],
                [
                    80.0698454,
                    52.8848063
                ],
                [
                    80.051011,
                    52.8854557
                ]
            ],
            "longitude": 80.0615044,
            "latitude": 52.8963333
        },
        "11417": {
            "name": "Тополинский Лесхоз",
            "population": 234,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.0837721,
            "latitude": 50.9378231
        },
        "11418": {
            "name": "Николаевка",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.0854047,
            "latitude": 53.183128
        },
        "11419": {
            "name": "Лебедиха",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.1100164,
            "latitude": 53.6203567
        },
        "11420": {
            "name": "Ляпуново",
            "population": 174,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.1379785,
            "latitude": 51.2909435
        },
        "11421": {
            "name": "Ленский",
            "population": 217,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.1401723,
            "latitude": 54.0082909
        },
        "11422": {
            "name": "Украинский",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.1548061,
            "latitude": 53.2313654
        },
        "11423": {
            "name": "Добровольский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.1586526,
            "latitude": 53.2066937
        },
        "11424": {
            "name": "Новотюменцево",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.2031457,
            "latitude": 53.0661033
        },
        "11425": {
            "name": "Глядень-4",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    80.1983101,
                    52.7578559
                ],
                [
                    80.2006275,
                    52.7614399
                ],
                [
                    80.2030307,
                    52.762219
                ],
                [
                    80.2072364,
                    52.7613879
                ],
                [
                    80.211013,
                    52.7616528
                ],
                [
                    80.215562,
                    52.7564586
                ],
                [
                    80.2164203,
                    52.7519859
                ],
                [
                    80.2113563,
                    52.7518301
                ],
                [
                    80.2107555,
                    52.7493883
                ],
                [
                    80.2026016,
                    52.7476738
                ],
                [
                    80.1983101,
                    52.7578559
                ]
            ],
            "longitude": 80.2073747,
            "latitude": 52.7560501
        },
        "11426": {
            "name": "Красноармейский",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.2253765,
            "latitude": 53.5721313
        },
        "11427": {
            "name": "Нефтебаза",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.2295617,
            "latitude": 53.7502622
        },
        "11428": {
            "name": "Петровский",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.2460926,
            "latitude": 54.0170531
        },
        "11429": {
            "name": "Панкрушиха",
            "population": 150,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.2603313,
            "latitude": 53.7582492
        },
        "11430": {
            "name": "Горькое",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.2679256,
            "latitude": 51.179072
        },
        "11431": {
            "name": "Курган",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.288719,
            "latitude": 53.100853
        },
        "11432": {
            "name": "Плодосовхоз",
            "population": 148,
            "type": "hamlet",
            "poly": [
                [
                    80.2844929,
                    51.9958658
                ],
                [
                    80.2939343,
                    51.9981911
                ],
                [
                    80.3020027,
                    51.9942284
                ],
                [
                    80.292046,
                    51.9878323
                ],
                [
                    80.2844929,
                    51.9958658
                ]
            ],
            "longitude": 80.2948973,
            "latitude": 51.9947821
        },
        "11433": {
            "name": "Хорошавка",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.2976727,
            "latitude": 52.8742546
        },
        "11434": {
            "name": "Первые Коростели",
            "population": 114,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.3285858,
            "latitude": 51.223337
        },
        "11435": {
            "name": "Шубинка",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.3436457,
            "latitude": 52.7661066
        },
        "11436": {
            "name": "Бирючий",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.3448374,
            "latitude": 53.6657399
        },
        "11437": {
            "name": "Усть-Кормиха",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.3551556,
            "latitude": 51.8265918
        },
        "11438": {
            "name": "Павловка",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.3787002,
            "latitude": 53.2342031
        },
        "11439": {
            "name": "Дмитриевка",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.4211184,
            "latitude": 53.0433618
        },
        "11440": {
            "name": "Кызылту",
            "population": 124,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.4263657,
            "latitude": 53.9923298
        },
        "11441": {
            "name": "Заречный",
            "population": 107,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.4349355,
            "latitude": 53.8138122
        },
        "11442": {
            "name": "Чуманка",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.4659965,
            "latitude": 53.5115579
        },
        "11443": {
            "name": "Чернокоровниково",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.4712469,
            "latitude": 51.6163348
        },
        "11444": {
            "name": "Калиновка",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.480431,
            "latitude": 52.849228
        },
        "11445": {
            "name": "Покровка",
            "population": 226,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.4911349,
            "latitude": 53.1289519
        },
        "11446": {
            "name": "Павловский",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.5101381,
            "latitude": 53.6394751
        },
        "11447": {
            "name": "Ганёнок",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.5112325,
            "latitude": 53.5712899
        },
        "11448": {
            "name": "Кормиха",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.5364715,
            "latitude": 51.6954364
        },
        "11449": {
            "name": "Раздольный",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.557051,
            "latitude": 53.6143289
        },
        "11450": {
            "name": "Конёво",
            "population": 158,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.5599192,
            "latitude": 53.8699469
        },
        "11451": {
            "name": "Новокуликовский",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.5694718,
            "latitude": 52.9942968
        },
        "11452": {
            "name": "Александровка",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.585754,
            "latitude": 52.90575
        },
        "11453": {
            "name": "Зелёная Дубрава",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.5902526,
            "latitude": 52.4888392
        },
        "11454": {
            "name": "Речка-Кормиха",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    80.604817,
                    51.819518
                ],
                [
                    80.6083905,
                    51.8220983
                ],
                [
                    80.616693,
                    51.8223738
                ],
                [
                    80.6185993,
                    51.8217165
                ],
                [
                    80.6160613,
                    51.8179007
                ],
                [
                    80.6161034,
                    51.8139183
                ],
                [
                    80.6147941,
                    51.8134786
                ],
                [
                    80.6134751,
                    51.8174447
                ],
                [
                    80.604817,
                    51.819518
                ]
            ],
            "longitude": 80.6129163,
            "latitude": 51.820004
        },
        "11455": {
            "name": "Рыбные Борки",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.6165096,
            "latitude": 53.1951857
        },
        "11456": {
            "name": "Московский",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.631162,
            "latitude": 54.0072026
        },
        "11457": {
            "name": "Новосоветский",
            "population": 24,
            "type": "hamlet",
            "poly": [
                [
                    80.6334264,
                    51.826538
                ],
                [
                    80.6356412,
                    51.8289331
                ],
                [
                    80.6432652,
                    51.8303595
                ],
                [
                    80.6503033,
                    51.8242061
                ],
                [
                    80.6391454,
                    51.8204925
                ],
                [
                    80.6334264,
                    51.826538
                ]
            ],
            "longitude": 80.6367936,
            "latitude": 51.8269502
        },
        "11458": {
            "name": "Первомайский",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.6509353,
            "latitude": 53.728
        },
        "11459": {
            "name": "Световская",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.6589404,
            "latitude": 53.7188112
        },
        "11460": {
            "name": "Александровка",
            "population": 231,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.6852715,
            "latitude": 52.688952
        },
        "11461": {
            "name": "Зелёная Дубрава",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.708838,
            "latitude": 53.6826027
        },
        "11462": {
            "name": "Соболи",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.7303153,
            "latitude": 53.0966803
        },
        "11463": {
            "name": "Борисовка",
            "population": 200,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.7773088,
            "latitude": 51.5580151
        },
        "11464": {
            "name": "Краснодубровский",
            "population": 203,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.7853669,
            "latitude": 52.915269
        },
        "11465": {
            "name": "Тамбовский",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.8899181,
            "latitude": 53.7150386
        },
        "11466": {
            "name": "Долино",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.9097172,
            "latitude": 51.4890641
        },
        "11467": {
            "name": "Первомайский",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.9191697,
            "latitude": 52.7727531
        },
        "11468": {
            "name": "Петухов Лог",
            "population": 115,
            "type": "hamlet",
            "poly": [
                [
                    80.9342312,
                    51.8242061
                ],
                [
                    80.9378361,
                    51.8283438
                ],
                [
                    80.9422093,
                    51.8306878
                ],
                [
                    80.9450459,
                    51.8316325
                ],
                [
                    80.9503674,
                    51.8304655
                ],
                [
                    80.9587788,
                    51.8253732
                ],
                [
                    80.9635854,
                    51.8231451
                ],
                [
                    80.9620404,
                    51.8203863
                ],
                [
                    80.9579205,
                    51.8181579
                ],
                [
                    80.9543156,
                    51.8126398
                ],
                [
                    80.9471059,
                    51.8155051
                ],
                [
                    80.9477925,
                    51.8176275
                ],
                [
                    80.9486508,
                    51.8192192
                ],
                [
                    80.9477925,
                    51.8203863
                ],
                [
                    80.9465909,
                    51.8207047
                ],
                [
                    80.9441876,
                    51.8194314
                ],
                [
                    80.942986,
                    51.8194314
                ],
                [
                    80.9342312,
                    51.8242061
                ]
            ],
            "longitude": 80.9511953,
            "latitude": 51.8247655
        },
        "11469": {
            "name": "Красноряжский",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.9668369,
            "latitude": 53.9259509
        },
        "11470": {
            "name": "Капустинка",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.9936329,
            "latitude": 53.3183713
        },
        "11471": {
            "name": "Журавли",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 80.999599,
            "latitude": 52.7446842
        },
        "11472": {
            "name": "Новодубровский",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.0335007,
            "latitude": 53.7853933
        },
        "11473": {
            "name": "Новая Дубрава",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.0337451,
            "latitude": 53.712283
        },
        "11474": {
            "name": "Весёлая Дубрава",
            "population": 139,
            "type": "hamlet",
            "poly": [
                [
                    81.0188603,
                    52.2594294
                ],
                [
                    81.0522474,
                    52.2751551
                ],
                [
                    81.0548172,
                    52.2751994
                ],
                [
                    81.0473561,
                    52.2708807
                ],
                [
                    81.0506177,
                    52.2663636
                ],
                [
                    81.0475278,
                    52.2639471
                ],
                [
                    81.0468411,
                    52.2584837
                ],
                [
                    81.040318,
                    52.2555415
                ],
                [
                    81.0380864,
                    52.2584837
                ],
                [
                    81.0336231,
                    52.2585888
                ],
                [
                    81.0283993,
                    52.2575369
                ],
                [
                    81.0188603,
                    52.2594294
                ]
            ],
            "longitude": 81.0353517,
            "latitude": 52.2658202
        },
        "11475": {
            "name": "Песчаный Борок",
            "population": 117,
            "type": "hamlet",
            "poly": [
                [
                    81.0507893,
                    51.6463512
                ],
                [
                    81.050961,
                    51.6490141
                ],
                [
                    81.0561108,
                    51.6530614
                ],
                [
                    81.0641789,
                    51.6559369
                ],
                [
                    81.0701871,
                    51.6485881
                ],
                [
                    81.0672687,
                    51.6463512
                ],
                [
                    81.0607457,
                    51.6433686
                ],
                [
                    81.0549092,
                    51.6441143
                ],
                [
                    81.0507893,
                    51.6463512
                ]
            ],
            "longitude": 81.060529,
            "latitude": 51.6490588
        },
        "11476": {
            "name": "Новодубровский",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.0615812,
            "latitude": 53.7156358
        },
        "11477": {
            "name": "Жерновцы",
            "population": 50,
            "type": "hamlet",
            "poly": [
                [
                    81.0724187,
                    51.9331448
                ],
                [
                    81.0806584,
                    51.9409765
                ],
                [
                    81.0830617,
                    51.9387541
                ],
                [
                    81.0909581,
                    51.9371666
                ],
                [
                    81.0904431,
                    51.9355791
                ],
                [
                    81.0866666,
                    51.9318746
                ],
                [
                    81.08186,
                    51.9291226
                ],
                [
                    81.0763669,
                    51.930922
                ],
                [
                    81.0724187,
                    51.9331448
                ]
            ],
            "longitude": 81.0830874,
            "latitude": 51.9361344
        },
        "11478": {
            "name": "Песчаный",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.0877367,
            "latitude": 51.632393
        },
        "11479": {
            "name": "538 км",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.0887012,
            "latitude": 51.2535039
        },
        "11480": {
            "name": "Радостный",
            "population": 223,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.0921407,
            "latitude": 53.9489051
        },
        "11481": {
            "name": "Большой Лог",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.0931544,
            "latitude": 53.8805421
        },
        "11482": {
            "name": "543 км",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.1017992,
            "latitude": 51.215741
        },
        "11483": {
            "name": "Зерно",
            "population": 239,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.106854,
            "latitude": 51.3622727
        },
        "11484": {
            "name": "Сафроново",
            "population": 246,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.1105358,
            "latitude": 53.1919533
        },
        "11485": {
            "name": "Сибирь",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.1137156,
            "latitude": 51.6897369
        },
        "11486": {
            "name": "Колос",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.1371544,
            "latitude": 51.3921495
        },
        "11487": {
            "name": "519 км",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.1497694,
            "latitude": 51.4252045
        },
        "11488": {
            "name": "512 км",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.1773391,
            "latitude": 51.4784097
        },
        "11489": {
            "name": "Ивановка",
            "population": 1,
            "type": "hamlet",
            "poly": [
                [
                    81.1769604,
                    51.8563429
                ],
                [
                    81.1774754,
                    51.8581452
                ],
                [
                    81.1798787,
                    51.8587814
                ],
                [
                    81.1809087,
                    51.8599476
                ],
                [
                    81.19035,
                    51.8564488
                ],
                [
                    81.1942982,
                    51.8563429
                ],
                [
                    81.1972165,
                    51.8492387
                ],
                [
                    81.1991048,
                    51.8439363
                ],
                [
                    81.1951566,
                    51.8407547
                ],
                [
                    81.1896634,
                    51.8408607
                ],
                [
                    81.1860585,
                    51.8425577
                ],
                [
                    81.1810803,
                    51.8459514
                ],
                [
                    81.1793637,
                    51.852738
                ],
                [
                    81.1769604,
                    51.8563429
                ]
            ],
            "longitude": 81.1894451,
            "latitude": 51.850412
        },
        "11490": {
            "name": "Новомихайловка",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.203225,
            "latitude": 51.1424873
        },
        "11491": {
            "name": "Подветренно-Телеутское",
            "population": 50,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.2080807,
            "latitude": 53.4784921
        },
        "11492": {
            "name": "Новоматвеевка",
            "population": 100,
            "type": "hamlet",
            "poly": [
                [
                    81.2099408,
                    51.3211624
                ],
                [
                    81.2126701,
                    51.3344049
                ],
                [
                    81.2171654,
                    51.3339284
                ],
                [
                    81.2135531,
                    51.3206356
                ],
                [
                    81.2099408,
                    51.3211624
                ]
            ],
            "longitude": 81.2128801,
            "latitude": 51.3274634
        },
        "11493": {
            "name": "Караси",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.2322804,
            "latitude": 53.8360903
        },
        "11494": {
            "name": "Ильинский",
            "population": 135,
            "type": "hamlet",
            "poly": [
                [
                    81.2166142,
                    52.3742289
                ],
                [
                    81.2171292,
                    52.3746481
                ],
                [
                    81.2450718,
                    52.3901899
                ],
                [
                    81.2468266,
                    52.3896317
                ],
                [
                    81.2459683,
                    52.3873269
                ],
                [
                    81.2504315,
                    52.3874317
                ],
                [
                    81.2519765,
                    52.3841838
                ],
                [
                    81.2468266,
                    52.3820882
                ],
                [
                    81.24614,
                    52.3762201
                ],
                [
                    81.2219357,
                    52.3701415
                ],
                [
                    81.2166142,
                    52.3742289
                ]
            ],
            "longitude": 81.232717,
            "latitude": 52.379888
        },
        "11495": {
            "name": "Добрая Воля",
            "population": 91,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.2384314,
            "latitude": 52.9019096
        },
        "11496": {
            "name": "Тракторный",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.2445666,
            "latitude": 51.5783461
        },
        "11497": {
            "name": "Овечкино",
            "population": 120,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.2487102,
            "latitude": 52.9698231
        },
        "11498": {
            "name": "498 км",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.2544896,
            "latitude": 51.5955861
        },
        "11499": {
            "name": "Мирный",
            "population": 245,
            "type": "hamlet",
            "poly": [
                [
                    81.2559247,
                    51.7779229
                ],
                [
                    81.2564397,
                    51.780047
                ],
                [
                    81.2595295,
                    51.7836578
                ],
                [
                    81.256783,
                    51.7861002
                ],
                [
                    81.2584995,
                    51.787693
                ],
                [
                    81.2646794,
                    51.7892858
                ],
                [
                    81.2681126,
                    51.7909847
                ],
                [
                    81.2717175,
                    51.7896043
                ],
                [
                    81.2791237,
                    51.7875028
                ],
                [
                    81.275593,
                    51.7837425
                ],
                [
                    81.2809218,
                    51.7812374
                ],
                [
                    81.2761807,
                    51.7794098
                ],
                [
                    81.2693143,
                    51.7777103
                ],
                [
                    81.2686276,
                    51.7787725
                ],
                [
                    81.2662244,
                    51.7804718
                ],
                [
                    81.2597012,
                    51.7762235
                ],
                [
                    81.2559247,
                    51.7779229
                ]
            ],
            "longitude": 81.2670594,
            "latitude": 51.7847925
        },
        "11500": {
            "name": "Масляха",
            "population": 222,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.267998,
            "latitude": 54.053089
        },
        "11501": {
            "name": "Новоувальский",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.2808792,
            "latitude": 53.8579499
        },
        "11502": {
            "name": "Память Коммунаров",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.2967858,
            "latitude": 52.7295433
        },
        "11503": {
            "name": "Соколово",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.3101283,
            "latitude": 53.9948279
        },
        "11504": {
            "name": "Самарский",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.3345378,
            "latitude": 53.518847
        },
        "11505": {
            "name": "Малетино",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.4052835,
            "latitude": 54.0411052
        },
        "11506": {
            "name": "Гоноховский",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.4480435,
            "latitude": 52.9726599
        },
        "11507": {
            "name": "Красноярка",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.457033,
            "latitude": 52.0888709
        },
        "11508": {
            "name": "Алейниковский",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.4616903,
            "latitude": 51.9353732
        },
        "11509": {
            "name": "Ключи",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.4824063,
            "latitude": 53.9650763
        },
        "11510": {
            "name": "Латкинский",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.5162746,
            "latitude": 53.169767
        },
        "11511": {
            "name": "Плотниково",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.517925,
            "latitude": 53.54395
        },
        "11512": {
            "name": "VI Конгресса Коминтерна",
            "population": 216,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.525658,
            "latitude": 51.3115651
        },
        "11513": {
            "name": "Мыски",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.5385243,
            "latitude": 53.6899686
        },
        "11514": {
            "name": "Мирный",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.5538561,
            "latitude": 51.0587118
        },
        "11515": {
            "name": "Мамонтово",
            "population": 120,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.5582739,
            "latitude": 52.1537689
        },
        "11516": {
            "name": "Калиновка",
            "population": 67,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.5734873,
            "latitude": 53.4652693
        },
        "11517": {
            "name": "3 Интернационал",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.5950925,
            "latitude": 53.8804474
        },
        "11518": {
            "name": "Раздольное",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.6141885,
            "latitude": 50.8662122
        },
        "11519": {
            "name": "Родина",
            "population": 13,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.6150483,
            "latitude": 53.8011741
        },
        "11520": {
            "name": "Петровский",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.6277938,
            "latitude": 52.2586249
        },
        "11521": {
            "name": "Степной",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.6346126,
            "latitude": 50.9996427
        },
        "11522": {
            "name": "Новый Мир",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.6419082,
            "latitude": 51.7326015
        },
        "11523": {
            "name": "Назаровка",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.6718708,
            "latitude": 51.425607
        },
        "11524": {
            "name": "Духовая",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.6925207,
            "latitude": 53.7997672
        },
        "11525": {
            "name": "Благодатный",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.6926385,
            "latitude": 51.6411468
        },
        "11526": {
            "name": "Павловка",
            "population": 141,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7072752,
            "latitude": 51.1587061
        },
        "11527": {
            "name": "Вознесенский",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7084798,
            "latitude": 52.8388484
        },
        "11528": {
            "name": "Невский",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7106114,
            "latitude": 52.2971168
        },
        "11529": {
            "name": "Тушканиха",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7127201,
            "latitude": 51.2596996
        },
        "11530": {
            "name": "Кучеровка",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7250216,
            "latitude": 50.9039043
        },
        "11531": {
            "name": "Чебуриха",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7506033,
            "latitude": 51.5083193
        },
        "11532": {
            "name": "Ходаевский",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7579746,
            "latitude": 51.648837
        },
        "11533": {
            "name": "Междуречье",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7625498,
            "latitude": 51.1031336
        },
        "11534": {
            "name": "Михайловка",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7729002,
            "latitude": 53.9208216
        },
        "11535": {
            "name": "Берёзовка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.776123,
            "latitude": 52.198547
        },
        "11536": {
            "name": "Варшава",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7789551,
            "latitude": 51.4254994
        },
        "11537": {
            "name": "Степнобугринский",
            "population": 166,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.7811629,
            "latitude": 51.5721843
        },
        "11538": {
            "name": "Отрада",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.791946,
            "latitude": 51.303757
        },
        "11539": {
            "name": "Антошиха",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.8035422,
            "latitude": 50.9001668
        },
        "11540": {
            "name": "Борок",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.8056796,
            "latitude": 52.0611806
        },
        "11541": {
            "name": "Локоток",
            "population": 138,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.8209825,
            "latitude": 51.2557166
        },
        "11542": {
            "name": "Борково",
            "population": 3,
            "type": "hamlet",
            "poly": [
                [
                    81.8224072,
                    52.7435588
                ],
                [
                    81.8443799,
                    52.7484429
                ],
                [
                    81.8495297,
                    52.7418961
                ],
                [
                    81.8416333,
                    52.7414804
                ],
                [
                    81.8399167,
                    52.7396097
                ],
                [
                    81.8260121,
                    52.7381547
                ],
                [
                    81.8224072,
                    52.7435588
                ]
            ],
            "longitude": 81.8304104,
            "latitude": 52.7390925
        },
        "11543": {
            "name": "Артамоново",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.852981,
            "latitude": 52.2916201
        },
        "11544": {
            "name": "Потеряевка",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.8623266,
            "latitude": 52.9938633
        },
        "11545": {
            "name": "Тулай",
            "population": 171,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.8778225,
            "latitude": 53.1212893
        },
        "11546": {
            "name": "Подстепновский",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.9002817,
            "latitude": 52.9878678
        },
        "11547": {
            "name": "Предгорный",
            "population": 132,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.9004729,
            "latitude": 51.231652
        },
        "11548": {
            "name": "Хлопуново",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 81.9899654,
            "latitude": 52.0664106
        },
        "11549": {
            "name": "Воронеж",
            "population": 202,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.0108354,
            "latitude": 51.1912316
        },
        "11550": {
            "name": "Объездное",
            "population": 14,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.0374288,
            "latitude": 52.4329428
        },
        "11551": {
            "name": "Мирный",
            "population": 151,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.0437891,
            "latitude": 52.0301096
        },
        "11552": {
            "name": "Утка",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.0535983,
            "latitude": 51.3340291
        },
        "11553": {
            "name": "Новокузнецовка",
            "population": 125,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.0606897,
            "latitude": 51.231386
        },
        "11554": {
            "name": "Чеканово",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.0650687,
            "latitude": 51.1018029
        },
        "11555": {
            "name": "Берёзовка",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.083809,
            "latitude": 51.146622
        },
        "11556": {
            "name": "Горновка",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.095118,
            "latitude": 51.5054902
        },
        "11557": {
            "name": "Паново",
            "population": 44,
            "type": "hamlet",
            "poly": [
                [
                    82.1179583,
                    53.0016352
                ],
                [
                    82.1182125,
                    53.0045523
                ],
                [
                    82.1254564,
                    53.0058196
                ],
                [
                    82.1282705,
                    53.0047817
                ],
                [
                    82.128107,
                    53.0039186
                ],
                [
                    82.1339531,
                    53.0024437
                ],
                [
                    82.1278348,
                    53.0021269
                ],
                [
                    82.1254019,
                    53.0022361
                ],
                [
                    82.1225153,
                    53.0021269
                ],
                [
                    82.1179583,
                    53.0016352
                ]
            ],
            "longitude": 82.1236892,
            "latitude": 53.0035704
        },
        "11558": {
            "name": "Михайловка",
            "population": 12,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.1356884,
            "latitude": 51.4791391
        },
        "11559": {
            "name": "Новохарьковка",
            "population": 74,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.1516237,
            "latitude": 51.299448
        },
        "11560": {
            "name": "Калиновка",
            "population": 196,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.157,
            "latitude": 52.1196208
        },
        "11561": {
            "name": "Красногвардейский",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.179378,
            "latitude": 51.2109086
        },
        "11562": {
            "name": "Майское Утро",
            "population": 28,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.1804045,
            "latitude": 52.3073283
        },
        "11563": {
            "name": "Защита",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.1891546,
            "latitude": 52.0146939
        },
        "11564": {
            "name": "Светлая Заря",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.1935592,
            "latitude": 50.8363916
        },
        "11565": {
            "name": "Лесной",
            "population": 45,
            "type": "hamlet",
            "poly": [
                [
                    82.2257662,
                    53.014307
                ],
                [
                    82.2259085,
                    53.0146283
                ],
                [
                    82.2258334,
                    53.0151402
                ],
                [
                    82.2273474,
                    53.016036
                ],
                [
                    82.2281609,
                    53.0159005
                ],
                [
                    82.2294998,
                    53.0165328
                ],
                [
                    82.2300003,
                    53.016578
                ],
                [
                    82.2310264,
                    53.0169619
                ],
                [
                    82.2315269,
                    53.0176545
                ],
                [
                    82.2385468,
                    53.0217041
                ],
                [
                    82.2399107,
                    53.0215084
                ],
                [
                    82.2406615,
                    53.0216137
                ],
                [
                    82.2418002,
                    53.0213503
                ],
                [
                    82.2418628,
                    53.0211019
                ],
                [
                    82.2427387,
                    53.0210041
                ],
                [
                    82.2429639,
                    53.0202514
                ],
                [
                    82.2436771,
                    53.0198072
                ],
                [
                    82.2442152,
                    53.0199578
                ],
                [
                    82.2448784,
                    53.0196116
                ],
                [
                    82.2414373,
                    53.0173835
                ],
                [
                    82.2390974,
                    53.016307
                ],
                [
                    82.23687,
                    53.016292
                ],
                [
                    82.2327406,
                    53.0145454
                ],
                [
                    82.2283807,
                    53.0141689
                ],
                [
                    82.2257662,
                    53.014307
                ]
            ],
            "longitude": 82.2387318,
            "latitude": 53.0186094
        },
        "11566": {
            "name": "Берёзовка",
            "population": 136,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.2498507,
            "latitude": 52.4387637
        },
        "11567": {
            "name": "Краснознаменский",
            "population": 77,
            "type": "hamlet",
            "poly": [
                [
                    82.2475087,
                    51.6626825
                ],
                [
                    82.2598177,
                    51.6667386
                ],
                [
                    82.2686648,
                    51.6637563
                ],
                [
                    82.2725114,
                    51.6488417
                ],
                [
                    82.2619333,
                    51.6465743
                ],
                [
                    82.2475087,
                    51.6626825
                ]
            ],
            "longitude": 82.2646576,
            "latitude": 51.6566182
        },
        "11568": {
            "name": "Рязановка",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.2695066,
            "latitude": 51.0553715
        },
        "11569": {
            "name": "Новознаменка",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.2796467,
            "latitude": 51.6622799
        },
        "11570": {
            "name": "Боровлянка",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.2952143,
            "latitude": 50.8261156
        },
        "11571": {
            "name": "Берёзовский",
            "population": 2,
            "type": "hamlet",
            "poly": [
                [
                    82.2922444,
                    52.5696651
                ],
                [
                    82.2982526,
                    52.5741512
                ],
                [
                    82.3085522,
                    52.5735254
                ],
                [
                    82.3118138,
                    52.5703954
                ],
                [
                    82.3099255,
                    52.5691435
                ],
                [
                    82.3174786,
                    52.562048
                ],
                [
                    82.3039174,
                    52.5573519
                ],
                [
                    82.2922444,
                    52.5696651
                ]
            ],
            "longitude": 82.3040311,
            "latitude": 52.566
        },
        "11572": {
            "name": "Луговое",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.3150232,
            "latitude": 53.4680939
        },
        "11573": {
            "name": "Красное Раздолье",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.3354821,
            "latitude": 50.9126346
        },
        "11574": {
            "name": "Ручьёво",
            "population": 182,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.3425799,
            "latitude": 51.4030919
        },
        "11575": {
            "name": "Серебренниково",
            "population": 52,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.3453456,
            "latitude": 52.7269439
        },
        "11576": {
            "name": "Чернышевский",
            "population": 87,
            "type": "hamlet",
            "poly": [
                [
                    82.3363614,
                    52.6153401
                ],
                [
                    82.3512959,
                    52.6225312
                ],
                [
                    82.3564458,
                    52.6237817
                ],
                [
                    82.3645139,
                    52.6175288
                ],
                [
                    82.3705219,
                    52.6160697
                ],
                [
                    82.3660588,
                    52.6082522
                ],
                [
                    82.3600507,
                    52.6093988
                ],
                [
                    82.3585057,
                    52.6121089
                ],
                [
                    82.3442578,
                    52.6095031
                ],
                [
                    82.3363614,
                    52.6153401
                ]
            ],
            "longitude": 82.3525147,
            "latitude": 52.6161499
        },
        "11577": {
            "name": "Лазурка",
            "population": 169,
            "type": "hamlet",
            "poly": [
                [
                    82.3759622,
                    51.0935246
                ],
                [
                    82.3772067,
                    51.0963546
                ],
                [
                    82.3847983,
                    51.0967683
                ],
                [
                    82.3883647,
                    51.0949531
                ],
                [
                    82.3887509,
                    51.0912875
                ],
                [
                    82.3855279,
                    51.0897335
                ],
                [
                    82.3781508,
                    51.0900476
                ],
                [
                    82.3759622,
                    51.0935246
                ]
            ],
            "longitude": 82.3801831,
            "latitude": 51.092639
        },
        "11578": {
            "name": "Каменка",
            "population": 58,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.3802209,
            "latitude": 51.3250812
        },
        "11579": {
            "name": "Рудовозово",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.38646,
            "latitude": 51.3668812
        },
        "11580": {
            "name": "Ивановка",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.4013681,
            "latitude": 50.9247047
        },
        "11581": {
            "name": "Чаячий",
            "population": 114,
            "type": "hamlet",
            "poly": [
                [
                    82.4154145,
                    52.1262625
                ],
                [
                    82.4168521,
                    52.1280112
                ],
                [
                    82.4197274,
                    52.1291602
                ],
                [
                    82.4236337,
                    52.1293267
                ],
                [
                    82.4274042,
                    52.1269453
                ],
                [
                    82.4268617,
                    52.1253632
                ],
                [
                    82.4211652,
                    52.1217659
                ],
                [
                    82.4185339,
                    52.1228152
                ],
                [
                    82.41574,
                    52.1228652
                ],
                [
                    82.4154145,
                    52.1262625
                ]
            ],
            "longitude": 82.4212243,
            "latitude": 52.1262092
        },
        "11582": {
            "name": "Калмацкий",
            "population": 82,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.4609228,
            "latitude": 51.734231
        },
        "11583": {
            "name": "Дальний",
            "population": 104,
            "type": "hamlet",
            "poly": [
                [
                    82.4569324,
                    53.0218432
                ],
                [
                    82.4587771,
                    53.0226101
                ],
                [
                    82.4641572,
                    53.0240153
                ],
                [
                    82.4674313,
                    53.0244943
                ],
                [
                    82.4703868,
                    53.0247497
                ],
                [
                    82.4690008,
                    53.0220851
                ],
                [
                    82.4669239,
                    53.0215508
                ],
                [
                    82.4572828,
                    53.0212719
                ],
                [
                    82.4569324,
                    53.0218432
                ]
            ],
            "longitude": 82.4658535,
            "latitude": 53.021973
        },
        "11584": {
            "name": "Сибирка",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5007199,
            "latitude": 53.4449253
        },
        "11585": {
            "name": "Подзаймище",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5169677,
            "latitude": 51.7055145
        },
        "11586": {
            "name": "Язевка-Сибирская",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5294702,
            "latitude": 52.3655317
        },
        "11587": {
            "name": "Подхоз",
            "population": 102,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5366142,
            "latitude": 51.3320679
        },
        "11588": {
            "name": "Мурзинка",
            "population": 94,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5500716,
            "latitude": 51.6273478
        },
        "11589": {
            "name": "Эстония",
            "population": 172,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.5501275,
            "latitude": 51.8979902
        },
        "11590": {
            "name": "Семилетка",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.571106,
            "latitude": 52.1888239
        },
        "11591": {
            "name": "Чарышский",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6056363,
            "latitude": 51.6851323
        },
        "11592": {
            "name": "Дружба",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6234991,
            "latitude": 52.2220258
        },
        "11593": {
            "name": "Первомайский",
            "population": 160,
            "type": "hamlet",
            "poly": [
                [
                    82.6158261,
                    52.4905078
                ],
                [
                    82.6281857,
                    52.49542
                ],
                [
                    82.6340222,
                    52.4886263
                ],
                [
                    82.6220059,
                    52.4848631
                ],
                [
                    82.6158261,
                    52.4905078
                ]
            ],
            "longitude": 82.6256571,
            "latitude": 52.4901625
        },
        "11594": {
            "name": "имени 8 Марта",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6332796,
            "latitude": 51.3020274
        },
        "11595": {
            "name": "Карпово Первое",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6442693,
            "latitude": 51.7168241
        },
        "11596": {
            "name": "363 км",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6645442,
            "latitude": 52.4233929
        },
        "11597": {
            "name": "Засурье",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.6654805,
            "latitude": 51.7347233
        },
        "11598": {
            "name": "Ракиты",
            "population": 0,
            "type": "hamlet",
            "poly": [
                [
                    82.6774017,
                    53.0606183
                ],
                [
                    82.6779138,
                    53.0612885
                ],
                [
                    82.682232,
                    53.0624599
                ],
                [
                    82.6842312,
                    53.0628018
                ],
                [
                    82.6868287,
                    53.0622231
                ],
                [
                    82.6871935,
                    53.0618197
                ],
                [
                    82.6867266,
                    53.0612585
                ],
                [
                    82.6786129,
                    53.0594519
                ],
                [
                    82.6774017,
                    53.0606183
                ]
            ],
            "longitude": 82.6815725,
            "latitude": 53.0615045
        },
        "11599": {
            "name": "Троицкий",
            "population": 42,
            "type": "hamlet",
            "poly": [
                [
                    82.6741909,
                    52.5921957
                ],
                [
                    82.6970219,
                    52.6023099
                ],
                [
                    82.7049184,
                    52.5980351
                ],
                [
                    82.6994251,
                    52.5964711
                ],
                [
                    82.7025151,
                    52.5924043
                ],
                [
                    82.6922154,
                    52.5881286
                ],
                [
                    82.6898122,
                    52.5894843
                ],
                [
                    82.6810574,
                    52.5863556
                ],
                [
                    82.6741909,
                    52.5921957
                ]
            ],
            "longitude": 82.6922278,
            "latitude": 52.5940713
        },
        "11600": {
            "name": "Мамонтовский",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.70565,
            "latitude": 52.322765
        },
        "11601": {
            "name": "Подпалатцы",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7188188,
            "latitude": 51.2408032
        },
        "11602": {
            "name": "Молодёжный",
            "population": 229,
            "type": "hamlet",
            "poly": [
                [
                    82.7001064,
                    53.0585669
                ],
                [
                    82.7045264,
                    53.060204
                ],
                [
                    82.7052717,
                    53.0594627
                ],
                [
                    82.7069934,
                    53.0597098
                ],
                [
                    82.7096146,
                    53.0609453
                ],
                [
                    82.7074559,
                    53.0629374
                ],
                [
                    82.7059398,
                    53.0639413
                ],
                [
                    82.7051689,
                    53.0652075
                ],
                [
                    82.7064795,
                    53.0656399
                ],
                [
                    82.7074046,
                    53.0649759
                ],
                [
                    82.7087666,
                    53.0654083
                ],
                [
                    82.7095632,
                    53.0652384
                ],
                [
                    82.7120816,
                    53.0630146
                ],
                [
                    82.7136749,
                    53.0634007
                ],
                [
                    82.7150369,
                    53.0641575
                ],
                [
                    82.7214357,
                    53.065748
                ],
                [
                    82.7271662,
                    53.0615785
                ],
                [
                    82.7283484,
                    53.062088
                ],
                [
                    82.7295562,
                    53.0619646
                ],
                [
                    82.7333852,
                    53.0642347
                ],
                [
                    82.7398354,
                    53.0600341
                ],
                [
                    82.7445124,
                    53.055895
                ],
                [
                    82.7319204,
                    53.0507514
                ],
                [
                    82.7217954,
                    53.0588141
                ],
                [
                    82.7217697,
                    53.0590766
                ],
                [
                    82.7182234,
                    53.0620418
                ],
                [
                    82.7071732,
                    53.0577484
                ],
                [
                    82.7060939,
                    53.0567599
                ],
                [
                    82.7034728,
                    53.0560494
                ],
                [
                    82.7020337,
                    53.0573623
                ],
                [
                    82.7007488,
                    53.0578256
                ],
                [
                    82.7002863,
                    53.0580726
                ],
                [
                    82.7001064,
                    53.0585669
                ]
            ],
            "longitude": 82.738356,
            "latitude": 53.0562821
        },
        "11603": {
            "name": "Семёновка",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7398608,
            "latitude": 51.5670059
        },
        "11604": {
            "name": "Малахово",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7551932,
            "latitude": 52.4117834
        },
        "11605": {
            "name": "Краснодубровский",
            "population": 158,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7612985,
            "latitude": 52.6862879
        },
        "11606": {
            "name": "Октябрьский",
            "population": 120,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7617632,
            "latitude": 52.3431379
        },
        "11607": {
            "name": "Аверенка",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7668302,
            "latitude": 51.4814134
        },
        "11608": {
            "name": "Зелёная Поляна",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7728582,
            "latitude": 52.4347078
        },
        "11609": {
            "name": "Талина",
            "population": 111,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.774002,
            "latitude": 52.2038313
        },
        "11610": {
            "name": "Чупино",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.7929017,
            "latitude": 52.1214208
        },
        "11611": {
            "name": "Рямы",
            "population": 64,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8055259,
            "latitude": 53.8029034
        },
        "11612": {
            "name": "имени Мамонтова",
            "population": 140,
            "type": "hamlet",
            "poly": [
                [
                    82.8001728,
                    53.0909725
                ],
                [
                    82.8008104,
                    53.0917766
                ],
                [
                    82.8008742,
                    53.0921979
                ],
                [
                    82.8020644,
                    53.0937933
                ],
                [
                    82.8026595,
                    53.0946229
                ],
                [
                    82.802617,
                    53.096601
                ],
                [
                    82.8038922,
                    53.0985408
                ],
                [
                    82.8041898,
                    53.0997149
                ],
                [
                    82.8037222,
                    53.1002892
                ],
                [
                    82.8059113,
                    53.101259
                ],
                [
                    82.8106509,
                    53.0990768
                ],
                [
                    82.8120112,
                    53.0998936
                ],
                [
                    82.8125638,
                    53.0998808
                ],
                [
                    82.8146466,
                    53.0984387
                ],
                [
                    82.8147316,
                    53.0969711
                ],
                [
                    82.8140303,
                    53.0960139
                ],
                [
                    82.8120537,
                    53.0948781
                ],
                [
                    82.8115011,
                    53.0942017
                ],
                [
                    82.8112961,
                    53.0941128
                ],
                [
                    82.8092907,
                    53.0932699
                ],
                [
                    82.8076753,
                    53.0921213
                ],
                [
                    82.8062939,
                    53.0911385
                ],
                [
                    82.8053161,
                    53.0901173
                ],
                [
                    82.8028508,
                    53.0891473
                ],
                [
                    82.8021282,
                    53.0902578
                ],
                [
                    82.8001728,
                    53.0909725
                ]
            ],
            "longitude": 82.805576,
            "latitude": 53.0940281
        },
        "11613": {
            "name": "Красная Дубрава",
            "population": 257,
            "type": "hamlet",
            "poly": [
                [
                    82.8047976,
                    53.2869376
                ],
                [
                    82.8082758,
                    53.2874453
                ],
                [
                    82.8151917,
                    53.2880497
                ],
                [
                    82.8167488,
                    53.2847373
                ],
                [
                    82.817214,
                    53.2841812
                ],
                [
                    82.8227947,
                    53.2851071
                ],
                [
                    82.8237862,
                    53.2848219
                ],
                [
                    82.8310257,
                    53.2862243
                ],
                [
                    82.8338567,
                    53.2816786
                ],
                [
                    82.8350094,
                    53.2782568
                ],
                [
                    82.8291248,
                    53.276298
                ],
                [
                    82.830965,
                    53.2745325
                ],
                [
                    82.8301561,
                    53.2735288
                ],
                [
                    82.8315716,
                    53.2722954
                ],
                [
                    82.8299337,
                    53.2721864
                ],
                [
                    82.8297921,
                    53.2705781
                ],
                [
                    82.8283159,
                    53.269913
                ],
                [
                    82.8273655,
                    53.2688124
                ],
                [
                    82.8255063,
                    53.2686213
                ],
                [
                    82.8246961,
                    53.2691027
                ],
                [
                    82.8238064,
                    53.2688124
                ],
                [
                    82.8208258,
                    53.273832
                ],
                [
                    82.8227705,
                    53.2743606
                ],
                [
                    82.8219821,
                    53.2750207
                ],
                [
                    82.8213315,
                    53.2750678
                ],
                [
                    82.8201293,
                    53.2747614
                ],
                [
                    82.8190649,
                    53.2757632
                ],
                [
                    82.8180202,
                    53.2758811
                ],
                [
                    82.8177837,
                    53.2765411
                ],
                [
                    82.8190452,
                    53.2768476
                ],
                [
                    82.8176654,
                    53.2779908
                ],
                [
                    82.8150636,
                    53.2809371
                ],
                [
                    82.8140781,
                    53.2817267
                ],
                [
                    82.8147285,
                    53.2830348
                ],
                [
                    82.8127449,
                    53.2826337
                ],
                [
                    82.8120574,
                    53.2830085
                ],
                [
                    82.810844,
                    53.2840482
                ],
                [
                    82.8101363,
                    53.2844593
                ],
                [
                    82.8101565,
                    53.2851363
                ],
                [
                    82.8088623,
                    53.286599
                ],
                [
                    82.8079927,
                    53.2870705
                ],
                [
                    82.8047976,
                    53.2869376
                ]
            ],
            "longitude": 82.826118,
            "latitude": 53.278534
        },
        "11614": {
            "name": "Андреевский",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8292431,
            "latitude": 51.1022534
        },
        "11615": {
            "name": "Новоникольский",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8393397,
            "latitude": 52.7643176
        },
        "11616": {
            "name": "347 км",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8442123,
            "latitude": 52.5184878
        },
        "11617": {
            "name": "Малая Суетка",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8462617,
            "latitude": 51.6080323
        },
        "11618": {
            "name": "Дубровский",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8517074,
            "latitude": 52.6537639
        },
        "11619": {
            "name": "Кондратьевский",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8635456,
            "latitude": 52.7102957
        },
        "11620": {
            "name": "Усть-Ермилиха",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8801263,
            "latitude": 52.0198884
        },
        "11621": {
            "name": "Успеновка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 82.8960167,
            "latitude": 52.5199071
        },
        "11622": {
            "name": "Советский",
            "population": 122,
            "type": "hamlet",
            "poly": [
                [
                    82.8900283,
                    53.1557231
                ],
                [
                    82.9029725,
                    53.1607589
                ],
                [
                    82.9034342,
                    53.1590342
                ],
                [
                    82.9094358,
                    53.1532422
                ],
                [
                    82.910661,
                    53.1485247
                ],
                [
                    82.9033454,
                    53.1453726
                ],
                [
                    82.9010549,
                    53.1477581
                ],
                [
                    82.8990307,
                    53.1469487
                ],
                [
                    82.8978943,
                    53.1478965
                ],
                [
                    82.8986045,
                    53.148855
                ],
                [
                    82.895,
                    53.1513148
                ],
                [
                    82.8917151,
                    53.1542643
                ],
                [
                    82.8900283,
                    53.1557231
                ]
            ],
            "longitude": 82.9027779,
            "latitude": 53.1505064
        },
        "11623": {
            "name": "Арбузовка",
            "population": 270,
            "type": "hamlet",
            "poly": [
                [
                    82.9302094,
                    53.0387853
                ],
                [
                    82.9330259,
                    53.0400526
                ],
                [
                    82.9306092,
                    53.040719
                ],
                [
                    82.9320083,
                    53.0416149
                ],
                [
                    82.9331894,
                    53.0426965
                ],
                [
                    82.9325716,
                    53.0433629
                ],
                [
                    82.9344432,
                    53.0446738
                ],
                [
                    82.9369144,
                    53.047219
                ],
                [
                    82.9398399,
                    53.0489886
                ],
                [
                    82.9391312,
                    53.0496221
                ],
                [
                    82.9396218,
                    53.0500262
                ],
                [
                    82.940821,
                    53.0495784
                ],
                [
                    82.9420749,
                    53.0501464
                ],
                [
                    82.9458724,
                    53.0527131
                ],
                [
                    82.9453456,
                    53.053008
                ],
                [
                    82.9521778,
                    53.0583267
                ],
                [
                    82.9513238,
                    53.0593642
                ],
                [
                    82.9543946,
                    53.0603579
                ],
                [
                    82.9548669,
                    53.0610568
                ],
                [
                    82.956884,
                    53.0608165
                ],
                [
                    82.958592,
                    53.0614171
                ],
                [
                    82.9570657,
                    53.0626729
                ],
                [
                    82.9576653,
                    53.0629677
                ],
                [
                    82.9597368,
                    53.0616028
                ],
                [
                    82.962317,
                    53.061712
                ],
                [
                    82.9680408,
                    53.0639941
                ],
                [
                    82.9722201,
                    53.0639832
                ],
                [
                    82.9739099,
                    53.064289
                ],
                [
                    82.9745641,
                    53.0644855
                ],
                [
                    82.9770535,
                    53.0624545
                ],
                [
                    82.9736374,
                    53.0593531
                ],
                [
                    82.9708719,
                    53.0577756
                ],
                [
                    82.9617356,
                    53.0554545
                ],
                [
                    82.9563934,
                    53.0517738
                ],
                [
                    82.9526501,
                    53.0497422
                ],
                [
                    82.9472717,
                    53.0471862
                ],
                [
                    82.9413299,
                    53.043199
                ],
                [
                    82.9342796,
                    53.0397249
                ],
                [
                    82.9302094,
                    53.0387853
                ]
            ],
            "longitude": 82.9527456,
            "latitude": 53.0549773
        },
        "11624": {
            "name": "Новоколпаково",
            "population": 91,
            "type": "hamlet",
            "poly": [
                [
                    82.9505727,
                    52.558017
                ],
                [
                    82.9594375,
                    52.5737742
                ],
                [
                    82.9761724,
                    52.5784268
                ],
                [
                    82.9888694,
                    52.5657994
                ],
                [
                    82.9763612,
                    52.5598135
                ],
                [
                    82.9695112,
                    52.5646717
                ],
                [
                    82.9505727,
                    52.558017
                ]
            ],
            "longitude": 82.9721303,
            "latitude": 52.5692436
        },
        "11625": {
            "name": "Сандалово",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.0039388,
            "latitude": 53.7465323
        },
        "11626": {
            "name": "Тигерек",
            "population": 39,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.03015,
            "latitude": 51.1453134
        },
        "11627": {
            "name": "Уржум",
            "population": 237,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.031685,
            "latitude": 52.239819
        },
        "11628": {
            "name": "Западный",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.0546927,
            "latitude": 52.1300456
        },
        "11629": {
            "name": "Озёрный",
            "population": 232,
            "type": "hamlet",
            "poly": [
                [
                    83.0459316,
                    53.2263516
                ],
                [
                    83.0501885,
                    53.2265987
                ],
                [
                    83.0514269,
                    53.2268458
                ],
                [
                    83.0555032,
                    53.2282513
                ],
                [
                    83.056174,
                    53.2281741
                ],
                [
                    83.0570512,
                    53.227371
                ],
                [
                    83.0603535,
                    53.2263362
                ],
                [
                    83.0627528,
                    53.2261817
                ],
                [
                    83.061824,
                    53.2255176
                ],
                [
                    83.063501,
                    53.2255794
                ],
                [
                    83.0646362,
                    53.2253168
                ],
                [
                    83.0681707,
                    53.2235096
                ],
                [
                    83.0693575,
                    53.2234788
                ],
                [
                    83.0701056,
                    53.2219959
                ],
                [
                    83.070054,
                    53.2212854
                ],
                [
                    83.0677117,
                    53.2198615
                ],
                [
                    83.0602761,
                    53.2171763
                ],
                [
                    83.0549872,
                    53.2159096
                ],
                [
                    83.0523815,
                    53.220822
                ],
                [
                    83.0524331,
                    53.2211463
                ],
                [
                    83.0519429,
                    53.2218106
                ],
                [
                    83.0494661,
                    53.2229845
                ],
                [
                    83.0481246,
                    53.2240811
                ],
                [
                    83.0459316,
                    53.2263516
                ]
            ],
            "longitude": 83.0586788,
            "latitude": 53.2216701
        },
        "11630": {
            "name": "Степной",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.0660778,
            "latitude": 52.7203112
        },
        "11631": {
            "name": "Золотушка",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.0714579,
            "latitude": 51.5541196
        },
        "11632": {
            "name": "Талый Ключ",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.0750791,
            "latitude": 51.2829328
        },
        "11633": {
            "name": "Новобарнаулка",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.0762671,
            "latitude": 53.0367048
        },
        "11634": {
            "name": "Приятельский",
            "population": 219,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.0895722,
            "latitude": 52.2162537
        },
        "11635": {
            "name": "Красный Май",
            "population": 219,
            "type": "hamlet",
            "poly": [
                [
                    83.0944953,
                    53.338535
                ],
                [
                    83.1066773,
                    53.3445875
                ],
                [
                    83.116219,
                    53.3373232
                ],
                [
                    83.1185897,
                    53.3338283
                ],
                [
                    83.1114289,
                    53.332159
                ],
                [
                    83.0979386,
                    53.3371386
                ],
                [
                    83.0944953,
                    53.338535
                ]
            ],
            "longitude": 83.104424,
            "latitude": 53.3389531
        },
        "11636": {
            "name": "Черёмно-Подгорное",
            "population": 7,
            "type": "hamlet",
            "poly": [
                [
                    83.1030108,
                    53.4517983
                ],
                [
                    83.1036117,
                    53.4527183
                ],
                [
                    83.1115939,
                    53.4535872
                ],
                [
                    83.1216361,
                    53.450546
                ],
                [
                    83.1296183,
                    53.4470446
                ],
                [
                    83.1283738,
                    53.4456388
                ],
                [
                    83.1030108,
                    53.4517983
                ]
            ],
            "longitude": 83.111397,
            "latitude": 53.451694
        },
        "11637": {
            "name": "Усть-Чагырка",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1311332,
            "latitude": 51.4306782
        },
        "11638": {
            "name": "Крутой Лог",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1386872,
            "latitude": 52.5147794
        },
        "11639": {
            "name": "Солоновка",
            "population": 160,
            "type": "hamlet",
            "poly": [
                [
                    83.1482848,
                    53.1456228
                ],
                [
                    83.1528871,
                    53.1481547
                ],
                [
                    83.1558695,
                    53.147507
                ],
                [
                    83.1563206,
                    53.1471311
                ],
                [
                    83.1572201,
                    53.147347
                ],
                [
                    83.1584793,
                    53.1470233
                ],
                [
                    83.1658186,
                    53.1477569
                ],
                [
                    83.1666821,
                    53.1482748
                ],
                [
                    83.1685529,
                    53.1478433
                ],
                [
                    83.171575,
                    53.1487495
                ],
                [
                    83.1856781,
                    53.1495047
                ],
                [
                    83.1869373,
                    53.1476706
                ],
                [
                    83.1752511,
                    53.1427541
                ],
                [
                    83.1679244,
                    53.143456
                ],
                [
                    83.1577994,
                    53.1418385
                ],
                [
                    83.1565783,
                    53.144219
                ],
                [
                    83.1482848,
                    53.1456228
                ]
            ],
            "longitude": 83.172432,
            "latitude": 53.146366
        },
        "11640": {
            "name": "Ивановка",
            "population": 89,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1820613,
            "latitude": 53.0099671
        },
        "11641": {
            "name": "Новая Заря",
            "population": 123,
            "type": "hamlet",
            "poly": [
                [
                    83.1822313,
                    53.8749336
                ],
                [
                    83.1844122,
                    53.8886536
                ],
                [
                    83.1948592,
                    53.8889072
                ],
                [
                    83.1913618,
                    53.8745217
                ],
                [
                    83.1822313,
                    53.8749336
                ]
            ],
            "longitude": 83.1873023,
            "latitude": 53.8805415
        },
        "11642": {
            "name": "Усть-Ионыш",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1891101,
            "latitude": 51.1088288
        },
        "11643": {
            "name": "Садовый",
            "population": 139,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.1976506,
            "latitude": 52.5340433
        },
        "11644": {
            "name": "Генералка",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2185379,
            "latitude": 51.2639
        },
        "11645": {
            "name": "Круглое",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2187352,
            "latitude": 53.7693204
        },
        "11646": {
            "name": "Касмала",
            "population": 52,
            "type": "hamlet",
            "poly": [
                [
                    83.2359625,
                    53.4368965
                ],
                [
                    83.2424857,
                    53.4399642
                ],
                [
                    83.2410695,
                    53.4410634
                ],
                [
                    83.2498671,
                    53.4451788
                ],
                [
                    83.2549741,
                    53.4430828
                ],
                [
                    83.2405545,
                    53.4350047
                ],
                [
                    83.2359625,
                    53.4368965
                ]
            ],
            "longitude": 83.2455381,
            "latitude": 53.4412535
        },
        "11647": {
            "name": "Ермачиха",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2461602,
            "latitude": 51.8406146
        },
        "11648": {
            "name": "Солонцовый",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.260882,
            "latitude": 52.868466
        },
        "11649": {
            "name": "Нагорный",
            "population": 66,
            "type": "hamlet",
            "poly": [
                [
                    83.2536866,
                    53.4329849
                ],
                [
                    83.2630851,
                    53.4370499
                ],
                [
                    83.2707669,
                    53.4305559
                ],
                [
                    83.268707,
                    53.4296099
                ],
                [
                    83.2654024,
                    53.431323
                ],
                [
                    83.261583,
                    53.4316809
                ],
                [
                    83.2563903,
                    53.4310673
                ],
                [
                    83.2536866,
                    53.4329849
                ]
            ],
            "longitude": 83.2623919,
            "latitude": 53.4336445
        },
        "11650": {
            "name": "Жданово",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2732875,
            "latitude": 52.9426772
        },
        "11651": {
            "name": "Харьково",
            "population": 4,
            "type": "hamlet",
            "poly": [
                [
                    83.2783629,
                    53.4191762
                ],
                [
                    83.2881047,
                    53.4279223
                ],
                [
                    83.2901217,
                    53.4271551
                ],
                [
                    83.2801225,
                    53.4182555
                ],
                [
                    83.2783629,
                    53.4191762
                ]
            ],
            "longitude": 83.2844409,
            "latitude": 53.4227471
        },
        "11652": {
            "name": "Алешиха",
            "population": 68,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2855353,
            "latitude": 51.7800668
        },
        "11653": {
            "name": "290 км",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2861247,
            "latitude": 52.9270737
        },
        "11654": {
            "name": "Дружба",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.2972481,
            "latitude": 52.2384487
        },
        "11655": {
            "name": "Шиловский",
            "population": 45,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3088038,
            "latitude": 52.9520881
        },
        "11656": {
            "name": "Отдаленный",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.315916,
            "latitude": 52.3041268
        },
        "11657": {
            "name": "Рассвет",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3426893,
            "latitude": 53.856446
        },
        "11658": {
            "name": "Алексеевка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3488089,
            "latitude": 51.1388737
        },
        "11659": {
            "name": "Логовской",
            "population": 165,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.3660199,
            "latitude": 52.8560178
        },
        "11660": {
            "name": "Александровка",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4004797,
            "latitude": 53.0480963
        },
        "11661": {
            "name": "Воронежская-Молодёжная",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4083025,
            "latitude": 53.770865
        },
        "11662": {
            "name": "Озерки",
            "population": 159,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4300697,
            "latitude": 51.515296
        },
        "11663": {
            "name": "Малая Штабка",
            "population": 44,
            "type": "hamlet",
            "poly": [
                [
                    83.4134677,
                    53.2626976
                ],
                [
                    83.4141681,
                    53.2651485
                ],
                [
                    83.42464,
                    53.2646039
                ],
                [
                    83.4249902,
                    53.2659445
                ],
                [
                    83.4472297,
                    53.2663425
                ],
                [
                    83.4489809,
                    53.2659025
                ],
                [
                    83.4528684,
                    53.2658607
                ],
                [
                    83.4499966,
                    53.2596599
                ],
                [
                    83.4487708,
                    53.2608959
                ],
                [
                    83.4471247,
                    53.2614615
                ],
                [
                    83.4447081,
                    53.2615035
                ],
                [
                    83.4355762,
                    53.2626358
                ],
                [
                    83.4289784,
                    53.262048
                ],
                [
                    83.4220998,
                    53.2618066
                ],
                [
                    83.4134677,
                    53.2626976
                ]
            ],
            "longitude": 83.4355518,
            "latitude": 53.2650219
        },
        "11664": {
            "name": "Моховое",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4417627,
            "latitude": 53.2539441
        },
        "11665": {
            "name": "260 км",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.454032,
            "latitude": 53.1586942
        },
        "11666": {
            "name": "Перуново",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4615428,
            "latitude": 53.9117102
        },
        "11667": {
            "name": "Петлиха",
            "population": 88,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4627597,
            "latitude": 52.3091404
        },
        "11668": {
            "name": "Зимари",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4638347,
            "latitude": 53.1648432
        },
        "11669": {
            "name": "Прудской",
            "population": 137,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4798076,
            "latitude": 53.1622316
        },
        "11670": {
            "name": "Красный Боец",
            "population": 118,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.4852608,
            "latitude": 53.8681933
        },
        "11671": {
            "name": "Майорка",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5096565,
            "latitude": 51.2368518
        },
        "11672": {
            "name": "Новый",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5247394,
            "latitude": 53.1726798
        },
        "11673": {
            "name": "Железнодорожная Казарма 253",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5324255,
            "latitude": 53.1944425
        },
        "11674": {
            "name": "Нагорный",
            "population": 19,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5505994,
            "latitude": 52.7965661
        },
        "11675": {
            "name": "Усть-Пихтовка",
            "population": 72,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5651379,
            "latitude": 51.699504
        },
        "11676": {
            "name": "Железнодорожная Казарма 250",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.5764367,
            "latitude": 53.2094512
        },
        "11677": {
            "name": "Землянуха",
            "population": 82,
            "type": "hamlet",
            "poly": [
                [
                    83.5806756,
                    53.4038074
                ],
                [
                    83.5851917,
                    53.4052312
                ],
                [
                    83.586515,
                    53.4037397
                ],
                [
                    83.5821086,
                    53.4023157
                ],
                [
                    83.5806756,
                    53.4038074
                ]
            ],
            "longitude": 83.5837753,
            "latitude": 53.4038599
        },
        "11678": {
            "name": "Староалейка",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6101258,
            "latitude": 52.8232159
        },
        "11679": {
            "name": "Сосновка",
            "population": 109,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6115682,
            "latitude": 51.5588089
        },
        "11680": {
            "name": "Власиха",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6219214,
            "latitude": 53.2907708
        },
        "11681": {
            "name": "Чайное",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6267884,
            "latitude": 51.625499
        },
        "11682": {
            "name": "Железнодорожная Казарма 242",
            "population": 110,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6536563,
            "latitude": 53.2581444
        },
        "11683": {
            "name": "Слюдянка",
            "population": 161,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.658524,
            "latitude": 51.883095
        },
        "11684": {
            "name": "Покровка",
            "population": 186,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6717981,
            "latitude": 51.1300632
        },
        "11685": {
            "name": "Беспалово",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6889147,
            "latitude": 52.3132102
        },
        "11686": {
            "name": "Конюхи",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.6941878,
            "latitude": 53.1689411
        },
        "11687": {
            "name": "Кислуха",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.710869,
            "latitude": 53.498688
        },
        "11688": {
            "name": "Пономаревка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.7159729,
            "latitude": 53.2554771
        },
        "11689": {
            "name": "Костяки",
            "population": 34,
            "type": "hamlet",
            "poly": [
                [
                    83.7265485,
                    53.5533758
                ],
                [
                    83.7269777,
                    53.5537582
                ],
                [
                    83.726718,
                    53.554082
                ],
                [
                    83.7272995,
                    53.5543956
                ],
                [
                    83.7287801,
                    53.5543701
                ],
                [
                    83.7304946,
                    53.5543114
                ],
                [
                    83.7326618,
                    53.5546938
                ],
                [
                    83.7344449,
                    53.5554281
                ],
                [
                    83.7373417,
                    53.5557722
                ],
                [
                    83.7401741,
                    53.5559379
                ],
                [
                    83.7434571,
                    53.5559889
                ],
                [
                    83.7443155,
                    53.5554536
                ],
                [
                    83.7453454,
                    53.5551349
                ],
                [
                    83.7470406,
                    53.5557212
                ],
                [
                    83.7484781,
                    53.555734
                ],
                [
                    83.7507957,
                    53.5558487
                ],
                [
                    83.7523599,
                    53.5559558
                ],
                [
                    83.7524887,
                    53.5555351
                ],
                [
                    83.7514823,
                    53.5550966
                ],
                [
                    83.7507742,
                    53.554829
                ],
                [
                    83.7491649,
                    53.5540641
                ],
                [
                    83.7461823,
                    53.5538729
                ],
                [
                    83.7444013,
                    53.5539749
                ],
                [
                    83.742704,
                    53.554133
                ],
                [
                    83.7410539,
                    53.5536817
                ],
                [
                    83.7393995,
                    53.5534829
                ],
                [
                    83.7383695,
                    53.5539545
                ],
                [
                    83.7367624,
                    53.5541661
                ],
                [
                    83.7359663,
                    53.5540182
                ],
                [
                    83.7347668,
                    53.5538474
                ],
                [
                    83.7330287,
                    53.5532228
                ],
                [
                    83.7307971,
                    53.5528914
                ],
                [
                    83.7280699,
                    53.552718
                ],
                [
                    83.7266129,
                    53.5528786
                ],
                [
                    83.7265485,
                    53.5533758
                ]
            ],
            "longitude": 83.7409314,
            "latitude": 53.5551517
        },
        "11690": {
            "name": "Цаплино",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    83.744663,
                    53.5734121
                ],
                [
                    83.7457536,
                    53.5737284
                ],
                [
                    83.7462793,
                    53.5738303
                ],
                [
                    83.7468264,
                    53.5741552
                ],
                [
                    83.746805,
                    53.5744865
                ],
                [
                    83.7475238,
                    53.5746458
                ],
                [
                    83.7479422,
                    53.5750024
                ],
                [
                    83.7475276,
                    53.5756099
                ],
                [
                    83.7483929,
                    53.5758498
                ],
                [
                    83.7490833,
                    53.5765591
                ],
                [
                    83.7509715,
                    53.5768267
                ],
                [
                    83.7516651,
                    53.5767735
                ],
                [
                    83.7525809,
                    53.5768521
                ],
                [
                    83.7532207,
                    53.5761747
                ],
                [
                    83.7533962,
                    53.5756736
                ],
                [
                    83.7529671,
                    53.5754188
                ],
                [
                    83.7534177,
                    53.5753169
                ],
                [
                    83.7538538,
                    53.5753593
                ],
                [
                    83.7540469,
                    53.5751936
                ],
                [
                    83.7544331,
                    53.5749515
                ],
                [
                    83.7532207,
                    53.5743208
                ],
                [
                    83.7526093,
                    53.5740533
                ],
                [
                    83.7514972,
                    53.5743295
                ],
                [
                    83.7500451,
                    53.5739323
                ],
                [
                    83.7485966,
                    53.5733398
                ],
                [
                    83.7482035,
                    53.5730107
                ],
                [
                    83.7470662,
                    53.5728324
                ],
                [
                    83.746798,
                    53.5732401
                ],
                [
                    83.745178,
                    53.5728132
                ],
                [
                    83.744663,
                    53.5734121
                ]
            ],
            "longitude": 83.7506877,
            "latitude": 53.574968
        },
        "11691": {
            "name": "Усть-Чарыш",
            "population": 142,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.7511055,
            "latitude": 52.3325958
        },
        "11692": {
            "name": "Васильевка",
            "population": 153,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.7511445,
            "latitude": 51.9343244
        },
        "11693": {
            "name": "Боровлянка",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.7566489,
            "latitude": 51.4059254
        },
        "11694": {
            "name": "193 км",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.7979872,
            "latitude": 53.5490339
        },
        "11695": {
            "name": "Митюшово",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8034443,
            "latitude": 53.9216363
        },
        "11696": {
            "name": "Аба",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8095036,
            "latitude": 51.2967414
        },
        "11697": {
            "name": "Лесной",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8130906,
            "latitude": 53.5312964
        },
        "11698": {
            "name": "Ивановка",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8239195,
            "latitude": 51.5422779
        },
        "11699": {
            "name": "Малая Речка",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8288325,
            "latitude": 52.9938762
        },
        "11700": {
            "name": "Нижняя Петровка",
            "population": 188,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8485023,
            "latitude": 52.9145957
        },
        "11701": {
            "name": "Машенка",
            "population": 61,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8594972,
            "latitude": 51.2559553
        },
        "11702": {
            "name": "Старокрайчиково",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.8996134,
            "latitude": 53.9009792
        },
        "11703": {
            "name": "Станция Боровиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.9141155,
            "latitude": 53.4798312
        },
        "11704": {
            "name": "Голышево",
            "population": 220,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.9223982,
            "latitude": 53.6798421
        },
        "11705": {
            "name": "Токарёво",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.9467276,
            "latitude": 53.4490803
        },
        "11706": {
            "name": "Волга",
            "population": 168,
            "type": "hamlet",
            "poly": null,
            "longitude": 83.989685,
            "latitude": 53.6302348
        },
        "11707": {
            "name": "Видоново",
            "population": 152,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.060815,
            "latitude": 53.9801757
        },
        "11708": {
            "name": "Солдатово",
            "population": 116,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0725437,
            "latitude": 52.3393005
        },
        "11709": {
            "name": "Пурысево",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.078087,
            "latitude": 53.933342
        },
        "11710": {
            "name": "Партизанский",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.0792256,
            "latitude": 51.7123843
        },
        "11711": {
            "name": "Таловка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1274296,
            "latitude": 53.7625635
        },
        "11712": {
            "name": "Лосиха",
            "population": 44,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1288153,
            "latitude": 53.3253421
        },
        "11713": {
            "name": "Садовый",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1297256,
            "latitude": 51.7444913
        },
        "11714": {
            "name": "Покровка",
            "population": 198,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1353615,
            "latitude": 53.3374406
        },
        "11715": {
            "name": "Лебяжье",
            "population": 236,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1392426,
            "latitude": 53.8361966
        },
        "11716": {
            "name": "Уткино",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1419925,
            "latitude": 52.5773048
        },
        "11717": {
            "name": "Камышенка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1539008,
            "latitude": 53.976899
        },
        "11718": {
            "name": "Красный Восток",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1556158,
            "latitude": 52.1911688
        },
        "11719": {
            "name": "Малый Калтай",
            "population": 121,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1721691,
            "latitude": 53.993682
        },
        "11720": {
            "name": "Бешенцево",
            "population": 167,
            "type": "hamlet",
            "poly": [
                [
                    84.1623953,
                    53.5156894
                ],
                [
                    84.1632965,
                    53.5183686
                ],
                [
                    84.1671589,
                    53.5185728
                ],
                [
                    84.169648,
                    53.5175265
                ],
                [
                    84.1712359,
                    53.5175265
                ],
                [
                    84.1751025,
                    53.5187858
                ],
                [
                    84.1784928,
                    53.5205719
                ],
                [
                    84.1810206,
                    53.5215325
                ],
                [
                    84.1842391,
                    53.521558
                ],
                [
                    84.1859987,
                    53.5204864
                ],
                [
                    84.1890886,
                    53.520665
                ],
                [
                    84.1935947,
                    53.5218131
                ],
                [
                    84.1944531,
                    53.5212263
                ],
                [
                    84.1943243,
                    53.5201037
                ],
                [
                    84.1918781,
                    53.5196444
                ],
                [
                    84.1893461,
                    53.5184197
                ],
                [
                    84.1860416,
                    53.5179349
                ],
                [
                    84.1817115,
                    53.517459
                ],
                [
                    84.1781066,
                    53.5171783
                ],
                [
                    84.1750124,
                    53.517399
                ],
                [
                    84.1728237,
                    53.5165825
                ],
                [
                    84.1698239,
                    53.5154686
                ],
                [
                    84.1668156,
                    53.5149238
                ],
                [
                    84.1634682,
                    53.5145155
                ],
                [
                    84.1623953,
                    53.5156894
                ]
            ],
            "longitude": 84.1817882,
            "latitude": 53.518571
        },
        "11721": {
            "name": "Новый Мир",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1904613,
            "latitude": 53.4782512
        },
        "11722": {
            "name": "Калининский",
            "population": 40,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.1985511,
            "latitude": 51.783361
        },
        "11723": {
            "name": "Степной",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.2053462,
            "latitude": 53.6618667
        },
        "11724": {
            "name": "Ногино",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.2252008,
            "latitude": 53.9555465
        },
        "11725": {
            "name": "Восход",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.274002,
            "latitude": 53.991505
        },
        "11726": {
            "name": "Талица",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3052028,
            "latitude": 54.1016784
        },
        "11727": {
            "name": "Баюново",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3177592,
            "latitude": 53.2850381
        },
        "11728": {
            "name": "Новокопылово",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3420761,
            "latitude": 53.5038576
        },
        "11729": {
            "name": "Инюшово",
            "population": 75,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.344128,
            "latitude": 53.6364157
        },
        "11730": {
            "name": "Голубцово",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3464452,
            "latitude": 53.5184733
        },
        "11731": {
            "name": "Восход",
            "population": 195,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3613002,
            "latitude": 53.3431325
        },
        "11732": {
            "name": "Романово",
            "population": 230,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3723035,
            "latitude": 53.2497507
        },
        "11733": {
            "name": "Логовое",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3743485,
            "latitude": 53.2870201
        },
        "11734": {
            "name": "Голубцово",
            "population": 133,
            "type": "hamlet",
            "poly": [
                [
                    84.3738821,
                    53.5635333
                ],
                [
                    84.3771051,
                    53.5654793
                ],
                [
                    84.381006,
                    53.5670251
                ],
                [
                    84.3849113,
                    53.5682485
                ],
                [
                    84.3862031,
                    53.568028
                ],
                [
                    84.3874434,
                    53.5663879
                ],
                [
                    84.3866323,
                    53.5647402
                ],
                [
                    84.3818687,
                    53.562803
                ],
                [
                    84.3768433,
                    53.5616981
                ],
                [
                    84.3747833,
                    53.5621314
                ],
                [
                    84.3738821,
                    53.5635333
                ]
            ],
            "longitude": 84.3810101,
            "latitude": 53.5654038
        },
        "11735": {
            "name": "Малая Повалиха",
            "population": 68,
            "type": "hamlet",
            "poly": [
                [
                    84.384985,
                    53.7560432
                ],
                [
                    84.3929908,
                    53.7570225
                ],
                [
                    84.3967867,
                    53.7526155
                ],
                [
                    84.3940951,
                    53.7474327
                ],
                [
                    84.385054,
                    53.7507791
                ],
                [
                    84.384985,
                    53.7560432
                ]
            ],
            "longitude": 84.3901233,
            "latitude": 53.7524231
        },
        "11736": {
            "name": "Елиново",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.3988777,
            "latitude": 51.4063509
        },
        "11737": {
            "name": "Рыбное",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4118547,
            "latitude": 51.3829815
        },
        "11738": {
            "name": "Новочесноковка",
            "population": 147,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4137429,
            "latitude": 53.5000895
        },
        "11739": {
            "name": "Захарово",
            "population": 59,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4232258,
            "latitude": 53.9710231
        },
        "11740": {
            "name": "Березово",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4245804,
            "latitude": 51.9444062
        },
        "11741": {
            "name": "Южаково",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4642567,
            "latitude": 52.7950071
        },
        "11742": {
            "name": "Лесной",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4836432,
            "latitude": 52.8452972
        },
        "11743": {
            "name": "Пустынь",
            "population": 261,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.4893074,
            "latitude": 53.3554224
        },
        "11744": {
            "name": "Овчинниково",
            "population": 203,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.498962,
            "latitude": 53.21521
        },
        "11745": {
            "name": "Барсуково",
            "population": 62,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.515613,
            "latitude": 51.6160516
        },
        "11746": {
            "name": "Первомайский",
            "population": 37,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5283333,
            "latitude": 52.1777453
        },
        "11747": {
            "name": "Ленинский",
            "population": 180,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5295573,
            "latitude": 52.7620628
        },
        "11748": {
            "name": "Комсомольский",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5404764,
            "latitude": 51.7958358
        },
        "11749": {
            "name": "Калиновка",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5589678,
            "latitude": 53.8590668
        },
        "11750": {
            "name": "Комсомолец",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5607127,
            "latitude": 53.1625293
        },
        "11751": {
            "name": "Заплывино",
            "population": 214,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5737854,
            "latitude": 53.938391
        },
        "11752": {
            "name": "Усть-Каменка",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.5981907,
            "latitude": 53.9578131
        },
        "11753": {
            "name": "Тог-Алтай",
            "population": 11,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6097557,
            "latitude": 51.442939
        },
        "11754": {
            "name": "Зелёная Роща",
            "population": 27,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6196772,
            "latitude": 53.1596556
        },
        "11755": {
            "name": "Гуниха",
            "population": 181,
            "type": "hamlet",
            "poly": [
                [
                    84.6352666,
                    54.2058961
                ],
                [
                    84.6362504,
                    54.2104989
                ],
                [
                    84.6414971,
                    54.2122248
                ],
                [
                    84.6523184,
                    54.2072387
                ],
                [
                    84.6569093,
                    54.2081976
                ],
                [
                    84.6611722,
                    54.2074304
                ],
                [
                    84.6572372,
                    54.1895907
                ],
                [
                    84.6483834,
                    54.1869044
                ],
                [
                    84.6437925,
                    54.1901663
                ],
                [
                    84.6352666,
                    54.2058961
                ]
            ],
            "longitude": 84.6519905,
            "latitude": 54.1986074
        },
        "11756": {
            "name": "Большая Тихая",
            "population": 165,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6648532,
            "latitude": 51.791105
        },
        "11757": {
            "name": "Смирново",
            "population": 263,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.671127,
            "latitude": 53.692829
        },
        "11758": {
            "name": "Загонный",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6744465,
            "latitude": 53.5946329
        },
        "11759": {
            "name": "Лучевое",
            "population": 205,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6748212,
            "latitude": 53.3272678
        },
        "11760": {
            "name": "Загайново",
            "population": 92,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.678165,
            "latitude": 52.8931673
        },
        "11761": {
            "name": "Староглушинка",
            "population": 212,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.6914246,
            "latitude": 53.7921306
        },
        "11762": {
            "name": "Индейка",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7079543,
            "latitude": 53.2126374
        },
        "11763": {
            "name": "Чегон",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7083171,
            "latitude": 51.4631561
        },
        "11764": {
            "name": "Новокрасилово",
            "population": 131,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7228446,
            "latitude": 53.7702849
        },
        "11765": {
            "name": "Муравей",
            "population": 238,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7279927,
            "latitude": 53.8949038
        },
        "11766": {
            "name": "Новосмоленка",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7330979,
            "latitude": 52.2357485
        },
        "11767": {
            "name": "Дёмино",
            "population": 265,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.742744,
            "latitude": 51.56279
        },
        "11768": {
            "name": "Булатово",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7524509,
            "latitude": 51.7478172
        },
        "11769": {
            "name": "Верх-Бобровка",
            "population": 165,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7760943,
            "latitude": 53.1877075
        },
        "11770": {
            "name": "Казанка",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.7903013,
            "latitude": 51.6730251
        },
        "11771": {
            "name": "Старокопылово",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.797791,
            "latitude": 53.7962013
        },
        "11772": {
            "name": "Берёзовая Роща",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8032116,
            "latitude": 52.6782198
        },
        "11773": {
            "name": "Батунная",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8097109,
            "latitude": 53.6554166
        },
        "11774": {
            "name": "Буланиха",
            "population": 169,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.814128,
            "latitude": 52.7923661
        },
        "11775": {
            "name": "Новозырянка",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8242463,
            "latitude": 53.4328743
        },
        "11776": {
            "name": "Парижская Коммуна",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8415171,
            "latitude": 52.8067327
        },
        "11777": {
            "name": "Пролетарская Крепость",
            "population": 148,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8546439,
            "latitude": 54.0119066
        },
        "11778": {
            "name": "Уткуль",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8561974,
            "latitude": 52.7404841
        },
        "11779": {
            "name": "Сохарево",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8571701,
            "latitude": 53.3097829
        },
        "11780": {
            "name": "Омутная",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8648079,
            "latitude": 53.6399752
        },
        "11781": {
            "name": "Жаворонково",
            "population": 113,
            "type": "hamlet",
            "poly": [
                [
                    84.880709,
                    52.5111791
                ],
                [
                    84.8884107,
                    52.5151869
                ],
                [
                    84.8910896,
                    52.5152548
                ],
                [
                    84.895666,
                    52.4977943
                ],
                [
                    84.8923174,
                    52.4943965
                ],
                [
                    84.8859551,
                    52.4939208
                ],
                [
                    84.8836111,
                    52.5001047
                ],
                [
                    84.880709,
                    52.5111791
                ]
            ],
            "longitude": 84.8890368,
            "latitude": 52.5061932
        },
        "11782": {
            "name": "Свекловичный",
            "population": 170,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.8926101,
            "latitude": 52.7273449
        },
        "11783": {
            "name": "Зудилово",
            "population": 16,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.895137,
            "latitude": 53.5472706
        },
        "11784": {
            "name": "Урожайный",
            "population": 187,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9241536,
            "latitude": 52.7113578
        },
        "11785": {
            "name": "Восход",
            "population": 240,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9576934,
            "latitude": 52.7253302
        },
        "11786": {
            "name": "Молочный",
            "population": 170,
            "type": "hamlet",
            "poly": [
                [
                    84.963763,
                    52.4086288
                ],
                [
                    84.9644136,
                    52.4119977
                ],
                [
                    84.9647672,
                    52.4120695
                ],
                [
                    84.9702311,
                    52.4131792
                ],
                [
                    84.9758492,
                    52.413932
                ],
                [
                    84.9799509,
                    52.4123551
                ],
                [
                    84.9798456,
                    52.4119863
                ],
                [
                    84.973374,
                    52.4110661
                ],
                [
                    84.9709731,
                    52.4108964
                ],
                [
                    84.9680646,
                    52.4099489
                ],
                [
                    84.963763,
                    52.4086288
                ]
            ],
            "longitude": 84.9737939,
            "latitude": 52.4117251
        },
        "11787": {
            "name": "Никольское",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9871189,
            "latitude": 51.795309
        },
        "11788": {
            "name": "Речной",
            "population": 158,
            "type": "hamlet",
            "poly": [
                [
                    84.987951,
                    52.3142515
                ],
                [
                    84.9974754,
                    52.3142515
                ],
                [
                    84.9978097,
                    52.3090415
                ],
                [
                    84.9889536,
                    52.3092459
                ],
                [
                    84.987951,
                    52.3142515
                ]
            ],
            "longitude": 84.9926297,
            "latitude": 52.3110847
        },
        "11789": {
            "name": "Маточный",
            "population": 222,
            "type": "hamlet",
            "poly": null,
            "longitude": 84.9975658,
            "latitude": 52.4232626
        },
        "11790": {
            "name": "Широкий Луг",
            "population": 93,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0018765,
            "latitude": 53.861428
        },
        "11791": {
            "name": "Раздольный",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0100514,
            "latitude": 52.3018094
        },
        "11792": {
            "name": "Филатово",
            "population": 144,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.013049,
            "latitude": 53.2898569
        },
        "11793": {
            "name": "Никольский",
            "population": 85,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0207104,
            "latitude": 54.055883
        },
        "11794": {
            "name": "Кокорский",
            "population": 145,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0360601,
            "latitude": 53.7486263
        },
        "11795": {
            "name": "Михайловка",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0404083,
            "latitude": 52.2813765
        },
        "11796": {
            "name": "Кирпичный",
            "population": 84,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.040814,
            "latitude": 52.4180294
        },
        "11797": {
            "name": "Даниловка",
            "population": 15,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0551063,
            "latitude": 51.976779
        },
        "11798": {
            "name": "Нефтебаза",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0791702,
            "latitude": 52.4249707
        },
        "11799": {
            "name": "Талдинка",
            "population": 167,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.0839588,
            "latitude": 53.1318429
        },
        "11800": {
            "name": "Новокытманово",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.089569,
            "latitude": 53.333858
        },
        "11801": {
            "name": "Иконниково",
            "population": 80,
            "type": "hamlet",
            "poly": [
                [
                    85.0838765,
                    52.4325462
                ],
                [
                    85.0846626,
                    52.4333442
                ],
                [
                    85.0907798,
                    52.43564
                ],
                [
                    85.0941583,
                    52.4356469
                ],
                [
                    85.0961001,
                    52.4346478
                ],
                [
                    85.0969846,
                    52.4325634
                ],
                [
                    85.0950773,
                    52.4319619
                ],
                [
                    85.0942151,
                    52.4302815
                ],
                [
                    85.0921673,
                    52.4296713
                ],
                [
                    85.0921673,
                    52.4293146
                ],
                [
                    85.0911512,
                    52.4290423
                ],
                [
                    85.0895807,
                    52.4293427
                ],
                [
                    85.0891188,
                    52.4297933
                ],
                [
                    85.0884875,
                    52.4296619
                ],
                [
                    85.0882237,
                    52.4303151
                ],
                [
                    85.0875738,
                    52.4301302
                ],
                [
                    85.0860062,
                    52.43086
                ],
                [
                    85.0850452,
                    52.4314117
                ],
                [
                    85.0845513,
                    52.4320892
                ],
                [
                    85.0838765,
                    52.4325462
                ]
            ],
            "longitude": 85.0907851,
            "latitude": 52.4319595
        },
        "11802": {
            "name": "Залесиха",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1074539,
            "latitude": 53.8838976
        },
        "11803": {
            "name": "Авдеевская База",
            "population": 106,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1120881,
            "latitude": 53.8397974
        },
        "11804": {
            "name": "Междуречье",
            "population": 21,
            "type": "hamlet",
            "poly": [
                [
                    85.1167883,
                    52.4210198
                ],
                [
                    85.1170311,
                    52.422015
                ],
                [
                    85.1187607,
                    52.4219506
                ],
                [
                    85.120775,
                    52.4222658
                ],
                [
                    85.1211651,
                    52.4228317
                ],
                [
                    85.1218507,
                    52.4232176
                ],
                [
                    85.1220194,
                    52.4238608
                ],
                [
                    85.1212918,
                    52.4246711
                ],
                [
                    85.121218,
                    52.4254235
                ],
                [
                    85.1223359,
                    52.426446
                ],
                [
                    85.124656,
                    52.4263817
                ],
                [
                    85.1265332,
                    52.4269026
                ],
                [
                    85.127173,
                    52.4267206
                ],
                [
                    85.1268329,
                    52.4262666
                ],
                [
                    85.1266547,
                    52.42573
                ],
                [
                    85.1272216,
                    52.4253546
                ],
                [
                    85.1266493,
                    52.4243536
                ],
                [
                    85.1272673,
                    52.4234771
                ],
                [
                    85.1256672,
                    52.4229396
                ],
                [
                    85.1246485,
                    52.422444
                ],
                [
                    85.123636,
                    52.421983
                ],
                [
                    85.1214753,
                    52.4213483
                ],
                [
                    85.1203616,
                    52.4211707
                ],
                [
                    85.1188952,
                    52.4210585
                ],
                [
                    85.1184777,
                    52.420979
                ],
                [
                    85.1178513,
                    52.4209831
                ],
                [
                    85.1167883,
                    52.4210198
                ]
            ],
            "longitude": 85.1243526,
            "latitude": 52.4246112
        },
        "11805": {
            "name": "Новый Быт",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1295644,
            "latitude": 52.7202044
        },
        "11806": {
            "name": "Красный Маяк",
            "population": 149,
            "type": "hamlet",
            "poly": [
                [
                    85.1372327,
                    52.3812834
                ],
                [
                    85.1505105,
                    52.3832051
                ],
                [
                    85.1533167,
                    52.3786096
                ],
                [
                    85.1595449,
                    52.3747656
                ],
                [
                    85.1509896,
                    52.3707542
                ],
                [
                    85.1412024,
                    52.375267
                ],
                [
                    85.1372327,
                    52.3812834
                ]
            ],
            "longitude": 85.1432201,
            "latitude": 52.3811683
        },
        "11807": {
            "name": "Каменушка",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1445973,
            "latitude": 53.906089
        },
        "11808": {
            "name": "Новодресвянка",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.1769018,
            "latitude": 53.9878354
        },
        "11809": {
            "name": "Студенческий",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2032026,
            "latitude": 52.6063768
        },
        "11810": {
            "name": "Казанцево",
            "population": 105,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.203888,
            "latitude": 53.861374
        },
        "11811": {
            "name": "Змазнево",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2159767,
            "latitude": 53.8086923
        },
        "11812": {
            "name": "Ларионово",
            "population": 35,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.248915,
            "latitude": 53.6140477
        },
        "11813": {
            "name": "Афонино",
            "population": 178,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2500329,
            "latitude": 53.7721458
        },
        "11814": {
            "name": "Заречный",
            "population": 90,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2624105,
            "latitude": 52.4519929
        },
        "11815": {
            "name": "Клабуковка",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2625483,
            "latitude": 54.0698833
        },
        "11816": {
            "name": "Ягодный",
            "population": 174,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.27185,
            "latitude": 52.6349797
        },
        "11817": {
            "name": "Черкасово",
            "population": 238,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2776902,
            "latitude": 53.2595792
        },
        "11818": {
            "name": "Красный Октябрь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.2978381,
            "latitude": 52.6910747
        },
        "11819": {
            "name": "Путь Ленинизма",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3016202,
            "latitude": 52.8206812
        },
        "11820": {
            "name": "Ленинское",
            "population": 162,
            "type": "hamlet",
            "poly": [
                [
                    85.2949417,
                    52.2920601
                ],
                [
                    85.3046406,
                    52.2965606
                ],
                [
                    85.3085782,
                    52.2902672
                ],
                [
                    85.3137088,
                    52.2877566
                ],
                [
                    85.3122979,
                    52.2833625
                ],
                [
                    85.3031844,
                    52.2874541
                ],
                [
                    85.299946,
                    52.286765
                ],
                [
                    85.2949417,
                    52.2920601
                ]
            ],
            "longitude": 85.3034977,
            "latitude": 52.2903667
        },
        "11821": {
            "name": "Заречное",
            "population": 224,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3252199,
            "latitude": 53.5877016
        },
        "11822": {
            "name": "Солнечная Поляна",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3300642,
            "latitude": 52.5441554
        },
        "11823": {
            "name": "Горюшино",
            "population": 8,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.330399,
            "latitude": 53.883808
        },
        "11824": {
            "name": "Калиновский",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3402419,
            "latitude": 53.5401952
        },
        "11825": {
            "name": "Петрушиха",
            "population": 221,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3421536,
            "latitude": 53.497934
        },
        "11826": {
            "name": "Целинный",
            "population": 130,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3424924,
            "latitude": 53.2664237
        },
        "11827": {
            "name": "Рудник",
            "population": 75,
            "type": "hamlet",
            "poly": [
                [
                    85.3423343,
                    51.8437852
                ],
                [
                    85.3445445,
                    51.8454688
                ],
                [
                    85.34554,
                    51.8467885
                ],
                [
                    85.3439437,
                    51.8491804
                ],
                [
                    85.3441582,
                    51.8503999
                ],
                [
                    85.3464542,
                    51.8527194
                ],
                [
                    85.3460894,
                    51.8553039
                ],
                [
                    85.3479219,
                    51.8551123
                ],
                [
                    85.348557,
                    51.853223
                ],
                [
                    85.3478142,
                    51.8504937
                ],
                [
                    85.3474478,
                    51.8479462
                ],
                [
                    85.3469263,
                    51.8463702
                ],
                [
                    85.3454757,
                    51.8452773
                ],
                [
                    85.3435016,
                    51.8437925
                ],
                [
                    85.3424845,
                    51.843202
                ],
                [
                    85.3423343,
                    51.8437852
                ]
            ],
            "longitude": 85.3451056,
            "latitude": 51.8488658
        },
        "11828": {
            "name": "Сосновка",
            "population": 243,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3549947,
            "latitude": 52.4400687
        },
        "11829": {
            "name": "Большая Кыркыла",
            "population": 16,
            "type": "hamlet",
            "poly": [
                [
                    85.3568826,
                    51.7621826
                ],
                [
                    85.3590799,
                    51.7620837
                ],
                [
                    85.3591786,
                    51.7612131
                ],
                [
                    85.3577195,
                    51.7610936
                ],
                [
                    85.3568826,
                    51.7621826
                ]
            ],
            "longitude": 85.3581535,
            "latitude": 51.7618888
        },
        "11830": {
            "name": "Курья",
            "population": 126,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.362574,
            "latitude": 53.4743569
        },
        "11831": {
            "name": "Пролетарка",
            "population": 165,
            "type": "hamlet",
            "poly": [
                [
                    85.358758,
                    51.8014439
                ],
                [
                    85.3598437,
                    51.8015029
                ],
                [
                    85.3604661,
                    51.7998709
                ],
                [
                    85.3652941,
                    51.7970842
                ],
                [
                    85.3644143,
                    51.7940186
                ],
                [
                    85.3635431,
                    51.7917033
                ],
                [
                    85.3619467,
                    51.7902891
                ],
                [
                    85.3609167,
                    51.7903953
                ],
                [
                    85.3613029,
                    51.7919747
                ],
                [
                    85.3628994,
                    51.7945169
                ],
                [
                    85.363586,
                    51.7951539
                ],
                [
                    85.3601957,
                    51.7970516
                ],
                [
                    85.3595949,
                    51.7977152
                ],
                [
                    85.3609467,
                    51.7984848
                ],
                [
                    85.3591871,
                    51.800117
                ],
                [
                    85.358758,
                    51.8014439
                ]
            ],
            "longitude": 85.3639089,
            "latitude": 51.7962401
        },
        "11832": {
            "name": "Комар",
            "population": 193,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.3888935,
            "latitude": 51.7108298
        },
        "11833": {
            "name": "Булухта",
            "population": 8,
            "type": "hamlet",
            "poly": [
                [
                    85.3985666,
                    51.5922265
                ],
                [
                    85.3988248,
                    51.5929189
                ],
                [
                    85.4002338,
                    51.5929501
                ],
                [
                    85.4031766,
                    51.5924258
                ],
                [
                    85.4030916,
                    51.592281
                ],
                [
                    85.4039094,
                    51.5921127
                ],
                [
                    85.4037197,
                    51.5918278
                ],
                [
                    85.403011,
                    51.5917143
                ],
                [
                    85.4024086,
                    51.5918806
                ],
                [
                    85.401119,
                    51.5920077
                ],
                [
                    85.3999626,
                    51.5919754
                ],
                [
                    85.3993593,
                    51.592039
                ],
                [
                    85.398595,
                    51.5921107
                ],
                [
                    85.3985666,
                    51.5922265
                ]
            ],
            "longitude": 85.4004708,
            "latitude": 51.5924501
        },
        "11834": {
            "name": "Беспалово",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4011219,
            "latitude": 53.4835249
        },
        "11835": {
            "name": "Малиновка",
            "population": 36,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.403145,
            "latitude": 53.913544
        },
        "11836": {
            "name": "Басаргино",
            "population": 1,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.423317,
            "latitude": 51.734386
        },
        "11837": {
            "name": "Мостовой",
            "population": 173,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4255275,
            "latitude": 53.75904
        },
        "11838": {
            "name": "Мироновка",
            "population": 98,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.435844,
            "latitude": 53.804764
        },
        "11839": {
            "name": "Кытманушка",
            "population": 245,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4458903,
            "latitude": 53.4732235
        },
        "11840": {
            "name": "Черемшанка",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4469341,
            "latitude": 51.7566906
        },
        "11841": {
            "name": "Берёзовая Горка",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4633474,
            "latitude": 52.7198081
        },
        "11842": {
            "name": "Боровлянка",
            "population": 38,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.470154,
            "latitude": 53.875896
        },
        "11843": {
            "name": "Усть-Бороуйск",
            "population": 63,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4742373,
            "latitude": 53.6606342
        },
        "11844": {
            "name": "Заозёрный",
            "population": 231,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.4835163,
            "latitude": 52.5338984
        },
        "11845": {
            "name": "Мишиха",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.5548179,
            "latitude": 53.7415554
        },
        "11846": {
            "name": "Анатолия",
            "population": 17,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.5580004,
            "latitude": 53.8966235
        },
        "11847": {
            "name": "Полеводка",
            "population": 240,
            "type": "hamlet",
            "poly": [
                [
                    85.559958,
                    52.4298833
                ],
                [
                    85.5618463,
                    52.4328139
                ],
                [
                    85.5672635,
                    52.431254
                ],
                [
                    85.5732901,
                    52.4308634
                ],
                [
                    85.580214,
                    52.4285226
                ],
                [
                    85.5754075,
                    52.4242309
                ],
                [
                    85.570086,
                    52.4220325
                ],
                [
                    85.559958,
                    52.4298833
                ]
            ],
            "longitude": 85.5655491,
            "latitude": 52.4297524
        },
        "11848": {
            "name": "Улус-Тараба",
            "population": 129,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.5786903,
            "latitude": 53.4047298
        },
        "11849": {
            "name": "Карасук",
            "population": 222,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.5871515,
            "latitude": 52.3858431
        },
        "11850": {
            "name": "Врублёвский",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6074303,
            "latitude": 53.7719582
        },
        "11851": {
            "name": "Ясашино",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6086743,
            "latitude": 53.4450634
        },
        "11852": {
            "name": "Усково",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6138696,
            "latitude": 53.7041671
        },
        "11853": {
            "name": "Новоозёрное",
            "population": 184,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.618011,
            "latitude": 53.476639
        },
        "11854": {
            "name": "Степной",
            "population": 23,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6430817,
            "latitude": 52.7467722
        },
        "11855": {
            "name": "Ключи",
            "population": 227,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6455509,
            "latitude": 52.590735
        },
        "11856": {
            "name": "Отрадное",
            "population": 215,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6565338,
            "latitude": 53.6849216
        },
        "11857": {
            "name": "Предгорный",
            "population": 97,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6665343,
            "latitude": 52.4900095
        },
        "11858": {
            "name": "Новодуплинка",
            "population": 51,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6744496,
            "latitude": 53.4523927
        },
        "11859": {
            "name": "Лебединый",
            "population": 243,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6751485,
            "latitude": 52.3030888
        },
        "11860": {
            "name": "Новохмелёвка",
            "population": 100,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6928788,
            "latitude": 53.6175355
        },
        "11861": {
            "name": "Мальцева Курья",
            "population": 194,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.6961902,
            "latitude": 52.5791913
        },
        "11862": {
            "name": "Каменка",
            "population": 177,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.7122065,
            "latitude": 53.5397251
        },
        "11863": {
            "name": "Образцовка",
            "population": 147,
            "type": "hamlet",
            "poly": [
                [
                    85.7831861,
                    52.3850641
                ],
                [
                    85.7871748,
                    52.3853251
                ],
                [
                    85.787684,
                    52.3858924
                ],
                [
                    85.7896801,
                    52.3860637
                ],
                [
                    85.7931909,
                    52.3848258
                ],
                [
                    85.7946417,
                    52.3856524
                ],
                [
                    85.7963099,
                    52.3840248
                ],
                [
                    85.7981846,
                    52.3829638
                ],
                [
                    85.7997929,
                    52.3803893
                ],
                [
                    85.7968414,
                    52.3788383
                ],
                [
                    85.7932268,
                    52.3817277
                ],
                [
                    85.791231,
                    52.383255
                ],
                [
                    85.7891859,
                    52.3837544
                ],
                [
                    85.7832373,
                    52.3841407
                ],
                [
                    85.7831861,
                    52.3850641
                ]
            ],
            "longitude": 85.7923389,
            "latitude": 52.383579
        },
        "11864": {
            "name": "Бураново",
            "population": 251,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8025123,
            "latitude": 53.387079
        },
        "11865": {
            "name": "Хуторки",
            "population": 264,
            "type": "hamlet",
            "poly": [
                [
                    85.7943355,
                    52.2651144
                ],
                [
                    85.7943355,
                    52.270157
                ],
                [
                    85.8142482,
                    52.2598612
                ],
                [
                    85.8116733,
                    52.2557633
                ],
                [
                    85.7943355,
                    52.2651144
                ]
            ],
            "longitude": 85.8030902,
            "latitude": 52.2624879
        },
        "11866": {
            "name": "Бехтемир-Аникино",
            "population": 119,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8033982,
            "latitude": 52.6539311
        },
        "11867": {
            "name": "Аксёново",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8775717,
            "latitude": 53.2636777
        },
        "11868": {
            "name": "Мост Иша",
            "population": 123,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.8848497,
            "latitude": 52.2066131
        },
        "11869": {
            "name": "Долина Свободы",
            "population": 110,
            "type": "hamlet",
            "poly": [
                [
                    85.919156,
                    52.1222386
                ],
                [
                    85.9216756,
                    52.1219514
                ],
                [
                    85.9215815,
                    52.1273275
                ],
                [
                    85.9212459,
                    52.1313214
                ],
                [
                    85.9205813,
                    52.1327143
                ],
                [
                    85.920014,
                    52.1347937
                ],
                [
                    85.9229084,
                    52.1347796
                ],
                [
                    85.9237258,
                    52.1267244
                ],
                [
                    85.9257072,
                    52.1267856
                ],
                [
                    85.9273591,
                    52.123436
                ],
                [
                    85.9307024,
                    52.1189144
                ],
                [
                    85.9303131,
                    52.1182094
                ],
                [
                    85.9287667,
                    52.1154088
                ],
                [
                    85.9238069,
                    52.115588
                ],
                [
                    85.9227935,
                    52.1086034
                ],
                [
                    85.921693,
                    52.1051703
                ],
                [
                    85.9196694,
                    52.1055246
                ],
                [
                    85.9196141,
                    52.1071043
                ],
                [
                    85.9204752,
                    52.1103387
                ],
                [
                    85.9212031,
                    52.114641
                ],
                [
                    85.9224313,
                    52.1178813
                ],
                [
                    85.9214305,
                    52.1198086
                ],
                [
                    85.919156,
                    52.1222386
                ]
            ],
            "longitude": 85.9244005,
            "latitude": 52.1189722
        },
        "11870": {
            "name": "Новая Суртайка",
            "population": 185,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9552256,
            "latitude": 52.2236578
        },
        "11871": {
            "name": "Брагино",
            "population": 86,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9659254,
            "latitude": 53.2161377
        },
        "11872": {
            "name": "Многопольное",
            "population": 42,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9702702,
            "latitude": 52.4046334
        },
        "11873": {
            "name": "Шумиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 85.9967619,
            "latitude": 53.6189635
        },
        "11874": {
            "name": "Промышленный",
            "population": 189,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0035542,
            "latitude": 52.6129258
        },
        "11875": {
            "name": "Горный",
            "population": 112,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0695748,
            "latitude": 52.1608945
        },
        "11876": {
            "name": "Каменка",
            "population": 81,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0790075,
            "latitude": 52.4751494
        },
        "11877": {
            "name": "Чесноково",
            "population": 237,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.0990412,
            "latitude": 53.0798932
        },
        "11878": {
            "name": "Мануильское",
            "population": 207,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1214924,
            "latitude": 52.3076674
        },
        "11879": {
            "name": "Луговое",
            "population": 70,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1333455,
            "latitude": 52.343557
        },
        "11880": {
            "name": "Верх-Кажа",
            "population": 65,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.157275,
            "latitude": 52.3982196
        },
        "11881": {
            "name": "Ужлеп",
            "population": 115,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.1947463,
            "latitude": 52.2500807
        },
        "11882": {
            "name": "Пильно",
            "population": 33,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2307885,
            "latitude": 52.4830478
        },
        "11883": {
            "name": "Егона",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2458244,
            "latitude": 52.3329612
        },
        "11884": {
            "name": "Курлек",
            "population": 25,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.254746,
            "latitude": 52.2131709
        },
        "11885": {
            "name": "Иртышкино",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.2800661,
            "latitude": 52.4105737
        },
        "11886": {
            "name": "Карагайка",
            "population": 108,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3042414,
            "latitude": 52.2509076
        },
        "11887": {
            "name": "Чапша",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3062339,
            "latitude": 52.3633391
        },
        "11888": {
            "name": "Тайна",
            "population": 194,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3449571,
            "latitude": 52.1864505
        },
        "11889": {
            "name": "Анамас",
            "population": 9,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3638284,
            "latitude": 53.1201956
        },
        "11890": {
            "name": "Ивановка",
            "population": 34,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3908377,
            "latitude": 52.2217474
        },
        "11891": {
            "name": "Кажа",
            "population": 113,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3919176,
            "latitude": 52.4568284
        },
        "11892": {
            "name": "Старая Ажинка",
            "population": 43,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.3931155,
            "latitude": 52.6411513
        },
        "11893": {
            "name": "Бедреп",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4202348,
            "latitude": 53.3483608
        },
        "11894": {
            "name": "Калтык",
            "population": 41,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4316866,
            "latitude": 53.2308555
        },
        "11895": {
            "name": "Макарьевское",
            "population": 140,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4572712,
            "latitude": 52.5524587
        },
        "11896": {
            "name": "Чистая Грива",
            "population": 57,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4596663,
            "latitude": 53.1921807
        },
        "11897": {
            "name": "Калташ",
            "population": 5,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4691043,
            "latitude": 52.3570398
        },
        "11898": {
            "name": "Каракан",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.4748141,
            "latitude": 52.9654851
        },
        "11899": {
            "name": "Троицк",
            "population": 22,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5023131,
            "latitude": 53.15418
        },
        "11900": {
            "name": "Сосновка",
            "population": 134,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5434452,
            "latitude": 52.578042
        },
        "11901": {
            "name": "Кичек",
            "population": 47,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5500358,
            "latitude": 52.759056
        },
        "11902": {
            "name": "Балыкса",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5585339,
            "latitude": 52.5447623
        },
        "11903": {
            "name": "Последниково",
            "population": 128,
            "type": "hamlet",
            "poly": [
                [
                    86.5568328,
                    53.1926173
                ],
                [
                    86.5772358,
                    53.1959399
                ],
                [
                    86.5772358,
                    53.1902161
                ],
                [
                    86.5620145,
                    53.1888092
                ],
                [
                    86.55829,
                    53.1899007
                ],
                [
                    86.5568328,
                    53.1926173
                ]
            ],
            "longitude": 86.567533,
            "latitude": 53.1925591
        },
        "11904": {
            "name": "Бахта",
            "population": 30,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5838653,
            "latitude": 53.1544601
        },
        "11905": {
            "name": "Вятск",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.5847601,
            "latitude": 53.2659909
        },
        "11906": {
            "name": "Казанск",
            "population": 2,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6109757,
            "latitude": 53.2236066
        },
        "11907": {
            "name": "Кедровка",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.6548,
            "latitude": 53.0531099
        },
        "11908": {
            "name": "Вознесенка",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.697641,
            "latitude": 52.7879352
        },
        "11909": {
            "name": "Новотроицк",
            "population": 156,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.740118,
            "latitude": 52.7906161
        },
        "11910": {
            "name": "Шабурово",
            "population": 20,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.8025769,
            "latitude": 52.7991213
        },
        "11911": {
            "name": "Афонино",
            "population": 0,
            "type": "hamlet",
            "poly": null,
            "longitude": 86.9009504,
            "latitude": 53.0021835
        },
        "11912": {
            "name": "Шаснур",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.504456,
            "latitude": 52.671234
        },
        "11913": {
            "name": "Шарза",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.51252,
            "latitude": 52.711807
        },
        "11914": {
            "name": "Балакта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.6996991,
            "latitude": 52.4937706
        },
        "11915": {
            "name": "Хара-Хужир",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.7162188,
            "latitude": 52.6045265
        },
        "11916": {
            "name": "Хурга",
            "population": 117,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.901367,
            "latitude": 52.374924
        },
        "11917": {
            "name": "Субаря",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 99.9360025,
            "latitude": 52.1146647
        },
        "11918": {
            "name": "Дебгэк",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.0069853,
            "latitude": 52.8239718
        },
        "11919": {
            "name": "Алаг-Шулун",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.111954,
            "latitude": 52.830215
        },
        "11920": {
            "name": "Боксон",
            "population": 122,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.330078,
            "latitude": 52.162697
        },
        "11921": {
            "name": "Ботогол",
            "population": 10,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.738121,
            "latitude": 52.371872
        },
        "11922": {
            "name": "Зун-Холба",
            "population": 29,
            "type": "hamlet",
            "poly": null,
            "longitude": 100.9588261,
            "latitude": 52.1614133
        },
        "11923": {
            "name": "Самарта",
            "population": 3,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.139145,
            "latitude": 52.102329
        },
        "11924": {
            "name": "поселок Оспин",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.3702336,
            "latitude": 52.1550161
        },
        "11925": {
            "name": "Мойготы",
            "population": 53,
            "type": "hamlet",
            "poly": null,
            "longitude": 101.3959099,
            "latitude": 51.6476682
        },
        "11926": {
            "name": "Могой-Горхон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.07856,
            "latitude": 51.672119
        },
        "11927": {
            "name": "Енгорга",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.103737,
            "latitude": 51.77108
        },
        "11928": {
            "name": "Нуган",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.197929,
            "latitude": 51.692787
        },
        "11929": {
            "name": "Улбугай",
            "population": 80,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.315483,
            "latitude": 51.803612
        },
        "11930": {
            "name": "Малый Жемчуг",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.361504,
            "latitude": 51.686485
        },
        "11931": {
            "name": "Улан-Горхон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.520821,
            "latitude": 51.670242
        },
        "11932": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.5229633,
            "latitude": 51.7014407
        },
        "11933": {
            "name": "Никольск",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    102.5564914,
                    51.7330174
                ],
                [
                    102.5677838,
                    51.7335554
                ],
                [
                    102.5699554,
                    51.7330174
                ],
                [
                    102.5732438,
                    51.7328253
                ],
                [
                    102.5754154,
                    51.7338243
                ],
                [
                    102.5807514,
                    51.7327484
                ],
                [
                    102.5830471,
                    51.7272915
                ],
                [
                    102.5833573,
                    51.7249855
                ],
                [
                    102.5796966,
                    51.7242553
                ],
                [
                    102.5727474,
                    51.7280601
                ],
                [
                    102.5648676,
                    51.7301353
                ],
                [
                    102.5574221,
                    51.7315572
                ],
                [
                    102.5564914,
                    51.7330174
                ]
            ],
            "longitude": 102.574982,
            "latitude": 51.730904
        },
        "11934": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.6063356,
            "latitude": 51.7614621
        },
        "11935": {
            "name": "Ахалик",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.675667,
            "latitude": 51.787308
        },
        "11936": {
            "name": "Еловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.75528,
            "latitude": 51.759392
        },
        "11937": {
            "name": "Шанай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.857224,
            "latitude": 51.751968
        },
        "11938": {
            "name": "Гужиры",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 102.893463,
            "latitude": 51.791492
        },
        "11939": {
            "name": "Хасура",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 103.285698,
            "latitude": 50.32552
        },
        "11940": {
            "name": "Выдрино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.643913,
            "latitude": 51.445446
        },
        "11941": {
            "name": "Хулдат",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.68969,
            "latitude": 50.489239
        },
        "11942": {
            "name": "Толбазиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.692703,
            "latitude": 51.445496
        },
        "11943": {
            "name": "Подхулдочи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.718689,
            "latitude": 50.599716
        },
        "11944": {
            "name": "Шартыкей",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.8024875,
            "latitude": 50.5132632
        },
        "11945": {
            "name": "Речка Выдрино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.847404,
            "latitude": 51.486988
        },
        "11946": {
            "name": "Кедровая",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.929176,
            "latitude": 51.512924
        },
        "11947": {
            "name": "Старый Укырчелон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 104.976425,
            "latitude": 50.512009
        },
        "11948": {
            "name": "Тохой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.002258,
            "latitude": 50.49749
        },
        "11949": {
            "name": "Тэнгэрэк",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.120102,
            "latitude": 50.484383
        },
        "11950": {
            "name": "Мельница",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.138992,
            "latitude": 50.496494
        },
        "11951": {
            "name": "Баян",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.280693,
            "latitude": 50.546165
        },
        "11952": {
            "name": "Прибой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.419754,
            "latitude": 51.605858
        },
        "11953": {
            "name": "Речка Мишиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.532913,
            "latitude": 51.641815
        },
        "11954": {
            "name": "Верхний Енхор",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.72435,
            "latitude": 50.481651
        },
        "11955": {
            "name": "Ивановка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.728951,
            "latitude": 51.683189
        },
        "11956": {
            "name": "Нюгуй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.755707,
            "latitude": 50.52454
        },
        "11957": {
            "name": "Усть-Урма",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.9772085,
            "latitude": 51.052671
        },
        "11958": {
            "name": "Мантуриха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.9804839,
            "latitude": 51.7770346
        },
        "11959": {
            "name": "Удунга",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 105.9827875,
            "latitude": 51.1269595
        },
        "11960": {
            "name": "Сосновка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.0102125,
            "latitude": 50.8830819
        },
        "11961": {
            "name": "Хужир",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.197495,
            "latitude": 50.573051
        },
        "11962": {
            "name": "Байкальский Прибой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.2014635,
            "latitude": 51.9369097
        },
        "11963": {
            "name": "Шана",
            "population": 267,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.2098955,
            "latitude": 50.9292768
        },
        "11964": {
            "name": "Исток",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.256203,
            "latitude": 52.097443
        },
        "11965": {
            "name": "Мост Темник",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.2568899,
            "latitude": 50.9640214
        },
        "11966": {
            "name": "Рыбзавод",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.2974508,
            "latitude": 51.1056215
        },
        "11967": {
            "name": "Дэбэн",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.3091287,
            "latitude": 50.7476336
        },
        "11968": {
            "name": "Цайдам",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.3606141,
            "latitude": 51.1014194
        },
        "11969": {
            "name": "Суджа",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.409247,
            "latitude": 50.4676251
        },
        "11970": {
            "name": "Заозёрный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.4483999,
            "latitude": 51.3229645
        },
        "11971": {
            "name": "Борки",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.474922,
            "latitude": 52.156113
        },
        "11972": {
            "name": "Калинишна",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.487167,
            "latitude": 50.653233
        },
        "11973": {
            "name": "Мурзино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.489098,
            "latitude": 52.186508
        },
        "11974": {
            "name": "Загустай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.489365,
            "latitude": 51.325954
        },
        "11975": {
            "name": "Енхор",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.4969048,
            "latitude": 50.9866289
        },
        "11976": {
            "name": "Малое Колесово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.542473,
            "latitude": 52.124516
        },
        "11977": {
            "name": "Полевой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.562607,
            "latitude": 52.0548332
        },
        "11978": {
            "name": "Ардасан",
            "population": 163,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.5742635,
            "latitude": 51.4378727
        },
        "11979": {
            "name": "Булак",
            "population": 21,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.5763102,
            "latitude": 51.3102368
        },
        "11980": {
            "name": "Сульфат",
            "population": 18,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.58242,
            "latitude": 51.371201
        },
        "11981": {
            "name": "Закалтус",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.590744,
            "latitude": 52.017712
        },
        "11982": {
            "name": "Каргино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.5989,
            "latitude": 52.08247
        },
        "11983": {
            "name": "Новая Деревня",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.604248,
            "latitude": 52.166294
        },
        "11984": {
            "name": "Жилино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.60817,
            "latitude": 52.143757
        },
        "11985": {
            "name": "Бургастай",
            "population": 96,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.6193103,
            "latitude": 51.1549097
        },
        "11986": {
            "name": "Поворот",
            "population": 181,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.623352,
            "latitude": 50.921337
        },
        "11987": {
            "name": "Бурдуны",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.630432,
            "latitude": 50.404163
        },
        "11988": {
            "name": "Харьяста",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.63813,
            "latitude": 50.720806
        },
        "11989": {
            "name": "Романово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.663185,
            "latitude": 52.110119
        },
        "11990": {
            "name": "Шерашово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.697792,
            "latitude": 52.256397
        },
        "11991": {
            "name": "Хандала",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.704033,
            "latitude": 52.119949
        },
        "11992": {
            "name": "Новодесятниково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.7089,
            "latitude": 50.783302
        },
        "11993": {
            "name": "Быково",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.714378,
            "latitude": 52.166252
        },
        "11994": {
            "name": "Средний Убукун",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.724846,
            "latitude": 51.461712
        },
        "11995": {
            "name": "Инкино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.738068,
            "latitude": 52.287975
        },
        "11996": {
            "name": "Фофоново",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.757515,
            "latitude": 52.053116
        },
        "11997": {
            "name": "Дубинино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.768303,
            "latitude": 52.30302
        },
        "11998": {
            "name": "Убукун",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.8524693,
            "latitude": 51.5006804
        },
        "11999": {
            "name": "Курорт Киран",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.855835,
            "latitude": 50.329044
        },
        "12000": {
            "name": "Харлун",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.875183,
            "latitude": 50.599094
        },
        "12001": {
            "name": "Никольск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.876892,
            "latitude": 52.070313
        },
        "12002": {
            "name": "Дулан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.879501,
            "latitude": 52.373718
        },
        "12003": {
            "name": "Хилгантуй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.886116,
            "latitude": 50.43578
        },
        "12004": {
            "name": "Залан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.8902753,
            "latitude": 51.0702565
        },
        "12005": {
            "name": "Мэнгэй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.9219919,
            "latitude": 51.0046813
        },
        "12006": {
            "name": "Дэбэн",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.939255,
            "latitude": 50.565449
        },
        "12007": {
            "name": "Таракановка",
            "population": 157,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.959457,
            "latitude": 52.073048
        },
        "12008": {
            "name": "Тухум",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.9607445,
            "latitude": 50.9541009
        },
        "12009": {
            "name": "Новый Энхэлук",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.968124,
            "latitude": 52.483749
        },
        "12010": {
            "name": "Гильбира",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.970848,
            "latitude": 51.583202
        },
        "12011": {
            "name": "Верхние Мурочи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.9807927,
            "latitude": 50.2503863
        },
        "12012": {
            "name": "Энхалук",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 106.9944407,
            "latitude": 52.4970702
        },
        "12013": {
            "name": "Барун-Оронгой",
            "population": 48,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.017113,
            "latitude": 51.500885
        },
        "12014": {
            "name": "Кибалино",
            "population": 176,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.019562,
            "latitude": 51.420845
        },
        "12015": {
            "name": "Оронгой",
            "population": 24,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.0240778,
            "latitude": 51.530604
        },
        "12016": {
            "name": "Полканово",
            "population": 146,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.036942,
            "latitude": 50.31081
        },
        "12017": {
            "name": "Черноярово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.0563599,
            "latitude": 50.9093918
        },
        "12018": {
            "name": "Старые Ключи",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.079689,
            "latitude": 50.55904
        },
        "12019": {
            "name": "Зун-Оронгой",
            "population": 79,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.110703,
            "latitude": 51.510494
        },
        "12020": {
            "name": "Югово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.113129,
            "latitude": 52.123421
        },
        "12021": {
            "name": "Нижний Мангиртуй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.1668373,
            "latitude": 50.6802663
        },
        "12022": {
            "name": "Троицкое",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.1804418,
            "latitude": 52.1188641
        },
        "12023": {
            "name": "Ганзурино",
            "population": 149,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.187523,
            "latitude": 51.515285
        },
        "12024": {
            "name": "Лесовозный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.2488726,
            "latitude": 52.116302
        },
        "12025": {
            "name": "Хаян",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.2957559,
                    50.613627
                ],
                [
                    107.2959564,
                    50.6172215
                ],
                [
                    107.2985633,
                    50.6180008
                ],
                [
                    107.300744,
                    50.617142
                ],
                [
                    107.3008944,
                    50.6136429
                ],
                [
                    107.3008192,
                    50.611591
                ],
                [
                    107.2989142,
                    50.6108275
                ],
                [
                    107.2972598,
                    50.6117501
                ],
                [
                    107.2957559,
                    50.613627
                ]
            ],
            "longitude": 107.298531,
            "latitude": 50.614624
        },
        "12026": {
            "name": "Семёновка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.347519,
            "latitude": 50.157349
        },
        "12027": {
            "name": "Кардон",
            "population": 164,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.3704908,
            "latitude": 51.603292
        },
        "12028": {
            "name": "Гашей",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.371536,
            "latitude": 51.038345
        },
        "12029": {
            "name": "Улан-Иволгинский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.373772,
            "latitude": 51.775795
        },
        "12030": {
            "name": "Тапхар",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.3711797,
                    51.7298394
                ],
                [
                    107.3727247,
                    51.7326036
                ],
                [
                    107.3742482,
                    51.737042
                ],
                [
                    107.3787114,
                    51.7344907
                ],
                [
                    107.3813292,
                    51.728404
                ],
                [
                    107.386243,
                    51.7221304
                ],
                [
                    107.3852345,
                    51.7217581
                ],
                [
                    107.3840114,
                    51.7227684
                ],
                [
                    107.3828527,
                    51.7224361
                ],
                [
                    107.3807928,
                    51.7245496
                ],
                [
                    107.3749134,
                    51.7245894
                ],
                [
                    107.373819,
                    51.7260116
                ],
                [
                    107.3717376,
                    51.7266363
                ],
                [
                    107.3736388,
                    51.7280279
                ],
                [
                    107.3711797,
                    51.7298394
                ]
            ],
            "longitude": 107.378014,
            "latitude": 51.730129
        },
        "12031": {
            "name": "Бурнашево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.387634,
            "latitude": 51.426075
        },
        "12032": {
            "name": "Селенга",
            "population": 99,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.412239,
            "latitude": 51.631927
        },
        "12033": {
            "name": "Хара-Шибирь",
            "population": 175,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.452759,
            "latitude": 52.0714
        },
        "12034": {
            "name": "Саратовка",
            "population": 210,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.4234072,
            "latitude": 51.6530498
        },
        "12035": {
            "name": "Хамнигадай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.4308455,
            "latitude": 50.1814691
        },
        "12036": {
            "name": "Зандин",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.431702,
            "latitude": 51.070744
        },
        "12037": {
            "name": "Ара-Киреть",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.432495,
            "latitude": 50.593246
        },
        "12038": {
            "name": "Саянтуй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.4462804,
            "latitude": 51.6895725
        },
        "12039": {
            "name": "Первомайское",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.450294,
            "latitude": 50.11639
        },
        "12040": {
            "name": "Острог",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.4503438,
                    52.1524037
                ],
                [
                    107.4551038,
                    52.1530724
                ],
                [
                    107.45583,
                    52.15492
                ],
                [
                    107.4616406,
                    52.1557196
                ],
                [
                    107.4642372,
                    52.1556207
                ],
                [
                    107.4711325,
                    52.1584011
                ],
                [
                    107.4732178,
                    52.1560301
                ],
                [
                    107.4735655,
                    52.1556789
                ],
                [
                    107.4731429,
                    52.1551331
                ],
                [
                    107.4746999,
                    52.1543143
                ],
                [
                    107.4732096,
                    52.1527039
                ],
                [
                    107.4695395,
                    52.1528813
                ],
                [
                    107.4663365,
                    52.1515848
                ],
                [
                    107.4645349,
                    52.1514756
                ],
                [
                    107.4603754,
                    52.1524855
                ],
                [
                    107.4555042,
                    52.1515984
                ],
                [
                    107.4553485,
                    52.1504111
                ],
                [
                    107.4509666,
                    52.1515166
                ],
                [
                    107.4503438,
                    52.1524037
                ]
            ],
            "longitude": 107.463966,
            "latitude": 52.154205
        },
        "12041": {
            "name": "Цаган-Челутай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.470772,
            "latitude": 49.992817
        },
        "12042": {
            "name": "Сужа Северная",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.4923313,
            "latitude": 51.7875764
        },
        "12043": {
            "name": "Сухой Ручей",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.500961,
            "latitude": 50.548569
        },
        "12044": {
            "name": "Бурдуково",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.502362,
                    52.0946166
                ],
                [
                    107.5060323,
                    52.0943834
                ],
                [
                    107.5076776,
                    52.0935281
                ],
                [
                    107.5126134,
                    52.0937613
                ],
                [
                    107.5143853,
                    52.0916619
                ],
                [
                    107.5175493,
                    52.0914286
                ],
                [
                    107.517929,
                    52.093839
                ],
                [
                    107.5215992,
                    52.093839
                ],
                [
                    107.5224852,
                    52.0901845
                ],
                [
                    107.5204602,
                    52.0883182
                ],
                [
                    107.5141322,
                    52.086685
                ],
                [
                    107.5040073,
                    52.0881625
                ],
                [
                    107.5057792,
                    52.0918173
                ],
                [
                    107.502362,
                    52.0946166
                ]
            ],
            "longitude": 107.512222,
            "latitude": 52.090405
        },
        "12045": {
            "name": "Куготы",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.518992,
            "latitude": 51.0374264
        },
        "12046": {
            "name": "Лиственничное",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.5268158,
                    52.1699231
                ],
                [
                    107.5278217,
                    52.1708171
                ],
                [
                    107.530188,
                    52.170868
                ],
                [
                    107.5342283,
                    52.1682035
                ],
                [
                    107.5341414,
                    52.1639933
                ],
                [
                    107.5294649,
                    52.1640071
                ],
                [
                    107.5280769,
                    52.1684493
                ],
                [
                    107.5268158,
                    52.1699231
                ]
            ],
            "longitude": 107.530807,
            "latitude": 52.167614
        },
        "12047": {
            "name": "Алтачей",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.538376,
            "latitude": 50.710106
        },
        "12048": {
            "name": "Клочнево",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.5511144,
                    52.1744556
                ],
                [
                    107.5518781,
                    52.1834568
                ],
                [
                    107.5574782,
                    52.184029
                ],
                [
                    107.5646905,
                    52.1865782
                ],
                [
                    107.566133,
                    52.1854857
                ],
                [
                    107.560448,
                    52.181792
                ],
                [
                    107.5605328,
                    52.1780979
                ],
                [
                    107.5671512,
                    52.1774736
                ],
                [
                    107.5709694,
                    52.1778378
                ],
                [
                    107.5742786,
                    52.1775776
                ],
                [
                    107.5744483,
                    52.1756524
                ],
                [
                    107.5674057,
                    52.1743516
                ],
                [
                    107.560935,
                    52.1748373
                ],
                [
                    107.5532357,
                    52.1724782
                ],
                [
                    107.5511144,
                    52.1744556
                ]
            ],
            "longitude": 107.556122,
            "latitude": 52.179874
        },
        "12049": {
            "name": "Анагустай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.578705,
            "latitude": 49.987469
        },
        "12050": {
            "name": "Засухино",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.5926768,
                    52.1974445
                ],
                [
                    107.6066601,
                    52.2013969
                ],
                [
                    107.6096469,
                    52.199608
                ],
                [
                    107.6081888,
                    52.1975786
                ],
                [
                    107.604053,
                    52.1980259
                ],
                [
                    107.6002692,
                    52.1969274
                ],
                [
                    107.6004115,
                    52.1962075
                ],
                [
                    107.5980271,
                    52.195684
                ],
                [
                    107.5975466,
                    52.1962839
                ],
                [
                    107.5943258,
                    52.1956467
                ],
                [
                    107.5926768,
                    52.1974445
                ]
            ],
            "longitude": 107.601654,
            "latitude": 52.198818
        },
        "12051": {
            "name": "Харьястка",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.6510828,
                    51.2594442
                ],
                [
                    107.6570623,
                    51.2607111
                ],
                [
                    107.6634655,
                    51.2484086
                ],
                [
                    107.6614645,
                    51.2464046
                ],
                [
                    107.6589456,
                    51.2426762
                ],
                [
                    107.6572977,
                    51.2427793
                ],
                [
                    107.6510828,
                    51.2594442
                ]
            ],
            "longitude": 107.6578668,
            "latitude": 51.2524882
        },
        "12052": {
            "name": "Халзаново",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.6706477,
                    52.2259738
                ],
                [
                    107.672175,
                    52.227533
                ],
                [
                    107.6780297,
                    52.2283646
                ],
                [
                    107.6810843,
                    52.227533
                ],
                [
                    107.6822722,
                    52.2257139
                ],
                [
                    107.6805752,
                    52.223323
                ],
                [
                    107.6770963,
                    52.2212958
                ],
                [
                    107.6735326,
                    52.2205161
                ],
                [
                    107.6714962,
                    52.2219196
                ],
                [
                    107.6706477,
                    52.2259738
                ]
            ],
            "longitude": 107.674889,
            "latitude": 52.225777
        },
        "12053": {
            "name": "Бурля",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    107.7426553,
                    52.3550434
                ],
                [
                    107.7511765,
                    52.357088
                ],
                [
                    107.7558429,
                    52.3529368
                ],
                [
                    107.750365,
                    52.352627
                ],
                [
                    107.7497563,
                    52.3548576
                ],
                [
                    107.7427568,
                    52.3535564
                ],
                [
                    107.7426553,
                    52.3550434
                ]
            ],
            "longitude": 107.7502946,
            "latitude": 52.355382
        },
        "12054": {
            "name": "Дабата",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.846581,
            "latitude": 51.904041
        },
        "12055": {
            "name": "Батурино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.8577835,
            "latitude": 52.3355902
        },
        "12056": {
            "name": "Ангир",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.8638856,
            "latitude": 52.2727547
        },
        "12057": {
            "name": "Лесной",
            "population": 6,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.8970196,
            "latitude": 51.717589
        },
        "12058": {
            "name": "Гурулево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.9236339,
            "latitude": 52.4033198
        },
        "12059": {
            "name": "Нарын-Шибирь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.929886,
            "latitude": 51.927307
        },
        "12060": {
            "name": "Усть-Заган",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.933617,
            "latitude": 50.693653
        },
        "12061": {
            "name": "Дабатуй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.94622,
            "latitude": 50.802216
        },
        "12062": {
            "name": "Озёрный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 107.9679127,
            "latitude": 51.8940134
        },
        "12063": {
            "name": "Онохой-Шибирь",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.019173,
            "latitude": 51.976372
        },
        "12064": {
            "name": "Атхатай",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    108.033414,
                    51.5380528
                ],
                [
                    108.0429064,
                    51.5406891
                ],
                [
                    108.051079,
                    51.5411943
                ],
                [
                    108.0566121,
                    51.5414626
                ],
                [
                    108.0594801,
                    51.5406734
                ],
                [
                    108.057805,
                    51.5368215
                ],
                [
                    108.0552161,
                    51.5351164
                ],
                [
                    108.0491501,
                    51.5362373
                ],
                [
                    108.0384902,
                    51.5354795
                ],
                [
                    108.0336932,
                    51.5363478
                ],
                [
                    108.033414,
                    51.5380528
                ]
            ],
            "longitude": 108.048615,
            "latitude": 51.538177
        },
        "12065": {
            "name": "Амагалантуй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.050056,
            "latitude": 50.825489
        },
        "12066": {
            "name": "Старый Онохой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.0511659,
            "latitude": 51.9393156
        },
        "12067": {
            "name": "Тодогто",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.052582,
            "latitude": 51.846378
        },
        "12068": {
            "name": "Черёмушка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.099091,
            "latitude": 52.754894
        },
        "12069": {
            "name": "Новоспасск",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    108.1209497,
                    51.269874
                ],
                [
                    108.1209703,
                    51.2747235
                ],
                [
                    108.1241743,
                    51.27462
                ],
                [
                    108.1239262,
                    51.2701198
                ],
                [
                    108.1209497,
                    51.269874
                ]
            ],
            "longitude": 108.1222752,
            "latitude": 51.2730988
        },
        "12070": {
            "name": "имени Серова",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.131584,
            "latitude": 51.926968
        },
        "12071": {
            "name": "Добо-Енхор",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.1597621,
            "latitude": 52.0035653
        },
        "12072": {
            "name": "Степной",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    108.2071955,
                    51.2189774
                ],
                [
                    108.2145932,
                    51.2236365
                ],
                [
                    108.221991,
                    51.2233019
                ],
                [
                    108.2224431,
                    51.2185913
                ],
                [
                    108.2185387,
                    51.2160684
                ],
                [
                    108.2124561,
                    51.2159397
                ],
                [
                    108.2071955,
                    51.2189774
                ]
            ],
            "longitude": 108.216835,
            "latitude": 51.219856
        },
        "12073": {
            "name": "Шинестуй",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    108.2286321,
                    51.343476
                ],
                [
                    108.2434244,
                    51.3455338
                ],
                [
                    108.246428,
                    51.340026
                ],
                [
                    108.2399362,
                    51.339219
                ],
                [
                    108.230247,
                    51.3407725
                ],
                [
                    108.2286321,
                    51.343476
                ]
            ],
            "longitude": 108.238289,
            "latitude": 51.342644
        },
        "12074": {
            "name": "Хотогор",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.278358,
            "latitude": 52.047039
        },
        "12075": {
            "name": "Шулута",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.370529,
            "latitude": 52.083904
        },
        "12076": {
            "name": "Тарбагатайка",
            "population": 56,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.413536,
            "latitude": 51.604321
        },
        "12077": {
            "name": "Петропавловка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.485504,
            "latitude": 52.041405
        },
        "12078": {
            "name": "Шэнэ-Буса",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.49826,
            "latitude": 51.737156
        },
        "12079": {
            "name": "Святой Нос",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.524567,
            "latitude": 53.497173
        },
        "12080": {
            "name": "Ушканьи острова",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.601067,
            "latitude": 53.852192
        },
        "12081": {
            "name": "Красный Яр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.6119,
            "latitude": 52.208908
        },
        "12082": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.661836,
            "latitude": 54.5386224
        },
        "12083": {
            "name": "Додо-Гол",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.7318005,
            "latitude": 52.0007059
        },
        "12084": {
            "name": "Дэдэ-Тала",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.794357,
            "latitude": 51.585747
        },
        "12085": {
            "name": "Лесозаводской",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.799446,
            "latitude": 51.575596
        },
        "12086": {
            "name": "Мухор-Тала",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.811523,
            "latitude": 51.755127
        },
        "12087": {
            "name": "Коса",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.866667,
            "latitude": 54.783333
        },
        "12088": {
            "name": "Кижа",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 108.885178,
            "latitude": 51.457695
        },
        "12089": {
            "name": "Монахово",
            "population": 4,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.006493,
            "latitude": 53.669369
        },
        "12090": {
            "name": "Катунь",
            "population": 7,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.024239,
            "latitude": 53.677116
        },
        "12091": {
            "name": "Курбулик",
            "population": 101,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.0409005,
            "latitude": 53.7050899
        },
        "12092": {
            "name": "Могой",
            "population": 26,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.115849,
            "latitude": 52.4604134
        },
        "12093": {
            "name": "Хандагай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.1248668,
            "latitude": 52.0101333
        },
        "12094": {
            "name": "Тарбагатай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.2002131,
            "latitude": 52.1131056
        },
        "12095": {
            "name": "Ойбонт",
            "population": 71,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.2084397,
            "latitude": 52.4983249
        },
        "12096": {
            "name": "Чивыркуй",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.220253,
            "latitude": 53.825352
        },
        "12097": {
            "name": "Гусиха",
            "population": 270,
            "type": "hamlet",
            "poly": [
                [
                    109.2541131,
                    53.4306026
                ],
                [
                    109.2545554,
                    53.4337121
                ],
                [
                    109.256767,
                    53.4399304
                ],
                [
                    109.2639323,
                    53.4369794
                ],
                [
                    109.2664756,
                    53.4329066
                ],
                [
                    109.2740047,
                    53.4284209
                ],
                [
                    109.2688342,
                    53.4255021
                ],
                [
                    109.2645188,
                    53.4249771
                ],
                [
                    109.2541131,
                    53.4306026
                ]
            ],
            "longitude": 109.262703,
            "latitude": 53.431034
        },
        "12098": {
            "name": "Тарбагатай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.281387,
            "latitude": 51.758305
        },
        "12099": {
            "name": "Нарын",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.3114842,
            "latitude": 52.0787209
        },
        "12100": {
            "name": "Зорино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.365364,
            "latitude": 53.508732
        },
        "12101": {
            "name": "Журавлиха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.379959,
            "latitude": 53.518948
        },
        "12102": {
            "name": "Куорка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.453224,
            "latitude": 51.565628
        },
        "12103": {
            "name": "Давша",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.50502,
            "latitude": 54.354969
        },
        "12104": {
            "name": "Малая Курба",
            "population": 60,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.5179328,
            "latitude": 52.6531449
        },
        "12105": {
            "name": "Орот",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.645958,
            "latitude": 51.902046
        },
        "12106": {
            "name": "Шапеньково",
            "population": null,
            "type": "hamlet",
            "poly": [
                [
                    109.637182,
                    53.5703112
                ],
                [
                    109.6408621,
                    53.5723065
                ],
                [
                    109.6463023,
                    53.5714989
                ],
                [
                    109.6523824,
                    53.5659402
                ],
                [
                    109.6555825,
                    53.5612837
                ],
                [
                    109.6528624,
                    53.5601432
                ],
                [
                    109.6455022,
                    53.562044
                ],
                [
                    109.6403821,
                    53.5675081
                ],
                [
                    109.637182,
                    53.5703112
                ]
            ],
            "longitude": 109.646225,
            "latitude": 53.566414
        },
        "12107": {
            "name": "Нестериха",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.710335,
            "latitude": 53.647678
        },
        "12108": {
            "name": "Томпа",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.7281309,
            "latitude": 55.1330394
        },
        "12109": {
            "name": "Леоновка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.73661,
            "latitude": 51.748627
        },
        "12110": {
            "name": "",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.8197372,
            "latitude": 55.3616427
        },
        "12111": {
            "name": "Анинск",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.8435701,
            "latitude": 52.1961583
        },
        "12112": {
            "name": "Малое Уро",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.844955,
            "latitude": 53.528339
        },
        "12113": {
            "name": "Ушхайта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.847733,
            "latitude": 51.817741
        },
        "12114": {
            "name": "Красный Яр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.900665,
            "latitude": 51.920181
        },
        "12115": {
            "name": "Ярикта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 109.991539,
            "latitude": 53.9147
        },
        "12116": {
            "name": "Майла",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.003792,
            "latitude": 52.507019
        },
        "12117": {
            "name": "Бахлайта",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.032074,
            "latitude": 51.788193
        },
        "12118": {
            "name": "Хара-Усун",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.121513,
            "latitude": 53.803982
        },
        "12119": {
            "name": "Соёл",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.19574,
            "latitude": 53.854805
        },
        "12120": {
            "name": "Галгатай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.2198701,
            "latitude": 54.1982742
        },
        "12121": {
            "name": "Хонхино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.222878,
            "latitude": 54.233227
        },
        "12122": {
            "name": "Арбун",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.274467,
            "latitude": 54.199024
        },
        "12123": {
            "name": "Мургун",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.3323083,
            "latitude": 54.2622003
        },
        "12124": {
            "name": "Дзелинда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.33638,
            "latitude": 55.9354025
        },
        "12125": {
            "name": "Уржил",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.348297,
            "latitude": 53.828884
        },
        "12126": {
            "name": "Унэгэтэй",
            "population": 104,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.3837374,
            "latitude": 54.2042564
        },
        "12127": {
            "name": "заимка Хамнига",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.4447837,
            "latitude": 54.114076
        },
        "12128": {
            "name": "заимка Хадын Бори",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.4481458,
            "latitude": 54.1060423
        },
        "12129": {
            "name": "заимка Шулуута",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.473134,
            "latitude": 54.1074312
        },
        "12130": {
            "name": "Харамодун",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.503563,
            "latitude": 54.20153
        },
        "12131": {
            "name": "Булаг",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.513412,
            "latitude": 54.244179
        },
        "12132": {
            "name": "заимка Уртонхой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.5257673,
            "latitude": 54.1343843
        },
        "12133": {
            "name": "заимка Уртонхой 1",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.5418373,
            "latitude": 54.1396128
        },
        "12134": {
            "name": "заимка Усть-Гарга",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.5484744,
            "latitude": 54.4325591
        },
        "12135": {
            "name": "заимка Уртонхой 2",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.5503397,
            "latitude": 54.1521071
        },
        "12136": {
            "name": "Томокто",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.573845,
            "latitude": 54.290272
        },
        "12137": {
            "name": "заимка Хуторхой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.5826323,
            "latitude": 54.1901989
        },
        "12138": {
            "name": "Гарга",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.605782,
            "latitude": 54.430023
        },
        "12139": {
            "name": "заимка Иликчин",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.6238901,
            "latitude": 54.1835539
        },
        "12140": {
            "name": "заимка Племферма",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.6758404,
            "latitude": 54.2210561
        },
        "12141": {
            "name": "Угнасай",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.67852,
            "latitude": 54.500294
        },
        "12142": {
            "name": "заимка Дусен",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.7020718,
            "latitude": 54.2420688
        },
        "12143": {
            "name": "нп Верхняя Аргада",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.7102523,
            "latitude": 54.2662476
        },
        "12144": {
            "name": "заимка Аматхан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.7126359,
            "latitude": 54.4068742
        },
        "12145": {
            "name": "Тунгэн",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.778786,
            "latitude": 54.329327
        },
        "12146": {
            "name": "Курорт Гаргинский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 110.9969625,
            "latitude": 54.3191176
        },
        "12147": {
            "name": "Кулькисон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.016289,
            "latitude": 52.048996
        },
        "12148": {
            "name": "Ягдыг",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.083374,
            "latitude": 54.850182
        },
        "12149": {
            "name": "Таза",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.1615614,
            "latitude": 54.8763212
        },
        "12150": {
            "name": "Хорга",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.822983,
            "latitude": 52.81937
        },
        "12151": {
            "name": "Карафтит",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.917686,
            "latitude": 54.202862
        },
        "12152": {
            "name": "Орколикан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 111.9666669,
            "latitude": 56.733333
        },
        "12153": {
            "name": "Орочен",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.283333,
            "latitude": 55.516667
        },
        "12154": {
            "name": "Окунево",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.349037,
            "latitude": 54.833309
        },
        "12155": {
            "name": "Червяк",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.45,
            "latitude": 55.033333
        },
        "12156": {
            "name": "Курорт Баунт",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 112.91172,
            "latitude": 55.128201
        },
        "12157": {
            "name": "Верхний Ципикан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.066849,
            "latitude": 54.836136
        },
        "12158": {
            "name": "Баунт",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.123428,
            "latitude": 55.250668
        },
        "12159": {
            "name": "Троицкий",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.156799,
            "latitude": 54.587391
        },
        "12160": {
            "name": "Усть-Антосе",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.197182,
            "latitude": 53.964172
        },
        "12161": {
            "name": "Николаевский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.2,
            "latitude": 55.016667
        },
        "12162": {
            "name": "Нагорный",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.316667,
            "latitude": 54.95
        },
        "12163": {
            "name": "Соловьёвский",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.35,
            "latitude": 54.95
        },
        "12164": {
            "name": "Бусани",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.552376,
            "latitude": 55.355125
        },
        "12165": {
            "name": "Байса",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.587959,
            "latitude": 53.980415
        },
        "12166": {
            "name": "Торм",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 113.642395,
            "latitude": 53.955681
        },
        "12167": {
            "name": "Бугунда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.223038,
            "latitude": 53.756111
        },
        "12168": {
            "name": "Талой",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.383333,
            "latitude": 55.05
        },
        "12169": {
            "name": "Уя",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.5038906,
            "latitude": 55.5840638
        },
        "12170": {
            "name": "Джунок",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.683333,
            "latitude": 55.633333
        },
        "12171": {
            "name": "Аматкан",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 114.966667,
            "latitude": 55.683333
        },
        "12172": {
            "name": "Иракинда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.192886,
            "latitude": 55.929413
        },
        "12173": {
            "name": "Усть-Тананда",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.2361099,
            "latitude": 54.657993
        },
        "12174": {
            "name": "Итокит",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.333333,
            "latitude": 55.75
        },
        "12175": {
            "name": "Шипишка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.368333,
            "latitude": 54.270833
        },
        "12176": {
            "name": "Тилишма",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.450856,
            "latitude": 55.852231
        },
        "12177": {
            "name": "Солонцово",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.5999999,
            "latitude": 54.416667
        },
        "12178": {
            "name": "Баргалино",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.648949,
            "latitude": 56.504208
        },
        "12179": {
            "name": "Муя",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.666389,
            "latitude": 56.457352
        },
        "12180": {
            "name": "Витим",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.728104,
            "latitude": 56.219364
        },
        "12181": {
            "name": "Бамбуйка",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.7964651,
            "latitude": 55.7882649
        },
        "12182": {
            "name": "Красный Яр",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.8166669,
            "latitude": 55.766667
        },
        "12183": {
            "name": "Каралон",
            "population": null,
            "type": "hamlet",
            "poly": null,
            "longitude": 115.8875,
            "latitude": 57.0225
        },
        "12184": {
            "name": "Солнечная",
            "population": null,
            "type": "",
            "poly": null,
            "longitude": 108.25561738716983,
            "latitude": 54.030776123669476
        },
        "12185": {
            "name": "Чернильщиково",
            "population": null,
            "type": "",
            "poly": null,
            "longitude": 84.7236331848494,
            "latitude": 56.67296808786216
        },
        "12186": {
            "name": "",
            "population": null,
            "type": "",
            "poly": null,
            "longitude": 73.45491765359326,
            "latitude": 54.85009537166474
        },
        "12187": {
            "name": "Черёмуховское",
            "population": null,
            "type": "",
            "poly": null,
            "longitude": 73.45491765359326,
            "latitude": 54.85009537166474
        },
        "12188": {
            "name": "Черёмушки",
            "population": null,
            "type": "",
            "poly": null,
            "longitude": 73.40720874842397,
            "latitude": 54.84409296141935
        },
        "12189": {
            "name": "Новая Станица",
            "population": null,
            "type": "",
            "poly": null,
            "longitude": 73.38109731754857,
            "latitude": 54.833328376565966
        }
    }